
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequired6c0"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequired6c0"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("1b2ls", function(module, exports) {

$parcel$export(module.exports, "Fragment", () => $0db8a335f84591c1$export$ffb0004e005737fa, (v) => $0db8a335f84591c1$export$ffb0004e005737fa = v);
$parcel$export(module.exports, "jsx", () => $0db8a335f84591c1$export$34b9dba7ce09269b, (v) => $0db8a335f84591c1$export$34b9dba7ce09269b = v);
$parcel$export(module.exports, "jsxs", () => $0db8a335f84591c1$export$25062201e9e25d76, (v) => $0db8a335f84591c1$export$25062201e9e25d76 = v);
/**
 * @license React
 * react-jsx-runtime.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $0db8a335f84591c1$export$ffb0004e005737fa;
var $0db8a335f84591c1$export$34b9dba7ce09269b;
var $0db8a335f84591c1$export$25062201e9e25d76;
"use strict";

var $acw62 = parcelRequire("acw62");
var $0db8a335f84591c1$var$k = Symbol.for("react.element"), $0db8a335f84591c1$var$l = Symbol.for("react.fragment"), $0db8a335f84591c1$var$m = Object.prototype.hasOwnProperty, $0db8a335f84591c1$var$n = $acw62.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, $0db8a335f84591c1$var$p = {
    key: !0,
    ref: !0,
    __self: !0,
    __source: !0
};
function $0db8a335f84591c1$var$q(c, a, g) {
    var b, d = {}, e = null, h = null;
    void 0 !== g && (e = "" + g);
    void 0 !== a.key && (e = "" + a.key);
    void 0 !== a.ref && (h = a.ref);
    for(b in a)$0db8a335f84591c1$var$m.call(a, b) && !$0db8a335f84591c1$var$p.hasOwnProperty(b) && (d[b] = a[b]);
    if (c && c.defaultProps) for(b in a = c.defaultProps, a)void 0 === d[b] && (d[b] = a[b]);
    return {
        $$typeof: $0db8a335f84591c1$var$k,
        type: c,
        key: e,
        ref: h,
        props: d,
        _owner: $0db8a335f84591c1$var$n.current
    };
}
$0db8a335f84591c1$export$ffb0004e005737fa = $0db8a335f84591c1$var$l;
$0db8a335f84591c1$export$34b9dba7ce09269b = $0db8a335f84591c1$var$q;
$0db8a335f84591c1$export$25062201e9e25d76 = $0db8a335f84591c1$var$q;

});
parcelRegister("acw62", function(module, exports) {
"use strict";

module.exports = (parcelRequire("2pUnB"));

});
parcelRegister("2pUnB", function(module, exports) {

$parcel$export(module.exports, "Children", () => $1c29a66706a62afd$export$dca3b0875bd9a954, (v) => $1c29a66706a62afd$export$dca3b0875bd9a954 = v);
$parcel$export(module.exports, "Component", () => $1c29a66706a62afd$export$16fa2f45be04daa8, (v) => $1c29a66706a62afd$export$16fa2f45be04daa8 = v);
$parcel$export(module.exports, "Fragment", () => $1c29a66706a62afd$export$ffb0004e005737fa, (v) => $1c29a66706a62afd$export$ffb0004e005737fa = v);
$parcel$export(module.exports, "Profiler", () => $1c29a66706a62afd$export$e2c29f18771995cb, (v) => $1c29a66706a62afd$export$e2c29f18771995cb = v);
$parcel$export(module.exports, "PureComponent", () => $1c29a66706a62afd$export$221d75b3f55bb0bd, (v) => $1c29a66706a62afd$export$221d75b3f55bb0bd = v);
$parcel$export(module.exports, "StrictMode", () => $1c29a66706a62afd$export$5f8d39834fd61797, (v) => $1c29a66706a62afd$export$5f8d39834fd61797 = v);
$parcel$export(module.exports, "Suspense", () => $1c29a66706a62afd$export$74bf444e3cd11ea5, (v) => $1c29a66706a62afd$export$74bf444e3cd11ea5 = v);
$parcel$export(module.exports, "__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED", () => $1c29a66706a62afd$export$ae55be85d98224ed, (v) => $1c29a66706a62afd$export$ae55be85d98224ed = v);
$parcel$export(module.exports, "cloneElement", () => $1c29a66706a62afd$export$e530037191fcd5d7, (v) => $1c29a66706a62afd$export$e530037191fcd5d7 = v);
$parcel$export(module.exports, "createContext", () => $1c29a66706a62afd$export$fd42f52fd3ae1109, (v) => $1c29a66706a62afd$export$fd42f52fd3ae1109 = v);
$parcel$export(module.exports, "createElement", () => $1c29a66706a62afd$export$c8a8987d4410bf2d, (v) => $1c29a66706a62afd$export$c8a8987d4410bf2d = v);
$parcel$export(module.exports, "createFactory", () => $1c29a66706a62afd$export$d38cd72104c1f0e9, (v) => $1c29a66706a62afd$export$d38cd72104c1f0e9 = v);
$parcel$export(module.exports, "createRef", () => $1c29a66706a62afd$export$7d1e3a5e95ceca43, (v) => $1c29a66706a62afd$export$7d1e3a5e95ceca43 = v);
$parcel$export(module.exports, "forwardRef", () => $1c29a66706a62afd$export$257a8862b851cb5b, (v) => $1c29a66706a62afd$export$257a8862b851cb5b = v);
$parcel$export(module.exports, "isValidElement", () => $1c29a66706a62afd$export$a8257692ac88316c, (v) => $1c29a66706a62afd$export$a8257692ac88316c = v);
$parcel$export(module.exports, "lazy", () => $1c29a66706a62afd$export$488013bae63b21da, (v) => $1c29a66706a62afd$export$488013bae63b21da = v);
$parcel$export(module.exports, "memo", () => $1c29a66706a62afd$export$7c73462e0d25e514, (v) => $1c29a66706a62afd$export$7c73462e0d25e514 = v);
$parcel$export(module.exports, "startTransition", () => $1c29a66706a62afd$export$7568632d0d33d16d, (v) => $1c29a66706a62afd$export$7568632d0d33d16d = v);
$parcel$export(module.exports, "unstable_act", () => $1c29a66706a62afd$export$88948ce120ea2619, (v) => $1c29a66706a62afd$export$88948ce120ea2619 = v);
$parcel$export(module.exports, "useCallback", () => $1c29a66706a62afd$export$35808ee640e87ca7, (v) => $1c29a66706a62afd$export$35808ee640e87ca7 = v);
$parcel$export(module.exports, "useContext", () => $1c29a66706a62afd$export$fae74005e78b1a27, (v) => $1c29a66706a62afd$export$fae74005e78b1a27 = v);
$parcel$export(module.exports, "useDebugValue", () => $1c29a66706a62afd$export$dc8fbce3eb94dc1e, (v) => $1c29a66706a62afd$export$dc8fbce3eb94dc1e = v);
$parcel$export(module.exports, "useDeferredValue", () => $1c29a66706a62afd$export$6a7bc4e911dc01cf, (v) => $1c29a66706a62afd$export$6a7bc4e911dc01cf = v);
$parcel$export(module.exports, "useEffect", () => $1c29a66706a62afd$export$6d9c69b0de29b591, (v) => $1c29a66706a62afd$export$6d9c69b0de29b591 = v);
$parcel$export(module.exports, "useId", () => $1c29a66706a62afd$export$f680877a34711e37, (v) => $1c29a66706a62afd$export$f680877a34711e37 = v);
$parcel$export(module.exports, "useImperativeHandle", () => $1c29a66706a62afd$export$d5a552a76deda3c2, (v) => $1c29a66706a62afd$export$d5a552a76deda3c2 = v);
$parcel$export(module.exports, "useInsertionEffect", () => $1c29a66706a62afd$export$aaabe4eda9ed9969, (v) => $1c29a66706a62afd$export$aaabe4eda9ed9969 = v);
$parcel$export(module.exports, "useLayoutEffect", () => $1c29a66706a62afd$export$e5c5a5f917a5871c, (v) => $1c29a66706a62afd$export$e5c5a5f917a5871c = v);
$parcel$export(module.exports, "useMemo", () => $1c29a66706a62afd$export$1538c33de8887b59, (v) => $1c29a66706a62afd$export$1538c33de8887b59 = v);
$parcel$export(module.exports, "useReducer", () => $1c29a66706a62afd$export$13e3392192263954, (v) => $1c29a66706a62afd$export$13e3392192263954 = v);
$parcel$export(module.exports, "useRef", () => $1c29a66706a62afd$export$b8f5890fc79d6aca, (v) => $1c29a66706a62afd$export$b8f5890fc79d6aca = v);
$parcel$export(module.exports, "useState", () => $1c29a66706a62afd$export$60241385465d0a34, (v) => $1c29a66706a62afd$export$60241385465d0a34 = v);
$parcel$export(module.exports, "useSyncExternalStore", () => $1c29a66706a62afd$export$306c0aa65ff9ec16, (v) => $1c29a66706a62afd$export$306c0aa65ff9ec16 = v);
$parcel$export(module.exports, "useTransition", () => $1c29a66706a62afd$export$7b286972b8d8ccbf, (v) => $1c29a66706a62afd$export$7b286972b8d8ccbf = v);
$parcel$export(module.exports, "version", () => $1c29a66706a62afd$export$83d89fbfd8236492, (v) => $1c29a66706a62afd$export$83d89fbfd8236492 = v);
/**
 * @license React
 * react.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $1c29a66706a62afd$export$dca3b0875bd9a954;
var $1c29a66706a62afd$export$16fa2f45be04daa8;
var $1c29a66706a62afd$export$ffb0004e005737fa;
var $1c29a66706a62afd$export$e2c29f18771995cb;
var $1c29a66706a62afd$export$221d75b3f55bb0bd;
var $1c29a66706a62afd$export$5f8d39834fd61797;
var $1c29a66706a62afd$export$74bf444e3cd11ea5;
var $1c29a66706a62afd$export$ae55be85d98224ed;
var $1c29a66706a62afd$export$e530037191fcd5d7;
var $1c29a66706a62afd$export$fd42f52fd3ae1109;
var $1c29a66706a62afd$export$c8a8987d4410bf2d;
var $1c29a66706a62afd$export$d38cd72104c1f0e9;
var $1c29a66706a62afd$export$7d1e3a5e95ceca43;
var $1c29a66706a62afd$export$257a8862b851cb5b;
var $1c29a66706a62afd$export$a8257692ac88316c;
var $1c29a66706a62afd$export$488013bae63b21da;
var $1c29a66706a62afd$export$7c73462e0d25e514;
var $1c29a66706a62afd$export$7568632d0d33d16d;
var $1c29a66706a62afd$export$88948ce120ea2619;
var $1c29a66706a62afd$export$35808ee640e87ca7;
var $1c29a66706a62afd$export$fae74005e78b1a27;
var $1c29a66706a62afd$export$dc8fbce3eb94dc1e;
var $1c29a66706a62afd$export$6a7bc4e911dc01cf;
var $1c29a66706a62afd$export$6d9c69b0de29b591;
var $1c29a66706a62afd$export$f680877a34711e37;
var $1c29a66706a62afd$export$d5a552a76deda3c2;
var $1c29a66706a62afd$export$aaabe4eda9ed9969;
var $1c29a66706a62afd$export$e5c5a5f917a5871c;
var $1c29a66706a62afd$export$1538c33de8887b59;
var $1c29a66706a62afd$export$13e3392192263954;
var $1c29a66706a62afd$export$b8f5890fc79d6aca;
var $1c29a66706a62afd$export$60241385465d0a34;
var $1c29a66706a62afd$export$306c0aa65ff9ec16;
var $1c29a66706a62afd$export$7b286972b8d8ccbf;
var $1c29a66706a62afd$export$83d89fbfd8236492;
"use strict";
var $1c29a66706a62afd$var$l = Symbol.for("react.element"), $1c29a66706a62afd$var$n = Symbol.for("react.portal"), $1c29a66706a62afd$var$p = Symbol.for("react.fragment"), $1c29a66706a62afd$var$q = Symbol.for("react.strict_mode"), $1c29a66706a62afd$var$r = Symbol.for("react.profiler"), $1c29a66706a62afd$var$t = Symbol.for("react.provider"), $1c29a66706a62afd$var$u = Symbol.for("react.context"), $1c29a66706a62afd$var$v = Symbol.for("react.forward_ref"), $1c29a66706a62afd$var$w = Symbol.for("react.suspense"), $1c29a66706a62afd$var$x = Symbol.for("react.memo"), $1c29a66706a62afd$var$y = Symbol.for("react.lazy"), $1c29a66706a62afd$var$z = Symbol.iterator;
function $1c29a66706a62afd$var$A(a) {
    if (null === a || "object" !== typeof a) return null;
    a = $1c29a66706a62afd$var$z && a[$1c29a66706a62afd$var$z] || a["@@iterator"];
    return "function" === typeof a ? a : null;
}
var $1c29a66706a62afd$var$B = {
    isMounted: function() {
        return !1;
    },
    enqueueForceUpdate: function() {},
    enqueueReplaceState: function() {},
    enqueueSetState: function() {}
}, $1c29a66706a62afd$var$C = Object.assign, $1c29a66706a62afd$var$D = {};
function $1c29a66706a62afd$var$E(a, b, e) {
    this.props = a;
    this.context = b;
    this.refs = $1c29a66706a62afd$var$D;
    this.updater = e || $1c29a66706a62afd$var$B;
}
$1c29a66706a62afd$var$E.prototype.isReactComponent = {};
$1c29a66706a62afd$var$E.prototype.setState = function(a, b) {
    if ("object" !== typeof a && "function" !== typeof a && null != a) throw Error("setState(...): takes an object of state variables to update or a function which returns an object of state variables.");
    this.updater.enqueueSetState(this, a, b, "setState");
};
$1c29a66706a62afd$var$E.prototype.forceUpdate = function(a) {
    this.updater.enqueueForceUpdate(this, a, "forceUpdate");
};
function $1c29a66706a62afd$var$F() {}
$1c29a66706a62afd$var$F.prototype = $1c29a66706a62afd$var$E.prototype;
function $1c29a66706a62afd$var$G(a, b, e) {
    this.props = a;
    this.context = b;
    this.refs = $1c29a66706a62afd$var$D;
    this.updater = e || $1c29a66706a62afd$var$B;
}
var $1c29a66706a62afd$var$H = $1c29a66706a62afd$var$G.prototype = new $1c29a66706a62afd$var$F;
$1c29a66706a62afd$var$H.constructor = $1c29a66706a62afd$var$G;
$1c29a66706a62afd$var$C($1c29a66706a62afd$var$H, $1c29a66706a62afd$var$E.prototype);
$1c29a66706a62afd$var$H.isPureReactComponent = !0;
var $1c29a66706a62afd$var$I = Array.isArray, $1c29a66706a62afd$var$J = Object.prototype.hasOwnProperty, $1c29a66706a62afd$var$K = {
    current: null
}, $1c29a66706a62afd$var$L = {
    key: !0,
    ref: !0,
    __self: !0,
    __source: !0
};
function $1c29a66706a62afd$var$M(a, b, e) {
    var d, c = {}, k = null, h = null;
    if (null != b) for(d in void 0 !== b.ref && (h = b.ref), void 0 !== b.key && (k = "" + b.key), b)$1c29a66706a62afd$var$J.call(b, d) && !$1c29a66706a62afd$var$L.hasOwnProperty(d) && (c[d] = b[d]);
    var g = arguments.length - 2;
    if (1 === g) c.children = e;
    else if (1 < g) {
        for(var f = Array(g), m = 0; m < g; m++)f[m] = arguments[m + 2];
        c.children = f;
    }
    if (a && a.defaultProps) for(d in g = a.defaultProps, g)void 0 === c[d] && (c[d] = g[d]);
    return {
        $$typeof: $1c29a66706a62afd$var$l,
        type: a,
        key: k,
        ref: h,
        props: c,
        _owner: $1c29a66706a62afd$var$K.current
    };
}
function $1c29a66706a62afd$var$N(a, b) {
    return {
        $$typeof: $1c29a66706a62afd$var$l,
        type: a.type,
        key: b,
        ref: a.ref,
        props: a.props,
        _owner: a._owner
    };
}
function $1c29a66706a62afd$var$O(a) {
    return "object" === typeof a && null !== a && a.$$typeof === $1c29a66706a62afd$var$l;
}
function $1c29a66706a62afd$var$escape(a) {
    var b = {
        "=": "=0",
        ":": "=2"
    };
    return "$" + a.replace(/[=:]/g, function(a) {
        return b[a];
    });
}
var $1c29a66706a62afd$var$P = /\/+/g;
function $1c29a66706a62afd$var$Q(a, b) {
    return "object" === typeof a && null !== a && null != a.key ? $1c29a66706a62afd$var$escape("" + a.key) : b.toString(36);
}
function $1c29a66706a62afd$var$R(a, b, e, d, c) {
    var k = typeof a;
    if ("undefined" === k || "boolean" === k) a = null;
    var h = !1;
    if (null === a) h = !0;
    else switch(k){
        case "string":
        case "number":
            h = !0;
            break;
        case "object":
            switch(a.$$typeof){
                case $1c29a66706a62afd$var$l:
                case $1c29a66706a62afd$var$n:
                    h = !0;
            }
    }
    if (h) return h = a, c = c(h), a = "" === d ? "." + $1c29a66706a62afd$var$Q(h, 0) : d, $1c29a66706a62afd$var$I(c) ? (e = "", null != a && (e = a.replace($1c29a66706a62afd$var$P, "$&/") + "/"), $1c29a66706a62afd$var$R(c, b, e, "", function(a) {
        return a;
    })) : null != c && ($1c29a66706a62afd$var$O(c) && (c = $1c29a66706a62afd$var$N(c, e + (!c.key || h && h.key === c.key ? "" : ("" + c.key).replace($1c29a66706a62afd$var$P, "$&/") + "/") + a)), b.push(c)), 1;
    h = 0;
    d = "" === d ? "." : d + ":";
    if ($1c29a66706a62afd$var$I(a)) for(var g = 0; g < a.length; g++){
        k = a[g];
        var f = d + $1c29a66706a62afd$var$Q(k, g);
        h += $1c29a66706a62afd$var$R(k, b, e, f, c);
    }
    else if (f = $1c29a66706a62afd$var$A(a), "function" === typeof f) for(a = f.call(a), g = 0; !(k = a.next()).done;)k = k.value, f = d + $1c29a66706a62afd$var$Q(k, g++), h += $1c29a66706a62afd$var$R(k, b, e, f, c);
    else if ("object" === k) throw b = String(a), Error("Objects are not valid as a React child (found: " + ("[object Object]" === b ? "object with keys {" + Object.keys(a).join(", ") + "}" : b) + "). If you meant to render a collection of children, use an array instead.");
    return h;
}
function $1c29a66706a62afd$var$S(a, b, e) {
    if (null == a) return a;
    var d = [], c = 0;
    $1c29a66706a62afd$var$R(a, d, "", "", function(a) {
        return b.call(e, a, c++);
    });
    return d;
}
function $1c29a66706a62afd$var$T(a) {
    if (-1 === a._status) {
        var b = a._result;
        b = b();
        b.then(function(b) {
            if (0 === a._status || -1 === a._status) a._status = 1, a._result = b;
        }, function(b) {
            if (0 === a._status || -1 === a._status) a._status = 2, a._result = b;
        });
        -1 === a._status && (a._status = 0, a._result = b);
    }
    if (1 === a._status) return a._result.default;
    throw a._result;
}
var $1c29a66706a62afd$var$U = {
    current: null
}, $1c29a66706a62afd$var$V = {
    transition: null
}, $1c29a66706a62afd$var$W = {
    ReactCurrentDispatcher: $1c29a66706a62afd$var$U,
    ReactCurrentBatchConfig: $1c29a66706a62afd$var$V,
    ReactCurrentOwner: $1c29a66706a62afd$var$K
};
$1c29a66706a62afd$export$dca3b0875bd9a954 = {
    map: $1c29a66706a62afd$var$S,
    forEach: function(a, b, e) {
        $1c29a66706a62afd$var$S(a, function() {
            b.apply(this, arguments);
        }, e);
    },
    count: function(a) {
        var b = 0;
        $1c29a66706a62afd$var$S(a, function() {
            b++;
        });
        return b;
    },
    toArray: function(a) {
        return $1c29a66706a62afd$var$S(a, function(a) {
            return a;
        }) || [];
    },
    only: function(a) {
        if (!$1c29a66706a62afd$var$O(a)) throw Error("React.Children.only expected to receive a single React element child.");
        return a;
    }
};
$1c29a66706a62afd$export$16fa2f45be04daa8 = $1c29a66706a62afd$var$E;
$1c29a66706a62afd$export$ffb0004e005737fa = $1c29a66706a62afd$var$p;
$1c29a66706a62afd$export$e2c29f18771995cb = $1c29a66706a62afd$var$r;
$1c29a66706a62afd$export$221d75b3f55bb0bd = $1c29a66706a62afd$var$G;
$1c29a66706a62afd$export$5f8d39834fd61797 = $1c29a66706a62afd$var$q;
$1c29a66706a62afd$export$74bf444e3cd11ea5 = $1c29a66706a62afd$var$w;
$1c29a66706a62afd$export$ae55be85d98224ed = $1c29a66706a62afd$var$W;
$1c29a66706a62afd$export$e530037191fcd5d7 = function(a, b, e) {
    if (null === a || void 0 === a) throw Error("React.cloneElement(...): The argument must be a React element, but you passed " + a + ".");
    var d = $1c29a66706a62afd$var$C({}, a.props), c = a.key, k = a.ref, h = a._owner;
    if (null != b) {
        void 0 !== b.ref && (k = b.ref, h = $1c29a66706a62afd$var$K.current);
        void 0 !== b.key && (c = "" + b.key);
        if (a.type && a.type.defaultProps) var g = a.type.defaultProps;
        for(f in b)$1c29a66706a62afd$var$J.call(b, f) && !$1c29a66706a62afd$var$L.hasOwnProperty(f) && (d[f] = void 0 === b[f] && void 0 !== g ? g[f] : b[f]);
    }
    var f = arguments.length - 2;
    if (1 === f) d.children = e;
    else if (1 < f) {
        g = Array(f);
        for(var m = 0; m < f; m++)g[m] = arguments[m + 2];
        d.children = g;
    }
    return {
        $$typeof: $1c29a66706a62afd$var$l,
        type: a.type,
        key: c,
        ref: k,
        props: d,
        _owner: h
    };
};
$1c29a66706a62afd$export$fd42f52fd3ae1109 = function(a) {
    a = {
        $$typeof: $1c29a66706a62afd$var$u,
        _currentValue: a,
        _currentValue2: a,
        _threadCount: 0,
        Provider: null,
        Consumer: null,
        _defaultValue: null,
        _globalName: null
    };
    a.Provider = {
        $$typeof: $1c29a66706a62afd$var$t,
        _context: a
    };
    return a.Consumer = a;
};
$1c29a66706a62afd$export$c8a8987d4410bf2d = $1c29a66706a62afd$var$M;
$1c29a66706a62afd$export$d38cd72104c1f0e9 = function(a) {
    var b = $1c29a66706a62afd$var$M.bind(null, a);
    b.type = a;
    return b;
};
$1c29a66706a62afd$export$7d1e3a5e95ceca43 = function() {
    return {
        current: null
    };
};
$1c29a66706a62afd$export$257a8862b851cb5b = function(a) {
    return {
        $$typeof: $1c29a66706a62afd$var$v,
        render: a
    };
};
$1c29a66706a62afd$export$a8257692ac88316c = $1c29a66706a62afd$var$O;
$1c29a66706a62afd$export$488013bae63b21da = function(a) {
    return {
        $$typeof: $1c29a66706a62afd$var$y,
        _payload: {
            _status: -1,
            _result: a
        },
        _init: $1c29a66706a62afd$var$T
    };
};
$1c29a66706a62afd$export$7c73462e0d25e514 = function(a, b) {
    return {
        $$typeof: $1c29a66706a62afd$var$x,
        type: a,
        compare: void 0 === b ? null : b
    };
};
$1c29a66706a62afd$export$7568632d0d33d16d = function(a) {
    var b = $1c29a66706a62afd$var$V.transition;
    $1c29a66706a62afd$var$V.transition = {};
    try {
        a();
    } finally{
        $1c29a66706a62afd$var$V.transition = b;
    }
};
$1c29a66706a62afd$export$88948ce120ea2619 = function() {
    throw Error("act(...) is not supported in production builds of React.");
};
$1c29a66706a62afd$export$35808ee640e87ca7 = function(a, b) {
    return $1c29a66706a62afd$var$U.current.useCallback(a, b);
};
$1c29a66706a62afd$export$fae74005e78b1a27 = function(a) {
    return $1c29a66706a62afd$var$U.current.useContext(a);
};
$1c29a66706a62afd$export$dc8fbce3eb94dc1e = function() {};
$1c29a66706a62afd$export$6a7bc4e911dc01cf = function(a) {
    return $1c29a66706a62afd$var$U.current.useDeferredValue(a);
};
$1c29a66706a62afd$export$6d9c69b0de29b591 = function(a, b) {
    return $1c29a66706a62afd$var$U.current.useEffect(a, b);
};
$1c29a66706a62afd$export$f680877a34711e37 = function() {
    return $1c29a66706a62afd$var$U.current.useId();
};
$1c29a66706a62afd$export$d5a552a76deda3c2 = function(a, b, e) {
    return $1c29a66706a62afd$var$U.current.useImperativeHandle(a, b, e);
};
$1c29a66706a62afd$export$aaabe4eda9ed9969 = function(a, b) {
    return $1c29a66706a62afd$var$U.current.useInsertionEffect(a, b);
};
$1c29a66706a62afd$export$e5c5a5f917a5871c = function(a, b) {
    return $1c29a66706a62afd$var$U.current.useLayoutEffect(a, b);
};
$1c29a66706a62afd$export$1538c33de8887b59 = function(a, b) {
    return $1c29a66706a62afd$var$U.current.useMemo(a, b);
};
$1c29a66706a62afd$export$13e3392192263954 = function(a, b, e) {
    return $1c29a66706a62afd$var$U.current.useReducer(a, b, e);
};
$1c29a66706a62afd$export$b8f5890fc79d6aca = function(a) {
    return $1c29a66706a62afd$var$U.current.useRef(a);
};
$1c29a66706a62afd$export$60241385465d0a34 = function(a) {
    return $1c29a66706a62afd$var$U.current.useState(a);
};
$1c29a66706a62afd$export$306c0aa65ff9ec16 = function(a, b, e) {
    return $1c29a66706a62afd$var$U.current.useSyncExternalStore(a, b, e);
};
$1c29a66706a62afd$export$7b286972b8d8ccbf = function() {
    return $1c29a66706a62afd$var$U.current.useTransition();
};
$1c29a66706a62afd$export$83d89fbfd8236492 = "18.2.0";

});



parcelRegister("Xw6Mv", function(module, exports) {

$parcel$export(module.exports, "__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED", () => $0b2e6adb871a3b94$export$ae55be85d98224ed, (v) => $0b2e6adb871a3b94$export$ae55be85d98224ed = v);
$parcel$export(module.exports, "createPortal", () => $0b2e6adb871a3b94$export$d39a5bbd09211389, (v) => $0b2e6adb871a3b94$export$d39a5bbd09211389 = v);
$parcel$export(module.exports, "createRoot", () => $0b2e6adb871a3b94$export$882461b6382ed46c, (v) => $0b2e6adb871a3b94$export$882461b6382ed46c = v);
$parcel$export(module.exports, "findDOMNode", () => $0b2e6adb871a3b94$export$466bfc07425424d5, (v) => $0b2e6adb871a3b94$export$466bfc07425424d5 = v);
$parcel$export(module.exports, "flushSync", () => $0b2e6adb871a3b94$export$cd75ccfd720a3cd4, (v) => $0b2e6adb871a3b94$export$cd75ccfd720a3cd4 = v);
$parcel$export(module.exports, "hydrate", () => $0b2e6adb871a3b94$export$fa8d919ba61d84db, (v) => $0b2e6adb871a3b94$export$fa8d919ba61d84db = v);
$parcel$export(module.exports, "hydrateRoot", () => $0b2e6adb871a3b94$export$757ceba2d55c277e, (v) => $0b2e6adb871a3b94$export$757ceba2d55c277e = v);
$parcel$export(module.exports, "render", () => $0b2e6adb871a3b94$export$b3890eb0ae9dca99, (v) => $0b2e6adb871a3b94$export$b3890eb0ae9dca99 = v);
$parcel$export(module.exports, "unmountComponentAtNode", () => $0b2e6adb871a3b94$export$502457920280e6be, (v) => $0b2e6adb871a3b94$export$502457920280e6be = v);
$parcel$export(module.exports, "unstable_batchedUpdates", () => $0b2e6adb871a3b94$export$c78a37762a8d58e1, (v) => $0b2e6adb871a3b94$export$c78a37762a8d58e1 = v);
$parcel$export(module.exports, "unstable_renderSubtreeIntoContainer", () => $0b2e6adb871a3b94$export$dc54d992c10e8a18, (v) => $0b2e6adb871a3b94$export$dc54d992c10e8a18 = v);
$parcel$export(module.exports, "version", () => $0b2e6adb871a3b94$export$83d89fbfd8236492, (v) => $0b2e6adb871a3b94$export$83d89fbfd8236492 = v);
/**
 * @license React
 * react-dom.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ /*
 Modernizr 3.0.0pre (Custom Build) | MIT
*/ var $0b2e6adb871a3b94$export$ae55be85d98224ed;
var $0b2e6adb871a3b94$export$d39a5bbd09211389;
var $0b2e6adb871a3b94$export$882461b6382ed46c;
var $0b2e6adb871a3b94$export$466bfc07425424d5;
var $0b2e6adb871a3b94$export$cd75ccfd720a3cd4;
var $0b2e6adb871a3b94$export$fa8d919ba61d84db;
var $0b2e6adb871a3b94$export$757ceba2d55c277e;
var $0b2e6adb871a3b94$export$b3890eb0ae9dca99;
var $0b2e6adb871a3b94$export$502457920280e6be;
var $0b2e6adb871a3b94$export$c78a37762a8d58e1;
var $0b2e6adb871a3b94$export$dc54d992c10e8a18;
var $0b2e6adb871a3b94$export$83d89fbfd8236492;
"use strict";

var $acw62 = parcelRequire("acw62");

var $fO90s = parcelRequire("fO90s");
function $0b2e6adb871a3b94$var$p(a) {
    for(var b = "https://reactjs.org/docs/error-decoder.html?invariant=" + a, c = 1; c < arguments.length; c++)b += "&args[]=" + encodeURIComponent(arguments[c]);
    return "Minified React error #" + a + "; visit " + b + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
}
var $0b2e6adb871a3b94$var$da = new Set, $0b2e6adb871a3b94$var$ea = {};
function $0b2e6adb871a3b94$var$fa(a, b) {
    $0b2e6adb871a3b94$var$ha(a, b);
    $0b2e6adb871a3b94$var$ha(a + "Capture", b);
}
function $0b2e6adb871a3b94$var$ha(a, b) {
    $0b2e6adb871a3b94$var$ea[a] = b;
    for(a = 0; a < b.length; a++)$0b2e6adb871a3b94$var$da.add(b[a]);
}
var $0b2e6adb871a3b94$var$ia = !("undefined" === typeof window || "undefined" === typeof window.document || "undefined" === typeof window.document.createElement), $0b2e6adb871a3b94$var$ja = Object.prototype.hasOwnProperty, $0b2e6adb871a3b94$var$ka = /^[:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD][:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD\-.0-9\u00B7\u0300-\u036F\u203F-\u2040]*$/, $0b2e6adb871a3b94$var$la = {}, $0b2e6adb871a3b94$var$ma = {};
function $0b2e6adb871a3b94$var$oa(a) {
    if ($0b2e6adb871a3b94$var$ja.call($0b2e6adb871a3b94$var$ma, a)) return !0;
    if ($0b2e6adb871a3b94$var$ja.call($0b2e6adb871a3b94$var$la, a)) return !1;
    if ($0b2e6adb871a3b94$var$ka.test(a)) return $0b2e6adb871a3b94$var$ma[a] = !0;
    $0b2e6adb871a3b94$var$la[a] = !0;
    return !1;
}
function $0b2e6adb871a3b94$var$pa(a, b, c, d) {
    if (null !== c && 0 === c.type) return !1;
    switch(typeof b){
        case "function":
        case "symbol":
            return !0;
        case "boolean":
            if (d) return !1;
            if (null !== c) return !c.acceptsBooleans;
            a = a.toLowerCase().slice(0, 5);
            return "data-" !== a && "aria-" !== a;
        default:
            return !1;
    }
}
function $0b2e6adb871a3b94$var$qa(a, b, c, d) {
    if (null === b || "undefined" === typeof b || $0b2e6adb871a3b94$var$pa(a, b, c, d)) return !0;
    if (d) return !1;
    if (null !== c) switch(c.type){
        case 3:
            return !b;
        case 4:
            return !1 === b;
        case 5:
            return isNaN(b);
        case 6:
            return isNaN(b) || 1 > b;
    }
    return !1;
}
function $0b2e6adb871a3b94$var$v(a, b, c, d, e, f, g) {
    this.acceptsBooleans = 2 === b || 3 === b || 4 === b;
    this.attributeName = d;
    this.attributeNamespace = e;
    this.mustUseProperty = c;
    this.propertyName = a;
    this.type = b;
    this.sanitizeURL = f;
    this.removeEmptyString = g;
}
var $0b2e6adb871a3b94$var$z = {};
"children dangerouslySetInnerHTML defaultValue defaultChecked innerHTML suppressContentEditableWarning suppressHydrationWarning style".split(" ").forEach(function(a) {
    $0b2e6adb871a3b94$var$z[a] = new $0b2e6adb871a3b94$var$v(a, 0, !1, a, null, !1, !1);
});
[
    [
        "acceptCharset",
        "accept-charset"
    ],
    [
        "className",
        "class"
    ],
    [
        "htmlFor",
        "for"
    ],
    [
        "httpEquiv",
        "http-equiv"
    ]
].forEach(function(a) {
    var b = a[0];
    $0b2e6adb871a3b94$var$z[b] = new $0b2e6adb871a3b94$var$v(b, 1, !1, a[1], null, !1, !1);
});
[
    "contentEditable",
    "draggable",
    "spellCheck",
    "value"
].forEach(function(a) {
    $0b2e6adb871a3b94$var$z[a] = new $0b2e6adb871a3b94$var$v(a, 2, !1, a.toLowerCase(), null, !1, !1);
});
[
    "autoReverse",
    "externalResourcesRequired",
    "focusable",
    "preserveAlpha"
].forEach(function(a) {
    $0b2e6adb871a3b94$var$z[a] = new $0b2e6adb871a3b94$var$v(a, 2, !1, a, null, !1, !1);
});
"allowFullScreen async autoFocus autoPlay controls default defer disabled disablePictureInPicture disableRemotePlayback formNoValidate hidden loop noModule noValidate open playsInline readOnly required reversed scoped seamless itemScope".split(" ").forEach(function(a) {
    $0b2e6adb871a3b94$var$z[a] = new $0b2e6adb871a3b94$var$v(a, 3, !1, a.toLowerCase(), null, !1, !1);
});
[
    "checked",
    "multiple",
    "muted",
    "selected"
].forEach(function(a) {
    $0b2e6adb871a3b94$var$z[a] = new $0b2e6adb871a3b94$var$v(a, 3, !0, a, null, !1, !1);
});
[
    "capture",
    "download"
].forEach(function(a) {
    $0b2e6adb871a3b94$var$z[a] = new $0b2e6adb871a3b94$var$v(a, 4, !1, a, null, !1, !1);
});
[
    "cols",
    "rows",
    "size",
    "span"
].forEach(function(a) {
    $0b2e6adb871a3b94$var$z[a] = new $0b2e6adb871a3b94$var$v(a, 6, !1, a, null, !1, !1);
});
[
    "rowSpan",
    "start"
].forEach(function(a) {
    $0b2e6adb871a3b94$var$z[a] = new $0b2e6adb871a3b94$var$v(a, 5, !1, a.toLowerCase(), null, !1, !1);
});
var $0b2e6adb871a3b94$var$ra = /[\-:]([a-z])/g;
function $0b2e6adb871a3b94$var$sa(a) {
    return a[1].toUpperCase();
}
"accent-height alignment-baseline arabic-form baseline-shift cap-height clip-path clip-rule color-interpolation color-interpolation-filters color-profile color-rendering dominant-baseline enable-background fill-opacity fill-rule flood-color flood-opacity font-family font-size font-size-adjust font-stretch font-style font-variant font-weight glyph-name glyph-orientation-horizontal glyph-orientation-vertical horiz-adv-x horiz-origin-x image-rendering letter-spacing lighting-color marker-end marker-mid marker-start overline-position overline-thickness paint-order panose-1 pointer-events rendering-intent shape-rendering stop-color stop-opacity strikethrough-position strikethrough-thickness stroke-dasharray stroke-dashoffset stroke-linecap stroke-linejoin stroke-miterlimit stroke-opacity stroke-width text-anchor text-decoration text-rendering underline-position underline-thickness unicode-bidi unicode-range units-per-em v-alphabetic v-hanging v-ideographic v-mathematical vector-effect vert-adv-y vert-origin-x vert-origin-y word-spacing writing-mode xmlns:xlink x-height".split(" ").forEach(function(a) {
    var b = a.replace($0b2e6adb871a3b94$var$ra, $0b2e6adb871a3b94$var$sa);
    $0b2e6adb871a3b94$var$z[b] = new $0b2e6adb871a3b94$var$v(b, 1, !1, a, null, !1, !1);
});
"xlink:actuate xlink:arcrole xlink:role xlink:show xlink:title xlink:type".split(" ").forEach(function(a) {
    var b = a.replace($0b2e6adb871a3b94$var$ra, $0b2e6adb871a3b94$var$sa);
    $0b2e6adb871a3b94$var$z[b] = new $0b2e6adb871a3b94$var$v(b, 1, !1, a, "http://www.w3.org/1999/xlink", !1, !1);
});
[
    "xml:base",
    "xml:lang",
    "xml:space"
].forEach(function(a) {
    var b = a.replace($0b2e6adb871a3b94$var$ra, $0b2e6adb871a3b94$var$sa);
    $0b2e6adb871a3b94$var$z[b] = new $0b2e6adb871a3b94$var$v(b, 1, !1, a, "http://www.w3.org/XML/1998/namespace", !1, !1);
});
[
    "tabIndex",
    "crossOrigin"
].forEach(function(a) {
    $0b2e6adb871a3b94$var$z[a] = new $0b2e6adb871a3b94$var$v(a, 1, !1, a.toLowerCase(), null, !1, !1);
});
$0b2e6adb871a3b94$var$z.xlinkHref = new $0b2e6adb871a3b94$var$v("xlinkHref", 1, !1, "xlink:href", "http://www.w3.org/1999/xlink", !0, !1);
[
    "src",
    "href",
    "action",
    "formAction"
].forEach(function(a) {
    $0b2e6adb871a3b94$var$z[a] = new $0b2e6adb871a3b94$var$v(a, 1, !1, a.toLowerCase(), null, !0, !0);
});
function $0b2e6adb871a3b94$var$ta(a, b, c, d) {
    var e = $0b2e6adb871a3b94$var$z.hasOwnProperty(b) ? $0b2e6adb871a3b94$var$z[b] : null;
    if (null !== e ? 0 !== e.type : d || !(2 < b.length) || "o" !== b[0] && "O" !== b[0] || "n" !== b[1] && "N" !== b[1]) $0b2e6adb871a3b94$var$qa(b, c, e, d) && (c = null), d || null === e ? $0b2e6adb871a3b94$var$oa(b) && (null === c ? a.removeAttribute(b) : a.setAttribute(b, "" + c)) : e.mustUseProperty ? a[e.propertyName] = null === c ? 3 === e.type ? !1 : "" : c : (b = e.attributeName, d = e.attributeNamespace, null === c ? a.removeAttribute(b) : (e = e.type, c = 3 === e || 4 === e && !0 === c ? "" : "" + c, d ? a.setAttributeNS(d, b, c) : a.setAttribute(b, c)));
}
var $0b2e6adb871a3b94$var$ua = $acw62.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED, $0b2e6adb871a3b94$var$va = Symbol.for("react.element"), $0b2e6adb871a3b94$var$wa = Symbol.for("react.portal"), $0b2e6adb871a3b94$var$ya = Symbol.for("react.fragment"), $0b2e6adb871a3b94$var$za = Symbol.for("react.strict_mode"), $0b2e6adb871a3b94$var$Aa = Symbol.for("react.profiler"), $0b2e6adb871a3b94$var$Ba = Symbol.for("react.provider"), $0b2e6adb871a3b94$var$Ca = Symbol.for("react.context"), $0b2e6adb871a3b94$var$Da = Symbol.for("react.forward_ref"), $0b2e6adb871a3b94$var$Ea = Symbol.for("react.suspense"), $0b2e6adb871a3b94$var$Fa = Symbol.for("react.suspense_list"), $0b2e6adb871a3b94$var$Ga = Symbol.for("react.memo"), $0b2e6adb871a3b94$var$Ha = Symbol.for("react.lazy");
Symbol.for("react.scope");
Symbol.for("react.debug_trace_mode");
var $0b2e6adb871a3b94$var$Ia = Symbol.for("react.offscreen");
Symbol.for("react.legacy_hidden");
Symbol.for("react.cache");
Symbol.for("react.tracing_marker");
var $0b2e6adb871a3b94$var$Ja = Symbol.iterator;
function $0b2e6adb871a3b94$var$Ka(a) {
    if (null === a || "object" !== typeof a) return null;
    a = $0b2e6adb871a3b94$var$Ja && a[$0b2e6adb871a3b94$var$Ja] || a["@@iterator"];
    return "function" === typeof a ? a : null;
}
var $0b2e6adb871a3b94$var$A = Object.assign, $0b2e6adb871a3b94$var$La;
function $0b2e6adb871a3b94$var$Ma(a) {
    if (void 0 === $0b2e6adb871a3b94$var$La) try {
        throw Error();
    } catch (c) {
        var b = c.stack.trim().match(/\n( *(at )?)/);
        $0b2e6adb871a3b94$var$La = b && b[1] || "";
    }
    return "\n" + $0b2e6adb871a3b94$var$La + a;
}
var $0b2e6adb871a3b94$var$Na = !1;
function $0b2e6adb871a3b94$var$Oa(a, b) {
    if (!a || $0b2e6adb871a3b94$var$Na) return "";
    $0b2e6adb871a3b94$var$Na = !0;
    var c = Error.prepareStackTrace;
    Error.prepareStackTrace = void 0;
    try {
        if (b) {
            if (b = function() {
                throw Error();
            }, Object.defineProperty(b.prototype, "props", {
                set: function() {
                    throw Error();
                }
            }), "object" === typeof Reflect && Reflect.construct) {
                try {
                    Reflect.construct(b, []);
                } catch (l) {
                    var d = l;
                }
                Reflect.construct(a, [], b);
            } else {
                try {
                    b.call();
                } catch (l) {
                    d = l;
                }
                a.call(b.prototype);
            }
        } else {
            try {
                throw Error();
            } catch (l) {
                d = l;
            }
            a();
        }
    } catch (l) {
        if (l && d && "string" === typeof l.stack) {
            for(var e = l.stack.split("\n"), f = d.stack.split("\n"), g = e.length - 1, h = f.length - 1; 1 <= g && 0 <= h && e[g] !== f[h];)h--;
            for(; 1 <= g && 0 <= h; g--, h--)if (e[g] !== f[h]) {
                if (1 !== g || 1 !== h) {
                    do if (g--, h--, 0 > h || e[g] !== f[h]) {
                        var k = "\n" + e[g].replace(" at new ", " at ");
                        a.displayName && k.includes("<anonymous>") && (k = k.replace("<anonymous>", a.displayName));
                        return k;
                    }
                    while (1 <= g && 0 <= h);
                }
                break;
            }
        }
    } finally{
        $0b2e6adb871a3b94$var$Na = !1, Error.prepareStackTrace = c;
    }
    return (a = a ? a.displayName || a.name : "") ? $0b2e6adb871a3b94$var$Ma(a) : "";
}
function $0b2e6adb871a3b94$var$Pa(a) {
    switch(a.tag){
        case 5:
            return $0b2e6adb871a3b94$var$Ma(a.type);
        case 16:
            return $0b2e6adb871a3b94$var$Ma("Lazy");
        case 13:
            return $0b2e6adb871a3b94$var$Ma("Suspense");
        case 19:
            return $0b2e6adb871a3b94$var$Ma("SuspenseList");
        case 0:
        case 2:
        case 15:
            return a = $0b2e6adb871a3b94$var$Oa(a.type, !1), a;
        case 11:
            return a = $0b2e6adb871a3b94$var$Oa(a.type.render, !1), a;
        case 1:
            return a = $0b2e6adb871a3b94$var$Oa(a.type, !0), a;
        default:
            return "";
    }
}
function $0b2e6adb871a3b94$var$Qa(a) {
    if (null == a) return null;
    if ("function" === typeof a) return a.displayName || a.name || null;
    if ("string" === typeof a) return a;
    switch(a){
        case $0b2e6adb871a3b94$var$ya:
            return "Fragment";
        case $0b2e6adb871a3b94$var$wa:
            return "Portal";
        case $0b2e6adb871a3b94$var$Aa:
            return "Profiler";
        case $0b2e6adb871a3b94$var$za:
            return "StrictMode";
        case $0b2e6adb871a3b94$var$Ea:
            return "Suspense";
        case $0b2e6adb871a3b94$var$Fa:
            return "SuspenseList";
    }
    if ("object" === typeof a) switch(a.$$typeof){
        case $0b2e6adb871a3b94$var$Ca:
            return (a.displayName || "Context") + ".Consumer";
        case $0b2e6adb871a3b94$var$Ba:
            return (a._context.displayName || "Context") + ".Provider";
        case $0b2e6adb871a3b94$var$Da:
            var b = a.render;
            a = a.displayName;
            a || (a = b.displayName || b.name || "", a = "" !== a ? "ForwardRef(" + a + ")" : "ForwardRef");
            return a;
        case $0b2e6adb871a3b94$var$Ga:
            return b = a.displayName || null, null !== b ? b : $0b2e6adb871a3b94$var$Qa(a.type) || "Memo";
        case $0b2e6adb871a3b94$var$Ha:
            b = a._payload;
            a = a._init;
            try {
                return $0b2e6adb871a3b94$var$Qa(a(b));
            } catch (c) {}
    }
    return null;
}
function $0b2e6adb871a3b94$var$Ra(a) {
    var b = a.type;
    switch(a.tag){
        case 24:
            return "Cache";
        case 9:
            return (b.displayName || "Context") + ".Consumer";
        case 10:
            return (b._context.displayName || "Context") + ".Provider";
        case 18:
            return "DehydratedFragment";
        case 11:
            return a = b.render, a = a.displayName || a.name || "", b.displayName || ("" !== a ? "ForwardRef(" + a + ")" : "ForwardRef");
        case 7:
            return "Fragment";
        case 5:
            return b;
        case 4:
            return "Portal";
        case 3:
            return "Root";
        case 6:
            return "Text";
        case 16:
            return $0b2e6adb871a3b94$var$Qa(b);
        case 8:
            return b === $0b2e6adb871a3b94$var$za ? "StrictMode" : "Mode";
        case 22:
            return "Offscreen";
        case 12:
            return "Profiler";
        case 21:
            return "Scope";
        case 13:
            return "Suspense";
        case 19:
            return "SuspenseList";
        case 25:
            return "TracingMarker";
        case 1:
        case 0:
        case 17:
        case 2:
        case 14:
        case 15:
            if ("function" === typeof b) return b.displayName || b.name || null;
            if ("string" === typeof b) return b;
    }
    return null;
}
function $0b2e6adb871a3b94$var$Sa(a) {
    switch(typeof a){
        case "boolean":
        case "number":
        case "string":
        case "undefined":
            return a;
        case "object":
            return a;
        default:
            return "";
    }
}
function $0b2e6adb871a3b94$var$Ta(a) {
    var b = a.type;
    return (a = a.nodeName) && "input" === a.toLowerCase() && ("checkbox" === b || "radio" === b);
}
function $0b2e6adb871a3b94$var$Ua(a) {
    var b = $0b2e6adb871a3b94$var$Ta(a) ? "checked" : "value", c = Object.getOwnPropertyDescriptor(a.constructor.prototype, b), d = "" + a[b];
    if (!a.hasOwnProperty(b) && "undefined" !== typeof c && "function" === typeof c.get && "function" === typeof c.set) {
        var e = c.get, f = c.set;
        Object.defineProperty(a, b, {
            configurable: !0,
            get: function() {
                return e.call(this);
            },
            set: function(a) {
                d = "" + a;
                f.call(this, a);
            }
        });
        Object.defineProperty(a, b, {
            enumerable: c.enumerable
        });
        return {
            getValue: function() {
                return d;
            },
            setValue: function(a) {
                d = "" + a;
            },
            stopTracking: function() {
                a._valueTracker = null;
                delete a[b];
            }
        };
    }
}
function $0b2e6adb871a3b94$var$Va(a) {
    a._valueTracker || (a._valueTracker = $0b2e6adb871a3b94$var$Ua(a));
}
function $0b2e6adb871a3b94$var$Wa(a) {
    if (!a) return !1;
    var b = a._valueTracker;
    if (!b) return !0;
    var c = b.getValue();
    var d = "";
    a && (d = $0b2e6adb871a3b94$var$Ta(a) ? a.checked ? "true" : "false" : a.value);
    a = d;
    return a !== c ? (b.setValue(a), !0) : !1;
}
function $0b2e6adb871a3b94$var$Xa(a) {
    a = a || ("undefined" !== typeof document ? document : void 0);
    if ("undefined" === typeof a) return null;
    try {
        return a.activeElement || a.body;
    } catch (b) {
        return a.body;
    }
}
function $0b2e6adb871a3b94$var$Ya(a, b) {
    var c = b.checked;
    return $0b2e6adb871a3b94$var$A({}, b, {
        defaultChecked: void 0,
        defaultValue: void 0,
        value: void 0,
        checked: null != c ? c : a._wrapperState.initialChecked
    });
}
function $0b2e6adb871a3b94$var$Za(a, b) {
    var c = null == b.defaultValue ? "" : b.defaultValue, d = null != b.checked ? b.checked : b.defaultChecked;
    c = $0b2e6adb871a3b94$var$Sa(null != b.value ? b.value : c);
    a._wrapperState = {
        initialChecked: d,
        initialValue: c,
        controlled: "checkbox" === b.type || "radio" === b.type ? null != b.checked : null != b.value
    };
}
function $0b2e6adb871a3b94$var$ab(a, b) {
    b = b.checked;
    null != b && $0b2e6adb871a3b94$var$ta(a, "checked", b, !1);
}
function $0b2e6adb871a3b94$var$bb(a, b) {
    $0b2e6adb871a3b94$var$ab(a, b);
    var c = $0b2e6adb871a3b94$var$Sa(b.value), d = b.type;
    if (null != c) {
        if ("number" === d) {
            if (0 === c && "" === a.value || a.value != c) a.value = "" + c;
        } else a.value !== "" + c && (a.value = "" + c);
    } else if ("submit" === d || "reset" === d) {
        a.removeAttribute("value");
        return;
    }
    b.hasOwnProperty("value") ? $0b2e6adb871a3b94$var$cb(a, b.type, c) : b.hasOwnProperty("defaultValue") && $0b2e6adb871a3b94$var$cb(a, b.type, $0b2e6adb871a3b94$var$Sa(b.defaultValue));
    null == b.checked && null != b.defaultChecked && (a.defaultChecked = !!b.defaultChecked);
}
function $0b2e6adb871a3b94$var$db(a, b, c) {
    if (b.hasOwnProperty("value") || b.hasOwnProperty("defaultValue")) {
        var d = b.type;
        if (!("submit" !== d && "reset" !== d || void 0 !== b.value && null !== b.value)) return;
        b = "" + a._wrapperState.initialValue;
        c || b === a.value || (a.value = b);
        a.defaultValue = b;
    }
    c = a.name;
    "" !== c && (a.name = "");
    a.defaultChecked = !!a._wrapperState.initialChecked;
    "" !== c && (a.name = c);
}
function $0b2e6adb871a3b94$var$cb(a, b, c) {
    if ("number" !== b || $0b2e6adb871a3b94$var$Xa(a.ownerDocument) !== a) null == c ? a.defaultValue = "" + a._wrapperState.initialValue : a.defaultValue !== "" + c && (a.defaultValue = "" + c);
}
var $0b2e6adb871a3b94$var$eb = Array.isArray;
function $0b2e6adb871a3b94$var$fb(a, b, c, d) {
    a = a.options;
    if (b) {
        b = {};
        for(var e = 0; e < c.length; e++)b["$" + c[e]] = !0;
        for(c = 0; c < a.length; c++)e = b.hasOwnProperty("$" + a[c].value), a[c].selected !== e && (a[c].selected = e), e && d && (a[c].defaultSelected = !0);
    } else {
        c = "" + $0b2e6adb871a3b94$var$Sa(c);
        b = null;
        for(e = 0; e < a.length; e++){
            if (a[e].value === c) {
                a[e].selected = !0;
                d && (a[e].defaultSelected = !0);
                return;
            }
            null !== b || a[e].disabled || (b = a[e]);
        }
        null !== b && (b.selected = !0);
    }
}
function $0b2e6adb871a3b94$var$gb(a, b) {
    if (null != b.dangerouslySetInnerHTML) throw Error($0b2e6adb871a3b94$var$p(91));
    return $0b2e6adb871a3b94$var$A({}, b, {
        value: void 0,
        defaultValue: void 0,
        children: "" + a._wrapperState.initialValue
    });
}
function $0b2e6adb871a3b94$var$hb(a, b) {
    var c = b.value;
    if (null == c) {
        c = b.children;
        b = b.defaultValue;
        if (null != c) {
            if (null != b) throw Error($0b2e6adb871a3b94$var$p(92));
            if ($0b2e6adb871a3b94$var$eb(c)) {
                if (1 < c.length) throw Error($0b2e6adb871a3b94$var$p(93));
                c = c[0];
            }
            b = c;
        }
        null == b && (b = "");
        c = b;
    }
    a._wrapperState = {
        initialValue: $0b2e6adb871a3b94$var$Sa(c)
    };
}
function $0b2e6adb871a3b94$var$ib(a, b) {
    var c = $0b2e6adb871a3b94$var$Sa(b.value), d = $0b2e6adb871a3b94$var$Sa(b.defaultValue);
    null != c && (c = "" + c, c !== a.value && (a.value = c), null == b.defaultValue && a.defaultValue !== c && (a.defaultValue = c));
    null != d && (a.defaultValue = "" + d);
}
function $0b2e6adb871a3b94$var$jb(a) {
    var b = a.textContent;
    b === a._wrapperState.initialValue && "" !== b && null !== b && (a.value = b);
}
function $0b2e6adb871a3b94$var$kb(a) {
    switch(a){
        case "svg":
            return "http://www.w3.org/2000/svg";
        case "math":
            return "http://www.w3.org/1998/Math/MathML";
        default:
            return "http://www.w3.org/1999/xhtml";
    }
}
function $0b2e6adb871a3b94$var$lb(a, b) {
    return null == a || "http://www.w3.org/1999/xhtml" === a ? $0b2e6adb871a3b94$var$kb(b) : "http://www.w3.org/2000/svg" === a && "foreignObject" === b ? "http://www.w3.org/1999/xhtml" : a;
}
var $0b2e6adb871a3b94$var$mb, $0b2e6adb871a3b94$var$nb = function(a) {
    return "undefined" !== typeof MSApp && MSApp.execUnsafeLocalFunction ? function(b, c, d, e) {
        MSApp.execUnsafeLocalFunction(function() {
            return a(b, c, d, e);
        });
    } : a;
}(function(a, b) {
    if ("http://www.w3.org/2000/svg" !== a.namespaceURI || "innerHTML" in a) a.innerHTML = b;
    else {
        $0b2e6adb871a3b94$var$mb = $0b2e6adb871a3b94$var$mb || document.createElement("div");
        $0b2e6adb871a3b94$var$mb.innerHTML = "<svg>" + b.valueOf().toString() + "</svg>";
        for(b = $0b2e6adb871a3b94$var$mb.firstChild; a.firstChild;)a.removeChild(a.firstChild);
        for(; b.firstChild;)a.appendChild(b.firstChild);
    }
});
function $0b2e6adb871a3b94$var$ob(a, b) {
    if (b) {
        var c = a.firstChild;
        if (c && c === a.lastChild && 3 === c.nodeType) {
            c.nodeValue = b;
            return;
        }
    }
    a.textContent = b;
}
var $0b2e6adb871a3b94$var$pb = {
    animationIterationCount: !0,
    aspectRatio: !0,
    borderImageOutset: !0,
    borderImageSlice: !0,
    borderImageWidth: !0,
    boxFlex: !0,
    boxFlexGroup: !0,
    boxOrdinalGroup: !0,
    columnCount: !0,
    columns: !0,
    flex: !0,
    flexGrow: !0,
    flexPositive: !0,
    flexShrink: !0,
    flexNegative: !0,
    flexOrder: !0,
    gridArea: !0,
    gridRow: !0,
    gridRowEnd: !0,
    gridRowSpan: !0,
    gridRowStart: !0,
    gridColumn: !0,
    gridColumnEnd: !0,
    gridColumnSpan: !0,
    gridColumnStart: !0,
    fontWeight: !0,
    lineClamp: !0,
    lineHeight: !0,
    opacity: !0,
    order: !0,
    orphans: !0,
    tabSize: !0,
    widows: !0,
    zIndex: !0,
    zoom: !0,
    fillOpacity: !0,
    floodOpacity: !0,
    stopOpacity: !0,
    strokeDasharray: !0,
    strokeDashoffset: !0,
    strokeMiterlimit: !0,
    strokeOpacity: !0,
    strokeWidth: !0
}, $0b2e6adb871a3b94$var$qb = [
    "Webkit",
    "ms",
    "Moz",
    "O"
];
Object.keys($0b2e6adb871a3b94$var$pb).forEach(function(a) {
    $0b2e6adb871a3b94$var$qb.forEach(function(b) {
        b = b + a.charAt(0).toUpperCase() + a.substring(1);
        $0b2e6adb871a3b94$var$pb[b] = $0b2e6adb871a3b94$var$pb[a];
    });
});
function $0b2e6adb871a3b94$var$rb(a, b, c) {
    return null == b || "boolean" === typeof b || "" === b ? "" : c || "number" !== typeof b || 0 === b || $0b2e6adb871a3b94$var$pb.hasOwnProperty(a) && $0b2e6adb871a3b94$var$pb[a] ? ("" + b).trim() : b + "px";
}
function $0b2e6adb871a3b94$var$sb(a, b) {
    a = a.style;
    for(var c in b)if (b.hasOwnProperty(c)) {
        var d = 0 === c.indexOf("--"), e = $0b2e6adb871a3b94$var$rb(c, b[c], d);
        "float" === c && (c = "cssFloat");
        d ? a.setProperty(c, e) : a[c] = e;
    }
}
var $0b2e6adb871a3b94$var$tb = $0b2e6adb871a3b94$var$A({
    menuitem: !0
}, {
    area: !0,
    base: !0,
    br: !0,
    col: !0,
    embed: !0,
    hr: !0,
    img: !0,
    input: !0,
    keygen: !0,
    link: !0,
    meta: !0,
    param: !0,
    source: !0,
    track: !0,
    wbr: !0
});
function $0b2e6adb871a3b94$var$ub(a, b) {
    if (b) {
        if ($0b2e6adb871a3b94$var$tb[a] && (null != b.children || null != b.dangerouslySetInnerHTML)) throw Error($0b2e6adb871a3b94$var$p(137, a));
        if (null != b.dangerouslySetInnerHTML) {
            if (null != b.children) throw Error($0b2e6adb871a3b94$var$p(60));
            if ("object" !== typeof b.dangerouslySetInnerHTML || !("__html" in b.dangerouslySetInnerHTML)) throw Error($0b2e6adb871a3b94$var$p(61));
        }
        if (null != b.style && "object" !== typeof b.style) throw Error($0b2e6adb871a3b94$var$p(62));
    }
}
function $0b2e6adb871a3b94$var$vb(a, b) {
    if (-1 === a.indexOf("-")) return "string" === typeof b.is;
    switch(a){
        case "annotation-xml":
        case "color-profile":
        case "font-face":
        case "font-face-src":
        case "font-face-uri":
        case "font-face-format":
        case "font-face-name":
        case "missing-glyph":
            return !1;
        default:
            return !0;
    }
}
var $0b2e6adb871a3b94$var$wb = null;
function $0b2e6adb871a3b94$var$xb(a) {
    a = a.target || a.srcElement || window;
    a.correspondingUseElement && (a = a.correspondingUseElement);
    return 3 === a.nodeType ? a.parentNode : a;
}
var $0b2e6adb871a3b94$var$yb = null, $0b2e6adb871a3b94$var$zb = null, $0b2e6adb871a3b94$var$Ab = null;
function $0b2e6adb871a3b94$var$Bb(a) {
    if (a = $0b2e6adb871a3b94$var$Cb(a)) {
        if ("function" !== typeof $0b2e6adb871a3b94$var$yb) throw Error($0b2e6adb871a3b94$var$p(280));
        var b = a.stateNode;
        b && (b = $0b2e6adb871a3b94$var$Db(b), $0b2e6adb871a3b94$var$yb(a.stateNode, a.type, b));
    }
}
function $0b2e6adb871a3b94$var$Eb(a) {
    $0b2e6adb871a3b94$var$zb ? $0b2e6adb871a3b94$var$Ab ? $0b2e6adb871a3b94$var$Ab.push(a) : $0b2e6adb871a3b94$var$Ab = [
        a
    ] : $0b2e6adb871a3b94$var$zb = a;
}
function $0b2e6adb871a3b94$var$Fb() {
    if ($0b2e6adb871a3b94$var$zb) {
        var a = $0b2e6adb871a3b94$var$zb, b = $0b2e6adb871a3b94$var$Ab;
        $0b2e6adb871a3b94$var$Ab = $0b2e6adb871a3b94$var$zb = null;
        $0b2e6adb871a3b94$var$Bb(a);
        if (b) for(a = 0; a < b.length; a++)$0b2e6adb871a3b94$var$Bb(b[a]);
    }
}
function $0b2e6adb871a3b94$var$Gb(a, b) {
    return a(b);
}
function $0b2e6adb871a3b94$var$Hb() {}
var $0b2e6adb871a3b94$var$Ib = !1;
function $0b2e6adb871a3b94$var$Jb(a, b, c) {
    if ($0b2e6adb871a3b94$var$Ib) return a(b, c);
    $0b2e6adb871a3b94$var$Ib = !0;
    try {
        return $0b2e6adb871a3b94$var$Gb(a, b, c);
    } finally{
        if ($0b2e6adb871a3b94$var$Ib = !1, null !== $0b2e6adb871a3b94$var$zb || null !== $0b2e6adb871a3b94$var$Ab) $0b2e6adb871a3b94$var$Hb(), $0b2e6adb871a3b94$var$Fb();
    }
}
function $0b2e6adb871a3b94$var$Kb(a, b) {
    var c = a.stateNode;
    if (null === c) return null;
    var d = $0b2e6adb871a3b94$var$Db(c);
    if (null === d) return null;
    c = d[b];
    a: switch(b){
        case "onClick":
        case "onClickCapture":
        case "onDoubleClick":
        case "onDoubleClickCapture":
        case "onMouseDown":
        case "onMouseDownCapture":
        case "onMouseMove":
        case "onMouseMoveCapture":
        case "onMouseUp":
        case "onMouseUpCapture":
        case "onMouseEnter":
            (d = !d.disabled) || (a = a.type, d = !("button" === a || "input" === a || "select" === a || "textarea" === a));
            a = !d;
            break a;
        default:
            a = !1;
    }
    if (a) return null;
    if (c && "function" !== typeof c) throw Error($0b2e6adb871a3b94$var$p(231, b, typeof c));
    return c;
}
var $0b2e6adb871a3b94$var$Lb = !1;
if ($0b2e6adb871a3b94$var$ia) try {
    var $0b2e6adb871a3b94$var$Mb = {};
    Object.defineProperty($0b2e6adb871a3b94$var$Mb, "passive", {
        get: function() {
            $0b2e6adb871a3b94$var$Lb = !0;
        }
    });
    window.addEventListener("test", $0b2e6adb871a3b94$var$Mb, $0b2e6adb871a3b94$var$Mb);
    window.removeEventListener("test", $0b2e6adb871a3b94$var$Mb, $0b2e6adb871a3b94$var$Mb);
} catch (a) {
    $0b2e6adb871a3b94$var$Lb = !1;
}
function $0b2e6adb871a3b94$var$Nb(a, b, c, d, e, f, g, h, k) {
    var l = Array.prototype.slice.call(arguments, 3);
    try {
        b.apply(c, l);
    } catch (m) {
        this.onError(m);
    }
}
var $0b2e6adb871a3b94$var$Ob = !1, $0b2e6adb871a3b94$var$Pb = null, $0b2e6adb871a3b94$var$Qb = !1, $0b2e6adb871a3b94$var$Rb = null, $0b2e6adb871a3b94$var$Sb = {
    onError: function(a) {
        $0b2e6adb871a3b94$var$Ob = !0;
        $0b2e6adb871a3b94$var$Pb = a;
    }
};
function $0b2e6adb871a3b94$var$Tb(a, b, c, d, e, f, g, h, k) {
    $0b2e6adb871a3b94$var$Ob = !1;
    $0b2e6adb871a3b94$var$Pb = null;
    $0b2e6adb871a3b94$var$Nb.apply($0b2e6adb871a3b94$var$Sb, arguments);
}
function $0b2e6adb871a3b94$var$Ub(a, b, c, d, e, f, g, h, k) {
    $0b2e6adb871a3b94$var$Tb.apply(this, arguments);
    if ($0b2e6adb871a3b94$var$Ob) {
        if ($0b2e6adb871a3b94$var$Ob) {
            var l = $0b2e6adb871a3b94$var$Pb;
            $0b2e6adb871a3b94$var$Ob = !1;
            $0b2e6adb871a3b94$var$Pb = null;
        } else throw Error($0b2e6adb871a3b94$var$p(198));
        $0b2e6adb871a3b94$var$Qb || ($0b2e6adb871a3b94$var$Qb = !0, $0b2e6adb871a3b94$var$Rb = l);
    }
}
function $0b2e6adb871a3b94$var$Vb(a) {
    var b = a, c = a;
    if (a.alternate) for(; b.return;)b = b.return;
    else {
        a = b;
        do b = a, 0 !== (b.flags & 4098) && (c = b.return), a = b.return;
        while (a);
    }
    return 3 === b.tag ? c : null;
}
function $0b2e6adb871a3b94$var$Wb(a) {
    if (13 === a.tag) {
        var b = a.memoizedState;
        null === b && (a = a.alternate, null !== a && (b = a.memoizedState));
        if (null !== b) return b.dehydrated;
    }
    return null;
}
function $0b2e6adb871a3b94$var$Xb(a) {
    if ($0b2e6adb871a3b94$var$Vb(a) !== a) throw Error($0b2e6adb871a3b94$var$p(188));
}
function $0b2e6adb871a3b94$var$Yb(a) {
    var b = a.alternate;
    if (!b) {
        b = $0b2e6adb871a3b94$var$Vb(a);
        if (null === b) throw Error($0b2e6adb871a3b94$var$p(188));
        return b !== a ? null : a;
    }
    for(var c = a, d = b;;){
        var e = c.return;
        if (null === e) break;
        var f = e.alternate;
        if (null === f) {
            d = e.return;
            if (null !== d) {
                c = d;
                continue;
            }
            break;
        }
        if (e.child === f.child) {
            for(f = e.child; f;){
                if (f === c) return $0b2e6adb871a3b94$var$Xb(e), a;
                if (f === d) return $0b2e6adb871a3b94$var$Xb(e), b;
                f = f.sibling;
            }
            throw Error($0b2e6adb871a3b94$var$p(188));
        }
        if (c.return !== d.return) c = e, d = f;
        else {
            for(var g = !1, h = e.child; h;){
                if (h === c) {
                    g = !0;
                    c = e;
                    d = f;
                    break;
                }
                if (h === d) {
                    g = !0;
                    d = e;
                    c = f;
                    break;
                }
                h = h.sibling;
            }
            if (!g) {
                for(h = f.child; h;){
                    if (h === c) {
                        g = !0;
                        c = f;
                        d = e;
                        break;
                    }
                    if (h === d) {
                        g = !0;
                        d = f;
                        c = e;
                        break;
                    }
                    h = h.sibling;
                }
                if (!g) throw Error($0b2e6adb871a3b94$var$p(189));
            }
        }
        if (c.alternate !== d) throw Error($0b2e6adb871a3b94$var$p(190));
    }
    if (3 !== c.tag) throw Error($0b2e6adb871a3b94$var$p(188));
    return c.stateNode.current === c ? a : b;
}
function $0b2e6adb871a3b94$var$Zb(a) {
    a = $0b2e6adb871a3b94$var$Yb(a);
    return null !== a ? $0b2e6adb871a3b94$var$$b(a) : null;
}
function $0b2e6adb871a3b94$var$$b(a) {
    if (5 === a.tag || 6 === a.tag) return a;
    for(a = a.child; null !== a;){
        var b = $0b2e6adb871a3b94$var$$b(a);
        if (null !== b) return b;
        a = a.sibling;
    }
    return null;
}
var $0b2e6adb871a3b94$var$ac = $fO90s.unstable_scheduleCallback, $0b2e6adb871a3b94$var$bc = $fO90s.unstable_cancelCallback, $0b2e6adb871a3b94$var$cc = $fO90s.unstable_shouldYield, $0b2e6adb871a3b94$var$dc = $fO90s.unstable_requestPaint, $0b2e6adb871a3b94$var$B = $fO90s.unstable_now, $0b2e6adb871a3b94$var$ec = $fO90s.unstable_getCurrentPriorityLevel, $0b2e6adb871a3b94$var$fc = $fO90s.unstable_ImmediatePriority, $0b2e6adb871a3b94$var$gc = $fO90s.unstable_UserBlockingPriority, $0b2e6adb871a3b94$var$hc = $fO90s.unstable_NormalPriority, $0b2e6adb871a3b94$var$ic = $fO90s.unstable_LowPriority, $0b2e6adb871a3b94$var$jc = $fO90s.unstable_IdlePriority, $0b2e6adb871a3b94$var$kc = null, $0b2e6adb871a3b94$var$lc = null;
function $0b2e6adb871a3b94$var$mc(a) {
    if ($0b2e6adb871a3b94$var$lc && "function" === typeof $0b2e6adb871a3b94$var$lc.onCommitFiberRoot) try {
        $0b2e6adb871a3b94$var$lc.onCommitFiberRoot($0b2e6adb871a3b94$var$kc, a, void 0, 128 === (a.current.flags & 128));
    } catch (b) {}
}
var $0b2e6adb871a3b94$var$oc = Math.clz32 ? Math.clz32 : $0b2e6adb871a3b94$var$nc, $0b2e6adb871a3b94$var$pc = Math.log, $0b2e6adb871a3b94$var$qc = Math.LN2;
function $0b2e6adb871a3b94$var$nc(a) {
    a >>>= 0;
    return 0 === a ? 32 : 31 - ($0b2e6adb871a3b94$var$pc(a) / $0b2e6adb871a3b94$var$qc | 0) | 0;
}
var $0b2e6adb871a3b94$var$rc = 64, $0b2e6adb871a3b94$var$sc = 4194304;
function $0b2e6adb871a3b94$var$tc(a) {
    switch(a & -a){
        case 1:
            return 1;
        case 2:
            return 2;
        case 4:
            return 4;
        case 8:
            return 8;
        case 16:
            return 16;
        case 32:
            return 32;
        case 64:
        case 128:
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
            return a & 4194240;
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
        case 67108864:
            return a & 130023424;
        case 134217728:
            return 134217728;
        case 268435456:
            return 268435456;
        case 536870912:
            return 536870912;
        case 1073741824:
            return 1073741824;
        default:
            return a;
    }
}
function $0b2e6adb871a3b94$var$uc(a, b) {
    var c = a.pendingLanes;
    if (0 === c) return 0;
    var d = 0, e = a.suspendedLanes, f = a.pingedLanes, g = c & 268435455;
    if (0 !== g) {
        var h = g & ~e;
        0 !== h ? d = $0b2e6adb871a3b94$var$tc(h) : (f &= g, 0 !== f && (d = $0b2e6adb871a3b94$var$tc(f)));
    } else g = c & ~e, 0 !== g ? d = $0b2e6adb871a3b94$var$tc(g) : 0 !== f && (d = $0b2e6adb871a3b94$var$tc(f));
    if (0 === d) return 0;
    if (0 !== b && b !== d && 0 === (b & e) && (e = d & -d, f = b & -b, e >= f || 16 === e && 0 !== (f & 4194240))) return b;
    0 !== (d & 4) && (d |= c & 16);
    b = a.entangledLanes;
    if (0 !== b) for(a = a.entanglements, b &= d; 0 < b;)c = 31 - $0b2e6adb871a3b94$var$oc(b), e = 1 << c, d |= a[c], b &= ~e;
    return d;
}
function $0b2e6adb871a3b94$var$vc(a, b) {
    switch(a){
        case 1:
        case 2:
        case 4:
            return b + 250;
        case 8:
        case 16:
        case 32:
        case 64:
        case 128:
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
            return b + 5E3;
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
        case 67108864:
            return -1;
        case 134217728:
        case 268435456:
        case 536870912:
        case 1073741824:
            return -1;
        default:
            return -1;
    }
}
function $0b2e6adb871a3b94$var$wc(a, b) {
    for(var c = a.suspendedLanes, d = a.pingedLanes, e = a.expirationTimes, f = a.pendingLanes; 0 < f;){
        var g = 31 - $0b2e6adb871a3b94$var$oc(f), h = 1 << g, k = e[g];
        if (-1 === k) {
            if (0 === (h & c) || 0 !== (h & d)) e[g] = $0b2e6adb871a3b94$var$vc(h, b);
        } else k <= b && (a.expiredLanes |= h);
        f &= ~h;
    }
}
function $0b2e6adb871a3b94$var$xc(a) {
    a = a.pendingLanes & -1073741825;
    return 0 !== a ? a : a & 1073741824 ? 1073741824 : 0;
}
function $0b2e6adb871a3b94$var$yc() {
    var a = $0b2e6adb871a3b94$var$rc;
    $0b2e6adb871a3b94$var$rc <<= 1;
    0 === ($0b2e6adb871a3b94$var$rc & 4194240) && ($0b2e6adb871a3b94$var$rc = 64);
    return a;
}
function $0b2e6adb871a3b94$var$zc(a) {
    for(var b = [], c = 0; 31 > c; c++)b.push(a);
    return b;
}
function $0b2e6adb871a3b94$var$Ac(a, b, c) {
    a.pendingLanes |= b;
    536870912 !== b && (a.suspendedLanes = 0, a.pingedLanes = 0);
    a = a.eventTimes;
    b = 31 - $0b2e6adb871a3b94$var$oc(b);
    a[b] = c;
}
function $0b2e6adb871a3b94$var$Bc(a, b) {
    var c = a.pendingLanes & ~b;
    a.pendingLanes = b;
    a.suspendedLanes = 0;
    a.pingedLanes = 0;
    a.expiredLanes &= b;
    a.mutableReadLanes &= b;
    a.entangledLanes &= b;
    b = a.entanglements;
    var d = a.eventTimes;
    for(a = a.expirationTimes; 0 < c;){
        var e = 31 - $0b2e6adb871a3b94$var$oc(c), f = 1 << e;
        b[e] = 0;
        d[e] = -1;
        a[e] = -1;
        c &= ~f;
    }
}
function $0b2e6adb871a3b94$var$Cc(a, b) {
    var c = a.entangledLanes |= b;
    for(a = a.entanglements; c;){
        var d = 31 - $0b2e6adb871a3b94$var$oc(c), e = 1 << d;
        e & b | a[d] & b && (a[d] |= b);
        c &= ~e;
    }
}
var $0b2e6adb871a3b94$var$C = 0;
function $0b2e6adb871a3b94$var$Dc(a) {
    a &= -a;
    return 1 < a ? 4 < a ? 0 !== (a & 268435455) ? 16 : 536870912 : 4 : 1;
}
var $0b2e6adb871a3b94$var$Ec, $0b2e6adb871a3b94$var$Fc, $0b2e6adb871a3b94$var$Gc, $0b2e6adb871a3b94$var$Hc, $0b2e6adb871a3b94$var$Ic, $0b2e6adb871a3b94$var$Jc = !1, $0b2e6adb871a3b94$var$Kc = [], $0b2e6adb871a3b94$var$Lc = null, $0b2e6adb871a3b94$var$Mc = null, $0b2e6adb871a3b94$var$Nc = null, $0b2e6adb871a3b94$var$Oc = new Map, $0b2e6adb871a3b94$var$Pc = new Map, $0b2e6adb871a3b94$var$Qc = [], $0b2e6adb871a3b94$var$Rc = "mousedown mouseup touchcancel touchend touchstart auxclick dblclick pointercancel pointerdown pointerup dragend dragstart drop compositionend compositionstart keydown keypress keyup input textInput copy cut paste click change contextmenu reset submit".split(" ");
function $0b2e6adb871a3b94$var$Sc(a, b) {
    switch(a){
        case "focusin":
        case "focusout":
            $0b2e6adb871a3b94$var$Lc = null;
            break;
        case "dragenter":
        case "dragleave":
            $0b2e6adb871a3b94$var$Mc = null;
            break;
        case "mouseover":
        case "mouseout":
            $0b2e6adb871a3b94$var$Nc = null;
            break;
        case "pointerover":
        case "pointerout":
            $0b2e6adb871a3b94$var$Oc.delete(b.pointerId);
            break;
        case "gotpointercapture":
        case "lostpointercapture":
            $0b2e6adb871a3b94$var$Pc.delete(b.pointerId);
    }
}
function $0b2e6adb871a3b94$var$Tc(a, b, c, d, e, f) {
    if (null === a || a.nativeEvent !== f) return a = {
        blockedOn: b,
        domEventName: c,
        eventSystemFlags: d,
        nativeEvent: f,
        targetContainers: [
            e
        ]
    }, null !== b && (b = $0b2e6adb871a3b94$var$Cb(b), null !== b && $0b2e6adb871a3b94$var$Fc(b)), a;
    a.eventSystemFlags |= d;
    b = a.targetContainers;
    null !== e && -1 === b.indexOf(e) && b.push(e);
    return a;
}
function $0b2e6adb871a3b94$var$Uc(a, b, c, d, e) {
    switch(b){
        case "focusin":
            return $0b2e6adb871a3b94$var$Lc = $0b2e6adb871a3b94$var$Tc($0b2e6adb871a3b94$var$Lc, a, b, c, d, e), !0;
        case "dragenter":
            return $0b2e6adb871a3b94$var$Mc = $0b2e6adb871a3b94$var$Tc($0b2e6adb871a3b94$var$Mc, a, b, c, d, e), !0;
        case "mouseover":
            return $0b2e6adb871a3b94$var$Nc = $0b2e6adb871a3b94$var$Tc($0b2e6adb871a3b94$var$Nc, a, b, c, d, e), !0;
        case "pointerover":
            var f = e.pointerId;
            $0b2e6adb871a3b94$var$Oc.set(f, $0b2e6adb871a3b94$var$Tc($0b2e6adb871a3b94$var$Oc.get(f) || null, a, b, c, d, e));
            return !0;
        case "gotpointercapture":
            return f = e.pointerId, $0b2e6adb871a3b94$var$Pc.set(f, $0b2e6adb871a3b94$var$Tc($0b2e6adb871a3b94$var$Pc.get(f) || null, a, b, c, d, e)), !0;
    }
    return !1;
}
function $0b2e6adb871a3b94$var$Vc(a) {
    var b = $0b2e6adb871a3b94$var$Wc(a.target);
    if (null !== b) {
        var c = $0b2e6adb871a3b94$var$Vb(b);
        if (null !== c) {
            if (b = c.tag, 13 === b) {
                if (b = $0b2e6adb871a3b94$var$Wb(c), null !== b) {
                    a.blockedOn = b;
                    $0b2e6adb871a3b94$var$Ic(a.priority, function() {
                        $0b2e6adb871a3b94$var$Gc(c);
                    });
                    return;
                }
            } else if (3 === b && c.stateNode.current.memoizedState.isDehydrated) {
                a.blockedOn = 3 === c.tag ? c.stateNode.containerInfo : null;
                return;
            }
        }
    }
    a.blockedOn = null;
}
function $0b2e6adb871a3b94$var$Xc(a) {
    if (null !== a.blockedOn) return !1;
    for(var b = a.targetContainers; 0 < b.length;){
        var c = $0b2e6adb871a3b94$var$Yc(a.domEventName, a.eventSystemFlags, b[0], a.nativeEvent);
        if (null === c) {
            c = a.nativeEvent;
            var d = new c.constructor(c.type, c);
            $0b2e6adb871a3b94$var$wb = d;
            c.target.dispatchEvent(d);
            $0b2e6adb871a3b94$var$wb = null;
        } else return b = $0b2e6adb871a3b94$var$Cb(c), null !== b && $0b2e6adb871a3b94$var$Fc(b), a.blockedOn = c, !1;
        b.shift();
    }
    return !0;
}
function $0b2e6adb871a3b94$var$Zc(a, b, c) {
    $0b2e6adb871a3b94$var$Xc(a) && c.delete(b);
}
function $0b2e6adb871a3b94$var$$c() {
    $0b2e6adb871a3b94$var$Jc = !1;
    null !== $0b2e6adb871a3b94$var$Lc && $0b2e6adb871a3b94$var$Xc($0b2e6adb871a3b94$var$Lc) && ($0b2e6adb871a3b94$var$Lc = null);
    null !== $0b2e6adb871a3b94$var$Mc && $0b2e6adb871a3b94$var$Xc($0b2e6adb871a3b94$var$Mc) && ($0b2e6adb871a3b94$var$Mc = null);
    null !== $0b2e6adb871a3b94$var$Nc && $0b2e6adb871a3b94$var$Xc($0b2e6adb871a3b94$var$Nc) && ($0b2e6adb871a3b94$var$Nc = null);
    $0b2e6adb871a3b94$var$Oc.forEach($0b2e6adb871a3b94$var$Zc);
    $0b2e6adb871a3b94$var$Pc.forEach($0b2e6adb871a3b94$var$Zc);
}
function $0b2e6adb871a3b94$var$ad(a, b) {
    a.blockedOn === b && (a.blockedOn = null, $0b2e6adb871a3b94$var$Jc || ($0b2e6adb871a3b94$var$Jc = !0, $fO90s.unstable_scheduleCallback($fO90s.unstable_NormalPriority, $0b2e6adb871a3b94$var$$c)));
}
function $0b2e6adb871a3b94$var$bd(a) {
    function b(b) {
        return $0b2e6adb871a3b94$var$ad(b, a);
    }
    if (0 < $0b2e6adb871a3b94$var$Kc.length) {
        $0b2e6adb871a3b94$var$ad($0b2e6adb871a3b94$var$Kc[0], a);
        for(var c = 1; c < $0b2e6adb871a3b94$var$Kc.length; c++){
            var d = $0b2e6adb871a3b94$var$Kc[c];
            d.blockedOn === a && (d.blockedOn = null);
        }
    }
    null !== $0b2e6adb871a3b94$var$Lc && $0b2e6adb871a3b94$var$ad($0b2e6adb871a3b94$var$Lc, a);
    null !== $0b2e6adb871a3b94$var$Mc && $0b2e6adb871a3b94$var$ad($0b2e6adb871a3b94$var$Mc, a);
    null !== $0b2e6adb871a3b94$var$Nc && $0b2e6adb871a3b94$var$ad($0b2e6adb871a3b94$var$Nc, a);
    $0b2e6adb871a3b94$var$Oc.forEach(b);
    $0b2e6adb871a3b94$var$Pc.forEach(b);
    for(c = 0; c < $0b2e6adb871a3b94$var$Qc.length; c++)d = $0b2e6adb871a3b94$var$Qc[c], d.blockedOn === a && (d.blockedOn = null);
    for(; 0 < $0b2e6adb871a3b94$var$Qc.length && (c = $0b2e6adb871a3b94$var$Qc[0], null === c.blockedOn);)$0b2e6adb871a3b94$var$Vc(c), null === c.blockedOn && $0b2e6adb871a3b94$var$Qc.shift();
}
var $0b2e6adb871a3b94$var$cd = $0b2e6adb871a3b94$var$ua.ReactCurrentBatchConfig, $0b2e6adb871a3b94$var$dd = !0;
function $0b2e6adb871a3b94$var$ed(a, b, c, d) {
    var e = $0b2e6adb871a3b94$var$C, f = $0b2e6adb871a3b94$var$cd.transition;
    $0b2e6adb871a3b94$var$cd.transition = null;
    try {
        $0b2e6adb871a3b94$var$C = 1, $0b2e6adb871a3b94$var$fd(a, b, c, d);
    } finally{
        $0b2e6adb871a3b94$var$C = e, $0b2e6adb871a3b94$var$cd.transition = f;
    }
}
function $0b2e6adb871a3b94$var$gd(a, b, c, d) {
    var e = $0b2e6adb871a3b94$var$C, f = $0b2e6adb871a3b94$var$cd.transition;
    $0b2e6adb871a3b94$var$cd.transition = null;
    try {
        $0b2e6adb871a3b94$var$C = 4, $0b2e6adb871a3b94$var$fd(a, b, c, d);
    } finally{
        $0b2e6adb871a3b94$var$C = e, $0b2e6adb871a3b94$var$cd.transition = f;
    }
}
function $0b2e6adb871a3b94$var$fd(a, b, c, d) {
    if ($0b2e6adb871a3b94$var$dd) {
        var e = $0b2e6adb871a3b94$var$Yc(a, b, c, d);
        if (null === e) $0b2e6adb871a3b94$var$hd(a, b, d, $0b2e6adb871a3b94$var$id, c), $0b2e6adb871a3b94$var$Sc(a, d);
        else if ($0b2e6adb871a3b94$var$Uc(e, a, b, c, d)) d.stopPropagation();
        else if ($0b2e6adb871a3b94$var$Sc(a, d), b & 4 && -1 < $0b2e6adb871a3b94$var$Rc.indexOf(a)) {
            for(; null !== e;){
                var f = $0b2e6adb871a3b94$var$Cb(e);
                null !== f && $0b2e6adb871a3b94$var$Ec(f);
                f = $0b2e6adb871a3b94$var$Yc(a, b, c, d);
                null === f && $0b2e6adb871a3b94$var$hd(a, b, d, $0b2e6adb871a3b94$var$id, c);
                if (f === e) break;
                e = f;
            }
            null !== e && d.stopPropagation();
        } else $0b2e6adb871a3b94$var$hd(a, b, d, null, c);
    }
}
var $0b2e6adb871a3b94$var$id = null;
function $0b2e6adb871a3b94$var$Yc(a, b, c, d) {
    $0b2e6adb871a3b94$var$id = null;
    a = $0b2e6adb871a3b94$var$xb(d);
    a = $0b2e6adb871a3b94$var$Wc(a);
    if (null !== a) {
        if (b = $0b2e6adb871a3b94$var$Vb(a), null === b) a = null;
        else if (c = b.tag, 13 === c) {
            a = $0b2e6adb871a3b94$var$Wb(b);
            if (null !== a) return a;
            a = null;
        } else if (3 === c) {
            if (b.stateNode.current.memoizedState.isDehydrated) return 3 === b.tag ? b.stateNode.containerInfo : null;
            a = null;
        } else b !== a && (a = null);
    }
    $0b2e6adb871a3b94$var$id = a;
    return null;
}
function $0b2e6adb871a3b94$var$jd(a) {
    switch(a){
        case "cancel":
        case "click":
        case "close":
        case "contextmenu":
        case "copy":
        case "cut":
        case "auxclick":
        case "dblclick":
        case "dragend":
        case "dragstart":
        case "drop":
        case "focusin":
        case "focusout":
        case "input":
        case "invalid":
        case "keydown":
        case "keypress":
        case "keyup":
        case "mousedown":
        case "mouseup":
        case "paste":
        case "pause":
        case "play":
        case "pointercancel":
        case "pointerdown":
        case "pointerup":
        case "ratechange":
        case "reset":
        case "resize":
        case "seeked":
        case "submit":
        case "touchcancel":
        case "touchend":
        case "touchstart":
        case "volumechange":
        case "change":
        case "selectionchange":
        case "textInput":
        case "compositionstart":
        case "compositionend":
        case "compositionupdate":
        case "beforeblur":
        case "afterblur":
        case "beforeinput":
        case "blur":
        case "fullscreenchange":
        case "focus":
        case "hashchange":
        case "popstate":
        case "select":
        case "selectstart":
            return 1;
        case "drag":
        case "dragenter":
        case "dragexit":
        case "dragleave":
        case "dragover":
        case "mousemove":
        case "mouseout":
        case "mouseover":
        case "pointermove":
        case "pointerout":
        case "pointerover":
        case "scroll":
        case "toggle":
        case "touchmove":
        case "wheel":
        case "mouseenter":
        case "mouseleave":
        case "pointerenter":
        case "pointerleave":
            return 4;
        case "message":
            switch($0b2e6adb871a3b94$var$ec()){
                case $0b2e6adb871a3b94$var$fc:
                    return 1;
                case $0b2e6adb871a3b94$var$gc:
                    return 4;
                case $0b2e6adb871a3b94$var$hc:
                case $0b2e6adb871a3b94$var$ic:
                    return 16;
                case $0b2e6adb871a3b94$var$jc:
                    return 536870912;
                default:
                    return 16;
            }
        default:
            return 16;
    }
}
var $0b2e6adb871a3b94$var$kd = null, $0b2e6adb871a3b94$var$ld = null, $0b2e6adb871a3b94$var$md = null;
function $0b2e6adb871a3b94$var$nd() {
    if ($0b2e6adb871a3b94$var$md) return $0b2e6adb871a3b94$var$md;
    var a, b = $0b2e6adb871a3b94$var$ld, c = b.length, d, e = "value" in $0b2e6adb871a3b94$var$kd ? $0b2e6adb871a3b94$var$kd.value : $0b2e6adb871a3b94$var$kd.textContent, f = e.length;
    for(a = 0; a < c && b[a] === e[a]; a++);
    var g = c - a;
    for(d = 1; d <= g && b[c - d] === e[f - d]; d++);
    return $0b2e6adb871a3b94$var$md = e.slice(a, 1 < d ? 1 - d : void 0);
}
function $0b2e6adb871a3b94$var$od(a) {
    var b = a.keyCode;
    "charCode" in a ? (a = a.charCode, 0 === a && 13 === b && (a = 13)) : a = b;
    10 === a && (a = 13);
    return 32 <= a || 13 === a ? a : 0;
}
function $0b2e6adb871a3b94$var$pd() {
    return !0;
}
function $0b2e6adb871a3b94$var$qd() {
    return !1;
}
function $0b2e6adb871a3b94$var$rd(a) {
    function b(b, d, e, f, g) {
        this._reactName = b;
        this._targetInst = e;
        this.type = d;
        this.nativeEvent = f;
        this.target = g;
        this.currentTarget = null;
        for(var c in a)a.hasOwnProperty(c) && (b = a[c], this[c] = b ? b(f) : f[c]);
        this.isDefaultPrevented = (null != f.defaultPrevented ? f.defaultPrevented : !1 === f.returnValue) ? $0b2e6adb871a3b94$var$pd : $0b2e6adb871a3b94$var$qd;
        this.isPropagationStopped = $0b2e6adb871a3b94$var$qd;
        return this;
    }
    $0b2e6adb871a3b94$var$A(b.prototype, {
        preventDefault: function() {
            this.defaultPrevented = !0;
            var a = this.nativeEvent;
            a && (a.preventDefault ? a.preventDefault() : "unknown" !== typeof a.returnValue && (a.returnValue = !1), this.isDefaultPrevented = $0b2e6adb871a3b94$var$pd);
        },
        stopPropagation: function() {
            var a = this.nativeEvent;
            a && (a.stopPropagation ? a.stopPropagation() : "unknown" !== typeof a.cancelBubble && (a.cancelBubble = !0), this.isPropagationStopped = $0b2e6adb871a3b94$var$pd);
        },
        persist: function() {},
        isPersistent: $0b2e6adb871a3b94$var$pd
    });
    return b;
}
var $0b2e6adb871a3b94$var$sd = {
    eventPhase: 0,
    bubbles: 0,
    cancelable: 0,
    timeStamp: function(a) {
        return a.timeStamp || Date.now();
    },
    defaultPrevented: 0,
    isTrusted: 0
}, $0b2e6adb871a3b94$var$td = $0b2e6adb871a3b94$var$rd($0b2e6adb871a3b94$var$sd), $0b2e6adb871a3b94$var$ud = $0b2e6adb871a3b94$var$A({}, $0b2e6adb871a3b94$var$sd, {
    view: 0,
    detail: 0
}), $0b2e6adb871a3b94$var$vd = $0b2e6adb871a3b94$var$rd($0b2e6adb871a3b94$var$ud), $0b2e6adb871a3b94$var$wd, $0b2e6adb871a3b94$var$xd, $0b2e6adb871a3b94$var$yd, $0b2e6adb871a3b94$var$Ad = $0b2e6adb871a3b94$var$A({}, $0b2e6adb871a3b94$var$ud, {
    screenX: 0,
    screenY: 0,
    clientX: 0,
    clientY: 0,
    pageX: 0,
    pageY: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    getModifierState: $0b2e6adb871a3b94$var$zd,
    button: 0,
    buttons: 0,
    relatedTarget: function(a) {
        return void 0 === a.relatedTarget ? a.fromElement === a.srcElement ? a.toElement : a.fromElement : a.relatedTarget;
    },
    movementX: function(a) {
        if ("movementX" in a) return a.movementX;
        a !== $0b2e6adb871a3b94$var$yd && ($0b2e6adb871a3b94$var$yd && "mousemove" === a.type ? ($0b2e6adb871a3b94$var$wd = a.screenX - $0b2e6adb871a3b94$var$yd.screenX, $0b2e6adb871a3b94$var$xd = a.screenY - $0b2e6adb871a3b94$var$yd.screenY) : $0b2e6adb871a3b94$var$xd = $0b2e6adb871a3b94$var$wd = 0, $0b2e6adb871a3b94$var$yd = a);
        return $0b2e6adb871a3b94$var$wd;
    },
    movementY: function(a) {
        return "movementY" in a ? a.movementY : $0b2e6adb871a3b94$var$xd;
    }
}), $0b2e6adb871a3b94$var$Bd = $0b2e6adb871a3b94$var$rd($0b2e6adb871a3b94$var$Ad), $0b2e6adb871a3b94$var$Cd = $0b2e6adb871a3b94$var$A({}, $0b2e6adb871a3b94$var$Ad, {
    dataTransfer: 0
}), $0b2e6adb871a3b94$var$Dd = $0b2e6adb871a3b94$var$rd($0b2e6adb871a3b94$var$Cd), $0b2e6adb871a3b94$var$Ed = $0b2e6adb871a3b94$var$A({}, $0b2e6adb871a3b94$var$ud, {
    relatedTarget: 0
}), $0b2e6adb871a3b94$var$Fd = $0b2e6adb871a3b94$var$rd($0b2e6adb871a3b94$var$Ed), $0b2e6adb871a3b94$var$Gd = $0b2e6adb871a3b94$var$A({}, $0b2e6adb871a3b94$var$sd, {
    animationName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), $0b2e6adb871a3b94$var$Hd = $0b2e6adb871a3b94$var$rd($0b2e6adb871a3b94$var$Gd), $0b2e6adb871a3b94$var$Id = $0b2e6adb871a3b94$var$A({}, $0b2e6adb871a3b94$var$sd, {
    clipboardData: function(a) {
        return "clipboardData" in a ? a.clipboardData : window.clipboardData;
    }
}), $0b2e6adb871a3b94$var$Jd = $0b2e6adb871a3b94$var$rd($0b2e6adb871a3b94$var$Id), $0b2e6adb871a3b94$var$Kd = $0b2e6adb871a3b94$var$A({}, $0b2e6adb871a3b94$var$sd, {
    data: 0
}), $0b2e6adb871a3b94$var$Ld = $0b2e6adb871a3b94$var$rd($0b2e6adb871a3b94$var$Kd), $0b2e6adb871a3b94$var$Md = {
    Esc: "Escape",
    Spacebar: " ",
    Left: "ArrowLeft",
    Up: "ArrowUp",
    Right: "ArrowRight",
    Down: "ArrowDown",
    Del: "Delete",
    Win: "OS",
    Menu: "ContextMenu",
    Apps: "ContextMenu",
    Scroll: "ScrollLock",
    MozPrintableKey: "Unidentified"
}, $0b2e6adb871a3b94$var$Nd = {
    8: "Backspace",
    9: "Tab",
    12: "Clear",
    13: "Enter",
    16: "Shift",
    17: "Control",
    18: "Alt",
    19: "Pause",
    20: "CapsLock",
    27: "Escape",
    32: " ",
    33: "PageUp",
    34: "PageDown",
    35: "End",
    36: "Home",
    37: "ArrowLeft",
    38: "ArrowUp",
    39: "ArrowRight",
    40: "ArrowDown",
    45: "Insert",
    46: "Delete",
    112: "F1",
    113: "F2",
    114: "F3",
    115: "F4",
    116: "F5",
    117: "F6",
    118: "F7",
    119: "F8",
    120: "F9",
    121: "F10",
    122: "F11",
    123: "F12",
    144: "NumLock",
    145: "ScrollLock",
    224: "Meta"
}, $0b2e6adb871a3b94$var$Od = {
    Alt: "altKey",
    Control: "ctrlKey",
    Meta: "metaKey",
    Shift: "shiftKey"
};
function $0b2e6adb871a3b94$var$Pd(a) {
    var b = this.nativeEvent;
    return b.getModifierState ? b.getModifierState(a) : (a = $0b2e6adb871a3b94$var$Od[a]) ? !!b[a] : !1;
}
function $0b2e6adb871a3b94$var$zd() {
    return $0b2e6adb871a3b94$var$Pd;
}
var $0b2e6adb871a3b94$var$Qd = $0b2e6adb871a3b94$var$A({}, $0b2e6adb871a3b94$var$ud, {
    key: function(a) {
        if (a.key) {
            var b = $0b2e6adb871a3b94$var$Md[a.key] || a.key;
            if ("Unidentified" !== b) return b;
        }
        return "keypress" === a.type ? (a = $0b2e6adb871a3b94$var$od(a), 13 === a ? "Enter" : String.fromCharCode(a)) : "keydown" === a.type || "keyup" === a.type ? $0b2e6adb871a3b94$var$Nd[a.keyCode] || "Unidentified" : "";
    },
    code: 0,
    location: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    repeat: 0,
    locale: 0,
    getModifierState: $0b2e6adb871a3b94$var$zd,
    charCode: function(a) {
        return "keypress" === a.type ? $0b2e6adb871a3b94$var$od(a) : 0;
    },
    keyCode: function(a) {
        return "keydown" === a.type || "keyup" === a.type ? a.keyCode : 0;
    },
    which: function(a) {
        return "keypress" === a.type ? $0b2e6adb871a3b94$var$od(a) : "keydown" === a.type || "keyup" === a.type ? a.keyCode : 0;
    }
}), $0b2e6adb871a3b94$var$Rd = $0b2e6adb871a3b94$var$rd($0b2e6adb871a3b94$var$Qd), $0b2e6adb871a3b94$var$Sd = $0b2e6adb871a3b94$var$A({}, $0b2e6adb871a3b94$var$Ad, {
    pointerId: 0,
    width: 0,
    height: 0,
    pressure: 0,
    tangentialPressure: 0,
    tiltX: 0,
    tiltY: 0,
    twist: 0,
    pointerType: 0,
    isPrimary: 0
}), $0b2e6adb871a3b94$var$Td = $0b2e6adb871a3b94$var$rd($0b2e6adb871a3b94$var$Sd), $0b2e6adb871a3b94$var$Ud = $0b2e6adb871a3b94$var$A({}, $0b2e6adb871a3b94$var$ud, {
    touches: 0,
    targetTouches: 0,
    changedTouches: 0,
    altKey: 0,
    metaKey: 0,
    ctrlKey: 0,
    shiftKey: 0,
    getModifierState: $0b2e6adb871a3b94$var$zd
}), $0b2e6adb871a3b94$var$Vd = $0b2e6adb871a3b94$var$rd($0b2e6adb871a3b94$var$Ud), $0b2e6adb871a3b94$var$Wd = $0b2e6adb871a3b94$var$A({}, $0b2e6adb871a3b94$var$sd, {
    propertyName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), $0b2e6adb871a3b94$var$Xd = $0b2e6adb871a3b94$var$rd($0b2e6adb871a3b94$var$Wd), $0b2e6adb871a3b94$var$Yd = $0b2e6adb871a3b94$var$A({}, $0b2e6adb871a3b94$var$Ad, {
    deltaX: function(a) {
        return "deltaX" in a ? a.deltaX : "wheelDeltaX" in a ? -a.wheelDeltaX : 0;
    },
    deltaY: function(a) {
        return "deltaY" in a ? a.deltaY : "wheelDeltaY" in a ? -a.wheelDeltaY : "wheelDelta" in a ? -a.wheelDelta : 0;
    },
    deltaZ: 0,
    deltaMode: 0
}), $0b2e6adb871a3b94$var$Zd = $0b2e6adb871a3b94$var$rd($0b2e6adb871a3b94$var$Yd), $0b2e6adb871a3b94$var$$d = [
    9,
    13,
    27,
    32
], $0b2e6adb871a3b94$var$ae = $0b2e6adb871a3b94$var$ia && "CompositionEvent" in window, $0b2e6adb871a3b94$var$be = null;
$0b2e6adb871a3b94$var$ia && "documentMode" in document && ($0b2e6adb871a3b94$var$be = document.documentMode);
var $0b2e6adb871a3b94$var$ce = $0b2e6adb871a3b94$var$ia && "TextEvent" in window && !$0b2e6adb871a3b94$var$be, $0b2e6adb871a3b94$var$de = $0b2e6adb871a3b94$var$ia && (!$0b2e6adb871a3b94$var$ae || $0b2e6adb871a3b94$var$be && 8 < $0b2e6adb871a3b94$var$be && 11 >= $0b2e6adb871a3b94$var$be), $0b2e6adb871a3b94$var$ee = String.fromCharCode(32), $0b2e6adb871a3b94$var$fe = !1;
function $0b2e6adb871a3b94$var$ge(a, b) {
    switch(a){
        case "keyup":
            return -1 !== $0b2e6adb871a3b94$var$$d.indexOf(b.keyCode);
        case "keydown":
            return 229 !== b.keyCode;
        case "keypress":
        case "mousedown":
        case "focusout":
            return !0;
        default:
            return !1;
    }
}
function $0b2e6adb871a3b94$var$he(a) {
    a = a.detail;
    return "object" === typeof a && "data" in a ? a.data : null;
}
var $0b2e6adb871a3b94$var$ie = !1;
function $0b2e6adb871a3b94$var$je(a, b) {
    switch(a){
        case "compositionend":
            return $0b2e6adb871a3b94$var$he(b);
        case "keypress":
            if (32 !== b.which) return null;
            $0b2e6adb871a3b94$var$fe = !0;
            return $0b2e6adb871a3b94$var$ee;
        case "textInput":
            return a = b.data, a === $0b2e6adb871a3b94$var$ee && $0b2e6adb871a3b94$var$fe ? null : a;
        default:
            return null;
    }
}
function $0b2e6adb871a3b94$var$ke(a, b) {
    if ($0b2e6adb871a3b94$var$ie) return "compositionend" === a || !$0b2e6adb871a3b94$var$ae && $0b2e6adb871a3b94$var$ge(a, b) ? (a = $0b2e6adb871a3b94$var$nd(), $0b2e6adb871a3b94$var$md = $0b2e6adb871a3b94$var$ld = $0b2e6adb871a3b94$var$kd = null, $0b2e6adb871a3b94$var$ie = !1, a) : null;
    switch(a){
        case "paste":
            return null;
        case "keypress":
            if (!(b.ctrlKey || b.altKey || b.metaKey) || b.ctrlKey && b.altKey) {
                if (b.char && 1 < b.char.length) return b.char;
                if (b.which) return String.fromCharCode(b.which);
            }
            return null;
        case "compositionend":
            return $0b2e6adb871a3b94$var$de && "ko" !== b.locale ? null : b.data;
        default:
            return null;
    }
}
var $0b2e6adb871a3b94$var$le = {
    color: !0,
    date: !0,
    datetime: !0,
    "datetime-local": !0,
    email: !0,
    month: !0,
    number: !0,
    password: !0,
    range: !0,
    search: !0,
    tel: !0,
    text: !0,
    time: !0,
    url: !0,
    week: !0
};
function $0b2e6adb871a3b94$var$me(a) {
    var b = a && a.nodeName && a.nodeName.toLowerCase();
    return "input" === b ? !!$0b2e6adb871a3b94$var$le[a.type] : "textarea" === b ? !0 : !1;
}
function $0b2e6adb871a3b94$var$ne(a, b, c, d) {
    $0b2e6adb871a3b94$var$Eb(d);
    b = $0b2e6adb871a3b94$var$oe(b, "onChange");
    0 < b.length && (c = new $0b2e6adb871a3b94$var$td("onChange", "change", null, c, d), a.push({
        event: c,
        listeners: b
    }));
}
var $0b2e6adb871a3b94$var$pe = null, $0b2e6adb871a3b94$var$qe = null;
function $0b2e6adb871a3b94$var$re(a) {
    $0b2e6adb871a3b94$var$se(a, 0);
}
function $0b2e6adb871a3b94$var$te(a) {
    var b = $0b2e6adb871a3b94$var$ue(a);
    if ($0b2e6adb871a3b94$var$Wa(b)) return a;
}
function $0b2e6adb871a3b94$var$ve(a, b) {
    if ("change" === a) return b;
}
var $0b2e6adb871a3b94$var$we = !1;
if ($0b2e6adb871a3b94$var$ia) {
    var $0b2e6adb871a3b94$var$xe;
    if ($0b2e6adb871a3b94$var$ia) {
        var $0b2e6adb871a3b94$var$ye = "oninput" in document;
        if (!$0b2e6adb871a3b94$var$ye) {
            var $0b2e6adb871a3b94$var$ze = document.createElement("div");
            $0b2e6adb871a3b94$var$ze.setAttribute("oninput", "return;");
            $0b2e6adb871a3b94$var$ye = "function" === typeof $0b2e6adb871a3b94$var$ze.oninput;
        }
        $0b2e6adb871a3b94$var$xe = $0b2e6adb871a3b94$var$ye;
    } else $0b2e6adb871a3b94$var$xe = !1;
    $0b2e6adb871a3b94$var$we = $0b2e6adb871a3b94$var$xe && (!document.documentMode || 9 < document.documentMode);
}
function $0b2e6adb871a3b94$var$Ae() {
    $0b2e6adb871a3b94$var$pe && ($0b2e6adb871a3b94$var$pe.detachEvent("onpropertychange", $0b2e6adb871a3b94$var$Be), $0b2e6adb871a3b94$var$qe = $0b2e6adb871a3b94$var$pe = null);
}
function $0b2e6adb871a3b94$var$Be(a) {
    if ("value" === a.propertyName && $0b2e6adb871a3b94$var$te($0b2e6adb871a3b94$var$qe)) {
        var b = [];
        $0b2e6adb871a3b94$var$ne(b, $0b2e6adb871a3b94$var$qe, a, $0b2e6adb871a3b94$var$xb(a));
        $0b2e6adb871a3b94$var$Jb($0b2e6adb871a3b94$var$re, b);
    }
}
function $0b2e6adb871a3b94$var$Ce(a, b, c) {
    "focusin" === a ? ($0b2e6adb871a3b94$var$Ae(), $0b2e6adb871a3b94$var$pe = b, $0b2e6adb871a3b94$var$qe = c, $0b2e6adb871a3b94$var$pe.attachEvent("onpropertychange", $0b2e6adb871a3b94$var$Be)) : "focusout" === a && $0b2e6adb871a3b94$var$Ae();
}
function $0b2e6adb871a3b94$var$De(a) {
    if ("selectionchange" === a || "keyup" === a || "keydown" === a) return $0b2e6adb871a3b94$var$te($0b2e6adb871a3b94$var$qe);
}
function $0b2e6adb871a3b94$var$Ee(a, b) {
    if ("click" === a) return $0b2e6adb871a3b94$var$te(b);
}
function $0b2e6adb871a3b94$var$Fe(a, b) {
    if ("input" === a || "change" === a) return $0b2e6adb871a3b94$var$te(b);
}
function $0b2e6adb871a3b94$var$Ge(a, b) {
    return a === b && (0 !== a || 1 / a === 1 / b) || a !== a && b !== b;
}
var $0b2e6adb871a3b94$var$He = "function" === typeof Object.is ? Object.is : $0b2e6adb871a3b94$var$Ge;
function $0b2e6adb871a3b94$var$Ie(a, b) {
    if ($0b2e6adb871a3b94$var$He(a, b)) return !0;
    if ("object" !== typeof a || null === a || "object" !== typeof b || null === b) return !1;
    var c = Object.keys(a), d = Object.keys(b);
    if (c.length !== d.length) return !1;
    for(d = 0; d < c.length; d++){
        var e = c[d];
        if (!$0b2e6adb871a3b94$var$ja.call(b, e) || !$0b2e6adb871a3b94$var$He(a[e], b[e])) return !1;
    }
    return !0;
}
function $0b2e6adb871a3b94$var$Je(a) {
    for(; a && a.firstChild;)a = a.firstChild;
    return a;
}
function $0b2e6adb871a3b94$var$Ke(a, b) {
    var c = $0b2e6adb871a3b94$var$Je(a);
    a = 0;
    for(var d; c;){
        if (3 === c.nodeType) {
            d = a + c.textContent.length;
            if (a <= b && d >= b) return {
                node: c,
                offset: b - a
            };
            a = d;
        }
        a: {
            for(; c;){
                if (c.nextSibling) {
                    c = c.nextSibling;
                    break a;
                }
                c = c.parentNode;
            }
            c = void 0;
        }
        c = $0b2e6adb871a3b94$var$Je(c);
    }
}
function $0b2e6adb871a3b94$var$Le(a, b) {
    return a && b ? a === b ? !0 : a && 3 === a.nodeType ? !1 : b && 3 === b.nodeType ? $0b2e6adb871a3b94$var$Le(a, b.parentNode) : "contains" in a ? a.contains(b) : a.compareDocumentPosition ? !!(a.compareDocumentPosition(b) & 16) : !1 : !1;
}
function $0b2e6adb871a3b94$var$Me() {
    for(var a = window, b = $0b2e6adb871a3b94$var$Xa(); b instanceof a.HTMLIFrameElement;){
        try {
            var c = "string" === typeof b.contentWindow.location.href;
        } catch (d) {
            c = !1;
        }
        if (c) a = b.contentWindow;
        else break;
        b = $0b2e6adb871a3b94$var$Xa(a.document);
    }
    return b;
}
function $0b2e6adb871a3b94$var$Ne(a) {
    var b = a && a.nodeName && a.nodeName.toLowerCase();
    return b && ("input" === b && ("text" === a.type || "search" === a.type || "tel" === a.type || "url" === a.type || "password" === a.type) || "textarea" === b || "true" === a.contentEditable);
}
function $0b2e6adb871a3b94$var$Oe(a) {
    var b = $0b2e6adb871a3b94$var$Me(), c = a.focusedElem, d = a.selectionRange;
    if (b !== c && c && c.ownerDocument && $0b2e6adb871a3b94$var$Le(c.ownerDocument.documentElement, c)) {
        if (null !== d && $0b2e6adb871a3b94$var$Ne(c)) {
            if (b = d.start, a = d.end, void 0 === a && (a = b), "selectionStart" in c) c.selectionStart = b, c.selectionEnd = Math.min(a, c.value.length);
            else if (a = (b = c.ownerDocument || document) && b.defaultView || window, a.getSelection) {
                a = a.getSelection();
                var e = c.textContent.length, f = Math.min(d.start, e);
                d = void 0 === d.end ? f : Math.min(d.end, e);
                !a.extend && f > d && (e = d, d = f, f = e);
                e = $0b2e6adb871a3b94$var$Ke(c, f);
                var g = $0b2e6adb871a3b94$var$Ke(c, d);
                e && g && (1 !== a.rangeCount || a.anchorNode !== e.node || a.anchorOffset !== e.offset || a.focusNode !== g.node || a.focusOffset !== g.offset) && (b = b.createRange(), b.setStart(e.node, e.offset), a.removeAllRanges(), f > d ? (a.addRange(b), a.extend(g.node, g.offset)) : (b.setEnd(g.node, g.offset), a.addRange(b)));
            }
        }
        b = [];
        for(a = c; a = a.parentNode;)1 === a.nodeType && b.push({
            element: a,
            left: a.scrollLeft,
            top: a.scrollTop
        });
        "function" === typeof c.focus && c.focus();
        for(c = 0; c < b.length; c++)a = b[c], a.element.scrollLeft = a.left, a.element.scrollTop = a.top;
    }
}
var $0b2e6adb871a3b94$var$Pe = $0b2e6adb871a3b94$var$ia && "documentMode" in document && 11 >= document.documentMode, $0b2e6adb871a3b94$var$Qe = null, $0b2e6adb871a3b94$var$Re = null, $0b2e6adb871a3b94$var$Se = null, $0b2e6adb871a3b94$var$Te = !1;
function $0b2e6adb871a3b94$var$Ue(a, b, c) {
    var d = c.window === c ? c.document : 9 === c.nodeType ? c : c.ownerDocument;
    $0b2e6adb871a3b94$var$Te || null == $0b2e6adb871a3b94$var$Qe || $0b2e6adb871a3b94$var$Qe !== $0b2e6adb871a3b94$var$Xa(d) || (d = $0b2e6adb871a3b94$var$Qe, "selectionStart" in d && $0b2e6adb871a3b94$var$Ne(d) ? d = {
        start: d.selectionStart,
        end: d.selectionEnd
    } : (d = (d.ownerDocument && d.ownerDocument.defaultView || window).getSelection(), d = {
        anchorNode: d.anchorNode,
        anchorOffset: d.anchorOffset,
        focusNode: d.focusNode,
        focusOffset: d.focusOffset
    }), $0b2e6adb871a3b94$var$Se && $0b2e6adb871a3b94$var$Ie($0b2e6adb871a3b94$var$Se, d) || ($0b2e6adb871a3b94$var$Se = d, d = $0b2e6adb871a3b94$var$oe($0b2e6adb871a3b94$var$Re, "onSelect"), 0 < d.length && (b = new $0b2e6adb871a3b94$var$td("onSelect", "select", null, b, c), a.push({
        event: b,
        listeners: d
    }), b.target = $0b2e6adb871a3b94$var$Qe)));
}
function $0b2e6adb871a3b94$var$Ve(a, b) {
    var c = {};
    c[a.toLowerCase()] = b.toLowerCase();
    c["Webkit" + a] = "webkit" + b;
    c["Moz" + a] = "moz" + b;
    return c;
}
var $0b2e6adb871a3b94$var$We = {
    animationend: $0b2e6adb871a3b94$var$Ve("Animation", "AnimationEnd"),
    animationiteration: $0b2e6adb871a3b94$var$Ve("Animation", "AnimationIteration"),
    animationstart: $0b2e6adb871a3b94$var$Ve("Animation", "AnimationStart"),
    transitionend: $0b2e6adb871a3b94$var$Ve("Transition", "TransitionEnd")
}, $0b2e6adb871a3b94$var$Xe = {}, $0b2e6adb871a3b94$var$Ye = {};
$0b2e6adb871a3b94$var$ia && ($0b2e6adb871a3b94$var$Ye = document.createElement("div").style, "AnimationEvent" in window || (delete $0b2e6adb871a3b94$var$We.animationend.animation, delete $0b2e6adb871a3b94$var$We.animationiteration.animation, delete $0b2e6adb871a3b94$var$We.animationstart.animation), "TransitionEvent" in window || delete $0b2e6adb871a3b94$var$We.transitionend.transition);
function $0b2e6adb871a3b94$var$Ze(a) {
    if ($0b2e6adb871a3b94$var$Xe[a]) return $0b2e6adb871a3b94$var$Xe[a];
    if (!$0b2e6adb871a3b94$var$We[a]) return a;
    var b = $0b2e6adb871a3b94$var$We[a], c;
    for(c in b)if (b.hasOwnProperty(c) && c in $0b2e6adb871a3b94$var$Ye) return $0b2e6adb871a3b94$var$Xe[a] = b[c];
    return a;
}
var $0b2e6adb871a3b94$var$$e = $0b2e6adb871a3b94$var$Ze("animationend"), $0b2e6adb871a3b94$var$af = $0b2e6adb871a3b94$var$Ze("animationiteration"), $0b2e6adb871a3b94$var$bf = $0b2e6adb871a3b94$var$Ze("animationstart"), $0b2e6adb871a3b94$var$cf = $0b2e6adb871a3b94$var$Ze("transitionend"), $0b2e6adb871a3b94$var$df = new Map, $0b2e6adb871a3b94$var$ef = "abort auxClick cancel canPlay canPlayThrough click close contextMenu copy cut drag dragEnd dragEnter dragExit dragLeave dragOver dragStart drop durationChange emptied encrypted ended error gotPointerCapture input invalid keyDown keyPress keyUp load loadedData loadedMetadata loadStart lostPointerCapture mouseDown mouseMove mouseOut mouseOver mouseUp paste pause play playing pointerCancel pointerDown pointerMove pointerOut pointerOver pointerUp progress rateChange reset resize seeked seeking stalled submit suspend timeUpdate touchCancel touchEnd touchStart volumeChange scroll toggle touchMove waiting wheel".split(" ");
function $0b2e6adb871a3b94$var$ff(a, b) {
    $0b2e6adb871a3b94$var$df.set(a, b);
    $0b2e6adb871a3b94$var$fa(b, [
        a
    ]);
}
for(var $0b2e6adb871a3b94$var$gf = 0; $0b2e6adb871a3b94$var$gf < $0b2e6adb871a3b94$var$ef.length; $0b2e6adb871a3b94$var$gf++){
    var $0b2e6adb871a3b94$var$hf = $0b2e6adb871a3b94$var$ef[$0b2e6adb871a3b94$var$gf], $0b2e6adb871a3b94$var$jf = $0b2e6adb871a3b94$var$hf.toLowerCase(), $0b2e6adb871a3b94$var$kf = $0b2e6adb871a3b94$var$hf[0].toUpperCase() + $0b2e6adb871a3b94$var$hf.slice(1);
    $0b2e6adb871a3b94$var$ff($0b2e6adb871a3b94$var$jf, "on" + $0b2e6adb871a3b94$var$kf);
}
$0b2e6adb871a3b94$var$ff($0b2e6adb871a3b94$var$$e, "onAnimationEnd");
$0b2e6adb871a3b94$var$ff($0b2e6adb871a3b94$var$af, "onAnimationIteration");
$0b2e6adb871a3b94$var$ff($0b2e6adb871a3b94$var$bf, "onAnimationStart");
$0b2e6adb871a3b94$var$ff("dblclick", "onDoubleClick");
$0b2e6adb871a3b94$var$ff("focusin", "onFocus");
$0b2e6adb871a3b94$var$ff("focusout", "onBlur");
$0b2e6adb871a3b94$var$ff($0b2e6adb871a3b94$var$cf, "onTransitionEnd");
$0b2e6adb871a3b94$var$ha("onMouseEnter", [
    "mouseout",
    "mouseover"
]);
$0b2e6adb871a3b94$var$ha("onMouseLeave", [
    "mouseout",
    "mouseover"
]);
$0b2e6adb871a3b94$var$ha("onPointerEnter", [
    "pointerout",
    "pointerover"
]);
$0b2e6adb871a3b94$var$ha("onPointerLeave", [
    "pointerout",
    "pointerover"
]);
$0b2e6adb871a3b94$var$fa("onChange", "change click focusin focusout input keydown keyup selectionchange".split(" "));
$0b2e6adb871a3b94$var$fa("onSelect", "focusout contextmenu dragend focusin keydown keyup mousedown mouseup selectionchange".split(" "));
$0b2e6adb871a3b94$var$fa("onBeforeInput", [
    "compositionend",
    "keypress",
    "textInput",
    "paste"
]);
$0b2e6adb871a3b94$var$fa("onCompositionEnd", "compositionend focusout keydown keypress keyup mousedown".split(" "));
$0b2e6adb871a3b94$var$fa("onCompositionStart", "compositionstart focusout keydown keypress keyup mousedown".split(" "));
$0b2e6adb871a3b94$var$fa("onCompositionUpdate", "compositionupdate focusout keydown keypress keyup mousedown".split(" "));
var $0b2e6adb871a3b94$var$lf = "abort canplay canplaythrough durationchange emptied encrypted ended error loadeddata loadedmetadata loadstart pause play playing progress ratechange resize seeked seeking stalled suspend timeupdate volumechange waiting".split(" "), $0b2e6adb871a3b94$var$mf = new Set("cancel close invalid load scroll toggle".split(" ").concat($0b2e6adb871a3b94$var$lf));
function $0b2e6adb871a3b94$var$nf(a, b, c) {
    var d = a.type || "unknown-event";
    a.currentTarget = c;
    $0b2e6adb871a3b94$var$Ub(d, b, void 0, a);
    a.currentTarget = null;
}
function $0b2e6adb871a3b94$var$se(a, b) {
    b = 0 !== (b & 4);
    for(var c = 0; c < a.length; c++){
        var d = a[c], e = d.event;
        d = d.listeners;
        a: {
            var f = void 0;
            if (b) for(var g = d.length - 1; 0 <= g; g--){
                var h = d[g], k = h.instance, l = h.currentTarget;
                h = h.listener;
                if (k !== f && e.isPropagationStopped()) break a;
                $0b2e6adb871a3b94$var$nf(e, h, l);
                f = k;
            }
            else for(g = 0; g < d.length; g++){
                h = d[g];
                k = h.instance;
                l = h.currentTarget;
                h = h.listener;
                if (k !== f && e.isPropagationStopped()) break a;
                $0b2e6adb871a3b94$var$nf(e, h, l);
                f = k;
            }
        }
    }
    if ($0b2e6adb871a3b94$var$Qb) throw a = $0b2e6adb871a3b94$var$Rb, $0b2e6adb871a3b94$var$Qb = !1, $0b2e6adb871a3b94$var$Rb = null, a;
}
function $0b2e6adb871a3b94$var$D(a, b) {
    var c = b[$0b2e6adb871a3b94$var$of];
    void 0 === c && (c = b[$0b2e6adb871a3b94$var$of] = new Set);
    var d = a + "__bubble";
    c.has(d) || ($0b2e6adb871a3b94$var$pf(b, a, 2, !1), c.add(d));
}
function $0b2e6adb871a3b94$var$qf(a, b, c) {
    var d = 0;
    b && (d |= 4);
    $0b2e6adb871a3b94$var$pf(c, a, d, b);
}
var $0b2e6adb871a3b94$var$rf = "_reactListening" + Math.random().toString(36).slice(2);
function $0b2e6adb871a3b94$var$sf(a) {
    if (!a[$0b2e6adb871a3b94$var$rf]) {
        a[$0b2e6adb871a3b94$var$rf] = !0;
        $0b2e6adb871a3b94$var$da.forEach(function(b) {
            "selectionchange" !== b && ($0b2e6adb871a3b94$var$mf.has(b) || $0b2e6adb871a3b94$var$qf(b, !1, a), $0b2e6adb871a3b94$var$qf(b, !0, a));
        });
        var b = 9 === a.nodeType ? a : a.ownerDocument;
        null === b || b[$0b2e6adb871a3b94$var$rf] || (b[$0b2e6adb871a3b94$var$rf] = !0, $0b2e6adb871a3b94$var$qf("selectionchange", !1, b));
    }
}
function $0b2e6adb871a3b94$var$pf(a, b, c, d) {
    switch($0b2e6adb871a3b94$var$jd(b)){
        case 1:
            var e = $0b2e6adb871a3b94$var$ed;
            break;
        case 4:
            e = $0b2e6adb871a3b94$var$gd;
            break;
        default:
            e = $0b2e6adb871a3b94$var$fd;
    }
    c = e.bind(null, b, c, a);
    e = void 0;
    !$0b2e6adb871a3b94$var$Lb || "touchstart" !== b && "touchmove" !== b && "wheel" !== b || (e = !0);
    d ? void 0 !== e ? a.addEventListener(b, c, {
        capture: !0,
        passive: e
    }) : a.addEventListener(b, c, !0) : void 0 !== e ? a.addEventListener(b, c, {
        passive: e
    }) : a.addEventListener(b, c, !1);
}
function $0b2e6adb871a3b94$var$hd(a, b, c, d, e) {
    var f = d;
    if (0 === (b & 1) && 0 === (b & 2) && null !== d) a: for(;;){
        if (null === d) return;
        var g = d.tag;
        if (3 === g || 4 === g) {
            var h = d.stateNode.containerInfo;
            if (h === e || 8 === h.nodeType && h.parentNode === e) break;
            if (4 === g) for(g = d.return; null !== g;){
                var k = g.tag;
                if (3 === k || 4 === k) {
                    if (k = g.stateNode.containerInfo, k === e || 8 === k.nodeType && k.parentNode === e) return;
                }
                g = g.return;
            }
            for(; null !== h;){
                g = $0b2e6adb871a3b94$var$Wc(h);
                if (null === g) return;
                k = g.tag;
                if (5 === k || 6 === k) {
                    d = f = g;
                    continue a;
                }
                h = h.parentNode;
            }
        }
        d = d.return;
    }
    $0b2e6adb871a3b94$var$Jb(function() {
        var d = f, e = $0b2e6adb871a3b94$var$xb(c), g = [];
        a: {
            var h = $0b2e6adb871a3b94$var$df.get(a);
            if (void 0 !== h) {
                var k = $0b2e6adb871a3b94$var$td, n = a;
                switch(a){
                    case "keypress":
                        if (0 === $0b2e6adb871a3b94$var$od(c)) break a;
                    case "keydown":
                    case "keyup":
                        k = $0b2e6adb871a3b94$var$Rd;
                        break;
                    case "focusin":
                        n = "focus";
                        k = $0b2e6adb871a3b94$var$Fd;
                        break;
                    case "focusout":
                        n = "blur";
                        k = $0b2e6adb871a3b94$var$Fd;
                        break;
                    case "beforeblur":
                    case "afterblur":
                        k = $0b2e6adb871a3b94$var$Fd;
                        break;
                    case "click":
                        if (2 === c.button) break a;
                    case "auxclick":
                    case "dblclick":
                    case "mousedown":
                    case "mousemove":
                    case "mouseup":
                    case "mouseout":
                    case "mouseover":
                    case "contextmenu":
                        k = $0b2e6adb871a3b94$var$Bd;
                        break;
                    case "drag":
                    case "dragend":
                    case "dragenter":
                    case "dragexit":
                    case "dragleave":
                    case "dragover":
                    case "dragstart":
                    case "drop":
                        k = $0b2e6adb871a3b94$var$Dd;
                        break;
                    case "touchcancel":
                    case "touchend":
                    case "touchmove":
                    case "touchstart":
                        k = $0b2e6adb871a3b94$var$Vd;
                        break;
                    case $0b2e6adb871a3b94$var$$e:
                    case $0b2e6adb871a3b94$var$af:
                    case $0b2e6adb871a3b94$var$bf:
                        k = $0b2e6adb871a3b94$var$Hd;
                        break;
                    case $0b2e6adb871a3b94$var$cf:
                        k = $0b2e6adb871a3b94$var$Xd;
                        break;
                    case "scroll":
                        k = $0b2e6adb871a3b94$var$vd;
                        break;
                    case "wheel":
                        k = $0b2e6adb871a3b94$var$Zd;
                        break;
                    case "copy":
                    case "cut":
                    case "paste":
                        k = $0b2e6adb871a3b94$var$Jd;
                        break;
                    case "gotpointercapture":
                    case "lostpointercapture":
                    case "pointercancel":
                    case "pointerdown":
                    case "pointermove":
                    case "pointerout":
                    case "pointerover":
                    case "pointerup":
                        k = $0b2e6adb871a3b94$var$Td;
                }
                var t = 0 !== (b & 4), J = !t && "scroll" === a, x = t ? null !== h ? h + "Capture" : null : h;
                t = [];
                for(var w = d, u; null !== w;){
                    u = w;
                    var F = u.stateNode;
                    5 === u.tag && null !== F && (u = F, null !== x && (F = $0b2e6adb871a3b94$var$Kb(w, x), null != F && t.push($0b2e6adb871a3b94$var$tf(w, F, u))));
                    if (J) break;
                    w = w.return;
                }
                0 < t.length && (h = new k(h, n, null, c, e), g.push({
                    event: h,
                    listeners: t
                }));
            }
        }
        if (0 === (b & 7)) {
            a: {
                h = "mouseover" === a || "pointerover" === a;
                k = "mouseout" === a || "pointerout" === a;
                if (h && c !== $0b2e6adb871a3b94$var$wb && (n = c.relatedTarget || c.fromElement) && ($0b2e6adb871a3b94$var$Wc(n) || n[$0b2e6adb871a3b94$var$uf])) break a;
                if (k || h) {
                    h = e.window === e ? e : (h = e.ownerDocument) ? h.defaultView || h.parentWindow : window;
                    if (k) {
                        if (n = c.relatedTarget || c.toElement, k = d, n = n ? $0b2e6adb871a3b94$var$Wc(n) : null, null !== n && (J = $0b2e6adb871a3b94$var$Vb(n), n !== J || 5 !== n.tag && 6 !== n.tag)) n = null;
                    } else k = null, n = d;
                    if (k !== n) {
                        t = $0b2e6adb871a3b94$var$Bd;
                        F = "onMouseLeave";
                        x = "onMouseEnter";
                        w = "mouse";
                        if ("pointerout" === a || "pointerover" === a) t = $0b2e6adb871a3b94$var$Td, F = "onPointerLeave", x = "onPointerEnter", w = "pointer";
                        J = null == k ? h : $0b2e6adb871a3b94$var$ue(k);
                        u = null == n ? h : $0b2e6adb871a3b94$var$ue(n);
                        h = new t(F, w + "leave", k, c, e);
                        h.target = J;
                        h.relatedTarget = u;
                        F = null;
                        $0b2e6adb871a3b94$var$Wc(e) === d && (t = new t(x, w + "enter", n, c, e), t.target = u, t.relatedTarget = J, F = t);
                        J = F;
                        if (k && n) b: {
                            t = k;
                            x = n;
                            w = 0;
                            for(u = t; u; u = $0b2e6adb871a3b94$var$vf(u))w++;
                            u = 0;
                            for(F = x; F; F = $0b2e6adb871a3b94$var$vf(F))u++;
                            for(; 0 < w - u;)t = $0b2e6adb871a3b94$var$vf(t), w--;
                            for(; 0 < u - w;)x = $0b2e6adb871a3b94$var$vf(x), u--;
                            for(; w--;){
                                if (t === x || null !== x && t === x.alternate) break b;
                                t = $0b2e6adb871a3b94$var$vf(t);
                                x = $0b2e6adb871a3b94$var$vf(x);
                            }
                            t = null;
                        }
                        else t = null;
                        null !== k && $0b2e6adb871a3b94$var$wf(g, h, k, t, !1);
                        null !== n && null !== J && $0b2e6adb871a3b94$var$wf(g, J, n, t, !0);
                    }
                }
            }
            a: {
                h = d ? $0b2e6adb871a3b94$var$ue(d) : window;
                k = h.nodeName && h.nodeName.toLowerCase();
                if ("select" === k || "input" === k && "file" === h.type) var na = $0b2e6adb871a3b94$var$ve;
                else if ($0b2e6adb871a3b94$var$me(h)) {
                    if ($0b2e6adb871a3b94$var$we) na = $0b2e6adb871a3b94$var$Fe;
                    else {
                        na = $0b2e6adb871a3b94$var$De;
                        var xa = $0b2e6adb871a3b94$var$Ce;
                    }
                } else (k = h.nodeName) && "input" === k.toLowerCase() && ("checkbox" === h.type || "radio" === h.type) && (na = $0b2e6adb871a3b94$var$Ee);
                if (na && (na = na(a, d))) {
                    $0b2e6adb871a3b94$var$ne(g, na, c, e);
                    break a;
                }
                xa && xa(a, h, d);
                "focusout" === a && (xa = h._wrapperState) && xa.controlled && "number" === h.type && $0b2e6adb871a3b94$var$cb(h, "number", h.value);
            }
            xa = d ? $0b2e6adb871a3b94$var$ue(d) : window;
            switch(a){
                case "focusin":
                    if ($0b2e6adb871a3b94$var$me(xa) || "true" === xa.contentEditable) $0b2e6adb871a3b94$var$Qe = xa, $0b2e6adb871a3b94$var$Re = d, $0b2e6adb871a3b94$var$Se = null;
                    break;
                case "focusout":
                    $0b2e6adb871a3b94$var$Se = $0b2e6adb871a3b94$var$Re = $0b2e6adb871a3b94$var$Qe = null;
                    break;
                case "mousedown":
                    $0b2e6adb871a3b94$var$Te = !0;
                    break;
                case "contextmenu":
                case "mouseup":
                case "dragend":
                    $0b2e6adb871a3b94$var$Te = !1;
                    $0b2e6adb871a3b94$var$Ue(g, c, e);
                    break;
                case "selectionchange":
                    if ($0b2e6adb871a3b94$var$Pe) break;
                case "keydown":
                case "keyup":
                    $0b2e6adb871a3b94$var$Ue(g, c, e);
            }
            var $a;
            if ($0b2e6adb871a3b94$var$ae) b: {
                switch(a){
                    case "compositionstart":
                        var ba = "onCompositionStart";
                        break b;
                    case "compositionend":
                        ba = "onCompositionEnd";
                        break b;
                    case "compositionupdate":
                        ba = "onCompositionUpdate";
                        break b;
                }
                ba = void 0;
            }
            else $0b2e6adb871a3b94$var$ie ? $0b2e6adb871a3b94$var$ge(a, c) && (ba = "onCompositionEnd") : "keydown" === a && 229 === c.keyCode && (ba = "onCompositionStart");
            ba && ($0b2e6adb871a3b94$var$de && "ko" !== c.locale && ($0b2e6adb871a3b94$var$ie || "onCompositionStart" !== ba ? "onCompositionEnd" === ba && $0b2e6adb871a3b94$var$ie && ($a = $0b2e6adb871a3b94$var$nd()) : ($0b2e6adb871a3b94$var$kd = e, $0b2e6adb871a3b94$var$ld = "value" in $0b2e6adb871a3b94$var$kd ? $0b2e6adb871a3b94$var$kd.value : $0b2e6adb871a3b94$var$kd.textContent, $0b2e6adb871a3b94$var$ie = !0)), xa = $0b2e6adb871a3b94$var$oe(d, ba), 0 < xa.length && (ba = new $0b2e6adb871a3b94$var$Ld(ba, a, null, c, e), g.push({
                event: ba,
                listeners: xa
            }), $a ? ba.data = $a : ($a = $0b2e6adb871a3b94$var$he(c), null !== $a && (ba.data = $a))));
            if ($a = $0b2e6adb871a3b94$var$ce ? $0b2e6adb871a3b94$var$je(a, c) : $0b2e6adb871a3b94$var$ke(a, c)) d = $0b2e6adb871a3b94$var$oe(d, "onBeforeInput"), 0 < d.length && (e = new $0b2e6adb871a3b94$var$Ld("onBeforeInput", "beforeinput", null, c, e), g.push({
                event: e,
                listeners: d
            }), e.data = $a);
        }
        $0b2e6adb871a3b94$var$se(g, b);
    });
}
function $0b2e6adb871a3b94$var$tf(a, b, c) {
    return {
        instance: a,
        listener: b,
        currentTarget: c
    };
}
function $0b2e6adb871a3b94$var$oe(a, b) {
    for(var c = b + "Capture", d = []; null !== a;){
        var e = a, f = e.stateNode;
        5 === e.tag && null !== f && (e = f, f = $0b2e6adb871a3b94$var$Kb(a, c), null != f && d.unshift($0b2e6adb871a3b94$var$tf(a, f, e)), f = $0b2e6adb871a3b94$var$Kb(a, b), null != f && d.push($0b2e6adb871a3b94$var$tf(a, f, e)));
        a = a.return;
    }
    return d;
}
function $0b2e6adb871a3b94$var$vf(a) {
    if (null === a) return null;
    do a = a.return;
    while (a && 5 !== a.tag);
    return a ? a : null;
}
function $0b2e6adb871a3b94$var$wf(a, b, c, d, e) {
    for(var f = b._reactName, g = []; null !== c && c !== d;){
        var h = c, k = h.alternate, l = h.stateNode;
        if (null !== k && k === d) break;
        5 === h.tag && null !== l && (h = l, e ? (k = $0b2e6adb871a3b94$var$Kb(c, f), null != k && g.unshift($0b2e6adb871a3b94$var$tf(c, k, h))) : e || (k = $0b2e6adb871a3b94$var$Kb(c, f), null != k && g.push($0b2e6adb871a3b94$var$tf(c, k, h))));
        c = c.return;
    }
    0 !== g.length && a.push({
        event: b,
        listeners: g
    });
}
var $0b2e6adb871a3b94$var$xf = /\r\n?/g, $0b2e6adb871a3b94$var$yf = /\u0000|\uFFFD/g;
function $0b2e6adb871a3b94$var$zf(a) {
    return ("string" === typeof a ? a : "" + a).replace($0b2e6adb871a3b94$var$xf, "\n").replace($0b2e6adb871a3b94$var$yf, "");
}
function $0b2e6adb871a3b94$var$Af(a, b, c) {
    b = $0b2e6adb871a3b94$var$zf(b);
    if ($0b2e6adb871a3b94$var$zf(a) !== b && c) throw Error($0b2e6adb871a3b94$var$p(425));
}
function $0b2e6adb871a3b94$var$Bf() {}
var $0b2e6adb871a3b94$var$Cf = null, $0b2e6adb871a3b94$var$Df = null;
function $0b2e6adb871a3b94$var$Ef(a, b) {
    return "textarea" === a || "noscript" === a || "string" === typeof b.children || "number" === typeof b.children || "object" === typeof b.dangerouslySetInnerHTML && null !== b.dangerouslySetInnerHTML && null != b.dangerouslySetInnerHTML.__html;
}
var $0b2e6adb871a3b94$var$Ff = "function" === typeof setTimeout ? setTimeout : void 0, $0b2e6adb871a3b94$var$Gf = "function" === typeof clearTimeout ? clearTimeout : void 0, $0b2e6adb871a3b94$var$Hf = "function" === typeof Promise ? Promise : void 0, $0b2e6adb871a3b94$var$Jf = "function" === typeof queueMicrotask ? queueMicrotask : "undefined" !== typeof $0b2e6adb871a3b94$var$Hf ? function(a) {
    return $0b2e6adb871a3b94$var$Hf.resolve(null).then(a).catch($0b2e6adb871a3b94$var$If);
} : $0b2e6adb871a3b94$var$Ff;
function $0b2e6adb871a3b94$var$If(a) {
    setTimeout(function() {
        throw a;
    });
}
function $0b2e6adb871a3b94$var$Kf(a, b) {
    var c = b, d = 0;
    do {
        var e = c.nextSibling;
        a.removeChild(c);
        if (e && 8 === e.nodeType) {
            if (c = e.data, "/$" === c) {
                if (0 === d) {
                    a.removeChild(e);
                    $0b2e6adb871a3b94$var$bd(b);
                    return;
                }
                d--;
            } else "$" !== c && "$?" !== c && "$!" !== c || d++;
        }
        c = e;
    }while (c);
    $0b2e6adb871a3b94$var$bd(b);
}
function $0b2e6adb871a3b94$var$Lf(a) {
    for(; null != a; a = a.nextSibling){
        var b = a.nodeType;
        if (1 === b || 3 === b) break;
        if (8 === b) {
            b = a.data;
            if ("$" === b || "$!" === b || "$?" === b) break;
            if ("/$" === b) return null;
        }
    }
    return a;
}
function $0b2e6adb871a3b94$var$Mf(a) {
    a = a.previousSibling;
    for(var b = 0; a;){
        if (8 === a.nodeType) {
            var c = a.data;
            if ("$" === c || "$!" === c || "$?" === c) {
                if (0 === b) return a;
                b--;
            } else "/$" === c && b++;
        }
        a = a.previousSibling;
    }
    return null;
}
var $0b2e6adb871a3b94$var$Nf = Math.random().toString(36).slice(2), $0b2e6adb871a3b94$var$Of = "__reactFiber$" + $0b2e6adb871a3b94$var$Nf, $0b2e6adb871a3b94$var$Pf = "__reactProps$" + $0b2e6adb871a3b94$var$Nf, $0b2e6adb871a3b94$var$uf = "__reactContainer$" + $0b2e6adb871a3b94$var$Nf, $0b2e6adb871a3b94$var$of = "__reactEvents$" + $0b2e6adb871a3b94$var$Nf, $0b2e6adb871a3b94$var$Qf = "__reactListeners$" + $0b2e6adb871a3b94$var$Nf, $0b2e6adb871a3b94$var$Rf = "__reactHandles$" + $0b2e6adb871a3b94$var$Nf;
function $0b2e6adb871a3b94$var$Wc(a) {
    var b = a[$0b2e6adb871a3b94$var$Of];
    if (b) return b;
    for(var c = a.parentNode; c;){
        if (b = c[$0b2e6adb871a3b94$var$uf] || c[$0b2e6adb871a3b94$var$Of]) {
            c = b.alternate;
            if (null !== b.child || null !== c && null !== c.child) for(a = $0b2e6adb871a3b94$var$Mf(a); null !== a;){
                if (c = a[$0b2e6adb871a3b94$var$Of]) return c;
                a = $0b2e6adb871a3b94$var$Mf(a);
            }
            return b;
        }
        a = c;
        c = a.parentNode;
    }
    return null;
}
function $0b2e6adb871a3b94$var$Cb(a) {
    a = a[$0b2e6adb871a3b94$var$Of] || a[$0b2e6adb871a3b94$var$uf];
    return !a || 5 !== a.tag && 6 !== a.tag && 13 !== a.tag && 3 !== a.tag ? null : a;
}
function $0b2e6adb871a3b94$var$ue(a) {
    if (5 === a.tag || 6 === a.tag) return a.stateNode;
    throw Error($0b2e6adb871a3b94$var$p(33));
}
function $0b2e6adb871a3b94$var$Db(a) {
    return a[$0b2e6adb871a3b94$var$Pf] || null;
}
var $0b2e6adb871a3b94$var$Sf = [], $0b2e6adb871a3b94$var$Tf = -1;
function $0b2e6adb871a3b94$var$Uf(a) {
    return {
        current: a
    };
}
function $0b2e6adb871a3b94$var$E(a) {
    0 > $0b2e6adb871a3b94$var$Tf || (a.current = $0b2e6adb871a3b94$var$Sf[$0b2e6adb871a3b94$var$Tf], $0b2e6adb871a3b94$var$Sf[$0b2e6adb871a3b94$var$Tf] = null, $0b2e6adb871a3b94$var$Tf--);
}
function $0b2e6adb871a3b94$var$G(a, b) {
    $0b2e6adb871a3b94$var$Tf++;
    $0b2e6adb871a3b94$var$Sf[$0b2e6adb871a3b94$var$Tf] = a.current;
    a.current = b;
}
var $0b2e6adb871a3b94$var$Vf = {}, $0b2e6adb871a3b94$var$H = $0b2e6adb871a3b94$var$Uf($0b2e6adb871a3b94$var$Vf), $0b2e6adb871a3b94$var$Wf = $0b2e6adb871a3b94$var$Uf(!1), $0b2e6adb871a3b94$var$Xf = $0b2e6adb871a3b94$var$Vf;
function $0b2e6adb871a3b94$var$Yf(a, b) {
    var c = a.type.contextTypes;
    if (!c) return $0b2e6adb871a3b94$var$Vf;
    var d = a.stateNode;
    if (d && d.__reactInternalMemoizedUnmaskedChildContext === b) return d.__reactInternalMemoizedMaskedChildContext;
    var e = {}, f;
    for(f in c)e[f] = b[f];
    d && (a = a.stateNode, a.__reactInternalMemoizedUnmaskedChildContext = b, a.__reactInternalMemoizedMaskedChildContext = e);
    return e;
}
function $0b2e6adb871a3b94$var$Zf(a) {
    a = a.childContextTypes;
    return null !== a && void 0 !== a;
}
function $0b2e6adb871a3b94$var$$f() {
    $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$Wf);
    $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$H);
}
function $0b2e6adb871a3b94$var$ag(a, b, c) {
    if ($0b2e6adb871a3b94$var$H.current !== $0b2e6adb871a3b94$var$Vf) throw Error($0b2e6adb871a3b94$var$p(168));
    $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$H, b);
    $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$Wf, c);
}
function $0b2e6adb871a3b94$var$bg(a, b, c) {
    var d = a.stateNode;
    b = b.childContextTypes;
    if ("function" !== typeof d.getChildContext) return c;
    d = d.getChildContext();
    for(var e in d)if (!(e in b)) throw Error($0b2e6adb871a3b94$var$p(108, $0b2e6adb871a3b94$var$Ra(a) || "Unknown", e));
    return $0b2e6adb871a3b94$var$A({}, c, d);
}
function $0b2e6adb871a3b94$var$cg(a) {
    a = (a = a.stateNode) && a.__reactInternalMemoizedMergedChildContext || $0b2e6adb871a3b94$var$Vf;
    $0b2e6adb871a3b94$var$Xf = $0b2e6adb871a3b94$var$H.current;
    $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$H, a);
    $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$Wf, $0b2e6adb871a3b94$var$Wf.current);
    return !0;
}
function $0b2e6adb871a3b94$var$dg(a, b, c) {
    var d = a.stateNode;
    if (!d) throw Error($0b2e6adb871a3b94$var$p(169));
    c ? (a = $0b2e6adb871a3b94$var$bg(a, b, $0b2e6adb871a3b94$var$Xf), d.__reactInternalMemoizedMergedChildContext = a, $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$Wf), $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$H), $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$H, a)) : $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$Wf);
    $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$Wf, c);
}
var $0b2e6adb871a3b94$var$eg = null, $0b2e6adb871a3b94$var$fg = !1, $0b2e6adb871a3b94$var$gg = !1;
function $0b2e6adb871a3b94$var$hg(a) {
    null === $0b2e6adb871a3b94$var$eg ? $0b2e6adb871a3b94$var$eg = [
        a
    ] : $0b2e6adb871a3b94$var$eg.push(a);
}
function $0b2e6adb871a3b94$var$ig(a) {
    $0b2e6adb871a3b94$var$fg = !0;
    $0b2e6adb871a3b94$var$hg(a);
}
function $0b2e6adb871a3b94$var$jg() {
    if (!$0b2e6adb871a3b94$var$gg && null !== $0b2e6adb871a3b94$var$eg) {
        $0b2e6adb871a3b94$var$gg = !0;
        var a = 0, b = $0b2e6adb871a3b94$var$C;
        try {
            var c = $0b2e6adb871a3b94$var$eg;
            for($0b2e6adb871a3b94$var$C = 1; a < c.length; a++){
                var d = c[a];
                do d = d(!0);
                while (null !== d);
            }
            $0b2e6adb871a3b94$var$eg = null;
            $0b2e6adb871a3b94$var$fg = !1;
        } catch (e) {
            throw null !== $0b2e6adb871a3b94$var$eg && ($0b2e6adb871a3b94$var$eg = $0b2e6adb871a3b94$var$eg.slice(a + 1)), $0b2e6adb871a3b94$var$ac($0b2e6adb871a3b94$var$fc, $0b2e6adb871a3b94$var$jg), e;
        } finally{
            $0b2e6adb871a3b94$var$C = b, $0b2e6adb871a3b94$var$gg = !1;
        }
    }
    return null;
}
var $0b2e6adb871a3b94$var$kg = [], $0b2e6adb871a3b94$var$lg = 0, $0b2e6adb871a3b94$var$mg = null, $0b2e6adb871a3b94$var$ng = 0, $0b2e6adb871a3b94$var$og = [], $0b2e6adb871a3b94$var$pg = 0, $0b2e6adb871a3b94$var$qg = null, $0b2e6adb871a3b94$var$rg = 1, $0b2e6adb871a3b94$var$sg = "";
function $0b2e6adb871a3b94$var$tg(a, b) {
    $0b2e6adb871a3b94$var$kg[$0b2e6adb871a3b94$var$lg++] = $0b2e6adb871a3b94$var$ng;
    $0b2e6adb871a3b94$var$kg[$0b2e6adb871a3b94$var$lg++] = $0b2e6adb871a3b94$var$mg;
    $0b2e6adb871a3b94$var$mg = a;
    $0b2e6adb871a3b94$var$ng = b;
}
function $0b2e6adb871a3b94$var$ug(a, b, c) {
    $0b2e6adb871a3b94$var$og[$0b2e6adb871a3b94$var$pg++] = $0b2e6adb871a3b94$var$rg;
    $0b2e6adb871a3b94$var$og[$0b2e6adb871a3b94$var$pg++] = $0b2e6adb871a3b94$var$sg;
    $0b2e6adb871a3b94$var$og[$0b2e6adb871a3b94$var$pg++] = $0b2e6adb871a3b94$var$qg;
    $0b2e6adb871a3b94$var$qg = a;
    var d = $0b2e6adb871a3b94$var$rg;
    a = $0b2e6adb871a3b94$var$sg;
    var e = 32 - $0b2e6adb871a3b94$var$oc(d) - 1;
    d &= ~(1 << e);
    c += 1;
    var f = 32 - $0b2e6adb871a3b94$var$oc(b) + e;
    if (30 < f) {
        var g = e - e % 5;
        f = (d & (1 << g) - 1).toString(32);
        d >>= g;
        e -= g;
        $0b2e6adb871a3b94$var$rg = 1 << 32 - $0b2e6adb871a3b94$var$oc(b) + e | c << e | d;
        $0b2e6adb871a3b94$var$sg = f + a;
    } else $0b2e6adb871a3b94$var$rg = 1 << f | c << e | d, $0b2e6adb871a3b94$var$sg = a;
}
function $0b2e6adb871a3b94$var$vg(a) {
    null !== a.return && ($0b2e6adb871a3b94$var$tg(a, 1), $0b2e6adb871a3b94$var$ug(a, 1, 0));
}
function $0b2e6adb871a3b94$var$wg(a) {
    for(; a === $0b2e6adb871a3b94$var$mg;)$0b2e6adb871a3b94$var$mg = $0b2e6adb871a3b94$var$kg[--$0b2e6adb871a3b94$var$lg], $0b2e6adb871a3b94$var$kg[$0b2e6adb871a3b94$var$lg] = null, $0b2e6adb871a3b94$var$ng = $0b2e6adb871a3b94$var$kg[--$0b2e6adb871a3b94$var$lg], $0b2e6adb871a3b94$var$kg[$0b2e6adb871a3b94$var$lg] = null;
    for(; a === $0b2e6adb871a3b94$var$qg;)$0b2e6adb871a3b94$var$qg = $0b2e6adb871a3b94$var$og[--$0b2e6adb871a3b94$var$pg], $0b2e6adb871a3b94$var$og[$0b2e6adb871a3b94$var$pg] = null, $0b2e6adb871a3b94$var$sg = $0b2e6adb871a3b94$var$og[--$0b2e6adb871a3b94$var$pg], $0b2e6adb871a3b94$var$og[$0b2e6adb871a3b94$var$pg] = null, $0b2e6adb871a3b94$var$rg = $0b2e6adb871a3b94$var$og[--$0b2e6adb871a3b94$var$pg], $0b2e6adb871a3b94$var$og[$0b2e6adb871a3b94$var$pg] = null;
}
var $0b2e6adb871a3b94$var$xg = null, $0b2e6adb871a3b94$var$yg = null, $0b2e6adb871a3b94$var$I = !1, $0b2e6adb871a3b94$var$zg = null;
function $0b2e6adb871a3b94$var$Ag(a, b) {
    var c = $0b2e6adb871a3b94$var$Bg(5, null, null, 0);
    c.elementType = "DELETED";
    c.stateNode = b;
    c.return = a;
    b = a.deletions;
    null === b ? (a.deletions = [
        c
    ], a.flags |= 16) : b.push(c);
}
function $0b2e6adb871a3b94$var$Cg(a, b) {
    switch(a.tag){
        case 5:
            var c = a.type;
            b = 1 !== b.nodeType || c.toLowerCase() !== b.nodeName.toLowerCase() ? null : b;
            return null !== b ? (a.stateNode = b, $0b2e6adb871a3b94$var$xg = a, $0b2e6adb871a3b94$var$yg = $0b2e6adb871a3b94$var$Lf(b.firstChild), !0) : !1;
        case 6:
            return b = "" === a.pendingProps || 3 !== b.nodeType ? null : b, null !== b ? (a.stateNode = b, $0b2e6adb871a3b94$var$xg = a, $0b2e6adb871a3b94$var$yg = null, !0) : !1;
        case 13:
            return b = 8 !== b.nodeType ? null : b, null !== b ? (c = null !== $0b2e6adb871a3b94$var$qg ? {
                id: $0b2e6adb871a3b94$var$rg,
                overflow: $0b2e6adb871a3b94$var$sg
            } : null, a.memoizedState = {
                dehydrated: b,
                treeContext: c,
                retryLane: 1073741824
            }, c = $0b2e6adb871a3b94$var$Bg(18, null, null, 0), c.stateNode = b, c.return = a, a.child = c, $0b2e6adb871a3b94$var$xg = a, $0b2e6adb871a3b94$var$yg = null, !0) : !1;
        default:
            return !1;
    }
}
function $0b2e6adb871a3b94$var$Dg(a) {
    return 0 !== (a.mode & 1) && 0 === (a.flags & 128);
}
function $0b2e6adb871a3b94$var$Eg(a) {
    if ($0b2e6adb871a3b94$var$I) {
        var b = $0b2e6adb871a3b94$var$yg;
        if (b) {
            var c = b;
            if (!$0b2e6adb871a3b94$var$Cg(a, b)) {
                if ($0b2e6adb871a3b94$var$Dg(a)) throw Error($0b2e6adb871a3b94$var$p(418));
                b = $0b2e6adb871a3b94$var$Lf(c.nextSibling);
                var d = $0b2e6adb871a3b94$var$xg;
                b && $0b2e6adb871a3b94$var$Cg(a, b) ? $0b2e6adb871a3b94$var$Ag(d, c) : (a.flags = a.flags & -4097 | 2, $0b2e6adb871a3b94$var$I = !1, $0b2e6adb871a3b94$var$xg = a);
            }
        } else {
            if ($0b2e6adb871a3b94$var$Dg(a)) throw Error($0b2e6adb871a3b94$var$p(418));
            a.flags = a.flags & -4097 | 2;
            $0b2e6adb871a3b94$var$I = !1;
            $0b2e6adb871a3b94$var$xg = a;
        }
    }
}
function $0b2e6adb871a3b94$var$Fg(a) {
    for(a = a.return; null !== a && 5 !== a.tag && 3 !== a.tag && 13 !== a.tag;)a = a.return;
    $0b2e6adb871a3b94$var$xg = a;
}
function $0b2e6adb871a3b94$var$Gg(a) {
    if (a !== $0b2e6adb871a3b94$var$xg) return !1;
    if (!$0b2e6adb871a3b94$var$I) return $0b2e6adb871a3b94$var$Fg(a), $0b2e6adb871a3b94$var$I = !0, !1;
    var b;
    (b = 3 !== a.tag) && !(b = 5 !== a.tag) && (b = a.type, b = "head" !== b && "body" !== b && !$0b2e6adb871a3b94$var$Ef(a.type, a.memoizedProps));
    if (b && (b = $0b2e6adb871a3b94$var$yg)) {
        if ($0b2e6adb871a3b94$var$Dg(a)) throw $0b2e6adb871a3b94$var$Hg(), Error($0b2e6adb871a3b94$var$p(418));
        for(; b;)$0b2e6adb871a3b94$var$Ag(a, b), b = $0b2e6adb871a3b94$var$Lf(b.nextSibling);
    }
    $0b2e6adb871a3b94$var$Fg(a);
    if (13 === a.tag) {
        a = a.memoizedState;
        a = null !== a ? a.dehydrated : null;
        if (!a) throw Error($0b2e6adb871a3b94$var$p(317));
        a: {
            a = a.nextSibling;
            for(b = 0; a;){
                if (8 === a.nodeType) {
                    var c = a.data;
                    if ("/$" === c) {
                        if (0 === b) {
                            $0b2e6adb871a3b94$var$yg = $0b2e6adb871a3b94$var$Lf(a.nextSibling);
                            break a;
                        }
                        b--;
                    } else "$" !== c && "$!" !== c && "$?" !== c || b++;
                }
                a = a.nextSibling;
            }
            $0b2e6adb871a3b94$var$yg = null;
        }
    } else $0b2e6adb871a3b94$var$yg = $0b2e6adb871a3b94$var$xg ? $0b2e6adb871a3b94$var$Lf(a.stateNode.nextSibling) : null;
    return !0;
}
function $0b2e6adb871a3b94$var$Hg() {
    for(var a = $0b2e6adb871a3b94$var$yg; a;)a = $0b2e6adb871a3b94$var$Lf(a.nextSibling);
}
function $0b2e6adb871a3b94$var$Ig() {
    $0b2e6adb871a3b94$var$yg = $0b2e6adb871a3b94$var$xg = null;
    $0b2e6adb871a3b94$var$I = !1;
}
function $0b2e6adb871a3b94$var$Jg(a) {
    null === $0b2e6adb871a3b94$var$zg ? $0b2e6adb871a3b94$var$zg = [
        a
    ] : $0b2e6adb871a3b94$var$zg.push(a);
}
var $0b2e6adb871a3b94$var$Kg = $0b2e6adb871a3b94$var$ua.ReactCurrentBatchConfig;
function $0b2e6adb871a3b94$var$Lg(a, b) {
    if (a && a.defaultProps) {
        b = $0b2e6adb871a3b94$var$A({}, b);
        a = a.defaultProps;
        for(var c in a)void 0 === b[c] && (b[c] = a[c]);
        return b;
    }
    return b;
}
var $0b2e6adb871a3b94$var$Mg = $0b2e6adb871a3b94$var$Uf(null), $0b2e6adb871a3b94$var$Ng = null, $0b2e6adb871a3b94$var$Og = null, $0b2e6adb871a3b94$var$Pg = null;
function $0b2e6adb871a3b94$var$Qg() {
    $0b2e6adb871a3b94$var$Pg = $0b2e6adb871a3b94$var$Og = $0b2e6adb871a3b94$var$Ng = null;
}
function $0b2e6adb871a3b94$var$Rg(a) {
    var b = $0b2e6adb871a3b94$var$Mg.current;
    $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$Mg);
    a._currentValue = b;
}
function $0b2e6adb871a3b94$var$Sg(a, b, c) {
    for(; null !== a;){
        var d = a.alternate;
        (a.childLanes & b) !== b ? (a.childLanes |= b, null !== d && (d.childLanes |= b)) : null !== d && (d.childLanes & b) !== b && (d.childLanes |= b);
        if (a === c) break;
        a = a.return;
    }
}
function $0b2e6adb871a3b94$var$Tg(a, b) {
    $0b2e6adb871a3b94$var$Ng = a;
    $0b2e6adb871a3b94$var$Pg = $0b2e6adb871a3b94$var$Og = null;
    a = a.dependencies;
    null !== a && null !== a.firstContext && (0 !== (a.lanes & b) && ($0b2e6adb871a3b94$var$Ug = !0), a.firstContext = null);
}
function $0b2e6adb871a3b94$var$Vg(a) {
    var b = a._currentValue;
    if ($0b2e6adb871a3b94$var$Pg !== a) {
        if (a = {
            context: a,
            memoizedValue: b,
            next: null
        }, null === $0b2e6adb871a3b94$var$Og) {
            if (null === $0b2e6adb871a3b94$var$Ng) throw Error($0b2e6adb871a3b94$var$p(308));
            $0b2e6adb871a3b94$var$Og = a;
            $0b2e6adb871a3b94$var$Ng.dependencies = {
                lanes: 0,
                firstContext: a
            };
        } else $0b2e6adb871a3b94$var$Og = $0b2e6adb871a3b94$var$Og.next = a;
    }
    return b;
}
var $0b2e6adb871a3b94$var$Wg = null;
function $0b2e6adb871a3b94$var$Xg(a) {
    null === $0b2e6adb871a3b94$var$Wg ? $0b2e6adb871a3b94$var$Wg = [
        a
    ] : $0b2e6adb871a3b94$var$Wg.push(a);
}
function $0b2e6adb871a3b94$var$Yg(a, b, c, d) {
    var e = b.interleaved;
    null === e ? (c.next = c, $0b2e6adb871a3b94$var$Xg(b)) : (c.next = e.next, e.next = c);
    b.interleaved = c;
    return $0b2e6adb871a3b94$var$Zg(a, d);
}
function $0b2e6adb871a3b94$var$Zg(a, b) {
    a.lanes |= b;
    var c = a.alternate;
    null !== c && (c.lanes |= b);
    c = a;
    for(a = a.return; null !== a;)a.childLanes |= b, c = a.alternate, null !== c && (c.childLanes |= b), c = a, a = a.return;
    return 3 === c.tag ? c.stateNode : null;
}
var $0b2e6adb871a3b94$var$$g = !1;
function $0b2e6adb871a3b94$var$ah(a) {
    a.updateQueue = {
        baseState: a.memoizedState,
        firstBaseUpdate: null,
        lastBaseUpdate: null,
        shared: {
            pending: null,
            interleaved: null,
            lanes: 0
        },
        effects: null
    };
}
function $0b2e6adb871a3b94$var$bh(a, b) {
    a = a.updateQueue;
    b.updateQueue === a && (b.updateQueue = {
        baseState: a.baseState,
        firstBaseUpdate: a.firstBaseUpdate,
        lastBaseUpdate: a.lastBaseUpdate,
        shared: a.shared,
        effects: a.effects
    });
}
function $0b2e6adb871a3b94$var$ch(a, b) {
    return {
        eventTime: a,
        lane: b,
        tag: 0,
        payload: null,
        callback: null,
        next: null
    };
}
function $0b2e6adb871a3b94$var$dh(a, b, c) {
    var d = a.updateQueue;
    if (null === d) return null;
    d = d.shared;
    if (0 !== ($0b2e6adb871a3b94$var$K & 2)) {
        var e = d.pending;
        null === e ? b.next = b : (b.next = e.next, e.next = b);
        d.pending = b;
        return $0b2e6adb871a3b94$var$Zg(a, c);
    }
    e = d.interleaved;
    null === e ? (b.next = b, $0b2e6adb871a3b94$var$Xg(d)) : (b.next = e.next, e.next = b);
    d.interleaved = b;
    return $0b2e6adb871a3b94$var$Zg(a, c);
}
function $0b2e6adb871a3b94$var$eh(a, b, c) {
    b = b.updateQueue;
    if (null !== b && (b = b.shared, 0 !== (c & 4194240))) {
        var d = b.lanes;
        d &= a.pendingLanes;
        c |= d;
        b.lanes = c;
        $0b2e6adb871a3b94$var$Cc(a, c);
    }
}
function $0b2e6adb871a3b94$var$fh(a, b) {
    var c = a.updateQueue, d = a.alternate;
    if (null !== d && (d = d.updateQueue, c === d)) {
        var e = null, f = null;
        c = c.firstBaseUpdate;
        if (null !== c) {
            do {
                var g = {
                    eventTime: c.eventTime,
                    lane: c.lane,
                    tag: c.tag,
                    payload: c.payload,
                    callback: c.callback,
                    next: null
                };
                null === f ? e = f = g : f = f.next = g;
                c = c.next;
            }while (null !== c);
            null === f ? e = f = b : f = f.next = b;
        } else e = f = b;
        c = {
            baseState: d.baseState,
            firstBaseUpdate: e,
            lastBaseUpdate: f,
            shared: d.shared,
            effects: d.effects
        };
        a.updateQueue = c;
        return;
    }
    a = c.lastBaseUpdate;
    null === a ? c.firstBaseUpdate = b : a.next = b;
    c.lastBaseUpdate = b;
}
function $0b2e6adb871a3b94$var$gh(a, b, c, d) {
    var e = a.updateQueue;
    $0b2e6adb871a3b94$var$$g = !1;
    var f = e.firstBaseUpdate, g = e.lastBaseUpdate, h = e.shared.pending;
    if (null !== h) {
        e.shared.pending = null;
        var k = h, l = k.next;
        k.next = null;
        null === g ? f = l : g.next = l;
        g = k;
        var m = a.alternate;
        null !== m && (m = m.updateQueue, h = m.lastBaseUpdate, h !== g && (null === h ? m.firstBaseUpdate = l : h.next = l, m.lastBaseUpdate = k));
    }
    if (null !== f) {
        var q = e.baseState;
        g = 0;
        m = l = k = null;
        h = f;
        do {
            var r = h.lane, y = h.eventTime;
            if ((d & r) === r) {
                null !== m && (m = m.next = {
                    eventTime: y,
                    lane: 0,
                    tag: h.tag,
                    payload: h.payload,
                    callback: h.callback,
                    next: null
                });
                a: {
                    var n = a, t = h;
                    r = b;
                    y = c;
                    switch(t.tag){
                        case 1:
                            n = t.payload;
                            if ("function" === typeof n) {
                                q = n.call(y, q, r);
                                break a;
                            }
                            q = n;
                            break a;
                        case 3:
                            n.flags = n.flags & -65537 | 128;
                        case 0:
                            n = t.payload;
                            r = "function" === typeof n ? n.call(y, q, r) : n;
                            if (null === r || void 0 === r) break a;
                            q = $0b2e6adb871a3b94$var$A({}, q, r);
                            break a;
                        case 2:
                            $0b2e6adb871a3b94$var$$g = !0;
                    }
                }
                null !== h.callback && 0 !== h.lane && (a.flags |= 64, r = e.effects, null === r ? e.effects = [
                    h
                ] : r.push(h));
            } else y = {
                eventTime: y,
                lane: r,
                tag: h.tag,
                payload: h.payload,
                callback: h.callback,
                next: null
            }, null === m ? (l = m = y, k = q) : m = m.next = y, g |= r;
            h = h.next;
            if (null === h) {
                if (h = e.shared.pending, null === h) break;
                else r = h, h = r.next, r.next = null, e.lastBaseUpdate = r, e.shared.pending = null;
            }
        }while (1);
        null === m && (k = q);
        e.baseState = k;
        e.firstBaseUpdate = l;
        e.lastBaseUpdate = m;
        b = e.shared.interleaved;
        if (null !== b) {
            e = b;
            do g |= e.lane, e = e.next;
            while (e !== b);
        } else null === f && (e.shared.lanes = 0);
        $0b2e6adb871a3b94$var$hh |= g;
        a.lanes = g;
        a.memoizedState = q;
    }
}
function $0b2e6adb871a3b94$var$ih(a, b, c) {
    a = b.effects;
    b.effects = null;
    if (null !== a) for(b = 0; b < a.length; b++){
        var d = a[b], e = d.callback;
        if (null !== e) {
            d.callback = null;
            d = c;
            if ("function" !== typeof e) throw Error($0b2e6adb871a3b94$var$p(191, e));
            e.call(d);
        }
    }
}
var $0b2e6adb871a3b94$var$jh = (new $acw62.Component).refs;
function $0b2e6adb871a3b94$var$kh(a, b, c, d) {
    b = a.memoizedState;
    c = c(d, b);
    c = null === c || void 0 === c ? b : $0b2e6adb871a3b94$var$A({}, b, c);
    a.memoizedState = c;
    0 === a.lanes && (a.updateQueue.baseState = c);
}
var $0b2e6adb871a3b94$var$nh = {
    isMounted: function(a) {
        return (a = a._reactInternals) ? $0b2e6adb871a3b94$var$Vb(a) === a : !1;
    },
    enqueueSetState: function(a, b, c) {
        a = a._reactInternals;
        var d = $0b2e6adb871a3b94$var$L(), e = $0b2e6adb871a3b94$var$lh(a), f = $0b2e6adb871a3b94$var$ch(d, e);
        f.payload = b;
        void 0 !== c && null !== c && (f.callback = c);
        b = $0b2e6adb871a3b94$var$dh(a, f, e);
        null !== b && ($0b2e6adb871a3b94$var$mh(b, a, e, d), $0b2e6adb871a3b94$var$eh(b, a, e));
    },
    enqueueReplaceState: function(a, b, c) {
        a = a._reactInternals;
        var d = $0b2e6adb871a3b94$var$L(), e = $0b2e6adb871a3b94$var$lh(a), f = $0b2e6adb871a3b94$var$ch(d, e);
        f.tag = 1;
        f.payload = b;
        void 0 !== c && null !== c && (f.callback = c);
        b = $0b2e6adb871a3b94$var$dh(a, f, e);
        null !== b && ($0b2e6adb871a3b94$var$mh(b, a, e, d), $0b2e6adb871a3b94$var$eh(b, a, e));
    },
    enqueueForceUpdate: function(a, b) {
        a = a._reactInternals;
        var c = $0b2e6adb871a3b94$var$L(), d = $0b2e6adb871a3b94$var$lh(a), e = $0b2e6adb871a3b94$var$ch(c, d);
        e.tag = 2;
        void 0 !== b && null !== b && (e.callback = b);
        b = $0b2e6adb871a3b94$var$dh(a, e, d);
        null !== b && ($0b2e6adb871a3b94$var$mh(b, a, d, c), $0b2e6adb871a3b94$var$eh(b, a, d));
    }
};
function $0b2e6adb871a3b94$var$oh(a, b, c, d, e, f, g) {
    a = a.stateNode;
    return "function" === typeof a.shouldComponentUpdate ? a.shouldComponentUpdate(d, f, g) : b.prototype && b.prototype.isPureReactComponent ? !$0b2e6adb871a3b94$var$Ie(c, d) || !$0b2e6adb871a3b94$var$Ie(e, f) : !0;
}
function $0b2e6adb871a3b94$var$ph(a, b, c) {
    var d = !1, e = $0b2e6adb871a3b94$var$Vf;
    var f = b.contextType;
    "object" === typeof f && null !== f ? f = $0b2e6adb871a3b94$var$Vg(f) : (e = $0b2e6adb871a3b94$var$Zf(b) ? $0b2e6adb871a3b94$var$Xf : $0b2e6adb871a3b94$var$H.current, d = b.contextTypes, f = (d = null !== d && void 0 !== d) ? $0b2e6adb871a3b94$var$Yf(a, e) : $0b2e6adb871a3b94$var$Vf);
    b = new b(c, f);
    a.memoizedState = null !== b.state && void 0 !== b.state ? b.state : null;
    b.updater = $0b2e6adb871a3b94$var$nh;
    a.stateNode = b;
    b._reactInternals = a;
    d && (a = a.stateNode, a.__reactInternalMemoizedUnmaskedChildContext = e, a.__reactInternalMemoizedMaskedChildContext = f);
    return b;
}
function $0b2e6adb871a3b94$var$qh(a, b, c, d) {
    a = b.state;
    "function" === typeof b.componentWillReceiveProps && b.componentWillReceiveProps(c, d);
    "function" === typeof b.UNSAFE_componentWillReceiveProps && b.UNSAFE_componentWillReceiveProps(c, d);
    b.state !== a && $0b2e6adb871a3b94$var$nh.enqueueReplaceState(b, b.state, null);
}
function $0b2e6adb871a3b94$var$rh(a, b, c, d) {
    var e = a.stateNode;
    e.props = c;
    e.state = a.memoizedState;
    e.refs = $0b2e6adb871a3b94$var$jh;
    $0b2e6adb871a3b94$var$ah(a);
    var f = b.contextType;
    "object" === typeof f && null !== f ? e.context = $0b2e6adb871a3b94$var$Vg(f) : (f = $0b2e6adb871a3b94$var$Zf(b) ? $0b2e6adb871a3b94$var$Xf : $0b2e6adb871a3b94$var$H.current, e.context = $0b2e6adb871a3b94$var$Yf(a, f));
    e.state = a.memoizedState;
    f = b.getDerivedStateFromProps;
    "function" === typeof f && ($0b2e6adb871a3b94$var$kh(a, b, f, c), e.state = a.memoizedState);
    "function" === typeof b.getDerivedStateFromProps || "function" === typeof e.getSnapshotBeforeUpdate || "function" !== typeof e.UNSAFE_componentWillMount && "function" !== typeof e.componentWillMount || (b = e.state, "function" === typeof e.componentWillMount && e.componentWillMount(), "function" === typeof e.UNSAFE_componentWillMount && e.UNSAFE_componentWillMount(), b !== e.state && $0b2e6adb871a3b94$var$nh.enqueueReplaceState(e, e.state, null), $0b2e6adb871a3b94$var$gh(a, c, e, d), e.state = a.memoizedState);
    "function" === typeof e.componentDidMount && (a.flags |= 4194308);
}
function $0b2e6adb871a3b94$var$sh(a, b, c) {
    a = c.ref;
    if (null !== a && "function" !== typeof a && "object" !== typeof a) {
        if (c._owner) {
            c = c._owner;
            if (c) {
                if (1 !== c.tag) throw Error($0b2e6adb871a3b94$var$p(309));
                var d = c.stateNode;
            }
            if (!d) throw Error($0b2e6adb871a3b94$var$p(147, a));
            var e = d, f = "" + a;
            if (null !== b && null !== b.ref && "function" === typeof b.ref && b.ref._stringRef === f) return b.ref;
            b = function(a) {
                var b = e.refs;
                b === $0b2e6adb871a3b94$var$jh && (b = e.refs = {});
                null === a ? delete b[f] : b[f] = a;
            };
            b._stringRef = f;
            return b;
        }
        if ("string" !== typeof a) throw Error($0b2e6adb871a3b94$var$p(284));
        if (!c._owner) throw Error($0b2e6adb871a3b94$var$p(290, a));
    }
    return a;
}
function $0b2e6adb871a3b94$var$th(a, b) {
    a = Object.prototype.toString.call(b);
    throw Error($0b2e6adb871a3b94$var$p(31, "[object Object]" === a ? "object with keys {" + Object.keys(b).join(", ") + "}" : a));
}
function $0b2e6adb871a3b94$var$uh(a) {
    var b = a._init;
    return b(a._payload);
}
function $0b2e6adb871a3b94$var$vh(a) {
    function b(b, c) {
        if (a) {
            var d = b.deletions;
            null === d ? (b.deletions = [
                c
            ], b.flags |= 16) : d.push(c);
        }
    }
    function c(c, d) {
        if (!a) return null;
        for(; null !== d;)b(c, d), d = d.sibling;
        return null;
    }
    function d(a, b) {
        for(a = new Map; null !== b;)null !== b.key ? a.set(b.key, b) : a.set(b.index, b), b = b.sibling;
        return a;
    }
    function e(a, b) {
        a = $0b2e6adb871a3b94$var$wh(a, b);
        a.index = 0;
        a.sibling = null;
        return a;
    }
    function f(b, c, d) {
        b.index = d;
        if (!a) return b.flags |= 1048576, c;
        d = b.alternate;
        if (null !== d) return d = d.index, d < c ? (b.flags |= 2, c) : d;
        b.flags |= 2;
        return c;
    }
    function g(b) {
        a && null === b.alternate && (b.flags |= 2);
        return b;
    }
    function h(a, b, c, d) {
        if (null === b || 6 !== b.tag) return b = $0b2e6adb871a3b94$var$xh(c, a.mode, d), b.return = a, b;
        b = e(b, c);
        b.return = a;
        return b;
    }
    function k(a, b, c, d) {
        var f = c.type;
        if (f === $0b2e6adb871a3b94$var$ya) return m(a, b, c.props.children, d, c.key);
        if (null !== b && (b.elementType === f || "object" === typeof f && null !== f && f.$$typeof === $0b2e6adb871a3b94$var$Ha && $0b2e6adb871a3b94$var$uh(f) === b.type)) return d = e(b, c.props), d.ref = $0b2e6adb871a3b94$var$sh(a, b, c), d.return = a, d;
        d = $0b2e6adb871a3b94$var$yh(c.type, c.key, c.props, null, a.mode, d);
        d.ref = $0b2e6adb871a3b94$var$sh(a, b, c);
        d.return = a;
        return d;
    }
    function l(a, b, c, d) {
        if (null === b || 4 !== b.tag || b.stateNode.containerInfo !== c.containerInfo || b.stateNode.implementation !== c.implementation) return b = $0b2e6adb871a3b94$var$zh(c, a.mode, d), b.return = a, b;
        b = e(b, c.children || []);
        b.return = a;
        return b;
    }
    function m(a, b, c, d, f) {
        if (null === b || 7 !== b.tag) return b = $0b2e6adb871a3b94$var$Ah(c, a.mode, d, f), b.return = a, b;
        b = e(b, c);
        b.return = a;
        return b;
    }
    function q(a, b, c) {
        if ("string" === typeof b && "" !== b || "number" === typeof b) return b = $0b2e6adb871a3b94$var$xh("" + b, a.mode, c), b.return = a, b;
        if ("object" === typeof b && null !== b) {
            switch(b.$$typeof){
                case $0b2e6adb871a3b94$var$va:
                    return c = $0b2e6adb871a3b94$var$yh(b.type, b.key, b.props, null, a.mode, c), c.ref = $0b2e6adb871a3b94$var$sh(a, null, b), c.return = a, c;
                case $0b2e6adb871a3b94$var$wa:
                    return b = $0b2e6adb871a3b94$var$zh(b, a.mode, c), b.return = a, b;
                case $0b2e6adb871a3b94$var$Ha:
                    var d = b._init;
                    return q(a, d(b._payload), c);
            }
            if ($0b2e6adb871a3b94$var$eb(b) || $0b2e6adb871a3b94$var$Ka(b)) return b = $0b2e6adb871a3b94$var$Ah(b, a.mode, c, null), b.return = a, b;
            $0b2e6adb871a3b94$var$th(a, b);
        }
        return null;
    }
    function r(a, b, c, d) {
        var e = null !== b ? b.key : null;
        if ("string" === typeof c && "" !== c || "number" === typeof c) return null !== e ? null : h(a, b, "" + c, d);
        if ("object" === typeof c && null !== c) {
            switch(c.$$typeof){
                case $0b2e6adb871a3b94$var$va:
                    return c.key === e ? k(a, b, c, d) : null;
                case $0b2e6adb871a3b94$var$wa:
                    return c.key === e ? l(a, b, c, d) : null;
                case $0b2e6adb871a3b94$var$Ha:
                    return e = c._init, r(a, b, e(c._payload), d);
            }
            if ($0b2e6adb871a3b94$var$eb(c) || $0b2e6adb871a3b94$var$Ka(c)) return null !== e ? null : m(a, b, c, d, null);
            $0b2e6adb871a3b94$var$th(a, c);
        }
        return null;
    }
    function y(a, b, c, d, e) {
        if ("string" === typeof d && "" !== d || "number" === typeof d) return a = a.get(c) || null, h(b, a, "" + d, e);
        if ("object" === typeof d && null !== d) {
            switch(d.$$typeof){
                case $0b2e6adb871a3b94$var$va:
                    return a = a.get(null === d.key ? c : d.key) || null, k(b, a, d, e);
                case $0b2e6adb871a3b94$var$wa:
                    return a = a.get(null === d.key ? c : d.key) || null, l(b, a, d, e);
                case $0b2e6adb871a3b94$var$Ha:
                    var f = d._init;
                    return y(a, b, c, f(d._payload), e);
            }
            if ($0b2e6adb871a3b94$var$eb(d) || $0b2e6adb871a3b94$var$Ka(d)) return a = a.get(c) || null, m(b, a, d, e, null);
            $0b2e6adb871a3b94$var$th(b, d);
        }
        return null;
    }
    function n(e, g, h, k) {
        for(var l = null, m = null, u = g, w = g = 0, x = null; null !== u && w < h.length; w++){
            u.index > w ? (x = u, u = null) : x = u.sibling;
            var n = r(e, u, h[w], k);
            if (null === n) {
                null === u && (u = x);
                break;
            }
            a && u && null === n.alternate && b(e, u);
            g = f(n, g, w);
            null === m ? l = n : m.sibling = n;
            m = n;
            u = x;
        }
        if (w === h.length) return c(e, u), $0b2e6adb871a3b94$var$I && $0b2e6adb871a3b94$var$tg(e, w), l;
        if (null === u) {
            for(; w < h.length; w++)u = q(e, h[w], k), null !== u && (g = f(u, g, w), null === m ? l = u : m.sibling = u, m = u);
            $0b2e6adb871a3b94$var$I && $0b2e6adb871a3b94$var$tg(e, w);
            return l;
        }
        for(u = d(e, u); w < h.length; w++)x = y(u, e, w, h[w], k), null !== x && (a && null !== x.alternate && u.delete(null === x.key ? w : x.key), g = f(x, g, w), null === m ? l = x : m.sibling = x, m = x);
        a && u.forEach(function(a) {
            return b(e, a);
        });
        $0b2e6adb871a3b94$var$I && $0b2e6adb871a3b94$var$tg(e, w);
        return l;
    }
    function t(e, g, h, k) {
        var l = $0b2e6adb871a3b94$var$Ka(h);
        if ("function" !== typeof l) throw Error($0b2e6adb871a3b94$var$p(150));
        h = l.call(h);
        if (null == h) throw Error($0b2e6adb871a3b94$var$p(151));
        for(var u = l = null, m = g, w = g = 0, x = null, n = h.next(); null !== m && !n.done; w++, n = h.next()){
            m.index > w ? (x = m, m = null) : x = m.sibling;
            var t = r(e, m, n.value, k);
            if (null === t) {
                null === m && (m = x);
                break;
            }
            a && m && null === t.alternate && b(e, m);
            g = f(t, g, w);
            null === u ? l = t : u.sibling = t;
            u = t;
            m = x;
        }
        if (n.done) return c(e, m), $0b2e6adb871a3b94$var$I && $0b2e6adb871a3b94$var$tg(e, w), l;
        if (null === m) {
            for(; !n.done; w++, n = h.next())n = q(e, n.value, k), null !== n && (g = f(n, g, w), null === u ? l = n : u.sibling = n, u = n);
            $0b2e6adb871a3b94$var$I && $0b2e6adb871a3b94$var$tg(e, w);
            return l;
        }
        for(m = d(e, m); !n.done; w++, n = h.next())n = y(m, e, w, n.value, k), null !== n && (a && null !== n.alternate && m.delete(null === n.key ? w : n.key), g = f(n, g, w), null === u ? l = n : u.sibling = n, u = n);
        a && m.forEach(function(a) {
            return b(e, a);
        });
        $0b2e6adb871a3b94$var$I && $0b2e6adb871a3b94$var$tg(e, w);
        return l;
    }
    function J(a, d, f, h) {
        "object" === typeof f && null !== f && f.type === $0b2e6adb871a3b94$var$ya && null === f.key && (f = f.props.children);
        if ("object" === typeof f && null !== f) {
            switch(f.$$typeof){
                case $0b2e6adb871a3b94$var$va:
                    a: {
                        for(var k = f.key, l = d; null !== l;){
                            if (l.key === k) {
                                k = f.type;
                                if (k === $0b2e6adb871a3b94$var$ya) {
                                    if (7 === l.tag) {
                                        c(a, l.sibling);
                                        d = e(l, f.props.children);
                                        d.return = a;
                                        a = d;
                                        break a;
                                    }
                                } else if (l.elementType === k || "object" === typeof k && null !== k && k.$$typeof === $0b2e6adb871a3b94$var$Ha && $0b2e6adb871a3b94$var$uh(k) === l.type) {
                                    c(a, l.sibling);
                                    d = e(l, f.props);
                                    d.ref = $0b2e6adb871a3b94$var$sh(a, l, f);
                                    d.return = a;
                                    a = d;
                                    break a;
                                }
                                c(a, l);
                                break;
                            } else b(a, l);
                            l = l.sibling;
                        }
                        f.type === $0b2e6adb871a3b94$var$ya ? (d = $0b2e6adb871a3b94$var$Ah(f.props.children, a.mode, h, f.key), d.return = a, a = d) : (h = $0b2e6adb871a3b94$var$yh(f.type, f.key, f.props, null, a.mode, h), h.ref = $0b2e6adb871a3b94$var$sh(a, d, f), h.return = a, a = h);
                    }
                    return g(a);
                case $0b2e6adb871a3b94$var$wa:
                    a: {
                        for(l = f.key; null !== d;){
                            if (d.key === l) {
                                if (4 === d.tag && d.stateNode.containerInfo === f.containerInfo && d.stateNode.implementation === f.implementation) {
                                    c(a, d.sibling);
                                    d = e(d, f.children || []);
                                    d.return = a;
                                    a = d;
                                    break a;
                                } else {
                                    c(a, d);
                                    break;
                                }
                            } else b(a, d);
                            d = d.sibling;
                        }
                        d = $0b2e6adb871a3b94$var$zh(f, a.mode, h);
                        d.return = a;
                        a = d;
                    }
                    return g(a);
                case $0b2e6adb871a3b94$var$Ha:
                    return l = f._init, J(a, d, l(f._payload), h);
            }
            if ($0b2e6adb871a3b94$var$eb(f)) return n(a, d, f, h);
            if ($0b2e6adb871a3b94$var$Ka(f)) return t(a, d, f, h);
            $0b2e6adb871a3b94$var$th(a, f);
        }
        return "string" === typeof f && "" !== f || "number" === typeof f ? (f = "" + f, null !== d && 6 === d.tag ? (c(a, d.sibling), d = e(d, f), d.return = a, a = d) : (c(a, d), d = $0b2e6adb871a3b94$var$xh(f, a.mode, h), d.return = a, a = d), g(a)) : c(a, d);
    }
    return J;
}
var $0b2e6adb871a3b94$var$Bh = $0b2e6adb871a3b94$var$vh(!0), $0b2e6adb871a3b94$var$Ch = $0b2e6adb871a3b94$var$vh(!1), $0b2e6adb871a3b94$var$Dh = {}, $0b2e6adb871a3b94$var$Eh = $0b2e6adb871a3b94$var$Uf($0b2e6adb871a3b94$var$Dh), $0b2e6adb871a3b94$var$Fh = $0b2e6adb871a3b94$var$Uf($0b2e6adb871a3b94$var$Dh), $0b2e6adb871a3b94$var$Gh = $0b2e6adb871a3b94$var$Uf($0b2e6adb871a3b94$var$Dh);
function $0b2e6adb871a3b94$var$Hh(a) {
    if (a === $0b2e6adb871a3b94$var$Dh) throw Error($0b2e6adb871a3b94$var$p(174));
    return a;
}
function $0b2e6adb871a3b94$var$Ih(a, b) {
    $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$Gh, b);
    $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$Fh, a);
    $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$Eh, $0b2e6adb871a3b94$var$Dh);
    a = b.nodeType;
    switch(a){
        case 9:
        case 11:
            b = (b = b.documentElement) ? b.namespaceURI : $0b2e6adb871a3b94$var$lb(null, "");
            break;
        default:
            a = 8 === a ? b.parentNode : b, b = a.namespaceURI || null, a = a.tagName, b = $0b2e6adb871a3b94$var$lb(b, a);
    }
    $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$Eh);
    $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$Eh, b);
}
function $0b2e6adb871a3b94$var$Jh() {
    $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$Eh);
    $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$Fh);
    $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$Gh);
}
function $0b2e6adb871a3b94$var$Kh(a) {
    $0b2e6adb871a3b94$var$Hh($0b2e6adb871a3b94$var$Gh.current);
    var b = $0b2e6adb871a3b94$var$Hh($0b2e6adb871a3b94$var$Eh.current);
    var c = $0b2e6adb871a3b94$var$lb(b, a.type);
    b !== c && ($0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$Fh, a), $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$Eh, c));
}
function $0b2e6adb871a3b94$var$Lh(a) {
    $0b2e6adb871a3b94$var$Fh.current === a && ($0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$Eh), $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$Fh));
}
var $0b2e6adb871a3b94$var$M = $0b2e6adb871a3b94$var$Uf(0);
function $0b2e6adb871a3b94$var$Mh(a) {
    for(var b = a; null !== b;){
        if (13 === b.tag) {
            var c = b.memoizedState;
            if (null !== c && (c = c.dehydrated, null === c || "$?" === c.data || "$!" === c.data)) return b;
        } else if (19 === b.tag && void 0 !== b.memoizedProps.revealOrder) {
            if (0 !== (b.flags & 128)) return b;
        } else if (null !== b.child) {
            b.child.return = b;
            b = b.child;
            continue;
        }
        if (b === a) break;
        for(; null === b.sibling;){
            if (null === b.return || b.return === a) return null;
            b = b.return;
        }
        b.sibling.return = b.return;
        b = b.sibling;
    }
    return null;
}
var $0b2e6adb871a3b94$var$Nh = [];
function $0b2e6adb871a3b94$var$Oh() {
    for(var a = 0; a < $0b2e6adb871a3b94$var$Nh.length; a++)$0b2e6adb871a3b94$var$Nh[a]._workInProgressVersionPrimary = null;
    $0b2e6adb871a3b94$var$Nh.length = 0;
}
var $0b2e6adb871a3b94$var$Ph = $0b2e6adb871a3b94$var$ua.ReactCurrentDispatcher, $0b2e6adb871a3b94$var$Qh = $0b2e6adb871a3b94$var$ua.ReactCurrentBatchConfig, $0b2e6adb871a3b94$var$Rh = 0, $0b2e6adb871a3b94$var$N = null, $0b2e6adb871a3b94$var$O = null, $0b2e6adb871a3b94$var$P = null, $0b2e6adb871a3b94$var$Sh = !1, $0b2e6adb871a3b94$var$Th = !1, $0b2e6adb871a3b94$var$Uh = 0, $0b2e6adb871a3b94$var$Vh = 0;
function $0b2e6adb871a3b94$var$Q() {
    throw Error($0b2e6adb871a3b94$var$p(321));
}
function $0b2e6adb871a3b94$var$Wh(a, b) {
    if (null === b) return !1;
    for(var c = 0; c < b.length && c < a.length; c++)if (!$0b2e6adb871a3b94$var$He(a[c], b[c])) return !1;
    return !0;
}
function $0b2e6adb871a3b94$var$Xh(a, b, c, d, e, f) {
    $0b2e6adb871a3b94$var$Rh = f;
    $0b2e6adb871a3b94$var$N = b;
    b.memoizedState = null;
    b.updateQueue = null;
    b.lanes = 0;
    $0b2e6adb871a3b94$var$Ph.current = null === a || null === a.memoizedState ? $0b2e6adb871a3b94$var$Yh : $0b2e6adb871a3b94$var$Zh;
    a = c(d, e);
    if ($0b2e6adb871a3b94$var$Th) {
        f = 0;
        do {
            $0b2e6adb871a3b94$var$Th = !1;
            $0b2e6adb871a3b94$var$Uh = 0;
            if (25 <= f) throw Error($0b2e6adb871a3b94$var$p(301));
            f += 1;
            $0b2e6adb871a3b94$var$P = $0b2e6adb871a3b94$var$O = null;
            b.updateQueue = null;
            $0b2e6adb871a3b94$var$Ph.current = $0b2e6adb871a3b94$var$$h;
            a = c(d, e);
        }while ($0b2e6adb871a3b94$var$Th);
    }
    $0b2e6adb871a3b94$var$Ph.current = $0b2e6adb871a3b94$var$ai;
    b = null !== $0b2e6adb871a3b94$var$O && null !== $0b2e6adb871a3b94$var$O.next;
    $0b2e6adb871a3b94$var$Rh = 0;
    $0b2e6adb871a3b94$var$P = $0b2e6adb871a3b94$var$O = $0b2e6adb871a3b94$var$N = null;
    $0b2e6adb871a3b94$var$Sh = !1;
    if (b) throw Error($0b2e6adb871a3b94$var$p(300));
    return a;
}
function $0b2e6adb871a3b94$var$bi() {
    var a = 0 !== $0b2e6adb871a3b94$var$Uh;
    $0b2e6adb871a3b94$var$Uh = 0;
    return a;
}
function $0b2e6adb871a3b94$var$ci() {
    var a = {
        memoizedState: null,
        baseState: null,
        baseQueue: null,
        queue: null,
        next: null
    };
    null === $0b2e6adb871a3b94$var$P ? $0b2e6adb871a3b94$var$N.memoizedState = $0b2e6adb871a3b94$var$P = a : $0b2e6adb871a3b94$var$P = $0b2e6adb871a3b94$var$P.next = a;
    return $0b2e6adb871a3b94$var$P;
}
function $0b2e6adb871a3b94$var$di() {
    if (null === $0b2e6adb871a3b94$var$O) {
        var a = $0b2e6adb871a3b94$var$N.alternate;
        a = null !== a ? a.memoizedState : null;
    } else a = $0b2e6adb871a3b94$var$O.next;
    var b = null === $0b2e6adb871a3b94$var$P ? $0b2e6adb871a3b94$var$N.memoizedState : $0b2e6adb871a3b94$var$P.next;
    if (null !== b) $0b2e6adb871a3b94$var$P = b, $0b2e6adb871a3b94$var$O = a;
    else {
        if (null === a) throw Error($0b2e6adb871a3b94$var$p(310));
        $0b2e6adb871a3b94$var$O = a;
        a = {
            memoizedState: $0b2e6adb871a3b94$var$O.memoizedState,
            baseState: $0b2e6adb871a3b94$var$O.baseState,
            baseQueue: $0b2e6adb871a3b94$var$O.baseQueue,
            queue: $0b2e6adb871a3b94$var$O.queue,
            next: null
        };
        null === $0b2e6adb871a3b94$var$P ? $0b2e6adb871a3b94$var$N.memoizedState = $0b2e6adb871a3b94$var$P = a : $0b2e6adb871a3b94$var$P = $0b2e6adb871a3b94$var$P.next = a;
    }
    return $0b2e6adb871a3b94$var$P;
}
function $0b2e6adb871a3b94$var$ei(a, b) {
    return "function" === typeof b ? b(a) : b;
}
function $0b2e6adb871a3b94$var$fi(a) {
    var b = $0b2e6adb871a3b94$var$di(), c = b.queue;
    if (null === c) throw Error($0b2e6adb871a3b94$var$p(311));
    c.lastRenderedReducer = a;
    var d = $0b2e6adb871a3b94$var$O, e = d.baseQueue, f = c.pending;
    if (null !== f) {
        if (null !== e) {
            var g = e.next;
            e.next = f.next;
            f.next = g;
        }
        d.baseQueue = e = f;
        c.pending = null;
    }
    if (null !== e) {
        f = e.next;
        d = d.baseState;
        var h = g = null, k = null, l = f;
        do {
            var m = l.lane;
            if (($0b2e6adb871a3b94$var$Rh & m) === m) null !== k && (k = k.next = {
                lane: 0,
                action: l.action,
                hasEagerState: l.hasEagerState,
                eagerState: l.eagerState,
                next: null
            }), d = l.hasEagerState ? l.eagerState : a(d, l.action);
            else {
                var q = {
                    lane: m,
                    action: l.action,
                    hasEagerState: l.hasEagerState,
                    eagerState: l.eagerState,
                    next: null
                };
                null === k ? (h = k = q, g = d) : k = k.next = q;
                $0b2e6adb871a3b94$var$N.lanes |= m;
                $0b2e6adb871a3b94$var$hh |= m;
            }
            l = l.next;
        }while (null !== l && l !== f);
        null === k ? g = d : k.next = h;
        $0b2e6adb871a3b94$var$He(d, b.memoizedState) || ($0b2e6adb871a3b94$var$Ug = !0);
        b.memoizedState = d;
        b.baseState = g;
        b.baseQueue = k;
        c.lastRenderedState = d;
    }
    a = c.interleaved;
    if (null !== a) {
        e = a;
        do f = e.lane, $0b2e6adb871a3b94$var$N.lanes |= f, $0b2e6adb871a3b94$var$hh |= f, e = e.next;
        while (e !== a);
    } else null === e && (c.lanes = 0);
    return [
        b.memoizedState,
        c.dispatch
    ];
}
function $0b2e6adb871a3b94$var$gi(a) {
    var b = $0b2e6adb871a3b94$var$di(), c = b.queue;
    if (null === c) throw Error($0b2e6adb871a3b94$var$p(311));
    c.lastRenderedReducer = a;
    var d = c.dispatch, e = c.pending, f = b.memoizedState;
    if (null !== e) {
        c.pending = null;
        var g = e = e.next;
        do f = a(f, g.action), g = g.next;
        while (g !== e);
        $0b2e6adb871a3b94$var$He(f, b.memoizedState) || ($0b2e6adb871a3b94$var$Ug = !0);
        b.memoizedState = f;
        null === b.baseQueue && (b.baseState = f);
        c.lastRenderedState = f;
    }
    return [
        f,
        d
    ];
}
function $0b2e6adb871a3b94$var$hi() {}
function $0b2e6adb871a3b94$var$ii(a, b) {
    var c = $0b2e6adb871a3b94$var$N, d = $0b2e6adb871a3b94$var$di(), e = b(), f = !$0b2e6adb871a3b94$var$He(d.memoizedState, e);
    f && (d.memoizedState = e, $0b2e6adb871a3b94$var$Ug = !0);
    d = d.queue;
    $0b2e6adb871a3b94$var$ji($0b2e6adb871a3b94$var$ki.bind(null, c, d, a), [
        a
    ]);
    if (d.getSnapshot !== b || f || null !== $0b2e6adb871a3b94$var$P && $0b2e6adb871a3b94$var$P.memoizedState.tag & 1) {
        c.flags |= 2048;
        $0b2e6adb871a3b94$var$li(9, $0b2e6adb871a3b94$var$mi.bind(null, c, d, e, b), void 0, null);
        if (null === $0b2e6adb871a3b94$var$R) throw Error($0b2e6adb871a3b94$var$p(349));
        0 !== ($0b2e6adb871a3b94$var$Rh & 30) || $0b2e6adb871a3b94$var$ni(c, b, e);
    }
    return e;
}
function $0b2e6adb871a3b94$var$ni(a, b, c) {
    a.flags |= 16384;
    a = {
        getSnapshot: b,
        value: c
    };
    b = $0b2e6adb871a3b94$var$N.updateQueue;
    null === b ? (b = {
        lastEffect: null,
        stores: null
    }, $0b2e6adb871a3b94$var$N.updateQueue = b, b.stores = [
        a
    ]) : (c = b.stores, null === c ? b.stores = [
        a
    ] : c.push(a));
}
function $0b2e6adb871a3b94$var$mi(a, b, c, d) {
    b.value = c;
    b.getSnapshot = d;
    $0b2e6adb871a3b94$var$oi(b) && $0b2e6adb871a3b94$var$pi(a);
}
function $0b2e6adb871a3b94$var$ki(a, b, c) {
    return c(function() {
        $0b2e6adb871a3b94$var$oi(b) && $0b2e6adb871a3b94$var$pi(a);
    });
}
function $0b2e6adb871a3b94$var$oi(a) {
    var b = a.getSnapshot;
    a = a.value;
    try {
        var c = b();
        return !$0b2e6adb871a3b94$var$He(a, c);
    } catch (d) {
        return !0;
    }
}
function $0b2e6adb871a3b94$var$pi(a) {
    var b = $0b2e6adb871a3b94$var$Zg(a, 1);
    null !== b && $0b2e6adb871a3b94$var$mh(b, a, 1, -1);
}
function $0b2e6adb871a3b94$var$qi(a) {
    var b = $0b2e6adb871a3b94$var$ci();
    "function" === typeof a && (a = a());
    b.memoizedState = b.baseState = a;
    a = {
        pending: null,
        interleaved: null,
        lanes: 0,
        dispatch: null,
        lastRenderedReducer: $0b2e6adb871a3b94$var$ei,
        lastRenderedState: a
    };
    b.queue = a;
    a = a.dispatch = $0b2e6adb871a3b94$var$ri.bind(null, $0b2e6adb871a3b94$var$N, a);
    return [
        b.memoizedState,
        a
    ];
}
function $0b2e6adb871a3b94$var$li(a, b, c, d) {
    a = {
        tag: a,
        create: b,
        destroy: c,
        deps: d,
        next: null
    };
    b = $0b2e6adb871a3b94$var$N.updateQueue;
    null === b ? (b = {
        lastEffect: null,
        stores: null
    }, $0b2e6adb871a3b94$var$N.updateQueue = b, b.lastEffect = a.next = a) : (c = b.lastEffect, null === c ? b.lastEffect = a.next = a : (d = c.next, c.next = a, a.next = d, b.lastEffect = a));
    return a;
}
function $0b2e6adb871a3b94$var$si() {
    return $0b2e6adb871a3b94$var$di().memoizedState;
}
function $0b2e6adb871a3b94$var$ti(a, b, c, d) {
    var e = $0b2e6adb871a3b94$var$ci();
    $0b2e6adb871a3b94$var$N.flags |= a;
    e.memoizedState = $0b2e6adb871a3b94$var$li(1 | b, c, void 0, void 0 === d ? null : d);
}
function $0b2e6adb871a3b94$var$ui(a, b, c, d) {
    var e = $0b2e6adb871a3b94$var$di();
    d = void 0 === d ? null : d;
    var f = void 0;
    if (null !== $0b2e6adb871a3b94$var$O) {
        var g = $0b2e6adb871a3b94$var$O.memoizedState;
        f = g.destroy;
        if (null !== d && $0b2e6adb871a3b94$var$Wh(d, g.deps)) {
            e.memoizedState = $0b2e6adb871a3b94$var$li(b, c, f, d);
            return;
        }
    }
    $0b2e6adb871a3b94$var$N.flags |= a;
    e.memoizedState = $0b2e6adb871a3b94$var$li(1 | b, c, f, d);
}
function $0b2e6adb871a3b94$var$vi(a, b) {
    return $0b2e6adb871a3b94$var$ti(8390656, 8, a, b);
}
function $0b2e6adb871a3b94$var$ji(a, b) {
    return $0b2e6adb871a3b94$var$ui(2048, 8, a, b);
}
function $0b2e6adb871a3b94$var$wi(a, b) {
    return $0b2e6adb871a3b94$var$ui(4, 2, a, b);
}
function $0b2e6adb871a3b94$var$xi(a, b) {
    return $0b2e6adb871a3b94$var$ui(4, 4, a, b);
}
function $0b2e6adb871a3b94$var$yi(a, b) {
    if ("function" === typeof b) return a = a(), b(a), function() {
        b(null);
    };
    if (null !== b && void 0 !== b) return a = a(), b.current = a, function() {
        b.current = null;
    };
}
function $0b2e6adb871a3b94$var$zi(a, b, c) {
    c = null !== c && void 0 !== c ? c.concat([
        a
    ]) : null;
    return $0b2e6adb871a3b94$var$ui(4, 4, $0b2e6adb871a3b94$var$yi.bind(null, b, a), c);
}
function $0b2e6adb871a3b94$var$Ai() {}
function $0b2e6adb871a3b94$var$Bi(a, b) {
    var c = $0b2e6adb871a3b94$var$di();
    b = void 0 === b ? null : b;
    var d = c.memoizedState;
    if (null !== d && null !== b && $0b2e6adb871a3b94$var$Wh(b, d[1])) return d[0];
    c.memoizedState = [
        a,
        b
    ];
    return a;
}
function $0b2e6adb871a3b94$var$Ci(a, b) {
    var c = $0b2e6adb871a3b94$var$di();
    b = void 0 === b ? null : b;
    var d = c.memoizedState;
    if (null !== d && null !== b && $0b2e6adb871a3b94$var$Wh(b, d[1])) return d[0];
    a = a();
    c.memoizedState = [
        a,
        b
    ];
    return a;
}
function $0b2e6adb871a3b94$var$Di(a, b, c) {
    if (0 === ($0b2e6adb871a3b94$var$Rh & 21)) return a.baseState && (a.baseState = !1, $0b2e6adb871a3b94$var$Ug = !0), a.memoizedState = c;
    $0b2e6adb871a3b94$var$He(c, b) || (c = $0b2e6adb871a3b94$var$yc(), $0b2e6adb871a3b94$var$N.lanes |= c, $0b2e6adb871a3b94$var$hh |= c, a.baseState = !0);
    return b;
}
function $0b2e6adb871a3b94$var$Ei(a, b) {
    var c = $0b2e6adb871a3b94$var$C;
    $0b2e6adb871a3b94$var$C = 0 !== c && 4 > c ? c : 4;
    a(!0);
    var d = $0b2e6adb871a3b94$var$Qh.transition;
    $0b2e6adb871a3b94$var$Qh.transition = {};
    try {
        a(!1), b();
    } finally{
        $0b2e6adb871a3b94$var$C = c, $0b2e6adb871a3b94$var$Qh.transition = d;
    }
}
function $0b2e6adb871a3b94$var$Fi() {
    return $0b2e6adb871a3b94$var$di().memoizedState;
}
function $0b2e6adb871a3b94$var$Gi(a, b, c) {
    var d = $0b2e6adb871a3b94$var$lh(a);
    c = {
        lane: d,
        action: c,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    if ($0b2e6adb871a3b94$var$Hi(a)) $0b2e6adb871a3b94$var$Ii(b, c);
    else if (c = $0b2e6adb871a3b94$var$Yg(a, b, c, d), null !== c) {
        var e = $0b2e6adb871a3b94$var$L();
        $0b2e6adb871a3b94$var$mh(c, a, d, e);
        $0b2e6adb871a3b94$var$Ji(c, b, d);
    }
}
function $0b2e6adb871a3b94$var$ri(a, b, c) {
    var d = $0b2e6adb871a3b94$var$lh(a), e = {
        lane: d,
        action: c,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    if ($0b2e6adb871a3b94$var$Hi(a)) $0b2e6adb871a3b94$var$Ii(b, e);
    else {
        var f = a.alternate;
        if (0 === a.lanes && (null === f || 0 === f.lanes) && (f = b.lastRenderedReducer, null !== f)) try {
            var g = b.lastRenderedState, h = f(g, c);
            e.hasEagerState = !0;
            e.eagerState = h;
            if ($0b2e6adb871a3b94$var$He(h, g)) {
                var k = b.interleaved;
                null === k ? (e.next = e, $0b2e6adb871a3b94$var$Xg(b)) : (e.next = k.next, k.next = e);
                b.interleaved = e;
                return;
            }
        } catch (l) {} finally{}
        c = $0b2e6adb871a3b94$var$Yg(a, b, e, d);
        null !== c && (e = $0b2e6adb871a3b94$var$L(), $0b2e6adb871a3b94$var$mh(c, a, d, e), $0b2e6adb871a3b94$var$Ji(c, b, d));
    }
}
function $0b2e6adb871a3b94$var$Hi(a) {
    var b = a.alternate;
    return a === $0b2e6adb871a3b94$var$N || null !== b && b === $0b2e6adb871a3b94$var$N;
}
function $0b2e6adb871a3b94$var$Ii(a, b) {
    $0b2e6adb871a3b94$var$Th = $0b2e6adb871a3b94$var$Sh = !0;
    var c = a.pending;
    null === c ? b.next = b : (b.next = c.next, c.next = b);
    a.pending = b;
}
function $0b2e6adb871a3b94$var$Ji(a, b, c) {
    if (0 !== (c & 4194240)) {
        var d = b.lanes;
        d &= a.pendingLanes;
        c |= d;
        b.lanes = c;
        $0b2e6adb871a3b94$var$Cc(a, c);
    }
}
var $0b2e6adb871a3b94$var$ai = {
    readContext: $0b2e6adb871a3b94$var$Vg,
    useCallback: $0b2e6adb871a3b94$var$Q,
    useContext: $0b2e6adb871a3b94$var$Q,
    useEffect: $0b2e6adb871a3b94$var$Q,
    useImperativeHandle: $0b2e6adb871a3b94$var$Q,
    useInsertionEffect: $0b2e6adb871a3b94$var$Q,
    useLayoutEffect: $0b2e6adb871a3b94$var$Q,
    useMemo: $0b2e6adb871a3b94$var$Q,
    useReducer: $0b2e6adb871a3b94$var$Q,
    useRef: $0b2e6adb871a3b94$var$Q,
    useState: $0b2e6adb871a3b94$var$Q,
    useDebugValue: $0b2e6adb871a3b94$var$Q,
    useDeferredValue: $0b2e6adb871a3b94$var$Q,
    useTransition: $0b2e6adb871a3b94$var$Q,
    useMutableSource: $0b2e6adb871a3b94$var$Q,
    useSyncExternalStore: $0b2e6adb871a3b94$var$Q,
    useId: $0b2e6adb871a3b94$var$Q,
    unstable_isNewReconciler: !1
}, $0b2e6adb871a3b94$var$Yh = {
    readContext: $0b2e6adb871a3b94$var$Vg,
    useCallback: function(a, b) {
        $0b2e6adb871a3b94$var$ci().memoizedState = [
            a,
            void 0 === b ? null : b
        ];
        return a;
    },
    useContext: $0b2e6adb871a3b94$var$Vg,
    useEffect: $0b2e6adb871a3b94$var$vi,
    useImperativeHandle: function(a, b, c) {
        c = null !== c && void 0 !== c ? c.concat([
            a
        ]) : null;
        return $0b2e6adb871a3b94$var$ti(4194308, 4, $0b2e6adb871a3b94$var$yi.bind(null, b, a), c);
    },
    useLayoutEffect: function(a, b) {
        return $0b2e6adb871a3b94$var$ti(4194308, 4, a, b);
    },
    useInsertionEffect: function(a, b) {
        return $0b2e6adb871a3b94$var$ti(4, 2, a, b);
    },
    useMemo: function(a, b) {
        var c = $0b2e6adb871a3b94$var$ci();
        b = void 0 === b ? null : b;
        a = a();
        c.memoizedState = [
            a,
            b
        ];
        return a;
    },
    useReducer: function(a, b, c) {
        var d = $0b2e6adb871a3b94$var$ci();
        b = void 0 !== c ? c(b) : b;
        d.memoizedState = d.baseState = b;
        a = {
            pending: null,
            interleaved: null,
            lanes: 0,
            dispatch: null,
            lastRenderedReducer: a,
            lastRenderedState: b
        };
        d.queue = a;
        a = a.dispatch = $0b2e6adb871a3b94$var$Gi.bind(null, $0b2e6adb871a3b94$var$N, a);
        return [
            d.memoizedState,
            a
        ];
    },
    useRef: function(a) {
        var b = $0b2e6adb871a3b94$var$ci();
        a = {
            current: a
        };
        return b.memoizedState = a;
    },
    useState: $0b2e6adb871a3b94$var$qi,
    useDebugValue: $0b2e6adb871a3b94$var$Ai,
    useDeferredValue: function(a) {
        return $0b2e6adb871a3b94$var$ci().memoizedState = a;
    },
    useTransition: function() {
        var a = $0b2e6adb871a3b94$var$qi(!1), b = a[0];
        a = $0b2e6adb871a3b94$var$Ei.bind(null, a[1]);
        $0b2e6adb871a3b94$var$ci().memoizedState = a;
        return [
            b,
            a
        ];
    },
    useMutableSource: function() {},
    useSyncExternalStore: function(a, b, c) {
        var d = $0b2e6adb871a3b94$var$N, e = $0b2e6adb871a3b94$var$ci();
        if ($0b2e6adb871a3b94$var$I) {
            if (void 0 === c) throw Error($0b2e6adb871a3b94$var$p(407));
            c = c();
        } else {
            c = b();
            if (null === $0b2e6adb871a3b94$var$R) throw Error($0b2e6adb871a3b94$var$p(349));
            0 !== ($0b2e6adb871a3b94$var$Rh & 30) || $0b2e6adb871a3b94$var$ni(d, b, c);
        }
        e.memoizedState = c;
        var f = {
            value: c,
            getSnapshot: b
        };
        e.queue = f;
        $0b2e6adb871a3b94$var$vi($0b2e6adb871a3b94$var$ki.bind(null, d, f, a), [
            a
        ]);
        d.flags |= 2048;
        $0b2e6adb871a3b94$var$li(9, $0b2e6adb871a3b94$var$mi.bind(null, d, f, c, b), void 0, null);
        return c;
    },
    useId: function() {
        var a = $0b2e6adb871a3b94$var$ci(), b = $0b2e6adb871a3b94$var$R.identifierPrefix;
        if ($0b2e6adb871a3b94$var$I) {
            var c = $0b2e6adb871a3b94$var$sg;
            var d = $0b2e6adb871a3b94$var$rg;
            c = (d & ~(1 << 32 - $0b2e6adb871a3b94$var$oc(d) - 1)).toString(32) + c;
            b = ":" + b + "R" + c;
            c = $0b2e6adb871a3b94$var$Uh++;
            0 < c && (b += "H" + c.toString(32));
            b += ":";
        } else c = $0b2e6adb871a3b94$var$Vh++, b = ":" + b + "r" + c.toString(32) + ":";
        return a.memoizedState = b;
    },
    unstable_isNewReconciler: !1
}, $0b2e6adb871a3b94$var$Zh = {
    readContext: $0b2e6adb871a3b94$var$Vg,
    useCallback: $0b2e6adb871a3b94$var$Bi,
    useContext: $0b2e6adb871a3b94$var$Vg,
    useEffect: $0b2e6adb871a3b94$var$ji,
    useImperativeHandle: $0b2e6adb871a3b94$var$zi,
    useInsertionEffect: $0b2e6adb871a3b94$var$wi,
    useLayoutEffect: $0b2e6adb871a3b94$var$xi,
    useMemo: $0b2e6adb871a3b94$var$Ci,
    useReducer: $0b2e6adb871a3b94$var$fi,
    useRef: $0b2e6adb871a3b94$var$si,
    useState: function() {
        return $0b2e6adb871a3b94$var$fi($0b2e6adb871a3b94$var$ei);
    },
    useDebugValue: $0b2e6adb871a3b94$var$Ai,
    useDeferredValue: function(a) {
        var b = $0b2e6adb871a3b94$var$di();
        return $0b2e6adb871a3b94$var$Di(b, $0b2e6adb871a3b94$var$O.memoizedState, a);
    },
    useTransition: function() {
        var a = $0b2e6adb871a3b94$var$fi($0b2e6adb871a3b94$var$ei)[0], b = $0b2e6adb871a3b94$var$di().memoizedState;
        return [
            a,
            b
        ];
    },
    useMutableSource: $0b2e6adb871a3b94$var$hi,
    useSyncExternalStore: $0b2e6adb871a3b94$var$ii,
    useId: $0b2e6adb871a3b94$var$Fi,
    unstable_isNewReconciler: !1
}, $0b2e6adb871a3b94$var$$h = {
    readContext: $0b2e6adb871a3b94$var$Vg,
    useCallback: $0b2e6adb871a3b94$var$Bi,
    useContext: $0b2e6adb871a3b94$var$Vg,
    useEffect: $0b2e6adb871a3b94$var$ji,
    useImperativeHandle: $0b2e6adb871a3b94$var$zi,
    useInsertionEffect: $0b2e6adb871a3b94$var$wi,
    useLayoutEffect: $0b2e6adb871a3b94$var$xi,
    useMemo: $0b2e6adb871a3b94$var$Ci,
    useReducer: $0b2e6adb871a3b94$var$gi,
    useRef: $0b2e6adb871a3b94$var$si,
    useState: function() {
        return $0b2e6adb871a3b94$var$gi($0b2e6adb871a3b94$var$ei);
    },
    useDebugValue: $0b2e6adb871a3b94$var$Ai,
    useDeferredValue: function(a) {
        var b = $0b2e6adb871a3b94$var$di();
        return null === $0b2e6adb871a3b94$var$O ? b.memoizedState = a : $0b2e6adb871a3b94$var$Di(b, $0b2e6adb871a3b94$var$O.memoizedState, a);
    },
    useTransition: function() {
        var a = $0b2e6adb871a3b94$var$gi($0b2e6adb871a3b94$var$ei)[0], b = $0b2e6adb871a3b94$var$di().memoizedState;
        return [
            a,
            b
        ];
    },
    useMutableSource: $0b2e6adb871a3b94$var$hi,
    useSyncExternalStore: $0b2e6adb871a3b94$var$ii,
    useId: $0b2e6adb871a3b94$var$Fi,
    unstable_isNewReconciler: !1
};
function $0b2e6adb871a3b94$var$Ki(a, b) {
    try {
        var c = "", d = b;
        do c += $0b2e6adb871a3b94$var$Pa(d), d = d.return;
        while (d);
        var e = c;
    } catch (f) {
        e = "\nError generating stack: " + f.message + "\n" + f.stack;
    }
    return {
        value: a,
        source: b,
        stack: e,
        digest: null
    };
}
function $0b2e6adb871a3b94$var$Li(a, b, c) {
    return {
        value: a,
        source: null,
        stack: null != c ? c : null,
        digest: null != b ? b : null
    };
}
function $0b2e6adb871a3b94$var$Mi(a, b) {
    try {
        console.error(b.value);
    } catch (c) {
        setTimeout(function() {
            throw c;
        });
    }
}
var $0b2e6adb871a3b94$var$Ni = "function" === typeof WeakMap ? WeakMap : Map;
function $0b2e6adb871a3b94$var$Oi(a, b, c) {
    c = $0b2e6adb871a3b94$var$ch(-1, c);
    c.tag = 3;
    c.payload = {
        element: null
    };
    var d = b.value;
    c.callback = function() {
        $0b2e6adb871a3b94$var$Pi || ($0b2e6adb871a3b94$var$Pi = !0, $0b2e6adb871a3b94$var$Qi = d);
        $0b2e6adb871a3b94$var$Mi(a, b);
    };
    return c;
}
function $0b2e6adb871a3b94$var$Ri(a, b, c) {
    c = $0b2e6adb871a3b94$var$ch(-1, c);
    c.tag = 3;
    var d = a.type.getDerivedStateFromError;
    if ("function" === typeof d) {
        var e = b.value;
        c.payload = function() {
            return d(e);
        };
        c.callback = function() {
            $0b2e6adb871a3b94$var$Mi(a, b);
        };
    }
    var f = a.stateNode;
    null !== f && "function" === typeof f.componentDidCatch && (c.callback = function() {
        $0b2e6adb871a3b94$var$Mi(a, b);
        "function" !== typeof d && (null === $0b2e6adb871a3b94$var$Si ? $0b2e6adb871a3b94$var$Si = new Set([
            this
        ]) : $0b2e6adb871a3b94$var$Si.add(this));
        var c = b.stack;
        this.componentDidCatch(b.value, {
            componentStack: null !== c ? c : ""
        });
    });
    return c;
}
function $0b2e6adb871a3b94$var$Ti(a, b, c) {
    var d = a.pingCache;
    if (null === d) {
        d = a.pingCache = new $0b2e6adb871a3b94$var$Ni;
        var e = new Set;
        d.set(b, e);
    } else e = d.get(b), void 0 === e && (e = new Set, d.set(b, e));
    e.has(c) || (e.add(c), a = $0b2e6adb871a3b94$var$Ui.bind(null, a, b, c), b.then(a, a));
}
function $0b2e6adb871a3b94$var$Vi(a) {
    do {
        var b;
        if (b = 13 === a.tag) b = a.memoizedState, b = null !== b ? null !== b.dehydrated ? !0 : !1 : !0;
        if (b) return a;
        a = a.return;
    }while (null !== a);
    return null;
}
function $0b2e6adb871a3b94$var$Wi(a, b, c, d, e) {
    if (0 === (a.mode & 1)) return a === b ? a.flags |= 65536 : (a.flags |= 128, c.flags |= 131072, c.flags &= -52805, 1 === c.tag && (null === c.alternate ? c.tag = 17 : (b = $0b2e6adb871a3b94$var$ch(-1, 1), b.tag = 2, $0b2e6adb871a3b94$var$dh(c, b, 1))), c.lanes |= 1), a;
    a.flags |= 65536;
    a.lanes = e;
    return a;
}
var $0b2e6adb871a3b94$var$Xi = $0b2e6adb871a3b94$var$ua.ReactCurrentOwner, $0b2e6adb871a3b94$var$Ug = !1;
function $0b2e6adb871a3b94$var$Yi(a, b, c, d) {
    b.child = null === a ? $0b2e6adb871a3b94$var$Ch(b, null, c, d) : $0b2e6adb871a3b94$var$Bh(b, a.child, c, d);
}
function $0b2e6adb871a3b94$var$Zi(a, b, c, d, e) {
    c = c.render;
    var f = b.ref;
    $0b2e6adb871a3b94$var$Tg(b, e);
    d = $0b2e6adb871a3b94$var$Xh(a, b, c, d, f, e);
    c = $0b2e6adb871a3b94$var$bi();
    if (null !== a && !$0b2e6adb871a3b94$var$Ug) return b.updateQueue = a.updateQueue, b.flags &= -2053, a.lanes &= ~e, $0b2e6adb871a3b94$var$$i(a, b, e);
    $0b2e6adb871a3b94$var$I && c && $0b2e6adb871a3b94$var$vg(b);
    b.flags |= 1;
    $0b2e6adb871a3b94$var$Yi(a, b, d, e);
    return b.child;
}
function $0b2e6adb871a3b94$var$aj(a, b, c, d, e) {
    if (null === a) {
        var f = c.type;
        if ("function" === typeof f && !$0b2e6adb871a3b94$var$bj(f) && void 0 === f.defaultProps && null === c.compare && void 0 === c.defaultProps) return b.tag = 15, b.type = f, $0b2e6adb871a3b94$var$cj(a, b, f, d, e);
        a = $0b2e6adb871a3b94$var$yh(c.type, null, d, b, b.mode, e);
        a.ref = b.ref;
        a.return = b;
        return b.child = a;
    }
    f = a.child;
    if (0 === (a.lanes & e)) {
        var g = f.memoizedProps;
        c = c.compare;
        c = null !== c ? c : $0b2e6adb871a3b94$var$Ie;
        if (c(g, d) && a.ref === b.ref) return $0b2e6adb871a3b94$var$$i(a, b, e);
    }
    b.flags |= 1;
    a = $0b2e6adb871a3b94$var$wh(f, d);
    a.ref = b.ref;
    a.return = b;
    return b.child = a;
}
function $0b2e6adb871a3b94$var$cj(a, b, c, d, e) {
    if (null !== a) {
        var f = a.memoizedProps;
        if ($0b2e6adb871a3b94$var$Ie(f, d) && a.ref === b.ref) {
            if ($0b2e6adb871a3b94$var$Ug = !1, b.pendingProps = d = f, 0 !== (a.lanes & e)) 0 !== (a.flags & 131072) && ($0b2e6adb871a3b94$var$Ug = !0);
            else return b.lanes = a.lanes, $0b2e6adb871a3b94$var$$i(a, b, e);
        }
    }
    return $0b2e6adb871a3b94$var$dj(a, b, c, d, e);
}
function $0b2e6adb871a3b94$var$ej(a, b, c) {
    var d = b.pendingProps, e = d.children, f = null !== a ? a.memoizedState : null;
    if ("hidden" === d.mode) {
        if (0 === (b.mode & 1)) b.memoizedState = {
            baseLanes: 0,
            cachePool: null,
            transitions: null
        }, $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$fj, $0b2e6adb871a3b94$var$gj), $0b2e6adb871a3b94$var$gj |= c;
        else {
            if (0 === (c & 1073741824)) return a = null !== f ? f.baseLanes | c : c, b.lanes = b.childLanes = 1073741824, b.memoizedState = {
                baseLanes: a,
                cachePool: null,
                transitions: null
            }, b.updateQueue = null, $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$fj, $0b2e6adb871a3b94$var$gj), $0b2e6adb871a3b94$var$gj |= a, null;
            b.memoizedState = {
                baseLanes: 0,
                cachePool: null,
                transitions: null
            };
            d = null !== f ? f.baseLanes : c;
            $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$fj, $0b2e6adb871a3b94$var$gj);
            $0b2e6adb871a3b94$var$gj |= d;
        }
    } else null !== f ? (d = f.baseLanes | c, b.memoizedState = null) : d = c, $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$fj, $0b2e6adb871a3b94$var$gj), $0b2e6adb871a3b94$var$gj |= d;
    $0b2e6adb871a3b94$var$Yi(a, b, e, c);
    return b.child;
}
function $0b2e6adb871a3b94$var$hj(a, b) {
    var c = b.ref;
    if (null === a && null !== c || null !== a && a.ref !== c) b.flags |= 512, b.flags |= 2097152;
}
function $0b2e6adb871a3b94$var$dj(a, b, c, d, e) {
    var f = $0b2e6adb871a3b94$var$Zf(c) ? $0b2e6adb871a3b94$var$Xf : $0b2e6adb871a3b94$var$H.current;
    f = $0b2e6adb871a3b94$var$Yf(b, f);
    $0b2e6adb871a3b94$var$Tg(b, e);
    c = $0b2e6adb871a3b94$var$Xh(a, b, c, d, f, e);
    d = $0b2e6adb871a3b94$var$bi();
    if (null !== a && !$0b2e6adb871a3b94$var$Ug) return b.updateQueue = a.updateQueue, b.flags &= -2053, a.lanes &= ~e, $0b2e6adb871a3b94$var$$i(a, b, e);
    $0b2e6adb871a3b94$var$I && d && $0b2e6adb871a3b94$var$vg(b);
    b.flags |= 1;
    $0b2e6adb871a3b94$var$Yi(a, b, c, e);
    return b.child;
}
function $0b2e6adb871a3b94$var$ij(a, b, c, d, e) {
    if ($0b2e6adb871a3b94$var$Zf(c)) {
        var f = !0;
        $0b2e6adb871a3b94$var$cg(b);
    } else f = !1;
    $0b2e6adb871a3b94$var$Tg(b, e);
    if (null === b.stateNode) $0b2e6adb871a3b94$var$jj(a, b), $0b2e6adb871a3b94$var$ph(b, c, d), $0b2e6adb871a3b94$var$rh(b, c, d, e), d = !0;
    else if (null === a) {
        var g = b.stateNode, h = b.memoizedProps;
        g.props = h;
        var k = g.context, l = c.contextType;
        "object" === typeof l && null !== l ? l = $0b2e6adb871a3b94$var$Vg(l) : (l = $0b2e6adb871a3b94$var$Zf(c) ? $0b2e6adb871a3b94$var$Xf : $0b2e6adb871a3b94$var$H.current, l = $0b2e6adb871a3b94$var$Yf(b, l));
        var m = c.getDerivedStateFromProps, q = "function" === typeof m || "function" === typeof g.getSnapshotBeforeUpdate;
        q || "function" !== typeof g.UNSAFE_componentWillReceiveProps && "function" !== typeof g.componentWillReceiveProps || (h !== d || k !== l) && $0b2e6adb871a3b94$var$qh(b, g, d, l);
        $0b2e6adb871a3b94$var$$g = !1;
        var r = b.memoizedState;
        g.state = r;
        $0b2e6adb871a3b94$var$gh(b, d, g, e);
        k = b.memoizedState;
        h !== d || r !== k || $0b2e6adb871a3b94$var$Wf.current || $0b2e6adb871a3b94$var$$g ? ("function" === typeof m && ($0b2e6adb871a3b94$var$kh(b, c, m, d), k = b.memoizedState), (h = $0b2e6adb871a3b94$var$$g || $0b2e6adb871a3b94$var$oh(b, c, h, d, r, k, l)) ? (q || "function" !== typeof g.UNSAFE_componentWillMount && "function" !== typeof g.componentWillMount || ("function" === typeof g.componentWillMount && g.componentWillMount(), "function" === typeof g.UNSAFE_componentWillMount && g.UNSAFE_componentWillMount()), "function" === typeof g.componentDidMount && (b.flags |= 4194308)) : ("function" === typeof g.componentDidMount && (b.flags |= 4194308), b.memoizedProps = d, b.memoizedState = k), g.props = d, g.state = k, g.context = l, d = h) : ("function" === typeof g.componentDidMount && (b.flags |= 4194308), d = !1);
    } else {
        g = b.stateNode;
        $0b2e6adb871a3b94$var$bh(a, b);
        h = b.memoizedProps;
        l = b.type === b.elementType ? h : $0b2e6adb871a3b94$var$Lg(b.type, h);
        g.props = l;
        q = b.pendingProps;
        r = g.context;
        k = c.contextType;
        "object" === typeof k && null !== k ? k = $0b2e6adb871a3b94$var$Vg(k) : (k = $0b2e6adb871a3b94$var$Zf(c) ? $0b2e6adb871a3b94$var$Xf : $0b2e6adb871a3b94$var$H.current, k = $0b2e6adb871a3b94$var$Yf(b, k));
        var y = c.getDerivedStateFromProps;
        (m = "function" === typeof y || "function" === typeof g.getSnapshotBeforeUpdate) || "function" !== typeof g.UNSAFE_componentWillReceiveProps && "function" !== typeof g.componentWillReceiveProps || (h !== q || r !== k) && $0b2e6adb871a3b94$var$qh(b, g, d, k);
        $0b2e6adb871a3b94$var$$g = !1;
        r = b.memoizedState;
        g.state = r;
        $0b2e6adb871a3b94$var$gh(b, d, g, e);
        var n = b.memoizedState;
        h !== q || r !== n || $0b2e6adb871a3b94$var$Wf.current || $0b2e6adb871a3b94$var$$g ? ("function" === typeof y && ($0b2e6adb871a3b94$var$kh(b, c, y, d), n = b.memoizedState), (l = $0b2e6adb871a3b94$var$$g || $0b2e6adb871a3b94$var$oh(b, c, l, d, r, n, k) || !1) ? (m || "function" !== typeof g.UNSAFE_componentWillUpdate && "function" !== typeof g.componentWillUpdate || ("function" === typeof g.componentWillUpdate && g.componentWillUpdate(d, n, k), "function" === typeof g.UNSAFE_componentWillUpdate && g.UNSAFE_componentWillUpdate(d, n, k)), "function" === typeof g.componentDidUpdate && (b.flags |= 4), "function" === typeof g.getSnapshotBeforeUpdate && (b.flags |= 1024)) : ("function" !== typeof g.componentDidUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 4), "function" !== typeof g.getSnapshotBeforeUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 1024), b.memoizedProps = d, b.memoizedState = n), g.props = d, g.state = n, g.context = k, d = l) : ("function" !== typeof g.componentDidUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 4), "function" !== typeof g.getSnapshotBeforeUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 1024), d = !1);
    }
    return $0b2e6adb871a3b94$var$kj(a, b, c, d, f, e);
}
function $0b2e6adb871a3b94$var$kj(a, b, c, d, e, f) {
    $0b2e6adb871a3b94$var$hj(a, b);
    var g = 0 !== (b.flags & 128);
    if (!d && !g) return e && $0b2e6adb871a3b94$var$dg(b, c, !1), $0b2e6adb871a3b94$var$$i(a, b, f);
    d = b.stateNode;
    $0b2e6adb871a3b94$var$Xi.current = b;
    var h = g && "function" !== typeof c.getDerivedStateFromError ? null : d.render();
    b.flags |= 1;
    null !== a && g ? (b.child = $0b2e6adb871a3b94$var$Bh(b, a.child, null, f), b.child = $0b2e6adb871a3b94$var$Bh(b, null, h, f)) : $0b2e6adb871a3b94$var$Yi(a, b, h, f);
    b.memoizedState = d.state;
    e && $0b2e6adb871a3b94$var$dg(b, c, !0);
    return b.child;
}
function $0b2e6adb871a3b94$var$lj(a) {
    var b = a.stateNode;
    b.pendingContext ? $0b2e6adb871a3b94$var$ag(a, b.pendingContext, b.pendingContext !== b.context) : b.context && $0b2e6adb871a3b94$var$ag(a, b.context, !1);
    $0b2e6adb871a3b94$var$Ih(a, b.containerInfo);
}
function $0b2e6adb871a3b94$var$mj(a, b, c, d, e) {
    $0b2e6adb871a3b94$var$Ig();
    $0b2e6adb871a3b94$var$Jg(e);
    b.flags |= 256;
    $0b2e6adb871a3b94$var$Yi(a, b, c, d);
    return b.child;
}
var $0b2e6adb871a3b94$var$nj = {
    dehydrated: null,
    treeContext: null,
    retryLane: 0
};
function $0b2e6adb871a3b94$var$oj(a) {
    return {
        baseLanes: a,
        cachePool: null,
        transitions: null
    };
}
function $0b2e6adb871a3b94$var$pj(a, b, c) {
    var d = b.pendingProps, e = $0b2e6adb871a3b94$var$M.current, f = !1, g = 0 !== (b.flags & 128), h;
    (h = g) || (h = null !== a && null === a.memoizedState ? !1 : 0 !== (e & 2));
    if (h) f = !0, b.flags &= -129;
    else if (null === a || null !== a.memoizedState) e |= 1;
    $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$M, e & 1);
    if (null === a) {
        $0b2e6adb871a3b94$var$Eg(b);
        a = b.memoizedState;
        if (null !== a && (a = a.dehydrated, null !== a)) return 0 === (b.mode & 1) ? b.lanes = 1 : "$!" === a.data ? b.lanes = 8 : b.lanes = 1073741824, null;
        g = d.children;
        a = d.fallback;
        return f ? (d = b.mode, f = b.child, g = {
            mode: "hidden",
            children: g
        }, 0 === (d & 1) && null !== f ? (f.childLanes = 0, f.pendingProps = g) : f = $0b2e6adb871a3b94$var$qj(g, d, 0, null), a = $0b2e6adb871a3b94$var$Ah(a, d, c, null), f.return = b, a.return = b, f.sibling = a, b.child = f, b.child.memoizedState = $0b2e6adb871a3b94$var$oj(c), b.memoizedState = $0b2e6adb871a3b94$var$nj, a) : $0b2e6adb871a3b94$var$rj(b, g);
    }
    e = a.memoizedState;
    if (null !== e && (h = e.dehydrated, null !== h)) return $0b2e6adb871a3b94$var$sj(a, b, g, d, h, e, c);
    if (f) {
        f = d.fallback;
        g = b.mode;
        e = a.child;
        h = e.sibling;
        var k = {
            mode: "hidden",
            children: d.children
        };
        0 === (g & 1) && b.child !== e ? (d = b.child, d.childLanes = 0, d.pendingProps = k, b.deletions = null) : (d = $0b2e6adb871a3b94$var$wh(e, k), d.subtreeFlags = e.subtreeFlags & 14680064);
        null !== h ? f = $0b2e6adb871a3b94$var$wh(h, f) : (f = $0b2e6adb871a3b94$var$Ah(f, g, c, null), f.flags |= 2);
        f.return = b;
        d.return = b;
        d.sibling = f;
        b.child = d;
        d = f;
        f = b.child;
        g = a.child.memoizedState;
        g = null === g ? $0b2e6adb871a3b94$var$oj(c) : {
            baseLanes: g.baseLanes | c,
            cachePool: null,
            transitions: g.transitions
        };
        f.memoizedState = g;
        f.childLanes = a.childLanes & ~c;
        b.memoizedState = $0b2e6adb871a3b94$var$nj;
        return d;
    }
    f = a.child;
    a = f.sibling;
    d = $0b2e6adb871a3b94$var$wh(f, {
        mode: "visible",
        children: d.children
    });
    0 === (b.mode & 1) && (d.lanes = c);
    d.return = b;
    d.sibling = null;
    null !== a && (c = b.deletions, null === c ? (b.deletions = [
        a
    ], b.flags |= 16) : c.push(a));
    b.child = d;
    b.memoizedState = null;
    return d;
}
function $0b2e6adb871a3b94$var$rj(a, b) {
    b = $0b2e6adb871a3b94$var$qj({
        mode: "visible",
        children: b
    }, a.mode, 0, null);
    b.return = a;
    return a.child = b;
}
function $0b2e6adb871a3b94$var$tj(a, b, c, d) {
    null !== d && $0b2e6adb871a3b94$var$Jg(d);
    $0b2e6adb871a3b94$var$Bh(b, a.child, null, c);
    a = $0b2e6adb871a3b94$var$rj(b, b.pendingProps.children);
    a.flags |= 2;
    b.memoizedState = null;
    return a;
}
function $0b2e6adb871a3b94$var$sj(a, b, c, d, e, f, g) {
    if (c) {
        if (b.flags & 256) return b.flags &= -257, d = $0b2e6adb871a3b94$var$Li(Error($0b2e6adb871a3b94$var$p(422))), $0b2e6adb871a3b94$var$tj(a, b, g, d);
        if (null !== b.memoizedState) return b.child = a.child, b.flags |= 128, null;
        f = d.fallback;
        e = b.mode;
        d = $0b2e6adb871a3b94$var$qj({
            mode: "visible",
            children: d.children
        }, e, 0, null);
        f = $0b2e6adb871a3b94$var$Ah(f, e, g, null);
        f.flags |= 2;
        d.return = b;
        f.return = b;
        d.sibling = f;
        b.child = d;
        0 !== (b.mode & 1) && $0b2e6adb871a3b94$var$Bh(b, a.child, null, g);
        b.child.memoizedState = $0b2e6adb871a3b94$var$oj(g);
        b.memoizedState = $0b2e6adb871a3b94$var$nj;
        return f;
    }
    if (0 === (b.mode & 1)) return $0b2e6adb871a3b94$var$tj(a, b, g, null);
    if ("$!" === e.data) {
        d = e.nextSibling && e.nextSibling.dataset;
        if (d) var h = d.dgst;
        d = h;
        f = Error($0b2e6adb871a3b94$var$p(419));
        d = $0b2e6adb871a3b94$var$Li(f, d, void 0);
        return $0b2e6adb871a3b94$var$tj(a, b, g, d);
    }
    h = 0 !== (g & a.childLanes);
    if ($0b2e6adb871a3b94$var$Ug || h) {
        d = $0b2e6adb871a3b94$var$R;
        if (null !== d) {
            switch(g & -g){
                case 4:
                    e = 2;
                    break;
                case 16:
                    e = 8;
                    break;
                case 64:
                case 128:
                case 256:
                case 512:
                case 1024:
                case 2048:
                case 4096:
                case 8192:
                case 16384:
                case 32768:
                case 65536:
                case 131072:
                case 262144:
                case 524288:
                case 1048576:
                case 2097152:
                case 4194304:
                case 8388608:
                case 16777216:
                case 33554432:
                case 67108864:
                    e = 32;
                    break;
                case 536870912:
                    e = 268435456;
                    break;
                default:
                    e = 0;
            }
            e = 0 !== (e & (d.suspendedLanes | g)) ? 0 : e;
            0 !== e && e !== f.retryLane && (f.retryLane = e, $0b2e6adb871a3b94$var$Zg(a, e), $0b2e6adb871a3b94$var$mh(d, a, e, -1));
        }
        $0b2e6adb871a3b94$var$uj();
        d = $0b2e6adb871a3b94$var$Li(Error($0b2e6adb871a3b94$var$p(421)));
        return $0b2e6adb871a3b94$var$tj(a, b, g, d);
    }
    if ("$?" === e.data) return b.flags |= 128, b.child = a.child, b = $0b2e6adb871a3b94$var$vj.bind(null, a), e._reactRetry = b, null;
    a = f.treeContext;
    $0b2e6adb871a3b94$var$yg = $0b2e6adb871a3b94$var$Lf(e.nextSibling);
    $0b2e6adb871a3b94$var$xg = b;
    $0b2e6adb871a3b94$var$I = !0;
    $0b2e6adb871a3b94$var$zg = null;
    null !== a && ($0b2e6adb871a3b94$var$og[$0b2e6adb871a3b94$var$pg++] = $0b2e6adb871a3b94$var$rg, $0b2e6adb871a3b94$var$og[$0b2e6adb871a3b94$var$pg++] = $0b2e6adb871a3b94$var$sg, $0b2e6adb871a3b94$var$og[$0b2e6adb871a3b94$var$pg++] = $0b2e6adb871a3b94$var$qg, $0b2e6adb871a3b94$var$rg = a.id, $0b2e6adb871a3b94$var$sg = a.overflow, $0b2e6adb871a3b94$var$qg = b);
    b = $0b2e6adb871a3b94$var$rj(b, d.children);
    b.flags |= 4096;
    return b;
}
function $0b2e6adb871a3b94$var$wj(a, b, c) {
    a.lanes |= b;
    var d = a.alternate;
    null !== d && (d.lanes |= b);
    $0b2e6adb871a3b94$var$Sg(a.return, b, c);
}
function $0b2e6adb871a3b94$var$xj(a, b, c, d, e) {
    var f = a.memoizedState;
    null === f ? a.memoizedState = {
        isBackwards: b,
        rendering: null,
        renderingStartTime: 0,
        last: d,
        tail: c,
        tailMode: e
    } : (f.isBackwards = b, f.rendering = null, f.renderingStartTime = 0, f.last = d, f.tail = c, f.tailMode = e);
}
function $0b2e6adb871a3b94$var$yj(a, b, c) {
    var d = b.pendingProps, e = d.revealOrder, f = d.tail;
    $0b2e6adb871a3b94$var$Yi(a, b, d.children, c);
    d = $0b2e6adb871a3b94$var$M.current;
    if (0 !== (d & 2)) d = d & 1 | 2, b.flags |= 128;
    else {
        if (null !== a && 0 !== (a.flags & 128)) a: for(a = b.child; null !== a;){
            if (13 === a.tag) null !== a.memoizedState && $0b2e6adb871a3b94$var$wj(a, c, b);
            else if (19 === a.tag) $0b2e6adb871a3b94$var$wj(a, c, b);
            else if (null !== a.child) {
                a.child.return = a;
                a = a.child;
                continue;
            }
            if (a === b) break a;
            for(; null === a.sibling;){
                if (null === a.return || a.return === b) break a;
                a = a.return;
            }
            a.sibling.return = a.return;
            a = a.sibling;
        }
        d &= 1;
    }
    $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$M, d);
    if (0 === (b.mode & 1)) b.memoizedState = null;
    else switch(e){
        case "forwards":
            c = b.child;
            for(e = null; null !== c;)a = c.alternate, null !== a && null === $0b2e6adb871a3b94$var$Mh(a) && (e = c), c = c.sibling;
            c = e;
            null === c ? (e = b.child, b.child = null) : (e = c.sibling, c.sibling = null);
            $0b2e6adb871a3b94$var$xj(b, !1, e, c, f);
            break;
        case "backwards":
            c = null;
            e = b.child;
            for(b.child = null; null !== e;){
                a = e.alternate;
                if (null !== a && null === $0b2e6adb871a3b94$var$Mh(a)) {
                    b.child = e;
                    break;
                }
                a = e.sibling;
                e.sibling = c;
                c = e;
                e = a;
            }
            $0b2e6adb871a3b94$var$xj(b, !0, c, null, f);
            break;
        case "together":
            $0b2e6adb871a3b94$var$xj(b, !1, null, null, void 0);
            break;
        default:
            b.memoizedState = null;
    }
    return b.child;
}
function $0b2e6adb871a3b94$var$jj(a, b) {
    0 === (b.mode & 1) && null !== a && (a.alternate = null, b.alternate = null, b.flags |= 2);
}
function $0b2e6adb871a3b94$var$$i(a, b, c) {
    null !== a && (b.dependencies = a.dependencies);
    $0b2e6adb871a3b94$var$hh |= b.lanes;
    if (0 === (c & b.childLanes)) return null;
    if (null !== a && b.child !== a.child) throw Error($0b2e6adb871a3b94$var$p(153));
    if (null !== b.child) {
        a = b.child;
        c = $0b2e6adb871a3b94$var$wh(a, a.pendingProps);
        b.child = c;
        for(c.return = b; null !== a.sibling;)a = a.sibling, c = c.sibling = $0b2e6adb871a3b94$var$wh(a, a.pendingProps), c.return = b;
        c.sibling = null;
    }
    return b.child;
}
function $0b2e6adb871a3b94$var$zj(a, b, c) {
    switch(b.tag){
        case 3:
            $0b2e6adb871a3b94$var$lj(b);
            $0b2e6adb871a3b94$var$Ig();
            break;
        case 5:
            $0b2e6adb871a3b94$var$Kh(b);
            break;
        case 1:
            $0b2e6adb871a3b94$var$Zf(b.type) && $0b2e6adb871a3b94$var$cg(b);
            break;
        case 4:
            $0b2e6adb871a3b94$var$Ih(b, b.stateNode.containerInfo);
            break;
        case 10:
            var d = b.type._context, e = b.memoizedProps.value;
            $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$Mg, d._currentValue);
            d._currentValue = e;
            break;
        case 13:
            d = b.memoizedState;
            if (null !== d) {
                if (null !== d.dehydrated) return $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$M, $0b2e6adb871a3b94$var$M.current & 1), b.flags |= 128, null;
                if (0 !== (c & b.child.childLanes)) return $0b2e6adb871a3b94$var$pj(a, b, c);
                $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$M, $0b2e6adb871a3b94$var$M.current & 1);
                a = $0b2e6adb871a3b94$var$$i(a, b, c);
                return null !== a ? a.sibling : null;
            }
            $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$M, $0b2e6adb871a3b94$var$M.current & 1);
            break;
        case 19:
            d = 0 !== (c & b.childLanes);
            if (0 !== (a.flags & 128)) {
                if (d) return $0b2e6adb871a3b94$var$yj(a, b, c);
                b.flags |= 128;
            }
            e = b.memoizedState;
            null !== e && (e.rendering = null, e.tail = null, e.lastEffect = null);
            $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$M, $0b2e6adb871a3b94$var$M.current);
            if (d) break;
            else return null;
        case 22:
        case 23:
            return b.lanes = 0, $0b2e6adb871a3b94$var$ej(a, b, c);
    }
    return $0b2e6adb871a3b94$var$$i(a, b, c);
}
var $0b2e6adb871a3b94$var$Aj, $0b2e6adb871a3b94$var$Bj, $0b2e6adb871a3b94$var$Cj, $0b2e6adb871a3b94$var$Dj;
$0b2e6adb871a3b94$var$Aj = function(a, b) {
    for(var c = b.child; null !== c;){
        if (5 === c.tag || 6 === c.tag) a.appendChild(c.stateNode);
        else if (4 !== c.tag && null !== c.child) {
            c.child.return = c;
            c = c.child;
            continue;
        }
        if (c === b) break;
        for(; null === c.sibling;){
            if (null === c.return || c.return === b) return;
            c = c.return;
        }
        c.sibling.return = c.return;
        c = c.sibling;
    }
};
$0b2e6adb871a3b94$var$Bj = function() {};
$0b2e6adb871a3b94$var$Cj = function(a, b, c, d) {
    var e = a.memoizedProps;
    if (e !== d) {
        a = b.stateNode;
        $0b2e6adb871a3b94$var$Hh($0b2e6adb871a3b94$var$Eh.current);
        var f = null;
        switch(c){
            case "input":
                e = $0b2e6adb871a3b94$var$Ya(a, e);
                d = $0b2e6adb871a3b94$var$Ya(a, d);
                f = [];
                break;
            case "select":
                e = $0b2e6adb871a3b94$var$A({}, e, {
                    value: void 0
                });
                d = $0b2e6adb871a3b94$var$A({}, d, {
                    value: void 0
                });
                f = [];
                break;
            case "textarea":
                e = $0b2e6adb871a3b94$var$gb(a, e);
                d = $0b2e6adb871a3b94$var$gb(a, d);
                f = [];
                break;
            default:
                "function" !== typeof e.onClick && "function" === typeof d.onClick && (a.onclick = $0b2e6adb871a3b94$var$Bf);
        }
        $0b2e6adb871a3b94$var$ub(c, d);
        var g;
        c = null;
        for(l in e)if (!d.hasOwnProperty(l) && e.hasOwnProperty(l) && null != e[l]) {
            if ("style" === l) {
                var h = e[l];
                for(g in h)h.hasOwnProperty(g) && (c || (c = {}), c[g] = "");
            } else "dangerouslySetInnerHTML" !== l && "children" !== l && "suppressContentEditableWarning" !== l && "suppressHydrationWarning" !== l && "autoFocus" !== l && ($0b2e6adb871a3b94$var$ea.hasOwnProperty(l) ? f || (f = []) : (f = f || []).push(l, null));
        }
        for(l in d){
            var k = d[l];
            h = null != e ? e[l] : void 0;
            if (d.hasOwnProperty(l) && k !== h && (null != k || null != h)) {
                if ("style" === l) {
                    if (h) {
                        for(g in h)!h.hasOwnProperty(g) || k && k.hasOwnProperty(g) || (c || (c = {}), c[g] = "");
                        for(g in k)k.hasOwnProperty(g) && h[g] !== k[g] && (c || (c = {}), c[g] = k[g]);
                    } else c || (f || (f = []), f.push(l, c)), c = k;
                } else "dangerouslySetInnerHTML" === l ? (k = k ? k.__html : void 0, h = h ? h.__html : void 0, null != k && h !== k && (f = f || []).push(l, k)) : "children" === l ? "string" !== typeof k && "number" !== typeof k || (f = f || []).push(l, "" + k) : "suppressContentEditableWarning" !== l && "suppressHydrationWarning" !== l && ($0b2e6adb871a3b94$var$ea.hasOwnProperty(l) ? (null != k && "onScroll" === l && $0b2e6adb871a3b94$var$D("scroll", a), f || h === k || (f = [])) : (f = f || []).push(l, k));
            }
        }
        c && (f = f || []).push("style", c);
        var l = f;
        if (b.updateQueue = l) b.flags |= 4;
    }
};
$0b2e6adb871a3b94$var$Dj = function(a, b, c, d) {
    c !== d && (b.flags |= 4);
};
function $0b2e6adb871a3b94$var$Ej(a, b) {
    if (!$0b2e6adb871a3b94$var$I) switch(a.tailMode){
        case "hidden":
            b = a.tail;
            for(var c = null; null !== b;)null !== b.alternate && (c = b), b = b.sibling;
            null === c ? a.tail = null : c.sibling = null;
            break;
        case "collapsed":
            c = a.tail;
            for(var d = null; null !== c;)null !== c.alternate && (d = c), c = c.sibling;
            null === d ? b || null === a.tail ? a.tail = null : a.tail.sibling = null : d.sibling = null;
    }
}
function $0b2e6adb871a3b94$var$S(a) {
    var b = null !== a.alternate && a.alternate.child === a.child, c = 0, d = 0;
    if (b) for(var e = a.child; null !== e;)c |= e.lanes | e.childLanes, d |= e.subtreeFlags & 14680064, d |= e.flags & 14680064, e.return = a, e = e.sibling;
    else for(e = a.child; null !== e;)c |= e.lanes | e.childLanes, d |= e.subtreeFlags, d |= e.flags, e.return = a, e = e.sibling;
    a.subtreeFlags |= d;
    a.childLanes = c;
    return b;
}
function $0b2e6adb871a3b94$var$Fj(a, b, c) {
    var d = b.pendingProps;
    $0b2e6adb871a3b94$var$wg(b);
    switch(b.tag){
        case 2:
        case 16:
        case 15:
        case 0:
        case 11:
        case 7:
        case 8:
        case 12:
        case 9:
        case 14:
            return $0b2e6adb871a3b94$var$S(b), null;
        case 1:
            return $0b2e6adb871a3b94$var$Zf(b.type) && $0b2e6adb871a3b94$var$$f(), $0b2e6adb871a3b94$var$S(b), null;
        case 3:
            d = b.stateNode;
            $0b2e6adb871a3b94$var$Jh();
            $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$Wf);
            $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$H);
            $0b2e6adb871a3b94$var$Oh();
            d.pendingContext && (d.context = d.pendingContext, d.pendingContext = null);
            if (null === a || null === a.child) $0b2e6adb871a3b94$var$Gg(b) ? b.flags |= 4 : null === a || a.memoizedState.isDehydrated && 0 === (b.flags & 256) || (b.flags |= 1024, null !== $0b2e6adb871a3b94$var$zg && ($0b2e6adb871a3b94$var$Gj($0b2e6adb871a3b94$var$zg), $0b2e6adb871a3b94$var$zg = null));
            $0b2e6adb871a3b94$var$Bj(a, b);
            $0b2e6adb871a3b94$var$S(b);
            return null;
        case 5:
            $0b2e6adb871a3b94$var$Lh(b);
            var e = $0b2e6adb871a3b94$var$Hh($0b2e6adb871a3b94$var$Gh.current);
            c = b.type;
            if (null !== a && null != b.stateNode) $0b2e6adb871a3b94$var$Cj(a, b, c, d, e), a.ref !== b.ref && (b.flags |= 512, b.flags |= 2097152);
            else {
                if (!d) {
                    if (null === b.stateNode) throw Error($0b2e6adb871a3b94$var$p(166));
                    $0b2e6adb871a3b94$var$S(b);
                    return null;
                }
                a = $0b2e6adb871a3b94$var$Hh($0b2e6adb871a3b94$var$Eh.current);
                if ($0b2e6adb871a3b94$var$Gg(b)) {
                    d = b.stateNode;
                    c = b.type;
                    var f = b.memoizedProps;
                    d[$0b2e6adb871a3b94$var$Of] = b;
                    d[$0b2e6adb871a3b94$var$Pf] = f;
                    a = 0 !== (b.mode & 1);
                    switch(c){
                        case "dialog":
                            $0b2e6adb871a3b94$var$D("cancel", d);
                            $0b2e6adb871a3b94$var$D("close", d);
                            break;
                        case "iframe":
                        case "object":
                        case "embed":
                            $0b2e6adb871a3b94$var$D("load", d);
                            break;
                        case "video":
                        case "audio":
                            for(e = 0; e < $0b2e6adb871a3b94$var$lf.length; e++)$0b2e6adb871a3b94$var$D($0b2e6adb871a3b94$var$lf[e], d);
                            break;
                        case "source":
                            $0b2e6adb871a3b94$var$D("error", d);
                            break;
                        case "img":
                        case "image":
                        case "link":
                            $0b2e6adb871a3b94$var$D("error", d);
                            $0b2e6adb871a3b94$var$D("load", d);
                            break;
                        case "details":
                            $0b2e6adb871a3b94$var$D("toggle", d);
                            break;
                        case "input":
                            $0b2e6adb871a3b94$var$Za(d, f);
                            $0b2e6adb871a3b94$var$D("invalid", d);
                            break;
                        case "select":
                            d._wrapperState = {
                                wasMultiple: !!f.multiple
                            };
                            $0b2e6adb871a3b94$var$D("invalid", d);
                            break;
                        case "textarea":
                            $0b2e6adb871a3b94$var$hb(d, f), $0b2e6adb871a3b94$var$D("invalid", d);
                    }
                    $0b2e6adb871a3b94$var$ub(c, f);
                    e = null;
                    for(var g in f)if (f.hasOwnProperty(g)) {
                        var h = f[g];
                        "children" === g ? "string" === typeof h ? d.textContent !== h && (!0 !== f.suppressHydrationWarning && $0b2e6adb871a3b94$var$Af(d.textContent, h, a), e = [
                            "children",
                            h
                        ]) : "number" === typeof h && d.textContent !== "" + h && (!0 !== f.suppressHydrationWarning && $0b2e6adb871a3b94$var$Af(d.textContent, h, a), e = [
                            "children",
                            "" + h
                        ]) : $0b2e6adb871a3b94$var$ea.hasOwnProperty(g) && null != h && "onScroll" === g && $0b2e6adb871a3b94$var$D("scroll", d);
                    }
                    switch(c){
                        case "input":
                            $0b2e6adb871a3b94$var$Va(d);
                            $0b2e6adb871a3b94$var$db(d, f, !0);
                            break;
                        case "textarea":
                            $0b2e6adb871a3b94$var$Va(d);
                            $0b2e6adb871a3b94$var$jb(d);
                            break;
                        case "select":
                        case "option":
                            break;
                        default:
                            "function" === typeof f.onClick && (d.onclick = $0b2e6adb871a3b94$var$Bf);
                    }
                    d = e;
                    b.updateQueue = d;
                    null !== d && (b.flags |= 4);
                } else {
                    g = 9 === e.nodeType ? e : e.ownerDocument;
                    "http://www.w3.org/1999/xhtml" === a && (a = $0b2e6adb871a3b94$var$kb(c));
                    "http://www.w3.org/1999/xhtml" === a ? "script" === c ? (a = g.createElement("div"), a.innerHTML = "<script></script>", a = a.removeChild(a.firstChild)) : "string" === typeof d.is ? a = g.createElement(c, {
                        is: d.is
                    }) : (a = g.createElement(c), "select" === c && (g = a, d.multiple ? g.multiple = !0 : d.size && (g.size = d.size))) : a = g.createElementNS(a, c);
                    a[$0b2e6adb871a3b94$var$Of] = b;
                    a[$0b2e6adb871a3b94$var$Pf] = d;
                    $0b2e6adb871a3b94$var$Aj(a, b, !1, !1);
                    b.stateNode = a;
                    a: {
                        g = $0b2e6adb871a3b94$var$vb(c, d);
                        switch(c){
                            case "dialog":
                                $0b2e6adb871a3b94$var$D("cancel", a);
                                $0b2e6adb871a3b94$var$D("close", a);
                                e = d;
                                break;
                            case "iframe":
                            case "object":
                            case "embed":
                                $0b2e6adb871a3b94$var$D("load", a);
                                e = d;
                                break;
                            case "video":
                            case "audio":
                                for(e = 0; e < $0b2e6adb871a3b94$var$lf.length; e++)$0b2e6adb871a3b94$var$D($0b2e6adb871a3b94$var$lf[e], a);
                                e = d;
                                break;
                            case "source":
                                $0b2e6adb871a3b94$var$D("error", a);
                                e = d;
                                break;
                            case "img":
                            case "image":
                            case "link":
                                $0b2e6adb871a3b94$var$D("error", a);
                                $0b2e6adb871a3b94$var$D("load", a);
                                e = d;
                                break;
                            case "details":
                                $0b2e6adb871a3b94$var$D("toggle", a);
                                e = d;
                                break;
                            case "input":
                                $0b2e6adb871a3b94$var$Za(a, d);
                                e = $0b2e6adb871a3b94$var$Ya(a, d);
                                $0b2e6adb871a3b94$var$D("invalid", a);
                                break;
                            case "option":
                                e = d;
                                break;
                            case "select":
                                a._wrapperState = {
                                    wasMultiple: !!d.multiple
                                };
                                e = $0b2e6adb871a3b94$var$A({}, d, {
                                    value: void 0
                                });
                                $0b2e6adb871a3b94$var$D("invalid", a);
                                break;
                            case "textarea":
                                $0b2e6adb871a3b94$var$hb(a, d);
                                e = $0b2e6adb871a3b94$var$gb(a, d);
                                $0b2e6adb871a3b94$var$D("invalid", a);
                                break;
                            default:
                                e = d;
                        }
                        $0b2e6adb871a3b94$var$ub(c, e);
                        h = e;
                        for(f in h)if (h.hasOwnProperty(f)) {
                            var k = h[f];
                            "style" === f ? $0b2e6adb871a3b94$var$sb(a, k) : "dangerouslySetInnerHTML" === f ? (k = k ? k.__html : void 0, null != k && $0b2e6adb871a3b94$var$nb(a, k)) : "children" === f ? "string" === typeof k ? ("textarea" !== c || "" !== k) && $0b2e6adb871a3b94$var$ob(a, k) : "number" === typeof k && $0b2e6adb871a3b94$var$ob(a, "" + k) : "suppressContentEditableWarning" !== f && "suppressHydrationWarning" !== f && "autoFocus" !== f && ($0b2e6adb871a3b94$var$ea.hasOwnProperty(f) ? null != k && "onScroll" === f && $0b2e6adb871a3b94$var$D("scroll", a) : null != k && $0b2e6adb871a3b94$var$ta(a, f, k, g));
                        }
                        switch(c){
                            case "input":
                                $0b2e6adb871a3b94$var$Va(a);
                                $0b2e6adb871a3b94$var$db(a, d, !1);
                                break;
                            case "textarea":
                                $0b2e6adb871a3b94$var$Va(a);
                                $0b2e6adb871a3b94$var$jb(a);
                                break;
                            case "option":
                                null != d.value && a.setAttribute("value", "" + $0b2e6adb871a3b94$var$Sa(d.value));
                                break;
                            case "select":
                                a.multiple = !!d.multiple;
                                f = d.value;
                                null != f ? $0b2e6adb871a3b94$var$fb(a, !!d.multiple, f, !1) : null != d.defaultValue && $0b2e6adb871a3b94$var$fb(a, !!d.multiple, d.defaultValue, !0);
                                break;
                            default:
                                "function" === typeof e.onClick && (a.onclick = $0b2e6adb871a3b94$var$Bf);
                        }
                        switch(c){
                            case "button":
                            case "input":
                            case "select":
                            case "textarea":
                                d = !!d.autoFocus;
                                break a;
                            case "img":
                                d = !0;
                                break a;
                            default:
                                d = !1;
                        }
                    }
                    d && (b.flags |= 4);
                }
                null !== b.ref && (b.flags |= 512, b.flags |= 2097152);
            }
            $0b2e6adb871a3b94$var$S(b);
            return null;
        case 6:
            if (a && null != b.stateNode) $0b2e6adb871a3b94$var$Dj(a, b, a.memoizedProps, d);
            else {
                if ("string" !== typeof d && null === b.stateNode) throw Error($0b2e6adb871a3b94$var$p(166));
                c = $0b2e6adb871a3b94$var$Hh($0b2e6adb871a3b94$var$Gh.current);
                $0b2e6adb871a3b94$var$Hh($0b2e6adb871a3b94$var$Eh.current);
                if ($0b2e6adb871a3b94$var$Gg(b)) {
                    d = b.stateNode;
                    c = b.memoizedProps;
                    d[$0b2e6adb871a3b94$var$Of] = b;
                    if (f = d.nodeValue !== c) {
                        if (a = $0b2e6adb871a3b94$var$xg, null !== a) switch(a.tag){
                            case 3:
                                $0b2e6adb871a3b94$var$Af(d.nodeValue, c, 0 !== (a.mode & 1));
                                break;
                            case 5:
                                !0 !== a.memoizedProps.suppressHydrationWarning && $0b2e6adb871a3b94$var$Af(d.nodeValue, c, 0 !== (a.mode & 1));
                        }
                    }
                    f && (b.flags |= 4);
                } else d = (9 === c.nodeType ? c : c.ownerDocument).createTextNode(d), d[$0b2e6adb871a3b94$var$Of] = b, b.stateNode = d;
            }
            $0b2e6adb871a3b94$var$S(b);
            return null;
        case 13:
            $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$M);
            d = b.memoizedState;
            if (null === a || null !== a.memoizedState && null !== a.memoizedState.dehydrated) {
                if ($0b2e6adb871a3b94$var$I && null !== $0b2e6adb871a3b94$var$yg && 0 !== (b.mode & 1) && 0 === (b.flags & 128)) $0b2e6adb871a3b94$var$Hg(), $0b2e6adb871a3b94$var$Ig(), b.flags |= 98560, f = !1;
                else if (f = $0b2e6adb871a3b94$var$Gg(b), null !== d && null !== d.dehydrated) {
                    if (null === a) {
                        if (!f) throw Error($0b2e6adb871a3b94$var$p(318));
                        f = b.memoizedState;
                        f = null !== f ? f.dehydrated : null;
                        if (!f) throw Error($0b2e6adb871a3b94$var$p(317));
                        f[$0b2e6adb871a3b94$var$Of] = b;
                    } else $0b2e6adb871a3b94$var$Ig(), 0 === (b.flags & 128) && (b.memoizedState = null), b.flags |= 4;
                    $0b2e6adb871a3b94$var$S(b);
                    f = !1;
                } else null !== $0b2e6adb871a3b94$var$zg && ($0b2e6adb871a3b94$var$Gj($0b2e6adb871a3b94$var$zg), $0b2e6adb871a3b94$var$zg = null), f = !0;
                if (!f) return b.flags & 65536 ? b : null;
            }
            if (0 !== (b.flags & 128)) return b.lanes = c, b;
            d = null !== d;
            d !== (null !== a && null !== a.memoizedState) && d && (b.child.flags |= 8192, 0 !== (b.mode & 1) && (null === a || 0 !== ($0b2e6adb871a3b94$var$M.current & 1) ? 0 === $0b2e6adb871a3b94$var$T && ($0b2e6adb871a3b94$var$T = 3) : $0b2e6adb871a3b94$var$uj()));
            null !== b.updateQueue && (b.flags |= 4);
            $0b2e6adb871a3b94$var$S(b);
            return null;
        case 4:
            return $0b2e6adb871a3b94$var$Jh(), $0b2e6adb871a3b94$var$Bj(a, b), null === a && $0b2e6adb871a3b94$var$sf(b.stateNode.containerInfo), $0b2e6adb871a3b94$var$S(b), null;
        case 10:
            return $0b2e6adb871a3b94$var$Rg(b.type._context), $0b2e6adb871a3b94$var$S(b), null;
        case 17:
            return $0b2e6adb871a3b94$var$Zf(b.type) && $0b2e6adb871a3b94$var$$f(), $0b2e6adb871a3b94$var$S(b), null;
        case 19:
            $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$M);
            f = b.memoizedState;
            if (null === f) return $0b2e6adb871a3b94$var$S(b), null;
            d = 0 !== (b.flags & 128);
            g = f.rendering;
            if (null === g) {
                if (d) $0b2e6adb871a3b94$var$Ej(f, !1);
                else {
                    if (0 !== $0b2e6adb871a3b94$var$T || null !== a && 0 !== (a.flags & 128)) for(a = b.child; null !== a;){
                        g = $0b2e6adb871a3b94$var$Mh(a);
                        if (null !== g) {
                            b.flags |= 128;
                            $0b2e6adb871a3b94$var$Ej(f, !1);
                            d = g.updateQueue;
                            null !== d && (b.updateQueue = d, b.flags |= 4);
                            b.subtreeFlags = 0;
                            d = c;
                            for(c = b.child; null !== c;)f = c, a = d, f.flags &= 14680066, g = f.alternate, null === g ? (f.childLanes = 0, f.lanes = a, f.child = null, f.subtreeFlags = 0, f.memoizedProps = null, f.memoizedState = null, f.updateQueue = null, f.dependencies = null, f.stateNode = null) : (f.childLanes = g.childLanes, f.lanes = g.lanes, f.child = g.child, f.subtreeFlags = 0, f.deletions = null, f.memoizedProps = g.memoizedProps, f.memoizedState = g.memoizedState, f.updateQueue = g.updateQueue, f.type = g.type, a = g.dependencies, f.dependencies = null === a ? null : {
                                lanes: a.lanes,
                                firstContext: a.firstContext
                            }), c = c.sibling;
                            $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$M, $0b2e6adb871a3b94$var$M.current & 1 | 2);
                            return b.child;
                        }
                        a = a.sibling;
                    }
                    null !== f.tail && $0b2e6adb871a3b94$var$B() > $0b2e6adb871a3b94$var$Hj && (b.flags |= 128, d = !0, $0b2e6adb871a3b94$var$Ej(f, !1), b.lanes = 4194304);
                }
            } else {
                if (!d) {
                    if (a = $0b2e6adb871a3b94$var$Mh(g), null !== a) {
                        if (b.flags |= 128, d = !0, c = a.updateQueue, null !== c && (b.updateQueue = c, b.flags |= 4), $0b2e6adb871a3b94$var$Ej(f, !0), null === f.tail && "hidden" === f.tailMode && !g.alternate && !$0b2e6adb871a3b94$var$I) return $0b2e6adb871a3b94$var$S(b), null;
                    } else 2 * $0b2e6adb871a3b94$var$B() - f.renderingStartTime > $0b2e6adb871a3b94$var$Hj && 1073741824 !== c && (b.flags |= 128, d = !0, $0b2e6adb871a3b94$var$Ej(f, !1), b.lanes = 4194304);
                }
                f.isBackwards ? (g.sibling = b.child, b.child = g) : (c = f.last, null !== c ? c.sibling = g : b.child = g, f.last = g);
            }
            if (null !== f.tail) return b = f.tail, f.rendering = b, f.tail = b.sibling, f.renderingStartTime = $0b2e6adb871a3b94$var$B(), b.sibling = null, c = $0b2e6adb871a3b94$var$M.current, $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$M, d ? c & 1 | 2 : c & 1), b;
            $0b2e6adb871a3b94$var$S(b);
            return null;
        case 22:
        case 23:
            return $0b2e6adb871a3b94$var$Ij(), d = null !== b.memoizedState, null !== a && null !== a.memoizedState !== d && (b.flags |= 8192), d && 0 !== (b.mode & 1) ? 0 !== ($0b2e6adb871a3b94$var$gj & 1073741824) && ($0b2e6adb871a3b94$var$S(b), b.subtreeFlags & 6 && (b.flags |= 8192)) : $0b2e6adb871a3b94$var$S(b), null;
        case 24:
            return null;
        case 25:
            return null;
    }
    throw Error($0b2e6adb871a3b94$var$p(156, b.tag));
}
function $0b2e6adb871a3b94$var$Jj(a, b) {
    $0b2e6adb871a3b94$var$wg(b);
    switch(b.tag){
        case 1:
            return $0b2e6adb871a3b94$var$Zf(b.type) && $0b2e6adb871a3b94$var$$f(), a = b.flags, a & 65536 ? (b.flags = a & -65537 | 128, b) : null;
        case 3:
            return $0b2e6adb871a3b94$var$Jh(), $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$Wf), $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$H), $0b2e6adb871a3b94$var$Oh(), a = b.flags, 0 !== (a & 65536) && 0 === (a & 128) ? (b.flags = a & -65537 | 128, b) : null;
        case 5:
            return $0b2e6adb871a3b94$var$Lh(b), null;
        case 13:
            $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$M);
            a = b.memoizedState;
            if (null !== a && null !== a.dehydrated) {
                if (null === b.alternate) throw Error($0b2e6adb871a3b94$var$p(340));
                $0b2e6adb871a3b94$var$Ig();
            }
            a = b.flags;
            return a & 65536 ? (b.flags = a & -65537 | 128, b) : null;
        case 19:
            return $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$M), null;
        case 4:
            return $0b2e6adb871a3b94$var$Jh(), null;
        case 10:
            return $0b2e6adb871a3b94$var$Rg(b.type._context), null;
        case 22:
        case 23:
            return $0b2e6adb871a3b94$var$Ij(), null;
        case 24:
            return null;
        default:
            return null;
    }
}
var $0b2e6adb871a3b94$var$Kj = !1, $0b2e6adb871a3b94$var$U = !1, $0b2e6adb871a3b94$var$Lj = "function" === typeof WeakSet ? WeakSet : Set, $0b2e6adb871a3b94$var$V = null;
function $0b2e6adb871a3b94$var$Mj(a, b) {
    var c = a.ref;
    if (null !== c) {
        if ("function" === typeof c) try {
            c(null);
        } catch (d) {
            $0b2e6adb871a3b94$var$W(a, b, d);
        }
        else c.current = null;
    }
}
function $0b2e6adb871a3b94$var$Nj(a, b, c) {
    try {
        c();
    } catch (d) {
        $0b2e6adb871a3b94$var$W(a, b, d);
    }
}
var $0b2e6adb871a3b94$var$Oj = !1;
function $0b2e6adb871a3b94$var$Pj(a, b) {
    $0b2e6adb871a3b94$var$Cf = $0b2e6adb871a3b94$var$dd;
    a = $0b2e6adb871a3b94$var$Me();
    if ($0b2e6adb871a3b94$var$Ne(a)) {
        if ("selectionStart" in a) var c = {
            start: a.selectionStart,
            end: a.selectionEnd
        };
        else a: {
            c = (c = a.ownerDocument) && c.defaultView || window;
            var d = c.getSelection && c.getSelection();
            if (d && 0 !== d.rangeCount) {
                c = d.anchorNode;
                var e = d.anchorOffset, f = d.focusNode;
                d = d.focusOffset;
                try {
                    c.nodeType, f.nodeType;
                } catch (F) {
                    c = null;
                    break a;
                }
                var g = 0, h = -1, k = -1, l = 0, m = 0, q = a, r = null;
                b: for(;;){
                    for(var y;;){
                        q !== c || 0 !== e && 3 !== q.nodeType || (h = g + e);
                        q !== f || 0 !== d && 3 !== q.nodeType || (k = g + d);
                        3 === q.nodeType && (g += q.nodeValue.length);
                        if (null === (y = q.firstChild)) break;
                        r = q;
                        q = y;
                    }
                    for(;;){
                        if (q === a) break b;
                        r === c && ++l === e && (h = g);
                        r === f && ++m === d && (k = g);
                        if (null !== (y = q.nextSibling)) break;
                        q = r;
                        r = q.parentNode;
                    }
                    q = y;
                }
                c = -1 === h || -1 === k ? null : {
                    start: h,
                    end: k
                };
            } else c = null;
        }
        c = c || {
            start: 0,
            end: 0
        };
    } else c = null;
    $0b2e6adb871a3b94$var$Df = {
        focusedElem: a,
        selectionRange: c
    };
    $0b2e6adb871a3b94$var$dd = !1;
    for($0b2e6adb871a3b94$var$V = b; null !== $0b2e6adb871a3b94$var$V;)if (b = $0b2e6adb871a3b94$var$V, a = b.child, 0 !== (b.subtreeFlags & 1028) && null !== a) a.return = b, $0b2e6adb871a3b94$var$V = a;
    else for(; null !== $0b2e6adb871a3b94$var$V;){
        b = $0b2e6adb871a3b94$var$V;
        try {
            var n = b.alternate;
            if (0 !== (b.flags & 1024)) switch(b.tag){
                case 0:
                case 11:
                case 15:
                    break;
                case 1:
                    if (null !== n) {
                        var t = n.memoizedProps, J = n.memoizedState, x = b.stateNode, w = x.getSnapshotBeforeUpdate(b.elementType === b.type ? t : $0b2e6adb871a3b94$var$Lg(b.type, t), J);
                        x.__reactInternalSnapshotBeforeUpdate = w;
                    }
                    break;
                case 3:
                    var u = b.stateNode.containerInfo;
                    1 === u.nodeType ? u.textContent = "" : 9 === u.nodeType && u.documentElement && u.removeChild(u.documentElement);
                    break;
                case 5:
                case 6:
                case 4:
                case 17:
                    break;
                default:
                    throw Error($0b2e6adb871a3b94$var$p(163));
            }
        } catch (F) {
            $0b2e6adb871a3b94$var$W(b, b.return, F);
        }
        a = b.sibling;
        if (null !== a) {
            a.return = b.return;
            $0b2e6adb871a3b94$var$V = a;
            break;
        }
        $0b2e6adb871a3b94$var$V = b.return;
    }
    n = $0b2e6adb871a3b94$var$Oj;
    $0b2e6adb871a3b94$var$Oj = !1;
    return n;
}
function $0b2e6adb871a3b94$var$Qj(a, b, c) {
    var d = b.updateQueue;
    d = null !== d ? d.lastEffect : null;
    if (null !== d) {
        var e = d = d.next;
        do {
            if ((e.tag & a) === a) {
                var f = e.destroy;
                e.destroy = void 0;
                void 0 !== f && $0b2e6adb871a3b94$var$Nj(b, c, f);
            }
            e = e.next;
        }while (e !== d);
    }
}
function $0b2e6adb871a3b94$var$Rj(a, b) {
    b = b.updateQueue;
    b = null !== b ? b.lastEffect : null;
    if (null !== b) {
        var c = b = b.next;
        do {
            if ((c.tag & a) === a) {
                var d = c.create;
                c.destroy = d();
            }
            c = c.next;
        }while (c !== b);
    }
}
function $0b2e6adb871a3b94$var$Sj(a) {
    var b = a.ref;
    if (null !== b) {
        var c = a.stateNode;
        switch(a.tag){
            case 5:
                a = c;
                break;
            default:
                a = c;
        }
        "function" === typeof b ? b(a) : b.current = a;
    }
}
function $0b2e6adb871a3b94$var$Tj(a) {
    var b = a.alternate;
    null !== b && (a.alternate = null, $0b2e6adb871a3b94$var$Tj(b));
    a.child = null;
    a.deletions = null;
    a.sibling = null;
    5 === a.tag && (b = a.stateNode, null !== b && (delete b[$0b2e6adb871a3b94$var$Of], delete b[$0b2e6adb871a3b94$var$Pf], delete b[$0b2e6adb871a3b94$var$of], delete b[$0b2e6adb871a3b94$var$Qf], delete b[$0b2e6adb871a3b94$var$Rf]));
    a.stateNode = null;
    a.return = null;
    a.dependencies = null;
    a.memoizedProps = null;
    a.memoizedState = null;
    a.pendingProps = null;
    a.stateNode = null;
    a.updateQueue = null;
}
function $0b2e6adb871a3b94$var$Uj(a) {
    return 5 === a.tag || 3 === a.tag || 4 === a.tag;
}
function $0b2e6adb871a3b94$var$Vj(a) {
    a: for(;;){
        for(; null === a.sibling;){
            if (null === a.return || $0b2e6adb871a3b94$var$Uj(a.return)) return null;
            a = a.return;
        }
        a.sibling.return = a.return;
        for(a = a.sibling; 5 !== a.tag && 6 !== a.tag && 18 !== a.tag;){
            if (a.flags & 2) continue a;
            if (null === a.child || 4 === a.tag) continue a;
            else a.child.return = a, a = a.child;
        }
        if (!(a.flags & 2)) return a.stateNode;
    }
}
function $0b2e6adb871a3b94$var$Wj(a, b, c) {
    var d = a.tag;
    if (5 === d || 6 === d) a = a.stateNode, b ? 8 === c.nodeType ? c.parentNode.insertBefore(a, b) : c.insertBefore(a, b) : (8 === c.nodeType ? (b = c.parentNode, b.insertBefore(a, c)) : (b = c, b.appendChild(a)), c = c._reactRootContainer, null !== c && void 0 !== c || null !== b.onclick || (b.onclick = $0b2e6adb871a3b94$var$Bf));
    else if (4 !== d && (a = a.child, null !== a)) for($0b2e6adb871a3b94$var$Wj(a, b, c), a = a.sibling; null !== a;)$0b2e6adb871a3b94$var$Wj(a, b, c), a = a.sibling;
}
function $0b2e6adb871a3b94$var$Xj(a, b, c) {
    var d = a.tag;
    if (5 === d || 6 === d) a = a.stateNode, b ? c.insertBefore(a, b) : c.appendChild(a);
    else if (4 !== d && (a = a.child, null !== a)) for($0b2e6adb871a3b94$var$Xj(a, b, c), a = a.sibling; null !== a;)$0b2e6adb871a3b94$var$Xj(a, b, c), a = a.sibling;
}
var $0b2e6adb871a3b94$var$X = null, $0b2e6adb871a3b94$var$Yj = !1;
function $0b2e6adb871a3b94$var$Zj(a, b, c) {
    for(c = c.child; null !== c;)$0b2e6adb871a3b94$var$ak(a, b, c), c = c.sibling;
}
function $0b2e6adb871a3b94$var$ak(a, b, c) {
    if ($0b2e6adb871a3b94$var$lc && "function" === typeof $0b2e6adb871a3b94$var$lc.onCommitFiberUnmount) try {
        $0b2e6adb871a3b94$var$lc.onCommitFiberUnmount($0b2e6adb871a3b94$var$kc, c);
    } catch (h) {}
    switch(c.tag){
        case 5:
            $0b2e6adb871a3b94$var$U || $0b2e6adb871a3b94$var$Mj(c, b);
        case 6:
            var d = $0b2e6adb871a3b94$var$X, e = $0b2e6adb871a3b94$var$Yj;
            $0b2e6adb871a3b94$var$X = null;
            $0b2e6adb871a3b94$var$Zj(a, b, c);
            $0b2e6adb871a3b94$var$X = d;
            $0b2e6adb871a3b94$var$Yj = e;
            null !== $0b2e6adb871a3b94$var$X && ($0b2e6adb871a3b94$var$Yj ? (a = $0b2e6adb871a3b94$var$X, c = c.stateNode, 8 === a.nodeType ? a.parentNode.removeChild(c) : a.removeChild(c)) : $0b2e6adb871a3b94$var$X.removeChild(c.stateNode));
            break;
        case 18:
            null !== $0b2e6adb871a3b94$var$X && ($0b2e6adb871a3b94$var$Yj ? (a = $0b2e6adb871a3b94$var$X, c = c.stateNode, 8 === a.nodeType ? $0b2e6adb871a3b94$var$Kf(a.parentNode, c) : 1 === a.nodeType && $0b2e6adb871a3b94$var$Kf(a, c), $0b2e6adb871a3b94$var$bd(a)) : $0b2e6adb871a3b94$var$Kf($0b2e6adb871a3b94$var$X, c.stateNode));
            break;
        case 4:
            d = $0b2e6adb871a3b94$var$X;
            e = $0b2e6adb871a3b94$var$Yj;
            $0b2e6adb871a3b94$var$X = c.stateNode.containerInfo;
            $0b2e6adb871a3b94$var$Yj = !0;
            $0b2e6adb871a3b94$var$Zj(a, b, c);
            $0b2e6adb871a3b94$var$X = d;
            $0b2e6adb871a3b94$var$Yj = e;
            break;
        case 0:
        case 11:
        case 14:
        case 15:
            if (!$0b2e6adb871a3b94$var$U && (d = c.updateQueue, null !== d && (d = d.lastEffect, null !== d))) {
                e = d = d.next;
                do {
                    var f = e, g = f.destroy;
                    f = f.tag;
                    void 0 !== g && (0 !== (f & 2) ? $0b2e6adb871a3b94$var$Nj(c, b, g) : 0 !== (f & 4) && $0b2e6adb871a3b94$var$Nj(c, b, g));
                    e = e.next;
                }while (e !== d);
            }
            $0b2e6adb871a3b94$var$Zj(a, b, c);
            break;
        case 1:
            if (!$0b2e6adb871a3b94$var$U && ($0b2e6adb871a3b94$var$Mj(c, b), d = c.stateNode, "function" === typeof d.componentWillUnmount)) try {
                d.props = c.memoizedProps, d.state = c.memoizedState, d.componentWillUnmount();
            } catch (h) {
                $0b2e6adb871a3b94$var$W(c, b, h);
            }
            $0b2e6adb871a3b94$var$Zj(a, b, c);
            break;
        case 21:
            $0b2e6adb871a3b94$var$Zj(a, b, c);
            break;
        case 22:
            c.mode & 1 ? ($0b2e6adb871a3b94$var$U = (d = $0b2e6adb871a3b94$var$U) || null !== c.memoizedState, $0b2e6adb871a3b94$var$Zj(a, b, c), $0b2e6adb871a3b94$var$U = d) : $0b2e6adb871a3b94$var$Zj(a, b, c);
            break;
        default:
            $0b2e6adb871a3b94$var$Zj(a, b, c);
    }
}
function $0b2e6adb871a3b94$var$bk(a) {
    var b = a.updateQueue;
    if (null !== b) {
        a.updateQueue = null;
        var c = a.stateNode;
        null === c && (c = a.stateNode = new $0b2e6adb871a3b94$var$Lj);
        b.forEach(function(b) {
            var d = $0b2e6adb871a3b94$var$ck.bind(null, a, b);
            c.has(b) || (c.add(b), b.then(d, d));
        });
    }
}
function $0b2e6adb871a3b94$var$dk(a, b) {
    var c = b.deletions;
    if (null !== c) for(var d = 0; d < c.length; d++){
        var e = c[d];
        try {
            var f = a, g = b, h = g;
            a: for(; null !== h;){
                switch(h.tag){
                    case 5:
                        $0b2e6adb871a3b94$var$X = h.stateNode;
                        $0b2e6adb871a3b94$var$Yj = !1;
                        break a;
                    case 3:
                        $0b2e6adb871a3b94$var$X = h.stateNode.containerInfo;
                        $0b2e6adb871a3b94$var$Yj = !0;
                        break a;
                    case 4:
                        $0b2e6adb871a3b94$var$X = h.stateNode.containerInfo;
                        $0b2e6adb871a3b94$var$Yj = !0;
                        break a;
                }
                h = h.return;
            }
            if (null === $0b2e6adb871a3b94$var$X) throw Error($0b2e6adb871a3b94$var$p(160));
            $0b2e6adb871a3b94$var$ak(f, g, e);
            $0b2e6adb871a3b94$var$X = null;
            $0b2e6adb871a3b94$var$Yj = !1;
            var k = e.alternate;
            null !== k && (k.return = null);
            e.return = null;
        } catch (l) {
            $0b2e6adb871a3b94$var$W(e, b, l);
        }
    }
    if (b.subtreeFlags & 12854) for(b = b.child; null !== b;)$0b2e6adb871a3b94$var$ek(b, a), b = b.sibling;
}
function $0b2e6adb871a3b94$var$ek(a, b) {
    var c = a.alternate, d = a.flags;
    switch(a.tag){
        case 0:
        case 11:
        case 14:
        case 15:
            $0b2e6adb871a3b94$var$dk(b, a);
            $0b2e6adb871a3b94$var$fk(a);
            if (d & 4) {
                try {
                    $0b2e6adb871a3b94$var$Qj(3, a, a.return), $0b2e6adb871a3b94$var$Rj(3, a);
                } catch (t) {
                    $0b2e6adb871a3b94$var$W(a, a.return, t);
                }
                try {
                    $0b2e6adb871a3b94$var$Qj(5, a, a.return);
                } catch (t) {
                    $0b2e6adb871a3b94$var$W(a, a.return, t);
                }
            }
            break;
        case 1:
            $0b2e6adb871a3b94$var$dk(b, a);
            $0b2e6adb871a3b94$var$fk(a);
            d & 512 && null !== c && $0b2e6adb871a3b94$var$Mj(c, c.return);
            break;
        case 5:
            $0b2e6adb871a3b94$var$dk(b, a);
            $0b2e6adb871a3b94$var$fk(a);
            d & 512 && null !== c && $0b2e6adb871a3b94$var$Mj(c, c.return);
            if (a.flags & 32) {
                var e = a.stateNode;
                try {
                    $0b2e6adb871a3b94$var$ob(e, "");
                } catch (t) {
                    $0b2e6adb871a3b94$var$W(a, a.return, t);
                }
            }
            if (d & 4 && (e = a.stateNode, null != e)) {
                var f = a.memoizedProps, g = null !== c ? c.memoizedProps : f, h = a.type, k = a.updateQueue;
                a.updateQueue = null;
                if (null !== k) try {
                    "input" === h && "radio" === f.type && null != f.name && $0b2e6adb871a3b94$var$ab(e, f);
                    $0b2e6adb871a3b94$var$vb(h, g);
                    var l = $0b2e6adb871a3b94$var$vb(h, f);
                    for(g = 0; g < k.length; g += 2){
                        var m = k[g], q = k[g + 1];
                        "style" === m ? $0b2e6adb871a3b94$var$sb(e, q) : "dangerouslySetInnerHTML" === m ? $0b2e6adb871a3b94$var$nb(e, q) : "children" === m ? $0b2e6adb871a3b94$var$ob(e, q) : $0b2e6adb871a3b94$var$ta(e, m, q, l);
                    }
                    switch(h){
                        case "input":
                            $0b2e6adb871a3b94$var$bb(e, f);
                            break;
                        case "textarea":
                            $0b2e6adb871a3b94$var$ib(e, f);
                            break;
                        case "select":
                            var r = e._wrapperState.wasMultiple;
                            e._wrapperState.wasMultiple = !!f.multiple;
                            var y = f.value;
                            null != y ? $0b2e6adb871a3b94$var$fb(e, !!f.multiple, y, !1) : r !== !!f.multiple && (null != f.defaultValue ? $0b2e6adb871a3b94$var$fb(e, !!f.multiple, f.defaultValue, !0) : $0b2e6adb871a3b94$var$fb(e, !!f.multiple, f.multiple ? [] : "", !1));
                    }
                    e[$0b2e6adb871a3b94$var$Pf] = f;
                } catch (t) {
                    $0b2e6adb871a3b94$var$W(a, a.return, t);
                }
            }
            break;
        case 6:
            $0b2e6adb871a3b94$var$dk(b, a);
            $0b2e6adb871a3b94$var$fk(a);
            if (d & 4) {
                if (null === a.stateNode) throw Error($0b2e6adb871a3b94$var$p(162));
                e = a.stateNode;
                f = a.memoizedProps;
                try {
                    e.nodeValue = f;
                } catch (t) {
                    $0b2e6adb871a3b94$var$W(a, a.return, t);
                }
            }
            break;
        case 3:
            $0b2e6adb871a3b94$var$dk(b, a);
            $0b2e6adb871a3b94$var$fk(a);
            if (d & 4 && null !== c && c.memoizedState.isDehydrated) try {
                $0b2e6adb871a3b94$var$bd(b.containerInfo);
            } catch (t) {
                $0b2e6adb871a3b94$var$W(a, a.return, t);
            }
            break;
        case 4:
            $0b2e6adb871a3b94$var$dk(b, a);
            $0b2e6adb871a3b94$var$fk(a);
            break;
        case 13:
            $0b2e6adb871a3b94$var$dk(b, a);
            $0b2e6adb871a3b94$var$fk(a);
            e = a.child;
            e.flags & 8192 && (f = null !== e.memoizedState, e.stateNode.isHidden = f, !f || null !== e.alternate && null !== e.alternate.memoizedState || ($0b2e6adb871a3b94$var$gk = $0b2e6adb871a3b94$var$B()));
            d & 4 && $0b2e6adb871a3b94$var$bk(a);
            break;
        case 22:
            m = null !== c && null !== c.memoizedState;
            a.mode & 1 ? ($0b2e6adb871a3b94$var$U = (l = $0b2e6adb871a3b94$var$U) || m, $0b2e6adb871a3b94$var$dk(b, a), $0b2e6adb871a3b94$var$U = l) : $0b2e6adb871a3b94$var$dk(b, a);
            $0b2e6adb871a3b94$var$fk(a);
            if (d & 8192) {
                l = null !== a.memoizedState;
                if ((a.stateNode.isHidden = l) && !m && 0 !== (a.mode & 1)) for($0b2e6adb871a3b94$var$V = a, m = a.child; null !== m;){
                    for(q = $0b2e6adb871a3b94$var$V = m; null !== $0b2e6adb871a3b94$var$V;){
                        r = $0b2e6adb871a3b94$var$V;
                        y = r.child;
                        switch(r.tag){
                            case 0:
                            case 11:
                            case 14:
                            case 15:
                                $0b2e6adb871a3b94$var$Qj(4, r, r.return);
                                break;
                            case 1:
                                $0b2e6adb871a3b94$var$Mj(r, r.return);
                                var n = r.stateNode;
                                if ("function" === typeof n.componentWillUnmount) {
                                    d = r;
                                    c = r.return;
                                    try {
                                        b = d, n.props = b.memoizedProps, n.state = b.memoizedState, n.componentWillUnmount();
                                    } catch (t) {
                                        $0b2e6adb871a3b94$var$W(d, c, t);
                                    }
                                }
                                break;
                            case 5:
                                $0b2e6adb871a3b94$var$Mj(r, r.return);
                                break;
                            case 22:
                                if (null !== r.memoizedState) {
                                    $0b2e6adb871a3b94$var$hk(q);
                                    continue;
                                }
                        }
                        null !== y ? (y.return = r, $0b2e6adb871a3b94$var$V = y) : $0b2e6adb871a3b94$var$hk(q);
                    }
                    m = m.sibling;
                }
                a: for(m = null, q = a;;){
                    if (5 === q.tag) {
                        if (null === m) {
                            m = q;
                            try {
                                e = q.stateNode, l ? (f = e.style, "function" === typeof f.setProperty ? f.setProperty("display", "none", "important") : f.display = "none") : (h = q.stateNode, k = q.memoizedProps.style, g = void 0 !== k && null !== k && k.hasOwnProperty("display") ? k.display : null, h.style.display = $0b2e6adb871a3b94$var$rb("display", g));
                            } catch (t) {
                                $0b2e6adb871a3b94$var$W(a, a.return, t);
                            }
                        }
                    } else if (6 === q.tag) {
                        if (null === m) try {
                            q.stateNode.nodeValue = l ? "" : q.memoizedProps;
                        } catch (t) {
                            $0b2e6adb871a3b94$var$W(a, a.return, t);
                        }
                    } else if ((22 !== q.tag && 23 !== q.tag || null === q.memoizedState || q === a) && null !== q.child) {
                        q.child.return = q;
                        q = q.child;
                        continue;
                    }
                    if (q === a) break a;
                    for(; null === q.sibling;){
                        if (null === q.return || q.return === a) break a;
                        m === q && (m = null);
                        q = q.return;
                    }
                    m === q && (m = null);
                    q.sibling.return = q.return;
                    q = q.sibling;
                }
            }
            break;
        case 19:
            $0b2e6adb871a3b94$var$dk(b, a);
            $0b2e6adb871a3b94$var$fk(a);
            d & 4 && $0b2e6adb871a3b94$var$bk(a);
            break;
        case 21:
            break;
        default:
            $0b2e6adb871a3b94$var$dk(b, a), $0b2e6adb871a3b94$var$fk(a);
    }
}
function $0b2e6adb871a3b94$var$fk(a) {
    var b = a.flags;
    if (b & 2) {
        try {
            a: {
                for(var c = a.return; null !== c;){
                    if ($0b2e6adb871a3b94$var$Uj(c)) {
                        var d = c;
                        break a;
                    }
                    c = c.return;
                }
                throw Error($0b2e6adb871a3b94$var$p(160));
            }
            switch(d.tag){
                case 5:
                    var e = d.stateNode;
                    d.flags & 32 && ($0b2e6adb871a3b94$var$ob(e, ""), d.flags &= -33);
                    var f = $0b2e6adb871a3b94$var$Vj(a);
                    $0b2e6adb871a3b94$var$Xj(a, f, e);
                    break;
                case 3:
                case 4:
                    var g = d.stateNode.containerInfo, h = $0b2e6adb871a3b94$var$Vj(a);
                    $0b2e6adb871a3b94$var$Wj(a, h, g);
                    break;
                default:
                    throw Error($0b2e6adb871a3b94$var$p(161));
            }
        } catch (k) {
            $0b2e6adb871a3b94$var$W(a, a.return, k);
        }
        a.flags &= -3;
    }
    b & 4096 && (a.flags &= -4097);
}
function $0b2e6adb871a3b94$var$ik(a, b, c) {
    $0b2e6adb871a3b94$var$V = a;
    $0b2e6adb871a3b94$var$jk(a, b, c);
}
function $0b2e6adb871a3b94$var$jk(a, b, c) {
    for(var d = 0 !== (a.mode & 1); null !== $0b2e6adb871a3b94$var$V;){
        var e = $0b2e6adb871a3b94$var$V, f = e.child;
        if (22 === e.tag && d) {
            var g = null !== e.memoizedState || $0b2e6adb871a3b94$var$Kj;
            if (!g) {
                var h = e.alternate, k = null !== h && null !== h.memoizedState || $0b2e6adb871a3b94$var$U;
                h = $0b2e6adb871a3b94$var$Kj;
                var l = $0b2e6adb871a3b94$var$U;
                $0b2e6adb871a3b94$var$Kj = g;
                if (($0b2e6adb871a3b94$var$U = k) && !l) for($0b2e6adb871a3b94$var$V = e; null !== $0b2e6adb871a3b94$var$V;)g = $0b2e6adb871a3b94$var$V, k = g.child, 22 === g.tag && null !== g.memoizedState ? $0b2e6adb871a3b94$var$kk(e) : null !== k ? (k.return = g, $0b2e6adb871a3b94$var$V = k) : $0b2e6adb871a3b94$var$kk(e);
                for(; null !== f;)$0b2e6adb871a3b94$var$V = f, $0b2e6adb871a3b94$var$jk(f, b, c), f = f.sibling;
                $0b2e6adb871a3b94$var$V = e;
                $0b2e6adb871a3b94$var$Kj = h;
                $0b2e6adb871a3b94$var$U = l;
            }
            $0b2e6adb871a3b94$var$lk(a, b, c);
        } else 0 !== (e.subtreeFlags & 8772) && null !== f ? (f.return = e, $0b2e6adb871a3b94$var$V = f) : $0b2e6adb871a3b94$var$lk(a, b, c);
    }
}
function $0b2e6adb871a3b94$var$lk(a) {
    for(; null !== $0b2e6adb871a3b94$var$V;){
        var b = $0b2e6adb871a3b94$var$V;
        if (0 !== (b.flags & 8772)) {
            var c = b.alternate;
            try {
                if (0 !== (b.flags & 8772)) switch(b.tag){
                    case 0:
                    case 11:
                    case 15:
                        $0b2e6adb871a3b94$var$U || $0b2e6adb871a3b94$var$Rj(5, b);
                        break;
                    case 1:
                        var d = b.stateNode;
                        if (b.flags & 4 && !$0b2e6adb871a3b94$var$U) {
                            if (null === c) d.componentDidMount();
                            else {
                                var e = b.elementType === b.type ? c.memoizedProps : $0b2e6adb871a3b94$var$Lg(b.type, c.memoizedProps);
                                d.componentDidUpdate(e, c.memoizedState, d.__reactInternalSnapshotBeforeUpdate);
                            }
                        }
                        var f = b.updateQueue;
                        null !== f && $0b2e6adb871a3b94$var$ih(b, f, d);
                        break;
                    case 3:
                        var g = b.updateQueue;
                        if (null !== g) {
                            c = null;
                            if (null !== b.child) switch(b.child.tag){
                                case 5:
                                    c = b.child.stateNode;
                                    break;
                                case 1:
                                    c = b.child.stateNode;
                            }
                            $0b2e6adb871a3b94$var$ih(b, g, c);
                        }
                        break;
                    case 5:
                        var h = b.stateNode;
                        if (null === c && b.flags & 4) {
                            c = h;
                            var k = b.memoizedProps;
                            switch(b.type){
                                case "button":
                                case "input":
                                case "select":
                                case "textarea":
                                    k.autoFocus && c.focus();
                                    break;
                                case "img":
                                    k.src && (c.src = k.src);
                            }
                        }
                        break;
                    case 6:
                        break;
                    case 4:
                        break;
                    case 12:
                        break;
                    case 13:
                        if (null === b.memoizedState) {
                            var l = b.alternate;
                            if (null !== l) {
                                var m = l.memoizedState;
                                if (null !== m) {
                                    var q = m.dehydrated;
                                    null !== q && $0b2e6adb871a3b94$var$bd(q);
                                }
                            }
                        }
                        break;
                    case 19:
                    case 17:
                    case 21:
                    case 22:
                    case 23:
                    case 25:
                        break;
                    default:
                        throw Error($0b2e6adb871a3b94$var$p(163));
                }
                $0b2e6adb871a3b94$var$U || b.flags & 512 && $0b2e6adb871a3b94$var$Sj(b);
            } catch (r) {
                $0b2e6adb871a3b94$var$W(b, b.return, r);
            }
        }
        if (b === a) {
            $0b2e6adb871a3b94$var$V = null;
            break;
        }
        c = b.sibling;
        if (null !== c) {
            c.return = b.return;
            $0b2e6adb871a3b94$var$V = c;
            break;
        }
        $0b2e6adb871a3b94$var$V = b.return;
    }
}
function $0b2e6adb871a3b94$var$hk(a) {
    for(; null !== $0b2e6adb871a3b94$var$V;){
        var b = $0b2e6adb871a3b94$var$V;
        if (b === a) {
            $0b2e6adb871a3b94$var$V = null;
            break;
        }
        var c = b.sibling;
        if (null !== c) {
            c.return = b.return;
            $0b2e6adb871a3b94$var$V = c;
            break;
        }
        $0b2e6adb871a3b94$var$V = b.return;
    }
}
function $0b2e6adb871a3b94$var$kk(a) {
    for(; null !== $0b2e6adb871a3b94$var$V;){
        var b = $0b2e6adb871a3b94$var$V;
        try {
            switch(b.tag){
                case 0:
                case 11:
                case 15:
                    var c = b.return;
                    try {
                        $0b2e6adb871a3b94$var$Rj(4, b);
                    } catch (k) {
                        $0b2e6adb871a3b94$var$W(b, c, k);
                    }
                    break;
                case 1:
                    var d = b.stateNode;
                    if ("function" === typeof d.componentDidMount) {
                        var e = b.return;
                        try {
                            d.componentDidMount();
                        } catch (k) {
                            $0b2e6adb871a3b94$var$W(b, e, k);
                        }
                    }
                    var f = b.return;
                    try {
                        $0b2e6adb871a3b94$var$Sj(b);
                    } catch (k) {
                        $0b2e6adb871a3b94$var$W(b, f, k);
                    }
                    break;
                case 5:
                    var g = b.return;
                    try {
                        $0b2e6adb871a3b94$var$Sj(b);
                    } catch (k) {
                        $0b2e6adb871a3b94$var$W(b, g, k);
                    }
            }
        } catch (k) {
            $0b2e6adb871a3b94$var$W(b, b.return, k);
        }
        if (b === a) {
            $0b2e6adb871a3b94$var$V = null;
            break;
        }
        var h = b.sibling;
        if (null !== h) {
            h.return = b.return;
            $0b2e6adb871a3b94$var$V = h;
            break;
        }
        $0b2e6adb871a3b94$var$V = b.return;
    }
}
var $0b2e6adb871a3b94$var$mk = Math.ceil, $0b2e6adb871a3b94$var$nk = $0b2e6adb871a3b94$var$ua.ReactCurrentDispatcher, $0b2e6adb871a3b94$var$ok = $0b2e6adb871a3b94$var$ua.ReactCurrentOwner, $0b2e6adb871a3b94$var$pk = $0b2e6adb871a3b94$var$ua.ReactCurrentBatchConfig, $0b2e6adb871a3b94$var$K = 0, $0b2e6adb871a3b94$var$R = null, $0b2e6adb871a3b94$var$Y = null, $0b2e6adb871a3b94$var$Z = 0, $0b2e6adb871a3b94$var$gj = 0, $0b2e6adb871a3b94$var$fj = $0b2e6adb871a3b94$var$Uf(0), $0b2e6adb871a3b94$var$T = 0, $0b2e6adb871a3b94$var$qk = null, $0b2e6adb871a3b94$var$hh = 0, $0b2e6adb871a3b94$var$rk = 0, $0b2e6adb871a3b94$var$sk = 0, $0b2e6adb871a3b94$var$tk = null, $0b2e6adb871a3b94$var$uk = null, $0b2e6adb871a3b94$var$gk = 0, $0b2e6adb871a3b94$var$Hj = Infinity, $0b2e6adb871a3b94$var$vk = null, $0b2e6adb871a3b94$var$Pi = !1, $0b2e6adb871a3b94$var$Qi = null, $0b2e6adb871a3b94$var$Si = null, $0b2e6adb871a3b94$var$wk = !1, $0b2e6adb871a3b94$var$xk = null, $0b2e6adb871a3b94$var$yk = 0, $0b2e6adb871a3b94$var$zk = 0, $0b2e6adb871a3b94$var$Ak = null, $0b2e6adb871a3b94$var$Bk = -1, $0b2e6adb871a3b94$var$Ck = 0;
function $0b2e6adb871a3b94$var$L() {
    return 0 !== ($0b2e6adb871a3b94$var$K & 6) ? $0b2e6adb871a3b94$var$B() : -1 !== $0b2e6adb871a3b94$var$Bk ? $0b2e6adb871a3b94$var$Bk : $0b2e6adb871a3b94$var$Bk = $0b2e6adb871a3b94$var$B();
}
function $0b2e6adb871a3b94$var$lh(a) {
    if (0 === (a.mode & 1)) return 1;
    if (0 !== ($0b2e6adb871a3b94$var$K & 2) && 0 !== $0b2e6adb871a3b94$var$Z) return $0b2e6adb871a3b94$var$Z & -$0b2e6adb871a3b94$var$Z;
    if (null !== $0b2e6adb871a3b94$var$Kg.transition) return 0 === $0b2e6adb871a3b94$var$Ck && ($0b2e6adb871a3b94$var$Ck = $0b2e6adb871a3b94$var$yc()), $0b2e6adb871a3b94$var$Ck;
    a = $0b2e6adb871a3b94$var$C;
    if (0 !== a) return a;
    a = window.event;
    a = void 0 === a ? 16 : $0b2e6adb871a3b94$var$jd(a.type);
    return a;
}
function $0b2e6adb871a3b94$var$mh(a, b, c, d) {
    if (50 < $0b2e6adb871a3b94$var$zk) throw $0b2e6adb871a3b94$var$zk = 0, $0b2e6adb871a3b94$var$Ak = null, Error($0b2e6adb871a3b94$var$p(185));
    $0b2e6adb871a3b94$var$Ac(a, c, d);
    if (0 === ($0b2e6adb871a3b94$var$K & 2) || a !== $0b2e6adb871a3b94$var$R) a === $0b2e6adb871a3b94$var$R && (0 === ($0b2e6adb871a3b94$var$K & 2) && ($0b2e6adb871a3b94$var$rk |= c), 4 === $0b2e6adb871a3b94$var$T && $0b2e6adb871a3b94$var$Dk(a, $0b2e6adb871a3b94$var$Z)), $0b2e6adb871a3b94$var$Ek(a, d), 1 === c && 0 === $0b2e6adb871a3b94$var$K && 0 === (b.mode & 1) && ($0b2e6adb871a3b94$var$Hj = $0b2e6adb871a3b94$var$B() + 500, $0b2e6adb871a3b94$var$fg && $0b2e6adb871a3b94$var$jg());
}
function $0b2e6adb871a3b94$var$Ek(a, b) {
    var c = a.callbackNode;
    $0b2e6adb871a3b94$var$wc(a, b);
    var d = $0b2e6adb871a3b94$var$uc(a, a === $0b2e6adb871a3b94$var$R ? $0b2e6adb871a3b94$var$Z : 0);
    if (0 === d) null !== c && $0b2e6adb871a3b94$var$bc(c), a.callbackNode = null, a.callbackPriority = 0;
    else if (b = d & -d, a.callbackPriority !== b) {
        null != c && $0b2e6adb871a3b94$var$bc(c);
        if (1 === b) 0 === a.tag ? $0b2e6adb871a3b94$var$ig($0b2e6adb871a3b94$var$Fk.bind(null, a)) : $0b2e6adb871a3b94$var$hg($0b2e6adb871a3b94$var$Fk.bind(null, a)), $0b2e6adb871a3b94$var$Jf(function() {
            0 === ($0b2e6adb871a3b94$var$K & 6) && $0b2e6adb871a3b94$var$jg();
        }), c = null;
        else {
            switch($0b2e6adb871a3b94$var$Dc(d)){
                case 1:
                    c = $0b2e6adb871a3b94$var$fc;
                    break;
                case 4:
                    c = $0b2e6adb871a3b94$var$gc;
                    break;
                case 16:
                    c = $0b2e6adb871a3b94$var$hc;
                    break;
                case 536870912:
                    c = $0b2e6adb871a3b94$var$jc;
                    break;
                default:
                    c = $0b2e6adb871a3b94$var$hc;
            }
            c = $0b2e6adb871a3b94$var$Gk(c, $0b2e6adb871a3b94$var$Hk.bind(null, a));
        }
        a.callbackPriority = b;
        a.callbackNode = c;
    }
}
function $0b2e6adb871a3b94$var$Hk(a, b) {
    $0b2e6adb871a3b94$var$Bk = -1;
    $0b2e6adb871a3b94$var$Ck = 0;
    if (0 !== ($0b2e6adb871a3b94$var$K & 6)) throw Error($0b2e6adb871a3b94$var$p(327));
    var c = a.callbackNode;
    if ($0b2e6adb871a3b94$var$Ik() && a.callbackNode !== c) return null;
    var d = $0b2e6adb871a3b94$var$uc(a, a === $0b2e6adb871a3b94$var$R ? $0b2e6adb871a3b94$var$Z : 0);
    if (0 === d) return null;
    if (0 !== (d & 30) || 0 !== (d & a.expiredLanes) || b) b = $0b2e6adb871a3b94$var$Jk(a, d);
    else {
        b = d;
        var e = $0b2e6adb871a3b94$var$K;
        $0b2e6adb871a3b94$var$K |= 2;
        var f = $0b2e6adb871a3b94$var$Kk();
        if ($0b2e6adb871a3b94$var$R !== a || $0b2e6adb871a3b94$var$Z !== b) $0b2e6adb871a3b94$var$vk = null, $0b2e6adb871a3b94$var$Hj = $0b2e6adb871a3b94$var$B() + 500, $0b2e6adb871a3b94$var$Lk(a, b);
        for(;;)try {
            $0b2e6adb871a3b94$var$Mk();
            break;
        } catch (h) {
            $0b2e6adb871a3b94$var$Nk(a, h);
        }
        $0b2e6adb871a3b94$var$Qg();
        $0b2e6adb871a3b94$var$nk.current = f;
        $0b2e6adb871a3b94$var$K = e;
        null !== $0b2e6adb871a3b94$var$Y ? b = 0 : ($0b2e6adb871a3b94$var$R = null, $0b2e6adb871a3b94$var$Z = 0, b = $0b2e6adb871a3b94$var$T);
    }
    if (0 !== b) {
        2 === b && (e = $0b2e6adb871a3b94$var$xc(a), 0 !== e && (d = e, b = $0b2e6adb871a3b94$var$Ok(a, e)));
        if (1 === b) throw c = $0b2e6adb871a3b94$var$qk, $0b2e6adb871a3b94$var$Lk(a, 0), $0b2e6adb871a3b94$var$Dk(a, d), $0b2e6adb871a3b94$var$Ek(a, $0b2e6adb871a3b94$var$B()), c;
        if (6 === b) $0b2e6adb871a3b94$var$Dk(a, d);
        else {
            e = a.current.alternate;
            if (0 === (d & 30) && !$0b2e6adb871a3b94$var$Pk(e) && (b = $0b2e6adb871a3b94$var$Jk(a, d), 2 === b && (f = $0b2e6adb871a3b94$var$xc(a), 0 !== f && (d = f, b = $0b2e6adb871a3b94$var$Ok(a, f))), 1 === b)) throw c = $0b2e6adb871a3b94$var$qk, $0b2e6adb871a3b94$var$Lk(a, 0), $0b2e6adb871a3b94$var$Dk(a, d), $0b2e6adb871a3b94$var$Ek(a, $0b2e6adb871a3b94$var$B()), c;
            a.finishedWork = e;
            a.finishedLanes = d;
            switch(b){
                case 0:
                case 1:
                    throw Error($0b2e6adb871a3b94$var$p(345));
                case 2:
                    $0b2e6adb871a3b94$var$Qk(a, $0b2e6adb871a3b94$var$uk, $0b2e6adb871a3b94$var$vk);
                    break;
                case 3:
                    $0b2e6adb871a3b94$var$Dk(a, d);
                    if ((d & 130023424) === d && (b = $0b2e6adb871a3b94$var$gk + 500 - $0b2e6adb871a3b94$var$B(), 10 < b)) {
                        if (0 !== $0b2e6adb871a3b94$var$uc(a, 0)) break;
                        e = a.suspendedLanes;
                        if ((e & d) !== d) {
                            $0b2e6adb871a3b94$var$L();
                            a.pingedLanes |= a.suspendedLanes & e;
                            break;
                        }
                        a.timeoutHandle = $0b2e6adb871a3b94$var$Ff($0b2e6adb871a3b94$var$Qk.bind(null, a, $0b2e6adb871a3b94$var$uk, $0b2e6adb871a3b94$var$vk), b);
                        break;
                    }
                    $0b2e6adb871a3b94$var$Qk(a, $0b2e6adb871a3b94$var$uk, $0b2e6adb871a3b94$var$vk);
                    break;
                case 4:
                    $0b2e6adb871a3b94$var$Dk(a, d);
                    if ((d & 4194240) === d) break;
                    b = a.eventTimes;
                    for(e = -1; 0 < d;){
                        var g = 31 - $0b2e6adb871a3b94$var$oc(d);
                        f = 1 << g;
                        g = b[g];
                        g > e && (e = g);
                        d &= ~f;
                    }
                    d = e;
                    d = $0b2e6adb871a3b94$var$B() - d;
                    d = (120 > d ? 120 : 480 > d ? 480 : 1080 > d ? 1080 : 1920 > d ? 1920 : 3E3 > d ? 3E3 : 4320 > d ? 4320 : 1960 * $0b2e6adb871a3b94$var$mk(d / 1960)) - d;
                    if (10 < d) {
                        a.timeoutHandle = $0b2e6adb871a3b94$var$Ff($0b2e6adb871a3b94$var$Qk.bind(null, a, $0b2e6adb871a3b94$var$uk, $0b2e6adb871a3b94$var$vk), d);
                        break;
                    }
                    $0b2e6adb871a3b94$var$Qk(a, $0b2e6adb871a3b94$var$uk, $0b2e6adb871a3b94$var$vk);
                    break;
                case 5:
                    $0b2e6adb871a3b94$var$Qk(a, $0b2e6adb871a3b94$var$uk, $0b2e6adb871a3b94$var$vk);
                    break;
                default:
                    throw Error($0b2e6adb871a3b94$var$p(329));
            }
        }
    }
    $0b2e6adb871a3b94$var$Ek(a, $0b2e6adb871a3b94$var$B());
    return a.callbackNode === c ? $0b2e6adb871a3b94$var$Hk.bind(null, a) : null;
}
function $0b2e6adb871a3b94$var$Ok(a, b) {
    var c = $0b2e6adb871a3b94$var$tk;
    a.current.memoizedState.isDehydrated && ($0b2e6adb871a3b94$var$Lk(a, b).flags |= 256);
    a = $0b2e6adb871a3b94$var$Jk(a, b);
    2 !== a && (b = $0b2e6adb871a3b94$var$uk, $0b2e6adb871a3b94$var$uk = c, null !== b && $0b2e6adb871a3b94$var$Gj(b));
    return a;
}
function $0b2e6adb871a3b94$var$Gj(a) {
    null === $0b2e6adb871a3b94$var$uk ? $0b2e6adb871a3b94$var$uk = a : $0b2e6adb871a3b94$var$uk.push.apply($0b2e6adb871a3b94$var$uk, a);
}
function $0b2e6adb871a3b94$var$Pk(a) {
    for(var b = a;;){
        if (b.flags & 16384) {
            var c = b.updateQueue;
            if (null !== c && (c = c.stores, null !== c)) for(var d = 0; d < c.length; d++){
                var e = c[d], f = e.getSnapshot;
                e = e.value;
                try {
                    if (!$0b2e6adb871a3b94$var$He(f(), e)) return !1;
                } catch (g) {
                    return !1;
                }
            }
        }
        c = b.child;
        if (b.subtreeFlags & 16384 && null !== c) c.return = b, b = c;
        else {
            if (b === a) break;
            for(; null === b.sibling;){
                if (null === b.return || b.return === a) return !0;
                b = b.return;
            }
            b.sibling.return = b.return;
            b = b.sibling;
        }
    }
    return !0;
}
function $0b2e6adb871a3b94$var$Dk(a, b) {
    b &= ~$0b2e6adb871a3b94$var$sk;
    b &= ~$0b2e6adb871a3b94$var$rk;
    a.suspendedLanes |= b;
    a.pingedLanes &= ~b;
    for(a = a.expirationTimes; 0 < b;){
        var c = 31 - $0b2e6adb871a3b94$var$oc(b), d = 1 << c;
        a[c] = -1;
        b &= ~d;
    }
}
function $0b2e6adb871a3b94$var$Fk(a) {
    if (0 !== ($0b2e6adb871a3b94$var$K & 6)) throw Error($0b2e6adb871a3b94$var$p(327));
    $0b2e6adb871a3b94$var$Ik();
    var b = $0b2e6adb871a3b94$var$uc(a, 0);
    if (0 === (b & 1)) return $0b2e6adb871a3b94$var$Ek(a, $0b2e6adb871a3b94$var$B()), null;
    var c = $0b2e6adb871a3b94$var$Jk(a, b);
    if (0 !== a.tag && 2 === c) {
        var d = $0b2e6adb871a3b94$var$xc(a);
        0 !== d && (b = d, c = $0b2e6adb871a3b94$var$Ok(a, d));
    }
    if (1 === c) throw c = $0b2e6adb871a3b94$var$qk, $0b2e6adb871a3b94$var$Lk(a, 0), $0b2e6adb871a3b94$var$Dk(a, b), $0b2e6adb871a3b94$var$Ek(a, $0b2e6adb871a3b94$var$B()), c;
    if (6 === c) throw Error($0b2e6adb871a3b94$var$p(345));
    a.finishedWork = a.current.alternate;
    a.finishedLanes = b;
    $0b2e6adb871a3b94$var$Qk(a, $0b2e6adb871a3b94$var$uk, $0b2e6adb871a3b94$var$vk);
    $0b2e6adb871a3b94$var$Ek(a, $0b2e6adb871a3b94$var$B());
    return null;
}
function $0b2e6adb871a3b94$var$Rk(a, b) {
    var c = $0b2e6adb871a3b94$var$K;
    $0b2e6adb871a3b94$var$K |= 1;
    try {
        return a(b);
    } finally{
        $0b2e6adb871a3b94$var$K = c, 0 === $0b2e6adb871a3b94$var$K && ($0b2e6adb871a3b94$var$Hj = $0b2e6adb871a3b94$var$B() + 500, $0b2e6adb871a3b94$var$fg && $0b2e6adb871a3b94$var$jg());
    }
}
function $0b2e6adb871a3b94$var$Sk(a) {
    null !== $0b2e6adb871a3b94$var$xk && 0 === $0b2e6adb871a3b94$var$xk.tag && 0 === ($0b2e6adb871a3b94$var$K & 6) && $0b2e6adb871a3b94$var$Ik();
    var b = $0b2e6adb871a3b94$var$K;
    $0b2e6adb871a3b94$var$K |= 1;
    var c = $0b2e6adb871a3b94$var$pk.transition, d = $0b2e6adb871a3b94$var$C;
    try {
        if ($0b2e6adb871a3b94$var$pk.transition = null, $0b2e6adb871a3b94$var$C = 1, a) return a();
    } finally{
        $0b2e6adb871a3b94$var$C = d, $0b2e6adb871a3b94$var$pk.transition = c, $0b2e6adb871a3b94$var$K = b, 0 === ($0b2e6adb871a3b94$var$K & 6) && $0b2e6adb871a3b94$var$jg();
    }
}
function $0b2e6adb871a3b94$var$Ij() {
    $0b2e6adb871a3b94$var$gj = $0b2e6adb871a3b94$var$fj.current;
    $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$fj);
}
function $0b2e6adb871a3b94$var$Lk(a, b) {
    a.finishedWork = null;
    a.finishedLanes = 0;
    var c = a.timeoutHandle;
    -1 !== c && (a.timeoutHandle = -1, $0b2e6adb871a3b94$var$Gf(c));
    if (null !== $0b2e6adb871a3b94$var$Y) for(c = $0b2e6adb871a3b94$var$Y.return; null !== c;){
        var d = c;
        $0b2e6adb871a3b94$var$wg(d);
        switch(d.tag){
            case 1:
                d = d.type.childContextTypes;
                null !== d && void 0 !== d && $0b2e6adb871a3b94$var$$f();
                break;
            case 3:
                $0b2e6adb871a3b94$var$Jh();
                $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$Wf);
                $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$H);
                $0b2e6adb871a3b94$var$Oh();
                break;
            case 5:
                $0b2e6adb871a3b94$var$Lh(d);
                break;
            case 4:
                $0b2e6adb871a3b94$var$Jh();
                break;
            case 13:
                $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$M);
                break;
            case 19:
                $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$M);
                break;
            case 10:
                $0b2e6adb871a3b94$var$Rg(d.type._context);
                break;
            case 22:
            case 23:
                $0b2e6adb871a3b94$var$Ij();
        }
        c = c.return;
    }
    $0b2e6adb871a3b94$var$R = a;
    $0b2e6adb871a3b94$var$Y = a = $0b2e6adb871a3b94$var$wh(a.current, null);
    $0b2e6adb871a3b94$var$Z = $0b2e6adb871a3b94$var$gj = b;
    $0b2e6adb871a3b94$var$T = 0;
    $0b2e6adb871a3b94$var$qk = null;
    $0b2e6adb871a3b94$var$sk = $0b2e6adb871a3b94$var$rk = $0b2e6adb871a3b94$var$hh = 0;
    $0b2e6adb871a3b94$var$uk = $0b2e6adb871a3b94$var$tk = null;
    if (null !== $0b2e6adb871a3b94$var$Wg) {
        for(b = 0; b < $0b2e6adb871a3b94$var$Wg.length; b++)if (c = $0b2e6adb871a3b94$var$Wg[b], d = c.interleaved, null !== d) {
            c.interleaved = null;
            var e = d.next, f = c.pending;
            if (null !== f) {
                var g = f.next;
                f.next = e;
                d.next = g;
            }
            c.pending = d;
        }
        $0b2e6adb871a3b94$var$Wg = null;
    }
    return a;
}
function $0b2e6adb871a3b94$var$Nk(a, b) {
    do {
        var c = $0b2e6adb871a3b94$var$Y;
        try {
            $0b2e6adb871a3b94$var$Qg();
            $0b2e6adb871a3b94$var$Ph.current = $0b2e6adb871a3b94$var$ai;
            if ($0b2e6adb871a3b94$var$Sh) {
                for(var d = $0b2e6adb871a3b94$var$N.memoizedState; null !== d;){
                    var e = d.queue;
                    null !== e && (e.pending = null);
                    d = d.next;
                }
                $0b2e6adb871a3b94$var$Sh = !1;
            }
            $0b2e6adb871a3b94$var$Rh = 0;
            $0b2e6adb871a3b94$var$P = $0b2e6adb871a3b94$var$O = $0b2e6adb871a3b94$var$N = null;
            $0b2e6adb871a3b94$var$Th = !1;
            $0b2e6adb871a3b94$var$Uh = 0;
            $0b2e6adb871a3b94$var$ok.current = null;
            if (null === c || null === c.return) {
                $0b2e6adb871a3b94$var$T = 1;
                $0b2e6adb871a3b94$var$qk = b;
                $0b2e6adb871a3b94$var$Y = null;
                break;
            }
            a: {
                var f = a, g = c.return, h = c, k = b;
                b = $0b2e6adb871a3b94$var$Z;
                h.flags |= 32768;
                if (null !== k && "object" === typeof k && "function" === typeof k.then) {
                    var l = k, m = h, q = m.tag;
                    if (0 === (m.mode & 1) && (0 === q || 11 === q || 15 === q)) {
                        var r = m.alternate;
                        r ? (m.updateQueue = r.updateQueue, m.memoizedState = r.memoizedState, m.lanes = r.lanes) : (m.updateQueue = null, m.memoizedState = null);
                    }
                    var y = $0b2e6adb871a3b94$var$Vi(g);
                    if (null !== y) {
                        y.flags &= -257;
                        $0b2e6adb871a3b94$var$Wi(y, g, h, f, b);
                        y.mode & 1 && $0b2e6adb871a3b94$var$Ti(f, l, b);
                        b = y;
                        k = l;
                        var n = b.updateQueue;
                        if (null === n) {
                            var t = new Set;
                            t.add(k);
                            b.updateQueue = t;
                        } else n.add(k);
                        break a;
                    } else {
                        if (0 === (b & 1)) {
                            $0b2e6adb871a3b94$var$Ti(f, l, b);
                            $0b2e6adb871a3b94$var$uj();
                            break a;
                        }
                        k = Error($0b2e6adb871a3b94$var$p(426));
                    }
                } else if ($0b2e6adb871a3b94$var$I && h.mode & 1) {
                    var J = $0b2e6adb871a3b94$var$Vi(g);
                    if (null !== J) {
                        0 === (J.flags & 65536) && (J.flags |= 256);
                        $0b2e6adb871a3b94$var$Wi(J, g, h, f, b);
                        $0b2e6adb871a3b94$var$Jg($0b2e6adb871a3b94$var$Ki(k, h));
                        break a;
                    }
                }
                f = k = $0b2e6adb871a3b94$var$Ki(k, h);
                4 !== $0b2e6adb871a3b94$var$T && ($0b2e6adb871a3b94$var$T = 2);
                null === $0b2e6adb871a3b94$var$tk ? $0b2e6adb871a3b94$var$tk = [
                    f
                ] : $0b2e6adb871a3b94$var$tk.push(f);
                f = g;
                do {
                    switch(f.tag){
                        case 3:
                            f.flags |= 65536;
                            b &= -b;
                            f.lanes |= b;
                            var x = $0b2e6adb871a3b94$var$Oi(f, k, b);
                            $0b2e6adb871a3b94$var$fh(f, x);
                            break a;
                        case 1:
                            h = k;
                            var w = f.type, u = f.stateNode;
                            if (0 === (f.flags & 128) && ("function" === typeof w.getDerivedStateFromError || null !== u && "function" === typeof u.componentDidCatch && (null === $0b2e6adb871a3b94$var$Si || !$0b2e6adb871a3b94$var$Si.has(u)))) {
                                f.flags |= 65536;
                                b &= -b;
                                f.lanes |= b;
                                var F = $0b2e6adb871a3b94$var$Ri(f, h, b);
                                $0b2e6adb871a3b94$var$fh(f, F);
                                break a;
                            }
                    }
                    f = f.return;
                }while (null !== f);
            }
            $0b2e6adb871a3b94$var$Tk(c);
        } catch (na) {
            b = na;
            $0b2e6adb871a3b94$var$Y === c && null !== c && ($0b2e6adb871a3b94$var$Y = c = c.return);
            continue;
        }
        break;
    }while (1);
}
function $0b2e6adb871a3b94$var$Kk() {
    var a = $0b2e6adb871a3b94$var$nk.current;
    $0b2e6adb871a3b94$var$nk.current = $0b2e6adb871a3b94$var$ai;
    return null === a ? $0b2e6adb871a3b94$var$ai : a;
}
function $0b2e6adb871a3b94$var$uj() {
    if (0 === $0b2e6adb871a3b94$var$T || 3 === $0b2e6adb871a3b94$var$T || 2 === $0b2e6adb871a3b94$var$T) $0b2e6adb871a3b94$var$T = 4;
    null === $0b2e6adb871a3b94$var$R || 0 === ($0b2e6adb871a3b94$var$hh & 268435455) && 0 === ($0b2e6adb871a3b94$var$rk & 268435455) || $0b2e6adb871a3b94$var$Dk($0b2e6adb871a3b94$var$R, $0b2e6adb871a3b94$var$Z);
}
function $0b2e6adb871a3b94$var$Jk(a, b) {
    var c = $0b2e6adb871a3b94$var$K;
    $0b2e6adb871a3b94$var$K |= 2;
    var d = $0b2e6adb871a3b94$var$Kk();
    if ($0b2e6adb871a3b94$var$R !== a || $0b2e6adb871a3b94$var$Z !== b) $0b2e6adb871a3b94$var$vk = null, $0b2e6adb871a3b94$var$Lk(a, b);
    for(;;)try {
        $0b2e6adb871a3b94$var$Uk();
        break;
    } catch (e) {
        $0b2e6adb871a3b94$var$Nk(a, e);
    }
    $0b2e6adb871a3b94$var$Qg();
    $0b2e6adb871a3b94$var$K = c;
    $0b2e6adb871a3b94$var$nk.current = d;
    if (null !== $0b2e6adb871a3b94$var$Y) throw Error($0b2e6adb871a3b94$var$p(261));
    $0b2e6adb871a3b94$var$R = null;
    $0b2e6adb871a3b94$var$Z = 0;
    return $0b2e6adb871a3b94$var$T;
}
function $0b2e6adb871a3b94$var$Uk() {
    for(; null !== $0b2e6adb871a3b94$var$Y;)$0b2e6adb871a3b94$var$Vk($0b2e6adb871a3b94$var$Y);
}
function $0b2e6adb871a3b94$var$Mk() {
    for(; null !== $0b2e6adb871a3b94$var$Y && !$0b2e6adb871a3b94$var$cc();)$0b2e6adb871a3b94$var$Vk($0b2e6adb871a3b94$var$Y);
}
function $0b2e6adb871a3b94$var$Vk(a) {
    var b = $0b2e6adb871a3b94$var$Wk(a.alternate, a, $0b2e6adb871a3b94$var$gj);
    a.memoizedProps = a.pendingProps;
    null === b ? $0b2e6adb871a3b94$var$Tk(a) : $0b2e6adb871a3b94$var$Y = b;
    $0b2e6adb871a3b94$var$ok.current = null;
}
function $0b2e6adb871a3b94$var$Tk(a) {
    var b = a;
    do {
        var c = b.alternate;
        a = b.return;
        if (0 === (b.flags & 32768)) {
            if (c = $0b2e6adb871a3b94$var$Fj(c, b, $0b2e6adb871a3b94$var$gj), null !== c) {
                $0b2e6adb871a3b94$var$Y = c;
                return;
            }
        } else {
            c = $0b2e6adb871a3b94$var$Jj(c, b);
            if (null !== c) {
                c.flags &= 32767;
                $0b2e6adb871a3b94$var$Y = c;
                return;
            }
            if (null !== a) a.flags |= 32768, a.subtreeFlags = 0, a.deletions = null;
            else {
                $0b2e6adb871a3b94$var$T = 6;
                $0b2e6adb871a3b94$var$Y = null;
                return;
            }
        }
        b = b.sibling;
        if (null !== b) {
            $0b2e6adb871a3b94$var$Y = b;
            return;
        }
        $0b2e6adb871a3b94$var$Y = b = a;
    }while (null !== b);
    0 === $0b2e6adb871a3b94$var$T && ($0b2e6adb871a3b94$var$T = 5);
}
function $0b2e6adb871a3b94$var$Qk(a, b, c) {
    var d = $0b2e6adb871a3b94$var$C, e = $0b2e6adb871a3b94$var$pk.transition;
    try {
        $0b2e6adb871a3b94$var$pk.transition = null, $0b2e6adb871a3b94$var$C = 1, $0b2e6adb871a3b94$var$Xk(a, b, c, d);
    } finally{
        $0b2e6adb871a3b94$var$pk.transition = e, $0b2e6adb871a3b94$var$C = d;
    }
    return null;
}
function $0b2e6adb871a3b94$var$Xk(a, b, c, d) {
    do $0b2e6adb871a3b94$var$Ik();
    while (null !== $0b2e6adb871a3b94$var$xk);
    if (0 !== ($0b2e6adb871a3b94$var$K & 6)) throw Error($0b2e6adb871a3b94$var$p(327));
    c = a.finishedWork;
    var e = a.finishedLanes;
    if (null === c) return null;
    a.finishedWork = null;
    a.finishedLanes = 0;
    if (c === a.current) throw Error($0b2e6adb871a3b94$var$p(177));
    a.callbackNode = null;
    a.callbackPriority = 0;
    var f = c.lanes | c.childLanes;
    $0b2e6adb871a3b94$var$Bc(a, f);
    a === $0b2e6adb871a3b94$var$R && ($0b2e6adb871a3b94$var$Y = $0b2e6adb871a3b94$var$R = null, $0b2e6adb871a3b94$var$Z = 0);
    0 === (c.subtreeFlags & 2064) && 0 === (c.flags & 2064) || $0b2e6adb871a3b94$var$wk || ($0b2e6adb871a3b94$var$wk = !0, $0b2e6adb871a3b94$var$Gk($0b2e6adb871a3b94$var$hc, function() {
        $0b2e6adb871a3b94$var$Ik();
        return null;
    }));
    f = 0 !== (c.flags & 15990);
    if (0 !== (c.subtreeFlags & 15990) || f) {
        f = $0b2e6adb871a3b94$var$pk.transition;
        $0b2e6adb871a3b94$var$pk.transition = null;
        var g = $0b2e6adb871a3b94$var$C;
        $0b2e6adb871a3b94$var$C = 1;
        var h = $0b2e6adb871a3b94$var$K;
        $0b2e6adb871a3b94$var$K |= 4;
        $0b2e6adb871a3b94$var$ok.current = null;
        $0b2e6adb871a3b94$var$Pj(a, c);
        $0b2e6adb871a3b94$var$ek(c, a);
        $0b2e6adb871a3b94$var$Oe($0b2e6adb871a3b94$var$Df);
        $0b2e6adb871a3b94$var$dd = !!$0b2e6adb871a3b94$var$Cf;
        $0b2e6adb871a3b94$var$Df = $0b2e6adb871a3b94$var$Cf = null;
        a.current = c;
        $0b2e6adb871a3b94$var$ik(c, a, e);
        $0b2e6adb871a3b94$var$dc();
        $0b2e6adb871a3b94$var$K = h;
        $0b2e6adb871a3b94$var$C = g;
        $0b2e6adb871a3b94$var$pk.transition = f;
    } else a.current = c;
    $0b2e6adb871a3b94$var$wk && ($0b2e6adb871a3b94$var$wk = !1, $0b2e6adb871a3b94$var$xk = a, $0b2e6adb871a3b94$var$yk = e);
    f = a.pendingLanes;
    0 === f && ($0b2e6adb871a3b94$var$Si = null);
    $0b2e6adb871a3b94$var$mc(c.stateNode, d);
    $0b2e6adb871a3b94$var$Ek(a, $0b2e6adb871a3b94$var$B());
    if (null !== b) for(d = a.onRecoverableError, c = 0; c < b.length; c++)e = b[c], d(e.value, {
        componentStack: e.stack,
        digest: e.digest
    });
    if ($0b2e6adb871a3b94$var$Pi) throw $0b2e6adb871a3b94$var$Pi = !1, a = $0b2e6adb871a3b94$var$Qi, $0b2e6adb871a3b94$var$Qi = null, a;
    0 !== ($0b2e6adb871a3b94$var$yk & 1) && 0 !== a.tag && $0b2e6adb871a3b94$var$Ik();
    f = a.pendingLanes;
    0 !== (f & 1) ? a === $0b2e6adb871a3b94$var$Ak ? $0b2e6adb871a3b94$var$zk++ : ($0b2e6adb871a3b94$var$zk = 0, $0b2e6adb871a3b94$var$Ak = a) : $0b2e6adb871a3b94$var$zk = 0;
    $0b2e6adb871a3b94$var$jg();
    return null;
}
function $0b2e6adb871a3b94$var$Ik() {
    if (null !== $0b2e6adb871a3b94$var$xk) {
        var a = $0b2e6adb871a3b94$var$Dc($0b2e6adb871a3b94$var$yk), b = $0b2e6adb871a3b94$var$pk.transition, c = $0b2e6adb871a3b94$var$C;
        try {
            $0b2e6adb871a3b94$var$pk.transition = null;
            $0b2e6adb871a3b94$var$C = 16 > a ? 16 : a;
            if (null === $0b2e6adb871a3b94$var$xk) var d = !1;
            else {
                a = $0b2e6adb871a3b94$var$xk;
                $0b2e6adb871a3b94$var$xk = null;
                $0b2e6adb871a3b94$var$yk = 0;
                if (0 !== ($0b2e6adb871a3b94$var$K & 6)) throw Error($0b2e6adb871a3b94$var$p(331));
                var e = $0b2e6adb871a3b94$var$K;
                $0b2e6adb871a3b94$var$K |= 4;
                for($0b2e6adb871a3b94$var$V = a.current; null !== $0b2e6adb871a3b94$var$V;){
                    var f = $0b2e6adb871a3b94$var$V, g = f.child;
                    if (0 !== ($0b2e6adb871a3b94$var$V.flags & 16)) {
                        var h = f.deletions;
                        if (null !== h) {
                            for(var k = 0; k < h.length; k++){
                                var l = h[k];
                                for($0b2e6adb871a3b94$var$V = l; null !== $0b2e6adb871a3b94$var$V;){
                                    var m = $0b2e6adb871a3b94$var$V;
                                    switch(m.tag){
                                        case 0:
                                        case 11:
                                        case 15:
                                            $0b2e6adb871a3b94$var$Qj(8, m, f);
                                    }
                                    var q = m.child;
                                    if (null !== q) q.return = m, $0b2e6adb871a3b94$var$V = q;
                                    else for(; null !== $0b2e6adb871a3b94$var$V;){
                                        m = $0b2e6adb871a3b94$var$V;
                                        var r = m.sibling, y = m.return;
                                        $0b2e6adb871a3b94$var$Tj(m);
                                        if (m === l) {
                                            $0b2e6adb871a3b94$var$V = null;
                                            break;
                                        }
                                        if (null !== r) {
                                            r.return = y;
                                            $0b2e6adb871a3b94$var$V = r;
                                            break;
                                        }
                                        $0b2e6adb871a3b94$var$V = y;
                                    }
                                }
                            }
                            var n = f.alternate;
                            if (null !== n) {
                                var t = n.child;
                                if (null !== t) {
                                    n.child = null;
                                    do {
                                        var J = t.sibling;
                                        t.sibling = null;
                                        t = J;
                                    }while (null !== t);
                                }
                            }
                            $0b2e6adb871a3b94$var$V = f;
                        }
                    }
                    if (0 !== (f.subtreeFlags & 2064) && null !== g) g.return = f, $0b2e6adb871a3b94$var$V = g;
                    else b: for(; null !== $0b2e6adb871a3b94$var$V;){
                        f = $0b2e6adb871a3b94$var$V;
                        if (0 !== (f.flags & 2048)) switch(f.tag){
                            case 0:
                            case 11:
                            case 15:
                                $0b2e6adb871a3b94$var$Qj(9, f, f.return);
                        }
                        var x = f.sibling;
                        if (null !== x) {
                            x.return = f.return;
                            $0b2e6adb871a3b94$var$V = x;
                            break b;
                        }
                        $0b2e6adb871a3b94$var$V = f.return;
                    }
                }
                var w = a.current;
                for($0b2e6adb871a3b94$var$V = w; null !== $0b2e6adb871a3b94$var$V;){
                    g = $0b2e6adb871a3b94$var$V;
                    var u = g.child;
                    if (0 !== (g.subtreeFlags & 2064) && null !== u) u.return = g, $0b2e6adb871a3b94$var$V = u;
                    else b: for(g = w; null !== $0b2e6adb871a3b94$var$V;){
                        h = $0b2e6adb871a3b94$var$V;
                        if (0 !== (h.flags & 2048)) try {
                            switch(h.tag){
                                case 0:
                                case 11:
                                case 15:
                                    $0b2e6adb871a3b94$var$Rj(9, h);
                            }
                        } catch (na) {
                            $0b2e6adb871a3b94$var$W(h, h.return, na);
                        }
                        if (h === g) {
                            $0b2e6adb871a3b94$var$V = null;
                            break b;
                        }
                        var F = h.sibling;
                        if (null !== F) {
                            F.return = h.return;
                            $0b2e6adb871a3b94$var$V = F;
                            break b;
                        }
                        $0b2e6adb871a3b94$var$V = h.return;
                    }
                }
                $0b2e6adb871a3b94$var$K = e;
                $0b2e6adb871a3b94$var$jg();
                if ($0b2e6adb871a3b94$var$lc && "function" === typeof $0b2e6adb871a3b94$var$lc.onPostCommitFiberRoot) try {
                    $0b2e6adb871a3b94$var$lc.onPostCommitFiberRoot($0b2e6adb871a3b94$var$kc, a);
                } catch (na) {}
                d = !0;
            }
            return d;
        } finally{
            $0b2e6adb871a3b94$var$C = c, $0b2e6adb871a3b94$var$pk.transition = b;
        }
    }
    return !1;
}
function $0b2e6adb871a3b94$var$Yk(a, b, c) {
    b = $0b2e6adb871a3b94$var$Ki(c, b);
    b = $0b2e6adb871a3b94$var$Oi(a, b, 1);
    a = $0b2e6adb871a3b94$var$dh(a, b, 1);
    b = $0b2e6adb871a3b94$var$L();
    null !== a && ($0b2e6adb871a3b94$var$Ac(a, 1, b), $0b2e6adb871a3b94$var$Ek(a, b));
}
function $0b2e6adb871a3b94$var$W(a, b, c) {
    if (3 === a.tag) $0b2e6adb871a3b94$var$Yk(a, a, c);
    else for(; null !== b;){
        if (3 === b.tag) {
            $0b2e6adb871a3b94$var$Yk(b, a, c);
            break;
        } else if (1 === b.tag) {
            var d = b.stateNode;
            if ("function" === typeof b.type.getDerivedStateFromError || "function" === typeof d.componentDidCatch && (null === $0b2e6adb871a3b94$var$Si || !$0b2e6adb871a3b94$var$Si.has(d))) {
                a = $0b2e6adb871a3b94$var$Ki(c, a);
                a = $0b2e6adb871a3b94$var$Ri(b, a, 1);
                b = $0b2e6adb871a3b94$var$dh(b, a, 1);
                a = $0b2e6adb871a3b94$var$L();
                null !== b && ($0b2e6adb871a3b94$var$Ac(b, 1, a), $0b2e6adb871a3b94$var$Ek(b, a));
                break;
            }
        }
        b = b.return;
    }
}
function $0b2e6adb871a3b94$var$Ui(a, b, c) {
    var d = a.pingCache;
    null !== d && d.delete(b);
    b = $0b2e6adb871a3b94$var$L();
    a.pingedLanes |= a.suspendedLanes & c;
    $0b2e6adb871a3b94$var$R === a && ($0b2e6adb871a3b94$var$Z & c) === c && (4 === $0b2e6adb871a3b94$var$T || 3 === $0b2e6adb871a3b94$var$T && ($0b2e6adb871a3b94$var$Z & 130023424) === $0b2e6adb871a3b94$var$Z && 500 > $0b2e6adb871a3b94$var$B() - $0b2e6adb871a3b94$var$gk ? $0b2e6adb871a3b94$var$Lk(a, 0) : $0b2e6adb871a3b94$var$sk |= c);
    $0b2e6adb871a3b94$var$Ek(a, b);
}
function $0b2e6adb871a3b94$var$Zk(a, b) {
    0 === b && (0 === (a.mode & 1) ? b = 1 : (b = $0b2e6adb871a3b94$var$sc, $0b2e6adb871a3b94$var$sc <<= 1, 0 === ($0b2e6adb871a3b94$var$sc & 130023424) && ($0b2e6adb871a3b94$var$sc = 4194304)));
    var c = $0b2e6adb871a3b94$var$L();
    a = $0b2e6adb871a3b94$var$Zg(a, b);
    null !== a && ($0b2e6adb871a3b94$var$Ac(a, b, c), $0b2e6adb871a3b94$var$Ek(a, c));
}
function $0b2e6adb871a3b94$var$vj(a) {
    var b = a.memoizedState, c = 0;
    null !== b && (c = b.retryLane);
    $0b2e6adb871a3b94$var$Zk(a, c);
}
function $0b2e6adb871a3b94$var$ck(a, b) {
    var c = 0;
    switch(a.tag){
        case 13:
            var d = a.stateNode;
            var e = a.memoizedState;
            null !== e && (c = e.retryLane);
            break;
        case 19:
            d = a.stateNode;
            break;
        default:
            throw Error($0b2e6adb871a3b94$var$p(314));
    }
    null !== d && d.delete(b);
    $0b2e6adb871a3b94$var$Zk(a, c);
}
var $0b2e6adb871a3b94$var$Wk;
$0b2e6adb871a3b94$var$Wk = function(a, b, c) {
    if (null !== a) {
        if (a.memoizedProps !== b.pendingProps || $0b2e6adb871a3b94$var$Wf.current) $0b2e6adb871a3b94$var$Ug = !0;
        else {
            if (0 === (a.lanes & c) && 0 === (b.flags & 128)) return $0b2e6adb871a3b94$var$Ug = !1, $0b2e6adb871a3b94$var$zj(a, b, c);
            $0b2e6adb871a3b94$var$Ug = 0 !== (a.flags & 131072) ? !0 : !1;
        }
    } else $0b2e6adb871a3b94$var$Ug = !1, $0b2e6adb871a3b94$var$I && 0 !== (b.flags & 1048576) && $0b2e6adb871a3b94$var$ug(b, $0b2e6adb871a3b94$var$ng, b.index);
    b.lanes = 0;
    switch(b.tag){
        case 2:
            var d = b.type;
            $0b2e6adb871a3b94$var$jj(a, b);
            a = b.pendingProps;
            var e = $0b2e6adb871a3b94$var$Yf(b, $0b2e6adb871a3b94$var$H.current);
            $0b2e6adb871a3b94$var$Tg(b, c);
            e = $0b2e6adb871a3b94$var$Xh(null, b, d, a, e, c);
            var f = $0b2e6adb871a3b94$var$bi();
            b.flags |= 1;
            "object" === typeof e && null !== e && "function" === typeof e.render && void 0 === e.$$typeof ? (b.tag = 1, b.memoizedState = null, b.updateQueue = null, $0b2e6adb871a3b94$var$Zf(d) ? (f = !0, $0b2e6adb871a3b94$var$cg(b)) : f = !1, b.memoizedState = null !== e.state && void 0 !== e.state ? e.state : null, $0b2e6adb871a3b94$var$ah(b), e.updater = $0b2e6adb871a3b94$var$nh, b.stateNode = e, e._reactInternals = b, $0b2e6adb871a3b94$var$rh(b, d, a, c), b = $0b2e6adb871a3b94$var$kj(null, b, d, !0, f, c)) : (b.tag = 0, $0b2e6adb871a3b94$var$I && f && $0b2e6adb871a3b94$var$vg(b), $0b2e6adb871a3b94$var$Yi(null, b, e, c), b = b.child);
            return b;
        case 16:
            d = b.elementType;
            a: {
                $0b2e6adb871a3b94$var$jj(a, b);
                a = b.pendingProps;
                e = d._init;
                d = e(d._payload);
                b.type = d;
                e = b.tag = $0b2e6adb871a3b94$var$$k(d);
                a = $0b2e6adb871a3b94$var$Lg(d, a);
                switch(e){
                    case 0:
                        b = $0b2e6adb871a3b94$var$dj(null, b, d, a, c);
                        break a;
                    case 1:
                        b = $0b2e6adb871a3b94$var$ij(null, b, d, a, c);
                        break a;
                    case 11:
                        b = $0b2e6adb871a3b94$var$Zi(null, b, d, a, c);
                        break a;
                    case 14:
                        b = $0b2e6adb871a3b94$var$aj(null, b, d, $0b2e6adb871a3b94$var$Lg(d.type, a), c);
                        break a;
                }
                throw Error($0b2e6adb871a3b94$var$p(306, d, ""));
            }
            return b;
        case 0:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $0b2e6adb871a3b94$var$Lg(d, e), $0b2e6adb871a3b94$var$dj(a, b, d, e, c);
        case 1:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $0b2e6adb871a3b94$var$Lg(d, e), $0b2e6adb871a3b94$var$ij(a, b, d, e, c);
        case 3:
            a: {
                $0b2e6adb871a3b94$var$lj(b);
                if (null === a) throw Error($0b2e6adb871a3b94$var$p(387));
                d = b.pendingProps;
                f = b.memoizedState;
                e = f.element;
                $0b2e6adb871a3b94$var$bh(a, b);
                $0b2e6adb871a3b94$var$gh(b, d, null, c);
                var g = b.memoizedState;
                d = g.element;
                if (f.isDehydrated) {
                    if (f = {
                        element: d,
                        isDehydrated: !1,
                        cache: g.cache,
                        pendingSuspenseBoundaries: g.pendingSuspenseBoundaries,
                        transitions: g.transitions
                    }, b.updateQueue.baseState = f, b.memoizedState = f, b.flags & 256) {
                        e = $0b2e6adb871a3b94$var$Ki(Error($0b2e6adb871a3b94$var$p(423)), b);
                        b = $0b2e6adb871a3b94$var$mj(a, b, d, c, e);
                        break a;
                    } else if (d !== e) {
                        e = $0b2e6adb871a3b94$var$Ki(Error($0b2e6adb871a3b94$var$p(424)), b);
                        b = $0b2e6adb871a3b94$var$mj(a, b, d, c, e);
                        break a;
                    } else for($0b2e6adb871a3b94$var$yg = $0b2e6adb871a3b94$var$Lf(b.stateNode.containerInfo.firstChild), $0b2e6adb871a3b94$var$xg = b, $0b2e6adb871a3b94$var$I = !0, $0b2e6adb871a3b94$var$zg = null, c = $0b2e6adb871a3b94$var$Ch(b, null, d, c), b.child = c; c;)c.flags = c.flags & -3 | 4096, c = c.sibling;
                } else {
                    $0b2e6adb871a3b94$var$Ig();
                    if (d === e) {
                        b = $0b2e6adb871a3b94$var$$i(a, b, c);
                        break a;
                    }
                    $0b2e6adb871a3b94$var$Yi(a, b, d, c);
                }
                b = b.child;
            }
            return b;
        case 5:
            return $0b2e6adb871a3b94$var$Kh(b), null === a && $0b2e6adb871a3b94$var$Eg(b), d = b.type, e = b.pendingProps, f = null !== a ? a.memoizedProps : null, g = e.children, $0b2e6adb871a3b94$var$Ef(d, e) ? g = null : null !== f && $0b2e6adb871a3b94$var$Ef(d, f) && (b.flags |= 32), $0b2e6adb871a3b94$var$hj(a, b), $0b2e6adb871a3b94$var$Yi(a, b, g, c), b.child;
        case 6:
            return null === a && $0b2e6adb871a3b94$var$Eg(b), null;
        case 13:
            return $0b2e6adb871a3b94$var$pj(a, b, c);
        case 4:
            return $0b2e6adb871a3b94$var$Ih(b, b.stateNode.containerInfo), d = b.pendingProps, null === a ? b.child = $0b2e6adb871a3b94$var$Bh(b, null, d, c) : $0b2e6adb871a3b94$var$Yi(a, b, d, c), b.child;
        case 11:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $0b2e6adb871a3b94$var$Lg(d, e), $0b2e6adb871a3b94$var$Zi(a, b, d, e, c);
        case 7:
            return $0b2e6adb871a3b94$var$Yi(a, b, b.pendingProps, c), b.child;
        case 8:
            return $0b2e6adb871a3b94$var$Yi(a, b, b.pendingProps.children, c), b.child;
        case 12:
            return $0b2e6adb871a3b94$var$Yi(a, b, b.pendingProps.children, c), b.child;
        case 10:
            a: {
                d = b.type._context;
                e = b.pendingProps;
                f = b.memoizedProps;
                g = e.value;
                $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$Mg, d._currentValue);
                d._currentValue = g;
                if (null !== f) {
                    if ($0b2e6adb871a3b94$var$He(f.value, g)) {
                        if (f.children === e.children && !$0b2e6adb871a3b94$var$Wf.current) {
                            b = $0b2e6adb871a3b94$var$$i(a, b, c);
                            break a;
                        }
                    } else for(f = b.child, null !== f && (f.return = b); null !== f;){
                        var h = f.dependencies;
                        if (null !== h) {
                            g = f.child;
                            for(var k = h.firstContext; null !== k;){
                                if (k.context === d) {
                                    if (1 === f.tag) {
                                        k = $0b2e6adb871a3b94$var$ch(-1, c & -c);
                                        k.tag = 2;
                                        var l = f.updateQueue;
                                        if (null !== l) {
                                            l = l.shared;
                                            var m = l.pending;
                                            null === m ? k.next = k : (k.next = m.next, m.next = k);
                                            l.pending = k;
                                        }
                                    }
                                    f.lanes |= c;
                                    k = f.alternate;
                                    null !== k && (k.lanes |= c);
                                    $0b2e6adb871a3b94$var$Sg(f.return, c, b);
                                    h.lanes |= c;
                                    break;
                                }
                                k = k.next;
                            }
                        } else if (10 === f.tag) g = f.type === b.type ? null : f.child;
                        else if (18 === f.tag) {
                            g = f.return;
                            if (null === g) throw Error($0b2e6adb871a3b94$var$p(341));
                            g.lanes |= c;
                            h = g.alternate;
                            null !== h && (h.lanes |= c);
                            $0b2e6adb871a3b94$var$Sg(g, c, b);
                            g = f.sibling;
                        } else g = f.child;
                        if (null !== g) g.return = f;
                        else for(g = f; null !== g;){
                            if (g === b) {
                                g = null;
                                break;
                            }
                            f = g.sibling;
                            if (null !== f) {
                                f.return = g.return;
                                g = f;
                                break;
                            }
                            g = g.return;
                        }
                        f = g;
                    }
                }
                $0b2e6adb871a3b94$var$Yi(a, b, e.children, c);
                b = b.child;
            }
            return b;
        case 9:
            return e = b.type, d = b.pendingProps.children, $0b2e6adb871a3b94$var$Tg(b, c), e = $0b2e6adb871a3b94$var$Vg(e), d = d(e), b.flags |= 1, $0b2e6adb871a3b94$var$Yi(a, b, d, c), b.child;
        case 14:
            return d = b.type, e = $0b2e6adb871a3b94$var$Lg(d, b.pendingProps), e = $0b2e6adb871a3b94$var$Lg(d.type, e), $0b2e6adb871a3b94$var$aj(a, b, d, e, c);
        case 15:
            return $0b2e6adb871a3b94$var$cj(a, b, b.type, b.pendingProps, c);
        case 17:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $0b2e6adb871a3b94$var$Lg(d, e), $0b2e6adb871a3b94$var$jj(a, b), b.tag = 1, $0b2e6adb871a3b94$var$Zf(d) ? (a = !0, $0b2e6adb871a3b94$var$cg(b)) : a = !1, $0b2e6adb871a3b94$var$Tg(b, c), $0b2e6adb871a3b94$var$ph(b, d, e), $0b2e6adb871a3b94$var$rh(b, d, e, c), $0b2e6adb871a3b94$var$kj(null, b, d, !0, a, c);
        case 19:
            return $0b2e6adb871a3b94$var$yj(a, b, c);
        case 22:
            return $0b2e6adb871a3b94$var$ej(a, b, c);
    }
    throw Error($0b2e6adb871a3b94$var$p(156, b.tag));
};
function $0b2e6adb871a3b94$var$Gk(a, b) {
    return $0b2e6adb871a3b94$var$ac(a, b);
}
function $0b2e6adb871a3b94$var$al(a, b, c, d) {
    this.tag = a;
    this.key = c;
    this.sibling = this.child = this.return = this.stateNode = this.type = this.elementType = null;
    this.index = 0;
    this.ref = null;
    this.pendingProps = b;
    this.dependencies = this.memoizedState = this.updateQueue = this.memoizedProps = null;
    this.mode = d;
    this.subtreeFlags = this.flags = 0;
    this.deletions = null;
    this.childLanes = this.lanes = 0;
    this.alternate = null;
}
function $0b2e6adb871a3b94$var$Bg(a, b, c, d) {
    return new $0b2e6adb871a3b94$var$al(a, b, c, d);
}
function $0b2e6adb871a3b94$var$bj(a) {
    a = a.prototype;
    return !(!a || !a.isReactComponent);
}
function $0b2e6adb871a3b94$var$$k(a) {
    if ("function" === typeof a) return $0b2e6adb871a3b94$var$bj(a) ? 1 : 0;
    if (void 0 !== a && null !== a) {
        a = a.$$typeof;
        if (a === $0b2e6adb871a3b94$var$Da) return 11;
        if (a === $0b2e6adb871a3b94$var$Ga) return 14;
    }
    return 2;
}
function $0b2e6adb871a3b94$var$wh(a, b) {
    var c = a.alternate;
    null === c ? (c = $0b2e6adb871a3b94$var$Bg(a.tag, b, a.key, a.mode), c.elementType = a.elementType, c.type = a.type, c.stateNode = a.stateNode, c.alternate = a, a.alternate = c) : (c.pendingProps = b, c.type = a.type, c.flags = 0, c.subtreeFlags = 0, c.deletions = null);
    c.flags = a.flags & 14680064;
    c.childLanes = a.childLanes;
    c.lanes = a.lanes;
    c.child = a.child;
    c.memoizedProps = a.memoizedProps;
    c.memoizedState = a.memoizedState;
    c.updateQueue = a.updateQueue;
    b = a.dependencies;
    c.dependencies = null === b ? null : {
        lanes: b.lanes,
        firstContext: b.firstContext
    };
    c.sibling = a.sibling;
    c.index = a.index;
    c.ref = a.ref;
    return c;
}
function $0b2e6adb871a3b94$var$yh(a, b, c, d, e, f) {
    var g = 2;
    d = a;
    if ("function" === typeof a) $0b2e6adb871a3b94$var$bj(a) && (g = 1);
    else if ("string" === typeof a) g = 5;
    else a: switch(a){
        case $0b2e6adb871a3b94$var$ya:
            return $0b2e6adb871a3b94$var$Ah(c.children, e, f, b);
        case $0b2e6adb871a3b94$var$za:
            g = 8;
            e |= 8;
            break;
        case $0b2e6adb871a3b94$var$Aa:
            return a = $0b2e6adb871a3b94$var$Bg(12, c, b, e | 2), a.elementType = $0b2e6adb871a3b94$var$Aa, a.lanes = f, a;
        case $0b2e6adb871a3b94$var$Ea:
            return a = $0b2e6adb871a3b94$var$Bg(13, c, b, e), a.elementType = $0b2e6adb871a3b94$var$Ea, a.lanes = f, a;
        case $0b2e6adb871a3b94$var$Fa:
            return a = $0b2e6adb871a3b94$var$Bg(19, c, b, e), a.elementType = $0b2e6adb871a3b94$var$Fa, a.lanes = f, a;
        case $0b2e6adb871a3b94$var$Ia:
            return $0b2e6adb871a3b94$var$qj(c, e, f, b);
        default:
            if ("object" === typeof a && null !== a) switch(a.$$typeof){
                case $0b2e6adb871a3b94$var$Ba:
                    g = 10;
                    break a;
                case $0b2e6adb871a3b94$var$Ca:
                    g = 9;
                    break a;
                case $0b2e6adb871a3b94$var$Da:
                    g = 11;
                    break a;
                case $0b2e6adb871a3b94$var$Ga:
                    g = 14;
                    break a;
                case $0b2e6adb871a3b94$var$Ha:
                    g = 16;
                    d = null;
                    break a;
            }
            throw Error($0b2e6adb871a3b94$var$p(130, null == a ? a : typeof a, ""));
    }
    b = $0b2e6adb871a3b94$var$Bg(g, c, b, e);
    b.elementType = a;
    b.type = d;
    b.lanes = f;
    return b;
}
function $0b2e6adb871a3b94$var$Ah(a, b, c, d) {
    a = $0b2e6adb871a3b94$var$Bg(7, a, d, b);
    a.lanes = c;
    return a;
}
function $0b2e6adb871a3b94$var$qj(a, b, c, d) {
    a = $0b2e6adb871a3b94$var$Bg(22, a, d, b);
    a.elementType = $0b2e6adb871a3b94$var$Ia;
    a.lanes = c;
    a.stateNode = {
        isHidden: !1
    };
    return a;
}
function $0b2e6adb871a3b94$var$xh(a, b, c) {
    a = $0b2e6adb871a3b94$var$Bg(6, a, null, b);
    a.lanes = c;
    return a;
}
function $0b2e6adb871a3b94$var$zh(a, b, c) {
    b = $0b2e6adb871a3b94$var$Bg(4, null !== a.children ? a.children : [], a.key, b);
    b.lanes = c;
    b.stateNode = {
        containerInfo: a.containerInfo,
        pendingChildren: null,
        implementation: a.implementation
    };
    return b;
}
function $0b2e6adb871a3b94$var$bl(a, b, c, d, e) {
    this.tag = b;
    this.containerInfo = a;
    this.finishedWork = this.pingCache = this.current = this.pendingChildren = null;
    this.timeoutHandle = -1;
    this.callbackNode = this.pendingContext = this.context = null;
    this.callbackPriority = 0;
    this.eventTimes = $0b2e6adb871a3b94$var$zc(0);
    this.expirationTimes = $0b2e6adb871a3b94$var$zc(-1);
    this.entangledLanes = this.finishedLanes = this.mutableReadLanes = this.expiredLanes = this.pingedLanes = this.suspendedLanes = this.pendingLanes = 0;
    this.entanglements = $0b2e6adb871a3b94$var$zc(0);
    this.identifierPrefix = d;
    this.onRecoverableError = e;
    this.mutableSourceEagerHydrationData = null;
}
function $0b2e6adb871a3b94$var$cl(a, b, c, d, e, f, g, h, k) {
    a = new $0b2e6adb871a3b94$var$bl(a, b, c, h, k);
    1 === b ? (b = 1, !0 === f && (b |= 8)) : b = 0;
    f = $0b2e6adb871a3b94$var$Bg(3, null, null, b);
    a.current = f;
    f.stateNode = a;
    f.memoizedState = {
        element: d,
        isDehydrated: c,
        cache: null,
        transitions: null,
        pendingSuspenseBoundaries: null
    };
    $0b2e6adb871a3b94$var$ah(f);
    return a;
}
function $0b2e6adb871a3b94$var$dl(a, b, c) {
    var d = 3 < arguments.length && void 0 !== arguments[3] ? arguments[3] : null;
    return {
        $$typeof: $0b2e6adb871a3b94$var$wa,
        key: null == d ? null : "" + d,
        children: a,
        containerInfo: b,
        implementation: c
    };
}
function $0b2e6adb871a3b94$var$el(a) {
    if (!a) return $0b2e6adb871a3b94$var$Vf;
    a = a._reactInternals;
    a: {
        if ($0b2e6adb871a3b94$var$Vb(a) !== a || 1 !== a.tag) throw Error($0b2e6adb871a3b94$var$p(170));
        var b = a;
        do {
            switch(b.tag){
                case 3:
                    b = b.stateNode.context;
                    break a;
                case 1:
                    if ($0b2e6adb871a3b94$var$Zf(b.type)) {
                        b = b.stateNode.__reactInternalMemoizedMergedChildContext;
                        break a;
                    }
            }
            b = b.return;
        }while (null !== b);
        throw Error($0b2e6adb871a3b94$var$p(171));
    }
    if (1 === a.tag) {
        var c = a.type;
        if ($0b2e6adb871a3b94$var$Zf(c)) return $0b2e6adb871a3b94$var$bg(a, c, b);
    }
    return b;
}
function $0b2e6adb871a3b94$var$fl(a, b, c, d, e, f, g, h, k) {
    a = $0b2e6adb871a3b94$var$cl(c, d, !0, a, e, f, g, h, k);
    a.context = $0b2e6adb871a3b94$var$el(null);
    c = a.current;
    d = $0b2e6adb871a3b94$var$L();
    e = $0b2e6adb871a3b94$var$lh(c);
    f = $0b2e6adb871a3b94$var$ch(d, e);
    f.callback = void 0 !== b && null !== b ? b : null;
    $0b2e6adb871a3b94$var$dh(c, f, e);
    a.current.lanes = e;
    $0b2e6adb871a3b94$var$Ac(a, e, d);
    $0b2e6adb871a3b94$var$Ek(a, d);
    return a;
}
function $0b2e6adb871a3b94$var$gl(a, b, c, d) {
    var e = b.current, f = $0b2e6adb871a3b94$var$L(), g = $0b2e6adb871a3b94$var$lh(e);
    c = $0b2e6adb871a3b94$var$el(c);
    null === b.context ? b.context = c : b.pendingContext = c;
    b = $0b2e6adb871a3b94$var$ch(f, g);
    b.payload = {
        element: a
    };
    d = void 0 === d ? null : d;
    null !== d && (b.callback = d);
    a = $0b2e6adb871a3b94$var$dh(e, b, g);
    null !== a && ($0b2e6adb871a3b94$var$mh(a, e, g, f), $0b2e6adb871a3b94$var$eh(a, e, g));
    return g;
}
function $0b2e6adb871a3b94$var$hl(a) {
    a = a.current;
    if (!a.child) return null;
    switch(a.child.tag){
        case 5:
            return a.child.stateNode;
        default:
            return a.child.stateNode;
    }
}
function $0b2e6adb871a3b94$var$il(a, b) {
    a = a.memoizedState;
    if (null !== a && null !== a.dehydrated) {
        var c = a.retryLane;
        a.retryLane = 0 !== c && c < b ? c : b;
    }
}
function $0b2e6adb871a3b94$var$jl(a, b) {
    $0b2e6adb871a3b94$var$il(a, b);
    (a = a.alternate) && $0b2e6adb871a3b94$var$il(a, b);
}
function $0b2e6adb871a3b94$var$kl() {
    return null;
}
var $0b2e6adb871a3b94$var$ll = "function" === typeof reportError ? reportError : function(a) {
    console.error(a);
};
function $0b2e6adb871a3b94$var$ml(a) {
    this._internalRoot = a;
}
$0b2e6adb871a3b94$var$nl.prototype.render = $0b2e6adb871a3b94$var$ml.prototype.render = function(a) {
    var b = this._internalRoot;
    if (null === b) throw Error($0b2e6adb871a3b94$var$p(409));
    $0b2e6adb871a3b94$var$gl(a, b, null, null);
};
$0b2e6adb871a3b94$var$nl.prototype.unmount = $0b2e6adb871a3b94$var$ml.prototype.unmount = function() {
    var a = this._internalRoot;
    if (null !== a) {
        this._internalRoot = null;
        var b = a.containerInfo;
        $0b2e6adb871a3b94$var$Sk(function() {
            $0b2e6adb871a3b94$var$gl(null, a, null, null);
        });
        b[$0b2e6adb871a3b94$var$uf] = null;
    }
};
function $0b2e6adb871a3b94$var$nl(a) {
    this._internalRoot = a;
}
$0b2e6adb871a3b94$var$nl.prototype.unstable_scheduleHydration = function(a) {
    if (a) {
        var b = $0b2e6adb871a3b94$var$Hc();
        a = {
            blockedOn: null,
            target: a,
            priority: b
        };
        for(var c = 0; c < $0b2e6adb871a3b94$var$Qc.length && 0 !== b && b < $0b2e6adb871a3b94$var$Qc[c].priority; c++);
        $0b2e6adb871a3b94$var$Qc.splice(c, 0, a);
        0 === c && $0b2e6adb871a3b94$var$Vc(a);
    }
};
function $0b2e6adb871a3b94$var$ol(a) {
    return !(!a || 1 !== a.nodeType && 9 !== a.nodeType && 11 !== a.nodeType);
}
function $0b2e6adb871a3b94$var$pl(a) {
    return !(!a || 1 !== a.nodeType && 9 !== a.nodeType && 11 !== a.nodeType && (8 !== a.nodeType || " react-mount-point-unstable " !== a.nodeValue));
}
function $0b2e6adb871a3b94$var$ql() {}
function $0b2e6adb871a3b94$var$rl(a, b, c, d, e) {
    if (e) {
        if ("function" === typeof d) {
            var f = d;
            d = function() {
                var a = $0b2e6adb871a3b94$var$hl(g);
                f.call(a);
            };
        }
        var g = $0b2e6adb871a3b94$var$fl(b, d, a, 0, null, !1, !1, "", $0b2e6adb871a3b94$var$ql);
        a._reactRootContainer = g;
        a[$0b2e6adb871a3b94$var$uf] = g.current;
        $0b2e6adb871a3b94$var$sf(8 === a.nodeType ? a.parentNode : a);
        $0b2e6adb871a3b94$var$Sk();
        return g;
    }
    for(; e = a.lastChild;)a.removeChild(e);
    if ("function" === typeof d) {
        var h = d;
        d = function() {
            var a = $0b2e6adb871a3b94$var$hl(k);
            h.call(a);
        };
    }
    var k = $0b2e6adb871a3b94$var$cl(a, 0, !1, null, null, !1, !1, "", $0b2e6adb871a3b94$var$ql);
    a._reactRootContainer = k;
    a[$0b2e6adb871a3b94$var$uf] = k.current;
    $0b2e6adb871a3b94$var$sf(8 === a.nodeType ? a.parentNode : a);
    $0b2e6adb871a3b94$var$Sk(function() {
        $0b2e6adb871a3b94$var$gl(b, k, c, d);
    });
    return k;
}
function $0b2e6adb871a3b94$var$sl(a, b, c, d, e) {
    var f = c._reactRootContainer;
    if (f) {
        var g = f;
        if ("function" === typeof e) {
            var h = e;
            e = function() {
                var a = $0b2e6adb871a3b94$var$hl(g);
                h.call(a);
            };
        }
        $0b2e6adb871a3b94$var$gl(b, g, a, e);
    } else g = $0b2e6adb871a3b94$var$rl(c, b, a, e, d);
    return $0b2e6adb871a3b94$var$hl(g);
}
$0b2e6adb871a3b94$var$Ec = function(a) {
    switch(a.tag){
        case 3:
            var b = a.stateNode;
            if (b.current.memoizedState.isDehydrated) {
                var c = $0b2e6adb871a3b94$var$tc(b.pendingLanes);
                0 !== c && ($0b2e6adb871a3b94$var$Cc(b, c | 1), $0b2e6adb871a3b94$var$Ek(b, $0b2e6adb871a3b94$var$B()), 0 === ($0b2e6adb871a3b94$var$K & 6) && ($0b2e6adb871a3b94$var$Hj = $0b2e6adb871a3b94$var$B() + 500, $0b2e6adb871a3b94$var$jg()));
            }
            break;
        case 13:
            $0b2e6adb871a3b94$var$Sk(function() {
                var b = $0b2e6adb871a3b94$var$Zg(a, 1);
                if (null !== b) {
                    var c = $0b2e6adb871a3b94$var$L();
                    $0b2e6adb871a3b94$var$mh(b, a, 1, c);
                }
            }), $0b2e6adb871a3b94$var$jl(a, 1);
    }
};
$0b2e6adb871a3b94$var$Fc = function(a) {
    if (13 === a.tag) {
        var b = $0b2e6adb871a3b94$var$Zg(a, 134217728);
        if (null !== b) {
            var c = $0b2e6adb871a3b94$var$L();
            $0b2e6adb871a3b94$var$mh(b, a, 134217728, c);
        }
        $0b2e6adb871a3b94$var$jl(a, 134217728);
    }
};
$0b2e6adb871a3b94$var$Gc = function(a) {
    if (13 === a.tag) {
        var b = $0b2e6adb871a3b94$var$lh(a), c = $0b2e6adb871a3b94$var$Zg(a, b);
        if (null !== c) {
            var d = $0b2e6adb871a3b94$var$L();
            $0b2e6adb871a3b94$var$mh(c, a, b, d);
        }
        $0b2e6adb871a3b94$var$jl(a, b);
    }
};
$0b2e6adb871a3b94$var$Hc = function() {
    return $0b2e6adb871a3b94$var$C;
};
$0b2e6adb871a3b94$var$Ic = function(a, b) {
    var c = $0b2e6adb871a3b94$var$C;
    try {
        return $0b2e6adb871a3b94$var$C = a, b();
    } finally{
        $0b2e6adb871a3b94$var$C = c;
    }
};
$0b2e6adb871a3b94$var$yb = function(a, b, c) {
    switch(b){
        case "input":
            $0b2e6adb871a3b94$var$bb(a, c);
            b = c.name;
            if ("radio" === c.type && null != b) {
                for(c = a; c.parentNode;)c = c.parentNode;
                c = c.querySelectorAll("input[name=" + JSON.stringify("" + b) + '][type="radio"]');
                for(b = 0; b < c.length; b++){
                    var d = c[b];
                    if (d !== a && d.form === a.form) {
                        var e = $0b2e6adb871a3b94$var$Db(d);
                        if (!e) throw Error($0b2e6adb871a3b94$var$p(90));
                        $0b2e6adb871a3b94$var$Wa(d);
                        $0b2e6adb871a3b94$var$bb(d, e);
                    }
                }
            }
            break;
        case "textarea":
            $0b2e6adb871a3b94$var$ib(a, c);
            break;
        case "select":
            b = c.value, null != b && $0b2e6adb871a3b94$var$fb(a, !!c.multiple, b, !1);
    }
};
$0b2e6adb871a3b94$var$Gb = $0b2e6adb871a3b94$var$Rk;
$0b2e6adb871a3b94$var$Hb = $0b2e6adb871a3b94$var$Sk;
var $0b2e6adb871a3b94$var$tl = {
    usingClientEntryPoint: !1,
    Events: [
        $0b2e6adb871a3b94$var$Cb,
        $0b2e6adb871a3b94$var$ue,
        $0b2e6adb871a3b94$var$Db,
        $0b2e6adb871a3b94$var$Eb,
        $0b2e6adb871a3b94$var$Fb,
        $0b2e6adb871a3b94$var$Rk
    ]
}, $0b2e6adb871a3b94$var$ul = {
    findFiberByHostInstance: $0b2e6adb871a3b94$var$Wc,
    bundleType: 0,
    version: "18.2.0",
    rendererPackageName: "react-dom"
};
var $0b2e6adb871a3b94$var$vl = {
    bundleType: $0b2e6adb871a3b94$var$ul.bundleType,
    version: $0b2e6adb871a3b94$var$ul.version,
    rendererPackageName: $0b2e6adb871a3b94$var$ul.rendererPackageName,
    rendererConfig: $0b2e6adb871a3b94$var$ul.rendererConfig,
    overrideHookState: null,
    overrideHookStateDeletePath: null,
    overrideHookStateRenamePath: null,
    overrideProps: null,
    overridePropsDeletePath: null,
    overridePropsRenamePath: null,
    setErrorHandler: null,
    setSuspenseHandler: null,
    scheduleUpdate: null,
    currentDispatcherRef: $0b2e6adb871a3b94$var$ua.ReactCurrentDispatcher,
    findHostInstanceByFiber: function(a) {
        a = $0b2e6adb871a3b94$var$Zb(a);
        return null === a ? null : a.stateNode;
    },
    findFiberByHostInstance: $0b2e6adb871a3b94$var$ul.findFiberByHostInstance || $0b2e6adb871a3b94$var$kl,
    findHostInstancesForRefresh: null,
    scheduleRefresh: null,
    scheduleRoot: null,
    setRefreshHandler: null,
    getCurrentFiber: null,
    reconcilerVersion: "18.2.0-next-9e3b772b8-20220608"
};
if ("undefined" !== typeof __REACT_DEVTOOLS_GLOBAL_HOOK__) {
    var $0b2e6adb871a3b94$var$wl = __REACT_DEVTOOLS_GLOBAL_HOOK__;
    if (!$0b2e6adb871a3b94$var$wl.isDisabled && $0b2e6adb871a3b94$var$wl.supportsFiber) try {
        $0b2e6adb871a3b94$var$kc = $0b2e6adb871a3b94$var$wl.inject($0b2e6adb871a3b94$var$vl), $0b2e6adb871a3b94$var$lc = $0b2e6adb871a3b94$var$wl;
    } catch (a) {}
}
$0b2e6adb871a3b94$export$ae55be85d98224ed = $0b2e6adb871a3b94$var$tl;
$0b2e6adb871a3b94$export$d39a5bbd09211389 = function(a, b) {
    var c = 2 < arguments.length && void 0 !== arguments[2] ? arguments[2] : null;
    if (!$0b2e6adb871a3b94$var$ol(b)) throw Error($0b2e6adb871a3b94$var$p(200));
    return $0b2e6adb871a3b94$var$dl(a, b, null, c);
};
$0b2e6adb871a3b94$export$882461b6382ed46c = function(a, b) {
    if (!$0b2e6adb871a3b94$var$ol(a)) throw Error($0b2e6adb871a3b94$var$p(299));
    var c = !1, d = "", e = $0b2e6adb871a3b94$var$ll;
    null !== b && void 0 !== b && (!0 === b.unstable_strictMode && (c = !0), void 0 !== b.identifierPrefix && (d = b.identifierPrefix), void 0 !== b.onRecoverableError && (e = b.onRecoverableError));
    b = $0b2e6adb871a3b94$var$cl(a, 1, !1, null, null, c, !1, d, e);
    a[$0b2e6adb871a3b94$var$uf] = b.current;
    $0b2e6adb871a3b94$var$sf(8 === a.nodeType ? a.parentNode : a);
    return new $0b2e6adb871a3b94$var$ml(b);
};
$0b2e6adb871a3b94$export$466bfc07425424d5 = function(a) {
    if (null == a) return null;
    if (1 === a.nodeType) return a;
    var b = a._reactInternals;
    if (void 0 === b) {
        if ("function" === typeof a.render) throw Error($0b2e6adb871a3b94$var$p(188));
        a = Object.keys(a).join(",");
        throw Error($0b2e6adb871a3b94$var$p(268, a));
    }
    a = $0b2e6adb871a3b94$var$Zb(b);
    a = null === a ? null : a.stateNode;
    return a;
};
$0b2e6adb871a3b94$export$cd75ccfd720a3cd4 = function(a) {
    return $0b2e6adb871a3b94$var$Sk(a);
};
$0b2e6adb871a3b94$export$fa8d919ba61d84db = function(a, b, c) {
    if (!$0b2e6adb871a3b94$var$pl(b)) throw Error($0b2e6adb871a3b94$var$p(200));
    return $0b2e6adb871a3b94$var$sl(null, a, b, !0, c);
};
$0b2e6adb871a3b94$export$757ceba2d55c277e = function(a, b, c) {
    if (!$0b2e6adb871a3b94$var$ol(a)) throw Error($0b2e6adb871a3b94$var$p(405));
    var d = null != c && c.hydratedSources || null, e = !1, f = "", g = $0b2e6adb871a3b94$var$ll;
    null !== c && void 0 !== c && (!0 === c.unstable_strictMode && (e = !0), void 0 !== c.identifierPrefix && (f = c.identifierPrefix), void 0 !== c.onRecoverableError && (g = c.onRecoverableError));
    b = $0b2e6adb871a3b94$var$fl(b, null, a, 1, null != c ? c : null, e, !1, f, g);
    a[$0b2e6adb871a3b94$var$uf] = b.current;
    $0b2e6adb871a3b94$var$sf(a);
    if (d) for(a = 0; a < d.length; a++)c = d[a], e = c._getVersion, e = e(c._source), null == b.mutableSourceEagerHydrationData ? b.mutableSourceEagerHydrationData = [
        c,
        e
    ] : b.mutableSourceEagerHydrationData.push(c, e);
    return new $0b2e6adb871a3b94$var$nl(b);
};
$0b2e6adb871a3b94$export$b3890eb0ae9dca99 = function(a, b, c) {
    if (!$0b2e6adb871a3b94$var$pl(b)) throw Error($0b2e6adb871a3b94$var$p(200));
    return $0b2e6adb871a3b94$var$sl(null, a, b, !1, c);
};
$0b2e6adb871a3b94$export$502457920280e6be = function(a) {
    if (!$0b2e6adb871a3b94$var$pl(a)) throw Error($0b2e6adb871a3b94$var$p(40));
    return a._reactRootContainer ? ($0b2e6adb871a3b94$var$Sk(function() {
        $0b2e6adb871a3b94$var$sl(null, null, a, !1, function() {
            a._reactRootContainer = null;
            a[$0b2e6adb871a3b94$var$uf] = null;
        });
    }), !0) : !1;
};
$0b2e6adb871a3b94$export$c78a37762a8d58e1 = $0b2e6adb871a3b94$var$Rk;
$0b2e6adb871a3b94$export$dc54d992c10e8a18 = function(a, b, c, d) {
    if (!$0b2e6adb871a3b94$var$pl(c)) throw Error($0b2e6adb871a3b94$var$p(200));
    if (null == a || void 0 === a._reactInternals) throw Error($0b2e6adb871a3b94$var$p(38));
    return $0b2e6adb871a3b94$var$sl(a, b, c, !1, d);
};
$0b2e6adb871a3b94$export$83d89fbfd8236492 = "18.2.0-next-9e3b772b8-20220608";

});
parcelRegister("fO90s", function(module, exports) {
"use strict";

module.exports = (parcelRequire("gcnCG"));

});
parcelRegister("gcnCG", function(module, exports) {

$parcel$export(module.exports, "unstable_now", () => $bcb017604639e9d7$export$c4744153514ff05d, (v) => $bcb017604639e9d7$export$c4744153514ff05d = v);
$parcel$export(module.exports, "unstable_IdlePriority", () => $bcb017604639e9d7$export$3e506c1ccc9cc1a7, (v) => $bcb017604639e9d7$export$3e506c1ccc9cc1a7 = v);
$parcel$export(module.exports, "unstable_ImmediatePriority", () => $bcb017604639e9d7$export$e26fe2ed2fa76875, (v) => $bcb017604639e9d7$export$e26fe2ed2fa76875 = v);
$parcel$export(module.exports, "unstable_LowPriority", () => $bcb017604639e9d7$export$502329bbf4b505b1, (v) => $bcb017604639e9d7$export$502329bbf4b505b1 = v);
$parcel$export(module.exports, "unstable_NormalPriority", () => $bcb017604639e9d7$export$6e3807111c4874c4, (v) => $bcb017604639e9d7$export$6e3807111c4874c4 = v);
$parcel$export(module.exports, "unstable_Profiling", () => $bcb017604639e9d7$export$c27134553091fb3a, (v) => $bcb017604639e9d7$export$c27134553091fb3a = v);
$parcel$export(module.exports, "unstable_UserBlockingPriority", () => $bcb017604639e9d7$export$33ee1acdc04fd2a2, (v) => $bcb017604639e9d7$export$33ee1acdc04fd2a2 = v);
$parcel$export(module.exports, "unstable_cancelCallback", () => $bcb017604639e9d7$export$b00a404bbd5edef2, (v) => $bcb017604639e9d7$export$b00a404bbd5edef2 = v);
$parcel$export(module.exports, "unstable_continueExecution", () => $bcb017604639e9d7$export$8352ce38b91d0c62, (v) => $bcb017604639e9d7$export$8352ce38b91d0c62 = v);
$parcel$export(module.exports, "unstable_forceFrameRate", () => $bcb017604639e9d7$export$d66a1c1c77bd778b, (v) => $bcb017604639e9d7$export$d66a1c1c77bd778b = v);
$parcel$export(module.exports, "unstable_getCurrentPriorityLevel", () => $bcb017604639e9d7$export$d3dfb8e4810cb555, (v) => $bcb017604639e9d7$export$d3dfb8e4810cb555 = v);
$parcel$export(module.exports, "unstable_getFirstCallbackNode", () => $bcb017604639e9d7$export$839f9183b0465a69, (v) => $bcb017604639e9d7$export$839f9183b0465a69 = v);
$parcel$export(module.exports, "unstable_next", () => $bcb017604639e9d7$export$72fdf0e06517287b, (v) => $bcb017604639e9d7$export$72fdf0e06517287b = v);
$parcel$export(module.exports, "unstable_pauseExecution", () => $bcb017604639e9d7$export$4b844e58a3e414b4, (v) => $bcb017604639e9d7$export$4b844e58a3e414b4 = v);
$parcel$export(module.exports, "unstable_requestPaint", () => $bcb017604639e9d7$export$816d2913ae6b83b1, (v) => $bcb017604639e9d7$export$816d2913ae6b83b1 = v);
$parcel$export(module.exports, "unstable_runWithPriority", () => $bcb017604639e9d7$export$61bcfe829111a1d0, (v) => $bcb017604639e9d7$export$61bcfe829111a1d0 = v);
$parcel$export(module.exports, "unstable_scheduleCallback", () => $bcb017604639e9d7$export$7ee8c9beb337bc3f, (v) => $bcb017604639e9d7$export$7ee8c9beb337bc3f = v);
$parcel$export(module.exports, "unstable_shouldYield", () => $bcb017604639e9d7$export$b5836b71941fa3ed, (v) => $bcb017604639e9d7$export$b5836b71941fa3ed = v);
$parcel$export(module.exports, "unstable_wrapCallback", () => $bcb017604639e9d7$export$cf845f2c119da08a, (v) => $bcb017604639e9d7$export$cf845f2c119da08a = v);
/**
 * @license React
 * scheduler.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $bcb017604639e9d7$export$c4744153514ff05d;
var $bcb017604639e9d7$export$3e506c1ccc9cc1a7;
var $bcb017604639e9d7$export$e26fe2ed2fa76875;
var $bcb017604639e9d7$export$502329bbf4b505b1;
var $bcb017604639e9d7$export$6e3807111c4874c4;
var $bcb017604639e9d7$export$c27134553091fb3a;
var $bcb017604639e9d7$export$33ee1acdc04fd2a2;
var $bcb017604639e9d7$export$b00a404bbd5edef2;
var $bcb017604639e9d7$export$8352ce38b91d0c62;
var $bcb017604639e9d7$export$d66a1c1c77bd778b;
var $bcb017604639e9d7$export$d3dfb8e4810cb555;
var $bcb017604639e9d7$export$839f9183b0465a69;
var $bcb017604639e9d7$export$72fdf0e06517287b;
var $bcb017604639e9d7$export$4b844e58a3e414b4;
var $bcb017604639e9d7$export$816d2913ae6b83b1;
var $bcb017604639e9d7$export$61bcfe829111a1d0;
var $bcb017604639e9d7$export$7ee8c9beb337bc3f;
var $bcb017604639e9d7$export$b5836b71941fa3ed;
var $bcb017604639e9d7$export$cf845f2c119da08a;
"use strict";
function $bcb017604639e9d7$var$f(a, b) {
    var c = a.length;
    a.push(b);
    a: for(; 0 < c;){
        var d = c - 1 >>> 1, e = a[d];
        if (0 < $bcb017604639e9d7$var$g(e, b)) a[d] = b, a[c] = e, c = d;
        else break a;
    }
}
function $bcb017604639e9d7$var$h(a) {
    return 0 === a.length ? null : a[0];
}
function $bcb017604639e9d7$var$k(a) {
    if (0 === a.length) return null;
    var b = a[0], c = a.pop();
    if (c !== b) {
        a[0] = c;
        a: for(var d = 0, e = a.length, w = e >>> 1; d < w;){
            var m = 2 * (d + 1) - 1, C = a[m], n = m + 1, x = a[n];
            if (0 > $bcb017604639e9d7$var$g(C, c)) n < e && 0 > $bcb017604639e9d7$var$g(x, C) ? (a[d] = x, a[n] = c, d = n) : (a[d] = C, a[m] = c, d = m);
            else if (n < e && 0 > $bcb017604639e9d7$var$g(x, c)) a[d] = x, a[n] = c, d = n;
            else break a;
        }
    }
    return b;
}
function $bcb017604639e9d7$var$g(a, b) {
    var c = a.sortIndex - b.sortIndex;
    return 0 !== c ? c : a.id - b.id;
}
if ("object" === typeof performance && "function" === typeof performance.now) {
    var $bcb017604639e9d7$var$l = performance;
    $bcb017604639e9d7$export$c4744153514ff05d = function() {
        return $bcb017604639e9d7$var$l.now();
    };
} else {
    var $bcb017604639e9d7$var$p = Date, $bcb017604639e9d7$var$q = $bcb017604639e9d7$var$p.now();
    $bcb017604639e9d7$export$c4744153514ff05d = function() {
        return $bcb017604639e9d7$var$p.now() - $bcb017604639e9d7$var$q;
    };
}
var $bcb017604639e9d7$var$r = [], $bcb017604639e9d7$var$t = [], $bcb017604639e9d7$var$u = 1, $bcb017604639e9d7$var$v = null, $bcb017604639e9d7$var$y = 3, $bcb017604639e9d7$var$z = !1, $bcb017604639e9d7$var$A = !1, $bcb017604639e9d7$var$B = !1, $bcb017604639e9d7$var$D = "function" === typeof setTimeout ? setTimeout : null, $bcb017604639e9d7$var$E = "function" === typeof clearTimeout ? clearTimeout : null, $bcb017604639e9d7$var$F = "undefined" !== typeof setImmediate ? setImmediate : null;
"undefined" !== typeof navigator && void 0 !== navigator.scheduling && void 0 !== navigator.scheduling.isInputPending && navigator.scheduling.isInputPending.bind(navigator.scheduling);
function $bcb017604639e9d7$var$G(a) {
    for(var b = $bcb017604639e9d7$var$h($bcb017604639e9d7$var$t); null !== b;){
        if (null === b.callback) $bcb017604639e9d7$var$k($bcb017604639e9d7$var$t);
        else if (b.startTime <= a) $bcb017604639e9d7$var$k($bcb017604639e9d7$var$t), b.sortIndex = b.expirationTime, $bcb017604639e9d7$var$f($bcb017604639e9d7$var$r, b);
        else break;
        b = $bcb017604639e9d7$var$h($bcb017604639e9d7$var$t);
    }
}
function $bcb017604639e9d7$var$H(a) {
    $bcb017604639e9d7$var$B = !1;
    $bcb017604639e9d7$var$G(a);
    if (!$bcb017604639e9d7$var$A) {
        if (null !== $bcb017604639e9d7$var$h($bcb017604639e9d7$var$r)) $bcb017604639e9d7$var$A = !0, $bcb017604639e9d7$var$I($bcb017604639e9d7$var$J);
        else {
            var b = $bcb017604639e9d7$var$h($bcb017604639e9d7$var$t);
            null !== b && $bcb017604639e9d7$var$K($bcb017604639e9d7$var$H, b.startTime - a);
        }
    }
}
function $bcb017604639e9d7$var$J(a, b) {
    $bcb017604639e9d7$var$A = !1;
    $bcb017604639e9d7$var$B && ($bcb017604639e9d7$var$B = !1, $bcb017604639e9d7$var$E($bcb017604639e9d7$var$L), $bcb017604639e9d7$var$L = -1);
    $bcb017604639e9d7$var$z = !0;
    var c = $bcb017604639e9d7$var$y;
    try {
        $bcb017604639e9d7$var$G(b);
        for($bcb017604639e9d7$var$v = $bcb017604639e9d7$var$h($bcb017604639e9d7$var$r); null !== $bcb017604639e9d7$var$v && (!($bcb017604639e9d7$var$v.expirationTime > b) || a && !$bcb017604639e9d7$var$M());){
            var d = $bcb017604639e9d7$var$v.callback;
            if ("function" === typeof d) {
                $bcb017604639e9d7$var$v.callback = null;
                $bcb017604639e9d7$var$y = $bcb017604639e9d7$var$v.priorityLevel;
                var e = d($bcb017604639e9d7$var$v.expirationTime <= b);
                b = $bcb017604639e9d7$export$c4744153514ff05d();
                "function" === typeof e ? $bcb017604639e9d7$var$v.callback = e : $bcb017604639e9d7$var$v === $bcb017604639e9d7$var$h($bcb017604639e9d7$var$r) && $bcb017604639e9d7$var$k($bcb017604639e9d7$var$r);
                $bcb017604639e9d7$var$G(b);
            } else $bcb017604639e9d7$var$k($bcb017604639e9d7$var$r);
            $bcb017604639e9d7$var$v = $bcb017604639e9d7$var$h($bcb017604639e9d7$var$r);
        }
        if (null !== $bcb017604639e9d7$var$v) var w = !0;
        else {
            var m = $bcb017604639e9d7$var$h($bcb017604639e9d7$var$t);
            null !== m && $bcb017604639e9d7$var$K($bcb017604639e9d7$var$H, m.startTime - b);
            w = !1;
        }
        return w;
    } finally{
        $bcb017604639e9d7$var$v = null, $bcb017604639e9d7$var$y = c, $bcb017604639e9d7$var$z = !1;
    }
}
var $bcb017604639e9d7$var$N = !1, $bcb017604639e9d7$var$O = null, $bcb017604639e9d7$var$L = -1, $bcb017604639e9d7$var$P = 5, $bcb017604639e9d7$var$Q = -1;
function $bcb017604639e9d7$var$M() {
    return $bcb017604639e9d7$export$c4744153514ff05d() - $bcb017604639e9d7$var$Q < $bcb017604639e9d7$var$P ? !1 : !0;
}
function $bcb017604639e9d7$var$R() {
    if (null !== $bcb017604639e9d7$var$O) {
        var a = $bcb017604639e9d7$export$c4744153514ff05d();
        $bcb017604639e9d7$var$Q = a;
        var b = !0;
        try {
            b = $bcb017604639e9d7$var$O(!0, a);
        } finally{
            b ? $bcb017604639e9d7$var$S() : ($bcb017604639e9d7$var$N = !1, $bcb017604639e9d7$var$O = null);
        }
    } else $bcb017604639e9d7$var$N = !1;
}
var $bcb017604639e9d7$var$S;
if ("function" === typeof $bcb017604639e9d7$var$F) $bcb017604639e9d7$var$S = function() {
    $bcb017604639e9d7$var$F($bcb017604639e9d7$var$R);
};
else if ("undefined" !== typeof MessageChannel) {
    var $bcb017604639e9d7$var$T = new MessageChannel, $bcb017604639e9d7$var$U = $bcb017604639e9d7$var$T.port2;
    $bcb017604639e9d7$var$T.port1.onmessage = $bcb017604639e9d7$var$R;
    $bcb017604639e9d7$var$S = function() {
        $bcb017604639e9d7$var$U.postMessage(null);
    };
} else $bcb017604639e9d7$var$S = function() {
    $bcb017604639e9d7$var$D($bcb017604639e9d7$var$R, 0);
};
function $bcb017604639e9d7$var$I(a) {
    $bcb017604639e9d7$var$O = a;
    $bcb017604639e9d7$var$N || ($bcb017604639e9d7$var$N = !0, $bcb017604639e9d7$var$S());
}
function $bcb017604639e9d7$var$K(a, b) {
    $bcb017604639e9d7$var$L = $bcb017604639e9d7$var$D(function() {
        a($bcb017604639e9d7$export$c4744153514ff05d());
    }, b);
}
$bcb017604639e9d7$export$3e506c1ccc9cc1a7 = 5;
$bcb017604639e9d7$export$e26fe2ed2fa76875 = 1;
$bcb017604639e9d7$export$502329bbf4b505b1 = 4;
$bcb017604639e9d7$export$6e3807111c4874c4 = 3;
$bcb017604639e9d7$export$c27134553091fb3a = null;
$bcb017604639e9d7$export$33ee1acdc04fd2a2 = 2;
$bcb017604639e9d7$export$b00a404bbd5edef2 = function(a) {
    a.callback = null;
};
$bcb017604639e9d7$export$8352ce38b91d0c62 = function() {
    $bcb017604639e9d7$var$A || $bcb017604639e9d7$var$z || ($bcb017604639e9d7$var$A = !0, $bcb017604639e9d7$var$I($bcb017604639e9d7$var$J));
};
$bcb017604639e9d7$export$d66a1c1c77bd778b = function(a) {
    0 > a || 125 < a ? console.error("forceFrameRate takes a positive int between 0 and 125, forcing frame rates higher than 125 fps is not supported") : $bcb017604639e9d7$var$P = 0 < a ? Math.floor(1E3 / a) : 5;
};
$bcb017604639e9d7$export$d3dfb8e4810cb555 = function() {
    return $bcb017604639e9d7$var$y;
};
$bcb017604639e9d7$export$839f9183b0465a69 = function() {
    return $bcb017604639e9d7$var$h($bcb017604639e9d7$var$r);
};
$bcb017604639e9d7$export$72fdf0e06517287b = function(a) {
    switch($bcb017604639e9d7$var$y){
        case 1:
        case 2:
        case 3:
            var b = 3;
            break;
        default:
            b = $bcb017604639e9d7$var$y;
    }
    var c = $bcb017604639e9d7$var$y;
    $bcb017604639e9d7$var$y = b;
    try {
        return a();
    } finally{
        $bcb017604639e9d7$var$y = c;
    }
};
$bcb017604639e9d7$export$4b844e58a3e414b4 = function() {};
$bcb017604639e9d7$export$816d2913ae6b83b1 = function() {};
$bcb017604639e9d7$export$61bcfe829111a1d0 = function(a, b) {
    switch(a){
        case 1:
        case 2:
        case 3:
        case 4:
        case 5:
            break;
        default:
            a = 3;
    }
    var c = $bcb017604639e9d7$var$y;
    $bcb017604639e9d7$var$y = a;
    try {
        return b();
    } finally{
        $bcb017604639e9d7$var$y = c;
    }
};
$bcb017604639e9d7$export$7ee8c9beb337bc3f = function(a, b, c) {
    var d = $bcb017604639e9d7$export$c4744153514ff05d();
    "object" === typeof c && null !== c ? (c = c.delay, c = "number" === typeof c && 0 < c ? d + c : d) : c = d;
    switch(a){
        case 1:
            var e = -1;
            break;
        case 2:
            e = 250;
            break;
        case 5:
            e = 1073741823;
            break;
        case 4:
            e = 1E4;
            break;
        default:
            e = 5E3;
    }
    e = c + e;
    a = {
        id: $bcb017604639e9d7$var$u++,
        callback: b,
        priorityLevel: a,
        startTime: c,
        expirationTime: e,
        sortIndex: -1
    };
    c > d ? (a.sortIndex = c, $bcb017604639e9d7$var$f($bcb017604639e9d7$var$t, a), null === $bcb017604639e9d7$var$h($bcb017604639e9d7$var$r) && a === $bcb017604639e9d7$var$h($bcb017604639e9d7$var$t) && ($bcb017604639e9d7$var$B ? ($bcb017604639e9d7$var$E($bcb017604639e9d7$var$L), $bcb017604639e9d7$var$L = -1) : $bcb017604639e9d7$var$B = !0, $bcb017604639e9d7$var$K($bcb017604639e9d7$var$H, c - d))) : (a.sortIndex = e, $bcb017604639e9d7$var$f($bcb017604639e9d7$var$r, a), $bcb017604639e9d7$var$A || $bcb017604639e9d7$var$z || ($bcb017604639e9d7$var$A = !0, $bcb017604639e9d7$var$I($bcb017604639e9d7$var$J)));
    return a;
};
$bcb017604639e9d7$export$b5836b71941fa3ed = $bcb017604639e9d7$var$M;
$bcb017604639e9d7$export$cf845f2c119da08a = function(a) {
    var b = $bcb017604639e9d7$var$y;
    return function() {
        var c = $bcb017604639e9d7$var$y;
        $bcb017604639e9d7$var$y = b;
        try {
            return a.apply(this, arguments);
        } finally{
            $bcb017604639e9d7$var$y = c;
        }
    };
};

});



parcelRegister("6ZWSX", function(module, exports) {

$parcel$export(module.exports, "Buffer", () => $51861dfc7ca9d588$export$a143d493d941bafc, (v) => $51861dfc7ca9d588$export$a143d493d941bafc = v);
$parcel$export(module.exports, "SlowBuffer", () => $51861dfc7ca9d588$export$e4cf37d7f6fb9e0a, (v) => $51861dfc7ca9d588$export$e4cf37d7f6fb9e0a = v);
$parcel$export(module.exports, "INSPECT_MAX_BYTES", () => $51861dfc7ca9d588$export$f99ded8fe4b79145, (v) => $51861dfc7ca9d588$export$f99ded8fe4b79145 = v);
$parcel$export(module.exports, "kMaxLength", () => $51861dfc7ca9d588$export$599f31c3813fae4d, (v) => $51861dfc7ca9d588$export$599f31c3813fae4d = v);
/*!
 * The buffer module from node.js, for the browser.
 *
 * @author   Feross Aboukhadijeh <https://feross.org>
 * @license  MIT
 */ /* eslint-disable no-proto */ var $51861dfc7ca9d588$export$a143d493d941bafc;
var $51861dfc7ca9d588$export$e4cf37d7f6fb9e0a;
var $51861dfc7ca9d588$export$f99ded8fe4b79145;
var $51861dfc7ca9d588$export$599f31c3813fae4d;
"use strict";

var $kuxul = parcelRequire("kuxul");

var $9NvM5 = parcelRequire("9NvM5");
const $51861dfc7ca9d588$var$customInspectSymbol = typeof Symbol === "function" && typeof Symbol["for"] === "function" // eslint-disable-line dot-notation
 ? Symbol["for"]("nodejs.util.inspect.custom") // eslint-disable-line dot-notation
 : null;
$51861dfc7ca9d588$export$a143d493d941bafc = $51861dfc7ca9d588$var$Buffer;
$51861dfc7ca9d588$export$e4cf37d7f6fb9e0a = $51861dfc7ca9d588$var$SlowBuffer;
$51861dfc7ca9d588$export$f99ded8fe4b79145 = 50;
const $51861dfc7ca9d588$var$K_MAX_LENGTH = 0x7fffffff;
$51861dfc7ca9d588$export$599f31c3813fae4d = $51861dfc7ca9d588$var$K_MAX_LENGTH;
/**
 * If `Buffer.TYPED_ARRAY_SUPPORT`:
 *   === true    Use Uint8Array implementation (fastest)
 *   === false   Print warning and recommend using `buffer` v4.x which has an Object
 *               implementation (most compatible, even IE6)
 *
 * Browsers that support typed arrays are IE 10+, Firefox 4+, Chrome 7+, Safari 5.1+,
 * Opera 11.6+, iOS 4.2+.
 *
 * We report that the browser does not support typed arrays if the are not subclassable
 * using __proto__. Firefox 4-29 lacks support for adding new properties to `Uint8Array`
 * (See: https://bugzilla.mozilla.org/show_bug.cgi?id=695438). IE 10 lacks support
 * for __proto__ and has a buggy typed array implementation.
 */ $51861dfc7ca9d588$var$Buffer.TYPED_ARRAY_SUPPORT = $51861dfc7ca9d588$var$typedArraySupport();
if (!$51861dfc7ca9d588$var$Buffer.TYPED_ARRAY_SUPPORT && typeof console !== "undefined" && typeof console.error === "function") console.error("This browser lacks typed array (Uint8Array) support which is required by `buffer` v5.x. Use `buffer` v4.x if you require old browser support.");
function $51861dfc7ca9d588$var$typedArraySupport() {
    // Can typed array instances can be augmented?
    try {
        const arr = new Uint8Array(1);
        const proto = {
            foo: function() {
                return 42;
            }
        };
        Object.setPrototypeOf(proto, Uint8Array.prototype);
        Object.setPrototypeOf(arr, proto);
        return arr.foo() === 42;
    } catch (e) {
        return false;
    }
}
Object.defineProperty($51861dfc7ca9d588$var$Buffer.prototype, "parent", {
    enumerable: true,
    get: function() {
        if (!$51861dfc7ca9d588$var$Buffer.isBuffer(this)) return undefined;
        return this.buffer;
    }
});
Object.defineProperty($51861dfc7ca9d588$var$Buffer.prototype, "offset", {
    enumerable: true,
    get: function() {
        if (!$51861dfc7ca9d588$var$Buffer.isBuffer(this)) return undefined;
        return this.byteOffset;
    }
});
function $51861dfc7ca9d588$var$createBuffer(length) {
    if (length > $51861dfc7ca9d588$var$K_MAX_LENGTH) throw new RangeError('The value "' + length + '" is invalid for option "size"');
    // Return an augmented `Uint8Array` instance
    const buf = new Uint8Array(length);
    Object.setPrototypeOf(buf, $51861dfc7ca9d588$var$Buffer.prototype);
    return buf;
}
/**
 * The Buffer constructor returns instances of `Uint8Array` that have their
 * prototype changed to `Buffer.prototype`. Furthermore, `Buffer` is a subclass of
 * `Uint8Array`, so the returned instances will have all the node `Buffer` methods
 * and the `Uint8Array` methods. Square bracket notation works as expected -- it
 * returns a single octet.
 *
 * The `Uint8Array` prototype remains unmodified.
 */ function $51861dfc7ca9d588$var$Buffer(arg, encodingOrOffset, length) {
    // Common case.
    if (typeof arg === "number") {
        if (typeof encodingOrOffset === "string") throw new TypeError('The "string" argument must be of type string. Received type number');
        return $51861dfc7ca9d588$var$allocUnsafe(arg);
    }
    return $51861dfc7ca9d588$var$from(arg, encodingOrOffset, length);
}
$51861dfc7ca9d588$var$Buffer.poolSize = 8192 // not used by this implementation
;
function $51861dfc7ca9d588$var$from(value, encodingOrOffset, length) {
    if (typeof value === "string") return $51861dfc7ca9d588$var$fromString(value, encodingOrOffset);
    if (ArrayBuffer.isView(value)) return $51861dfc7ca9d588$var$fromArrayView(value);
    if (value == null) throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof value);
    if ($51861dfc7ca9d588$var$isInstance(value, ArrayBuffer) || value && $51861dfc7ca9d588$var$isInstance(value.buffer, ArrayBuffer)) return $51861dfc7ca9d588$var$fromArrayBuffer(value, encodingOrOffset, length);
    if (typeof SharedArrayBuffer !== "undefined" && ($51861dfc7ca9d588$var$isInstance(value, SharedArrayBuffer) || value && $51861dfc7ca9d588$var$isInstance(value.buffer, SharedArrayBuffer))) return $51861dfc7ca9d588$var$fromArrayBuffer(value, encodingOrOffset, length);
    if (typeof value === "number") throw new TypeError('The "value" argument must not be of type number. Received type number');
    const valueOf = value.valueOf && value.valueOf();
    if (valueOf != null && valueOf !== value) return $51861dfc7ca9d588$var$Buffer.from(valueOf, encodingOrOffset, length);
    const b = $51861dfc7ca9d588$var$fromObject(value);
    if (b) return b;
    if (typeof Symbol !== "undefined" && Symbol.toPrimitive != null && typeof value[Symbol.toPrimitive] === "function") return $51861dfc7ca9d588$var$Buffer.from(value[Symbol.toPrimitive]("string"), encodingOrOffset, length);
    throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof value);
}
/**
 * Functionally equivalent to Buffer(arg, encoding) but throws a TypeError
 * if value is a number.
 * Buffer.from(str[, encoding])
 * Buffer.from(array)
 * Buffer.from(buffer)
 * Buffer.from(arrayBuffer[, byteOffset[, length]])
 **/ $51861dfc7ca9d588$var$Buffer.from = function(value, encodingOrOffset, length) {
    return $51861dfc7ca9d588$var$from(value, encodingOrOffset, length);
};
// Note: Change prototype *after* Buffer.from is defined to workaround Chrome bug:
// https://github.com/feross/buffer/pull/148
Object.setPrototypeOf($51861dfc7ca9d588$var$Buffer.prototype, Uint8Array.prototype);
Object.setPrototypeOf($51861dfc7ca9d588$var$Buffer, Uint8Array);
function $51861dfc7ca9d588$var$assertSize(size) {
    if (typeof size !== "number") throw new TypeError('"size" argument must be of type number');
    else if (size < 0) throw new RangeError('The value "' + size + '" is invalid for option "size"');
}
function $51861dfc7ca9d588$var$alloc(size, fill, encoding) {
    $51861dfc7ca9d588$var$assertSize(size);
    if (size <= 0) return $51861dfc7ca9d588$var$createBuffer(size);
    if (fill !== undefined) // Only pay attention to encoding if it's a string. This
    // prevents accidentally sending in a number that would
    // be interpreted as a start offset.
    return typeof encoding === "string" ? $51861dfc7ca9d588$var$createBuffer(size).fill(fill, encoding) : $51861dfc7ca9d588$var$createBuffer(size).fill(fill);
    return $51861dfc7ca9d588$var$createBuffer(size);
}
/**
 * Creates a new filled Buffer instance.
 * alloc(size[, fill[, encoding]])
 **/ $51861dfc7ca9d588$var$Buffer.alloc = function(size, fill, encoding) {
    return $51861dfc7ca9d588$var$alloc(size, fill, encoding);
};
function $51861dfc7ca9d588$var$allocUnsafe(size) {
    $51861dfc7ca9d588$var$assertSize(size);
    return $51861dfc7ca9d588$var$createBuffer(size < 0 ? 0 : $51861dfc7ca9d588$var$checked(size) | 0);
}
/**
 * Equivalent to Buffer(num), by default creates a non-zero-filled Buffer instance.
 * */ $51861dfc7ca9d588$var$Buffer.allocUnsafe = function(size) {
    return $51861dfc7ca9d588$var$allocUnsafe(size);
};
/**
 * Equivalent to SlowBuffer(num), by default creates a non-zero-filled Buffer instance.
 */ $51861dfc7ca9d588$var$Buffer.allocUnsafeSlow = function(size) {
    return $51861dfc7ca9d588$var$allocUnsafe(size);
};
function $51861dfc7ca9d588$var$fromString(string, encoding) {
    if (typeof encoding !== "string" || encoding === "") encoding = "utf8";
    if (!$51861dfc7ca9d588$var$Buffer.isEncoding(encoding)) throw new TypeError("Unknown encoding: " + encoding);
    const length = $51861dfc7ca9d588$var$byteLength(string, encoding) | 0;
    let buf = $51861dfc7ca9d588$var$createBuffer(length);
    const actual = buf.write(string, encoding);
    if (actual !== length) // Writing a hex string, for example, that contains invalid characters will
    // cause everything after the first invalid character to be ignored. (e.g.
    // 'abxxcd' will be treated as 'ab')
    buf = buf.slice(0, actual);
    return buf;
}
function $51861dfc7ca9d588$var$fromArrayLike(array) {
    const length = array.length < 0 ? 0 : $51861dfc7ca9d588$var$checked(array.length) | 0;
    const buf = $51861dfc7ca9d588$var$createBuffer(length);
    for(let i = 0; i < length; i += 1)buf[i] = array[i] & 255;
    return buf;
}
function $51861dfc7ca9d588$var$fromArrayView(arrayView) {
    if ($51861dfc7ca9d588$var$isInstance(arrayView, Uint8Array)) {
        const copy = new Uint8Array(arrayView);
        return $51861dfc7ca9d588$var$fromArrayBuffer(copy.buffer, copy.byteOffset, copy.byteLength);
    }
    return $51861dfc7ca9d588$var$fromArrayLike(arrayView);
}
function $51861dfc7ca9d588$var$fromArrayBuffer(array, byteOffset, length) {
    if (byteOffset < 0 || array.byteLength < byteOffset) throw new RangeError('"offset" is outside of buffer bounds');
    if (array.byteLength < byteOffset + (length || 0)) throw new RangeError('"length" is outside of buffer bounds');
    let buf;
    if (byteOffset === undefined && length === undefined) buf = new Uint8Array(array);
    else if (length === undefined) buf = new Uint8Array(array, byteOffset);
    else buf = new Uint8Array(array, byteOffset, length);
    // Return an augmented `Uint8Array` instance
    Object.setPrototypeOf(buf, $51861dfc7ca9d588$var$Buffer.prototype);
    return buf;
}
function $51861dfc7ca9d588$var$fromObject(obj) {
    if ($51861dfc7ca9d588$var$Buffer.isBuffer(obj)) {
        const len = $51861dfc7ca9d588$var$checked(obj.length) | 0;
        const buf = $51861dfc7ca9d588$var$createBuffer(len);
        if (buf.length === 0) return buf;
        obj.copy(buf, 0, 0, len);
        return buf;
    }
    if (obj.length !== undefined) {
        if (typeof obj.length !== "number" || $51861dfc7ca9d588$var$numberIsNaN(obj.length)) return $51861dfc7ca9d588$var$createBuffer(0);
        return $51861dfc7ca9d588$var$fromArrayLike(obj);
    }
    if (obj.type === "Buffer" && Array.isArray(obj.data)) return $51861dfc7ca9d588$var$fromArrayLike(obj.data);
}
function $51861dfc7ca9d588$var$checked(length) {
    // Note: cannot use `length < K_MAX_LENGTH` here because that fails when
    // length is NaN (which is otherwise coerced to zero.)
    if (length >= $51861dfc7ca9d588$var$K_MAX_LENGTH) throw new RangeError("Attempt to allocate Buffer larger than maximum size: 0x" + $51861dfc7ca9d588$var$K_MAX_LENGTH.toString(16) + " bytes");
    return length | 0;
}
function $51861dfc7ca9d588$var$SlowBuffer(length) {
    if (+length != length) length = 0;
    return $51861dfc7ca9d588$var$Buffer.alloc(+length);
}
$51861dfc7ca9d588$var$Buffer.isBuffer = function isBuffer(b) {
    return b != null && b._isBuffer === true && b !== $51861dfc7ca9d588$var$Buffer.prototype // so Buffer.isBuffer(Buffer.prototype) will be false
    ;
};
$51861dfc7ca9d588$var$Buffer.compare = function compare(a, b) {
    if ($51861dfc7ca9d588$var$isInstance(a, Uint8Array)) a = $51861dfc7ca9d588$var$Buffer.from(a, a.offset, a.byteLength);
    if ($51861dfc7ca9d588$var$isInstance(b, Uint8Array)) b = $51861dfc7ca9d588$var$Buffer.from(b, b.offset, b.byteLength);
    if (!$51861dfc7ca9d588$var$Buffer.isBuffer(a) || !$51861dfc7ca9d588$var$Buffer.isBuffer(b)) throw new TypeError('The "buf1", "buf2" arguments must be one of type Buffer or Uint8Array');
    if (a === b) return 0;
    let x = a.length;
    let y = b.length;
    for(let i = 0, len = Math.min(x, y); i < len; ++i)if (a[i] !== b[i]) {
        x = a[i];
        y = b[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
$51861dfc7ca9d588$var$Buffer.isEncoding = function isEncoding(encoding) {
    switch(String(encoding).toLowerCase()){
        case "hex":
        case "utf8":
        case "utf-8":
        case "ascii":
        case "latin1":
        case "binary":
        case "base64":
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
            return true;
        default:
            return false;
    }
};
$51861dfc7ca9d588$var$Buffer.concat = function concat(list, length) {
    if (!Array.isArray(list)) throw new TypeError('"list" argument must be an Array of Buffers');
    if (list.length === 0) return $51861dfc7ca9d588$var$Buffer.alloc(0);
    let i;
    if (length === undefined) {
        length = 0;
        for(i = 0; i < list.length; ++i)length += list[i].length;
    }
    const buffer = $51861dfc7ca9d588$var$Buffer.allocUnsafe(length);
    let pos = 0;
    for(i = 0; i < list.length; ++i){
        let buf = list[i];
        if ($51861dfc7ca9d588$var$isInstance(buf, Uint8Array)) {
            if (pos + buf.length > buffer.length) {
                if (!$51861dfc7ca9d588$var$Buffer.isBuffer(buf)) buf = $51861dfc7ca9d588$var$Buffer.from(buf);
                buf.copy(buffer, pos);
            } else Uint8Array.prototype.set.call(buffer, buf, pos);
        } else if (!$51861dfc7ca9d588$var$Buffer.isBuffer(buf)) throw new TypeError('"list" argument must be an Array of Buffers');
        else buf.copy(buffer, pos);
        pos += buf.length;
    }
    return buffer;
};
function $51861dfc7ca9d588$var$byteLength(string, encoding) {
    if ($51861dfc7ca9d588$var$Buffer.isBuffer(string)) return string.length;
    if (ArrayBuffer.isView(string) || $51861dfc7ca9d588$var$isInstance(string, ArrayBuffer)) return string.byteLength;
    if (typeof string !== "string") throw new TypeError('The "string" argument must be one of type string, Buffer, or ArrayBuffer. Received type ' + typeof string);
    const len = string.length;
    const mustMatch = arguments.length > 2 && arguments[2] === true;
    if (!mustMatch && len === 0) return 0;
    // Use a for loop to avoid recursion
    let loweredCase = false;
    for(;;)switch(encoding){
        case "ascii":
        case "latin1":
        case "binary":
            return len;
        case "utf8":
        case "utf-8":
            return $51861dfc7ca9d588$var$utf8ToBytes(string).length;
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
            return len * 2;
        case "hex":
            return len >>> 1;
        case "base64":
            return $51861dfc7ca9d588$var$base64ToBytes(string).length;
        default:
            if (loweredCase) return mustMatch ? -1 : $51861dfc7ca9d588$var$utf8ToBytes(string).length // assume utf8
            ;
            encoding = ("" + encoding).toLowerCase();
            loweredCase = true;
    }
}
$51861dfc7ca9d588$var$Buffer.byteLength = $51861dfc7ca9d588$var$byteLength;
function $51861dfc7ca9d588$var$slowToString(encoding, start, end) {
    let loweredCase = false;
    // No need to verify that "this.length <= MAX_UINT32" since it's a read-only
    // property of a typed array.
    // This behaves neither like String nor Uint8Array in that we set start/end
    // to their upper/lower bounds if the value passed is out of range.
    // undefined is handled specially as per ECMA-262 6th Edition,
    // Section 13.3.3.7 Runtime Semantics: KeyedBindingInitialization.
    if (start === undefined || start < 0) start = 0;
    // Return early if start > this.length. Done here to prevent potential uint32
    // coercion fail below.
    if (start > this.length) return "";
    if (end === undefined || end > this.length) end = this.length;
    if (end <= 0) return "";
    // Force coercion to uint32. This will also coerce falsey/NaN values to 0.
    end >>>= 0;
    start >>>= 0;
    if (end <= start) return "";
    if (!encoding) encoding = "utf8";
    while(true)switch(encoding){
        case "hex":
            return $51861dfc7ca9d588$var$hexSlice(this, start, end);
        case "utf8":
        case "utf-8":
            return $51861dfc7ca9d588$var$utf8Slice(this, start, end);
        case "ascii":
            return $51861dfc7ca9d588$var$asciiSlice(this, start, end);
        case "latin1":
        case "binary":
            return $51861dfc7ca9d588$var$latin1Slice(this, start, end);
        case "base64":
            return $51861dfc7ca9d588$var$base64Slice(this, start, end);
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
            return $51861dfc7ca9d588$var$utf16leSlice(this, start, end);
        default:
            if (loweredCase) throw new TypeError("Unknown encoding: " + encoding);
            encoding = (encoding + "").toLowerCase();
            loweredCase = true;
    }
}
// This property is used by `Buffer.isBuffer` (and the `is-buffer` npm package)
// to detect a Buffer instance. It's not possible to use `instanceof Buffer`
// reliably in a browserify context because there could be multiple different
// copies of the 'buffer' package in use. This method works even for Buffer
// instances that were created from another copy of the `buffer` package.
// See: https://github.com/feross/buffer/issues/154
$51861dfc7ca9d588$var$Buffer.prototype._isBuffer = true;
function $51861dfc7ca9d588$var$swap(b, n, m) {
    const i = b[n];
    b[n] = b[m];
    b[m] = i;
}
$51861dfc7ca9d588$var$Buffer.prototype.swap16 = function swap16() {
    const len = this.length;
    if (len % 2 !== 0) throw new RangeError("Buffer size must be a multiple of 16-bits");
    for(let i = 0; i < len; i += 2)$51861dfc7ca9d588$var$swap(this, i, i + 1);
    return this;
};
$51861dfc7ca9d588$var$Buffer.prototype.swap32 = function swap32() {
    const len = this.length;
    if (len % 4 !== 0) throw new RangeError("Buffer size must be a multiple of 32-bits");
    for(let i = 0; i < len; i += 4){
        $51861dfc7ca9d588$var$swap(this, i, i + 3);
        $51861dfc7ca9d588$var$swap(this, i + 1, i + 2);
    }
    return this;
};
$51861dfc7ca9d588$var$Buffer.prototype.swap64 = function swap64() {
    const len = this.length;
    if (len % 8 !== 0) throw new RangeError("Buffer size must be a multiple of 64-bits");
    for(let i = 0; i < len; i += 8){
        $51861dfc7ca9d588$var$swap(this, i, i + 7);
        $51861dfc7ca9d588$var$swap(this, i + 1, i + 6);
        $51861dfc7ca9d588$var$swap(this, i + 2, i + 5);
        $51861dfc7ca9d588$var$swap(this, i + 3, i + 4);
    }
    return this;
};
$51861dfc7ca9d588$var$Buffer.prototype.toString = function toString() {
    const length = this.length;
    if (length === 0) return "";
    if (arguments.length === 0) return $51861dfc7ca9d588$var$utf8Slice(this, 0, length);
    return $51861dfc7ca9d588$var$slowToString.apply(this, arguments);
};
$51861dfc7ca9d588$var$Buffer.prototype.toLocaleString = $51861dfc7ca9d588$var$Buffer.prototype.toString;
$51861dfc7ca9d588$var$Buffer.prototype.equals = function equals(b) {
    if (!$51861dfc7ca9d588$var$Buffer.isBuffer(b)) throw new TypeError("Argument must be a Buffer");
    if (this === b) return true;
    return $51861dfc7ca9d588$var$Buffer.compare(this, b) === 0;
};
$51861dfc7ca9d588$var$Buffer.prototype.inspect = function inspect() {
    let str = "";
    const max = $51861dfc7ca9d588$export$f99ded8fe4b79145;
    str = this.toString("hex", 0, max).replace(/(.{2})/g, "$1 ").trim();
    if (this.length > max) str += " ... ";
    return "<Buffer " + str + ">";
};
if ($51861dfc7ca9d588$var$customInspectSymbol) $51861dfc7ca9d588$var$Buffer.prototype[$51861dfc7ca9d588$var$customInspectSymbol] = $51861dfc7ca9d588$var$Buffer.prototype.inspect;
$51861dfc7ca9d588$var$Buffer.prototype.compare = function compare(target, start, end, thisStart, thisEnd) {
    if ($51861dfc7ca9d588$var$isInstance(target, Uint8Array)) target = $51861dfc7ca9d588$var$Buffer.from(target, target.offset, target.byteLength);
    if (!$51861dfc7ca9d588$var$Buffer.isBuffer(target)) throw new TypeError('The "target" argument must be one of type Buffer or Uint8Array. Received type ' + typeof target);
    if (start === undefined) start = 0;
    if (end === undefined) end = target ? target.length : 0;
    if (thisStart === undefined) thisStart = 0;
    if (thisEnd === undefined) thisEnd = this.length;
    if (start < 0 || end > target.length || thisStart < 0 || thisEnd > this.length) throw new RangeError("out of range index");
    if (thisStart >= thisEnd && start >= end) return 0;
    if (thisStart >= thisEnd) return -1;
    if (start >= end) return 1;
    start >>>= 0;
    end >>>= 0;
    thisStart >>>= 0;
    thisEnd >>>= 0;
    if (this === target) return 0;
    let x = thisEnd - thisStart;
    let y = end - start;
    const len = Math.min(x, y);
    const thisCopy = this.slice(thisStart, thisEnd);
    const targetCopy = target.slice(start, end);
    for(let i = 0; i < len; ++i)if (thisCopy[i] !== targetCopy[i]) {
        x = thisCopy[i];
        y = targetCopy[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
// Finds either the first index of `val` in `buffer` at offset >= `byteOffset`,
// OR the last index of `val` in `buffer` at offset <= `byteOffset`.
//
// Arguments:
// - buffer - a Buffer to search
// - val - a string, Buffer, or number
// - byteOffset - an index into `buffer`; will be clamped to an int32
// - encoding - an optional encoding, relevant is val is a string
// - dir - true for indexOf, false for lastIndexOf
function $51861dfc7ca9d588$var$bidirectionalIndexOf(buffer, val, byteOffset, encoding, dir) {
    // Empty buffer means no match
    if (buffer.length === 0) return -1;
    // Normalize byteOffset
    if (typeof byteOffset === "string") {
        encoding = byteOffset;
        byteOffset = 0;
    } else if (byteOffset > 0x7fffffff) byteOffset = 0x7fffffff;
    else if (byteOffset < -2147483648) byteOffset = -2147483648;
    byteOffset = +byteOffset // Coerce to Number.
    ;
    if ($51861dfc7ca9d588$var$numberIsNaN(byteOffset)) // byteOffset: it it's undefined, null, NaN, "foo", etc, search whole buffer
    byteOffset = dir ? 0 : buffer.length - 1;
    // Normalize byteOffset: negative offsets start from the end of the buffer
    if (byteOffset < 0) byteOffset = buffer.length + byteOffset;
    if (byteOffset >= buffer.length) {
        if (dir) return -1;
        else byteOffset = buffer.length - 1;
    } else if (byteOffset < 0) {
        if (dir) byteOffset = 0;
        else return -1;
    }
    // Normalize val
    if (typeof val === "string") val = $51861dfc7ca9d588$var$Buffer.from(val, encoding);
    // Finally, search either indexOf (if dir is true) or lastIndexOf
    if ($51861dfc7ca9d588$var$Buffer.isBuffer(val)) {
        // Special case: looking for empty string/buffer always fails
        if (val.length === 0) return -1;
        return $51861dfc7ca9d588$var$arrayIndexOf(buffer, val, byteOffset, encoding, dir);
    } else if (typeof val === "number") {
        val = val & 0xFF // Search for a byte value [0-255]
        ;
        if (typeof Uint8Array.prototype.indexOf === "function") {
            if (dir) return Uint8Array.prototype.indexOf.call(buffer, val, byteOffset);
            else return Uint8Array.prototype.lastIndexOf.call(buffer, val, byteOffset);
        }
        return $51861dfc7ca9d588$var$arrayIndexOf(buffer, [
            val
        ], byteOffset, encoding, dir);
    }
    throw new TypeError("val must be string, number or Buffer");
}
function $51861dfc7ca9d588$var$arrayIndexOf(arr, val, byteOffset, encoding, dir) {
    let indexSize = 1;
    let arrLength = arr.length;
    let valLength = val.length;
    if (encoding !== undefined) {
        encoding = String(encoding).toLowerCase();
        if (encoding === "ucs2" || encoding === "ucs-2" || encoding === "utf16le" || encoding === "utf-16le") {
            if (arr.length < 2 || val.length < 2) return -1;
            indexSize = 2;
            arrLength /= 2;
            valLength /= 2;
            byteOffset /= 2;
        }
    }
    function read(buf, i) {
        if (indexSize === 1) return buf[i];
        else return buf.readUInt16BE(i * indexSize);
    }
    let i;
    if (dir) {
        let foundIndex = -1;
        for(i = byteOffset; i < arrLength; i++)if (read(arr, i) === read(val, foundIndex === -1 ? 0 : i - foundIndex)) {
            if (foundIndex === -1) foundIndex = i;
            if (i - foundIndex + 1 === valLength) return foundIndex * indexSize;
        } else {
            if (foundIndex !== -1) i -= i - foundIndex;
            foundIndex = -1;
        }
    } else {
        if (byteOffset + valLength > arrLength) byteOffset = arrLength - valLength;
        for(i = byteOffset; i >= 0; i--){
            let found = true;
            for(let j = 0; j < valLength; j++)if (read(arr, i + j) !== read(val, j)) {
                found = false;
                break;
            }
            if (found) return i;
        }
    }
    return -1;
}
$51861dfc7ca9d588$var$Buffer.prototype.includes = function includes(val, byteOffset, encoding) {
    return this.indexOf(val, byteOffset, encoding) !== -1;
};
$51861dfc7ca9d588$var$Buffer.prototype.indexOf = function indexOf(val, byteOffset, encoding) {
    return $51861dfc7ca9d588$var$bidirectionalIndexOf(this, val, byteOffset, encoding, true);
};
$51861dfc7ca9d588$var$Buffer.prototype.lastIndexOf = function lastIndexOf(val, byteOffset, encoding) {
    return $51861dfc7ca9d588$var$bidirectionalIndexOf(this, val, byteOffset, encoding, false);
};
function $51861dfc7ca9d588$var$hexWrite(buf, string, offset, length) {
    offset = Number(offset) || 0;
    const remaining = buf.length - offset;
    if (!length) length = remaining;
    else {
        length = Number(length);
        if (length > remaining) length = remaining;
    }
    const strLen = string.length;
    if (length > strLen / 2) length = strLen / 2;
    let i;
    for(i = 0; i < length; ++i){
        const parsed = parseInt(string.substr(i * 2, 2), 16);
        if ($51861dfc7ca9d588$var$numberIsNaN(parsed)) return i;
        buf[offset + i] = parsed;
    }
    return i;
}
function $51861dfc7ca9d588$var$utf8Write(buf, string, offset, length) {
    return $51861dfc7ca9d588$var$blitBuffer($51861dfc7ca9d588$var$utf8ToBytes(string, buf.length - offset), buf, offset, length);
}
function $51861dfc7ca9d588$var$asciiWrite(buf, string, offset, length) {
    return $51861dfc7ca9d588$var$blitBuffer($51861dfc7ca9d588$var$asciiToBytes(string), buf, offset, length);
}
function $51861dfc7ca9d588$var$base64Write(buf, string, offset, length) {
    return $51861dfc7ca9d588$var$blitBuffer($51861dfc7ca9d588$var$base64ToBytes(string), buf, offset, length);
}
function $51861dfc7ca9d588$var$ucs2Write(buf, string, offset, length) {
    return $51861dfc7ca9d588$var$blitBuffer($51861dfc7ca9d588$var$utf16leToBytes(string, buf.length - offset), buf, offset, length);
}
$51861dfc7ca9d588$var$Buffer.prototype.write = function write(string, offset, length, encoding) {
    // Buffer#write(string)
    if (offset === undefined) {
        encoding = "utf8";
        length = this.length;
        offset = 0;
    // Buffer#write(string, encoding)
    } else if (length === undefined && typeof offset === "string") {
        encoding = offset;
        length = this.length;
        offset = 0;
    // Buffer#write(string, offset[, length][, encoding])
    } else if (isFinite(offset)) {
        offset = offset >>> 0;
        if (isFinite(length)) {
            length = length >>> 0;
            if (encoding === undefined) encoding = "utf8";
        } else {
            encoding = length;
            length = undefined;
        }
    } else throw new Error("Buffer.write(string, encoding, offset[, length]) is no longer supported");
    const remaining = this.length - offset;
    if (length === undefined || length > remaining) length = remaining;
    if (string.length > 0 && (length < 0 || offset < 0) || offset > this.length) throw new RangeError("Attempt to write outside buffer bounds");
    if (!encoding) encoding = "utf8";
    let loweredCase = false;
    for(;;)switch(encoding){
        case "hex":
            return $51861dfc7ca9d588$var$hexWrite(this, string, offset, length);
        case "utf8":
        case "utf-8":
            return $51861dfc7ca9d588$var$utf8Write(this, string, offset, length);
        case "ascii":
        case "latin1":
        case "binary":
            return $51861dfc7ca9d588$var$asciiWrite(this, string, offset, length);
        case "base64":
            // Warning: maxLength not taken into account in base64Write
            return $51861dfc7ca9d588$var$base64Write(this, string, offset, length);
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
            return $51861dfc7ca9d588$var$ucs2Write(this, string, offset, length);
        default:
            if (loweredCase) throw new TypeError("Unknown encoding: " + encoding);
            encoding = ("" + encoding).toLowerCase();
            loweredCase = true;
    }
};
$51861dfc7ca9d588$var$Buffer.prototype.toJSON = function toJSON() {
    return {
        type: "Buffer",
        data: Array.prototype.slice.call(this._arr || this, 0)
    };
};
function $51861dfc7ca9d588$var$base64Slice(buf, start, end) {
    if (start === 0 && end === buf.length) return $kuxul.fromByteArray(buf);
    else return $kuxul.fromByteArray(buf.slice(start, end));
}
function $51861dfc7ca9d588$var$utf8Slice(buf, start, end) {
    end = Math.min(buf.length, end);
    const res = [];
    let i = start;
    while(i < end){
        const firstByte = buf[i];
        let codePoint = null;
        let bytesPerSequence = firstByte > 0xEF ? 4 : firstByte > 0xDF ? 3 : firstByte > 0xBF ? 2 : 1;
        if (i + bytesPerSequence <= end) {
            let secondByte, thirdByte, fourthByte, tempCodePoint;
            switch(bytesPerSequence){
                case 1:
                    if (firstByte < 0x80) codePoint = firstByte;
                    break;
                case 2:
                    secondByte = buf[i + 1];
                    if ((secondByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0x1F) << 0x6 | secondByte & 0x3F;
                        if (tempCodePoint > 0x7F) codePoint = tempCodePoint;
                    }
                    break;
                case 3:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0xC | (secondByte & 0x3F) << 0x6 | thirdByte & 0x3F;
                        if (tempCodePoint > 0x7FF && (tempCodePoint < 0xD800 || tempCodePoint > 0xDFFF)) codePoint = tempCodePoint;
                    }
                    break;
                case 4:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    fourthByte = buf[i + 3];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80 && (fourthByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0x12 | (secondByte & 0x3F) << 0xC | (thirdByte & 0x3F) << 0x6 | fourthByte & 0x3F;
                        if (tempCodePoint > 0xFFFF && tempCodePoint < 0x110000) codePoint = tempCodePoint;
                    }
            }
        }
        if (codePoint === null) {
            // we did not generate a valid codePoint so insert a
            // replacement char (U+FFFD) and advance only 1 byte
            codePoint = 0xFFFD;
            bytesPerSequence = 1;
        } else if (codePoint > 0xFFFF) {
            // encode to utf16 (surrogate pair dance)
            codePoint -= 0x10000;
            res.push(codePoint >>> 10 & 0x3FF | 0xD800);
            codePoint = 0xDC00 | codePoint & 0x3FF;
        }
        res.push(codePoint);
        i += bytesPerSequence;
    }
    return $51861dfc7ca9d588$var$decodeCodePointsArray(res);
}
// Based on http://stackoverflow.com/a/22747272/680742, the browser with
// the lowest limit is Chrome, with 0x10000 args.
// We go 1 magnitude less, for safety
const $51861dfc7ca9d588$var$MAX_ARGUMENTS_LENGTH = 0x1000;
function $51861dfc7ca9d588$var$decodeCodePointsArray(codePoints) {
    const len = codePoints.length;
    if (len <= $51861dfc7ca9d588$var$MAX_ARGUMENTS_LENGTH) return String.fromCharCode.apply(String, codePoints) // avoid extra slice()
    ;
    // Decode in chunks to avoid "call stack size exceeded".
    let res = "";
    let i = 0;
    while(i < len)res += String.fromCharCode.apply(String, codePoints.slice(i, i += $51861dfc7ca9d588$var$MAX_ARGUMENTS_LENGTH));
    return res;
}
function $51861dfc7ca9d588$var$asciiSlice(buf, start, end) {
    let ret = "";
    end = Math.min(buf.length, end);
    for(let i = start; i < end; ++i)ret += String.fromCharCode(buf[i] & 0x7F);
    return ret;
}
function $51861dfc7ca9d588$var$latin1Slice(buf, start, end) {
    let ret = "";
    end = Math.min(buf.length, end);
    for(let i = start; i < end; ++i)ret += String.fromCharCode(buf[i]);
    return ret;
}
function $51861dfc7ca9d588$var$hexSlice(buf, start, end) {
    const len = buf.length;
    if (!start || start < 0) start = 0;
    if (!end || end < 0 || end > len) end = len;
    let out = "";
    for(let i = start; i < end; ++i)out += $51861dfc7ca9d588$var$hexSliceLookupTable[buf[i]];
    return out;
}
function $51861dfc7ca9d588$var$utf16leSlice(buf, start, end) {
    const bytes = buf.slice(start, end);
    let res = "";
    // If bytes.length is odd, the last 8 bits must be ignored (same as node.js)
    for(let i = 0; i < bytes.length - 1; i += 2)res += String.fromCharCode(bytes[i] + bytes[i + 1] * 256);
    return res;
}
$51861dfc7ca9d588$var$Buffer.prototype.slice = function slice(start, end) {
    const len = this.length;
    start = ~~start;
    end = end === undefined ? len : ~~end;
    if (start < 0) {
        start += len;
        if (start < 0) start = 0;
    } else if (start > len) start = len;
    if (end < 0) {
        end += len;
        if (end < 0) end = 0;
    } else if (end > len) end = len;
    if (end < start) end = start;
    const newBuf = this.subarray(start, end);
    // Return an augmented `Uint8Array` instance
    Object.setPrototypeOf(newBuf, $51861dfc7ca9d588$var$Buffer.prototype);
    return newBuf;
};
/*
 * Need to make sure that buffer isn't trying to write out of bounds.
 */ function $51861dfc7ca9d588$var$checkOffset(offset, ext, length) {
    if (offset % 1 !== 0 || offset < 0) throw new RangeError("offset is not uint");
    if (offset + ext > length) throw new RangeError("Trying to access beyond buffer length");
}
$51861dfc7ca9d588$var$Buffer.prototype.readUintLE = $51861dfc7ca9d588$var$Buffer.prototype.readUIntLE = function readUIntLE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, byteLength, this.length);
    let val = this[offset];
    let mul = 1;
    let i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    return val;
};
$51861dfc7ca9d588$var$Buffer.prototype.readUintBE = $51861dfc7ca9d588$var$Buffer.prototype.readUIntBE = function readUIntBE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, byteLength, this.length);
    let val = this[offset + --byteLength];
    let mul = 1;
    while(byteLength > 0 && (mul *= 0x100))val += this[offset + --byteLength] * mul;
    return val;
};
$51861dfc7ca9d588$var$Buffer.prototype.readUint8 = $51861dfc7ca9d588$var$Buffer.prototype.readUInt8 = function readUInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 1, this.length);
    return this[offset];
};
$51861dfc7ca9d588$var$Buffer.prototype.readUint16LE = $51861dfc7ca9d588$var$Buffer.prototype.readUInt16LE = function readUInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 2, this.length);
    return this[offset] | this[offset + 1] << 8;
};
$51861dfc7ca9d588$var$Buffer.prototype.readUint16BE = $51861dfc7ca9d588$var$Buffer.prototype.readUInt16BE = function readUInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 2, this.length);
    return this[offset] << 8 | this[offset + 1];
};
$51861dfc7ca9d588$var$Buffer.prototype.readUint32LE = $51861dfc7ca9d588$var$Buffer.prototype.readUInt32LE = function readUInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 4, this.length);
    return (this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16) + this[offset + 3] * 0x1000000;
};
$51861dfc7ca9d588$var$Buffer.prototype.readUint32BE = $51861dfc7ca9d588$var$Buffer.prototype.readUInt32BE = function readUInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 4, this.length);
    return this[offset] * 0x1000000 + (this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3]);
};
$51861dfc7ca9d588$var$Buffer.prototype.readBigUInt64LE = $51861dfc7ca9d588$var$defineBigIntMethod(function readBigUInt64LE(offset) {
    offset = offset >>> 0;
    $51861dfc7ca9d588$var$validateNumber(offset, "offset");
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $51861dfc7ca9d588$var$boundsError(offset, this.length - 8);
    const lo = first + this[++offset] * 256 + this[++offset] * 2 ** 16 + this[++offset] * 2 ** 24;
    const hi = this[++offset] + this[++offset] * 256 + this[++offset] * 2 ** 16 + last * 2 ** 24;
    return BigInt(lo) + (BigInt(hi) << BigInt(32));
});
$51861dfc7ca9d588$var$Buffer.prototype.readBigUInt64BE = $51861dfc7ca9d588$var$defineBigIntMethod(function readBigUInt64BE(offset) {
    offset = offset >>> 0;
    $51861dfc7ca9d588$var$validateNumber(offset, "offset");
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $51861dfc7ca9d588$var$boundsError(offset, this.length - 8);
    const hi = first * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + this[++offset];
    const lo = this[++offset] * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + last;
    return (BigInt(hi) << BigInt(32)) + BigInt(lo);
});
$51861dfc7ca9d588$var$Buffer.prototype.readIntLE = function readIntLE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, byteLength, this.length);
    let val = this[offset];
    let mul = 1;
    let i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
$51861dfc7ca9d588$var$Buffer.prototype.readIntBE = function readIntBE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, byteLength, this.length);
    let i = byteLength;
    let mul = 1;
    let val = this[offset + --i];
    while(i > 0 && (mul *= 0x100))val += this[offset + --i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
$51861dfc7ca9d588$var$Buffer.prototype.readInt8 = function readInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 1, this.length);
    if (!(this[offset] & 0x80)) return this[offset];
    return (0xff - this[offset] + 1) * -1;
};
$51861dfc7ca9d588$var$Buffer.prototype.readInt16LE = function readInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 2, this.length);
    const val = this[offset] | this[offset + 1] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
$51861dfc7ca9d588$var$Buffer.prototype.readInt16BE = function readInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 2, this.length);
    const val = this[offset + 1] | this[offset] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
$51861dfc7ca9d588$var$Buffer.prototype.readInt32LE = function readInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 4, this.length);
    return this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16 | this[offset + 3] << 24;
};
$51861dfc7ca9d588$var$Buffer.prototype.readInt32BE = function readInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 4, this.length);
    return this[offset] << 24 | this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3];
};
$51861dfc7ca9d588$var$Buffer.prototype.readBigInt64LE = $51861dfc7ca9d588$var$defineBigIntMethod(function readBigInt64LE(offset) {
    offset = offset >>> 0;
    $51861dfc7ca9d588$var$validateNumber(offset, "offset");
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $51861dfc7ca9d588$var$boundsError(offset, this.length - 8);
    const val = this[offset + 4] + this[offset + 5] * 256 + this[offset + 6] * 2 ** 16 + (last << 24 // Overflow
    );
    return (BigInt(val) << BigInt(32)) + BigInt(first + this[++offset] * 256 + this[++offset] * 2 ** 16 + this[++offset] * 2 ** 24);
});
$51861dfc7ca9d588$var$Buffer.prototype.readBigInt64BE = $51861dfc7ca9d588$var$defineBigIntMethod(function readBigInt64BE(offset) {
    offset = offset >>> 0;
    $51861dfc7ca9d588$var$validateNumber(offset, "offset");
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $51861dfc7ca9d588$var$boundsError(offset, this.length - 8);
    const val = (first << 24) + // Overflow
    this[++offset] * 2 ** 16 + this[++offset] * 256 + this[++offset];
    return (BigInt(val) << BigInt(32)) + BigInt(this[++offset] * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + last);
});
$51861dfc7ca9d588$var$Buffer.prototype.readFloatLE = function readFloatLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 4, this.length);
    return $9NvM5.read(this, offset, true, 23, 4);
};
$51861dfc7ca9d588$var$Buffer.prototype.readFloatBE = function readFloatBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 4, this.length);
    return $9NvM5.read(this, offset, false, 23, 4);
};
$51861dfc7ca9d588$var$Buffer.prototype.readDoubleLE = function readDoubleLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 8, this.length);
    return $9NvM5.read(this, offset, true, 52, 8);
};
$51861dfc7ca9d588$var$Buffer.prototype.readDoubleBE = function readDoubleBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 8, this.length);
    return $9NvM5.read(this, offset, false, 52, 8);
};
function $51861dfc7ca9d588$var$checkInt(buf, value, offset, ext, max, min) {
    if (!$51861dfc7ca9d588$var$Buffer.isBuffer(buf)) throw new TypeError('"buffer" argument must be a Buffer instance');
    if (value > max || value < min) throw new RangeError('"value" argument is out of bounds');
    if (offset + ext > buf.length) throw new RangeError("Index out of range");
}
$51861dfc7ca9d588$var$Buffer.prototype.writeUintLE = $51861dfc7ca9d588$var$Buffer.prototype.writeUIntLE = function writeUIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
        const maxBytes = Math.pow(2, 8 * byteLength) - 1;
        $51861dfc7ca9d588$var$checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    let mul = 1;
    let i = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeUintBE = $51861dfc7ca9d588$var$Buffer.prototype.writeUIntBE = function writeUIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
        const maxBytes = Math.pow(2, 8 * byteLength) - 1;
        $51861dfc7ca9d588$var$checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    let i = byteLength - 1;
    let mul = 1;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeUint8 = $51861dfc7ca9d588$var$Buffer.prototype.writeUInt8 = function writeUInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 1, 0xff, 0);
    this[offset] = value & 0xff;
    return offset + 1;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeUint16LE = $51861dfc7ca9d588$var$Buffer.prototype.writeUInt16LE = function writeUInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 2, 0xffff, 0);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    return offset + 2;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeUint16BE = $51861dfc7ca9d588$var$Buffer.prototype.writeUInt16BE = function writeUInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 2, 0xffff, 0);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
    return offset + 2;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeUint32LE = $51861dfc7ca9d588$var$Buffer.prototype.writeUInt32LE = function writeUInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 4, 0xffffffff, 0);
    this[offset + 3] = value >>> 24;
    this[offset + 2] = value >>> 16;
    this[offset + 1] = value >>> 8;
    this[offset] = value & 0xff;
    return offset + 4;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeUint32BE = $51861dfc7ca9d588$var$Buffer.prototype.writeUInt32BE = function writeUInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 4, 0xffffffff, 0);
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
    return offset + 4;
};
function $51861dfc7ca9d588$var$wrtBigUInt64LE(buf, value, offset, min, max) {
    $51861dfc7ca9d588$var$checkIntBI(value, min, max, buf, offset, 7);
    let lo = Number(value & BigInt(0xffffffff));
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    let hi = Number(value >> BigInt(32) & BigInt(0xffffffff));
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    return offset;
}
function $51861dfc7ca9d588$var$wrtBigUInt64BE(buf, value, offset, min, max) {
    $51861dfc7ca9d588$var$checkIntBI(value, min, max, buf, offset, 7);
    let lo = Number(value & BigInt(0xffffffff));
    buf[offset + 7] = lo;
    lo = lo >> 8;
    buf[offset + 6] = lo;
    lo = lo >> 8;
    buf[offset + 5] = lo;
    lo = lo >> 8;
    buf[offset + 4] = lo;
    let hi = Number(value >> BigInt(32) & BigInt(0xffffffff));
    buf[offset + 3] = hi;
    hi = hi >> 8;
    buf[offset + 2] = hi;
    hi = hi >> 8;
    buf[offset + 1] = hi;
    hi = hi >> 8;
    buf[offset] = hi;
    return offset + 8;
}
$51861dfc7ca9d588$var$Buffer.prototype.writeBigUInt64LE = $51861dfc7ca9d588$var$defineBigIntMethod(function writeBigUInt64LE(value, offset = 0) {
    return $51861dfc7ca9d588$var$wrtBigUInt64LE(this, value, offset, BigInt(0), BigInt("0xffffffffffffffff"));
});
$51861dfc7ca9d588$var$Buffer.prototype.writeBigUInt64BE = $51861dfc7ca9d588$var$defineBigIntMethod(function writeBigUInt64BE(value, offset = 0) {
    return $51861dfc7ca9d588$var$wrtBigUInt64BE(this, value, offset, BigInt(0), BigInt("0xffffffffffffffff"));
});
$51861dfc7ca9d588$var$Buffer.prototype.writeIntLE = function writeIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
        const limit = Math.pow(2, 8 * byteLength - 1);
        $51861dfc7ca9d588$var$checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    let i = 0;
    let mul = 1;
    let sub = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i - 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeIntBE = function writeIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
        const limit = Math.pow(2, 8 * byteLength - 1);
        $51861dfc7ca9d588$var$checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    let i = byteLength - 1;
    let mul = 1;
    let sub = 0;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i + 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeInt8 = function writeInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 1, 0x7f, -128);
    if (value < 0) value = 0xff + value + 1;
    this[offset] = value & 0xff;
    return offset + 1;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeInt16LE = function writeInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 2, 0x7fff, -32768);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    return offset + 2;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeInt16BE = function writeInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 2, 0x7fff, -32768);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
    return offset + 2;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeInt32LE = function writeInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    this[offset + 2] = value >>> 16;
    this[offset + 3] = value >>> 24;
    return offset + 4;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeInt32BE = function writeInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    if (value < 0) value = 0xffffffff + value + 1;
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
    return offset + 4;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeBigInt64LE = $51861dfc7ca9d588$var$defineBigIntMethod(function writeBigInt64LE(value, offset = 0) {
    return $51861dfc7ca9d588$var$wrtBigUInt64LE(this, value, offset, -BigInt("0x8000000000000000"), BigInt("0x7fffffffffffffff"));
});
$51861dfc7ca9d588$var$Buffer.prototype.writeBigInt64BE = $51861dfc7ca9d588$var$defineBigIntMethod(function writeBigInt64BE(value, offset = 0) {
    return $51861dfc7ca9d588$var$wrtBigUInt64BE(this, value, offset, -BigInt("0x8000000000000000"), BigInt("0x7fffffffffffffff"));
});
function $51861dfc7ca9d588$var$checkIEEE754(buf, value, offset, ext, max, min) {
    if (offset + ext > buf.length) throw new RangeError("Index out of range");
    if (offset < 0) throw new RangeError("Index out of range");
}
function $51861dfc7ca9d588$var$writeFloat(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkIEEE754(buf, value, offset, 4, 3.4028234663852886e+38, -340282346638528860000000000000000000000);
    $9NvM5.write(buf, value, offset, littleEndian, 23, 4);
    return offset + 4;
}
$51861dfc7ca9d588$var$Buffer.prototype.writeFloatLE = function writeFloatLE(value, offset, noAssert) {
    return $51861dfc7ca9d588$var$writeFloat(this, value, offset, true, noAssert);
};
$51861dfc7ca9d588$var$Buffer.prototype.writeFloatBE = function writeFloatBE(value, offset, noAssert) {
    return $51861dfc7ca9d588$var$writeFloat(this, value, offset, false, noAssert);
};
function $51861dfc7ca9d588$var$writeDouble(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkIEEE754(buf, value, offset, 8, 1.7976931348623157E+308, -179769313486231570000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000);
    $9NvM5.write(buf, value, offset, littleEndian, 52, 8);
    return offset + 8;
}
$51861dfc7ca9d588$var$Buffer.prototype.writeDoubleLE = function writeDoubleLE(value, offset, noAssert) {
    return $51861dfc7ca9d588$var$writeDouble(this, value, offset, true, noAssert);
};
$51861dfc7ca9d588$var$Buffer.prototype.writeDoubleBE = function writeDoubleBE(value, offset, noAssert) {
    return $51861dfc7ca9d588$var$writeDouble(this, value, offset, false, noAssert);
};
// copy(targetBuffer, targetStart=0, sourceStart=0, sourceEnd=buffer.length)
$51861dfc7ca9d588$var$Buffer.prototype.copy = function copy(target, targetStart, start, end) {
    if (!$51861dfc7ca9d588$var$Buffer.isBuffer(target)) throw new TypeError("argument should be a Buffer");
    if (!start) start = 0;
    if (!end && end !== 0) end = this.length;
    if (targetStart >= target.length) targetStart = target.length;
    if (!targetStart) targetStart = 0;
    if (end > 0 && end < start) end = start;
    // Copy 0 bytes; we're done
    if (end === start) return 0;
    if (target.length === 0 || this.length === 0) return 0;
    // Fatal error conditions
    if (targetStart < 0) throw new RangeError("targetStart out of bounds");
    if (start < 0 || start >= this.length) throw new RangeError("Index out of range");
    if (end < 0) throw new RangeError("sourceEnd out of bounds");
    // Are we oob?
    if (end > this.length) end = this.length;
    if (target.length - targetStart < end - start) end = target.length - targetStart + start;
    const len = end - start;
    if (this === target && typeof Uint8Array.prototype.copyWithin === "function") // Use built-in when available, missing from IE11
    this.copyWithin(targetStart, start, end);
    else Uint8Array.prototype.set.call(target, this.subarray(start, end), targetStart);
    return len;
};
// Usage:
//    buffer.fill(number[, offset[, end]])
//    buffer.fill(buffer[, offset[, end]])
//    buffer.fill(string[, offset[, end]][, encoding])
$51861dfc7ca9d588$var$Buffer.prototype.fill = function fill(val, start, end, encoding) {
    // Handle string cases:
    if (typeof val === "string") {
        if (typeof start === "string") {
            encoding = start;
            start = 0;
            end = this.length;
        } else if (typeof end === "string") {
            encoding = end;
            end = this.length;
        }
        if (encoding !== undefined && typeof encoding !== "string") throw new TypeError("encoding must be a string");
        if (typeof encoding === "string" && !$51861dfc7ca9d588$var$Buffer.isEncoding(encoding)) throw new TypeError("Unknown encoding: " + encoding);
        if (val.length === 1) {
            const code = val.charCodeAt(0);
            if (encoding === "utf8" && code < 128 || encoding === "latin1") // Fast path: If `val` fits into a single byte, use that numeric value.
            val = code;
        }
    } else if (typeof val === "number") val = val & 255;
    else if (typeof val === "boolean") val = Number(val);
    // Invalid ranges are not set to a default, so can range check early.
    if (start < 0 || this.length < start || this.length < end) throw new RangeError("Out of range index");
    if (end <= start) return this;
    start = start >>> 0;
    end = end === undefined ? this.length : end >>> 0;
    if (!val) val = 0;
    let i;
    if (typeof val === "number") for(i = start; i < end; ++i)this[i] = val;
    else {
        const bytes = $51861dfc7ca9d588$var$Buffer.isBuffer(val) ? val : $51861dfc7ca9d588$var$Buffer.from(val, encoding);
        const len = bytes.length;
        if (len === 0) throw new TypeError('The value "' + val + '" is invalid for argument "value"');
        for(i = 0; i < end - start; ++i)this[i + start] = bytes[i % len];
    }
    return this;
};
// CUSTOM ERRORS
// =============
// Simplified versions from Node, changed for Buffer-only usage
const $51861dfc7ca9d588$var$errors = {};
function $51861dfc7ca9d588$var$E(sym, getMessage, Base) {
    $51861dfc7ca9d588$var$errors[sym] = class NodeError extends Base {
        constructor(){
            super();
            Object.defineProperty(this, "message", {
                value: getMessage.apply(this, arguments),
                writable: true,
                configurable: true
            });
            // Add the error code to the name to include it in the stack trace.
            this.name = `${this.name} [${sym}]`;
            // Access the stack to generate the error message including the error code
            // from the name.
            this.stack // eslint-disable-line no-unused-expressions
            ;
            // Reset the name to the actual name.
            delete this.name;
        }
        get code() {
            return sym;
        }
        set code(value) {
            Object.defineProperty(this, "code", {
                configurable: true,
                enumerable: true,
                value: value,
                writable: true
            });
        }
        toString() {
            return `${this.name} [${sym}]: ${this.message}`;
        }
    };
}
$51861dfc7ca9d588$var$E("ERR_BUFFER_OUT_OF_BOUNDS", function(name) {
    if (name) return `${name} is outside of buffer bounds`;
    return "Attempt to access memory outside buffer bounds";
}, RangeError);
$51861dfc7ca9d588$var$E("ERR_INVALID_ARG_TYPE", function(name, actual) {
    return `The "${name}" argument must be of type number. Received type ${typeof actual}`;
}, TypeError);
$51861dfc7ca9d588$var$E("ERR_OUT_OF_RANGE", function(str, range, input) {
    let msg = `The value of "${str}" is out of range.`;
    let received = input;
    if (Number.isInteger(input) && Math.abs(input) > 2 ** 32) received = $51861dfc7ca9d588$var$addNumericalSeparator(String(input));
    else if (typeof input === "bigint") {
        received = String(input);
        if (input > BigInt(2) ** BigInt(32) || input < -(BigInt(2) ** BigInt(32))) received = $51861dfc7ca9d588$var$addNumericalSeparator(received);
        received += "n";
    }
    msg += ` It must be ${range}. Received ${received}`;
    return msg;
}, RangeError);
function $51861dfc7ca9d588$var$addNumericalSeparator(val) {
    let res = "";
    let i = val.length;
    const start = val[0] === "-" ? 1 : 0;
    for(; i >= start + 4; i -= 3)res = `_${val.slice(i - 3, i)}${res}`;
    return `${val.slice(0, i)}${res}`;
}
// CHECK FUNCTIONS
// ===============
function $51861dfc7ca9d588$var$checkBounds(buf, offset, byteLength) {
    $51861dfc7ca9d588$var$validateNumber(offset, "offset");
    if (buf[offset] === undefined || buf[offset + byteLength] === undefined) $51861dfc7ca9d588$var$boundsError(offset, buf.length - (byteLength + 1));
}
function $51861dfc7ca9d588$var$checkIntBI(value, min, max, buf, offset, byteLength) {
    if (value > max || value < min) {
        const n = typeof min === "bigint" ? "n" : "";
        let range;
        if (byteLength > 3) {
            if (min === 0 || min === BigInt(0)) range = `>= 0${n} and < 2${n} ** ${(byteLength + 1) * 8}${n}`;
            else range = `>= -(2${n} ** ${(byteLength + 1) * 8 - 1}${n}) and < 2 ** ` + `${(byteLength + 1) * 8 - 1}${n}`;
        } else range = `>= ${min}${n} and <= ${max}${n}`;
        throw new $51861dfc7ca9d588$var$errors.ERR_OUT_OF_RANGE("value", range, value);
    }
    $51861dfc7ca9d588$var$checkBounds(buf, offset, byteLength);
}
function $51861dfc7ca9d588$var$validateNumber(value, name) {
    if (typeof value !== "number") throw new $51861dfc7ca9d588$var$errors.ERR_INVALID_ARG_TYPE(name, "number", value);
}
function $51861dfc7ca9d588$var$boundsError(value, length, type) {
    if (Math.floor(value) !== value) {
        $51861dfc7ca9d588$var$validateNumber(value, type);
        throw new $51861dfc7ca9d588$var$errors.ERR_OUT_OF_RANGE(type || "offset", "an integer", value);
    }
    if (length < 0) throw new $51861dfc7ca9d588$var$errors.ERR_BUFFER_OUT_OF_BOUNDS();
    throw new $51861dfc7ca9d588$var$errors.ERR_OUT_OF_RANGE(type || "offset", `>= ${type ? 1 : 0} and <= ${length}`, value);
}
// HELPER FUNCTIONS
// ================
const $51861dfc7ca9d588$var$INVALID_BASE64_RE = /[^+/0-9A-Za-z-_]/g;
function $51861dfc7ca9d588$var$base64clean(str) {
    // Node takes equal signs as end of the Base64 encoding
    str = str.split("=")[0];
    // Node strips out invalid characters like \n and \t from the string, base64-js does not
    str = str.trim().replace($51861dfc7ca9d588$var$INVALID_BASE64_RE, "");
    // Node converts strings with length < 2 to ''
    if (str.length < 2) return "";
    // Node allows for non-padded base64 strings (missing trailing ===), base64-js does not
    while(str.length % 4 !== 0)str = str + "=";
    return str;
}
function $51861dfc7ca9d588$var$utf8ToBytes(string, units) {
    units = units || Infinity;
    let codePoint;
    const length = string.length;
    let leadSurrogate = null;
    const bytes = [];
    for(let i = 0; i < length; ++i){
        codePoint = string.charCodeAt(i);
        // is surrogate component
        if (codePoint > 0xD7FF && codePoint < 0xE000) {
            // last char was a lead
            if (!leadSurrogate) {
                // no lead yet
                if (codePoint > 0xDBFF) {
                    // unexpected trail
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                } else if (i + 1 === length) {
                    // unpaired lead
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                }
                // valid lead
                leadSurrogate = codePoint;
                continue;
            }
            // 2 leads in a row
            if (codePoint < 0xDC00) {
                if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                leadSurrogate = codePoint;
                continue;
            }
            // valid surrogate pair
            codePoint = (leadSurrogate - 0xD800 << 10 | codePoint - 0xDC00) + 0x10000;
        } else if (leadSurrogate) // valid bmp char, but last char was a lead
        {
            if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
        }
        leadSurrogate = null;
        // encode utf8
        if (codePoint < 0x80) {
            if ((units -= 1) < 0) break;
            bytes.push(codePoint);
        } else if (codePoint < 0x800) {
            if ((units -= 2) < 0) break;
            bytes.push(codePoint >> 0x6 | 0xC0, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x10000) {
            if ((units -= 3) < 0) break;
            bytes.push(codePoint >> 0xC | 0xE0, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x110000) {
            if ((units -= 4) < 0) break;
            bytes.push(codePoint >> 0x12 | 0xF0, codePoint >> 0xC & 0x3F | 0x80, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else throw new Error("Invalid code point");
    }
    return bytes;
}
function $51861dfc7ca9d588$var$asciiToBytes(str) {
    const byteArray = [];
    for(let i = 0; i < str.length; ++i)// Node's code seems to be doing this and not & 0x7F..
    byteArray.push(str.charCodeAt(i) & 0xFF);
    return byteArray;
}
function $51861dfc7ca9d588$var$utf16leToBytes(str, units) {
    let c, hi, lo;
    const byteArray = [];
    for(let i = 0; i < str.length; ++i){
        if ((units -= 2) < 0) break;
        c = str.charCodeAt(i);
        hi = c >> 8;
        lo = c % 256;
        byteArray.push(lo);
        byteArray.push(hi);
    }
    return byteArray;
}
function $51861dfc7ca9d588$var$base64ToBytes(str) {
    return $kuxul.toByteArray($51861dfc7ca9d588$var$base64clean(str));
}
function $51861dfc7ca9d588$var$blitBuffer(src, dst, offset, length) {
    let i;
    for(i = 0; i < length; ++i){
        if (i + offset >= dst.length || i >= src.length) break;
        dst[i + offset] = src[i];
    }
    return i;
}
// ArrayBuffer or Uint8Array objects from other contexts (i.e. iframes) do not pass
// the `instanceof` check but they should be treated as of that type.
// See: https://github.com/feross/buffer/issues/166
function $51861dfc7ca9d588$var$isInstance(obj, type) {
    return obj instanceof type || obj != null && obj.constructor != null && obj.constructor.name != null && obj.constructor.name === type.name;
}
function $51861dfc7ca9d588$var$numberIsNaN(obj) {
    // For IE11 support
    return obj !== obj // eslint-disable-line no-self-compare
    ;
}
// Create lookup table for `toString('hex')`
// See: https://github.com/feross/buffer/issues/219
const $51861dfc7ca9d588$var$hexSliceLookupTable = function() {
    const alphabet = "0123456789abcdef";
    const table = new Array(256);
    for(let i = 0; i < 16; ++i){
        const i16 = i * 16;
        for(let j = 0; j < 16; ++j)table[i16 + j] = alphabet[i] + alphabet[j];
    }
    return table;
}();
// Return not function with Error if BigInt not supported
function $51861dfc7ca9d588$var$defineBigIntMethod(fn) {
    return typeof BigInt === "undefined" ? $51861dfc7ca9d588$var$BufferBigIntNotDefined : fn;
}
function $51861dfc7ca9d588$var$BufferBigIntNotDefined() {
    throw new Error("BigInt not supported");
}

});
parcelRegister("kuxul", function(module, exports) {

$parcel$export(module.exports, "toByteArray", () => $eeb0961446aae8e3$export$d622b2ad8d90c771, (v) => $eeb0961446aae8e3$export$d622b2ad8d90c771 = v);
$parcel$export(module.exports, "fromByteArray", () => $eeb0961446aae8e3$export$6100ba28696e12de, (v) => $eeb0961446aae8e3$export$6100ba28696e12de = v);
var $eeb0961446aae8e3$export$a48f0734ac7c2329;
var $eeb0961446aae8e3$export$d622b2ad8d90c771;
var $eeb0961446aae8e3$export$6100ba28696e12de;
"use strict";
$eeb0961446aae8e3$export$a48f0734ac7c2329 = $eeb0961446aae8e3$var$byteLength;
$eeb0961446aae8e3$export$d622b2ad8d90c771 = $eeb0961446aae8e3$var$toByteArray;
$eeb0961446aae8e3$export$6100ba28696e12de = $eeb0961446aae8e3$var$fromByteArray;
var $eeb0961446aae8e3$var$lookup = [];
var $eeb0961446aae8e3$var$revLookup = [];
var $eeb0961446aae8e3$var$Arr = typeof Uint8Array !== "undefined" ? Uint8Array : Array;
var $eeb0961446aae8e3$var$code = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/";
for(var $eeb0961446aae8e3$var$i = 0, $eeb0961446aae8e3$var$len = $eeb0961446aae8e3$var$code.length; $eeb0961446aae8e3$var$i < $eeb0961446aae8e3$var$len; ++$eeb0961446aae8e3$var$i){
    $eeb0961446aae8e3$var$lookup[$eeb0961446aae8e3$var$i] = $eeb0961446aae8e3$var$code[$eeb0961446aae8e3$var$i];
    $eeb0961446aae8e3$var$revLookup[$eeb0961446aae8e3$var$code.charCodeAt($eeb0961446aae8e3$var$i)] = $eeb0961446aae8e3$var$i;
}
// Support decoding URL-safe base64 strings, as Node.js does.
// See: https://en.wikipedia.org/wiki/Base64#URL_applications
$eeb0961446aae8e3$var$revLookup["-".charCodeAt(0)] = 62;
$eeb0961446aae8e3$var$revLookup["_".charCodeAt(0)] = 63;
function $eeb0961446aae8e3$var$getLens(b64) {
    var len = b64.length;
    if (len % 4 > 0) throw new Error("Invalid string. Length must be a multiple of 4");
    // Trim off extra bytes after placeholder bytes are found
    // See: https://github.com/beatgammit/base64-js/issues/42
    var validLen = b64.indexOf("=");
    if (validLen === -1) validLen = len;
    var placeHoldersLen = validLen === len ? 0 : 4 - validLen % 4;
    return [
        validLen,
        placeHoldersLen
    ];
}
// base64 is 4/3 + up to two characters of the original data
function $eeb0961446aae8e3$var$byteLength(b64) {
    var lens = $eeb0961446aae8e3$var$getLens(b64);
    var validLen = lens[0];
    var placeHoldersLen = lens[1];
    return (validLen + placeHoldersLen) * 3 / 4 - placeHoldersLen;
}
function $eeb0961446aae8e3$var$_byteLength(b64, validLen, placeHoldersLen) {
    return (validLen + placeHoldersLen) * 3 / 4 - placeHoldersLen;
}
function $eeb0961446aae8e3$var$toByteArray(b64) {
    var tmp;
    var lens = $eeb0961446aae8e3$var$getLens(b64);
    var validLen = lens[0];
    var placeHoldersLen = lens[1];
    var arr = new $eeb0961446aae8e3$var$Arr($eeb0961446aae8e3$var$_byteLength(b64, validLen, placeHoldersLen));
    var curByte = 0;
    // if there are placeholders, only get up to the last complete 4 chars
    var len = placeHoldersLen > 0 ? validLen - 4 : validLen;
    var i;
    for(i = 0; i < len; i += 4){
        tmp = $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i)] << 18 | $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i + 1)] << 12 | $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i + 2)] << 6 | $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i + 3)];
        arr[curByte++] = tmp >> 16 & 0xFF;
        arr[curByte++] = tmp >> 8 & 0xFF;
        arr[curByte++] = tmp & 0xFF;
    }
    if (placeHoldersLen === 2) {
        tmp = $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i)] << 2 | $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i + 1)] >> 4;
        arr[curByte++] = tmp & 0xFF;
    }
    if (placeHoldersLen === 1) {
        tmp = $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i)] << 10 | $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i + 1)] << 4 | $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i + 2)] >> 2;
        arr[curByte++] = tmp >> 8 & 0xFF;
        arr[curByte++] = tmp & 0xFF;
    }
    return arr;
}
function $eeb0961446aae8e3$var$tripletToBase64(num) {
    return $eeb0961446aae8e3$var$lookup[num >> 18 & 0x3F] + $eeb0961446aae8e3$var$lookup[num >> 12 & 0x3F] + $eeb0961446aae8e3$var$lookup[num >> 6 & 0x3F] + $eeb0961446aae8e3$var$lookup[num & 0x3F];
}
function $eeb0961446aae8e3$var$encodeChunk(uint8, start, end) {
    var tmp;
    var output = [];
    for(var i = start; i < end; i += 3){
        tmp = (uint8[i] << 16 & 0xFF0000) + (uint8[i + 1] << 8 & 0xFF00) + (uint8[i + 2] & 0xFF);
        output.push($eeb0961446aae8e3$var$tripletToBase64(tmp));
    }
    return output.join("");
}
function $eeb0961446aae8e3$var$fromByteArray(uint8) {
    var tmp;
    var len = uint8.length;
    var extraBytes = len % 3 // if we have 1 byte left, pad 2 bytes
    ;
    var parts = [];
    var maxChunkLength = 16383 // must be multiple of 3
    ;
    // go through the array every three bytes, we'll deal with trailing stuff later
    for(var i = 0, len2 = len - extraBytes; i < len2; i += maxChunkLength)parts.push($eeb0961446aae8e3$var$encodeChunk(uint8, i, i + maxChunkLength > len2 ? len2 : i + maxChunkLength));
    // pad the end with zeros, but make sure to not forget the extra bytes
    if (extraBytes === 1) {
        tmp = uint8[len - 1];
        parts.push($eeb0961446aae8e3$var$lookup[tmp >> 2] + $eeb0961446aae8e3$var$lookup[tmp << 4 & 0x3F] + "==");
    } else if (extraBytes === 2) {
        tmp = (uint8[len - 2] << 8) + uint8[len - 1];
        parts.push($eeb0961446aae8e3$var$lookup[tmp >> 10] + $eeb0961446aae8e3$var$lookup[tmp >> 4 & 0x3F] + $eeb0961446aae8e3$var$lookup[tmp << 2 & 0x3F] + "=");
    }
    return parts.join("");
}

});

parcelRegister("9NvM5", function(module, exports) {

$parcel$export(module.exports, "read", () => $7221566bd4d49f44$export$aafa59e2e03f2942, (v) => $7221566bd4d49f44$export$aafa59e2e03f2942 = v);
$parcel$export(module.exports, "write", () => $7221566bd4d49f44$export$68d8715fc104d294, (v) => $7221566bd4d49f44$export$68d8715fc104d294 = v);
/*! ieee754. BSD-3-Clause License. Feross Aboukhadijeh <https://feross.org/opensource> */ var $7221566bd4d49f44$export$aafa59e2e03f2942;
var $7221566bd4d49f44$export$68d8715fc104d294;
$7221566bd4d49f44$export$aafa59e2e03f2942 = function(buffer, offset, isLE, mLen, nBytes) {
    var e, m;
    var eLen = nBytes * 8 - mLen - 1;
    var eMax = (1 << eLen) - 1;
    var eBias = eMax >> 1;
    var nBits = -7;
    var i = isLE ? nBytes - 1 : 0;
    var d = isLE ? -1 : 1;
    var s = buffer[offset + i];
    i += d;
    e = s & (1 << -nBits) - 1;
    s >>= -nBits;
    nBits += eLen;
    for(; nBits > 0; e = e * 256 + buffer[offset + i], i += d, nBits -= 8);
    m = e & (1 << -nBits) - 1;
    e >>= -nBits;
    nBits += mLen;
    for(; nBits > 0; m = m * 256 + buffer[offset + i], i += d, nBits -= 8);
    if (e === 0) e = 1 - eBias;
    else if (e === eMax) return m ? NaN : (s ? -1 : 1) * Infinity;
    else {
        m = m + Math.pow(2, mLen);
        e = e - eBias;
    }
    return (s ? -1 : 1) * m * Math.pow(2, e - mLen);
};
$7221566bd4d49f44$export$68d8715fc104d294 = function(buffer, value, offset, isLE, mLen, nBytes) {
    var e, m, c;
    var eLen = nBytes * 8 - mLen - 1;
    var eMax = (1 << eLen) - 1;
    var eBias = eMax >> 1;
    var rt = mLen === 23 ? Math.pow(2, -24) - Math.pow(2, -77) : 0;
    var i = isLE ? 0 : nBytes - 1;
    var d = isLE ? 1 : -1;
    var s = value < 0 || value === 0 && 1 / value < 0 ? 1 : 0;
    value = Math.abs(value);
    if (isNaN(value) || value === Infinity) {
        m = isNaN(value) ? 1 : 0;
        e = eMax;
    } else {
        e = Math.floor(Math.log(value) / Math.LN2);
        if (value * (c = Math.pow(2, -e)) < 1) {
            e--;
            c *= 2;
        }
        if (e + eBias >= 1) value += rt / c;
        else value += rt * Math.pow(2, 1 - eBias);
        if (value * c >= 2) {
            e++;
            c /= 2;
        }
        if (e + eBias >= eMax) {
            m = 0;
            e = eMax;
        } else if (e + eBias >= 1) {
            m = (value * c - 1) * Math.pow(2, mLen);
            e = e + eBias;
        } else {
            m = value * Math.pow(2, eBias - 1) * Math.pow(2, mLen);
            e = 0;
        }
    }
    for(; mLen >= 8; buffer[offset + i] = m & 0xff, i += d, m /= 256, mLen -= 8);
    e = e << mLen | m;
    eLen += mLen;
    for(; eLen > 0; buffer[offset + i] = e & 0xff, i += d, e /= 256, eLen -= 8);
    buffer[offset + i - d] |= s * 128;
};

});


parcelRegister("gNDby", function(module, exports) {

$parcel$export(module.exports, "Struct", () => $c3af9e523501759a$export$eabc71f011df675a);
$parcel$export(module.exports, "SOLANA_SCHEMA", () => $c3af9e523501759a$export$68d13ce9b4cc48f3);
$parcel$export(module.exports, "Enum", () => $c3af9e523501759a$export$deb82508dd66d288);
$parcel$export(module.exports, "MAX_SEED_LENGTH", () => $c3af9e523501759a$export$8240f9da84ad7873);
$parcel$export(module.exports, "PUBLIC_KEY_LENGTH", () => $c3af9e523501759a$export$84fc0a248cc54343);
$parcel$export(module.exports, "PublicKey", () => $c3af9e523501759a$export$ca8b6604d6ce14de);
$parcel$export(module.exports, "Account", () => $c3af9e523501759a$export$1ed4b10e4aba04a7);
$parcel$export(module.exports, "BPF_LOADER_DEPRECATED_PROGRAM_ID", () => $c3af9e523501759a$export$42bd37c1c64962b6);
$parcel$export(module.exports, "PACKET_DATA_SIZE", () => $c3af9e523501759a$export$4c6d5b89e1596f26);
$parcel$export(module.exports, "VERSION_PREFIX_MASK", () => $c3af9e523501759a$export$3c3793d809f8b858);
$parcel$export(module.exports, "SIGNATURE_LENGTH_IN_BYTES", () => $c3af9e523501759a$export$14aee086fde78fa6);
$parcel$export(module.exports, "TransactionExpiredBlockheightExceededError", () => $c3af9e523501759a$export$718fcd78527f88ed);
$parcel$export(module.exports, "TransactionExpiredTimeoutError", () => $c3af9e523501759a$export$b822204c22e46bdf);
$parcel$export(module.exports, "TransactionExpiredNonceInvalidError", () => $c3af9e523501759a$export$a3e7565a95f5a1e5);
$parcel$export(module.exports, "MessageAccountKeys", () => $c3af9e523501759a$export$109914c107623102);
$parcel$export(module.exports, "Message", () => $c3af9e523501759a$export$f69c19e57285b83a);
$parcel$export(module.exports, "MessageV0", () => $c3af9e523501759a$export$ee274c70e0fae590);
$parcel$export(module.exports, "VersionedMessage", () => $c3af9e523501759a$export$b0a61927d00ede7f);
$parcel$export(module.exports, "TransactionStatus", () => $c3af9e523501759a$export$7c391bd3b61d2374);
$parcel$export(module.exports, "TransactionInstruction", () => $c3af9e523501759a$export$a7a3aa8360ac9f59);
$parcel$export(module.exports, "Transaction", () => $c3af9e523501759a$export$febc5573c75cefb0);
$parcel$export(module.exports, "TransactionMessage", () => $c3af9e523501759a$export$eb15f3e001dd262d);
$parcel$export(module.exports, "VersionedTransaction", () => $c3af9e523501759a$export$232cc3f078dcc284);
$parcel$export(module.exports, "SYSVAR_CLOCK_PUBKEY", () => $c3af9e523501759a$export$393aa1412d47050e);
$parcel$export(module.exports, "SYSVAR_EPOCH_SCHEDULE_PUBKEY", () => $c3af9e523501759a$export$2b71d479444d2f4);
$parcel$export(module.exports, "SYSVAR_INSTRUCTIONS_PUBKEY", () => $c3af9e523501759a$export$54419cc1a3ece8d6);
$parcel$export(module.exports, "SYSVAR_RECENT_BLOCKHASHES_PUBKEY", () => $c3af9e523501759a$export$e74201139e9833db);
$parcel$export(module.exports, "SYSVAR_RENT_PUBKEY", () => $c3af9e523501759a$export$970d0190cdb3a8e9);
$parcel$export(module.exports, "SYSVAR_REWARDS_PUBKEY", () => $c3af9e523501759a$export$da3b38d796bc1af1);
$parcel$export(module.exports, "SYSVAR_SLOT_HASHES_PUBKEY", () => $c3af9e523501759a$export$7b3a057916a4a7ae);
$parcel$export(module.exports, "SYSVAR_SLOT_HISTORY_PUBKEY", () => $c3af9e523501759a$export$3272815bf0633907);
$parcel$export(module.exports, "SYSVAR_STAKE_HISTORY_PUBKEY", () => $c3af9e523501759a$export$ca994171317280ea);
$parcel$export(module.exports, "sendAndConfirmTransaction", () => $c3af9e523501759a$export$4ad6fe6dae0b6bc3);
$parcel$export(module.exports, "FeeCalculatorLayout", () => $c3af9e523501759a$export$d1cc579b1c48f515);
$parcel$export(module.exports, "NONCE_ACCOUNT_LENGTH", () => $c3af9e523501759a$export$7126250b6d8bd94a);
$parcel$export(module.exports, "NonceAccount", () => $c3af9e523501759a$export$ed1c2356ce604759);
$parcel$export(module.exports, "SystemInstruction", () => $c3af9e523501759a$export$f009802131fa3d06);
$parcel$export(module.exports, "SYSTEM_INSTRUCTION_LAYOUTS", () => $c3af9e523501759a$export$74bdf41d8d1e7108);
$parcel$export(module.exports, "SystemProgram", () => $c3af9e523501759a$export$d8c4e17726848113);
$parcel$export(module.exports, "Loader", () => $c3af9e523501759a$export$3b0d6d7590275603);
$parcel$export(module.exports, "BPF_LOADER_PROGRAM_ID", () => $c3af9e523501759a$export$59833422f998b937);
$parcel$export(module.exports, "BpfLoader", () => $c3af9e523501759a$export$493be68e6a240d3b);
$parcel$export(module.exports, "EpochSchedule", () => $c3af9e523501759a$export$df8ed3e830b1d591);
$parcel$export(module.exports, "SendTransactionError", () => $c3af9e523501759a$export$121e803f723b3045);
$parcel$export(module.exports, "SolanaJSONRPCErrorCode", () => $c3af9e523501759a$export$e5e9869922dd22f8);
$parcel$export(module.exports, "SolanaJSONRPCError", () => $c3af9e523501759a$export$ea1b1a1bba5c14ad);
$parcel$export(module.exports, "AddressLookupTableAccount", () => $c3af9e523501759a$export$5b2310da10e607da);
$parcel$export(module.exports, "BLOCKHASH_CACHE_TIMEOUT_MS", () => $c3af9e523501759a$export$fcb705732fb5c597);
$parcel$export(module.exports, "Connection", () => $c3af9e523501759a$export$98b66c25bb38499d);
$parcel$export(module.exports, "Keypair", () => $c3af9e523501759a$export$c53bca448cf33676);
$parcel$export(module.exports, "LOOKUP_TABLE_INSTRUCTION_LAYOUTS", () => $c3af9e523501759a$export$7d102200c3a357d6);
$parcel$export(module.exports, "AddressLookupTableInstruction", () => $c3af9e523501759a$export$3ab2b24d551f0dc2);
$parcel$export(module.exports, "AddressLookupTableProgram", () => $c3af9e523501759a$export$5147a345798de168);
$parcel$export(module.exports, "ComputeBudgetInstruction", () => $c3af9e523501759a$export$bc4776847c641a67);
$parcel$export(module.exports, "COMPUTE_BUDGET_INSTRUCTION_LAYOUTS", () => $c3af9e523501759a$export$b7c79c50764da3d6);
$parcel$export(module.exports, "ComputeBudgetProgram", () => $c3af9e523501759a$export$11585db5942bcdb7);
$parcel$export(module.exports, "Ed25519Program", () => $c3af9e523501759a$export$e5087aea02631e);
$parcel$export(module.exports, "Secp256k1Program", () => $c3af9e523501759a$export$d85dd4c1161d13c9);
$parcel$export(module.exports, "STAKE_CONFIG_ID", () => $c3af9e523501759a$export$18aac71979bdd08f);
$parcel$export(module.exports, "Authorized", () => $c3af9e523501759a$export$9ac74ae66932a145);
$parcel$export(module.exports, "Lockup", () => $c3af9e523501759a$export$e7f3941ade35598c);
$parcel$export(module.exports, "StakeInstruction", () => $c3af9e523501759a$export$aded313c3a4800f9);
$parcel$export(module.exports, "STAKE_INSTRUCTION_LAYOUTS", () => $c3af9e523501759a$export$c89793bd2bba8b2e);
$parcel$export(module.exports, "StakeProgram", () => $c3af9e523501759a$export$df86f933e9f8fb15);
$parcel$export(module.exports, "StakeAuthorizationLayout", () => $c3af9e523501759a$export$4783920eadd34361);
$parcel$export(module.exports, "VoteInit", () => $c3af9e523501759a$export$3f9d1b16ff840d7);
$parcel$export(module.exports, "VoteInstruction", () => $c3af9e523501759a$export$af8300401fc56047);
$parcel$export(module.exports, "VoteProgram", () => $c3af9e523501759a$export$83db2bc702bee1eb);
$parcel$export(module.exports, "VoteAuthorizationLayout", () => $c3af9e523501759a$export$3f2a92246fa9f71c);
$parcel$export(module.exports, "VALIDATOR_INFO_KEY", () => $c3af9e523501759a$export$afdb09d3afdde87c);
$parcel$export(module.exports, "ValidatorInfo", () => $c3af9e523501759a$export$152d279cf067309b);
$parcel$export(module.exports, "VOTE_PROGRAM_ID", () => $c3af9e523501759a$export$90bca02a3aea0768);
$parcel$export(module.exports, "VoteAccount", () => $c3af9e523501759a$export$89ef186f708d638b);
$parcel$export(module.exports, "clusterApiUrl", () => $c3af9e523501759a$export$11656287b4eb76ff);
$parcel$export(module.exports, "sendAndConfirmRawTransaction", () => $c3af9e523501759a$export$554271b88fdb7843);
$parcel$export(module.exports, "LAMPORTS_PER_SOL", () => $c3af9e523501759a$export$5f6a2f2669741bbe);

var $6ZWSX = parcelRequire("6ZWSX");

var $kE5x4 = parcelRequire("kE5x4");

var $dEXSZ = parcelRequire("dEXSZ");

var $4UTkl = parcelRequire("4UTkl");

var $6XnWx = parcelRequire("6XnWx");

var $75BJw = parcelRequire("75BJw");

var $Q02IV = parcelRequire("Q02IV");

var $gyRuj = parcelRequire("gyRuj");

var $kZFCD = parcelRequire("kZFCD");

var $7pfXJ = parcelRequire("7pfXJ");

var $9aP4M = parcelRequire("9aP4M");

var $ckEgg = parcelRequire("ckEgg");

var $J0sDk = parcelRequire("J0sDk");

var $5r7db = parcelRequire("5r7db");
/**
 * A 64 byte secret key, the first 32 bytes of which is the
 * private scalar and the last 32 bytes is the public key.
 * Read more: https://blog.mozilla.org/warner/2011/11/29/ed25519-keys/
 */ /**
 * Ed25519 Keypair
 */ const $c3af9e523501759a$var$generatePrivateKey = (0, $kE5x4.ed25519).utils.randomPrivateKey;
const $c3af9e523501759a$var$generateKeypair = ()=>{
    const privateScalar = (0, $kE5x4.ed25519).utils.randomPrivateKey();
    const publicKey = $c3af9e523501759a$var$getPublicKey(privateScalar);
    const secretKey = new Uint8Array(64);
    secretKey.set(privateScalar);
    secretKey.set(publicKey, 32);
    return {
        publicKey: publicKey,
        secretKey: secretKey
    };
};
const $c3af9e523501759a$var$getPublicKey = (0, $kE5x4.ed25519).getPublicKey;
function $c3af9e523501759a$var$isOnCurve(publicKey) {
    try {
        (0, $kE5x4.ed25519).ExtendedPoint.fromHex(publicKey);
        return true;
    } catch  {
        return false;
    }
}
const $c3af9e523501759a$var$sign = (message, secretKey)=>(0, $kE5x4.ed25519).sign(message, secretKey.slice(0, 32));
const $c3af9e523501759a$var$verify = (0, $kE5x4.ed25519).verify;
const $c3af9e523501759a$var$toBuffer = (arr)=>{
    if ((0, $6ZWSX.Buffer).isBuffer(arr)) return arr;
    else if (arr instanceof Uint8Array) return (0, $6ZWSX.Buffer).from(arr.buffer, arr.byteOffset, arr.byteLength);
    else return (0, $6ZWSX.Buffer).from(arr);
};
// Class wrapping a plain object
class $c3af9e523501759a$export$eabc71f011df675a {
    constructor(properties){
        Object.assign(this, properties);
    }
    encode() {
        return (0, $6ZWSX.Buffer).from((0, $75BJw.serialize)($c3af9e523501759a$export$68d13ce9b4cc48f3, this));
    }
    static decode(data) {
        return (0, $75BJw.deserialize)($c3af9e523501759a$export$68d13ce9b4cc48f3, this, data);
    }
    static decodeUnchecked(data) {
        return (0, $75BJw.deserializeUnchecked)($c3af9e523501759a$export$68d13ce9b4cc48f3, this, data);
    }
}
// Class representing a Rust-compatible enum, since enums are only strings or
// numbers in pure JS
class $c3af9e523501759a$export$deb82508dd66d288 extends $c3af9e523501759a$export$eabc71f011df675a {
    constructor(properties){
        super(properties);
        this.enum = "";
        if (Object.keys(properties).length !== 1) throw new Error("Enum can only take single value");
        Object.keys(properties).map((key)=>{
            this.enum = key;
        });
    }
}
const $c3af9e523501759a$export$68d13ce9b4cc48f3 = new Map();
var $c3af9e523501759a$var$_class;
let $c3af9e523501759a$var$_Symbol$toStringTag;
/**
 * Maximum length of derived pubkey seed
 */ const $c3af9e523501759a$export$8240f9da84ad7873 = 32;
/**
 * Size of public key in bytes
 */ const $c3af9e523501759a$export$84fc0a248cc54343 = 32;
/**
 * Value to be converted into public key
 */ /**
 * JSON object representation of PublicKey class
 */ function $c3af9e523501759a$var$isPublicKeyData(value) {
    return value._bn !== undefined;
}
// local counter used by PublicKey.unique()
let $c3af9e523501759a$var$uniquePublicKeyCounter = 1;
/**
 * A public key
 */ $c3af9e523501759a$var$_Symbol$toStringTag = Symbol.toStringTag;
class $c3af9e523501759a$export$ca8b6604d6ce14de extends $c3af9e523501759a$export$eabc71f011df675a {
    /**
   * Create a new PublicKey object
   * @param value ed25519 public key as buffer or base-58 encoded string
   */ constructor(value){
        super({});
        /** @internal */ this._bn = void 0;
        if ($c3af9e523501759a$var$isPublicKeyData(value)) this._bn = value._bn;
        else {
            if (typeof value === "string") {
                // assume base 58 encoding by default
                const decoded = (0, (/*@__PURE__*/$parcel$interopDefault($4UTkl))).decode(value);
                if (decoded.length != $c3af9e523501759a$export$84fc0a248cc54343) throw new Error(`Invalid public key input`);
                this._bn = new (0, (/*@__PURE__*/$parcel$interopDefault($dEXSZ)))(decoded);
            } else this._bn = new (0, (/*@__PURE__*/$parcel$interopDefault($dEXSZ)))(value);
            if (this._bn.byteLength() > $c3af9e523501759a$export$84fc0a248cc54343) throw new Error(`Invalid public key input`);
        }
    }
    /**
   * Returns a unique PublicKey for tests and benchmarks using a counter
   */ static unique() {
        const key = new $c3af9e523501759a$export$ca8b6604d6ce14de($c3af9e523501759a$var$uniquePublicKeyCounter);
        $c3af9e523501759a$var$uniquePublicKeyCounter += 1;
        return new $c3af9e523501759a$export$ca8b6604d6ce14de(key.toBuffer());
    }
    /**
   * Default public key value. The base58-encoded string representation is all ones (as seen below)
   * The underlying BN number is 32 bytes that are all zeros
   */ /**
   * Checks if two publicKeys are equal
   */ equals(publicKey) {
        return this._bn.eq(publicKey._bn);
    }
    /**
   * Return the base-58 representation of the public key
   */ toBase58() {
        return (0, (/*@__PURE__*/$parcel$interopDefault($4UTkl))).encode(this.toBytes());
    }
    toJSON() {
        return this.toBase58();
    }
    /**
   * Return the byte array representation of the public key in big endian
   */ toBytes() {
        const buf = this.toBuffer();
        return new Uint8Array(buf.buffer, buf.byteOffset, buf.byteLength);
    }
    /**
   * Return the Buffer representation of the public key in big endian
   */ toBuffer() {
        const b = this._bn.toArrayLike((0, $6ZWSX.Buffer));
        if (b.length === $c3af9e523501759a$export$84fc0a248cc54343) return b;
        const zeroPad = (0, $6ZWSX.Buffer).alloc(32);
        b.copy(zeroPad, 32 - b.length);
        return zeroPad;
    }
    get [$c3af9e523501759a$var$_Symbol$toStringTag]() {
        return `PublicKey(${this.toString()})`;
    }
    /**
   * Return the base-58 representation of the public key
   */ toString() {
        return this.toBase58();
    }
    /**
   * Derive a public key from another key, a seed, and a program ID.
   * The program ID will also serve as the owner of the public key, giving
   * it permission to write data to the account.
   */ /* eslint-disable require-await */ static async createWithSeed(fromPublicKey, seed, programId) {
        const buffer = (0, $6ZWSX.Buffer).concat([
            fromPublicKey.toBuffer(),
            (0, $6ZWSX.Buffer).from(seed),
            programId.toBuffer()
        ]);
        const publicKeyBytes = (0, $6XnWx.sha256)(buffer);
        return new $c3af9e523501759a$export$ca8b6604d6ce14de(publicKeyBytes);
    }
    /**
   * Derive a program address from seeds and a program ID.
   */ /* eslint-disable require-await */ static createProgramAddressSync(seeds, programId) {
        let buffer = (0, $6ZWSX.Buffer).alloc(0);
        seeds.forEach(function(seed) {
            if (seed.length > $c3af9e523501759a$export$8240f9da84ad7873) throw new TypeError(`Max seed length exceeded`);
            buffer = (0, $6ZWSX.Buffer).concat([
                buffer,
                $c3af9e523501759a$var$toBuffer(seed)
            ]);
        });
        buffer = (0, $6ZWSX.Buffer).concat([
            buffer,
            programId.toBuffer(),
            (0, $6ZWSX.Buffer).from("ProgramDerivedAddress")
        ]);
        const publicKeyBytes = (0, $6XnWx.sha256)(buffer);
        if ($c3af9e523501759a$var$isOnCurve(publicKeyBytes)) throw new Error(`Invalid seeds, address must fall off the curve`);
        return new $c3af9e523501759a$export$ca8b6604d6ce14de(publicKeyBytes);
    }
    /**
   * Async version of createProgramAddressSync
   * For backwards compatibility
   *
   * @deprecated Use {@link createProgramAddressSync} instead
   */ /* eslint-disable require-await */ static async createProgramAddress(seeds, programId) {
        return this.createProgramAddressSync(seeds, programId);
    }
    /**
   * Find a valid program address
   *
   * Valid program addresses must fall off the ed25519 curve.  This function
   * iterates a nonce until it finds one that when combined with the seeds
   * results in a valid program address.
   */ static findProgramAddressSync(seeds, programId) {
        let nonce = 255;
        let address;
        while(nonce != 0){
            try {
                const seedsWithNonce = seeds.concat((0, $6ZWSX.Buffer).from([
                    nonce
                ]));
                address = this.createProgramAddressSync(seedsWithNonce, programId);
            } catch (err) {
                if (err instanceof TypeError) throw err;
                nonce--;
                continue;
            }
            return [
                address,
                nonce
            ];
        }
        throw new Error(`Unable to find a viable program address nonce`);
    }
    /**
   * Async version of findProgramAddressSync
   * For backwards compatibility
   *
   * @deprecated Use {@link findProgramAddressSync} instead
   */ static async findProgramAddress(seeds, programId) {
        return this.findProgramAddressSync(seeds, programId);
    }
    /**
   * Check that a pubkey is on the ed25519 curve.
   */ static isOnCurve(pubkeyData) {
        const pubkey = new $c3af9e523501759a$export$ca8b6604d6ce14de(pubkeyData);
        return $c3af9e523501759a$var$isOnCurve(pubkey.toBytes());
    }
}
$c3af9e523501759a$var$_class = $c3af9e523501759a$export$ca8b6604d6ce14de;
$c3af9e523501759a$export$ca8b6604d6ce14de.default = new $c3af9e523501759a$var$_class("11111111111111111111111111111111");
$c3af9e523501759a$export$68d13ce9b4cc48f3.set($c3af9e523501759a$export$ca8b6604d6ce14de, {
    kind: "struct",
    fields: [
        [
            "_bn",
            "u256"
        ]
    ]
});
/**
 * An account key pair (public and secret keys).
 *
 * @deprecated since v1.10.0, please use {@link Keypair} instead.
 */ class $c3af9e523501759a$export$1ed4b10e4aba04a7 {
    /**
   * Create a new Account object
   *
   * If the secretKey parameter is not provided a new key pair is randomly
   * created for the account
   *
   * @param secretKey Secret key for the account
   */ constructor(secretKey){
        /** @internal */ this._publicKey = void 0;
        /** @internal */ this._secretKey = void 0;
        if (secretKey) {
            const secretKeyBuffer = $c3af9e523501759a$var$toBuffer(secretKey);
            if (secretKey.length !== 64) throw new Error("bad secret key size");
            this._publicKey = secretKeyBuffer.slice(32, 64);
            this._secretKey = secretKeyBuffer.slice(0, 32);
        } else {
            this._secretKey = $c3af9e523501759a$var$toBuffer($c3af9e523501759a$var$generatePrivateKey());
            this._publicKey = $c3af9e523501759a$var$toBuffer($c3af9e523501759a$var$getPublicKey(this._secretKey));
        }
    }
    /**
   * The public key for this account
   */ get publicKey() {
        return new $c3af9e523501759a$export$ca8b6604d6ce14de(this._publicKey);
    }
    /**
   * The **unencrypted** secret key for this account. The first 32 bytes
   * is the private scalar and the last 32 bytes is the public key.
   * Read more: https://blog.mozilla.org/warner/2011/11/29/ed25519-keys/
   */ get secretKey() {
        return (0, $6ZWSX.Buffer).concat([
            this._secretKey,
            this._publicKey
        ], 64);
    }
}
const $c3af9e523501759a$export$42bd37c1c64962b6 = new $c3af9e523501759a$export$ca8b6604d6ce14de("BPFLoader1111111111111111111111111111111111");
/**
 * Maximum over-the-wire size of a Transaction
 *
 * 1280 is IPv6 minimum MTU
 * 40 bytes is the size of the IPv6 header
 * 8 bytes is the size of the fragment header
 */ const $c3af9e523501759a$export$4c6d5b89e1596f26 = 1232;
const $c3af9e523501759a$export$3c3793d809f8b858 = 0x7f;
const $c3af9e523501759a$export$14aee086fde78fa6 = 64;
class $c3af9e523501759a$export$718fcd78527f88ed extends Error {
    constructor(signature){
        super(`Signature ${signature} has expired: block height exceeded.`);
        this.signature = void 0;
        this.signature = signature;
    }
}
Object.defineProperty($c3af9e523501759a$export$718fcd78527f88ed.prototype, "name", {
    value: "TransactionExpiredBlockheightExceededError"
});
class $c3af9e523501759a$export$b822204c22e46bdf extends Error {
    constructor(signature, timeoutSeconds){
        super(`Transaction was not confirmed in ${timeoutSeconds.toFixed(2)} seconds. It is ` + "unknown if it succeeded or failed. Check signature " + `${signature} using the Solana Explorer or CLI tools.`);
        this.signature = void 0;
        this.signature = signature;
    }
}
Object.defineProperty($c3af9e523501759a$export$b822204c22e46bdf.prototype, "name", {
    value: "TransactionExpiredTimeoutError"
});
class $c3af9e523501759a$export$a3e7565a95f5a1e5 extends Error {
    constructor(signature){
        super(`Signature ${signature} has expired: the nonce is no longer valid.`);
        this.signature = void 0;
        this.signature = signature;
    }
}
Object.defineProperty($c3af9e523501759a$export$a3e7565a95f5a1e5.prototype, "name", {
    value: "TransactionExpiredNonceInvalidError"
});
class $c3af9e523501759a$export$109914c107623102 {
    constructor(staticAccountKeys, accountKeysFromLookups){
        this.staticAccountKeys = void 0;
        this.accountKeysFromLookups = void 0;
        this.staticAccountKeys = staticAccountKeys;
        this.accountKeysFromLookups = accountKeysFromLookups;
    }
    keySegments() {
        const keySegments = [
            this.staticAccountKeys
        ];
        if (this.accountKeysFromLookups) {
            keySegments.push(this.accountKeysFromLookups.writable);
            keySegments.push(this.accountKeysFromLookups.readonly);
        }
        return keySegments;
    }
    get(index) {
        for (const keySegment of this.keySegments()){
            if (index < keySegment.length) return keySegment[index];
            else index -= keySegment.length;
        }
        return;
    }
    get length() {
        return this.keySegments().flat().length;
    }
    compileInstructions(instructions) {
        // Bail early if any account indexes would overflow a u8
        const U8_MAX = 255;
        if (this.length > U8_MAX + 1) throw new Error("Account index overflow encountered during compilation");
        const keyIndexMap = new Map();
        this.keySegments().flat().forEach((key, index)=>{
            keyIndexMap.set(key.toBase58(), index);
        });
        const findKeyIndex = (key)=>{
            const keyIndex = keyIndexMap.get(key.toBase58());
            if (keyIndex === undefined) throw new Error("Encountered an unknown instruction account key during compilation");
            return keyIndex;
        };
        return instructions.map((instruction)=>{
            return {
                programIdIndex: findKeyIndex(instruction.programId),
                accountKeyIndexes: instruction.keys.map((meta)=>findKeyIndex(meta.pubkey)),
                data: instruction.data
            };
        });
    }
}
/**
 * Layout for a public key
 */ const $c3af9e523501759a$var$publicKey = (property = "publicKey")=>{
    return $Q02IV.blob(32, property);
};
/**
 * Layout for a signature
 */ const $c3af9e523501759a$var$signature = (property = "signature")=>{
    return $Q02IV.blob(64, property);
};
/**
 * Layout for a Rust String type
 */ const $c3af9e523501759a$var$rustString = (property = "string")=>{
    const rsl = $Q02IV.struct([
        $Q02IV.u32("length"),
        $Q02IV.u32("lengthPadding"),
        $Q02IV.blob($Q02IV.offset($Q02IV.u32(), -8), "chars")
    ], property);
    const _decode = rsl.decode.bind(rsl);
    const _encode = rsl.encode.bind(rsl);
    const rslShim = rsl;
    rslShim.decode = (b, offset)=>{
        const data = _decode(b, offset);
        return data["chars"].toString();
    };
    rslShim.encode = (str, b, offset)=>{
        const data = {
            chars: (0, $6ZWSX.Buffer).from(str, "utf8")
        };
        return _encode(data, b, offset);
    };
    rslShim.alloc = (str)=>{
        return $Q02IV.u32().span + $Q02IV.u32().span + (0, $6ZWSX.Buffer).from(str, "utf8").length;
    };
    return rslShim;
};
/**
 * Layout for an Authorized object
 */ const $c3af9e523501759a$var$authorized = (property = "authorized")=>{
    return $Q02IV.struct([
        $c3af9e523501759a$var$publicKey("staker"),
        $c3af9e523501759a$var$publicKey("withdrawer")
    ], property);
};
/**
 * Layout for a Lockup object
 */ const $c3af9e523501759a$var$lockup = (property = "lockup")=>{
    return $Q02IV.struct([
        $Q02IV.ns64("unixTimestamp"),
        $Q02IV.ns64("epoch"),
        $c3af9e523501759a$var$publicKey("custodian")
    ], property);
};
/**
 *  Layout for a VoteInit object
 */ const $c3af9e523501759a$var$voteInit = (property = "voteInit")=>{
    return $Q02IV.struct([
        $c3af9e523501759a$var$publicKey("nodePubkey"),
        $c3af9e523501759a$var$publicKey("authorizedVoter"),
        $c3af9e523501759a$var$publicKey("authorizedWithdrawer"),
        $Q02IV.u8("commission")
    ], property);
};
/**
 *  Layout for a VoteAuthorizeWithSeedArgs object
 */ const $c3af9e523501759a$var$voteAuthorizeWithSeedArgs = (property = "voteAuthorizeWithSeedArgs")=>{
    return $Q02IV.struct([
        $Q02IV.u32("voteAuthorizationType"),
        $c3af9e523501759a$var$publicKey("currentAuthorityDerivedKeyOwnerPubkey"),
        $c3af9e523501759a$var$rustString("currentAuthorityDerivedKeySeed"),
        $c3af9e523501759a$var$publicKey("newAuthorized")
    ], property);
};
function $c3af9e523501759a$var$getAlloc(type, fields) {
    const getItemAlloc = (item)=>{
        if (item.span >= 0) return item.span;
        else if (typeof item.alloc === "function") return item.alloc(fields[item.property]);
        else if ("count" in item && "elementLayout" in item) {
            const field = fields[item.property];
            if (Array.isArray(field)) return field.length * getItemAlloc(item.elementLayout);
        } else if ("fields" in item) // This is a `Structure` whose size needs to be recursively measured.
        return $c3af9e523501759a$var$getAlloc({
            layout: item
        }, fields[item.property]);
        // Couldn't determine allocated size of layout
        return 0;
    };
    let alloc = 0;
    type.layout.fields.forEach((item)=>{
        alloc += getItemAlloc(item);
    });
    return alloc;
}
function $c3af9e523501759a$var$decodeLength(bytes) {
    let len = 0;
    let size = 0;
    for(;;){
        let elem = bytes.shift();
        len |= (elem & 0x7f) << size * 7;
        size += 1;
        if ((elem & 0x80) === 0) break;
    }
    return len;
}
function $c3af9e523501759a$var$encodeLength(bytes, len) {
    let rem_len = len;
    for(;;){
        let elem = rem_len & 0x7f;
        rem_len >>= 7;
        if (rem_len == 0) {
            bytes.push(elem);
            break;
        } else {
            elem |= 0x80;
            bytes.push(elem);
        }
    }
}
function $c3af9e523501759a$var$assert(condition, message) {
    if (!condition) throw new Error(message || "Assertion failed");
}
class $c3af9e523501759a$var$CompiledKeys {
    constructor(payer, keyMetaMap){
        this.payer = void 0;
        this.keyMetaMap = void 0;
        this.payer = payer;
        this.keyMetaMap = keyMetaMap;
    }
    static compile(instructions, payer) {
        const keyMetaMap = new Map();
        const getOrInsertDefault = (pubkey)=>{
            const address = pubkey.toBase58();
            let keyMeta = keyMetaMap.get(address);
            if (keyMeta === undefined) {
                keyMeta = {
                    isSigner: false,
                    isWritable: false,
                    isInvoked: false
                };
                keyMetaMap.set(address, keyMeta);
            }
            return keyMeta;
        };
        const payerKeyMeta = getOrInsertDefault(payer);
        payerKeyMeta.isSigner = true;
        payerKeyMeta.isWritable = true;
        for (const ix of instructions){
            getOrInsertDefault(ix.programId).isInvoked = true;
            for (const accountMeta of ix.keys){
                const keyMeta = getOrInsertDefault(accountMeta.pubkey);
                keyMeta.isSigner ||= accountMeta.isSigner;
                keyMeta.isWritable ||= accountMeta.isWritable;
            }
        }
        return new $c3af9e523501759a$var$CompiledKeys(payer, keyMetaMap);
    }
    getMessageComponents() {
        const mapEntries = [
            ...this.keyMetaMap.entries()
        ];
        $c3af9e523501759a$var$assert(mapEntries.length <= 256, "Max static account keys length exceeded");
        const writableSigners = mapEntries.filter(([, meta])=>meta.isSigner && meta.isWritable);
        const readonlySigners = mapEntries.filter(([, meta])=>meta.isSigner && !meta.isWritable);
        const writableNonSigners = mapEntries.filter(([, meta])=>!meta.isSigner && meta.isWritable);
        const readonlyNonSigners = mapEntries.filter(([, meta])=>!meta.isSigner && !meta.isWritable);
        const header = {
            numRequiredSignatures: writableSigners.length + readonlySigners.length,
            numReadonlySignedAccounts: readonlySigners.length,
            numReadonlyUnsignedAccounts: readonlyNonSigners.length
        };
        // sanity checks
        {
            $c3af9e523501759a$var$assert(writableSigners.length > 0, "Expected at least one writable signer key");
            const [payerAddress] = writableSigners[0];
            $c3af9e523501759a$var$assert(payerAddress === this.payer.toBase58(), "Expected first writable signer key to be the fee payer");
        }
        const staticAccountKeys = [
            ...writableSigners.map(([address])=>new $c3af9e523501759a$export$ca8b6604d6ce14de(address)),
            ...readonlySigners.map(([address])=>new $c3af9e523501759a$export$ca8b6604d6ce14de(address)),
            ...writableNonSigners.map(([address])=>new $c3af9e523501759a$export$ca8b6604d6ce14de(address)),
            ...readonlyNonSigners.map(([address])=>new $c3af9e523501759a$export$ca8b6604d6ce14de(address))
        ];
        return [
            header,
            staticAccountKeys
        ];
    }
    extractTableLookup(lookupTable) {
        const [writableIndexes, drainedWritableKeys] = this.drainKeysFoundInLookupTable(lookupTable.state.addresses, (keyMeta)=>!keyMeta.isSigner && !keyMeta.isInvoked && keyMeta.isWritable);
        const [readonlyIndexes, drainedReadonlyKeys] = this.drainKeysFoundInLookupTable(lookupTable.state.addresses, (keyMeta)=>!keyMeta.isSigner && !keyMeta.isInvoked && !keyMeta.isWritable);
        // Don't extract lookup if no keys were found
        if (writableIndexes.length === 0 && readonlyIndexes.length === 0) return;
        return [
            {
                accountKey: lookupTable.key,
                writableIndexes: writableIndexes,
                readonlyIndexes: readonlyIndexes
            },
            {
                writable: drainedWritableKeys,
                readonly: drainedReadonlyKeys
            }
        ];
    }
    /** @internal */ drainKeysFoundInLookupTable(lookupTableEntries, keyMetaFilter) {
        const lookupTableIndexes = new Array();
        const drainedKeys = new Array();
        for (const [address, keyMeta] of this.keyMetaMap.entries())if (keyMetaFilter(keyMeta)) {
            const key = new $c3af9e523501759a$export$ca8b6604d6ce14de(address);
            const lookupTableIndex = lookupTableEntries.findIndex((entry)=>entry.equals(key));
            if (lookupTableIndex >= 0) {
                $c3af9e523501759a$var$assert(lookupTableIndex < 256, "Max lookup table index exceeded");
                lookupTableIndexes.push(lookupTableIndex);
                drainedKeys.push(key);
                this.keyMetaMap.delete(address);
            }
        }
        return [
            lookupTableIndexes,
            drainedKeys
        ];
    }
}
/**
 * An instruction to execute by a program
 *
 * @property {number} programIdIndex
 * @property {number[]} accounts
 * @property {string} data
 */ /**
 * Message constructor arguments
 */ /**
 * List of instructions to be processed atomically
 */ class $c3af9e523501759a$export$f69c19e57285b83a {
    constructor(args){
        this.header = void 0;
        this.accountKeys = void 0;
        this.recentBlockhash = void 0;
        this.instructions = void 0;
        this.indexToProgramIds = new Map();
        this.header = args.header;
        this.accountKeys = args.accountKeys.map((account)=>new $c3af9e523501759a$export$ca8b6604d6ce14de(account));
        this.recentBlockhash = args.recentBlockhash;
        this.instructions = args.instructions;
        this.instructions.forEach((ix)=>this.indexToProgramIds.set(ix.programIdIndex, this.accountKeys[ix.programIdIndex]));
    }
    get version() {
        return "legacy";
    }
    get staticAccountKeys() {
        return this.accountKeys;
    }
    get compiledInstructions() {
        return this.instructions.map((ix)=>({
                programIdIndex: ix.programIdIndex,
                accountKeyIndexes: ix.accounts,
                data: (0, (/*@__PURE__*/$parcel$interopDefault($4UTkl))).decode(ix.data)
            }));
    }
    get addressTableLookups() {
        return [];
    }
    getAccountKeys() {
        return new $c3af9e523501759a$export$109914c107623102(this.staticAccountKeys);
    }
    static compile(args) {
        const compiledKeys = $c3af9e523501759a$var$CompiledKeys.compile(args.instructions, args.payerKey);
        const [header, staticAccountKeys] = compiledKeys.getMessageComponents();
        const accountKeys = new $c3af9e523501759a$export$109914c107623102(staticAccountKeys);
        const instructions = accountKeys.compileInstructions(args.instructions).map((ix)=>({
                programIdIndex: ix.programIdIndex,
                accounts: ix.accountKeyIndexes,
                data: (0, (/*@__PURE__*/$parcel$interopDefault($4UTkl))).encode(ix.data)
            }));
        return new $c3af9e523501759a$export$f69c19e57285b83a({
            header: header,
            accountKeys: staticAccountKeys,
            recentBlockhash: args.recentBlockhash,
            instructions: instructions
        });
    }
    isAccountSigner(index) {
        return index < this.header.numRequiredSignatures;
    }
    isAccountWritable(index) {
        const numSignedAccounts = this.header.numRequiredSignatures;
        if (index >= this.header.numRequiredSignatures) {
            const unsignedAccountIndex = index - numSignedAccounts;
            const numUnsignedAccounts = this.accountKeys.length - numSignedAccounts;
            const numWritableUnsignedAccounts = numUnsignedAccounts - this.header.numReadonlyUnsignedAccounts;
            return unsignedAccountIndex < numWritableUnsignedAccounts;
        } else {
            const numWritableSignedAccounts = numSignedAccounts - this.header.numReadonlySignedAccounts;
            return index < numWritableSignedAccounts;
        }
    }
    isProgramId(index) {
        return this.indexToProgramIds.has(index);
    }
    programIds() {
        return [
            ...this.indexToProgramIds.values()
        ];
    }
    nonProgramIds() {
        return this.accountKeys.filter((_, index)=>!this.isProgramId(index));
    }
    serialize() {
        const numKeys = this.accountKeys.length;
        let keyCount = [];
        $c3af9e523501759a$var$encodeLength(keyCount, numKeys);
        const instructions = this.instructions.map((instruction)=>{
            const { accounts: accounts, programIdIndex: programIdIndex } = instruction;
            const data = Array.from((0, (/*@__PURE__*/$parcel$interopDefault($4UTkl))).decode(instruction.data));
            let keyIndicesCount = [];
            $c3af9e523501759a$var$encodeLength(keyIndicesCount, accounts.length);
            let dataCount = [];
            $c3af9e523501759a$var$encodeLength(dataCount, data.length);
            return {
                programIdIndex: programIdIndex,
                keyIndicesCount: (0, $6ZWSX.Buffer).from(keyIndicesCount),
                keyIndices: accounts,
                dataLength: (0, $6ZWSX.Buffer).from(dataCount),
                data: data
            };
        });
        let instructionCount = [];
        $c3af9e523501759a$var$encodeLength(instructionCount, instructions.length);
        let instructionBuffer = (0, $6ZWSX.Buffer).alloc($c3af9e523501759a$export$4c6d5b89e1596f26);
        (0, $6ZWSX.Buffer).from(instructionCount).copy(instructionBuffer);
        let instructionBufferLength = instructionCount.length;
        instructions.forEach((instruction)=>{
            const instructionLayout = $Q02IV.struct([
                $Q02IV.u8("programIdIndex"),
                $Q02IV.blob(instruction.keyIndicesCount.length, "keyIndicesCount"),
                $Q02IV.seq($Q02IV.u8("keyIndex"), instruction.keyIndices.length, "keyIndices"),
                $Q02IV.blob(instruction.dataLength.length, "dataLength"),
                $Q02IV.seq($Q02IV.u8("userdatum"), instruction.data.length, "data")
            ]);
            const length = instructionLayout.encode(instruction, instructionBuffer, instructionBufferLength);
            instructionBufferLength += length;
        });
        instructionBuffer = instructionBuffer.slice(0, instructionBufferLength);
        const signDataLayout = $Q02IV.struct([
            $Q02IV.blob(1, "numRequiredSignatures"),
            $Q02IV.blob(1, "numReadonlySignedAccounts"),
            $Q02IV.blob(1, "numReadonlyUnsignedAccounts"),
            $Q02IV.blob(keyCount.length, "keyCount"),
            $Q02IV.seq($c3af9e523501759a$var$publicKey("key"), numKeys, "keys"),
            $c3af9e523501759a$var$publicKey("recentBlockhash")
        ]);
        const transaction = {
            numRequiredSignatures: (0, $6ZWSX.Buffer).from([
                this.header.numRequiredSignatures
            ]),
            numReadonlySignedAccounts: (0, $6ZWSX.Buffer).from([
                this.header.numReadonlySignedAccounts
            ]),
            numReadonlyUnsignedAccounts: (0, $6ZWSX.Buffer).from([
                this.header.numReadonlyUnsignedAccounts
            ]),
            keyCount: (0, $6ZWSX.Buffer).from(keyCount),
            keys: this.accountKeys.map((key)=>$c3af9e523501759a$var$toBuffer(key.toBytes())),
            recentBlockhash: (0, (/*@__PURE__*/$parcel$interopDefault($4UTkl))).decode(this.recentBlockhash)
        };
        let signData = (0, $6ZWSX.Buffer).alloc(2048);
        const length = signDataLayout.encode(transaction, signData);
        instructionBuffer.copy(signData, length);
        return signData.slice(0, length + instructionBuffer.length);
    }
    /**
   * Decode a compiled message into a Message object.
   */ static from(buffer) {
        // Slice up wire data
        let byteArray = [
            ...buffer
        ];
        const numRequiredSignatures = byteArray.shift();
        if (numRequiredSignatures !== (numRequiredSignatures & $c3af9e523501759a$export$3c3793d809f8b858)) throw new Error("Versioned messages must be deserialized with VersionedMessage.deserialize()");
        const numReadonlySignedAccounts = byteArray.shift();
        const numReadonlyUnsignedAccounts = byteArray.shift();
        const accountCount = $c3af9e523501759a$var$decodeLength(byteArray);
        let accountKeys = [];
        for(let i = 0; i < accountCount; i++){
            const account = byteArray.slice(0, $c3af9e523501759a$export$84fc0a248cc54343);
            byteArray = byteArray.slice($c3af9e523501759a$export$84fc0a248cc54343);
            accountKeys.push(new $c3af9e523501759a$export$ca8b6604d6ce14de((0, $6ZWSX.Buffer).from(account)));
        }
        const recentBlockhash = byteArray.slice(0, $c3af9e523501759a$export$84fc0a248cc54343);
        byteArray = byteArray.slice($c3af9e523501759a$export$84fc0a248cc54343);
        const instructionCount = $c3af9e523501759a$var$decodeLength(byteArray);
        let instructions = [];
        for(let i = 0; i < instructionCount; i++){
            const programIdIndex = byteArray.shift();
            const accountCount = $c3af9e523501759a$var$decodeLength(byteArray);
            const accounts = byteArray.slice(0, accountCount);
            byteArray = byteArray.slice(accountCount);
            const dataLength = $c3af9e523501759a$var$decodeLength(byteArray);
            const dataSlice = byteArray.slice(0, dataLength);
            const data = (0, (/*@__PURE__*/$parcel$interopDefault($4UTkl))).encode((0, $6ZWSX.Buffer).from(dataSlice));
            byteArray = byteArray.slice(dataLength);
            instructions.push({
                programIdIndex: programIdIndex,
                accounts: accounts,
                data: data
            });
        }
        const messageArgs = {
            header: {
                numRequiredSignatures: numRequiredSignatures,
                numReadonlySignedAccounts: numReadonlySignedAccounts,
                numReadonlyUnsignedAccounts: numReadonlyUnsignedAccounts
            },
            recentBlockhash: (0, (/*@__PURE__*/$parcel$interopDefault($4UTkl))).encode((0, $6ZWSX.Buffer).from(recentBlockhash)),
            accountKeys: accountKeys,
            instructions: instructions
        };
        return new $c3af9e523501759a$export$f69c19e57285b83a(messageArgs);
    }
}
/**
 * Message constructor arguments
 */ class $c3af9e523501759a$export$ee274c70e0fae590 {
    constructor(args){
        this.header = void 0;
        this.staticAccountKeys = void 0;
        this.recentBlockhash = void 0;
        this.compiledInstructions = void 0;
        this.addressTableLookups = void 0;
        this.header = args.header;
        this.staticAccountKeys = args.staticAccountKeys;
        this.recentBlockhash = args.recentBlockhash;
        this.compiledInstructions = args.compiledInstructions;
        this.addressTableLookups = args.addressTableLookups;
    }
    get version() {
        return 0;
    }
    get numAccountKeysFromLookups() {
        let count = 0;
        for (const lookup of this.addressTableLookups)count += lookup.readonlyIndexes.length + lookup.writableIndexes.length;
        return count;
    }
    getAccountKeys(args) {
        let accountKeysFromLookups;
        if (args && "accountKeysFromLookups" in args && args.accountKeysFromLookups) {
            if (this.numAccountKeysFromLookups != args.accountKeysFromLookups.writable.length + args.accountKeysFromLookups.readonly.length) throw new Error("Failed to get account keys because of a mismatch in the number of account keys from lookups");
            accountKeysFromLookups = args.accountKeysFromLookups;
        } else if (args && "addressLookupTableAccounts" in args && args.addressLookupTableAccounts) accountKeysFromLookups = this.resolveAddressTableLookups(args.addressLookupTableAccounts);
        else if (this.addressTableLookups.length > 0) throw new Error("Failed to get account keys because address table lookups were not resolved");
        return new $c3af9e523501759a$export$109914c107623102(this.staticAccountKeys, accountKeysFromLookups);
    }
    isAccountSigner(index) {
        return index < this.header.numRequiredSignatures;
    }
    isAccountWritable(index) {
        const numSignedAccounts = this.header.numRequiredSignatures;
        const numStaticAccountKeys = this.staticAccountKeys.length;
        if (index >= numStaticAccountKeys) {
            const lookupAccountKeysIndex = index - numStaticAccountKeys;
            const numWritableLookupAccountKeys = this.addressTableLookups.reduce((count, lookup)=>count + lookup.writableIndexes.length, 0);
            return lookupAccountKeysIndex < numWritableLookupAccountKeys;
        } else if (index >= this.header.numRequiredSignatures) {
            const unsignedAccountIndex = index - numSignedAccounts;
            const numUnsignedAccounts = numStaticAccountKeys - numSignedAccounts;
            const numWritableUnsignedAccounts = numUnsignedAccounts - this.header.numReadonlyUnsignedAccounts;
            return unsignedAccountIndex < numWritableUnsignedAccounts;
        } else {
            const numWritableSignedAccounts = numSignedAccounts - this.header.numReadonlySignedAccounts;
            return index < numWritableSignedAccounts;
        }
    }
    resolveAddressTableLookups(addressLookupTableAccounts) {
        const accountKeysFromLookups = {
            writable: [],
            readonly: []
        };
        for (const tableLookup of this.addressTableLookups){
            const tableAccount = addressLookupTableAccounts.find((account)=>account.key.equals(tableLookup.accountKey));
            if (!tableAccount) throw new Error(`Failed to find address lookup table account for table key ${tableLookup.accountKey.toBase58()}`);
            for (const index of tableLookup.writableIndexes){
                if (index < tableAccount.state.addresses.length) accountKeysFromLookups.writable.push(tableAccount.state.addresses[index]);
                else throw new Error(`Failed to find address for index ${index} in address lookup table ${tableLookup.accountKey.toBase58()}`);
            }
            for (const index of tableLookup.readonlyIndexes){
                if (index < tableAccount.state.addresses.length) accountKeysFromLookups.readonly.push(tableAccount.state.addresses[index]);
                else throw new Error(`Failed to find address for index ${index} in address lookup table ${tableLookup.accountKey.toBase58()}`);
            }
        }
        return accountKeysFromLookups;
    }
    static compile(args) {
        const compiledKeys = $c3af9e523501759a$var$CompiledKeys.compile(args.instructions, args.payerKey);
        const addressTableLookups = new Array();
        const accountKeysFromLookups = {
            writable: new Array(),
            readonly: new Array()
        };
        const lookupTableAccounts = args.addressLookupTableAccounts || [];
        for (const lookupTable of lookupTableAccounts){
            const extractResult = compiledKeys.extractTableLookup(lookupTable);
            if (extractResult !== undefined) {
                const [addressTableLookup, { writable: writable, readonly: readonly }] = extractResult;
                addressTableLookups.push(addressTableLookup);
                accountKeysFromLookups.writable.push(...writable);
                accountKeysFromLookups.readonly.push(...readonly);
            }
        }
        const [header, staticAccountKeys] = compiledKeys.getMessageComponents();
        const accountKeys = new $c3af9e523501759a$export$109914c107623102(staticAccountKeys, accountKeysFromLookups);
        const compiledInstructions = accountKeys.compileInstructions(args.instructions);
        return new $c3af9e523501759a$export$ee274c70e0fae590({
            header: header,
            staticAccountKeys: staticAccountKeys,
            recentBlockhash: args.recentBlockhash,
            compiledInstructions: compiledInstructions,
            addressTableLookups: addressTableLookups
        });
    }
    serialize() {
        const encodedStaticAccountKeysLength = Array();
        $c3af9e523501759a$var$encodeLength(encodedStaticAccountKeysLength, this.staticAccountKeys.length);
        const serializedInstructions = this.serializeInstructions();
        const encodedInstructionsLength = Array();
        $c3af9e523501759a$var$encodeLength(encodedInstructionsLength, this.compiledInstructions.length);
        const serializedAddressTableLookups = this.serializeAddressTableLookups();
        const encodedAddressTableLookupsLength = Array();
        $c3af9e523501759a$var$encodeLength(encodedAddressTableLookupsLength, this.addressTableLookups.length);
        const messageLayout = $Q02IV.struct([
            $Q02IV.u8("prefix"),
            $Q02IV.struct([
                $Q02IV.u8("numRequiredSignatures"),
                $Q02IV.u8("numReadonlySignedAccounts"),
                $Q02IV.u8("numReadonlyUnsignedAccounts")
            ], "header"),
            $Q02IV.blob(encodedStaticAccountKeysLength.length, "staticAccountKeysLength"),
            $Q02IV.seq($c3af9e523501759a$var$publicKey(), this.staticAccountKeys.length, "staticAccountKeys"),
            $c3af9e523501759a$var$publicKey("recentBlockhash"),
            $Q02IV.blob(encodedInstructionsLength.length, "instructionsLength"),
            $Q02IV.blob(serializedInstructions.length, "serializedInstructions"),
            $Q02IV.blob(encodedAddressTableLookupsLength.length, "addressTableLookupsLength"),
            $Q02IV.blob(serializedAddressTableLookups.length, "serializedAddressTableLookups")
        ]);
        const serializedMessage = new Uint8Array($c3af9e523501759a$export$4c6d5b89e1596f26);
        const MESSAGE_VERSION_0_PREFIX = 128;
        const serializedMessageLength = messageLayout.encode({
            prefix: MESSAGE_VERSION_0_PREFIX,
            header: this.header,
            staticAccountKeysLength: new Uint8Array(encodedStaticAccountKeysLength),
            staticAccountKeys: this.staticAccountKeys.map((key)=>key.toBytes()),
            recentBlockhash: (0, (/*@__PURE__*/$parcel$interopDefault($4UTkl))).decode(this.recentBlockhash),
            instructionsLength: new Uint8Array(encodedInstructionsLength),
            serializedInstructions: serializedInstructions,
            addressTableLookupsLength: new Uint8Array(encodedAddressTableLookupsLength),
            serializedAddressTableLookups: serializedAddressTableLookups
        }, serializedMessage);
        return serializedMessage.slice(0, serializedMessageLength);
    }
    serializeInstructions() {
        let serializedLength = 0;
        const serializedInstructions = new Uint8Array($c3af9e523501759a$export$4c6d5b89e1596f26);
        for (const instruction of this.compiledInstructions){
            const encodedAccountKeyIndexesLength = Array();
            $c3af9e523501759a$var$encodeLength(encodedAccountKeyIndexesLength, instruction.accountKeyIndexes.length);
            const encodedDataLength = Array();
            $c3af9e523501759a$var$encodeLength(encodedDataLength, instruction.data.length);
            const instructionLayout = $Q02IV.struct([
                $Q02IV.u8("programIdIndex"),
                $Q02IV.blob(encodedAccountKeyIndexesLength.length, "encodedAccountKeyIndexesLength"),
                $Q02IV.seq($Q02IV.u8(), instruction.accountKeyIndexes.length, "accountKeyIndexes"),
                $Q02IV.blob(encodedDataLength.length, "encodedDataLength"),
                $Q02IV.blob(instruction.data.length, "data")
            ]);
            serializedLength += instructionLayout.encode({
                programIdIndex: instruction.programIdIndex,
                encodedAccountKeyIndexesLength: new Uint8Array(encodedAccountKeyIndexesLength),
                accountKeyIndexes: instruction.accountKeyIndexes,
                encodedDataLength: new Uint8Array(encodedDataLength),
                data: instruction.data
            }, serializedInstructions, serializedLength);
        }
        return serializedInstructions.slice(0, serializedLength);
    }
    serializeAddressTableLookups() {
        let serializedLength = 0;
        const serializedAddressTableLookups = new Uint8Array($c3af9e523501759a$export$4c6d5b89e1596f26);
        for (const lookup of this.addressTableLookups){
            const encodedWritableIndexesLength = Array();
            $c3af9e523501759a$var$encodeLength(encodedWritableIndexesLength, lookup.writableIndexes.length);
            const encodedReadonlyIndexesLength = Array();
            $c3af9e523501759a$var$encodeLength(encodedReadonlyIndexesLength, lookup.readonlyIndexes.length);
            const addressTableLookupLayout = $Q02IV.struct([
                $c3af9e523501759a$var$publicKey("accountKey"),
                $Q02IV.blob(encodedWritableIndexesLength.length, "encodedWritableIndexesLength"),
                $Q02IV.seq($Q02IV.u8(), lookup.writableIndexes.length, "writableIndexes"),
                $Q02IV.blob(encodedReadonlyIndexesLength.length, "encodedReadonlyIndexesLength"),
                $Q02IV.seq($Q02IV.u8(), lookup.readonlyIndexes.length, "readonlyIndexes")
            ]);
            serializedLength += addressTableLookupLayout.encode({
                accountKey: lookup.accountKey.toBytes(),
                encodedWritableIndexesLength: new Uint8Array(encodedWritableIndexesLength),
                writableIndexes: lookup.writableIndexes,
                encodedReadonlyIndexesLength: new Uint8Array(encodedReadonlyIndexesLength),
                readonlyIndexes: lookup.readonlyIndexes
            }, serializedAddressTableLookups, serializedLength);
        }
        return serializedAddressTableLookups.slice(0, serializedLength);
    }
    static deserialize(serializedMessage) {
        let byteArray = [
            ...serializedMessage
        ];
        const prefix = byteArray.shift();
        const maskedPrefix = prefix & $c3af9e523501759a$export$3c3793d809f8b858;
        $c3af9e523501759a$var$assert(prefix !== maskedPrefix, `Expected versioned message but received legacy message`);
        const version = maskedPrefix;
        $c3af9e523501759a$var$assert(version === 0, `Expected versioned message with version 0 but found version ${version}`);
        const header = {
            numRequiredSignatures: byteArray.shift(),
            numReadonlySignedAccounts: byteArray.shift(),
            numReadonlyUnsignedAccounts: byteArray.shift()
        };
        const staticAccountKeys = [];
        const staticAccountKeysLength = $c3af9e523501759a$var$decodeLength(byteArray);
        for(let i = 0; i < staticAccountKeysLength; i++)staticAccountKeys.push(new $c3af9e523501759a$export$ca8b6604d6ce14de(byteArray.splice(0, $c3af9e523501759a$export$84fc0a248cc54343)));
        const recentBlockhash = (0, (/*@__PURE__*/$parcel$interopDefault($4UTkl))).encode(byteArray.splice(0, $c3af9e523501759a$export$84fc0a248cc54343));
        const instructionCount = $c3af9e523501759a$var$decodeLength(byteArray);
        const compiledInstructions = [];
        for(let i = 0; i < instructionCount; i++){
            const programIdIndex = byteArray.shift();
            const accountKeyIndexesLength = $c3af9e523501759a$var$decodeLength(byteArray);
            const accountKeyIndexes = byteArray.splice(0, accountKeyIndexesLength);
            const dataLength = $c3af9e523501759a$var$decodeLength(byteArray);
            const data = new Uint8Array(byteArray.splice(0, dataLength));
            compiledInstructions.push({
                programIdIndex: programIdIndex,
                accountKeyIndexes: accountKeyIndexes,
                data: data
            });
        }
        const addressTableLookupsCount = $c3af9e523501759a$var$decodeLength(byteArray);
        const addressTableLookups = [];
        for(let i = 0; i < addressTableLookupsCount; i++){
            const accountKey = new $c3af9e523501759a$export$ca8b6604d6ce14de(byteArray.splice(0, $c3af9e523501759a$export$84fc0a248cc54343));
            const writableIndexesLength = $c3af9e523501759a$var$decodeLength(byteArray);
            const writableIndexes = byteArray.splice(0, writableIndexesLength);
            const readonlyIndexesLength = $c3af9e523501759a$var$decodeLength(byteArray);
            const readonlyIndexes = byteArray.splice(0, readonlyIndexesLength);
            addressTableLookups.push({
                accountKey: accountKey,
                writableIndexes: writableIndexes,
                readonlyIndexes: readonlyIndexes
            });
        }
        return new $c3af9e523501759a$export$ee274c70e0fae590({
            header: header,
            staticAccountKeys: staticAccountKeys,
            recentBlockhash: recentBlockhash,
            compiledInstructions: compiledInstructions,
            addressTableLookups: addressTableLookups
        });
    }
}
// eslint-disable-next-line no-redeclare
const $c3af9e523501759a$export$b0a61927d00ede7f = {
    deserializeMessageVersion (serializedMessage) {
        const prefix = serializedMessage[0];
        const maskedPrefix = prefix & $c3af9e523501759a$export$3c3793d809f8b858;
        // if the highest bit of the prefix is not set, the message is not versioned
        if (maskedPrefix === prefix) return "legacy";
        // the lower 7 bits of the prefix indicate the message version
        return maskedPrefix;
    },
    deserialize: (serializedMessage)=>{
        const version = $c3af9e523501759a$export$b0a61927d00ede7f.deserializeMessageVersion(serializedMessage);
        if (version === "legacy") return $c3af9e523501759a$export$f69c19e57285b83a.from(serializedMessage);
        if (version === 0) return $c3af9e523501759a$export$ee274c70e0fae590.deserialize(serializedMessage);
        else throw new Error(`Transaction message version ${version} deserialization is not supported`);
    }
};
/**
 * Transaction signature as base-58 encoded string
 */ let $c3af9e523501759a$export$7c391bd3b61d2374 = /*#__PURE__*/ function(TransactionStatus) {
    TransactionStatus[TransactionStatus["BLOCKHEIGHT_EXCEEDED"] = 0] = "BLOCKHEIGHT_EXCEEDED";
    TransactionStatus[TransactionStatus["PROCESSED"] = 1] = "PROCESSED";
    TransactionStatus[TransactionStatus["TIMED_OUT"] = 2] = "TIMED_OUT";
    TransactionStatus[TransactionStatus["NONCE_INVALID"] = 3] = "NONCE_INVALID";
    return TransactionStatus;
}({});
/**
 * Default (empty) signature
 */ const $c3af9e523501759a$var$DEFAULT_SIGNATURE = (0, $6ZWSX.Buffer).alloc($c3af9e523501759a$export$14aee086fde78fa6).fill(0);
/**
 * Account metadata used to define instructions
 */ /**
 * List of TransactionInstruction object fields that may be initialized at construction
 */ /**
 * Configuration object for Transaction.serialize()
 */ /**
 * @internal
 */ /**
 * Transaction Instruction class
 */ class $c3af9e523501759a$export$a7a3aa8360ac9f59 {
    constructor(opts){
        /**
     * Public keys to include in this transaction
     * Boolean represents whether this pubkey needs to sign the transaction
     */ this.keys = void 0;
        /**
     * Program Id to execute
     */ this.programId = void 0;
        /**
     * Program input
     */ this.data = (0, $6ZWSX.Buffer).alloc(0);
        this.programId = opts.programId;
        this.keys = opts.keys;
        if (opts.data) this.data = opts.data;
    }
    /**
   * @internal
   */ toJSON() {
        return {
            keys: this.keys.map(({ pubkey: pubkey, isSigner: isSigner, isWritable: isWritable })=>({
                    pubkey: pubkey.toJSON(),
                    isSigner: isSigner,
                    isWritable: isWritable
                })),
            programId: this.programId.toJSON(),
            data: [
                ...this.data
            ]
        };
    }
}
/**
 * Pair of signature and corresponding public key
 */ /**
 * List of Transaction object fields that may be initialized at construction
 */ // For backward compatibility; an unfortunate consequence of being
// forced to over-export types by the documentation generator.
// See https://github.com/solana-labs/solana/pull/25820
/**
 * Blockhash-based transactions have a lifetime that are defined by
 * the blockhash they include. Any transaction whose blockhash is
 * too old will be rejected.
 */ /**
 * Use these options to construct a durable nonce transaction.
 */ /**
 * Nonce information to be used to build an offline Transaction.
 */ /**
 * @internal
 */ /**
 * Transaction class
 */ class $c3af9e523501759a$export$febc5573c75cefb0 {
    /**
   * The first (payer) Transaction signature
   *
   * @returns {Buffer | null} Buffer of payer's signature
   */ get signature() {
        if (this.signatures.length > 0) return this.signatures[0].signature;
        return null;
    }
    /**
   * The transaction fee payer
   */ // Construct a transaction with a blockhash and lastValidBlockHeight
    // Construct a transaction using a durable nonce
    /**
   * @deprecated `TransactionCtorFields` has been deprecated and will be removed in a future version.
   * Please supply a `TransactionBlockhashCtor` instead.
   */ /**
   * Construct an empty Transaction
   */ constructor(opts){
        /**
     * Signatures for the transaction.  Typically created by invoking the
     * `sign()` method
     */ this.signatures = [];
        this.feePayer = void 0;
        /**
     * The instructions to atomically execute
     */ this.instructions = [];
        /**
     * A recent transaction id. Must be populated by the caller
     */ this.recentBlockhash = void 0;
        /**
     * the last block chain can advance to before tx is declared expired
     * */ this.lastValidBlockHeight = void 0;
        /**
     * Optional Nonce information. If populated, transaction will use a durable
     * Nonce hash instead of a recentBlockhash. Must be populated by the caller
     */ this.nonceInfo = void 0;
        /**
     * If this is a nonce transaction this represents the minimum slot from which
     * to evaluate if the nonce has advanced when attempting to confirm the
     * transaction. This protects against a case where the transaction confirmation
     * logic loads the nonce account from an old slot and assumes the mismatch in
     * nonce value implies that the nonce has been advanced.
     */ this.minNonceContextSlot = void 0;
        /**
     * @internal
     */ this._message = void 0;
        /**
     * @internal
     */ this._json = void 0;
        if (!opts) return;
        if (opts.feePayer) this.feePayer = opts.feePayer;
        if (opts.signatures) this.signatures = opts.signatures;
        if (Object.prototype.hasOwnProperty.call(opts, "nonceInfo")) {
            const { minContextSlot: minContextSlot, nonceInfo: nonceInfo } = opts;
            this.minNonceContextSlot = minContextSlot;
            this.nonceInfo = nonceInfo;
        } else if (Object.prototype.hasOwnProperty.call(opts, "lastValidBlockHeight")) {
            const { blockhash: blockhash, lastValidBlockHeight: lastValidBlockHeight } = opts;
            this.recentBlockhash = blockhash;
            this.lastValidBlockHeight = lastValidBlockHeight;
        } else {
            const { recentBlockhash: recentBlockhash, nonceInfo: nonceInfo } = opts;
            if (nonceInfo) this.nonceInfo = nonceInfo;
            this.recentBlockhash = recentBlockhash;
        }
    }
    /**
   * @internal
   */ toJSON() {
        return {
            recentBlockhash: this.recentBlockhash || null,
            feePayer: this.feePayer ? this.feePayer.toJSON() : null,
            nonceInfo: this.nonceInfo ? {
                nonce: this.nonceInfo.nonce,
                nonceInstruction: this.nonceInfo.nonceInstruction.toJSON()
            } : null,
            instructions: this.instructions.map((instruction)=>instruction.toJSON()),
            signers: this.signatures.map(({ publicKey: publicKey })=>{
                return publicKey.toJSON();
            })
        };
    }
    /**
   * Add one or more instructions to this Transaction
   *
   * @param {Array< Transaction | TransactionInstruction | TransactionInstructionCtorFields >} items - Instructions to add to the Transaction
   */ add(...items) {
        if (items.length === 0) throw new Error("No instructions");
        items.forEach((item)=>{
            if ("instructions" in item) this.instructions = this.instructions.concat(item.instructions);
            else if ("data" in item && "programId" in item && "keys" in item) this.instructions.push(item);
            else this.instructions.push(new $c3af9e523501759a$export$a7a3aa8360ac9f59(item));
        });
        return this;
    }
    /**
   * Compile transaction data
   */ compileMessage() {
        if (this._message && JSON.stringify(this.toJSON()) === JSON.stringify(this._json)) return this._message;
        let recentBlockhash;
        let instructions;
        if (this.nonceInfo) {
            recentBlockhash = this.nonceInfo.nonce;
            if (this.instructions[0] != this.nonceInfo.nonceInstruction) instructions = [
                this.nonceInfo.nonceInstruction,
                ...this.instructions
            ];
            else instructions = this.instructions;
        } else {
            recentBlockhash = this.recentBlockhash;
            instructions = this.instructions;
        }
        if (!recentBlockhash) throw new Error("Transaction recentBlockhash required");
        if (instructions.length < 1) console.warn("No instructions provided");
        let feePayer;
        if (this.feePayer) feePayer = this.feePayer;
        else if (this.signatures.length > 0 && this.signatures[0].publicKey) // Use implicit fee payer
        feePayer = this.signatures[0].publicKey;
        else throw new Error("Transaction fee payer required");
        for(let i = 0; i < instructions.length; i++){
            if (instructions[i].programId === undefined) throw new Error(`Transaction instruction index ${i} has undefined program id`);
        }
        const programIds = [];
        const accountMetas = [];
        instructions.forEach((instruction)=>{
            instruction.keys.forEach((accountMeta)=>{
                accountMetas.push({
                    ...accountMeta
                });
            });
            const programId = instruction.programId.toString();
            if (!programIds.includes(programId)) programIds.push(programId);
        });
        // Append programID account metas
        programIds.forEach((programId)=>{
            accountMetas.push({
                pubkey: new $c3af9e523501759a$export$ca8b6604d6ce14de(programId),
                isSigner: false,
                isWritable: false
            });
        });
        // Cull duplicate account metas
        const uniqueMetas = [];
        accountMetas.forEach((accountMeta)=>{
            const pubkeyString = accountMeta.pubkey.toString();
            const uniqueIndex = uniqueMetas.findIndex((x)=>{
                return x.pubkey.toString() === pubkeyString;
            });
            if (uniqueIndex > -1) {
                uniqueMetas[uniqueIndex].isWritable = uniqueMetas[uniqueIndex].isWritable || accountMeta.isWritable;
                uniqueMetas[uniqueIndex].isSigner = uniqueMetas[uniqueIndex].isSigner || accountMeta.isSigner;
            } else uniqueMetas.push(accountMeta);
        });
        // Sort. Prioritizing first by signer, then by writable
        uniqueMetas.sort(function(x, y) {
            if (x.isSigner !== y.isSigner) // Signers always come before non-signers
            return x.isSigner ? -1 : 1;
            if (x.isWritable !== y.isWritable) // Writable accounts always come before read-only accounts
            return x.isWritable ? -1 : 1;
            // Otherwise, sort by pubkey, stringwise.
            const options = {
                localeMatcher: "best fit",
                usage: "sort",
                sensitivity: "variant",
                ignorePunctuation: false,
                numeric: false,
                caseFirst: "lower"
            };
            return x.pubkey.toBase58().localeCompare(y.pubkey.toBase58(), "en", options);
        });
        // Move fee payer to the front
        const feePayerIndex = uniqueMetas.findIndex((x)=>{
            return x.pubkey.equals(feePayer);
        });
        if (feePayerIndex > -1) {
            const [payerMeta] = uniqueMetas.splice(feePayerIndex, 1);
            payerMeta.isSigner = true;
            payerMeta.isWritable = true;
            uniqueMetas.unshift(payerMeta);
        } else uniqueMetas.unshift({
            pubkey: feePayer,
            isSigner: true,
            isWritable: true
        });
        // Disallow unknown signers
        for (const signature of this.signatures){
            const uniqueIndex = uniqueMetas.findIndex((x)=>{
                return x.pubkey.equals(signature.publicKey);
            });
            if (uniqueIndex > -1) {
                if (!uniqueMetas[uniqueIndex].isSigner) {
                    uniqueMetas[uniqueIndex].isSigner = true;
                    console.warn("Transaction references a signature that is unnecessary, only the fee payer and instruction signer accounts should sign a transaction. This behavior is deprecated and will throw an error in the next major version release.");
                }
            } else throw new Error(`unknown signer: ${signature.publicKey.toString()}`);
        }
        let numRequiredSignatures = 0;
        let numReadonlySignedAccounts = 0;
        let numReadonlyUnsignedAccounts = 0;
        // Split out signing from non-signing keys and count header values
        const signedKeys = [];
        const unsignedKeys = [];
        uniqueMetas.forEach(({ pubkey: pubkey, isSigner: isSigner, isWritable: isWritable })=>{
            if (isSigner) {
                signedKeys.push(pubkey.toString());
                numRequiredSignatures += 1;
                if (!isWritable) numReadonlySignedAccounts += 1;
            } else {
                unsignedKeys.push(pubkey.toString());
                if (!isWritable) numReadonlyUnsignedAccounts += 1;
            }
        });
        const accountKeys = signedKeys.concat(unsignedKeys);
        const compiledInstructions = instructions.map((instruction)=>{
            const { data: data, programId: programId } = instruction;
            return {
                programIdIndex: accountKeys.indexOf(programId.toString()),
                accounts: instruction.keys.map((meta)=>accountKeys.indexOf(meta.pubkey.toString())),
                data: (0, (/*@__PURE__*/$parcel$interopDefault($4UTkl))).encode(data)
            };
        });
        compiledInstructions.forEach((instruction)=>{
            $c3af9e523501759a$var$assert(instruction.programIdIndex >= 0);
            instruction.accounts.forEach((keyIndex)=>$c3af9e523501759a$var$assert(keyIndex >= 0));
        });
        return new $c3af9e523501759a$export$f69c19e57285b83a({
            header: {
                numRequiredSignatures: numRequiredSignatures,
                numReadonlySignedAccounts: numReadonlySignedAccounts,
                numReadonlyUnsignedAccounts: numReadonlyUnsignedAccounts
            },
            accountKeys: accountKeys,
            recentBlockhash: recentBlockhash,
            instructions: compiledInstructions
        });
    }
    /**
   * @internal
   */ _compile() {
        const message = this.compileMessage();
        const signedKeys = message.accountKeys.slice(0, message.header.numRequiredSignatures);
        if (this.signatures.length === signedKeys.length) {
            const valid = this.signatures.every((pair, index)=>{
                return signedKeys[index].equals(pair.publicKey);
            });
            if (valid) return message;
        }
        this.signatures = signedKeys.map((publicKey)=>({
                signature: null,
                publicKey: publicKey
            }));
        return message;
    }
    /**
   * Get a buffer of the Transaction data that need to be covered by signatures
   */ serializeMessage() {
        return this._compile().serialize();
    }
    /**
   * Get the estimated fee associated with a transaction
   *
   * @param {Connection} connection Connection to RPC Endpoint.
   *
   * @returns {Promise<number | null>} The estimated fee for the transaction
   */ async getEstimatedFee(connection) {
        return (await connection.getFeeForMessage(this.compileMessage())).value;
    }
    /**
   * Specify the public keys which will be used to sign the Transaction.
   * The first signer will be used as the transaction fee payer account.
   *
   * Signatures can be added with either `partialSign` or `addSignature`
   *
   * @deprecated Deprecated since v0.84.0. Only the fee payer needs to be
   * specified and it can be set in the Transaction constructor or with the
   * `feePayer` property.
   */ setSigners(...signers) {
        if (signers.length === 0) throw new Error("No signers");
        const seen = new Set();
        this.signatures = signers.filter((publicKey)=>{
            const key = publicKey.toString();
            if (seen.has(key)) return false;
            else {
                seen.add(key);
                return true;
            }
        }).map((publicKey)=>({
                signature: null,
                publicKey: publicKey
            }));
    }
    /**
   * Sign the Transaction with the specified signers. Multiple signatures may
   * be applied to a Transaction. The first signature is considered "primary"
   * and is used identify and confirm transactions.
   *
   * If the Transaction `feePayer` is not set, the first signer will be used
   * as the transaction fee payer account.
   *
   * Transaction fields should not be modified after the first call to `sign`,
   * as doing so may invalidate the signature and cause the Transaction to be
   * rejected.
   *
   * The Transaction must be assigned a valid `recentBlockhash` before invoking this method
   *
   * @param {Array<Signer>} signers Array of signers that will sign the transaction
   */ sign(...signers) {
        if (signers.length === 0) throw new Error("No signers");
        // Dedupe signers
        const seen = new Set();
        const uniqueSigners = [];
        for (const signer of signers){
            const key = signer.publicKey.toString();
            if (seen.has(key)) continue;
            else {
                seen.add(key);
                uniqueSigners.push(signer);
            }
        }
        this.signatures = uniqueSigners.map((signer)=>({
                signature: null,
                publicKey: signer.publicKey
            }));
        const message = this._compile();
        this._partialSign(message, ...uniqueSigners);
    }
    /**
   * Partially sign a transaction with the specified accounts. All accounts must
   * correspond to either the fee payer or a signer account in the transaction
   * instructions.
   *
   * All the caveats from the `sign` method apply to `partialSign`
   *
   * @param {Array<Signer>} signers Array of signers that will sign the transaction
   */ partialSign(...signers) {
        if (signers.length === 0) throw new Error("No signers");
        // Dedupe signers
        const seen = new Set();
        const uniqueSigners = [];
        for (const signer of signers){
            const key = signer.publicKey.toString();
            if (seen.has(key)) continue;
            else {
                seen.add(key);
                uniqueSigners.push(signer);
            }
        }
        const message = this._compile();
        this._partialSign(message, ...uniqueSigners);
    }
    /**
   * @internal
   */ _partialSign(message, ...signers) {
        const signData = message.serialize();
        signers.forEach((signer)=>{
            const signature = $c3af9e523501759a$var$sign(signData, signer.secretKey);
            this._addSignature(signer.publicKey, $c3af9e523501759a$var$toBuffer(signature));
        });
    }
    /**
   * Add an externally created signature to a transaction. The public key
   * must correspond to either the fee payer or a signer account in the transaction
   * instructions.
   *
   * @param {PublicKey} pubkey Public key that will be added to the transaction.
   * @param {Buffer} signature An externally created signature to add to the transaction.
   */ addSignature(pubkey, signature) {
        this._compile(); // Ensure signatures array is populated
        this._addSignature(pubkey, signature);
    }
    /**
   * @internal
   */ _addSignature(pubkey, signature) {
        $c3af9e523501759a$var$assert(signature.length === 64);
        const index = this.signatures.findIndex((sigpair)=>pubkey.equals(sigpair.publicKey));
        if (index < 0) throw new Error(`unknown signer: ${pubkey.toString()}`);
        this.signatures[index].signature = (0, $6ZWSX.Buffer).from(signature);
    }
    /**
   * Verify signatures of a Transaction
   * Optional parameter specifies if we're expecting a fully signed Transaction or a partially signed one.
   * If no boolean is provided, we expect a fully signed Transaction by default.
   *
   * @param {boolean} [requireAllSignatures=true] Require a fully signed Transaction
   */ verifySignatures(requireAllSignatures) {
        return this._verifySignatures(this.serializeMessage(), requireAllSignatures === undefined ? true : requireAllSignatures);
    }
    /**
   * @internal
   */ _verifySignatures(signData, requireAllSignatures) {
        for (const { signature: signature, publicKey: publicKey } of this.signatures)if (signature === null) {
            if (requireAllSignatures) return false;
        } else {
            if (!$c3af9e523501759a$var$verify(signature, signData, publicKey.toBytes())) return false;
        }
        return true;
    }
    /**
   * Serialize the Transaction in the wire format.
   *
   * @param {Buffer} [config] Config of transaction.
   *
   * @returns {Buffer} Signature of transaction in wire format.
   */ serialize(config) {
        const { requireAllSignatures: requireAllSignatures, verifySignatures: verifySignatures } = Object.assign({
            requireAllSignatures: true,
            verifySignatures: true
        }, config);
        const signData = this.serializeMessage();
        if (verifySignatures && !this._verifySignatures(signData, requireAllSignatures)) throw new Error("Signature verification failed");
        return this._serialize(signData);
    }
    /**
   * @internal
   */ _serialize(signData) {
        const { signatures: signatures } = this;
        const signatureCount = [];
        $c3af9e523501759a$var$encodeLength(signatureCount, signatures.length);
        const transactionLength = signatureCount.length + signatures.length * 64 + signData.length;
        const wireTransaction = (0, $6ZWSX.Buffer).alloc(transactionLength);
        $c3af9e523501759a$var$assert(signatures.length < 256);
        (0, $6ZWSX.Buffer).from(signatureCount).copy(wireTransaction, 0);
        signatures.forEach(({ signature: signature }, index)=>{
            if (signature !== null) {
                $c3af9e523501759a$var$assert(signature.length === 64, `signature has invalid length`);
                (0, $6ZWSX.Buffer).from(signature).copy(wireTransaction, signatureCount.length + index * 64);
            }
        });
        signData.copy(wireTransaction, signatureCount.length + signatures.length * 64);
        $c3af9e523501759a$var$assert(wireTransaction.length <= $c3af9e523501759a$export$4c6d5b89e1596f26, `Transaction too large: ${wireTransaction.length} > ${$c3af9e523501759a$export$4c6d5b89e1596f26}`);
        return wireTransaction;
    }
    /**
   * Deprecated method
   * @internal
   */ get keys() {
        $c3af9e523501759a$var$assert(this.instructions.length === 1);
        return this.instructions[0].keys.map((keyObj)=>keyObj.pubkey);
    }
    /**
   * Deprecated method
   * @internal
   */ get programId() {
        $c3af9e523501759a$var$assert(this.instructions.length === 1);
        return this.instructions[0].programId;
    }
    /**
   * Deprecated method
   * @internal
   */ get data() {
        $c3af9e523501759a$var$assert(this.instructions.length === 1);
        return this.instructions[0].data;
    }
    /**
   * Parse a wire transaction into a Transaction object.
   *
   * @param {Buffer | Uint8Array | Array<number>} buffer Signature of wire Transaction
   *
   * @returns {Transaction} Transaction associated with the signature
   */ static from(buffer) {
        // Slice up wire data
        let byteArray = [
            ...buffer
        ];
        const signatureCount = $c3af9e523501759a$var$decodeLength(byteArray);
        let signatures = [];
        for(let i = 0; i < signatureCount; i++){
            const signature = byteArray.slice(0, $c3af9e523501759a$export$14aee086fde78fa6);
            byteArray = byteArray.slice($c3af9e523501759a$export$14aee086fde78fa6);
            signatures.push((0, (/*@__PURE__*/$parcel$interopDefault($4UTkl))).encode((0, $6ZWSX.Buffer).from(signature)));
        }
        return $c3af9e523501759a$export$febc5573c75cefb0.populate($c3af9e523501759a$export$f69c19e57285b83a.from(byteArray), signatures);
    }
    /**
   * Populate Transaction object from message and signatures
   *
   * @param {Message} message Message of transaction
   * @param {Array<string>} signatures List of signatures to assign to the transaction
   *
   * @returns {Transaction} The populated Transaction
   */ static populate(message, signatures = []) {
        const transaction = new $c3af9e523501759a$export$febc5573c75cefb0();
        transaction.recentBlockhash = message.recentBlockhash;
        if (message.header.numRequiredSignatures > 0) transaction.feePayer = message.accountKeys[0];
        signatures.forEach((signature, index)=>{
            const sigPubkeyPair = {
                signature: signature == (0, (/*@__PURE__*/$parcel$interopDefault($4UTkl))).encode($c3af9e523501759a$var$DEFAULT_SIGNATURE) ? null : (0, (/*@__PURE__*/$parcel$interopDefault($4UTkl))).decode(signature),
                publicKey: message.accountKeys[index]
            };
            transaction.signatures.push(sigPubkeyPair);
        });
        message.instructions.forEach((instruction)=>{
            const keys = instruction.accounts.map((account)=>{
                const pubkey = message.accountKeys[account];
                return {
                    pubkey: pubkey,
                    isSigner: transaction.signatures.some((keyObj)=>keyObj.publicKey.toString() === pubkey.toString()) || message.isAccountSigner(account),
                    isWritable: message.isAccountWritable(account)
                };
            });
            transaction.instructions.push(new $c3af9e523501759a$export$a7a3aa8360ac9f59({
                keys: keys,
                programId: message.accountKeys[instruction.programIdIndex],
                data: (0, (/*@__PURE__*/$parcel$interopDefault($4UTkl))).decode(instruction.data)
            }));
        });
        transaction._message = message;
        transaction._json = transaction.toJSON();
        return transaction;
    }
}
class $c3af9e523501759a$export$eb15f3e001dd262d {
    constructor(args){
        this.payerKey = void 0;
        this.instructions = void 0;
        this.recentBlockhash = void 0;
        this.payerKey = args.payerKey;
        this.instructions = args.instructions;
        this.recentBlockhash = args.recentBlockhash;
    }
    static decompile(message, args) {
        const { header: header, compiledInstructions: compiledInstructions, recentBlockhash: recentBlockhash } = message;
        const { numRequiredSignatures: numRequiredSignatures, numReadonlySignedAccounts: numReadonlySignedAccounts, numReadonlyUnsignedAccounts: numReadonlyUnsignedAccounts } = header;
        const numWritableSignedAccounts = numRequiredSignatures - numReadonlySignedAccounts;
        $c3af9e523501759a$var$assert(numWritableSignedAccounts > 0, "Message header is invalid");
        const numWritableUnsignedAccounts = message.staticAccountKeys.length - numRequiredSignatures - numReadonlyUnsignedAccounts;
        $c3af9e523501759a$var$assert(numWritableUnsignedAccounts >= 0, "Message header is invalid");
        const accountKeys = message.getAccountKeys(args);
        const payerKey = accountKeys.get(0);
        if (payerKey === undefined) throw new Error("Failed to decompile message because no account keys were found");
        const instructions = [];
        for (const compiledIx of compiledInstructions){
            const keys = [];
            for (const keyIndex of compiledIx.accountKeyIndexes){
                const pubkey = accountKeys.get(keyIndex);
                if (pubkey === undefined) throw new Error(`Failed to find key for account key index ${keyIndex}`);
                const isSigner = keyIndex < numRequiredSignatures;
                let isWritable;
                if (isSigner) isWritable = keyIndex < numWritableSignedAccounts;
                else if (keyIndex < accountKeys.staticAccountKeys.length) isWritable = keyIndex - numRequiredSignatures < numWritableUnsignedAccounts;
                else isWritable = keyIndex - accountKeys.staticAccountKeys.length < // accountKeysFromLookups cannot be undefined because we already found a pubkey for this index above
                accountKeys.accountKeysFromLookups.writable.length;
                keys.push({
                    pubkey: pubkey,
                    isSigner: keyIndex < header.numRequiredSignatures,
                    isWritable: isWritable
                });
            }
            const programId = accountKeys.get(compiledIx.programIdIndex);
            if (programId === undefined) throw new Error(`Failed to find program id for program id index ${compiledIx.programIdIndex}`);
            instructions.push(new $c3af9e523501759a$export$a7a3aa8360ac9f59({
                programId: programId,
                data: $c3af9e523501759a$var$toBuffer(compiledIx.data),
                keys: keys
            }));
        }
        return new $c3af9e523501759a$export$eb15f3e001dd262d({
            payerKey: payerKey,
            instructions: instructions,
            recentBlockhash: recentBlockhash
        });
    }
    compileToLegacyMessage() {
        return $c3af9e523501759a$export$f69c19e57285b83a.compile({
            payerKey: this.payerKey,
            recentBlockhash: this.recentBlockhash,
            instructions: this.instructions
        });
    }
    compileToV0Message(addressLookupTableAccounts) {
        return $c3af9e523501759a$export$ee274c70e0fae590.compile({
            payerKey: this.payerKey,
            recentBlockhash: this.recentBlockhash,
            instructions: this.instructions,
            addressLookupTableAccounts: addressLookupTableAccounts
        });
    }
}
/**
 * Versioned transaction class
 */ class $c3af9e523501759a$export$232cc3f078dcc284 {
    get version() {
        return this.message.version;
    }
    constructor(message, signatures){
        this.signatures = void 0;
        this.message = void 0;
        if (signatures !== undefined) {
            $c3af9e523501759a$var$assert(signatures.length === message.header.numRequiredSignatures, "Expected signatures length to be equal to the number of required signatures");
            this.signatures = signatures;
        } else {
            const defaultSignatures = [];
            for(let i = 0; i < message.header.numRequiredSignatures; i++)defaultSignatures.push(new Uint8Array($c3af9e523501759a$export$14aee086fde78fa6));
            this.signatures = defaultSignatures;
        }
        this.message = message;
    }
    serialize() {
        const serializedMessage = this.message.serialize();
        const encodedSignaturesLength = Array();
        $c3af9e523501759a$var$encodeLength(encodedSignaturesLength, this.signatures.length);
        const transactionLayout = $Q02IV.struct([
            $Q02IV.blob(encodedSignaturesLength.length, "encodedSignaturesLength"),
            $Q02IV.seq($c3af9e523501759a$var$signature(), this.signatures.length, "signatures"),
            $Q02IV.blob(serializedMessage.length, "serializedMessage")
        ]);
        const serializedTransaction = new Uint8Array(2048);
        const serializedTransactionLength = transactionLayout.encode({
            encodedSignaturesLength: new Uint8Array(encodedSignaturesLength),
            signatures: this.signatures,
            serializedMessage: serializedMessage
        }, serializedTransaction);
        return serializedTransaction.slice(0, serializedTransactionLength);
    }
    static deserialize(serializedTransaction) {
        let byteArray = [
            ...serializedTransaction
        ];
        const signatures = [];
        const signaturesLength = $c3af9e523501759a$var$decodeLength(byteArray);
        for(let i = 0; i < signaturesLength; i++)signatures.push(new Uint8Array(byteArray.splice(0, $c3af9e523501759a$export$14aee086fde78fa6)));
        const message = $c3af9e523501759a$export$b0a61927d00ede7f.deserialize(new Uint8Array(byteArray));
        return new $c3af9e523501759a$export$232cc3f078dcc284(message, signatures);
    }
    sign(signers) {
        const messageData = this.message.serialize();
        const signerPubkeys = this.message.staticAccountKeys.slice(0, this.message.header.numRequiredSignatures);
        for (const signer of signers){
            const signerIndex = signerPubkeys.findIndex((pubkey)=>pubkey.equals(signer.publicKey));
            $c3af9e523501759a$var$assert(signerIndex >= 0, `Cannot sign with non signer key ${signer.publicKey.toBase58()}`);
            this.signatures[signerIndex] = $c3af9e523501759a$var$sign(messageData, signer.secretKey);
        }
    }
    addSignature(publicKey, signature) {
        $c3af9e523501759a$var$assert(signature.byteLength === 64, "Signature must be 64 bytes long");
        const signerPubkeys = this.message.staticAccountKeys.slice(0, this.message.header.numRequiredSignatures);
        const signerIndex = signerPubkeys.findIndex((pubkey)=>pubkey.equals(publicKey));
        $c3af9e523501759a$var$assert(signerIndex >= 0, `Can not add signature; \`${publicKey.toBase58()}\` is not required to sign this transaction`);
        this.signatures[signerIndex] = signature;
    }
}
// TODO: These constants should be removed in favor of reading them out of a
// Syscall account
/**
 * @internal
 */ const $c3af9e523501759a$var$NUM_TICKS_PER_SECOND = 160;
/**
 * @internal
 */ const $c3af9e523501759a$var$DEFAULT_TICKS_PER_SLOT = 64;
/**
 * @internal
 */ const $c3af9e523501759a$var$NUM_SLOTS_PER_SECOND = $c3af9e523501759a$var$NUM_TICKS_PER_SECOND / $c3af9e523501759a$var$DEFAULT_TICKS_PER_SLOT;
/**
 * @internal
 */ const $c3af9e523501759a$var$MS_PER_SLOT = 1000 / $c3af9e523501759a$var$NUM_SLOTS_PER_SECOND;
const $c3af9e523501759a$export$393aa1412d47050e = new $c3af9e523501759a$export$ca8b6604d6ce14de("SysvarC1ock11111111111111111111111111111111");
const $c3af9e523501759a$export$2b71d479444d2f4 = new $c3af9e523501759a$export$ca8b6604d6ce14de("SysvarEpochSchedu1e111111111111111111111111");
const $c3af9e523501759a$export$54419cc1a3ece8d6 = new $c3af9e523501759a$export$ca8b6604d6ce14de("Sysvar1nstructions1111111111111111111111111");
const $c3af9e523501759a$export$e74201139e9833db = new $c3af9e523501759a$export$ca8b6604d6ce14de("SysvarRecentB1ockHashes11111111111111111111");
const $c3af9e523501759a$export$970d0190cdb3a8e9 = new $c3af9e523501759a$export$ca8b6604d6ce14de("SysvarRent111111111111111111111111111111111");
const $c3af9e523501759a$export$da3b38d796bc1af1 = new $c3af9e523501759a$export$ca8b6604d6ce14de("SysvarRewards111111111111111111111111111111");
const $c3af9e523501759a$export$7b3a057916a4a7ae = new $c3af9e523501759a$export$ca8b6604d6ce14de("SysvarS1otHashes111111111111111111111111111");
const $c3af9e523501759a$export$3272815bf0633907 = new $c3af9e523501759a$export$ca8b6604d6ce14de("SysvarS1otHistory11111111111111111111111111");
const $c3af9e523501759a$export$ca994171317280ea = new $c3af9e523501759a$export$ca8b6604d6ce14de("SysvarStakeHistory1111111111111111111111111");
/**
 * Sign, send and confirm a transaction.
 *
 * If `commitment` option is not specified, defaults to 'max' commitment.
 *
 * @param {Connection} connection
 * @param {Transaction} transaction
 * @param {Array<Signer>} signers
 * @param {ConfirmOptions} [options]
 * @returns {Promise<TransactionSignature>}
 */ async function $c3af9e523501759a$export$4ad6fe6dae0b6bc3(connection, transaction, signers, options) {
    const sendOptions = options && {
        skipPreflight: options.skipPreflight,
        preflightCommitment: options.preflightCommitment || options.commitment,
        maxRetries: options.maxRetries,
        minContextSlot: options.minContextSlot
    };
    const signature = await connection.sendTransaction(transaction, signers, sendOptions);
    let status;
    if (transaction.recentBlockhash != null && transaction.lastValidBlockHeight != null) status = (await connection.confirmTransaction({
        abortSignal: options?.abortSignal,
        signature: signature,
        blockhash: transaction.recentBlockhash,
        lastValidBlockHeight: transaction.lastValidBlockHeight
    }, options && options.commitment)).value;
    else if (transaction.minNonceContextSlot != null && transaction.nonceInfo != null) {
        const { nonceInstruction: nonceInstruction } = transaction.nonceInfo;
        const nonceAccountPubkey = nonceInstruction.keys[0].pubkey;
        status = (await connection.confirmTransaction({
            abortSignal: options?.abortSignal,
            minContextSlot: transaction.minNonceContextSlot,
            nonceAccountPubkey: nonceAccountPubkey,
            nonceValue: transaction.nonceInfo.nonce,
            signature: signature
        }, options && options.commitment)).value;
    } else {
        if (options?.abortSignal != null) console.warn("sendAndConfirmTransaction(): A transaction with a deprecated confirmation strategy was supplied along with an `abortSignal`. Only transactions having `lastValidBlockHeight` or a combination of `nonceInfo` and `minNonceContextSlot` are abortable.");
        status = (await connection.confirmTransaction(signature, options && options.commitment)).value;
    }
    if (status.err) throw new Error(`Transaction ${signature} failed (${JSON.stringify(status)})`);
    return signature;
}
// zzz
function $c3af9e523501759a$var$sleep(ms) {
    return new Promise((resolve)=>setTimeout(resolve, ms));
}
/**
 * @internal
 */ /**
 * Populate a buffer of instruction data using an InstructionType
 * @internal
 */ function $c3af9e523501759a$var$encodeData(type, fields) {
    const allocLength = type.layout.span >= 0 ? type.layout.span : $c3af9e523501759a$var$getAlloc(type, fields);
    const data = (0, $6ZWSX.Buffer).alloc(allocLength);
    const layoutFields = Object.assign({
        instruction: type.index
    }, fields);
    type.layout.encode(layoutFields, data);
    return data;
}
/**
 * Decode instruction data buffer using an InstructionType
 * @internal
 */ function $c3af9e523501759a$var$decodeData$1(type, buffer) {
    let data;
    try {
        data = type.layout.decode(buffer);
    } catch (err) {
        throw new Error("invalid instruction; " + err);
    }
    if (data.instruction !== type.index) throw new Error(`invalid instruction; instruction index mismatch ${data.instruction} != ${type.index}`);
    return data;
}
/**
 * https://github.com/solana-labs/solana/blob/90bedd7e067b5b8f3ddbb45da00a4e9cabb22c62/sdk/src/fee_calculator.rs#L7-L11
 *
 * @internal
 */ const $c3af9e523501759a$export$d1cc579b1c48f515 = $Q02IV.nu64("lamportsPerSignature");
/**
 * Calculator for transaction fees.
 *
 * @deprecated Deprecated since Solana v1.8.0.
 */ /**
 * See https://github.com/solana-labs/solana/blob/0ea2843ec9cdc517572b8e62c959f41b55cf4453/sdk/src/nonce_state.rs#L29-L32
 *
 * @internal
 */ const $c3af9e523501759a$var$NonceAccountLayout = $Q02IV.struct([
    $Q02IV.u32("version"),
    $Q02IV.u32("state"),
    $c3af9e523501759a$var$publicKey("authorizedPubkey"),
    $c3af9e523501759a$var$publicKey("nonce"),
    $Q02IV.struct([
        $c3af9e523501759a$export$d1cc579b1c48f515
    ], "feeCalculator")
]);
const $c3af9e523501759a$export$7126250b6d8bd94a = $c3af9e523501759a$var$NonceAccountLayout.span;
/**
 * A durable nonce is a 32 byte value encoded as a base58 string.
 */ /**
 * NonceAccount class
 */ class $c3af9e523501759a$export$ed1c2356ce604759 {
    /**
   * @internal
   */ constructor(args){
        this.authorizedPubkey = void 0;
        this.nonce = void 0;
        this.feeCalculator = void 0;
        this.authorizedPubkey = args.authorizedPubkey;
        this.nonce = args.nonce;
        this.feeCalculator = args.feeCalculator;
    }
    /**
   * Deserialize NonceAccount from the account data.
   *
   * @param buffer account data
   * @return NonceAccount
   */ static fromAccountData(buffer) {
        const nonceAccount = $c3af9e523501759a$var$NonceAccountLayout.decode($c3af9e523501759a$var$toBuffer(buffer), 0);
        return new $c3af9e523501759a$export$ed1c2356ce604759({
            authorizedPubkey: new $c3af9e523501759a$export$ca8b6604d6ce14de(nonceAccount.authorizedPubkey),
            nonce: new $c3af9e523501759a$export$ca8b6604d6ce14de(nonceAccount.nonce).toString(),
            feeCalculator: nonceAccount.feeCalculator
        });
    }
}
const $c3af9e523501759a$var$encodeDecode = (layout)=>{
    const decode = layout.decode.bind(layout);
    const encode = layout.encode.bind(layout);
    return {
        decode: decode,
        encode: encode
    };
};
const $c3af9e523501759a$var$bigInt = (length)=>(property)=>{
        const layout = (0, $Q02IV.blob)(length, property);
        const { encode: encode, decode: decode } = $c3af9e523501759a$var$encodeDecode(layout);
        const bigIntLayout = layout;
        bigIntLayout.decode = (buffer, offset)=>{
            const src = decode(buffer, offset);
            return (0, $gyRuj.toBigIntLE)((0, $6ZWSX.Buffer).from(src));
        };
        bigIntLayout.encode = (bigInt, buffer, offset)=>{
            const src = (0, $gyRuj.toBufferLE)(bigInt, length);
            return encode(src, buffer, offset);
        };
        return bigIntLayout;
    };
const $c3af9e523501759a$var$u64 = $c3af9e523501759a$var$bigInt(8);
/**
 * Create account system transaction params
 */ /**
 * Transfer system transaction params
 */ /**
 * Assign system transaction params
 */ /**
 * Create account with seed system transaction params
 */ /**
 * Create nonce account system transaction params
 */ /**
 * Create nonce account with seed system transaction params
 */ /**
 * Initialize nonce account system instruction params
 */ /**
 * Advance nonce account system instruction params
 */ /**
 * Withdraw nonce account system transaction params
 */ /**
 * Authorize nonce account system transaction params
 */ /**
 * Allocate account system transaction params
 */ /**
 * Allocate account with seed system transaction params
 */ /**
 * Assign account with seed system transaction params
 */ /**
 * Transfer with seed system transaction params
 */ /** Decoded transfer system transaction instruction */ /** Decoded transferWithSeed system transaction instruction */ /**
 * System Instruction class
 */ class $c3af9e523501759a$export$f009802131fa3d06 {
    /**
   * @internal
   */ constructor(){}
    /**
   * Decode a system instruction and retrieve the instruction type.
   */ static decodeInstructionType(instruction) {
        this.checkProgramId(instruction.programId);
        const instructionTypeLayout = $Q02IV.u32("instruction");
        const typeIndex = instructionTypeLayout.decode(instruction.data);
        let type;
        for (const [ixType, layout] of Object.entries($c3af9e523501759a$export$74bdf41d8d1e7108))if (layout.index == typeIndex) {
            type = ixType;
            break;
        }
        if (!type) throw new Error("Instruction type incorrect; not a SystemInstruction");
        return type;
    }
    /**
   * Decode a create account system instruction and retrieve the instruction params.
   */ static decodeCreateAccount(instruction) {
        this.checkProgramId(instruction.programId);
        this.checkKeyLength(instruction.keys, 2);
        const { lamports: lamports, space: space, programId: programId } = $c3af9e523501759a$var$decodeData$1($c3af9e523501759a$export$74bdf41d8d1e7108.Create, instruction.data);
        return {
            fromPubkey: instruction.keys[0].pubkey,
            newAccountPubkey: instruction.keys[1].pubkey,
            lamports: lamports,
            space: space,
            programId: new $c3af9e523501759a$export$ca8b6604d6ce14de(programId)
        };
    }
    /**
   * Decode a transfer system instruction and retrieve the instruction params.
   */ static decodeTransfer(instruction) {
        this.checkProgramId(instruction.programId);
        this.checkKeyLength(instruction.keys, 2);
        const { lamports: lamports } = $c3af9e523501759a$var$decodeData$1($c3af9e523501759a$export$74bdf41d8d1e7108.Transfer, instruction.data);
        return {
            fromPubkey: instruction.keys[0].pubkey,
            toPubkey: instruction.keys[1].pubkey,
            lamports: lamports
        };
    }
    /**
   * Decode a transfer with seed system instruction and retrieve the instruction params.
   */ static decodeTransferWithSeed(instruction) {
        this.checkProgramId(instruction.programId);
        this.checkKeyLength(instruction.keys, 3);
        const { lamports: lamports, seed: seed, programId: programId } = $c3af9e523501759a$var$decodeData$1($c3af9e523501759a$export$74bdf41d8d1e7108.TransferWithSeed, instruction.data);
        return {
            fromPubkey: instruction.keys[0].pubkey,
            basePubkey: instruction.keys[1].pubkey,
            toPubkey: instruction.keys[2].pubkey,
            lamports: lamports,
            seed: seed,
            programId: new $c3af9e523501759a$export$ca8b6604d6ce14de(programId)
        };
    }
    /**
   * Decode an allocate system instruction and retrieve the instruction params.
   */ static decodeAllocate(instruction) {
        this.checkProgramId(instruction.programId);
        this.checkKeyLength(instruction.keys, 1);
        const { space: space } = $c3af9e523501759a$var$decodeData$1($c3af9e523501759a$export$74bdf41d8d1e7108.Allocate, instruction.data);
        return {
            accountPubkey: instruction.keys[0].pubkey,
            space: space
        };
    }
    /**
   * Decode an allocate with seed system instruction and retrieve the instruction params.
   */ static decodeAllocateWithSeed(instruction) {
        this.checkProgramId(instruction.programId);
        this.checkKeyLength(instruction.keys, 1);
        const { base: base, seed: seed, space: space, programId: programId } = $c3af9e523501759a$var$decodeData$1($c3af9e523501759a$export$74bdf41d8d1e7108.AllocateWithSeed, instruction.data);
        return {
            accountPubkey: instruction.keys[0].pubkey,
            basePubkey: new $c3af9e523501759a$export$ca8b6604d6ce14de(base),
            seed: seed,
            space: space,
            programId: new $c3af9e523501759a$export$ca8b6604d6ce14de(programId)
        };
    }
    /**
   * Decode an assign system instruction and retrieve the instruction params.
   */ static decodeAssign(instruction) {
        this.checkProgramId(instruction.programId);
        this.checkKeyLength(instruction.keys, 1);
        const { programId: programId } = $c3af9e523501759a$var$decodeData$1($c3af9e523501759a$export$74bdf41d8d1e7108.Assign, instruction.data);
        return {
            accountPubkey: instruction.keys[0].pubkey,
            programId: new $c3af9e523501759a$export$ca8b6604d6ce14de(programId)
        };
    }
    /**
   * Decode an assign with seed system instruction and retrieve the instruction params.
   */ static decodeAssignWithSeed(instruction) {
        this.checkProgramId(instruction.programId);
        this.checkKeyLength(instruction.keys, 1);
        const { base: base, seed: seed, programId: programId } = $c3af9e523501759a$var$decodeData$1($c3af9e523501759a$export$74bdf41d8d1e7108.AssignWithSeed, instruction.data);
        return {
            accountPubkey: instruction.keys[0].pubkey,
            basePubkey: new $c3af9e523501759a$export$ca8b6604d6ce14de(base),
            seed: seed,
            programId: new $c3af9e523501759a$export$ca8b6604d6ce14de(programId)
        };
    }
    /**
   * Decode a create account with seed system instruction and retrieve the instruction params.
   */ static decodeCreateWithSeed(instruction) {
        this.checkProgramId(instruction.programId);
        this.checkKeyLength(instruction.keys, 2);
        const { base: base, seed: seed, lamports: lamports, space: space, programId: programId } = $c3af9e523501759a$var$decodeData$1($c3af9e523501759a$export$74bdf41d8d1e7108.CreateWithSeed, instruction.data);
        return {
            fromPubkey: instruction.keys[0].pubkey,
            newAccountPubkey: instruction.keys[1].pubkey,
            basePubkey: new $c3af9e523501759a$export$ca8b6604d6ce14de(base),
            seed: seed,
            lamports: lamports,
            space: space,
            programId: new $c3af9e523501759a$export$ca8b6604d6ce14de(programId)
        };
    }
    /**
   * Decode a nonce initialize system instruction and retrieve the instruction params.
   */ static decodeNonceInitialize(instruction) {
        this.checkProgramId(instruction.programId);
        this.checkKeyLength(instruction.keys, 3);
        const { authorized: authorized } = $c3af9e523501759a$var$decodeData$1($c3af9e523501759a$export$74bdf41d8d1e7108.InitializeNonceAccount, instruction.data);
        return {
            noncePubkey: instruction.keys[0].pubkey,
            authorizedPubkey: new $c3af9e523501759a$export$ca8b6604d6ce14de(authorized)
        };
    }
    /**
   * Decode a nonce advance system instruction and retrieve the instruction params.
   */ static decodeNonceAdvance(instruction) {
        this.checkProgramId(instruction.programId);
        this.checkKeyLength(instruction.keys, 3);
        $c3af9e523501759a$var$decodeData$1($c3af9e523501759a$export$74bdf41d8d1e7108.AdvanceNonceAccount, instruction.data);
        return {
            noncePubkey: instruction.keys[0].pubkey,
            authorizedPubkey: instruction.keys[2].pubkey
        };
    }
    /**
   * Decode a nonce withdraw system instruction and retrieve the instruction params.
   */ static decodeNonceWithdraw(instruction) {
        this.checkProgramId(instruction.programId);
        this.checkKeyLength(instruction.keys, 5);
        const { lamports: lamports } = $c3af9e523501759a$var$decodeData$1($c3af9e523501759a$export$74bdf41d8d1e7108.WithdrawNonceAccount, instruction.data);
        return {
            noncePubkey: instruction.keys[0].pubkey,
            toPubkey: instruction.keys[1].pubkey,
            authorizedPubkey: instruction.keys[4].pubkey,
            lamports: lamports
        };
    }
    /**
   * Decode a nonce authorize system instruction and retrieve the instruction params.
   */ static decodeNonceAuthorize(instruction) {
        this.checkProgramId(instruction.programId);
        this.checkKeyLength(instruction.keys, 2);
        const { authorized: authorized } = $c3af9e523501759a$var$decodeData$1($c3af9e523501759a$export$74bdf41d8d1e7108.AuthorizeNonceAccount, instruction.data);
        return {
            noncePubkey: instruction.keys[0].pubkey,
            authorizedPubkey: instruction.keys[1].pubkey,
            newAuthorizedPubkey: new $c3af9e523501759a$export$ca8b6604d6ce14de(authorized)
        };
    }
    /**
   * @internal
   */ static checkProgramId(programId) {
        if (!programId.equals($c3af9e523501759a$export$d8c4e17726848113.programId)) throw new Error("invalid instruction; programId is not SystemProgram");
    }
    /**
   * @internal
   */ static checkKeyLength(keys, expectedLength) {
        if (keys.length < expectedLength) throw new Error(`invalid instruction; found ${keys.length} keys, expected at least ${expectedLength}`);
    }
}
/**
 * An enumeration of valid SystemInstructionType's
 */ /**
 * An enumeration of valid system InstructionType's
 * @internal
 */ const $c3af9e523501759a$export$74bdf41d8d1e7108 = Object.freeze({
    Create: {
        index: 0,
        layout: $Q02IV.struct([
            $Q02IV.u32("instruction"),
            $Q02IV.ns64("lamports"),
            $Q02IV.ns64("space"),
            $c3af9e523501759a$var$publicKey("programId")
        ])
    },
    Assign: {
        index: 1,
        layout: $Q02IV.struct([
            $Q02IV.u32("instruction"),
            $c3af9e523501759a$var$publicKey("programId")
        ])
    },
    Transfer: {
        index: 2,
        layout: $Q02IV.struct([
            $Q02IV.u32("instruction"),
            $c3af9e523501759a$var$u64("lamports")
        ])
    },
    CreateWithSeed: {
        index: 3,
        layout: $Q02IV.struct([
            $Q02IV.u32("instruction"),
            $c3af9e523501759a$var$publicKey("base"),
            $c3af9e523501759a$var$rustString("seed"),
            $Q02IV.ns64("lamports"),
            $Q02IV.ns64("space"),
            $c3af9e523501759a$var$publicKey("programId")
        ])
    },
    AdvanceNonceAccount: {
        index: 4,
        layout: $Q02IV.struct([
            $Q02IV.u32("instruction")
        ])
    },
    WithdrawNonceAccount: {
        index: 5,
        layout: $Q02IV.struct([
            $Q02IV.u32("instruction"),
            $Q02IV.ns64("lamports")
        ])
    },
    InitializeNonceAccount: {
        index: 6,
        layout: $Q02IV.struct([
            $Q02IV.u32("instruction"),
            $c3af9e523501759a$var$publicKey("authorized")
        ])
    },
    AuthorizeNonceAccount: {
        index: 7,
        layout: $Q02IV.struct([
            $Q02IV.u32("instruction"),
            $c3af9e523501759a$var$publicKey("authorized")
        ])
    },
    Allocate: {
        index: 8,
        layout: $Q02IV.struct([
            $Q02IV.u32("instruction"),
            $Q02IV.ns64("space")
        ])
    },
    AllocateWithSeed: {
        index: 9,
        layout: $Q02IV.struct([
            $Q02IV.u32("instruction"),
            $c3af9e523501759a$var$publicKey("base"),
            $c3af9e523501759a$var$rustString("seed"),
            $Q02IV.ns64("space"),
            $c3af9e523501759a$var$publicKey("programId")
        ])
    },
    AssignWithSeed: {
        index: 10,
        layout: $Q02IV.struct([
            $Q02IV.u32("instruction"),
            $c3af9e523501759a$var$publicKey("base"),
            $c3af9e523501759a$var$rustString("seed"),
            $c3af9e523501759a$var$publicKey("programId")
        ])
    },
    TransferWithSeed: {
        index: 11,
        layout: $Q02IV.struct([
            $Q02IV.u32("instruction"),
            $c3af9e523501759a$var$u64("lamports"),
            $c3af9e523501759a$var$rustString("seed"),
            $c3af9e523501759a$var$publicKey("programId")
        ])
    },
    UpgradeNonceAccount: {
        index: 12,
        layout: $Q02IV.struct([
            $Q02IV.u32("instruction")
        ])
    }
});
/**
 * Factory class for transactions to interact with the System program
 */ class $c3af9e523501759a$export$d8c4e17726848113 {
    /**
   * @internal
   */ constructor(){}
    /**
   * Public key that identifies the System program
   */ /**
   * Generate a transaction instruction that creates a new account
   */ static createAccount(params) {
        const type = $c3af9e523501759a$export$74bdf41d8d1e7108.Create;
        const data = $c3af9e523501759a$var$encodeData(type, {
            lamports: params.lamports,
            space: params.space,
            programId: $c3af9e523501759a$var$toBuffer(params.programId.toBuffer())
        });
        return new $c3af9e523501759a$export$a7a3aa8360ac9f59({
            keys: [
                {
                    pubkey: params.fromPubkey,
                    isSigner: true,
                    isWritable: true
                },
                {
                    pubkey: params.newAccountPubkey,
                    isSigner: true,
                    isWritable: true
                }
            ],
            programId: this.programId,
            data: data
        });
    }
    /**
   * Generate a transaction instruction that transfers lamports from one account to another
   */ static transfer(params) {
        let data;
        let keys;
        if ("basePubkey" in params) {
            const type = $c3af9e523501759a$export$74bdf41d8d1e7108.TransferWithSeed;
            data = $c3af9e523501759a$var$encodeData(type, {
                lamports: BigInt(params.lamports),
                seed: params.seed,
                programId: $c3af9e523501759a$var$toBuffer(params.programId.toBuffer())
            });
            keys = [
                {
                    pubkey: params.fromPubkey,
                    isSigner: false,
                    isWritable: true
                },
                {
                    pubkey: params.basePubkey,
                    isSigner: true,
                    isWritable: false
                },
                {
                    pubkey: params.toPubkey,
                    isSigner: false,
                    isWritable: true
                }
            ];
        } else {
            const type = $c3af9e523501759a$export$74bdf41d8d1e7108.Transfer;
            data = $c3af9e523501759a$var$encodeData(type, {
                lamports: BigInt(params.lamports)
            });
            keys = [
                {
                    pubkey: params.fromPubkey,
                    isSigner: true,
                    isWritable: true
                },
                {
                    pubkey: params.toPubkey,
                    isSigner: false,
                    isWritable: true
                }
            ];
        }
        return new $c3af9e523501759a$export$a7a3aa8360ac9f59({
            keys: keys,
            programId: this.programId,
            data: data
        });
    }
    /**
   * Generate a transaction instruction that assigns an account to a program
   */ static assign(params) {
        let data;
        let keys;
        if ("basePubkey" in params) {
            const type = $c3af9e523501759a$export$74bdf41d8d1e7108.AssignWithSeed;
            data = $c3af9e523501759a$var$encodeData(type, {
                base: $c3af9e523501759a$var$toBuffer(params.basePubkey.toBuffer()),
                seed: params.seed,
                programId: $c3af9e523501759a$var$toBuffer(params.programId.toBuffer())
            });
            keys = [
                {
                    pubkey: params.accountPubkey,
                    isSigner: false,
                    isWritable: true
                },
                {
                    pubkey: params.basePubkey,
                    isSigner: true,
                    isWritable: false
                }
            ];
        } else {
            const type = $c3af9e523501759a$export$74bdf41d8d1e7108.Assign;
            data = $c3af9e523501759a$var$encodeData(type, {
                programId: $c3af9e523501759a$var$toBuffer(params.programId.toBuffer())
            });
            keys = [
                {
                    pubkey: params.accountPubkey,
                    isSigner: true,
                    isWritable: true
                }
            ];
        }
        return new $c3af9e523501759a$export$a7a3aa8360ac9f59({
            keys: keys,
            programId: this.programId,
            data: data
        });
    }
    /**
   * Generate a transaction instruction that creates a new account at
   *   an address generated with `from`, a seed, and programId
   */ static createAccountWithSeed(params) {
        const type = $c3af9e523501759a$export$74bdf41d8d1e7108.CreateWithSeed;
        const data = $c3af9e523501759a$var$encodeData(type, {
            base: $c3af9e523501759a$var$toBuffer(params.basePubkey.toBuffer()),
            seed: params.seed,
            lamports: params.lamports,
            space: params.space,
            programId: $c3af9e523501759a$var$toBuffer(params.programId.toBuffer())
        });
        let keys = [
            {
                pubkey: params.fromPubkey,
                isSigner: true,
                isWritable: true
            },
            {
                pubkey: params.newAccountPubkey,
                isSigner: false,
                isWritable: true
            }
        ];
        if (params.basePubkey != params.fromPubkey) keys.push({
            pubkey: params.basePubkey,
            isSigner: true,
            isWritable: false
        });
        return new $c3af9e523501759a$export$a7a3aa8360ac9f59({
            keys: keys,
            programId: this.programId,
            data: data
        });
    }
    /**
   * Generate a transaction that creates a new Nonce account
   */ static createNonceAccount(params) {
        const transaction = new $c3af9e523501759a$export$febc5573c75cefb0();
        if ("basePubkey" in params && "seed" in params) transaction.add($c3af9e523501759a$export$d8c4e17726848113.createAccountWithSeed({
            fromPubkey: params.fromPubkey,
            newAccountPubkey: params.noncePubkey,
            basePubkey: params.basePubkey,
            seed: params.seed,
            lamports: params.lamports,
            space: $c3af9e523501759a$export$7126250b6d8bd94a,
            programId: this.programId
        }));
        else transaction.add($c3af9e523501759a$export$d8c4e17726848113.createAccount({
            fromPubkey: params.fromPubkey,
            newAccountPubkey: params.noncePubkey,
            lamports: params.lamports,
            space: $c3af9e523501759a$export$7126250b6d8bd94a,
            programId: this.programId
        }));
        const initParams = {
            noncePubkey: params.noncePubkey,
            authorizedPubkey: params.authorizedPubkey
        };
        transaction.add(this.nonceInitialize(initParams));
        return transaction;
    }
    /**
   * Generate an instruction to initialize a Nonce account
   */ static nonceInitialize(params) {
        const type = $c3af9e523501759a$export$74bdf41d8d1e7108.InitializeNonceAccount;
        const data = $c3af9e523501759a$var$encodeData(type, {
            authorized: $c3af9e523501759a$var$toBuffer(params.authorizedPubkey.toBuffer())
        });
        const instructionData = {
            keys: [
                {
                    pubkey: params.noncePubkey,
                    isSigner: false,
                    isWritable: true
                },
                {
                    pubkey: $c3af9e523501759a$export$e74201139e9833db,
                    isSigner: false,
                    isWritable: false
                },
                {
                    pubkey: $c3af9e523501759a$export$970d0190cdb3a8e9,
                    isSigner: false,
                    isWritable: false
                }
            ],
            programId: this.programId,
            data: data
        };
        return new $c3af9e523501759a$export$a7a3aa8360ac9f59(instructionData);
    }
    /**
   * Generate an instruction to advance the nonce in a Nonce account
   */ static nonceAdvance(params) {
        const type = $c3af9e523501759a$export$74bdf41d8d1e7108.AdvanceNonceAccount;
        const data = $c3af9e523501759a$var$encodeData(type);
        const instructionData = {
            keys: [
                {
                    pubkey: params.noncePubkey,
                    isSigner: false,
                    isWritable: true
                },
                {
                    pubkey: $c3af9e523501759a$export$e74201139e9833db,
                    isSigner: false,
                    isWritable: false
                },
                {
                    pubkey: params.authorizedPubkey,
                    isSigner: true,
                    isWritable: false
                }
            ],
            programId: this.programId,
            data: data
        };
        return new $c3af9e523501759a$export$a7a3aa8360ac9f59(instructionData);
    }
    /**
   * Generate a transaction instruction that withdraws lamports from a Nonce account
   */ static nonceWithdraw(params) {
        const type = $c3af9e523501759a$export$74bdf41d8d1e7108.WithdrawNonceAccount;
        const data = $c3af9e523501759a$var$encodeData(type, {
            lamports: params.lamports
        });
        return new $c3af9e523501759a$export$a7a3aa8360ac9f59({
            keys: [
                {
                    pubkey: params.noncePubkey,
                    isSigner: false,
                    isWritable: true
                },
                {
                    pubkey: params.toPubkey,
                    isSigner: false,
                    isWritable: true
                },
                {
                    pubkey: $c3af9e523501759a$export$e74201139e9833db,
                    isSigner: false,
                    isWritable: false
                },
                {
                    pubkey: $c3af9e523501759a$export$970d0190cdb3a8e9,
                    isSigner: false,
                    isWritable: false
                },
                {
                    pubkey: params.authorizedPubkey,
                    isSigner: true,
                    isWritable: false
                }
            ],
            programId: this.programId,
            data: data
        });
    }
    /**
   * Generate a transaction instruction that authorizes a new PublicKey as the authority
   * on a Nonce account.
   */ static nonceAuthorize(params) {
        const type = $c3af9e523501759a$export$74bdf41d8d1e7108.AuthorizeNonceAccount;
        const data = $c3af9e523501759a$var$encodeData(type, {
            authorized: $c3af9e523501759a$var$toBuffer(params.newAuthorizedPubkey.toBuffer())
        });
        return new $c3af9e523501759a$export$a7a3aa8360ac9f59({
            keys: [
                {
                    pubkey: params.noncePubkey,
                    isSigner: false,
                    isWritable: true
                },
                {
                    pubkey: params.authorizedPubkey,
                    isSigner: true,
                    isWritable: false
                }
            ],
            programId: this.programId,
            data: data
        });
    }
    /**
   * Generate a transaction instruction that allocates space in an account without funding
   */ static allocate(params) {
        let data;
        let keys;
        if ("basePubkey" in params) {
            const type = $c3af9e523501759a$export$74bdf41d8d1e7108.AllocateWithSeed;
            data = $c3af9e523501759a$var$encodeData(type, {
                base: $c3af9e523501759a$var$toBuffer(params.basePubkey.toBuffer()),
                seed: params.seed,
                space: params.space,
                programId: $c3af9e523501759a$var$toBuffer(params.programId.toBuffer())
            });
            keys = [
                {
                    pubkey: params.accountPubkey,
                    isSigner: false,
                    isWritable: true
                },
                {
                    pubkey: params.basePubkey,
                    isSigner: true,
                    isWritable: false
                }
            ];
        } else {
            const type = $c3af9e523501759a$export$74bdf41d8d1e7108.Allocate;
            data = $c3af9e523501759a$var$encodeData(type, {
                space: params.space
            });
            keys = [
                {
                    pubkey: params.accountPubkey,
                    isSigner: true,
                    isWritable: true
                }
            ];
        }
        return new $c3af9e523501759a$export$a7a3aa8360ac9f59({
            keys: keys,
            programId: this.programId,
            data: data
        });
    }
}
$c3af9e523501759a$export$d8c4e17726848113.programId = new $c3af9e523501759a$export$ca8b6604d6ce14de("11111111111111111111111111111111");
// Keep program chunks under PACKET_DATA_SIZE, leaving enough room for the
// rest of the Transaction fields
//
// TODO: replace 300 with a proper constant for the size of the other
// Transaction fields
const $c3af9e523501759a$var$CHUNK_SIZE = $c3af9e523501759a$export$4c6d5b89e1596f26 - 300;
/**
 * Program loader interface
 */ class $c3af9e523501759a$export$3b0d6d7590275603 {
    /**
   * @internal
   */ constructor(){}
    /**
   * Amount of program data placed in each load Transaction
   */ /**
   * Minimum number of signatures required to load a program not including
   * retries
   *
   * Can be used to calculate transaction fees
   */ static getMinNumSignatures(dataLength) {
        return 2 * // Every transaction requires two signatures (payer + program)
        (Math.ceil(dataLength / $c3af9e523501759a$export$3b0d6d7590275603.chunkSize) + 1 + // Add one for Create transaction
        1 // Add one for Finalize transaction
        );
    }
    /**
   * Loads a generic program
   *
   * @param connection The connection to use
   * @param payer System account that pays to load the program
   * @param program Account to load the program into
   * @param programId Public key that identifies the loader
   * @param data Program octets
   * @return true if program was loaded successfully, false if program was already loaded
   */ static async load(connection, payer, program, programId, data) {
        {
            const balanceNeeded = await connection.getMinimumBalanceForRentExemption(data.length);
            // Fetch program account info to check if it has already been created
            const programInfo = await connection.getAccountInfo(program.publicKey, "confirmed");
            let transaction = null;
            if (programInfo !== null) {
                if (programInfo.executable) {
                    console.error("Program load failed, account is already executable");
                    return false;
                }
                if (programInfo.data.length !== data.length) {
                    transaction = transaction || new $c3af9e523501759a$export$febc5573c75cefb0();
                    transaction.add($c3af9e523501759a$export$d8c4e17726848113.allocate({
                        accountPubkey: program.publicKey,
                        space: data.length
                    }));
                }
                if (!programInfo.owner.equals(programId)) {
                    transaction = transaction || new $c3af9e523501759a$export$febc5573c75cefb0();
                    transaction.add($c3af9e523501759a$export$d8c4e17726848113.assign({
                        accountPubkey: program.publicKey,
                        programId: programId
                    }));
                }
                if (programInfo.lamports < balanceNeeded) {
                    transaction = transaction || new $c3af9e523501759a$export$febc5573c75cefb0();
                    transaction.add($c3af9e523501759a$export$d8c4e17726848113.transfer({
                        fromPubkey: payer.publicKey,
                        toPubkey: program.publicKey,
                        lamports: balanceNeeded - programInfo.lamports
                    }));
                }
            } else transaction = new $c3af9e523501759a$export$febc5573c75cefb0().add($c3af9e523501759a$export$d8c4e17726848113.createAccount({
                fromPubkey: payer.publicKey,
                newAccountPubkey: program.publicKey,
                lamports: balanceNeeded > 0 ? balanceNeeded : 1,
                space: data.length,
                programId: programId
            }));
            // If the account is already created correctly, skip this step
            // and proceed directly to loading instructions
            if (transaction !== null) await $c3af9e523501759a$export$4ad6fe6dae0b6bc3(connection, transaction, [
                payer,
                program
            ], {
                commitment: "confirmed"
            });
        }
        const dataLayout = $Q02IV.struct([
            $Q02IV.u32("instruction"),
            $Q02IV.u32("offset"),
            $Q02IV.u32("bytesLength"),
            $Q02IV.u32("bytesLengthPadding"),
            $Q02IV.seq($Q02IV.u8("byte"), $Q02IV.offset($Q02IV.u32(), -8), "bytes")
        ]);
        const chunkSize = $c3af9e523501759a$export$3b0d6d7590275603.chunkSize;
        let offset = 0;
        let array = data;
        let transactions = [];
        while(array.length > 0){
            const bytes = array.slice(0, chunkSize);
            const data = (0, $6ZWSX.Buffer).alloc(chunkSize + 16);
            dataLayout.encode({
                instruction: 0,
                offset: // Load instruction
                offset,
                bytes: bytes,
                bytesLength: 0,
                bytesLengthPadding: 0
            }, data);
            const transaction = new $c3af9e523501759a$export$febc5573c75cefb0().add({
                keys: [
                    {
                        pubkey: program.publicKey,
                        isSigner: true,
                        isWritable: true
                    }
                ],
                programId: programId,
                data: data
            });
            transactions.push($c3af9e523501759a$export$4ad6fe6dae0b6bc3(connection, transaction, [
                payer,
                program
            ], {
                commitment: "confirmed"
            }));
            // Delay between sends in an attempt to reduce rate limit errors
            if (connection._rpcEndpoint.includes("solana.com")) {
                const REQUESTS_PER_SECOND = 4;
                await $c3af9e523501759a$var$sleep(1000 / REQUESTS_PER_SECOND);
            }
            offset += chunkSize;
            array = array.slice(chunkSize);
        }
        await Promise.all(transactions);
        // Finalize the account loaded with program data for execution
        {
            const dataLayout = $Q02IV.struct([
                $Q02IV.u32("instruction")
            ]);
            const data = (0, $6ZWSX.Buffer).alloc(dataLayout.span);
            dataLayout.encode({
                instruction: 1 // Finalize instruction
            }, data);
            const transaction = new $c3af9e523501759a$export$febc5573c75cefb0().add({
                keys: [
                    {
                        pubkey: program.publicKey,
                        isSigner: true,
                        isWritable: true
                    },
                    {
                        pubkey: $c3af9e523501759a$export$970d0190cdb3a8e9,
                        isSigner: false,
                        isWritable: false
                    }
                ],
                programId: programId,
                data: data
            });
            const deployCommitment = "processed";
            const finalizeSignature = await connection.sendTransaction(transaction, [
                payer,
                program
            ], {
                preflightCommitment: deployCommitment
            });
            const { context: context, value: value } = await connection.confirmTransaction({
                signature: finalizeSignature,
                lastValidBlockHeight: transaction.lastValidBlockHeight,
                blockhash: transaction.recentBlockhash
            }, deployCommitment);
            if (value.err) throw new Error(`Transaction ${finalizeSignature} failed (${JSON.stringify(value)})`);
            // We prevent programs from being usable until the slot after their deployment.
            // See https://github.com/solana-labs/solana/pull/29654
            while(true // eslint-disable-line no-constant-condition
            ){
                try {
                    const currentSlot = await connection.getSlot({
                        commitment: deployCommitment
                    });
                    if (currentSlot > context.slot) break;
                } catch  {
                /* empty */ }
                await new Promise((resolve)=>setTimeout(resolve, Math.round($c3af9e523501759a$var$MS_PER_SLOT / 2)));
            }
        }
        // success
        return true;
    }
}
$c3af9e523501759a$export$3b0d6d7590275603.chunkSize = $c3af9e523501759a$var$CHUNK_SIZE;
const $c3af9e523501759a$export$59833422f998b937 = new $c3af9e523501759a$export$ca8b6604d6ce14de("BPFLoader2111111111111111111111111111111111");
/**
 * Factory class for transactions to interact with a program loader
 */ class $c3af9e523501759a$export$493be68e6a240d3b {
    /**
   * Minimum number of signatures required to load a program not including
   * retries
   *
   * Can be used to calculate transaction fees
   */ static getMinNumSignatures(dataLength) {
        return $c3af9e523501759a$export$3b0d6d7590275603.getMinNumSignatures(dataLength);
    }
    /**
   * Load a SBF program
   *
   * @param connection The connection to use
   * @param payer Account that will pay program loading fees
   * @param program Account to load the program into
   * @param elf The entire ELF containing the SBF program
   * @param loaderProgramId The program id of the BPF loader to use
   * @return true if program was loaded successfully, false if program was already loaded
   */ static load(connection, payer, program, elf, loaderProgramId) {
        return $c3af9e523501759a$export$3b0d6d7590275603.load(connection, payer, program, loaderProgramId, elf);
    }
}
function $c3af9e523501759a$var$getDefaultExportFromCjs(x) {
    return x && x.__esModule && Object.prototype.hasOwnProperty.call(x, "default") ? x["default"] : x;
}
var $c3af9e523501759a$var$objToString = Object.prototype.toString;
var $c3af9e523501759a$var$objKeys = Object.keys || function(obj) {
    var keys = [];
    for(var name in obj)keys.push(name);
    return keys;
};
function $c3af9e523501759a$var$stringify(val, isArrayProp) {
    var i, max, str, keys, key, propVal, toStr;
    if (val === true) return "true";
    if (val === false) return "false";
    switch(typeof val){
        case "object":
            if (val === null) return null;
            else if (val.toJSON && typeof val.toJSON === "function") return $c3af9e523501759a$var$stringify(val.toJSON(), isArrayProp);
            else {
                toStr = $c3af9e523501759a$var$objToString.call(val);
                if (toStr === "[object Array]") {
                    str = "[";
                    max = val.length - 1;
                    for(i = 0; i < max; i++)str += $c3af9e523501759a$var$stringify(val[i], true) + ",";
                    if (max > -1) str += $c3af9e523501759a$var$stringify(val[i], true);
                    return str + "]";
                } else if (toStr === "[object Object]") {
                    // only object is left
                    keys = $c3af9e523501759a$var$objKeys(val).sort();
                    max = keys.length;
                    str = "";
                    i = 0;
                    while(i < max){
                        key = keys[i];
                        propVal = $c3af9e523501759a$var$stringify(val[key], false);
                        if (propVal !== undefined) {
                            if (str) str += ",";
                            str += JSON.stringify(key) + ":" + propVal;
                        }
                        i++;
                    }
                    return "{" + str + "}";
                } else return JSON.stringify(val);
            }
        case "function":
        case "undefined":
            return isArrayProp ? null : undefined;
        case "string":
            return JSON.stringify(val);
        default:
            return isFinite(val) ? val : null;
    }
}
var $c3af9e523501759a$var$fastStableStringify = function(val) {
    var returnVal = $c3af9e523501759a$var$stringify(val, false);
    if (returnVal !== undefined) return "" + returnVal;
};
var $c3af9e523501759a$var$fastStableStringify$1 = /*@__PURE__*/ $c3af9e523501759a$var$getDefaultExportFromCjs($c3af9e523501759a$var$fastStableStringify);
const $c3af9e523501759a$var$MINIMUM_SLOT_PER_EPOCH = 32;
// Returns the number of trailing zeros in the binary representation of self.
function $c3af9e523501759a$var$trailingZeros(n) {
    let trailingZeros = 0;
    while(n > 1){
        n /= 2;
        trailingZeros++;
    }
    return trailingZeros;
}
// Returns the smallest power of two greater than or equal to n
function $c3af9e523501759a$var$nextPowerOfTwo(n) {
    if (n === 0) return 1;
    n--;
    n |= n >> 1;
    n |= n >> 2;
    n |= n >> 4;
    n |= n >> 8;
    n |= n >> 16;
    n |= n >> 32;
    return n + 1;
}
/**
 * Epoch schedule
 * (see https://docs.solana.com/terminology#epoch)
 * Can be retrieved with the {@link Connection.getEpochSchedule} method
 */ class $c3af9e523501759a$export$df8ed3e830b1d591 {
    constructor(slotsPerEpoch, leaderScheduleSlotOffset, warmup, firstNormalEpoch, firstNormalSlot){
        /** The maximum number of slots in each epoch */ this.slotsPerEpoch = void 0;
        /** The number of slots before beginning of an epoch to calculate a leader schedule for that epoch */ this.leaderScheduleSlotOffset = void 0;
        /** Indicates whether epochs start short and grow */ this.warmup = void 0;
        /** The first epoch with `slotsPerEpoch` slots */ this.firstNormalEpoch = void 0;
        /** The first slot of `firstNormalEpoch` */ this.firstNormalSlot = void 0;
        this.slotsPerEpoch = slotsPerEpoch;
        this.leaderScheduleSlotOffset = leaderScheduleSlotOffset;
        this.warmup = warmup;
        this.firstNormalEpoch = firstNormalEpoch;
        this.firstNormalSlot = firstNormalSlot;
    }
    getEpoch(slot) {
        return this.getEpochAndSlotIndex(slot)[0];
    }
    getEpochAndSlotIndex(slot) {
        if (slot < this.firstNormalSlot) {
            const epoch = $c3af9e523501759a$var$trailingZeros($c3af9e523501759a$var$nextPowerOfTwo(slot + $c3af9e523501759a$var$MINIMUM_SLOT_PER_EPOCH + 1)) - $c3af9e523501759a$var$trailingZeros($c3af9e523501759a$var$MINIMUM_SLOT_PER_EPOCH) - 1;
            const epochLen = this.getSlotsInEpoch(epoch);
            const slotIndex = slot - (epochLen - $c3af9e523501759a$var$MINIMUM_SLOT_PER_EPOCH);
            return [
                epoch,
                slotIndex
            ];
        } else {
            const normalSlotIndex = slot - this.firstNormalSlot;
            const normalEpochIndex = Math.floor(normalSlotIndex / this.slotsPerEpoch);
            const epoch = this.firstNormalEpoch + normalEpochIndex;
            const slotIndex = normalSlotIndex % this.slotsPerEpoch;
            return [
                epoch,
                slotIndex
            ];
        }
    }
    getFirstSlotInEpoch(epoch) {
        if (epoch <= this.firstNormalEpoch) return (Math.pow(2, epoch) - 1) * $c3af9e523501759a$var$MINIMUM_SLOT_PER_EPOCH;
        else return (epoch - this.firstNormalEpoch) * this.slotsPerEpoch + this.firstNormalSlot;
    }
    getLastSlotInEpoch(epoch) {
        return this.getFirstSlotInEpoch(epoch) + this.getSlotsInEpoch(epoch) - 1;
    }
    getSlotsInEpoch(epoch) {
        if (epoch < this.firstNormalEpoch) return Math.pow(2, epoch + $c3af9e523501759a$var$trailingZeros($c3af9e523501759a$var$MINIMUM_SLOT_PER_EPOCH));
        else return this.slotsPerEpoch;
    }
}
class $c3af9e523501759a$export$121e803f723b3045 extends Error {
    constructor(message, logs){
        super(message);
        this.logs = void 0;
        this.logs = logs;
    }
}
// Keep in sync with client/src/rpc_custom_errors.rs
// Typescript `enums` thwart tree-shaking. See https://bargsten.org/jsts/enums/
const $c3af9e523501759a$export$e5e9869922dd22f8 = {
    JSON_RPC_SERVER_ERROR_BLOCK_CLEANED_UP: -32001,
    JSON_RPC_SERVER_ERROR_SEND_TRANSACTION_PREFLIGHT_FAILURE: -32002,
    JSON_RPC_SERVER_ERROR_TRANSACTION_SIGNATURE_VERIFICATION_FAILURE: -32003,
    JSON_RPC_SERVER_ERROR_BLOCK_NOT_AVAILABLE: -32004,
    JSON_RPC_SERVER_ERROR_NODE_UNHEALTHY: -32005,
    JSON_RPC_SERVER_ERROR_TRANSACTION_PRECOMPILE_VERIFICATION_FAILURE: -32006,
    JSON_RPC_SERVER_ERROR_SLOT_SKIPPED: -32007,
    JSON_RPC_SERVER_ERROR_NO_SNAPSHOT: -32008,
    JSON_RPC_SERVER_ERROR_LONG_TERM_STORAGE_SLOT_SKIPPED: -32009,
    JSON_RPC_SERVER_ERROR_KEY_EXCLUDED_FROM_SECONDARY_INDEX: -32010,
    JSON_RPC_SERVER_ERROR_TRANSACTION_HISTORY_NOT_AVAILABLE: -32011,
    JSON_RPC_SCAN_ERROR: -32012,
    JSON_RPC_SERVER_ERROR_TRANSACTION_SIGNATURE_LEN_MISMATCH: -32013,
    JSON_RPC_SERVER_ERROR_BLOCK_STATUS_NOT_AVAILABLE_YET: -32014,
    JSON_RPC_SERVER_ERROR_UNSUPPORTED_TRANSACTION_VERSION: -32015,
    JSON_RPC_SERVER_ERROR_MIN_CONTEXT_SLOT_NOT_REACHED: -32016
};
class $c3af9e523501759a$export$ea1b1a1bba5c14ad extends Error {
    constructor({ code: code, message: message, data: data }, customMessage){
        super(customMessage != null ? `${customMessage}: ${message}` : message);
        this.code = void 0;
        this.data = void 0;
        this.code = code;
        this.data = data;
        this.name = "SolanaJSONRPCError";
    }
}
var $c3af9e523501759a$var$fetchImpl = globalThis.fetch;
class $c3af9e523501759a$var$RpcWebSocketClient extends (0, (/*@__PURE__*/$parcel$interopDefault($9aP4M))) {
    constructor(address, options, generate_request_id){
        const webSocketFactory = (url)=>{
            const rpc = (0, (/*@__PURE__*/$parcel$interopDefault($ckEgg)))(url, {
                autoconnect: true,
                max_reconnects: 5,
                reconnect: true,
                reconnect_interval: 1000,
                ...options
            });
            if ("socket" in rpc) this.underlyingSocket = rpc.socket;
            else this.underlyingSocket = rpc;
            return rpc;
        };
        super(webSocketFactory, address, options, generate_request_id);
        this.underlyingSocket = void 0;
    }
    call(...args) {
        const readyState = this.underlyingSocket?.readyState;
        if (readyState === 1 /* WebSocket.OPEN */ ) return super.call(...args);
        return Promise.reject(new Error("Tried to call a JSON-RPC method `" + args[0] + "` but the socket was not `CONNECTING` or `OPEN` (`readyState` was " + readyState + ")"));
    }
    notify(...args) {
        const readyState = this.underlyingSocket?.readyState;
        if (readyState === 1 /* WebSocket.OPEN */ ) return super.notify(...args);
        return Promise.reject(new Error("Tried to send a JSON-RPC notification `" + args[0] + "` but the socket was not `CONNECTING` or `OPEN` (`readyState` was " + readyState + ")"));
    }
}
/**
 * @internal
 */ /**
 * Decode account data buffer using an AccountType
 * @internal
 */ function $c3af9e523501759a$var$decodeData(type, data) {
    let decoded;
    try {
        decoded = type.layout.decode(data);
    } catch (err) {
        throw new Error("invalid instruction; " + err);
    }
    if (decoded.typeIndex !== type.index) throw new Error(`invalid account data; account type mismatch ${decoded.typeIndex} != ${type.index}`);
    return decoded;
}
/// The serialized size of lookup table metadata
const $c3af9e523501759a$var$LOOKUP_TABLE_META_SIZE = 56;
class $c3af9e523501759a$export$5b2310da10e607da {
    constructor(args){
        this.key = void 0;
        this.state = void 0;
        this.key = args.key;
        this.state = args.state;
    }
    isActive() {
        const U64_MAX = BigInt("0xffffffffffffffff");
        return this.state.deactivationSlot === U64_MAX;
    }
    static deserialize(accountData) {
        const meta = $c3af9e523501759a$var$decodeData($c3af9e523501759a$var$LookupTableMetaLayout, accountData);
        const serializedAddressesLen = accountData.length - $c3af9e523501759a$var$LOOKUP_TABLE_META_SIZE;
        $c3af9e523501759a$var$assert(serializedAddressesLen >= 0, "lookup table is invalid");
        $c3af9e523501759a$var$assert(serializedAddressesLen % 32 === 0, "lookup table is invalid");
        const numSerializedAddresses = serializedAddressesLen / 32;
        const { addresses: addresses } = $Q02IV.struct([
            $Q02IV.seq($c3af9e523501759a$var$publicKey(), numSerializedAddresses, "addresses")
        ]).decode(accountData.slice($c3af9e523501759a$var$LOOKUP_TABLE_META_SIZE));
        return {
            deactivationSlot: meta.deactivationSlot,
            lastExtendedSlot: meta.lastExtendedSlot,
            lastExtendedSlotStartIndex: meta.lastExtendedStartIndex,
            authority: meta.authority.length !== 0 ? new $c3af9e523501759a$export$ca8b6604d6ce14de(meta.authority[0]) : undefined,
            addresses: addresses.map((address)=>new $c3af9e523501759a$export$ca8b6604d6ce14de(address))
        };
    }
}
const $c3af9e523501759a$var$LookupTableMetaLayout = {
    index: 1,
    layout: $Q02IV.struct([
        $Q02IV.u32("typeIndex"),
        $c3af9e523501759a$var$u64("deactivationSlot"),
        $Q02IV.nu64("lastExtendedSlot"),
        $Q02IV.u8("lastExtendedStartIndex"),
        $Q02IV.u8(),
        // option
        $Q02IV.seq($c3af9e523501759a$var$publicKey(), $Q02IV.offset($Q02IV.u8(), -1), "authority")
    ])
};
const $c3af9e523501759a$var$URL_RE = /^[^:]+:\/\/([^:[]+|\[[^\]]+\])(:\d+)?(.*)/i;
function $c3af9e523501759a$var$makeWebsocketUrl(endpoint) {
    const matches = endpoint.match($c3af9e523501759a$var$URL_RE);
    if (matches == null) throw TypeError(`Failed to validate endpoint URL \`${endpoint}\``);
    const [_, // eslint-disable-line @typescript-eslint/no-unused-vars
    hostish, portWithColon, rest] = matches;
    const protocol = endpoint.startsWith("https:") ? "wss:" : "ws:";
    const startPort = portWithColon == null ? null : parseInt(portWithColon.slice(1), 10);
    const websocketPort = // Only shift the port by +1 as a convention for ws(s) only if given endpoint
    // is explicitly specifying the endpoint port (HTTP-based RPC), assuming
    // we're directly trying to connect to solana-validator's ws listening port.
    // When the endpoint omits the port, we're connecting to the protocol
    // default ports: http(80) or https(443) and it's assumed we're behind a reverse
    // proxy which manages WebSocket upgrade and backend port redirection.
    startPort == null ? "" : `:${startPort + 1}`;
    return `${protocol}//${hostish}${websocketPort}${rest}`;
}
const $c3af9e523501759a$var$PublicKeyFromString = (0, $kZFCD.coerce)((0, $kZFCD.instance)($c3af9e523501759a$export$ca8b6604d6ce14de), (0, $kZFCD.string)(), (value)=>new $c3af9e523501759a$export$ca8b6604d6ce14de(value));
const $c3af9e523501759a$var$RawAccountDataResult = (0, $kZFCD.tuple)([
    (0, $kZFCD.string)(),
    (0, $kZFCD.literal)("base64")
]);
const $c3af9e523501759a$var$BufferFromRawAccountData = (0, $kZFCD.coerce)((0, $kZFCD.instance)((0, $6ZWSX.Buffer)), $c3af9e523501759a$var$RawAccountDataResult, (value)=>(0, $6ZWSX.Buffer).from(value[0], "base64"));
/**
 * Attempt to use a recent blockhash for up to 30 seconds
 * @internal
 */ const $c3af9e523501759a$export$fcb705732fb5c597 = 30000;
/**
 * HACK.
 * Copied from rpc-websockets/dist/lib/client.
 * Otherwise, `yarn build` fails with:
 * https://gist.github.com/steveluscher/c057eca81d479ef705cdb53162f9971d
 */ /** @internal */ /** @internal */ /** @internal */ /** @internal */ /** @internal */ /**
 * @internal
 * Every subscription contains the args used to open the subscription with
 * the server, and a list of callers interested in notifications.
 */ /**
 * @internal
 * A subscription may be in various states of connectedness. Only when it is
 * fully connected will it have a server subscription id associated with it.
 * This id can be returned to the server to unsubscribe the client entirely.
 */ /**
 * A type that encapsulates a subscription's RPC method
 * names and notification (callback) signature.
 */ /**
 * @internal
 * Utility type that keeps tagged unions intact while omitting properties.
 */ /**
 * @internal
 * This type represents a single subscribable 'topic.' It's made up of:
 *
 * - The args used to open the subscription with the server,
 * - The state of the subscription, in terms of its connectedness, and
 * - The set of callbacks to call when the server publishes notifications
 *
 * This record gets indexed by `SubscriptionConfigHash` and is used to
 * set up subscriptions, fan out notifications, and track subscription state.
 */ /**
 * @internal
 */ /**
 * Extra contextual information for RPC responses
 */ /**
 * Options for sending transactions
 */ /**
 * Options for confirming transactions
 */ /**
 * Options for getConfirmedSignaturesForAddress2
 */ /**
 * Options for getSignaturesForAddress
 */ /**
 * RPC Response with extra contextual information
 */ /**
 * A strategy for confirming transactions that uses the last valid
 * block height for a given blockhash to check for transaction expiration.
 */ /**
 * A strategy for confirming durable nonce transactions.
 */ /**
 * Properties shared by all transaction confirmation strategies
 */ /**
 * This type represents all transaction confirmation strategies
 */ /* @internal */ function $c3af9e523501759a$var$assertEndpointUrl(putativeUrl) {
    if (/^https?:/.test(putativeUrl) === false) throw new TypeError("Endpoint URL must start with `http:` or `https:`.");
    return putativeUrl;
}
/** @internal */ function $c3af9e523501759a$var$extractCommitmentFromConfig(commitmentOrConfig) {
    let commitment;
    let config;
    if (typeof commitmentOrConfig === "string") commitment = commitmentOrConfig;
    else if (commitmentOrConfig) {
        const { commitment: specifiedCommitment, ...specifiedConfig } = commitmentOrConfig;
        commitment = specifiedCommitment;
        config = specifiedConfig;
    }
    return {
        commitment: commitment,
        config: config
    };
}
/**
 * @internal
 */ function $c3af9e523501759a$var$createRpcResult(result) {
    return (0, $kZFCD.union)([
        (0, $kZFCD.type)({
            jsonrpc: (0, $kZFCD.literal)("2.0"),
            id: (0, $kZFCD.string)(),
            result: result
        }),
        (0, $kZFCD.type)({
            jsonrpc: (0, $kZFCD.literal)("2.0"),
            id: (0, $kZFCD.string)(),
            error: (0, $kZFCD.type)({
                code: (0, $kZFCD.unknown)(),
                message: (0, $kZFCD.string)(),
                data: (0, $kZFCD.optional)((0, $kZFCD.any)())
            })
        })
    ]);
}
const $c3af9e523501759a$var$UnknownRpcResult = $c3af9e523501759a$var$createRpcResult((0, $kZFCD.unknown)());
/**
 * @internal
 */ function $c3af9e523501759a$var$jsonRpcResult(schema) {
    return (0, $kZFCD.coerce)($c3af9e523501759a$var$createRpcResult(schema), $c3af9e523501759a$var$UnknownRpcResult, (value)=>{
        if ("error" in value) return value;
        else return {
            ...value,
            result: (0, $kZFCD.create)(value.result, schema)
        };
    });
}
/**
 * @internal
 */ function $c3af9e523501759a$var$jsonRpcResultAndContext(value) {
    return $c3af9e523501759a$var$jsonRpcResult((0, $kZFCD.type)({
        context: (0, $kZFCD.type)({
            slot: (0, $kZFCD.number)()
        }),
        value: value
    }));
}
/**
 * @internal
 */ function $c3af9e523501759a$var$notificationResultAndContext(value) {
    return (0, $kZFCD.type)({
        context: (0, $kZFCD.type)({
            slot: (0, $kZFCD.number)()
        }),
        value: value
    });
}
/**
 * @internal
 */ function $c3af9e523501759a$var$versionedMessageFromResponse(version, response) {
    if (version === 0) return new $c3af9e523501759a$export$ee274c70e0fae590({
        header: response.header,
        staticAccountKeys: response.accountKeys.map((accountKey)=>new $c3af9e523501759a$export$ca8b6604d6ce14de(accountKey)),
        recentBlockhash: response.recentBlockhash,
        compiledInstructions: response.instructions.map((ix)=>({
                programIdIndex: ix.programIdIndex,
                accountKeyIndexes: ix.accounts,
                data: (0, (/*@__PURE__*/$parcel$interopDefault($4UTkl))).decode(ix.data)
            })),
        addressTableLookups: response.addressTableLookups
    });
    else return new $c3af9e523501759a$export$f69c19e57285b83a(response);
}
/**
 * The level of commitment desired when querying state
 * <pre>
 *   'processed': Query the most recent block which has reached 1 confirmation by the connected node
 *   'confirmed': Query the most recent block which has reached 1 confirmation by the cluster
 *   'finalized': Query the most recent block which has been finalized by the cluster
 * </pre>
 */ // Deprecated as of v1.5.5
/**
 * A subset of Commitment levels, which are at least optimistically confirmed
 * <pre>
 *   'confirmed': Query the most recent block which has reached 1 confirmation by the cluster
 *   'finalized': Query the most recent block which has been finalized by the cluster
 * </pre>
 */ /**
 * Filter for largest accounts query
 * <pre>
 *   'circulating':    Return the largest accounts that are part of the circulating supply
 *   'nonCirculating': Return the largest accounts that are not part of the circulating supply
 * </pre>
 */ /**
 * Configuration object for changing `getAccountInfo` query behavior
 */ /**
 * Configuration object for changing `getBalance` query behavior
 */ /**
 * Configuration object for changing `getBlock` query behavior
 */ /**
 * Configuration object for changing `getBlock` query behavior
 */ /**
 * Configuration object for changing `getStakeMinimumDelegation` query behavior
 */ /**
 * Configuration object for changing `getBlockHeight` query behavior
 */ /**
 * Configuration object for changing `getEpochInfo` query behavior
 */ /**
 * Configuration object for changing `getInflationReward` query behavior
 */ /**
 * Configuration object for changing `getLatestBlockhash` query behavior
 */ /**
 * Configuration object for changing `isBlockhashValid` query behavior
 */ /**
 * Configuration object for changing `getSlot` query behavior
 */ /**
 * Configuration object for changing `getSlotLeader` query behavior
 */ /**
 * Configuration object for changing `getTransaction` query behavior
 */ /**
 * Configuration object for changing `getTransaction` query behavior
 */ /**
 * Configuration object for changing `getLargestAccounts` query behavior
 */ /**
 * Configuration object for changing `getSupply` request behavior
 */ /**
 * Configuration object for changing query behavior
 */ /**
 * Information describing a cluster node
 */ /**
 * Information describing a vote account
 */ /**
 * A collection of cluster vote accounts
 */ /**
 * Network Inflation
 * (see https://docs.solana.com/implemented-proposals/ed_overview)
 */ const $c3af9e523501759a$var$GetInflationGovernorResult = (0, $kZFCD.type)({
    foundation: (0, $kZFCD.number)(),
    foundationTerm: (0, $kZFCD.number)(),
    initial: (0, $kZFCD.number)(),
    taper: (0, $kZFCD.number)(),
    terminal: (0, $kZFCD.number)()
});
/**
 * The inflation reward for an epoch
 */ /**
 * Expected JSON RPC response for the "getInflationReward" message
 */ const $c3af9e523501759a$var$GetInflationRewardResult = $c3af9e523501759a$var$jsonRpcResult((0, $kZFCD.array)((0, $kZFCD.nullable)((0, $kZFCD.type)({
    epoch: (0, $kZFCD.number)(),
    effectiveSlot: (0, $kZFCD.number)(),
    amount: (0, $kZFCD.number)(),
    postBalance: (0, $kZFCD.number)(),
    commission: (0, $kZFCD.optional)((0, $kZFCD.nullable)((0, $kZFCD.number)()))
}))));
/**
 * Configuration object for changing `getRecentPrioritizationFees` query behavior
 */ /**
 * Expected JSON RPC response for the "getRecentPrioritizationFees" message
 */ const $c3af9e523501759a$var$GetRecentPrioritizationFeesResult = (0, $kZFCD.array)((0, $kZFCD.type)({
    slot: (0, $kZFCD.number)(),
    prioritizationFee: (0, $kZFCD.number)()
}));
/**
 * Expected JSON RPC response for the "getInflationRate" message
 */ const $c3af9e523501759a$var$GetInflationRateResult = (0, $kZFCD.type)({
    total: (0, $kZFCD.number)(),
    validator: (0, $kZFCD.number)(),
    foundation: (0, $kZFCD.number)(),
    epoch: (0, $kZFCD.number)()
});
/**
 * Information about the current epoch
 */ const $c3af9e523501759a$var$GetEpochInfoResult = (0, $kZFCD.type)({
    epoch: (0, $kZFCD.number)(),
    slotIndex: (0, $kZFCD.number)(),
    slotsInEpoch: (0, $kZFCD.number)(),
    absoluteSlot: (0, $kZFCD.number)(),
    blockHeight: (0, $kZFCD.optional)((0, $kZFCD.number)()),
    transactionCount: (0, $kZFCD.optional)((0, $kZFCD.number)())
});
const $c3af9e523501759a$var$GetEpochScheduleResult = (0, $kZFCD.type)({
    slotsPerEpoch: (0, $kZFCD.number)(),
    leaderScheduleSlotOffset: (0, $kZFCD.number)(),
    warmup: (0, $kZFCD.boolean)(),
    firstNormalEpoch: (0, $kZFCD.number)(),
    firstNormalSlot: (0, $kZFCD.number)()
});
/**
 * Leader schedule
 * (see https://docs.solana.com/terminology#leader-schedule)
 */ const $c3af9e523501759a$var$GetLeaderScheduleResult = (0, $kZFCD.record)((0, $kZFCD.string)(), (0, $kZFCD.array)((0, $kZFCD.number)()));
/**
 * Transaction error or null
 */ const $c3af9e523501759a$var$TransactionErrorResult = (0, $kZFCD.nullable)((0, $kZFCD.union)([
    (0, $kZFCD.type)({}),
    (0, $kZFCD.string)()
]));
/**
 * Signature status for a transaction
 */ const $c3af9e523501759a$var$SignatureStatusResult = (0, $kZFCD.type)({
    err: $c3af9e523501759a$var$TransactionErrorResult
});
/**
 * Transaction signature received notification
 */ const $c3af9e523501759a$var$SignatureReceivedResult = (0, $kZFCD.literal)("receivedSignature");
/**
 * Version info for a node
 */ const $c3af9e523501759a$var$VersionResult = (0, $kZFCD.type)({
    "solana-core": (0, $kZFCD.string)(),
    "feature-set": (0, $kZFCD.optional)((0, $kZFCD.number)())
});
const $c3af9e523501759a$var$SimulatedTransactionResponseStruct = $c3af9e523501759a$var$jsonRpcResultAndContext((0, $kZFCD.type)({
    err: (0, $kZFCD.nullable)((0, $kZFCD.union)([
        (0, $kZFCD.type)({}),
        (0, $kZFCD.string)()
    ])),
    logs: (0, $kZFCD.nullable)((0, $kZFCD.array)((0, $kZFCD.string)())),
    accounts: (0, $kZFCD.optional)((0, $kZFCD.nullable)((0, $kZFCD.array)((0, $kZFCD.nullable)((0, $kZFCD.type)({
        executable: (0, $kZFCD.boolean)(),
        owner: (0, $kZFCD.string)(),
        lamports: (0, $kZFCD.number)(),
        data: (0, $kZFCD.array)((0, $kZFCD.string)()),
        rentEpoch: (0, $kZFCD.optional)((0, $kZFCD.number)())
    }))))),
    unitsConsumed: (0, $kZFCD.optional)((0, $kZFCD.number)()),
    returnData: (0, $kZFCD.optional)((0, $kZFCD.nullable)((0, $kZFCD.type)({
        programId: (0, $kZFCD.string)(),
        data: (0, $kZFCD.tuple)([
            (0, $kZFCD.string)(),
            (0, $kZFCD.literal)("base64")
        ])
    })))
}));
/**
 * Metadata for a parsed confirmed transaction on the ledger
 *
 * @deprecated Deprecated since Solana v1.8.0. Please use {@link ParsedTransactionMeta} instead.
 */ /**
 * Collection of addresses loaded by a transaction using address table lookups
 */ /**
 * Metadata for a parsed transaction on the ledger
 */ /**
 * Metadata for a confirmed transaction on the ledger
 */ /**
 * A processed transaction from the RPC API
 */ /**
 * A processed transaction from the RPC API
 */ /**
 * A processed transaction message from the RPC API
 */ /**
 * A confirmed transaction on the ledger
 *
 * @deprecated Deprecated since Solana v1.8.0.
 */ /**
 * A partially decoded transaction instruction
 */ /**
 * A parsed transaction message account
 */ /**
 * A parsed transaction instruction
 */ /**
 * A parsed address table lookup
 */ /**
 * A parsed transaction message
 */ /**
 * A parsed transaction
 */ /**
 * A parsed and confirmed transaction on the ledger
 *
 * @deprecated Deprecated since Solana v1.8.0. Please use {@link ParsedTransactionWithMeta} instead.
 */ /**
 * A parsed transaction on the ledger with meta
 */ /**
 * A processed block fetched from the RPC API
 */ /**
 * A processed block fetched from the RPC API where the `transactionDetails` mode is `accounts`
 */ /**
 * A processed block fetched from the RPC API where the `transactionDetails` mode is `none`
 */ /**
 * A block with parsed transactions
 */ /**
 * A block with parsed transactions where the `transactionDetails` mode is `accounts`
 */ /**
 * A block with parsed transactions where the `transactionDetails` mode is `none`
 */ /**
 * A processed block fetched from the RPC API
 */ /**
 * A processed block fetched from the RPC API where the `transactionDetails` mode is `accounts`
 */ /**
 * A processed block fetched from the RPC API where the `transactionDetails` mode is `none`
 */ /**
 * A confirmed block on the ledger
 *
 * @deprecated Deprecated since Solana v1.8.0.
 */ /**
 * A Block on the ledger with signatures only
 */ /**
 * recent block production information
 */ /**
 * Expected JSON RPC response for the "getBlockProduction" message
 */ const $c3af9e523501759a$var$BlockProductionResponseStruct = $c3af9e523501759a$var$jsonRpcResultAndContext((0, $kZFCD.type)({
    byIdentity: (0, $kZFCD.record)((0, $kZFCD.string)(), (0, $kZFCD.array)((0, $kZFCD.number)())),
    range: (0, $kZFCD.type)({
        firstSlot: (0, $kZFCD.number)(),
        lastSlot: (0, $kZFCD.number)()
    })
}));
/**
 * A performance sample
 */ function $c3af9e523501759a$var$createRpcClient(url, httpHeaders, customFetch, fetchMiddleware, disableRetryOnRateLimit, httpAgent) {
    const fetch = customFetch ? customFetch : $c3af9e523501759a$var$fetchImpl;
    let agent;
    if (httpAgent != null) console.warn("You have supplied an `httpAgent` when creating a `Connection` in a browser environment.It has been ignored; `httpAgent` is only used in Node environments.");
    let fetchWithMiddleware;
    if (fetchMiddleware) fetchWithMiddleware = async (info, init)=>{
        const modifiedFetchArgs = await new Promise((resolve, reject)=>{
            try {
                fetchMiddleware(info, init, (modifiedInfo, modifiedInit)=>resolve([
                        modifiedInfo,
                        modifiedInit
                    ]));
            } catch (error) {
                reject(error);
            }
        });
        return await fetch(...modifiedFetchArgs);
    };
    const clientBrowser = new (0, (/*@__PURE__*/$parcel$interopDefault($7pfXJ)))(async (request, callback)=>{
        const options = {
            method: "POST",
            body: request,
            agent: agent,
            headers: Object.assign({
                "Content-Type": "application/json"
            }, httpHeaders || {}, $c3af9e523501759a$var$COMMON_HTTP_HEADERS)
        };
        try {
            let too_many_requests_retries = 5;
            let res;
            let waitTime = 500;
            for(;;){
                if (fetchWithMiddleware) res = await fetchWithMiddleware(url, options);
                else res = await fetch(url, options);
                if (res.status !== 429 /* Too many requests */ ) break;
                if (disableRetryOnRateLimit === true) break;
                too_many_requests_retries -= 1;
                if (too_many_requests_retries === 0) break;
                console.log(`Server responded with ${res.status} ${res.statusText}.  Retrying after ${waitTime}ms delay...`);
                await $c3af9e523501759a$var$sleep(waitTime);
                waitTime *= 2;
            }
            const text = await res.text();
            if (res.ok) callback(null, text);
            else callback(new Error(`${res.status} ${res.statusText}: ${text}`));
        } catch (err) {
            if (err instanceof Error) callback(err);
        }
    }, {});
    return clientBrowser;
}
function $c3af9e523501759a$var$createRpcRequest(client) {
    return (method, args)=>{
        return new Promise((resolve, reject)=>{
            client.request(method, args, (err, response)=>{
                if (err) {
                    reject(err);
                    return;
                }
                resolve(response);
            });
        });
    };
}
function $c3af9e523501759a$var$createRpcBatchRequest(client) {
    return (requests)=>{
        return new Promise((resolve, reject)=>{
            // Do nothing if requests is empty
            if (requests.length === 0) resolve([]);
            const batch = requests.map((params)=>{
                return client.request(params.methodName, params.args);
            });
            client.request(batch, (err, response)=>{
                if (err) {
                    reject(err);
                    return;
                }
                resolve(response);
            });
        });
    };
}
/**
 * Expected JSON RPC response for the "getInflationGovernor" message
 */ const $c3af9e523501759a$var$GetInflationGovernorRpcResult = $c3af9e523501759a$var$jsonRpcResult($c3af9e523501759a$var$GetInflationGovernorResult);
/**
 * Expected JSON RPC response for the "getInflationRate" message
 */ const $c3af9e523501759a$var$GetInflationRateRpcResult = $c3af9e523501759a$var$jsonRpcResult($c3af9e523501759a$var$GetInflationRateResult);
/**
 * Expected JSON RPC response for the "getRecentPrioritizationFees" message
 */ const $c3af9e523501759a$var$GetRecentPrioritizationFeesRpcResult = $c3af9e523501759a$var$jsonRpcResult($c3af9e523501759a$var$GetRecentPrioritizationFeesResult);
/**
 * Expected JSON RPC response for the "getEpochInfo" message
 */ const $c3af9e523501759a$var$GetEpochInfoRpcResult = $c3af9e523501759a$var$jsonRpcResult($c3af9e523501759a$var$GetEpochInfoResult);
/**
 * Expected JSON RPC response for the "getEpochSchedule" message
 */ const $c3af9e523501759a$var$GetEpochScheduleRpcResult = $c3af9e523501759a$var$jsonRpcResult($c3af9e523501759a$var$GetEpochScheduleResult);
/**
 * Expected JSON RPC response for the "getLeaderSchedule" message
 */ const $c3af9e523501759a$var$GetLeaderScheduleRpcResult = $c3af9e523501759a$var$jsonRpcResult($c3af9e523501759a$var$GetLeaderScheduleResult);
/**
 * Expected JSON RPC response for the "minimumLedgerSlot" and "getFirstAvailableBlock" messages
 */ const $c3af9e523501759a$var$SlotRpcResult = $c3af9e523501759a$var$jsonRpcResult((0, $kZFCD.number)());
/**
 * Supply
 */ /**
 * Expected JSON RPC response for the "getSupply" message
 */ const $c3af9e523501759a$var$GetSupplyRpcResult = $c3af9e523501759a$var$jsonRpcResultAndContext((0, $kZFCD.type)({
    total: (0, $kZFCD.number)(),
    circulating: (0, $kZFCD.number)(),
    nonCirculating: (0, $kZFCD.number)(),
    nonCirculatingAccounts: (0, $kZFCD.array)($c3af9e523501759a$var$PublicKeyFromString)
}));
/**
 * Token amount object which returns a token amount in different formats
 * for various client use cases.
 */ /**
 * Expected JSON RPC structure for token amounts
 */ const $c3af9e523501759a$var$TokenAmountResult = (0, $kZFCD.type)({
    amount: (0, $kZFCD.string)(),
    uiAmount: (0, $kZFCD.nullable)((0, $kZFCD.number)()),
    decimals: (0, $kZFCD.number)(),
    uiAmountString: (0, $kZFCD.optional)((0, $kZFCD.string)())
});
/**
 * Token address and balance.
 */ /**
 * Expected JSON RPC response for the "getTokenLargestAccounts" message
 */ const $c3af9e523501759a$var$GetTokenLargestAccountsResult = $c3af9e523501759a$var$jsonRpcResultAndContext((0, $kZFCD.array)((0, $kZFCD.type)({
    address: $c3af9e523501759a$var$PublicKeyFromString,
    amount: (0, $kZFCD.string)(),
    uiAmount: (0, $kZFCD.nullable)((0, $kZFCD.number)()),
    decimals: (0, $kZFCD.number)(),
    uiAmountString: (0, $kZFCD.optional)((0, $kZFCD.string)())
})));
/**
 * Expected JSON RPC response for the "getTokenAccountsByOwner" message
 */ const $c3af9e523501759a$var$GetTokenAccountsByOwner = $c3af9e523501759a$var$jsonRpcResultAndContext((0, $kZFCD.array)((0, $kZFCD.type)({
    pubkey: $c3af9e523501759a$var$PublicKeyFromString,
    account: (0, $kZFCD.type)({
        executable: (0, $kZFCD.boolean)(),
        owner: $c3af9e523501759a$var$PublicKeyFromString,
        lamports: (0, $kZFCD.number)(),
        data: $c3af9e523501759a$var$BufferFromRawAccountData,
        rentEpoch: (0, $kZFCD.number)()
    })
})));
const $c3af9e523501759a$var$ParsedAccountDataResult = (0, $kZFCD.type)({
    program: (0, $kZFCD.string)(),
    parsed: (0, $kZFCD.unknown)(),
    space: (0, $kZFCD.number)()
});
/**
 * Expected JSON RPC response for the "getTokenAccountsByOwner" message with parsed data
 */ const $c3af9e523501759a$var$GetParsedTokenAccountsByOwner = $c3af9e523501759a$var$jsonRpcResultAndContext((0, $kZFCD.array)((0, $kZFCD.type)({
    pubkey: $c3af9e523501759a$var$PublicKeyFromString,
    account: (0, $kZFCD.type)({
        executable: (0, $kZFCD.boolean)(),
        owner: $c3af9e523501759a$var$PublicKeyFromString,
        lamports: (0, $kZFCD.number)(),
        data: $c3af9e523501759a$var$ParsedAccountDataResult,
        rentEpoch: (0, $kZFCD.number)()
    })
})));
/**
 * Pair of an account address and its balance
 */ /**
 * Expected JSON RPC response for the "getLargestAccounts" message
 */ const $c3af9e523501759a$var$GetLargestAccountsRpcResult = $c3af9e523501759a$var$jsonRpcResultAndContext((0, $kZFCD.array)((0, $kZFCD.type)({
    lamports: (0, $kZFCD.number)(),
    address: $c3af9e523501759a$var$PublicKeyFromString
})));
/**
 * @internal
 */ const $c3af9e523501759a$var$AccountInfoResult = (0, $kZFCD.type)({
    executable: (0, $kZFCD.boolean)(),
    owner: $c3af9e523501759a$var$PublicKeyFromString,
    lamports: (0, $kZFCD.number)(),
    data: $c3af9e523501759a$var$BufferFromRawAccountData,
    rentEpoch: (0, $kZFCD.number)()
});
/**
 * @internal
 */ const $c3af9e523501759a$var$KeyedAccountInfoResult = (0, $kZFCD.type)({
    pubkey: $c3af9e523501759a$var$PublicKeyFromString,
    account: $c3af9e523501759a$var$AccountInfoResult
});
const $c3af9e523501759a$var$ParsedOrRawAccountData = (0, $kZFCD.coerce)((0, $kZFCD.union)([
    (0, $kZFCD.instance)((0, $6ZWSX.Buffer)),
    $c3af9e523501759a$var$ParsedAccountDataResult
]), (0, $kZFCD.union)([
    $c3af9e523501759a$var$RawAccountDataResult,
    $c3af9e523501759a$var$ParsedAccountDataResult
]), (value)=>{
    if (Array.isArray(value)) return (0, $kZFCD.create)(value, $c3af9e523501759a$var$BufferFromRawAccountData);
    else return value;
});
/**
 * @internal
 */ const $c3af9e523501759a$var$ParsedAccountInfoResult = (0, $kZFCD.type)({
    executable: (0, $kZFCD.boolean)(),
    owner: $c3af9e523501759a$var$PublicKeyFromString,
    lamports: (0, $kZFCD.number)(),
    data: $c3af9e523501759a$var$ParsedOrRawAccountData,
    rentEpoch: (0, $kZFCD.number)()
});
const $c3af9e523501759a$var$KeyedParsedAccountInfoResult = (0, $kZFCD.type)({
    pubkey: $c3af9e523501759a$var$PublicKeyFromString,
    account: $c3af9e523501759a$var$ParsedAccountInfoResult
});
/**
 * @internal
 */ const $c3af9e523501759a$var$StakeActivationResult = (0, $kZFCD.type)({
    state: (0, $kZFCD.union)([
        (0, $kZFCD.literal)("active"),
        (0, $kZFCD.literal)("inactive"),
        (0, $kZFCD.literal)("activating"),
        (0, $kZFCD.literal)("deactivating")
    ]),
    active: (0, $kZFCD.number)(),
    inactive: (0, $kZFCD.number)()
});
/**
 * Expected JSON RPC response for the "getConfirmedSignaturesForAddress2" message
 */ const $c3af9e523501759a$var$GetConfirmedSignaturesForAddress2RpcResult = $c3af9e523501759a$var$jsonRpcResult((0, $kZFCD.array)((0, $kZFCD.type)({
    signature: (0, $kZFCD.string)(),
    slot: (0, $kZFCD.number)(),
    err: $c3af9e523501759a$var$TransactionErrorResult,
    memo: (0, $kZFCD.nullable)((0, $kZFCD.string)()),
    blockTime: (0, $kZFCD.optional)((0, $kZFCD.nullable)((0, $kZFCD.number)()))
})));
/**
 * Expected JSON RPC response for the "getSignaturesForAddress" message
 */ const $c3af9e523501759a$var$GetSignaturesForAddressRpcResult = $c3af9e523501759a$var$jsonRpcResult((0, $kZFCD.array)((0, $kZFCD.type)({
    signature: (0, $kZFCD.string)(),
    slot: (0, $kZFCD.number)(),
    err: $c3af9e523501759a$var$TransactionErrorResult,
    memo: (0, $kZFCD.nullable)((0, $kZFCD.string)()),
    blockTime: (0, $kZFCD.optional)((0, $kZFCD.nullable)((0, $kZFCD.number)()))
})));
/***
 * Expected JSON RPC response for the "accountNotification" message
 */ const $c3af9e523501759a$var$AccountNotificationResult = (0, $kZFCD.type)({
    subscription: (0, $kZFCD.number)(),
    result: $c3af9e523501759a$var$notificationResultAndContext($c3af9e523501759a$var$AccountInfoResult)
});
/**
 * @internal
 */ const $c3af9e523501759a$var$ProgramAccountInfoResult = (0, $kZFCD.type)({
    pubkey: $c3af9e523501759a$var$PublicKeyFromString,
    account: $c3af9e523501759a$var$AccountInfoResult
});
/***
 * Expected JSON RPC response for the "programNotification" message
 */ const $c3af9e523501759a$var$ProgramAccountNotificationResult = (0, $kZFCD.type)({
    subscription: (0, $kZFCD.number)(),
    result: $c3af9e523501759a$var$notificationResultAndContext($c3af9e523501759a$var$ProgramAccountInfoResult)
});
/**
 * @internal
 */ const $c3af9e523501759a$var$SlotInfoResult = (0, $kZFCD.type)({
    parent: (0, $kZFCD.number)(),
    slot: (0, $kZFCD.number)(),
    root: (0, $kZFCD.number)()
});
/**
 * Expected JSON RPC response for the "slotNotification" message
 */ const $c3af9e523501759a$var$SlotNotificationResult = (0, $kZFCD.type)({
    subscription: (0, $kZFCD.number)(),
    result: $c3af9e523501759a$var$SlotInfoResult
});
/**
 * Slot updates which can be used for tracking the live progress of a cluster.
 * - `"firstShredReceived"`: connected node received the first shred of a block.
 * Indicates that a new block that is being produced.
 * - `"completed"`: connected node has received all shreds of a block. Indicates
 * a block was recently produced.
 * - `"optimisticConfirmation"`: block was optimistically confirmed by the
 * cluster. It is not guaranteed that an optimistic confirmation notification
 * will be sent for every finalized blocks.
 * - `"root"`: the connected node rooted this block.
 * - `"createdBank"`: the connected node has started validating this block.
 * - `"frozen"`: the connected node has validated this block.
 * - `"dead"`: the connected node failed to validate this block.
 */ /**
 * @internal
 */ const $c3af9e523501759a$var$SlotUpdateResult = (0, $kZFCD.union)([
    (0, $kZFCD.type)({
        type: (0, $kZFCD.union)([
            (0, $kZFCD.literal)("firstShredReceived"),
            (0, $kZFCD.literal)("completed"),
            (0, $kZFCD.literal)("optimisticConfirmation"),
            (0, $kZFCD.literal)("root")
        ]),
        slot: (0, $kZFCD.number)(),
        timestamp: (0, $kZFCD.number)()
    }),
    (0, $kZFCD.type)({
        type: (0, $kZFCD.literal)("createdBank"),
        parent: (0, $kZFCD.number)(),
        slot: (0, $kZFCD.number)(),
        timestamp: (0, $kZFCD.number)()
    }),
    (0, $kZFCD.type)({
        type: (0, $kZFCD.literal)("frozen"),
        slot: (0, $kZFCD.number)(),
        timestamp: (0, $kZFCD.number)(),
        stats: (0, $kZFCD.type)({
            numTransactionEntries: (0, $kZFCD.number)(),
            numSuccessfulTransactions: (0, $kZFCD.number)(),
            numFailedTransactions: (0, $kZFCD.number)(),
            maxTransactionsPerEntry: (0, $kZFCD.number)()
        })
    }),
    (0, $kZFCD.type)({
        type: (0, $kZFCD.literal)("dead"),
        slot: (0, $kZFCD.number)(),
        timestamp: (0, $kZFCD.number)(),
        err: (0, $kZFCD.string)()
    })
]);
/**
 * Expected JSON RPC response for the "slotsUpdatesNotification" message
 */ const $c3af9e523501759a$var$SlotUpdateNotificationResult = (0, $kZFCD.type)({
    subscription: (0, $kZFCD.number)(),
    result: $c3af9e523501759a$var$SlotUpdateResult
});
/**
 * Expected JSON RPC response for the "signatureNotification" message
 */ const $c3af9e523501759a$var$SignatureNotificationResult = (0, $kZFCD.type)({
    subscription: (0, $kZFCD.number)(),
    result: $c3af9e523501759a$var$notificationResultAndContext((0, $kZFCD.union)([
        $c3af9e523501759a$var$SignatureStatusResult,
        $c3af9e523501759a$var$SignatureReceivedResult
    ]))
});
/**
 * Expected JSON RPC response for the "rootNotification" message
 */ const $c3af9e523501759a$var$RootNotificationResult = (0, $kZFCD.type)({
    subscription: (0, $kZFCD.number)(),
    result: (0, $kZFCD.number)()
});
const $c3af9e523501759a$var$ContactInfoResult = (0, $kZFCD.type)({
    pubkey: (0, $kZFCD.string)(),
    gossip: (0, $kZFCD.nullable)((0, $kZFCD.string)()),
    tpu: (0, $kZFCD.nullable)((0, $kZFCD.string)()),
    rpc: (0, $kZFCD.nullable)((0, $kZFCD.string)()),
    version: (0, $kZFCD.nullable)((0, $kZFCD.string)())
});
const $c3af9e523501759a$var$VoteAccountInfoResult = (0, $kZFCD.type)({
    votePubkey: (0, $kZFCD.string)(),
    nodePubkey: (0, $kZFCD.string)(),
    activatedStake: (0, $kZFCD.number)(),
    epochVoteAccount: (0, $kZFCD.boolean)(),
    epochCredits: (0, $kZFCD.array)((0, $kZFCD.tuple)([
        (0, $kZFCD.number)(),
        (0, $kZFCD.number)(),
        (0, $kZFCD.number)()
    ])),
    commission: (0, $kZFCD.number)(),
    lastVote: (0, $kZFCD.number)(),
    rootSlot: (0, $kZFCD.nullable)((0, $kZFCD.number)())
});
/**
 * Expected JSON RPC response for the "getVoteAccounts" message
 */ const $c3af9e523501759a$var$GetVoteAccounts = $c3af9e523501759a$var$jsonRpcResult((0, $kZFCD.type)({
    current: (0, $kZFCD.array)($c3af9e523501759a$var$VoteAccountInfoResult),
    delinquent: (0, $kZFCD.array)($c3af9e523501759a$var$VoteAccountInfoResult)
}));
const $c3af9e523501759a$var$ConfirmationStatus = (0, $kZFCD.union)([
    (0, $kZFCD.literal)("processed"),
    (0, $kZFCD.literal)("confirmed"),
    (0, $kZFCD.literal)("finalized")
]);
const $c3af9e523501759a$var$SignatureStatusResponse = (0, $kZFCD.type)({
    slot: (0, $kZFCD.number)(),
    confirmations: (0, $kZFCD.nullable)((0, $kZFCD.number)()),
    err: $c3af9e523501759a$var$TransactionErrorResult,
    confirmationStatus: (0, $kZFCD.optional)($c3af9e523501759a$var$ConfirmationStatus)
});
/**
 * Expected JSON RPC response for the "getSignatureStatuses" message
 */ const $c3af9e523501759a$var$GetSignatureStatusesRpcResult = $c3af9e523501759a$var$jsonRpcResultAndContext((0, $kZFCD.array)((0, $kZFCD.nullable)($c3af9e523501759a$var$SignatureStatusResponse)));
/**
 * Expected JSON RPC response for the "getMinimumBalanceForRentExemption" message
 */ const $c3af9e523501759a$var$GetMinimumBalanceForRentExemptionRpcResult = $c3af9e523501759a$var$jsonRpcResult((0, $kZFCD.number)());
const $c3af9e523501759a$var$AddressTableLookupStruct = (0, $kZFCD.type)({
    accountKey: $c3af9e523501759a$var$PublicKeyFromString,
    writableIndexes: (0, $kZFCD.array)((0, $kZFCD.number)()),
    readonlyIndexes: (0, $kZFCD.array)((0, $kZFCD.number)())
});
const $c3af9e523501759a$var$ConfirmedTransactionResult = (0, $kZFCD.type)({
    signatures: (0, $kZFCD.array)((0, $kZFCD.string)()),
    message: (0, $kZFCD.type)({
        accountKeys: (0, $kZFCD.array)((0, $kZFCD.string)()),
        header: (0, $kZFCD.type)({
            numRequiredSignatures: (0, $kZFCD.number)(),
            numReadonlySignedAccounts: (0, $kZFCD.number)(),
            numReadonlyUnsignedAccounts: (0, $kZFCD.number)()
        }),
        instructions: (0, $kZFCD.array)((0, $kZFCD.type)({
            accounts: (0, $kZFCD.array)((0, $kZFCD.number)()),
            data: (0, $kZFCD.string)(),
            programIdIndex: (0, $kZFCD.number)()
        })),
        recentBlockhash: (0, $kZFCD.string)(),
        addressTableLookups: (0, $kZFCD.optional)((0, $kZFCD.array)($c3af9e523501759a$var$AddressTableLookupStruct))
    })
});
const $c3af9e523501759a$var$AnnotatedAccountKey = (0, $kZFCD.type)({
    pubkey: $c3af9e523501759a$var$PublicKeyFromString,
    signer: (0, $kZFCD.boolean)(),
    writable: (0, $kZFCD.boolean)(),
    source: (0, $kZFCD.optional)((0, $kZFCD.union)([
        (0, $kZFCD.literal)("transaction"),
        (0, $kZFCD.literal)("lookupTable")
    ]))
});
const $c3af9e523501759a$var$ConfirmedTransactionAccountsModeResult = (0, $kZFCD.type)({
    accountKeys: (0, $kZFCD.array)($c3af9e523501759a$var$AnnotatedAccountKey),
    signatures: (0, $kZFCD.array)((0, $kZFCD.string)())
});
const $c3af9e523501759a$var$ParsedInstructionResult = (0, $kZFCD.type)({
    parsed: (0, $kZFCD.unknown)(),
    program: (0, $kZFCD.string)(),
    programId: $c3af9e523501759a$var$PublicKeyFromString
});
const $c3af9e523501759a$var$RawInstructionResult = (0, $kZFCD.type)({
    accounts: (0, $kZFCD.array)($c3af9e523501759a$var$PublicKeyFromString),
    data: (0, $kZFCD.string)(),
    programId: $c3af9e523501759a$var$PublicKeyFromString
});
const $c3af9e523501759a$var$InstructionResult = (0, $kZFCD.union)([
    $c3af9e523501759a$var$RawInstructionResult,
    $c3af9e523501759a$var$ParsedInstructionResult
]);
const $c3af9e523501759a$var$UnknownInstructionResult = (0, $kZFCD.union)([
    (0, $kZFCD.type)({
        parsed: (0, $kZFCD.unknown)(),
        program: (0, $kZFCD.string)(),
        programId: (0, $kZFCD.string)()
    }),
    (0, $kZFCD.type)({
        accounts: (0, $kZFCD.array)((0, $kZFCD.string)()),
        data: (0, $kZFCD.string)(),
        programId: (0, $kZFCD.string)()
    })
]);
const $c3af9e523501759a$var$ParsedOrRawInstruction = (0, $kZFCD.coerce)($c3af9e523501759a$var$InstructionResult, $c3af9e523501759a$var$UnknownInstructionResult, (value)=>{
    if ("accounts" in value) return (0, $kZFCD.create)(value, $c3af9e523501759a$var$RawInstructionResult);
    else return (0, $kZFCD.create)(value, $c3af9e523501759a$var$ParsedInstructionResult);
});
/**
 * @internal
 */ const $c3af9e523501759a$var$ParsedConfirmedTransactionResult = (0, $kZFCD.type)({
    signatures: (0, $kZFCD.array)((0, $kZFCD.string)()),
    message: (0, $kZFCD.type)({
        accountKeys: (0, $kZFCD.array)($c3af9e523501759a$var$AnnotatedAccountKey),
        instructions: (0, $kZFCD.array)($c3af9e523501759a$var$ParsedOrRawInstruction),
        recentBlockhash: (0, $kZFCD.string)(),
        addressTableLookups: (0, $kZFCD.optional)((0, $kZFCD.nullable)((0, $kZFCD.array)($c3af9e523501759a$var$AddressTableLookupStruct)))
    })
});
const $c3af9e523501759a$var$TokenBalanceResult = (0, $kZFCD.type)({
    accountIndex: (0, $kZFCD.number)(),
    mint: (0, $kZFCD.string)(),
    owner: (0, $kZFCD.optional)((0, $kZFCD.string)()),
    uiTokenAmount: $c3af9e523501759a$var$TokenAmountResult
});
const $c3af9e523501759a$var$LoadedAddressesResult = (0, $kZFCD.type)({
    writable: (0, $kZFCD.array)($c3af9e523501759a$var$PublicKeyFromString),
    readonly: (0, $kZFCD.array)($c3af9e523501759a$var$PublicKeyFromString)
});
/**
 * @internal
 */ const $c3af9e523501759a$var$ConfirmedTransactionMetaResult = (0, $kZFCD.type)({
    err: $c3af9e523501759a$var$TransactionErrorResult,
    fee: (0, $kZFCD.number)(),
    innerInstructions: (0, $kZFCD.optional)((0, $kZFCD.nullable)((0, $kZFCD.array)((0, $kZFCD.type)({
        index: (0, $kZFCD.number)(),
        instructions: (0, $kZFCD.array)((0, $kZFCD.type)({
            accounts: (0, $kZFCD.array)((0, $kZFCD.number)()),
            data: (0, $kZFCD.string)(),
            programIdIndex: (0, $kZFCD.number)()
        }))
    })))),
    preBalances: (0, $kZFCD.array)((0, $kZFCD.number)()),
    postBalances: (0, $kZFCD.array)((0, $kZFCD.number)()),
    logMessages: (0, $kZFCD.optional)((0, $kZFCD.nullable)((0, $kZFCD.array)((0, $kZFCD.string)()))),
    preTokenBalances: (0, $kZFCD.optional)((0, $kZFCD.nullable)((0, $kZFCD.array)($c3af9e523501759a$var$TokenBalanceResult))),
    postTokenBalances: (0, $kZFCD.optional)((0, $kZFCD.nullable)((0, $kZFCD.array)($c3af9e523501759a$var$TokenBalanceResult))),
    loadedAddresses: (0, $kZFCD.optional)($c3af9e523501759a$var$LoadedAddressesResult),
    computeUnitsConsumed: (0, $kZFCD.optional)((0, $kZFCD.number)())
});
/**
 * @internal
 */ const $c3af9e523501759a$var$ParsedConfirmedTransactionMetaResult = (0, $kZFCD.type)({
    err: $c3af9e523501759a$var$TransactionErrorResult,
    fee: (0, $kZFCD.number)(),
    innerInstructions: (0, $kZFCD.optional)((0, $kZFCD.nullable)((0, $kZFCD.array)((0, $kZFCD.type)({
        index: (0, $kZFCD.number)(),
        instructions: (0, $kZFCD.array)($c3af9e523501759a$var$ParsedOrRawInstruction)
    })))),
    preBalances: (0, $kZFCD.array)((0, $kZFCD.number)()),
    postBalances: (0, $kZFCD.array)((0, $kZFCD.number)()),
    logMessages: (0, $kZFCD.optional)((0, $kZFCD.nullable)((0, $kZFCD.array)((0, $kZFCD.string)()))),
    preTokenBalances: (0, $kZFCD.optional)((0, $kZFCD.nullable)((0, $kZFCD.array)($c3af9e523501759a$var$TokenBalanceResult))),
    postTokenBalances: (0, $kZFCD.optional)((0, $kZFCD.nullable)((0, $kZFCD.array)($c3af9e523501759a$var$TokenBalanceResult))),
    loadedAddresses: (0, $kZFCD.optional)($c3af9e523501759a$var$LoadedAddressesResult),
    computeUnitsConsumed: (0, $kZFCD.optional)((0, $kZFCD.number)())
});
const $c3af9e523501759a$var$TransactionVersionStruct = (0, $kZFCD.union)([
    (0, $kZFCD.literal)(0),
    (0, $kZFCD.literal)("legacy")
]);
/** @internal */ const $c3af9e523501759a$var$RewardsResult = (0, $kZFCD.type)({
    pubkey: (0, $kZFCD.string)(),
    lamports: (0, $kZFCD.number)(),
    postBalance: (0, $kZFCD.nullable)((0, $kZFCD.number)()),
    rewardType: (0, $kZFCD.nullable)((0, $kZFCD.string)()),
    commission: (0, $kZFCD.optional)((0, $kZFCD.nullable)((0, $kZFCD.number)()))
});
/**
 * Expected JSON RPC response for the "getBlock" message
 */ const $c3af9e523501759a$var$GetBlockRpcResult = $c3af9e523501759a$var$jsonRpcResult((0, $kZFCD.nullable)((0, $kZFCD.type)({
    blockhash: (0, $kZFCD.string)(),
    previousBlockhash: (0, $kZFCD.string)(),
    parentSlot: (0, $kZFCD.number)(),
    transactions: (0, $kZFCD.array)((0, $kZFCD.type)({
        transaction: $c3af9e523501759a$var$ConfirmedTransactionResult,
        meta: (0, $kZFCD.nullable)($c3af9e523501759a$var$ConfirmedTransactionMetaResult),
        version: (0, $kZFCD.optional)($c3af9e523501759a$var$TransactionVersionStruct)
    })),
    rewards: (0, $kZFCD.optional)((0, $kZFCD.array)($c3af9e523501759a$var$RewardsResult)),
    blockTime: (0, $kZFCD.nullable)((0, $kZFCD.number)()),
    blockHeight: (0, $kZFCD.nullable)((0, $kZFCD.number)())
})));
/**
 * Expected JSON RPC response for the "getBlock" message when `transactionDetails` is `none`
 */ const $c3af9e523501759a$var$GetNoneModeBlockRpcResult = $c3af9e523501759a$var$jsonRpcResult((0, $kZFCD.nullable)((0, $kZFCD.type)({
    blockhash: (0, $kZFCD.string)(),
    previousBlockhash: (0, $kZFCD.string)(),
    parentSlot: (0, $kZFCD.number)(),
    rewards: (0, $kZFCD.optional)((0, $kZFCD.array)($c3af9e523501759a$var$RewardsResult)),
    blockTime: (0, $kZFCD.nullable)((0, $kZFCD.number)()),
    blockHeight: (0, $kZFCD.nullable)((0, $kZFCD.number)())
})));
/**
 * Expected JSON RPC response for the "getBlock" message when `transactionDetails` is `accounts`
 */ const $c3af9e523501759a$var$GetAccountsModeBlockRpcResult = $c3af9e523501759a$var$jsonRpcResult((0, $kZFCD.nullable)((0, $kZFCD.type)({
    blockhash: (0, $kZFCD.string)(),
    previousBlockhash: (0, $kZFCD.string)(),
    parentSlot: (0, $kZFCD.number)(),
    transactions: (0, $kZFCD.array)((0, $kZFCD.type)({
        transaction: $c3af9e523501759a$var$ConfirmedTransactionAccountsModeResult,
        meta: (0, $kZFCD.nullable)($c3af9e523501759a$var$ConfirmedTransactionMetaResult),
        version: (0, $kZFCD.optional)($c3af9e523501759a$var$TransactionVersionStruct)
    })),
    rewards: (0, $kZFCD.optional)((0, $kZFCD.array)($c3af9e523501759a$var$RewardsResult)),
    blockTime: (0, $kZFCD.nullable)((0, $kZFCD.number)()),
    blockHeight: (0, $kZFCD.nullable)((0, $kZFCD.number)())
})));
/**
 * Expected parsed JSON RPC response for the "getBlock" message
 */ const $c3af9e523501759a$var$GetParsedBlockRpcResult = $c3af9e523501759a$var$jsonRpcResult((0, $kZFCD.nullable)((0, $kZFCD.type)({
    blockhash: (0, $kZFCD.string)(),
    previousBlockhash: (0, $kZFCD.string)(),
    parentSlot: (0, $kZFCD.number)(),
    transactions: (0, $kZFCD.array)((0, $kZFCD.type)({
        transaction: $c3af9e523501759a$var$ParsedConfirmedTransactionResult,
        meta: (0, $kZFCD.nullable)($c3af9e523501759a$var$ParsedConfirmedTransactionMetaResult),
        version: (0, $kZFCD.optional)($c3af9e523501759a$var$TransactionVersionStruct)
    })),
    rewards: (0, $kZFCD.optional)((0, $kZFCD.array)($c3af9e523501759a$var$RewardsResult)),
    blockTime: (0, $kZFCD.nullable)((0, $kZFCD.number)()),
    blockHeight: (0, $kZFCD.nullable)((0, $kZFCD.number)())
})));
/**
 * Expected parsed JSON RPC response for the "getBlock" message  when `transactionDetails` is `accounts`
 */ const $c3af9e523501759a$var$GetParsedAccountsModeBlockRpcResult = $c3af9e523501759a$var$jsonRpcResult((0, $kZFCD.nullable)((0, $kZFCD.type)({
    blockhash: (0, $kZFCD.string)(),
    previousBlockhash: (0, $kZFCD.string)(),
    parentSlot: (0, $kZFCD.number)(),
    transactions: (0, $kZFCD.array)((0, $kZFCD.type)({
        transaction: $c3af9e523501759a$var$ConfirmedTransactionAccountsModeResult,
        meta: (0, $kZFCD.nullable)($c3af9e523501759a$var$ParsedConfirmedTransactionMetaResult),
        version: (0, $kZFCD.optional)($c3af9e523501759a$var$TransactionVersionStruct)
    })),
    rewards: (0, $kZFCD.optional)((0, $kZFCD.array)($c3af9e523501759a$var$RewardsResult)),
    blockTime: (0, $kZFCD.nullable)((0, $kZFCD.number)()),
    blockHeight: (0, $kZFCD.nullable)((0, $kZFCD.number)())
})));
/**
 * Expected parsed JSON RPC response for the "getBlock" message  when `transactionDetails` is `none`
 */ const $c3af9e523501759a$var$GetParsedNoneModeBlockRpcResult = $c3af9e523501759a$var$jsonRpcResult((0, $kZFCD.nullable)((0, $kZFCD.type)({
    blockhash: (0, $kZFCD.string)(),
    previousBlockhash: (0, $kZFCD.string)(),
    parentSlot: (0, $kZFCD.number)(),
    rewards: (0, $kZFCD.optional)((0, $kZFCD.array)($c3af9e523501759a$var$RewardsResult)),
    blockTime: (0, $kZFCD.nullable)((0, $kZFCD.number)()),
    blockHeight: (0, $kZFCD.nullable)((0, $kZFCD.number)())
})));
/**
 * Expected JSON RPC response for the "getConfirmedBlock" message
 *
 * @deprecated Deprecated since Solana v1.8.0. Please use {@link GetBlockRpcResult} instead.
 */ const $c3af9e523501759a$var$GetConfirmedBlockRpcResult = $c3af9e523501759a$var$jsonRpcResult((0, $kZFCD.nullable)((0, $kZFCD.type)({
    blockhash: (0, $kZFCD.string)(),
    previousBlockhash: (0, $kZFCD.string)(),
    parentSlot: (0, $kZFCD.number)(),
    transactions: (0, $kZFCD.array)((0, $kZFCD.type)({
        transaction: $c3af9e523501759a$var$ConfirmedTransactionResult,
        meta: (0, $kZFCD.nullable)($c3af9e523501759a$var$ConfirmedTransactionMetaResult)
    })),
    rewards: (0, $kZFCD.optional)((0, $kZFCD.array)($c3af9e523501759a$var$RewardsResult)),
    blockTime: (0, $kZFCD.nullable)((0, $kZFCD.number)())
})));
/**
 * Expected JSON RPC response for the "getBlock" message
 */ const $c3af9e523501759a$var$GetBlockSignaturesRpcResult = $c3af9e523501759a$var$jsonRpcResult((0, $kZFCD.nullable)((0, $kZFCD.type)({
    blockhash: (0, $kZFCD.string)(),
    previousBlockhash: (0, $kZFCD.string)(),
    parentSlot: (0, $kZFCD.number)(),
    signatures: (0, $kZFCD.array)((0, $kZFCD.string)()),
    blockTime: (0, $kZFCD.nullable)((0, $kZFCD.number)())
})));
/**
 * Expected JSON RPC response for the "getTransaction" message
 */ const $c3af9e523501759a$var$GetTransactionRpcResult = $c3af9e523501759a$var$jsonRpcResult((0, $kZFCD.nullable)((0, $kZFCD.type)({
    slot: (0, $kZFCD.number)(),
    meta: (0, $kZFCD.nullable)($c3af9e523501759a$var$ConfirmedTransactionMetaResult),
    blockTime: (0, $kZFCD.optional)((0, $kZFCD.nullable)((0, $kZFCD.number)())),
    transaction: $c3af9e523501759a$var$ConfirmedTransactionResult,
    version: (0, $kZFCD.optional)($c3af9e523501759a$var$TransactionVersionStruct)
})));
/**
 * Expected parsed JSON RPC response for the "getTransaction" message
 */ const $c3af9e523501759a$var$GetParsedTransactionRpcResult = $c3af9e523501759a$var$jsonRpcResult((0, $kZFCD.nullable)((0, $kZFCD.type)({
    slot: (0, $kZFCD.number)(),
    transaction: $c3af9e523501759a$var$ParsedConfirmedTransactionResult,
    meta: (0, $kZFCD.nullable)($c3af9e523501759a$var$ParsedConfirmedTransactionMetaResult),
    blockTime: (0, $kZFCD.optional)((0, $kZFCD.nullable)((0, $kZFCD.number)())),
    version: (0, $kZFCD.optional)($c3af9e523501759a$var$TransactionVersionStruct)
})));
/**
 * Expected JSON RPC response for the "getRecentBlockhash" message
 *
 * @deprecated Deprecated since Solana v1.8.0. Please use {@link GetLatestBlockhashRpcResult} instead.
 */ const $c3af9e523501759a$var$GetRecentBlockhashAndContextRpcResult = $c3af9e523501759a$var$jsonRpcResultAndContext((0, $kZFCD.type)({
    blockhash: (0, $kZFCD.string)(),
    feeCalculator: (0, $kZFCD.type)({
        lamportsPerSignature: (0, $kZFCD.number)()
    })
}));
/**
 * Expected JSON RPC response for the "getLatestBlockhash" message
 */ const $c3af9e523501759a$var$GetLatestBlockhashRpcResult = $c3af9e523501759a$var$jsonRpcResultAndContext((0, $kZFCD.type)({
    blockhash: (0, $kZFCD.string)(),
    lastValidBlockHeight: (0, $kZFCD.number)()
}));
/**
 * Expected JSON RPC response for the "isBlockhashValid" message
 */ const $c3af9e523501759a$var$IsBlockhashValidRpcResult = $c3af9e523501759a$var$jsonRpcResultAndContext((0, $kZFCD.boolean)());
const $c3af9e523501759a$var$PerfSampleResult = (0, $kZFCD.type)({
    slot: (0, $kZFCD.number)(),
    numTransactions: (0, $kZFCD.number)(),
    numSlots: (0, $kZFCD.number)(),
    samplePeriodSecs: (0, $kZFCD.number)()
});
/*
 * Expected JSON RPC response for "getRecentPerformanceSamples" message
 */ const $c3af9e523501759a$var$GetRecentPerformanceSamplesRpcResult = $c3af9e523501759a$var$jsonRpcResult((0, $kZFCD.array)($c3af9e523501759a$var$PerfSampleResult));
/**
 * Expected JSON RPC response for the "getFeeCalculatorForBlockhash" message
 */ const $c3af9e523501759a$var$GetFeeCalculatorRpcResult = $c3af9e523501759a$var$jsonRpcResultAndContext((0, $kZFCD.nullable)((0, $kZFCD.type)({
    feeCalculator: (0, $kZFCD.type)({
        lamportsPerSignature: (0, $kZFCD.number)()
    })
})));
/**
 * Expected JSON RPC response for the "requestAirdrop" message
 */ const $c3af9e523501759a$var$RequestAirdropRpcResult = $c3af9e523501759a$var$jsonRpcResult((0, $kZFCD.string)());
/**
 * Expected JSON RPC response for the "sendTransaction" message
 */ const $c3af9e523501759a$var$SendTransactionRpcResult = $c3af9e523501759a$var$jsonRpcResult((0, $kZFCD.string)());
/**
 * Information about the latest slot being processed by a node
 */ /**
 * Parsed account data
 */ /**
 * Stake Activation data
 */ /**
 * Data slice argument for getProgramAccounts
 */ /**
 * Memory comparison filter for getProgramAccounts
 */ /**
 * Data size comparison filter for getProgramAccounts
 */ /**
 * A filter object for getProgramAccounts
 */ /**
 * Configuration object for getProgramAccounts requests
 */ /**
 * Configuration object for getParsedProgramAccounts
 */ /**
 * Configuration object for getMultipleAccounts
 */ /**
 * Configuration object for `getStakeActivation`
 */ /**
 * Configuration object for `getStakeActivation`
 */ /**
 * Configuration object for `getStakeActivation`
 */ /**
 * Configuration object for `getNonce`
 */ /**
 * Configuration object for `getNonceAndContext`
 */ /**
 * Information describing an account
 */ /**
 * Account information identified by pubkey
 */ /**
 * Callback function for account change notifications
 */ /**
 * Callback function for program account change notifications
 */ /**
 * Callback function for slot change notifications
 */ /**
 * Callback function for slot update notifications
 */ /**
 * Callback function for signature status notifications
 */ /**
 * Signature status notification with transaction result
 */ /**
 * Signature received notification
 */ /**
 * Callback function for signature notifications
 */ /**
 * Signature subscription options
 */ /**
 * Callback function for root change notifications
 */ /**
 * @internal
 */ const $c3af9e523501759a$var$LogsResult = (0, $kZFCD.type)({
    err: $c3af9e523501759a$var$TransactionErrorResult,
    logs: (0, $kZFCD.array)((0, $kZFCD.string)()),
    signature: (0, $kZFCD.string)()
});
/**
 * Logs result.
 */ /**
 * Expected JSON RPC response for the "logsNotification" message.
 */ const $c3af9e523501759a$var$LogsNotificationResult = (0, $kZFCD.type)({
    result: $c3af9e523501759a$var$notificationResultAndContext($c3af9e523501759a$var$LogsResult),
    subscription: (0, $kZFCD.number)()
});
/**
 * Filter for log subscriptions.
 */ /**
 * Callback function for log notifications.
 */ /**
 * Signature result
 */ /**
 * Transaction error
 */ /**
 * Transaction confirmation status
 * <pre>
 *   'processed': Transaction landed in a block which has reached 1 confirmation by the connected node
 *   'confirmed': Transaction landed in a block which has reached 1 confirmation by the cluster
 *   'finalized': Transaction landed in a block which has been finalized by the cluster
 * </pre>
 */ /**
 * Signature status
 */ /**
 * A confirmed signature with its status
 */ /**
 * An object defining headers to be passed to the RPC server
 */ /**
 * The type of the JavaScript `fetch()` API
 */ /**
 * A callback used to augment the outgoing HTTP request
 */ /**
 * Configuration for instantiating a Connection
 */ /** @internal */ const $c3af9e523501759a$var$COMMON_HTTP_HEADERS = {
    "solana-client": `js/${"0.0.0-development"}`
};
/**
 * A connection to a fullnode JSON RPC endpoint
 */ class $c3af9e523501759a$export$98b66c25bb38499d {
    /**
   * Establish a JSON RPC connection
   *
   * @param endpoint URL to the fullnode JSON RPC endpoint
   * @param commitmentOrConfig optional default commitment level or optional ConnectionConfig configuration object
   */ constructor(endpoint, _commitmentOrConfig){
        /** @internal */ this._commitment = void 0;
        /** @internal */ this._confirmTransactionInitialTimeout = void 0;
        /** @internal */ this._rpcEndpoint = void 0;
        /** @internal */ this._rpcWsEndpoint = void 0;
        /** @internal */ this._rpcClient = void 0;
        /** @internal */ this._rpcRequest = void 0;
        /** @internal */ this._rpcBatchRequest = void 0;
        /** @internal */ this._rpcWebSocket = void 0;
        /** @internal */ this._rpcWebSocketConnected = false;
        /** @internal */ this._rpcWebSocketHeartbeat = null;
        /** @internal */ this._rpcWebSocketIdleTimeout = null;
        /** @internal
     * A number that we increment every time an active connection closes.
     * Used to determine whether the same socket connection that was open
     * when an async operation started is the same one that's active when
     * its continuation fires.
     *
     */ this._rpcWebSocketGeneration = 0;
        /** @internal */ this._disableBlockhashCaching = false;
        /** @internal */ this._pollingBlockhash = false;
        /** @internal */ this._blockhashInfo = {
            latestBlockhash: null,
            lastFetch: 0,
            transactionSignatures: [],
            simulatedSignatures: []
        };
        /** @internal */ this._nextClientSubscriptionId = 0;
        /** @internal */ this._subscriptionDisposeFunctionsByClientSubscriptionId = {};
        /** @internal */ this._subscriptionHashByClientSubscriptionId = {};
        /** @internal */ this._subscriptionStateChangeCallbacksByHash = {};
        /** @internal */ this._subscriptionCallbacksByServerSubscriptionId = {};
        /** @internal */ this._subscriptionsByHash = {};
        /**
     * Special case.
     * After a signature is processed, RPCs automatically dispose of the
     * subscription on the server side. We need to track which of these
     * subscriptions have been disposed in such a way, so that we know
     * whether the client is dealing with a not-yet-processed signature
     * (in which case we must tear down the server subscription) or an
     * already-processed signature (in which case the client can simply
     * clear out the subscription locally without telling the server).
     *
     * NOTE: There is a proposal to eliminate this special case, here:
     * https://github.com/solana-labs/solana/issues/18892
     */ /** @internal */ this._subscriptionsAutoDisposedByRpc = new Set();
        /*
     * Returns the current block height of the node
     */ this.getBlockHeight = (()=>{
            const requestPromises = {};
            return async (commitmentOrConfig)=>{
                const { commitment: commitment, config: config } = $c3af9e523501759a$var$extractCommitmentFromConfig(commitmentOrConfig);
                const args = this._buildArgs([], commitment, undefined /* encoding */ , config);
                const requestHash = $c3af9e523501759a$var$fastStableStringify$1(args);
                requestPromises[requestHash] = requestPromises[requestHash] ?? (async ()=>{
                    try {
                        const unsafeRes = await this._rpcRequest("getBlockHeight", args);
                        const res = (0, $kZFCD.create)(unsafeRes, $c3af9e523501759a$var$jsonRpcResult((0, $kZFCD.number)()));
                        if ("error" in res) throw new $c3af9e523501759a$export$ea1b1a1bba5c14ad(res.error, "failed to get block height information");
                        return res.result;
                    } finally{
                        delete requestPromises[requestHash];
                    }
                })();
                return await requestPromises[requestHash];
            };
        })();
        let wsEndpoint;
        let httpHeaders;
        let fetch;
        let fetchMiddleware;
        let disableRetryOnRateLimit;
        let httpAgent;
        if (_commitmentOrConfig && typeof _commitmentOrConfig === "string") this._commitment = _commitmentOrConfig;
        else if (_commitmentOrConfig) {
            this._commitment = _commitmentOrConfig.commitment;
            this._confirmTransactionInitialTimeout = _commitmentOrConfig.confirmTransactionInitialTimeout;
            wsEndpoint = _commitmentOrConfig.wsEndpoint;
            httpHeaders = _commitmentOrConfig.httpHeaders;
            fetch = _commitmentOrConfig.fetch;
            fetchMiddleware = _commitmentOrConfig.fetchMiddleware;
            disableRetryOnRateLimit = _commitmentOrConfig.disableRetryOnRateLimit;
            httpAgent = _commitmentOrConfig.httpAgent;
        }
        this._rpcEndpoint = $c3af9e523501759a$var$assertEndpointUrl(endpoint);
        this._rpcWsEndpoint = wsEndpoint || $c3af9e523501759a$var$makeWebsocketUrl(endpoint);
        this._rpcClient = $c3af9e523501759a$var$createRpcClient(endpoint, httpHeaders, fetch, fetchMiddleware, disableRetryOnRateLimit, httpAgent);
        this._rpcRequest = $c3af9e523501759a$var$createRpcRequest(this._rpcClient);
        this._rpcBatchRequest = $c3af9e523501759a$var$createRpcBatchRequest(this._rpcClient);
        this._rpcWebSocket = new $c3af9e523501759a$var$RpcWebSocketClient(this._rpcWsEndpoint, {
            autoconnect: false,
            max_reconnects: Infinity
        });
        this._rpcWebSocket.on("open", this._wsOnOpen.bind(this));
        this._rpcWebSocket.on("error", this._wsOnError.bind(this));
        this._rpcWebSocket.on("close", this._wsOnClose.bind(this));
        this._rpcWebSocket.on("accountNotification", this._wsOnAccountNotification.bind(this));
        this._rpcWebSocket.on("programNotification", this._wsOnProgramAccountNotification.bind(this));
        this._rpcWebSocket.on("slotNotification", this._wsOnSlotNotification.bind(this));
        this._rpcWebSocket.on("slotsUpdatesNotification", this._wsOnSlotUpdatesNotification.bind(this));
        this._rpcWebSocket.on("signatureNotification", this._wsOnSignatureNotification.bind(this));
        this._rpcWebSocket.on("rootNotification", this._wsOnRootNotification.bind(this));
        this._rpcWebSocket.on("logsNotification", this._wsOnLogsNotification.bind(this));
    }
    /**
   * The default commitment used for requests
   */ get commitment() {
        return this._commitment;
    }
    /**
   * The RPC endpoint
   */ get rpcEndpoint() {
        return this._rpcEndpoint;
    }
    /**
   * Fetch the balance for the specified public key, return with context
   */ async getBalanceAndContext(publicKey, commitmentOrConfig) {
        /** @internal */ const { commitment: commitment, config: config } = $c3af9e523501759a$var$extractCommitmentFromConfig(commitmentOrConfig);
        const args = this._buildArgs([
            publicKey.toBase58()
        ], commitment, undefined /* encoding */ , config);
        const unsafeRes = await this._rpcRequest("getBalance", args);
        const res = (0, $kZFCD.create)(unsafeRes, $c3af9e523501759a$var$jsonRpcResultAndContext((0, $kZFCD.number)()));
        if ("error" in res) throw new $c3af9e523501759a$export$ea1b1a1bba5c14ad(res.error, `failed to get balance for ${publicKey.toBase58()}`);
        return res.result;
    }
    /**
   * Fetch the balance for the specified public key
   */ async getBalance(publicKey, commitmentOrConfig) {
        return await this.getBalanceAndContext(publicKey, commitmentOrConfig).then((x)=>x.value).catch((e)=>{
            throw new Error("failed to get balance of account " + publicKey.toBase58() + ": " + e);
        });
    }
    /**
   * Fetch the estimated production time of a block
   */ async getBlockTime(slot) {
        const unsafeRes = await this._rpcRequest("getBlockTime", [
            slot
        ]);
        const res = (0, $kZFCD.create)(unsafeRes, $c3af9e523501759a$var$jsonRpcResult((0, $kZFCD.nullable)((0, $kZFCD.number)())));
        if ("error" in res) throw new $c3af9e523501759a$export$ea1b1a1bba5c14ad(res.error, `failed to get block time for slot ${slot}`);
        return res.result;
    }
    /**
   * Fetch the lowest slot that the node has information about in its ledger.
   * This value may increase over time if the node is configured to purge older ledger data
   */ async getMinimumLedgerSlot() {
        const unsafeRes = await this._rpcRequest("minimumLedgerSlot", []);
        const res = (0, $kZFCD.create)(unsafeRes, $c3af9e523501759a$var$jsonRpcResult((0, $kZFCD.number)()));
        if ("error" in res) throw new $c3af9e523501759a$export$ea1b1a1bba5c14ad(res.error, "failed to get minimum ledger slot");
        return res.result;
    }
    /**
   * Fetch the slot of the lowest confirmed block that has not been purged from the ledger
   */ async getFirstAvailableBlock() {
        const unsafeRes = await this._rpcRequest("getFirstAvailableBlock", []);
        const res = (0, $kZFCD.create)(unsafeRes, $c3af9e523501759a$var$SlotRpcResult);
        if ("error" in res) throw new $c3af9e523501759a$export$ea1b1a1bba5c14ad(res.error, "failed to get first available block");
        return res.result;
    }
    /**
   * Fetch information about the current supply
   */ async getSupply(config) {
        let configArg = {};
        if (typeof config === "string") configArg = {
            commitment: config
        };
        else if (config) configArg = {
            ...config,
            commitment: config && config.commitment || this.commitment
        };
        else configArg = {
            commitment: this.commitment
        };
        const unsafeRes = await this._rpcRequest("getSupply", [
            configArg
        ]);
        const res = (0, $kZFCD.create)(unsafeRes, $c3af9e523501759a$var$GetSupplyRpcResult);
        if ("error" in res) throw new $c3af9e523501759a$export$ea1b1a1bba5c14ad(res.error, "failed to get supply");
        return res.result;
    }
    /**
   * Fetch the current supply of a token mint
   */ async getTokenSupply(tokenMintAddress, commitment) {
        const args = this._buildArgs([
            tokenMintAddress.toBase58()
        ], commitment);
        const unsafeRes = await this._rpcRequest("getTokenSupply", args);
        const res = (0, $kZFCD.create)(unsafeRes, $c3af9e523501759a$var$jsonRpcResultAndContext($c3af9e523501759a$var$TokenAmountResult));
        if ("error" in res) throw new $c3af9e523501759a$export$ea1b1a1bba5c14ad(res.error, "failed to get token supply");
        return res.result;
    }
    /**
   * Fetch the current balance of a token account
   */ async getTokenAccountBalance(tokenAddress, commitment) {
        const args = this._buildArgs([
            tokenAddress.toBase58()
        ], commitment);
        const unsafeRes = await this._rpcRequest("getTokenAccountBalance", args);
        const res = (0, $kZFCD.create)(unsafeRes, $c3af9e523501759a$var$jsonRpcResultAndContext($c3af9e523501759a$var$TokenAmountResult));
        if ("error" in res) throw new $c3af9e523501759a$export$ea1b1a1bba5c14ad(res.error, "failed to get token account balance");
        return res.result;
    }
    /**
   * Fetch all the token accounts owned by the specified account
   *
   * @return {Promise<RpcResponseAndContext<GetProgramAccountsResponse>}
   */ async getTokenAccountsByOwner(ownerAddress, filter, commitmentOrConfig) {
        const { commitment: commitment, config: config } = $c3af9e523501759a$var$extractCommitmentFromConfig(commitmentOrConfig);
        let _args = [
            ownerAddress.toBase58()
        ];
        if ("mint" in filter) _args.push({
            mint: filter.mint.toBase58()
        });
        else _args.push({
            programId: filter.programId.toBase58()
        });
        const args = this._buildArgs(_args, commitment, "base64", config);
        const unsafeRes = await this._rpcRequest("getTokenAccountsByOwner", args);
        const res = (0, $kZFCD.create)(unsafeRes, $c3af9e523501759a$var$GetTokenAccountsByOwner);
        if ("error" in res) throw new $c3af9e523501759a$export$ea1b1a1bba5c14ad(res.error, `failed to get token accounts owned by account ${ownerAddress.toBase58()}`);
        return res.result;
    }
    /**
   * Fetch parsed token accounts owned by the specified account
   *
   * @return {Promise<RpcResponseAndContext<Array<{pubkey: PublicKey, account: AccountInfo<ParsedAccountData>}>>>}
   */ async getParsedTokenAccountsByOwner(ownerAddress, filter, commitment) {
        let _args = [
            ownerAddress.toBase58()
        ];
        if ("mint" in filter) _args.push({
            mint: filter.mint.toBase58()
        });
        else _args.push({
            programId: filter.programId.toBase58()
        });
        const args = this._buildArgs(_args, commitment, "jsonParsed");
        const unsafeRes = await this._rpcRequest("getTokenAccountsByOwner", args);
        const res = (0, $kZFCD.create)(unsafeRes, $c3af9e523501759a$var$GetParsedTokenAccountsByOwner);
        if ("error" in res) throw new $c3af9e523501759a$export$ea1b1a1bba5c14ad(res.error, `failed to get token accounts owned by account ${ownerAddress.toBase58()}`);
        return res.result;
    }
    /**
   * Fetch the 20 largest accounts with their current balances
   */ async getLargestAccounts(config) {
        const arg = {
            ...config,
            commitment: config && config.commitment || this.commitment
        };
        const args = arg.filter || arg.commitment ? [
            arg
        ] : [];
        const unsafeRes = await this._rpcRequest("getLargestAccounts", args);
        const res = (0, $kZFCD.create)(unsafeRes, $c3af9e523501759a$var$GetLargestAccountsRpcResult);
        if ("error" in res) throw new $c3af9e523501759a$export$ea1b1a1bba5c14ad(res.error, "failed to get largest accounts");
        return res.result;
    }
    /**
   * Fetch the 20 largest token accounts with their current balances
   * for a given mint.
   */ async getTokenLargestAccounts(mintAddress, commitment) {
        const args = this._buildArgs([
            mintAddress.toBase58()
        ], commitment);
        const unsafeRes = await this._rpcRequest("getTokenLargestAccounts", args);
        const res = (0, $kZFCD.create)(unsafeRes, $c3af9e523501759a$var$GetTokenLargestAccountsResult);
        if ("error" in res) throw new $c3af9e523501759a$export$ea1b1a1bba5c14ad(res.error, "failed to get token largest accounts");
        return res.result;
    }
    /**
   * Fetch all the account info for the specified public key, return with context
   */ async getAccountInfoAndContext(publicKey, commitmentOrConfig) {
        const { commitment: commitment, config: config } = $c3af9e523501759a$var$extractCommitmentFromConfig(commitmentOrConfig);
        const args = this._buildArgs([
            publicKey.toBase58()
        ], commitment, "base64", config);
        const unsafeRes = await this._rpcRequest("getAccountInfo", args);
        const res = (0, $kZFCD.create)(unsafeRes, $c3af9e523501759a$var$jsonRpcResultAndContext((0, $kZFCD.nullable)($c3af9e523501759a$var$AccountInfoResult)));
        if ("error" in res) throw new $c3af9e523501759a$export$ea1b1a1bba5c14ad(res.error, `failed to get info about account ${publicKey.toBase58()}`);
        return res.result;
    }
    /**
   * Fetch parsed account info for the specified public key
   */ async getParsedAccountInfo(publicKey, commitmentOrConfig) {
        const { commitment: commitment, config: config } = $c3af9e523501759a$var$extractCommitmentFromConfig(commitmentOrConfig);
        const args = this._buildArgs([
            publicKey.toBase58()
        ], commitment, "jsonParsed", config);
        const unsafeRes = await this._rpcRequest("getAccountInfo", args);
        const res = (0, $kZFCD.create)(unsafeRes, $c3af9e523501759a$var$jsonRpcResultAndContext((0, $kZFCD.nullable)($c3af9e523501759a$var$ParsedAccountInfoResult)));
        if ("error" in res) throw new $c3af9e523501759a$export$ea1b1a1bba5c14ad(res.error, `failed to get info about account ${publicKey.toBase58()}`);
        return res.result;
    }
    /**
   * Fetch all the account info for the specified public key
   */ async getAccountInfo(publicKey, commitmentOrConfig) {
        try {
            const res = await this.getAccountInfoAndContext(publicKey, commitmentOrConfig);
            return res.value;
        } catch (e) {
            throw new Error("failed to get info about account " + publicKey.toBase58() + ": " + e);
        }
    }
    /**
   * Fetch all the account info for multiple accounts specified by an array of public keys, return with context
   */ async getMultipleParsedAccounts(publicKeys, rawConfig) {
        const { commitment: commitment, config: config } = $c3af9e523501759a$var$extractCommitmentFromConfig(rawConfig);
        const keys = publicKeys.map((key)=>key.toBase58());
        const args = this._buildArgs([
            keys
        ], commitment, "jsonParsed", config);
        const unsafeRes = await this._rpcRequest("getMultipleAccounts", args);
        const res = (0, $kZFCD.create)(unsafeRes, $c3af9e523501759a$var$jsonRpcResultAndContext((0, $kZFCD.array)((0, $kZFCD.nullable)($c3af9e523501759a$var$ParsedAccountInfoResult))));
        if ("error" in res) throw new $c3af9e523501759a$export$ea1b1a1bba5c14ad(res.error, `failed to get info for accounts ${keys}`);
        return res.result;
    }
    /**
   * Fetch all the account info for multiple accounts specified by an array of public keys, return with context
   */ async getMultipleAccountsInfoAndContext(publicKeys, commitmentOrConfig) {
        const { commitment: commitment, config: config } = $c3af9e523501759a$var$extractCommitmentFromConfig(commitmentOrConfig);
        const keys = publicKeys.map((key)=>key.toBase58());
        const args = this._buildArgs([
            keys
        ], commitment, "base64", config);
        const unsafeRes = await this._rpcRequest("getMultipleAccounts", args);
        const res = (0, $kZFCD.create)(unsafeRes, $c3af9e523501759a$var$jsonRpcResultAndContext((0, $kZFCD.array)((0, $kZFCD.nullable)($c3af9e523501759a$var$AccountInfoResult))));
        if ("error" in res) throw new $c3af9e523501759a$export$ea1b1a1bba5c14ad(res.error, `failed to get info for accounts ${keys}`);
        return res.result;
    }
    /**
   * Fetch all the account info for multiple accounts specified by an array of public keys
   */ async getMultipleAccountsInfo(publicKeys, commitmentOrConfig) {
        const res = await this.getMultipleAccountsInfoAndContext(publicKeys, commitmentOrConfig);
        return res.value;
    }
    /**
   * Returns epoch activation information for a stake account that has been delegated
   */ async getStakeActivation(publicKey, commitmentOrConfig, epoch) {
        const { commitment: commitment, config: config } = $c3af9e523501759a$var$extractCommitmentFromConfig(commitmentOrConfig);
        const args = this._buildArgs([
            publicKey.toBase58()
        ], commitment, undefined /* encoding */ , {
            ...config,
            epoch: epoch != null ? epoch : config?.epoch
        });
        const unsafeRes = await this._rpcRequest("getStakeActivation", args);
        const res = (0, $kZFCD.create)(unsafeRes, $c3af9e523501759a$var$jsonRpcResult($c3af9e523501759a$var$StakeActivationResult));
        if ("error" in res) throw new $c3af9e523501759a$export$ea1b1a1bba5c14ad(res.error, `failed to get Stake Activation ${publicKey.toBase58()}`);
        return res.result;
    }
    /**
   * Fetch all the accounts owned by the specified program id
   *
   * @return {Promise<Array<{pubkey: PublicKey, account: AccountInfo<Buffer>}>>}
   */ // eslint-disable-next-line no-dupe-class-members
    // eslint-disable-next-line no-dupe-class-members
    async getProgramAccounts(programId, configOrCommitment) {
        const { commitment: commitment, config: config } = $c3af9e523501759a$var$extractCommitmentFromConfig(configOrCommitment);
        const { encoding: encoding, ...configWithoutEncoding } = config || {};
        const args = this._buildArgs([
            programId.toBase58()
        ], commitment, encoding || "base64", configWithoutEncoding);
        const unsafeRes = await this._rpcRequest("getProgramAccounts", args);
        const baseSchema = (0, $kZFCD.array)($c3af9e523501759a$var$KeyedAccountInfoResult);
        const res = configWithoutEncoding.withContext === true ? (0, $kZFCD.create)(unsafeRes, $c3af9e523501759a$var$jsonRpcResultAndContext(baseSchema)) : (0, $kZFCD.create)(unsafeRes, $c3af9e523501759a$var$jsonRpcResult(baseSchema));
        if ("error" in res) throw new $c3af9e523501759a$export$ea1b1a1bba5c14ad(res.error, `failed to get accounts owned by program ${programId.toBase58()}`);
        return res.result;
    }
    /**
   * Fetch and parse all the accounts owned by the specified program id
   *
   * @return {Promise<Array<{pubkey: PublicKey, account: AccountInfo<Buffer | ParsedAccountData>}>>}
   */ async getParsedProgramAccounts(programId, configOrCommitment) {
        const { commitment: commitment, config: config } = $c3af9e523501759a$var$extractCommitmentFromConfig(configOrCommitment);
        const args = this._buildArgs([
            programId.toBase58()
        ], commitment, "jsonParsed", config);
        const unsafeRes = await this._rpcRequest("getProgramAccounts", args);
        const res = (0, $kZFCD.create)(unsafeRes, $c3af9e523501759a$var$jsonRpcResult((0, $kZFCD.array)($c3af9e523501759a$var$KeyedParsedAccountInfoResult)));
        if ("error" in res) throw new $c3af9e523501759a$export$ea1b1a1bba5c14ad(res.error, `failed to get accounts owned by program ${programId.toBase58()}`);
        return res.result;
    }
    /** @deprecated Instead, call `confirmTransaction` and pass in {@link TransactionConfirmationStrategy} */ // eslint-disable-next-line no-dupe-class-members
    // eslint-disable-next-line no-dupe-class-members
    async confirmTransaction(strategy, commitment) {
        let rawSignature;
        if (typeof strategy == "string") rawSignature = strategy;
        else {
            const config = strategy;
            if (config.abortSignal?.aborted) return Promise.reject(config.abortSignal.reason);
            rawSignature = config.signature;
        }
        let decodedSignature;
        try {
            decodedSignature = (0, (/*@__PURE__*/$parcel$interopDefault($4UTkl))).decode(rawSignature);
        } catch (err) {
            throw new Error("signature must be base58 encoded: " + rawSignature);
        }
        $c3af9e523501759a$var$assert(decodedSignature.length === 64, "signature has invalid length");
        if (typeof strategy === "string") return await this.confirmTransactionUsingLegacyTimeoutStrategy({
            commitment: commitment || this.commitment,
            signature: rawSignature
        });
        else if ("lastValidBlockHeight" in strategy) return await this.confirmTransactionUsingBlockHeightExceedanceStrategy({
            commitment: commitment || this.commitment,
            strategy: strategy
        });
        else return await this.confirmTransactionUsingDurableNonceStrategy({
            commitment: commitment || this.commitment,
            strategy: strategy
        });
    }
    getCancellationPromise(signal) {
        return new Promise((_, reject)=>{
            if (signal == null) return;
            if (signal.aborted) reject(signal.reason);
            else signal.addEventListener("abort", ()=>{
                reject(signal.reason);
            });
        });
    }
    getTransactionConfirmationPromise({ commitment: commitment, signature: signature }) {
        let signatureSubscriptionId;
        let disposeSignatureSubscriptionStateChangeObserver;
        let done = false;
        const confirmationPromise = new Promise((resolve, reject)=>{
            try {
                signatureSubscriptionId = this.onSignature(signature, (result, context)=>{
                    signatureSubscriptionId = undefined;
                    const response = {
                        context: context,
                        value: result
                    };
                    resolve({
                        __type: $c3af9e523501759a$export$7c391bd3b61d2374.PROCESSED,
                        response: response
                    });
                }, commitment);
                const subscriptionSetupPromise = new Promise((resolveSubscriptionSetup)=>{
                    if (signatureSubscriptionId == null) resolveSubscriptionSetup();
                    else disposeSignatureSubscriptionStateChangeObserver = this._onSubscriptionStateChange(signatureSubscriptionId, (nextState)=>{
                        if (nextState === "subscribed") resolveSubscriptionSetup();
                    });
                });
                (async ()=>{
                    await subscriptionSetupPromise;
                    if (done) return;
                    const response = await this.getSignatureStatus(signature);
                    if (done) return;
                    if (response == null) return;
                    const { context: context, value: value } = response;
                    if (value == null) return;
                    if (value?.err) reject(value.err);
                    else {
                        switch(commitment){
                            case "confirmed":
                            case "single":
                            case "singleGossip":
                                if (value.confirmationStatus === "processed") return;
                                break;
                            case "finalized":
                            case "max":
                            case "root":
                                if (value.confirmationStatus === "processed" || value.confirmationStatus === "confirmed") return;
                                break;
                            // exhaust enums to ensure full coverage
                            case "processed":
                            case "recent":
                        }
                        done = true;
                        resolve({
                            __type: $c3af9e523501759a$export$7c391bd3b61d2374.PROCESSED,
                            response: {
                                context: context,
                                value: value
                            }
                        });
                    }
                })();
            } catch (err) {
                reject(err);
            }
        });
        const abortConfirmation = ()=>{
            if (disposeSignatureSubscriptionStateChangeObserver) {
                disposeSignatureSubscriptionStateChangeObserver();
                disposeSignatureSubscriptionStateChangeObserver = undefined;
            }
            if (signatureSubscriptionId != null) {
                this.removeSignatureListener(signatureSubscriptionId);
                signatureSubscriptionId = undefined;
            }
        };
        return {
            abortConfirmation: abortConfirmation,
            confirmationPromise: confirmationPromise
        };
    }
    async confirmTransactionUsingBlockHeightExceedanceStrategy({ commitment: commitment, strategy: { abortSignal: abortSignal, lastValidBlockHeight: lastValidBlockHeight, signature: signature } }) {
        let done = false;
        const expiryPromise = new Promise((resolve)=>{
            const checkBlockHeight = async ()=>{
                try {
                    const blockHeight = await this.getBlockHeight(commitment);
                    return blockHeight;
                } catch (_e) {
                    return -1;
                }
            };
            (async ()=>{
                let currentBlockHeight = await checkBlockHeight();
                if (done) return;
                while(currentBlockHeight <= lastValidBlockHeight){
                    await $c3af9e523501759a$var$sleep(1000);
                    if (done) return;
                    currentBlockHeight = await checkBlockHeight();
                    if (done) return;
                }
                resolve({
                    __type: $c3af9e523501759a$export$7c391bd3b61d2374.BLOCKHEIGHT_EXCEEDED
                });
            })();
        });
        const { abortConfirmation: abortConfirmation, confirmationPromise: confirmationPromise } = this.getTransactionConfirmationPromise({
            commitment: commitment,
            signature: signature
        });
        const cancellationPromise = this.getCancellationPromise(abortSignal);
        let result;
        try {
            const outcome = await Promise.race([
                cancellationPromise,
                confirmationPromise,
                expiryPromise
            ]);
            if (outcome.__type === $c3af9e523501759a$export$7c391bd3b61d2374.PROCESSED) result = outcome.response;
            else throw new $c3af9e523501759a$export$718fcd78527f88ed(signature);
        } finally{
            done = true;
            abortConfirmation();
        }
        return result;
    }
    async confirmTransactionUsingDurableNonceStrategy({ commitment: commitment, strategy: { abortSignal: abortSignal, minContextSlot: minContextSlot, nonceAccountPubkey: nonceAccountPubkey, nonceValue: nonceValue, signature: signature } }) {
        let done = false;
        const expiryPromise = new Promise((resolve)=>{
            let currentNonceValue = nonceValue;
            let lastCheckedSlot = null;
            const getCurrentNonceValue = async ()=>{
                try {
                    const { context: context, value: nonceAccount } = await this.getNonceAndContext(nonceAccountPubkey, {
                        commitment: commitment,
                        minContextSlot: minContextSlot
                    });
                    lastCheckedSlot = context.slot;
                    return nonceAccount?.nonce;
                } catch (e) {
                    // If for whatever reason we can't reach/read the nonce
                    // account, just keep using the last-known value.
                    return currentNonceValue;
                }
            };
            (async ()=>{
                currentNonceValue = await getCurrentNonceValue();
                if (done) return;
                while(true // eslint-disable-line no-constant-condition
                ){
                    if (nonceValue !== currentNonceValue) {
                        resolve({
                            __type: $c3af9e523501759a$export$7c391bd3b61d2374.NONCE_INVALID,
                            slotInWhichNonceDidAdvance: lastCheckedSlot
                        });
                        return;
                    }
                    await $c3af9e523501759a$var$sleep(2000);
                    if (done) return;
                    currentNonceValue = await getCurrentNonceValue();
                    if (done) return;
                }
            })();
        });
        const { abortConfirmation: abortConfirmation, confirmationPromise: confirmationPromise } = this.getTransactionConfirmationPromise({
            commitment: commitment,
            signature: signature
        });
        const cancellationPromise = this.getCancellationPromise(abortSignal);
        let result;
        try {
            const outcome = await Promise.race([
                cancellationPromise,
                confirmationPromise,
                expiryPromise
            ]);
            if (outcome.__type === $c3af9e523501759a$export$7c391bd3b61d2374.PROCESSED) result = outcome.response;
            else {
                // Double check that the transaction is indeed unconfirmed.
                let signatureStatus;
                while(true // eslint-disable-line no-constant-condition
                ){
                    const status = await this.getSignatureStatus(signature);
                    if (status == null) break;
                    if (status.context.slot < (outcome.slotInWhichNonceDidAdvance ?? minContextSlot)) {
                        await $c3af9e523501759a$var$sleep(400);
                        continue;
                    }
                    signatureStatus = status;
                    break;
                }
                if (signatureStatus?.value) {
                    const commitmentForStatus = commitment || "finalized";
                    const { confirmationStatus: confirmationStatus } = signatureStatus.value;
                    switch(commitmentForStatus){
                        case "processed":
                        case "recent":
                            if (confirmationStatus !== "processed" && confirmationStatus !== "confirmed" && confirmationStatus !== "finalized") throw new $c3af9e523501759a$export$a3e7565a95f5a1e5(signature);
                            break;
                        case "confirmed":
                        case "single":
                        case "singleGossip":
                            if (confirmationStatus !== "confirmed" && confirmationStatus !== "finalized") throw new $c3af9e523501759a$export$a3e7565a95f5a1e5(signature);
                            break;
                        case "finalized":
                        case "max":
                        case "root":
                            if (confirmationStatus !== "finalized") throw new $c3af9e523501759a$export$a3e7565a95f5a1e5(signature);
                            break;
                        default:
                            // Exhaustive switch.
                            // eslint-disable-next-line @typescript-eslint/no-unused-vars
                            ((_)=>{})(commitmentForStatus);
                    }
                    result = {
                        context: signatureStatus.context,
                        value: {
                            err: signatureStatus.value.err
                        }
                    };
                } else throw new $c3af9e523501759a$export$a3e7565a95f5a1e5(signature);
            }
        } finally{
            done = true;
            abortConfirmation();
        }
        return result;
    }
    async confirmTransactionUsingLegacyTimeoutStrategy({ commitment: commitment, signature: signature }) {
        let timeoutId;
        const expiryPromise = new Promise((resolve)=>{
            let timeoutMs = this._confirmTransactionInitialTimeout || 60000;
            switch(commitment){
                case "processed":
                case "recent":
                case "single":
                case "confirmed":
                case "singleGossip":
                    timeoutMs = this._confirmTransactionInitialTimeout || 30000;
                    break;
            }
            timeoutId = setTimeout(()=>resolve({
                    __type: $c3af9e523501759a$export$7c391bd3b61d2374.TIMED_OUT,
                    timeoutMs: timeoutMs
                }), timeoutMs);
        });
        const { abortConfirmation: abortConfirmation, confirmationPromise: confirmationPromise } = this.getTransactionConfirmationPromise({
            commitment: commitment,
            signature: signature
        });
        let result;
        try {
            const outcome = await Promise.race([
                confirmationPromise,
                expiryPromise
            ]);
            if (outcome.__type === $c3af9e523501759a$export$7c391bd3b61d2374.PROCESSED) result = outcome.response;
            else throw new $c3af9e523501759a$export$b822204c22e46bdf(signature, outcome.timeoutMs / 1000);
        } finally{
            clearTimeout(timeoutId);
            abortConfirmation();
        }
        return result;
    }
    /**
   * Return the list of nodes that are currently participating in the cluster
   */ async getClusterNodes() {
        const unsafeRes = await this._rpcRequest("getClusterNodes", []);
        const res = (0, $kZFCD.create)(unsafeRes, $c3af9e523501759a$var$jsonRpcResult((0, $kZFCD.array)($c3af9e523501759a$var$ContactInfoResult)));
        if ("error" in res) throw new $c3af9e523501759a$export$ea1b1a1bba5c14ad(res.error, "failed to get cluster nodes");
        return res.result;
    }
    /**
   * Return the list of nodes that are currently participating in the cluster
   */ async getVoteAccounts(commitment) {
        const args = this._buildArgs([], commitment);
        const unsafeRes = await this._rpcRequest("getVoteAccounts", args);
        const res = (0, $kZFCD.create)(unsafeRes, $c3af9e523501759a$var$GetVoteAccounts);
        if ("error" in res) throw new $c3af9e523501759a$export$ea1b1a1bba5c14ad(res.error, "failed to get vote accounts");
        return res.result;
    }
    /**
   * Fetch the current slot that the node is processing
   */ async getSlot(commitmentOrConfig) {
        const { commitment: commitment, config: config } = $c3af9e523501759a$var$extractCommitmentFromConfig(commitmentOrConfig);
        const args = this._buildArgs([], commitment, undefined /* encoding */ , config);
        const unsafeRes = await this._rpcRequest("getSlot", args);
        const res = (0, $kZFCD.create)(unsafeRes, $c3af9e523501759a$var$jsonRpcResult((0, $kZFCD.number)()));
        if ("error" in res) throw new $c3af9e523501759a$export$ea1b1a1bba5c14ad(res.error, "failed to get slot");
        return res.result;
    }
    /**
   * Fetch the current slot leader of the cluster
   */ async getSlotLeader(commitmentOrConfig) {
        const { commitment: commitment, config: config } = $c3af9e523501759a$var$extractCommitmentFromConfig(commitmentOrConfig);
        const args = this._buildArgs([], commitment, undefined /* encoding */ , config);
        const unsafeRes = await this._rpcRequest("getSlotLeader", args);
        const res = (0, $kZFCD.create)(unsafeRes, $c3af9e523501759a$var$jsonRpcResult((0, $kZFCD.string)()));
        if ("error" in res) throw new $c3af9e523501759a$export$ea1b1a1bba5c14ad(res.error, "failed to get slot leader");
        return res.result;
    }
    /**
   * Fetch `limit` number of slot leaders starting from `startSlot`
   *
   * @param startSlot fetch slot leaders starting from this slot
   * @param limit number of slot leaders to return
   */ async getSlotLeaders(startSlot, limit) {
        const args = [
            startSlot,
            limit
        ];
        const unsafeRes = await this._rpcRequest("getSlotLeaders", args);
        const res = (0, $kZFCD.create)(unsafeRes, $c3af9e523501759a$var$jsonRpcResult((0, $kZFCD.array)($c3af9e523501759a$var$PublicKeyFromString)));
        if ("error" in res) throw new $c3af9e523501759a$export$ea1b1a1bba5c14ad(res.error, "failed to get slot leaders");
        return res.result;
    }
    /**
   * Fetch the current status of a signature
   */ async getSignatureStatus(signature, config) {
        const { context: context, value: values } = await this.getSignatureStatuses([
            signature
        ], config);
        $c3af9e523501759a$var$assert(values.length === 1);
        const value = values[0];
        return {
            context: context,
            value: value
        };
    }
    /**
   * Fetch the current statuses of a batch of signatures
   */ async getSignatureStatuses(signatures, config) {
        const params = [
            signatures
        ];
        if (config) params.push(config);
        const unsafeRes = await this._rpcRequest("getSignatureStatuses", params);
        const res = (0, $kZFCD.create)(unsafeRes, $c3af9e523501759a$var$GetSignatureStatusesRpcResult);
        if ("error" in res) throw new $c3af9e523501759a$export$ea1b1a1bba5c14ad(res.error, "failed to get signature status");
        return res.result;
    }
    /**
   * Fetch the current transaction count of the cluster
   */ async getTransactionCount(commitmentOrConfig) {
        const { commitment: commitment, config: config } = $c3af9e523501759a$var$extractCommitmentFromConfig(commitmentOrConfig);
        const args = this._buildArgs([], commitment, undefined /* encoding */ , config);
        const unsafeRes = await this._rpcRequest("getTransactionCount", args);
        const res = (0, $kZFCD.create)(unsafeRes, $c3af9e523501759a$var$jsonRpcResult((0, $kZFCD.number)()));
        if ("error" in res) throw new $c3af9e523501759a$export$ea1b1a1bba5c14ad(res.error, "failed to get transaction count");
        return res.result;
    }
    /**
   * Fetch the current total currency supply of the cluster in lamports
   *
   * @deprecated Deprecated since v1.2.8. Please use {@link getSupply} instead.
   */ async getTotalSupply(commitment) {
        const result = await this.getSupply({
            commitment: commitment,
            excludeNonCirculatingAccountsList: true
        });
        return result.value.total;
    }
    /**
   * Fetch the cluster InflationGovernor parameters
   */ async getInflationGovernor(commitment) {
        const args = this._buildArgs([], commitment);
        const unsafeRes = await this._rpcRequest("getInflationGovernor", args);
        const res = (0, $kZFCD.create)(unsafeRes, $c3af9e523501759a$var$GetInflationGovernorRpcResult);
        if ("error" in res) throw new $c3af9e523501759a$export$ea1b1a1bba5c14ad(res.error, "failed to get inflation");
        return res.result;
    }
    /**
   * Fetch the inflation reward for a list of addresses for an epoch
   */ async getInflationReward(addresses, epoch, commitmentOrConfig) {
        const { commitment: commitment, config: config } = $c3af9e523501759a$var$extractCommitmentFromConfig(commitmentOrConfig);
        const args = this._buildArgs([
            addresses.map((pubkey)=>pubkey.toBase58())
        ], commitment, undefined /* encoding */ , {
            ...config,
            epoch: epoch != null ? epoch : config?.epoch
        });
        const unsafeRes = await this._rpcRequest("getInflationReward", args);
        const res = (0, $kZFCD.create)(unsafeRes, $c3af9e523501759a$var$GetInflationRewardResult);
        if ("error" in res) throw new $c3af9e523501759a$export$ea1b1a1bba5c14ad(res.error, "failed to get inflation reward");
        return res.result;
    }
    /**
   * Fetch the specific inflation values for the current epoch
   */ async getInflationRate() {
        const unsafeRes = await this._rpcRequest("getInflationRate", []);
        const res = (0, $kZFCD.create)(unsafeRes, $c3af9e523501759a$var$GetInflationRateRpcResult);
        if ("error" in res) throw new $c3af9e523501759a$export$ea1b1a1bba5c14ad(res.error, "failed to get inflation rate");
        return res.result;
    }
    /**
   * Fetch the Epoch Info parameters
   */ async getEpochInfo(commitmentOrConfig) {
        const { commitment: commitment, config: config } = $c3af9e523501759a$var$extractCommitmentFromConfig(commitmentOrConfig);
        const args = this._buildArgs([], commitment, undefined /* encoding */ , config);
        const unsafeRes = await this._rpcRequest("getEpochInfo", args);
        const res = (0, $kZFCD.create)(unsafeRes, $c3af9e523501759a$var$GetEpochInfoRpcResult);
        if ("error" in res) throw new $c3af9e523501759a$export$ea1b1a1bba5c14ad(res.error, "failed to get epoch info");
        return res.result;
    }
    /**
   * Fetch the Epoch Schedule parameters
   */ async getEpochSchedule() {
        const unsafeRes = await this._rpcRequest("getEpochSchedule", []);
        const res = (0, $kZFCD.create)(unsafeRes, $c3af9e523501759a$var$GetEpochScheduleRpcResult);
        if ("error" in res) throw new $c3af9e523501759a$export$ea1b1a1bba5c14ad(res.error, "failed to get epoch schedule");
        const epochSchedule = res.result;
        return new $c3af9e523501759a$export$df8ed3e830b1d591(epochSchedule.slotsPerEpoch, epochSchedule.leaderScheduleSlotOffset, epochSchedule.warmup, epochSchedule.firstNormalEpoch, epochSchedule.firstNormalSlot);
    }
    /**
   * Fetch the leader schedule for the current epoch
   * @return {Promise<RpcResponseAndContext<LeaderSchedule>>}
   */ async getLeaderSchedule() {
        const unsafeRes = await this._rpcRequest("getLeaderSchedule", []);
        const res = (0, $kZFCD.create)(unsafeRes, $c3af9e523501759a$var$GetLeaderScheduleRpcResult);
        if ("error" in res) throw new $c3af9e523501759a$export$ea1b1a1bba5c14ad(res.error, "failed to get leader schedule");
        return res.result;
    }
    /**
   * Fetch the minimum balance needed to exempt an account of `dataLength`
   * size from rent
   */ async getMinimumBalanceForRentExemption(dataLength, commitment) {
        const args = this._buildArgs([
            dataLength
        ], commitment);
        const unsafeRes = await this._rpcRequest("getMinimumBalanceForRentExemption", args);
        const res = (0, $kZFCD.create)(unsafeRes, $c3af9e523501759a$var$GetMinimumBalanceForRentExemptionRpcResult);
        if ("error" in res) {
            console.warn("Unable to fetch minimum balance for rent exemption");
            return 0;
        }
        return res.result;
    }
    /**
   * Fetch a recent blockhash from the cluster, return with context
   * @return {Promise<RpcResponseAndContext<{blockhash: Blockhash, feeCalculator: FeeCalculator}>>}
   *
   * @deprecated Deprecated since Solana v1.8.0. Please use {@link getLatestBlockhash} instead.
   */ async getRecentBlockhashAndContext(commitment) {
        const args = this._buildArgs([], commitment);
        const unsafeRes = await this._rpcRequest("getRecentBlockhash", args);
        const res = (0, $kZFCD.create)(unsafeRes, $c3af9e523501759a$var$GetRecentBlockhashAndContextRpcResult);
        if ("error" in res) throw new $c3af9e523501759a$export$ea1b1a1bba5c14ad(res.error, "failed to get recent blockhash");
        return res.result;
    }
    /**
   * Fetch recent performance samples
   * @return {Promise<Array<PerfSample>>}
   */ async getRecentPerformanceSamples(limit) {
        const unsafeRes = await this._rpcRequest("getRecentPerformanceSamples", limit ? [
            limit
        ] : []);
        const res = (0, $kZFCD.create)(unsafeRes, $c3af9e523501759a$var$GetRecentPerformanceSamplesRpcResult);
        if ("error" in res) throw new $c3af9e523501759a$export$ea1b1a1bba5c14ad(res.error, "failed to get recent performance samples");
        return res.result;
    }
    /**
   * Fetch the fee calculator for a recent blockhash from the cluster, return with context
   *
   * @deprecated Deprecated since Solana v1.8.0. Please use {@link getFeeForMessage} instead.
   */ async getFeeCalculatorForBlockhash(blockhash, commitment) {
        const args = this._buildArgs([
            blockhash
        ], commitment);
        const unsafeRes = await this._rpcRequest("getFeeCalculatorForBlockhash", args);
        const res = (0, $kZFCD.create)(unsafeRes, $c3af9e523501759a$var$GetFeeCalculatorRpcResult);
        if ("error" in res) throw new $c3af9e523501759a$export$ea1b1a1bba5c14ad(res.error, "failed to get fee calculator");
        const { context: context, value: value } = res.result;
        return {
            context: context,
            value: value !== null ? value.feeCalculator : null
        };
    }
    /**
   * Fetch the fee for a message from the cluster, return with context
   */ async getFeeForMessage(message, commitment) {
        const wireMessage = $c3af9e523501759a$var$toBuffer(message.serialize()).toString("base64");
        const args = this._buildArgs([
            wireMessage
        ], commitment);
        const unsafeRes = await this._rpcRequest("getFeeForMessage", args);
        const res = (0, $kZFCD.create)(unsafeRes, $c3af9e523501759a$var$jsonRpcResultAndContext((0, $kZFCD.nullable)((0, $kZFCD.number)())));
        if ("error" in res) throw new $c3af9e523501759a$export$ea1b1a1bba5c14ad(res.error, "failed to get fee for message");
        if (res.result === null) throw new Error("invalid blockhash");
        return res.result;
    }
    /**
   * Fetch a list of prioritization fees from recent blocks.
   */ async getRecentPrioritizationFees(config) {
        const accounts = config?.lockedWritableAccounts?.map((key)=>key.toBase58());
        const args = accounts?.length ? [
            accounts
        ] : [];
        const unsafeRes = await this._rpcRequest("getRecentPrioritizationFees", args);
        const res = (0, $kZFCD.create)(unsafeRes, $c3af9e523501759a$var$GetRecentPrioritizationFeesRpcResult);
        if ("error" in res) throw new $c3af9e523501759a$export$ea1b1a1bba5c14ad(res.error, "failed to get recent prioritization fees");
        return res.result;
    }
    /**
   * Fetch a recent blockhash from the cluster
   * @return {Promise<{blockhash: Blockhash, feeCalculator: FeeCalculator}>}
   *
   * @deprecated Deprecated since Solana v1.8.0. Please use {@link getLatestBlockhash} instead.
   */ async getRecentBlockhash(commitment) {
        try {
            const res = await this.getRecentBlockhashAndContext(commitment);
            return res.value;
        } catch (e) {
            throw new Error("failed to get recent blockhash: " + e);
        }
    }
    /**
   * Fetch the latest blockhash from the cluster
   * @return {Promise<BlockhashWithExpiryBlockHeight>}
   */ async getLatestBlockhash(commitmentOrConfig) {
        try {
            const res = await this.getLatestBlockhashAndContext(commitmentOrConfig);
            return res.value;
        } catch (e) {
            throw new Error("failed to get recent blockhash: " + e);
        }
    }
    /**
   * Fetch the latest blockhash from the cluster
   * @return {Promise<BlockhashWithExpiryBlockHeight>}
   */ async getLatestBlockhashAndContext(commitmentOrConfig) {
        const { commitment: commitment, config: config } = $c3af9e523501759a$var$extractCommitmentFromConfig(commitmentOrConfig);
        const args = this._buildArgs([], commitment, undefined /* encoding */ , config);
        const unsafeRes = await this._rpcRequest("getLatestBlockhash", args);
        const res = (0, $kZFCD.create)(unsafeRes, $c3af9e523501759a$var$GetLatestBlockhashRpcResult);
        if ("error" in res) throw new $c3af9e523501759a$export$ea1b1a1bba5c14ad(res.error, "failed to get latest blockhash");
        return res.result;
    }
    /**
   * Returns whether a blockhash is still valid or not
   */ async isBlockhashValid(blockhash, rawConfig) {
        const { commitment: commitment, config: config } = $c3af9e523501759a$var$extractCommitmentFromConfig(rawConfig);
        const args = this._buildArgs([
            blockhash
        ], commitment, undefined /* encoding */ , config);
        const unsafeRes = await this._rpcRequest("isBlockhashValid", args);
        const res = (0, $kZFCD.create)(unsafeRes, $c3af9e523501759a$var$IsBlockhashValidRpcResult);
        if ("error" in res) throw new $c3af9e523501759a$export$ea1b1a1bba5c14ad(res.error, "failed to determine if the blockhash `" + blockhash + "`is valid");
        return res.result;
    }
    /**
   * Fetch the node version
   */ async getVersion() {
        const unsafeRes = await this._rpcRequest("getVersion", []);
        const res = (0, $kZFCD.create)(unsafeRes, $c3af9e523501759a$var$jsonRpcResult($c3af9e523501759a$var$VersionResult));
        if ("error" in res) throw new $c3af9e523501759a$export$ea1b1a1bba5c14ad(res.error, "failed to get version");
        return res.result;
    }
    /**
   * Fetch the genesis hash
   */ async getGenesisHash() {
        const unsafeRes = await this._rpcRequest("getGenesisHash", []);
        const res = (0, $kZFCD.create)(unsafeRes, $c3af9e523501759a$var$jsonRpcResult((0, $kZFCD.string)()));
        if ("error" in res) throw new $c3af9e523501759a$export$ea1b1a1bba5c14ad(res.error, "failed to get genesis hash");
        return res.result;
    }
    /**
   * Fetch a processed block from the cluster.
   *
   * @deprecated Instead, call `getBlock` using a `GetVersionedBlockConfig` by
   * setting the `maxSupportedTransactionVersion` property.
   */ /**
   * @deprecated Instead, call `getBlock` using a `GetVersionedBlockConfig` by
   * setting the `maxSupportedTransactionVersion` property.
   */ // eslint-disable-next-line no-dupe-class-members
    /**
   * @deprecated Instead, call `getBlock` using a `GetVersionedBlockConfig` by
   * setting the `maxSupportedTransactionVersion` property.
   */ // eslint-disable-next-line no-dupe-class-members
    /**
   * Fetch a processed block from the cluster.
   */ // eslint-disable-next-line no-dupe-class-members
    // eslint-disable-next-line no-dupe-class-members
    // eslint-disable-next-line no-dupe-class-members
    /**
   * Fetch a processed block from the cluster.
   */ // eslint-disable-next-line no-dupe-class-members
    async getBlock(slot, rawConfig) {
        const { commitment: commitment, config: config } = $c3af9e523501759a$var$extractCommitmentFromConfig(rawConfig);
        const args = this._buildArgsAtLeastConfirmed([
            slot
        ], commitment, undefined /* encoding */ , config);
        const unsafeRes = await this._rpcRequest("getBlock", args);
        try {
            switch(config?.transactionDetails){
                case "accounts":
                    {
                        const res = (0, $kZFCD.create)(unsafeRes, $c3af9e523501759a$var$GetAccountsModeBlockRpcResult);
                        if ("error" in res) throw res.error;
                        return res.result;
                    }
                case "none":
                    {
                        const res = (0, $kZFCD.create)(unsafeRes, $c3af9e523501759a$var$GetNoneModeBlockRpcResult);
                        if ("error" in res) throw res.error;
                        return res.result;
                    }
                default:
                    {
                        const res = (0, $kZFCD.create)(unsafeRes, $c3af9e523501759a$var$GetBlockRpcResult);
                        if ("error" in res) throw res.error;
                        const { result: result } = res;
                        return result ? {
                            ...result,
                            transactions: result.transactions.map(({ transaction: transaction, meta: meta, version: version })=>({
                                    meta: meta,
                                    transaction: {
                                        ...transaction,
                                        message: $c3af9e523501759a$var$versionedMessageFromResponse(version, transaction.message)
                                    },
                                    version: version
                                }))
                        } : null;
                    }
            }
        } catch (e) {
            throw new $c3af9e523501759a$export$ea1b1a1bba5c14ad(e, "failed to get confirmed block");
        }
    }
    /**
   * Fetch parsed transaction details for a confirmed or finalized block
   */ // eslint-disable-next-line no-dupe-class-members
    // eslint-disable-next-line no-dupe-class-members
    // eslint-disable-next-line no-dupe-class-members
    async getParsedBlock(slot, rawConfig) {
        const { commitment: commitment, config: config } = $c3af9e523501759a$var$extractCommitmentFromConfig(rawConfig);
        const args = this._buildArgsAtLeastConfirmed([
            slot
        ], commitment, "jsonParsed", config);
        const unsafeRes = await this._rpcRequest("getBlock", args);
        try {
            switch(config?.transactionDetails){
                case "accounts":
                    {
                        const res = (0, $kZFCD.create)(unsafeRes, $c3af9e523501759a$var$GetParsedAccountsModeBlockRpcResult);
                        if ("error" in res) throw res.error;
                        return res.result;
                    }
                case "none":
                    {
                        const res = (0, $kZFCD.create)(unsafeRes, $c3af9e523501759a$var$GetParsedNoneModeBlockRpcResult);
                        if ("error" in res) throw res.error;
                        return res.result;
                    }
                default:
                    {
                        const res = (0, $kZFCD.create)(unsafeRes, $c3af9e523501759a$var$GetParsedBlockRpcResult);
                        if ("error" in res) throw res.error;
                        return res.result;
                    }
            }
        } catch (e) {
            throw new $c3af9e523501759a$export$ea1b1a1bba5c14ad(e, "failed to get block");
        }
    }
    /*
   * Returns recent block production information from the current or previous epoch
   */ async getBlockProduction(configOrCommitment) {
        let extra;
        let commitment;
        if (typeof configOrCommitment === "string") commitment = configOrCommitment;
        else if (configOrCommitment) {
            const { commitment: c, ...rest } = configOrCommitment;
            commitment = c;
            extra = rest;
        }
        const args = this._buildArgs([], commitment, "base64", extra);
        const unsafeRes = await this._rpcRequest("getBlockProduction", args);
        const res = (0, $kZFCD.create)(unsafeRes, $c3af9e523501759a$var$BlockProductionResponseStruct);
        if ("error" in res) throw new $c3af9e523501759a$export$ea1b1a1bba5c14ad(res.error, "failed to get block production information");
        return res.result;
    }
    /**
   * Fetch a confirmed or finalized transaction from the cluster.
   *
   * @deprecated Instead, call `getTransaction` using a
   * `GetVersionedTransactionConfig` by setting the
   * `maxSupportedTransactionVersion` property.
   */ /**
   * Fetch a confirmed or finalized transaction from the cluster.
   */ // eslint-disable-next-line no-dupe-class-members
    /**
   * Fetch a confirmed or finalized transaction from the cluster.
   */ // eslint-disable-next-line no-dupe-class-members
    async getTransaction(signature, rawConfig) {
        const { commitment: commitment, config: config } = $c3af9e523501759a$var$extractCommitmentFromConfig(rawConfig);
        const args = this._buildArgsAtLeastConfirmed([
            signature
        ], commitment, undefined /* encoding */ , config);
        const unsafeRes = await this._rpcRequest("getTransaction", args);
        const res = (0, $kZFCD.create)(unsafeRes, $c3af9e523501759a$var$GetTransactionRpcResult);
        if ("error" in res) throw new $c3af9e523501759a$export$ea1b1a1bba5c14ad(res.error, "failed to get transaction");
        const result = res.result;
        if (!result) return result;
        return {
            ...result,
            transaction: {
                ...result.transaction,
                message: $c3af9e523501759a$var$versionedMessageFromResponse(result.version, result.transaction.message)
            }
        };
    }
    /**
   * Fetch parsed transaction details for a confirmed or finalized transaction
   */ async getParsedTransaction(signature, commitmentOrConfig) {
        const { commitment: commitment, config: config } = $c3af9e523501759a$var$extractCommitmentFromConfig(commitmentOrConfig);
        const args = this._buildArgsAtLeastConfirmed([
            signature
        ], commitment, "jsonParsed", config);
        const unsafeRes = await this._rpcRequest("getTransaction", args);
        const res = (0, $kZFCD.create)(unsafeRes, $c3af9e523501759a$var$GetParsedTransactionRpcResult);
        if ("error" in res) throw new $c3af9e523501759a$export$ea1b1a1bba5c14ad(res.error, "failed to get transaction");
        return res.result;
    }
    /**
   * Fetch parsed transaction details for a batch of confirmed transactions
   */ async getParsedTransactions(signatures, commitmentOrConfig) {
        const { commitment: commitment, config: config } = $c3af9e523501759a$var$extractCommitmentFromConfig(commitmentOrConfig);
        const batch = signatures.map((signature)=>{
            const args = this._buildArgsAtLeastConfirmed([
                signature
            ], commitment, "jsonParsed", config);
            return {
                methodName: "getTransaction",
                args: args
            };
        });
        const unsafeRes = await this._rpcBatchRequest(batch);
        const res = unsafeRes.map((unsafeRes)=>{
            const res = (0, $kZFCD.create)(unsafeRes, $c3af9e523501759a$var$GetParsedTransactionRpcResult);
            if ("error" in res) throw new $c3af9e523501759a$export$ea1b1a1bba5c14ad(res.error, "failed to get transactions");
            return res.result;
        });
        return res;
    }
    /**
   * Fetch transaction details for a batch of confirmed transactions.
   * Similar to {@link getParsedTransactions} but returns a {@link TransactionResponse}.
   *
   * @deprecated Instead, call `getTransactions` using a
   * `GetVersionedTransactionConfig` by setting the
   * `maxSupportedTransactionVersion` property.
   */ /**
   * Fetch transaction details for a batch of confirmed transactions.
   * Similar to {@link getParsedTransactions} but returns a {@link
   * VersionedTransactionResponse}.
   */ // eslint-disable-next-line no-dupe-class-members
    /**
   * Fetch transaction details for a batch of confirmed transactions.
   * Similar to {@link getParsedTransactions} but returns a {@link
   * VersionedTransactionResponse}.
   */ // eslint-disable-next-line no-dupe-class-members
    async getTransactions(signatures, commitmentOrConfig) {
        const { commitment: commitment, config: config } = $c3af9e523501759a$var$extractCommitmentFromConfig(commitmentOrConfig);
        const batch = signatures.map((signature)=>{
            const args = this._buildArgsAtLeastConfirmed([
                signature
            ], commitment, undefined /* encoding */ , config);
            return {
                methodName: "getTransaction",
                args: args
            };
        });
        const unsafeRes = await this._rpcBatchRequest(batch);
        const res = unsafeRes.map((unsafeRes)=>{
            const res = (0, $kZFCD.create)(unsafeRes, $c3af9e523501759a$var$GetTransactionRpcResult);
            if ("error" in res) throw new $c3af9e523501759a$export$ea1b1a1bba5c14ad(res.error, "failed to get transactions");
            const result = res.result;
            if (!result) return result;
            return {
                ...result,
                transaction: {
                    ...result.transaction,
                    message: $c3af9e523501759a$var$versionedMessageFromResponse(result.version, result.transaction.message)
                }
            };
        });
        return res;
    }
    /**
   * Fetch a list of Transactions and transaction statuses from the cluster
   * for a confirmed block.
   *
   * @deprecated Deprecated since v1.13.0. Please use {@link getBlock} instead.
   */ async getConfirmedBlock(slot, commitment) {
        const args = this._buildArgsAtLeastConfirmed([
            slot
        ], commitment);
        const unsafeRes = await this._rpcRequest("getConfirmedBlock", args);
        const res = (0, $kZFCD.create)(unsafeRes, $c3af9e523501759a$var$GetConfirmedBlockRpcResult);
        if ("error" in res) throw new $c3af9e523501759a$export$ea1b1a1bba5c14ad(res.error, "failed to get confirmed block");
        const result = res.result;
        if (!result) throw new Error("Confirmed block " + slot + " not found");
        const block = {
            ...result,
            transactions: result.transactions.map(({ transaction: transaction, meta: meta })=>{
                const message = new $c3af9e523501759a$export$f69c19e57285b83a(transaction.message);
                return {
                    meta: meta,
                    transaction: {
                        ...transaction,
                        message: message
                    }
                };
            })
        };
        return {
            ...block,
            transactions: block.transactions.map(({ transaction: transaction, meta: meta })=>{
                return {
                    meta: meta,
                    transaction: $c3af9e523501759a$export$febc5573c75cefb0.populate(transaction.message, transaction.signatures)
                };
            })
        };
    }
    /**
   * Fetch confirmed blocks between two slots
   */ async getBlocks(startSlot, endSlot, commitment) {
        const args = this._buildArgsAtLeastConfirmed(endSlot !== undefined ? [
            startSlot,
            endSlot
        ] : [
            startSlot
        ], commitment);
        const unsafeRes = await this._rpcRequest("getBlocks", args);
        const res = (0, $kZFCD.create)(unsafeRes, $c3af9e523501759a$var$jsonRpcResult((0, $kZFCD.array)((0, $kZFCD.number)())));
        if ("error" in res) throw new $c3af9e523501759a$export$ea1b1a1bba5c14ad(res.error, "failed to get blocks");
        return res.result;
    }
    /**
   * Fetch a list of Signatures from the cluster for a block, excluding rewards
   */ async getBlockSignatures(slot, commitment) {
        const args = this._buildArgsAtLeastConfirmed([
            slot
        ], commitment, undefined, {
            transactionDetails: "signatures",
            rewards: false
        });
        const unsafeRes = await this._rpcRequest("getBlock", args);
        const res = (0, $kZFCD.create)(unsafeRes, $c3af9e523501759a$var$GetBlockSignaturesRpcResult);
        if ("error" in res) throw new $c3af9e523501759a$export$ea1b1a1bba5c14ad(res.error, "failed to get block");
        const result = res.result;
        if (!result) throw new Error("Block " + slot + " not found");
        return result;
    }
    /**
   * Fetch a list of Signatures from the cluster for a confirmed block, excluding rewards
   *
   * @deprecated Deprecated since Solana v1.8.0. Please use {@link getBlockSignatures} instead.
   */ async getConfirmedBlockSignatures(slot, commitment) {
        const args = this._buildArgsAtLeastConfirmed([
            slot
        ], commitment, undefined, {
            transactionDetails: "signatures",
            rewards: false
        });
        const unsafeRes = await this._rpcRequest("getConfirmedBlock", args);
        const res = (0, $kZFCD.create)(unsafeRes, $c3af9e523501759a$var$GetBlockSignaturesRpcResult);
        if ("error" in res) throw new $c3af9e523501759a$export$ea1b1a1bba5c14ad(res.error, "failed to get confirmed block");
        const result = res.result;
        if (!result) throw new Error("Confirmed block " + slot + " not found");
        return result;
    }
    /**
   * Fetch a transaction details for a confirmed transaction
   *
   * @deprecated Deprecated since Solana v1.8.0. Please use {@link getTransaction} instead.
   */ async getConfirmedTransaction(signature, commitment) {
        const args = this._buildArgsAtLeastConfirmed([
            signature
        ], commitment);
        const unsafeRes = await this._rpcRequest("getConfirmedTransaction", args);
        const res = (0, $kZFCD.create)(unsafeRes, $c3af9e523501759a$var$GetTransactionRpcResult);
        if ("error" in res) throw new $c3af9e523501759a$export$ea1b1a1bba5c14ad(res.error, "failed to get transaction");
        const result = res.result;
        if (!result) return result;
        const message = new $c3af9e523501759a$export$f69c19e57285b83a(result.transaction.message);
        const signatures = result.transaction.signatures;
        return {
            ...result,
            transaction: $c3af9e523501759a$export$febc5573c75cefb0.populate(message, signatures)
        };
    }
    /**
   * Fetch parsed transaction details for a confirmed transaction
   *
   * @deprecated Deprecated since Solana v1.8.0. Please use {@link getParsedTransaction} instead.
   */ async getParsedConfirmedTransaction(signature, commitment) {
        const args = this._buildArgsAtLeastConfirmed([
            signature
        ], commitment, "jsonParsed");
        const unsafeRes = await this._rpcRequest("getConfirmedTransaction", args);
        const res = (0, $kZFCD.create)(unsafeRes, $c3af9e523501759a$var$GetParsedTransactionRpcResult);
        if ("error" in res) throw new $c3af9e523501759a$export$ea1b1a1bba5c14ad(res.error, "failed to get confirmed transaction");
        return res.result;
    }
    /**
   * Fetch parsed transaction details for a batch of confirmed transactions
   *
   * @deprecated Deprecated since Solana v1.8.0. Please use {@link getParsedTransactions} instead.
   */ async getParsedConfirmedTransactions(signatures, commitment) {
        const batch = signatures.map((signature)=>{
            const args = this._buildArgsAtLeastConfirmed([
                signature
            ], commitment, "jsonParsed");
            return {
                methodName: "getConfirmedTransaction",
                args: args
            };
        });
        const unsafeRes = await this._rpcBatchRequest(batch);
        const res = unsafeRes.map((unsafeRes)=>{
            const res = (0, $kZFCD.create)(unsafeRes, $c3af9e523501759a$var$GetParsedTransactionRpcResult);
            if ("error" in res) throw new $c3af9e523501759a$export$ea1b1a1bba5c14ad(res.error, "failed to get confirmed transactions");
            return res.result;
        });
        return res;
    }
    /**
   * Fetch a list of all the confirmed signatures for transactions involving an address
   * within a specified slot range. Max range allowed is 10,000 slots.
   *
   * @deprecated Deprecated since v1.3. Please use {@link getConfirmedSignaturesForAddress2} instead.
   *
   * @param address queried address
   * @param startSlot start slot, inclusive
   * @param endSlot end slot, inclusive
   */ async getConfirmedSignaturesForAddress(address, startSlot, endSlot) {
        let options = {};
        let firstAvailableBlock = await this.getFirstAvailableBlock();
        while(!("until" in options)){
            startSlot--;
            if (startSlot <= 0 || startSlot < firstAvailableBlock) break;
            try {
                const block = await this.getConfirmedBlockSignatures(startSlot, "finalized");
                if (block.signatures.length > 0) options.until = block.signatures[block.signatures.length - 1].toString();
            } catch (err) {
                if (err instanceof Error && err.message.includes("skipped")) continue;
                else throw err;
            }
        }
        let highestConfirmedRoot = await this.getSlot("finalized");
        while(!("before" in options)){
            endSlot++;
            if (endSlot > highestConfirmedRoot) break;
            try {
                const block = await this.getConfirmedBlockSignatures(endSlot);
                if (block.signatures.length > 0) options.before = block.signatures[block.signatures.length - 1].toString();
            } catch (err) {
                if (err instanceof Error && err.message.includes("skipped")) continue;
                else throw err;
            }
        }
        const confirmedSignatureInfo = await this.getConfirmedSignaturesForAddress2(address, options);
        return confirmedSignatureInfo.map((info)=>info.signature);
    }
    /**
   * Returns confirmed signatures for transactions involving an
   * address backwards in time from the provided signature or most recent confirmed block
   *
   *
   * @param address queried address
   * @param options
   */ async getConfirmedSignaturesForAddress2(address, options, commitment) {
        const args = this._buildArgsAtLeastConfirmed([
            address.toBase58()
        ], commitment, undefined, options);
        const unsafeRes = await this._rpcRequest("getConfirmedSignaturesForAddress2", args);
        const res = (0, $kZFCD.create)(unsafeRes, $c3af9e523501759a$var$GetConfirmedSignaturesForAddress2RpcResult);
        if ("error" in res) throw new $c3af9e523501759a$export$ea1b1a1bba5c14ad(res.error, "failed to get confirmed signatures for address");
        return res.result;
    }
    /**
   * Returns confirmed signatures for transactions involving an
   * address backwards in time from the provided signature or most recent confirmed block
   *
   *
   * @param address queried address
   * @param options
   */ async getSignaturesForAddress(address, options, commitment) {
        const args = this._buildArgsAtLeastConfirmed([
            address.toBase58()
        ], commitment, undefined, options);
        const unsafeRes = await this._rpcRequest("getSignaturesForAddress", args);
        const res = (0, $kZFCD.create)(unsafeRes, $c3af9e523501759a$var$GetSignaturesForAddressRpcResult);
        if ("error" in res) throw new $c3af9e523501759a$export$ea1b1a1bba5c14ad(res.error, "failed to get signatures for address");
        return res.result;
    }
    async getAddressLookupTable(accountKey, config) {
        const { context: context, value: accountInfo } = await this.getAccountInfoAndContext(accountKey, config);
        let value = null;
        if (accountInfo !== null) value = new $c3af9e523501759a$export$5b2310da10e607da({
            key: accountKey,
            state: $c3af9e523501759a$export$5b2310da10e607da.deserialize(accountInfo.data)
        });
        return {
            context: context,
            value: value
        };
    }
    /**
   * Fetch the contents of a Nonce account from the cluster, return with context
   */ async getNonceAndContext(nonceAccount, commitmentOrConfig) {
        const { context: context, value: accountInfo } = await this.getAccountInfoAndContext(nonceAccount, commitmentOrConfig);
        let value = null;
        if (accountInfo !== null) value = $c3af9e523501759a$export$ed1c2356ce604759.fromAccountData(accountInfo.data);
        return {
            context: context,
            value: value
        };
    }
    /**
   * Fetch the contents of a Nonce account from the cluster
   */ async getNonce(nonceAccount, commitmentOrConfig) {
        return await this.getNonceAndContext(nonceAccount, commitmentOrConfig).then((x)=>x.value).catch((e)=>{
            throw new Error("failed to get nonce for account " + nonceAccount.toBase58() + ": " + e);
        });
    }
    /**
   * Request an allocation of lamports to the specified address
   *
   * ```typescript
   * import { Connection, PublicKey, LAMPORTS_PER_SOL } from "@solana/web3.js";
   *
   * (async () => {
   *   const connection = new Connection("https://api.testnet.solana.com", "confirmed");
   *   const myAddress = new PublicKey("2nr1bHFT86W9tGnyvmYW4vcHKsQB3sVQfnddasz4kExM");
   *   const signature = await connection.requestAirdrop(myAddress, LAMPORTS_PER_SOL);
   *   await connection.confirmTransaction(signature);
   * })();
   * ```
   */ async requestAirdrop(to, lamports) {
        const unsafeRes = await this._rpcRequest("requestAirdrop", [
            to.toBase58(),
            lamports
        ]);
        const res = (0, $kZFCD.create)(unsafeRes, $c3af9e523501759a$var$RequestAirdropRpcResult);
        if ("error" in res) throw new $c3af9e523501759a$export$ea1b1a1bba5c14ad(res.error, `airdrop to ${to.toBase58()} failed`);
        return res.result;
    }
    /**
   * @internal
   */ async _blockhashWithExpiryBlockHeight(disableCache) {
        if (!disableCache) {
            // Wait for polling to finish
            while(this._pollingBlockhash)await $c3af9e523501759a$var$sleep(100);
            const timeSinceFetch = Date.now() - this._blockhashInfo.lastFetch;
            const expired = timeSinceFetch >= $c3af9e523501759a$export$fcb705732fb5c597;
            if (this._blockhashInfo.latestBlockhash !== null && !expired) return this._blockhashInfo.latestBlockhash;
        }
        return await this._pollNewBlockhash();
    }
    /**
   * @internal
   */ async _pollNewBlockhash() {
        this._pollingBlockhash = true;
        try {
            const startTime = Date.now();
            const cachedLatestBlockhash = this._blockhashInfo.latestBlockhash;
            const cachedBlockhash = cachedLatestBlockhash ? cachedLatestBlockhash.blockhash : null;
            for(let i = 0; i < 50; i++){
                const latestBlockhash = await this.getLatestBlockhash("finalized");
                if (cachedBlockhash !== latestBlockhash.blockhash) {
                    this._blockhashInfo = {
                        latestBlockhash: latestBlockhash,
                        lastFetch: Date.now(),
                        transactionSignatures: [],
                        simulatedSignatures: []
                    };
                    return latestBlockhash;
                }
                // Sleep for approximately half a slot
                await $c3af9e523501759a$var$sleep($c3af9e523501759a$var$MS_PER_SLOT / 2);
            }
            throw new Error(`Unable to obtain a new blockhash after ${Date.now() - startTime}ms`);
        } finally{
            this._pollingBlockhash = false;
        }
    }
    /**
   * get the stake minimum delegation
   */ async getStakeMinimumDelegation(config) {
        const { commitment: commitment, config: configArg } = $c3af9e523501759a$var$extractCommitmentFromConfig(config);
        const args = this._buildArgs([], commitment, "base64", configArg);
        const unsafeRes = await this._rpcRequest("getStakeMinimumDelegation", args);
        const res = (0, $kZFCD.create)(unsafeRes, $c3af9e523501759a$var$jsonRpcResultAndContext((0, $kZFCD.number)()));
        if ("error" in res) throw new $c3af9e523501759a$export$ea1b1a1bba5c14ad(res.error, `failed to get stake minimum delegation`);
        return res.result;
    }
    /**
   * Simulate a transaction
   *
   * @deprecated Instead, call {@link simulateTransaction} with {@link
   * VersionedTransaction} and {@link SimulateTransactionConfig} parameters
   */ /**
   * Simulate a transaction
   */ // eslint-disable-next-line no-dupe-class-members
    /**
   * Simulate a transaction
   */ // eslint-disable-next-line no-dupe-class-members
    async simulateTransaction(transactionOrMessage, configOrSigners, includeAccounts) {
        if ("message" in transactionOrMessage) {
            const versionedTx = transactionOrMessage;
            const wireTransaction = versionedTx.serialize();
            const encodedTransaction = (0, $6ZWSX.Buffer).from(wireTransaction).toString("base64");
            if (Array.isArray(configOrSigners) || includeAccounts !== undefined) throw new Error("Invalid arguments");
            const config = configOrSigners || {};
            config.encoding = "base64";
            if (!("commitment" in config)) config.commitment = this.commitment;
            const args = [
                encodedTransaction,
                config
            ];
            const unsafeRes = await this._rpcRequest("simulateTransaction", args);
            const res = (0, $kZFCD.create)(unsafeRes, $c3af9e523501759a$var$SimulatedTransactionResponseStruct);
            if ("error" in res) throw new Error("failed to simulate transaction: " + res.error.message);
            return res.result;
        }
        let transaction;
        if (transactionOrMessage instanceof $c3af9e523501759a$export$febc5573c75cefb0) {
            let originalTx = transactionOrMessage;
            transaction = new $c3af9e523501759a$export$febc5573c75cefb0();
            transaction.feePayer = originalTx.feePayer;
            transaction.instructions = transactionOrMessage.instructions;
            transaction.nonceInfo = originalTx.nonceInfo;
            transaction.signatures = originalTx.signatures;
        } else {
            transaction = $c3af9e523501759a$export$febc5573c75cefb0.populate(transactionOrMessage);
            // HACK: this function relies on mutating the populated transaction
            transaction._message = transaction._json = undefined;
        }
        if (configOrSigners !== undefined && !Array.isArray(configOrSigners)) throw new Error("Invalid arguments");
        const signers = configOrSigners;
        if (transaction.nonceInfo && signers) transaction.sign(...signers);
        else {
            let disableCache = this._disableBlockhashCaching;
            for(;;){
                const latestBlockhash = await this._blockhashWithExpiryBlockHeight(disableCache);
                transaction.lastValidBlockHeight = latestBlockhash.lastValidBlockHeight;
                transaction.recentBlockhash = latestBlockhash.blockhash;
                if (!signers) break;
                transaction.sign(...signers);
                if (!transaction.signature) throw new Error("!signature"); // should never happen
                const signature = transaction.signature.toString("base64");
                if (!this._blockhashInfo.simulatedSignatures.includes(signature) && !this._blockhashInfo.transactionSignatures.includes(signature)) {
                    // The signature of this transaction has not been seen before with the
                    // current recentBlockhash, all done. Let's break
                    this._blockhashInfo.simulatedSignatures.push(signature);
                    break;
                } else // This transaction would be treated as duplicate (its derived signature
                // matched to one of already recorded signatures).
                // So, we must fetch a new blockhash for a different signature by disabling
                // our cache not to wait for the cache expiration (BLOCKHASH_CACHE_TIMEOUT_MS).
                disableCache = true;
            }
        }
        const message = transaction._compile();
        const signData = message.serialize();
        const wireTransaction = transaction._serialize(signData);
        const encodedTransaction = wireTransaction.toString("base64");
        const config = {
            encoding: "base64",
            commitment: this.commitment
        };
        if (includeAccounts) {
            const addresses = (Array.isArray(includeAccounts) ? includeAccounts : message.nonProgramIds()).map((key)=>key.toBase58());
            config["accounts"] = {
                encoding: "base64",
                addresses: addresses
            };
        }
        if (signers) config.sigVerify = true;
        const args = [
            encodedTransaction,
            config
        ];
        const unsafeRes = await this._rpcRequest("simulateTransaction", args);
        const res = (0, $kZFCD.create)(unsafeRes, $c3af9e523501759a$var$SimulatedTransactionResponseStruct);
        if ("error" in res) {
            let logs;
            if ("data" in res.error) {
                logs = res.error.data.logs;
                if (logs && Array.isArray(logs)) {
                    const traceIndent = "\n    ";
                    const logTrace = traceIndent + logs.join(traceIndent);
                    console.error(res.error.message, logTrace);
                }
            }
            throw new $c3af9e523501759a$export$121e803f723b3045("failed to simulate transaction: " + res.error.message, logs);
        }
        return res.result;
    }
    /**
   * Sign and send a transaction
   *
   * @deprecated Instead, call {@link sendTransaction} with a {@link
   * VersionedTransaction}
   */ /**
   * Send a signed transaction
   */ // eslint-disable-next-line no-dupe-class-members
    /**
   * Sign and send a transaction
   */ // eslint-disable-next-line no-dupe-class-members
    async sendTransaction(transaction, signersOrOptions, options) {
        if ("version" in transaction) {
            if (signersOrOptions && Array.isArray(signersOrOptions)) throw new Error("Invalid arguments");
            const wireTransaction = transaction.serialize();
            return await this.sendRawTransaction(wireTransaction, signersOrOptions);
        }
        if (signersOrOptions === undefined || !Array.isArray(signersOrOptions)) throw new Error("Invalid arguments");
        const signers = signersOrOptions;
        if (transaction.nonceInfo) transaction.sign(...signers);
        else {
            let disableCache = this._disableBlockhashCaching;
            for(;;){
                const latestBlockhash = await this._blockhashWithExpiryBlockHeight(disableCache);
                transaction.lastValidBlockHeight = latestBlockhash.lastValidBlockHeight;
                transaction.recentBlockhash = latestBlockhash.blockhash;
                transaction.sign(...signers);
                if (!transaction.signature) throw new Error("!signature"); // should never happen
                const signature = transaction.signature.toString("base64");
                if (!this._blockhashInfo.transactionSignatures.includes(signature)) {
                    // The signature of this transaction has not been seen before with the
                    // current recentBlockhash, all done. Let's break
                    this._blockhashInfo.transactionSignatures.push(signature);
                    break;
                } else // This transaction would be treated as duplicate (its derived signature
                // matched to one of already recorded signatures).
                // So, we must fetch a new blockhash for a different signature by disabling
                // our cache not to wait for the cache expiration (BLOCKHASH_CACHE_TIMEOUT_MS).
                disableCache = true;
            }
        }
        const wireTransaction = transaction.serialize();
        return await this.sendRawTransaction(wireTransaction, options);
    }
    /**
   * Send a transaction that has already been signed and serialized into the
   * wire format
   */ async sendRawTransaction(rawTransaction, options) {
        const encodedTransaction = $c3af9e523501759a$var$toBuffer(rawTransaction).toString("base64");
        const result = await this.sendEncodedTransaction(encodedTransaction, options);
        return result;
    }
    /**
   * Send a transaction that has already been signed, serialized into the
   * wire format, and encoded as a base64 string
   */ async sendEncodedTransaction(encodedTransaction, options) {
        const config = {
            encoding: "base64"
        };
        const skipPreflight = options && options.skipPreflight;
        const preflightCommitment = options && options.preflightCommitment || this.commitment;
        if (options && options.maxRetries != null) config.maxRetries = options.maxRetries;
        if (options && options.minContextSlot != null) config.minContextSlot = options.minContextSlot;
        if (skipPreflight) config.skipPreflight = skipPreflight;
        if (preflightCommitment) config.preflightCommitment = preflightCommitment;
        const args = [
            encodedTransaction,
            config
        ];
        const unsafeRes = await this._rpcRequest("sendTransaction", args);
        const res = (0, $kZFCD.create)(unsafeRes, $c3af9e523501759a$var$SendTransactionRpcResult);
        if ("error" in res) {
            let logs;
            if ("data" in res.error) logs = res.error.data.logs;
            throw new $c3af9e523501759a$export$121e803f723b3045("failed to send transaction: " + res.error.message, logs);
        }
        return res.result;
    }
    /**
   * @internal
   */ _wsOnOpen() {
        this._rpcWebSocketConnected = true;
        this._rpcWebSocketHeartbeat = setInterval(()=>{
            // Ping server every 5s to prevent idle timeouts
            (async ()=>{
                try {
                    await this._rpcWebSocket.notify("ping");
                // eslint-disable-next-line no-empty
                } catch  {}
            })();
        }, 5000);
        this._updateSubscriptions();
    }
    /**
   * @internal
   */ _wsOnError(err) {
        this._rpcWebSocketConnected = false;
        console.error("ws error:", err.message);
    }
    /**
   * @internal
   */ _wsOnClose(code) {
        this._rpcWebSocketConnected = false;
        this._rpcWebSocketGeneration = (this._rpcWebSocketGeneration + 1) % Number.MAX_SAFE_INTEGER;
        if (this._rpcWebSocketIdleTimeout) {
            clearTimeout(this._rpcWebSocketIdleTimeout);
            this._rpcWebSocketIdleTimeout = null;
        }
        if (this._rpcWebSocketHeartbeat) {
            clearInterval(this._rpcWebSocketHeartbeat);
            this._rpcWebSocketHeartbeat = null;
        }
        if (code === 1000) {
            // explicit close, check if any subscriptions have been made since close
            this._updateSubscriptions();
            return;
        }
        // implicit close, prepare subscriptions for auto-reconnect
        this._subscriptionCallbacksByServerSubscriptionId = {};
        Object.entries(this._subscriptionsByHash).forEach(([hash, subscription])=>{
            this._setSubscription(hash, {
                ...subscription,
                state: "pending"
            });
        });
    }
    /**
   * @internal
   */ _setSubscription(hash, nextSubscription) {
        const prevState = this._subscriptionsByHash[hash]?.state;
        this._subscriptionsByHash[hash] = nextSubscription;
        if (prevState !== nextSubscription.state) {
            const stateChangeCallbacks = this._subscriptionStateChangeCallbacksByHash[hash];
            if (stateChangeCallbacks) stateChangeCallbacks.forEach((cb)=>{
                try {
                    cb(nextSubscription.state);
                // eslint-disable-next-line no-empty
                } catch  {}
            });
        }
    }
    /**
   * @internal
   */ _onSubscriptionStateChange(clientSubscriptionId, callback) {
        const hash = this._subscriptionHashByClientSubscriptionId[clientSubscriptionId];
        if (hash == null) return ()=>{};
        const stateChangeCallbacks = this._subscriptionStateChangeCallbacksByHash[hash] ||= new Set();
        stateChangeCallbacks.add(callback);
        return ()=>{
            stateChangeCallbacks.delete(callback);
            if (stateChangeCallbacks.size === 0) delete this._subscriptionStateChangeCallbacksByHash[hash];
        };
    }
    /**
   * @internal
   */ async _updateSubscriptions() {
        if (Object.keys(this._subscriptionsByHash).length === 0) {
            if (this._rpcWebSocketConnected) {
                this._rpcWebSocketConnected = false;
                this._rpcWebSocketIdleTimeout = setTimeout(()=>{
                    this._rpcWebSocketIdleTimeout = null;
                    try {
                        this._rpcWebSocket.close();
                    } catch (err) {
                        // swallow error if socket has already been closed.
                        if (err instanceof Error) console.log(`Error when closing socket connection: ${err.message}`);
                    }
                }, 500);
            }
            return;
        }
        if (this._rpcWebSocketIdleTimeout !== null) {
            clearTimeout(this._rpcWebSocketIdleTimeout);
            this._rpcWebSocketIdleTimeout = null;
            this._rpcWebSocketConnected = true;
        }
        if (!this._rpcWebSocketConnected) {
            this._rpcWebSocket.connect();
            return;
        }
        const activeWebSocketGeneration = this._rpcWebSocketGeneration;
        const isCurrentConnectionStillActive = ()=>{
            return activeWebSocketGeneration === this._rpcWebSocketGeneration;
        };
        await Promise.all(// Don't be tempted to change this to `Object.entries`. We call
        // `_updateSubscriptions` recursively when processing the state,
        // so it's important that we look up the *current* version of
        // each subscription, every time we process a hash.
        Object.keys(this._subscriptionsByHash).map(async (hash)=>{
            const subscription = this._subscriptionsByHash[hash];
            if (subscription === undefined) // This entry has since been deleted. Skip.
            return;
            switch(subscription.state){
                case "pending":
                case "unsubscribed":
                    if (subscription.callbacks.size === 0) {
                        /**
             * You can end up here when:
             *
             * - a subscription has recently unsubscribed
             *   without having new callbacks added to it
             *   while the unsubscribe was in flight, or
             * - when a pending subscription has its
             *   listeners removed before a request was
             *   sent to the server.
             *
             * Being that nobody is interested in this
             * subscription any longer, delete it.
             */ delete this._subscriptionsByHash[hash];
                        if (subscription.state === "unsubscribed") delete this._subscriptionCallbacksByServerSubscriptionId[subscription.serverSubscriptionId];
                        await this._updateSubscriptions();
                        return;
                    }
                    await (async ()=>{
                        const { args: args, method: method } = subscription;
                        try {
                            this._setSubscription(hash, {
                                ...subscription,
                                state: "subscribing"
                            });
                            const serverSubscriptionId = await this._rpcWebSocket.call(method, args);
                            this._setSubscription(hash, {
                                ...subscription,
                                serverSubscriptionId: serverSubscriptionId,
                                state: "subscribed"
                            });
                            this._subscriptionCallbacksByServerSubscriptionId[serverSubscriptionId] = subscription.callbacks;
                            await this._updateSubscriptions();
                        } catch (e) {
                            if (e instanceof Error) console.error(`${method} error for argument`, args, e.message);
                            if (!isCurrentConnectionStillActive()) return;
                            // TODO: Maybe add an 'errored' state or a retry limit?
                            this._setSubscription(hash, {
                                ...subscription,
                                state: "pending"
                            });
                            await this._updateSubscriptions();
                        }
                    })();
                    break;
                case "subscribed":
                    if (subscription.callbacks.size === 0) // By the time we successfully set up a subscription
                    // with the server, the client stopped caring about it.
                    // Tear it down now.
                    await (async ()=>{
                        const { serverSubscriptionId: serverSubscriptionId, unsubscribeMethod: unsubscribeMethod } = subscription;
                        if (this._subscriptionsAutoDisposedByRpc.has(serverSubscriptionId)) /**
                 * Special case.
                 * If we're dealing with a subscription that has been auto-
                 * disposed by the RPC, then we can skip the RPC call to
                 * tear down the subscription here.
                 *
                 * NOTE: There is a proposal to eliminate this special case, here:
                 * https://github.com/solana-labs/solana/issues/18892
                 */ this._subscriptionsAutoDisposedByRpc.delete(serverSubscriptionId);
                        else {
                            this._setSubscription(hash, {
                                ...subscription,
                                state: "unsubscribing"
                            });
                            this._setSubscription(hash, {
                                ...subscription,
                                state: "unsubscribing"
                            });
                            try {
                                await this._rpcWebSocket.call(unsubscribeMethod, [
                                    serverSubscriptionId
                                ]);
                            } catch (e) {
                                if (e instanceof Error) console.error(`${unsubscribeMethod} error:`, e.message);
                                if (!isCurrentConnectionStillActive()) return;
                                // TODO: Maybe add an 'errored' state or a retry limit?
                                this._setSubscription(hash, {
                                    ...subscription,
                                    state: "subscribed"
                                });
                                await this._updateSubscriptions();
                                return;
                            }
                        }
                        this._setSubscription(hash, {
                            ...subscription,
                            state: "unsubscribed"
                        });
                        await this._updateSubscriptions();
                    })();
                    break;
            }
        }));
    }
    /**
   * @internal
   */ _handleServerNotification(serverSubscriptionId, callbackArgs) {
        const callbacks = this._subscriptionCallbacksByServerSubscriptionId[serverSubscriptionId];
        if (callbacks === undefined) return;
        callbacks.forEach((cb)=>{
            try {
                cb(// I failed to find a way to convince TypeScript that `cb` is of type
                // `TCallback` which is certainly compatible with `Parameters<TCallback>`.
                // See https://github.com/microsoft/TypeScript/issues/47615
                // @ts-ignore
                ...callbackArgs);
            } catch (e) {
                console.error(e);
            }
        });
    }
    /**
   * @internal
   */ _wsOnAccountNotification(notification) {
        const { result: result, subscription: subscription } = (0, $kZFCD.create)(notification, $c3af9e523501759a$var$AccountNotificationResult);
        this._handleServerNotification(subscription, [
            result.value,
            result.context
        ]);
    }
    /**
   * @internal
   */ _makeSubscription(subscriptionConfig, /**
   * When preparing `args` for a call to `_makeSubscription`, be sure
   * to carefully apply a default `commitment` property, if necessary.
   *
   * - If the user supplied a `commitment` use that.
   * - Otherwise, if the `Connection::commitment` is set, use that.
   * - Otherwise, set it to the RPC server default: `finalized`.
   *
   * This is extremely important to ensure that these two fundamentally
   * identical subscriptions produce the same identifying hash:
   *
   * - A subscription made without specifying a commitment.
   * - A subscription made where the commitment specified is the same
   *   as the default applied to the subscription above.
   *
   * Example; these two subscriptions must produce the same hash:
   *
   * - An `accountSubscribe` subscription for `'PUBKEY'`
   * - An `accountSubscribe` subscription for `'PUBKEY'` with commitment
   *   `'finalized'`.
   *
   * See the 'making a subscription with defaulted params omitted' test
   * in `connection-subscriptions.ts` for more.
   */ args) {
        const clientSubscriptionId = this._nextClientSubscriptionId++;
        const hash = $c3af9e523501759a$var$fastStableStringify$1([
            subscriptionConfig.method,
            args
        ], true);
        const existingSubscription = this._subscriptionsByHash[hash];
        if (existingSubscription === undefined) this._subscriptionsByHash[hash] = {
            ...subscriptionConfig,
            args: args,
            callbacks: new Set([
                subscriptionConfig.callback
            ]),
            state: "pending"
        };
        else existingSubscription.callbacks.add(subscriptionConfig.callback);
        this._subscriptionHashByClientSubscriptionId[clientSubscriptionId] = hash;
        this._subscriptionDisposeFunctionsByClientSubscriptionId[clientSubscriptionId] = async ()=>{
            delete this._subscriptionDisposeFunctionsByClientSubscriptionId[clientSubscriptionId];
            delete this._subscriptionHashByClientSubscriptionId[clientSubscriptionId];
            const subscription = this._subscriptionsByHash[hash];
            $c3af9e523501759a$var$assert(subscription !== undefined, `Could not find a \`Subscription\` when tearing down client subscription #${clientSubscriptionId}`);
            subscription.callbacks.delete(subscriptionConfig.callback);
            await this._updateSubscriptions();
        };
        this._updateSubscriptions();
        return clientSubscriptionId;
    }
    /**
   * Register a callback to be invoked whenever the specified account changes
   *
   * @param publicKey Public key of the account to monitor
   * @param callback Function to invoke whenever the account is changed
   * @param commitment Specify the commitment level account changes must reach before notification
   * @return subscription id
   */ onAccountChange(publicKey, callback, commitment) {
        const args = this._buildArgs([
            publicKey.toBase58()
        ], commitment || this._commitment || "finalized", // Apply connection/server default.
        "base64");
        return this._makeSubscription({
            callback: callback,
            method: "accountSubscribe",
            unsubscribeMethod: "accountUnsubscribe"
        }, args);
    }
    /**
   * Deregister an account notification callback
   *
   * @param id client subscription id to deregister
   */ async removeAccountChangeListener(clientSubscriptionId) {
        await this._unsubscribeClientSubscription(clientSubscriptionId, "account change");
    }
    /**
   * @internal
   */ _wsOnProgramAccountNotification(notification) {
        const { result: result, subscription: subscription } = (0, $kZFCD.create)(notification, $c3af9e523501759a$var$ProgramAccountNotificationResult);
        this._handleServerNotification(subscription, [
            {
                accountId: result.value.pubkey,
                accountInfo: result.value.account
            },
            result.context
        ]);
    }
    /**
   * Register a callback to be invoked whenever accounts owned by the
   * specified program change
   *
   * @param programId Public key of the program to monitor
   * @param callback Function to invoke whenever the account is changed
   * @param commitment Specify the commitment level account changes must reach before notification
   * @param filters The program account filters to pass into the RPC method
   * @return subscription id
   */ onProgramAccountChange(programId, callback, commitment, filters) {
        const args = this._buildArgs([
            programId.toBase58()
        ], commitment || this._commitment || "finalized", // Apply connection/server default.
        "base64" /* encoding */ , filters ? {
            filters: filters
        } : undefined /* extra */ );
        return this._makeSubscription({
            callback: callback,
            method: "programSubscribe",
            unsubscribeMethod: "programUnsubscribe"
        }, args);
    }
    /**
   * Deregister an account notification callback
   *
   * @param id client subscription id to deregister
   */ async removeProgramAccountChangeListener(clientSubscriptionId) {
        await this._unsubscribeClientSubscription(clientSubscriptionId, "program account change");
    }
    /**
   * Registers a callback to be invoked whenever logs are emitted.
   */ onLogs(filter, callback, commitment) {
        const args = this._buildArgs([
            typeof filter === "object" ? {
                mentions: [
                    filter.toString()
                ]
            } : filter
        ], commitment || this._commitment || "finalized" // Apply connection/server default.
        );
        return this._makeSubscription({
            callback: callback,
            method: "logsSubscribe",
            unsubscribeMethod: "logsUnsubscribe"
        }, args);
    }
    /**
   * Deregister a logs callback.
   *
   * @param id client subscription id to deregister.
   */ async removeOnLogsListener(clientSubscriptionId) {
        await this._unsubscribeClientSubscription(clientSubscriptionId, "logs");
    }
    /**
   * @internal
   */ _wsOnLogsNotification(notification) {
        const { result: result, subscription: subscription } = (0, $kZFCD.create)(notification, $c3af9e523501759a$var$LogsNotificationResult);
        this._handleServerNotification(subscription, [
            result.value,
            result.context
        ]);
    }
    /**
   * @internal
   */ _wsOnSlotNotification(notification) {
        const { result: result, subscription: subscription } = (0, $kZFCD.create)(notification, $c3af9e523501759a$var$SlotNotificationResult);
        this._handleServerNotification(subscription, [
            result
        ]);
    }
    /**
   * Register a callback to be invoked upon slot changes
   *
   * @param callback Function to invoke whenever the slot changes
   * @return subscription id
   */ onSlotChange(callback) {
        return this._makeSubscription({
            callback: callback,
            method: "slotSubscribe",
            unsubscribeMethod: "slotUnsubscribe"
        }, []);
    }
    /**
   * Deregister a slot notification callback
   *
   * @param id client subscription id to deregister
   */ async removeSlotChangeListener(clientSubscriptionId) {
        await this._unsubscribeClientSubscription(clientSubscriptionId, "slot change");
    }
    /**
   * @internal
   */ _wsOnSlotUpdatesNotification(notification) {
        const { result: result, subscription: subscription } = (0, $kZFCD.create)(notification, $c3af9e523501759a$var$SlotUpdateNotificationResult);
        this._handleServerNotification(subscription, [
            result
        ]);
    }
    /**
   * Register a callback to be invoked upon slot updates. {@link SlotUpdate}'s
   * may be useful to track live progress of a cluster.
   *
   * @param callback Function to invoke whenever the slot updates
   * @return subscription id
   */ onSlotUpdate(callback) {
        return this._makeSubscription({
            callback: callback,
            method: "slotsUpdatesSubscribe",
            unsubscribeMethod: "slotsUpdatesUnsubscribe"
        }, []);
    }
    /**
   * Deregister a slot update notification callback
   *
   * @param id client subscription id to deregister
   */ async removeSlotUpdateListener(clientSubscriptionId) {
        await this._unsubscribeClientSubscription(clientSubscriptionId, "slot update");
    }
    /**
   * @internal
   */ async _unsubscribeClientSubscription(clientSubscriptionId, subscriptionName) {
        const dispose = this._subscriptionDisposeFunctionsByClientSubscriptionId[clientSubscriptionId];
        if (dispose) await dispose();
        else console.warn("Ignored unsubscribe request because an active subscription with id " + `\`${clientSubscriptionId}\` for '${subscriptionName}' events ` + "could not be found.");
    }
    _buildArgs(args, override, encoding, extra) {
        const commitment = override || this._commitment;
        if (commitment || encoding || extra) {
            let options = {};
            if (encoding) options.encoding = encoding;
            if (commitment) options.commitment = commitment;
            if (extra) options = Object.assign(options, extra);
            args.push(options);
        }
        return args;
    }
    /**
   * @internal
   */ _buildArgsAtLeastConfirmed(args, override, encoding, extra) {
        const commitment = override || this._commitment;
        if (commitment && ![
            "confirmed",
            "finalized"
        ].includes(commitment)) throw new Error("Using Connection with default commitment: `" + this._commitment + "`, but method requires at least `confirmed`");
        return this._buildArgs(args, override, encoding, extra);
    }
    /**
   * @internal
   */ _wsOnSignatureNotification(notification) {
        const { result: result, subscription: subscription } = (0, $kZFCD.create)(notification, $c3af9e523501759a$var$SignatureNotificationResult);
        if (result.value !== "receivedSignature") /**
       * Special case.
       * After a signature is processed, RPCs automatically dispose of the
       * subscription on the server side. We need to track which of these
       * subscriptions have been disposed in such a way, so that we know
       * whether the client is dealing with a not-yet-processed signature
       * (in which case we must tear down the server subscription) or an
       * already-processed signature (in which case the client can simply
       * clear out the subscription locally without telling the server).
       *
       * NOTE: There is a proposal to eliminate this special case, here:
       * https://github.com/solana-labs/solana/issues/18892
       */ this._subscriptionsAutoDisposedByRpc.add(subscription);
        this._handleServerNotification(subscription, result.value === "receivedSignature" ? [
            {
                type: "received"
            },
            result.context
        ] : [
            {
                type: "status",
                result: result.value
            },
            result.context
        ]);
    }
    /**
   * Register a callback to be invoked upon signature updates
   *
   * @param signature Transaction signature string in base 58
   * @param callback Function to invoke on signature notifications
   * @param commitment Specify the commitment level signature must reach before notification
   * @return subscription id
   */ onSignature(signature, callback, commitment) {
        const args = this._buildArgs([
            signature
        ], commitment || this._commitment || "finalized" // Apply connection/server default.
        );
        const clientSubscriptionId = this._makeSubscription({
            callback: (notification, context)=>{
                if (notification.type === "status") {
                    callback(notification.result, context);
                    // Signatures subscriptions are auto-removed by the RPC service
                    // so no need to explicitly send an unsubscribe message.
                    try {
                        this.removeSignatureListener(clientSubscriptionId);
                    // eslint-disable-next-line no-empty
                    } catch (_err) {
                    // Already removed.
                    }
                }
            },
            method: "signatureSubscribe",
            unsubscribeMethod: "signatureUnsubscribe"
        }, args);
        return clientSubscriptionId;
    }
    /**
   * Register a callback to be invoked when a transaction is
   * received and/or processed.
   *
   * @param signature Transaction signature string in base 58
   * @param callback Function to invoke on signature notifications
   * @param options Enable received notifications and set the commitment
   *   level that signature must reach before notification
   * @return subscription id
   */ onSignatureWithOptions(signature, callback, options) {
        const { commitment: commitment, ...extra } = {
            ...options,
            commitment: options && options.commitment || this._commitment || "finalized" // Apply connection/server default.
        };
        const args = this._buildArgs([
            signature
        ], commitment, undefined /* encoding */ , extra);
        const clientSubscriptionId = this._makeSubscription({
            callback: (notification, context)=>{
                callback(notification, context);
                // Signatures subscriptions are auto-removed by the RPC service
                // so no need to explicitly send an unsubscribe message.
                try {
                    this.removeSignatureListener(clientSubscriptionId);
                // eslint-disable-next-line no-empty
                } catch (_err) {
                // Already removed.
                }
            },
            method: "signatureSubscribe",
            unsubscribeMethod: "signatureUnsubscribe"
        }, args);
        return clientSubscriptionId;
    }
    /**
   * Deregister a signature notification callback
   *
   * @param id client subscription id to deregister
   */ async removeSignatureListener(clientSubscriptionId) {
        await this._unsubscribeClientSubscription(clientSubscriptionId, "signature result");
    }
    /**
   * @internal
   */ _wsOnRootNotification(notification) {
        const { result: result, subscription: subscription } = (0, $kZFCD.create)(notification, $c3af9e523501759a$var$RootNotificationResult);
        this._handleServerNotification(subscription, [
            result
        ]);
    }
    /**
   * Register a callback to be invoked upon root changes
   *
   * @param callback Function to invoke whenever the root changes
   * @return subscription id
   */ onRootChange(callback) {
        return this._makeSubscription({
            callback: callback,
            method: "rootSubscribe",
            unsubscribeMethod: "rootUnsubscribe"
        }, []);
    }
    /**
   * Deregister a root notification callback
   *
   * @param id client subscription id to deregister
   */ async removeRootChangeListener(clientSubscriptionId) {
        await this._unsubscribeClientSubscription(clientSubscriptionId, "root change");
    }
}
/**
 * Keypair signer interface
 */ /**
 * An account keypair used for signing transactions.
 */ class $c3af9e523501759a$export$c53bca448cf33676 {
    /**
   * Create a new keypair instance.
   * Generate random keypair if no {@link Ed25519Keypair} is provided.
   *
   * @param {Ed25519Keypair} keypair ed25519 keypair
   */ constructor(keypair){
        this._keypair = void 0;
        this._keypair = keypair ?? $c3af9e523501759a$var$generateKeypair();
    }
    /**
   * Generate a new random keypair
   *
   * @returns {Keypair} Keypair
   */ static generate() {
        return new $c3af9e523501759a$export$c53bca448cf33676($c3af9e523501759a$var$generateKeypair());
    }
    /**
   * Create a keypair from a raw secret key byte array.
   *
   * This method should only be used to recreate a keypair from a previously
   * generated secret key. Generating keypairs from a random seed should be done
   * with the {@link Keypair.fromSeed} method.
   *
   * @throws error if the provided secret key is invalid and validation is not skipped.
   *
   * @param secretKey secret key byte array
   * @param options skip secret key validation
   *
   * @returns {Keypair} Keypair
   */ static fromSecretKey(secretKey, options) {
        if (secretKey.byteLength !== 64) throw new Error("bad secret key size");
        const publicKey = secretKey.slice(32, 64);
        if (!options || !options.skipValidation) {
            const privateScalar = secretKey.slice(0, 32);
            const computedPublicKey = $c3af9e523501759a$var$getPublicKey(privateScalar);
            for(let ii = 0; ii < 32; ii++){
                if (publicKey[ii] !== computedPublicKey[ii]) throw new Error("provided secretKey is invalid");
            }
        }
        return new $c3af9e523501759a$export$c53bca448cf33676({
            publicKey: publicKey,
            secretKey: secretKey
        });
    }
    /**
   * Generate a keypair from a 32 byte seed.
   *
   * @param seed seed byte array
   *
   * @returns {Keypair} Keypair
   */ static fromSeed(seed) {
        const publicKey = $c3af9e523501759a$var$getPublicKey(seed);
        const secretKey = new Uint8Array(64);
        secretKey.set(seed);
        secretKey.set(publicKey, 32);
        return new $c3af9e523501759a$export$c53bca448cf33676({
            publicKey: publicKey,
            secretKey: secretKey
        });
    }
    /**
   * The public key for this keypair
   *
   * @returns {PublicKey} PublicKey
   */ get publicKey() {
        return new $c3af9e523501759a$export$ca8b6604d6ce14de(this._keypair.publicKey);
    }
    /**
   * The raw secret key for this keypair
   * @returns {Uint8Array} Secret key in an array of Uint8 bytes
   */ get secretKey() {
        return new Uint8Array(this._keypair.secretKey);
    }
}
/**
 * An enumeration of valid LookupTableInstructionType's
 */ /**
 * An enumeration of valid address lookup table InstructionType's
 * @internal
 */ const $c3af9e523501759a$export$7d102200c3a357d6 = Object.freeze({
    CreateLookupTable: {
        index: 0,
        layout: $Q02IV.struct([
            $Q02IV.u32("instruction"),
            $c3af9e523501759a$var$u64("recentSlot"),
            $Q02IV.u8("bumpSeed")
        ])
    },
    FreezeLookupTable: {
        index: 1,
        layout: $Q02IV.struct([
            $Q02IV.u32("instruction")
        ])
    },
    ExtendLookupTable: {
        index: 2,
        layout: $Q02IV.struct([
            $Q02IV.u32("instruction"),
            $c3af9e523501759a$var$u64(),
            $Q02IV.seq($c3af9e523501759a$var$publicKey(), $Q02IV.offset($Q02IV.u32(), -8), "addresses")
        ])
    },
    DeactivateLookupTable: {
        index: 3,
        layout: $Q02IV.struct([
            $Q02IV.u32("instruction")
        ])
    },
    CloseLookupTable: {
        index: 4,
        layout: $Q02IV.struct([
            $Q02IV.u32("instruction")
        ])
    }
});
class $c3af9e523501759a$export$3ab2b24d551f0dc2 {
    /**
   * @internal
   */ constructor(){}
    static decodeInstructionType(instruction) {
        this.checkProgramId(instruction.programId);
        const instructionTypeLayout = $Q02IV.u32("instruction");
        const index = instructionTypeLayout.decode(instruction.data);
        let type;
        for (const [layoutType, layout] of Object.entries($c3af9e523501759a$export$7d102200c3a357d6))if (layout.index == index) {
            type = layoutType;
            break;
        }
        if (!type) throw new Error("Invalid Instruction. Should be a LookupTable Instruction");
        return type;
    }
    static decodeCreateLookupTable(instruction) {
        this.checkProgramId(instruction.programId);
        this.checkKeysLength(instruction.keys, 4);
        const { recentSlot: recentSlot } = $c3af9e523501759a$var$decodeData$1($c3af9e523501759a$export$7d102200c3a357d6.CreateLookupTable, instruction.data);
        return {
            authority: instruction.keys[1].pubkey,
            payer: instruction.keys[2].pubkey,
            recentSlot: Number(recentSlot)
        };
    }
    static decodeExtendLookupTable(instruction) {
        this.checkProgramId(instruction.programId);
        if (instruction.keys.length < 2) throw new Error(`invalid instruction; found ${instruction.keys.length} keys, expected at least 2`);
        const { addresses: addresses } = $c3af9e523501759a$var$decodeData$1($c3af9e523501759a$export$7d102200c3a357d6.ExtendLookupTable, instruction.data);
        return {
            lookupTable: instruction.keys[0].pubkey,
            authority: instruction.keys[1].pubkey,
            payer: instruction.keys.length > 2 ? instruction.keys[2].pubkey : undefined,
            addresses: addresses.map((buffer)=>new $c3af9e523501759a$export$ca8b6604d6ce14de(buffer))
        };
    }
    static decodeCloseLookupTable(instruction) {
        this.checkProgramId(instruction.programId);
        this.checkKeysLength(instruction.keys, 3);
        return {
            lookupTable: instruction.keys[0].pubkey,
            authority: instruction.keys[1].pubkey,
            recipient: instruction.keys[2].pubkey
        };
    }
    static decodeFreezeLookupTable(instruction) {
        this.checkProgramId(instruction.programId);
        this.checkKeysLength(instruction.keys, 2);
        return {
            lookupTable: instruction.keys[0].pubkey,
            authority: instruction.keys[1].pubkey
        };
    }
    static decodeDeactivateLookupTable(instruction) {
        this.checkProgramId(instruction.programId);
        this.checkKeysLength(instruction.keys, 2);
        return {
            lookupTable: instruction.keys[0].pubkey,
            authority: instruction.keys[1].pubkey
        };
    }
    /**
   * @internal
   */ static checkProgramId(programId) {
        if (!programId.equals($c3af9e523501759a$export$5147a345798de168.programId)) throw new Error("invalid instruction; programId is not AddressLookupTable Program");
    }
    /**
   * @internal
   */ static checkKeysLength(keys, expectedLength) {
        if (keys.length < expectedLength) throw new Error(`invalid instruction; found ${keys.length} keys, expected at least ${expectedLength}`);
    }
}
class $c3af9e523501759a$export$5147a345798de168 {
    /**
   * @internal
   */ constructor(){}
    static createLookupTable(params) {
        const [lookupTableAddress, bumpSeed] = $c3af9e523501759a$export$ca8b6604d6ce14de.findProgramAddressSync([
            params.authority.toBuffer(),
            (0, $gyRuj.toBufferLE)(BigInt(params.recentSlot), 8)
        ], this.programId);
        const type = $c3af9e523501759a$export$7d102200c3a357d6.CreateLookupTable;
        const data = $c3af9e523501759a$var$encodeData(type, {
            recentSlot: BigInt(params.recentSlot),
            bumpSeed: bumpSeed
        });
        const keys = [
            {
                pubkey: lookupTableAddress,
                isSigner: false,
                isWritable: true
            },
            {
                pubkey: params.authority,
                isSigner: true,
                isWritable: false
            },
            {
                pubkey: params.payer,
                isSigner: true,
                isWritable: true
            },
            {
                pubkey: $c3af9e523501759a$export$d8c4e17726848113.programId,
                isSigner: false,
                isWritable: false
            }
        ];
        return [
            new $c3af9e523501759a$export$a7a3aa8360ac9f59({
                programId: this.programId,
                keys: keys,
                data: data
            }),
            lookupTableAddress
        ];
    }
    static freezeLookupTable(params) {
        const type = $c3af9e523501759a$export$7d102200c3a357d6.FreezeLookupTable;
        const data = $c3af9e523501759a$var$encodeData(type);
        const keys = [
            {
                pubkey: params.lookupTable,
                isSigner: false,
                isWritable: true
            },
            {
                pubkey: params.authority,
                isSigner: true,
                isWritable: false
            }
        ];
        return new $c3af9e523501759a$export$a7a3aa8360ac9f59({
            programId: this.programId,
            keys: keys,
            data: data
        });
    }
    static extendLookupTable(params) {
        const type = $c3af9e523501759a$export$7d102200c3a357d6.ExtendLookupTable;
        const data = $c3af9e523501759a$var$encodeData(type, {
            addresses: params.addresses.map((addr)=>addr.toBytes())
        });
        const keys = [
            {
                pubkey: params.lookupTable,
                isSigner: false,
                isWritable: true
            },
            {
                pubkey: params.authority,
                isSigner: true,
                isWritable: false
            }
        ];
        if (params.payer) keys.push({
            pubkey: params.payer,
            isSigner: true,
            isWritable: true
        }, {
            pubkey: $c3af9e523501759a$export$d8c4e17726848113.programId,
            isSigner: false,
            isWritable: false
        });
        return new $c3af9e523501759a$export$a7a3aa8360ac9f59({
            programId: this.programId,
            keys: keys,
            data: data
        });
    }
    static deactivateLookupTable(params) {
        const type = $c3af9e523501759a$export$7d102200c3a357d6.DeactivateLookupTable;
        const data = $c3af9e523501759a$var$encodeData(type);
        const keys = [
            {
                pubkey: params.lookupTable,
                isSigner: false,
                isWritable: true
            },
            {
                pubkey: params.authority,
                isSigner: true,
                isWritable: false
            }
        ];
        return new $c3af9e523501759a$export$a7a3aa8360ac9f59({
            programId: this.programId,
            keys: keys,
            data: data
        });
    }
    static closeLookupTable(params) {
        const type = $c3af9e523501759a$export$7d102200c3a357d6.CloseLookupTable;
        const data = $c3af9e523501759a$var$encodeData(type);
        const keys = [
            {
                pubkey: params.lookupTable,
                isSigner: false,
                isWritable: true
            },
            {
                pubkey: params.authority,
                isSigner: true,
                isWritable: false
            },
            {
                pubkey: params.recipient,
                isSigner: false,
                isWritable: true
            }
        ];
        return new $c3af9e523501759a$export$a7a3aa8360ac9f59({
            programId: this.programId,
            keys: keys,
            data: data
        });
    }
}
$c3af9e523501759a$export$5147a345798de168.programId = new $c3af9e523501759a$export$ca8b6604d6ce14de("AddressLookupTab1e1111111111111111111111111");
/**
 * Compute Budget Instruction class
 */ class $c3af9e523501759a$export$bc4776847c641a67 {
    /**
   * @internal
   */ constructor(){}
    /**
   * Decode a compute budget instruction and retrieve the instruction type.
   */ static decodeInstructionType(instruction) {
        this.checkProgramId(instruction.programId);
        const instructionTypeLayout = $Q02IV.u8("instruction");
        const typeIndex = instructionTypeLayout.decode(instruction.data);
        let type;
        for (const [ixType, layout] of Object.entries($c3af9e523501759a$export$b7c79c50764da3d6))if (layout.index == typeIndex) {
            type = ixType;
            break;
        }
        if (!type) throw new Error("Instruction type incorrect; not a ComputeBudgetInstruction");
        return type;
    }
    /**
   * Decode request units compute budget instruction and retrieve the instruction params.
   */ static decodeRequestUnits(instruction) {
        this.checkProgramId(instruction.programId);
        const { units: units, additionalFee: additionalFee } = $c3af9e523501759a$var$decodeData$1($c3af9e523501759a$export$b7c79c50764da3d6.RequestUnits, instruction.data);
        return {
            units: units,
            additionalFee: additionalFee
        };
    }
    /**
   * Decode request heap frame compute budget instruction and retrieve the instruction params.
   */ static decodeRequestHeapFrame(instruction) {
        this.checkProgramId(instruction.programId);
        const { bytes: bytes } = $c3af9e523501759a$var$decodeData$1($c3af9e523501759a$export$b7c79c50764da3d6.RequestHeapFrame, instruction.data);
        return {
            bytes: bytes
        };
    }
    /**
   * Decode set compute unit limit compute budget instruction and retrieve the instruction params.
   */ static decodeSetComputeUnitLimit(instruction) {
        this.checkProgramId(instruction.programId);
        const { units: units } = $c3af9e523501759a$var$decodeData$1($c3af9e523501759a$export$b7c79c50764da3d6.SetComputeUnitLimit, instruction.data);
        return {
            units: units
        };
    }
    /**
   * Decode set compute unit price compute budget instruction and retrieve the instruction params.
   */ static decodeSetComputeUnitPrice(instruction) {
        this.checkProgramId(instruction.programId);
        const { microLamports: microLamports } = $c3af9e523501759a$var$decodeData$1($c3af9e523501759a$export$b7c79c50764da3d6.SetComputeUnitPrice, instruction.data);
        return {
            microLamports: microLamports
        };
    }
    /**
   * @internal
   */ static checkProgramId(programId) {
        if (!programId.equals($c3af9e523501759a$export$11585db5942bcdb7.programId)) throw new Error("invalid instruction; programId is not ComputeBudgetProgram");
    }
}
/**
 * An enumeration of valid ComputeBudgetInstructionType's
 */ /**
 * Request units instruction params
 */ /**
 * Request heap frame instruction params
 */ /**
 * Set compute unit limit instruction params
 */ /**
 * Set compute unit price instruction params
 */ /**
 * An enumeration of valid ComputeBudget InstructionType's
 * @internal
 */ const $c3af9e523501759a$export$b7c79c50764da3d6 = Object.freeze({
    RequestUnits: {
        index: 0,
        layout: $Q02IV.struct([
            $Q02IV.u8("instruction"),
            $Q02IV.u32("units"),
            $Q02IV.u32("additionalFee")
        ])
    },
    RequestHeapFrame: {
        index: 1,
        layout: $Q02IV.struct([
            $Q02IV.u8("instruction"),
            $Q02IV.u32("bytes")
        ])
    },
    SetComputeUnitLimit: {
        index: 2,
        layout: $Q02IV.struct([
            $Q02IV.u8("instruction"),
            $Q02IV.u32("units")
        ])
    },
    SetComputeUnitPrice: {
        index: 3,
        layout: $Q02IV.struct([
            $Q02IV.u8("instruction"),
            $c3af9e523501759a$var$u64("microLamports")
        ])
    }
});
/**
 * Factory class for transaction instructions to interact with the Compute Budget program
 */ class $c3af9e523501759a$export$11585db5942bcdb7 {
    /**
   * @internal
   */ constructor(){}
    /**
   * Public key that identifies the Compute Budget program
   */ /**
   * @deprecated Instead, call {@link setComputeUnitLimit} and/or {@link setComputeUnitPrice}
   */ static requestUnits(params) {
        const type = $c3af9e523501759a$export$b7c79c50764da3d6.RequestUnits;
        const data = $c3af9e523501759a$var$encodeData(type, params);
        return new $c3af9e523501759a$export$a7a3aa8360ac9f59({
            keys: [],
            programId: this.programId,
            data: data
        });
    }
    static requestHeapFrame(params) {
        const type = $c3af9e523501759a$export$b7c79c50764da3d6.RequestHeapFrame;
        const data = $c3af9e523501759a$var$encodeData(type, params);
        return new $c3af9e523501759a$export$a7a3aa8360ac9f59({
            keys: [],
            programId: this.programId,
            data: data
        });
    }
    static setComputeUnitLimit(params) {
        const type = $c3af9e523501759a$export$b7c79c50764da3d6.SetComputeUnitLimit;
        const data = $c3af9e523501759a$var$encodeData(type, params);
        return new $c3af9e523501759a$export$a7a3aa8360ac9f59({
            keys: [],
            programId: this.programId,
            data: data
        });
    }
    static setComputeUnitPrice(params) {
        const type = $c3af9e523501759a$export$b7c79c50764da3d6.SetComputeUnitPrice;
        const data = $c3af9e523501759a$var$encodeData(type, {
            microLamports: BigInt(params.microLamports)
        });
        return new $c3af9e523501759a$export$a7a3aa8360ac9f59({
            keys: [],
            programId: this.programId,
            data: data
        });
    }
}
$c3af9e523501759a$export$11585db5942bcdb7.programId = new $c3af9e523501759a$export$ca8b6604d6ce14de("ComputeBudget111111111111111111111111111111");
const $c3af9e523501759a$var$PRIVATE_KEY_BYTES$1 = 64;
const $c3af9e523501759a$var$PUBLIC_KEY_BYTES$1 = 32;
const $c3af9e523501759a$var$SIGNATURE_BYTES = 64;
/**
 * Params for creating an ed25519 instruction using a public key
 */ /**
 * Params for creating an ed25519 instruction using a private key
 */ const $c3af9e523501759a$var$ED25519_INSTRUCTION_LAYOUT = $Q02IV.struct([
    $Q02IV.u8("numSignatures"),
    $Q02IV.u8("padding"),
    $Q02IV.u16("signatureOffset"),
    $Q02IV.u16("signatureInstructionIndex"),
    $Q02IV.u16("publicKeyOffset"),
    $Q02IV.u16("publicKeyInstructionIndex"),
    $Q02IV.u16("messageDataOffset"),
    $Q02IV.u16("messageDataSize"),
    $Q02IV.u16("messageInstructionIndex")
]);
class $c3af9e523501759a$export$e5087aea02631e {
    /**
   * @internal
   */ constructor(){}
    /**
   * Public key that identifies the ed25519 program
   */ /**
   * Create an ed25519 instruction with a public key and signature. The
   * public key must be a buffer that is 32 bytes long, and the signature
   * must be a buffer of 64 bytes.
   */ static createInstructionWithPublicKey(params) {
        const { publicKey: publicKey, message: message, signature: signature, instructionIndex: instructionIndex } = params;
        $c3af9e523501759a$var$assert(publicKey.length === $c3af9e523501759a$var$PUBLIC_KEY_BYTES$1, `Public Key must be ${$c3af9e523501759a$var$PUBLIC_KEY_BYTES$1} bytes but received ${publicKey.length} bytes`);
        $c3af9e523501759a$var$assert(signature.length === $c3af9e523501759a$var$SIGNATURE_BYTES, `Signature must be ${$c3af9e523501759a$var$SIGNATURE_BYTES} bytes but received ${signature.length} bytes`);
        const publicKeyOffset = $c3af9e523501759a$var$ED25519_INSTRUCTION_LAYOUT.span;
        const signatureOffset = publicKeyOffset + publicKey.length;
        const messageDataOffset = signatureOffset + signature.length;
        const numSignatures = 1;
        const instructionData = (0, $6ZWSX.Buffer).alloc(messageDataOffset + message.length);
        const index = instructionIndex == null ? 0xffff // An index of `u16::MAX` makes it default to the current instruction.
         : instructionIndex;
        $c3af9e523501759a$var$ED25519_INSTRUCTION_LAYOUT.encode({
            numSignatures: numSignatures,
            padding: 0,
            signatureOffset: signatureOffset,
            signatureInstructionIndex: index,
            publicKeyOffset: publicKeyOffset,
            publicKeyInstructionIndex: index,
            messageDataOffset: messageDataOffset,
            messageDataSize: message.length,
            messageInstructionIndex: index
        }, instructionData);
        instructionData.fill(publicKey, publicKeyOffset);
        instructionData.fill(signature, signatureOffset);
        instructionData.fill(message, messageDataOffset);
        return new $c3af9e523501759a$export$a7a3aa8360ac9f59({
            keys: [],
            programId: $c3af9e523501759a$export$e5087aea02631e.programId,
            data: instructionData
        });
    }
    /**
   * Create an ed25519 instruction with a private key. The private key
   * must be a buffer that is 64 bytes long.
   */ static createInstructionWithPrivateKey(params) {
        const { privateKey: privateKey, message: message, instructionIndex: instructionIndex } = params;
        $c3af9e523501759a$var$assert(privateKey.length === $c3af9e523501759a$var$PRIVATE_KEY_BYTES$1, `Private key must be ${$c3af9e523501759a$var$PRIVATE_KEY_BYTES$1} bytes but received ${privateKey.length} bytes`);
        try {
            const keypair = $c3af9e523501759a$export$c53bca448cf33676.fromSecretKey(privateKey);
            const publicKey = keypair.publicKey.toBytes();
            const signature = $c3af9e523501759a$var$sign(message, keypair.secretKey);
            return this.createInstructionWithPublicKey({
                publicKey: publicKey,
                message: message,
                signature: signature,
                instructionIndex: instructionIndex
            });
        } catch (error) {
            throw new Error(`Error creating instruction; ${error}`);
        }
    }
}
$c3af9e523501759a$export$e5087aea02631e.programId = new $c3af9e523501759a$export$ca8b6604d6ce14de("Ed25519SigVerify111111111111111111111111111");
const $c3af9e523501759a$var$ecdsaSign = (msgHash, privKey)=>{
    const signature = (0, $5r7db.secp256k1).sign(msgHash, privKey);
    return [
        signature.toCompactRawBytes(),
        signature.recovery
    ];
};
(0, $5r7db.secp256k1).utils.isValidPrivateKey;
const $c3af9e523501759a$var$publicKeyCreate = (0, $5r7db.secp256k1).getPublicKey;
const $c3af9e523501759a$var$PRIVATE_KEY_BYTES = 32;
const $c3af9e523501759a$var$ETHEREUM_ADDRESS_BYTES = 20;
const $c3af9e523501759a$var$PUBLIC_KEY_BYTES = 64;
const $c3af9e523501759a$var$SIGNATURE_OFFSETS_SERIALIZED_SIZE = 11;
/**
 * Params for creating an secp256k1 instruction using a public key
 */ /**
 * Params for creating an secp256k1 instruction using an Ethereum address
 */ /**
 * Params for creating an secp256k1 instruction using a private key
 */ const $c3af9e523501759a$var$SECP256K1_INSTRUCTION_LAYOUT = $Q02IV.struct([
    $Q02IV.u8("numSignatures"),
    $Q02IV.u16("signatureOffset"),
    $Q02IV.u8("signatureInstructionIndex"),
    $Q02IV.u16("ethAddressOffset"),
    $Q02IV.u8("ethAddressInstructionIndex"),
    $Q02IV.u16("messageDataOffset"),
    $Q02IV.u16("messageDataSize"),
    $Q02IV.u8("messageInstructionIndex"),
    $Q02IV.blob(20, "ethAddress"),
    $Q02IV.blob(64, "signature"),
    $Q02IV.u8("recoveryId")
]);
class $c3af9e523501759a$export$d85dd4c1161d13c9 {
    /**
   * @internal
   */ constructor(){}
    /**
   * Public key that identifies the secp256k1 program
   */ /**
   * Construct an Ethereum address from a secp256k1 public key buffer.
   * @param {Buffer} publicKey a 64 byte secp256k1 public key buffer
   */ static publicKeyToEthAddress(publicKey) {
        $c3af9e523501759a$var$assert(publicKey.length === $c3af9e523501759a$var$PUBLIC_KEY_BYTES, `Public key must be ${$c3af9e523501759a$var$PUBLIC_KEY_BYTES} bytes but received ${publicKey.length} bytes`);
        try {
            return (0, $6ZWSX.Buffer).from((0, $J0sDk.keccak_256)($c3af9e523501759a$var$toBuffer(publicKey))).slice(-$c3af9e523501759a$var$ETHEREUM_ADDRESS_BYTES);
        } catch (error) {
            throw new Error(`Error constructing Ethereum address: ${error}`);
        }
    }
    /**
   * Create an secp256k1 instruction with a public key. The public key
   * must be a buffer that is 64 bytes long.
   */ static createInstructionWithPublicKey(params) {
        const { publicKey: publicKey, message: message, signature: signature, recoveryId: recoveryId, instructionIndex: instructionIndex } = params;
        return $c3af9e523501759a$export$d85dd4c1161d13c9.createInstructionWithEthAddress({
            ethAddress: $c3af9e523501759a$export$d85dd4c1161d13c9.publicKeyToEthAddress(publicKey),
            message: message,
            signature: signature,
            recoveryId: recoveryId,
            instructionIndex: instructionIndex
        });
    }
    /**
   * Create an secp256k1 instruction with an Ethereum address. The address
   * must be a hex string or a buffer that is 20 bytes long.
   */ static createInstructionWithEthAddress(params) {
        const { ethAddress: rawAddress, message: message, signature: signature, recoveryId: recoveryId, instructionIndex: instructionIndex = 0 } = params;
        let ethAddress;
        if (typeof rawAddress === "string") {
            if (rawAddress.startsWith("0x")) ethAddress = (0, $6ZWSX.Buffer).from(rawAddress.substr(2), "hex");
            else ethAddress = (0, $6ZWSX.Buffer).from(rawAddress, "hex");
        } else ethAddress = rawAddress;
        $c3af9e523501759a$var$assert(ethAddress.length === $c3af9e523501759a$var$ETHEREUM_ADDRESS_BYTES, `Address must be ${$c3af9e523501759a$var$ETHEREUM_ADDRESS_BYTES} bytes but received ${ethAddress.length} bytes`);
        const dataStart = 1 + $c3af9e523501759a$var$SIGNATURE_OFFSETS_SERIALIZED_SIZE;
        const ethAddressOffset = dataStart;
        const signatureOffset = dataStart + ethAddress.length;
        const messageDataOffset = signatureOffset + signature.length + 1;
        const numSignatures = 1;
        const instructionData = (0, $6ZWSX.Buffer).alloc($c3af9e523501759a$var$SECP256K1_INSTRUCTION_LAYOUT.span + message.length);
        $c3af9e523501759a$var$SECP256K1_INSTRUCTION_LAYOUT.encode({
            numSignatures: numSignatures,
            signatureOffset: signatureOffset,
            signatureInstructionIndex: instructionIndex,
            ethAddressOffset: ethAddressOffset,
            ethAddressInstructionIndex: instructionIndex,
            messageDataOffset: messageDataOffset,
            messageDataSize: message.length,
            messageInstructionIndex: instructionIndex,
            signature: $c3af9e523501759a$var$toBuffer(signature),
            ethAddress: $c3af9e523501759a$var$toBuffer(ethAddress),
            recoveryId: recoveryId
        }, instructionData);
        instructionData.fill($c3af9e523501759a$var$toBuffer(message), $c3af9e523501759a$var$SECP256K1_INSTRUCTION_LAYOUT.span);
        return new $c3af9e523501759a$export$a7a3aa8360ac9f59({
            keys: [],
            programId: $c3af9e523501759a$export$d85dd4c1161d13c9.programId,
            data: instructionData
        });
    }
    /**
   * Create an secp256k1 instruction with a private key. The private key
   * must be a buffer that is 32 bytes long.
   */ static createInstructionWithPrivateKey(params) {
        const { privateKey: pkey, message: message, instructionIndex: instructionIndex } = params;
        $c3af9e523501759a$var$assert(pkey.length === $c3af9e523501759a$var$PRIVATE_KEY_BYTES, `Private key must be ${$c3af9e523501759a$var$PRIVATE_KEY_BYTES} bytes but received ${pkey.length} bytes`);
        try {
            const privateKey = $c3af9e523501759a$var$toBuffer(pkey);
            const publicKey = $c3af9e523501759a$var$publicKeyCreate(privateKey, false).slice(1); // throw away leading byte
            const messageHash = (0, $6ZWSX.Buffer).from((0, $J0sDk.keccak_256)($c3af9e523501759a$var$toBuffer(message)));
            const [signature, recoveryId] = $c3af9e523501759a$var$ecdsaSign(messageHash, privateKey);
            return this.createInstructionWithPublicKey({
                publicKey: publicKey,
                message: message,
                signature: signature,
                recoveryId: recoveryId,
                instructionIndex: instructionIndex
            });
        } catch (error) {
            throw new Error(`Error creating instruction; ${error}`);
        }
    }
}
$c3af9e523501759a$export$d85dd4c1161d13c9.programId = new $c3af9e523501759a$export$ca8b6604d6ce14de("KeccakSecp256k11111111111111111111111111111");
var $c3af9e523501759a$var$_class2;
/**
 * Address of the stake config account which configures the rate
 * of stake warmup and cooldown as well as the slashing penalty.
 */ const $c3af9e523501759a$export$18aac71979bdd08f = new $c3af9e523501759a$export$ca8b6604d6ce14de("StakeConfig11111111111111111111111111111111");
/**
 * Stake account authority info
 */ class $c3af9e523501759a$export$9ac74ae66932a145 {
    /**
   * Create a new Authorized object
   * @param staker the stake authority
   * @param withdrawer the withdraw authority
   */ constructor(staker, withdrawer){
        /** stake authority */ this.staker = void 0;
        /** withdraw authority */ this.withdrawer = void 0;
        this.staker = staker;
        this.withdrawer = withdrawer;
    }
}
/**
 * Stake account lockup info
 */ class $c3af9e523501759a$export$e7f3941ade35598c {
    /**
   * Create a new Lockup object
   */ constructor(unixTimestamp, epoch, custodian){
        /** Unix timestamp of lockup expiration */ this.unixTimestamp = void 0;
        /** Epoch of lockup expiration */ this.epoch = void 0;
        /** Lockup custodian authority */ this.custodian = void 0;
        this.unixTimestamp = unixTimestamp;
        this.epoch = epoch;
        this.custodian = custodian;
    }
}
$c3af9e523501759a$var$_class2 = $c3af9e523501759a$export$e7f3941ade35598c;
$c3af9e523501759a$export$e7f3941ade35598c.default = new $c3af9e523501759a$var$_class2(0, 0, $c3af9e523501759a$export$ca8b6604d6ce14de.default);
/**
 * Create stake account transaction params
 */ /**
 * Create stake account with seed transaction params
 */ /**
 * Initialize stake instruction params
 */ /**
 * Delegate stake instruction params
 */ /**
 * Authorize stake instruction params
 */ /**
 * Authorize stake instruction params using a derived key
 */ /**
 * Split stake instruction params
 */ /**
 * Split with seed transaction params
 */ /**
 * Withdraw stake instruction params
 */ /**
 * Deactivate stake instruction params
 */ /**
 * Merge stake instruction params
 */ /**
 * Stake Instruction class
 */ class $c3af9e523501759a$export$aded313c3a4800f9 {
    /**
   * @internal
   */ constructor(){}
    /**
   * Decode a stake instruction and retrieve the instruction type.
   */ static decodeInstructionType(instruction) {
        this.checkProgramId(instruction.programId);
        const instructionTypeLayout = $Q02IV.u32("instruction");
        const typeIndex = instructionTypeLayout.decode(instruction.data);
        let type;
        for (const [ixType, layout] of Object.entries($c3af9e523501759a$export$c89793bd2bba8b2e))if (layout.index == typeIndex) {
            type = ixType;
            break;
        }
        if (!type) throw new Error("Instruction type incorrect; not a StakeInstruction");
        return type;
    }
    /**
   * Decode a initialize stake instruction and retrieve the instruction params.
   */ static decodeInitialize(instruction) {
        this.checkProgramId(instruction.programId);
        this.checkKeyLength(instruction.keys, 2);
        const { authorized: authorized, lockup: lockup } = $c3af9e523501759a$var$decodeData$1($c3af9e523501759a$export$c89793bd2bba8b2e.Initialize, instruction.data);
        return {
            stakePubkey: instruction.keys[0].pubkey,
            authorized: new $c3af9e523501759a$export$9ac74ae66932a145(new $c3af9e523501759a$export$ca8b6604d6ce14de(authorized.staker), new $c3af9e523501759a$export$ca8b6604d6ce14de(authorized.withdrawer)),
            lockup: new $c3af9e523501759a$export$e7f3941ade35598c(lockup.unixTimestamp, lockup.epoch, new $c3af9e523501759a$export$ca8b6604d6ce14de(lockup.custodian))
        };
    }
    /**
   * Decode a delegate stake instruction and retrieve the instruction params.
   */ static decodeDelegate(instruction) {
        this.checkProgramId(instruction.programId);
        this.checkKeyLength(instruction.keys, 6);
        $c3af9e523501759a$var$decodeData$1($c3af9e523501759a$export$c89793bd2bba8b2e.Delegate, instruction.data);
        return {
            stakePubkey: instruction.keys[0].pubkey,
            votePubkey: instruction.keys[1].pubkey,
            authorizedPubkey: instruction.keys[5].pubkey
        };
    }
    /**
   * Decode an authorize stake instruction and retrieve the instruction params.
   */ static decodeAuthorize(instruction) {
        this.checkProgramId(instruction.programId);
        this.checkKeyLength(instruction.keys, 3);
        const { newAuthorized: newAuthorized, stakeAuthorizationType: stakeAuthorizationType } = $c3af9e523501759a$var$decodeData$1($c3af9e523501759a$export$c89793bd2bba8b2e.Authorize, instruction.data);
        const o = {
            stakePubkey: instruction.keys[0].pubkey,
            authorizedPubkey: instruction.keys[2].pubkey,
            newAuthorizedPubkey: new $c3af9e523501759a$export$ca8b6604d6ce14de(newAuthorized),
            stakeAuthorizationType: {
                index: stakeAuthorizationType
            }
        };
        if (instruction.keys.length > 3) o.custodianPubkey = instruction.keys[3].pubkey;
        return o;
    }
    /**
   * Decode an authorize-with-seed stake instruction and retrieve the instruction params.
   */ static decodeAuthorizeWithSeed(instruction) {
        this.checkProgramId(instruction.programId);
        this.checkKeyLength(instruction.keys, 2);
        const { newAuthorized: newAuthorized, stakeAuthorizationType: stakeAuthorizationType, authoritySeed: authoritySeed, authorityOwner: authorityOwner } = $c3af9e523501759a$var$decodeData$1($c3af9e523501759a$export$c89793bd2bba8b2e.AuthorizeWithSeed, instruction.data);
        const o = {
            stakePubkey: instruction.keys[0].pubkey,
            authorityBase: instruction.keys[1].pubkey,
            authoritySeed: authoritySeed,
            authorityOwner: new $c3af9e523501759a$export$ca8b6604d6ce14de(authorityOwner),
            newAuthorizedPubkey: new $c3af9e523501759a$export$ca8b6604d6ce14de(newAuthorized),
            stakeAuthorizationType: {
                index: stakeAuthorizationType
            }
        };
        if (instruction.keys.length > 3) o.custodianPubkey = instruction.keys[3].pubkey;
        return o;
    }
    /**
   * Decode a split stake instruction and retrieve the instruction params.
   */ static decodeSplit(instruction) {
        this.checkProgramId(instruction.programId);
        this.checkKeyLength(instruction.keys, 3);
        const { lamports: lamports } = $c3af9e523501759a$var$decodeData$1($c3af9e523501759a$export$c89793bd2bba8b2e.Split, instruction.data);
        return {
            stakePubkey: instruction.keys[0].pubkey,
            splitStakePubkey: instruction.keys[1].pubkey,
            authorizedPubkey: instruction.keys[2].pubkey,
            lamports: lamports
        };
    }
    /**
   * Decode a merge stake instruction and retrieve the instruction params.
   */ static decodeMerge(instruction) {
        this.checkProgramId(instruction.programId);
        this.checkKeyLength(instruction.keys, 3);
        $c3af9e523501759a$var$decodeData$1($c3af9e523501759a$export$c89793bd2bba8b2e.Merge, instruction.data);
        return {
            stakePubkey: instruction.keys[0].pubkey,
            sourceStakePubKey: instruction.keys[1].pubkey,
            authorizedPubkey: instruction.keys[4].pubkey
        };
    }
    /**
   * Decode a withdraw stake instruction and retrieve the instruction params.
   */ static decodeWithdraw(instruction) {
        this.checkProgramId(instruction.programId);
        this.checkKeyLength(instruction.keys, 5);
        const { lamports: lamports } = $c3af9e523501759a$var$decodeData$1($c3af9e523501759a$export$c89793bd2bba8b2e.Withdraw, instruction.data);
        const o = {
            stakePubkey: instruction.keys[0].pubkey,
            toPubkey: instruction.keys[1].pubkey,
            authorizedPubkey: instruction.keys[4].pubkey,
            lamports: lamports
        };
        if (instruction.keys.length > 5) o.custodianPubkey = instruction.keys[5].pubkey;
        return o;
    }
    /**
   * Decode a deactivate stake instruction and retrieve the instruction params.
   */ static decodeDeactivate(instruction) {
        this.checkProgramId(instruction.programId);
        this.checkKeyLength(instruction.keys, 3);
        $c3af9e523501759a$var$decodeData$1($c3af9e523501759a$export$c89793bd2bba8b2e.Deactivate, instruction.data);
        return {
            stakePubkey: instruction.keys[0].pubkey,
            authorizedPubkey: instruction.keys[2].pubkey
        };
    }
    /**
   * @internal
   */ static checkProgramId(programId) {
        if (!programId.equals($c3af9e523501759a$export$df86f933e9f8fb15.programId)) throw new Error("invalid instruction; programId is not StakeProgram");
    }
    /**
   * @internal
   */ static checkKeyLength(keys, expectedLength) {
        if (keys.length < expectedLength) throw new Error(`invalid instruction; found ${keys.length} keys, expected at least ${expectedLength}`);
    }
}
/**
 * An enumeration of valid StakeInstructionType's
 */ /**
 * An enumeration of valid stake InstructionType's
 * @internal
 */ const $c3af9e523501759a$export$c89793bd2bba8b2e = Object.freeze({
    Initialize: {
        index: 0,
        layout: $Q02IV.struct([
            $Q02IV.u32("instruction"),
            $c3af9e523501759a$var$authorized(),
            $c3af9e523501759a$var$lockup()
        ])
    },
    Authorize: {
        index: 1,
        layout: $Q02IV.struct([
            $Q02IV.u32("instruction"),
            $c3af9e523501759a$var$publicKey("newAuthorized"),
            $Q02IV.u32("stakeAuthorizationType")
        ])
    },
    Delegate: {
        index: 2,
        layout: $Q02IV.struct([
            $Q02IV.u32("instruction")
        ])
    },
    Split: {
        index: 3,
        layout: $Q02IV.struct([
            $Q02IV.u32("instruction"),
            $Q02IV.ns64("lamports")
        ])
    },
    Withdraw: {
        index: 4,
        layout: $Q02IV.struct([
            $Q02IV.u32("instruction"),
            $Q02IV.ns64("lamports")
        ])
    },
    Deactivate: {
        index: 5,
        layout: $Q02IV.struct([
            $Q02IV.u32("instruction")
        ])
    },
    Merge: {
        index: 7,
        layout: $Q02IV.struct([
            $Q02IV.u32("instruction")
        ])
    },
    AuthorizeWithSeed: {
        index: 8,
        layout: $Q02IV.struct([
            $Q02IV.u32("instruction"),
            $c3af9e523501759a$var$publicKey("newAuthorized"),
            $Q02IV.u32("stakeAuthorizationType"),
            $c3af9e523501759a$var$rustString("authoritySeed"),
            $c3af9e523501759a$var$publicKey("authorityOwner")
        ])
    }
});
/**
 * Stake authorization type
 */ /**
 * An enumeration of valid StakeAuthorizationLayout's
 */ const $c3af9e523501759a$export$4783920eadd34361 = Object.freeze({
    Staker: {
        index: 0
    },
    Withdrawer: {
        index: 1
    }
});
/**
 * Factory class for transactions to interact with the Stake program
 */ class $c3af9e523501759a$export$df86f933e9f8fb15 {
    /**
   * @internal
   */ constructor(){}
    /**
   * Public key that identifies the Stake program
   */ /**
   * Generate an Initialize instruction to add to a Stake Create transaction
   */ static initialize(params) {
        const { stakePubkey: stakePubkey, authorized: authorized, lockup: maybeLockup } = params;
        const lockup = maybeLockup || $c3af9e523501759a$export$e7f3941ade35598c.default;
        const type = $c3af9e523501759a$export$c89793bd2bba8b2e.Initialize;
        const data = $c3af9e523501759a$var$encodeData(type, {
            authorized: {
                staker: $c3af9e523501759a$var$toBuffer(authorized.staker.toBuffer()),
                withdrawer: $c3af9e523501759a$var$toBuffer(authorized.withdrawer.toBuffer())
            },
            lockup: {
                unixTimestamp: lockup.unixTimestamp,
                epoch: lockup.epoch,
                custodian: $c3af9e523501759a$var$toBuffer(lockup.custodian.toBuffer())
            }
        });
        const instructionData = {
            keys: [
                {
                    pubkey: stakePubkey,
                    isSigner: false,
                    isWritable: true
                },
                {
                    pubkey: $c3af9e523501759a$export$970d0190cdb3a8e9,
                    isSigner: false,
                    isWritable: false
                }
            ],
            programId: this.programId,
            data: data
        };
        return new $c3af9e523501759a$export$a7a3aa8360ac9f59(instructionData);
    }
    /**
   * Generate a Transaction that creates a new Stake account at
   *   an address generated with `from`, a seed, and the Stake programId
   */ static createAccountWithSeed(params) {
        const transaction = new $c3af9e523501759a$export$febc5573c75cefb0();
        transaction.add($c3af9e523501759a$export$d8c4e17726848113.createAccountWithSeed({
            fromPubkey: params.fromPubkey,
            newAccountPubkey: params.stakePubkey,
            basePubkey: params.basePubkey,
            seed: params.seed,
            lamports: params.lamports,
            space: this.space,
            programId: this.programId
        }));
        const { stakePubkey: stakePubkey, authorized: authorized, lockup: lockup } = params;
        return transaction.add(this.initialize({
            stakePubkey: stakePubkey,
            authorized: authorized,
            lockup: lockup
        }));
    }
    /**
   * Generate a Transaction that creates a new Stake account
   */ static createAccount(params) {
        const transaction = new $c3af9e523501759a$export$febc5573c75cefb0();
        transaction.add($c3af9e523501759a$export$d8c4e17726848113.createAccount({
            fromPubkey: params.fromPubkey,
            newAccountPubkey: params.stakePubkey,
            lamports: params.lamports,
            space: this.space,
            programId: this.programId
        }));
        const { stakePubkey: stakePubkey, authorized: authorized, lockup: lockup } = params;
        return transaction.add(this.initialize({
            stakePubkey: stakePubkey,
            authorized: authorized,
            lockup: lockup
        }));
    }
    /**
   * Generate a Transaction that delegates Stake tokens to a validator
   * Vote PublicKey. This transaction can also be used to redelegate Stake
   * to a new validator Vote PublicKey.
   */ static delegate(params) {
        const { stakePubkey: stakePubkey, authorizedPubkey: authorizedPubkey, votePubkey: votePubkey } = params;
        const type = $c3af9e523501759a$export$c89793bd2bba8b2e.Delegate;
        const data = $c3af9e523501759a$var$encodeData(type);
        return new $c3af9e523501759a$export$febc5573c75cefb0().add({
            keys: [
                {
                    pubkey: stakePubkey,
                    isSigner: false,
                    isWritable: true
                },
                {
                    pubkey: votePubkey,
                    isSigner: false,
                    isWritable: false
                },
                {
                    pubkey: $c3af9e523501759a$export$393aa1412d47050e,
                    isSigner: false,
                    isWritable: false
                },
                {
                    pubkey: $c3af9e523501759a$export$ca994171317280ea,
                    isSigner: false,
                    isWritable: false
                },
                {
                    pubkey: $c3af9e523501759a$export$18aac71979bdd08f,
                    isSigner: false,
                    isWritable: false
                },
                {
                    pubkey: authorizedPubkey,
                    isSigner: true,
                    isWritable: false
                }
            ],
            programId: this.programId,
            data: data
        });
    }
    /**
   * Generate a Transaction that authorizes a new PublicKey as Staker
   * or Withdrawer on the Stake account.
   */ static authorize(params) {
        const { stakePubkey: stakePubkey, authorizedPubkey: authorizedPubkey, newAuthorizedPubkey: newAuthorizedPubkey, stakeAuthorizationType: stakeAuthorizationType, custodianPubkey: custodianPubkey } = params;
        const type = $c3af9e523501759a$export$c89793bd2bba8b2e.Authorize;
        const data = $c3af9e523501759a$var$encodeData(type, {
            newAuthorized: $c3af9e523501759a$var$toBuffer(newAuthorizedPubkey.toBuffer()),
            stakeAuthorizationType: stakeAuthorizationType.index
        });
        const keys = [
            {
                pubkey: stakePubkey,
                isSigner: false,
                isWritable: true
            },
            {
                pubkey: $c3af9e523501759a$export$393aa1412d47050e,
                isSigner: false,
                isWritable: true
            },
            {
                pubkey: authorizedPubkey,
                isSigner: true,
                isWritable: false
            }
        ];
        if (custodianPubkey) keys.push({
            pubkey: custodianPubkey,
            isSigner: false,
            isWritable: false
        });
        return new $c3af9e523501759a$export$febc5573c75cefb0().add({
            keys: keys,
            programId: this.programId,
            data: data
        });
    }
    /**
   * Generate a Transaction that authorizes a new PublicKey as Staker
   * or Withdrawer on the Stake account.
   */ static authorizeWithSeed(params) {
        const { stakePubkey: stakePubkey, authorityBase: authorityBase, authoritySeed: authoritySeed, authorityOwner: authorityOwner, newAuthorizedPubkey: newAuthorizedPubkey, stakeAuthorizationType: stakeAuthorizationType, custodianPubkey: custodianPubkey } = params;
        const type = $c3af9e523501759a$export$c89793bd2bba8b2e.AuthorizeWithSeed;
        const data = $c3af9e523501759a$var$encodeData(type, {
            newAuthorized: $c3af9e523501759a$var$toBuffer(newAuthorizedPubkey.toBuffer()),
            stakeAuthorizationType: stakeAuthorizationType.index,
            authoritySeed: authoritySeed,
            authorityOwner: $c3af9e523501759a$var$toBuffer(authorityOwner.toBuffer())
        });
        const keys = [
            {
                pubkey: stakePubkey,
                isSigner: false,
                isWritable: true
            },
            {
                pubkey: authorityBase,
                isSigner: true,
                isWritable: false
            },
            {
                pubkey: $c3af9e523501759a$export$393aa1412d47050e,
                isSigner: false,
                isWritable: false
            }
        ];
        if (custodianPubkey) keys.push({
            pubkey: custodianPubkey,
            isSigner: false,
            isWritable: false
        });
        return new $c3af9e523501759a$export$febc5573c75cefb0().add({
            keys: keys,
            programId: this.programId,
            data: data
        });
    }
    /**
   * @internal
   */ static splitInstruction(params) {
        const { stakePubkey: stakePubkey, authorizedPubkey: authorizedPubkey, splitStakePubkey: splitStakePubkey, lamports: lamports } = params;
        const type = $c3af9e523501759a$export$c89793bd2bba8b2e.Split;
        const data = $c3af9e523501759a$var$encodeData(type, {
            lamports: lamports
        });
        return new $c3af9e523501759a$export$a7a3aa8360ac9f59({
            keys: [
                {
                    pubkey: stakePubkey,
                    isSigner: false,
                    isWritable: true
                },
                {
                    pubkey: splitStakePubkey,
                    isSigner: false,
                    isWritable: true
                },
                {
                    pubkey: authorizedPubkey,
                    isSigner: true,
                    isWritable: false
                }
            ],
            programId: this.programId,
            data: data
        });
    }
    /**
   * Generate a Transaction that splits Stake tokens into another stake account
   */ static split(params) {
        const transaction = new $c3af9e523501759a$export$febc5573c75cefb0();
        transaction.add($c3af9e523501759a$export$d8c4e17726848113.createAccount({
            fromPubkey: params.authorizedPubkey,
            newAccountPubkey: params.splitStakePubkey,
            lamports: 0,
            space: this.space,
            programId: this.programId
        }));
        return transaction.add(this.splitInstruction(params));
    }
    /**
   * Generate a Transaction that splits Stake tokens into another account
   * derived from a base public key and seed
   */ static splitWithSeed(params) {
        const { stakePubkey: stakePubkey, authorizedPubkey: authorizedPubkey, splitStakePubkey: splitStakePubkey, basePubkey: basePubkey, seed: seed, lamports: lamports } = params;
        const transaction = new $c3af9e523501759a$export$febc5573c75cefb0();
        transaction.add($c3af9e523501759a$export$d8c4e17726848113.allocate({
            accountPubkey: splitStakePubkey,
            basePubkey: basePubkey,
            seed: seed,
            space: this.space,
            programId: this.programId
        }));
        return transaction.add(this.splitInstruction({
            stakePubkey: stakePubkey,
            authorizedPubkey: authorizedPubkey,
            splitStakePubkey: splitStakePubkey,
            lamports: lamports
        }));
    }
    /**
   * Generate a Transaction that merges Stake accounts.
   */ static merge(params) {
        const { stakePubkey: stakePubkey, sourceStakePubKey: sourceStakePubKey, authorizedPubkey: authorizedPubkey } = params;
        const type = $c3af9e523501759a$export$c89793bd2bba8b2e.Merge;
        const data = $c3af9e523501759a$var$encodeData(type);
        return new $c3af9e523501759a$export$febc5573c75cefb0().add({
            keys: [
                {
                    pubkey: stakePubkey,
                    isSigner: false,
                    isWritable: true
                },
                {
                    pubkey: sourceStakePubKey,
                    isSigner: false,
                    isWritable: true
                },
                {
                    pubkey: $c3af9e523501759a$export$393aa1412d47050e,
                    isSigner: false,
                    isWritable: false
                },
                {
                    pubkey: $c3af9e523501759a$export$ca994171317280ea,
                    isSigner: false,
                    isWritable: false
                },
                {
                    pubkey: authorizedPubkey,
                    isSigner: true,
                    isWritable: false
                }
            ],
            programId: this.programId,
            data: data
        });
    }
    /**
   * Generate a Transaction that withdraws deactivated Stake tokens.
   */ static withdraw(params) {
        const { stakePubkey: stakePubkey, authorizedPubkey: authorizedPubkey, toPubkey: toPubkey, lamports: lamports, custodianPubkey: custodianPubkey } = params;
        const type = $c3af9e523501759a$export$c89793bd2bba8b2e.Withdraw;
        const data = $c3af9e523501759a$var$encodeData(type, {
            lamports: lamports
        });
        const keys = [
            {
                pubkey: stakePubkey,
                isSigner: false,
                isWritable: true
            },
            {
                pubkey: toPubkey,
                isSigner: false,
                isWritable: true
            },
            {
                pubkey: $c3af9e523501759a$export$393aa1412d47050e,
                isSigner: false,
                isWritable: false
            },
            {
                pubkey: $c3af9e523501759a$export$ca994171317280ea,
                isSigner: false,
                isWritable: false
            },
            {
                pubkey: authorizedPubkey,
                isSigner: true,
                isWritable: false
            }
        ];
        if (custodianPubkey) keys.push({
            pubkey: custodianPubkey,
            isSigner: false,
            isWritable: false
        });
        return new $c3af9e523501759a$export$febc5573c75cefb0().add({
            keys: keys,
            programId: this.programId,
            data: data
        });
    }
    /**
   * Generate a Transaction that deactivates Stake tokens.
   */ static deactivate(params) {
        const { stakePubkey: stakePubkey, authorizedPubkey: authorizedPubkey } = params;
        const type = $c3af9e523501759a$export$c89793bd2bba8b2e.Deactivate;
        const data = $c3af9e523501759a$var$encodeData(type);
        return new $c3af9e523501759a$export$febc5573c75cefb0().add({
            keys: [
                {
                    pubkey: stakePubkey,
                    isSigner: false,
                    isWritable: true
                },
                {
                    pubkey: $c3af9e523501759a$export$393aa1412d47050e,
                    isSigner: false,
                    isWritable: false
                },
                {
                    pubkey: authorizedPubkey,
                    isSigner: true,
                    isWritable: false
                }
            ],
            programId: this.programId,
            data: data
        });
    }
}
$c3af9e523501759a$export$df86f933e9f8fb15.programId = new $c3af9e523501759a$export$ca8b6604d6ce14de("Stake11111111111111111111111111111111111111");
/**
 * Max space of a Stake account
 *
 * This is generated from the solana-stake-program StakeState struct as
 * `StakeState::size_of()`:
 * https://docs.rs/solana-stake-program/latest/solana_stake_program/stake_state/enum.StakeState.html
 */ $c3af9e523501759a$export$df86f933e9f8fb15.space = 200;
/**
 * Vote account info
 */ class $c3af9e523501759a$export$3f9d1b16ff840d7 {
    /** [0, 100] */ constructor(nodePubkey, authorizedVoter, authorizedWithdrawer, commission){
        this.nodePubkey = void 0;
        this.authorizedVoter = void 0;
        this.authorizedWithdrawer = void 0;
        this.commission = void 0;
        this.nodePubkey = nodePubkey;
        this.authorizedVoter = authorizedVoter;
        this.authorizedWithdrawer = authorizedWithdrawer;
        this.commission = commission;
    }
}
/**
 * Create vote account transaction params
 */ /**
 * InitializeAccount instruction params
 */ /**
 * Authorize instruction params
 */ /**
 * AuthorizeWithSeed instruction params
 */ /**
 * Withdraw from vote account transaction params
 */ /**
 * Vote Instruction class
 */ class $c3af9e523501759a$export$af8300401fc56047 {
    /**
   * @internal
   */ constructor(){}
    /**
   * Decode a vote instruction and retrieve the instruction type.
   */ static decodeInstructionType(instruction) {
        this.checkProgramId(instruction.programId);
        const instructionTypeLayout = $Q02IV.u32("instruction");
        const typeIndex = instructionTypeLayout.decode(instruction.data);
        let type;
        for (const [ixType, layout] of Object.entries($c3af9e523501759a$var$VOTE_INSTRUCTION_LAYOUTS))if (layout.index == typeIndex) {
            type = ixType;
            break;
        }
        if (!type) throw new Error("Instruction type incorrect; not a VoteInstruction");
        return type;
    }
    /**
   * Decode an initialize vote instruction and retrieve the instruction params.
   */ static decodeInitializeAccount(instruction) {
        this.checkProgramId(instruction.programId);
        this.checkKeyLength(instruction.keys, 4);
        const { voteInit: voteInit } = $c3af9e523501759a$var$decodeData$1($c3af9e523501759a$var$VOTE_INSTRUCTION_LAYOUTS.InitializeAccount, instruction.data);
        return {
            votePubkey: instruction.keys[0].pubkey,
            nodePubkey: instruction.keys[3].pubkey,
            voteInit: new $c3af9e523501759a$export$3f9d1b16ff840d7(new $c3af9e523501759a$export$ca8b6604d6ce14de(voteInit.nodePubkey), new $c3af9e523501759a$export$ca8b6604d6ce14de(voteInit.authorizedVoter), new $c3af9e523501759a$export$ca8b6604d6ce14de(voteInit.authorizedWithdrawer), voteInit.commission)
        };
    }
    /**
   * Decode an authorize instruction and retrieve the instruction params.
   */ static decodeAuthorize(instruction) {
        this.checkProgramId(instruction.programId);
        this.checkKeyLength(instruction.keys, 3);
        const { newAuthorized: newAuthorized, voteAuthorizationType: voteAuthorizationType } = $c3af9e523501759a$var$decodeData$1($c3af9e523501759a$var$VOTE_INSTRUCTION_LAYOUTS.Authorize, instruction.data);
        return {
            votePubkey: instruction.keys[0].pubkey,
            authorizedPubkey: instruction.keys[2].pubkey,
            newAuthorizedPubkey: new $c3af9e523501759a$export$ca8b6604d6ce14de(newAuthorized),
            voteAuthorizationType: {
                index: voteAuthorizationType
            }
        };
    }
    /**
   * Decode an authorize instruction and retrieve the instruction params.
   */ static decodeAuthorizeWithSeed(instruction) {
        this.checkProgramId(instruction.programId);
        this.checkKeyLength(instruction.keys, 3);
        const { voteAuthorizeWithSeedArgs: { currentAuthorityDerivedKeyOwnerPubkey: currentAuthorityDerivedKeyOwnerPubkey, currentAuthorityDerivedKeySeed: currentAuthorityDerivedKeySeed, newAuthorized: newAuthorized, voteAuthorizationType: voteAuthorizationType } } = $c3af9e523501759a$var$decodeData$1($c3af9e523501759a$var$VOTE_INSTRUCTION_LAYOUTS.AuthorizeWithSeed, instruction.data);
        return {
            currentAuthorityDerivedKeyBasePubkey: instruction.keys[2].pubkey,
            currentAuthorityDerivedKeyOwnerPubkey: new $c3af9e523501759a$export$ca8b6604d6ce14de(currentAuthorityDerivedKeyOwnerPubkey),
            currentAuthorityDerivedKeySeed: currentAuthorityDerivedKeySeed,
            newAuthorizedPubkey: new $c3af9e523501759a$export$ca8b6604d6ce14de(newAuthorized),
            voteAuthorizationType: {
                index: voteAuthorizationType
            },
            votePubkey: instruction.keys[0].pubkey
        };
    }
    /**
   * Decode a withdraw instruction and retrieve the instruction params.
   */ static decodeWithdraw(instruction) {
        this.checkProgramId(instruction.programId);
        this.checkKeyLength(instruction.keys, 3);
        const { lamports: lamports } = $c3af9e523501759a$var$decodeData$1($c3af9e523501759a$var$VOTE_INSTRUCTION_LAYOUTS.Withdraw, instruction.data);
        return {
            votePubkey: instruction.keys[0].pubkey,
            authorizedWithdrawerPubkey: instruction.keys[2].pubkey,
            lamports: lamports,
            toPubkey: instruction.keys[1].pubkey
        };
    }
    /**
   * @internal
   */ static checkProgramId(programId) {
        if (!programId.equals($c3af9e523501759a$export$83db2bc702bee1eb.programId)) throw new Error("invalid instruction; programId is not VoteProgram");
    }
    /**
   * @internal
   */ static checkKeyLength(keys, expectedLength) {
        if (keys.length < expectedLength) throw new Error(`invalid instruction; found ${keys.length} keys, expected at least ${expectedLength}`);
    }
}
/**
 * An enumeration of valid VoteInstructionType's
 */ /** @internal */ const $c3af9e523501759a$var$VOTE_INSTRUCTION_LAYOUTS = Object.freeze({
    InitializeAccount: {
        index: 0,
        layout: $Q02IV.struct([
            $Q02IV.u32("instruction"),
            $c3af9e523501759a$var$voteInit()
        ])
    },
    Authorize: {
        index: 1,
        layout: $Q02IV.struct([
            $Q02IV.u32("instruction"),
            $c3af9e523501759a$var$publicKey("newAuthorized"),
            $Q02IV.u32("voteAuthorizationType")
        ])
    },
    Withdraw: {
        index: 3,
        layout: $Q02IV.struct([
            $Q02IV.u32("instruction"),
            $Q02IV.ns64("lamports")
        ])
    },
    AuthorizeWithSeed: {
        index: 10,
        layout: $Q02IV.struct([
            $Q02IV.u32("instruction"),
            $c3af9e523501759a$var$voteAuthorizeWithSeedArgs()
        ])
    }
});
/**
 * VoteAuthorize type
 */ /**
 * An enumeration of valid VoteAuthorization layouts.
 */ const $c3af9e523501759a$export$3f2a92246fa9f71c = Object.freeze({
    Voter: {
        index: 0
    },
    Withdrawer: {
        index: 1
    }
});
/**
 * Factory class for transactions to interact with the Vote program
 */ class $c3af9e523501759a$export$83db2bc702bee1eb {
    /**
   * @internal
   */ constructor(){}
    /**
   * Public key that identifies the Vote program
   */ /**
   * Generate an Initialize instruction.
   */ static initializeAccount(params) {
        const { votePubkey: votePubkey, nodePubkey: nodePubkey, voteInit: voteInit } = params;
        const type = $c3af9e523501759a$var$VOTE_INSTRUCTION_LAYOUTS.InitializeAccount;
        const data = $c3af9e523501759a$var$encodeData(type, {
            voteInit: {
                nodePubkey: $c3af9e523501759a$var$toBuffer(voteInit.nodePubkey.toBuffer()),
                authorizedVoter: $c3af9e523501759a$var$toBuffer(voteInit.authorizedVoter.toBuffer()),
                authorizedWithdrawer: $c3af9e523501759a$var$toBuffer(voteInit.authorizedWithdrawer.toBuffer()),
                commission: voteInit.commission
            }
        });
        const instructionData = {
            keys: [
                {
                    pubkey: votePubkey,
                    isSigner: false,
                    isWritable: true
                },
                {
                    pubkey: $c3af9e523501759a$export$970d0190cdb3a8e9,
                    isSigner: false,
                    isWritable: false
                },
                {
                    pubkey: $c3af9e523501759a$export$393aa1412d47050e,
                    isSigner: false,
                    isWritable: false
                },
                {
                    pubkey: nodePubkey,
                    isSigner: true,
                    isWritable: false
                }
            ],
            programId: this.programId,
            data: data
        };
        return new $c3af9e523501759a$export$a7a3aa8360ac9f59(instructionData);
    }
    /**
   * Generate a transaction that creates a new Vote account.
   */ static createAccount(params) {
        const transaction = new $c3af9e523501759a$export$febc5573c75cefb0();
        transaction.add($c3af9e523501759a$export$d8c4e17726848113.createAccount({
            fromPubkey: params.fromPubkey,
            newAccountPubkey: params.votePubkey,
            lamports: params.lamports,
            space: this.space,
            programId: this.programId
        }));
        return transaction.add(this.initializeAccount({
            votePubkey: params.votePubkey,
            nodePubkey: params.voteInit.nodePubkey,
            voteInit: params.voteInit
        }));
    }
    /**
   * Generate a transaction that authorizes a new Voter or Withdrawer on the Vote account.
   */ static authorize(params) {
        const { votePubkey: votePubkey, authorizedPubkey: authorizedPubkey, newAuthorizedPubkey: newAuthorizedPubkey, voteAuthorizationType: voteAuthorizationType } = params;
        const type = $c3af9e523501759a$var$VOTE_INSTRUCTION_LAYOUTS.Authorize;
        const data = $c3af9e523501759a$var$encodeData(type, {
            newAuthorized: $c3af9e523501759a$var$toBuffer(newAuthorizedPubkey.toBuffer()),
            voteAuthorizationType: voteAuthorizationType.index
        });
        const keys = [
            {
                pubkey: votePubkey,
                isSigner: false,
                isWritable: true
            },
            {
                pubkey: $c3af9e523501759a$export$393aa1412d47050e,
                isSigner: false,
                isWritable: false
            },
            {
                pubkey: authorizedPubkey,
                isSigner: true,
                isWritable: false
            }
        ];
        return new $c3af9e523501759a$export$febc5573c75cefb0().add({
            keys: keys,
            programId: this.programId,
            data: data
        });
    }
    /**
   * Generate a transaction that authorizes a new Voter or Withdrawer on the Vote account
   * where the current Voter or Withdrawer authority is a derived key.
   */ static authorizeWithSeed(params) {
        const { currentAuthorityDerivedKeyBasePubkey: currentAuthorityDerivedKeyBasePubkey, currentAuthorityDerivedKeyOwnerPubkey: currentAuthorityDerivedKeyOwnerPubkey, currentAuthorityDerivedKeySeed: currentAuthorityDerivedKeySeed, newAuthorizedPubkey: newAuthorizedPubkey, voteAuthorizationType: voteAuthorizationType, votePubkey: votePubkey } = params;
        const type = $c3af9e523501759a$var$VOTE_INSTRUCTION_LAYOUTS.AuthorizeWithSeed;
        const data = $c3af9e523501759a$var$encodeData(type, {
            voteAuthorizeWithSeedArgs: {
                currentAuthorityDerivedKeyOwnerPubkey: $c3af9e523501759a$var$toBuffer(currentAuthorityDerivedKeyOwnerPubkey.toBuffer()),
                currentAuthorityDerivedKeySeed: currentAuthorityDerivedKeySeed,
                newAuthorized: $c3af9e523501759a$var$toBuffer(newAuthorizedPubkey.toBuffer()),
                voteAuthorizationType: voteAuthorizationType.index
            }
        });
        const keys = [
            {
                pubkey: votePubkey,
                isSigner: false,
                isWritable: true
            },
            {
                pubkey: $c3af9e523501759a$export$393aa1412d47050e,
                isSigner: false,
                isWritable: false
            },
            {
                pubkey: currentAuthorityDerivedKeyBasePubkey,
                isSigner: true,
                isWritable: false
            }
        ];
        return new $c3af9e523501759a$export$febc5573c75cefb0().add({
            keys: keys,
            programId: this.programId,
            data: data
        });
    }
    /**
   * Generate a transaction to withdraw from a Vote account.
   */ static withdraw(params) {
        const { votePubkey: votePubkey, authorizedWithdrawerPubkey: authorizedWithdrawerPubkey, lamports: lamports, toPubkey: toPubkey } = params;
        const type = $c3af9e523501759a$var$VOTE_INSTRUCTION_LAYOUTS.Withdraw;
        const data = $c3af9e523501759a$var$encodeData(type, {
            lamports: lamports
        });
        const keys = [
            {
                pubkey: votePubkey,
                isSigner: false,
                isWritable: true
            },
            {
                pubkey: toPubkey,
                isSigner: false,
                isWritable: true
            },
            {
                pubkey: authorizedWithdrawerPubkey,
                isSigner: true,
                isWritable: false
            }
        ];
        return new $c3af9e523501759a$export$febc5573c75cefb0().add({
            keys: keys,
            programId: this.programId,
            data: data
        });
    }
    /**
   * Generate a transaction to withdraw safely from a Vote account.
   *
   * This function was created as a safeguard for vote accounts running validators, `safeWithdraw`
   * checks that the withdraw amount will not exceed the specified balance while leaving enough left
   * to cover rent. If you wish to close the vote account by withdrawing the full amount, call the
   * `withdraw` method directly.
   */ static safeWithdraw(params, currentVoteAccountBalance, rentExemptMinimum) {
        if (params.lamports > currentVoteAccountBalance - rentExemptMinimum) throw new Error("Withdraw will leave vote account with insuffcient funds.");
        return $c3af9e523501759a$export$83db2bc702bee1eb.withdraw(params);
    }
}
$c3af9e523501759a$export$83db2bc702bee1eb.programId = new $c3af9e523501759a$export$ca8b6604d6ce14de("Vote111111111111111111111111111111111111111");
/**
 * Max space of a Vote account
 *
 * This is generated from the solana-vote-program VoteState struct as
 * `VoteState::size_of()`:
 * https://docs.rs/solana-vote-program/1.9.5/solana_vote_program/vote_state/struct.VoteState.html#method.size_of
 *
 * KEEP IN SYNC WITH `VoteState::size_of()` in https://github.com/solana-labs/solana/blob/a474cb24b9238f5edcc982f65c0b37d4a1046f7e/sdk/program/src/vote/state/mod.rs#L340-L342
 */ $c3af9e523501759a$export$83db2bc702bee1eb.space = 3731;
const $c3af9e523501759a$export$afdb09d3afdde87c = new $c3af9e523501759a$export$ca8b6604d6ce14de("Va1idator1nfo111111111111111111111111111111");
/**
 * @internal
 */ /**
 * Info used to identity validators.
 */ const $c3af9e523501759a$var$InfoString = (0, $kZFCD.type)({
    name: (0, $kZFCD.string)(),
    website: (0, $kZFCD.optional)((0, $kZFCD.string)()),
    details: (0, $kZFCD.optional)((0, $kZFCD.string)()),
    keybaseUsername: (0, $kZFCD.optional)((0, $kZFCD.string)())
});
/**
 * ValidatorInfo class
 */ class $c3af9e523501759a$export$152d279cf067309b {
    /**
   * Construct a valid ValidatorInfo
   *
   * @param key validator public key
   * @param info validator information
   */ constructor(key, info){
        /**
     * validator public key
     */ this.key = void 0;
        /**
     * validator information
     */ this.info = void 0;
        this.key = key;
        this.info = info;
    }
    /**
   * Deserialize ValidatorInfo from the config account data. Exactly two config
   * keys are required in the data.
   *
   * @param buffer config account data
   * @return null if info was not found
   */ static fromConfigData(buffer) {
        let byteArray = [
            ...buffer
        ];
        const configKeyCount = $c3af9e523501759a$var$decodeLength(byteArray);
        if (configKeyCount !== 2) return null;
        const configKeys = [];
        for(let i = 0; i < 2; i++){
            const publicKey = new $c3af9e523501759a$export$ca8b6604d6ce14de(byteArray.slice(0, $c3af9e523501759a$export$84fc0a248cc54343));
            byteArray = byteArray.slice($c3af9e523501759a$export$84fc0a248cc54343);
            const isSigner = byteArray.slice(0, 1)[0] === 1;
            byteArray = byteArray.slice(1);
            configKeys.push({
                publicKey: publicKey,
                isSigner: isSigner
            });
        }
        if (configKeys[0].publicKey.equals($c3af9e523501759a$export$afdb09d3afdde87c)) {
            if (configKeys[1].isSigner) {
                const rawInfo = $c3af9e523501759a$var$rustString().decode((0, $6ZWSX.Buffer).from(byteArray));
                const info = JSON.parse(rawInfo);
                (0, $kZFCD.assert)(info, $c3af9e523501759a$var$InfoString);
                return new $c3af9e523501759a$export$152d279cf067309b(configKeys[1].publicKey, info);
            }
        }
        return null;
    }
}
const $c3af9e523501759a$export$90bca02a3aea0768 = new $c3af9e523501759a$export$ca8b6604d6ce14de("Vote111111111111111111111111111111111111111");
/**
 * History of how many credits earned by the end of each epoch
 */ /**
 * See https://github.com/solana-labs/solana/blob/8a12ed029cfa38d4a45400916c2463fb82bbec8c/programs/vote_api/src/vote_state.rs#L68-L88
 *
 * @internal
 */ const $c3af9e523501759a$var$VoteAccountLayout = $Q02IV.struct([
    $c3af9e523501759a$var$publicKey("nodePubkey"),
    $c3af9e523501759a$var$publicKey("authorizedWithdrawer"),
    $Q02IV.u8("commission"),
    $Q02IV.nu64(),
    // votes.length
    $Q02IV.seq($Q02IV.struct([
        $Q02IV.nu64("slot"),
        $Q02IV.u32("confirmationCount")
    ]), $Q02IV.offset($Q02IV.u32(), -8), "votes"),
    $Q02IV.u8("rootSlotValid"),
    $Q02IV.nu64("rootSlot"),
    $Q02IV.nu64(),
    // authorizedVoters.length
    $Q02IV.seq($Q02IV.struct([
        $Q02IV.nu64("epoch"),
        $c3af9e523501759a$var$publicKey("authorizedVoter")
    ]), $Q02IV.offset($Q02IV.u32(), -8), "authorizedVoters"),
    $Q02IV.struct([
        $Q02IV.seq($Q02IV.struct([
            $c3af9e523501759a$var$publicKey("authorizedPubkey"),
            $Q02IV.nu64("epochOfLastAuthorizedSwitch"),
            $Q02IV.nu64("targetEpoch")
        ]), 32, "buf"),
        $Q02IV.nu64("idx"),
        $Q02IV.u8("isEmpty")
    ], "priorVoters"),
    $Q02IV.nu64(),
    // epochCredits.length
    $Q02IV.seq($Q02IV.struct([
        $Q02IV.nu64("epoch"),
        $Q02IV.nu64("credits"),
        $Q02IV.nu64("prevCredits")
    ]), $Q02IV.offset($Q02IV.u32(), -8), "epochCredits"),
    $Q02IV.struct([
        $Q02IV.nu64("slot"),
        $Q02IV.nu64("timestamp")
    ], "lastTimestamp")
]);
/**
 * VoteAccount class
 */ class $c3af9e523501759a$export$89ef186f708d638b {
    /**
   * @internal
   */ constructor(args){
        this.nodePubkey = void 0;
        this.authorizedWithdrawer = void 0;
        this.commission = void 0;
        this.rootSlot = void 0;
        this.votes = void 0;
        this.authorizedVoters = void 0;
        this.priorVoters = void 0;
        this.epochCredits = void 0;
        this.lastTimestamp = void 0;
        this.nodePubkey = args.nodePubkey;
        this.authorizedWithdrawer = args.authorizedWithdrawer;
        this.commission = args.commission;
        this.rootSlot = args.rootSlot;
        this.votes = args.votes;
        this.authorizedVoters = args.authorizedVoters;
        this.priorVoters = args.priorVoters;
        this.epochCredits = args.epochCredits;
        this.lastTimestamp = args.lastTimestamp;
    }
    /**
   * Deserialize VoteAccount from the account data.
   *
   * @param buffer account data
   * @return VoteAccount
   */ static fromAccountData(buffer) {
        const versionOffset = 4;
        const va = $c3af9e523501759a$var$VoteAccountLayout.decode($c3af9e523501759a$var$toBuffer(buffer), versionOffset);
        let rootSlot = va.rootSlot;
        if (!va.rootSlotValid) rootSlot = null;
        return new $c3af9e523501759a$export$89ef186f708d638b({
            nodePubkey: new $c3af9e523501759a$export$ca8b6604d6ce14de(va.nodePubkey),
            authorizedWithdrawer: new $c3af9e523501759a$export$ca8b6604d6ce14de(va.authorizedWithdrawer),
            commission: va.commission,
            votes: va.votes,
            rootSlot: rootSlot,
            authorizedVoters: va.authorizedVoters.map($c3af9e523501759a$var$parseAuthorizedVoter),
            priorVoters: $c3af9e523501759a$var$getPriorVoters(va.priorVoters),
            epochCredits: va.epochCredits,
            lastTimestamp: va.lastTimestamp
        });
    }
}
function $c3af9e523501759a$var$parseAuthorizedVoter({ authorizedVoter: authorizedVoter, epoch: epoch }) {
    return {
        epoch: epoch,
        authorizedVoter: new $c3af9e523501759a$export$ca8b6604d6ce14de(authorizedVoter)
    };
}
function $c3af9e523501759a$var$parsePriorVoters({ authorizedPubkey: authorizedPubkey, epochOfLastAuthorizedSwitch: epochOfLastAuthorizedSwitch, targetEpoch: targetEpoch }) {
    return {
        authorizedPubkey: new $c3af9e523501759a$export$ca8b6604d6ce14de(authorizedPubkey),
        epochOfLastAuthorizedSwitch: epochOfLastAuthorizedSwitch,
        targetEpoch: targetEpoch
    };
}
function $c3af9e523501759a$var$getPriorVoters({ buf: buf, idx: idx, isEmpty: isEmpty }) {
    if (isEmpty) return [];
    return [
        ...buf.slice(idx + 1).map($c3af9e523501759a$var$parsePriorVoters),
        ...buf.slice(0, idx).map($c3af9e523501759a$var$parsePriorVoters)
    ];
}
const $c3af9e523501759a$var$endpoint = {
    http: {
        devnet: "http://api.devnet.solana.com",
        testnet: "http://api.testnet.solana.com",
        "mainnet-beta": "http://api.mainnet-beta.solana.com/"
    },
    https: {
        devnet: "https://api.devnet.solana.com",
        testnet: "https://api.testnet.solana.com",
        "mainnet-beta": "https://api.mainnet-beta.solana.com/"
    }
};
/**
 * Retrieves the RPC API URL for the specified cluster
 * @param {Cluster} [cluster="devnet"] - The cluster name of the RPC API URL to use. Possible options: 'devnet' | 'testnet' | 'mainnet-beta'
 * @param {boolean} [tls="http"] - Use TLS when connecting to cluster.
 *
 * @returns {string} URL string of the RPC endpoint
 */ function $c3af9e523501759a$export$11656287b4eb76ff(cluster, tls) {
    const key = tls === false ? "http" : "https";
    if (!cluster) return $c3af9e523501759a$var$endpoint[key]["devnet"];
    const url = $c3af9e523501759a$var$endpoint[key][cluster];
    if (!url) throw new Error(`Unknown ${key} cluster: ${cluster}`);
    return url;
}
/**
 * Send and confirm a raw transaction
 *
 * If `commitment` option is not specified, defaults to 'max' commitment.
 *
 * @param {Connection} connection
 * @param {Buffer} rawTransaction
 * @param {TransactionConfirmationStrategy} confirmationStrategy
 * @param {ConfirmOptions} [options]
 * @returns {Promise<TransactionSignature>}
 */ /**
 * @deprecated Calling `sendAndConfirmRawTransaction()` without a `confirmationStrategy`
 * is no longer supported and will be removed in a future version.
 */ // eslint-disable-next-line no-redeclare
// eslint-disable-next-line no-redeclare
async function $c3af9e523501759a$export$554271b88fdb7843(connection, rawTransaction, confirmationStrategyOrConfirmOptions, maybeConfirmOptions) {
    let confirmationStrategy;
    let options;
    if (confirmationStrategyOrConfirmOptions && Object.prototype.hasOwnProperty.call(confirmationStrategyOrConfirmOptions, "lastValidBlockHeight")) {
        confirmationStrategy = confirmationStrategyOrConfirmOptions;
        options = maybeConfirmOptions;
    } else if (confirmationStrategyOrConfirmOptions && Object.prototype.hasOwnProperty.call(confirmationStrategyOrConfirmOptions, "nonceValue")) {
        confirmationStrategy = confirmationStrategyOrConfirmOptions;
        options = maybeConfirmOptions;
    } else options = confirmationStrategyOrConfirmOptions;
    const sendOptions = options && {
        skipPreflight: options.skipPreflight,
        preflightCommitment: options.preflightCommitment || options.commitment,
        minContextSlot: options.minContextSlot
    };
    const signature = await connection.sendRawTransaction(rawTransaction, sendOptions);
    const commitment = options && options.commitment;
    const confirmationPromise = confirmationStrategy ? connection.confirmTransaction(confirmationStrategy, commitment) : connection.confirmTransaction(signature, commitment);
    const status = (await confirmationPromise).value;
    if (status.err) throw new Error(`Raw transaction ${signature} failed (${JSON.stringify(status)})`);
    return signature;
}
/**
 * There are 1-billion lamports in one SOL
 */ const $c3af9e523501759a$export$5f6a2f2669741bbe = 1000000000;

});
parcelRegister("kE5x4", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.hash_to_ristretto255 = module.exports.hashToRistretto255 = module.exports.RistrettoPoint = module.exports.encodeToCurve = module.exports.hashToCurve = module.exports.edwardsToMontgomeryPriv = module.exports.edwardsToMontgomery = module.exports.edwardsToMontgomeryPub = module.exports.x25519 = module.exports.ed25519ph = module.exports.ed25519ctx = module.exports.ed25519 = module.exports.ED25519_TORSION_SUBGROUP = void 0;

var $3dtER = parcelRequire("3dtER");

var $3Bcdj = parcelRequire("3Bcdj");

var $qoWOx = parcelRequire("qoWOx");

var $kiLeO = parcelRequire("kiLeO");

var $2D9sF = parcelRequire("2D9sF");

var $esaJO = parcelRequire("esaJO");

var $rkPJ6 = parcelRequire("rkPJ6");
/**
 * ed25519 Twisted Edwards curve with following addons:
 * - X25519 ECDH
 * - Ristretto cofactor elimination
 * - Elligator hash-to-group / point indistinguishability
 */ const $f07bd5acd6595f86$var$ED25519_P = BigInt("57896044618658097711785492504343953926634992332820282019728792003956564819949");
// √(-1) aka √(a) aka 2^((p-1)/4)
const $f07bd5acd6595f86$var$ED25519_SQRT_M1 = BigInt("19681161376707505956807079304988542015446066515923890162744021073123829784752");
// prettier-ignore
const $f07bd5acd6595f86$var$_0n = BigInt(0), $f07bd5acd6595f86$var$_1n = BigInt(1), $f07bd5acd6595f86$var$_2n = BigInt(2), $f07bd5acd6595f86$var$_5n = BigInt(5);
// prettier-ignore
const $f07bd5acd6595f86$var$_10n = BigInt(10), $f07bd5acd6595f86$var$_20n = BigInt(20), $f07bd5acd6595f86$var$_40n = BigInt(40), $f07bd5acd6595f86$var$_80n = BigInt(80);
function $f07bd5acd6595f86$var$ed25519_pow_2_252_3(x) {
    const P = $f07bd5acd6595f86$var$ED25519_P;
    const x2 = x * x % P;
    const b2 = x2 * x % P; // x^3, 11
    const b4 = (0, $2D9sF.pow2)(b2, $f07bd5acd6595f86$var$_2n, P) * b2 % P; // x^15, 1111
    const b5 = (0, $2D9sF.pow2)(b4, $f07bd5acd6595f86$var$_1n, P) * x % P; // x^31
    const b10 = (0, $2D9sF.pow2)(b5, $f07bd5acd6595f86$var$_5n, P) * b5 % P;
    const b20 = (0, $2D9sF.pow2)(b10, $f07bd5acd6595f86$var$_10n, P) * b10 % P;
    const b40 = (0, $2D9sF.pow2)(b20, $f07bd5acd6595f86$var$_20n, P) * b20 % P;
    const b80 = (0, $2D9sF.pow2)(b40, $f07bd5acd6595f86$var$_40n, P) * b40 % P;
    const b160 = (0, $2D9sF.pow2)(b80, $f07bd5acd6595f86$var$_80n, P) * b80 % P;
    const b240 = (0, $2D9sF.pow2)(b160, $f07bd5acd6595f86$var$_80n, P) * b80 % P;
    const b250 = (0, $2D9sF.pow2)(b240, $f07bd5acd6595f86$var$_10n, P) * b10 % P;
    const pow_p_5_8 = (0, $2D9sF.pow2)(b250, $f07bd5acd6595f86$var$_2n, P) * x % P;
    // ^ To pow to (p+3)/8, multiply it by x.
    return {
        pow_p_5_8: pow_p_5_8,
        b2: b2
    };
}
function $f07bd5acd6595f86$var$adjustScalarBytes(bytes) {
    // Section 5: For X25519, in order to decode 32 random bytes as an integer scalar,
    // set the three least significant bits of the first byte
    bytes[0] &= 248; // 0b1111_1000
    // and the most significant bit of the last to zero,
    bytes[31] &= 127; // 0b0111_1111
    // set the second most significant bit of the last byte to 1
    bytes[31] |= 64; // 0b0100_0000
    return bytes;
}
// sqrt(u/v)
function $f07bd5acd6595f86$var$uvRatio(u, v) {
    const P = $f07bd5acd6595f86$var$ED25519_P;
    const v3 = (0, $2D9sF.mod)(v * v * v, P); // v³
    const v7 = (0, $2D9sF.mod)(v3 * v3 * v, P); // v⁷
    // (p+3)/8 and (p-5)/8
    const pow = $f07bd5acd6595f86$var$ed25519_pow_2_252_3(u * v7).pow_p_5_8;
    let x = (0, $2D9sF.mod)(u * v3 * pow, P); // (uv³)(uv⁷)^(p-5)/8
    const vx2 = (0, $2D9sF.mod)(v * x * x, P); // vx²
    const root1 = x; // First root candidate
    const root2 = (0, $2D9sF.mod)(x * $f07bd5acd6595f86$var$ED25519_SQRT_M1, P); // Second root candidate
    const useRoot1 = vx2 === u; // If vx² = u (mod p), x is a square root
    const useRoot2 = vx2 === (0, $2D9sF.mod)(-u, P); // If vx² = -u, set x <-- x * 2^((p-1)/4)
    const noRoot = vx2 === (0, $2D9sF.mod)(-u * $f07bd5acd6595f86$var$ED25519_SQRT_M1, P); // There is no valid root, vx² = -u√(-1)
    if (useRoot1) x = root1;
    if (useRoot2 || noRoot) x = root2; // We return root2 anyway, for const-time
    if ((0, $2D9sF.isNegativeLE)(x, P)) x = (0, $2D9sF.mod)(-x, P);
    return {
        isValid: useRoot1 || useRoot2,
        value: x
    };
}
// Just in case
module.exports.ED25519_TORSION_SUBGROUP = [
    "0100000000000000000000000000000000000000000000000000000000000000",
    "c7176a703d4dd84fba3c0b760d10670f2a2053fa2c39ccc64ec7fd7792ac037a",
    "0000000000000000000000000000000000000000000000000000000000000080",
    "26e8958fc2b227b045c3f489f2ef98f0d5dfac05d3c63339b13802886d53fc05",
    "ecffffffffffffffffffffffffffffffffffffffffffffffffffffffffffff7f",
    "26e8958fc2b227b045c3f489f2ef98f0d5dfac05d3c63339b13802886d53fc85",
    "0000000000000000000000000000000000000000000000000000000000000000",
    "c7176a703d4dd84fba3c0b760d10670f2a2053fa2c39ccc64ec7fd7792ac03fa"
];
const $f07bd5acd6595f86$var$Fp = (0, $2D9sF.Field)($f07bd5acd6595f86$var$ED25519_P, undefined, true);
const $f07bd5acd6595f86$var$ed25519Defaults = {
    // Param: a
    a: BigInt(-1),
    // d is equal to -121665/121666 over finite field.
    // Negative number is P - number, and division is invert(number, P)
    d: BigInt("37095705934669439343138083508754565189542113879843219016388785533085940283555"),
    Fp: // Finite field 𝔽p over which we'll do calculations; 2n**255n - 19n
    $f07bd5acd6595f86$var$Fp,
    // Subgroup order: how many points curve has
    // 2n**252n + 27742317777372353535851937790883648493n;
    n: BigInt("7237005577332262213973186563042994240857116359379907606001950938285454250989"),
    // Cofactor
    h: BigInt(8),
    // Base point (x, y) aka generator point
    Gx: BigInt("15112221349535400772501151409588531511454012693041857206046113283949847762202"),
    Gy: BigInt("46316835694926478169428394003475163141307993866256225615783033603165251855960"),
    hash: $3dtER.sha512,
    randomBytes: $3Bcdj.randomBytes,
    adjustScalarBytes: $f07bd5acd6595f86$var$adjustScalarBytes,
    uvRatio: // dom2
    // Ratio of u to v. Allows us to combine inversion and square root. Uses algo from RFC8032 5.1.3.
    // Constant-time, u/√v
    $f07bd5acd6595f86$var$uvRatio
};
module.exports.ed25519 = (0, $qoWOx.twistedEdwards)($f07bd5acd6595f86$var$ed25519Defaults);
function $f07bd5acd6595f86$var$ed25519_domain(data, ctx, phflag) {
    if (ctx.length > 255) throw new Error("Context is too big");
    return (0, $3Bcdj.concatBytes)((0, $3Bcdj.utf8ToBytes)("SigEd25519 no Ed25519 collisions"), new Uint8Array([
        phflag ? 1 : 0,
        ctx.length
    ]), ctx, data);
}
module.exports.ed25519ctx = (0, $qoWOx.twistedEdwards)({
    ...$f07bd5acd6595f86$var$ed25519Defaults,
    domain: $f07bd5acd6595f86$var$ed25519_domain
});
module.exports.ed25519ph = (0, $qoWOx.twistedEdwards)({
    ...$f07bd5acd6595f86$var$ed25519Defaults,
    domain: $f07bd5acd6595f86$var$ed25519_domain,
    prehash: $3dtER.sha512
});
module.exports.x25519 = (()=>(0, $kiLeO.montgomery)({
        P: $f07bd5acd6595f86$var$ED25519_P,
        a: BigInt(486662),
        montgomeryBits: 255,
        nByteLength: 32,
        Gu: BigInt(9),
        powPminus2: (x)=>{
            const P = $f07bd5acd6595f86$var$ED25519_P;
            // x^(p-2) aka x^(2^255-21)
            const { pow_p_5_8: pow_p_5_8, b2: b2 } = $f07bd5acd6595f86$var$ed25519_pow_2_252_3(x);
            return (0, $2D9sF.mod)((0, $2D9sF.pow2)(pow_p_5_8, BigInt(3), P) * b2, P);
        },
        adjustScalarBytes: $f07bd5acd6595f86$var$adjustScalarBytes,
        randomBytes: $3Bcdj.randomBytes
    }))();
/**
 * Converts ed25519 public key to x25519 public key. Uses formula:
 * * `(u, v) = ((1+y)/(1-y), sqrt(-486664)*u/x)`
 * * `(x, y) = (sqrt(-486664)*u/v, (u-1)/(u+1))`
 * @example
 *   const someonesPub = ed25519.getPublicKey(ed25519.utils.randomPrivateKey());
 *   const aPriv = x25519.utils.randomPrivateKey();
 *   x25519.getSharedSecret(aPriv, edwardsToMontgomeryPub(someonesPub))
 */ function $f07bd5acd6595f86$var$edwardsToMontgomeryPub(edwardsPub) {
    const { y: y } = module.exports.ed25519.ExtendedPoint.fromHex(edwardsPub);
    const _1n = BigInt(1);
    return $f07bd5acd6595f86$var$Fp.toBytes($f07bd5acd6595f86$var$Fp.create((_1n + y) * $f07bd5acd6595f86$var$Fp.inv(_1n - y)));
}
module.exports.edwardsToMontgomeryPub = $f07bd5acd6595f86$var$edwardsToMontgomeryPub;
module.exports.edwardsToMontgomery = $f07bd5acd6595f86$var$edwardsToMontgomeryPub; // deprecated
/**
 * Converts ed25519 secret key to x25519 secret key.
 * @example
 *   const someonesPub = x25519.getPublicKey(x25519.utils.randomPrivateKey());
 *   const aPriv = ed25519.utils.randomPrivateKey();
 *   x25519.getSharedSecret(edwardsToMontgomeryPriv(aPriv), someonesPub)
 */ function $f07bd5acd6595f86$var$edwardsToMontgomeryPriv(edwardsPriv) {
    const hashed = $f07bd5acd6595f86$var$ed25519Defaults.hash(edwardsPriv.subarray(0, 32));
    return $f07bd5acd6595f86$var$ed25519Defaults.adjustScalarBytes(hashed).subarray(0, 32);
}
module.exports.edwardsToMontgomeryPriv = $f07bd5acd6595f86$var$edwardsToMontgomeryPriv;
// Hash To Curve Elligator2 Map (NOTE: different from ristretto255 elligator)
// NOTE: very important part is usage of FpSqrtEven for ELL2_C1_EDWARDS, since
// SageMath returns different root first and everything falls apart
const $f07bd5acd6595f86$var$ELL2_C1 = ($f07bd5acd6595f86$var$Fp.ORDER + BigInt(3)) / BigInt(8); // 1. c1 = (q + 3) / 8       # Integer arithmetic
const $f07bd5acd6595f86$var$ELL2_C2 = $f07bd5acd6595f86$var$Fp.pow($f07bd5acd6595f86$var$_2n, $f07bd5acd6595f86$var$ELL2_C1); // 2. c2 = 2^c1
const $f07bd5acd6595f86$var$ELL2_C3 = $f07bd5acd6595f86$var$Fp.sqrt($f07bd5acd6595f86$var$Fp.neg($f07bd5acd6595f86$var$Fp.ONE)); // 3. c3 = sqrt(-1)
const $f07bd5acd6595f86$var$ELL2_C4 = ($f07bd5acd6595f86$var$Fp.ORDER - BigInt(5)) / BigInt(8); // 4. c4 = (q - 5) / 8       # Integer arithmetic
const $f07bd5acd6595f86$var$ELL2_J = BigInt(486662);
// prettier-ignore
function $f07bd5acd6595f86$var$map_to_curve_elligator2_curve25519(u) {
    let tv1 = $f07bd5acd6595f86$var$Fp.sqr(u); //  1.  tv1 = u^2
    tv1 = $f07bd5acd6595f86$var$Fp.mul(tv1, $f07bd5acd6595f86$var$_2n); //  2.  tv1 = 2 * tv1
    let xd = $f07bd5acd6595f86$var$Fp.add(tv1, $f07bd5acd6595f86$var$Fp.ONE); //  3.   xd = tv1 + 1         # Nonzero: -1 is square (mod p), tv1 is not
    let x1n = $f07bd5acd6595f86$var$Fp.neg($f07bd5acd6595f86$var$ELL2_J); //  4.  x1n = -J              # x1 = x1n / xd = -J / (1 + 2 * u^2)
    let tv2 = $f07bd5acd6595f86$var$Fp.sqr(xd); //  5.  tv2 = xd^2
    let gxd = $f07bd5acd6595f86$var$Fp.mul(tv2, xd); //  6.  gxd = tv2 * xd        # gxd = xd^3
    let gx1 = $f07bd5acd6595f86$var$Fp.mul(tv1, $f07bd5acd6595f86$var$ELL2_J); //  7.  gx1 = J * tv1         # x1n + J * xd
    gx1 = $f07bd5acd6595f86$var$Fp.mul(gx1, x1n); //  8.  gx1 = gx1 * x1n       # x1n^2 + J * x1n * xd
    gx1 = $f07bd5acd6595f86$var$Fp.add(gx1, tv2); //  9.  gx1 = gx1 + tv2       # x1n^2 + J * x1n * xd + xd^2
    gx1 = $f07bd5acd6595f86$var$Fp.mul(gx1, x1n); //  10. gx1 = gx1 * x1n       # x1n^3 + J * x1n^2 * xd + x1n * xd^2
    let tv3 = $f07bd5acd6595f86$var$Fp.sqr(gxd); //  11. tv3 = gxd^2
    tv2 = $f07bd5acd6595f86$var$Fp.sqr(tv3); //  12. tv2 = tv3^2           # gxd^4
    tv3 = $f07bd5acd6595f86$var$Fp.mul(tv3, gxd); //  13. tv3 = tv3 * gxd       # gxd^3
    tv3 = $f07bd5acd6595f86$var$Fp.mul(tv3, gx1); //  14. tv3 = tv3 * gx1       # gx1 * gxd^3
    tv2 = $f07bd5acd6595f86$var$Fp.mul(tv2, tv3); //  15. tv2 = tv2 * tv3       # gx1 * gxd^7
    let y11 = $f07bd5acd6595f86$var$Fp.pow(tv2, $f07bd5acd6595f86$var$ELL2_C4); //  16. y11 = tv2^c4        # (gx1 * gxd^7)^((p - 5) / 8)
    y11 = $f07bd5acd6595f86$var$Fp.mul(y11, tv3); //  17. y11 = y11 * tv3       # gx1*gxd^3*(gx1*gxd^7)^((p-5)/8)
    let y12 = $f07bd5acd6595f86$var$Fp.mul(y11, $f07bd5acd6595f86$var$ELL2_C3); //  18. y12 = y11 * c3
    tv2 = $f07bd5acd6595f86$var$Fp.sqr(y11); //  19. tv2 = y11^2
    tv2 = $f07bd5acd6595f86$var$Fp.mul(tv2, gxd); //  20. tv2 = tv2 * gxd
    let e1 = $f07bd5acd6595f86$var$Fp.eql(tv2, gx1); //  21.  e1 = tv2 == gx1
    let y1 = $f07bd5acd6595f86$var$Fp.cmov(y12, y11, e1); //  22.  y1 = CMOV(y12, y11, e1)  # If g(x1) is square, this is its sqrt
    let x2n = $f07bd5acd6595f86$var$Fp.mul(x1n, tv1); //  23. x2n = x1n * tv1       # x2 = x2n / xd = 2 * u^2 * x1n / xd
    let y21 = $f07bd5acd6595f86$var$Fp.mul(y11, u); //  24. y21 = y11 * u
    y21 = $f07bd5acd6595f86$var$Fp.mul(y21, $f07bd5acd6595f86$var$ELL2_C2); //  25. y21 = y21 * c2
    let y22 = $f07bd5acd6595f86$var$Fp.mul(y21, $f07bd5acd6595f86$var$ELL2_C3); //  26. y22 = y21 * c3
    let gx2 = $f07bd5acd6595f86$var$Fp.mul(gx1, tv1); //  27. gx2 = gx1 * tv1       # g(x2) = gx2 / gxd = 2 * u^2 * g(x1)
    tv2 = $f07bd5acd6595f86$var$Fp.sqr(y21); //  28. tv2 = y21^2
    tv2 = $f07bd5acd6595f86$var$Fp.mul(tv2, gxd); //  29. tv2 = tv2 * gxd
    let e2 = $f07bd5acd6595f86$var$Fp.eql(tv2, gx2); //  30.  e2 = tv2 == gx2
    let y2 = $f07bd5acd6595f86$var$Fp.cmov(y22, y21, e2); //  31.  y2 = CMOV(y22, y21, e2)  # If g(x2) is square, this is its sqrt
    tv2 = $f07bd5acd6595f86$var$Fp.sqr(y1); //  32. tv2 = y1^2
    tv2 = $f07bd5acd6595f86$var$Fp.mul(tv2, gxd); //  33. tv2 = tv2 * gxd
    let e3 = $f07bd5acd6595f86$var$Fp.eql(tv2, gx1); //  34.  e3 = tv2 == gx1
    let xn = $f07bd5acd6595f86$var$Fp.cmov(x2n, x1n, e3); //  35.  xn = CMOV(x2n, x1n, e3)  # If e3, x = x1, else x = x2
    let y = $f07bd5acd6595f86$var$Fp.cmov(y2, y1, e3); //  36.   y = CMOV(y2, y1, e3)    # If e3, y = y1, else y = y2
    let e4 = $f07bd5acd6595f86$var$Fp.isOdd(y); //  37.  e4 = sgn0(y) == 1        # Fix sign of y
    y = $f07bd5acd6595f86$var$Fp.cmov(y, $f07bd5acd6595f86$var$Fp.neg(y), e3 !== e4); //  38.   y = CMOV(y, -y, e3 XOR e4)
    return {
        xMn: xn,
        xMd: xd,
        yMn: y,
        yMd: $f07bd5acd6595f86$var$_1n
    }; //  39. return (xn, xd, y, 1)
}
const $f07bd5acd6595f86$var$ELL2_C1_EDWARDS = (0, $2D9sF.FpSqrtEven)($f07bd5acd6595f86$var$Fp, $f07bd5acd6595f86$var$Fp.neg(BigInt(486664))); // sgn0(c1) MUST equal 0
function $f07bd5acd6595f86$var$map_to_curve_elligator2_edwards25519(u) {
    const { xMn: xMn, xMd: xMd, yMn: yMn, yMd: yMd } = $f07bd5acd6595f86$var$map_to_curve_elligator2_curve25519(u); //  1.  (xMn, xMd, yMn, yMd) =
    // map_to_curve_elligator2_curve25519(u)
    let xn = $f07bd5acd6595f86$var$Fp.mul(xMn, yMd); //  2.  xn = xMn * yMd
    xn = $f07bd5acd6595f86$var$Fp.mul(xn, $f07bd5acd6595f86$var$ELL2_C1_EDWARDS); //  3.  xn = xn * c1
    let xd = $f07bd5acd6595f86$var$Fp.mul(xMd, yMn); //  4.  xd = xMd * yMn    # xn / xd = c1 * xM / yM
    let yn = $f07bd5acd6595f86$var$Fp.sub(xMn, xMd); //  5.  yn = xMn - xMd
    let yd = $f07bd5acd6595f86$var$Fp.add(xMn, xMd); //  6.  yd = xMn + xMd    # (n / d - 1) / (n / d + 1) = (n - d) / (n + d)
    let tv1 = $f07bd5acd6595f86$var$Fp.mul(xd, yd); //  7. tv1 = xd * yd
    let e = $f07bd5acd6595f86$var$Fp.eql(tv1, $f07bd5acd6595f86$var$Fp.ZERO); //  8.   e = tv1 == 0
    xn = $f07bd5acd6595f86$var$Fp.cmov(xn, $f07bd5acd6595f86$var$Fp.ZERO, e); //  9.  xn = CMOV(xn, 0, e)
    xd = $f07bd5acd6595f86$var$Fp.cmov(xd, $f07bd5acd6595f86$var$Fp.ONE, e); //  10. xd = CMOV(xd, 1, e)
    yn = $f07bd5acd6595f86$var$Fp.cmov(yn, $f07bd5acd6595f86$var$Fp.ONE, e); //  11. yn = CMOV(yn, 1, e)
    yd = $f07bd5acd6595f86$var$Fp.cmov(yd, $f07bd5acd6595f86$var$Fp.ONE, e); //  12. yd = CMOV(yd, 1, e)
    const inv = $f07bd5acd6595f86$var$Fp.invertBatch([
        xd,
        yd
    ]); // batch division
    return {
        x: $f07bd5acd6595f86$var$Fp.mul(xn, inv[0]),
        y: $f07bd5acd6595f86$var$Fp.mul(yn, inv[1])
    }; //  13. return (xn, xd, yn, yd)
}
const $f07bd5acd6595f86$var$htf = /* @__PURE__ */ (()=>(0, $rkPJ6.createHasher)(module.exports.ed25519.ExtendedPoint, (scalars)=>$f07bd5acd6595f86$var$map_to_curve_elligator2_edwards25519(scalars[0]), {
        DST: "edwards25519_XMD:SHA-512_ELL2_RO_",
        encodeDST: "edwards25519_XMD:SHA-512_ELL2_NU_",
        p: $f07bd5acd6595f86$var$Fp.ORDER,
        m: 1,
        k: 128,
        expand: "xmd",
        hash: $3dtER.sha512
    }))();
module.exports.hashToCurve = (()=>$f07bd5acd6595f86$var$htf.hashToCurve)();
module.exports.encodeToCurve = (()=>$f07bd5acd6595f86$var$htf.encodeToCurve)();
function $f07bd5acd6595f86$var$assertRstPoint(other) {
    if (!(other instanceof $f07bd5acd6595f86$var$RistPoint)) throw new Error("RistrettoPoint expected");
}
// √(-1) aka √(a) aka 2^((p-1)/4)
const $f07bd5acd6595f86$var$SQRT_M1 = $f07bd5acd6595f86$var$ED25519_SQRT_M1;
// √(ad - 1)
const $f07bd5acd6595f86$var$SQRT_AD_MINUS_ONE = BigInt("25063068953384623474111414158702152701244531502492656460079210482610430750235");
// 1 / √(a-d)
const $f07bd5acd6595f86$var$INVSQRT_A_MINUS_D = BigInt("54469307008909316920995813868745141605393597292927456921205312896311721017578");
// 1-d²
const $f07bd5acd6595f86$var$ONE_MINUS_D_SQ = BigInt("1159843021668779879193775521855586647937357759715417654439879720876111806838");
// (d-1)²
const $f07bd5acd6595f86$var$D_MINUS_ONE_SQ = BigInt("40440834346308536858101042469323190826248399146238708352240133220865137265952");
// Calculates 1/√(number)
const $f07bd5acd6595f86$var$invertSqrt = (number)=>$f07bd5acd6595f86$var$uvRatio($f07bd5acd6595f86$var$_1n, number);
const $f07bd5acd6595f86$var$MAX_255B = BigInt("0x7fffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffff");
const $f07bd5acd6595f86$var$bytes255ToNumberLE = (bytes)=>module.exports.ed25519.CURVE.Fp.create((0, $esaJO.bytesToNumberLE)(bytes) & $f07bd5acd6595f86$var$MAX_255B);
// Computes Elligator map for Ristretto
// https://ristretto.group/formulas/elligator.html
function $f07bd5acd6595f86$var$calcElligatorRistrettoMap(r0) {
    const { d: d } = module.exports.ed25519.CURVE;
    const P = module.exports.ed25519.CURVE.Fp.ORDER;
    const mod = module.exports.ed25519.CURVE.Fp.create;
    const r = mod($f07bd5acd6595f86$var$SQRT_M1 * r0 * r0); // 1
    const Ns = mod((r + $f07bd5acd6595f86$var$_1n) * $f07bd5acd6595f86$var$ONE_MINUS_D_SQ); // 2
    let c = BigInt(-1); // 3
    const D = mod((c - d * r) * mod(r + d)); // 4
    let { isValid: Ns_D_is_sq, value: s } = $f07bd5acd6595f86$var$uvRatio(Ns, D); // 5
    let s_ = mod(s * r0); // 6
    if (!(0, $2D9sF.isNegativeLE)(s_, P)) s_ = mod(-s_);
    if (!Ns_D_is_sq) s = s_; // 7
    if (!Ns_D_is_sq) c = r; // 8
    const Nt = mod(c * (r - $f07bd5acd6595f86$var$_1n) * $f07bd5acd6595f86$var$D_MINUS_ONE_SQ - D); // 9
    const s2 = s * s;
    const W0 = mod((s + s) * D); // 10
    const W1 = mod(Nt * $f07bd5acd6595f86$var$SQRT_AD_MINUS_ONE); // 11
    const W2 = mod($f07bd5acd6595f86$var$_1n - s2); // 12
    const W3 = mod($f07bd5acd6595f86$var$_1n + s2); // 13
    return new module.exports.ed25519.ExtendedPoint(mod(W0 * W3), mod(W2 * W1), mod(W1 * W3), mod(W0 * W2));
}
/**
 * Each ed25519/ExtendedPoint has 8 different equivalent points. This can be
 * a source of bugs for protocols like ring signatures. Ristretto was created to solve this.
 * Ristretto point operates in X:Y:Z:T extended coordinates like ExtendedPoint,
 * but it should work in its own namespace: do not combine those two.
 * https://datatracker.ietf.org/doc/html/draft-irtf-cfrg-ristretto255-decaf448
 */ class $f07bd5acd6595f86$var$RistPoint {
    // Private property to discourage combining ExtendedPoint + RistrettoPoint
    // Always use Ristretto encoding/decoding instead.
    constructor(ep){
        this.ep = ep;
    }
    static fromAffine(ap) {
        return new $f07bd5acd6595f86$var$RistPoint(module.exports.ed25519.ExtendedPoint.fromAffine(ap));
    }
    /**
     * Takes uniform output of 64-byte hash function like sha512 and converts it to `RistrettoPoint`.
     * The hash-to-group operation applies Elligator twice and adds the results.
     * **Note:** this is one-way map, there is no conversion from point to hash.
     * https://ristretto.group/formulas/elligator.html
     * @param hex 64-byte output of a hash function
     */ static hashToCurve(hex) {
        hex = (0, $esaJO.ensureBytes)("ristrettoHash", hex, 64);
        const r1 = $f07bd5acd6595f86$var$bytes255ToNumberLE(hex.slice(0, 32));
        const R1 = $f07bd5acd6595f86$var$calcElligatorRistrettoMap(r1);
        const r2 = $f07bd5acd6595f86$var$bytes255ToNumberLE(hex.slice(32, 64));
        const R2 = $f07bd5acd6595f86$var$calcElligatorRistrettoMap(r2);
        return new $f07bd5acd6595f86$var$RistPoint(R1.add(R2));
    }
    /**
     * Converts ristretto-encoded string to ristretto point.
     * https://ristretto.group/formulas/decoding.html
     * @param hex Ristretto-encoded 32 bytes. Not every 32-byte string is valid ristretto encoding
     */ static fromHex(hex) {
        hex = (0, $esaJO.ensureBytes)("ristrettoHex", hex, 32);
        const { a: a, d: d } = module.exports.ed25519.CURVE;
        const P = module.exports.ed25519.CURVE.Fp.ORDER;
        const mod = module.exports.ed25519.CURVE.Fp.create;
        const emsg = "RistrettoPoint.fromHex: the hex is not valid encoding of RistrettoPoint";
        const s = $f07bd5acd6595f86$var$bytes255ToNumberLE(hex);
        // 1. Check that s_bytes is the canonical encoding of a field element, or else abort.
        // 3. Check that s is non-negative, or else abort
        if (!(0, $esaJO.equalBytes)((0, $esaJO.numberToBytesLE)(s, 32), hex) || (0, $2D9sF.isNegativeLE)(s, P)) throw new Error(emsg);
        const s2 = mod(s * s);
        const u1 = mod($f07bd5acd6595f86$var$_1n + a * s2); // 4 (a is -1)
        const u2 = mod($f07bd5acd6595f86$var$_1n - a * s2); // 5
        const u1_2 = mod(u1 * u1);
        const u2_2 = mod(u2 * u2);
        const v = mod(a * d * u1_2 - u2_2); // 6
        const { isValid: isValid, value: I } = $f07bd5acd6595f86$var$invertSqrt(mod(v * u2_2)); // 7
        const Dx = mod(I * u2); // 8
        const Dy = mod(I * Dx * v); // 9
        let x = mod((s + s) * Dx); // 10
        if ((0, $2D9sF.isNegativeLE)(x, P)) x = mod(-x); // 10
        const y = mod(u1 * Dy); // 11
        const t = mod(x * y); // 12
        if (!isValid || (0, $2D9sF.isNegativeLE)(t, P) || y === $f07bd5acd6595f86$var$_0n) throw new Error(emsg);
        return new $f07bd5acd6595f86$var$RistPoint(new module.exports.ed25519.ExtendedPoint(x, y, $f07bd5acd6595f86$var$_1n, t));
    }
    /**
     * Encodes ristretto point to Uint8Array.
     * https://ristretto.group/formulas/encoding.html
     */ toRawBytes() {
        let { ex: x, ey: y, ez: z, et: t } = this.ep;
        const P = module.exports.ed25519.CURVE.Fp.ORDER;
        const mod = module.exports.ed25519.CURVE.Fp.create;
        const u1 = mod(mod(z + y) * mod(z - y)); // 1
        const u2 = mod(x * y); // 2
        // Square root always exists
        const u2sq = mod(u2 * u2);
        const { value: invsqrt } = $f07bd5acd6595f86$var$invertSqrt(mod(u1 * u2sq)); // 3
        const D1 = mod(invsqrt * u1); // 4
        const D2 = mod(invsqrt * u2); // 5
        const zInv = mod(D1 * D2 * t); // 6
        let D; // 7
        if ((0, $2D9sF.isNegativeLE)(t * zInv, P)) {
            let _x = mod(y * $f07bd5acd6595f86$var$SQRT_M1);
            let _y = mod(x * $f07bd5acd6595f86$var$SQRT_M1);
            x = _x;
            y = _y;
            D = mod(D1 * $f07bd5acd6595f86$var$INVSQRT_A_MINUS_D);
        } else D = D2; // 8
        if ((0, $2D9sF.isNegativeLE)(x * zInv, P)) y = mod(-y); // 9
        let s = mod((z - y) * D); // 10 (check footer's note, no sqrt(-a))
        if ((0, $2D9sF.isNegativeLE)(s, P)) s = mod(-s);
        return (0, $esaJO.numberToBytesLE)(s, 32); // 11
    }
    toHex() {
        return (0, $esaJO.bytesToHex)(this.toRawBytes());
    }
    toString() {
        return this.toHex();
    }
    // Compare one point to another.
    equals(other) {
        $f07bd5acd6595f86$var$assertRstPoint(other);
        const { ex: X1, ey: Y1 } = this.ep;
        const { ex: X2, ey: Y2 } = other.ep;
        const mod = module.exports.ed25519.CURVE.Fp.create;
        // (x1 * y2 == y1 * x2) | (y1 * y2 == x1 * x2)
        const one = mod(X1 * Y2) === mod(Y1 * X2);
        const two = mod(Y1 * Y2) === mod(X1 * X2);
        return one || two;
    }
    add(other) {
        $f07bd5acd6595f86$var$assertRstPoint(other);
        return new $f07bd5acd6595f86$var$RistPoint(this.ep.add(other.ep));
    }
    subtract(other) {
        $f07bd5acd6595f86$var$assertRstPoint(other);
        return new $f07bd5acd6595f86$var$RistPoint(this.ep.subtract(other.ep));
    }
    multiply(scalar) {
        return new $f07bd5acd6595f86$var$RistPoint(this.ep.multiply(scalar));
    }
    multiplyUnsafe(scalar) {
        return new $f07bd5acd6595f86$var$RistPoint(this.ep.multiplyUnsafe(scalar));
    }
}
module.exports.RistrettoPoint = (()=>{
    if (!$f07bd5acd6595f86$var$RistPoint.BASE) $f07bd5acd6595f86$var$RistPoint.BASE = new $f07bd5acd6595f86$var$RistPoint(module.exports.ed25519.ExtendedPoint.BASE);
    if (!$f07bd5acd6595f86$var$RistPoint.ZERO) $f07bd5acd6595f86$var$RistPoint.ZERO = new $f07bd5acd6595f86$var$RistPoint(module.exports.ed25519.ExtendedPoint.ZERO);
    return $f07bd5acd6595f86$var$RistPoint;
})();
// Hashing to ristretto255. https://www.rfc-editor.org/rfc/rfc9380#appendix-B
const $f07bd5acd6595f86$var$hashToRistretto255 = (msg, options)=>{
    const d = options.DST;
    const DST = typeof d === "string" ? (0, $3Bcdj.utf8ToBytes)(d) : d;
    const uniform_bytes = (0, $rkPJ6.expand_message_xmd)(msg, DST, 64, $3dtER.sha512);
    const P = $f07bd5acd6595f86$var$RistPoint.hashToCurve(uniform_bytes);
    return P;
};
module.exports.hashToRistretto255 = $f07bd5acd6595f86$var$hashToRistretto255;
module.exports.hash_to_ristretto255 = module.exports.hashToRistretto255; // legacy

});
parcelRegister("3dtER", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.sha384 = module.exports.sha512_256 = module.exports.sha512_224 = module.exports.sha512 = module.exports.SHA512 = void 0;

var $g9W9K = parcelRequire("g9W9K");

var $eDgKs = parcelRequire("eDgKs");

var $3Bcdj = parcelRequire("3Bcdj");
// Round contants (first 32 bits of the fractional parts of the cube roots of the first 80 primes 2..409):
// prettier-ignore
const [$2579977b4e52adba$var$SHA512_Kh, $2579977b4e52adba$var$SHA512_Kl] = /* @__PURE__ */ (()=>$eDgKs.default.split([
        "0x428a2f98d728ae22",
        "0x7137449123ef65cd",
        "0xb5c0fbcfec4d3b2f",
        "0xe9b5dba58189dbbc",
        "0x3956c25bf348b538",
        "0x59f111f1b605d019",
        "0x923f82a4af194f9b",
        "0xab1c5ed5da6d8118",
        "0xd807aa98a3030242",
        "0x12835b0145706fbe",
        "0x243185be4ee4b28c",
        "0x550c7dc3d5ffb4e2",
        "0x72be5d74f27b896f",
        "0x80deb1fe3b1696b1",
        "0x9bdc06a725c71235",
        "0xc19bf174cf692694",
        "0xe49b69c19ef14ad2",
        "0xefbe4786384f25e3",
        "0x0fc19dc68b8cd5b5",
        "0x240ca1cc77ac9c65",
        "0x2de92c6f592b0275",
        "0x4a7484aa6ea6e483",
        "0x5cb0a9dcbd41fbd4",
        "0x76f988da831153b5",
        "0x983e5152ee66dfab",
        "0xa831c66d2db43210",
        "0xb00327c898fb213f",
        "0xbf597fc7beef0ee4",
        "0xc6e00bf33da88fc2",
        "0xd5a79147930aa725",
        "0x06ca6351e003826f",
        "0x142929670a0e6e70",
        "0x27b70a8546d22ffc",
        "0x2e1b21385c26c926",
        "0x4d2c6dfc5ac42aed",
        "0x53380d139d95b3df",
        "0x650a73548baf63de",
        "0x766a0abb3c77b2a8",
        "0x81c2c92e47edaee6",
        "0x92722c851482353b",
        "0xa2bfe8a14cf10364",
        "0xa81a664bbc423001",
        "0xc24b8b70d0f89791",
        "0xc76c51a30654be30",
        "0xd192e819d6ef5218",
        "0xd69906245565a910",
        "0xf40e35855771202a",
        "0x106aa07032bbd1b8",
        "0x19a4c116b8d2d0c8",
        "0x1e376c085141ab53",
        "0x2748774cdf8eeb99",
        "0x34b0bcb5e19b48a8",
        "0x391c0cb3c5c95a63",
        "0x4ed8aa4ae3418acb",
        "0x5b9cca4f7763e373",
        "0x682e6ff3d6b2b8a3",
        "0x748f82ee5defb2fc",
        "0x78a5636f43172f60",
        "0x84c87814a1f0ab72",
        "0x8cc702081a6439ec",
        "0x90befffa23631e28",
        "0xa4506cebde82bde9",
        "0xbef9a3f7b2c67915",
        "0xc67178f2e372532b",
        "0xca273eceea26619c",
        "0xd186b8c721c0c207",
        "0xeada7dd6cde0eb1e",
        "0xf57d4f7fee6ed178",
        "0x06f067aa72176fba",
        "0x0a637dc5a2c898a6",
        "0x113f9804bef90dae",
        "0x1b710b35131c471b",
        "0x28db77f523047d84",
        "0x32caab7b40c72493",
        "0x3c9ebe0a15c9bebc",
        "0x431d67c49c100d4c",
        "0x4cc5d4becb3e42b6",
        "0x597f299cfc657e2a",
        "0x5fcb6fab3ad6faec",
        "0x6c44198c4a475817"
    ].map((n)=>BigInt(n))))();
// Temporary buffer, not used to store anything between runs
const $2579977b4e52adba$var$SHA512_W_H = /* @__PURE__ */ new Uint32Array(80);
const $2579977b4e52adba$var$SHA512_W_L = /* @__PURE__ */ new Uint32Array(80);
class $2579977b4e52adba$var$SHA512 extends $g9W9K.SHA2 {
    constructor(){
        super(128, 64, 16, false);
        // We cannot use array here since array allows indexing by variable which means optimizer/compiler cannot use registers.
        // Also looks cleaner and easier to verify with spec.
        // Initial state (first 32 bits of the fractional parts of the square roots of the first 8 primes 2..19):
        // h -- high 32 bits, l -- low 32 bits
        this.Ah = 1779033703;
        this.Al = -205731576;
        this.Bh = -1150833019;
        this.Bl = -2067093701;
        this.Ch = 1013904242;
        this.Cl = -23791573;
        this.Dh = -1521486534;
        this.Dl = 1595750129;
        this.Eh = 1359893119;
        this.El = -1377402159;
        this.Fh = -1694144372;
        this.Fl = 725511199;
        this.Gh = 528734635;
        this.Gl = -79577749;
        this.Hh = 1541459225;
        this.Hl = 327033209;
    }
    // prettier-ignore
    get() {
        const { Ah: Ah, Al: Al, Bh: Bh, Bl: Bl, Ch: Ch, Cl: Cl, Dh: Dh, Dl: Dl, Eh: Eh, El: El, Fh: Fh, Fl: Fl, Gh: Gh, Gl: Gl, Hh: Hh, Hl: Hl } = this;
        return [
            Ah,
            Al,
            Bh,
            Bl,
            Ch,
            Cl,
            Dh,
            Dl,
            Eh,
            El,
            Fh,
            Fl,
            Gh,
            Gl,
            Hh,
            Hl
        ];
    }
    // prettier-ignore
    set(Ah, Al, Bh, Bl, Ch, Cl, Dh, Dl, Eh, El, Fh, Fl, Gh, Gl, Hh, Hl) {
        this.Ah = Ah | 0;
        this.Al = Al | 0;
        this.Bh = Bh | 0;
        this.Bl = Bl | 0;
        this.Ch = Ch | 0;
        this.Cl = Cl | 0;
        this.Dh = Dh | 0;
        this.Dl = Dl | 0;
        this.Eh = Eh | 0;
        this.El = El | 0;
        this.Fh = Fh | 0;
        this.Fl = Fl | 0;
        this.Gh = Gh | 0;
        this.Gl = Gl | 0;
        this.Hh = Hh | 0;
        this.Hl = Hl | 0;
    }
    process(view, offset) {
        // Extend the first 16 words into the remaining 64 words w[16..79] of the message schedule array
        for(let i = 0; i < 16; i++, offset += 4){
            $2579977b4e52adba$var$SHA512_W_H[i] = view.getUint32(offset);
            $2579977b4e52adba$var$SHA512_W_L[i] = view.getUint32(offset += 4);
        }
        for(let i = 16; i < 80; i++){
            // s0 := (w[i-15] rightrotate 1) xor (w[i-15] rightrotate 8) xor (w[i-15] rightshift 7)
            const W15h = $2579977b4e52adba$var$SHA512_W_H[i - 15] | 0;
            const W15l = $2579977b4e52adba$var$SHA512_W_L[i - 15] | 0;
            const s0h = $eDgKs.default.rotrSH(W15h, W15l, 1) ^ $eDgKs.default.rotrSH(W15h, W15l, 8) ^ $eDgKs.default.shrSH(W15h, W15l, 7);
            const s0l = $eDgKs.default.rotrSL(W15h, W15l, 1) ^ $eDgKs.default.rotrSL(W15h, W15l, 8) ^ $eDgKs.default.shrSL(W15h, W15l, 7);
            // s1 := (w[i-2] rightrotate 19) xor (w[i-2] rightrotate 61) xor (w[i-2] rightshift 6)
            const W2h = $2579977b4e52adba$var$SHA512_W_H[i - 2] | 0;
            const W2l = $2579977b4e52adba$var$SHA512_W_L[i - 2] | 0;
            const s1h = $eDgKs.default.rotrSH(W2h, W2l, 19) ^ $eDgKs.default.rotrBH(W2h, W2l, 61) ^ $eDgKs.default.shrSH(W2h, W2l, 6);
            const s1l = $eDgKs.default.rotrSL(W2h, W2l, 19) ^ $eDgKs.default.rotrBL(W2h, W2l, 61) ^ $eDgKs.default.shrSL(W2h, W2l, 6);
            // SHA256_W[i] = s0 + s1 + SHA256_W[i - 7] + SHA256_W[i - 16];
            const SUMl = $eDgKs.default.add4L(s0l, s1l, $2579977b4e52adba$var$SHA512_W_L[i - 7], $2579977b4e52adba$var$SHA512_W_L[i - 16]);
            const SUMh = $eDgKs.default.add4H(SUMl, s0h, s1h, $2579977b4e52adba$var$SHA512_W_H[i - 7], $2579977b4e52adba$var$SHA512_W_H[i - 16]);
            $2579977b4e52adba$var$SHA512_W_H[i] = SUMh | 0;
            $2579977b4e52adba$var$SHA512_W_L[i] = SUMl | 0;
        }
        let { Ah: Ah, Al: Al, Bh: Bh, Bl: Bl, Ch: Ch, Cl: Cl, Dh: Dh, Dl: Dl, Eh: Eh, El: El, Fh: Fh, Fl: Fl, Gh: Gh, Gl: Gl, Hh: Hh, Hl: Hl } = this;
        // Compression function main loop, 80 rounds
        for(let i = 0; i < 80; i++){
            // S1 := (e rightrotate 14) xor (e rightrotate 18) xor (e rightrotate 41)
            const sigma1h = $eDgKs.default.rotrSH(Eh, El, 14) ^ $eDgKs.default.rotrSH(Eh, El, 18) ^ $eDgKs.default.rotrBH(Eh, El, 41);
            const sigma1l = $eDgKs.default.rotrSL(Eh, El, 14) ^ $eDgKs.default.rotrSL(Eh, El, 18) ^ $eDgKs.default.rotrBL(Eh, El, 41);
            //const T1 = (H + sigma1 + Chi(E, F, G) + SHA256_K[i] + SHA256_W[i]) | 0;
            const CHIh = Eh & Fh ^ ~Eh & Gh;
            const CHIl = El & Fl ^ ~El & Gl;
            // T1 = H + sigma1 + Chi(E, F, G) + SHA512_K[i] + SHA512_W[i]
            // prettier-ignore
            const T1ll = $eDgKs.default.add5L(Hl, sigma1l, CHIl, $2579977b4e52adba$var$SHA512_Kl[i], $2579977b4e52adba$var$SHA512_W_L[i]);
            const T1h = $eDgKs.default.add5H(T1ll, Hh, sigma1h, CHIh, $2579977b4e52adba$var$SHA512_Kh[i], $2579977b4e52adba$var$SHA512_W_H[i]);
            const T1l = T1ll | 0;
            // S0 := (a rightrotate 28) xor (a rightrotate 34) xor (a rightrotate 39)
            const sigma0h = $eDgKs.default.rotrSH(Ah, Al, 28) ^ $eDgKs.default.rotrBH(Ah, Al, 34) ^ $eDgKs.default.rotrBH(Ah, Al, 39);
            const sigma0l = $eDgKs.default.rotrSL(Ah, Al, 28) ^ $eDgKs.default.rotrBL(Ah, Al, 34) ^ $eDgKs.default.rotrBL(Ah, Al, 39);
            const MAJh = Ah & Bh ^ Ah & Ch ^ Bh & Ch;
            const MAJl = Al & Bl ^ Al & Cl ^ Bl & Cl;
            Hh = Gh | 0;
            Hl = Gl | 0;
            Gh = Fh | 0;
            Gl = Fl | 0;
            Fh = Eh | 0;
            Fl = El | 0;
            ({ h: Eh, l: El } = $eDgKs.default.add(Dh | 0, Dl | 0, T1h | 0, T1l | 0));
            Dh = Ch | 0;
            Dl = Cl | 0;
            Ch = Bh | 0;
            Cl = Bl | 0;
            Bh = Ah | 0;
            Bl = Al | 0;
            const All = $eDgKs.default.add3L(T1l, sigma0l, MAJl);
            Ah = $eDgKs.default.add3H(All, T1h, sigma0h, MAJh);
            Al = All | 0;
        }
        // Add the compressed chunk to the current hash value
        ({ h: Ah, l: Al } = $eDgKs.default.add(this.Ah | 0, this.Al | 0, Ah | 0, Al | 0));
        ({ h: Bh, l: Bl } = $eDgKs.default.add(this.Bh | 0, this.Bl | 0, Bh | 0, Bl | 0));
        ({ h: Ch, l: Cl } = $eDgKs.default.add(this.Ch | 0, this.Cl | 0, Ch | 0, Cl | 0));
        ({ h: Dh, l: Dl } = $eDgKs.default.add(this.Dh | 0, this.Dl | 0, Dh | 0, Dl | 0));
        ({ h: Eh, l: El } = $eDgKs.default.add(this.Eh | 0, this.El | 0, Eh | 0, El | 0));
        ({ h: Fh, l: Fl } = $eDgKs.default.add(this.Fh | 0, this.Fl | 0, Fh | 0, Fl | 0));
        ({ h: Gh, l: Gl } = $eDgKs.default.add(this.Gh | 0, this.Gl | 0, Gh | 0, Gl | 0));
        ({ h: Hh, l: Hl } = $eDgKs.default.add(this.Hh | 0, this.Hl | 0, Hh | 0, Hl | 0));
        this.set(Ah, Al, Bh, Bl, Ch, Cl, Dh, Dl, Eh, El, Fh, Fl, Gh, Gl, Hh, Hl);
    }
    roundClean() {
        $2579977b4e52adba$var$SHA512_W_H.fill(0);
        $2579977b4e52adba$var$SHA512_W_L.fill(0);
    }
    destroy() {
        this.buffer.fill(0);
        this.set(0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0);
    }
}
module.exports.SHA512 = $2579977b4e52adba$var$SHA512;
class $2579977b4e52adba$var$SHA512_224 extends $2579977b4e52adba$var$SHA512 {
    constructor(){
        super();
        // h -- high 32 bits, l -- low 32 bits
        this.Ah = -1942145080;
        this.Al = 424955298;
        this.Bh = 1944164710;
        this.Bl = -1982016298;
        this.Ch = 502970286;
        this.Cl = 855612546;
        this.Dh = 1738396948;
        this.Dl = 1479516111;
        this.Eh = 258812777;
        this.El = 2077511080;
        this.Fh = 2011393907;
        this.Fl = 79989058;
        this.Gh = 1067287976;
        this.Gl = 1780299464;
        this.Hh = 286451373;
        this.Hl = -1848208735;
        this.outputLen = 28;
    }
}
class $2579977b4e52adba$var$SHA512_256 extends $2579977b4e52adba$var$SHA512 {
    constructor(){
        super();
        // h -- high 32 bits, l -- low 32 bits
        this.Ah = 573645204;
        this.Al = -64227540;
        this.Bh = -1621794909;
        this.Bl = -934517566;
        this.Ch = 596883563;
        this.Cl = 1867755857;
        this.Dh = -1774684391;
        this.Dl = 1497426621;
        this.Eh = -1775747358;
        this.El = -1467023389;
        this.Fh = -1101128155;
        this.Fl = 1401305490;
        this.Gh = 721525244;
        this.Gl = 746961066;
        this.Hh = 246885852;
        this.Hl = -2117784414;
        this.outputLen = 32;
    }
}
class $2579977b4e52adba$var$SHA384 extends $2579977b4e52adba$var$SHA512 {
    constructor(){
        super();
        // h -- high 32 bits, l -- low 32 bits
        this.Ah = -876896931;
        this.Al = -1056596264;
        this.Bh = 1654270250;
        this.Bl = 914150663;
        this.Ch = -1856437926;
        this.Cl = 812702999;
        this.Dh = 355462360;
        this.Dl = -150054599;
        this.Eh = 1731405415;
        this.El = -4191439;
        this.Fh = -1900787065;
        this.Fl = 1750603025;
        this.Gh = -619958771;
        this.Gl = 1694076839;
        this.Hh = 1203062813;
        this.Hl = -1090891868;
        this.outputLen = 48;
    }
}
module.exports.sha512 = (0, $3Bcdj.wrapConstructor)(()=>new $2579977b4e52adba$var$SHA512());
module.exports.sha512_224 = (0, $3Bcdj.wrapConstructor)(()=>new $2579977b4e52adba$var$SHA512_224());
module.exports.sha512_256 = (0, $3Bcdj.wrapConstructor)(()=>new $2579977b4e52adba$var$SHA512_256());
module.exports.sha384 = (0, $3Bcdj.wrapConstructor)(()=>new $2579977b4e52adba$var$SHA384());

});
parcelRegister("g9W9K", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.SHA2 = void 0;

var $dNiq9 = parcelRequire("dNiq9");

var $3Bcdj = parcelRequire("3Bcdj");
// Polyfill for Safari 14
function $bc3a993d7d38a7a0$var$setBigUint64(view, byteOffset, value, isLE) {
    if (typeof view.setBigUint64 === "function") return view.setBigUint64(byteOffset, value, isLE);
    const _32n = BigInt(32);
    const _u32_max = BigInt(0xffffffff);
    const wh = Number(value >> _32n & _u32_max);
    const wl = Number(value & _u32_max);
    const h = isLE ? 4 : 0;
    const l = isLE ? 0 : 4;
    view.setUint32(byteOffset + h, wh, isLE);
    view.setUint32(byteOffset + l, wl, isLE);
}
// Base SHA2 class (RFC 6234)
class $bc3a993d7d38a7a0$var$SHA2 extends $3Bcdj.Hash {
    constructor(blockLen, outputLen, padOffset, isLE){
        super();
        this.blockLen = blockLen;
        this.outputLen = outputLen;
        this.padOffset = padOffset;
        this.isLE = isLE;
        this.finished = false;
        this.length = 0;
        this.pos = 0;
        this.destroyed = false;
        this.buffer = new Uint8Array(blockLen);
        this.view = (0, $3Bcdj.createView)(this.buffer);
    }
    update(data) {
        (0, $dNiq9.exists)(this);
        const { view: view, buffer: buffer, blockLen: blockLen } = this;
        data = (0, $3Bcdj.toBytes)(data);
        const len = data.length;
        for(let pos = 0; pos < len;){
            const take = Math.min(blockLen - this.pos, len - pos);
            // Fast path: we have at least one block in input, cast it to view and process
            if (take === blockLen) {
                const dataView = (0, $3Bcdj.createView)(data);
                for(; blockLen <= len - pos; pos += blockLen)this.process(dataView, pos);
                continue;
            }
            buffer.set(data.subarray(pos, pos + take), this.pos);
            this.pos += take;
            pos += take;
            if (this.pos === blockLen) {
                this.process(view, 0);
                this.pos = 0;
            }
        }
        this.length += data.length;
        this.roundClean();
        return this;
    }
    digestInto(out) {
        (0, $dNiq9.exists)(this);
        (0, $dNiq9.output)(out, this);
        this.finished = true;
        // Padding
        // We can avoid allocation of buffer for padding completely if it
        // was previously not allocated here. But it won't change performance.
        const { buffer: buffer, view: view, blockLen: blockLen, isLE: isLE } = this;
        let { pos: pos } = this;
        // append the bit '1' to the message
        buffer[pos++] = 128;
        this.buffer.subarray(pos).fill(0);
        // we have less than padOffset left in buffer, so we cannot put length in current block, need process it and pad again
        if (this.padOffset > blockLen - pos) {
            this.process(view, 0);
            pos = 0;
        }
        // Pad until full block byte with zeros
        for(let i = pos; i < blockLen; i++)buffer[i] = 0;
        // Note: sha512 requires length to be 128bit integer, but length in JS will overflow before that
        // You need to write around 2 exabytes (u64_max / 8 / (1024**6)) for this to happen.
        // So we just write lowest 64 bits of that value.
        $bc3a993d7d38a7a0$var$setBigUint64(view, blockLen - 8, BigInt(this.length * 8), isLE);
        this.process(view, 0);
        const oview = (0, $3Bcdj.createView)(out);
        const len = this.outputLen;
        // NOTE: we do division by 4 later, which should be fused in single op with modulo by JIT
        if (len % 4) throw new Error("_sha2: outputLen should be aligned to 32bit");
        const outLen = len / 4;
        const state = this.get();
        if (outLen > state.length) throw new Error("_sha2: outputLen bigger than state");
        for(let i = 0; i < outLen; i++)oview.setUint32(4 * i, state[i], isLE);
    }
    digest() {
        const { buffer: buffer, outputLen: outputLen } = this;
        this.digestInto(buffer);
        const res = buffer.slice(0, outputLen);
        this.destroy();
        return res;
    }
    _cloneInto(to) {
        to || (to = new this.constructor());
        to.set(...this.get());
        const { blockLen: blockLen, buffer: buffer, length: length, finished: finished, destroyed: destroyed, pos: pos } = this;
        to.length = length;
        to.pos = pos;
        to.finished = finished;
        to.destroyed = destroyed;
        if (length % blockLen) to.buffer.set(buffer);
        return to;
    }
}
module.exports.SHA2 = $bc3a993d7d38a7a0$var$SHA2;

});
parcelRegister("dNiq9", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.output = module.exports.exists = module.exports.hash = module.exports.bytes = module.exports.bool = module.exports.number = void 0;
function $a0ae23f5901291b4$var$number(n) {
    if (!Number.isSafeInteger(n) || n < 0) throw new Error(`Wrong positive integer: ${n}`);
}
module.exports.number = $a0ae23f5901291b4$var$number;
function $a0ae23f5901291b4$var$bool(b) {
    if (typeof b !== "boolean") throw new Error(`Expected boolean, not ${b}`);
}
module.exports.bool = $a0ae23f5901291b4$var$bool;
function $a0ae23f5901291b4$var$bytes(b, ...lengths) {
    if (!(b instanceof Uint8Array)) throw new Error("Expected Uint8Array");
    if (lengths.length > 0 && !lengths.includes(b.length)) throw new Error(`Expected Uint8Array of length ${lengths}, not of length=${b.length}`);
}
module.exports.bytes = $a0ae23f5901291b4$var$bytes;
function $a0ae23f5901291b4$var$hash(hash) {
    if (typeof hash !== "function" || typeof hash.create !== "function") throw new Error("Hash should be wrapped by utils.wrapConstructor");
    $a0ae23f5901291b4$var$number(hash.outputLen);
    $a0ae23f5901291b4$var$number(hash.blockLen);
}
module.exports.hash = $a0ae23f5901291b4$var$hash;
function $a0ae23f5901291b4$var$exists(instance, checkFinished = true) {
    if (instance.destroyed) throw new Error("Hash instance has been destroyed");
    if (checkFinished && instance.finished) throw new Error("Hash#digest() has already been called");
}
module.exports.exists = $a0ae23f5901291b4$var$exists;
function $a0ae23f5901291b4$var$output(out, instance) {
    $a0ae23f5901291b4$var$bytes(out);
    const min = instance.outputLen;
    if (out.length < min) throw new Error(`digestInto() expects output buffer of length at least ${min}`);
}
module.exports.output = $a0ae23f5901291b4$var$output;
const $a0ae23f5901291b4$var$assert = {
    number: $a0ae23f5901291b4$var$number,
    bool: $a0ae23f5901291b4$var$bool,
    bytes: $a0ae23f5901291b4$var$bytes,
    hash: $a0ae23f5901291b4$var$hash,
    exists: $a0ae23f5901291b4$var$exists,
    output: $a0ae23f5901291b4$var$output
};
module.exports.default = $a0ae23f5901291b4$var$assert;

});

parcelRegister("3Bcdj", function(module, exports) {
"use strict";
/*! noble-hashes - MIT License (c) 2022 Paul Miller (paulmillr.com) */ Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.randomBytes = module.exports.wrapXOFConstructorWithOpts = module.exports.wrapConstructorWithOpts = module.exports.wrapConstructor = module.exports.checkOpts = module.exports.Hash = module.exports.concatBytes = module.exports.toBytes = module.exports.utf8ToBytes = module.exports.asyncLoop = module.exports.nextTick = module.exports.hexToBytes = module.exports.bytesToHex = module.exports.isLE = module.exports.rotr = module.exports.createView = module.exports.u32 = module.exports.u8 = void 0;

var $dUxV2 = parcelRequire("dUxV2");
const $29ee4d3171d9809b$var$u8a = (a)=>a instanceof Uint8Array;
// Cast array to different type
const $29ee4d3171d9809b$var$u8 = (arr)=>new Uint8Array(arr.buffer, arr.byteOffset, arr.byteLength);
module.exports.u8 = $29ee4d3171d9809b$var$u8;
const $29ee4d3171d9809b$var$u32 = (arr)=>new Uint32Array(arr.buffer, arr.byteOffset, Math.floor(arr.byteLength / 4));
module.exports.u32 = $29ee4d3171d9809b$var$u32;
// Cast array to view
const $29ee4d3171d9809b$var$createView = (arr)=>new DataView(arr.buffer, arr.byteOffset, arr.byteLength);
module.exports.createView = $29ee4d3171d9809b$var$createView;
// The rotate right (circular right shift) operation for uint32
const $29ee4d3171d9809b$var$rotr = (word, shift)=>word << 32 - shift | word >>> shift;
module.exports.rotr = $29ee4d3171d9809b$var$rotr;
// big-endian hardware is rare. Just in case someone still decides to run hashes:
// early-throw an error because we don't support BE yet.
module.exports.isLE = new Uint8Array(new Uint32Array([
    0x11223344
]).buffer)[0] === 0x44;
if (!module.exports.isLE) throw new Error("Non little-endian hardware is not supported");
const $29ee4d3171d9809b$var$hexes = /* @__PURE__ */ Array.from({
    length: 256
}, (_, i)=>i.toString(16).padStart(2, "0"));
/**
 * @example bytesToHex(Uint8Array.from([0xca, 0xfe, 0x01, 0x23])) // 'cafe0123'
 */ function $29ee4d3171d9809b$var$bytesToHex(bytes) {
    if (!$29ee4d3171d9809b$var$u8a(bytes)) throw new Error("Uint8Array expected");
    // pre-caching improves the speed 6x
    let hex = "";
    for(let i = 0; i < bytes.length; i++)hex += $29ee4d3171d9809b$var$hexes[bytes[i]];
    return hex;
}
module.exports.bytesToHex = $29ee4d3171d9809b$var$bytesToHex;
/**
 * @example hexToBytes('cafe0123') // Uint8Array.from([0xca, 0xfe, 0x01, 0x23])
 */ function $29ee4d3171d9809b$var$hexToBytes(hex) {
    if (typeof hex !== "string") throw new Error("hex string expected, got " + typeof hex);
    const len = hex.length;
    if (len % 2) throw new Error("padded hex string expected, got unpadded hex of length " + len);
    const array = new Uint8Array(len / 2);
    for(let i = 0; i < array.length; i++){
        const j = i * 2;
        const hexByte = hex.slice(j, j + 2);
        const byte = Number.parseInt(hexByte, 16);
        if (Number.isNaN(byte) || byte < 0) throw new Error("Invalid byte sequence");
        array[i] = byte;
    }
    return array;
}
module.exports.hexToBytes = $29ee4d3171d9809b$var$hexToBytes;
// There is no setImmediate in browser and setTimeout is slow.
// call of async fn will return Promise, which will be fullfiled only on
// next scheduler queue processing step and this is exactly what we need.
const $29ee4d3171d9809b$var$nextTick = async ()=>{};
module.exports.nextTick = $29ee4d3171d9809b$var$nextTick;
// Returns control to thread each 'tick' ms to avoid blocking
async function $29ee4d3171d9809b$var$asyncLoop(iters, tick, cb) {
    let ts = Date.now();
    for(let i = 0; i < iters; i++){
        cb(i);
        // Date.now() is not monotonic, so in case if clock goes backwards we return return control too
        const diff = Date.now() - ts;
        if (diff >= 0 && diff < tick) continue;
        await (0, module.exports.nextTick)();
        ts += diff;
    }
}
module.exports.asyncLoop = $29ee4d3171d9809b$var$asyncLoop;
/**
 * @example utf8ToBytes('abc') // new Uint8Array([97, 98, 99])
 */ function $29ee4d3171d9809b$var$utf8ToBytes(str) {
    if (typeof str !== "string") throw new Error(`utf8ToBytes expected string, got ${typeof str}`);
    return new Uint8Array(new TextEncoder().encode(str)); // https://bugzil.la/1681809
}
module.exports.utf8ToBytes = $29ee4d3171d9809b$var$utf8ToBytes;
/**
 * Normalizes (non-hex) string or Uint8Array to Uint8Array.
 * Warning: when Uint8Array is passed, it would NOT get copied.
 * Keep in mind for future mutable operations.
 */ function $29ee4d3171d9809b$var$toBytes(data) {
    if (typeof data === "string") data = $29ee4d3171d9809b$var$utf8ToBytes(data);
    if (!$29ee4d3171d9809b$var$u8a(data)) throw new Error(`expected Uint8Array, got ${typeof data}`);
    return data;
}
module.exports.toBytes = $29ee4d3171d9809b$var$toBytes;
/**
 * Copies several Uint8Arrays into one.
 */ function $29ee4d3171d9809b$var$concatBytes(...arrays) {
    const r = new Uint8Array(arrays.reduce((sum, a)=>sum + a.length, 0));
    let pad = 0; // walk through each item, ensure they have proper type
    arrays.forEach((a)=>{
        if (!$29ee4d3171d9809b$var$u8a(a)) throw new Error("Uint8Array expected");
        r.set(a, pad);
        pad += a.length;
    });
    return r;
}
module.exports.concatBytes = $29ee4d3171d9809b$var$concatBytes;
// For runtime check if class implements interface
class $29ee4d3171d9809b$var$Hash {
    // Safe version that clones internal state
    clone() {
        return this._cloneInto();
    }
}
module.exports.Hash = $29ee4d3171d9809b$var$Hash;
const $29ee4d3171d9809b$var$toStr = {}.toString;
function $29ee4d3171d9809b$var$checkOpts(defaults, opts) {
    if (opts !== undefined && $29ee4d3171d9809b$var$toStr.call(opts) !== "[object Object]") throw new Error("Options should be object or undefined");
    const merged = Object.assign(defaults, opts);
    return merged;
}
module.exports.checkOpts = $29ee4d3171d9809b$var$checkOpts;
function $29ee4d3171d9809b$var$wrapConstructor(hashCons) {
    const hashC = (msg)=>hashCons().update($29ee4d3171d9809b$var$toBytes(msg)).digest();
    const tmp = hashCons();
    hashC.outputLen = tmp.outputLen;
    hashC.blockLen = tmp.blockLen;
    hashC.create = ()=>hashCons();
    return hashC;
}
module.exports.wrapConstructor = $29ee4d3171d9809b$var$wrapConstructor;
function $29ee4d3171d9809b$var$wrapConstructorWithOpts(hashCons) {
    const hashC = (msg, opts)=>hashCons(opts).update($29ee4d3171d9809b$var$toBytes(msg)).digest();
    const tmp = hashCons({});
    hashC.outputLen = tmp.outputLen;
    hashC.blockLen = tmp.blockLen;
    hashC.create = (opts)=>hashCons(opts);
    return hashC;
}
module.exports.wrapConstructorWithOpts = $29ee4d3171d9809b$var$wrapConstructorWithOpts;
function $29ee4d3171d9809b$var$wrapXOFConstructorWithOpts(hashCons) {
    const hashC = (msg, opts)=>hashCons(opts).update($29ee4d3171d9809b$var$toBytes(msg)).digest();
    const tmp = hashCons({});
    hashC.outputLen = tmp.outputLen;
    hashC.blockLen = tmp.blockLen;
    hashC.create = (opts)=>hashCons(opts);
    return hashC;
}
module.exports.wrapXOFConstructorWithOpts = $29ee4d3171d9809b$var$wrapXOFConstructorWithOpts;
/**
 * Secure PRNG. Uses `crypto.getRandomValues`, which defers to OS.
 */ function $29ee4d3171d9809b$var$randomBytes(bytesLength = 32) {
    if ($dUxV2.crypto && typeof $dUxV2.crypto.getRandomValues === "function") return $dUxV2.crypto.getRandomValues(new Uint8Array(bytesLength));
    throw new Error("crypto.getRandomValues must be defined");
}
module.exports.randomBytes = $29ee4d3171d9809b$var$randomBytes;

});
parcelRegister("dUxV2", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.crypto = void 0;
module.exports.crypto = typeof globalThis === "object" && "crypto" in globalThis ? globalThis.crypto : undefined;

});



parcelRegister("eDgKs", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.add5L = module.exports.add5H = module.exports.add4H = module.exports.add4L = module.exports.add3H = module.exports.add3L = module.exports.add = module.exports.rotlBL = module.exports.rotlBH = module.exports.rotlSL = module.exports.rotlSH = module.exports.rotr32L = module.exports.rotr32H = module.exports.rotrBL = module.exports.rotrBH = module.exports.rotrSL = module.exports.rotrSH = module.exports.shrSL = module.exports.shrSH = module.exports.toBig = module.exports.split = module.exports.fromBig = void 0;
const $aa71b30d36adb919$var$U32_MASK64 = /* @__PURE__ */ BigInt(2 ** 32 - 1);
const $aa71b30d36adb919$var$_32n = /* @__PURE__ */ BigInt(32);
// We are not using BigUint64Array, because they are extremely slow as per 2022
function $aa71b30d36adb919$var$fromBig(n, le = false) {
    if (le) return {
        h: Number(n & $aa71b30d36adb919$var$U32_MASK64),
        l: Number(n >> $aa71b30d36adb919$var$_32n & $aa71b30d36adb919$var$U32_MASK64)
    };
    return {
        h: Number(n >> $aa71b30d36adb919$var$_32n & $aa71b30d36adb919$var$U32_MASK64) | 0,
        l: Number(n & $aa71b30d36adb919$var$U32_MASK64) | 0
    };
}
module.exports.fromBig = $aa71b30d36adb919$var$fromBig;
function $aa71b30d36adb919$var$split(lst, le = false) {
    let Ah = new Uint32Array(lst.length);
    let Al = new Uint32Array(lst.length);
    for(let i = 0; i < lst.length; i++){
        const { h: h, l: l } = $aa71b30d36adb919$var$fromBig(lst[i], le);
        [Ah[i], Al[i]] = [
            h,
            l
        ];
    }
    return [
        Ah,
        Al
    ];
}
module.exports.split = $aa71b30d36adb919$var$split;
const $aa71b30d36adb919$var$toBig = (h, l)=>BigInt(h >>> 0) << $aa71b30d36adb919$var$_32n | BigInt(l >>> 0);
module.exports.toBig = $aa71b30d36adb919$var$toBig;
// for Shift in [0, 32)
const $aa71b30d36adb919$var$shrSH = (h, _l, s)=>h >>> s;
module.exports.shrSH = $aa71b30d36adb919$var$shrSH;
const $aa71b30d36adb919$var$shrSL = (h, l, s)=>h << 32 - s | l >>> s;
module.exports.shrSL = $aa71b30d36adb919$var$shrSL;
// Right rotate for Shift in [1, 32)
const $aa71b30d36adb919$var$rotrSH = (h, l, s)=>h >>> s | l << 32 - s;
module.exports.rotrSH = $aa71b30d36adb919$var$rotrSH;
const $aa71b30d36adb919$var$rotrSL = (h, l, s)=>h << 32 - s | l >>> s;
module.exports.rotrSL = $aa71b30d36adb919$var$rotrSL;
// Right rotate for Shift in (32, 64), NOTE: 32 is special case.
const $aa71b30d36adb919$var$rotrBH = (h, l, s)=>h << 64 - s | l >>> s - 32;
module.exports.rotrBH = $aa71b30d36adb919$var$rotrBH;
const $aa71b30d36adb919$var$rotrBL = (h, l, s)=>h >>> s - 32 | l << 64 - s;
module.exports.rotrBL = $aa71b30d36adb919$var$rotrBL;
// Right rotate for shift===32 (just swaps l&h)
const $aa71b30d36adb919$var$rotr32H = (_h, l)=>l;
module.exports.rotr32H = $aa71b30d36adb919$var$rotr32H;
const $aa71b30d36adb919$var$rotr32L = (h, _l)=>h;
module.exports.rotr32L = $aa71b30d36adb919$var$rotr32L;
// Left rotate for Shift in [1, 32)
const $aa71b30d36adb919$var$rotlSH = (h, l, s)=>h << s | l >>> 32 - s;
module.exports.rotlSH = $aa71b30d36adb919$var$rotlSH;
const $aa71b30d36adb919$var$rotlSL = (h, l, s)=>l << s | h >>> 32 - s;
module.exports.rotlSL = $aa71b30d36adb919$var$rotlSL;
// Left rotate for Shift in (32, 64), NOTE: 32 is special case.
const $aa71b30d36adb919$var$rotlBH = (h, l, s)=>l << s - 32 | h >>> 64 - s;
module.exports.rotlBH = $aa71b30d36adb919$var$rotlBH;
const $aa71b30d36adb919$var$rotlBL = (h, l, s)=>h << s - 32 | l >>> 64 - s;
module.exports.rotlBL = $aa71b30d36adb919$var$rotlBL;
// JS uses 32-bit signed integers for bitwise operations which means we cannot
// simple take carry out of low bit sum by shift, we need to use division.
function $aa71b30d36adb919$var$add(Ah, Al, Bh, Bl) {
    const l = (Al >>> 0) + (Bl >>> 0);
    return {
        h: Ah + Bh + (l / 2 ** 32 | 0) | 0,
        l: l | 0
    };
}
module.exports.add = $aa71b30d36adb919$var$add;
// Addition with more than 2 elements
const $aa71b30d36adb919$var$add3L = (Al, Bl, Cl)=>(Al >>> 0) + (Bl >>> 0) + (Cl >>> 0);
module.exports.add3L = $aa71b30d36adb919$var$add3L;
const $aa71b30d36adb919$var$add3H = (low, Ah, Bh, Ch)=>Ah + Bh + Ch + (low / 2 ** 32 | 0) | 0;
module.exports.add3H = $aa71b30d36adb919$var$add3H;
const $aa71b30d36adb919$var$add4L = (Al, Bl, Cl, Dl)=>(Al >>> 0) + (Bl >>> 0) + (Cl >>> 0) + (Dl >>> 0);
module.exports.add4L = $aa71b30d36adb919$var$add4L;
const $aa71b30d36adb919$var$add4H = (low, Ah, Bh, Ch, Dh)=>Ah + Bh + Ch + Dh + (low / 2 ** 32 | 0) | 0;
module.exports.add4H = $aa71b30d36adb919$var$add4H;
const $aa71b30d36adb919$var$add5L = (Al, Bl, Cl, Dl, El)=>(Al >>> 0) + (Bl >>> 0) + (Cl >>> 0) + (Dl >>> 0) + (El >>> 0);
module.exports.add5L = $aa71b30d36adb919$var$add5L;
const $aa71b30d36adb919$var$add5H = (low, Ah, Bh, Ch, Dh, Eh)=>Ah + Bh + Ch + Dh + Eh + (low / 2 ** 32 | 0) | 0;
module.exports.add5H = $aa71b30d36adb919$var$add5H;
// prettier-ignore
const $aa71b30d36adb919$var$u64 = {
    fromBig: $aa71b30d36adb919$var$fromBig,
    split: $aa71b30d36adb919$var$split,
    toBig: $aa71b30d36adb919$var$toBig,
    shrSH: $aa71b30d36adb919$var$shrSH,
    shrSL: $aa71b30d36adb919$var$shrSL,
    rotrSH: $aa71b30d36adb919$var$rotrSH,
    rotrSL: $aa71b30d36adb919$var$rotrSL,
    rotrBH: $aa71b30d36adb919$var$rotrBH,
    rotrBL: $aa71b30d36adb919$var$rotrBL,
    rotr32H: $aa71b30d36adb919$var$rotr32H,
    rotr32L: $aa71b30d36adb919$var$rotr32L,
    rotlSH: $aa71b30d36adb919$var$rotlSH,
    rotlSL: $aa71b30d36adb919$var$rotlSL,
    rotlBH: $aa71b30d36adb919$var$rotlBH,
    rotlBL: $aa71b30d36adb919$var$rotlBL,
    add: $aa71b30d36adb919$var$add,
    add3L: $aa71b30d36adb919$var$add3L,
    add3H: $aa71b30d36adb919$var$add3H,
    add4L: $aa71b30d36adb919$var$add4L,
    add4H: $aa71b30d36adb919$var$add4H,
    add5H: $aa71b30d36adb919$var$add5H,
    add5L: $aa71b30d36adb919$var$add5L
};
module.exports.default = $aa71b30d36adb919$var$u64;

});


parcelRegister("qoWOx", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.twistedEdwards = void 0;

var $2D9sF = parcelRequire("2D9sF");

var $esaJO = parcelRequire("esaJO");

var $esaJO = parcelRequire("esaJO");

var $lkFCe = parcelRequire("lkFCe");
// Be friendly to bad ECMAScript parsers by not using bigint literals
// prettier-ignore
const $04f5c7e644575b38$var$_0n = BigInt(0), $04f5c7e644575b38$var$_1n = BigInt(1), $04f5c7e644575b38$var$_2n = BigInt(2), $04f5c7e644575b38$var$_8n = BigInt(8);
// verification rule is either zip215 or rfc8032 / nist186-5. Consult fromHex:
const $04f5c7e644575b38$var$VERIFY_DEFAULT = {
    zip215: true
};
function $04f5c7e644575b38$var$validateOpts(curve) {
    const opts = (0, $lkFCe.validateBasic)(curve);
    $esaJO.validateObject(curve, {
        hash: "function",
        a: "bigint",
        d: "bigint",
        randomBytes: "function"
    }, {
        adjustScalarBytes: "function",
        domain: "function",
        uvRatio: "function",
        mapToCurve: "function"
    });
    // Set defaults
    return Object.freeze({
        ...opts
    });
}
// It is not generic twisted curve for now, but ed25519/ed448 generic implementation
function $04f5c7e644575b38$var$twistedEdwards(curveDef) {
    const CURVE = $04f5c7e644575b38$var$validateOpts(curveDef);
    const { Fp: Fp, n: CURVE_ORDER, prehash: prehash, hash: cHash, randomBytes: randomBytes, nByteLength: nByteLength, h: cofactor } = CURVE;
    const MASK = $04f5c7e644575b38$var$_2n << BigInt(nByteLength * 8) - $04f5c7e644575b38$var$_1n;
    const modP = Fp.create; // Function overrides
    // sqrt(u/v)
    const uvRatio = CURVE.uvRatio || ((u, v)=>{
        try {
            return {
                isValid: true,
                value: Fp.sqrt(u * Fp.inv(v))
            };
        } catch (e) {
            return {
                isValid: false,
                value: $04f5c7e644575b38$var$_0n
            };
        }
    });
    const adjustScalarBytes = CURVE.adjustScalarBytes || ((bytes)=>bytes); // NOOP
    const domain = CURVE.domain || ((data, ctx, phflag)=>{
        if (ctx.length || phflag) throw new Error("Contexts/pre-hash are not supported");
        return data;
    }); // NOOP
    const inBig = (n)=>typeof n === "bigint" && $04f5c7e644575b38$var$_0n < n; // n in [1..]
    const inRange = (n, max)=>inBig(n) && inBig(max) && n < max; // n in [1..max-1]
    const in0MaskRange = (n)=>n === $04f5c7e644575b38$var$_0n || inRange(n, MASK); // n in [0..MASK-1]
    function assertInRange(n, max) {
        // n in [1..max-1]
        if (inRange(n, max)) return n;
        throw new Error(`Expected valid scalar < ${max}, got ${typeof n} ${n}`);
    }
    function assertGE0(n) {
        // n in [0..CURVE_ORDER-1]
        return n === $04f5c7e644575b38$var$_0n ? n : assertInRange(n, CURVE_ORDER); // GE = prime subgroup, not full group
    }
    const pointPrecomputes = new Map();
    function isPoint(other) {
        if (!(other instanceof Point)) throw new Error("ExtendedPoint expected");
    }
    // Extended Point works in extended coordinates: (x, y, z, t) ∋ (x=x/z, y=y/z, t=xy).
    // https://en.wikipedia.org/wiki/Twisted_Edwards_curve#Extended_coordinates
    class Point {
        constructor(ex, ey, ez, et){
            this.ex = ex;
            this.ey = ey;
            this.ez = ez;
            this.et = et;
            if (!in0MaskRange(ex)) throw new Error("x required");
            if (!in0MaskRange(ey)) throw new Error("y required");
            if (!in0MaskRange(ez)) throw new Error("z required");
            if (!in0MaskRange(et)) throw new Error("t required");
        }
        get x() {
            return this.toAffine().x;
        }
        get y() {
            return this.toAffine().y;
        }
        static fromAffine(p) {
            if (p instanceof Point) throw new Error("extended point not allowed");
            const { x: x, y: y } = p || {};
            if (!in0MaskRange(x) || !in0MaskRange(y)) throw new Error("invalid affine point");
            return new Point(x, y, $04f5c7e644575b38$var$_1n, modP(x * y));
        }
        static normalizeZ(points) {
            const toInv = Fp.invertBatch(points.map((p)=>p.ez));
            return points.map((p, i)=>p.toAffine(toInv[i])).map(Point.fromAffine);
        }
        // "Private method", don't use it directly
        _setWindowSize(windowSize) {
            this._WINDOW_SIZE = windowSize;
            pointPrecomputes.delete(this);
        }
        // Not required for fromHex(), which always creates valid points.
        // Could be useful for fromAffine().
        assertValidity() {
            const { a: a, d: d } = CURVE;
            if (this.is0()) throw new Error("bad point: ZERO"); // TODO: optimize, with vars below?
            // Equation in affine coordinates: ax² + y² = 1 + dx²y²
            // Equation in projective coordinates (X/Z, Y/Z, Z):  (aX² + Y²)Z² = Z⁴ + dX²Y²
            const { ex: X, ey: Y, ez: Z, et: T } = this;
            const X2 = modP(X * X); // X²
            const Y2 = modP(Y * Y); // Y²
            const Z2 = modP(Z * Z); // Z²
            const Z4 = modP(Z2 * Z2); // Z⁴
            const aX2 = modP(X2 * a); // aX²
            const left = modP(Z2 * modP(aX2 + Y2)); // (aX² + Y²)Z²
            const right = modP(Z4 + modP(d * modP(X2 * Y2))); // Z⁴ + dX²Y²
            if (left !== right) throw new Error("bad point: equation left != right (1)");
            // In Extended coordinates we also have T, which is x*y=T/Z: check X*Y == Z*T
            const XY = modP(X * Y);
            const ZT = modP(Z * T);
            if (XY !== ZT) throw new Error("bad point: equation left != right (2)");
        }
        // Compare one point to another.
        equals(other) {
            isPoint(other);
            const { ex: X1, ey: Y1, ez: Z1 } = this;
            const { ex: X2, ey: Y2, ez: Z2 } = other;
            const X1Z2 = modP(X1 * Z2);
            const X2Z1 = modP(X2 * Z1);
            const Y1Z2 = modP(Y1 * Z2);
            const Y2Z1 = modP(Y2 * Z1);
            return X1Z2 === X2Z1 && Y1Z2 === Y2Z1;
        }
        is0() {
            return this.equals(Point.ZERO);
        }
        negate() {
            // Flips point sign to a negative one (-x, y in affine coords)
            return new Point(modP(-this.ex), this.ey, this.ez, modP(-this.et));
        }
        // Fast algo for doubling Extended Point.
        // https://hyperelliptic.org/EFD/g1p/auto-twisted-extended.html#doubling-dbl-2008-hwcd
        // Cost: 4M + 4S + 1*a + 6add + 1*2.
        double() {
            const { a: a } = CURVE;
            const { ex: X1, ey: Y1, ez: Z1 } = this;
            const A = modP(X1 * X1); // A = X12
            const B = modP(Y1 * Y1); // B = Y12
            const C = modP($04f5c7e644575b38$var$_2n * modP(Z1 * Z1)); // C = 2*Z12
            const D = modP(a * A); // D = a*A
            const x1y1 = X1 + Y1;
            const E = modP(modP(x1y1 * x1y1) - A - B); // E = (X1+Y1)2-A-B
            const G = D + B; // G = D+B
            const F = G - C; // F = G-C
            const H = D - B; // H = D-B
            const X3 = modP(E * F); // X3 = E*F
            const Y3 = modP(G * H); // Y3 = G*H
            const T3 = modP(E * H); // T3 = E*H
            const Z3 = modP(F * G); // Z3 = F*G
            return new Point(X3, Y3, Z3, T3);
        }
        // Fast algo for adding 2 Extended Points.
        // https://hyperelliptic.org/EFD/g1p/auto-twisted-extended.html#addition-add-2008-hwcd
        // Cost: 9M + 1*a + 1*d + 7add.
        add(other) {
            isPoint(other);
            const { a: a, d: d } = CURVE;
            const { ex: X1, ey: Y1, ez: Z1, et: T1 } = this;
            const { ex: X2, ey: Y2, ez: Z2, et: T2 } = other;
            // Faster algo for adding 2 Extended Points when curve's a=-1.
            // http://hyperelliptic.org/EFD/g1p/auto-twisted-extended-1.html#addition-add-2008-hwcd-4
            // Cost: 8M + 8add + 2*2.
            // Note: It does not check whether the `other` point is valid.
            if (a === BigInt(-1)) {
                const A = modP((Y1 - X1) * (Y2 + X2));
                const B = modP((Y1 + X1) * (Y2 - X2));
                const F = modP(B - A);
                if (F === $04f5c7e644575b38$var$_0n) return this.double(); // Same point. Tests say it doesn't affect timing
                const C = modP(Z1 * $04f5c7e644575b38$var$_2n * T2);
                const D = modP(T1 * $04f5c7e644575b38$var$_2n * Z2);
                const E = D + C;
                const G = B + A;
                const H = D - C;
                const X3 = modP(E * F);
                const Y3 = modP(G * H);
                const T3 = modP(E * H);
                const Z3 = modP(F * G);
                return new Point(X3, Y3, Z3, T3);
            }
            const A = modP(X1 * X2); // A = X1*X2
            const B = modP(Y1 * Y2); // B = Y1*Y2
            const C = modP(T1 * d * T2); // C = T1*d*T2
            const D = modP(Z1 * Z2); // D = Z1*Z2
            const E = modP((X1 + Y1) * (X2 + Y2) - A - B); // E = (X1+Y1)*(X2+Y2)-A-B
            const F = D - C; // F = D-C
            const G = D + C; // G = D+C
            const H = modP(B - a * A); // H = B-a*A
            const X3 = modP(E * F); // X3 = E*F
            const Y3 = modP(G * H); // Y3 = G*H
            const T3 = modP(E * H); // T3 = E*H
            const Z3 = modP(F * G); // Z3 = F*G
            return new Point(X3, Y3, Z3, T3);
        }
        subtract(other) {
            return this.add(other.negate());
        }
        wNAF(n) {
            return wnaf.wNAFCached(this, pointPrecomputes, n, Point.normalizeZ);
        }
        // Constant-time multiplication.
        multiply(scalar) {
            const { p: p, f: f } = this.wNAF(assertInRange(scalar, CURVE_ORDER));
            return Point.normalizeZ([
                p,
                f
            ])[0];
        }
        // Non-constant-time multiplication. Uses double-and-add algorithm.
        // It's faster, but should only be used when you don't care about
        // an exposed private key e.g. sig verification.
        // Does NOT allow scalars higher than CURVE.n.
        multiplyUnsafe(scalar) {
            let n = assertGE0(scalar); // 0 <= scalar < CURVE.n
            if (n === $04f5c7e644575b38$var$_0n) return I;
            if (this.equals(I) || n === $04f5c7e644575b38$var$_1n) return this;
            if (this.equals(G)) return this.wNAF(n).p;
            return wnaf.unsafeLadder(this, n);
        }
        // Checks if point is of small order.
        // If you add something to small order point, you will have "dirty"
        // point with torsion component.
        // Multiplies point by cofactor and checks if the result is 0.
        isSmallOrder() {
            return this.multiplyUnsafe(cofactor).is0();
        }
        // Multiplies point by curve order and checks if the result is 0.
        // Returns `false` is the point is dirty.
        isTorsionFree() {
            return wnaf.unsafeLadder(this, CURVE_ORDER).is0();
        }
        // Converts Extended point to default (x, y) coordinates.
        // Can accept precomputed Z^-1 - for example, from invertBatch.
        toAffine(iz) {
            const { ex: x, ey: y, ez: z } = this;
            const is0 = this.is0();
            if (iz == null) iz = is0 ? $04f5c7e644575b38$var$_8n : Fp.inv(z); // 8 was chosen arbitrarily
            const ax = modP(x * iz);
            const ay = modP(y * iz);
            const zz = modP(z * iz);
            if (is0) return {
                x: $04f5c7e644575b38$var$_0n,
                y: $04f5c7e644575b38$var$_1n
            };
            if (zz !== $04f5c7e644575b38$var$_1n) throw new Error("invZ was invalid");
            return {
                x: ax,
                y: ay
            };
        }
        clearCofactor() {
            const { h: cofactor } = CURVE;
            if (cofactor === $04f5c7e644575b38$var$_1n) return this;
            return this.multiplyUnsafe(cofactor);
        }
        // Converts hash string or Uint8Array to Point.
        // Uses algo from RFC8032 5.1.3.
        static fromHex(hex, zip215 = false) {
            const { d: d, a: a } = CURVE;
            const len = Fp.BYTES;
            hex = (0, $esaJO.ensureBytes)("pointHex", hex, len); // copy hex to a new array
            const normed = hex.slice(); // copy again, we'll manipulate it
            const lastByte = hex[len - 1]; // select last byte
            normed[len - 1] = lastByte & -129; // clear last bit
            const y = $esaJO.bytesToNumberLE(normed);
            if (y === $04f5c7e644575b38$var$_0n) ;
            else // RFC8032 prohibits >= p, but ZIP215 doesn't
            if (zip215) assertInRange(y, MASK); // zip215=true [1..P-1] (2^255-19-1 for ed25519)
            else assertInRange(y, Fp.ORDER); // zip215=false [1..MASK-1] (2^256-1 for ed25519)
            // Ed25519: x² = (y²-1)/(dy²+1) mod p. Ed448: x² = (y²-1)/(dy²-1) mod p. Generic case:
            // ax²+y²=1+dx²y² => y²-1=dx²y²-ax² => y²-1=x²(dy²-a) => x²=(y²-1)/(dy²-a)
            const y2 = modP(y * y); // denominator is always non-0 mod p.
            const u = modP(y2 - $04f5c7e644575b38$var$_1n); // u = y² - 1
            const v = modP(d * y2 - a); // v = d y² + 1.
            let { isValid: isValid, value: x } = uvRatio(u, v); // √(u/v)
            if (!isValid) throw new Error("Point.fromHex: invalid y coordinate");
            const isXOdd = (x & $04f5c7e644575b38$var$_1n) === $04f5c7e644575b38$var$_1n; // There are 2 square roots. Use x_0 bit to select proper
            const isLastByteOdd = (lastByte & 0x80) !== 0; // x_0, last bit
            if (!zip215 && x === $04f5c7e644575b38$var$_0n && isLastByteOdd) // if x=0 and x_0 = 1, fail
            throw new Error("Point.fromHex: x=0 and x_0=1");
            if (isLastByteOdd !== isXOdd) x = modP(-x); // if x_0 != x mod 2, set x = p-x
            return Point.fromAffine({
                x: x,
                y: y
            });
        }
        static fromPrivateKey(privKey) {
            return getExtendedPublicKey(privKey).point;
        }
        toRawBytes() {
            const { x: x, y: y } = this.toAffine();
            const bytes = $esaJO.numberToBytesLE(y, Fp.BYTES); // each y has 2 x values (x, -y)
            bytes[bytes.length - 1] |= x & $04f5c7e644575b38$var$_1n ? 0x80 : 0; // when compressing, it's enough to store y
            return bytes; // and use the last byte to encode sign of x
        }
        toHex() {
            return $esaJO.bytesToHex(this.toRawBytes()); // Same as toRawBytes, but returns string.
        }
    }
    Point.BASE = new Point(CURVE.Gx, CURVE.Gy, $04f5c7e644575b38$var$_1n, modP(CURVE.Gx * CURVE.Gy));
    Point.ZERO = new Point($04f5c7e644575b38$var$_0n, $04f5c7e644575b38$var$_1n, $04f5c7e644575b38$var$_1n, $04f5c7e644575b38$var$_0n); // 0, 1, 1, 0
    const { BASE: G, ZERO: I } = Point;
    const wnaf = (0, $lkFCe.wNAF)(Point, nByteLength * 8);
    function modN(a) {
        return (0, $2D9sF.mod)(a, CURVE_ORDER);
    }
    // Little-endian SHA512 with modulo n
    function modN_LE(hash) {
        return modN($esaJO.bytesToNumberLE(hash));
    }
    /** Convenience method that creates public key and other stuff. RFC8032 5.1.5 */ function getExtendedPublicKey(key) {
        const len = nByteLength;
        key = (0, $esaJO.ensureBytes)("private key", key, len);
        // Hash private key with curve's hash function to produce uniformingly random input
        // Check byte lengths: ensure(64, h(ensure(32, key)))
        const hashed = (0, $esaJO.ensureBytes)("hashed private key", cHash(key), 2 * len);
        const head = adjustScalarBytes(hashed.slice(0, len)); // clear first half bits, produce FE
        const prefix = hashed.slice(len, 2 * len); // second half is called key prefix (5.1.6)
        const scalar = modN_LE(head); // The actual private scalar
        const point = G.multiply(scalar); // Point on Edwards curve aka public key
        const pointBytes = point.toRawBytes(); // Uint8Array representation
        return {
            head: head,
            prefix: prefix,
            scalar: scalar,
            point: point,
            pointBytes: pointBytes
        };
    }
    // Calculates EdDSA pub key. RFC8032 5.1.5. Privkey is hashed. Use first half with 3 bits cleared
    function getPublicKey(privKey) {
        return getExtendedPublicKey(privKey).pointBytes;
    }
    // int('LE', SHA512(dom2(F, C) || msgs)) mod N
    function hashDomainToScalar(context = new Uint8Array(), ...msgs) {
        const msg = $esaJO.concatBytes(...msgs);
        return modN_LE(cHash(domain(msg, (0, $esaJO.ensureBytes)("context", context), !!prehash)));
    }
    /** Signs message with privateKey. RFC8032 5.1.6 */ function sign(msg, privKey, options = {}) {
        msg = (0, $esaJO.ensureBytes)("message", msg);
        if (prehash) msg = prehash(msg); // for ed25519ph etc.
        const { prefix: prefix, scalar: scalar, pointBytes: pointBytes } = getExtendedPublicKey(privKey);
        const r = hashDomainToScalar(options.context, prefix, msg); // r = dom2(F, C) || prefix || PH(M)
        const R = G.multiply(r).toRawBytes(); // R = rG
        const k = hashDomainToScalar(options.context, R, pointBytes, msg); // R || A || PH(M)
        const s = modN(r + k * scalar); // S = (r + k * s) mod L
        assertGE0(s); // 0 <= s < l
        const res = $esaJO.concatBytes(R, $esaJO.numberToBytesLE(s, Fp.BYTES));
        return (0, $esaJO.ensureBytes)("result", res, nByteLength * 2); // 64-byte signature
    }
    const verifyOpts = $04f5c7e644575b38$var$VERIFY_DEFAULT;
    function verify(sig, msg, publicKey, options = verifyOpts) {
        const { context: context, zip215: zip215 } = options;
        const len = Fp.BYTES; // Verifies EdDSA signature against message and public key. RFC8032 5.1.7.
        sig = (0, $esaJO.ensureBytes)("signature", sig, 2 * len); // An extended group equation is checked.
        msg = (0, $esaJO.ensureBytes)("message", msg);
        if (prehash) msg = prehash(msg); // for ed25519ph, etc
        const s = $esaJO.bytesToNumberLE(sig.slice(len, 2 * len));
        // zip215: true is good for consensus-critical apps and allows points < 2^256
        // zip215: false follows RFC8032 / NIST186-5 and restricts points to CURVE.p
        let A, R, SB;
        try {
            A = Point.fromHex(publicKey, zip215);
            R = Point.fromHex(sig.slice(0, len), zip215);
            SB = G.multiplyUnsafe(s); // 0 <= s < l is done inside
        } catch (error) {
            return false;
        }
        if (!zip215 && A.isSmallOrder()) return false;
        const k = hashDomainToScalar(context, R.toRawBytes(), A.toRawBytes(), msg);
        const RkA = R.add(A.multiplyUnsafe(k));
        // [8][S]B = [8]R + [8][k]A'
        return RkA.subtract(SB).clearCofactor().equals(Point.ZERO);
    }
    G._setWindowSize(8); // Enable precomputes. Slows down first publicKey computation by 20ms.
    const utils = {
        getExtendedPublicKey: getExtendedPublicKey,
        // ed25519 private keys are uniform 32b. No need to check for modulo bias, like in secp256k1.
        randomPrivateKey: ()=>randomBytes(Fp.BYTES),
        /**
         * We're doing scalar multiplication (used in getPublicKey etc) with precomputed BASE_POINT
         * values. This slows down first getPublicKey() by milliseconds (see Speed section),
         * but allows to speed-up subsequent getPublicKey() calls up to 20x.
         * @param windowSize 2, 4, 8, 16
         */ precompute (windowSize = 8, point = Point.BASE) {
            point._setWindowSize(windowSize);
            point.multiply(BigInt(3));
            return point;
        }
    };
    return {
        CURVE: CURVE,
        getPublicKey: getPublicKey,
        sign: sign,
        verify: verify,
        ExtendedPoint: Point,
        utils: utils
    };
}
module.exports.twistedEdwards = $04f5c7e644575b38$var$twistedEdwards;

});
parcelRegister("2D9sF", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.mapHashToField = module.exports.getMinHashLength = module.exports.getFieldBytesLength = module.exports.hashToPrivateScalar = module.exports.FpSqrtEven = module.exports.FpSqrtOdd = module.exports.Field = module.exports.nLength = module.exports.FpIsSquare = module.exports.FpDiv = module.exports.FpInvertBatch = module.exports.FpPow = module.exports.validateField = module.exports.isNegativeLE = module.exports.FpSqrt = module.exports.tonelliShanks = module.exports.invert = module.exports.pow2 = module.exports.pow = module.exports.mod = void 0;

var $esaJO = parcelRequire("esaJO");
// prettier-ignore
const $1ea6901afdde618b$var$_0n = BigInt(0), $1ea6901afdde618b$var$_1n = BigInt(1), $1ea6901afdde618b$var$_2n = BigInt(2), $1ea6901afdde618b$var$_3n = BigInt(3);
// prettier-ignore
const $1ea6901afdde618b$var$_4n = BigInt(4), $1ea6901afdde618b$var$_5n = BigInt(5), $1ea6901afdde618b$var$_8n = BigInt(8);
// prettier-ignore
const $1ea6901afdde618b$var$_9n = BigInt(9), $1ea6901afdde618b$var$_16n = BigInt(16);
// Calculates a modulo b
function $1ea6901afdde618b$var$mod(a, b) {
    const result = a % b;
    return result >= $1ea6901afdde618b$var$_0n ? result : b + result;
}
module.exports.mod = $1ea6901afdde618b$var$mod;
/**
 * Efficiently raise num to power and do modular division.
 * Unsafe in some contexts: uses ladder, so can expose bigint bits.
 * @example
 * pow(2n, 6n, 11n) // 64n % 11n == 9n
 */ // TODO: use field version && remove
function $1ea6901afdde618b$var$pow(num, power, modulo) {
    if (modulo <= $1ea6901afdde618b$var$_0n || power < $1ea6901afdde618b$var$_0n) throw new Error("Expected power/modulo > 0");
    if (modulo === $1ea6901afdde618b$var$_1n) return $1ea6901afdde618b$var$_0n;
    let res = $1ea6901afdde618b$var$_1n;
    while(power > $1ea6901afdde618b$var$_0n){
        if (power & $1ea6901afdde618b$var$_1n) res = res * num % modulo;
        num = num * num % modulo;
        power >>= $1ea6901afdde618b$var$_1n;
    }
    return res;
}
module.exports.pow = $1ea6901afdde618b$var$pow;
// Does x ^ (2 ^ power) mod p. pow2(30, 4) == 30 ^ (2 ^ 4)
function $1ea6901afdde618b$var$pow2(x, power, modulo) {
    let res = x;
    while(power-- > $1ea6901afdde618b$var$_0n){
        res *= res;
        res %= modulo;
    }
    return res;
}
module.exports.pow2 = $1ea6901afdde618b$var$pow2;
// Inverses number over modulo
function $1ea6901afdde618b$var$invert(number, modulo) {
    if (number === $1ea6901afdde618b$var$_0n || modulo <= $1ea6901afdde618b$var$_0n) throw new Error(`invert: expected positive integers, got n=${number} mod=${modulo}`);
    // Euclidean GCD https://brilliant.org/wiki/extended-euclidean-algorithm/
    // Fermat's little theorem "CT-like" version inv(n) = n^(m-2) mod m is 30x slower.
    let a = $1ea6901afdde618b$var$mod(number, modulo);
    let b = modulo;
    // prettier-ignore
    let x = $1ea6901afdde618b$var$_0n, y = $1ea6901afdde618b$var$_1n, u = $1ea6901afdde618b$var$_1n, v = $1ea6901afdde618b$var$_0n;
    while(a !== $1ea6901afdde618b$var$_0n){
        // JIT applies optimization if those two lines follow each other
        const q = b / a;
        const r = b % a;
        const m = x - u * q;
        const n = y - v * q;
        // prettier-ignore
        b = a, a = r, x = u, y = v, u = m, v = n;
    }
    const gcd = b;
    if (gcd !== $1ea6901afdde618b$var$_1n) throw new Error("invert: does not exist");
    return $1ea6901afdde618b$var$mod(x, modulo);
}
module.exports.invert = $1ea6901afdde618b$var$invert;
/**
 * Tonelli-Shanks square root search algorithm.
 * 1. https://eprint.iacr.org/2012/685.pdf (page 12)
 * 2. Square Roots from 1; 24, 51, 10 to Dan Shanks
 * Will start an infinite loop if field order P is not prime.
 * @param P field order
 * @returns function that takes field Fp (created from P) and number n
 */ function $1ea6901afdde618b$var$tonelliShanks(P) {
    // Legendre constant: used to calculate Legendre symbol (a | p),
    // which denotes the value of a^((p-1)/2) (mod p).
    // (a | p) ≡ 1    if a is a square (mod p)
    // (a | p) ≡ -1   if a is not a square (mod p)
    // (a | p) ≡ 0    if a ≡ 0 (mod p)
    const legendreC = (P - $1ea6901afdde618b$var$_1n) / $1ea6901afdde618b$var$_2n;
    let Q, S, Z;
    // Step 1: By factoring out powers of 2 from p - 1,
    // find q and s such that p - 1 = q*(2^s) with q odd
    for(Q = P - $1ea6901afdde618b$var$_1n, S = 0; Q % $1ea6901afdde618b$var$_2n === $1ea6901afdde618b$var$_0n; Q /= $1ea6901afdde618b$var$_2n, S++);
    // Step 2: Select a non-square z such that (z | p) ≡ -1 and set c ≡ zq
    for(Z = $1ea6901afdde618b$var$_2n; Z < P && $1ea6901afdde618b$var$pow(Z, legendreC, P) !== P - $1ea6901afdde618b$var$_1n; Z++);
    // Fast-path
    if (S === 1) {
        const p1div4 = (P + $1ea6901afdde618b$var$_1n) / $1ea6901afdde618b$var$_4n;
        return function tonelliFast(Fp, n) {
            const root = Fp.pow(n, p1div4);
            if (!Fp.eql(Fp.sqr(root), n)) throw new Error("Cannot find square root");
            return root;
        };
    }
    // Slow-path
    const Q1div2 = (Q + $1ea6901afdde618b$var$_1n) / $1ea6901afdde618b$var$_2n;
    return function tonelliSlow(Fp, n) {
        // Step 0: Check that n is indeed a square: (n | p) should not be ≡ -1
        if (Fp.pow(n, legendreC) === Fp.neg(Fp.ONE)) throw new Error("Cannot find square root");
        let r = S;
        // TODO: will fail at Fp2/etc
        let g = Fp.pow(Fp.mul(Fp.ONE, Z), Q); // will update both x and b
        let x = Fp.pow(n, Q1div2); // first guess at the square root
        let b = Fp.pow(n, Q); // first guess at the fudge factor
        while(!Fp.eql(b, Fp.ONE)){
            if (Fp.eql(b, Fp.ZERO)) return Fp.ZERO; // https://en.wikipedia.org/wiki/Tonelli%E2%80%93Shanks_algorithm (4. If t = 0, return r = 0)
            // Find m such b^(2^m)==1
            let m = 1;
            for(let t2 = Fp.sqr(b); m < r; m++){
                if (Fp.eql(t2, Fp.ONE)) break;
                t2 = Fp.sqr(t2); // t2 *= t2
            }
            // NOTE: r-m-1 can be bigger than 32, need to convert to bigint before shift, otherwise there will be overflow
            const ge = Fp.pow(g, $1ea6901afdde618b$var$_1n << BigInt(r - m - 1)); // ge = 2^(r-m-1)
            g = Fp.sqr(ge); // g = ge * ge
            x = Fp.mul(x, ge); // x *= ge
            b = Fp.mul(b, g); // b *= g
            r = m;
        }
        return x;
    };
}
module.exports.tonelliShanks = $1ea6901afdde618b$var$tonelliShanks;
function $1ea6901afdde618b$var$FpSqrt(P) {
    // NOTE: different algorithms can give different roots, it is up to user to decide which one they want.
    // For example there is FpSqrtOdd/FpSqrtEven to choice root based on oddness (used for hash-to-curve).
    // P ≡ 3 (mod 4)
    // √n = n^((P+1)/4)
    if (P % $1ea6901afdde618b$var$_4n === $1ea6901afdde618b$var$_3n) {
        // Not all roots possible!
        // const ORDER =
        //   0x1a0111ea397fe69a4b1ba7b6434bacd764774b84f38512bf6730d2a0f6b0f6241eabfffeb153ffffb9feffffffffaaabn;
        // const NUM = 72057594037927816n;
        const p1div4 = (P + $1ea6901afdde618b$var$_1n) / $1ea6901afdde618b$var$_4n;
        return function sqrt3mod4(Fp, n) {
            const root = Fp.pow(n, p1div4);
            // Throw if root**2 != n
            if (!Fp.eql(Fp.sqr(root), n)) throw new Error("Cannot find square root");
            return root;
        };
    }
    // Atkin algorithm for q ≡ 5 (mod 8), https://eprint.iacr.org/2012/685.pdf (page 10)
    if (P % $1ea6901afdde618b$var$_8n === $1ea6901afdde618b$var$_5n) {
        const c1 = (P - $1ea6901afdde618b$var$_5n) / $1ea6901afdde618b$var$_8n;
        return function sqrt5mod8(Fp, n) {
            const n2 = Fp.mul(n, $1ea6901afdde618b$var$_2n);
            const v = Fp.pow(n2, c1);
            const nv = Fp.mul(n, v);
            const i = Fp.mul(Fp.mul(nv, $1ea6901afdde618b$var$_2n), v);
            const root = Fp.mul(nv, Fp.sub(i, Fp.ONE));
            if (!Fp.eql(Fp.sqr(root), n)) throw new Error("Cannot find square root");
            return root;
        };
    }
    // P ≡ 9 (mod 16)
    $1ea6901afdde618b$var$_9n;
    // Other cases: Tonelli-Shanks algorithm
    return $1ea6901afdde618b$var$tonelliShanks(P);
}
module.exports.FpSqrt = $1ea6901afdde618b$var$FpSqrt;
// Little-endian check for first LE bit (last BE bit);
const $1ea6901afdde618b$var$isNegativeLE = (num, modulo)=>($1ea6901afdde618b$var$mod(num, modulo) & $1ea6901afdde618b$var$_1n) === $1ea6901afdde618b$var$_1n;
module.exports.isNegativeLE = $1ea6901afdde618b$var$isNegativeLE;
// prettier-ignore
const $1ea6901afdde618b$var$FIELD_FIELDS = [
    "create",
    "isValid",
    "is0",
    "neg",
    "inv",
    "sqrt",
    "sqr",
    "eql",
    "add",
    "sub",
    "mul",
    "pow",
    "div",
    "addN",
    "subN",
    "mulN",
    "sqrN"
];
function $1ea6901afdde618b$var$validateField(field) {
    const initial = {
        ORDER: "bigint",
        MASK: "bigint",
        BYTES: "isSafeInteger",
        BITS: "isSafeInteger"
    };
    const opts = $1ea6901afdde618b$var$FIELD_FIELDS.reduce((map, val)=>{
        map[val] = "function";
        return map;
    }, initial);
    return (0, $esaJO.validateObject)(field, opts);
}
module.exports.validateField = $1ea6901afdde618b$var$validateField;
// Generic field functions
/**
 * Same as `pow` but for Fp: non-constant-time.
 * Unsafe in some contexts: uses ladder, so can expose bigint bits.
 */ function $1ea6901afdde618b$var$FpPow(f, num, power) {
    // Should have same speed as pow for bigints
    // TODO: benchmark!
    if (power < $1ea6901afdde618b$var$_0n) throw new Error("Expected power > 0");
    if (power === $1ea6901afdde618b$var$_0n) return f.ONE;
    if (power === $1ea6901afdde618b$var$_1n) return num;
    let p = f.ONE;
    let d = num;
    while(power > $1ea6901afdde618b$var$_0n){
        if (power & $1ea6901afdde618b$var$_1n) p = f.mul(p, d);
        d = f.sqr(d);
        power >>= $1ea6901afdde618b$var$_1n;
    }
    return p;
}
module.exports.FpPow = $1ea6901afdde618b$var$FpPow;
/**
 * Efficiently invert an array of Field elements.
 * `inv(0)` will return `undefined` here: make sure to throw an error.
 */ function $1ea6901afdde618b$var$FpInvertBatch(f, nums) {
    const tmp = new Array(nums.length);
    // Walk from first to last, multiply them by each other MOD p
    const lastMultiplied = nums.reduce((acc, num, i)=>{
        if (f.is0(num)) return acc;
        tmp[i] = acc;
        return f.mul(acc, num);
    }, f.ONE);
    // Invert last element
    const inverted = f.inv(lastMultiplied);
    // Walk from last to first, multiply them by inverted each other MOD p
    nums.reduceRight((acc, num, i)=>{
        if (f.is0(num)) return acc;
        tmp[i] = f.mul(acc, tmp[i]);
        return f.mul(acc, num);
    }, inverted);
    return tmp;
}
module.exports.FpInvertBatch = $1ea6901afdde618b$var$FpInvertBatch;
function $1ea6901afdde618b$var$FpDiv(f, lhs, rhs) {
    return f.mul(lhs, typeof rhs === "bigint" ? $1ea6901afdde618b$var$invert(rhs, f.ORDER) : f.inv(rhs));
}
module.exports.FpDiv = $1ea6901afdde618b$var$FpDiv;
// This function returns True whenever the value x is a square in the field F.
function $1ea6901afdde618b$var$FpIsSquare(f) {
    const legendreConst = (f.ORDER - $1ea6901afdde618b$var$_1n) / $1ea6901afdde618b$var$_2n; // Integer arithmetic
    return (x)=>{
        const p = f.pow(x, legendreConst);
        return f.eql(p, f.ZERO) || f.eql(p, f.ONE);
    };
}
module.exports.FpIsSquare = $1ea6901afdde618b$var$FpIsSquare;
// CURVE.n lengths
function $1ea6901afdde618b$var$nLength(n, nBitLength) {
    // Bit size, byte size of CURVE.n
    const _nBitLength = nBitLength !== undefined ? nBitLength : n.toString(2).length;
    const nByteLength = Math.ceil(_nBitLength / 8);
    return {
        nBitLength: _nBitLength,
        nByteLength: nByteLength
    };
}
module.exports.nLength = $1ea6901afdde618b$var$nLength;
/**
 * Initializes a finite field over prime. **Non-primes are not supported.**
 * Do not init in loop: slow. Very fragile: always run a benchmark on a change.
 * Major performance optimizations:
 * * a) denormalized operations like mulN instead of mul
 * * b) same object shape: never add or remove keys
 * * c) Object.freeze
 * @param ORDER prime positive bigint
 * @param bitLen how many bits the field consumes
 * @param isLE (def: false) if encoding / decoding should be in little-endian
 * @param redef optional faster redefinitions of sqrt and other methods
 */ function $1ea6901afdde618b$var$Field(ORDER, bitLen, isLE = false, redef = {}) {
    if (ORDER <= $1ea6901afdde618b$var$_0n) throw new Error(`Expected Field ORDER > 0, got ${ORDER}`);
    const { nBitLength: BITS, nByteLength: BYTES } = $1ea6901afdde618b$var$nLength(ORDER, bitLen);
    if (BYTES > 2048) throw new Error("Field lengths over 2048 bytes are not supported");
    const sqrtP = $1ea6901afdde618b$var$FpSqrt(ORDER);
    const f = Object.freeze({
        ORDER: ORDER,
        BITS: BITS,
        BYTES: BYTES,
        MASK: (0, $esaJO.bitMask)(BITS),
        ZERO: $1ea6901afdde618b$var$_0n,
        ONE: $1ea6901afdde618b$var$_1n,
        create: (num)=>$1ea6901afdde618b$var$mod(num, ORDER),
        isValid: (num)=>{
            if (typeof num !== "bigint") throw new Error(`Invalid field element: expected bigint, got ${typeof num}`);
            return $1ea6901afdde618b$var$_0n <= num && num < ORDER; // 0 is valid element, but it's not invertible
        },
        is0: (num)=>num === $1ea6901afdde618b$var$_0n,
        isOdd: (num)=>(num & $1ea6901afdde618b$var$_1n) === $1ea6901afdde618b$var$_1n,
        neg: (num)=>$1ea6901afdde618b$var$mod(-num, ORDER),
        eql: (lhs, rhs)=>lhs === rhs,
        sqr: (num)=>$1ea6901afdde618b$var$mod(num * num, ORDER),
        add: (lhs, rhs)=>$1ea6901afdde618b$var$mod(lhs + rhs, ORDER),
        sub: (lhs, rhs)=>$1ea6901afdde618b$var$mod(lhs - rhs, ORDER),
        mul: (lhs, rhs)=>$1ea6901afdde618b$var$mod(lhs * rhs, ORDER),
        pow: (num, power)=>$1ea6901afdde618b$var$FpPow(f, num, power),
        div: (lhs, rhs)=>$1ea6901afdde618b$var$mod(lhs * $1ea6901afdde618b$var$invert(rhs, ORDER), ORDER),
        // Same as above, but doesn't normalize
        sqrN: (num)=>num * num,
        addN: (lhs, rhs)=>lhs + rhs,
        subN: (lhs, rhs)=>lhs - rhs,
        mulN: (lhs, rhs)=>lhs * rhs,
        inv: (num)=>$1ea6901afdde618b$var$invert(num, ORDER),
        sqrt: redef.sqrt || ((n)=>sqrtP(f, n)),
        invertBatch: (lst)=>$1ea6901afdde618b$var$FpInvertBatch(f, lst),
        // TODO: do we really need constant cmov?
        // We don't have const-time bigints anyway, so probably will be not very useful
        cmov: (a, b, c)=>c ? b : a,
        toBytes: (num)=>isLE ? (0, $esaJO.numberToBytesLE)(num, BYTES) : (0, $esaJO.numberToBytesBE)(num, BYTES),
        fromBytes: (bytes)=>{
            if (bytes.length !== BYTES) throw new Error(`Fp.fromBytes: expected ${BYTES}, got ${bytes.length}`);
            return isLE ? (0, $esaJO.bytesToNumberLE)(bytes) : (0, $esaJO.bytesToNumberBE)(bytes);
        }
    });
    return Object.freeze(f);
}
module.exports.Field = $1ea6901afdde618b$var$Field;
function $1ea6901afdde618b$var$FpSqrtOdd(Fp, elm) {
    if (!Fp.isOdd) throw new Error(`Field doesn't have isOdd`);
    const root = Fp.sqrt(elm);
    return Fp.isOdd(root) ? root : Fp.neg(root);
}
module.exports.FpSqrtOdd = $1ea6901afdde618b$var$FpSqrtOdd;
function $1ea6901afdde618b$var$FpSqrtEven(Fp, elm) {
    if (!Fp.isOdd) throw new Error(`Field doesn't have isOdd`);
    const root = Fp.sqrt(elm);
    return Fp.isOdd(root) ? Fp.neg(root) : root;
}
module.exports.FpSqrtEven = $1ea6901afdde618b$var$FpSqrtEven;
/**
 * "Constant-time" private key generation utility.
 * Same as mapKeyToField, but accepts less bytes (40 instead of 48 for 32-byte field).
 * Which makes it slightly more biased, less secure.
 * @deprecated use mapKeyToField instead
 */ function $1ea6901afdde618b$var$hashToPrivateScalar(hash, groupOrder, isLE = false) {
    hash = (0, $esaJO.ensureBytes)("privateHash", hash);
    const hashLen = hash.length;
    const minLen = $1ea6901afdde618b$var$nLength(groupOrder).nByteLength + 8;
    if (minLen < 24 || hashLen < minLen || hashLen > 1024) throw new Error(`hashToPrivateScalar: expected ${minLen}-1024 bytes of input, got ${hashLen}`);
    const num = isLE ? (0, $esaJO.bytesToNumberLE)(hash) : (0, $esaJO.bytesToNumberBE)(hash);
    return $1ea6901afdde618b$var$mod(num, groupOrder - $1ea6901afdde618b$var$_1n) + $1ea6901afdde618b$var$_1n;
}
module.exports.hashToPrivateScalar = $1ea6901afdde618b$var$hashToPrivateScalar;
/**
 * Returns total number of bytes consumed by the field element.
 * For example, 32 bytes for usual 256-bit weierstrass curve.
 * @param fieldOrder number of field elements, usually CURVE.n
 * @returns byte length of field
 */ function $1ea6901afdde618b$var$getFieldBytesLength(fieldOrder) {
    if (typeof fieldOrder !== "bigint") throw new Error("field order must be bigint");
    const bitLength = fieldOrder.toString(2).length;
    return Math.ceil(bitLength / 8);
}
module.exports.getFieldBytesLength = $1ea6901afdde618b$var$getFieldBytesLength;
/**
 * Returns minimal amount of bytes that can be safely reduced
 * by field order.
 * Should be 2^-128 for 128-bit curve such as P256.
 * @param fieldOrder number of field elements, usually CURVE.n
 * @returns byte length of target hash
 */ function $1ea6901afdde618b$var$getMinHashLength(fieldOrder) {
    const length = $1ea6901afdde618b$var$getFieldBytesLength(fieldOrder);
    return length + Math.ceil(length / 2);
}
module.exports.getMinHashLength = $1ea6901afdde618b$var$getMinHashLength;
/**
 * "Constant-time" private key generation utility.
 * Can take (n + n/2) or more bytes of uniform input e.g. from CSPRNG or KDF
 * and convert them into private scalar, with the modulo bias being negligible.
 * Needs at least 48 bytes of input for 32-byte private key.
 * https://research.kudelskisecurity.com/2020/07/28/the-definitive-guide-to-modulo-bias-and-how-to-avoid-it/
 * FIPS 186-5, A.2 https://csrc.nist.gov/publications/detail/fips/186/5/final
 * RFC 9380, https://www.rfc-editor.org/rfc/rfc9380#section-5
 * @param hash hash output from SHA3 or a similar function
 * @param groupOrder size of subgroup - (e.g. secp256k1.CURVE.n)
 * @param isLE interpret hash bytes as LE num
 * @returns valid private scalar
 */ function $1ea6901afdde618b$var$mapHashToField(key, fieldOrder, isLE = false) {
    const len = key.length;
    const fieldLen = $1ea6901afdde618b$var$getFieldBytesLength(fieldOrder);
    const minLen = $1ea6901afdde618b$var$getMinHashLength(fieldOrder);
    // No small numbers: need to understand bias story. No huge numbers: easier to detect JS timings.
    if (len < 16 || len < minLen || len > 1024) throw new Error(`expected ${minLen}-1024 bytes of input, got ${len}`);
    const num = isLE ? (0, $esaJO.bytesToNumberBE)(key) : (0, $esaJO.bytesToNumberLE)(key);
    // `mod(x, 11)` can sometimes produce 0. `mod(x, 10) + 1` is the same, but no 0
    const reduced = $1ea6901afdde618b$var$mod(num, fieldOrder - $1ea6901afdde618b$var$_1n) + $1ea6901afdde618b$var$_1n;
    return isLE ? (0, $esaJO.numberToBytesLE)(reduced, fieldLen) : (0, $esaJO.numberToBytesBE)(reduced, fieldLen);
}
module.exports.mapHashToField = $1ea6901afdde618b$var$mapHashToField;

});
parcelRegister("esaJO", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.validateObject = module.exports.createHmacDrbg = module.exports.bitMask = module.exports.bitSet = module.exports.bitGet = module.exports.bitLen = module.exports.utf8ToBytes = module.exports.equalBytes = module.exports.concatBytes = module.exports.ensureBytes = module.exports.numberToVarBytesBE = module.exports.numberToBytesLE = module.exports.numberToBytesBE = module.exports.bytesToNumberLE = module.exports.bytesToNumberBE = module.exports.hexToBytes = module.exports.hexToNumber = module.exports.numberToHexUnpadded = module.exports.bytesToHex = void 0;
/*! noble-curves - MIT License (c) 2022 Paul Miller (paulmillr.com) */ // 100 lines of code in the file are duplicated from noble-hashes (utils).
// This is OK: `abstract` directory does not use noble-hashes.
// User may opt-in into using different hashing library. This way, noble-hashes
// won't be included into their bundle.
const $a85c028f110aa8ce$var$_0n = BigInt(0);
const $a85c028f110aa8ce$var$_1n = BigInt(1);
const $a85c028f110aa8ce$var$_2n = BigInt(2);
const $a85c028f110aa8ce$var$u8a = (a)=>a instanceof Uint8Array;
const $a85c028f110aa8ce$var$hexes = /* @__PURE__ */ Array.from({
    length: 256
}, (_, i)=>i.toString(16).padStart(2, "0"));
/**
 * @example bytesToHex(Uint8Array.from([0xca, 0xfe, 0x01, 0x23])) // 'cafe0123'
 */ function $a85c028f110aa8ce$var$bytesToHex(bytes) {
    if (!$a85c028f110aa8ce$var$u8a(bytes)) throw new Error("Uint8Array expected");
    // pre-caching improves the speed 6x
    let hex = "";
    for(let i = 0; i < bytes.length; i++)hex += $a85c028f110aa8ce$var$hexes[bytes[i]];
    return hex;
}
module.exports.bytesToHex = $a85c028f110aa8ce$var$bytesToHex;
function $a85c028f110aa8ce$var$numberToHexUnpadded(num) {
    const hex = num.toString(16);
    return hex.length & 1 ? `0${hex}` : hex;
}
module.exports.numberToHexUnpadded = $a85c028f110aa8ce$var$numberToHexUnpadded;
function $a85c028f110aa8ce$var$hexToNumber(hex) {
    if (typeof hex !== "string") throw new Error("hex string expected, got " + typeof hex);
    // Big Endian
    return BigInt(hex === "" ? "0" : `0x${hex}`);
}
module.exports.hexToNumber = $a85c028f110aa8ce$var$hexToNumber;
/**
 * @example hexToBytes('cafe0123') // Uint8Array.from([0xca, 0xfe, 0x01, 0x23])
 */ function $a85c028f110aa8ce$var$hexToBytes(hex) {
    if (typeof hex !== "string") throw new Error("hex string expected, got " + typeof hex);
    const len = hex.length;
    if (len % 2) throw new Error("padded hex string expected, got unpadded hex of length " + len);
    const array = new Uint8Array(len / 2);
    for(let i = 0; i < array.length; i++){
        const j = i * 2;
        const hexByte = hex.slice(j, j + 2);
        const byte = Number.parseInt(hexByte, 16);
        if (Number.isNaN(byte) || byte < 0) throw new Error("Invalid byte sequence");
        array[i] = byte;
    }
    return array;
}
module.exports.hexToBytes = $a85c028f110aa8ce$var$hexToBytes;
// BE: Big Endian, LE: Little Endian
function $a85c028f110aa8ce$var$bytesToNumberBE(bytes) {
    return $a85c028f110aa8ce$var$hexToNumber($a85c028f110aa8ce$var$bytesToHex(bytes));
}
module.exports.bytesToNumberBE = $a85c028f110aa8ce$var$bytesToNumberBE;
function $a85c028f110aa8ce$var$bytesToNumberLE(bytes) {
    if (!$a85c028f110aa8ce$var$u8a(bytes)) throw new Error("Uint8Array expected");
    return $a85c028f110aa8ce$var$hexToNumber($a85c028f110aa8ce$var$bytesToHex(Uint8Array.from(bytes).reverse()));
}
module.exports.bytesToNumberLE = $a85c028f110aa8ce$var$bytesToNumberLE;
function $a85c028f110aa8ce$var$numberToBytesBE(n, len) {
    return $a85c028f110aa8ce$var$hexToBytes(n.toString(16).padStart(len * 2, "0"));
}
module.exports.numberToBytesBE = $a85c028f110aa8ce$var$numberToBytesBE;
function $a85c028f110aa8ce$var$numberToBytesLE(n, len) {
    return $a85c028f110aa8ce$var$numberToBytesBE(n, len).reverse();
}
module.exports.numberToBytesLE = $a85c028f110aa8ce$var$numberToBytesLE;
// Unpadded, rarely used
function $a85c028f110aa8ce$var$numberToVarBytesBE(n) {
    return $a85c028f110aa8ce$var$hexToBytes($a85c028f110aa8ce$var$numberToHexUnpadded(n));
}
module.exports.numberToVarBytesBE = $a85c028f110aa8ce$var$numberToVarBytesBE;
/**
 * Takes hex string or Uint8Array, converts to Uint8Array.
 * Validates output length.
 * Will throw error for other types.
 * @param title descriptive title for an error e.g. 'private key'
 * @param hex hex string or Uint8Array
 * @param expectedLength optional, will compare to result array's length
 * @returns
 */ function $a85c028f110aa8ce$var$ensureBytes(title, hex, expectedLength) {
    let res;
    if (typeof hex === "string") try {
        res = $a85c028f110aa8ce$var$hexToBytes(hex);
    } catch (e) {
        throw new Error(`${title} must be valid hex string, got "${hex}". Cause: ${e}`);
    }
    else if ($a85c028f110aa8ce$var$u8a(hex)) // Uint8Array.from() instead of hash.slice() because node.js Buffer
    // is instance of Uint8Array, and its slice() creates **mutable** copy
    res = Uint8Array.from(hex);
    else throw new Error(`${title} must be hex string or Uint8Array`);
    const len = res.length;
    if (typeof expectedLength === "number" && len !== expectedLength) throw new Error(`${title} expected ${expectedLength} bytes, got ${len}`);
    return res;
}
module.exports.ensureBytes = $a85c028f110aa8ce$var$ensureBytes;
/**
 * Copies several Uint8Arrays into one.
 */ function $a85c028f110aa8ce$var$concatBytes(...arrays) {
    const r = new Uint8Array(arrays.reduce((sum, a)=>sum + a.length, 0));
    let pad = 0; // walk through each item, ensure they have proper type
    arrays.forEach((a)=>{
        if (!$a85c028f110aa8ce$var$u8a(a)) throw new Error("Uint8Array expected");
        r.set(a, pad);
        pad += a.length;
    });
    return r;
}
module.exports.concatBytes = $a85c028f110aa8ce$var$concatBytes;
function $a85c028f110aa8ce$var$equalBytes(b1, b2) {
    // We don't care about timing attacks here
    if (b1.length !== b2.length) return false;
    for(let i = 0; i < b1.length; i++)if (b1[i] !== b2[i]) return false;
    return true;
}
module.exports.equalBytes = $a85c028f110aa8ce$var$equalBytes;
/**
 * @example utf8ToBytes('abc') // new Uint8Array([97, 98, 99])
 */ function $a85c028f110aa8ce$var$utf8ToBytes(str) {
    if (typeof str !== "string") throw new Error(`utf8ToBytes expected string, got ${typeof str}`);
    return new Uint8Array(new TextEncoder().encode(str)); // https://bugzil.la/1681809
}
module.exports.utf8ToBytes = $a85c028f110aa8ce$var$utf8ToBytes;
// Bit operations
/**
 * Calculates amount of bits in a bigint.
 * Same as `n.toString(2).length`
 */ function $a85c028f110aa8ce$var$bitLen(n) {
    let len;
    for(len = 0; n > $a85c028f110aa8ce$var$_0n; n >>= $a85c028f110aa8ce$var$_1n, len += 1);
    return len;
}
module.exports.bitLen = $a85c028f110aa8ce$var$bitLen;
/**
 * Gets single bit at position.
 * NOTE: first bit position is 0 (same as arrays)
 * Same as `!!+Array.from(n.toString(2)).reverse()[pos]`
 */ function $a85c028f110aa8ce$var$bitGet(n, pos) {
    return n >> BigInt(pos) & $a85c028f110aa8ce$var$_1n;
}
module.exports.bitGet = $a85c028f110aa8ce$var$bitGet;
/**
 * Sets single bit at position.
 */ const $a85c028f110aa8ce$var$bitSet = (n, pos, value)=>{
    return n | (value ? $a85c028f110aa8ce$var$_1n : $a85c028f110aa8ce$var$_0n) << BigInt(pos);
};
module.exports.bitSet = $a85c028f110aa8ce$var$bitSet;
/**
 * Calculate mask for N bits. Not using ** operator with bigints because of old engines.
 * Same as BigInt(`0b${Array(i).fill('1').join('')}`)
 */ const $a85c028f110aa8ce$var$bitMask = (n)=>($a85c028f110aa8ce$var$_2n << BigInt(n - 1)) - $a85c028f110aa8ce$var$_1n;
module.exports.bitMask = $a85c028f110aa8ce$var$bitMask;
// DRBG
const $a85c028f110aa8ce$var$u8n = (data)=>new Uint8Array(data); // creates Uint8Array
const $a85c028f110aa8ce$var$u8fr = (arr)=>Uint8Array.from(arr); // another shortcut
/**
 * Minimal HMAC-DRBG from NIST 800-90 for RFC6979 sigs.
 * @returns function that will call DRBG until 2nd arg returns something meaningful
 * @example
 *   const drbg = createHmacDRBG<Key>(32, 32, hmac);
 *   drbg(seed, bytesToKey); // bytesToKey must return Key or undefined
 */ function $a85c028f110aa8ce$var$createHmacDrbg(hashLen, qByteLen, hmacFn) {
    if (typeof hashLen !== "number" || hashLen < 2) throw new Error("hashLen must be a number");
    if (typeof qByteLen !== "number" || qByteLen < 2) throw new Error("qByteLen must be a number");
    if (typeof hmacFn !== "function") throw new Error("hmacFn must be a function");
    // Step B, Step C: set hashLen to 8*ceil(hlen/8)
    let v = $a85c028f110aa8ce$var$u8n(hashLen); // Minimal non-full-spec HMAC-DRBG from NIST 800-90 for RFC6979 sigs.
    let k = $a85c028f110aa8ce$var$u8n(hashLen); // Steps B and C of RFC6979 3.2: set hashLen, in our case always same
    let i = 0; // Iterations counter, will throw when over 1000
    const reset = ()=>{
        v.fill(1);
        k.fill(0);
        i = 0;
    };
    const h = (...b)=>hmacFn(k, v, ...b); // hmac(k)(v, ...values)
    const reseed = (seed = $a85c028f110aa8ce$var$u8n())=>{
        // HMAC-DRBG reseed() function. Steps D-G
        k = h($a85c028f110aa8ce$var$u8fr([
            0x00
        ]), seed); // k = hmac(k || v || 0x00 || seed)
        v = h(); // v = hmac(k || v)
        if (seed.length === 0) return;
        k = h($a85c028f110aa8ce$var$u8fr([
            0x01
        ]), seed); // k = hmac(k || v || 0x01 || seed)
        v = h(); // v = hmac(k || v)
    };
    const gen = ()=>{
        // HMAC-DRBG generate() function
        if (i++ >= 1000) throw new Error("drbg: tried 1000 values");
        let len = 0;
        const out = [];
        while(len < qByteLen){
            v = h();
            const sl = v.slice();
            out.push(sl);
            len += v.length;
        }
        return $a85c028f110aa8ce$var$concatBytes(...out);
    };
    const genUntil = (seed, pred)=>{
        reset();
        reseed(seed); // Steps D-G
        let res = undefined; // Step H: grind until k is in [1..n-1]
        while(!(res = pred(gen())))reseed();
        reset();
        return res;
    };
    return genUntil;
}
module.exports.createHmacDrbg = $a85c028f110aa8ce$var$createHmacDrbg;
// Validating curves and fields
const $a85c028f110aa8ce$var$validatorFns = {
    bigint: (val)=>typeof val === "bigint",
    function: (val)=>typeof val === "function",
    boolean: (val)=>typeof val === "boolean",
    string: (val)=>typeof val === "string",
    stringOrUint8Array: (val)=>typeof val === "string" || val instanceof Uint8Array,
    isSafeInteger: (val)=>Number.isSafeInteger(val),
    array: (val)=>Array.isArray(val),
    field: (val, object)=>object.Fp.isValid(val),
    hash: (val)=>typeof val === "function" && Number.isSafeInteger(val.outputLen)
};
// type Record<K extends string | number | symbol, T> = { [P in K]: T; }
function $a85c028f110aa8ce$var$validateObject(object, validators, optValidators = {}) {
    const checkField = (fieldName, type, isOptional)=>{
        const checkVal = $a85c028f110aa8ce$var$validatorFns[type];
        if (typeof checkVal !== "function") throw new Error(`Invalid validator "${type}", expected function`);
        const val = object[fieldName];
        if (isOptional && val === undefined) return;
        if (!checkVal(val, object)) throw new Error(`Invalid param ${String(fieldName)}=${val} (${typeof val}), expected ${type}`);
    };
    for (const [fieldName, type] of Object.entries(validators))checkField(fieldName, type, false);
    for (const [fieldName, type] of Object.entries(optValidators))checkField(fieldName, type, true);
    return object;
}
module.exports.validateObject = $a85c028f110aa8ce$var$validateObject; // validate type tests
 // const o: { a: number; b: number; c: number } = { a: 1, b: 5, c: 6 };
 // const z0 = validateObject(o, { a: 'isSafeInteger' }, { c: 'bigint' }); // Ok!
 // // Should fail type-check
 // const z1 = validateObject(o, { a: 'tmp' }, { c: 'zz' });
 // const z2 = validateObject(o, { a: 'isSafeInteger' }, { c: 'zz' });
 // const z3 = validateObject(o, { test: 'boolean', z: 'bug' });
 // const z4 = validateObject(o, { a: 'boolean', z: 'bug' });

});


parcelRegister("lkFCe", function(module, exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.validateBasic = exports.wNAF = void 0;

var $2D9sF = parcelRequire("2D9sF");

var $esaJO = parcelRequire("esaJO");
const _0n = BigInt(0);
const _1n = BigInt(1);
// Elliptic curve multiplication of Point by scalar. Fragile.
// Scalars should always be less than curve order: this should be checked inside of a curve itself.
// Creates precomputation tables for fast multiplication:
// - private scalar is split by fixed size windows of W bits
// - every window point is collected from window's table & added to accumulator
// - since windows are different, same point inside tables won't be accessed more than once per calc
// - each multiplication is 'Math.ceil(CURVE_ORDER / 𝑊) + 1' point additions (fixed for any scalar)
// - +1 window is neccessary for wNAF
// - wNAF reduces table size: 2x less memory + 2x faster generation, but 10% slower multiplication
// TODO: Research returning 2d JS array of windows, instead of a single window. This would allow
// windows to be in different memory locations
function wNAF(c, bits) {
    const constTimeNegate = (condition, item)=>{
        const neg = item.negate();
        return condition ? neg : item;
    };
    const opts = (W)=>{
        const windows = Math.ceil(bits / W) + 1; // +1, because
        const windowSize = 2 ** (W - 1); // -1 because we skip zero
        return {
            windows: windows,
            windowSize: windowSize
        };
    };
    return {
        constTimeNegate: constTimeNegate,
        // non-const time multiplication ladder
        unsafeLadder (elm, n) {
            let p = c.ZERO;
            let d = elm;
            while(n > _0n){
                if (n & _1n) p = p.add(d);
                d = d.double();
                n >>= _1n;
            }
            return p;
        },
        /**
         * Creates a wNAF precomputation window. Used for caching.
         * Default window size is set by `utils.precompute()` and is equal to 8.
         * Number of precomputed points depends on the curve size:
         * 2^(𝑊−1) * (Math.ceil(𝑛 / 𝑊) + 1), where:
         * - 𝑊 is the window size
         * - 𝑛 is the bitlength of the curve order.
         * For a 256-bit curve and window size 8, the number of precomputed points is 128 * 33 = 4224.
         * @returns precomputed point tables flattened to a single array
         */ precomputeWindow (elm, W) {
            const { windows, windowSize } = opts(W);
            const points = [];
            let p = elm;
            let base = p;
            for(let window = 0; window < windows; window++){
                base = p;
                points.push(base);
                // =1, because we skip zero
                for(let i = 1; i < windowSize; i++){
                    base = base.add(p);
                    points.push(base);
                }
                p = base.double();
            }
            return points;
        },
        /**
         * Implements ec multiplication using precomputed tables and w-ary non-adjacent form.
         * @param W window size
         * @param precomputes precomputed tables
         * @param n scalar (we don't check here, but should be less than curve order)
         * @returns real and fake (for const-time) points
         */ wNAF (W, precomputes, n) {
            // TODO: maybe check that scalar is less than group order? wNAF behavious is undefined otherwise
            // But need to carefully remove other checks before wNAF. ORDER == bits here
            const { windows, windowSize } = opts(W);
            let p = c.ZERO;
            let f = c.BASE;
            const mask = BigInt(2 ** W - 1); // Create mask with W ones: 0b1111 for W=4 etc.
            const maxNumber = 2 ** W;
            const shiftBy = BigInt(W);
            for(let window = 0; window < windows; window++){
                const offset = window * windowSize;
                // Extract W bits.
                let wbits = Number(n & mask);
                // Shift number by W bits.
                n >>= shiftBy;
                // If the bits are bigger than max size, we'll split those.
                // +224 => 256 - 32
                if (wbits > windowSize) {
                    wbits -= maxNumber;
                    n += _1n;
                }
                // This code was first written with assumption that 'f' and 'p' will never be infinity point:
                // since each addition is multiplied by 2 ** W, it cannot cancel each other. However,
                // there is negate now: it is possible that negated element from low value
                // would be the same as high element, which will create carry into next window.
                // It's not obvious how this can fail, but still worth investigating later.
                // Check if we're onto Zero point.
                // Add random point inside current window to f.
                const offset1 = offset;
                const offset2 = offset + Math.abs(wbits) - 1; // -1 because we skip zero
                const cond1 = window % 2 !== 0;
                const cond2 = wbits < 0;
                if (wbits === 0) // The most important part for const-time getPublicKey
                f = f.add(constTimeNegate(cond1, precomputes[offset1]));
                else p = p.add(constTimeNegate(cond2, precomputes[offset2]));
            }
            // JIT-compiler should not eliminate f here, since it will later be used in normalizeZ()
            // Even if the variable is still unused, there are some checks which will
            // throw an exception, so compiler needs to prove they won't happen, which is hard.
            // At this point there is a way to F be infinity-point even if p is not,
            // which makes it less const-time: around 1 bigint multiply.
            return {
                p: p,
                f: f
            };
        },
        wNAFCached (P, precomputesMap, n, transform) {
            // @ts-ignore
            const W = P._WINDOW_SIZE || 1;
            // Calculate precomputes on a first run, reuse them after
            let comp = precomputesMap.get(P);
            if (!comp) {
                comp = this.precomputeWindow(P, W);
                if (W !== 1) precomputesMap.set(P, transform(comp));
            }
            return this.wNAF(W, comp, n);
        }
    };
}
exports.wNAF = wNAF;
function validateBasic(curve) {
    (0, $2D9sF.validateField)(curve.Fp);
    (0, $esaJO.validateObject)(curve, {
        n: "bigint",
        h: "bigint",
        Gx: "field",
        Gy: "field"
    }, {
        nBitLength: "isSafeInteger",
        nByteLength: "isSafeInteger"
    });
    // Set defaults
    return Object.freeze({
        ...(0, $2D9sF.nLength)(curve.n, curve.nBitLength),
        ...curve,
        p: curve.Fp.ORDER
    });
}
exports.validateBasic = validateBasic;

});


parcelRegister("kiLeO", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.montgomery = void 0;

var $2D9sF = parcelRequire("2D9sF");

var $esaJO = parcelRequire("esaJO");
const $ec7a218c4f0875a8$var$_0n = BigInt(0);
const $ec7a218c4f0875a8$var$_1n = BigInt(1);
function $ec7a218c4f0875a8$var$validateOpts(curve) {
    (0, $esaJO.validateObject)(curve, {
        a: "bigint"
    }, {
        montgomeryBits: "isSafeInteger",
        nByteLength: "isSafeInteger",
        adjustScalarBytes: "function",
        domain: "function",
        powPminus2: "function",
        Gu: "bigint"
    });
    // Set defaults
    return Object.freeze({
        ...curve
    });
}
// NOTE: not really montgomery curve, just bunch of very specific methods for X25519/X448 (RFC 7748, https://www.rfc-editor.org/rfc/rfc7748)
// Uses only one coordinate instead of two
function $ec7a218c4f0875a8$var$montgomery(curveDef) {
    const CURVE = $ec7a218c4f0875a8$var$validateOpts(curveDef);
    const { P: P } = CURVE;
    const modP = (n)=>(0, $2D9sF.mod)(n, P);
    const montgomeryBits = CURVE.montgomeryBits;
    const montgomeryBytes = Math.ceil(montgomeryBits / 8);
    const fieldLen = CURVE.nByteLength;
    const adjustScalarBytes = CURVE.adjustScalarBytes || ((bytes)=>bytes);
    const powPminus2 = CURVE.powPminus2 || ((x)=>(0, $2D9sF.pow)(x, P - BigInt(2), P));
    // cswap from RFC7748. But it is not from RFC7748!
    /*
      cswap(swap, x_2, x_3):
           dummy = mask(swap) AND (x_2 XOR x_3)
           x_2 = x_2 XOR dummy
           x_3 = x_3 XOR dummy
           Return (x_2, x_3)
    Where mask(swap) is the all-1 or all-0 word of the same length as x_2
     and x_3, computed, e.g., as mask(swap) = 0 - swap.
    */ function cswap(swap, x_2, x_3) {
        const dummy = modP(swap * (x_2 - x_3));
        x_2 = modP(x_2 - dummy);
        x_3 = modP(x_3 + dummy);
        return [
            x_2,
            x_3
        ];
    }
    // Accepts 0 as well
    function assertFieldElement(n) {
        if (typeof n === "bigint" && $ec7a218c4f0875a8$var$_0n <= n && n < P) return n;
        throw new Error("Expected valid scalar 0 < scalar < CURVE.P");
    }
    // x25519 from 4
    // The constant a24 is (486662 - 2) / 4 = 121665 for curve25519/X25519
    const a24 = (CURVE.a - BigInt(2)) / BigInt(4);
    /**
     *
     * @param pointU u coordinate (x) on Montgomery Curve 25519
     * @param scalar by which the point would be multiplied
     * @returns new Point on Montgomery curve
     */ function montgomeryLadder(pointU, scalar) {
        const u = assertFieldElement(pointU);
        // Section 5: Implementations MUST accept non-canonical values and process them as
        // if they had been reduced modulo the field prime.
        const k = assertFieldElement(scalar);
        const x_1 = u;
        let x_2 = $ec7a218c4f0875a8$var$_1n;
        let z_2 = $ec7a218c4f0875a8$var$_0n;
        let x_3 = u;
        let z_3 = $ec7a218c4f0875a8$var$_1n;
        let swap = $ec7a218c4f0875a8$var$_0n;
        let sw;
        for(let t = BigInt(montgomeryBits - 1); t >= $ec7a218c4f0875a8$var$_0n; t--){
            const k_t = k >> t & $ec7a218c4f0875a8$var$_1n;
            swap ^= k_t;
            sw = cswap(swap, x_2, x_3);
            x_2 = sw[0];
            x_3 = sw[1];
            sw = cswap(swap, z_2, z_3);
            z_2 = sw[0];
            z_3 = sw[1];
            swap = k_t;
            const A = x_2 + z_2;
            const AA = modP(A * A);
            const B = x_2 - z_2;
            const BB = modP(B * B);
            const E = AA - BB;
            const C = x_3 + z_3;
            const D = x_3 - z_3;
            const DA = modP(D * A);
            const CB = modP(C * B);
            const dacb = DA + CB;
            const da_cb = DA - CB;
            x_3 = modP(dacb * dacb);
            z_3 = modP(x_1 * modP(da_cb * da_cb));
            x_2 = modP(AA * BB);
            z_2 = modP(E * (AA + modP(a24 * E)));
        }
        // (x_2, x_3) = cswap(swap, x_2, x_3)
        sw = cswap(swap, x_2, x_3);
        x_2 = sw[0];
        x_3 = sw[1];
        // (z_2, z_3) = cswap(swap, z_2, z_3)
        sw = cswap(swap, z_2, z_3);
        z_2 = sw[0];
        z_3 = sw[1];
        // z_2^(p - 2)
        const z2 = powPminus2(z_2);
        // Return x_2 * (z_2^(p - 2))
        return modP(x_2 * z2);
    }
    function encodeUCoordinate(u) {
        return (0, $esaJO.numberToBytesLE)(modP(u), montgomeryBytes);
    }
    function decodeUCoordinate(uEnc) {
        // Section 5: When receiving such an array, implementations of X25519
        // MUST mask the most significant bit in the final byte.
        // This is very ugly way, but it works because fieldLen-1 is outside of bounds for X448, so this becomes NOOP
        // fieldLen - scalaryBytes = 1 for X448 and = 0 for X25519
        const u = (0, $esaJO.ensureBytes)("u coordinate", uEnc, montgomeryBytes);
        // u[fieldLen-1] crashes QuickJS (TypeError: out-of-bound numeric index)
        if (fieldLen === montgomeryBytes) u[fieldLen - 1] &= 127; // 0b0111_1111
        return (0, $esaJO.bytesToNumberLE)(u);
    }
    function decodeScalar(n) {
        const bytes = (0, $esaJO.ensureBytes)("scalar", n);
        if (bytes.length !== montgomeryBytes && bytes.length !== fieldLen) throw new Error(`Expected ${montgomeryBytes} or ${fieldLen} bytes, got ${bytes.length}`);
        return (0, $esaJO.bytesToNumberLE)(adjustScalarBytes(bytes));
    }
    function scalarMult(scalar, u) {
        const pointU = decodeUCoordinate(u);
        const _scalar = decodeScalar(scalar);
        const pu = montgomeryLadder(pointU, _scalar);
        // The result was not contributory
        // https://cr.yp.to/ecdh.html#validate
        if (pu === $ec7a218c4f0875a8$var$_0n) throw new Error("Invalid private or public key received");
        return encodeUCoordinate(pu);
    }
    // Computes public key from private. By doing scalar multiplication of base point.
    const GuBytes = encodeUCoordinate(CURVE.Gu);
    function scalarMultBase(scalar) {
        return scalarMult(scalar, GuBytes);
    }
    return {
        scalarMult: scalarMult,
        scalarMultBase: scalarMultBase,
        getSharedSecret: (privateKey, publicKey)=>scalarMult(privateKey, publicKey),
        getPublicKey: (privateKey)=>scalarMultBase(privateKey),
        utils: {
            randomPrivateKey: ()=>CURVE.randomBytes(CURVE.nByteLength)
        },
        GuBytes: GuBytes
    };
}
module.exports.montgomery = $ec7a218c4f0875a8$var$montgomery;

});

parcelRegister("rkPJ6", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.createHasher = module.exports.isogenyMap = module.exports.hash_to_field = module.exports.expand_message_xof = module.exports.expand_message_xmd = void 0;

var $2D9sF = parcelRequire("2D9sF");

var $esaJO = parcelRequire("esaJO");
function $0522aeca5769187c$var$validateDST(dst) {
    if (dst instanceof Uint8Array) return dst;
    if (typeof dst === "string") return (0, $esaJO.utf8ToBytes)(dst);
    throw new Error("DST must be Uint8Array or string");
}
// Octet Stream to Integer. "spec" implementation of os2ip is 2.5x slower vs bytesToNumberBE.
const $0522aeca5769187c$var$os2ip = $esaJO.bytesToNumberBE;
// Integer to Octet Stream (numberToBytesBE)
function $0522aeca5769187c$var$i2osp(value, length) {
    if (value < 0 || value >= 1 << 8 * length) throw new Error(`bad I2OSP call: value=${value} length=${length}`);
    const res = Array.from({
        length: length
    }).fill(0);
    for(let i = length - 1; i >= 0; i--){
        res[i] = value & 0xff;
        value >>>= 8;
    }
    return new Uint8Array(res);
}
function $0522aeca5769187c$var$strxor(a, b) {
    const arr = new Uint8Array(a.length);
    for(let i = 0; i < a.length; i++)arr[i] = a[i] ^ b[i];
    return arr;
}
function $0522aeca5769187c$var$isBytes(item) {
    if (!(item instanceof Uint8Array)) throw new Error("Uint8Array expected");
}
function $0522aeca5769187c$var$isNum(item) {
    if (!Number.isSafeInteger(item)) throw new Error("number expected");
}
// Produces a uniformly random byte string using a cryptographic hash function H that outputs b bits
// https://www.rfc-editor.org/rfc/rfc9380#section-5.3.1
function $0522aeca5769187c$var$expand_message_xmd(msg, DST, lenInBytes, H) {
    $0522aeca5769187c$var$isBytes(msg);
    $0522aeca5769187c$var$isBytes(DST);
    $0522aeca5769187c$var$isNum(lenInBytes);
    // https://www.rfc-editor.org/rfc/rfc9380#section-5.3.3
    if (DST.length > 255) DST = H((0, $esaJO.concatBytes)((0, $esaJO.utf8ToBytes)("H2C-OVERSIZE-DST-"), DST));
    const { outputLen: b_in_bytes, blockLen: r_in_bytes } = H;
    const ell = Math.ceil(lenInBytes / b_in_bytes);
    if (ell > 255) throw new Error("Invalid xmd length");
    const DST_prime = (0, $esaJO.concatBytes)(DST, $0522aeca5769187c$var$i2osp(DST.length, 1));
    const Z_pad = $0522aeca5769187c$var$i2osp(0, r_in_bytes);
    const l_i_b_str = $0522aeca5769187c$var$i2osp(lenInBytes, 2); // len_in_bytes_str
    const b = new Array(ell);
    const b_0 = H((0, $esaJO.concatBytes)(Z_pad, msg, l_i_b_str, $0522aeca5769187c$var$i2osp(0, 1), DST_prime));
    b[0] = H((0, $esaJO.concatBytes)(b_0, $0522aeca5769187c$var$i2osp(1, 1), DST_prime));
    for(let i = 1; i <= ell; i++){
        const args = [
            $0522aeca5769187c$var$strxor(b_0, b[i - 1]),
            $0522aeca5769187c$var$i2osp(i + 1, 1),
            DST_prime
        ];
        b[i] = H((0, $esaJO.concatBytes)(...args));
    }
    const pseudo_random_bytes = (0, $esaJO.concatBytes)(...b);
    return pseudo_random_bytes.slice(0, lenInBytes);
}
module.exports.expand_message_xmd = $0522aeca5769187c$var$expand_message_xmd;
// Produces a uniformly random byte string using an extendable-output function (XOF) H.
// 1. The collision resistance of H MUST be at least k bits.
// 2. H MUST be an XOF that has been proved indifferentiable from
//    a random oracle under a reasonable cryptographic assumption.
// https://www.rfc-editor.org/rfc/rfc9380#section-5.3.2
function $0522aeca5769187c$var$expand_message_xof(msg, DST, lenInBytes, k, H) {
    $0522aeca5769187c$var$isBytes(msg);
    $0522aeca5769187c$var$isBytes(DST);
    $0522aeca5769187c$var$isNum(lenInBytes);
    // https://www.rfc-editor.org/rfc/rfc9380#section-5.3.3
    // DST = H('H2C-OVERSIZE-DST-' || a_very_long_DST, Math.ceil((lenInBytes * k) / 8));
    if (DST.length > 255) {
        const dkLen = Math.ceil(2 * k / 8);
        DST = H.create({
            dkLen: dkLen
        }).update((0, $esaJO.utf8ToBytes)("H2C-OVERSIZE-DST-")).update(DST).digest();
    }
    if (lenInBytes > 65535 || DST.length > 255) throw new Error("expand_message_xof: invalid lenInBytes");
    return H.create({
        dkLen: lenInBytes
    }).update(msg).update($0522aeca5769187c$var$i2osp(lenInBytes, 2))// 2. DST_prime = DST || I2OSP(len(DST), 1)
    .update(DST).update($0522aeca5769187c$var$i2osp(DST.length, 1)).digest();
}
module.exports.expand_message_xof = $0522aeca5769187c$var$expand_message_xof;
/**
 * Hashes arbitrary-length byte strings to a list of one or more elements of a finite field F
 * https://www.rfc-editor.org/rfc/rfc9380#section-5.2
 * @param msg a byte string containing the message to hash
 * @param count the number of elements of F to output
 * @param options `{DST: string, p: bigint, m: number, k: number, expand: 'xmd' | 'xof', hash: H}`, see above
 * @returns [u_0, ..., u_(count - 1)], a list of field elements.
 */ function $0522aeca5769187c$var$hash_to_field(msg, count, options) {
    (0, $esaJO.validateObject)(options, {
        DST: "stringOrUint8Array",
        p: "bigint",
        m: "isSafeInteger",
        k: "isSafeInteger",
        hash: "hash"
    });
    const { p: p, k: k, m: m, hash: hash, expand: expand, DST: _DST } = options;
    $0522aeca5769187c$var$isBytes(msg);
    $0522aeca5769187c$var$isNum(count);
    const DST = $0522aeca5769187c$var$validateDST(_DST);
    const log2p = p.toString(2).length;
    const L = Math.ceil((log2p + k) / 8); // section 5.1 of ietf draft link above
    const len_in_bytes = count * m * L;
    let prb; // pseudo_random_bytes
    if (expand === "xmd") prb = $0522aeca5769187c$var$expand_message_xmd(msg, DST, len_in_bytes, hash);
    else if (expand === "xof") prb = $0522aeca5769187c$var$expand_message_xof(msg, DST, len_in_bytes, k, hash);
    else if (expand === "_internal_pass") // for internal tests only
    prb = msg;
    else throw new Error('expand must be "xmd" or "xof"');
    const u = new Array(count);
    for(let i = 0; i < count; i++){
        const e = new Array(m);
        for(let j = 0; j < m; j++){
            const elm_offset = L * (j + i * m);
            const tv = prb.subarray(elm_offset, elm_offset + L);
            e[j] = (0, $2D9sF.mod)($0522aeca5769187c$var$os2ip(tv), p);
        }
        u[i] = e;
    }
    return u;
}
module.exports.hash_to_field = $0522aeca5769187c$var$hash_to_field;
function $0522aeca5769187c$var$isogenyMap(field, map) {
    // Make same order as in spec
    const COEFF = map.map((i)=>Array.from(i).reverse());
    return (x, y)=>{
        const [xNum, xDen, yNum, yDen] = COEFF.map((val)=>val.reduce((acc, i)=>field.add(field.mul(acc, x), i)));
        x = field.div(xNum, xDen); // xNum / xDen
        y = field.mul(y, field.div(yNum, yDen)); // y * (yNum / yDev)
        return {
            x: x,
            y: y
        };
    };
}
module.exports.isogenyMap = $0522aeca5769187c$var$isogenyMap;
function $0522aeca5769187c$var$createHasher(Point, mapToCurve, def) {
    if (typeof mapToCurve !== "function") throw new Error("mapToCurve() must be defined");
    return {
        // Encodes byte string to elliptic curve.
        // hash_to_curve from https://www.rfc-editor.org/rfc/rfc9380#section-3
        hashToCurve (msg, options) {
            const u = $0522aeca5769187c$var$hash_to_field(msg, 2, {
                ...def,
                DST: def.DST,
                ...options
            });
            const u0 = Point.fromAffine(mapToCurve(u[0]));
            const u1 = Point.fromAffine(mapToCurve(u[1]));
            const P = u0.add(u1).clearCofactor();
            P.assertValidity();
            return P;
        },
        // Encodes byte string to elliptic curve.
        // encode_to_curve from https://www.rfc-editor.org/rfc/rfc9380#section-3
        encodeToCurve (msg, options) {
            const u = $0522aeca5769187c$var$hash_to_field(msg, 1, {
                ...def,
                DST: def.encodeDST,
                ...options
            });
            const P = Point.fromAffine(mapToCurve(u[0])).clearCofactor();
            P.assertValidity();
            return P;
        }
    };
}
module.exports.createHasher = $0522aeca5769187c$var$createHasher;

});


parcelRegister("dEXSZ", function(module, exports) {

(function(module1, exports) {
    "use strict";
    // Utils
    function assert(val, msg) {
        if (!val) throw new Error(msg || "Assertion failed");
    }
    // Could use `inherits` module, but don't want to move from single file
    // architecture yet.
    function inherits(ctor, superCtor) {
        ctor.super_ = superCtor;
        var TempCtor = function() {};
        TempCtor.prototype = superCtor.prototype;
        ctor.prototype = new TempCtor();
        ctor.prototype.constructor = ctor;
    }
    // BN
    function BN(number, base, endian) {
        if (BN.isBN(number)) return number;
        this.negative = 0;
        this.words = null;
        this.length = 0;
        // Reduction context
        this.red = null;
        if (number !== null) {
            if (base === "le" || base === "be") {
                endian = base;
                base = 10;
            }
            this._init(number || 0, base || 10, endian || "be");
        }
    }
    if (typeof module1 === "object") module1.exports = BN;
    else exports.BN = BN;
    BN.BN = BN;
    BN.wordSize = 26;
    var Buffer;
    try {
        if (typeof window !== "undefined" && typeof window.Buffer !== "undefined") Buffer = window.Buffer;
        else Buffer = (parcelRequire("kjyEk")).Buffer;
    } catch (e) {}
    BN.isBN = function isBN(num) {
        if (num instanceof BN) return true;
        return num !== null && typeof num === "object" && num.constructor.wordSize === BN.wordSize && Array.isArray(num.words);
    };
    BN.max = function max(left, right) {
        if (left.cmp(right) > 0) return left;
        return right;
    };
    BN.min = function min(left, right) {
        if (left.cmp(right) < 0) return left;
        return right;
    };
    BN.prototype._init = function init(number, base, endian) {
        if (typeof number === "number") return this._initNumber(number, base, endian);
        if (typeof number === "object") return this._initArray(number, base, endian);
        if (base === "hex") base = 16;
        assert(base === (base | 0) && base >= 2 && base <= 36);
        number = number.toString().replace(/\s+/g, "");
        var start = 0;
        if (number[0] === "-") {
            start++;
            this.negative = 1;
        }
        if (start < number.length) {
            if (base === 16) this._parseHex(number, start, endian);
            else {
                this._parseBase(number, base, start);
                if (endian === "le") this._initArray(this.toArray(), base, endian);
            }
        }
    };
    BN.prototype._initNumber = function _initNumber(number, base, endian) {
        if (number < 0) {
            this.negative = 1;
            number = -number;
        }
        if (number < 0x4000000) {
            this.words = [
                number & 0x3ffffff
            ];
            this.length = 1;
        } else if (number < 0x10000000000000) {
            this.words = [
                number & 0x3ffffff,
                number / 0x4000000 & 0x3ffffff
            ];
            this.length = 2;
        } else {
            assert(number < 0x20000000000000); // 2 ^ 53 (unsafe)
            this.words = [
                number & 0x3ffffff,
                number / 0x4000000 & 0x3ffffff,
                1
            ];
            this.length = 3;
        }
        if (endian !== "le") return;
        // Reverse the bytes
        this._initArray(this.toArray(), base, endian);
    };
    BN.prototype._initArray = function _initArray(number, base, endian) {
        // Perhaps a Uint8Array
        assert(typeof number.length === "number");
        if (number.length <= 0) {
            this.words = [
                0
            ];
            this.length = 1;
            return this;
        }
        this.length = Math.ceil(number.length / 3);
        this.words = new Array(this.length);
        for(var i = 0; i < this.length; i++)this.words[i] = 0;
        var j, w;
        var off = 0;
        if (endian === "be") for(i = number.length - 1, j = 0; i >= 0; i -= 3){
            w = number[i] | number[i - 1] << 8 | number[i - 2] << 16;
            this.words[j] |= w << off & 0x3ffffff;
            this.words[j + 1] = w >>> 26 - off & 0x3ffffff;
            off += 24;
            if (off >= 26) {
                off -= 26;
                j++;
            }
        }
        else if (endian === "le") for(i = 0, j = 0; i < number.length; i += 3){
            w = number[i] | number[i + 1] << 8 | number[i + 2] << 16;
            this.words[j] |= w << off & 0x3ffffff;
            this.words[j + 1] = w >>> 26 - off & 0x3ffffff;
            off += 24;
            if (off >= 26) {
                off -= 26;
                j++;
            }
        }
        return this._strip();
    };
    function parseHex4Bits(string, index) {
        var c = string.charCodeAt(index);
        // '0' - '9'
        if (c >= 48 && c <= 57) return c - 48;
        else if (c >= 65 && c <= 70) return c - 55;
        else if (c >= 97 && c <= 102) return c - 87;
        else assert(false, "Invalid character in " + string);
    }
    function parseHexByte(string, lowerBound, index) {
        var r = parseHex4Bits(string, index);
        if (index - 1 >= lowerBound) r |= parseHex4Bits(string, index - 1) << 4;
        return r;
    }
    BN.prototype._parseHex = function _parseHex(number, start, endian) {
        // Create possibly bigger array to ensure that it fits the number
        this.length = Math.ceil((number.length - start) / 6);
        this.words = new Array(this.length);
        for(var i = 0; i < this.length; i++)this.words[i] = 0;
        // 24-bits chunks
        var off = 0;
        var j = 0;
        var w;
        if (endian === "be") for(i = number.length - 1; i >= start; i -= 2){
            w = parseHexByte(number, start, i) << off;
            this.words[j] |= w & 0x3ffffff;
            if (off >= 18) {
                off -= 18;
                j += 1;
                this.words[j] |= w >>> 26;
            } else off += 8;
        }
        else {
            var parseLength = number.length - start;
            for(i = parseLength % 2 === 0 ? start + 1 : start; i < number.length; i += 2){
                w = parseHexByte(number, start, i) << off;
                this.words[j] |= w & 0x3ffffff;
                if (off >= 18) {
                    off -= 18;
                    j += 1;
                    this.words[j] |= w >>> 26;
                } else off += 8;
            }
        }
        this._strip();
    };
    function parseBase(str, start, end, mul) {
        var r = 0;
        var b = 0;
        var len = Math.min(str.length, end);
        for(var i = start; i < len; i++){
            var c = str.charCodeAt(i) - 48;
            r *= mul;
            // 'a'
            if (c >= 49) b = c - 49 + 0xa;
            else if (c >= 17) b = c - 17 + 0xa;
            else b = c;
            assert(c >= 0 && b < mul, "Invalid character");
            r += b;
        }
        return r;
    }
    BN.prototype._parseBase = function _parseBase(number, base, start) {
        // Initialize as zero
        this.words = [
            0
        ];
        this.length = 1;
        // Find length of limb in base
        for(var limbLen = 0, limbPow = 1; limbPow <= 0x3ffffff; limbPow *= base)limbLen++;
        limbLen--;
        limbPow = limbPow / base | 0;
        var total = number.length - start;
        var mod = total % limbLen;
        var end = Math.min(total, total - mod) + start;
        var word = 0;
        for(var i = start; i < end; i += limbLen){
            word = parseBase(number, i, i + limbLen, base);
            this.imuln(limbPow);
            if (this.words[0] + word < 0x4000000) this.words[0] += word;
            else this._iaddn(word);
        }
        if (mod !== 0) {
            var pow = 1;
            word = parseBase(number, i, number.length, base);
            for(i = 0; i < mod; i++)pow *= base;
            this.imuln(pow);
            if (this.words[0] + word < 0x4000000) this.words[0] += word;
            else this._iaddn(word);
        }
        this._strip();
    };
    BN.prototype.copy = function copy(dest) {
        dest.words = new Array(this.length);
        for(var i = 0; i < this.length; i++)dest.words[i] = this.words[i];
        dest.length = this.length;
        dest.negative = this.negative;
        dest.red = this.red;
    };
    function move(dest, src) {
        dest.words = src.words;
        dest.length = src.length;
        dest.negative = src.negative;
        dest.red = src.red;
    }
    BN.prototype._move = function _move(dest) {
        move(dest, this);
    };
    BN.prototype.clone = function clone() {
        var r = new BN(null);
        this.copy(r);
        return r;
    };
    BN.prototype._expand = function _expand(size) {
        while(this.length < size)this.words[this.length++] = 0;
        return this;
    };
    // Remove leading `0` from `this`
    BN.prototype._strip = function strip() {
        while(this.length > 1 && this.words[this.length - 1] === 0)this.length--;
        return this._normSign();
    };
    BN.prototype._normSign = function _normSign() {
        // -0 = 0
        if (this.length === 1 && this.words[0] === 0) this.negative = 0;
        return this;
    };
    // Check Symbol.for because not everywhere where Symbol defined
    // See https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Symbol#Browser_compatibility
    if (typeof Symbol !== "undefined" && typeof Symbol.for === "function") try {
        BN.prototype[Symbol.for("nodejs.util.inspect.custom")] = inspect;
    } catch (e) {
        BN.prototype.inspect = inspect;
    }
    else BN.prototype.inspect = inspect;
    function inspect() {
        return (this.red ? "<BN-R: " : "<BN: ") + this.toString(16) + ">";
    }
    /*

  var zeros = [];
  var groupSizes = [];
  var groupBases = [];

  var s = '';
  var i = -1;
  while (++i < BN.wordSize) {
    zeros[i] = s;
    s += '0';
  }
  groupSizes[0] = 0;
  groupSizes[1] = 0;
  groupBases[0] = 0;
  groupBases[1] = 0;
  var base = 2 - 1;
  while (++base < 36 + 1) {
    var groupSize = 0;
    var groupBase = 1;
    while (groupBase < (1 << BN.wordSize) / base) {
      groupBase *= base;
      groupSize += 1;
    }
    groupSizes[base] = groupSize;
    groupBases[base] = groupBase;
  }

  */ var zeros = [
        "",
        "0",
        "00",
        "000",
        "0000",
        "00000",
        "000000",
        "0000000",
        "00000000",
        "000000000",
        "0000000000",
        "00000000000",
        "000000000000",
        "0000000000000",
        "00000000000000",
        "000000000000000",
        "0000000000000000",
        "00000000000000000",
        "000000000000000000",
        "0000000000000000000",
        "00000000000000000000",
        "000000000000000000000",
        "0000000000000000000000",
        "00000000000000000000000",
        "000000000000000000000000",
        "0000000000000000000000000"
    ];
    var groupSizes = [
        0,
        0,
        25,
        16,
        12,
        11,
        10,
        9,
        8,
        8,
        7,
        7,
        7,
        7,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5
    ];
    var groupBases = [
        0,
        0,
        33554432,
        43046721,
        16777216,
        48828125,
        60466176,
        40353607,
        16777216,
        43046721,
        10000000,
        19487171,
        35831808,
        62748517,
        7529536,
        11390625,
        16777216,
        24137569,
        34012224,
        47045881,
        64000000,
        4084101,
        5153632,
        6436343,
        7962624,
        9765625,
        11881376,
        14348907,
        17210368,
        20511149,
        24300000,
        28629151,
        33554432,
        39135393,
        45435424,
        52521875,
        60466176
    ];
    BN.prototype.toString = function toString(base, padding) {
        base = base || 10;
        padding = padding | 0 || 1;
        var out;
        if (base === 16 || base === "hex") {
            out = "";
            var off = 0;
            var carry = 0;
            for(var i = 0; i < this.length; i++){
                var w = this.words[i];
                var word = ((w << off | carry) & 0xffffff).toString(16);
                carry = w >>> 24 - off & 0xffffff;
                off += 2;
                if (off >= 26) {
                    off -= 26;
                    i--;
                }
                if (carry !== 0 || i !== this.length - 1) out = zeros[6 - word.length] + word + out;
                else out = word + out;
            }
            if (carry !== 0) out = carry.toString(16) + out;
            while(out.length % padding !== 0)out = "0" + out;
            if (this.negative !== 0) out = "-" + out;
            return out;
        }
        if (base === (base | 0) && base >= 2 && base <= 36) {
            // var groupSize = Math.floor(BN.wordSize * Math.LN2 / Math.log(base));
            var groupSize = groupSizes[base];
            // var groupBase = Math.pow(base, groupSize);
            var groupBase = groupBases[base];
            out = "";
            var c = this.clone();
            c.negative = 0;
            while(!c.isZero()){
                var r = c.modrn(groupBase).toString(base);
                c = c.idivn(groupBase);
                if (!c.isZero()) out = zeros[groupSize - r.length] + r + out;
                else out = r + out;
            }
            if (this.isZero()) out = "0" + out;
            while(out.length % padding !== 0)out = "0" + out;
            if (this.negative !== 0) out = "-" + out;
            return out;
        }
        assert(false, "Base should be between 2 and 36");
    };
    BN.prototype.toNumber = function toNumber() {
        var ret = this.words[0];
        if (this.length === 2) ret += this.words[1] * 0x4000000;
        else if (this.length === 3 && this.words[2] === 0x01) // NOTE: at this stage it is known that the top bit is set
        ret += 0x10000000000000 + this.words[1] * 0x4000000;
        else if (this.length > 2) assert(false, "Number can only safely store up to 53 bits");
        return this.negative !== 0 ? -ret : ret;
    };
    BN.prototype.toJSON = function toJSON() {
        return this.toString(16, 2);
    };
    if (Buffer) BN.prototype.toBuffer = function toBuffer(endian, length) {
        return this.toArrayLike(Buffer, endian, length);
    };
    BN.prototype.toArray = function toArray(endian, length) {
        return this.toArrayLike(Array, endian, length);
    };
    var allocate = function allocate(ArrayType, size) {
        if (ArrayType.allocUnsafe) return ArrayType.allocUnsafe(size);
        return new ArrayType(size);
    };
    BN.prototype.toArrayLike = function toArrayLike(ArrayType, endian, length) {
        this._strip();
        var byteLength = this.byteLength();
        var reqLength = length || Math.max(1, byteLength);
        assert(byteLength <= reqLength, "byte array longer than desired length");
        assert(reqLength > 0, "Requested array length <= 0");
        var res = allocate(ArrayType, reqLength);
        var postfix = endian === "le" ? "LE" : "BE";
        this["_toArrayLike" + postfix](res, byteLength);
        return res;
    };
    BN.prototype._toArrayLikeLE = function _toArrayLikeLE(res, byteLength) {
        var position = 0;
        var carry = 0;
        for(var i = 0, shift = 0; i < this.length; i++){
            var word = this.words[i] << shift | carry;
            res[position++] = word & 0xff;
            if (position < res.length) res[position++] = word >> 8 & 0xff;
            if (position < res.length) res[position++] = word >> 16 & 0xff;
            if (shift === 6) {
                if (position < res.length) res[position++] = word >> 24 & 0xff;
                carry = 0;
                shift = 0;
            } else {
                carry = word >>> 24;
                shift += 2;
            }
        }
        if (position < res.length) {
            res[position++] = carry;
            while(position < res.length)res[position++] = 0;
        }
    };
    BN.prototype._toArrayLikeBE = function _toArrayLikeBE(res, byteLength) {
        var position = res.length - 1;
        var carry = 0;
        for(var i = 0, shift = 0; i < this.length; i++){
            var word = this.words[i] << shift | carry;
            res[position--] = word & 0xff;
            if (position >= 0) res[position--] = word >> 8 & 0xff;
            if (position >= 0) res[position--] = word >> 16 & 0xff;
            if (shift === 6) {
                if (position >= 0) res[position--] = word >> 24 & 0xff;
                carry = 0;
                shift = 0;
            } else {
                carry = word >>> 24;
                shift += 2;
            }
        }
        if (position >= 0) {
            res[position--] = carry;
            while(position >= 0)res[position--] = 0;
        }
    };
    if (Math.clz32) BN.prototype._countBits = function _countBits(w) {
        return 32 - Math.clz32(w);
    };
    else BN.prototype._countBits = function _countBits(w) {
        var t = w;
        var r = 0;
        if (t >= 0x1000) {
            r += 13;
            t >>>= 13;
        }
        if (t >= 0x40) {
            r += 7;
            t >>>= 7;
        }
        if (t >= 0x8) {
            r += 4;
            t >>>= 4;
        }
        if (t >= 0x02) {
            r += 2;
            t >>>= 2;
        }
        return r + t;
    };
    BN.prototype._zeroBits = function _zeroBits(w) {
        // Short-cut
        if (w === 0) return 26;
        var t = w;
        var r = 0;
        if ((t & 0x1fff) === 0) {
            r += 13;
            t >>>= 13;
        }
        if ((t & 0x7f) === 0) {
            r += 7;
            t >>>= 7;
        }
        if ((t & 0xf) === 0) {
            r += 4;
            t >>>= 4;
        }
        if ((t & 0x3) === 0) {
            r += 2;
            t >>>= 2;
        }
        if ((t & 0x1) === 0) r++;
        return r;
    };
    // Return number of used bits in a BN
    BN.prototype.bitLength = function bitLength() {
        var w = this.words[this.length - 1];
        var hi = this._countBits(w);
        return (this.length - 1) * 26 + hi;
    };
    function toBitArray(num) {
        var w = new Array(num.bitLength());
        for(var bit = 0; bit < w.length; bit++){
            var off = bit / 26 | 0;
            var wbit = bit % 26;
            w[bit] = num.words[off] >>> wbit & 0x01;
        }
        return w;
    }
    // Number of trailing zero bits
    BN.prototype.zeroBits = function zeroBits() {
        if (this.isZero()) return 0;
        var r = 0;
        for(var i = 0; i < this.length; i++){
            var b = this._zeroBits(this.words[i]);
            r += b;
            if (b !== 26) break;
        }
        return r;
    };
    BN.prototype.byteLength = function byteLength() {
        return Math.ceil(this.bitLength() / 8);
    };
    BN.prototype.toTwos = function toTwos(width) {
        if (this.negative !== 0) return this.abs().inotn(width).iaddn(1);
        return this.clone();
    };
    BN.prototype.fromTwos = function fromTwos(width) {
        if (this.testn(width - 1)) return this.notn(width).iaddn(1).ineg();
        return this.clone();
    };
    BN.prototype.isNeg = function isNeg() {
        return this.negative !== 0;
    };
    // Return negative clone of `this`
    BN.prototype.neg = function neg() {
        return this.clone().ineg();
    };
    BN.prototype.ineg = function ineg() {
        if (!this.isZero()) this.negative ^= 1;
        return this;
    };
    // Or `num` with `this` in-place
    BN.prototype.iuor = function iuor(num) {
        while(this.length < num.length)this.words[this.length++] = 0;
        for(var i = 0; i < num.length; i++)this.words[i] = this.words[i] | num.words[i];
        return this._strip();
    };
    BN.prototype.ior = function ior(num) {
        assert((this.negative | num.negative) === 0);
        return this.iuor(num);
    };
    // Or `num` with `this`
    BN.prototype.or = function or(num) {
        if (this.length > num.length) return this.clone().ior(num);
        return num.clone().ior(this);
    };
    BN.prototype.uor = function uor(num) {
        if (this.length > num.length) return this.clone().iuor(num);
        return num.clone().iuor(this);
    };
    // And `num` with `this` in-place
    BN.prototype.iuand = function iuand(num) {
        // b = min-length(num, this)
        var b;
        if (this.length > num.length) b = num;
        else b = this;
        for(var i = 0; i < b.length; i++)this.words[i] = this.words[i] & num.words[i];
        this.length = b.length;
        return this._strip();
    };
    BN.prototype.iand = function iand(num) {
        assert((this.negative | num.negative) === 0);
        return this.iuand(num);
    };
    // And `num` with `this`
    BN.prototype.and = function and(num) {
        if (this.length > num.length) return this.clone().iand(num);
        return num.clone().iand(this);
    };
    BN.prototype.uand = function uand(num) {
        if (this.length > num.length) return this.clone().iuand(num);
        return num.clone().iuand(this);
    };
    // Xor `num` with `this` in-place
    BN.prototype.iuxor = function iuxor(num) {
        // a.length > b.length
        var a;
        var b;
        if (this.length > num.length) {
            a = this;
            b = num;
        } else {
            a = num;
            b = this;
        }
        for(var i = 0; i < b.length; i++)this.words[i] = a.words[i] ^ b.words[i];
        if (this !== a) for(; i < a.length; i++)this.words[i] = a.words[i];
        this.length = a.length;
        return this._strip();
    };
    BN.prototype.ixor = function ixor(num) {
        assert((this.negative | num.negative) === 0);
        return this.iuxor(num);
    };
    // Xor `num` with `this`
    BN.prototype.xor = function xor(num) {
        if (this.length > num.length) return this.clone().ixor(num);
        return num.clone().ixor(this);
    };
    BN.prototype.uxor = function uxor(num) {
        if (this.length > num.length) return this.clone().iuxor(num);
        return num.clone().iuxor(this);
    };
    // Not ``this`` with ``width`` bitwidth
    BN.prototype.inotn = function inotn(width) {
        assert(typeof width === "number" && width >= 0);
        var bytesNeeded = Math.ceil(width / 26) | 0;
        var bitsLeft = width % 26;
        // Extend the buffer with leading zeroes
        this._expand(bytesNeeded);
        if (bitsLeft > 0) bytesNeeded--;
        // Handle complete words
        for(var i = 0; i < bytesNeeded; i++)this.words[i] = ~this.words[i] & 0x3ffffff;
        // Handle the residue
        if (bitsLeft > 0) this.words[i] = ~this.words[i] & 0x3ffffff >> 26 - bitsLeft;
        // And remove leading zeroes
        return this._strip();
    };
    BN.prototype.notn = function notn(width) {
        return this.clone().inotn(width);
    };
    // Set `bit` of `this`
    BN.prototype.setn = function setn(bit, val) {
        assert(typeof bit === "number" && bit >= 0);
        var off = bit / 26 | 0;
        var wbit = bit % 26;
        this._expand(off + 1);
        if (val) this.words[off] = this.words[off] | 1 << wbit;
        else this.words[off] = this.words[off] & ~(1 << wbit);
        return this._strip();
    };
    // Add `num` to `this` in-place
    BN.prototype.iadd = function iadd(num) {
        var r;
        // negative + positive
        if (this.negative !== 0 && num.negative === 0) {
            this.negative = 0;
            r = this.isub(num);
            this.negative ^= 1;
            return this._normSign();
        // positive + negative
        } else if (this.negative === 0 && num.negative !== 0) {
            num.negative = 0;
            r = this.isub(num);
            num.negative = 1;
            return r._normSign();
        }
        // a.length > b.length
        var a, b;
        if (this.length > num.length) {
            a = this;
            b = num;
        } else {
            a = num;
            b = this;
        }
        var carry = 0;
        for(var i = 0; i < b.length; i++){
            r = (a.words[i] | 0) + (b.words[i] | 0) + carry;
            this.words[i] = r & 0x3ffffff;
            carry = r >>> 26;
        }
        for(; carry !== 0 && i < a.length; i++){
            r = (a.words[i] | 0) + carry;
            this.words[i] = r & 0x3ffffff;
            carry = r >>> 26;
        }
        this.length = a.length;
        if (carry !== 0) {
            this.words[this.length] = carry;
            this.length++;
        // Copy the rest of the words
        } else if (a !== this) for(; i < a.length; i++)this.words[i] = a.words[i];
        return this;
    };
    // Add `num` to `this`
    BN.prototype.add = function add(num) {
        var res;
        if (num.negative !== 0 && this.negative === 0) {
            num.negative = 0;
            res = this.sub(num);
            num.negative ^= 1;
            return res;
        } else if (num.negative === 0 && this.negative !== 0) {
            this.negative = 0;
            res = num.sub(this);
            this.negative = 1;
            return res;
        }
        if (this.length > num.length) return this.clone().iadd(num);
        return num.clone().iadd(this);
    };
    // Subtract `num` from `this` in-place
    BN.prototype.isub = function isub(num) {
        // this - (-num) = this + num
        if (num.negative !== 0) {
            num.negative = 0;
            var r = this.iadd(num);
            num.negative = 1;
            return r._normSign();
        // -this - num = -(this + num)
        } else if (this.negative !== 0) {
            this.negative = 0;
            this.iadd(num);
            this.negative = 1;
            return this._normSign();
        }
        // At this point both numbers are positive
        var cmp = this.cmp(num);
        // Optimization - zeroify
        if (cmp === 0) {
            this.negative = 0;
            this.length = 1;
            this.words[0] = 0;
            return this;
        }
        // a > b
        var a, b;
        if (cmp > 0) {
            a = this;
            b = num;
        } else {
            a = num;
            b = this;
        }
        var carry = 0;
        for(var i = 0; i < b.length; i++){
            r = (a.words[i] | 0) - (b.words[i] | 0) + carry;
            carry = r >> 26;
            this.words[i] = r & 0x3ffffff;
        }
        for(; carry !== 0 && i < a.length; i++){
            r = (a.words[i] | 0) + carry;
            carry = r >> 26;
            this.words[i] = r & 0x3ffffff;
        }
        // Copy rest of the words
        if (carry === 0 && i < a.length && a !== this) for(; i < a.length; i++)this.words[i] = a.words[i];
        this.length = Math.max(this.length, i);
        if (a !== this) this.negative = 1;
        return this._strip();
    };
    // Subtract `num` from `this`
    BN.prototype.sub = function sub(num) {
        return this.clone().isub(num);
    };
    function smallMulTo(self, num, out) {
        out.negative = num.negative ^ self.negative;
        var len = self.length + num.length | 0;
        out.length = len;
        len = len - 1 | 0;
        // Peel one iteration (compiler can't do it, because of code complexity)
        var a = self.words[0] | 0;
        var b = num.words[0] | 0;
        var r = a * b;
        var lo = r & 0x3ffffff;
        var carry = r / 0x4000000 | 0;
        out.words[0] = lo;
        for(var k = 1; k < len; k++){
            // Sum all words with the same `i + j = k` and accumulate `ncarry`,
            // note that ncarry could be >= 0x3ffffff
            var ncarry = carry >>> 26;
            var rword = carry & 0x3ffffff;
            var maxJ = Math.min(k, num.length - 1);
            for(var j = Math.max(0, k - self.length + 1); j <= maxJ; j++){
                var i = k - j | 0;
                a = self.words[i] | 0;
                b = num.words[j] | 0;
                r = a * b + rword;
                ncarry += r / 0x4000000 | 0;
                rword = r & 0x3ffffff;
            }
            out.words[k] = rword | 0;
            carry = ncarry | 0;
        }
        if (carry !== 0) out.words[k] = carry | 0;
        else out.length--;
        return out._strip();
    }
    // TODO(indutny): it may be reasonable to omit it for users who don't need
    // to work with 256-bit numbers, otherwise it gives 20% improvement for 256-bit
    // multiplication (like elliptic secp256k1).
    var comb10MulTo = function comb10MulTo(self, num, out) {
        var a = self.words;
        var b = num.words;
        var o = out.words;
        var c = 0;
        var lo;
        var mid;
        var hi;
        var a0 = a[0] | 0;
        var al0 = a0 & 0x1fff;
        var ah0 = a0 >>> 13;
        var a1 = a[1] | 0;
        var al1 = a1 & 0x1fff;
        var ah1 = a1 >>> 13;
        var a2 = a[2] | 0;
        var al2 = a2 & 0x1fff;
        var ah2 = a2 >>> 13;
        var a3 = a[3] | 0;
        var al3 = a3 & 0x1fff;
        var ah3 = a3 >>> 13;
        var a4 = a[4] | 0;
        var al4 = a4 & 0x1fff;
        var ah4 = a4 >>> 13;
        var a5 = a[5] | 0;
        var al5 = a5 & 0x1fff;
        var ah5 = a5 >>> 13;
        var a6 = a[6] | 0;
        var al6 = a6 & 0x1fff;
        var ah6 = a6 >>> 13;
        var a7 = a[7] | 0;
        var al7 = a7 & 0x1fff;
        var ah7 = a7 >>> 13;
        var a8 = a[8] | 0;
        var al8 = a8 & 0x1fff;
        var ah8 = a8 >>> 13;
        var a9 = a[9] | 0;
        var al9 = a9 & 0x1fff;
        var ah9 = a9 >>> 13;
        var b0 = b[0] | 0;
        var bl0 = b0 & 0x1fff;
        var bh0 = b0 >>> 13;
        var b1 = b[1] | 0;
        var bl1 = b1 & 0x1fff;
        var bh1 = b1 >>> 13;
        var b2 = b[2] | 0;
        var bl2 = b2 & 0x1fff;
        var bh2 = b2 >>> 13;
        var b3 = b[3] | 0;
        var bl3 = b3 & 0x1fff;
        var bh3 = b3 >>> 13;
        var b4 = b[4] | 0;
        var bl4 = b4 & 0x1fff;
        var bh4 = b4 >>> 13;
        var b5 = b[5] | 0;
        var bl5 = b5 & 0x1fff;
        var bh5 = b5 >>> 13;
        var b6 = b[6] | 0;
        var bl6 = b6 & 0x1fff;
        var bh6 = b6 >>> 13;
        var b7 = b[7] | 0;
        var bl7 = b7 & 0x1fff;
        var bh7 = b7 >>> 13;
        var b8 = b[8] | 0;
        var bl8 = b8 & 0x1fff;
        var bh8 = b8 >>> 13;
        var b9 = b[9] | 0;
        var bl9 = b9 & 0x1fff;
        var bh9 = b9 >>> 13;
        out.negative = self.negative ^ num.negative;
        out.length = 19;
        /* k = 0 */ lo = Math.imul(al0, bl0);
        mid = Math.imul(al0, bh0);
        mid = mid + Math.imul(ah0, bl0) | 0;
        hi = Math.imul(ah0, bh0);
        var w0 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w0 >>> 26) | 0;
        w0 &= 0x3ffffff;
        /* k = 1 */ lo = Math.imul(al1, bl0);
        mid = Math.imul(al1, bh0);
        mid = mid + Math.imul(ah1, bl0) | 0;
        hi = Math.imul(ah1, bh0);
        lo = lo + Math.imul(al0, bl1) | 0;
        mid = mid + Math.imul(al0, bh1) | 0;
        mid = mid + Math.imul(ah0, bl1) | 0;
        hi = hi + Math.imul(ah0, bh1) | 0;
        var w1 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w1 >>> 26) | 0;
        w1 &= 0x3ffffff;
        /* k = 2 */ lo = Math.imul(al2, bl0);
        mid = Math.imul(al2, bh0);
        mid = mid + Math.imul(ah2, bl0) | 0;
        hi = Math.imul(ah2, bh0);
        lo = lo + Math.imul(al1, bl1) | 0;
        mid = mid + Math.imul(al1, bh1) | 0;
        mid = mid + Math.imul(ah1, bl1) | 0;
        hi = hi + Math.imul(ah1, bh1) | 0;
        lo = lo + Math.imul(al0, bl2) | 0;
        mid = mid + Math.imul(al0, bh2) | 0;
        mid = mid + Math.imul(ah0, bl2) | 0;
        hi = hi + Math.imul(ah0, bh2) | 0;
        var w2 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w2 >>> 26) | 0;
        w2 &= 0x3ffffff;
        /* k = 3 */ lo = Math.imul(al3, bl0);
        mid = Math.imul(al3, bh0);
        mid = mid + Math.imul(ah3, bl0) | 0;
        hi = Math.imul(ah3, bh0);
        lo = lo + Math.imul(al2, bl1) | 0;
        mid = mid + Math.imul(al2, bh1) | 0;
        mid = mid + Math.imul(ah2, bl1) | 0;
        hi = hi + Math.imul(ah2, bh1) | 0;
        lo = lo + Math.imul(al1, bl2) | 0;
        mid = mid + Math.imul(al1, bh2) | 0;
        mid = mid + Math.imul(ah1, bl2) | 0;
        hi = hi + Math.imul(ah1, bh2) | 0;
        lo = lo + Math.imul(al0, bl3) | 0;
        mid = mid + Math.imul(al0, bh3) | 0;
        mid = mid + Math.imul(ah0, bl3) | 0;
        hi = hi + Math.imul(ah0, bh3) | 0;
        var w3 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w3 >>> 26) | 0;
        w3 &= 0x3ffffff;
        /* k = 4 */ lo = Math.imul(al4, bl0);
        mid = Math.imul(al4, bh0);
        mid = mid + Math.imul(ah4, bl0) | 0;
        hi = Math.imul(ah4, bh0);
        lo = lo + Math.imul(al3, bl1) | 0;
        mid = mid + Math.imul(al3, bh1) | 0;
        mid = mid + Math.imul(ah3, bl1) | 0;
        hi = hi + Math.imul(ah3, bh1) | 0;
        lo = lo + Math.imul(al2, bl2) | 0;
        mid = mid + Math.imul(al2, bh2) | 0;
        mid = mid + Math.imul(ah2, bl2) | 0;
        hi = hi + Math.imul(ah2, bh2) | 0;
        lo = lo + Math.imul(al1, bl3) | 0;
        mid = mid + Math.imul(al1, bh3) | 0;
        mid = mid + Math.imul(ah1, bl3) | 0;
        hi = hi + Math.imul(ah1, bh3) | 0;
        lo = lo + Math.imul(al0, bl4) | 0;
        mid = mid + Math.imul(al0, bh4) | 0;
        mid = mid + Math.imul(ah0, bl4) | 0;
        hi = hi + Math.imul(ah0, bh4) | 0;
        var w4 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w4 >>> 26) | 0;
        w4 &= 0x3ffffff;
        /* k = 5 */ lo = Math.imul(al5, bl0);
        mid = Math.imul(al5, bh0);
        mid = mid + Math.imul(ah5, bl0) | 0;
        hi = Math.imul(ah5, bh0);
        lo = lo + Math.imul(al4, bl1) | 0;
        mid = mid + Math.imul(al4, bh1) | 0;
        mid = mid + Math.imul(ah4, bl1) | 0;
        hi = hi + Math.imul(ah4, bh1) | 0;
        lo = lo + Math.imul(al3, bl2) | 0;
        mid = mid + Math.imul(al3, bh2) | 0;
        mid = mid + Math.imul(ah3, bl2) | 0;
        hi = hi + Math.imul(ah3, bh2) | 0;
        lo = lo + Math.imul(al2, bl3) | 0;
        mid = mid + Math.imul(al2, bh3) | 0;
        mid = mid + Math.imul(ah2, bl3) | 0;
        hi = hi + Math.imul(ah2, bh3) | 0;
        lo = lo + Math.imul(al1, bl4) | 0;
        mid = mid + Math.imul(al1, bh4) | 0;
        mid = mid + Math.imul(ah1, bl4) | 0;
        hi = hi + Math.imul(ah1, bh4) | 0;
        lo = lo + Math.imul(al0, bl5) | 0;
        mid = mid + Math.imul(al0, bh5) | 0;
        mid = mid + Math.imul(ah0, bl5) | 0;
        hi = hi + Math.imul(ah0, bh5) | 0;
        var w5 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w5 >>> 26) | 0;
        w5 &= 0x3ffffff;
        /* k = 6 */ lo = Math.imul(al6, bl0);
        mid = Math.imul(al6, bh0);
        mid = mid + Math.imul(ah6, bl0) | 0;
        hi = Math.imul(ah6, bh0);
        lo = lo + Math.imul(al5, bl1) | 0;
        mid = mid + Math.imul(al5, bh1) | 0;
        mid = mid + Math.imul(ah5, bl1) | 0;
        hi = hi + Math.imul(ah5, bh1) | 0;
        lo = lo + Math.imul(al4, bl2) | 0;
        mid = mid + Math.imul(al4, bh2) | 0;
        mid = mid + Math.imul(ah4, bl2) | 0;
        hi = hi + Math.imul(ah4, bh2) | 0;
        lo = lo + Math.imul(al3, bl3) | 0;
        mid = mid + Math.imul(al3, bh3) | 0;
        mid = mid + Math.imul(ah3, bl3) | 0;
        hi = hi + Math.imul(ah3, bh3) | 0;
        lo = lo + Math.imul(al2, bl4) | 0;
        mid = mid + Math.imul(al2, bh4) | 0;
        mid = mid + Math.imul(ah2, bl4) | 0;
        hi = hi + Math.imul(ah2, bh4) | 0;
        lo = lo + Math.imul(al1, bl5) | 0;
        mid = mid + Math.imul(al1, bh5) | 0;
        mid = mid + Math.imul(ah1, bl5) | 0;
        hi = hi + Math.imul(ah1, bh5) | 0;
        lo = lo + Math.imul(al0, bl6) | 0;
        mid = mid + Math.imul(al0, bh6) | 0;
        mid = mid + Math.imul(ah0, bl6) | 0;
        hi = hi + Math.imul(ah0, bh6) | 0;
        var w6 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w6 >>> 26) | 0;
        w6 &= 0x3ffffff;
        /* k = 7 */ lo = Math.imul(al7, bl0);
        mid = Math.imul(al7, bh0);
        mid = mid + Math.imul(ah7, bl0) | 0;
        hi = Math.imul(ah7, bh0);
        lo = lo + Math.imul(al6, bl1) | 0;
        mid = mid + Math.imul(al6, bh1) | 0;
        mid = mid + Math.imul(ah6, bl1) | 0;
        hi = hi + Math.imul(ah6, bh1) | 0;
        lo = lo + Math.imul(al5, bl2) | 0;
        mid = mid + Math.imul(al5, bh2) | 0;
        mid = mid + Math.imul(ah5, bl2) | 0;
        hi = hi + Math.imul(ah5, bh2) | 0;
        lo = lo + Math.imul(al4, bl3) | 0;
        mid = mid + Math.imul(al4, bh3) | 0;
        mid = mid + Math.imul(ah4, bl3) | 0;
        hi = hi + Math.imul(ah4, bh3) | 0;
        lo = lo + Math.imul(al3, bl4) | 0;
        mid = mid + Math.imul(al3, bh4) | 0;
        mid = mid + Math.imul(ah3, bl4) | 0;
        hi = hi + Math.imul(ah3, bh4) | 0;
        lo = lo + Math.imul(al2, bl5) | 0;
        mid = mid + Math.imul(al2, bh5) | 0;
        mid = mid + Math.imul(ah2, bl5) | 0;
        hi = hi + Math.imul(ah2, bh5) | 0;
        lo = lo + Math.imul(al1, bl6) | 0;
        mid = mid + Math.imul(al1, bh6) | 0;
        mid = mid + Math.imul(ah1, bl6) | 0;
        hi = hi + Math.imul(ah1, bh6) | 0;
        lo = lo + Math.imul(al0, bl7) | 0;
        mid = mid + Math.imul(al0, bh7) | 0;
        mid = mid + Math.imul(ah0, bl7) | 0;
        hi = hi + Math.imul(ah0, bh7) | 0;
        var w7 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w7 >>> 26) | 0;
        w7 &= 0x3ffffff;
        /* k = 8 */ lo = Math.imul(al8, bl0);
        mid = Math.imul(al8, bh0);
        mid = mid + Math.imul(ah8, bl0) | 0;
        hi = Math.imul(ah8, bh0);
        lo = lo + Math.imul(al7, bl1) | 0;
        mid = mid + Math.imul(al7, bh1) | 0;
        mid = mid + Math.imul(ah7, bl1) | 0;
        hi = hi + Math.imul(ah7, bh1) | 0;
        lo = lo + Math.imul(al6, bl2) | 0;
        mid = mid + Math.imul(al6, bh2) | 0;
        mid = mid + Math.imul(ah6, bl2) | 0;
        hi = hi + Math.imul(ah6, bh2) | 0;
        lo = lo + Math.imul(al5, bl3) | 0;
        mid = mid + Math.imul(al5, bh3) | 0;
        mid = mid + Math.imul(ah5, bl3) | 0;
        hi = hi + Math.imul(ah5, bh3) | 0;
        lo = lo + Math.imul(al4, bl4) | 0;
        mid = mid + Math.imul(al4, bh4) | 0;
        mid = mid + Math.imul(ah4, bl4) | 0;
        hi = hi + Math.imul(ah4, bh4) | 0;
        lo = lo + Math.imul(al3, bl5) | 0;
        mid = mid + Math.imul(al3, bh5) | 0;
        mid = mid + Math.imul(ah3, bl5) | 0;
        hi = hi + Math.imul(ah3, bh5) | 0;
        lo = lo + Math.imul(al2, bl6) | 0;
        mid = mid + Math.imul(al2, bh6) | 0;
        mid = mid + Math.imul(ah2, bl6) | 0;
        hi = hi + Math.imul(ah2, bh6) | 0;
        lo = lo + Math.imul(al1, bl7) | 0;
        mid = mid + Math.imul(al1, bh7) | 0;
        mid = mid + Math.imul(ah1, bl7) | 0;
        hi = hi + Math.imul(ah1, bh7) | 0;
        lo = lo + Math.imul(al0, bl8) | 0;
        mid = mid + Math.imul(al0, bh8) | 0;
        mid = mid + Math.imul(ah0, bl8) | 0;
        hi = hi + Math.imul(ah0, bh8) | 0;
        var w8 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w8 >>> 26) | 0;
        w8 &= 0x3ffffff;
        /* k = 9 */ lo = Math.imul(al9, bl0);
        mid = Math.imul(al9, bh0);
        mid = mid + Math.imul(ah9, bl0) | 0;
        hi = Math.imul(ah9, bh0);
        lo = lo + Math.imul(al8, bl1) | 0;
        mid = mid + Math.imul(al8, bh1) | 0;
        mid = mid + Math.imul(ah8, bl1) | 0;
        hi = hi + Math.imul(ah8, bh1) | 0;
        lo = lo + Math.imul(al7, bl2) | 0;
        mid = mid + Math.imul(al7, bh2) | 0;
        mid = mid + Math.imul(ah7, bl2) | 0;
        hi = hi + Math.imul(ah7, bh2) | 0;
        lo = lo + Math.imul(al6, bl3) | 0;
        mid = mid + Math.imul(al6, bh3) | 0;
        mid = mid + Math.imul(ah6, bl3) | 0;
        hi = hi + Math.imul(ah6, bh3) | 0;
        lo = lo + Math.imul(al5, bl4) | 0;
        mid = mid + Math.imul(al5, bh4) | 0;
        mid = mid + Math.imul(ah5, bl4) | 0;
        hi = hi + Math.imul(ah5, bh4) | 0;
        lo = lo + Math.imul(al4, bl5) | 0;
        mid = mid + Math.imul(al4, bh5) | 0;
        mid = mid + Math.imul(ah4, bl5) | 0;
        hi = hi + Math.imul(ah4, bh5) | 0;
        lo = lo + Math.imul(al3, bl6) | 0;
        mid = mid + Math.imul(al3, bh6) | 0;
        mid = mid + Math.imul(ah3, bl6) | 0;
        hi = hi + Math.imul(ah3, bh6) | 0;
        lo = lo + Math.imul(al2, bl7) | 0;
        mid = mid + Math.imul(al2, bh7) | 0;
        mid = mid + Math.imul(ah2, bl7) | 0;
        hi = hi + Math.imul(ah2, bh7) | 0;
        lo = lo + Math.imul(al1, bl8) | 0;
        mid = mid + Math.imul(al1, bh8) | 0;
        mid = mid + Math.imul(ah1, bl8) | 0;
        hi = hi + Math.imul(ah1, bh8) | 0;
        lo = lo + Math.imul(al0, bl9) | 0;
        mid = mid + Math.imul(al0, bh9) | 0;
        mid = mid + Math.imul(ah0, bl9) | 0;
        hi = hi + Math.imul(ah0, bh9) | 0;
        var w9 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w9 >>> 26) | 0;
        w9 &= 0x3ffffff;
        /* k = 10 */ lo = Math.imul(al9, bl1);
        mid = Math.imul(al9, bh1);
        mid = mid + Math.imul(ah9, bl1) | 0;
        hi = Math.imul(ah9, bh1);
        lo = lo + Math.imul(al8, bl2) | 0;
        mid = mid + Math.imul(al8, bh2) | 0;
        mid = mid + Math.imul(ah8, bl2) | 0;
        hi = hi + Math.imul(ah8, bh2) | 0;
        lo = lo + Math.imul(al7, bl3) | 0;
        mid = mid + Math.imul(al7, bh3) | 0;
        mid = mid + Math.imul(ah7, bl3) | 0;
        hi = hi + Math.imul(ah7, bh3) | 0;
        lo = lo + Math.imul(al6, bl4) | 0;
        mid = mid + Math.imul(al6, bh4) | 0;
        mid = mid + Math.imul(ah6, bl4) | 0;
        hi = hi + Math.imul(ah6, bh4) | 0;
        lo = lo + Math.imul(al5, bl5) | 0;
        mid = mid + Math.imul(al5, bh5) | 0;
        mid = mid + Math.imul(ah5, bl5) | 0;
        hi = hi + Math.imul(ah5, bh5) | 0;
        lo = lo + Math.imul(al4, bl6) | 0;
        mid = mid + Math.imul(al4, bh6) | 0;
        mid = mid + Math.imul(ah4, bl6) | 0;
        hi = hi + Math.imul(ah4, bh6) | 0;
        lo = lo + Math.imul(al3, bl7) | 0;
        mid = mid + Math.imul(al3, bh7) | 0;
        mid = mid + Math.imul(ah3, bl7) | 0;
        hi = hi + Math.imul(ah3, bh7) | 0;
        lo = lo + Math.imul(al2, bl8) | 0;
        mid = mid + Math.imul(al2, bh8) | 0;
        mid = mid + Math.imul(ah2, bl8) | 0;
        hi = hi + Math.imul(ah2, bh8) | 0;
        lo = lo + Math.imul(al1, bl9) | 0;
        mid = mid + Math.imul(al1, bh9) | 0;
        mid = mid + Math.imul(ah1, bl9) | 0;
        hi = hi + Math.imul(ah1, bh9) | 0;
        var w10 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w10 >>> 26) | 0;
        w10 &= 0x3ffffff;
        /* k = 11 */ lo = Math.imul(al9, bl2);
        mid = Math.imul(al9, bh2);
        mid = mid + Math.imul(ah9, bl2) | 0;
        hi = Math.imul(ah9, bh2);
        lo = lo + Math.imul(al8, bl3) | 0;
        mid = mid + Math.imul(al8, bh3) | 0;
        mid = mid + Math.imul(ah8, bl3) | 0;
        hi = hi + Math.imul(ah8, bh3) | 0;
        lo = lo + Math.imul(al7, bl4) | 0;
        mid = mid + Math.imul(al7, bh4) | 0;
        mid = mid + Math.imul(ah7, bl4) | 0;
        hi = hi + Math.imul(ah7, bh4) | 0;
        lo = lo + Math.imul(al6, bl5) | 0;
        mid = mid + Math.imul(al6, bh5) | 0;
        mid = mid + Math.imul(ah6, bl5) | 0;
        hi = hi + Math.imul(ah6, bh5) | 0;
        lo = lo + Math.imul(al5, bl6) | 0;
        mid = mid + Math.imul(al5, bh6) | 0;
        mid = mid + Math.imul(ah5, bl6) | 0;
        hi = hi + Math.imul(ah5, bh6) | 0;
        lo = lo + Math.imul(al4, bl7) | 0;
        mid = mid + Math.imul(al4, bh7) | 0;
        mid = mid + Math.imul(ah4, bl7) | 0;
        hi = hi + Math.imul(ah4, bh7) | 0;
        lo = lo + Math.imul(al3, bl8) | 0;
        mid = mid + Math.imul(al3, bh8) | 0;
        mid = mid + Math.imul(ah3, bl8) | 0;
        hi = hi + Math.imul(ah3, bh8) | 0;
        lo = lo + Math.imul(al2, bl9) | 0;
        mid = mid + Math.imul(al2, bh9) | 0;
        mid = mid + Math.imul(ah2, bl9) | 0;
        hi = hi + Math.imul(ah2, bh9) | 0;
        var w11 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w11 >>> 26) | 0;
        w11 &= 0x3ffffff;
        /* k = 12 */ lo = Math.imul(al9, bl3);
        mid = Math.imul(al9, bh3);
        mid = mid + Math.imul(ah9, bl3) | 0;
        hi = Math.imul(ah9, bh3);
        lo = lo + Math.imul(al8, bl4) | 0;
        mid = mid + Math.imul(al8, bh4) | 0;
        mid = mid + Math.imul(ah8, bl4) | 0;
        hi = hi + Math.imul(ah8, bh4) | 0;
        lo = lo + Math.imul(al7, bl5) | 0;
        mid = mid + Math.imul(al7, bh5) | 0;
        mid = mid + Math.imul(ah7, bl5) | 0;
        hi = hi + Math.imul(ah7, bh5) | 0;
        lo = lo + Math.imul(al6, bl6) | 0;
        mid = mid + Math.imul(al6, bh6) | 0;
        mid = mid + Math.imul(ah6, bl6) | 0;
        hi = hi + Math.imul(ah6, bh6) | 0;
        lo = lo + Math.imul(al5, bl7) | 0;
        mid = mid + Math.imul(al5, bh7) | 0;
        mid = mid + Math.imul(ah5, bl7) | 0;
        hi = hi + Math.imul(ah5, bh7) | 0;
        lo = lo + Math.imul(al4, bl8) | 0;
        mid = mid + Math.imul(al4, bh8) | 0;
        mid = mid + Math.imul(ah4, bl8) | 0;
        hi = hi + Math.imul(ah4, bh8) | 0;
        lo = lo + Math.imul(al3, bl9) | 0;
        mid = mid + Math.imul(al3, bh9) | 0;
        mid = mid + Math.imul(ah3, bl9) | 0;
        hi = hi + Math.imul(ah3, bh9) | 0;
        var w12 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w12 >>> 26) | 0;
        w12 &= 0x3ffffff;
        /* k = 13 */ lo = Math.imul(al9, bl4);
        mid = Math.imul(al9, bh4);
        mid = mid + Math.imul(ah9, bl4) | 0;
        hi = Math.imul(ah9, bh4);
        lo = lo + Math.imul(al8, bl5) | 0;
        mid = mid + Math.imul(al8, bh5) | 0;
        mid = mid + Math.imul(ah8, bl5) | 0;
        hi = hi + Math.imul(ah8, bh5) | 0;
        lo = lo + Math.imul(al7, bl6) | 0;
        mid = mid + Math.imul(al7, bh6) | 0;
        mid = mid + Math.imul(ah7, bl6) | 0;
        hi = hi + Math.imul(ah7, bh6) | 0;
        lo = lo + Math.imul(al6, bl7) | 0;
        mid = mid + Math.imul(al6, bh7) | 0;
        mid = mid + Math.imul(ah6, bl7) | 0;
        hi = hi + Math.imul(ah6, bh7) | 0;
        lo = lo + Math.imul(al5, bl8) | 0;
        mid = mid + Math.imul(al5, bh8) | 0;
        mid = mid + Math.imul(ah5, bl8) | 0;
        hi = hi + Math.imul(ah5, bh8) | 0;
        lo = lo + Math.imul(al4, bl9) | 0;
        mid = mid + Math.imul(al4, bh9) | 0;
        mid = mid + Math.imul(ah4, bl9) | 0;
        hi = hi + Math.imul(ah4, bh9) | 0;
        var w13 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w13 >>> 26) | 0;
        w13 &= 0x3ffffff;
        /* k = 14 */ lo = Math.imul(al9, bl5);
        mid = Math.imul(al9, bh5);
        mid = mid + Math.imul(ah9, bl5) | 0;
        hi = Math.imul(ah9, bh5);
        lo = lo + Math.imul(al8, bl6) | 0;
        mid = mid + Math.imul(al8, bh6) | 0;
        mid = mid + Math.imul(ah8, bl6) | 0;
        hi = hi + Math.imul(ah8, bh6) | 0;
        lo = lo + Math.imul(al7, bl7) | 0;
        mid = mid + Math.imul(al7, bh7) | 0;
        mid = mid + Math.imul(ah7, bl7) | 0;
        hi = hi + Math.imul(ah7, bh7) | 0;
        lo = lo + Math.imul(al6, bl8) | 0;
        mid = mid + Math.imul(al6, bh8) | 0;
        mid = mid + Math.imul(ah6, bl8) | 0;
        hi = hi + Math.imul(ah6, bh8) | 0;
        lo = lo + Math.imul(al5, bl9) | 0;
        mid = mid + Math.imul(al5, bh9) | 0;
        mid = mid + Math.imul(ah5, bl9) | 0;
        hi = hi + Math.imul(ah5, bh9) | 0;
        var w14 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w14 >>> 26) | 0;
        w14 &= 0x3ffffff;
        /* k = 15 */ lo = Math.imul(al9, bl6);
        mid = Math.imul(al9, bh6);
        mid = mid + Math.imul(ah9, bl6) | 0;
        hi = Math.imul(ah9, bh6);
        lo = lo + Math.imul(al8, bl7) | 0;
        mid = mid + Math.imul(al8, bh7) | 0;
        mid = mid + Math.imul(ah8, bl7) | 0;
        hi = hi + Math.imul(ah8, bh7) | 0;
        lo = lo + Math.imul(al7, bl8) | 0;
        mid = mid + Math.imul(al7, bh8) | 0;
        mid = mid + Math.imul(ah7, bl8) | 0;
        hi = hi + Math.imul(ah7, bh8) | 0;
        lo = lo + Math.imul(al6, bl9) | 0;
        mid = mid + Math.imul(al6, bh9) | 0;
        mid = mid + Math.imul(ah6, bl9) | 0;
        hi = hi + Math.imul(ah6, bh9) | 0;
        var w15 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w15 >>> 26) | 0;
        w15 &= 0x3ffffff;
        /* k = 16 */ lo = Math.imul(al9, bl7);
        mid = Math.imul(al9, bh7);
        mid = mid + Math.imul(ah9, bl7) | 0;
        hi = Math.imul(ah9, bh7);
        lo = lo + Math.imul(al8, bl8) | 0;
        mid = mid + Math.imul(al8, bh8) | 0;
        mid = mid + Math.imul(ah8, bl8) | 0;
        hi = hi + Math.imul(ah8, bh8) | 0;
        lo = lo + Math.imul(al7, bl9) | 0;
        mid = mid + Math.imul(al7, bh9) | 0;
        mid = mid + Math.imul(ah7, bl9) | 0;
        hi = hi + Math.imul(ah7, bh9) | 0;
        var w16 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w16 >>> 26) | 0;
        w16 &= 0x3ffffff;
        /* k = 17 */ lo = Math.imul(al9, bl8);
        mid = Math.imul(al9, bh8);
        mid = mid + Math.imul(ah9, bl8) | 0;
        hi = Math.imul(ah9, bh8);
        lo = lo + Math.imul(al8, bl9) | 0;
        mid = mid + Math.imul(al8, bh9) | 0;
        mid = mid + Math.imul(ah8, bl9) | 0;
        hi = hi + Math.imul(ah8, bh9) | 0;
        var w17 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w17 >>> 26) | 0;
        w17 &= 0x3ffffff;
        /* k = 18 */ lo = Math.imul(al9, bl9);
        mid = Math.imul(al9, bh9);
        mid = mid + Math.imul(ah9, bl9) | 0;
        hi = Math.imul(ah9, bh9);
        var w18 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w18 >>> 26) | 0;
        w18 &= 0x3ffffff;
        o[0] = w0;
        o[1] = w1;
        o[2] = w2;
        o[3] = w3;
        o[4] = w4;
        o[5] = w5;
        o[6] = w6;
        o[7] = w7;
        o[8] = w8;
        o[9] = w9;
        o[10] = w10;
        o[11] = w11;
        o[12] = w12;
        o[13] = w13;
        o[14] = w14;
        o[15] = w15;
        o[16] = w16;
        o[17] = w17;
        o[18] = w18;
        if (c !== 0) {
            o[19] = c;
            out.length++;
        }
        return out;
    };
    // Polyfill comb
    if (!Math.imul) comb10MulTo = smallMulTo;
    function bigMulTo(self, num, out) {
        out.negative = num.negative ^ self.negative;
        out.length = self.length + num.length;
        var carry = 0;
        var hncarry = 0;
        for(var k = 0; k < out.length - 1; k++){
            // Sum all words with the same `i + j = k` and accumulate `ncarry`,
            // note that ncarry could be >= 0x3ffffff
            var ncarry = hncarry;
            hncarry = 0;
            var rword = carry & 0x3ffffff;
            var maxJ = Math.min(k, num.length - 1);
            for(var j = Math.max(0, k - self.length + 1); j <= maxJ; j++){
                var i = k - j;
                var a = self.words[i] | 0;
                var b = num.words[j] | 0;
                var r = a * b;
                var lo = r & 0x3ffffff;
                ncarry = ncarry + (r / 0x4000000 | 0) | 0;
                lo = lo + rword | 0;
                rword = lo & 0x3ffffff;
                ncarry = ncarry + (lo >>> 26) | 0;
                hncarry += ncarry >>> 26;
                ncarry &= 0x3ffffff;
            }
            out.words[k] = rword;
            carry = ncarry;
            ncarry = hncarry;
        }
        if (carry !== 0) out.words[k] = carry;
        else out.length--;
        return out._strip();
    }
    function jumboMulTo(self, num, out) {
        // Temporary disable, see https://github.com/indutny/bn.js/issues/211
        // var fftm = new FFTM();
        // return fftm.mulp(self, num, out);
        return bigMulTo(self, num, out);
    }
    BN.prototype.mulTo = function mulTo(num, out) {
        var res;
        var len = this.length + num.length;
        if (this.length === 10 && num.length === 10) res = comb10MulTo(this, num, out);
        else if (len < 63) res = smallMulTo(this, num, out);
        else if (len < 1024) res = bigMulTo(this, num, out);
        else res = jumboMulTo(this, num, out);
        return res;
    };
    // Cooley-Tukey algorithm for FFT
    // slightly revisited to rely on looping instead of recursion
    function FFTM(x, y) {
        this.x = x;
        this.y = y;
    }
    FFTM.prototype.makeRBT = function makeRBT(N) {
        var t = new Array(N);
        var l = BN.prototype._countBits(N) - 1;
        for(var i = 0; i < N; i++)t[i] = this.revBin(i, l, N);
        return t;
    };
    // Returns binary-reversed representation of `x`
    FFTM.prototype.revBin = function revBin(x, l, N) {
        if (x === 0 || x === N - 1) return x;
        var rb = 0;
        for(var i = 0; i < l; i++){
            rb |= (x & 1) << l - i - 1;
            x >>= 1;
        }
        return rb;
    };
    // Performs "tweedling" phase, therefore 'emulating'
    // behaviour of the recursive algorithm
    FFTM.prototype.permute = function permute(rbt, rws, iws, rtws, itws, N) {
        for(var i = 0; i < N; i++){
            rtws[i] = rws[rbt[i]];
            itws[i] = iws[rbt[i]];
        }
    };
    FFTM.prototype.transform = function transform(rws, iws, rtws, itws, N, rbt) {
        this.permute(rbt, rws, iws, rtws, itws, N);
        for(var s = 1; s < N; s <<= 1){
            var l = s << 1;
            var rtwdf = Math.cos(2 * Math.PI / l);
            var itwdf = Math.sin(2 * Math.PI / l);
            for(var p = 0; p < N; p += l){
                var rtwdf_ = rtwdf;
                var itwdf_ = itwdf;
                for(var j = 0; j < s; j++){
                    var re = rtws[p + j];
                    var ie = itws[p + j];
                    var ro = rtws[p + j + s];
                    var io = itws[p + j + s];
                    var rx = rtwdf_ * ro - itwdf_ * io;
                    io = rtwdf_ * io + itwdf_ * ro;
                    ro = rx;
                    rtws[p + j] = re + ro;
                    itws[p + j] = ie + io;
                    rtws[p + j + s] = re - ro;
                    itws[p + j + s] = ie - io;
                    /* jshint maxdepth : false */ if (j !== l) {
                        rx = rtwdf * rtwdf_ - itwdf * itwdf_;
                        itwdf_ = rtwdf * itwdf_ + itwdf * rtwdf_;
                        rtwdf_ = rx;
                    }
                }
            }
        }
    };
    FFTM.prototype.guessLen13b = function guessLen13b(n, m) {
        var N = Math.max(m, n) | 1;
        var odd = N & 1;
        var i = 0;
        for(N = N / 2 | 0; N; N = N >>> 1)i++;
        return 1 << i + 1 + odd;
    };
    FFTM.prototype.conjugate = function conjugate(rws, iws, N) {
        if (N <= 1) return;
        for(var i = 0; i < N / 2; i++){
            var t = rws[i];
            rws[i] = rws[N - i - 1];
            rws[N - i - 1] = t;
            t = iws[i];
            iws[i] = -iws[N - i - 1];
            iws[N - i - 1] = -t;
        }
    };
    FFTM.prototype.normalize13b = function normalize13b(ws, N) {
        var carry = 0;
        for(var i = 0; i < N / 2; i++){
            var w = Math.round(ws[2 * i + 1] / N) * 0x2000 + Math.round(ws[2 * i] / N) + carry;
            ws[i] = w & 0x3ffffff;
            if (w < 0x4000000) carry = 0;
            else carry = w / 0x4000000 | 0;
        }
        return ws;
    };
    FFTM.prototype.convert13b = function convert13b(ws, len, rws, N) {
        var carry = 0;
        for(var i = 0; i < len; i++){
            carry = carry + (ws[i] | 0);
            rws[2 * i] = carry & 0x1fff;
            carry = carry >>> 13;
            rws[2 * i + 1] = carry & 0x1fff;
            carry = carry >>> 13;
        }
        // Pad with zeroes
        for(i = 2 * len; i < N; ++i)rws[i] = 0;
        assert(carry === 0);
        assert((carry & -8192) === 0);
    };
    FFTM.prototype.stub = function stub(N) {
        var ph = new Array(N);
        for(var i = 0; i < N; i++)ph[i] = 0;
        return ph;
    };
    FFTM.prototype.mulp = function mulp(x, y, out) {
        var N = 2 * this.guessLen13b(x.length, y.length);
        var rbt = this.makeRBT(N);
        var _ = this.stub(N);
        var rws = new Array(N);
        var rwst = new Array(N);
        var iwst = new Array(N);
        var nrws = new Array(N);
        var nrwst = new Array(N);
        var niwst = new Array(N);
        var rmws = out.words;
        rmws.length = N;
        this.convert13b(x.words, x.length, rws, N);
        this.convert13b(y.words, y.length, nrws, N);
        this.transform(rws, _, rwst, iwst, N, rbt);
        this.transform(nrws, _, nrwst, niwst, N, rbt);
        for(var i = 0; i < N; i++){
            var rx = rwst[i] * nrwst[i] - iwst[i] * niwst[i];
            iwst[i] = rwst[i] * niwst[i] + iwst[i] * nrwst[i];
            rwst[i] = rx;
        }
        this.conjugate(rwst, iwst, N);
        this.transform(rwst, iwst, rmws, _, N, rbt);
        this.conjugate(rmws, _, N);
        this.normalize13b(rmws, N);
        out.negative = x.negative ^ y.negative;
        out.length = x.length + y.length;
        return out._strip();
    };
    // Multiply `this` by `num`
    BN.prototype.mul = function mul(num) {
        var out = new BN(null);
        out.words = new Array(this.length + num.length);
        return this.mulTo(num, out);
    };
    // Multiply employing FFT
    BN.prototype.mulf = function mulf(num) {
        var out = new BN(null);
        out.words = new Array(this.length + num.length);
        return jumboMulTo(this, num, out);
    };
    // In-place Multiplication
    BN.prototype.imul = function imul(num) {
        return this.clone().mulTo(num, this);
    };
    BN.prototype.imuln = function imuln(num) {
        var isNegNum = num < 0;
        if (isNegNum) num = -num;
        assert(typeof num === "number");
        assert(num < 0x4000000);
        // Carry
        var carry = 0;
        for(var i = 0; i < this.length; i++){
            var w = (this.words[i] | 0) * num;
            var lo = (w & 0x3ffffff) + (carry & 0x3ffffff);
            carry >>= 26;
            carry += w / 0x4000000 | 0;
            // NOTE: lo is 27bit maximum
            carry += lo >>> 26;
            this.words[i] = lo & 0x3ffffff;
        }
        if (carry !== 0) {
            this.words[i] = carry;
            this.length++;
        }
        return isNegNum ? this.ineg() : this;
    };
    BN.prototype.muln = function muln(num) {
        return this.clone().imuln(num);
    };
    // `this` * `this`
    BN.prototype.sqr = function sqr() {
        return this.mul(this);
    };
    // `this` * `this` in-place
    BN.prototype.isqr = function isqr() {
        return this.imul(this.clone());
    };
    // Math.pow(`this`, `num`)
    BN.prototype.pow = function pow(num) {
        var w = toBitArray(num);
        if (w.length === 0) return new BN(1);
        // Skip leading zeroes
        var res = this;
        for(var i = 0; i < w.length; i++, res = res.sqr()){
            if (w[i] !== 0) break;
        }
        if (++i < w.length) for(var q = res.sqr(); i < w.length; i++, q = q.sqr()){
            if (w[i] === 0) continue;
            res = res.mul(q);
        }
        return res;
    };
    // Shift-left in-place
    BN.prototype.iushln = function iushln(bits) {
        assert(typeof bits === "number" && bits >= 0);
        var r = bits % 26;
        var s = (bits - r) / 26;
        var carryMask = 0x3ffffff >>> 26 - r << 26 - r;
        var i;
        if (r !== 0) {
            var carry = 0;
            for(i = 0; i < this.length; i++){
                var newCarry = this.words[i] & carryMask;
                var c = (this.words[i] | 0) - newCarry << r;
                this.words[i] = c | carry;
                carry = newCarry >>> 26 - r;
            }
            if (carry) {
                this.words[i] = carry;
                this.length++;
            }
        }
        if (s !== 0) {
            for(i = this.length - 1; i >= 0; i--)this.words[i + s] = this.words[i];
            for(i = 0; i < s; i++)this.words[i] = 0;
            this.length += s;
        }
        return this._strip();
    };
    BN.prototype.ishln = function ishln(bits) {
        // TODO(indutny): implement me
        assert(this.negative === 0);
        return this.iushln(bits);
    };
    // Shift-right in-place
    // NOTE: `hint` is a lowest bit before trailing zeroes
    // NOTE: if `extended` is present - it will be filled with destroyed bits
    BN.prototype.iushrn = function iushrn(bits, hint, extended) {
        assert(typeof bits === "number" && bits >= 0);
        var h;
        if (hint) h = (hint - hint % 26) / 26;
        else h = 0;
        var r = bits % 26;
        var s = Math.min((bits - r) / 26, this.length);
        var mask = 0x3ffffff ^ 0x3ffffff >>> r << r;
        var maskedWords = extended;
        h -= s;
        h = Math.max(0, h);
        // Extended mode, copy masked part
        if (maskedWords) {
            for(var i = 0; i < s; i++)maskedWords.words[i] = this.words[i];
            maskedWords.length = s;
        }
        if (s === 0) ;
        else if (this.length > s) {
            this.length -= s;
            for(i = 0; i < this.length; i++)this.words[i] = this.words[i + s];
        } else {
            this.words[0] = 0;
            this.length = 1;
        }
        var carry = 0;
        for(i = this.length - 1; i >= 0 && (carry !== 0 || i >= h); i--){
            var word = this.words[i] | 0;
            this.words[i] = carry << 26 - r | word >>> r;
            carry = word & mask;
        }
        // Push carried bits as a mask
        if (maskedWords && carry !== 0) maskedWords.words[maskedWords.length++] = carry;
        if (this.length === 0) {
            this.words[0] = 0;
            this.length = 1;
        }
        return this._strip();
    };
    BN.prototype.ishrn = function ishrn(bits, hint, extended) {
        // TODO(indutny): implement me
        assert(this.negative === 0);
        return this.iushrn(bits, hint, extended);
    };
    // Shift-left
    BN.prototype.shln = function shln(bits) {
        return this.clone().ishln(bits);
    };
    BN.prototype.ushln = function ushln(bits) {
        return this.clone().iushln(bits);
    };
    // Shift-right
    BN.prototype.shrn = function shrn(bits) {
        return this.clone().ishrn(bits);
    };
    BN.prototype.ushrn = function ushrn(bits) {
        return this.clone().iushrn(bits);
    };
    // Test if n bit is set
    BN.prototype.testn = function testn(bit) {
        assert(typeof bit === "number" && bit >= 0);
        var r = bit % 26;
        var s = (bit - r) / 26;
        var q = 1 << r;
        // Fast case: bit is much higher than all existing words
        if (this.length <= s) return false;
        // Check bit and return
        var w = this.words[s];
        return !!(w & q);
    };
    // Return only lowers bits of number (in-place)
    BN.prototype.imaskn = function imaskn(bits) {
        assert(typeof bits === "number" && bits >= 0);
        var r = bits % 26;
        var s = (bits - r) / 26;
        assert(this.negative === 0, "imaskn works only with positive numbers");
        if (this.length <= s) return this;
        if (r !== 0) s++;
        this.length = Math.min(s, this.length);
        if (r !== 0) {
            var mask = 0x3ffffff ^ 0x3ffffff >>> r << r;
            this.words[this.length - 1] &= mask;
        }
        return this._strip();
    };
    // Return only lowers bits of number
    BN.prototype.maskn = function maskn(bits) {
        return this.clone().imaskn(bits);
    };
    // Add plain number `num` to `this`
    BN.prototype.iaddn = function iaddn(num) {
        assert(typeof num === "number");
        assert(num < 0x4000000);
        if (num < 0) return this.isubn(-num);
        // Possible sign change
        if (this.negative !== 0) {
            if (this.length === 1 && (this.words[0] | 0) <= num) {
                this.words[0] = num - (this.words[0] | 0);
                this.negative = 0;
                return this;
            }
            this.negative = 0;
            this.isubn(num);
            this.negative = 1;
            return this;
        }
        // Add without checks
        return this._iaddn(num);
    };
    BN.prototype._iaddn = function _iaddn(num) {
        this.words[0] += num;
        // Carry
        for(var i = 0; i < this.length && this.words[i] >= 0x4000000; i++){
            this.words[i] -= 0x4000000;
            if (i === this.length - 1) this.words[i + 1] = 1;
            else this.words[i + 1]++;
        }
        this.length = Math.max(this.length, i + 1);
        return this;
    };
    // Subtract plain number `num` from `this`
    BN.prototype.isubn = function isubn(num) {
        assert(typeof num === "number");
        assert(num < 0x4000000);
        if (num < 0) return this.iaddn(-num);
        if (this.negative !== 0) {
            this.negative = 0;
            this.iaddn(num);
            this.negative = 1;
            return this;
        }
        this.words[0] -= num;
        if (this.length === 1 && this.words[0] < 0) {
            this.words[0] = -this.words[0];
            this.negative = 1;
        } else // Carry
        for(var i = 0; i < this.length && this.words[i] < 0; i++){
            this.words[i] += 0x4000000;
            this.words[i + 1] -= 1;
        }
        return this._strip();
    };
    BN.prototype.addn = function addn(num) {
        return this.clone().iaddn(num);
    };
    BN.prototype.subn = function subn(num) {
        return this.clone().isubn(num);
    };
    BN.prototype.iabs = function iabs() {
        this.negative = 0;
        return this;
    };
    BN.prototype.abs = function abs() {
        return this.clone().iabs();
    };
    BN.prototype._ishlnsubmul = function _ishlnsubmul(num, mul, shift) {
        var len = num.length + shift;
        var i;
        this._expand(len);
        var w;
        var carry = 0;
        for(i = 0; i < num.length; i++){
            w = (this.words[i + shift] | 0) + carry;
            var right = (num.words[i] | 0) * mul;
            w -= right & 0x3ffffff;
            carry = (w >> 26) - (right / 0x4000000 | 0);
            this.words[i + shift] = w & 0x3ffffff;
        }
        for(; i < this.length - shift; i++){
            w = (this.words[i + shift] | 0) + carry;
            carry = w >> 26;
            this.words[i + shift] = w & 0x3ffffff;
        }
        if (carry === 0) return this._strip();
        // Subtraction overflow
        assert(carry === -1);
        carry = 0;
        for(i = 0; i < this.length; i++){
            w = -(this.words[i] | 0) + carry;
            carry = w >> 26;
            this.words[i] = w & 0x3ffffff;
        }
        this.negative = 1;
        return this._strip();
    };
    BN.prototype._wordDiv = function _wordDiv(num, mode) {
        var shift = this.length - num.length;
        var a = this.clone();
        var b = num;
        // Normalize
        var bhi = b.words[b.length - 1] | 0;
        var bhiBits = this._countBits(bhi);
        shift = 26 - bhiBits;
        if (shift !== 0) {
            b = b.ushln(shift);
            a.iushln(shift);
            bhi = b.words[b.length - 1] | 0;
        }
        // Initialize quotient
        var m = a.length - b.length;
        var q;
        if (mode !== "mod") {
            q = new BN(null);
            q.length = m + 1;
            q.words = new Array(q.length);
            for(var i = 0; i < q.length; i++)q.words[i] = 0;
        }
        var diff = a.clone()._ishlnsubmul(b, 1, m);
        if (diff.negative === 0) {
            a = diff;
            if (q) q.words[m] = 1;
        }
        for(var j = m - 1; j >= 0; j--){
            var qj = (a.words[b.length + j] | 0) * 0x4000000 + (a.words[b.length + j - 1] | 0);
            // NOTE: (qj / bhi) is (0x3ffffff * 0x4000000 + 0x3ffffff) / 0x2000000 max
            // (0x7ffffff)
            qj = Math.min(qj / bhi | 0, 0x3ffffff);
            a._ishlnsubmul(b, qj, j);
            while(a.negative !== 0){
                qj--;
                a.negative = 0;
                a._ishlnsubmul(b, 1, j);
                if (!a.isZero()) a.negative ^= 1;
            }
            if (q) q.words[j] = qj;
        }
        if (q) q._strip();
        a._strip();
        // Denormalize
        if (mode !== "div" && shift !== 0) a.iushrn(shift);
        return {
            div: q || null,
            mod: a
        };
    };
    // NOTE: 1) `mode` can be set to `mod` to request mod only,
    //       to `div` to request div only, or be absent to
    //       request both div & mod
    //       2) `positive` is true if unsigned mod is requested
    BN.prototype.divmod = function divmod(num, mode, positive) {
        assert(!num.isZero());
        if (this.isZero()) return {
            div: new BN(0),
            mod: new BN(0)
        };
        var div, mod, res;
        if (this.negative !== 0 && num.negative === 0) {
            res = this.neg().divmod(num, mode);
            if (mode !== "mod") div = res.div.neg();
            if (mode !== "div") {
                mod = res.mod.neg();
                if (positive && mod.negative !== 0) mod.iadd(num);
            }
            return {
                div: div,
                mod: mod
            };
        }
        if (this.negative === 0 && num.negative !== 0) {
            res = this.divmod(num.neg(), mode);
            if (mode !== "mod") div = res.div.neg();
            return {
                div: div,
                mod: res.mod
            };
        }
        if ((this.negative & num.negative) !== 0) {
            res = this.neg().divmod(num.neg(), mode);
            if (mode !== "div") {
                mod = res.mod.neg();
                if (positive && mod.negative !== 0) mod.isub(num);
            }
            return {
                div: res.div,
                mod: mod
            };
        }
        // Both numbers are positive at this point
        // Strip both numbers to approximate shift value
        if (num.length > this.length || this.cmp(num) < 0) return {
            div: new BN(0),
            mod: this
        };
        // Very short reduction
        if (num.length === 1) {
            if (mode === "div") return {
                div: this.divn(num.words[0]),
                mod: null
            };
            if (mode === "mod") return {
                div: null,
                mod: new BN(this.modrn(num.words[0]))
            };
            return {
                div: this.divn(num.words[0]),
                mod: new BN(this.modrn(num.words[0]))
            };
        }
        return this._wordDiv(num, mode);
    };
    // Find `this` / `num`
    BN.prototype.div = function div(num) {
        return this.divmod(num, "div", false).div;
    };
    // Find `this` % `num`
    BN.prototype.mod = function mod(num) {
        return this.divmod(num, "mod", false).mod;
    };
    BN.prototype.umod = function umod(num) {
        return this.divmod(num, "mod", true).mod;
    };
    // Find Round(`this` / `num`)
    BN.prototype.divRound = function divRound(num) {
        var dm = this.divmod(num);
        // Fast case - exact division
        if (dm.mod.isZero()) return dm.div;
        var mod = dm.div.negative !== 0 ? dm.mod.isub(num) : dm.mod;
        var half = num.ushrn(1);
        var r2 = num.andln(1);
        var cmp = mod.cmp(half);
        // Round down
        if (cmp < 0 || r2 === 1 && cmp === 0) return dm.div;
        // Round up
        return dm.div.negative !== 0 ? dm.div.isubn(1) : dm.div.iaddn(1);
    };
    BN.prototype.modrn = function modrn(num) {
        var isNegNum = num < 0;
        if (isNegNum) num = -num;
        assert(num <= 0x3ffffff);
        var p = 67108864 % num;
        var acc = 0;
        for(var i = this.length - 1; i >= 0; i--)acc = (p * acc + (this.words[i] | 0)) % num;
        return isNegNum ? -acc : acc;
    };
    // WARNING: DEPRECATED
    BN.prototype.modn = function modn(num) {
        return this.modrn(num);
    };
    // In-place division by number
    BN.prototype.idivn = function idivn(num) {
        var isNegNum = num < 0;
        if (isNegNum) num = -num;
        assert(num <= 0x3ffffff);
        var carry = 0;
        for(var i = this.length - 1; i >= 0; i--){
            var w = (this.words[i] | 0) + carry * 0x4000000;
            this.words[i] = w / num | 0;
            carry = w % num;
        }
        this._strip();
        return isNegNum ? this.ineg() : this;
    };
    BN.prototype.divn = function divn(num) {
        return this.clone().idivn(num);
    };
    BN.prototype.egcd = function egcd(p) {
        assert(p.negative === 0);
        assert(!p.isZero());
        var x = this;
        var y = p.clone();
        if (x.negative !== 0) x = x.umod(p);
        else x = x.clone();
        // A * x + B * y = x
        var A = new BN(1);
        var B = new BN(0);
        // C * x + D * y = y
        var C = new BN(0);
        var D = new BN(1);
        var g = 0;
        while(x.isEven() && y.isEven()){
            x.iushrn(1);
            y.iushrn(1);
            ++g;
        }
        var yp = y.clone();
        var xp = x.clone();
        while(!x.isZero()){
            for(var i = 0, im = 1; (x.words[0] & im) === 0 && i < 26; ++i, im <<= 1);
            if (i > 0) {
                x.iushrn(i);
                while(i-- > 0){
                    if (A.isOdd() || B.isOdd()) {
                        A.iadd(yp);
                        B.isub(xp);
                    }
                    A.iushrn(1);
                    B.iushrn(1);
                }
            }
            for(var j = 0, jm = 1; (y.words[0] & jm) === 0 && j < 26; ++j, jm <<= 1);
            if (j > 0) {
                y.iushrn(j);
                while(j-- > 0){
                    if (C.isOdd() || D.isOdd()) {
                        C.iadd(yp);
                        D.isub(xp);
                    }
                    C.iushrn(1);
                    D.iushrn(1);
                }
            }
            if (x.cmp(y) >= 0) {
                x.isub(y);
                A.isub(C);
                B.isub(D);
            } else {
                y.isub(x);
                C.isub(A);
                D.isub(B);
            }
        }
        return {
            a: C,
            b: D,
            gcd: y.iushln(g)
        };
    };
    // This is reduced incarnation of the binary EEA
    // above, designated to invert members of the
    // _prime_ fields F(p) at a maximal speed
    BN.prototype._invmp = function _invmp(p) {
        assert(p.negative === 0);
        assert(!p.isZero());
        var a = this;
        var b = p.clone();
        if (a.negative !== 0) a = a.umod(p);
        else a = a.clone();
        var x1 = new BN(1);
        var x2 = new BN(0);
        var delta = b.clone();
        while(a.cmpn(1) > 0 && b.cmpn(1) > 0){
            for(var i = 0, im = 1; (a.words[0] & im) === 0 && i < 26; ++i, im <<= 1);
            if (i > 0) {
                a.iushrn(i);
                while(i-- > 0){
                    if (x1.isOdd()) x1.iadd(delta);
                    x1.iushrn(1);
                }
            }
            for(var j = 0, jm = 1; (b.words[0] & jm) === 0 && j < 26; ++j, jm <<= 1);
            if (j > 0) {
                b.iushrn(j);
                while(j-- > 0){
                    if (x2.isOdd()) x2.iadd(delta);
                    x2.iushrn(1);
                }
            }
            if (a.cmp(b) >= 0) {
                a.isub(b);
                x1.isub(x2);
            } else {
                b.isub(a);
                x2.isub(x1);
            }
        }
        var res;
        if (a.cmpn(1) === 0) res = x1;
        else res = x2;
        if (res.cmpn(0) < 0) res.iadd(p);
        return res;
    };
    BN.prototype.gcd = function gcd(num) {
        if (this.isZero()) return num.abs();
        if (num.isZero()) return this.abs();
        var a = this.clone();
        var b = num.clone();
        a.negative = 0;
        b.negative = 0;
        // Remove common factor of two
        for(var shift = 0; a.isEven() && b.isEven(); shift++){
            a.iushrn(1);
            b.iushrn(1);
        }
        do {
            while(a.isEven())a.iushrn(1);
            while(b.isEven())b.iushrn(1);
            var r = a.cmp(b);
            if (r < 0) {
                // Swap `a` and `b` to make `a` always bigger than `b`
                var t = a;
                a = b;
                b = t;
            } else if (r === 0 || b.cmpn(1) === 0) break;
            a.isub(b);
        }while (true);
        return b.iushln(shift);
    };
    // Invert number in the field F(num)
    BN.prototype.invm = function invm(num) {
        return this.egcd(num).a.umod(num);
    };
    BN.prototype.isEven = function isEven() {
        return (this.words[0] & 1) === 0;
    };
    BN.prototype.isOdd = function isOdd() {
        return (this.words[0] & 1) === 1;
    };
    // And first word and num
    BN.prototype.andln = function andln(num) {
        return this.words[0] & num;
    };
    // Increment at the bit position in-line
    BN.prototype.bincn = function bincn(bit) {
        assert(typeof bit === "number");
        var r = bit % 26;
        var s = (bit - r) / 26;
        var q = 1 << r;
        // Fast case: bit is much higher than all existing words
        if (this.length <= s) {
            this._expand(s + 1);
            this.words[s] |= q;
            return this;
        }
        // Add bit and propagate, if needed
        var carry = q;
        for(var i = s; carry !== 0 && i < this.length; i++){
            var w = this.words[i] | 0;
            w += carry;
            carry = w >>> 26;
            w &= 0x3ffffff;
            this.words[i] = w;
        }
        if (carry !== 0) {
            this.words[i] = carry;
            this.length++;
        }
        return this;
    };
    BN.prototype.isZero = function isZero() {
        return this.length === 1 && this.words[0] === 0;
    };
    BN.prototype.cmpn = function cmpn(num) {
        var negative = num < 0;
        if (this.negative !== 0 && !negative) return -1;
        if (this.negative === 0 && negative) return 1;
        this._strip();
        var res;
        if (this.length > 1) res = 1;
        else {
            if (negative) num = -num;
            assert(num <= 0x3ffffff, "Number is too big");
            var w = this.words[0] | 0;
            res = w === num ? 0 : w < num ? -1 : 1;
        }
        if (this.negative !== 0) return -res | 0;
        return res;
    };
    // Compare two numbers and return:
    // 1 - if `this` > `num`
    // 0 - if `this` == `num`
    // -1 - if `this` < `num`
    BN.prototype.cmp = function cmp(num) {
        if (this.negative !== 0 && num.negative === 0) return -1;
        if (this.negative === 0 && num.negative !== 0) return 1;
        var res = this.ucmp(num);
        if (this.negative !== 0) return -res | 0;
        return res;
    };
    // Unsigned comparison
    BN.prototype.ucmp = function ucmp(num) {
        // At this point both numbers have the same sign
        if (this.length > num.length) return 1;
        if (this.length < num.length) return -1;
        var res = 0;
        for(var i = this.length - 1; i >= 0; i--){
            var a = this.words[i] | 0;
            var b = num.words[i] | 0;
            if (a === b) continue;
            if (a < b) res = -1;
            else if (a > b) res = 1;
            break;
        }
        return res;
    };
    BN.prototype.gtn = function gtn(num) {
        return this.cmpn(num) === 1;
    };
    BN.prototype.gt = function gt(num) {
        return this.cmp(num) === 1;
    };
    BN.prototype.gten = function gten(num) {
        return this.cmpn(num) >= 0;
    };
    BN.prototype.gte = function gte(num) {
        return this.cmp(num) >= 0;
    };
    BN.prototype.ltn = function ltn(num) {
        return this.cmpn(num) === -1;
    };
    BN.prototype.lt = function lt(num) {
        return this.cmp(num) === -1;
    };
    BN.prototype.lten = function lten(num) {
        return this.cmpn(num) <= 0;
    };
    BN.prototype.lte = function lte(num) {
        return this.cmp(num) <= 0;
    };
    BN.prototype.eqn = function eqn(num) {
        return this.cmpn(num) === 0;
    };
    BN.prototype.eq = function eq(num) {
        return this.cmp(num) === 0;
    };
    //
    // A reduce context, could be using montgomery or something better, depending
    // on the `m` itself.
    //
    BN.red = function red(num) {
        return new Red(num);
    };
    BN.prototype.toRed = function toRed(ctx) {
        assert(!this.red, "Already a number in reduction context");
        assert(this.negative === 0, "red works only with positives");
        return ctx.convertTo(this)._forceRed(ctx);
    };
    BN.prototype.fromRed = function fromRed() {
        assert(this.red, "fromRed works only with numbers in reduction context");
        return this.red.convertFrom(this);
    };
    BN.prototype._forceRed = function _forceRed(ctx) {
        this.red = ctx;
        return this;
    };
    BN.prototype.forceRed = function forceRed(ctx) {
        assert(!this.red, "Already a number in reduction context");
        return this._forceRed(ctx);
    };
    BN.prototype.redAdd = function redAdd(num) {
        assert(this.red, "redAdd works only with red numbers");
        return this.red.add(this, num);
    };
    BN.prototype.redIAdd = function redIAdd(num) {
        assert(this.red, "redIAdd works only with red numbers");
        return this.red.iadd(this, num);
    };
    BN.prototype.redSub = function redSub(num) {
        assert(this.red, "redSub works only with red numbers");
        return this.red.sub(this, num);
    };
    BN.prototype.redISub = function redISub(num) {
        assert(this.red, "redISub works only with red numbers");
        return this.red.isub(this, num);
    };
    BN.prototype.redShl = function redShl(num) {
        assert(this.red, "redShl works only with red numbers");
        return this.red.shl(this, num);
    };
    BN.prototype.redMul = function redMul(num) {
        assert(this.red, "redMul works only with red numbers");
        this.red._verify2(this, num);
        return this.red.mul(this, num);
    };
    BN.prototype.redIMul = function redIMul(num) {
        assert(this.red, "redMul works only with red numbers");
        this.red._verify2(this, num);
        return this.red.imul(this, num);
    };
    BN.prototype.redSqr = function redSqr() {
        assert(this.red, "redSqr works only with red numbers");
        this.red._verify1(this);
        return this.red.sqr(this);
    };
    BN.prototype.redISqr = function redISqr() {
        assert(this.red, "redISqr works only with red numbers");
        this.red._verify1(this);
        return this.red.isqr(this);
    };
    // Square root over p
    BN.prototype.redSqrt = function redSqrt() {
        assert(this.red, "redSqrt works only with red numbers");
        this.red._verify1(this);
        return this.red.sqrt(this);
    };
    BN.prototype.redInvm = function redInvm() {
        assert(this.red, "redInvm works only with red numbers");
        this.red._verify1(this);
        return this.red.invm(this);
    };
    // Return negative clone of `this` % `red modulo`
    BN.prototype.redNeg = function redNeg() {
        assert(this.red, "redNeg works only with red numbers");
        this.red._verify1(this);
        return this.red.neg(this);
    };
    BN.prototype.redPow = function redPow(num) {
        assert(this.red && !num.red, "redPow(normalNum)");
        this.red._verify1(this);
        return this.red.pow(this, num);
    };
    // Prime numbers with efficient reduction
    var primes = {
        k256: null,
        p224: null,
        p192: null,
        p25519: null
    };
    // Pseudo-Mersenne prime
    function MPrime(name, p) {
        // P = 2 ^ N - K
        this.name = name;
        this.p = new BN(p, 16);
        this.n = this.p.bitLength();
        this.k = new BN(1).iushln(this.n).isub(this.p);
        this.tmp = this._tmp();
    }
    MPrime.prototype._tmp = function _tmp() {
        var tmp = new BN(null);
        tmp.words = new Array(Math.ceil(this.n / 13));
        return tmp;
    };
    MPrime.prototype.ireduce = function ireduce(num) {
        // Assumes that `num` is less than `P^2`
        // num = HI * (2 ^ N - K) + HI * K + LO = HI * K + LO (mod P)
        var r = num;
        var rlen;
        do {
            this.split(r, this.tmp);
            r = this.imulK(r);
            r = r.iadd(this.tmp);
            rlen = r.bitLength();
        }while (rlen > this.n);
        var cmp = rlen < this.n ? -1 : r.ucmp(this.p);
        if (cmp === 0) {
            r.words[0] = 0;
            r.length = 1;
        } else if (cmp > 0) r.isub(this.p);
        else if (r.strip !== undefined) // r is a BN v4 instance
        r.strip();
        else // r is a BN v5 instance
        r._strip();
        return r;
    };
    MPrime.prototype.split = function split(input, out) {
        input.iushrn(this.n, 0, out);
    };
    MPrime.prototype.imulK = function imulK(num) {
        return num.imul(this.k);
    };
    function K256() {
        MPrime.call(this, "k256", "ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe fffffc2f");
    }
    inherits(K256, MPrime);
    K256.prototype.split = function split(input, output) {
        // 256 = 9 * 26 + 22
        var mask = 0x3fffff;
        var outLen = Math.min(input.length, 9);
        for(var i = 0; i < outLen; i++)output.words[i] = input.words[i];
        output.length = outLen;
        if (input.length <= 9) {
            input.words[0] = 0;
            input.length = 1;
            return;
        }
        // Shift by 9 limbs
        var prev = input.words[9];
        output.words[output.length++] = prev & mask;
        for(i = 10; i < input.length; i++){
            var next = input.words[i] | 0;
            input.words[i - 10] = (next & mask) << 4 | prev >>> 22;
            prev = next;
        }
        prev >>>= 22;
        input.words[i - 10] = prev;
        if (prev === 0 && input.length > 10) input.length -= 10;
        else input.length -= 9;
    };
    K256.prototype.imulK = function imulK(num) {
        // K = 0x1000003d1 = [ 0x40, 0x3d1 ]
        num.words[num.length] = 0;
        num.words[num.length + 1] = 0;
        num.length += 2;
        // bounded at: 0x40 * 0x3ffffff + 0x3d0 = 0x100000390
        var lo = 0;
        for(var i = 0; i < num.length; i++){
            var w = num.words[i] | 0;
            lo += w * 0x3d1;
            num.words[i] = lo & 0x3ffffff;
            lo = w * 0x40 + (lo / 0x4000000 | 0);
        }
        // Fast length reduction
        if (num.words[num.length - 1] === 0) {
            num.length--;
            if (num.words[num.length - 1] === 0) num.length--;
        }
        return num;
    };
    function P224() {
        MPrime.call(this, "p224", "ffffffff ffffffff ffffffff ffffffff 00000000 00000000 00000001");
    }
    inherits(P224, MPrime);
    function P192() {
        MPrime.call(this, "p192", "ffffffff ffffffff ffffffff fffffffe ffffffff ffffffff");
    }
    inherits(P192, MPrime);
    function P25519() {
        // 2 ^ 255 - 19
        MPrime.call(this, "25519", "7fffffffffffffff ffffffffffffffff ffffffffffffffff ffffffffffffffed");
    }
    inherits(P25519, MPrime);
    P25519.prototype.imulK = function imulK(num) {
        // K = 0x13
        var carry = 0;
        for(var i = 0; i < num.length; i++){
            var hi = (num.words[i] | 0) * 0x13 + carry;
            var lo = hi & 0x3ffffff;
            hi >>>= 26;
            num.words[i] = lo;
            carry = hi;
        }
        if (carry !== 0) num.words[num.length++] = carry;
        return num;
    };
    // Exported mostly for testing purposes, use plain name instead
    BN._prime = function prime(name) {
        // Cached version of prime
        if (primes[name]) return primes[name];
        var prime;
        if (name === "k256") prime = new K256();
        else if (name === "p224") prime = new P224();
        else if (name === "p192") prime = new P192();
        else if (name === "p25519") prime = new P25519();
        else throw new Error("Unknown prime " + name);
        primes[name] = prime;
        return prime;
    };
    //
    // Base reduction engine
    //
    function Red(m) {
        if (typeof m === "string") {
            var prime = BN._prime(m);
            this.m = prime.p;
            this.prime = prime;
        } else {
            assert(m.gtn(1), "modulus must be greater than 1");
            this.m = m;
            this.prime = null;
        }
    }
    Red.prototype._verify1 = function _verify1(a) {
        assert(a.negative === 0, "red works only with positives");
        assert(a.red, "red works only with red numbers");
    };
    Red.prototype._verify2 = function _verify2(a, b) {
        assert((a.negative | b.negative) === 0, "red works only with positives");
        assert(a.red && a.red === b.red, "red works only with red numbers");
    };
    Red.prototype.imod = function imod(a) {
        if (this.prime) return this.prime.ireduce(a)._forceRed(this);
        move(a, a.umod(this.m)._forceRed(this));
        return a;
    };
    Red.prototype.neg = function neg(a) {
        if (a.isZero()) return a.clone();
        return this.m.sub(a)._forceRed(this);
    };
    Red.prototype.add = function add(a, b) {
        this._verify2(a, b);
        var res = a.add(b);
        if (res.cmp(this.m) >= 0) res.isub(this.m);
        return res._forceRed(this);
    };
    Red.prototype.iadd = function iadd(a, b) {
        this._verify2(a, b);
        var res = a.iadd(b);
        if (res.cmp(this.m) >= 0) res.isub(this.m);
        return res;
    };
    Red.prototype.sub = function sub(a, b) {
        this._verify2(a, b);
        var res = a.sub(b);
        if (res.cmpn(0) < 0) res.iadd(this.m);
        return res._forceRed(this);
    };
    Red.prototype.isub = function isub(a, b) {
        this._verify2(a, b);
        var res = a.isub(b);
        if (res.cmpn(0) < 0) res.iadd(this.m);
        return res;
    };
    Red.prototype.shl = function shl(a, num) {
        this._verify1(a);
        return this.imod(a.ushln(num));
    };
    Red.prototype.imul = function imul(a, b) {
        this._verify2(a, b);
        return this.imod(a.imul(b));
    };
    Red.prototype.mul = function mul(a, b) {
        this._verify2(a, b);
        return this.imod(a.mul(b));
    };
    Red.prototype.isqr = function isqr(a) {
        return this.imul(a, a.clone());
    };
    Red.prototype.sqr = function sqr(a) {
        return this.mul(a, a);
    };
    Red.prototype.sqrt = function sqrt(a) {
        if (a.isZero()) return a.clone();
        var mod3 = this.m.andln(3);
        assert(mod3 % 2 === 1);
        // Fast case
        if (mod3 === 3) {
            var pow = this.m.add(new BN(1)).iushrn(2);
            return this.pow(a, pow);
        }
        // Tonelli-Shanks algorithm (Totally unoptimized and slow)
        //
        // Find Q and S, that Q * 2 ^ S = (P - 1)
        var q = this.m.subn(1);
        var s = 0;
        while(!q.isZero() && q.andln(1) === 0){
            s++;
            q.iushrn(1);
        }
        assert(!q.isZero());
        var one = new BN(1).toRed(this);
        var nOne = one.redNeg();
        // Find quadratic non-residue
        // NOTE: Max is such because of generalized Riemann hypothesis.
        var lpow = this.m.subn(1).iushrn(1);
        var z = this.m.bitLength();
        z = new BN(2 * z * z).toRed(this);
        while(this.pow(z, lpow).cmp(nOne) !== 0)z.redIAdd(nOne);
        var c = this.pow(z, q);
        var r = this.pow(a, q.addn(1).iushrn(1));
        var t = this.pow(a, q);
        var m = s;
        while(t.cmp(one) !== 0){
            var tmp = t;
            for(var i = 0; tmp.cmp(one) !== 0; i++)tmp = tmp.redSqr();
            assert(i < m);
            var b = this.pow(c, new BN(1).iushln(m - i - 1));
            r = r.redMul(b);
            c = b.redSqr();
            t = t.redMul(c);
            m = i;
        }
        return r;
    };
    Red.prototype.invm = function invm(a) {
        var inv = a._invmp(this.m);
        if (inv.negative !== 0) {
            inv.negative = 0;
            return this.imod(inv).redNeg();
        } else return this.imod(inv);
    };
    Red.prototype.pow = function pow(a, num) {
        if (num.isZero()) return new BN(1).toRed(this);
        if (num.cmpn(1) === 0) return a.clone();
        var windowSize = 4;
        var wnd = new Array(1 << windowSize);
        wnd[0] = new BN(1).toRed(this);
        wnd[1] = a;
        for(var i = 2; i < wnd.length; i++)wnd[i] = this.mul(wnd[i - 1], a);
        var res = wnd[0];
        var current = 0;
        var currentLen = 0;
        var start = num.bitLength() % 26;
        if (start === 0) start = 26;
        for(i = num.length - 1; i >= 0; i--){
            var word = num.words[i];
            for(var j = start - 1; j >= 0; j--){
                var bit = word >> j & 1;
                if (res !== wnd[0]) res = this.sqr(res);
                if (bit === 0 && current === 0) {
                    currentLen = 0;
                    continue;
                }
                current <<= 1;
                current |= bit;
                currentLen++;
                if (currentLen !== windowSize && (i !== 0 || j !== 0)) continue;
                res = this.mul(res, wnd[current]);
                currentLen = 0;
                current = 0;
            }
            start = 26;
        }
        return res;
    };
    Red.prototype.convertTo = function convertTo(num) {
        var r = num.umod(this.m);
        return r === num ? r.clone() : r;
    };
    Red.prototype.convertFrom = function convertFrom(num) {
        var res = num.clone();
        res.red = null;
        return res;
    };
    //
    // Montgomery method engine
    //
    BN.mont = function mont(num) {
        return new Mont(num);
    };
    function Mont(m) {
        Red.call(this, m);
        this.shift = this.m.bitLength();
        if (this.shift % 26 !== 0) this.shift += 26 - this.shift % 26;
        this.r = new BN(1).iushln(this.shift);
        this.r2 = this.imod(this.r.sqr());
        this.rinv = this.r._invmp(this.m);
        this.minv = this.rinv.mul(this.r).isubn(1).div(this.m);
        this.minv = this.minv.umod(this.r);
        this.minv = this.r.sub(this.minv);
    }
    inherits(Mont, Red);
    Mont.prototype.convertTo = function convertTo(num) {
        return this.imod(num.ushln(this.shift));
    };
    Mont.prototype.convertFrom = function convertFrom(num) {
        var r = this.imod(num.mul(this.rinv));
        r.red = null;
        return r;
    };
    Mont.prototype.imul = function imul(a, b) {
        if (a.isZero() || b.isZero()) {
            a.words[0] = 0;
            a.length = 1;
            return a;
        }
        var t = a.imul(b);
        var c = t.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m);
        var u = t.isub(c).iushrn(this.shift);
        var res = u;
        if (u.cmp(this.m) >= 0) res = u.isub(this.m);
        else if (u.cmpn(0) < 0) res = u.iadd(this.m);
        return res._forceRed(this);
    };
    Mont.prototype.mul = function mul(a, b) {
        if (a.isZero() || b.isZero()) return new BN(0)._forceRed(this);
        var t = a.mul(b);
        var c = t.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m);
        var u = t.isub(c).iushrn(this.shift);
        var res = u;
        if (u.cmp(this.m) >= 0) res = u.isub(this.m);
        else if (u.cmpn(0) < 0) res = u.iadd(this.m);
        return res._forceRed(this);
    };
    Mont.prototype.invm = function invm(a) {
        // (AR)^-1 * R^2 = (A^-1 * R^-1) * R^2 = A^-1 * R
        var res = this.imod(a._invmp(this.m).mul(this.r2));
        return res._forceRed(this);
    };
})(module, this);

});
parcelRegister("kjyEk", function(module, exports) {
"use strict";

});


parcelRegister("4UTkl", function(module, exports) {

var $0DhcF = parcelRequire("0DhcF");
var $39474f2e0b7869f0$var$ALPHABET = "123456789ABCDEFGHJKLMNPQRSTUVWXYZabcdefghijkmnopqrstuvwxyz";
module.exports = $0DhcF($39474f2e0b7869f0$var$ALPHABET);

});
parcelRegister("0DhcF", function(module, exports) {
"use strict";

var $1U9GM = parcelRequire("1U9GM");
var $001e77b0dfd1bf3d$require$_Buffer = $1U9GM.Buffer;
function $001e77b0dfd1bf3d$var$base(ALPHABET) {
    if (ALPHABET.length >= 255) throw new TypeError("Alphabet too long");
    var BASE_MAP = new Uint8Array(256);
    for(var j = 0; j < BASE_MAP.length; j++)BASE_MAP[j] = 255;
    for(var i = 0; i < ALPHABET.length; i++){
        var x = ALPHABET.charAt(i);
        var xc = x.charCodeAt(0);
        if (BASE_MAP[xc] !== 255) throw new TypeError(x + " is ambiguous");
        BASE_MAP[xc] = i;
    }
    var BASE = ALPHABET.length;
    var LEADER = ALPHABET.charAt(0);
    var FACTOR = Math.log(BASE) / Math.log(256) // log(BASE) / log(256), rounded up
    ;
    var iFACTOR = Math.log(256) / Math.log(BASE) // log(256) / log(BASE), rounded up
    ;
    function encode(source) {
        if (Array.isArray(source) || source instanceof Uint8Array) source = $001e77b0dfd1bf3d$require$_Buffer.from(source);
        if (!$001e77b0dfd1bf3d$require$_Buffer.isBuffer(source)) throw new TypeError("Expected Buffer");
        if (source.length === 0) return "";
        // Skip & count leading zeroes.
        var zeroes = 0;
        var length = 0;
        var pbegin = 0;
        var pend = source.length;
        while(pbegin !== pend && source[pbegin] === 0){
            pbegin++;
            zeroes++;
        }
        // Allocate enough space in big-endian base58 representation.
        var size = (pend - pbegin) * iFACTOR + 1 >>> 0;
        var b58 = new Uint8Array(size);
        // Process the bytes.
        while(pbegin !== pend){
            var carry = source[pbegin];
            // Apply "b58 = b58 * 256 + ch".
            var i = 0;
            for(var it1 = size - 1; (carry !== 0 || i < length) && it1 !== -1; it1--, i++){
                carry += 256 * b58[it1] >>> 0;
                b58[it1] = carry % BASE >>> 0;
                carry = carry / BASE >>> 0;
            }
            if (carry !== 0) throw new Error("Non-zero carry");
            length = i;
            pbegin++;
        }
        // Skip leading zeroes in base58 result.
        var it2 = size - length;
        while(it2 !== size && b58[it2] === 0)it2++;
        // Translate the result into a string.
        var str = LEADER.repeat(zeroes);
        for(; it2 < size; ++it2)str += ALPHABET.charAt(b58[it2]);
        return str;
    }
    function decodeUnsafe(source) {
        if (typeof source !== "string") throw new TypeError("Expected String");
        if (source.length === 0) return $001e77b0dfd1bf3d$require$_Buffer.alloc(0);
        var psz = 0;
        // Skip and count leading '1's.
        var zeroes = 0;
        var length = 0;
        while(source[psz] === LEADER){
            zeroes++;
            psz++;
        }
        // Allocate enough space in big-endian base256 representation.
        var size = (source.length - psz) * FACTOR + 1 >>> 0 // log(58) / log(256), rounded up.
        ;
        var b256 = new Uint8Array(size);
        // Process the characters.
        while(source[psz]){
            // Decode character
            var carry = BASE_MAP[source.charCodeAt(psz)];
            // Invalid character
            if (carry === 255) return;
            var i = 0;
            for(var it3 = size - 1; (carry !== 0 || i < length) && it3 !== -1; it3--, i++){
                carry += BASE * b256[it3] >>> 0;
                b256[it3] = carry % 256 >>> 0;
                carry = carry / 256 >>> 0;
            }
            if (carry !== 0) throw new Error("Non-zero carry");
            length = i;
            psz++;
        }
        // Skip leading zeroes in b256.
        var it4 = size - length;
        while(it4 !== size && b256[it4] === 0)it4++;
        var vch = $001e77b0dfd1bf3d$require$_Buffer.allocUnsafe(zeroes + (size - it4));
        vch.fill(0x00, 0, zeroes);
        var j = zeroes;
        while(it4 !== size)vch[j++] = b256[it4++];
        return vch;
    }
    function decode(string) {
        var buffer = decodeUnsafe(string);
        if (buffer) return buffer;
        throw new Error("Non-base" + BASE + " character");
    }
    return {
        encode: encode,
        decodeUnsafe: decodeUnsafe,
        decode: decode
    };
}
module.exports = $001e77b0dfd1bf3d$var$base;

});
parcelRegister("1U9GM", function(module, exports) {
/*! safe-buffer. MIT License. Feross Aboukhadijeh <https://feross.org/opensource> */ /* eslint-disable node/no-deprecated-api */ 
var $6ZWSX = parcelRequire("6ZWSX");
var $1632896ed805433d$var$Buffer = $6ZWSX.Buffer;
// alternative to using Object.keys for old browsers
function $1632896ed805433d$var$copyProps(src, dst) {
    for(var key in src)dst[key] = src[key];
}
if ($1632896ed805433d$var$Buffer.from && $1632896ed805433d$var$Buffer.alloc && $1632896ed805433d$var$Buffer.allocUnsafe && $1632896ed805433d$var$Buffer.allocUnsafeSlow) module.exports = $6ZWSX;
else {
    // Copy properties from require('buffer')
    $1632896ed805433d$var$copyProps($6ZWSX, module.exports);
    module.exports.Buffer = $1632896ed805433d$var$SafeBuffer;
}
function $1632896ed805433d$var$SafeBuffer(arg, encodingOrOffset, length) {
    return $1632896ed805433d$var$Buffer(arg, encodingOrOffset, length);
}
$1632896ed805433d$var$SafeBuffer.prototype = Object.create($1632896ed805433d$var$Buffer.prototype);
// Copy static methods from Buffer
$1632896ed805433d$var$copyProps($1632896ed805433d$var$Buffer, $1632896ed805433d$var$SafeBuffer);
$1632896ed805433d$var$SafeBuffer.from = function(arg, encodingOrOffset, length) {
    if (typeof arg === "number") throw new TypeError("Argument must not be a number");
    return $1632896ed805433d$var$Buffer(arg, encodingOrOffset, length);
};
$1632896ed805433d$var$SafeBuffer.alloc = function(size, fill, encoding) {
    if (typeof size !== "number") throw new TypeError("Argument must be a number");
    var buf = $1632896ed805433d$var$Buffer(size);
    if (fill !== undefined) {
        if (typeof encoding === "string") buf.fill(fill, encoding);
        else buf.fill(fill);
    } else buf.fill(0);
    return buf;
};
$1632896ed805433d$var$SafeBuffer.allocUnsafe = function(size) {
    if (typeof size !== "number") throw new TypeError("Argument must be a number");
    return $1632896ed805433d$var$Buffer(size);
};
$1632896ed805433d$var$SafeBuffer.allocUnsafeSlow = function(size) {
    if (typeof size !== "number") throw new TypeError("Argument must be a number");
    return $6ZWSX.SlowBuffer(size);
};

});



parcelRegister("6XnWx", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.sha224 = module.exports.sha256 = void 0;

var $g9W9K = parcelRequire("g9W9K");

var $3Bcdj = parcelRequire("3Bcdj");
// SHA2-256 need to try 2^128 hashes to execute birthday attack.
// BTC network is doing 2^67 hashes/sec as per early 2023.
// Choice: a ? b : c
const $510ad3657d73a9d2$var$Chi = (a, b, c)=>a & b ^ ~a & c;
// Majority function, true if any two inpust is true
const $510ad3657d73a9d2$var$Maj = (a, b, c)=>a & b ^ a & c ^ b & c;
// Round constants:
// first 32 bits of the fractional parts of the cube roots of the first 64 primes 2..311)
// prettier-ignore
const $510ad3657d73a9d2$var$SHA256_K = /* @__PURE__ */ new Uint32Array([
    0x428a2f98,
    0x71374491,
    0xb5c0fbcf,
    0xe9b5dba5,
    0x3956c25b,
    0x59f111f1,
    0x923f82a4,
    0xab1c5ed5,
    0xd807aa98,
    0x12835b01,
    0x243185be,
    0x550c7dc3,
    0x72be5d74,
    0x80deb1fe,
    0x9bdc06a7,
    0xc19bf174,
    0xe49b69c1,
    0xefbe4786,
    0x0fc19dc6,
    0x240ca1cc,
    0x2de92c6f,
    0x4a7484aa,
    0x5cb0a9dc,
    0x76f988da,
    0x983e5152,
    0xa831c66d,
    0xb00327c8,
    0xbf597fc7,
    0xc6e00bf3,
    0xd5a79147,
    0x06ca6351,
    0x14292967,
    0x27b70a85,
    0x2e1b2138,
    0x4d2c6dfc,
    0x53380d13,
    0x650a7354,
    0x766a0abb,
    0x81c2c92e,
    0x92722c85,
    0xa2bfe8a1,
    0xa81a664b,
    0xc24b8b70,
    0xc76c51a3,
    0xd192e819,
    0xd6990624,
    0xf40e3585,
    0x106aa070,
    0x19a4c116,
    0x1e376c08,
    0x2748774c,
    0x34b0bcb5,
    0x391c0cb3,
    0x4ed8aa4a,
    0x5b9cca4f,
    0x682e6ff3,
    0x748f82ee,
    0x78a5636f,
    0x84c87814,
    0x8cc70208,
    0x90befffa,
    0xa4506ceb,
    0xbef9a3f7,
    0xc67178f2
]);
// Initial state (first 32 bits of the fractional parts of the square roots of the first 8 primes 2..19):
// prettier-ignore
const $510ad3657d73a9d2$var$IV = /* @__PURE__ */ new Uint32Array([
    0x6a09e667,
    0xbb67ae85,
    0x3c6ef372,
    0xa54ff53a,
    0x510e527f,
    0x9b05688c,
    0x1f83d9ab,
    0x5be0cd19
]);
// Temporary buffer, not used to store anything between runs
// Named this way because it matches specification.
const $510ad3657d73a9d2$var$SHA256_W = /* @__PURE__ */ new Uint32Array(64);
class $510ad3657d73a9d2$var$SHA256 extends $g9W9K.SHA2 {
    constructor(){
        super(64, 32, 8, false);
        // We cannot use array here since array allows indexing by variable
        // which means optimizer/compiler cannot use registers.
        this.A = $510ad3657d73a9d2$var$IV[0] | 0;
        this.B = $510ad3657d73a9d2$var$IV[1] | 0;
        this.C = $510ad3657d73a9d2$var$IV[2] | 0;
        this.D = $510ad3657d73a9d2$var$IV[3] | 0;
        this.E = $510ad3657d73a9d2$var$IV[4] | 0;
        this.F = $510ad3657d73a9d2$var$IV[5] | 0;
        this.G = $510ad3657d73a9d2$var$IV[6] | 0;
        this.H = $510ad3657d73a9d2$var$IV[7] | 0;
    }
    get() {
        const { A: A, B: B, C: C, D: D, E: E, F: F, G: G, H: H } = this;
        return [
            A,
            B,
            C,
            D,
            E,
            F,
            G,
            H
        ];
    }
    // prettier-ignore
    set(A, B, C, D, E, F, G, H) {
        this.A = A | 0;
        this.B = B | 0;
        this.C = C | 0;
        this.D = D | 0;
        this.E = E | 0;
        this.F = F | 0;
        this.G = G | 0;
        this.H = H | 0;
    }
    process(view, offset) {
        // Extend the first 16 words into the remaining 48 words w[16..63] of the message schedule array
        for(let i = 0; i < 16; i++, offset += 4)$510ad3657d73a9d2$var$SHA256_W[i] = view.getUint32(offset, false);
        for(let i = 16; i < 64; i++){
            const W15 = $510ad3657d73a9d2$var$SHA256_W[i - 15];
            const W2 = $510ad3657d73a9d2$var$SHA256_W[i - 2];
            const s0 = (0, $3Bcdj.rotr)(W15, 7) ^ (0, $3Bcdj.rotr)(W15, 18) ^ W15 >>> 3;
            const s1 = (0, $3Bcdj.rotr)(W2, 17) ^ (0, $3Bcdj.rotr)(W2, 19) ^ W2 >>> 10;
            $510ad3657d73a9d2$var$SHA256_W[i] = s1 + $510ad3657d73a9d2$var$SHA256_W[i - 7] + s0 + $510ad3657d73a9d2$var$SHA256_W[i - 16] | 0;
        }
        // Compression function main loop, 64 rounds
        let { A: A, B: B, C: C, D: D, E: E, F: F, G: G, H: H } = this;
        for(let i = 0; i < 64; i++){
            const sigma1 = (0, $3Bcdj.rotr)(E, 6) ^ (0, $3Bcdj.rotr)(E, 11) ^ (0, $3Bcdj.rotr)(E, 25);
            const T1 = H + sigma1 + $510ad3657d73a9d2$var$Chi(E, F, G) + $510ad3657d73a9d2$var$SHA256_K[i] + $510ad3657d73a9d2$var$SHA256_W[i] | 0;
            const sigma0 = (0, $3Bcdj.rotr)(A, 2) ^ (0, $3Bcdj.rotr)(A, 13) ^ (0, $3Bcdj.rotr)(A, 22);
            const T2 = sigma0 + $510ad3657d73a9d2$var$Maj(A, B, C) | 0;
            H = G;
            G = F;
            F = E;
            E = D + T1 | 0;
            D = C;
            C = B;
            B = A;
            A = T1 + T2 | 0;
        }
        // Add the compressed chunk to the current hash value
        A = A + this.A | 0;
        B = B + this.B | 0;
        C = C + this.C | 0;
        D = D + this.D | 0;
        E = E + this.E | 0;
        F = F + this.F | 0;
        G = G + this.G | 0;
        H = H + this.H | 0;
        this.set(A, B, C, D, E, F, G, H);
    }
    roundClean() {
        $510ad3657d73a9d2$var$SHA256_W.fill(0);
    }
    destroy() {
        this.set(0, 0, 0, 0, 0, 0, 0, 0);
        this.buffer.fill(0);
    }
}
// Constants from https://nvlpubs.nist.gov/nistpubs/FIPS/NIST.FIPS.180-4.pdf
class $510ad3657d73a9d2$var$SHA224 extends $510ad3657d73a9d2$var$SHA256 {
    constructor(){
        super();
        this.A = -1056596264;
        this.B = 914150663;
        this.C = 812702999;
        this.D = -150054599;
        this.E = -4191439;
        this.F = 1750603025;
        this.G = 1694076839;
        this.H = -1090891868;
        this.outputLen = 28;
    }
}
/**
 * SHA2-256 hash function
 * @param message - data that would be hashed
 */ module.exports.sha256 = (0, $3Bcdj.wrapConstructor)(()=>new $510ad3657d73a9d2$var$SHA256());
module.exports.sha224 = (0, $3Bcdj.wrapConstructor)(()=>new $510ad3657d73a9d2$var$SHA224());

});

parcelRegister("75BJw", function(module, exports) {

var $6ZWSX = parcelRequire("6ZWSX");
var $5296450c35a171ab$require$Buffer = $6ZWSX.Buffer;
"use strict";
var $5296450c35a171ab$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, {
        enumerable: true,
        get: function() {
            return m[k];
        }
    });
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $5296450c35a171ab$var$__setModuleDefault = module.exports && module.exports.__setModuleDefault || (Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
});
var $5296450c35a171ab$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var $5296450c35a171ab$var$__importStar = module.exports && module.exports.__importStar || function(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.hasOwnProperty.call(mod, k)) $5296450c35a171ab$var$__createBinding(result, mod, k);
    }
    $5296450c35a171ab$var$__setModuleDefault(result, mod);
    return result;
};
var $5296450c35a171ab$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.deserializeUnchecked = module.exports.deserialize = module.exports.serialize = module.exports.BinaryReader = module.exports.BinaryWriter = module.exports.BorshError = module.exports.baseDecode = module.exports.baseEncode = void 0;

const $5296450c35a171ab$var$bn_js_1 = $5296450c35a171ab$var$__importDefault((parcelRequire("dEXSZ")));

const $5296450c35a171ab$var$bs58_1 = $5296450c35a171ab$var$__importDefault((parcelRequire("89V9C")));

// TODO: Make sure this polyfill not included when not required
const $5296450c35a171ab$var$encoding = $5296450c35a171ab$var$__importStar((parcelRequire("kOaA4")));
const $5296450c35a171ab$var$ResolvedTextDecoder = typeof TextDecoder !== "function" ? $5296450c35a171ab$var$encoding.TextDecoder : TextDecoder;
const $5296450c35a171ab$var$textDecoder = new $5296450c35a171ab$var$ResolvedTextDecoder("utf-8", {
    fatal: true
});
function $5296450c35a171ab$var$baseEncode(value) {
    if (typeof value === "string") value = $5296450c35a171ab$require$Buffer.from(value, "utf8");
    return $5296450c35a171ab$var$bs58_1.default.encode($5296450c35a171ab$require$Buffer.from(value));
}
module.exports.baseEncode = $5296450c35a171ab$var$baseEncode;
function $5296450c35a171ab$var$baseDecode(value) {
    return $5296450c35a171ab$require$Buffer.from($5296450c35a171ab$var$bs58_1.default.decode(value));
}
module.exports.baseDecode = $5296450c35a171ab$var$baseDecode;
const $5296450c35a171ab$var$INITIAL_LENGTH = 1024;
class $5296450c35a171ab$var$BorshError extends Error {
    constructor(message){
        super(message);
        this.fieldPath = [];
        this.originalMessage = message;
    }
    addToFieldPath(fieldName) {
        this.fieldPath.splice(0, 0, fieldName);
        // NOTE: Modifying message directly as jest doesn't use .toString()
        this.message = this.originalMessage + ": " + this.fieldPath.join(".");
    }
}
module.exports.BorshError = $5296450c35a171ab$var$BorshError;
/// Binary encoder.
class $5296450c35a171ab$var$BinaryWriter {
    constructor(){
        this.buf = $5296450c35a171ab$require$Buffer.alloc($5296450c35a171ab$var$INITIAL_LENGTH);
        this.length = 0;
    }
    maybeResize() {
        if (this.buf.length < 16 + this.length) this.buf = $5296450c35a171ab$require$Buffer.concat([
            this.buf,
            $5296450c35a171ab$require$Buffer.alloc($5296450c35a171ab$var$INITIAL_LENGTH)
        ]);
    }
    writeU8(value) {
        this.maybeResize();
        this.buf.writeUInt8(value, this.length);
        this.length += 1;
    }
    writeU16(value) {
        this.maybeResize();
        this.buf.writeUInt16LE(value, this.length);
        this.length += 2;
    }
    writeU32(value) {
        this.maybeResize();
        this.buf.writeUInt32LE(value, this.length);
        this.length += 4;
    }
    writeU64(value) {
        this.maybeResize();
        this.writeBuffer($5296450c35a171ab$require$Buffer.from(new $5296450c35a171ab$var$bn_js_1.default(value).toArray("le", 8)));
    }
    writeU128(value) {
        this.maybeResize();
        this.writeBuffer($5296450c35a171ab$require$Buffer.from(new $5296450c35a171ab$var$bn_js_1.default(value).toArray("le", 16)));
    }
    writeU256(value) {
        this.maybeResize();
        this.writeBuffer($5296450c35a171ab$require$Buffer.from(new $5296450c35a171ab$var$bn_js_1.default(value).toArray("le", 32)));
    }
    writeU512(value) {
        this.maybeResize();
        this.writeBuffer($5296450c35a171ab$require$Buffer.from(new $5296450c35a171ab$var$bn_js_1.default(value).toArray("le", 64)));
    }
    writeBuffer(buffer) {
        // Buffer.from is needed as this.buf.subarray can return plain Uint8Array in browser
        this.buf = $5296450c35a171ab$require$Buffer.concat([
            $5296450c35a171ab$require$Buffer.from(this.buf.subarray(0, this.length)),
            buffer,
            $5296450c35a171ab$require$Buffer.alloc($5296450c35a171ab$var$INITIAL_LENGTH)
        ]);
        this.length += buffer.length;
    }
    writeString(str) {
        this.maybeResize();
        const b = $5296450c35a171ab$require$Buffer.from(str, "utf8");
        this.writeU32(b.length);
        this.writeBuffer(b);
    }
    writeFixedArray(array) {
        this.writeBuffer($5296450c35a171ab$require$Buffer.from(array));
    }
    writeArray(array, fn) {
        this.maybeResize();
        this.writeU32(array.length);
        for (const elem of array){
            this.maybeResize();
            fn(elem);
        }
    }
    toArray() {
        return this.buf.subarray(0, this.length);
    }
}
module.exports.BinaryWriter = $5296450c35a171ab$var$BinaryWriter;
function $5296450c35a171ab$var$handlingRangeError(target, propertyKey, propertyDescriptor) {
    const originalMethod = propertyDescriptor.value;
    propertyDescriptor.value = function(...args) {
        try {
            return originalMethod.apply(this, args);
        } catch (e) {
            if (e instanceof RangeError) {
                const code = e.code;
                if ([
                    "ERR_BUFFER_OUT_OF_BOUNDS",
                    "ERR_OUT_OF_RANGE"
                ].indexOf(code) >= 0) throw new $5296450c35a171ab$var$BorshError("Reached the end of buffer when deserializing");
            }
            throw e;
        }
    };
}
class $5296450c35a171ab$var$BinaryReader {
    constructor(buf){
        this.buf = buf;
        this.offset = 0;
    }
    readU8() {
        const value = this.buf.readUInt8(this.offset);
        this.offset += 1;
        return value;
    }
    readU16() {
        const value = this.buf.readUInt16LE(this.offset);
        this.offset += 2;
        return value;
    }
    readU32() {
        const value = this.buf.readUInt32LE(this.offset);
        this.offset += 4;
        return value;
    }
    readU64() {
        const buf = this.readBuffer(8);
        return new $5296450c35a171ab$var$bn_js_1.default(buf, "le");
    }
    readU128() {
        const buf = this.readBuffer(16);
        return new $5296450c35a171ab$var$bn_js_1.default(buf, "le");
    }
    readU256() {
        const buf = this.readBuffer(32);
        return new $5296450c35a171ab$var$bn_js_1.default(buf, "le");
    }
    readU512() {
        const buf = this.readBuffer(64);
        return new $5296450c35a171ab$var$bn_js_1.default(buf, "le");
    }
    readBuffer(len) {
        if (this.offset + len > this.buf.length) throw new $5296450c35a171ab$var$BorshError(`Expected buffer length ${len} isn't within bounds`);
        const result = this.buf.slice(this.offset, this.offset + len);
        this.offset += len;
        return result;
    }
    readString() {
        const len = this.readU32();
        const buf = this.readBuffer(len);
        try {
            // NOTE: Using TextDecoder to fail on invalid UTF-8
            return $5296450c35a171ab$var$textDecoder.decode(buf);
        } catch (e) {
            throw new $5296450c35a171ab$var$BorshError(`Error decoding UTF-8 string: ${e}`);
        }
    }
    readFixedArray(len) {
        return new Uint8Array(this.readBuffer(len));
    }
    readArray(fn) {
        const len = this.readU32();
        const result = Array();
        for(let i = 0; i < len; ++i)result.push(fn());
        return result;
    }
}
$5296450c35a171ab$var$__decorate([
    $5296450c35a171ab$var$handlingRangeError
], $5296450c35a171ab$var$BinaryReader.prototype, "readU8", null);
$5296450c35a171ab$var$__decorate([
    $5296450c35a171ab$var$handlingRangeError
], $5296450c35a171ab$var$BinaryReader.prototype, "readU16", null);
$5296450c35a171ab$var$__decorate([
    $5296450c35a171ab$var$handlingRangeError
], $5296450c35a171ab$var$BinaryReader.prototype, "readU32", null);
$5296450c35a171ab$var$__decorate([
    $5296450c35a171ab$var$handlingRangeError
], $5296450c35a171ab$var$BinaryReader.prototype, "readU64", null);
$5296450c35a171ab$var$__decorate([
    $5296450c35a171ab$var$handlingRangeError
], $5296450c35a171ab$var$BinaryReader.prototype, "readU128", null);
$5296450c35a171ab$var$__decorate([
    $5296450c35a171ab$var$handlingRangeError
], $5296450c35a171ab$var$BinaryReader.prototype, "readU256", null);
$5296450c35a171ab$var$__decorate([
    $5296450c35a171ab$var$handlingRangeError
], $5296450c35a171ab$var$BinaryReader.prototype, "readU512", null);
$5296450c35a171ab$var$__decorate([
    $5296450c35a171ab$var$handlingRangeError
], $5296450c35a171ab$var$BinaryReader.prototype, "readString", null);
$5296450c35a171ab$var$__decorate([
    $5296450c35a171ab$var$handlingRangeError
], $5296450c35a171ab$var$BinaryReader.prototype, "readFixedArray", null);
$5296450c35a171ab$var$__decorate([
    $5296450c35a171ab$var$handlingRangeError
], $5296450c35a171ab$var$BinaryReader.prototype, "readArray", null);
module.exports.BinaryReader = $5296450c35a171ab$var$BinaryReader;
function $5296450c35a171ab$var$capitalizeFirstLetter(string) {
    return string.charAt(0).toUpperCase() + string.slice(1);
}
function $5296450c35a171ab$var$serializeField(schema, fieldName, value, fieldType, writer) {
    try {
        // TODO: Handle missing values properly (make sure they never result in just skipped write)
        if (typeof fieldType === "string") writer[`write${$5296450c35a171ab$var$capitalizeFirstLetter(fieldType)}`](value);
        else if (fieldType instanceof Array) {
            if (typeof fieldType[0] === "number") {
                if (value.length !== fieldType[0]) throw new $5296450c35a171ab$var$BorshError(`Expecting byte array of length ${fieldType[0]}, but got ${value.length} bytes`);
                writer.writeFixedArray(value);
            } else if (fieldType.length === 2 && typeof fieldType[1] === "number") {
                if (value.length !== fieldType[1]) throw new $5296450c35a171ab$var$BorshError(`Expecting byte array of length ${fieldType[1]}, but got ${value.length} bytes`);
                for(let i = 0; i < fieldType[1]; i++)$5296450c35a171ab$var$serializeField(schema, null, value[i], fieldType[0], writer);
            } else writer.writeArray(value, (item)=>{
                $5296450c35a171ab$var$serializeField(schema, fieldName, item, fieldType[0], writer);
            });
        } else if (fieldType.kind !== undefined) switch(fieldType.kind){
            case "option":
                if (value === null || value === undefined) writer.writeU8(0);
                else {
                    writer.writeU8(1);
                    $5296450c35a171ab$var$serializeField(schema, fieldName, value, fieldType.type, writer);
                }
                break;
            case "map":
                writer.writeU32(value.size);
                value.forEach((val, key)=>{
                    $5296450c35a171ab$var$serializeField(schema, fieldName, key, fieldType.key, writer);
                    $5296450c35a171ab$var$serializeField(schema, fieldName, val, fieldType.value, writer);
                });
                break;
            default:
                throw new $5296450c35a171ab$var$BorshError(`FieldType ${fieldType} unrecognized`);
        }
        else $5296450c35a171ab$var$serializeStruct(schema, value, writer);
    } catch (error) {
        if (error instanceof $5296450c35a171ab$var$BorshError) error.addToFieldPath(fieldName);
        throw error;
    }
}
function $5296450c35a171ab$var$serializeStruct(schema, obj, writer) {
    if (typeof obj.borshSerialize === "function") {
        obj.borshSerialize(writer);
        return;
    }
    const structSchema = schema.get(obj.constructor);
    if (!structSchema) throw new $5296450c35a171ab$var$BorshError(`Class ${obj.constructor.name} is missing in schema`);
    if (structSchema.kind === "struct") structSchema.fields.map(([fieldName, fieldType])=>{
        $5296450c35a171ab$var$serializeField(schema, fieldName, obj[fieldName], fieldType, writer);
    });
    else if (structSchema.kind === "enum") {
        const name = obj[structSchema.field];
        for(let idx = 0; idx < structSchema.values.length; ++idx){
            const [fieldName, fieldType] = structSchema.values[idx];
            if (fieldName === name) {
                writer.writeU8(idx);
                $5296450c35a171ab$var$serializeField(schema, fieldName, obj[fieldName], fieldType, writer);
                break;
            }
        }
    } else throw new $5296450c35a171ab$var$BorshError(`Unexpected schema kind: ${structSchema.kind} for ${obj.constructor.name}`);
}
/// Serialize given object using schema of the form:
/// { class_name -> [ [field_name, field_type], .. ], .. }
function $5296450c35a171ab$var$serialize(schema, obj, Writer = $5296450c35a171ab$var$BinaryWriter) {
    const writer = new Writer();
    $5296450c35a171ab$var$serializeStruct(schema, obj, writer);
    return writer.toArray();
}
module.exports.serialize = $5296450c35a171ab$var$serialize;
function $5296450c35a171ab$var$deserializeField(schema, fieldName, fieldType, reader) {
    try {
        if (typeof fieldType === "string") return reader[`read${$5296450c35a171ab$var$capitalizeFirstLetter(fieldType)}`]();
        if (fieldType instanceof Array) {
            if (typeof fieldType[0] === "number") return reader.readFixedArray(fieldType[0]);
            else if (typeof fieldType[1] === "number") {
                const arr = [];
                for(let i = 0; i < fieldType[1]; i++)arr.push($5296450c35a171ab$var$deserializeField(schema, null, fieldType[0], reader));
                return arr;
            } else return reader.readArray(()=>$5296450c35a171ab$var$deserializeField(schema, fieldName, fieldType[0], reader));
        }
        if (fieldType.kind === "option") {
            const option = reader.readU8();
            if (option) return $5296450c35a171ab$var$deserializeField(schema, fieldName, fieldType.type, reader);
            return undefined;
        }
        if (fieldType.kind === "map") {
            let map = new Map();
            const length = reader.readU32();
            for(let i = 0; i < length; i++){
                const key = $5296450c35a171ab$var$deserializeField(schema, fieldName, fieldType.key, reader);
                const val = $5296450c35a171ab$var$deserializeField(schema, fieldName, fieldType.value, reader);
                map.set(key, val);
            }
            return map;
        }
        return $5296450c35a171ab$var$deserializeStruct(schema, fieldType, reader);
    } catch (error) {
        if (error instanceof $5296450c35a171ab$var$BorshError) error.addToFieldPath(fieldName);
        throw error;
    }
}
function $5296450c35a171ab$var$deserializeStruct(schema, classType, reader) {
    if (typeof classType.borshDeserialize === "function") return classType.borshDeserialize(reader);
    const structSchema = schema.get(classType);
    if (!structSchema) throw new $5296450c35a171ab$var$BorshError(`Class ${classType.name} is missing in schema`);
    if (structSchema.kind === "struct") {
        const result = {};
        for (const [fieldName, fieldType] of schema.get(classType).fields)result[fieldName] = $5296450c35a171ab$var$deserializeField(schema, fieldName, fieldType, reader);
        return new classType(result);
    }
    if (structSchema.kind === "enum") {
        const idx = reader.readU8();
        if (idx >= structSchema.values.length) throw new $5296450c35a171ab$var$BorshError(`Enum index: ${idx} is out of range`);
        const [fieldName, fieldType] = structSchema.values[idx];
        const fieldValue = $5296450c35a171ab$var$deserializeField(schema, fieldName, fieldType, reader);
        return new classType({
            [fieldName]: fieldValue
        });
    }
    throw new $5296450c35a171ab$var$BorshError(`Unexpected schema kind: ${structSchema.kind} for ${classType.constructor.name}`);
}
/// Deserializes object from bytes using schema.
function $5296450c35a171ab$var$deserialize(schema, classType, buffer, Reader = $5296450c35a171ab$var$BinaryReader) {
    const reader = new Reader(buffer);
    const result = $5296450c35a171ab$var$deserializeStruct(schema, classType, reader);
    if (reader.offset < buffer.length) throw new $5296450c35a171ab$var$BorshError(`Unexpected ${buffer.length - reader.offset} bytes after deserialized data`);
    return result;
}
module.exports.deserialize = $5296450c35a171ab$var$deserialize;
/// Deserializes object from bytes using schema, without checking the length read
function $5296450c35a171ab$var$deserializeUnchecked(schema, classType, buffer, Reader = $5296450c35a171ab$var$BinaryReader) {
    const reader = new Reader(buffer);
    return $5296450c35a171ab$var$deserializeStruct(schema, classType, reader);
}
module.exports.deserializeUnchecked = $5296450c35a171ab$var$deserializeUnchecked;

});
parcelRegister("89V9C", function(module, exports) {

var $0DhcF = parcelRequire("0DhcF");
var $5f0b7fa097add6fe$var$ALPHABET = "123456789ABCDEFGHJKLMNPQRSTUVWXYZabcdefghijkmnopqrstuvwxyz";
module.exports = $0DhcF($5f0b7fa097add6fe$var$ALPHABET);

});

parcelRegister("kOaA4", function(module, exports) {

$parcel$export(module.exports, "TextEncoder", () => $f260af419b27244f$export$88fb0cfd153261a7, (v) => $f260af419b27244f$export$88fb0cfd153261a7 = v);
$parcel$export(module.exports, "TextDecoder", () => $f260af419b27244f$export$9c6b53e35bc51b5c, (v) => $f260af419b27244f$export$9c6b53e35bc51b5c = v);
var $f260af419b27244f$export$88fb0cfd153261a7;
var $f260af419b27244f$export$9c6b53e35bc51b5c;
"use strict";
// This is free and unencumbered software released into the public domain.
// See LICENSE.md for more information.
//
// Utilities
//
/**
 * @param {number} a The number to test.
 * @param {number} min The minimum value in the range, inclusive.
 * @param {number} max The maximum value in the range, inclusive.
 * @return {boolean} True if a >= min and a <= max.
 */ function $f260af419b27244f$var$inRange(a, min, max) {
    return min <= a && a <= max;
}
/**
 * @param {*} o
 * @return {Object}
 */ function $f260af419b27244f$var$ToDictionary(o) {
    if (o === undefined) return {};
    if (o === Object(o)) return o;
    throw TypeError("Could not convert argument to dictionary");
}
/**
 * @param {string} string Input string of UTF-16 code units.
 * @return {!Array.<number>} Code points.
 */ function $f260af419b27244f$var$stringToCodePoints(string) {
    // https://heycam.github.io/webidl/#dfn-obtain-unicode
    // 1. Let S be the DOMString value.
    var s = String(string);
    // 2. Let n be the length of S.
    var n = s.length;
    // 3. Initialize i to 0.
    var i = 0;
    // 4. Initialize U to be an empty sequence of Unicode characters.
    var u = [];
    // 5. While i < n:
    while(i < n){
        // 1. Let c be the code unit in S at index i.
        var c = s.charCodeAt(i);
        // 2. Depending on the value of c:
        // c < 0xD800 or c > 0xDFFF
        if (c < 0xD800 || c > 0xDFFF) // Append to U the Unicode character with code point c.
        u.push(c);
        else if (0xDC00 <= c && c <= 0xDFFF) // Append to U a U+FFFD REPLACEMENT CHARACTER.
        u.push(0xFFFD);
        else if (0xD800 <= c && c <= 0xDBFF) {
            // 1. If i = n−1, then append to U a U+FFFD REPLACEMENT
            // CHARACTER.
            if (i === n - 1) u.push(0xFFFD);
            else {
                // 1. Let d be the code unit in S at index i+1.
                var d = string.charCodeAt(i + 1);
                // 2. If 0xDC00 ≤ d ≤ 0xDFFF, then:
                if (0xDC00 <= d && d <= 0xDFFF) {
                    // 1. Let a be c & 0x3FF.
                    var a = c & 0x3FF;
                    // 2. Let b be d & 0x3FF.
                    var b = d & 0x3FF;
                    // 3. Append to U the Unicode character with code point
                    // 2^16+2^10*a+b.
                    u.push(0x10000 + (a << 10) + b);
                    // 4. Set i to i+1.
                    i += 1;
                } else u.push(0xFFFD);
            }
        }
        // 3. Set i to i+1.
        i += 1;
    }
    // 6. Return U.
    return u;
}
/**
 * @param {!Array.<number>} code_points Array of code points.
 * @return {string} string String of UTF-16 code units.
 */ function $f260af419b27244f$var$codePointsToString(code_points) {
    var s = "";
    for(var i = 0; i < code_points.length; ++i){
        var cp = code_points[i];
        if (cp <= 0xFFFF) s += String.fromCharCode(cp);
        else {
            cp -= 0x10000;
            s += String.fromCharCode((cp >> 10) + 0xD800, (cp & 0x3FF) + 0xDC00);
        }
    }
    return s;
}
//
// Implementation of Encoding specification
// https://encoding.spec.whatwg.org/
//
//
// 3. Terminology
//
/**
 * End-of-stream is a special token that signifies no more tokens
 * are in the stream.
 * @const
 */ var $f260af419b27244f$var$end_of_stream = -1;
/**
 * A stream represents an ordered sequence of tokens.
 *
 * @constructor
 * @param {!(Array.<number>|Uint8Array)} tokens Array of tokens that provide the
 * stream.
 */ function $f260af419b27244f$var$Stream(tokens) {
    /** @type {!Array.<number>} */ this.tokens = [].slice.call(tokens);
}
$f260af419b27244f$var$Stream.prototype = {
    /**
   * @return {boolean} True if end-of-stream has been hit.
   */ endOfStream: function() {
        return !this.tokens.length;
    },
    /**
   * When a token is read from a stream, the first token in the
   * stream must be returned and subsequently removed, and
   * end-of-stream must be returned otherwise.
   *
   * @return {number} Get the next token from the stream, or
   * end_of_stream.
   */ read: function() {
        if (!this.tokens.length) return $f260af419b27244f$var$end_of_stream;
        return this.tokens.shift();
    },
    /**
   * When one or more tokens are prepended to a stream, those tokens
   * must be inserted, in given order, before the first token in the
   * stream.
   *
   * @param {(number|!Array.<number>)} token The token(s) to prepend to the stream.
   */ prepend: function(token) {
        if (Array.isArray(token)) {
            var tokens = /**@type {!Array.<number>}*/ token;
            while(tokens.length)this.tokens.unshift(tokens.pop());
        } else this.tokens.unshift(token);
    },
    /**
   * When one or more tokens are pushed to a stream, those tokens
   * must be inserted, in given order, after the last token in the
   * stream.
   *
   * @param {(number|!Array.<number>)} token The tokens(s) to prepend to the stream.
   */ push: function(token) {
        if (Array.isArray(token)) {
            var tokens = /**@type {!Array.<number>}*/ token;
            while(tokens.length)this.tokens.push(tokens.shift());
        } else this.tokens.push(token);
    }
};
//
// 4. Encodings
//
// 4.1 Encoders and decoders
/** @const */ var $f260af419b27244f$var$finished = -1;
/**
 * @param {boolean} fatal If true, decoding errors raise an exception.
 * @param {number=} opt_code_point Override the standard fallback code point.
 * @return {number} The code point to insert on a decoding error.
 */ function $f260af419b27244f$var$decoderError(fatal, opt_code_point) {
    if (fatal) throw TypeError("Decoder error");
    return opt_code_point || 0xFFFD;
}
//
// 7. API
//
/** @const */ var $f260af419b27244f$var$DEFAULT_ENCODING = "utf-8";
// 7.1 Interface TextDecoder
/**
 * @constructor
 * @param {string=} encoding The label of the encoding;
 *     defaults to 'utf-8'.
 * @param {Object=} options
 */ function $f260af419b27244f$var$TextDecoder(encoding, options) {
    if (!(this instanceof $f260af419b27244f$var$TextDecoder)) return new $f260af419b27244f$var$TextDecoder(encoding, options);
    encoding = encoding !== undefined ? String(encoding).toLowerCase() : $f260af419b27244f$var$DEFAULT_ENCODING;
    if (encoding !== $f260af419b27244f$var$DEFAULT_ENCODING) throw new Error("Encoding not supported. Only utf-8 is supported");
    options = $f260af419b27244f$var$ToDictionary(options);
    /** @private @type {boolean} */ this._streaming = false;
    /** @private @type {boolean} */ this._BOMseen = false;
    /** @private @type {?Decoder} */ this._decoder = null;
    /** @private @type {boolean} */ this._fatal = Boolean(options["fatal"]);
    /** @private @type {boolean} */ this._ignoreBOM = Boolean(options["ignoreBOM"]);
    Object.defineProperty(this, "encoding", {
        value: "utf-8"
    });
    Object.defineProperty(this, "fatal", {
        value: this._fatal
    });
    Object.defineProperty(this, "ignoreBOM", {
        value: this._ignoreBOM
    });
}
$f260af419b27244f$var$TextDecoder.prototype = {
    /**
   * @param {ArrayBufferView=} input The buffer of bytes to decode.
   * @param {Object=} options
   * @return {string} The decoded string.
   */ decode: function decode(input, options) {
        var bytes;
        if (typeof input === "object" && input instanceof ArrayBuffer) bytes = new Uint8Array(input);
        else if (typeof input === "object" && "buffer" in input && input.buffer instanceof ArrayBuffer) bytes = new Uint8Array(input.buffer, input.byteOffset, input.byteLength);
        else bytes = new Uint8Array(0);
        options = $f260af419b27244f$var$ToDictionary(options);
        if (!this._streaming) {
            this._decoder = new $f260af419b27244f$var$UTF8Decoder({
                fatal: this._fatal
            });
            this._BOMseen = false;
        }
        this._streaming = Boolean(options["stream"]);
        var input_stream = new $f260af419b27244f$var$Stream(bytes);
        var code_points = [];
        /** @type {?(number|!Array.<number>)} */ var result;
        while(!input_stream.endOfStream()){
            result = this._decoder.handler(input_stream, input_stream.read());
            if (result === $f260af419b27244f$var$finished) break;
            if (result === null) continue;
            if (Array.isArray(result)) code_points.push.apply(code_points, /**@type {!Array.<number>}*/ result);
            else code_points.push(result);
        }
        if (!this._streaming) {
            do {
                result = this._decoder.handler(input_stream, input_stream.read());
                if (result === $f260af419b27244f$var$finished) break;
                if (result === null) continue;
                if (Array.isArray(result)) code_points.push.apply(code_points, /**@type {!Array.<number>}*/ result);
                else code_points.push(result);
            }while (!input_stream.endOfStream());
            this._decoder = null;
        }
        if (code_points.length) // If encoding is one of utf-8, utf-16be, and utf-16le, and
        // ignore BOM flag and BOM seen flag are unset, run these
        // subsubsteps:
        {
            if ([
                "utf-8"
            ].indexOf(this.encoding) !== -1 && !this._ignoreBOM && !this._BOMseen) {
                // If token is U+FEFF, set BOM seen flag.
                if (code_points[0] === 0xFEFF) {
                    this._BOMseen = true;
                    code_points.shift();
                } else // Otherwise, if token is not end-of-stream, set BOM seen
                // flag and append token to output.
                this._BOMseen = true;
            }
        }
        return $f260af419b27244f$var$codePointsToString(code_points);
    }
};
// 7.2 Interface TextEncoder
/**
 * @constructor
 * @param {string=} encoding The label of the encoding;
 *     defaults to 'utf-8'.
 * @param {Object=} options
 */ function $f260af419b27244f$var$TextEncoder(encoding, options) {
    if (!(this instanceof $f260af419b27244f$var$TextEncoder)) return new $f260af419b27244f$var$TextEncoder(encoding, options);
    encoding = encoding !== undefined ? String(encoding).toLowerCase() : $f260af419b27244f$var$DEFAULT_ENCODING;
    if (encoding !== $f260af419b27244f$var$DEFAULT_ENCODING) throw new Error("Encoding not supported. Only utf-8 is supported");
    options = $f260af419b27244f$var$ToDictionary(options);
    /** @private @type {boolean} */ this._streaming = false;
    /** @private @type {?Encoder} */ this._encoder = null;
    /** @private @type {{fatal: boolean}} */ this._options = {
        fatal: Boolean(options["fatal"])
    };
    Object.defineProperty(this, "encoding", {
        value: "utf-8"
    });
}
$f260af419b27244f$var$TextEncoder.prototype = {
    /**
   * @param {string=} opt_string The string to encode.
   * @param {Object=} options
   * @return {Uint8Array} Encoded bytes, as a Uint8Array.
   */ encode: function encode(opt_string, options) {
        opt_string = opt_string ? String(opt_string) : "";
        options = $f260af419b27244f$var$ToDictionary(options);
        // NOTE: This option is nonstandard. None of the encodings
        // permitted for encoding (i.e. UTF-8, UTF-16) are stateful,
        // so streaming is not necessary.
        if (!this._streaming) this._encoder = new $f260af419b27244f$var$UTF8Encoder(this._options);
        this._streaming = Boolean(options["stream"]);
        var bytes = [];
        var input_stream = new $f260af419b27244f$var$Stream($f260af419b27244f$var$stringToCodePoints(opt_string));
        /** @type {?(number|!Array.<number>)} */ var result;
        while(!input_stream.endOfStream()){
            result = this._encoder.handler(input_stream, input_stream.read());
            if (result === $f260af419b27244f$var$finished) break;
            if (Array.isArray(result)) bytes.push.apply(bytes, /**@type {!Array.<number>}*/ result);
            else bytes.push(result);
        }
        if (!this._streaming) {
            while(true){
                result = this._encoder.handler(input_stream, input_stream.read());
                if (result === $f260af419b27244f$var$finished) break;
                if (Array.isArray(result)) bytes.push.apply(bytes, /**@type {!Array.<number>}*/ result);
                else bytes.push(result);
            }
            this._encoder = null;
        }
        return new Uint8Array(bytes);
    }
};
//
// 8. The encoding
//
// 8.1 utf-8
/**
 * @constructor
 * @implements {Decoder}
 * @param {{fatal: boolean}} options
 */ function $f260af419b27244f$var$UTF8Decoder(options) {
    var fatal = options.fatal;
    // utf-8's decoder's has an associated utf-8 code point, utf-8
    // bytes seen, and utf-8 bytes needed (all initially 0), a utf-8
    // lower boundary (initially 0x80), and a utf-8 upper boundary
    // (initially 0xBF).
    var /** @type {number} */ utf8_code_point = 0, /** @type {number} */ utf8_bytes_seen = 0, /** @type {number} */ utf8_bytes_needed = 0, /** @type {number} */ utf8_lower_boundary = 0x80, /** @type {number} */ utf8_upper_boundary = 0xBF;
    /**
   * @param {Stream} stream The stream of bytes being decoded.
   * @param {number} bite The next byte read from the stream.
   * @return {?(number|!Array.<number>)} The next code point(s)
   *     decoded, or null if not enough data exists in the input
   *     stream to decode a complete code point.
   */ this.handler = function(stream, bite) {
        // 1. If byte is end-of-stream and utf-8 bytes needed is not 0,
        // set utf-8 bytes needed to 0 and return error.
        if (bite === $f260af419b27244f$var$end_of_stream && utf8_bytes_needed !== 0) {
            utf8_bytes_needed = 0;
            return $f260af419b27244f$var$decoderError(fatal);
        }
        // 2. If byte is end-of-stream, return finished.
        if (bite === $f260af419b27244f$var$end_of_stream) return $f260af419b27244f$var$finished;
        // 3. If utf-8 bytes needed is 0, based on byte:
        if (utf8_bytes_needed === 0) {
            // 0x00 to 0x7F
            if ($f260af419b27244f$var$inRange(bite, 0x00, 0x7F)) // Return a code point whose value is byte.
            return bite;
            // 0xC2 to 0xDF
            if ($f260af419b27244f$var$inRange(bite, 0xC2, 0xDF)) {
                // Set utf-8 bytes needed to 1 and utf-8 code point to byte
                // − 0xC0.
                utf8_bytes_needed = 1;
                utf8_code_point = bite - 0xC0;
            } else if ($f260af419b27244f$var$inRange(bite, 0xE0, 0xEF)) {
                // 1. If byte is 0xE0, set utf-8 lower boundary to 0xA0.
                if (bite === 0xE0) utf8_lower_boundary = 0xA0;
                // 2. If byte is 0xED, set utf-8 upper boundary to 0x9F.
                if (bite === 0xED) utf8_upper_boundary = 0x9F;
                // 3. Set utf-8 bytes needed to 2 and utf-8 code point to
                // byte − 0xE0.
                utf8_bytes_needed = 2;
                utf8_code_point = bite - 0xE0;
            } else if ($f260af419b27244f$var$inRange(bite, 0xF0, 0xF4)) {
                // 1. If byte is 0xF0, set utf-8 lower boundary to 0x90.
                if (bite === 0xF0) utf8_lower_boundary = 0x90;
                // 2. If byte is 0xF4, set utf-8 upper boundary to 0x8F.
                if (bite === 0xF4) utf8_upper_boundary = 0x8F;
                // 3. Set utf-8 bytes needed to 3 and utf-8 code point to
                // byte − 0xF0.
                utf8_bytes_needed = 3;
                utf8_code_point = bite - 0xF0;
            } else // Return error.
            return $f260af419b27244f$var$decoderError(fatal);
            // Then (byte is in the range 0xC2 to 0xF4) set utf-8 code
            // point to utf-8 code point << (6 × utf-8 bytes needed) and
            // return continue.
            utf8_code_point = utf8_code_point << 6 * utf8_bytes_needed;
            return null;
        }
        // 4. If byte is not in the range utf-8 lower boundary to utf-8
        // upper boundary, run these substeps:
        if (!$f260af419b27244f$var$inRange(bite, utf8_lower_boundary, utf8_upper_boundary)) {
            // 1. Set utf-8 code point, utf-8 bytes needed, and utf-8
            // bytes seen to 0, set utf-8 lower boundary to 0x80, and set
            // utf-8 upper boundary to 0xBF.
            utf8_code_point = utf8_bytes_needed = utf8_bytes_seen = 0;
            utf8_lower_boundary = 0x80;
            utf8_upper_boundary = 0xBF;
            // 2. Prepend byte to stream.
            stream.prepend(bite);
            // 3. Return error.
            return $f260af419b27244f$var$decoderError(fatal);
        }
        // 5. Set utf-8 lower boundary to 0x80 and utf-8 upper boundary
        // to 0xBF.
        utf8_lower_boundary = 0x80;
        utf8_upper_boundary = 0xBF;
        // 6. Increase utf-8 bytes seen by one and set utf-8 code point
        // to utf-8 code point + (byte − 0x80) << (6 × (utf-8 bytes
        // needed − utf-8 bytes seen)).
        utf8_bytes_seen += 1;
        utf8_code_point += bite - 0x80 << 6 * (utf8_bytes_needed - utf8_bytes_seen);
        // 7. If utf-8 bytes seen is not equal to utf-8 bytes needed,
        // continue.
        if (utf8_bytes_seen !== utf8_bytes_needed) return null;
        // 8. Let code point be utf-8 code point.
        var code_point = utf8_code_point;
        // 9. Set utf-8 code point, utf-8 bytes needed, and utf-8 bytes
        // seen to 0.
        utf8_code_point = utf8_bytes_needed = utf8_bytes_seen = 0;
        // 10. Return a code point whose value is code point.
        return code_point;
    };
}
/**
 * @constructor
 * @implements {Encoder}
 * @param {{fatal: boolean}} options
 */ function $f260af419b27244f$var$UTF8Encoder(options) {
    var fatal = options.fatal;
    /**
   * @param {Stream} stream Input stream.
   * @param {number} code_point Next code point read from the stream.
   * @return {(number|!Array.<number>)} Byte(s) to emit.
   */ this.handler = function(stream, code_point) {
        // 1. If code point is end-of-stream, return finished.
        if (code_point === $f260af419b27244f$var$end_of_stream) return $f260af419b27244f$var$finished;
        // 2. If code point is in the range U+0000 to U+007F, return a
        // byte whose value is code point.
        if ($f260af419b27244f$var$inRange(code_point, 0x0000, 0x007f)) return code_point;
        // 3. Set count and offset based on the range code point is in:
        var count, offset;
        // U+0080 to U+07FF:    1 and 0xC0
        if ($f260af419b27244f$var$inRange(code_point, 0x0080, 0x07FF)) {
            count = 1;
            offset = 0xC0;
        } else if ($f260af419b27244f$var$inRange(code_point, 0x0800, 0xFFFF)) {
            count = 2;
            offset = 0xE0;
        } else if ($f260af419b27244f$var$inRange(code_point, 0x10000, 0x10FFFF)) {
            count = 3;
            offset = 0xF0;
        }
        // 4.Let bytes be a byte sequence whose first byte is (code
        // point >> (6 × count)) + offset.
        var bytes = [
            (code_point >> 6 * count) + offset
        ];
        // 5. Run these substeps while count is greater than 0:
        while(count > 0){
            // 1. Set temp to code point >> (6 × (count − 1)).
            var temp = code_point >> 6 * (count - 1);
            // 2. Append to bytes 0x80 | (temp & 0x3F).
            bytes.push(0x80 | temp & 0x3F);
            // 3. Decrease count by one.
            count -= 1;
        }
        // 6. Return bytes bytes, in order.
        return bytes;
    };
}
$f260af419b27244f$export$88fb0cfd153261a7 = $f260af419b27244f$var$TextEncoder;
$f260af419b27244f$export$9c6b53e35bc51b5c = $f260af419b27244f$var$TextDecoder;

});


parcelRegister("Q02IV", function(module, exports) {
/* The MIT License (MIT)
 *
 * Copyright 2015-2018 Peter A. Bigot
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in
 * all copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
 * THE SOFTWARE.
 */ /**
 * Support for translating between Uint8Array instances and JavaScript
 * native types.
 *
 * {@link module:Layout~Layout|Layout} is the basis of a class
 * hierarchy that associates property names with sequences of encoded
 * bytes.
 *
 * Layouts are supported for these scalar (numeric) types:
 * * {@link module:Layout~UInt|Unsigned integers in little-endian
 *   format} with {@link module:Layout.u8|8-bit}, {@link
 *   module:Layout.u16|16-bit}, {@link module:Layout.u24|24-bit},
 *   {@link module:Layout.u32|32-bit}, {@link
 *   module:Layout.u40|40-bit}, and {@link module:Layout.u48|48-bit}
 *   representation ranges;
 * * {@link module:Layout~UIntBE|Unsigned integers in big-endian
 *   format} with {@link module:Layout.u16be|16-bit}, {@link
 *   module:Layout.u24be|24-bit}, {@link module:Layout.u32be|32-bit},
 *   {@link module:Layout.u40be|40-bit}, and {@link
 *   module:Layout.u48be|48-bit} representation ranges;
 * * {@link module:Layout~Int|Signed integers in little-endian
 *   format} with {@link module:Layout.s8|8-bit}, {@link
 *   module:Layout.s16|16-bit}, {@link module:Layout.s24|24-bit},
 *   {@link module:Layout.s32|32-bit}, {@link
 *   module:Layout.s40|40-bit}, and {@link module:Layout.s48|48-bit}
 *   representation ranges;
 * * {@link module:Layout~IntBE|Signed integers in big-endian format}
 *   with {@link module:Layout.s16be|16-bit}, {@link
 *   module:Layout.s24be|24-bit}, {@link module:Layout.s32be|32-bit},
 *   {@link module:Layout.s40be|40-bit}, and {@link
 *   module:Layout.s48be|48-bit} representation ranges;
 * * 64-bit integral values that decode to an exact (if magnitude is
 *   less than 2^53) or nearby integral Number in {@link
 *   module:Layout.nu64|unsigned little-endian}, {@link
 *   module:Layout.nu64be|unsigned big-endian}, {@link
 *   module:Layout.ns64|signed little-endian}, and {@link
 *   module:Layout.ns64be|unsigned big-endian} encodings;
 * * 32-bit floating point values with {@link
 *   module:Layout.f32|little-endian} and {@link
 *   module:Layout.f32be|big-endian} representations;
 * * 64-bit floating point values with {@link
 *   module:Layout.f64|little-endian} and {@link
 *   module:Layout.f64be|big-endian} representations;
 * * {@link module:Layout.const|Constants} that take no space in the
 *   encoded expression.
 *
 * and for these aggregate types:
 * * {@link module:Layout.seq|Sequence}s of instances of a {@link
 *   module:Layout~Layout|Layout}, with JavaScript representation as
 *   an Array and constant or data-dependent {@link
 *   module:Layout~Sequence#count|length};
 * * {@link module:Layout.struct|Structure}s that aggregate a
 *   heterogeneous sequence of {@link module:Layout~Layout|Layout}
 *   instances, with JavaScript representation as an Object;
 * * {@link module:Layout.union|Union}s that support multiple {@link
 *   module:Layout~VariantLayout|variant layouts} over a fixed
 *   (padded) or variable (not padded) span of bytes, using an
 *   unsigned integer at the start of the data or a separate {@link
 *   module:Layout.unionLayoutDiscriminator|layout element} to
 *   determine which layout to use when interpreting the buffer
 *   contents;
 * * {@link module:Layout.bits|BitStructure}s that contain a sequence
 *   of individual {@link
 *   module:Layout~BitStructure#addField|BitField}s packed into an 8,
 *   16, 24, or 32-bit unsigned integer starting at the least- or
 *   most-significant bit;
 * * {@link module:Layout.cstr|C strings} of varying length;
 * * {@link module:Layout.blob|Blobs} of fixed- or variable-{@link
 *   module:Layout~Blob#length|length} raw data.
 *
 * All {@link module:Layout~Layout|Layout} instances are immutable
 * after construction, to prevent internal state from becoming
 * inconsistent.
 *
 * @local Layout
 * @local ExternalLayout
 * @local GreedyCount
 * @local OffsetLayout
 * @local UInt
 * @local UIntBE
 * @local Int
 * @local IntBE
 * @local NearUInt64
 * @local NearUInt64BE
 * @local NearInt64
 * @local NearInt64BE
 * @local Float
 * @local FloatBE
 * @local Double
 * @local DoubleBE
 * @local Sequence
 * @local Structure
 * @local UnionDiscriminator
 * @local UnionLayoutDiscriminator
 * @local Union
 * @local VariantLayout
 * @local BitStructure
 * @local BitField
 * @local Boolean
 * @local Blob
 * @local CString
 * @local Constant
 * @local bindConstructorLayout
 * @module Layout
 * @license MIT
 * @author Peter A. Bigot
 * @see {@link https://github.com/pabigot/buffer-layout|buffer-layout on GitHub}
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.s16 = module.exports.s8 = module.exports.nu64be = module.exports.u48be = module.exports.u40be = module.exports.u32be = module.exports.u24be = module.exports.u16be = module.exports.nu64 = module.exports.u48 = module.exports.u40 = module.exports.u32 = module.exports.u24 = module.exports.u16 = module.exports.u8 = module.exports.offset = module.exports.greedy = module.exports.Constant = module.exports.UTF8 = module.exports.CString = module.exports.Blob = module.exports.Boolean = module.exports.BitField = module.exports.BitStructure = module.exports.VariantLayout = module.exports.Union = module.exports.UnionLayoutDiscriminator = module.exports.UnionDiscriminator = module.exports.Structure = module.exports.Sequence = module.exports.DoubleBE = module.exports.Double = module.exports.FloatBE = module.exports.Float = module.exports.NearInt64BE = module.exports.NearInt64 = module.exports.NearUInt64BE = module.exports.NearUInt64 = module.exports.IntBE = module.exports.Int = module.exports.UIntBE = module.exports.UInt = module.exports.OffsetLayout = module.exports.GreedyCount = module.exports.ExternalLayout = module.exports.bindConstructorLayout = module.exports.nameWithProperty = module.exports.Layout = module.exports.uint8ArrayToBuffer = module.exports.checkUint8Array = void 0;
module.exports.constant = module.exports.utf8 = module.exports.cstr = module.exports.blob = module.exports.unionLayoutDiscriminator = module.exports.union = module.exports.seq = module.exports.bits = module.exports.struct = module.exports.f64be = module.exports.f64 = module.exports.f32be = module.exports.f32 = module.exports.ns64be = module.exports.s48be = module.exports.s40be = module.exports.s32be = module.exports.s24be = module.exports.s16be = module.exports.ns64 = module.exports.s48 = module.exports.s40 = module.exports.s32 = module.exports.s24 = void 0;

var $6ZWSX = parcelRequire("6ZWSX");
/* Check if a value is a Uint8Array.
 *
 * @ignore */ function $09c4e3f7de797447$var$checkUint8Array(b) {
    if (!(b instanceof Uint8Array)) throw new TypeError("b must be a Uint8Array");
}
module.exports.checkUint8Array = $09c4e3f7de797447$var$checkUint8Array;
/* Create a Buffer instance from a Uint8Array.
 *
 * @ignore */ function $09c4e3f7de797447$var$uint8ArrayToBuffer(b) {
    $09c4e3f7de797447$var$checkUint8Array(b);
    return $6ZWSX.Buffer.from(b.buffer, b.byteOffset, b.length);
}
module.exports.uint8ArrayToBuffer = $09c4e3f7de797447$var$uint8ArrayToBuffer;
/**
 * Base class for layout objects.
 *
 * **NOTE** This is an abstract base class; you can create instances
 * if it amuses you, but they won't support the {@link
 * Layout#encode|encode} or {@link Layout#decode|decode} functions.
 *
 * @param {Number} span - Initializer for {@link Layout#span|span}.  The
 * parameter must be an integer; a negative value signifies that the
 * span is {@link Layout#getSpan|value-specific}.
 *
 * @param {string} [property] - Initializer for {@link
 * Layout#property|property}.
 *
 * @abstract
 */ class $09c4e3f7de797447$var$Layout {
    constructor(span, property){
        if (!Number.isInteger(span)) throw new TypeError("span must be an integer");
        /** The span of the layout in bytes.
         *
         * Positive values are generally expected.
         *
         * Zero will only appear in {@link Constant}s and in {@link
         * Sequence}s where the {@link Sequence#count|count} is zero.
         *
         * A negative value indicates that the span is value-specific, and
         * must be obtained using {@link Layout#getSpan|getSpan}. */ this.span = span;
        /** The property name used when this layout is represented in an
         * Object.
         *
         * Used only for layouts that {@link Layout#decode|decode} to Object
         * instances.  If left undefined the span of the unnamed layout will
         * be treated as padding: it will not be mutated by {@link
         * Layout#encode|encode} nor represented as a property in the
         * decoded Object. */ this.property = property;
    }
    /** Function to create an Object into which decoded properties will
     * be written.
     *
     * Used only for layouts that {@link Layout#decode|decode} to Object
     * instances, which means:
     * * {@link Structure}
     * * {@link Union}
     * * {@link VariantLayout}
     * * {@link BitStructure}
     *
     * If left undefined the JavaScript representation of these layouts
     * will be Object instances.
     *
     * See {@link bindConstructorLayout}.
     */ makeDestinationObject() {
        return {};
    }
    /**
     * Calculate the span of a specific instance of a layout.
     *
     * @param {Uint8Array} b - the buffer that contains an encoded instance.
     *
     * @param {Number} [offset] - the offset at which the encoded instance
     * starts.  If absent a zero offset is inferred.
     *
     * @return {Number} - the number of bytes covered by the layout
     * instance.  If this method is not overridden in a subclass the
     * definition-time constant {@link Layout#span|span} will be
     * returned.
     *
     * @throws {RangeError} - if the length of the value cannot be
     * determined.
     */ getSpan(b, offset) {
        if (0 > this.span) throw new RangeError("indeterminate span");
        return this.span;
    }
    /**
     * Replicate the layout using a new property.
     *
     * This function must be used to get a structurally-equivalent layout
     * with a different name since all {@link Layout} instances are
     * immutable.
     *
     * **NOTE** This is a shallow copy.  All fields except {@link
     * Layout#property|property} are strictly equal to the origin layout.
     *
     * @param {String} property - the value for {@link
     * Layout#property|property} in the replica.
     *
     * @returns {Layout} - the copy with {@link Layout#property|property}
     * set to `property`.
     */ replicate(property) {
        const rv = Object.create(this.constructor.prototype);
        Object.assign(rv, this);
        rv.property = property;
        return rv;
    }
    /**
     * Create an object from layout properties and an array of values.
     *
     * **NOTE** This function returns `undefined` if invoked on a layout
     * that does not return its value as an Object.  Objects are
     * returned for things that are a {@link Structure}, which includes
     * {@link VariantLayout|variant layouts} if they are structures, and
     * excludes {@link Union}s.  If you want this feature for a union
     * you must use {@link Union.getVariant|getVariant} to select the
     * desired layout.
     *
     * @param {Array} values - an array of values that correspond to the
     * default order for properties.  As with {@link Layout#decode|decode}
     * layout elements that have no property name are skipped when
     * iterating over the array values.  Only the top-level properties are
     * assigned; arguments are not assigned to properties of contained
     * layouts.  Any unused values are ignored.
     *
     * @return {(Object|undefined)}
     */ fromArray(values) {
        return undefined;
    }
}
module.exports.Layout = $09c4e3f7de797447$var$Layout;
/* Provide text that carries a name (such as for a function that will
 * be throwing an error) annotated with the property of a given layout
 * (such as one for which the value was unacceptable).
 *
 * @ignore */ function $09c4e3f7de797447$var$nameWithProperty(name, lo) {
    if (lo.property) return name + "[" + lo.property + "]";
    return name;
}
module.exports.nameWithProperty = $09c4e3f7de797447$var$nameWithProperty;
/**
 * Augment a class so that instances can be encoded/decoded using a
 * given layout.
 *
 * Calling this function couples `Class` with `layout` in several ways:
 *
 * * `Class.layout_` becomes a static member property equal to `layout`;
 * * `layout.boundConstructor_` becomes a static member property equal
 *    to `Class`;
 * * The {@link Layout#makeDestinationObject|makeDestinationObject()}
 *   property of `layout` is set to a function that returns a `new
 *   Class()`;
 * * `Class.decode(b, offset)` becomes a static member function that
 *   delegates to {@link Layout#decode|layout.decode}.  The
 *   synthesized function may be captured and extended.
 * * `Class.prototype.encode(b, offset)` provides an instance member
 *   function that delegates to {@link Layout#encode|layout.encode}
 *   with `src` set to `this`.  The synthesized function may be
 *   captured and extended, but when the extension is invoked `this`
 *   must be explicitly bound to the instance.
 *
 * @param {class} Class - a JavaScript class with a nullary
 * constructor.
 *
 * @param {Layout} layout - the {@link Layout} instance used to encode
 * instances of `Class`.
 */ // `Class` must be a constructor Function, but the assignment of a `layout_` property to it makes it difficult to type
// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
function $09c4e3f7de797447$var$bindConstructorLayout(Class, layout) {
    if ("function" !== typeof Class) throw new TypeError("Class must be constructor");
    if (Object.prototype.hasOwnProperty.call(Class, "layout_")) throw new Error("Class is already bound to a layout");
    if (!(layout && layout instanceof $09c4e3f7de797447$var$Layout)) throw new TypeError("layout must be a Layout");
    if (Object.prototype.hasOwnProperty.call(layout, "boundConstructor_")) throw new Error("layout is already bound to a constructor");
    Class.layout_ = layout;
    layout.boundConstructor_ = Class;
    layout.makeDestinationObject = ()=>new Class();
    Object.defineProperty(Class.prototype, "encode", {
        value (b, offset) {
            return layout.encode(this, b, offset);
        },
        writable: true
    });
    Object.defineProperty(Class, "decode", {
        value (b, offset) {
            return layout.decode(b, offset);
        },
        writable: true
    });
}
module.exports.bindConstructorLayout = $09c4e3f7de797447$var$bindConstructorLayout;
/**
 * An object that behaves like a layout but does not consume space
 * within its containing layout.
 *
 * This is primarily used to obtain metadata about a member, such as a
 * {@link OffsetLayout} that can provide data about a {@link
 * Layout#getSpan|value-specific span}.
 *
 * **NOTE** This is an abstract base class; you can create instances
 * if it amuses you, but they won't support {@link
 * ExternalLayout#isCount|isCount} or other {@link Layout} functions.
 *
 * @param {Number} span - initializer for {@link Layout#span|span}.
 * The parameter can range from 1 through 6.
 *
 * @param {string} [property] - initializer for {@link
 * Layout#property|property}.
 *
 * @abstract
 * @augments {Layout}
 */ class $09c4e3f7de797447$var$ExternalLayout extends $09c4e3f7de797447$var$Layout {
    /**
     * Return `true` iff the external layout decodes to an unsigned
     * integer layout.
     *
     * In that case it can be used as the source of {@link
     * Sequence#count|Sequence counts}, {@link Blob#length|Blob lengths},
     * or as {@link UnionLayoutDiscriminator#layout|external union
     * discriminators}.
     *
     * @abstract
     */ isCount() {
        throw new Error("ExternalLayout is abstract");
    }
}
module.exports.ExternalLayout = $09c4e3f7de797447$var$ExternalLayout;
/**
 * An {@link ExternalLayout} that determines its {@link
 * Layout#decode|value} based on offset into and length of the buffer
 * on which it is invoked.
 *
 * *Factory*: {@link module:Layout.greedy|greedy}
 *
 * @param {Number} [elementSpan] - initializer for {@link
 * GreedyCount#elementSpan|elementSpan}.
 *
 * @param {string} [property] - initializer for {@link
 * Layout#property|property}.
 *
 * @augments {ExternalLayout}
 */ class $09c4e3f7de797447$var$GreedyCount extends $09c4e3f7de797447$var$ExternalLayout {
    constructor(elementSpan = 1, property){
        if (!Number.isInteger(elementSpan) || 0 >= elementSpan) throw new TypeError("elementSpan must be a (positive) integer");
        super(-1, property);
        /** The layout for individual elements of the sequence.  The value
         * must be a positive integer.  If not provided, the value will be
         * 1. */ this.elementSpan = elementSpan;
    }
    /** @override */ isCount() {
        return true;
    }
    /** @override */ decode(b, offset = 0) {
        $09c4e3f7de797447$var$checkUint8Array(b);
        const rem = b.length - offset;
        return Math.floor(rem / this.elementSpan);
    }
    /** @override */ encode(src, b, offset) {
        return 0;
    }
}
module.exports.GreedyCount = $09c4e3f7de797447$var$GreedyCount;
/**
 * An {@link ExternalLayout} that supports accessing a {@link Layout}
 * at a fixed offset from the start of another Layout.  The offset may
 * be before, within, or after the base layout.
 *
 * *Factory*: {@link module:Layout.offset|offset}
 *
 * @param {Layout} layout - initializer for {@link
 * OffsetLayout#layout|layout}, modulo `property`.
 *
 * @param {Number} [offset] - Initializes {@link
 * OffsetLayout#offset|offset}.  Defaults to zero.
 *
 * @param {string} [property] - Optional new property name for a
 * {@link Layout#replicate| replica} of `layout` to be used as {@link
 * OffsetLayout#layout|layout}.  If not provided the `layout` is used
 * unchanged.
 *
 * @augments {Layout}
 */ class $09c4e3f7de797447$var$OffsetLayout extends $09c4e3f7de797447$var$ExternalLayout {
    constructor(layout, offset = 0, property){
        if (!(layout instanceof $09c4e3f7de797447$var$Layout)) throw new TypeError("layout must be a Layout");
        if (!Number.isInteger(offset)) throw new TypeError("offset must be integer or undefined");
        super(layout.span, property || layout.property);
        /** The subordinated layout. */ this.layout = layout;
        /** The location of {@link OffsetLayout#layout} relative to the
         * start of another layout.
         *
         * The value may be positive or negative, but an error will thrown
         * if at the point of use it goes outside the span of the Uint8Array
         * being accessed.  */ this.offset = offset;
    }
    /** @override */ isCount() {
        return this.layout instanceof $09c4e3f7de797447$var$UInt || this.layout instanceof $09c4e3f7de797447$var$UIntBE;
    }
    /** @override */ decode(b, offset = 0) {
        return this.layout.decode(b, offset + this.offset);
    }
    /** @override */ encode(src, b, offset = 0) {
        return this.layout.encode(src, b, offset + this.offset);
    }
}
module.exports.OffsetLayout = $09c4e3f7de797447$var$OffsetLayout;
/**
 * Represent an unsigned integer in little-endian format.
 *
 * *Factory*: {@link module:Layout.u8|u8}, {@link
 *  module:Layout.u16|u16}, {@link module:Layout.u24|u24}, {@link
 *  module:Layout.u32|u32}, {@link module:Layout.u40|u40}, {@link
 *  module:Layout.u48|u48}
 *
 * @param {Number} span - initializer for {@link Layout#span|span}.
 * The parameter can range from 1 through 6.
 *
 * @param {string} [property] - initializer for {@link
 * Layout#property|property}.
 *
 * @augments {Layout}
 */ class $09c4e3f7de797447$var$UInt extends $09c4e3f7de797447$var$Layout {
    constructor(span, property){
        super(span, property);
        if (6 < this.span) throw new RangeError("span must not exceed 6 bytes");
    }
    /** @override */ decode(b, offset = 0) {
        return $09c4e3f7de797447$var$uint8ArrayToBuffer(b).readUIntLE(offset, this.span);
    }
    /** @override */ encode(src, b, offset = 0) {
        $09c4e3f7de797447$var$uint8ArrayToBuffer(b).writeUIntLE(src, offset, this.span);
        return this.span;
    }
}
module.exports.UInt = $09c4e3f7de797447$var$UInt;
/**
 * Represent an unsigned integer in big-endian format.
 *
 * *Factory*: {@link module:Layout.u8be|u8be}, {@link
 * module:Layout.u16be|u16be}, {@link module:Layout.u24be|u24be},
 * {@link module:Layout.u32be|u32be}, {@link
 * module:Layout.u40be|u40be}, {@link module:Layout.u48be|u48be}
 *
 * @param {Number} span - initializer for {@link Layout#span|span}.
 * The parameter can range from 1 through 6.
 *
 * @param {string} [property] - initializer for {@link
 * Layout#property|property}.
 *
 * @augments {Layout}
 */ class $09c4e3f7de797447$var$UIntBE extends $09c4e3f7de797447$var$Layout {
    constructor(span, property){
        super(span, property);
        if (6 < this.span) throw new RangeError("span must not exceed 6 bytes");
    }
    /** @override */ decode(b, offset = 0) {
        return $09c4e3f7de797447$var$uint8ArrayToBuffer(b).readUIntBE(offset, this.span);
    }
    /** @override */ encode(src, b, offset = 0) {
        $09c4e3f7de797447$var$uint8ArrayToBuffer(b).writeUIntBE(src, offset, this.span);
        return this.span;
    }
}
module.exports.UIntBE = $09c4e3f7de797447$var$UIntBE;
/**
 * Represent a signed integer in little-endian format.
 *
 * *Factory*: {@link module:Layout.s8|s8}, {@link
 *  module:Layout.s16|s16}, {@link module:Layout.s24|s24}, {@link
 *  module:Layout.s32|s32}, {@link module:Layout.s40|s40}, {@link
 *  module:Layout.s48|s48}
 *
 * @param {Number} span - initializer for {@link Layout#span|span}.
 * The parameter can range from 1 through 6.
 *
 * @param {string} [property] - initializer for {@link
 * Layout#property|property}.
 *
 * @augments {Layout}
 */ class $09c4e3f7de797447$var$Int extends $09c4e3f7de797447$var$Layout {
    constructor(span, property){
        super(span, property);
        if (6 < this.span) throw new RangeError("span must not exceed 6 bytes");
    }
    /** @override */ decode(b, offset = 0) {
        return $09c4e3f7de797447$var$uint8ArrayToBuffer(b).readIntLE(offset, this.span);
    }
    /** @override */ encode(src, b, offset = 0) {
        $09c4e3f7de797447$var$uint8ArrayToBuffer(b).writeIntLE(src, offset, this.span);
        return this.span;
    }
}
module.exports.Int = $09c4e3f7de797447$var$Int;
/**
 * Represent a signed integer in big-endian format.
 *
 * *Factory*: {@link module:Layout.s8be|s8be}, {@link
 * module:Layout.s16be|s16be}, {@link module:Layout.s24be|s24be},
 * {@link module:Layout.s32be|s32be}, {@link
 * module:Layout.s40be|s40be}, {@link module:Layout.s48be|s48be}
 *
 * @param {Number} span - initializer for {@link Layout#span|span}.
 * The parameter can range from 1 through 6.
 *
 * @param {string} [property] - initializer for {@link
 * Layout#property|property}.
 *
 * @augments {Layout}
 */ class $09c4e3f7de797447$var$IntBE extends $09c4e3f7de797447$var$Layout {
    constructor(span, property){
        super(span, property);
        if (6 < this.span) throw new RangeError("span must not exceed 6 bytes");
    }
    /** @override */ decode(b, offset = 0) {
        return $09c4e3f7de797447$var$uint8ArrayToBuffer(b).readIntBE(offset, this.span);
    }
    /** @override */ encode(src, b, offset = 0) {
        $09c4e3f7de797447$var$uint8ArrayToBuffer(b).writeIntBE(src, offset, this.span);
        return this.span;
    }
}
module.exports.IntBE = $09c4e3f7de797447$var$IntBE;
const $09c4e3f7de797447$var$V2E32 = Math.pow(2, 32);
/* True modulus high and low 32-bit words, where low word is always
 * non-negative. */ function $09c4e3f7de797447$var$divmodInt64(src) {
    const hi32 = Math.floor(src / $09c4e3f7de797447$var$V2E32);
    const lo32 = src - hi32 * $09c4e3f7de797447$var$V2E32;
    return {
        hi32: hi32,
        lo32: lo32
    };
}
/* Reconstruct Number from quotient and non-negative remainder */ function $09c4e3f7de797447$var$roundedInt64(hi32, lo32) {
    return hi32 * $09c4e3f7de797447$var$V2E32 + lo32;
}
/**
 * Represent an unsigned 64-bit integer in little-endian format when
 * encoded and as a near integral JavaScript Number when decoded.
 *
 * *Factory*: {@link module:Layout.nu64|nu64}
 *
 * **NOTE** Values with magnitude greater than 2^52 may not decode to
 * the exact value of the encoded representation.
 *
 * @augments {Layout}
 */ class $09c4e3f7de797447$var$NearUInt64 extends $09c4e3f7de797447$var$Layout {
    constructor(property){
        super(8, property);
    }
    /** @override */ decode(b, offset = 0) {
        const buffer = $09c4e3f7de797447$var$uint8ArrayToBuffer(b);
        const lo32 = buffer.readUInt32LE(offset);
        const hi32 = buffer.readUInt32LE(offset + 4);
        return $09c4e3f7de797447$var$roundedInt64(hi32, lo32);
    }
    /** @override */ encode(src, b, offset = 0) {
        const split = $09c4e3f7de797447$var$divmodInt64(src);
        const buffer = $09c4e3f7de797447$var$uint8ArrayToBuffer(b);
        buffer.writeUInt32LE(split.lo32, offset);
        buffer.writeUInt32LE(split.hi32, offset + 4);
        return 8;
    }
}
module.exports.NearUInt64 = $09c4e3f7de797447$var$NearUInt64;
/**
 * Represent an unsigned 64-bit integer in big-endian format when
 * encoded and as a near integral JavaScript Number when decoded.
 *
 * *Factory*: {@link module:Layout.nu64be|nu64be}
 *
 * **NOTE** Values with magnitude greater than 2^52 may not decode to
 * the exact value of the encoded representation.
 *
 * @augments {Layout}
 */ class $09c4e3f7de797447$var$NearUInt64BE extends $09c4e3f7de797447$var$Layout {
    constructor(property){
        super(8, property);
    }
    /** @override */ decode(b, offset = 0) {
        const buffer = $09c4e3f7de797447$var$uint8ArrayToBuffer(b);
        const hi32 = buffer.readUInt32BE(offset);
        const lo32 = buffer.readUInt32BE(offset + 4);
        return $09c4e3f7de797447$var$roundedInt64(hi32, lo32);
    }
    /** @override */ encode(src, b, offset = 0) {
        const split = $09c4e3f7de797447$var$divmodInt64(src);
        const buffer = $09c4e3f7de797447$var$uint8ArrayToBuffer(b);
        buffer.writeUInt32BE(split.hi32, offset);
        buffer.writeUInt32BE(split.lo32, offset + 4);
        return 8;
    }
}
module.exports.NearUInt64BE = $09c4e3f7de797447$var$NearUInt64BE;
/**
 * Represent a signed 64-bit integer in little-endian format when
 * encoded and as a near integral JavaScript Number when decoded.
 *
 * *Factory*: {@link module:Layout.ns64|ns64}
 *
 * **NOTE** Values with magnitude greater than 2^52 may not decode to
 * the exact value of the encoded representation.
 *
 * @augments {Layout}
 */ class $09c4e3f7de797447$var$NearInt64 extends $09c4e3f7de797447$var$Layout {
    constructor(property){
        super(8, property);
    }
    /** @override */ decode(b, offset = 0) {
        const buffer = $09c4e3f7de797447$var$uint8ArrayToBuffer(b);
        const lo32 = buffer.readUInt32LE(offset);
        const hi32 = buffer.readInt32LE(offset + 4);
        return $09c4e3f7de797447$var$roundedInt64(hi32, lo32);
    }
    /** @override */ encode(src, b, offset = 0) {
        const split = $09c4e3f7de797447$var$divmodInt64(src);
        const buffer = $09c4e3f7de797447$var$uint8ArrayToBuffer(b);
        buffer.writeUInt32LE(split.lo32, offset);
        buffer.writeInt32LE(split.hi32, offset + 4);
        return 8;
    }
}
module.exports.NearInt64 = $09c4e3f7de797447$var$NearInt64;
/**
 * Represent a signed 64-bit integer in big-endian format when
 * encoded and as a near integral JavaScript Number when decoded.
 *
 * *Factory*: {@link module:Layout.ns64be|ns64be}
 *
 * **NOTE** Values with magnitude greater than 2^52 may not decode to
 * the exact value of the encoded representation.
 *
 * @augments {Layout}
 */ class $09c4e3f7de797447$var$NearInt64BE extends $09c4e3f7de797447$var$Layout {
    constructor(property){
        super(8, property);
    }
    /** @override */ decode(b, offset = 0) {
        const buffer = $09c4e3f7de797447$var$uint8ArrayToBuffer(b);
        const hi32 = buffer.readInt32BE(offset);
        const lo32 = buffer.readUInt32BE(offset + 4);
        return $09c4e3f7de797447$var$roundedInt64(hi32, lo32);
    }
    /** @override */ encode(src, b, offset = 0) {
        const split = $09c4e3f7de797447$var$divmodInt64(src);
        const buffer = $09c4e3f7de797447$var$uint8ArrayToBuffer(b);
        buffer.writeInt32BE(split.hi32, offset);
        buffer.writeUInt32BE(split.lo32, offset + 4);
        return 8;
    }
}
module.exports.NearInt64BE = $09c4e3f7de797447$var$NearInt64BE;
/**
 * Represent a 32-bit floating point number in little-endian format.
 *
 * *Factory*: {@link module:Layout.f32|f32}
 *
 * @param {string} [property] - initializer for {@link
 * Layout#property|property}.
 *
 * @augments {Layout}
 */ class $09c4e3f7de797447$var$Float extends $09c4e3f7de797447$var$Layout {
    constructor(property){
        super(4, property);
    }
    /** @override */ decode(b, offset = 0) {
        return $09c4e3f7de797447$var$uint8ArrayToBuffer(b).readFloatLE(offset);
    }
    /** @override */ encode(src, b, offset = 0) {
        $09c4e3f7de797447$var$uint8ArrayToBuffer(b).writeFloatLE(src, offset);
        return 4;
    }
}
module.exports.Float = $09c4e3f7de797447$var$Float;
/**
 * Represent a 32-bit floating point number in big-endian format.
 *
 * *Factory*: {@link module:Layout.f32be|f32be}
 *
 * @param {string} [property] - initializer for {@link
 * Layout#property|property}.
 *
 * @augments {Layout}
 */ class $09c4e3f7de797447$var$FloatBE extends $09c4e3f7de797447$var$Layout {
    constructor(property){
        super(4, property);
    }
    /** @override */ decode(b, offset = 0) {
        return $09c4e3f7de797447$var$uint8ArrayToBuffer(b).readFloatBE(offset);
    }
    /** @override */ encode(src, b, offset = 0) {
        $09c4e3f7de797447$var$uint8ArrayToBuffer(b).writeFloatBE(src, offset);
        return 4;
    }
}
module.exports.FloatBE = $09c4e3f7de797447$var$FloatBE;
/**
 * Represent a 64-bit floating point number in little-endian format.
 *
 * *Factory*: {@link module:Layout.f64|f64}
 *
 * @param {string} [property] - initializer for {@link
 * Layout#property|property}.
 *
 * @augments {Layout}
 */ class $09c4e3f7de797447$var$Double extends $09c4e3f7de797447$var$Layout {
    constructor(property){
        super(8, property);
    }
    /** @override */ decode(b, offset = 0) {
        return $09c4e3f7de797447$var$uint8ArrayToBuffer(b).readDoubleLE(offset);
    }
    /** @override */ encode(src, b, offset = 0) {
        $09c4e3f7de797447$var$uint8ArrayToBuffer(b).writeDoubleLE(src, offset);
        return 8;
    }
}
module.exports.Double = $09c4e3f7de797447$var$Double;
/**
 * Represent a 64-bit floating point number in big-endian format.
 *
 * *Factory*: {@link module:Layout.f64be|f64be}
 *
 * @param {string} [property] - initializer for {@link
 * Layout#property|property}.
 *
 * @augments {Layout}
 */ class $09c4e3f7de797447$var$DoubleBE extends $09c4e3f7de797447$var$Layout {
    constructor(property){
        super(8, property);
    }
    /** @override */ decode(b, offset = 0) {
        return $09c4e3f7de797447$var$uint8ArrayToBuffer(b).readDoubleBE(offset);
    }
    /** @override */ encode(src, b, offset = 0) {
        $09c4e3f7de797447$var$uint8ArrayToBuffer(b).writeDoubleBE(src, offset);
        return 8;
    }
}
module.exports.DoubleBE = $09c4e3f7de797447$var$DoubleBE;
/**
 * Represent a contiguous sequence of a specific layout as an Array.
 *
 * *Factory*: {@link module:Layout.seq|seq}
 *
 * @param {Layout} elementLayout - initializer for {@link
 * Sequence#elementLayout|elementLayout}.
 *
 * @param {(Number|ExternalLayout)} count - initializer for {@link
 * Sequence#count|count}.  The parameter must be either a positive
 * integer or an instance of {@link ExternalLayout}.
 *
 * @param {string} [property] - initializer for {@link
 * Layout#property|property}.
 *
 * @augments {Layout}
 */ class $09c4e3f7de797447$var$Sequence extends $09c4e3f7de797447$var$Layout {
    constructor(elementLayout, count, property){
        if (!(elementLayout instanceof $09c4e3f7de797447$var$Layout)) throw new TypeError("elementLayout must be a Layout");
        if (!(count instanceof $09c4e3f7de797447$var$ExternalLayout && count.isCount() || Number.isInteger(count) && 0 <= count)) throw new TypeError("count must be non-negative integer or an unsigned integer ExternalLayout");
        let span = -1;
        if (!(count instanceof $09c4e3f7de797447$var$ExternalLayout) && 0 < elementLayout.span) span = count * elementLayout.span;
        super(span, property);
        /** The layout for individual elements of the sequence. */ this.elementLayout = elementLayout;
        /** The number of elements in the sequence.
         *
         * This will be either a non-negative integer or an instance of
         * {@link ExternalLayout} for which {@link
         * ExternalLayout#isCount|isCount()} is `true`. */ this.count = count;
    }
    /** @override */ getSpan(b, offset = 0) {
        if (0 <= this.span) return this.span;
        let span = 0;
        let count = this.count;
        if (count instanceof $09c4e3f7de797447$var$ExternalLayout) count = count.decode(b, offset);
        if (0 < this.elementLayout.span) span = count * this.elementLayout.span;
        else {
            let idx = 0;
            while(idx < count){
                span += this.elementLayout.getSpan(b, offset + span);
                ++idx;
            }
        }
        return span;
    }
    /** @override */ decode(b, offset = 0) {
        const rv = [];
        let i = 0;
        let count = this.count;
        if (count instanceof $09c4e3f7de797447$var$ExternalLayout) count = count.decode(b, offset);
        while(i < count){
            rv.push(this.elementLayout.decode(b, offset));
            offset += this.elementLayout.getSpan(b, offset);
            i += 1;
        }
        return rv;
    }
    /** Implement {@link Layout#encode|encode} for {@link Sequence}.
     *
     * **NOTE** If `src` is shorter than {@link Sequence#count|count} then
     * the unused space in the buffer is left unchanged.  If `src` is
     * longer than {@link Sequence#count|count} the unneeded elements are
     * ignored.
     *
     * **NOTE** If {@link Layout#count|count} is an instance of {@link
     * ExternalLayout} then the length of `src` will be encoded as the
     * count after `src` is encoded. */ encode(src, b, offset = 0) {
        const elo = this.elementLayout;
        const span = src.reduce((span, v)=>{
            return span + elo.encode(v, b, offset + span);
        }, 0);
        if (this.count instanceof $09c4e3f7de797447$var$ExternalLayout) this.count.encode(src.length, b, offset);
        return span;
    }
}
module.exports.Sequence = $09c4e3f7de797447$var$Sequence;
/**
 * Represent a contiguous sequence of arbitrary layout elements as an
 * Object.
 *
 * *Factory*: {@link module:Layout.struct|struct}
 *
 * **NOTE** The {@link Layout#span|span} of the structure is variable
 * if any layout in {@link Structure#fields|fields} has a variable
 * span.  When {@link Layout#encode|encoding} we must have a value for
 * all variable-length fields, or we wouldn't be able to figure out
 * how much space to use for storage.  We can only identify the value
 * for a field when it has a {@link Layout#property|property}.  As
 * such, although a structure may contain both unnamed fields and
 * variable-length fields, it cannot contain an unnamed
 * variable-length field.
 *
 * @param {Layout[]} fields - initializer for {@link
 * Structure#fields|fields}.  An error is raised if this contains a
 * variable-length field for which a {@link Layout#property|property}
 * is not defined.
 *
 * @param {string} [property] - initializer for {@link
 * Layout#property|property}.
 *
 * @param {Boolean} [decodePrefixes] - initializer for {@link
 * Structure#decodePrefixes|property}.
 *
 * @throws {Error} - if `fields` contains an unnamed variable-length
 * layout.
 *
 * @augments {Layout}
 */ class $09c4e3f7de797447$var$Structure extends $09c4e3f7de797447$var$Layout {
    constructor(fields, property, decodePrefixes){
        if (!(Array.isArray(fields) && fields.reduce((acc, v)=>acc && v instanceof $09c4e3f7de797447$var$Layout, true))) throw new TypeError("fields must be array of Layout instances");
        if ("boolean" === typeof property && undefined === decodePrefixes) {
            decodePrefixes = property;
            property = undefined;
        }
        /* Verify absence of unnamed variable-length fields. */ for (const fd of fields){
            if (0 > fd.span && undefined === fd.property) throw new Error("fields cannot contain unnamed variable-length layout");
        }
        let span = -1;
        try {
            span = fields.reduce((span, fd)=>span + fd.getSpan(), 0);
        } catch (e) {
        // ignore error
        }
        super(span, property);
        /** The sequence of {@link Layout} values that comprise the
         * structure.
         *
         * The individual elements need not be the same type, and may be
         * either scalar or aggregate layouts.  If a member layout leaves
         * its {@link Layout#property|property} undefined the
         * corresponding region of the buffer associated with the element
         * will not be mutated.
         *
         * @type {Layout[]} */ this.fields = fields;
        /** Control behavior of {@link Layout#decode|decode()} given short
         * buffers.
         *
         * In some situations a structure many be extended with additional
         * fields over time, with older installations providing only a
         * prefix of the full structure.  If this property is `true`
         * decoding will accept those buffers and leave subsequent fields
         * undefined, as long as the buffer ends at a field boundary.
         * Defaults to `false`. */ this.decodePrefixes = !!decodePrefixes;
    }
    /** @override */ getSpan(b, offset = 0) {
        if (0 <= this.span) return this.span;
        let span = 0;
        try {
            span = this.fields.reduce((span, fd)=>{
                const fsp = fd.getSpan(b, offset);
                offset += fsp;
                return span + fsp;
            }, 0);
        } catch (e) {
            throw new RangeError("indeterminate span");
        }
        return span;
    }
    /** @override */ decode(b, offset = 0) {
        $09c4e3f7de797447$var$checkUint8Array(b);
        const dest = this.makeDestinationObject();
        for (const fd of this.fields){
            if (undefined !== fd.property) dest[fd.property] = fd.decode(b, offset);
            offset += fd.getSpan(b, offset);
            if (this.decodePrefixes && b.length === offset) break;
        }
        return dest;
    }
    /** Implement {@link Layout#encode|encode} for {@link Structure}.
     *
     * If `src` is missing a property for a member with a defined {@link
     * Layout#property|property} the corresponding region of the buffer is
     * left unmodified. */ encode(src, b, offset = 0) {
        const firstOffset = offset;
        let lastOffset = 0;
        let lastWrote = 0;
        for (const fd of this.fields){
            let span = fd.span;
            lastWrote = 0 < span ? span : 0;
            if (undefined !== fd.property) {
                const fv = src[fd.property];
                if (undefined !== fv) {
                    lastWrote = fd.encode(fv, b, offset);
                    if (0 > span) /* Read the as-encoded span, which is not necessarily the
                         * same as what we wrote. */ span = fd.getSpan(b, offset);
                }
            }
            lastOffset = offset;
            offset += span;
        }
        /* Use (lastOffset + lastWrote) instead of offset because the last
         * item may have had a dynamic length and we don't want to include
         * the padding between it and the end of the space reserved for
         * it. */ return lastOffset + lastWrote - firstOffset;
    }
    /** @override */ fromArray(values) {
        const dest = this.makeDestinationObject();
        for (const fd of this.fields)if (undefined !== fd.property && 0 < values.length) dest[fd.property] = values.shift();
        return dest;
    }
    /**
     * Get access to the layout of a given property.
     *
     * @param {String} property - the structure member of interest.
     *
     * @return {Layout} - the layout associated with `property`, or
     * undefined if there is no such property.
     */ layoutFor(property) {
        if ("string" !== typeof property) throw new TypeError("property must be string");
        for (const fd of this.fields){
            if (fd.property === property) return fd;
        }
        return undefined;
    }
    /**
     * Get the offset of a structure member.
     *
     * @param {String} property - the structure member of interest.
     *
     * @return {Number} - the offset in bytes to the start of `property`
     * within the structure, or undefined if `property` is not a field
     * within the structure.  If the property is a member but follows a
     * variable-length structure member a negative number will be
     * returned.
     */ offsetOf(property) {
        if ("string" !== typeof property) throw new TypeError("property must be string");
        let offset = 0;
        for (const fd of this.fields){
            if (fd.property === property) return offset;
            if (0 > fd.span) offset = -1;
            else if (0 <= offset) offset += fd.span;
        }
        return undefined;
    }
}
module.exports.Structure = $09c4e3f7de797447$var$Structure;
/**
 * An object that can provide a {@link
 * Union#discriminator|discriminator} API for {@link Union}.
 *
 * **NOTE** This is an abstract base class; you can create instances
 * if it amuses you, but they won't support the {@link
 * UnionDiscriminator#encode|encode} or {@link
 * UnionDiscriminator#decode|decode} functions.
 *
 * @param {string} [property] - Default for {@link
 * UnionDiscriminator#property|property}.
 *
 * @abstract
 */ class $09c4e3f7de797447$var$UnionDiscriminator {
    constructor(property){
        /** The {@link Layout#property|property} to be used when the
         * discriminator is referenced in isolation (generally when {@link
         * Union#decode|Union decode} cannot delegate to a specific
         * variant). */ this.property = property;
    }
    /** Analog to {@link Layout#decode|Layout decode} for union discriminators.
     *
     * The implementation of this method need not reference the buffer if
     * variant information is available through other means. */ decode(b, offset) {
        throw new Error("UnionDiscriminator is abstract");
    }
    /** Analog to {@link Layout#decode|Layout encode} for union discriminators.
     *
     * The implementation of this method need not store the value if
     * variant information is maintained through other means. */ encode(src, b, offset) {
        throw new Error("UnionDiscriminator is abstract");
    }
}
module.exports.UnionDiscriminator = $09c4e3f7de797447$var$UnionDiscriminator;
/**
 * An object that can provide a {@link
 * UnionDiscriminator|discriminator API} for {@link Union} using an
 * unsigned integral {@link Layout} instance located either inside or
 * outside the union.
 *
 * @param {ExternalLayout} layout - initializes {@link
 * UnionLayoutDiscriminator#layout|layout}.  Must satisfy {@link
 * ExternalLayout#isCount|isCount()}.
 *
 * @param {string} [property] - Default for {@link
 * UnionDiscriminator#property|property}, superseding the property
 * from `layout`, but defaulting to `variant` if neither `property`
 * nor layout provide a property name.
 *
 * @augments {UnionDiscriminator}
 */ class $09c4e3f7de797447$var$UnionLayoutDiscriminator extends $09c4e3f7de797447$var$UnionDiscriminator {
    constructor(layout, property){
        if (!(layout instanceof $09c4e3f7de797447$var$ExternalLayout && layout.isCount())) throw new TypeError("layout must be an unsigned integer ExternalLayout");
        super(property || layout.property || "variant");
        /** The {@link ExternalLayout} used to access the discriminator
         * value. */ this.layout = layout;
    }
    /** Delegate decoding to {@link UnionLayoutDiscriminator#layout|layout}. */ decode(b, offset) {
        return this.layout.decode(b, offset);
    }
    /** Delegate encoding to {@link UnionLayoutDiscriminator#layout|layout}. */ encode(src, b, offset) {
        return this.layout.encode(src, b, offset);
    }
}
module.exports.UnionLayoutDiscriminator = $09c4e3f7de797447$var$UnionLayoutDiscriminator;
/**
 * Represent any number of span-compatible layouts.
 *
 * *Factory*: {@link module:Layout.union|union}
 *
 * If the union has a {@link Union#defaultLayout|default layout} that
 * layout must have a non-negative {@link Layout#span|span}.  The span
 * of a fixed-span union includes its {@link
 * Union#discriminator|discriminator} if the variant is a {@link
 * Union#usesPrefixDiscriminator|prefix of the union}, plus the span
 * of its {@link Union#defaultLayout|default layout}.
 *
 * If the union does not have a default layout then the encoded span
 * of the union depends on the encoded span of its variant (which may
 * be fixed or variable).
 *
 * {@link VariantLayout#layout|Variant layout}s are added through
 * {@link Union#addVariant|addVariant}.  If the union has a default
 * layout, the span of the {@link VariantLayout#layout|layout
 * contained by the variant} must not exceed the span of the {@link
 * Union#defaultLayout|default layout} (minus the span of a {@link
 * Union#usesPrefixDiscriminator|prefix disriminator}, if used).  The
 * span of the variant will equal the span of the union itself.
 *
 * The variant for a buffer can only be identified from the {@link
 * Union#discriminator|discriminator} {@link
 * UnionDiscriminator#property|property} (in the case of the {@link
 * Union#defaultLayout|default layout}), or by using {@link
 * Union#getVariant|getVariant} and examining the resulting {@link
 * VariantLayout} instance.
 *
 * A variant compatible with a JavaScript object can be identified
 * using {@link Union#getSourceVariant|getSourceVariant}.
 *
 * @param {(UnionDiscriminator|ExternalLayout|Layout)} discr - How to
 * identify the layout used to interpret the union contents.  The
 * parameter must be an instance of {@link UnionDiscriminator}, an
 * {@link ExternalLayout} that satisfies {@link
 * ExternalLayout#isCount|isCount()}, or {@link UInt} (or {@link
 * UIntBE}).  When a non-external layout element is passed the layout
 * appears at the start of the union.  In all cases the (synthesized)
 * {@link UnionDiscriminator} instance is recorded as {@link
 * Union#discriminator|discriminator}.
 *
 * @param {(Layout|null)} defaultLayout - initializer for {@link
 * Union#defaultLayout|defaultLayout}.  If absent defaults to `null`.
 * If `null` there is no default layout: the union has data-dependent
 * length and attempts to decode or encode unrecognized variants will
 * throw an exception.  A {@link Layout} instance must have a
 * non-negative {@link Layout#span|span}, and if it lacks a {@link
 * Layout#property|property} the {@link
 * Union#defaultLayout|defaultLayout} will be a {@link
 * Layout#replicate|replica} with property `content`.
 *
 * @param {string} [property] - initializer for {@link
 * Layout#property|property}.
 *
 * @augments {Layout}
 */ class $09c4e3f7de797447$var$Union extends $09c4e3f7de797447$var$Layout {
    constructor(discr, defaultLayout, property){
        let discriminator;
        if (discr instanceof $09c4e3f7de797447$var$UInt || discr instanceof $09c4e3f7de797447$var$UIntBE) discriminator = new $09c4e3f7de797447$var$UnionLayoutDiscriminator(new $09c4e3f7de797447$var$OffsetLayout(discr));
        else if (discr instanceof $09c4e3f7de797447$var$ExternalLayout && discr.isCount()) discriminator = new $09c4e3f7de797447$var$UnionLayoutDiscriminator(discr);
        else if (!(discr instanceof $09c4e3f7de797447$var$UnionDiscriminator)) throw new TypeError("discr must be a UnionDiscriminator or an unsigned integer layout");
        else discriminator = discr;
        if (undefined === defaultLayout) defaultLayout = null;
        if (!(null === defaultLayout || defaultLayout instanceof $09c4e3f7de797447$var$Layout)) throw new TypeError("defaultLayout must be null or a Layout");
        if (null !== defaultLayout) {
            if (0 > defaultLayout.span) throw new Error("defaultLayout must have constant span");
            if (undefined === defaultLayout.property) defaultLayout = defaultLayout.replicate("content");
        }
        /* The union span can be estimated only if there's a default
         * layout.  The union spans its default layout, plus any prefix
         * variant layout.  By construction both layouts, if present, have
         * non-negative span. */ let span = -1;
        if (defaultLayout) {
            span = defaultLayout.span;
            if (0 <= span && (discr instanceof $09c4e3f7de797447$var$UInt || discr instanceof $09c4e3f7de797447$var$UIntBE)) span += discriminator.layout.span;
        }
        super(span, property);
        /** The interface for the discriminator value in isolation.
         *
         * This a {@link UnionDiscriminator} either passed to the
         * constructor or synthesized from the `discr` constructor
         * argument.  {@link
         * Union#usesPrefixDiscriminator|usesPrefixDiscriminator} will be
         * `true` iff the `discr` parameter was a non-offset {@link
         * Layout} instance. */ this.discriminator = discriminator;
        /** `true` if the {@link Union#discriminator|discriminator} is the
         * first field in the union.
         *
         * If `false` the discriminator is obtained from somewhere
         * else. */ this.usesPrefixDiscriminator = discr instanceof $09c4e3f7de797447$var$UInt || discr instanceof $09c4e3f7de797447$var$UIntBE;
        /** The layout for non-discriminator content when the value of the
         * discriminator is not recognized.
         *
         * This is the value passed to the constructor.  It is
         * structurally equivalent to the second component of {@link
         * Union#layout|layout} but may have a different property
         * name. */ this.defaultLayout = defaultLayout;
        /** A registry of allowed variants.
         *
         * The keys are unsigned integers which should be compatible with
         * {@link Union.discriminator|discriminator}.  The property value
         * is the corresponding {@link VariantLayout} instances assigned
         * to this union by {@link Union#addVariant|addVariant}.
         *
         * **NOTE** The registry remains mutable so that variants can be
         * {@link Union#addVariant|added} at any time.  Users should not
         * manipulate the content of this property. */ this.registry = {};
        /* Private variable used when invoking getSourceVariant */ let boundGetSourceVariant = this.defaultGetSourceVariant.bind(this);
        /** Function to infer the variant selected by a source object.
         *
         * Defaults to {@link
         * Union#defaultGetSourceVariant|defaultGetSourceVariant} but may
         * be overridden using {@link
         * Union#configGetSourceVariant|configGetSourceVariant}.
         *
         * @param {Object} src - as with {@link
         * Union#defaultGetSourceVariant|defaultGetSourceVariant}.
         *
         * @returns {(undefined|VariantLayout)} The default variant
         * (`undefined`) or first registered variant that uses a property
         * available in `src`. */ this.getSourceVariant = function(src) {
            return boundGetSourceVariant(src);
        };
        /** Function to override the implementation of {@link
         * Union#getSourceVariant|getSourceVariant}.
         *
         * Use this if the desired variant cannot be identified using the
         * algorithm of {@link
         * Union#defaultGetSourceVariant|defaultGetSourceVariant}.
         *
         * **NOTE** The provided function will be invoked bound to this
         * Union instance, providing local access to {@link
         * Union#registry|registry}.
         *
         * @param {Function} gsv - a function that follows the API of
         * {@link Union#defaultGetSourceVariant|defaultGetSourceVariant}. */ this.configGetSourceVariant = function(gsv) {
            boundGetSourceVariant = gsv.bind(this);
        };
    }
    /** @override */ getSpan(b, offset = 0) {
        if (0 <= this.span) return this.span;
        /* Default layouts always have non-negative span, so we don't have
         * one and we have to recognize the variant which will in turn
         * determine the span. */ const vlo = this.getVariant(b, offset);
        if (!vlo) throw new Error("unable to determine span for unrecognized variant");
        return vlo.getSpan(b, offset);
    }
    /**
     * Method to infer a registered Union variant compatible with `src`.
     *
     * The first satisfied rule in the following sequence defines the
     * return value:
     * * If `src` has properties matching the Union discriminator and
     *   the default layout, `undefined` is returned regardless of the
     *   value of the discriminator property (this ensures the default
     *   layout will be used);
     * * If `src` has a property matching the Union discriminator, the
     *   value of the discriminator identifies a registered variant, and
     *   either (a) the variant has no layout, or (b) `src` has the
     *   variant's property, then the variant is returned (because the
     *   source satisfies the constraints of the variant it identifies);
     * * If `src` does not have a property matching the Union
     *   discriminator, but does have a property matching a registered
     *   variant, then the variant is returned (because the source
     *   matches a variant without an explicit conflict);
     * * An error is thrown (because we either can't identify a variant,
     *   or we were explicitly told the variant but can't satisfy it).
     *
     * @param {Object} src - an object presumed to be compatible with
     * the content of the Union.
     *
     * @return {(undefined|VariantLayout)} - as described above.
     *
     * @throws {Error} - if `src` cannot be associated with a default or
     * registered variant.
     */ defaultGetSourceVariant(src) {
        if (Object.prototype.hasOwnProperty.call(src, this.discriminator.property)) {
            if (this.defaultLayout && this.defaultLayout.property && Object.prototype.hasOwnProperty.call(src, this.defaultLayout.property)) return undefined;
            const vlo = this.registry[src[this.discriminator.property]];
            if (vlo && (!vlo.layout || vlo.property && Object.prototype.hasOwnProperty.call(src, vlo.property))) return vlo;
        } else for(const tag in this.registry){
            const vlo = this.registry[tag];
            if (vlo.property && Object.prototype.hasOwnProperty.call(src, vlo.property)) return vlo;
        }
        throw new Error("unable to infer src variant");
    }
    /** Implement {@link Layout#decode|decode} for {@link Union}.
     *
     * If the variant is {@link Union#addVariant|registered} the return
     * value is an instance of that variant, with no explicit
     * discriminator.  Otherwise the {@link Union#defaultLayout|default
     * layout} is used to decode the content. */ decode(b, offset = 0) {
        let dest;
        const dlo = this.discriminator;
        const discr = dlo.decode(b, offset);
        const clo = this.registry[discr];
        if (undefined === clo) {
            const defaultLayout = this.defaultLayout;
            let contentOffset = 0;
            if (this.usesPrefixDiscriminator) contentOffset = dlo.layout.span;
            dest = this.makeDestinationObject();
            dest[dlo.property] = discr;
            // defaultLayout.property can be undefined, but this is allowed by buffer-layout
            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            dest[defaultLayout.property] = defaultLayout.decode(b, offset + contentOffset);
        } else dest = clo.decode(b, offset);
        return dest;
    }
    /** Implement {@link Layout#encode|encode} for {@link Union}.
     *
     * This API assumes the `src` object is consistent with the union's
     * {@link Union#defaultLayout|default layout}.  To encode variants
     * use the appropriate variant-specific {@link VariantLayout#encode}
     * method. */ encode(src, b, offset = 0) {
        const vlo = this.getSourceVariant(src);
        if (undefined === vlo) {
            const dlo = this.discriminator;
            // this.defaultLayout is not undefined when vlo is undefined
            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            const clo = this.defaultLayout;
            let contentOffset = 0;
            if (this.usesPrefixDiscriminator) contentOffset = dlo.layout.span;
            dlo.encode(src[dlo.property], b, offset);
            // clo.property is not undefined when vlo is undefined
            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            return contentOffset + clo.encode(src[clo.property], b, offset + contentOffset);
        }
        return vlo.encode(src, b, offset);
    }
    /** Register a new variant structure within a union.  The newly
     * created variant is returned.
     *
     * @param {Number} variant - initializer for {@link
     * VariantLayout#variant|variant}.
     *
     * @param {Layout} layout - initializer for {@link
     * VariantLayout#layout|layout}.
     *
     * @param {String} property - initializer for {@link
     * Layout#property|property}.
     *
     * @return {VariantLayout} */ addVariant(variant, layout, property) {
        const rv = new $09c4e3f7de797447$var$VariantLayout(this, variant, layout, property);
        this.registry[variant] = rv;
        return rv;
    }
    /**
     * Get the layout associated with a registered variant.
     *
     * If `vb` does not produce a registered variant the function returns
     * `undefined`.
     *
     * @param {(Number|Uint8Array)} vb - either the variant number, or a
     * buffer from which the discriminator is to be read.
     *
     * @param {Number} offset - offset into `vb` for the start of the
     * union.  Used only when `vb` is an instance of {Uint8Array}.
     *
     * @return {({VariantLayout}|undefined)}
     */ getVariant(vb, offset = 0) {
        let variant;
        if (vb instanceof Uint8Array) variant = this.discriminator.decode(vb, offset);
        else variant = vb;
        return this.registry[variant];
    }
}
module.exports.Union = $09c4e3f7de797447$var$Union;
/**
 * Represent a specific variant within a containing union.
 *
 * **NOTE** The {@link Layout#span|span} of the variant may include
 * the span of the {@link Union#discriminator|discriminator} used to
 * identify it, but values read and written using the variant strictly
 * conform to the content of {@link VariantLayout#layout|layout}.
 *
 * **NOTE** User code should not invoke this constructor directly.  Use
 * the union {@link Union#addVariant|addVariant} helper method.
 *
 * @param {Union} union - initializer for {@link
 * VariantLayout#union|union}.
 *
 * @param {Number} variant - initializer for {@link
 * VariantLayout#variant|variant}.
 *
 * @param {Layout} [layout] - initializer for {@link
 * VariantLayout#layout|layout}.  If absent the variant carries no
 * data.
 *
 * @param {String} [property] - initializer for {@link
 * Layout#property|property}.  Unlike many other layouts, variant
 * layouts normally include a property name so they can be identified
 * within their containing {@link Union}.  The property identifier may
 * be absent only if `layout` is is absent.
 *
 * @augments {Layout}
 */ class $09c4e3f7de797447$var$VariantLayout extends $09c4e3f7de797447$var$Layout {
    constructor(union, variant, layout, property){
        if (!(union instanceof $09c4e3f7de797447$var$Union)) throw new TypeError("union must be a Union");
        if (!Number.isInteger(variant) || 0 > variant) throw new TypeError("variant must be a (non-negative) integer");
        if ("string" === typeof layout && undefined === property) {
            property = layout;
            layout = null;
        }
        if (layout) {
            if (!(layout instanceof $09c4e3f7de797447$var$Layout)) throw new TypeError("layout must be a Layout");
            if (null !== union.defaultLayout && 0 <= layout.span && layout.span > union.defaultLayout.span) throw new Error("variant span exceeds span of containing union");
            if ("string" !== typeof property) throw new TypeError("variant must have a String property");
        }
        let span = union.span;
        if (0 > union.span) {
            span = layout ? layout.span : 0;
            if (0 <= span && union.usesPrefixDiscriminator) span += union.discriminator.layout.span;
        }
        super(span, property);
        /** The {@link Union} to which this variant belongs. */ this.union = union;
        /** The unsigned integral value identifying this variant within
         * the {@link Union#discriminator|discriminator} of the containing
         * union. */ this.variant = variant;
        /** The {@link Layout} to be used when reading/writing the
         * non-discriminator part of the {@link
         * VariantLayout#union|union}.  If `null` the variant carries no
         * data. */ this.layout = layout || null;
    }
    /** @override */ getSpan(b, offset = 0) {
        if (0 <= this.span) /* Will be equal to the containing union span if that is not
             * variable. */ return this.span;
        let contentOffset = 0;
        if (this.union.usesPrefixDiscriminator) contentOffset = this.union.discriminator.layout.span;
        /* Span is defined solely by the variant (and prefix discriminator) */ let span = 0;
        if (this.layout) span = this.layout.getSpan(b, offset + contentOffset);
        return contentOffset + span;
    }
    /** @override */ decode(b, offset = 0) {
        const dest = this.makeDestinationObject();
        if (this !== this.union.getVariant(b, offset)) throw new Error("variant mismatch");
        let contentOffset = 0;
        if (this.union.usesPrefixDiscriminator) contentOffset = this.union.discriminator.layout.span;
        if (this.layout) dest[this.property] = this.layout.decode(b, offset + contentOffset);
        else if (this.property) dest[this.property] = true;
        else if (this.union.usesPrefixDiscriminator) dest[this.union.discriminator.property] = this.variant;
        return dest;
    }
    /** @override */ encode(src, b, offset = 0) {
        let contentOffset = 0;
        if (this.union.usesPrefixDiscriminator) contentOffset = this.union.discriminator.layout.span;
        if (this.layout && !Object.prototype.hasOwnProperty.call(src, this.property)) throw new TypeError("variant lacks property " + this.property);
        this.union.discriminator.encode(this.variant, b, offset);
        let span = contentOffset;
        if (this.layout) {
            this.layout.encode(src[this.property], b, offset + contentOffset);
            span += this.layout.getSpan(b, offset + contentOffset);
            if (0 <= this.union.span && span > this.union.span) throw new Error("encoded variant overruns containing union");
        }
        return span;
    }
    /** Delegate {@link Layout#fromArray|fromArray} to {@link
     * VariantLayout#layout|layout}. */ fromArray(values) {
        if (this.layout) return this.layout.fromArray(values);
        return undefined;
    }
}
module.exports.VariantLayout = $09c4e3f7de797447$var$VariantLayout;
/** JavaScript chose to define bitwise operations as operating on
 * signed 32-bit values in 2's complement form, meaning any integer
 * with bit 31 set is going to look negative.  For right shifts that's
 * not a problem, because `>>>` is a logical shift, but for every
 * other bitwise operator we have to compensate for possible negative
 * results. */ function $09c4e3f7de797447$var$fixBitwiseResult(v) {
    if (0 > v) v += 0x100000000;
    return v;
}
/**
 * Contain a sequence of bit fields as an unsigned integer.
 *
 * *Factory*: {@link module:Layout.bits|bits}
 *
 * This is a container element; within it there are {@link BitField}
 * instances that provide the extracted properties.  The container
 * simply defines the aggregate representation and its bit ordering.
 * The representation is an object containing properties with numeric
 * or {@link Boolean} values.
 *
 * {@link BitField}s are added with the {@link
 * BitStructure#addField|addField} and {@link
 * BitStructure#addBoolean|addBoolean} methods.

 * @param {Layout} word - initializer for {@link
 * BitStructure#word|word}.  The parameter must be an instance of
 * {@link UInt} (or {@link UIntBE}) that is no more than 4 bytes wide.
 *
 * @param {bool} [msb] - `true` if the bit numbering starts at the
 * most significant bit of the containing word; `false` (default) if
 * it starts at the least significant bit of the containing word.  If
 * the parameter at this position is a string and `property` is
 * `undefined` the value of this argument will instead be used as the
 * value of `property`.
 *
 * @param {string} [property] - initializer for {@link
 * Layout#property|property}.
 *
 * @augments {Layout}
 */ class $09c4e3f7de797447$var$BitStructure extends $09c4e3f7de797447$var$Layout {
    constructor(word, msb, property){
        if (!(word instanceof $09c4e3f7de797447$var$UInt || word instanceof $09c4e3f7de797447$var$UIntBE)) throw new TypeError("word must be a UInt or UIntBE layout");
        if ("string" === typeof msb && undefined === property) {
            property = msb;
            msb = false;
        }
        if (4 < word.span) throw new RangeError("word cannot exceed 32 bits");
        super(word.span, property);
        /** The layout used for the packed value.  {@link BitField}
         * instances are packed sequentially depending on {@link
         * BitStructure#msb|msb}. */ this.word = word;
        /** Whether the bit sequences are packed starting at the most
         * significant bit growing down (`true`), or the least significant
         * bit growing up (`false`).
         *
         * **NOTE** Regardless of this value, the least significant bit of
         * any {@link BitField} value is the least significant bit of the
         * corresponding section of the packed value. */ this.msb = !!msb;
        /** The sequence of {@link BitField} layouts that comprise the
         * packed structure.
         *
         * **NOTE** The array remains mutable to allow fields to be {@link
         * BitStructure#addField|added} after construction.  Users should
         * not manipulate the content of this property.*/ this.fields = [];
        /* Storage for the value.  Capture a variable instead of using an
         * instance property because we don't want anything to change the
         * value without going through the mutator. */ let value = 0;
        this._packedSetValue = function(v) {
            value = $09c4e3f7de797447$var$fixBitwiseResult(v);
            return this;
        };
        this._packedGetValue = function() {
            return value;
        };
    }
    /** @override */ decode(b, offset = 0) {
        const dest = this.makeDestinationObject();
        const value = this.word.decode(b, offset);
        this._packedSetValue(value);
        for (const fd of this.fields)if (undefined !== fd.property) dest[fd.property] = fd.decode(b);
        return dest;
    }
    /** Implement {@link Layout#encode|encode} for {@link BitStructure}.
     *
     * If `src` is missing a property for a member with a defined {@link
     * Layout#property|property} the corresponding region of the packed
     * value is left unmodified.  Unused bits are also left unmodified. */ encode(src, b, offset = 0) {
        const value = this.word.decode(b, offset);
        this._packedSetValue(value);
        for (const fd of this.fields)if (undefined !== fd.property) {
            const fv = src[fd.property];
            if (undefined !== fv) fd.encode(fv);
        }
        return this.word.encode(this._packedGetValue(), b, offset);
    }
    /** Register a new bitfield with a containing bit structure.  The
     * resulting bitfield is returned.
     *
     * @param {Number} bits - initializer for {@link BitField#bits|bits}.
     *
     * @param {string} property - initializer for {@link
     * Layout#property|property}.
     *
     * @return {BitField} */ addField(bits, property) {
        const bf = new $09c4e3f7de797447$var$BitField(this, bits, property);
        this.fields.push(bf);
        return bf;
    }
    /** As with {@link BitStructure#addField|addField} for single-bit
     * fields with `boolean` value representation.
     *
     * @param {string} property - initializer for {@link
     * Layout#property|property}.
     *
     * @return {Boolean} */ // `Boolean` conflicts with the native primitive type
    // eslint-disable-next-line @typescript-eslint/ban-types
    addBoolean(property) {
        // This is my Boolean, not the Javascript one.
        const bf = new $09c4e3f7de797447$var$Boolean(this, property);
        this.fields.push(bf);
        return bf;
    }
    /**
     * Get access to the bit field for a given property.
     *
     * @param {String} property - the bit field of interest.
     *
     * @return {BitField} - the field associated with `property`, or
     * undefined if there is no such property.
     */ fieldFor(property) {
        if ("string" !== typeof property) throw new TypeError("property must be string");
        for (const fd of this.fields){
            if (fd.property === property) return fd;
        }
        return undefined;
    }
}
module.exports.BitStructure = $09c4e3f7de797447$var$BitStructure;
/**
 * Represent a sequence of bits within a {@link BitStructure}.
 *
 * All bit field values are represented as unsigned integers.
 *
 * **NOTE** User code should not invoke this constructor directly.
 * Use the container {@link BitStructure#addField|addField} helper
 * method.
 *
 * **NOTE** BitField instances are not instances of {@link Layout}
 * since {@link Layout#span|span} measures 8-bit units.
 *
 * @param {BitStructure} container - initializer for {@link
 * BitField#container|container}.
 *
 * @param {Number} bits - initializer for {@link BitField#bits|bits}.
 *
 * @param {string} [property] - initializer for {@link
 * Layout#property|property}.
 */ class $09c4e3f7de797447$var$BitField {
    constructor(container, bits, property){
        if (!(container instanceof $09c4e3f7de797447$var$BitStructure)) throw new TypeError("container must be a BitStructure");
        if (!Number.isInteger(bits) || 0 >= bits) throw new TypeError("bits must be positive integer");
        const totalBits = 8 * container.span;
        const usedBits = container.fields.reduce((sum, fd)=>sum + fd.bits, 0);
        if (bits + usedBits > totalBits) throw new Error("bits too long for span remainder (" + (totalBits - usedBits) + " of " + totalBits + " remain)");
        /** The {@link BitStructure} instance to which this bit field
         * belongs. */ this.container = container;
        /** The span of this value in bits. */ this.bits = bits;
        /** A mask of {@link BitField#bits|bits} bits isolating value bits
         * that fit within the field.
         *
         * That is, it masks a value that has not yet been shifted into
         * position within its containing packed integer. */ this.valueMask = (1 << bits) - 1;
        if (32 === bits) this.valueMask = 0xFFFFFFFF;
        /** The offset of the value within the containing packed unsigned
         * integer.  The least significant bit of the packed value is at
         * offset zero, regardless of bit ordering used. */ this.start = usedBits;
        if (this.container.msb) this.start = totalBits - usedBits - bits;
        /** A mask of {@link BitField#bits|bits} isolating the field value
         * within the containing packed unsigned integer. */ this.wordMask = $09c4e3f7de797447$var$fixBitwiseResult(this.valueMask << this.start);
        /** The property name used when this bitfield is represented in an
         * Object.
         *
         * Intended to be functionally equivalent to {@link
         * Layout#property}.
         *
         * If left undefined the corresponding span of bits will be
         * treated as padding: it will not be mutated by {@link
         * Layout#encode|encode} nor represented as a property in the
         * decoded Object. */ this.property = property;
    }
    /** Store a value into the corresponding subsequence of the containing
     * bit field. */ decode(b, offset) {
        const word = this.container._packedGetValue();
        const wordValue = $09c4e3f7de797447$var$fixBitwiseResult(word & this.wordMask);
        const value = wordValue >>> this.start;
        return value;
    }
    /** Store a value into the corresponding subsequence of the containing
     * bit field.
     *
     * **NOTE** This is not a specialization of {@link
     * Layout#encode|Layout.encode} and there is no return value. */ encode(value) {
        if ("number" !== typeof value || !Number.isInteger(value) || value !== $09c4e3f7de797447$var$fixBitwiseResult(value & this.valueMask)) throw new TypeError($09c4e3f7de797447$var$nameWithProperty("BitField.encode", this) + " value must be integer not exceeding " + this.valueMask);
        const word = this.container._packedGetValue();
        const wordValue = $09c4e3f7de797447$var$fixBitwiseResult(value << this.start);
        this.container._packedSetValue($09c4e3f7de797447$var$fixBitwiseResult(word & ~this.wordMask) | wordValue);
    }
}
module.exports.BitField = $09c4e3f7de797447$var$BitField;
/**
 * Represent a single bit within a {@link BitStructure} as a
 * JavaScript boolean.
 *
 * **NOTE** User code should not invoke this constructor directly.
 * Use the container {@link BitStructure#addBoolean|addBoolean} helper
 * method.
 *
 * @param {BitStructure} container - initializer for {@link
 * BitField#container|container}.
 *
 * @param {string} [property] - initializer for {@link
 * Layout#property|property}.
 *
 * @augments {BitField}
 */ /* eslint-disable no-extend-native */ class $09c4e3f7de797447$var$Boolean extends $09c4e3f7de797447$var$BitField {
    constructor(container, property){
        super(container, 1, property);
    }
    /** Override {@link BitField#decode|decode} for {@link Boolean|Boolean}.
     *
     * @returns {boolean} */ decode(b, offset) {
        return !!super.decode(b, offset);
    }
    /** @override */ encode(value) {
        if ("boolean" === typeof value) // BitField requires integer values
        value = +value;
        super.encode(value);
    }
}
module.exports.Boolean = $09c4e3f7de797447$var$Boolean;
/* eslint-enable no-extend-native */ /**
 * Contain a fixed-length block of arbitrary data, represented as a
 * Uint8Array.
 *
 * *Factory*: {@link module:Layout.blob|blob}
 *
 * @param {(Number|ExternalLayout)} length - initializes {@link
 * Blob#length|length}.
 *
 * @param {String} [property] - initializer for {@link
 * Layout#property|property}.
 *
 * @augments {Layout}
 */ class $09c4e3f7de797447$var$Blob extends $09c4e3f7de797447$var$Layout {
    constructor(length, property){
        if (!(length instanceof $09c4e3f7de797447$var$ExternalLayout && length.isCount() || Number.isInteger(length) && 0 <= length)) throw new TypeError("length must be positive integer or an unsigned integer ExternalLayout");
        let span = -1;
        if (!(length instanceof $09c4e3f7de797447$var$ExternalLayout)) span = length;
        super(span, property);
        /** The number of bytes in the blob.
         *
         * This may be a non-negative integer, or an instance of {@link
         * ExternalLayout} that satisfies {@link
         * ExternalLayout#isCount|isCount()}. */ this.length = length;
    }
    /** @override */ getSpan(b, offset) {
        let span = this.span;
        if (0 > span) span = this.length.decode(b, offset);
        return span;
    }
    /** @override */ decode(b, offset = 0) {
        let span = this.span;
        if (0 > span) span = this.length.decode(b, offset);
        return $09c4e3f7de797447$var$uint8ArrayToBuffer(b).slice(offset, offset + span);
    }
    /** Implement {@link Layout#encode|encode} for {@link Blob}.
     *
     * **NOTE** If {@link Layout#count|count} is an instance of {@link
     * ExternalLayout} then the length of `src` will be encoded as the
     * count after `src` is encoded. */ encode(src, b, offset) {
        let span = this.length;
        if (this.length instanceof $09c4e3f7de797447$var$ExternalLayout) span = src.length;
        if (!(src instanceof Uint8Array && span === src.length)) throw new TypeError($09c4e3f7de797447$var$nameWithProperty("Blob.encode", this) + " requires (length " + span + ") Uint8Array as src");
        if (offset + span > b.length) throw new RangeError("encoding overruns Uint8Array");
        const srcBuffer = $09c4e3f7de797447$var$uint8ArrayToBuffer(src);
        $09c4e3f7de797447$var$uint8ArrayToBuffer(b).write(srcBuffer.toString("hex"), offset, span, "hex");
        if (this.length instanceof $09c4e3f7de797447$var$ExternalLayout) this.length.encode(span, b, offset);
        return span;
    }
}
module.exports.Blob = $09c4e3f7de797447$var$Blob;
/**
 * Contain a `NUL`-terminated UTF8 string.
 *
 * *Factory*: {@link module:Layout.cstr|cstr}
 *
 * **NOTE** Any UTF8 string that incorporates a zero-valued byte will
 * not be correctly decoded by this layout.
 *
 * @param {String} [property] - initializer for {@link
 * Layout#property|property}.
 *
 * @augments {Layout}
 */ class $09c4e3f7de797447$var$CString extends $09c4e3f7de797447$var$Layout {
    constructor(property){
        super(-1, property);
    }
    /** @override */ getSpan(b, offset = 0) {
        $09c4e3f7de797447$var$checkUint8Array(b);
        let idx = offset;
        while(idx < b.length && 0 !== b[idx])idx += 1;
        return 1 + idx - offset;
    }
    /** @override */ decode(b, offset = 0) {
        const span = this.getSpan(b, offset);
        return $09c4e3f7de797447$var$uint8ArrayToBuffer(b).slice(offset, offset + span - 1).toString("utf-8");
    }
    /** @override */ encode(src, b, offset = 0) {
        /* Must force this to a string, lest it be a number and the
         * "utf8-encoding" below actually allocate a buffer of length
         * src */ if ("string" !== typeof src) src = String(src);
        const srcb = $6ZWSX.Buffer.from(src, "utf8");
        const span = srcb.length;
        if (offset + span > b.length) throw new RangeError("encoding overruns Buffer");
        const buffer = $09c4e3f7de797447$var$uint8ArrayToBuffer(b);
        srcb.copy(buffer, offset);
        buffer[offset + span] = 0;
        return span + 1;
    }
}
module.exports.CString = $09c4e3f7de797447$var$CString;
/**
 * Contain a UTF8 string with implicit length.
 *
 * *Factory*: {@link module:Layout.utf8|utf8}
 *
 * **NOTE** Because the length is implicit in the size of the buffer
 * this layout should be used only in isolation, or in a situation
 * where the length can be expressed by operating on a slice of the
 * containing buffer.
 *
 * @param {Number} [maxSpan] - the maximum length allowed for encoded
 * string content.  If not provided there is no bound on the allowed
 * content.
 *
 * @param {String} [property] - initializer for {@link
 * Layout#property|property}.
 *
 * @augments {Layout}
 */ class $09c4e3f7de797447$var$UTF8 extends $09c4e3f7de797447$var$Layout {
    constructor(maxSpan, property){
        if ("string" === typeof maxSpan && undefined === property) {
            property = maxSpan;
            maxSpan = undefined;
        }
        if (undefined === maxSpan) maxSpan = -1;
        else if (!Number.isInteger(maxSpan)) throw new TypeError("maxSpan must be an integer");
        super(-1, property);
        /** The maximum span of the layout in bytes.
         *
         * Positive values are generally expected.  Zero is abnormal.
         * Attempts to encode or decode a value that exceeds this length
         * will throw a `RangeError`.
         *
         * A negative value indicates that there is no bound on the length
         * of the content. */ this.maxSpan = maxSpan;
    }
    /** @override */ getSpan(b, offset = 0) {
        $09c4e3f7de797447$var$checkUint8Array(b);
        return b.length - offset;
    }
    /** @override */ decode(b, offset = 0) {
        const span = this.getSpan(b, offset);
        if (0 <= this.maxSpan && this.maxSpan < span) throw new RangeError("text length exceeds maxSpan");
        return $09c4e3f7de797447$var$uint8ArrayToBuffer(b).slice(offset, offset + span).toString("utf-8");
    }
    /** @override */ encode(src, b, offset = 0) {
        /* Must force this to a string, lest it be a number and the
         * "utf8-encoding" below actually allocate a buffer of length
         * src */ if ("string" !== typeof src) src = String(src);
        const srcb = $6ZWSX.Buffer.from(src, "utf8");
        const span = srcb.length;
        if (0 <= this.maxSpan && this.maxSpan < span) throw new RangeError("text length exceeds maxSpan");
        if (offset + span > b.length) throw new RangeError("encoding overruns Buffer");
        srcb.copy($09c4e3f7de797447$var$uint8ArrayToBuffer(b), offset);
        return span;
    }
}
module.exports.UTF8 = $09c4e3f7de797447$var$UTF8;
/**
 * Contain a constant value.
 *
 * This layout may be used in cases where a JavaScript value can be
 * inferred without an expression in the binary encoding.  An example
 * would be a {@link VariantLayout|variant layout} where the content
 * is implied by the union {@link Union#discriminator|discriminator}.
 *
 * @param {Object|Number|String} value - initializer for {@link
 * Constant#value|value}.  If the value is an object (or array) and
 * the application intends the object to remain unchanged regardless
 * of what is done to values decoded by this layout, the value should
 * be frozen prior passing it to this constructor.
 *
 * @param {String} [property] - initializer for {@link
 * Layout#property|property}.
 *
 * @augments {Layout}
 */ class $09c4e3f7de797447$var$Constant extends $09c4e3f7de797447$var$Layout {
    constructor(value, property){
        super(0, property);
        /** The value produced by this constant when the layout is {@link
         * Constant#decode|decoded}.
         *
         * Any JavaScript value including `null` and `undefined` is
         * permitted.
         *
         * **WARNING** If `value` passed in the constructor was not
         * frozen, it is possible for users of decoded values to change
         * the content of the value. */ this.value = value;
    }
    /** @override */ decode(b, offset) {
        return this.value;
    }
    /** @override */ encode(src, b, offset) {
        /* Constants take no space */ return 0;
    }
}
module.exports.Constant = $09c4e3f7de797447$var$Constant;
/** Factory for {@link GreedyCount}. */ module.exports.greedy = (elementSpan, property)=>new $09c4e3f7de797447$var$GreedyCount(elementSpan, property);
/** Factory for {@link OffsetLayout}. */ module.exports.offset = (layout, offset, property)=>new $09c4e3f7de797447$var$OffsetLayout(layout, offset, property);
/** Factory for {@link UInt|unsigned int layouts} spanning one
 * byte. */ module.exports.u8 = (property)=>new $09c4e3f7de797447$var$UInt(1, property);
/** Factory for {@link UInt|little-endian unsigned int layouts}
 * spanning two bytes. */ module.exports.u16 = (property)=>new $09c4e3f7de797447$var$UInt(2, property);
/** Factory for {@link UInt|little-endian unsigned int layouts}
 * spanning three bytes. */ module.exports.u24 = (property)=>new $09c4e3f7de797447$var$UInt(3, property);
/** Factory for {@link UInt|little-endian unsigned int layouts}
 * spanning four bytes. */ module.exports.u32 = (property)=>new $09c4e3f7de797447$var$UInt(4, property);
/** Factory for {@link UInt|little-endian unsigned int layouts}
 * spanning five bytes. */ module.exports.u40 = (property)=>new $09c4e3f7de797447$var$UInt(5, property);
/** Factory for {@link UInt|little-endian unsigned int layouts}
 * spanning six bytes. */ module.exports.u48 = (property)=>new $09c4e3f7de797447$var$UInt(6, property);
/** Factory for {@link NearUInt64|little-endian unsigned int
 * layouts} interpreted as Numbers. */ module.exports.nu64 = (property)=>new $09c4e3f7de797447$var$NearUInt64(property);
/** Factory for {@link UInt|big-endian unsigned int layouts}
 * spanning two bytes. */ module.exports.u16be = (property)=>new $09c4e3f7de797447$var$UIntBE(2, property);
/** Factory for {@link UInt|big-endian unsigned int layouts}
 * spanning three bytes. */ module.exports.u24be = (property)=>new $09c4e3f7de797447$var$UIntBE(3, property);
/** Factory for {@link UInt|big-endian unsigned int layouts}
 * spanning four bytes. */ module.exports.u32be = (property)=>new $09c4e3f7de797447$var$UIntBE(4, property);
/** Factory for {@link UInt|big-endian unsigned int layouts}
 * spanning five bytes. */ module.exports.u40be = (property)=>new $09c4e3f7de797447$var$UIntBE(5, property);
/** Factory for {@link UInt|big-endian unsigned int layouts}
 * spanning six bytes. */ module.exports.u48be = (property)=>new $09c4e3f7de797447$var$UIntBE(6, property);
/** Factory for {@link NearUInt64BE|big-endian unsigned int
 * layouts} interpreted as Numbers. */ module.exports.nu64be = (property)=>new $09c4e3f7de797447$var$NearUInt64BE(property);
/** Factory for {@link Int|signed int layouts} spanning one
 * byte. */ module.exports.s8 = (property)=>new $09c4e3f7de797447$var$Int(1, property);
/** Factory for {@link Int|little-endian signed int layouts}
 * spanning two bytes. */ module.exports.s16 = (property)=>new $09c4e3f7de797447$var$Int(2, property);
/** Factory for {@link Int|little-endian signed int layouts}
 * spanning three bytes. */ module.exports.s24 = (property)=>new $09c4e3f7de797447$var$Int(3, property);
/** Factory for {@link Int|little-endian signed int layouts}
 * spanning four bytes. */ module.exports.s32 = (property)=>new $09c4e3f7de797447$var$Int(4, property);
/** Factory for {@link Int|little-endian signed int layouts}
 * spanning five bytes. */ module.exports.s40 = (property)=>new $09c4e3f7de797447$var$Int(5, property);
/** Factory for {@link Int|little-endian signed int layouts}
 * spanning six bytes. */ module.exports.s48 = (property)=>new $09c4e3f7de797447$var$Int(6, property);
/** Factory for {@link NearInt64|little-endian signed int layouts}
 * interpreted as Numbers. */ module.exports.ns64 = (property)=>new $09c4e3f7de797447$var$NearInt64(property);
/** Factory for {@link Int|big-endian signed int layouts}
 * spanning two bytes. */ module.exports.s16be = (property)=>new $09c4e3f7de797447$var$IntBE(2, property);
/** Factory for {@link Int|big-endian signed int layouts}
 * spanning three bytes. */ module.exports.s24be = (property)=>new $09c4e3f7de797447$var$IntBE(3, property);
/** Factory for {@link Int|big-endian signed int layouts}
 * spanning four bytes. */ module.exports.s32be = (property)=>new $09c4e3f7de797447$var$IntBE(4, property);
/** Factory for {@link Int|big-endian signed int layouts}
 * spanning five bytes. */ module.exports.s40be = (property)=>new $09c4e3f7de797447$var$IntBE(5, property);
/** Factory for {@link Int|big-endian signed int layouts}
 * spanning six bytes. */ module.exports.s48be = (property)=>new $09c4e3f7de797447$var$IntBE(6, property);
/** Factory for {@link NearInt64BE|big-endian signed int layouts}
 * interpreted as Numbers. */ module.exports.ns64be = (property)=>new $09c4e3f7de797447$var$NearInt64BE(property);
/** Factory for {@link Float|little-endian 32-bit floating point} values. */ module.exports.f32 = (property)=>new $09c4e3f7de797447$var$Float(property);
/** Factory for {@link FloatBE|big-endian 32-bit floating point} values. */ module.exports.f32be = (property)=>new $09c4e3f7de797447$var$FloatBE(property);
/** Factory for {@link Double|little-endian 64-bit floating point} values. */ module.exports.f64 = (property)=>new $09c4e3f7de797447$var$Double(property);
/** Factory for {@link DoubleBE|big-endian 64-bit floating point} values. */ module.exports.f64be = (property)=>new $09c4e3f7de797447$var$DoubleBE(property);
/** Factory for {@link Structure} values. */ module.exports.struct = (fields, property, decodePrefixes)=>new $09c4e3f7de797447$var$Structure(fields, property, decodePrefixes);
/** Factory for {@link BitStructure} values. */ module.exports.bits = (word, msb, property)=>new $09c4e3f7de797447$var$BitStructure(word, msb, property);
/** Factory for {@link Sequence} values. */ module.exports.seq = (elementLayout, count, property)=>new $09c4e3f7de797447$var$Sequence(elementLayout, count, property);
/** Factory for {@link Union} values. */ module.exports.union = (discr, defaultLayout, property)=>new $09c4e3f7de797447$var$Union(discr, defaultLayout, property);
/** Factory for {@link UnionLayoutDiscriminator} values. */ module.exports.unionLayoutDiscriminator = (layout, property)=>new $09c4e3f7de797447$var$UnionLayoutDiscriminator(layout, property);
/** Factory for {@link Blob} values. */ module.exports.blob = (length, property)=>new $09c4e3f7de797447$var$Blob(length, property);
/** Factory for {@link CString} values. */ module.exports.cstr = (property)=>new $09c4e3f7de797447$var$CString(property);
/** Factory for {@link UTF8} values. */ module.exports.utf8 = (maxSpan, property)=>new $09c4e3f7de797447$var$UTF8(maxSpan, property);
/** Factory for {@link Constant} values. */ module.exports.constant = (value, property)=>new $09c4e3f7de797447$var$Constant(value, property);

});

parcelRegister("gyRuj", function(module, exports) {

var $6ZWSX = parcelRequire("6ZWSX");
var $c0e94fe1a84d811b$require$Buffer = $6ZWSX.Buffer;
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
let $c0e94fe1a84d811b$var$converter;
/**
 * Convert a little-endian buffer into a BigInt.
 * @param buf The little-endian buffer to convert
 * @returns A BigInt with the little-endian representation of buf.
 */ function $c0e94fe1a84d811b$var$toBigIntLE(buf) {
    {
        const reversed = $c0e94fe1a84d811b$require$Buffer.from(buf);
        reversed.reverse();
        const hex = reversed.toString("hex");
        if (hex.length === 0) return BigInt(0);
        return BigInt(`0x${hex}`);
    }
    return $c0e94fe1a84d811b$var$converter.toBigInt(buf, false);
}
module.exports.toBigIntLE = $c0e94fe1a84d811b$var$toBigIntLE;
/**
 * Convert a big-endian buffer into a BigInt
 * @param buf The big-endian buffer to convert.
 * @returns A BigInt with the big-endian representation of buf.
 */ function $c0e94fe1a84d811b$var$toBigIntBE(buf) {
    {
        const hex = buf.toString("hex");
        if (hex.length === 0) return BigInt(0);
        return BigInt(`0x${hex}`);
    }
    return $c0e94fe1a84d811b$var$converter.toBigInt(buf, true);
}
module.exports.toBigIntBE = $c0e94fe1a84d811b$var$toBigIntBE;
/**
 * Convert a BigInt to a little-endian buffer.
 * @param num   The BigInt to convert.
 * @param width The number of bytes that the resulting buffer should be.
 * @returns A little-endian buffer representation of num.
 */ function $c0e94fe1a84d811b$var$toBufferLE(num, width) {
    {
        const hex = num.toString(16);
        const buffer = $c0e94fe1a84d811b$require$Buffer.from(hex.padStart(width * 2, "0").slice(0, width * 2), "hex");
        buffer.reverse();
        return buffer;
    }
    // Allocation is done here, since it is slower using napi in C
    return $c0e94fe1a84d811b$var$converter.fromBigInt(num, $c0e94fe1a84d811b$require$Buffer.allocUnsafe(width), false);
}
module.exports.toBufferLE = $c0e94fe1a84d811b$var$toBufferLE;
/**
 * Convert a BigInt to a big-endian buffer.
 * @param num   The BigInt to convert.
 * @param width The number of bytes that the resulting buffer should be.
 * @returns A big-endian buffer representation of num.
 */ function $c0e94fe1a84d811b$var$toBufferBE(num, width) {
    {
        const hex = num.toString(16);
        return $c0e94fe1a84d811b$require$Buffer.from(hex.padStart(width * 2, "0").slice(0, width * 2), "hex");
    }
    return $c0e94fe1a84d811b$var$converter.fromBigInt(num, $c0e94fe1a84d811b$require$Buffer.allocUnsafe(width), true);
}
module.exports.toBufferBE = $c0e94fe1a84d811b$var$toBufferBE;

});

parcelRegister("kZFCD", function(module, exports) {

$parcel$export(module.exports, "assert", () => $f489ca74554b80bd$export$a7a9523472993e97);
$parcel$export(module.exports, "create", () => $f489ca74554b80bd$export$185802fd694ee1f5);
$parcel$export(module.exports, "optional", () => $f489ca74554b80bd$export$516e28dec6a4b6d4);
$parcel$export(module.exports, "any", () => $f489ca74554b80bd$export$4154a199d7d90455);
$parcel$export(module.exports, "array", () => $f489ca74554b80bd$export$2f23118c22fb2630);
$parcel$export(module.exports, "boolean", () => $f489ca74554b80bd$export$4a21f16c33752377);
$parcel$export(module.exports, "instance", () => $f489ca74554b80bd$export$9544d5bb712b01ea);
$parcel$export(module.exports, "literal", () => $f489ca74554b80bd$export$c8ec6e1ec9fefcb0);
$parcel$export(module.exports, "nullable", () => $f489ca74554b80bd$export$133fc36489ac9add);
$parcel$export(module.exports, "number", () => $f489ca74554b80bd$export$98e628dec113755e);
$parcel$export(module.exports, "record", () => $f489ca74554b80bd$export$e5185e241753e543);
$parcel$export(module.exports, "string", () => $f489ca74554b80bd$export$22b082955e083ec3);
$parcel$export(module.exports, "tuple", () => $f489ca74554b80bd$export$65e3907585753458);
$parcel$export(module.exports, "type", () => $f489ca74554b80bd$export$bf9fb029d174d554);
$parcel$export(module.exports, "union", () => $f489ca74554b80bd$export$971dd5b0dfd021b6);
$parcel$export(module.exports, "unknown", () => $f489ca74554b80bd$export$19282c40b967aec6);
$parcel$export(module.exports, "coerce", () => $f489ca74554b80bd$export$8c14e57e778d3873);
/**
 * A `StructFailure` represents a single specific failure in validation.
 */ /**
 * `StructError` objects are thrown (or returned) when validation fails.
 *
 * Validation logic is design to exit early for maximum performance. The error
 * represents the first error encountered during validation. For more detail,
 * the `error.failures` property is a generator function that can be run to
 * continue validation and receive all the failures in the data.
 */ class $f489ca74554b80bd$export$58cc9131e3e8861b extends TypeError {
    constructor(failure, failures){
        let cached;
        const { message: message, ...rest } = failure;
        const { path: path } = failure;
        const msg = path.length === 0 ? message : "At path: " + path.join(".") + " -- " + message;
        super(msg);
        Object.assign(this, rest);
        this.name = this.constructor.name;
        this.failures = ()=>{
            var _cached;
            return (_cached = cached) != null ? _cached : cached = [
                failure,
                ...failures()
            ];
        };
    }
}
/**
 * Check if a value is an iterator.
 */ function $f489ca74554b80bd$var$isIterable(x) {
    return $f489ca74554b80bd$var$isObject(x) && typeof x[Symbol.iterator] === "function";
}
/**
 * Check if a value is a plain object.
 */ function $f489ca74554b80bd$var$isObject(x) {
    return typeof x === "object" && x != null;
}
/**
 * Check if a value is a plain object.
 */ function $f489ca74554b80bd$var$isPlainObject(x) {
    if (Object.prototype.toString.call(x) !== "[object Object]") return false;
    const prototype = Object.getPrototypeOf(x);
    return prototype === null || prototype === Object.prototype;
}
/**
 * Return a value as a printable string.
 */ function $f489ca74554b80bd$var$print(value) {
    return typeof value === "string" ? JSON.stringify(value) : "" + value;
}
/**
 * Shifts (removes and returns) the first value from the `input` iterator.
 * Like `Array.prototype.shift()` but for an `Iterator`.
 */ function $f489ca74554b80bd$var$shiftIterator(input) {
    const { done: done, value: value } = input.next();
    return done ? undefined : value;
}
/**
 * Convert a single validation result to a failure.
 */ function $f489ca74554b80bd$var$toFailure(result, context, struct, value) {
    if (result === true) return;
    else if (result === false) result = {};
    else if (typeof result === "string") result = {
        message: result
    };
    const { path: path, branch: branch } = context;
    const { type: type } = struct;
    const { refinement: refinement, message: message = "Expected a value of type `" + type + "`" + (refinement ? " with refinement `" + refinement + "`" : "") + ", but received: `" + $f489ca74554b80bd$var$print(value) + "`" } = result;
    return {
        value: value,
        type: type,
        refinement: refinement,
        key: path[path.length - 1],
        path: path,
        branch: branch,
        ...result,
        message: message
    };
}
/**
 * Convert a validation result to an iterable of failures.
 */ function* $f489ca74554b80bd$var$toFailures(result, context, struct, value) {
    if (!$f489ca74554b80bd$var$isIterable(result)) result = [
        result
    ];
    for (const r of result){
        const failure = $f489ca74554b80bd$var$toFailure(r, context, struct, value);
        if (failure) yield failure;
    }
}
/**
 * Check a value against a struct, traversing deeply into nested values, and
 * returning an iterator of failures or success.
 */ function* $f489ca74554b80bd$var$run(value, struct, options = {}) {
    const { path: path = [], branch: branch = [
        value
    ], coerce: coerce = false, mask: mask = false } = options;
    const ctx = {
        path: path,
        branch: branch
    };
    if (coerce) {
        value = struct.coercer(value, ctx);
        if (mask && struct.type !== "type" && $f489ca74554b80bd$var$isObject(struct.schema) && $f489ca74554b80bd$var$isObject(value) && !Array.isArray(value)) {
            for(const key in value)if (struct.schema[key] === undefined) delete value[key];
        }
    }
    let valid = true;
    for (const failure of struct.validator(value, ctx)){
        valid = false;
        yield [
            failure,
            undefined
        ];
    }
    for (let [k, v, s] of struct.entries(value, ctx)){
        const ts = $f489ca74554b80bd$var$run(v, s, {
            path: k === undefined ? path : [
                ...path,
                k
            ],
            branch: k === undefined ? branch : [
                ...branch,
                v
            ],
            coerce: coerce,
            mask: mask
        });
        for (const t of ts){
            if (t[0]) {
                valid = false;
                yield [
                    t[0],
                    undefined
                ];
            } else if (coerce) {
                v = t[1];
                if (k === undefined) value = v;
                else if (value instanceof Map) value.set(k, v);
                else if (value instanceof Set) value.add(v);
                else if ($f489ca74554b80bd$var$isObject(value)) value[k] = v;
            }
        }
    }
    if (valid) for (const failure of struct.refiner(value, ctx)){
        valid = false;
        yield [
            failure,
            undefined
        ];
    }
    if (valid) yield [
        undefined,
        value
    ];
}
/**
 * `Struct` objects encapsulate the validation logic for a specific type of
 * values. Once constructed, you use the `assert`, `is` or `validate` helpers to
 * validate unknown input data against the struct.
 */ class $f489ca74554b80bd$export$eabc71f011df675a {
    constructor(props){
        const { type: type, schema: schema, validator: validator, refiner: refiner, coercer: coercer = (value)=>value, entries: entries = function*() {} } = props;
        this.type = type;
        this.schema = schema;
        this.entries = entries;
        this.coercer = coercer;
        if (validator) this.validator = (value, context)=>{
            const result = validator(value, context);
            return $f489ca74554b80bd$var$toFailures(result, context, this, value);
        };
        else this.validator = ()=>[];
        if (refiner) this.refiner = (value, context)=>{
            const result = refiner(value, context);
            return $f489ca74554b80bd$var$toFailures(result, context, this, value);
        };
        else this.refiner = ()=>[];
    }
    /**
   * Assert that a value passes the struct's validation, throwing if it doesn't.
   */ assert(value) {
        return $f489ca74554b80bd$export$a7a9523472993e97(value, this);
    }
    /**
   * Create a value with the struct's coercion logic, then validate it.
   */ create(value) {
        return $f489ca74554b80bd$export$185802fd694ee1f5(value, this);
    }
    /**
   * Check if a value passes the struct's validation.
   */ is(value) {
        return $f489ca74554b80bd$export$226b3eccf92c9ed9(value, this);
    }
    /**
   * Mask a value, coercing and validating it, but returning only the subset of
   * properties defined by the struct's schema.
   */ mask(value) {
        return $f489ca74554b80bd$export$d99f0801a68bbcf1(value, this);
    }
    /**
   * Validate a value with the struct's validation logic, returning a tuple
   * representing the result.
   *
   * You may optionally pass `true` for the `withCoercion` argument to coerce
   * the value before attempting to validate it. If you do, the result will
   * contain the coerced result when successful.
   */ validate(value, options = {}) {
        return $f489ca74554b80bd$export$a22775fa5e2eebd9(value, this, options);
    }
}
/**
 * Assert that a value passes a struct, throwing if it doesn't.
 */ function $f489ca74554b80bd$export$a7a9523472993e97(value, struct) {
    const result = $f489ca74554b80bd$export$a22775fa5e2eebd9(value, struct);
    if (result[0]) throw result[0];
}
/**
 * Create a value with the coercion logic of struct and validate it.
 */ function $f489ca74554b80bd$export$185802fd694ee1f5(value, struct) {
    const result = $f489ca74554b80bd$export$a22775fa5e2eebd9(value, struct, {
        coerce: true
    });
    if (result[0]) throw result[0];
    else return result[1];
}
/**
 * Mask a value, returning only the subset of properties defined by a struct.
 */ function $f489ca74554b80bd$export$d99f0801a68bbcf1(value, struct) {
    const result = $f489ca74554b80bd$export$a22775fa5e2eebd9(value, struct, {
        coerce: true,
        mask: true
    });
    if (result[0]) throw result[0];
    else return result[1];
}
/**
 * Check if a value passes a struct.
 */ function $f489ca74554b80bd$export$226b3eccf92c9ed9(value, struct) {
    const result = $f489ca74554b80bd$export$a22775fa5e2eebd9(value, struct);
    return !result[0];
}
/**
 * Validate a value against a struct, returning an error if invalid, or the
 * value (with potential coercion) if valid.
 */ function $f489ca74554b80bd$export$a22775fa5e2eebd9(value, struct, options = {}) {
    const tuples = $f489ca74554b80bd$var$run(value, struct, options);
    const tuple = $f489ca74554b80bd$var$shiftIterator(tuples);
    if (tuple[0]) {
        const error = new $f489ca74554b80bd$export$58cc9131e3e8861b(tuple[0], function*() {
            for (const t of tuples)if (t[0]) yield t[0];
        });
        return [
            error,
            undefined
        ];
    } else {
        const v = tuple[1];
        return [
            undefined,
            v
        ];
    }
}
function $f489ca74554b80bd$export$e6e34fd1f2686227(...Structs) {
    const schemas = Structs.map((s)=>s.schema);
    const schema = Object.assign({}, ...schemas);
    return $f489ca74554b80bd$export$be5493f9613cbbe(schema);
}
/**
 * Define a new struct type with a custom validation function.
 */ function $f489ca74554b80bd$export$f36d6a7a5c09a23e(name, validator) {
    return new $f489ca74554b80bd$export$eabc71f011df675a({
        type: name,
        schema: null,
        validator: validator
    });
}
/**
 * Create a new struct based on an existing struct, but the value is allowed to
 * be `undefined`. `log` will be called if the value is not `undefined`.
 */ function $f489ca74554b80bd$export$cdd73fc4100a6ef4(struct, log) {
    return new $f489ca74554b80bd$export$eabc71f011df675a({
        ...struct,
        refiner: (value, ctx)=>value === undefined || struct.refiner(value, ctx),
        validator (value, ctx) {
            if (value === undefined) return true;
            else {
                log(value, ctx);
                return struct.validator(value, ctx);
            }
        }
    });
}
/**
 * Create a struct with dynamic validation logic.
 *
 * The callback will receive the value currently being validated, and must
 * return a struct object to validate it with. This can be useful to model
 * validation logic that changes based on its input.
 */ function $f489ca74554b80bd$export$7077912c31975674(fn) {
    return new $f489ca74554b80bd$export$eabc71f011df675a({
        type: "dynamic",
        schema: null,
        *entries (value, ctx) {
            const struct = fn(value, ctx);
            yield* struct.entries(value, ctx);
        },
        validator (value, ctx) {
            const struct = fn(value, ctx);
            return struct.validator(value, ctx);
        },
        coercer (value, ctx) {
            const struct = fn(value, ctx);
            return struct.coercer(value, ctx);
        }
    });
}
/**
 * Create a struct with lazily evaluated validation logic.
 *
 * The first time validation is run with the struct, the callback will be called
 * and must return a struct object to use. This is useful for cases where you
 * want to have self-referential structs for nested data structures to avoid a
 * circular definition problem.
 */ function $f489ca74554b80bd$export$488013bae63b21da(fn) {
    let struct;
    return new $f489ca74554b80bd$export$eabc71f011df675a({
        type: "lazy",
        schema: null,
        *entries (value, ctx) {
            var _struct;
            (_struct = struct) != null ? _struct : struct = fn();
            yield* struct.entries(value, ctx);
        },
        validator (value, ctx) {
            var _struct2;
            (_struct2 = struct) != null ? _struct2 : struct = fn();
            return struct.validator(value, ctx);
        },
        coercer (value, ctx) {
            var _struct3;
            (_struct3 = struct) != null ? _struct3 : struct = fn();
            return struct.coercer(value, ctx);
        }
    });
}
/**
 * Create a new struct based on an existing object struct, but excluding
 * specific properties.
 *
 * Like TypeScript's `Omit` utility.
 */ function $f489ca74554b80bd$export$30a06c8d3562193f(struct, keys) {
    const { schema: schema } = struct;
    const subschema = {
        ...schema
    };
    for (const key of keys)delete subschema[key];
    return $f489ca74554b80bd$export$be5493f9613cbbe(subschema);
}
/**
 * Create a new struct based on an existing object struct, but with all of its
 * properties allowed to be `undefined`.
 *
 * Like TypeScript's `Partial` utility.
 */ function $f489ca74554b80bd$export$e45945969df8035a(struct) {
    const schema = struct instanceof $f489ca74554b80bd$export$eabc71f011df675a ? {
        ...struct.schema
    } : {
        ...struct
    };
    for(const key in schema)schema[key] = $f489ca74554b80bd$export$516e28dec6a4b6d4(schema[key]);
    return $f489ca74554b80bd$export$be5493f9613cbbe(schema);
}
/**
 * Create a new struct based on an existing object struct, but only including
 * specific properties.
 *
 * Like TypeScript's `Pick` utility.
 */ function $f489ca74554b80bd$export$357523c63a2253b9(struct, keys) {
    const { schema: schema } = struct;
    const subschema = {};
    for (const key of keys)subschema[key] = schema[key];
    return $f489ca74554b80bd$export$be5493f9613cbbe(subschema);
}
/**
 * Define a new struct type with a custom validation function.
 *
 * @deprecated This function has been renamed to `define`.
 */ function $f489ca74554b80bd$export$8cf3da7c1c9174ea(name, validator) {
    console.warn("superstruct@0.11 - The `struct` helper has been renamed to `define`.");
    return $f489ca74554b80bd$export$f36d6a7a5c09a23e(name, validator);
}
/**
 * Ensure that any value passes validation.
 */ function $f489ca74554b80bd$export$4154a199d7d90455() {
    return $f489ca74554b80bd$export$f36d6a7a5c09a23e("any", ()=>true);
}
function $f489ca74554b80bd$export$2f23118c22fb2630(Element) {
    return new $f489ca74554b80bd$export$eabc71f011df675a({
        type: "array",
        schema: Element,
        *entries (value) {
            if (Element && Array.isArray(value)) for (const [i, v] of value.entries())yield [
                i,
                v,
                Element
            ];
        },
        coercer (value) {
            return Array.isArray(value) ? value.slice() : value;
        },
        validator (value) {
            return Array.isArray(value) || "Expected an array value, but received: " + $f489ca74554b80bd$var$print(value);
        }
    });
}
/**
 * Ensure that a value is a boolean.
 */ function $f489ca74554b80bd$export$4a21f16c33752377() {
    return $f489ca74554b80bd$export$f36d6a7a5c09a23e("boolean", (value)=>{
        return typeof value === "boolean";
    });
}
/**
 * Ensure that a value is a valid `Date`.
 *
 * Note: this also ensures that the value is *not* an invalid `Date` object,
 * which can occur when parsing a date fails but still returns a `Date`.
 */ function $f489ca74554b80bd$export$324d90190a8b822a() {
    return $f489ca74554b80bd$export$f36d6a7a5c09a23e("date", (value)=>{
        return value instanceof Date && !isNaN(value.getTime()) || "Expected a valid `Date` object, but received: " + $f489ca74554b80bd$var$print(value);
    });
}
function $f489ca74554b80bd$export$9b16c434df8cc259(values) {
    const schema = {};
    const description = values.map((v)=>$f489ca74554b80bd$var$print(v)).join();
    for (const key of values)schema[key] = key;
    return new $f489ca74554b80bd$export$eabc71f011df675a({
        type: "enums",
        schema: schema,
        validator (value) {
            return values.includes(value) || "Expected one of `" + description + "`, but received: " + $f489ca74554b80bd$var$print(value);
        }
    });
}
/**
 * Ensure that a value is a function.
 */ function $f489ca74554b80bd$export$86951950244e2001() {
    return $f489ca74554b80bd$export$f36d6a7a5c09a23e("func", (value)=>{
        return typeof value === "function" || "Expected a function, but received: " + $f489ca74554b80bd$var$print(value);
    });
}
/**
 * Ensure that a value is an instance of a specific class.
 */ function $f489ca74554b80bd$export$9544d5bb712b01ea(Class) {
    return $f489ca74554b80bd$export$f36d6a7a5c09a23e("instance", (value)=>{
        return value instanceof Class || "Expected a `" + Class.name + "` instance, but received: " + $f489ca74554b80bd$var$print(value);
    });
}
/**
 * Ensure that a value is an integer.
 */ function $f489ca74554b80bd$export$32744b5b3bba4764() {
    return $f489ca74554b80bd$export$f36d6a7a5c09a23e("integer", (value)=>{
        return typeof value === "number" && !isNaN(value) && Number.isInteger(value) || "Expected an integer, but received: " + $f489ca74554b80bd$var$print(value);
    });
}
function $f489ca74554b80bd$export$bc86dfbf7795668c(Structs) {
    return new $f489ca74554b80bd$export$eabc71f011df675a({
        type: "intersection",
        schema: null,
        *entries (value, ctx) {
            for (const S of Structs)yield* S.entries(value, ctx);
        },
        *validator (value, ctx) {
            for (const S of Structs)yield* S.validator(value, ctx);
        },
        *refiner (value, ctx) {
            for (const S of Structs)yield* S.refiner(value, ctx);
        }
    });
}
function $f489ca74554b80bd$export$c8ec6e1ec9fefcb0(constant) {
    const description = $f489ca74554b80bd$var$print(constant);
    const t = typeof constant;
    return new $f489ca74554b80bd$export$eabc71f011df675a({
        type: "literal",
        schema: t === "string" || t === "number" || t === "boolean" ? constant : null,
        validator (value) {
            return value === constant || "Expected the literal `" + description + "`, but received: " + $f489ca74554b80bd$var$print(value);
        }
    });
}
function $f489ca74554b80bd$export$871de8747c9eaa88(Key, Value) {
    return new $f489ca74554b80bd$export$eabc71f011df675a({
        type: "map",
        schema: null,
        *entries (value) {
            if (Key && Value && value instanceof Map) for (const [k, v] of value.entries()){
                yield [
                    k,
                    k,
                    Key
                ];
                yield [
                    k,
                    v,
                    Value
                ];
            }
        },
        coercer (value) {
            return value instanceof Map ? new Map(value) : value;
        },
        validator (value) {
            return value instanceof Map || "Expected a `Map` object, but received: " + $f489ca74554b80bd$var$print(value);
        }
    });
}
/**
 * Ensure that no value ever passes validation.
 */ function $f489ca74554b80bd$export$b3e22bcfd64c1022() {
    return $f489ca74554b80bd$export$f36d6a7a5c09a23e("never", ()=>false);
}
/**
 * Augment an existing struct to allow `null` values.
 */ function $f489ca74554b80bd$export$133fc36489ac9add(struct) {
    return new $f489ca74554b80bd$export$eabc71f011df675a({
        ...struct,
        validator: (value, ctx)=>value === null || struct.validator(value, ctx),
        refiner: (value, ctx)=>value === null || struct.refiner(value, ctx)
    });
}
/**
 * Ensure that a value is a number.
 */ function $f489ca74554b80bd$export$98e628dec113755e() {
    return $f489ca74554b80bd$export$f36d6a7a5c09a23e("number", (value)=>{
        return typeof value === "number" && !isNaN(value) || "Expected a number, but received: " + $f489ca74554b80bd$var$print(value);
    });
}
function $f489ca74554b80bd$export$be5493f9613cbbe(schema) {
    const knowns = schema ? Object.keys(schema) : [];
    const Never = $f489ca74554b80bd$export$b3e22bcfd64c1022();
    return new $f489ca74554b80bd$export$eabc71f011df675a({
        type: "object",
        schema: schema ? schema : null,
        *entries (value) {
            if (schema && $f489ca74554b80bd$var$isObject(value)) {
                const unknowns = new Set(Object.keys(value));
                for (const key of knowns){
                    unknowns.delete(key);
                    yield [
                        key,
                        value[key],
                        schema[key]
                    ];
                }
                for (const key of unknowns)yield [
                    key,
                    value[key],
                    Never
                ];
            }
        },
        validator (value) {
            return $f489ca74554b80bd$var$isObject(value) || "Expected an object, but received: " + $f489ca74554b80bd$var$print(value);
        },
        coercer (value) {
            return $f489ca74554b80bd$var$isObject(value) ? {
                ...value
            } : value;
        }
    });
}
/**
 * Augment a struct to allow `undefined` values.
 */ function $f489ca74554b80bd$export$516e28dec6a4b6d4(struct) {
    return new $f489ca74554b80bd$export$eabc71f011df675a({
        ...struct,
        validator: (value, ctx)=>value === undefined || struct.validator(value, ctx),
        refiner: (value, ctx)=>value === undefined || struct.refiner(value, ctx)
    });
}
/**
 * Ensure that a value is an object with keys and values of specific types, but
 * without ensuring any specific shape of properties.
 *
 * Like TypeScript's `Record` utility.
 */ function $f489ca74554b80bd$export$e5185e241753e543(Key, Value) {
    return new $f489ca74554b80bd$export$eabc71f011df675a({
        type: "record",
        schema: null,
        *entries (value) {
            if ($f489ca74554b80bd$var$isObject(value)) for(const k in value){
                const v = value[k];
                yield [
                    k,
                    k,
                    Key
                ];
                yield [
                    k,
                    v,
                    Value
                ];
            }
        },
        validator (value) {
            return $f489ca74554b80bd$var$isObject(value) || "Expected an object, but received: " + $f489ca74554b80bd$var$print(value);
        }
    });
}
/**
 * Ensure that a value is a `RegExp`.
 *
 * Note: this does not test the value against the regular expression! For that
 * you need to use the `pattern()` refinement.
 */ function $f489ca74554b80bd$export$efdc1e5bdb609bb() {
    return $f489ca74554b80bd$export$f36d6a7a5c09a23e("regexp", (value)=>{
        return value instanceof RegExp;
    });
}
function $f489ca74554b80bd$export$adaa4cf7ef1b65be(Element) {
    return new $f489ca74554b80bd$export$eabc71f011df675a({
        type: "set",
        schema: null,
        *entries (value) {
            if (Element && value instanceof Set) for (const v of value)yield [
                v,
                v,
                Element
            ];
        },
        coercer (value) {
            return value instanceof Set ? new Set(value) : value;
        },
        validator (value) {
            return value instanceof Set || "Expected a `Set` object, but received: " + $f489ca74554b80bd$var$print(value);
        }
    });
}
/**
 * Ensure that a value is a string.
 */ function $f489ca74554b80bd$export$22b082955e083ec3() {
    return $f489ca74554b80bd$export$f36d6a7a5c09a23e("string", (value)=>{
        return typeof value === "string" || "Expected a string, but received: " + $f489ca74554b80bd$var$print(value);
    });
}
function $f489ca74554b80bd$export$65e3907585753458(Elements) {
    const Never = $f489ca74554b80bd$export$b3e22bcfd64c1022();
    return new $f489ca74554b80bd$export$eabc71f011df675a({
        type: "tuple",
        schema: null,
        *entries (value) {
            if (Array.isArray(value)) {
                const length = Math.max(Elements.length, value.length);
                for(let i = 0; i < length; i++)yield [
                    i,
                    value[i],
                    Elements[i] || Never
                ];
            }
        },
        validator (value) {
            return Array.isArray(value) || "Expected an array, but received: " + $f489ca74554b80bd$var$print(value);
        }
    });
}
/**
 * Ensure that a value has a set of known properties of specific types.
 *
 * Note: Unrecognized properties are allowed and untouched. This is similar to
 * how TypeScript's structural typing works.
 */ function $f489ca74554b80bd$export$bf9fb029d174d554(schema) {
    const keys = Object.keys(schema);
    return new $f489ca74554b80bd$export$eabc71f011df675a({
        type: "type",
        schema: schema,
        *entries (value) {
            if ($f489ca74554b80bd$var$isObject(value)) for (const k of keys)yield [
                k,
                value[k],
                schema[k]
            ];
        },
        validator (value) {
            return $f489ca74554b80bd$var$isObject(value) || "Expected an object, but received: " + $f489ca74554b80bd$var$print(value);
        }
    });
}
function $f489ca74554b80bd$export$971dd5b0dfd021b6(Structs) {
    const description = Structs.map((s)=>s.type).join(" | ");
    return new $f489ca74554b80bd$export$eabc71f011df675a({
        type: "union",
        schema: null,
        validator (value, ctx) {
            const failures = [];
            for (const S of Structs){
                const [...tuples] = $f489ca74554b80bd$var$run(value, S, ctx);
                const [first] = tuples;
                if (!first[0]) return [];
                else {
                    for (const [failure] of tuples)if (failure) failures.push(failure);
                }
            }
            return [
                "Expected the value to satisfy a union of `" + description + "`, but received: " + $f489ca74554b80bd$var$print(value),
                ...failures
            ];
        }
    });
}
/**
 * Ensure that any value passes validation, without widening its type to `any`.
 */ function $f489ca74554b80bd$export$19282c40b967aec6() {
    return $f489ca74554b80bd$export$f36d6a7a5c09a23e("unknown", ()=>true);
}
/**
 * Augment a `Struct` to add an additional coercion step to its input.
 *
 * This allows you to transform input data before validating it, to increase the
 * likelihood that it passes validation—for example for default values, parsing
 * different formats, etc.
 *
 * Note: You must use `create(value, Struct)` on the value to have the coercion
 * take effect! Using simply `assert()` or `is()` will not use coercion.
 */ function $f489ca74554b80bd$export$8c14e57e778d3873(struct, condition, coercer) {
    return new $f489ca74554b80bd$export$eabc71f011df675a({
        ...struct,
        coercer: (value, ctx)=>{
            return $f489ca74554b80bd$export$226b3eccf92c9ed9(value, condition) ? struct.coercer(coercer(value, ctx), ctx) : struct.coercer(value, ctx);
        }
    });
}
/**
 * Augment a struct to replace `undefined` values with a default.
 *
 * Note: You must use `create(value, Struct)` on the value to have the coercion
 * take effect! Using simply `assert()` or `is()` will not use coercion.
 */ function $f489ca74554b80bd$export$83c510c4356017ae(struct, fallback, options = {}) {
    return $f489ca74554b80bd$export$8c14e57e778d3873(struct, $f489ca74554b80bd$export$19282c40b967aec6(), (x)=>{
        const f = typeof fallback === "function" ? fallback() : fallback;
        if (x === undefined) return f;
        if (!options.strict && $f489ca74554b80bd$var$isPlainObject(x) && $f489ca74554b80bd$var$isPlainObject(f)) {
            const ret = {
                ...x
            };
            let changed = false;
            for(const key in f)if (ret[key] === undefined) {
                ret[key] = f[key];
                changed = true;
            }
            if (changed) return ret;
        }
        return x;
    });
}
/**
 * Augment a struct to trim string inputs.
 *
 * Note: You must use `create(value, Struct)` on the value to have the coercion
 * take effect! Using simply `assert()` or `is()` will not use coercion.
 */ function $f489ca74554b80bd$export$41f369984ed28930(struct) {
    return $f489ca74554b80bd$export$8c14e57e778d3873(struct, $f489ca74554b80bd$export$22b082955e083ec3(), (x)=>x.trim());
}
/**
 * Ensure that a string, array, map, or set is empty.
 */ function $f489ca74554b80bd$export$6e22c362a0406a2c(struct) {
    const expected = "Expected an empty " + struct.type;
    return $f489ca74554b80bd$export$edc9d475108b3212(struct, "empty", (value)=>{
        if (value instanceof Map || value instanceof Set) {
            const { size: size } = value;
            return size === 0 || expected + " but received one with a size of `" + size + "`";
        } else {
            const { length: length } = value;
            return length === 0 || expected + " but received one with a length of `" + length + "`";
        }
    });
}
/**
 * Ensure that a number or date is below a threshold.
 */ function $f489ca74554b80bd$export$8960430cfd85939f(struct, threshold, options = {}) {
    const { exclusive: exclusive } = options;
    return $f489ca74554b80bd$export$edc9d475108b3212(struct, "max", (value)=>{
        return exclusive ? value < threshold : value <= threshold || "Expected a " + struct.type + " greater than " + (exclusive ? "" : "or equal to ") + threshold + " but received `" + value + "`";
    });
}
/**
 * Ensure that a number or date is above a threshold.
 */ function $f489ca74554b80bd$export$96ec731ed4dcb222(struct, threshold, options = {}) {
    const { exclusive: exclusive } = options;
    return $f489ca74554b80bd$export$edc9d475108b3212(struct, "min", (value)=>{
        return exclusive ? value > threshold : value >= threshold || "Expected a " + struct.type + " greater than " + (exclusive ? "" : "or equal to ") + threshold + " but received `" + value + "`";
    });
}
/**
 * Ensure that a string matches a regular expression.
 */ function $f489ca74554b80bd$export$24f82734ea047e6f(struct, regexp) {
    return $f489ca74554b80bd$export$edc9d475108b3212(struct, "pattern", (value)=>{
        return regexp.test(value) || "Expected a " + struct.type + " matching `/" + regexp.source + '/` but received "' + value + '"';
    });
}
/**
 * Ensure that a string, array, number, date, map, or set has a size (or length, or time) between `min` and `max`.
 */ function $f489ca74554b80bd$export$346677f925de839c(struct, min, max = min) {
    const expected = "Expected a " + struct.type;
    const of = min === max ? "of `" + min + "`" : "between `" + min + "` and `" + max + "`";
    return $f489ca74554b80bd$export$edc9d475108b3212(struct, "size", (value)=>{
        if (typeof value === "number" || value instanceof Date) return min <= value && value <= max || expected + " " + of + " but received `" + value + "`";
        else if (value instanceof Map || value instanceof Set) {
            const { size: size } = value;
            return min <= size && size <= max || expected + " with a size " + of + " but received one with a size of `" + size + "`";
        } else {
            const { length: length } = value;
            return min <= length && length <= max || expected + " with a length " + of + " but received one with a length of `" + length + "`";
        }
    });
}
/**
 * Augment a `Struct` to add an additional refinement to the validation.
 *
 * The refiner function is guaranteed to receive a value of the struct's type,
 * because the struct's existing validation will already have passed. This
 * allows you to layer additional validation on top of existing structs.
 */ function $f489ca74554b80bd$export$edc9d475108b3212(struct, name, refiner) {
    return new $f489ca74554b80bd$export$eabc71f011df675a({
        ...struct,
        *refiner (value, ctx) {
            yield* struct.refiner(value, ctx);
            const result = refiner(value, ctx);
            const failures = $f489ca74554b80bd$var$toFailures(result, ctx, struct, value);
            for (const failure of failures)yield {
                ...failure,
                refinement: name
            };
        }
    });
}

});

parcelRegister("7pfXJ", function(module, exports) {
"use strict";

var $5sKyw = parcelRequire("5sKyw");
var $5647400503806718$require$uuid = $5sKyw.default;

var $4kTUs = parcelRequire("4kTUs");
/**
 * Constructor for a Jayson Browser Client that does not depend any node.js core libraries
 * @class ClientBrowser
 * @param {Function} callServer Method that calls the server, receives the stringified request and a regular node-style callback
 * @param {Object} [options]
 * @param {Function} [options.reviver] Reviver function for JSON
 * @param {Function} [options.replacer] Replacer function for JSON
 * @param {Number} [options.version=2] JSON-RPC version to use (1|2)
 * @param {Function} [options.generator] Function to use for generating request IDs
 *  @param {Boolean} [options.notificationIdNull=false] When true, version 2 requests will set id to null instead of omitting it
 * @return {ClientBrowser}
 */ const $5647400503806718$var$ClientBrowser = function(callServer, options) {
    if (!(this instanceof $5647400503806718$var$ClientBrowser)) return new $5647400503806718$var$ClientBrowser(callServer, options);
    if (!options) options = {};
    this.options = {
        reviver: typeof options.reviver !== "undefined" ? options.reviver : null,
        replacer: typeof options.replacer !== "undefined" ? options.replacer : null,
        generator: typeof options.generator !== "undefined" ? options.generator : function() {
            return $5647400503806718$require$uuid();
        },
        version: typeof options.version !== "undefined" ? options.version : 2,
        notificationIdNull: typeof options.notificationIdNull === "boolean" ? options.notificationIdNull : false
    };
    this.callServer = callServer;
};
module.exports = $5647400503806718$var$ClientBrowser;
/**
 *  Creates a request and dispatches it if given a callback.
 *  @param {String|Array} method A batch request if passed an Array, or a method name if passed a String
 *  @param {Array|Object} [params] Parameters for the method
 *  @param {String|Number} [id] Optional id. If undefined an id will be generated. If null it creates a notification request
 *  @param {Function} [callback] Request callback. If specified, executes the request rather than only returning it.
 *  @throws {TypeError} Invalid parameters
 *  @return {Object} JSON-RPC 1.0 or 2.0 compatible request
 */ $5647400503806718$var$ClientBrowser.prototype.request = function(method, params, id, callback) {
    const self = this;
    let request = null;
    // is this a batch request?
    const isBatch = Array.isArray(method) && typeof params === "function";
    if (this.options.version === 1 && isBatch) throw new TypeError("JSON-RPC 1.0 does not support batching");
    // is this a raw request?
    const isRaw = !isBatch && method && typeof method === "object" && typeof params === "function";
    if (isBatch || isRaw) {
        callback = params;
        request = method;
    } else {
        if (typeof id === "function") {
            callback = id;
            // specifically undefined because "null" is a notification request
            id = undefined;
        }
        const hasCallback = typeof callback === "function";
        try {
            request = $4kTUs(method, params, id, {
                generator: this.options.generator,
                version: this.options.version,
                notificationIdNull: this.options.notificationIdNull
            });
        } catch (err) {
            if (hasCallback) return callback(err);
            throw err;
        }
        // no callback means we should just return a raw request
        if (!hasCallback) return request;
    }
    let message;
    try {
        message = JSON.stringify(request, this.options.replacer);
    } catch (err) {
        return callback(err);
    }
    this.callServer(message, function(err, response) {
        self._parseResponse(err, response, callback);
    });
    // always return the raw request
    return request;
};
/**
 * Parses a response from a server
 * @param {Object} err Error to pass on that is unrelated to the actual response
 * @param {String} responseText JSON-RPC 1.0 or 2.0 response
 * @param {Function} callback Callback that will receive different arguments depending on the amount of parameters
 * @private
 */ $5647400503806718$var$ClientBrowser.prototype._parseResponse = function(err, responseText, callback) {
    if (err) {
        callback(err);
        return;
    }
    if (!responseText) // empty response text, assume that is correct because it could be a
    // notification which jayson does not give any body for
    return callback();
    let response;
    try {
        response = JSON.parse(responseText, this.options.reviver);
    } catch (err) {
        return callback(err);
    }
    if (callback.length === 3) {
        // if callback length is 3, we split callback arguments on error and response
        // is batch response?
        if (Array.isArray(response)) {
            // neccesary to split strictly on validity according to spec here
            const isError = function(res) {
                return typeof res.error !== "undefined";
            };
            const isNotError = function(res) {
                return !isError(res);
            };
            return callback(null, response.filter(isError), response.filter(isNotError));
        } else // split regardless of validity
        return callback(null, response.error, response.result);
    }
    callback(null, response);
};

});
parcelRegister("5sKyw", function(module, exports) {

$parcel$export(module.exports, "default", () => $3fa3ae484854b431$export$2e2bcd8739ae039);

var $7qKRb = parcelRequire("7qKRb");

var $2uohp = parcelRequire("2uohp");
function $3fa3ae484854b431$var$v4(options, buf, offset) {
    options = options || {};
    var rnds = options.random || (options.rng || (0, $7qKRb.default))(); // Per 4.4, set bits for version and `clock_seq_hi_and_reserved`
    rnds[6] = rnds[6] & 0x0f | 0x40;
    rnds[8] = rnds[8] & 0x3f | 0x80; // Copy bytes to buffer, if provided
    if (buf) {
        offset = offset || 0;
        for(var i = 0; i < 16; ++i)buf[offset + i] = rnds[i];
        return buf;
    }
    return (0, $2uohp.default)(rnds);
}
var $3fa3ae484854b431$export$2e2bcd8739ae039 = $3fa3ae484854b431$var$v4;

});
parcelRegister("7qKRb", function(module, exports) {

$parcel$export(module.exports, "default", () => $568f4ee4022ba00e$export$2e2bcd8739ae039);
// Unique ID creation requires a high quality random # generator. In the browser we therefore
// require the crypto API and do not support built-in fallback to lower quality random number
// generators (like Math.random()).
var $568f4ee4022ba00e$var$getRandomValues;
var $568f4ee4022ba00e$var$rnds8 = new Uint8Array(16);
function $568f4ee4022ba00e$export$2e2bcd8739ae039() {
    // lazy load so that environments that need to polyfill have a chance to do so
    if (!$568f4ee4022ba00e$var$getRandomValues) {
        // getRandomValues needs to be invoked in a context where "this" is a Crypto implementation. Also,
        // find the complete implementation of crypto (msCrypto) on IE11.
        $568f4ee4022ba00e$var$getRandomValues = typeof crypto !== "undefined" && crypto.getRandomValues && crypto.getRandomValues.bind(crypto) || typeof msCrypto !== "undefined" && typeof msCrypto.getRandomValues === "function" && msCrypto.getRandomValues.bind(msCrypto);
        if (!$568f4ee4022ba00e$var$getRandomValues) throw new Error("crypto.getRandomValues() not supported. See https://github.com/uuidjs/uuid#getrandomvalues-not-supported");
    }
    return $568f4ee4022ba00e$var$getRandomValues($568f4ee4022ba00e$var$rnds8);
}

});

parcelRegister("2uohp", function(module, exports) {

$parcel$export(module.exports, "default", () => $1d0137947e8554ce$export$2e2bcd8739ae039);

var $64ZUg = parcelRequire("64ZUg");
/**
 * Convert array of 16 byte values to UUID string format of the form:
 * XXXXXXXX-XXXX-XXXX-XXXX-XXXXXXXXXXXX
 */ var $1d0137947e8554ce$var$byteToHex = [];
for(var $1d0137947e8554ce$var$i = 0; $1d0137947e8554ce$var$i < 256; ++$1d0137947e8554ce$var$i)$1d0137947e8554ce$var$byteToHex.push(($1d0137947e8554ce$var$i + 0x100).toString(16).substr(1));
function $1d0137947e8554ce$var$stringify(arr) {
    var offset = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
    // Note: Be careful editing this code!  It's been tuned for performance
    // and works in ways you may not expect. See https://github.com/uuidjs/uuid/pull/434
    var uuid = ($1d0137947e8554ce$var$byteToHex[arr[offset + 0]] + $1d0137947e8554ce$var$byteToHex[arr[offset + 1]] + $1d0137947e8554ce$var$byteToHex[arr[offset + 2]] + $1d0137947e8554ce$var$byteToHex[arr[offset + 3]] + "-" + $1d0137947e8554ce$var$byteToHex[arr[offset + 4]] + $1d0137947e8554ce$var$byteToHex[arr[offset + 5]] + "-" + $1d0137947e8554ce$var$byteToHex[arr[offset + 6]] + $1d0137947e8554ce$var$byteToHex[arr[offset + 7]] + "-" + $1d0137947e8554ce$var$byteToHex[arr[offset + 8]] + $1d0137947e8554ce$var$byteToHex[arr[offset + 9]] + "-" + $1d0137947e8554ce$var$byteToHex[arr[offset + 10]] + $1d0137947e8554ce$var$byteToHex[arr[offset + 11]] + $1d0137947e8554ce$var$byteToHex[arr[offset + 12]] + $1d0137947e8554ce$var$byteToHex[arr[offset + 13]] + $1d0137947e8554ce$var$byteToHex[arr[offset + 14]] + $1d0137947e8554ce$var$byteToHex[arr[offset + 15]]).toLowerCase(); // Consistency check for valid UUID.  If this throws, it's likely due to one
    // of the following:
    // - One or more input array values don't map to a hex octet (leading to
    // "undefined" in the uuid)
    // - Invalid input values for the RFC `version` or `variant` fields
    if (!(0, $64ZUg.default)(uuid)) throw TypeError("Stringified UUID is invalid");
    return uuid;
}
var $1d0137947e8554ce$export$2e2bcd8739ae039 = $1d0137947e8554ce$var$stringify;

});
parcelRegister("64ZUg", function(module, exports) {

$parcel$export(module.exports, "default", () => $46d323206dcbf256$export$2e2bcd8739ae039);

var $4meF0 = parcelRequire("4meF0");
function $46d323206dcbf256$var$validate(uuid) {
    return typeof uuid === "string" && (0, $4meF0.default).test(uuid);
}
var $46d323206dcbf256$export$2e2bcd8739ae039 = $46d323206dcbf256$var$validate;

});
parcelRegister("4meF0", function(module, exports) {

$parcel$export(module.exports, "default", () => $32c496bfb6c27b56$export$2e2bcd8739ae039);
var $32c496bfb6c27b56$export$2e2bcd8739ae039 = /^(?:[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}|00000000-0000-0000-0000-000000000000)$/i;

});




parcelRegister("4kTUs", function(module, exports) {
"use strict";

var $5sKyw = parcelRequire("5sKyw");
var $3284662ae09c2cc1$require$uuid = $5sKyw.default;
/**
 *  Generates a JSON-RPC 1.0 or 2.0 request
 *  @param {String} method Name of method to call
 *  @param {Array|Object} params Array of parameters passed to the method as specified, or an object of parameter names and corresponding value
 *  @param {String|Number|null} [id] Request ID can be a string, number, null for explicit notification or left out for automatic generation
 *  @param {Object} [options]
 *  @param {Number} [options.version=2] JSON-RPC version to use (1 or 2)
 *  @param {Boolean} [options.notificationIdNull=false] When true, version 2 requests will set id to null instead of omitting it
 *  @param {Function} [options.generator] Passed the request, and the options object and is expected to return a request ID
 *  @throws {TypeError} If any of the parameters are invalid
 *  @return {Object} A JSON-RPC 1.0 or 2.0 request
 *  @memberOf Utils
 */ const $3284662ae09c2cc1$var$generateRequest = function(method, params, id, options) {
    if (typeof method !== "string") throw new TypeError(method + " must be a string");
    options = options || {};
    // check valid version provided
    const version = typeof options.version === "number" ? options.version : 2;
    if (version !== 1 && version !== 2) throw new TypeError(version + " must be 1 or 2");
    const request = {
        method: method
    };
    if (version === 2) request.jsonrpc = "2.0";
    if (params) {
        // params given, but invalid?
        if (typeof params !== "object" && !Array.isArray(params)) throw new TypeError(params + " must be an object, array or omitted");
        request.params = params;
    }
    // if id was left out, generate one (null means explicit notification)
    if (typeof id === "undefined") {
        const generator = typeof options.generator === "function" ? options.generator : function() {
            return $3284662ae09c2cc1$require$uuid();
        };
        request.id = generator(request, options);
    } else if (version === 2 && id === null) // we have a version 2 notification
    {
        if (options.notificationIdNull) request.id = null; // id will not be set at all unless option provided
    } else request.id = id;
    return request;
};
module.exports = $3284662ae09c2cc1$var$generateRequest;

});


parcelRegister("9aP4M", function(module, exports) {
/**
 * "Client" wraps "ws" or a browser-implemented "WebSocket" library
 * according to the environment providing JSON RPC 2.0 support on top.
 * @module Client
 */ 
var $6ZWSX = parcelRequire("6ZWSX");
var $6adcaae0654f4641$require$Buffer = $6ZWSX.Buffer;
"use strict";

var $1jnue = parcelRequire("1jnue");
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports["default"] = void 0;

var $6adcaae0654f4641$var$_regenerator = $1jnue((parcelRequire("h1Oiy")));

var $6adcaae0654f4641$var$_asyncToGenerator2 = $1jnue((parcelRequire("fOd0O")));

var $6adcaae0654f4641$var$_typeof2 = $1jnue((parcelRequire("41YNz")));

var $6adcaae0654f4641$var$_classCallCheck2 = $1jnue((parcelRequire("fu0YK")));

var $6adcaae0654f4641$var$_createClass2 = $1jnue((parcelRequire("lR7jo")));

var $6adcaae0654f4641$var$_inherits2 = $1jnue((parcelRequire("f8wIT")));

var $6adcaae0654f4641$var$_possibleConstructorReturn2 = $1jnue((parcelRequire("eN9hz")));

var $6adcaae0654f4641$var$_getPrototypeOf2 = $1jnue((parcelRequire("cGTaw")));

var $3vRz3 = parcelRequire("3vRz3");
function $6adcaae0654f4641$var$_createSuper(Derived) {
    var hasNativeReflectConstruct = $6adcaae0654f4641$var$_isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = (0, $6adcaae0654f4641$var$_getPrototypeOf2["default"])(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = (0, $6adcaae0654f4641$var$_getPrototypeOf2["default"])(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return (0, $6adcaae0654f4641$var$_possibleConstructorReturn2["default"])(this, result);
    };
}
function $6adcaae0654f4641$var$_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
var $6adcaae0654f4641$var$__rest = function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
// @ts-ignore
var $6adcaae0654f4641$var$CommonClient = /*#__PURE__*/ function(_EventEmitter) {
    (0, $6adcaae0654f4641$var$_inherits2["default"])(CommonClient, _EventEmitter);
    var _super = $6adcaae0654f4641$var$_createSuper(CommonClient);
    /**
   * Instantiate a Client class.
   * @constructor
   * @param {webSocketFactory} webSocketFactory - factory method for WebSocket
   * @param {String} address - url to a websocket server
   * @param {Object} options - ws options object with reconnect parameters
   * @param {Function} generate_request_id - custom generation request Id
   * @return {CommonClient}
   */ function CommonClient(webSocketFactory) {
        var _this;
        var address = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "ws://localhost:8080";
        var _a = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
        var generate_request_id = arguments.length > 3 ? arguments[3] : undefined;
        (0, $6adcaae0654f4641$var$_classCallCheck2["default"])(this, CommonClient);
        var _a$autoconnect = _a.autoconnect, autoconnect = _a$autoconnect === void 0 ? true : _a$autoconnect, _a$reconnect = _a.reconnect, reconnect = _a$reconnect === void 0 ? true : _a$reconnect, _a$reconnect_interval = _a.reconnect_interval, reconnect_interval = _a$reconnect_interval === void 0 ? 1000 : _a$reconnect_interval, _a$max_reconnects = _a.max_reconnects, max_reconnects = _a$max_reconnects === void 0 ? 5 : _a$max_reconnects, rest_options = $6adcaae0654f4641$var$__rest(_a, [
            "autoconnect",
            "reconnect",
            "reconnect_interval",
            "max_reconnects"
        ]);
        _this = _super.call(this);
        _this.webSocketFactory = webSocketFactory;
        _this.queue = {};
        _this.rpc_id = 0;
        _this.address = address;
        _this.autoconnect = autoconnect;
        _this.ready = false;
        _this.reconnect = reconnect;
        _this.reconnect_timer_id = undefined;
        _this.reconnect_interval = reconnect_interval;
        _this.max_reconnects = max_reconnects;
        _this.rest_options = rest_options;
        _this.current_reconnects = 0;
        _this.generate_request_id = generate_request_id || function() {
            return ++_this.rpc_id;
        };
        if (_this.autoconnect) _this._connect(_this.address, Object.assign({
            autoconnect: _this.autoconnect,
            reconnect: _this.reconnect,
            reconnect_interval: _this.reconnect_interval,
            max_reconnects: _this.max_reconnects
        }, _this.rest_options));
        return _this;
    }
    /**
   * Connects to a defined server if not connected already.
   * @method
   * @return {Undefined}
   */ (0, $6adcaae0654f4641$var$_createClass2["default"])(CommonClient, [
        {
            key: "connect",
            value: function connect() {
                if (this.socket) return;
                this._connect(this.address, Object.assign({
                    autoconnect: this.autoconnect,
                    reconnect: this.reconnect,
                    reconnect_interval: this.reconnect_interval,
                    max_reconnects: this.max_reconnects
                }, this.rest_options));
            }
        },
        {
            key: "call",
            value: function call(method, params, timeout, ws_opts) {
                var _this2 = this;
                if (!ws_opts && "object" === (0, $6adcaae0654f4641$var$_typeof2["default"])(timeout)) {
                    ws_opts = timeout;
                    timeout = null;
                }
                return new Promise(function(resolve, reject) {
                    if (!_this2.ready) return reject(new Error("socket not ready"));
                    var rpc_id = _this2.generate_request_id(method, params);
                    var message = {
                        jsonrpc: "2.0",
                        method: method,
                        params: params || null,
                        id: rpc_id
                    };
                    _this2.socket.send(JSON.stringify(message), ws_opts, function(error) {
                        if (error) return reject(error);
                        _this2.queue[rpc_id] = {
                            promise: [
                                resolve,
                                reject
                            ]
                        };
                        if (timeout) _this2.queue[rpc_id].timeout = setTimeout(function() {
                            delete _this2.queue[rpc_id];
                            reject(new Error("reply timeout"));
                        }, timeout);
                    });
                });
            }
        },
        {
            key: "login",
            value: function() {
                var _login = (0, $6adcaae0654f4641$var$_asyncToGenerator2["default"])(/*#__PURE__*/ $6adcaae0654f4641$var$_regenerator["default"].mark(function _callee(params) {
                    var resp;
                    return $6adcaae0654f4641$var$_regenerator["default"].wrap(function _callee$(_context) {
                        while(true)switch(_context.prev = _context.next){
                            case 0:
                                _context.next = 2;
                                return this.call("rpc.login", params);
                            case 2:
                                resp = _context.sent;
                                if (resp) {
                                    _context.next = 5;
                                    break;
                                }
                                throw new Error("authentication failed");
                            case 5:
                                return _context.abrupt("return", resp);
                            case 6:
                            case "end":
                                return _context.stop();
                        }
                    }, _callee, this);
                }));
                function login(_x) {
                    return _login.apply(this, arguments);
                }
                return login;
            }()
        },
        {
            key: "listMethods",
            value: function() {
                var _listMethods = (0, $6adcaae0654f4641$var$_asyncToGenerator2["default"])(/*#__PURE__*/ $6adcaae0654f4641$var$_regenerator["default"].mark(function _callee2() {
                    return $6adcaae0654f4641$var$_regenerator["default"].wrap(function _callee2$(_context2) {
                        while(true)switch(_context2.prev = _context2.next){
                            case 0:
                                _context2.next = 2;
                                return this.call("__listMethods");
                            case 2:
                                return _context2.abrupt("return", _context2.sent);
                            case 3:
                            case "end":
                                return _context2.stop();
                        }
                    }, _callee2, this);
                }));
                function listMethods() {
                    return _listMethods.apply(this, arguments);
                }
                return listMethods;
            }()
        },
        {
            key: "notify",
            value: function notify(method, params) {
                var _this3 = this;
                return new Promise(function(resolve, reject) {
                    if (!_this3.ready) return reject(new Error("socket not ready"));
                    var message = {
                        jsonrpc: "2.0",
                        method: method,
                        params: params || null
                    };
                    _this3.socket.send(JSON.stringify(message), function(error) {
                        if (error) return reject(error);
                        resolve();
                    });
                });
            }
        },
        {
            key: "subscribe",
            value: function() {
                var _subscribe = (0, $6adcaae0654f4641$var$_asyncToGenerator2["default"])(/*#__PURE__*/ $6adcaae0654f4641$var$_regenerator["default"].mark(function _callee3(event) {
                    var result;
                    return $6adcaae0654f4641$var$_regenerator["default"].wrap(function _callee3$(_context3) {
                        while(true)switch(_context3.prev = _context3.next){
                            case 0:
                                if (typeof event === "string") event = [
                                    event
                                ];
                                _context3.next = 3;
                                return this.call("rpc.on", event);
                            case 3:
                                result = _context3.sent;
                                if (!(typeof event === "string" && result[event] !== "ok")) {
                                    _context3.next = 6;
                                    break;
                                }
                                throw new Error("Failed subscribing to an event '" + event + "' with: " + result[event]);
                            case 6:
                                return _context3.abrupt("return", result);
                            case 7:
                            case "end":
                                return _context3.stop();
                        }
                    }, _callee3, this);
                }));
                function subscribe(_x2) {
                    return _subscribe.apply(this, arguments);
                }
                return subscribe;
            }()
        },
        {
            key: "unsubscribe",
            value: function() {
                var _unsubscribe = (0, $6adcaae0654f4641$var$_asyncToGenerator2["default"])(/*#__PURE__*/ $6adcaae0654f4641$var$_regenerator["default"].mark(function _callee4(event) {
                    var result;
                    return $6adcaae0654f4641$var$_regenerator["default"].wrap(function _callee4$(_context4) {
                        while(true)switch(_context4.prev = _context4.next){
                            case 0:
                                if (typeof event === "string") event = [
                                    event
                                ];
                                _context4.next = 3;
                                return this.call("rpc.off", event);
                            case 3:
                                result = _context4.sent;
                                if (!(typeof event === "string" && result[event] !== "ok")) {
                                    _context4.next = 6;
                                    break;
                                }
                                throw new Error("Failed unsubscribing from an event with: " + result);
                            case 6:
                                return _context4.abrupt("return", result);
                            case 7:
                            case "end":
                                return _context4.stop();
                        }
                    }, _callee4, this);
                }));
                function unsubscribe(_x3) {
                    return _unsubscribe.apply(this, arguments);
                }
                return unsubscribe;
            }()
        },
        {
            key: "close",
            value: function close(code, data) {
                this.socket.close(code || 1000, data);
            }
        },
        {
            key: "_connect",
            value: function _connect(address, options) {
                var _this4 = this;
                clearTimeout(this.reconnect_timer_id);
                this.socket = this.webSocketFactory(address, options);
                this.socket.addEventListener("open", function() {
                    _this4.ready = true;
                    _this4.emit("open");
                    _this4.current_reconnects = 0;
                });
                this.socket.addEventListener("message", function(_ref) {
                    var message = _ref.data;
                    if (message instanceof ArrayBuffer) message = $6adcaae0654f4641$require$Buffer.from(message).toString();
                    try {
                        message = JSON.parse(message);
                    } catch (error) {
                        return;
                    }
                    // check if any listeners are attached and forward event
                    if (message.notification && _this4.listeners(message.notification).length) {
                        if (!Object.keys(message.params).length) return _this4.emit(message.notification);
                        var args = [
                            message.notification
                        ];
                        if (message.params.constructor === Object) args.push(message.params);
                        else // using for-loop instead of unshift/spread because performance is better
                        for(var i = 0; i < message.params.length; i++)args.push(message.params[i]);
                        // run as microtask so that pending queue messages are resolved first
                        // eslint-disable-next-line prefer-spread
                        return Promise.resolve().then(function() {
                            _this4.emit.apply(_this4, args);
                        });
                    }
                    if (!_this4.queue[message.id]) {
                        // general JSON RPC 2.0 events
                        if (message.method && message.params) // run as microtask so that pending queue messages are resolved first
                        return Promise.resolve().then(function() {
                            _this4.emit(message.method, message.params);
                        });
                        return;
                    }
                    // reject early since server's response is invalid
                    if ("error" in message === "result" in message) _this4.queue[message.id].promise[1](new Error('Server response malformed. Response must include either "result" or "error", but not both.'));
                    if (_this4.queue[message.id].timeout) clearTimeout(_this4.queue[message.id].timeout);
                    if (message.error) _this4.queue[message.id].promise[1](message.error);
                    else _this4.queue[message.id].promise[0](message.result);
                    delete _this4.queue[message.id];
                });
                this.socket.addEventListener("error", function(error) {
                    return _this4.emit("error", error);
                });
                this.socket.addEventListener("close", function(_ref2) {
                    var code = _ref2.code, reason = _ref2.reason;
                    if (_this4.ready) // Delay close event until internal state is updated
                    setTimeout(function() {
                        return _this4.emit("close", code, reason);
                    }, 0);
                    _this4.ready = false;
                    _this4.socket = undefined;
                    if (code === 1000) return;
                    _this4.current_reconnects++;
                    if (_this4.reconnect && (_this4.max_reconnects > _this4.current_reconnects || _this4.max_reconnects === 0)) _this4.reconnect_timer_id = setTimeout(function() {
                        return _this4._connect(address, options);
                    }, _this4.reconnect_interval);
                });
            }
        }
    ]);
    return CommonClient;
}($3vRz3.EventEmitter);
module.exports["default"] = $6adcaae0654f4641$var$CommonClient;

});
parcelRegister("1jnue", function(module, exports) {
function $0f49c8ba50dff6ee$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        "default": obj
    };
}
module.exports = $0f49c8ba50dff6ee$var$_interopRequireDefault, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRegister("h1Oiy", function(module, exports) {
// TODO(Babel 8): Remove this file.

var $c6598bdb60f83fe0$var$runtime = (parcelRequire("8HV7i"))();
module.exports = $c6598bdb60f83fe0$var$runtime;
// Copied from https://github.com/facebook/regenerator/blob/main/packages/runtime/runtime.js#L736=
try {
    regeneratorRuntime = $c6598bdb60f83fe0$var$runtime;
} catch (accidentalStrictMode) {
    if (typeof globalThis === "object") globalThis.regeneratorRuntime = $c6598bdb60f83fe0$var$runtime;
    else Function("r", "regeneratorRuntime = r")($c6598bdb60f83fe0$var$runtime);
}

});
parcelRegister("8HV7i", function(module, exports) {

var $41YNz = parcelRequire("41YNz");
var $656ea513998a70a9$var$_typeof = $41YNz.default;
function $656ea513998a70a9$var$_regeneratorRuntime() {
    "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ 
    module.exports = $656ea513998a70a9$var$_regeneratorRuntime = function _regeneratorRuntime() {
        return e;
    }, module.exports.__esModule = true, module.exports["default"] = module.exports;
    var t, e = {}, r = Object.prototype, n = r.hasOwnProperty, o = Object.defineProperty || function(t, e, r) {
        t[e] = r.value;
    }, i = "function" == typeof Symbol ? Symbol : {}, a = i.iterator || "@@iterator", c = i.asyncIterator || "@@asyncIterator", u = i.toStringTag || "@@toStringTag";
    function define(t, e, r) {
        return Object.defineProperty(t, e, {
            value: r,
            enumerable: !0,
            configurable: !0,
            writable: !0
        }), t[e];
    }
    try {
        define({}, "");
    } catch (t) {
        define = function define(t, e, r) {
            return t[e] = r;
        };
    }
    function wrap(t, e, r, n) {
        var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype), c = new Context(n || []);
        return o(a, "_invoke", {
            value: makeInvokeMethod(t, r, c)
        }), a;
    }
    function tryCatch(t, e, r) {
        try {
            return {
                type: "normal",
                arg: t.call(e, r)
            };
        } catch (t) {
            return {
                type: "throw",
                arg: t
            };
        }
    }
    e.wrap = wrap;
    var h = "suspendedStart", l = "suspendedYield", f = "executing", s = "completed", y = {};
    function Generator() {}
    function GeneratorFunction() {}
    function GeneratorFunctionPrototype() {}
    var p = {};
    define(p, a, function() {
        return this;
    });
    var d = Object.getPrototypeOf, v = d && d(d(values([])));
    v && v !== r && n.call(v, a) && (p = v);
    var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p);
    function defineIteratorMethods(t) {
        [
            "next",
            "throw",
            "return"
        ].forEach(function(e) {
            define(t, e, function(t) {
                return this._invoke(e, t);
            });
        });
    }
    function AsyncIterator(t, e) {
        function invoke(r, o, i, a) {
            var c = tryCatch(t[r], t, o);
            if ("throw" !== c.type) {
                var u = c.arg, h = u.value;
                return h && "object" == $656ea513998a70a9$var$_typeof(h) && n.call(h, "__await") ? e.resolve(h.__await).then(function(t) {
                    invoke("next", t, i, a);
                }, function(t) {
                    invoke("throw", t, i, a);
                }) : e.resolve(h).then(function(t) {
                    u.value = t, i(u);
                }, function(t) {
                    return invoke("throw", t, i, a);
                });
            }
            a(c.arg);
        }
        var r;
        o(this, "_invoke", {
            value: function value(t, n) {
                function callInvokeWithMethodAndArg() {
                    return new e(function(e, r) {
                        invoke(t, n, e, r);
                    });
                }
                return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg();
            }
        });
    }
    function makeInvokeMethod(e, r, n) {
        var o = h;
        return function(i, a) {
            if (o === f) throw new Error("Generator is already running");
            if (o === s) {
                if ("throw" === i) throw a;
                return {
                    value: t,
                    done: !0
                };
            }
            for(n.method = i, n.arg = a;;){
                var c = n.delegate;
                if (c) {
                    var u = maybeInvokeDelegate(c, n);
                    if (u) {
                        if (u === y) continue;
                        return u;
                    }
                }
                if ("next" === n.method) n.sent = n._sent = n.arg;
                else if ("throw" === n.method) {
                    if (o === h) throw o = s, n.arg;
                    n.dispatchException(n.arg);
                } else "return" === n.method && n.abrupt("return", n.arg);
                o = f;
                var p = tryCatch(e, r, n);
                if ("normal" === p.type) {
                    if (o = n.done ? s : l, p.arg === y) continue;
                    return {
                        value: p.arg,
                        done: n.done
                    };
                }
                "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg);
            }
        };
    }
    function maybeInvokeDelegate(e, r) {
        var n = r.method, o = e.iterator[n];
        if (o === t) return r.delegate = null, "throw" === n && e.iterator["return"] && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y;
        var i = tryCatch(o, e.iterator, r.arg);
        if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y;
        var a = i.arg;
        return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y);
    }
    function pushTryEntry(t) {
        var e = {
            tryLoc: t[0]
        };
        1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e);
    }
    function resetTryEntry(t) {
        var e = t.completion || {};
        e.type = "normal", delete e.arg, t.completion = e;
    }
    function Context(t) {
        this.tryEntries = [
            {
                tryLoc: "root"
            }
        ], t.forEach(pushTryEntry, this), this.reset(!0);
    }
    function values(e) {
        if (e || "" === e) {
            var r = e[a];
            if (r) return r.call(e);
            if ("function" == typeof e.next) return e;
            if (!isNaN(e.length)) {
                var o = -1, i = function next() {
                    for(; ++o < e.length;)if (n.call(e, o)) return next.value = e[o], next.done = !1, next;
                    return next.value = t, next.done = !0, next;
                };
                return i.next = i;
            }
        }
        throw new TypeError($656ea513998a70a9$var$_typeof(e) + " is not iterable");
    }
    return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", {
        value: GeneratorFunctionPrototype,
        configurable: !0
    }), o(GeneratorFunctionPrototype, "constructor", {
        value: GeneratorFunction,
        configurable: !0
    }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function(t) {
        var e = "function" == typeof t && t.constructor;
        return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name));
    }, e.mark = function(t) {
        return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t;
    }, e.awrap = function(t) {
        return {
            __await: t
        };
    }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function() {
        return this;
    }), e.AsyncIterator = AsyncIterator, e.async = function(t, r, n, o, i) {
        void 0 === i && (i = Promise);
        var a = new AsyncIterator(wrap(t, r, n, o), i);
        return e.isGeneratorFunction(r) ? a : a.next().then(function(t) {
            return t.done ? t.value : a.next();
        });
    }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function() {
        return this;
    }), define(g, "toString", function() {
        return "[object Generator]";
    }), e.keys = function(t) {
        var e = Object(t), r = [];
        for(var n in e)r.push(n);
        return r.reverse(), function next() {
            for(; r.length;){
                var t = r.pop();
                if (t in e) return next.value = t, next.done = !1, next;
            }
            return next.done = !0, next;
        };
    }, e.values = values, Context.prototype = {
        constructor: Context,
        reset: function reset(e) {
            if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for(var r in this)"t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t);
        },
        stop: function stop() {
            this.done = !0;
            var t = this.tryEntries[0].completion;
            if ("throw" === t.type) throw t.arg;
            return this.rval;
        },
        dispatchException: function dispatchException(e) {
            if (this.done) throw e;
            var r = this;
            function handle(n, o) {
                return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o;
            }
            for(var o = this.tryEntries.length - 1; o >= 0; --o){
                var i = this.tryEntries[o], a = i.completion;
                if ("root" === i.tryLoc) return handle("end");
                if (i.tryLoc <= this.prev) {
                    var c = n.call(i, "catchLoc"), u = n.call(i, "finallyLoc");
                    if (c && u) {
                        if (this.prev < i.catchLoc) return handle(i.catchLoc, !0);
                        if (this.prev < i.finallyLoc) return handle(i.finallyLoc);
                    } else if (c) {
                        if (this.prev < i.catchLoc) return handle(i.catchLoc, !0);
                    } else {
                        if (!u) throw new Error("try statement without catch or finally");
                        if (this.prev < i.finallyLoc) return handle(i.finallyLoc);
                    }
                }
            }
        },
        abrupt: function abrupt(t, e) {
            for(var r = this.tryEntries.length - 1; r >= 0; --r){
                var o = this.tryEntries[r];
                if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) {
                    var i = o;
                    break;
                }
            }
            i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null);
            var a = i ? i.completion : {};
            return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a);
        },
        complete: function complete(t, e) {
            if ("throw" === t.type) throw t.arg;
            return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y;
        },
        finish: function finish(t) {
            for(var e = this.tryEntries.length - 1; e >= 0; --e){
                var r = this.tryEntries[e];
                if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y;
            }
        },
        "catch": function _catch(t) {
            for(var e = this.tryEntries.length - 1; e >= 0; --e){
                var r = this.tryEntries[e];
                if (r.tryLoc === t) {
                    var n = r.completion;
                    if ("throw" === n.type) {
                        var o = n.arg;
                        resetTryEntry(r);
                    }
                    return o;
                }
            }
            throw new Error("illegal catch attempt");
        },
        delegateYield: function delegateYield(e, r, n) {
            return this.delegate = {
                iterator: values(e),
                resultName: r,
                nextLoc: n
            }, "next" === this.method && (this.arg = t), y;
        }
    }, e;
}
module.exports = $656ea513998a70a9$var$_regeneratorRuntime, module.exports.__esModule = true, module.exports["default"] = module.exports;

});
parcelRegister("41YNz", function(module, exports) {
function $2ef66ab8c52ac1c0$var$_typeof(o) {
    "@babel/helpers - typeof";
    return module.exports = $2ef66ab8c52ac1c0$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, module.exports.__esModule = true, module.exports["default"] = module.exports, $2ef66ab8c52ac1c0$var$_typeof(o);
}
module.exports = $2ef66ab8c52ac1c0$var$_typeof, module.exports.__esModule = true, module.exports["default"] = module.exports;

});



parcelRegister("fOd0O", function(module, exports) {
function $b8259e79f5c77a6f$var$asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) resolve(value);
    else Promise.resolve(value).then(_next, _throw);
}
function $b8259e79f5c77a6f$var$_asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                $b8259e79f5c77a6f$var$asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                $b8259e79f5c77a6f$var$asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
module.exports = $b8259e79f5c77a6f$var$_asyncToGenerator, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRegister("fu0YK", function(module, exports) {
function $b45a6abf916bff88$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
module.exports = $b45a6abf916bff88$var$_classCallCheck, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRegister("lR7jo", function(module, exports) {

var $5DKOa = parcelRequire("5DKOa");
function $fe9438347a673ba6$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, $5DKOa(descriptor.key), descriptor);
    }
}
function $fe9438347a673ba6$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $fe9438347a673ba6$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $fe9438347a673ba6$var$_defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}
module.exports = $fe9438347a673ba6$var$_createClass, module.exports.__esModule = true, module.exports["default"] = module.exports;

});
parcelRegister("5DKOa", function(module, exports) {

var $41YNz = parcelRequire("41YNz");
var $010f4e0e13c82e16$var$_typeof = $41YNz.default;

var $fKGZD = parcelRequire("fKGZD");
function $010f4e0e13c82e16$var$_toPropertyKey(arg) {
    var key = $fKGZD(arg, "string");
    return $010f4e0e13c82e16$var$_typeof(key) === "symbol" ? key : String(key);
}
module.exports = $010f4e0e13c82e16$var$_toPropertyKey, module.exports.__esModule = true, module.exports["default"] = module.exports;

});
parcelRegister("fKGZD", function(module, exports) {

var $41YNz = parcelRequire("41YNz");
var $b77c8068776c2a21$var$_typeof = $41YNz.default;
function $b77c8068776c2a21$var$_toPrimitive(input, hint) {
    if ($b77c8068776c2a21$var$_typeof(input) !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if ($b77c8068776c2a21$var$_typeof(res) !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
module.exports = $b77c8068776c2a21$var$_toPrimitive, module.exports.__esModule = true, module.exports["default"] = module.exports;

});



parcelRegister("f8wIT", function(module, exports) {

var $aAhot = parcelRequire("aAhot");
function $b050fc8434f4a0e1$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    Object.defineProperty(subClass, "prototype", {
        writable: false
    });
    if (superClass) $aAhot(subClass, superClass);
}
module.exports = $b050fc8434f4a0e1$var$_inherits, module.exports.__esModule = true, module.exports["default"] = module.exports;

});
parcelRegister("aAhot", function(module, exports) {
function $7b4ac2338b8e8f97$var$_setPrototypeOf(o, p) {
    module.exports = $7b4ac2338b8e8f97$var$_setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    }, module.exports.__esModule = true, module.exports["default"] = module.exports;
    return $7b4ac2338b8e8f97$var$_setPrototypeOf(o, p);
}
module.exports = $7b4ac2338b8e8f97$var$_setPrototypeOf, module.exports.__esModule = true, module.exports["default"] = module.exports;

});


parcelRegister("eN9hz", function(module, exports) {

var $41YNz = parcelRequire("41YNz");
var $ac4cd79166dac6e4$var$_typeof = $41YNz.default;

var $6zC7B = parcelRequire("6zC7B");
function $ac4cd79166dac6e4$var$_possibleConstructorReturn(self, call) {
    if (call && ($ac4cd79166dac6e4$var$_typeof(call) === "object" || typeof call === "function")) return call;
    else if (call !== void 0) throw new TypeError("Derived constructors may only return object or undefined");
    return $6zC7B(self);
}
module.exports = $ac4cd79166dac6e4$var$_possibleConstructorReturn, module.exports.__esModule = true, module.exports["default"] = module.exports;

});
parcelRegister("6zC7B", function(module, exports) {
function $4c93951af9bb8a88$var$_assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
module.exports = $4c93951af9bb8a88$var$_assertThisInitialized, module.exports.__esModule = true, module.exports["default"] = module.exports;

});


parcelRegister("cGTaw", function(module, exports) {
function $93d4339c80153a6a$var$_getPrototypeOf(o) {
    module.exports = $93d4339c80153a6a$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    }, module.exports.__esModule = true, module.exports["default"] = module.exports;
    return $93d4339c80153a6a$var$_getPrototypeOf(o);
}
module.exports = $93d4339c80153a6a$var$_getPrototypeOf, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRegister("3vRz3", function(module, exports) {
"use strict";
var $28edd11f6c7e9f5f$var$has = Object.prototype.hasOwnProperty, $28edd11f6c7e9f5f$var$prefix = "~";
/**
 * Constructor to create a storage for our `EE` objects.
 * An `Events` instance is a plain object whose properties are event names.
 *
 * @constructor
 * @private
 */ function $28edd11f6c7e9f5f$var$Events() {}
//
// We try to not inherit from `Object.prototype`. In some engines creating an
// instance in this way is faster than calling `Object.create(null)` directly.
// If `Object.create(null)` is not supported we prefix the event names with a
// character to make sure that the built-in object properties are not
// overridden or used as an attack vector.
//
if (Object.create) {
    $28edd11f6c7e9f5f$var$Events.prototype = Object.create(null);
    //
    // This hack is needed because the `__proto__` property is still inherited in
    // some old browsers like Android 4, iPhone 5.1, Opera 11 and Safari 5.
    //
    if (!new $28edd11f6c7e9f5f$var$Events().__proto__) $28edd11f6c7e9f5f$var$prefix = false;
}
/**
 * Representation of a single event listener.
 *
 * @param {Function} fn The listener function.
 * @param {*} context The context to invoke the listener with.
 * @param {Boolean} [once=false] Specify if the listener is a one-time listener.
 * @constructor
 * @private
 */ function $28edd11f6c7e9f5f$var$EE(fn, context, once) {
    this.fn = fn;
    this.context = context;
    this.once = once || false;
}
/**
 * Add a listener for a given event.
 *
 * @param {EventEmitter} emitter Reference to the `EventEmitter` instance.
 * @param {(String|Symbol)} event The event name.
 * @param {Function} fn The listener function.
 * @param {*} context The context to invoke the listener with.
 * @param {Boolean} once Specify if the listener is a one-time listener.
 * @returns {EventEmitter}
 * @private
 */ function $28edd11f6c7e9f5f$var$addListener(emitter, event, fn, context, once) {
    if (typeof fn !== "function") throw new TypeError("The listener must be a function");
    var listener = new $28edd11f6c7e9f5f$var$EE(fn, context || emitter, once), evt = $28edd11f6c7e9f5f$var$prefix ? $28edd11f6c7e9f5f$var$prefix + event : event;
    if (!emitter._events[evt]) emitter._events[evt] = listener, emitter._eventsCount++;
    else if (!emitter._events[evt].fn) emitter._events[evt].push(listener);
    else emitter._events[evt] = [
        emitter._events[evt],
        listener
    ];
    return emitter;
}
/**
 * Clear event by name.
 *
 * @param {EventEmitter} emitter Reference to the `EventEmitter` instance.
 * @param {(String|Symbol)} evt The Event name.
 * @private
 */ function $28edd11f6c7e9f5f$var$clearEvent(emitter, evt) {
    if (--emitter._eventsCount === 0) emitter._events = new $28edd11f6c7e9f5f$var$Events();
    else delete emitter._events[evt];
}
/**
 * Minimal `EventEmitter` interface that is molded against the Node.js
 * `EventEmitter` interface.
 *
 * @constructor
 * @public
 */ function $28edd11f6c7e9f5f$var$EventEmitter() {
    this._events = new $28edd11f6c7e9f5f$var$Events();
    this._eventsCount = 0;
}
/**
 * Return an array listing the events for which the emitter has registered
 * listeners.
 *
 * @returns {Array}
 * @public
 */ $28edd11f6c7e9f5f$var$EventEmitter.prototype.eventNames = function eventNames() {
    var names = [], events, name;
    if (this._eventsCount === 0) return names;
    for(name in events = this._events)if ($28edd11f6c7e9f5f$var$has.call(events, name)) names.push($28edd11f6c7e9f5f$var$prefix ? name.slice(1) : name);
    if (Object.getOwnPropertySymbols) return names.concat(Object.getOwnPropertySymbols(events));
    return names;
};
/**
 * Return the listeners registered for a given event.
 *
 * @param {(String|Symbol)} event The event name.
 * @returns {Array} The registered listeners.
 * @public
 */ $28edd11f6c7e9f5f$var$EventEmitter.prototype.listeners = function listeners(event) {
    var evt = $28edd11f6c7e9f5f$var$prefix ? $28edd11f6c7e9f5f$var$prefix + event : event, handlers = this._events[evt];
    if (!handlers) return [];
    if (handlers.fn) return [
        handlers.fn
    ];
    for(var i = 0, l = handlers.length, ee = new Array(l); i < l; i++)ee[i] = handlers[i].fn;
    return ee;
};
/**
 * Return the number of listeners listening to a given event.
 *
 * @param {(String|Symbol)} event The event name.
 * @returns {Number} The number of listeners.
 * @public
 */ $28edd11f6c7e9f5f$var$EventEmitter.prototype.listenerCount = function listenerCount(event) {
    var evt = $28edd11f6c7e9f5f$var$prefix ? $28edd11f6c7e9f5f$var$prefix + event : event, listeners = this._events[evt];
    if (!listeners) return 0;
    if (listeners.fn) return 1;
    return listeners.length;
};
/**
 * Calls each of the listeners registered for a given event.
 *
 * @param {(String|Symbol)} event The event name.
 * @returns {Boolean} `true` if the event had listeners, else `false`.
 * @public
 */ $28edd11f6c7e9f5f$var$EventEmitter.prototype.emit = function emit(event, a1, a2, a3, a4, a5) {
    var evt = $28edd11f6c7e9f5f$var$prefix ? $28edd11f6c7e9f5f$var$prefix + event : event;
    if (!this._events[evt]) return false;
    var listeners = this._events[evt], len = arguments.length, args, i;
    if (listeners.fn) {
        if (listeners.once) this.removeListener(event, listeners.fn, undefined, true);
        switch(len){
            case 1:
                return listeners.fn.call(listeners.context), true;
            case 2:
                return listeners.fn.call(listeners.context, a1), true;
            case 3:
                return listeners.fn.call(listeners.context, a1, a2), true;
            case 4:
                return listeners.fn.call(listeners.context, a1, a2, a3), true;
            case 5:
                return listeners.fn.call(listeners.context, a1, a2, a3, a4), true;
            case 6:
                return listeners.fn.call(listeners.context, a1, a2, a3, a4, a5), true;
        }
        for(i = 1, args = new Array(len - 1); i < len; i++)args[i - 1] = arguments[i];
        listeners.fn.apply(listeners.context, args);
    } else {
        var length = listeners.length, j;
        for(i = 0; i < length; i++){
            if (listeners[i].once) this.removeListener(event, listeners[i].fn, undefined, true);
            switch(len){
                case 1:
                    listeners[i].fn.call(listeners[i].context);
                    break;
                case 2:
                    listeners[i].fn.call(listeners[i].context, a1);
                    break;
                case 3:
                    listeners[i].fn.call(listeners[i].context, a1, a2);
                    break;
                case 4:
                    listeners[i].fn.call(listeners[i].context, a1, a2, a3);
                    break;
                default:
                    if (!args) for(j = 1, args = new Array(len - 1); j < len; j++)args[j - 1] = arguments[j];
                    listeners[i].fn.apply(listeners[i].context, args);
            }
        }
    }
    return true;
};
/**
 * Add a listener for a given event.
 *
 * @param {(String|Symbol)} event The event name.
 * @param {Function} fn The listener function.
 * @param {*} [context=this] The context to invoke the listener with.
 * @returns {EventEmitter} `this`.
 * @public
 */ $28edd11f6c7e9f5f$var$EventEmitter.prototype.on = function on(event, fn, context) {
    return $28edd11f6c7e9f5f$var$addListener(this, event, fn, context, false);
};
/**
 * Add a one-time listener for a given event.
 *
 * @param {(String|Symbol)} event The event name.
 * @param {Function} fn The listener function.
 * @param {*} [context=this] The context to invoke the listener with.
 * @returns {EventEmitter} `this`.
 * @public
 */ $28edd11f6c7e9f5f$var$EventEmitter.prototype.once = function once(event, fn, context) {
    return $28edd11f6c7e9f5f$var$addListener(this, event, fn, context, true);
};
/**
 * Remove the listeners of a given event.
 *
 * @param {(String|Symbol)} event The event name.
 * @param {Function} fn Only remove the listeners that match this function.
 * @param {*} context Only remove the listeners that have this context.
 * @param {Boolean} once Only remove one-time listeners.
 * @returns {EventEmitter} `this`.
 * @public
 */ $28edd11f6c7e9f5f$var$EventEmitter.prototype.removeListener = function removeListener(event, fn, context, once) {
    var evt = $28edd11f6c7e9f5f$var$prefix ? $28edd11f6c7e9f5f$var$prefix + event : event;
    if (!this._events[evt]) return this;
    if (!fn) {
        $28edd11f6c7e9f5f$var$clearEvent(this, evt);
        return this;
    }
    var listeners = this._events[evt];
    if (listeners.fn) {
        if (listeners.fn === fn && (!once || listeners.once) && (!context || listeners.context === context)) $28edd11f6c7e9f5f$var$clearEvent(this, evt);
    } else {
        for(var i = 0, events = [], length = listeners.length; i < length; i++)if (listeners[i].fn !== fn || once && !listeners[i].once || context && listeners[i].context !== context) events.push(listeners[i]);
        //
        // Reset the array, or remove it completely if we have no more listeners.
        //
        if (events.length) this._events[evt] = events.length === 1 ? events[0] : events;
        else $28edd11f6c7e9f5f$var$clearEvent(this, evt);
    }
    return this;
};
/**
 * Remove all listeners, or those of the specified event.
 *
 * @param {(String|Symbol)} [event] The event name.
 * @returns {EventEmitter} `this`.
 * @public
 */ $28edd11f6c7e9f5f$var$EventEmitter.prototype.removeAllListeners = function removeAllListeners(event) {
    var evt;
    if (event) {
        evt = $28edd11f6c7e9f5f$var$prefix ? $28edd11f6c7e9f5f$var$prefix + event : event;
        if (this._events[evt]) $28edd11f6c7e9f5f$var$clearEvent(this, evt);
    } else {
        this._events = new $28edd11f6c7e9f5f$var$Events();
        this._eventsCount = 0;
    }
    return this;
};
//
// Alias methods names because people roll like that.
//
$28edd11f6c7e9f5f$var$EventEmitter.prototype.off = $28edd11f6c7e9f5f$var$EventEmitter.prototype.removeListener;
$28edd11f6c7e9f5f$var$EventEmitter.prototype.addListener = $28edd11f6c7e9f5f$var$EventEmitter.prototype.on;
//
// Expose the prefix.
//
$28edd11f6c7e9f5f$var$EventEmitter.prefixed = $28edd11f6c7e9f5f$var$prefix;
//
// Allow `EventEmitter` to be imported as module namespace.
//
$28edd11f6c7e9f5f$var$EventEmitter.EventEmitter = $28edd11f6c7e9f5f$var$EventEmitter;
module.exports = $28edd11f6c7e9f5f$var$EventEmitter;

});


parcelRegister("ckEgg", function(module, exports) {
/**
 * WebSocket implements a browser-side WebSocket specification.
 * @module Client
 */ "use strict";

var $1jnue = parcelRequire("1jnue");
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports["default"] = $8fa6955f5e890204$var$_default;

var $8fa6955f5e890204$var$_classCallCheck2 = $1jnue((parcelRequire("fu0YK")));

var $8fa6955f5e890204$var$_createClass2 = $1jnue((parcelRequire("lR7jo")));

var $8fa6955f5e890204$var$_inherits2 = $1jnue((parcelRequire("f8wIT")));

var $8fa6955f5e890204$var$_possibleConstructorReturn2 = $1jnue((parcelRequire("eN9hz")));

var $8fa6955f5e890204$var$_getPrototypeOf2 = $1jnue((parcelRequire("cGTaw")));

var $3vRz3 = parcelRequire("3vRz3");
function $8fa6955f5e890204$var$_createSuper(Derived) {
    var hasNativeReflectConstruct = $8fa6955f5e890204$var$_isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = (0, $8fa6955f5e890204$var$_getPrototypeOf2["default"])(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = (0, $8fa6955f5e890204$var$_getPrototypeOf2["default"])(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return (0, $8fa6955f5e890204$var$_possibleConstructorReturn2["default"])(this, result);
    };
}
function $8fa6955f5e890204$var$_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
var $8fa6955f5e890204$var$WebSocketBrowserImpl = /*#__PURE__*/ function(_EventEmitter) {
    (0, $8fa6955f5e890204$var$_inherits2["default"])(WebSocketBrowserImpl, _EventEmitter);
    var _super = $8fa6955f5e890204$var$_createSuper(WebSocketBrowserImpl);
    /** Instantiate a WebSocket class
   * @constructor
   * @param {String} address - url to a websocket server
   * @param {(Object)} options - websocket options
   * @param {(String|Array)} protocols - a list of protocols
   * @return {WebSocketBrowserImpl} - returns a WebSocket instance
   */ function WebSocketBrowserImpl(address, options, protocols) {
        var _this;
        (0, $8fa6955f5e890204$var$_classCallCheck2["default"])(this, WebSocketBrowserImpl);
        _this = _super.call(this);
        _this.socket = new window.WebSocket(address, protocols);
        _this.socket.onopen = function() {
            return _this.emit("open");
        };
        _this.socket.onmessage = function(event) {
            return _this.emit("message", event.data);
        };
        _this.socket.onerror = function(error) {
            return _this.emit("error", error);
        };
        _this.socket.onclose = function(event) {
            _this.emit("close", event.code, event.reason);
        };
        return _this;
    }
    /**
   * Sends data through a websocket connection
   * @method
   * @param {(String|Object)} data - data to be sent via websocket
   * @param {Object} optionsOrCallback - ws options
   * @param {Function} callback - a callback called once the data is sent
   * @return {Undefined}
   */ (0, $8fa6955f5e890204$var$_createClass2["default"])(WebSocketBrowserImpl, [
        {
            key: "send",
            value: function send(data, optionsOrCallback, callback) {
                var cb = callback || optionsOrCallback;
                try {
                    this.socket.send(data);
                    cb();
                } catch (error) {
                    cb(error);
                }
            }
        },
        {
            key: "close",
            value: function close(code, reason) {
                this.socket.close(code, reason);
            }
        },
        {
            key: "addEventListener",
            value: function addEventListener(type, listener, options) {
                this.socket.addEventListener(type, listener, options);
            }
        }
    ]);
    return WebSocketBrowserImpl;
}($3vRz3.EventEmitter);
/**
 * factory method for common WebSocket instance
 * @method
 * @param {String} address - url to a websocket server
 * @param {(Object)} options - websocket options
 * @return {Undefined}
 */ function $8fa6955f5e890204$var$_default(address, options) {
    return new $8fa6955f5e890204$var$WebSocketBrowserImpl(address, options);
}

});

parcelRegister("J0sDk", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.shake256 = module.exports.shake128 = module.exports.keccak_512 = module.exports.keccak_384 = module.exports.keccak_256 = module.exports.keccak_224 = module.exports.sha3_512 = module.exports.sha3_384 = module.exports.sha3_256 = module.exports.sha3_224 = module.exports.Keccak = module.exports.keccakP = void 0;

var $dNiq9 = parcelRequire("dNiq9");

var $eDgKs = parcelRequire("eDgKs");

var $3Bcdj = parcelRequire("3Bcdj");
// SHA3 (keccak) is based on a new design: basically, the internal state is bigger than output size.
// It's called a sponge function.
// Various per round constants calculations
const [$08748f983f07956b$var$SHA3_PI, $08748f983f07956b$var$SHA3_ROTL, $08748f983f07956b$var$_SHA3_IOTA] = [
    [],
    [],
    []
];
const $08748f983f07956b$var$_0n = /* @__PURE__ */ BigInt(0);
const $08748f983f07956b$var$_1n = /* @__PURE__ */ BigInt(1);
const $08748f983f07956b$var$_2n = /* @__PURE__ */ BigInt(2);
const $08748f983f07956b$var$_7n = /* @__PURE__ */ BigInt(7);
const $08748f983f07956b$var$_256n = /* @__PURE__ */ BigInt(256);
const $08748f983f07956b$var$_0x71n = /* @__PURE__ */ BigInt(0x71);
for(let round = 0, R = $08748f983f07956b$var$_1n, x = 1, y = 0; round < 24; round++){
    // Pi
    [x, y] = [
        y,
        (2 * x + 3 * y) % 5
    ];
    $08748f983f07956b$var$SHA3_PI.push(2 * (5 * y + x));
    // Rotational
    $08748f983f07956b$var$SHA3_ROTL.push((round + 1) * (round + 2) / 2 % 64);
    // Iota
    let t = $08748f983f07956b$var$_0n;
    for(let j = 0; j < 7; j++){
        R = (R << $08748f983f07956b$var$_1n ^ (R >> $08748f983f07956b$var$_7n) * $08748f983f07956b$var$_0x71n) % $08748f983f07956b$var$_256n;
        if (R & $08748f983f07956b$var$_2n) t ^= $08748f983f07956b$var$_1n << ($08748f983f07956b$var$_1n << /* @__PURE__ */ BigInt(j)) - $08748f983f07956b$var$_1n;
    }
    $08748f983f07956b$var$_SHA3_IOTA.push(t);
}
const [$08748f983f07956b$var$SHA3_IOTA_H, $08748f983f07956b$var$SHA3_IOTA_L] = /* @__PURE__ */ (0, $eDgKs.split)($08748f983f07956b$var$_SHA3_IOTA, true);
// Left rotation (without 0, 32, 64)
const $08748f983f07956b$var$rotlH = (h, l, s)=>s > 32 ? (0, $eDgKs.rotlBH)(h, l, s) : (0, $eDgKs.rotlSH)(h, l, s);
const $08748f983f07956b$var$rotlL = (h, l, s)=>s > 32 ? (0, $eDgKs.rotlBL)(h, l, s) : (0, $eDgKs.rotlSL)(h, l, s);
// Same as keccakf1600, but allows to skip some rounds
function $08748f983f07956b$var$keccakP(s, rounds = 24) {
    const B = new Uint32Array(10);
    // NOTE: all indices are x2 since we store state as u32 instead of u64 (bigints to slow in js)
    for(let round = 24 - rounds; round < 24; round++){
        // Theta θ
        for(let x = 0; x < 10; x++)B[x] = s[x] ^ s[x + 10] ^ s[x + 20] ^ s[x + 30] ^ s[x + 40];
        for(let x = 0; x < 10; x += 2){
            const idx1 = (x + 8) % 10;
            const idx0 = (x + 2) % 10;
            const B0 = B[idx0];
            const B1 = B[idx0 + 1];
            const Th = $08748f983f07956b$var$rotlH(B0, B1, 1) ^ B[idx1];
            const Tl = $08748f983f07956b$var$rotlL(B0, B1, 1) ^ B[idx1 + 1];
            for(let y = 0; y < 50; y += 10){
                s[x + y] ^= Th;
                s[x + y + 1] ^= Tl;
            }
        }
        // Rho (ρ) and Pi (π)
        let curH = s[2];
        let curL = s[3];
        for(let t = 0; t < 24; t++){
            const shift = $08748f983f07956b$var$SHA3_ROTL[t];
            const Th = $08748f983f07956b$var$rotlH(curH, curL, shift);
            const Tl = $08748f983f07956b$var$rotlL(curH, curL, shift);
            const PI = $08748f983f07956b$var$SHA3_PI[t];
            curH = s[PI];
            curL = s[PI + 1];
            s[PI] = Th;
            s[PI + 1] = Tl;
        }
        // Chi (χ)
        for(let y = 0; y < 50; y += 10){
            for(let x = 0; x < 10; x++)B[x] = s[y + x];
            for(let x = 0; x < 10; x++)s[y + x] ^= ~B[(x + 2) % 10] & B[(x + 4) % 10];
        }
        // Iota (ι)
        s[0] ^= $08748f983f07956b$var$SHA3_IOTA_H[round];
        s[1] ^= $08748f983f07956b$var$SHA3_IOTA_L[round];
    }
    B.fill(0);
}
module.exports.keccakP = $08748f983f07956b$var$keccakP;
class $08748f983f07956b$var$Keccak extends $3Bcdj.Hash {
    // NOTE: we accept arguments in bytes instead of bits here.
    constructor(blockLen, suffix, outputLen, enableXOF = false, rounds = 24){
        super();
        this.blockLen = blockLen;
        this.suffix = suffix;
        this.outputLen = outputLen;
        this.enableXOF = enableXOF;
        this.rounds = rounds;
        this.pos = 0;
        this.posOut = 0;
        this.finished = false;
        this.destroyed = false;
        // Can be passed from user as dkLen
        (0, $dNiq9.number)(outputLen);
        // 1600 = 5x5 matrix of 64bit.  1600 bits === 200 bytes
        if (0 >= this.blockLen || this.blockLen >= 200) throw new Error("Sha3 supports only keccak-f1600 function");
        this.state = new Uint8Array(200);
        this.state32 = (0, $3Bcdj.u32)(this.state);
    }
    keccak() {
        $08748f983f07956b$var$keccakP(this.state32, this.rounds);
        this.posOut = 0;
        this.pos = 0;
    }
    update(data) {
        (0, $dNiq9.exists)(this);
        const { blockLen: blockLen, state: state } = this;
        data = (0, $3Bcdj.toBytes)(data);
        const len = data.length;
        for(let pos = 0; pos < len;){
            const take = Math.min(blockLen - this.pos, len - pos);
            for(let i = 0; i < take; i++)state[this.pos++] ^= data[pos++];
            if (this.pos === blockLen) this.keccak();
        }
        return this;
    }
    finish() {
        if (this.finished) return;
        this.finished = true;
        const { state: state, suffix: suffix, pos: pos, blockLen: blockLen } = this;
        // Do the padding
        state[pos] ^= suffix;
        if ((suffix & 0x80) !== 0 && pos === blockLen - 1) this.keccak();
        state[blockLen - 1] ^= 0x80;
        this.keccak();
    }
    writeInto(out) {
        (0, $dNiq9.exists)(this, false);
        (0, $dNiq9.bytes)(out);
        this.finish();
        const bufferOut = this.state;
        const { blockLen: blockLen } = this;
        for(let pos = 0, len = out.length; pos < len;){
            if (this.posOut >= blockLen) this.keccak();
            const take = Math.min(blockLen - this.posOut, len - pos);
            out.set(bufferOut.subarray(this.posOut, this.posOut + take), pos);
            this.posOut += take;
            pos += take;
        }
        return out;
    }
    xofInto(out) {
        // Sha3/Keccak usage with XOF is probably mistake, only SHAKE instances can do XOF
        if (!this.enableXOF) throw new Error("XOF is not possible for this instance");
        return this.writeInto(out);
    }
    xof(bytes) {
        (0, $dNiq9.number)(bytes);
        return this.xofInto(new Uint8Array(bytes));
    }
    digestInto(out) {
        (0, $dNiq9.output)(out, this);
        if (this.finished) throw new Error("digest() was already called");
        this.writeInto(out);
        this.destroy();
        return out;
    }
    digest() {
        return this.digestInto(new Uint8Array(this.outputLen));
    }
    destroy() {
        this.destroyed = true;
        this.state.fill(0);
    }
    _cloneInto(to) {
        const { blockLen: blockLen, suffix: suffix, outputLen: outputLen, rounds: rounds, enableXOF: enableXOF } = this;
        to || (to = new $08748f983f07956b$var$Keccak(blockLen, suffix, outputLen, enableXOF, rounds));
        to.state32.set(this.state32);
        to.pos = this.pos;
        to.posOut = this.posOut;
        to.finished = this.finished;
        to.rounds = rounds;
        // Suffix can change in cSHAKE
        to.suffix = suffix;
        to.outputLen = outputLen;
        to.enableXOF = enableXOF;
        to.destroyed = this.destroyed;
        return to;
    }
}
module.exports.Keccak = $08748f983f07956b$var$Keccak;
const $08748f983f07956b$var$gen = (suffix, blockLen, outputLen)=>(0, $3Bcdj.wrapConstructor)(()=>new $08748f983f07956b$var$Keccak(blockLen, suffix, outputLen));
module.exports.sha3_224 = $08748f983f07956b$var$gen(0x06, 144, 28);
/**
 * SHA3-256 hash function
 * @param message - that would be hashed
 */ module.exports.sha3_256 = $08748f983f07956b$var$gen(0x06, 136, 32);
module.exports.sha3_384 = $08748f983f07956b$var$gen(0x06, 104, 48);
module.exports.sha3_512 = $08748f983f07956b$var$gen(0x06, 72, 64);
module.exports.keccak_224 = $08748f983f07956b$var$gen(0x01, 144, 28);
/**
 * keccak-256 hash function. Different from SHA3-256.
 * @param message - that would be hashed
 */ module.exports.keccak_256 = $08748f983f07956b$var$gen(0x01, 136, 32);
module.exports.keccak_384 = $08748f983f07956b$var$gen(0x01, 104, 48);
module.exports.keccak_512 = $08748f983f07956b$var$gen(0x01, 72, 64);
const $08748f983f07956b$var$genShake = (suffix, blockLen, outputLen)=>(0, $3Bcdj.wrapXOFConstructorWithOpts)((opts = {})=>new $08748f983f07956b$var$Keccak(blockLen, suffix, opts.dkLen === undefined ? outputLen : opts.dkLen, true));
module.exports.shake128 = $08748f983f07956b$var$genShake(0x1f, 168, 16);
module.exports.shake256 = $08748f983f07956b$var$genShake(0x1f, 136, 32);

});

parcelRegister("5r7db", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.encodeToCurve = module.exports.hashToCurve = module.exports.schnorr = module.exports.secp256k1 = void 0;

var $6XnWx = parcelRequire("6XnWx");

var $3Bcdj = parcelRequire("3Bcdj");

var $2D9sF = parcelRequire("2D9sF");

var $gNPqy = parcelRequire("gNPqy");

var $esaJO = parcelRequire("esaJO");

var $rkPJ6 = parcelRequire("rkPJ6");

var $7OcHe = parcelRequire("7OcHe");
const $3f551179096121b9$var$secp256k1P = BigInt("0xfffffffffffffffffffffffffffffffffffffffffffffffffffffffefffffc2f");
const $3f551179096121b9$var$secp256k1N = BigInt("0xfffffffffffffffffffffffffffffffebaaedce6af48a03bbfd25e8cd0364141");
const $3f551179096121b9$var$_1n = BigInt(1);
const $3f551179096121b9$var$_2n = BigInt(2);
const $3f551179096121b9$var$divNearest = (a, b)=>(a + b / $3f551179096121b9$var$_2n) / b;
/**
 * √n = n^((p+1)/4) for fields p = 3 mod 4. We unwrap the loop and multiply bit-by-bit.
 * (P+1n/4n).toString(2) would produce bits [223x 1, 0, 22x 1, 4x 0, 11, 00]
 */ function $3f551179096121b9$var$sqrtMod(y) {
    const P = $3f551179096121b9$var$secp256k1P;
    // prettier-ignore
    const _3n = BigInt(3), _6n = BigInt(6), _11n = BigInt(11), _22n = BigInt(22);
    // prettier-ignore
    const _23n = BigInt(23), _44n = BigInt(44), _88n = BigInt(88);
    const b2 = y * y * y % P; // x^3, 11
    const b3 = b2 * b2 * y % P; // x^7
    const b6 = (0, $2D9sF.pow2)(b3, _3n, P) * b3 % P;
    const b9 = (0, $2D9sF.pow2)(b6, _3n, P) * b3 % P;
    const b11 = (0, $2D9sF.pow2)(b9, $3f551179096121b9$var$_2n, P) * b2 % P;
    const b22 = (0, $2D9sF.pow2)(b11, _11n, P) * b11 % P;
    const b44 = (0, $2D9sF.pow2)(b22, _22n, P) * b22 % P;
    const b88 = (0, $2D9sF.pow2)(b44, _44n, P) * b44 % P;
    const b176 = (0, $2D9sF.pow2)(b88, _88n, P) * b88 % P;
    const b220 = (0, $2D9sF.pow2)(b176, _44n, P) * b44 % P;
    const b223 = (0, $2D9sF.pow2)(b220, _3n, P) * b3 % P;
    const t1 = (0, $2D9sF.pow2)(b223, _23n, P) * b22 % P;
    const t2 = (0, $2D9sF.pow2)(t1, _6n, P) * b2 % P;
    const root = (0, $2D9sF.pow2)(t2, $3f551179096121b9$var$_2n, P);
    if (!$3f551179096121b9$var$Fp.eql($3f551179096121b9$var$Fp.sqr(root), y)) throw new Error("Cannot find square root");
    return root;
}
const $3f551179096121b9$var$Fp = (0, $2D9sF.Field)($3f551179096121b9$var$secp256k1P, undefined, undefined, {
    sqrt: $3f551179096121b9$var$sqrtMod
});
module.exports.secp256k1 = (0, $7OcHe.createCurve)({
    a: BigInt(0),
    b: BigInt(7),
    Fp: $3f551179096121b9$var$Fp,
    n: $3f551179096121b9$var$secp256k1N,
    // Base point (x, y) aka generator point
    Gx: BigInt("55066263022277343669578718895168534326250603453777594175500187360389116729240"),
    Gy: BigInt("32670510020758816978083085130507043184471273380659243275938904335757337482424"),
    h: BigInt(1),
    lowS: true,
    /**
     * secp256k1 belongs to Koblitz curves: it has efficiently computable endomorphism.
     * Endomorphism uses 2x less RAM, speeds up precomputation by 2x and ECDH / key recovery by 20%.
     * For precomputed wNAF it trades off 1/2 init time & 1/3 ram for 20% perf hit.
     * Explanation: https://gist.github.com/paulmillr/eb670806793e84df628a7c434a873066
     */ endo: {
        beta: BigInt("0x7ae96a2b657c07106e64479eac3434e99cf0497512f58995c1396c28719501ee"),
        splitScalar: (k)=>{
            const n = $3f551179096121b9$var$secp256k1N;
            const a1 = BigInt("0x3086d221a7d46bcde86c90e49284eb15");
            const b1 = -$3f551179096121b9$var$_1n * BigInt("0xe4437ed6010e88286f547fa90abfe4c3");
            const a2 = BigInt("0x114ca50f7a8e2f3f657c1108d9d44cfd8");
            const b2 = a1;
            const POW_2_128 = BigInt("0x100000000000000000000000000000000"); // (2n**128n).toString(16)
            const c1 = $3f551179096121b9$var$divNearest(b2 * k, n);
            const c2 = $3f551179096121b9$var$divNearest(-b1 * k, n);
            let k1 = (0, $2D9sF.mod)(k - c1 * a1 - c2 * a2, n);
            let k2 = (0, $2D9sF.mod)(-c1 * b1 - c2 * b2, n);
            const k1neg = k1 > POW_2_128;
            const k2neg = k2 > POW_2_128;
            if (k1neg) k1 = n - k1;
            if (k2neg) k2 = n - k2;
            if (k1 > POW_2_128 || k2 > POW_2_128) throw new Error("splitScalar: Endomorphism failed, k=" + k);
            return {
                k1neg: k1neg,
                k1: k1,
                k2neg: k2neg,
                k2: k2
            };
        }
    }
}, $6XnWx.sha256);
// Schnorr signatures are superior to ECDSA from above. Below is Schnorr-specific BIP0340 code.
// https://github.com/bitcoin/bips/blob/master/bip-0340.mediawiki
const $3f551179096121b9$var$_0n = BigInt(0);
const $3f551179096121b9$var$fe = (x)=>typeof x === "bigint" && $3f551179096121b9$var$_0n < x && x < $3f551179096121b9$var$secp256k1P;
const $3f551179096121b9$var$ge = (x)=>typeof x === "bigint" && $3f551179096121b9$var$_0n < x && x < $3f551179096121b9$var$secp256k1N;
/** An object mapping tags to their tagged hash prefix of [SHA256(tag) | SHA256(tag)] */ const $3f551179096121b9$var$TAGGED_HASH_PREFIXES = {};
function $3f551179096121b9$var$taggedHash(tag, ...messages) {
    let tagP = $3f551179096121b9$var$TAGGED_HASH_PREFIXES[tag];
    if (tagP === undefined) {
        const tagH = (0, $6XnWx.sha256)(Uint8Array.from(tag, (c)=>c.charCodeAt(0)));
        tagP = (0, $esaJO.concatBytes)(tagH, tagH);
        $3f551179096121b9$var$TAGGED_HASH_PREFIXES[tag] = tagP;
    }
    return (0, $6XnWx.sha256)((0, $esaJO.concatBytes)(tagP, ...messages));
}
// ECDSA compact points are 33-byte. Schnorr is 32: we strip first byte 0x02 or 0x03
const $3f551179096121b9$var$pointToBytes = (point)=>point.toRawBytes(true).slice(1);
const $3f551179096121b9$var$numTo32b = (n)=>(0, $esaJO.numberToBytesBE)(n, 32);
const $3f551179096121b9$var$modP = (x)=>(0, $2D9sF.mod)(x, $3f551179096121b9$var$secp256k1P);
const $3f551179096121b9$var$modN = (x)=>(0, $2D9sF.mod)(x, $3f551179096121b9$var$secp256k1N);
const $3f551179096121b9$var$Point = module.exports.secp256k1.ProjectivePoint;
const $3f551179096121b9$var$GmulAdd = (Q, a, b)=>$3f551179096121b9$var$Point.BASE.multiplyAndAddUnsafe(Q, a, b);
// Calculate point, scalar and bytes
function $3f551179096121b9$var$schnorrGetExtPubKey(priv) {
    let d_ = module.exports.secp256k1.utils.normPrivateKeyToScalar(priv); // same method executed in fromPrivateKey
    let p = $3f551179096121b9$var$Point.fromPrivateKey(d_); // P = d'⋅G; 0 < d' < n check is done inside
    const scalar = p.hasEvenY() ? d_ : $3f551179096121b9$var$modN(-d_);
    return {
        scalar: scalar,
        bytes: $3f551179096121b9$var$pointToBytes(p)
    };
}
/**
 * lift_x from BIP340. Convert 32-byte x coordinate to elliptic curve point.
 * @returns valid point checked for being on-curve
 */ function $3f551179096121b9$var$lift_x(x) {
    if (!$3f551179096121b9$var$fe(x)) throw new Error("bad x: need 0 < x < p"); // Fail if x ≥ p.
    const xx = $3f551179096121b9$var$modP(x * x);
    const c = $3f551179096121b9$var$modP(xx * x + BigInt(7)); // Let c = x³ + 7 mod p.
    let y = $3f551179096121b9$var$sqrtMod(c); // Let y = c^(p+1)/4 mod p.
    if (y % $3f551179096121b9$var$_2n !== $3f551179096121b9$var$_0n) y = $3f551179096121b9$var$modP(-y); // Return the unique point P such that x(P) = x and
    const p = new $3f551179096121b9$var$Point(x, y, $3f551179096121b9$var$_1n); // y(P) = y if y mod 2 = 0 or y(P) = p-y otherwise.
    p.assertValidity();
    return p;
}
/**
 * Create tagged hash, convert it to bigint, reduce modulo-n.
 */ function $3f551179096121b9$var$challenge(...args) {
    return $3f551179096121b9$var$modN((0, $esaJO.bytesToNumberBE)($3f551179096121b9$var$taggedHash("BIP0340/challenge", ...args)));
}
/**
 * Schnorr public key is just `x` coordinate of Point as per BIP340.
 */ function $3f551179096121b9$var$schnorrGetPublicKey(privateKey) {
    return $3f551179096121b9$var$schnorrGetExtPubKey(privateKey).bytes; // d'=int(sk). Fail if d'=0 or d'≥n. Ret bytes(d'⋅G)
}
/**
 * Creates Schnorr signature as per BIP340. Verifies itself before returning anything.
 * auxRand is optional and is not the sole source of k generation: bad CSPRNG won't be dangerous.
 */ function $3f551179096121b9$var$schnorrSign(message, privateKey, auxRand = (0, $3Bcdj.randomBytes)(32)) {
    const m = (0, $esaJO.ensureBytes)("message", message);
    const { bytes: px, scalar: d } = $3f551179096121b9$var$schnorrGetExtPubKey(privateKey); // checks for isWithinCurveOrder
    const a = (0, $esaJO.ensureBytes)("auxRand", auxRand, 32); // Auxiliary random data a: a 32-byte array
    const t = $3f551179096121b9$var$numTo32b(d ^ (0, $esaJO.bytesToNumberBE)($3f551179096121b9$var$taggedHash("BIP0340/aux", a))); // Let t be the byte-wise xor of bytes(d) and hash/aux(a)
    const rand = $3f551179096121b9$var$taggedHash("BIP0340/nonce", t, px, m); // Let rand = hash/nonce(t || bytes(P) || m)
    const k_ = $3f551179096121b9$var$modN((0, $esaJO.bytesToNumberBE)(rand)); // Let k' = int(rand) mod n
    if (k_ === $3f551179096121b9$var$_0n) throw new Error("sign failed: k is zero"); // Fail if k' = 0.
    const { bytes: rx, scalar: k } = $3f551179096121b9$var$schnorrGetExtPubKey(k_); // Let R = k'⋅G.
    const e = $3f551179096121b9$var$challenge(rx, px, m); // Let e = int(hash/challenge(bytes(R) || bytes(P) || m)) mod n.
    const sig = new Uint8Array(64); // Let sig = bytes(R) || bytes((k + ed) mod n).
    sig.set(rx, 0);
    sig.set($3f551179096121b9$var$numTo32b($3f551179096121b9$var$modN(k + e * d)), 32);
    // If Verify(bytes(P), m, sig) (see below) returns failure, abort
    if (!$3f551179096121b9$var$schnorrVerify(sig, m, px)) throw new Error("sign: Invalid signature produced");
    return sig;
}
/**
 * Verifies Schnorr signature.
 * Will swallow errors & return false except for initial type validation of arguments.
 */ function $3f551179096121b9$var$schnorrVerify(signature, message, publicKey) {
    const sig = (0, $esaJO.ensureBytes)("signature", signature, 64);
    const m = (0, $esaJO.ensureBytes)("message", message);
    const pub = (0, $esaJO.ensureBytes)("publicKey", publicKey, 32);
    try {
        const P = $3f551179096121b9$var$lift_x((0, $esaJO.bytesToNumberBE)(pub)); // P = lift_x(int(pk)); fail if that fails
        const r = (0, $esaJO.bytesToNumberBE)(sig.subarray(0, 32)); // Let r = int(sig[0:32]); fail if r ≥ p.
        if (!$3f551179096121b9$var$fe(r)) return false;
        const s = (0, $esaJO.bytesToNumberBE)(sig.subarray(32, 64)); // Let s = int(sig[32:64]); fail if s ≥ n.
        if (!$3f551179096121b9$var$ge(s)) return false;
        const e = $3f551179096121b9$var$challenge($3f551179096121b9$var$numTo32b(r), $3f551179096121b9$var$pointToBytes(P), m); // int(challenge(bytes(r)||bytes(P)||m))%n
        const R = $3f551179096121b9$var$GmulAdd(P, s, $3f551179096121b9$var$modN(-e)); // R = s⋅G - e⋅P
        if (!R || !R.hasEvenY() || R.toAffine().x !== r) return false; // -eP == (n-e)P
        return true; // Fail if is_infinite(R) / not has_even_y(R) / x(R) ≠ r.
    } catch (error) {
        return false;
    }
}
module.exports.schnorr = (()=>({
        getPublicKey: $3f551179096121b9$var$schnorrGetPublicKey,
        sign: $3f551179096121b9$var$schnorrSign,
        verify: $3f551179096121b9$var$schnorrVerify,
        utils: {
            randomPrivateKey: module.exports.secp256k1.utils.randomPrivateKey,
            lift_x: $3f551179096121b9$var$lift_x,
            pointToBytes: $3f551179096121b9$var$pointToBytes,
            numberToBytesBE: $esaJO.numberToBytesBE,
            bytesToNumberBE: $esaJO.bytesToNumberBE,
            taggedHash: $3f551179096121b9$var$taggedHash,
            mod: $2D9sF.mod
        }
    }))();
const $3f551179096121b9$var$isoMap = /* @__PURE__ */ (()=>(0, $rkPJ6.isogenyMap)($3f551179096121b9$var$Fp, [
        // xNum
        [
            "0x8e38e38e38e38e38e38e38e38e38e38e38e38e38e38e38e38e38e38daaaaa8c7",
            "0x7d3d4c80bc321d5b9f315cea7fd44c5d595d2fc0bf63b92dfff1044f17c6581",
            "0x534c328d23f234e6e2a413deca25caece4506144037c40314ecbd0b53d9dd262",
            "0x8e38e38e38e38e38e38e38e38e38e38e38e38e38e38e38e38e38e38daaaaa88c"
        ],
        // xDen
        [
            "0xd35771193d94918a9ca34ccbb7b640dd86cd409542f8487d9fe6b745781eb49b",
            "0xedadc6f64383dc1df7c4b2d51b54225406d36b641f5e41bbc52a56612a8c6d14",
            "0x0000000000000000000000000000000000000000000000000000000000000001"
        ],
        // yNum
        [
            "0x4bda12f684bda12f684bda12f684bda12f684bda12f684bda12f684b8e38e23c",
            "0xc75e0c32d5cb7c0fa9d0a54b12a0a6d5647ab046d686da6fdffc90fc201d71a3",
            "0x29a6194691f91a73715209ef6512e576722830a201be2018a765e85a9ecee931",
            "0x2f684bda12f684bda12f684bda12f684bda12f684bda12f684bda12f38e38d84"
        ],
        // yDen
        [
            "0xfffffffffffffffffffffffffffffffffffffffffffffffffffffffefffff93b",
            "0x7a06534bb8bdb49fd5e9e6632722c2989467c1bfc8e8d978dfb425d2685c2573",
            "0x6484aa716545ca2cf3a70c3fa8fe337e0a3d21162f0d6299a7bf8192bfd2a76f",
            "0x0000000000000000000000000000000000000000000000000000000000000001"
        ]
    ].map((i)=>i.map((j)=>BigInt(j)))))();
const $3f551179096121b9$var$mapSWU = /* @__PURE__ */ (()=>(0, $gNPqy.mapToCurveSimpleSWU)($3f551179096121b9$var$Fp, {
        A: BigInt("0x3f8731abdd661adca08a5558f0f5d272e953d363cb6f0e5d405447c01a444533"),
        B: BigInt("1771"),
        Z: $3f551179096121b9$var$Fp.create(BigInt("-11"))
    }))();
const $3f551179096121b9$var$htf = /* @__PURE__ */ (()=>(0, $rkPJ6.createHasher)(module.exports.secp256k1.ProjectivePoint, (scalars)=>{
        const { x: x, y: y } = $3f551179096121b9$var$mapSWU($3f551179096121b9$var$Fp.create(scalars[0]));
        return $3f551179096121b9$var$isoMap(x, y);
    }, {
        DST: "secp256k1_XMD:SHA-256_SSWU_RO_",
        encodeDST: "secp256k1_XMD:SHA-256_SSWU_NU_",
        p: $3f551179096121b9$var$Fp.ORDER,
        m: 1,
        k: 128,
        expand: "xmd",
        hash: $6XnWx.sha256
    }))();
module.exports.hashToCurve = (()=>$3f551179096121b9$var$htf.hashToCurve)();
module.exports.encodeToCurve = (()=>$3f551179096121b9$var$htf.encodeToCurve)();

});
parcelRegister("gNPqy", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.mapToCurveSimpleSWU = module.exports.SWUFpSqrtRatio = module.exports.weierstrass = module.exports.weierstrassPoints = module.exports.DER = void 0;

var $2D9sF = parcelRequire("2D9sF");

var $esaJO = parcelRequire("esaJO");

var $esaJO = parcelRequire("esaJO");

var $lkFCe = parcelRequire("lkFCe");
function $c3b91d553ab14e64$var$validatePointOpts(curve) {
    const opts = (0, $lkFCe.validateBasic)(curve);
    $esaJO.validateObject(opts, {
        a: "field",
        b: "field"
    }, {
        allowedPrivateKeyLengths: "array",
        wrapPrivateKey: "boolean",
        isTorsionFree: "function",
        clearCofactor: "function",
        allowInfinityPoint: "boolean",
        fromBytes: "function",
        toBytes: "function"
    });
    const { endo: endo, Fp: Fp, a: a } = opts;
    if (endo) {
        if (!Fp.eql(a, Fp.ZERO)) throw new Error("Endomorphism can only be defined for Koblitz curves that have a=0");
        if (typeof endo !== "object" || typeof endo.beta !== "bigint" || typeof endo.splitScalar !== "function") throw new Error("Expected endomorphism with beta: bigint and splitScalar: function");
    }
    return Object.freeze({
        ...opts
    });
}
// ASN.1 DER encoding utilities
const { bytesToNumberBE: $c3b91d553ab14e64$var$b2n, hexToBytes: $c3b91d553ab14e64$var$h2b } = $esaJO;
module.exports.DER = {
    // asn.1 DER encoding utils
    Err: class DERErr extends Error {
        constructor(m = ""){
            super(m);
        }
    },
    _parseInt (data) {
        const { Err: E } = module.exports.DER;
        if (data.length < 2 || data[0] !== 0x02) throw new E("Invalid signature integer tag");
        const len = data[1];
        const res = data.subarray(2, len + 2);
        if (!len || res.length !== len) throw new E("Invalid signature integer: wrong length");
        // https://crypto.stackexchange.com/a/57734 Leftmost bit of first byte is 'negative' flag,
        // since we always use positive integers here. It must always be empty:
        // - add zero byte if exists
        // - if next byte doesn't have a flag, leading zero is not allowed (minimal encoding)
        if (res[0] & 128) throw new E("Invalid signature integer: negative");
        if (res[0] === 0x00 && !(res[1] & 128)) throw new E("Invalid signature integer: unnecessary leading zero");
        return {
            d: $c3b91d553ab14e64$var$b2n(res),
            l: data.subarray(len + 2)
        }; // d is data, l is left
    },
    toSig (hex) {
        // parse DER signature
        const { Err: E } = module.exports.DER;
        const data = typeof hex === "string" ? $c3b91d553ab14e64$var$h2b(hex) : hex;
        if (!(data instanceof Uint8Array)) throw new Error("ui8a expected");
        let l = data.length;
        if (l < 2 || data[0] != 0x30) throw new E("Invalid signature tag");
        if (data[1] !== l - 2) throw new E("Invalid signature: incorrect length");
        const { d: r, l: sBytes } = module.exports.DER._parseInt(data.subarray(2));
        const { d: s, l: rBytesLeft } = module.exports.DER._parseInt(sBytes);
        if (rBytesLeft.length) throw new E("Invalid signature: left bytes after parsing");
        return {
            r: r,
            s: s
        };
    },
    hexFromSig (sig) {
        // Add leading zero if first byte has negative bit enabled. More details in '_parseInt'
        const slice = (s)=>Number.parseInt(s[0], 16) & 8 ? "00" + s : s;
        const h = (num)=>{
            const hex = num.toString(16);
            return hex.length & 1 ? `0${hex}` : hex;
        };
        const s = slice(h(sig.s));
        const r = slice(h(sig.r));
        const shl = s.length / 2;
        const rhl = r.length / 2;
        const sl = h(shl);
        const rl = h(rhl);
        return `30${h(rhl + shl + 4)}02${rl}${r}02${sl}${s}`;
    }
};
// Be friendly to bad ECMAScript parsers by not using bigint literals
// prettier-ignore
const $c3b91d553ab14e64$var$_0n = BigInt(0), $c3b91d553ab14e64$var$_1n = BigInt(1), $c3b91d553ab14e64$var$_2n = BigInt(2), $c3b91d553ab14e64$var$_3n = BigInt(3), $c3b91d553ab14e64$var$_4n = BigInt(4);
function $c3b91d553ab14e64$var$weierstrassPoints(opts) {
    const CURVE = $c3b91d553ab14e64$var$validatePointOpts(opts);
    const { Fp: Fp } = CURVE; // All curves has same field / group length as for now, but they can differ
    const toBytes = CURVE.toBytes || ((_c, point, _isCompressed)=>{
        const a = point.toAffine();
        return $esaJO.concatBytes(Uint8Array.from([
            0x04
        ]), Fp.toBytes(a.x), Fp.toBytes(a.y));
    });
    const fromBytes = CURVE.fromBytes || ((bytes)=>{
        // const head = bytes[0];
        const tail = bytes.subarray(1);
        // if (head !== 0x04) throw new Error('Only non-compressed encoding is supported');
        const x = Fp.fromBytes(tail.subarray(0, Fp.BYTES));
        const y = Fp.fromBytes(tail.subarray(Fp.BYTES, 2 * Fp.BYTES));
        return {
            x: x,
            y: y
        };
    });
    /**
     * y² = x³ + ax + b: Short weierstrass curve formula
     * @returns y²
     */ function weierstrassEquation(x) {
        const { a: a, b: b } = CURVE;
        const x2 = Fp.sqr(x); // x * x
        const x3 = Fp.mul(x2, x); // x2 * x
        return Fp.add(Fp.add(x3, Fp.mul(x, a)), b); // x3 + a * x + b
    }
    // Validate whether the passed curve params are valid.
    // We check if curve equation works for generator point.
    // `assertValidity()` won't work: `isTorsionFree()` is not available at this point in bls12-381.
    // ProjectivePoint class has not been initialized yet.
    if (!Fp.eql(Fp.sqr(CURVE.Gy), weierstrassEquation(CURVE.Gx))) throw new Error("bad generator point: equation left != right");
    // Valid group elements reside in range 1..n-1
    function isWithinCurveOrder(num) {
        return typeof num === "bigint" && $c3b91d553ab14e64$var$_0n < num && num < CURVE.n;
    }
    function assertGE(num) {
        if (!isWithinCurveOrder(num)) throw new Error("Expected valid bigint: 0 < bigint < curve.n");
    }
    // Validates if priv key is valid and converts it to bigint.
    // Supports options allowedPrivateKeyLengths and wrapPrivateKey.
    function normPrivateKeyToScalar(key) {
        const { allowedPrivateKeyLengths: lengths, nByteLength: nByteLength, wrapPrivateKey: wrapPrivateKey, n: n } = CURVE;
        if (lengths && typeof key !== "bigint") {
            if (key instanceof Uint8Array) key = $esaJO.bytesToHex(key);
            // Normalize to hex string, pad. E.g. P521 would norm 130-132 char hex to 132-char bytes
            if (typeof key !== "string" || !lengths.includes(key.length)) throw new Error("Invalid key");
            key = key.padStart(nByteLength * 2, "0");
        }
        let num;
        try {
            num = typeof key === "bigint" ? key : $esaJO.bytesToNumberBE((0, $esaJO.ensureBytes)("private key", key, nByteLength));
        } catch (error) {
            throw new Error(`private key must be ${nByteLength} bytes, hex or bigint, not ${typeof key}`);
        }
        if (wrapPrivateKey) num = $2D9sF.mod(num, n); // disabled by default, enabled for BLS
        assertGE(num); // num in range [1..N-1]
        return num;
    }
    const pointPrecomputes = new Map();
    function assertPrjPoint(other) {
        if (!(other instanceof Point)) throw new Error("ProjectivePoint expected");
    }
    /**
     * Projective Point works in 3d / projective (homogeneous) coordinates: (x, y, z) ∋ (x=x/z, y=y/z)
     * Default Point works in 2d / affine coordinates: (x, y)
     * We're doing calculations in projective, because its operations don't require costly inversion.
     */ class Point {
        constructor(px, py, pz){
            this.px = px;
            this.py = py;
            this.pz = pz;
            if (px == null || !Fp.isValid(px)) throw new Error("x required");
            if (py == null || !Fp.isValid(py)) throw new Error("y required");
            if (pz == null || !Fp.isValid(pz)) throw new Error("z required");
        }
        // Does not validate if the point is on-curve.
        // Use fromHex instead, or call assertValidity() later.
        static fromAffine(p) {
            const { x: x, y: y } = p || {};
            if (!p || !Fp.isValid(x) || !Fp.isValid(y)) throw new Error("invalid affine point");
            if (p instanceof Point) throw new Error("projective point not allowed");
            const is0 = (i)=>Fp.eql(i, Fp.ZERO);
            // fromAffine(x:0, y:0) would produce (x:0, y:0, z:1), but we need (x:0, y:1, z:0)
            if (is0(x) && is0(y)) return Point.ZERO;
            return new Point(x, y, Fp.ONE);
        }
        get x() {
            return this.toAffine().x;
        }
        get y() {
            return this.toAffine().y;
        }
        /**
         * Takes a bunch of Projective Points but executes only one
         * inversion on all of them. Inversion is very slow operation,
         * so this improves performance massively.
         * Optimization: converts a list of projective points to a list of identical points with Z=1.
         */ static normalizeZ(points) {
            const toInv = Fp.invertBatch(points.map((p)=>p.pz));
            return points.map((p, i)=>p.toAffine(toInv[i])).map(Point.fromAffine);
        }
        /**
         * Converts hash string or Uint8Array to Point.
         * @param hex short/long ECDSA hex
         */ static fromHex(hex) {
            const P = Point.fromAffine(fromBytes((0, $esaJO.ensureBytes)("pointHex", hex)));
            P.assertValidity();
            return P;
        }
        // Multiplies generator point by privateKey.
        static fromPrivateKey(privateKey) {
            return Point.BASE.multiply(normPrivateKeyToScalar(privateKey));
        }
        // "Private method", don't use it directly
        _setWindowSize(windowSize) {
            this._WINDOW_SIZE = windowSize;
            pointPrecomputes.delete(this);
        }
        // A point on curve is valid if it conforms to equation.
        assertValidity() {
            if (this.is0()) {
                // (0, 1, 0) aka ZERO is invalid in most contexts.
                // In BLS, ZERO can be serialized, so we allow it.
                // (0, 0, 0) is wrong representation of ZERO and is always invalid.
                if (CURVE.allowInfinityPoint && !Fp.is0(this.py)) return;
                throw new Error("bad point: ZERO");
            }
            // Some 3rd-party test vectors require different wording between here & `fromCompressedHex`
            const { x: x, y: y } = this.toAffine();
            // Check if x, y are valid field elements
            if (!Fp.isValid(x) || !Fp.isValid(y)) throw new Error("bad point: x or y not FE");
            const left = Fp.sqr(y); // y²
            const right = weierstrassEquation(x); // x³ + ax + b
            if (!Fp.eql(left, right)) throw new Error("bad point: equation left != right");
            if (!this.isTorsionFree()) throw new Error("bad point: not in prime-order subgroup");
        }
        hasEvenY() {
            const { y: y } = this.toAffine();
            if (Fp.isOdd) return !Fp.isOdd(y);
            throw new Error("Field doesn't support isOdd");
        }
        /**
         * Compare one point to another.
         */ equals(other) {
            assertPrjPoint(other);
            const { px: X1, py: Y1, pz: Z1 } = this;
            const { px: X2, py: Y2, pz: Z2 } = other;
            const U1 = Fp.eql(Fp.mul(X1, Z2), Fp.mul(X2, Z1));
            const U2 = Fp.eql(Fp.mul(Y1, Z2), Fp.mul(Y2, Z1));
            return U1 && U2;
        }
        /**
         * Flips point to one corresponding to (x, -y) in Affine coordinates.
         */ negate() {
            return new Point(this.px, Fp.neg(this.py), this.pz);
        }
        // Renes-Costello-Batina exception-free doubling formula.
        // There is 30% faster Jacobian formula, but it is not complete.
        // https://eprint.iacr.org/2015/1060, algorithm 3
        // Cost: 8M + 3S + 3*a + 2*b3 + 15add.
        double() {
            const { a: a, b: b } = CURVE;
            const b3 = Fp.mul(b, $c3b91d553ab14e64$var$_3n);
            const { px: X1, py: Y1, pz: Z1 } = this;
            let X3 = Fp.ZERO, Y3 = Fp.ZERO, Z3 = Fp.ZERO; // prettier-ignore
            let t0 = Fp.mul(X1, X1); // step 1
            let t1 = Fp.mul(Y1, Y1);
            let t2 = Fp.mul(Z1, Z1);
            let t3 = Fp.mul(X1, Y1);
            t3 = Fp.add(t3, t3); // step 5
            Z3 = Fp.mul(X1, Z1);
            Z3 = Fp.add(Z3, Z3);
            X3 = Fp.mul(a, Z3);
            Y3 = Fp.mul(b3, t2);
            Y3 = Fp.add(X3, Y3); // step 10
            X3 = Fp.sub(t1, Y3);
            Y3 = Fp.add(t1, Y3);
            Y3 = Fp.mul(X3, Y3);
            X3 = Fp.mul(t3, X3);
            Z3 = Fp.mul(b3, Z3); // step 15
            t2 = Fp.mul(a, t2);
            t3 = Fp.sub(t0, t2);
            t3 = Fp.mul(a, t3);
            t3 = Fp.add(t3, Z3);
            Z3 = Fp.add(t0, t0); // step 20
            t0 = Fp.add(Z3, t0);
            t0 = Fp.add(t0, t2);
            t0 = Fp.mul(t0, t3);
            Y3 = Fp.add(Y3, t0);
            t2 = Fp.mul(Y1, Z1); // step 25
            t2 = Fp.add(t2, t2);
            t0 = Fp.mul(t2, t3);
            X3 = Fp.sub(X3, t0);
            Z3 = Fp.mul(t2, t1);
            Z3 = Fp.add(Z3, Z3); // step 30
            Z3 = Fp.add(Z3, Z3);
            return new Point(X3, Y3, Z3);
        }
        // Renes-Costello-Batina exception-free addition formula.
        // There is 30% faster Jacobian formula, but it is not complete.
        // https://eprint.iacr.org/2015/1060, algorithm 1
        // Cost: 12M + 0S + 3*a + 3*b3 + 23add.
        add(other) {
            assertPrjPoint(other);
            const { px: X1, py: Y1, pz: Z1 } = this;
            const { px: X2, py: Y2, pz: Z2 } = other;
            let X3 = Fp.ZERO, Y3 = Fp.ZERO, Z3 = Fp.ZERO; // prettier-ignore
            const a = CURVE.a;
            const b3 = Fp.mul(CURVE.b, $c3b91d553ab14e64$var$_3n);
            let t0 = Fp.mul(X1, X2); // step 1
            let t1 = Fp.mul(Y1, Y2);
            let t2 = Fp.mul(Z1, Z2);
            let t3 = Fp.add(X1, Y1);
            let t4 = Fp.add(X2, Y2); // step 5
            t3 = Fp.mul(t3, t4);
            t4 = Fp.add(t0, t1);
            t3 = Fp.sub(t3, t4);
            t4 = Fp.add(X1, Z1);
            let t5 = Fp.add(X2, Z2); // step 10
            t4 = Fp.mul(t4, t5);
            t5 = Fp.add(t0, t2);
            t4 = Fp.sub(t4, t5);
            t5 = Fp.add(Y1, Z1);
            X3 = Fp.add(Y2, Z2); // step 15
            t5 = Fp.mul(t5, X3);
            X3 = Fp.add(t1, t2);
            t5 = Fp.sub(t5, X3);
            Z3 = Fp.mul(a, t4);
            X3 = Fp.mul(b3, t2); // step 20
            Z3 = Fp.add(X3, Z3);
            X3 = Fp.sub(t1, Z3);
            Z3 = Fp.add(t1, Z3);
            Y3 = Fp.mul(X3, Z3);
            t1 = Fp.add(t0, t0); // step 25
            t1 = Fp.add(t1, t0);
            t2 = Fp.mul(a, t2);
            t4 = Fp.mul(b3, t4);
            t1 = Fp.add(t1, t2);
            t2 = Fp.sub(t0, t2); // step 30
            t2 = Fp.mul(a, t2);
            t4 = Fp.add(t4, t2);
            t0 = Fp.mul(t1, t4);
            Y3 = Fp.add(Y3, t0);
            t0 = Fp.mul(t5, t4); // step 35
            X3 = Fp.mul(t3, X3);
            X3 = Fp.sub(X3, t0);
            t0 = Fp.mul(t3, t1);
            Z3 = Fp.mul(t5, Z3);
            Z3 = Fp.add(Z3, t0); // step 40
            return new Point(X3, Y3, Z3);
        }
        subtract(other) {
            return this.add(other.negate());
        }
        is0() {
            return this.equals(Point.ZERO);
        }
        wNAF(n) {
            return wnaf.wNAFCached(this, pointPrecomputes, n, (comp)=>{
                const toInv = Fp.invertBatch(comp.map((p)=>p.pz));
                return comp.map((p, i)=>p.toAffine(toInv[i])).map(Point.fromAffine);
            });
        }
        /**
         * Non-constant-time multiplication. Uses double-and-add algorithm.
         * It's faster, but should only be used when you don't care about
         * an exposed private key e.g. sig verification, which works over *public* keys.
         */ multiplyUnsafe(n) {
            const I = Point.ZERO;
            if (n === $c3b91d553ab14e64$var$_0n) return I;
            assertGE(n); // Will throw on 0
            if (n === $c3b91d553ab14e64$var$_1n) return this;
            const { endo: endo } = CURVE;
            if (!endo) return wnaf.unsafeLadder(this, n);
            // Apply endomorphism
            let { k1neg: k1neg, k1: k1, k2neg: k2neg, k2: k2 } = endo.splitScalar(n);
            let k1p = I;
            let k2p = I;
            let d = this;
            while(k1 > $c3b91d553ab14e64$var$_0n || k2 > $c3b91d553ab14e64$var$_0n){
                if (k1 & $c3b91d553ab14e64$var$_1n) k1p = k1p.add(d);
                if (k2 & $c3b91d553ab14e64$var$_1n) k2p = k2p.add(d);
                d = d.double();
                k1 >>= $c3b91d553ab14e64$var$_1n;
                k2 >>= $c3b91d553ab14e64$var$_1n;
            }
            if (k1neg) k1p = k1p.negate();
            if (k2neg) k2p = k2p.negate();
            k2p = new Point(Fp.mul(k2p.px, endo.beta), k2p.py, k2p.pz);
            return k1p.add(k2p);
        }
        /**
         * Constant time multiplication.
         * Uses wNAF method. Windowed method may be 10% faster,
         * but takes 2x longer to generate and consumes 2x memory.
         * Uses precomputes when available.
         * Uses endomorphism for Koblitz curves.
         * @param scalar by which the point would be multiplied
         * @returns New point
         */ multiply(scalar) {
            assertGE(scalar);
            let n = scalar;
            let point, fake; // Fake point is used to const-time mult
            const { endo: endo } = CURVE;
            if (endo) {
                const { k1neg: k1neg, k1: k1, k2neg: k2neg, k2: k2 } = endo.splitScalar(n);
                let { p: k1p, f: f1p } = this.wNAF(k1);
                let { p: k2p, f: f2p } = this.wNAF(k2);
                k1p = wnaf.constTimeNegate(k1neg, k1p);
                k2p = wnaf.constTimeNegate(k2neg, k2p);
                k2p = new Point(Fp.mul(k2p.px, endo.beta), k2p.py, k2p.pz);
                point = k1p.add(k2p);
                fake = f1p.add(f2p);
            } else {
                const { p: p, f: f } = this.wNAF(n);
                point = p;
                fake = f;
            }
            // Normalize `z` for both points, but return only real one
            return Point.normalizeZ([
                point,
                fake
            ])[0];
        }
        /**
         * Efficiently calculate `aP + bQ`. Unsafe, can expose private key, if used incorrectly.
         * Not using Strauss-Shamir trick: precomputation tables are faster.
         * The trick could be useful if both P and Q are not G (not in our case).
         * @returns non-zero affine point
         */ multiplyAndAddUnsafe(Q, a, b) {
            const G = Point.BASE; // No Strauss-Shamir trick: we have 10% faster G precomputes
            const mul = (P, a // Select faster multiply() method
            )=>a === $c3b91d553ab14e64$var$_0n || a === $c3b91d553ab14e64$var$_1n || !P.equals(G) ? P.multiplyUnsafe(a) : P.multiply(a);
            const sum = mul(this, a).add(mul(Q, b));
            return sum.is0() ? undefined : sum;
        }
        // Converts Projective point to affine (x, y) coordinates.
        // Can accept precomputed Z^-1 - for example, from invertBatch.
        // (x, y, z) ∋ (x=x/z, y=y/z)
        toAffine(iz) {
            const { px: x, py: y, pz: z } = this;
            const is0 = this.is0();
            // If invZ was 0, we return zero point. However we still want to execute
            // all operations, so we replace invZ with a random number, 1.
            if (iz == null) iz = is0 ? Fp.ONE : Fp.inv(z);
            const ax = Fp.mul(x, iz);
            const ay = Fp.mul(y, iz);
            const zz = Fp.mul(z, iz);
            if (is0) return {
                x: Fp.ZERO,
                y: Fp.ZERO
            };
            if (!Fp.eql(zz, Fp.ONE)) throw new Error("invZ was invalid");
            return {
                x: ax,
                y: ay
            };
        }
        isTorsionFree() {
            const { h: cofactor, isTorsionFree: isTorsionFree } = CURVE;
            if (cofactor === $c3b91d553ab14e64$var$_1n) return true; // No subgroups, always torsion-free
            if (isTorsionFree) return isTorsionFree(Point, this);
            throw new Error("isTorsionFree() has not been declared for the elliptic curve");
        }
        clearCofactor() {
            const { h: cofactor, clearCofactor: clearCofactor } = CURVE;
            if (cofactor === $c3b91d553ab14e64$var$_1n) return this; // Fast-path
            if (clearCofactor) return clearCofactor(Point, this);
            return this.multiplyUnsafe(CURVE.h);
        }
        toRawBytes(isCompressed = true) {
            this.assertValidity();
            return toBytes(Point, this, isCompressed);
        }
        toHex(isCompressed = true) {
            return $esaJO.bytesToHex(this.toRawBytes(isCompressed));
        }
    }
    Point.BASE = new Point(CURVE.Gx, CURVE.Gy, Fp.ONE);
    Point.ZERO = new Point(Fp.ZERO, Fp.ONE, Fp.ZERO);
    const _bits = CURVE.nBitLength;
    const wnaf = (0, $lkFCe.wNAF)(Point, CURVE.endo ? Math.ceil(_bits / 2) : _bits);
    // Validate if generator point is on curve
    return {
        CURVE: CURVE,
        ProjectivePoint: Point,
        normPrivateKeyToScalar: normPrivateKeyToScalar,
        weierstrassEquation: weierstrassEquation,
        isWithinCurveOrder: isWithinCurveOrder
    };
}
module.exports.weierstrassPoints = $c3b91d553ab14e64$var$weierstrassPoints;
function $c3b91d553ab14e64$var$validateOpts(curve) {
    const opts = (0, $lkFCe.validateBasic)(curve);
    $esaJO.validateObject(opts, {
        hash: "hash",
        hmac: "function",
        randomBytes: "function"
    }, {
        bits2int: "function",
        bits2int_modN: "function",
        lowS: "boolean"
    });
    return Object.freeze({
        lowS: true,
        ...opts
    });
}
function $c3b91d553ab14e64$var$weierstrass(curveDef) {
    const CURVE = $c3b91d553ab14e64$var$validateOpts(curveDef);
    const { Fp: Fp, n: CURVE_ORDER } = CURVE;
    const compressedLen = Fp.BYTES + 1; // e.g. 33 for 32
    const uncompressedLen = 2 * Fp.BYTES + 1; // e.g. 65 for 32
    function isValidFieldElement(num) {
        return $c3b91d553ab14e64$var$_0n < num && num < Fp.ORDER; // 0 is banned since it's not invertible FE
    }
    function modN(a) {
        return $2D9sF.mod(a, CURVE_ORDER);
    }
    function invN(a) {
        return $2D9sF.invert(a, CURVE_ORDER);
    }
    const { ProjectivePoint: Point, normPrivateKeyToScalar: normPrivateKeyToScalar, weierstrassEquation: weierstrassEquation, isWithinCurveOrder: isWithinCurveOrder } = $c3b91d553ab14e64$var$weierstrassPoints({
        ...CURVE,
        toBytes (_c, point, isCompressed) {
            const a = point.toAffine();
            const x = Fp.toBytes(a.x);
            const cat = $esaJO.concatBytes;
            if (isCompressed) return cat(Uint8Array.from([
                point.hasEvenY() ? 0x02 : 0x03
            ]), x);
            else return cat(Uint8Array.from([
                0x04
            ]), x, Fp.toBytes(a.y));
        },
        fromBytes (bytes) {
            const len = bytes.length;
            const head = bytes[0];
            const tail = bytes.subarray(1);
            // this.assertValidity() is done inside of fromHex
            if (len === compressedLen && (head === 0x02 || head === 0x03)) {
                const x = $esaJO.bytesToNumberBE(tail);
                if (!isValidFieldElement(x)) throw new Error("Point is not on curve");
                const y2 = weierstrassEquation(x); // y² = x³ + ax + b
                let y = Fp.sqrt(y2); // y = y² ^ (p+1)/4
                const isYOdd = (y & $c3b91d553ab14e64$var$_1n) === $c3b91d553ab14e64$var$_1n;
                // ECDSA
                const isHeadOdd = (head & 1) === 1;
                if (isHeadOdd !== isYOdd) y = Fp.neg(y);
                return {
                    x: x,
                    y: y
                };
            } else if (len === uncompressedLen && head === 0x04) {
                const x = Fp.fromBytes(tail.subarray(0, Fp.BYTES));
                const y = Fp.fromBytes(tail.subarray(Fp.BYTES, 2 * Fp.BYTES));
                return {
                    x: x,
                    y: y
                };
            } else throw new Error(`Point of length ${len} was invalid. Expected ${compressedLen} compressed bytes or ${uncompressedLen} uncompressed bytes`);
        }
    });
    const numToNByteStr = (num)=>$esaJO.bytesToHex($esaJO.numberToBytesBE(num, CURVE.nByteLength));
    function isBiggerThanHalfOrder(number) {
        const HALF = CURVE_ORDER >> $c3b91d553ab14e64$var$_1n;
        return number > HALF;
    }
    function normalizeS(s) {
        return isBiggerThanHalfOrder(s) ? modN(-s) : s;
    }
    // slice bytes num
    const slcNum = (b, from, to)=>$esaJO.bytesToNumberBE(b.slice(from, to));
    /**
     * ECDSA signature with its (r, s) properties. Supports DER & compact representations.
     */ class Signature {
        constructor(r, s, recovery){
            this.r = r;
            this.s = s;
            this.recovery = recovery;
            this.assertValidity();
        }
        // pair (bytes of r, bytes of s)
        static fromCompact(hex) {
            const l = CURVE.nByteLength;
            hex = (0, $esaJO.ensureBytes)("compactSignature", hex, l * 2);
            return new Signature(slcNum(hex, 0, l), slcNum(hex, l, 2 * l));
        }
        // DER encoded ECDSA signature
        // https://bitcoin.stackexchange.com/questions/57644/what-are-the-parts-of-a-bitcoin-transaction-input-script
        static fromDER(hex) {
            const { r: r, s: s } = module.exports.DER.toSig((0, $esaJO.ensureBytes)("DER", hex));
            return new Signature(r, s);
        }
        assertValidity() {
            // can use assertGE here
            if (!isWithinCurveOrder(this.r)) throw new Error("r must be 0 < r < CURVE.n");
            if (!isWithinCurveOrder(this.s)) throw new Error("s must be 0 < s < CURVE.n");
        }
        addRecoveryBit(recovery) {
            return new Signature(this.r, this.s, recovery);
        }
        recoverPublicKey(msgHash) {
            const { r: r, s: s, recovery: rec } = this;
            const h = bits2int_modN((0, $esaJO.ensureBytes)("msgHash", msgHash)); // Truncate hash
            if (rec == null || ![
                0,
                1,
                2,
                3
            ].includes(rec)) throw new Error("recovery id invalid");
            const radj = rec === 2 || rec === 3 ? r + CURVE.n : r;
            if (radj >= Fp.ORDER) throw new Error("recovery id 2 or 3 invalid");
            const prefix = (rec & 1) === 0 ? "02" : "03";
            const R = Point.fromHex(prefix + numToNByteStr(radj));
            const ir = invN(radj); // r^-1
            const u1 = modN(-h * ir); // -hr^-1
            const u2 = modN(s * ir); // sr^-1
            const Q = Point.BASE.multiplyAndAddUnsafe(R, u1, u2); // (sr^-1)R-(hr^-1)G = -(hr^-1)G + (sr^-1)
            if (!Q) throw new Error("point at infinify"); // unsafe is fine: no priv data leaked
            Q.assertValidity();
            return Q;
        }
        // Signatures should be low-s, to prevent malleability.
        hasHighS() {
            return isBiggerThanHalfOrder(this.s);
        }
        normalizeS() {
            return this.hasHighS() ? new Signature(this.r, modN(-this.s), this.recovery) : this;
        }
        // DER-encoded
        toDERRawBytes() {
            return $esaJO.hexToBytes(this.toDERHex());
        }
        toDERHex() {
            return module.exports.DER.hexFromSig({
                r: this.r,
                s: this.s
            });
        }
        // padded bytes of r, then padded bytes of s
        toCompactRawBytes() {
            return $esaJO.hexToBytes(this.toCompactHex());
        }
        toCompactHex() {
            return numToNByteStr(this.r) + numToNByteStr(this.s);
        }
    }
    const utils = {
        isValidPrivateKey (privateKey) {
            try {
                normPrivateKeyToScalar(privateKey);
                return true;
            } catch (error) {
                return false;
            }
        },
        normPrivateKeyToScalar: normPrivateKeyToScalar,
        /**
         * Produces cryptographically secure private key from random of size
         * (groupLen + ceil(groupLen / 2)) with modulo bias being negligible.
         */ randomPrivateKey: ()=>{
            const length = $2D9sF.getMinHashLength(CURVE.n);
            return $2D9sF.mapHashToField(CURVE.randomBytes(length), CURVE.n);
        },
        /**
         * Creates precompute table for an arbitrary EC point. Makes point "cached".
         * Allows to massively speed-up `point.multiply(scalar)`.
         * @returns cached point
         * @example
         * const fast = utils.precompute(8, ProjectivePoint.fromHex(someonesPubKey));
         * fast.multiply(privKey); // much faster ECDH now
         */ precompute (windowSize = 8, point = Point.BASE) {
            point._setWindowSize(windowSize);
            point.multiply(BigInt(3)); // 3 is arbitrary, just need any number here
            return point;
        }
    };
    /**
     * Computes public key for a private key. Checks for validity of the private key.
     * @param privateKey private key
     * @param isCompressed whether to return compact (default), or full key
     * @returns Public key, full when isCompressed=false; short when isCompressed=true
     */ function getPublicKey(privateKey, isCompressed = true) {
        return Point.fromPrivateKey(privateKey).toRawBytes(isCompressed);
    }
    /**
     * Quick and dirty check for item being public key. Does not validate hex, or being on-curve.
     */ function isProbPub(item) {
        const arr = item instanceof Uint8Array;
        const str = typeof item === "string";
        const len = (arr || str) && item.length;
        if (arr) return len === compressedLen || len === uncompressedLen;
        if (str) return len === 2 * compressedLen || len === 2 * uncompressedLen;
        if (item instanceof Point) return true;
        return false;
    }
    /**
     * ECDH (Elliptic Curve Diffie Hellman).
     * Computes shared public key from private key and public key.
     * Checks: 1) private key validity 2) shared key is on-curve.
     * Does NOT hash the result.
     * @param privateA private key
     * @param publicB different public key
     * @param isCompressed whether to return compact (default), or full key
     * @returns shared public key
     */ function getSharedSecret(privateA, publicB, isCompressed = true) {
        if (isProbPub(privateA)) throw new Error("first arg must be private key");
        if (!isProbPub(publicB)) throw new Error("second arg must be public key");
        const b = Point.fromHex(publicB); // check for being on-curve
        return b.multiply(normPrivateKeyToScalar(privateA)).toRawBytes(isCompressed);
    }
    // RFC6979: ensure ECDSA msg is X bytes and < N. RFC suggests optional truncating via bits2octets.
    // FIPS 186-4 4.6 suggests the leftmost min(nBitLen, outLen) bits, which matches bits2int.
    // bits2int can produce res>N, we can do mod(res, N) since the bitLen is the same.
    // int2octets can't be used; pads small msgs with 0: unacceptatble for trunc as per RFC vectors
    const bits2int = CURVE.bits2int || function(bytes) {
        // For curves with nBitLength % 8 !== 0: bits2octets(bits2octets(m)) !== bits2octets(m)
        // for some cases, since bytes.length * 8 is not actual bitLength.
        const num = $esaJO.bytesToNumberBE(bytes); // check for == u8 done here
        const delta = bytes.length * 8 - CURVE.nBitLength; // truncate to nBitLength leftmost bits
        return delta > 0 ? num >> BigInt(delta) : num;
    };
    const bits2int_modN = CURVE.bits2int_modN || function(bytes) {
        return modN(bits2int(bytes)); // can't use bytesToNumberBE here
    };
    // NOTE: pads output with zero as per spec
    const ORDER_MASK = $esaJO.bitMask(CURVE.nBitLength);
    /**
     * Converts to bytes. Checks if num in `[0..ORDER_MASK-1]` e.g.: `[0..2^256-1]`.
     */ function int2octets(num) {
        if (typeof num !== "bigint") throw new Error("bigint expected");
        if (!($c3b91d553ab14e64$var$_0n <= num && num < ORDER_MASK)) throw new Error(`bigint expected < 2^${CURVE.nBitLength}`);
        // works with order, can have different size than numToField!
        return $esaJO.numberToBytesBE(num, CURVE.nByteLength);
    }
    // Steps A, D of RFC6979 3.2
    // Creates RFC6979 seed; converts msg/privKey to numbers.
    // Used only in sign, not in verify.
    // NOTE: we cannot assume here that msgHash has same amount of bytes as curve order, this will be wrong at least for P521.
    // Also it can be bigger for P224 + SHA256
    function prepSig(msgHash, privateKey, opts = defaultSigOpts) {
        if ([
            "recovered",
            "canonical"
        ].some((k)=>k in opts)) throw new Error("sign() legacy options not supported");
        const { hash: hash, randomBytes: randomBytes } = CURVE;
        let { lowS: lowS, prehash: prehash, extraEntropy: ent } = opts; // generates low-s sigs by default
        if (lowS == null) lowS = true; // RFC6979 3.2: we skip step A, because we already provide hash
        msgHash = (0, $esaJO.ensureBytes)("msgHash", msgHash);
        if (prehash) msgHash = (0, $esaJO.ensureBytes)("prehashed msgHash", hash(msgHash));
        // We can't later call bits2octets, since nested bits2int is broken for curves
        // with nBitLength % 8 !== 0. Because of that, we unwrap it here as int2octets call.
        // const bits2octets = (bits) => int2octets(bits2int_modN(bits))
        const h1int = bits2int_modN(msgHash);
        const d = normPrivateKeyToScalar(privateKey); // validate private key, convert to bigint
        const seedArgs = [
            int2octets(d),
            int2octets(h1int)
        ];
        // extraEntropy. RFC6979 3.6: additional k' (optional).
        if (ent != null) {
            // K = HMAC_K(V || 0x00 || int2octets(x) || bits2octets(h1) || k')
            const e = ent === true ? randomBytes(Fp.BYTES) : ent; // generate random bytes OR pass as-is
            seedArgs.push((0, $esaJO.ensureBytes)("extraEntropy", e)); // check for being bytes
        }
        const seed = $esaJO.concatBytes(...seedArgs); // Step D of RFC6979 3.2
        const m = h1int; // NOTE: no need to call bits2int second time here, it is inside truncateHash!
        // Converts signature params into point w r/s, checks result for validity.
        function k2sig(kBytes) {
            // RFC 6979 Section 3.2, step 3: k = bits2int(T)
            const k = bits2int(kBytes); // Cannot use fields methods, since it is group element
            if (!isWithinCurveOrder(k)) return; // Important: all mod() calls here must be done over N
            const ik = invN(k); // k^-1 mod n
            const q = Point.BASE.multiply(k).toAffine(); // q = Gk
            const r = modN(q.x); // r = q.x mod n
            if (r === $c3b91d553ab14e64$var$_0n) return;
            // Can use scalar blinding b^-1(bm + bdr) where b ∈ [1,q−1] according to
            // https://tches.iacr.org/index.php/TCHES/article/view/7337/6509. We've decided against it:
            // a) dependency on CSPRNG b) 15% slowdown c) doesn't really help since bigints are not CT
            const s = modN(ik * modN(m + r * d)); // Not using blinding here
            if (s === $c3b91d553ab14e64$var$_0n) return;
            let recovery = (q.x === r ? 0 : 2) | Number(q.y & $c3b91d553ab14e64$var$_1n); // recovery bit (2 or 3, when q.x > n)
            let normS = s;
            if (lowS && isBiggerThanHalfOrder(s)) {
                normS = normalizeS(s); // if lowS was passed, ensure s is always
                recovery ^= 1; // // in the bottom half of N
            }
            return new Signature(r, normS, recovery); // use normS, not s
        }
        return {
            seed: seed,
            k2sig: k2sig
        };
    }
    const defaultSigOpts = {
        lowS: CURVE.lowS,
        prehash: false
    };
    const defaultVerOpts = {
        lowS: CURVE.lowS,
        prehash: false
    };
    /**
     * Signs message hash with a private key.
     * ```
     * sign(m, d, k) where
     *   (x, y) = G × k
     *   r = x mod n
     *   s = (m + dr)/k mod n
     * ```
     * @param msgHash NOT message. msg needs to be hashed to `msgHash`, or use `prehash`.
     * @param privKey private key
     * @param opts lowS for non-malleable sigs. extraEntropy for mixing randomness into k. prehash will hash first arg.
     * @returns signature with recovery param
     */ function sign(msgHash, privKey, opts = defaultSigOpts) {
        const { seed: seed, k2sig: k2sig } = prepSig(msgHash, privKey, opts); // Steps A, D of RFC6979 3.2.
        const C = CURVE;
        const drbg = $esaJO.createHmacDrbg(C.hash.outputLen, C.nByteLength, C.hmac);
        return drbg(seed, k2sig); // Steps B, C, D, E, F, G
    }
    // Enable precomputes. Slows down first publicKey computation by 20ms.
    Point.BASE._setWindowSize(8);
    // utils.precompute(8, ProjectivePoint.BASE)
    /**
     * Verifies a signature against message hash and public key.
     * Rejects lowS signatures by default: to override,
     * specify option `{lowS: false}`. Implements section 4.1.4 from https://www.secg.org/sec1-v2.pdf:
     *
     * ```
     * verify(r, s, h, P) where
     *   U1 = hs^-1 mod n
     *   U2 = rs^-1 mod n
     *   R = U1⋅G - U2⋅P
     *   mod(R.x, n) == r
     * ```
     */ function verify(signature, msgHash, publicKey, opts = defaultVerOpts) {
        const sg = signature;
        msgHash = (0, $esaJO.ensureBytes)("msgHash", msgHash);
        publicKey = (0, $esaJO.ensureBytes)("publicKey", publicKey);
        if ("strict" in opts) throw new Error("options.strict was renamed to lowS");
        const { lowS: lowS, prehash: prehash } = opts;
        let _sig = undefined;
        let P;
        try {
            if (typeof sg === "string" || sg instanceof Uint8Array) // Signature can be represented in 2 ways: compact (2*nByteLength) & DER (variable-length).
            // Since DER can also be 2*nByteLength bytes, we check for it first.
            try {
                _sig = Signature.fromDER(sg);
            } catch (derError) {
                if (!(derError instanceof module.exports.DER.Err)) throw derError;
                _sig = Signature.fromCompact(sg);
            }
            else if (typeof sg === "object" && typeof sg.r === "bigint" && typeof sg.s === "bigint") {
                const { r: r, s: s } = sg;
                _sig = new Signature(r, s);
            } else throw new Error("PARSE");
            P = Point.fromHex(publicKey);
        } catch (error) {
            if (error.message === "PARSE") throw new Error(`signature must be Signature instance, Uint8Array or hex string`);
            return false;
        }
        if (lowS && _sig.hasHighS()) return false;
        if (prehash) msgHash = CURVE.hash(msgHash);
        const { r: r, s: s } = _sig;
        const h = bits2int_modN(msgHash); // Cannot use fields methods, since it is group element
        const is = invN(s); // s^-1
        const u1 = modN(h * is); // u1 = hs^-1 mod n
        const u2 = modN(r * is); // u2 = rs^-1 mod n
        const R = Point.BASE.multiplyAndAddUnsafe(P, u1, u2)?.toAffine(); // R = u1⋅G + u2⋅P
        if (!R) return false;
        const v = modN(R.x);
        return v === r;
    }
    return {
        CURVE: CURVE,
        getPublicKey: getPublicKey,
        getSharedSecret: getSharedSecret,
        sign: sign,
        verify: verify,
        ProjectivePoint: Point,
        Signature: Signature,
        utils: utils
    };
}
module.exports.weierstrass = $c3b91d553ab14e64$var$weierstrass;
/**
 * Implementation of the Shallue and van de Woestijne method for any weierstrass curve.
 * TODO: check if there is a way to merge this with uvRatio in Edwards; move to modular.
 * b = True and y = sqrt(u / v) if (u / v) is square in F, and
 * b = False and y = sqrt(Z * (u / v)) otherwise.
 * @param Fp
 * @param Z
 * @returns
 */ function $c3b91d553ab14e64$var$SWUFpSqrtRatio(Fp, Z) {
    // Generic implementation
    const q = Fp.ORDER;
    let l = $c3b91d553ab14e64$var$_0n;
    for(let o = q - $c3b91d553ab14e64$var$_1n; o % $c3b91d553ab14e64$var$_2n === $c3b91d553ab14e64$var$_0n; o /= $c3b91d553ab14e64$var$_2n)l += $c3b91d553ab14e64$var$_1n;
    const c1 = l; // 1. c1, the largest integer such that 2^c1 divides q - 1.
    // We need 2n ** c1 and 2n ** (c1-1). We can't use **; but we can use <<.
    // 2n ** c1 == 2n << (c1-1)
    const _2n_pow_c1_1 = $c3b91d553ab14e64$var$_2n << c1 - $c3b91d553ab14e64$var$_1n - $c3b91d553ab14e64$var$_1n;
    const _2n_pow_c1 = _2n_pow_c1_1 * $c3b91d553ab14e64$var$_2n;
    const c2 = (q - $c3b91d553ab14e64$var$_1n) / _2n_pow_c1; // 2. c2 = (q - 1) / (2^c1)  # Integer arithmetic
    const c3 = (c2 - $c3b91d553ab14e64$var$_1n) / $c3b91d553ab14e64$var$_2n; // 3. c3 = (c2 - 1) / 2            # Integer arithmetic
    const c4 = _2n_pow_c1 - $c3b91d553ab14e64$var$_1n; // 4. c4 = 2^c1 - 1                # Integer arithmetic
    const c5 = _2n_pow_c1_1; // 5. c5 = 2^(c1 - 1)                  # Integer arithmetic
    const c6 = Fp.pow(Z, c2); // 6. c6 = Z^c2
    const c7 = Fp.pow(Z, (c2 + $c3b91d553ab14e64$var$_1n) / $c3b91d553ab14e64$var$_2n); // 7. c7 = Z^((c2 + 1) / 2)
    let sqrtRatio = (u, v)=>{
        let tv1 = c6; // 1. tv1 = c6
        let tv2 = Fp.pow(v, c4); // 2. tv2 = v^c4
        let tv3 = Fp.sqr(tv2); // 3. tv3 = tv2^2
        tv3 = Fp.mul(tv3, v); // 4. tv3 = tv3 * v
        let tv5 = Fp.mul(u, tv3); // 5. tv5 = u * tv3
        tv5 = Fp.pow(tv5, c3); // 6. tv5 = tv5^c3
        tv5 = Fp.mul(tv5, tv2); // 7. tv5 = tv5 * tv2
        tv2 = Fp.mul(tv5, v); // 8. tv2 = tv5 * v
        tv3 = Fp.mul(tv5, u); // 9. tv3 = tv5 * u
        let tv4 = Fp.mul(tv3, tv2); // 10. tv4 = tv3 * tv2
        tv5 = Fp.pow(tv4, c5); // 11. tv5 = tv4^c5
        let isQR = Fp.eql(tv5, Fp.ONE); // 12. isQR = tv5 == 1
        tv2 = Fp.mul(tv3, c7); // 13. tv2 = tv3 * c7
        tv5 = Fp.mul(tv4, tv1); // 14. tv5 = tv4 * tv1
        tv3 = Fp.cmov(tv2, tv3, isQR); // 15. tv3 = CMOV(tv2, tv3, isQR)
        tv4 = Fp.cmov(tv5, tv4, isQR); // 16. tv4 = CMOV(tv5, tv4, isQR)
        // 17. for i in (c1, c1 - 1, ..., 2):
        for(let i = c1; i > $c3b91d553ab14e64$var$_1n; i--){
            let tv5 = i - $c3b91d553ab14e64$var$_2n; // 18.    tv5 = i - 2
            tv5 = $c3b91d553ab14e64$var$_2n << tv5 - $c3b91d553ab14e64$var$_1n; // 19.    tv5 = 2^tv5
            let tvv5 = Fp.pow(tv4, tv5); // 20.    tv5 = tv4^tv5
            const e1 = Fp.eql(tvv5, Fp.ONE); // 21.    e1 = tv5 == 1
            tv2 = Fp.mul(tv3, tv1); // 22.    tv2 = tv3 * tv1
            tv1 = Fp.mul(tv1, tv1); // 23.    tv1 = tv1 * tv1
            tvv5 = Fp.mul(tv4, tv1); // 24.    tv5 = tv4 * tv1
            tv3 = Fp.cmov(tv2, tv3, e1); // 25.    tv3 = CMOV(tv2, tv3, e1)
            tv4 = Fp.cmov(tvv5, tv4, e1); // 26.    tv4 = CMOV(tv5, tv4, e1)
        }
        return {
            isValid: isQR,
            value: tv3
        };
    };
    if (Fp.ORDER % $c3b91d553ab14e64$var$_4n === $c3b91d553ab14e64$var$_3n) {
        // sqrt_ratio_3mod4(u, v)
        const c1 = (Fp.ORDER - $c3b91d553ab14e64$var$_3n) / $c3b91d553ab14e64$var$_4n; // 1. c1 = (q - 3) / 4     # Integer arithmetic
        const c2 = Fp.sqrt(Fp.neg(Z)); // 2. c2 = sqrt(-Z)
        sqrtRatio = (u, v)=>{
            let tv1 = Fp.sqr(v); // 1. tv1 = v^2
            const tv2 = Fp.mul(u, v); // 2. tv2 = u * v
            tv1 = Fp.mul(tv1, tv2); // 3. tv1 = tv1 * tv2
            let y1 = Fp.pow(tv1, c1); // 4. y1 = tv1^c1
            y1 = Fp.mul(y1, tv2); // 5. y1 = y1 * tv2
            const y2 = Fp.mul(y1, c2); // 6. y2 = y1 * c2
            const tv3 = Fp.mul(Fp.sqr(y1), v); // 7. tv3 = y1^2; 8. tv3 = tv3 * v
            const isQR = Fp.eql(tv3, u); // 9. isQR = tv3 == u
            let y = Fp.cmov(y2, y1, isQR); // 10. y = CMOV(y2, y1, isQR)
            return {
                isValid: isQR,
                value: y
            }; // 11. return (isQR, y) isQR ? y : y*c2
        };
    }
    // No curves uses that
    // if (Fp.ORDER % _8n === _5n) // sqrt_ratio_5mod8
    return sqrtRatio;
}
module.exports.SWUFpSqrtRatio = $c3b91d553ab14e64$var$SWUFpSqrtRatio;
/**
 * Simplified Shallue-van de Woestijne-Ulas Method
 * https://www.rfc-editor.org/rfc/rfc9380#section-6.6.2
 */ function $c3b91d553ab14e64$var$mapToCurveSimpleSWU(Fp, opts) {
    $2D9sF.validateField(Fp);
    if (!Fp.isValid(opts.A) || !Fp.isValid(opts.B) || !Fp.isValid(opts.Z)) throw new Error("mapToCurveSimpleSWU: invalid opts");
    const sqrtRatio = $c3b91d553ab14e64$var$SWUFpSqrtRatio(Fp, opts.Z);
    if (!Fp.isOdd) throw new Error("Fp.isOdd is not implemented!");
    // Input: u, an element of F.
    // Output: (x, y), a point on E.
    return (u)=>{
        // prettier-ignore
        let tv1, tv2, tv3, tv4, tv5, tv6, x, y;
        tv1 = Fp.sqr(u); // 1.  tv1 = u^2
        tv1 = Fp.mul(tv1, opts.Z); // 2.  tv1 = Z * tv1
        tv2 = Fp.sqr(tv1); // 3.  tv2 = tv1^2
        tv2 = Fp.add(tv2, tv1); // 4.  tv2 = tv2 + tv1
        tv3 = Fp.add(tv2, Fp.ONE); // 5.  tv3 = tv2 + 1
        tv3 = Fp.mul(tv3, opts.B); // 6.  tv3 = B * tv3
        tv4 = Fp.cmov(opts.Z, Fp.neg(tv2), !Fp.eql(tv2, Fp.ZERO)); // 7.  tv4 = CMOV(Z, -tv2, tv2 != 0)
        tv4 = Fp.mul(tv4, opts.A); // 8.  tv4 = A * tv4
        tv2 = Fp.sqr(tv3); // 9.  tv2 = tv3^2
        tv6 = Fp.sqr(tv4); // 10. tv6 = tv4^2
        tv5 = Fp.mul(tv6, opts.A); // 11. tv5 = A * tv6
        tv2 = Fp.add(tv2, tv5); // 12. tv2 = tv2 + tv5
        tv2 = Fp.mul(tv2, tv3); // 13. tv2 = tv2 * tv3
        tv6 = Fp.mul(tv6, tv4); // 14. tv6 = tv6 * tv4
        tv5 = Fp.mul(tv6, opts.B); // 15. tv5 = B * tv6
        tv2 = Fp.add(tv2, tv5); // 16. tv2 = tv2 + tv5
        x = Fp.mul(tv1, tv3); // 17.   x = tv1 * tv3
        const { isValid: isValid, value: value } = sqrtRatio(tv2, tv6); // 18. (is_gx1_square, y1) = sqrt_ratio(tv2, tv6)
        y = Fp.mul(tv1, u); // 19.   y = tv1 * u  -> Z * u^3 * y1
        y = Fp.mul(y, value); // 20.   y = y * y1
        x = Fp.cmov(x, tv3, isValid); // 21.   x = CMOV(x, tv3, is_gx1_square)
        y = Fp.cmov(y, value, isValid); // 22.   y = CMOV(y, y1, is_gx1_square)
        const e1 = Fp.isOdd(u) === Fp.isOdd(y); // 23.  e1 = sgn0(u) == sgn0(y)
        y = Fp.cmov(Fp.neg(y), y, e1); // 24.   y = CMOV(-y, y, e1)
        x = Fp.div(x, tv4); // 25.   x = x / tv4
        return {
            x: x,
            y: y
        };
    };
}
module.exports.mapToCurveSimpleSWU = $c3b91d553ab14e64$var$mapToCurveSimpleSWU;

});

parcelRegister("7OcHe", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.createCurve = module.exports.getHash = void 0;

var $70Xw9 = parcelRequire("70Xw9");

var $3Bcdj = parcelRequire("3Bcdj");

var $gNPqy = parcelRequire("gNPqy");
// connects noble-curves to noble-hashes
function $5af70d1c5fca3e4e$var$getHash(hash) {
    return {
        hash: hash,
        hmac: (key, ...msgs)=>(0, $70Xw9.hmac)(hash, key, (0, $3Bcdj.concatBytes)(...msgs)),
        randomBytes: $3Bcdj.randomBytes
    };
}
module.exports.getHash = $5af70d1c5fca3e4e$var$getHash;
function $5af70d1c5fca3e4e$var$createCurve(curveDef, defHash) {
    const create = (hash)=>(0, $gNPqy.weierstrass)({
            ...curveDef,
            ...$5af70d1c5fca3e4e$var$getHash(hash)
        });
    return Object.freeze({
        ...create(defHash),
        create: create
    });
}
module.exports.createCurve = $5af70d1c5fca3e4e$var$createCurve;

});
parcelRegister("70Xw9", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.hmac = module.exports.HMAC = void 0;

var $dNiq9 = parcelRequire("dNiq9");

var $3Bcdj = parcelRequire("3Bcdj");
// HMAC (RFC 2104)
class $51b6b372898f65c0$var$HMAC extends $3Bcdj.Hash {
    constructor(hash, _key){
        super();
        this.finished = false;
        this.destroyed = false;
        (0, $dNiq9.hash)(hash);
        const key = (0, $3Bcdj.toBytes)(_key);
        this.iHash = hash.create();
        if (typeof this.iHash.update !== "function") throw new Error("Expected instance of class which extends utils.Hash");
        this.blockLen = this.iHash.blockLen;
        this.outputLen = this.iHash.outputLen;
        const blockLen = this.blockLen;
        const pad = new Uint8Array(blockLen);
        // blockLen can be bigger than outputLen
        pad.set(key.length > blockLen ? hash.create().update(key).digest() : key);
        for(let i = 0; i < pad.length; i++)pad[i] ^= 0x36;
        this.iHash.update(pad);
        // By doing update (processing of first block) of outer hash here we can re-use it between multiple calls via clone
        this.oHash = hash.create();
        // Undo internal XOR && apply outer XOR
        for(let i = 0; i < pad.length; i++)pad[i] ^= 106;
        this.oHash.update(pad);
        pad.fill(0);
    }
    update(buf) {
        (0, $dNiq9.exists)(this);
        this.iHash.update(buf);
        return this;
    }
    digestInto(out) {
        (0, $dNiq9.exists)(this);
        (0, $dNiq9.bytes)(out, this.outputLen);
        this.finished = true;
        this.iHash.digestInto(out);
        this.oHash.update(out);
        this.oHash.digestInto(out);
        this.destroy();
    }
    digest() {
        const out = new Uint8Array(this.oHash.outputLen);
        this.digestInto(out);
        return out;
    }
    _cloneInto(to) {
        // Create new instance without calling constructor since key already in state and we don't know it.
        to || (to = Object.create(Object.getPrototypeOf(this), {}));
        const { oHash: oHash, iHash: iHash, finished: finished, destroyed: destroyed, blockLen: blockLen, outputLen: outputLen } = this;
        to;
        to.finished = finished;
        to.destroyed = destroyed;
        to.blockLen = blockLen;
        to.outputLen = outputLen;
        to.oHash = oHash._cloneInto(to.oHash);
        to.iHash = iHash._cloneInto(to.iHash);
        return to;
    }
    destroy() {
        this.destroyed = true;
        this.oHash.destroy();
        this.iHash.destroy();
    }
}
module.exports.HMAC = $51b6b372898f65c0$var$HMAC;
/**
 * HMAC: RFC2104 message authentication code.
 * @param hash - function that would be used e.g. sha256
 * @param key - message key
 * @param message - message data
 */ const $51b6b372898f65c0$var$hmac = (hash, key, message)=>new $51b6b372898f65c0$var$HMAC(hash, key).update(message).digest();
module.exports.hmac = $51b6b372898f65c0$var$hmac;
module.exports.hmac.create = (hash, key)=>new $51b6b372898f65c0$var$HMAC(hash, key);

});




parcelRegister("hOzOt", function(module, exports) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ "use strict";

var $kZO5c = parcelRequire("kZO5c");
function $cf82e2ef667d5788$var$emptyFunction() {}
function $cf82e2ef667d5788$var$emptyFunctionWithReset() {}
$cf82e2ef667d5788$var$emptyFunctionWithReset.resetWarningCache = $cf82e2ef667d5788$var$emptyFunction;
module.exports = function() {
    function shim(props, propName, componentName, location, propFullName, secret) {
        if (secret === $kZO5c) // It is still safe when called from React.
        return;
        var err = new Error("Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types");
        err.name = "Invariant Violation";
        throw err;
    }
    shim.isRequired = shim;
    function getShim() {
        return shim;
    }
    // Important!
    // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
    var ReactPropTypes = {
        array: shim,
        bigint: shim,
        bool: shim,
        func: shim,
        number: shim,
        object: shim,
        string: shim,
        symbol: shim,
        any: shim,
        arrayOf: getShim,
        element: shim,
        elementType: shim,
        instanceOf: getShim,
        node: shim,
        objectOf: getShim,
        oneOf: getShim,
        oneOfType: getShim,
        shape: getShim,
        exact: getShim,
        checkPropTypes: $cf82e2ef667d5788$var$emptyFunctionWithReset,
        resetWarningCache: $cf82e2ef667d5788$var$emptyFunction
    };
    ReactPropTypes.PropTypes = ReactPropTypes;
    return ReactPropTypes;
};

});
parcelRegister("kZO5c", function(module, exports) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ "use strict";
var $f4905a8b274aa381$var$ReactPropTypesSecret = "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED";
module.exports = $f4905a8b274aa381$var$ReactPropTypesSecret;

});


parcelRegister("bYkMz", function(module, exports) {

var $5ltpn = parcelRequire("5ltpn");
const $8b756b3b8ee97947$var$ALPHABET = "123456789ABCDEFGHJKLMNPQRSTUVWXYZabcdefghijkmnopqrstuvwxyz";
module.exports = $5ltpn($8b756b3b8ee97947$var$ALPHABET);

});
parcelRegister("5ltpn", function(module, exports) {
"use strict";
// base-x encoding / decoding
// Copyright (c) 2018 base-x contributors
// Copyright (c) 2014-2018 The Bitcoin Core developers (base58.cpp)
// Distributed under the MIT software license, see the accompanying
// file LICENSE or http://www.opensource.org/licenses/mit-license.php.
function $3e45b9ca9a48d890$var$base(ALPHABET) {
    if (ALPHABET.length >= 255) throw new TypeError("Alphabet too long");
    var BASE_MAP = new Uint8Array(256);
    for(var j = 0; j < BASE_MAP.length; j++)BASE_MAP[j] = 255;
    for(var i = 0; i < ALPHABET.length; i++){
        var x = ALPHABET.charAt(i);
        var xc = x.charCodeAt(0);
        if (BASE_MAP[xc] !== 255) throw new TypeError(x + " is ambiguous");
        BASE_MAP[xc] = i;
    }
    var BASE = ALPHABET.length;
    var LEADER = ALPHABET.charAt(0);
    var FACTOR = Math.log(BASE) / Math.log(256) // log(BASE) / log(256), rounded up
    ;
    var iFACTOR = Math.log(256) / Math.log(BASE) // log(256) / log(BASE), rounded up
    ;
    function encode(source) {
        if (source instanceof Uint8Array) ;
        else if (ArrayBuffer.isView(source)) source = new Uint8Array(source.buffer, source.byteOffset, source.byteLength);
        else if (Array.isArray(source)) source = Uint8Array.from(source);
        if (!(source instanceof Uint8Array)) throw new TypeError("Expected Uint8Array");
        if (source.length === 0) return "";
        // Skip & count leading zeroes.
        var zeroes = 0;
        var length = 0;
        var pbegin = 0;
        var pend = source.length;
        while(pbegin !== pend && source[pbegin] === 0){
            pbegin++;
            zeroes++;
        }
        // Allocate enough space in big-endian base58 representation.
        var size = (pend - pbegin) * iFACTOR + 1 >>> 0;
        var b58 = new Uint8Array(size);
        // Process the bytes.
        while(pbegin !== pend){
            var carry = source[pbegin];
            // Apply "b58 = b58 * 256 + ch".
            var i = 0;
            for(var it1 = size - 1; (carry !== 0 || i < length) && it1 !== -1; it1--, i++){
                carry += 256 * b58[it1] >>> 0;
                b58[it1] = carry % BASE >>> 0;
                carry = carry / BASE >>> 0;
            }
            if (carry !== 0) throw new Error("Non-zero carry");
            length = i;
            pbegin++;
        }
        // Skip leading zeroes in base58 result.
        var it2 = size - length;
        while(it2 !== size && b58[it2] === 0)it2++;
        // Translate the result into a string.
        var str = LEADER.repeat(zeroes);
        for(; it2 < size; ++it2)str += ALPHABET.charAt(b58[it2]);
        return str;
    }
    function decodeUnsafe(source) {
        if (typeof source !== "string") throw new TypeError("Expected String");
        if (source.length === 0) return new Uint8Array();
        var psz = 0;
        // Skip and count leading '1's.
        var zeroes = 0;
        var length = 0;
        while(source[psz] === LEADER){
            zeroes++;
            psz++;
        }
        // Allocate enough space in big-endian base256 representation.
        var size = (source.length - psz) * FACTOR + 1 >>> 0 // log(58) / log(256), rounded up.
        ;
        var b256 = new Uint8Array(size);
        // Process the characters.
        while(source[psz]){
            // Decode character
            var carry = BASE_MAP[source.charCodeAt(psz)];
            // Invalid character
            if (carry === 255) return;
            var i = 0;
            for(var it3 = size - 1; (carry !== 0 || i < length) && it3 !== -1; it3--, i++){
                carry += BASE * b256[it3] >>> 0;
                b256[it3] = carry % 256 >>> 0;
                carry = carry / 256 >>> 0;
            }
            if (carry !== 0) throw new Error("Non-zero carry");
            length = i;
            psz++;
        }
        // Skip leading zeroes in b256.
        var it4 = size - length;
        while(it4 !== size && b256[it4] === 0)it4++;
        var vch = new Uint8Array(zeroes + (size - it4));
        var j = zeroes;
        while(it4 !== size)vch[j++] = b256[it4++];
        return vch;
    }
    function decode(string) {
        var buffer = decodeUnsafe(string);
        if (buffer) return buffer;
        throw new Error("Non-base" + BASE + " character");
    }
    return {
        encode: encode,
        decodeUnsafe: decodeUnsafe,
        decode: decode
    };
}
module.exports = $3e45b9ca9a48d890$var$base;

});


parcelRegister("iJxGt", function(module, exports) {

$parcel$export(module.exports, "SolanaSignAndSendTransaction", () => $da368ee8f406d58d$export$dd64f32469f35f81);
/** Name of the feature. */ const $da368ee8f406d58d$export$dd64f32469f35f81 = "solana:signAndSendTransaction";

});

parcelRegister("d2raY", function(module, exports) {

$parcel$export(module.exports, "SolanaSignTransaction", () => $97e08ae06ec466db$export$54187c3796d0ecb);
/** Name of the feature. */ const $97e08ae06ec466db$export$54187c3796d0ecb = "solana:signTransaction";

});

parcelRegister("7KE4n", function(module, exports) {

$parcel$export(module.exports, "SolanaSignMessage", () => $5a4be9421d6e6c61$export$22c7939a38084172);
/** Name of the feature. */ const $5a4be9421d6e6c61$export$22c7939a38084172 = "solana:signMessage";

});

parcelRegister("4KAV8", function(module, exports) {

$parcel$export(module.exports, "default", () => $375818ecee1623c3$export$2e2bcd8739ae039);
$parcel$export(module.exports, "TransportStatusError", () => (parcelRequire("degpm")).TransportStatusError);
$parcel$export(module.exports, "StatusCodes", () => (parcelRequire("degpm")).StatusCodes);

var $7etJZ = parcelRequire("7etJZ");

var $degpm = parcelRequire("degpm");

var $6ZWSX = parcelRequire("6ZWSX");
var $375818ecee1623c3$require$Buffer = $6ZWSX.Buffer;
var $375818ecee1623c3$var$__awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $375818ecee1623c3$var$__generator = undefined && undefined.__generator || function(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};
var $375818ecee1623c3$var$__read = undefined && undefined.__read || function(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
};
var $375818ecee1623c3$var$__spreadArray = undefined && undefined.__spreadArray || function(to, from, pack) {
    if (pack || arguments.length === 2) {
        for(var i = 0, l = from.length, ar; i < l; i++)if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var $375818ecee1623c3$var$__values = undefined && undefined.__values || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
/**
 * Transport defines the generic interface to share between node/u2f impl
 * A **Descriptor** is a parametric type that is up to be determined for the implementation.
 * it can be for instance an ID, an file path, a URL,...
 */ var $375818ecee1623c3$var$Transport = /** @class */ function() {
    function Transport() {
        var _this = this;
        this.exchangeTimeout = 30000;
        this.unresponsiveTimeout = 15000;
        this.deviceModel = null;
        this._events = new (0, (/*@__PURE__*/$parcel$interopDefault($7etJZ)))();
        /**
         * wrapper on top of exchange to simplify work of the implementation.
         * @param cla
         * @param ins
         * @param p1
         * @param p2
         * @param data
         * @param statusList is a list of accepted status code (shorts). [0x9000] by default
         * @return a Promise of response buffer
         */ this.send = function(cla, ins, p1, p2, data, statusList) {
            if (data === void 0) data = $375818ecee1623c3$require$Buffer.alloc(0);
            if (statusList === void 0) statusList = [
                (0, $degpm.StatusCodes).OK
            ];
            return $375818ecee1623c3$var$__awaiter(_this, void 0, void 0, function() {
                var response, sw;
                return $375818ecee1623c3$var$__generator(this, function(_a) {
                    switch(_a.label){
                        case 0:
                            if (data.length >= 256) throw new (0, $degpm.TransportError)("data.length exceed 256 bytes limit. Got: " + data.length, "DataLengthTooBig");
                            return [
                                4 /*yield*/ ,
                                this.exchange($375818ecee1623c3$require$Buffer.concat([
                                    $375818ecee1623c3$require$Buffer.from([
                                        cla,
                                        ins,
                                        p1,
                                        p2
                                    ]),
                                    $375818ecee1623c3$require$Buffer.from([
                                        data.length
                                    ]),
                                    data
                                ]))
                            ];
                        case 1:
                            response = _a.sent();
                            sw = response.readUInt16BE(response.length - 2);
                            if (!statusList.some(function(s) {
                                return s === sw;
                            })) throw new (0, $degpm.TransportStatusError)(sw);
                            return [
                                2 /*return*/ ,
                                response
                            ];
                    }
                });
            });
        };
        this.exchangeAtomicImpl = function(f) {
            return $375818ecee1623c3$var$__awaiter(_this, void 0, void 0, function() {
                var resolveBusy, busyPromise, unresponsiveReached, timeout, res;
                var _this = this;
                return $375818ecee1623c3$var$__generator(this, function(_a) {
                    switch(_a.label){
                        case 0:
                            if (this.exchangeBusyPromise) throw new (0, $degpm.TransportRaceCondition)("An action was already pending on the Ledger device. Please deny or reconnect.");
                            busyPromise = new Promise(function(r) {
                                resolveBusy = r;
                            });
                            this.exchangeBusyPromise = busyPromise;
                            unresponsiveReached = false;
                            timeout = setTimeout(function() {
                                unresponsiveReached = true;
                                _this.emit("unresponsive");
                            }, this.unresponsiveTimeout);
                            _a.label = 1;
                        case 1:
                            _a.trys.push([
                                1,
                                ,
                                3,
                                4
                            ]);
                            return [
                                4 /*yield*/ ,
                                f()
                            ];
                        case 2:
                            res = _a.sent();
                            if (unresponsiveReached) this.emit("responsive");
                            return [
                                2 /*return*/ ,
                                res
                            ];
                        case 3:
                            clearTimeout(timeout);
                            if (resolveBusy) resolveBusy();
                            this.exchangeBusyPromise = null;
                            return [
                                7 /*endfinally*/ 
                            ];
                        case 4:
                            return [
                                2 /*return*/ 
                            ];
                    }
                });
            });
        };
        this._appAPIlock = null;
    }
    /**
     * low level api to communicate with the device
     * This method is for implementations to implement but should not be directly called.
     * Instead, the recommanded way is to use send() method
     * @param apdu the data to send
     * @return a Promise of response data
     */ Transport.prototype.exchange = function(_apdu) {
        throw new Error("exchange not implemented");
    };
    /**
     * set the "scramble key" for the next exchanges with the device.
     * Each App can have a different scramble key and they internally will set it at instanciation.
     * @param key the scramble key
     */ Transport.prototype.setScrambleKey = function(_key) {};
    /**
     * close the exchange with the device.
     * @return a Promise that ends when the transport is closed.
     */ Transport.prototype.close = function() {
        return Promise.resolve();
    };
    /**
     * Listen to an event on an instance of transport.
     * Transport implementation can have specific events. Here is the common events:
     * * `"disconnect"` : triggered if Transport is disconnected
     */ Transport.prototype.on = function(eventName, cb) {
        this._events.on(eventName, cb);
    };
    /**
     * Stop listening to an event on an instance of transport.
     */ Transport.prototype.off = function(eventName, cb) {
        this._events.removeListener(eventName, cb);
    };
    Transport.prototype.emit = function(event) {
        var _a;
        var args = [];
        for(var _i = 1; _i < arguments.length; _i++)args[_i - 1] = arguments[_i];
        (_a = this._events).emit.apply(_a, $375818ecee1623c3$var$__spreadArray([
            event
        ], $375818ecee1623c3$var$__read(args), false));
    };
    /**
     * Enable or not logs of the binary exchange
     */ Transport.prototype.setDebugMode = function() {
        console.warn("setDebugMode is deprecated. use @ledgerhq/logs instead. No logs are emitted in this anymore.");
    };
    /**
     * Set a timeout (in milliseconds) for the exchange call. Only some transport might implement it. (e.g. U2F)
     */ Transport.prototype.setExchangeTimeout = function(exchangeTimeout) {
        this.exchangeTimeout = exchangeTimeout;
    };
    /**
     * Define the delay before emitting "unresponsive" on an exchange that does not respond
     */ Transport.prototype.setExchangeUnresponsiveTimeout = function(unresponsiveTimeout) {
        this.unresponsiveTimeout = unresponsiveTimeout;
    };
    /**
     * create() allows to open the first descriptor available or
     * throw if there is none or if timeout is reached.
     * This is a light helper, alternative to using listen() and open() (that you may need for any more advanced usecase)
     * @example
    TransportFoo.create().then(transport => ...)
     */ Transport.create = function(openTimeout, listenTimeout) {
        var _this = this;
        if (openTimeout === void 0) openTimeout = 3000;
        return new Promise(function(resolve, reject) {
            var found = false;
            var sub = _this.listen({
                next: function(e) {
                    found = true;
                    if (sub) sub.unsubscribe();
                    if (listenTimeoutId) clearTimeout(listenTimeoutId);
                    _this.open(e.descriptor, openTimeout).then(resolve, reject);
                },
                error: function(e) {
                    if (listenTimeoutId) clearTimeout(listenTimeoutId);
                    reject(e);
                },
                complete: function() {
                    if (listenTimeoutId) clearTimeout(listenTimeoutId);
                    if (!found) reject(new (0, $degpm.TransportError)(_this.ErrorMessage_NoDeviceFound, "NoDeviceFound"));
                }
            });
            var listenTimeoutId = listenTimeout ? setTimeout(function() {
                sub.unsubscribe();
                reject(new (0, $degpm.TransportError)(_this.ErrorMessage_ListenTimeout, "ListenTimeout"));
            }, listenTimeout) : null;
        });
    };
    Transport.prototype.decorateAppAPIMethods = function(self, methods, scrambleKey) {
        var e_1, _a;
        try {
            for(var methods_1 = $375818ecee1623c3$var$__values(methods), methods_1_1 = methods_1.next(); !methods_1_1.done; methods_1_1 = methods_1.next()){
                var methodName = methods_1_1.value;
                self[methodName] = this.decorateAppAPIMethod(methodName, self[methodName], self, scrambleKey);
            }
        } catch (e_1_1) {
            e_1 = {
                error: e_1_1
            };
        } finally{
            try {
                if (methods_1_1 && !methods_1_1.done && (_a = methods_1["return"])) _a.call(methods_1);
            } finally{
                if (e_1) throw e_1.error;
            }
        }
    };
    Transport.prototype.decorateAppAPIMethod = function(methodName, f, ctx, scrambleKey) {
        var _this = this;
        return function() {
            var args = [];
            for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
            return $375818ecee1623c3$var$__awaiter(_this, void 0, void 0, function() {
                var _appAPIlock;
                return $375818ecee1623c3$var$__generator(this, function(_a) {
                    switch(_a.label){
                        case 0:
                            _appAPIlock = this._appAPIlock;
                            if (_appAPIlock) return [
                                2 /*return*/ ,
                                Promise.reject(new (0, $degpm.TransportError)("Ledger Device is busy (lock " + _appAPIlock + ")", "TransportLocked"))
                            ];
                            _a.label = 1;
                        case 1:
                            _a.trys.push([
                                1,
                                ,
                                3,
                                4
                            ]);
                            this._appAPIlock = methodName;
                            this.setScrambleKey(scrambleKey);
                            return [
                                4 /*yield*/ ,
                                f.apply(ctx, args)
                            ];
                        case 2:
                            return [
                                2 /*return*/ ,
                                _a.sent()
                            ];
                        case 3:
                            this._appAPIlock = null;
                            return [
                                7 /*endfinally*/ 
                            ];
                        case 4:
                            return [
                                2 /*return*/ 
                            ];
                    }
                });
            });
        };
    };
    Transport.ErrorMessage_ListenTimeout = "No Ledger device found (timeout)";
    Transport.ErrorMessage_NoDeviceFound = "No Ledger device found";
    return Transport;
}();
var $375818ecee1623c3$export$2e2bcd8739ae039 = $375818ecee1623c3$var$Transport;

});
parcelRegister("7etJZ", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
"use strict";
var $5440e9199a418654$var$R = typeof Reflect === "object" ? Reflect : null;
var $5440e9199a418654$var$ReflectApply = $5440e9199a418654$var$R && typeof $5440e9199a418654$var$R.apply === "function" ? $5440e9199a418654$var$R.apply : function ReflectApply(target, receiver, args) {
    return Function.prototype.apply.call(target, receiver, args);
};
var $5440e9199a418654$var$ReflectOwnKeys;
if ($5440e9199a418654$var$R && typeof $5440e9199a418654$var$R.ownKeys === "function") $5440e9199a418654$var$ReflectOwnKeys = $5440e9199a418654$var$R.ownKeys;
else if (Object.getOwnPropertySymbols) $5440e9199a418654$var$ReflectOwnKeys = function ReflectOwnKeys(target) {
    return Object.getOwnPropertyNames(target).concat(Object.getOwnPropertySymbols(target));
};
else $5440e9199a418654$var$ReflectOwnKeys = function ReflectOwnKeys(target) {
    return Object.getOwnPropertyNames(target);
};
function $5440e9199a418654$var$ProcessEmitWarning(warning) {
    if (console && console.warn) console.warn(warning);
}
var $5440e9199a418654$var$NumberIsNaN = Number.isNaN || function NumberIsNaN(value) {
    return value !== value;
};
function $5440e9199a418654$var$EventEmitter() {
    $5440e9199a418654$var$EventEmitter.init.call(this);
}
module.exports = $5440e9199a418654$var$EventEmitter;
module.exports.once = $5440e9199a418654$var$once;
// Backwards-compat with node 0.10.x
$5440e9199a418654$var$EventEmitter.EventEmitter = $5440e9199a418654$var$EventEmitter;
$5440e9199a418654$var$EventEmitter.prototype._events = undefined;
$5440e9199a418654$var$EventEmitter.prototype._eventsCount = 0;
$5440e9199a418654$var$EventEmitter.prototype._maxListeners = undefined;
// By default EventEmitters will print a warning if more than 10 listeners are
// added to it. This is a useful default which helps finding memory leaks.
var $5440e9199a418654$var$defaultMaxListeners = 10;
function $5440e9199a418654$var$checkListener(listener) {
    if (typeof listener !== "function") throw new TypeError('The "listener" argument must be of type Function. Received type ' + typeof listener);
}
Object.defineProperty($5440e9199a418654$var$EventEmitter, "defaultMaxListeners", {
    enumerable: true,
    get: function() {
        return $5440e9199a418654$var$defaultMaxListeners;
    },
    set: function(arg) {
        if (typeof arg !== "number" || arg < 0 || $5440e9199a418654$var$NumberIsNaN(arg)) throw new RangeError('The value of "defaultMaxListeners" is out of range. It must be a non-negative number. Received ' + arg + ".");
        $5440e9199a418654$var$defaultMaxListeners = arg;
    }
});
$5440e9199a418654$var$EventEmitter.init = function() {
    if (this._events === undefined || this._events === Object.getPrototypeOf(this)._events) {
        this._events = Object.create(null);
        this._eventsCount = 0;
    }
    this._maxListeners = this._maxListeners || undefined;
};
// Obviously not all Emitters should be limited to 10. This function allows
// that to be increased. Set to zero for unlimited.
$5440e9199a418654$var$EventEmitter.prototype.setMaxListeners = function setMaxListeners(n) {
    if (typeof n !== "number" || n < 0 || $5440e9199a418654$var$NumberIsNaN(n)) throw new RangeError('The value of "n" is out of range. It must be a non-negative number. Received ' + n + ".");
    this._maxListeners = n;
    return this;
};
function $5440e9199a418654$var$_getMaxListeners(that) {
    if (that._maxListeners === undefined) return $5440e9199a418654$var$EventEmitter.defaultMaxListeners;
    return that._maxListeners;
}
$5440e9199a418654$var$EventEmitter.prototype.getMaxListeners = function getMaxListeners() {
    return $5440e9199a418654$var$_getMaxListeners(this);
};
$5440e9199a418654$var$EventEmitter.prototype.emit = function emit(type) {
    var args = [];
    for(var i = 1; i < arguments.length; i++)args.push(arguments[i]);
    var doError = type === "error";
    var events = this._events;
    if (events !== undefined) doError = doError && events.error === undefined;
    else if (!doError) return false;
    // If there is no 'error' event listener then throw.
    if (doError) {
        var er;
        if (args.length > 0) er = args[0];
        if (er instanceof Error) // Note: The comments on the `throw` lines are intentional, they show
        // up in Node's output if this results in an unhandled exception.
        throw er; // Unhandled 'error' event
        // At least give some kind of context to the user
        var err = new Error("Unhandled error." + (er ? " (" + er.message + ")" : ""));
        err.context = er;
        throw err; // Unhandled 'error' event
    }
    var handler = events[type];
    if (handler === undefined) return false;
    if (typeof handler === "function") $5440e9199a418654$var$ReflectApply(handler, this, args);
    else {
        var len = handler.length;
        var listeners = $5440e9199a418654$var$arrayClone(handler, len);
        for(var i = 0; i < len; ++i)$5440e9199a418654$var$ReflectApply(listeners[i], this, args);
    }
    return true;
};
function $5440e9199a418654$var$_addListener(target, type, listener, prepend) {
    var m;
    var events;
    var existing;
    $5440e9199a418654$var$checkListener(listener);
    events = target._events;
    if (events === undefined) {
        events = target._events = Object.create(null);
        target._eventsCount = 0;
    } else {
        // To avoid recursion in the case that type === "newListener"! Before
        // adding it to the listeners, first emit "newListener".
        if (events.newListener !== undefined) {
            target.emit("newListener", type, listener.listener ? listener.listener : listener);
            // Re-assign `events` because a newListener handler could have caused the
            // this._events to be assigned to a new object
            events = target._events;
        }
        existing = events[type];
    }
    if (existing === undefined) {
        // Optimize the case of one listener. Don't need the extra array object.
        existing = events[type] = listener;
        ++target._eventsCount;
    } else {
        if (typeof existing === "function") // Adding the second element, need to change to array.
        existing = events[type] = prepend ? [
            listener,
            existing
        ] : [
            existing,
            listener
        ];
        else if (prepend) existing.unshift(listener);
        else existing.push(listener);
        // Check for listener leak
        m = $5440e9199a418654$var$_getMaxListeners(target);
        if (m > 0 && existing.length > m && !existing.warned) {
            existing.warned = true;
            // No error code for this since it is a Warning
            // eslint-disable-next-line no-restricted-syntax
            var w = new Error("Possible EventEmitter memory leak detected. " + existing.length + " " + String(type) + " listeners " + "added. Use emitter.setMaxListeners() to " + "increase limit");
            w.name = "MaxListenersExceededWarning";
            w.emitter = target;
            w.type = type;
            w.count = existing.length;
            $5440e9199a418654$var$ProcessEmitWarning(w);
        }
    }
    return target;
}
$5440e9199a418654$var$EventEmitter.prototype.addListener = function addListener(type, listener) {
    return $5440e9199a418654$var$_addListener(this, type, listener, false);
};
$5440e9199a418654$var$EventEmitter.prototype.on = $5440e9199a418654$var$EventEmitter.prototype.addListener;
$5440e9199a418654$var$EventEmitter.prototype.prependListener = function prependListener(type, listener) {
    return $5440e9199a418654$var$_addListener(this, type, listener, true);
};
function $5440e9199a418654$var$onceWrapper() {
    if (!this.fired) {
        this.target.removeListener(this.type, this.wrapFn);
        this.fired = true;
        if (arguments.length === 0) return this.listener.call(this.target);
        return this.listener.apply(this.target, arguments);
    }
}
function $5440e9199a418654$var$_onceWrap(target, type, listener) {
    var state = {
        fired: false,
        wrapFn: undefined,
        target: target,
        type: type,
        listener: listener
    };
    var wrapped = $5440e9199a418654$var$onceWrapper.bind(state);
    wrapped.listener = listener;
    state.wrapFn = wrapped;
    return wrapped;
}
$5440e9199a418654$var$EventEmitter.prototype.once = function once(type, listener) {
    $5440e9199a418654$var$checkListener(listener);
    this.on(type, $5440e9199a418654$var$_onceWrap(this, type, listener));
    return this;
};
$5440e9199a418654$var$EventEmitter.prototype.prependOnceListener = function prependOnceListener(type, listener) {
    $5440e9199a418654$var$checkListener(listener);
    this.prependListener(type, $5440e9199a418654$var$_onceWrap(this, type, listener));
    return this;
};
// Emits a 'removeListener' event if and only if the listener was removed.
$5440e9199a418654$var$EventEmitter.prototype.removeListener = function removeListener(type, listener) {
    var list, events, position, i, originalListener;
    $5440e9199a418654$var$checkListener(listener);
    events = this._events;
    if (events === undefined) return this;
    list = events[type];
    if (list === undefined) return this;
    if (list === listener || list.listener === listener) {
        if (--this._eventsCount === 0) this._events = Object.create(null);
        else {
            delete events[type];
            if (events.removeListener) this.emit("removeListener", type, list.listener || listener);
        }
    } else if (typeof list !== "function") {
        position = -1;
        for(i = list.length - 1; i >= 0; i--)if (list[i] === listener || list[i].listener === listener) {
            originalListener = list[i].listener;
            position = i;
            break;
        }
        if (position < 0) return this;
        if (position === 0) list.shift();
        else $5440e9199a418654$var$spliceOne(list, position);
        if (list.length === 1) events[type] = list[0];
        if (events.removeListener !== undefined) this.emit("removeListener", type, originalListener || listener);
    }
    return this;
};
$5440e9199a418654$var$EventEmitter.prototype.off = $5440e9199a418654$var$EventEmitter.prototype.removeListener;
$5440e9199a418654$var$EventEmitter.prototype.removeAllListeners = function removeAllListeners(type) {
    var listeners, events, i;
    events = this._events;
    if (events === undefined) return this;
    // not listening for removeListener, no need to emit
    if (events.removeListener === undefined) {
        if (arguments.length === 0) {
            this._events = Object.create(null);
            this._eventsCount = 0;
        } else if (events[type] !== undefined) {
            if (--this._eventsCount === 0) this._events = Object.create(null);
            else delete events[type];
        }
        return this;
    }
    // emit removeListener for all listeners on all events
    if (arguments.length === 0) {
        var keys = Object.keys(events);
        var key;
        for(i = 0; i < keys.length; ++i){
            key = keys[i];
            if (key === "removeListener") continue;
            this.removeAllListeners(key);
        }
        this.removeAllListeners("removeListener");
        this._events = Object.create(null);
        this._eventsCount = 0;
        return this;
    }
    listeners = events[type];
    if (typeof listeners === "function") this.removeListener(type, listeners);
    else if (listeners !== undefined) // LIFO order
    for(i = listeners.length - 1; i >= 0; i--)this.removeListener(type, listeners[i]);
    return this;
};
function $5440e9199a418654$var$_listeners(target, type, unwrap) {
    var events = target._events;
    if (events === undefined) return [];
    var evlistener = events[type];
    if (evlistener === undefined) return [];
    if (typeof evlistener === "function") return unwrap ? [
        evlistener.listener || evlistener
    ] : [
        evlistener
    ];
    return unwrap ? $5440e9199a418654$var$unwrapListeners(evlistener) : $5440e9199a418654$var$arrayClone(evlistener, evlistener.length);
}
$5440e9199a418654$var$EventEmitter.prototype.listeners = function listeners(type) {
    return $5440e9199a418654$var$_listeners(this, type, true);
};
$5440e9199a418654$var$EventEmitter.prototype.rawListeners = function rawListeners(type) {
    return $5440e9199a418654$var$_listeners(this, type, false);
};
$5440e9199a418654$var$EventEmitter.listenerCount = function(emitter, type) {
    if (typeof emitter.listenerCount === "function") return emitter.listenerCount(type);
    else return $5440e9199a418654$var$listenerCount.call(emitter, type);
};
$5440e9199a418654$var$EventEmitter.prototype.listenerCount = $5440e9199a418654$var$listenerCount;
function $5440e9199a418654$var$listenerCount(type) {
    var events = this._events;
    if (events !== undefined) {
        var evlistener = events[type];
        if (typeof evlistener === "function") return 1;
        else if (evlistener !== undefined) return evlistener.length;
    }
    return 0;
}
$5440e9199a418654$var$EventEmitter.prototype.eventNames = function eventNames() {
    return this._eventsCount > 0 ? $5440e9199a418654$var$ReflectOwnKeys(this._events) : [];
};
function $5440e9199a418654$var$arrayClone(arr, n) {
    var copy = new Array(n);
    for(var i = 0; i < n; ++i)copy[i] = arr[i];
    return copy;
}
function $5440e9199a418654$var$spliceOne(list, index) {
    for(; index + 1 < list.length; index++)list[index] = list[index + 1];
    list.pop();
}
function $5440e9199a418654$var$unwrapListeners(arr) {
    var ret = new Array(arr.length);
    for(var i = 0; i < ret.length; ++i)ret[i] = arr[i].listener || arr[i];
    return ret;
}
function $5440e9199a418654$var$once(emitter, name) {
    return new Promise(function(resolve, reject) {
        function errorListener(err) {
            emitter.removeListener(name, resolver);
            reject(err);
        }
        function resolver() {
            if (typeof emitter.removeListener === "function") emitter.removeListener("error", errorListener);
            resolve([].slice.call(arguments));
        }
        $5440e9199a418654$var$eventTargetAgnosticAddListener(emitter, name, resolver, {
            once: true
        });
        if (name !== "error") $5440e9199a418654$var$addErrorHandlerIfEventEmitter(emitter, errorListener, {
            once: true
        });
    });
}
function $5440e9199a418654$var$addErrorHandlerIfEventEmitter(emitter, handler, flags) {
    if (typeof emitter.on === "function") $5440e9199a418654$var$eventTargetAgnosticAddListener(emitter, "error", handler, flags);
}
function $5440e9199a418654$var$eventTargetAgnosticAddListener(emitter, name, listener, flags) {
    if (typeof emitter.on === "function") {
        if (flags.once) emitter.once(name, listener);
        else emitter.on(name, listener);
    } else if (typeof emitter.addEventListener === "function") // EventTarget does not have `error` event semantics like Node
    // EventEmitters, we do not listen for `error` events here.
    emitter.addEventListener(name, function wrapListener(arg) {
        // IE does not have builtin `{ once: true }` support so we
        // have to do it manually.
        if (flags.once) emitter.removeEventListener(name, wrapListener);
        listener(arg);
    });
    else throw new TypeError('The "emitter" argument must be of type EventEmitter. Received type ' + typeof emitter);
}

});

parcelRegister("degpm", function(module, exports) {

$parcel$export(module.exports, "DisconnectedDevice", () => $9a194f74559621d2$export$1e42f3936938e063);
$parcel$export(module.exports, "DisconnectedDeviceDuringOperation", () => $9a194f74559621d2$export$2a60f41a2ed2742);
$parcel$export(module.exports, "TransportOpenUserCancelled", () => $9a194f74559621d2$export$9642f061c2494239);
$parcel$export(module.exports, "TransportRaceCondition", () => $9a194f74559621d2$export$d6cb63cda2c2b2a4);
$parcel$export(module.exports, "TransportError", () => $9a194f74559621d2$export$8e68de6fb26f2236);
$parcel$export(module.exports, "StatusCodes", () => $9a194f74559621d2$export$efd5569f873811b1);
$parcel$export(module.exports, "TransportStatusError", () => $9a194f74559621d2$export$78917f4716d96cfe);

var $6Sb0P = parcelRequire("6Sb0P");
const $9a194f74559621d2$export$d7dd32b41fc9c3a0 = (0, $6Sb0P.createCustomErrorClass)("AccountNameRequired");
const $9a194f74559621d2$export$fb9db505804530ec = (0, $6Sb0P.createCustomErrorClass)("AccountNotSupported");
const $9a194f74559621d2$export$c9d6bf2b06944665 = (0, $6Sb0P.createCustomErrorClass)("AmountRequired");
const $9a194f74559621d2$export$2628fce2396c23c2 = (0, $6Sb0P.createCustomErrorClass)("BluetoothRequired");
const $9a194f74559621d2$export$75f8b0767ef406f1 = (0, $6Sb0P.createCustomErrorClass)("BtcUnmatchedApp");
const $9a194f74559621d2$export$f60aa84fd00bc3ee = (0, $6Sb0P.createCustomErrorClass)("CantOpenDevice");
const $9a194f74559621d2$export$fc0260506e4022ab = (0, $6Sb0P.createCustomErrorClass)("CashAddrNotSupported");
const $9a194f74559621d2$export$1e9e90415b859c28 = (0, $6Sb0P.createCustomErrorClass)("ClaimRewardsFeesWarning");
const $9a194f74559621d2$export$e0b1ec53ba36e221 = (0, $6Sb0P.createCustomErrorClass)("CurrencyNotSupported");
const $9a194f74559621d2$export$fa9aacd48d3a45c2 = (0, $6Sb0P.createCustomErrorClass)("DeviceAppVerifyNotSupported");
const $9a194f74559621d2$export$f21ce806524ab8d4 = (0, $6Sb0P.createCustomErrorClass)("DeviceGenuineSocketEarlyClose");
const $9a194f74559621d2$export$9c30dc6872fcd74c = (0, $6Sb0P.createCustomErrorClass)("DeviceNotGenuine");
const $9a194f74559621d2$export$1d5ae41b109edf1f = (0, $6Sb0P.createCustomErrorClass)("DeviceOnDashboardExpected");
const $9a194f74559621d2$export$8eecf64ec9a8cfd7 = (0, $6Sb0P.createCustomErrorClass)("DeviceOnDashboardUnexpected");
const $9a194f74559621d2$export$a5e2071f1ac48fdd = (0, $6Sb0P.createCustomErrorClass)("DeviceInOSUExpected");
const $9a194f74559621d2$export$3be6e7231165f4ac = (0, $6Sb0P.createCustomErrorClass)("DeviceHalted");
const $9a194f74559621d2$export$fa7bfae6dce03474 = (0, $6Sb0P.createCustomErrorClass)("DeviceNameInvalid");
const $9a194f74559621d2$export$bcce4e5aded80ca0 = (0, $6Sb0P.createCustomErrorClass)("DeviceSocketFail");
const $9a194f74559621d2$export$944a0f9a7cc1e03a = (0, $6Sb0P.createCustomErrorClass)("DeviceSocketNoBulkStatus");
const $9a194f74559621d2$export$1fb6667702a70644 = (0, $6Sb0P.createCustomErrorClass)("LockedDeviceError");
const $9a194f74559621d2$export$5f6bf7cdd5818529 = (0, $6Sb0P.createCustomErrorClass)("UnresponsiveDeviceError");
const $9a194f74559621d2$export$1e42f3936938e063 = (0, $6Sb0P.createCustomErrorClass)("DisconnectedDevice");
const $9a194f74559621d2$export$2a60f41a2ed2742 = (0, $6Sb0P.createCustomErrorClass)("DisconnectedDeviceDuringOperation");
const $9a194f74559621d2$export$93e2040d8e24d646 = (0, $6Sb0P.createCustomErrorClass)("DeviceExtractOnboardingStateError");
const $9a194f74559621d2$export$e6aaf90bcb4b2013 = (0, $6Sb0P.createCustomErrorClass)("DeviceOnboardingStatePollingError");
const $9a194f74559621d2$export$cfbd0adf8f9fdaf9 = (0, $6Sb0P.createCustomErrorClass)("EnpointConfig");
const $9a194f74559621d2$export$96d8d3c501f1625 = (0, $6Sb0P.createCustomErrorClass)("EthAppPleaseEnableContractData");
const $9a194f74559621d2$export$37b49553b7172cb1 = (0, $6Sb0P.createCustomErrorClass)("FeeEstimationFailed");
const $9a194f74559621d2$export$d00fd6c398a70fd9 = (0, $6Sb0P.createCustomErrorClass)("FirmwareNotRecognized");
const $9a194f74559621d2$export$3dc3bbf8c134219c = (0, $6Sb0P.createCustomErrorClass)("HardResetFail");
const $9a194f74559621d2$export$5e8f7ae1054a2777 = (0, $6Sb0P.createCustomErrorClass)("InvalidXRPTag");
const $9a194f74559621d2$export$953b602d2269ceba = (0, $6Sb0P.createCustomErrorClass)("InvalidAddress");
const $9a194f74559621d2$export$61e75f453df94067 = (0, $6Sb0P.createCustomErrorClass)("InvalidNonce");
const $9a194f74559621d2$export$bbdaf7c77a7508eb = (0, $6Sb0P.createCustomErrorClass)("InvalidAddressBecauseDestinationIsAlsoSource");
const $9a194f74559621d2$export$882967e2980534f9 = (0, $6Sb0P.createCustomErrorClass)("LatestMCUInstalledError");
const $9a194f74559621d2$export$59772a13ac97df0e = (0, $6Sb0P.createCustomErrorClass)("UnknownMCU");
const $9a194f74559621d2$export$26bf4f7c63d50901 = (0, $6Sb0P.createCustomErrorClass)("LedgerAPIError");
const $9a194f74559621d2$export$fdab6afd1b1820af = (0, $6Sb0P.createCustomErrorClass)("LedgerAPIErrorWithMessage");
const $9a194f74559621d2$export$c2996b38942cf758 = (0, $6Sb0P.createCustomErrorClass)("LedgerAPINotAvailable");
const $9a194f74559621d2$export$3d81abcc61613a27 = (0, $6Sb0P.createCustomErrorClass)("ManagerAppAlreadyInstalled");
const $9a194f74559621d2$export$87a9bff9fff141e2 = (0, $6Sb0P.createCustomErrorClass)("ManagerAppRelyOnBTC");
const $9a194f74559621d2$export$86581a722c4238c0 = (0, $6Sb0P.createCustomErrorClass)("ManagerAppDepInstallRequired");
const $9a194f74559621d2$export$267a8476044885dd = (0, $6Sb0P.createCustomErrorClass)("ManagerAppDepUninstallRequired");
const $9a194f74559621d2$export$bb771ca417eca344 = (0, $6Sb0P.createCustomErrorClass)("ManagerDeviceLocked");
const $9a194f74559621d2$export$b634ce25e3ff5229 = (0, $6Sb0P.createCustomErrorClass)("ManagerFirmwareNotEnoughSpace");
const $9a194f74559621d2$export$2d26f4eadfe37285 = (0, $6Sb0P.createCustomErrorClass)("ManagerNotEnoughSpace");
const $9a194f74559621d2$export$ceb7f9bef5a1e481 = (0, $6Sb0P.createCustomErrorClass)("ManagerUninstallBTCDep");
const $9a194f74559621d2$export$baadb6886fde1621 = (0, $6Sb0P.createCustomErrorClass)("NetworkDown");
const $9a194f74559621d2$export$bae979e68e4dc802 = (0, $6Sb0P.createCustomErrorClass)("NetworkError");
const $9a194f74559621d2$export$5cbfa0659f97216a = (0, $6Sb0P.createCustomErrorClass)("NoAddressesFound");
const $9a194f74559621d2$export$9e00aead3515e5c9 = (0, $6Sb0P.createCustomErrorClass)("NotEnoughBalance");
const $9a194f74559621d2$export$5ed90e0e011f4857 = (0, $6Sb0P.createCustomErrorClass)("NotEnoughBalanceToDelegate");
const $9a194f74559621d2$export$75178c95e66d9630 = (0, $6Sb0P.createCustomErrorClass)("NotEnoughBalanceInParentAccount");
const $9a194f74559621d2$export$e3e2865b29f7e0b0 = (0, $6Sb0P.createCustomErrorClass)("NotEnoughSpendableBalance");
const $9a194f74559621d2$export$a84b3634866707ea = (0, $6Sb0P.createCustomErrorClass)("NotEnoughBalanceBecauseDestinationNotCreated");
const $9a194f74559621d2$export$a282f858b69a7326 = (0, $6Sb0P.createCustomErrorClass)("NoAccessToCamera");
const $9a194f74559621d2$export$5111c405c5cacc97 = (0, $6Sb0P.createCustomErrorClass)("NotEnoughGas");
const $9a194f74559621d2$export$1cb5c4489aaca4d6 = (0, $6Sb0P.createCustomErrorClass)("NotEnoughGasSwap");
const $9a194f74559621d2$export$626e1fd20d22139c = (0, $6Sb0P.createCustomErrorClass)("NotSupportedLegacyAddress");
const $9a194f74559621d2$export$f919e2c9c746346b = (0, $6Sb0P.createCustomErrorClass)("GasLessThanEstimate");
const $9a194f74559621d2$export$cc562f3706902d22 = (0, $6Sb0P.createCustomErrorClass)("PriorityFeeTooLow");
const $9a194f74559621d2$export$ee14d05cd43eb762 = (0, $6Sb0P.createCustomErrorClass)("PriorityFeeTooHigh");
const $9a194f74559621d2$export$931458f4b7d53154 = (0, $6Sb0P.createCustomErrorClass)("PriorityFeeHigherThanMaxFee");
const $9a194f74559621d2$export$c0ce9cadb94c6b86 = (0, $6Sb0P.createCustomErrorClass)("MaxFeeTooLow");
const $9a194f74559621d2$export$22c5aa8937c5b423 = (0, $6Sb0P.createCustomErrorClass)("PasswordsDontMatch");
const $9a194f74559621d2$export$f57670cd1aaf386 = (0, $6Sb0P.createCustomErrorClass)("PasswordIncorrect");
const $9a194f74559621d2$export$3ba22bf10deb1448 = (0, $6Sb0P.createCustomErrorClass)("RecommendSubAccountsToEmpty");
const $9a194f74559621d2$export$33f73085e1b7871b = (0, $6Sb0P.createCustomErrorClass)("RecommendUndelegation");
const $9a194f74559621d2$export$cd4d967a66d81060 = (0, $6Sb0P.createCustomErrorClass)("TimeoutTagged");
const $9a194f74559621d2$export$9375635756d6156e = (0, $6Sb0P.createCustomErrorClass)("UnexpectedBootloader");
const $9a194f74559621d2$export$90478a5d08d6c2d7 = (0, $6Sb0P.createCustomErrorClass)("MCUNotGenuineToDashboard");
const $9a194f74559621d2$export$132f0197eaa65535 = (0, $6Sb0P.createCustomErrorClass)("RecipientRequired");
const $9a194f74559621d2$export$7aee729193ab77ba = (0, $6Sb0P.createCustomErrorClass)("UnavailableTezosOriginatedAccountReceive");
const $9a194f74559621d2$export$4ec11dc947a3c9d6 = (0, $6Sb0P.createCustomErrorClass)("UnavailableTezosOriginatedAccountSend");
const $9a194f74559621d2$export$5e3ed85b946872a1 = (0, $6Sb0P.createCustomErrorClass)("UpdateFetchFileFail");
const $9a194f74559621d2$export$5db6383ad081f01e = (0, $6Sb0P.createCustomErrorClass)("UpdateIncorrectHash");
const $9a194f74559621d2$export$92c199eb837d8df8 = (0, $6Sb0P.createCustomErrorClass)("UpdateIncorrectSig");
const $9a194f74559621d2$export$85e0c017833c894c = (0, $6Sb0P.createCustomErrorClass)("UpdateYourApp");
const $9a194f74559621d2$export$84115f1b54c874b3 = (0, $6Sb0P.createCustomErrorClass)("UserRefusedDeviceNameChange");
const $9a194f74559621d2$export$3f4864efb1638333 = (0, $6Sb0P.createCustomErrorClass)("UserRefusedAddress");
const $9a194f74559621d2$export$d777e0ef77faca34 = (0, $6Sb0P.createCustomErrorClass)("UserRefusedFirmwareUpdate");
const $9a194f74559621d2$export$3d8a4f08cd3eb133 = (0, $6Sb0P.createCustomErrorClass)("UserRefusedAllowManager");
const $9a194f74559621d2$export$db9b724c3524b5d6 = (0, $6Sb0P.createCustomErrorClass)("UserRefusedOnDevice"); // TODO rename because it's just for transaction refusal
const $9a194f74559621d2$export$65df6bdf4eb29653 = (0, $6Sb0P.createCustomErrorClass)("ExpertModeRequired");
const $9a194f74559621d2$export$9642f061c2494239 = (0, $6Sb0P.createCustomErrorClass)("TransportOpenUserCancelled");
const $9a194f74559621d2$export$fd71e3a51c4bf0ae = (0, $6Sb0P.createCustomErrorClass)("TransportInterfaceNotAvailable");
const $9a194f74559621d2$export$d6cb63cda2c2b2a4 = (0, $6Sb0P.createCustomErrorClass)("TransportRaceCondition");
const $9a194f74559621d2$export$c0ffbdd94649bd06 = (0, $6Sb0P.createCustomErrorClass)("TransportWebUSBGestureRequired");
const $9a194f74559621d2$export$28149f687a2e30c9 = (0, $6Sb0P.createCustomErrorClass)("TransactionHasBeenValidatedError");
const $9a194f74559621d2$export$4800af3cc6204928 = (0, $6Sb0P.createCustomErrorClass)("DeviceShouldStayInApp");
const $9a194f74559621d2$export$101490ec073327e1 = (0, $6Sb0P.createCustomErrorClass)("WebsocketConnectionError");
const $9a194f74559621d2$export$219228963d86b069 = (0, $6Sb0P.createCustomErrorClass)("WebsocketConnectionFailed");
const $9a194f74559621d2$export$25b49ca0efdfe5d1 = (0, $6Sb0P.createCustomErrorClass)("WrongDeviceForAccount");
const $9a194f74559621d2$export$63498b46122d8a23 = (0, $6Sb0P.createCustomErrorClass)("WrongAppForCurrency");
const $9a194f74559621d2$export$707f317a4761c46d = (0, $6Sb0P.createCustomErrorClass)("ETHAddressNonEIP");
const $9a194f74559621d2$export$a5d8da2f27618c16 = (0, $6Sb0P.createCustomErrorClass)("CantScanQRCode");
const $9a194f74559621d2$export$3f2d8a7775aab6cc = (0, $6Sb0P.createCustomErrorClass)("FeeNotLoaded");
const $9a194f74559621d2$export$ffbf6641e9ab88d3 = (0, $6Sb0P.createCustomErrorClass)("FeeRequired");
const $9a194f74559621d2$export$53e797c2fa09aff3 = (0, $6Sb0P.createCustomErrorClass)("FeeTooHigh");
const $9a194f74559621d2$export$cb0b645e3d7170ab = (0, $6Sb0P.createCustomErrorClass)("PendingOperation");
const $9a194f74559621d2$export$2aca4567d80fd933 = (0, $6Sb0P.createCustomErrorClass)("SyncError");
const $9a194f74559621d2$export$a2d6658d365c43df = (0, $6Sb0P.createCustomErrorClass)("PairingFailed");
const $9a194f74559621d2$export$4400fa093e7d20ad = (0, $6Sb0P.createCustomErrorClass)("PeerRemovedPairing");
const $9a194f74559621d2$export$3f7ba18f3c84cced = (0, $6Sb0P.createCustomErrorClass)("GenuineCheckFailed");
const $9a194f74559621d2$export$437e6aac14cab3d9 = (0, $6Sb0P.createCustomErrorClass)("LedgerAPI4xx");
const $9a194f74559621d2$export$309835543e52bf92 = (0, $6Sb0P.createCustomErrorClass)("LedgerAPI5xx");
const $9a194f74559621d2$export$c282cdb2f7fdc27a = (0, $6Sb0P.createCustomErrorClass)("FirmwareOrAppUpdateRequired");
const $9a194f74559621d2$export$51a1e1b4f21df9f4 = (0, $6Sb0P.createCustomErrorClass)("OpReturnSizeLimit");
const $9a194f74559621d2$export$1d49177380419e3d = (0, $6Sb0P.createCustomErrorClass)("DustLimit");
const $9a194f74559621d2$export$28f62a162580c9c2 = (0, $6Sb0P.createCustomErrorClass)("LanguageNotFound");
const $9a194f74559621d2$export$d3cadb9f4e1fa40d = (0, $6Sb0P.createCustomErrorClass)("NoDBPathGiven");
const $9a194f74559621d2$export$de46c919e379f03f = (0, $6Sb0P.createCustomErrorClass)("DBWrongPassword");
const $9a194f74559621d2$export$e1c94c135b0a553e = (0, $6Sb0P.createCustomErrorClass)("DBNotReset");
var $9a194f74559621d2$export$62e86095f76df800;
(function(HwTransportErrorType) {
    HwTransportErrorType["Unknown"] = "Unknown";
    HwTransportErrorType["LocationServicesDisabled"] = "LocationServicesDisabled";
    HwTransportErrorType["LocationServicesUnauthorized"] = "LocationServicesUnauthorized";
    HwTransportErrorType["BluetoothScanStartFailed"] = "BluetoothScanStartFailed";
})($9a194f74559621d2$export$62e86095f76df800 || ($9a194f74559621d2$export$62e86095f76df800 = {}));
class $9a194f74559621d2$export$ef5ffbe444ecd147 extends Error {
    constructor(type, message){
        super(message);
        this.name = "HwTransportError";
        this.type = type;
        // Needed as long as we target < ES6
        Object.setPrototypeOf(this, $9a194f74559621d2$export$ef5ffbe444ecd147.prototype);
    }
}
class $9a194f74559621d2$export$8e68de6fb26f2236 extends Error {
    constructor(message, id){
        const name = "TransportError";
        super(message || name);
        this.name = name;
        this.message = message;
        this.stack = new Error(message).stack;
        this.id = id;
    }
}
(0, $6Sb0P.addCustomErrorDeserializer)("TransportError", (e)=>new $9a194f74559621d2$export$8e68de6fb26f2236(e.message, e.id));
const $9a194f74559621d2$export$efd5569f873811b1 = {
    ACCESS_CONDITION_NOT_FULFILLED: 0x9804,
    ALGORITHM_NOT_SUPPORTED: 0x9484,
    CLA_NOT_SUPPORTED: 0x6e00,
    CODE_BLOCKED: 0x9840,
    CODE_NOT_INITIALIZED: 0x9802,
    COMMAND_INCOMPATIBLE_FILE_STRUCTURE: 0x6981,
    CONDITIONS_OF_USE_NOT_SATISFIED: 0x6985,
    CONTRADICTION_INVALIDATION: 0x9810,
    CONTRADICTION_SECRET_CODE_STATUS: 0x9808,
    CUSTOM_IMAGE_BOOTLOADER: 0x662f,
    CUSTOM_IMAGE_EMPTY: 0x662e,
    FILE_ALREADY_EXISTS: 0x6a89,
    FILE_NOT_FOUND: 0x9404,
    GP_AUTH_FAILED: 0x6300,
    HALTED: 0x6faa,
    INCONSISTENT_FILE: 0x9408,
    INCORRECT_DATA: 0x6a80,
    INCORRECT_LENGTH: 0x6700,
    INCORRECT_P1_P2: 0x6b00,
    INS_NOT_SUPPORTED: 0x6d00,
    DEVICE_NOT_ONBOARDED: 0x6d07,
    DEVICE_NOT_ONBOARDED_2: 0x6611,
    INVALID_KCV: 0x9485,
    INVALID_OFFSET: 0x9402,
    LICENSING: 0x6f42,
    LOCKED_DEVICE: 0x5515,
    MAX_VALUE_REACHED: 0x9850,
    MEMORY_PROBLEM: 0x9240,
    MISSING_CRITICAL_PARAMETER: 0x6800,
    NO_EF_SELECTED: 0x9400,
    NOT_ENOUGH_MEMORY_SPACE: 0x6a84,
    OK: 0x9000,
    PIN_REMAINING_ATTEMPTS: 0x63c0,
    REFERENCED_DATA_NOT_FOUND: 0x6a88,
    SECURITY_STATUS_NOT_SATISFIED: 0x6982,
    TECHNICAL_PROBLEM: 0x6f00,
    UNKNOWN_APDU: 0x6d02,
    USER_REFUSED_ON_DEVICE: 0x5501,
    NOT_ENOUGH_SPACE: 0x5102
};
function $9a194f74559621d2$export$799566c03457ebd5(code) {
    switch(code){
        // improve text of most common errors
        case 0x6700:
            return "Incorrect length";
        case 0x6800:
            return "Missing critical parameter";
        case 0x6982:
            return "Security not satisfied (dongle locked or have invalid access rights)";
        case 0x6985:
            return "Condition of use not satisfied (denied by the user?)";
        case 0x6a80:
            return "Invalid data received";
        case 0x6b00:
            return "Invalid parameter received";
        case 0x5515:
            return "Locked device";
    }
    if (0x6f00 <= code && code <= 0x6fff) return "Internal error, please report";
}
function $9a194f74559621d2$export$78917f4716d96cfe(statusCode) {
    const statusText = Object.keys($9a194f74559621d2$export$efd5569f873811b1).find((k)=>$9a194f74559621d2$export$efd5569f873811b1[k] === statusCode) || "UNKNOWN_ERROR";
    const smsg = $9a194f74559621d2$export$799566c03457ebd5(statusCode) || statusText;
    const statusCodeStr = statusCode.toString(16);
    const message = `Ledger device: ${smsg} (0x${statusCodeStr})`;
    // Maps to a LockedDeviceError
    if (statusCode === $9a194f74559621d2$export$efd5569f873811b1.LOCKED_DEVICE) throw new $9a194f74559621d2$export$1fb6667702a70644(message);
    this.name = "TransportStatusError";
    this.message = message;
    this.stack = new Error(message).stack;
    this.statusCode = statusCode;
    this.statusText = statusText;
}
$9a194f74559621d2$export$78917f4716d96cfe.prototype = new Error();
(0, $6Sb0P.addCustomErrorDeserializer)("TransportStatusError", (e)=>new $9a194f74559621d2$export$78917f4716d96cfe(e.statusCode));

});
parcelRegister("6Sb0P", function(module, exports) {

$parcel$export(module.exports, "addCustomErrorDeserializer", () => $50105411ce29e10f$export$ff6248acd0c27a3f);
$parcel$export(module.exports, "createCustomErrorClass", () => $50105411ce29e10f$export$94baff7bf5134824);
/* eslint-disable no-continue */ /* eslint-disable no-unused-vars */ /* eslint-disable no-param-reassign */ /* eslint-disable no-prototype-builtins */ const $50105411ce29e10f$var$errorClasses = {};
const $50105411ce29e10f$var$deserializers = {};
const $50105411ce29e10f$export$ff6248acd0c27a3f = (name, deserializer)=>{
    $50105411ce29e10f$var$deserializers[name] = deserializer;
};
const $50105411ce29e10f$export$94baff7bf5134824 = (name)=>{
    class CustomErrorClass extends Error {
        constructor(message, fields, options){
            // eslint-disable-next-line @typescript-eslint/ban-ts-comment
            // @ts-ignore
            super(message || name, options);
            // Set the prototype explicitly. See https://github.com/Microsoft/TypeScript/wiki/Breaking-Changes#extending-built-ins-like-error-array-and-map-may-no-longer-work
            Object.setPrototypeOf(this, CustomErrorClass.prototype);
            this.name = name;
            if (fields) for(const k in fields)// eslint-disable-next-line @typescript-eslint/ban-ts-comment
            // @ts-ignore
            this[k] = fields[k];
            if (options && $50105411ce29e10f$var$isObject(options) && "cause" in options && !("cause" in this)) {
                // .cause was specified but the superconstructor
                // did not create an instance property.
                const cause = options.cause;
                this.cause = cause;
                if ("stack" in cause) this.stack = this.stack + "\nCAUSE: " + cause.stack;
            }
        }
    }
    $50105411ce29e10f$var$errorClasses[name] = CustomErrorClass;
    return CustomErrorClass;
};
function $50105411ce29e10f$var$isObject(value) {
    return typeof value === "object";
}
const $50105411ce29e10f$export$64cddc1e268e9046 = (object)=>{
    if (object && typeof object === "object") {
        try {
            if (typeof object.message === "string") {
                const msg = JSON.parse(object.message);
                if (msg.message && msg.name) object = msg;
            }
        } catch (e) {
        // nothing
        }
        let error;
        if (typeof object.name === "string") {
            const { name: name } = object;
            const des = $50105411ce29e10f$var$deserializers[name];
            if (des) error = des(object);
            else {
                let constructor = name === "Error" ? Error : $50105411ce29e10f$var$errorClasses[name];
                if (!constructor) {
                    console.warn("deserializing an unknown class '" + name + "'");
                    constructor = $50105411ce29e10f$export$94baff7bf5134824(name);
                }
                error = Object.create(constructor.prototype);
                try {
                    for(const prop in object)if (object.hasOwnProperty(prop)) error[prop] = object[prop];
                } catch (e) {
                // sometimes setting a property can fail (e.g. .name)
                }
            }
        } else if (typeof object.message === "string") error = new Error(object.message);
        if (error && !error.stack && Error.captureStackTrace) Error.captureStackTrace(error, $50105411ce29e10f$export$64cddc1e268e9046);
        return error;
    }
    return new Error(String(object));
};
const $50105411ce29e10f$export$46ff38bc6bdea8fb = (value)=>{
    if (!value) return value;
    if (typeof value === "object") return $50105411ce29e10f$var$destroyCircular(value, []);
    if (typeof value === "function") return `[Function: ${value.name || "anonymous"}]`;
    return value;
};
// https://www.npmjs.com/package/destroy-circular
function $50105411ce29e10f$var$destroyCircular(from, seen) {
    const to = {};
    seen.push(from);
    for (const key of Object.keys(from)){
        const value = from[key];
        if (typeof value === "function") continue;
        if (!value || typeof value !== "object") {
            to[key] = value;
            continue;
        }
        if (seen.indexOf(from[key]) === -1) {
            to[key] = $50105411ce29e10f$var$destroyCircular(from[key], seen.slice(0));
            continue;
        }
        to[key] = "[Circular]";
    }
    if (typeof from.name === "string") to.name = from.name;
    if (typeof from.message === "string") to.message = from.message;
    if (typeof from.stack === "string") to.stack = from.stack;
    return to;
}

});



parcelRegister("92h1s", function(module, exports) {

var $Gr8vk = parcelRequire("Gr8vk");
module.exports = $Gr8vk("bSJWN").then(()=>parcelRequire("fUHqW"));

});
parcelRegister("Gr8vk", function(module, exports) {
"use strict";

function $07f8f9093a769793$var$load(id) {
    // eslint-disable-next-line no-undef
    return import((parcelRequire("27Lyk")).resolve(id));
}
module.exports = $07f8f9093a769793$var$load;

});


parcelRegister("fSpOt", function(module, exports) {

var $Gr8vk = parcelRequire("Gr8vk");
module.exports = $Gr8vk("lHJg1").then(()=>parcelRequire("3lp4m"));

});

parcelRegister("hSLYn", function(module, exports) {

var $Gr8vk = parcelRequire("Gr8vk");
module.exports = $Gr8vk("2Wmvo").then(()=>parcelRequire("8VMga"));

});

parcelRegister("b8sjQ", function(module, exports) {
/* UAParser.js v1.0.37
   Copyright © 2012-2021 Faisal Salman <f@faisalman.com>
   MIT License */ (function(window1, undefined) {
    "use strict";
    var LIBVERSION = "1.0.37", EMPTY = "", UNKNOWN = "?", FUNC_TYPE = "function", UNDEF_TYPE = "undefined", OBJ_TYPE = "object", STR_TYPE = "string", MAJOR = "major", MODEL = "model", NAME = "name", TYPE = "type", VENDOR = "vendor", VERSION = "version", ARCHITECTURE = "architecture", CONSOLE = "console", MOBILE = "mobile", TABLET = "tablet", SMARTTV = "smarttv", WEARABLE = "wearable", EMBEDDED = "embedded", UA_MAX_LENGTH = 500;
    var AMAZON = "Amazon", APPLE = "Apple", ASUS = "ASUS", BLACKBERRY = "BlackBerry", BROWSER = "Browser", CHROME = "Chrome", EDGE = "Edge", FIREFOX = "Firefox", GOOGLE = "Google", HUAWEI = "Huawei", LG = "LG", MICROSOFT = "Microsoft", MOTOROLA = "Motorola", OPERA = "Opera", SAMSUNG = "Samsung", SHARP = "Sharp", SONY = "Sony", XIAOMI = "Xiaomi", ZEBRA = "Zebra", FACEBOOK = "Facebook", CHROMIUM_OS = "Chromium OS", MAC_OS = "Mac OS";
    var extend = function(regexes, extensions) {
        var mergedRegexes = {};
        for(var i in regexes)if (extensions[i] && extensions[i].length % 2 === 0) mergedRegexes[i] = extensions[i].concat(regexes[i]);
        else mergedRegexes[i] = regexes[i];
        return mergedRegexes;
    }, enumerize = function(arr) {
        var enums = {};
        for(var i = 0; i < arr.length; i++)enums[arr[i].toUpperCase()] = arr[i];
        return enums;
    }, has = function(str1, str2) {
        return typeof str1 === STR_TYPE ? lowerize(str2).indexOf(lowerize(str1)) !== -1 : false;
    }, lowerize = function(str) {
        return str.toLowerCase();
    }, majorize = function(version) {
        return typeof version === STR_TYPE ? version.replace(/[^\d\.]/g, EMPTY).split(".")[0] : undefined;
    }, trim = function(str, len) {
        if (typeof str === STR_TYPE) {
            str = str.replace(/^\s\s*/, EMPTY);
            return typeof len === UNDEF_TYPE ? str : str.substring(0, UA_MAX_LENGTH);
        }
    };
    var rgxMapper = function(ua, arrays) {
        var i = 0, j, k, p, q, matches, match;
        while(i < arrays.length && !matches){
            var regex = arrays[i], props = arrays[i + 1];
            j = k = 0;
            while(j < regex.length && !matches){
                if (!regex[j]) break;
                matches = regex[j++].exec(ua);
                if (!!matches) for(p = 0; p < props.length; p++){
                    match = matches[++k];
                    q = props[p];
                    if (typeof q === OBJ_TYPE && q.length > 0) {
                        if (q.length === 2) {
                            if (typeof q[1] == FUNC_TYPE) this[q[0]] = q[1].call(this, match);
                            else this[q[0]] = q[1];
                        } else if (q.length === 3) {
                            if (typeof q[1] === FUNC_TYPE && !(q[1].exec && q[1].test)) this[q[0]] = match ? q[1].call(this, match, q[2]) : undefined;
                            else this[q[0]] = match ? match.replace(q[1], q[2]) : undefined;
                        } else if (q.length === 4) this[q[0]] = match ? q[3].call(this, match.replace(q[1], q[2])) : undefined;
                    } else this[q] = match ? match : undefined;
                }
            }
            i += 2;
        }
    }, strMapper = function(str, map) {
        for(var i in map){
            if (typeof map[i] === OBJ_TYPE && map[i].length > 0) for(var j = 0; j < map[i].length; j++){
                if (has(map[i][j], str)) return i === UNKNOWN ? undefined : i;
            }
            else if (has(map[i], str)) return i === UNKNOWN ? undefined : i;
        }
        return str;
    };
    var oldSafariMap = {
        "1.0": "/8",
        1.2: "/1",
        1.3: "/3",
        "2.0": "/412",
        "2.0.2": "/416",
        "2.0.3": "/417",
        "2.0.4": "/419",
        "?": "/"
    }, windowsVersionMap = {
        ME: "4.90",
        "NT 3.11": "NT3.51",
        "NT 4.0": "NT4.0",
        2e3: "NT 5.0",
        XP: [
            "NT 5.1",
            "NT 5.2"
        ],
        Vista: "NT 6.0",
        7: "NT 6.1",
        8: "NT 6.2",
        8.1: "NT 6.3",
        10: [
            "NT 6.4",
            "NT 10.0"
        ],
        RT: "ARM"
    };
    var regexes = {
        browser: [
            [
                /\b(?:crmo|crios)\/([\w\.]+)/i
            ],
            [
                VERSION,
                [
                    NAME,
                    "Chrome"
                ]
            ],
            [
                /edg(?:e|ios|a)?\/([\w\.]+)/i
            ],
            [
                VERSION,
                [
                    NAME,
                    "Edge"
                ]
            ],
            [
                /(opera mini)\/([-\w\.]+)/i,
                /(opera [mobiletab]{3,6})\b.+version\/([-\w\.]+)/i,
                /(opera)(?:.+version\/|[\/ ]+)([\w\.]+)/i
            ],
            [
                NAME,
                VERSION
            ],
            [
                /opios[\/ ]+([\w\.]+)/i
            ],
            [
                VERSION,
                [
                    NAME,
                    OPERA + " Mini"
                ]
            ],
            [
                /\bopr\/([\w\.]+)/i
            ],
            [
                VERSION,
                [
                    NAME,
                    OPERA
                ]
            ],
            [
                /\bb[ai]*d(?:uhd|[ub]*[aekoprswx]{5,6})[\/ ]?([\w\.]+)/i
            ],
            [
                VERSION,
                [
                    NAME,
                    "Baidu"
                ]
            ],
            [
                /(kindle)\/([\w\.]+)/i,
                /(lunascape|maxthon|netfront|jasmine|blazer)[\/ ]?([\w\.]*)/i,
                /(avant|iemobile|slim)\s?(?:browser)?[\/ ]?([\w\.]*)/i,
                /(?:ms|\()(ie) ([\w\.]+)/i,
                /(flock|rockmelt|midori|epiphany|silk|skyfire|bolt|iron|vivaldi|iridium|phantomjs|bowser|quark|qupzilla|falkon|rekonq|puffin|brave|whale(?!.+naver)|qqbrowserlite|qq|duckduckgo)\/([-\w\.]+)/i,
                /(heytap|ovi)browser\/([\d\.]+)/i,
                /(weibo)__([\d\.]+)/i
            ],
            [
                NAME,
                VERSION
            ],
            [
                /(?:\buc? ?browser|(?:juc.+)ucweb)[\/ ]?([\w\.]+)/i
            ],
            [
                VERSION,
                [
                    NAME,
                    "UC" + BROWSER
                ]
            ],
            [
                /microm.+\bqbcore\/([\w\.]+)/i,
                /\bqbcore\/([\w\.]+).+microm/i,
                /micromessenger\/([\w\.]+)/i
            ],
            [
                VERSION,
                [
                    NAME,
                    "WeChat"
                ]
            ],
            [
                /konqueror\/([\w\.]+)/i
            ],
            [
                VERSION,
                [
                    NAME,
                    "Konqueror"
                ]
            ],
            [
                /trident.+rv[: ]([\w\.]{1,9})\b.+like gecko/i
            ],
            [
                VERSION,
                [
                    NAME,
                    "IE"
                ]
            ],
            [
                /ya(?:search)?browser\/([\w\.]+)/i
            ],
            [
                VERSION,
                [
                    NAME,
                    "Yandex"
                ]
            ],
            [
                /slbrowser\/([\w\.]+)/i
            ],
            [
                VERSION,
                [
                    NAME,
                    "Smart Lenovo " + BROWSER
                ]
            ],
            [
                /(avast|avg)\/([\w\.]+)/i
            ],
            [
                [
                    NAME,
                    /(.+)/,
                    "$1 Secure " + BROWSER
                ],
                VERSION
            ],
            [
                /\bfocus\/([\w\.]+)/i
            ],
            [
                VERSION,
                [
                    NAME,
                    FIREFOX + " Focus"
                ]
            ],
            [
                /\bopt\/([\w\.]+)/i
            ],
            [
                VERSION,
                [
                    NAME,
                    OPERA + " Touch"
                ]
            ],
            [
                /coc_coc\w+\/([\w\.]+)/i
            ],
            [
                VERSION,
                [
                    NAME,
                    "Coc Coc"
                ]
            ],
            [
                /dolfin\/([\w\.]+)/i
            ],
            [
                VERSION,
                [
                    NAME,
                    "Dolphin"
                ]
            ],
            [
                /coast\/([\w\.]+)/i
            ],
            [
                VERSION,
                [
                    NAME,
                    OPERA + " Coast"
                ]
            ],
            [
                /miuibrowser\/([\w\.]+)/i
            ],
            [
                VERSION,
                [
                    NAME,
                    "MIUI " + BROWSER
                ]
            ],
            [
                /fxios\/([-\w\.]+)/i
            ],
            [
                VERSION,
                [
                    NAME,
                    FIREFOX
                ]
            ],
            [
                /\bqihu|(qi?ho?o?|360)browser/i
            ],
            [
                [
                    NAME,
                    "360 " + BROWSER
                ]
            ],
            [
                /(oculus|sailfish|huawei|vivo)browser\/([\w\.]+)/i
            ],
            [
                [
                    NAME,
                    /(.+)/,
                    "$1 " + BROWSER
                ],
                VERSION
            ],
            [
                /samsungbrowser\/([\w\.]+)/i
            ],
            [
                VERSION,
                [
                    NAME,
                    SAMSUNG + " Internet"
                ]
            ],
            [
                /(comodo_dragon)\/([\w\.]+)/i
            ],
            [
                [
                    NAME,
                    /_/g,
                    " "
                ],
                VERSION
            ],
            [
                /metasr[\/ ]?([\d\.]+)/i
            ],
            [
                VERSION,
                [
                    NAME,
                    "Sogou Explorer"
                ]
            ],
            [
                /(sogou)mo\w+\/([\d\.]+)/i
            ],
            [
                [
                    NAME,
                    "Sogou Mobile"
                ],
                VERSION
            ],
            [
                /(electron)\/([\w\.]+) safari/i,
                /(tesla)(?: qtcarbrowser|\/(20\d\d\.[-\w\.]+))/i,
                /m?(qqbrowser|2345Explorer)[\/ ]?([\w\.]+)/i
            ],
            [
                NAME,
                VERSION
            ],
            [
                /(lbbrowser)/i,
                /\[(linkedin)app\]/i
            ],
            [
                NAME
            ],
            [
                /((?:fban\/fbios|fb_iab\/fb4a)(?!.+fbav)|;fbav\/([\w\.]+);)/i
            ],
            [
                [
                    NAME,
                    FACEBOOK
                ],
                VERSION
            ],
            [
                /(Klarna)\/([\w\.]+)/i,
                /(kakao(?:talk|story))[\/ ]([\w\.]+)/i,
                /(naver)\(.*?(\d+\.[\w\.]+).*\)/i,
                /safari (line)\/([\w\.]+)/i,
                /\b(line)\/([\w\.]+)\/iab/i,
                /(alipay)client\/([\w\.]+)/i,
                /(chromium|instagram|snapchat)[\/ ]([-\w\.]+)/i
            ],
            [
                NAME,
                VERSION
            ],
            [
                /\bgsa\/([\w\.]+) .*safari\//i
            ],
            [
                VERSION,
                [
                    NAME,
                    "GSA"
                ]
            ],
            [
                /musical_ly(?:.+app_?version\/|_)([\w\.]+)/i
            ],
            [
                VERSION,
                [
                    NAME,
                    "TikTok"
                ]
            ],
            [
                /headlesschrome(?:\/([\w\.]+)| )/i
            ],
            [
                VERSION,
                [
                    NAME,
                    CHROME + " Headless"
                ]
            ],
            [
                / wv\).+(chrome)\/([\w\.]+)/i
            ],
            [
                [
                    NAME,
                    CHROME + " WebView"
                ],
                VERSION
            ],
            [
                /droid.+ version\/([\w\.]+)\b.+(?:mobile safari|safari)/i
            ],
            [
                VERSION,
                [
                    NAME,
                    "Android " + BROWSER
                ]
            ],
            [
                /(chrome|omniweb|arora|[tizenoka]{5} ?browser)\/v?([\w\.]+)/i
            ],
            [
                NAME,
                VERSION
            ],
            [
                /version\/([\w\.\,]+) .*mobile\/\w+ (safari)/i
            ],
            [
                VERSION,
                [
                    NAME,
                    "Mobile Safari"
                ]
            ],
            [
                /version\/([\w(\.|\,)]+) .*(mobile ?safari|safari)/i
            ],
            [
                VERSION,
                NAME
            ],
            [
                /webkit.+?(mobile ?safari|safari)(\/[\w\.]+)/i
            ],
            [
                NAME,
                [
                    VERSION,
                    strMapper,
                    oldSafariMap
                ]
            ],
            [
                /(webkit|khtml)\/([\w\.]+)/i
            ],
            [
                NAME,
                VERSION
            ],
            [
                /(navigator|netscape\d?)\/([-\w\.]+)/i
            ],
            [
                [
                    NAME,
                    "Netscape"
                ],
                VERSION
            ],
            [
                /mobile vr; rv:([\w\.]+)\).+firefox/i
            ],
            [
                VERSION,
                [
                    NAME,
                    FIREFOX + " Reality"
                ]
            ],
            [
                /ekiohf.+(flow)\/([\w\.]+)/i,
                /(swiftfox)/i,
                /(icedragon|iceweasel|camino|chimera|fennec|maemo browser|minimo|conkeror|klar)[\/ ]?([\w\.\+]+)/i,
                /(seamonkey|k-meleon|icecat|iceape|firebird|phoenix|palemoon|basilisk|waterfox)\/([-\w\.]+)$/i,
                /(firefox)\/([\w\.]+)/i,
                /(mozilla)\/([\w\.]+) .+rv\:.+gecko\/\d+/i,
                /(polaris|lynx|dillo|icab|doris|amaya|w3m|netsurf|sleipnir|obigo|mosaic|(?:go|ice|up)[\. ]?browser)[-\/ ]?v?([\w\.]+)/i,
                /(links) \(([\w\.]+)/i,
                /panasonic;(viera)/i
            ],
            [
                NAME,
                VERSION
            ],
            [
                /(cobalt)\/([\w\.]+)/i
            ],
            [
                NAME,
                [
                    VERSION,
                    /master.|lts./,
                    ""
                ]
            ]
        ],
        cpu: [
            [
                /(?:(amd|x(?:(?:86|64)[-_])?|wow|win)64)[;\)]/i
            ],
            [
                [
                    ARCHITECTURE,
                    "amd64"
                ]
            ],
            [
                /(ia32(?=;))/i
            ],
            [
                [
                    ARCHITECTURE,
                    lowerize
                ]
            ],
            [
                /((?:i[346]|x)86)[;\)]/i
            ],
            [
                [
                    ARCHITECTURE,
                    "ia32"
                ]
            ],
            [
                /\b(aarch64|arm(v?8e?l?|_?64))\b/i
            ],
            [
                [
                    ARCHITECTURE,
                    "arm64"
                ]
            ],
            [
                /\b(arm(?:v[67])?ht?n?[fl]p?)\b/i
            ],
            [
                [
                    ARCHITECTURE,
                    "armhf"
                ]
            ],
            [
                /windows (ce|mobile); ppc;/i
            ],
            [
                [
                    ARCHITECTURE,
                    "arm"
                ]
            ],
            [
                /((?:ppc|powerpc)(?:64)?)(?: mac|;|\))/i
            ],
            [
                [
                    ARCHITECTURE,
                    /ower/,
                    EMPTY,
                    lowerize
                ]
            ],
            [
                /(sun4\w)[;\)]/i
            ],
            [
                [
                    ARCHITECTURE,
                    "sparc"
                ]
            ],
            [
                /((?:avr32|ia64(?=;))|68k(?=\))|\barm(?=v(?:[1-7]|[5-7]1)l?|;|eabi)|(?=atmel )avr|(?:irix|mips|sparc)(?:64)?\b|pa-risc)/i
            ],
            [
                [
                    ARCHITECTURE,
                    lowerize
                ]
            ]
        ],
        device: [
            [
                /\b(sch-i[89]0\d|shw-m380s|sm-[ptx]\w{2,4}|gt-[pn]\d{2,4}|sgh-t8[56]9|nexus 10)/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    SAMSUNG
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /\b((?:s[cgp]h|gt|sm)-\w+|sc[g-]?[\d]+a?|galaxy nexus)/i,
                /samsung[- ]([-\w]+)/i,
                /sec-(sgh\w+)/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    SAMSUNG
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /(?:\/|\()(ip(?:hone|od)[\w, ]*)(?:\/|;)/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    APPLE
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /\((ipad);[-\w\),; ]+apple/i,
                /applecoremedia\/[\w\.]+ \((ipad)/i,
                /\b(ipad)\d\d?,\d\d?[;\]].+ios/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    APPLE
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /(macintosh);/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    APPLE
                ]
            ],
            [
                /\b(sh-?[altvz]?\d\d[a-ekm]?)/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    SHARP
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /\b((?:ag[rs][23]?|bah2?|sht?|btv)-a?[lw]\d{2})\b(?!.+d\/s)/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    HUAWEI
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /(?:huawei|honor)([-\w ]+)[;\)]/i,
                /\b(nexus 6p|\w{2,4}e?-[atu]?[ln][\dx][012359c][adn]?)\b(?!.+d\/s)/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    HUAWEI
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /\b(poco[\w ]+|m2\d{3}j\d\d[a-z]{2})(?: bui|\))/i,
                /\b; (\w+) build\/hm\1/i,
                /\b(hm[-_ ]?note?[_ ]?(?:\d\w)?) bui/i,
                /\b(redmi[\-_ ]?(?:note|k)?[\w_ ]+)(?: bui|\))/i,
                /oid[^\)]+; (m?[12][0-389][01]\w{3,6}[c-y])( bui|; wv|\))/i,
                /\b(mi[-_ ]?(?:a\d|one|one[_ ]plus|note lte|max|cc)?[_ ]?(?:\d?\w?)[_ ]?(?:plus|se|lite)?)(?: bui|\))/i
            ],
            [
                [
                    MODEL,
                    /_/g,
                    " "
                ],
                [
                    VENDOR,
                    XIAOMI
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /oid[^\)]+; (2\d{4}(283|rpbf)[cgl])( bui|\))/i,
                /\b(mi[-_ ]?(?:pad)(?:[\w_ ]+))(?: bui|\))/i
            ],
            [
                [
                    MODEL,
                    /_/g,
                    " "
                ],
                [
                    VENDOR,
                    XIAOMI
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /; (\w+) bui.+ oppo/i,
                /\b(cph[12]\d{3}|p(?:af|c[al]|d\w|e[ar])[mt]\d0|x9007|a101op)\b/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "OPPO"
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /vivo (\w+)(?: bui|\))/i,
                /\b(v[12]\d{3}\w?[at])(?: bui|;)/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "Vivo"
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /\b(rmx[1-3]\d{3})(?: bui|;|\))/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "Realme"
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /\b(milestone|droid(?:[2-4x]| (?:bionic|x2|pro|razr))?:?( 4g)?)\b[\w ]+build\//i,
                /\bmot(?:orola)?[- ](\w*)/i,
                /((?:moto[\w\(\) ]+|xt\d{3,4}|nexus 6)(?= bui|\)))/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    MOTOROLA
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /\b(mz60\d|xoom[2 ]{0,2}) build\//i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    MOTOROLA
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /((?=lg)?[vl]k\-?\d{3}) bui| 3\.[-\w; ]{10}lg?-([06cv9]{3,4})/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    LG
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /(lm(?:-?f100[nv]?|-[\w\.]+)(?= bui|\))|nexus [45])/i,
                /\blg[-e;\/ ]+((?!browser|netcast|android tv)\w+)/i,
                /\blg-?([\d\w]+) bui/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    LG
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /(ideatab[-\w ]+)/i,
                /lenovo ?(s[56]000[-\w]+|tab(?:[\w ]+)|yt[-\d\w]{6}|tb[-\d\w]{6})/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "Lenovo"
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /(?:maemo|nokia).*(n900|lumia \d+)/i,
                /nokia[-_ ]?([-\w\.]*)/i
            ],
            [
                [
                    MODEL,
                    /_/g,
                    " "
                ],
                [
                    VENDOR,
                    "Nokia"
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /(pixel c)\b/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    GOOGLE
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /droid.+; (pixel[\daxl ]{0,6})(?: bui|\))/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    GOOGLE
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /droid.+ (a?\d[0-2]{2}so|[c-g]\d{4}|so[-gl]\w+|xq-a\w[4-7][12])(?= bui|\).+chrome\/(?![1-6]{0,1}\d\.))/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    SONY
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /sony tablet [ps]/i,
                /\b(?:sony)?sgp\w+(?: bui|\))/i
            ],
            [
                [
                    MODEL,
                    "Xperia Tablet"
                ],
                [
                    VENDOR,
                    SONY
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                / (kb2005|in20[12]5|be20[12][59])\b/i,
                /(?:one)?(?:plus)? (a\d0\d\d)(?: b|\))/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "OnePlus"
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /(alexa)webm/i,
                /(kf[a-z]{2}wi|aeo[c-r]{2})( bui|\))/i,
                /(kf[a-z]+)( bui|\)).+silk\//i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    AMAZON
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /((?:sd|kf)[0349hijorstuw]+)( bui|\)).+silk\//i
            ],
            [
                [
                    MODEL,
                    /(.+)/g,
                    "Fire Phone $1"
                ],
                [
                    VENDOR,
                    AMAZON
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /(playbook);[-\w\),; ]+(rim)/i
            ],
            [
                MODEL,
                VENDOR,
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /\b((?:bb[a-f]|st[hv])100-\d)/i,
                /\(bb10; (\w+)/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    BLACKBERRY
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /(?:\b|asus_)(transfo[prime ]{4,10} \w+|eeepc|slider \w+|nexus 7|padfone|p00[cj])/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    ASUS
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                / (z[bes]6[027][012][km][ls]|zenfone \d\w?)\b/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    ASUS
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /(nexus 9)/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "HTC"
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /(htc)[-;_ ]{1,2}([\w ]+(?=\)| bui)|\w+)/i,
                /(zte)[- ]([\w ]+?)(?: bui|\/|\))/i,
                /(alcatel|geeksphone|nexian|panasonic(?!(?:;|\.))|sony(?!-bra))[-_ ]?([-\w]*)/i
            ],
            [
                VENDOR,
                [
                    MODEL,
                    /_/g,
                    " "
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /droid.+; ([ab][1-7]-?[0178a]\d\d?)/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "Acer"
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /droid.+; (m[1-5] note) bui/i,
                /\bmz-([-\w]{2,})/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "Meizu"
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /; ((?:power )?armor(?:[\w ]{0,8}))(?: bui|\))/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "Ulefone"
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /(blackberry|benq|palm(?=\-)|sonyericsson|acer|asus|dell|meizu|motorola|polytron|infinix|tecno)[-_ ]?([-\w]*)/i,
                /(hp) ([\w ]+\w)/i,
                /(asus)-?(\w+)/i,
                /(microsoft); (lumia[\w ]+)/i,
                /(lenovo)[-_ ]?([-\w]+)/i,
                /(jolla)/i,
                /(oppo) ?([\w ]+) bui/i
            ],
            [
                VENDOR,
                MODEL,
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /(kobo)\s(ereader|touch)/i,
                /(archos) (gamepad2?)/i,
                /(hp).+(touchpad(?!.+tablet)|tablet)/i,
                /(kindle)\/([\w\.]+)/i,
                /(nook)[\w ]+build\/(\w+)/i,
                /(dell) (strea[kpr\d ]*[\dko])/i,
                /(le[- ]+pan)[- ]+(\w{1,9}) bui/i,
                /(trinity)[- ]*(t\d{3}) bui/i,
                /(gigaset)[- ]+(q\w{1,9}) bui/i,
                /(vodafone) ([\w ]+)(?:\)| bui)/i
            ],
            [
                VENDOR,
                MODEL,
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /(surface duo)/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    MICROSOFT
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /droid [\d\.]+; (fp\du?)(?: b|\))/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "Fairphone"
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /(u304aa)/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "AT&T"
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /\bsie-(\w*)/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "Siemens"
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /\b(rct\w+) b/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "RCA"
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /\b(venue[\d ]{2,7}) b/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "Dell"
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /\b(q(?:mv|ta)\w+) b/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "Verizon"
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /\b(?:barnes[& ]+noble |bn[rt])([\w\+ ]*) b/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "Barnes & Noble"
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /\b(tm\d{3}\w+) b/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "NuVision"
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /\b(k88) b/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "ZTE"
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /\b(nx\d{3}j) b/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "ZTE"
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /\b(gen\d{3}) b.+49h/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "Swiss"
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /\b(zur\d{3}) b/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "Swiss"
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /\b((zeki)?tb.*\b) b/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "Zeki"
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /\b([yr]\d{2}) b/i,
                /\b(dragon[- ]+touch |dt)(\w{5}) b/i
            ],
            [
                [
                    VENDOR,
                    "Dragon Touch"
                ],
                MODEL,
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /\b(ns-?\w{0,9}) b/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "Insignia"
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /\b((nxa|next)-?\w{0,9}) b/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "NextBook"
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /\b(xtreme\_)?(v(1[045]|2[015]|[3469]0|7[05])) b/i
            ],
            [
                [
                    VENDOR,
                    "Voice"
                ],
                MODEL,
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /\b(lvtel\-)?(v1[12]) b/i
            ],
            [
                [
                    VENDOR,
                    "LvTel"
                ],
                MODEL,
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /\b(ph-1) /i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "Essential"
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /\b(v(100md|700na|7011|917g).*\b) b/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "Envizen"
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /\b(trio[-\w\. ]+) b/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "MachSpeed"
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /\btu_(1491) b/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "Rotor"
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /(shield[\w ]+) b/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "Nvidia"
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /(sprint) (\w+)/i
            ],
            [
                VENDOR,
                MODEL,
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /(kin\.[onetw]{3})/i
            ],
            [
                [
                    MODEL,
                    /\./g,
                    " "
                ],
                [
                    VENDOR,
                    MICROSOFT
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /droid.+; (cc6666?|et5[16]|mc[239][23]x?|vc8[03]x?)\)/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    ZEBRA
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /droid.+; (ec30|ps20|tc[2-8]\d[kx])\)/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    ZEBRA
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /smart-tv.+(samsung)/i
            ],
            [
                VENDOR,
                [
                    TYPE,
                    SMARTTV
                ]
            ],
            [
                /hbbtv.+maple;(\d+)/i
            ],
            [
                [
                    MODEL,
                    /^/,
                    "SmartTV"
                ],
                [
                    VENDOR,
                    SAMSUNG
                ],
                [
                    TYPE,
                    SMARTTV
                ]
            ],
            [
                /(nux; netcast.+smarttv|lg (netcast\.tv-201\d|android tv))/i
            ],
            [
                [
                    VENDOR,
                    LG
                ],
                [
                    TYPE,
                    SMARTTV
                ]
            ],
            [
                /(apple) ?tv/i
            ],
            [
                VENDOR,
                [
                    MODEL,
                    APPLE + " TV"
                ],
                [
                    TYPE,
                    SMARTTV
                ]
            ],
            [
                /crkey/i
            ],
            [
                [
                    MODEL,
                    CHROME + "cast"
                ],
                [
                    VENDOR,
                    GOOGLE
                ],
                [
                    TYPE,
                    SMARTTV
                ]
            ],
            [
                /droid.+aft(\w+)( bui|\))/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    AMAZON
                ],
                [
                    TYPE,
                    SMARTTV
                ]
            ],
            [
                /\(dtv[\);].+(aquos)/i,
                /(aquos-tv[\w ]+)\)/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    SHARP
                ],
                [
                    TYPE,
                    SMARTTV
                ]
            ],
            [
                /(bravia[\w ]+)( bui|\))/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    SONY
                ],
                [
                    TYPE,
                    SMARTTV
                ]
            ],
            [
                /(mitv-\w{5}) bui/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    XIAOMI
                ],
                [
                    TYPE,
                    SMARTTV
                ]
            ],
            [
                /Hbbtv.*(technisat) (.*);/i
            ],
            [
                VENDOR,
                MODEL,
                [
                    TYPE,
                    SMARTTV
                ]
            ],
            [
                /\b(roku)[\dx]*[\)\/]((?:dvp-)?[\d\.]*)/i,
                /hbbtv\/\d+\.\d+\.\d+ +\([\w\+ ]*; *([\w\d][^;]*);([^;]*)/i
            ],
            [
                [
                    VENDOR,
                    trim
                ],
                [
                    MODEL,
                    trim
                ],
                [
                    TYPE,
                    SMARTTV
                ]
            ],
            [
                /\b(android tv|smart[- ]?tv|opera tv|tv; rv:)\b/i
            ],
            [
                [
                    TYPE,
                    SMARTTV
                ]
            ],
            [
                /(ouya)/i,
                /(nintendo) ([wids3utch]+)/i
            ],
            [
                VENDOR,
                MODEL,
                [
                    TYPE,
                    CONSOLE
                ]
            ],
            [
                /droid.+; (shield) bui/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "Nvidia"
                ],
                [
                    TYPE,
                    CONSOLE
                ]
            ],
            [
                /(playstation [345portablevi]+)/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    SONY
                ],
                [
                    TYPE,
                    CONSOLE
                ]
            ],
            [
                /\b(xbox(?: one)?(?!; xbox))[\); ]/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    MICROSOFT
                ],
                [
                    TYPE,
                    CONSOLE
                ]
            ],
            [
                /((pebble))app/i
            ],
            [
                VENDOR,
                MODEL,
                [
                    TYPE,
                    WEARABLE
                ]
            ],
            [
                /(watch)(?: ?os[,\/]|\d,\d\/)[\d\.]+/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    APPLE
                ],
                [
                    TYPE,
                    WEARABLE
                ]
            ],
            [
                /droid.+; (glass) \d/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    GOOGLE
                ],
                [
                    TYPE,
                    WEARABLE
                ]
            ],
            [
                /droid.+; (wt63?0{2,3})\)/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    ZEBRA
                ],
                [
                    TYPE,
                    WEARABLE
                ]
            ],
            [
                /(quest( 2| pro)?)/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    FACEBOOK
                ],
                [
                    TYPE,
                    WEARABLE
                ]
            ],
            [
                /(tesla)(?: qtcarbrowser|\/[-\w\.]+)/i
            ],
            [
                VENDOR,
                [
                    TYPE,
                    EMBEDDED
                ]
            ],
            [
                /(aeobc)\b/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    AMAZON
                ],
                [
                    TYPE,
                    EMBEDDED
                ]
            ],
            [
                /droid .+?; ([^;]+?)(?: bui|; wv\)|\) applew).+? mobile safari/i
            ],
            [
                MODEL,
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /droid .+?; ([^;]+?)(?: bui|\) applew).+?(?! mobile) safari/i
            ],
            [
                MODEL,
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /\b((tablet|tab)[;\/]|focus\/\d(?!.+mobile))/i
            ],
            [
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /(phone|mobile(?:[;\/]| [ \w\/\.]*safari)|pda(?=.+windows ce))/i
            ],
            [
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /(android[-\w\. ]{0,9});.+buil/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "Generic"
                ]
            ]
        ],
        engine: [
            [
                /windows.+ edge\/([\w\.]+)/i
            ],
            [
                VERSION,
                [
                    NAME,
                    EDGE + "HTML"
                ]
            ],
            [
                /webkit\/537\.36.+chrome\/(?!27)([\w\.]+)/i
            ],
            [
                VERSION,
                [
                    NAME,
                    "Blink"
                ]
            ],
            [
                /(presto)\/([\w\.]+)/i,
                /(webkit|trident|netfront|netsurf|amaya|lynx|w3m|goanna)\/([\w\.]+)/i,
                /ekioh(flow)\/([\w\.]+)/i,
                /(khtml|tasman|links)[\/ ]\(?([\w\.]+)/i,
                /(icab)[\/ ]([23]\.[\d\.]+)/i,
                /\b(libweb)/i
            ],
            [
                NAME,
                VERSION
            ],
            [
                /rv\:([\w\.]{1,9})\b.+(gecko)/i
            ],
            [
                VERSION,
                NAME
            ]
        ],
        os: [
            [
                /microsoft (windows) (vista|xp)/i
            ],
            [
                NAME,
                VERSION
            ],
            [
                /(windows (?:phone(?: os)?|mobile))[\/ ]?([\d\.\w ]*)/i
            ],
            [
                NAME,
                [
                    VERSION,
                    strMapper,
                    windowsVersionMap
                ]
            ],
            [
                /windows nt 6\.2; (arm)/i,
                /windows[\/ ]?([ntce\d\. ]+\w)(?!.+xbox)/i,
                /(?:win(?=3|9|n)|win 9x )([nt\d\.]+)/i
            ],
            [
                [
                    VERSION,
                    strMapper,
                    windowsVersionMap
                ],
                [
                    NAME,
                    "Windows"
                ]
            ],
            [
                /ip[honead]{2,4}\b(?:.*os ([\w]+) like mac|; opera)/i,
                /(?:ios;fbsv\/|iphone.+ios[\/ ])([\d\.]+)/i,
                /cfnetwork\/.+darwin/i
            ],
            [
                [
                    VERSION,
                    /_/g,
                    "."
                ],
                [
                    NAME,
                    "iOS"
                ]
            ],
            [
                /(mac os x) ?([\w\. ]*)/i,
                /(macintosh|mac_powerpc\b)(?!.+haiku)/i
            ],
            [
                [
                    NAME,
                    MAC_OS
                ],
                [
                    VERSION,
                    /_/g,
                    "."
                ]
            ],
            [
                /droid ([\w\.]+)\b.+(android[- ]x86|harmonyos)/i
            ],
            [
                VERSION,
                NAME
            ],
            [
                /(android|webos|qnx|bada|rim tablet os|maemo|meego|sailfish)[-\/ ]?([\w\.]*)/i,
                /(blackberry)\w*\/([\w\.]*)/i,
                /(tizen|kaios)[\/ ]([\w\.]+)/i,
                /\((series40);/i
            ],
            [
                NAME,
                VERSION
            ],
            [
                /\(bb(10);/i
            ],
            [
                VERSION,
                [
                    NAME,
                    BLACKBERRY
                ]
            ],
            [
                /(?:symbian ?os|symbos|s60(?=;)|series60)[-\/ ]?([\w\.]*)/i
            ],
            [
                VERSION,
                [
                    NAME,
                    "Symbian"
                ]
            ],
            [
                /mozilla\/[\d\.]+ \((?:mobile|tablet|tv|mobile; [\w ]+); rv:.+ gecko\/([\w\.]+)/i
            ],
            [
                VERSION,
                [
                    NAME,
                    FIREFOX + " OS"
                ]
            ],
            [
                /web0s;.+rt(tv)/i,
                /\b(?:hp)?wos(?:browser)?\/([\w\.]+)/i
            ],
            [
                VERSION,
                [
                    NAME,
                    "webOS"
                ]
            ],
            [
                /watch(?: ?os[,\/]|\d,\d\/)([\d\.]+)/i
            ],
            [
                VERSION,
                [
                    NAME,
                    "watchOS"
                ]
            ],
            [
                /crkey\/([\d\.]+)/i
            ],
            [
                VERSION,
                [
                    NAME,
                    CHROME + "cast"
                ]
            ],
            [
                /(cros) [\w]+(?:\)| ([\w\.]+)\b)/i
            ],
            [
                [
                    NAME,
                    CHROMIUM_OS
                ],
                VERSION
            ],
            [
                /panasonic;(viera)/i,
                /(netrange)mmh/i,
                /(nettv)\/(\d+\.[\w\.]+)/i,
                /(nintendo|playstation) ([wids345portablevuch]+)/i,
                /(xbox); +xbox ([^\);]+)/i,
                /\b(joli|palm)\b ?(?:os)?\/?([\w\.]*)/i,
                /(mint)[\/\(\) ]?(\w*)/i,
                /(mageia|vectorlinux)[; ]/i,
                /([kxln]?ubuntu|debian|suse|opensuse|gentoo|arch(?= linux)|slackware|fedora|mandriva|centos|pclinuxos|red ?hat|zenwalk|linpus|raspbian|plan 9|minix|risc os|contiki|deepin|manjaro|elementary os|sabayon|linspire)(?: gnu\/linux)?(?: enterprise)?(?:[- ]linux)?(?:-gnu)?[-\/ ]?(?!chrom|package)([-\w\.]*)/i,
                /(hurd|linux) ?([\w\.]*)/i,
                /(gnu) ?([\w\.]*)/i,
                /\b([-frentopcghs]{0,5}bsd|dragonfly)[\/ ]?(?!amd|[ix346]{1,2}86)([\w\.]*)/i,
                /(haiku) (\w+)/i
            ],
            [
                NAME,
                VERSION
            ],
            [
                /(sunos) ?([\w\.\d]*)/i
            ],
            [
                [
                    NAME,
                    "Solaris"
                ],
                VERSION
            ],
            [
                /((?:open)?solaris)[-\/ ]?([\w\.]*)/i,
                /(aix) ((\d)(?=\.|\)| )[\w\.])*/i,
                /\b(beos|os\/2|amigaos|morphos|openvms|fuchsia|hp-ux|serenityos)/i,
                /(unix) ?([\w\.]*)/i
            ],
            [
                NAME,
                VERSION
            ]
        ]
    };
    var UAParser = function(ua, extensions) {
        if (typeof ua === OBJ_TYPE) {
            extensions = ua;
            ua = undefined;
        }
        if (!(this instanceof UAParser)) return new UAParser(ua, extensions).getResult();
        var _navigator = typeof window1 !== UNDEF_TYPE && window1.navigator ? window1.navigator : undefined;
        var _ua = ua || (_navigator && _navigator.userAgent ? _navigator.userAgent : EMPTY);
        var _uach = _navigator && _navigator.userAgentData ? _navigator.userAgentData : undefined;
        var _rgxmap = extensions ? extend(regexes, extensions) : regexes;
        var _isSelfNav = _navigator && _navigator.userAgent == _ua;
        this.getBrowser = function() {
            var _browser = {};
            _browser[NAME] = undefined;
            _browser[VERSION] = undefined;
            rgxMapper.call(_browser, _ua, _rgxmap.browser);
            _browser[MAJOR] = majorize(_browser[VERSION]);
            if (_isSelfNav && _navigator && _navigator.brave && typeof _navigator.brave.isBrave == FUNC_TYPE) _browser[NAME] = "Brave";
            return _browser;
        };
        this.getCPU = function() {
            var _cpu = {};
            _cpu[ARCHITECTURE] = undefined;
            rgxMapper.call(_cpu, _ua, _rgxmap.cpu);
            return _cpu;
        };
        this.getDevice = function() {
            var _device = {};
            _device[VENDOR] = undefined;
            _device[MODEL] = undefined;
            _device[TYPE] = undefined;
            rgxMapper.call(_device, _ua, _rgxmap.device);
            if (_isSelfNav && !_device[TYPE] && _uach && _uach.mobile) _device[TYPE] = MOBILE;
            if (_isSelfNav && _device[MODEL] == "Macintosh" && _navigator && typeof _navigator.standalone !== UNDEF_TYPE && _navigator.maxTouchPoints && _navigator.maxTouchPoints > 2) {
                _device[MODEL] = "iPad";
                _device[TYPE] = TABLET;
            }
            return _device;
        };
        this.getEngine = function() {
            var _engine = {};
            _engine[NAME] = undefined;
            _engine[VERSION] = undefined;
            rgxMapper.call(_engine, _ua, _rgxmap.engine);
            return _engine;
        };
        this.getOS = function() {
            var _os = {};
            _os[NAME] = undefined;
            _os[VERSION] = undefined;
            rgxMapper.call(_os, _ua, _rgxmap.os);
            if (_isSelfNav && !_os[NAME] && _uach && _uach.platform != "Unknown") _os[NAME] = _uach.platform.replace(/chrome os/i, CHROMIUM_OS).replace(/macos/i, MAC_OS);
            return _os;
        };
        this.getResult = function() {
            return {
                ua: this.getUA(),
                browser: this.getBrowser(),
                engine: this.getEngine(),
                os: this.getOS(),
                device: this.getDevice(),
                cpu: this.getCPU()
            };
        };
        this.getUA = function() {
            return _ua;
        };
        this.setUA = function(ua) {
            _ua = typeof ua === STR_TYPE && ua.length > UA_MAX_LENGTH ? trim(ua, UA_MAX_LENGTH) : ua;
            return this;
        };
        this.setUA(_ua);
        return this;
    };
    UAParser.VERSION = LIBVERSION;
    UAParser.BROWSER = enumerize([
        NAME,
        VERSION,
        MAJOR
    ]);
    UAParser.CPU = enumerize([
        ARCHITECTURE
    ]);
    UAParser.DEVICE = enumerize([
        MODEL,
        VENDOR,
        TYPE,
        CONSOLE,
        MOBILE,
        SMARTTV,
        TABLET,
        WEARABLE,
        EMBEDDED
    ]);
    UAParser.ENGINE = UAParser.OS = enumerize([
        NAME,
        VERSION
    ]);
    if ("object" !== UNDEF_TYPE) {
        if ("object" !== UNDEF_TYPE && module.exports) exports = module.exports = UAParser;
        exports.UAParser = UAParser;
    } else {
        if (typeof define === FUNC_TYPE && define.amd) define(function() {
            return UAParser;
        });
        else if (typeof window1 !== UNDEF_TYPE) window1.UAParser = UAParser;
    }
    var $ = typeof window1 !== UNDEF_TYPE && (window1.jQuery || window1.Zepto);
    if ($ && !$.ua) {
        var parser = new UAParser;
        $.ua = parser.getResult();
        $.ua.get = function() {
            return parser.getUA();
        };
        $.ua.set = function(ua) {
            parser.setUA(ua);
            var result = parser.getResult();
            for(var prop in result)$.ua[prop] = result[prop];
        };
    }
})(typeof window === "object" ? window : this);

});

parcelRegister("1726n", function(module, exports) {
/*
 * Copyright Joyent, Inc. and other Node contributors.
 *
 * Permission is hereby granted, free of charge, to any person obtaining a
 * copy of this software and associated documentation files (the
 * "Software"), to deal in the Software without restriction, including
 * without limitation the rights to use, copy, modify, merge, publish,
 * distribute, sublicense, and/or sell copies of the Software, and to permit
 * persons to whom the Software is furnished to do so, subject to the
 * following conditions:
 *
 * The above copyright notice and this permission notice shall be included
 * in all copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
 * OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
 * MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
 * NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
 * DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
 * OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
 * USE OR OTHER DEALINGS IN THE SOFTWARE.
 */ "use strict";

var $dYgtC = parcelRequire("dYgtC");
function Url() {
    this.protocol = null;
    this.slashes = null;
    this.auth = null;
    this.host = null;
    this.port = null;
    this.hostname = null;
    this.hash = null;
    this.search = null;
    this.query = null;
    this.pathname = null;
    this.path = null;
    this.href = null;
}
// Reference: RFC 3986, RFC 1808, RFC 2396
/*
 * define these here so at least they only have to be
 * compiled once on the first module load.
 */ var protocolPattern = /^([a-z0-9.+-]+:)/i, portPattern = /:[0-9]*$/, // Special case for a simple path URL
simplePathPattern = /^(\/\/?(?!\/)[^?\s]*)(\?[^\s]*)?$/, /*
   * RFC 2396: characters reserved for delimiting URLs.
   * We actually just auto-escape these.
   */ delims = [
    "<",
    ">",
    '"',
    "`",
    " ",
    "\r",
    "\n",
    "	"
], // RFC 2396: characters not allowed for various reasons.
unwise = [
    "{",
    "}",
    "|",
    "\\",
    "^",
    "`"
].concat(delims), // Allowed by RFCs, but cause of XSS attacks.  Always escape these.
autoEscape = [
    "'"
].concat(unwise), /*
   * Characters that are never ever allowed in a hostname.
   * Note that any invalid chars are also handled, but these
   * are the ones that are *expected* to be seen, so we fast-path
   * them.
   */ nonHostChars = [
    "%",
    "/",
    "?",
    ";",
    "#"
].concat(autoEscape), hostEndingChars = [
    "/",
    "?",
    "#"
], hostnameMaxLen = 255, hostnamePartPattern = /^[+a-z0-9A-Z_-]{0,63}$/, hostnamePartStart = /^([+a-z0-9A-Z_-]{0,63})(.*)$/, // protocols that can allow "unsafe" and "unwise" chars.
unsafeProtocol = {
    javascript: true,
    "javascript:": true
}, // protocols that never have a hostname.
hostlessProtocol = {
    javascript: true,
    "javascript:": true
}, // protocols that always contain a // bit.
slashedProtocol = {
    http: true,
    https: true,
    ftp: true,
    gopher: true,
    file: true,
    "http:": true,
    "https:": true,
    "ftp:": true,
    "gopher:": true,
    "file:": true
};

var $emRzd = parcelRequire("emRzd");
function urlParse(url, parseQueryString, slashesDenoteHost) {
    if (url && typeof url === "object" && url instanceof Url) return url;
    var u = new Url();
    u.parse(url, parseQueryString, slashesDenoteHost);
    return u;
}
Url.prototype.parse = function(url, parseQueryString, slashesDenoteHost) {
    if (typeof url !== "string") throw new TypeError("Parameter 'url' must be a string, not " + typeof url);
    /*
   * Copy chrome, IE, opera backslash-handling behavior.
   * Back slashes before the query string get converted to forward slashes
   * See: https://code.google.com/p/chromium/issues/detail?id=25916
   */ var queryIndex = url.indexOf("?"), splitter = queryIndex !== -1 && queryIndex < url.indexOf("#") ? "?" : "#", uSplit = url.split(splitter), slashRegex = /\\/g;
    uSplit[0] = uSplit[0].replace(slashRegex, "/");
    url = uSplit.join(splitter);
    var rest = url;
    /*
   * trim before proceeding.
   * This is to support parse stuff like "  http://foo.com  \n"
   */ rest = rest.trim();
    if (!slashesDenoteHost && url.split("#").length === 1) {
        // Try fast path regexp
        var simplePath = simplePathPattern.exec(rest);
        if (simplePath) {
            this.path = rest;
            this.href = rest;
            this.pathname = simplePath[1];
            if (simplePath[2]) {
                this.search = simplePath[2];
                if (parseQueryString) this.query = $emRzd.parse(this.search.substr(1));
                else this.query = this.search.substr(1);
            } else if (parseQueryString) {
                this.search = "";
                this.query = {};
            }
            return this;
        }
    }
    var proto = protocolPattern.exec(rest);
    if (proto) {
        proto = proto[0];
        var lowerProto = proto.toLowerCase();
        this.protocol = lowerProto;
        rest = rest.substr(proto.length);
    }
    /*
   * figure out if it's got a host
   * user@server is *always* interpreted as a hostname, and url
   * resolution will treat //foo/bar as host=foo,path=bar because that's
   * how the browser resolves relative URLs.
   */ if (slashesDenoteHost || proto || rest.match(/^\/\/[^@/]+@[^@/]+/)) {
        var slashes = rest.substr(0, 2) === "//";
        if (slashes && !(proto && hostlessProtocol[proto])) {
            rest = rest.substr(2);
            this.slashes = true;
        }
    }
    if (!hostlessProtocol[proto] && (slashes || proto && !slashedProtocol[proto])) {
        /*
     * there's a hostname.
     * the first instance of /, ?, ;, or # ends the host.
     *
     * If there is an @ in the hostname, then non-host chars *are* allowed
     * to the left of the last @ sign, unless some host-ending character
     * comes *before* the @-sign.
     * URLs are obnoxious.
     *
     * ex:
     * http://a@b@c/ => user:a@b host:c
     * http://a@b?@c => user:a host:c path:/?@c
     */ /*
     * v0.12 TODO(isaacs): This is not quite how Chrome does things.
     * Review our test case against browsers more comprehensively.
     */ // find the first instance of any hostEndingChars
        var hostEnd = -1;
        for(var i = 0; i < hostEndingChars.length; i++){
            var hec = rest.indexOf(hostEndingChars[i]);
            if (hec !== -1 && (hostEnd === -1 || hec < hostEnd)) hostEnd = hec;
        }
        /*
     * at this point, either we have an explicit point where the
     * auth portion cannot go past, or the last @ char is the decider.
     */ var auth, atSign;
        if (hostEnd === -1) // atSign can be anywhere.
        atSign = rest.lastIndexOf("@");
        else /*
       * atSign must be in auth portion.
       * http://a@b/c@d => host:b auth:a path:/c@d
       */ atSign = rest.lastIndexOf("@", hostEnd);
        /*
     * Now we have a portion which is definitely the auth.
     * Pull that off.
     */ if (atSign !== -1) {
            auth = rest.slice(0, atSign);
            rest = rest.slice(atSign + 1);
            this.auth = decodeURIComponent(auth);
        }
        // the host is the remaining to the left of the first non-host char
        hostEnd = -1;
        for(var i = 0; i < nonHostChars.length; i++){
            var hec = rest.indexOf(nonHostChars[i]);
            if (hec !== -1 && (hostEnd === -1 || hec < hostEnd)) hostEnd = hec;
        }
        // if we still have not hit it, then the entire thing is a host.
        if (hostEnd === -1) hostEnd = rest.length;
        this.host = rest.slice(0, hostEnd);
        rest = rest.slice(hostEnd);
        // pull out port.
        this.parseHost();
        /*
     * we've indicated that there is a hostname,
     * so even if it's empty, it has to be present.
     */ this.hostname = this.hostname || "";
        /*
     * if hostname begins with [ and ends with ]
     * assume that it's an IPv6 address.
     */ var ipv6Hostname = this.hostname[0] === "[" && this.hostname[this.hostname.length - 1] === "]";
        // validate a little.
        if (!ipv6Hostname) {
            var hostparts = this.hostname.split(/\./);
            for(var i = 0, l = hostparts.length; i < l; i++){
                var part = hostparts[i];
                if (!part) continue;
                if (!part.match(hostnamePartPattern)) {
                    var newpart = "";
                    for(var j = 0, k = part.length; j < k; j++)if (part.charCodeAt(j) > 127) /*
               * we replace non-ASCII char with a temporary placeholder
               * we need this to make sure size of hostname is not
               * broken by replacing non-ASCII by nothing
               */ newpart += "x";
                    else newpart += part[j];
                    // we test again with ASCII char only
                    if (!newpart.match(hostnamePartPattern)) {
                        var validParts = hostparts.slice(0, i);
                        var notHost = hostparts.slice(i + 1);
                        var bit = part.match(hostnamePartStart);
                        if (bit) {
                            validParts.push(bit[1]);
                            notHost.unshift(bit[2]);
                        }
                        if (notHost.length) rest = "/" + notHost.join(".") + rest;
                        this.hostname = validParts.join(".");
                        break;
                    }
                }
            }
        }
        if (this.hostname.length > hostnameMaxLen) this.hostname = "";
        else // hostnames are always lower case.
        this.hostname = this.hostname.toLowerCase();
        if (!ipv6Hostname) /*
       * IDNA Support: Returns a punycoded representation of "domain".
       * It only converts parts of the domain name that
       * have non-ASCII characters, i.e. it doesn't matter if
       * you call it with a domain that already is ASCII-only.
       */ this.hostname = $dYgtC.toASCII(this.hostname);
        var p = this.port ? ":" + this.port : "";
        var h = this.hostname || "";
        this.host = h + p;
        this.href += this.host;
        /*
     * strip [ and ] from the hostname
     * the host field still retains them, though
     */ if (ipv6Hostname) {
            this.hostname = this.hostname.substr(1, this.hostname.length - 2);
            if (rest[0] !== "/") rest = "/" + rest;
        }
    }
    /*
   * now rest is set to the post-host stuff.
   * chop off any delim chars.
   */ if (!unsafeProtocol[lowerProto]) /*
     * First, make 100% sure that any "autoEscape" chars get
     * escaped, even if encodeURIComponent doesn't think they
     * need to be.
     */ for(var i = 0, l = autoEscape.length; i < l; i++){
        var ae = autoEscape[i];
        if (rest.indexOf(ae) === -1) continue;
        var esc = encodeURIComponent(ae);
        if (esc === ae) esc = escape(ae);
        rest = rest.split(ae).join(esc);
    }
    // chop off from the tail first.
    var hash = rest.indexOf("#");
    if (hash !== -1) {
        // got a fragment string.
        this.hash = rest.substr(hash);
        rest = rest.slice(0, hash);
    }
    var qm = rest.indexOf("?");
    if (qm !== -1) {
        this.search = rest.substr(qm);
        this.query = rest.substr(qm + 1);
        if (parseQueryString) this.query = $emRzd.parse(this.query);
        rest = rest.slice(0, qm);
    } else if (parseQueryString) {
        // no query string, but parseQueryString still requested
        this.search = "";
        this.query = {};
    }
    if (rest) this.pathname = rest;
    if (slashedProtocol[lowerProto] && this.hostname && !this.pathname) this.pathname = "/";
    // to support http.request
    if (this.pathname || this.search) {
        var p = this.pathname || "";
        var s = this.search || "";
        this.path = p + s;
    }
    // finally, reconstruct the href based on what has been validated.
    this.href = this.format();
    return this;
};
// format a parsed object into a url string
function urlFormat(obj) {
    /*
   * ensure it's an object, and not a string url.
   * If it's an obj, this is a no-op.
   * this way, you can call url_format() on strings
   * to clean up potentially wonky urls.
   */ if (typeof obj === "string") obj = urlParse(obj);
    if (!(obj instanceof Url)) return Url.prototype.format.call(obj);
    return obj.format();
}
Url.prototype.format = function() {
    var auth = this.auth || "";
    if (auth) {
        auth = encodeURIComponent(auth);
        auth = auth.replace(/%3A/i, ":");
        auth += "@";
    }
    var protocol = this.protocol || "", pathname = this.pathname || "", hash = this.hash || "", host = false, query = "";
    if (this.host) host = auth + this.host;
    else if (this.hostname) {
        host = auth + (this.hostname.indexOf(":") === -1 ? this.hostname : "[" + this.hostname + "]");
        if (this.port) host += ":" + this.port;
    }
    if (this.query && typeof this.query === "object" && Object.keys(this.query).length) query = $emRzd.stringify(this.query, {
        arrayFormat: "repeat",
        addQueryPrefix: false
    });
    var search = this.search || query && "?" + query || "";
    if (protocol && protocol.substr(-1) !== ":") protocol += ":";
    /*
   * only the slashedProtocols get the //.  Not mailto:, xmpp:, etc.
   * unless they had them to begin with.
   */ if (this.slashes || (!protocol || slashedProtocol[protocol]) && host !== false) {
        host = "//" + (host || "");
        if (pathname && pathname.charAt(0) !== "/") pathname = "/" + pathname;
    } else if (!host) host = "";
    if (hash && hash.charAt(0) !== "#") hash = "#" + hash;
    if (search && search.charAt(0) !== "?") search = "?" + search;
    pathname = pathname.replace(/[?#]/g, function(match) {
        return encodeURIComponent(match);
    });
    search = search.replace("#", "%23");
    return protocol + host + pathname + search + hash;
};
function urlResolve(source, relative) {
    return urlParse(source, false, true).resolve(relative);
}
Url.prototype.resolve = function(relative) {
    return this.resolveObject(urlParse(relative, false, true)).format();
};
function urlResolveObject(source, relative) {
    if (!source) return relative;
    return urlParse(source, false, true).resolveObject(relative);
}
Url.prototype.resolveObject = function(relative) {
    if (typeof relative === "string") {
        var rel = new Url();
        rel.parse(relative, false, true);
        relative = rel;
    }
    var result = new Url();
    var tkeys = Object.keys(this);
    for(var tk = 0; tk < tkeys.length; tk++){
        var tkey = tkeys[tk];
        result[tkey] = this[tkey];
    }
    /*
   * hash is always overridden, no matter what.
   * even href="" will remove it.
   */ result.hash = relative.hash;
    // if the relative url is empty, then there's nothing left to do here.
    if (relative.href === "") {
        result.href = result.format();
        return result;
    }
    // hrefs like //foo/bar always cut to the protocol.
    if (relative.slashes && !relative.protocol) {
        // take everything except the protocol from relative
        var rkeys = Object.keys(relative);
        for(var rk = 0; rk < rkeys.length; rk++){
            var rkey = rkeys[rk];
            if (rkey !== "protocol") result[rkey] = relative[rkey];
        }
        // urlParse appends trailing / to urls like http://www.example.com
        if (slashedProtocol[result.protocol] && result.hostname && !result.pathname) {
            result.pathname = "/";
            result.path = result.pathname;
        }
        result.href = result.format();
        return result;
    }
    if (relative.protocol && relative.protocol !== result.protocol) {
        /*
     * if it's a known url protocol, then changing
     * the protocol does weird things
     * first, if it's not file:, then we MUST have a host,
     * and if there was a path
     * to begin with, then we MUST have a path.
     * if it is file:, then the host is dropped,
     * because that's known to be hostless.
     * anything else is assumed to be absolute.
     */ if (!slashedProtocol[relative.protocol]) {
            var keys = Object.keys(relative);
            for(var v = 0; v < keys.length; v++){
                var k = keys[v];
                result[k] = relative[k];
            }
            result.href = result.format();
            return result;
        }
        result.protocol = relative.protocol;
        if (!relative.host && !hostlessProtocol[relative.protocol]) {
            var relPath = (relative.pathname || "").split("/");
            while(relPath.length && !(relative.host = relPath.shift()));
            if (!relative.host) relative.host = "";
            if (!relative.hostname) relative.hostname = "";
            if (relPath[0] !== "") relPath.unshift("");
            if (relPath.length < 2) relPath.unshift("");
            result.pathname = relPath.join("/");
        } else result.pathname = relative.pathname;
        result.search = relative.search;
        result.query = relative.query;
        result.host = relative.host || "";
        result.auth = relative.auth;
        result.hostname = relative.hostname || relative.host;
        result.port = relative.port;
        // to support http.request
        if (result.pathname || result.search) {
            var p = result.pathname || "";
            var s = result.search || "";
            result.path = p + s;
        }
        result.slashes = result.slashes || relative.slashes;
        result.href = result.format();
        return result;
    }
    var isSourceAbs = result.pathname && result.pathname.charAt(0) === "/", isRelAbs = relative.host || relative.pathname && relative.pathname.charAt(0) === "/", mustEndAbs = isRelAbs || isSourceAbs || result.host && relative.pathname, removeAllDots = mustEndAbs, srcPath = result.pathname && result.pathname.split("/") || [], relPath = relative.pathname && relative.pathname.split("/") || [], psychotic = result.protocol && !slashedProtocol[result.protocol];
    /*
   * if the url is a non-slashed url, then relative
   * links like ../.. should be able
   * to crawl up to the hostname, as well.  This is strange.
   * result.protocol has already been set by now.
   * Later on, put the first path part into the host field.
   */ if (psychotic) {
        result.hostname = "";
        result.port = null;
        if (result.host) {
            if (srcPath[0] === "") srcPath[0] = result.host;
            else srcPath.unshift(result.host);
        }
        result.host = "";
        if (relative.protocol) {
            relative.hostname = null;
            relative.port = null;
            if (relative.host) {
                if (relPath[0] === "") relPath[0] = relative.host;
                else relPath.unshift(relative.host);
            }
            relative.host = null;
        }
        mustEndAbs = mustEndAbs && (relPath[0] === "" || srcPath[0] === "");
    }
    if (isRelAbs) {
        // it's absolute.
        result.host = relative.host || relative.host === "" ? relative.host : result.host;
        result.hostname = relative.hostname || relative.hostname === "" ? relative.hostname : result.hostname;
        result.search = relative.search;
        result.query = relative.query;
        srcPath = relPath;
    // fall through to the dot-handling below.
    } else if (relPath.length) {
        /*
     * it's relative
     * throw away the existing file, and take the new path instead.
     */ if (!srcPath) srcPath = [];
        srcPath.pop();
        srcPath = srcPath.concat(relPath);
        result.search = relative.search;
        result.query = relative.query;
    } else if (relative.search != null) {
        /*
     * just pull out the search.
     * like href='?foo'.
     * Put this after the other two cases because it simplifies the booleans
     */ if (psychotic) {
            result.host = srcPath.shift();
            result.hostname = result.host;
            /*
       * occationaly the auth can get stuck only in host
       * this especially happens in cases like
       * url.resolveObject('mailto:local1@domain1', 'local2@domain2')
       */ var authInHost = result.host && result.host.indexOf("@") > 0 ? result.host.split("@") : false;
            if (authInHost) {
                result.auth = authInHost.shift();
                result.hostname = authInHost.shift();
                result.host = result.hostname;
            }
        }
        result.search = relative.search;
        result.query = relative.query;
        // to support http.request
        if (result.pathname !== null || result.search !== null) result.path = (result.pathname ? result.pathname : "") + (result.search ? result.search : "");
        result.href = result.format();
        return result;
    }
    if (!srcPath.length) {
        /*
     * no path at all.  easy.
     * we've already handled the other stuff above.
     */ result.pathname = null;
        // to support http.request
        if (result.search) result.path = "/" + result.search;
        else result.path = null;
        result.href = result.format();
        return result;
    }
    /*
   * if a url ENDs in . or .., then it must get a trailing slash.
   * however, if it ends in anything else non-slashy,
   * then it must NOT get a trailing slash.
   */ var last = srcPath.slice(-1)[0];
    var hasTrailingSlash = (result.host || relative.host || srcPath.length > 1) && (last === "." || last === "..") || last === "";
    /*
   * strip single dots, resolve double dots to parent dir
   * if the path tries to go above the root, `up` ends up > 0
   */ var up = 0;
    for(var i = srcPath.length; i >= 0; i--){
        last = srcPath[i];
        if (last === ".") srcPath.splice(i, 1);
        else if (last === "..") {
            srcPath.splice(i, 1);
            up++;
        } else if (up) {
            srcPath.splice(i, 1);
            up--;
        }
    }
    // if the path is allowed to go above the root, restore leading ..s
    if (!mustEndAbs && !removeAllDots) for(; up--; up)srcPath.unshift("..");
    if (mustEndAbs && srcPath[0] !== "" && (!srcPath[0] || srcPath[0].charAt(0) !== "/")) srcPath.unshift("");
    if (hasTrailingSlash && srcPath.join("/").substr(-1) !== "/") srcPath.push("");
    var isAbsolute = srcPath[0] === "" || srcPath[0] && srcPath[0].charAt(0) === "/";
    // put the host back
    if (psychotic) {
        result.hostname = isAbsolute ? "" : srcPath.length ? srcPath.shift() : "";
        result.host = result.hostname;
        /*
     * occationaly the auth can get stuck only in host
     * this especially happens in cases like
     * url.resolveObject('mailto:local1@domain1', 'local2@domain2')
     */ var authInHost = result.host && result.host.indexOf("@") > 0 ? result.host.split("@") : false;
        if (authInHost) {
            result.auth = authInHost.shift();
            result.hostname = authInHost.shift();
            result.host = result.hostname;
        }
    }
    mustEndAbs = mustEndAbs || result.host && srcPath.length;
    if (mustEndAbs && !isAbsolute) srcPath.unshift("");
    if (srcPath.length > 0) result.pathname = srcPath.join("/");
    else {
        result.pathname = null;
        result.path = null;
    }
    // to support request.http
    if (result.pathname !== null || result.search !== null) result.path = (result.pathname ? result.pathname : "") + (result.search ? result.search : "");
    result.auth = relative.auth || result.auth;
    result.slashes = result.slashes || relative.slashes;
    result.href = result.format();
    return result;
};
Url.prototype.parseHost = function() {
    var host = this.host;
    var port = portPattern.exec(host);
    if (port) {
        port = port[0];
        if (port !== ":") this.port = port.substr(1);
        host = host.substr(0, host.length - port.length);
    }
    if (host) this.hostname = host;
};
exports.parse = urlParse;
exports.resolve = urlResolve;
exports.resolveObject = urlResolveObject;
exports.format = urlFormat;
exports.Url = Url;

});
parcelRegister("dYgtC", function(module, exports) {
(function(root) {
    /** Detect free variables */ var freeExports = exports && !exports.nodeType && exports;
    var freeModule = module && !module.nodeType && module;
    var freeGlobal = typeof $parcel$global == "object" && $parcel$global;
    if (freeGlobal.global === freeGlobal || freeGlobal.window === freeGlobal || freeGlobal.self === freeGlobal) root = freeGlobal;
    /**
	 * The `punycode` object.
	 * @name punycode
	 * @type Object
	 */ var punycode, /** Highest positive signed 32-bit float value */ maxInt = 2147483647, /** Bootstring parameters */ base = 36, tMin = 1, tMax = 26, skew = 38, damp = 700, initialBias = 72, initialN = 128, delimiter = "-", /** Regular expressions */ regexPunycode = /^xn--/, regexNonASCII = /[^\x20-\x7E]/, regexSeparators = /[\x2E\u3002\uFF0E\uFF61]/g, /** Error messages */ errors = {
        "overflow": "Overflow: input needs wider integers to process",
        "not-basic": "Illegal input >= 0x80 (not a basic code point)",
        "invalid-input": "Invalid input"
    }, /** Convenience shortcuts */ baseMinusTMin = base - tMin, floor = Math.floor, stringFromCharCode = String.fromCharCode, /** Temporary variable */ key;
    /*--------------------------------------------------------------------------*/ /**
	 * A generic error utility function.
	 * @private
	 * @param {String} type The error type.
	 * @returns {Error} Throws a `RangeError` with the applicable error message.
	 */ function error(type) {
        throw new RangeError(errors[type]);
    }
    /**
	 * A generic `Array#map` utility function.
	 * @private
	 * @param {Array} array The array to iterate over.
	 * @param {Function} callback The function that gets called for every array
	 * item.
	 * @returns {Array} A new array of values returned by the callback function.
	 */ function map(array, fn) {
        var length = array.length;
        var result = [];
        while(length--)result[length] = fn(array[length]);
        return result;
    }
    /**
	 * A simple `Array#map`-like wrapper to work with domain name strings or email
	 * addresses.
	 * @private
	 * @param {String} domain The domain name or email address.
	 * @param {Function} callback The function that gets called for every
	 * character.
	 * @returns {Array} A new string of characters returned by the callback
	 * function.
	 */ function mapDomain(string, fn) {
        var parts = string.split("@");
        var result = "";
        if (parts.length > 1) {
            // In email addresses, only the domain name should be punycoded. Leave
            // the local part (i.e. everything up to `@`) intact.
            result = parts[0] + "@";
            string = parts[1];
        }
        // Avoid `split(regex)` for IE8 compatibility. See #17.
        string = string.replace(regexSeparators, ".");
        var labels = string.split(".");
        var encoded = map(labels, fn).join(".");
        return result + encoded;
    }
    /**
	 * Creates an array containing the numeric code points of each Unicode
	 * character in the string. While JavaScript uses UCS-2 internally,
	 * this function will convert a pair of surrogate halves (each of which
	 * UCS-2 exposes as separate characters) into a single code point,
	 * matching UTF-16.
	 * @see `punycode.ucs2.encode`
	 * @see <https://mathiasbynens.be/notes/javascript-encoding>
	 * @memberOf punycode.ucs2
	 * @name decode
	 * @param {String} string The Unicode input string (UCS-2).
	 * @returns {Array} The new array of code points.
	 */ function ucs2decode(string) {
        var output = [], counter = 0, length = string.length, value, extra;
        while(counter < length){
            value = string.charCodeAt(counter++);
            if (value >= 0xD800 && value <= 0xDBFF && counter < length) {
                // high surrogate, and there is a next character
                extra = string.charCodeAt(counter++);
                if ((extra & 0xFC00) == 0xDC00) output.push(((value & 0x3FF) << 10) + (extra & 0x3FF) + 0x10000);
                else {
                    // unmatched surrogate; only append this code unit, in case the next
                    // code unit is the high surrogate of a surrogate pair
                    output.push(value);
                    counter--;
                }
            } else output.push(value);
        }
        return output;
    }
    /**
	 * Creates a string based on an array of numeric code points.
	 * @see `punycode.ucs2.decode`
	 * @memberOf punycode.ucs2
	 * @name encode
	 * @param {Array} codePoints The array of numeric code points.
	 * @returns {String} The new Unicode string (UCS-2).
	 */ function ucs2encode(array) {
        return map(array, function(value) {
            var output = "";
            if (value > 0xFFFF) {
                value -= 0x10000;
                output += stringFromCharCode(value >>> 10 & 0x3FF | 0xD800);
                value = 0xDC00 | value & 0x3FF;
            }
            output += stringFromCharCode(value);
            return output;
        }).join("");
    }
    /**
	 * Converts a basic code point into a digit/integer.
	 * @see `digitToBasic()`
	 * @private
	 * @param {Number} codePoint The basic numeric code point value.
	 * @returns {Number} The numeric value of a basic code point (for use in
	 * representing integers) in the range `0` to `base - 1`, or `base` if
	 * the code point does not represent a value.
	 */ function basicToDigit(codePoint) {
        if (codePoint - 48 < 10) return codePoint - 22;
        if (codePoint - 65 < 26) return codePoint - 65;
        if (codePoint - 97 < 26) return codePoint - 97;
        return base;
    }
    /**
	 * Converts a digit/integer into a basic code point.
	 * @see `basicToDigit()`
	 * @private
	 * @param {Number} digit The numeric value of a basic code point.
	 * @returns {Number} The basic code point whose value (when used for
	 * representing integers) is `digit`, which needs to be in the range
	 * `0` to `base - 1`. If `flag` is non-zero, the uppercase form is
	 * used; else, the lowercase form is used. The behavior is undefined
	 * if `flag` is non-zero and `digit` has no uppercase form.
	 */ function digitToBasic(digit, flag) {
        //  0..25 map to ASCII a..z or A..Z
        // 26..35 map to ASCII 0..9
        return digit + 22 + 75 * (digit < 26) - ((flag != 0) << 5);
    }
    /**
	 * Bias adaptation function as per section 3.4 of RFC 3492.
	 * https://tools.ietf.org/html/rfc3492#section-3.4
	 * @private
	 */ function adapt(delta, numPoints, firstTime) {
        var k = 0;
        delta = firstTime ? floor(delta / damp) : delta >> 1;
        delta += floor(delta / numPoints);
        for(; delta > baseMinusTMin * tMax >> 1; k += base)delta = floor(delta / baseMinusTMin);
        return floor(k + (baseMinusTMin + 1) * delta / (delta + skew));
    }
    /**
	 * Converts a Punycode string of ASCII-only symbols to a string of Unicode
	 * symbols.
	 * @memberOf punycode
	 * @param {String} input The Punycode string of ASCII-only symbols.
	 * @returns {String} The resulting string of Unicode symbols.
	 */ function decode(input) {
        // Don't use UCS-2
        var output = [], inputLength = input.length, out, i = 0, n = initialN, bias = initialBias, basic, j, index, oldi, w, k, digit, t, /** Cached calculation results */ baseMinusT;
        // Handle the basic code points: let `basic` be the number of input code
        // points before the last delimiter, or `0` if there is none, then copy
        // the first basic code points to the output.
        basic = input.lastIndexOf(delimiter);
        if (basic < 0) basic = 0;
        for(j = 0; j < basic; ++j){
            // if it's not a basic code point
            if (input.charCodeAt(j) >= 0x80) error("not-basic");
            output.push(input.charCodeAt(j));
        }
        // Main decoding loop: start just after the last delimiter if any basic code
        // points were copied; start at the beginning otherwise.
        for(index = basic > 0 ? basic + 1 : 0; index < inputLength;){
            // `index` is the index of the next character to be consumed.
            // Decode a generalized variable-length integer into `delta`,
            // which gets added to `i`. The overflow checking is easier
            // if we increase `i` as we go, then subtract off its starting
            // value at the end to obtain `delta`.
            for(oldi = i, w = 1, k = base;; k += base){
                if (index >= inputLength) error("invalid-input");
                digit = basicToDigit(input.charCodeAt(index++));
                if (digit >= base || digit > floor((maxInt - i) / w)) error("overflow");
                i += digit * w;
                t = k <= bias ? tMin : k >= bias + tMax ? tMax : k - bias;
                if (digit < t) break;
                baseMinusT = base - t;
                if (w > floor(maxInt / baseMinusT)) error("overflow");
                w *= baseMinusT;
            }
            out = output.length + 1;
            bias = adapt(i - oldi, out, oldi == 0);
            // `i` was supposed to wrap around from `out` to `0`,
            // incrementing `n` each time, so we'll fix that now:
            if (floor(i / out) > maxInt - n) error("overflow");
            n += floor(i / out);
            i %= out;
            // Insert `n` at position `i` of the output
            output.splice(i++, 0, n);
        }
        return ucs2encode(output);
    }
    /**
	 * Converts a string of Unicode symbols (e.g. a domain name label) to a
	 * Punycode string of ASCII-only symbols.
	 * @memberOf punycode
	 * @param {String} input The string of Unicode symbols.
	 * @returns {String} The resulting Punycode string of ASCII-only symbols.
	 */ function encode(input) {
        var n, delta, handledCPCount, basicLength, bias, j, m, q, k, t, currentValue, output = [], /** `inputLength` will hold the number of code points in `input`. */ inputLength, /** Cached calculation results */ handledCPCountPlusOne, baseMinusT, qMinusT;
        // Convert the input in UCS-2 to Unicode
        input = ucs2decode(input);
        // Cache the length
        inputLength = input.length;
        // Initialize the state
        n = initialN;
        delta = 0;
        bias = initialBias;
        // Handle the basic code points
        for(j = 0; j < inputLength; ++j){
            currentValue = input[j];
            if (currentValue < 0x80) output.push(stringFromCharCode(currentValue));
        }
        handledCPCount = basicLength = output.length;
        // `handledCPCount` is the number of code points that have been handled;
        // `basicLength` is the number of basic code points.
        // Finish the basic string - if it is not empty - with a delimiter
        if (basicLength) output.push(delimiter);
        // Main encoding loop:
        while(handledCPCount < inputLength){
            // All non-basic code points < n have been handled already. Find the next
            // larger one:
            for(m = maxInt, j = 0; j < inputLength; ++j){
                currentValue = input[j];
                if (currentValue >= n && currentValue < m) m = currentValue;
            }
            // Increase `delta` enough to advance the decoder's <n,i> state to <m,0>,
            // but guard against overflow
            handledCPCountPlusOne = handledCPCount + 1;
            if (m - n > floor((maxInt - delta) / handledCPCountPlusOne)) error("overflow");
            delta += (m - n) * handledCPCountPlusOne;
            n = m;
            for(j = 0; j < inputLength; ++j){
                currentValue = input[j];
                if (currentValue < n && ++delta > maxInt) error("overflow");
                if (currentValue == n) {
                    // Represent delta as a generalized variable-length integer
                    for(q = delta, k = base;; k += base){
                        t = k <= bias ? tMin : k >= bias + tMax ? tMax : k - bias;
                        if (q < t) break;
                        qMinusT = q - t;
                        baseMinusT = base - t;
                        output.push(stringFromCharCode(digitToBasic(t + qMinusT % baseMinusT, 0)));
                        q = floor(qMinusT / baseMinusT);
                    }
                    output.push(stringFromCharCode(digitToBasic(q, 0)));
                    bias = adapt(delta, handledCPCountPlusOne, handledCPCount == basicLength);
                    delta = 0;
                    ++handledCPCount;
                }
            }
            ++delta;
            ++n;
        }
        return output.join("");
    }
    /**
	 * Converts a Punycode string representing a domain name or an email address
	 * to Unicode. Only the Punycoded parts of the input will be converted, i.e.
	 * it doesn't matter if you call it on a string that has already been
	 * converted to Unicode.
	 * @memberOf punycode
	 * @param {String} input The Punycoded domain name or email address to
	 * convert to Unicode.
	 * @returns {String} The Unicode representation of the given Punycode
	 * string.
	 */ function toUnicode(input) {
        return mapDomain(input, function(string) {
            return regexPunycode.test(string) ? decode(string.slice(4).toLowerCase()) : string;
        });
    }
    /**
	 * Converts a Unicode string representing a domain name or an email address to
	 * Punycode. Only the non-ASCII parts of the domain name will be converted,
	 * i.e. it doesn't matter if you call it with a domain that's already in
	 * ASCII.
	 * @memberOf punycode
	 * @param {String} input The domain name or email address to convert, as a
	 * Unicode string.
	 * @returns {String} The Punycode representation of the given domain name or
	 * email address.
	 */ function toASCII(input) {
        return mapDomain(input, function(string) {
            return regexNonASCII.test(string) ? "xn--" + encode(string) : string;
        });
    }
    /*--------------------------------------------------------------------------*/ /** Define the public API */ punycode = {
        /**
		 * A string representing the current Punycode.js version number.
		 * @memberOf punycode
		 * @type String
		 */ "version": "1.4.1",
        /**
		 * An object of methods to convert from JavaScript's internal character
		 * representation (UCS-2) to Unicode code points, and back.
		 * @see <https://mathiasbynens.be/notes/javascript-encoding>
		 * @memberOf punycode
		 * @type Object
		 */ "ucs2": {
            "decode": ucs2decode,
            "encode": ucs2encode
        },
        "decode": decode,
        "encode": encode,
        "toASCII": toASCII,
        "toUnicode": toUnicode
    };
    /** Expose `punycode` */ // Some AMD build optimizers, like r.js, check for specific condition patterns
    // like the following:
    if (typeof define == "function" && typeof define.amd == "object" && define.amd) define("punycode", function() {
        return punycode;
    });
    else if (freeExports && freeModule) {
        if (module.exports == freeExports) // in Node.js, io.js, or RingoJS v0.8.0+
        freeModule.exports = punycode;
        else // in Narwhal or RingoJS v0.7.0-
        for(key in punycode)punycode.hasOwnProperty(key) && (freeExports[key] = punycode[key]);
    } else // in Rhino or a web browser
    root.punycode = punycode;
})(this);

});

parcelRegister("emRzd", function(module, exports) {
"use strict";

var $fGFBp = parcelRequire("fGFBp");

var $l9gKj = parcelRequire("l9gKj");

var $5kWEx = parcelRequire("5kWEx");
module.exports = {
    formats: $5kWEx,
    parse: $l9gKj,
    stringify: $fGFBp
};

});
parcelRegister("fGFBp", function(module, exports) {
"use strict";

var $3kaiA = parcelRequire("3kaiA");

var $1NX32 = parcelRequire("1NX32");

var $5kWEx = parcelRequire("5kWEx");
var $b6bb0c9f7f23a6e1$var$has = Object.prototype.hasOwnProperty;
var $b6bb0c9f7f23a6e1$var$arrayPrefixGenerators = {
    brackets: function brackets(prefix) {
        return prefix + "[]";
    },
    comma: "comma",
    indices: function indices(prefix, key) {
        return prefix + "[" + key + "]";
    },
    repeat: function repeat(prefix) {
        return prefix;
    }
};
var $b6bb0c9f7f23a6e1$var$isArray = Array.isArray;
var $b6bb0c9f7f23a6e1$var$push = Array.prototype.push;
var $b6bb0c9f7f23a6e1$var$pushToArray = function(arr, valueOrArray) {
    $b6bb0c9f7f23a6e1$var$push.apply(arr, $b6bb0c9f7f23a6e1$var$isArray(valueOrArray) ? valueOrArray : [
        valueOrArray
    ]);
};
var $b6bb0c9f7f23a6e1$var$toISO = Date.prototype.toISOString;
var $b6bb0c9f7f23a6e1$var$defaultFormat = $5kWEx.default;
var $b6bb0c9f7f23a6e1$var$defaults = {
    addQueryPrefix: false,
    allowDots: false,
    charset: "utf-8",
    charsetSentinel: false,
    delimiter: "&",
    encode: true,
    encoder: $1NX32.encode,
    encodeValuesOnly: false,
    format: $b6bb0c9f7f23a6e1$var$defaultFormat,
    formatter: $5kWEx.formatters[$b6bb0c9f7f23a6e1$var$defaultFormat],
    // deprecated
    indices: false,
    serializeDate: function serializeDate(date) {
        return $b6bb0c9f7f23a6e1$var$toISO.call(date);
    },
    skipNulls: false,
    strictNullHandling: false
};
var $b6bb0c9f7f23a6e1$var$isNonNullishPrimitive = function isNonNullishPrimitive(v) {
    return typeof v === "string" || typeof v === "number" || typeof v === "boolean" || typeof v === "symbol" || typeof v === "bigint";
};
var $b6bb0c9f7f23a6e1$var$sentinel = {};
var $b6bb0c9f7f23a6e1$var$stringify = function stringify(object, prefix, generateArrayPrefix, commaRoundTrip, strictNullHandling, skipNulls, encoder, filter, sort, allowDots, serializeDate, format, formatter, encodeValuesOnly, charset, sideChannel) {
    var obj = object;
    var tmpSc = sideChannel;
    var step = 0;
    var findFlag = false;
    while((tmpSc = tmpSc.get($b6bb0c9f7f23a6e1$var$sentinel)) !== void 0 && !findFlag){
        // Where object last appeared in the ref tree
        var pos = tmpSc.get(object);
        step += 1;
        if (typeof pos !== "undefined") {
            if (pos === step) throw new RangeError("Cyclic object value");
            else findFlag = true; // Break while
        }
        if (typeof tmpSc.get($b6bb0c9f7f23a6e1$var$sentinel) === "undefined") step = 0;
    }
    if (typeof filter === "function") obj = filter(prefix, obj);
    else if (obj instanceof Date) obj = serializeDate(obj);
    else if (generateArrayPrefix === "comma" && $b6bb0c9f7f23a6e1$var$isArray(obj)) obj = $1NX32.maybeMap(obj, function(value) {
        if (value instanceof Date) return serializeDate(value);
        return value;
    });
    if (obj === null) {
        if (strictNullHandling) return encoder && !encodeValuesOnly ? encoder(prefix, $b6bb0c9f7f23a6e1$var$defaults.encoder, charset, "key", format) : prefix;
        obj = "";
    }
    if ($b6bb0c9f7f23a6e1$var$isNonNullishPrimitive(obj) || $1NX32.isBuffer(obj)) {
        if (encoder) {
            var keyValue = encodeValuesOnly ? prefix : encoder(prefix, $b6bb0c9f7f23a6e1$var$defaults.encoder, charset, "key", format);
            return [
                formatter(keyValue) + "=" + formatter(encoder(obj, $b6bb0c9f7f23a6e1$var$defaults.encoder, charset, "value", format))
            ];
        }
        return [
            formatter(prefix) + "=" + formatter(String(obj))
        ];
    }
    var values = [];
    if (typeof obj === "undefined") return values;
    var objKeys;
    if (generateArrayPrefix === "comma" && $b6bb0c9f7f23a6e1$var$isArray(obj)) {
        // we need to join elements in
        if (encodeValuesOnly && encoder) obj = $1NX32.maybeMap(obj, encoder);
        objKeys = [
            {
                value: obj.length > 0 ? obj.join(",") || null : void 0
            }
        ];
    } else if ($b6bb0c9f7f23a6e1$var$isArray(filter)) objKeys = filter;
    else {
        var keys = Object.keys(obj);
        objKeys = sort ? keys.sort(sort) : keys;
    }
    var adjustedPrefix = commaRoundTrip && $b6bb0c9f7f23a6e1$var$isArray(obj) && obj.length === 1 ? prefix + "[]" : prefix;
    for(var j = 0; j < objKeys.length; ++j){
        var key = objKeys[j];
        var value = typeof key === "object" && typeof key.value !== "undefined" ? key.value : obj[key];
        if (skipNulls && value === null) continue;
        var keyPrefix = $b6bb0c9f7f23a6e1$var$isArray(obj) ? typeof generateArrayPrefix === "function" ? generateArrayPrefix(adjustedPrefix, key) : adjustedPrefix : adjustedPrefix + (allowDots ? "." + key : "[" + key + "]");
        sideChannel.set(object, step);
        var valueSideChannel = $3kaiA();
        valueSideChannel.set($b6bb0c9f7f23a6e1$var$sentinel, sideChannel);
        $b6bb0c9f7f23a6e1$var$pushToArray(values, stringify(value, keyPrefix, generateArrayPrefix, commaRoundTrip, strictNullHandling, skipNulls, generateArrayPrefix === "comma" && encodeValuesOnly && $b6bb0c9f7f23a6e1$var$isArray(obj) ? null : encoder, filter, sort, allowDots, serializeDate, format, formatter, encodeValuesOnly, charset, valueSideChannel));
    }
    return values;
};
var $b6bb0c9f7f23a6e1$var$normalizeStringifyOptions = function normalizeStringifyOptions(opts) {
    if (!opts) return $b6bb0c9f7f23a6e1$var$defaults;
    if (opts.encoder !== null && typeof opts.encoder !== "undefined" && typeof opts.encoder !== "function") throw new TypeError("Encoder has to be a function.");
    var charset = opts.charset || $b6bb0c9f7f23a6e1$var$defaults.charset;
    if (typeof opts.charset !== "undefined" && opts.charset !== "utf-8" && opts.charset !== "iso-8859-1") throw new TypeError("The charset option must be either utf-8, iso-8859-1, or undefined");
    var format = $5kWEx.default;
    if (typeof opts.format !== "undefined") {
        if (!$b6bb0c9f7f23a6e1$var$has.call($5kWEx.formatters, opts.format)) throw new TypeError("Unknown format option provided.");
        format = opts.format;
    }
    var formatter = $5kWEx.formatters[format];
    var filter = $b6bb0c9f7f23a6e1$var$defaults.filter;
    if (typeof opts.filter === "function" || $b6bb0c9f7f23a6e1$var$isArray(opts.filter)) filter = opts.filter;
    return {
        addQueryPrefix: typeof opts.addQueryPrefix === "boolean" ? opts.addQueryPrefix : $b6bb0c9f7f23a6e1$var$defaults.addQueryPrefix,
        allowDots: typeof opts.allowDots === "undefined" ? $b6bb0c9f7f23a6e1$var$defaults.allowDots : !!opts.allowDots,
        charset: charset,
        charsetSentinel: typeof opts.charsetSentinel === "boolean" ? opts.charsetSentinel : $b6bb0c9f7f23a6e1$var$defaults.charsetSentinel,
        delimiter: typeof opts.delimiter === "undefined" ? $b6bb0c9f7f23a6e1$var$defaults.delimiter : opts.delimiter,
        encode: typeof opts.encode === "boolean" ? opts.encode : $b6bb0c9f7f23a6e1$var$defaults.encode,
        encoder: typeof opts.encoder === "function" ? opts.encoder : $b6bb0c9f7f23a6e1$var$defaults.encoder,
        encodeValuesOnly: typeof opts.encodeValuesOnly === "boolean" ? opts.encodeValuesOnly : $b6bb0c9f7f23a6e1$var$defaults.encodeValuesOnly,
        filter: filter,
        format: format,
        formatter: formatter,
        serializeDate: typeof opts.serializeDate === "function" ? opts.serializeDate : $b6bb0c9f7f23a6e1$var$defaults.serializeDate,
        skipNulls: typeof opts.skipNulls === "boolean" ? opts.skipNulls : $b6bb0c9f7f23a6e1$var$defaults.skipNulls,
        sort: typeof opts.sort === "function" ? opts.sort : null,
        strictNullHandling: typeof opts.strictNullHandling === "boolean" ? opts.strictNullHandling : $b6bb0c9f7f23a6e1$var$defaults.strictNullHandling
    };
};
module.exports = function(object, opts) {
    var obj = object;
    var options = $b6bb0c9f7f23a6e1$var$normalizeStringifyOptions(opts);
    var objKeys;
    var filter;
    if (typeof options.filter === "function") {
        filter = options.filter;
        obj = filter("", obj);
    } else if ($b6bb0c9f7f23a6e1$var$isArray(options.filter)) {
        filter = options.filter;
        objKeys = filter;
    }
    var keys = [];
    if (typeof obj !== "object" || obj === null) return "";
    var arrayFormat;
    if (opts && opts.arrayFormat in $b6bb0c9f7f23a6e1$var$arrayPrefixGenerators) arrayFormat = opts.arrayFormat;
    else if (opts && "indices" in opts) arrayFormat = opts.indices ? "indices" : "repeat";
    else arrayFormat = "indices";
    var generateArrayPrefix = $b6bb0c9f7f23a6e1$var$arrayPrefixGenerators[arrayFormat];
    if (opts && "commaRoundTrip" in opts && typeof opts.commaRoundTrip !== "boolean") throw new TypeError("`commaRoundTrip` must be a boolean, or absent");
    var commaRoundTrip = generateArrayPrefix === "comma" && opts && opts.commaRoundTrip;
    if (!objKeys) objKeys = Object.keys(obj);
    if (options.sort) objKeys.sort(options.sort);
    var sideChannel = $3kaiA();
    for(var i = 0; i < objKeys.length; ++i){
        var key = objKeys[i];
        if (options.skipNulls && obj[key] === null) continue;
        $b6bb0c9f7f23a6e1$var$pushToArray(keys, $b6bb0c9f7f23a6e1$var$stringify(obj[key], key, generateArrayPrefix, commaRoundTrip, options.strictNullHandling, options.skipNulls, options.encode ? options.encoder : null, options.filter, options.sort, options.allowDots, options.serializeDate, options.format, options.formatter, options.encodeValuesOnly, options.charset, sideChannel));
    }
    var joined = keys.join(options.delimiter);
    var prefix = options.addQueryPrefix === true ? "?" : "";
    if (options.charsetSentinel) {
        if (options.charset === "iso-8859-1") // encodeURIComponent('&#10003;'), the "numeric entity" representation of a checkmark
        prefix += "utf8=%26%2310003%3B&";
        else // encodeURIComponent('✓')
        prefix += "utf8=%E2%9C%93&";
    }
    return joined.length > 0 ? prefix + joined : "";
};

});
parcelRegister("3kaiA", function(module, exports) {
"use strict";

var $bcSjm = parcelRequire("bcSjm");

var $hM5KX = parcelRequire("hM5KX");

var $3lTif = parcelRequire("3lTif");
var $26bb3a7bd51d55ef$var$$TypeError = $bcSjm("%TypeError%");
var $26bb3a7bd51d55ef$var$$WeakMap = $bcSjm("%WeakMap%", true);
var $26bb3a7bd51d55ef$var$$Map = $bcSjm("%Map%", true);
var $26bb3a7bd51d55ef$var$$weakMapGet = $hM5KX("WeakMap.prototype.get", true);
var $26bb3a7bd51d55ef$var$$weakMapSet = $hM5KX("WeakMap.prototype.set", true);
var $26bb3a7bd51d55ef$var$$weakMapHas = $hM5KX("WeakMap.prototype.has", true);
var $26bb3a7bd51d55ef$var$$mapGet = $hM5KX("Map.prototype.get", true);
var $26bb3a7bd51d55ef$var$$mapSet = $hM5KX("Map.prototype.set", true);
var $26bb3a7bd51d55ef$var$$mapHas = $hM5KX("Map.prototype.has", true);
/*
 * This function traverses the list returning the node corresponding to the
 * given key.
 *
 * That node is also moved to the head of the list, so that if it's accessed
 * again we don't need to traverse the whole list. By doing so, all the recently
 * used nodes can be accessed relatively quickly.
 */ var $26bb3a7bd51d55ef$var$listGetNode = function(list, key) {
    for(var prev = list, curr; (curr = prev.next) !== null; prev = curr)if (curr.key === key) {
        prev.next = curr.next;
        curr.next = list.next;
        list.next = curr; // eslint-disable-line no-param-reassign
        return curr;
    }
};
var $26bb3a7bd51d55ef$var$listGet = function(objects, key) {
    var node = $26bb3a7bd51d55ef$var$listGetNode(objects, key);
    return node && node.value;
};
var $26bb3a7bd51d55ef$var$listSet = function(objects, key, value) {
    var node = $26bb3a7bd51d55ef$var$listGetNode(objects, key);
    if (node) node.value = value;
    else // Prepend the new node to the beginning of the list
    objects.next = {
        key: key,
        next: objects.next,
        value: value
    };
};
var $26bb3a7bd51d55ef$var$listHas = function(objects, key) {
    return !!$26bb3a7bd51d55ef$var$listGetNode(objects, key);
};
module.exports = function getSideChannel() {
    var $wm;
    var $m;
    var $o;
    var channel = {
        assert: function(key) {
            if (!channel.has(key)) throw new $26bb3a7bd51d55ef$var$$TypeError("Side channel does not contain " + $3lTif(key));
        },
        get: function(key) {
            if ($26bb3a7bd51d55ef$var$$WeakMap && key && (typeof key === "object" || typeof key === "function")) {
                if ($wm) return $26bb3a7bd51d55ef$var$$weakMapGet($wm, key);
            } else if ($26bb3a7bd51d55ef$var$$Map) {
                if ($m) return $26bb3a7bd51d55ef$var$$mapGet($m, key);
            } else {
                if ($o) return $26bb3a7bd51d55ef$var$listGet($o, key);
            }
        },
        has: function(key) {
            if ($26bb3a7bd51d55ef$var$$WeakMap && key && (typeof key === "object" || typeof key === "function")) {
                if ($wm) return $26bb3a7bd51d55ef$var$$weakMapHas($wm, key);
            } else if ($26bb3a7bd51d55ef$var$$Map) {
                if ($m) return $26bb3a7bd51d55ef$var$$mapHas($m, key);
            } else {
                if ($o) return $26bb3a7bd51d55ef$var$listHas($o, key);
            }
            return false;
        },
        set: function(key, value) {
            if ($26bb3a7bd51d55ef$var$$WeakMap && key && (typeof key === "object" || typeof key === "function")) {
                if (!$wm) $wm = new $26bb3a7bd51d55ef$var$$WeakMap();
                $26bb3a7bd51d55ef$var$$weakMapSet($wm, key, value);
            } else if ($26bb3a7bd51d55ef$var$$Map) {
                if (!$m) $m = new $26bb3a7bd51d55ef$var$$Map();
                $26bb3a7bd51d55ef$var$$mapSet($m, key, value);
            } else {
                if (!$o) /*
					 * Initialize the linked list as an empty node, so that we don't have
					 * to special-case handling of the first node: we can always refer to
					 * it as (previous node).next, instead of something like (list).head
					 */ $o = {
                    key: {},
                    next: null
                };
                $26bb3a7bd51d55ef$var$listSet($o, key, value);
            }
        }
    };
    return channel;
};

});
parcelRegister("bcSjm", function(module, exports) {
"use strict";
var $828af1c4bfd6cf1c$var$undefined1;
var $828af1c4bfd6cf1c$var$$SyntaxError = SyntaxError;
var $828af1c4bfd6cf1c$var$$Function = Function;
var $828af1c4bfd6cf1c$var$$TypeError = TypeError;
// eslint-disable-next-line consistent-return
var $828af1c4bfd6cf1c$var$getEvalledConstructor = function(expressionSyntax) {
    try {
        return $828af1c4bfd6cf1c$var$$Function('"use strict"; return (' + expressionSyntax + ").constructor;")();
    } catch (e) {}
};
var $828af1c4bfd6cf1c$var$$gOPD = Object.getOwnPropertyDescriptor;
if ($828af1c4bfd6cf1c$var$$gOPD) try {
    $828af1c4bfd6cf1c$var$$gOPD({}, "");
} catch (e) {
    $828af1c4bfd6cf1c$var$$gOPD = null; // this is IE 8, which has a broken gOPD
}
var $828af1c4bfd6cf1c$var$throwTypeError = function() {
    throw new $828af1c4bfd6cf1c$var$$TypeError();
};
var $828af1c4bfd6cf1c$var$ThrowTypeError = $828af1c4bfd6cf1c$var$$gOPD ? function() {
    try {
        // eslint-disable-next-line no-unused-expressions, no-caller, no-restricted-properties
        arguments.callee; // IE 8 does not throw here
        return $828af1c4bfd6cf1c$var$throwTypeError;
    } catch (calleeThrows) {
        try {
            // IE 8 throws on Object.getOwnPropertyDescriptor(arguments, '')
            return $828af1c4bfd6cf1c$var$$gOPD(arguments, "callee").get;
        } catch (gOPDthrows) {
            return $828af1c4bfd6cf1c$var$throwTypeError;
        }
    }
}() : $828af1c4bfd6cf1c$var$throwTypeError;

var $828af1c4bfd6cf1c$var$hasSymbols = (parcelRequire("iX2fd"))();

var $828af1c4bfd6cf1c$var$hasProto = (parcelRequire("9xD0l"))();
var $828af1c4bfd6cf1c$var$getProto = Object.getPrototypeOf || ($828af1c4bfd6cf1c$var$hasProto ? function(x) {
    return x.__proto__;
} // eslint-disable-line no-proto
 : null);
var $828af1c4bfd6cf1c$var$needsEval = {};
var $828af1c4bfd6cf1c$var$TypedArray = typeof Uint8Array === "undefined" || !$828af1c4bfd6cf1c$var$getProto ? undefined : $828af1c4bfd6cf1c$var$getProto(Uint8Array);
var $828af1c4bfd6cf1c$var$INTRINSICS = {
    "%AggregateError%": typeof AggregateError === "undefined" ? undefined : AggregateError,
    "%Array%": Array,
    "%ArrayBuffer%": typeof ArrayBuffer === "undefined" ? undefined : ArrayBuffer,
    "%ArrayIteratorPrototype%": $828af1c4bfd6cf1c$var$hasSymbols && $828af1c4bfd6cf1c$var$getProto ? $828af1c4bfd6cf1c$var$getProto([][Symbol.iterator]()) : undefined,
    "%AsyncFromSyncIteratorPrototype%": undefined,
    "%AsyncFunction%": $828af1c4bfd6cf1c$var$needsEval,
    "%AsyncGenerator%": $828af1c4bfd6cf1c$var$needsEval,
    "%AsyncGeneratorFunction%": $828af1c4bfd6cf1c$var$needsEval,
    "%AsyncIteratorPrototype%": $828af1c4bfd6cf1c$var$needsEval,
    "%Atomics%": typeof Atomics === "undefined" ? undefined : Atomics,
    "%BigInt%": typeof BigInt === "undefined" ? undefined : BigInt,
    "%BigInt64Array%": typeof BigInt64Array === "undefined" ? undefined : BigInt64Array,
    "%BigUint64Array%": typeof BigUint64Array === "undefined" ? undefined : BigUint64Array,
    "%Boolean%": Boolean,
    "%DataView%": typeof DataView === "undefined" ? undefined : DataView,
    "%Date%": Date,
    "%decodeURI%": decodeURI,
    "%decodeURIComponent%": decodeURIComponent,
    "%encodeURI%": encodeURI,
    "%encodeURIComponent%": encodeURIComponent,
    "%Error%": Error,
    "%eval%": eval,
    "%EvalError%": EvalError,
    "%Float32Array%": typeof Float32Array === "undefined" ? undefined : Float32Array,
    "%Float64Array%": typeof Float64Array === "undefined" ? undefined : Float64Array,
    "%FinalizationRegistry%": typeof FinalizationRegistry === "undefined" ? undefined : FinalizationRegistry,
    "%Function%": $828af1c4bfd6cf1c$var$$Function,
    "%GeneratorFunction%": $828af1c4bfd6cf1c$var$needsEval,
    "%Int8Array%": typeof Int8Array === "undefined" ? undefined : Int8Array,
    "%Int16Array%": typeof Int16Array === "undefined" ? undefined : Int16Array,
    "%Int32Array%": typeof Int32Array === "undefined" ? undefined : Int32Array,
    "%isFinite%": isFinite,
    "%isNaN%": isNaN,
    "%IteratorPrototype%": $828af1c4bfd6cf1c$var$hasSymbols && $828af1c4bfd6cf1c$var$getProto ? $828af1c4bfd6cf1c$var$getProto($828af1c4bfd6cf1c$var$getProto([][Symbol.iterator]())) : undefined,
    "%JSON%": typeof JSON === "object" ? JSON : undefined,
    "%Map%": typeof Map === "undefined" ? undefined : Map,
    "%MapIteratorPrototype%": typeof Map === "undefined" || !$828af1c4bfd6cf1c$var$hasSymbols || !$828af1c4bfd6cf1c$var$getProto ? undefined : $828af1c4bfd6cf1c$var$getProto(new Map()[Symbol.iterator]()),
    "%Math%": Math,
    "%Number%": Number,
    "%Object%": Object,
    "%parseFloat%": parseFloat,
    "%parseInt%": parseInt,
    "%Promise%": typeof Promise === "undefined" ? undefined : Promise,
    "%Proxy%": typeof Proxy === "undefined" ? undefined : Proxy,
    "%RangeError%": RangeError,
    "%ReferenceError%": ReferenceError,
    "%Reflect%": typeof Reflect === "undefined" ? undefined : Reflect,
    "%RegExp%": RegExp,
    "%Set%": typeof Set === "undefined" ? undefined : Set,
    "%SetIteratorPrototype%": typeof Set === "undefined" || !$828af1c4bfd6cf1c$var$hasSymbols || !$828af1c4bfd6cf1c$var$getProto ? undefined : $828af1c4bfd6cf1c$var$getProto(new Set()[Symbol.iterator]()),
    "%SharedArrayBuffer%": typeof SharedArrayBuffer === "undefined" ? undefined : SharedArrayBuffer,
    "%String%": String,
    "%StringIteratorPrototype%": $828af1c4bfd6cf1c$var$hasSymbols && $828af1c4bfd6cf1c$var$getProto ? $828af1c4bfd6cf1c$var$getProto(""[Symbol.iterator]()) : undefined,
    "%Symbol%": $828af1c4bfd6cf1c$var$hasSymbols ? Symbol : undefined,
    "%SyntaxError%": $828af1c4bfd6cf1c$var$$SyntaxError,
    "%ThrowTypeError%": $828af1c4bfd6cf1c$var$ThrowTypeError,
    "%TypedArray%": $828af1c4bfd6cf1c$var$TypedArray,
    "%TypeError%": $828af1c4bfd6cf1c$var$$TypeError,
    "%Uint8Array%": typeof Uint8Array === "undefined" ? undefined : Uint8Array,
    "%Uint8ClampedArray%": typeof Uint8ClampedArray === "undefined" ? undefined : Uint8ClampedArray,
    "%Uint16Array%": typeof Uint16Array === "undefined" ? undefined : Uint16Array,
    "%Uint32Array%": typeof Uint32Array === "undefined" ? undefined : Uint32Array,
    "%URIError%": URIError,
    "%WeakMap%": typeof WeakMap === "undefined" ? undefined : WeakMap,
    "%WeakRef%": typeof WeakRef === "undefined" ? undefined : WeakRef,
    "%WeakSet%": typeof WeakSet === "undefined" ? undefined : WeakSet
};
if ($828af1c4bfd6cf1c$var$getProto) try {
    null.error; // eslint-disable-line no-unused-expressions
} catch (e) {
    // https://github.com/tc39/proposal-shadowrealm/pull/384#issuecomment-1364264229
    var $828af1c4bfd6cf1c$var$errorProto = $828af1c4bfd6cf1c$var$getProto($828af1c4bfd6cf1c$var$getProto(e));
    $828af1c4bfd6cf1c$var$INTRINSICS["%Error.prototype%"] = $828af1c4bfd6cf1c$var$errorProto;
}
var $828af1c4bfd6cf1c$var$doEval = function doEval(name) {
    var value;
    if (name === "%AsyncFunction%") value = $828af1c4bfd6cf1c$var$getEvalledConstructor("async function () {}");
    else if (name === "%GeneratorFunction%") value = $828af1c4bfd6cf1c$var$getEvalledConstructor("function* () {}");
    else if (name === "%AsyncGeneratorFunction%") value = $828af1c4bfd6cf1c$var$getEvalledConstructor("async function* () {}");
    else if (name === "%AsyncGenerator%") {
        var fn = doEval("%AsyncGeneratorFunction%");
        if (fn) value = fn.prototype;
    } else if (name === "%AsyncIteratorPrototype%") {
        var gen = doEval("%AsyncGenerator%");
        if (gen && $828af1c4bfd6cf1c$var$getProto) value = $828af1c4bfd6cf1c$var$getProto(gen.prototype);
    }
    $828af1c4bfd6cf1c$var$INTRINSICS[name] = value;
    return value;
};
var $828af1c4bfd6cf1c$var$LEGACY_ALIASES = {
    "%ArrayBufferPrototype%": [
        "ArrayBuffer",
        "prototype"
    ],
    "%ArrayPrototype%": [
        "Array",
        "prototype"
    ],
    "%ArrayProto_entries%": [
        "Array",
        "prototype",
        "entries"
    ],
    "%ArrayProto_forEach%": [
        "Array",
        "prototype",
        "forEach"
    ],
    "%ArrayProto_keys%": [
        "Array",
        "prototype",
        "keys"
    ],
    "%ArrayProto_values%": [
        "Array",
        "prototype",
        "values"
    ],
    "%AsyncFunctionPrototype%": [
        "AsyncFunction",
        "prototype"
    ],
    "%AsyncGenerator%": [
        "AsyncGeneratorFunction",
        "prototype"
    ],
    "%AsyncGeneratorPrototype%": [
        "AsyncGeneratorFunction",
        "prototype",
        "prototype"
    ],
    "%BooleanPrototype%": [
        "Boolean",
        "prototype"
    ],
    "%DataViewPrototype%": [
        "DataView",
        "prototype"
    ],
    "%DatePrototype%": [
        "Date",
        "prototype"
    ],
    "%ErrorPrototype%": [
        "Error",
        "prototype"
    ],
    "%EvalErrorPrototype%": [
        "EvalError",
        "prototype"
    ],
    "%Float32ArrayPrototype%": [
        "Float32Array",
        "prototype"
    ],
    "%Float64ArrayPrototype%": [
        "Float64Array",
        "prototype"
    ],
    "%FunctionPrototype%": [
        "Function",
        "prototype"
    ],
    "%Generator%": [
        "GeneratorFunction",
        "prototype"
    ],
    "%GeneratorPrototype%": [
        "GeneratorFunction",
        "prototype",
        "prototype"
    ],
    "%Int8ArrayPrototype%": [
        "Int8Array",
        "prototype"
    ],
    "%Int16ArrayPrototype%": [
        "Int16Array",
        "prototype"
    ],
    "%Int32ArrayPrototype%": [
        "Int32Array",
        "prototype"
    ],
    "%JSONParse%": [
        "JSON",
        "parse"
    ],
    "%JSONStringify%": [
        "JSON",
        "stringify"
    ],
    "%MapPrototype%": [
        "Map",
        "prototype"
    ],
    "%NumberPrototype%": [
        "Number",
        "prototype"
    ],
    "%ObjectPrototype%": [
        "Object",
        "prototype"
    ],
    "%ObjProto_toString%": [
        "Object",
        "prototype",
        "toString"
    ],
    "%ObjProto_valueOf%": [
        "Object",
        "prototype",
        "valueOf"
    ],
    "%PromisePrototype%": [
        "Promise",
        "prototype"
    ],
    "%PromiseProto_then%": [
        "Promise",
        "prototype",
        "then"
    ],
    "%Promise_all%": [
        "Promise",
        "all"
    ],
    "%Promise_reject%": [
        "Promise",
        "reject"
    ],
    "%Promise_resolve%": [
        "Promise",
        "resolve"
    ],
    "%RangeErrorPrototype%": [
        "RangeError",
        "prototype"
    ],
    "%ReferenceErrorPrototype%": [
        "ReferenceError",
        "prototype"
    ],
    "%RegExpPrototype%": [
        "RegExp",
        "prototype"
    ],
    "%SetPrototype%": [
        "Set",
        "prototype"
    ],
    "%SharedArrayBufferPrototype%": [
        "SharedArrayBuffer",
        "prototype"
    ],
    "%StringPrototype%": [
        "String",
        "prototype"
    ],
    "%SymbolPrototype%": [
        "Symbol",
        "prototype"
    ],
    "%SyntaxErrorPrototype%": [
        "SyntaxError",
        "prototype"
    ],
    "%TypedArrayPrototype%": [
        "TypedArray",
        "prototype"
    ],
    "%TypeErrorPrototype%": [
        "TypeError",
        "prototype"
    ],
    "%Uint8ArrayPrototype%": [
        "Uint8Array",
        "prototype"
    ],
    "%Uint8ClampedArrayPrototype%": [
        "Uint8ClampedArray",
        "prototype"
    ],
    "%Uint16ArrayPrototype%": [
        "Uint16Array",
        "prototype"
    ],
    "%Uint32ArrayPrototype%": [
        "Uint32Array",
        "prototype"
    ],
    "%URIErrorPrototype%": [
        "URIError",
        "prototype"
    ],
    "%WeakMapPrototype%": [
        "WeakMap",
        "prototype"
    ],
    "%WeakSetPrototype%": [
        "WeakSet",
        "prototype"
    ]
};

var $7UXlv = parcelRequire("7UXlv");

var $bvUCU = parcelRequire("bvUCU");
var $828af1c4bfd6cf1c$var$$concat = $7UXlv.call(Function.call, Array.prototype.concat);
var $828af1c4bfd6cf1c$var$$spliceApply = $7UXlv.call(Function.apply, Array.prototype.splice);
var $828af1c4bfd6cf1c$var$$replace = $7UXlv.call(Function.call, String.prototype.replace);
var $828af1c4bfd6cf1c$var$$strSlice = $7UXlv.call(Function.call, String.prototype.slice);
var $828af1c4bfd6cf1c$var$$exec = $7UXlv.call(Function.call, RegExp.prototype.exec);
/* adapted from https://github.com/lodash/lodash/blob/4.17.15/dist/lodash.js#L6735-L6744 */ var $828af1c4bfd6cf1c$var$rePropName = /[^%.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|%$))/g;
var $828af1c4bfd6cf1c$var$reEscapeChar = /\\(\\)?/g; /** Used to match backslashes in property paths. */ 
var $828af1c4bfd6cf1c$var$stringToPath = function stringToPath(string) {
    var first = $828af1c4bfd6cf1c$var$$strSlice(string, 0, 1);
    var last = $828af1c4bfd6cf1c$var$$strSlice(string, -1);
    if (first === "%" && last !== "%") throw new $828af1c4bfd6cf1c$var$$SyntaxError("invalid intrinsic syntax, expected closing `%`");
    else if (last === "%" && first !== "%") throw new $828af1c4bfd6cf1c$var$$SyntaxError("invalid intrinsic syntax, expected opening `%`");
    var result = [];
    $828af1c4bfd6cf1c$var$$replace(string, $828af1c4bfd6cf1c$var$rePropName, function(match, number, quote, subString) {
        result[result.length] = quote ? $828af1c4bfd6cf1c$var$$replace(subString, $828af1c4bfd6cf1c$var$reEscapeChar, "$1") : number || match;
    });
    return result;
};
/* end adaptation */ var $828af1c4bfd6cf1c$var$getBaseIntrinsic = function getBaseIntrinsic(name, allowMissing) {
    var intrinsicName = name;
    var alias;
    if ($bvUCU($828af1c4bfd6cf1c$var$LEGACY_ALIASES, intrinsicName)) {
        alias = $828af1c4bfd6cf1c$var$LEGACY_ALIASES[intrinsicName];
        intrinsicName = "%" + alias[0] + "%";
    }
    if ($bvUCU($828af1c4bfd6cf1c$var$INTRINSICS, intrinsicName)) {
        var value = $828af1c4bfd6cf1c$var$INTRINSICS[intrinsicName];
        if (value === $828af1c4bfd6cf1c$var$needsEval) value = $828af1c4bfd6cf1c$var$doEval(intrinsicName);
        if (typeof value === "undefined" && !allowMissing) throw new $828af1c4bfd6cf1c$var$$TypeError("intrinsic " + name + " exists, but is not available. Please file an issue!");
        return {
            alias: alias,
            name: intrinsicName,
            value: value
        };
    }
    throw new $828af1c4bfd6cf1c$var$$SyntaxError("intrinsic " + name + " does not exist!");
};
module.exports = function GetIntrinsic(name, allowMissing) {
    if (typeof name !== "string" || name.length === 0) throw new $828af1c4bfd6cf1c$var$$TypeError("intrinsic name must be a non-empty string");
    if (arguments.length > 1 && typeof allowMissing !== "boolean") throw new $828af1c4bfd6cf1c$var$$TypeError('"allowMissing" argument must be a boolean');
    if ($828af1c4bfd6cf1c$var$$exec(/^%?[^%]*%?$/, name) === null) throw new $828af1c4bfd6cf1c$var$$SyntaxError("`%` may not be present anywhere but at the beginning and end of the intrinsic name");
    var parts = $828af1c4bfd6cf1c$var$stringToPath(name);
    var intrinsicBaseName = parts.length > 0 ? parts[0] : "";
    var intrinsic = $828af1c4bfd6cf1c$var$getBaseIntrinsic("%" + intrinsicBaseName + "%", allowMissing);
    var intrinsicRealName = intrinsic.name;
    var value = intrinsic.value;
    var skipFurtherCaching = false;
    var alias = intrinsic.alias;
    if (alias) {
        intrinsicBaseName = alias[0];
        $828af1c4bfd6cf1c$var$$spliceApply(parts, $828af1c4bfd6cf1c$var$$concat([
            0,
            1
        ], alias));
    }
    for(var i = 1, isOwn = true; i < parts.length; i += 1){
        var part = parts[i];
        var first = $828af1c4bfd6cf1c$var$$strSlice(part, 0, 1);
        var last = $828af1c4bfd6cf1c$var$$strSlice(part, -1);
        if ((first === '"' || first === "'" || first === "`" || last === '"' || last === "'" || last === "`") && first !== last) throw new $828af1c4bfd6cf1c$var$$SyntaxError("property names with quotes must have matching quotes");
        if (part === "constructor" || !isOwn) skipFurtherCaching = true;
        intrinsicBaseName += "." + part;
        intrinsicRealName = "%" + intrinsicBaseName + "%";
        if ($bvUCU($828af1c4bfd6cf1c$var$INTRINSICS, intrinsicRealName)) value = $828af1c4bfd6cf1c$var$INTRINSICS[intrinsicRealName];
        else if (value != null) {
            if (!(part in value)) {
                if (!allowMissing) throw new $828af1c4bfd6cf1c$var$$TypeError("base intrinsic for " + name + " exists, but the property is not available.");
                return void 0;
            }
            if ($828af1c4bfd6cf1c$var$$gOPD && i + 1 >= parts.length) {
                var desc = $828af1c4bfd6cf1c$var$$gOPD(value, part);
                isOwn = !!desc;
                // By convention, when a data property is converted to an accessor
                // property to emulate a data property that does not suffer from
                // the override mistake, that accessor's getter is marked with
                // an `originalValue` property. Here, when we detect this, we
                // uphold the illusion by pretending to see that original data
                // property, i.e., returning the value rather than the getter
                // itself.
                if (isOwn && "get" in desc && !("originalValue" in desc.get)) value = desc.get;
                else value = value[part];
            } else {
                isOwn = $bvUCU(value, part);
                value = value[part];
            }
            if (isOwn && !skipFurtherCaching) $828af1c4bfd6cf1c$var$INTRINSICS[intrinsicRealName] = value;
        }
    }
    return value;
};

});
parcelRegister("iX2fd", function(module, exports) {
"use strict";
var $dcbf7a5a25399b1d$var$origSymbol = typeof Symbol !== "undefined" && Symbol;

var $a9FZQ = parcelRequire("a9FZQ");
module.exports = function hasNativeSymbols() {
    if (typeof $dcbf7a5a25399b1d$var$origSymbol !== "function") return false;
    if (typeof Symbol !== "function") return false;
    if (typeof $dcbf7a5a25399b1d$var$origSymbol("foo") !== "symbol") return false;
    if (typeof Symbol("bar") !== "symbol") return false;
    return $a9FZQ();
};

});
parcelRegister("a9FZQ", function(module, exports) {
"use strict";
/* eslint complexity: [2, 18], max-statements: [2, 33] */ module.exports = function hasSymbols() {
    if (typeof Symbol !== "function" || typeof Object.getOwnPropertySymbols !== "function") return false;
    if (typeof Symbol.iterator === "symbol") return true;
    var obj = {};
    var sym = Symbol("test");
    var symObj = Object(sym);
    if (typeof sym === "string") return false;
    if (Object.prototype.toString.call(sym) !== "[object Symbol]") return false;
    if (Object.prototype.toString.call(symObj) !== "[object Symbol]") return false;
    // temp disabled per https://github.com/ljharb/object.assign/issues/17
    // if (sym instanceof Symbol) { return false; }
    // temp disabled per https://github.com/WebReflection/get-own-property-symbols/issues/4
    // if (!(symObj instanceof Symbol)) { return false; }
    // if (typeof Symbol.prototype.toString !== 'function') { return false; }
    // if (String(sym) !== Symbol.prototype.toString.call(sym)) { return false; }
    var symVal = 42;
    obj[sym] = symVal;
    for(sym in obj)return false;
     // eslint-disable-line no-restricted-syntax, no-unreachable-loop
    if (typeof Object.keys === "function" && Object.keys(obj).length !== 0) return false;
    if (typeof Object.getOwnPropertyNames === "function" && Object.getOwnPropertyNames(obj).length !== 0) return false;
    var syms = Object.getOwnPropertySymbols(obj);
    if (syms.length !== 1 || syms[0] !== sym) return false;
    if (!Object.prototype.propertyIsEnumerable.call(obj, sym)) return false;
    if (typeof Object.getOwnPropertyDescriptor === "function") {
        var descriptor = Object.getOwnPropertyDescriptor(obj, sym);
        if (descriptor.value !== symVal || descriptor.enumerable !== true) return false;
    }
    return true;
};

});


parcelRegister("9xD0l", function(module, exports) {
"use strict";
var $6f25739bdbc3dc04$var$test = {
    foo: {}
};
var $6f25739bdbc3dc04$var$$Object = Object;
module.exports = function hasProto() {
    return ({
        __proto__: $6f25739bdbc3dc04$var$test
    }).foo === $6f25739bdbc3dc04$var$test.foo && !(({
        __proto__: null
    }) instanceof $6f25739bdbc3dc04$var$$Object);
};

});

parcelRegister("7UXlv", function(module, exports) {
"use strict";

var $5lmjX = parcelRequire("5lmjX");
module.exports = Function.prototype.bind || $5lmjX;

});
parcelRegister("5lmjX", function(module, exports) {
"use strict";
/* eslint no-invalid-this: 1 */ var $3e403a67f45fc3cc$var$ERROR_MESSAGE = "Function.prototype.bind called on incompatible ";
var $3e403a67f45fc3cc$var$toStr = Object.prototype.toString;
var $3e403a67f45fc3cc$var$max = Math.max;
var $3e403a67f45fc3cc$var$funcType = "[object Function]";
var $3e403a67f45fc3cc$var$concatty = function concatty(a, b) {
    var arr = [];
    for(var i = 0; i < a.length; i += 1)arr[i] = a[i];
    for(var j = 0; j < b.length; j += 1)arr[j + a.length] = b[j];
    return arr;
};
var $3e403a67f45fc3cc$var$slicy = function slicy(arrLike, offset) {
    var arr = [];
    for(var i = offset || 0, j = 0; i < arrLike.length; i += 1, j += 1)arr[j] = arrLike[i];
    return arr;
};
var $3e403a67f45fc3cc$var$joiny = function(arr, joiner) {
    var str = "";
    for(var i = 0; i < arr.length; i += 1){
        str += arr[i];
        if (i + 1 < arr.length) str += joiner;
    }
    return str;
};
module.exports = function bind(that) {
    var target = this;
    if (typeof target !== "function" || $3e403a67f45fc3cc$var$toStr.apply(target) !== $3e403a67f45fc3cc$var$funcType) throw new TypeError($3e403a67f45fc3cc$var$ERROR_MESSAGE + target);
    var args = $3e403a67f45fc3cc$var$slicy(arguments, 1);
    var bound;
    var binder = function() {
        if (this instanceof bound) {
            var result = target.apply(this, $3e403a67f45fc3cc$var$concatty(args, arguments));
            if (Object(result) === result) return result;
            return this;
        }
        return target.apply(that, $3e403a67f45fc3cc$var$concatty(args, arguments));
    };
    var boundLength = $3e403a67f45fc3cc$var$max(0, target.length - args.length);
    var boundArgs = [];
    for(var i = 0; i < boundLength; i++)boundArgs[i] = "$" + i;
    bound = Function("binder", "return function (" + $3e403a67f45fc3cc$var$joiny(boundArgs, ",") + "){ return binder.apply(this,arguments); }")(binder);
    if (target.prototype) {
        var Empty = function Empty() {};
        Empty.prototype = target.prototype;
        bound.prototype = new Empty();
        Empty.prototype = null;
    }
    return bound;
};

});


parcelRegister("bvUCU", function(module, exports) {
"use strict";
var $861e83cfa20d97c8$var$hasOwnProperty = {}.hasOwnProperty;
var $861e83cfa20d97c8$var$call = Function.prototype.call;
module.exports = $861e83cfa20d97c8$var$call.bind ? $861e83cfa20d97c8$var$call.bind($861e83cfa20d97c8$var$hasOwnProperty) : function(O, P) {
    return $861e83cfa20d97c8$var$call.call($861e83cfa20d97c8$var$hasOwnProperty, O, P);
};

});


parcelRegister("hM5KX", function(module, exports) {
"use strict";

var $bcSjm = parcelRequire("bcSjm");

var $jkQ8q = parcelRequire("jkQ8q");
var $cf0b6273c0c1e657$var$$indexOf = $jkQ8q($bcSjm("String.prototype.indexOf"));
module.exports = function callBoundIntrinsic(name, allowMissing) {
    var intrinsic = $bcSjm(name, !!allowMissing);
    if (typeof intrinsic === "function" && $cf0b6273c0c1e657$var$$indexOf(name, ".prototype.") > -1) return $jkQ8q(intrinsic);
    return intrinsic;
};

});
parcelRegister("jkQ8q", function(module, exports) {
"use strict";

var $7UXlv = parcelRequire("7UXlv");

var $bcSjm = parcelRequire("bcSjm");
var $e138537b8a4dabe8$var$$apply = $bcSjm("%Function.prototype.apply%");
var $e138537b8a4dabe8$var$$call = $bcSjm("%Function.prototype.call%");
var $e138537b8a4dabe8$var$$reflectApply = $bcSjm("%Reflect.apply%", true) || $7UXlv.call($e138537b8a4dabe8$var$$call, $e138537b8a4dabe8$var$$apply);
var $e138537b8a4dabe8$var$$gOPD = $bcSjm("%Object.getOwnPropertyDescriptor%", true);
var $e138537b8a4dabe8$var$$defineProperty = $bcSjm("%Object.defineProperty%", true);
var $e138537b8a4dabe8$var$$max = $bcSjm("%Math.max%");
if ($e138537b8a4dabe8$var$$defineProperty) try {
    $e138537b8a4dabe8$var$$defineProperty({}, "a", {
        value: 1
    });
} catch (e) {
    // IE 8 has a broken defineProperty
    $e138537b8a4dabe8$var$$defineProperty = null;
}
module.exports = function callBind(originalFunction) {
    var func = $e138537b8a4dabe8$var$$reflectApply($7UXlv, $e138537b8a4dabe8$var$$call, arguments);
    if ($e138537b8a4dabe8$var$$gOPD && $e138537b8a4dabe8$var$$defineProperty) {
        var desc = $e138537b8a4dabe8$var$$gOPD(func, "length");
        if (desc.configurable) // original length, plus the receiver, minus any additional arguments (after the receiver)
        $e138537b8a4dabe8$var$$defineProperty(func, "length", {
            value: 1 + $e138537b8a4dabe8$var$$max(0, originalFunction.length - (arguments.length - 1))
        });
    }
    return func;
};
var $e138537b8a4dabe8$var$applyBind = function applyBind() {
    return $e138537b8a4dabe8$var$$reflectApply($7UXlv, $e138537b8a4dabe8$var$$apply, arguments);
};
if ($e138537b8a4dabe8$var$$defineProperty) $e138537b8a4dabe8$var$$defineProperty(module.exports, "apply", {
    value: $e138537b8a4dabe8$var$applyBind
});
else module.exports.apply = $e138537b8a4dabe8$var$applyBind;

});


parcelRegister("3lTif", function(module, exports) {
var $270e396337d3ca8f$var$hasMap = typeof Map === "function" && Map.prototype;
var $270e396337d3ca8f$var$mapSizeDescriptor = Object.getOwnPropertyDescriptor && $270e396337d3ca8f$var$hasMap ? Object.getOwnPropertyDescriptor(Map.prototype, "size") : null;
var $270e396337d3ca8f$var$mapSize = $270e396337d3ca8f$var$hasMap && $270e396337d3ca8f$var$mapSizeDescriptor && typeof $270e396337d3ca8f$var$mapSizeDescriptor.get === "function" ? $270e396337d3ca8f$var$mapSizeDescriptor.get : null;
var $270e396337d3ca8f$var$mapForEach = $270e396337d3ca8f$var$hasMap && Map.prototype.forEach;
var $270e396337d3ca8f$var$hasSet = typeof Set === "function" && Set.prototype;
var $270e396337d3ca8f$var$setSizeDescriptor = Object.getOwnPropertyDescriptor && $270e396337d3ca8f$var$hasSet ? Object.getOwnPropertyDescriptor(Set.prototype, "size") : null;
var $270e396337d3ca8f$var$setSize = $270e396337d3ca8f$var$hasSet && $270e396337d3ca8f$var$setSizeDescriptor && typeof $270e396337d3ca8f$var$setSizeDescriptor.get === "function" ? $270e396337d3ca8f$var$setSizeDescriptor.get : null;
var $270e396337d3ca8f$var$setForEach = $270e396337d3ca8f$var$hasSet && Set.prototype.forEach;
var $270e396337d3ca8f$var$hasWeakMap = typeof WeakMap === "function" && WeakMap.prototype;
var $270e396337d3ca8f$var$weakMapHas = $270e396337d3ca8f$var$hasWeakMap ? WeakMap.prototype.has : null;
var $270e396337d3ca8f$var$hasWeakSet = typeof WeakSet === "function" && WeakSet.prototype;
var $270e396337d3ca8f$var$weakSetHas = $270e396337d3ca8f$var$hasWeakSet ? WeakSet.prototype.has : null;
var $270e396337d3ca8f$var$hasWeakRef = typeof WeakRef === "function" && WeakRef.prototype;
var $270e396337d3ca8f$var$weakRefDeref = $270e396337d3ca8f$var$hasWeakRef ? WeakRef.prototype.deref : null;
var $270e396337d3ca8f$var$booleanValueOf = Boolean.prototype.valueOf;
var $270e396337d3ca8f$var$objectToString = Object.prototype.toString;
var $270e396337d3ca8f$var$functionToString = Function.prototype.toString;
var $270e396337d3ca8f$var$$match = String.prototype.match;
var $270e396337d3ca8f$var$$slice = String.prototype.slice;
var $270e396337d3ca8f$var$$replace = String.prototype.replace;
var $270e396337d3ca8f$var$$toUpperCase = String.prototype.toUpperCase;
var $270e396337d3ca8f$var$$toLowerCase = String.prototype.toLowerCase;
var $270e396337d3ca8f$var$$test = RegExp.prototype.test;
var $270e396337d3ca8f$var$$concat = Array.prototype.concat;
var $270e396337d3ca8f$var$$join = Array.prototype.join;
var $270e396337d3ca8f$var$$arrSlice = Array.prototype.slice;
var $270e396337d3ca8f$var$$floor = Math.floor;
var $270e396337d3ca8f$var$bigIntValueOf = typeof BigInt === "function" ? BigInt.prototype.valueOf : null;
var $270e396337d3ca8f$var$gOPS = Object.getOwnPropertySymbols;
var $270e396337d3ca8f$var$symToString = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? Symbol.prototype.toString : null;
var $270e396337d3ca8f$var$hasShammedSymbols = typeof Symbol === "function" && typeof Symbol.iterator === "object";
// ie, `has-tostringtag/shams
var $270e396337d3ca8f$var$toStringTag = typeof Symbol === "function" && Symbol.toStringTag && (typeof Symbol.toStringTag === $270e396337d3ca8f$var$hasShammedSymbols ? "object" : "symbol") ? Symbol.toStringTag : null;
var $270e396337d3ca8f$var$isEnumerable = Object.prototype.propertyIsEnumerable;
var $270e396337d3ca8f$var$gPO = (typeof Reflect === "function" ? Reflect.getPrototypeOf : Object.getPrototypeOf) || ([].__proto__ === Array.prototype // eslint-disable-line no-proto
 ? function(O) {
    return O.__proto__; // eslint-disable-line no-proto
} : null);
function $270e396337d3ca8f$var$addNumericSeparator(num, str) {
    if (num === Infinity || num === -Infinity || num !== num || num && num > -1000 && num < 1000 || $270e396337d3ca8f$var$$test.call(/e/, str)) return str;
    var sepRegex = /[0-9](?=(?:[0-9]{3})+(?![0-9]))/g;
    if (typeof num === "number") {
        var int = num < 0 ? -$270e396337d3ca8f$var$$floor(-num) : $270e396337d3ca8f$var$$floor(num); // trunc(num)
        if (int !== num) {
            var intStr = String(int);
            var dec = $270e396337d3ca8f$var$$slice.call(str, intStr.length + 1);
            return $270e396337d3ca8f$var$$replace.call(intStr, sepRegex, "$&_") + "." + $270e396337d3ca8f$var$$replace.call($270e396337d3ca8f$var$$replace.call(dec, /([0-9]{3})/g, "$&_"), /_$/, "");
        }
    }
    return $270e396337d3ca8f$var$$replace.call(str, sepRegex, "$&_");
}

var $kjyEk = parcelRequire("kjyEk");
var $270e396337d3ca8f$var$inspectCustom = $kjyEk.custom;
var $270e396337d3ca8f$var$inspectSymbol = $270e396337d3ca8f$var$isSymbol($270e396337d3ca8f$var$inspectCustom) ? $270e396337d3ca8f$var$inspectCustom : null;
module.exports = function inspect_(obj, options, depth, seen) {
    var opts = options || {};
    if ($270e396337d3ca8f$var$has(opts, "quoteStyle") && opts.quoteStyle !== "single" && opts.quoteStyle !== "double") throw new TypeError('option "quoteStyle" must be "single" or "double"');
    if ($270e396337d3ca8f$var$has(opts, "maxStringLength") && (typeof opts.maxStringLength === "number" ? opts.maxStringLength < 0 && opts.maxStringLength !== Infinity : opts.maxStringLength !== null)) throw new TypeError('option "maxStringLength", if provided, must be a positive integer, Infinity, or `null`');
    var customInspect = $270e396337d3ca8f$var$has(opts, "customInspect") ? opts.customInspect : true;
    if (typeof customInspect !== "boolean" && customInspect !== "symbol") throw new TypeError("option \"customInspect\", if provided, must be `true`, `false`, or `'symbol'`");
    if ($270e396337d3ca8f$var$has(opts, "indent") && opts.indent !== null && opts.indent !== "	" && !(parseInt(opts.indent, 10) === opts.indent && opts.indent > 0)) throw new TypeError('option "indent" must be "\\t", an integer > 0, or `null`');
    if ($270e396337d3ca8f$var$has(opts, "numericSeparator") && typeof opts.numericSeparator !== "boolean") throw new TypeError('option "numericSeparator", if provided, must be `true` or `false`');
    var numericSeparator = opts.numericSeparator;
    if (typeof obj === "undefined") return "undefined";
    if (obj === null) return "null";
    if (typeof obj === "boolean") return obj ? "true" : "false";
    if (typeof obj === "string") return $270e396337d3ca8f$var$inspectString(obj, opts);
    if (typeof obj === "number") {
        if (obj === 0) return Infinity / obj > 0 ? "0" : "-0";
        var str = String(obj);
        return numericSeparator ? $270e396337d3ca8f$var$addNumericSeparator(obj, str) : str;
    }
    if (typeof obj === "bigint") {
        var bigIntStr = String(obj) + "n";
        return numericSeparator ? $270e396337d3ca8f$var$addNumericSeparator(obj, bigIntStr) : bigIntStr;
    }
    var maxDepth = typeof opts.depth === "undefined" ? 5 : opts.depth;
    if (typeof depth === "undefined") depth = 0;
    if (depth >= maxDepth && maxDepth > 0 && typeof obj === "object") return $270e396337d3ca8f$var$isArray(obj) ? "[Array]" : "[Object]";
    var indent = $270e396337d3ca8f$var$getIndent(opts, depth);
    if (typeof seen === "undefined") seen = [];
    else if ($270e396337d3ca8f$var$indexOf(seen, obj) >= 0) return "[Circular]";
    function inspect(value, from, noIndent) {
        if (from) {
            seen = $270e396337d3ca8f$var$$arrSlice.call(seen);
            seen.push(from);
        }
        if (noIndent) {
            var newOpts = {
                depth: opts.depth
            };
            if ($270e396337d3ca8f$var$has(opts, "quoteStyle")) newOpts.quoteStyle = opts.quoteStyle;
            return inspect_(value, newOpts, depth + 1, seen);
        }
        return inspect_(value, opts, depth + 1, seen);
    }
    if (typeof obj === "function" && !$270e396337d3ca8f$var$isRegExp(obj)) {
        var name = $270e396337d3ca8f$var$nameOf(obj);
        var keys = $270e396337d3ca8f$var$arrObjKeys(obj, inspect);
        return "[Function" + (name ? ": " + name : " (anonymous)") + "]" + (keys.length > 0 ? " { " + $270e396337d3ca8f$var$$join.call(keys, ", ") + " }" : "");
    }
    if ($270e396337d3ca8f$var$isSymbol(obj)) {
        var symString = $270e396337d3ca8f$var$hasShammedSymbols ? $270e396337d3ca8f$var$$replace.call(String(obj), /^(Symbol\(.*\))_[^)]*$/, "$1") : $270e396337d3ca8f$var$symToString.call(obj);
        return typeof obj === "object" && !$270e396337d3ca8f$var$hasShammedSymbols ? $270e396337d3ca8f$var$markBoxed(symString) : symString;
    }
    if ($270e396337d3ca8f$var$isElement(obj)) {
        var s = "<" + $270e396337d3ca8f$var$$toLowerCase.call(String(obj.nodeName));
        var attrs = obj.attributes || [];
        for(var i = 0; i < attrs.length; i++)s += " " + attrs[i].name + "=" + $270e396337d3ca8f$var$wrapQuotes($270e396337d3ca8f$var$quote(attrs[i].value), "double", opts);
        s += ">";
        if (obj.childNodes && obj.childNodes.length) s += "...";
        s += "</" + $270e396337d3ca8f$var$$toLowerCase.call(String(obj.nodeName)) + ">";
        return s;
    }
    if ($270e396337d3ca8f$var$isArray(obj)) {
        if (obj.length === 0) return "[]";
        var xs = $270e396337d3ca8f$var$arrObjKeys(obj, inspect);
        if (indent && !$270e396337d3ca8f$var$singleLineValues(xs)) return "[" + $270e396337d3ca8f$var$indentedJoin(xs, indent) + "]";
        return "[ " + $270e396337d3ca8f$var$$join.call(xs, ", ") + " ]";
    }
    if ($270e396337d3ca8f$var$isError(obj)) {
        var parts = $270e396337d3ca8f$var$arrObjKeys(obj, inspect);
        if (!("cause" in Error.prototype) && "cause" in obj && !$270e396337d3ca8f$var$isEnumerable.call(obj, "cause")) return "{ [" + String(obj) + "] " + $270e396337d3ca8f$var$$join.call($270e396337d3ca8f$var$$concat.call("[cause]: " + inspect(obj.cause), parts), ", ") + " }";
        if (parts.length === 0) return "[" + String(obj) + "]";
        return "{ [" + String(obj) + "] " + $270e396337d3ca8f$var$$join.call(parts, ", ") + " }";
    }
    if (typeof obj === "object" && customInspect) {
        if ($270e396337d3ca8f$var$inspectSymbol && typeof obj[$270e396337d3ca8f$var$inspectSymbol] === "function" && $kjyEk) return $kjyEk(obj, {
            depth: maxDepth - depth
        });
        else if (customInspect !== "symbol" && typeof obj.inspect === "function") return obj.inspect();
    }
    if ($270e396337d3ca8f$var$isMap(obj)) {
        var mapParts = [];
        if ($270e396337d3ca8f$var$mapForEach) $270e396337d3ca8f$var$mapForEach.call(obj, function(value, key) {
            mapParts.push(inspect(key, obj, true) + " => " + inspect(value, obj));
        });
        return $270e396337d3ca8f$var$collectionOf("Map", $270e396337d3ca8f$var$mapSize.call(obj), mapParts, indent);
    }
    if ($270e396337d3ca8f$var$isSet(obj)) {
        var setParts = [];
        if ($270e396337d3ca8f$var$setForEach) $270e396337d3ca8f$var$setForEach.call(obj, function(value) {
            setParts.push(inspect(value, obj));
        });
        return $270e396337d3ca8f$var$collectionOf("Set", $270e396337d3ca8f$var$setSize.call(obj), setParts, indent);
    }
    if ($270e396337d3ca8f$var$isWeakMap(obj)) return $270e396337d3ca8f$var$weakCollectionOf("WeakMap");
    if ($270e396337d3ca8f$var$isWeakSet(obj)) return $270e396337d3ca8f$var$weakCollectionOf("WeakSet");
    if ($270e396337d3ca8f$var$isWeakRef(obj)) return $270e396337d3ca8f$var$weakCollectionOf("WeakRef");
    if ($270e396337d3ca8f$var$isNumber(obj)) return $270e396337d3ca8f$var$markBoxed(inspect(Number(obj)));
    if ($270e396337d3ca8f$var$isBigInt(obj)) return $270e396337d3ca8f$var$markBoxed(inspect($270e396337d3ca8f$var$bigIntValueOf.call(obj)));
    if ($270e396337d3ca8f$var$isBoolean(obj)) return $270e396337d3ca8f$var$markBoxed($270e396337d3ca8f$var$booleanValueOf.call(obj));
    if ($270e396337d3ca8f$var$isString(obj)) return $270e396337d3ca8f$var$markBoxed(inspect(String(obj)));
    if (obj === $parcel$global) {
        /* eslint-env browser */ if (typeof window !== "undefined") return "{ [object Window] }";
        return "{ [object global] }";
    }
    if (!$270e396337d3ca8f$var$isDate(obj) && !$270e396337d3ca8f$var$isRegExp(obj)) {
        var ys = $270e396337d3ca8f$var$arrObjKeys(obj, inspect);
        var isPlainObject = $270e396337d3ca8f$var$gPO ? $270e396337d3ca8f$var$gPO(obj) === Object.prototype : obj instanceof Object || obj.constructor === Object;
        var protoTag = obj instanceof Object ? "" : "null prototype";
        var stringTag = !isPlainObject && $270e396337d3ca8f$var$toStringTag && Object(obj) === obj && $270e396337d3ca8f$var$toStringTag in obj ? $270e396337d3ca8f$var$$slice.call($270e396337d3ca8f$var$toStr(obj), 8, -1) : protoTag ? "Object" : "";
        var constructorTag = isPlainObject || typeof obj.constructor !== "function" ? "" : obj.constructor.name ? obj.constructor.name + " " : "";
        var tag = constructorTag + (stringTag || protoTag ? "[" + $270e396337d3ca8f$var$$join.call($270e396337d3ca8f$var$$concat.call([], stringTag || [], protoTag || []), ": ") + "] " : "");
        if (ys.length === 0) return tag + "{}";
        if (indent) return tag + "{" + $270e396337d3ca8f$var$indentedJoin(ys, indent) + "}";
        return tag + "{ " + $270e396337d3ca8f$var$$join.call(ys, ", ") + " }";
    }
    return String(obj);
};
function $270e396337d3ca8f$var$wrapQuotes(s, defaultStyle, opts) {
    var quoteChar = (opts.quoteStyle || defaultStyle) === "double" ? '"' : "'";
    return quoteChar + s + quoteChar;
}
function $270e396337d3ca8f$var$quote(s) {
    return $270e396337d3ca8f$var$$replace.call(String(s), /"/g, "&quot;");
}
function $270e396337d3ca8f$var$isArray(obj) {
    return $270e396337d3ca8f$var$toStr(obj) === "[object Array]" && (!$270e396337d3ca8f$var$toStringTag || !(typeof obj === "object" && $270e396337d3ca8f$var$toStringTag in obj));
}
function $270e396337d3ca8f$var$isDate(obj) {
    return $270e396337d3ca8f$var$toStr(obj) === "[object Date]" && (!$270e396337d3ca8f$var$toStringTag || !(typeof obj === "object" && $270e396337d3ca8f$var$toStringTag in obj));
}
function $270e396337d3ca8f$var$isRegExp(obj) {
    return $270e396337d3ca8f$var$toStr(obj) === "[object RegExp]" && (!$270e396337d3ca8f$var$toStringTag || !(typeof obj === "object" && $270e396337d3ca8f$var$toStringTag in obj));
}
function $270e396337d3ca8f$var$isError(obj) {
    return $270e396337d3ca8f$var$toStr(obj) === "[object Error]" && (!$270e396337d3ca8f$var$toStringTag || !(typeof obj === "object" && $270e396337d3ca8f$var$toStringTag in obj));
}
function $270e396337d3ca8f$var$isString(obj) {
    return $270e396337d3ca8f$var$toStr(obj) === "[object String]" && (!$270e396337d3ca8f$var$toStringTag || !(typeof obj === "object" && $270e396337d3ca8f$var$toStringTag in obj));
}
function $270e396337d3ca8f$var$isNumber(obj) {
    return $270e396337d3ca8f$var$toStr(obj) === "[object Number]" && (!$270e396337d3ca8f$var$toStringTag || !(typeof obj === "object" && $270e396337d3ca8f$var$toStringTag in obj));
}
function $270e396337d3ca8f$var$isBoolean(obj) {
    return $270e396337d3ca8f$var$toStr(obj) === "[object Boolean]" && (!$270e396337d3ca8f$var$toStringTag || !(typeof obj === "object" && $270e396337d3ca8f$var$toStringTag in obj));
}
// Symbol and BigInt do have Symbol.toStringTag by spec, so that can't be used to eliminate false positives
function $270e396337d3ca8f$var$isSymbol(obj) {
    if ($270e396337d3ca8f$var$hasShammedSymbols) return obj && typeof obj === "object" && obj instanceof Symbol;
    if (typeof obj === "symbol") return true;
    if (!obj || typeof obj !== "object" || !$270e396337d3ca8f$var$symToString) return false;
    try {
        $270e396337d3ca8f$var$symToString.call(obj);
        return true;
    } catch (e) {}
    return false;
}
function $270e396337d3ca8f$var$isBigInt(obj) {
    if (!obj || typeof obj !== "object" || !$270e396337d3ca8f$var$bigIntValueOf) return false;
    try {
        $270e396337d3ca8f$var$bigIntValueOf.call(obj);
        return true;
    } catch (e) {}
    return false;
}
var $270e396337d3ca8f$var$hasOwn = Object.prototype.hasOwnProperty || function(key) {
    return key in this;
};
function $270e396337d3ca8f$var$has(obj, key) {
    return $270e396337d3ca8f$var$hasOwn.call(obj, key);
}
function $270e396337d3ca8f$var$toStr(obj) {
    return $270e396337d3ca8f$var$objectToString.call(obj);
}
function $270e396337d3ca8f$var$nameOf(f) {
    if (f.name) return f.name;
    var m = $270e396337d3ca8f$var$$match.call($270e396337d3ca8f$var$functionToString.call(f), /^function\s*([\w$]+)/);
    if (m) return m[1];
    return null;
}
function $270e396337d3ca8f$var$indexOf(xs, x) {
    if (xs.indexOf) return xs.indexOf(x);
    for(var i = 0, l = xs.length; i < l; i++){
        if (xs[i] === x) return i;
    }
    return -1;
}
function $270e396337d3ca8f$var$isMap(x) {
    if (!$270e396337d3ca8f$var$mapSize || !x || typeof x !== "object") return false;
    try {
        $270e396337d3ca8f$var$mapSize.call(x);
        try {
            $270e396337d3ca8f$var$setSize.call(x);
        } catch (s) {
            return true;
        }
        return x instanceof Map; // core-js workaround, pre-v2.5.0
    } catch (e) {}
    return false;
}
function $270e396337d3ca8f$var$isWeakMap(x) {
    if (!$270e396337d3ca8f$var$weakMapHas || !x || typeof x !== "object") return false;
    try {
        $270e396337d3ca8f$var$weakMapHas.call(x, $270e396337d3ca8f$var$weakMapHas);
        try {
            $270e396337d3ca8f$var$weakSetHas.call(x, $270e396337d3ca8f$var$weakSetHas);
        } catch (s) {
            return true;
        }
        return x instanceof WeakMap; // core-js workaround, pre-v2.5.0
    } catch (e) {}
    return false;
}
function $270e396337d3ca8f$var$isWeakRef(x) {
    if (!$270e396337d3ca8f$var$weakRefDeref || !x || typeof x !== "object") return false;
    try {
        $270e396337d3ca8f$var$weakRefDeref.call(x);
        return true;
    } catch (e) {}
    return false;
}
function $270e396337d3ca8f$var$isSet(x) {
    if (!$270e396337d3ca8f$var$setSize || !x || typeof x !== "object") return false;
    try {
        $270e396337d3ca8f$var$setSize.call(x);
        try {
            $270e396337d3ca8f$var$mapSize.call(x);
        } catch (m) {
            return true;
        }
        return x instanceof Set; // core-js workaround, pre-v2.5.0
    } catch (e) {}
    return false;
}
function $270e396337d3ca8f$var$isWeakSet(x) {
    if (!$270e396337d3ca8f$var$weakSetHas || !x || typeof x !== "object") return false;
    try {
        $270e396337d3ca8f$var$weakSetHas.call(x, $270e396337d3ca8f$var$weakSetHas);
        try {
            $270e396337d3ca8f$var$weakMapHas.call(x, $270e396337d3ca8f$var$weakMapHas);
        } catch (s) {
            return true;
        }
        return x instanceof WeakSet; // core-js workaround, pre-v2.5.0
    } catch (e) {}
    return false;
}
function $270e396337d3ca8f$var$isElement(x) {
    if (!x || typeof x !== "object") return false;
    if (typeof HTMLElement !== "undefined" && x instanceof HTMLElement) return true;
    return typeof x.nodeName === "string" && typeof x.getAttribute === "function";
}
function $270e396337d3ca8f$var$inspectString(str, opts) {
    if (str.length > opts.maxStringLength) {
        var remaining = str.length - opts.maxStringLength;
        var trailer = "... " + remaining + " more character" + (remaining > 1 ? "s" : "");
        return $270e396337d3ca8f$var$inspectString($270e396337d3ca8f$var$$slice.call(str, 0, opts.maxStringLength), opts) + trailer;
    }
    // eslint-disable-next-line no-control-regex
    var s = $270e396337d3ca8f$var$$replace.call($270e396337d3ca8f$var$$replace.call(str, /(['\\])/g, "\\$1"), /[\x00-\x1f]/g, $270e396337d3ca8f$var$lowbyte);
    return $270e396337d3ca8f$var$wrapQuotes(s, "single", opts);
}
function $270e396337d3ca8f$var$lowbyte(c) {
    var n = c.charCodeAt(0);
    var x = {
        8: "b",
        9: "t",
        10: "n",
        12: "f",
        13: "r"
    }[n];
    if (x) return "\\" + x;
    return "\\x" + (n < 0x10 ? "0" : "") + $270e396337d3ca8f$var$$toUpperCase.call(n.toString(16));
}
function $270e396337d3ca8f$var$markBoxed(str) {
    return "Object(" + str + ")";
}
function $270e396337d3ca8f$var$weakCollectionOf(type) {
    return type + " { ? }";
}
function $270e396337d3ca8f$var$collectionOf(type, size, entries, indent) {
    var joinedEntries = indent ? $270e396337d3ca8f$var$indentedJoin(entries, indent) : $270e396337d3ca8f$var$$join.call(entries, ", ");
    return type + " (" + size + ") {" + joinedEntries + "}";
}
function $270e396337d3ca8f$var$singleLineValues(xs) {
    for(var i = 0; i < xs.length; i++){
        if ($270e396337d3ca8f$var$indexOf(xs[i], "\n") >= 0) return false;
    }
    return true;
}
function $270e396337d3ca8f$var$getIndent(opts, depth) {
    var baseIndent;
    if (opts.indent === "	") baseIndent = "	";
    else if (typeof opts.indent === "number" && opts.indent > 0) baseIndent = $270e396337d3ca8f$var$$join.call(Array(opts.indent + 1), " ");
    else return null;
    return {
        base: baseIndent,
        prev: $270e396337d3ca8f$var$$join.call(Array(depth + 1), baseIndent)
    };
}
function $270e396337d3ca8f$var$indentedJoin(xs, indent) {
    if (xs.length === 0) return "";
    var lineJoiner = "\n" + indent.prev + indent.base;
    return lineJoiner + $270e396337d3ca8f$var$$join.call(xs, "," + lineJoiner) + "\n" + indent.prev;
}
function $270e396337d3ca8f$var$arrObjKeys(obj, inspect) {
    var isArr = $270e396337d3ca8f$var$isArray(obj);
    var xs = [];
    if (isArr) {
        xs.length = obj.length;
        for(var i = 0; i < obj.length; i++)xs[i] = $270e396337d3ca8f$var$has(obj, i) ? inspect(obj[i], obj) : "";
    }
    var syms = typeof $270e396337d3ca8f$var$gOPS === "function" ? $270e396337d3ca8f$var$gOPS(obj) : [];
    var symMap;
    if ($270e396337d3ca8f$var$hasShammedSymbols) {
        symMap = {};
        for(var k = 0; k < syms.length; k++)symMap["$" + syms[k]] = syms[k];
    }
    for(var key in obj){
        if (!$270e396337d3ca8f$var$has(obj, key)) continue;
         // eslint-disable-line no-restricted-syntax, no-continue
        if (isArr && String(Number(key)) === key && key < obj.length) continue;
         // eslint-disable-line no-restricted-syntax, no-continue
        if ($270e396337d3ca8f$var$hasShammedSymbols && symMap["$" + key] instanceof Symbol) continue; // eslint-disable-line no-restricted-syntax, no-continue
        else if ($270e396337d3ca8f$var$$test.call(/[^\w$]/, key)) xs.push(inspect(key, obj) + ": " + inspect(obj[key], obj));
        else xs.push(key + ": " + inspect(obj[key], obj));
    }
    if (typeof $270e396337d3ca8f$var$gOPS === "function") {
        for(var j = 0; j < syms.length; j++)if ($270e396337d3ca8f$var$isEnumerable.call(obj, syms[j])) xs.push("[" + inspect(syms[j]) + "]: " + inspect(obj[syms[j]], obj));
    }
    return xs;
}

});


parcelRegister("1NX32", function(module, exports) {
"use strict";

var $5kWEx = parcelRequire("5kWEx");
var $15082bc281dd6f5a$var$has = Object.prototype.hasOwnProperty;
var $15082bc281dd6f5a$var$isArray = Array.isArray;
var $15082bc281dd6f5a$var$hexTable = function() {
    var array = [];
    for(var i = 0; i < 256; ++i)array.push("%" + ((i < 16 ? "0" : "") + i.toString(16)).toUpperCase());
    return array;
}();
var $15082bc281dd6f5a$var$compactQueue = function compactQueue(queue) {
    while(queue.length > 1){
        var item = queue.pop();
        var obj = item.obj[item.prop];
        if ($15082bc281dd6f5a$var$isArray(obj)) {
            var compacted = [];
            for(var j = 0; j < obj.length; ++j)if (typeof obj[j] !== "undefined") compacted.push(obj[j]);
            item.obj[item.prop] = compacted;
        }
    }
};
var $15082bc281dd6f5a$var$arrayToObject = function arrayToObject(source, options) {
    var obj = options && options.plainObjects ? Object.create(null) : {};
    for(var i = 0; i < source.length; ++i)if (typeof source[i] !== "undefined") obj[i] = source[i];
    return obj;
};
var $15082bc281dd6f5a$var$merge = function merge(target, source, options) {
    /* eslint no-param-reassign: 0 */ if (!source) return target;
    if (typeof source !== "object") {
        if ($15082bc281dd6f5a$var$isArray(target)) target.push(source);
        else if (target && typeof target === "object") {
            if (options && (options.plainObjects || options.allowPrototypes) || !$15082bc281dd6f5a$var$has.call(Object.prototype, source)) target[source] = true;
        } else return [
            target,
            source
        ];
        return target;
    }
    if (!target || typeof target !== "object") return [
        target
    ].concat(source);
    var mergeTarget = target;
    if ($15082bc281dd6f5a$var$isArray(target) && !$15082bc281dd6f5a$var$isArray(source)) mergeTarget = $15082bc281dd6f5a$var$arrayToObject(target, options);
    if ($15082bc281dd6f5a$var$isArray(target) && $15082bc281dd6f5a$var$isArray(source)) {
        source.forEach(function(item, i) {
            if ($15082bc281dd6f5a$var$has.call(target, i)) {
                var targetItem = target[i];
                if (targetItem && typeof targetItem === "object" && item && typeof item === "object") target[i] = merge(targetItem, item, options);
                else target.push(item);
            } else target[i] = item;
        });
        return target;
    }
    return Object.keys(source).reduce(function(acc, key) {
        var value = source[key];
        if ($15082bc281dd6f5a$var$has.call(acc, key)) acc[key] = merge(acc[key], value, options);
        else acc[key] = value;
        return acc;
    }, mergeTarget);
};
var $15082bc281dd6f5a$var$assign = function assignSingleSource(target, source) {
    return Object.keys(source).reduce(function(acc, key) {
        acc[key] = source[key];
        return acc;
    }, target);
};
var $15082bc281dd6f5a$var$decode = function(str, decoder, charset) {
    var strWithoutPlus = str.replace(/\+/g, " ");
    if (charset === "iso-8859-1") // unescape never throws, no try...catch needed:
    return strWithoutPlus.replace(/%[0-9a-f]{2}/gi, unescape);
    // utf-8
    try {
        return decodeURIComponent(strWithoutPlus);
    } catch (e) {
        return strWithoutPlus;
    }
};
var $15082bc281dd6f5a$var$encode = function encode(str, defaultEncoder, charset, kind, format) {
    // This code was originally written by Brian White (mscdex) for the io.js core querystring library.
    // It has been adapted here for stricter adherence to RFC 3986
    if (str.length === 0) return str;
    var string = str;
    if (typeof str === "symbol") string = Symbol.prototype.toString.call(str);
    else if (typeof str !== "string") string = String(str);
    if (charset === "iso-8859-1") return escape(string).replace(/%u[0-9a-f]{4}/gi, function($0) {
        return "%26%23" + parseInt($0.slice(2), 16) + "%3B";
    });
    var out = "";
    for(var i = 0; i < string.length; ++i){
        var c = string.charCodeAt(i);
        if (c === 0x2D // -
         || c === 0x2E // .
         || c === 0x5F // _
         || c === 0x7E // ~
         || c >= 0x30 && c <= 0x39 // 0-9
         || c >= 0x41 && c <= 0x5A // a-z
         || c >= 0x61 && c <= 0x7A // A-Z
         || format === $5kWEx.RFC1738 && (c === 0x28 || c === 0x29) // ( )
        ) {
            out += string.charAt(i);
            continue;
        }
        if (c < 0x80) {
            out = out + $15082bc281dd6f5a$var$hexTable[c];
            continue;
        }
        if (c < 0x800) {
            out = out + ($15082bc281dd6f5a$var$hexTable[0xC0 | c >> 6] + $15082bc281dd6f5a$var$hexTable[0x80 | c & 0x3F]);
            continue;
        }
        if (c < 0xD800 || c >= 0xE000) {
            out = out + ($15082bc281dd6f5a$var$hexTable[0xE0 | c >> 12] + $15082bc281dd6f5a$var$hexTable[0x80 | c >> 6 & 0x3F] + $15082bc281dd6f5a$var$hexTable[0x80 | c & 0x3F]);
            continue;
        }
        i += 1;
        c = 0x10000 + ((c & 0x3FF) << 10 | string.charCodeAt(i) & 0x3FF);
        /* eslint operator-linebreak: [2, "before"] */ out += $15082bc281dd6f5a$var$hexTable[0xF0 | c >> 18] + $15082bc281dd6f5a$var$hexTable[0x80 | c >> 12 & 0x3F] + $15082bc281dd6f5a$var$hexTable[0x80 | c >> 6 & 0x3F] + $15082bc281dd6f5a$var$hexTable[0x80 | c & 0x3F];
    }
    return out;
};
var $15082bc281dd6f5a$var$compact = function compact(value) {
    var queue = [
        {
            obj: {
                o: value
            },
            prop: "o"
        }
    ];
    var refs = [];
    for(var i = 0; i < queue.length; ++i){
        var item = queue[i];
        var obj = item.obj[item.prop];
        var keys = Object.keys(obj);
        for(var j = 0; j < keys.length; ++j){
            var key = keys[j];
            var val = obj[key];
            if (typeof val === "object" && val !== null && refs.indexOf(val) === -1) {
                queue.push({
                    obj: obj,
                    prop: key
                });
                refs.push(val);
            }
        }
    }
    $15082bc281dd6f5a$var$compactQueue(queue);
    return value;
};
var $15082bc281dd6f5a$var$isRegExp = function isRegExp(obj) {
    return Object.prototype.toString.call(obj) === "[object RegExp]";
};
var $15082bc281dd6f5a$var$isBuffer = function isBuffer(obj) {
    if (!obj || typeof obj !== "object") return false;
    return !!(obj.constructor && obj.constructor.isBuffer && obj.constructor.isBuffer(obj));
};
var $15082bc281dd6f5a$var$combine = function combine(a, b) {
    return [].concat(a, b);
};
var $15082bc281dd6f5a$var$maybeMap = function maybeMap(val, fn) {
    if ($15082bc281dd6f5a$var$isArray(val)) {
        var mapped = [];
        for(var i = 0; i < val.length; i += 1)mapped.push(fn(val[i]));
        return mapped;
    }
    return fn(val);
};
module.exports = {
    arrayToObject: $15082bc281dd6f5a$var$arrayToObject,
    assign: $15082bc281dd6f5a$var$assign,
    combine: $15082bc281dd6f5a$var$combine,
    compact: $15082bc281dd6f5a$var$compact,
    decode: $15082bc281dd6f5a$var$decode,
    encode: $15082bc281dd6f5a$var$encode,
    isBuffer: $15082bc281dd6f5a$var$isBuffer,
    isRegExp: $15082bc281dd6f5a$var$isRegExp,
    maybeMap: $15082bc281dd6f5a$var$maybeMap,
    merge: $15082bc281dd6f5a$var$merge
};

});
parcelRegister("5kWEx", function(module, exports) {
"use strict";
var $3e2c51390759eecd$var$replace = String.prototype.replace;
var $3e2c51390759eecd$var$percentTwenties = /%20/g;
var $3e2c51390759eecd$var$Format = {
    RFC1738: "RFC1738",
    RFC3986: "RFC3986"
};
module.exports = {
    "default": $3e2c51390759eecd$var$Format.RFC3986,
    formatters: {
        RFC1738: function(value) {
            return $3e2c51390759eecd$var$replace.call(value, $3e2c51390759eecd$var$percentTwenties, "+");
        },
        RFC3986: function(value) {
            return String(value);
        }
    },
    RFC1738: $3e2c51390759eecd$var$Format.RFC1738,
    RFC3986: $3e2c51390759eecd$var$Format.RFC3986
};

});



parcelRegister("l9gKj", function(module, exports) {
"use strict";

var $1NX32 = parcelRequire("1NX32");
var $f6576da9da7506e9$var$has = Object.prototype.hasOwnProperty;
var $f6576da9da7506e9$var$isArray = Array.isArray;
var $f6576da9da7506e9$var$defaults = {
    allowDots: false,
    allowPrototypes: false,
    allowSparse: false,
    arrayLimit: 20,
    charset: "utf-8",
    charsetSentinel: false,
    comma: false,
    decoder: $1NX32.decode,
    delimiter: "&",
    depth: 5,
    ignoreQueryPrefix: false,
    interpretNumericEntities: false,
    parameterLimit: 1000,
    parseArrays: true,
    plainObjects: false,
    strictNullHandling: false
};
var $f6576da9da7506e9$var$interpretNumericEntities = function(str) {
    return str.replace(/&#(\d+);/g, function($0, numberStr) {
        return String.fromCharCode(parseInt(numberStr, 10));
    });
};
var $f6576da9da7506e9$var$parseArrayValue = function(val, options) {
    if (val && typeof val === "string" && options.comma && val.indexOf(",") > -1) return val.split(",");
    return val;
};
// This is what browsers will submit when the ✓ character occurs in an
// application/x-www-form-urlencoded body and the encoding of the page containing
// the form is iso-8859-1, or when the submitted form has an accept-charset
// attribute of iso-8859-1. Presumably also with other charsets that do not contain
// the ✓ character, such as us-ascii.
var $f6576da9da7506e9$var$isoSentinel = "utf8=%26%2310003%3B"; // encodeURIComponent('&#10003;')
// These are the percent-encoded utf-8 octets representing a checkmark, indicating that the request actually is utf-8 encoded.
var $f6576da9da7506e9$var$charsetSentinel = "utf8=%E2%9C%93"; // encodeURIComponent('✓')
var $f6576da9da7506e9$var$parseValues = function parseQueryStringValues(str, options) {
    var obj = {
        __proto__: null
    };
    var cleanStr = options.ignoreQueryPrefix ? str.replace(/^\?/, "") : str;
    var limit = options.parameterLimit === Infinity ? undefined : options.parameterLimit;
    var parts = cleanStr.split(options.delimiter, limit);
    var skipIndex = -1; // Keep track of where the utf8 sentinel was found
    var i;
    var charset = options.charset;
    if (options.charsetSentinel) {
        for(i = 0; i < parts.length; ++i)if (parts[i].indexOf("utf8=") === 0) {
            if (parts[i] === $f6576da9da7506e9$var$charsetSentinel) charset = "utf-8";
            else if (parts[i] === $f6576da9da7506e9$var$isoSentinel) charset = "iso-8859-1";
            skipIndex = i;
            i = parts.length; // The eslint settings do not allow break;
        }
    }
    for(i = 0; i < parts.length; ++i){
        if (i === skipIndex) continue;
        var part = parts[i];
        var bracketEqualsPos = part.indexOf("]=");
        var pos = bracketEqualsPos === -1 ? part.indexOf("=") : bracketEqualsPos + 1;
        var key, val;
        if (pos === -1) {
            key = options.decoder(part, $f6576da9da7506e9$var$defaults.decoder, charset, "key");
            val = options.strictNullHandling ? null : "";
        } else {
            key = options.decoder(part.slice(0, pos), $f6576da9da7506e9$var$defaults.decoder, charset, "key");
            val = $1NX32.maybeMap($f6576da9da7506e9$var$parseArrayValue(part.slice(pos + 1), options), function(encodedVal) {
                return options.decoder(encodedVal, $f6576da9da7506e9$var$defaults.decoder, charset, "value");
            });
        }
        if (val && options.interpretNumericEntities && charset === "iso-8859-1") val = $f6576da9da7506e9$var$interpretNumericEntities(val);
        if (part.indexOf("[]=") > -1) val = $f6576da9da7506e9$var$isArray(val) ? [
            val
        ] : val;
        if ($f6576da9da7506e9$var$has.call(obj, key)) obj[key] = $1NX32.combine(obj[key], val);
        else obj[key] = val;
    }
    return obj;
};
var $f6576da9da7506e9$var$parseObject = function(chain, val, options, valuesParsed) {
    var leaf = valuesParsed ? val : $f6576da9da7506e9$var$parseArrayValue(val, options);
    for(var i = chain.length - 1; i >= 0; --i){
        var obj;
        var root = chain[i];
        if (root === "[]" && options.parseArrays) obj = [].concat(leaf);
        else {
            obj = options.plainObjects ? Object.create(null) : {};
            var cleanRoot = root.charAt(0) === "[" && root.charAt(root.length - 1) === "]" ? root.slice(1, -1) : root;
            var index = parseInt(cleanRoot, 10);
            if (!options.parseArrays && cleanRoot === "") obj = {
                0: leaf
            };
            else if (!isNaN(index) && root !== cleanRoot && String(index) === cleanRoot && index >= 0 && options.parseArrays && index <= options.arrayLimit) {
                obj = [];
                obj[index] = leaf;
            } else if (cleanRoot !== "__proto__") obj[cleanRoot] = leaf;
        }
        leaf = obj;
    }
    return leaf;
};
var $f6576da9da7506e9$var$parseKeys = function parseQueryStringKeys(givenKey, val, options, valuesParsed) {
    if (!givenKey) return;
    // Transform dot notation to bracket notation
    var key = options.allowDots ? givenKey.replace(/\.([^.[]+)/g, "[$1]") : givenKey;
    // The regex chunks
    var brackets = /(\[[^[\]]*])/;
    var child = /(\[[^[\]]*])/g;
    // Get the parent
    var segment = options.depth > 0 && brackets.exec(key);
    var parent = segment ? key.slice(0, segment.index) : key;
    // Stash the parent if it exists
    var keys = [];
    if (parent) {
        // If we aren't using plain objects, optionally prefix keys that would overwrite object prototype properties
        if (!options.plainObjects && $f6576da9da7506e9$var$has.call(Object.prototype, parent)) {
            if (!options.allowPrototypes) return;
        }
        keys.push(parent);
    }
    // Loop through children appending to the array until we hit depth
    var i = 0;
    while(options.depth > 0 && (segment = child.exec(key)) !== null && i < options.depth){
        i += 1;
        if (!options.plainObjects && $f6576da9da7506e9$var$has.call(Object.prototype, segment[1].slice(1, -1))) {
            if (!options.allowPrototypes) return;
        }
        keys.push(segment[1]);
    }
    // If there's a remainder, just add whatever is left
    if (segment) keys.push("[" + key.slice(segment.index) + "]");
    return $f6576da9da7506e9$var$parseObject(keys, val, options, valuesParsed);
};
var $f6576da9da7506e9$var$normalizeParseOptions = function normalizeParseOptions(opts) {
    if (!opts) return $f6576da9da7506e9$var$defaults;
    if (opts.decoder !== null && opts.decoder !== undefined && typeof opts.decoder !== "function") throw new TypeError("Decoder has to be a function.");
    if (typeof opts.charset !== "undefined" && opts.charset !== "utf-8" && opts.charset !== "iso-8859-1") throw new TypeError("The charset option must be either utf-8, iso-8859-1, or undefined");
    var charset = typeof opts.charset === "undefined" ? $f6576da9da7506e9$var$defaults.charset : opts.charset;
    return {
        allowDots: typeof opts.allowDots === "undefined" ? $f6576da9da7506e9$var$defaults.allowDots : !!opts.allowDots,
        allowPrototypes: typeof opts.allowPrototypes === "boolean" ? opts.allowPrototypes : $f6576da9da7506e9$var$defaults.allowPrototypes,
        allowSparse: typeof opts.allowSparse === "boolean" ? opts.allowSparse : $f6576da9da7506e9$var$defaults.allowSparse,
        arrayLimit: typeof opts.arrayLimit === "number" ? opts.arrayLimit : $f6576da9da7506e9$var$defaults.arrayLimit,
        charset: charset,
        charsetSentinel: typeof opts.charsetSentinel === "boolean" ? opts.charsetSentinel : $f6576da9da7506e9$var$defaults.charsetSentinel,
        comma: typeof opts.comma === "boolean" ? opts.comma : $f6576da9da7506e9$var$defaults.comma,
        decoder: typeof opts.decoder === "function" ? opts.decoder : $f6576da9da7506e9$var$defaults.decoder,
        delimiter: typeof opts.delimiter === "string" || $1NX32.isRegExp(opts.delimiter) ? opts.delimiter : $f6576da9da7506e9$var$defaults.delimiter,
        // eslint-disable-next-line no-implicit-coercion, no-extra-parens
        depth: typeof opts.depth === "number" || opts.depth === false ? +opts.depth : $f6576da9da7506e9$var$defaults.depth,
        ignoreQueryPrefix: opts.ignoreQueryPrefix === true,
        interpretNumericEntities: typeof opts.interpretNumericEntities === "boolean" ? opts.interpretNumericEntities : $f6576da9da7506e9$var$defaults.interpretNumericEntities,
        parameterLimit: typeof opts.parameterLimit === "number" ? opts.parameterLimit : $f6576da9da7506e9$var$defaults.parameterLimit,
        parseArrays: opts.parseArrays !== false,
        plainObjects: typeof opts.plainObjects === "boolean" ? opts.plainObjects : $f6576da9da7506e9$var$defaults.plainObjects,
        strictNullHandling: typeof opts.strictNullHandling === "boolean" ? opts.strictNullHandling : $f6576da9da7506e9$var$defaults.strictNullHandling
    };
};
module.exports = function(str, opts) {
    var options = $f6576da9da7506e9$var$normalizeParseOptions(opts);
    if (str === "" || str === null || typeof str === "undefined") return options.plainObjects ? Object.create(null) : {};
    var tempObj = typeof str === "string" ? $f6576da9da7506e9$var$parseValues(str, options) : str;
    var obj = options.plainObjects ? Object.create(null) : {};
    // Iterate over the keys and setup the new object
    var keys = Object.keys(tempObj);
    for(var i = 0; i < keys.length; ++i){
        var key = keys[i];
        var newObj = $f6576da9da7506e9$var$parseKeys(key, tempObj[key], options, typeof str === "string");
        obj = $1NX32.merge(obj, newObj, options);
    }
    if (options.allowSparse === true) return obj;
    return $1NX32.compact(obj);
};

});



parcelRegister("hKNIR", function(module, exports) {

$parcel$export(module.exports, "_config", () => _config);
$parcel$export(module.exports, "_isString", () => _isString);
$parcel$export(module.exports, "_isUndefined", () => _isUndefined);
$parcel$export(module.exports, "_numExp", () => _numExp);
$parcel$export(module.exports, "_numWithUnitExp", () => _numWithUnitExp);
$parcel$export(module.exports, "_relExp", () => _relExp);
$parcel$export(module.exports, "gsap", () => gsap);
$parcel$export(module.exports, "_missingPlugin", () => _missingPlugin);
$parcel$export(module.exports, "_plugins", () => _plugins);
$parcel$export(module.exports, "GSCache", () => GSCache);
$parcel$export(module.exports, "_getCache", () => _getCache);
$parcel$export(module.exports, "_getProperty", () => _getProperty);
$parcel$export(module.exports, "_forEachName", () => _forEachName);
$parcel$export(module.exports, "_round", () => _round);
$parcel$export(module.exports, "_parseRelative", () => _parseRelative);
$parcel$export(module.exports, "_ticker", () => _ticker);
$parcel$export(module.exports, "getUnit", () => getUnit);
$parcel$export(module.exports, "_replaceRandom", () => _replaceRandom);
$parcel$export(module.exports, "_getSetter", () => _getSetter);
$parcel$export(module.exports, "PropTween", () => PropTween);
$parcel$export(module.exports, "_colorExp", () => _colorExp);
$parcel$export(module.exports, "_colorStringFilter", () => _colorStringFilter);
$parcel$export(module.exports, "_renderComplexString", () => _renderComplexString);
$parcel$export(module.exports, "_checkPlugin", () => _checkPlugin);
$parcel$export(module.exports, "_sortPropTweensByPriority", () => _sortPropTweensByPriority);
$parcel$export(module.exports, "Linear", () => Linear);
function _assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function _inheritsLoose(subClass, superClass) {
    subClass.prototype = Object.create(superClass.prototype);
    subClass.prototype.constructor = subClass;
    subClass.__proto__ = superClass;
}
/*!
 * GSAP 3.12.2
 * https://greensock.com
 *
 * @license Copyright 2008-2023, GreenSock. All rights reserved.
 * Subject to the terms at https://greensock.com/standard-license or for
 * Club GreenSock members, the agreement issued with that membership.
 * @author: Jack Doyle, jack@greensock.com
*/ /* eslint-disable */ var _config = {
    autoSleep: 120,
    force3D: "auto",
    nullTargetWarn: 1,
    units: {
        lineHeight: ""
    }
}, _defaults = {
    duration: .5,
    overwrite: false,
    delay: 0
}, _suppressOverwrites, _reverting, _context, _bigNum = 1e8, _tinyNum = 1 / _bigNum, _2PI = Math.PI * 2, _HALF_PI = _2PI / 4, _gsID = 0, _sqrt = Math.sqrt, _cos = Math.cos, _sin = Math.sin, _isString = function _isString(value) {
    return typeof value === "string";
}, _isFunction = function _isFunction(value) {
    return typeof value === "function";
}, _isNumber = function _isNumber(value) {
    return typeof value === "number";
}, _isUndefined = function _isUndefined(value) {
    return typeof value === "undefined";
}, _isObject = function _isObject(value) {
    return typeof value === "object";
}, _isNotFalse = function _isNotFalse(value) {
    return value !== false;
}, _windowExists = function _windowExists() {
    return typeof window !== "undefined";
}, _isFuncOrString = function _isFuncOrString(value) {
    return _isFunction(value) || _isString(value);
}, _isTypedArray = typeof ArrayBuffer === "function" && ArrayBuffer.isView || function() {}, // note: IE10 has ArrayBuffer, but NOT ArrayBuffer.isView().
_isArray = Array.isArray, _strictNumExp = /(?:-?\.?\d|\.)+/gi, //only numbers (including negatives and decimals) but NOT relative values.
_numExp = /[-+=.]*\d+[.e\-+]*\d*[e\-+]*\d*/g, //finds any numbers, including ones that start with += or -=, negative numbers, and ones in scientific notation like 1e-8.
_numWithUnitExp = /[-+=.]*\d+[.e-]*\d*[a-z%]*/g, _complexStringNumExp = /[-+=.]*\d+\.?\d*(?:e-|e\+)?\d*/gi, //duplicate so that while we're looping through matches from exec(), it doesn't contaminate the lastIndex of _numExp which we use to search for colors too.
_relExp = /[+-]=-?[.\d]+/, _delimitedValueExp = /[^,'"\[\]\s]+/gi, // previously /[#\-+.]*\b[a-z\d\-=+%.]+/gi but didn't catch special characters.
_unitExp = /^[+\-=e\s\d]*\d+[.\d]*([a-z]*|%)\s*$/i, _globalTimeline, _win, _coreInitted, _doc, _globals = {}, _installScope = {}, _coreReady, _install = function _install(scope) {
    return (_installScope = _merge(scope, _globals)) && gsap;
}, _missingPlugin = function _missingPlugin(property, value) {
    return console.warn("Invalid property", property, "set to", value, "Missing plugin? gsap.registerPlugin()");
}, _warn = function _warn(message, suppress) {
    return !suppress && console.warn(message);
}, _addGlobal = function _addGlobal(name, obj) {
    return name && (_globals[name] = obj) && _installScope && (_installScope[name] = obj) || _globals;
}, _emptyFunc = function _emptyFunc() {
    return 0;
}, _startAtRevertConfig = {
    suppressEvents: true,
    isStart: true,
    kill: false
}, _revertConfigNoKill = {
    suppressEvents: true,
    kill: false
}, _revertConfig = {
    suppressEvents: true
}, _reservedProps = {}, _lazyTweens = [], _lazyLookup = {}, _lastRenderedFrame, _plugins = {}, _effects = {}, _nextGCFrame = 30, _harnessPlugins = [], _callbackNames = "", _harness = function _harness(targets) {
    var target = targets[0], harnessPlugin, i;
    _isObject(target) || _isFunction(target) || (targets = [
        targets
    ]);
    if (!(harnessPlugin = (target._gsap || {}).harness)) {
        // find the first target with a harness. We assume targets passed into an animation will be of similar type, meaning the same kind of harness can be used for them all (performance optimization)
        i = _harnessPlugins.length;
        while(i-- && !_harnessPlugins[i].targetTest(target));
        harnessPlugin = _harnessPlugins[i];
    }
    i = targets.length;
    while(i--)targets[i] && (targets[i]._gsap || (targets[i]._gsap = new GSCache(targets[i], harnessPlugin))) || targets.splice(i, 1);
    return targets;
}, _getCache = function _getCache(target) {
    return target._gsap || _harness(toArray(target))[0]._gsap;
}, _getProperty = function _getProperty(target, property, v) {
    return (v = target[property]) && _isFunction(v) ? target[property]() : _isUndefined(v) && target.getAttribute && target.getAttribute(property) || v;
}, _forEachName = function _forEachName(names, func) {
    return (names = names.split(",")).forEach(func) || names;
}, //split a comma-delimited list of names into an array, then run a forEach() function and return the split array (this is just a way to consolidate/shorten some code).
_round = function _round(value) {
    return Math.round(value * 100000) / 100000 || 0;
}, _roundPrecise = function _roundPrecise(value) {
    return Math.round(value * 10000000) / 10000000 || 0;
}, // increased precision mostly for timing values.
_parseRelative = function _parseRelative(start, value) {
    var operator = value.charAt(0), end = parseFloat(value.substr(2));
    start = parseFloat(start);
    return operator === "+" ? start + end : operator === "-" ? start - end : operator === "*" ? start * end : start / end;
}, _arrayContainsAny = function _arrayContainsAny(toSearch, toFind) {
    //searches one array to find matches for any of the items in the toFind array. As soon as one is found, it returns true. It does NOT return all the matches; it's simply a boolean search.
    var l = toFind.length, i = 0;
    for(; toSearch.indexOf(toFind[i]) < 0 && ++i < l;);
    return i < l;
}, _lazyRender = function _lazyRender() {
    var l = _lazyTweens.length, a = _lazyTweens.slice(0), i, tween;
    _lazyLookup = {};
    _lazyTweens.length = 0;
    for(i = 0; i < l; i++){
        tween = a[i];
        tween && tween._lazy && (tween.render(tween._lazy[0], tween._lazy[1], true)._lazy = 0);
    }
}, _lazySafeRender = function _lazySafeRender(animation, time, suppressEvents, force) {
    _lazyTweens.length && !_reverting && _lazyRender();
    animation.render(time, suppressEvents, force || _reverting && time < 0 && (animation._initted || animation._startAt));
    _lazyTweens.length && !_reverting && _lazyRender(); //in case rendering caused any tweens to lazy-init, we should render them because typically when someone calls seek() or time() or progress(), they expect an immediate render.
}, _numericIfPossible = function _numericIfPossible(value) {
    var n = parseFloat(value);
    return (n || n === 0) && (value + "").match(_delimitedValueExp).length < 2 ? n : _isString(value) ? value.trim() : value;
}, _passThrough = function _passThrough(p) {
    return p;
}, _setDefaults = function _setDefaults(obj, defaults) {
    for(var p in defaults)p in obj || (obj[p] = defaults[p]);
    return obj;
}, _setKeyframeDefaults = function _setKeyframeDefaults(excludeDuration) {
    return function(obj, defaults) {
        for(var p in defaults)p in obj || p === "duration" && excludeDuration || p === "ease" || (obj[p] = defaults[p]);
    };
}, _merge = function _merge(base, toMerge) {
    for(var p in toMerge)base[p] = toMerge[p];
    return base;
}, _mergeDeep = function _mergeDeep(base, toMerge) {
    for(var p in toMerge)p !== "__proto__" && p !== "constructor" && p !== "prototype" && (base[p] = _isObject(toMerge[p]) ? _mergeDeep(base[p] || (base[p] = {}), toMerge[p]) : toMerge[p]);
    return base;
}, _copyExcluding = function _copyExcluding(obj, excluding) {
    var copy = {}, p;
    for(p in obj)p in excluding || (copy[p] = obj[p]);
    return copy;
}, _inheritDefaults = function _inheritDefaults(vars) {
    var parent = vars.parent || _globalTimeline, func = vars.keyframes ? _setKeyframeDefaults(_isArray(vars.keyframes)) : _setDefaults;
    if (_isNotFalse(vars.inherit)) while(parent){
        func(vars, parent.vars.defaults);
        parent = parent.parent || parent._dp;
    }
    return vars;
}, _arraysMatch = function _arraysMatch(a1, a2) {
    var i = a1.length, match = i === a2.length;
    while(match && i-- && a1[i] === a2[i]);
    return i < 0;
}, _addLinkedListItem = function _addLinkedListItem(parent, child, firstProp, lastProp, sortBy) {
    if (firstProp === void 0) firstProp = "_first";
    if (lastProp === void 0) lastProp = "_last";
    var prev = parent[lastProp], t;
    if (sortBy) {
        t = child[sortBy];
        while(prev && prev[sortBy] > t)prev = prev._prev;
    }
    if (prev) {
        child._next = prev._next;
        prev._next = child;
    } else {
        child._next = parent[firstProp];
        parent[firstProp] = child;
    }
    if (child._next) child._next._prev = child;
    else parent[lastProp] = child;
    child._prev = prev;
    child.parent = child._dp = parent;
    return child;
}, _removeLinkedListItem = function _removeLinkedListItem(parent, child, firstProp, lastProp) {
    if (firstProp === void 0) firstProp = "_first";
    if (lastProp === void 0) lastProp = "_last";
    var prev = child._prev, next = child._next;
    if (prev) prev._next = next;
    else if (parent[firstProp] === child) parent[firstProp] = next;
    if (next) next._prev = prev;
    else if (parent[lastProp] === child) parent[lastProp] = prev;
    child._next = child._prev = child.parent = null; // don't delete the _dp just so we can revert if necessary. But parent should be null to indicate the item isn't in a linked list.
}, _removeFromParent = function _removeFromParent(child, onlyIfParentHasAutoRemove) {
    child.parent && (!onlyIfParentHasAutoRemove || child.parent.autoRemoveChildren) && child.parent.remove && child.parent.remove(child);
    child._act = 0;
}, _uncache = function _uncache(animation, child) {
    if (animation && (!child || child._end > animation._dur || child._start < 0)) {
        // performance optimization: if a child animation is passed in we should only uncache if that child EXTENDS the animation (its end time is beyond the end)
        var a = animation;
        while(a){
            a._dirty = 1;
            a = a.parent;
        }
    }
    return animation;
}, _recacheAncestors = function _recacheAncestors(animation) {
    var parent = animation.parent;
    while(parent && parent.parent){
        //sometimes we must force a re-sort of all children and update the duration/totalDuration of all ancestor timelines immediately in case, for example, in the middle of a render loop, one tween alters another tween's timeScale which shoves its startTime before 0, forcing the parent timeline to shift around and shiftChildren() which could affect that next tween's render (startTime). Doesn't matter for the root timeline though.
        parent._dirty = 1;
        parent.totalDuration();
        parent = parent.parent;
    }
    return animation;
}, _rewindStartAt = function _rewindStartAt(tween, totalTime, suppressEvents, force) {
    return tween._startAt && (_reverting ? tween._startAt.revert(_revertConfigNoKill) : tween.vars.immediateRender && !tween.vars.autoRevert || tween._startAt.render(totalTime, true, force));
}, _hasNoPausedAncestors = function _hasNoPausedAncestors(animation) {
    return !animation || animation._ts && _hasNoPausedAncestors(animation.parent);
}, _elapsedCycleDuration = function _elapsedCycleDuration(animation) {
    return animation._repeat ? _animationCycle(animation._tTime, animation = animation.duration() + animation._rDelay) * animation : 0;
}, // feed in the totalTime and cycleDuration and it'll return the cycle (iteration minus 1) and if the playhead is exactly at the very END, it will NOT bump up to the next cycle.
_animationCycle = function _animationCycle(tTime, cycleDuration) {
    var whole = Math.floor(tTime /= cycleDuration);
    return tTime && whole === tTime ? whole - 1 : whole;
}, _parentToChildTotalTime = function _parentToChildTotalTime(parentTime, child) {
    return (parentTime - child._start) * child._ts + (child._ts >= 0 ? 0 : child._dirty ? child.totalDuration() : child._tDur);
}, _setEnd = function _setEnd(animation) {
    return animation._end = _roundPrecise(animation._start + (animation._tDur / Math.abs(animation._ts || animation._rts || _tinyNum) || 0));
}, _alignPlayhead = function _alignPlayhead(animation, totalTime) {
    // adjusts the animation's _start and _end according to the provided totalTime (only if the parent's smoothChildTiming is true and the animation isn't paused). It doesn't do any rendering or forcing things back into parent timelines, etc. - that's what totalTime() is for.
    var parent = animation._dp;
    if (parent && parent.smoothChildTiming && animation._ts) {
        animation._start = _roundPrecise(parent._time - (animation._ts > 0 ? totalTime / animation._ts : ((animation._dirty ? animation.totalDuration() : animation._tDur) - totalTime) / -animation._ts));
        _setEnd(animation);
        parent._dirty || _uncache(parent, animation); //for performance improvement. If the parent's cache is already dirty, it already took care of marking the ancestors as dirty too, so skip the function call here.
    }
    return animation;
}, /*
_totalTimeToTime = (clampedTotalTime, duration, repeat, repeatDelay, yoyo) => {
	let cycleDuration = duration + repeatDelay,
		time = _round(clampedTotalTime % cycleDuration);
	if (time > duration) {
		time = duration;
	}
	return (yoyo && (~~(clampedTotalTime / cycleDuration) & 1)) ? duration - time : time;
},
*/ _postAddChecks = function _postAddChecks(timeline, child) {
    var t;
    if (child._time || !child._dur && child._initted || child._start < timeline._time && (child._dur || !child.add)) {
        // in case, for example, the _start is moved on a tween that has already rendered, or if it's being inserted into a timeline BEFORE where the playhead is currently. Imagine it's at its end state, then the startTime is moved WAY later (after the end of this timeline), it should render at its beginning. Special case: if it's a timeline (has .add() method) and no duration, we can skip rendering because the user may be populating it AFTER adding it to a parent timeline (unconventional, but possible, and we wouldn't want it to get removed if the parent's autoRemoveChildren is true).
        t = _parentToChildTotalTime(timeline.rawTime(), child);
        if (!child._dur || _clamp(0, child.totalDuration(), t) - child._tTime > _tinyNum) child.render(t, true);
    } //if the timeline has already ended but the inserted tween/timeline extends the duration, we should enable this timeline again so that it renders properly. We should also align the playhead with the parent timeline's when appropriate.
    if (_uncache(timeline, child)._dp && timeline._initted && timeline._time >= timeline._dur && timeline._ts) {
        //in case any of the ancestors had completed but should now be enabled...
        if (timeline._dur < timeline.duration()) {
            t = timeline;
            while(t._dp){
                t.rawTime() >= 0 && t.totalTime(t._tTime); //moves the timeline (shifts its startTime) if necessary, and also enables it. If it's currently zero, though, it may not be scheduled to render until later so there's no need to force it to align with the current playhead position. Only move to catch up with the playhead.
                t = t._dp;
            }
        }
        timeline._zTime = -_tinyNum; // helps ensure that the next render() will be forced (crossingStart = true in render()), even if the duration hasn't changed (we're adding a child which would need to get rendered). Definitely an edge case. Note: we MUST do this AFTER the loop above where the totalTime() might trigger a render() because this _addToTimeline() method gets called from the Animation constructor, BEFORE tweens even record their targets, etc. so we wouldn't want things to get triggered in the wrong order.
    }
}, _addToTimeline = function _addToTimeline(timeline, child, position, skipChecks) {
    child.parent && _removeFromParent(child);
    child._start = _roundPrecise((_isNumber(position) ? position : position || timeline !== _globalTimeline ? _parsePosition(timeline, position, child) : timeline._time) + child._delay);
    child._end = _roundPrecise(child._start + (child.totalDuration() / Math.abs(child.timeScale()) || 0));
    _addLinkedListItem(timeline, child, "_first", "_last", timeline._sort ? "_start" : 0);
    _isFromOrFromStart(child) || (timeline._recent = child);
    skipChecks || _postAddChecks(timeline, child);
    timeline._ts < 0 && _alignPlayhead(timeline, timeline._tTime); // if the timeline is reversed and the new child makes it longer, we may need to adjust the parent's _start (push it back)
    return timeline;
}, _scrollTrigger = function _scrollTrigger(animation, trigger) {
    return (_globals.ScrollTrigger || _missingPlugin("scrollTrigger", trigger)) && _globals.ScrollTrigger.create(trigger, animation);
}, _attemptInitTween = function _attemptInitTween(tween, time, force, suppressEvents, tTime) {
    _initTween(tween, time, tTime);
    if (!tween._initted) return 1;
    if (!force && tween._pt && !_reverting && (tween._dur && tween.vars.lazy !== false || !tween._dur && tween.vars.lazy) && _lastRenderedFrame !== _ticker.frame) {
        _lazyTweens.push(tween);
        tween._lazy = [
            tTime,
            suppressEvents
        ];
        return 1;
    }
}, _parentPlayheadIsBeforeStart = function _parentPlayheadIsBeforeStart(_ref) {
    var parent = _ref.parent;
    return parent && parent._ts && parent._initted && !parent._lock && (parent.rawTime() < 0 || _parentPlayheadIsBeforeStart(parent));
}, // check parent's _lock because when a timeline repeats/yoyos and does its artificial wrapping, we shouldn't force the ratio back to 0
_isFromOrFromStart = function _isFromOrFromStart(_ref2) {
    var data = _ref2.data;
    return data === "isFromStart" || data === "isStart";
}, _renderZeroDurationTween = function _renderZeroDurationTween(tween, totalTime, suppressEvents, force) {
    var prevRatio = tween.ratio, ratio = totalTime < 0 || !totalTime && (!tween._start && _parentPlayheadIsBeforeStart(tween) && !(!tween._initted && _isFromOrFromStart(tween)) || (tween._ts < 0 || tween._dp._ts < 0) && !_isFromOrFromStart(tween)) ? 0 : 1, // if the tween or its parent is reversed and the totalTime is 0, we should go to a ratio of 0. Edge case: if a from() or fromTo() stagger tween is placed later in a timeline, the "startAt" zero-duration tween could initially render at a time when the parent timeline's playhead is technically BEFORE where this tween is, so make sure that any "from" and "fromTo" startAt tweens are rendered the first time at a ratio of 1.
    repeatDelay = tween._rDelay, tTime = 0, pt, iteration, prevIteration;
    if (repeatDelay && tween._repeat) {
        // in case there's a zero-duration tween that has a repeat with a repeatDelay
        tTime = _clamp(0, tween._tDur, totalTime);
        iteration = _animationCycle(tTime, repeatDelay);
        tween._yoyo && iteration & 1 && (ratio = 1 - ratio);
        if (iteration !== _animationCycle(tween._tTime, repeatDelay)) {
            // if iteration changed
            prevRatio = 1 - ratio;
            tween.vars.repeatRefresh && tween._initted && tween.invalidate();
        }
    }
    if (ratio !== prevRatio || _reverting || force || tween._zTime === _tinyNum || !totalTime && tween._zTime) {
        if (!tween._initted && _attemptInitTween(tween, totalTime, force, suppressEvents, tTime)) // if we render the very beginning (time == 0) of a fromTo(), we must force the render (normal tweens wouldn't need to render at a time of 0 when the prevTime was also 0). This is also mandatory to make sure overwriting kicks in immediately.
        return;
        prevIteration = tween._zTime;
        tween._zTime = totalTime || (suppressEvents ? _tinyNum : 0); // when the playhead arrives at EXACTLY time 0 (right on top) of a zero-duration tween, we need to discern if events are suppressed so that when the playhead moves again (next time), it'll trigger the callback. If events are NOT suppressed, obviously the callback would be triggered in this render. Basically, the callback should fire either when the playhead ARRIVES or LEAVES this exact spot, not both. Imagine doing a timeline.seek(0) and there's a callback that sits at 0. Since events are suppressed on that seek() by default, nothing will fire, but when the playhead moves off of that position, the callback should fire. This behavior is what people intuitively expect.
        suppressEvents || (suppressEvents = totalTime && !prevIteration); // if it was rendered previously at exactly 0 (_zTime) and now the playhead is moving away, DON'T fire callbacks otherwise they'll seem like duplicates.
        tween.ratio = ratio;
        tween._from && (ratio = 1 - ratio);
        tween._time = 0;
        tween._tTime = tTime;
        pt = tween._pt;
        while(pt){
            pt.r(ratio, pt.d);
            pt = pt._next;
        }
        totalTime < 0 && _rewindStartAt(tween, totalTime, suppressEvents, true);
        tween._onUpdate && !suppressEvents && _callback(tween, "onUpdate");
        tTime && tween._repeat && !suppressEvents && tween.parent && _callback(tween, "onRepeat");
        if ((totalTime >= tween._tDur || totalTime < 0) && tween.ratio === ratio) {
            ratio && _removeFromParent(tween, 1);
            if (!suppressEvents && !_reverting) {
                _callback(tween, ratio ? "onComplete" : "onReverseComplete", true);
                tween._prom && tween._prom();
            }
        }
    } else if (!tween._zTime) tween._zTime = totalTime;
}, _findNextPauseTween = function _findNextPauseTween(animation, prevTime, time) {
    var child;
    if (time > prevTime) {
        child = animation._first;
        while(child && child._start <= time){
            if (child.data === "isPause" && child._start > prevTime) return child;
            child = child._next;
        }
    } else {
        child = animation._last;
        while(child && child._start >= time){
            if (child.data === "isPause" && child._start < prevTime) return child;
            child = child._prev;
        }
    }
}, _setDuration = function _setDuration(animation, duration, skipUncache, leavePlayhead) {
    var repeat = animation._repeat, dur = _roundPrecise(duration) || 0, totalProgress = animation._tTime / animation._tDur;
    totalProgress && !leavePlayhead && (animation._time *= dur / animation._dur);
    animation._dur = dur;
    animation._tDur = !repeat ? dur : repeat < 0 ? 1e10 : _roundPrecise(dur * (repeat + 1) + animation._rDelay * repeat);
    totalProgress > 0 && !leavePlayhead && _alignPlayhead(animation, animation._tTime = animation._tDur * totalProgress);
    animation.parent && _setEnd(animation);
    skipUncache || _uncache(animation.parent, animation);
    return animation;
}, _onUpdateTotalDuration = function _onUpdateTotalDuration(animation) {
    return animation instanceof Timeline ? _uncache(animation) : _setDuration(animation, animation._dur);
}, _zeroPosition = {
    _start: 0,
    endTime: _emptyFunc,
    totalDuration: _emptyFunc
}, _parsePosition = function _parsePosition(animation, position, percentAnimation) {
    var labels = animation.labels, recent = animation._recent || _zeroPosition, clippedDuration = animation.duration() >= _bigNum ? recent.endTime(false) : animation._dur, //in case there's a child that infinitely repeats, users almost never intend for the insertion point of a new child to be based on a SUPER long value like that so we clip it and assume the most recently-added child's endTime should be used instead.
    i, offset, isPercent;
    if (_isString(position) && (isNaN(position) || position in labels)) {
        //if the string is a number like "1", check to see if there's a label with that name, otherwise interpret it as a number (absolute value).
        offset = position.charAt(0);
        isPercent = position.substr(-1) === "%";
        i = position.indexOf("=");
        if (offset === "<" || offset === ">") {
            i >= 0 && (position = position.replace(/=/, ""));
            return (offset === "<" ? recent._start : recent.endTime(recent._repeat >= 0)) + (parseFloat(position.substr(1)) || 0) * (isPercent ? (i < 0 ? recent : percentAnimation).totalDuration() / 100 : 1);
        }
        if (i < 0) {
            position in labels || (labels[position] = clippedDuration);
            return labels[position];
        }
        offset = parseFloat(position.charAt(i - 1) + position.substr(i + 1));
        if (isPercent && percentAnimation) offset = offset / 100 * (_isArray(percentAnimation) ? percentAnimation[0] : percentAnimation).totalDuration();
        return i > 1 ? _parsePosition(animation, position.substr(0, i - 1), percentAnimation) + offset : clippedDuration + offset;
    }
    return position == null ? clippedDuration : +position;
}, _createTweenType = function _createTweenType(type, params, timeline) {
    var isLegacy = _isNumber(params[1]), varsIndex = (isLegacy ? 2 : 1) + (type < 2 ? 0 : 1), vars = params[varsIndex], irVars, parent;
    isLegacy && (vars.duration = params[1]);
    vars.parent = timeline;
    if (type) {
        irVars = vars;
        parent = timeline;
        while(parent && !("immediateRender" in irVars)){
            // inheritance hasn't happened yet, but someone may have set a default in an ancestor timeline. We could do vars.immediateRender = _isNotFalse(_inheritDefaults(vars).immediateRender) but that'd exact a slight performance penalty because _inheritDefaults() also runs in the Tween constructor. We're paying a small kb price here to gain speed.
            irVars = parent.vars.defaults || {};
            parent = _isNotFalse(parent.vars.inherit) && parent.parent;
        }
        vars.immediateRender = _isNotFalse(irVars.immediateRender);
        type < 2 ? vars.runBackwards = 1 : vars.startAt = params[varsIndex - 1]; // "from" vars
    }
    return new Tween(params[0], vars, params[varsIndex + 1]);
}, _conditionalReturn = function _conditionalReturn(value, func) {
    return value || value === 0 ? func(value) : func;
}, _clamp = function _clamp(min, max, value) {
    return value < min ? min : value > max ? max : value;
}, getUnit = function getUnit(value, v) {
    return !_isString(value) || !(v = _unitExp.exec(value)) ? "" : v[1];
}, // note: protect against padded numbers as strings, like "100.100". That shouldn't return "00" as the unit. If it's numeric, return no unit.
clamp = function clamp(min, max, value) {
    return _conditionalReturn(value, function(v) {
        return _clamp(min, max, v);
    });
}, _slice = [].slice, _isArrayLike = function _isArrayLike(value, nonEmpty) {
    return value && _isObject(value) && "length" in value && (!nonEmpty && !value.length || value.length - 1 in value && _isObject(value[0])) && !value.nodeType && value !== _win;
}, _flatten = function _flatten(ar, leaveStrings, accumulator) {
    if (accumulator === void 0) accumulator = [];
    return ar.forEach(function(value) {
        var _accumulator;
        return _isString(value) && !leaveStrings || _isArrayLike(value, 1) ? (_accumulator = accumulator).push.apply(_accumulator, toArray(value)) : accumulator.push(value);
    }) || accumulator;
}, //takes any value and returns an array. If it's a string (and leaveStrings isn't true), it'll use document.querySelectorAll() and convert that to an array. It'll also accept iterables like jQuery objects.
toArray = function toArray(value, scope, leaveStrings) {
    return _context && !scope && _context.selector ? _context.selector(value) : _isString(value) && !leaveStrings && (_coreInitted || !_wake()) ? _slice.call((scope || _doc).querySelectorAll(value), 0) : _isArray(value) ? _flatten(value, leaveStrings) : _isArrayLike(value) ? _slice.call(value, 0) : value ? [
        value
    ] : [];
}, selector = function selector(value) {
    value = toArray(value)[0] || _warn("Invalid scope") || {};
    return function(v) {
        var el = value.current || value.nativeElement || value;
        return toArray(v, el.querySelectorAll ? el : el === value ? _warn("Invalid scope") || _doc.createElement("div") : value);
    };
}, shuffle = function shuffle(a) {
    return a.sort(function() {
        return .5 - Math.random();
    });
}, // alternative that's a bit faster and more reliably diverse but bigger:   for (let j, v, i = a.length; i; j = Math.floor(Math.random() * i), v = a[--i], a[i] = a[j], a[j] = v); return a;
//for distributing values across an array. Can accept a number, a function or (most commonly) a function which can contain the following properties: {base, amount, from, ease, grid, axis, length, each}. Returns a function that expects the following parameters: index, target, array. Recognizes the following
distribute = function distribute(v) {
    if (_isFunction(v)) return v;
    var vars = _isObject(v) ? v : {
        each: v
    }, //n:1 is just to indicate v was a number; we leverage that later to set v according to the length we get. If a number is passed in, we treat it like the old stagger value where 0.1, for example, would mean that things would be distributed with 0.1 between each element in the array rather than a total "amount" that's chunked out among them all.
    ease = _parseEase(vars.ease), from = vars.from || 0, base = parseFloat(vars.base) || 0, cache = {}, isDecimal = from > 0 && from < 1, ratios = isNaN(from) || isDecimal, axis = vars.axis, ratioX = from, ratioY = from;
    if (_isString(from)) ratioX = ratioY = ({
        center: .5,
        edges: .5,
        end: 1
    })[from] || 0;
    else if (!isDecimal && ratios) {
        ratioX = from[0];
        ratioY = from[1];
    }
    return function(i, target, a) {
        var l = (a || vars).length, distances = cache[l], originX, originY, x, y, d, j, max, min, wrapAt;
        if (!distances) {
            wrapAt = vars.grid === "auto" ? 0 : (vars.grid || [
                1,
                _bigNum
            ])[1];
            if (!wrapAt) {
                max = -_bigNum;
                while(max < (max = a[wrapAt++].getBoundingClientRect().left) && wrapAt < l);
                wrapAt--;
            }
            distances = cache[l] = [];
            originX = ratios ? Math.min(wrapAt, l) * ratioX - .5 : from % wrapAt;
            originY = wrapAt === _bigNum ? 0 : ratios ? l * ratioY / wrapAt - .5 : from / wrapAt | 0;
            max = 0;
            min = _bigNum;
            for(j = 0; j < l; j++){
                x = j % wrapAt - originX;
                y = originY - (j / wrapAt | 0);
                distances[j] = d = !axis ? _sqrt(x * x + y * y) : Math.abs(axis === "y" ? y : x);
                d > max && (max = d);
                d < min && (min = d);
            }
            from === "random" && shuffle(distances);
            distances.max = max - min;
            distances.min = min;
            distances.v = l = (parseFloat(vars.amount) || parseFloat(vars.each) * (wrapAt > l ? l - 1 : !axis ? Math.max(wrapAt, l / wrapAt) : axis === "y" ? l / wrapAt : wrapAt) || 0) * (from === "edges" ? -1 : 1);
            distances.b = l < 0 ? base - l : base;
            distances.u = getUnit(vars.amount || vars.each) || 0; //unit
            ease = ease && l < 0 ? _invertEase(ease) : ease;
        }
        l = (distances[i] - distances.min) / distances.max || 0;
        return _roundPrecise(distances.b + (ease ? ease(l) : l) * distances.v) + distances.u; //round in order to work around floating point errors
    };
}, _roundModifier = function _roundModifier(v) {
    //pass in 0.1 get a function that'll round to the nearest tenth, or 5 to round to the closest 5, or 0.001 to the closest 1000th, etc.
    var p = Math.pow(10, ((v + "").split(".")[1] || "").length); //to avoid floating point math errors (like 24 * 0.1 == 2.4000000000000004), we chop off at a specific number of decimal places (much faster than toFixed())
    return function(raw) {
        var n = _roundPrecise(Math.round(parseFloat(raw) / v) * v * p);
        return (n - n % 1) / p + (_isNumber(raw) ? 0 : getUnit(raw)); // n - n % 1 replaces Math.floor() in order to handle negative values properly. For example, Math.floor(-150.00000000000003) is 151!
    };
}, snap = function snap(snapTo, value) {
    var isArray = _isArray(snapTo), radius, is2D;
    if (!isArray && _isObject(snapTo)) {
        radius = isArray = snapTo.radius || _bigNum;
        if (snapTo.values) {
            snapTo = toArray(snapTo.values);
            if (is2D = !_isNumber(snapTo[0])) radius *= radius; //performance optimization so we don't have to Math.sqrt() in the loop.
        } else snapTo = _roundModifier(snapTo.increment);
    }
    return _conditionalReturn(value, !isArray ? _roundModifier(snapTo) : _isFunction(snapTo) ? function(raw) {
        is2D = snapTo(raw);
        return Math.abs(is2D - raw) <= radius ? is2D : raw;
    } : function(raw) {
        var x = parseFloat(is2D ? raw.x : raw), y = parseFloat(is2D ? raw.y : 0), min = _bigNum, closest = 0, i = snapTo.length, dx, dy;
        while(i--){
            if (is2D) {
                dx = snapTo[i].x - x;
                dy = snapTo[i].y - y;
                dx = dx * dx + dy * dy;
            } else dx = Math.abs(snapTo[i] - x);
            if (dx < min) {
                min = dx;
                closest = i;
            }
        }
        closest = !radius || min <= radius ? snapTo[closest] : raw;
        return is2D || closest === raw || _isNumber(raw) ? closest : closest + getUnit(raw);
    });
}, random = function random(min, max, roundingIncrement, returnFunction) {
    return _conditionalReturn(_isArray(min) ? !max : roundingIncrement === true ? (roundingIncrement = 0, false) : !returnFunction, function() {
        return _isArray(min) ? min[~~(Math.random() * min.length)] : (roundingIncrement = roundingIncrement || 1e-5, returnFunction = roundingIncrement < 1 ? Math.pow(10, (roundingIncrement + "").length - 2) : 1) && Math.floor(Math.round((min - roundingIncrement / 2 + Math.random() * (max - min + roundingIncrement * .99)) / roundingIncrement) * roundingIncrement * returnFunction) / returnFunction;
    });
}, pipe = function pipe() {
    for(var _len = arguments.length, functions = new Array(_len), _key = 0; _key < _len; _key++)functions[_key] = arguments[_key];
    return function(value) {
        return functions.reduce(function(v, f) {
            return f(v);
        }, value);
    };
}, unitize = function unitize(func, unit) {
    return function(value) {
        return func(parseFloat(value)) + (unit || getUnit(value));
    };
}, normalize = function normalize(min, max, value) {
    return mapRange(min, max, 0, 1, value);
}, _wrapArray = function _wrapArray(a, wrapper, value) {
    return _conditionalReturn(value, function(index) {
        return a[~~wrapper(index)];
    });
}, wrap = function wrap(min, max, value) {
    // NOTE: wrap() CANNOT be an arrow function! A very odd compiling bug causes problems (unrelated to GSAP).
    var range = max - min;
    return _isArray(min) ? _wrapArray(min, wrap(0, min.length), max) : _conditionalReturn(value, function(value) {
        return (range + (value - min) % range) % range + min;
    });
}, wrapYoyo = function wrapYoyo(min, max, value) {
    var range = max - min, total = range * 2;
    return _isArray(min) ? _wrapArray(min, wrapYoyo(0, min.length - 1), max) : _conditionalReturn(value, function(value) {
        value = (total + (value - min) % total) % total || 0;
        return min + (value > range ? total - value : value);
    });
}, _replaceRandom = function _replaceRandom(value) {
    //replaces all occurrences of random(...) in a string with the calculated random value. can be a range like random(-100, 100, 5) or an array like random([0, 100, 500])
    var prev = 0, s = "", i, nums, end, isArray;
    while(~(i = value.indexOf("random(", prev))){
        end = value.indexOf(")", i);
        isArray = value.charAt(i + 7) === "[";
        nums = value.substr(i + 7, end - i - 7).match(isArray ? _delimitedValueExp : _strictNumExp);
        s += value.substr(prev, i - prev) + random(isArray ? nums : +nums[0], isArray ? 0 : +nums[1], +nums[2] || 1e-5);
        prev = end + 1;
    }
    return s + value.substr(prev, value.length - prev);
}, mapRange = function mapRange(inMin, inMax, outMin, outMax, value) {
    var inRange = inMax - inMin, outRange = outMax - outMin;
    return _conditionalReturn(value, function(value) {
        return outMin + ((value - inMin) / inRange * outRange || 0);
    });
}, interpolate = function interpolate(start, end, progress, mutate) {
    var func = isNaN(start + end) ? 0 : function(p) {
        return (1 - p) * start + p * end;
    };
    if (!func) {
        var isString = _isString(start), master = {}, p, i, interpolators, l, il;
        progress === true && (mutate = 1) && (progress = null);
        if (isString) {
            start = {
                p: start
            };
            end = {
                p: end
            };
        } else if (_isArray(start) && !_isArray(end)) {
            interpolators = [];
            l = start.length;
            il = l - 2;
            for(i = 1; i < l; i++)interpolators.push(interpolate(start[i - 1], start[i])); //build the interpolators up front as a performance optimization so that when the function is called many times, it can just reuse them.
            l--;
            func = function func(p) {
                p *= l;
                var i = Math.min(il, ~~p);
                return interpolators[i](p - i);
            };
            progress = end;
        } else if (!mutate) start = _merge(_isArray(start) ? [] : {}, start);
        if (!interpolators) {
            for(p in end)_addPropTween.call(master, start, p, "get", end[p]);
            func = function func(p) {
                return _renderPropTweens(p, master) || (isString ? start.p : start);
            };
        }
    }
    return _conditionalReturn(progress, func);
}, _getLabelInDirection = function _getLabelInDirection(timeline, fromTime, backward) {
    //used for nextLabel() and previousLabel()
    var labels = timeline.labels, min = _bigNum, p, distance, label;
    for(p in labels){
        distance = labels[p] - fromTime;
        if (distance < 0 === !!backward && distance && min > (distance = Math.abs(distance))) {
            label = p;
            min = distance;
        }
    }
    return label;
}, _callback = function _callback(animation, type, executeLazyFirst) {
    var v = animation.vars, callback = v[type], prevContext = _context, context = animation._ctx, params, scope, result;
    if (!callback) return;
    params = v[type + "Params"];
    scope = v.callbackScope || animation;
    executeLazyFirst && _lazyTweens.length && _lazyRender(); //in case rendering caused any tweens to lazy-init, we should render them because typically when a timeline finishes, users expect things to have rendered fully. Imagine an onUpdate on a timeline that reports/checks tweened values.
    context && (_context = context);
    result = params ? callback.apply(scope, params) : callback.call(scope);
    _context = prevContext;
    return result;
}, _interrupt = function _interrupt(animation) {
    _removeFromParent(animation);
    animation.scrollTrigger && animation.scrollTrigger.kill(!!_reverting);
    animation.progress() < 1 && _callback(animation, "onInterrupt");
    return animation;
}, _quickTween, _registerPluginQueue = [], _createPlugin = function _createPlugin(config) {
    if (_windowExists() && config) {
        // edge case: some build tools may pass in a null/undefined value
        config = !config.name && config["default"] || config; //UMD packaging wraps things oddly, so for example MotionPathHelper becomes {MotionPathHelper:MotionPathHelper, default:MotionPathHelper}.
        var name = config.name, isFunc = _isFunction(config), Plugin = name && !isFunc && config.init ? function() {
            this._props = [];
        } : config, //in case someone passes in an object that's not a plugin, like CustomEase
        instanceDefaults = {
            init: _emptyFunc,
            render: _renderPropTweens,
            add: _addPropTween,
            kill: _killPropTweensOf,
            modifier: _addPluginModifier,
            rawVars: 0
        }, statics = {
            targetTest: 0,
            get: 0,
            getSetter: _getSetter,
            aliases: {},
            register: 0
        };
        _wake();
        if (config !== Plugin) {
            if (_plugins[name]) return;
            _setDefaults(Plugin, _setDefaults(_copyExcluding(config, instanceDefaults), statics)); //static methods
            _merge(Plugin.prototype, _merge(instanceDefaults, _copyExcluding(config, statics))); //instance methods
            _plugins[Plugin.prop = name] = Plugin;
            if (config.targetTest) {
                _harnessPlugins.push(Plugin);
                _reservedProps[name] = 1;
            }
            name = (name === "css" ? "CSS" : name.charAt(0).toUpperCase() + name.substr(1)) + "Plugin"; //for the global name. "motionPath" should become MotionPathPlugin
        }
        _addGlobal(name, Plugin);
        config.register && config.register(gsap, Plugin, PropTween);
    } else config && _registerPluginQueue.push(config);
}, /*
 * --------------------------------------------------------------------------------------
 * COLORS
 * --------------------------------------------------------------------------------------
 */ _255 = 255, _colorLookup = {
    aqua: [
        0,
        _255,
        _255
    ],
    lime: [
        0,
        _255,
        0
    ],
    silver: [
        192,
        192,
        192
    ],
    black: [
        0,
        0,
        0
    ],
    maroon: [
        128,
        0,
        0
    ],
    teal: [
        0,
        128,
        128
    ],
    blue: [
        0,
        0,
        _255
    ],
    navy: [
        0,
        0,
        128
    ],
    white: [
        _255,
        _255,
        _255
    ],
    olive: [
        128,
        128,
        0
    ],
    yellow: [
        _255,
        _255,
        0
    ],
    orange: [
        _255,
        165,
        0
    ],
    gray: [
        128,
        128,
        128
    ],
    purple: [
        128,
        0,
        128
    ],
    green: [
        0,
        128,
        0
    ],
    red: [
        _255,
        0,
        0
    ],
    pink: [
        _255,
        192,
        203
    ],
    cyan: [
        0,
        _255,
        _255
    ],
    transparent: [
        _255,
        _255,
        _255,
        0
    ]
}, // possible future idea to replace the hard-coded color name values - put this in the ticker.wake() where we set the _doc:
// let ctx = _doc.createElement("canvas").getContext("2d");
// _forEachName("aqua,lime,silver,black,maroon,teal,blue,navy,white,olive,yellow,orange,gray,purple,green,red,pink,cyan", color => {ctx.fillStyle = color; _colorLookup[color] = splitColor(ctx.fillStyle)});
_hue = function _hue(h, m1, m2) {
    h += h < 0 ? 1 : h > 1 ? -1 : 0;
    return (h * 6 < 1 ? m1 + (m2 - m1) * h * 6 : h < .5 ? m2 : h * 3 < 2 ? m1 + (m2 - m1) * (2 / 3 - h) * 6 : m1) * _255 + .5 | 0;
}, splitColor = function splitColor(v, toHSL, forceAlpha) {
    var a = !v ? _colorLookup.black : _isNumber(v) ? [
        v >> 16,
        v >> 8 & _255,
        v & _255
    ] : 0, r, g, b, h, s, l, max, min, d, wasHSL;
    if (!a) {
        if (v.substr(-1) === ",") //sometimes a trailing comma is included and we should chop it off (typically from a comma-delimited list of values like a textShadow:"2px 2px 2px blue, 5px 5px 5px rgb(255,0,0)" - in this example "blue," has a trailing comma. We could strip it out inside parseComplex() but we'd need to do it to the beginning and ending values plus it wouldn't provide protection from other potential scenarios like if the user passes in a similar value.
        v = v.substr(0, v.length - 1);
        if (_colorLookup[v]) a = _colorLookup[v];
        else if (v.charAt(0) === "#") {
            if (v.length < 6) {
                //for shorthand like #9F0 or #9F0F (could have alpha)
                r = v.charAt(1);
                g = v.charAt(2);
                b = v.charAt(3);
                v = "#" + r + r + g + g + b + b + (v.length === 5 ? v.charAt(4) + v.charAt(4) : "");
            }
            if (v.length === 9) {
                // hex with alpha, like #fd5e53ff
                a = parseInt(v.substr(1, 6), 16);
                return [
                    a >> 16,
                    a >> 8 & _255,
                    a & _255,
                    parseInt(v.substr(7), 16) / 255
                ];
            }
            v = parseInt(v.substr(1), 16);
            a = [
                v >> 16,
                v >> 8 & _255,
                v & _255
            ];
        } else if (v.substr(0, 3) === "hsl") {
            a = wasHSL = v.match(_strictNumExp);
            if (!toHSL) {
                h = +a[0] % 360 / 360;
                s = +a[1] / 100;
                l = +a[2] / 100;
                g = l <= .5 ? l * (s + 1) : l + s - l * s;
                r = l * 2 - g;
                a.length > 3 && (a[3] *= 1); //cast as number
                a[0] = _hue(h + 1 / 3, r, g);
                a[1] = _hue(h, r, g);
                a[2] = _hue(h - 1 / 3, r, g);
            } else if (~v.indexOf("=")) {
                //if relative values are found, just return the raw strings with the relative prefixes in place.
                a = v.match(_numExp);
                forceAlpha && a.length < 4 && (a[3] = 1);
                return a;
            }
        } else a = v.match(_strictNumExp) || _colorLookup.transparent;
        a = a.map(Number);
    }
    if (toHSL && !wasHSL) {
        r = a[0] / _255;
        g = a[1] / _255;
        b = a[2] / _255;
        max = Math.max(r, g, b);
        min = Math.min(r, g, b);
        l = (max + min) / 2;
        if (max === min) h = s = 0;
        else {
            d = max - min;
            s = l > 0.5 ? d / (2 - max - min) : d / (max + min);
            h = max === r ? (g - b) / d + (g < b ? 6 : 0) : max === g ? (b - r) / d + 2 : (r - g) / d + 4;
            h *= 60;
        }
        a[0] = ~~(h + .5);
        a[1] = ~~(s * 100 + .5);
        a[2] = ~~(l * 100 + .5);
    }
    forceAlpha && a.length < 4 && (a[3] = 1);
    return a;
}, _colorOrderData = function _colorOrderData(v) {
    // strips out the colors from the string, finds all the numeric slots (with units) and returns an array of those. The Array also has a "c" property which is an Array of the index values where the colors belong. This is to help work around issues where there's a mis-matched order of color/numeric data like drop-shadow(#f00 0px 1px 2px) and drop-shadow(0x 1px 2px #f00). This is basically a helper function used in _formatColors()
    var values = [], c = [], i = -1;
    v.split(_colorExp).forEach(function(v) {
        var a = v.match(_numWithUnitExp) || [];
        values.push.apply(values, a);
        c.push(i += a.length + 1);
    });
    values.c = c;
    return values;
}, _formatColors = function _formatColors(s, toHSL, orderMatchData) {
    var result = "", colors = (s + result).match(_colorExp), type = toHSL ? "hsla(" : "rgba(", i = 0, c, shell, d, l;
    if (!colors) return s;
    colors = colors.map(function(color) {
        return (color = splitColor(color, toHSL, 1)) && type + (toHSL ? color[0] + "," + color[1] + "%," + color[2] + "%," + color[3] : color.join(",")) + ")";
    });
    if (orderMatchData) {
        d = _colorOrderData(s);
        c = orderMatchData.c;
        if (c.join(result) !== d.c.join(result)) {
            shell = s.replace(_colorExp, "1").split(_numWithUnitExp);
            l = shell.length - 1;
            for(; i < l; i++)result += shell[i] + (~c.indexOf(i) ? colors.shift() || type + "0,0,0,0)" : (d.length ? d : colors.length ? colors : orderMatchData).shift());
        }
    }
    if (!shell) {
        shell = s.split(_colorExp);
        l = shell.length - 1;
        for(; i < l; i++)result += shell[i] + colors[i];
    }
    return result + shell[l];
}, _colorExp = function() {
    var s = "(?:\\b(?:(?:rgb|rgba|hsl|hsla)\\(.+?\\))|\\B#(?:[0-9a-f]{3,4}){1,2}\\b", //we'll dynamically build this Regular Expression to conserve file size. After building it, it will be able to find rgb(), rgba(), # (hexadecimal), and named color values like red, blue, purple, etc.,
    p;
    for(p in _colorLookup)s += "|" + p + "\\b";
    return new RegExp(s + ")", "gi");
}(), _hslExp = /hsl[a]?\(/, _colorStringFilter = function _colorStringFilter(a) {
    var combined = a.join(" "), toHSL;
    _colorExp.lastIndex = 0;
    if (_colorExp.test(combined)) {
        toHSL = _hslExp.test(combined);
        a[1] = _formatColors(a[1], toHSL);
        a[0] = _formatColors(a[0], toHSL, _colorOrderData(a[1])); // make sure the order of numbers/colors match with the END value.
        return true;
    }
}, /*
 * --------------------------------------------------------------------------------------
 * TICKER
 * --------------------------------------------------------------------------------------
 */ _tickerActive, _ticker = function() {
    var _getTime = Date.now, _lagThreshold = 500, _adjustedLag = 33, _startTime = _getTime(), _lastUpdate = _startTime, _gap = 1000 / 240, _nextTime = _gap, _listeners = [], _id, _req, _raf, _self, _delta, _i, _tick = function _tick(v) {
        var elapsed = _getTime() - _lastUpdate, manual = v === true, overlap, dispatch, time, frame;
        elapsed > _lagThreshold && (_startTime += elapsed - _adjustedLag);
        _lastUpdate += elapsed;
        time = _lastUpdate - _startTime;
        overlap = time - _nextTime;
        if (overlap > 0 || manual) {
            frame = ++_self.frame;
            _delta = time - _self.time * 1000;
            _self.time = time = time / 1000;
            _nextTime += overlap + (overlap >= _gap ? 4 : _gap - overlap);
            dispatch = 1;
        }
        manual || (_id = _req(_tick)); //make sure the request is made before we dispatch the "tick" event so that timing is maintained. Otherwise, if processing the "tick" requires a bunch of time (like 15ms) and we're using a setTimeout() that's based on 16.7ms, it'd technically take 31.7ms between frames otherwise.
        if (dispatch) for(_i = 0; _i < _listeners.length; _i++)// use _i and check _listeners.length instead of a variable because a listener could get removed during the loop, and if that happens to an element less than the current index, it'd throw things off in the loop.
        _listeners[_i](time, _delta, frame, v);
    };
    _self = {
        time: 0,
        frame: 0,
        tick: function tick() {
            _tick(true);
        },
        deltaRatio: function deltaRatio(fps) {
            return _delta / (1000 / (fps || 60));
        },
        wake: function wake() {
            if (_coreReady) {
                if (!_coreInitted && _windowExists()) {
                    _win = _coreInitted = window;
                    _doc = _win.document || {};
                    _globals.gsap = gsap;
                    (_win.gsapVersions || (_win.gsapVersions = [])).push(gsap.version);
                    _install(_installScope || _win.GreenSockGlobals || !_win.gsap && _win || {});
                    _raf = _win.requestAnimationFrame;
                    _registerPluginQueue.forEach(_createPlugin);
                }
                _id && _self.sleep();
                _req = _raf || function(f) {
                    return setTimeout(f, _nextTime - _self.time * 1000 + 1 | 0);
                };
                _tickerActive = 1;
                _tick(2);
            }
        },
        sleep: function sleep() {
            (_raf ? _win.cancelAnimationFrame : clearTimeout)(_id);
            _tickerActive = 0;
            _req = _emptyFunc;
        },
        lagSmoothing: function lagSmoothing(threshold, adjustedLag) {
            _lagThreshold = threshold || Infinity; // zero should be interpreted as basically unlimited
            _adjustedLag = Math.min(adjustedLag || 33, _lagThreshold);
        },
        fps: function fps(_fps) {
            _gap = 1000 / (_fps || 240);
            _nextTime = _self.time * 1000 + _gap;
        },
        add: function add(callback, once, prioritize) {
            var func = once ? function(t, d, f, v) {
                callback(t, d, f, v);
                _self.remove(func);
            } : callback;
            _self.remove(callback);
            _listeners[prioritize ? "unshift" : "push"](func);
            _wake();
            return func;
        },
        remove: function remove(callback, i) {
            ~(i = _listeners.indexOf(callback)) && _listeners.splice(i, 1) && _i >= i && _i--;
        },
        _listeners: _listeners
    };
    return _self;
}(), _wake = function _wake() {
    return !_tickerActive && _ticker.wake();
}, //also ensures the core classes are initialized.
/*
* -------------------------------------------------
* EASING
* -------------------------------------------------
*/ _easeMap = {}, _customEaseExp = /^[\d.\-M][\d.\-,\s]/, _quotesExp = /["']/g, _parseObjectInString = function _parseObjectInString(value) {
    //takes a string like "{wiggles:10, type:anticipate})" and turns it into a real object. Notice it ends in ")" and includes the {} wrappers. This is because we only use this function for parsing ease configs and prioritized optimization rather than reusability.
    var obj = {}, split = value.substr(1, value.length - 3).split(":"), key = split[0], i = 1, l = split.length, index, val, parsedVal;
    for(; i < l; i++){
        val = split[i];
        index = i !== l - 1 ? val.lastIndexOf(",") : val.length;
        parsedVal = val.substr(0, index);
        obj[key] = isNaN(parsedVal) ? parsedVal.replace(_quotesExp, "").trim() : +parsedVal;
        key = val.substr(index + 1).trim();
    }
    return obj;
}, _valueInParentheses = function _valueInParentheses(value) {
    var open = value.indexOf("(") + 1, close = value.indexOf(")"), nested = value.indexOf("(", open);
    return value.substring(open, ~nested && nested < close ? value.indexOf(")", close + 1) : close);
}, _configEaseFromString = function _configEaseFromString(name) {
    //name can be a string like "elastic.out(1,0.5)", and pass in _easeMap as obj and it'll parse it out and call the actual function like _easeMap.Elastic.easeOut.config(1,0.5). It will also parse custom ease strings as long as CustomEase is loaded and registered (internally as _easeMap._CE).
    var split = (name + "").split("("), ease = _easeMap[split[0]];
    return ease && split.length > 1 && ease.config ? ease.config.apply(null, ~name.indexOf("{") ? [
        _parseObjectInString(split[1])
    ] : _valueInParentheses(name).split(",").map(_numericIfPossible)) : _easeMap._CE && _customEaseExp.test(name) ? _easeMap._CE("", name) : ease;
}, _invertEase = function _invertEase(ease) {
    return function(p) {
        return 1 - ease(1 - p);
    };
}, // allow yoyoEase to be set in children and have those affected when the parent/ancestor timeline yoyos.
_propagateYoyoEase = function _propagateYoyoEase(timeline, isYoyo) {
    var child = timeline._first, ease;
    while(child){
        if (child instanceof Timeline) _propagateYoyoEase(child, isYoyo);
        else if (child.vars.yoyoEase && (!child._yoyo || !child._repeat) && child._yoyo !== isYoyo) {
            if (child.timeline) _propagateYoyoEase(child.timeline, isYoyo);
            else {
                ease = child._ease;
                child._ease = child._yEase;
                child._yEase = ease;
                child._yoyo = isYoyo;
            }
        }
        child = child._next;
    }
}, _parseEase = function _parseEase(ease, defaultEase) {
    return !ease ? defaultEase : (_isFunction(ease) ? ease : _easeMap[ease] || _configEaseFromString(ease)) || defaultEase;
}, _insertEase = function _insertEase(names, easeIn, easeOut, easeInOut) {
    if (easeOut === void 0) easeOut = function easeOut(p) {
        return 1 - easeIn(1 - p);
    };
    if (easeInOut === void 0) easeInOut = function easeInOut(p) {
        return p < .5 ? easeIn(p * 2) / 2 : 1 - easeIn((1 - p) * 2) / 2;
    };
    var ease = {
        easeIn: easeIn,
        easeOut: easeOut,
        easeInOut: easeInOut
    }, lowercaseName;
    _forEachName(names, function(name) {
        _easeMap[name] = _globals[name] = ease;
        _easeMap[lowercaseName = name.toLowerCase()] = easeOut;
        for(var p in ease)_easeMap[lowercaseName + (p === "easeIn" ? ".in" : p === "easeOut" ? ".out" : ".inOut")] = _easeMap[name + "." + p] = ease[p];
    });
    return ease;
}, _easeInOutFromOut = function _easeInOutFromOut(easeOut) {
    return function(p) {
        return p < .5 ? (1 - easeOut(1 - p * 2)) / 2 : .5 + easeOut((p - .5) * 2) / 2;
    };
}, _configElastic = function _configElastic(type, amplitude, period) {
    var p1 = amplitude >= 1 ? amplitude : 1, //note: if amplitude is < 1, we simply adjust the period for a more natural feel. Otherwise the math doesn't work right and the curve starts at 1.
    p2 = (period || (type ? .3 : .45)) / (amplitude < 1 ? amplitude : 1), p3 = p2 / _2PI * (Math.asin(1 / p1) || 0), easeOut = function easeOut(p) {
        return p === 1 ? 1 : p1 * Math.pow(2, -10 * p) * _sin((p - p3) * p2) + 1;
    }, ease = type === "out" ? easeOut : type === "in" ? function(p) {
        return 1 - easeOut(1 - p);
    } : _easeInOutFromOut(easeOut);
    p2 = _2PI / p2; //precalculate to optimize
    ease.config = function(amplitude, period) {
        return _configElastic(type, amplitude, period);
    };
    return ease;
}, _configBack = function _configBack(type, overshoot) {
    if (overshoot === void 0) overshoot = 1.70158;
    var easeOut = function easeOut(p) {
        return p ? --p * p * ((overshoot + 1) * p + overshoot) + 1 : 0;
    }, ease = type === "out" ? easeOut : type === "in" ? function(p) {
        return 1 - easeOut(1 - p);
    } : _easeInOutFromOut(easeOut);
    ease.config = function(overshoot) {
        return _configBack(type, overshoot);
    };
    return ease;
}; // a cheaper (kb and cpu) but more mild way to get a parameterized weighted ease by feeding in a value between -1 (easeIn) and 1 (easeOut) where 0 is linear.
// _weightedEase = ratio => {
// 	let y = 0.5 + ratio / 2;
// 	return p => (2 * (1 - p) * p * y + p * p);
// },
// a stronger (but more expensive kb/cpu) parameterized weighted ease that lets you feed in a value between -1 (easeIn) and 1 (easeOut) where 0 is linear.
// _weightedEaseStrong = ratio => {
// 	ratio = .5 + ratio / 2;
// 	let o = 1 / 3 * (ratio < .5 ? ratio : 1 - ratio),
// 		b = ratio - o,
// 		c = ratio + o;
// 	return p => p === 1 ? p : 3 * b * (1 - p) * (1 - p) * p + 3 * c * (1 - p) * p * p + p * p * p;
// };
_forEachName("Linear,Quad,Cubic,Quart,Quint,Strong", function(name, i) {
    var power = i < 5 ? i + 1 : i;
    _insertEase(name + ",Power" + (power - 1), i ? function(p) {
        return Math.pow(p, power);
    } : function(p) {
        return p;
    }, function(p) {
        return 1 - Math.pow(1 - p, power);
    }, function(p) {
        return p < .5 ? Math.pow(p * 2, power) / 2 : 1 - Math.pow((1 - p) * 2, power) / 2;
    });
});
_easeMap.Linear.easeNone = _easeMap.none = _easeMap.Linear.easeIn;
_insertEase("Elastic", _configElastic("in"), _configElastic("out"), _configElastic());
(function(n, c) {
    var n1 = 1 / c, n2 = 2 * n1, n3 = 2.5 * n1, easeOut = function easeOut(p) {
        return p < n1 ? n * p * p : p < n2 ? n * Math.pow(p - 1.5 / c, 2) + .75 : p < n3 ? n * (p -= 2.25 / c) * p + .9375 : n * Math.pow(p - 2.625 / c, 2) + .984375;
    };
    _insertEase("Bounce", function(p) {
        return 1 - easeOut(1 - p);
    }, easeOut);
})(7.5625, 2.75);
_insertEase("Expo", function(p) {
    return p ? Math.pow(2, 10 * (p - 1)) : 0;
});
_insertEase("Circ", function(p) {
    return -(_sqrt(1 - p * p) - 1);
});
_insertEase("Sine", function(p) {
    return p === 1 ? 1 : -_cos(p * _HALF_PI) + 1;
});
_insertEase("Back", _configBack("in"), _configBack("out"), _configBack());
_easeMap.SteppedEase = _easeMap.steps = _globals.SteppedEase = {
    config: function config(steps, immediateStart) {
        if (steps === void 0) steps = 1;
        var p1 = 1 / steps, p2 = steps + (immediateStart ? 0 : 1), p3 = immediateStart ? 1 : 0, max = 1 - _tinyNum;
        return function(p) {
            return ((p2 * _clamp(0, max, p) | 0) + p3) * p1;
        };
    }
};
_defaults.ease = _easeMap["quad.out"];
_forEachName("onComplete,onUpdate,onStart,onRepeat,onReverseComplete,onInterrupt", function(name) {
    return _callbackNames += name + "," + name + "Params,";
});
var GSCache = function GSCache(target, harness) {
    this.id = _gsID++;
    target._gsap = this;
    this.target = target;
    this.harness = harness;
    this.get = harness ? harness.get : _getProperty;
    this.set = harness ? harness.getSetter : _getSetter;
};
var Animation = /*#__PURE__*/ function() {
    function Animation(vars) {
        this.vars = vars;
        this._delay = +vars.delay || 0;
        if (this._repeat = vars.repeat === Infinity ? -2 : vars.repeat || 0) {
            // TODO: repeat: Infinity on a timeline's children must flag that timeline internally and affect its totalDuration, otherwise it'll stop in the negative direction when reaching the start.
            this._rDelay = vars.repeatDelay || 0;
            this._yoyo = !!vars.yoyo || !!vars.yoyoEase;
        }
        this._ts = 1;
        _setDuration(this, +vars.duration, 1, 1);
        this.data = vars.data;
        if (_context) {
            this._ctx = _context;
            _context.data.push(this);
        }
        _tickerActive || _ticker.wake();
    }
    var _proto = Animation.prototype;
    _proto.delay = function delay(value) {
        if (value || value === 0) {
            this.parent && this.parent.smoothChildTiming && this.startTime(this._start + value - this._delay);
            this._delay = value;
            return this;
        }
        return this._delay;
    };
    _proto.duration = function duration(value) {
        return arguments.length ? this.totalDuration(this._repeat > 0 ? value + (value + this._rDelay) * this._repeat : value) : this.totalDuration() && this._dur;
    };
    _proto.totalDuration = function totalDuration(value) {
        if (!arguments.length) return this._tDur;
        this._dirty = 0;
        return _setDuration(this, this._repeat < 0 ? value : (value - this._repeat * this._rDelay) / (this._repeat + 1));
    };
    _proto.totalTime = function totalTime(_totalTime, suppressEvents) {
        _wake();
        if (!arguments.length) return this._tTime;
        var parent = this._dp;
        if (parent && parent.smoothChildTiming && this._ts) {
            _alignPlayhead(this, _totalTime);
            !parent._dp || parent.parent || _postAddChecks(parent, this); // edge case: if this is a child of a timeline that already completed, for example, we must re-activate the parent.
            //in case any of the ancestor timelines had completed but should now be enabled, we should reset their totalTime() which will also ensure that they're lined up properly and enabled. Skip for animations that are on the root (wasteful). Example: a TimelineLite.exportRoot() is performed when there's a paused tween on the root, the export will not complete until that tween is unpaused, but imagine a child gets restarted later, after all [unpaused] tweens have completed. The start of that child would get pushed out, but one of the ancestors may have completed.
            while(parent && parent.parent){
                if (parent.parent._time !== parent._start + (parent._ts >= 0 ? parent._tTime / parent._ts : (parent.totalDuration() - parent._tTime) / -parent._ts)) parent.totalTime(parent._tTime, true);
                parent = parent.parent;
            }
            if (!this.parent && this._dp.autoRemoveChildren && (this._ts > 0 && _totalTime < this._tDur || this._ts < 0 && _totalTime > 0 || !this._tDur && !_totalTime)) //if the animation doesn't have a parent, put it back into its last parent (recorded as _dp for exactly cases like this). Limit to parents with autoRemoveChildren (like globalTimeline) so that if the user manually removes an animation from a timeline and then alters its playhead, it doesn't get added back in.
            _addToTimeline(this._dp, this, this._start - this._delay);
        }
        if (this._tTime !== _totalTime || !this._dur && !suppressEvents || this._initted && Math.abs(this._zTime) === _tinyNum || !_totalTime && !this._initted && (this.add || this._ptLookup)) {
            // check for _ptLookup on a Tween instance to ensure it has actually finished being instantiated, otherwise if this.reverse() gets called in the Animation constructor, it could trigger a render() here even though the _targets weren't populated, thus when _init() is called there won't be any PropTweens (it'll act like the tween is non-functional)
            this._ts || (this._pTime = _totalTime); // otherwise, if an animation is paused, then the playhead is moved back to zero, then resumed, it'd revert back to the original time at the pause
            //if (!this._lock) { // avoid endless recursion (not sure we need this yet or if it's worth the performance hit)
            //   this._lock = 1;
            _lazySafeRender(this, _totalTime, suppressEvents); //   this._lock = 0;
        //}
        }
        return this;
    };
    _proto.time = function time(value, suppressEvents) {
        return arguments.length ? this.totalTime(Math.min(this.totalDuration(), value + _elapsedCycleDuration(this)) % (this._dur + this._rDelay) || (value ? this._dur : 0), suppressEvents) : this._time; // note: if the modulus results in 0, the playhead could be exactly at the end or the beginning, and we always defer to the END with a non-zero value, otherwise if you set the time() to the very end (duration()), it would render at the START!
    };
    _proto.totalProgress = function totalProgress(value, suppressEvents) {
        return arguments.length ? this.totalTime(this.totalDuration() * value, suppressEvents) : this.totalDuration() ? Math.min(1, this._tTime / this._tDur) : this.ratio;
    };
    _proto.progress = function progress(value, suppressEvents) {
        return arguments.length ? this.totalTime(this.duration() * (this._yoyo && !(this.iteration() & 1) ? 1 - value : value) + _elapsedCycleDuration(this), suppressEvents) : this.duration() ? Math.min(1, this._time / this._dur) : this.ratio;
    };
    _proto.iteration = function iteration(value, suppressEvents) {
        var cycleDuration = this.duration() + this._rDelay;
        return arguments.length ? this.totalTime(this._time + (value - 1) * cycleDuration, suppressEvents) : this._repeat ? _animationCycle(this._tTime, cycleDuration) + 1 : 1;
    } // potential future addition:
    ;
    _proto.timeScale = function timeScale(value) {
        if (!arguments.length) return this._rts === -_tinyNum ? 0 : this._rts; // recorded timeScale. Special case: if someone calls reverse() on an animation with timeScale of 0, we assign it -_tinyNum to remember it's reversed.
        if (this._rts === value) return this;
        var tTime = this.parent && this._ts ? _parentToChildTotalTime(this.parent._time, this) : this._tTime; // make sure to do the parentToChildTotalTime() BEFORE setting the new _ts because the old one must be used in that calculation.
        // future addition? Up side: fast and minimal file size. Down side: only works on this animation; if a timeline is reversed, for example, its childrens' onReverse wouldn't get called.
        //(+value < 0 && this._rts >= 0) && _callback(this, "onReverse", true);
        // prioritize rendering where the parent's playhead lines up instead of this._tTime because there could be a tween that's animating another tween's timeScale in the same rendering loop (same parent), thus if the timeScale tween renders first, it would alter _start BEFORE _tTime was set on that tick (in the rendering loop), effectively freezing it until the timeScale tween finishes.
        this._rts = +value || 0;
        this._ts = this._ps || value === -_tinyNum ? 0 : this._rts; // _ts is the functional timeScale which would be 0 if the animation is paused.
        this.totalTime(_clamp(-Math.abs(this._delay), this._tDur, tTime), true);
        _setEnd(this); // if parent.smoothChildTiming was false, the end time didn't get updated in the _alignPlayhead() method, so do it here.
        return _recacheAncestors(this);
    };
    _proto.paused = function paused(value) {
        if (!arguments.length) return this._ps;
        if (this._ps !== value) {
            this._ps = value;
            if (value) {
                this._pTime = this._tTime || Math.max(-this._delay, this.rawTime()); // if the pause occurs during the delay phase, make sure that's factored in when resuming.
                this._ts = this._act = 0; // _ts is the functional timeScale, so a paused tween would effectively have a timeScale of 0. We record the "real" timeScale as _rts (recorded time scale)
            } else {
                _wake();
                this._ts = this._rts; //only defer to _pTime (pauseTime) if tTime is zero. Remember, someone could pause() an animation, then scrub the playhead and resume(). If the parent doesn't have smoothChildTiming, we render at the rawTime() because the startTime won't get updated.
                this.totalTime(this.parent && !this.parent.smoothChildTiming ? this.rawTime() : this._tTime || this._pTime, this.progress() === 1 && Math.abs(this._zTime) !== _tinyNum && (this._tTime -= _tinyNum)); // edge case: animation.progress(1).pause().play() wouldn't render again because the playhead is already at the end, but the call to totalTime() below will add it back to its parent...and not remove it again (since removing only happens upon rendering at a new time). Offsetting the _tTime slightly is done simply to cause the final render in totalTime() that'll pop it off its timeline (if autoRemoveChildren is true, of course). Check to make sure _zTime isn't -_tinyNum to avoid an edge case where the playhead is pushed to the end but INSIDE a tween/callback, the timeline itself is paused thus halting rendering and leaving a few unrendered. When resuming, it wouldn't render those otherwise.
            }
        }
        return this;
    };
    _proto.startTime = function startTime(value) {
        if (arguments.length) {
            this._start = value;
            var parent = this.parent || this._dp;
            parent && (parent._sort || !this.parent) && _addToTimeline(parent, this, value - this._delay);
            return this;
        }
        return this._start;
    };
    _proto.endTime = function endTime(includeRepeats) {
        return this._start + (_isNotFalse(includeRepeats) ? this.totalDuration() : this.duration()) / Math.abs(this._ts || 1);
    };
    _proto.rawTime = function rawTime(wrapRepeats) {
        var parent = this.parent || this._dp; // _dp = detached parent
        return !parent ? this._tTime : wrapRepeats && (!this._ts || this._repeat && this._time && this.totalProgress() < 1) ? this._tTime % (this._dur + this._rDelay) : !this._ts ? this._tTime : _parentToChildTotalTime(parent.rawTime(wrapRepeats), this);
    };
    _proto.revert = function revert(config) {
        if (config === void 0) config = _revertConfig;
        var prevIsReverting = _reverting;
        _reverting = config;
        if (this._initted || this._startAt) {
            this.timeline && this.timeline.revert(config);
            this.totalTime(-0.01, config.suppressEvents);
        }
        this.data !== "nested" && config.kill !== false && this.kill();
        _reverting = prevIsReverting;
        return this;
    };
    _proto.globalTime = function globalTime(rawTime) {
        var animation = this, time = arguments.length ? rawTime : animation.rawTime();
        while(animation){
            time = animation._start + time / (animation._ts || 1);
            animation = animation._dp;
        }
        return !this.parent && this._sat ? this._sat.vars.immediateRender ? -Infinity : this._sat.globalTime(rawTime) : time; // the _startAt tweens for .fromTo() and .from() that have immediateRender should always be FIRST in the timeline (important for context.revert()). "_sat" stands for _startAtTween, referring to the parent tween that created the _startAt. We must discern if that tween had immediateRender so that we can know whether or not to prioritize it in revert().
    };
    _proto.repeat = function repeat(value) {
        if (arguments.length) {
            this._repeat = value === Infinity ? -2 : value;
            return _onUpdateTotalDuration(this);
        }
        return this._repeat === -2 ? Infinity : this._repeat;
    };
    _proto.repeatDelay = function repeatDelay(value) {
        if (arguments.length) {
            var time = this._time;
            this._rDelay = value;
            _onUpdateTotalDuration(this);
            return time ? this.time(time) : this;
        }
        return this._rDelay;
    };
    _proto.yoyo = function yoyo(value) {
        if (arguments.length) {
            this._yoyo = value;
            return this;
        }
        return this._yoyo;
    };
    _proto.seek = function seek(position, suppressEvents) {
        return this.totalTime(_parsePosition(this, position), _isNotFalse(suppressEvents));
    };
    _proto.restart = function restart(includeDelay, suppressEvents) {
        return this.play().totalTime(includeDelay ? -this._delay : 0, _isNotFalse(suppressEvents));
    };
    _proto.play = function play(from, suppressEvents) {
        from != null && this.seek(from, suppressEvents);
        return this.reversed(false).paused(false);
    };
    _proto.reverse = function reverse(from, suppressEvents) {
        from != null && this.seek(from || this.totalDuration(), suppressEvents);
        return this.reversed(true).paused(false);
    };
    _proto.pause = function pause(atTime, suppressEvents) {
        atTime != null && this.seek(atTime, suppressEvents);
        return this.paused(true);
    };
    _proto.resume = function resume() {
        return this.paused(false);
    };
    _proto.reversed = function reversed(value) {
        if (arguments.length) {
            !!value !== this.reversed() && this.timeScale(-this._rts || (value ? -_tinyNum : 0)); // in case timeScale is zero, reversing would have no effect so we use _tinyNum.
            return this;
        }
        return this._rts < 0;
    };
    _proto.invalidate = function invalidate() {
        this._initted = this._act = 0;
        this._zTime = -_tinyNum;
        return this;
    };
    _proto.isActive = function isActive() {
        var parent = this.parent || this._dp, start = this._start, rawTime;
        return !!(!parent || this._ts && this._initted && parent.isActive() && (rawTime = parent.rawTime(true)) >= start && rawTime < this.endTime(true) - _tinyNum);
    };
    _proto.eventCallback = function eventCallback(type, callback, params) {
        var vars = this.vars;
        if (arguments.length > 1) {
            if (!callback) delete vars[type];
            else {
                vars[type] = callback;
                params && (vars[type + "Params"] = params);
                type === "onUpdate" && (this._onUpdate = callback);
            }
            return this;
        }
        return vars[type];
    };
    _proto.then = function then(onFulfilled) {
        var self = this;
        return new Promise(function(resolve) {
            var f = _isFunction(onFulfilled) ? onFulfilled : _passThrough, _resolve = function _resolve() {
                var _then = self.then;
                self.then = null; // temporarily null the then() method to avoid an infinite loop (see https://github.com/greensock/GSAP/issues/322)
                _isFunction(f) && (f = f(self)) && (f.then || f === self) && (self.then = _then);
                resolve(f);
                self.then = _then;
            };
            if (self._initted && self.totalProgress() === 1 && self._ts >= 0 || !self._tTime && self._ts < 0) _resolve();
            else self._prom = _resolve;
        });
    };
    _proto.kill = function kill() {
        _interrupt(this);
    };
    return Animation;
}();
_setDefaults(Animation.prototype, {
    _time: 0,
    _start: 0,
    _end: 0,
    _tTime: 0,
    _tDur: 0,
    _dirty: 0,
    _repeat: 0,
    _yoyo: false,
    parent: null,
    _initted: false,
    _rDelay: 0,
    _ts: 1,
    _dp: 0,
    ratio: 0,
    _zTime: -_tinyNum,
    _prom: 0,
    _ps: false,
    _rts: 1
});
var Timeline = /*#__PURE__*/ function(_Animation) {
    _inheritsLoose(Timeline, _Animation);
    function Timeline(vars, position) {
        var _this;
        if (vars === void 0) vars = {};
        _this = _Animation.call(this, vars) || this;
        _this.labels = {};
        _this.smoothChildTiming = !!vars.smoothChildTiming;
        _this.autoRemoveChildren = !!vars.autoRemoveChildren;
        _this._sort = _isNotFalse(vars.sortChildren);
        _globalTimeline && _addToTimeline(vars.parent || _globalTimeline, _assertThisInitialized(_this), position);
        vars.reversed && _this.reverse();
        vars.paused && _this.paused(true);
        vars.scrollTrigger && _scrollTrigger(_assertThisInitialized(_this), vars.scrollTrigger);
        return _this;
    }
    var _proto2 = Timeline.prototype;
    _proto2.to = function to(targets, vars, position) {
        _createTweenType(0, arguments, this);
        return this;
    };
    _proto2.from = function from(targets, vars, position) {
        _createTweenType(1, arguments, this);
        return this;
    };
    _proto2.fromTo = function fromTo(targets, fromVars, toVars, position) {
        _createTweenType(2, arguments, this);
        return this;
    };
    _proto2.set = function set(targets, vars, position) {
        vars.duration = 0;
        vars.parent = this;
        _inheritDefaults(vars).repeatDelay || (vars.repeat = 0);
        vars.immediateRender = !!vars.immediateRender;
        new Tween(targets, vars, _parsePosition(this, position), 1);
        return this;
    };
    _proto2.call = function call(callback, params, position) {
        return _addToTimeline(this, Tween.delayedCall(0, callback, params), position);
    } //ONLY for backward compatibility! Maybe delete?
    ;
    _proto2.staggerTo = function staggerTo(targets, duration, vars, stagger, position, onCompleteAll, onCompleteAllParams) {
        vars.duration = duration;
        vars.stagger = vars.stagger || stagger;
        vars.onComplete = onCompleteAll;
        vars.onCompleteParams = onCompleteAllParams;
        vars.parent = this;
        new Tween(targets, vars, _parsePosition(this, position));
        return this;
    };
    _proto2.staggerFrom = function staggerFrom(targets, duration, vars, stagger, position, onCompleteAll, onCompleteAllParams) {
        vars.runBackwards = 1;
        _inheritDefaults(vars).immediateRender = _isNotFalse(vars.immediateRender);
        return this.staggerTo(targets, duration, vars, stagger, position, onCompleteAll, onCompleteAllParams);
    };
    _proto2.staggerFromTo = function staggerFromTo(targets, duration, fromVars, toVars, stagger, position, onCompleteAll, onCompleteAllParams) {
        toVars.startAt = fromVars;
        _inheritDefaults(toVars).immediateRender = _isNotFalse(toVars.immediateRender);
        return this.staggerTo(targets, duration, toVars, stagger, position, onCompleteAll, onCompleteAllParams);
    };
    _proto2.render = function render(totalTime, suppressEvents, force) {
        var prevTime = this._time, tDur = this._dirty ? this.totalDuration() : this._tDur, dur = this._dur, tTime = totalTime <= 0 ? 0 : _roundPrecise(totalTime), // if a paused timeline is resumed (or its _start is updated for another reason...which rounds it), that could result in the playhead shifting a **tiny** amount and a zero-duration child at that spot may get rendered at a different ratio, like its totalTime in render() may be 1e-17 instead of 0, for example.
        crossingStart = this._zTime < 0 !== totalTime < 0 && (this._initted || !dur), time, child, next, iteration, cycleDuration, prevPaused, pauseTween, timeScale, prevStart, prevIteration, yoyo, isYoyo;
        this !== _globalTimeline && tTime > tDur && totalTime >= 0 && (tTime = tDur);
        if (tTime !== this._tTime || force || crossingStart) {
            if (prevTime !== this._time && dur) {
                //if totalDuration() finds a child with a negative startTime and smoothChildTiming is true, things get shifted around internally so we need to adjust the time accordingly. For example, if a tween starts at -30 we must shift EVERYTHING forward 30 seconds and move this timeline's startTime backward by 30 seconds so that things align with the playhead (no jump).
                tTime += this._time - prevTime;
                totalTime += this._time - prevTime;
            }
            time = tTime;
            prevStart = this._start;
            timeScale = this._ts;
            prevPaused = !timeScale;
            if (crossingStart) {
                dur || (prevTime = this._zTime); //when the playhead arrives at EXACTLY time 0 (right on top) of a zero-duration timeline, we need to discern if events are suppressed so that when the playhead moves again (next time), it'll trigger the callback. If events are NOT suppressed, obviously the callback would be triggered in this render. Basically, the callback should fire either when the playhead ARRIVES or LEAVES this exact spot, not both. Imagine doing a timeline.seek(0) and there's a callback that sits at 0. Since events are suppressed on that seek() by default, nothing will fire, but when the playhead moves off of that position, the callback should fire. This behavior is what people intuitively expect.
                (totalTime || !suppressEvents) && (this._zTime = totalTime);
            }
            if (this._repeat) {
                //adjust the time for repeats and yoyos
                yoyo = this._yoyo;
                cycleDuration = dur + this._rDelay;
                if (this._repeat < -1 && totalTime < 0) return this.totalTime(cycleDuration * 100 + totalTime, suppressEvents, force);
                time = _roundPrecise(tTime % cycleDuration); //round to avoid floating point errors. (4 % 0.8 should be 0 but some browsers report it as 0.79999999!)
                if (tTime === tDur) {
                    // the tDur === tTime is for edge cases where there's a lengthy decimal on the duration and it may reach the very end but the time is rendered as not-quite-there (remember, tDur is rounded to 4 decimals whereas dur isn't)
                    iteration = this._repeat;
                    time = dur;
                } else {
                    iteration = ~~(tTime / cycleDuration);
                    if (iteration && iteration === tTime / cycleDuration) {
                        time = dur;
                        iteration--;
                    }
                    time > dur && (time = dur);
                }
                prevIteration = _animationCycle(this._tTime, cycleDuration);
                !prevTime && this._tTime && prevIteration !== iteration && this._tTime - prevIteration * cycleDuration - this._dur <= 0 && (prevIteration = iteration); // edge case - if someone does addPause() at the very beginning of a repeating timeline, that pause is technically at the same spot as the end which causes this._time to get set to 0 when the totalTime would normally place the playhead at the end. See https://greensock.com/forums/topic/23823-closing-nav-animation-not-working-on-ie-and-iphone-6-maybe-other-older-browser/?tab=comments#comment-113005 also, this._tTime - prevIteration * cycleDuration - this._dur <= 0 just checks to make sure it wasn't previously in the "repeatDelay" portion
                if (yoyo && iteration & 1) {
                    time = dur - time;
                    isYoyo = 1;
                }
                /*
        make sure children at the end/beginning of the timeline are rendered properly. If, for example,
        a 3-second long timeline rendered at 2.9 seconds previously, and now renders at 3.2 seconds (which
        would get translated to 2.8 seconds if the timeline yoyos or 0.2 seconds if it just repeats), there
        could be a callback or a short tween that's at 2.95 or 3 seconds in which wouldn't render. So
        we need to push the timeline to the end (and/or beginning depending on its yoyo value). Also we must
        ensure that zero-duration tweens at the very beginning or end of the Timeline work.
        */ if (iteration !== prevIteration && !this._lock) {
                    var rewinding = yoyo && prevIteration & 1, doesWrap = rewinding === (yoyo && iteration & 1);
                    iteration < prevIteration && (rewinding = !rewinding);
                    prevTime = rewinding ? 0 : tTime % dur ? dur : tTime; // if the playhead is landing exactly at the end of an iteration, use that totalTime rather than only the duration, otherwise it'll skip the 2nd render since it's effectively at the same time.
                    this._lock = 1;
                    this.render(prevTime || (isYoyo ? 0 : _roundPrecise(iteration * cycleDuration)), suppressEvents, !dur)._lock = 0;
                    this._tTime = tTime; // if a user gets the iteration() inside the onRepeat, for example, it should be accurate.
                    !suppressEvents && this.parent && _callback(this, "onRepeat");
                    this.vars.repeatRefresh && !isYoyo && (this.invalidate()._lock = 1);
                    if (prevTime && prevTime !== this._time || prevPaused !== !this._ts || this.vars.onRepeat && !this.parent && !this._act) // if prevTime is 0 and we render at the very end, _time will be the end, thus won't match. So in this edge case, prevTime won't match _time but that's okay. If it gets killed in the onRepeat, eject as well.
                    return this;
                    dur = this._dur; // in case the duration changed in the onRepeat
                    tDur = this._tDur;
                    if (doesWrap) {
                        this._lock = 2;
                        prevTime = rewinding ? dur : -0.0001;
                        this.render(prevTime, true);
                        this.vars.repeatRefresh && !isYoyo && this.invalidate();
                    }
                    this._lock = 0;
                    if (!this._ts && !prevPaused) return this;
                     //in order for yoyoEase to work properly when there's a stagger, we must swap out the ease in each sub-tween.
                    _propagateYoyoEase(this, isYoyo);
                }
            }
            if (this._hasPause && !this._forcing && this._lock < 2) {
                pauseTween = _findNextPauseTween(this, _roundPrecise(prevTime), _roundPrecise(time));
                if (pauseTween) tTime -= time - (time = pauseTween._start);
            }
            this._tTime = tTime;
            this._time = time;
            this._act = !timeScale; //as long as it's not paused, force it to be active so that if the user renders independent of the parent timeline, it'll be forced to re-render on the next tick.
            if (!this._initted) {
                this._onUpdate = this.vars.onUpdate;
                this._initted = 1;
                this._zTime = totalTime;
                prevTime = 0; // upon init, the playhead should always go forward; someone could invalidate() a completed timeline and then if they restart(), that would make child tweens render in reverse order which could lock in the wrong starting values if they build on each other, like tl.to(obj, {x: 100}).to(obj, {x: 0}).
            }
            if (!prevTime && time && !suppressEvents && !iteration) {
                _callback(this, "onStart");
                if (this._tTime !== tTime) // in case the onStart triggered a render at a different spot, eject. Like if someone did animation.pause(0.5) or something inside the onStart.
                return this;
            }
            if (time >= prevTime && totalTime >= 0) {
                child = this._first;
                while(child){
                    next = child._next;
                    if ((child._act || time >= child._start) && child._ts && pauseTween !== child) {
                        if (child.parent !== this) // an extreme edge case - the child's render could do something like kill() the "next" one in the linked list, or reparent it. In that case we must re-initiate the whole render to be safe.
                        return this.render(totalTime, suppressEvents, force);
                        child.render(child._ts > 0 ? (time - child._start) * child._ts : (child._dirty ? child.totalDuration() : child._tDur) + (time - child._start) * child._ts, suppressEvents, force);
                        if (time !== this._time || !this._ts && !prevPaused) {
                            //in case a tween pauses or seeks the timeline when rendering, like inside of an onUpdate/onComplete
                            pauseTween = 0;
                            next && (tTime += this._zTime = -_tinyNum); // it didn't finish rendering, so flag zTime as negative so that so that the next time render() is called it'll be forced (to render any remaining children)
                            break;
                        }
                    }
                    child = next;
                }
            } else {
                child = this._last;
                var adjustedTime = totalTime < 0 ? totalTime : time; //when the playhead goes backward beyond the start of this timeline, we must pass that information down to the child animations so that zero-duration tweens know whether to render their starting or ending values.
                while(child){
                    next = child._prev;
                    if ((child._act || adjustedTime <= child._end) && child._ts && pauseTween !== child) {
                        if (child.parent !== this) // an extreme edge case - the child's render could do something like kill() the "next" one in the linked list, or reparent it. In that case we must re-initiate the whole render to be safe.
                        return this.render(totalTime, suppressEvents, force);
                        child.render(child._ts > 0 ? (adjustedTime - child._start) * child._ts : (child._dirty ? child.totalDuration() : child._tDur) + (adjustedTime - child._start) * child._ts, suppressEvents, force || _reverting && (child._initted || child._startAt)); // if reverting, we should always force renders of initted tweens (but remember that .fromTo() or .from() may have a _startAt but not _initted yet). If, for example, a .fromTo() tween with a stagger (which creates an internal timeline) gets reverted BEFORE some of its child tweens render for the first time, it may not properly trigger them to revert.
                        if (time !== this._time || !this._ts && !prevPaused) {
                            //in case a tween pauses or seeks the timeline when rendering, like inside of an onUpdate/onComplete
                            pauseTween = 0;
                            next && (tTime += this._zTime = adjustedTime ? -_tinyNum : _tinyNum); // it didn't finish rendering, so adjust zTime so that so that the next time render() is called it'll be forced (to render any remaining children)
                            break;
                        }
                    }
                    child = next;
                }
            }
            if (pauseTween && !suppressEvents) {
                this.pause();
                pauseTween.render(time >= prevTime ? 0 : -_tinyNum)._zTime = time >= prevTime ? 1 : -1;
                if (this._ts) {
                    //the callback resumed playback! So since we may have held back the playhead due to where the pause is positioned, go ahead and jump to where it's SUPPOSED to be (if no pause happened).
                    this._start = prevStart; //if the pause was at an earlier time and the user resumed in the callback, it could reposition the timeline (changing its startTime), throwing things off slightly, so we make sure the _start doesn't shift.
                    _setEnd(this);
                    return this.render(totalTime, suppressEvents, force);
                }
            }
            this._onUpdate && !suppressEvents && _callback(this, "onUpdate", true);
            if (tTime === tDur && this._tTime >= this.totalDuration() || !tTime && prevTime) {
                if (prevStart === this._start || Math.abs(timeScale) !== Math.abs(this._ts)) {
                    if (!this._lock) {
                        // remember, a child's callback may alter this timeline's playhead or timeScale which is why we need to add some of these checks.
                        (totalTime || !dur) && (tTime === tDur && this._ts > 0 || !tTime && this._ts < 0) && _removeFromParent(this, 1); // don't remove if the timeline is reversed and the playhead isn't at 0, otherwise tl.progress(1).reverse() won't work. Only remove if the playhead is at the end and timeScale is positive, or if the playhead is at 0 and the timeScale is negative.
                        if (!suppressEvents && !(totalTime < 0 && !prevTime) && (tTime || prevTime || !tDur)) {
                            _callback(this, tTime === tDur && totalTime >= 0 ? "onComplete" : "onReverseComplete", true);
                            this._prom && !(tTime < tDur && this.timeScale() > 0) && this._prom();
                        }
                    }
                }
            }
        }
        return this;
    };
    _proto2.add = function add(child, position) {
        var _this2 = this;
        _isNumber(position) || (position = _parsePosition(this, position, child));
        if (!(child instanceof Animation)) {
            if (_isArray(child)) {
                child.forEach(function(obj) {
                    return _this2.add(obj, position);
                });
                return this;
            }
            if (_isString(child)) return this.addLabel(child, position);
            if (_isFunction(child)) child = Tween.delayedCall(0, child);
            else return this;
        }
        return this !== child ? _addToTimeline(this, child, position) : this; //don't allow a timeline to be added to itself as a child!
    };
    _proto2.getChildren = function getChildren(nested, tweens, timelines, ignoreBeforeTime) {
        if (nested === void 0) nested = true;
        if (tweens === void 0) tweens = true;
        if (timelines === void 0) timelines = true;
        if (ignoreBeforeTime === void 0) ignoreBeforeTime = -_bigNum;
        var a = [], child = this._first;
        while(child){
            if (child._start >= ignoreBeforeTime) {
                if (child instanceof Tween) tweens && a.push(child);
                else {
                    timelines && a.push(child);
                    nested && a.push.apply(a, child.getChildren(true, tweens, timelines));
                }
            }
            child = child._next;
        }
        return a;
    };
    _proto2.getById = function getById(id) {
        var animations = this.getChildren(1, 1, 1), i = animations.length;
        while(i--){
            if (animations[i].vars.id === id) return animations[i];
        }
    };
    _proto2.remove = function remove(child) {
        if (_isString(child)) return this.removeLabel(child);
        if (_isFunction(child)) return this.killTweensOf(child);
        _removeLinkedListItem(this, child);
        if (child === this._recent) this._recent = this._last;
        return _uncache(this);
    };
    _proto2.totalTime = function totalTime(_totalTime2, suppressEvents) {
        if (!arguments.length) return this._tTime;
        this._forcing = 1;
        if (!this._dp && this._ts) //special case for the global timeline (or any other that has no parent or detached parent).
        this._start = _roundPrecise(_ticker.time - (this._ts > 0 ? _totalTime2 / this._ts : (this.totalDuration() - _totalTime2) / -this._ts));
        _Animation.prototype.totalTime.call(this, _totalTime2, suppressEvents);
        this._forcing = 0;
        return this;
    };
    _proto2.addLabel = function addLabel(label, position) {
        this.labels[label] = _parsePosition(this, position);
        return this;
    };
    _proto2.removeLabel = function removeLabel(label) {
        delete this.labels[label];
        return this;
    };
    _proto2.addPause = function addPause(position, callback, params) {
        var t = Tween.delayedCall(0, callback || _emptyFunc, params);
        t.data = "isPause";
        this._hasPause = 1;
        return _addToTimeline(this, t, _parsePosition(this, position));
    };
    _proto2.removePause = function removePause(position) {
        var child = this._first;
        position = _parsePosition(this, position);
        while(child){
            if (child._start === position && child.data === "isPause") _removeFromParent(child);
            child = child._next;
        }
    };
    _proto2.killTweensOf = function killTweensOf(targets, props, onlyActive) {
        var tweens = this.getTweensOf(targets, onlyActive), i = tweens.length;
        while(i--)_overwritingTween !== tweens[i] && tweens[i].kill(targets, props);
        return this;
    };
    _proto2.getTweensOf = function getTweensOf(targets, onlyActive) {
        var a = [], parsedTargets = toArray(targets), child = this._first, isGlobalTime = _isNumber(onlyActive), // a number is interpreted as a global time. If the animation spans
        children;
        while(child){
            if (child instanceof Tween) {
                if (_arrayContainsAny(child._targets, parsedTargets) && (isGlobalTime ? (!_overwritingTween || child._initted && child._ts) && child.globalTime(0) <= onlyActive && child.globalTime(child.totalDuration()) > onlyActive : !onlyActive || child.isActive())) // note: if this is for overwriting, it should only be for tweens that aren't paused and are initted.
                a.push(child);
            } else if ((children = child.getTweensOf(parsedTargets, onlyActive)).length) a.push.apply(a, children);
            child = child._next;
        }
        return a;
    } // potential future feature - targets() on timelines
    ;
    _proto2.tweenTo = function tweenTo(position, vars) {
        vars = vars || {};
        var tl = this, endTime = _parsePosition(tl, position), _vars = vars, startAt = _vars.startAt, _onStart = _vars.onStart, onStartParams = _vars.onStartParams, immediateRender = _vars.immediateRender, initted, tween = Tween.to(tl, _setDefaults({
            ease: vars.ease || "none",
            lazy: false,
            immediateRender: false,
            time: endTime,
            overwrite: "auto",
            duration: vars.duration || Math.abs((endTime - (startAt && "time" in startAt ? startAt.time : tl._time)) / tl.timeScale()) || _tinyNum,
            onStart: function onStart() {
                tl.pause();
                if (!initted) {
                    var duration = vars.duration || Math.abs((endTime - (startAt && "time" in startAt ? startAt.time : tl._time)) / tl.timeScale());
                    tween._dur !== duration && _setDuration(tween, duration, 0, 1).render(tween._time, true, true);
                    initted = 1;
                }
                _onStart && _onStart.apply(tween, onStartParams || []); //in case the user had an onStart in the vars - we don't want to overwrite it.
            }
        }, vars));
        return immediateRender ? tween.render(0) : tween;
    };
    _proto2.tweenFromTo = function tweenFromTo(fromPosition, toPosition, vars) {
        return this.tweenTo(toPosition, _setDefaults({
            startAt: {
                time: _parsePosition(this, fromPosition)
            }
        }, vars));
    };
    _proto2.recent = function recent() {
        return this._recent;
    };
    _proto2.nextLabel = function nextLabel(afterTime) {
        if (afterTime === void 0) afterTime = this._time;
        return _getLabelInDirection(this, _parsePosition(this, afterTime));
    };
    _proto2.previousLabel = function previousLabel(beforeTime) {
        if (beforeTime === void 0) beforeTime = this._time;
        return _getLabelInDirection(this, _parsePosition(this, beforeTime), 1);
    };
    _proto2.currentLabel = function currentLabel(value) {
        return arguments.length ? this.seek(value, true) : this.previousLabel(this._time + _tinyNum);
    };
    _proto2.shiftChildren = function shiftChildren(amount, adjustLabels, ignoreBeforeTime) {
        if (ignoreBeforeTime === void 0) ignoreBeforeTime = 0;
        var child = this._first, labels = this.labels, p;
        while(child){
            if (child._start >= ignoreBeforeTime) {
                child._start += amount;
                child._end += amount;
            }
            child = child._next;
        }
        if (adjustLabels) {
            for(p in labels)if (labels[p] >= ignoreBeforeTime) labels[p] += amount;
        }
        return _uncache(this);
    };
    _proto2.invalidate = function invalidate(soft) {
        var child = this._first;
        this._lock = 0;
        while(child){
            child.invalidate(soft);
            child = child._next;
        }
        return _Animation.prototype.invalidate.call(this, soft);
    };
    _proto2.clear = function clear(includeLabels) {
        if (includeLabels === void 0) includeLabels = true;
        var child = this._first, next;
        while(child){
            next = child._next;
            this.remove(child);
            child = next;
        }
        this._dp && (this._time = this._tTime = this._pTime = 0);
        includeLabels && (this.labels = {});
        return _uncache(this);
    };
    _proto2.totalDuration = function totalDuration(value) {
        var max = 0, self = this, child = self._last, prevStart = _bigNum, prev, start, parent;
        if (arguments.length) return self.timeScale((self._repeat < 0 ? self.duration() : self.totalDuration()) / (self.reversed() ? -value : value));
        if (self._dirty) {
            parent = self.parent;
            while(child){
                prev = child._prev; //record it here in case the tween changes position in the sequence...
                child._dirty && child.totalDuration(); //could change the tween._startTime, so make sure the animation's cache is clean before analyzing it.
                start = child._start;
                if (start > prevStart && self._sort && child._ts && !self._lock) {
                    //in case one of the tweens shifted out of order, it needs to be re-inserted into the correct position in the sequence
                    self._lock = 1; //prevent endless recursive calls - there are methods that get triggered that check duration/totalDuration when we add().
                    _addToTimeline(self, child, start - child._delay, 1)._lock = 0;
                } else prevStart = start;
                if (start < 0 && child._ts) {
                    //children aren't allowed to have negative startTimes unless smoothChildTiming is true, so adjust here if one is found.
                    max -= start;
                    if (!parent && !self._dp || parent && parent.smoothChildTiming) {
                        self._start += start / self._ts;
                        self._time -= start;
                        self._tTime -= start;
                    }
                    self.shiftChildren(-start, false, -Infinity);
                    prevStart = 0;
                }
                child._end > max && child._ts && (max = child._end);
                child = prev;
            }
            _setDuration(self, self === _globalTimeline && self._time > max ? self._time : max, 1, 1);
            self._dirty = 0;
        }
        return self._tDur;
    };
    Timeline.updateRoot = function updateRoot(time) {
        if (_globalTimeline._ts) {
            _lazySafeRender(_globalTimeline, _parentToChildTotalTime(time, _globalTimeline));
            _lastRenderedFrame = _ticker.frame;
        }
        if (_ticker.frame >= _nextGCFrame) {
            _nextGCFrame += _config.autoSleep || 120;
            var child = _globalTimeline._first;
            if (!child || !child._ts) {
                if (_config.autoSleep && _ticker._listeners.length < 2) {
                    while(child && !child._ts)child = child._next;
                    child || _ticker.sleep();
                }
            }
        }
    };
    return Timeline;
}(Animation);
_setDefaults(Timeline.prototype, {
    _lock: 0,
    _hasPause: 0,
    _forcing: 0
});
var _addComplexStringPropTween = function _addComplexStringPropTween(target, prop, start, end, setter, stringFilter, funcParam) {
    //note: we call _addComplexStringPropTween.call(tweenInstance...) to ensure that it's scoped properly. We may call it from within a plugin too, thus "this" would refer to the plugin.
    var pt = new PropTween(this._pt, target, prop, 0, 1, _renderComplexString, null, setter), index = 0, matchIndex = 0, result, startNums, color, endNum, chunk, startNum, hasRandom, a;
    pt.b = start;
    pt.e = end;
    start += ""; //ensure values are strings
    end += "";
    if (hasRandom = ~end.indexOf("random(")) end = _replaceRandom(end);
    if (stringFilter) {
        a = [
            start,
            end
        ];
        stringFilter(a, target, prop); //pass an array with the starting and ending values and let the filter do whatever it needs to the values.
        start = a[0];
        end = a[1];
    }
    startNums = start.match(_complexStringNumExp) || [];
    while(result = _complexStringNumExp.exec(end)){
        endNum = result[0];
        chunk = end.substring(index, result.index);
        if (color) color = (color + 1) % 5;
        else if (chunk.substr(-5) === "rgba(") color = 1;
        if (endNum !== startNums[matchIndex++]) {
            startNum = parseFloat(startNums[matchIndex - 1]) || 0; //these nested PropTweens are handled in a special way - we'll never actually call a render or setter method on them. We'll just loop through them in the parent complex string PropTween's render method.
            pt._pt = {
                _next: pt._pt,
                p: chunk || matchIndex === 1 ? chunk : ",",
                //note: SVG spec allows omission of comma/space when a negative sign is wedged between two numbers, like 2.5-5.3 instead of 2.5,-5.3 but when tweening, the negative value may switch to positive, so we insert the comma just in case.
                s: startNum,
                c: endNum.charAt(1) === "=" ? _parseRelative(startNum, endNum) - startNum : parseFloat(endNum) - startNum,
                m: color && color < 4 ? Math.round : 0
            };
            index = _complexStringNumExp.lastIndex;
        }
    }
    pt.c = index < end.length ? end.substring(index, end.length) : ""; //we use the "c" of the PropTween to store the final part of the string (after the last number)
    pt.fp = funcParam;
    if (_relExp.test(end) || hasRandom) pt.e = 0; //if the end string contains relative values or dynamic random(...) values, delete the end it so that on the final render we don't actually set it to the string with += or -= characters (forces it to use the calculated value).
    this._pt = pt; //start the linked list with this new PropTween. Remember, we call _addComplexStringPropTween.call(tweenInstance...) to ensure that it's scoped properly. We may call it from within a plugin too, thus "this" would refer to the plugin.
    return pt;
}, _addPropTween = function _addPropTween(target, prop, start, end, index, targets, modifier, stringFilter, funcParam, optional) {
    _isFunction(end) && (end = end(index || 0, target, targets));
    var currentValue = target[prop], parsedStart = start !== "get" ? start : !_isFunction(currentValue) ? currentValue : funcParam ? target[prop.indexOf("set") || !_isFunction(target["get" + prop.substr(3)]) ? prop : "get" + prop.substr(3)](funcParam) : target[prop](), setter = !_isFunction(currentValue) ? _setterPlain : funcParam ? _setterFuncWithParam : _setterFunc, pt;
    if (_isString(end)) {
        if (~end.indexOf("random(")) end = _replaceRandom(end);
        if (end.charAt(1) === "=") {
            pt = _parseRelative(parsedStart, end) + (getUnit(parsedStart) || 0);
            if (pt || pt === 0) // to avoid isNaN, like if someone passes in a value like "!= whatever"
            end = pt;
        }
    }
    if (!optional || parsedStart !== end || _forceAllPropTweens) {
        if (!isNaN(parsedStart * end) && end !== "") {
            // fun fact: any number multiplied by "" is evaluated as the number 0!
            pt = new PropTween(this._pt, target, prop, +parsedStart || 0, end - (parsedStart || 0), typeof currentValue === "boolean" ? _renderBoolean : _renderPlain, 0, setter);
            funcParam && (pt.fp = funcParam);
            modifier && pt.modifier(modifier, this, target);
            return this._pt = pt;
        }
        !currentValue && !(prop in target) && _missingPlugin(prop, end);
        return _addComplexStringPropTween.call(this, target, prop, parsedStart, end, setter, stringFilter || _config.stringFilter, funcParam);
    }
}, //creates a copy of the vars object and processes any function-based values (putting the resulting values directly into the copy) as well as strings with "random()" in them. It does NOT process relative values.
_processVars = function _processVars(vars, index, target, targets, tween) {
    _isFunction(vars) && (vars = _parseFuncOrString(vars, tween, index, target, targets));
    if (!_isObject(vars) || vars.style && vars.nodeType || _isArray(vars) || _isTypedArray(vars)) return _isString(vars) ? _parseFuncOrString(vars, tween, index, target, targets) : vars;
    var copy = {}, p;
    for(p in vars)copy[p] = _parseFuncOrString(vars[p], tween, index, target, targets);
    return copy;
}, _checkPlugin = function _checkPlugin(property, vars, tween, index, target, targets) {
    var plugin, pt, ptLookup, i;
    if (_plugins[property] && (plugin = new _plugins[property]()).init(target, plugin.rawVars ? vars[property] : _processVars(vars[property], index, target, targets, tween), tween, index, targets) !== false) {
        tween._pt = pt = new PropTween(tween._pt, target, property, 0, 1, plugin.render, plugin, 0, plugin.priority);
        if (tween !== _quickTween) {
            ptLookup = tween._ptLookup[tween._targets.indexOf(target)]; //note: we can't use tween._ptLookup[index] because for staggered tweens, the index from the fullTargets array won't match what it is in each individual tween that spawns from the stagger.
            i = plugin._props.length;
            while(i--)ptLookup[plugin._props[i]] = pt;
        }
    }
    return plugin;
}, _overwritingTween, //store a reference temporarily so we can avoid overwriting itself.
_forceAllPropTweens, _initTween = function _initTween(tween, time, tTime) {
    var vars = tween.vars, ease = vars.ease, startAt = vars.startAt, immediateRender = vars.immediateRender, lazy = vars.lazy, onUpdate = vars.onUpdate, onUpdateParams = vars.onUpdateParams, callbackScope = vars.callbackScope, runBackwards = vars.runBackwards, yoyoEase = vars.yoyoEase, keyframes = vars.keyframes, autoRevert = vars.autoRevert, dur = tween._dur, prevStartAt = tween._startAt, targets = tween._targets, parent = tween.parent, fullTargets = parent && parent.data === "nested" ? parent.vars.targets : targets, autoOverwrite = tween._overwrite === "auto" && !_suppressOverwrites, tl = tween.timeline, cleanVars, i, p, pt, target, hasPriority, gsData, harness, plugin, ptLookup, index, harnessVars, overwritten;
    tl && (!keyframes || !ease) && (ease = "none");
    tween._ease = _parseEase(ease, _defaults.ease);
    tween._yEase = yoyoEase ? _invertEase(_parseEase(yoyoEase === true ? ease : yoyoEase, _defaults.ease)) : 0;
    if (yoyoEase && tween._yoyo && !tween._repeat) {
        //there must have been a parent timeline with yoyo:true that is currently in its yoyo phase, so flip the eases.
        yoyoEase = tween._yEase;
        tween._yEase = tween._ease;
        tween._ease = yoyoEase;
    }
    tween._from = !tl && !!vars.runBackwards; //nested timelines should never run backwards - the backwards-ness is in the child tweens.
    if (!tl || keyframes && !vars.stagger) {
        //if there's an internal timeline, skip all the parsing because we passed that task down the chain.
        harness = targets[0] ? _getCache(targets[0]).harness : 0;
        harnessVars = harness && vars[harness.prop]; //someone may need to specify CSS-specific values AND non-CSS values, like if the element has an "x" property plus it's a standard DOM element. We allow people to distinguish by wrapping plugin-specific stuff in a css:{} object for example.
        cleanVars = _copyExcluding(vars, _reservedProps);
        if (prevStartAt) {
            prevStartAt._zTime < 0 && prevStartAt.progress(1); // in case it's a lazy startAt that hasn't rendered yet.
            time < 0 && runBackwards && immediateRender && !autoRevert ? prevStartAt.render(-1, true) : prevStartAt.revert(runBackwards && dur ? _revertConfigNoKill : _startAtRevertConfig); // if it's a "startAt" (not "from()" or runBackwards: true), we only need to do a shallow revert (keep transforms cached in CSSPlugin)
            // don't just _removeFromParent(prevStartAt.render(-1, true)) because that'll leave inline styles. We're creating a new _startAt for "startAt" tweens that re-capture things to ensure that if the pre-tween values changed since the tween was created, they're recorded.
            prevStartAt._lazy = 0;
        }
        if (startAt) {
            _removeFromParent(tween._startAt = Tween.set(targets, _setDefaults({
                data: "isStart",
                overwrite: false,
                parent: parent,
                immediateRender: true,
                lazy: !prevStartAt && _isNotFalse(lazy),
                startAt: null,
                delay: 0,
                onUpdate: onUpdate,
                onUpdateParams: onUpdateParams,
                callbackScope: callbackScope,
                stagger: 0
            }, startAt))); //copy the properties/values into a new object to avoid collisions, like var to = {x:0}, from = {x:500}; timeline.fromTo(e, from, to).fromTo(e, to, from);
            tween._startAt._dp = 0; // don't allow it to get put back into root timeline! Like when revert() is called and totalTime() gets set.
            tween._startAt._sat = tween; // used in globalTime(). _sat stands for _startAtTween
            time < 0 && (_reverting || !immediateRender && !autoRevert) && tween._startAt.revert(_revertConfigNoKill); // rare edge case, like if a render is forced in the negative direction of a non-initted tween.
            if (immediateRender) {
                if (dur && time <= 0 && tTime <= 0) {
                    // check tTime here because in the case of a yoyo tween whose playhead gets pushed to the end like tween.progress(1), we should allow it through so that the onComplete gets fired properly.
                    time && (tween._zTime = time);
                    return; //we skip initialization here so that overwriting doesn't occur until the tween actually begins. Otherwise, if you create several immediateRender:true tweens of the same target/properties to drop into a Timeline, the last one created would overwrite the first ones because they didn't get placed into the timeline yet before the first render occurs and kicks in overwriting.
                }
            }
        } else if (runBackwards && dur) //from() tweens must be handled uniquely: their beginning values must be rendered but we don't want overwriting to occur yet (when time is still 0). Wait until the tween actually begins before doing all the routines like overwriting. At that time, we should render at the END of the tween to ensure that things initialize correctly (remember, from() tweens go backwards)
        {
            if (!prevStartAt) {
                time && (immediateRender = false); //in rare cases (like if a from() tween runs and then is invalidate()-ed), immediateRender could be true but the initial forced-render gets skipped, so there's no need to force the render in this context when the _time is greater than 0
                p = _setDefaults({
                    overwrite: false,
                    data: "isFromStart",
                    //we tag the tween with as "isFromStart" so that if [inside a plugin] we need to only do something at the very END of a tween, we have a way of identifying this tween as merely the one that's setting the beginning values for a "from()" tween. For example, clearProps in CSSPlugin should only get applied at the very END of a tween and without this tag, from(...{height:100, clearProps:"height", delay:1}) would wipe the height at the beginning of the tween and after 1 second, it'd kick back in.
                    lazy: immediateRender && !prevStartAt && _isNotFalse(lazy),
                    immediateRender: immediateRender,
                    //zero-duration tweens render immediately by default, but if we're not specifically instructed to render this tween immediately, we should skip this and merely _init() to record the starting values (rendering them immediately would push them to completion which is wasteful in that case - we'd have to render(-1) immediately after)
                    stagger: 0,
                    parent: parent //ensures that nested tweens that had a stagger are handled properly, like gsap.from(".class", {y: gsap.utils.wrap([-100,100]), stagger: 0.5})
                }, cleanVars);
                harnessVars && (p[harness.prop] = harnessVars); // in case someone does something like .from(..., {css:{}})
                _removeFromParent(tween._startAt = Tween.set(targets, p));
                tween._startAt._dp = 0; // don't allow it to get put back into root timeline!
                tween._startAt._sat = tween; // used in globalTime()
                time < 0 && (_reverting ? tween._startAt.revert(_revertConfigNoKill) : tween._startAt.render(-1, true));
                tween._zTime = time;
                if (!immediateRender) _initTween(tween._startAt, _tinyNum, _tinyNum); //ensures that the initial values are recorded
                else if (!time) return;
            }
        }
        tween._pt = tween._ptCache = 0;
        lazy = dur && _isNotFalse(lazy) || lazy && !dur;
        for(i = 0; i < targets.length; i++){
            target = targets[i];
            gsData = target._gsap || _harness(targets)[i]._gsap;
            tween._ptLookup[i] = ptLookup = {};
            _lazyLookup[gsData.id] && _lazyTweens.length && _lazyRender(); //if other tweens of the same target have recently initted but haven't rendered yet, we've got to force the render so that the starting values are correct (imagine populating a timeline with a bunch of sequential tweens and then jumping to the end)
            index = fullTargets === targets ? i : fullTargets.indexOf(target);
            if (harness && (plugin = new harness()).init(target, harnessVars || cleanVars, tween, index, fullTargets) !== false) {
                tween._pt = pt = new PropTween(tween._pt, target, plugin.name, 0, 1, plugin.render, plugin, 0, plugin.priority);
                plugin._props.forEach(function(name) {
                    ptLookup[name] = pt;
                });
                plugin.priority && (hasPriority = 1);
            }
            if (!harness || harnessVars) {
                for(p in cleanVars)if (_plugins[p] && (plugin = _checkPlugin(p, cleanVars, tween, index, target, fullTargets))) plugin.priority && (hasPriority = 1);
                else ptLookup[p] = pt = _addPropTween.call(tween, target, p, "get", cleanVars[p], index, fullTargets, 0, vars.stringFilter);
            }
            tween._op && tween._op[i] && tween.kill(target, tween._op[i]);
            if (autoOverwrite && tween._pt) {
                _overwritingTween = tween;
                _globalTimeline.killTweensOf(target, ptLookup, tween.globalTime(time)); // make sure the overwriting doesn't overwrite THIS tween!!!
                overwritten = !tween.parent;
                _overwritingTween = 0;
            }
            tween._pt && lazy && (_lazyLookup[gsData.id] = 1);
        }
        hasPriority && _sortPropTweensByPriority(tween);
        tween._onInit && tween._onInit(tween); //plugins like RoundProps must wait until ALL of the PropTweens are instantiated. In the plugin's init() function, it sets the _onInit on the tween instance. May not be pretty/intuitive, but it's fast and keeps file size down.
    }
    tween._onUpdate = onUpdate;
    tween._initted = (!tween._op || tween._pt) && !overwritten; // if overwrittenProps resulted in the entire tween being killed, do NOT flag it as initted or else it may render for one tick.
    keyframes && time <= 0 && tl.render(_bigNum, true, true); // if there's a 0% keyframe, it'll render in the "before" state for any staggered/delayed animations thus when the following tween initializes, it'll use the "before" state instead of the "after" state as the initial values.
}, _updatePropTweens = function _updatePropTweens(tween, property, value, start, startIsRelative, ratio, time) {
    var ptCache = (tween._pt && tween._ptCache || (tween._ptCache = {}))[property], pt, rootPT, lookup, i;
    if (!ptCache) {
        ptCache = tween._ptCache[property] = [];
        lookup = tween._ptLookup;
        i = tween._targets.length;
        while(i--){
            pt = lookup[i][property];
            if (pt && pt.d && pt.d._pt) {
                // it's a plugin, so find the nested PropTween
                pt = pt.d._pt;
                while(pt && pt.p !== property && pt.fp !== property)// "fp" is functionParam for things like setting CSS variables which require .setProperty("--var-name", value)
                pt = pt._next;
            }
            if (!pt) {
                // there is no PropTween associated with that property, so we must FORCE one to be created and ditch out of this
                // if the tween has other properties that already rendered at new positions, we'd normally have to rewind to put them back like tween.render(0, true) before forcing an _initTween(), but that can create another edge case like tweening a timeline's progress would trigger onUpdates to fire which could move other things around. It's better to just inform users that .resetTo() should ONLY be used for tweens that already have that property. For example, you can't gsap.to(...{ y: 0 }) and then tween.restTo("x", 200) for example.
                _forceAllPropTweens = 1; // otherwise, when we _addPropTween() and it finds no change between the start and end values, it skips creating a PropTween (for efficiency...why tween when there's no difference?) but in this case we NEED that PropTween created so we can edit it.
                tween.vars[property] = "+=0";
                _initTween(tween, time);
                _forceAllPropTweens = 0;
                return 1;
            }
            ptCache.push(pt);
        }
    }
    i = ptCache.length;
    while(i--){
        rootPT = ptCache[i];
        pt = rootPT._pt || rootPT; // complex values may have nested PropTweens. We only accommodate the FIRST value.
        pt.s = (start || start === 0) && !startIsRelative ? start : pt.s + (start || 0) + ratio * pt.c;
        pt.c = value - pt.s;
        rootPT.e && (rootPT.e = _round(value) + getUnit(rootPT.e)); // mainly for CSSPlugin (end value)
        rootPT.b && (rootPT.b = pt.s + getUnit(rootPT.b)); // (beginning value)
    }
}, _addAliasesToVars = function _addAliasesToVars(targets, vars) {
    var harness = targets[0] ? _getCache(targets[0]).harness : 0, propertyAliases = harness && harness.aliases, copy, p, i, aliases;
    if (!propertyAliases) return vars;
    copy = _merge({}, vars);
    for(p in propertyAliases)if (p in copy) {
        aliases = propertyAliases[p].split(",");
        i = aliases.length;
        while(i--)copy[aliases[i]] = copy[p];
    }
    return copy;
}, // parses multiple formats, like {"0%": {x: 100}, {"50%": {x: -20}} and { x: {"0%": 100, "50%": -20} }, and an "ease" can be set on any object. We populate an "allProps" object with an Array for each property, like {x: [{}, {}], y:[{}, {}]} with data for each property tween. The objects have a "t" (time), "v", (value), and "e" (ease) property. This allows us to piece together a timeline later.
_parseKeyframe = function _parseKeyframe(prop, obj, allProps, easeEach) {
    var ease = obj.ease || easeEach || "power1.inOut", p, a;
    if (_isArray(obj)) {
        a = allProps[prop] || (allProps[prop] = []); // t = time (out of 100), v = value, e = ease
        obj.forEach(function(value, i) {
            return a.push({
                t: i / (obj.length - 1) * 100,
                v: value,
                e: ease
            });
        });
    } else for(p in obj){
        a = allProps[p] || (allProps[p] = []);
        p === "ease" || a.push({
            t: parseFloat(prop),
            v: obj[p],
            e: ease
        });
    }
}, _parseFuncOrString = function _parseFuncOrString(value, tween, i, target, targets) {
    return _isFunction(value) ? value.call(tween, i, target, targets) : _isString(value) && ~value.indexOf("random(") ? _replaceRandom(value) : value;
}, _staggerTweenProps = _callbackNames + "repeat,repeatDelay,yoyo,repeatRefresh,yoyoEase,autoRevert", _staggerPropsToSkip = {};
_forEachName(_staggerTweenProps + ",id,stagger,delay,duration,paused,scrollTrigger", function(name) {
    return _staggerPropsToSkip[name] = 1;
});
var Tween = /*#__PURE__*/ function(_Animation2) {
    _inheritsLoose(Tween, _Animation2);
    function Tween(targets, vars, position, skipInherit) {
        var _this3;
        if (typeof vars === "number") {
            position.duration = vars;
            vars = position;
            position = null;
        }
        _this3 = _Animation2.call(this, skipInherit ? vars : _inheritDefaults(vars)) || this;
        var _this3$vars = _this3.vars, duration = _this3$vars.duration, delay = _this3$vars.delay, immediateRender = _this3$vars.immediateRender, stagger = _this3$vars.stagger, overwrite = _this3$vars.overwrite, keyframes = _this3$vars.keyframes, defaults = _this3$vars.defaults, scrollTrigger = _this3$vars.scrollTrigger, yoyoEase = _this3$vars.yoyoEase, parent = vars.parent || _globalTimeline, parsedTargets = (_isArray(targets) || _isTypedArray(targets) ? _isNumber(targets[0]) : "length" in vars) ? [
            targets
        ] : toArray(targets), tl, i, copy, l, p, curTarget, staggerFunc, staggerVarsToMerge;
        _this3._targets = parsedTargets.length ? _harness(parsedTargets) : _warn("GSAP target " + targets + " not found. https://greensock.com", !_config.nullTargetWarn) || [];
        _this3._ptLookup = []; //PropTween lookup. An array containing an object for each target, having keys for each tweening property
        _this3._overwrite = overwrite;
        if (keyframes || stagger || _isFuncOrString(duration) || _isFuncOrString(delay)) {
            vars = _this3.vars;
            tl = _this3.timeline = new Timeline({
                data: "nested",
                defaults: defaults || {},
                targets: parent && parent.data === "nested" ? parent.vars.targets : parsedTargets
            }); // we need to store the targets because for staggers and keyframes, we end up creating an individual tween for each but function-based values need to know the index and the whole Array of targets.
            tl.kill();
            tl.parent = tl._dp = _assertThisInitialized(_this3);
            tl._start = 0;
            if (stagger || _isFuncOrString(duration) || _isFuncOrString(delay)) {
                l = parsedTargets.length;
                staggerFunc = stagger && distribute(stagger);
                if (_isObject(stagger)) {
                    //users can pass in callbacks like onStart/onComplete in the stagger object. These should fire with each individual tween.
                    for(p in stagger)if (~_staggerTweenProps.indexOf(p)) {
                        staggerVarsToMerge || (staggerVarsToMerge = {});
                        staggerVarsToMerge[p] = stagger[p];
                    }
                }
                for(i = 0; i < l; i++){
                    copy = _copyExcluding(vars, _staggerPropsToSkip);
                    copy.stagger = 0;
                    yoyoEase && (copy.yoyoEase = yoyoEase);
                    staggerVarsToMerge && _merge(copy, staggerVarsToMerge);
                    curTarget = parsedTargets[i]; //don't just copy duration or delay because if they're a string or function, we'd end up in an infinite loop because _isFuncOrString() would evaluate as true in the child tweens, entering this loop, etc. So we parse the value straight from vars and default to 0.
                    copy.duration = +_parseFuncOrString(duration, _assertThisInitialized(_this3), i, curTarget, parsedTargets);
                    copy.delay = (+_parseFuncOrString(delay, _assertThisInitialized(_this3), i, curTarget, parsedTargets) || 0) - _this3._delay;
                    if (!stagger && l === 1 && copy.delay) {
                        // if someone does delay:"random(1, 5)", repeat:-1, for example, the delay shouldn't be inside the repeat.
                        _this3._delay = delay = copy.delay;
                        _this3._start += delay;
                        copy.delay = 0;
                    }
                    tl.to(curTarget, copy, staggerFunc ? staggerFunc(i, curTarget, parsedTargets) : 0);
                    tl._ease = _easeMap.none;
                }
                tl.duration() ? duration = delay = 0 : _this3.timeline = 0; // if the timeline's duration is 0, we don't need a timeline internally!
            } else if (keyframes) {
                _inheritDefaults(_setDefaults(tl.vars.defaults, {
                    ease: "none"
                }));
                tl._ease = _parseEase(keyframes.ease || vars.ease || "none");
                var time = 0, a, kf, v;
                if (_isArray(keyframes)) {
                    keyframes.forEach(function(frame) {
                        return tl.to(parsedTargets, frame, ">");
                    });
                    tl.duration(); // to ensure tl._dur is cached because we tap into it for performance purposes in the render() method.
                } else {
                    copy = {};
                    for(p in keyframes)p === "ease" || p === "easeEach" || _parseKeyframe(p, keyframes[p], copy, keyframes.easeEach);
                    for(p in copy){
                        a = copy[p].sort(function(a, b) {
                            return a.t - b.t;
                        });
                        time = 0;
                        for(i = 0; i < a.length; i++){
                            kf = a[i];
                            v = {
                                ease: kf.e,
                                duration: (kf.t - (i ? a[i - 1].t : 0)) / 100 * duration
                            };
                            v[p] = kf.v;
                            tl.to(parsedTargets, v, time);
                            time += v.duration;
                        }
                    }
                    tl.duration() < duration && tl.to({}, {
                        duration: duration - tl.duration()
                    }); // in case keyframes didn't go to 100%
                }
            }
            duration || _this3.duration(duration = tl.duration());
        } else _this3.timeline = 0; //speed optimization, faster lookups (no going up the prototype chain)
        if (overwrite === true && !_suppressOverwrites) {
            _overwritingTween = _assertThisInitialized(_this3);
            _globalTimeline.killTweensOf(parsedTargets);
            _overwritingTween = 0;
        }
        _addToTimeline(parent, _assertThisInitialized(_this3), position);
        vars.reversed && _this3.reverse();
        vars.paused && _this3.paused(true);
        if (immediateRender || !duration && !keyframes && _this3._start === _roundPrecise(parent._time) && _isNotFalse(immediateRender) && _hasNoPausedAncestors(_assertThisInitialized(_this3)) && parent.data !== "nested") {
            _this3._tTime = -_tinyNum; //forces a render without having to set the render() "force" parameter to true because we want to allow lazying by default (using the "force" parameter always forces an immediate full render)
            _this3.render(Math.max(0, -delay) || 0); //in case delay is negative
        }
        scrollTrigger && _scrollTrigger(_assertThisInitialized(_this3), scrollTrigger);
        return _this3;
    }
    var _proto3 = Tween.prototype;
    _proto3.render = function render(totalTime, suppressEvents, force) {
        var prevTime = this._time, tDur = this._tDur, dur = this._dur, isNegative = totalTime < 0, tTime = totalTime > tDur - _tinyNum && !isNegative ? tDur : totalTime < _tinyNum ? 0 : totalTime, time, pt, iteration, cycleDuration, prevIteration, isYoyo, ratio, timeline, yoyoEase;
        if (!dur) _renderZeroDurationTween(this, totalTime, suppressEvents, force);
        else if (tTime !== this._tTime || !totalTime || force || !this._initted && this._tTime || this._startAt && this._zTime < 0 !== isNegative) {
            //this senses if we're crossing over the start time, in which case we must record _zTime and force the render, but we do it in this lengthy conditional way for performance reasons (usually we can skip the calculations): this._initted && (this._zTime < 0) !== (totalTime < 0)
            time = tTime;
            timeline = this.timeline;
            if (this._repeat) {
                //adjust the time for repeats and yoyos
                cycleDuration = dur + this._rDelay;
                if (this._repeat < -1 && isNegative) return this.totalTime(cycleDuration * 100 + totalTime, suppressEvents, force);
                time = _roundPrecise(tTime % cycleDuration); //round to avoid floating point errors. (4 % 0.8 should be 0 but some browsers report it as 0.79999999!)
                if (tTime === tDur) {
                    // the tDur === tTime is for edge cases where there's a lengthy decimal on the duration and it may reach the very end but the time is rendered as not-quite-there (remember, tDur is rounded to 4 decimals whereas dur isn't)
                    iteration = this._repeat;
                    time = dur;
                } else {
                    iteration = ~~(tTime / cycleDuration);
                    if (iteration && iteration === tTime / cycleDuration) {
                        time = dur;
                        iteration--;
                    }
                    time > dur && (time = dur);
                }
                isYoyo = this._yoyo && iteration & 1;
                if (isYoyo) {
                    yoyoEase = this._yEase;
                    time = dur - time;
                }
                prevIteration = _animationCycle(this._tTime, cycleDuration);
                if (time === prevTime && !force && this._initted) {
                    //could be during the repeatDelay part. No need to render and fire callbacks.
                    this._tTime = tTime;
                    return this;
                }
                if (iteration !== prevIteration) {
                    timeline && this._yEase && _propagateYoyoEase(timeline, isYoyo); //repeatRefresh functionality
                    if (this.vars.repeatRefresh && !isYoyo && !this._lock) {
                        this._lock = force = 1; //force, otherwise if lazy is true, the _attemptInitTween() will return and we'll jump out and get caught bouncing on each tick.
                        this.render(_roundPrecise(cycleDuration * iteration), true).invalidate()._lock = 0;
                    }
                }
            }
            if (!this._initted) {
                if (_attemptInitTween(this, isNegative ? totalTime : time, force, suppressEvents, tTime)) {
                    this._tTime = 0; // in constructor if immediateRender is true, we set _tTime to -_tinyNum to have the playhead cross the starting point but we can't leave _tTime as a negative number.
                    return this;
                }
                if (prevTime !== this._time) // rare edge case - during initialization, an onUpdate in the _startAt (.fromTo()) might force this tween to render at a different spot in which case we should ditch this render() call so that it doesn't revert the values.
                return this;
                if (dur !== this._dur) // while initting, a plugin like InertiaPlugin might alter the duration, so rerun from the start to ensure everything renders as it should.
                return this.render(totalTime, suppressEvents, force);
            }
            this._tTime = tTime;
            this._time = time;
            if (!this._act && this._ts) {
                this._act = 1; //as long as it's not paused, force it to be active so that if the user renders independent of the parent timeline, it'll be forced to re-render on the next tick.
                this._lazy = 0;
            }
            this.ratio = ratio = (yoyoEase || this._ease)(time / dur);
            if (this._from) this.ratio = ratio = 1 - ratio;
            if (time && !prevTime && !suppressEvents && !iteration) {
                _callback(this, "onStart");
                if (this._tTime !== tTime) // in case the onStart triggered a render at a different spot, eject. Like if someone did animation.pause(0.5) or something inside the onStart.
                return this;
            }
            pt = this._pt;
            while(pt){
                pt.r(ratio, pt.d);
                pt = pt._next;
            }
            timeline && timeline.render(totalTime < 0 ? totalTime : !time && isYoyo ? -_tinyNum : timeline._dur * timeline._ease(time / this._dur), suppressEvents, force) || this._startAt && (this._zTime = totalTime);
            if (this._onUpdate && !suppressEvents) {
                isNegative && _rewindStartAt(this, totalTime, suppressEvents, force); //note: for performance reasons, we tuck this conditional logic inside less traveled areas (most tweens don't have an onUpdate). We'd just have it at the end before the onComplete, but the values should be updated before any onUpdate is called, so we ALSO put it here and then if it's not called, we do so later near the onComplete.
                _callback(this, "onUpdate");
            }
            this._repeat && iteration !== prevIteration && this.vars.onRepeat && !suppressEvents && this.parent && _callback(this, "onRepeat");
            if ((tTime === this._tDur || !tTime) && this._tTime === tTime) {
                isNegative && !this._onUpdate && _rewindStartAt(this, totalTime, true, true);
                (totalTime || !dur) && (tTime === this._tDur && this._ts > 0 || !tTime && this._ts < 0) && _removeFromParent(this, 1); // don't remove if we're rendering at exactly a time of 0, as there could be autoRevert values that should get set on the next tick (if the playhead goes backward beyond the startTime, negative totalTime). Don't remove if the timeline is reversed and the playhead isn't at 0, otherwise tl.progress(1).reverse() won't work. Only remove if the playhead is at the end and timeScale is positive, or if the playhead is at 0 and the timeScale is negative.
                if (!suppressEvents && !(isNegative && !prevTime) && (tTime || prevTime || isYoyo)) {
                    // if prevTime and tTime are zero, we shouldn't fire the onReverseComplete. This could happen if you gsap.to(... {paused:true}).play();
                    _callback(this, tTime === tDur ? "onComplete" : "onReverseComplete", true);
                    this._prom && !(tTime < tDur && this.timeScale() > 0) && this._prom();
                }
            }
        }
        return this;
    };
    _proto3.targets = function targets() {
        return this._targets;
    };
    _proto3.invalidate = function invalidate(soft) {
        // "soft" gives us a way to clear out everything EXCEPT the recorded pre-"from" portion of from() tweens. Otherwise, for example, if you tween.progress(1).render(0, true true).invalidate(), the "from" values would persist and then on the next render, the from() tweens would initialize and the current value would match the "from" values, thus animate from the same value to the same value (no animation). We tap into this in ScrollTrigger's refresh() where we must push a tween to completion and then back again but honor its init state in case the tween is dependent on another tween further up on the page.
        (!soft || !this.vars.runBackwards) && (this._startAt = 0);
        this._pt = this._op = this._onUpdate = this._lazy = this.ratio = 0;
        this._ptLookup = [];
        this.timeline && this.timeline.invalidate(soft);
        return _Animation2.prototype.invalidate.call(this, soft);
    };
    _proto3.resetTo = function resetTo(property, value, start, startIsRelative) {
        _tickerActive || _ticker.wake();
        this._ts || this.play();
        var time = Math.min(this._dur, (this._dp._time - this._start) * this._ts), ratio;
        this._initted || _initTween(this, time);
        ratio = this._ease(time / this._dur); // don't just get tween.ratio because it may not have rendered yet.
        // possible future addition to allow an object with multiple values to update, like tween.resetTo({x: 100, y: 200}); At this point, it doesn't seem worth the added kb given the fact that most users will likely opt for the convenient gsap.quickTo() way of interacting with this method.
        // if (_isObject(property)) { // performance optimization
        // 	for (p in property) {
        // 		if (_updatePropTweens(this, p, property[p], value ? value[p] : null, start, ratio, time)) {
        // 			return this.resetTo(property, value, start, startIsRelative); // if a PropTween wasn't found for the property, it'll get forced with a re-initialization so we need to jump out and start over again.
        // 		}
        // 	}
        // } else {
        if (_updatePropTweens(this, property, value, start, startIsRelative, ratio, time)) return this.resetTo(property, value, start, startIsRelative); // if a PropTween wasn't found for the property, it'll get forced with a re-initialization so we need to jump out and start over again.
         //}
        _alignPlayhead(this, 0);
        this.parent || _addLinkedListItem(this._dp, this, "_first", "_last", this._dp._sort ? "_start" : 0);
        return this.render(0);
    };
    _proto3.kill = function kill(targets, vars) {
        if (vars === void 0) vars = "all";
        if (!targets && (!vars || vars === "all")) {
            this._lazy = this._pt = 0;
            return this.parent ? _interrupt(this) : this;
        }
        if (this.timeline) {
            var tDur = this.timeline.totalDuration();
            this.timeline.killTweensOf(targets, vars, _overwritingTween && _overwritingTween.vars.overwrite !== true)._first || _interrupt(this); // if nothing is left tweening, interrupt.
            this.parent && tDur !== this.timeline.totalDuration() && _setDuration(this, this._dur * this.timeline._tDur / tDur, 0, 1); // if a nested tween is killed that changes the duration, it should affect this tween's duration. We must use the ratio, though, because sometimes the internal timeline is stretched like for keyframes where they don't all add up to whatever the parent tween's duration was set to.
            return this;
        }
        var parsedTargets = this._targets, killingTargets = targets ? toArray(targets) : parsedTargets, propTweenLookup = this._ptLookup, firstPT = this._pt, overwrittenProps, curLookup, curOverwriteProps, props, p, pt, i;
        if ((!vars || vars === "all") && _arraysMatch(parsedTargets, killingTargets)) {
            vars === "all" && (this._pt = 0);
            return _interrupt(this);
        }
        overwrittenProps = this._op = this._op || [];
        if (vars !== "all") {
            //so people can pass in a comma-delimited list of property names
            if (_isString(vars)) {
                p = {};
                _forEachName(vars, function(name) {
                    return p[name] = 1;
                });
                vars = p;
            }
            vars = _addAliasesToVars(parsedTargets, vars);
        }
        i = parsedTargets.length;
        while(i--)if (~killingTargets.indexOf(parsedTargets[i])) {
            curLookup = propTweenLookup[i];
            if (vars === "all") {
                overwrittenProps[i] = vars;
                props = curLookup;
                curOverwriteProps = {};
            } else {
                curOverwriteProps = overwrittenProps[i] = overwrittenProps[i] || {};
                props = vars;
            }
            for(p in props){
                pt = curLookup && curLookup[p];
                if (pt) {
                    if (!("kill" in pt.d) || pt.d.kill(p) === true) _removeLinkedListItem(this, pt, "_pt");
                    delete curLookup[p];
                }
                if (curOverwriteProps !== "all") curOverwriteProps[p] = 1;
            }
        }
        this._initted && !this._pt && firstPT && _interrupt(this); //if all tweening properties are killed, kill the tween. Without this line, if there's a tween with multiple targets and then you killTweensOf() each target individually, the tween would technically still remain active and fire its onComplete even though there aren't any more properties tweening.
        return this;
    };
    Tween.to = function to(targets, vars) {
        return new Tween(targets, vars, arguments[2]);
    };
    Tween.from = function from(targets, vars) {
        return _createTweenType(1, arguments);
    };
    Tween.delayedCall = function delayedCall(delay, callback, params, scope) {
        return new Tween(callback, 0, {
            immediateRender: false,
            lazy: false,
            overwrite: false,
            delay: delay,
            onComplete: callback,
            onReverseComplete: callback,
            onCompleteParams: params,
            onReverseCompleteParams: params,
            callbackScope: scope
        }); // we must use onReverseComplete too for things like timeline.add(() => {...}) which should be triggered in BOTH directions (forward and reverse)
    };
    Tween.fromTo = function fromTo(targets, fromVars, toVars) {
        return _createTweenType(2, arguments);
    };
    Tween.set = function set(targets, vars) {
        vars.duration = 0;
        vars.repeatDelay || (vars.repeat = 0);
        return new Tween(targets, vars);
    };
    Tween.killTweensOf = function killTweensOf(targets, props, onlyActive) {
        return _globalTimeline.killTweensOf(targets, props, onlyActive);
    };
    return Tween;
}(Animation);
_setDefaults(Tween.prototype, {
    _targets: [],
    _lazy: 0,
    _startAt: 0,
    _op: 0,
    _onInit: 0
}); //add the pertinent timeline methods to Tween instances so that users can chain conveniently and create a timeline automatically. (removed due to concerns that it'd ultimately add to more confusion especially for beginners)
// _forEachName("to,from,fromTo,set,call,add,addLabel,addPause", name => {
// 	Tween.prototype[name] = function() {
// 		let tl = new Timeline();
// 		return _addToTimeline(tl, this)[name].apply(tl, toArray(arguments));
// 	}
// });
//for backward compatibility. Leverage the timeline calls.
_forEachName("staggerTo,staggerFrom,staggerFromTo", function(name) {
    Tween[name] = function() {
        var tl = new Timeline(), params = _slice.call(arguments, 0);
        params.splice(name === "staggerFromTo" ? 5 : 4, 0, 0);
        return tl[name].apply(tl, params);
    };
});
/*
 * --------------------------------------------------------------------------------------
 * PROPTWEEN
 * --------------------------------------------------------------------------------------
 */ var _setterPlain = function _setterPlain(target, property, value) {
    return target[property] = value;
}, _setterFunc = function _setterFunc(target, property, value) {
    return target[property](value);
}, _setterFuncWithParam = function _setterFuncWithParam(target, property, value, data) {
    return target[property](data.fp, value);
}, _setterAttribute = function _setterAttribute(target, property, value) {
    return target.setAttribute(property, value);
}, _getSetter = function _getSetter(target, property) {
    return _isFunction(target[property]) ? _setterFunc : _isUndefined(target[property]) && target.setAttribute ? _setterAttribute : _setterPlain;
}, _renderPlain = function _renderPlain(ratio, data) {
    return data.set(data.t, data.p, Math.round((data.s + data.c * ratio) * 1000000) / 1000000, data);
}, _renderBoolean = function _renderBoolean(ratio, data) {
    return data.set(data.t, data.p, !!(data.s + data.c * ratio), data);
}, _renderComplexString = function _renderComplexString(ratio, data) {
    var pt = data._pt, s = "";
    if (!ratio && data.b) //b = beginning string
    s = data.b;
    else if (ratio === 1 && data.e) //e = ending string
    s = data.e;
    else {
        while(pt){
            s = pt.p + (pt.m ? pt.m(pt.s + pt.c * ratio) : Math.round((pt.s + pt.c * ratio) * 10000) / 10000) + s; //we use the "p" property for the text inbetween (like a suffix). And in the context of a complex string, the modifier (m) is typically just Math.round(), like for RGB colors.
            pt = pt._next;
        }
        s += data.c; //we use the "c" of the PropTween to store the final chunk of non-numeric text.
    }
    data.set(data.t, data.p, s, data);
}, _renderPropTweens = function _renderPropTweens(ratio, data) {
    var pt = data._pt;
    while(pt){
        pt.r(ratio, pt.d);
        pt = pt._next;
    }
}, _addPluginModifier = function _addPluginModifier(modifier, tween, target, property) {
    var pt = this._pt, next;
    while(pt){
        next = pt._next;
        pt.p === property && pt.modifier(modifier, tween, target);
        pt = next;
    }
}, _killPropTweensOf = function _killPropTweensOf(property) {
    var pt = this._pt, hasNonDependentRemaining, next;
    while(pt){
        next = pt._next;
        if (pt.p === property && !pt.op || pt.op === property) _removeLinkedListItem(this, pt, "_pt");
        else if (!pt.dep) hasNonDependentRemaining = 1;
        pt = next;
    }
    return !hasNonDependentRemaining;
}, _setterWithModifier = function _setterWithModifier(target, property, value, data) {
    data.mSet(target, property, data.m.call(data.tween, value, data.mt), data);
}, _sortPropTweensByPriority = function _sortPropTweensByPriority(parent) {
    var pt = parent._pt, next, pt2, first, last; //sorts the PropTween linked list in order of priority because some plugins need to do their work after ALL of the PropTweens were created (like RoundPropsPlugin and ModifiersPlugin)
    while(pt){
        next = pt._next;
        pt2 = first;
        while(pt2 && pt2.pr > pt.pr)pt2 = pt2._next;
        if (pt._prev = pt2 ? pt2._prev : last) pt._prev._next = pt;
        else first = pt;
        if (pt._next = pt2) pt2._prev = pt;
        else last = pt;
        pt = next;
    }
    parent._pt = first;
}; //PropTween key: t = target, p = prop, r = renderer, d = data, s = start, c = change, op = overwriteProperty (ONLY populated when it's different than p), pr = priority, _next/_prev for the linked list siblings, set = setter, m = modifier, mSet = modifierSetter (the original setter, before a modifier was added)
var PropTween = /*#__PURE__*/ function() {
    function PropTween(next, target, prop, start, change, renderer, data, setter, priority) {
        this.t = target;
        this.s = start;
        this.c = change;
        this.p = prop;
        this.r = renderer || _renderPlain;
        this.d = data || this;
        this.set = setter || _setterPlain;
        this.pr = priority || 0;
        this._next = next;
        if (next) next._prev = this;
    }
    var _proto4 = PropTween.prototype;
    _proto4.modifier = function modifier(func, tween, target) {
        this.mSet = this.mSet || this.set; //in case it was already set (a PropTween can only have one modifier)
        this.set = _setterWithModifier;
        this.m = func;
        this.mt = target; //modifier target
        this.tween = tween;
    };
    return PropTween;
}(); //Initialization tasks
_forEachName(_callbackNames + "parent,duration,ease,delay,overwrite,runBackwards,startAt,yoyo,immediateRender,repeat,repeatDelay,data,paused,reversed,lazy,callbackScope,stringFilter,id,yoyoEase,stagger,inherit,repeatRefresh,keyframes,autoRevert,scrollTrigger", function(name) {
    return _reservedProps[name] = 1;
});
_globals.TweenMax = _globals.TweenLite = Tween;
_globals.TimelineLite = _globals.TimelineMax = Timeline;
_globalTimeline = new Timeline({
    sortChildren: false,
    defaults: _defaults,
    autoRemoveChildren: true,
    id: "root",
    smoothChildTiming: true
});
_config.stringFilter = _colorStringFilter;
var _media = [], _listeners = {}, _emptyArray = [], _lastMediaTime = 0, _contextID = 0, _dispatch = function _dispatch(type) {
    return (_listeners[type] || _emptyArray).map(function(f) {
        return f();
    });
}, _onMediaChange = function _onMediaChange() {
    var time = Date.now(), matches = [];
    if (time - _lastMediaTime > 2) {
        _dispatch("matchMediaInit");
        _media.forEach(function(c) {
            var queries = c.queries, conditions = c.conditions, match, p, anyMatch, toggled;
            for(p in queries){
                match = _win.matchMedia(queries[p]).matches; // Firefox doesn't update the "matches" property of the MediaQueryList object correctly - it only does so as it calls its change handler - so we must re-create a media query here to ensure it's accurate.
                match && (anyMatch = 1);
                if (match !== conditions[p]) {
                    conditions[p] = match;
                    toggled = 1;
                }
            }
            if (toggled) {
                c.revert();
                anyMatch && matches.push(c);
            }
        });
        _dispatch("matchMediaRevert");
        matches.forEach(function(c) {
            return c.onMatch(c);
        });
        _lastMediaTime = time;
        _dispatch("matchMedia");
    }
};
var Context = /*#__PURE__*/ function() {
    function Context(func, scope) {
        this.selector = scope && selector(scope);
        this.data = [];
        this._r = []; // returned/cleanup functions
        this.isReverted = false;
        this.id = _contextID++; // to work around issues that frameworks like Vue cause by making things into Proxies which make it impossible to do something like _media.indexOf(this) because "this" would no longer refer to the Context instance itself - it'd refer to a Proxy! We needed a way to identify the context uniquely
        func && this.add(func);
    }
    var _proto5 = Context.prototype;
    _proto5.add = function add(name, func, scope) {
        // possible future addition if we need the ability to add() an animation to a context and for whatever reason cannot create that animation inside of a context.add(() => {...}) function.
        // if (name && _isFunction(name.revert)) {
        // 	this.data.push(name);
        // 	return (name._ctx = this);
        // }
        if (_isFunction(name)) {
            scope = func;
            func = name;
            name = _isFunction;
        }
        var self = this, f = function f() {
            var prev = _context, prevSelector = self.selector, result;
            prev && prev !== self && prev.data.push(self);
            scope && (self.selector = selector(scope));
            _context = self;
            result = func.apply(self, arguments);
            _isFunction(result) && self._r.push(result);
            _context = prev;
            self.selector = prevSelector;
            self.isReverted = false;
            return result;
        };
        self.last = f;
        return name === _isFunction ? f(self) : name ? self[name] = f : f;
    };
    _proto5.ignore = function ignore(func) {
        var prev = _context;
        _context = null;
        func(this);
        _context = prev;
    };
    _proto5.getTweens = function getTweens() {
        var a = [];
        this.data.forEach(function(e) {
            return e instanceof Context ? a.push.apply(a, e.getTweens()) : e instanceof Tween && !(e.parent && e.parent.data === "nested") && a.push(e);
        });
        return a;
    };
    _proto5.clear = function clear() {
        this._r.length = this.data.length = 0;
    };
    _proto5.kill = function kill(revert, matchMedia) {
        var _this4 = this;
        if (revert) {
            var tweens = this.getTweens();
            this.data.forEach(function(t) {
                // Flip plugin tweens are very different in that they should actually be pushed to their end. The plugin replaces the timeline's .revert() method to do exactly that. But we also need to remove any of those nested tweens inside the flip timeline so that they don't get individually reverted.
                if (t.data === "isFlip") {
                    t.revert();
                    t.getChildren(true, true, false).forEach(function(tween) {
                        return tweens.splice(tweens.indexOf(tween), 1);
                    });
                }
            }); // save as an object so that we can cache the globalTime for each tween to optimize performance during the sort
            tweens.map(function(t) {
                return {
                    g: t.globalTime(0),
                    t: t
                };
            }).sort(function(a, b) {
                return b.g - a.g || -Infinity;
            }).forEach(function(o) {
                return o.t.revert(revert);
            }); // note: all of the _startAt tweens should be reverted in reverse order that they were created, and they'll all have the same globalTime (-1) so the " || -1" in the sort keeps the order properly.
            this.data.forEach(function(e) {
                return !(e instanceof Tween) && e.revert && e.revert(revert);
            });
            this._r.forEach(function(f) {
                return f(revert, _this4);
            });
            this.isReverted = true;
        } else this.data.forEach(function(e) {
            return e.kill && e.kill();
        });
        this.clear();
        if (matchMedia) {
            var i = _media.length;
            while(i--)// previously, we checked _media.indexOf(this), but some frameworks like Vue enforce Proxy objects that make it impossible to get the proper result that way, so we must use a unique ID number instead.
            _media[i].id === this.id && _media.splice(i, 1);
        }
    };
    _proto5.revert = function revert(config) {
        this.kill(config || {});
    };
    return Context;
}();
var MatchMedia = /*#__PURE__*/ function() {
    function MatchMedia(scope) {
        this.contexts = [];
        this.scope = scope;
    }
    var _proto6 = MatchMedia.prototype;
    _proto6.add = function add(conditions, func, scope) {
        _isObject(conditions) || (conditions = {
            matches: conditions
        });
        var context = new Context(0, scope || this.scope), cond = context.conditions = {}, mq, p, active;
        _context && !context.selector && (context.selector = _context.selector); // in case a context is created inside a context. Like a gsap.matchMedia() that's inside a scoped gsap.context()
        this.contexts.push(context);
        func = context.add("onMatch", func);
        context.queries = conditions;
        for(p in conditions)if (p === "all") active = 1;
        else {
            mq = _win.matchMedia(conditions[p]);
            if (mq) {
                _media.indexOf(context) < 0 && _media.push(context);
                (cond[p] = mq.matches) && (active = 1);
                mq.addListener ? mq.addListener(_onMediaChange) : mq.addEventListener("change", _onMediaChange);
            }
        }
        active && func(context);
        return this;
    } // refresh() {
    ;
    _proto6.revert = function revert(config) {
        this.kill(config || {});
    };
    _proto6.kill = function kill(revert) {
        this.contexts.forEach(function(c) {
            return c.kill(revert, true);
        });
    };
    return MatchMedia;
}();
/*
 * --------------------------------------------------------------------------------------
 * GSAP
 * --------------------------------------------------------------------------------------
 */ var _gsap = {
    registerPlugin: function registerPlugin() {
        for(var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)args[_key2] = arguments[_key2];
        args.forEach(function(config) {
            return _createPlugin(config);
        });
    },
    timeline: function timeline(vars) {
        return new Timeline(vars);
    },
    getTweensOf: function getTweensOf(targets, onlyActive) {
        return _globalTimeline.getTweensOf(targets, onlyActive);
    },
    getProperty: function getProperty(target, property, unit, uncache) {
        _isString(target) && (target = toArray(target)[0]); //in case selector text or an array is passed in
        var getter = _getCache(target || {}).get, format = unit ? _passThrough : _numericIfPossible;
        unit === "native" && (unit = "");
        return !target ? target : !property ? function(property, unit, uncache) {
            return format((_plugins[property] && _plugins[property].get || getter)(target, property, unit, uncache));
        } : format((_plugins[property] && _plugins[property].get || getter)(target, property, unit, uncache));
    },
    quickSetter: function quickSetter(target, property, unit) {
        target = toArray(target);
        if (target.length > 1) {
            var setters = target.map(function(t) {
                return gsap.quickSetter(t, property, unit);
            }), l = setters.length;
            return function(value) {
                var i = l;
                while(i--)setters[i](value);
            };
        }
        target = target[0] || {};
        var Plugin = _plugins[property], cache = _getCache(target), p = cache.harness && (cache.harness.aliases || {})[property] || property, // in case it's an alias, like "rotate" for "rotation".
        setter = Plugin ? function(value) {
            var p = new Plugin();
            _quickTween._pt = 0;
            p.init(target, unit ? value + unit : value, _quickTween, 0, [
                target
            ]);
            p.render(1, p);
            _quickTween._pt && _renderPropTweens(1, _quickTween);
        } : cache.set(target, p);
        return Plugin ? setter : function(value) {
            return setter(target, p, unit ? value + unit : value, cache, 1);
        };
    },
    quickTo: function quickTo(target, property, vars) {
        var _merge2;
        var tween = gsap.to(target, _merge((_merge2 = {}, _merge2[property] = "+=0.1", _merge2.paused = true, _merge2), vars || {})), func = function func(value, start, startIsRelative) {
            return tween.resetTo(property, value, start, startIsRelative);
        };
        func.tween = tween;
        return func;
    },
    isTweening: function isTweening(targets) {
        return _globalTimeline.getTweensOf(targets, true).length > 0;
    },
    defaults: function defaults(value) {
        value && value.ease && (value.ease = _parseEase(value.ease, _defaults.ease));
        return _mergeDeep(_defaults, value || {});
    },
    config: function config(value) {
        return _mergeDeep(_config, value || {});
    },
    registerEffect: function registerEffect(_ref3) {
        var name = _ref3.name, effect = _ref3.effect, plugins = _ref3.plugins, defaults = _ref3.defaults, extendTimeline = _ref3.extendTimeline;
        (plugins || "").split(",").forEach(function(pluginName) {
            return pluginName && !_plugins[pluginName] && !_globals[pluginName] && _warn(name + " effect requires " + pluginName + " plugin.");
        });
        _effects[name] = function(targets, vars, tl) {
            return effect(toArray(targets), _setDefaults(vars || {}, defaults), tl);
        };
        if (extendTimeline) Timeline.prototype[name] = function(targets, vars, position) {
            return this.add(_effects[name](targets, _isObject(vars) ? vars : (position = vars) && {}, this), position);
        };
    },
    registerEase: function registerEase(name, ease) {
        _easeMap[name] = _parseEase(ease);
    },
    parseEase: function parseEase(ease, defaultEase) {
        return arguments.length ? _parseEase(ease, defaultEase) : _easeMap;
    },
    getById: function getById(id) {
        return _globalTimeline.getById(id);
    },
    exportRoot: function exportRoot(vars, includeDelayedCalls) {
        if (vars === void 0) vars = {};
        var tl = new Timeline(vars), child, next;
        tl.smoothChildTiming = _isNotFalse(vars.smoothChildTiming);
        _globalTimeline.remove(tl);
        tl._dp = 0; //otherwise it'll get re-activated when adding children and be re-introduced into _globalTimeline's linked list (then added to itself).
        tl._time = tl._tTime = _globalTimeline._time;
        child = _globalTimeline._first;
        while(child){
            next = child._next;
            if (includeDelayedCalls || !(!child._dur && child instanceof Tween && child.vars.onComplete === child._targets[0])) _addToTimeline(tl, child, child._start - child._delay);
            child = next;
        }
        _addToTimeline(_globalTimeline, tl, 0);
        return tl;
    },
    context: function context(func, scope) {
        return func ? new Context(func, scope) : _context;
    },
    matchMedia: function matchMedia(scope) {
        return new MatchMedia(scope);
    },
    matchMediaRefresh: function matchMediaRefresh() {
        return _media.forEach(function(c) {
            var cond = c.conditions, found, p;
            for(p in cond)if (cond[p]) {
                cond[p] = false;
                found = 1;
            }
            found && c.revert();
        }) || _onMediaChange();
    },
    addEventListener: function addEventListener(type, callback) {
        var a = _listeners[type] || (_listeners[type] = []);
        ~a.indexOf(callback) || a.push(callback);
    },
    removeEventListener: function removeEventListener(type, callback) {
        var a = _listeners[type], i = a && a.indexOf(callback);
        i >= 0 && a.splice(i, 1);
    },
    utils: {
        wrap: wrap,
        wrapYoyo: wrapYoyo,
        distribute: distribute,
        random: random,
        snap: snap,
        normalize: normalize,
        getUnit: getUnit,
        clamp: clamp,
        splitColor: splitColor,
        toArray: toArray,
        selector: selector,
        mapRange: mapRange,
        pipe: pipe,
        unitize: unitize,
        interpolate: interpolate,
        shuffle: shuffle
    },
    install: _install,
    effects: _effects,
    ticker: _ticker,
    updateRoot: Timeline.updateRoot,
    plugins: _plugins,
    globalTimeline: _globalTimeline,
    core: {
        PropTween: PropTween,
        globals: _addGlobal,
        Tween: Tween,
        Timeline: Timeline,
        Animation: Animation,
        getCache: _getCache,
        _removeLinkedListItem: _removeLinkedListItem,
        reverting: function reverting() {
            return _reverting;
        },
        context: function context(toAdd) {
            if (toAdd && _context) {
                _context.data.push(toAdd);
                toAdd._ctx = _context;
            }
            return _context;
        },
        suppressOverwrites: function suppressOverwrites(value) {
            return _suppressOverwrites = value;
        }
    }
};
_forEachName("to,from,fromTo,delayedCall,set,killTweensOf", function(name) {
    return _gsap[name] = Tween[name];
});
_ticker.add(Timeline.updateRoot);
_quickTween = _gsap.to({}, {
    duration: 0
}); // ---- EXTRA PLUGINS --------------------------------------------------------
var _getPluginPropTween = function _getPluginPropTween(plugin, prop) {
    var pt = plugin._pt;
    while(pt && pt.p !== prop && pt.op !== prop && pt.fp !== prop)pt = pt._next;
    return pt;
}, _addModifiers = function _addModifiers(tween, modifiers) {
    var targets = tween._targets, p, i, pt;
    for(p in modifiers){
        i = targets.length;
        while(i--){
            pt = tween._ptLookup[i][p];
            if (pt && (pt = pt.d)) {
                if (pt._pt) // is a plugin
                pt = _getPluginPropTween(pt, p);
                pt && pt.modifier && pt.modifier(modifiers[p], tween, targets[i], p);
            }
        }
    }
}, _buildModifierPlugin = function _buildModifierPlugin(name, modifier) {
    return {
        name: name,
        rawVars: 1,
        //don't pre-process function-based values or "random()" strings.
        init: function init(target, vars, tween) {
            tween._onInit = function(tween) {
                var temp, p;
                if (_isString(vars)) {
                    temp = {};
                    _forEachName(vars, function(name) {
                        return temp[name] = 1;
                    }); //if the user passes in a comma-delimited list of property names to roundProps, like "x,y", we round to whole numbers.
                    vars = temp;
                }
                if (modifier) {
                    temp = {};
                    for(p in vars)temp[p] = modifier(vars[p]);
                    vars = temp;
                }
                _addModifiers(tween, vars);
            };
        }
    };
}; //register core plugins
var gsap = _gsap.registerPlugin({
    name: "attr",
    init: function init(target, vars, tween, index, targets) {
        var p, pt, v;
        this.tween = tween;
        for(p in vars){
            v = target.getAttribute(p) || "";
            pt = this.add(target, "setAttribute", (v || 0) + "", vars[p], index, targets, 0, 0, p);
            pt.op = p;
            pt.b = v; // record the beginning value so we can revert()
            this._props.push(p);
        }
    },
    render: function render(ratio, data) {
        var pt = data._pt;
        while(pt){
            _reverting ? pt.set(pt.t, pt.p, pt.b, pt) : pt.r(ratio, pt.d); // if reverting, go back to the original (pt.b)
            pt = pt._next;
        }
    }
}, {
    name: "endArray",
    init: function init(target, value) {
        var i = value.length;
        while(i--)this.add(target, i, target[i] || 0, value[i], 0, 0, 0, 0, 0, 1);
    }
}, _buildModifierPlugin("roundProps", _roundModifier), _buildModifierPlugin("modifiers"), _buildModifierPlugin("snap", snap)) || _gsap; //to prevent the core plugins from being dropped via aggressive tree shaking, we must include them in the variable declaration in this way.
Tween.version = Timeline.version = gsap.version = "3.12.2";
_coreReady = 1;
_windowExists() && _wake();
var Power0 = _easeMap.Power0, Power1 = _easeMap.Power1, Power2 = _easeMap.Power2, Power3 = _easeMap.Power3, Power4 = _easeMap.Power4, Linear = _easeMap.Linear, Quad = _easeMap.Quad, Cubic = _easeMap.Cubic, Quart = _easeMap.Quart, Quint = _easeMap.Quint, Strong = _easeMap.Strong, Elastic = _easeMap.Elastic, Back = _easeMap.Back, SteppedEase = _easeMap.SteppedEase, Bounce = _easeMap.Bounce, Sine = _easeMap.Sine, Expo = _easeMap.Expo, Circ = _easeMap.Circ;

});

parcelRegister("ftY1i", function(module, exports) {

$parcel$export(module.exports, "zeroPad", () => zeroPad);
$parcel$export(module.exports, "calcTimeDelta", () => calcTimeDelta);
$parcel$export(module.exports, "formatTimeDelta", () => formatTimeDelta);
$parcel$export(module.exports, "default", () => $b4581f2618089d23$export$2e2bcd8739ae039);

var $acw62 = parcelRequire("acw62");

var $c9Z8w = parcelRequire("c9Z8w");
function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function _defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function _createClass(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    return Constructor;
}
function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) _setPrototypeOf(subClass, superClass);
}
function _getPrototypeOf(o) {
    _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return _getPrototypeOf(o);
}
function _setPrototypeOf(o, p) {
    _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return _setPrototypeOf(o, p);
}
function _isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Date.prototype.toString.call(Reflect.construct(Date, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function _assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function _possibleConstructorReturn(self, call) {
    if (call && (typeof call === "object" || typeof call === "function")) return call;
    return _assertThisInitialized(self);
}
function _createSuper(Derived) {
    var hasNativeReflectConstruct = _isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = _getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = _getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return _possibleConstructorReturn(this, result);
    };
}
function _toConsumableArray(arr) {
    return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
}
function _arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return _arrayLikeToArray(arr);
}
function _iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter);
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function zeroPad(value) {
    var length = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 2;
    var strValue = String(value);
    if (length === 0) return strValue;
    var match = strValue.match(/(.*?)([0-9]+)(.*)/);
    var prefix = match ? match[1] : "";
    var suffix = match ? match[3] : "";
    var strNo = match ? match[2] : strValue;
    var paddedNo = strNo.length >= length ? strNo : (_toConsumableArray(Array(length)).map(function() {
        return "0";
    }).join("") + strNo).slice(length * -1);
    return "".concat(prefix).concat(paddedNo).concat(suffix);
}
var timeDeltaFormatOptionsDefaults = {
    daysInHours: false,
    zeroPadTime: 2
};
function calcTimeDelta(date) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var _options$now = options.now, now = _options$now === void 0 ? Date.now : _options$now, _options$precision = options.precision, precision = _options$precision === void 0 ? 0 : _options$precision, controlled = options.controlled, _options$offsetTime = options.offsetTime, offsetTime = _options$offsetTime === void 0 ? 0 : _options$offsetTime, overtime = options.overtime;
    var startTimestamp;
    if (typeof date === "string") startTimestamp = new Date(date).getTime();
    else if (date instanceof Date) startTimestamp = date.getTime();
    else startTimestamp = date;
    if (!controlled) startTimestamp += offsetTime;
    var timeLeft = controlled ? startTimestamp : startTimestamp - now();
    var clampedPrecision = Math.min(20, Math.max(0, precision));
    var total = Math.round(parseFloat(((overtime ? timeLeft : Math.max(0, timeLeft)) / 1000).toFixed(clampedPrecision)) * 1000);
    var seconds = Math.abs(total) / 1000;
    return {
        total: total,
        days: Math.floor(seconds / 86400),
        hours: Math.floor(seconds / 3600 % 24),
        minutes: Math.floor(seconds / 60 % 60),
        seconds: Math.floor(seconds % 60),
        milliseconds: Number((seconds % 1 * 1000).toFixed()),
        completed: total <= 0
    };
}
function formatTimeDelta(timeDelta, options) {
    var days = timeDelta.days, hours = timeDelta.hours, minutes = timeDelta.minutes, seconds = timeDelta.seconds;
    var _Object$assign = Object.assign(Object.assign({}, timeDeltaFormatOptionsDefaults), options), daysInHours = _Object$assign.daysInHours, zeroPadTime = _Object$assign.zeroPadTime, _Object$assign$zeroPa = _Object$assign.zeroPadDays, zeroPadDays = _Object$assign$zeroPa === void 0 ? zeroPadTime : _Object$assign$zeroPa;
    var zeroPadTimeLength = Math.min(2, zeroPadTime);
    var formattedHours = daysInHours ? zeroPad(hours + days * 24, zeroPadTime) : zeroPad(hours, zeroPadTimeLength);
    return {
        days: daysInHours ? "" : zeroPad(days, zeroPadDays),
        hours: formattedHours,
        minutes: zeroPad(minutes, zeroPadTimeLength),
        seconds: zeroPad(seconds, zeroPadTimeLength)
    };
}
var Countdown = function(_React$Component) {
    _inherits(Countdown, _React$Component);
    var _super = _createSuper(Countdown);
    function Countdown() {
        var _this;
        _classCallCheck(this, Countdown);
        _this = _super.apply(this, arguments);
        _this.state = {
            count: _this.props.count || 3
        };
        _this.startCountdown = function() {
            _this.interval = window.setInterval(function() {
                var count = _this.state.count - 1;
                if (count === 0) {
                    _this.stopCountdown();
                    _this.props.onComplete && _this.props.onComplete();
                } else _this.setState(function(prevState) {
                    return {
                        count: prevState.count - 1
                    };
                });
            }, 1000);
        };
        _this.stopCountdown = function() {
            clearInterval(_this.interval);
        };
        _this.addTime = function(seconds) {
            _this.stopCountdown();
            _this.setState(function(prevState) {
                return {
                    count: prevState.count + seconds
                };
            }, _this.startCountdown);
        };
        return _this;
    }
    _createClass(Countdown, [
        {
            key: "componentDidMount",
            value: function componentDidMount() {
                this.startCountdown();
            }
        },
        {
            key: "componentWillUnmount",
            value: function componentWillUnmount() {
                clearInterval(this.interval);
            }
        },
        {
            key: "render",
            value: function render() {
                return this.props.children ? (0, $acw62.cloneElement)(this.props.children, {
                    count: this.state.count
                }) : null;
            }
        }
    ]);
    return Countdown;
}((0, $acw62.Component));
Countdown.propTypes = {
    count: (0, $c9Z8w.number),
    children: (0, $c9Z8w.element),
    onComplete: (0, $c9Z8w.func)
};
var Countdown$1 = function(_React$Component) {
    _inherits(Countdown$1, _React$Component);
    var _super = _createSuper(Countdown$1);
    function Countdown$1(props) {
        var _this;
        _classCallCheck(this, Countdown$1);
        _this = _super.call(this, props);
        _this.mounted = false;
        _this.initialTimestamp = _this.calcOffsetStartTimestamp();
        _this.offsetStartTimestamp = _this.props.autoStart ? 0 : _this.initialTimestamp;
        _this.offsetTime = 0;
        _this.legacyMode = false;
        _this.legacyCountdownRef = (0, $acw62.createRef)();
        _this.tick = function() {
            var timeDelta = _this.calcTimeDelta();
            var callback = timeDelta.completed && !_this.props.overtime ? undefined : _this.props.onTick;
            _this.setTimeDeltaState(timeDelta, undefined, callback);
        };
        _this.start = function() {
            if (_this.isStarted()) return;
            var prevOffsetStartTimestamp = _this.offsetStartTimestamp;
            _this.offsetStartTimestamp = 0;
            _this.offsetTime += prevOffsetStartTimestamp ? _this.calcOffsetStartTimestamp() - prevOffsetStartTimestamp : 0;
            var timeDelta = _this.calcTimeDelta();
            _this.setTimeDeltaState(timeDelta, "STARTED", _this.props.onStart);
            if (!_this.props.controlled && (!timeDelta.completed || _this.props.overtime)) {
                _this.clearTimer();
                _this.interval = window.setInterval(_this.tick, _this.props.intervalDelay);
            }
        };
        _this.pause = function() {
            if (_this.isPaused()) return;
            _this.clearTimer();
            _this.offsetStartTimestamp = _this.calcOffsetStartTimestamp();
            _this.setTimeDeltaState(_this.state.timeDelta, "PAUSED", _this.props.onPause);
        };
        _this.stop = function() {
            if (_this.isStopped()) return;
            _this.clearTimer();
            _this.offsetStartTimestamp = _this.calcOffsetStartTimestamp();
            _this.offsetTime = _this.offsetStartTimestamp - _this.initialTimestamp;
            _this.setTimeDeltaState(_this.calcTimeDelta(), "STOPPED", _this.props.onStop);
        };
        _this.isStarted = function() {
            return _this.isStatus("STARTED");
        };
        _this.isPaused = function() {
            return _this.isStatus("PAUSED");
        };
        _this.isStopped = function() {
            return _this.isStatus("STOPPED");
        };
        _this.isCompleted = function() {
            return _this.isStatus("COMPLETED");
        };
        if (props.date) {
            var timeDelta = _this.calcTimeDelta();
            _this.state = {
                timeDelta: timeDelta,
                status: timeDelta.completed ? "COMPLETED" : "STOPPED"
            };
        } else _this.legacyMode = true;
        return _this;
    }
    _createClass(Countdown$1, [
        {
            key: "componentDidMount",
            value: function componentDidMount() {
                if (this.legacyMode) return;
                this.mounted = true;
                if (this.props.onMount) this.props.onMount(this.calcTimeDelta());
                if (this.props.autoStart) this.start();
            }
        },
        {
            key: "componentDidUpdate",
            value: function componentDidUpdate(prevProps) {
                if (this.legacyMode) return;
                if (this.props.date !== prevProps.date) {
                    this.initialTimestamp = this.calcOffsetStartTimestamp();
                    this.offsetStartTimestamp = this.initialTimestamp;
                    this.offsetTime = 0;
                    this.setTimeDeltaState(this.calcTimeDelta());
                }
            }
        },
        {
            key: "componentWillUnmount",
            value: function componentWillUnmount() {
                if (this.legacyMode) return;
                this.mounted = false;
                this.clearTimer();
            }
        },
        {
            key: "calcTimeDelta",
            value: function calcTimeDelta$1() {
                var _this$props = this.props, date = _this$props.date, now = _this$props.now, precision = _this$props.precision, controlled = _this$props.controlled, overtime = _this$props.overtime;
                return calcTimeDelta(date, {
                    now: now,
                    precision: precision,
                    controlled: controlled,
                    offsetTime: this.offsetTime,
                    overtime: overtime
                });
            }
        },
        {
            key: "calcOffsetStartTimestamp",
            value: function calcOffsetStartTimestamp() {
                return Date.now();
            }
        },
        {
            key: "addTime",
            value: function addTime(seconds) {
                this.legacyCountdownRef.current.addTime(seconds);
            }
        },
        {
            key: "clearTimer",
            value: function clearTimer() {
                window.clearInterval(this.interval);
            }
        },
        {
            key: "isStatus",
            value: function isStatus(status) {
                return this.state.status === status;
            }
        },
        {
            key: "setTimeDeltaState",
            value: function setTimeDeltaState(timeDelta, status, callback) {
                var _this2 = this;
                if (!this.mounted) return;
                var completing = timeDelta.completed && !this.state.timeDelta.completed;
                var completedOnStart = timeDelta.completed && status === "STARTED";
                if (completing && !this.props.overtime) this.clearTimer();
                var onDone = function onDone() {
                    if (callback) callback(_this2.state.timeDelta);
                    if (_this2.props.onComplete && (completing || completedOnStart)) _this2.props.onComplete(timeDelta, completedOnStart);
                };
                return this.setState(function(prevState) {
                    var newStatus = status || prevState.status;
                    if (timeDelta.completed && !_this2.props.overtime) newStatus = "COMPLETED";
                    else if (!status && newStatus === "COMPLETED") newStatus = "STOPPED";
                    return {
                        timeDelta: timeDelta,
                        status: newStatus
                    };
                }, onDone);
            }
        },
        {
            key: "getApi",
            value: function getApi() {
                return this.api = this.api || {
                    start: this.start,
                    pause: this.pause,
                    stop: this.stop,
                    isStarted: this.isStarted,
                    isPaused: this.isPaused,
                    isStopped: this.isStopped,
                    isCompleted: this.isCompleted
                };
            }
        },
        {
            key: "getRenderProps",
            value: function getRenderProps() {
                var _this$props2 = this.props, daysInHours = _this$props2.daysInHours, zeroPadTime = _this$props2.zeroPadTime, zeroPadDays = _this$props2.zeroPadDays;
                var timeDelta = this.state.timeDelta;
                return Object.assign(Object.assign({}, timeDelta), {
                    api: this.getApi(),
                    props: this.props,
                    formatted: formatTimeDelta(timeDelta, {
                        daysInHours: daysInHours,
                        zeroPadTime: zeroPadTime,
                        zeroPadDays: zeroPadDays
                    })
                });
            }
        },
        {
            key: "render",
            value: function render() {
                if (this.legacyMode) {
                    var _this$props3 = this.props, count = _this$props3.count, _children = _this$props3.children, onComplete = _this$props3.onComplete;
                    return (0, $acw62.createElement)(Countdown, {
                        ref: this.legacyCountdownRef,
                        count: count,
                        onComplete: onComplete
                    }, _children);
                }
                var _this$props4 = this.props, className = _this$props4.className, overtime = _this$props4.overtime, children = _this$props4.children, renderer = _this$props4.renderer;
                var renderProps = this.getRenderProps();
                if (renderer) return renderer(renderProps);
                if (children && this.state.timeDelta.completed && !overtime) return (0, $acw62.cloneElement)(children, {
                    countdown: renderProps
                });
                var _renderProps$formatte = renderProps.formatted, days = _renderProps$formatte.days, hours = _renderProps$formatte.hours, minutes = _renderProps$formatte.minutes, seconds = _renderProps$formatte.seconds;
                return (0, $acw62.createElement)("span", {
                    className: className
                }, renderProps.total < 0 ? "-" : "", days, days ? ":" : "", hours, ":", minutes, ":", seconds);
            }
        }
    ]);
    return Countdown$1;
}((0, $acw62.Component));
Countdown$1.defaultProps = Object.assign(Object.assign({}, timeDeltaFormatOptionsDefaults), {
    controlled: false,
    intervalDelay: 1000,
    precision: 0,
    autoStart: true
});
Countdown$1.propTypes = {
    date: (0, $c9Z8w.oneOfType)([
        (0, $c9Z8w.instanceOf)(Date),
        (0, $c9Z8w.string),
        (0, $c9Z8w.number)
    ]),
    daysInHours: (0, $c9Z8w.bool),
    zeroPadTime: (0, $c9Z8w.number),
    zeroPadDays: (0, $c9Z8w.number),
    controlled: (0, $c9Z8w.bool),
    intervalDelay: (0, $c9Z8w.number),
    precision: (0, $c9Z8w.number),
    autoStart: (0, $c9Z8w.bool),
    overtime: (0, $c9Z8w.bool),
    className: (0, $c9Z8w.string),
    children: (0, $c9Z8w.element),
    renderer: (0, $c9Z8w.func),
    now: (0, $c9Z8w.func),
    onMount: (0, $c9Z8w.func),
    onStart: (0, $c9Z8w.func),
    onPause: (0, $c9Z8w.func),
    onStop: (0, $c9Z8w.func),
    onTick: (0, $c9Z8w.func),
    onComplete: (0, $c9Z8w.func)
};
var $b4581f2618089d23$export$2e2bcd8739ae039 = Countdown$1;

});
parcelRegister("c9Z8w", function(module, exports) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $8da5bfbbed271cd7$var$ReactIs, $8da5bfbbed271cd7$var$throwOnDirectAccess;

// By explicitly using `prop-types` you are opting into new production behavior.
// http://fb.me/prop-types-in-prod
module.exports = (parcelRequire("hOzOt"))();

});


parcelRegister("1V2eF", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ErrorHandling = void 0;

var $i2izK = parcelRequire("i2izK");
class $165cd93f90c53d0f$var$ErrorHandling {
    static generateErrorResult(message) {
        return {
            color: null,
            error: {
                message: message
            }
        };
    }
    static generateInputErrorMessage(colorType, colorString, format) {
        const errorPrefix = `Input ${colorType} color string could not be parsed.`;
        const actualStringReceived = `String received: ${colorString}.`;
        const messageStrings = [
            errorPrefix,
            actualStringReceived
        ];
        if (format) {
            const expectedFormat = `Expected format: ${format}.`;
            messageStrings.splice(1, 0, expectedFormat);
        }
        return messageStrings.join(" ");
    }
    static generateUnexpectedError(error) {
        const errorMessage = `${$i2izK.UNEXPECTED_ERROR_MESSAGE_INTRODUCTION}: \n${error.message}`;
        return $165cd93f90c53d0f$var$ErrorHandling.generateErrorResult(errorMessage);
    }
    static hasError(param) {
        return !!param.errorMessage;
    }
}
module.exports.ErrorHandling = $165cd93f90c53d0f$var$ErrorHandling;

});
parcelRegister("i2izK", function(module, exports) {
"use strict";
// if there are too many new issues being created, change the below variables to the following:
// export const UNEXPECTED_ERROR_MESSAGE_PREFIX =
//   'Unexpected error has occurred, please report this by creating a new issue in the following link: ';
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.MUST_INSTALL_PUPPETEER = module.exports.DEFAULT_CONVERSION_ERROR_MESSAGE = module.exports.UNEXPECTED_ERROR_MESSAGE_INTRODUCTION = module.exports.UNEXPECTED_ERROR_MESSAGE_LINK = module.exports.UNEXPECTED_ERROR_MESSAGE_PREFIX = void 0;
// export const UNEXPECTED_ERROR_MESSAGE_LINK = 'https://github.com/OvidijusParsiunas/css-filter-converter/issues';
module.exports.UNEXPECTED_ERROR_MESSAGE_PREFIX = "Unexpected error has occurred, please report this by using the following link: ";
module.exports.UNEXPECTED_ERROR_MESSAGE_LINK = "https://github.com/OvidijusParsiunas/css-filter-converter/issues/new";
module.exports.UNEXPECTED_ERROR_MESSAGE_INTRODUCTION = module.exports.UNEXPECTED_ERROR_MESSAGE_PREFIX + module.exports.UNEXPECTED_ERROR_MESSAGE_LINK;
module.exports.DEFAULT_CONVERSION_ERROR_MESSAGE = "Input value is invalid";
module.exports.MUST_INSTALL_PUPPETEER = "To convert filter values to color in Node - you will first need to install 'puppeteer' by running: \n npm install puppeteer";

});


parcelRegister("f4ycg", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ColorTypes = void 0;
var $af91c1883bc5ecb2$var$ColorTypes;
(function(ColorTypes) {
    ColorTypes["HEX"] = "hex";
    ColorTypes["RGB"] = "rgb";
    ColorTypes["HSL"] = "hsl";
    ColorTypes["KEYWORD"] = "keyword";
    ColorTypes["FILTER"] = "filter";
})($af91c1883bc5ecb2$var$ColorTypes = module.exports.ColorTypes || (module.exports.ColorTypes = {}));

});

parcelRegister("j1wjX", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ColorFormats = void 0;
var $dd972e978bff0e43$var$ColorFormats;
(function(ColorFormats) {
    ColorFormats["HEX"] = "#ffffff or #fff";
    ColorFormats["RGB"] = "rgb([0-255], [0-255], [0-255]) or rgb([0-255], [0-255], [0-255], [0-1]) or rgb([0-100%], [0-100%], [0-100%]) or rgb([0-100%], [0-100%], [0-100%], [0-100%]) or [0-255], [0-255], [0-255] or [0-255] [0-255] [0-255]";
    ColorFormats["HSL"] = "hsl([0-360], [0-100], [0-100]) or hsl([0-360], [0-100%], [0-100%]) or [0-360], [0-100], [0-100] or [0-360] [0-100] [0-100]";
    ColorFormats["FILTER"] = "blur(), brightness(), contrast(), drop-shadow(), grayscale(), hue-rotate(), invert(), saturate(), sepia() with each parameter populated with %, px or deg where approriate e.g. contrast(101%)";
    ColorFormats["KEYWORD"] = "Generic color string. See the following link for all available colors: https://github.com/colorjs/color-name/blob/master/index.js";
})($dd972e978bff0e43$var$ColorFormats = module.exports.ColorFormats || (module.exports.ColorFormats = {}));

});

parcelRegister("kUVKl", function(module, exports) {
"use strict";
module.exports = {
    "aliceblue": [
        240,
        248,
        255
    ],
    "antiquewhite": [
        250,
        235,
        215
    ],
    "aqua": [
        0,
        255,
        255
    ],
    "aquamarine": [
        127,
        255,
        212
    ],
    "azure": [
        240,
        255,
        255
    ],
    "beige": [
        245,
        245,
        220
    ],
    "bisque": [
        255,
        228,
        196
    ],
    "black": [
        0,
        0,
        0
    ],
    "blanchedalmond": [
        255,
        235,
        205
    ],
    "blue": [
        0,
        0,
        255
    ],
    "blueviolet": [
        138,
        43,
        226
    ],
    "brown": [
        165,
        42,
        42
    ],
    "burlywood": [
        222,
        184,
        135
    ],
    "cadetblue": [
        95,
        158,
        160
    ],
    "chartreuse": [
        127,
        255,
        0
    ],
    "chocolate": [
        210,
        105,
        30
    ],
    "coral": [
        255,
        127,
        80
    ],
    "cornflowerblue": [
        100,
        149,
        237
    ],
    "cornsilk": [
        255,
        248,
        220
    ],
    "crimson": [
        220,
        20,
        60
    ],
    "cyan": [
        0,
        255,
        255
    ],
    "darkblue": [
        0,
        0,
        139
    ],
    "darkcyan": [
        0,
        139,
        139
    ],
    "darkgoldenrod": [
        184,
        134,
        11
    ],
    "darkgray": [
        169,
        169,
        169
    ],
    "darkgreen": [
        0,
        100,
        0
    ],
    "darkgrey": [
        169,
        169,
        169
    ],
    "darkkhaki": [
        189,
        183,
        107
    ],
    "darkmagenta": [
        139,
        0,
        139
    ],
    "darkolivegreen": [
        85,
        107,
        47
    ],
    "darkorange": [
        255,
        140,
        0
    ],
    "darkorchid": [
        153,
        50,
        204
    ],
    "darkred": [
        139,
        0,
        0
    ],
    "darksalmon": [
        233,
        150,
        122
    ],
    "darkseagreen": [
        143,
        188,
        143
    ],
    "darkslateblue": [
        72,
        61,
        139
    ],
    "darkslategray": [
        47,
        79,
        79
    ],
    "darkslategrey": [
        47,
        79,
        79
    ],
    "darkturquoise": [
        0,
        206,
        209
    ],
    "darkviolet": [
        148,
        0,
        211
    ],
    "deeppink": [
        255,
        20,
        147
    ],
    "deepskyblue": [
        0,
        191,
        255
    ],
    "dimgray": [
        105,
        105,
        105
    ],
    "dimgrey": [
        105,
        105,
        105
    ],
    "dodgerblue": [
        30,
        144,
        255
    ],
    "firebrick": [
        178,
        34,
        34
    ],
    "floralwhite": [
        255,
        250,
        240
    ],
    "forestgreen": [
        34,
        139,
        34
    ],
    "fuchsia": [
        255,
        0,
        255
    ],
    "gainsboro": [
        220,
        220,
        220
    ],
    "ghostwhite": [
        248,
        248,
        255
    ],
    "gold": [
        255,
        215,
        0
    ],
    "goldenrod": [
        218,
        165,
        32
    ],
    "gray": [
        128,
        128,
        128
    ],
    "green": [
        0,
        128,
        0
    ],
    "greenyellow": [
        173,
        255,
        47
    ],
    "grey": [
        128,
        128,
        128
    ],
    "honeydew": [
        240,
        255,
        240
    ],
    "hotpink": [
        255,
        105,
        180
    ],
    "indianred": [
        205,
        92,
        92
    ],
    "indigo": [
        75,
        0,
        130
    ],
    "ivory": [
        255,
        255,
        240
    ],
    "khaki": [
        240,
        230,
        140
    ],
    "lavender": [
        230,
        230,
        250
    ],
    "lavenderblush": [
        255,
        240,
        245
    ],
    "lawngreen": [
        124,
        252,
        0
    ],
    "lemonchiffon": [
        255,
        250,
        205
    ],
    "lightblue": [
        173,
        216,
        230
    ],
    "lightcoral": [
        240,
        128,
        128
    ],
    "lightcyan": [
        224,
        255,
        255
    ],
    "lightgoldenrodyellow": [
        250,
        250,
        210
    ],
    "lightgray": [
        211,
        211,
        211
    ],
    "lightgreen": [
        144,
        238,
        144
    ],
    "lightgrey": [
        211,
        211,
        211
    ],
    "lightpink": [
        255,
        182,
        193
    ],
    "lightsalmon": [
        255,
        160,
        122
    ],
    "lightseagreen": [
        32,
        178,
        170
    ],
    "lightskyblue": [
        135,
        206,
        250
    ],
    "lightslategray": [
        119,
        136,
        153
    ],
    "lightslategrey": [
        119,
        136,
        153
    ],
    "lightsteelblue": [
        176,
        196,
        222
    ],
    "lightyellow": [
        255,
        255,
        224
    ],
    "lime": [
        0,
        255,
        0
    ],
    "limegreen": [
        50,
        205,
        50
    ],
    "linen": [
        250,
        240,
        230
    ],
    "magenta": [
        255,
        0,
        255
    ],
    "maroon": [
        128,
        0,
        0
    ],
    "mediumaquamarine": [
        102,
        205,
        170
    ],
    "mediumblue": [
        0,
        0,
        205
    ],
    "mediumorchid": [
        186,
        85,
        211
    ],
    "mediumpurple": [
        147,
        112,
        219
    ],
    "mediumseagreen": [
        60,
        179,
        113
    ],
    "mediumslateblue": [
        123,
        104,
        238
    ],
    "mediumspringgreen": [
        0,
        250,
        154
    ],
    "mediumturquoise": [
        72,
        209,
        204
    ],
    "mediumvioletred": [
        199,
        21,
        133
    ],
    "midnightblue": [
        25,
        25,
        112
    ],
    "mintcream": [
        245,
        255,
        250
    ],
    "mistyrose": [
        255,
        228,
        225
    ],
    "moccasin": [
        255,
        228,
        181
    ],
    "navajowhite": [
        255,
        222,
        173
    ],
    "navy": [
        0,
        0,
        128
    ],
    "oldlace": [
        253,
        245,
        230
    ],
    "olive": [
        128,
        128,
        0
    ],
    "olivedrab": [
        107,
        142,
        35
    ],
    "orange": [
        255,
        165,
        0
    ],
    "orangered": [
        255,
        69,
        0
    ],
    "orchid": [
        218,
        112,
        214
    ],
    "palegoldenrod": [
        238,
        232,
        170
    ],
    "palegreen": [
        152,
        251,
        152
    ],
    "paleturquoise": [
        175,
        238,
        238
    ],
    "palevioletred": [
        219,
        112,
        147
    ],
    "papayawhip": [
        255,
        239,
        213
    ],
    "peachpuff": [
        255,
        218,
        185
    ],
    "peru": [
        205,
        133,
        63
    ],
    "pink": [
        255,
        192,
        203
    ],
    "plum": [
        221,
        160,
        221
    ],
    "powderblue": [
        176,
        224,
        230
    ],
    "purple": [
        128,
        0,
        128
    ],
    "rebeccapurple": [
        102,
        51,
        153
    ],
    "red": [
        255,
        0,
        0
    ],
    "rosybrown": [
        188,
        143,
        143
    ],
    "royalblue": [
        65,
        105,
        225
    ],
    "saddlebrown": [
        139,
        69,
        19
    ],
    "salmon": [
        250,
        128,
        114
    ],
    "sandybrown": [
        244,
        164,
        96
    ],
    "seagreen": [
        46,
        139,
        87
    ],
    "seashell": [
        255,
        245,
        238
    ],
    "sienna": [
        160,
        82,
        45
    ],
    "silver": [
        192,
        192,
        192
    ],
    "skyblue": [
        135,
        206,
        235
    ],
    "slateblue": [
        106,
        90,
        205
    ],
    "slategray": [
        112,
        128,
        144
    ],
    "slategrey": [
        112,
        128,
        144
    ],
    "snow": [
        255,
        250,
        250
    ],
    "springgreen": [
        0,
        255,
        127
    ],
    "steelblue": [
        70,
        130,
        180
    ],
    "tan": [
        210,
        180,
        140
    ],
    "teal": [
        0,
        128,
        128
    ],
    "thistle": [
        216,
        191,
        216
    ],
    "tomato": [
        255,
        99,
        71
    ],
    "turquoise": [
        64,
        224,
        208
    ],
    "violet": [
        238,
        130,
        238
    ],
    "wheat": [
        245,
        222,
        179
    ],
    "white": [
        255,
        255,
        255
    ],
    "whitesmoke": [
        245,
        245,
        245
    ],
    "yellow": [
        255,
        255,
        0
    ],
    "yellowgreen": [
        154,
        205,
        50
    ]
};

});

parcelRegister("dO2Xp", function(module, exports) {

var $a35ln = parcelRequire("a35ln");

var $4YVup = parcelRequire("4YVup");
const $a0d23d1a7b5eee81$var$convert = {};
const $a0d23d1a7b5eee81$var$models = Object.keys($a35ln);
function $a0d23d1a7b5eee81$var$wrapRaw(fn) {
    const wrappedFn = function(...args) {
        const arg0 = args[0];
        if (arg0 === undefined || arg0 === null) return arg0;
        if (arg0.length > 1) args = arg0;
        return fn(args);
    };
    // Preserve .conversion property if there is one
    if ("conversion" in fn) wrappedFn.conversion = fn.conversion;
    return wrappedFn;
}
function $a0d23d1a7b5eee81$var$wrapRounded(fn) {
    const wrappedFn = function(...args) {
        const arg0 = args[0];
        if (arg0 === undefined || arg0 === null) return arg0;
        if (arg0.length > 1) args = arg0;
        const result = fn(args);
        // We're assuming the result is an array here.
        // see notice in conversions.js; don't use box types
        // in conversion functions.
        if (typeof result === "object") for(let len = result.length, i = 0; i < len; i++)result[i] = Math.round(result[i]);
        return result;
    };
    // Preserve .conversion property if there is one
    if ("conversion" in fn) wrappedFn.conversion = fn.conversion;
    return wrappedFn;
}
$a0d23d1a7b5eee81$var$models.forEach((fromModel)=>{
    $a0d23d1a7b5eee81$var$convert[fromModel] = {};
    Object.defineProperty($a0d23d1a7b5eee81$var$convert[fromModel], "channels", {
        value: $a35ln[fromModel].channels
    });
    Object.defineProperty($a0d23d1a7b5eee81$var$convert[fromModel], "labels", {
        value: $a35ln[fromModel].labels
    });
    const routes = $4YVup(fromModel);
    const routeModels = Object.keys(routes);
    routeModels.forEach((toModel)=>{
        const fn = routes[toModel];
        $a0d23d1a7b5eee81$var$convert[fromModel][toModel] = $a0d23d1a7b5eee81$var$wrapRounded(fn);
        $a0d23d1a7b5eee81$var$convert[fromModel][toModel].raw = $a0d23d1a7b5eee81$var$wrapRaw(fn);
    });
});
module.exports = $a0d23d1a7b5eee81$var$convert;

});
parcelRegister("a35ln", function(module, exports) {
/* MIT license */ /* eslint-disable no-mixed-operators */ 
var $kUVKl = parcelRequire("kUVKl");
// NOTE: conversions should only return primitive values (i.e. arrays, or
//       values that give correct `typeof` results).
//       do not use box values types (i.e. Number(), String(), etc.)
const $750e545b282550a0$var$reverseKeywords = {};
for (const key of Object.keys($kUVKl))$750e545b282550a0$var$reverseKeywords[$kUVKl[key]] = key;
const $750e545b282550a0$var$convert = {
    rgb: {
        channels: 3,
        labels: "rgb"
    },
    hsl: {
        channels: 3,
        labels: "hsl"
    },
    hsv: {
        channels: 3,
        labels: "hsv"
    },
    hwb: {
        channels: 3,
        labels: "hwb"
    },
    cmyk: {
        channels: 4,
        labels: "cmyk"
    },
    xyz: {
        channels: 3,
        labels: "xyz"
    },
    lab: {
        channels: 3,
        labels: "lab"
    },
    lch: {
        channels: 3,
        labels: "lch"
    },
    hex: {
        channels: 1,
        labels: [
            "hex"
        ]
    },
    keyword: {
        channels: 1,
        labels: [
            "keyword"
        ]
    },
    ansi16: {
        channels: 1,
        labels: [
            "ansi16"
        ]
    },
    ansi256: {
        channels: 1,
        labels: [
            "ansi256"
        ]
    },
    hcg: {
        channels: 3,
        labels: [
            "h",
            "c",
            "g"
        ]
    },
    apple: {
        channels: 3,
        labels: [
            "r16",
            "g16",
            "b16"
        ]
    },
    gray: {
        channels: 1,
        labels: [
            "gray"
        ]
    }
};
module.exports = $750e545b282550a0$var$convert;
// Hide .channels and .labels properties
for (const model of Object.keys($750e545b282550a0$var$convert)){
    if (!("channels" in $750e545b282550a0$var$convert[model])) throw new Error("missing channels property: " + model);
    if (!("labels" in $750e545b282550a0$var$convert[model])) throw new Error("missing channel labels property: " + model);
    if ($750e545b282550a0$var$convert[model].labels.length !== $750e545b282550a0$var$convert[model].channels) throw new Error("channel and label counts mismatch: " + model);
    const { channels: channels, labels: labels } = $750e545b282550a0$var$convert[model];
    delete $750e545b282550a0$var$convert[model].channels;
    delete $750e545b282550a0$var$convert[model].labels;
    Object.defineProperty($750e545b282550a0$var$convert[model], "channels", {
        value: channels
    });
    Object.defineProperty($750e545b282550a0$var$convert[model], "labels", {
        value: labels
    });
}
$750e545b282550a0$var$convert.rgb.hsl = function(rgb) {
    const r = rgb[0] / 255;
    const g = rgb[1] / 255;
    const b = rgb[2] / 255;
    const min = Math.min(r, g, b);
    const max = Math.max(r, g, b);
    const delta = max - min;
    let h;
    let s;
    if (max === min) h = 0;
    else if (r === max) h = (g - b) / delta;
    else if (g === max) h = 2 + (b - r) / delta;
    else if (b === max) h = 4 + (r - g) / delta;
    h = Math.min(h * 60, 360);
    if (h < 0) h += 360;
    const l = (min + max) / 2;
    if (max === min) s = 0;
    else if (l <= 0.5) s = delta / (max + min);
    else s = delta / (2 - max - min);
    return [
        h,
        s * 100,
        l * 100
    ];
};
$750e545b282550a0$var$convert.rgb.hsv = function(rgb) {
    let rdif;
    let gdif;
    let bdif;
    let h;
    let s;
    const r = rgb[0] / 255;
    const g = rgb[1] / 255;
    const b = rgb[2] / 255;
    const v = Math.max(r, g, b);
    const diff = v - Math.min(r, g, b);
    const diffc = function(c) {
        return (v - c) / 6 / diff + 0.5;
    };
    if (diff === 0) {
        h = 0;
        s = 0;
    } else {
        s = diff / v;
        rdif = diffc(r);
        gdif = diffc(g);
        bdif = diffc(b);
        if (r === v) h = bdif - gdif;
        else if (g === v) h = 1 / 3 + rdif - bdif;
        else if (b === v) h = 2 / 3 + gdif - rdif;
        if (h < 0) h += 1;
        else if (h > 1) h -= 1;
    }
    return [
        h * 360,
        s * 100,
        v * 100
    ];
};
$750e545b282550a0$var$convert.rgb.hwb = function(rgb) {
    const r = rgb[0];
    const g = rgb[1];
    let b = rgb[2];
    const h = $750e545b282550a0$var$convert.rgb.hsl(rgb)[0];
    const w = 1 / 255 * Math.min(r, Math.min(g, b));
    b = 1 - 1 / 255 * Math.max(r, Math.max(g, b));
    return [
        h,
        w * 100,
        b * 100
    ];
};
$750e545b282550a0$var$convert.rgb.cmyk = function(rgb) {
    const r = rgb[0] / 255;
    const g = rgb[1] / 255;
    const b = rgb[2] / 255;
    const k = Math.min(1 - r, 1 - g, 1 - b);
    const c = (1 - r - k) / (1 - k) || 0;
    const m = (1 - g - k) / (1 - k) || 0;
    const y = (1 - b - k) / (1 - k) || 0;
    return [
        c * 100,
        m * 100,
        y * 100,
        k * 100
    ];
};
function $750e545b282550a0$var$comparativeDistance(x, y) {
    /*
		See https://en.m.wikipedia.org/wiki/Euclidean_distance#Squared_Euclidean_distance
	*/ return (x[0] - y[0]) ** 2 + (x[1] - y[1]) ** 2 + (x[2] - y[2]) ** 2;
}
$750e545b282550a0$var$convert.rgb.keyword = function(rgb) {
    const reversed = $750e545b282550a0$var$reverseKeywords[rgb];
    if (reversed) return reversed;
    let currentClosestDistance = Infinity;
    let currentClosestKeyword;
    for (const keyword of Object.keys($kUVKl)){
        const value = $kUVKl[keyword];
        // Compute comparative distance
        const distance = $750e545b282550a0$var$comparativeDistance(rgb, value);
        // Check if its less, if so set as closest
        if (distance < currentClosestDistance) {
            currentClosestDistance = distance;
            currentClosestKeyword = keyword;
        }
    }
    return currentClosestKeyword;
};
$750e545b282550a0$var$convert.keyword.rgb = function(keyword) {
    return $kUVKl[keyword];
};
$750e545b282550a0$var$convert.rgb.xyz = function(rgb) {
    let r = rgb[0] / 255;
    let g = rgb[1] / 255;
    let b = rgb[2] / 255;
    // Assume sRGB
    r = r > 0.04045 ? ((r + 0.055) / 1.055) ** 2.4 : r / 12.92;
    g = g > 0.04045 ? ((g + 0.055) / 1.055) ** 2.4 : g / 12.92;
    b = b > 0.04045 ? ((b + 0.055) / 1.055) ** 2.4 : b / 12.92;
    const x = r * 0.4124 + g * 0.3576 + b * 0.1805;
    const y = r * 0.2126 + g * 0.7152 + b * 0.0722;
    const z = r * 0.0193 + g * 0.1192 + b * 0.9505;
    return [
        x * 100,
        y * 100,
        z * 100
    ];
};
$750e545b282550a0$var$convert.rgb.lab = function(rgb) {
    const xyz = $750e545b282550a0$var$convert.rgb.xyz(rgb);
    let x = xyz[0];
    let y = xyz[1];
    let z = xyz[2];
    x /= 95.047;
    y /= 100;
    z /= 108.883;
    x = x > 0.008856 ? x ** (1 / 3) : 7.787 * x + 16 / 116;
    y = y > 0.008856 ? y ** (1 / 3) : 7.787 * y + 16 / 116;
    z = z > 0.008856 ? z ** (1 / 3) : 7.787 * z + 16 / 116;
    const l = 116 * y - 16;
    const a = 500 * (x - y);
    const b = 200 * (y - z);
    return [
        l,
        a,
        b
    ];
};
$750e545b282550a0$var$convert.hsl.rgb = function(hsl) {
    const h = hsl[0] / 360;
    const s = hsl[1] / 100;
    const l = hsl[2] / 100;
    let t2;
    let t3;
    let val;
    if (s === 0) {
        val = l * 255;
        return [
            val,
            val,
            val
        ];
    }
    if (l < 0.5) t2 = l * (1 + s);
    else t2 = l + s - l * s;
    const t1 = 2 * l - t2;
    const rgb = [
        0,
        0,
        0
    ];
    for(let i = 0; i < 3; i++){
        t3 = h + 1 / 3 * -(i - 1);
        if (t3 < 0) t3++;
        if (t3 > 1) t3--;
        if (6 * t3 < 1) val = t1 + (t2 - t1) * 6 * t3;
        else if (2 * t3 < 1) val = t2;
        else if (3 * t3 < 2) val = t1 + (t2 - t1) * (2 / 3 - t3) * 6;
        else val = t1;
        rgb[i] = val * 255;
    }
    return rgb;
};
$750e545b282550a0$var$convert.hsl.hsv = function(hsl) {
    const h = hsl[0];
    let s = hsl[1] / 100;
    let l = hsl[2] / 100;
    let smin = s;
    const lmin = Math.max(l, 0.01);
    l *= 2;
    s *= l <= 1 ? l : 2 - l;
    smin *= lmin <= 1 ? lmin : 2 - lmin;
    const v = (l + s) / 2;
    const sv = l === 0 ? 2 * smin / (lmin + smin) : 2 * s / (l + s);
    return [
        h,
        sv * 100,
        v * 100
    ];
};
$750e545b282550a0$var$convert.hsv.rgb = function(hsv) {
    const h = hsv[0] / 60;
    const s = hsv[1] / 100;
    let v = hsv[2] / 100;
    const hi = Math.floor(h) % 6;
    const f = h - Math.floor(h);
    const p = 255 * v * (1 - s);
    const q = 255 * v * (1 - s * f);
    const t = 255 * v * (1 - s * (1 - f));
    v *= 255;
    switch(hi){
        case 0:
            return [
                v,
                t,
                p
            ];
        case 1:
            return [
                q,
                v,
                p
            ];
        case 2:
            return [
                p,
                v,
                t
            ];
        case 3:
            return [
                p,
                q,
                v
            ];
        case 4:
            return [
                t,
                p,
                v
            ];
        case 5:
            return [
                v,
                p,
                q
            ];
    }
};
$750e545b282550a0$var$convert.hsv.hsl = function(hsv) {
    const h = hsv[0];
    const s = hsv[1] / 100;
    const v = hsv[2] / 100;
    const vmin = Math.max(v, 0.01);
    let sl;
    let l;
    l = (2 - s) * v;
    const lmin = (2 - s) * vmin;
    sl = s * vmin;
    sl /= lmin <= 1 ? lmin : 2 - lmin;
    sl = sl || 0;
    l /= 2;
    return [
        h,
        sl * 100,
        l * 100
    ];
};
// http://dev.w3.org/csswg/css-color/#hwb-to-rgb
$750e545b282550a0$var$convert.hwb.rgb = function(hwb) {
    const h = hwb[0] / 360;
    let wh = hwb[1] / 100;
    let bl = hwb[2] / 100;
    const ratio = wh + bl;
    let f;
    // Wh + bl cant be > 1
    if (ratio > 1) {
        wh /= ratio;
        bl /= ratio;
    }
    const i = Math.floor(6 * h);
    const v = 1 - bl;
    f = 6 * h - i;
    if ((i & 0x01) !== 0) f = 1 - f;
    const n = wh + f * (v - wh); // Linear interpolation
    let r;
    let g;
    let b;
    /* eslint-disable max-statements-per-line,no-multi-spaces */ switch(i){
        default:
        case 6:
        case 0:
            r = v;
            g = n;
            b = wh;
            break;
        case 1:
            r = n;
            g = v;
            b = wh;
            break;
        case 2:
            r = wh;
            g = v;
            b = n;
            break;
        case 3:
            r = wh;
            g = n;
            b = v;
            break;
        case 4:
            r = n;
            g = wh;
            b = v;
            break;
        case 5:
            r = v;
            g = wh;
            b = n;
            break;
    }
    /* eslint-enable max-statements-per-line,no-multi-spaces */ return [
        r * 255,
        g * 255,
        b * 255
    ];
};
$750e545b282550a0$var$convert.cmyk.rgb = function(cmyk) {
    const c = cmyk[0] / 100;
    const m = cmyk[1] / 100;
    const y = cmyk[2] / 100;
    const k = cmyk[3] / 100;
    const r = 1 - Math.min(1, c * (1 - k) + k);
    const g = 1 - Math.min(1, m * (1 - k) + k);
    const b = 1 - Math.min(1, y * (1 - k) + k);
    return [
        r * 255,
        g * 255,
        b * 255
    ];
};
$750e545b282550a0$var$convert.xyz.rgb = function(xyz) {
    const x = xyz[0] / 100;
    const y = xyz[1] / 100;
    const z = xyz[2] / 100;
    let r;
    let g;
    let b;
    r = x * 3.2406 + y * -1.5372 + z * -0.4986;
    g = x * -0.9689 + y * 1.8758 + z * 0.0415;
    b = x * 0.0557 + y * -0.204 + z * 1.0570;
    // Assume sRGB
    r = r > 0.0031308 ? 1.055 * r ** (1.0 / 2.4) - 0.055 : r * 12.92;
    g = g > 0.0031308 ? 1.055 * g ** (1.0 / 2.4) - 0.055 : g * 12.92;
    b = b > 0.0031308 ? 1.055 * b ** (1.0 / 2.4) - 0.055 : b * 12.92;
    r = Math.min(Math.max(0, r), 1);
    g = Math.min(Math.max(0, g), 1);
    b = Math.min(Math.max(0, b), 1);
    return [
        r * 255,
        g * 255,
        b * 255
    ];
};
$750e545b282550a0$var$convert.xyz.lab = function(xyz) {
    let x = xyz[0];
    let y = xyz[1];
    let z = xyz[2];
    x /= 95.047;
    y /= 100;
    z /= 108.883;
    x = x > 0.008856 ? x ** (1 / 3) : 7.787 * x + 16 / 116;
    y = y > 0.008856 ? y ** (1 / 3) : 7.787 * y + 16 / 116;
    z = z > 0.008856 ? z ** (1 / 3) : 7.787 * z + 16 / 116;
    const l = 116 * y - 16;
    const a = 500 * (x - y);
    const b = 200 * (y - z);
    return [
        l,
        a,
        b
    ];
};
$750e545b282550a0$var$convert.lab.xyz = function(lab) {
    const l = lab[0];
    const a = lab[1];
    const b = lab[2];
    let x;
    let y;
    let z;
    y = (l + 16) / 116;
    x = a / 500 + y;
    z = y - b / 200;
    const y2 = y ** 3;
    const x2 = x ** 3;
    const z2 = z ** 3;
    y = y2 > 0.008856 ? y2 : (y - 16 / 116) / 7.787;
    x = x2 > 0.008856 ? x2 : (x - 16 / 116) / 7.787;
    z = z2 > 0.008856 ? z2 : (z - 16 / 116) / 7.787;
    x *= 95.047;
    y *= 100;
    z *= 108.883;
    return [
        x,
        y,
        z
    ];
};
$750e545b282550a0$var$convert.lab.lch = function(lab) {
    const l = lab[0];
    const a = lab[1];
    const b = lab[2];
    let h;
    const hr = Math.atan2(b, a);
    h = hr * 360 / 2 / Math.PI;
    if (h < 0) h += 360;
    const c = Math.sqrt(a * a + b * b);
    return [
        l,
        c,
        h
    ];
};
$750e545b282550a0$var$convert.lch.lab = function(lch) {
    const l = lch[0];
    const c = lch[1];
    const h = lch[2];
    const hr = h / 360 * 2 * Math.PI;
    const a = c * Math.cos(hr);
    const b = c * Math.sin(hr);
    return [
        l,
        a,
        b
    ];
};
$750e545b282550a0$var$convert.rgb.ansi16 = function(args, saturation = null) {
    const [r, g, b] = args;
    let value = saturation === null ? $750e545b282550a0$var$convert.rgb.hsv(args)[2] : saturation; // Hsv -> ansi16 optimization
    value = Math.round(value / 50);
    if (value === 0) return 30;
    let ansi = 30 + (Math.round(b / 255) << 2 | Math.round(g / 255) << 1 | Math.round(r / 255));
    if (value === 2) ansi += 60;
    return ansi;
};
$750e545b282550a0$var$convert.hsv.ansi16 = function(args) {
    // Optimization here; we already know the value and don't need to get
    // it converted for us.
    return $750e545b282550a0$var$convert.rgb.ansi16($750e545b282550a0$var$convert.hsv.rgb(args), args[2]);
};
$750e545b282550a0$var$convert.rgb.ansi256 = function(args) {
    const r = args[0];
    const g = args[1];
    const b = args[2];
    // We use the extended greyscale palette here, with the exception of
    // black and white. normal palette only has 4 greyscale shades.
    if (r === g && g === b) {
        if (r < 8) return 16;
        if (r > 248) return 231;
        return Math.round((r - 8) / 247 * 24) + 232;
    }
    const ansi = 16 + 36 * Math.round(r / 255 * 5) + 6 * Math.round(g / 255 * 5) + Math.round(b / 255 * 5);
    return ansi;
};
$750e545b282550a0$var$convert.ansi16.rgb = function(args) {
    let color = args % 10;
    // Handle greyscale
    if (color === 0 || color === 7) {
        if (args > 50) color += 3.5;
        color = color / 10.5 * 255;
        return [
            color,
            color,
            color
        ];
    }
    const mult = (~~(args > 50) + 1) * 0.5;
    const r = (color & 1) * mult * 255;
    const g = (color >> 1 & 1) * mult * 255;
    const b = (color >> 2 & 1) * mult * 255;
    return [
        r,
        g,
        b
    ];
};
$750e545b282550a0$var$convert.ansi256.rgb = function(args) {
    // Handle greyscale
    if (args >= 232) {
        const c = (args - 232) * 10 + 8;
        return [
            c,
            c,
            c
        ];
    }
    args -= 16;
    let rem;
    const r = Math.floor(args / 36) / 5 * 255;
    const g = Math.floor((rem = args % 36) / 6) / 5 * 255;
    const b = rem % 6 / 5 * 255;
    return [
        r,
        g,
        b
    ];
};
$750e545b282550a0$var$convert.rgb.hex = function(args) {
    const integer = ((Math.round(args[0]) & 0xFF) << 16) + ((Math.round(args[1]) & 0xFF) << 8) + (Math.round(args[2]) & 0xFF);
    const string = integer.toString(16).toUpperCase();
    return "000000".substring(string.length) + string;
};
$750e545b282550a0$var$convert.hex.rgb = function(args) {
    const match = args.toString(16).match(/[a-f0-9]{6}|[a-f0-9]{3}/i);
    if (!match) return [
        0,
        0,
        0
    ];
    let colorString = match[0];
    if (match[0].length === 3) colorString = colorString.split("").map((char)=>{
        return char + char;
    }).join("");
    const integer = parseInt(colorString, 16);
    const r = integer >> 16 & 0xFF;
    const g = integer >> 8 & 0xFF;
    const b = integer & 0xFF;
    return [
        r,
        g,
        b
    ];
};
$750e545b282550a0$var$convert.rgb.hcg = function(rgb) {
    const r = rgb[0] / 255;
    const g = rgb[1] / 255;
    const b = rgb[2] / 255;
    const max = Math.max(Math.max(r, g), b);
    const min = Math.min(Math.min(r, g), b);
    const chroma = max - min;
    let grayscale;
    let hue;
    if (chroma < 1) grayscale = min / (1 - chroma);
    else grayscale = 0;
    if (chroma <= 0) hue = 0;
    else if (max === r) hue = (g - b) / chroma % 6;
    else if (max === g) hue = 2 + (b - r) / chroma;
    else hue = 4 + (r - g) / chroma;
    hue /= 6;
    hue %= 1;
    return [
        hue * 360,
        chroma * 100,
        grayscale * 100
    ];
};
$750e545b282550a0$var$convert.hsl.hcg = function(hsl) {
    const s = hsl[1] / 100;
    const l = hsl[2] / 100;
    const c = l < 0.5 ? 2.0 * s * l : 2.0 * s * (1.0 - l);
    let f = 0;
    if (c < 1.0) f = (l - 0.5 * c) / (1.0 - c);
    return [
        hsl[0],
        c * 100,
        f * 100
    ];
};
$750e545b282550a0$var$convert.hsv.hcg = function(hsv) {
    const s = hsv[1] / 100;
    const v = hsv[2] / 100;
    const c = s * v;
    let f = 0;
    if (c < 1.0) f = (v - c) / (1 - c);
    return [
        hsv[0],
        c * 100,
        f * 100
    ];
};
$750e545b282550a0$var$convert.hcg.rgb = function(hcg) {
    const h = hcg[0] / 360;
    const c = hcg[1] / 100;
    const g = hcg[2] / 100;
    if (c === 0.0) return [
        g * 255,
        g * 255,
        g * 255
    ];
    const pure = [
        0,
        0,
        0
    ];
    const hi = h % 1 * 6;
    const v = hi % 1;
    const w = 1 - v;
    let mg = 0;
    /* eslint-disable max-statements-per-line */ switch(Math.floor(hi)){
        case 0:
            pure[0] = 1;
            pure[1] = v;
            pure[2] = 0;
            break;
        case 1:
            pure[0] = w;
            pure[1] = 1;
            pure[2] = 0;
            break;
        case 2:
            pure[0] = 0;
            pure[1] = 1;
            pure[2] = v;
            break;
        case 3:
            pure[0] = 0;
            pure[1] = w;
            pure[2] = 1;
            break;
        case 4:
            pure[0] = v;
            pure[1] = 0;
            pure[2] = 1;
            break;
        default:
            pure[0] = 1;
            pure[1] = 0;
            pure[2] = w;
    }
    /* eslint-enable max-statements-per-line */ mg = (1.0 - c) * g;
    return [
        (c * pure[0] + mg) * 255,
        (c * pure[1] + mg) * 255,
        (c * pure[2] + mg) * 255
    ];
};
$750e545b282550a0$var$convert.hcg.hsv = function(hcg) {
    const c = hcg[1] / 100;
    const g = hcg[2] / 100;
    const v = c + g * (1.0 - c);
    let f = 0;
    if (v > 0.0) f = c / v;
    return [
        hcg[0],
        f * 100,
        v * 100
    ];
};
$750e545b282550a0$var$convert.hcg.hsl = function(hcg) {
    const c = hcg[1] / 100;
    const g = hcg[2] / 100;
    const l = g * (1.0 - c) + 0.5 * c;
    let s = 0;
    if (l > 0.0 && l < 0.5) s = c / (2 * l);
    else if (l >= 0.5 && l < 1.0) s = c / (2 * (1 - l));
    return [
        hcg[0],
        s * 100,
        l * 100
    ];
};
$750e545b282550a0$var$convert.hcg.hwb = function(hcg) {
    const c = hcg[1] / 100;
    const g = hcg[2] / 100;
    const v = c + g * (1.0 - c);
    return [
        hcg[0],
        (v - c) * 100,
        (1 - v) * 100
    ];
};
$750e545b282550a0$var$convert.hwb.hcg = function(hwb) {
    const w = hwb[1] / 100;
    const b = hwb[2] / 100;
    const v = 1 - b;
    const c = v - w;
    let g = 0;
    if (c < 1) g = (v - c) / (1 - c);
    return [
        hwb[0],
        c * 100,
        g * 100
    ];
};
$750e545b282550a0$var$convert.apple.rgb = function(apple) {
    return [
        apple[0] / 65535 * 255,
        apple[1] / 65535 * 255,
        apple[2] / 65535 * 255
    ];
};
$750e545b282550a0$var$convert.rgb.apple = function(rgb) {
    return [
        rgb[0] / 255 * 65535,
        rgb[1] / 255 * 65535,
        rgb[2] / 255 * 65535
    ];
};
$750e545b282550a0$var$convert.gray.rgb = function(args) {
    return [
        args[0] / 100 * 255,
        args[0] / 100 * 255,
        args[0] / 100 * 255
    ];
};
$750e545b282550a0$var$convert.gray.hsl = function(args) {
    return [
        0,
        0,
        args[0]
    ];
};
$750e545b282550a0$var$convert.gray.hsv = $750e545b282550a0$var$convert.gray.hsl;
$750e545b282550a0$var$convert.gray.hwb = function(gray) {
    return [
        0,
        100,
        gray[0]
    ];
};
$750e545b282550a0$var$convert.gray.cmyk = function(gray) {
    return [
        0,
        0,
        0,
        gray[0]
    ];
};
$750e545b282550a0$var$convert.gray.lab = function(gray) {
    return [
        gray[0],
        0,
        0
    ];
};
$750e545b282550a0$var$convert.gray.hex = function(gray) {
    const val = Math.round(gray[0] / 100 * 255) & 0xFF;
    const integer = (val << 16) + (val << 8) + val;
    const string = integer.toString(16).toUpperCase();
    return "000000".substring(string.length) + string;
};
$750e545b282550a0$var$convert.rgb.gray = function(rgb) {
    const val = (rgb[0] + rgb[1] + rgb[2]) / 3;
    return [
        val / 255 * 100
    ];
};

});

parcelRegister("4YVup", function(module, exports) {

var $a35ln = parcelRequire("a35ln");
/*
	This function routes a model to all other models.

	all functions that are routed have a property `.conversion` attached
	to the returned synthetic function. This property is an array
	of strings, each with the steps in between the 'from' and 'to'
	color models (inclusive).

	conversions that are not possible simply are not included.
*/ function $3a095c3e41357474$var$buildGraph() {
    const graph = {};
    // https://jsperf.com/object-keys-vs-for-in-with-closure/3
    const models = Object.keys($a35ln);
    for(let len = models.length, i = 0; i < len; i++)graph[models[i]] = {
        // http://jsperf.com/1-vs-infinity
        // micro-opt, but this is simple.
        distance: -1,
        parent: null
    };
    return graph;
}
// https://en.wikipedia.org/wiki/Breadth-first_search
function $3a095c3e41357474$var$deriveBFS(fromModel) {
    const graph = $3a095c3e41357474$var$buildGraph();
    const queue = [
        fromModel
    ]; // Unshift -> queue -> pop
    graph[fromModel].distance = 0;
    while(queue.length){
        const current = queue.pop();
        const adjacents = Object.keys($a35ln[current]);
        for(let len = adjacents.length, i = 0; i < len; i++){
            const adjacent = adjacents[i];
            const node = graph[adjacent];
            if (node.distance === -1) {
                node.distance = graph[current].distance + 1;
                node.parent = current;
                queue.unshift(adjacent);
            }
        }
    }
    return graph;
}
function $3a095c3e41357474$var$link(from, to) {
    return function(args) {
        return to(from(args));
    };
}
function $3a095c3e41357474$var$wrapConversion(toModel, graph) {
    const path = [
        graph[toModel].parent,
        toModel
    ];
    let fn = $a35ln[graph[toModel].parent][toModel];
    let cur = graph[toModel].parent;
    while(graph[cur].parent){
        path.unshift(graph[cur].parent);
        fn = $3a095c3e41357474$var$link($a35ln[graph[cur].parent][cur], fn);
        cur = graph[cur].parent;
    }
    fn.conversion = path;
    return fn;
}
module.exports = function(fromModel) {
    const graph = $3a095c3e41357474$var$deriveBFS(fromModel);
    const conversion = {};
    const models = Object.keys(graph);
    for(let len = models.length, i = 0; i < len; i++){
        const toModel = models[i];
        const node = graph[toModel];
        if (node.parent === null) continue;
        conversion[toModel] = $3a095c3e41357474$var$wrapConversion(toModel, graph);
    }
    return conversion;
};

});


parcelRegister("gDx9E", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.FilterToHexShared = void 0;

var $1V2eF = parcelRequire("1V2eF");

var $j1wjX = parcelRequire("j1wjX");

var $f4ycg = parcelRequire("f4ycg");
class $c1ca01a969843711$var$FilterToHexShared {
    static generateInputErrorMessage(filterString) {
        return $1V2eF.ErrorHandling.generateInputErrorMessage($f4ycg.ColorTypes.FILTER, filterString, $j1wjX.ColorFormats.FILTER);
    }
    // functions are encapsulated within a single method in order to allow them to be executed within the same context
    // of the puppeteer evaluate method
    static addSVGElementsToDOMAndValidateFilter(filterString, svgSideLength = 1) {
        function createSVGElement() {
            const xmlns = "http://www.w3.org/2000/svg";
            const svgElement = document.createElementNS(xmlns, "svg");
            svgElement.style.height = "inherit";
            svgElement.style.width = "inherit";
            svgElement.style.float = "left";
            svgElement.style.filter = filterString;
            const rect = document.createElementNS(xmlns, "rect");
            rect.setAttributeNS(null, "width", svgSideLength.toString());
            rect.setAttributeNS(null, "height", svgSideLength.toString());
            svgElement.appendChild(rect);
            return svgElement;
        }
        function createSVGContainerElement() {
            const svgContainerElement = document.createElement("div");
            svgContainerElement.style.height = `${svgSideLength}px`;
            svgContainerElement.style.width = `${svgSideLength}px`;
            svgContainerElement.style.position = "absolute";
            svgContainerElement.style.top = "0px";
            svgContainerElement.style.left = "0px";
            return svgContainerElement;
        }
        const svgContainerElement = createSVGContainerElement();
        const svgElement = createSVGElement();
        if (svgElement.style.filter === "") return {
            errorMessage: "error indicator",
            svgContainerElement: svgContainerElement
        };
        svgContainerElement.appendChild(svgElement);
        document.body.appendChild(svgContainerElement);
        return {
            svgContainerElement: svgContainerElement
        };
    }
    // functions are encapsulated within a single method in order to allow them to be executed within the same context
    // of the puppeteer evaluate method
    static async getColorViaImageDataURL(base64EncodedDataURL) {
        function rgbToHex(r, g, b) {
            if (r > 255 || g > 255 || b > 255) throw new Error("Invalid color component");
            return (r << 16 | g << 8 | b).toString(16);
        }
        function getData(canvasElement) {
            const canvasStartCoordinate = 0;
            const canvasFinalCoordinate = canvasElement.width;
            return canvasElement.getContext("2d").getImageData(canvasStartCoordinate, canvasStartCoordinate, canvasFinalCoordinate, canvasFinalCoordinate).data;
        }
        function getCanvasHexColor(canvasElement) {
            const data = getData(canvasElement);
            const hex = rgbToHex(data[0], data[1], data[2]);
            return `#${`000000${hex}`.slice(-6)}`;
        }
        function createCanvasElement(imageElement) {
            const canvasElement = document.createElement("canvas");
            canvasElement.width = imageElement.width;
            canvasElement.height = imageElement.height;
            canvasElement.getContext("2d").drawImage(imageElement, 0, 0, imageElement.width, imageElement.height);
            return canvasElement;
        }
        async function createImage() {
            const imageElement = new Image();
            imageElement.src = base64EncodedDataURL;
            return new Promise((resolve)=>{
                setTimeout(()=>resolve(imageElement));
            });
        }
        const imageElement = await createImage();
        const canvasElement = createCanvasElement(imageElement);
        return getCanvasHexColor(canvasElement);
    }
}
module.exports.FilterToHexShared = $c1ca01a969843711$var$FilterToHexShared;

});

parcelRegister("h0THN", function(module, exports) {

var $Gr8vk = parcelRequire("Gr8vk");
module.exports = $Gr8vk("kWFu0").then(()=>parcelRequire("37sd8"));

});

parcelRegister("gLWJ8", function(module, exports) {

var $Gr8vk = parcelRequire("Gr8vk");
module.exports = $Gr8vk("7UuVN").then(()=>parcelRequire("81JcS"));

});

parcelRegister("5dlKa", function(module, exports) {
"use strict";
var $3cbf08790a4f0a3f$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $3cbf08790a4f0a3f$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $3cbf08790a4f0a3f$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.PROGRAM_ID = module.exports.PROGRAM_ADDRESS = void 0;

var $gNDby = parcelRequire("gNDby");

$3cbf08790a4f0a3f$var$__exportStar((parcelRequire("6WDOb")), module.exports);

$3cbf08790a4f0a3f$var$__exportStar((parcelRequire("apO5D")), module.exports);

$3cbf08790a4f0a3f$var$__exportStar((parcelRequire("46mYT")), module.exports);

$3cbf08790a4f0a3f$var$__exportStar((parcelRequire("dtie9")), module.exports);
module.exports.PROGRAM_ADDRESS = "BGUMAp9Gq7iTEuizy4pqaxsTyUCBK68MDfK752saRPUY";
module.exports.PROGRAM_ID = new $gNDby.PublicKey(module.exports.PROGRAM_ADDRESS);

});
parcelRegister("6WDOb", function(module, exports) {
"use strict";
var $50e709f96f753ffd$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $50e709f96f753ffd$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $50e709f96f753ffd$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.accountProviders = void 0;

$50e709f96f753ffd$var$__exportStar((parcelRequire("2P1un")), module.exports);

$50e709f96f753ffd$var$__exportStar((parcelRequire("6iBPp")), module.exports);


module.exports.accountProviders = {
    TreeConfig: (parcelRequire("2P1un")).TreeConfig,
    Voucher: (parcelRequire("6iBPp")).Voucher
};

});
parcelRegister("2P1un", function(module, exports) {
"use strict";
var $20e17fe407764ad7$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $20e17fe407764ad7$var$__setModuleDefault = module.exports && module.exports.__setModuleDefault || (Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
});
var $20e17fe407764ad7$var$__importStar = module.exports && module.exports.__importStar || function(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) $20e17fe407764ad7$var$__createBinding(result, mod, k);
    }
    $20e17fe407764ad7$var$__setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.treeConfigBeet = module.exports.TreeConfig = module.exports.treeConfigDiscriminator = void 0;

const $20e17fe407764ad7$var$web3 = $20e17fe407764ad7$var$__importStar((parcelRequire("gNDby")));

const $20e17fe407764ad7$var$beet = $20e17fe407764ad7$var$__importStar((parcelRequire("1DULh")));

const $20e17fe407764ad7$var$beetSolana = $20e17fe407764ad7$var$__importStar((parcelRequire("8OnYx")));
module.exports.treeConfigDiscriminator = [
    122,
    245,
    175,
    248,
    171,
    34,
    0,
    207
];
class $20e17fe407764ad7$var$TreeConfig {
    constructor(treeCreator, treeDelegate, totalMintCapacity, numMinted, isPublic){
        this.treeCreator = treeCreator;
        this.treeDelegate = treeDelegate;
        this.totalMintCapacity = totalMintCapacity;
        this.numMinted = numMinted;
        this.isPublic = isPublic;
    }
    static fromArgs(args) {
        return new $20e17fe407764ad7$var$TreeConfig(args.treeCreator, args.treeDelegate, args.totalMintCapacity, args.numMinted, args.isPublic);
    }
    static fromAccountInfo(accountInfo, offset = 0) {
        return $20e17fe407764ad7$var$TreeConfig.deserialize(accountInfo.data, offset);
    }
    static async fromAccountAddress(connection, address, commitmentOrConfig) {
        const accountInfo = await connection.getAccountInfo(address, commitmentOrConfig);
        if (accountInfo == null) throw new Error(`Unable to find TreeConfig account at ${address}`);
        return $20e17fe407764ad7$var$TreeConfig.fromAccountInfo(accountInfo, 0)[0];
    }
    static gpaBuilder(programId = new $20e17fe407764ad7$var$web3.PublicKey("BGUMAp9Gq7iTEuizy4pqaxsTyUCBK68MDfK752saRPUY")) {
        return $20e17fe407764ad7$var$beetSolana.GpaBuilder.fromStruct(programId, module.exports.treeConfigBeet);
    }
    static deserialize(buf, offset = 0) {
        return module.exports.treeConfigBeet.deserialize(buf, offset);
    }
    serialize() {
        return module.exports.treeConfigBeet.serialize({
            accountDiscriminator: module.exports.treeConfigDiscriminator,
            ...this
        });
    }
    static get byteSize() {
        return module.exports.treeConfigBeet.byteSize;
    }
    static async getMinimumBalanceForRentExemption(connection, commitment) {
        return connection.getMinimumBalanceForRentExemption($20e17fe407764ad7$var$TreeConfig.byteSize, commitment);
    }
    static hasCorrectByteSize(buf, offset = 0) {
        return buf.byteLength - offset === $20e17fe407764ad7$var$TreeConfig.byteSize;
    }
    pretty() {
        return {
            treeCreator: this.treeCreator.toBase58(),
            treeDelegate: this.treeDelegate.toBase58(),
            totalMintCapacity: (()=>{
                const x = this.totalMintCapacity;
                if (typeof x.toNumber === "function") try {
                    return x.toNumber();
                } catch (_) {
                    return x;
                }
                return x;
            })(),
            numMinted: (()=>{
                const x = this.numMinted;
                if (typeof x.toNumber === "function") try {
                    return x.toNumber();
                } catch (_) {
                    return x;
                }
                return x;
            })(),
            isPublic: this.isPublic
        };
    }
}
module.exports.TreeConfig = $20e17fe407764ad7$var$TreeConfig;
module.exports.treeConfigBeet = new $20e17fe407764ad7$var$beet.BeetStruct([
    [
        "accountDiscriminator",
        $20e17fe407764ad7$var$beet.uniformFixedSizeArray($20e17fe407764ad7$var$beet.u8, 8)
    ],
    [
        "treeCreator",
        $20e17fe407764ad7$var$beetSolana.publicKey
    ],
    [
        "treeDelegate",
        $20e17fe407764ad7$var$beetSolana.publicKey
    ],
    [
        "totalMintCapacity",
        $20e17fe407764ad7$var$beet.u64
    ],
    [
        "numMinted",
        $20e17fe407764ad7$var$beet.u64
    ],
    [
        "isPublic",
        $20e17fe407764ad7$var$beet.bool
    ]
], $20e17fe407764ad7$var$TreeConfig.fromArgs, "TreeConfig");

});
parcelRegister("1DULh", function(module, exports) {
"use strict";
var $132576a64d76b7a4$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $132576a64d76b7a4$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $132576a64d76b7a4$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.supportedTypeMap = void 0;











$132576a64d76b7a4$var$__exportStar((parcelRequire("5vXUZ")), module.exports);

$132576a64d76b7a4$var$__exportStar((parcelRequire("3rgjF")), module.exports);

$132576a64d76b7a4$var$__exportStar((parcelRequire("iadi0")), module.exports);

$132576a64d76b7a4$var$__exportStar((parcelRequire("3MHbE")), module.exports);

$132576a64d76b7a4$var$__exportStar((parcelRequire("ipcLD")), module.exports);

$132576a64d76b7a4$var$__exportStar((parcelRequire("7RrfS")), module.exports);

$132576a64d76b7a4$var$__exportStar((parcelRequire("dWJUH")), module.exports);

$132576a64d76b7a4$var$__exportStar((parcelRequire("981vi")), module.exports);

$132576a64d76b7a4$var$__exportStar((parcelRequire("ioTrE")), module.exports);

$132576a64d76b7a4$var$__exportStar((parcelRequire("i0sX8")), module.exports);

$132576a64d76b7a4$var$__exportStar((parcelRequire("l9HYk")), module.exports);

$132576a64d76b7a4$var$__exportStar((parcelRequire("inPTV")), module.exports);

$132576a64d76b7a4$var$__exportStar((parcelRequire("4kKfe")), module.exports);

$132576a64d76b7a4$var$__exportStar((parcelRequire("d5fNB")), module.exports);

$132576a64d76b7a4$var$__exportStar((parcelRequire("kOHSh")), module.exports);
/**
 * Maps all {@link Beet} de/serializers to metadata which describes in which
 * package it is defined as well as which TypeScript type is used to represent
 * the deserialized value in JavaScript.
 *
 * @category TypeDefinition
 */ module.exports.supportedTypeMap = {
    ...(parcelRequire("3rgjF")).collectionsTypeMap,
    ...(parcelRequire("981vi")).stringTypeMap,
    ...(parcelRequire("iadi0")).compositesTypeMap,
    ...(parcelRequire("3MHbE")).enumsTypeMap,
    ...(parcelRequire("7RrfS")).numbersTypeMap,
    ...(parcelRequire("5vXUZ")).aliasesTypeMap,
    ...(parcelRequire("ioTrE")).tuplesTypeMap,
    ...(parcelRequire("ipcLD")).mapsTypeMap,
    ...(parcelRequire("dWJUH")).setsTypeMap,
    ...(parcelRequire("i0sX8")).unitTypeMap
};

});
parcelRegister("3rgjF", function(module, exports) {

var $6ZWSX = parcelRequire("6ZWSX");
var $28108ccbe34966f6$require$Buffer = $6ZWSX.Buffer;
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.collectionsTypeMap = module.exports.uint8Array = module.exports.fixedSizeUint8Array = module.exports.fixedSizeBuffer = module.exports.array = module.exports.fixedSizeArray = module.exports.uniformFixedSizeArray = void 0;

var $kOHSh = parcelRequire("kOHSh");

var $aLUwE = parcelRequire("aLUwE");

var $7RrfS = parcelRequire("7RrfS");

var $kOHSh = parcelRequire("kOHSh");

var $2xd6i = parcelRequire("2xd6i");

var $l9HYk = parcelRequire("l9HYk");
/**
 * De/Serializes an array with a specific number of elements of type {@link T}
 * which all have the same size.
 *
 * @template T type of elements held in the array
 *
 * @param element the De/Serializer for the element type
 * @param len the number of elements in the array
 * @param lenPrefix if `true` a 4 byte number indicating the size of the array
 * will be included before serialized array data
 *
 * @category beet/collection
 */ function $28108ccbe34966f6$var$uniformFixedSizeArray(element, len, lenPrefix = false) {
    const arraySize = element.byteSize * len;
    const byteSize = lenPrefix ? 4 + arraySize : arraySize;
    return {
        write: function(buf, offset, value) {
            $aLUwE.strict.equal(value.length, len, `array length ${value.length} should match len ${len}`);
            if (lenPrefix) {
                $7RrfS.u32.write(buf, offset, len);
                offset += 4;
            }
            for(let i = 0; i < len; i++)element.write(buf, offset + i * element.byteSize, value[i]);
        },
        read: function(buf, offset) {
            if (lenPrefix) {
                const size = $7RrfS.u32.read(buf, offset);
                $aLUwE.strict.equal(size, len, "invalid byte size");
                offset += 4;
            }
            const arr = new Array(len);
            for(let i = 0; i < len; i++)arr[i] = element.read(buf, offset + i * element.byteSize);
            return arr;
        },
        byteSize: byteSize,
        length: len,
        elementByteSize: element.byteSize,
        lenPrefixByteSize: 4,
        description: `Array<${element.description}>(${len})`
    };
}
module.exports.uniformFixedSizeArray = $28108ccbe34966f6$var$uniformFixedSizeArray;
/**
 * De/Serializes an array with a specific number of elements of type {@link T}
 * which do not all have the same size.
 *
 * @template T type of elements held in the array
 *
 * @param elements the De/Serializers for the element types
 * @param elementsByteSize size of all elements in the array combined
 *
 * @category beet/collection
 */ function $28108ccbe34966f6$var$fixedSizeArray(elements, elementsByteSize) {
    const len = elements.length;
    const firstElement = len === 0 ? "<EMPTY>" : elements[0].description;
    return {
        write: function(buf, offset, value) {
            $aLUwE.strict.equal(value.length, len, `array length ${value.length} should match len ${len}`);
            $7RrfS.u32.write(buf, offset, len);
            let cursor = offset + 4;
            for(let i = 0; i < len; i++){
                const element = elements[i];
                element.write(buf, cursor, value[i]);
                cursor += element.byteSize;
            }
        },
        read: function(buf, offset) {
            const size = $7RrfS.u32.read(buf, offset);
            $aLUwE.strict.equal(size, len, "invalid byte size");
            let cursor = offset + 4;
            const arr = new Array(len);
            for(let i = 0; i < len; i++){
                const element = elements[i];
                arr[i] = element.read(buf, cursor);
                cursor += element.byteSize;
            }
            return arr;
        },
        byteSize: 4 + elementsByteSize,
        length: len,
        description: `Array<${firstElement}>(${len})[ 4 + ${elementsByteSize} ]`
    };
}
module.exports.fixedSizeArray = $28108ccbe34966f6$var$fixedSizeArray;
/**
 * Wraps an array De/Serializer with with elements of type {@link T} which do
 * not all have the same size.
 *
 * @template T type of elements held in the array
 *
 * @param element the De/Serializer for the element types
 *
 * @category beet/collection
 */ function $28108ccbe34966f6$var$array(element) {
    return {
        toFixedFromData (buf, offset) {
            const len = $7RrfS.u32.read(buf, offset);
            (0, $2xd6i.logTrace)(`${this.description}[${len}]`);
            const cursorStart = offset + 4;
            let cursor = cursorStart;
            const fixedElements = new Array(len);
            for(let i = 0; i < len; i++){
                const fixedElement = (0, $l9HYk.fixBeetFromData)(element, buf, cursor);
                fixedElements[i] = fixedElement;
                cursor += fixedElement.byteSize;
            }
            return $28108ccbe34966f6$var$fixedSizeArray(fixedElements, cursor - cursorStart);
        },
        toFixedFromValue (vals) {
            (0, $aLUwE.strict)(Array.isArray(vals), `${vals} should be an array`);
            let elementsSize = 0;
            const fixedElements = new Array(vals.length);
            for(let i = 0; i < vals.length; i++){
                const fixedElement = (0, $l9HYk.fixBeetFromValue)(element, vals[i]);
                fixedElements[i] = fixedElement;
                elementsSize += fixedElement.byteSize;
            }
            return $28108ccbe34966f6$var$fixedSizeArray(fixedElements, elementsSize);
        },
        description: `array`
    };
}
module.exports.array = $28108ccbe34966f6$var$array;
/**
 * A De/Serializer for raw {@link Buffer}s that just copies/reads the buffer bytes
 * to/from the provided buffer.
 *
 * @param bytes the byte size of the buffer to de/serialize
 * @category beet/collection
 */ function $28108ccbe34966f6$var$fixedSizeBuffer(bytes) {
    return {
        write: function(buf, offset, value) {
            value.copy(buf, offset, 0, bytes);
        },
        read: function(buf, offset) {
            return buf.slice(offset, offset + bytes);
        },
        byteSize: bytes,
        description: `Buffer(${bytes})`
    };
}
module.exports.fixedSizeBuffer = $28108ccbe34966f6$var$fixedSizeBuffer;
/**
 * A De/Serializer for {@link Uint8Array}s of known size that just copies/reads
 * the array bytes to/from the provided buffer.
 *
 * @category beet/collection
 */ function $28108ccbe34966f6$var$fixedSizeUint8Array(len, lenPrefix = false) {
    const arrayBufferBeet = $28108ccbe34966f6$var$fixedSizeBuffer(len);
    const byteSize = lenPrefix ? len + 4 : len;
    return {
        write: function(buf, offset, value) {
            $aLUwE.strict.equal(value.byteLength, len, `Uint8Array length ${value.byteLength} should match len ${len}`);
            if (lenPrefix) {
                $7RrfS.u32.write(buf, offset, len);
                offset += 4;
            }
            const valueBuf = $28108ccbe34966f6$require$Buffer.from(value);
            arrayBufferBeet.write(buf, offset, valueBuf);
        },
        read: function(buf, offset) {
            if (lenPrefix) {
                const size = $7RrfS.u32.read(buf, offset);
                $aLUwE.strict.equal(size, len, "invalid byte size");
                offset += 4;
            }
            const arrayBuffer = arrayBufferBeet.read(buf, offset);
            return Uint8Array.from(arrayBuffer);
        },
        byteSize: byteSize,
        description: `Uint8Array(${len})`
    };
}
module.exports.fixedSizeUint8Array = $28108ccbe34966f6$var$fixedSizeUint8Array;
/**
 * A De/Serializer for {@link Uint8Array}s that just copies/reads the array bytes
 * to/from the provided buffer.
 *
 * @category beet/collection
 */ module.exports.uint8Array = {
    toFixedFromData (buf, offset) {
        const len = $7RrfS.u32.read(buf, offset);
        (0, $2xd6i.logTrace)(`${this.description}[${len}]`);
        return $28108ccbe34966f6$var$fixedSizeUint8Array(len, true);
    },
    toFixedFromValue (val) {
        const len = val.byteLength;
        return $28108ccbe34966f6$var$fixedSizeUint8Array(len, true);
    },
    description: `Uint8Array`
};
/**
 * Maps collections beet exports to metadata which describes in which package it
 * is defined as well as which TypeScript type is used to represent the
 * deserialized value in JavaScript.
 *
 * @category TypeDefinition
 */ module.exports.collectionsTypeMap = {
    Array: {
        beet: "array",
        isFixable: true,
        sourcePack: $kOHSh.BEET_PACKAGE,
        ts: "Array",
        arg: $kOHSh.BEET_TYPE_ARG_LEN
    },
    FixedSizeArray: {
        beet: "fixedSizeArray",
        isFixable: false,
        sourcePack: $kOHSh.BEET_PACKAGE,
        ts: "Array",
        arg: $kOHSh.BEET_TYPE_ARG_LEN
    },
    UniformFixedSizeArray: {
        beet: "uniformFixedSizeArray",
        isFixable: false,
        sourcePack: $kOHSh.BEET_PACKAGE,
        ts: "Array",
        arg: $kOHSh.BEET_TYPE_ARG_LEN
    },
    Buffer: {
        beet: "fixedSizeBuffer",
        isFixable: false,
        sourcePack: $kOHSh.BEET_PACKAGE,
        ts: "Buffer",
        arg: $kOHSh.BEET_TYPE_ARG_LEN
    },
    FixedSizeUint8Array: {
        beet: "fixedSizeUint8Array",
        isFixable: false,
        sourcePack: $kOHSh.BEET_PACKAGE,
        ts: "Uint8Array",
        arg: $kOHSh.BEET_TYPE_ARG_LEN
    },
    Uint8Array: {
        beet: "uint8Array",
        isFixable: true,
        sourcePack: $kOHSh.BEET_PACKAGE,
        ts: "Uint8Array",
        arg: $kOHSh.BEET_TYPE_ARG_LEN
    }
};

});
parcelRegister("kOHSh", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.isElementCollectionFixedSizeBeet = module.exports.isFixableBeet = module.exports.assertFixedSizeBeet = module.exports.isFixedSizeBeet = module.exports.BEET_TYPE_ARG_INNER = module.exports.BEET_TYPE_ARG_LEN = module.exports.BEET_PACKAGE = void 0;

var $aLUwE = parcelRequire("aLUwE");
/**
 * Matches name in package.json
 *
 * @private
 */ module.exports.BEET_PACKAGE = "@metaplex-foundation/beet";
/**
 * @private
 * @category beet
 */ module.exports.BEET_TYPE_ARG_LEN = "len";
/**
 * @private
 * @category beet
 */ module.exports.BEET_TYPE_ARG_INNER = "Beet<{innner}>";
// -----------------
// Guards
// -----------------
/**
 * @private
 */ function $f27a82bdd5dd8608$var$isFixedSizeBeet(x) {
    return Object.keys(x).includes("byteSize");
}
module.exports.isFixedSizeBeet = $f27a82bdd5dd8608$var$isFixedSizeBeet;
/**
 * @private
 */ function $f27a82bdd5dd8608$var$assertFixedSizeBeet(x, msg = `${x} should have been a fixed beet`) {
    (0, $aLUwE.strict)($f27a82bdd5dd8608$var$isFixedSizeBeet(x), msg);
}
module.exports.assertFixedSizeBeet = $f27a82bdd5dd8608$var$assertFixedSizeBeet;
/**
 * @private
 */ function $f27a82bdd5dd8608$var$isFixableBeet(x) {
    return typeof x.toFixedFromData === "function" && typeof x.toFixedFromValue === "function";
}
module.exports.isFixableBeet = $f27a82bdd5dd8608$var$isFixableBeet;
/**
 * @private
 */ function $f27a82bdd5dd8608$var$isElementCollectionFixedSizeBeet(x) {
    const keys = Object.keys(x);
    return keys.includes("length") && keys.includes("elementByteSize") && keys.includes("lenPrefixByteSize");
}
module.exports.isElementCollectionFixedSizeBeet = $f27a82bdd5dd8608$var$isElementCollectionFixedSizeBeet;

});
parcelRegister("aLUwE", function(module, exports) {
// Currently in sync with Node.js lib/assert.js
// https://github.com/nodejs/node/commit/2a51ae424a513ec9a6aa3466baa0cc1d55dd4f3b
// Originally from narwhal.js (http://narwhaljs.org)
// Copyright (c) 2009 Thomas Robinson <280north.com>
//
// Permission is hereby granted, free of charge, to any person obtaining a copy
// of this software and associated documentation files (the 'Software'), to
// deal in the Software without restriction, including without limitation the
// rights to use, copy, modify, merge, publish, distribute, sublicense, and/or
// sell copies of the Software, and to permit persons to whom the Software is
// furnished to do so, subject to the following conditions:
//
// The above copyright notice and this permission notice shall be included in
// all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED 'AS IS', WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
// IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
// FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
// AUTHORS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN
// ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION
// WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.

var $hPtJY = parcelRequire("hPtJY");
"use strict";
function $7d7a23f7babfddb7$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $7d7a23f7babfddb7$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $7d7a23f7babfddb7$var$_typeof(o);
}
function $7d7a23f7babfddb7$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, $7d7a23f7babfddb7$var$_toPropertyKey(descriptor.key), descriptor);
    }
}
function $7d7a23f7babfddb7$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $7d7a23f7babfddb7$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $7d7a23f7babfddb7$var$_defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}
function $7d7a23f7babfddb7$var$_toPropertyKey(arg) {
    var key = $7d7a23f7babfddb7$var$_toPrimitive(arg, "string");
    return $7d7a23f7babfddb7$var$_typeof(key) === "symbol" ? key : String(key);
}
function $7d7a23f7babfddb7$var$_toPrimitive(input, hint) {
    if ($7d7a23f7babfddb7$var$_typeof(input) !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if ($7d7a23f7babfddb7$var$_typeof(res) !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
function $7d7a23f7babfddb7$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}

var $cCihK = parcelRequire("cCihK");
var $7d7a23f7babfddb7$var$_require$codes = $cCihK.codes, $7d7a23f7babfddb7$var$ERR_AMBIGUOUS_ARGUMENT = $7d7a23f7babfddb7$var$_require$codes.ERR_AMBIGUOUS_ARGUMENT, $7d7a23f7babfddb7$var$ERR_INVALID_ARG_TYPE = $7d7a23f7babfddb7$var$_require$codes.ERR_INVALID_ARG_TYPE, $7d7a23f7babfddb7$var$ERR_INVALID_ARG_VALUE = $7d7a23f7babfddb7$var$_require$codes.ERR_INVALID_ARG_VALUE, $7d7a23f7babfddb7$var$ERR_INVALID_RETURN_VALUE = $7d7a23f7babfddb7$var$_require$codes.ERR_INVALID_RETURN_VALUE, $7d7a23f7babfddb7$var$ERR_MISSING_ARGS = $7d7a23f7babfddb7$var$_require$codes.ERR_MISSING_ARGS;

var $8pS6q = parcelRequire("8pS6q");

var $N7Lcz = parcelRequire("N7Lcz");
var $7d7a23f7babfddb7$var$inspect = $N7Lcz.inspect;

var $N7Lcz = parcelRequire("N7Lcz");
var $7d7a23f7babfddb7$require$_require$types = $N7Lcz.types;
var $7d7a23f7babfddb7$var$isPromise = $7d7a23f7babfddb7$require$_require$types.isPromise, $7d7a23f7babfddb7$var$isRegExp = $7d7a23f7babfddb7$require$_require$types.isRegExp;

var $7d7a23f7babfddb7$var$objectAssign = (parcelRequire("boX8x"))();

var $7d7a23f7babfddb7$var$objectIs = (parcelRequire("5SxoI"))();

var $7d7a23f7babfddb7$var$RegExpPrototypeTest = (parcelRequire("hXu6F"))("RegExp.prototype.test");
var $7d7a23f7babfddb7$var$errorCache = new Map();
var $7d7a23f7babfddb7$var$isDeepEqual;
var $7d7a23f7babfddb7$var$isDeepStrictEqual;
var $7d7a23f7babfddb7$var$parseExpressionAt;
var $7d7a23f7babfddb7$var$findNodeAround;
var $7d7a23f7babfddb7$var$decoder;

function $7d7a23f7babfddb7$var$lazyLoadComparison() {
    var comparison = (parcelRequire("3LKhK"));
    $7d7a23f7babfddb7$var$isDeepEqual = comparison.isDeepEqual;
    $7d7a23f7babfddb7$var$isDeepStrictEqual = comparison.isDeepStrictEqual;
}
// Escape control characters but not \n and \t to keep the line breaks and
// indentation intact.
// eslint-disable-next-line no-control-regex
var $7d7a23f7babfddb7$var$escapeSequencesRegExp = /[\x00-\x08\x0b\x0c\x0e-\x1f]/g;
var $7d7a23f7babfddb7$var$meta = [
    "\\u0000",
    "\\u0001",
    "\\u0002",
    "\\u0003",
    "\\u0004",
    "\\u0005",
    "\\u0006",
    "\\u0007",
    "\\b",
    "",
    "",
    "\\u000b",
    "\\f",
    "",
    "\\u000e",
    "\\u000f",
    "\\u0010",
    "\\u0011",
    "\\u0012",
    "\\u0013",
    "\\u0014",
    "\\u0015",
    "\\u0016",
    "\\u0017",
    "\\u0018",
    "\\u0019",
    "\\u001a",
    "\\u001b",
    "\\u001c",
    "\\u001d",
    "\\u001e",
    "\\u001f"
];
var $7d7a23f7babfddb7$var$escapeFn = function escapeFn(str) {
    return $7d7a23f7babfddb7$var$meta[str.charCodeAt(0)];
};
var $7d7a23f7babfddb7$var$warned = false;
// The assert module provides functions that throw
// AssertionError's when particular conditions are not met. The
// assert module must conform to the following interface.
var $7d7a23f7babfddb7$var$assert = module.exports = $7d7a23f7babfddb7$var$ok;
var $7d7a23f7babfddb7$var$NO_EXCEPTION_SENTINEL = {};
// All of the following functions must throw an AssertionError
// when a corresponding condition is not met, with a message that
// may be undefined if not provided. All assertion methods provide
// both the actual and expected values to the assertion error for
// display purposes.
function $7d7a23f7babfddb7$var$innerFail(obj) {
    if (obj.message instanceof Error) throw obj.message;
    throw new $8pS6q(obj);
}
function $7d7a23f7babfddb7$var$fail(actual, expected, message, operator, stackStartFn) {
    var argsLen = arguments.length;
    var internalMessage;
    if (argsLen === 0) internalMessage = "Failed";
    else if (argsLen === 1) {
        message = actual;
        actual = undefined;
    } else {
        if ($7d7a23f7babfddb7$var$warned === false) {
            $7d7a23f7babfddb7$var$warned = true;
            var warn = $hPtJY.emitWarning ? $hPtJY.emitWarning : console.warn.bind(console);
            warn("assert.fail() with more than one argument is deprecated. Please use assert.strictEqual() instead or only pass a message.", "DeprecationWarning", "DEP0094");
        }
        if (argsLen === 2) operator = "!=";
    }
    if (message instanceof Error) throw message;
    var errArgs = {
        actual: actual,
        expected: expected,
        operator: operator === undefined ? "fail" : operator,
        stackStartFn: stackStartFn || $7d7a23f7babfddb7$var$fail
    };
    if (message !== undefined) errArgs.message = message;
    var err = new $8pS6q(errArgs);
    if (internalMessage) {
        err.message = internalMessage;
        err.generatedMessage = true;
    }
    throw err;
}
$7d7a23f7babfddb7$var$assert.fail = $7d7a23f7babfddb7$var$fail;
// The AssertionError is defined in internal/error.
$7d7a23f7babfddb7$var$assert.AssertionError = $8pS6q;
function $7d7a23f7babfddb7$var$innerOk(fn, argLen, value, message) {
    if (!value) {
        var generatedMessage = false;
        if (argLen === 0) {
            generatedMessage = true;
            message = "No value argument passed to `assert.ok()`";
        } else if (message instanceof Error) throw message;
        var err = new $8pS6q({
            actual: value,
            expected: true,
            message: message,
            operator: "==",
            stackStartFn: fn
        });
        err.generatedMessage = generatedMessage;
        throw err;
    }
}
// Pure assertion tests whether a value is truthy, as determined
// by !!value.
function $7d7a23f7babfddb7$var$ok() {
    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
    $7d7a23f7babfddb7$var$innerOk.apply(void 0, [
        $7d7a23f7babfddb7$var$ok,
        args.length
    ].concat(args));
}
$7d7a23f7babfddb7$var$assert.ok = $7d7a23f7babfddb7$var$ok;
// The equality assertion tests shallow, coercive equality with ==.
/* eslint-disable no-restricted-properties */ $7d7a23f7babfddb7$var$assert.equal = function equal(actual, expected, message) {
    if (arguments.length < 2) throw new $7d7a23f7babfddb7$var$ERR_MISSING_ARGS("actual", "expected");
    // eslint-disable-next-line eqeqeq
    if (actual != expected) $7d7a23f7babfddb7$var$innerFail({
        actual: actual,
        expected: expected,
        message: message,
        operator: "==",
        stackStartFn: equal
    });
};
// The non-equality assertion tests for whether two objects are not
// equal with !=.
$7d7a23f7babfddb7$var$assert.notEqual = function notEqual(actual, expected, message) {
    if (arguments.length < 2) throw new $7d7a23f7babfddb7$var$ERR_MISSING_ARGS("actual", "expected");
    // eslint-disable-next-line eqeqeq
    if (actual == expected) $7d7a23f7babfddb7$var$innerFail({
        actual: actual,
        expected: expected,
        message: message,
        operator: "!=",
        stackStartFn: notEqual
    });
};
// The equivalence assertion tests a deep equality relation.
$7d7a23f7babfddb7$var$assert.deepEqual = function deepEqual(actual, expected, message) {
    if (arguments.length < 2) throw new $7d7a23f7babfddb7$var$ERR_MISSING_ARGS("actual", "expected");
    if ($7d7a23f7babfddb7$var$isDeepEqual === undefined) $7d7a23f7babfddb7$var$lazyLoadComparison();
    if (!$7d7a23f7babfddb7$var$isDeepEqual(actual, expected)) $7d7a23f7babfddb7$var$innerFail({
        actual: actual,
        expected: expected,
        message: message,
        operator: "deepEqual",
        stackStartFn: deepEqual
    });
};
// The non-equivalence assertion tests for any deep inequality.
$7d7a23f7babfddb7$var$assert.notDeepEqual = function notDeepEqual(actual, expected, message) {
    if (arguments.length < 2) throw new $7d7a23f7babfddb7$var$ERR_MISSING_ARGS("actual", "expected");
    if ($7d7a23f7babfddb7$var$isDeepEqual === undefined) $7d7a23f7babfddb7$var$lazyLoadComparison();
    if ($7d7a23f7babfddb7$var$isDeepEqual(actual, expected)) $7d7a23f7babfddb7$var$innerFail({
        actual: actual,
        expected: expected,
        message: message,
        operator: "notDeepEqual",
        stackStartFn: notDeepEqual
    });
};
/* eslint-enable */ $7d7a23f7babfddb7$var$assert.deepStrictEqual = function deepStrictEqual(actual, expected, message) {
    if (arguments.length < 2) throw new $7d7a23f7babfddb7$var$ERR_MISSING_ARGS("actual", "expected");
    if ($7d7a23f7babfddb7$var$isDeepEqual === undefined) $7d7a23f7babfddb7$var$lazyLoadComparison();
    if (!$7d7a23f7babfddb7$var$isDeepStrictEqual(actual, expected)) $7d7a23f7babfddb7$var$innerFail({
        actual: actual,
        expected: expected,
        message: message,
        operator: "deepStrictEqual",
        stackStartFn: deepStrictEqual
    });
};
$7d7a23f7babfddb7$var$assert.notDeepStrictEqual = $7d7a23f7babfddb7$var$notDeepStrictEqual;
function $7d7a23f7babfddb7$var$notDeepStrictEqual(actual, expected, message) {
    if (arguments.length < 2) throw new $7d7a23f7babfddb7$var$ERR_MISSING_ARGS("actual", "expected");
    if ($7d7a23f7babfddb7$var$isDeepEqual === undefined) $7d7a23f7babfddb7$var$lazyLoadComparison();
    if ($7d7a23f7babfddb7$var$isDeepStrictEqual(actual, expected)) $7d7a23f7babfddb7$var$innerFail({
        actual: actual,
        expected: expected,
        message: message,
        operator: "notDeepStrictEqual",
        stackStartFn: $7d7a23f7babfddb7$var$notDeepStrictEqual
    });
}
$7d7a23f7babfddb7$var$assert.strictEqual = function strictEqual(actual, expected, message) {
    if (arguments.length < 2) throw new $7d7a23f7babfddb7$var$ERR_MISSING_ARGS("actual", "expected");
    if (!$7d7a23f7babfddb7$var$objectIs(actual, expected)) $7d7a23f7babfddb7$var$innerFail({
        actual: actual,
        expected: expected,
        message: message,
        operator: "strictEqual",
        stackStartFn: strictEqual
    });
};
$7d7a23f7babfddb7$var$assert.notStrictEqual = function notStrictEqual(actual, expected, message) {
    if (arguments.length < 2) throw new $7d7a23f7babfddb7$var$ERR_MISSING_ARGS("actual", "expected");
    if ($7d7a23f7babfddb7$var$objectIs(actual, expected)) $7d7a23f7babfddb7$var$innerFail({
        actual: actual,
        expected: expected,
        message: message,
        operator: "notStrictEqual",
        stackStartFn: notStrictEqual
    });
};
var $7d7a23f7babfddb7$var$Comparison = /*#__PURE__*/ $7d7a23f7babfddb7$var$_createClass(function Comparison(obj, keys, actual) {
    var _this = this;
    $7d7a23f7babfddb7$var$_classCallCheck(this, Comparison);
    keys.forEach(function(key) {
        if (key in obj) {
            if (actual !== undefined && typeof actual[key] === "string" && $7d7a23f7babfddb7$var$isRegExp(obj[key]) && $7d7a23f7babfddb7$var$RegExpPrototypeTest(obj[key], actual[key])) _this[key] = actual[key];
            else _this[key] = obj[key];
        }
    });
});
function $7d7a23f7babfddb7$var$compareExceptionKey(actual, expected, key, message, keys, fn) {
    if (!(key in actual) || !$7d7a23f7babfddb7$var$isDeepStrictEqual(actual[key], expected[key])) {
        if (!message) {
            // Create placeholder objects to create a nice output.
            var a = new $7d7a23f7babfddb7$var$Comparison(actual, keys);
            var b = new $7d7a23f7babfddb7$var$Comparison(expected, keys, actual);
            var err = new $8pS6q({
                actual: a,
                expected: b,
                operator: "deepStrictEqual",
                stackStartFn: fn
            });
            err.actual = actual;
            err.expected = expected;
            err.operator = fn.name;
            throw err;
        }
        $7d7a23f7babfddb7$var$innerFail({
            actual: actual,
            expected: expected,
            message: message,
            operator: fn.name,
            stackStartFn: fn
        });
    }
}
function $7d7a23f7babfddb7$var$expectedException(actual, expected, msg, fn) {
    if (typeof expected !== "function") {
        if ($7d7a23f7babfddb7$var$isRegExp(expected)) return $7d7a23f7babfddb7$var$RegExpPrototypeTest(expected, actual);
        // assert.doesNotThrow does not accept objects.
        if (arguments.length === 2) throw new $7d7a23f7babfddb7$var$ERR_INVALID_ARG_TYPE("expected", [
            "Function",
            "RegExp"
        ], expected);
        // Handle primitives properly.
        if ($7d7a23f7babfddb7$var$_typeof(actual) !== "object" || actual === null) {
            var err = new $8pS6q({
                actual: actual,
                expected: expected,
                message: msg,
                operator: "deepStrictEqual",
                stackStartFn: fn
            });
            err.operator = fn.name;
            throw err;
        }
        var keys = Object.keys(expected);
        // Special handle errors to make sure the name and the message are compared
        // as well.
        if (expected instanceof Error) keys.push("name", "message");
        else if (keys.length === 0) throw new $7d7a23f7babfddb7$var$ERR_INVALID_ARG_VALUE("error", expected, "may not be an empty object");
        if ($7d7a23f7babfddb7$var$isDeepEqual === undefined) $7d7a23f7babfddb7$var$lazyLoadComparison();
        keys.forEach(function(key) {
            if (typeof actual[key] === "string" && $7d7a23f7babfddb7$var$isRegExp(expected[key]) && $7d7a23f7babfddb7$var$RegExpPrototypeTest(expected[key], actual[key])) return;
            $7d7a23f7babfddb7$var$compareExceptionKey(actual, expected, key, msg, keys, fn);
        });
        return true;
    }
    // Guard instanceof against arrow functions as they don't have a prototype.
    if (expected.prototype !== undefined && actual instanceof expected) return true;
    if (Error.isPrototypeOf(expected)) return false;
    return expected.call({}, actual) === true;
}
function $7d7a23f7babfddb7$var$getActual(fn) {
    if (typeof fn !== "function") throw new $7d7a23f7babfddb7$var$ERR_INVALID_ARG_TYPE("fn", "Function", fn);
    try {
        fn();
    } catch (e) {
        return e;
    }
    return $7d7a23f7babfddb7$var$NO_EXCEPTION_SENTINEL;
}
function $7d7a23f7babfddb7$var$checkIsPromise(obj) {
    // Accept native ES6 promises and promises that are implemented in a similar
    // way. Do not accept thenables that use a function as `obj` and that have no
    // `catch` handler.
    // TODO: thenables are checked up until they have the correct methods,
    // but according to documentation, the `then` method should receive
    // the `fulfill` and `reject` arguments as well or it may be never resolved.
    return $7d7a23f7babfddb7$var$isPromise(obj) || obj !== null && $7d7a23f7babfddb7$var$_typeof(obj) === "object" && typeof obj.then === "function" && typeof obj.catch === "function";
}
function $7d7a23f7babfddb7$var$waitForActual(promiseFn) {
    return Promise.resolve().then(function() {
        var resultPromise;
        if (typeof promiseFn === "function") {
            // Return a rejected promise if `promiseFn` throws synchronously.
            resultPromise = promiseFn();
            // Fail in case no promise is returned.
            if (!$7d7a23f7babfddb7$var$checkIsPromise(resultPromise)) throw new $7d7a23f7babfddb7$var$ERR_INVALID_RETURN_VALUE("instance of Promise", "promiseFn", resultPromise);
        } else if ($7d7a23f7babfddb7$var$checkIsPromise(promiseFn)) resultPromise = promiseFn;
        else throw new $7d7a23f7babfddb7$var$ERR_INVALID_ARG_TYPE("promiseFn", [
            "Function",
            "Promise"
        ], promiseFn);
        return Promise.resolve().then(function() {
            return resultPromise;
        }).then(function() {
            return $7d7a23f7babfddb7$var$NO_EXCEPTION_SENTINEL;
        }).catch(function(e) {
            return e;
        });
    });
}
function $7d7a23f7babfddb7$var$expectsError(stackStartFn, actual, error, message) {
    if (typeof error === "string") {
        if (arguments.length === 4) throw new $7d7a23f7babfddb7$var$ERR_INVALID_ARG_TYPE("error", [
            "Object",
            "Error",
            "Function",
            "RegExp"
        ], error);
        if ($7d7a23f7babfddb7$var$_typeof(actual) === "object" && actual !== null) {
            if (actual.message === error) throw new $7d7a23f7babfddb7$var$ERR_AMBIGUOUS_ARGUMENT("error/message", 'The error message "'.concat(actual.message, '" is identical to the message.'));
        } else if (actual === error) throw new $7d7a23f7babfddb7$var$ERR_AMBIGUOUS_ARGUMENT("error/message", 'The error "'.concat(actual, '" is identical to the message.'));
        message = error;
        error = undefined;
    } else if (error != null && $7d7a23f7babfddb7$var$_typeof(error) !== "object" && typeof error !== "function") throw new $7d7a23f7babfddb7$var$ERR_INVALID_ARG_TYPE("error", [
        "Object",
        "Error",
        "Function",
        "RegExp"
    ], error);
    if (actual === $7d7a23f7babfddb7$var$NO_EXCEPTION_SENTINEL) {
        var details = "";
        if (error && error.name) details += " (".concat(error.name, ")");
        details += message ? ": ".concat(message) : ".";
        var fnType = stackStartFn.name === "rejects" ? "rejection" : "exception";
        $7d7a23f7babfddb7$var$innerFail({
            actual: undefined,
            expected: error,
            operator: stackStartFn.name,
            message: "Missing expected ".concat(fnType).concat(details),
            stackStartFn: stackStartFn
        });
    }
    if (error && !$7d7a23f7babfddb7$var$expectedException(actual, error, message, stackStartFn)) throw actual;
}
function $7d7a23f7babfddb7$var$expectsNoError(stackStartFn, actual, error, message) {
    if (actual === $7d7a23f7babfddb7$var$NO_EXCEPTION_SENTINEL) return;
    if (typeof error === "string") {
        message = error;
        error = undefined;
    }
    if (!error || $7d7a23f7babfddb7$var$expectedException(actual, error)) {
        var details = message ? ": ".concat(message) : ".";
        var fnType = stackStartFn.name === "doesNotReject" ? "rejection" : "exception";
        $7d7a23f7babfddb7$var$innerFail({
            actual: actual,
            expected: error,
            operator: stackStartFn.name,
            message: "Got unwanted ".concat(fnType).concat(details, "\n") + 'Actual message: "'.concat(actual && actual.message, '"'),
            stackStartFn: stackStartFn
        });
    }
    throw actual;
}
$7d7a23f7babfddb7$var$assert.throws = function throws(promiseFn) {
    for(var _len2 = arguments.length, args = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++)args[_key2 - 1] = arguments[_key2];
    $7d7a23f7babfddb7$var$expectsError.apply(void 0, [
        throws,
        $7d7a23f7babfddb7$var$getActual(promiseFn)
    ].concat(args));
};
$7d7a23f7babfddb7$var$assert.rejects = function rejects(promiseFn) {
    for(var _len3 = arguments.length, args = new Array(_len3 > 1 ? _len3 - 1 : 0), _key3 = 1; _key3 < _len3; _key3++)args[_key3 - 1] = arguments[_key3];
    return $7d7a23f7babfddb7$var$waitForActual(promiseFn).then(function(result) {
        return $7d7a23f7babfddb7$var$expectsError.apply(void 0, [
            rejects,
            result
        ].concat(args));
    });
};
$7d7a23f7babfddb7$var$assert.doesNotThrow = function doesNotThrow(fn) {
    for(var _len4 = arguments.length, args = new Array(_len4 > 1 ? _len4 - 1 : 0), _key4 = 1; _key4 < _len4; _key4++)args[_key4 - 1] = arguments[_key4];
    $7d7a23f7babfddb7$var$expectsNoError.apply(void 0, [
        doesNotThrow,
        $7d7a23f7babfddb7$var$getActual(fn)
    ].concat(args));
};
$7d7a23f7babfddb7$var$assert.doesNotReject = function doesNotReject(fn) {
    for(var _len5 = arguments.length, args = new Array(_len5 > 1 ? _len5 - 1 : 0), _key5 = 1; _key5 < _len5; _key5++)args[_key5 - 1] = arguments[_key5];
    return $7d7a23f7babfddb7$var$waitForActual(fn).then(function(result) {
        return $7d7a23f7babfddb7$var$expectsNoError.apply(void 0, [
            doesNotReject,
            result
        ].concat(args));
    });
};
$7d7a23f7babfddb7$var$assert.ifError = function ifError(err) {
    if (err !== null && err !== undefined) {
        var message = "ifError got unwanted exception: ";
        if ($7d7a23f7babfddb7$var$_typeof(err) === "object" && typeof err.message === "string") {
            if (err.message.length === 0 && err.constructor) message += err.constructor.name;
            else message += err.message;
        } else message += $7d7a23f7babfddb7$var$inspect(err);
        var newErr = new $8pS6q({
            actual: err,
            expected: null,
            operator: "ifError",
            message: message,
            stackStartFn: ifError
        });
        // Make sure we actually have a stack trace!
        var origStack = err.stack;
        if (typeof origStack === "string") {
            // This will remove any duplicated frames from the error frames taken
            // from within `ifError` and add the original error frames to the newly
            // created ones.
            var tmp2 = origStack.split("\n");
            tmp2.shift();
            // Filter all frames existing in err.stack.
            var tmp1 = newErr.stack.split("\n");
            for(var i = 0; i < tmp2.length; i++){
                // Find the first occurrence of the frame.
                var pos = tmp1.indexOf(tmp2[i]);
                if (pos !== -1) {
                    // Only keep new frames.
                    tmp1 = tmp1.slice(0, pos);
                    break;
                }
            }
            newErr.stack = "".concat(tmp1.join("\n"), "\n").concat(tmp2.join("\n"));
        }
        throw newErr;
    }
};
// Currently in sync with Node.js lib/assert.js
// https://github.com/nodejs/node/commit/2a871df3dfb8ea663ef5e1f8f62701ec51384ecb
function $7d7a23f7babfddb7$var$internalMatch(string, regexp, message, fn, fnName) {
    if (!$7d7a23f7babfddb7$var$isRegExp(regexp)) throw new $7d7a23f7babfddb7$var$ERR_INVALID_ARG_TYPE("regexp", "RegExp", regexp);
    var match = fnName === "match";
    if (typeof string !== "string" || $7d7a23f7babfddb7$var$RegExpPrototypeTest(regexp, string) !== match) {
        if (message instanceof Error) throw message;
        var generatedMessage = !message;
        // 'The input was expected to not match the regular expression ' +
        message = message || (typeof string !== "string" ? 'The "string" argument must be of type string. Received type ' + "".concat($7d7a23f7babfddb7$var$_typeof(string), " (").concat($7d7a23f7babfddb7$var$inspect(string), ")") : (match ? "The input did not match the regular expression " : "The input was expected to not match the regular expression ") + "".concat($7d7a23f7babfddb7$var$inspect(regexp), ". Input:\n\n").concat($7d7a23f7babfddb7$var$inspect(string), "\n"));
        var err = new $8pS6q({
            actual: string,
            expected: regexp,
            message: message,
            operator: fnName,
            stackStartFn: fn
        });
        err.generatedMessage = generatedMessage;
        throw err;
    }
}
$7d7a23f7babfddb7$var$assert.match = function match(string, regexp, message) {
    $7d7a23f7babfddb7$var$internalMatch(string, regexp, message, match, "match");
};
$7d7a23f7babfddb7$var$assert.doesNotMatch = function doesNotMatch(string, regexp, message) {
    $7d7a23f7babfddb7$var$internalMatch(string, regexp, message, doesNotMatch, "doesNotMatch");
};
// Expose a strict only variant of assert
function $7d7a23f7babfddb7$var$strict() {
    for(var _len6 = arguments.length, args = new Array(_len6), _key6 = 0; _key6 < _len6; _key6++)args[_key6] = arguments[_key6];
    $7d7a23f7babfddb7$var$innerOk.apply(void 0, [
        $7d7a23f7babfddb7$var$strict,
        args.length
    ].concat(args));
}
$7d7a23f7babfddb7$var$assert.strict = $7d7a23f7babfddb7$var$objectAssign($7d7a23f7babfddb7$var$strict, $7d7a23f7babfddb7$var$assert, {
    equal: $7d7a23f7babfddb7$var$assert.strictEqual,
    deepEqual: $7d7a23f7babfddb7$var$assert.deepStrictEqual,
    notEqual: $7d7a23f7babfddb7$var$assert.notStrictEqual,
    notDeepEqual: $7d7a23f7babfddb7$var$assert.notDeepStrictEqual
});
$7d7a23f7babfddb7$var$assert.strict.strict = $7d7a23f7babfddb7$var$assert.strict;

});
parcelRegister("hPtJY", function(module, exports) {
// shim for using process in browser
var $cfae44f0dfdf62c0$var$process = module.exports = {};
// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.
var $cfae44f0dfdf62c0$var$cachedSetTimeout;
var $cfae44f0dfdf62c0$var$cachedClearTimeout;
function $cfae44f0dfdf62c0$var$defaultSetTimout() {
    throw new Error("setTimeout has not been defined");
}
function $cfae44f0dfdf62c0$var$defaultClearTimeout() {
    throw new Error("clearTimeout has not been defined");
}
(function() {
    try {
        if (typeof setTimeout === "function") $cfae44f0dfdf62c0$var$cachedSetTimeout = setTimeout;
        else $cfae44f0dfdf62c0$var$cachedSetTimeout = $cfae44f0dfdf62c0$var$defaultSetTimout;
    } catch (e) {
        $cfae44f0dfdf62c0$var$cachedSetTimeout = $cfae44f0dfdf62c0$var$defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === "function") $cfae44f0dfdf62c0$var$cachedClearTimeout = clearTimeout;
        else $cfae44f0dfdf62c0$var$cachedClearTimeout = $cfae44f0dfdf62c0$var$defaultClearTimeout;
    } catch (e) {
        $cfae44f0dfdf62c0$var$cachedClearTimeout = $cfae44f0dfdf62c0$var$defaultClearTimeout;
    }
})();
function $cfae44f0dfdf62c0$var$runTimeout(fun) {
    if ($cfae44f0dfdf62c0$var$cachedSetTimeout === setTimeout) //normal enviroments in sane situations
    return setTimeout(fun, 0);
    // if setTimeout wasn't available but was latter defined
    if (($cfae44f0dfdf62c0$var$cachedSetTimeout === $cfae44f0dfdf62c0$var$defaultSetTimout || !$cfae44f0dfdf62c0$var$cachedSetTimeout) && setTimeout) {
        $cfae44f0dfdf62c0$var$cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return $cfae44f0dfdf62c0$var$cachedSetTimeout(fun, 0);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return $cfae44f0dfdf62c0$var$cachedSetTimeout.call(null, fun, 0);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return $cfae44f0dfdf62c0$var$cachedSetTimeout.call(this, fun, 0);
        }
    }
}
function $cfae44f0dfdf62c0$var$runClearTimeout(marker) {
    if ($cfae44f0dfdf62c0$var$cachedClearTimeout === clearTimeout) //normal enviroments in sane situations
    return clearTimeout(marker);
    // if clearTimeout wasn't available but was latter defined
    if (($cfae44f0dfdf62c0$var$cachedClearTimeout === $cfae44f0dfdf62c0$var$defaultClearTimeout || !$cfae44f0dfdf62c0$var$cachedClearTimeout) && clearTimeout) {
        $cfae44f0dfdf62c0$var$cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return $cfae44f0dfdf62c0$var$cachedClearTimeout(marker);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return $cfae44f0dfdf62c0$var$cachedClearTimeout.call(null, marker);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return $cfae44f0dfdf62c0$var$cachedClearTimeout.call(this, marker);
        }
    }
}
var $cfae44f0dfdf62c0$var$queue = [];
var $cfae44f0dfdf62c0$var$draining = false;
var $cfae44f0dfdf62c0$var$currentQueue;
var $cfae44f0dfdf62c0$var$queueIndex = -1;
function $cfae44f0dfdf62c0$var$cleanUpNextTick() {
    if (!$cfae44f0dfdf62c0$var$draining || !$cfae44f0dfdf62c0$var$currentQueue) return;
    $cfae44f0dfdf62c0$var$draining = false;
    if ($cfae44f0dfdf62c0$var$currentQueue.length) $cfae44f0dfdf62c0$var$queue = $cfae44f0dfdf62c0$var$currentQueue.concat($cfae44f0dfdf62c0$var$queue);
    else $cfae44f0dfdf62c0$var$queueIndex = -1;
    if ($cfae44f0dfdf62c0$var$queue.length) $cfae44f0dfdf62c0$var$drainQueue();
}
function $cfae44f0dfdf62c0$var$drainQueue() {
    if ($cfae44f0dfdf62c0$var$draining) return;
    var timeout = $cfae44f0dfdf62c0$var$runTimeout($cfae44f0dfdf62c0$var$cleanUpNextTick);
    $cfae44f0dfdf62c0$var$draining = true;
    var len = $cfae44f0dfdf62c0$var$queue.length;
    while(len){
        $cfae44f0dfdf62c0$var$currentQueue = $cfae44f0dfdf62c0$var$queue;
        $cfae44f0dfdf62c0$var$queue = [];
        while(++$cfae44f0dfdf62c0$var$queueIndex < len)if ($cfae44f0dfdf62c0$var$currentQueue) $cfae44f0dfdf62c0$var$currentQueue[$cfae44f0dfdf62c0$var$queueIndex].run();
        $cfae44f0dfdf62c0$var$queueIndex = -1;
        len = $cfae44f0dfdf62c0$var$queue.length;
    }
    $cfae44f0dfdf62c0$var$currentQueue = null;
    $cfae44f0dfdf62c0$var$draining = false;
    $cfae44f0dfdf62c0$var$runClearTimeout(timeout);
}
$cfae44f0dfdf62c0$var$process.nextTick = function(fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) for(var i = 1; i < arguments.length; i++)args[i - 1] = arguments[i];
    $cfae44f0dfdf62c0$var$queue.push(new $cfae44f0dfdf62c0$var$Item(fun, args));
    if ($cfae44f0dfdf62c0$var$queue.length === 1 && !$cfae44f0dfdf62c0$var$draining) $cfae44f0dfdf62c0$var$runTimeout($cfae44f0dfdf62c0$var$drainQueue);
};
// v8 likes predictible objects
function $cfae44f0dfdf62c0$var$Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
$cfae44f0dfdf62c0$var$Item.prototype.run = function() {
    this.fun.apply(null, this.array);
};
$cfae44f0dfdf62c0$var$process.title = "browser";
$cfae44f0dfdf62c0$var$process.browser = true;
$cfae44f0dfdf62c0$var$process.env = {};
$cfae44f0dfdf62c0$var$process.argv = [];
$cfae44f0dfdf62c0$var$process.version = ""; // empty string to avoid regexp issues
$cfae44f0dfdf62c0$var$process.versions = {};
function $cfae44f0dfdf62c0$var$noop() {}
$cfae44f0dfdf62c0$var$process.on = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.addListener = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.once = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.off = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.removeListener = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.removeAllListeners = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.emit = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.prependListener = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.prependOnceListener = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.listeners = function(name) {
    return [];
};
$cfae44f0dfdf62c0$var$process.binding = function(name) {
    throw new Error("process.binding is not supported");
};
$cfae44f0dfdf62c0$var$process.cwd = function() {
    return "/";
};
$cfae44f0dfdf62c0$var$process.chdir = function(dir) {
    throw new Error("process.chdir is not supported");
};
$cfae44f0dfdf62c0$var$process.umask = function() {
    return 0;
};

});

parcelRegister("cCihK", function(module, exports) {

$parcel$export(module.exports, "codes", () => $92f737b1c63f6b54$export$e45cb6485273080e, (v) => $92f737b1c63f6b54$export$e45cb6485273080e = v);
// Currently in sync with Node.js lib/internal/errors.js
// https://github.com/nodejs/node/commit/3b044962c48fe313905877a96b5d0894a5404f6f
/* eslint node-core/documented-errors: "error" */ /* eslint node-core/alphabetize-errors: "error" */ /* eslint node-core/prefer-util-format-errors: "error" */ var $92f737b1c63f6b54$export$e45cb6485273080e;
"use strict";
// The whole point behind this internal module is to allow Node.js to no
// longer be forced to treat every error message change as a semver-major
// change. The NodeError classes here all expose a `code` property whose
// value statically and permanently identifies the error. While the error
// message may change, the code should not.
function $92f737b1c63f6b54$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $92f737b1c63f6b54$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $92f737b1c63f6b54$var$_typeof(o);
}
function $92f737b1c63f6b54$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, $92f737b1c63f6b54$var$_toPropertyKey(descriptor.key), descriptor);
    }
}
function $92f737b1c63f6b54$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $92f737b1c63f6b54$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $92f737b1c63f6b54$var$_defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}
function $92f737b1c63f6b54$var$_toPropertyKey(arg) {
    var key = $92f737b1c63f6b54$var$_toPrimitive(arg, "string");
    return $92f737b1c63f6b54$var$_typeof(key) === "symbol" ? key : String(key);
}
function $92f737b1c63f6b54$var$_toPrimitive(input, hint) {
    if ($92f737b1c63f6b54$var$_typeof(input) !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if ($92f737b1c63f6b54$var$_typeof(res) !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
function $92f737b1c63f6b54$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $92f737b1c63f6b54$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    Object.defineProperty(subClass, "prototype", {
        writable: false
    });
    if (superClass) $92f737b1c63f6b54$var$_setPrototypeOf(subClass, superClass);
}
function $92f737b1c63f6b54$var$_setPrototypeOf(o, p) {
    $92f737b1c63f6b54$var$_setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $92f737b1c63f6b54$var$_setPrototypeOf(o, p);
}
function $92f737b1c63f6b54$var$_createSuper(Derived) {
    var hasNativeReflectConstruct = $92f737b1c63f6b54$var$_isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = $92f737b1c63f6b54$var$_getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = $92f737b1c63f6b54$var$_getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return $92f737b1c63f6b54$var$_possibleConstructorReturn(this, result);
    };
}
function $92f737b1c63f6b54$var$_possibleConstructorReturn(self, call) {
    if (call && ($92f737b1c63f6b54$var$_typeof(call) === "object" || typeof call === "function")) return call;
    else if (call !== void 0) throw new TypeError("Derived constructors may only return object or undefined");
    return $92f737b1c63f6b54$var$_assertThisInitialized(self);
}
function $92f737b1c63f6b54$var$_assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function $92f737b1c63f6b54$var$_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function $92f737b1c63f6b54$var$_getPrototypeOf(o) {
    $92f737b1c63f6b54$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $92f737b1c63f6b54$var$_getPrototypeOf(o);
}
var $92f737b1c63f6b54$var$codes = {};
// Lazy loaded
var $92f737b1c63f6b54$var$assert;
var $92f737b1c63f6b54$var$util;
function $92f737b1c63f6b54$var$createErrorType(code, message, Base) {
    if (!Base) Base = Error;
    function getMessage(arg1, arg2, arg3) {
        if (typeof message === "string") return message;
        else return message(arg1, arg2, arg3);
    }
    var NodeError = /*#__PURE__*/ function(_Base) {
        $92f737b1c63f6b54$var$_inherits(NodeError, _Base);
        var _super = $92f737b1c63f6b54$var$_createSuper(NodeError);
        function NodeError(arg1, arg2, arg3) {
            var _this;
            $92f737b1c63f6b54$var$_classCallCheck(this, NodeError);
            _this = _super.call(this, getMessage(arg1, arg2, arg3));
            _this.code = code;
            return _this;
        }
        return $92f737b1c63f6b54$var$_createClass(NodeError);
    }(Base);
    $92f737b1c63f6b54$var$codes[code] = NodeError;
}
// https://github.com/nodejs/node/blob/v10.8.0/lib/internal/errors.js
function $92f737b1c63f6b54$var$oneOf(expected, thing) {
    if (Array.isArray(expected)) {
        var len = expected.length;
        expected = expected.map(function(i) {
            return String(i);
        });
        if (len > 2) return "one of ".concat(thing, " ").concat(expected.slice(0, len - 1).join(", "), ", or ") + expected[len - 1];
        else if (len === 2) return "one of ".concat(thing, " ").concat(expected[0], " or ").concat(expected[1]);
        else return "of ".concat(thing, " ").concat(expected[0]);
    } else return "of ".concat(thing, " ").concat(String(expected));
}
// https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/String/startsWith
function $92f737b1c63f6b54$var$startsWith(str, search, pos) {
    return str.substr(!pos || pos < 0 ? 0 : +pos, search.length) === search;
}
// https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/String/endsWith
function $92f737b1c63f6b54$var$endsWith(str, search, this_len) {
    if (this_len === undefined || this_len > str.length) this_len = str.length;
    return str.substring(this_len - search.length, this_len) === search;
}
// https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/String/includes
function $92f737b1c63f6b54$var$includes(str, search, start) {
    if (typeof start !== "number") start = 0;
    if (start + search.length > str.length) return false;
    else return str.indexOf(search, start) !== -1;
}
$92f737b1c63f6b54$var$createErrorType("ERR_AMBIGUOUS_ARGUMENT", 'The "%s" argument is ambiguous. %s', TypeError);

$92f737b1c63f6b54$var$createErrorType("ERR_INVALID_ARG_TYPE", function(name, expected, actual) {
    if ($92f737b1c63f6b54$var$assert === undefined) $92f737b1c63f6b54$var$assert = (parcelRequire("aLUwE"));
    $92f737b1c63f6b54$var$assert(typeof name === "string", "'name' must be a string");
    // determiner: 'must be' or 'must not be'
    var determiner;
    if (typeof expected === "string" && $92f737b1c63f6b54$var$startsWith(expected, "not ")) {
        determiner = "must not be";
        expected = expected.replace(/^not /, "");
    } else determiner = "must be";
    var msg;
    if ($92f737b1c63f6b54$var$endsWith(name, " argument")) // For cases like 'first argument'
    msg = "The ".concat(name, " ").concat(determiner, " ").concat($92f737b1c63f6b54$var$oneOf(expected, "type"));
    else {
        var type = $92f737b1c63f6b54$var$includes(name, ".") ? "property" : "argument";
        msg = 'The "'.concat(name, '" ').concat(type, " ").concat(determiner, " ").concat($92f737b1c63f6b54$var$oneOf(expected, "type"));
    }
    // TODO(BridgeAR): Improve the output by showing `null` and similar.
    msg += ". Received type ".concat($92f737b1c63f6b54$var$_typeof(actual));
    return msg;
}, TypeError);

$92f737b1c63f6b54$var$createErrorType("ERR_INVALID_ARG_VALUE", function(name, value) {
    var reason = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : "is invalid";
    if ($92f737b1c63f6b54$var$util === undefined) $92f737b1c63f6b54$var$util = (parcelRequire("N7Lcz"));
    var inspected = $92f737b1c63f6b54$var$util.inspect(value);
    if (inspected.length > 128) inspected = "".concat(inspected.slice(0, 128), "...");
    return "The argument '".concat(name, "' ").concat(reason, ". Received ").concat(inspected);
}, TypeError, RangeError);
$92f737b1c63f6b54$var$createErrorType("ERR_INVALID_RETURN_VALUE", function(input, name, value) {
    var type;
    if (value && value.constructor && value.constructor.name) type = "instance of ".concat(value.constructor.name);
    else type = "type ".concat($92f737b1c63f6b54$var$_typeof(value));
    return "Expected ".concat(input, ' to be returned from the "').concat(name, '"') + " function but got ".concat(type, ".");
}, TypeError);

$92f737b1c63f6b54$var$createErrorType("ERR_MISSING_ARGS", function() {
    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
    if ($92f737b1c63f6b54$var$assert === undefined) $92f737b1c63f6b54$var$assert = (parcelRequire("aLUwE"));
    $92f737b1c63f6b54$var$assert(args.length > 0, "At least one arg needs to be specified");
    var msg = "The ";
    var len = args.length;
    args = args.map(function(a) {
        return '"'.concat(a, '"');
    });
    switch(len){
        case 1:
            msg += "".concat(args[0], " argument");
            break;
        case 2:
            msg += "".concat(args[0], " and ").concat(args[1], " arguments");
            break;
        default:
            msg += args.slice(0, len - 1).join(", ");
            msg += ", and ".concat(args[len - 1], " arguments");
            break;
    }
    return "".concat(msg, " must be specified");
}, TypeError);
$92f737b1c63f6b54$export$e45cb6485273080e = $92f737b1c63f6b54$var$codes;

});
parcelRegister("N7Lcz", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.

var $hPtJY = parcelRequire("hPtJY");
var $093a98c17cb6b6b8$var$getOwnPropertyDescriptors = Object.getOwnPropertyDescriptors || function getOwnPropertyDescriptors(obj) {
    var keys = Object.keys(obj);
    var descriptors = {};
    for(var i = 0; i < keys.length; i++)descriptors[keys[i]] = Object.getOwnPropertyDescriptor(obj, keys[i]);
    return descriptors;
};
var $093a98c17cb6b6b8$var$formatRegExp = /%[sdj%]/g;
module.exports.format = function(f) {
    if (!$093a98c17cb6b6b8$var$isString(f)) {
        var objects = [];
        for(var i = 0; i < arguments.length; i++)objects.push($093a98c17cb6b6b8$var$inspect(arguments[i]));
        return objects.join(" ");
    }
    var i = 1;
    var args = arguments;
    var len = args.length;
    var str = String(f).replace($093a98c17cb6b6b8$var$formatRegExp, function(x) {
        if (x === "%%") return "%";
        if (i >= len) return x;
        switch(x){
            case "%s":
                return String(args[i++]);
            case "%d":
                return Number(args[i++]);
            case "%j":
                try {
                    return JSON.stringify(args[i++]);
                } catch (_) {
                    return "[Circular]";
                }
            default:
                return x;
        }
    });
    for(var x = args[i]; i < len; x = args[++i])if ($093a98c17cb6b6b8$var$isNull(x) || !$093a98c17cb6b6b8$var$isObject(x)) str += " " + x;
    else str += " " + $093a98c17cb6b6b8$var$inspect(x);
    return str;
};
// Mark that a method should not be used.
// Returns a modified function which warns once by default.
// If --no-deprecation is set, then it is a no-op.
module.exports.deprecate = function(fn, msg) {
    if (typeof $hPtJY !== "undefined" && $hPtJY.noDeprecation === true) return fn;
    // Allow for deprecating things in the process of starting up.
    if (typeof $hPtJY === "undefined") return function() {
        return module.exports.deprecate(fn, msg).apply(this, arguments);
    };
    var warned = false;
    function deprecated() {
        if (!warned) {
            if ($hPtJY.throwDeprecation) throw new Error(msg);
            else if ($hPtJY.traceDeprecation) console.trace(msg);
            else console.error(msg);
            warned = true;
        }
        return fn.apply(this, arguments);
    }
    return deprecated;
};
var $093a98c17cb6b6b8$var$debugs = {};
var $093a98c17cb6b6b8$var$debugEnvRegex = /^$/;
var $093a98c17cb6b6b8$var$debugEnv;
module.exports.debuglog = function(set) {
    set = set.toUpperCase();
    if (!$093a98c17cb6b6b8$var$debugs[set]) {
        if ($093a98c17cb6b6b8$var$debugEnvRegex.test(set)) {
            var pid = $hPtJY.pid;
            $093a98c17cb6b6b8$var$debugs[set] = function() {
                var msg = module.exports.format.apply(module.exports, arguments);
                console.error("%s %d: %s", set, pid, msg);
            };
        } else $093a98c17cb6b6b8$var$debugs[set] = function() {};
    }
    return $093a98c17cb6b6b8$var$debugs[set];
};
/**
 * Echos the value of a value. Trys to print the value out
 * in the best way possible given the different types.
 *
 * @param {Object} obj The object to print out.
 * @param {Object} opts Optional options object that alters the output.
 */ /* legacy: obj, showHidden, depth, colors*/ function $093a98c17cb6b6b8$var$inspect(obj, opts) {
    // default options
    var ctx = {
        seen: [],
        stylize: $093a98c17cb6b6b8$var$stylizeNoColor
    };
    // legacy...
    if (arguments.length >= 3) ctx.depth = arguments[2];
    if (arguments.length >= 4) ctx.colors = arguments[3];
    if ($093a98c17cb6b6b8$var$isBoolean(opts)) // legacy...
    ctx.showHidden = opts;
    else if (opts) // got an "options" object
    module.exports._extend(ctx, opts);
    // set default options
    if ($093a98c17cb6b6b8$var$isUndefined(ctx.showHidden)) ctx.showHidden = false;
    if ($093a98c17cb6b6b8$var$isUndefined(ctx.depth)) ctx.depth = 2;
    if ($093a98c17cb6b6b8$var$isUndefined(ctx.colors)) ctx.colors = false;
    if ($093a98c17cb6b6b8$var$isUndefined(ctx.customInspect)) ctx.customInspect = true;
    if (ctx.colors) ctx.stylize = $093a98c17cb6b6b8$var$stylizeWithColor;
    return $093a98c17cb6b6b8$var$formatValue(ctx, obj, ctx.depth);
}
module.exports.inspect = $093a98c17cb6b6b8$var$inspect;
// http://en.wikipedia.org/wiki/ANSI_escape_code#graphics
$093a98c17cb6b6b8$var$inspect.colors = {
    "bold": [
        1,
        22
    ],
    "italic": [
        3,
        23
    ],
    "underline": [
        4,
        24
    ],
    "inverse": [
        7,
        27
    ],
    "white": [
        37,
        39
    ],
    "grey": [
        90,
        39
    ],
    "black": [
        30,
        39
    ],
    "blue": [
        34,
        39
    ],
    "cyan": [
        36,
        39
    ],
    "green": [
        32,
        39
    ],
    "magenta": [
        35,
        39
    ],
    "red": [
        31,
        39
    ],
    "yellow": [
        33,
        39
    ]
};
// Don't use 'blue' not visible on cmd.exe
$093a98c17cb6b6b8$var$inspect.styles = {
    "special": "cyan",
    "number": "yellow",
    "boolean": "yellow",
    "undefined": "grey",
    "null": "bold",
    "string": "green",
    "date": "magenta",
    // "name": intentionally not styling
    "regexp": "red"
};
function $093a98c17cb6b6b8$var$stylizeWithColor(str, styleType) {
    var style = $093a98c17cb6b6b8$var$inspect.styles[styleType];
    if (style) return "\x1b[" + $093a98c17cb6b6b8$var$inspect.colors[style][0] + "m" + str + "\x1b[" + $093a98c17cb6b6b8$var$inspect.colors[style][1] + "m";
    else return str;
}
function $093a98c17cb6b6b8$var$stylizeNoColor(str, styleType) {
    return str;
}
function $093a98c17cb6b6b8$var$arrayToHash(array) {
    var hash = {};
    array.forEach(function(val, idx) {
        hash[val] = true;
    });
    return hash;
}
function $093a98c17cb6b6b8$var$formatValue(ctx, value, recurseTimes) {
    // Provide a hook for user-specified inspect functions.
    // Check that value is an object with an inspect function on it
    if (ctx.customInspect && value && $093a98c17cb6b6b8$var$isFunction(value.inspect) && // Filter out the util module, it's inspect function is special
    value.inspect !== module.exports.inspect && // Also filter out any prototype objects using the circular check.
    !(value.constructor && value.constructor.prototype === value)) {
        var ret = value.inspect(recurseTimes, ctx);
        if (!$093a98c17cb6b6b8$var$isString(ret)) ret = $093a98c17cb6b6b8$var$formatValue(ctx, ret, recurseTimes);
        return ret;
    }
    // Primitive types cannot have properties
    var primitive = $093a98c17cb6b6b8$var$formatPrimitive(ctx, value);
    if (primitive) return primitive;
    // Look up the keys of the object.
    var keys = Object.keys(value);
    var visibleKeys = $093a98c17cb6b6b8$var$arrayToHash(keys);
    if (ctx.showHidden) keys = Object.getOwnPropertyNames(value);
    // IE doesn't make error fields non-enumerable
    // http://msdn.microsoft.com/en-us/library/ie/dww52sbt(v=vs.94).aspx
    if ($093a98c17cb6b6b8$var$isError(value) && (keys.indexOf("message") >= 0 || keys.indexOf("description") >= 0)) return $093a98c17cb6b6b8$var$formatError(value);
    // Some type of object without properties can be shortcutted.
    if (keys.length === 0) {
        if ($093a98c17cb6b6b8$var$isFunction(value)) {
            var name = value.name ? ": " + value.name : "";
            return ctx.stylize("[Function" + name + "]", "special");
        }
        if ($093a98c17cb6b6b8$var$isRegExp(value)) return ctx.stylize(RegExp.prototype.toString.call(value), "regexp");
        if ($093a98c17cb6b6b8$var$isDate(value)) return ctx.stylize(Date.prototype.toString.call(value), "date");
        if ($093a98c17cb6b6b8$var$isError(value)) return $093a98c17cb6b6b8$var$formatError(value);
    }
    var base = "", array = false, braces = [
        "{",
        "}"
    ];
    // Make Array say that they are Array
    if ($093a98c17cb6b6b8$var$isArray(value)) {
        array = true;
        braces = [
            "[",
            "]"
        ];
    }
    // Make functions say that they are functions
    if ($093a98c17cb6b6b8$var$isFunction(value)) {
        var n = value.name ? ": " + value.name : "";
        base = " [Function" + n + "]";
    }
    // Make RegExps say that they are RegExps
    if ($093a98c17cb6b6b8$var$isRegExp(value)) base = " " + RegExp.prototype.toString.call(value);
    // Make dates with properties first say the date
    if ($093a98c17cb6b6b8$var$isDate(value)) base = " " + Date.prototype.toUTCString.call(value);
    // Make error with message first say the error
    if ($093a98c17cb6b6b8$var$isError(value)) base = " " + $093a98c17cb6b6b8$var$formatError(value);
    if (keys.length === 0 && (!array || value.length == 0)) return braces[0] + base + braces[1];
    if (recurseTimes < 0) {
        if ($093a98c17cb6b6b8$var$isRegExp(value)) return ctx.stylize(RegExp.prototype.toString.call(value), "regexp");
        else return ctx.stylize("[Object]", "special");
    }
    ctx.seen.push(value);
    var output;
    if (array) output = $093a98c17cb6b6b8$var$formatArray(ctx, value, recurseTimes, visibleKeys, keys);
    else output = keys.map(function(key) {
        return $093a98c17cb6b6b8$var$formatProperty(ctx, value, recurseTimes, visibleKeys, key, array);
    });
    ctx.seen.pop();
    return $093a98c17cb6b6b8$var$reduceToSingleString(output, base, braces);
}
function $093a98c17cb6b6b8$var$formatPrimitive(ctx, value) {
    if ($093a98c17cb6b6b8$var$isUndefined(value)) return ctx.stylize("undefined", "undefined");
    if ($093a98c17cb6b6b8$var$isString(value)) {
        var simple = "'" + JSON.stringify(value).replace(/^"|"$/g, "").replace(/'/g, "\\'").replace(/\\"/g, '"') + "'";
        return ctx.stylize(simple, "string");
    }
    if ($093a98c17cb6b6b8$var$isNumber(value)) return ctx.stylize("" + value, "number");
    if ($093a98c17cb6b6b8$var$isBoolean(value)) return ctx.stylize("" + value, "boolean");
    // For some reason typeof null is "object", so special case here.
    if ($093a98c17cb6b6b8$var$isNull(value)) return ctx.stylize("null", "null");
}
function $093a98c17cb6b6b8$var$formatError(value) {
    return "[" + Error.prototype.toString.call(value) + "]";
}
function $093a98c17cb6b6b8$var$formatArray(ctx, value, recurseTimes, visibleKeys, keys) {
    var output = [];
    for(var i = 0, l = value.length; i < l; ++i)if ($093a98c17cb6b6b8$var$hasOwnProperty(value, String(i))) output.push($093a98c17cb6b6b8$var$formatProperty(ctx, value, recurseTimes, visibleKeys, String(i), true));
    else output.push("");
    keys.forEach(function(key) {
        if (!key.match(/^\d+$/)) output.push($093a98c17cb6b6b8$var$formatProperty(ctx, value, recurseTimes, visibleKeys, key, true));
    });
    return output;
}
function $093a98c17cb6b6b8$var$formatProperty(ctx, value, recurseTimes, visibleKeys, key, array) {
    var name, str, desc;
    desc = Object.getOwnPropertyDescriptor(value, key) || {
        value: value[key]
    };
    if (desc.get) {
        if (desc.set) str = ctx.stylize("[Getter/Setter]", "special");
        else str = ctx.stylize("[Getter]", "special");
    } else if (desc.set) str = ctx.stylize("[Setter]", "special");
    if (!$093a98c17cb6b6b8$var$hasOwnProperty(visibleKeys, key)) name = "[" + key + "]";
    if (!str) {
        if (ctx.seen.indexOf(desc.value) < 0) {
            if ($093a98c17cb6b6b8$var$isNull(recurseTimes)) str = $093a98c17cb6b6b8$var$formatValue(ctx, desc.value, null);
            else str = $093a98c17cb6b6b8$var$formatValue(ctx, desc.value, recurseTimes - 1);
            if (str.indexOf("\n") > -1) {
                if (array) str = str.split("\n").map(function(line) {
                    return "  " + line;
                }).join("\n").slice(2);
                else str = "\n" + str.split("\n").map(function(line) {
                    return "   " + line;
                }).join("\n");
            }
        } else str = ctx.stylize("[Circular]", "special");
    }
    if ($093a98c17cb6b6b8$var$isUndefined(name)) {
        if (array && key.match(/^\d+$/)) return str;
        name = JSON.stringify("" + key);
        if (name.match(/^"([a-zA-Z_][a-zA-Z_0-9]*)"$/)) {
            name = name.slice(1, -1);
            name = ctx.stylize(name, "name");
        } else {
            name = name.replace(/'/g, "\\'").replace(/\\"/g, '"').replace(/(^"|"$)/g, "'");
            name = ctx.stylize(name, "string");
        }
    }
    return name + ": " + str;
}
function $093a98c17cb6b6b8$var$reduceToSingleString(output, base, braces) {
    var numLinesEst = 0;
    var length = output.reduce(function(prev, cur) {
        numLinesEst++;
        if (cur.indexOf("\n") >= 0) numLinesEst++;
        return prev + cur.replace(/\u001b\[\d\d?m/g, "").length + 1;
    }, 0);
    if (length > 60) return braces[0] + (base === "" ? "" : base + "\n ") + " " + output.join(",\n  ") + " " + braces[1];
    return braces[0] + base + " " + output.join(", ") + " " + braces[1];
}

// NOTE: These type checking functions intentionally don't use `instanceof`
// because it is fragile and can be easily faked with `Object.create()`.
module.exports.types = (parcelRequire("7He6T"));
function $093a98c17cb6b6b8$var$isArray(ar) {
    return Array.isArray(ar);
}
module.exports.isArray = $093a98c17cb6b6b8$var$isArray;
function $093a98c17cb6b6b8$var$isBoolean(arg) {
    return typeof arg === "boolean";
}
module.exports.isBoolean = $093a98c17cb6b6b8$var$isBoolean;
function $093a98c17cb6b6b8$var$isNull(arg) {
    return arg === null;
}
module.exports.isNull = $093a98c17cb6b6b8$var$isNull;
function $093a98c17cb6b6b8$var$isNullOrUndefined(arg) {
    return arg == null;
}
module.exports.isNullOrUndefined = $093a98c17cb6b6b8$var$isNullOrUndefined;
function $093a98c17cb6b6b8$var$isNumber(arg) {
    return typeof arg === "number";
}
module.exports.isNumber = $093a98c17cb6b6b8$var$isNumber;
function $093a98c17cb6b6b8$var$isString(arg) {
    return typeof arg === "string";
}
module.exports.isString = $093a98c17cb6b6b8$var$isString;
function $093a98c17cb6b6b8$var$isSymbol(arg) {
    return typeof arg === "symbol";
}
module.exports.isSymbol = $093a98c17cb6b6b8$var$isSymbol;
function $093a98c17cb6b6b8$var$isUndefined(arg) {
    return arg === void 0;
}
module.exports.isUndefined = $093a98c17cb6b6b8$var$isUndefined;
function $093a98c17cb6b6b8$var$isRegExp(re) {
    return $093a98c17cb6b6b8$var$isObject(re) && $093a98c17cb6b6b8$var$objectToString(re) === "[object RegExp]";
}
module.exports.isRegExp = $093a98c17cb6b6b8$var$isRegExp;
module.exports.types.isRegExp = $093a98c17cb6b6b8$var$isRegExp;
function $093a98c17cb6b6b8$var$isObject(arg) {
    return typeof arg === "object" && arg !== null;
}
module.exports.isObject = $093a98c17cb6b6b8$var$isObject;
function $093a98c17cb6b6b8$var$isDate(d) {
    return $093a98c17cb6b6b8$var$isObject(d) && $093a98c17cb6b6b8$var$objectToString(d) === "[object Date]";
}
module.exports.isDate = $093a98c17cb6b6b8$var$isDate;
module.exports.types.isDate = $093a98c17cb6b6b8$var$isDate;
function $093a98c17cb6b6b8$var$isError(e) {
    return $093a98c17cb6b6b8$var$isObject(e) && ($093a98c17cb6b6b8$var$objectToString(e) === "[object Error]" || e instanceof Error);
}
module.exports.isError = $093a98c17cb6b6b8$var$isError;
module.exports.types.isNativeError = $093a98c17cb6b6b8$var$isError;
function $093a98c17cb6b6b8$var$isFunction(arg) {
    return typeof arg === "function";
}
module.exports.isFunction = $093a98c17cb6b6b8$var$isFunction;
function $093a98c17cb6b6b8$var$isPrimitive(arg) {
    return arg === null || typeof arg === "boolean" || typeof arg === "number" || typeof arg === "string" || typeof arg === "symbol" || // ES6 symbol
    typeof arg === "undefined";
}
module.exports.isPrimitive = $093a98c17cb6b6b8$var$isPrimitive;

module.exports.isBuffer = (parcelRequire("kotBY"));
function $093a98c17cb6b6b8$var$objectToString(o) {
    return Object.prototype.toString.call(o);
}
function $093a98c17cb6b6b8$var$pad(n) {
    return n < 10 ? "0" + n.toString(10) : n.toString(10);
}
var $093a98c17cb6b6b8$var$months = [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "Jun",
    "Jul",
    "Aug",
    "Sep",
    "Oct",
    "Nov",
    "Dec"
];
// 26 Feb 16:19:34
function $093a98c17cb6b6b8$var$timestamp() {
    var d = new Date();
    var time = [
        $093a98c17cb6b6b8$var$pad(d.getHours()),
        $093a98c17cb6b6b8$var$pad(d.getMinutes()),
        $093a98c17cb6b6b8$var$pad(d.getSeconds())
    ].join(":");
    return [
        d.getDate(),
        $093a98c17cb6b6b8$var$months[d.getMonth()],
        time
    ].join(" ");
}
// log is just a thin wrapper to console.log that prepends a timestamp
module.exports.log = function() {
    console.log("%s - %s", $093a98c17cb6b6b8$var$timestamp(), module.exports.format.apply(module.exports, arguments));
};

/**
 * Inherit the prototype methods from one constructor into another.
 *
 * The Function.prototype.inherits from lang.js rewritten as a standalone
 * function (not on Function.prototype). NOTE: If this file is to be loaded
 * during bootstrapping this function needs to be rewritten using some native
 * functions as prototype setup using normal JavaScript does not work as
 * expected during bootstrapping (see mirror.js in r114903).
 *
 * @param {function} ctor Constructor function which needs to inherit the
 *     prototype.
 * @param {function} superCtor Constructor function to inherit prototype from.
 */ module.exports.inherits = (parcelRequire("dlqwk"));
module.exports._extend = function(origin, add) {
    // Don't do anything if add isn't an object
    if (!add || !$093a98c17cb6b6b8$var$isObject(add)) return origin;
    var keys = Object.keys(add);
    var i = keys.length;
    while(i--)origin[keys[i]] = add[keys[i]];
    return origin;
};
function $093a98c17cb6b6b8$var$hasOwnProperty(obj, prop) {
    return Object.prototype.hasOwnProperty.call(obj, prop);
}
var $093a98c17cb6b6b8$var$kCustomPromisifiedSymbol = typeof Symbol !== "undefined" ? Symbol("util.promisify.custom") : undefined;
module.exports.promisify = function promisify(original) {
    if (typeof original !== "function") throw new TypeError('The "original" argument must be of type Function');
    if ($093a98c17cb6b6b8$var$kCustomPromisifiedSymbol && original[$093a98c17cb6b6b8$var$kCustomPromisifiedSymbol]) {
        var fn = original[$093a98c17cb6b6b8$var$kCustomPromisifiedSymbol];
        if (typeof fn !== "function") throw new TypeError('The "util.promisify.custom" argument must be of type Function');
        Object.defineProperty(fn, $093a98c17cb6b6b8$var$kCustomPromisifiedSymbol, {
            value: fn,
            enumerable: false,
            writable: false,
            configurable: true
        });
        return fn;
    }
    function fn() {
        var promiseResolve, promiseReject;
        var promise = new Promise(function(resolve, reject) {
            promiseResolve = resolve;
            promiseReject = reject;
        });
        var args = [];
        for(var i = 0; i < arguments.length; i++)args.push(arguments[i]);
        args.push(function(err, value) {
            if (err) promiseReject(err);
            else promiseResolve(value);
        });
        try {
            original.apply(this, args);
        } catch (err) {
            promiseReject(err);
        }
        return promise;
    }
    Object.setPrototypeOf(fn, Object.getPrototypeOf(original));
    if ($093a98c17cb6b6b8$var$kCustomPromisifiedSymbol) Object.defineProperty(fn, $093a98c17cb6b6b8$var$kCustomPromisifiedSymbol, {
        value: fn,
        enumerable: false,
        writable: false,
        configurable: true
    });
    return Object.defineProperties(fn, $093a98c17cb6b6b8$var$getOwnPropertyDescriptors(original));
};
module.exports.promisify.custom = $093a98c17cb6b6b8$var$kCustomPromisifiedSymbol;
function $093a98c17cb6b6b8$var$callbackifyOnRejected(reason, cb) {
    // `!reason` guard inspired by bluebird (Ref: https://goo.gl/t5IS6M).
    // Because `null` is a special error value in callbacks which means "no error
    // occurred", we error-wrap so the callback consumer can distinguish between
    // "the promise rejected with null" or "the promise fulfilled with undefined".
    if (!reason) {
        var newReason = new Error("Promise was rejected with a falsy value");
        newReason.reason = reason;
        reason = newReason;
    }
    return cb(reason);
}
function $093a98c17cb6b6b8$var$callbackify(original) {
    if (typeof original !== "function") throw new TypeError('The "original" argument must be of type Function');
    // We DO NOT return the promise as it gives the user a false sense that
    // the promise is actually somehow related to the callback's execution
    // and that the callback throwing will reject the promise.
    function callbackified() {
        var args = [];
        for(var i = 0; i < arguments.length; i++)args.push(arguments[i]);
        var maybeCb = args.pop();
        if (typeof maybeCb !== "function") throw new TypeError("The last argument must be of type Function");
        var self = this;
        var cb = function() {
            return maybeCb.apply(self, arguments);
        };
        // In true node style we process the callback on `nextTick` with all the
        // implications (stack, `uncaughtException`, `async_hooks`)
        original.apply(this, args).then(function(ret) {
            $hPtJY.nextTick(cb.bind(null, null, ret));
        }, function(rej) {
            $hPtJY.nextTick($093a98c17cb6b6b8$var$callbackifyOnRejected.bind(null, rej, cb));
        });
    }
    Object.setPrototypeOf(callbackified, Object.getPrototypeOf(original));
    Object.defineProperties(callbackified, $093a98c17cb6b6b8$var$getOwnPropertyDescriptors(original));
    return callbackified;
}
module.exports.callbackify = $093a98c17cb6b6b8$var$callbackify;

});
parcelRegister("7He6T", function(module, exports) {
// Currently in sync with Node.js lib/internal/util/types.js
// https://github.com/nodejs/node/commit/112cc7c27551254aa2b17098fb774867f05ed0d9
"use strict";

var $f4HGZ = parcelRequire("f4HGZ");

var $5WnCa = parcelRequire("5WnCa");

var $gJrpv = parcelRequire("gJrpv");

var $hN833 = parcelRequire("hN833");
function $59a77e8886024a57$var$uncurryThis(f) {
    return f.call.bind(f);
}
var $59a77e8886024a57$var$BigIntSupported = typeof BigInt !== "undefined";
var $59a77e8886024a57$var$SymbolSupported = typeof Symbol !== "undefined";
var $59a77e8886024a57$var$ObjectToString = $59a77e8886024a57$var$uncurryThis(Object.prototype.toString);
var $59a77e8886024a57$var$numberValue = $59a77e8886024a57$var$uncurryThis(Number.prototype.valueOf);
var $59a77e8886024a57$var$stringValue = $59a77e8886024a57$var$uncurryThis(String.prototype.valueOf);
var $59a77e8886024a57$var$booleanValue = $59a77e8886024a57$var$uncurryThis(Boolean.prototype.valueOf);
if ($59a77e8886024a57$var$BigIntSupported) var $59a77e8886024a57$var$bigIntValue = $59a77e8886024a57$var$uncurryThis(BigInt.prototype.valueOf);
if ($59a77e8886024a57$var$SymbolSupported) var $59a77e8886024a57$var$symbolValue = $59a77e8886024a57$var$uncurryThis(Symbol.prototype.valueOf);
function $59a77e8886024a57$var$checkBoxedPrimitive(value, prototypeValueOf) {
    if (typeof value !== "object") return false;
    try {
        prototypeValueOf(value);
        return true;
    } catch (e) {
        return false;
    }
}
module.exports.isArgumentsObject = $f4HGZ;
module.exports.isGeneratorFunction = $5WnCa;
module.exports.isTypedArray = $hN833;
// Taken from here and modified for better browser support
// https://github.com/sindresorhus/p-is-promise/blob/cda35a513bda03f977ad5cde3a079d237e82d7ef/index.js
function $59a77e8886024a57$var$isPromise(input) {
    return typeof Promise !== "undefined" && input instanceof Promise || input !== null && typeof input === "object" && typeof input.then === "function" && typeof input.catch === "function";
}
module.exports.isPromise = $59a77e8886024a57$var$isPromise;
function $59a77e8886024a57$var$isArrayBufferView(value) {
    if (typeof ArrayBuffer !== "undefined" && ArrayBuffer.isView) return ArrayBuffer.isView(value);
    return $hN833(value) || $59a77e8886024a57$var$isDataView(value);
}
module.exports.isArrayBufferView = $59a77e8886024a57$var$isArrayBufferView;
function $59a77e8886024a57$var$isUint8Array(value) {
    return $gJrpv(value) === "Uint8Array";
}
module.exports.isUint8Array = $59a77e8886024a57$var$isUint8Array;
function $59a77e8886024a57$var$isUint8ClampedArray(value) {
    return $gJrpv(value) === "Uint8ClampedArray";
}
module.exports.isUint8ClampedArray = $59a77e8886024a57$var$isUint8ClampedArray;
function $59a77e8886024a57$var$isUint16Array(value) {
    return $gJrpv(value) === "Uint16Array";
}
module.exports.isUint16Array = $59a77e8886024a57$var$isUint16Array;
function $59a77e8886024a57$var$isUint32Array(value) {
    return $gJrpv(value) === "Uint32Array";
}
module.exports.isUint32Array = $59a77e8886024a57$var$isUint32Array;
function $59a77e8886024a57$var$isInt8Array(value) {
    return $gJrpv(value) === "Int8Array";
}
module.exports.isInt8Array = $59a77e8886024a57$var$isInt8Array;
function $59a77e8886024a57$var$isInt16Array(value) {
    return $gJrpv(value) === "Int16Array";
}
module.exports.isInt16Array = $59a77e8886024a57$var$isInt16Array;
function $59a77e8886024a57$var$isInt32Array(value) {
    return $gJrpv(value) === "Int32Array";
}
module.exports.isInt32Array = $59a77e8886024a57$var$isInt32Array;
function $59a77e8886024a57$var$isFloat32Array(value) {
    return $gJrpv(value) === "Float32Array";
}
module.exports.isFloat32Array = $59a77e8886024a57$var$isFloat32Array;
function $59a77e8886024a57$var$isFloat64Array(value) {
    return $gJrpv(value) === "Float64Array";
}
module.exports.isFloat64Array = $59a77e8886024a57$var$isFloat64Array;
function $59a77e8886024a57$var$isBigInt64Array(value) {
    return $gJrpv(value) === "BigInt64Array";
}
module.exports.isBigInt64Array = $59a77e8886024a57$var$isBigInt64Array;
function $59a77e8886024a57$var$isBigUint64Array(value) {
    return $gJrpv(value) === "BigUint64Array";
}
module.exports.isBigUint64Array = $59a77e8886024a57$var$isBigUint64Array;
function $59a77e8886024a57$var$isMapToString(value) {
    return $59a77e8886024a57$var$ObjectToString(value) === "[object Map]";
}
$59a77e8886024a57$var$isMapToString.working = typeof Map !== "undefined" && $59a77e8886024a57$var$isMapToString(new Map());
function $59a77e8886024a57$var$isMap(value) {
    if (typeof Map === "undefined") return false;
    return $59a77e8886024a57$var$isMapToString.working ? $59a77e8886024a57$var$isMapToString(value) : value instanceof Map;
}
module.exports.isMap = $59a77e8886024a57$var$isMap;
function $59a77e8886024a57$var$isSetToString(value) {
    return $59a77e8886024a57$var$ObjectToString(value) === "[object Set]";
}
$59a77e8886024a57$var$isSetToString.working = typeof Set !== "undefined" && $59a77e8886024a57$var$isSetToString(new Set());
function $59a77e8886024a57$var$isSet(value) {
    if (typeof Set === "undefined") return false;
    return $59a77e8886024a57$var$isSetToString.working ? $59a77e8886024a57$var$isSetToString(value) : value instanceof Set;
}
module.exports.isSet = $59a77e8886024a57$var$isSet;
function $59a77e8886024a57$var$isWeakMapToString(value) {
    return $59a77e8886024a57$var$ObjectToString(value) === "[object WeakMap]";
}
$59a77e8886024a57$var$isWeakMapToString.working = typeof WeakMap !== "undefined" && $59a77e8886024a57$var$isWeakMapToString(new WeakMap());
function $59a77e8886024a57$var$isWeakMap(value) {
    if (typeof WeakMap === "undefined") return false;
    return $59a77e8886024a57$var$isWeakMapToString.working ? $59a77e8886024a57$var$isWeakMapToString(value) : value instanceof WeakMap;
}
module.exports.isWeakMap = $59a77e8886024a57$var$isWeakMap;
function $59a77e8886024a57$var$isWeakSetToString(value) {
    return $59a77e8886024a57$var$ObjectToString(value) === "[object WeakSet]";
}
$59a77e8886024a57$var$isWeakSetToString.working = typeof WeakSet !== "undefined" && $59a77e8886024a57$var$isWeakSetToString(new WeakSet());
function $59a77e8886024a57$var$isWeakSet(value) {
    return $59a77e8886024a57$var$isWeakSetToString(value);
}
module.exports.isWeakSet = $59a77e8886024a57$var$isWeakSet;
function $59a77e8886024a57$var$isArrayBufferToString(value) {
    return $59a77e8886024a57$var$ObjectToString(value) === "[object ArrayBuffer]";
}
$59a77e8886024a57$var$isArrayBufferToString.working = typeof ArrayBuffer !== "undefined" && $59a77e8886024a57$var$isArrayBufferToString(new ArrayBuffer());
function $59a77e8886024a57$var$isArrayBuffer(value) {
    if (typeof ArrayBuffer === "undefined") return false;
    return $59a77e8886024a57$var$isArrayBufferToString.working ? $59a77e8886024a57$var$isArrayBufferToString(value) : value instanceof ArrayBuffer;
}
module.exports.isArrayBuffer = $59a77e8886024a57$var$isArrayBuffer;
function $59a77e8886024a57$var$isDataViewToString(value) {
    return $59a77e8886024a57$var$ObjectToString(value) === "[object DataView]";
}
$59a77e8886024a57$var$isDataViewToString.working = typeof ArrayBuffer !== "undefined" && typeof DataView !== "undefined" && $59a77e8886024a57$var$isDataViewToString(new DataView(new ArrayBuffer(1), 0, 1));
function $59a77e8886024a57$var$isDataView(value) {
    if (typeof DataView === "undefined") return false;
    return $59a77e8886024a57$var$isDataViewToString.working ? $59a77e8886024a57$var$isDataViewToString(value) : value instanceof DataView;
}
module.exports.isDataView = $59a77e8886024a57$var$isDataView;
// Store a copy of SharedArrayBuffer in case it's deleted elsewhere
var $59a77e8886024a57$var$SharedArrayBufferCopy = typeof SharedArrayBuffer !== "undefined" ? SharedArrayBuffer : undefined;
function $59a77e8886024a57$var$isSharedArrayBufferToString(value) {
    return $59a77e8886024a57$var$ObjectToString(value) === "[object SharedArrayBuffer]";
}
function $59a77e8886024a57$var$isSharedArrayBuffer(value) {
    if (typeof $59a77e8886024a57$var$SharedArrayBufferCopy === "undefined") return false;
    if (typeof $59a77e8886024a57$var$isSharedArrayBufferToString.working === "undefined") $59a77e8886024a57$var$isSharedArrayBufferToString.working = $59a77e8886024a57$var$isSharedArrayBufferToString(new $59a77e8886024a57$var$SharedArrayBufferCopy());
    return $59a77e8886024a57$var$isSharedArrayBufferToString.working ? $59a77e8886024a57$var$isSharedArrayBufferToString(value) : value instanceof $59a77e8886024a57$var$SharedArrayBufferCopy;
}
module.exports.isSharedArrayBuffer = $59a77e8886024a57$var$isSharedArrayBuffer;
function $59a77e8886024a57$var$isAsyncFunction(value) {
    return $59a77e8886024a57$var$ObjectToString(value) === "[object AsyncFunction]";
}
module.exports.isAsyncFunction = $59a77e8886024a57$var$isAsyncFunction;
function $59a77e8886024a57$var$isMapIterator(value) {
    return $59a77e8886024a57$var$ObjectToString(value) === "[object Map Iterator]";
}
module.exports.isMapIterator = $59a77e8886024a57$var$isMapIterator;
function $59a77e8886024a57$var$isSetIterator(value) {
    return $59a77e8886024a57$var$ObjectToString(value) === "[object Set Iterator]";
}
module.exports.isSetIterator = $59a77e8886024a57$var$isSetIterator;
function $59a77e8886024a57$var$isGeneratorObject(value) {
    return $59a77e8886024a57$var$ObjectToString(value) === "[object Generator]";
}
module.exports.isGeneratorObject = $59a77e8886024a57$var$isGeneratorObject;
function $59a77e8886024a57$var$isWebAssemblyCompiledModule(value) {
    return $59a77e8886024a57$var$ObjectToString(value) === "[object WebAssembly.Module]";
}
module.exports.isWebAssemblyCompiledModule = $59a77e8886024a57$var$isWebAssemblyCompiledModule;
function $59a77e8886024a57$var$isNumberObject(value) {
    return $59a77e8886024a57$var$checkBoxedPrimitive(value, $59a77e8886024a57$var$numberValue);
}
module.exports.isNumberObject = $59a77e8886024a57$var$isNumberObject;
function $59a77e8886024a57$var$isStringObject(value) {
    return $59a77e8886024a57$var$checkBoxedPrimitive(value, $59a77e8886024a57$var$stringValue);
}
module.exports.isStringObject = $59a77e8886024a57$var$isStringObject;
function $59a77e8886024a57$var$isBooleanObject(value) {
    return $59a77e8886024a57$var$checkBoxedPrimitive(value, $59a77e8886024a57$var$booleanValue);
}
module.exports.isBooleanObject = $59a77e8886024a57$var$isBooleanObject;
function $59a77e8886024a57$var$isBigIntObject(value) {
    return $59a77e8886024a57$var$BigIntSupported && $59a77e8886024a57$var$checkBoxedPrimitive(value, $59a77e8886024a57$var$bigIntValue);
}
module.exports.isBigIntObject = $59a77e8886024a57$var$isBigIntObject;
function $59a77e8886024a57$var$isSymbolObject(value) {
    return $59a77e8886024a57$var$SymbolSupported && $59a77e8886024a57$var$checkBoxedPrimitive(value, $59a77e8886024a57$var$symbolValue);
}
module.exports.isSymbolObject = $59a77e8886024a57$var$isSymbolObject;
function $59a77e8886024a57$var$isBoxedPrimitive(value) {
    return $59a77e8886024a57$var$isNumberObject(value) || $59a77e8886024a57$var$isStringObject(value) || $59a77e8886024a57$var$isBooleanObject(value) || $59a77e8886024a57$var$isBigIntObject(value) || $59a77e8886024a57$var$isSymbolObject(value);
}
module.exports.isBoxedPrimitive = $59a77e8886024a57$var$isBoxedPrimitive;
function $59a77e8886024a57$var$isAnyArrayBuffer(value) {
    return typeof Uint8Array !== "undefined" && ($59a77e8886024a57$var$isArrayBuffer(value) || $59a77e8886024a57$var$isSharedArrayBuffer(value));
}
module.exports.isAnyArrayBuffer = $59a77e8886024a57$var$isAnyArrayBuffer;
[
    "isProxy",
    "isExternal",
    "isModuleNamespaceObject"
].forEach(function(method) {
    Object.defineProperty(module.exports, method, {
        enumerable: false,
        value: function() {
            throw new Error(method + " is not supported in userland");
        }
    });
});

});
parcelRegister("f4HGZ", function(module, exports) {
"use strict";

var $af991f1d6c80f097$var$hasToStringTag = (parcelRequire("3KyxH"))();

var $hXu6F = parcelRequire("hXu6F");
var $af991f1d6c80f097$var$$toString = $hXu6F("Object.prototype.toString");
var $af991f1d6c80f097$var$isStandardArguments = function isArguments(value) {
    if ($af991f1d6c80f097$var$hasToStringTag && value && typeof value === "object" && Symbol.toStringTag in value) return false;
    return $af991f1d6c80f097$var$$toString(value) === "[object Arguments]";
};
var $af991f1d6c80f097$var$isLegacyArguments = function isArguments(value) {
    if ($af991f1d6c80f097$var$isStandardArguments(value)) return true;
    return value !== null && typeof value === "object" && typeof value.length === "number" && value.length >= 0 && $af991f1d6c80f097$var$$toString(value) !== "[object Array]" && $af991f1d6c80f097$var$$toString(value.callee) === "[object Function]";
};
var $af991f1d6c80f097$var$supportsStandardArguments = function() {
    return $af991f1d6c80f097$var$isStandardArguments(arguments);
}();
$af991f1d6c80f097$var$isStandardArguments.isLegacyArguments = $af991f1d6c80f097$var$isLegacyArguments; // for tests
module.exports = $af991f1d6c80f097$var$supportsStandardArguments ? $af991f1d6c80f097$var$isStandardArguments : $af991f1d6c80f097$var$isLegacyArguments;

});
parcelRegister("3KyxH", function(module, exports) {
"use strict";

var $7YWkK = parcelRequire("7YWkK");
module.exports = function hasToStringTagShams() {
    return $7YWkK() && !!Symbol.toStringTag;
};

});
parcelRegister("7YWkK", function(module, exports) {
"use strict";
/* eslint complexity: [2, 18], max-statements: [2, 33] */ module.exports = function hasSymbols() {
    if (typeof Symbol !== "function" || typeof Object.getOwnPropertySymbols !== "function") return false;
    if (typeof Symbol.iterator === "symbol") return true;
    var obj = {};
    var sym = Symbol("test");
    var symObj = Object(sym);
    if (typeof sym === "string") return false;
    if (Object.prototype.toString.call(sym) !== "[object Symbol]") return false;
    if (Object.prototype.toString.call(symObj) !== "[object Symbol]") return false;
    // temp disabled per https://github.com/ljharb/object.assign/issues/17
    // if (sym instanceof Symbol) { return false; }
    // temp disabled per https://github.com/WebReflection/get-own-property-symbols/issues/4
    // if (!(symObj instanceof Symbol)) { return false; }
    // if (typeof Symbol.prototype.toString !== 'function') { return false; }
    // if (String(sym) !== Symbol.prototype.toString.call(sym)) { return false; }
    var symVal = 42;
    obj[sym] = symVal;
    for(sym in obj)return false;
     // eslint-disable-line no-restricted-syntax, no-unreachable-loop
    if (typeof Object.keys === "function" && Object.keys(obj).length !== 0) return false;
    if (typeof Object.getOwnPropertyNames === "function" && Object.getOwnPropertyNames(obj).length !== 0) return false;
    var syms = Object.getOwnPropertySymbols(obj);
    if (syms.length !== 1 || syms[0] !== sym) return false;
    if (!Object.prototype.propertyIsEnumerable.call(obj, sym)) return false;
    if (typeof Object.getOwnPropertyDescriptor === "function") {
        var descriptor = Object.getOwnPropertyDescriptor(obj, sym);
        if (descriptor.value !== symVal || descriptor.enumerable !== true) return false;
    }
    return true;
};

});


parcelRegister("hXu6F", function(module, exports) {
"use strict";

var $1zENl = parcelRequire("1zENl");

var $cOB0F = parcelRequire("cOB0F");
var $d12f4cdcd6b10506$var$$indexOf = $cOB0F($1zENl("String.prototype.indexOf"));
module.exports = function callBoundIntrinsic(name, allowMissing) {
    var intrinsic = $1zENl(name, !!allowMissing);
    if (typeof intrinsic === "function" && $d12f4cdcd6b10506$var$$indexOf(name, ".prototype.") > -1) return $cOB0F(intrinsic);
    return intrinsic;
};

});
parcelRegister("1zENl", function(module, exports) {
"use strict";
var $1258b452ecf218a1$var$undefined1;
var $1258b452ecf218a1$var$$SyntaxError = SyntaxError;
var $1258b452ecf218a1$var$$Function = Function;
var $1258b452ecf218a1$var$$TypeError = TypeError;
// eslint-disable-next-line consistent-return
var $1258b452ecf218a1$var$getEvalledConstructor = function(expressionSyntax) {
    try {
        return $1258b452ecf218a1$var$$Function('"use strict"; return (' + expressionSyntax + ").constructor;")();
    } catch (e) {}
};
var $1258b452ecf218a1$var$$gOPD = Object.getOwnPropertyDescriptor;
if ($1258b452ecf218a1$var$$gOPD) try {
    $1258b452ecf218a1$var$$gOPD({}, "");
} catch (e) {
    $1258b452ecf218a1$var$$gOPD = null; // this is IE 8, which has a broken gOPD
}
var $1258b452ecf218a1$var$throwTypeError = function() {
    throw new $1258b452ecf218a1$var$$TypeError();
};
var $1258b452ecf218a1$var$ThrowTypeError = $1258b452ecf218a1$var$$gOPD ? function() {
    try {
        // eslint-disable-next-line no-unused-expressions, no-caller, no-restricted-properties
        arguments.callee; // IE 8 does not throw here
        return $1258b452ecf218a1$var$throwTypeError;
    } catch (calleeThrows) {
        try {
            // IE 8 throws on Object.getOwnPropertyDescriptor(arguments, '')
            return $1258b452ecf218a1$var$$gOPD(arguments, "callee").get;
        } catch (gOPDthrows) {
            return $1258b452ecf218a1$var$throwTypeError;
        }
    }
}() : $1258b452ecf218a1$var$throwTypeError;

var $1258b452ecf218a1$var$hasSymbols = (parcelRequire("24qIq"))();

var $1258b452ecf218a1$var$hasProto = (parcelRequire("dSRh6"))();
var $1258b452ecf218a1$var$getProto = Object.getPrototypeOf || ($1258b452ecf218a1$var$hasProto ? function(x) {
    return x.__proto__;
} // eslint-disable-line no-proto
 : null);
var $1258b452ecf218a1$var$needsEval = {};
var $1258b452ecf218a1$var$TypedArray = typeof Uint8Array === "undefined" || !$1258b452ecf218a1$var$getProto ? undefined : $1258b452ecf218a1$var$getProto(Uint8Array);
var $1258b452ecf218a1$var$INTRINSICS = {
    "%AggregateError%": typeof AggregateError === "undefined" ? undefined : AggregateError,
    "%Array%": Array,
    "%ArrayBuffer%": typeof ArrayBuffer === "undefined" ? undefined : ArrayBuffer,
    "%ArrayIteratorPrototype%": $1258b452ecf218a1$var$hasSymbols && $1258b452ecf218a1$var$getProto ? $1258b452ecf218a1$var$getProto([][Symbol.iterator]()) : undefined,
    "%AsyncFromSyncIteratorPrototype%": undefined,
    "%AsyncFunction%": $1258b452ecf218a1$var$needsEval,
    "%AsyncGenerator%": $1258b452ecf218a1$var$needsEval,
    "%AsyncGeneratorFunction%": $1258b452ecf218a1$var$needsEval,
    "%AsyncIteratorPrototype%": $1258b452ecf218a1$var$needsEval,
    "%Atomics%": typeof Atomics === "undefined" ? undefined : Atomics,
    "%BigInt%": typeof BigInt === "undefined" ? undefined : BigInt,
    "%BigInt64Array%": typeof BigInt64Array === "undefined" ? undefined : BigInt64Array,
    "%BigUint64Array%": typeof BigUint64Array === "undefined" ? undefined : BigUint64Array,
    "%Boolean%": Boolean,
    "%DataView%": typeof DataView === "undefined" ? undefined : DataView,
    "%Date%": Date,
    "%decodeURI%": decodeURI,
    "%decodeURIComponent%": decodeURIComponent,
    "%encodeURI%": encodeURI,
    "%encodeURIComponent%": encodeURIComponent,
    "%Error%": Error,
    "%eval%": eval,
    "%EvalError%": EvalError,
    "%Float32Array%": typeof Float32Array === "undefined" ? undefined : Float32Array,
    "%Float64Array%": typeof Float64Array === "undefined" ? undefined : Float64Array,
    "%FinalizationRegistry%": typeof FinalizationRegistry === "undefined" ? undefined : FinalizationRegistry,
    "%Function%": $1258b452ecf218a1$var$$Function,
    "%GeneratorFunction%": $1258b452ecf218a1$var$needsEval,
    "%Int8Array%": typeof Int8Array === "undefined" ? undefined : Int8Array,
    "%Int16Array%": typeof Int16Array === "undefined" ? undefined : Int16Array,
    "%Int32Array%": typeof Int32Array === "undefined" ? undefined : Int32Array,
    "%isFinite%": isFinite,
    "%isNaN%": isNaN,
    "%IteratorPrototype%": $1258b452ecf218a1$var$hasSymbols && $1258b452ecf218a1$var$getProto ? $1258b452ecf218a1$var$getProto($1258b452ecf218a1$var$getProto([][Symbol.iterator]())) : undefined,
    "%JSON%": typeof JSON === "object" ? JSON : undefined,
    "%Map%": typeof Map === "undefined" ? undefined : Map,
    "%MapIteratorPrototype%": typeof Map === "undefined" || !$1258b452ecf218a1$var$hasSymbols || !$1258b452ecf218a1$var$getProto ? undefined : $1258b452ecf218a1$var$getProto(new Map()[Symbol.iterator]()),
    "%Math%": Math,
    "%Number%": Number,
    "%Object%": Object,
    "%parseFloat%": parseFloat,
    "%parseInt%": parseInt,
    "%Promise%": typeof Promise === "undefined" ? undefined : Promise,
    "%Proxy%": typeof Proxy === "undefined" ? undefined : Proxy,
    "%RangeError%": RangeError,
    "%ReferenceError%": ReferenceError,
    "%Reflect%": typeof Reflect === "undefined" ? undefined : Reflect,
    "%RegExp%": RegExp,
    "%Set%": typeof Set === "undefined" ? undefined : Set,
    "%SetIteratorPrototype%": typeof Set === "undefined" || !$1258b452ecf218a1$var$hasSymbols || !$1258b452ecf218a1$var$getProto ? undefined : $1258b452ecf218a1$var$getProto(new Set()[Symbol.iterator]()),
    "%SharedArrayBuffer%": typeof SharedArrayBuffer === "undefined" ? undefined : SharedArrayBuffer,
    "%String%": String,
    "%StringIteratorPrototype%": $1258b452ecf218a1$var$hasSymbols && $1258b452ecf218a1$var$getProto ? $1258b452ecf218a1$var$getProto(""[Symbol.iterator]()) : undefined,
    "%Symbol%": $1258b452ecf218a1$var$hasSymbols ? Symbol : undefined,
    "%SyntaxError%": $1258b452ecf218a1$var$$SyntaxError,
    "%ThrowTypeError%": $1258b452ecf218a1$var$ThrowTypeError,
    "%TypedArray%": $1258b452ecf218a1$var$TypedArray,
    "%TypeError%": $1258b452ecf218a1$var$$TypeError,
    "%Uint8Array%": typeof Uint8Array === "undefined" ? undefined : Uint8Array,
    "%Uint8ClampedArray%": typeof Uint8ClampedArray === "undefined" ? undefined : Uint8ClampedArray,
    "%Uint16Array%": typeof Uint16Array === "undefined" ? undefined : Uint16Array,
    "%Uint32Array%": typeof Uint32Array === "undefined" ? undefined : Uint32Array,
    "%URIError%": URIError,
    "%WeakMap%": typeof WeakMap === "undefined" ? undefined : WeakMap,
    "%WeakRef%": typeof WeakRef === "undefined" ? undefined : WeakRef,
    "%WeakSet%": typeof WeakSet === "undefined" ? undefined : WeakSet
};
if ($1258b452ecf218a1$var$getProto) try {
    null.error; // eslint-disable-line no-unused-expressions
} catch (e) {
    // https://github.com/tc39/proposal-shadowrealm/pull/384#issuecomment-1364264229
    var $1258b452ecf218a1$var$errorProto = $1258b452ecf218a1$var$getProto($1258b452ecf218a1$var$getProto(e));
    $1258b452ecf218a1$var$INTRINSICS["%Error.prototype%"] = $1258b452ecf218a1$var$errorProto;
}
var $1258b452ecf218a1$var$doEval = function doEval(name) {
    var value;
    if (name === "%AsyncFunction%") value = $1258b452ecf218a1$var$getEvalledConstructor("async function () {}");
    else if (name === "%GeneratorFunction%") value = $1258b452ecf218a1$var$getEvalledConstructor("function* () {}");
    else if (name === "%AsyncGeneratorFunction%") value = $1258b452ecf218a1$var$getEvalledConstructor("async function* () {}");
    else if (name === "%AsyncGenerator%") {
        var fn = doEval("%AsyncGeneratorFunction%");
        if (fn) value = fn.prototype;
    } else if (name === "%AsyncIteratorPrototype%") {
        var gen = doEval("%AsyncGenerator%");
        if (gen && $1258b452ecf218a1$var$getProto) value = $1258b452ecf218a1$var$getProto(gen.prototype);
    }
    $1258b452ecf218a1$var$INTRINSICS[name] = value;
    return value;
};
var $1258b452ecf218a1$var$LEGACY_ALIASES = {
    "%ArrayBufferPrototype%": [
        "ArrayBuffer",
        "prototype"
    ],
    "%ArrayPrototype%": [
        "Array",
        "prototype"
    ],
    "%ArrayProto_entries%": [
        "Array",
        "prototype",
        "entries"
    ],
    "%ArrayProto_forEach%": [
        "Array",
        "prototype",
        "forEach"
    ],
    "%ArrayProto_keys%": [
        "Array",
        "prototype",
        "keys"
    ],
    "%ArrayProto_values%": [
        "Array",
        "prototype",
        "values"
    ],
    "%AsyncFunctionPrototype%": [
        "AsyncFunction",
        "prototype"
    ],
    "%AsyncGenerator%": [
        "AsyncGeneratorFunction",
        "prototype"
    ],
    "%AsyncGeneratorPrototype%": [
        "AsyncGeneratorFunction",
        "prototype",
        "prototype"
    ],
    "%BooleanPrototype%": [
        "Boolean",
        "prototype"
    ],
    "%DataViewPrototype%": [
        "DataView",
        "prototype"
    ],
    "%DatePrototype%": [
        "Date",
        "prototype"
    ],
    "%ErrorPrototype%": [
        "Error",
        "prototype"
    ],
    "%EvalErrorPrototype%": [
        "EvalError",
        "prototype"
    ],
    "%Float32ArrayPrototype%": [
        "Float32Array",
        "prototype"
    ],
    "%Float64ArrayPrototype%": [
        "Float64Array",
        "prototype"
    ],
    "%FunctionPrototype%": [
        "Function",
        "prototype"
    ],
    "%Generator%": [
        "GeneratorFunction",
        "prototype"
    ],
    "%GeneratorPrototype%": [
        "GeneratorFunction",
        "prototype",
        "prototype"
    ],
    "%Int8ArrayPrototype%": [
        "Int8Array",
        "prototype"
    ],
    "%Int16ArrayPrototype%": [
        "Int16Array",
        "prototype"
    ],
    "%Int32ArrayPrototype%": [
        "Int32Array",
        "prototype"
    ],
    "%JSONParse%": [
        "JSON",
        "parse"
    ],
    "%JSONStringify%": [
        "JSON",
        "stringify"
    ],
    "%MapPrototype%": [
        "Map",
        "prototype"
    ],
    "%NumberPrototype%": [
        "Number",
        "prototype"
    ],
    "%ObjectPrototype%": [
        "Object",
        "prototype"
    ],
    "%ObjProto_toString%": [
        "Object",
        "prototype",
        "toString"
    ],
    "%ObjProto_valueOf%": [
        "Object",
        "prototype",
        "valueOf"
    ],
    "%PromisePrototype%": [
        "Promise",
        "prototype"
    ],
    "%PromiseProto_then%": [
        "Promise",
        "prototype",
        "then"
    ],
    "%Promise_all%": [
        "Promise",
        "all"
    ],
    "%Promise_reject%": [
        "Promise",
        "reject"
    ],
    "%Promise_resolve%": [
        "Promise",
        "resolve"
    ],
    "%RangeErrorPrototype%": [
        "RangeError",
        "prototype"
    ],
    "%ReferenceErrorPrototype%": [
        "ReferenceError",
        "prototype"
    ],
    "%RegExpPrototype%": [
        "RegExp",
        "prototype"
    ],
    "%SetPrototype%": [
        "Set",
        "prototype"
    ],
    "%SharedArrayBufferPrototype%": [
        "SharedArrayBuffer",
        "prototype"
    ],
    "%StringPrototype%": [
        "String",
        "prototype"
    ],
    "%SymbolPrototype%": [
        "Symbol",
        "prototype"
    ],
    "%SyntaxErrorPrototype%": [
        "SyntaxError",
        "prototype"
    ],
    "%TypedArrayPrototype%": [
        "TypedArray",
        "prototype"
    ],
    "%TypeErrorPrototype%": [
        "TypeError",
        "prototype"
    ],
    "%Uint8ArrayPrototype%": [
        "Uint8Array",
        "prototype"
    ],
    "%Uint8ClampedArrayPrototype%": [
        "Uint8ClampedArray",
        "prototype"
    ],
    "%Uint16ArrayPrototype%": [
        "Uint16Array",
        "prototype"
    ],
    "%Uint32ArrayPrototype%": [
        "Uint32Array",
        "prototype"
    ],
    "%URIErrorPrototype%": [
        "URIError",
        "prototype"
    ],
    "%WeakMapPrototype%": [
        "WeakMap",
        "prototype"
    ],
    "%WeakSetPrototype%": [
        "WeakSet",
        "prototype"
    ]
};

var $gvair = parcelRequire("gvair");

var $4c4Ky = parcelRequire("4c4Ky");
var $1258b452ecf218a1$var$$concat = $gvair.call(Function.call, Array.prototype.concat);
var $1258b452ecf218a1$var$$spliceApply = $gvair.call(Function.apply, Array.prototype.splice);
var $1258b452ecf218a1$var$$replace = $gvair.call(Function.call, String.prototype.replace);
var $1258b452ecf218a1$var$$strSlice = $gvair.call(Function.call, String.prototype.slice);
var $1258b452ecf218a1$var$$exec = $gvair.call(Function.call, RegExp.prototype.exec);
/* adapted from https://github.com/lodash/lodash/blob/4.17.15/dist/lodash.js#L6735-L6744 */ var $1258b452ecf218a1$var$rePropName = /[^%.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|%$))/g;
var $1258b452ecf218a1$var$reEscapeChar = /\\(\\)?/g; /** Used to match backslashes in property paths. */ 
var $1258b452ecf218a1$var$stringToPath = function stringToPath(string) {
    var first = $1258b452ecf218a1$var$$strSlice(string, 0, 1);
    var last = $1258b452ecf218a1$var$$strSlice(string, -1);
    if (first === "%" && last !== "%") throw new $1258b452ecf218a1$var$$SyntaxError("invalid intrinsic syntax, expected closing `%`");
    else if (last === "%" && first !== "%") throw new $1258b452ecf218a1$var$$SyntaxError("invalid intrinsic syntax, expected opening `%`");
    var result = [];
    $1258b452ecf218a1$var$$replace(string, $1258b452ecf218a1$var$rePropName, function(match, number, quote, subString) {
        result[result.length] = quote ? $1258b452ecf218a1$var$$replace(subString, $1258b452ecf218a1$var$reEscapeChar, "$1") : number || match;
    });
    return result;
};
/* end adaptation */ var $1258b452ecf218a1$var$getBaseIntrinsic = function getBaseIntrinsic(name, allowMissing) {
    var intrinsicName = name;
    var alias;
    if ($4c4Ky($1258b452ecf218a1$var$LEGACY_ALIASES, intrinsicName)) {
        alias = $1258b452ecf218a1$var$LEGACY_ALIASES[intrinsicName];
        intrinsicName = "%" + alias[0] + "%";
    }
    if ($4c4Ky($1258b452ecf218a1$var$INTRINSICS, intrinsicName)) {
        var value = $1258b452ecf218a1$var$INTRINSICS[intrinsicName];
        if (value === $1258b452ecf218a1$var$needsEval) value = $1258b452ecf218a1$var$doEval(intrinsicName);
        if (typeof value === "undefined" && !allowMissing) throw new $1258b452ecf218a1$var$$TypeError("intrinsic " + name + " exists, but is not available. Please file an issue!");
        return {
            alias: alias,
            name: intrinsicName,
            value: value
        };
    }
    throw new $1258b452ecf218a1$var$$SyntaxError("intrinsic " + name + " does not exist!");
};
module.exports = function GetIntrinsic(name, allowMissing) {
    if (typeof name !== "string" || name.length === 0) throw new $1258b452ecf218a1$var$$TypeError("intrinsic name must be a non-empty string");
    if (arguments.length > 1 && typeof allowMissing !== "boolean") throw new $1258b452ecf218a1$var$$TypeError('"allowMissing" argument must be a boolean');
    if ($1258b452ecf218a1$var$$exec(/^%?[^%]*%?$/, name) === null) throw new $1258b452ecf218a1$var$$SyntaxError("`%` may not be present anywhere but at the beginning and end of the intrinsic name");
    var parts = $1258b452ecf218a1$var$stringToPath(name);
    var intrinsicBaseName = parts.length > 0 ? parts[0] : "";
    var intrinsic = $1258b452ecf218a1$var$getBaseIntrinsic("%" + intrinsicBaseName + "%", allowMissing);
    var intrinsicRealName = intrinsic.name;
    var value = intrinsic.value;
    var skipFurtherCaching = false;
    var alias = intrinsic.alias;
    if (alias) {
        intrinsicBaseName = alias[0];
        $1258b452ecf218a1$var$$spliceApply(parts, $1258b452ecf218a1$var$$concat([
            0,
            1
        ], alias));
    }
    for(var i = 1, isOwn = true; i < parts.length; i += 1){
        var part = parts[i];
        var first = $1258b452ecf218a1$var$$strSlice(part, 0, 1);
        var last = $1258b452ecf218a1$var$$strSlice(part, -1);
        if ((first === '"' || first === "'" || first === "`" || last === '"' || last === "'" || last === "`") && first !== last) throw new $1258b452ecf218a1$var$$SyntaxError("property names with quotes must have matching quotes");
        if (part === "constructor" || !isOwn) skipFurtherCaching = true;
        intrinsicBaseName += "." + part;
        intrinsicRealName = "%" + intrinsicBaseName + "%";
        if ($4c4Ky($1258b452ecf218a1$var$INTRINSICS, intrinsicRealName)) value = $1258b452ecf218a1$var$INTRINSICS[intrinsicRealName];
        else if (value != null) {
            if (!(part in value)) {
                if (!allowMissing) throw new $1258b452ecf218a1$var$$TypeError("base intrinsic for " + name + " exists, but the property is not available.");
                return void 0;
            }
            if ($1258b452ecf218a1$var$$gOPD && i + 1 >= parts.length) {
                var desc = $1258b452ecf218a1$var$$gOPD(value, part);
                isOwn = !!desc;
                // By convention, when a data property is converted to an accessor
                // property to emulate a data property that does not suffer from
                // the override mistake, that accessor's getter is marked with
                // an `originalValue` property. Here, when we detect this, we
                // uphold the illusion by pretending to see that original data
                // property, i.e., returning the value rather than the getter
                // itself.
                if (isOwn && "get" in desc && !("originalValue" in desc.get)) value = desc.get;
                else value = value[part];
            } else {
                isOwn = $4c4Ky(value, part);
                value = value[part];
            }
            if (isOwn && !skipFurtherCaching) $1258b452ecf218a1$var$INTRINSICS[intrinsicRealName] = value;
        }
    }
    return value;
};

});
parcelRegister("24qIq", function(module, exports) {
"use strict";
var $1820ada193f67aeb$var$origSymbol = typeof Symbol !== "undefined" && Symbol;

var $7YWkK = parcelRequire("7YWkK");
module.exports = function hasNativeSymbols() {
    if (typeof $1820ada193f67aeb$var$origSymbol !== "function") return false;
    if (typeof Symbol !== "function") return false;
    if (typeof $1820ada193f67aeb$var$origSymbol("foo") !== "symbol") return false;
    if (typeof Symbol("bar") !== "symbol") return false;
    return $7YWkK();
};

});

parcelRegister("dSRh6", function(module, exports) {
"use strict";
var $a1b9a4c94d7d9147$var$test = {
    foo: {}
};
var $a1b9a4c94d7d9147$var$$Object = Object;
module.exports = function hasProto() {
    return ({
        __proto__: $a1b9a4c94d7d9147$var$test
    }).foo === $a1b9a4c94d7d9147$var$test.foo && !(({
        __proto__: null
    }) instanceof $a1b9a4c94d7d9147$var$$Object);
};

});

parcelRegister("gvair", function(module, exports) {
"use strict";

var $kAGnA = parcelRequire("kAGnA");
module.exports = Function.prototype.bind || $kAGnA;

});
parcelRegister("kAGnA", function(module, exports) {
"use strict";
/* eslint no-invalid-this: 1 */ var $efd80b1d7fbb2850$var$ERROR_MESSAGE = "Function.prototype.bind called on incompatible ";
var $efd80b1d7fbb2850$var$toStr = Object.prototype.toString;
var $efd80b1d7fbb2850$var$max = Math.max;
var $efd80b1d7fbb2850$var$funcType = "[object Function]";
var $efd80b1d7fbb2850$var$concatty = function concatty(a, b) {
    var arr = [];
    for(var i = 0; i < a.length; i += 1)arr[i] = a[i];
    for(var j = 0; j < b.length; j += 1)arr[j + a.length] = b[j];
    return arr;
};
var $efd80b1d7fbb2850$var$slicy = function slicy(arrLike, offset) {
    var arr = [];
    for(var i = offset || 0, j = 0; i < arrLike.length; i += 1, j += 1)arr[j] = arrLike[i];
    return arr;
};
var $efd80b1d7fbb2850$var$joiny = function(arr, joiner) {
    var str = "";
    for(var i = 0; i < arr.length; i += 1){
        str += arr[i];
        if (i + 1 < arr.length) str += joiner;
    }
    return str;
};
module.exports = function bind(that) {
    var target = this;
    if (typeof target !== "function" || $efd80b1d7fbb2850$var$toStr.apply(target) !== $efd80b1d7fbb2850$var$funcType) throw new TypeError($efd80b1d7fbb2850$var$ERROR_MESSAGE + target);
    var args = $efd80b1d7fbb2850$var$slicy(arguments, 1);
    var bound;
    var binder = function() {
        if (this instanceof bound) {
            var result = target.apply(this, $efd80b1d7fbb2850$var$concatty(args, arguments));
            if (Object(result) === result) return result;
            return this;
        }
        return target.apply(that, $efd80b1d7fbb2850$var$concatty(args, arguments));
    };
    var boundLength = $efd80b1d7fbb2850$var$max(0, target.length - args.length);
    var boundArgs = [];
    for(var i = 0; i < boundLength; i++)boundArgs[i] = "$" + i;
    bound = Function("binder", "return function (" + $efd80b1d7fbb2850$var$joiny(boundArgs, ",") + "){ return binder.apply(this,arguments); }")(binder);
    if (target.prototype) {
        var Empty = function Empty() {};
        Empty.prototype = target.prototype;
        bound.prototype = new Empty();
        Empty.prototype = null;
    }
    return bound;
};

});


parcelRegister("4c4Ky", function(module, exports) {
"use strict";
var $30dbf79dbae6c725$var$call = Function.prototype.call;
var $30dbf79dbae6c725$var$$hasOwn = Object.prototype.hasOwnProperty;

var $gvair = parcelRequire("gvair");
/** @type {(o: {}, p: PropertyKey) => p is keyof o} */ module.exports = $gvair.call($30dbf79dbae6c725$var$call, $30dbf79dbae6c725$var$$hasOwn);

});


parcelRegister("cOB0F", function(module, exports) {
"use strict";

var $gvair = parcelRequire("gvair");

var $1zENl = parcelRequire("1zENl");

var $BPe9e = parcelRequire("BPe9e");
var $9546dce5bd4976bd$var$$TypeError = $1zENl("%TypeError%");
var $9546dce5bd4976bd$var$$apply = $1zENl("%Function.prototype.apply%");
var $9546dce5bd4976bd$var$$call = $1zENl("%Function.prototype.call%");
var $9546dce5bd4976bd$var$$reflectApply = $1zENl("%Reflect.apply%", true) || $gvair.call($9546dce5bd4976bd$var$$call, $9546dce5bd4976bd$var$$apply);
var $9546dce5bd4976bd$var$$defineProperty = $1zENl("%Object.defineProperty%", true);
var $9546dce5bd4976bd$var$$max = $1zENl("%Math.max%");
if ($9546dce5bd4976bd$var$$defineProperty) try {
    $9546dce5bd4976bd$var$$defineProperty({}, "a", {
        value: 1
    });
} catch (e) {
    // IE 8 has a broken defineProperty
    $9546dce5bd4976bd$var$$defineProperty = null;
}
module.exports = function callBind(originalFunction) {
    if (typeof originalFunction !== "function") throw new $9546dce5bd4976bd$var$$TypeError("a function is required");
    var func = $9546dce5bd4976bd$var$$reflectApply($gvair, $9546dce5bd4976bd$var$$call, arguments);
    return $BPe9e(func, 1 + $9546dce5bd4976bd$var$$max(0, originalFunction.length - (arguments.length - 1)), true);
};
var $9546dce5bd4976bd$var$applyBind = function applyBind() {
    return $9546dce5bd4976bd$var$$reflectApply($gvair, $9546dce5bd4976bd$var$$apply, arguments);
};
if ($9546dce5bd4976bd$var$$defineProperty) $9546dce5bd4976bd$var$$defineProperty(module.exports, "apply", {
    value: $9546dce5bd4976bd$var$applyBind
});
else module.exports.apply = $9546dce5bd4976bd$var$applyBind;

});
parcelRegister("BPe9e", function(module, exports) {
"use strict";

var $1zENl = parcelRequire("1zENl");

var $5FEEt = parcelRequire("5FEEt");

var $071b317808876eb5$var$hasDescriptors = (parcelRequire("i16wS"))();

var $dYOee = parcelRequire("dYOee");
var $071b317808876eb5$var$$TypeError = $1zENl("%TypeError%");
var $071b317808876eb5$var$$floor = $1zENl("%Math.floor%");
module.exports = function setFunctionLength(fn, length) {
    if (typeof fn !== "function") throw new $071b317808876eb5$var$$TypeError("`fn` is not a function");
    if (typeof length !== "number" || length < 0 || length > 0xFFFFFFFF || $071b317808876eb5$var$$floor(length) !== length) throw new $071b317808876eb5$var$$TypeError("`length` must be a positive 32-bit integer");
    var loose = arguments.length > 2 && !!arguments[2];
    var functionLengthIsConfigurable = true;
    var functionLengthIsWritable = true;
    if ("length" in fn && $dYOee) {
        var desc = $dYOee(fn, "length");
        if (desc && !desc.configurable) functionLengthIsConfigurable = false;
        if (desc && !desc.writable) functionLengthIsWritable = false;
    }
    if (functionLengthIsConfigurable || functionLengthIsWritable || !loose) {
        if ($071b317808876eb5$var$hasDescriptors) $5FEEt(fn, "length", length, true, true);
        else $5FEEt(fn, "length", length);
    }
    return fn;
};

});
parcelRegister("5FEEt", function(module, exports) {
"use strict";

var $421050b39f25e605$var$hasPropertyDescriptors = (parcelRequire("i16wS"))();

var $1zENl = parcelRequire("1zENl");
var $421050b39f25e605$var$$defineProperty = $421050b39f25e605$var$hasPropertyDescriptors && $1zENl("%Object.defineProperty%", true);
if ($421050b39f25e605$var$$defineProperty) try {
    $421050b39f25e605$var$$defineProperty({}, "a", {
        value: 1
    });
} catch (e) {
    // IE 8 has a broken defineProperty
    $421050b39f25e605$var$$defineProperty = false;
}
var $421050b39f25e605$var$$SyntaxError = $1zENl("%SyntaxError%");
var $421050b39f25e605$var$$TypeError = $1zENl("%TypeError%");

var $dYOee = parcelRequire("dYOee");
/** @type {(obj: Record<PropertyKey, unknown>, property: PropertyKey, value: unknown, nonEnumerable?: boolean | null, nonWritable?: boolean | null, nonConfigurable?: boolean | null, loose?: boolean) => void} */ module.exports = function defineDataProperty(obj, property, value) {
    if (!obj || typeof obj !== "object" && typeof obj !== "function") throw new $421050b39f25e605$var$$TypeError("`obj` must be an object or a function`");
    if (typeof property !== "string" && typeof property !== "symbol") throw new $421050b39f25e605$var$$TypeError("`property` must be a string or a symbol`");
    if (arguments.length > 3 && typeof arguments[3] !== "boolean" && arguments[3] !== null) throw new $421050b39f25e605$var$$TypeError("`nonEnumerable`, if provided, must be a boolean or null");
    if (arguments.length > 4 && typeof arguments[4] !== "boolean" && arguments[4] !== null) throw new $421050b39f25e605$var$$TypeError("`nonWritable`, if provided, must be a boolean or null");
    if (arguments.length > 5 && typeof arguments[5] !== "boolean" && arguments[5] !== null) throw new $421050b39f25e605$var$$TypeError("`nonConfigurable`, if provided, must be a boolean or null");
    if (arguments.length > 6 && typeof arguments[6] !== "boolean") throw new $421050b39f25e605$var$$TypeError("`loose`, if provided, must be a boolean");
    var nonEnumerable = arguments.length > 3 ? arguments[3] : null;
    var nonWritable = arguments.length > 4 ? arguments[4] : null;
    var nonConfigurable = arguments.length > 5 ? arguments[5] : null;
    var loose = arguments.length > 6 ? arguments[6] : false;
    /* @type {false | TypedPropertyDescriptor<unknown>} */ var desc = !!$dYOee && $dYOee(obj, property);
    if ($421050b39f25e605$var$$defineProperty) $421050b39f25e605$var$$defineProperty(obj, property, {
        configurable: nonConfigurable === null && desc ? desc.configurable : !nonConfigurable,
        enumerable: nonEnumerable === null && desc ? desc.enumerable : !nonEnumerable,
        value: value,
        writable: nonWritable === null && desc ? desc.writable : !nonWritable
    });
    else if (loose || !nonEnumerable && !nonWritable && !nonConfigurable) // must fall back to [[Set]], and was not explicitly asked to make non-enumerable, non-writable, or non-configurable
    obj[property] = value; // eslint-disable-line no-param-reassign
    else throw new $421050b39f25e605$var$$SyntaxError("This environment does not support defining a property as non-configurable, non-writable, or non-enumerable.");
};

});
parcelRegister("i16wS", function(module, exports) {
"use strict";

var $1zENl = parcelRequire("1zENl");
var $d1dd62937e17e68d$var$$defineProperty = $1zENl("%Object.defineProperty%", true);
var $d1dd62937e17e68d$var$hasPropertyDescriptors = function hasPropertyDescriptors() {
    if ($d1dd62937e17e68d$var$$defineProperty) try {
        $d1dd62937e17e68d$var$$defineProperty({}, "a", {
            value: 1
        });
        return true;
    } catch (e) {
        // IE 8 has a broken defineProperty
        return false;
    }
    return false;
};
$d1dd62937e17e68d$var$hasPropertyDescriptors.hasArrayLengthDefineBug = function hasArrayLengthDefineBug() {
    // node v0.6 has a bug where array lengths can be Set but not Defined
    if (!$d1dd62937e17e68d$var$hasPropertyDescriptors()) return null;
    try {
        return $d1dd62937e17e68d$var$$defineProperty([], "length", {
            value: 1
        }).length !== 1;
    } catch (e) {
        // In Firefox 4-22, defining length on an array throws an exception.
        return true;
    }
};
module.exports = $d1dd62937e17e68d$var$hasPropertyDescriptors;

});

parcelRegister("dYOee", function(module, exports) {
"use strict";

var $1zENl = parcelRequire("1zENl");
var $a2d7d74e83f6c3ed$var$$gOPD = $1zENl("%Object.getOwnPropertyDescriptor%", true);
if ($a2d7d74e83f6c3ed$var$$gOPD) try {
    $a2d7d74e83f6c3ed$var$$gOPD([], "length");
} catch (e) {
    // IE 8 has a broken gOPD
    $a2d7d74e83f6c3ed$var$$gOPD = null;
}
module.exports = $a2d7d74e83f6c3ed$var$$gOPD;

});






parcelRegister("5WnCa", function(module, exports) {
"use strict";
var $4534afe844d627e4$var$toStr = Object.prototype.toString;
var $4534afe844d627e4$var$fnToStr = Function.prototype.toString;
var $4534afe844d627e4$var$isFnRegex = /^\s*(?:function)?\*/;

var $4534afe844d627e4$var$hasToStringTag = (parcelRequire("3KyxH"))();
var $4534afe844d627e4$var$getProto = Object.getPrototypeOf;
var $4534afe844d627e4$var$getGeneratorFunc = function() {
    if (!$4534afe844d627e4$var$hasToStringTag) return false;
    try {
        return Function("return function*() {}")();
    } catch (e) {}
};
var $4534afe844d627e4$var$GeneratorFunction;
module.exports = function isGeneratorFunction(fn) {
    if (typeof fn !== "function") return false;
    if ($4534afe844d627e4$var$isFnRegex.test($4534afe844d627e4$var$fnToStr.call(fn))) return true;
    if (!$4534afe844d627e4$var$hasToStringTag) {
        var str = $4534afe844d627e4$var$toStr.call(fn);
        return str === "[object GeneratorFunction]";
    }
    if (!$4534afe844d627e4$var$getProto) return false;
    if (typeof $4534afe844d627e4$var$GeneratorFunction === "undefined") {
        var generatorFunc = $4534afe844d627e4$var$getGeneratorFunc();
        $4534afe844d627e4$var$GeneratorFunction = generatorFunc ? $4534afe844d627e4$var$getProto(generatorFunc) : false;
    }
    return $4534afe844d627e4$var$getProto(fn) === $4534afe844d627e4$var$GeneratorFunction;
};

});

parcelRegister("gJrpv", function(module, exports) {
"use strict";

var $gFhA7 = parcelRequire("gFhA7");

var $8yXCr = parcelRequire("8yXCr");

var $cOB0F = parcelRequire("cOB0F");

var $hXu6F = parcelRequire("hXu6F");

var $dYOee = parcelRequire("dYOee");
var $c2e61c703a2c9ae0$var$$toString = $hXu6F("Object.prototype.toString");

var $c2e61c703a2c9ae0$var$hasToStringTag = (parcelRequire("3KyxH"))();
var $c2e61c703a2c9ae0$var$g = typeof globalThis === "undefined" ? $parcel$global : globalThis;
var $c2e61c703a2c9ae0$var$typedArrays = $8yXCr();
var $c2e61c703a2c9ae0$var$$slice = $hXu6F("String.prototype.slice");
var $c2e61c703a2c9ae0$var$getPrototypeOf = Object.getPrototypeOf; // require('getprototypeof');
var $c2e61c703a2c9ae0$var$$indexOf = $hXu6F("Array.prototype.indexOf", true) || function indexOf(array, value) {
    for(var i = 0; i < array.length; i += 1){
        if (array[i] === value) return i;
    }
    return -1;
};
var $c2e61c703a2c9ae0$var$cache = {
    __proto__: null
};
if ($c2e61c703a2c9ae0$var$hasToStringTag && $dYOee && $c2e61c703a2c9ae0$var$getPrototypeOf) $gFhA7($c2e61c703a2c9ae0$var$typedArrays, function(typedArray) {
    var arr = new $c2e61c703a2c9ae0$var$g[typedArray]();
    if (Symbol.toStringTag in arr) {
        var proto = $c2e61c703a2c9ae0$var$getPrototypeOf(arr);
        var descriptor = $dYOee(proto, Symbol.toStringTag);
        if (!descriptor) {
            var superProto = $c2e61c703a2c9ae0$var$getPrototypeOf(proto);
            descriptor = $dYOee(superProto, Symbol.toStringTag);
        }
        $c2e61c703a2c9ae0$var$cache["$" + typedArray] = $cOB0F(descriptor.get);
    }
});
else $gFhA7($c2e61c703a2c9ae0$var$typedArrays, function(typedArray) {
    var arr = new $c2e61c703a2c9ae0$var$g[typedArray]();
    var fn = arr.slice || arr.set;
    if (fn) $c2e61c703a2c9ae0$var$cache["$" + typedArray] = $cOB0F(fn);
});
var $c2e61c703a2c9ae0$var$tryTypedArrays = function tryAllTypedArrays(value) {
    var found = false;
    $gFhA7($c2e61c703a2c9ae0$var$cache, function(getter, typedArray) {
        if (!found) try {
            if ("$" + getter(value) === typedArray) found = $c2e61c703a2c9ae0$var$$slice(typedArray, 1);
        } catch (e) {}
    });
    return found;
};
var $c2e61c703a2c9ae0$var$trySlices = function tryAllSlices(value) {
    var found = false;
    $gFhA7($c2e61c703a2c9ae0$var$cache, function(getter, name) {
        if (!found) try {
            getter(value);
            found = $c2e61c703a2c9ae0$var$$slice(name, 1);
        } catch (e) {}
    });
    return found;
};
module.exports = function whichTypedArray(value) {
    if (!value || typeof value !== "object") return false;
    if (!$c2e61c703a2c9ae0$var$hasToStringTag) {
        var tag = $c2e61c703a2c9ae0$var$$slice($c2e61c703a2c9ae0$var$$toString(value), 8, -1);
        if ($c2e61c703a2c9ae0$var$$indexOf($c2e61c703a2c9ae0$var$typedArrays, tag) > -1) return tag;
        if (tag !== "Object") return false;
        // node < 0.6 hits here on real Typed Arrays
        return $c2e61c703a2c9ae0$var$trySlices(value);
    }
    if (!$dYOee) return null;
     // unknown engine
    return $c2e61c703a2c9ae0$var$tryTypedArrays(value);
};

});
parcelRegister("gFhA7", function(module, exports) {
"use strict";

var $63RD0 = parcelRequire("63RD0");
var $c21e1d005400ef2a$var$toStr = Object.prototype.toString;
var $c21e1d005400ef2a$var$hasOwnProperty = Object.prototype.hasOwnProperty;
var $c21e1d005400ef2a$var$forEachArray = function forEachArray(array, iterator, receiver) {
    for(var i = 0, len = array.length; i < len; i++)if ($c21e1d005400ef2a$var$hasOwnProperty.call(array, i)) {
        if (receiver == null) iterator(array[i], i, array);
        else iterator.call(receiver, array[i], i, array);
    }
};
var $c21e1d005400ef2a$var$forEachString = function forEachString(string, iterator, receiver) {
    for(var i = 0, len = string.length; i < len; i++)// no such thing as a sparse string.
    if (receiver == null) iterator(string.charAt(i), i, string);
    else iterator.call(receiver, string.charAt(i), i, string);
};
var $c21e1d005400ef2a$var$forEachObject = function forEachObject(object, iterator, receiver) {
    for(var k in object)if ($c21e1d005400ef2a$var$hasOwnProperty.call(object, k)) {
        if (receiver == null) iterator(object[k], k, object);
        else iterator.call(receiver, object[k], k, object);
    }
};
var $c21e1d005400ef2a$var$forEach = function forEach(list, iterator, thisArg) {
    if (!$63RD0(iterator)) throw new TypeError("iterator must be a function");
    var receiver;
    if (arguments.length >= 3) receiver = thisArg;
    if ($c21e1d005400ef2a$var$toStr.call(list) === "[object Array]") $c21e1d005400ef2a$var$forEachArray(list, iterator, receiver);
    else if (typeof list === "string") $c21e1d005400ef2a$var$forEachString(list, iterator, receiver);
    else $c21e1d005400ef2a$var$forEachObject(list, iterator, receiver);
};
module.exports = $c21e1d005400ef2a$var$forEach;

});
parcelRegister("63RD0", function(module, exports) {
"use strict";
var $469c9f4bd3a650de$var$fnToStr = Function.prototype.toString;
var $469c9f4bd3a650de$var$reflectApply = typeof Reflect === "object" && Reflect !== null && Reflect.apply;
var $469c9f4bd3a650de$var$badArrayLike;
var $469c9f4bd3a650de$var$isCallableMarker;
if (typeof $469c9f4bd3a650de$var$reflectApply === "function" && typeof Object.defineProperty === "function") try {
    $469c9f4bd3a650de$var$badArrayLike = Object.defineProperty({}, "length", {
        get: function() {
            throw $469c9f4bd3a650de$var$isCallableMarker;
        }
    });
    $469c9f4bd3a650de$var$isCallableMarker = {};
    // eslint-disable-next-line no-throw-literal
    $469c9f4bd3a650de$var$reflectApply(function() {
        throw 42;
    }, null, $469c9f4bd3a650de$var$badArrayLike);
} catch (_) {
    if (_ !== $469c9f4bd3a650de$var$isCallableMarker) $469c9f4bd3a650de$var$reflectApply = null;
}
else $469c9f4bd3a650de$var$reflectApply = null;
var $469c9f4bd3a650de$var$constructorRegex = /^\s*class\b/;
var $469c9f4bd3a650de$var$isES6ClassFn = function isES6ClassFunction(value) {
    try {
        var fnStr = $469c9f4bd3a650de$var$fnToStr.call(value);
        return $469c9f4bd3a650de$var$constructorRegex.test(fnStr);
    } catch (e) {
        return false; // not a function
    }
};
var $469c9f4bd3a650de$var$tryFunctionObject = function tryFunctionToStr(value) {
    try {
        if ($469c9f4bd3a650de$var$isES6ClassFn(value)) return false;
        $469c9f4bd3a650de$var$fnToStr.call(value);
        return true;
    } catch (e) {
        return false;
    }
};
var $469c9f4bd3a650de$var$toStr = Object.prototype.toString;
var $469c9f4bd3a650de$var$objectClass = "[object Object]";
var $469c9f4bd3a650de$var$fnClass = "[object Function]";
var $469c9f4bd3a650de$var$genClass = "[object GeneratorFunction]";
var $469c9f4bd3a650de$var$ddaClass = "[object HTMLAllCollection]"; // IE 11
var $469c9f4bd3a650de$var$ddaClass2 = "[object HTML document.all class]";
var $469c9f4bd3a650de$var$ddaClass3 = "[object HTMLCollection]"; // IE 9-10
var $469c9f4bd3a650de$var$hasToStringTag = typeof Symbol === "function" && !!Symbol.toStringTag; // better: use `has-tostringtag`
var $469c9f4bd3a650de$var$isIE68 = !(0 in [
    , 
]); // eslint-disable-line no-sparse-arrays, comma-spacing
var $469c9f4bd3a650de$var$isDDA = function isDocumentDotAll() {
    return false;
};
if (typeof document === "object") {
    // Firefox 3 canonicalizes DDA to undefined when it's not accessed directly
    var $469c9f4bd3a650de$var$all = document.all;
    if ($469c9f4bd3a650de$var$toStr.call($469c9f4bd3a650de$var$all) === $469c9f4bd3a650de$var$toStr.call(document.all)) $469c9f4bd3a650de$var$isDDA = function isDocumentDotAll(value) {
        /* globals document: false */ // in IE 6-8, typeof document.all is "object" and it's truthy
        if (($469c9f4bd3a650de$var$isIE68 || !value) && (typeof value === "undefined" || typeof value === "object")) try {
            var str = $469c9f4bd3a650de$var$toStr.call(value);
            return (str === $469c9f4bd3a650de$var$ddaClass || str === $469c9f4bd3a650de$var$ddaClass2 || str === $469c9f4bd3a650de$var$ddaClass3 // opera 12.16
             || str === $469c9f4bd3a650de$var$objectClass // IE 6-8
            ) && value("") == null; // eslint-disable-line eqeqeq
        } catch (e) {}
        return false;
    };
}
module.exports = $469c9f4bd3a650de$var$reflectApply ? function isCallable(value) {
    if ($469c9f4bd3a650de$var$isDDA(value)) return true;
    if (!value) return false;
    if (typeof value !== "function" && typeof value !== "object") return false;
    try {
        $469c9f4bd3a650de$var$reflectApply(value, null, $469c9f4bd3a650de$var$badArrayLike);
    } catch (e) {
        if (e !== $469c9f4bd3a650de$var$isCallableMarker) return false;
    }
    return !$469c9f4bd3a650de$var$isES6ClassFn(value) && $469c9f4bd3a650de$var$tryFunctionObject(value);
} : function isCallable(value) {
    if ($469c9f4bd3a650de$var$isDDA(value)) return true;
    if (!value) return false;
    if (typeof value !== "function" && typeof value !== "object") return false;
    if ($469c9f4bd3a650de$var$hasToStringTag) return $469c9f4bd3a650de$var$tryFunctionObject(value);
    if ($469c9f4bd3a650de$var$isES6ClassFn(value)) return false;
    var strClass = $469c9f4bd3a650de$var$toStr.call(value);
    if (strClass !== $469c9f4bd3a650de$var$fnClass && strClass !== $469c9f4bd3a650de$var$genClass && !/^\[object HTML/.test(strClass)) return false;
    return $469c9f4bd3a650de$var$tryFunctionObject(value);
};

});


parcelRegister("8yXCr", function(module, exports) {
"use strict";
var $63bfbecf41903c8f$var$possibleNames = [
    "BigInt64Array",
    "BigUint64Array",
    "Float32Array",
    "Float64Array",
    "Int16Array",
    "Int32Array",
    "Int8Array",
    "Uint16Array",
    "Uint32Array",
    "Uint8Array",
    "Uint8ClampedArray"
];
var $63bfbecf41903c8f$var$g = typeof globalThis === "undefined" ? $parcel$global : globalThis;
module.exports = function availableTypedArrays() {
    var out = [];
    for(var i = 0; i < $63bfbecf41903c8f$var$possibleNames.length; i++)if (typeof $63bfbecf41903c8f$var$g[$63bfbecf41903c8f$var$possibleNames[i]] === "function") out[out.length] = $63bfbecf41903c8f$var$possibleNames[i];
    return out;
};

});


parcelRegister("hN833", function(module, exports) {
"use strict";

var $gJrpv = parcelRequire("gJrpv");
module.exports = function isTypedArray(value) {
    return !!$gJrpv(value);
};

});


parcelRegister("kotBY", function(module, exports) {
module.exports = function isBuffer(arg) {
    return arg && typeof arg === "object" && typeof arg.copy === "function" && typeof arg.fill === "function" && typeof arg.readUInt8 === "function";
};

});

parcelRegister("dlqwk", function(module, exports) {
if (typeof Object.create === "function") // implementation from standard node.js 'util' module
module.exports = function inherits(ctor, superCtor) {
    if (superCtor) {
        ctor.super_ = superCtor;
        ctor.prototype = Object.create(superCtor.prototype, {
            constructor: {
                value: ctor,
                enumerable: false,
                writable: true,
                configurable: true
            }
        });
    }
};
else // old school shim for old browsers
module.exports = function inherits(ctor, superCtor) {
    if (superCtor) {
        ctor.super_ = superCtor;
        var TempCtor = function() {};
        TempCtor.prototype = superCtor.prototype;
        ctor.prototype = new TempCtor();
        ctor.prototype.constructor = ctor;
    }
};

});



parcelRegister("8pS6q", function(module, exports) {
// Currently in sync with Node.js lib/internal/assert/assertion_error.js
// https://github.com/nodejs/node/commit/0817840f775032169ddd70c85ac059f18ffcc81c

var $hPtJY = parcelRequire("hPtJY");
"use strict";
function $620aa032cca82da4$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $620aa032cca82da4$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $620aa032cca82da4$var$ownKeys(Object(t), !0).forEach(function(r) {
            $620aa032cca82da4$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $620aa032cca82da4$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $620aa032cca82da4$var$_defineProperty(obj, key, value) {
    key = $620aa032cca82da4$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $620aa032cca82da4$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $620aa032cca82da4$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, $620aa032cca82da4$var$_toPropertyKey(descriptor.key), descriptor);
    }
}
function $620aa032cca82da4$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $620aa032cca82da4$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $620aa032cca82da4$var$_defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}
function $620aa032cca82da4$var$_toPropertyKey(arg) {
    var key = $620aa032cca82da4$var$_toPrimitive(arg, "string");
    return $620aa032cca82da4$var$_typeof(key) === "symbol" ? key : String(key);
}
function $620aa032cca82da4$var$_toPrimitive(input, hint) {
    if ($620aa032cca82da4$var$_typeof(input) !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if ($620aa032cca82da4$var$_typeof(res) !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
function $620aa032cca82da4$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    Object.defineProperty(subClass, "prototype", {
        writable: false
    });
    if (superClass) $620aa032cca82da4$var$_setPrototypeOf(subClass, superClass);
}
function $620aa032cca82da4$var$_createSuper(Derived) {
    var hasNativeReflectConstruct = $620aa032cca82da4$var$_isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = $620aa032cca82da4$var$_getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = $620aa032cca82da4$var$_getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return $620aa032cca82da4$var$_possibleConstructorReturn(this, result);
    };
}
function $620aa032cca82da4$var$_possibleConstructorReturn(self, call) {
    if (call && ($620aa032cca82da4$var$_typeof(call) === "object" || typeof call === "function")) return call;
    else if (call !== void 0) throw new TypeError("Derived constructors may only return object or undefined");
    return $620aa032cca82da4$var$_assertThisInitialized(self);
}
function $620aa032cca82da4$var$_assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function $620aa032cca82da4$var$_wrapNativeSuper(Class) {
    var _cache = typeof Map === "function" ? new Map() : undefined;
    $620aa032cca82da4$var$_wrapNativeSuper = function _wrapNativeSuper(Class) {
        if (Class === null || !$620aa032cca82da4$var$_isNativeFunction(Class)) return Class;
        if (typeof Class !== "function") throw new TypeError("Super expression must either be null or a function");
        if (typeof _cache !== "undefined") {
            if (_cache.has(Class)) return _cache.get(Class);
            _cache.set(Class, Wrapper);
        }
        function Wrapper() {
            return $620aa032cca82da4$var$_construct(Class, arguments, $620aa032cca82da4$var$_getPrototypeOf(this).constructor);
        }
        Wrapper.prototype = Object.create(Class.prototype, {
            constructor: {
                value: Wrapper,
                enumerable: false,
                writable: true,
                configurable: true
            }
        });
        return $620aa032cca82da4$var$_setPrototypeOf(Wrapper, Class);
    };
    return $620aa032cca82da4$var$_wrapNativeSuper(Class);
}
function $620aa032cca82da4$var$_construct(Parent, args, Class) {
    if ($620aa032cca82da4$var$_isNativeReflectConstruct()) $620aa032cca82da4$var$_construct = Reflect.construct.bind();
    else $620aa032cca82da4$var$_construct = function _construct(Parent, args, Class) {
        var a = [
            null
        ];
        a.push.apply(a, args);
        var Constructor = Function.bind.apply(Parent, a);
        var instance = new Constructor();
        if (Class) $620aa032cca82da4$var$_setPrototypeOf(instance, Class.prototype);
        return instance;
    };
    return $620aa032cca82da4$var$_construct.apply(null, arguments);
}
function $620aa032cca82da4$var$_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function $620aa032cca82da4$var$_isNativeFunction(fn) {
    return Function.toString.call(fn).indexOf("[native code]") !== -1;
}
function $620aa032cca82da4$var$_setPrototypeOf(o, p) {
    $620aa032cca82da4$var$_setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $620aa032cca82da4$var$_setPrototypeOf(o, p);
}
function $620aa032cca82da4$var$_getPrototypeOf(o) {
    $620aa032cca82da4$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $620aa032cca82da4$var$_getPrototypeOf(o);
}
function $620aa032cca82da4$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $620aa032cca82da4$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $620aa032cca82da4$var$_typeof(o);
}

var $N7Lcz = parcelRequire("N7Lcz");
var $620aa032cca82da4$var$inspect = $N7Lcz.inspect;

var $cCihK = parcelRequire("cCihK");
var $620aa032cca82da4$var$ERR_INVALID_ARG_TYPE = $cCihK.codes.ERR_INVALID_ARG_TYPE;
// https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/String/endsWith
function $620aa032cca82da4$var$endsWith(str, search, this_len) {
    if (this_len === undefined || this_len > str.length) this_len = str.length;
    return str.substring(this_len - search.length, this_len) === search;
}
// https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/String/repeat
function $620aa032cca82da4$var$repeat(str, count) {
    count = Math.floor(count);
    if (str.length == 0 || count == 0) return "";
    var maxCount = str.length * count;
    count = Math.floor(Math.log(count) / Math.log(2));
    while(count){
        str += str;
        count--;
    }
    str += str.substring(0, maxCount - str.length);
    return str;
}
var $620aa032cca82da4$var$blue = "";
var $620aa032cca82da4$var$green = "";
var $620aa032cca82da4$var$red = "";
var $620aa032cca82da4$var$white = "";
var $620aa032cca82da4$var$kReadableOperator = {
    deepStrictEqual: "Expected values to be strictly deep-equal:",
    strictEqual: "Expected values to be strictly equal:",
    strictEqualObject: 'Expected "actual" to be reference-equal to "expected":',
    deepEqual: "Expected values to be loosely deep-equal:",
    equal: "Expected values to be loosely equal:",
    notDeepStrictEqual: 'Expected "actual" not to be strictly deep-equal to:',
    notStrictEqual: 'Expected "actual" to be strictly unequal to:',
    notStrictEqualObject: 'Expected "actual" not to be reference-equal to "expected":',
    notDeepEqual: 'Expected "actual" not to be loosely deep-equal to:',
    notEqual: 'Expected "actual" to be loosely unequal to:',
    notIdentical: "Values identical but not reference-equal:"
};
// Comparing short primitives should just show === / !== instead of using the
// diff.
var $620aa032cca82da4$var$kMaxShortLength = 10;
function $620aa032cca82da4$var$copyError(source) {
    var keys = Object.keys(source);
    var target = Object.create(Object.getPrototypeOf(source));
    keys.forEach(function(key) {
        target[key] = source[key];
    });
    Object.defineProperty(target, "message", {
        value: source.message
    });
    return target;
}
function $620aa032cca82da4$var$inspectValue(val) {
    // The util.inspect default values could be changed. This makes sure the
    // error messages contain the necessary information nevertheless.
    return $620aa032cca82da4$var$inspect(val, {
        compact: false,
        customInspect: false,
        depth: 1000,
        maxArrayLength: Infinity,
        // Assert compares only enumerable properties (with a few exceptions).
        showHidden: false,
        // Having a long line as error is better than wrapping the line for
        // comparison for now.
        // TODO(BridgeAR): `breakLength` should be limited as soon as soon as we
        // have meta information about the inspected properties (i.e., know where
        // in what line the property starts and ends).
        breakLength: Infinity,
        // Assert does not detect proxies currently.
        showProxy: false,
        sorted: true,
        // Inspect getters as we also check them when comparing entries.
        getters: true
    });
}
function $620aa032cca82da4$var$createErrDiff(actual, expected, operator) {
    var other = "";
    var res = "";
    var lastPos = 0;
    var end = "";
    var skipped = false;
    var actualInspected = $620aa032cca82da4$var$inspectValue(actual);
    var actualLines = actualInspected.split("\n");
    var expectedLines = $620aa032cca82da4$var$inspectValue(expected).split("\n");
    var i = 0;
    var indicator = "";
    // In case both values are objects explicitly mark them as not reference equal
    // for the `strictEqual` operator.
    if (operator === "strictEqual" && $620aa032cca82da4$var$_typeof(actual) === "object" && $620aa032cca82da4$var$_typeof(expected) === "object" && actual !== null && expected !== null) operator = "strictEqualObject";
    // If "actual" and "expected" fit on a single line and they are not strictly
    // equal, check further special handling.
    if (actualLines.length === 1 && expectedLines.length === 1 && actualLines[0] !== expectedLines[0]) {
        var inputLength = actualLines[0].length + expectedLines[0].length;
        // If the character length of "actual" and "expected" together is less than
        // kMaxShortLength and if neither is an object and at least one of them is
        // not `zero`, use the strict equal comparison to visualize the output.
        if (inputLength <= $620aa032cca82da4$var$kMaxShortLength) {
            if (($620aa032cca82da4$var$_typeof(actual) !== "object" || actual === null) && ($620aa032cca82da4$var$_typeof(expected) !== "object" || expected === null) && (actual !== 0 || expected !== 0)) // -0 === +0
            return "".concat($620aa032cca82da4$var$kReadableOperator[operator], "\n\n") + "".concat(actualLines[0], " !== ").concat(expectedLines[0], "\n");
        } else if (operator !== "strictEqualObject") {
            // If the stderr is a tty and the input length is lower than the current
            // columns per line, add a mismatch indicator below the output. If it is
            // not a tty, use a default value of 80 characters.
            var maxLength = $hPtJY.stderr && $hPtJY.stderr.isTTY ? $hPtJY.stderr.columns : 80;
            if (inputLength < maxLength) {
                while(actualLines[0][i] === expectedLines[0][i])i++;
                // Ignore the first characters.
                if (i > 2) {
                    // Add position indicator for the first mismatch in case it is a
                    // single line and the input length is less than the column length.
                    indicator = "\n  ".concat($620aa032cca82da4$var$repeat(" ", i), "^");
                    i = 0;
                }
            }
        }
    }
    // Remove all ending lines that match (this optimizes the output for
    // readability by reducing the number of total changed lines).
    var a = actualLines[actualLines.length - 1];
    var b = expectedLines[expectedLines.length - 1];
    while(a === b){
        if (i++ < 2) end = "\n  ".concat(a).concat(end);
        else other = a;
        actualLines.pop();
        expectedLines.pop();
        if (actualLines.length === 0 || expectedLines.length === 0) break;
        a = actualLines[actualLines.length - 1];
        b = expectedLines[expectedLines.length - 1];
    }
    var maxLines = Math.max(actualLines.length, expectedLines.length);
    // Strict equal with identical objects that are not identical by reference.
    // E.g., assert.deepStrictEqual({ a: Symbol() }, { a: Symbol() })
    if (maxLines === 0) {
        // We have to get the result again. The lines were all removed before.
        var _actualLines = actualInspected.split("\n");
        // Only remove lines in case it makes sense to collapse those.
        // TODO: Accept env to always show the full error.
        if (_actualLines.length > 30) {
            _actualLines[26] = "".concat($620aa032cca82da4$var$blue, "...").concat($620aa032cca82da4$var$white);
            while(_actualLines.length > 27)_actualLines.pop();
        }
        return "".concat($620aa032cca82da4$var$kReadableOperator.notIdentical, "\n\n").concat(_actualLines.join("\n"), "\n");
    }
    if (i > 3) {
        end = "\n".concat($620aa032cca82da4$var$blue, "...").concat($620aa032cca82da4$var$white).concat(end);
        skipped = true;
    }
    if (other !== "") {
        end = "\n  ".concat(other).concat(end);
        other = "";
    }
    var printedLines = 0;
    var msg = $620aa032cca82da4$var$kReadableOperator[operator] + "\n".concat($620aa032cca82da4$var$green, "+ actual").concat($620aa032cca82da4$var$white, " ").concat($620aa032cca82da4$var$red, "- expected").concat($620aa032cca82da4$var$white);
    var skippedMsg = " ".concat($620aa032cca82da4$var$blue, "...").concat($620aa032cca82da4$var$white, " Lines skipped");
    for(i = 0; i < maxLines; i++){
        // Only extra expected lines exist
        var cur = i - lastPos;
        if (actualLines.length < i + 1) {
            // If the last diverging line is more than one line above and the
            // current line is at least line three, add some of the former lines and
            // also add dots to indicate skipped entries.
            if (cur > 1 && i > 2) {
                if (cur > 4) {
                    res += "\n".concat($620aa032cca82da4$var$blue, "...").concat($620aa032cca82da4$var$white);
                    skipped = true;
                } else if (cur > 3) {
                    res += "\n  ".concat(expectedLines[i - 2]);
                    printedLines++;
                }
                res += "\n  ".concat(expectedLines[i - 1]);
                printedLines++;
            }
            // Mark the current line as the last diverging one.
            lastPos = i;
            // Add the expected line to the cache.
            other += "\n".concat($620aa032cca82da4$var$red, "-").concat($620aa032cca82da4$var$white, " ").concat(expectedLines[i]);
            printedLines++;
        // Only extra actual lines exist
        } else if (expectedLines.length < i + 1) {
            // If the last diverging line is more than one line above and the
            // current line is at least line three, add some of the former lines and
            // also add dots to indicate skipped entries.
            if (cur > 1 && i > 2) {
                if (cur > 4) {
                    res += "\n".concat($620aa032cca82da4$var$blue, "...").concat($620aa032cca82da4$var$white);
                    skipped = true;
                } else if (cur > 3) {
                    res += "\n  ".concat(actualLines[i - 2]);
                    printedLines++;
                }
                res += "\n  ".concat(actualLines[i - 1]);
                printedLines++;
            }
            // Mark the current line as the last diverging one.
            lastPos = i;
            // Add the actual line to the result.
            res += "\n".concat($620aa032cca82da4$var$green, "+").concat($620aa032cca82da4$var$white, " ").concat(actualLines[i]);
            printedLines++;
        // Lines diverge
        } else {
            var expectedLine = expectedLines[i];
            var actualLine = actualLines[i];
            // If the lines diverge, specifically check for lines that only diverge by
            // a trailing comma. In that case it is actually identical and we should
            // mark it as such.
            var divergingLines = actualLine !== expectedLine && (!$620aa032cca82da4$var$endsWith(actualLine, ",") || actualLine.slice(0, -1) !== expectedLine);
            // If the expected line has a trailing comma but is otherwise identical,
            // add a comma at the end of the actual line. Otherwise the output could
            // look weird as in:
            //
            //   [
            //     1         // No comma at the end!
            // +   2
            //   ]
            //
            if (divergingLines && $620aa032cca82da4$var$endsWith(expectedLine, ",") && expectedLine.slice(0, -1) === actualLine) {
                divergingLines = false;
                actualLine += ",";
            }
            if (divergingLines) {
                // If the last diverging line is more than one line above and the
                // current line is at least line three, add some of the former lines and
                // also add dots to indicate skipped entries.
                if (cur > 1 && i > 2) {
                    if (cur > 4) {
                        res += "\n".concat($620aa032cca82da4$var$blue, "...").concat($620aa032cca82da4$var$white);
                        skipped = true;
                    } else if (cur > 3) {
                        res += "\n  ".concat(actualLines[i - 2]);
                        printedLines++;
                    }
                    res += "\n  ".concat(actualLines[i - 1]);
                    printedLines++;
                }
                // Mark the current line as the last diverging one.
                lastPos = i;
                // Add the actual line to the result and cache the expected diverging
                // line so consecutive diverging lines show up as +++--- and not +-+-+-.
                res += "\n".concat($620aa032cca82da4$var$green, "+").concat($620aa032cca82da4$var$white, " ").concat(actualLine);
                other += "\n".concat($620aa032cca82da4$var$red, "-").concat($620aa032cca82da4$var$white, " ").concat(expectedLine);
                printedLines += 2;
            // Lines are identical
            } else {
                // Add all cached information to the result before adding other things
                // and reset the cache.
                res += other;
                other = "";
                // If the last diverging line is exactly one line above or if it is the
                // very first line, add the line to the result.
                if (cur === 1 || i === 0) {
                    res += "\n  ".concat(actualLine);
                    printedLines++;
                }
            }
        }
        // Inspected object to big (Show ~20 rows max)
        if (printedLines > 20 && i < maxLines - 2) return "".concat(msg).concat(skippedMsg, "\n").concat(res, "\n").concat($620aa032cca82da4$var$blue, "...").concat($620aa032cca82da4$var$white).concat(other, "\n") + "".concat($620aa032cca82da4$var$blue, "...").concat($620aa032cca82da4$var$white);
    }
    return "".concat(msg).concat(skipped ? skippedMsg : "", "\n").concat(res).concat(other).concat(end).concat(indicator);
}
var $620aa032cca82da4$var$AssertionError = /*#__PURE__*/ function(_Error, _inspect$custom) {
    $620aa032cca82da4$var$_inherits(AssertionError, _Error);
    var _super = $620aa032cca82da4$var$_createSuper(AssertionError);
    function AssertionError(options) {
        var _this;
        $620aa032cca82da4$var$_classCallCheck(this, AssertionError);
        if ($620aa032cca82da4$var$_typeof(options) !== "object" || options === null) throw new $620aa032cca82da4$var$ERR_INVALID_ARG_TYPE("options", "Object", options);
        var message = options.message, operator = options.operator, stackStartFn = options.stackStartFn;
        var actual = options.actual, expected = options.expected;
        var limit = Error.stackTraceLimit;
        Error.stackTraceLimit = 0;
        if (message != null) _this = _super.call(this, String(message));
        else {
            if ($hPtJY.stderr && $hPtJY.stderr.isTTY) {
                // Reset on each call to make sure we handle dynamically set environment
                // variables correct.
                if ($hPtJY.stderr && $hPtJY.stderr.getColorDepth && $hPtJY.stderr.getColorDepth() !== 1) {
                    $620aa032cca82da4$var$blue = "\x1b[34m";
                    $620aa032cca82da4$var$green = "\x1b[32m";
                    $620aa032cca82da4$var$white = "\x1b[39m";
                    $620aa032cca82da4$var$red = "\x1b[31m";
                } else {
                    $620aa032cca82da4$var$blue = "";
                    $620aa032cca82da4$var$green = "";
                    $620aa032cca82da4$var$white = "";
                    $620aa032cca82da4$var$red = "";
                }
            }
            // Prevent the error stack from being visible by duplicating the error
            // in a very close way to the original in case both sides are actually
            // instances of Error.
            if ($620aa032cca82da4$var$_typeof(actual) === "object" && actual !== null && $620aa032cca82da4$var$_typeof(expected) === "object" && expected !== null && "stack" in actual && actual instanceof Error && "stack" in expected && expected instanceof Error) {
                actual = $620aa032cca82da4$var$copyError(actual);
                expected = $620aa032cca82da4$var$copyError(expected);
            }
            if (operator === "deepStrictEqual" || operator === "strictEqual") _this = _super.call(this, $620aa032cca82da4$var$createErrDiff(actual, expected, operator));
            else if (operator === "notDeepStrictEqual" || operator === "notStrictEqual") {
                // In case the objects are equal but the operator requires unequal, show
                // the first object and say A equals B
                var base = $620aa032cca82da4$var$kReadableOperator[operator];
                var res = $620aa032cca82da4$var$inspectValue(actual).split("\n");
                // In case "actual" is an object, it should not be reference equal.
                if (operator === "notStrictEqual" && $620aa032cca82da4$var$_typeof(actual) === "object" && actual !== null) base = $620aa032cca82da4$var$kReadableOperator.notStrictEqualObject;
                // Only remove lines in case it makes sense to collapse those.
                // TODO: Accept env to always show the full error.
                if (res.length > 30) {
                    res[26] = "".concat($620aa032cca82da4$var$blue, "...").concat($620aa032cca82da4$var$white);
                    while(res.length > 27)res.pop();
                }
                // Only print a single input.
                if (res.length === 1) _this = _super.call(this, "".concat(base, " ").concat(res[0]));
                else _this = _super.call(this, "".concat(base, "\n\n").concat(res.join("\n"), "\n"));
            } else {
                var _res = $620aa032cca82da4$var$inspectValue(actual);
                var other = "";
                var knownOperators = $620aa032cca82da4$var$kReadableOperator[operator];
                if (operator === "notDeepEqual" || operator === "notEqual") {
                    _res = "".concat($620aa032cca82da4$var$kReadableOperator[operator], "\n\n").concat(_res);
                    if (_res.length > 1024) _res = "".concat(_res.slice(0, 1021), "...");
                } else {
                    other = "".concat($620aa032cca82da4$var$inspectValue(expected));
                    if (_res.length > 512) _res = "".concat(_res.slice(0, 509), "...");
                    if (other.length > 512) other = "".concat(other.slice(0, 509), "...");
                    if (operator === "deepEqual" || operator === "equal") _res = "".concat(knownOperators, "\n\n").concat(_res, "\n\nshould equal\n\n");
                    else other = " ".concat(operator, " ").concat(other);
                }
                _this = _super.call(this, "".concat(_res).concat(other));
            }
        }
        Error.stackTraceLimit = limit;
        _this.generatedMessage = !message;
        Object.defineProperty($620aa032cca82da4$var$_assertThisInitialized(_this), "name", {
            value: "AssertionError [ERR_ASSERTION]",
            enumerable: false,
            writable: true,
            configurable: true
        });
        _this.code = "ERR_ASSERTION";
        _this.actual = actual;
        _this.expected = expected;
        _this.operator = operator;
        if (Error.captureStackTrace) // eslint-disable-next-line no-restricted-syntax
        Error.captureStackTrace($620aa032cca82da4$var$_assertThisInitialized(_this), stackStartFn);
        // Create error message including the error code in the name.
        _this.stack;
        // Reset the name.
        _this.name = "AssertionError";
        return $620aa032cca82da4$var$_possibleConstructorReturn(_this);
    }
    $620aa032cca82da4$var$_createClass(AssertionError, [
        {
            key: "toString",
            value: function toString() {
                return "".concat(this.name, " [").concat(this.code, "]: ").concat(this.message);
            }
        },
        {
            key: _inspect$custom,
            value: function value(recurseTimes, ctx) {
                // This limits the `actual` and `expected` property default inspection to
                // the minimum depth. Otherwise those values would be too verbose compared
                // to the actual error message which contains a combined view of these two
                // input values.
                return $620aa032cca82da4$var$inspect(this, $620aa032cca82da4$var$_objectSpread($620aa032cca82da4$var$_objectSpread({}, ctx), {}, {
                    customInspect: false,
                    depth: 0
                }));
            }
        }
    ]);
    return AssertionError;
}(/*#__PURE__*/ $620aa032cca82da4$var$_wrapNativeSuper(Error), $620aa032cca82da4$var$inspect.custom);
module.exports = $620aa032cca82da4$var$AssertionError;

});

parcelRegister("boX8x", function(module, exports) {
"use strict";

var $aHVV7 = parcelRequire("aHVV7");
var $84cfceeae7d9941c$var$lacksProperEnumerationOrder = function() {
    if (!Object.assign) return false;
    /*
	 * v8, specifically in node 4.x, has a bug with incorrect property enumeration order
	 * note: this does not detect the bug unless there's 20 characters
	 */ var str = "abcdefghijklmnopqrst";
    var letters = str.split("");
    var map = {};
    for(var i = 0; i < letters.length; ++i)map[letters[i]] = letters[i];
    var obj = Object.assign({}, map);
    var actual = "";
    for(var k in obj)actual += k;
    return str !== actual;
};
var $84cfceeae7d9941c$var$assignHasPendingExceptions = function() {
    if (!Object.assign || !Object.preventExtensions) return false;
    /*
	 * Firefox 37 still has "pending exception" logic in its Object.assign implementation,
	 * which is 72% slower than our shim, and Firefox 40's native implementation.
	 */ var thrower = Object.preventExtensions({
        1: 2
    });
    try {
        Object.assign(thrower, "xy");
    } catch (e) {
        return thrower[1] === "y";
    }
    return false;
};
module.exports = function getPolyfill() {
    if (!Object.assign) return $aHVV7;
    if ($84cfceeae7d9941c$var$lacksProperEnumerationOrder()) return $aHVV7;
    if ($84cfceeae7d9941c$var$assignHasPendingExceptions()) return $aHVV7;
    return Object.assign;
};

});
parcelRegister("aHVV7", function(module, exports) {
"use strict";

var $81enX = parcelRequire("81enX");

var $7cbad94b4017a2be$var$hasSymbols = (parcelRequire("7YWkK"))();

var $hXu6F = parcelRequire("hXu6F");
var $7cbad94b4017a2be$var$toObject = Object;
var $7cbad94b4017a2be$var$$push = $hXu6F("Array.prototype.push");
var $7cbad94b4017a2be$var$$propIsEnumerable = $hXu6F("Object.prototype.propertyIsEnumerable");
var $7cbad94b4017a2be$var$originalGetSymbols = $7cbad94b4017a2be$var$hasSymbols ? Object.getOwnPropertySymbols : null;
// eslint-disable-next-line no-unused-vars
module.exports = function assign(target, source1) {
    if (target == null) throw new TypeError("target must be an object");
    var to = $7cbad94b4017a2be$var$toObject(target); // step 1
    if (arguments.length === 1) return to; // step 2
    for(var s = 1; s < arguments.length; ++s){
        var from = $7cbad94b4017a2be$var$toObject(arguments[s]); // step 3.a.i
        // step 3.a.ii:
        var keys = $81enX(from);
        var getSymbols = $7cbad94b4017a2be$var$hasSymbols && (Object.getOwnPropertySymbols || $7cbad94b4017a2be$var$originalGetSymbols);
        if (getSymbols) {
            var syms = getSymbols(from);
            for(var j = 0; j < syms.length; ++j){
                var key = syms[j];
                if ($7cbad94b4017a2be$var$$propIsEnumerable(from, key)) $7cbad94b4017a2be$var$$push(keys, key);
            }
        }
        // step 3.a.iii:
        for(var i = 0; i < keys.length; ++i){
            var nextKey = keys[i];
            if ($7cbad94b4017a2be$var$$propIsEnumerable(from, nextKey)) {
                var propValue = from[nextKey]; // step 3.a.iii.2.a
                to[nextKey] = propValue; // step 3.a.iii.2.b
            }
        }
    }
    return to; // step 4
};

});
parcelRegister("81enX", function(module, exports) {
"use strict";
var $5d69935f2747da8d$var$slice = Array.prototype.slice;

var $z1gio = parcelRequire("z1gio");
var $5d69935f2747da8d$var$origKeys = Object.keys;

var $5d69935f2747da8d$var$keysShim = $5d69935f2747da8d$var$origKeys ? function keys(o) {
    return $5d69935f2747da8d$var$origKeys(o);
} : (parcelRequire("4nFCC"));
var $5d69935f2747da8d$var$originalKeys = Object.keys;
$5d69935f2747da8d$var$keysShim.shim = function shimObjectKeys() {
    if (Object.keys) {
        var keysWorksWithArguments = function() {
            // Safari 5.0 bug
            var args = Object.keys(arguments);
            return args && args.length === arguments.length;
        }(1, 2);
        if (!keysWorksWithArguments) Object.keys = function keys(object) {
            if ($z1gio(object)) return $5d69935f2747da8d$var$originalKeys($5d69935f2747da8d$var$slice.call(object));
            return $5d69935f2747da8d$var$originalKeys(object);
        };
    } else Object.keys = $5d69935f2747da8d$var$keysShim;
    return Object.keys || $5d69935f2747da8d$var$keysShim;
};
module.exports = $5d69935f2747da8d$var$keysShim;

});
parcelRegister("z1gio", function(module, exports) {
"use strict";
var $06943f92b55ad7fa$var$toStr = Object.prototype.toString;
module.exports = function isArguments(value) {
    var str = $06943f92b55ad7fa$var$toStr.call(value);
    var isArgs = str === "[object Arguments]";
    if (!isArgs) isArgs = str !== "[object Array]" && value !== null && typeof value === "object" && typeof value.length === "number" && value.length >= 0 && $06943f92b55ad7fa$var$toStr.call(value.callee) === "[object Function]";
    return isArgs;
};

});

parcelRegister("4nFCC", function(module, exports) {
"use strict";
var $330998a67e44345d$var$keysShim;

if (!Object.keys) {
    // modified from https://github.com/es-shims/es5-shim
    var $330998a67e44345d$var$has = Object.prototype.hasOwnProperty;
    var $330998a67e44345d$var$toStr = Object.prototype.toString;
    var $330998a67e44345d$var$isArgs = (parcelRequire("z1gio")); // eslint-disable-line global-require
    var $330998a67e44345d$var$isEnumerable = Object.prototype.propertyIsEnumerable;
    var $330998a67e44345d$var$hasDontEnumBug = !$330998a67e44345d$var$isEnumerable.call({
        toString: null
    }, "toString");
    var $330998a67e44345d$var$hasProtoEnumBug = $330998a67e44345d$var$isEnumerable.call(function() {}, "prototype");
    var $330998a67e44345d$var$dontEnums = [
        "toString",
        "toLocaleString",
        "valueOf",
        "hasOwnProperty",
        "isPrototypeOf",
        "propertyIsEnumerable",
        "constructor"
    ];
    var $330998a67e44345d$var$equalsConstructorPrototype = function(o) {
        var ctor = o.constructor;
        return ctor && ctor.prototype === o;
    };
    var $330998a67e44345d$var$excludedKeys = {
        $applicationCache: true,
        $console: true,
        $external: true,
        $frame: true,
        $frameElement: true,
        $frames: true,
        $innerHeight: true,
        $innerWidth: true,
        $onmozfullscreenchange: true,
        $onmozfullscreenerror: true,
        $outerHeight: true,
        $outerWidth: true,
        $pageXOffset: true,
        $pageYOffset: true,
        $parent: true,
        $scrollLeft: true,
        $scrollTop: true,
        $scrollX: true,
        $scrollY: true,
        $self: true,
        $webkitIndexedDB: true,
        $webkitStorageInfo: true,
        $window: true
    };
    var $330998a67e44345d$var$hasAutomationEqualityBug = function() {
        /* global window */ if (typeof window === "undefined") return false;
        for(var k in window)try {
            if (!$330998a67e44345d$var$excludedKeys["$" + k] && $330998a67e44345d$var$has.call(window, k) && window[k] !== null && typeof window[k] === "object") try {
                $330998a67e44345d$var$equalsConstructorPrototype(window[k]);
            } catch (e) {
                return true;
            }
        } catch (e) {
            return true;
        }
        return false;
    }();
    var $330998a67e44345d$var$equalsConstructorPrototypeIfNotBuggy = function(o) {
        /* global window */ if (typeof window === "undefined" || !$330998a67e44345d$var$hasAutomationEqualityBug) return $330998a67e44345d$var$equalsConstructorPrototype(o);
        try {
            return $330998a67e44345d$var$equalsConstructorPrototype(o);
        } catch (e) {
            return false;
        }
    };
    $330998a67e44345d$var$keysShim = function keys(object) {
        var isObject = object !== null && typeof object === "object";
        var isFunction = $330998a67e44345d$var$toStr.call(object) === "[object Function]";
        var isArguments = $330998a67e44345d$var$isArgs(object);
        var isString = isObject && $330998a67e44345d$var$toStr.call(object) === "[object String]";
        var theKeys = [];
        if (!isObject && !isFunction && !isArguments) throw new TypeError("Object.keys called on a non-object");
        var skipProto = $330998a67e44345d$var$hasProtoEnumBug && isFunction;
        if (isString && object.length > 0 && !$330998a67e44345d$var$has.call(object, 0)) for(var i = 0; i < object.length; ++i)theKeys.push(String(i));
        if (isArguments && object.length > 0) for(var j = 0; j < object.length; ++j)theKeys.push(String(j));
        else {
            for(var name in object)if (!(skipProto && name === "prototype") && $330998a67e44345d$var$has.call(object, name)) theKeys.push(String(name));
        }
        if ($330998a67e44345d$var$hasDontEnumBug) {
            var skipConstructor = $330998a67e44345d$var$equalsConstructorPrototypeIfNotBuggy(object);
            for(var k = 0; k < $330998a67e44345d$var$dontEnums.length; ++k)if (!(skipConstructor && $330998a67e44345d$var$dontEnums[k] === "constructor") && $330998a67e44345d$var$has.call(object, $330998a67e44345d$var$dontEnums[k])) theKeys.push($330998a67e44345d$var$dontEnums[k]);
        }
        return theKeys;
    };
}
module.exports = $330998a67e44345d$var$keysShim;

});




parcelRegister("5SxoI", function(module, exports) {
"use strict";

var $6wuPW = parcelRequire("6wuPW");
module.exports = function getPolyfill() {
    return typeof Object.is === "function" ? Object.is : $6wuPW;
};

});
parcelRegister("6wuPW", function(module, exports) {
"use strict";
var $4bfda6cb765ad269$var$numberIsNaN = function(value) {
    return value !== value;
};
module.exports = function is(a, b) {
    if (a === 0 && b === 0) return 1 / a === 1 / b;
    if (a === b) return true;
    if ($4bfda6cb765ad269$var$numberIsNaN(a) && $4bfda6cb765ad269$var$numberIsNaN(b)) return true;
    return false;
};

});


parcelRegister("3LKhK", function(module, exports) {
// Currently in sync with Node.js lib/internal/util/comparisons.js
// https://github.com/nodejs/node/commit/112cc7c27551254aa2b17098fb774867f05ed0d9
"use strict";
function $2be9aa30bff457b9$var$_slicedToArray(arr, i) {
    return $2be9aa30bff457b9$var$_arrayWithHoles(arr) || $2be9aa30bff457b9$var$_iterableToArrayLimit(arr, i) || $2be9aa30bff457b9$var$_unsupportedIterableToArray(arr, i) || $2be9aa30bff457b9$var$_nonIterableRest();
}
function $2be9aa30bff457b9$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $2be9aa30bff457b9$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $2be9aa30bff457b9$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $2be9aa30bff457b9$var$_arrayLikeToArray(o, minLen);
}
function $2be9aa30bff457b9$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $2be9aa30bff457b9$var$_iterableToArrayLimit(r, l) {
    var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (null != t) {
        var e, n, i, u, a = [], f = !0, o = !1;
        try {
            if (i = (t = t.call(r)).next, 0 === l) {
                if (Object(t) !== t) return;
                f = !1;
            } else for(; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
        } catch (r) {
            o = !0, n = r;
        } finally{
            try {
                if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return;
            } finally{
                if (o) throw n;
            }
        }
        return a;
    }
}
function $2be9aa30bff457b9$var$_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function $2be9aa30bff457b9$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $2be9aa30bff457b9$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $2be9aa30bff457b9$var$_typeof(o);
}
var $2be9aa30bff457b9$var$regexFlagsSupported = /a/g.flags !== undefined;
var $2be9aa30bff457b9$var$arrayFromSet = function arrayFromSet(set) {
    var array = [];
    set.forEach(function(value) {
        return array.push(value);
    });
    return array;
};
var $2be9aa30bff457b9$var$arrayFromMap = function arrayFromMap(map) {
    var array = [];
    map.forEach(function(value, key) {
        return array.push([
            key,
            value
        ]);
    });
    return array;
};

var $2be9aa30bff457b9$var$objectIs = Object.is ? Object.is : (parcelRequire("eT9RM"));
var $2be9aa30bff457b9$var$objectGetOwnPropertySymbols = Object.getOwnPropertySymbols ? Object.getOwnPropertySymbols : function() {
    return [];
};

var $2be9aa30bff457b9$var$numberIsNaN = Number.isNaN ? Number.isNaN : (parcelRequire("c8Cyq"));
function $2be9aa30bff457b9$var$uncurryThis(f) {
    return f.call.bind(f);
}
var $2be9aa30bff457b9$var$hasOwnProperty = $2be9aa30bff457b9$var$uncurryThis(Object.prototype.hasOwnProperty);
var $2be9aa30bff457b9$var$propertyIsEnumerable = $2be9aa30bff457b9$var$uncurryThis(Object.prototype.propertyIsEnumerable);
var $2be9aa30bff457b9$var$objectToString = $2be9aa30bff457b9$var$uncurryThis(Object.prototype.toString);

var $N7Lcz = parcelRequire("N7Lcz");
var $2be9aa30bff457b9$require$_require$types = $N7Lcz.types;
var $2be9aa30bff457b9$var$isAnyArrayBuffer = $2be9aa30bff457b9$require$_require$types.isAnyArrayBuffer, $2be9aa30bff457b9$var$isArrayBufferView = $2be9aa30bff457b9$require$_require$types.isArrayBufferView, $2be9aa30bff457b9$var$isDate = $2be9aa30bff457b9$require$_require$types.isDate, $2be9aa30bff457b9$var$isMap = $2be9aa30bff457b9$require$_require$types.isMap, $2be9aa30bff457b9$var$isRegExp = $2be9aa30bff457b9$require$_require$types.isRegExp, $2be9aa30bff457b9$var$isSet = $2be9aa30bff457b9$require$_require$types.isSet, $2be9aa30bff457b9$var$isNativeError = $2be9aa30bff457b9$require$_require$types.isNativeError, $2be9aa30bff457b9$var$isBoxedPrimitive = $2be9aa30bff457b9$require$_require$types.isBoxedPrimitive, $2be9aa30bff457b9$var$isNumberObject = $2be9aa30bff457b9$require$_require$types.isNumberObject, $2be9aa30bff457b9$var$isStringObject = $2be9aa30bff457b9$require$_require$types.isStringObject, $2be9aa30bff457b9$var$isBooleanObject = $2be9aa30bff457b9$require$_require$types.isBooleanObject, $2be9aa30bff457b9$var$isBigIntObject = $2be9aa30bff457b9$require$_require$types.isBigIntObject, $2be9aa30bff457b9$var$isSymbolObject = $2be9aa30bff457b9$require$_require$types.isSymbolObject, $2be9aa30bff457b9$var$isFloat32Array = $2be9aa30bff457b9$require$_require$types.isFloat32Array, $2be9aa30bff457b9$var$isFloat64Array = $2be9aa30bff457b9$require$_require$types.isFloat64Array;
function $2be9aa30bff457b9$var$isNonIndex(key) {
    if (key.length === 0 || key.length > 10) return true;
    for(var i = 0; i < key.length; i++){
        var code = key.charCodeAt(i);
        if (code < 48 || code > 57) return true;
    }
    // The maximum size for an array is 2 ** 32 -1.
    return key.length === 10 && key >= Math.pow(2, 32);
}
function $2be9aa30bff457b9$var$getOwnNonIndexProperties(value) {
    return Object.keys(value).filter($2be9aa30bff457b9$var$isNonIndex).concat($2be9aa30bff457b9$var$objectGetOwnPropertySymbols(value).filter(Object.prototype.propertyIsEnumerable.bind(value)));
}
// Taken from https://github.com/feross/buffer/blob/680e9e5e488f22aac27599a57dc844a6315928dd/index.js
// original notice:
/*!
 * The buffer module from node.js, for the browser.
 *
 * @author   Feross Aboukhadijeh <feross@feross.org> <http://feross.org>
 * @license  MIT
 */ function $2be9aa30bff457b9$var$compare(a, b) {
    if (a === b) return 0;
    var x = a.length;
    var y = b.length;
    for(var i = 0, len = Math.min(x, y); i < len; ++i)if (a[i] !== b[i]) {
        x = a[i];
        y = b[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
}
var $2be9aa30bff457b9$var$ONLY_ENUMERABLE = undefined;
var $2be9aa30bff457b9$var$kStrict = true;
var $2be9aa30bff457b9$var$kLoose = false;
var $2be9aa30bff457b9$var$kNoIterator = 0;
var $2be9aa30bff457b9$var$kIsArray = 1;
var $2be9aa30bff457b9$var$kIsSet = 2;
var $2be9aa30bff457b9$var$kIsMap = 3;
// Check if they have the same source and flags
function $2be9aa30bff457b9$var$areSimilarRegExps(a, b) {
    return $2be9aa30bff457b9$var$regexFlagsSupported ? a.source === b.source && a.flags === b.flags : RegExp.prototype.toString.call(a) === RegExp.prototype.toString.call(b);
}
function $2be9aa30bff457b9$var$areSimilarFloatArrays(a, b) {
    if (a.byteLength !== b.byteLength) return false;
    for(var offset = 0; offset < a.byteLength; offset++){
        if (a[offset] !== b[offset]) return false;
    }
    return true;
}
function $2be9aa30bff457b9$var$areSimilarTypedArrays(a, b) {
    if (a.byteLength !== b.byteLength) return false;
    return $2be9aa30bff457b9$var$compare(new Uint8Array(a.buffer, a.byteOffset, a.byteLength), new Uint8Array(b.buffer, b.byteOffset, b.byteLength)) === 0;
}
function $2be9aa30bff457b9$var$areEqualArrayBuffers(buf1, buf2) {
    return buf1.byteLength === buf2.byteLength && $2be9aa30bff457b9$var$compare(new Uint8Array(buf1), new Uint8Array(buf2)) === 0;
}
function $2be9aa30bff457b9$var$isEqualBoxedPrimitive(val1, val2) {
    if ($2be9aa30bff457b9$var$isNumberObject(val1)) return $2be9aa30bff457b9$var$isNumberObject(val2) && $2be9aa30bff457b9$var$objectIs(Number.prototype.valueOf.call(val1), Number.prototype.valueOf.call(val2));
    if ($2be9aa30bff457b9$var$isStringObject(val1)) return $2be9aa30bff457b9$var$isStringObject(val2) && String.prototype.valueOf.call(val1) === String.prototype.valueOf.call(val2);
    if ($2be9aa30bff457b9$var$isBooleanObject(val1)) return $2be9aa30bff457b9$var$isBooleanObject(val2) && Boolean.prototype.valueOf.call(val1) === Boolean.prototype.valueOf.call(val2);
    if ($2be9aa30bff457b9$var$isBigIntObject(val1)) return $2be9aa30bff457b9$var$isBigIntObject(val2) && BigInt.prototype.valueOf.call(val1) === BigInt.prototype.valueOf.call(val2);
    return $2be9aa30bff457b9$var$isSymbolObject(val2) && Symbol.prototype.valueOf.call(val1) === Symbol.prototype.valueOf.call(val2);
}
// Notes: Type tags are historical [[Class]] properties that can be set by
// FunctionTemplate::SetClassName() in C++ or Symbol.toStringTag in JS
// and retrieved using Object.prototype.toString.call(obj) in JS
// See https://tc39.github.io/ecma262/#sec-object.prototype.tostring
// for a list of tags pre-defined in the spec.
// There are some unspecified tags in the wild too (e.g. typed array tags).
// Since tags can be altered, they only serve fast failures
//
// Typed arrays and buffers are checked by comparing the content in their
// underlying ArrayBuffer. This optimization requires that it's
// reasonable to interpret their underlying memory in the same way,
// which is checked by comparing their type tags.
// (e.g. a Uint8Array and a Uint16Array with the same memory content
// could still be different because they will be interpreted differently).
//
// For strict comparison, objects should have
// a) The same built-in type tags
// b) The same prototypes.
function $2be9aa30bff457b9$var$innerDeepEqual(val1, val2, strict, memos) {
    // All identical values are equivalent, as determined by ===.
    if (val1 === val2) {
        if (val1 !== 0) return true;
        return strict ? $2be9aa30bff457b9$var$objectIs(val1, val2) : true;
    }
    // Check more closely if val1 and val2 are equal.
    if (strict) {
        if ($2be9aa30bff457b9$var$_typeof(val1) !== "object") return typeof val1 === "number" && $2be9aa30bff457b9$var$numberIsNaN(val1) && $2be9aa30bff457b9$var$numberIsNaN(val2);
        if ($2be9aa30bff457b9$var$_typeof(val2) !== "object" || val1 === null || val2 === null) return false;
        if (Object.getPrototypeOf(val1) !== Object.getPrototypeOf(val2)) return false;
    } else {
        if (val1 === null || $2be9aa30bff457b9$var$_typeof(val1) !== "object") {
            if (val2 === null || $2be9aa30bff457b9$var$_typeof(val2) !== "object") // eslint-disable-next-line eqeqeq
            return val1 == val2;
            return false;
        }
        if (val2 === null || $2be9aa30bff457b9$var$_typeof(val2) !== "object") return false;
    }
    var val1Tag = $2be9aa30bff457b9$var$objectToString(val1);
    var val2Tag = $2be9aa30bff457b9$var$objectToString(val2);
    if (val1Tag !== val2Tag) return false;
    if (Array.isArray(val1)) {
        // Check for sparse arrays and general fast path
        if (val1.length !== val2.length) return false;
        var keys1 = $2be9aa30bff457b9$var$getOwnNonIndexProperties(val1, $2be9aa30bff457b9$var$ONLY_ENUMERABLE);
        var keys2 = $2be9aa30bff457b9$var$getOwnNonIndexProperties(val2, $2be9aa30bff457b9$var$ONLY_ENUMERABLE);
        if (keys1.length !== keys2.length) return false;
        return $2be9aa30bff457b9$var$keyCheck(val1, val2, strict, memos, $2be9aa30bff457b9$var$kIsArray, keys1);
    }
    // [browserify] This triggers on certain types in IE (Map/Set) so we don't
    // wan't to early return out of the rest of the checks. However we can check
    // if the second value is one of these values and the first isn't.
    if (val1Tag === "[object Object]") {
        // return keyCheck(val1, val2, strict, memos, kNoIterator);
        if (!$2be9aa30bff457b9$var$isMap(val1) && $2be9aa30bff457b9$var$isMap(val2) || !$2be9aa30bff457b9$var$isSet(val1) && $2be9aa30bff457b9$var$isSet(val2)) return false;
    }
    if ($2be9aa30bff457b9$var$isDate(val1)) {
        if (!$2be9aa30bff457b9$var$isDate(val2) || Date.prototype.getTime.call(val1) !== Date.prototype.getTime.call(val2)) return false;
    } else if ($2be9aa30bff457b9$var$isRegExp(val1)) {
        if (!$2be9aa30bff457b9$var$isRegExp(val2) || !$2be9aa30bff457b9$var$areSimilarRegExps(val1, val2)) return false;
    } else if ($2be9aa30bff457b9$var$isNativeError(val1) || val1 instanceof Error) {
        // Do not compare the stack as it might differ even though the error itself
        // is otherwise identical.
        if (val1.message !== val2.message || val1.name !== val2.name) return false;
    } else if ($2be9aa30bff457b9$var$isArrayBufferView(val1)) {
        if (!strict && ($2be9aa30bff457b9$var$isFloat32Array(val1) || $2be9aa30bff457b9$var$isFloat64Array(val1))) {
            if (!$2be9aa30bff457b9$var$areSimilarFloatArrays(val1, val2)) return false;
        } else if (!$2be9aa30bff457b9$var$areSimilarTypedArrays(val1, val2)) return false;
        // Buffer.compare returns true, so val1.length === val2.length. If they both
        // only contain numeric keys, we don't need to exam further than checking
        // the symbols.
        var _keys = $2be9aa30bff457b9$var$getOwnNonIndexProperties(val1, $2be9aa30bff457b9$var$ONLY_ENUMERABLE);
        var _keys2 = $2be9aa30bff457b9$var$getOwnNonIndexProperties(val2, $2be9aa30bff457b9$var$ONLY_ENUMERABLE);
        if (_keys.length !== _keys2.length) return false;
        return $2be9aa30bff457b9$var$keyCheck(val1, val2, strict, memos, $2be9aa30bff457b9$var$kNoIterator, _keys);
    } else if ($2be9aa30bff457b9$var$isSet(val1)) {
        if (!$2be9aa30bff457b9$var$isSet(val2) || val1.size !== val2.size) return false;
        return $2be9aa30bff457b9$var$keyCheck(val1, val2, strict, memos, $2be9aa30bff457b9$var$kIsSet);
    } else if ($2be9aa30bff457b9$var$isMap(val1)) {
        if (!$2be9aa30bff457b9$var$isMap(val2) || val1.size !== val2.size) return false;
        return $2be9aa30bff457b9$var$keyCheck(val1, val2, strict, memos, $2be9aa30bff457b9$var$kIsMap);
    } else if ($2be9aa30bff457b9$var$isAnyArrayBuffer(val1)) {
        if (!$2be9aa30bff457b9$var$areEqualArrayBuffers(val1, val2)) return false;
    } else if ($2be9aa30bff457b9$var$isBoxedPrimitive(val1) && !$2be9aa30bff457b9$var$isEqualBoxedPrimitive(val1, val2)) return false;
    return $2be9aa30bff457b9$var$keyCheck(val1, val2, strict, memos, $2be9aa30bff457b9$var$kNoIterator);
}
function $2be9aa30bff457b9$var$getEnumerables(val, keys) {
    return keys.filter(function(k) {
        return $2be9aa30bff457b9$var$propertyIsEnumerable(val, k);
    });
}
function $2be9aa30bff457b9$var$keyCheck(val1, val2, strict, memos, iterationType, aKeys) {
    // For all remaining Object pairs, including Array, objects and Maps,
    // equivalence is determined by having:
    // a) The same number of owned enumerable properties
    // b) The same set of keys/indexes (although not necessarily the same order)
    // c) Equivalent values for every corresponding key/index
    // d) For Sets and Maps, equal contents
    // Note: this accounts for both named and indexed properties on Arrays.
    if (arguments.length === 5) {
        aKeys = Object.keys(val1);
        var bKeys = Object.keys(val2);
        // The pair must have the same number of owned properties.
        if (aKeys.length !== bKeys.length) return false;
    }
    // Cheap key test
    var i = 0;
    for(; i < aKeys.length; i++){
        if (!$2be9aa30bff457b9$var$hasOwnProperty(val2, aKeys[i])) return false;
    }
    if (strict && arguments.length === 5) {
        var symbolKeysA = $2be9aa30bff457b9$var$objectGetOwnPropertySymbols(val1);
        if (symbolKeysA.length !== 0) {
            var count = 0;
            for(i = 0; i < symbolKeysA.length; i++){
                var key = symbolKeysA[i];
                if ($2be9aa30bff457b9$var$propertyIsEnumerable(val1, key)) {
                    if (!$2be9aa30bff457b9$var$propertyIsEnumerable(val2, key)) return false;
                    aKeys.push(key);
                    count++;
                } else if ($2be9aa30bff457b9$var$propertyIsEnumerable(val2, key)) return false;
            }
            var symbolKeysB = $2be9aa30bff457b9$var$objectGetOwnPropertySymbols(val2);
            if (symbolKeysA.length !== symbolKeysB.length && $2be9aa30bff457b9$var$getEnumerables(val2, symbolKeysB).length !== count) return false;
        } else {
            var _symbolKeysB = $2be9aa30bff457b9$var$objectGetOwnPropertySymbols(val2);
            if (_symbolKeysB.length !== 0 && $2be9aa30bff457b9$var$getEnumerables(val2, _symbolKeysB).length !== 0) return false;
        }
    }
    if (aKeys.length === 0 && (iterationType === $2be9aa30bff457b9$var$kNoIterator || iterationType === $2be9aa30bff457b9$var$kIsArray && val1.length === 0 || val1.size === 0)) return true;
    // Use memos to handle cycles.
    if (memos === undefined) memos = {
        val1: new Map(),
        val2: new Map(),
        position: 0
    };
    else {
        // We prevent up to two map.has(x) calls by directly retrieving the value
        // and checking for undefined. The map can only contain numbers, so it is
        // safe to check for undefined only.
        var val2MemoA = memos.val1.get(val1);
        if (val2MemoA !== undefined) {
            var val2MemoB = memos.val2.get(val2);
            if (val2MemoB !== undefined) return val2MemoA === val2MemoB;
        }
        memos.position++;
    }
    memos.val1.set(val1, memos.position);
    memos.val2.set(val2, memos.position);
    var areEq = $2be9aa30bff457b9$var$objEquiv(val1, val2, strict, aKeys, memos, iterationType);
    memos.val1.delete(val1);
    memos.val2.delete(val2);
    return areEq;
}
function $2be9aa30bff457b9$var$setHasEqualElement(set, val1, strict, memo) {
    // Go looking.
    var setValues = $2be9aa30bff457b9$var$arrayFromSet(set);
    for(var i = 0; i < setValues.length; i++){
        var val2 = setValues[i];
        if ($2be9aa30bff457b9$var$innerDeepEqual(val1, val2, strict, memo)) {
            // Remove the matching element to make sure we do not check that again.
            set.delete(val2);
            return true;
        }
    }
    return false;
}
// See https://developer.mozilla.org/en-US/docs/Web/JavaScript/Equality_comparisons_and_sameness#Loose_equality_using
// Sadly it is not possible to detect corresponding values properly in case the
// type is a string, number, bigint or boolean. The reason is that those values
// can match lots of different string values (e.g., 1n == '+00001').
function $2be9aa30bff457b9$var$findLooseMatchingPrimitives(prim) {
    switch($2be9aa30bff457b9$var$_typeof(prim)){
        case "undefined":
            return null;
        case "object":
            // Only pass in null as object!
            return undefined;
        case "symbol":
            return false;
        case "string":
            prim = +prim;
        // Loose equal entries exist only if the string is possible to convert to
        // a regular number and not NaN.
        // Fall through
        case "number":
            if ($2be9aa30bff457b9$var$numberIsNaN(prim)) return false;
    }
    return true;
}
function $2be9aa30bff457b9$var$setMightHaveLoosePrim(a, b, prim) {
    var altValue = $2be9aa30bff457b9$var$findLooseMatchingPrimitives(prim);
    if (altValue != null) return altValue;
    return b.has(altValue) && !a.has(altValue);
}
function $2be9aa30bff457b9$var$mapMightHaveLoosePrim(a, b, prim, item, memo) {
    var altValue = $2be9aa30bff457b9$var$findLooseMatchingPrimitives(prim);
    if (altValue != null) return altValue;
    var curB = b.get(altValue);
    if (curB === undefined && !b.has(altValue) || !$2be9aa30bff457b9$var$innerDeepEqual(item, curB, false, memo)) return false;
    return !a.has(altValue) && $2be9aa30bff457b9$var$innerDeepEqual(item, curB, false, memo);
}
function $2be9aa30bff457b9$var$setEquiv(a, b, strict, memo) {
    // This is a lazily initiated Set of entries which have to be compared
    // pairwise.
    var set = null;
    var aValues = $2be9aa30bff457b9$var$arrayFromSet(a);
    for(var i = 0; i < aValues.length; i++){
        var val = aValues[i];
        // Note: Checking for the objects first improves the performance for object
        // heavy sets but it is a minor slow down for primitives. As they are fast
        // to check this improves the worst case scenario instead.
        if ($2be9aa30bff457b9$var$_typeof(val) === "object" && val !== null) {
            if (set === null) set = new Set();
            // If the specified value doesn't exist in the second set its an not null
            // object (or non strict only: a not matching primitive) we'll need to go
            // hunting for something thats deep-(strict-)equal to it. To make this
            // O(n log n) complexity we have to copy these values in a new set first.
            set.add(val);
        } else if (!b.has(val)) {
            if (strict) return false;
            // Fast path to detect missing string, symbol, undefined and null values.
            if (!$2be9aa30bff457b9$var$setMightHaveLoosePrim(a, b, val)) return false;
            if (set === null) set = new Set();
            set.add(val);
        }
    }
    if (set !== null) {
        var bValues = $2be9aa30bff457b9$var$arrayFromSet(b);
        for(var _i = 0; _i < bValues.length; _i++){
            var _val = bValues[_i];
            // We have to check if a primitive value is already
            // matching and only if it's not, go hunting for it.
            if ($2be9aa30bff457b9$var$_typeof(_val) === "object" && _val !== null) {
                if (!$2be9aa30bff457b9$var$setHasEqualElement(set, _val, strict, memo)) return false;
            } else if (!strict && !a.has(_val) && !$2be9aa30bff457b9$var$setHasEqualElement(set, _val, strict, memo)) return false;
        }
        return set.size === 0;
    }
    return true;
}
function $2be9aa30bff457b9$var$mapHasEqualEntry(set, map, key1, item1, strict, memo) {
    // To be able to handle cases like:
    //   Map([[{}, 'a'], [{}, 'b']]) vs Map([[{}, 'b'], [{}, 'a']])
    // ... we need to consider *all* matching keys, not just the first we find.
    var setValues = $2be9aa30bff457b9$var$arrayFromSet(set);
    for(var i = 0; i < setValues.length; i++){
        var key2 = setValues[i];
        if ($2be9aa30bff457b9$var$innerDeepEqual(key1, key2, strict, memo) && $2be9aa30bff457b9$var$innerDeepEqual(item1, map.get(key2), strict, memo)) {
            set.delete(key2);
            return true;
        }
    }
    return false;
}
function $2be9aa30bff457b9$var$mapEquiv(a, b, strict, memo) {
    var set = null;
    var aEntries = $2be9aa30bff457b9$var$arrayFromMap(a);
    for(var i = 0; i < aEntries.length; i++){
        var _aEntries$i = $2be9aa30bff457b9$var$_slicedToArray(aEntries[i], 2), key = _aEntries$i[0], item1 = _aEntries$i[1];
        if ($2be9aa30bff457b9$var$_typeof(key) === "object" && key !== null) {
            if (set === null) set = new Set();
            set.add(key);
        } else {
            // By directly retrieving the value we prevent another b.has(key) check in
            // almost all possible cases.
            var item2 = b.get(key);
            if (item2 === undefined && !b.has(key) || !$2be9aa30bff457b9$var$innerDeepEqual(item1, item2, strict, memo)) {
                if (strict) return false;
                // Fast path to detect missing string, symbol, undefined and null
                // keys.
                if (!$2be9aa30bff457b9$var$mapMightHaveLoosePrim(a, b, key, item1, memo)) return false;
                if (set === null) set = new Set();
                set.add(key);
            }
        }
    }
    if (set !== null) {
        var bEntries = $2be9aa30bff457b9$var$arrayFromMap(b);
        for(var _i2 = 0; _i2 < bEntries.length; _i2++){
            var _bEntries$_i = $2be9aa30bff457b9$var$_slicedToArray(bEntries[_i2], 2), _key = _bEntries$_i[0], item = _bEntries$_i[1];
            if ($2be9aa30bff457b9$var$_typeof(_key) === "object" && _key !== null) {
                if (!$2be9aa30bff457b9$var$mapHasEqualEntry(set, a, _key, item, strict, memo)) return false;
            } else if (!strict && (!a.has(_key) || !$2be9aa30bff457b9$var$innerDeepEqual(a.get(_key), item, false, memo)) && !$2be9aa30bff457b9$var$mapHasEqualEntry(set, a, _key, item, false, memo)) return false;
        }
        return set.size === 0;
    }
    return true;
}
function $2be9aa30bff457b9$var$objEquiv(a, b, strict, keys, memos, iterationType) {
    // Sets and maps don't have their entries accessible via normal object
    // properties.
    var i = 0;
    if (iterationType === $2be9aa30bff457b9$var$kIsSet) {
        if (!$2be9aa30bff457b9$var$setEquiv(a, b, strict, memos)) return false;
    } else if (iterationType === $2be9aa30bff457b9$var$kIsMap) {
        if (!$2be9aa30bff457b9$var$mapEquiv(a, b, strict, memos)) return false;
    } else if (iterationType === $2be9aa30bff457b9$var$kIsArray) for(; i < a.length; i++){
        if ($2be9aa30bff457b9$var$hasOwnProperty(a, i)) {
            if (!$2be9aa30bff457b9$var$hasOwnProperty(b, i) || !$2be9aa30bff457b9$var$innerDeepEqual(a[i], b[i], strict, memos)) return false;
        } else if ($2be9aa30bff457b9$var$hasOwnProperty(b, i)) return false;
        else {
            // Array is sparse.
            var keysA = Object.keys(a);
            for(; i < keysA.length; i++){
                var key = keysA[i];
                if (!$2be9aa30bff457b9$var$hasOwnProperty(b, key) || !$2be9aa30bff457b9$var$innerDeepEqual(a[key], b[key], strict, memos)) return false;
            }
            if (keysA.length !== Object.keys(b).length) return false;
            return true;
        }
    }
    // The pair must have equivalent values for every corresponding key.
    // Possibly expensive deep test:
    for(i = 0; i < keys.length; i++){
        var _key2 = keys[i];
        if (!$2be9aa30bff457b9$var$innerDeepEqual(a[_key2], b[_key2], strict, memos)) return false;
    }
    return true;
}
function $2be9aa30bff457b9$var$isDeepEqual(val1, val2) {
    return $2be9aa30bff457b9$var$innerDeepEqual(val1, val2, $2be9aa30bff457b9$var$kLoose);
}
function $2be9aa30bff457b9$var$isDeepStrictEqual(val1, val2) {
    return $2be9aa30bff457b9$var$innerDeepEqual(val1, val2, $2be9aa30bff457b9$var$kStrict);
}
module.exports = {
    isDeepEqual: $2be9aa30bff457b9$var$isDeepEqual,
    isDeepStrictEqual: $2be9aa30bff457b9$var$isDeepStrictEqual
};

});
parcelRegister("eT9RM", function(module, exports) {
"use strict";

var $1UbTr = parcelRequire("1UbTr");

var $cOB0F = parcelRequire("cOB0F");

var $6wuPW = parcelRequire("6wuPW");

var $5SxoI = parcelRequire("5SxoI");

var $bNbuK = parcelRequire("bNbuK");
var $ad6ddb07ef0cb149$var$polyfill = $cOB0F($5SxoI(), Object);
$1UbTr($ad6ddb07ef0cb149$var$polyfill, {
    getPolyfill: $5SxoI,
    implementation: $6wuPW,
    shim: $bNbuK
});
module.exports = $ad6ddb07ef0cb149$var$polyfill;

});
parcelRegister("1UbTr", function(module, exports) {
"use strict";

var $81enX = parcelRequire("81enX");
var $16343f2546a69e4c$var$hasSymbols = typeof Symbol === "function" && typeof Symbol("foo") === "symbol";
var $16343f2546a69e4c$var$toStr = Object.prototype.toString;
var $16343f2546a69e4c$var$concat = Array.prototype.concat;

var $5FEEt = parcelRequire("5FEEt");
var $16343f2546a69e4c$var$isFunction = function(fn) {
    return typeof fn === "function" && $16343f2546a69e4c$var$toStr.call(fn) === "[object Function]";
};

var $16343f2546a69e4c$var$supportsDescriptors = (parcelRequire("i16wS"))();
var $16343f2546a69e4c$var$defineProperty = function(object, name, value, predicate) {
    if (name in object) {
        if (predicate === true) {
            if (object[name] === value) return;
        } else if (!$16343f2546a69e4c$var$isFunction(predicate) || !predicate()) return;
    }
    if ($16343f2546a69e4c$var$supportsDescriptors) $5FEEt(object, name, value, true);
    else $5FEEt(object, name, value);
};
var $16343f2546a69e4c$var$defineProperties = function(object, map) {
    var predicates = arguments.length > 2 ? arguments[2] : {};
    var props = $81enX(map);
    if ($16343f2546a69e4c$var$hasSymbols) props = $16343f2546a69e4c$var$concat.call(props, Object.getOwnPropertySymbols(map));
    for(var i = 0; i < props.length; i += 1)$16343f2546a69e4c$var$defineProperty(object, props[i], map[props[i]], predicates[props[i]]);
};
$16343f2546a69e4c$var$defineProperties.supportsDescriptors = !!$16343f2546a69e4c$var$supportsDescriptors;
module.exports = $16343f2546a69e4c$var$defineProperties;

});

parcelRegister("bNbuK", function(module, exports) {
"use strict";

var $5SxoI = parcelRequire("5SxoI");

var $1UbTr = parcelRequire("1UbTr");
module.exports = function shimObjectIs() {
    var polyfill = $5SxoI();
    $1UbTr(Object, {
        is: polyfill
    }, {
        is: function testObjectIs() {
            return Object.is !== polyfill;
        }
    });
    return polyfill;
};

});


parcelRegister("c8Cyq", function(module, exports) {
"use strict";

var $cOB0F = parcelRequire("cOB0F");

var $1UbTr = parcelRequire("1UbTr");

var $8sYH2 = parcelRequire("8sYH2");

var $91M8b = parcelRequire("91M8b");

var $hCf9I = parcelRequire("hCf9I");
var $8d642377f5822430$var$polyfill = $cOB0F($91M8b(), Number);
/* http://www.ecma-international.org/ecma-262/6.0/#sec-number.isnan */ $1UbTr($8d642377f5822430$var$polyfill, {
    getPolyfill: $91M8b,
    implementation: $8sYH2,
    shim: $hCf9I
});
module.exports = $8d642377f5822430$var$polyfill;

});
parcelRegister("8sYH2", function(module, exports) {
"use strict";
/* http://www.ecma-international.org/ecma-262/6.0/#sec-number.isnan */ module.exports = function isNaN(value) {
    return value !== value;
};

});

parcelRegister("91M8b", function(module, exports) {
"use strict";

var $8sYH2 = parcelRequire("8sYH2");
module.exports = function getPolyfill() {
    if (Number.isNaN && Number.isNaN(NaN) && !Number.isNaN("a")) return Number.isNaN;
    return $8sYH2;
};

});

parcelRegister("hCf9I", function(module, exports) {
"use strict";

var $1UbTr = parcelRequire("1UbTr");

var $91M8b = parcelRequire("91M8b");
/* http://www.ecma-international.org/ecma-262/6.0/#sec-number.isnan */ module.exports = function shimNumberIsNaN() {
    var polyfill = $91M8b();
    $1UbTr(Number, {
        isNaN: polyfill
    }, {
        isNaN: function testIsNaN() {
            return Number.isNaN !== polyfill;
        }
    });
    return polyfill;
};

});





parcelRegister("7RrfS", function(module, exports) {

var $6ZWSX = parcelRequire("6ZWSX");
var $5b929ff18799ba6b$require$Buffer = $6ZWSX.Buffer;
"use strict";
var $5b929ff18799ba6b$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.numbersTypeMap = module.exports.bool = module.exports.i512 = module.exports.i256 = module.exports.i128 = module.exports.i64 = module.exports.i32 = module.exports.i16 = module.exports.i8 = module.exports.u512 = module.exports.u256 = module.exports.u128 = module.exports.u64 = module.exports.u32 = module.exports.u16 = module.exports.u8 = void 0;

const $5b929ff18799ba6b$var$bn_js_1 = $5b929ff18799ba6b$var$__importDefault((parcelRequire("dEXSZ")));

var $kOHSh = parcelRequire("kOHSh");
// -----------------
// Unsigned
// -----------------
/**
 * De/Serializer for 8-bit unsigned integers aka `u8`.
 *
 * @category beet/primitive
 */ module.exports.u8 = {
    write: function(buf, offset, value) {
        buf.writeUInt8(value, offset);
    },
    read: function(buf, offset) {
        return buf.readUInt8(offset);
    },
    byteSize: 1,
    description: "u8"
};
/**
 * De/Serializer 16-bit unsigned integers aka `u16`.
 *
 * @category beet/primitive
 */ module.exports.u16 = {
    write: function(buf, offset, value) {
        buf.writeUInt16LE(value, offset);
    },
    read: function(buf, offset) {
        return buf.readUInt16LE(offset);
    },
    byteSize: 2,
    description: "u16"
};
/**
 * De/Serializer for 32-bit unsigned integers aka `u32`.
 *
 * @category beet/primitive
 */ module.exports.u32 = {
    write: function(buf, offset, value) {
        buf.writeUInt32LE(value, offset);
    },
    read: function(buf, offset) {
        return buf.readUInt32LE(offset);
    },
    byteSize: 4,
    description: "u32"
};
function $5b929ff18799ba6b$var$unsignedLargeBeet(byteSize, description) {
    return {
        write: function(buf, offset, value) {
            const bn = $5b929ff18799ba6b$var$bn_js_1.default.isBN(value) ? value : new $5b929ff18799ba6b$var$bn_js_1.default(value);
            const bytesArray = bn.toArray("le", this.byteSize);
            const bytesArrayBuf = $5b929ff18799ba6b$require$Buffer.from(bytesArray);
            bytesArrayBuf.copy(buf, offset, 0, this.byteSize);
        },
        read: function(buf, offset) {
            const slice = buf.slice(offset, offset + this.byteSize);
            return new $5b929ff18799ba6b$var$bn_js_1.default(slice, "le");
        },
        byteSize: byteSize,
        description: description
    };
}
/**
 * De/Serializer for 64-bit unsigned integers aka `u64` which serializes to a JavaScript
 * _BigNum_ via {@link https://github.com/indutny/bn.js | BN}.
 *
 * @category beet/primitive
 */ module.exports.u64 = $5b929ff18799ba6b$var$unsignedLargeBeet(8, "u64");
/**
 * De/Serializer for 128-bit unsigned integers aka `u128` which serializes to a JavaScript
 * _BigNum_ via {@link https://github.com/indutny/bn.js | BN}.
 *
 * @category beet/primitive
 */ module.exports.u128 = $5b929ff18799ba6b$var$unsignedLargeBeet(16, "u128");
/**
 * De/Serializer for 256-bit unsigned integers aka `u256` which serializes to a JavaScript
 * _BigNum_ via {@link https://github.com/indutny/bn.js | BN}.
 *
 * @category beet/primitive
 */ module.exports.u256 = $5b929ff18799ba6b$var$unsignedLargeBeet(32, "u256");
/**
 * De/Serializer for 512-bit unsigned integers aka `u512` which serializes to a JavaScript
 * _BigNum_ via {@link https://github.com/indutny/bn.js | BN}.
 *
 * @category beet/primitive
 */ module.exports.u512 = $5b929ff18799ba6b$var$unsignedLargeBeet(64, "u512");
// -----------------
// Signed
// -----------------
/**
 * De/Serializer 8-bit signed integers aka `i8`.
 *
 * @category beet/primitive
 */ module.exports.i8 = {
    write: function(buf, offset, value) {
        buf.writeInt8(value, offset);
    },
    read: function(buf, offset) {
        return buf.readInt8(offset);
    },
    byteSize: 1,
    description: "i8"
};
/**
 * De/Serializer 16-bit signed integers aka `i16`.
 *
 * @category beet/primitive
 */ module.exports.i16 = {
    write: function(buf, offset, value) {
        buf.writeInt16LE(value, offset);
    },
    read: function(buf, offset) {
        return buf.readInt16LE(offset);
    },
    byteSize: 2,
    description: "i16"
};
/**
 * De/Serializer 32-bit signed integers aka `i32`.
 *
 * @category beet/primitive
 */ module.exports.i32 = {
    write: function(buf, offset, value) {
        buf.writeInt32LE(value, offset);
    },
    read: function(buf, offset) {
        return buf.readInt32LE(offset);
    },
    byteSize: 4,
    description: "i32"
};
function $5b929ff18799ba6b$var$signedLargeBeet(byteSize, description) {
    const bitSize = byteSize * 8;
    return {
        write: function(buf, offset, value) {
            const bn = ($5b929ff18799ba6b$var$bn_js_1.default.isBN(value) ? value : new $5b929ff18799ba6b$var$bn_js_1.default(value)).toTwos(bitSize);
            const bytesArray = bn.toArray("le", this.byteSize);
            const bytesArrayBuf = $5b929ff18799ba6b$require$Buffer.from(bytesArray);
            bytesArrayBuf.copy(buf, offset, 0, this.byteSize);
        },
        read: function(buf, offset) {
            const slice = buf.slice(offset, offset + this.byteSize);
            const x = new $5b929ff18799ba6b$var$bn_js_1.default(slice, "le");
            return x.fromTwos(bitSize);
        },
        byteSize: byteSize,
        description: description
    };
}
/**
 * De/Serializer for 64-bit signed integers aka `i64` which serializes to a JavaScript
 * _BigNum_ via {@link https://github.com/indutny/bn.js | BN}.
 *
 * @category beet/primitive
 */ module.exports.i64 = $5b929ff18799ba6b$var$signedLargeBeet(8, "i64");
/**
 * De/Serializer for 128-bit signed integers aka `i128` which serializes to a JavaScript
 * _BigNum_ via {@link https://github.com/indutny/bn.js | BN}.
 *
 * @category beet/primitive
 */ module.exports.i128 = $5b929ff18799ba6b$var$signedLargeBeet(16, "i128");
/**
 * De/Serializer for 256-bit signed integers aka `i256` which serializes to a JavaScript
 * _BigNum_ via {@link https://github.com/indutny/bn.js | BN}.
 *
 * @category beet/primitive
 */ module.exports.i256 = $5b929ff18799ba6b$var$signedLargeBeet(32, "i256");
/**
 * De/Serializer for 512-bit signed integers aka `i512` which serializes to a JavaScript
 * _BigNum_ via {@link https://github.com/indutny/bn.js | BN}.
 *
 * @category beet/primitive
 */ module.exports.i512 = $5b929ff18799ba6b$var$signedLargeBeet(64, "i512");
// -----------------
// Boolean
// -----------------
/**
 * De/Serializer booleans aka `bool`.
 *
 * @category beet/primitive
 */ module.exports.bool = {
    write: function(buf, offset, value) {
        const n = value ? 1 : 0;
        module.exports.u8.write(buf, offset, n);
    },
    read: function(buf, offset) {
        return module.exports.u8.read(buf, offset) === 1;
    },
    byteSize: 1,
    description: "bool"
};
/**
 * Maps primitive beet exports to metadata which describes in which package it
 * is defined as well as which TypeScript type is used to represent the
 * deserialized value in JavaScript.
 *
 * @category TypeDefinition
 */ // prettier-ignore
module.exports.numbersTypeMap = {
    // <= 32-bit numbers and boolean
    u8: {
        beet: "u8",
        isFixable: false,
        sourcePack: $kOHSh.BEET_PACKAGE,
        ts: "number"
    },
    u16: {
        beet: "u16",
        isFixable: false,
        sourcePack: $kOHSh.BEET_PACKAGE,
        ts: "number"
    },
    u32: {
        beet: "u32",
        isFixable: false,
        sourcePack: $kOHSh.BEET_PACKAGE,
        ts: "number"
    },
    i8: {
        beet: "i8",
        isFixable: false,
        sourcePack: $kOHSh.BEET_PACKAGE,
        ts: "number"
    },
    i16: {
        beet: "i16",
        isFixable: false,
        sourcePack: $kOHSh.BEET_PACKAGE,
        ts: "number"
    },
    i32: {
        beet: "i32",
        isFixable: false,
        sourcePack: $kOHSh.BEET_PACKAGE,
        ts: "number"
    },
    bool: {
        beet: "bool",
        isFixable: false,
        sourcePack: $kOHSh.BEET_PACKAGE,
        ts: "boolean"
    },
    // Big Number, they use, the 'bignum' type which is defined in this package
    u64: {
        beet: "u64",
        isFixable: false,
        sourcePack: $kOHSh.BEET_PACKAGE,
        ts: "bignum",
        pack: $kOHSh.BEET_PACKAGE
    },
    u128: {
        beet: "u128",
        isFixable: false,
        sourcePack: $kOHSh.BEET_PACKAGE,
        ts: "bignum",
        pack: $kOHSh.BEET_PACKAGE
    },
    u256: {
        beet: "u256",
        isFixable: false,
        sourcePack: $kOHSh.BEET_PACKAGE,
        ts: "bignum",
        pack: $kOHSh.BEET_PACKAGE
    },
    u512: {
        beet: "u512",
        isFixable: false,
        sourcePack: $kOHSh.BEET_PACKAGE,
        ts: "bignum",
        pack: $kOHSh.BEET_PACKAGE
    },
    i64: {
        beet: "i64",
        isFixable: false,
        sourcePack: $kOHSh.BEET_PACKAGE,
        ts: "bignum",
        pack: $kOHSh.BEET_PACKAGE
    },
    i128: {
        beet: "i128",
        isFixable: false,
        sourcePack: $kOHSh.BEET_PACKAGE,
        ts: "bignum",
        pack: $kOHSh.BEET_PACKAGE
    },
    i256: {
        beet: "i256",
        isFixable: false,
        sourcePack: $kOHSh.BEET_PACKAGE,
        ts: "bignum",
        pack: $kOHSh.BEET_PACKAGE
    },
    i512: {
        beet: "i512",
        isFixable: false,
        sourcePack: $kOHSh.BEET_PACKAGE,
        ts: "bignum",
        pack: $kOHSh.BEET_PACKAGE
    }
};

});

parcelRegister("2xd6i", function(module, exports) {
"use strict";
var $1d88d3568bd0b41d$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.UnreachableCaseError = module.exports.stringify = module.exports.bytes = module.exports.beetBytes = module.exports.logTrace = module.exports.logDebug = module.exports.logInfo = module.exports.logError = void 0;

const $1d88d3568bd0b41d$var$debug_1 = $1d88d3568bd0b41d$var$__importDefault((parcelRequire("1SXIy")));

const $1d88d3568bd0b41d$var$ansicolors_1 = $1d88d3568bd0b41d$var$__importDefault((parcelRequire("5wDjf")));

var $kOHSh = parcelRequire("kOHSh");
const { brightBlack: $1d88d3568bd0b41d$var$brightBlack } = $1d88d3568bd0b41d$var$ansicolors_1.default;
module.exports.logError = (0, $1d88d3568bd0b41d$var$debug_1.default)("beet:error");
module.exports.logInfo = (0, $1d88d3568bd0b41d$var$debug_1.default)("beet:info");
module.exports.logDebug = (0, $1d88d3568bd0b41d$var$debug_1.default)("beet:debug");
module.exports.logTrace = (0, $1d88d3568bd0b41d$var$debug_1.default)("beet:trace");
function $1d88d3568bd0b41d$var$beetBytes(beet, isFixable = false) {
    let bytes;
    if ((0, $kOHSh.isFixableBeet)(beet)) bytes = "? B";
    else if ((0, $kOHSh.isElementCollectionFixedSizeBeet)(beet)) {
        const len = isFixable ? "length" : beet.length;
        const lenBytes = beet.lenPrefixByteSize;
        bytes = lenBytes > 0 ? `${lenBytes} + (${beet.elementByteSize} * ${len}) B  (${beet.byteSize} B)` : `(${beet.elementByteSize} * ${len}) B (${beet.byteSize} B)`;
    } else bytes = `${beet.byteSize} B`;
    return $1d88d3568bd0b41d$var$brightBlack(bytes);
}
module.exports.beetBytes = $1d88d3568bd0b41d$var$beetBytes;
function $1d88d3568bd0b41d$var$bytes(n) {
    return $1d88d3568bd0b41d$var$brightBlack(`${n} B`);
}
module.exports.bytes = $1d88d3568bd0b41d$var$bytes;
function $1d88d3568bd0b41d$var$stringify(x) {
    return x.toString === "function" ? x.toString() : x;
}
module.exports.stringify = $1d88d3568bd0b41d$var$stringify;
class $1d88d3568bd0b41d$var$UnreachableCaseError extends Error {
    constructor(value){
        super(`Unreachable case: ${value}`);
    }
}
module.exports.UnreachableCaseError = $1d88d3568bd0b41d$var$UnreachableCaseError;

});
parcelRegister("1SXIy", function(module, exports) {
/* eslint-env browser */ /**
 * This is the web browser implementation of `debug()`.
 */ 
var $hPtJY = parcelRequire("hPtJY");
exports.formatArgs = formatArgs;
exports.save = save;
exports.load = load;
exports.useColors = useColors;
exports.storage = localstorage();
exports.destroy = (()=>{
    let warned = false;
    return ()=>{
        if (!warned) {
            warned = true;
            console.warn("Instance method `debug.destroy()` is deprecated and no longer does anything. It will be removed in the next major version of `debug`.");
        }
    };
})();
/**
 * Colors.
 */ exports.colors = [
    "#0000CC",
    "#0000FF",
    "#0033CC",
    "#0033FF",
    "#0066CC",
    "#0066FF",
    "#0099CC",
    "#0099FF",
    "#00CC00",
    "#00CC33",
    "#00CC66",
    "#00CC99",
    "#00CCCC",
    "#00CCFF",
    "#3300CC",
    "#3300FF",
    "#3333CC",
    "#3333FF",
    "#3366CC",
    "#3366FF",
    "#3399CC",
    "#3399FF",
    "#33CC00",
    "#33CC33",
    "#33CC66",
    "#33CC99",
    "#33CCCC",
    "#33CCFF",
    "#6600CC",
    "#6600FF",
    "#6633CC",
    "#6633FF",
    "#66CC00",
    "#66CC33",
    "#9900CC",
    "#9900FF",
    "#9933CC",
    "#9933FF",
    "#99CC00",
    "#99CC33",
    "#CC0000",
    "#CC0033",
    "#CC0066",
    "#CC0099",
    "#CC00CC",
    "#CC00FF",
    "#CC3300",
    "#CC3333",
    "#CC3366",
    "#CC3399",
    "#CC33CC",
    "#CC33FF",
    "#CC6600",
    "#CC6633",
    "#CC9900",
    "#CC9933",
    "#CCCC00",
    "#CCCC33",
    "#FF0000",
    "#FF0033",
    "#FF0066",
    "#FF0099",
    "#FF00CC",
    "#FF00FF",
    "#FF3300",
    "#FF3333",
    "#FF3366",
    "#FF3399",
    "#FF33CC",
    "#FF33FF",
    "#FF6600",
    "#FF6633",
    "#FF9900",
    "#FF9933",
    "#FFCC00",
    "#FFCC33"
];
/**
 * Currently only WebKit-based Web Inspectors, Firefox >= v31,
 * and the Firebug extension (any Firefox version) are known
 * to support "%c" CSS customizations.
 *
 * TODO: add a `localStorage` variable to explicitly enable/disable colors
 */ // eslint-disable-next-line complexity
function useColors() {
    // NB: In an Electron preload script, document will be defined but not fully
    // initialized. Since we know we're in Chrome, we'll just detect this case
    // explicitly
    if (typeof window !== "undefined" && window.process && (window.process.type === "renderer" || window.process.__nwjs)) return true;
    // Internet Explorer and Edge do not support colors.
    if (typeof navigator !== "undefined" && navigator.userAgent && navigator.userAgent.toLowerCase().match(/(edge|trident)\/(\d+)/)) return false;
    // Is webkit? http://stackoverflow.com/a/16459606/376773
    // document is undefined in react-native: https://github.com/facebook/react-native/pull/1632
    return typeof document !== "undefined" && document.documentElement && document.documentElement.style && document.documentElement.style.WebkitAppearance || // Is firebug? http://stackoverflow.com/a/398120/376773
    typeof window !== "undefined" && window.console && (window.console.firebug || window.console.exception && window.console.table) || // Is firefox >= v31?
    // https://developer.mozilla.org/en-US/docs/Tools/Web_Console#Styling_messages
    typeof navigator !== "undefined" && navigator.userAgent && navigator.userAgent.toLowerCase().match(/firefox\/(\d+)/) && parseInt(RegExp.$1, 10) >= 31 || // Double check webkit in userAgent just in case we are in a worker
    typeof navigator !== "undefined" && navigator.userAgent && navigator.userAgent.toLowerCase().match(/applewebkit\/(\d+)/);
}
/**
 * Colorize log arguments if enabled.
 *
 * @api public
 */ function formatArgs(args) {
    args[0] = (this.useColors ? "%c" : "") + this.namespace + (this.useColors ? " %c" : " ") + args[0] + (this.useColors ? "%c " : " ") + "+" + module.exports.humanize(this.diff);
    if (!this.useColors) return;
    const c = "color: " + this.color;
    args.splice(1, 0, c, "color: inherit");
    // The final "%c" is somewhat tricky, because there could be other
    // arguments passed either before or after the %c, so we need to
    // figure out the correct index to insert the CSS into
    let index = 0;
    let lastC = 0;
    args[0].replace(/%[a-zA-Z%]/g, (match)=>{
        if (match === "%%") return;
        index++;
        if (match === "%c") // We only are interested in the *last* %c
        // (the user may have provided their own)
        lastC = index;
    });
    args.splice(lastC, 0, c);
}
/**
 * Invokes `console.debug()` when available.
 * No-op when `console.debug` is not a "function".
 * If `console.debug` is not available, falls back
 * to `console.log`.
 *
 * @api public
 */ exports.log = console.debug || console.log || (()=>{});
/**
 * Save `namespaces`.
 *
 * @param {String} namespaces
 * @api private
 */ function save(namespaces) {
    try {
        if (namespaces) exports.storage.setItem("debug", namespaces);
        else exports.storage.removeItem("debug");
    } catch (error) {
    // Swallow
    // XXX (@Qix-) should we be logging these?
    }
}
/**
 * Load `namespaces`.
 *
 * @return {String} returns the previously persisted debug modes
 * @api private
 */ function load() {
    let r;
    try {
        r = exports.storage.getItem("debug");
    } catch (error) {
    // Swallow
    // XXX (@Qix-) should we be logging these?
    }
    // If debug isn't set in LS, and we're in Electron, try to load $DEBUG
    if (!r && typeof $hPtJY !== "undefined" && "env" in $hPtJY) r = undefined;
    return r;
}
/**
 * Localstorage attempts to return the localstorage.
 *
 * This is necessary because safari throws
 * when a user disables cookies/localstorage
 * and you attempt to access it.
 *
 * @return {LocalStorage}
 * @api private
 */ function localstorage() {
    try {
        // TVMLKit (Apple TV JS Runtime) does not have a window object, just localStorage in the global context
        // The Browser also has localStorage in the global context.
        return localStorage;
    } catch (error) {
    // Swallow
    // XXX (@Qix-) should we be logging these?
    }
}

module.exports = (parcelRequire("7kBR8"))(exports);
const { formatters } = module.exports;
/**
 * Map %j to `JSON.stringify()`, since no Web Inspectors do that by default.
 */ formatters.j = function(v) {
    try {
        return JSON.stringify(v);
    } catch (error) {
        return "[UnexpectedJSONParseError]: " + error.message;
    }
};

});
parcelRegister("7kBR8", function(module, exports) {
/**
 * This is the common logic for both the Node.js and web browser
 * implementations of `debug()`.
 */ 
function $5567c417bf6247fd$var$setup(env) {
    createDebug.debug = createDebug;
    createDebug.default = createDebug;
    createDebug.coerce = coerce;
    createDebug.disable = disable;
    createDebug.enable = enable;
    createDebug.enabled = enabled;
    createDebug.humanize = (parcelRequire("3pRq5"));
    createDebug.destroy = destroy;
    Object.keys(env).forEach((key)=>{
        createDebug[key] = env[key];
    });
    /**
	* The currently active debug mode names, and names to skip.
	*/ createDebug.names = [];
    createDebug.skips = [];
    /**
	* Map of special "%n" handling functions, for the debug "format" argument.
	*
	* Valid key names are a single, lower or upper-case letter, i.e. "n" and "N".
	*/ createDebug.formatters = {};
    /**
	* Selects a color for a debug namespace
	* @param {String} namespace The namespace string for the debug instance to be colored
	* @return {Number|String} An ANSI color code for the given namespace
	* @api private
	*/ function selectColor(namespace) {
        let hash = 0;
        for(let i = 0; i < namespace.length; i++){
            hash = (hash << 5) - hash + namespace.charCodeAt(i);
            hash |= 0; // Convert to 32bit integer
        }
        return createDebug.colors[Math.abs(hash) % createDebug.colors.length];
    }
    createDebug.selectColor = selectColor;
    /**
	* Create a debugger with the given `namespace`.
	*
	* @param {String} namespace
	* @return {Function}
	* @api public
	*/ function createDebug(namespace) {
        let prevTime;
        let enableOverride = null;
        let namespacesCache;
        let enabledCache;
        function debug(...args) {
            // Disabled?
            if (!debug.enabled) return;
            const self = debug;
            // Set `diff` timestamp
            const curr = Number(new Date());
            const ms = curr - (prevTime || curr);
            self.diff = ms;
            self.prev = prevTime;
            self.curr = curr;
            prevTime = curr;
            args[0] = createDebug.coerce(args[0]);
            if (typeof args[0] !== "string") // Anything else let's inspect with %O
            args.unshift("%O");
            // Apply any `formatters` transformations
            let index = 0;
            args[0] = args[0].replace(/%([a-zA-Z%])/g, (match, format)=>{
                // If we encounter an escaped % then don't increase the array index
                if (match === "%%") return "%";
                index++;
                const formatter = createDebug.formatters[format];
                if (typeof formatter === "function") {
                    const val = args[index];
                    match = formatter.call(self, val);
                    // Now we need to remove `args[index]` since it's inlined in the `format`
                    args.splice(index, 1);
                    index--;
                }
                return match;
            });
            // Apply env-specific formatting (colors, etc.)
            createDebug.formatArgs.call(self, args);
            const logFn = self.log || createDebug.log;
            logFn.apply(self, args);
        }
        debug.namespace = namespace;
        debug.useColors = createDebug.useColors();
        debug.color = createDebug.selectColor(namespace);
        debug.extend = extend;
        debug.destroy = createDebug.destroy; // XXX Temporary. Will be removed in the next major release.
        Object.defineProperty(debug, "enabled", {
            enumerable: true,
            configurable: false,
            get: ()=>{
                if (enableOverride !== null) return enableOverride;
                if (namespacesCache !== createDebug.namespaces) {
                    namespacesCache = createDebug.namespaces;
                    enabledCache = createDebug.enabled(namespace);
                }
                return enabledCache;
            },
            set: (v)=>{
                enableOverride = v;
            }
        });
        // Env-specific initialization logic for debug instances
        if (typeof createDebug.init === "function") createDebug.init(debug);
        return debug;
    }
    function extend(namespace, delimiter) {
        const newDebug = createDebug(this.namespace + (typeof delimiter === "undefined" ? ":" : delimiter) + namespace);
        newDebug.log = this.log;
        return newDebug;
    }
    /**
	* Enables a debug mode by namespaces. This can include modes
	* separated by a colon and wildcards.
	*
	* @param {String} namespaces
	* @api public
	*/ function enable(namespaces) {
        createDebug.save(namespaces);
        createDebug.namespaces = namespaces;
        createDebug.names = [];
        createDebug.skips = [];
        let i;
        const split = (typeof namespaces === "string" ? namespaces : "").split(/[\s,]+/);
        const len = split.length;
        for(i = 0; i < len; i++){
            if (!split[i]) continue;
            namespaces = split[i].replace(/\*/g, ".*?");
            if (namespaces[0] === "-") createDebug.skips.push(new RegExp("^" + namespaces.slice(1) + "$"));
            else createDebug.names.push(new RegExp("^" + namespaces + "$"));
        }
    }
    /**
	* Disable debug output.
	*
	* @return {String} namespaces
	* @api public
	*/ function disable() {
        const namespaces = [
            ...createDebug.names.map(toNamespace),
            ...createDebug.skips.map(toNamespace).map((namespace)=>"-" + namespace)
        ].join(",");
        createDebug.enable("");
        return namespaces;
    }
    /**
	* Returns true if the given mode name is enabled, false otherwise.
	*
	* @param {String} name
	* @return {Boolean}
	* @api public
	*/ function enabled(name) {
        if (name[name.length - 1] === "*") return true;
        let i;
        let len;
        for(i = 0, len = createDebug.skips.length; i < len; i++){
            if (createDebug.skips[i].test(name)) return false;
        }
        for(i = 0, len = createDebug.names.length; i < len; i++){
            if (createDebug.names[i].test(name)) return true;
        }
        return false;
    }
    /**
	* Convert regexp to namespace
	*
	* @param {RegExp} regxep
	* @return {String} namespace
	* @api private
	*/ function toNamespace(regexp) {
        return regexp.toString().substring(2, regexp.toString().length - 2).replace(/\.\*\?$/, "*");
    }
    /**
	* Coerce `val`.
	*
	* @param {Mixed} val
	* @return {Mixed}
	* @api private
	*/ function coerce(val) {
        if (val instanceof Error) return val.stack || val.message;
        return val;
    }
    /**
	* XXX DO NOT USE. This is a temporary stub function.
	* XXX It WILL be removed in the next major release.
	*/ function destroy() {
        console.warn("Instance method `debug.destroy()` is deprecated and no longer does anything. It will be removed in the next major version of `debug`.");
    }
    createDebug.enable(createDebug.load());
    return createDebug;
}
module.exports = $5567c417bf6247fd$var$setup;

});
parcelRegister("3pRq5", function(module, exports) {
/**
 * Helpers.
 */ var $27cd24efd2f930b8$var$s = 1000;
var $27cd24efd2f930b8$var$m = $27cd24efd2f930b8$var$s * 60;
var $27cd24efd2f930b8$var$h = $27cd24efd2f930b8$var$m * 60;
var $27cd24efd2f930b8$var$d = $27cd24efd2f930b8$var$h * 24;
var $27cd24efd2f930b8$var$w = $27cd24efd2f930b8$var$d * 7;
var $27cd24efd2f930b8$var$y = $27cd24efd2f930b8$var$d * 365.25;
/**
 * Parse or format the given `val`.
 *
 * Options:
 *
 *  - `long` verbose formatting [false]
 *
 * @param {String|Number} val
 * @param {Object} [options]
 * @throws {Error} throw an error if val is not a non-empty string or a number
 * @return {String|Number}
 * @api public
 */ module.exports = function(val, options) {
    options = options || {};
    var type = typeof val;
    if (type === "string" && val.length > 0) return $27cd24efd2f930b8$var$parse(val);
    else if (type === "number" && isFinite(val)) return options.long ? $27cd24efd2f930b8$var$fmtLong(val) : $27cd24efd2f930b8$var$fmtShort(val);
    throw new Error("val is not a non-empty string or a valid number. val=" + JSON.stringify(val));
};
/**
 * Parse the given `str` and return milliseconds.
 *
 * @param {String} str
 * @return {Number}
 * @api private
 */ function $27cd24efd2f930b8$var$parse(str) {
    str = String(str);
    if (str.length > 100) return;
    var match = /^(-?(?:\d+)?\.?\d+) *(milliseconds?|msecs?|ms|seconds?|secs?|s|minutes?|mins?|m|hours?|hrs?|h|days?|d|weeks?|w|years?|yrs?|y)?$/i.exec(str);
    if (!match) return;
    var n = parseFloat(match[1]);
    var type = (match[2] || "ms").toLowerCase();
    switch(type){
        case "years":
        case "year":
        case "yrs":
        case "yr":
        case "y":
            return n * $27cd24efd2f930b8$var$y;
        case "weeks":
        case "week":
        case "w":
            return n * $27cd24efd2f930b8$var$w;
        case "days":
        case "day":
        case "d":
            return n * $27cd24efd2f930b8$var$d;
        case "hours":
        case "hour":
        case "hrs":
        case "hr":
        case "h":
            return n * $27cd24efd2f930b8$var$h;
        case "minutes":
        case "minute":
        case "mins":
        case "min":
        case "m":
            return n * $27cd24efd2f930b8$var$m;
        case "seconds":
        case "second":
        case "secs":
        case "sec":
        case "s":
            return n * $27cd24efd2f930b8$var$s;
        case "milliseconds":
        case "millisecond":
        case "msecs":
        case "msec":
        case "ms":
            return n;
        default:
            return undefined;
    }
}
/**
 * Short format for `ms`.
 *
 * @param {Number} ms
 * @return {String}
 * @api private
 */ function $27cd24efd2f930b8$var$fmtShort(ms) {
    var msAbs = Math.abs(ms);
    if (msAbs >= $27cd24efd2f930b8$var$d) return Math.round(ms / $27cd24efd2f930b8$var$d) + "d";
    if (msAbs >= $27cd24efd2f930b8$var$h) return Math.round(ms / $27cd24efd2f930b8$var$h) + "h";
    if (msAbs >= $27cd24efd2f930b8$var$m) return Math.round(ms / $27cd24efd2f930b8$var$m) + "m";
    if (msAbs >= $27cd24efd2f930b8$var$s) return Math.round(ms / $27cd24efd2f930b8$var$s) + "s";
    return ms + "ms";
}
/**
 * Long format for `ms`.
 *
 * @param {Number} ms
 * @return {String}
 * @api private
 */ function $27cd24efd2f930b8$var$fmtLong(ms) {
    var msAbs = Math.abs(ms);
    if (msAbs >= $27cd24efd2f930b8$var$d) return $27cd24efd2f930b8$var$plural(ms, msAbs, $27cd24efd2f930b8$var$d, "day");
    if (msAbs >= $27cd24efd2f930b8$var$h) return $27cd24efd2f930b8$var$plural(ms, msAbs, $27cd24efd2f930b8$var$h, "hour");
    if (msAbs >= $27cd24efd2f930b8$var$m) return $27cd24efd2f930b8$var$plural(ms, msAbs, $27cd24efd2f930b8$var$m, "minute");
    if (msAbs >= $27cd24efd2f930b8$var$s) return $27cd24efd2f930b8$var$plural(ms, msAbs, $27cd24efd2f930b8$var$s, "second");
    return ms + " ms";
}
/**
 * Pluralization helper.
 */ function $27cd24efd2f930b8$var$plural(ms, msAbs, n, name) {
    var isPlural = msAbs >= n * 1.5;
    return Math.round(ms / n) + " " + name + (isPlural ? "s" : "");
}

});



parcelRegister("5wDjf", function(module, exports) {
// ColorCodes explained: http://www.termsys.demon.co.uk/vtansi.htm
"use strict";
var $405e6ef07bea67a5$var$colorNums = {
    white: 37,
    black: 30,
    blue: 34,
    cyan: 36,
    green: 32,
    magenta: 35,
    red: 31,
    yellow: 33,
    brightBlack: 90,
    brightRed: 91,
    brightGreen: 92,
    brightYellow: 93,
    brightBlue: 94,
    brightMagenta: 95,
    brightCyan: 96,
    brightWhite: 97
}, $405e6ef07bea67a5$var$backgroundColorNums = {
    bgBlack: 40,
    bgRed: 41,
    bgGreen: 42,
    bgYellow: 43,
    bgBlue: 44,
    bgMagenta: 45,
    bgCyan: 46,
    bgWhite: 47,
    bgBrightBlack: 100,
    bgBrightRed: 101,
    bgBrightGreen: 102,
    bgBrightYellow: 103,
    bgBrightBlue: 104,
    bgBrightMagenta: 105,
    bgBrightCyan: 106,
    bgBrightWhite: 107
}, $405e6ef07bea67a5$var$open = {}, $405e6ef07bea67a5$var$close = {}, $405e6ef07bea67a5$var$colors = {};
Object.keys($405e6ef07bea67a5$var$colorNums).forEach(function(k) {
    var o = $405e6ef07bea67a5$var$open[k] = "\x1b[" + $405e6ef07bea67a5$var$colorNums[k] + "m";
    var c = $405e6ef07bea67a5$var$close[k] = "\x1b[39m";
    $405e6ef07bea67a5$var$colors[k] = function(s) {
        return o + s + c;
    };
});
Object.keys($405e6ef07bea67a5$var$backgroundColorNums).forEach(function(k) {
    var o = $405e6ef07bea67a5$var$open[k] = "\x1b[" + $405e6ef07bea67a5$var$backgroundColorNums[k] + "m";
    var c = $405e6ef07bea67a5$var$close[k] = "\x1b[49m";
    $405e6ef07bea67a5$var$colors[k] = function(s) {
        return o + s + c;
    };
});
module.exports = $405e6ef07bea67a5$var$colors;
$405e6ef07bea67a5$var$colors.open = $405e6ef07bea67a5$var$open;
$405e6ef07bea67a5$var$colors.close = $405e6ef07bea67a5$var$close;

});


parcelRegister("l9HYk", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.fixBeetFromValue = module.exports.fixBeetFromData = void 0;

var $kOHSh = parcelRequire("kOHSh");

var $2xd6i = parcelRequire("2xd6i");
/**
 * Converts the provided beet into a {@link FixedBeet} unless it already is.
 * The sizes for {@link FixableBeet}s are determined from the provided data.
 *
 * @param beet to convert
 * @param buf containing serialized data that the fixed beet needs to process
 * @param offset at which the data for the beet starts
 *
 * @category beet
 */ function $f66c8c258bc2cdf1$var$fixBeetFromData(beet, buf, offset) {
    if ((0, $kOHSh.isFixedSizeBeet)(beet)) return beet;
    if ((0, $kOHSh.isFixableBeet)(beet)) return beet.toFixedFromData(buf, offset);
    throw new $2xd6i.UnreachableCaseError(beet);
}
module.exports.fixBeetFromData = $f66c8c258bc2cdf1$var$fixBeetFromData;
/**
 * Converts the provided beet into a {@link FixedBeet} unless it already is.
 * The sizes for {@link FixableBeet}s are determined from the provided value.
 *
 * @param beet to convert
 * @param val value that the fixed beet needs to process
 *
 * @category beet
 */ function $f66c8c258bc2cdf1$var$fixBeetFromValue(beet, val) {
    if ((0, $kOHSh.isFixedSizeBeet)(beet)) return beet;
    if ((0, $kOHSh.isFixableBeet)(beet)) return beet.toFixedFromValue(val);
    throw new $2xd6i.UnreachableCaseError(beet);
}
module.exports.fixBeetFromValue = $f66c8c258bc2cdf1$var$fixBeetFromValue;

});


parcelRegister("iadi0", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.compositesTypeMap = module.exports.coption = module.exports.coptionSome = module.exports.coptionNone = module.exports.isNoneBuffer = module.exports.isSomeBuffer = void 0;

var $aLUwE = parcelRequire("aLUwE");

var $kOHSh = parcelRequire("kOHSh");

var $kOHSh = parcelRequire("kOHSh");

var $2xd6i = parcelRequire("2xd6i");

var $l9HYk = parcelRequire("l9HYk");
const $d3937826b9deff1e$var$NONE = 0;
const $d3937826b9deff1e$var$SOME = 1;
/**
 * @private
 */ function $d3937826b9deff1e$var$isSomeBuffer(buf, offset) {
    return buf[offset] === $d3937826b9deff1e$var$SOME;
}
module.exports.isSomeBuffer = $d3937826b9deff1e$var$isSomeBuffer;
/**
 * @private
 */ function $d3937826b9deff1e$var$isNoneBuffer(buf, offset) {
    return buf[offset] === $d3937826b9deff1e$var$NONE;
}
module.exports.isNoneBuffer = $d3937826b9deff1e$var$isNoneBuffer;
/**
 * De/Serializes `None` case of an _Option_ of type {@link T} represented by
 * {@link COption}.
 *
 * The de/serialized type is prefixed with `0`.
 * This matches the `COption::None` type borsh representation.
 *
 * @template T inner option type
 * @param description the description of the inner type
 *
 * @category beet/option
 */ function $d3937826b9deff1e$var$coptionNone(description) {
    (0, $2xd6i.logTrace)(`coptionNone(${description})`);
    return {
        write: function(buf, offset, value) {
            (0, $aLUwE.strict)(value == null, "coptionNone can only handle `null` values");
            buf[offset] = $d3937826b9deff1e$var$NONE;
        },
        read: function(buf, offset) {
            (0, $aLUwE.strict)($d3937826b9deff1e$var$isNoneBuffer(buf, offset), "coptionNone can only handle `NONE` data");
            return null;
        },
        byteSize: 1,
        description: `COption<None(${description})>`
    };
}
module.exports.coptionNone = $d3937826b9deff1e$var$coptionNone;
/**
 * De/Serializes `Some` case of an _Option_ of type {@link T} represented by
 * {@link COption}.
 *
 * The de/serialized type is prefixed with `1`.
 * This matches the `COption::Some` type borsh representation.
 *
 * @template T inner option type
 * @param inner the De/Serializer for the inner type
 *
 * @category beet/composite
 */ function $d3937826b9deff1e$var$coptionSome(inner) {
    const byteSize = 1 + inner.byteSize;
    const beet = {
        write: function(buf, offset, value) {
            (0, $kOHSh.assertFixedSizeBeet)(inner, `coption inner type ${inner.description} needs to be fixed before calling write`);
            (0, $aLUwE.strict)(value != null, "coptionSome cannot handle `null` values");
            buf[offset] = $d3937826b9deff1e$var$SOME;
            inner.write(buf, offset + 1, value);
        },
        read: function(buf, offset) {
            (0, $kOHSh.assertFixedSizeBeet)(inner, `coption inner type ${inner.description} needs to be fixed before calling read`);
            (0, $aLUwE.strict)($d3937826b9deff1e$var$isSomeBuffer(buf, offset), "coptionSome can only handle `SOME` data");
            return inner.read(buf, offset + 1);
        },
        description: `COption<${inner.description}>[1 + ${inner.byteSize}]`,
        byteSize: byteSize,
        inner: inner
    };
    (0, $2xd6i.logTrace)(beet.description);
    return beet;
}
module.exports.coptionSome = $d3937826b9deff1e$var$coptionSome;
/**
 * De/Serializes an _Option_ of type {@link T} represented by {@link COption}.
 *
 * The de/serialized type is prefixed with `1` if the inner value is present
 * and with `0` if not.
 * This matches the `COption` type borsh representation.
 *
 * @template T inner option type
 * @param inner the De/Serializer for the inner type
 *
 * @category beet/composite
 */ function $d3937826b9deff1e$var$coption(inner) {
    return {
        toFixedFromData (buf, offset) {
            if ($d3937826b9deff1e$var$isSomeBuffer(buf, offset)) {
                const innerFixed = (0, $l9HYk.fixBeetFromData)(inner, buf, offset + 1);
                return $d3937826b9deff1e$var$coptionSome(innerFixed);
            } else {
                (0, $aLUwE.strict)($d3937826b9deff1e$var$isNoneBuffer(buf, offset), `Expected ${buf} to hold a COption`);
                return $d3937826b9deff1e$var$coptionNone(inner.description);
            }
        },
        toFixedFromValue (val) {
            return val == null ? $d3937826b9deff1e$var$coptionNone(inner.description) : $d3937826b9deff1e$var$coptionSome((0, $l9HYk.fixBeetFromValue)(inner, val));
        },
        description: `COption<${inner.description}>`
    };
}
module.exports.coption = $d3937826b9deff1e$var$coption;
/**
 * Maps composite beet exports to metadata which describes in which package it
 * is defined as well as which TypeScript type is used to represent the
 * deserialized value in JavaScript.
 *
 * @category TypeDefinition
 */ module.exports.compositesTypeMap = {
    option: {
        beet: "coption",
        isFixable: true,
        sourcePack: $kOHSh.BEET_PACKAGE,
        ts: "COption<Inner>",
        arg: $kOHSh.BEET_TYPE_ARG_INNER,
        pack: $kOHSh.BEET_PACKAGE
    }
};

});

parcelRegister("981vi", function(module, exports) {

var $6ZWSX = parcelRequire("6ZWSX");
var $6a560704b2a83816$require$Buffer = $6ZWSX.Buffer;
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.stringTypeMap = module.exports.utf8String = module.exports.fixedSizeUtf8String = void 0;

var $kOHSh = parcelRequire("kOHSh");

var $aLUwE = parcelRequire("aLUwE");

var $7RrfS = parcelRequire("7RrfS");

var $2xd6i = parcelRequire("2xd6i");
/**
 * De/Serializes a UTF8 string of a particular size.
 *
 * @param stringByteLength the number of bytes of the string
 *
 * @category beet/collection
 */ const $6a560704b2a83816$var$fixedSizeUtf8String = (stringByteLength)=>{
    return {
        write: function(buf, offset, value) {
            const stringBuf = $6a560704b2a83816$require$Buffer.from(value, "utf8");
            $aLUwE.strict.equal(stringBuf.byteLength, stringByteLength, `${value} has invalid byte size`);
            $7RrfS.u32.write(buf, offset, stringByteLength);
            stringBuf.copy(buf, offset + 4, 0, stringByteLength);
        },
        read: function(buf, offset) {
            const size = $7RrfS.u32.read(buf, offset);
            $aLUwE.strict.equal(size, stringByteLength, `invalid byte size`);
            const stringSlice = buf.slice(offset + 4, offset + 4 + stringByteLength);
            return stringSlice.toString("utf8");
        },
        elementByteSize: 1,
        length: stringByteLength,
        lenPrefixByteSize: 4,
        byteSize: 4 + stringByteLength,
        description: `Utf8String(4 + ${stringByteLength})`
    };
};
module.exports.fixedSizeUtf8String = $6a560704b2a83816$var$fixedSizeUtf8String;
/**
 * De/Serializes a UTF8 string of any size.
 *
 * @category beet/collection
 */ module.exports.utf8String = {
    toFixedFromData (buf, offset) {
        const len = $7RrfS.u32.read(buf, offset);
        (0, $2xd6i.logTrace)(`${this.description}[${len}]`);
        return (0, module.exports.fixedSizeUtf8String)(len);
    },
    toFixedFromValue (val) {
        const len = $6a560704b2a83816$require$Buffer.from(val).byteLength;
        return (0, module.exports.fixedSizeUtf8String)(len);
    },
    description: `Utf8String`
};
/**
 * Maps string beet exports to metadata which describes in which package it
 * is defined as well as which TypeScript type is used to represent the
 * deserialized value in JavaScript.
 *
 * @category TypeDefinition
 */ module.exports.stringTypeMap = {
    fixedSizeString: {
        beet: "fixedSizeUtf8String",
        isFixable: false,
        sourcePack: $kOHSh.BEET_PACKAGE,
        ts: "string",
        arg: $kOHSh.BEET_TYPE_ARG_LEN
    },
    string: {
        beet: "utf8String",
        isFixable: true,
        sourcePack: $kOHSh.BEET_PACKAGE,
        ts: "string"
    }
};

});

parcelRegister("3MHbE", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.enumsTypeMap = module.exports.dataEnum = module.exports.uniformDataEnum = module.exports.fixedScalarEnum = void 0;

var $kOHSh = parcelRequire("kOHSh");

var $7RrfS = parcelRequire("7RrfS");

var $aLUwE = parcelRequire("aLUwE");

var $4kKfe = parcelRequire("4kKfe");

var $d5fNB = parcelRequire("d5fNB");

var $i0sX8 = parcelRequire("i0sX8");
// -----------------
// Fixed Scalar Enum
// -----------------
function $2c175accf7eb7520$var$resolveEnumVariant(value, isNumVariant) {
    return isNumVariant ? `${value}` : value;
}
/**
 * De/serializer for enums with up to 255 less variants which have no data.
 *
 * @param enumType type of enum to process, i.e. Color or Direction
 *
 * @category beet/enum
 */ function $2c175accf7eb7520$var$fixedScalarEnum(enumType) {
    const keys = Object.keys(enumType);
    return {
        write (buf, offset, value) {
            const isNumVariant = typeof value === "number";
            const variantKey = $2c175accf7eb7520$var$resolveEnumVariant(value, isNumVariant);
            if (!keys.includes(variantKey)) $aLUwE.strict.fail(`${value} should be a variant of the provided enum type, i.e. [ ${Object.values(enumType).join(", ")} ], but isn't`);
            if (isNumVariant) $7RrfS.u8.write(buf, offset, value);
            else {
                const enumValue = enumType[variantKey];
                $7RrfS.u8.write(buf, offset, enumValue);
            }
        },
        read (buf, offset) {
            const value = $7RrfS.u8.read(buf, offset);
            const isNumVariant = typeof value === "number";
            const variantKey = $2c175accf7eb7520$var$resolveEnumVariant(value, isNumVariant);
            if (!keys.includes(variantKey)) $aLUwE.strict.fail(`${value} should be a of a variant of the provided enum type, i.e. [ ${Object.values(enumType).join(", ")} ], but isn't`);
            return isNumVariant ? value : enumType[variantKey];
        },
        byteSize: $7RrfS.u8.byteSize,
        description: "Enum"
    };
}
module.exports.fixedScalarEnum = $2c175accf7eb7520$var$fixedScalarEnum;
/**
 * De/Serializes an {@link Enum} that contains a type of data, i.e. a {@link Struct}.
 * The main difference to a Rust enum is that the type of data has to be the
 * same for all enum variants.
 *
 * @template T inner enum data type
 *
 * @param inner the De/Serializer for the data type
 *
 * @category beet/enum
 */ function $2c175accf7eb7520$var$uniformDataEnum(inner) {
    return {
        write: function(buf, offset, value) {
            $7RrfS.u8.write(buf, offset, value.kind);
            inner.write(buf, offset + 1, value.data);
        },
        read: function(buf, offset) {
            const kind = $7RrfS.u8.read(buf, offset);
            const data = inner.read(buf, offset + 1);
            return {
                kind: kind,
                data: data
            };
        },
        byteSize: 1 + inner.byteSize,
        description: `UniformDataEnum<${inner.description}>`
    };
}
module.exports.uniformDataEnum = $2c175accf7eb7520$var$uniformDataEnum;
function $2c175accf7eb7520$var$enumDataVariantBeet(inner, discriminant, kind) {
    return {
        write (buf, offset, value) {
            $7RrfS.u8.write(buf, offset, discriminant);
            inner.write(buf, offset + $7RrfS.u8.byteSize, value);
        },
        read (buf, offset) {
            const val = inner.read(buf, offset + $7RrfS.u8.byteSize);
            return {
                __kind: kind,
                ...val
            };
        },
        byteSize: inner.byteSize + $7RrfS.u8.byteSize,
        description: `EnumData<${inner.description}>`
    };
}
/**
 * De/serializes Data Enums.
 * They are represented as a discriminated unions in TypeScript.
 *
 * NOTE: only structs, i.e. {@link BeetArgsStruct} and
 * {@link FixableBeetArgsStruct} are supported as the data of each enum variant.
 *
 * ## Example
 *
 * ```ts
 * type Simple = {
 *   First: { n1: number }
 *   Second: { n2: number }
 * }
 *
 * const beet = dataEnum<Simple>([
 *   ['First', new BeetArgsStruct<Simple['First']>([['n1', u32]])],
 *   ['Second', new BeetArgsStruct<Simple['Second']>([['n2', u32]])],
 * ])
 * ```
 *
 * @category beet/enum
 * @param variants an array of {@link DataEnumBeet}s each a tuple of `[ kind, data ]`
 */ function $2c175accf7eb7520$var$dataEnum(variants) {
    for (const [_, beet] of variants)(0, $aLUwE.strict)((0, $4kKfe.isBeetStruct)(beet) || (0, $d5fNB.isFixableBeetStruct)(beet) || // scalar variant
    beet === $i0sX8.unit, "dataEnum: variants must be a data beet struct or a scalar unit");
    return {
        toFixedFromData (buf, offset) {
            const discriminant = $7RrfS.u8.read(buf, offset);
            const variant = variants[discriminant];
            (0, $aLUwE.strict)(variant != null, `Discriminant ${discriminant} out of range for ${variants.length} variants`);
            const [__kind, dataBeet] = variant;
            const fixed = (0, $kOHSh.isFixedSizeBeet)(dataBeet) ? dataBeet : dataBeet.toFixedFromData(buf, offset + 1);
            return $2c175accf7eb7520$var$enumDataVariantBeet(fixed, discriminant, __kind);
        },
        toFixedFromValue (val) {
            if (val.__kind == null) {
                const keys = Object.keys(val).join(", ");
                const validKinds = variants.map(([__kind])=>__kind).join(", ");
                $aLUwE.strict.fail(`Value with fields [ ${keys} ] is missing __kind, ` + `which needs to be set to one of [ ${validKinds} ]`);
            }
            const discriminant = variants.findIndex(([__kind])=>__kind === val.__kind);
            if (discriminant < 0) {
                const validKinds = variants.map(([__kind])=>__kind).join(", ");
                $aLUwE.strict.fail(`${val.__kind} is not a valid kind, needs to be one of [ ${validKinds} ]`);
            }
            const variant = variants[discriminant];
            const { __kind: __kind, ...dataValue } = val;
            const [__variantKind, dataBeet] = variant;
            const fixed = (0, $kOHSh.isFixedSizeBeet)(dataBeet) ? dataBeet : dataBeet.toFixedFromValue(dataValue);
            return $2c175accf7eb7520$var$enumDataVariantBeet(fixed, discriminant, __variantKind);
        },
        description: `DataEnum<${variants.length} variants>`
    };
}
module.exports.dataEnum = $2c175accf7eb7520$var$dataEnum;
/**
 * Maps composite beet exports to metadata which describes in which package it
 * is defined as well as which TypeScript type is used to represent the
 * deserialized value in JavaScript.
 *
 * @category TypeDefinition
 */ module.exports.enumsTypeMap = {
    fixedScalarEnum: {
        beet: "fixedScalarEnum",
        isFixable: false,
        sourcePack: $kOHSh.BEET_PACKAGE,
        ts: "<TypeName>",
        arg: $kOHSh.BEET_TYPE_ARG_INNER,
        pack: $kOHSh.BEET_PACKAGE
    },
    dataEnum: {
        beet: "dataEnum",
        isFixable: false,
        sourcePack: $kOHSh.BEET_PACKAGE,
        ts: "DataEnum<Kind, Inner>",
        arg: $kOHSh.BEET_TYPE_ARG_INNER,
        pack: $kOHSh.BEET_PACKAGE
    }
};

});
parcelRegister("4kKfe", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.BeetArgsStruct = module.exports.isBeetStruct = module.exports.BeetStruct = void 0;

var $inPTV = parcelRequire("inPTV");

var $2xd6i = parcelRequire("2xd6i");
/**
 * Configures a class or any JavaScript object type for de/serialization aka
 * read/write. All fields of that class have to be of fixed size.
 * If a field requires a {@link FixableBeet} use the {@link FixableBeetStruct}
 * instead.
 *
 * @template Class the type to produce when deserializing
 * @template Args contains all fields, is typically a subset of Class and is
 * used to construct an instance of it
 *
 * @category beet/struct
 */ class $327ce6e8b4836d9b$var$BeetStruct {
    /**
     * Creates an instance of the BeetStruct.
     *
     * @param fields de/serializers for each field of the {@link Class}
     * @param construct the function that creates an instance of {@link Class}
     * from the args
     * @param description identifies this struct for diagnostics/debugging
     * purposes
     */ constructor(fields, construct, description = $327ce6e8b4836d9b$var$BeetStruct.description){
        this.fields = fields;
        this.construct = construct;
        this.description = description;
        this.byteSize = this.getByteSize();
        if ($2xd6i.logDebug.enabled) {
            const flds = fields.map(([key, val])=>`${String(key)}: ${val.description} ${(0, $2xd6i.beetBytes)(val)}`).join("\n  ");
            (0, $2xd6i.logDebug)(`struct ${description} {\n  ${flds}\n} ${(0, $2xd6i.beetBytes)(this)}`);
        }
    }
    /**
     * Along with `write` this allows structs to be treated as {@link Beet}s and
     * thus supports composing/nesting them the same way.
     * @private
     */ read(buf, offset) {
        const [value] = this.deserialize(buf, offset);
        return value;
    }
    /**
     * Along with `read` this allows structs to be treated as {@link Beet}s and
     * thus supports composing/nesting them the same way.
     * @private
     */ write(buf, offset, value) {
        const [innerBuf, innerOffset] = this.serialize(value);
        innerBuf.copy(buf, offset, 0, innerOffset);
    }
    /**
     * Deserializes an instance of the Class from the provided buffer starting to
     * read at the provided offset.
     *
     * @returns `[instance of Class, offset into buffer after deserialization completed]`
     */ deserialize(buffer, offset = 0) {
        if ($2xd6i.logTrace.enabled) {
            (0, $2xd6i.logTrace)("deserializing [%s] from %d bytes buffer", this.description, buffer.byteLength);
            (0, $2xd6i.logTrace)(buffer);
            (0, $2xd6i.logTrace)(buffer.toJSON().data);
        }
        const reader = new $inPTV.BeetReader(buffer, offset);
        const args = reader.readStruct(this.fields);
        return [
            this.construct(args),
            reader.offset
        ];
    }
    /**
     * Serializes the provided instance into a new {@link Buffer}
     *
     * @param instance of the struct to serialize
     * @param byteSize allows to override the size fo the created Buffer and
     * defaults to the size of the struct to serialize
     */ serialize(instance, byteSize = this.byteSize) {
        (0, $2xd6i.logTrace)("serializing [%s] %o to %d bytes buffer", this.description, instance, byteSize);
        const writer = new $inPTV.BeetWriter(byteSize);
        writer.writeStruct(instance, this.fields);
        return [
            writer.buffer,
            writer.offset
        ];
    }
    getByteSize() {
        return this.fields.reduce((acc, [_, beet])=>acc + beet.byteSize, 0);
    }
    get type() {
        return $327ce6e8b4836d9b$var$BeetStruct.TYPE;
    }
}
module.exports.BeetStruct = $327ce6e8b4836d9b$var$BeetStruct;
$327ce6e8b4836d9b$var$BeetStruct.description = "BeetStruct";
$327ce6e8b4836d9b$var$BeetStruct.TYPE = "BeetStruct";
function $327ce6e8b4836d9b$var$isBeetStruct(beet) {
    return beet.type === $327ce6e8b4836d9b$var$BeetStruct.TYPE;
}
module.exports.isBeetStruct = $327ce6e8b4836d9b$var$isBeetStruct;
/**
 * Convenience wrapper around {@link BeetStruct} which is used for plain JavasScript
 * objects, like are used for option args passed to functions.
 *
 * @category beet/struct
 */ class $327ce6e8b4836d9b$var$BeetArgsStruct extends $327ce6e8b4836d9b$var$BeetStruct {
    constructor(fields, description = $327ce6e8b4836d9b$var$BeetArgsStruct.description){
        super(fields, (args)=>args, description);
    }
}
module.exports.BeetArgsStruct = $327ce6e8b4836d9b$var$BeetArgsStruct;
$327ce6e8b4836d9b$var$BeetArgsStruct.description = "BeetArgsStruct";

});
parcelRegister("inPTV", function(module, exports) {

var $6ZWSX = parcelRequire("6ZWSX");
var $d622a27109c5010c$require$Buffer = $6ZWSX.Buffer;
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.BeetReader = module.exports.BeetWriter = void 0;

var $aLUwE = parcelRequire("aLUwE");
/**
 * Underlying writer used to serialize structs.
 *
 * @private
 * @category beet/struct
 */ class $d622a27109c5010c$var$BeetWriter {
    constructor(byteSize){
        this.buf = $d622a27109c5010c$require$Buffer.alloc(byteSize);
        this._offset = 0;
    }
    get buffer() {
        return this.buf;
    }
    get offset() {
        return this._offset;
    }
    maybeResize(bytesNeeded) {
        if (this._offset + bytesNeeded > this.buf.length) $aLUwE.strict.fail(`We shouldn't ever need to resize, but ${this._offset + bytesNeeded} > ${this.buf.length}`);
    }
    write(beet, value) {
        this.maybeResize(beet.byteSize);
        beet.write(this.buf, this._offset, value);
        this._offset += beet.byteSize;
    }
    writeStruct(instance, fields) {
        for (const [key, beet] of fields){
            const value = instance[key];
            this.write(beet, value);
        }
    }
}
module.exports.BeetWriter = $d622a27109c5010c$var$BeetWriter;
/**
 * Underlying reader used to deserialize structs.
 *
 * @private
 * @category beet/struct
 */ class $d622a27109c5010c$var$BeetReader {
    constructor(buffer, _offset = 0){
        this.buffer = buffer;
        this._offset = _offset;
    }
    get offset() {
        return this._offset;
    }
    read(beet) {
        const value = beet.read(this.buffer, this._offset);
        this._offset += beet.byteSize;
        return value;
    }
    readStruct(fields) {
        const acc = {};
        for (const [key, beet] of fields)acc[key] = this.read(beet);
        return acc;
    }
}
module.exports.BeetReader = $d622a27109c5010c$var$BeetReader;

});


parcelRegister("d5fNB", function(module, exports) {
"use strict";
var $9867ff587fb97119$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.FixableBeetArgsStruct = module.exports.isFixableBeetStruct = module.exports.FixableBeetStruct = void 0;

var $l9HYk = parcelRequire("l9HYk");

var $4kKfe = parcelRequire("4kKfe");

var $kOHSh = parcelRequire("kOHSh");

var $aLUwE = parcelRequire("aLUwE");

var $2xd6i = parcelRequire("2xd6i");

const $9867ff587fb97119$var$ansicolors_1 = $9867ff587fb97119$var$__importDefault((parcelRequire("5wDjf")));
const { brightBlack: $9867ff587fb97119$var$brightBlack } = $9867ff587fb97119$var$ansicolors_1.default;
/**
 * Configures a class or any JavaScript object type for de/serialization aka
 * read/write. Not all fields of that class have to be of fixed size.
 * If none of the fields requires a {@link FixableBeet} use the {@link BeetStruct} instead.
 *
 * @template Class the type to produce when deserializing
 * @template Args contains all fields, is typically a subset of Class and is
 * used to construct an instance of it
 *
 * @category beet/struct
 */ class $9867ff587fb97119$var$FixableBeetStruct {
    /**
     * Creates an instance of the {@link FixableBeetStruct}.
     *
     * @param fields fixed or fixable de/serializers for each field of the {@link Class}
     * @param construct the function that creates an instance of {@link Class}
     * from the args
     * @param description identifies this struct for diagnostics/debugging
     * purposes
     */ constructor(fields, construct, description = $9867ff587fb97119$var$FixableBeetStruct.description){
        this.fields = fields;
        this.construct = construct;
        this.description = description;
        let minByteSize = 0;
        if ($2xd6i.logDebug.enabled) {
            const flds = fields.map(([key, val])=>{
                if ((0, $kOHSh.isFixedSizeBeet)(val)) minByteSize += val.byteSize;
                return `${key}: ${val.description} ${(0, $2xd6i.beetBytes)(val)}`;
            }).join("\n  ");
            const bytes = `> ${minByteSize} B`;
            (0, $2xd6i.logDebug)(`struct ${description} {\n  ${flds}\n} ${$9867ff587fb97119$var$brightBlack(bytes)}`);
        }
    }
    /**
     * Deserializes an instance of the Class from the provided buffer starting to
     * read at the provided offset.
     *
     * @returns `[instance of Class, offset into buffer after deserialization completed]`
     */ deserialize(buffer, offset = 0) {
        return this.toFixedFromData(buffer, offset).deserialize(buffer, offset);
    }
    /**
     * Serializes the provided instance into a new {@link Buffer}
     *
     * **NOTE:** that the `instance` is traversed and each of its fields accessed
     * twice, once to derive a _fixed size_ {@link BeetStruct} and then use it to
     * serialize the `instance`.
     * Therefore ensure that none of the properties that are part of the struct
     * have side effects, i.e. via `Getter`s.
     *
     * @param instance of the struct to serialize
     * @param byteSize allows to override the size fo the created Buffer and
     * defaults to the size of the struct to serialize
     */ serialize(instance, byteSize) {
        return this.toFixedFromValue(instance).serialize(instance, byteSize);
    }
    toFixedFromData(buf, offset) {
        let cursor = offset;
        const fixedFields = new Array(this.fields.length);
        for(let i = 0; i < this.fields.length; i++){
            const [key, beet] = this.fields[i];
            const fixedBeet = (0, $l9HYk.fixBeetFromData)(beet, buf, cursor);
            fixedFields[i] = [
                key,
                fixedBeet
            ];
            cursor += fixedBeet.byteSize;
        }
        return this.description !== $9867ff587fb97119$var$FixableBeetStruct.description ? new $4kKfe.BeetStruct(fixedFields, this.construct, this.description) : new $4kKfe.BeetStruct(fixedFields, this.construct);
    }
    toFixedFromValue(args) {
        const argsKeys = Object.keys(args);
        const fixedFields = new Array(this.fields.length);
        for(let i = 0; i < this.fields.length; i++){
            const [key, beet] = this.fields[i];
            (0, $aLUwE.strict)(argsKeys.includes(key), `Value with keys [ ${argsKeys} ] should include struct key '${key}' but doesn't.`);
            const val = args[key];
            const fixedBeet = (0, $l9HYk.fixBeetFromValue)(beet, val);
            fixedFields[i] = [
                key,
                fixedBeet
            ];
        }
        return this.description !== $9867ff587fb97119$var$FixableBeetStruct.description ? new $4kKfe.BeetStruct(fixedFields, this.construct, this.description) : new $4kKfe.BeetStruct(fixedFields, this.construct);
    }
    get type() {
        return $9867ff587fb97119$var$FixableBeetStruct.TYPE;
    }
}
module.exports.FixableBeetStruct = $9867ff587fb97119$var$FixableBeetStruct;
$9867ff587fb97119$var$FixableBeetStruct.description = "FixableBeetStruct";
$9867ff587fb97119$var$FixableBeetStruct.TYPE = "FixableBeetStruct";
function $9867ff587fb97119$var$isFixableBeetStruct(beet) {
    return beet.type === $9867ff587fb97119$var$FixableBeetStruct.TYPE;
}
module.exports.isFixableBeetStruct = $9867ff587fb97119$var$isFixableBeetStruct;
/**
 * Convenience wrapper around {@link FixableBeetStruct} which is used for plain JavasScript
 * objects, like are used for option args passed to functions.
 *
 * @category beet/struct
 */ class $9867ff587fb97119$var$FixableBeetArgsStruct extends $9867ff587fb97119$var$FixableBeetStruct {
    constructor(fields, description = $9867ff587fb97119$var$FixableBeetArgsStruct.description){
        super(fields, (args)=>args, description);
    }
}
module.exports.FixableBeetArgsStruct = $9867ff587fb97119$var$FixableBeetArgsStruct;
$9867ff587fb97119$var$FixableBeetArgsStruct.description = "FixableBeetArgsStruct";

});

parcelRegister("i0sX8", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.unitTypeMap = module.exports.unit = void 0;

var $kOHSh = parcelRequire("kOHSh");
/**
 * De/Serializer for non-values, i.e. `void`, `()`, `undefined` aka the _unit_ type .
 *
 * @category beet/primitive
 */ module.exports.unit = {
    write: function(_buf, _offset, _value) {},
    read: function(_buf, _offset) {
        return undefined;
    },
    byteSize: 0,
    description: "unit"
};
/**
 * Maps unit beet exports to metadata which describes in which package it
 * is defined as well as which TypeScript type is used to represent the
 * deserialized value in JavaScript.
 *
 * @category TypeDefinition
 */ module.exports.unitTypeMap = {
    unit: {
        beet: "unit",
        isFixable: false,
        sourcePack: $kOHSh.BEET_PACKAGE,
        ts: "void"
    }
};

});


parcelRegister("5vXUZ", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.aliasesTypeMap = module.exports.bytes = void 0;

var $3rgjF = parcelRequire("3rgjF");
/**
 * Alias for {@link uint8Array}.
 * @category TypeDefinition
 */ module.exports.bytes = $3rgjF.uint8Array;
module.exports.aliasesTypeMap = {
    // @ts-ignore
    bytes: $3rgjF.collectionsTypeMap.Uint8Array
};

});

parcelRegister("ioTrE", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.tuplesTypeMap = module.exports.tuple = module.exports.fixedSizeTuple = void 0;

var $kOHSh = parcelRequire("kOHSh");

var $aLUwE = parcelRequire("aLUwE");

var $l9HYk = parcelRequire("l9HYk");
// Tuples are a special kind of composite which can be understood as
// fixed length arrays where each tuple element can have a different data type.
// Since the Tuple type itself dictates the length, and buffer layout, no extra
// information is included in the serialized data.
/**
 * De/Serializes a tuple with all fixed size tuple elements .
 * Since each tuple element can be of a different type not much type safety can
 * be provided here.
 *
 * @param elements the De/Serializer for each tuple element type
 *
 * @category beet/composite
 */ function $d6557a1e225d0a31$var$fixedSizeTuple(elements) {
    const len = elements.length;
    const elDescs = elements.map((x)=>x.description);
    const byteSizes = elements.map((x)=>x.byteSize);
    const byteSize = byteSizes.reduce((acc, x)=>acc + x, 0);
    return {
        write: function(buf, offset, value) {
            $aLUwE.strict.equal(value.length, len, `tuple value element size ${value.length} should match len ${len}`);
            let cursor = offset;
            for(let i = 0; i < len; i++){
                const v = value[i];
                const beetEl = elements[i];
                beetEl.write(buf, cursor, v);
                cursor += beetEl.byteSize;
            }
        },
        read: function(buf, offset) {
            const els = [];
            let cursor = offset;
            for(let i = 0; i < len; i++){
                const elBeet = elements[i];
                els[i] = elBeet.read(buf, cursor);
                cursor += elBeet.byteSize;
            }
            return els;
        },
        byteSize: byteSize,
        length: len,
        description: `FixedSizeTuple<${elDescs.join(",")}>[ ${byteSizes.join(", ")} ]`
    };
}
module.exports.fixedSizeTuple = $d6557a1e225d0a31$var$fixedSizeTuple;
/**
 * De/Serializes a tuple which contains some non-fixed size tuple elements.
 *
 * Since each tuple element can be of a different type not much type safety can
 * be provided here.
 *
 * @param elements the De/Serializer for each tuple element type
 * @category beet/composite
 */ function $d6557a1e225d0a31$var$tuple(elements) {
    const len = elements.length;
    const elDescs = elements.map((x)=>x.description);
    return {
        toFixedFromData (buf, offset) {
            let cursor = offset;
            const fixedElements = new Array(len);
            for(let i = 0; i < len; i++){
                const fixedElement = (0, $l9HYk.fixBeetFromData)(elements[i], buf, cursor);
                fixedElements[i] = fixedElement;
                cursor += fixedElement.byteSize;
            }
            return $d6557a1e225d0a31$var$fixedSizeTuple(fixedElements);
        },
        toFixedFromValue (vals) {
            (0, $aLUwE.strict)(Array.isArray(vals), `${vals} should be an array of tuple values`);
            $aLUwE.strict.equal(vals.length, len, `There should be ${len} tuple values, but there are ${vals.length}`);
            const fixedElements = new Array(len);
            for(let i = 0; i < vals.length; i++){
                const fixedElement = (0, $l9HYk.fixBeetFromValue)(elements[i], vals[i]);
                fixedElements[i] = fixedElement;
            }
            return $d6557a1e225d0a31$var$fixedSizeTuple(fixedElements);
        },
        description: `Tuple<${elDescs.join(",")}>`
    };
}
module.exports.tuple = $d6557a1e225d0a31$var$tuple;
/**
 * Maps tuples beet exports to metadata which describes in which package it
 * is defined as well as which TypeScript type is used to represent the
 * deserialized value in JavaScript.
 *
 * @category TypeDefinition
 */ module.exports.tuplesTypeMap = {
    Tuple: {
        beet: "tuple",
        isFixable: true,
        sourcePack: $kOHSh.BEET_PACKAGE,
        ts: "[__tuple_elements__]"
    },
    FixedSizeTuple: {
        beet: "fixedSizeTuple",
        isFixable: false,
        sourcePack: $kOHSh.BEET_PACKAGE,
        ts: "[__tuple_elements__]"
    }
};

});

parcelRegister("ipcLD", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.mapsTypeMap = module.exports.map = void 0;

var $kOHSh = parcelRequire("kOHSh");

var $7RrfS = parcelRequire("7RrfS");

var $2xd6i = parcelRequire("2xd6i");

var $aLUwE = parcelRequire("aLUwE");
/**
 * De/Serializes a map with a specific number of key/values of type {@link K}
 * and {@link V} respectively.
 *
 * NOTE: that it is not exported as no fixed size map exists but will have to
 * be derived from data or value instead.
 *
 * @template K type of key elements held in the map
 * @template V type of value elements held in the map
 *
 * @param keyElement the De/Serializers for the key element types
 * @param valElement the De/Serializers for the value element types
 * @param len amount of entries in the map
 *
 * @category beet/composite
 * @private
 */ function $d664771978268b87$var$fixedSizeMap(keyElement, valElement, fixedElements, len) {
    const keyElementFixed = (0, $kOHSh.isFixedSizeBeet)(keyElement);
    const valElementFixed = (0, $kOHSh.isFixedSizeBeet)(valElement);
    function determineSizes() {
        if (keyElementFixed && valElementFixed) {
            const elementByteSize = keyElement.byteSize + valElement.byteSize;
            return {
                elementByteSize: elementByteSize,
                byteSize: 4 + len * elementByteSize
            };
        } else if (keyElementFixed) {
            let valsByteSize = 0;
            for (const [_, v] of fixedElements.values())valsByteSize += v.byteSize;
            // If any element has a dynamic size all we can do here is take an average
            const elementByteSize = keyElement.byteSize + Math.ceil(valsByteSize / len);
            return {
                elementByteSize: elementByteSize,
                byteSize: 4 + keyElement.byteSize * len + valsByteSize
            };
        } else if (valElementFixed) {
            let keysByteSize = 0;
            for (const [k, _] of fixedElements.values())keysByteSize += k.byteSize;
            const elementByteSize = Math.ceil(keysByteSize / len) + valElement.byteSize;
            return {
                elementByteSize: elementByteSize,
                byteSize: 4 + keysByteSize + valElement.byteSize * len
            };
        } else {
            let keysByteSize = 0;
            let valsByteSize = 0;
            for (const [k, v] of fixedElements.values()){
                keysByteSize += k.byteSize;
                valsByteSize += v.byteSize;
            }
            const elementByteSize = Math.ceil(keysByteSize / len + valsByteSize / len);
            return {
                elementByteSize: elementByteSize,
                byteSize: 4 + keysByteSize + valsByteSize
            };
        }
    }
    const { elementByteSize: elementByteSize, byteSize: byteSize } = determineSizes();
    return {
        write: function(buf, offset, map) {
            // Write the values first and then the size as it comes clear while we do the former
            let cursor = offset + 4;
            let size = 0;
            for (const [k, v] of map.entries()){
                let fixedKey = keyElementFixed ? keyElement : null;
                let fixedVal = valElementFixed ? valElement : null;
                if (fixedKey == null || fixedVal == null) {
                    // When we write the value we know the key and an just pull the
                    // matching fixed beet for key/val from the provided map which is
                    // faster than fixing it by value
                    const els = fixedElements.get(k);
                    (0, $aLUwE.strict)(els != null, `Should be able to find beet els for ${(0, $2xd6i.stringify)(k)}, but could not`);
                    fixedKey !== null && fixedKey !== void 0 ? fixedKey : fixedKey = els[0];
                    fixedVal !== null && fixedVal !== void 0 ? fixedVal : fixedVal = els[1];
                }
                fixedKey.write(buf, cursor, k);
                cursor += fixedKey.byteSize;
                fixedVal.write(buf, cursor, v);
                cursor += fixedVal.byteSize;
                size++;
            }
            $7RrfS.u32.write(buf, offset, size);
            $aLUwE.strict.equal(size, len, `Expected map to have size ${len}, but has ${size}.`);
        },
        read: function(buf, offset) {
            const size = $7RrfS.u32.read(buf, offset);
            $aLUwE.strict.equal(size, len, `Expected map to have size ${len}, but has ${size}.`);
            let cursor = offset + 4;
            const map = new Map();
            for(let i = 0; i < size; i++){
                // When we read the value from a buffer we don't know the key we're
                // reading yet and thus cannot use the provided map of fixed
                // de/serializers.
                // Therefore we obtain it by fixing it by data instead.
                const fixedKey = keyElementFixed ? keyElement : keyElement.toFixedFromData(buf, cursor);
                const k = fixedKey.read(buf, cursor);
                cursor += fixedKey.byteSize;
                const fixedVal = valElementFixed ? valElement : valElement.toFixedFromData(buf, cursor);
                const v = fixedVal.read(buf, cursor);
                cursor += fixedVal.byteSize;
                map.set(k, v);
            }
            return map;
        },
        elementByteSize: elementByteSize,
        byteSize: byteSize,
        length: len,
        lenPrefixByteSize: 4,
        description: `Map<${keyElement.description}, ${valElement.description}>`
    };
}
/**
 * De/Serializes a map with a specific number of key/values of type {@link K}
 * and {@link V} respectively.
 *
 * @template K type of key elements held in the map
 * @template V type of value elements held in the map
 *
 * @param keyElement the _fixable_ or _fixed_ de/serializers for the key element types
 * @param valElement the _fixable_ or _fixed_ de/serializers for the value element types
 *
 * @category beet/composite
 */ function $d664771978268b87$var$map(keyElement, valElement) {
    const keyIsFixed = (0, $kOHSh.isFixedSizeBeet)(keyElement);
    const valIsFixed = (0, $kOHSh.isFixedSizeBeet)(valElement);
    return {
        toFixedFromData (buf, offset) {
            const len = $7RrfS.u32.read(buf, offset);
            let cursor = offset + 4;
            // Shortcut for the case that both key and value are fixed size beets
            if (keyIsFixed && valIsFixed) return $d664771978268b87$var$fixedSizeMap(keyElement, valElement, new Map(), len);
            // If either key or val are not fixed size beets we need to determine the
            // fixed versions and add them to a map by key
            const fixedBeets = new Map();
            for(let i = 0; i < len; i++){
                const keyFixed = keyIsFixed ? keyElement : keyElement.toFixedFromData(buf, cursor);
                const key = keyFixed.read(buf, cursor);
                cursor += keyFixed.byteSize;
                const valFixed = valIsFixed ? valElement : valElement.toFixedFromData(buf, cursor);
                cursor += valFixed.byteSize;
                fixedBeets.set(key, [
                    keyFixed,
                    valFixed
                ]);
            }
            return $d664771978268b87$var$fixedSizeMap(keyElement, valElement, fixedBeets, len);
        },
        toFixedFromValue (mapVal) {
            const len = mapVal.size;
            // As above shortcut for the optimal case and build a map for all others
            if (keyIsFixed && valIsFixed) return $d664771978268b87$var$fixedSizeMap(keyElement, valElement, new Map(), len);
            const fixedBeets = new Map();
            for (const [k, v] of mapVal){
                const keyFixed = keyIsFixed ? keyElement : keyElement.toFixedFromValue(k);
                const valFixed = valIsFixed ? valElement : valElement.toFixedFromValue(v);
                fixedBeets.set(k, [
                    keyFixed,
                    valFixed
                ]);
            }
            return $d664771978268b87$var$fixedSizeMap(keyElement, valElement, fixedBeets, len);
        },
        description: `FixableMap<${keyElement.description}, ${valElement.description}>`
    };
}
module.exports.map = $d664771978268b87$var$map;
/**
 * Maps maps beet exports to metadata which describes in which package it
 * is defined as well as which TypeScript type is used to represent the
 * deserialized value in JavaScript.
 *
 * @category TypeDefinition
 */ module.exports.mapsTypeMap = {
    Map: {
        beet: "map",
        isFixable: true,
        sourcePack: $kOHSh.BEET_PACKAGE,
        ts: "Map"
    }
};

});

parcelRegister("dWJUH", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.setsTypeMap = module.exports.set = void 0;

var $kOHSh = parcelRequire("kOHSh");

var $7RrfS = parcelRequire("7RrfS");

var $2xd6i = parcelRequire("2xd6i");

var $aLUwE = parcelRequire("aLUwE");
/**
 * De/Serializes a set with a specific number of keys of type {@link K}.
 *
 * NOTE: that it is not exported as no fixed size set exists but will have to
 * be derived from data or value instead.
 *
 * @template K type of key elements held in the set
 *
 * @param keyElement the De/Serializers for the key element types
 * @param len amount of entries in the set
 *
 * @category beet/composite
 * @private
 */ function $a2744e96ba67f8d1$var$fixedSizeSet(keyElement, fixedElements, len) {
    const keyElementFixed = (0, $kOHSh.isFixedSizeBeet)(keyElement);
    function determineSizes() {
        if (keyElementFixed) {
            const elementByteSize = keyElement.byteSize;
            return {
                elementByteSize: elementByteSize,
                byteSize: 4 + len * elementByteSize
            };
        } else {
            let keysByteSize = 0;
            for (const k of fixedElements.values())keysByteSize += k.byteSize;
            const elementByteSize = Math.ceil(keysByteSize / len);
            return {
                elementByteSize: elementByteSize,
                byteSize: 4 + keysByteSize
            };
        }
    }
    const { elementByteSize: elementByteSize, byteSize: byteSize } = determineSizes();
    return {
        write: function(buf, offset, set) {
            // Write the values first and then the size as it comes clear while we do the former
            let cursor = offset + 4;
            let size = 0;
            for (const k of set.keys()){
                let fixedKey = keyElementFixed ? keyElement : null;
                if (fixedKey == null) {
                    // When we write the value we know the key and an just pull the
                    // matching fixed beet for key from the provided set which is
                    // faster than fixing it by value
                    const el = fixedElements.get(k);
                    (0, $aLUwE.strict)(el != null, `Should be able to find beet el for ${(0, $2xd6i.stringify)(k)}, but could not`);
                    fixedKey !== null && fixedKey !== void 0 ? fixedKey : fixedKey = el;
                }
                fixedKey.write(buf, cursor, k);
                cursor += fixedKey.byteSize;
                size++;
            }
            $7RrfS.u32.write(buf, offset, size);
            $aLUwE.strict.equal(size, len, `Expected set to have size ${len}, but has ${size}.`);
        },
        read: function(buf, offset) {
            const size = $7RrfS.u32.read(buf, offset);
            $aLUwE.strict.equal(size, len, `Expected set to have size ${len}, but has ${size}.`);
            let cursor = offset + 4;
            const set = new Set();
            for(let i = 0; i < size; i++){
                // When we read the value from a buffer we don't know the key we're
                // reading yet and thus cannot use the provided set of fixed
                // de/serializers.
                // Therefore we obtain it by fixing it by data instead.
                const fixedKey = keyElementFixed ? keyElement : keyElement.toFixedFromData(buf, cursor);
                const k = fixedKey.read(buf, cursor);
                cursor += fixedKey.byteSize;
                set.add(k);
            }
            return set;
        },
        elementByteSize: elementByteSize,
        byteSize: byteSize,
        length: len,
        lenPrefixByteSize: 4,
        description: `Set<${keyElement.description}>`
    };
}
/**
 * De/Serializes a set with a specific number of keys of type {@link K}
 *
 * @template K type of key elements held in the set
 *
 * @param keyElement the _fixable_ or _fixed_ de/serializers for the key element types
 *
 * @category beet/composite
 */ function $a2744e96ba67f8d1$var$set(keyElement) {
    const keyIsFixed = (0, $kOHSh.isFixedSizeBeet)(keyElement);
    return {
        toFixedFromData (buf, offset) {
            const len = $7RrfS.u32.read(buf, offset);
            let cursor = offset + 4;
            // Shortcut for the case that both key and value are fixed size beets
            if (keyIsFixed) return $a2744e96ba67f8d1$var$fixedSizeSet(keyElement, new Map(), len);
            // If key is not fixed size beet we need to determine the fixed versions and add them to a set by key
            const fixedBeets = new Map();
            for(let i = 0; i < len; i++){
                const keyFixed = keyIsFixed ? keyElement : keyElement.toFixedFromData(buf, cursor);
                const key = keyFixed.read(buf, cursor);
                cursor += keyFixed.byteSize;
                fixedBeets.set(key, keyFixed);
            }
            return $a2744e96ba67f8d1$var$fixedSizeSet(keyElement, fixedBeets, len);
        },
        toFixedFromValue (setVal) {
            const len = setVal.size;
            // As above shortcut for the optimal case and build a set for all others
            if (keyIsFixed) return $a2744e96ba67f8d1$var$fixedSizeSet(keyElement, new Map(), len);
            const fixedBeets = new Map();
            for (const k of setVal){
                const keyFixed = keyIsFixed ? keyElement : keyElement.toFixedFromValue(k);
                fixedBeets.set(k, keyFixed);
            }
            return $a2744e96ba67f8d1$var$fixedSizeSet(keyElement, fixedBeets, len);
        },
        description: `FixableSet<${keyElement.description}>`
    };
}
module.exports.set = $a2744e96ba67f8d1$var$set;
/**
 * Sets sets beet exports to metadata which describes in which package it
 * is defined as well as which TypeScript type is used to represent the
 * deserialized value in JavaScript.
 *
 * @category TypeDefinition
 */ module.exports.setsTypeMap = {
    Set: {
        beet: "set",
        isFixable: true,
        sourcePack: $kOHSh.BEET_PACKAGE,
        ts: "Set"
    }
};

});


parcelRegister("8OnYx", function(module, exports) {
"use strict";
var $66a597413bb7650f$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $66a597413bb7650f$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $66a597413bb7650f$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.supportedTypeMap = void 0;


$66a597413bb7650f$var$__exportStar((parcelRequire("6b618")), module.exports);

$66a597413bb7650f$var$__exportStar((parcelRequire("efy3L")), module.exports);
/**
 * Maps solana beet exports to metadata which describes in which package it
 * is defined as well as which TypeScript type is used to represent the
 * deserialized value in JavaScript.
 *
 * @category TypeDefinition
 */ module.exports.supportedTypeMap = (parcelRequire("6b618")).keysTypeMap;

});
parcelRegister("6b618", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.keysTypeMap = module.exports.publicKey = void 0;

var $gNDby = parcelRequire("gNDby");

var $1DULh = parcelRequire("1DULh");
const $47f8701010c4006a$var$BEET_SOLANA_PACKAGE = "@metaplex-foundation/beet-solana";
const $47f8701010c4006a$var$SOLANA_WEB3_PACKAGE = "@solana/web3.js";
const $47f8701010c4006a$var$uint8Array32 = (0, $1DULh.fixedSizeUint8Array)(32);
/**
 * De/Serializer for solana {@link PublicKey}s aka `publicKey`.
 *
 *
 * ## Using PublicKey Directly
 *
 * ```ts
 * import { publicKey } from '@metaplex-foundation/beet-solana'
 *
 * const generatedKey  = Keypair.generate().publicKey
 * const buf = Buffer.alloc(publicKey.byteSize)
 * beet.write(buf, 0, generatedKey)
 * beet.read(buf, 0) // same as generatedKey
 * ```
 *
 * ## PublicKey as part of a Struct Configuration
 *
 * ```ts
 * import { publicKey } from '@metaplex-foundation/beet-solana'
 *
 * type InstructionArgs = {
 *   authority: web3.PublicKey
 * }
 *
 * const createStruct = new beet.BeetArgsStruct<InstructionArgs>(
 *   [
 *     ['authority', publicKey]
 *   ],
 *   'InstructionArgs'
 * )
 * ```
 *
 * @category beet/solana
 */ module.exports.publicKey = {
    write: function(buf, offset, value) {
        const arr = value.toBytes();
        $47f8701010c4006a$var$uint8Array32.write(buf, offset, arr);
    },
    read: function(buf, offset) {
        const bytes = $47f8701010c4006a$var$uint8Array32.read(buf, offset);
        return new $gNDby.PublicKey(bytes);
    },
    byteSize: $47f8701010c4006a$var$uint8Array32.byteSize,
    description: "PublicKey"
};
/**
 * Maps solana keys beet exports to metadata which describes in which package it
 * is defined as well as which TypeScript type is used to represent the
 * deserialized value in JavaScript.
 *
 * @category TypeDefinition
 */ module.exports.keysTypeMap = {
    publicKey: {
        beet: "publicKey",
        isFixable: false,
        sourcePack: $47f8701010c4006a$var$BEET_SOLANA_PACKAGE,
        ts: "PublicKey",
        pack: $47f8701010c4006a$var$SOLANA_WEB3_PACKAGE
    }
};

});

parcelRegister("efy3L", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.GpaBuilder = void 0;

var $1DULh = parcelRequire("1DULh");

var $aLUwE = parcelRequire("aLUwE");

var $ceQUo = parcelRequire("ceQUo");

var $4UQgj = parcelRequire("4UQgj");
/**
 * Provides an Account specific GPA builder.
 *
 * @template T - the type of the account for which the GpaBuilder is used
 */ class $a5fce2edf8b8bef4$var$GpaBuilder {
    constructor(programId, beets, accountSize){
        this.programId = programId;
        this.beets = beets;
        this.accountSize = accountSize;
        /**
         * web3.js {@link GetProgramAccountsConfig} configured via filter GpaBuilder filter methods.
         */ this.config = {};
    }
    _addFilter(filter) {
        if (this.config.filters == null) this.config.filters = [];
        this.config.filters.push(filter);
        return this;
    }
    _addInnerFilter(key, innerKey, val) {
        (0, $ceQUo.logTrace)(`gpa.addInnerFilter: ${key}.${innerKey}`);
        const outerBeetInfo = this.beets.get(key);
        (0, $aLUwE.strict)(outerBeetInfo != null, "Outer filter key needs to be an existing field name");
        const beetInfo = outerBeetInfo.beet;
        let offset = outerBeetInfo.offset;
        const outerBeet = (0, $1DULh.isFixedSizeBeet)(beetInfo) ? beetInfo : beetInfo.toFixedFromValue(val);
        let beet;
        for (const [k, v] of outerBeet.fields){
            if (k === innerKey) {
                beet = v;
                break;
            }
            offset += v.byteSize;
        }
        (0, $aLUwE.strict)(beet != null, `${innerKey} is not a field of the ${key} struct`);
        const bytes = (0, $4UQgj.encodeFixedBeet)(beet, val);
        this._addFilter({
            memcmp: {
                offset: offset,
                bytes: bytes
            }
        });
        return this;
    }
    /**
     * Adds a _memcmp_ filter for a field inside a field which is a struct value.
     * The provided keys need to be separated by a `.` and only one level of
     * nesting is supported at this point.
     *
     * The filter is applied to the inner value.
     *
     * ## Example
     *
     * ### Given:
     *
     * ```typescript
     * type Inner = {
     *   a: number
     * }
     * type Outer = {
     *   idx: number
     *   inner: Inner
     * }
     * ```
     * ### Apply a filter on `a` of the `Inner` type:
     *
     * ```typescript
     * gpaBuilder.addInnerFilter('inner.a', 2)
     * ```
     *
     * @param keys - the names of the fields by which to filter, i.e. `'outer.inner'`
     * @param val - the field value that the filter should match
     */ addInnerFilter(keys, val) {
        const parts = keys.split(".");
        $aLUwE.strict.equal(parts.length, 2, `inner filters can go only one level deep, i.e. 'outer.inner' is ok, but 'outer.inner.deep' is not`);
        const [ka, kb] = parts;
        return this._addInnerFilter(ka, kb, val);
    }
    /**
     * Adds a _memcmp_ filter for the provided {@link key} of the struct.
     *
     * @param key - the name of the field by which to filter
     * @param val - the field value that the filter should match
     */ addFilter(key, val) {
        const beetInfo = this.beets.get(key);
        (0, $aLUwE.strict)(beetInfo != null, "Filter key needs to be an existing field name");
        const beet = (0, $1DULh.isFixedSizeBeet)(beetInfo.beet) ? beetInfo.beet : beetInfo.beet.toFixedFromValue(val);
        const bytes = (0, $4UQgj.encodeFixedBeet)(beet, val);
        this._addFilter({
            memcmp: {
                offset: beetInfo.offset,
                bytes: bytes
            }
        });
        return this;
    }
    /**
     * Adds a `dataSize` filter which will match on account's sizes.
     * You have to provide that {@link size} for accounts that don't have a fixed size.
     * For _fixed_ size accounts that size is determined for you.
     *
     * @param size - the account size to match for
     */ dataSize(size) {
        size = size !== null && size !== void 0 ? size : this.accountSize;
        (0, $aLUwE.strict)(size != null, "for accounts of dynamic size the dataSize arg needs to be provided");
        return this._addFilter({
            dataSize: size
        });
    }
    /**
     * Attempts to find the accounts matching the configured filters.
     *
     * @param connection used to query the program accounts on the cluster
     */ run(connection) {
        return connection.getProgramAccounts(this.programId, this.config);
    }
    /**
     * Creates a GPA builder that supports adding up to four filters for
     * fixed size fields.
     *
     * Once a non-fixed field is encountered, the remaining fields following it
     * will not be included as a filter option since their position in the
     * bytes array will change depending on the content of the non-fixed field.
     *
     * @param programId - the id of the program that owns the accounts we are querying
     * @param beetFields - the beet fields that make up the structure of the account data
     */ static fromBeetFields(programId, beetFields) {
        const map = new Map();
        let offset = 0;
        let encounteredNonFixed = false;
        for (const [k, v] of beetFields){
            map.set(k, {
                beet: v,
                offset: offset
            });
            if (!(0, $1DULh.isFixedSizeBeet)(v)) {
                encounteredNonFixed = true;
                break;
            }
            offset += v.byteSize;
        }
        const accountSize = encounteredNonFixed ? undefined : offset;
        return new $a5fce2edf8b8bef4$var$GpaBuilder(programId, map, accountSize);
    }
    /**
     * Convenience wrapper around {@link GpaBuilder.fromBeetFields} that allows
     * providing a struct which contains the beet fields.
     *
     * @param programId - the id of the program that owns the accounts we are querying
     * @param struct - containing the beet `fields` specifying the layout of the account
     */ static fromStruct(programId, struct) {
        return $a5fce2edf8b8bef4$var$GpaBuilder.fromBeetFields(programId, struct.fields);
    }
}
module.exports.GpaBuilder = $a5fce2edf8b8bef4$var$GpaBuilder;

});
parcelRegister("ceQUo", function(module, exports) {
"use strict";
var $8e8fd55d5c22472b$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.logTrace = module.exports.logDebug = module.exports.logInfo = module.exports.logError = void 0;

const $8e8fd55d5c22472b$var$debug_1 = $8e8fd55d5c22472b$var$__importDefault((parcelRequire("1SXIy")));
module.exports.logError = (0, $8e8fd55d5c22472b$var$debug_1.default)("beet:error");
module.exports.logInfo = (0, $8e8fd55d5c22472b$var$debug_1.default)("beet:info");
module.exports.logDebug = (0, $8e8fd55d5c22472b$var$debug_1.default)("beet:debug");
module.exports.logTrace = (0, $8e8fd55d5c22472b$var$debug_1.default)("beet:trace");

});

parcelRegister("4UQgj", function(module, exports) {

var $6ZWSX = parcelRequire("6ZWSX");
var $3944ee91e912904c$require$Buffer = $6ZWSX.Buffer;
"use strict";
var $3944ee91e912904c$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.encodeFixedBeet = void 0;

const $3944ee91e912904c$var$bs58_1 = $3944ee91e912904c$var$__importDefault((parcelRequire("bYkMz")));
function $3944ee91e912904c$var$encodeFixedBeet(beet, val) {
    const buf = $3944ee91e912904c$require$Buffer.alloc(beet.byteSize);
    beet.write(buf, 0, val);
    return $3944ee91e912904c$var$bs58_1.default.encode(buf);
}
module.exports.encodeFixedBeet = $3944ee91e912904c$var$encodeFixedBeet;

});




parcelRegister("6iBPp", function(module, exports) {
"use strict";
var $4961c462fea64a88$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $4961c462fea64a88$var$__setModuleDefault = module.exports && module.exports.__setModuleDefault || (Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
});
var $4961c462fea64a88$var$__importStar = module.exports && module.exports.__importStar || function(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) $4961c462fea64a88$var$__createBinding(result, mod, k);
    }
    $4961c462fea64a88$var$__setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.voucherBeet = module.exports.Voucher = module.exports.voucherDiscriminator = void 0;

const $4961c462fea64a88$var$web3 = $4961c462fea64a88$var$__importStar((parcelRequire("gNDby")));

const $4961c462fea64a88$var$beet = $4961c462fea64a88$var$__importStar((parcelRequire("1DULh")));

const $4961c462fea64a88$var$beetSolana = $4961c462fea64a88$var$__importStar((parcelRequire("8OnYx")));

var $fwbNs = parcelRequire("fwbNs");
module.exports.voucherDiscriminator = [
    191,
    204,
    149,
    234,
    213,
    165,
    13,
    65
];
class $4961c462fea64a88$var$Voucher {
    constructor(leafSchema, index, merkleTree){
        this.leafSchema = leafSchema;
        this.index = index;
        this.merkleTree = merkleTree;
    }
    static fromArgs(args) {
        return new $4961c462fea64a88$var$Voucher(args.leafSchema, args.index, args.merkleTree);
    }
    static fromAccountInfo(accountInfo, offset = 0) {
        return $4961c462fea64a88$var$Voucher.deserialize(accountInfo.data, offset);
    }
    static async fromAccountAddress(connection, address, commitmentOrConfig) {
        const accountInfo = await connection.getAccountInfo(address, commitmentOrConfig);
        if (accountInfo == null) throw new Error(`Unable to find Voucher account at ${address}`);
        return $4961c462fea64a88$var$Voucher.fromAccountInfo(accountInfo, 0)[0];
    }
    static gpaBuilder(programId = new $4961c462fea64a88$var$web3.PublicKey("BGUMAp9Gq7iTEuizy4pqaxsTyUCBK68MDfK752saRPUY")) {
        return $4961c462fea64a88$var$beetSolana.GpaBuilder.fromStruct(programId, module.exports.voucherBeet);
    }
    static deserialize(buf, offset = 0) {
        return module.exports.voucherBeet.deserialize(buf, offset);
    }
    serialize() {
        return module.exports.voucherBeet.serialize({
            accountDiscriminator: module.exports.voucherDiscriminator,
            ...this
        });
    }
    static byteSize(args) {
        const instance = $4961c462fea64a88$var$Voucher.fromArgs(args);
        return module.exports.voucherBeet.toFixedFromValue({
            accountDiscriminator: module.exports.voucherDiscriminator,
            ...instance
        }).byteSize;
    }
    static async getMinimumBalanceForRentExemption(args, connection, commitment) {
        return connection.getMinimumBalanceForRentExemption($4961c462fea64a88$var$Voucher.byteSize(args), commitment);
    }
    pretty() {
        return {
            leafSchema: this.leafSchema.__kind,
            index: this.index,
            merkleTree: this.merkleTree.toBase58()
        };
    }
}
module.exports.Voucher = $4961c462fea64a88$var$Voucher;
module.exports.voucherBeet = new $4961c462fea64a88$var$beet.FixableBeetStruct([
    [
        "accountDiscriminator",
        $4961c462fea64a88$var$beet.uniformFixedSizeArray($4961c462fea64a88$var$beet.u8, 8)
    ],
    [
        "leafSchema",
        $fwbNs.leafSchemaBeet
    ],
    [
        "index",
        $4961c462fea64a88$var$beet.u32
    ],
    [
        "merkleTree",
        $4961c462fea64a88$var$beetSolana.publicKey
    ]
], $4961c462fea64a88$var$Voucher.fromArgs, "Voucher");

});
parcelRegister("fwbNs", function(module, exports) {
"use strict";
var $b4c2fec1b6c997a2$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $b4c2fec1b6c997a2$var$__setModuleDefault = module.exports && module.exports.__setModuleDefault || (Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
});
var $b4c2fec1b6c997a2$var$__importStar = module.exports && module.exports.__importStar || function(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) $b4c2fec1b6c997a2$var$__createBinding(result, mod, k);
    }
    $b4c2fec1b6c997a2$var$__setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.leafSchemaBeet = module.exports.isLeafSchemaV1 = void 0;

const $b4c2fec1b6c997a2$var$beet = $b4c2fec1b6c997a2$var$__importStar((parcelRequire("1DULh")));

const $b4c2fec1b6c997a2$var$beetSolana = $b4c2fec1b6c997a2$var$__importStar((parcelRequire("8OnYx")));
const $b4c2fec1b6c997a2$var$isLeafSchemaV1 = (x)=>x.__kind === "V1";
module.exports.isLeafSchemaV1 = $b4c2fec1b6c997a2$var$isLeafSchemaV1;
module.exports.leafSchemaBeet = $b4c2fec1b6c997a2$var$beet.dataEnum([
    [
        "V1",
        new $b4c2fec1b6c997a2$var$beet.BeetArgsStruct([
            [
                "id",
                $b4c2fec1b6c997a2$var$beetSolana.publicKey
            ],
            [
                "owner",
                $b4c2fec1b6c997a2$var$beetSolana.publicKey
            ],
            [
                "delegate",
                $b4c2fec1b6c997a2$var$beetSolana.publicKey
            ],
            [
                "nonce",
                $b4c2fec1b6c997a2$var$beet.u64
            ],
            [
                "dataHash",
                $b4c2fec1b6c997a2$var$beet.uniformFixedSizeArray($b4c2fec1b6c997a2$var$beet.u8, 32)
            ],
            [
                "creatorHash",
                $b4c2fec1b6c997a2$var$beet.uniformFixedSizeArray($b4c2fec1b6c997a2$var$beet.u8, 32)
            ]
        ], 'LeafSchemaRecord["V1"]')
    ]
]);

});



parcelRegister("apO5D", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.errorFromName = module.exports.errorFromCode = module.exports.CollectionMustBeSizedError = module.exports.LeafAuthorityMustSignError = module.exports.UpdateAuthorityIncorrectError = module.exports.AlreadyUnverifiedError = module.exports.AlreadyVerifiedError = module.exports.CollectionNotFoundError = module.exports.CollectionCannotBeVerifiedInThisInstructionError = module.exports.IncorrectOwnerError = module.exports.NumericalOverflowErrorError = module.exports.InsufficientMintCapacityError = module.exports.TreeAuthorityIncorrectError = module.exports.MetadataBasisPointsTooHighError = module.exports.MetadataUriTooLongError = module.exports.MetadataSymbolTooLongError = module.exports.MetadataNameTooLongError = module.exports.CreatorsTooLongError = module.exports.DataHashMismatchError = module.exports.CreatorHashMismatchError = module.exports.NoCreatorsPresentError = module.exports.CreatorNotFoundError = module.exports.CreatorDidNotVerifyError = module.exports.DuplicateCreatorAddressError = module.exports.CreatorShareTotalMustBe100Error = module.exports.UnsupportedSchemaVersionError = module.exports.HashingMismatchError = module.exports.PublicKeyMismatchError = module.exports.AssetOwnerMismatchError = void 0;
const $795317f8cbeefa16$var$createErrorFromCodeLookup = new Map();
const $795317f8cbeefa16$var$createErrorFromNameLookup = new Map();
class $795317f8cbeefa16$var$AssetOwnerMismatchError extends Error {
    constructor(){
        super("Asset Owner Does not match");
        this.code = 0x1770;
        this.name = "AssetOwnerMismatch";
        if (typeof Error.captureStackTrace === "function") Error.captureStackTrace(this, $795317f8cbeefa16$var$AssetOwnerMismatchError);
    }
}
module.exports.AssetOwnerMismatchError = $795317f8cbeefa16$var$AssetOwnerMismatchError;
$795317f8cbeefa16$var$createErrorFromCodeLookup.set(0x1770, ()=>new $795317f8cbeefa16$var$AssetOwnerMismatchError());
$795317f8cbeefa16$var$createErrorFromNameLookup.set("AssetOwnerMismatch", ()=>new $795317f8cbeefa16$var$AssetOwnerMismatchError());
class $795317f8cbeefa16$var$PublicKeyMismatchError extends Error {
    constructor(){
        super("PublicKeyMismatch");
        this.code = 0x1771;
        this.name = "PublicKeyMismatch";
        if (typeof Error.captureStackTrace === "function") Error.captureStackTrace(this, $795317f8cbeefa16$var$PublicKeyMismatchError);
    }
}
module.exports.PublicKeyMismatchError = $795317f8cbeefa16$var$PublicKeyMismatchError;
$795317f8cbeefa16$var$createErrorFromCodeLookup.set(0x1771, ()=>new $795317f8cbeefa16$var$PublicKeyMismatchError());
$795317f8cbeefa16$var$createErrorFromNameLookup.set("PublicKeyMismatch", ()=>new $795317f8cbeefa16$var$PublicKeyMismatchError());
class $795317f8cbeefa16$var$HashingMismatchError extends Error {
    constructor(){
        super("Hashing Mismatch Within Leaf Schema");
        this.code = 0x1772;
        this.name = "HashingMismatch";
        if (typeof Error.captureStackTrace === "function") Error.captureStackTrace(this, $795317f8cbeefa16$var$HashingMismatchError);
    }
}
module.exports.HashingMismatchError = $795317f8cbeefa16$var$HashingMismatchError;
$795317f8cbeefa16$var$createErrorFromCodeLookup.set(0x1772, ()=>new $795317f8cbeefa16$var$HashingMismatchError());
$795317f8cbeefa16$var$createErrorFromNameLookup.set("HashingMismatch", ()=>new $795317f8cbeefa16$var$HashingMismatchError());
class $795317f8cbeefa16$var$UnsupportedSchemaVersionError extends Error {
    constructor(){
        super("Unsupported Schema Version");
        this.code = 0x1773;
        this.name = "UnsupportedSchemaVersion";
        if (typeof Error.captureStackTrace === "function") Error.captureStackTrace(this, $795317f8cbeefa16$var$UnsupportedSchemaVersionError);
    }
}
module.exports.UnsupportedSchemaVersionError = $795317f8cbeefa16$var$UnsupportedSchemaVersionError;
$795317f8cbeefa16$var$createErrorFromCodeLookup.set(0x1773, ()=>new $795317f8cbeefa16$var$UnsupportedSchemaVersionError());
$795317f8cbeefa16$var$createErrorFromNameLookup.set("UnsupportedSchemaVersion", ()=>new $795317f8cbeefa16$var$UnsupportedSchemaVersionError());
class $795317f8cbeefa16$var$CreatorShareTotalMustBe100Error extends Error {
    constructor(){
        super("Creator shares must sum to 100");
        this.code = 0x1774;
        this.name = "CreatorShareTotalMustBe100";
        if (typeof Error.captureStackTrace === "function") Error.captureStackTrace(this, $795317f8cbeefa16$var$CreatorShareTotalMustBe100Error);
    }
}
module.exports.CreatorShareTotalMustBe100Error = $795317f8cbeefa16$var$CreatorShareTotalMustBe100Error;
$795317f8cbeefa16$var$createErrorFromCodeLookup.set(0x1774, ()=>new $795317f8cbeefa16$var$CreatorShareTotalMustBe100Error());
$795317f8cbeefa16$var$createErrorFromNameLookup.set("CreatorShareTotalMustBe100", ()=>new $795317f8cbeefa16$var$CreatorShareTotalMustBe100Error());
class $795317f8cbeefa16$var$DuplicateCreatorAddressError extends Error {
    constructor(){
        super("No duplicate creator addresses in metadata");
        this.code = 0x1775;
        this.name = "DuplicateCreatorAddress";
        if (typeof Error.captureStackTrace === "function") Error.captureStackTrace(this, $795317f8cbeefa16$var$DuplicateCreatorAddressError);
    }
}
module.exports.DuplicateCreatorAddressError = $795317f8cbeefa16$var$DuplicateCreatorAddressError;
$795317f8cbeefa16$var$createErrorFromCodeLookup.set(0x1775, ()=>new $795317f8cbeefa16$var$DuplicateCreatorAddressError());
$795317f8cbeefa16$var$createErrorFromNameLookup.set("DuplicateCreatorAddress", ()=>new $795317f8cbeefa16$var$DuplicateCreatorAddressError());
class $795317f8cbeefa16$var$CreatorDidNotVerifyError extends Error {
    constructor(){
        super("Creator did not verify the metadata");
        this.code = 0x1776;
        this.name = "CreatorDidNotVerify";
        if (typeof Error.captureStackTrace === "function") Error.captureStackTrace(this, $795317f8cbeefa16$var$CreatorDidNotVerifyError);
    }
}
module.exports.CreatorDidNotVerifyError = $795317f8cbeefa16$var$CreatorDidNotVerifyError;
$795317f8cbeefa16$var$createErrorFromCodeLookup.set(0x1776, ()=>new $795317f8cbeefa16$var$CreatorDidNotVerifyError());
$795317f8cbeefa16$var$createErrorFromNameLookup.set("CreatorDidNotVerify", ()=>new $795317f8cbeefa16$var$CreatorDidNotVerifyError());
class $795317f8cbeefa16$var$CreatorNotFoundError extends Error {
    constructor(){
        super("Creator not found in creator Vec");
        this.code = 0x1777;
        this.name = "CreatorNotFound";
        if (typeof Error.captureStackTrace === "function") Error.captureStackTrace(this, $795317f8cbeefa16$var$CreatorNotFoundError);
    }
}
module.exports.CreatorNotFoundError = $795317f8cbeefa16$var$CreatorNotFoundError;
$795317f8cbeefa16$var$createErrorFromCodeLookup.set(0x1777, ()=>new $795317f8cbeefa16$var$CreatorNotFoundError());
$795317f8cbeefa16$var$createErrorFromNameLookup.set("CreatorNotFound", ()=>new $795317f8cbeefa16$var$CreatorNotFoundError());
class $795317f8cbeefa16$var$NoCreatorsPresentError extends Error {
    constructor(){
        super("No creators in creator Vec");
        this.code = 0x1778;
        this.name = "NoCreatorsPresent";
        if (typeof Error.captureStackTrace === "function") Error.captureStackTrace(this, $795317f8cbeefa16$var$NoCreatorsPresentError);
    }
}
module.exports.NoCreatorsPresentError = $795317f8cbeefa16$var$NoCreatorsPresentError;
$795317f8cbeefa16$var$createErrorFromCodeLookup.set(0x1778, ()=>new $795317f8cbeefa16$var$NoCreatorsPresentError());
$795317f8cbeefa16$var$createErrorFromNameLookup.set("NoCreatorsPresent", ()=>new $795317f8cbeefa16$var$NoCreatorsPresentError());
class $795317f8cbeefa16$var$CreatorHashMismatchError extends Error {
    constructor(){
        super("User-provided creator Vec must result in same user-provided creator hash");
        this.code = 0x1779;
        this.name = "CreatorHashMismatch";
        if (typeof Error.captureStackTrace === "function") Error.captureStackTrace(this, $795317f8cbeefa16$var$CreatorHashMismatchError);
    }
}
module.exports.CreatorHashMismatchError = $795317f8cbeefa16$var$CreatorHashMismatchError;
$795317f8cbeefa16$var$createErrorFromCodeLookup.set(0x1779, ()=>new $795317f8cbeefa16$var$CreatorHashMismatchError());
$795317f8cbeefa16$var$createErrorFromNameLookup.set("CreatorHashMismatch", ()=>new $795317f8cbeefa16$var$CreatorHashMismatchError());
class $795317f8cbeefa16$var$DataHashMismatchError extends Error {
    constructor(){
        super("User-provided metadata must result in same user-provided data hash");
        this.code = 0x177a;
        this.name = "DataHashMismatch";
        if (typeof Error.captureStackTrace === "function") Error.captureStackTrace(this, $795317f8cbeefa16$var$DataHashMismatchError);
    }
}
module.exports.DataHashMismatchError = $795317f8cbeefa16$var$DataHashMismatchError;
$795317f8cbeefa16$var$createErrorFromCodeLookup.set(0x177a, ()=>new $795317f8cbeefa16$var$DataHashMismatchError());
$795317f8cbeefa16$var$createErrorFromNameLookup.set("DataHashMismatch", ()=>new $795317f8cbeefa16$var$DataHashMismatchError());
class $795317f8cbeefa16$var$CreatorsTooLongError extends Error {
    constructor(){
        super("Creators list too long");
        this.code = 0x177b;
        this.name = "CreatorsTooLong";
        if (typeof Error.captureStackTrace === "function") Error.captureStackTrace(this, $795317f8cbeefa16$var$CreatorsTooLongError);
    }
}
module.exports.CreatorsTooLongError = $795317f8cbeefa16$var$CreatorsTooLongError;
$795317f8cbeefa16$var$createErrorFromCodeLookup.set(0x177b, ()=>new $795317f8cbeefa16$var$CreatorsTooLongError());
$795317f8cbeefa16$var$createErrorFromNameLookup.set("CreatorsTooLong", ()=>new $795317f8cbeefa16$var$CreatorsTooLongError());
class $795317f8cbeefa16$var$MetadataNameTooLongError extends Error {
    constructor(){
        super("Name in metadata is too long");
        this.code = 0x177c;
        this.name = "MetadataNameTooLong";
        if (typeof Error.captureStackTrace === "function") Error.captureStackTrace(this, $795317f8cbeefa16$var$MetadataNameTooLongError);
    }
}
module.exports.MetadataNameTooLongError = $795317f8cbeefa16$var$MetadataNameTooLongError;
$795317f8cbeefa16$var$createErrorFromCodeLookup.set(0x177c, ()=>new $795317f8cbeefa16$var$MetadataNameTooLongError());
$795317f8cbeefa16$var$createErrorFromNameLookup.set("MetadataNameTooLong", ()=>new $795317f8cbeefa16$var$MetadataNameTooLongError());
class $795317f8cbeefa16$var$MetadataSymbolTooLongError extends Error {
    constructor(){
        super("Symbol in metadata is too long");
        this.code = 0x177d;
        this.name = "MetadataSymbolTooLong";
        if (typeof Error.captureStackTrace === "function") Error.captureStackTrace(this, $795317f8cbeefa16$var$MetadataSymbolTooLongError);
    }
}
module.exports.MetadataSymbolTooLongError = $795317f8cbeefa16$var$MetadataSymbolTooLongError;
$795317f8cbeefa16$var$createErrorFromCodeLookup.set(0x177d, ()=>new $795317f8cbeefa16$var$MetadataSymbolTooLongError());
$795317f8cbeefa16$var$createErrorFromNameLookup.set("MetadataSymbolTooLong", ()=>new $795317f8cbeefa16$var$MetadataSymbolTooLongError());
class $795317f8cbeefa16$var$MetadataUriTooLongError extends Error {
    constructor(){
        super("Uri in metadata is too long");
        this.code = 0x177e;
        this.name = "MetadataUriTooLong";
        if (typeof Error.captureStackTrace === "function") Error.captureStackTrace(this, $795317f8cbeefa16$var$MetadataUriTooLongError);
    }
}
module.exports.MetadataUriTooLongError = $795317f8cbeefa16$var$MetadataUriTooLongError;
$795317f8cbeefa16$var$createErrorFromCodeLookup.set(0x177e, ()=>new $795317f8cbeefa16$var$MetadataUriTooLongError());
$795317f8cbeefa16$var$createErrorFromNameLookup.set("MetadataUriTooLong", ()=>new $795317f8cbeefa16$var$MetadataUriTooLongError());
class $795317f8cbeefa16$var$MetadataBasisPointsTooHighError extends Error {
    constructor(){
        super("Basis points in metadata cannot exceed 10000");
        this.code = 0x177f;
        this.name = "MetadataBasisPointsTooHigh";
        if (typeof Error.captureStackTrace === "function") Error.captureStackTrace(this, $795317f8cbeefa16$var$MetadataBasisPointsTooHighError);
    }
}
module.exports.MetadataBasisPointsTooHighError = $795317f8cbeefa16$var$MetadataBasisPointsTooHighError;
$795317f8cbeefa16$var$createErrorFromCodeLookup.set(0x177f, ()=>new $795317f8cbeefa16$var$MetadataBasisPointsTooHighError());
$795317f8cbeefa16$var$createErrorFromNameLookup.set("MetadataBasisPointsTooHigh", ()=>new $795317f8cbeefa16$var$MetadataBasisPointsTooHighError());
class $795317f8cbeefa16$var$TreeAuthorityIncorrectError extends Error {
    constructor(){
        super("Tree creator or tree delegate must sign.");
        this.code = 0x1780;
        this.name = "TreeAuthorityIncorrect";
        if (typeof Error.captureStackTrace === "function") Error.captureStackTrace(this, $795317f8cbeefa16$var$TreeAuthorityIncorrectError);
    }
}
module.exports.TreeAuthorityIncorrectError = $795317f8cbeefa16$var$TreeAuthorityIncorrectError;
$795317f8cbeefa16$var$createErrorFromCodeLookup.set(0x1780, ()=>new $795317f8cbeefa16$var$TreeAuthorityIncorrectError());
$795317f8cbeefa16$var$createErrorFromNameLookup.set("TreeAuthorityIncorrect", ()=>new $795317f8cbeefa16$var$TreeAuthorityIncorrectError());
class $795317f8cbeefa16$var$InsufficientMintCapacityError extends Error {
    constructor(){
        super("Not enough unapproved mints left");
        this.code = 0x1781;
        this.name = "InsufficientMintCapacity";
        if (typeof Error.captureStackTrace === "function") Error.captureStackTrace(this, $795317f8cbeefa16$var$InsufficientMintCapacityError);
    }
}
module.exports.InsufficientMintCapacityError = $795317f8cbeefa16$var$InsufficientMintCapacityError;
$795317f8cbeefa16$var$createErrorFromCodeLookup.set(0x1781, ()=>new $795317f8cbeefa16$var$InsufficientMintCapacityError());
$795317f8cbeefa16$var$createErrorFromNameLookup.set("InsufficientMintCapacity", ()=>new $795317f8cbeefa16$var$InsufficientMintCapacityError());
class $795317f8cbeefa16$var$NumericalOverflowErrorError extends Error {
    constructor(){
        super("NumericalOverflowError");
        this.code = 0x1782;
        this.name = "NumericalOverflowError";
        if (typeof Error.captureStackTrace === "function") Error.captureStackTrace(this, $795317f8cbeefa16$var$NumericalOverflowErrorError);
    }
}
module.exports.NumericalOverflowErrorError = $795317f8cbeefa16$var$NumericalOverflowErrorError;
$795317f8cbeefa16$var$createErrorFromCodeLookup.set(0x1782, ()=>new $795317f8cbeefa16$var$NumericalOverflowErrorError());
$795317f8cbeefa16$var$createErrorFromNameLookup.set("NumericalOverflowError", ()=>new $795317f8cbeefa16$var$NumericalOverflowErrorError());
class $795317f8cbeefa16$var$IncorrectOwnerError extends Error {
    constructor(){
        super("Incorrect account owner");
        this.code = 0x1783;
        this.name = "IncorrectOwner";
        if (typeof Error.captureStackTrace === "function") Error.captureStackTrace(this, $795317f8cbeefa16$var$IncorrectOwnerError);
    }
}
module.exports.IncorrectOwnerError = $795317f8cbeefa16$var$IncorrectOwnerError;
$795317f8cbeefa16$var$createErrorFromCodeLookup.set(0x1783, ()=>new $795317f8cbeefa16$var$IncorrectOwnerError());
$795317f8cbeefa16$var$createErrorFromNameLookup.set("IncorrectOwner", ()=>new $795317f8cbeefa16$var$IncorrectOwnerError());
class $795317f8cbeefa16$var$CollectionCannotBeVerifiedInThisInstructionError extends Error {
    constructor(){
        super("Cannot Verify Collection in this Instruction");
        this.code = 0x1784;
        this.name = "CollectionCannotBeVerifiedInThisInstruction";
        if (typeof Error.captureStackTrace === "function") Error.captureStackTrace(this, $795317f8cbeefa16$var$CollectionCannotBeVerifiedInThisInstructionError);
    }
}
module.exports.CollectionCannotBeVerifiedInThisInstructionError = $795317f8cbeefa16$var$CollectionCannotBeVerifiedInThisInstructionError;
$795317f8cbeefa16$var$createErrorFromCodeLookup.set(0x1784, ()=>new $795317f8cbeefa16$var$CollectionCannotBeVerifiedInThisInstructionError());
$795317f8cbeefa16$var$createErrorFromNameLookup.set("CollectionCannotBeVerifiedInThisInstruction", ()=>new $795317f8cbeefa16$var$CollectionCannotBeVerifiedInThisInstructionError());
class $795317f8cbeefa16$var$CollectionNotFoundError extends Error {
    constructor(){
        super("Collection Not Found on Metadata");
        this.code = 0x1785;
        this.name = "CollectionNotFound";
        if (typeof Error.captureStackTrace === "function") Error.captureStackTrace(this, $795317f8cbeefa16$var$CollectionNotFoundError);
    }
}
module.exports.CollectionNotFoundError = $795317f8cbeefa16$var$CollectionNotFoundError;
$795317f8cbeefa16$var$createErrorFromCodeLookup.set(0x1785, ()=>new $795317f8cbeefa16$var$CollectionNotFoundError());
$795317f8cbeefa16$var$createErrorFromNameLookup.set("CollectionNotFound", ()=>new $795317f8cbeefa16$var$CollectionNotFoundError());
class $795317f8cbeefa16$var$AlreadyVerifiedError extends Error {
    constructor(){
        super("Collection item is already verified.");
        this.code = 0x1786;
        this.name = "AlreadyVerified";
        if (typeof Error.captureStackTrace === "function") Error.captureStackTrace(this, $795317f8cbeefa16$var$AlreadyVerifiedError);
    }
}
module.exports.AlreadyVerifiedError = $795317f8cbeefa16$var$AlreadyVerifiedError;
$795317f8cbeefa16$var$createErrorFromCodeLookup.set(0x1786, ()=>new $795317f8cbeefa16$var$AlreadyVerifiedError());
$795317f8cbeefa16$var$createErrorFromNameLookup.set("AlreadyVerified", ()=>new $795317f8cbeefa16$var$AlreadyVerifiedError());
class $795317f8cbeefa16$var$AlreadyUnverifiedError extends Error {
    constructor(){
        super("Collection item is already unverified.");
        this.code = 0x1787;
        this.name = "AlreadyUnverified";
        if (typeof Error.captureStackTrace === "function") Error.captureStackTrace(this, $795317f8cbeefa16$var$AlreadyUnverifiedError);
    }
}
module.exports.AlreadyUnverifiedError = $795317f8cbeefa16$var$AlreadyUnverifiedError;
$795317f8cbeefa16$var$createErrorFromCodeLookup.set(0x1787, ()=>new $795317f8cbeefa16$var$AlreadyUnverifiedError());
$795317f8cbeefa16$var$createErrorFromNameLookup.set("AlreadyUnverified", ()=>new $795317f8cbeefa16$var$AlreadyUnverifiedError());
class $795317f8cbeefa16$var$UpdateAuthorityIncorrectError extends Error {
    constructor(){
        super("Incorrect leaf metadata update authority.");
        this.code = 0x1788;
        this.name = "UpdateAuthorityIncorrect";
        if (typeof Error.captureStackTrace === "function") Error.captureStackTrace(this, $795317f8cbeefa16$var$UpdateAuthorityIncorrectError);
    }
}
module.exports.UpdateAuthorityIncorrectError = $795317f8cbeefa16$var$UpdateAuthorityIncorrectError;
$795317f8cbeefa16$var$createErrorFromCodeLookup.set(0x1788, ()=>new $795317f8cbeefa16$var$UpdateAuthorityIncorrectError());
$795317f8cbeefa16$var$createErrorFromNameLookup.set("UpdateAuthorityIncorrect", ()=>new $795317f8cbeefa16$var$UpdateAuthorityIncorrectError());
class $795317f8cbeefa16$var$LeafAuthorityMustSignError extends Error {
    constructor(){
        super("This transaction must be signed by either the leaf owner or leaf delegate");
        this.code = 0x1789;
        this.name = "LeafAuthorityMustSign";
        if (typeof Error.captureStackTrace === "function") Error.captureStackTrace(this, $795317f8cbeefa16$var$LeafAuthorityMustSignError);
    }
}
module.exports.LeafAuthorityMustSignError = $795317f8cbeefa16$var$LeafAuthorityMustSignError;
$795317f8cbeefa16$var$createErrorFromCodeLookup.set(0x1789, ()=>new $795317f8cbeefa16$var$LeafAuthorityMustSignError());
$795317f8cbeefa16$var$createErrorFromNameLookup.set("LeafAuthorityMustSign", ()=>new $795317f8cbeefa16$var$LeafAuthorityMustSignError());
class $795317f8cbeefa16$var$CollectionMustBeSizedError extends Error {
    constructor(){
        super("Collection Not Compatable with Compression, Must be Sized");
        this.code = 0x178a;
        this.name = "CollectionMustBeSized";
        if (typeof Error.captureStackTrace === "function") Error.captureStackTrace(this, $795317f8cbeefa16$var$CollectionMustBeSizedError);
    }
}
module.exports.CollectionMustBeSizedError = $795317f8cbeefa16$var$CollectionMustBeSizedError;
$795317f8cbeefa16$var$createErrorFromCodeLookup.set(0x178a, ()=>new $795317f8cbeefa16$var$CollectionMustBeSizedError());
$795317f8cbeefa16$var$createErrorFromNameLookup.set("CollectionMustBeSized", ()=>new $795317f8cbeefa16$var$CollectionMustBeSizedError());
function $795317f8cbeefa16$var$errorFromCode(code) {
    const createError = $795317f8cbeefa16$var$createErrorFromCodeLookup.get(code);
    return createError != null ? createError() : null;
}
module.exports.errorFromCode = $795317f8cbeefa16$var$errorFromCode;
function $795317f8cbeefa16$var$errorFromName(name) {
    const createError = $795317f8cbeefa16$var$createErrorFromNameLookup.get(name);
    return createError != null ? createError() : null;
}
module.exports.errorFromName = $795317f8cbeefa16$var$errorFromName;

});

parcelRegister("46mYT", function(module, exports) {
"use strict";
var $2fc98c85ab1df4b5$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $2fc98c85ab1df4b5$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $2fc98c85ab1df4b5$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

$2fc98c85ab1df4b5$var$__exportStar((parcelRequire("7GgjK")), module.exports);

$2fc98c85ab1df4b5$var$__exportStar((parcelRequire("wmAso")), module.exports);

$2fc98c85ab1df4b5$var$__exportStar((parcelRequire("bbF90")), module.exports);

$2fc98c85ab1df4b5$var$__exportStar((parcelRequire("44mK7")), module.exports);

$2fc98c85ab1df4b5$var$__exportStar((parcelRequire("99h0T")), module.exports);

$2fc98c85ab1df4b5$var$__exportStar((parcelRequire("gHOAl")), module.exports);

$2fc98c85ab1df4b5$var$__exportStar((parcelRequire("1TGNa")), module.exports);

$2fc98c85ab1df4b5$var$__exportStar((parcelRequire("S6Egr")), module.exports);

$2fc98c85ab1df4b5$var$__exportStar((parcelRequire("8PAJ0")), module.exports);

$2fc98c85ab1df4b5$var$__exportStar((parcelRequire("3A2AA")), module.exports);

$2fc98c85ab1df4b5$var$__exportStar((parcelRequire("d8YsU")), module.exports);

$2fc98c85ab1df4b5$var$__exportStar((parcelRequire("dtfyi")), module.exports);

$2fc98c85ab1df4b5$var$__exportStar((parcelRequire("7XMRi")), module.exports);

$2fc98c85ab1df4b5$var$__exportStar((parcelRequire("epq2U")), module.exports);

$2fc98c85ab1df4b5$var$__exportStar((parcelRequire("1X08Y")), module.exports);

$2fc98c85ab1df4b5$var$__exportStar((parcelRequire("bMpY1")), module.exports);

});
parcelRegister("7GgjK", function(module, exports) {
"use strict";
var $59791cfda864d09d$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $59791cfda864d09d$var$__setModuleDefault = module.exports && module.exports.__setModuleDefault || (Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
});
var $59791cfda864d09d$var$__importStar = module.exports && module.exports.__importStar || function(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) $59791cfda864d09d$var$__createBinding(result, mod, k);
    }
    $59791cfda864d09d$var$__setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.createBurnInstruction = module.exports.burnInstructionDiscriminator = module.exports.burnStruct = void 0;

const $59791cfda864d09d$var$beet = $59791cfda864d09d$var$__importStar((parcelRequire("1DULh")));

const $59791cfda864d09d$var$web3 = $59791cfda864d09d$var$__importStar((parcelRequire("gNDby")));
module.exports.burnStruct = new $59791cfda864d09d$var$beet.BeetArgsStruct([
    [
        "instructionDiscriminator",
        $59791cfda864d09d$var$beet.uniformFixedSizeArray($59791cfda864d09d$var$beet.u8, 8)
    ],
    [
        "root",
        $59791cfda864d09d$var$beet.uniformFixedSizeArray($59791cfda864d09d$var$beet.u8, 32)
    ],
    [
        "dataHash",
        $59791cfda864d09d$var$beet.uniformFixedSizeArray($59791cfda864d09d$var$beet.u8, 32)
    ],
    [
        "creatorHash",
        $59791cfda864d09d$var$beet.uniformFixedSizeArray($59791cfda864d09d$var$beet.u8, 32)
    ],
    [
        "nonce",
        $59791cfda864d09d$var$beet.u64
    ],
    [
        "index",
        $59791cfda864d09d$var$beet.u32
    ]
], "BurnInstructionArgs");
module.exports.burnInstructionDiscriminator = [
    116,
    110,
    29,
    56,
    107,
    219,
    42,
    93
];
function $59791cfda864d09d$var$createBurnInstruction(accounts, args, programId = new $59791cfda864d09d$var$web3.PublicKey("BGUMAp9Gq7iTEuizy4pqaxsTyUCBK68MDfK752saRPUY")) {
    var _a;
    const [data] = module.exports.burnStruct.serialize({
        instructionDiscriminator: module.exports.burnInstructionDiscriminator,
        ...args
    });
    const keys = [
        {
            pubkey: accounts.treeAuthority,
            isWritable: false,
            isSigner: false
        },
        {
            pubkey: accounts.leafOwner,
            isWritable: false,
            isSigner: false
        },
        {
            pubkey: accounts.leafDelegate,
            isWritable: false,
            isSigner: false
        },
        {
            pubkey: accounts.merkleTree,
            isWritable: true,
            isSigner: false
        },
        {
            pubkey: accounts.logWrapper,
            isWritable: false,
            isSigner: false
        },
        {
            pubkey: accounts.compressionProgram,
            isWritable: false,
            isSigner: false
        },
        {
            pubkey: (_a = accounts.systemProgram) !== null && _a !== void 0 ? _a : $59791cfda864d09d$var$web3.SystemProgram.programId,
            isWritable: false,
            isSigner: false
        }
    ];
    if (accounts.anchorRemainingAccounts != null) for (const acc of accounts.anchorRemainingAccounts)keys.push(acc);
    const ix = new $59791cfda864d09d$var$web3.TransactionInstruction({
        programId: programId,
        keys: keys,
        data: data
    });
    return ix;
}
module.exports.createBurnInstruction = $59791cfda864d09d$var$createBurnInstruction;

});

parcelRegister("wmAso", function(module, exports) {
"use strict";
var $061482959cb7774e$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $061482959cb7774e$var$__setModuleDefault = module.exports && module.exports.__setModuleDefault || (Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
});
var $061482959cb7774e$var$__importStar = module.exports && module.exports.__importStar || function(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) $061482959cb7774e$var$__createBinding(result, mod, k);
    }
    $061482959cb7774e$var$__setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.createCancelRedeemInstruction = module.exports.cancelRedeemInstructionDiscriminator = module.exports.cancelRedeemStruct = void 0;

const $061482959cb7774e$var$beet = $061482959cb7774e$var$__importStar((parcelRequire("1DULh")));

const $061482959cb7774e$var$web3 = $061482959cb7774e$var$__importStar((parcelRequire("gNDby")));
module.exports.cancelRedeemStruct = new $061482959cb7774e$var$beet.BeetArgsStruct([
    [
        "instructionDiscriminator",
        $061482959cb7774e$var$beet.uniformFixedSizeArray($061482959cb7774e$var$beet.u8, 8)
    ],
    [
        "root",
        $061482959cb7774e$var$beet.uniformFixedSizeArray($061482959cb7774e$var$beet.u8, 32)
    ]
], "CancelRedeemInstructionArgs");
module.exports.cancelRedeemInstructionDiscriminator = [
    111,
    76,
    232,
    50,
    39,
    175,
    48,
    242
];
function $061482959cb7774e$var$createCancelRedeemInstruction(accounts, args, programId = new $061482959cb7774e$var$web3.PublicKey("BGUMAp9Gq7iTEuizy4pqaxsTyUCBK68MDfK752saRPUY")) {
    var _a;
    const [data] = module.exports.cancelRedeemStruct.serialize({
        instructionDiscriminator: module.exports.cancelRedeemInstructionDiscriminator,
        ...args
    });
    const keys = [
        {
            pubkey: accounts.treeAuthority,
            isWritable: false,
            isSigner: false
        },
        {
            pubkey: accounts.leafOwner,
            isWritable: true,
            isSigner: true
        },
        {
            pubkey: accounts.merkleTree,
            isWritable: true,
            isSigner: false
        },
        {
            pubkey: accounts.voucher,
            isWritable: true,
            isSigner: false
        },
        {
            pubkey: accounts.logWrapper,
            isWritable: false,
            isSigner: false
        },
        {
            pubkey: accounts.compressionProgram,
            isWritable: false,
            isSigner: false
        },
        {
            pubkey: (_a = accounts.systemProgram) !== null && _a !== void 0 ? _a : $061482959cb7774e$var$web3.SystemProgram.programId,
            isWritable: false,
            isSigner: false
        }
    ];
    if (accounts.anchorRemainingAccounts != null) for (const acc of accounts.anchorRemainingAccounts)keys.push(acc);
    const ix = new $061482959cb7774e$var$web3.TransactionInstruction({
        programId: programId,
        keys: keys,
        data: data
    });
    return ix;
}
module.exports.createCancelRedeemInstruction = $061482959cb7774e$var$createCancelRedeemInstruction;

});

parcelRegister("bbF90", function(module, exports) {
"use strict";
var $8250a32eb418b32c$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $8250a32eb418b32c$var$__setModuleDefault = module.exports && module.exports.__setModuleDefault || (Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
});
var $8250a32eb418b32c$var$__importStar = module.exports && module.exports.__importStar || function(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) $8250a32eb418b32c$var$__createBinding(result, mod, k);
    }
    $8250a32eb418b32c$var$__setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.createCompressInstruction = module.exports.compressInstructionDiscriminator = module.exports.compressStruct = void 0;

const $8250a32eb418b32c$var$splToken = $8250a32eb418b32c$var$__importStar((parcelRequire("dmNue")));

const $8250a32eb418b32c$var$beet = $8250a32eb418b32c$var$__importStar((parcelRequire("1DULh")));

const $8250a32eb418b32c$var$web3 = $8250a32eb418b32c$var$__importStar((parcelRequire("gNDby")));
module.exports.compressStruct = new $8250a32eb418b32c$var$beet.BeetArgsStruct([
    [
        "instructionDiscriminator",
        $8250a32eb418b32c$var$beet.uniformFixedSizeArray($8250a32eb418b32c$var$beet.u8, 8)
    ]
], "CompressInstructionArgs");
module.exports.compressInstructionDiscriminator = [
    82,
    193,
    176,
    117,
    176,
    21,
    115,
    253
];
function $8250a32eb418b32c$var$createCompressInstruction(accounts, programId = new $8250a32eb418b32c$var$web3.PublicKey("BGUMAp9Gq7iTEuizy4pqaxsTyUCBK68MDfK752saRPUY")) {
    var _a, _b;
    const [data] = module.exports.compressStruct.serialize({
        instructionDiscriminator: module.exports.compressInstructionDiscriminator
    });
    const keys = [
        {
            pubkey: accounts.treeAuthority,
            isWritable: false,
            isSigner: false
        },
        {
            pubkey: accounts.leafOwner,
            isWritable: false,
            isSigner: true
        },
        {
            pubkey: accounts.leafDelegate,
            isWritable: false,
            isSigner: false
        },
        {
            pubkey: accounts.merkleTree,
            isWritable: false,
            isSigner: false
        },
        {
            pubkey: accounts.tokenAccount,
            isWritable: true,
            isSigner: false
        },
        {
            pubkey: accounts.mint,
            isWritable: true,
            isSigner: false
        },
        {
            pubkey: accounts.metadata,
            isWritable: true,
            isSigner: false
        },
        {
            pubkey: accounts.masterEdition,
            isWritable: true,
            isSigner: false
        },
        {
            pubkey: accounts.payer,
            isWritable: true,
            isSigner: true
        },
        {
            pubkey: accounts.logWrapper,
            isWritable: false,
            isSigner: false
        },
        {
            pubkey: accounts.compressionProgram,
            isWritable: false,
            isSigner: false
        },
        {
            pubkey: (_a = accounts.tokenProgram) !== null && _a !== void 0 ? _a : $8250a32eb418b32c$var$splToken.TOKEN_PROGRAM_ID,
            isWritable: false,
            isSigner: false
        },
        {
            pubkey: accounts.tokenMetadataProgram,
            isWritable: false,
            isSigner: false
        },
        {
            pubkey: (_b = accounts.systemProgram) !== null && _b !== void 0 ? _b : $8250a32eb418b32c$var$web3.SystemProgram.programId,
            isWritable: false,
            isSigner: false
        }
    ];
    if (accounts.anchorRemainingAccounts != null) for (const acc of accounts.anchorRemainingAccounts)keys.push(acc);
    const ix = new $8250a32eb418b32c$var$web3.TransactionInstruction({
        programId: programId,
        keys: keys,
        data: data
    });
    return ix;
}
module.exports.createCompressInstruction = $8250a32eb418b32c$var$createCompressInstruction;

});
parcelRegister("dmNue", function(module, exports) {

$parcel$export(module.exports, "TOKEN_PROGRAM_ID", () => $9bb3b775df4f8b9f$export$79de3e3c2b1ca801);
$parcel$export(module.exports, "ASSOCIATED_TOKEN_PROGRAM_ID", () => $9bb3b775df4f8b9f$export$57a4f33bcc1767fa);
$parcel$export(module.exports, "u64", () => $9bb3b775df4f8b9f$export$cd1442401e54cffa);
$parcel$export(module.exports, "NATIVE_MINT", () => $9bb3b775df4f8b9f$export$71f490c6a4aef7af);
$parcel$export(module.exports, "MintLayout", () => $9bb3b775df4f8b9f$export$1374e91decd2fbe5);
$parcel$export(module.exports, "AccountLayout", () => $9bb3b775df4f8b9f$export$cab31ec27f6c5fa);
$parcel$export(module.exports, "Token", () => $9bb3b775df4f8b9f$export$50792b0e93539fde);

var $g5Zhu = parcelRequire("g5Zhu");

var $dEXSZ = parcelRequire("dEXSZ");

var $gNDby = parcelRequire("gNDby");
var $9bb3b775df4f8b9f$var$buffer = {};
var $9bb3b775df4f8b9f$var$base64Js = {};
$9bb3b775df4f8b9f$var$base64Js.byteLength = $9bb3b775df4f8b9f$var$byteLength;
$9bb3b775df4f8b9f$var$base64Js.toByteArray = $9bb3b775df4f8b9f$var$toByteArray;
$9bb3b775df4f8b9f$var$base64Js.fromByteArray = $9bb3b775df4f8b9f$var$fromByteArray;
var $9bb3b775df4f8b9f$var$lookup = [];
var $9bb3b775df4f8b9f$var$revLookup = [];
var $9bb3b775df4f8b9f$var$Arr = typeof Uint8Array !== "undefined" ? Uint8Array : Array;
var $9bb3b775df4f8b9f$var$code = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/";
for(var $9bb3b775df4f8b9f$var$i = 0, $9bb3b775df4f8b9f$var$len = $9bb3b775df4f8b9f$var$code.length; $9bb3b775df4f8b9f$var$i < $9bb3b775df4f8b9f$var$len; ++$9bb3b775df4f8b9f$var$i){
    $9bb3b775df4f8b9f$var$lookup[$9bb3b775df4f8b9f$var$i] = $9bb3b775df4f8b9f$var$code[$9bb3b775df4f8b9f$var$i];
    $9bb3b775df4f8b9f$var$revLookup[$9bb3b775df4f8b9f$var$code.charCodeAt($9bb3b775df4f8b9f$var$i)] = $9bb3b775df4f8b9f$var$i;
}
// Support decoding URL-safe base64 strings, as Node.js does.
// See: https://en.wikipedia.org/wiki/Base64#URL_applications
$9bb3b775df4f8b9f$var$revLookup["-".charCodeAt(0)] = 62;
$9bb3b775df4f8b9f$var$revLookup["_".charCodeAt(0)] = 63;
function $9bb3b775df4f8b9f$var$getLens(b64) {
    var len = b64.length;
    if (len % 4 > 0) throw new Error("Invalid string. Length must be a multiple of 4");
    // Trim off extra bytes after placeholder bytes are found
    // See: https://github.com/beatgammit/base64-js/issues/42
    var validLen = b64.indexOf("=");
    if (validLen === -1) validLen = len;
    var placeHoldersLen = validLen === len ? 0 : 4 - validLen % 4;
    return [
        validLen,
        placeHoldersLen
    ];
}
// base64 is 4/3 + up to two characters of the original data
function $9bb3b775df4f8b9f$var$byteLength(b64) {
    var lens = $9bb3b775df4f8b9f$var$getLens(b64);
    var validLen = lens[0];
    var placeHoldersLen = lens[1];
    return (validLen + placeHoldersLen) * 3 / 4 - placeHoldersLen;
}
function $9bb3b775df4f8b9f$var$_byteLength(b64, validLen, placeHoldersLen) {
    return (validLen + placeHoldersLen) * 3 / 4 - placeHoldersLen;
}
function $9bb3b775df4f8b9f$var$toByteArray(b64) {
    var tmp;
    var lens = $9bb3b775df4f8b9f$var$getLens(b64);
    var validLen = lens[0];
    var placeHoldersLen = lens[1];
    var arr = new $9bb3b775df4f8b9f$var$Arr($9bb3b775df4f8b9f$var$_byteLength(b64, validLen, placeHoldersLen));
    var curByte = 0;
    // if there are placeholders, only get up to the last complete 4 chars
    var len = placeHoldersLen > 0 ? validLen - 4 : validLen;
    var i;
    for(i = 0; i < len; i += 4){
        tmp = $9bb3b775df4f8b9f$var$revLookup[b64.charCodeAt(i)] << 18 | $9bb3b775df4f8b9f$var$revLookup[b64.charCodeAt(i + 1)] << 12 | $9bb3b775df4f8b9f$var$revLookup[b64.charCodeAt(i + 2)] << 6 | $9bb3b775df4f8b9f$var$revLookup[b64.charCodeAt(i + 3)];
        arr[curByte++] = tmp >> 16 & 0xFF;
        arr[curByte++] = tmp >> 8 & 0xFF;
        arr[curByte++] = tmp & 0xFF;
    }
    if (placeHoldersLen === 2) {
        tmp = $9bb3b775df4f8b9f$var$revLookup[b64.charCodeAt(i)] << 2 | $9bb3b775df4f8b9f$var$revLookup[b64.charCodeAt(i + 1)] >> 4;
        arr[curByte++] = tmp & 0xFF;
    }
    if (placeHoldersLen === 1) {
        tmp = $9bb3b775df4f8b9f$var$revLookup[b64.charCodeAt(i)] << 10 | $9bb3b775df4f8b9f$var$revLookup[b64.charCodeAt(i + 1)] << 4 | $9bb3b775df4f8b9f$var$revLookup[b64.charCodeAt(i + 2)] >> 2;
        arr[curByte++] = tmp >> 8 & 0xFF;
        arr[curByte++] = tmp & 0xFF;
    }
    return arr;
}
function $9bb3b775df4f8b9f$var$tripletToBase64(num) {
    return $9bb3b775df4f8b9f$var$lookup[num >> 18 & 0x3F] + $9bb3b775df4f8b9f$var$lookup[num >> 12 & 0x3F] + $9bb3b775df4f8b9f$var$lookup[num >> 6 & 0x3F] + $9bb3b775df4f8b9f$var$lookup[num & 0x3F];
}
function $9bb3b775df4f8b9f$var$encodeChunk(uint8, start, end) {
    var tmp;
    var output = [];
    for(var i = start; i < end; i += 3){
        tmp = (uint8[i] << 16 & 0xFF0000) + (uint8[i + 1] << 8 & 0xFF00) + (uint8[i + 2] & 0xFF);
        output.push($9bb3b775df4f8b9f$var$tripletToBase64(tmp));
    }
    return output.join("");
}
function $9bb3b775df4f8b9f$var$fromByteArray(uint8) {
    var tmp;
    var len = uint8.length;
    var extraBytes = len % 3; // if we have 1 byte left, pad 2 bytes
    var parts = [];
    var maxChunkLength = 16383; // must be multiple of 3
    // go through the array every three bytes, we'll deal with trailing stuff later
    for(var i = 0, len2 = len - extraBytes; i < len2; i += maxChunkLength)parts.push($9bb3b775df4f8b9f$var$encodeChunk(uint8, i, i + maxChunkLength > len2 ? len2 : i + maxChunkLength));
    // pad the end with zeros, but make sure to not forget the extra bytes
    if (extraBytes === 1) {
        tmp = uint8[len - 1];
        parts.push($9bb3b775df4f8b9f$var$lookup[tmp >> 2] + $9bb3b775df4f8b9f$var$lookup[tmp << 4 & 0x3F] + "==");
    } else if (extraBytes === 2) {
        tmp = (uint8[len - 2] << 8) + uint8[len - 1];
        parts.push($9bb3b775df4f8b9f$var$lookup[tmp >> 10] + $9bb3b775df4f8b9f$var$lookup[tmp >> 4 & 0x3F] + $9bb3b775df4f8b9f$var$lookup[tmp << 2 & 0x3F] + "=");
    }
    return parts.join("");
}
var $9bb3b775df4f8b9f$var$ieee754 = {};
/*! ieee754. BSD-3-Clause License. Feross Aboukhadijeh <https://feross.org/opensource> */ $9bb3b775df4f8b9f$var$ieee754.read = function(buffer, offset, isLE, mLen, nBytes) {
    var e, m;
    var eLen = nBytes * 8 - mLen - 1;
    var eMax = (1 << eLen) - 1;
    var eBias = eMax >> 1;
    var nBits = -7;
    var i = isLE ? nBytes - 1 : 0;
    var d = isLE ? -1 : 1;
    var s = buffer[offset + i];
    i += d;
    e = s & (1 << -nBits) - 1;
    s >>= -nBits;
    nBits += eLen;
    for(; nBits > 0; e = e * 256 + buffer[offset + i], i += d, nBits -= 8);
    m = e & (1 << -nBits) - 1;
    e >>= -nBits;
    nBits += mLen;
    for(; nBits > 0; m = m * 256 + buffer[offset + i], i += d, nBits -= 8);
    if (e === 0) e = 1 - eBias;
    else if (e === eMax) return m ? NaN : (s ? -1 : 1) * Infinity;
    else {
        m = m + Math.pow(2, mLen);
        e = e - eBias;
    }
    return (s ? -1 : 1) * m * Math.pow(2, e - mLen);
};
$9bb3b775df4f8b9f$var$ieee754.write = function(buffer, value, offset, isLE, mLen, nBytes) {
    var e, m, c;
    var eLen = nBytes * 8 - mLen - 1;
    var eMax = (1 << eLen) - 1;
    var eBias = eMax >> 1;
    var rt = mLen === 23 ? Math.pow(2, -24) - Math.pow(2, -77) : 0;
    var i = isLE ? 0 : nBytes - 1;
    var d = isLE ? 1 : -1;
    var s = value < 0 || value === 0 && 1 / value < 0 ? 1 : 0;
    value = Math.abs(value);
    if (isNaN(value) || value === Infinity) {
        m = isNaN(value) ? 1 : 0;
        e = eMax;
    } else {
        e = Math.floor(Math.log(value) / Math.LN2);
        if (value * (c = Math.pow(2, -e)) < 1) {
            e--;
            c *= 2;
        }
        if (e + eBias >= 1) value += rt / c;
        else value += rt * Math.pow(2, 1 - eBias);
        if (value * c >= 2) {
            e++;
            c /= 2;
        }
        if (e + eBias >= eMax) {
            m = 0;
            e = eMax;
        } else if (e + eBias >= 1) {
            m = (value * c - 1) * Math.pow(2, mLen);
            e = e + eBias;
        } else {
            m = value * Math.pow(2, eBias - 1) * Math.pow(2, mLen);
            e = 0;
        }
    }
    for(; mLen >= 8; buffer[offset + i] = m & 0xff, i += d, m /= 256, mLen -= 8);
    e = e << mLen | m;
    eLen += mLen;
    for(; eLen > 0; buffer[offset + i] = e & 0xff, i += d, e /= 256, eLen -= 8);
    buffer[offset + i - d] |= s * 128;
};
/*!
 * The buffer module from node.js, for the browser.
 *
 * @author   Feross Aboukhadijeh <https://feross.org>
 * @license  MIT
 */ (function(exports) {
    const base64 = $9bb3b775df4f8b9f$var$base64Js;
    const ieee754$1 = $9bb3b775df4f8b9f$var$ieee754;
    const customInspectSymbol = typeof Symbol === "function" && typeof Symbol["for"] === "function" // eslint-disable-line dot-notation
     ? Symbol["for"]("nodejs.util.inspect.custom") // eslint-disable-line dot-notation
     : null;
    exports.Buffer = Buffer;
    exports.SlowBuffer = SlowBuffer;
    exports.INSPECT_MAX_BYTES = 50;
    const K_MAX_LENGTH = 0x7fffffff;
    exports.kMaxLength = K_MAX_LENGTH;
    /**
 * If `Buffer.TYPED_ARRAY_SUPPORT`:
 *   === true    Use Uint8Array implementation (fastest)
 *   === false   Print warning and recommend using `buffer` v4.x which has an Object
 *               implementation (most compatible, even IE6)
 *
 * Browsers that support typed arrays are IE 10+, Firefox 4+, Chrome 7+, Safari 5.1+,
 * Opera 11.6+, iOS 4.2+.
 *
 * We report that the browser does not support typed arrays if the are not subclassable
 * using __proto__. Firefox 4-29 lacks support for adding new properties to `Uint8Array`
 * (See: https://bugzilla.mozilla.org/show_bug.cgi?id=695438). IE 10 lacks support
 * for __proto__ and has a buggy typed array implementation.
 */ Buffer.TYPED_ARRAY_SUPPORT = typedArraySupport();
    if (!Buffer.TYPED_ARRAY_SUPPORT && typeof console !== "undefined" && typeof console.error === "function") console.error("This browser lacks typed array (Uint8Array) support which is required by `buffer` v5.x. Use `buffer` v4.x if you require old browser support.");
    function typedArraySupport() {
        // Can typed array instances can be augmented?
        try {
            const arr = new Uint8Array(1);
            const proto = {
                foo: function() {
                    return 42;
                }
            };
            Object.setPrototypeOf(proto, Uint8Array.prototype);
            Object.setPrototypeOf(arr, proto);
            return arr.foo() === 42;
        } catch (e) {
            return false;
        }
    }
    Object.defineProperty(Buffer.prototype, "parent", {
        enumerable: true,
        get: function() {
            if (!Buffer.isBuffer(this)) return undefined;
            return this.buffer;
        }
    });
    Object.defineProperty(Buffer.prototype, "offset", {
        enumerable: true,
        get: function() {
            if (!Buffer.isBuffer(this)) return undefined;
            return this.byteOffset;
        }
    });
    function createBuffer(length) {
        if (length > K_MAX_LENGTH) throw new RangeError('The value "' + length + '" is invalid for option "size"');
        // Return an augmented `Uint8Array` instance
        const buf = new Uint8Array(length);
        Object.setPrototypeOf(buf, Buffer.prototype);
        return buf;
    }
    /**
 * The Buffer constructor returns instances of `Uint8Array` that have their
 * prototype changed to `Buffer.prototype`. Furthermore, `Buffer` is a subclass of
 * `Uint8Array`, so the returned instances will have all the node `Buffer` methods
 * and the `Uint8Array` methods. Square bracket notation works as expected -- it
 * returns a single octet.
 *
 * The `Uint8Array` prototype remains unmodified.
 */ function Buffer(arg, encodingOrOffset, length) {
        // Common case.
        if (typeof arg === "number") {
            if (typeof encodingOrOffset === "string") throw new TypeError('The "string" argument must be of type string. Received type number');
            return allocUnsafe(arg);
        }
        return from(arg, encodingOrOffset, length);
    }
    Buffer.poolSize = 8192; // not used by this implementation
    function from(value, encodingOrOffset, length) {
        if (typeof value === "string") return fromString(value, encodingOrOffset);
        if (ArrayBuffer.isView(value)) return fromArrayView(value);
        if (value == null) throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof value);
        if (isInstance(value, ArrayBuffer) || value && isInstance(value.buffer, ArrayBuffer)) return fromArrayBuffer(value, encodingOrOffset, length);
        if (typeof SharedArrayBuffer !== "undefined" && (isInstance(value, SharedArrayBuffer) || value && isInstance(value.buffer, SharedArrayBuffer))) return fromArrayBuffer(value, encodingOrOffset, length);
        if (typeof value === "number") throw new TypeError('The "value" argument must not be of type number. Received type number');
        const valueOf = value.valueOf && value.valueOf();
        if (valueOf != null && valueOf !== value) return Buffer.from(valueOf, encodingOrOffset, length);
        const b = fromObject(value);
        if (b) return b;
        if (typeof Symbol !== "undefined" && Symbol.toPrimitive != null && typeof value[Symbol.toPrimitive] === "function") return Buffer.from(value[Symbol.toPrimitive]("string"), encodingOrOffset, length);
        throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof value);
    }
    /**
 * Functionally equivalent to Buffer(arg, encoding) but throws a TypeError
 * if value is a number.
 * Buffer.from(str[, encoding])
 * Buffer.from(array)
 * Buffer.from(buffer)
 * Buffer.from(arrayBuffer[, byteOffset[, length]])
 **/ Buffer.from = function(value, encodingOrOffset, length) {
        return from(value, encodingOrOffset, length);
    };
    // Note: Change prototype *after* Buffer.from is defined to workaround Chrome bug:
    // https://github.com/feross/buffer/pull/148
    Object.setPrototypeOf(Buffer.prototype, Uint8Array.prototype);
    Object.setPrototypeOf(Buffer, Uint8Array);
    function assertSize(size) {
        if (typeof size !== "number") throw new TypeError('"size" argument must be of type number');
        else if (size < 0) throw new RangeError('The value "' + size + '" is invalid for option "size"');
    }
    function alloc(size, fill, encoding) {
        assertSize(size);
        if (size <= 0) return createBuffer(size);
        if (fill !== undefined) // Only pay attention to encoding if it's a string. This
        // prevents accidentally sending in a number that would
        // be interpreted as a start offset.
        return typeof encoding === "string" ? createBuffer(size).fill(fill, encoding) : createBuffer(size).fill(fill);
        return createBuffer(size);
    }
    /**
 * Creates a new filled Buffer instance.
 * alloc(size[, fill[, encoding]])
 **/ Buffer.alloc = function(size, fill, encoding) {
        return alloc(size, fill, encoding);
    };
    function allocUnsafe(size) {
        assertSize(size);
        return createBuffer(size < 0 ? 0 : checked(size) | 0);
    }
    /**
 * Equivalent to Buffer(num), by default creates a non-zero-filled Buffer instance.
 * */ Buffer.allocUnsafe = function(size) {
        return allocUnsafe(size);
    };
    /**
 * Equivalent to SlowBuffer(num), by default creates a non-zero-filled Buffer instance.
 */ Buffer.allocUnsafeSlow = function(size) {
        return allocUnsafe(size);
    };
    function fromString(string, encoding) {
        if (typeof encoding !== "string" || encoding === "") encoding = "utf8";
        if (!Buffer.isEncoding(encoding)) throw new TypeError("Unknown encoding: " + encoding);
        const length = byteLength(string, encoding) | 0;
        let buf = createBuffer(length);
        const actual = buf.write(string, encoding);
        if (actual !== length) // Writing a hex string, for example, that contains invalid characters will
        // cause everything after the first invalid character to be ignored. (e.g.
        // 'abxxcd' will be treated as 'ab')
        buf = buf.slice(0, actual);
        return buf;
    }
    function fromArrayLike(array) {
        const length = array.length < 0 ? 0 : checked(array.length) | 0;
        const buf = createBuffer(length);
        for(let i = 0; i < length; i += 1)buf[i] = array[i] & 255;
        return buf;
    }
    function fromArrayView(arrayView) {
        if (isInstance(arrayView, Uint8Array)) {
            const copy = new Uint8Array(arrayView);
            return fromArrayBuffer(copy.buffer, copy.byteOffset, copy.byteLength);
        }
        return fromArrayLike(arrayView);
    }
    function fromArrayBuffer(array, byteOffset, length) {
        if (byteOffset < 0 || array.byteLength < byteOffset) throw new RangeError('"offset" is outside of buffer bounds');
        if (array.byteLength < byteOffset + (length || 0)) throw new RangeError('"length" is outside of buffer bounds');
        let buf;
        if (byteOffset === undefined && length === undefined) buf = new Uint8Array(array);
        else if (length === undefined) buf = new Uint8Array(array, byteOffset);
        else buf = new Uint8Array(array, byteOffset, length);
        // Return an augmented `Uint8Array` instance
        Object.setPrototypeOf(buf, Buffer.prototype);
        return buf;
    }
    function fromObject(obj) {
        if (Buffer.isBuffer(obj)) {
            const len = checked(obj.length) | 0;
            const buf = createBuffer(len);
            if (buf.length === 0) return buf;
            obj.copy(buf, 0, 0, len);
            return buf;
        }
        if (obj.length !== undefined) {
            if (typeof obj.length !== "number" || numberIsNaN(obj.length)) return createBuffer(0);
            return fromArrayLike(obj);
        }
        if (obj.type === "Buffer" && Array.isArray(obj.data)) return fromArrayLike(obj.data);
    }
    function checked(length) {
        // Note: cannot use `length < K_MAX_LENGTH` here because that fails when
        // length is NaN (which is otherwise coerced to zero.)
        if (length >= K_MAX_LENGTH) throw new RangeError("Attempt to allocate Buffer larger than maximum size: 0x" + K_MAX_LENGTH.toString(16) + " bytes");
        return length | 0;
    }
    function SlowBuffer(length) {
        if (+length != length) length = 0;
        return Buffer.alloc(+length);
    }
    Buffer.isBuffer = function isBuffer(b) {
        return b != null && b._isBuffer === true && b !== Buffer.prototype // so Buffer.isBuffer(Buffer.prototype) will be false
        ;
    };
    Buffer.compare = function compare(a, b) {
        if (isInstance(a, Uint8Array)) a = Buffer.from(a, a.offset, a.byteLength);
        if (isInstance(b, Uint8Array)) b = Buffer.from(b, b.offset, b.byteLength);
        if (!Buffer.isBuffer(a) || !Buffer.isBuffer(b)) throw new TypeError('The "buf1", "buf2" arguments must be one of type Buffer or Uint8Array');
        if (a === b) return 0;
        let x = a.length;
        let y = b.length;
        for(let i = 0, len = Math.min(x, y); i < len; ++i)if (a[i] !== b[i]) {
            x = a[i];
            y = b[i];
            break;
        }
        if (x < y) return -1;
        if (y < x) return 1;
        return 0;
    };
    Buffer.isEncoding = function isEncoding(encoding) {
        switch(String(encoding).toLowerCase()){
            case "hex":
            case "utf8":
            case "utf-8":
            case "ascii":
            case "latin1":
            case "binary":
            case "base64":
            case "ucs2":
            case "ucs-2":
            case "utf16le":
            case "utf-16le":
                return true;
            default:
                return false;
        }
    };
    Buffer.concat = function concat(list, length) {
        if (!Array.isArray(list)) throw new TypeError('"list" argument must be an Array of Buffers');
        if (list.length === 0) return Buffer.alloc(0);
        let i;
        if (length === undefined) {
            length = 0;
            for(i = 0; i < list.length; ++i)length += list[i].length;
        }
        const buffer = Buffer.allocUnsafe(length);
        let pos = 0;
        for(i = 0; i < list.length; ++i){
            let buf = list[i];
            if (isInstance(buf, Uint8Array)) {
                if (pos + buf.length > buffer.length) {
                    if (!Buffer.isBuffer(buf)) buf = Buffer.from(buf);
                    buf.copy(buffer, pos);
                } else Uint8Array.prototype.set.call(buffer, buf, pos);
            } else if (!Buffer.isBuffer(buf)) throw new TypeError('"list" argument must be an Array of Buffers');
            else buf.copy(buffer, pos);
            pos += buf.length;
        }
        return buffer;
    };
    function byteLength(string, encoding) {
        if (Buffer.isBuffer(string)) return string.length;
        if (ArrayBuffer.isView(string) || isInstance(string, ArrayBuffer)) return string.byteLength;
        if (typeof string !== "string") throw new TypeError('The "string" argument must be one of type string, Buffer, or ArrayBuffer. Received type ' + typeof string);
        const len = string.length;
        const mustMatch = arguments.length > 2 && arguments[2] === true;
        if (!mustMatch && len === 0) return 0;
        // Use a for loop to avoid recursion
        let loweredCase = false;
        for(;;)switch(encoding){
            case "ascii":
            case "latin1":
            case "binary":
                return len;
            case "utf8":
            case "utf-8":
                return utf8ToBytes(string).length;
            case "ucs2":
            case "ucs-2":
            case "utf16le":
            case "utf-16le":
                return len * 2;
            case "hex":
                return len >>> 1;
            case "base64":
                return base64ToBytes(string).length;
            default:
                if (loweredCase) return mustMatch ? -1 : utf8ToBytes(string).length // assume utf8
                ;
                encoding = ("" + encoding).toLowerCase();
                loweredCase = true;
        }
    }
    Buffer.byteLength = byteLength;
    function slowToString(encoding, start, end) {
        let loweredCase = false;
        // No need to verify that "this.length <= MAX_UINT32" since it's a read-only
        // property of a typed array.
        // This behaves neither like String nor Uint8Array in that we set start/end
        // to their upper/lower bounds if the value passed is out of range.
        // undefined is handled specially as per ECMA-262 6th Edition,
        // Section 13.3.3.7 Runtime Semantics: KeyedBindingInitialization.
        if (start === undefined || start < 0) start = 0;
        // Return early if start > this.length. Done here to prevent potential uint32
        // coercion fail below.
        if (start > this.length) return "";
        if (end === undefined || end > this.length) end = this.length;
        if (end <= 0) return "";
        // Force coercion to uint32. This will also coerce falsey/NaN values to 0.
        end >>>= 0;
        start >>>= 0;
        if (end <= start) return "";
        if (!encoding) encoding = "utf8";
        while(true)switch(encoding){
            case "hex":
                return hexSlice(this, start, end);
            case "utf8":
            case "utf-8":
                return utf8Slice(this, start, end);
            case "ascii":
                return asciiSlice(this, start, end);
            case "latin1":
            case "binary":
                return latin1Slice(this, start, end);
            case "base64":
                return base64Slice(this, start, end);
            case "ucs2":
            case "ucs-2":
            case "utf16le":
            case "utf-16le":
                return utf16leSlice(this, start, end);
            default:
                if (loweredCase) throw new TypeError("Unknown encoding: " + encoding);
                encoding = (encoding + "").toLowerCase();
                loweredCase = true;
        }
    }
    // This property is used by `Buffer.isBuffer` (and the `is-buffer` npm package)
    // to detect a Buffer instance. It's not possible to use `instanceof Buffer`
    // reliably in a browserify context because there could be multiple different
    // copies of the 'buffer' package in use. This method works even for Buffer
    // instances that were created from another copy of the `buffer` package.
    // See: https://github.com/feross/buffer/issues/154
    Buffer.prototype._isBuffer = true;
    function swap(b, n, m) {
        const i = b[n];
        b[n] = b[m];
        b[m] = i;
    }
    Buffer.prototype.swap16 = function swap16() {
        const len = this.length;
        if (len % 2 !== 0) throw new RangeError("Buffer size must be a multiple of 16-bits");
        for(let i = 0; i < len; i += 2)swap(this, i, i + 1);
        return this;
    };
    Buffer.prototype.swap32 = function swap32() {
        const len = this.length;
        if (len % 4 !== 0) throw new RangeError("Buffer size must be a multiple of 32-bits");
        for(let i = 0; i < len; i += 4){
            swap(this, i, i + 3);
            swap(this, i + 1, i + 2);
        }
        return this;
    };
    Buffer.prototype.swap64 = function swap64() {
        const len = this.length;
        if (len % 8 !== 0) throw new RangeError("Buffer size must be a multiple of 64-bits");
        for(let i = 0; i < len; i += 8){
            swap(this, i, i + 7);
            swap(this, i + 1, i + 6);
            swap(this, i + 2, i + 5);
            swap(this, i + 3, i + 4);
        }
        return this;
    };
    Buffer.prototype.toString = function toString() {
        const length = this.length;
        if (length === 0) return "";
        if (arguments.length === 0) return utf8Slice(this, 0, length);
        return slowToString.apply(this, arguments);
    };
    Buffer.prototype.toLocaleString = Buffer.prototype.toString;
    Buffer.prototype.equals = function equals(b) {
        if (!Buffer.isBuffer(b)) throw new TypeError("Argument must be a Buffer");
        if (this === b) return true;
        return Buffer.compare(this, b) === 0;
    };
    Buffer.prototype.inspect = function inspect() {
        let str = "";
        const max = exports.INSPECT_MAX_BYTES;
        str = this.toString("hex", 0, max).replace(/(.{2})/g, "$1 ").trim();
        if (this.length > max) str += " ... ";
        return "<Buffer " + str + ">";
    };
    if (customInspectSymbol) Buffer.prototype[customInspectSymbol] = Buffer.prototype.inspect;
    Buffer.prototype.compare = function compare(target, start, end, thisStart, thisEnd) {
        if (isInstance(target, Uint8Array)) target = Buffer.from(target, target.offset, target.byteLength);
        if (!Buffer.isBuffer(target)) throw new TypeError('The "target" argument must be one of type Buffer or Uint8Array. Received type ' + typeof target);
        if (start === undefined) start = 0;
        if (end === undefined) end = target ? target.length : 0;
        if (thisStart === undefined) thisStart = 0;
        if (thisEnd === undefined) thisEnd = this.length;
        if (start < 0 || end > target.length || thisStart < 0 || thisEnd > this.length) throw new RangeError("out of range index");
        if (thisStart >= thisEnd && start >= end) return 0;
        if (thisStart >= thisEnd) return -1;
        if (start >= end) return 1;
        start >>>= 0;
        end >>>= 0;
        thisStart >>>= 0;
        thisEnd >>>= 0;
        if (this === target) return 0;
        let x = thisEnd - thisStart;
        let y = end - start;
        const len = Math.min(x, y);
        const thisCopy = this.slice(thisStart, thisEnd);
        const targetCopy = target.slice(start, end);
        for(let i = 0; i < len; ++i)if (thisCopy[i] !== targetCopy[i]) {
            x = thisCopy[i];
            y = targetCopy[i];
            break;
        }
        if (x < y) return -1;
        if (y < x) return 1;
        return 0;
    };
    // Finds either the first index of `val` in `buffer` at offset >= `byteOffset`,
    // OR the last index of `val` in `buffer` at offset <= `byteOffset`.
    //
    // Arguments:
    // - buffer - a Buffer to search
    // - val - a string, Buffer, or number
    // - byteOffset - an index into `buffer`; will be clamped to an int32
    // - encoding - an optional encoding, relevant is val is a string
    // - dir - true for indexOf, false for lastIndexOf
    function bidirectionalIndexOf(buffer, val, byteOffset, encoding, dir) {
        // Empty buffer means no match
        if (buffer.length === 0) return -1;
        // Normalize byteOffset
        if (typeof byteOffset === "string") {
            encoding = byteOffset;
            byteOffset = 0;
        } else if (byteOffset > 0x7fffffff) byteOffset = 0x7fffffff;
        else if (byteOffset < -2147483648) byteOffset = -2147483648;
        byteOffset = +byteOffset; // Coerce to Number.
        if (numberIsNaN(byteOffset)) // byteOffset: it it's undefined, null, NaN, "foo", etc, search whole buffer
        byteOffset = dir ? 0 : buffer.length - 1;
        // Normalize byteOffset: negative offsets start from the end of the buffer
        if (byteOffset < 0) byteOffset = buffer.length + byteOffset;
        if (byteOffset >= buffer.length) {
            if (dir) return -1;
            else byteOffset = buffer.length - 1;
        } else if (byteOffset < 0) {
            if (dir) byteOffset = 0;
            else return -1;
        }
        // Normalize val
        if (typeof val === "string") val = Buffer.from(val, encoding);
        // Finally, search either indexOf (if dir is true) or lastIndexOf
        if (Buffer.isBuffer(val)) {
            // Special case: looking for empty string/buffer always fails
            if (val.length === 0) return -1;
            return arrayIndexOf(buffer, val, byteOffset, encoding, dir);
        } else if (typeof val === "number") {
            val = val & 0xFF; // Search for a byte value [0-255]
            if (typeof Uint8Array.prototype.indexOf === "function") {
                if (dir) return Uint8Array.prototype.indexOf.call(buffer, val, byteOffset);
                else return Uint8Array.prototype.lastIndexOf.call(buffer, val, byteOffset);
            }
            return arrayIndexOf(buffer, [
                val
            ], byteOffset, encoding, dir);
        }
        throw new TypeError("val must be string, number or Buffer");
    }
    function arrayIndexOf(arr, val, byteOffset, encoding, dir) {
        let indexSize = 1;
        let arrLength = arr.length;
        let valLength = val.length;
        if (encoding !== undefined) {
            encoding = String(encoding).toLowerCase();
            if (encoding === "ucs2" || encoding === "ucs-2" || encoding === "utf16le" || encoding === "utf-16le") {
                if (arr.length < 2 || val.length < 2) return -1;
                indexSize = 2;
                arrLength /= 2;
                valLength /= 2;
                byteOffset /= 2;
            }
        }
        function read(buf, i) {
            if (indexSize === 1) return buf[i];
            else return buf.readUInt16BE(i * indexSize);
        }
        let i;
        if (dir) {
            let foundIndex = -1;
            for(i = byteOffset; i < arrLength; i++)if (read(arr, i) === read(val, foundIndex === -1 ? 0 : i - foundIndex)) {
                if (foundIndex === -1) foundIndex = i;
                if (i - foundIndex + 1 === valLength) return foundIndex * indexSize;
            } else {
                if (foundIndex !== -1) i -= i - foundIndex;
                foundIndex = -1;
            }
        } else {
            if (byteOffset + valLength > arrLength) byteOffset = arrLength - valLength;
            for(i = byteOffset; i >= 0; i--){
                let found = true;
                for(let j = 0; j < valLength; j++)if (read(arr, i + j) !== read(val, j)) {
                    found = false;
                    break;
                }
                if (found) return i;
            }
        }
        return -1;
    }
    Buffer.prototype.includes = function includes(val, byteOffset, encoding) {
        return this.indexOf(val, byteOffset, encoding) !== -1;
    };
    Buffer.prototype.indexOf = function indexOf(val, byteOffset, encoding) {
        return bidirectionalIndexOf(this, val, byteOffset, encoding, true);
    };
    Buffer.prototype.lastIndexOf = function lastIndexOf(val, byteOffset, encoding) {
        return bidirectionalIndexOf(this, val, byteOffset, encoding, false);
    };
    function hexWrite(buf, string, offset, length) {
        offset = Number(offset) || 0;
        const remaining = buf.length - offset;
        if (!length) length = remaining;
        else {
            length = Number(length);
            if (length > remaining) length = remaining;
        }
        const strLen = string.length;
        if (length > strLen / 2) length = strLen / 2;
        let i;
        for(i = 0; i < length; ++i){
            const parsed = parseInt(string.substr(i * 2, 2), 16);
            if (numberIsNaN(parsed)) return i;
            buf[offset + i] = parsed;
        }
        return i;
    }
    function utf8Write(buf, string, offset, length) {
        return blitBuffer(utf8ToBytes(string, buf.length - offset), buf, offset, length);
    }
    function asciiWrite(buf, string, offset, length) {
        return blitBuffer(asciiToBytes(string), buf, offset, length);
    }
    function base64Write(buf, string, offset, length) {
        return blitBuffer(base64ToBytes(string), buf, offset, length);
    }
    function ucs2Write(buf, string, offset, length) {
        return blitBuffer(utf16leToBytes(string, buf.length - offset), buf, offset, length);
    }
    Buffer.prototype.write = function write(string, offset, length, encoding) {
        // Buffer#write(string)
        if (offset === undefined) {
            encoding = "utf8";
            length = this.length;
            offset = 0;
        // Buffer#write(string, encoding)
        } else if (length === undefined && typeof offset === "string") {
            encoding = offset;
            length = this.length;
            offset = 0;
        // Buffer#write(string, offset[, length][, encoding])
        } else if (isFinite(offset)) {
            offset = offset >>> 0;
            if (isFinite(length)) {
                length = length >>> 0;
                if (encoding === undefined) encoding = "utf8";
            } else {
                encoding = length;
                length = undefined;
            }
        } else throw new Error("Buffer.write(string, encoding, offset[, length]) is no longer supported");
        const remaining = this.length - offset;
        if (length === undefined || length > remaining) length = remaining;
        if (string.length > 0 && (length < 0 || offset < 0) || offset > this.length) throw new RangeError("Attempt to write outside buffer bounds");
        if (!encoding) encoding = "utf8";
        let loweredCase = false;
        for(;;)switch(encoding){
            case "hex":
                return hexWrite(this, string, offset, length);
            case "utf8":
            case "utf-8":
                return utf8Write(this, string, offset, length);
            case "ascii":
            case "latin1":
            case "binary":
                return asciiWrite(this, string, offset, length);
            case "base64":
                // Warning: maxLength not taken into account in base64Write
                return base64Write(this, string, offset, length);
            case "ucs2":
            case "ucs-2":
            case "utf16le":
            case "utf-16le":
                return ucs2Write(this, string, offset, length);
            default:
                if (loweredCase) throw new TypeError("Unknown encoding: " + encoding);
                encoding = ("" + encoding).toLowerCase();
                loweredCase = true;
        }
    };
    Buffer.prototype.toJSON = function toJSON() {
        return {
            type: "Buffer",
            data: Array.prototype.slice.call(this._arr || this, 0)
        };
    };
    function base64Slice(buf, start, end) {
        if (start === 0 && end === buf.length) return base64.fromByteArray(buf);
        else return base64.fromByteArray(buf.slice(start, end));
    }
    function utf8Slice(buf, start, end) {
        end = Math.min(buf.length, end);
        const res = [];
        let i = start;
        while(i < end){
            const firstByte = buf[i];
            let codePoint = null;
            let bytesPerSequence = firstByte > 0xEF ? 4 : firstByte > 0xDF ? 3 : firstByte > 0xBF ? 2 : 1;
            if (i + bytesPerSequence <= end) {
                let secondByte, thirdByte, fourthByte, tempCodePoint;
                switch(bytesPerSequence){
                    case 1:
                        if (firstByte < 0x80) codePoint = firstByte;
                        break;
                    case 2:
                        secondByte = buf[i + 1];
                        if ((secondByte & 0xC0) === 0x80) {
                            tempCodePoint = (firstByte & 0x1F) << 0x6 | secondByte & 0x3F;
                            if (tempCodePoint > 0x7F) codePoint = tempCodePoint;
                        }
                        break;
                    case 3:
                        secondByte = buf[i + 1];
                        thirdByte = buf[i + 2];
                        if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80) {
                            tempCodePoint = (firstByte & 0xF) << 0xC | (secondByte & 0x3F) << 0x6 | thirdByte & 0x3F;
                            if (tempCodePoint > 0x7FF && (tempCodePoint < 0xD800 || tempCodePoint > 0xDFFF)) codePoint = tempCodePoint;
                        }
                        break;
                    case 4:
                        secondByte = buf[i + 1];
                        thirdByte = buf[i + 2];
                        fourthByte = buf[i + 3];
                        if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80 && (fourthByte & 0xC0) === 0x80) {
                            tempCodePoint = (firstByte & 0xF) << 0x12 | (secondByte & 0x3F) << 0xC | (thirdByte & 0x3F) << 0x6 | fourthByte & 0x3F;
                            if (tempCodePoint > 0xFFFF && tempCodePoint < 0x110000) codePoint = tempCodePoint;
                        }
                }
            }
            if (codePoint === null) {
                // we did not generate a valid codePoint so insert a
                // replacement char (U+FFFD) and advance only 1 byte
                codePoint = 0xFFFD;
                bytesPerSequence = 1;
            } else if (codePoint > 0xFFFF) {
                // encode to utf16 (surrogate pair dance)
                codePoint -= 0x10000;
                res.push(codePoint >>> 10 & 0x3FF | 0xD800);
                codePoint = 0xDC00 | codePoint & 0x3FF;
            }
            res.push(codePoint);
            i += bytesPerSequence;
        }
        return decodeCodePointsArray(res);
    }
    // Based on http://stackoverflow.com/a/22747272/680742, the browser with
    // the lowest limit is Chrome, with 0x10000 args.
    // We go 1 magnitude less, for safety
    const MAX_ARGUMENTS_LENGTH = 0x1000;
    function decodeCodePointsArray(codePoints) {
        const len = codePoints.length;
        if (len <= MAX_ARGUMENTS_LENGTH) return String.fromCharCode.apply(String, codePoints) // avoid extra slice()
        ;
        // Decode in chunks to avoid "call stack size exceeded".
        let res = "";
        let i = 0;
        while(i < len)res += String.fromCharCode.apply(String, codePoints.slice(i, i += MAX_ARGUMENTS_LENGTH));
        return res;
    }
    function asciiSlice(buf, start, end) {
        let ret = "";
        end = Math.min(buf.length, end);
        for(let i = start; i < end; ++i)ret += String.fromCharCode(buf[i] & 0x7F);
        return ret;
    }
    function latin1Slice(buf, start, end) {
        let ret = "";
        end = Math.min(buf.length, end);
        for(let i = start; i < end; ++i)ret += String.fromCharCode(buf[i]);
        return ret;
    }
    function hexSlice(buf, start, end) {
        const len = buf.length;
        if (!start || start < 0) start = 0;
        if (!end || end < 0 || end > len) end = len;
        let out = "";
        for(let i = start; i < end; ++i)out += hexSliceLookupTable[buf[i]];
        return out;
    }
    function utf16leSlice(buf, start, end) {
        const bytes = buf.slice(start, end);
        let res = "";
        // If bytes.length is odd, the last 8 bits must be ignored (same as node.js)
        for(let i = 0; i < bytes.length - 1; i += 2)res += String.fromCharCode(bytes[i] + bytes[i + 1] * 256);
        return res;
    }
    Buffer.prototype.slice = function slice(start, end) {
        const len = this.length;
        start = ~~start;
        end = end === undefined ? len : ~~end;
        if (start < 0) {
            start += len;
            if (start < 0) start = 0;
        } else if (start > len) start = len;
        if (end < 0) {
            end += len;
            if (end < 0) end = 0;
        } else if (end > len) end = len;
        if (end < start) end = start;
        const newBuf = this.subarray(start, end);
        // Return an augmented `Uint8Array` instance
        Object.setPrototypeOf(newBuf, Buffer.prototype);
        return newBuf;
    };
    /*
 * Need to make sure that buffer isn't trying to write out of bounds.
 */ function checkOffset(offset, ext, length) {
        if (offset % 1 !== 0 || offset < 0) throw new RangeError("offset is not uint");
        if (offset + ext > length) throw new RangeError("Trying to access beyond buffer length");
    }
    Buffer.prototype.readUintLE = Buffer.prototype.readUIntLE = function readUIntLE(offset, byteLength, noAssert) {
        offset = offset >>> 0;
        byteLength = byteLength >>> 0;
        if (!noAssert) checkOffset(offset, byteLength, this.length);
        let val = this[offset];
        let mul = 1;
        let i = 0;
        while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
        return val;
    };
    Buffer.prototype.readUintBE = Buffer.prototype.readUIntBE = function readUIntBE(offset, byteLength, noAssert) {
        offset = offset >>> 0;
        byteLength = byteLength >>> 0;
        if (!noAssert) checkOffset(offset, byteLength, this.length);
        let val = this[offset + --byteLength];
        let mul = 1;
        while(byteLength > 0 && (mul *= 0x100))val += this[offset + --byteLength] * mul;
        return val;
    };
    Buffer.prototype.readUint8 = Buffer.prototype.readUInt8 = function readUInt8(offset, noAssert) {
        offset = offset >>> 0;
        if (!noAssert) checkOffset(offset, 1, this.length);
        return this[offset];
    };
    Buffer.prototype.readUint16LE = Buffer.prototype.readUInt16LE = function readUInt16LE(offset, noAssert) {
        offset = offset >>> 0;
        if (!noAssert) checkOffset(offset, 2, this.length);
        return this[offset] | this[offset + 1] << 8;
    };
    Buffer.prototype.readUint16BE = Buffer.prototype.readUInt16BE = function readUInt16BE(offset, noAssert) {
        offset = offset >>> 0;
        if (!noAssert) checkOffset(offset, 2, this.length);
        return this[offset] << 8 | this[offset + 1];
    };
    Buffer.prototype.readUint32LE = Buffer.prototype.readUInt32LE = function readUInt32LE(offset, noAssert) {
        offset = offset >>> 0;
        if (!noAssert) checkOffset(offset, 4, this.length);
        return (this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16) + this[offset + 3] * 0x1000000;
    };
    Buffer.prototype.readUint32BE = Buffer.prototype.readUInt32BE = function readUInt32BE(offset, noAssert) {
        offset = offset >>> 0;
        if (!noAssert) checkOffset(offset, 4, this.length);
        return this[offset] * 0x1000000 + (this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3]);
    };
    Buffer.prototype.readBigUInt64LE = defineBigIntMethod(function readBigUInt64LE(offset) {
        offset = offset >>> 0;
        validateNumber(offset, "offset");
        const first = this[offset];
        const last = this[offset + 7];
        if (first === undefined || last === undefined) boundsError(offset, this.length - 8);
        const lo = first + this[++offset] * 256 + this[++offset] * 2 ** 16 + this[++offset] * 2 ** 24;
        const hi = this[++offset] + this[++offset] * 256 + this[++offset] * 2 ** 16 + last * 2 ** 24;
        return BigInt(lo) + (BigInt(hi) << BigInt(32));
    });
    Buffer.prototype.readBigUInt64BE = defineBigIntMethod(function readBigUInt64BE(offset) {
        offset = offset >>> 0;
        validateNumber(offset, "offset");
        const first = this[offset];
        const last = this[offset + 7];
        if (first === undefined || last === undefined) boundsError(offset, this.length - 8);
        const hi = first * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + this[++offset];
        const lo = this[++offset] * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + last;
        return (BigInt(hi) << BigInt(32)) + BigInt(lo);
    });
    Buffer.prototype.readIntLE = function readIntLE(offset, byteLength, noAssert) {
        offset = offset >>> 0;
        byteLength = byteLength >>> 0;
        if (!noAssert) checkOffset(offset, byteLength, this.length);
        let val = this[offset];
        let mul = 1;
        let i = 0;
        while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
        mul *= 0x80;
        if (val >= mul) val -= Math.pow(2, 8 * byteLength);
        return val;
    };
    Buffer.prototype.readIntBE = function readIntBE(offset, byteLength, noAssert) {
        offset = offset >>> 0;
        byteLength = byteLength >>> 0;
        if (!noAssert) checkOffset(offset, byteLength, this.length);
        let i = byteLength;
        let mul = 1;
        let val = this[offset + --i];
        while(i > 0 && (mul *= 0x100))val += this[offset + --i] * mul;
        mul *= 0x80;
        if (val >= mul) val -= Math.pow(2, 8 * byteLength);
        return val;
    };
    Buffer.prototype.readInt8 = function readInt8(offset, noAssert) {
        offset = offset >>> 0;
        if (!noAssert) checkOffset(offset, 1, this.length);
        if (!(this[offset] & 0x80)) return this[offset];
        return (0xff - this[offset] + 1) * -1;
    };
    Buffer.prototype.readInt16LE = function readInt16LE(offset, noAssert) {
        offset = offset >>> 0;
        if (!noAssert) checkOffset(offset, 2, this.length);
        const val = this[offset] | this[offset + 1] << 8;
        return val & 0x8000 ? val | 0xFFFF0000 : val;
    };
    Buffer.prototype.readInt16BE = function readInt16BE(offset, noAssert) {
        offset = offset >>> 0;
        if (!noAssert) checkOffset(offset, 2, this.length);
        const val = this[offset + 1] | this[offset] << 8;
        return val & 0x8000 ? val | 0xFFFF0000 : val;
    };
    Buffer.prototype.readInt32LE = function readInt32LE(offset, noAssert) {
        offset = offset >>> 0;
        if (!noAssert) checkOffset(offset, 4, this.length);
        return this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16 | this[offset + 3] << 24;
    };
    Buffer.prototype.readInt32BE = function readInt32BE(offset, noAssert) {
        offset = offset >>> 0;
        if (!noAssert) checkOffset(offset, 4, this.length);
        return this[offset] << 24 | this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3];
    };
    Buffer.prototype.readBigInt64LE = defineBigIntMethod(function readBigInt64LE(offset) {
        offset = offset >>> 0;
        validateNumber(offset, "offset");
        const first = this[offset];
        const last = this[offset + 7];
        if (first === undefined || last === undefined) boundsError(offset, this.length - 8);
        const val = this[offset + 4] + this[offset + 5] * 256 + this[offset + 6] * 2 ** 16 + (last << 24); // Overflow
        return (BigInt(val) << BigInt(32)) + BigInt(first + this[++offset] * 256 + this[++offset] * 2 ** 16 + this[++offset] * 2 ** 24);
    });
    Buffer.prototype.readBigInt64BE = defineBigIntMethod(function readBigInt64BE(offset) {
        offset = offset >>> 0;
        validateNumber(offset, "offset");
        const first = this[offset];
        const last = this[offset + 7];
        if (first === undefined || last === undefined) boundsError(offset, this.length - 8);
        const val = (first << 24) + // Overflow
        this[++offset] * 2 ** 16 + this[++offset] * 256 + this[++offset];
        return (BigInt(val) << BigInt(32)) + BigInt(this[++offset] * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + last);
    });
    Buffer.prototype.readFloatLE = function readFloatLE(offset, noAssert) {
        offset = offset >>> 0;
        if (!noAssert) checkOffset(offset, 4, this.length);
        return ieee754$1.read(this, offset, true, 23, 4);
    };
    Buffer.prototype.readFloatBE = function readFloatBE(offset, noAssert) {
        offset = offset >>> 0;
        if (!noAssert) checkOffset(offset, 4, this.length);
        return ieee754$1.read(this, offset, false, 23, 4);
    };
    Buffer.prototype.readDoubleLE = function readDoubleLE(offset, noAssert) {
        offset = offset >>> 0;
        if (!noAssert) checkOffset(offset, 8, this.length);
        return ieee754$1.read(this, offset, true, 52, 8);
    };
    Buffer.prototype.readDoubleBE = function readDoubleBE(offset, noAssert) {
        offset = offset >>> 0;
        if (!noAssert) checkOffset(offset, 8, this.length);
        return ieee754$1.read(this, offset, false, 52, 8);
    };
    function checkInt(buf, value, offset, ext, max, min) {
        if (!Buffer.isBuffer(buf)) throw new TypeError('"buffer" argument must be a Buffer instance');
        if (value > max || value < min) throw new RangeError('"value" argument is out of bounds');
        if (offset + ext > buf.length) throw new RangeError("Index out of range");
    }
    Buffer.prototype.writeUintLE = Buffer.prototype.writeUIntLE = function writeUIntLE(value, offset, byteLength, noAssert) {
        value = +value;
        offset = offset >>> 0;
        byteLength = byteLength >>> 0;
        if (!noAssert) {
            const maxBytes = Math.pow(2, 8 * byteLength) - 1;
            checkInt(this, value, offset, byteLength, maxBytes, 0);
        }
        let mul = 1;
        let i = 0;
        this[offset] = value & 0xFF;
        while(++i < byteLength && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
        return offset + byteLength;
    };
    Buffer.prototype.writeUintBE = Buffer.prototype.writeUIntBE = function writeUIntBE(value, offset, byteLength, noAssert) {
        value = +value;
        offset = offset >>> 0;
        byteLength = byteLength >>> 0;
        if (!noAssert) {
            const maxBytes = Math.pow(2, 8 * byteLength) - 1;
            checkInt(this, value, offset, byteLength, maxBytes, 0);
        }
        let i = byteLength - 1;
        let mul = 1;
        this[offset + i] = value & 0xFF;
        while(--i >= 0 && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
        return offset + byteLength;
    };
    Buffer.prototype.writeUint8 = Buffer.prototype.writeUInt8 = function writeUInt8(value, offset, noAssert) {
        value = +value;
        offset = offset >>> 0;
        if (!noAssert) checkInt(this, value, offset, 1, 0xff, 0);
        this[offset] = value & 0xff;
        return offset + 1;
    };
    Buffer.prototype.writeUint16LE = Buffer.prototype.writeUInt16LE = function writeUInt16LE(value, offset, noAssert) {
        value = +value;
        offset = offset >>> 0;
        if (!noAssert) checkInt(this, value, offset, 2, 0xffff, 0);
        this[offset] = value & 0xff;
        this[offset + 1] = value >>> 8;
        return offset + 2;
    };
    Buffer.prototype.writeUint16BE = Buffer.prototype.writeUInt16BE = function writeUInt16BE(value, offset, noAssert) {
        value = +value;
        offset = offset >>> 0;
        if (!noAssert) checkInt(this, value, offset, 2, 0xffff, 0);
        this[offset] = value >>> 8;
        this[offset + 1] = value & 0xff;
        return offset + 2;
    };
    Buffer.prototype.writeUint32LE = Buffer.prototype.writeUInt32LE = function writeUInt32LE(value, offset, noAssert) {
        value = +value;
        offset = offset >>> 0;
        if (!noAssert) checkInt(this, value, offset, 4, 0xffffffff, 0);
        this[offset + 3] = value >>> 24;
        this[offset + 2] = value >>> 16;
        this[offset + 1] = value >>> 8;
        this[offset] = value & 0xff;
        return offset + 4;
    };
    Buffer.prototype.writeUint32BE = Buffer.prototype.writeUInt32BE = function writeUInt32BE(value, offset, noAssert) {
        value = +value;
        offset = offset >>> 0;
        if (!noAssert) checkInt(this, value, offset, 4, 0xffffffff, 0);
        this[offset] = value >>> 24;
        this[offset + 1] = value >>> 16;
        this[offset + 2] = value >>> 8;
        this[offset + 3] = value & 0xff;
        return offset + 4;
    };
    function wrtBigUInt64LE(buf, value, offset, min, max) {
        checkIntBI(value, min, max, buf, offset, 7);
        let lo = Number(value & BigInt(0xffffffff));
        buf[offset++] = lo;
        lo = lo >> 8;
        buf[offset++] = lo;
        lo = lo >> 8;
        buf[offset++] = lo;
        lo = lo >> 8;
        buf[offset++] = lo;
        let hi = Number(value >> BigInt(32) & BigInt(0xffffffff));
        buf[offset++] = hi;
        hi = hi >> 8;
        buf[offset++] = hi;
        hi = hi >> 8;
        buf[offset++] = hi;
        hi = hi >> 8;
        buf[offset++] = hi;
        return offset;
    }
    function wrtBigUInt64BE(buf, value, offset, min, max) {
        checkIntBI(value, min, max, buf, offset, 7);
        let lo = Number(value & BigInt(0xffffffff));
        buf[offset + 7] = lo;
        lo = lo >> 8;
        buf[offset + 6] = lo;
        lo = lo >> 8;
        buf[offset + 5] = lo;
        lo = lo >> 8;
        buf[offset + 4] = lo;
        let hi = Number(value >> BigInt(32) & BigInt(0xffffffff));
        buf[offset + 3] = hi;
        hi = hi >> 8;
        buf[offset + 2] = hi;
        hi = hi >> 8;
        buf[offset + 1] = hi;
        hi = hi >> 8;
        buf[offset] = hi;
        return offset + 8;
    }
    Buffer.prototype.writeBigUInt64LE = defineBigIntMethod(function writeBigUInt64LE(value, offset = 0) {
        return wrtBigUInt64LE(this, value, offset, BigInt(0), BigInt("0xffffffffffffffff"));
    });
    Buffer.prototype.writeBigUInt64BE = defineBigIntMethod(function writeBigUInt64BE(value, offset = 0) {
        return wrtBigUInt64BE(this, value, offset, BigInt(0), BigInt("0xffffffffffffffff"));
    });
    Buffer.prototype.writeIntLE = function writeIntLE(value, offset, byteLength, noAssert) {
        value = +value;
        offset = offset >>> 0;
        if (!noAssert) {
            const limit = Math.pow(2, 8 * byteLength - 1);
            checkInt(this, value, offset, byteLength, limit - 1, -limit);
        }
        let i = 0;
        let mul = 1;
        let sub = 0;
        this[offset] = value & 0xFF;
        while(++i < byteLength && (mul *= 0x100)){
            if (value < 0 && sub === 0 && this[offset + i - 1] !== 0) sub = 1;
            this[offset + i] = (value / mul >> 0) - sub & 0xFF;
        }
        return offset + byteLength;
    };
    Buffer.prototype.writeIntBE = function writeIntBE(value, offset, byteLength, noAssert) {
        value = +value;
        offset = offset >>> 0;
        if (!noAssert) {
            const limit = Math.pow(2, 8 * byteLength - 1);
            checkInt(this, value, offset, byteLength, limit - 1, -limit);
        }
        let i = byteLength - 1;
        let mul = 1;
        let sub = 0;
        this[offset + i] = value & 0xFF;
        while(--i >= 0 && (mul *= 0x100)){
            if (value < 0 && sub === 0 && this[offset + i + 1] !== 0) sub = 1;
            this[offset + i] = (value / mul >> 0) - sub & 0xFF;
        }
        return offset + byteLength;
    };
    Buffer.prototype.writeInt8 = function writeInt8(value, offset, noAssert) {
        value = +value;
        offset = offset >>> 0;
        if (!noAssert) checkInt(this, value, offset, 1, 0x7f, -128);
        if (value < 0) value = 0xff + value + 1;
        this[offset] = value & 0xff;
        return offset + 1;
    };
    Buffer.prototype.writeInt16LE = function writeInt16LE(value, offset, noAssert) {
        value = +value;
        offset = offset >>> 0;
        if (!noAssert) checkInt(this, value, offset, 2, 0x7fff, -32768);
        this[offset] = value & 0xff;
        this[offset + 1] = value >>> 8;
        return offset + 2;
    };
    Buffer.prototype.writeInt16BE = function writeInt16BE(value, offset, noAssert) {
        value = +value;
        offset = offset >>> 0;
        if (!noAssert) checkInt(this, value, offset, 2, 0x7fff, -32768);
        this[offset] = value >>> 8;
        this[offset + 1] = value & 0xff;
        return offset + 2;
    };
    Buffer.prototype.writeInt32LE = function writeInt32LE(value, offset, noAssert) {
        value = +value;
        offset = offset >>> 0;
        if (!noAssert) checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
        this[offset] = value & 0xff;
        this[offset + 1] = value >>> 8;
        this[offset + 2] = value >>> 16;
        this[offset + 3] = value >>> 24;
        return offset + 4;
    };
    Buffer.prototype.writeInt32BE = function writeInt32BE(value, offset, noAssert) {
        value = +value;
        offset = offset >>> 0;
        if (!noAssert) checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
        if (value < 0) value = 0xffffffff + value + 1;
        this[offset] = value >>> 24;
        this[offset + 1] = value >>> 16;
        this[offset + 2] = value >>> 8;
        this[offset + 3] = value & 0xff;
        return offset + 4;
    };
    Buffer.prototype.writeBigInt64LE = defineBigIntMethod(function writeBigInt64LE(value, offset = 0) {
        return wrtBigUInt64LE(this, value, offset, -BigInt("0x8000000000000000"), BigInt("0x7fffffffffffffff"));
    });
    Buffer.prototype.writeBigInt64BE = defineBigIntMethod(function writeBigInt64BE(value, offset = 0) {
        return wrtBigUInt64BE(this, value, offset, -BigInt("0x8000000000000000"), BigInt("0x7fffffffffffffff"));
    });
    function checkIEEE754(buf, value, offset, ext, max, min) {
        if (offset + ext > buf.length) throw new RangeError("Index out of range");
        if (offset < 0) throw new RangeError("Index out of range");
    }
    function writeFloat(buf, value, offset, littleEndian, noAssert) {
        value = +value;
        offset = offset >>> 0;
        if (!noAssert) checkIEEE754(buf, value, offset, 4);
        ieee754$1.write(buf, value, offset, littleEndian, 23, 4);
        return offset + 4;
    }
    Buffer.prototype.writeFloatLE = function writeFloatLE(value, offset, noAssert) {
        return writeFloat(this, value, offset, true, noAssert);
    };
    Buffer.prototype.writeFloatBE = function writeFloatBE(value, offset, noAssert) {
        return writeFloat(this, value, offset, false, noAssert);
    };
    function writeDouble(buf, value, offset, littleEndian, noAssert) {
        value = +value;
        offset = offset >>> 0;
        if (!noAssert) checkIEEE754(buf, value, offset, 8);
        ieee754$1.write(buf, value, offset, littleEndian, 52, 8);
        return offset + 8;
    }
    Buffer.prototype.writeDoubleLE = function writeDoubleLE(value, offset, noAssert) {
        return writeDouble(this, value, offset, true, noAssert);
    };
    Buffer.prototype.writeDoubleBE = function writeDoubleBE(value, offset, noAssert) {
        return writeDouble(this, value, offset, false, noAssert);
    };
    // copy(targetBuffer, targetStart=0, sourceStart=0, sourceEnd=buffer.length)
    Buffer.prototype.copy = function copy(target, targetStart, start, end) {
        if (!Buffer.isBuffer(target)) throw new TypeError("argument should be a Buffer");
        if (!start) start = 0;
        if (!end && end !== 0) end = this.length;
        if (targetStart >= target.length) targetStart = target.length;
        if (!targetStart) targetStart = 0;
        if (end > 0 && end < start) end = start;
        // Copy 0 bytes; we're done
        if (end === start) return 0;
        if (target.length === 0 || this.length === 0) return 0;
        // Fatal error conditions
        if (targetStart < 0) throw new RangeError("targetStart out of bounds");
        if (start < 0 || start >= this.length) throw new RangeError("Index out of range");
        if (end < 0) throw new RangeError("sourceEnd out of bounds");
        // Are we oob?
        if (end > this.length) end = this.length;
        if (target.length - targetStart < end - start) end = target.length - targetStart + start;
        const len = end - start;
        if (this === target && typeof Uint8Array.prototype.copyWithin === "function") // Use built-in when available, missing from IE11
        this.copyWithin(targetStart, start, end);
        else Uint8Array.prototype.set.call(target, this.subarray(start, end), targetStart);
        return len;
    };
    // Usage:
    //    buffer.fill(number[, offset[, end]])
    //    buffer.fill(buffer[, offset[, end]])
    //    buffer.fill(string[, offset[, end]][, encoding])
    Buffer.prototype.fill = function fill(val, start, end, encoding) {
        // Handle string cases:
        if (typeof val === "string") {
            if (typeof start === "string") {
                encoding = start;
                start = 0;
                end = this.length;
            } else if (typeof end === "string") {
                encoding = end;
                end = this.length;
            }
            if (encoding !== undefined && typeof encoding !== "string") throw new TypeError("encoding must be a string");
            if (typeof encoding === "string" && !Buffer.isEncoding(encoding)) throw new TypeError("Unknown encoding: " + encoding);
            if (val.length === 1) {
                const code = val.charCodeAt(0);
                if (encoding === "utf8" && code < 128 || encoding === "latin1") // Fast path: If `val` fits into a single byte, use that numeric value.
                val = code;
            }
        } else if (typeof val === "number") val = val & 255;
        else if (typeof val === "boolean") val = Number(val);
        // Invalid ranges are not set to a default, so can range check early.
        if (start < 0 || this.length < start || this.length < end) throw new RangeError("Out of range index");
        if (end <= start) return this;
        start = start >>> 0;
        end = end === undefined ? this.length : end >>> 0;
        if (!val) val = 0;
        let i;
        if (typeof val === "number") for(i = start; i < end; ++i)this[i] = val;
        else {
            const bytes = Buffer.isBuffer(val) ? val : Buffer.from(val, encoding);
            const len = bytes.length;
            if (len === 0) throw new TypeError('The value "' + val + '" is invalid for argument "value"');
            for(i = 0; i < end - start; ++i)this[i + start] = bytes[i % len];
        }
        return this;
    };
    // CUSTOM ERRORS
    // =============
    // Simplified versions from Node, changed for Buffer-only usage
    const errors = {};
    function E(sym, getMessage, Base) {
        errors[sym] = class NodeError extends Base {
            constructor(){
                super();
                Object.defineProperty(this, "message", {
                    value: getMessage.apply(this, arguments),
                    writable: true,
                    configurable: true
                });
                // Add the error code to the name to include it in the stack trace.
                this.name = `${this.name} [${sym}]`;
                // Access the stack to generate the error message including the error code
                // from the name.
                this.stack; // eslint-disable-line no-unused-expressions
                // Reset the name to the actual name.
                delete this.name;
            }
            get code() {
                return sym;
            }
            set code(value) {
                Object.defineProperty(this, "code", {
                    configurable: true,
                    enumerable: true,
                    value: value,
                    writable: true
                });
            }
            toString() {
                return `${this.name} [${sym}]: ${this.message}`;
            }
        };
    }
    E("ERR_BUFFER_OUT_OF_BOUNDS", function(name) {
        if (name) return `${name} is outside of buffer bounds`;
        return "Attempt to access memory outside buffer bounds";
    }, RangeError);
    E("ERR_INVALID_ARG_TYPE", function(name, actual) {
        return `The "${name}" argument must be of type number. Received type ${typeof actual}`;
    }, TypeError);
    E("ERR_OUT_OF_RANGE", function(str, range, input) {
        let msg = `The value of "${str}" is out of range.`;
        let received = input;
        if (Number.isInteger(input) && Math.abs(input) > 2 ** 32) received = addNumericalSeparator(String(input));
        else if (typeof input === "bigint") {
            received = String(input);
            if (input > BigInt(2) ** BigInt(32) || input < -(BigInt(2) ** BigInt(32))) received = addNumericalSeparator(received);
            received += "n";
        }
        msg += ` It must be ${range}. Received ${received}`;
        return msg;
    }, RangeError);
    function addNumericalSeparator(val) {
        let res = "";
        let i = val.length;
        const start = val[0] === "-" ? 1 : 0;
        for(; i >= start + 4; i -= 3)res = `_${val.slice(i - 3, i)}${res}`;
        return `${val.slice(0, i)}${res}`;
    }
    // CHECK FUNCTIONS
    // ===============
    function checkBounds(buf, offset, byteLength) {
        validateNumber(offset, "offset");
        if (buf[offset] === undefined || buf[offset + byteLength] === undefined) boundsError(offset, buf.length - (byteLength + 1));
    }
    function checkIntBI(value, min, max, buf, offset, byteLength) {
        if (value > max || value < min) {
            const n = typeof min === "bigint" ? "n" : "";
            let range;
            if (byteLength > 3) {
                if (min === 0 || min === BigInt(0)) range = `>= 0${n} and < 2${n} ** ${(byteLength + 1) * 8}${n}`;
                else range = `>= -(2${n} ** ${(byteLength + 1) * 8 - 1}${n}) and < 2 ** ` + `${(byteLength + 1) * 8 - 1}${n}`;
            } else range = `>= ${min}${n} and <= ${max}${n}`;
            throw new errors.ERR_OUT_OF_RANGE("value", range, value);
        }
        checkBounds(buf, offset, byteLength);
    }
    function validateNumber(value, name) {
        if (typeof value !== "number") throw new errors.ERR_INVALID_ARG_TYPE(name, "number", value);
    }
    function boundsError(value, length, type) {
        if (Math.floor(value) !== value) {
            validateNumber(value, type);
            throw new errors.ERR_OUT_OF_RANGE(type || "offset", "an integer", value);
        }
        if (length < 0) throw new errors.ERR_BUFFER_OUT_OF_BOUNDS();
        throw new errors.ERR_OUT_OF_RANGE(type || "offset", `>= ${type ? 1 : 0} and <= ${length}`, value);
    }
    // HELPER FUNCTIONS
    // ================
    const INVALID_BASE64_RE = /[^+/0-9A-Za-z-_]/g;
    function base64clean(str) {
        // Node takes equal signs as end of the Base64 encoding
        str = str.split("=")[0];
        // Node strips out invalid characters like \n and \t from the string, base64-js does not
        str = str.trim().replace(INVALID_BASE64_RE, "");
        // Node converts strings with length < 2 to ''
        if (str.length < 2) return "";
        // Node allows for non-padded base64 strings (missing trailing ===), base64-js does not
        while(str.length % 4 !== 0)str = str + "=";
        return str;
    }
    function utf8ToBytes(string, units) {
        units = units || Infinity;
        let codePoint;
        const length = string.length;
        let leadSurrogate = null;
        const bytes = [];
        for(let i = 0; i < length; ++i){
            codePoint = string.charCodeAt(i);
            // is surrogate component
            if (codePoint > 0xD7FF && codePoint < 0xE000) {
                // last char was a lead
                if (!leadSurrogate) {
                    // no lead yet
                    if (codePoint > 0xDBFF) {
                        // unexpected trail
                        if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                        continue;
                    } else if (i + 1 === length) {
                        // unpaired lead
                        if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                        continue;
                    }
                    // valid lead
                    leadSurrogate = codePoint;
                    continue;
                }
                // 2 leads in a row
                if (codePoint < 0xDC00) {
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    leadSurrogate = codePoint;
                    continue;
                }
                // valid surrogate pair
                codePoint = (leadSurrogate - 0xD800 << 10 | codePoint - 0xDC00) + 0x10000;
            } else if (leadSurrogate) // valid bmp char, but last char was a lead
            {
                if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
            }
            leadSurrogate = null;
            // encode utf8
            if (codePoint < 0x80) {
                if ((units -= 1) < 0) break;
                bytes.push(codePoint);
            } else if (codePoint < 0x800) {
                if ((units -= 2) < 0) break;
                bytes.push(codePoint >> 0x6 | 0xC0, codePoint & 0x3F | 0x80);
            } else if (codePoint < 0x10000) {
                if ((units -= 3) < 0) break;
                bytes.push(codePoint >> 0xC | 0xE0, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
            } else if (codePoint < 0x110000) {
                if ((units -= 4) < 0) break;
                bytes.push(codePoint >> 0x12 | 0xF0, codePoint >> 0xC & 0x3F | 0x80, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
            } else throw new Error("Invalid code point");
        }
        return bytes;
    }
    function asciiToBytes(str) {
        const byteArray = [];
        for(let i = 0; i < str.length; ++i)// Node's code seems to be doing this and not & 0x7F..
        byteArray.push(str.charCodeAt(i) & 0xFF);
        return byteArray;
    }
    function utf16leToBytes(str, units) {
        let c, hi, lo;
        const byteArray = [];
        for(let i = 0; i < str.length; ++i){
            if ((units -= 2) < 0) break;
            c = str.charCodeAt(i);
            hi = c >> 8;
            lo = c % 256;
            byteArray.push(lo);
            byteArray.push(hi);
        }
        return byteArray;
    }
    function base64ToBytes(str) {
        return base64.toByteArray(base64clean(str));
    }
    function blitBuffer(src, dst, offset, length) {
        let i;
        for(i = 0; i < length; ++i){
            if (i + offset >= dst.length || i >= src.length) break;
            dst[i + offset] = src[i];
        }
        return i;
    }
    // ArrayBuffer or Uint8Array objects from other contexts (i.e. iframes) do not pass
    // the `instanceof` check but they should be treated as of that type.
    // See: https://github.com/feross/buffer/issues/166
    function isInstance(obj, type) {
        return obj instanceof type || obj != null && obj.constructor != null && obj.constructor.name != null && obj.constructor.name === type.name;
    }
    function numberIsNaN(obj) {
        // For IE11 support
        return obj !== obj // eslint-disable-line no-self-compare
        ;
    }
    // Create lookup table for `toString('hex')`
    // See: https://github.com/feross/buffer/issues/219
    const hexSliceLookupTable = function() {
        const alphabet = "0123456789abcdef";
        const table = new Array(256);
        for(let i = 0; i < 16; ++i){
            const i16 = i * 16;
            for(let j = 0; j < 16; ++j)table[i16 + j] = alphabet[i] + alphabet[j];
        }
        return table;
    }();
    // Return not function with Error if BigInt not supported
    function defineBigIntMethod(fn) {
        return typeof BigInt === "undefined" ? BufferBigIntNotDefined : fn;
    }
    function BufferBigIntNotDefined() {
        throw new Error("BigInt not supported");
    }
})($9bb3b775df4f8b9f$var$buffer);
var $9bb3b775df4f8b9f$var$global$1 = typeof $parcel$global !== "undefined" ? $parcel$global : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {};
var $9bb3b775df4f8b9f$var$inherits;
if (typeof Object.create === "function") $9bb3b775df4f8b9f$var$inherits = function inherits(ctor, superCtor) {
    // implementation from standard node.js 'util' module
    ctor.super_ = superCtor;
    ctor.prototype = Object.create(superCtor.prototype, {
        constructor: {
            value: ctor,
            enumerable: false,
            writable: true,
            configurable: true
        }
    });
};
else $9bb3b775df4f8b9f$var$inherits = function inherits(ctor, superCtor) {
    ctor.super_ = superCtor;
    var TempCtor = function() {};
    TempCtor.prototype = superCtor.prototype;
    ctor.prototype = new TempCtor();
    ctor.prototype.constructor = ctor;
};
var $9bb3b775df4f8b9f$var$inherits$1 = $9bb3b775df4f8b9f$var$inherits;
/**
 * Echos the value of a value. Trys to print the value out
 * in the best way possible given the different types.
 *
 * @param {Object} obj The object to print out.
 * @param {Object} opts Optional options object that alters the output.
 */ /* legacy: obj, showHidden, depth, colors*/ function $9bb3b775df4f8b9f$var$inspect$1(obj, opts) {
    // default options
    var ctx = {
        seen: [],
        stylize: $9bb3b775df4f8b9f$var$stylizeNoColor
    };
    // legacy...
    if (arguments.length >= 3) ctx.depth = arguments[2];
    if (arguments.length >= 4) ctx.colors = arguments[3];
    if ($9bb3b775df4f8b9f$var$isBoolean(opts)) // legacy...
    ctx.showHidden = opts;
    else if (opts) // got an "options" object
    $9bb3b775df4f8b9f$var$_extend(ctx, opts);
    // set default options
    if ($9bb3b775df4f8b9f$var$isUndefined(ctx.showHidden)) ctx.showHidden = false;
    if ($9bb3b775df4f8b9f$var$isUndefined(ctx.depth)) ctx.depth = 2;
    if ($9bb3b775df4f8b9f$var$isUndefined(ctx.colors)) ctx.colors = false;
    if ($9bb3b775df4f8b9f$var$isUndefined(ctx.customInspect)) ctx.customInspect = true;
    if (ctx.colors) ctx.stylize = $9bb3b775df4f8b9f$var$stylizeWithColor;
    return $9bb3b775df4f8b9f$var$formatValue(ctx, obj, ctx.depth);
}
// http://en.wikipedia.org/wiki/ANSI_escape_code#graphics
$9bb3b775df4f8b9f$var$inspect$1.colors = {
    "bold": [
        1,
        22
    ],
    "italic": [
        3,
        23
    ],
    "underline": [
        4,
        24
    ],
    "inverse": [
        7,
        27
    ],
    "white": [
        37,
        39
    ],
    "grey": [
        90,
        39
    ],
    "black": [
        30,
        39
    ],
    "blue": [
        34,
        39
    ],
    "cyan": [
        36,
        39
    ],
    "green": [
        32,
        39
    ],
    "magenta": [
        35,
        39
    ],
    "red": [
        31,
        39
    ],
    "yellow": [
        33,
        39
    ]
};
// Don't use 'blue' not visible on cmd.exe
$9bb3b775df4f8b9f$var$inspect$1.styles = {
    "special": "cyan",
    "number": "yellow",
    "boolean": "yellow",
    "undefined": "grey",
    "null": "bold",
    "string": "green",
    "date": "magenta",
    // "name": intentionally not styling
    "regexp": "red"
};
function $9bb3b775df4f8b9f$var$stylizeWithColor(str, styleType) {
    var style = $9bb3b775df4f8b9f$var$inspect$1.styles[styleType];
    if (style) return "\x1b[" + $9bb3b775df4f8b9f$var$inspect$1.colors[style][0] + "m" + str + "\x1b[" + $9bb3b775df4f8b9f$var$inspect$1.colors[style][1] + "m";
    else return str;
}
function $9bb3b775df4f8b9f$var$stylizeNoColor(str, styleType) {
    return str;
}
function $9bb3b775df4f8b9f$var$arrayToHash(array) {
    var hash = {};
    array.forEach(function(val, idx) {
        hash[val] = true;
    });
    return hash;
}
function $9bb3b775df4f8b9f$var$formatValue(ctx, value, recurseTimes) {
    // Provide a hook for user-specified inspect functions.
    // Check that value is an object with an inspect function on it
    if (ctx.customInspect && value && $9bb3b775df4f8b9f$var$isFunction(value.inspect) && // Filter out the util module, it's inspect function is special
    value.inspect !== $9bb3b775df4f8b9f$var$inspect$1 && // Also filter out any prototype objects using the circular check.
    !(value.constructor && value.constructor.prototype === value)) {
        var ret = value.inspect(recurseTimes, ctx);
        if (!$9bb3b775df4f8b9f$var$isString(ret)) ret = $9bb3b775df4f8b9f$var$formatValue(ctx, ret, recurseTimes);
        return ret;
    }
    // Primitive types cannot have properties
    var primitive = $9bb3b775df4f8b9f$var$formatPrimitive(ctx, value);
    if (primitive) return primitive;
    // Look up the keys of the object.
    var keys = Object.keys(value);
    var visibleKeys = $9bb3b775df4f8b9f$var$arrayToHash(keys);
    if (ctx.showHidden) keys = Object.getOwnPropertyNames(value);
    // IE doesn't make error fields non-enumerable
    // http://msdn.microsoft.com/en-us/library/ie/dww52sbt(v=vs.94).aspx
    if ($9bb3b775df4f8b9f$var$isError(value) && (keys.indexOf("message") >= 0 || keys.indexOf("description") >= 0)) return $9bb3b775df4f8b9f$var$formatError(value);
    // Some type of object without properties can be shortcutted.
    if (keys.length === 0) {
        if ($9bb3b775df4f8b9f$var$isFunction(value)) {
            var name = value.name ? ": " + value.name : "";
            return ctx.stylize("[Function" + name + "]", "special");
        }
        if ($9bb3b775df4f8b9f$var$isRegExp(value)) return ctx.stylize(RegExp.prototype.toString.call(value), "regexp");
        if ($9bb3b775df4f8b9f$var$isDate(value)) return ctx.stylize(Date.prototype.toString.call(value), "date");
        if ($9bb3b775df4f8b9f$var$isError(value)) return $9bb3b775df4f8b9f$var$formatError(value);
    }
    var base = "", array = false, braces = [
        "{",
        "}"
    ];
    // Make Array say that they are Array
    if ($9bb3b775df4f8b9f$var$isArray(value)) {
        array = true;
        braces = [
            "[",
            "]"
        ];
    }
    // Make functions say that they are functions
    if ($9bb3b775df4f8b9f$var$isFunction(value)) {
        var n = value.name ? ": " + value.name : "";
        base = " [Function" + n + "]";
    }
    // Make RegExps say that they are RegExps
    if ($9bb3b775df4f8b9f$var$isRegExp(value)) base = " " + RegExp.prototype.toString.call(value);
    // Make dates with properties first say the date
    if ($9bb3b775df4f8b9f$var$isDate(value)) base = " " + Date.prototype.toUTCString.call(value);
    // Make error with message first say the error
    if ($9bb3b775df4f8b9f$var$isError(value)) base = " " + $9bb3b775df4f8b9f$var$formatError(value);
    if (keys.length === 0 && (!array || value.length == 0)) return braces[0] + base + braces[1];
    if (recurseTimes < 0) {
        if ($9bb3b775df4f8b9f$var$isRegExp(value)) return ctx.stylize(RegExp.prototype.toString.call(value), "regexp");
        else return ctx.stylize("[Object]", "special");
    }
    ctx.seen.push(value);
    var output;
    if (array) output = $9bb3b775df4f8b9f$var$formatArray(ctx, value, recurseTimes, visibleKeys, keys);
    else output = keys.map(function(key) {
        return $9bb3b775df4f8b9f$var$formatProperty(ctx, value, recurseTimes, visibleKeys, key, array);
    });
    ctx.seen.pop();
    return $9bb3b775df4f8b9f$var$reduceToSingleString(output, base, braces);
}
function $9bb3b775df4f8b9f$var$formatPrimitive(ctx, value) {
    if ($9bb3b775df4f8b9f$var$isUndefined(value)) return ctx.stylize("undefined", "undefined");
    if ($9bb3b775df4f8b9f$var$isString(value)) {
        var simple = "'" + JSON.stringify(value).replace(/^"|"$/g, "").replace(/'/g, "\\'").replace(/\\"/g, '"') + "'";
        return ctx.stylize(simple, "string");
    }
    if ($9bb3b775df4f8b9f$var$isNumber(value)) return ctx.stylize("" + value, "number");
    if ($9bb3b775df4f8b9f$var$isBoolean(value)) return ctx.stylize("" + value, "boolean");
    // For some reason typeof null is "object", so special case here.
    if ($9bb3b775df4f8b9f$var$isNull(value)) return ctx.stylize("null", "null");
}
function $9bb3b775df4f8b9f$var$formatError(value) {
    return "[" + Error.prototype.toString.call(value) + "]";
}
function $9bb3b775df4f8b9f$var$formatArray(ctx, value, recurseTimes, visibleKeys, keys) {
    var output = [];
    for(var i = 0, l = value.length; i < l; ++i)if ($9bb3b775df4f8b9f$var$hasOwnProperty(value, String(i))) output.push($9bb3b775df4f8b9f$var$formatProperty(ctx, value, recurseTimes, visibleKeys, String(i), true));
    else output.push("");
    keys.forEach(function(key) {
        if (!key.match(/^\d+$/)) output.push($9bb3b775df4f8b9f$var$formatProperty(ctx, value, recurseTimes, visibleKeys, key, true));
    });
    return output;
}
function $9bb3b775df4f8b9f$var$formatProperty(ctx, value, recurseTimes, visibleKeys, key, array) {
    var name, str, desc;
    desc = Object.getOwnPropertyDescriptor(value, key) || {
        value: value[key]
    };
    if (desc.get) {
        if (desc.set) str = ctx.stylize("[Getter/Setter]", "special");
        else str = ctx.stylize("[Getter]", "special");
    } else if (desc.set) str = ctx.stylize("[Setter]", "special");
    if (!$9bb3b775df4f8b9f$var$hasOwnProperty(visibleKeys, key)) name = "[" + key + "]";
    if (!str) {
        if (ctx.seen.indexOf(desc.value) < 0) {
            if ($9bb3b775df4f8b9f$var$isNull(recurseTimes)) str = $9bb3b775df4f8b9f$var$formatValue(ctx, desc.value, null);
            else str = $9bb3b775df4f8b9f$var$formatValue(ctx, desc.value, recurseTimes - 1);
            if (str.indexOf("\n") > -1) {
                if (array) str = str.split("\n").map(function(line) {
                    return "  " + line;
                }).join("\n").substr(2);
                else str = "\n" + str.split("\n").map(function(line) {
                    return "   " + line;
                }).join("\n");
            }
        } else str = ctx.stylize("[Circular]", "special");
    }
    if ($9bb3b775df4f8b9f$var$isUndefined(name)) {
        if (array && key.match(/^\d+$/)) return str;
        name = JSON.stringify("" + key);
        if (name.match(/^"([a-zA-Z_][a-zA-Z_0-9]*)"$/)) {
            name = name.substr(1, name.length - 2);
            name = ctx.stylize(name, "name");
        } else {
            name = name.replace(/'/g, "\\'").replace(/\\"/g, '"').replace(/(^"|"$)/g, "'");
            name = ctx.stylize(name, "string");
        }
    }
    return name + ": " + str;
}
function $9bb3b775df4f8b9f$var$reduceToSingleString(output, base, braces) {
    var length = output.reduce(function(prev, cur) {
        cur.indexOf("\n");
        return prev + cur.replace(/\u001b\[\d\d?m/g, "").length + 1;
    }, 0);
    if (length > 60) return braces[0] + (base === "" ? "" : base + "\n ") + " " + output.join(",\n  ") + " " + braces[1];
    return braces[0] + base + " " + output.join(", ") + " " + braces[1];
}
// NOTE: These type checking functions intentionally don't use `instanceof`
// because it is fragile and can be easily faked with `Object.create()`.
function $9bb3b775df4f8b9f$var$isArray(ar) {
    return Array.isArray(ar);
}
function $9bb3b775df4f8b9f$var$isBoolean(arg) {
    return typeof arg === "boolean";
}
function $9bb3b775df4f8b9f$var$isNull(arg) {
    return arg === null;
}
function $9bb3b775df4f8b9f$var$isNumber(arg) {
    return typeof arg === "number";
}
function $9bb3b775df4f8b9f$var$isString(arg) {
    return typeof arg === "string";
}
function $9bb3b775df4f8b9f$var$isUndefined(arg) {
    return arg === void 0;
}
function $9bb3b775df4f8b9f$var$isRegExp(re) {
    return $9bb3b775df4f8b9f$var$isObject(re) && $9bb3b775df4f8b9f$var$objectToString(re) === "[object RegExp]";
}
function $9bb3b775df4f8b9f$var$isObject(arg) {
    return typeof arg === "object" && arg !== null;
}
function $9bb3b775df4f8b9f$var$isDate(d) {
    return $9bb3b775df4f8b9f$var$isObject(d) && $9bb3b775df4f8b9f$var$objectToString(d) === "[object Date]";
}
function $9bb3b775df4f8b9f$var$isError(e) {
    return $9bb3b775df4f8b9f$var$isObject(e) && ($9bb3b775df4f8b9f$var$objectToString(e) === "[object Error]" || e instanceof Error);
}
function $9bb3b775df4f8b9f$var$isFunction(arg) {
    return typeof arg === "function";
}
function $9bb3b775df4f8b9f$var$isPrimitive(arg) {
    return arg === null || typeof arg === "boolean" || typeof arg === "number" || typeof arg === "string" || typeof arg === "symbol" || // ES6 symbol
    typeof arg === "undefined";
}
function $9bb3b775df4f8b9f$var$objectToString(o) {
    return Object.prototype.toString.call(o);
}
function $9bb3b775df4f8b9f$var$_extend(origin, add) {
    // Don't do anything if add isn't an object
    if (!add || !$9bb3b775df4f8b9f$var$isObject(add)) return origin;
    var keys = Object.keys(add);
    var i = keys.length;
    while(i--)origin[keys[i]] = add[keys[i]];
    return origin;
}
function $9bb3b775df4f8b9f$var$hasOwnProperty(obj, prop) {
    return Object.prototype.hasOwnProperty.call(obj, prop);
}
function $9bb3b775df4f8b9f$var$compare(a, b) {
    if (a === b) return 0;
    var x = a.length;
    var y = b.length;
    for(var i = 0, len = Math.min(x, y); i < len; ++i)if (a[i] !== b[i]) {
        x = a[i];
        y = b[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
}
var $9bb3b775df4f8b9f$var$hasOwn = Object.prototype.hasOwnProperty;
var $9bb3b775df4f8b9f$var$objectKeys = Object.keys || function(obj) {
    var keys = [];
    for(var key in obj)if ($9bb3b775df4f8b9f$var$hasOwn.call(obj, key)) keys.push(key);
    return keys;
};
var $9bb3b775df4f8b9f$var$pSlice = Array.prototype.slice;
var $9bb3b775df4f8b9f$var$_functionsHaveNames;
function $9bb3b775df4f8b9f$var$functionsHaveNames() {
    if (typeof $9bb3b775df4f8b9f$var$_functionsHaveNames !== "undefined") return $9bb3b775df4f8b9f$var$_functionsHaveNames;
    return $9bb3b775df4f8b9f$var$_functionsHaveNames = function() {
        return (function foo() {}).name === "foo";
    }();
}
function $9bb3b775df4f8b9f$var$pToString(obj) {
    return Object.prototype.toString.call(obj);
}
function $9bb3b775df4f8b9f$var$isView(arrbuf) {
    if ($9bb3b775df4f8b9f$var$buffer.isBuffer(arrbuf)) return false;
    if (typeof $9bb3b775df4f8b9f$var$global$1.ArrayBuffer !== "function") return false;
    if (typeof ArrayBuffer.isView === "function") return ArrayBuffer.isView(arrbuf);
    if (!arrbuf) return false;
    if (arrbuf instanceof DataView) return true;
    if (arrbuf.buffer && arrbuf.buffer instanceof ArrayBuffer) return true;
    return false;
}
// 1. The assert module provides functions that throw
// AssertionError's when particular conditions are not met. The
// assert module must conform to the following interface.
function $9bb3b775df4f8b9f$var$assert(value, message) {
    if (!value) $9bb3b775df4f8b9f$var$fail(value, true, message, "==", $9bb3b775df4f8b9f$var$ok);
}
// 2. The AssertionError is defined in assert.
// new assert.AssertionError({ message: message,
//                             actual: actual,
//                             expected: expected })
var $9bb3b775df4f8b9f$var$regex = /\s*function\s+([^\(\s]*)\s*/;
// based on https://github.com/ljharb/function.prototype.name/blob/adeeeec8bfcc6068b187d7d9fb3d5bb1d3a30899/implementation.js
function $9bb3b775df4f8b9f$var$getName(func) {
    if (!$9bb3b775df4f8b9f$var$isFunction(func)) return;
    if ($9bb3b775df4f8b9f$var$functionsHaveNames()) return func.name;
    var str = func.toString();
    var match = str.match($9bb3b775df4f8b9f$var$regex);
    return match && match[1];
}
$9bb3b775df4f8b9f$var$assert.AssertionError = $9bb3b775df4f8b9f$var$AssertionError;
function $9bb3b775df4f8b9f$var$AssertionError(options) {
    this.name = "AssertionError";
    this.actual = options.actual;
    this.expected = options.expected;
    this.operator = options.operator;
    if (options.message) {
        this.message = options.message;
        this.generatedMessage = false;
    } else {
        this.message = $9bb3b775df4f8b9f$var$getMessage(this);
        this.generatedMessage = true;
    }
    var stackStartFunction = options.stackStartFunction || $9bb3b775df4f8b9f$var$fail;
    if (Error.captureStackTrace) Error.captureStackTrace(this, stackStartFunction);
    else {
        // non v8 browsers so we can have a stacktrace
        var err = new Error();
        if (err.stack) {
            var out = err.stack;
            // try to strip useless frames
            var fn_name = $9bb3b775df4f8b9f$var$getName(stackStartFunction);
            var idx = out.indexOf("\n" + fn_name);
            if (idx >= 0) {
                // once we have located the function frame
                // we need to strip out everything before it (and its line)
                var next_line = out.indexOf("\n", idx + 1);
                out = out.substring(next_line + 1);
            }
            this.stack = out;
        }
    }
}
// assert.AssertionError instanceof Error
$9bb3b775df4f8b9f$var$inherits$1($9bb3b775df4f8b9f$var$AssertionError, Error);
function $9bb3b775df4f8b9f$var$truncate(s, n) {
    if (typeof s === "string") return s.length < n ? s : s.slice(0, n);
    else return s;
}
function $9bb3b775df4f8b9f$var$inspect(something) {
    if ($9bb3b775df4f8b9f$var$functionsHaveNames() || !$9bb3b775df4f8b9f$var$isFunction(something)) return $9bb3b775df4f8b9f$var$inspect$1(something);
    var rawname = $9bb3b775df4f8b9f$var$getName(something);
    var name = rawname ? ": " + rawname : "";
    return "[Function" + name + "]";
}
function $9bb3b775df4f8b9f$var$getMessage(self1) {
    return $9bb3b775df4f8b9f$var$truncate($9bb3b775df4f8b9f$var$inspect(self1.actual), 128) + " " + self1.operator + " " + $9bb3b775df4f8b9f$var$truncate($9bb3b775df4f8b9f$var$inspect(self1.expected), 128);
}
// At present only the three keys mentioned above are used and
// understood by the spec. Implementations or sub modules can pass
// other keys to the AssertionError's constructor - they will be
// ignored.
// 3. All of the following functions must throw an AssertionError
// when a corresponding condition is not met, with a message that
// may be undefined if not provided.  All assertion methods provide
// both the actual and expected values to the assertion error for
// display purposes.
function $9bb3b775df4f8b9f$var$fail(actual, expected, message, operator, stackStartFunction) {
    throw new $9bb3b775df4f8b9f$var$AssertionError({
        message: message,
        actual: actual,
        expected: expected,
        operator: operator,
        stackStartFunction: stackStartFunction
    });
}
// EXTENSION! allows for well behaved errors defined elsewhere.
$9bb3b775df4f8b9f$var$assert.fail = $9bb3b775df4f8b9f$var$fail;
// 4. Pure assertion tests whether a value is truthy, as determined
// by !!guard.
// assert.ok(guard, message_opt);
// This statement is equivalent to assert.equal(true, !!guard,
// message_opt);. To test strictly for the value true, use
// assert.strictEqual(true, guard, message_opt);.
function $9bb3b775df4f8b9f$var$ok(value, message) {
    if (!value) $9bb3b775df4f8b9f$var$fail(value, true, message, "==", $9bb3b775df4f8b9f$var$ok);
}
$9bb3b775df4f8b9f$var$assert.ok = $9bb3b775df4f8b9f$var$ok;
// 5. The equality assertion tests shallow, coercive equality with
// ==.
// assert.equal(actual, expected, message_opt);
$9bb3b775df4f8b9f$var$assert.equal = $9bb3b775df4f8b9f$var$equal;
function $9bb3b775df4f8b9f$var$equal(actual, expected, message) {
    if (actual != expected) $9bb3b775df4f8b9f$var$fail(actual, expected, message, "==", $9bb3b775df4f8b9f$var$equal);
}
// 6. The non-equality assertion tests for whether two objects are not equal
// with != assert.notEqual(actual, expected, message_opt);
$9bb3b775df4f8b9f$var$assert.notEqual = $9bb3b775df4f8b9f$var$notEqual;
function $9bb3b775df4f8b9f$var$notEqual(actual, expected, message) {
    if (actual == expected) $9bb3b775df4f8b9f$var$fail(actual, expected, message, "!=", $9bb3b775df4f8b9f$var$notEqual);
}
// 7. The equivalence assertion tests a deep equality relation.
// assert.deepEqual(actual, expected, message_opt);
$9bb3b775df4f8b9f$var$assert.deepEqual = $9bb3b775df4f8b9f$var$deepEqual;
function $9bb3b775df4f8b9f$var$deepEqual(actual, expected, message) {
    if (!$9bb3b775df4f8b9f$var$_deepEqual(actual, expected, false)) $9bb3b775df4f8b9f$var$fail(actual, expected, message, "deepEqual", $9bb3b775df4f8b9f$var$deepEqual);
}
$9bb3b775df4f8b9f$var$assert.deepStrictEqual = $9bb3b775df4f8b9f$var$deepStrictEqual;
function $9bb3b775df4f8b9f$var$deepStrictEqual(actual, expected, message) {
    if (!$9bb3b775df4f8b9f$var$_deepEqual(actual, expected, true)) $9bb3b775df4f8b9f$var$fail(actual, expected, message, "deepStrictEqual", $9bb3b775df4f8b9f$var$deepStrictEqual);
}
function $9bb3b775df4f8b9f$var$_deepEqual(actual, expected, strict, memos) {
    // 7.1. All identical values are equivalent, as determined by ===.
    if (actual === expected) return true;
    else if ($9bb3b775df4f8b9f$var$buffer.isBuffer(actual) && $9bb3b775df4f8b9f$var$buffer.isBuffer(expected)) return $9bb3b775df4f8b9f$var$compare(actual, expected) === 0;
    else if ($9bb3b775df4f8b9f$var$isDate(actual) && $9bb3b775df4f8b9f$var$isDate(expected)) return actual.getTime() === expected.getTime();
    else if ($9bb3b775df4f8b9f$var$isRegExp(actual) && $9bb3b775df4f8b9f$var$isRegExp(expected)) return actual.source === expected.source && actual.global === expected.global && actual.multiline === expected.multiline && actual.lastIndex === expected.lastIndex && actual.ignoreCase === expected.ignoreCase;
    else if ((actual === null || typeof actual !== "object") && (expected === null || typeof expected !== "object")) return strict ? actual === expected : actual == expected;
    else if ($9bb3b775df4f8b9f$var$isView(actual) && $9bb3b775df4f8b9f$var$isView(expected) && $9bb3b775df4f8b9f$var$pToString(actual) === $9bb3b775df4f8b9f$var$pToString(expected) && !(actual instanceof Float32Array || actual instanceof Float64Array)) return $9bb3b775df4f8b9f$var$compare(new Uint8Array(actual.buffer), new Uint8Array(expected.buffer)) === 0;
    else if ($9bb3b775df4f8b9f$var$buffer.isBuffer(actual) !== $9bb3b775df4f8b9f$var$buffer.isBuffer(expected)) return false;
    else {
        memos = memos || {
            actual: [],
            expected: []
        };
        var actualIndex = memos.actual.indexOf(actual);
        if (actualIndex !== -1) {
            if (actualIndex === memos.expected.indexOf(expected)) return true;
        }
        memos.actual.push(actual);
        memos.expected.push(expected);
        return $9bb3b775df4f8b9f$var$objEquiv(actual, expected, strict, memos);
    }
}
function $9bb3b775df4f8b9f$var$isArguments(object) {
    return Object.prototype.toString.call(object) == "[object Arguments]";
}
function $9bb3b775df4f8b9f$var$objEquiv(a, b, strict, actualVisitedObjects) {
    if (a === null || a === undefined || b === null || b === undefined) return false;
    // if one is a primitive, the other must be same
    if ($9bb3b775df4f8b9f$var$isPrimitive(a) || $9bb3b775df4f8b9f$var$isPrimitive(b)) return a === b;
    if (strict && Object.getPrototypeOf(a) !== Object.getPrototypeOf(b)) return false;
    var aIsArgs = $9bb3b775df4f8b9f$var$isArguments(a);
    var bIsArgs = $9bb3b775df4f8b9f$var$isArguments(b);
    if (aIsArgs && !bIsArgs || !aIsArgs && bIsArgs) return false;
    if (aIsArgs) {
        a = $9bb3b775df4f8b9f$var$pSlice.call(a);
        b = $9bb3b775df4f8b9f$var$pSlice.call(b);
        return $9bb3b775df4f8b9f$var$_deepEqual(a, b, strict);
    }
    var ka = $9bb3b775df4f8b9f$var$objectKeys(a);
    var kb = $9bb3b775df4f8b9f$var$objectKeys(b);
    var key, i;
    // having the same number of owned properties (keys incorporates
    // hasOwnProperty)
    if (ka.length !== kb.length) return false;
    //the same set of keys (although not necessarily the same order),
    ka.sort();
    kb.sort();
    //~~~cheap key test
    for(i = ka.length - 1; i >= 0; i--){
        if (ka[i] !== kb[i]) return false;
    }
    //equivalent values for every corresponding key, and
    //~~~possibly expensive deep test
    for(i = ka.length - 1; i >= 0; i--){
        key = ka[i];
        if (!$9bb3b775df4f8b9f$var$_deepEqual(a[key], b[key], strict, actualVisitedObjects)) return false;
    }
    return true;
}
// 8. The non-equivalence assertion tests for any deep inequality.
// assert.notDeepEqual(actual, expected, message_opt);
$9bb3b775df4f8b9f$var$assert.notDeepEqual = $9bb3b775df4f8b9f$var$notDeepEqual;
function $9bb3b775df4f8b9f$var$notDeepEqual(actual, expected, message) {
    if ($9bb3b775df4f8b9f$var$_deepEqual(actual, expected, false)) $9bb3b775df4f8b9f$var$fail(actual, expected, message, "notDeepEqual", $9bb3b775df4f8b9f$var$notDeepEqual);
}
$9bb3b775df4f8b9f$var$assert.notDeepStrictEqual = $9bb3b775df4f8b9f$var$notDeepStrictEqual;
function $9bb3b775df4f8b9f$var$notDeepStrictEqual(actual, expected, message) {
    if ($9bb3b775df4f8b9f$var$_deepEqual(actual, expected, true)) $9bb3b775df4f8b9f$var$fail(actual, expected, message, "notDeepStrictEqual", $9bb3b775df4f8b9f$var$notDeepStrictEqual);
}
// 9. The strict equality assertion tests strict equality, as determined by ===.
// assert.strictEqual(actual, expected, message_opt);
$9bb3b775df4f8b9f$var$assert.strictEqual = $9bb3b775df4f8b9f$var$strictEqual;
function $9bb3b775df4f8b9f$var$strictEqual(actual, expected, message) {
    if (actual !== expected) $9bb3b775df4f8b9f$var$fail(actual, expected, message, "===", $9bb3b775df4f8b9f$var$strictEqual);
}
// 10. The strict non-equality assertion tests for strict inequality, as
// determined by !==.  assert.notStrictEqual(actual, expected, message_opt);
$9bb3b775df4f8b9f$var$assert.notStrictEqual = $9bb3b775df4f8b9f$var$notStrictEqual;
function $9bb3b775df4f8b9f$var$notStrictEqual(actual, expected, message) {
    if (actual === expected) $9bb3b775df4f8b9f$var$fail(actual, expected, message, "!==", $9bb3b775df4f8b9f$var$notStrictEqual);
}
function $9bb3b775df4f8b9f$var$expectedException(actual, expected) {
    if (!actual || !expected) return false;
    if (Object.prototype.toString.call(expected) == "[object RegExp]") return expected.test(actual);
    try {
        if (actual instanceof expected) return true;
    } catch (e) {
    // Ignore.  The instanceof check doesn't work for arrow functions.
    }
    if (Error.isPrototypeOf(expected)) return false;
    return expected.call({}, actual) === true;
}
function $9bb3b775df4f8b9f$var$_tryBlock(block) {
    var error;
    try {
        block();
    } catch (e) {
        error = e;
    }
    return error;
}
function $9bb3b775df4f8b9f$var$_throws(shouldThrow, block, expected, message) {
    var actual;
    if (typeof block !== "function") throw new TypeError('"block" argument must be a function');
    if (typeof expected === "string") {
        message = expected;
        expected = null;
    }
    actual = $9bb3b775df4f8b9f$var$_tryBlock(block);
    message = (expected && expected.name ? " (" + expected.name + ")." : ".") + (message ? " " + message : ".");
    if (shouldThrow && !actual) $9bb3b775df4f8b9f$var$fail(actual, expected, "Missing expected exception" + message);
    var userProvidedMessage = typeof message === "string";
    var isUnwantedException = !shouldThrow && $9bb3b775df4f8b9f$var$isError(actual);
    var isUnexpectedException = !shouldThrow && actual && !expected;
    if (isUnwantedException && userProvidedMessage && $9bb3b775df4f8b9f$var$expectedException(actual, expected) || isUnexpectedException) $9bb3b775df4f8b9f$var$fail(actual, expected, "Got unwanted exception" + message);
    if (shouldThrow && actual && expected && !$9bb3b775df4f8b9f$var$expectedException(actual, expected) || !shouldThrow && actual) throw actual;
}
// 11. Expected to throw an error:
// assert.throws(block, Error_opt, message_opt);
$9bb3b775df4f8b9f$var$assert.throws = $9bb3b775df4f8b9f$var$throws;
function $9bb3b775df4f8b9f$var$throws(block, /*optional*/ error, /*optional*/ message) {
    $9bb3b775df4f8b9f$var$_throws(true, block, error, message);
}
// EXTENSION! This is annoying to write outside this module.
$9bb3b775df4f8b9f$var$assert.doesNotThrow = $9bb3b775df4f8b9f$var$doesNotThrow;
function $9bb3b775df4f8b9f$var$doesNotThrow(block, /*optional*/ error, /*optional*/ message) {
    $9bb3b775df4f8b9f$var$_throws(false, block, error, message);
}
$9bb3b775df4f8b9f$var$assert.ifError = $9bb3b775df4f8b9f$var$ifError;
function $9bb3b775df4f8b9f$var$ifError(err) {
    if (err) throw err;
}
var $9bb3b775df4f8b9f$var$Layout$1 = {};
/**
 * Base class for layout objects.
 *
 * **NOTE** This is an abstract base class; you can create instances
 * if it amuses you, but they won't support the {@link
 * Layout#encode|encode} or {@link Layout#decode|decode} functions.
 *
 * @param {Number} span - Initializer for {@link Layout#span|span}.  The
 * parameter must be an integer; a negative value signifies that the
 * span is {@link Layout#getSpan|value-specific}.
 *
 * @param {string} [property] - Initializer for {@link
 * Layout#property|property}.
 *
 * @abstract
 */ class $9bb3b775df4f8b9f$var$Layout {
    constructor(span, property){
        if (!Number.isInteger(span)) throw new TypeError("span must be an integer");
        /** The span of the layout in bytes.
     *
     * Positive values are generally expected.
     *
     * Zero will only appear in {@link Constant}s and in {@link
     * Sequence}s where the {@link Sequence#count|count} is zero.
     *
     * A negative value indicates that the span is value-specific, and
     * must be obtained using {@link Layout#getSpan|getSpan}. */ this.span = span;
        /** The property name used when this layout is represented in an
     * Object.
     *
     * Used only for layouts that {@link Layout#decode|decode} to Object
     * instances.  If left undefined the span of the unnamed layout will
     * be treated as padding: it will not be mutated by {@link
     * Layout#encode|encode} nor represented as a property in the
     * decoded Object. */ this.property = property;
    }
    /** Function to create an Object into which decoded properties will
   * be written.
   *
   * Used only for layouts that {@link Layout#decode|decode} to Object
   * instances, which means:
   * * {@link Structure}
   * * {@link Union}
   * * {@link VariantLayout}
   * * {@link BitStructure}
   *
   * If left undefined the JavaScript representation of these layouts
   * will be Object instances.
   *
   * See {@link bindConstructorLayout}.
   */ makeDestinationObject() {
        return {};
    }
    /**
   * Decode from a Buffer into an JavaScript value.
   *
   * @param {Buffer} b - the buffer from which encoded data is read.
   *
   * @param {Number} [offset] - the offset at which the encoded data
   * starts.  If absent a zero offset is inferred.
   *
   * @returns {(Number|Array|Object)} - the value of the decoded data.
   *
   * @abstract
   */ decode(b, offset) {
        throw new Error("Layout is abstract");
    }
    /**
   * Encode a JavaScript value into a Buffer.
   *
   * @param {(Number|Array|Object)} src - the value to be encoded into
   * the buffer.  The type accepted depends on the (sub-)type of {@link
   * Layout}.
   *
   * @param {Buffer} b - the buffer into which encoded data will be
   * written.
   *
   * @param {Number} [offset] - the offset at which the encoded data
   * starts.  If absent a zero offset is inferred.
   *
   * @returns {Number} - the number of bytes encoded, including the
   * space skipped for internal padding, but excluding data such as
   * {@link Sequence#count|lengths} when stored {@link
   * ExternalLayout|externally}.  This is the adjustment to `offset`
   * producing the offset where data for the next layout would be
   * written.
   *
   * @abstract
   */ encode(src, b, offset) {
        throw new Error("Layout is abstract");
    }
    /**
   * Calculate the span of a specific instance of a layout.
   *
   * @param {Buffer} b - the buffer that contains an encoded instance.
   *
   * @param {Number} [offset] - the offset at which the encoded instance
   * starts.  If absent a zero offset is inferred.
   *
   * @return {Number} - the number of bytes covered by the layout
   * instance.  If this method is not overridden in a subclass the
   * definition-time constant {@link Layout#span|span} will be
   * returned.
   *
   * @throws {RangeError} - if the length of the value cannot be
   * determined.
   */ getSpan(b, offset) {
        if (0 > this.span) throw new RangeError("indeterminate span");
        return this.span;
    }
    /**
   * Replicate the layout using a new property.
   *
   * This function must be used to get a structurally-equivalent layout
   * with a different name since all {@link Layout} instances are
   * immutable.
   *
   * **NOTE** This is a shallow copy.  All fields except {@link
   * Layout#property|property} are strictly equal to the origin layout.
   *
   * @param {String} property - the value for {@link
   * Layout#property|property} in the replica.
   *
   * @returns {Layout} - the copy with {@link Layout#property|property}
   * set to `property`.
   */ replicate(property) {
        const rv = Object.create(this.constructor.prototype);
        Object.assign(rv, this);
        rv.property = property;
        return rv;
    }
    /**
   * Create an object from layout properties and an array of values.
   *
   * **NOTE** This function returns `undefined` if invoked on a layout
   * that does not return its value as an Object.  Objects are
   * returned for things that are a {@link Structure}, which includes
   * {@link VariantLayout|variant layouts} if they are structures, and
   * excludes {@link Union}s.  If you want this feature for a union
   * you must use {@link Union.getVariant|getVariant} to select the
   * desired layout.
   *
   * @param {Array} values - an array of values that correspond to the
   * default order for properties.  As with {@link Layout#decode|decode}
   * layout elements that have no property name are skipped when
   * iterating over the array values.  Only the top-level properties are
   * assigned; arguments are not assigned to properties of contained
   * layouts.  Any unused values are ignored.
   *
   * @return {(Object|undefined)}
   */ fromArray(values) {
        return undefined;
    }
}
$9bb3b775df4f8b9f$var$Layout$1.Layout = $9bb3b775df4f8b9f$var$Layout;
/* Provide text that carries a name (such as for a function that will
 * be throwing an error) annotated with the property of a given layout
 * (such as one for which the value was unacceptable).
 *
 * @ignore */ function $9bb3b775df4f8b9f$var$nameWithProperty(name, lo) {
    if (lo.property) return name + "[" + lo.property + "]";
    return name;
}
$9bb3b775df4f8b9f$var$Layout$1.nameWithProperty = $9bb3b775df4f8b9f$var$nameWithProperty;
/**
 * Augment a class so that instances can be encoded/decoded using a
 * given layout.
 *
 * Calling this function couples `Class` with `layout` in several ways:
 *
 * * `Class.layout_` becomes a static member property equal to `layout`;
 * * `layout.boundConstructor_` becomes a static member property equal
 *    to `Class`;
 * * The {@link Layout#makeDestinationObject|makeDestinationObject()}
 *   property of `layout` is set to a function that returns a `new
 *   Class()`;
 * * `Class.decode(b, offset)` becomes a static member function that
 *   delegates to {@link Layout#decode|layout.decode}.  The
 *   synthesized function may be captured and extended.
 * * `Class.prototype.encode(b, offset)` provides an instance member
 *   function that delegates to {@link Layout#encode|layout.encode}
 *   with `src` set to `this`.  The synthesized function may be
 *   captured and extended, but when the extension is invoked `this`
 *   must be explicitly bound to the instance.
 *
 * @param {class} Class - a JavaScript class with a nullary
 * constructor.
 *
 * @param {Layout} layout - the {@link Layout} instance used to encode
 * instances of `Class`.
 */ function $9bb3b775df4f8b9f$var$bindConstructorLayout(Class, layout) {
    if ("function" !== typeof Class) throw new TypeError("Class must be constructor");
    if (Class.hasOwnProperty("layout_")) throw new Error("Class is already bound to a layout");
    if (!(layout && layout instanceof $9bb3b775df4f8b9f$var$Layout)) throw new TypeError("layout must be a Layout");
    if (layout.hasOwnProperty("boundConstructor_")) throw new Error("layout is already bound to a constructor");
    Class.layout_ = layout;
    layout.boundConstructor_ = Class;
    layout.makeDestinationObject = ()=>new Class();
    Object.defineProperty(Class.prototype, "encode", {
        value: function(b, offset) {
            return layout.encode(this, b, offset);
        },
        writable: true
    });
    Object.defineProperty(Class, "decode", {
        value: function(b, offset) {
            return layout.decode(b, offset);
        },
        writable: true
    });
}
$9bb3b775df4f8b9f$var$Layout$1.bindConstructorLayout = $9bb3b775df4f8b9f$var$bindConstructorLayout;
/**
 * An object that behaves like a layout but does not consume space
 * within its containing layout.
 *
 * This is primarily used to obtain metadata about a member, such as a
 * {@link OffsetLayout} that can provide data about a {@link
 * Layout#getSpan|value-specific span}.
 *
 * **NOTE** This is an abstract base class; you can create instances
 * if it amuses you, but they won't support {@link
 * ExternalLayout#isCount|isCount} or other {@link Layout} functions.
 *
 * @param {Number} span - initializer for {@link Layout#span|span}.
 * The parameter can range from 1 through 6.
 *
 * @param {string} [property] - initializer for {@link
 * Layout#property|property}.
 *
 * @abstract
 * @augments {Layout}
 */ class $9bb3b775df4f8b9f$var$ExternalLayout extends $9bb3b775df4f8b9f$var$Layout {
    /**
   * Return `true` iff the external layout decodes to an unsigned
   * integer layout.
   *
   * In that case it can be used as the source of {@link
   * Sequence#count|Sequence counts}, {@link Blob#length|Blob lengths},
   * or as {@link UnionLayoutDiscriminator#layout|external union
   * discriminators}.
   *
   * @abstract
   */ isCount() {
        throw new Error("ExternalLayout is abstract");
    }
}
/**
 * An {@link ExternalLayout} that determines its {@link
 * Layout#decode|value} based on offset into and length of the buffer
 * on which it is invoked.
 *
 * *Factory*: {@link module:Layout.greedy|greedy}
 *
 * @param {Number} [elementSpan] - initializer for {@link
 * GreedyCount#elementSpan|elementSpan}.
 *
 * @param {string} [property] - initializer for {@link
 * Layout#property|property}.
 *
 * @augments {ExternalLayout}
 */ class $9bb3b775df4f8b9f$var$GreedyCount extends $9bb3b775df4f8b9f$var$ExternalLayout {
    constructor(elementSpan, property){
        if (undefined === elementSpan) elementSpan = 1;
        if (!Number.isInteger(elementSpan) || 0 >= elementSpan) throw new TypeError("elementSpan must be a (positive) integer");
        super(-1, property);
        /** The layout for individual elements of the sequence.  The value
     * must be a positive integer.  If not provided, the value will be
     * 1. */ this.elementSpan = elementSpan;
    }
    /** @override */ isCount() {
        return true;
    }
    /** @override */ decode(b, offset) {
        if (undefined === offset) offset = 0;
        const rem = b.length - offset;
        return Math.floor(rem / this.elementSpan);
    }
    /** @override */ encode(src, b, offset) {
        return 0;
    }
}
/**
 * An {@link ExternalLayout} that supports accessing a {@link Layout}
 * at a fixed offset from the start of another Layout.  The offset may
 * be before, within, or after the base layout.
 *
 * *Factory*: {@link module:Layout.offset|offset}
 *
 * @param {Layout} layout - initializer for {@link
 * OffsetLayout#layout|layout}, modulo `property`.
 *
 * @param {Number} [offset] - Initializes {@link
 * OffsetLayout#offset|offset}.  Defaults to zero.
 *
 * @param {string} [property] - Optional new property name for a
 * {@link Layout#replicate| replica} of `layout` to be used as {@link
 * OffsetLayout#layout|layout}.  If not provided the `layout` is used
 * unchanged.
 *
 * @augments {Layout}
 */ class $9bb3b775df4f8b9f$var$OffsetLayout extends $9bb3b775df4f8b9f$var$ExternalLayout {
    constructor(layout, offset, property){
        if (!(layout instanceof $9bb3b775df4f8b9f$var$Layout)) throw new TypeError("layout must be a Layout");
        if (undefined === offset) offset = 0;
        else if (!Number.isInteger(offset)) throw new TypeError("offset must be integer or undefined");
        super(layout.span, property || layout.property);
        /** The subordinated layout. */ this.layout = layout;
        /** The location of {@link OffsetLayout#layout} relative to the
     * start of another layout.
     *
     * The value may be positive or negative, but an error will thrown
     * if at the point of use it goes outside the span of the Buffer
     * being accessed.  */ this.offset = offset;
    }
    /** @override */ isCount() {
        return this.layout instanceof $9bb3b775df4f8b9f$var$UInt || this.layout instanceof $9bb3b775df4f8b9f$var$UIntBE;
    }
    /** @override */ decode(b, offset) {
        if (undefined === offset) offset = 0;
        return this.layout.decode(b, offset + this.offset);
    }
    /** @override */ encode(src, b, offset) {
        if (undefined === offset) offset = 0;
        return this.layout.encode(src, b, offset + this.offset);
    }
}
/**
 * Represent an unsigned integer in little-endian format.
 *
 * *Factory*: {@link module:Layout.u8|u8}, {@link
 *  module:Layout.u16|u16}, {@link module:Layout.u24|u24}, {@link
 *  module:Layout.u32|u32}, {@link module:Layout.u40|u40}, {@link
 *  module:Layout.u48|u48}
 *
 * @param {Number} span - initializer for {@link Layout#span|span}.
 * The parameter can range from 1 through 6.
 *
 * @param {string} [property] - initializer for {@link
 * Layout#property|property}.
 *
 * @augments {Layout}
 */ class $9bb3b775df4f8b9f$var$UInt extends $9bb3b775df4f8b9f$var$Layout {
    constructor(span, property){
        super(span, property);
        if (6 < this.span) throw new RangeError("span must not exceed 6 bytes");
    }
    /** @override */ decode(b, offset) {
        if (undefined === offset) offset = 0;
        return b.readUIntLE(offset, this.span);
    }
    /** @override */ encode(src, b, offset) {
        if (undefined === offset) offset = 0;
        b.writeUIntLE(src, offset, this.span);
        return this.span;
    }
}
/**
 * Represent an unsigned integer in big-endian format.
 *
 * *Factory*: {@link module:Layout.u8be|u8be}, {@link
 * module:Layout.u16be|u16be}, {@link module:Layout.u24be|u24be},
 * {@link module:Layout.u32be|u32be}, {@link
 * module:Layout.u40be|u40be}, {@link module:Layout.u48be|u48be}
 *
 * @param {Number} span - initializer for {@link Layout#span|span}.
 * The parameter can range from 1 through 6.
 *
 * @param {string} [property] - initializer for {@link
 * Layout#property|property}.
 *
 * @augments {Layout}
 */ class $9bb3b775df4f8b9f$var$UIntBE extends $9bb3b775df4f8b9f$var$Layout {
    constructor(span, property){
        super(span, property);
        if (6 < this.span) throw new RangeError("span must not exceed 6 bytes");
    }
    /** @override */ decode(b, offset) {
        if (undefined === offset) offset = 0;
        return b.readUIntBE(offset, this.span);
    }
    /** @override */ encode(src, b, offset) {
        if (undefined === offset) offset = 0;
        b.writeUIntBE(src, offset, this.span);
        return this.span;
    }
}
/**
 * Represent a signed integer in little-endian format.
 *
 * *Factory*: {@link module:Layout.s8|s8}, {@link
 *  module:Layout.s16|s16}, {@link module:Layout.s24|s24}, {@link
 *  module:Layout.s32|s32}, {@link module:Layout.s40|s40}, {@link
 *  module:Layout.s48|s48}
 *
 * @param {Number} span - initializer for {@link Layout#span|span}.
 * The parameter can range from 1 through 6.
 *
 * @param {string} [property] - initializer for {@link
 * Layout#property|property}.
 *
 * @augments {Layout}
 */ class $9bb3b775df4f8b9f$var$Int extends $9bb3b775df4f8b9f$var$Layout {
    constructor(span, property){
        super(span, property);
        if (6 < this.span) throw new RangeError("span must not exceed 6 bytes");
    }
    /** @override */ decode(b, offset) {
        if (undefined === offset) offset = 0;
        return b.readIntLE(offset, this.span);
    }
    /** @override */ encode(src, b, offset) {
        if (undefined === offset) offset = 0;
        b.writeIntLE(src, offset, this.span);
        return this.span;
    }
}
/**
 * Represent a signed integer in big-endian format.
 *
 * *Factory*: {@link module:Layout.s8be|s8be}, {@link
 * module:Layout.s16be|s16be}, {@link module:Layout.s24be|s24be},
 * {@link module:Layout.s32be|s32be}, {@link
 * module:Layout.s40be|s40be}, {@link module:Layout.s48be|s48be}
 *
 * @param {Number} span - initializer for {@link Layout#span|span}.
 * The parameter can range from 1 through 6.
 *
 * @param {string} [property] - initializer for {@link
 * Layout#property|property}.
 *
 * @augments {Layout}
 */ class $9bb3b775df4f8b9f$var$IntBE extends $9bb3b775df4f8b9f$var$Layout {
    constructor(span, property){
        super(span, property);
        if (6 < this.span) throw new RangeError("span must not exceed 6 bytes");
    }
    /** @override */ decode(b, offset) {
        if (undefined === offset) offset = 0;
        return b.readIntBE(offset, this.span);
    }
    /** @override */ encode(src, b, offset) {
        if (undefined === offset) offset = 0;
        b.writeIntBE(src, offset, this.span);
        return this.span;
    }
}
const $9bb3b775df4f8b9f$var$V2E32 = Math.pow(2, 32);
/* True modulus high and low 32-bit words, where low word is always
 * non-negative. */ function $9bb3b775df4f8b9f$var$divmodInt64(src) {
    const hi32 = Math.floor(src / $9bb3b775df4f8b9f$var$V2E32);
    const lo32 = src - hi32 * $9bb3b775df4f8b9f$var$V2E32;
    return {
        hi32: hi32,
        lo32: lo32
    };
}
/* Reconstruct Number from quotient and non-negative remainder */ function $9bb3b775df4f8b9f$var$roundedInt64(hi32, lo32) {
    return hi32 * $9bb3b775df4f8b9f$var$V2E32 + lo32;
}
/**
 * Represent an unsigned 64-bit integer in little-endian format when
 * encoded and as a near integral JavaScript Number when decoded.
 *
 * *Factory*: {@link module:Layout.nu64|nu64}
 *
 * **NOTE** Values with magnitude greater than 2^52 may not decode to
 * the exact value of the encoded representation.
 *
 * @augments {Layout}
 */ class $9bb3b775df4f8b9f$var$NearUInt64 extends $9bb3b775df4f8b9f$var$Layout {
    constructor(property){
        super(8, property);
    }
    /** @override */ decode(b, offset) {
        if (undefined === offset) offset = 0;
        const lo32 = b.readUInt32LE(offset);
        const hi32 = b.readUInt32LE(offset + 4);
        return $9bb3b775df4f8b9f$var$roundedInt64(hi32, lo32);
    }
    /** @override */ encode(src, b, offset) {
        if (undefined === offset) offset = 0;
        const split = $9bb3b775df4f8b9f$var$divmodInt64(src);
        b.writeUInt32LE(split.lo32, offset);
        b.writeUInt32LE(split.hi32, offset + 4);
        return 8;
    }
}
/**
 * Represent an unsigned 64-bit integer in big-endian format when
 * encoded and as a near integral JavaScript Number when decoded.
 *
 * *Factory*: {@link module:Layout.nu64be|nu64be}
 *
 * **NOTE** Values with magnitude greater than 2^52 may not decode to
 * the exact value of the encoded representation.
 *
 * @augments {Layout}
 */ class $9bb3b775df4f8b9f$var$NearUInt64BE extends $9bb3b775df4f8b9f$var$Layout {
    constructor(property){
        super(8, property);
    }
    /** @override */ decode(b, offset) {
        if (undefined === offset) offset = 0;
        const hi32 = b.readUInt32BE(offset);
        const lo32 = b.readUInt32BE(offset + 4);
        return $9bb3b775df4f8b9f$var$roundedInt64(hi32, lo32);
    }
    /** @override */ encode(src, b, offset) {
        if (undefined === offset) offset = 0;
        const split = $9bb3b775df4f8b9f$var$divmodInt64(src);
        b.writeUInt32BE(split.hi32, offset);
        b.writeUInt32BE(split.lo32, offset + 4);
        return 8;
    }
}
/**
 * Represent a signed 64-bit integer in little-endian format when
 * encoded and as a near integral JavaScript Number when decoded.
 *
 * *Factory*: {@link module:Layout.ns64|ns64}
 *
 * **NOTE** Values with magnitude greater than 2^52 may not decode to
 * the exact value of the encoded representation.
 *
 * @augments {Layout}
 */ class $9bb3b775df4f8b9f$var$NearInt64 extends $9bb3b775df4f8b9f$var$Layout {
    constructor(property){
        super(8, property);
    }
    /** @override */ decode(b, offset) {
        if (undefined === offset) offset = 0;
        const lo32 = b.readUInt32LE(offset);
        const hi32 = b.readInt32LE(offset + 4);
        return $9bb3b775df4f8b9f$var$roundedInt64(hi32, lo32);
    }
    /** @override */ encode(src, b, offset) {
        if (undefined === offset) offset = 0;
        const split = $9bb3b775df4f8b9f$var$divmodInt64(src);
        b.writeUInt32LE(split.lo32, offset);
        b.writeInt32LE(split.hi32, offset + 4);
        return 8;
    }
}
/**
 * Represent a signed 64-bit integer in big-endian format when
 * encoded and as a near integral JavaScript Number when decoded.
 *
 * *Factory*: {@link module:Layout.ns64be|ns64be}
 *
 * **NOTE** Values with magnitude greater than 2^52 may not decode to
 * the exact value of the encoded representation.
 *
 * @augments {Layout}
 */ class $9bb3b775df4f8b9f$var$NearInt64BE extends $9bb3b775df4f8b9f$var$Layout {
    constructor(property){
        super(8, property);
    }
    /** @override */ decode(b, offset) {
        if (undefined === offset) offset = 0;
        const hi32 = b.readInt32BE(offset);
        const lo32 = b.readUInt32BE(offset + 4);
        return $9bb3b775df4f8b9f$var$roundedInt64(hi32, lo32);
    }
    /** @override */ encode(src, b, offset) {
        if (undefined === offset) offset = 0;
        const split = $9bb3b775df4f8b9f$var$divmodInt64(src);
        b.writeInt32BE(split.hi32, offset);
        b.writeUInt32BE(split.lo32, offset + 4);
        return 8;
    }
}
/**
 * Represent a 32-bit floating point number in little-endian format.
 *
 * *Factory*: {@link module:Layout.f32|f32}
 *
 * @param {string} [property] - initializer for {@link
 * Layout#property|property}.
 *
 * @augments {Layout}
 */ class $9bb3b775df4f8b9f$var$Float extends $9bb3b775df4f8b9f$var$Layout {
    constructor(property){
        super(4, property);
    }
    /** @override */ decode(b, offset) {
        if (undefined === offset) offset = 0;
        return b.readFloatLE(offset);
    }
    /** @override */ encode(src, b, offset) {
        if (undefined === offset) offset = 0;
        b.writeFloatLE(src, offset);
        return 4;
    }
}
/**
 * Represent a 32-bit floating point number in big-endian format.
 *
 * *Factory*: {@link module:Layout.f32be|f32be}
 *
 * @param {string} [property] - initializer for {@link
 * Layout#property|property}.
 *
 * @augments {Layout}
 */ class $9bb3b775df4f8b9f$var$FloatBE extends $9bb3b775df4f8b9f$var$Layout {
    constructor(property){
        super(4, property);
    }
    /** @override */ decode(b, offset) {
        if (undefined === offset) offset = 0;
        return b.readFloatBE(offset);
    }
    /** @override */ encode(src, b, offset) {
        if (undefined === offset) offset = 0;
        b.writeFloatBE(src, offset);
        return 4;
    }
}
/**
 * Represent a 64-bit floating point number in little-endian format.
 *
 * *Factory*: {@link module:Layout.f64|f64}
 *
 * @param {string} [property] - initializer for {@link
 * Layout#property|property}.
 *
 * @augments {Layout}
 */ class $9bb3b775df4f8b9f$var$Double extends $9bb3b775df4f8b9f$var$Layout {
    constructor(property){
        super(8, property);
    }
    /** @override */ decode(b, offset) {
        if (undefined === offset) offset = 0;
        return b.readDoubleLE(offset);
    }
    /** @override */ encode(src, b, offset) {
        if (undefined === offset) offset = 0;
        b.writeDoubleLE(src, offset);
        return 8;
    }
}
/**
 * Represent a 64-bit floating point number in big-endian format.
 *
 * *Factory*: {@link module:Layout.f64be|f64be}
 *
 * @param {string} [property] - initializer for {@link
 * Layout#property|property}.
 *
 * @augments {Layout}
 */ class $9bb3b775df4f8b9f$var$DoubleBE extends $9bb3b775df4f8b9f$var$Layout {
    constructor(property){
        super(8, property);
    }
    /** @override */ decode(b, offset) {
        if (undefined === offset) offset = 0;
        return b.readDoubleBE(offset);
    }
    /** @override */ encode(src, b, offset) {
        if (undefined === offset) offset = 0;
        b.writeDoubleBE(src, offset);
        return 8;
    }
}
/**
 * Represent a contiguous sequence of a specific layout as an Array.
 *
 * *Factory*: {@link module:Layout.seq|seq}
 *
 * @param {Layout} elementLayout - initializer for {@link
 * Sequence#elementLayout|elementLayout}.
 *
 * @param {(Number|ExternalLayout)} count - initializer for {@link
 * Sequence#count|count}.  The parameter must be either a positive
 * integer or an instance of {@link ExternalLayout}.
 *
 * @param {string} [property] - initializer for {@link
 * Layout#property|property}.
 *
 * @augments {Layout}
 */ class $9bb3b775df4f8b9f$var$Sequence extends $9bb3b775df4f8b9f$var$Layout {
    constructor(elementLayout, count, property){
        if (!(elementLayout instanceof $9bb3b775df4f8b9f$var$Layout)) throw new TypeError("elementLayout must be a Layout");
        if (!(count instanceof $9bb3b775df4f8b9f$var$ExternalLayout && count.isCount() || Number.isInteger(count) && 0 <= count)) throw new TypeError("count must be non-negative integer or an unsigned integer ExternalLayout");
        let span = -1;
        if (!(count instanceof $9bb3b775df4f8b9f$var$ExternalLayout) && 0 < elementLayout.span) span = count * elementLayout.span;
        super(span, property);
        /** The layout for individual elements of the sequence. */ this.elementLayout = elementLayout;
        /** The number of elements in the sequence.
     *
     * This will be either a non-negative integer or an instance of
     * {@link ExternalLayout} for which {@link
     * ExternalLayout#isCount|isCount()} is `true`. */ this.count = count;
    }
    /** @override */ getSpan(b, offset) {
        if (0 <= this.span) return this.span;
        if (undefined === offset) offset = 0;
        let span = 0;
        let count = this.count;
        if (count instanceof $9bb3b775df4f8b9f$var$ExternalLayout) count = count.decode(b, offset);
        if (0 < this.elementLayout.span) span = count * this.elementLayout.span;
        else {
            let idx = 0;
            while(idx < count){
                span += this.elementLayout.getSpan(b, offset + span);
                ++idx;
            }
        }
        return span;
    }
    /** @override */ decode(b, offset) {
        if (undefined === offset) offset = 0;
        const rv = [];
        let i = 0;
        let count = this.count;
        if (count instanceof $9bb3b775df4f8b9f$var$ExternalLayout) count = count.decode(b, offset);
        while(i < count){
            rv.push(this.elementLayout.decode(b, offset));
            offset += this.elementLayout.getSpan(b, offset);
            i += 1;
        }
        return rv;
    }
    /** Implement {@link Layout#encode|encode} for {@link Sequence}.
   *
   * **NOTE** If `src` is shorter than {@link Sequence#count|count} then
   * the unused space in the buffer is left unchanged.  If `src` is
   * longer than {@link Sequence#count|count} the unneeded elements are
   * ignored.
   *
   * **NOTE** If {@link Layout#count|count} is an instance of {@link
   * ExternalLayout} then the length of `src` will be encoded as the
   * count after `src` is encoded. */ encode(src, b, offset) {
        if (undefined === offset) offset = 0;
        const elo = this.elementLayout;
        const span = src.reduce((span, v)=>{
            return span + elo.encode(v, b, offset + span);
        }, 0);
        if (this.count instanceof $9bb3b775df4f8b9f$var$ExternalLayout) this.count.encode(src.length, b, offset);
        return span;
    }
}
/**
 * Represent a contiguous sequence of arbitrary layout elements as an
 * Object.
 *
 * *Factory*: {@link module:Layout.struct|struct}
 *
 * **NOTE** The {@link Layout#span|span} of the structure is variable
 * if any layout in {@link Structure#fields|fields} has a variable
 * span.  When {@link Layout#encode|encoding} we must have a value for
 * all variable-length fields, or we wouldn't be able to figure out
 * how much space to use for storage.  We can only identify the value
 * for a field when it has a {@link Layout#property|property}.  As
 * such, although a structure may contain both unnamed fields and
 * variable-length fields, it cannot contain an unnamed
 * variable-length field.
 *
 * @param {Layout[]} fields - initializer for {@link
 * Structure#fields|fields}.  An error is raised if this contains a
 * variable-length field for which a {@link Layout#property|property}
 * is not defined.
 *
 * @param {string} [property] - initializer for {@link
 * Layout#property|property}.
 *
 * @param {Boolean} [decodePrefixes] - initializer for {@link
 * Structure#decodePrefixes|property}.
 *
 * @throws {Error} - if `fields` contains an unnamed variable-length
 * layout.
 *
 * @augments {Layout}
 */ class $9bb3b775df4f8b9f$var$Structure extends $9bb3b775df4f8b9f$var$Layout {
    constructor(fields, property, decodePrefixes){
        if (!(Array.isArray(fields) && fields.reduce((acc, v)=>acc && v instanceof $9bb3b775df4f8b9f$var$Layout, true))) throw new TypeError("fields must be array of Layout instances");
        if ("boolean" === typeof property && undefined === decodePrefixes) {
            decodePrefixes = property;
            property = undefined;
        }
        /* Verify absence of unnamed variable-length fields. */ for (const fd of fields){
            if (0 > fd.span && undefined === fd.property) throw new Error("fields cannot contain unnamed variable-length layout");
        }
        let span = -1;
        try {
            span = fields.reduce((span, fd)=>span + fd.getSpan(), 0);
        } catch (e) {}
        super(span, property);
        /** The sequence of {@link Layout} values that comprise the
     * structure.
     *
     * The individual elements need not be the same type, and may be
     * either scalar or aggregate layouts.  If a member layout leaves
     * its {@link Layout#property|property} undefined the
     * corresponding region of the buffer associated with the element
     * will not be mutated.
     *
     * @type {Layout[]} */ this.fields = fields;
        /** Control behavior of {@link Layout#decode|decode()} given short
     * buffers.
     *
     * In some situations a structure many be extended with additional
     * fields over time, with older installations providing only a
     * prefix of the full structure.  If this property is `true`
     * decoding will accept those buffers and leave subsequent fields
     * undefined, as long as the buffer ends at a field boundary.
     * Defaults to `false`. */ this.decodePrefixes = !!decodePrefixes;
    }
    /** @override */ getSpan(b, offset) {
        if (0 <= this.span) return this.span;
        if (undefined === offset) offset = 0;
        let span = 0;
        try {
            span = this.fields.reduce((span, fd)=>{
                const fsp = fd.getSpan(b, offset);
                offset += fsp;
                return span + fsp;
            }, 0);
        } catch (e) {
            throw new RangeError("indeterminate span");
        }
        return span;
    }
    /** @override */ decode(b, offset) {
        if (undefined === offset) offset = 0;
        const dest = this.makeDestinationObject();
        for (const fd of this.fields){
            if (undefined !== fd.property) dest[fd.property] = fd.decode(b, offset);
            offset += fd.getSpan(b, offset);
            if (this.decodePrefixes && b.length === offset) break;
        }
        return dest;
    }
    /** Implement {@link Layout#encode|encode} for {@link Structure}.
   *
   * If `src` is missing a property for a member with a defined {@link
   * Layout#property|property} the corresponding region of the buffer is
   * left unmodified. */ encode(src, b, offset) {
        if (undefined === offset) offset = 0;
        const firstOffset = offset;
        let lastOffset = 0;
        let lastWrote = 0;
        for (const fd of this.fields){
            let span = fd.span;
            lastWrote = 0 < span ? span : 0;
            if (undefined !== fd.property) {
                const fv = src[fd.property];
                if (undefined !== fv) {
                    lastWrote = fd.encode(fv, b, offset);
                    if (0 > span) /* Read the as-encoded span, which is not necessarily the
             * same as what we wrote. */ span = fd.getSpan(b, offset);
                }
            }
            lastOffset = offset;
            offset += span;
        }
        /* Use (lastOffset + lastWrote) instead of offset because the last
     * item may have had a dynamic length and we don't want to include
     * the padding between it and the end of the space reserved for
     * it. */ return lastOffset + lastWrote - firstOffset;
    }
    /** @override */ fromArray(values) {
        const dest = this.makeDestinationObject();
        for (const fd of this.fields)if (undefined !== fd.property && 0 < values.length) dest[fd.property] = values.shift();
        return dest;
    }
    /**
   * Get access to the layout of a given property.
   *
   * @param {String} property - the structure member of interest.
   *
   * @return {Layout} - the layout associated with `property`, or
   * undefined if there is no such property.
   */ layoutFor(property) {
        if ("string" !== typeof property) throw new TypeError("property must be string");
        for (const fd of this.fields){
            if (fd.property === property) return fd;
        }
    }
    /**
   * Get the offset of a structure member.
   *
   * @param {String} property - the structure member of interest.
   *
   * @return {Number} - the offset in bytes to the start of `property`
   * within the structure, or undefined if `property` is not a field
   * within the structure.  If the property is a member but follows a
   * variable-length structure member a negative number will be
   * returned.
   */ offsetOf(property) {
        if ("string" !== typeof property) throw new TypeError("property must be string");
        let offset = 0;
        for (const fd of this.fields){
            if (fd.property === property) return offset;
            if (0 > fd.span) offset = -1;
            else if (0 <= offset) offset += fd.span;
        }
    }
}
/**
 * An object that can provide a {@link
 * Union#discriminator|discriminator} API for {@link Union}.
 *
 * **NOTE** This is an abstract base class; you can create instances
 * if it amuses you, but they won't support the {@link
 * UnionDiscriminator#encode|encode} or {@link
 * UnionDiscriminator#decode|decode} functions.
 *
 * @param {string} [property] - Default for {@link
 * UnionDiscriminator#property|property}.
 *
 * @abstract
 */ class $9bb3b775df4f8b9f$var$UnionDiscriminator {
    constructor(property){
        /** The {@link Layout#property|property} to be used when the
     * discriminator is referenced in isolation (generally when {@link
     * Union#decode|Union decode} cannot delegate to a specific
     * variant). */ this.property = property;
    }
    /** Analog to {@link Layout#decode|Layout decode} for union discriminators.
   *
   * The implementation of this method need not reference the buffer if
   * variant information is available through other means. */ decode() {
        throw new Error("UnionDiscriminator is abstract");
    }
    /** Analog to {@link Layout#decode|Layout encode} for union discriminators.
   *
   * The implementation of this method need not store the value if
   * variant information is maintained through other means. */ encode() {
        throw new Error("UnionDiscriminator is abstract");
    }
}
/**
 * An object that can provide a {@link
 * UnionDiscriminator|discriminator API} for {@link Union} using an
 * unsigned integral {@link Layout} instance located either inside or
 * outside the union.
 *
 * @param {ExternalLayout} layout - initializes {@link
 * UnionLayoutDiscriminator#layout|layout}.  Must satisfy {@link
 * ExternalLayout#isCount|isCount()}.
 *
 * @param {string} [property] - Default for {@link
 * UnionDiscriminator#property|property}, superseding the property
 * from `layout`, but defaulting to `variant` if neither `property`
 * nor layout provide a property name.
 *
 * @augments {UnionDiscriminator}
 */ class $9bb3b775df4f8b9f$var$UnionLayoutDiscriminator extends $9bb3b775df4f8b9f$var$UnionDiscriminator {
    constructor(layout, property){
        if (!(layout instanceof $9bb3b775df4f8b9f$var$ExternalLayout && layout.isCount())) throw new TypeError("layout must be an unsigned integer ExternalLayout");
        super(property || layout.property || "variant");
        /** The {@link ExternalLayout} used to access the discriminator
     * value. */ this.layout = layout;
    }
    /** Delegate decoding to {@link UnionLayoutDiscriminator#layout|layout}. */ decode(b, offset) {
        return this.layout.decode(b, offset);
    }
    /** Delegate encoding to {@link UnionLayoutDiscriminator#layout|layout}. */ encode(src, b, offset) {
        return this.layout.encode(src, b, offset);
    }
}
/**
 * Represent any number of span-compatible layouts.
 *
 * *Factory*: {@link module:Layout.union|union}
 *
 * If the union has a {@link Union#defaultLayout|default layout} that
 * layout must have a non-negative {@link Layout#span|span}.  The span
 * of a fixed-span union includes its {@link
 * Union#discriminator|discriminator} if the variant is a {@link
 * Union#usesPrefixDiscriminator|prefix of the union}, plus the span
 * of its {@link Union#defaultLayout|default layout}.
 *
 * If the union does not have a default layout then the encoded span
 * of the union depends on the encoded span of its variant (which may
 * be fixed or variable).
 *
 * {@link VariantLayout#layout|Variant layout}s are added through
 * {@link Union#addVariant|addVariant}.  If the union has a default
 * layout, the span of the {@link VariantLayout#layout|layout
 * contained by the variant} must not exceed the span of the {@link
 * Union#defaultLayout|default layout} (minus the span of a {@link
 * Union#usesPrefixDiscriminator|prefix disriminator}, if used).  The
 * span of the variant will equal the span of the union itself.
 *
 * The variant for a buffer can only be identified from the {@link
 * Union#discriminator|discriminator} {@link
 * UnionDiscriminator#property|property} (in the case of the {@link
 * Union#defaultLayout|default layout}), or by using {@link
 * Union#getVariant|getVariant} and examining the resulting {@link
 * VariantLayout} instance.
 *
 * A variant compatible with a JavaScript object can be identified
 * using {@link Union#getSourceVariant|getSourceVariant}.
 *
 * @param {(UnionDiscriminator|ExternalLayout|Layout)} discr - How to
 * identify the layout used to interpret the union contents.  The
 * parameter must be an instance of {@link UnionDiscriminator}, an
 * {@link ExternalLayout} that satisfies {@link
 * ExternalLayout#isCount|isCount()}, or {@link UInt} (or {@link
 * UIntBE}).  When a non-external layout element is passed the layout
 * appears at the start of the union.  In all cases the (synthesized)
 * {@link UnionDiscriminator} instance is recorded as {@link
 * Union#discriminator|discriminator}.
 *
 * @param {(Layout|null)} defaultLayout - initializer for {@link
 * Union#defaultLayout|defaultLayout}.  If absent defaults to `null`.
 * If `null` there is no default layout: the union has data-dependent
 * length and attempts to decode or encode unrecognized variants will
 * throw an exception.  A {@link Layout} instance must have a
 * non-negative {@link Layout#span|span}, and if it lacks a {@link
 * Layout#property|property} the {@link
 * Union#defaultLayout|defaultLayout} will be a {@link
 * Layout#replicate|replica} with property `content`.
 *
 * @param {string} [property] - initializer for {@link
 * Layout#property|property}.
 *
 * @augments {Layout}
 */ class $9bb3b775df4f8b9f$var$Union extends $9bb3b775df4f8b9f$var$Layout {
    constructor(discr, defaultLayout, property){
        const upv = discr instanceof $9bb3b775df4f8b9f$var$UInt || discr instanceof $9bb3b775df4f8b9f$var$UIntBE;
        if (upv) discr = new $9bb3b775df4f8b9f$var$UnionLayoutDiscriminator(new $9bb3b775df4f8b9f$var$OffsetLayout(discr));
        else if (discr instanceof $9bb3b775df4f8b9f$var$ExternalLayout && discr.isCount()) discr = new $9bb3b775df4f8b9f$var$UnionLayoutDiscriminator(discr);
        else if (!(discr instanceof $9bb3b775df4f8b9f$var$UnionDiscriminator)) throw new TypeError("discr must be a UnionDiscriminator or an unsigned integer layout");
        if (undefined === defaultLayout) defaultLayout = null;
        if (!(null === defaultLayout || defaultLayout instanceof $9bb3b775df4f8b9f$var$Layout)) throw new TypeError("defaultLayout must be null or a Layout");
        if (null !== defaultLayout) {
            if (0 > defaultLayout.span) throw new Error("defaultLayout must have constant span");
            if (undefined === defaultLayout.property) defaultLayout = defaultLayout.replicate("content");
        }
        /* The union span can be estimated only if there's a default
     * layout.  The union spans its default layout, plus any prefix
     * variant layout.  By construction both layouts, if present, have
     * non-negative span. */ let span = -1;
        if (defaultLayout) {
            span = defaultLayout.span;
            if (0 <= span && upv) span += discr.layout.span;
        }
        super(span, property);
        /** The interface for the discriminator value in isolation.
     *
     * This a {@link UnionDiscriminator} either passed to the
     * constructor or synthesized from the `discr` constructor
     * argument.  {@link
     * Union#usesPrefixDiscriminator|usesPrefixDiscriminator} will be
     * `true` iff the `discr` parameter was a non-offset {@link
     * Layout} instance. */ this.discriminator = discr;
        /** `true` if the {@link Union#discriminator|discriminator} is the
     * first field in the union.
     *
     * If `false` the discriminator is obtained from somewhere
     * else. */ this.usesPrefixDiscriminator = upv;
        /** The layout for non-discriminator content when the value of the
     * discriminator is not recognized.
     *
     * This is the value passed to the constructor.  It is
     * structurally equivalent to the second component of {@link
     * Union#layout|layout} but may have a different property
     * name. */ this.defaultLayout = defaultLayout;
        /** A registry of allowed variants.
     *
     * The keys are unsigned integers which should be compatible with
     * {@link Union.discriminator|discriminator}.  The property value
     * is the corresponding {@link VariantLayout} instances assigned
     * to this union by {@link Union#addVariant|addVariant}.
     *
     * **NOTE** The registry remains mutable so that variants can be
     * {@link Union#addVariant|added} at any time.  Users should not
     * manipulate the content of this property. */ this.registry = {};
        /* Private variable used when invoking getSourceVariant */ let boundGetSourceVariant = this.defaultGetSourceVariant.bind(this);
        /** Function to infer the variant selected by a source object.
     *
     * Defaults to {@link
     * Union#defaultGetSourceVariant|defaultGetSourceVariant} but may
     * be overridden using {@link
     * Union#configGetSourceVariant|configGetSourceVariant}.
     *
     * @param {Object} src - as with {@link
     * Union#defaultGetSourceVariant|defaultGetSourceVariant}.
     *
     * @returns {(undefined|VariantLayout)} The default variant
     * (`undefined`) or first registered variant that uses a property
     * available in `src`. */ this.getSourceVariant = function(src) {
            return boundGetSourceVariant(src);
        };
        /** Function to override the implementation of {@link
     * Union#getSourceVariant|getSourceVariant}.
     *
     * Use this if the desired variant cannot be identified using the
     * algorithm of {@link
     * Union#defaultGetSourceVariant|defaultGetSourceVariant}.
     *
     * **NOTE** The provided function will be invoked bound to this
     * Union instance, providing local access to {@link
     * Union#registry|registry}.
     *
     * @param {Function} gsv - a function that follows the API of
     * {@link Union#defaultGetSourceVariant|defaultGetSourceVariant}. */ this.configGetSourceVariant = function(gsv) {
            boundGetSourceVariant = gsv.bind(this);
        };
    }
    /** @override */ getSpan(b, offset) {
        if (0 <= this.span) return this.span;
        if (undefined === offset) offset = 0;
        /* Default layouts always have non-negative span, so we don't have
     * one and we have to recognize the variant which will in turn
     * determine the span. */ const vlo = this.getVariant(b, offset);
        if (!vlo) throw new Error("unable to determine span for unrecognized variant");
        return vlo.getSpan(b, offset);
    }
    /**
   * Method to infer a registered Union variant compatible with `src`.
   *
   * The first satisified rule in the following sequence defines the
   * return value:
   * * If `src` has properties matching the Union discriminator and
   *   the default layout, `undefined` is returned regardless of the
   *   value of the discriminator property (this ensures the default
   *   layout will be used);
   * * If `src` has a property matching the Union discriminator, the
   *   value of the discriminator identifies a registered variant, and
   *   either (a) the variant has no layout, or (b) `src` has the
   *   variant's property, then the variant is returned (because the
   *   source satisfies the constraints of the variant it identifies);
   * * If `src` does not have a property matching the Union
   *   discriminator, but does have a property matching a registered
   *   variant, then the variant is returned (because the source
   *   matches a variant without an explicit conflict);
   * * An error is thrown (because we either can't identify a variant,
   *   or we were explicitly told the variant but can't satisfy it).
   *
   * @param {Object} src - an object presumed to be compatible with
   * the content of the Union.
   *
   * @return {(undefined|VariantLayout)} - as described above.
   *
   * @throws {Error} - if `src` cannot be associated with a default or
   * registered variant.
   */ defaultGetSourceVariant(src) {
        if (src.hasOwnProperty(this.discriminator.property)) {
            if (this.defaultLayout && src.hasOwnProperty(this.defaultLayout.property)) return undefined;
            const vlo = this.registry[src[this.discriminator.property]];
            if (vlo && (!vlo.layout || src.hasOwnProperty(vlo.property))) return vlo;
        } else for(const tag in this.registry){
            const vlo = this.registry[tag];
            if (src.hasOwnProperty(vlo.property)) return vlo;
        }
        throw new Error("unable to infer src variant");
    }
    /** Implement {@link Layout#decode|decode} for {@link Union}.
   *
   * If the variant is {@link Union#addVariant|registered} the return
   * value is an instance of that variant, with no explicit
   * discriminator.  Otherwise the {@link Union#defaultLayout|default
   * layout} is used to decode the content. */ decode(b, offset) {
        if (undefined === offset) offset = 0;
        let dest;
        const dlo = this.discriminator;
        const discr = dlo.decode(b, offset);
        let clo = this.registry[discr];
        if (undefined === clo) {
            let contentOffset = 0;
            clo = this.defaultLayout;
            if (this.usesPrefixDiscriminator) contentOffset = dlo.layout.span;
            dest = this.makeDestinationObject();
            dest[dlo.property] = discr;
            dest[clo.property] = this.defaultLayout.decode(b, offset + contentOffset);
        } else dest = clo.decode(b, offset);
        return dest;
    }
    /** Implement {@link Layout#encode|encode} for {@link Union}.
   *
   * This API assumes the `src` object is consistent with the union's
   * {@link Union#defaultLayout|default layout}.  To encode variants
   * use the appropriate variant-specific {@link VariantLayout#encode}
   * method. */ encode(src, b, offset) {
        if (undefined === offset) offset = 0;
        const vlo = this.getSourceVariant(src);
        if (undefined === vlo) {
            const dlo = this.discriminator;
            const clo = this.defaultLayout;
            let contentOffset = 0;
            if (this.usesPrefixDiscriminator) contentOffset = dlo.layout.span;
            dlo.encode(src[dlo.property], b, offset);
            return contentOffset + clo.encode(src[clo.property], b, offset + contentOffset);
        }
        return vlo.encode(src, b, offset);
    }
    /** Register a new variant structure within a union.  The newly
   * created variant is returned.
   *
   * @param {Number} variant - initializer for {@link
   * VariantLayout#variant|variant}.
   *
   * @param {Layout} layout - initializer for {@link
   * VariantLayout#layout|layout}.
   *
   * @param {String} property - initializer for {@link
   * Layout#property|property}.
   *
   * @return {VariantLayout} */ addVariant(variant, layout, property) {
        const rv = new $9bb3b775df4f8b9f$var$VariantLayout(this, variant, layout, property);
        this.registry[variant] = rv;
        return rv;
    }
    /**
   * Get the layout associated with a registered variant.
   *
   * If `vb` does not produce a registered variant the function returns
   * `undefined`.
   *
   * @param {(Number|Buffer)} vb - either the variant number, or a
   * buffer from which the discriminator is to be read.
   *
   * @param {Number} offset - offset into `vb` for the start of the
   * union.  Used only when `vb` is an instance of {Buffer}.
   *
   * @return {({VariantLayout}|undefined)}
   */ getVariant(vb, offset) {
        let variant = vb;
        if ($9bb3b775df4f8b9f$var$buffer.Buffer.isBuffer(vb)) {
            if (undefined === offset) offset = 0;
            variant = this.discriminator.decode(vb, offset);
        }
        return this.registry[variant];
    }
}
/**
 * Represent a specific variant within a containing union.
 *
 * **NOTE** The {@link Layout#span|span} of the variant may include
 * the span of the {@link Union#discriminator|discriminator} used to
 * identify it, but values read and written using the variant strictly
 * conform to the content of {@link VariantLayout#layout|layout}.
 *
 * **NOTE** User code should not invoke this constructor directly.  Use
 * the union {@link Union#addVariant|addVariant} helper method.
 *
 * @param {Union} union - initializer for {@link
 * VariantLayout#union|union}.
 *
 * @param {Number} variant - initializer for {@link
 * VariantLayout#variant|variant}.
 *
 * @param {Layout} [layout] - initializer for {@link
 * VariantLayout#layout|layout}.  If absent the variant carries no
 * data.
 *
 * @param {String} [property] - initializer for {@link
 * Layout#property|property}.  Unlike many other layouts, variant
 * layouts normally include a property name so they can be identified
 * within their containing {@link Union}.  The property identifier may
 * be absent only if `layout` is is absent.
 *
 * @augments {Layout}
 */ class $9bb3b775df4f8b9f$var$VariantLayout extends $9bb3b775df4f8b9f$var$Layout {
    constructor(union, variant, layout, property){
        if (!(union instanceof $9bb3b775df4f8b9f$var$Union)) throw new TypeError("union must be a Union");
        if (!Number.isInteger(variant) || 0 > variant) throw new TypeError("variant must be a (non-negative) integer");
        if ("string" === typeof layout && undefined === property) {
            property = layout;
            layout = null;
        }
        if (layout) {
            if (!(layout instanceof $9bb3b775df4f8b9f$var$Layout)) throw new TypeError("layout must be a Layout");
            if (null !== union.defaultLayout && 0 <= layout.span && layout.span > union.defaultLayout.span) throw new Error("variant span exceeds span of containing union");
            if ("string" !== typeof property) throw new TypeError("variant must have a String property");
        }
        let span = union.span;
        if (0 > union.span) {
            span = layout ? layout.span : 0;
            if (0 <= span && union.usesPrefixDiscriminator) span += union.discriminator.layout.span;
        }
        super(span, property);
        /** The {@link Union} to which this variant belongs. */ this.union = union;
        /** The unsigned integral value identifying this variant within
     * the {@link Union#discriminator|discriminator} of the containing
     * union. */ this.variant = variant;
        /** The {@link Layout} to be used when reading/writing the
     * non-discriminator part of the {@link
     * VariantLayout#union|union}.  If `null` the variant carries no
     * data. */ this.layout = layout || null;
    }
    /** @override */ getSpan(b, offset) {
        if (0 <= this.span) /* Will be equal to the containing union span if that is not
       * variable. */ return this.span;
        if (undefined === offset) offset = 0;
        let contentOffset = 0;
        if (this.union.usesPrefixDiscriminator) contentOffset = this.union.discriminator.layout.span;
        /* Span is defined solely by the variant (and prefix discriminator) */ return contentOffset + this.layout.getSpan(b, offset + contentOffset);
    }
    /** @override */ decode(b, offset) {
        const dest = this.makeDestinationObject();
        if (undefined === offset) offset = 0;
        if (this !== this.union.getVariant(b, offset)) throw new Error("variant mismatch");
        let contentOffset = 0;
        if (this.union.usesPrefixDiscriminator) contentOffset = this.union.discriminator.layout.span;
        if (this.layout) dest[this.property] = this.layout.decode(b, offset + contentOffset);
        else if (this.property) dest[this.property] = true;
        else if (this.union.usesPrefixDiscriminator) dest[this.union.discriminator.property] = this.variant;
        return dest;
    }
    /** @override */ encode(src, b, offset) {
        if (undefined === offset) offset = 0;
        let contentOffset = 0;
        if (this.union.usesPrefixDiscriminator) contentOffset = this.union.discriminator.layout.span;
        if (this.layout && !src.hasOwnProperty(this.property)) throw new TypeError("variant lacks property " + this.property);
        this.union.discriminator.encode(this.variant, b, offset);
        let span = contentOffset;
        if (this.layout) {
            this.layout.encode(src[this.property], b, offset + contentOffset);
            span += this.layout.getSpan(b, offset + contentOffset);
            if (0 <= this.union.span && span > this.union.span) throw new Error("encoded variant overruns containing union");
        }
        return span;
    }
    /** Delegate {@link Layout#fromArray|fromArray} to {@link
   * VariantLayout#layout|layout}. */ fromArray(values) {
        if (this.layout) return this.layout.fromArray(values);
    }
}
/** JavaScript chose to define bitwise operations as operating on
 * signed 32-bit values in 2's complement form, meaning any integer
 * with bit 31 set is going to look negative.  For right shifts that's
 * not a problem, because `>>>` is a logical shift, but for every
 * other bitwise operator we have to compensate for possible negative
 * results. */ function $9bb3b775df4f8b9f$var$fixBitwiseResult(v) {
    if (0 > v) v += 0x100000000;
    return v;
}
/**
 * Contain a sequence of bit fields as an unsigned integer.
 *
 * *Factory*: {@link module:Layout.bits|bits}
 *
 * This is a container element; within it there are {@link BitField}
 * instances that provide the extracted properties.  The container
 * simply defines the aggregate representation and its bit ordering.
 * The representation is an object containing properties with numeric
 * or {@link Boolean} values.
 *
 * {@link BitField}s are added with the {@link
 * BitStructure#addField|addField} and {@link
 * BitStructure#addBoolean|addBoolean} methods.

 * @param {Layout} word - initializer for {@link
 * BitStructure#word|word}.  The parameter must be an instance of
 * {@link UInt} (or {@link UIntBE}) that is no more than 4 bytes wide.
 *
 * @param {bool} [msb] - `true` if the bit numbering starts at the
 * most significant bit of the containing word; `false` (default) if
 * it starts at the least significant bit of the containing word.  If
 * the parameter at this position is a string and `property` is
 * `undefined` the value of this argument will instead be used as the
 * value of `property`.
 *
 * @param {string} [property] - initializer for {@link
 * Layout#property|property}.
 *
 * @augments {Layout}
 */ class $9bb3b775df4f8b9f$var$BitStructure extends $9bb3b775df4f8b9f$var$Layout {
    constructor(word, msb, property){
        if (!(word instanceof $9bb3b775df4f8b9f$var$UInt || word instanceof $9bb3b775df4f8b9f$var$UIntBE)) throw new TypeError("word must be a UInt or UIntBE layout");
        if ("string" === typeof msb && undefined === property) {
            property = msb;
            msb = undefined;
        }
        if (4 < word.span) throw new RangeError("word cannot exceed 32 bits");
        super(word.span, property);
        /** The layout used for the packed value.  {@link BitField}
     * instances are packed sequentially depending on {@link
     * BitStructure#msb|msb}. */ this.word = word;
        /** Whether the bit sequences are packed starting at the most
     * significant bit growing down (`true`), or the least significant
     * bit growing up (`false`).
     *
     * **NOTE** Regardless of this value, the least significant bit of
     * any {@link BitField} value is the least significant bit of the
     * corresponding section of the packed value. */ this.msb = !!msb;
        /** The sequence of {@link BitField} layouts that comprise the
     * packed structure.
     *
     * **NOTE** The array remains mutable to allow fields to be {@link
     * BitStructure#addField|added} after construction.  Users should
     * not manipulate the content of this property.*/ this.fields = [];
        /* Storage for the value.  Capture a variable instead of using an
     * instance property because we don't want anything to change the
     * value without going through the mutator. */ let value = 0;
        this._packedSetValue = function(v) {
            value = $9bb3b775df4f8b9f$var$fixBitwiseResult(v);
            return this;
        };
        this._packedGetValue = function() {
            return value;
        };
    }
    /** @override */ decode(b, offset) {
        const dest = this.makeDestinationObject();
        if (undefined === offset) offset = 0;
        const value = this.word.decode(b, offset);
        this._packedSetValue(value);
        for (const fd of this.fields)if (undefined !== fd.property) dest[fd.property] = fd.decode(value);
        return dest;
    }
    /** Implement {@link Layout#encode|encode} for {@link BitStructure}.
   *
   * If `src` is missing a property for a member with a defined {@link
   * Layout#property|property} the corresponding region of the packed
   * value is left unmodified.  Unused bits are also left unmodified. */ encode(src, b, offset) {
        if (undefined === offset) offset = 0;
        const value = this.word.decode(b, offset);
        this._packedSetValue(value);
        for (const fd of this.fields)if (undefined !== fd.property) {
            const fv = src[fd.property];
            if (undefined !== fv) fd.encode(fv);
        }
        return this.word.encode(this._packedGetValue(), b, offset);
    }
    /** Register a new bitfield with a containing bit structure.  The
   * resulting bitfield is returned.
   *
   * @param {Number} bits - initializer for {@link BitField#bits|bits}.
   *
   * @param {string} property - initializer for {@link
   * Layout#property|property}.
   *
   * @return {BitField} */ addField(bits, property) {
        const bf = new $9bb3b775df4f8b9f$var$BitField(this, bits, property);
        this.fields.push(bf);
        return bf;
    }
    /** As with {@link BitStructure#addField|addField} for single-bit
   * fields with `boolean` value representation.
   *
   * @param {string} property - initializer for {@link
   * Layout#property|property}.
   *
   * @return {Boolean} */ addBoolean(property) {
        // This is my Boolean, not the Javascript one.
        // eslint-disable-next-line no-new-wrappers
        const bf = new $9bb3b775df4f8b9f$var$Boolean(this, property);
        this.fields.push(bf);
        return bf;
    }
    /**
   * Get access to the bit field for a given property.
   *
   * @param {String} property - the bit field of interest.
   *
   * @return {BitField} - the field associated with `property`, or
   * undefined if there is no such property.
   */ fieldFor(property) {
        if ("string" !== typeof property) throw new TypeError("property must be string");
        for (const fd of this.fields){
            if (fd.property === property) return fd;
        }
    }
}
/**
 * Represent a sequence of bits within a {@link BitStructure}.
 *
 * All bit field values are represented as unsigned integers.
 *
 * **NOTE** User code should not invoke this constructor directly.
 * Use the container {@link BitStructure#addField|addField} helper
 * method.
 *
 * **NOTE** BitField instances are not instances of {@link Layout}
 * since {@link Layout#span|span} measures 8-bit units.
 *
 * @param {BitStructure} container - initializer for {@link
 * BitField#container|container}.
 *
 * @param {Number} bits - initializer for {@link BitField#bits|bits}.
 *
 * @param {string} [property] - initializer for {@link
 * Layout#property|property}.
 */ class $9bb3b775df4f8b9f$var$BitField {
    constructor(container, bits, property){
        if (!(container instanceof $9bb3b775df4f8b9f$var$BitStructure)) throw new TypeError("container must be a BitStructure");
        if (!Number.isInteger(bits) || 0 >= bits) throw new TypeError("bits must be positive integer");
        const totalBits = 8 * container.span;
        const usedBits = container.fields.reduce((sum, fd)=>sum + fd.bits, 0);
        if (bits + usedBits > totalBits) throw new Error("bits too long for span remainder (" + (totalBits - usedBits) + " of " + totalBits + " remain)");
        /** The {@link BitStructure} instance to which this bit field
     * belongs. */ this.container = container;
        /** The span of this value in bits. */ this.bits = bits;
        /** A mask of {@link BitField#bits|bits} bits isolating value bits
     * that fit within the field.
     *
     * That is, it masks a value that has not yet been shifted into
     * position within its containing packed integer. */ this.valueMask = (1 << bits) - 1;
        if (32 === bits) this.valueMask = 0xFFFFFFFF;
        /** The offset of the value within the containing packed unsigned
     * integer.  The least significant bit of the packed value is at
     * offset zero, regardless of bit ordering used. */ this.start = usedBits;
        if (this.container.msb) this.start = totalBits - usedBits - bits;
        /** A mask of {@link BitField#bits|bits} isolating the field value
     * within the containing packed unsigned integer. */ this.wordMask = $9bb3b775df4f8b9f$var$fixBitwiseResult(this.valueMask << this.start);
        /** The property name used when this bitfield is represented in an
     * Object.
     *
     * Intended to be functionally equivalent to {@link
     * Layout#property}.
     *
     * If left undefined the corresponding span of bits will be
     * treated as padding: it will not be mutated by {@link
     * Layout#encode|encode} nor represented as a property in the
     * decoded Object. */ this.property = property;
    }
    /** Store a value into the corresponding subsequence of the containing
   * bit field. */ decode() {
        const word = this.container._packedGetValue();
        const wordValue = $9bb3b775df4f8b9f$var$fixBitwiseResult(word & this.wordMask);
        const value = wordValue >>> this.start;
        return value;
    }
    /** Store a value into the corresponding subsequence of the containing
   * bit field.
   *
   * **NOTE** This is not a specialization of {@link
   * Layout#encode|Layout.encode} and there is no return value. */ encode(value) {
        if (!Number.isInteger(value) || value !== $9bb3b775df4f8b9f$var$fixBitwiseResult(value & this.valueMask)) throw new TypeError($9bb3b775df4f8b9f$var$nameWithProperty("BitField.encode", this) + " value must be integer not exceeding " + this.valueMask);
        const word = this.container._packedGetValue();
        const wordValue = $9bb3b775df4f8b9f$var$fixBitwiseResult(value << this.start);
        this.container._packedSetValue($9bb3b775df4f8b9f$var$fixBitwiseResult(word & ~this.wordMask) | wordValue);
    }
}
/**
 * Represent a single bit within a {@link BitStructure} as a
 * JavaScript boolean.
 *
 * **NOTE** User code should not invoke this constructor directly.
 * Use the container {@link BitStructure#addBoolean|addBoolean} helper
 * method.
 *
 * @param {BitStructure} container - initializer for {@link
 * BitField#container|container}.
 *
 * @param {string} [property] - initializer for {@link
 * Layout#property|property}.
 *
 * @augments {BitField}
 */ /* eslint-disable no-extend-native */ class $9bb3b775df4f8b9f$var$Boolean extends $9bb3b775df4f8b9f$var$BitField {
    constructor(container, property){
        super(container, 1, property);
    }
    /** Override {@link BitField#decode|decode} for {@link Boolean|Boolean}.
   *
   * @returns {boolean} */ decode(b, offset) {
        return !!$9bb3b775df4f8b9f$var$BitField.prototype.decode.call(this, b, offset);
    }
    /** @override */ encode(value) {
        if ("boolean" === typeof value) // BitField requires integer values
        value = +value;
        return $9bb3b775df4f8b9f$var$BitField.prototype.encode.call(this, value);
    }
}
/* eslint-enable no-extend-native */ /**
 * Contain a fixed-length block of arbitrary data, represented as a
 * Buffer.
 *
 * *Factory*: {@link module:Layout.blob|blob}
 *
 * @param {(Number|ExternalLayout)} length - initializes {@link
 * Blob#length|length}.
 *
 * @param {String} [property] - initializer for {@link
 * Layout#property|property}.
 *
 * @augments {Layout}
 */ class $9bb3b775df4f8b9f$var$Blob extends $9bb3b775df4f8b9f$var$Layout {
    constructor(length, property){
        if (!(length instanceof $9bb3b775df4f8b9f$var$ExternalLayout && length.isCount() || Number.isInteger(length) && 0 <= length)) throw new TypeError("length must be positive integer or an unsigned integer ExternalLayout");
        let span = -1;
        if (!(length instanceof $9bb3b775df4f8b9f$var$ExternalLayout)) span = length;
        super(span, property);
        /** The number of bytes in the blob.
     *
     * This may be a non-negative integer, or an instance of {@link
     * ExternalLayout} that satisfies {@link
     * ExternalLayout#isCount|isCount()}. */ this.length = length;
    }
    /** @override */ getSpan(b, offset) {
        let span = this.span;
        if (0 > span) span = this.length.decode(b, offset);
        return span;
    }
    /** @override */ decode(b, offset) {
        if (undefined === offset) offset = 0;
        let span = this.span;
        if (0 > span) span = this.length.decode(b, offset);
        return b.slice(offset, offset + span);
    }
    /** Implement {@link Layout#encode|encode} for {@link Blob}.
   *
   * **NOTE** If {@link Layout#count|count} is an instance of {@link
   * ExternalLayout} then the length of `src` will be encoded as the
   * count after `src` is encoded. */ encode(src, b, offset) {
        let span = this.length;
        if (this.length instanceof $9bb3b775df4f8b9f$var$ExternalLayout) span = src.length;
        if (!($9bb3b775df4f8b9f$var$buffer.Buffer.isBuffer(src) && span === src.length)) throw new TypeError($9bb3b775df4f8b9f$var$nameWithProperty("Blob.encode", this) + " requires (length " + span + ") Buffer as src");
        if (offset + span > b.length) throw new RangeError("encoding overruns Buffer");
        b.write(src.toString("hex"), offset, span, "hex");
        if (this.length instanceof $9bb3b775df4f8b9f$var$ExternalLayout) this.length.encode(span, b, offset);
        return span;
    }
}
/**
 * Contain a `NUL`-terminated UTF8 string.
 *
 * *Factory*: {@link module:Layout.cstr|cstr}
 *
 * **NOTE** Any UTF8 string that incorporates a zero-valued byte will
 * not be correctly decoded by this layout.
 *
 * @param {String} [property] - initializer for {@link
 * Layout#property|property}.
 *
 * @augments {Layout}
 */ class $9bb3b775df4f8b9f$var$CString extends $9bb3b775df4f8b9f$var$Layout {
    constructor(property){
        super(-1, property);
    }
    /** @override */ getSpan(b, offset) {
        if (!$9bb3b775df4f8b9f$var$buffer.Buffer.isBuffer(b)) throw new TypeError("b must be a Buffer");
        if (undefined === offset) offset = 0;
        let idx = offset;
        while(idx < b.length && 0 !== b[idx])idx += 1;
        return 1 + idx - offset;
    }
    /** @override */ decode(b, offset, dest) {
        if (undefined === offset) offset = 0;
        let span = this.getSpan(b, offset);
        return b.slice(offset, offset + span - 1).toString("utf-8");
    }
    /** @override */ encode(src, b, offset) {
        if (undefined === offset) offset = 0;
        /* Must force this to a string, lest it be a number and the
     * "utf8-encoding" below actually allocate a buffer of length
     * src */ if ("string" !== typeof src) src = src.toString();
        const srcb = new $9bb3b775df4f8b9f$var$buffer.Buffer(src, "utf8");
        const span = srcb.length;
        if (offset + span > b.length) throw new RangeError("encoding overruns Buffer");
        srcb.copy(b, offset);
        b[offset + span] = 0;
        return span + 1;
    }
}
/**
 * Contain a UTF8 string with implicit length.
 *
 * *Factory*: {@link module:Layout.utf8|utf8}
 *
 * **NOTE** Because the length is implicit in the size of the buffer
 * this layout should be used only in isolation, or in a situation
 * where the length can be expressed by operating on a slice of the
 * containing buffer.
 *
 * @param {Number} [maxSpan] - the maximum length allowed for encoded
 * string content.  If not provided there is no bound on the allowed
 * content.
 *
 * @param {String} [property] - initializer for {@link
 * Layout#property|property}.
 *
 * @augments {Layout}
 */ class $9bb3b775df4f8b9f$var$UTF8 extends $9bb3b775df4f8b9f$var$Layout {
    constructor(maxSpan, property){
        if ("string" === typeof maxSpan && undefined === property) {
            property = maxSpan;
            maxSpan = undefined;
        }
        if (undefined === maxSpan) maxSpan = -1;
        else if (!Number.isInteger(maxSpan)) throw new TypeError("maxSpan must be an integer");
        super(-1, property);
        /** The maximum span of the layout in bytes.
     *
     * Positive values are generally expected.  Zero is abnormal.
     * Attempts to encode or decode a value that exceeds this length
     * will throw a `RangeError`.
     *
     * A negative value indicates that there is no bound on the length
     * of the content. */ this.maxSpan = maxSpan;
    }
    /** @override */ getSpan(b, offset) {
        if (!$9bb3b775df4f8b9f$var$buffer.Buffer.isBuffer(b)) throw new TypeError("b must be a Buffer");
        if (undefined === offset) offset = 0;
        return b.length - offset;
    }
    /** @override */ decode(b, offset, dest) {
        if (undefined === offset) offset = 0;
        let span = this.getSpan(b, offset);
        if (0 <= this.maxSpan && this.maxSpan < span) throw new RangeError("text length exceeds maxSpan");
        return b.slice(offset, offset + span).toString("utf-8");
    }
    /** @override */ encode(src, b, offset) {
        if (undefined === offset) offset = 0;
        /* Must force this to a string, lest it be a number and the
     * "utf8-encoding" below actually allocate a buffer of length
     * src */ if ("string" !== typeof src) src = src.toString();
        const srcb = new $9bb3b775df4f8b9f$var$buffer.Buffer(src, "utf8");
        const span = srcb.length;
        if (0 <= this.maxSpan && this.maxSpan < span) throw new RangeError("text length exceeds maxSpan");
        if (offset + span > b.length) throw new RangeError("encoding overruns Buffer");
        srcb.copy(b, offset);
        return span;
    }
}
/**
 * Contain a constant value.
 *
 * This layout may be used in cases where a JavaScript value can be
 * inferred without an expression in the binary encoding.  An example
 * would be a {@link VariantLayout|variant layout} where the content
 * is implied by the union {@link Union#discriminator|discriminator}.
 *
 * @param {Object|Number|String} value - initializer for {@link
 * Constant#value|value}.  If the value is an object (or array) and
 * the application intends the object to remain unchanged regardless
 * of what is done to values decoded by this layout, the value should
 * be frozen prior passing it to this constructor.
 *
 * @param {String} [property] - initializer for {@link
 * Layout#property|property}.
 *
 * @augments {Layout}
 */ class $9bb3b775df4f8b9f$var$Constant extends $9bb3b775df4f8b9f$var$Layout {
    constructor(value, property){
        super(0, property);
        /** The value produced by this constant when the layout is {@link
     * Constant#decode|decoded}.
     *
     * Any JavaScript value including `null` and `undefined` is
     * permitted.
     *
     * **WARNING** If `value` passed in the constructor was not
     * frozen, it is possible for users of decoded values to change
     * the content of the value. */ this.value = value;
    }
    /** @override */ decode(b, offset, dest) {
        return this.value;
    }
    /** @override */ encode(src, b, offset) {
        /* Constants take no space */ return 0;
    }
}
$9bb3b775df4f8b9f$var$Layout$1.ExternalLayout = $9bb3b775df4f8b9f$var$ExternalLayout;
$9bb3b775df4f8b9f$var$Layout$1.GreedyCount = $9bb3b775df4f8b9f$var$GreedyCount;
$9bb3b775df4f8b9f$var$Layout$1.OffsetLayout = $9bb3b775df4f8b9f$var$OffsetLayout;
$9bb3b775df4f8b9f$var$Layout$1.UInt = $9bb3b775df4f8b9f$var$UInt;
$9bb3b775df4f8b9f$var$Layout$1.UIntBE = $9bb3b775df4f8b9f$var$UIntBE;
$9bb3b775df4f8b9f$var$Layout$1.Int = $9bb3b775df4f8b9f$var$Int;
$9bb3b775df4f8b9f$var$Layout$1.IntBE = $9bb3b775df4f8b9f$var$IntBE;
$9bb3b775df4f8b9f$var$Layout$1.Float = $9bb3b775df4f8b9f$var$Float;
$9bb3b775df4f8b9f$var$Layout$1.FloatBE = $9bb3b775df4f8b9f$var$FloatBE;
$9bb3b775df4f8b9f$var$Layout$1.Double = $9bb3b775df4f8b9f$var$Double;
$9bb3b775df4f8b9f$var$Layout$1.DoubleBE = $9bb3b775df4f8b9f$var$DoubleBE;
$9bb3b775df4f8b9f$var$Layout$1.Sequence = $9bb3b775df4f8b9f$var$Sequence;
$9bb3b775df4f8b9f$var$Layout$1.Structure = $9bb3b775df4f8b9f$var$Structure;
$9bb3b775df4f8b9f$var$Layout$1.UnionDiscriminator = $9bb3b775df4f8b9f$var$UnionDiscriminator;
$9bb3b775df4f8b9f$var$Layout$1.UnionLayoutDiscriminator = $9bb3b775df4f8b9f$var$UnionLayoutDiscriminator;
$9bb3b775df4f8b9f$var$Layout$1.Union = $9bb3b775df4f8b9f$var$Union;
$9bb3b775df4f8b9f$var$Layout$1.VariantLayout = $9bb3b775df4f8b9f$var$VariantLayout;
$9bb3b775df4f8b9f$var$Layout$1.BitStructure = $9bb3b775df4f8b9f$var$BitStructure;
$9bb3b775df4f8b9f$var$Layout$1.BitField = $9bb3b775df4f8b9f$var$BitField;
$9bb3b775df4f8b9f$var$Layout$1.Boolean = $9bb3b775df4f8b9f$var$Boolean;
$9bb3b775df4f8b9f$var$Layout$1.Blob = $9bb3b775df4f8b9f$var$Blob;
$9bb3b775df4f8b9f$var$Layout$1.CString = $9bb3b775df4f8b9f$var$CString;
$9bb3b775df4f8b9f$var$Layout$1.UTF8 = $9bb3b775df4f8b9f$var$UTF8;
$9bb3b775df4f8b9f$var$Layout$1.Constant = $9bb3b775df4f8b9f$var$Constant;
/** Factory for {@link GreedyCount}. */ $9bb3b775df4f8b9f$var$Layout$1.greedy = (elementSpan, property)=>new $9bb3b775df4f8b9f$var$GreedyCount(elementSpan, property);
/** Factory for {@link OffsetLayout}. */ $9bb3b775df4f8b9f$var$Layout$1.offset = (layout, offset, property)=>new $9bb3b775df4f8b9f$var$OffsetLayout(layout, offset, property);
/** Factory for {@link UInt|unsigned int layouts} spanning one
 * byte. */ var $9bb3b775df4f8b9f$var$u8 = $9bb3b775df4f8b9f$var$Layout$1.u8 = (property)=>new $9bb3b775df4f8b9f$var$UInt(1, property);
/** Factory for {@link UInt|little-endian unsigned int layouts}
 * spanning two bytes. */ $9bb3b775df4f8b9f$var$Layout$1.u16 = (property)=>new $9bb3b775df4f8b9f$var$UInt(2, property);
/** Factory for {@link UInt|little-endian unsigned int layouts}
 * spanning three bytes. */ $9bb3b775df4f8b9f$var$Layout$1.u24 = (property)=>new $9bb3b775df4f8b9f$var$UInt(3, property);
/** Factory for {@link UInt|little-endian unsigned int layouts}
 * spanning four bytes. */ var $9bb3b775df4f8b9f$var$u32 = $9bb3b775df4f8b9f$var$Layout$1.u32 = (property)=>new $9bb3b775df4f8b9f$var$UInt(4, property);
/** Factory for {@link UInt|little-endian unsigned int layouts}
 * spanning five bytes. */ $9bb3b775df4f8b9f$var$Layout$1.u40 = (property)=>new $9bb3b775df4f8b9f$var$UInt(5, property);
/** Factory for {@link UInt|little-endian unsigned int layouts}
 * spanning six bytes. */ $9bb3b775df4f8b9f$var$Layout$1.u48 = (property)=>new $9bb3b775df4f8b9f$var$UInt(6, property);
/** Factory for {@link NearUInt64|little-endian unsigned int
 * layouts} interpreted as Numbers. */ $9bb3b775df4f8b9f$var$Layout$1.nu64 = (property)=>new $9bb3b775df4f8b9f$var$NearUInt64(property);
/** Factory for {@link UInt|big-endian unsigned int layouts}
 * spanning two bytes. */ $9bb3b775df4f8b9f$var$Layout$1.u16be = (property)=>new $9bb3b775df4f8b9f$var$UIntBE(2, property);
/** Factory for {@link UInt|big-endian unsigned int layouts}
 * spanning three bytes. */ $9bb3b775df4f8b9f$var$Layout$1.u24be = (property)=>new $9bb3b775df4f8b9f$var$UIntBE(3, property);
/** Factory for {@link UInt|big-endian unsigned int layouts}
 * spanning four bytes. */ $9bb3b775df4f8b9f$var$Layout$1.u32be = (property)=>new $9bb3b775df4f8b9f$var$UIntBE(4, property);
/** Factory for {@link UInt|big-endian unsigned int layouts}
 * spanning five bytes. */ $9bb3b775df4f8b9f$var$Layout$1.u40be = (property)=>new $9bb3b775df4f8b9f$var$UIntBE(5, property);
/** Factory for {@link UInt|big-endian unsigned int layouts}
 * spanning six bytes. */ $9bb3b775df4f8b9f$var$Layout$1.u48be = (property)=>new $9bb3b775df4f8b9f$var$UIntBE(6, property);
/** Factory for {@link NearUInt64BE|big-endian unsigned int
 * layouts} interpreted as Numbers. */ $9bb3b775df4f8b9f$var$Layout$1.nu64be = (property)=>new $9bb3b775df4f8b9f$var$NearUInt64BE(property);
/** Factory for {@link Int|signed int layouts} spanning one
 * byte. */ $9bb3b775df4f8b9f$var$Layout$1.s8 = (property)=>new $9bb3b775df4f8b9f$var$Int(1, property);
/** Factory for {@link Int|little-endian signed int layouts}
 * spanning two bytes. */ $9bb3b775df4f8b9f$var$Layout$1.s16 = (property)=>new $9bb3b775df4f8b9f$var$Int(2, property);
/** Factory for {@link Int|little-endian signed int layouts}
 * spanning three bytes. */ $9bb3b775df4f8b9f$var$Layout$1.s24 = (property)=>new $9bb3b775df4f8b9f$var$Int(3, property);
/** Factory for {@link Int|little-endian signed int layouts}
 * spanning four bytes. */ $9bb3b775df4f8b9f$var$Layout$1.s32 = (property)=>new $9bb3b775df4f8b9f$var$Int(4, property);
/** Factory for {@link Int|little-endian signed int layouts}
 * spanning five bytes. */ $9bb3b775df4f8b9f$var$Layout$1.s40 = (property)=>new $9bb3b775df4f8b9f$var$Int(5, property);
/** Factory for {@link Int|little-endian signed int layouts}
 * spanning six bytes. */ $9bb3b775df4f8b9f$var$Layout$1.s48 = (property)=>new $9bb3b775df4f8b9f$var$Int(6, property);
/** Factory for {@link NearInt64|little-endian signed int layouts}
 * interpreted as Numbers. */ $9bb3b775df4f8b9f$var$Layout$1.ns64 = (property)=>new $9bb3b775df4f8b9f$var$NearInt64(property);
/** Factory for {@link Int|big-endian signed int layouts}
 * spanning two bytes. */ $9bb3b775df4f8b9f$var$Layout$1.s16be = (property)=>new $9bb3b775df4f8b9f$var$IntBE(2, property);
/** Factory for {@link Int|big-endian signed int layouts}
 * spanning three bytes. */ $9bb3b775df4f8b9f$var$Layout$1.s24be = (property)=>new $9bb3b775df4f8b9f$var$IntBE(3, property);
/** Factory for {@link Int|big-endian signed int layouts}
 * spanning four bytes. */ $9bb3b775df4f8b9f$var$Layout$1.s32be = (property)=>new $9bb3b775df4f8b9f$var$IntBE(4, property);
/** Factory for {@link Int|big-endian signed int layouts}
 * spanning five bytes. */ $9bb3b775df4f8b9f$var$Layout$1.s40be = (property)=>new $9bb3b775df4f8b9f$var$IntBE(5, property);
/** Factory for {@link Int|big-endian signed int layouts}
 * spanning six bytes. */ $9bb3b775df4f8b9f$var$Layout$1.s48be = (property)=>new $9bb3b775df4f8b9f$var$IntBE(6, property);
/** Factory for {@link NearInt64BE|big-endian signed int layouts}
 * interpreted as Numbers. */ $9bb3b775df4f8b9f$var$Layout$1.ns64be = (property)=>new $9bb3b775df4f8b9f$var$NearInt64BE(property);
/** Factory for {@link Float|little-endian 32-bit floating point} values. */ $9bb3b775df4f8b9f$var$Layout$1.f32 = (property)=>new $9bb3b775df4f8b9f$var$Float(property);
/** Factory for {@link FloatBE|big-endian 32-bit floating point} values. */ $9bb3b775df4f8b9f$var$Layout$1.f32be = (property)=>new $9bb3b775df4f8b9f$var$FloatBE(property);
/** Factory for {@link Double|little-endian 64-bit floating point} values. */ $9bb3b775df4f8b9f$var$Layout$1.f64 = (property)=>new $9bb3b775df4f8b9f$var$Double(property);
/** Factory for {@link DoubleBE|big-endian 64-bit floating point} values. */ $9bb3b775df4f8b9f$var$Layout$1.f64be = (property)=>new $9bb3b775df4f8b9f$var$DoubleBE(property);
/** Factory for {@link Structure} values. */ var $9bb3b775df4f8b9f$var$struct = $9bb3b775df4f8b9f$var$Layout$1.struct = (fields, property, decodePrefixes)=>new $9bb3b775df4f8b9f$var$Structure(fields, property, decodePrefixes);
/** Factory for {@link BitStructure} values. */ $9bb3b775df4f8b9f$var$Layout$1.bits = (word, msb, property)=>new $9bb3b775df4f8b9f$var$BitStructure(word, msb, property);
/** Factory for {@link Sequence} values. */ $9bb3b775df4f8b9f$var$Layout$1.seq = (elementLayout, count, property)=>new $9bb3b775df4f8b9f$var$Sequence(elementLayout, count, property);
/** Factory for {@link Union} values. */ $9bb3b775df4f8b9f$var$Layout$1.union = (discr, defaultLayout, property)=>new $9bb3b775df4f8b9f$var$Union(discr, defaultLayout, property);
/** Factory for {@link UnionLayoutDiscriminator} values. */ $9bb3b775df4f8b9f$var$Layout$1.unionLayoutDiscriminator = (layout, property)=>new $9bb3b775df4f8b9f$var$UnionLayoutDiscriminator(layout, property);
/** Factory for {@link Blob} values. */ var $9bb3b775df4f8b9f$var$blob = $9bb3b775df4f8b9f$var$Layout$1.blob = (length, property)=>new $9bb3b775df4f8b9f$var$Blob(length, property);
/** Factory for {@link CString} values. */ $9bb3b775df4f8b9f$var$Layout$1.cstr = (property)=>new $9bb3b775df4f8b9f$var$CString(property);
/** Factory for {@link UTF8} values. */ $9bb3b775df4f8b9f$var$Layout$1.utf8 = (maxSpan, property)=>new $9bb3b775df4f8b9f$var$UTF8(maxSpan, property);
/** Factory for {@link Constant} values. */ $9bb3b775df4f8b9f$var$Layout$1.const = (value, property)=>new $9bb3b775df4f8b9f$var$Constant(value, property);
//      
/**
 * Layout for a public key
 */ const $9bb3b775df4f8b9f$var$publicKey = (property = "publicKey")=>{
    return $9bb3b775df4f8b9f$var$blob(32, property);
};
/**
 * Layout for a 64bit unsigned value
 */ const $9bb3b775df4f8b9f$var$uint64 = (property = "uint64")=>{
    return $9bb3b775df4f8b9f$var$blob(8, property);
};
//      
function $9bb3b775df4f8b9f$var$sendAndConfirmTransaction(title, connection, transaction, ...signers) {
    return (0, $gNDby.sendAndConfirmTransaction)(connection, transaction, signers, {
        skipPreflight: false
    });
}
const $9bb3b775df4f8b9f$export$79de3e3c2b1ca801 = new (0, $gNDby.PublicKey)("TokenkegQfeZyiNwAJbNbGKPFXCWuBvf9Ss623VQ5DA");
const $9bb3b775df4f8b9f$export$57a4f33bcc1767fa = new (0, $gNDby.PublicKey)("ATokenGPvbdGVxr1b2hvZbsiqW5xWH25efTNsLJA8knL");
const $9bb3b775df4f8b9f$var$FAILED_TO_FIND_ACCOUNT = "Failed to find account";
const $9bb3b775df4f8b9f$var$INVALID_ACCOUNT_OWNER = "Invalid account owner";
/**
 * Unfortunately, BufferLayout.encode uses an `instanceof` check for `Buffer`
 * which fails when using `publicKey.toBuffer()` directly because the bundled `Buffer`
 * class in `@solana/web3.js` is different from the bundled `Buffer` class in this package
 */ function $9bb3b775df4f8b9f$var$pubkeyToBuffer(publicKey) {
    return $9bb3b775df4f8b9f$var$buffer.Buffer.from(publicKey.toBuffer());
}
/**
 * 64-bit value
 */ class $9bb3b775df4f8b9f$export$cd1442401e54cffa extends (0, (/*@__PURE__*/$parcel$interopDefault($dEXSZ))) {
    /**
   * Convert to Buffer representation
   */ toBuffer() {
        const a = super.toArray().reverse();
        const b = $9bb3b775df4f8b9f$var$buffer.Buffer.from(a);
        if (b.length === 8) return b;
        $9bb3b775df4f8b9f$var$assert(b.length < 8, "u64 too large");
        const zeroPad = $9bb3b775df4f8b9f$var$buffer.Buffer.alloc(8);
        b.copy(zeroPad);
        return zeroPad;
    }
    /**
   * Construct a u64 from Buffer representation
   */ static fromBuffer(buffer) {
        $9bb3b775df4f8b9f$var$assert(buffer.length === 8, `Invalid buffer length: ${buffer.length}`);
        return new $9bb3b775df4f8b9f$export$cd1442401e54cffa([
            ...buffer
        ].reverse().map((i)=>`00${i.toString(16)}`.slice(-2)).join(""), 16);
    }
}
function $9bb3b775df4f8b9f$var$isAccount(accountOrPublicKey) {
    return "publicKey" in accountOrPublicKey;
}
const $9bb3b775df4f8b9f$var$AuthorityTypeCodes = {
    MintTokens: 0,
    FreezeAccount: 1,
    AccountOwner: 2,
    CloseAccount: 3
}; // The address of the special mint for wrapped native token.
const $9bb3b775df4f8b9f$export$71f490c6a4aef7af = new (0, $gNDby.PublicKey)("So11111111111111111111111111111111111111112");
/**
 * Information about the mint
 */ const $9bb3b775df4f8b9f$export$1374e91decd2fbe5 = $9bb3b775df4f8b9f$var$struct([
    $9bb3b775df4f8b9f$var$u32("mintAuthorityOption"),
    $9bb3b775df4f8b9f$var$publicKey("mintAuthority"),
    $9bb3b775df4f8b9f$var$uint64("supply"),
    $9bb3b775df4f8b9f$var$u8("decimals"),
    $9bb3b775df4f8b9f$var$u8("isInitialized"),
    $9bb3b775df4f8b9f$var$u32("freezeAuthorityOption"),
    $9bb3b775df4f8b9f$var$publicKey("freezeAuthority")
]);
/**
 * Information about an account
 */ /**
 * @private
 */ const $9bb3b775df4f8b9f$export$cab31ec27f6c5fa = $9bb3b775df4f8b9f$var$struct([
    $9bb3b775df4f8b9f$var$publicKey("mint"),
    $9bb3b775df4f8b9f$var$publicKey("owner"),
    $9bb3b775df4f8b9f$var$uint64("amount"),
    $9bb3b775df4f8b9f$var$u32("delegateOption"),
    $9bb3b775df4f8b9f$var$publicKey("delegate"),
    $9bb3b775df4f8b9f$var$u8("state"),
    $9bb3b775df4f8b9f$var$u32("isNativeOption"),
    $9bb3b775df4f8b9f$var$uint64("isNative"),
    $9bb3b775df4f8b9f$var$uint64("delegatedAmount"),
    $9bb3b775df4f8b9f$var$u32("closeAuthorityOption"),
    $9bb3b775df4f8b9f$var$publicKey("closeAuthority")
]);
/**
 * Information about an multisig
 */ /**
 * @private
 */ const $9bb3b775df4f8b9f$var$MultisigLayout = $9bb3b775df4f8b9f$var$struct([
    $9bb3b775df4f8b9f$var$u8("m"),
    $9bb3b775df4f8b9f$var$u8("n"),
    $9bb3b775df4f8b9f$var$u8("is_initialized"),
    $9bb3b775df4f8b9f$var$publicKey("signer1"),
    $9bb3b775df4f8b9f$var$publicKey("signer2"),
    $9bb3b775df4f8b9f$var$publicKey("signer3"),
    $9bb3b775df4f8b9f$var$publicKey("signer4"),
    $9bb3b775df4f8b9f$var$publicKey("signer5"),
    $9bb3b775df4f8b9f$var$publicKey("signer6"),
    $9bb3b775df4f8b9f$var$publicKey("signer7"),
    $9bb3b775df4f8b9f$var$publicKey("signer8"),
    $9bb3b775df4f8b9f$var$publicKey("signer9"),
    $9bb3b775df4f8b9f$var$publicKey("signer10"),
    $9bb3b775df4f8b9f$var$publicKey("signer11")
]);
/**
 * An ERC20-like Token
 */ class $9bb3b775df4f8b9f$export$50792b0e93539fde {
    /**
   * @private
   */ /**
   * The public key identifying this mint
   */ /**
   * Program Identifier for the Token program
   */ /**
   * Program Identifier for the Associated Token program
   */ /**
   * Fee payer
   */ /**
   * Create a Token object attached to the specific mint
   *
   * @param connection The connection to use
   * @param token Public key of the mint
   * @param programId token programId
   * @param payer Payer of fees
   */ constructor(connection, publicKey, programId, payer){
        (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(this, "connection", void 0);
        (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(this, "publicKey", void 0);
        (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(this, "programId", void 0);
        (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(this, "associatedProgramId", void 0);
        (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(this, "payer", void 0);
        Object.assign(this, {
            connection: connection,
            publicKey: publicKey,
            programId: programId,
            payer: payer,
            // Hard code is ok; Overriding is needed only for tests
            associatedProgramId: $9bb3b775df4f8b9f$export$57a4f33bcc1767fa
        });
    }
    /**
   * Get the minimum balance for the mint to be rent exempt
   *
   * @return Number of lamports required
   */ static async getMinBalanceRentForExemptMint(connection) {
        return await connection.getMinimumBalanceForRentExemption($9bb3b775df4f8b9f$export$1374e91decd2fbe5.span);
    }
    /**
   * Get the minimum balance for the account to be rent exempt
   *
   * @return Number of lamports required
   */ static async getMinBalanceRentForExemptAccount(connection) {
        return await connection.getMinimumBalanceForRentExemption($9bb3b775df4f8b9f$export$cab31ec27f6c5fa.span);
    }
    /**
   * Get the minimum balance for the multsig to be rent exempt
   *
   * @return Number of lamports required
   */ static async getMinBalanceRentForExemptMultisig(connection) {
        return await connection.getMinimumBalanceForRentExemption($9bb3b775df4f8b9f$var$MultisigLayout.span);
    }
    /**
   * Create and initialize a token.
   *
   * @param connection The connection to use
   * @param payer Fee payer for transaction
   * @param mintAuthority Account or multisig that will control minting
   * @param freezeAuthority Optional account or multisig that can freeze token accounts
   * @param decimals Location of the decimal place
   * @param programId Optional token programId, uses the system programId by default
   * @return Token object for the newly minted token
   */ static async createMint(connection, payer, mintAuthority, freezeAuthority, decimals, programId) {
        const mintAccount = (0, $gNDby.Keypair).generate();
        const token = new $9bb3b775df4f8b9f$export$50792b0e93539fde(connection, mintAccount.publicKey, programId, payer); // Allocate memory for the account
        const balanceNeeded = await $9bb3b775df4f8b9f$export$50792b0e93539fde.getMinBalanceRentForExemptMint(connection);
        const transaction = new (0, $gNDby.Transaction)();
        transaction.add((0, $gNDby.SystemProgram).createAccount({
            fromPubkey: payer.publicKey,
            newAccountPubkey: mintAccount.publicKey,
            lamports: balanceNeeded,
            space: $9bb3b775df4f8b9f$export$1374e91decd2fbe5.span,
            programId: programId
        }));
        transaction.add($9bb3b775df4f8b9f$export$50792b0e93539fde.createInitMintInstruction(programId, mintAccount.publicKey, decimals, mintAuthority, freezeAuthority)); // Send the two instructions
        await $9bb3b775df4f8b9f$var$sendAndConfirmTransaction("createAccount and InitializeMint", connection, transaction, payer, mintAccount);
        return token;
    }
    /**
   * Create and initialize a new account.
   *
   * This account may then be used as a `transfer()` or `approve()` destination
   *
   * @param owner User account that will own the new account
   * @return Public key of the new empty account
   */ async createAccount(owner) {
        // Allocate memory for the account
        const balanceNeeded = await $9bb3b775df4f8b9f$export$50792b0e93539fde.getMinBalanceRentForExemptAccount(this.connection);
        const newAccount = (0, $gNDby.Keypair).generate();
        const transaction = new (0, $gNDby.Transaction)();
        transaction.add((0, $gNDby.SystemProgram).createAccount({
            fromPubkey: this.payer.publicKey,
            newAccountPubkey: newAccount.publicKey,
            lamports: balanceNeeded,
            space: $9bb3b775df4f8b9f$export$cab31ec27f6c5fa.span,
            programId: this.programId
        }));
        const mintPublicKey = this.publicKey;
        transaction.add($9bb3b775df4f8b9f$export$50792b0e93539fde.createInitAccountInstruction(this.programId, mintPublicKey, newAccount.publicKey, owner)); // Send the two instructions
        await $9bb3b775df4f8b9f$var$sendAndConfirmTransaction("createAccount and InitializeAccount", this.connection, transaction, this.payer, newAccount);
        return newAccount.publicKey;
    }
    /**
   * Create and initialize the associated account.
   *
   * This account may then be used as a `transfer()` or `approve()` destination
   *
   * @param owner User account that will own the new account
   * @return Public key of the new associated account
   */ async createAssociatedTokenAccount(owner) {
        const associatedAddress = await $9bb3b775df4f8b9f$export$50792b0e93539fde.getAssociatedTokenAddress(this.associatedProgramId, this.programId, this.publicKey, owner);
        return this.createAssociatedTokenAccountInternal(owner, associatedAddress);
    }
    async createAssociatedTokenAccountInternal(owner, associatedAddress) {
        await $9bb3b775df4f8b9f$var$sendAndConfirmTransaction("CreateAssociatedTokenAccount", this.connection, new (0, $gNDby.Transaction)().add($9bb3b775df4f8b9f$export$50792b0e93539fde.createAssociatedTokenAccountInstruction(this.associatedProgramId, this.programId, this.publicKey, associatedAddress, owner, this.payer.publicKey)), this.payer);
        return associatedAddress;
    }
    /**
   * Retrieve the associated account or create one if not found.
   *
   * This account may then be used as a `transfer()` or `approve()` destination
   *
   * @param owner User account that will own the new account
   * @return The new associated account
   */ async getOrCreateAssociatedAccountInfo(owner) {
        const associatedAddress = await $9bb3b775df4f8b9f$export$50792b0e93539fde.getAssociatedTokenAddress(this.associatedProgramId, this.programId, this.publicKey, owner); // This is the optimum logic, considering TX fee, client-side computation,
        // RPC roundtrips and guaranteed idempotent.
        // Sadly we can't do this atomically;
        try {
            return await this.getAccountInfo(associatedAddress);
        } catch (err) {
            // INVALID_ACCOUNT_OWNER can be possible if the associatedAddress has
            // already been received some lamports (= became system accounts).
            // Assuming program derived addressing is safe, this is the only case
            // for the INVALID_ACCOUNT_OWNER in this code-path
            if (err.message === $9bb3b775df4f8b9f$var$FAILED_TO_FIND_ACCOUNT || err.message === $9bb3b775df4f8b9f$var$INVALID_ACCOUNT_OWNER) {
                // as this isn't atomic, it's possible others can create associated
                // accounts meanwhile
                try {
                    await this.createAssociatedTokenAccountInternal(owner, associatedAddress);
                } catch (err) {
                // selectively ignore the expected instruction error if the
                // associated account is existing already.
                } // Now this should always succeed
                return await this.getAccountInfo(associatedAddress);
            } else throw err;
        }
    }
    /**
   * Create and initialize a new account on the special native token mint.
   *
   * In order to be wrapped, the account must have a balance of native tokens
   * when it is initialized with the token program.
   *
   * This function sends lamports to the new account before initializing it.
   *
   * @param connection A solana web3 connection
   * @param programId The token program ID
   * @param owner The owner of the new token account
   * @param payer The source of the lamports to initialize, and payer of the initialization fees.
   * @param amount The amount of lamports to wrap
   * @return {Promise<PublicKey>} The new token account
   */ static async createWrappedNativeAccount(connection, programId, owner, payer, amount) {
        // Allocate memory for the account
        const balanceNeeded = await $9bb3b775df4f8b9f$export$50792b0e93539fde.getMinBalanceRentForExemptAccount(connection); // Create a new account
        const newAccount = (0, $gNDby.Keypair).generate();
        const transaction = new (0, $gNDby.Transaction)();
        transaction.add((0, $gNDby.SystemProgram).createAccount({
            fromPubkey: payer.publicKey,
            newAccountPubkey: newAccount.publicKey,
            lamports: balanceNeeded,
            space: $9bb3b775df4f8b9f$export$cab31ec27f6c5fa.span,
            programId: programId
        })); // Send lamports to it (these will be wrapped into native tokens by the token program)
        transaction.add((0, $gNDby.SystemProgram).transfer({
            fromPubkey: payer.publicKey,
            toPubkey: newAccount.publicKey,
            lamports: amount
        })); // Assign the new account to the native token mint.
        // the account will be initialized with a balance equal to the native token balance.
        // (i.e. amount)
        transaction.add($9bb3b775df4f8b9f$export$50792b0e93539fde.createInitAccountInstruction(programId, $9bb3b775df4f8b9f$export$71f490c6a4aef7af, newAccount.publicKey, owner)); // Send the three instructions
        await $9bb3b775df4f8b9f$var$sendAndConfirmTransaction("createAccount, transfer, and initializeAccount", connection, transaction, payer, newAccount);
        return newAccount.publicKey;
    }
    /**
   * Create and initialize a new multisig.
   *
   * This account may then be used for multisignature verification
   *
   * @param m Number of required signatures
   * @param signers Full set of signers
   * @return Public key of the new multisig account
   */ async createMultisig(m, signers) {
        const multisigAccount = (0, $gNDby.Keypair).generate(); // Allocate memory for the account
        const balanceNeeded = await $9bb3b775df4f8b9f$export$50792b0e93539fde.getMinBalanceRentForExemptMultisig(this.connection);
        const transaction = new (0, $gNDby.Transaction)();
        transaction.add((0, $gNDby.SystemProgram).createAccount({
            fromPubkey: this.payer.publicKey,
            newAccountPubkey: multisigAccount.publicKey,
            lamports: balanceNeeded,
            space: $9bb3b775df4f8b9f$var$MultisigLayout.span,
            programId: this.programId
        })); // create the new account
        let keys = [
            {
                pubkey: multisigAccount.publicKey,
                isSigner: false,
                isWritable: true
            },
            {
                pubkey: (0, $gNDby.SYSVAR_RENT_PUBKEY),
                isSigner: false,
                isWritable: false
            }
        ];
        signers.forEach((signer)=>keys.push({
                pubkey: signer,
                isSigner: false,
                isWritable: false
            }));
        const dataLayout = $9bb3b775df4f8b9f$var$struct([
            $9bb3b775df4f8b9f$var$u8("instruction"),
            $9bb3b775df4f8b9f$var$u8("m")
        ]);
        const data = $9bb3b775df4f8b9f$var$buffer.Buffer.alloc(dataLayout.span);
        dataLayout.encode({
            instruction: 2,
            m: // InitializeMultisig instruction
            m
        }, data);
        transaction.add({
            keys: keys,
            programId: this.programId,
            data: data
        }); // Send the two instructions
        await $9bb3b775df4f8b9f$var$sendAndConfirmTransaction("createAccount and InitializeMultisig", this.connection, transaction, this.payer, multisigAccount);
        return multisigAccount.publicKey;
    }
    /**
   * Retrieve mint information
   */ async getMintInfo() {
        const info = await this.connection.getAccountInfo(this.publicKey);
        if (info === null) throw new Error("Failed to find mint account");
        if (!info.owner.equals(this.programId)) throw new Error(`Invalid mint owner: ${JSON.stringify(info.owner)}`);
        if (info.data.length != $9bb3b775df4f8b9f$export$1374e91decd2fbe5.span) throw new Error(`Invalid mint size`);
        const data = $9bb3b775df4f8b9f$var$buffer.Buffer.from(info.data);
        const mintInfo = $9bb3b775df4f8b9f$export$1374e91decd2fbe5.decode(data);
        if (mintInfo.mintAuthorityOption === 0) mintInfo.mintAuthority = null;
        else mintInfo.mintAuthority = new (0, $gNDby.PublicKey)(mintInfo.mintAuthority);
        mintInfo.supply = $9bb3b775df4f8b9f$export$cd1442401e54cffa.fromBuffer(mintInfo.supply);
        mintInfo.isInitialized = mintInfo.isInitialized != 0;
        if (mintInfo.freezeAuthorityOption === 0) mintInfo.freezeAuthority = null;
        else mintInfo.freezeAuthority = new (0, $gNDby.PublicKey)(mintInfo.freezeAuthority);
        return mintInfo;
    }
    /**
   * Retrieve account information
   *
   * @param account Public key of the account
   */ async getAccountInfo(account, commitment) {
        const info = await this.connection.getAccountInfo(account, commitment);
        if (info === null) throw new Error($9bb3b775df4f8b9f$var$FAILED_TO_FIND_ACCOUNT);
        if (!info.owner.equals(this.programId)) throw new Error($9bb3b775df4f8b9f$var$INVALID_ACCOUNT_OWNER);
        if (info.data.length != $9bb3b775df4f8b9f$export$cab31ec27f6c5fa.span) throw new Error(`Invalid account size`);
        const data = $9bb3b775df4f8b9f$var$buffer.Buffer.from(info.data);
        const accountInfo = $9bb3b775df4f8b9f$export$cab31ec27f6c5fa.decode(data);
        accountInfo.address = account;
        accountInfo.mint = new (0, $gNDby.PublicKey)(accountInfo.mint);
        accountInfo.owner = new (0, $gNDby.PublicKey)(accountInfo.owner);
        accountInfo.amount = $9bb3b775df4f8b9f$export$cd1442401e54cffa.fromBuffer(accountInfo.amount);
        if (accountInfo.delegateOption === 0) {
            accountInfo.delegate = null;
            accountInfo.delegatedAmount = new $9bb3b775df4f8b9f$export$cd1442401e54cffa();
        } else {
            accountInfo.delegate = new (0, $gNDby.PublicKey)(accountInfo.delegate);
            accountInfo.delegatedAmount = $9bb3b775df4f8b9f$export$cd1442401e54cffa.fromBuffer(accountInfo.delegatedAmount);
        }
        accountInfo.isInitialized = accountInfo.state !== 0;
        accountInfo.isFrozen = accountInfo.state === 2;
        if (accountInfo.isNativeOption === 1) {
            accountInfo.rentExemptReserve = $9bb3b775df4f8b9f$export$cd1442401e54cffa.fromBuffer(accountInfo.isNative);
            accountInfo.isNative = true;
        } else {
            accountInfo.rentExemptReserve = null;
            accountInfo.isNative = false;
        }
        if (accountInfo.closeAuthorityOption === 0) accountInfo.closeAuthority = null;
        else accountInfo.closeAuthority = new (0, $gNDby.PublicKey)(accountInfo.closeAuthority);
        if (!accountInfo.mint.equals(this.publicKey)) throw new Error(`Invalid account mint: ${JSON.stringify(accountInfo.mint)} !== ${JSON.stringify(this.publicKey)}`);
        return accountInfo;
    }
    /**
   * Retrieve Multisig information
   *
   * @param multisig Public key of the account
   */ async getMultisigInfo(multisig) {
        const info = await this.connection.getAccountInfo(multisig);
        if (info === null) throw new Error("Failed to find multisig");
        if (!info.owner.equals(this.programId)) throw new Error(`Invalid multisig owner`);
        if (info.data.length != $9bb3b775df4f8b9f$var$MultisigLayout.span) throw new Error(`Invalid multisig size`);
        const data = $9bb3b775df4f8b9f$var$buffer.Buffer.from(info.data);
        const multisigInfo = $9bb3b775df4f8b9f$var$MultisigLayout.decode(data);
        multisigInfo.signer1 = new (0, $gNDby.PublicKey)(multisigInfo.signer1);
        multisigInfo.signer2 = new (0, $gNDby.PublicKey)(multisigInfo.signer2);
        multisigInfo.signer3 = new (0, $gNDby.PublicKey)(multisigInfo.signer3);
        multisigInfo.signer4 = new (0, $gNDby.PublicKey)(multisigInfo.signer4);
        multisigInfo.signer5 = new (0, $gNDby.PublicKey)(multisigInfo.signer5);
        multisigInfo.signer6 = new (0, $gNDby.PublicKey)(multisigInfo.signer6);
        multisigInfo.signer7 = new (0, $gNDby.PublicKey)(multisigInfo.signer7);
        multisigInfo.signer8 = new (0, $gNDby.PublicKey)(multisigInfo.signer8);
        multisigInfo.signer9 = new (0, $gNDby.PublicKey)(multisigInfo.signer9);
        multisigInfo.signer10 = new (0, $gNDby.PublicKey)(multisigInfo.signer10);
        multisigInfo.signer11 = new (0, $gNDby.PublicKey)(multisigInfo.signer11);
        return multisigInfo;
    }
    /**
   * Transfer tokens to another account
   *
   * @param source Source account
   * @param destination Destination account
   * @param owner Owner of the source account
   * @param multiSigners Signing accounts if `owner` is a multiSig
   * @param amount Number of tokens to transfer
   */ async transfer(source, destination, owner, multiSigners, amount) {
        let ownerPublicKey;
        let signers;
        if ($9bb3b775df4f8b9f$var$isAccount(owner)) {
            ownerPublicKey = owner.publicKey;
            signers = [
                owner
            ];
        } else {
            ownerPublicKey = owner;
            signers = multiSigners;
        }
        return await $9bb3b775df4f8b9f$var$sendAndConfirmTransaction("Transfer", this.connection, new (0, $gNDby.Transaction)().add($9bb3b775df4f8b9f$export$50792b0e93539fde.createTransferInstruction(this.programId, source, destination, ownerPublicKey, multiSigners, amount)), this.payer, ...signers);
    }
    /**
   * Grant a third-party permission to transfer up the specified number of tokens from an account
   *
   * @param account Public key of the account
   * @param delegate Account authorized to perform a transfer tokens from the source account
   * @param owner Owner of the source account
   * @param multiSigners Signing accounts if `owner` is a multiSig
   * @param amount Maximum number of tokens the delegate may transfer
   */ async approve(account, delegate, owner, multiSigners, amount) {
        let ownerPublicKey;
        let signers;
        if ($9bb3b775df4f8b9f$var$isAccount(owner)) {
            ownerPublicKey = owner.publicKey;
            signers = [
                owner
            ];
        } else {
            ownerPublicKey = owner;
            signers = multiSigners;
        }
        await $9bb3b775df4f8b9f$var$sendAndConfirmTransaction("Approve", this.connection, new (0, $gNDby.Transaction)().add($9bb3b775df4f8b9f$export$50792b0e93539fde.createApproveInstruction(this.programId, account, delegate, ownerPublicKey, multiSigners, amount)), this.payer, ...signers);
    }
    /**
   * Remove approval for the transfer of any remaining tokens
   *
   * @param account Public key of the account
   * @param owner Owner of the source account
   * @param multiSigners Signing accounts if `owner` is a multiSig
   */ async revoke(account, owner, multiSigners) {
        let ownerPublicKey;
        let signers;
        if ($9bb3b775df4f8b9f$var$isAccount(owner)) {
            ownerPublicKey = owner.publicKey;
            signers = [
                owner
            ];
        } else {
            ownerPublicKey = owner;
            signers = multiSigners;
        }
        await $9bb3b775df4f8b9f$var$sendAndConfirmTransaction("Revoke", this.connection, new (0, $gNDby.Transaction)().add($9bb3b775df4f8b9f$export$50792b0e93539fde.createRevokeInstruction(this.programId, account, ownerPublicKey, multiSigners)), this.payer, ...signers);
    }
    /**
   * Assign a new authority to the account
   *
   * @param account Public key of the account
   * @param newAuthority New authority of the account
   * @param authorityType Type of authority to set
   * @param currentAuthority Current authority of the account
   * @param multiSigners Signing accounts if `currentAuthority` is a multiSig
   */ async setAuthority(account, newAuthority, authorityType, currentAuthority, multiSigners) {
        let currentAuthorityPublicKey;
        let signers;
        if ($9bb3b775df4f8b9f$var$isAccount(currentAuthority)) {
            currentAuthorityPublicKey = currentAuthority.publicKey;
            signers = [
                currentAuthority
            ];
        } else {
            currentAuthorityPublicKey = currentAuthority;
            signers = multiSigners;
        }
        await $9bb3b775df4f8b9f$var$sendAndConfirmTransaction("SetAuthority", this.connection, new (0, $gNDby.Transaction)().add($9bb3b775df4f8b9f$export$50792b0e93539fde.createSetAuthorityInstruction(this.programId, account, newAuthority, authorityType, currentAuthorityPublicKey, multiSigners)), this.payer, ...signers);
    }
    /**
   * Mint new tokens
   *
   * @param dest Public key of the account to mint to
   * @param authority Minting authority
   * @param multiSigners Signing accounts if `authority` is a multiSig
   * @param amount Amount to mint
   */ async mintTo(dest, authority, multiSigners, amount) {
        let ownerPublicKey;
        let signers;
        if ($9bb3b775df4f8b9f$var$isAccount(authority)) {
            ownerPublicKey = authority.publicKey;
            signers = [
                authority
            ];
        } else {
            ownerPublicKey = authority;
            signers = multiSigners;
        }
        await $9bb3b775df4f8b9f$var$sendAndConfirmTransaction("MintTo", this.connection, new (0, $gNDby.Transaction)().add($9bb3b775df4f8b9f$export$50792b0e93539fde.createMintToInstruction(this.programId, this.publicKey, dest, ownerPublicKey, multiSigners, amount)), this.payer, ...signers);
    }
    /**
   * Burn tokens
   *
   * @param account Account to burn tokens from
   * @param owner Account owner
   * @param multiSigners Signing accounts if `owner` is a multiSig
   * @param amount Amount to burn
   */ async burn(account, owner, multiSigners, amount) {
        let ownerPublicKey;
        let signers;
        if ($9bb3b775df4f8b9f$var$isAccount(owner)) {
            ownerPublicKey = owner.publicKey;
            signers = [
                owner
            ];
        } else {
            ownerPublicKey = owner;
            signers = multiSigners;
        }
        await $9bb3b775df4f8b9f$var$sendAndConfirmTransaction("Burn", this.connection, new (0, $gNDby.Transaction)().add($9bb3b775df4f8b9f$export$50792b0e93539fde.createBurnInstruction(this.programId, this.publicKey, account, ownerPublicKey, multiSigners, amount)), this.payer, ...signers);
    }
    /**
   * Close account
   *
   * @param account Account to close
   * @param dest Account to receive the remaining balance of the closed account
   * @param authority Authority which is allowed to close the account
   * @param multiSigners Signing accounts if `authority` is a multiSig
   */ async closeAccount(account, dest, authority, multiSigners) {
        let authorityPublicKey;
        let signers;
        if ($9bb3b775df4f8b9f$var$isAccount(authority)) {
            authorityPublicKey = authority.publicKey;
            signers = [
                authority
            ];
        } else {
            authorityPublicKey = authority;
            signers = multiSigners;
        }
        await $9bb3b775df4f8b9f$var$sendAndConfirmTransaction("CloseAccount", this.connection, new (0, $gNDby.Transaction)().add($9bb3b775df4f8b9f$export$50792b0e93539fde.createCloseAccountInstruction(this.programId, account, dest, authorityPublicKey, multiSigners)), this.payer, ...signers);
    }
    /**
   * Freeze account
   *
   * @param account Account to freeze
   * @param authority The mint freeze authority
   * @param multiSigners Signing accounts if `authority` is a multiSig
   */ async freezeAccount(account, authority, multiSigners) {
        let authorityPublicKey;
        let signers;
        if ($9bb3b775df4f8b9f$var$isAccount(authority)) {
            authorityPublicKey = authority.publicKey;
            signers = [
                authority
            ];
        } else {
            authorityPublicKey = authority;
            signers = multiSigners;
        }
        await $9bb3b775df4f8b9f$var$sendAndConfirmTransaction("FreezeAccount", this.connection, new (0, $gNDby.Transaction)().add($9bb3b775df4f8b9f$export$50792b0e93539fde.createFreezeAccountInstruction(this.programId, account, this.publicKey, authorityPublicKey, multiSigners)), this.payer, ...signers);
    }
    /**
   * Thaw account
   *
   * @param account Account to thaw
   * @param authority The mint freeze authority
   * @param multiSigners Signing accounts if `authority` is a multiSig
   */ async thawAccount(account, authority, multiSigners) {
        let authorityPublicKey;
        let signers;
        if ($9bb3b775df4f8b9f$var$isAccount(authority)) {
            authorityPublicKey = authority.publicKey;
            signers = [
                authority
            ];
        } else {
            authorityPublicKey = authority;
            signers = multiSigners;
        }
        await $9bb3b775df4f8b9f$var$sendAndConfirmTransaction("ThawAccount", this.connection, new (0, $gNDby.Transaction)().add($9bb3b775df4f8b9f$export$50792b0e93539fde.createThawAccountInstruction(this.programId, account, this.publicKey, authorityPublicKey, multiSigners)), this.payer, ...signers);
    }
    /**
   * Transfer tokens to another account, asserting the token mint and decimals
   *
   * @param source Source account
   * @param destination Destination account
   * @param owner Owner of the source account
   * @param multiSigners Signing accounts if `owner` is a multiSig
   * @param amount Number of tokens to transfer
   * @param decimals Number of decimals in transfer amount
   */ async transferChecked(source, destination, owner, multiSigners, amount, decimals) {
        let ownerPublicKey;
        let signers;
        if ($9bb3b775df4f8b9f$var$isAccount(owner)) {
            ownerPublicKey = owner.publicKey;
            signers = [
                owner
            ];
        } else {
            ownerPublicKey = owner;
            signers = multiSigners;
        }
        return await $9bb3b775df4f8b9f$var$sendAndConfirmTransaction("TransferChecked", this.connection, new (0, $gNDby.Transaction)().add($9bb3b775df4f8b9f$export$50792b0e93539fde.createTransferCheckedInstruction(this.programId, source, this.publicKey, destination, ownerPublicKey, multiSigners, amount, decimals)), this.payer, ...signers);
    }
    /**
   * Grant a third-party permission to transfer up the specified number of tokens from an account,
   * asserting the token mint and decimals
   *
   * @param account Public key of the account
   * @param delegate Account authorized to perform a transfer tokens from the source account
   * @param owner Owner of the source account
   * @param multiSigners Signing accounts if `owner` is a multiSig
   * @param amount Maximum number of tokens the delegate may transfer
   * @param decimals Number of decimals in approve amount
   */ async approveChecked(account, delegate, owner, multiSigners, amount, decimals) {
        let ownerPublicKey;
        let signers;
        if ($9bb3b775df4f8b9f$var$isAccount(owner)) {
            ownerPublicKey = owner.publicKey;
            signers = [
                owner
            ];
        } else {
            ownerPublicKey = owner;
            signers = multiSigners;
        }
        await $9bb3b775df4f8b9f$var$sendAndConfirmTransaction("ApproveChecked", this.connection, new (0, $gNDby.Transaction)().add($9bb3b775df4f8b9f$export$50792b0e93539fde.createApproveCheckedInstruction(this.programId, account, this.publicKey, delegate, ownerPublicKey, multiSigners, amount, decimals)), this.payer, ...signers);
    }
    /**
   * Mint new tokens, asserting the token mint and decimals
   *
   * @param dest Public key of the account to mint to
   * @param authority Minting authority
   * @param multiSigners Signing accounts if `authority` is a multiSig
   * @param amount Amount to mint
   * @param decimals Number of decimals in amount to mint
   */ async mintToChecked(dest, authority, multiSigners, amount, decimals) {
        let ownerPublicKey;
        let signers;
        if ($9bb3b775df4f8b9f$var$isAccount(authority)) {
            ownerPublicKey = authority.publicKey;
            signers = [
                authority
            ];
        } else {
            ownerPublicKey = authority;
            signers = multiSigners;
        }
        await $9bb3b775df4f8b9f$var$sendAndConfirmTransaction("MintToChecked", this.connection, new (0, $gNDby.Transaction)().add($9bb3b775df4f8b9f$export$50792b0e93539fde.createMintToCheckedInstruction(this.programId, this.publicKey, dest, ownerPublicKey, multiSigners, amount, decimals)), this.payer, ...signers);
    }
    /**
   * Burn tokens, asserting the token mint and decimals
   *
   * @param account Account to burn tokens from
   * @param owner Account owner
   * @param multiSigners Signing accounts if `owner` is a multiSig
   * @param amount Amount to burn
   * @param decimals Number of decimals in amount to burn
   */ async burnChecked(account, owner, multiSigners, amount, decimals) {
        let ownerPublicKey;
        let signers;
        if ($9bb3b775df4f8b9f$var$isAccount(owner)) {
            ownerPublicKey = owner.publicKey;
            signers = [
                owner
            ];
        } else {
            ownerPublicKey = owner;
            signers = multiSigners;
        }
        await $9bb3b775df4f8b9f$var$sendAndConfirmTransaction("BurnChecked", this.connection, new (0, $gNDby.Transaction)().add($9bb3b775df4f8b9f$export$50792b0e93539fde.createBurnCheckedInstruction(this.programId, this.publicKey, account, ownerPublicKey, multiSigners, amount, decimals)), this.payer, ...signers);
    }
    /**
   * Sync amount in native SPL token account to underlying lamports
   *
   * @param nativeAccount Account to sync
   */ async syncNative(nativeAccount) {
        await $9bb3b775df4f8b9f$var$sendAndConfirmTransaction("SyncNative", this.connection, new (0, $gNDby.Transaction)().add($9bb3b775df4f8b9f$export$50792b0e93539fde.createSyncNativeInstruction(this.programId, nativeAccount)), this.payer);
    }
    /**
   * Construct an InitializeMint instruction
   *
   * @param programId SPL Token program account
   * @param mint Token mint account
   * @param decimals Number of decimals in token account amounts
   * @param mintAuthority Minting authority
   * @param freezeAuthority Optional authority that can freeze token accounts
   */ static createInitMintInstruction(programId, mint, decimals, mintAuthority, freezeAuthority) {
        let keys = [
            {
                pubkey: mint,
                isSigner: false,
                isWritable: true
            },
            {
                pubkey: (0, $gNDby.SYSVAR_RENT_PUBKEY),
                isSigner: false,
                isWritable: false
            }
        ];
        const commandDataLayout = $9bb3b775df4f8b9f$var$struct([
            $9bb3b775df4f8b9f$var$u8("instruction"),
            $9bb3b775df4f8b9f$var$u8("decimals"),
            $9bb3b775df4f8b9f$var$publicKey("mintAuthority"),
            $9bb3b775df4f8b9f$var$u8("option"),
            $9bb3b775df4f8b9f$var$publicKey("freezeAuthority")
        ]);
        let data = $9bb3b775df4f8b9f$var$buffer.Buffer.alloc(1024);
        {
            const encodeLength = commandDataLayout.encode({
                instruction: 0,
                decimals: // InitializeMint instruction
                decimals,
                mintAuthority: $9bb3b775df4f8b9f$var$pubkeyToBuffer(mintAuthority),
                option: freezeAuthority === null ? 0 : 1,
                freezeAuthority: $9bb3b775df4f8b9f$var$pubkeyToBuffer(freezeAuthority || new (0, $gNDby.PublicKey)(0))
            }, data);
            data = data.slice(0, encodeLength);
        }
        return new (0, $gNDby.TransactionInstruction)({
            keys: keys,
            programId: programId,
            data: data
        });
    }
    /**
   * Construct an InitializeAccount instruction
   *
   * @param programId SPL Token program account
   * @param mint Token mint account
   * @param account New account
   * @param owner Owner of the new account
   */ static createInitAccountInstruction(programId, mint, account, owner) {
        const keys = [
            {
                pubkey: account,
                isSigner: false,
                isWritable: true
            },
            {
                pubkey: mint,
                isSigner: false,
                isWritable: false
            },
            {
                pubkey: owner,
                isSigner: false,
                isWritable: false
            },
            {
                pubkey: (0, $gNDby.SYSVAR_RENT_PUBKEY),
                isSigner: false,
                isWritable: false
            }
        ];
        const dataLayout = $9bb3b775df4f8b9f$var$struct([
            $9bb3b775df4f8b9f$var$u8("instruction")
        ]);
        const data = $9bb3b775df4f8b9f$var$buffer.Buffer.alloc(dataLayout.span);
        dataLayout.encode({
            instruction: 1 // InitializeAccount instruction
        }, data);
        return new (0, $gNDby.TransactionInstruction)({
            keys: keys,
            programId: programId,
            data: data
        });
    }
    /**
   * Construct a Transfer instruction
   *
   * @param programId SPL Token program account
   * @param source Source account
   * @param destination Destination account
   * @param owner Owner of the source account
   * @param multiSigners Signing accounts if `authority` is a multiSig
   * @param amount Number of tokens to transfer
   */ static createTransferInstruction(programId, source, destination, owner, multiSigners, amount) {
        const dataLayout = $9bb3b775df4f8b9f$var$struct([
            $9bb3b775df4f8b9f$var$u8("instruction"),
            $9bb3b775df4f8b9f$var$uint64("amount")
        ]);
        const data = $9bb3b775df4f8b9f$var$buffer.Buffer.alloc(dataLayout.span);
        dataLayout.encode({
            instruction: 3,
            // Transfer instruction
            amount: new $9bb3b775df4f8b9f$export$cd1442401e54cffa(amount).toBuffer()
        }, data);
        let keys = [
            {
                pubkey: source,
                isSigner: false,
                isWritable: true
            },
            {
                pubkey: destination,
                isSigner: false,
                isWritable: true
            }
        ];
        if (multiSigners.length === 0) keys.push({
            pubkey: owner,
            isSigner: true,
            isWritable: false
        });
        else {
            keys.push({
                pubkey: owner,
                isSigner: false,
                isWritable: false
            });
            multiSigners.forEach((signer)=>keys.push({
                    pubkey: signer.publicKey,
                    isSigner: true,
                    isWritable: false
                }));
        }
        return new (0, $gNDby.TransactionInstruction)({
            keys: keys,
            programId: programId,
            data: data
        });
    }
    /**
   * Construct an Approve instruction
   *
   * @param programId SPL Token program account
   * @param account Public key of the account
   * @param delegate Account authorized to perform a transfer of tokens from the source account
   * @param owner Owner of the source account
   * @param multiSigners Signing accounts if `owner` is a multiSig
   * @param amount Maximum number of tokens the delegate may transfer
   */ static createApproveInstruction(programId, account, delegate, owner, multiSigners, amount) {
        const dataLayout = $9bb3b775df4f8b9f$var$struct([
            $9bb3b775df4f8b9f$var$u8("instruction"),
            $9bb3b775df4f8b9f$var$uint64("amount")
        ]);
        const data = $9bb3b775df4f8b9f$var$buffer.Buffer.alloc(dataLayout.span);
        dataLayout.encode({
            instruction: 4,
            // Approve instruction
            amount: new $9bb3b775df4f8b9f$export$cd1442401e54cffa(amount).toBuffer()
        }, data);
        let keys = [
            {
                pubkey: account,
                isSigner: false,
                isWritable: true
            },
            {
                pubkey: delegate,
                isSigner: false,
                isWritable: false
            }
        ];
        if (multiSigners.length === 0) keys.push({
            pubkey: owner,
            isSigner: true,
            isWritable: false
        });
        else {
            keys.push({
                pubkey: owner,
                isSigner: false,
                isWritable: false
            });
            multiSigners.forEach((signer)=>keys.push({
                    pubkey: signer.publicKey,
                    isSigner: true,
                    isWritable: false
                }));
        }
        return new (0, $gNDby.TransactionInstruction)({
            keys: keys,
            programId: programId,
            data: data
        });
    }
    /**
   * Construct a Revoke instruction
   *
   * @param programId SPL Token program account
   * @param account Public key of the account
   * @param owner Owner of the source account
   * @param multiSigners Signing accounts if `owner` is a multiSig
   */ static createRevokeInstruction(programId, account, owner, multiSigners) {
        const dataLayout = $9bb3b775df4f8b9f$var$struct([
            $9bb3b775df4f8b9f$var$u8("instruction")
        ]);
        const data = $9bb3b775df4f8b9f$var$buffer.Buffer.alloc(dataLayout.span);
        dataLayout.encode({
            instruction: 5 // Approve instruction
        }, data);
        let keys = [
            {
                pubkey: account,
                isSigner: false,
                isWritable: true
            }
        ];
        if (multiSigners.length === 0) keys.push({
            pubkey: owner,
            isSigner: true,
            isWritable: false
        });
        else {
            keys.push({
                pubkey: owner,
                isSigner: false,
                isWritable: false
            });
            multiSigners.forEach((signer)=>keys.push({
                    pubkey: signer.publicKey,
                    isSigner: true,
                    isWritable: false
                }));
        }
        return new (0, $gNDby.TransactionInstruction)({
            keys: keys,
            programId: programId,
            data: data
        });
    }
    /**
   * Construct a SetAuthority instruction
   *
   * @param programId SPL Token program account
   * @param account Public key of the account
   * @param newAuthority New authority of the account
   * @param authorityType Type of authority to set
   * @param currentAuthority Current authority of the specified type
   * @param multiSigners Signing accounts if `currentAuthority` is a multiSig
   */ static createSetAuthorityInstruction(programId, account, newAuthority, authorityType, currentAuthority, multiSigners) {
        const commandDataLayout = $9bb3b775df4f8b9f$var$struct([
            $9bb3b775df4f8b9f$var$u8("instruction"),
            $9bb3b775df4f8b9f$var$u8("authorityType"),
            $9bb3b775df4f8b9f$var$u8("option"),
            $9bb3b775df4f8b9f$var$publicKey("newAuthority")
        ]);
        let data = $9bb3b775df4f8b9f$var$buffer.Buffer.alloc(1024);
        {
            const encodeLength = commandDataLayout.encode({
                instruction: 6,
                // SetAuthority instruction
                authorityType: $9bb3b775df4f8b9f$var$AuthorityTypeCodes[authorityType],
                option: newAuthority === null ? 0 : 1,
                newAuthority: $9bb3b775df4f8b9f$var$pubkeyToBuffer(newAuthority || new (0, $gNDby.PublicKey)(0))
            }, data);
            data = data.slice(0, encodeLength);
        }
        let keys = [
            {
                pubkey: account,
                isSigner: false,
                isWritable: true
            }
        ];
        if (multiSigners.length === 0) keys.push({
            pubkey: currentAuthority,
            isSigner: true,
            isWritable: false
        });
        else {
            keys.push({
                pubkey: currentAuthority,
                isSigner: false,
                isWritable: false
            });
            multiSigners.forEach((signer)=>keys.push({
                    pubkey: signer.publicKey,
                    isSigner: true,
                    isWritable: false
                }));
        }
        return new (0, $gNDby.TransactionInstruction)({
            keys: keys,
            programId: programId,
            data: data
        });
    }
    /**
   * Construct a MintTo instruction
   *
   * @param programId SPL Token program account
   * @param mint Public key of the mint
   * @param dest Public key of the account to mint to
   * @param authority The mint authority
   * @param multiSigners Signing accounts if `authority` is a multiSig
   * @param amount Amount to mint
   */ static createMintToInstruction(programId, mint, dest, authority, multiSigners, amount) {
        const dataLayout = $9bb3b775df4f8b9f$var$struct([
            $9bb3b775df4f8b9f$var$u8("instruction"),
            $9bb3b775df4f8b9f$var$uint64("amount")
        ]);
        const data = $9bb3b775df4f8b9f$var$buffer.Buffer.alloc(dataLayout.span);
        dataLayout.encode({
            instruction: 7,
            // MintTo instruction
            amount: new $9bb3b775df4f8b9f$export$cd1442401e54cffa(amount).toBuffer()
        }, data);
        let keys = [
            {
                pubkey: mint,
                isSigner: false,
                isWritable: true
            },
            {
                pubkey: dest,
                isSigner: false,
                isWritable: true
            }
        ];
        if (multiSigners.length === 0) keys.push({
            pubkey: authority,
            isSigner: true,
            isWritable: false
        });
        else {
            keys.push({
                pubkey: authority,
                isSigner: false,
                isWritable: false
            });
            multiSigners.forEach((signer)=>keys.push({
                    pubkey: signer.publicKey,
                    isSigner: true,
                    isWritable: false
                }));
        }
        return new (0, $gNDby.TransactionInstruction)({
            keys: keys,
            programId: programId,
            data: data
        });
    }
    /**
   * Construct a Burn instruction
   *
   * @param programId SPL Token program account
   * @param mint Mint for the account
   * @param account Account to burn tokens from
   * @param owner Owner of the account
   * @param multiSigners Signing accounts if `authority` is a multiSig
   * @param amount amount to burn
   */ static createBurnInstruction(programId, mint, account, owner, multiSigners, amount) {
        const dataLayout = $9bb3b775df4f8b9f$var$struct([
            $9bb3b775df4f8b9f$var$u8("instruction"),
            $9bb3b775df4f8b9f$var$uint64("amount")
        ]);
        const data = $9bb3b775df4f8b9f$var$buffer.Buffer.alloc(dataLayout.span);
        dataLayout.encode({
            instruction: 8,
            // Burn instruction
            amount: new $9bb3b775df4f8b9f$export$cd1442401e54cffa(amount).toBuffer()
        }, data);
        let keys = [
            {
                pubkey: account,
                isSigner: false,
                isWritable: true
            },
            {
                pubkey: mint,
                isSigner: false,
                isWritable: true
            }
        ];
        if (multiSigners.length === 0) keys.push({
            pubkey: owner,
            isSigner: true,
            isWritable: false
        });
        else {
            keys.push({
                pubkey: owner,
                isSigner: false,
                isWritable: false
            });
            multiSigners.forEach((signer)=>keys.push({
                    pubkey: signer.publicKey,
                    isSigner: true,
                    isWritable: false
                }));
        }
        return new (0, $gNDby.TransactionInstruction)({
            keys: keys,
            programId: programId,
            data: data
        });
    }
    /**
   * Construct a Close instruction
   *
   * @param programId SPL Token program account
   * @param account Account to close
   * @param dest Account to receive the remaining balance of the closed account
   * @param authority Account Close authority
   * @param multiSigners Signing accounts if `owner` is a multiSig
   */ static createCloseAccountInstruction(programId, account, dest, owner, multiSigners) {
        const dataLayout = $9bb3b775df4f8b9f$var$struct([
            $9bb3b775df4f8b9f$var$u8("instruction")
        ]);
        const data = $9bb3b775df4f8b9f$var$buffer.Buffer.alloc(dataLayout.span);
        dataLayout.encode({
            instruction: 9 // CloseAccount instruction
        }, data);
        let keys = [
            {
                pubkey: account,
                isSigner: false,
                isWritable: true
            },
            {
                pubkey: dest,
                isSigner: false,
                isWritable: true
            }
        ];
        if (multiSigners.length === 0) keys.push({
            pubkey: owner,
            isSigner: true,
            isWritable: false
        });
        else {
            keys.push({
                pubkey: owner,
                isSigner: false,
                isWritable: false
            });
            multiSigners.forEach((signer)=>keys.push({
                    pubkey: signer.publicKey,
                    isSigner: true,
                    isWritable: false
                }));
        }
        return new (0, $gNDby.TransactionInstruction)({
            keys: keys,
            programId: programId,
            data: data
        });
    }
    /**
   * Construct a Freeze instruction
   *
   * @param programId SPL Token program account
   * @param account Account to freeze
   * @param mint Mint account
   * @param authority Mint freeze authority
   * @param multiSigners Signing accounts if `owner` is a multiSig
   */ static createFreezeAccountInstruction(programId, account, mint, authority, multiSigners) {
        const dataLayout = $9bb3b775df4f8b9f$var$struct([
            $9bb3b775df4f8b9f$var$u8("instruction")
        ]);
        const data = $9bb3b775df4f8b9f$var$buffer.Buffer.alloc(dataLayout.span);
        dataLayout.encode({
            instruction: 10 // FreezeAccount instruction
        }, data);
        let keys = [
            {
                pubkey: account,
                isSigner: false,
                isWritable: true
            },
            {
                pubkey: mint,
                isSigner: false,
                isWritable: false
            }
        ];
        if (multiSigners.length === 0) keys.push({
            pubkey: authority,
            isSigner: true,
            isWritable: false
        });
        else {
            keys.push({
                pubkey: authority,
                isSigner: false,
                isWritable: false
            });
            multiSigners.forEach((signer)=>keys.push({
                    pubkey: signer.publicKey,
                    isSigner: true,
                    isWritable: false
                }));
        }
        return new (0, $gNDby.TransactionInstruction)({
            keys: keys,
            programId: programId,
            data: data
        });
    }
    /**
   * Construct a Thaw instruction
   *
   * @param programId SPL Token program account
   * @param account Account to thaw
   * @param mint Mint account
   * @param authority Mint freeze authority
   * @param multiSigners Signing accounts if `owner` is a multiSig
   */ static createThawAccountInstruction(programId, account, mint, authority, multiSigners) {
        const dataLayout = $9bb3b775df4f8b9f$var$struct([
            $9bb3b775df4f8b9f$var$u8("instruction")
        ]);
        const data = $9bb3b775df4f8b9f$var$buffer.Buffer.alloc(dataLayout.span);
        dataLayout.encode({
            instruction: 11 // ThawAccount instruction
        }, data);
        let keys = [
            {
                pubkey: account,
                isSigner: false,
                isWritable: true
            },
            {
                pubkey: mint,
                isSigner: false,
                isWritable: false
            }
        ];
        if (multiSigners.length === 0) keys.push({
            pubkey: authority,
            isSigner: true,
            isWritable: false
        });
        else {
            keys.push({
                pubkey: authority,
                isSigner: false,
                isWritable: false
            });
            multiSigners.forEach((signer)=>keys.push({
                    pubkey: signer.publicKey,
                    isSigner: true,
                    isWritable: false
                }));
        }
        return new (0, $gNDby.TransactionInstruction)({
            keys: keys,
            programId: programId,
            data: data
        });
    }
    /**
   * Construct a TransferChecked instruction
   *
   * @param programId SPL Token program account
   * @param source Source account
   * @param mint Mint account
   * @param destination Destination account
   * @param owner Owner of the source account
   * @param multiSigners Signing accounts if `authority` is a multiSig
   * @param amount Number of tokens to transfer
   * @param decimals Number of decimals in transfer amount
   */ static createTransferCheckedInstruction(programId, source, mint, destination, owner, multiSigners, amount, decimals) {
        const dataLayout = $9bb3b775df4f8b9f$var$struct([
            $9bb3b775df4f8b9f$var$u8("instruction"),
            $9bb3b775df4f8b9f$var$uint64("amount"),
            $9bb3b775df4f8b9f$var$u8("decimals")
        ]);
        const data = $9bb3b775df4f8b9f$var$buffer.Buffer.alloc(dataLayout.span);
        dataLayout.encode({
            instruction: 12,
            // TransferChecked instruction
            amount: new $9bb3b775df4f8b9f$export$cd1442401e54cffa(amount).toBuffer(),
            decimals: decimals
        }, data);
        let keys = [
            {
                pubkey: source,
                isSigner: false,
                isWritable: true
            },
            {
                pubkey: mint,
                isSigner: false,
                isWritable: false
            },
            {
                pubkey: destination,
                isSigner: false,
                isWritable: true
            }
        ];
        if (multiSigners.length === 0) keys.push({
            pubkey: owner,
            isSigner: true,
            isWritable: false
        });
        else {
            keys.push({
                pubkey: owner,
                isSigner: false,
                isWritable: false
            });
            multiSigners.forEach((signer)=>keys.push({
                    pubkey: signer.publicKey,
                    isSigner: true,
                    isWritable: false
                }));
        }
        return new (0, $gNDby.TransactionInstruction)({
            keys: keys,
            programId: programId,
            data: data
        });
    }
    /**
   * Construct an ApproveChecked instruction
   *
   * @param programId SPL Token program account
   * @param account Public key of the account
   * @param mint Mint account
   * @param delegate Account authorized to perform a transfer of tokens from the source account
   * @param owner Owner of the source account
   * @param multiSigners Signing accounts if `owner` is a multiSig
   * @param amount Maximum number of tokens the delegate may transfer
   * @param decimals Number of decimals in approve amount
   */ static createApproveCheckedInstruction(programId, account, mint, delegate, owner, multiSigners, amount, decimals) {
        const dataLayout = $9bb3b775df4f8b9f$var$struct([
            $9bb3b775df4f8b9f$var$u8("instruction"),
            $9bb3b775df4f8b9f$var$uint64("amount"),
            $9bb3b775df4f8b9f$var$u8("decimals")
        ]);
        const data = $9bb3b775df4f8b9f$var$buffer.Buffer.alloc(dataLayout.span);
        dataLayout.encode({
            instruction: 13,
            // ApproveChecked instruction
            amount: new $9bb3b775df4f8b9f$export$cd1442401e54cffa(amount).toBuffer(),
            decimals: decimals
        }, data);
        let keys = [
            {
                pubkey: account,
                isSigner: false,
                isWritable: true
            },
            {
                pubkey: mint,
                isSigner: false,
                isWritable: false
            },
            {
                pubkey: delegate,
                isSigner: false,
                isWritable: false
            }
        ];
        if (multiSigners.length === 0) keys.push({
            pubkey: owner,
            isSigner: true,
            isWritable: false
        });
        else {
            keys.push({
                pubkey: owner,
                isSigner: false,
                isWritable: false
            });
            multiSigners.forEach((signer)=>keys.push({
                    pubkey: signer.publicKey,
                    isSigner: true,
                    isWritable: false
                }));
        }
        return new (0, $gNDby.TransactionInstruction)({
            keys: keys,
            programId: programId,
            data: data
        });
    }
    /**
   * Construct a MintToChecked instruction
   *
   * @param programId SPL Token program account
   * @param mint Public key of the mint
   * @param dest Public key of the account to mint to
   * @param authority The mint authority
   * @param multiSigners Signing accounts if `authority` is a multiSig
   * @param amount Amount to mint
   * @param decimals Number of decimals in amount to mint
   */ static createMintToCheckedInstruction(programId, mint, dest, authority, multiSigners, amount, decimals) {
        const dataLayout = $9bb3b775df4f8b9f$var$struct([
            $9bb3b775df4f8b9f$var$u8("instruction"),
            $9bb3b775df4f8b9f$var$uint64("amount"),
            $9bb3b775df4f8b9f$var$u8("decimals")
        ]);
        const data = $9bb3b775df4f8b9f$var$buffer.Buffer.alloc(dataLayout.span);
        dataLayout.encode({
            instruction: 14,
            // MintToChecked instruction
            amount: new $9bb3b775df4f8b9f$export$cd1442401e54cffa(amount).toBuffer(),
            decimals: decimals
        }, data);
        let keys = [
            {
                pubkey: mint,
                isSigner: false,
                isWritable: true
            },
            {
                pubkey: dest,
                isSigner: false,
                isWritable: true
            }
        ];
        if (multiSigners.length === 0) keys.push({
            pubkey: authority,
            isSigner: true,
            isWritable: false
        });
        else {
            keys.push({
                pubkey: authority,
                isSigner: false,
                isWritable: false
            });
            multiSigners.forEach((signer)=>keys.push({
                    pubkey: signer.publicKey,
                    isSigner: true,
                    isWritable: false
                }));
        }
        return new (0, $gNDby.TransactionInstruction)({
            keys: keys,
            programId: programId,
            data: data
        });
    }
    /**
   * Construct a BurnChecked instruction
   *
   * @param programId SPL Token program account
   * @param mint Mint for the account
   * @param account Account to burn tokens from
   * @param owner Owner of the account
   * @param multiSigners Signing accounts if `authority` is a multiSig
   * @param amount amount to burn
   */ static createBurnCheckedInstruction(programId, mint, account, owner, multiSigners, amount, decimals) {
        const dataLayout = $9bb3b775df4f8b9f$var$struct([
            $9bb3b775df4f8b9f$var$u8("instruction"),
            $9bb3b775df4f8b9f$var$uint64("amount"),
            $9bb3b775df4f8b9f$var$u8("decimals")
        ]);
        const data = $9bb3b775df4f8b9f$var$buffer.Buffer.alloc(dataLayout.span);
        dataLayout.encode({
            instruction: 15,
            // BurnChecked instruction
            amount: new $9bb3b775df4f8b9f$export$cd1442401e54cffa(amount).toBuffer(),
            decimals: decimals
        }, data);
        let keys = [
            {
                pubkey: account,
                isSigner: false,
                isWritable: true
            },
            {
                pubkey: mint,
                isSigner: false,
                isWritable: true
            }
        ];
        if (multiSigners.length === 0) keys.push({
            pubkey: owner,
            isSigner: true,
            isWritable: false
        });
        else {
            keys.push({
                pubkey: owner,
                isSigner: false,
                isWritable: false
            });
            multiSigners.forEach((signer)=>keys.push({
                    pubkey: signer.publicKey,
                    isSigner: true,
                    isWritable: false
                }));
        }
        return new (0, $gNDby.TransactionInstruction)({
            keys: keys,
            programId: programId,
            data: data
        });
    }
    /**
   * Construct a SyncNative instruction
   *
   * @param programId SPL Token program account
   * @param nativeAccount Account to sync lamports from
   */ static createSyncNativeInstruction(programId, nativeAccount) {
        const dataLayout = $9bb3b775df4f8b9f$var$struct([
            $9bb3b775df4f8b9f$var$u8("instruction")
        ]);
        const data = $9bb3b775df4f8b9f$var$buffer.Buffer.alloc(dataLayout.span);
        dataLayout.encode({
            instruction: 17 // SyncNative instruction
        }, data);
        let keys = [
            {
                pubkey: nativeAccount,
                isSigner: false,
                isWritable: true
            }
        ];
        return new (0, $gNDby.TransactionInstruction)({
            keys: keys,
            programId: programId,
            data: data
        });
    }
    /**
   * Get the address for the associated token account
   *
   * @param associatedProgramId SPL Associated Token program account
   * @param programId SPL Token program account
   * @param mint Token mint account
   * @param owner Owner of the new account
   * @return Public key of the associated token account
   */ static async getAssociatedTokenAddress(associatedProgramId, programId, mint, owner, allowOwnerOffCurve = false) {
        if (!allowOwnerOffCurve && !(0, $gNDby.PublicKey).isOnCurve(owner.toBuffer())) throw new Error(`Owner cannot sign: ${owner.toString()}`);
        return (await (0, $gNDby.PublicKey).findProgramAddress([
            owner.toBuffer(),
            programId.toBuffer(),
            mint.toBuffer()
        ], associatedProgramId))[0];
    }
    /**
   * Construct the AssociatedTokenProgram instruction to create the associated
   * token account
   *
   * @param associatedProgramId SPL Associated Token program account
   * @param programId SPL Token program account
   * @param mint Token mint account
   * @param associatedAccount New associated account
   * @param owner Owner of the new account
   * @param payer Payer of fees
   */ static createAssociatedTokenAccountInstruction(associatedProgramId, programId, mint, associatedAccount, owner, payer) {
        const data = $9bb3b775df4f8b9f$var$buffer.Buffer.alloc(0);
        let keys = [
            {
                pubkey: payer,
                isSigner: true,
                isWritable: true
            },
            {
                pubkey: associatedAccount,
                isSigner: false,
                isWritable: true
            },
            {
                pubkey: owner,
                isSigner: false,
                isWritable: false
            },
            {
                pubkey: mint,
                isSigner: false,
                isWritable: false
            },
            {
                pubkey: (0, $gNDby.SystemProgram).programId,
                isSigner: false,
                isWritable: false
            },
            {
                pubkey: programId,
                isSigner: false,
                isWritable: false
            },
            {
                pubkey: (0, $gNDby.SYSVAR_RENT_PUBKEY),
                isSigner: false,
                isWritable: false
            }
        ];
        return new (0, $gNDby.TransactionInstruction)({
            keys: keys,
            programId: associatedProgramId,
            data: data
        });
    }
}

});
parcelRegister("g5Zhu", function(module, exports) {

var $5DKOa = parcelRequire("5DKOa");
function $bb7ca61ce45563c4$var$_defineProperty(obj, key, value) {
    key = $5DKOa(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
module.exports = $bb7ca61ce45563c4$var$_defineProperty, module.exports.__esModule = true, module.exports["default"] = module.exports;

});



parcelRegister("44mK7", function(module, exports) {
"use strict";
var $2f692d606127ddfe$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $2f692d606127ddfe$var$__setModuleDefault = module.exports && module.exports.__setModuleDefault || (Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
});
var $2f692d606127ddfe$var$__importStar = module.exports && module.exports.__importStar || function(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) $2f692d606127ddfe$var$__createBinding(result, mod, k);
    }
    $2f692d606127ddfe$var$__setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.createCreateTreeInstruction = module.exports.createTreeInstructionDiscriminator = module.exports.createTreeStruct = void 0;

const $2f692d606127ddfe$var$beet = $2f692d606127ddfe$var$__importStar((parcelRequire("1DULh")));

const $2f692d606127ddfe$var$web3 = $2f692d606127ddfe$var$__importStar((parcelRequire("gNDby")));
module.exports.createTreeStruct = new $2f692d606127ddfe$var$beet.FixableBeetArgsStruct([
    [
        "instructionDiscriminator",
        $2f692d606127ddfe$var$beet.uniformFixedSizeArray($2f692d606127ddfe$var$beet.u8, 8)
    ],
    [
        "maxDepth",
        $2f692d606127ddfe$var$beet.u32
    ],
    [
        "maxBufferSize",
        $2f692d606127ddfe$var$beet.u32
    ],
    [
        "public",
        $2f692d606127ddfe$var$beet.coption($2f692d606127ddfe$var$beet.bool)
    ]
], "CreateTreeInstructionArgs");
module.exports.createTreeInstructionDiscriminator = [
    165,
    83,
    136,
    142,
    89,
    202,
    47,
    220
];
function $2f692d606127ddfe$var$createCreateTreeInstruction(accounts, args, programId = new $2f692d606127ddfe$var$web3.PublicKey("BGUMAp9Gq7iTEuizy4pqaxsTyUCBK68MDfK752saRPUY")) {
    var _a;
    const [data] = module.exports.createTreeStruct.serialize({
        instructionDiscriminator: module.exports.createTreeInstructionDiscriminator,
        ...args
    });
    const keys = [
        {
            pubkey: accounts.treeAuthority,
            isWritable: true,
            isSigner: false
        },
        {
            pubkey: accounts.merkleTree,
            isWritable: true,
            isSigner: false
        },
        {
            pubkey: accounts.payer,
            isWritable: true,
            isSigner: true
        },
        {
            pubkey: accounts.treeCreator,
            isWritable: false,
            isSigner: true
        },
        {
            pubkey: accounts.logWrapper,
            isWritable: false,
            isSigner: false
        },
        {
            pubkey: accounts.compressionProgram,
            isWritable: false,
            isSigner: false
        },
        {
            pubkey: (_a = accounts.systemProgram) !== null && _a !== void 0 ? _a : $2f692d606127ddfe$var$web3.SystemProgram.programId,
            isWritable: false,
            isSigner: false
        }
    ];
    if (accounts.anchorRemainingAccounts != null) for (const acc of accounts.anchorRemainingAccounts)keys.push(acc);
    const ix = new $2f692d606127ddfe$var$web3.TransactionInstruction({
        programId: programId,
        keys: keys,
        data: data
    });
    return ix;
}
module.exports.createCreateTreeInstruction = $2f692d606127ddfe$var$createCreateTreeInstruction;

});

parcelRegister("99h0T", function(module, exports) {
"use strict";
var $6a9226cf958ab430$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $6a9226cf958ab430$var$__setModuleDefault = module.exports && module.exports.__setModuleDefault || (Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
});
var $6a9226cf958ab430$var$__importStar = module.exports && module.exports.__importStar || function(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) $6a9226cf958ab430$var$__createBinding(result, mod, k);
    }
    $6a9226cf958ab430$var$__setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.createDecompressV1Instruction = module.exports.decompressV1InstructionDiscriminator = module.exports.decompressV1Struct = void 0;

const $6a9226cf958ab430$var$splToken = $6a9226cf958ab430$var$__importStar((parcelRequire("dmNue")));

const $6a9226cf958ab430$var$beet = $6a9226cf958ab430$var$__importStar((parcelRequire("1DULh")));

const $6a9226cf958ab430$var$web3 = $6a9226cf958ab430$var$__importStar((parcelRequire("gNDby")));

var $k6S43 = parcelRequire("k6S43");
module.exports.decompressV1Struct = new $6a9226cf958ab430$var$beet.FixableBeetArgsStruct([
    [
        "instructionDiscriminator",
        $6a9226cf958ab430$var$beet.uniformFixedSizeArray($6a9226cf958ab430$var$beet.u8, 8)
    ],
    [
        "metadata",
        $k6S43.metadataArgsBeet
    ]
], "DecompressV1InstructionArgs");
module.exports.decompressV1InstructionDiscriminator = [
    54,
    85,
    76,
    70,
    228,
    250,
    164,
    81
];
function $6a9226cf958ab430$var$createDecompressV1Instruction(accounts, args, programId = new $6a9226cf958ab430$var$web3.PublicKey("BGUMAp9Gq7iTEuizy4pqaxsTyUCBK68MDfK752saRPUY")) {
    var _a, _b;
    const [data] = module.exports.decompressV1Struct.serialize({
        instructionDiscriminator: module.exports.decompressV1InstructionDiscriminator,
        ...args
    });
    const keys = [
        {
            pubkey: accounts.voucher,
            isWritable: true,
            isSigner: false
        },
        {
            pubkey: accounts.leafOwner,
            isWritable: true,
            isSigner: true
        },
        {
            pubkey: accounts.tokenAccount,
            isWritable: true,
            isSigner: false
        },
        {
            pubkey: accounts.mint,
            isWritable: true,
            isSigner: false
        },
        {
            pubkey: accounts.mintAuthority,
            isWritable: true,
            isSigner: false
        },
        {
            pubkey: accounts.metadata,
            isWritable: true,
            isSigner: false
        },
        {
            pubkey: accounts.masterEdition,
            isWritable: true,
            isSigner: false
        },
        {
            pubkey: (_a = accounts.systemProgram) !== null && _a !== void 0 ? _a : $6a9226cf958ab430$var$web3.SystemProgram.programId,
            isWritable: false,
            isSigner: false
        },
        {
            pubkey: accounts.sysvarRent,
            isWritable: false,
            isSigner: false
        },
        {
            pubkey: accounts.tokenMetadataProgram,
            isWritable: false,
            isSigner: false
        },
        {
            pubkey: (_b = accounts.tokenProgram) !== null && _b !== void 0 ? _b : $6a9226cf958ab430$var$splToken.TOKEN_PROGRAM_ID,
            isWritable: false,
            isSigner: false
        },
        {
            pubkey: accounts.associatedTokenProgram,
            isWritable: false,
            isSigner: false
        },
        {
            pubkey: accounts.logWrapper,
            isWritable: false,
            isSigner: false
        }
    ];
    if (accounts.anchorRemainingAccounts != null) for (const acc of accounts.anchorRemainingAccounts)keys.push(acc);
    const ix = new $6a9226cf958ab430$var$web3.TransactionInstruction({
        programId: programId,
        keys: keys,
        data: data
    });
    return ix;
}
module.exports.createDecompressV1Instruction = $6a9226cf958ab430$var$createDecompressV1Instruction;

});
parcelRegister("k6S43", function(module, exports) {
"use strict";
var $ea3e4e459a18ef64$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $ea3e4e459a18ef64$var$__setModuleDefault = module.exports && module.exports.__setModuleDefault || (Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
});
var $ea3e4e459a18ef64$var$__importStar = module.exports && module.exports.__importStar || function(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) $ea3e4e459a18ef64$var$__createBinding(result, mod, k);
    }
    $ea3e4e459a18ef64$var$__setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.metadataArgsBeet = void 0;

const $ea3e4e459a18ef64$var$beet = $ea3e4e459a18ef64$var$__importStar((parcelRequire("1DULh")));

var $bon4v = parcelRequire("bon4v");

var $3PxdX = parcelRequire("3PxdX");

var $hVvqL = parcelRequire("hVvqL");

var $e2KNJ = parcelRequire("e2KNJ");

var $awKN7 = parcelRequire("awKN7");
module.exports.metadataArgsBeet = new $ea3e4e459a18ef64$var$beet.FixableBeetArgsStruct([
    [
        "name",
        $ea3e4e459a18ef64$var$beet.utf8String
    ],
    [
        "symbol",
        $ea3e4e459a18ef64$var$beet.utf8String
    ],
    [
        "uri",
        $ea3e4e459a18ef64$var$beet.utf8String
    ],
    [
        "sellerFeeBasisPoints",
        $ea3e4e459a18ef64$var$beet.u16
    ],
    [
        "primarySaleHappened",
        $ea3e4e459a18ef64$var$beet.bool
    ],
    [
        "isMutable",
        $ea3e4e459a18ef64$var$beet.bool
    ],
    [
        "editionNonce",
        $ea3e4e459a18ef64$var$beet.coption($ea3e4e459a18ef64$var$beet.u8)
    ],
    [
        "tokenStandard",
        $ea3e4e459a18ef64$var$beet.coption($bon4v.tokenStandardBeet)
    ],
    [
        "collection",
        $ea3e4e459a18ef64$var$beet.coption($3PxdX.collectionBeet)
    ],
    [
        "uses",
        $ea3e4e459a18ef64$var$beet.coption($hVvqL.usesBeet)
    ],
    [
        "tokenProgramVersion",
        $e2KNJ.tokenProgramVersionBeet
    ],
    [
        "creators",
        $ea3e4e459a18ef64$var$beet.array($awKN7.creatorBeet)
    ]
], "MetadataArgs");

});
parcelRegister("bon4v", function(module, exports) {
"use strict";
var $84b3d529c0464cde$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $84b3d529c0464cde$var$__setModuleDefault = module.exports && module.exports.__setModuleDefault || (Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
});
var $84b3d529c0464cde$var$__importStar = module.exports && module.exports.__importStar || function(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) $84b3d529c0464cde$var$__createBinding(result, mod, k);
    }
    $84b3d529c0464cde$var$__setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.tokenStandardBeet = module.exports.TokenStandard = void 0;

const $84b3d529c0464cde$var$beet = $84b3d529c0464cde$var$__importStar((parcelRequire("1DULh")));
var $84b3d529c0464cde$var$TokenStandard;
(function(TokenStandard) {
    TokenStandard[TokenStandard["NonFungible"] = 0] = "NonFungible";
    TokenStandard[TokenStandard["FungibleAsset"] = 1] = "FungibleAsset";
    TokenStandard[TokenStandard["Fungible"] = 2] = "Fungible";
    TokenStandard[TokenStandard["NonFungibleEdition"] = 3] = "NonFungibleEdition";
})($84b3d529c0464cde$var$TokenStandard = module.exports.TokenStandard || (module.exports.TokenStandard = {}));
module.exports.tokenStandardBeet = $84b3d529c0464cde$var$beet.fixedScalarEnum($84b3d529c0464cde$var$TokenStandard);

});

parcelRegister("3PxdX", function(module, exports) {
"use strict";
var $2c9fe82319c92c32$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $2c9fe82319c92c32$var$__setModuleDefault = module.exports && module.exports.__setModuleDefault || (Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
});
var $2c9fe82319c92c32$var$__importStar = module.exports && module.exports.__importStar || function(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) $2c9fe82319c92c32$var$__createBinding(result, mod, k);
    }
    $2c9fe82319c92c32$var$__setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.collectionBeet = void 0;

const $2c9fe82319c92c32$var$beet = $2c9fe82319c92c32$var$__importStar((parcelRequire("1DULh")));

const $2c9fe82319c92c32$var$beetSolana = $2c9fe82319c92c32$var$__importStar((parcelRequire("8OnYx")));
module.exports.collectionBeet = new $2c9fe82319c92c32$var$beet.BeetArgsStruct([
    [
        "verified",
        $2c9fe82319c92c32$var$beet.bool
    ],
    [
        "key",
        $2c9fe82319c92c32$var$beetSolana.publicKey
    ]
], "Collection");

});

parcelRegister("hVvqL", function(module, exports) {
"use strict";
var $d0d02406f0d1a94e$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $d0d02406f0d1a94e$var$__setModuleDefault = module.exports && module.exports.__setModuleDefault || (Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
});
var $d0d02406f0d1a94e$var$__importStar = module.exports && module.exports.__importStar || function(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) $d0d02406f0d1a94e$var$__createBinding(result, mod, k);
    }
    $d0d02406f0d1a94e$var$__setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.usesBeet = void 0;

const $d0d02406f0d1a94e$var$beet = $d0d02406f0d1a94e$var$__importStar((parcelRequire("1DULh")));

var $3ZGlf = parcelRequire("3ZGlf");
module.exports.usesBeet = new $d0d02406f0d1a94e$var$beet.BeetArgsStruct([
    [
        "useMethod",
        $3ZGlf.useMethodBeet
    ],
    [
        "remaining",
        $d0d02406f0d1a94e$var$beet.u64
    ],
    [
        "total",
        $d0d02406f0d1a94e$var$beet.u64
    ]
], "Uses");

});
parcelRegister("3ZGlf", function(module, exports) {
"use strict";
var $2e87e9c940f5b255$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $2e87e9c940f5b255$var$__setModuleDefault = module.exports && module.exports.__setModuleDefault || (Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
});
var $2e87e9c940f5b255$var$__importStar = module.exports && module.exports.__importStar || function(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) $2e87e9c940f5b255$var$__createBinding(result, mod, k);
    }
    $2e87e9c940f5b255$var$__setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.useMethodBeet = module.exports.UseMethod = void 0;

const $2e87e9c940f5b255$var$beet = $2e87e9c940f5b255$var$__importStar((parcelRequire("1DULh")));
var $2e87e9c940f5b255$var$UseMethod;
(function(UseMethod) {
    UseMethod[UseMethod["Burn"] = 0] = "Burn";
    UseMethod[UseMethod["Multiple"] = 1] = "Multiple";
    UseMethod[UseMethod["Single"] = 2] = "Single";
})($2e87e9c940f5b255$var$UseMethod = module.exports.UseMethod || (module.exports.UseMethod = {}));
module.exports.useMethodBeet = $2e87e9c940f5b255$var$beet.fixedScalarEnum($2e87e9c940f5b255$var$UseMethod);

});


parcelRegister("e2KNJ", function(module, exports) {
"use strict";
var $a3958e5602f35431$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $a3958e5602f35431$var$__setModuleDefault = module.exports && module.exports.__setModuleDefault || (Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
});
var $a3958e5602f35431$var$__importStar = module.exports && module.exports.__importStar || function(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) $a3958e5602f35431$var$__createBinding(result, mod, k);
    }
    $a3958e5602f35431$var$__setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.tokenProgramVersionBeet = module.exports.TokenProgramVersion = void 0;

const $a3958e5602f35431$var$beet = $a3958e5602f35431$var$__importStar((parcelRequire("1DULh")));
var $a3958e5602f35431$var$TokenProgramVersion;
(function(TokenProgramVersion) {
    TokenProgramVersion[TokenProgramVersion["Original"] = 0] = "Original";
    TokenProgramVersion[TokenProgramVersion["Token2022"] = 1] = "Token2022";
})($a3958e5602f35431$var$TokenProgramVersion = module.exports.TokenProgramVersion || (module.exports.TokenProgramVersion = {}));
module.exports.tokenProgramVersionBeet = $a3958e5602f35431$var$beet.fixedScalarEnum($a3958e5602f35431$var$TokenProgramVersion);

});

parcelRegister("awKN7", function(module, exports) {
"use strict";
var $7aa1304906dfde2b$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $7aa1304906dfde2b$var$__setModuleDefault = module.exports && module.exports.__setModuleDefault || (Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
});
var $7aa1304906dfde2b$var$__importStar = module.exports && module.exports.__importStar || function(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) $7aa1304906dfde2b$var$__createBinding(result, mod, k);
    }
    $7aa1304906dfde2b$var$__setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.creatorBeet = void 0;

const $7aa1304906dfde2b$var$beetSolana = $7aa1304906dfde2b$var$__importStar((parcelRequire("8OnYx")));

const $7aa1304906dfde2b$var$beet = $7aa1304906dfde2b$var$__importStar((parcelRequire("1DULh")));
module.exports.creatorBeet = new $7aa1304906dfde2b$var$beet.BeetArgsStruct([
    [
        "address",
        $7aa1304906dfde2b$var$beetSolana.publicKey
    ],
    [
        "verified",
        $7aa1304906dfde2b$var$beet.bool
    ],
    [
        "share",
        $7aa1304906dfde2b$var$beet.u8
    ]
], "Creator");

});



parcelRegister("gHOAl", function(module, exports) {
"use strict";
var $c297e6ab47cc479f$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $c297e6ab47cc479f$var$__setModuleDefault = module.exports && module.exports.__setModuleDefault || (Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
});
var $c297e6ab47cc479f$var$__importStar = module.exports && module.exports.__importStar || function(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) $c297e6ab47cc479f$var$__createBinding(result, mod, k);
    }
    $c297e6ab47cc479f$var$__setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.createDelegateInstruction = module.exports.delegateInstructionDiscriminator = module.exports.delegateStruct = void 0;

const $c297e6ab47cc479f$var$beet = $c297e6ab47cc479f$var$__importStar((parcelRequire("1DULh")));

const $c297e6ab47cc479f$var$web3 = $c297e6ab47cc479f$var$__importStar((parcelRequire("gNDby")));
module.exports.delegateStruct = new $c297e6ab47cc479f$var$beet.BeetArgsStruct([
    [
        "instructionDiscriminator",
        $c297e6ab47cc479f$var$beet.uniformFixedSizeArray($c297e6ab47cc479f$var$beet.u8, 8)
    ],
    [
        "root",
        $c297e6ab47cc479f$var$beet.uniformFixedSizeArray($c297e6ab47cc479f$var$beet.u8, 32)
    ],
    [
        "dataHash",
        $c297e6ab47cc479f$var$beet.uniformFixedSizeArray($c297e6ab47cc479f$var$beet.u8, 32)
    ],
    [
        "creatorHash",
        $c297e6ab47cc479f$var$beet.uniformFixedSizeArray($c297e6ab47cc479f$var$beet.u8, 32)
    ],
    [
        "nonce",
        $c297e6ab47cc479f$var$beet.u64
    ],
    [
        "index",
        $c297e6ab47cc479f$var$beet.u32
    ]
], "DelegateInstructionArgs");
module.exports.delegateInstructionDiscriminator = [
    90,
    147,
    75,
    178,
    85,
    88,
    4,
    137
];
function $c297e6ab47cc479f$var$createDelegateInstruction(accounts, args, programId = new $c297e6ab47cc479f$var$web3.PublicKey("BGUMAp9Gq7iTEuizy4pqaxsTyUCBK68MDfK752saRPUY")) {
    var _a;
    const [data] = module.exports.delegateStruct.serialize({
        instructionDiscriminator: module.exports.delegateInstructionDiscriminator,
        ...args
    });
    const keys = [
        {
            pubkey: accounts.treeAuthority,
            isWritable: false,
            isSigner: false
        },
        {
            pubkey: accounts.leafOwner,
            isWritable: false,
            isSigner: true
        },
        {
            pubkey: accounts.previousLeafDelegate,
            isWritable: false,
            isSigner: false
        },
        {
            pubkey: accounts.newLeafDelegate,
            isWritable: false,
            isSigner: false
        },
        {
            pubkey: accounts.merkleTree,
            isWritable: true,
            isSigner: false
        },
        {
            pubkey: accounts.logWrapper,
            isWritable: false,
            isSigner: false
        },
        {
            pubkey: accounts.compressionProgram,
            isWritable: false,
            isSigner: false
        },
        {
            pubkey: (_a = accounts.systemProgram) !== null && _a !== void 0 ? _a : $c297e6ab47cc479f$var$web3.SystemProgram.programId,
            isWritable: false,
            isSigner: false
        }
    ];
    if (accounts.anchorRemainingAccounts != null) for (const acc of accounts.anchorRemainingAccounts)keys.push(acc);
    const ix = new $c297e6ab47cc479f$var$web3.TransactionInstruction({
        programId: programId,
        keys: keys,
        data: data
    });
    return ix;
}
module.exports.createDelegateInstruction = $c297e6ab47cc479f$var$createDelegateInstruction;

});

parcelRegister("1TGNa", function(module, exports) {
"use strict";
var $161c1f1c6adfd5f0$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $161c1f1c6adfd5f0$var$__setModuleDefault = module.exports && module.exports.__setModuleDefault || (Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
});
var $161c1f1c6adfd5f0$var$__importStar = module.exports && module.exports.__importStar || function(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) $161c1f1c6adfd5f0$var$__createBinding(result, mod, k);
    }
    $161c1f1c6adfd5f0$var$__setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.createMintToCollectionV1Instruction = module.exports.mintToCollectionV1InstructionDiscriminator = module.exports.mintToCollectionV1Struct = void 0;

const $161c1f1c6adfd5f0$var$beet = $161c1f1c6adfd5f0$var$__importStar((parcelRequire("1DULh")));

const $161c1f1c6adfd5f0$var$web3 = $161c1f1c6adfd5f0$var$__importStar((parcelRequire("gNDby")));

var $k6S43 = parcelRequire("k6S43");
module.exports.mintToCollectionV1Struct = new $161c1f1c6adfd5f0$var$beet.FixableBeetArgsStruct([
    [
        "instructionDiscriminator",
        $161c1f1c6adfd5f0$var$beet.uniformFixedSizeArray($161c1f1c6adfd5f0$var$beet.u8, 8)
    ],
    [
        "metadataArgs",
        $k6S43.metadataArgsBeet
    ]
], "MintToCollectionV1InstructionArgs");
module.exports.mintToCollectionV1InstructionDiscriminator = [
    153,
    18,
    178,
    47,
    197,
    158,
    86,
    15
];
function $161c1f1c6adfd5f0$var$createMintToCollectionV1Instruction(accounts, args, programId = new $161c1f1c6adfd5f0$var$web3.PublicKey("BGUMAp9Gq7iTEuizy4pqaxsTyUCBK68MDfK752saRPUY")) {
    var _a;
    const [data] = module.exports.mintToCollectionV1Struct.serialize({
        instructionDiscriminator: module.exports.mintToCollectionV1InstructionDiscriminator,
        ...args
    });
    const keys = [
        {
            pubkey: accounts.treeAuthority,
            isWritable: true,
            isSigner: false
        },
        {
            pubkey: accounts.leafOwner,
            isWritable: false,
            isSigner: false
        },
        {
            pubkey: accounts.leafDelegate,
            isWritable: false,
            isSigner: false
        },
        {
            pubkey: accounts.merkleTree,
            isWritable: true,
            isSigner: false
        },
        {
            pubkey: accounts.payer,
            isWritable: false,
            isSigner: true
        },
        {
            pubkey: accounts.treeDelegate,
            isWritable: false,
            isSigner: true
        },
        {
            pubkey: accounts.collectionAuthority,
            isWritable: false,
            isSigner: true
        },
        {
            pubkey: accounts.collectionAuthorityRecordPda,
            isWritable: false,
            isSigner: false
        },
        {
            pubkey: accounts.collectionMint,
            isWritable: false,
            isSigner: false
        },
        {
            pubkey: accounts.collectionMetadata,
            isWritable: true,
            isSigner: false
        },
        {
            pubkey: accounts.editionAccount,
            isWritable: false,
            isSigner: false
        },
        {
            pubkey: accounts.bubblegumSigner,
            isWritable: false,
            isSigner: false
        },
        {
            pubkey: accounts.logWrapper,
            isWritable: false,
            isSigner: false
        },
        {
            pubkey: accounts.compressionProgram,
            isWritable: false,
            isSigner: false
        },
        {
            pubkey: accounts.tokenMetadataProgram,
            isWritable: false,
            isSigner: false
        },
        {
            pubkey: (_a = accounts.systemProgram) !== null && _a !== void 0 ? _a : $161c1f1c6adfd5f0$var$web3.SystemProgram.programId,
            isWritable: false,
            isSigner: false
        }
    ];
    if (accounts.anchorRemainingAccounts != null) for (const acc of accounts.anchorRemainingAccounts)keys.push(acc);
    const ix = new $161c1f1c6adfd5f0$var$web3.TransactionInstruction({
        programId: programId,
        keys: keys,
        data: data
    });
    return ix;
}
module.exports.createMintToCollectionV1Instruction = $161c1f1c6adfd5f0$var$createMintToCollectionV1Instruction;

});

parcelRegister("S6Egr", function(module, exports) {
"use strict";
var $0a2a337fa7296a22$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $0a2a337fa7296a22$var$__setModuleDefault = module.exports && module.exports.__setModuleDefault || (Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
});
var $0a2a337fa7296a22$var$__importStar = module.exports && module.exports.__importStar || function(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) $0a2a337fa7296a22$var$__createBinding(result, mod, k);
    }
    $0a2a337fa7296a22$var$__setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.createMintV1Instruction = module.exports.mintV1InstructionDiscriminator = module.exports.mintV1Struct = void 0;

const $0a2a337fa7296a22$var$beet = $0a2a337fa7296a22$var$__importStar((parcelRequire("1DULh")));

const $0a2a337fa7296a22$var$web3 = $0a2a337fa7296a22$var$__importStar((parcelRequire("gNDby")));

var $k6S43 = parcelRequire("k6S43");
module.exports.mintV1Struct = new $0a2a337fa7296a22$var$beet.FixableBeetArgsStruct([
    [
        "instructionDiscriminator",
        $0a2a337fa7296a22$var$beet.uniformFixedSizeArray($0a2a337fa7296a22$var$beet.u8, 8)
    ],
    [
        "message",
        $k6S43.metadataArgsBeet
    ]
], "MintV1InstructionArgs");
module.exports.mintV1InstructionDiscriminator = [
    145,
    98,
    192,
    118,
    184,
    147,
    118,
    104
];
function $0a2a337fa7296a22$var$createMintV1Instruction(accounts, args, programId = new $0a2a337fa7296a22$var$web3.PublicKey("BGUMAp9Gq7iTEuizy4pqaxsTyUCBK68MDfK752saRPUY")) {
    var _a;
    const [data] = module.exports.mintV1Struct.serialize({
        instructionDiscriminator: module.exports.mintV1InstructionDiscriminator,
        ...args
    });
    const keys = [
        {
            pubkey: accounts.treeAuthority,
            isWritable: true,
            isSigner: false
        },
        {
            pubkey: accounts.leafOwner,
            isWritable: false,
            isSigner: false
        },
        {
            pubkey: accounts.leafDelegate,
            isWritable: false,
            isSigner: false
        },
        {
            pubkey: accounts.merkleTree,
            isWritable: true,
            isSigner: false
        },
        {
            pubkey: accounts.payer,
            isWritable: false,
            isSigner: true
        },
        {
            pubkey: accounts.treeDelegate,
            isWritable: false,
            isSigner: true
        },
        {
            pubkey: accounts.logWrapper,
            isWritable: false,
            isSigner: false
        },
        {
            pubkey: accounts.compressionProgram,
            isWritable: false,
            isSigner: false
        },
        {
            pubkey: (_a = accounts.systemProgram) !== null && _a !== void 0 ? _a : $0a2a337fa7296a22$var$web3.SystemProgram.programId,
            isWritable: false,
            isSigner: false
        }
    ];
    if (accounts.anchorRemainingAccounts != null) for (const acc of accounts.anchorRemainingAccounts)keys.push(acc);
    const ix = new $0a2a337fa7296a22$var$web3.TransactionInstruction({
        programId: programId,
        keys: keys,
        data: data
    });
    return ix;
}
module.exports.createMintV1Instruction = $0a2a337fa7296a22$var$createMintV1Instruction;

});

parcelRegister("8PAJ0", function(module, exports) {
"use strict";
var $66df92f5c4a0d5ee$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $66df92f5c4a0d5ee$var$__setModuleDefault = module.exports && module.exports.__setModuleDefault || (Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
});
var $66df92f5c4a0d5ee$var$__importStar = module.exports && module.exports.__importStar || function(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) $66df92f5c4a0d5ee$var$__createBinding(result, mod, k);
    }
    $66df92f5c4a0d5ee$var$__setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.createRedeemInstruction = module.exports.redeemInstructionDiscriminator = module.exports.redeemStruct = void 0;

const $66df92f5c4a0d5ee$var$beet = $66df92f5c4a0d5ee$var$__importStar((parcelRequire("1DULh")));

const $66df92f5c4a0d5ee$var$web3 = $66df92f5c4a0d5ee$var$__importStar((parcelRequire("gNDby")));
module.exports.redeemStruct = new $66df92f5c4a0d5ee$var$beet.BeetArgsStruct([
    [
        "instructionDiscriminator",
        $66df92f5c4a0d5ee$var$beet.uniformFixedSizeArray($66df92f5c4a0d5ee$var$beet.u8, 8)
    ],
    [
        "root",
        $66df92f5c4a0d5ee$var$beet.uniformFixedSizeArray($66df92f5c4a0d5ee$var$beet.u8, 32)
    ],
    [
        "dataHash",
        $66df92f5c4a0d5ee$var$beet.uniformFixedSizeArray($66df92f5c4a0d5ee$var$beet.u8, 32)
    ],
    [
        "creatorHash",
        $66df92f5c4a0d5ee$var$beet.uniformFixedSizeArray($66df92f5c4a0d5ee$var$beet.u8, 32)
    ],
    [
        "nonce",
        $66df92f5c4a0d5ee$var$beet.u64
    ],
    [
        "index",
        $66df92f5c4a0d5ee$var$beet.u32
    ]
], "RedeemInstructionArgs");
module.exports.redeemInstructionDiscriminator = [
    184,
    12,
    86,
    149,
    70,
    196,
    97,
    225
];
function $66df92f5c4a0d5ee$var$createRedeemInstruction(accounts, args, programId = new $66df92f5c4a0d5ee$var$web3.PublicKey("BGUMAp9Gq7iTEuizy4pqaxsTyUCBK68MDfK752saRPUY")) {
    var _a;
    const [data] = module.exports.redeemStruct.serialize({
        instructionDiscriminator: module.exports.redeemInstructionDiscriminator,
        ...args
    });
    const keys = [
        {
            pubkey: accounts.treeAuthority,
            isWritable: false,
            isSigner: false
        },
        {
            pubkey: accounts.leafOwner,
            isWritable: true,
            isSigner: true
        },
        {
            pubkey: accounts.leafDelegate,
            isWritable: false,
            isSigner: false
        },
        {
            pubkey: accounts.merkleTree,
            isWritable: true,
            isSigner: false
        },
        {
            pubkey: accounts.voucher,
            isWritable: true,
            isSigner: false
        },
        {
            pubkey: accounts.logWrapper,
            isWritable: false,
            isSigner: false
        },
        {
            pubkey: accounts.compressionProgram,
            isWritable: false,
            isSigner: false
        },
        {
            pubkey: (_a = accounts.systemProgram) !== null && _a !== void 0 ? _a : $66df92f5c4a0d5ee$var$web3.SystemProgram.programId,
            isWritable: false,
            isSigner: false
        }
    ];
    if (accounts.anchorRemainingAccounts != null) for (const acc of accounts.anchorRemainingAccounts)keys.push(acc);
    const ix = new $66df92f5c4a0d5ee$var$web3.TransactionInstruction({
        programId: programId,
        keys: keys,
        data: data
    });
    return ix;
}
module.exports.createRedeemInstruction = $66df92f5c4a0d5ee$var$createRedeemInstruction;

});

parcelRegister("3A2AA", function(module, exports) {
"use strict";
var $29b6be063d4047c6$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $29b6be063d4047c6$var$__setModuleDefault = module.exports && module.exports.__setModuleDefault || (Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
});
var $29b6be063d4047c6$var$__importStar = module.exports && module.exports.__importStar || function(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) $29b6be063d4047c6$var$__createBinding(result, mod, k);
    }
    $29b6be063d4047c6$var$__setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.createSetAndVerifyCollectionInstruction = module.exports.setAndVerifyCollectionInstructionDiscriminator = module.exports.setAndVerifyCollectionStruct = void 0;

const $29b6be063d4047c6$var$beet = $29b6be063d4047c6$var$__importStar((parcelRequire("1DULh")));

const $29b6be063d4047c6$var$web3 = $29b6be063d4047c6$var$__importStar((parcelRequire("gNDby")));

const $29b6be063d4047c6$var$beetSolana = $29b6be063d4047c6$var$__importStar((parcelRequire("8OnYx")));

var $k6S43 = parcelRequire("k6S43");
module.exports.setAndVerifyCollectionStruct = new $29b6be063d4047c6$var$beet.FixableBeetArgsStruct([
    [
        "instructionDiscriminator",
        $29b6be063d4047c6$var$beet.uniformFixedSizeArray($29b6be063d4047c6$var$beet.u8, 8)
    ],
    [
        "root",
        $29b6be063d4047c6$var$beet.uniformFixedSizeArray($29b6be063d4047c6$var$beet.u8, 32)
    ],
    [
        "dataHash",
        $29b6be063d4047c6$var$beet.uniformFixedSizeArray($29b6be063d4047c6$var$beet.u8, 32)
    ],
    [
        "creatorHash",
        $29b6be063d4047c6$var$beet.uniformFixedSizeArray($29b6be063d4047c6$var$beet.u8, 32)
    ],
    [
        "nonce",
        $29b6be063d4047c6$var$beet.u64
    ],
    [
        "index",
        $29b6be063d4047c6$var$beet.u32
    ],
    [
        "message",
        $k6S43.metadataArgsBeet
    ],
    [
        "collection",
        $29b6be063d4047c6$var$beetSolana.publicKey
    ]
], "SetAndVerifyCollectionInstructionArgs");
module.exports.setAndVerifyCollectionInstructionDiscriminator = [
    235,
    242,
    121,
    216,
    158,
    234,
    180,
    234
];
function $29b6be063d4047c6$var$createSetAndVerifyCollectionInstruction(accounts, args, programId = new $29b6be063d4047c6$var$web3.PublicKey("BGUMAp9Gq7iTEuizy4pqaxsTyUCBK68MDfK752saRPUY")) {
    var _a;
    const [data] = module.exports.setAndVerifyCollectionStruct.serialize({
        instructionDiscriminator: module.exports.setAndVerifyCollectionInstructionDiscriminator,
        ...args
    });
    const keys = [
        {
            pubkey: accounts.treeAuthority,
            isWritable: false,
            isSigner: false
        },
        {
            pubkey: accounts.leafOwner,
            isWritable: false,
            isSigner: false
        },
        {
            pubkey: accounts.leafDelegate,
            isWritable: false,
            isSigner: false
        },
        {
            pubkey: accounts.merkleTree,
            isWritable: true,
            isSigner: false
        },
        {
            pubkey: accounts.payer,
            isWritable: false,
            isSigner: true
        },
        {
            pubkey: accounts.treeDelegate,
            isWritable: false,
            isSigner: false
        },
        {
            pubkey: accounts.collectionAuthority,
            isWritable: false,
            isSigner: true
        },
        {
            pubkey: accounts.collectionAuthorityRecordPda,
            isWritable: false,
            isSigner: false
        },
        {
            pubkey: accounts.collectionMint,
            isWritable: false,
            isSigner: false
        },
        {
            pubkey: accounts.collectionMetadata,
            isWritable: true,
            isSigner: false
        },
        {
            pubkey: accounts.editionAccount,
            isWritable: false,
            isSigner: false
        },
        {
            pubkey: accounts.bubblegumSigner,
            isWritable: false,
            isSigner: false
        },
        {
            pubkey: accounts.logWrapper,
            isWritable: false,
            isSigner: false
        },
        {
            pubkey: accounts.compressionProgram,
            isWritable: false,
            isSigner: false
        },
        {
            pubkey: accounts.tokenMetadataProgram,
            isWritable: false,
            isSigner: false
        },
        {
            pubkey: (_a = accounts.systemProgram) !== null && _a !== void 0 ? _a : $29b6be063d4047c6$var$web3.SystemProgram.programId,
            isWritable: false,
            isSigner: false
        }
    ];
    if (accounts.anchorRemainingAccounts != null) for (const acc of accounts.anchorRemainingAccounts)keys.push(acc);
    const ix = new $29b6be063d4047c6$var$web3.TransactionInstruction({
        programId: programId,
        keys: keys,
        data: data
    });
    return ix;
}
module.exports.createSetAndVerifyCollectionInstruction = $29b6be063d4047c6$var$createSetAndVerifyCollectionInstruction;

});

parcelRegister("d8YsU", function(module, exports) {
"use strict";
var $991aecdbf305102c$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $991aecdbf305102c$var$__setModuleDefault = module.exports && module.exports.__setModuleDefault || (Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
});
var $991aecdbf305102c$var$__importStar = module.exports && module.exports.__importStar || function(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) $991aecdbf305102c$var$__createBinding(result, mod, k);
    }
    $991aecdbf305102c$var$__setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.createSetTreeDelegateInstruction = module.exports.setTreeDelegateInstructionDiscriminator = module.exports.setTreeDelegateStruct = void 0;

const $991aecdbf305102c$var$beet = $991aecdbf305102c$var$__importStar((parcelRequire("1DULh")));

const $991aecdbf305102c$var$web3 = $991aecdbf305102c$var$__importStar((parcelRequire("gNDby")));
module.exports.setTreeDelegateStruct = new $991aecdbf305102c$var$beet.BeetArgsStruct([
    [
        "instructionDiscriminator",
        $991aecdbf305102c$var$beet.uniformFixedSizeArray($991aecdbf305102c$var$beet.u8, 8)
    ]
], "SetTreeDelegateInstructionArgs");
module.exports.setTreeDelegateInstructionDiscriminator = [
    253,
    118,
    66,
    37,
    190,
    49,
    154,
    102
];
function $991aecdbf305102c$var$createSetTreeDelegateInstruction(accounts, programId = new $991aecdbf305102c$var$web3.PublicKey("BGUMAp9Gq7iTEuizy4pqaxsTyUCBK68MDfK752saRPUY")) {
    var _a;
    const [data] = module.exports.setTreeDelegateStruct.serialize({
        instructionDiscriminator: module.exports.setTreeDelegateInstructionDiscriminator
    });
    const keys = [
        {
            pubkey: accounts.treeAuthority,
            isWritable: true,
            isSigner: false
        },
        {
            pubkey: accounts.treeCreator,
            isWritable: false,
            isSigner: true
        },
        {
            pubkey: accounts.newTreeDelegate,
            isWritable: false,
            isSigner: false
        },
        {
            pubkey: accounts.merkleTree,
            isWritable: false,
            isSigner: false
        },
        {
            pubkey: (_a = accounts.systemProgram) !== null && _a !== void 0 ? _a : $991aecdbf305102c$var$web3.SystemProgram.programId,
            isWritable: false,
            isSigner: false
        }
    ];
    if (accounts.anchorRemainingAccounts != null) for (const acc of accounts.anchorRemainingAccounts)keys.push(acc);
    const ix = new $991aecdbf305102c$var$web3.TransactionInstruction({
        programId: programId,
        keys: keys,
        data: data
    });
    return ix;
}
module.exports.createSetTreeDelegateInstruction = $991aecdbf305102c$var$createSetTreeDelegateInstruction;

});

parcelRegister("dtfyi", function(module, exports) {
"use strict";
var $9cea0c271f0af83e$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $9cea0c271f0af83e$var$__setModuleDefault = module.exports && module.exports.__setModuleDefault || (Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
});
var $9cea0c271f0af83e$var$__importStar = module.exports && module.exports.__importStar || function(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) $9cea0c271f0af83e$var$__createBinding(result, mod, k);
    }
    $9cea0c271f0af83e$var$__setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.createTransferInstruction = module.exports.transferInstructionDiscriminator = module.exports.transferStruct = void 0;

const $9cea0c271f0af83e$var$beet = $9cea0c271f0af83e$var$__importStar((parcelRequire("1DULh")));

const $9cea0c271f0af83e$var$web3 = $9cea0c271f0af83e$var$__importStar((parcelRequire("gNDby")));
module.exports.transferStruct = new $9cea0c271f0af83e$var$beet.BeetArgsStruct([
    [
        "instructionDiscriminator",
        $9cea0c271f0af83e$var$beet.uniformFixedSizeArray($9cea0c271f0af83e$var$beet.u8, 8)
    ],
    [
        "root",
        $9cea0c271f0af83e$var$beet.uniformFixedSizeArray($9cea0c271f0af83e$var$beet.u8, 32)
    ],
    [
        "dataHash",
        $9cea0c271f0af83e$var$beet.uniformFixedSizeArray($9cea0c271f0af83e$var$beet.u8, 32)
    ],
    [
        "creatorHash",
        $9cea0c271f0af83e$var$beet.uniformFixedSizeArray($9cea0c271f0af83e$var$beet.u8, 32)
    ],
    [
        "nonce",
        $9cea0c271f0af83e$var$beet.u64
    ],
    [
        "index",
        $9cea0c271f0af83e$var$beet.u32
    ]
], "TransferInstructionArgs");
module.exports.transferInstructionDiscriminator = [
    163,
    52,
    200,
    231,
    140,
    3,
    69,
    186
];
function $9cea0c271f0af83e$var$createTransferInstruction(accounts, args, programId = new $9cea0c271f0af83e$var$web3.PublicKey("BGUMAp9Gq7iTEuizy4pqaxsTyUCBK68MDfK752saRPUY")) {
    var _a;
    const [data] = module.exports.transferStruct.serialize({
        instructionDiscriminator: module.exports.transferInstructionDiscriminator,
        ...args
    });
    const keys = [
        {
            pubkey: accounts.treeAuthority,
            isWritable: false,
            isSigner: false
        },
        {
            pubkey: accounts.leafOwner,
            isWritable: false,
            isSigner: false
        },
        {
            pubkey: accounts.leafDelegate,
            isWritable: false,
            isSigner: false
        },
        {
            pubkey: accounts.newLeafOwner,
            isWritable: false,
            isSigner: false
        },
        {
            pubkey: accounts.merkleTree,
            isWritable: true,
            isSigner: false
        },
        {
            pubkey: accounts.logWrapper,
            isWritable: false,
            isSigner: false
        },
        {
            pubkey: accounts.compressionProgram,
            isWritable: false,
            isSigner: false
        },
        {
            pubkey: (_a = accounts.systemProgram) !== null && _a !== void 0 ? _a : $9cea0c271f0af83e$var$web3.SystemProgram.programId,
            isWritable: false,
            isSigner: false
        }
    ];
    if (accounts.anchorRemainingAccounts != null) for (const acc of accounts.anchorRemainingAccounts)keys.push(acc);
    const ix = new $9cea0c271f0af83e$var$web3.TransactionInstruction({
        programId: programId,
        keys: keys,
        data: data
    });
    return ix;
}
module.exports.createTransferInstruction = $9cea0c271f0af83e$var$createTransferInstruction;

});

parcelRegister("7XMRi", function(module, exports) {
"use strict";
var $5cc3f1628e6791c8$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $5cc3f1628e6791c8$var$__setModuleDefault = module.exports && module.exports.__setModuleDefault || (Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
});
var $5cc3f1628e6791c8$var$__importStar = module.exports && module.exports.__importStar || function(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) $5cc3f1628e6791c8$var$__createBinding(result, mod, k);
    }
    $5cc3f1628e6791c8$var$__setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.createUnverifyCollectionInstruction = module.exports.unverifyCollectionInstructionDiscriminator = module.exports.unverifyCollectionStruct = void 0;

const $5cc3f1628e6791c8$var$beet = $5cc3f1628e6791c8$var$__importStar((parcelRequire("1DULh")));

const $5cc3f1628e6791c8$var$web3 = $5cc3f1628e6791c8$var$__importStar((parcelRequire("gNDby")));

var $k6S43 = parcelRequire("k6S43");
module.exports.unverifyCollectionStruct = new $5cc3f1628e6791c8$var$beet.FixableBeetArgsStruct([
    [
        "instructionDiscriminator",
        $5cc3f1628e6791c8$var$beet.uniformFixedSizeArray($5cc3f1628e6791c8$var$beet.u8, 8)
    ],
    [
        "root",
        $5cc3f1628e6791c8$var$beet.uniformFixedSizeArray($5cc3f1628e6791c8$var$beet.u8, 32)
    ],
    [
        "dataHash",
        $5cc3f1628e6791c8$var$beet.uniformFixedSizeArray($5cc3f1628e6791c8$var$beet.u8, 32)
    ],
    [
        "creatorHash",
        $5cc3f1628e6791c8$var$beet.uniformFixedSizeArray($5cc3f1628e6791c8$var$beet.u8, 32)
    ],
    [
        "nonce",
        $5cc3f1628e6791c8$var$beet.u64
    ],
    [
        "index",
        $5cc3f1628e6791c8$var$beet.u32
    ],
    [
        "message",
        $k6S43.metadataArgsBeet
    ]
], "UnverifyCollectionInstructionArgs");
module.exports.unverifyCollectionInstructionDiscriminator = [
    250,
    251,
    42,
    106,
    41,
    137,
    186,
    168
];
function $5cc3f1628e6791c8$var$createUnverifyCollectionInstruction(accounts, args, programId = new $5cc3f1628e6791c8$var$web3.PublicKey("BGUMAp9Gq7iTEuizy4pqaxsTyUCBK68MDfK752saRPUY")) {
    var _a;
    const [data] = module.exports.unverifyCollectionStruct.serialize({
        instructionDiscriminator: module.exports.unverifyCollectionInstructionDiscriminator,
        ...args
    });
    const keys = [
        {
            pubkey: accounts.treeAuthority,
            isWritable: false,
            isSigner: false
        },
        {
            pubkey: accounts.leafOwner,
            isWritable: false,
            isSigner: false
        },
        {
            pubkey: accounts.leafDelegate,
            isWritable: false,
            isSigner: false
        },
        {
            pubkey: accounts.merkleTree,
            isWritable: true,
            isSigner: false
        },
        {
            pubkey: accounts.payer,
            isWritable: false,
            isSigner: true
        },
        {
            pubkey: accounts.treeDelegate,
            isWritable: false,
            isSigner: false
        },
        {
            pubkey: accounts.collectionAuthority,
            isWritable: false,
            isSigner: true
        },
        {
            pubkey: accounts.collectionAuthorityRecordPda,
            isWritable: false,
            isSigner: false
        },
        {
            pubkey: accounts.collectionMint,
            isWritable: false,
            isSigner: false
        },
        {
            pubkey: accounts.collectionMetadata,
            isWritable: true,
            isSigner: false
        },
        {
            pubkey: accounts.editionAccount,
            isWritable: false,
            isSigner: false
        },
        {
            pubkey: accounts.bubblegumSigner,
            isWritable: false,
            isSigner: false
        },
        {
            pubkey: accounts.logWrapper,
            isWritable: false,
            isSigner: false
        },
        {
            pubkey: accounts.compressionProgram,
            isWritable: false,
            isSigner: false
        },
        {
            pubkey: accounts.tokenMetadataProgram,
            isWritable: false,
            isSigner: false
        },
        {
            pubkey: (_a = accounts.systemProgram) !== null && _a !== void 0 ? _a : $5cc3f1628e6791c8$var$web3.SystemProgram.programId,
            isWritable: false,
            isSigner: false
        }
    ];
    if (accounts.anchorRemainingAccounts != null) for (const acc of accounts.anchorRemainingAccounts)keys.push(acc);
    const ix = new $5cc3f1628e6791c8$var$web3.TransactionInstruction({
        programId: programId,
        keys: keys,
        data: data
    });
    return ix;
}
module.exports.createUnverifyCollectionInstruction = $5cc3f1628e6791c8$var$createUnverifyCollectionInstruction;

});

parcelRegister("epq2U", function(module, exports) {
"use strict";
var $a7d79aa9627c719d$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $a7d79aa9627c719d$var$__setModuleDefault = module.exports && module.exports.__setModuleDefault || (Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
});
var $a7d79aa9627c719d$var$__importStar = module.exports && module.exports.__importStar || function(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) $a7d79aa9627c719d$var$__createBinding(result, mod, k);
    }
    $a7d79aa9627c719d$var$__setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.createUnverifyCreatorInstruction = module.exports.unverifyCreatorInstructionDiscriminator = module.exports.unverifyCreatorStruct = void 0;

const $a7d79aa9627c719d$var$beet = $a7d79aa9627c719d$var$__importStar((parcelRequire("1DULh")));

const $a7d79aa9627c719d$var$web3 = $a7d79aa9627c719d$var$__importStar((parcelRequire("gNDby")));

var $k6S43 = parcelRequire("k6S43");
module.exports.unverifyCreatorStruct = new $a7d79aa9627c719d$var$beet.FixableBeetArgsStruct([
    [
        "instructionDiscriminator",
        $a7d79aa9627c719d$var$beet.uniformFixedSizeArray($a7d79aa9627c719d$var$beet.u8, 8)
    ],
    [
        "root",
        $a7d79aa9627c719d$var$beet.uniformFixedSizeArray($a7d79aa9627c719d$var$beet.u8, 32)
    ],
    [
        "dataHash",
        $a7d79aa9627c719d$var$beet.uniformFixedSizeArray($a7d79aa9627c719d$var$beet.u8, 32)
    ],
    [
        "creatorHash",
        $a7d79aa9627c719d$var$beet.uniformFixedSizeArray($a7d79aa9627c719d$var$beet.u8, 32)
    ],
    [
        "nonce",
        $a7d79aa9627c719d$var$beet.u64
    ],
    [
        "index",
        $a7d79aa9627c719d$var$beet.u32
    ],
    [
        "message",
        $k6S43.metadataArgsBeet
    ]
], "UnverifyCreatorInstructionArgs");
module.exports.unverifyCreatorInstructionDiscriminator = [
    107,
    178,
    57,
    39,
    105,
    115,
    112,
    152
];
function $a7d79aa9627c719d$var$createUnverifyCreatorInstruction(accounts, args, programId = new $a7d79aa9627c719d$var$web3.PublicKey("BGUMAp9Gq7iTEuizy4pqaxsTyUCBK68MDfK752saRPUY")) {
    var _a;
    const [data] = module.exports.unverifyCreatorStruct.serialize({
        instructionDiscriminator: module.exports.unverifyCreatorInstructionDiscriminator,
        ...args
    });
    const keys = [
        {
            pubkey: accounts.treeAuthority,
            isWritable: false,
            isSigner: false
        },
        {
            pubkey: accounts.leafOwner,
            isWritable: false,
            isSigner: false
        },
        {
            pubkey: accounts.leafDelegate,
            isWritable: false,
            isSigner: false
        },
        {
            pubkey: accounts.merkleTree,
            isWritable: true,
            isSigner: false
        },
        {
            pubkey: accounts.payer,
            isWritable: false,
            isSigner: true
        },
        {
            pubkey: accounts.creator,
            isWritable: false,
            isSigner: true
        },
        {
            pubkey: accounts.logWrapper,
            isWritable: false,
            isSigner: false
        },
        {
            pubkey: accounts.compressionProgram,
            isWritable: false,
            isSigner: false
        },
        {
            pubkey: (_a = accounts.systemProgram) !== null && _a !== void 0 ? _a : $a7d79aa9627c719d$var$web3.SystemProgram.programId,
            isWritable: false,
            isSigner: false
        }
    ];
    if (accounts.anchorRemainingAccounts != null) for (const acc of accounts.anchorRemainingAccounts)keys.push(acc);
    const ix = new $a7d79aa9627c719d$var$web3.TransactionInstruction({
        programId: programId,
        keys: keys,
        data: data
    });
    return ix;
}
module.exports.createUnverifyCreatorInstruction = $a7d79aa9627c719d$var$createUnverifyCreatorInstruction;

});

parcelRegister("1X08Y", function(module, exports) {
"use strict";
var $16bb69b0df34a265$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $16bb69b0df34a265$var$__setModuleDefault = module.exports && module.exports.__setModuleDefault || (Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
});
var $16bb69b0df34a265$var$__importStar = module.exports && module.exports.__importStar || function(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) $16bb69b0df34a265$var$__createBinding(result, mod, k);
    }
    $16bb69b0df34a265$var$__setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.createVerifyCollectionInstruction = module.exports.verifyCollectionInstructionDiscriminator = module.exports.verifyCollectionStruct = void 0;

const $16bb69b0df34a265$var$beet = $16bb69b0df34a265$var$__importStar((parcelRequire("1DULh")));

const $16bb69b0df34a265$var$web3 = $16bb69b0df34a265$var$__importStar((parcelRequire("gNDby")));

var $k6S43 = parcelRequire("k6S43");
module.exports.verifyCollectionStruct = new $16bb69b0df34a265$var$beet.FixableBeetArgsStruct([
    [
        "instructionDiscriminator",
        $16bb69b0df34a265$var$beet.uniformFixedSizeArray($16bb69b0df34a265$var$beet.u8, 8)
    ],
    [
        "root",
        $16bb69b0df34a265$var$beet.uniformFixedSizeArray($16bb69b0df34a265$var$beet.u8, 32)
    ],
    [
        "dataHash",
        $16bb69b0df34a265$var$beet.uniformFixedSizeArray($16bb69b0df34a265$var$beet.u8, 32)
    ],
    [
        "creatorHash",
        $16bb69b0df34a265$var$beet.uniformFixedSizeArray($16bb69b0df34a265$var$beet.u8, 32)
    ],
    [
        "nonce",
        $16bb69b0df34a265$var$beet.u64
    ],
    [
        "index",
        $16bb69b0df34a265$var$beet.u32
    ],
    [
        "message",
        $k6S43.metadataArgsBeet
    ]
], "VerifyCollectionInstructionArgs");
module.exports.verifyCollectionInstructionDiscriminator = [
    56,
    113,
    101,
    253,
    79,
    55,
    122,
    169
];
function $16bb69b0df34a265$var$createVerifyCollectionInstruction(accounts, args, programId = new $16bb69b0df34a265$var$web3.PublicKey("BGUMAp9Gq7iTEuizy4pqaxsTyUCBK68MDfK752saRPUY")) {
    var _a;
    const [data] = module.exports.verifyCollectionStruct.serialize({
        instructionDiscriminator: module.exports.verifyCollectionInstructionDiscriminator,
        ...args
    });
    const keys = [
        {
            pubkey: accounts.treeAuthority,
            isWritable: false,
            isSigner: false
        },
        {
            pubkey: accounts.leafOwner,
            isWritable: false,
            isSigner: false
        },
        {
            pubkey: accounts.leafDelegate,
            isWritable: false,
            isSigner: false
        },
        {
            pubkey: accounts.merkleTree,
            isWritable: true,
            isSigner: false
        },
        {
            pubkey: accounts.payer,
            isWritable: false,
            isSigner: true
        },
        {
            pubkey: accounts.treeDelegate,
            isWritable: false,
            isSigner: false
        },
        {
            pubkey: accounts.collectionAuthority,
            isWritable: false,
            isSigner: true
        },
        {
            pubkey: accounts.collectionAuthorityRecordPda,
            isWritable: false,
            isSigner: false
        },
        {
            pubkey: accounts.collectionMint,
            isWritable: false,
            isSigner: false
        },
        {
            pubkey: accounts.collectionMetadata,
            isWritable: true,
            isSigner: false
        },
        {
            pubkey: accounts.editionAccount,
            isWritable: false,
            isSigner: false
        },
        {
            pubkey: accounts.bubblegumSigner,
            isWritable: false,
            isSigner: false
        },
        {
            pubkey: accounts.logWrapper,
            isWritable: false,
            isSigner: false
        },
        {
            pubkey: accounts.compressionProgram,
            isWritable: false,
            isSigner: false
        },
        {
            pubkey: accounts.tokenMetadataProgram,
            isWritable: false,
            isSigner: false
        },
        {
            pubkey: (_a = accounts.systemProgram) !== null && _a !== void 0 ? _a : $16bb69b0df34a265$var$web3.SystemProgram.programId,
            isWritable: false,
            isSigner: false
        }
    ];
    if (accounts.anchorRemainingAccounts != null) for (const acc of accounts.anchorRemainingAccounts)keys.push(acc);
    const ix = new $16bb69b0df34a265$var$web3.TransactionInstruction({
        programId: programId,
        keys: keys,
        data: data
    });
    return ix;
}
module.exports.createVerifyCollectionInstruction = $16bb69b0df34a265$var$createVerifyCollectionInstruction;

});

parcelRegister("bMpY1", function(module, exports) {
"use strict";
var $893851ef6f4dde0b$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $893851ef6f4dde0b$var$__setModuleDefault = module.exports && module.exports.__setModuleDefault || (Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
});
var $893851ef6f4dde0b$var$__importStar = module.exports && module.exports.__importStar || function(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) $893851ef6f4dde0b$var$__createBinding(result, mod, k);
    }
    $893851ef6f4dde0b$var$__setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.createVerifyCreatorInstruction = module.exports.verifyCreatorInstructionDiscriminator = module.exports.verifyCreatorStruct = void 0;

const $893851ef6f4dde0b$var$beet = $893851ef6f4dde0b$var$__importStar((parcelRequire("1DULh")));

const $893851ef6f4dde0b$var$web3 = $893851ef6f4dde0b$var$__importStar((parcelRequire("gNDby")));

var $k6S43 = parcelRequire("k6S43");
module.exports.verifyCreatorStruct = new $893851ef6f4dde0b$var$beet.FixableBeetArgsStruct([
    [
        "instructionDiscriminator",
        $893851ef6f4dde0b$var$beet.uniformFixedSizeArray($893851ef6f4dde0b$var$beet.u8, 8)
    ],
    [
        "root",
        $893851ef6f4dde0b$var$beet.uniformFixedSizeArray($893851ef6f4dde0b$var$beet.u8, 32)
    ],
    [
        "dataHash",
        $893851ef6f4dde0b$var$beet.uniformFixedSizeArray($893851ef6f4dde0b$var$beet.u8, 32)
    ],
    [
        "creatorHash",
        $893851ef6f4dde0b$var$beet.uniformFixedSizeArray($893851ef6f4dde0b$var$beet.u8, 32)
    ],
    [
        "nonce",
        $893851ef6f4dde0b$var$beet.u64
    ],
    [
        "index",
        $893851ef6f4dde0b$var$beet.u32
    ],
    [
        "message",
        $k6S43.metadataArgsBeet
    ]
], "VerifyCreatorInstructionArgs");
module.exports.verifyCreatorInstructionDiscriminator = [
    52,
    17,
    96,
    132,
    71,
    4,
    85,
    194
];
function $893851ef6f4dde0b$var$createVerifyCreatorInstruction(accounts, args, programId = new $893851ef6f4dde0b$var$web3.PublicKey("BGUMAp9Gq7iTEuizy4pqaxsTyUCBK68MDfK752saRPUY")) {
    var _a;
    const [data] = module.exports.verifyCreatorStruct.serialize({
        instructionDiscriminator: module.exports.verifyCreatorInstructionDiscriminator,
        ...args
    });
    const keys = [
        {
            pubkey: accounts.treeAuthority,
            isWritable: false,
            isSigner: false
        },
        {
            pubkey: accounts.leafOwner,
            isWritable: false,
            isSigner: false
        },
        {
            pubkey: accounts.leafDelegate,
            isWritable: false,
            isSigner: false
        },
        {
            pubkey: accounts.merkleTree,
            isWritable: true,
            isSigner: false
        },
        {
            pubkey: accounts.payer,
            isWritable: false,
            isSigner: true
        },
        {
            pubkey: accounts.creator,
            isWritable: false,
            isSigner: true
        },
        {
            pubkey: accounts.logWrapper,
            isWritable: false,
            isSigner: false
        },
        {
            pubkey: accounts.compressionProgram,
            isWritable: false,
            isSigner: false
        },
        {
            pubkey: (_a = accounts.systemProgram) !== null && _a !== void 0 ? _a : $893851ef6f4dde0b$var$web3.SystemProgram.programId,
            isWritable: false,
            isSigner: false
        }
    ];
    if (accounts.anchorRemainingAccounts != null) for (const acc of accounts.anchorRemainingAccounts)keys.push(acc);
    const ix = new $893851ef6f4dde0b$var$web3.TransactionInstruction({
        programId: programId,
        keys: keys,
        data: data
    });
    return ix;
}
module.exports.createVerifyCreatorInstruction = $893851ef6f4dde0b$var$createVerifyCreatorInstruction;

});


parcelRegister("dtie9", function(module, exports) {
"use strict";
var $9cec1f5c438d3e74$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $9cec1f5c438d3e74$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $9cec1f5c438d3e74$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

$9cec1f5c438d3e74$var$__exportStar((parcelRequire("brd7C")), module.exports);

$9cec1f5c438d3e74$var$__exportStar((parcelRequire("3PxdX")), module.exports);

$9cec1f5c438d3e74$var$__exportStar((parcelRequire("awKN7")), module.exports);

$9cec1f5c438d3e74$var$__exportStar((parcelRequire("6IP7q")), module.exports);

$9cec1f5c438d3e74$var$__exportStar((parcelRequire("fwbNs")), module.exports);

$9cec1f5c438d3e74$var$__exportStar((parcelRequire("k6S43")), module.exports);

$9cec1f5c438d3e74$var$__exportStar((parcelRequire("e2KNJ")), module.exports);

$9cec1f5c438d3e74$var$__exportStar((parcelRequire("bon4v")), module.exports);

$9cec1f5c438d3e74$var$__exportStar((parcelRequire("3ZGlf")), module.exports);

$9cec1f5c438d3e74$var$__exportStar((parcelRequire("hVvqL")), module.exports);

$9cec1f5c438d3e74$var$__exportStar((parcelRequire("9LOhz")), module.exports);

});
parcelRegister("brd7C", function(module, exports) {
"use strict";
var $853c65116f3d2e81$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $853c65116f3d2e81$var$__setModuleDefault = module.exports && module.exports.__setModuleDefault || (Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
});
var $853c65116f3d2e81$var$__importStar = module.exports && module.exports.__importStar || function(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) $853c65116f3d2e81$var$__createBinding(result, mod, k);
    }
    $853c65116f3d2e81$var$__setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.bubblegumEventTypeBeet = module.exports.BubblegumEventType = void 0;

const $853c65116f3d2e81$var$beet = $853c65116f3d2e81$var$__importStar((parcelRequire("1DULh")));
var $853c65116f3d2e81$var$BubblegumEventType;
(function(BubblegumEventType) {
    BubblegumEventType[BubblegumEventType["Uninitialized"] = 0] = "Uninitialized";
    BubblegumEventType[BubblegumEventType["LeafSchemaEvent"] = 1] = "LeafSchemaEvent";
})($853c65116f3d2e81$var$BubblegumEventType = module.exports.BubblegumEventType || (module.exports.BubblegumEventType = {}));
module.exports.bubblegumEventTypeBeet = $853c65116f3d2e81$var$beet.fixedScalarEnum($853c65116f3d2e81$var$BubblegumEventType);

});

parcelRegister("6IP7q", function(module, exports) {
"use strict";
var $4e4e813c0b7ed135$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $4e4e813c0b7ed135$var$__setModuleDefault = module.exports && module.exports.__setModuleDefault || (Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
});
var $4e4e813c0b7ed135$var$__importStar = module.exports && module.exports.__importStar || function(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) $4e4e813c0b7ed135$var$__createBinding(result, mod, k);
    }
    $4e4e813c0b7ed135$var$__setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.instructionNameBeet = module.exports.InstructionName = void 0;

const $4e4e813c0b7ed135$var$beet = $4e4e813c0b7ed135$var$__importStar((parcelRequire("1DULh")));
var $4e4e813c0b7ed135$var$InstructionName;
(function(InstructionName) {
    InstructionName[InstructionName["Unknown"] = 0] = "Unknown";
    InstructionName[InstructionName["MintV1"] = 1] = "MintV1";
    InstructionName[InstructionName["Redeem"] = 2] = "Redeem";
    InstructionName[InstructionName["CancelRedeem"] = 3] = "CancelRedeem";
    InstructionName[InstructionName["Transfer"] = 4] = "Transfer";
    InstructionName[InstructionName["Delegate"] = 5] = "Delegate";
    InstructionName[InstructionName["DecompressV1"] = 6] = "DecompressV1";
    InstructionName[InstructionName["Compress"] = 7] = "Compress";
    InstructionName[InstructionName["Burn"] = 8] = "Burn";
    InstructionName[InstructionName["CreateTree"] = 9] = "CreateTree";
    InstructionName[InstructionName["VerifyCreator"] = 10] = "VerifyCreator";
    InstructionName[InstructionName["UnverifyCreator"] = 11] = "UnverifyCreator";
    InstructionName[InstructionName["VerifyCollection"] = 12] = "VerifyCollection";
    InstructionName[InstructionName["UnverifyCollection"] = 13] = "UnverifyCollection";
    InstructionName[InstructionName["SetAndVerifyCollection"] = 14] = "SetAndVerifyCollection";
    InstructionName[InstructionName["MintToCollectionV1"] = 15] = "MintToCollectionV1";
})($4e4e813c0b7ed135$var$InstructionName = module.exports.InstructionName || (module.exports.InstructionName = {}));
module.exports.instructionNameBeet = $4e4e813c0b7ed135$var$beet.fixedScalarEnum($4e4e813c0b7ed135$var$InstructionName);

});

parcelRegister("9LOhz", function(module, exports) {
"use strict";
var $71cf81e1b4cc86ea$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $71cf81e1b4cc86ea$var$__setModuleDefault = module.exports && module.exports.__setModuleDefault || (Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
});
var $71cf81e1b4cc86ea$var$__importStar = module.exports && module.exports.__importStar || function(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) $71cf81e1b4cc86ea$var$__createBinding(result, mod, k);
    }
    $71cf81e1b4cc86ea$var$__setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.versionBeet = module.exports.Version = void 0;

const $71cf81e1b4cc86ea$var$beet = $71cf81e1b4cc86ea$var$__importStar((parcelRequire("1DULh")));
var $71cf81e1b4cc86ea$var$Version;
(function(Version) {
    Version[Version["V1"] = 0] = "V1";
})($71cf81e1b4cc86ea$var$Version = module.exports.Version || (module.exports.Version = {}));
module.exports.versionBeet = $71cf81e1b4cc86ea$var$beet.fixedScalarEnum($71cf81e1b4cc86ea$var$Version);

});



parcelRegister("l0Lrl", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.cusper = void 0;

var $f22Bo = parcelRequire("f22Bo");

var $5dlKa = parcelRequire("5dlKa");
module.exports.cusper = (0, $f22Bo.initCusper)($5dlKa.errorFromCode);

});
parcelRegister("f22Bo", function(module, exports) {
"use strict";
var $af190fa12e0408c9$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, {
        enumerable: true,
        get: function() {
            return m[k];
        }
    });
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $af190fa12e0408c9$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $af190fa12e0408c9$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

$af190fa12e0408c9$var$__exportStar((parcelRequire("fi5RY")), module.exports);

$af190fa12e0408c9$var$__exportStar((parcelRequire("4fRY0")), module.exports);

});
parcelRegister("fi5RY", function(module, exports) {
"use strict";
var $b21d1707f5229bce$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, {
        enumerable: true,
        get: function() {
            return m[k];
        }
    });
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $b21d1707f5229bce$var$__setModuleDefault = module.exports && module.exports.__setModuleDefault || (Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
});
var $b21d1707f5229bce$var$__importStar = module.exports && module.exports.__importStar || function(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) $b21d1707f5229bce$var$__createBinding(result, mod, k);
    }
    $b21d1707f5229bce$var$__setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.TokenLendingError = module.exports.AnchorError = module.exports.CustomProgramError = module.exports.CusperUnknownError = module.exports.initCusper = module.exports.ErrorResolver = void 0;

var $bET1B = parcelRequire("bET1B");

const $b21d1707f5229bce$var$anchor = $b21d1707f5229bce$var$__importStar((parcelRequire("fbyRT")));

var $85ebB = parcelRequire("85ebB");
// -----------------
// Error Resolver
// -----------------
class $b21d1707f5229bce$var$ErrorResolver {
    constructor(resolveErrorFromCode){
        this.resolveErrorFromCode = resolveErrorFromCode;
    }
    /**
     * Attempts to resolve the provided error code to a known or custom error.
     *
     * @param captureBoundaryFn is used to exclude everything after (including)
     * that function from the stack trace if possible
     * @param fallbackToUnknown unless `false` a {@link CusperUnknownError} is
     * returned when resolution fails
     */ errorFromCode(code, captureBoundaryFn, fallbackToUnknown = true) {
        // Try specific program errors first since they're more likely
        let err = this.resolveErrorFromCode != null ? this.resolveErrorFromCode(code) : null;
        if (err != null) return this.passPreparedError(err, captureBoundaryFn !== null && captureBoundaryFn !== void 0 ? captureBoundaryFn : this.errorFromCode);
        // Then try errors of known programs
        err = $b21d1707f5229bce$var$AnchorError.fromCode(code);
        if (err != null) return this.passPreparedError(err, captureBoundaryFn !== null && captureBoundaryFn !== void 0 ? captureBoundaryFn : this.errorFromCode);
        err = $b21d1707f5229bce$var$TokenLendingError.fromCode(code);
        if (err != null) return this.passPreparedError(err, captureBoundaryFn !== null && captureBoundaryFn !== void 0 ? captureBoundaryFn : this.errorFromCode);
        if (fallbackToUnknown) {
            err = new $b21d1707f5229bce$var$CusperUnknownError(code, "CusperUnknownError", "cusper does not know this error");
            return this.passPreparedError(err, captureBoundaryFn !== null && captureBoundaryFn !== void 0 ? captureBoundaryFn : this.errorFromCode);
        }
    }
    /**
     * Attempts to parse the error code from the provied logs and then resolve it
     * to a known or custom error.
     * @param fallbackToUnknown unless `false` a {@link CusperUnknownError} is
     * returned when resolution fails
     */ errorFromProgramLogs(logs, fallbackToUnknown = true) {
        const code = (0, $bET1B.errorCodeFromLogs)(logs);
        return code == null ? null : this.errorFromCode(code, this.errorFromProgramLogs, fallbackToUnknown);
    }
    /**
     * Throws an error that it attempts to resolve from the logs of the provided error.
     * If no error can be resolved it throws a {@link CusperUnknownError} instead
     */ throwError(error) {
        const err = error.logs != null && this.errorFromProgramLogs(error.logs, true) || new $b21d1707f5229bce$var$CusperUnknownError(-1, "Error created without logs and thus without error code");
        throw this.passPreparedError(err, this.throwError);
    }
    passPreparedError(err, captureBoundaryFn) {
        if (err == null) return null;
        if (typeof Error.captureStackTrace === "function") Error.captureStackTrace(err, captureBoundaryFn);
        return err;
    }
}
module.exports.ErrorResolver = $b21d1707f5229bce$var$ErrorResolver;
/**
 * Initializes a Custom Program Error Resolver, aka _Cusper_.
 *
 * @param resolveErrorFromCode if provided it will be used to resolve custom
 * errors before falling back to known program errors
 */ function $b21d1707f5229bce$var$initCusper(resolveErrorFromCode) {
    return new $b21d1707f5229bce$var$ErrorResolver(resolveErrorFromCode);
}
module.exports.initCusper = $b21d1707f5229bce$var$initCusper;
// -----------------
// Unknown Error
// -----------------
/**
 * This error is returned/raised when an error code couldn't be found or resolved to a
 * custom or known error.
 */ class $b21d1707f5229bce$var$CusperUnknownError extends Error {
    constructor(code, ...params){
        super(...params);
        this.code = code;
        this.name = "CusperUnknownError";
    }
}
module.exports.CusperUnknownError = $b21d1707f5229bce$var$CusperUnknownError;
// -----------------
// Custom Program Error
// -----------------
/**
 * Used by implementers to provide their own errors to be resolved by cusper.
 */ class $b21d1707f5229bce$var$CustomProgramError extends Error {
    /**
     * Creates an instance of a {@link CustomProgramError}.
     *
     * @param code the error code for which this error was resolved
     * @param name the name of the error
     */ constructor(code, name, ...params){
        super(...params);
        this.code = code;
        this.name = `CustomProgramError#${name}`;
    }
}
module.exports.CustomProgramError = $b21d1707f5229bce$var$CustomProgramError;
// -----------------
// Anchor
// -----------------
/**
 * An error raised by the anchor program before getting to the actual program
 * implementation.
 */ class $b21d1707f5229bce$var$AnchorError extends Error {
    constructor(code, name, ...params){
        super(...params);
        this.code = code;
        this.name = `AnchorError#${name}`;
    }
    static fromCode(code) {
        const errorMeta = $b21d1707f5229bce$var$AnchorError.errorMap.get(code);
        return errorMeta != null ? new $b21d1707f5229bce$var$AnchorError(errorMeta.code, errorMeta.name, errorMeta.message) : null;
    }
    toString() {
        return `${this.name}: ${this.message}`;
    }
}
module.exports.AnchorError = $b21d1707f5229bce$var$AnchorError;
$b21d1707f5229bce$var$AnchorError.errorMap = Object.entries($b21d1707f5229bce$var$anchor.LangErrorCode).reduce((acc, [key, code])=>{
    acc.set(code, {
        code: code,
        name: key,
        message: $b21d1707f5229bce$var$anchor.LangErrorMessage.get(code)
    });
    return acc;
}, new Map());
// -----------------
// Token Lending
// -----------------
/**
 * Error raised by the token lending program.
 * Please note that error codes overlap with other _known_ programs as they start at `0`.
 * Thus in some cases they might be wrongly represented and actually not
 * originate from the token lending program.
 */ class $b21d1707f5229bce$var$TokenLendingError extends Error {
    constructor(code, name, ...params){
        super(...params);
        this.code = code;
        this.name = `TokenLendingError#${name}`;
    }
    static fromCode(code) {
        const errorMeta = $b21d1707f5229bce$var$TokenLendingError.errorMap.get(code);
        return errorMeta != null ? new $b21d1707f5229bce$var$TokenLendingError(errorMeta.code, errorMeta.name, errorMeta.message) : null;
    }
    toString() {
        return `${this.name}: ${this.message}`;
    }
}
module.exports.TokenLendingError = $b21d1707f5229bce$var$TokenLendingError;
$b21d1707f5229bce$var$TokenLendingError.errorMap = $85ebB.tokenLendingErrors;

});
parcelRegister("bET1B", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.errorCodeFromLogs = void 0;
const $87ce1ced2d953f5c$var$errorLineRx = /Custom program error: (0x[a-f0-9]+)/i;
/**
 * Parses an error code included with solana logs
 *
 * @private
 */ function $87ce1ced2d953f5c$var$errorCodeFromLogs(logs) {
    for (const line of logs){
        const match = line.match($87ce1ced2d953f5c$var$errorLineRx);
        if (match == null) continue;
        const hexCode = match[1];
        try {
            return parseInt(hexCode);
        } catch (_) {}
    }
    return null;
}
module.exports.errorCodeFromLogs = $87ce1ced2d953f5c$var$errorCodeFromLogs;

});

parcelRegister("fbyRT", function(module, exports) {
"use strict";
// https://github.com/project-serum/anchor/blob/1749a7bd53eec516416a61598290da1431e2910f/ts/src/error.ts
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.LangErrorMessage = module.exports.LangErrorCode = void 0;
/**
 * Maps Error names to Error codes
 *
 * @private
 */ module.exports.LangErrorCode = {
    // Instructions.
    InstructionMissing: 100,
    InstructionFallbackNotFound: 101,
    InstructionDidNotDeserialize: 102,
    InstructionDidNotSerialize: 103,
    // IDL instructions.
    IdlInstructionStub: 1000,
    IdlInstructionInvalidProgram: 1001,
    // Constraints.
    ConstraintMut: 2000,
    ConstraintHasOne: 2001,
    ConstraintSigner: 2002,
    ConstraintRaw: 2003,
    ConstraintOwner: 2004,
    ConstraintRentExempt: 2005,
    ConstraintSeeds: 2006,
    ConstraintExecutable: 2007,
    ConstraintState: 2008,
    ConstraintAssociated: 2009,
    ConstraintAssociatedInit: 2010,
    ConstraintClose: 2011,
    ConstraintAddress: 2012,
    ConstraintZero: 2013,
    ConstraintTokenMint: 2014,
    ConstraintTokenOwner: 2015,
    ConstraintMintMintAuthority: 2016,
    ConstraintMintFreezeAuthority: 2017,
    ConstraintMintDecimals: 2018,
    ConstraintSpace: 2019,
    // Accounts.
    AccountDiscriminatorAlreadySet: 3000,
    AccountDiscriminatorNotFound: 3001,
    AccountDiscriminatorMismatch: 3002,
    AccountDidNotDeserialize: 3003,
    AccountDidNotSerialize: 3004,
    AccountNotEnoughKeys: 3005,
    AccountNotMutable: 3006,
    AccountOwnedByWrongProgram: 3007,
    InvalidProgramId: 3008,
    InvalidProgramExecutable: 3009,
    AccountNotSigner: 3010,
    AccountNotSystemOwned: 3011,
    AccountNotInitialized: 3012,
    AccountNotProgramData: 3013,
    // State.
    StateInvalidAddress: 4000,
    // Used for APIs that shouldn't be used anymore.
    Deprecated: 5000
};
/**
 * Maps Error Codes to Error messages
 * @private
 */ module.exports.LangErrorMessage = new Map([
    // Instructions.
    [
        module.exports.LangErrorCode.InstructionMissing,
        "8 byte instruction identifier not provided"
    ],
    [
        module.exports.LangErrorCode.InstructionFallbackNotFound,
        "Fallback functions are not supported"
    ],
    [
        module.exports.LangErrorCode.InstructionDidNotDeserialize,
        "The program could not deserialize the given instruction"
    ],
    [
        module.exports.LangErrorCode.InstructionDidNotSerialize,
        "The program could not serialize the given instruction"
    ],
    // Idl instructions.
    [
        module.exports.LangErrorCode.IdlInstructionStub,
        "The program was compiled without idl instructions"
    ],
    [
        module.exports.LangErrorCode.IdlInstructionInvalidProgram,
        "The transaction was given an invalid program for the IDL instruction"
    ],
    // Constraints.
    [
        module.exports.LangErrorCode.ConstraintMut,
        "A mut constraint was violated"
    ],
    [
        module.exports.LangErrorCode.ConstraintHasOne,
        "A has_one constraint was violated"
    ],
    [
        module.exports.LangErrorCode.ConstraintSigner,
        "A signer constraint was violated"
    ],
    [
        module.exports.LangErrorCode.ConstraintRaw,
        "A raw constraint was violated"
    ],
    [
        module.exports.LangErrorCode.ConstraintOwner,
        "An owner constraint was violated"
    ],
    [
        module.exports.LangErrorCode.ConstraintRentExempt,
        "A rent exempt constraint was violated"
    ],
    [
        module.exports.LangErrorCode.ConstraintSeeds,
        "A seeds constraint was violated"
    ],
    [
        module.exports.LangErrorCode.ConstraintExecutable,
        "An executable constraint was violated"
    ],
    [
        module.exports.LangErrorCode.ConstraintState,
        "A state constraint was violated"
    ],
    [
        module.exports.LangErrorCode.ConstraintAssociated,
        "An associated constraint was violated"
    ],
    [
        module.exports.LangErrorCode.ConstraintAssociatedInit,
        "An associated init constraint was violated"
    ],
    [
        module.exports.LangErrorCode.ConstraintClose,
        "A close constraint was violated"
    ],
    [
        module.exports.LangErrorCode.ConstraintAddress,
        "An address constraint was violated"
    ],
    [
        module.exports.LangErrorCode.ConstraintZero,
        "Expected zero account discriminant"
    ],
    [
        module.exports.LangErrorCode.ConstraintTokenMint,
        "A token mint constraint was violated"
    ],
    [
        module.exports.LangErrorCode.ConstraintTokenOwner,
        "A token owner constraint was violated"
    ],
    [
        module.exports.LangErrorCode.ConstraintMintMintAuthority,
        "A mint mint authority constraint was violated"
    ],
    [
        module.exports.LangErrorCode.ConstraintMintFreezeAuthority,
        "A mint freeze authority constraint was violated"
    ],
    [
        module.exports.LangErrorCode.ConstraintMintDecimals,
        "A mint decimals constraint was violated"
    ],
    [
        module.exports.LangErrorCode.ConstraintSpace,
        "A space constraint was violated"
    ],
    // Accounts.
    [
        module.exports.LangErrorCode.AccountDiscriminatorAlreadySet,
        "The account discriminator was already set on this account"
    ],
    [
        module.exports.LangErrorCode.AccountDiscriminatorNotFound,
        "No 8 byte discriminator was found on the account"
    ],
    [
        module.exports.LangErrorCode.AccountDiscriminatorMismatch,
        "8 byte discriminator did not match what was expected"
    ],
    [
        module.exports.LangErrorCode.AccountDidNotDeserialize,
        "Failed to deserialize the account"
    ],
    [
        module.exports.LangErrorCode.AccountDidNotSerialize,
        "Failed to serialize the account"
    ],
    [
        module.exports.LangErrorCode.AccountNotEnoughKeys,
        "Not enough account keys given to the instruction"
    ],
    [
        module.exports.LangErrorCode.AccountNotMutable,
        "The given account is not mutable"
    ],
    [
        module.exports.LangErrorCode.AccountOwnedByWrongProgram,
        "The given account is owned by a different program than expected"
    ],
    [
        module.exports.LangErrorCode.InvalidProgramId,
        "Program ID was not as expected"
    ],
    [
        module.exports.LangErrorCode.InvalidProgramExecutable,
        "Program account is not executable"
    ],
    [
        module.exports.LangErrorCode.AccountNotSigner,
        "The given account did not sign"
    ],
    [
        module.exports.LangErrorCode.AccountNotSystemOwned,
        "The given account is not owned by the system program"
    ],
    [
        module.exports.LangErrorCode.AccountNotInitialized,
        "The program expected this account to be already initialized"
    ],
    [
        module.exports.LangErrorCode.AccountNotProgramData,
        "The given account is not a program data account"
    ],
    // State.
    [
        module.exports.LangErrorCode.StateInvalidAddress,
        "The given state account does not have the correct address"
    ],
    // Misc.
    [
        module.exports.LangErrorCode.Deprecated,
        "The API being used is deprecated and should no longer be used"
    ]
]);

});

parcelRegister("85ebB", function(module, exports) {
"use strict";
// Generated via ./scripts/fetch-token-lending-errors.ts
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.tokenLendingErrors = void 0;
/**
 * Maps error codes to {@link ErrorMeta}.
 * @private
 */ module.exports.tokenLendingErrors = new Map([
    [
        0,
        {
            code: 0,
            message: 'Failed to unpack instruction data"',
            name: "InstructionUnpackError"
        }
    ],
    [
        1,
        {
            code: 1,
            message: 'Account is already initialized"',
            name: "AlreadyInitialized"
        }
    ],
    [
        2,
        {
            code: 2,
            message: 'Lamport balance below rent-exempt threshold"',
            name: "NotRentExempt"
        }
    ],
    [
        3,
        {
            code: 3,
            message: 'Market authority is invalid"',
            name: "InvalidMarketAuthority"
        }
    ],
    [
        4,
        {
            code: 4,
            message: 'Market owner is invalid"',
            name: "InvalidMarketOwner"
        }
    ],
    [
        5,
        {
            code: 5,
            message: 'Input account owner is not the program address"',
            name: "InvalidAccountOwner"
        }
    ],
    [
        6,
        {
            code: 6,
            message: 'Input token account is not owned by the correct token program id"',
            name: "InvalidTokenOwner"
        }
    ],
    [
        7,
        {
            code: 7,
            message: 'Input token account is not valid"',
            name: "InvalidTokenAccount"
        }
    ],
    [
        8,
        {
            code: 8,
            message: 'Input token mint account is not valid"',
            name: "InvalidTokenMint"
        }
    ],
    [
        9,
        {
            code: 9,
            message: 'Input token program account is not valid"',
            name: "InvalidTokenProgram"
        }
    ],
    [
        10,
        {
            code: 10,
            message: 'Input amount is invalid"',
            name: "InvalidAmount"
        }
    ],
    [
        11,
        {
            code: 11,
            message: 'Input config value is invalid"',
            name: "InvalidConfig"
        }
    ],
    [
        12,
        {
            code: 12,
            message: 'Input account must be a signer"',
            name: "InvalidSigner"
        }
    ],
    [
        13,
        {
            code: 13,
            message: 'Invalid account input"',
            name: "InvalidAccountInput"
        }
    ],
    [
        14,
        {
            code: 14,
            message: 'Math operation overflow"',
            name: "MathOverflow"
        }
    ],
    [
        15,
        {
            code: 15,
            message: 'Token initialize mint failed"',
            name: "TokenInitializeMintFailed"
        }
    ],
    [
        16,
        {
            code: 16,
            message: 'Token initialize account failed"',
            name: "TokenInitializeAccountFailed"
        }
    ],
    [
        17,
        {
            code: 17,
            message: 'Token transfer failed"',
            name: "TokenTransferFailed"
        }
    ],
    [
        18,
        {
            code: 18,
            message: 'Token mint to failed"',
            name: "TokenMintToFailed"
        }
    ],
    [
        19,
        {
            code: 19,
            message: 'Token burn failed"',
            name: "TokenBurnFailed"
        }
    ],
    [
        20,
        {
            code: 20,
            message: 'Insufficient liquidity available"',
            name: "InsufficientLiquidity"
        }
    ],
    [
        21,
        {
            code: 21,
            message: 'Input reserve has collateral disabled"',
            name: "ReserveCollateralDisabled"
        }
    ],
    [
        22,
        {
            code: 22,
            message: 'Reserve state needs to be refreshed"',
            name: "ReserveStale"
        }
    ],
    [
        23,
        {
            code: 23,
            message: 'Withdraw amount too small"',
            name: "WithdrawTooSmall"
        }
    ],
    [
        24,
        {
            code: 24,
            message: 'Withdraw amount too large"',
            name: "WithdrawTooLarge"
        }
    ],
    [
        25,
        {
            code: 25,
            message: 'Borrow amount too small to receive liquidity after fees"',
            name: "BorrowTooSmall"
        }
    ],
    [
        26,
        {
            code: 26,
            message: 'Borrow amount too large for deposited collateral"',
            name: "BorrowTooLarge"
        }
    ],
    [
        27,
        {
            code: 27,
            message: 'Repay amount too small to transfer liquidity"',
            name: "RepayTooSmall"
        }
    ],
    [
        28,
        {
            code: 28,
            message: 'Liquidation amount too small to receive collateral"',
            name: "LiquidationTooSmall"
        }
    ],
    [
        29,
        {
            code: 29,
            message: 'Cannot liquidate healthy obligations"',
            name: "ObligationHealthy"
        }
    ],
    [
        30,
        {
            code: 30,
            message: 'Obligation state needs to be refreshed"',
            name: "ObligationStale"
        }
    ],
    [
        31,
        {
            code: 31,
            message: 'Obligation reserve limit exceeded"',
            name: "ObligationReserveLimit"
        }
    ],
    [
        32,
        {
            code: 32,
            message: 'Obligation owner is invalid"',
            name: "InvalidObligationOwner"
        }
    ],
    [
        33,
        {
            code: 33,
            message: 'Obligation deposits are empty"',
            name: "ObligationDepositsEmpty"
        }
    ],
    [
        34,
        {
            code: 34,
            message: 'Obligation borrows are empty"',
            name: "ObligationBorrowsEmpty"
        }
    ],
    [
        35,
        {
            code: 35,
            message: 'Obligation deposits have zero value"',
            name: "ObligationDepositsZero"
        }
    ],
    [
        36,
        {
            code: 36,
            message: 'Obligation borrows have zero value"',
            name: "ObligationBorrowsZero"
        }
    ],
    [
        37,
        {
            code: 37,
            message: 'Invalid obligation collateral"',
            name: "InvalidObligationCollateral"
        }
    ],
    [
        38,
        {
            code: 38,
            message: 'Invalid obligation liquidity"',
            name: "InvalidObligationLiquidity"
        }
    ],
    [
        39,
        {
            code: 39,
            message: 'Obligation collateral is empty"',
            name: "ObligationCollateralEmpty"
        }
    ],
    [
        40,
        {
            code: 40,
            message: 'Obligation liquidity is empty"',
            name: "ObligationLiquidityEmpty"
        }
    ],
    [
        41,
        {
            code: 41,
            message: 'Interest rate is negative"',
            name: "NegativeInterestRate"
        }
    ],
    [
        42,
        {
            code: 42,
            message: 'Input oracle config is invalid"',
            name: "InvalidOracleConfig"
        }
    ],
    [
        43,
        {
            code: 43,
            message: 'Input flash loan receiver program account is not valid"',
            name: "InvalidFlashLoanReceiverProgram"
        }
    ],
    [
        44,
        {
            code: 44,
            message: 'Not enough liquidity after flash loan"',
            name: "NotEnoughLiquidityAfterFlashLoan"
        }
    ]
]);

});


parcelRegister("4fRY0", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

});



parcelRegister("3JSSJ", function(module, exports) {

var $6ZWSX = parcelRequire("6ZWSX");
var $2b90257149c0879e$require$Buffer = $6ZWSX.Buffer;
"use strict";
var $2b90257149c0879e$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $2b90257149c0879e$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $2b90257149c0879e$var$__createBinding(exports1, m, p);
};
var $2b90257149c0879e$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.computeCompressedNFTHash = module.exports.computeCreatorHash = module.exports.computeDataHash = module.exports.getLeafAssetId = void 0;


var $1IGmO = parcelRequire("1IGmO");

var $gNDby = parcelRequire("gNDby");

const $2b90257149c0879e$var$bn_js_1 = $2b90257149c0879e$var$__importDefault((parcelRequire("dEXSZ")));

$2b90257149c0879e$var$__exportStar((parcelRequire("5dlKa")), module.exports);
async function $2b90257149c0879e$var$getLeafAssetId(tree, leafIndex) {
    const [assetId] = await $gNDby.PublicKey.findProgramAddress([
        $2b90257149c0879e$require$Buffer.from("asset", "utf8"),
        tree.toBuffer(),
        Uint8Array.from(leafIndex.toArray("le", 8))
    ], (parcelRequire("5dlKa")).PROGRAM_ID);
    return assetId;
}
module.exports.getLeafAssetId = $2b90257149c0879e$var$getLeafAssetId;
function $2b90257149c0879e$var$computeDataHash(metadata) {
    const [serializedMetadata] = (parcelRequire("5dlKa")).metadataArgsBeet.serialize(metadata);
    const metadataHash = $2b90257149c0879e$require$Buffer.from($1IGmO.keccak_256.digest(serializedMetadata));
    const sellerFeeBasisPointsBuffer = new $2b90257149c0879e$var$bn_js_1.default(metadata.sellerFeeBasisPoints).toBuffer("le", 2);
    return $2b90257149c0879e$require$Buffer.from($1IGmO.keccak_256.digest($2b90257149c0879e$require$Buffer.concat([
        metadataHash,
        sellerFeeBasisPointsBuffer
    ])));
}
module.exports.computeDataHash = $2b90257149c0879e$var$computeDataHash;
function $2b90257149c0879e$var$computeCreatorHash(creators) {
    let bufferOfCreatorShares = $2b90257149c0879e$require$Buffer.from([]);
    for (const creator of creators)bufferOfCreatorShares = $2b90257149c0879e$require$Buffer.concat([
        creator.address.toBuffer(),
        $2b90257149c0879e$require$Buffer.from([
            creator.verified ? 1 : 0
        ]),
        $2b90257149c0879e$require$Buffer.from([
            creator.share
        ])
    ]);
    return $2b90257149c0879e$require$Buffer.from($1IGmO.keccak_256.digest(bufferOfCreatorShares));
}
module.exports.computeCreatorHash = $2b90257149c0879e$var$computeCreatorHash;
function $2b90257149c0879e$var$computeCompressedNFTHash(assetId, owner, delegate, treeNonce, metadata) {
    const message = $2b90257149c0879e$require$Buffer.concat([
        $2b90257149c0879e$require$Buffer.from([
            0x1
        ]),
        assetId.toBuffer(),
        owner.toBuffer(),
        delegate.toBuffer(),
        treeNonce.toBuffer("le", 8),
        $2b90257149c0879e$var$computeDataHash(metadata),
        $2b90257149c0879e$var$computeCreatorHash(metadata.creators)
    ]);
    return $2b90257149c0879e$require$Buffer.from($1IGmO.keccak_256.digest(message));
}
module.exports.computeCompressedNFTHash = $2b90257149c0879e$var$computeCompressedNFTHash;

});
parcelRegister("1IGmO", function(module, exports) {

var $hPtJY = parcelRequire("hPtJY");
/**
 * [js-sha3]{@link https://github.com/emn178/js-sha3}
 *
 * @version 0.8.0
 * @author Chen, Yi-Cyuan [emn178@gmail.com]
 * @copyright Chen, Yi-Cyuan 2015-2018
 * @license MIT
 */ /*jslint bitwise: true */ (function() {
    "use strict";
    var INPUT_ERROR = "input is invalid type";
    var FINALIZE_ERROR = "finalize already called";
    var WINDOW = typeof window === "object";
    var root = WINDOW ? window : {};
    if (root.JS_SHA3_NO_WINDOW) WINDOW = false;
    var WEB_WORKER = !WINDOW && typeof self === "object";
    var NODE_JS = !root.JS_SHA3_NO_NODE_JS && typeof $hPtJY === "object" && $hPtJY.versions && $hPtJY.versions.node;
    if (NODE_JS) root = $parcel$global;
    else if (WEB_WORKER) root = self;
    var COMMON_JS = !root.JS_SHA3_NO_COMMON_JS && true && module.exports;
    var AMD = typeof define === "function" && define.amd;
    var ARRAY_BUFFER = !root.JS_SHA3_NO_ARRAY_BUFFER && typeof ArrayBuffer !== "undefined";
    var HEX_CHARS = "0123456789abcdef".split("");
    var SHAKE_PADDING = [
        31,
        7936,
        2031616,
        520093696
    ];
    var CSHAKE_PADDING = [
        4,
        1024,
        262144,
        67108864
    ];
    var KECCAK_PADDING = [
        1,
        256,
        65536,
        16777216
    ];
    var PADDING = [
        6,
        1536,
        393216,
        100663296
    ];
    var SHIFT = [
        0,
        8,
        16,
        24
    ];
    var RC = [
        1,
        0,
        32898,
        0,
        32906,
        2147483648,
        2147516416,
        2147483648,
        32907,
        0,
        2147483649,
        0,
        2147516545,
        2147483648,
        32777,
        2147483648,
        138,
        0,
        136,
        0,
        2147516425,
        0,
        2147483658,
        0,
        2147516555,
        0,
        139,
        2147483648,
        32905,
        2147483648,
        32771,
        2147483648,
        32770,
        2147483648,
        128,
        2147483648,
        32778,
        0,
        2147483658,
        2147483648,
        2147516545,
        2147483648,
        32896,
        2147483648,
        2147483649,
        0,
        2147516424,
        2147483648
    ];
    var BITS = [
        224,
        256,
        384,
        512
    ];
    var SHAKE_BITS = [
        128,
        256
    ];
    var OUTPUT_TYPES = [
        "hex",
        "buffer",
        "arrayBuffer",
        "array",
        "digest"
    ];
    var CSHAKE_BYTEPAD = {
        "128": 168,
        "256": 136
    };
    if (root.JS_SHA3_NO_NODE_JS || !Array.isArray) Array.isArray = function(obj) {
        return Object.prototype.toString.call(obj) === "[object Array]";
    };
    if (ARRAY_BUFFER && (root.JS_SHA3_NO_ARRAY_BUFFER_IS_VIEW || !ArrayBuffer.isView)) ArrayBuffer.isView = function(obj) {
        return typeof obj === "object" && obj.buffer && obj.buffer.constructor === ArrayBuffer;
    };
    var createOutputMethod = function(bits, padding, outputType) {
        return function(message) {
            return new Keccak(bits, padding, bits).update(message)[outputType]();
        };
    };
    var createShakeOutputMethod = function(bits, padding, outputType) {
        return function(message, outputBits) {
            return new Keccak(bits, padding, outputBits).update(message)[outputType]();
        };
    };
    var createCshakeOutputMethod = function(bits, padding, outputType) {
        return function(message, outputBits, n, s) {
            return methods["cshake" + bits].update(message, outputBits, n, s)[outputType]();
        };
    };
    var createKmacOutputMethod = function(bits, padding, outputType) {
        return function(key, message, outputBits, s) {
            return methods["kmac" + bits].update(key, message, outputBits, s)[outputType]();
        };
    };
    var createOutputMethods = function(method, createMethod, bits, padding) {
        for(var i = 0; i < OUTPUT_TYPES.length; ++i){
            var type = OUTPUT_TYPES[i];
            method[type] = createMethod(bits, padding, type);
        }
        return method;
    };
    var createMethod = function(bits, padding) {
        var method = createOutputMethod(bits, padding, "hex");
        method.create = function() {
            return new Keccak(bits, padding, bits);
        };
        method.update = function(message) {
            return method.create().update(message);
        };
        return createOutputMethods(method, createOutputMethod, bits, padding);
    };
    var createShakeMethod = function(bits, padding) {
        var method = createShakeOutputMethod(bits, padding, "hex");
        method.create = function(outputBits) {
            return new Keccak(bits, padding, outputBits);
        };
        method.update = function(message, outputBits) {
            return method.create(outputBits).update(message);
        };
        return createOutputMethods(method, createShakeOutputMethod, bits, padding);
    };
    var createCshakeMethod = function(bits, padding) {
        var w = CSHAKE_BYTEPAD[bits];
        var method = createCshakeOutputMethod(bits, padding, "hex");
        method.create = function(outputBits, n, s) {
            if (!n && !s) return methods["shake" + bits].create(outputBits);
            else return new Keccak(bits, padding, outputBits).bytepad([
                n,
                s
            ], w);
        };
        method.update = function(message, outputBits, n, s) {
            return method.create(outputBits, n, s).update(message);
        };
        return createOutputMethods(method, createCshakeOutputMethod, bits, padding);
    };
    var createKmacMethod = function(bits, padding) {
        var w = CSHAKE_BYTEPAD[bits];
        var method = createKmacOutputMethod(bits, padding, "hex");
        method.create = function(key, outputBits, s) {
            return new Kmac(bits, padding, outputBits).bytepad([
                "KMAC",
                s
            ], w).bytepad([
                key
            ], w);
        };
        method.update = function(key, message, outputBits, s) {
            return method.create(key, outputBits, s).update(message);
        };
        return createOutputMethods(method, createKmacOutputMethod, bits, padding);
    };
    var algorithms = [
        {
            name: "keccak",
            padding: KECCAK_PADDING,
            bits: BITS,
            createMethod: createMethod
        },
        {
            name: "sha3",
            padding: PADDING,
            bits: BITS,
            createMethod: createMethod
        },
        {
            name: "shake",
            padding: SHAKE_PADDING,
            bits: SHAKE_BITS,
            createMethod: createShakeMethod
        },
        {
            name: "cshake",
            padding: CSHAKE_PADDING,
            bits: SHAKE_BITS,
            createMethod: createCshakeMethod
        },
        {
            name: "kmac",
            padding: CSHAKE_PADDING,
            bits: SHAKE_BITS,
            createMethod: createKmacMethod
        }
    ];
    var methods = {}, methodNames = [];
    for(var i = 0; i < algorithms.length; ++i){
        var algorithm = algorithms[i];
        var bits = algorithm.bits;
        for(var j = 0; j < bits.length; ++j){
            var methodName = algorithm.name + "_" + bits[j];
            methodNames.push(methodName);
            methods[methodName] = algorithm.createMethod(bits[j], algorithm.padding);
            if (algorithm.name !== "sha3") {
                var newMethodName = algorithm.name + bits[j];
                methodNames.push(newMethodName);
                methods[newMethodName] = methods[methodName];
            }
        }
    }
    function Keccak(bits, padding, outputBits) {
        this.blocks = [];
        this.s = [];
        this.padding = padding;
        this.outputBits = outputBits;
        this.reset = true;
        this.finalized = false;
        this.block = 0;
        this.start = 0;
        this.blockCount = 1600 - (bits << 1) >> 5;
        this.byteCount = this.blockCount << 2;
        this.outputBlocks = outputBits >> 5;
        this.extraBytes = (outputBits & 31) >> 3;
        for(var i = 0; i < 50; ++i)this.s[i] = 0;
    }
    Keccak.prototype.update = function(message) {
        if (this.finalized) throw new Error(FINALIZE_ERROR);
        var notString, type = typeof message;
        if (type !== "string") {
            if (type === "object") {
                if (message === null) throw new Error(INPUT_ERROR);
                else if (ARRAY_BUFFER && message.constructor === ArrayBuffer) message = new Uint8Array(message);
                else if (!Array.isArray(message)) {
                    if (!ARRAY_BUFFER || !ArrayBuffer.isView(message)) throw new Error(INPUT_ERROR);
                }
            } else throw new Error(INPUT_ERROR);
            notString = true;
        }
        var blocks = this.blocks, byteCount = this.byteCount, length = message.length, blockCount = this.blockCount, index = 0, s = this.s, i, code;
        while(index < length){
            if (this.reset) {
                this.reset = false;
                blocks[0] = this.block;
                for(i = 1; i < blockCount + 1; ++i)blocks[i] = 0;
            }
            if (notString) for(i = this.start; index < length && i < byteCount; ++index)blocks[i >> 2] |= message[index] << SHIFT[i++ & 3];
            else for(i = this.start; index < length && i < byteCount; ++index){
                code = message.charCodeAt(index);
                if (code < 0x80) blocks[i >> 2] |= code << SHIFT[i++ & 3];
                else if (code < 0x800) {
                    blocks[i >> 2] |= (0xc0 | code >> 6) << SHIFT[i++ & 3];
                    blocks[i >> 2] |= (0x80 | code & 0x3f) << SHIFT[i++ & 3];
                } else if (code < 0xd800 || code >= 0xe000) {
                    blocks[i >> 2] |= (0xe0 | code >> 12) << SHIFT[i++ & 3];
                    blocks[i >> 2] |= (0x80 | code >> 6 & 0x3f) << SHIFT[i++ & 3];
                    blocks[i >> 2] |= (0x80 | code & 0x3f) << SHIFT[i++ & 3];
                } else {
                    code = 0x10000 + ((code & 0x3ff) << 10 | message.charCodeAt(++index) & 0x3ff);
                    blocks[i >> 2] |= (0xf0 | code >> 18) << SHIFT[i++ & 3];
                    blocks[i >> 2] |= (0x80 | code >> 12 & 0x3f) << SHIFT[i++ & 3];
                    blocks[i >> 2] |= (0x80 | code >> 6 & 0x3f) << SHIFT[i++ & 3];
                    blocks[i >> 2] |= (0x80 | code & 0x3f) << SHIFT[i++ & 3];
                }
            }
            this.lastByteIndex = i;
            if (i >= byteCount) {
                this.start = i - byteCount;
                this.block = blocks[blockCount];
                for(i = 0; i < blockCount; ++i)s[i] ^= blocks[i];
                f(s);
                this.reset = true;
            } else this.start = i;
        }
        return this;
    };
    Keccak.prototype.encode = function(x, right) {
        var o = x & 255, n = 1;
        var bytes = [
            o
        ];
        x = x >> 8;
        o = x & 255;
        while(o > 0){
            bytes.unshift(o);
            x = x >> 8;
            o = x & 255;
            ++n;
        }
        if (right) bytes.push(n);
        else bytes.unshift(n);
        this.update(bytes);
        return bytes.length;
    };
    Keccak.prototype.encodeString = function(str) {
        var notString, type = typeof str;
        if (type !== "string") {
            if (type === "object") {
                if (str === null) throw new Error(INPUT_ERROR);
                else if (ARRAY_BUFFER && str.constructor === ArrayBuffer) str = new Uint8Array(str);
                else if (!Array.isArray(str)) {
                    if (!ARRAY_BUFFER || !ArrayBuffer.isView(str)) throw new Error(INPUT_ERROR);
                }
            } else throw new Error(INPUT_ERROR);
            notString = true;
        }
        var bytes = 0, length = str.length;
        if (notString) bytes = length;
        else for(var i = 0; i < str.length; ++i){
            var code = str.charCodeAt(i);
            if (code < 0x80) bytes += 1;
            else if (code < 0x800) bytes += 2;
            else if (code < 0xd800 || code >= 0xe000) bytes += 3;
            else {
                code = 0x10000 + ((code & 0x3ff) << 10 | str.charCodeAt(++i) & 0x3ff);
                bytes += 4;
            }
        }
        bytes += this.encode(bytes * 8);
        this.update(str);
        return bytes;
    };
    Keccak.prototype.bytepad = function(strs, w) {
        var bytes = this.encode(w);
        for(var i = 0; i < strs.length; ++i)bytes += this.encodeString(strs[i]);
        var paddingBytes = w - bytes % w;
        var zeros = [];
        zeros.length = paddingBytes;
        this.update(zeros);
        return this;
    };
    Keccak.prototype.finalize = function() {
        if (this.finalized) return;
        this.finalized = true;
        var blocks = this.blocks, i = this.lastByteIndex, blockCount = this.blockCount, s = this.s;
        blocks[i >> 2] |= this.padding[i & 3];
        if (this.lastByteIndex === this.byteCount) {
            blocks[0] = blocks[blockCount];
            for(i = 1; i < blockCount + 1; ++i)blocks[i] = 0;
        }
        blocks[blockCount - 1] |= 0x80000000;
        for(i = 0; i < blockCount; ++i)s[i] ^= blocks[i];
        f(s);
    };
    Keccak.prototype.toString = Keccak.prototype.hex = function() {
        this.finalize();
        var blockCount = this.blockCount, s = this.s, outputBlocks = this.outputBlocks, extraBytes = this.extraBytes, i = 0, j = 0;
        var hex = "", block;
        while(j < outputBlocks){
            for(i = 0; i < blockCount && j < outputBlocks; ++i, ++j){
                block = s[i];
                hex += HEX_CHARS[block >> 4 & 0x0F] + HEX_CHARS[block & 0x0F] + HEX_CHARS[block >> 12 & 0x0F] + HEX_CHARS[block >> 8 & 0x0F] + HEX_CHARS[block >> 20 & 0x0F] + HEX_CHARS[block >> 16 & 0x0F] + HEX_CHARS[block >> 28 & 0x0F] + HEX_CHARS[block >> 24 & 0x0F];
            }
            if (j % blockCount === 0) {
                f(s);
                i = 0;
            }
        }
        if (extraBytes) {
            block = s[i];
            hex += HEX_CHARS[block >> 4 & 0x0F] + HEX_CHARS[block & 0x0F];
            if (extraBytes > 1) hex += HEX_CHARS[block >> 12 & 0x0F] + HEX_CHARS[block >> 8 & 0x0F];
            if (extraBytes > 2) hex += HEX_CHARS[block >> 20 & 0x0F] + HEX_CHARS[block >> 16 & 0x0F];
        }
        return hex;
    };
    Keccak.prototype.arrayBuffer = function() {
        this.finalize();
        var blockCount = this.blockCount, s = this.s, outputBlocks = this.outputBlocks, extraBytes = this.extraBytes, i = 0, j = 0;
        var bytes = this.outputBits >> 3;
        var buffer;
        if (extraBytes) buffer = new ArrayBuffer(outputBlocks + 1 << 2);
        else buffer = new ArrayBuffer(bytes);
        var array = new Uint32Array(buffer);
        while(j < outputBlocks){
            for(i = 0; i < blockCount && j < outputBlocks; ++i, ++j)array[j] = s[i];
            if (j % blockCount === 0) f(s);
        }
        if (extraBytes) {
            array[i] = s[i];
            buffer = buffer.slice(0, bytes);
        }
        return buffer;
    };
    Keccak.prototype.buffer = Keccak.prototype.arrayBuffer;
    Keccak.prototype.digest = Keccak.prototype.array = function() {
        this.finalize();
        var blockCount = this.blockCount, s = this.s, outputBlocks = this.outputBlocks, extraBytes = this.extraBytes, i = 0, j = 0;
        var array = [], offset, block;
        while(j < outputBlocks){
            for(i = 0; i < blockCount && j < outputBlocks; ++i, ++j){
                offset = j << 2;
                block = s[i];
                array[offset] = block & 0xFF;
                array[offset + 1] = block >> 8 & 0xFF;
                array[offset + 2] = block >> 16 & 0xFF;
                array[offset + 3] = block >> 24 & 0xFF;
            }
            if (j % blockCount === 0) f(s);
        }
        if (extraBytes) {
            offset = j << 2;
            block = s[i];
            array[offset] = block & 0xFF;
            if (extraBytes > 1) array[offset + 1] = block >> 8 & 0xFF;
            if (extraBytes > 2) array[offset + 2] = block >> 16 & 0xFF;
        }
        return array;
    };
    function Kmac(bits, padding, outputBits) {
        Keccak.call(this, bits, padding, outputBits);
    }
    Kmac.prototype = new Keccak();
    Kmac.prototype.finalize = function() {
        this.encode(this.outputBits, true);
        return Keccak.prototype.finalize.call(this);
    };
    var f = function(s) {
        var h, l, n, c0, c1, c2, c3, c4, c5, c6, c7, c8, c9, b0, b1, b2, b3, b4, b5, b6, b7, b8, b9, b10, b11, b12, b13, b14, b15, b16, b17, b18, b19, b20, b21, b22, b23, b24, b25, b26, b27, b28, b29, b30, b31, b32, b33, b34, b35, b36, b37, b38, b39, b40, b41, b42, b43, b44, b45, b46, b47, b48, b49;
        for(n = 0; n < 48; n += 2){
            c0 = s[0] ^ s[10] ^ s[20] ^ s[30] ^ s[40];
            c1 = s[1] ^ s[11] ^ s[21] ^ s[31] ^ s[41];
            c2 = s[2] ^ s[12] ^ s[22] ^ s[32] ^ s[42];
            c3 = s[3] ^ s[13] ^ s[23] ^ s[33] ^ s[43];
            c4 = s[4] ^ s[14] ^ s[24] ^ s[34] ^ s[44];
            c5 = s[5] ^ s[15] ^ s[25] ^ s[35] ^ s[45];
            c6 = s[6] ^ s[16] ^ s[26] ^ s[36] ^ s[46];
            c7 = s[7] ^ s[17] ^ s[27] ^ s[37] ^ s[47];
            c8 = s[8] ^ s[18] ^ s[28] ^ s[38] ^ s[48];
            c9 = s[9] ^ s[19] ^ s[29] ^ s[39] ^ s[49];
            h = c8 ^ (c2 << 1 | c3 >>> 31);
            l = c9 ^ (c3 << 1 | c2 >>> 31);
            s[0] ^= h;
            s[1] ^= l;
            s[10] ^= h;
            s[11] ^= l;
            s[20] ^= h;
            s[21] ^= l;
            s[30] ^= h;
            s[31] ^= l;
            s[40] ^= h;
            s[41] ^= l;
            h = c0 ^ (c4 << 1 | c5 >>> 31);
            l = c1 ^ (c5 << 1 | c4 >>> 31);
            s[2] ^= h;
            s[3] ^= l;
            s[12] ^= h;
            s[13] ^= l;
            s[22] ^= h;
            s[23] ^= l;
            s[32] ^= h;
            s[33] ^= l;
            s[42] ^= h;
            s[43] ^= l;
            h = c2 ^ (c6 << 1 | c7 >>> 31);
            l = c3 ^ (c7 << 1 | c6 >>> 31);
            s[4] ^= h;
            s[5] ^= l;
            s[14] ^= h;
            s[15] ^= l;
            s[24] ^= h;
            s[25] ^= l;
            s[34] ^= h;
            s[35] ^= l;
            s[44] ^= h;
            s[45] ^= l;
            h = c4 ^ (c8 << 1 | c9 >>> 31);
            l = c5 ^ (c9 << 1 | c8 >>> 31);
            s[6] ^= h;
            s[7] ^= l;
            s[16] ^= h;
            s[17] ^= l;
            s[26] ^= h;
            s[27] ^= l;
            s[36] ^= h;
            s[37] ^= l;
            s[46] ^= h;
            s[47] ^= l;
            h = c6 ^ (c0 << 1 | c1 >>> 31);
            l = c7 ^ (c1 << 1 | c0 >>> 31);
            s[8] ^= h;
            s[9] ^= l;
            s[18] ^= h;
            s[19] ^= l;
            s[28] ^= h;
            s[29] ^= l;
            s[38] ^= h;
            s[39] ^= l;
            s[48] ^= h;
            s[49] ^= l;
            b0 = s[0];
            b1 = s[1];
            b32 = s[11] << 4 | s[10] >>> 28;
            b33 = s[10] << 4 | s[11] >>> 28;
            b14 = s[20] << 3 | s[21] >>> 29;
            b15 = s[21] << 3 | s[20] >>> 29;
            b46 = s[31] << 9 | s[30] >>> 23;
            b47 = s[30] << 9 | s[31] >>> 23;
            b28 = s[40] << 18 | s[41] >>> 14;
            b29 = s[41] << 18 | s[40] >>> 14;
            b20 = s[2] << 1 | s[3] >>> 31;
            b21 = s[3] << 1 | s[2] >>> 31;
            b2 = s[13] << 12 | s[12] >>> 20;
            b3 = s[12] << 12 | s[13] >>> 20;
            b34 = s[22] << 10 | s[23] >>> 22;
            b35 = s[23] << 10 | s[22] >>> 22;
            b16 = s[33] << 13 | s[32] >>> 19;
            b17 = s[32] << 13 | s[33] >>> 19;
            b48 = s[42] << 2 | s[43] >>> 30;
            b49 = s[43] << 2 | s[42] >>> 30;
            b40 = s[5] << 30 | s[4] >>> 2;
            b41 = s[4] << 30 | s[5] >>> 2;
            b22 = s[14] << 6 | s[15] >>> 26;
            b23 = s[15] << 6 | s[14] >>> 26;
            b4 = s[25] << 11 | s[24] >>> 21;
            b5 = s[24] << 11 | s[25] >>> 21;
            b36 = s[34] << 15 | s[35] >>> 17;
            b37 = s[35] << 15 | s[34] >>> 17;
            b18 = s[45] << 29 | s[44] >>> 3;
            b19 = s[44] << 29 | s[45] >>> 3;
            b10 = s[6] << 28 | s[7] >>> 4;
            b11 = s[7] << 28 | s[6] >>> 4;
            b42 = s[17] << 23 | s[16] >>> 9;
            b43 = s[16] << 23 | s[17] >>> 9;
            b24 = s[26] << 25 | s[27] >>> 7;
            b25 = s[27] << 25 | s[26] >>> 7;
            b6 = s[36] << 21 | s[37] >>> 11;
            b7 = s[37] << 21 | s[36] >>> 11;
            b38 = s[47] << 24 | s[46] >>> 8;
            b39 = s[46] << 24 | s[47] >>> 8;
            b30 = s[8] << 27 | s[9] >>> 5;
            b31 = s[9] << 27 | s[8] >>> 5;
            b12 = s[18] << 20 | s[19] >>> 12;
            b13 = s[19] << 20 | s[18] >>> 12;
            b44 = s[29] << 7 | s[28] >>> 25;
            b45 = s[28] << 7 | s[29] >>> 25;
            b26 = s[38] << 8 | s[39] >>> 24;
            b27 = s[39] << 8 | s[38] >>> 24;
            b8 = s[48] << 14 | s[49] >>> 18;
            b9 = s[49] << 14 | s[48] >>> 18;
            s[0] = b0 ^ ~b2 & b4;
            s[1] = b1 ^ ~b3 & b5;
            s[10] = b10 ^ ~b12 & b14;
            s[11] = b11 ^ ~b13 & b15;
            s[20] = b20 ^ ~b22 & b24;
            s[21] = b21 ^ ~b23 & b25;
            s[30] = b30 ^ ~b32 & b34;
            s[31] = b31 ^ ~b33 & b35;
            s[40] = b40 ^ ~b42 & b44;
            s[41] = b41 ^ ~b43 & b45;
            s[2] = b2 ^ ~b4 & b6;
            s[3] = b3 ^ ~b5 & b7;
            s[12] = b12 ^ ~b14 & b16;
            s[13] = b13 ^ ~b15 & b17;
            s[22] = b22 ^ ~b24 & b26;
            s[23] = b23 ^ ~b25 & b27;
            s[32] = b32 ^ ~b34 & b36;
            s[33] = b33 ^ ~b35 & b37;
            s[42] = b42 ^ ~b44 & b46;
            s[43] = b43 ^ ~b45 & b47;
            s[4] = b4 ^ ~b6 & b8;
            s[5] = b5 ^ ~b7 & b9;
            s[14] = b14 ^ ~b16 & b18;
            s[15] = b15 ^ ~b17 & b19;
            s[24] = b24 ^ ~b26 & b28;
            s[25] = b25 ^ ~b27 & b29;
            s[34] = b34 ^ ~b36 & b38;
            s[35] = b35 ^ ~b37 & b39;
            s[44] = b44 ^ ~b46 & b48;
            s[45] = b45 ^ ~b47 & b49;
            s[6] = b6 ^ ~b8 & b0;
            s[7] = b7 ^ ~b9 & b1;
            s[16] = b16 ^ ~b18 & b10;
            s[17] = b17 ^ ~b19 & b11;
            s[26] = b26 ^ ~b28 & b20;
            s[27] = b27 ^ ~b29 & b21;
            s[36] = b36 ^ ~b38 & b30;
            s[37] = b37 ^ ~b39 & b31;
            s[46] = b46 ^ ~b48 & b40;
            s[47] = b47 ^ ~b49 & b41;
            s[8] = b8 ^ ~b0 & b2;
            s[9] = b9 ^ ~b1 & b3;
            s[18] = b18 ^ ~b10 & b12;
            s[19] = b19 ^ ~b11 & b13;
            s[28] = b28 ^ ~b20 & b22;
            s[29] = b29 ^ ~b21 & b23;
            s[38] = b38 ^ ~b30 & b32;
            s[39] = b39 ^ ~b31 & b33;
            s[48] = b48 ^ ~b40 & b42;
            s[49] = b49 ^ ~b41 & b43;
            s[0] ^= RC[n];
            s[1] ^= RC[n + 1];
        }
    };
    if (COMMON_JS) module.exports = methods;
    else {
        for(i = 0; i < methodNames.length; ++i)root[methodNames[i]] = methods[methodNames[i]];
        if (AMD) define(function() {
            return methods;
        });
    }
})();

});


var $7b02d682eb115277$exports = {};
"use strict";

$7b02d682eb115277$exports = (parcelRequire("1b2ls"));


parcelRequire("acw62");
var $7e96a608cb33bf79$export$882461b6382ed46c;
var $7e96a608cb33bf79$export$757ceba2d55c277e;
"use strict";
var $11492dca620dcaa5$exports = {};
"use strict";
function $11492dca620dcaa5$var$checkDCE() {
    /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */ if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === "undefined" || typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE !== "function") return;
    try {
        // Verify that the code above has been dead code eliminated (DCE'd).
        __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE($11492dca620dcaa5$var$checkDCE);
    } catch (err) {
        // DevTools shouldn't crash React, no matter what.
        // We should still report in case we break this code.
        console.error(err);
    }
}
// DCE check should happen before ReactDOM bundle executes so that
// DevTools can report bad minification during injection.
$11492dca620dcaa5$var$checkDCE();

$11492dca620dcaa5$exports = (parcelRequire("Xw6Mv"));


var $7e96a608cb33bf79$var$i;
$7e96a608cb33bf79$export$882461b6382ed46c = $11492dca620dcaa5$exports.createRoot;
$7e96a608cb33bf79$export$757ceba2d55c277e = $11492dca620dcaa5$exports.hydrateRoot;



parcelRequire("acw62");
/**
 * React Router DOM v6.18.0
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ 
var $acw62 = parcelRequire("acw62");
/**
 * @remix-run/router v1.11.0
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ function $1d34d5c4a288b213$var$_extends() {
    $1d34d5c4a288b213$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $1d34d5c4a288b213$var$_extends.apply(this, arguments);
}
////////////////////////////////////////////////////////////////////////////////
//#region Types and Constants
////////////////////////////////////////////////////////////////////////////////
/**
 * Actions represent the type of change to a location value.
 */ var $1d34d5c4a288b213$export$e19cd5f9376f8cee;
(function(Action) {
    /**
   * A POP indicates a change to an arbitrary index in the history stack, such
   * as a back or forward navigation. It does not describe the direction of the
   * navigation, only that the current index changed.
   *
   * Note: This is the default action for newly created history objects.
   */ Action["Pop"] = "POP";
    /**
   * A PUSH indicates a new entry being added to the history stack, such as when
   * a link is clicked and a new page loads. When this happens, all subsequent
   * entries in the stack are lost.
   */ Action["Push"] = "PUSH";
    /**
   * A REPLACE indicates the entry at the current index in the history stack
   * being replaced by a new one.
   */ Action["Replace"] = "REPLACE";
})($1d34d5c4a288b213$export$e19cd5f9376f8cee || ($1d34d5c4a288b213$export$e19cd5f9376f8cee = {}));
const $1d34d5c4a288b213$var$PopStateEventType = "popstate";
/**
 * Memory history stores the current location in memory. It is designed for use
 * in stateful non-browser environments like tests and React Native.
 */ function $1d34d5c4a288b213$export$2b76ad033c6e6d08(options) {
    if (options === void 0) options = {};
    let { initialEntries: initialEntries = [
        "/"
    ], initialIndex: initialIndex, v5Compat: v5Compat = false } = options;
    let entries; // Declare so we can access from createMemoryLocation
    entries = initialEntries.map((entry, index)=>createMemoryLocation(entry, typeof entry === "string" ? null : entry.state, index === 0 ? "default" : undefined));
    let index = clampIndex(initialIndex == null ? entries.length - 1 : initialIndex);
    let action = $1d34d5c4a288b213$export$e19cd5f9376f8cee.Pop;
    let listener = null;
    function clampIndex(n) {
        return Math.min(Math.max(n, 0), entries.length - 1);
    }
    function getCurrentLocation() {
        return entries[index];
    }
    function createMemoryLocation(to, state, key) {
        if (state === void 0) state = null;
        let location = $1d34d5c4a288b213$var$createLocation(entries ? getCurrentLocation().pathname : "/", to, state, key);
        $1d34d5c4a288b213$export$c0e02632e14916fd(location.pathname.charAt(0) === "/", "relative pathnames are not supported in memory history: " + JSON.stringify(to));
        return location;
    }
    function createHref(to) {
        return typeof to === "string" ? to : $1d34d5c4a288b213$export$fe53371bee54353d(to);
    }
    let history = {
        get index () {
            return index;
        },
        get action () {
            return action;
        },
        get location () {
            return getCurrentLocation();
        },
        createHref: createHref,
        createURL (to) {
            return new URL(createHref(to), "http://localhost");
        },
        encodeLocation (to) {
            let path = typeof to === "string" ? $1d34d5c4a288b213$export$8ccf933b0513f8d0(to) : to;
            return {
                pathname: path.pathname || "",
                search: path.search || "",
                hash: path.hash || ""
            };
        },
        push (to, state) {
            action = $1d34d5c4a288b213$export$e19cd5f9376f8cee.Push;
            let nextLocation = createMemoryLocation(to, state);
            index += 1;
            entries.splice(index, entries.length, nextLocation);
            if (v5Compat && listener) listener({
                action: action,
                location: nextLocation,
                delta: 1
            });
        },
        replace (to, state) {
            action = $1d34d5c4a288b213$export$e19cd5f9376f8cee.Replace;
            let nextLocation = createMemoryLocation(to, state);
            entries[index] = nextLocation;
            if (v5Compat && listener) listener({
                action: action,
                location: nextLocation,
                delta: 0
            });
        },
        go (delta) {
            action = $1d34d5c4a288b213$export$e19cd5f9376f8cee.Pop;
            let nextIndex = clampIndex(index + delta);
            let nextLocation = entries[nextIndex];
            index = nextIndex;
            if (listener) listener({
                action: action,
                location: nextLocation,
                delta: delta
            });
        },
        listen (fn) {
            listener = fn;
            return ()=>{
                listener = null;
            };
        }
    };
    return history;
}
/**
 * Browser history stores the location in regular URLs. This is the standard for
 * most web apps, but it requires some configuration on the server to ensure you
 * serve the same app at multiple URLs.
 *
 * @see https://github.com/remix-run/history/tree/main/docs/api-reference.md#createbrowserhistory
 */ function $1d34d5c4a288b213$export$719fc203c4e16dee(options) {
    if (options === void 0) options = {};
    function createBrowserLocation(window1, globalHistory) {
        let { pathname: pathname, search: search, hash: hash } = window1.location;
        return $1d34d5c4a288b213$var$createLocation("", {
            pathname: pathname,
            search: search,
            hash: hash
        }, // state defaults to `null` because `window.history.state` does
        globalHistory.state && globalHistory.state.usr || null, globalHistory.state && globalHistory.state.key || "default");
    }
    function createBrowserHref(window1, to) {
        return typeof to === "string" ? to : $1d34d5c4a288b213$export$fe53371bee54353d(to);
    }
    return $1d34d5c4a288b213$var$getUrlBasedHistory(createBrowserLocation, createBrowserHref, null, options);
}
/**
 * Hash history stores the location in window.location.hash. This makes it ideal
 * for situations where you don't want to send the location to the server for
 * some reason, either because you do cannot configure it or the URL space is
 * reserved for something else.
 *
 * @see https://github.com/remix-run/history/tree/main/docs/api-reference.md#createhashhistory
 */ function $1d34d5c4a288b213$export$b71fdd3798280242(options) {
    if (options === void 0) options = {};
    function createHashLocation(window1, globalHistory) {
        let { pathname: pathname = "/", search: search = "", hash: hash = "" } = $1d34d5c4a288b213$export$8ccf933b0513f8d0(window1.location.hash.substr(1));
        // Hash URL should always have a leading / just like window.location.pathname
        // does, so if an app ends up at a route like /#something then we add a
        // leading slash so all of our path-matching behaves the same as if it would
        // in a browser router.  This is particularly important when there exists a
        // root splat route (<Route path="*">) since that matches internally against
        // "/*" and we'd expect /#something to 404 in a hash router app.
        if (!pathname.startsWith("/") && !pathname.startsWith(".")) pathname = "/" + pathname;
        return $1d34d5c4a288b213$var$createLocation("", {
            pathname: pathname,
            search: search,
            hash: hash
        }, // state defaults to `null` because `window.history.state` does
        globalHistory.state && globalHistory.state.usr || null, globalHistory.state && globalHistory.state.key || "default");
    }
    function createHashHref(window1, to) {
        let base = window1.document.querySelector("base");
        let href = "";
        if (base && base.getAttribute("href")) {
            let url = window1.location.href;
            let hashIndex = url.indexOf("#");
            href = hashIndex === -1 ? url : url.slice(0, hashIndex);
        }
        return href + "#" + (typeof to === "string" ? to : $1d34d5c4a288b213$export$fe53371bee54353d(to));
    }
    function validateHashLocation(location, to) {
        $1d34d5c4a288b213$export$c0e02632e14916fd(location.pathname.charAt(0) === "/", "relative pathnames are not supported in hash history.push(" + JSON.stringify(to) + ")");
    }
    return $1d34d5c4a288b213$var$getUrlBasedHistory(createHashLocation, createHashHref, validateHashLocation, options);
}
function $1d34d5c4a288b213$export$3e9cee6b33872309(value, message) {
    if (value === false || value === null || typeof value === "undefined") throw new Error(message);
}
function $1d34d5c4a288b213$export$c0e02632e14916fd(cond, message) {
    if (!cond) {
        // eslint-disable-next-line no-console
        if (typeof console !== "undefined") console.warn(message);
        try {
            // Welcome to debugging history!
            //
            // This error is thrown as a convenience, so you can more easily
            // find the source for a warning that appears in the console by
            // enabling "pause on exceptions" in your JavaScript debugger.
            throw new Error(message);
        // eslint-disable-next-line no-empty
        } catch (e) {}
    }
}
function $1d34d5c4a288b213$var$createKey() {
    return Math.random().toString(36).substr(2, 8);
}
/**
 * For browser-based histories, we combine the state and key into an object
 */ function $1d34d5c4a288b213$var$getHistoryState(location, index) {
    return {
        usr: location.state,
        key: location.key,
        idx: index
    };
}
/**
 * Creates a Location object with a unique key from the given Path
 */ function $1d34d5c4a288b213$var$createLocation(current, to, state, key) {
    if (state === void 0) state = null;
    let location = $1d34d5c4a288b213$var$_extends({
        pathname: typeof current === "string" ? current : current.pathname,
        search: "",
        hash: ""
    }, typeof to === "string" ? $1d34d5c4a288b213$export$8ccf933b0513f8d0(to) : to, {
        state: state,
        // TODO: This could be cleaned up.  push/replace should probably just take
        // full Locations now and avoid the need to run through this flow at all
        // But that's a pretty big refactor to the current test suite so going to
        // keep as is for the time being and just let any incoming keys take precedence
        key: to && to.key || key || $1d34d5c4a288b213$var$createKey()
    });
    return location;
}
/**
 * Creates a string URL path from the given pathname, search, and hash components.
 */ function $1d34d5c4a288b213$export$fe53371bee54353d(_ref) {
    let { pathname: pathname = "/", search: search = "", hash: hash = "" } = _ref;
    if (search && search !== "?") pathname += search.charAt(0) === "?" ? search : "?" + search;
    if (hash && hash !== "#") pathname += hash.charAt(0) === "#" ? hash : "#" + hash;
    return pathname;
}
/**
 * Parses a string URL path into its separate pathname, search, and hash components.
 */ function $1d34d5c4a288b213$export$8ccf933b0513f8d0(path) {
    let parsedPath = {};
    if (path) {
        let hashIndex = path.indexOf("#");
        if (hashIndex >= 0) {
            parsedPath.hash = path.substr(hashIndex);
            path = path.substr(0, hashIndex);
        }
        let searchIndex = path.indexOf("?");
        if (searchIndex >= 0) {
            parsedPath.search = path.substr(searchIndex);
            path = path.substr(0, searchIndex);
        }
        if (path) parsedPath.pathname = path;
    }
    return parsedPath;
}
function $1d34d5c4a288b213$var$getUrlBasedHistory(getLocation, createHref, validateLocation, options) {
    if (options === void 0) options = {};
    let { window: window1 = document.defaultView, v5Compat: v5Compat = false } = options;
    let globalHistory = window1.history;
    let action = $1d34d5c4a288b213$export$e19cd5f9376f8cee.Pop;
    let listener = null;
    let index = getIndex();
    // Index should only be null when we initialize. If not, it's because the
    // user called history.pushState or history.replaceState directly, in which
    // case we should log a warning as it will result in bugs.
    if (index == null) {
        index = 0;
        globalHistory.replaceState($1d34d5c4a288b213$var$_extends({}, globalHistory.state, {
            idx: index
        }), "");
    }
    function getIndex() {
        let state = globalHistory.state || {
            idx: null
        };
        return state.idx;
    }
    function handlePop() {
        action = $1d34d5c4a288b213$export$e19cd5f9376f8cee.Pop;
        let nextIndex = getIndex();
        let delta = nextIndex == null ? null : nextIndex - index;
        index = nextIndex;
        if (listener) listener({
            action: action,
            location: history.location,
            delta: delta
        });
    }
    function push(to, state) {
        action = $1d34d5c4a288b213$export$e19cd5f9376f8cee.Push;
        let location = $1d34d5c4a288b213$var$createLocation(history.location, to, state);
        if (validateLocation) validateLocation(location, to);
        index = getIndex() + 1;
        let historyState = $1d34d5c4a288b213$var$getHistoryState(location, index);
        let url = history.createHref(location);
        // try...catch because iOS limits us to 100 pushState calls :/
        try {
            globalHistory.pushState(historyState, "", url);
        } catch (error) {
            // If the exception is because `state` can't be serialized, let that throw
            // outwards just like a replace call would so the dev knows the cause
            // https://html.spec.whatwg.org/multipage/nav-history-apis.html#shared-history-push/replace-state-steps
            // https://html.spec.whatwg.org/multipage/structured-data.html#structuredserializeinternal
            if (error instanceof DOMException && error.name === "DataCloneError") throw error;
            // They are going to lose state here, but there is no real
            // way to warn them about it since the page will refresh...
            window1.location.assign(url);
        }
        if (v5Compat && listener) listener({
            action: action,
            location: history.location,
            delta: 1
        });
    }
    function replace(to, state) {
        action = $1d34d5c4a288b213$export$e19cd5f9376f8cee.Replace;
        let location = $1d34d5c4a288b213$var$createLocation(history.location, to, state);
        if (validateLocation) validateLocation(location, to);
        index = getIndex();
        let historyState = $1d34d5c4a288b213$var$getHistoryState(location, index);
        let url = history.createHref(location);
        globalHistory.replaceState(historyState, "", url);
        if (v5Compat && listener) listener({
            action: action,
            location: history.location,
            delta: 0
        });
    }
    function createURL(to) {
        // window.location.origin is "null" (the literal string value) in Firefox
        // under certain conditions, notably when serving from a local HTML file
        // See https://bugzilla.mozilla.org/show_bug.cgi?id=878297
        let base = window1.location.origin !== "null" ? window1.location.origin : window1.location.href;
        let href = typeof to === "string" ? to : $1d34d5c4a288b213$export$fe53371bee54353d(to);
        $1d34d5c4a288b213$export$3e9cee6b33872309(base, "No window.location.(origin|href) available to create URL for href: " + href);
        return new URL(href, base);
    }
    let history = {
        get action () {
            return action;
        },
        get location () {
            return getLocation(window1, globalHistory);
        },
        listen (fn) {
            if (listener) throw new Error("A history only accepts one active listener");
            window1.addEventListener($1d34d5c4a288b213$var$PopStateEventType, handlePop);
            listener = fn;
            return ()=>{
                window1.removeEventListener($1d34d5c4a288b213$var$PopStateEventType, handlePop);
                listener = null;
            };
        },
        createHref (to) {
            return createHref(window1, to);
        },
        createURL: createURL,
        encodeLocation (to) {
            // Encode a Location the same way window.location would
            let url = createURL(to);
            return {
                pathname: url.pathname,
                search: url.search,
                hash: url.hash
            };
        },
        push: push,
        replace: replace,
        go (n) {
            return globalHistory.go(n);
        }
    };
    return history;
}
//#endregion
var $1d34d5c4a288b213$var$ResultType;
(function(ResultType) {
    ResultType["data"] = "data";
    ResultType["deferred"] = "deferred";
    ResultType["redirect"] = "redirect";
    ResultType["error"] = "error";
})($1d34d5c4a288b213$var$ResultType || ($1d34d5c4a288b213$var$ResultType = {}));
const $1d34d5c4a288b213$var$immutableRouteKeys = new Set([
    "lazy",
    "caseSensitive",
    "path",
    "id",
    "index",
    "children"
]);
function $1d34d5c4a288b213$var$isIndexRoute(route) {
    return route.index === true;
}
// Walk the route tree generating unique IDs where necessary, so we are working
// solely with AgnosticDataRouteObject's within the Router
function $1d34d5c4a288b213$export$4a6d22b32134ea5d(routes, mapRouteProperties, parentPath, manifest) {
    if (parentPath === void 0) parentPath = [];
    if (manifest === void 0) manifest = {};
    return routes.map((route, index)=>{
        let treePath = [
            ...parentPath,
            index
        ];
        let id = typeof route.id === "string" ? route.id : treePath.join("-");
        $1d34d5c4a288b213$export$3e9cee6b33872309(route.index !== true || !route.children, "Cannot specify children on an index route");
        $1d34d5c4a288b213$export$3e9cee6b33872309(!manifest[id], 'Found a route id collision on id "' + id + '".  Route ' + "id's must be globally unique within Data Router usages");
        if ($1d34d5c4a288b213$var$isIndexRoute(route)) {
            let indexRoute = $1d34d5c4a288b213$var$_extends({}, route, mapRouteProperties(route), {
                id: id
            });
            manifest[id] = indexRoute;
            return indexRoute;
        } else {
            let pathOrLayoutRoute = $1d34d5c4a288b213$var$_extends({}, route, mapRouteProperties(route), {
                id: id,
                children: undefined
            });
            manifest[id] = pathOrLayoutRoute;
            if (route.children) pathOrLayoutRoute.children = $1d34d5c4a288b213$export$4a6d22b32134ea5d(route.children, mapRouteProperties, treePath, manifest);
            return pathOrLayoutRoute;
        }
    });
}
/**
 * Matches the given routes to a location and returns the match data.
 *
 * @see https://reactrouter.com/utils/match-routes
 */ function $1d34d5c4a288b213$export$2708184779ceb39d(routes, locationArg, basename) {
    if (basename === void 0) basename = "/";
    let location = typeof locationArg === "string" ? $1d34d5c4a288b213$export$8ccf933b0513f8d0(locationArg) : locationArg;
    let pathname = $1d34d5c4a288b213$export$b69e3301ce081aa3(location.pathname || "/", basename);
    if (pathname == null) return null;
    let branches = $1d34d5c4a288b213$var$flattenRoutes(routes);
    $1d34d5c4a288b213$var$rankRouteBranches(branches);
    let matches = null;
    for(let i = 0; matches == null && i < branches.length; ++i)matches = $1d34d5c4a288b213$var$matchRouteBranch(branches[i], // Incoming pathnames are generally encoded from either window.location
    // or from router.navigate, but we want to match against the unencoded
    // paths in the route definitions.  Memory router locations won't be
    // encoded here but there also shouldn't be anything to decode so this
    // should be a safe operation.  This avoids needing matchRoutes to be
    // history-aware.
    $1d34d5c4a288b213$var$safelyDecodeURI(pathname));
    return matches;
}
function $1d34d5c4a288b213$export$b3fac024fad9e8ff(match, loaderData) {
    let { route: route, pathname: pathname, params: params } = match;
    return {
        id: route.id,
        pathname: pathname,
        params: params,
        data: loaderData[route.id],
        handle: route.handle
    };
}
function $1d34d5c4a288b213$var$flattenRoutes(routes, branches, parentsMeta, parentPath) {
    if (branches === void 0) branches = [];
    if (parentsMeta === void 0) parentsMeta = [];
    if (parentPath === void 0) parentPath = "";
    let flattenRoute = (route, index, relativePath)=>{
        let meta = {
            relativePath: relativePath === undefined ? route.path || "" : relativePath,
            caseSensitive: route.caseSensitive === true,
            childrenIndex: index,
            route: route
        };
        if (meta.relativePath.startsWith("/")) {
            $1d34d5c4a288b213$export$3e9cee6b33872309(meta.relativePath.startsWith(parentPath), 'Absolute route path "' + meta.relativePath + '" nested under path ' + ('"' + parentPath + '" is not valid. An absolute child route path ') + "must start with the combined path of all its parent routes.");
            meta.relativePath = meta.relativePath.slice(parentPath.length);
        }
        let path = $1d34d5c4a288b213$export$86d9a7913e44197e([
            parentPath,
            meta.relativePath
        ]);
        let routesMeta = parentsMeta.concat(meta);
        // Add the children before adding this route to the array, so we traverse the
        // route tree depth-first and child routes appear before their parents in
        // the "flattened" version.
        if (route.children && route.children.length > 0) {
            $1d34d5c4a288b213$export$3e9cee6b33872309(// Our types know better, but runtime JS may not!
            // @ts-expect-error
            route.index !== true, "Index routes must not have child routes. Please remove " + ('all child routes from route path "' + path + '".'));
            $1d34d5c4a288b213$var$flattenRoutes(route.children, branches, routesMeta, path);
        }
        // Routes without a path shouldn't ever match by themselves unless they are
        // index routes, so don't add them to the list of possible branches.
        if (route.path == null && !route.index) return;
        branches.push({
            path: path,
            score: $1d34d5c4a288b213$var$computeScore(path, route.index),
            routesMeta: routesMeta
        });
    };
    routes.forEach((route, index)=>{
        var _route$path;
        // coarse-grain check for optional params
        if (route.path === "" || !((_route$path = route.path) != null && _route$path.includes("?"))) flattenRoute(route, index);
        else for (let exploded of $1d34d5c4a288b213$var$explodeOptionalSegments(route.path))flattenRoute(route, index, exploded);
    });
    return branches;
}
/**
 * Computes all combinations of optional path segments for a given path,
 * excluding combinations that are ambiguous and of lower priority.
 *
 * For example, `/one/:two?/three/:four?/:five?` explodes to:
 * - `/one/three`
 * - `/one/:two/three`
 * - `/one/three/:four`
 * - `/one/three/:five`
 * - `/one/:two/three/:four`
 * - `/one/:two/three/:five`
 * - `/one/three/:four/:five`
 * - `/one/:two/three/:four/:five`
 */ function $1d34d5c4a288b213$var$explodeOptionalSegments(path) {
    let segments = path.split("/");
    if (segments.length === 0) return [];
    let [first, ...rest] = segments;
    // Optional path segments are denoted by a trailing `?`
    let isOptional = first.endsWith("?");
    // Compute the corresponding required segment: `foo?` -> `foo`
    let required = first.replace(/\?$/, "");
    if (rest.length === 0) // Intepret empty string as omitting an optional segment
    // `["one", "", "three"]` corresponds to omitting `:two` from `/one/:two?/three` -> `/one/three`
    return isOptional ? [
        required,
        ""
    ] : [
        required
    ];
    let restExploded = $1d34d5c4a288b213$var$explodeOptionalSegments(rest.join("/"));
    let result = [];
    // All child paths with the prefix.  Do this for all children before the
    // optional version for all children, so we get consistent ordering where the
    // parent optional aspect is preferred as required.  Otherwise, we can get
    // child sections interspersed where deeper optional segments are higher than
    // parent optional segments, where for example, /:two would explode _earlier_
    // then /:one.  By always including the parent as required _for all children_
    // first, we avoid this issue
    result.push(...restExploded.map((subpath)=>subpath === "" ? required : [
            required,
            subpath
        ].join("/")));
    // Then, if this is an optional value, add all child versions without
    if (isOptional) result.push(...restExploded);
    // for absolute paths, ensure `/` instead of empty segment
    return result.map((exploded)=>path.startsWith("/") && exploded === "" ? "/" : exploded);
}
function $1d34d5c4a288b213$var$rankRouteBranches(branches) {
    branches.sort((a, b)=>a.score !== b.score ? b.score - a.score // Higher score first
         : $1d34d5c4a288b213$var$compareIndexes(a.routesMeta.map((meta)=>meta.childrenIndex), b.routesMeta.map((meta)=>meta.childrenIndex)));
}
const $1d34d5c4a288b213$var$paramRe = /^:\w+$/;
const $1d34d5c4a288b213$var$dynamicSegmentValue = 3;
const $1d34d5c4a288b213$var$indexRouteValue = 2;
const $1d34d5c4a288b213$var$emptySegmentValue = 1;
const $1d34d5c4a288b213$var$staticSegmentValue = 10;
const $1d34d5c4a288b213$var$splatPenalty = -2;
const $1d34d5c4a288b213$var$isSplat = (s)=>s === "*";
function $1d34d5c4a288b213$var$computeScore(path, index) {
    let segments = path.split("/");
    let initialScore = segments.length;
    if (segments.some($1d34d5c4a288b213$var$isSplat)) initialScore += $1d34d5c4a288b213$var$splatPenalty;
    if (index) initialScore += $1d34d5c4a288b213$var$indexRouteValue;
    return segments.filter((s)=>!$1d34d5c4a288b213$var$isSplat(s)).reduce((score, segment)=>score + ($1d34d5c4a288b213$var$paramRe.test(segment) ? $1d34d5c4a288b213$var$dynamicSegmentValue : segment === "" ? $1d34d5c4a288b213$var$emptySegmentValue : $1d34d5c4a288b213$var$staticSegmentValue), initialScore);
}
function $1d34d5c4a288b213$var$compareIndexes(a, b) {
    let siblings = a.length === b.length && a.slice(0, -1).every((n, i)=>n === b[i]);
    return siblings ? // If two routes are siblings, we should try to match the earlier sibling
    // first. This allows people to have fine-grained control over the matching
    // behavior by simply putting routes with identical paths in the order they
    // want them tried.
    a[a.length - 1] - b[b.length - 1] : // Otherwise, it doesn't really make sense to rank non-siblings by index,
    // so they sort equally.
    0;
}
function $1d34d5c4a288b213$var$matchRouteBranch(branch, pathname) {
    let { routesMeta: routesMeta } = branch;
    let matchedParams = {};
    let matchedPathname = "/";
    let matches = [];
    for(let i = 0; i < routesMeta.length; ++i){
        let meta = routesMeta[i];
        let end = i === routesMeta.length - 1;
        let remainingPathname = matchedPathname === "/" ? pathname : pathname.slice(matchedPathname.length) || "/";
        let match = $1d34d5c4a288b213$export$81336c211d5ff295({
            path: meta.relativePath,
            caseSensitive: meta.caseSensitive,
            end: end
        }, remainingPathname);
        if (!match) return null;
        Object.assign(matchedParams, match.params);
        let route = meta.route;
        matches.push({
            // TODO: Can this as be avoided?
            params: matchedParams,
            pathname: $1d34d5c4a288b213$export$86d9a7913e44197e([
                matchedPathname,
                match.pathname
            ]),
            pathnameBase: $1d34d5c4a288b213$export$a5c6d149b50c1d86($1d34d5c4a288b213$export$86d9a7913e44197e([
                matchedPathname,
                match.pathnameBase
            ])),
            route: route
        });
        if (match.pathnameBase !== "/") matchedPathname = $1d34d5c4a288b213$export$86d9a7913e44197e([
            matchedPathname,
            match.pathnameBase
        ]);
    }
    return matches;
}
/**
 * Returns a path with params interpolated.
 *
 * @see https://reactrouter.com/utils/generate-path
 */ function $1d34d5c4a288b213$export$82476f982757e71e(originalPath, params) {
    if (params === void 0) params = {};
    let path = originalPath;
    if (path.endsWith("*") && path !== "*" && !path.endsWith("/*")) {
        $1d34d5c4a288b213$export$c0e02632e14916fd(false, 'Route path "' + path + '" will be treated as if it were ' + ('"' + path.replace(/\*$/, "/*") + '" because the `*` character must ') + "always follow a `/` in the pattern. To get rid of this warning, " + ('please change the route path to "' + path.replace(/\*$/, "/*") + '".'));
        path = path.replace(/\*$/, "/*");
    }
    // ensure `/` is added at the beginning if the path is absolute
    const prefix = path.startsWith("/") ? "/" : "";
    const stringify = (p)=>p == null ? "" : typeof p === "string" ? p : String(p);
    const segments = path.split(/\/+/).map((segment, index, array)=>{
        const isLastSegment = index === array.length - 1;
        // only apply the splat if it's the last segment
        if (isLastSegment && segment === "*") {
            const star = "*";
            // Apply the splat
            return stringify(params[star]);
        }
        const keyMatch = segment.match(/^:(\w+)(\??)$/);
        if (keyMatch) {
            const [, key, optional] = keyMatch;
            let param = params[key];
            $1d34d5c4a288b213$export$3e9cee6b33872309(optional === "?" || param != null, 'Missing ":' + key + '" param');
            return stringify(param);
        }
        // Remove any optional markers from optional static segments
        return segment.replace(/\?$/g, "");
    })// Remove empty segments
    .filter((segment)=>!!segment);
    return prefix + segments.join("/");
}
/**
 * Performs pattern matching on a URL pathname and returns information about
 * the match.
 *
 * @see https://reactrouter.com/utils/match-path
 */ function $1d34d5c4a288b213$export$81336c211d5ff295(pattern, pathname) {
    if (typeof pattern === "string") pattern = {
        path: pattern,
        caseSensitive: false,
        end: true
    };
    let [matcher, compiledParams] = $1d34d5c4a288b213$var$compilePath(pattern.path, pattern.caseSensitive, pattern.end);
    let match = pathname.match(matcher);
    if (!match) return null;
    let matchedPathname = match[0];
    let pathnameBase = matchedPathname.replace(/(.)\/+$/, "$1");
    let captureGroups = match.slice(1);
    let params = compiledParams.reduce((memo, _ref, index)=>{
        let { paramName: paramName, isOptional: isOptional } = _ref;
        // We need to compute the pathnameBase here using the raw splat value
        // instead of using params["*"] later because it will be decoded then
        if (paramName === "*") {
            let splatValue = captureGroups[index] || "";
            pathnameBase = matchedPathname.slice(0, matchedPathname.length - splatValue.length).replace(/(.)\/+$/, "$1");
        }
        const value = captureGroups[index];
        if (isOptional && !value) memo[paramName] = undefined;
        else memo[paramName] = $1d34d5c4a288b213$var$safelyDecodeURIComponent(value || "", paramName);
        return memo;
    }, {});
    return {
        params: params,
        pathname: matchedPathname,
        pathnameBase: pathnameBase,
        pattern: pattern
    };
}
function $1d34d5c4a288b213$var$compilePath(path, caseSensitive, end) {
    if (caseSensitive === void 0) caseSensitive = false;
    if (end === void 0) end = true;
    $1d34d5c4a288b213$export$c0e02632e14916fd(path === "*" || !path.endsWith("*") || path.endsWith("/*"), 'Route path "' + path + '" will be treated as if it were ' + ('"' + path.replace(/\*$/, "/*") + '" because the `*` character must ') + "always follow a `/` in the pattern. To get rid of this warning, " + ('please change the route path to "' + path.replace(/\*$/, "/*") + '".'));
    let params = [];
    let regexpSource = "^" + path.replace(/\/*\*?$/, "") // Ignore trailing / and /*, we'll handle it below
    .replace(/^\/*/, "/") // Make sure it has a leading /
    .replace(/[\\.*+^${}|()[\]]/g, "\\$&") // Escape special regex chars
    .replace(/\/:(\w+)(\?)?/g, (_, paramName, isOptional)=>{
        params.push({
            paramName: paramName,
            isOptional: isOptional != null
        });
        return isOptional ? "/?([^\\/]+)?" : "/([^\\/]+)";
    });
    if (path.endsWith("*")) {
        params.push({
            paramName: "*"
        });
        regexpSource += path === "*" || path === "/*" ? "(.*)$" // Already matched the initial /, just match the rest
         : "(?:\\/(.+)|\\/*)$"; // Don't include the / in params["*"]
    } else if (end) // When matching to the end, ignore trailing slashes
    regexpSource += "\\/*$";
    else if (path !== "" && path !== "/") // If our path is non-empty and contains anything beyond an initial slash,
    // then we have _some_ form of path in our regex, so we should expect to
    // match only if we find the end of this path segment.  Look for an optional
    // non-captured trailing slash (to match a portion of the URL) or the end
    // of the path (if we've matched to the end).  We used to do this with a
    // word boundary but that gives false positives on routes like
    // /user-preferences since `-` counts as a word boundary.
    regexpSource += "(?:(?=\\/|$))";
    let matcher = new RegExp(regexpSource, caseSensitive ? undefined : "i");
    return [
        matcher,
        params
    ];
}
function $1d34d5c4a288b213$var$safelyDecodeURI(value) {
    try {
        return decodeURI(value);
    } catch (error) {
        $1d34d5c4a288b213$export$c0e02632e14916fd(false, 'The URL path "' + value + '" could not be decoded because it is is a ' + "malformed URL segment. This is probably due to a bad percent " + ("encoding (" + error + ")."));
        return value;
    }
}
function $1d34d5c4a288b213$var$safelyDecodeURIComponent(value, paramName) {
    try {
        return decodeURIComponent(value);
    } catch (error) {
        $1d34d5c4a288b213$export$c0e02632e14916fd(false, 'The value for the URL param "' + paramName + '" will not be decoded because' + (' the string "' + value + '" is a malformed URL segment. This is probably') + (" due to a bad percent encoding (" + error + ")."));
        return value;
    }
}
/**
 * @private
 */ function $1d34d5c4a288b213$export$b69e3301ce081aa3(pathname, basename) {
    if (basename === "/") return pathname;
    if (!pathname.toLowerCase().startsWith(basename.toLowerCase())) return null;
    // We want to leave trailing slash behavior in the user's control, so if they
    // specify a basename with a trailing slash, we should support it
    let startIndex = basename.endsWith("/") ? basename.length - 1 : basename.length;
    let nextChar = pathname.charAt(startIndex);
    if (nextChar && nextChar !== "/") // pathname does not start with basename/
    return null;
    return pathname.slice(startIndex) || "/";
}
/**
 * Returns a resolved path object relative to the given pathname.
 *
 * @see https://reactrouter.com/utils/resolve-path
 */ function $1d34d5c4a288b213$export$b09f2ff0bbcb43c7(to, fromPathname) {
    if (fromPathname === void 0) fromPathname = "/";
    let { pathname: toPathname, search: search = "", hash: hash = "" } = typeof to === "string" ? $1d34d5c4a288b213$export$8ccf933b0513f8d0(to) : to;
    let pathname = toPathname ? toPathname.startsWith("/") ? toPathname : $1d34d5c4a288b213$var$resolvePathname(toPathname, fromPathname) : fromPathname;
    return {
        pathname: pathname,
        search: $1d34d5c4a288b213$var$normalizeSearch(search),
        hash: $1d34d5c4a288b213$var$normalizeHash(hash)
    };
}
function $1d34d5c4a288b213$var$resolvePathname(relativePath, fromPathname) {
    let segments = fromPathname.replace(/\/+$/, "").split("/");
    let relativeSegments = relativePath.split("/");
    relativeSegments.forEach((segment)=>{
        if (segment === "..") // Keep the root "" segment so the pathname starts at /
        {
            if (segments.length > 1) segments.pop();
        } else if (segment !== ".") segments.push(segment);
    });
    return segments.length > 1 ? segments.join("/") : "/";
}
function $1d34d5c4a288b213$var$getInvalidPathError(char, field, dest, path) {
    return "Cannot include a '" + char + "' character in a manually specified " + ("`to." + field + "` field [" + JSON.stringify(path) + "].  Please separate it out to the ") + ("`to." + dest + "` field. Alternatively you may provide the full path as ") + 'a string in <Link to="..."> and the router will parse it for you.';
}
/**
 * @private
 *
 * When processing relative navigation we want to ignore ancestor routes that
 * do not contribute to the path, such that index/pathless layout routes don't
 * interfere.
 *
 * For example, when moving a route element into an index route and/or a
 * pathless layout route, relative link behavior contained within should stay
 * the same.  Both of the following examples should link back to the root:
 *
 *   <Route path="/">
 *     <Route path="accounts" element={<Link to=".."}>
 *   </Route>
 *
 *   <Route path="/">
 *     <Route path="accounts">
 *       <Route element={<AccountsLayout />}>       // <-- Does not contribute
 *         <Route index element={<Link to=".."} />  // <-- Does not contribute
 *       </Route
 *     </Route>
 *   </Route>
 */ function $1d34d5c4a288b213$export$90ba53ce1c7fdff2(matches) {
    return matches.filter((match, index)=>index === 0 || match.route.path && match.route.path.length > 0);
}
/**
 * @private
 */ function $1d34d5c4a288b213$export$cae722b0cc860f13(toArg, routePathnames, locationPathname, isPathRelative) {
    if (isPathRelative === void 0) isPathRelative = false;
    let to;
    if (typeof toArg === "string") to = $1d34d5c4a288b213$export$8ccf933b0513f8d0(toArg);
    else {
        to = $1d34d5c4a288b213$var$_extends({}, toArg);
        $1d34d5c4a288b213$export$3e9cee6b33872309(!to.pathname || !to.pathname.includes("?"), $1d34d5c4a288b213$var$getInvalidPathError("?", "pathname", "search", to));
        $1d34d5c4a288b213$export$3e9cee6b33872309(!to.pathname || !to.pathname.includes("#"), $1d34d5c4a288b213$var$getInvalidPathError("#", "pathname", "hash", to));
        $1d34d5c4a288b213$export$3e9cee6b33872309(!to.search || !to.search.includes("#"), $1d34d5c4a288b213$var$getInvalidPathError("#", "search", "hash", to));
    }
    let isEmptyPath = toArg === "" || to.pathname === "";
    let toPathname = isEmptyPath ? "/" : to.pathname;
    let from;
    // Routing is relative to the current pathname if explicitly requested.
    //
    // If a pathname is explicitly provided in `to`, it should be relative to the
    // route context. This is explained in `Note on `<Link to>` values` in our
    // migration guide from v5 as a means of disambiguation between `to` values
    // that begin with `/` and those that do not. However, this is problematic for
    // `to` values that do not provide a pathname. `to` can simply be a search or
    // hash string, in which case we should assume that the navigation is relative
    // to the current location's pathname and *not* the route pathname.
    if (isPathRelative || toPathname == null) from = locationPathname;
    else {
        let routePathnameIndex = routePathnames.length - 1;
        if (toPathname.startsWith("..")) {
            let toSegments = toPathname.split("/");
            // Each leading .. segment means "go up one route" instead of "go up one
            // URL segment".  This is a key difference from how <a href> works and a
            // major reason we call this a "to" value instead of a "href".
            while(toSegments[0] === ".."){
                toSegments.shift();
                routePathnameIndex -= 1;
            }
            to.pathname = toSegments.join("/");
        }
        // If there are more ".." segments than parent routes, resolve relative to
        // the root / URL.
        from = routePathnameIndex >= 0 ? routePathnames[routePathnameIndex] : "/";
    }
    let path = $1d34d5c4a288b213$export$b09f2ff0bbcb43c7(to, from);
    // Ensure the pathname has a trailing slash if the original "to" had one
    let hasExplicitTrailingSlash = toPathname && toPathname !== "/" && toPathname.endsWith("/");
    // Or if this was a link to the current path which has a trailing slash
    let hasCurrentTrailingSlash = (isEmptyPath || toPathname === ".") && locationPathname.endsWith("/");
    if (!path.pathname.endsWith("/") && (hasExplicitTrailingSlash || hasCurrentTrailingSlash)) path.pathname += "/";
    return path;
}
/**
 * @private
 */ function $1d34d5c4a288b213$export$f5655dfea9d981c7(to) {
    // Empty strings should be treated the same as / paths
    return to === "" || to.pathname === "" ? "/" : typeof to === "string" ? $1d34d5c4a288b213$export$8ccf933b0513f8d0(to).pathname : to.pathname;
}
/**
 * @private
 */ const $1d34d5c4a288b213$export$86d9a7913e44197e = (paths)=>paths.join("/").replace(/\/\/+/g, "/");
/**
 * @private
 */ const $1d34d5c4a288b213$export$a5c6d149b50c1d86 = (pathname)=>pathname.replace(/\/+$/, "").replace(/^\/*/, "/");
/**
 * @private
 */ const $1d34d5c4a288b213$var$normalizeSearch = (search)=>!search || search === "?" ? "" : search.startsWith("?") ? search : "?" + search;
/**
 * @private
 */ const $1d34d5c4a288b213$var$normalizeHash = (hash)=>!hash || hash === "#" ? "" : hash.startsWith("#") ? hash : "#" + hash;
/**
 * This is a shortcut for creating `application/json` responses. Converts `data`
 * to JSON and sets the `Content-Type` header.
 */ const $1d34d5c4a288b213$export$7b419323e6ed4f31 = function json(data, init) {
    if (init === void 0) init = {};
    let responseInit = typeof init === "number" ? {
        status: init
    } : init;
    let headers = new Headers(responseInit.headers);
    if (!headers.has("Content-Type")) headers.set("Content-Type", "application/json; charset=utf-8");
    return new Response(JSON.stringify(data), $1d34d5c4a288b213$var$_extends({}, responseInit, {
        headers: headers
    }));
};
class $1d34d5c4a288b213$export$42a99a7a4bc0e76a extends Error {
}
class $1d34d5c4a288b213$export$61d759255b4eec65 {
    constructor(data, responseInit){
        this.pendingKeysSet = new Set();
        this.subscribers = new Set();
        this.deferredKeys = [];
        $1d34d5c4a288b213$export$3e9cee6b33872309(data && typeof data === "object" && !Array.isArray(data), "defer() only accepts plain objects");
        // Set up an AbortController + Promise we can race against to exit early
        // cancellation
        let reject;
        this.abortPromise = new Promise((_, r)=>reject = r);
        this.controller = new AbortController();
        let onAbort = ()=>reject(new $1d34d5c4a288b213$export$42a99a7a4bc0e76a("Deferred data aborted"));
        this.unlistenAbortSignal = ()=>this.controller.signal.removeEventListener("abort", onAbort);
        this.controller.signal.addEventListener("abort", onAbort);
        this.data = Object.entries(data).reduce((acc, _ref2)=>{
            let [key, value] = _ref2;
            return Object.assign(acc, {
                [key]: this.trackPromise(key, value)
            });
        }, {});
        if (this.done) // All incoming values were resolved
        this.unlistenAbortSignal();
        this.init = responseInit;
    }
    trackPromise(key, value) {
        if (!(value instanceof Promise)) return value;
        this.deferredKeys.push(key);
        this.pendingKeysSet.add(key);
        // We store a little wrapper promise that will be extended with
        // _data/_error props upon resolve/reject
        let promise = Promise.race([
            value,
            this.abortPromise
        ]).then((data)=>this.onSettle(promise, key, undefined, data), (error)=>this.onSettle(promise, key, error));
        // Register rejection listeners to avoid uncaught promise rejections on
        // errors or aborted deferred values
        promise.catch(()=>{});
        Object.defineProperty(promise, "_tracked", {
            get: ()=>true
        });
        return promise;
    }
    onSettle(promise, key, error, data) {
        if (this.controller.signal.aborted && error instanceof $1d34d5c4a288b213$export$42a99a7a4bc0e76a) {
            this.unlistenAbortSignal();
            Object.defineProperty(promise, "_error", {
                get: ()=>error
            });
            return Promise.reject(error);
        }
        this.pendingKeysSet.delete(key);
        if (this.done) // Nothing left to abort!
        this.unlistenAbortSignal();
        // If the promise was resolved/rejected with undefined, we'll throw an error as you
        // should always resolve with a value or null
        if (error === undefined && data === undefined) {
            let undefinedError = new Error('Deferred data for key "' + key + '" resolved/rejected with `undefined`, ' + "you must resolve/reject with a value or `null`.");
            Object.defineProperty(promise, "_error", {
                get: ()=>undefinedError
            });
            this.emit(false, key);
            return Promise.reject(undefinedError);
        }
        if (data === undefined) {
            Object.defineProperty(promise, "_error", {
                get: ()=>error
            });
            this.emit(false, key);
            return Promise.reject(error);
        }
        Object.defineProperty(promise, "_data", {
            get: ()=>data
        });
        this.emit(false, key);
        return data;
    }
    emit(aborted, settledKey) {
        this.subscribers.forEach((subscriber)=>subscriber(aborted, settledKey));
    }
    subscribe(fn) {
        this.subscribers.add(fn);
        return ()=>this.subscribers.delete(fn);
    }
    cancel() {
        this.controller.abort();
        this.pendingKeysSet.forEach((v, k)=>this.pendingKeysSet.delete(k));
        this.emit(true);
    }
    async resolveData(signal) {
        let aborted = false;
        if (!this.done) {
            let onAbort = ()=>this.cancel();
            signal.addEventListener("abort", onAbort);
            aborted = await new Promise((resolve)=>{
                this.subscribe((aborted)=>{
                    signal.removeEventListener("abort", onAbort);
                    if (aborted || this.done) resolve(aborted);
                });
            });
        }
        return aborted;
    }
    get done() {
        return this.pendingKeysSet.size === 0;
    }
    get unwrappedData() {
        $1d34d5c4a288b213$export$3e9cee6b33872309(this.data !== null && this.done, "Can only unwrap data on initialized and settled deferreds");
        return Object.entries(this.data).reduce((acc, _ref3)=>{
            let [key, value] = _ref3;
            return Object.assign(acc, {
                [key]: $1d34d5c4a288b213$var$unwrapTrackedPromise(value)
            });
        }, {});
    }
    get pendingKeys() {
        return Array.from(this.pendingKeysSet);
    }
}
function $1d34d5c4a288b213$var$isTrackedPromise(value) {
    return value instanceof Promise && value._tracked === true;
}
function $1d34d5c4a288b213$var$unwrapTrackedPromise(value) {
    if (!$1d34d5c4a288b213$var$isTrackedPromise(value)) return value;
    if (value._error) throw value._error;
    return value._data;
}
const $1d34d5c4a288b213$export$260e5c0943f31606 = function defer(data, init) {
    if (init === void 0) init = {};
    let responseInit = typeof init === "number" ? {
        status: init
    } : init;
    return new $1d34d5c4a288b213$export$61d759255b4eec65(data, responseInit);
};
/**
 * A redirect response. Sets the status code and the `Location` header.
 * Defaults to "302 Found".
 */ const $1d34d5c4a288b213$export$89e12c5b50f7529d = function redirect(url, init) {
    if (init === void 0) init = 302;
    let responseInit = init;
    if (typeof responseInit === "number") responseInit = {
        status: responseInit
    };
    else if (typeof responseInit.status === "undefined") responseInit.status = 302;
    let headers = new Headers(responseInit.headers);
    headers.set("Location", url);
    return new Response(null, $1d34d5c4a288b213$var$_extends({}, responseInit, {
        headers: headers
    }));
};
/**
 * A redirect response that will force a document reload to the new location.
 * Sets the status code and the `Location` header.
 * Defaults to "302 Found".
 */ const $1d34d5c4a288b213$export$a6cd19cd1951a23c = (url, init)=>{
    let response = $1d34d5c4a288b213$export$89e12c5b50f7529d(url, init);
    response.headers.set("X-Remix-Reload-Document", "true");
    return response;
};
/**
 * @private
 * Utility class we use to hold auto-unwrapped 4xx/5xx Response bodies
 *
 * We don't export the class for public use since it's an implementation
 * detail, but we export the interface above so folks can build their own
 * abstractions around instances via isRouteErrorResponse()
 */ class $1d34d5c4a288b213$export$6c6580e81da25755 {
    constructor(status, statusText, data, internal){
        if (internal === void 0) internal = false;
        this.status = status;
        this.statusText = statusText || "";
        this.internal = internal;
        if (data instanceof Error) {
            this.data = data.toString();
            this.error = data;
        } else this.data = data;
    }
}
/**
 * Check if the given error is an ErrorResponse generated from a 4xx/5xx
 * Response thrown from an action/loader
 */ function $1d34d5c4a288b213$export$972111febbeef05b(error) {
    return error != null && typeof error.status === "number" && typeof error.statusText === "string" && typeof error.internal === "boolean" && "data" in error;
}
const $1d34d5c4a288b213$var$validMutationMethodsArr = [
    "post",
    "put",
    "patch",
    "delete"
];
const $1d34d5c4a288b213$var$validMutationMethods = new Set($1d34d5c4a288b213$var$validMutationMethodsArr);
const $1d34d5c4a288b213$var$validRequestMethodsArr = [
    "get",
    ...$1d34d5c4a288b213$var$validMutationMethodsArr
];
const $1d34d5c4a288b213$var$validRequestMethods = new Set($1d34d5c4a288b213$var$validRequestMethodsArr);
const $1d34d5c4a288b213$var$redirectStatusCodes = new Set([
    301,
    302,
    303,
    307,
    308
]);
const $1d34d5c4a288b213$var$redirectPreserveMethodStatusCodes = new Set([
    307,
    308
]);
const $1d34d5c4a288b213$export$ed3e14b2f9e105d0 = {
    state: "idle",
    location: undefined,
    formMethod: undefined,
    formAction: undefined,
    formEncType: undefined,
    formData: undefined,
    json: undefined,
    text: undefined
};
const $1d34d5c4a288b213$export$52eace9c284d3585 = {
    state: "idle",
    data: undefined,
    formMethod: undefined,
    formAction: undefined,
    formEncType: undefined,
    formData: undefined,
    json: undefined,
    text: undefined
};
const $1d34d5c4a288b213$export$386d57f03f0b2883 = {
    state: "unblocked",
    proceed: undefined,
    reset: undefined,
    location: undefined
};
const $1d34d5c4a288b213$var$ABSOLUTE_URL_REGEX = /^(?:[a-z][a-z0-9+.-]*:|\/\/)/i;
const $1d34d5c4a288b213$var$defaultMapRouteProperties = (route)=>({
        hasErrorBoundary: Boolean(route.hasErrorBoundary)
    });
const $1d34d5c4a288b213$var$TRANSITIONS_STORAGE_KEY = "remix-router-transitions";
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region createRouter
////////////////////////////////////////////////////////////////////////////////
/**
 * Create a router and listen to history POP navigations
 */ function $1d34d5c4a288b213$export$baddd0131ee8c05b(init) {
    const routerWindow = init.window ? init.window : typeof window !== "undefined" ? window : undefined;
    const isBrowser = typeof routerWindow !== "undefined" && typeof routerWindow.document !== "undefined" && typeof routerWindow.document.createElement !== "undefined";
    const isServer = !isBrowser;
    $1d34d5c4a288b213$export$3e9cee6b33872309(init.routes.length > 0, "You must provide a non-empty routes array to createRouter");
    let mapRouteProperties;
    if (init.mapRouteProperties) mapRouteProperties = init.mapRouteProperties;
    else if (init.detectErrorBoundary) {
        // If they are still using the deprecated version, wrap it with the new API
        let detectErrorBoundary = init.detectErrorBoundary;
        mapRouteProperties = (route)=>({
                hasErrorBoundary: detectErrorBoundary(route)
            });
    } else mapRouteProperties = $1d34d5c4a288b213$var$defaultMapRouteProperties;
    // Routes keyed by ID
    let manifest = {};
    // Routes in tree format for matching
    let dataRoutes = $1d34d5c4a288b213$export$4a6d22b32134ea5d(init.routes, mapRouteProperties, undefined, manifest);
    let inFlightDataRoutes;
    let basename = init.basename || "/";
    // Config driven behavior flags
    let future = $1d34d5c4a288b213$var$_extends({
        v7_fetcherPersist: false,
        v7_normalizeFormMethod: false,
        v7_prependBasename: false
    }, init.future);
    // Cleanup function for history
    let unlistenHistory = null;
    // Externally-provided functions to call on all state changes
    let subscribers = new Set();
    // Externally-provided object to hold scroll restoration locations during routing
    let savedScrollPositions = null;
    // Externally-provided function to get scroll restoration keys
    let getScrollRestorationKey = null;
    // Externally-provided function to get current scroll position
    let getScrollPosition = null;
    // One-time flag to control the initial hydration scroll restoration.  Because
    // we don't get the saved positions from <ScrollRestoration /> until _after_
    // the initial render, we need to manually trigger a separate updateState to
    // send along the restoreScrollPosition
    // Set to true if we have `hydrationData` since we assume we were SSR'd and that
    // SSR did the initial scroll restoration.
    let initialScrollRestored = init.hydrationData != null;
    let initialMatches = $1d34d5c4a288b213$export$2708184779ceb39d(dataRoutes, init.history.location, basename);
    let initialErrors = null;
    if (initialMatches == null) {
        // If we do not match a user-provided-route, fall back to the root
        // to allow the error boundary to take over
        let error = $1d34d5c4a288b213$var$getInternalRouterError(404, {
            pathname: init.history.location.pathname
        });
        let { matches: matches, route: route } = $1d34d5c4a288b213$var$getShortCircuitMatches(dataRoutes);
        initialMatches = matches;
        initialErrors = {
            [route.id]: error
        };
    }
    let initialized = // All initialMatches need to be loaded before we're ready.  If we have lazy
    // functions around still then we'll need to run them in initialize()
    !initialMatches.some((m)=>m.route.lazy) && // And we have to either have no loaders or have been provided hydrationData
    (!initialMatches.some((m)=>m.route.loader) || init.hydrationData != null);
    let router;
    let state = {
        historyAction: init.history.action,
        location: init.history.location,
        matches: initialMatches,
        initialized: initialized,
        navigation: $1d34d5c4a288b213$export$ed3e14b2f9e105d0,
        // Don't restore on initial updateState() if we were SSR'd
        restoreScrollPosition: init.hydrationData != null ? false : null,
        preventScrollReset: false,
        revalidation: "idle",
        loaderData: init.hydrationData && init.hydrationData.loaderData || {},
        actionData: init.hydrationData && init.hydrationData.actionData || null,
        errors: init.hydrationData && init.hydrationData.errors || initialErrors,
        fetchers: new Map(),
        blockers: new Map()
    };
    // -- Stateful internal variables to manage navigations --
    // Current navigation in progress (to be committed in completeNavigation)
    let pendingAction = $1d34d5c4a288b213$export$e19cd5f9376f8cee.Pop;
    // Should the current navigation prevent the scroll reset if scroll cannot
    // be restored?
    let pendingPreventScrollReset = false;
    // AbortController for the active navigation
    let pendingNavigationController;
    // Should the current navigation enable document.startViewTransition?
    let pendingViewTransitionEnabled = false;
    // Store applied view transitions so we can apply them on POP
    let appliedViewTransitions = new Map();
    // Cleanup function for persisting applied transitions to sessionStorage
    let removePageHideEventListener = null;
    // We use this to avoid touching history in completeNavigation if a
    // revalidation is entirely uninterrupted
    let isUninterruptedRevalidation = false;
    // Use this internal flag to force revalidation of all loaders:
    //  - submissions (completed or interrupted)
    //  - useRevalidator()
    //  - X-Remix-Revalidate (from redirect)
    let isRevalidationRequired = false;
    // Use this internal array to capture routes that require revalidation due
    // to a cancelled deferred on action submission
    let cancelledDeferredRoutes = [];
    // Use this internal array to capture fetcher loads that were cancelled by an
    // action navigation and require revalidation
    let cancelledFetcherLoads = [];
    // AbortControllers for any in-flight fetchers
    let fetchControllers = new Map();
    // Track loads based on the order in which they started
    let incrementingLoadId = 0;
    // Track the outstanding pending navigation data load to be compared against
    // the globally incrementing load when a fetcher load lands after a completed
    // navigation
    let pendingNavigationLoadId = -1;
    // Fetchers that triggered data reloads as a result of their actions
    let fetchReloadIds = new Map();
    // Fetchers that triggered redirect navigations
    let fetchRedirectIds = new Set();
    // Most recent href/match for fetcher.load calls for fetchers
    let fetchLoadMatches = new Map();
    // Ref-count mounted fetchers so we know when it's ok to clean them up
    let activeFetchers = new Map();
    // Fetchers that have requested a delete when using v7_fetcherPersist,
    // they'll be officially removed after they return to idle
    let deletedFetchers = new Set();
    // Store DeferredData instances for active route matches.  When a
    // route loader returns defer() we stick one in here.  Then, when a nested
    // promise resolves we update loaderData.  If a new navigation starts we
    // cancel active deferreds for eliminated routes.
    let activeDeferreds = new Map();
    // Store blocker functions in a separate Map outside of router state since
    // we don't need to update UI state if they change
    let blockerFunctions = new Map();
    // Flag to ignore the next history update, so we can revert the URL change on
    // a POP navigation that was blocked by the user without touching router state
    let ignoreNextHistoryUpdate = false;
    // Initialize the router, all side effects should be kicked off from here.
    // Implemented as a Fluent API for ease of:
    //   let router = createRouter(init).initialize();
    function initialize() {
        // If history informs us of a POP navigation, start the navigation but do not update
        // state.  We'll update our own state once the navigation completes
        unlistenHistory = init.history.listen((_ref)=>{
            let { action: historyAction, location: location, delta: delta } = _ref;
            // Ignore this event if it was just us resetting the URL from a
            // blocked POP navigation
            if (ignoreNextHistoryUpdate) {
                ignoreNextHistoryUpdate = false;
                return;
            }
            $1d34d5c4a288b213$export$c0e02632e14916fd(blockerFunctions.size === 0 || delta != null, "You are trying to use a blocker on a POP navigation to a location that was not created by @remix-run/router. This will fail silently in production. This can happen if you are navigating outside the router via `window.history.pushState`/`window.location.hash` instead of using router navigation APIs.  This can also happen if you are using createHashRouter and the user manually changes the URL.");
            let blockerKey = shouldBlockNavigation({
                currentLocation: state.location,
                nextLocation: location,
                historyAction: historyAction
            });
            if (blockerKey && delta != null) {
                // Restore the URL to match the current UI, but don't update router state
                ignoreNextHistoryUpdate = true;
                init.history.go(delta * -1);
                // Put the blocker into a blocked state
                updateBlocker(blockerKey, {
                    state: "blocked",
                    location: location,
                    proceed () {
                        updateBlocker(blockerKey, {
                            state: "proceeding",
                            proceed: undefined,
                            reset: undefined,
                            location: location
                        });
                        // Re-do the same POP navigation we just blocked
                        init.history.go(delta);
                    },
                    reset () {
                        let blockers = new Map(state.blockers);
                        blockers.set(blockerKey, $1d34d5c4a288b213$export$386d57f03f0b2883);
                        updateState({
                            blockers: blockers
                        });
                    }
                });
                return;
            }
            return startNavigation(historyAction, location);
        });
        if (isBrowser) {
            // FIXME: This feels gross.  How can we cleanup the lines between
            // scrollRestoration/appliedTransitions persistance?
            $1d34d5c4a288b213$var$restoreAppliedTransitions(routerWindow, appliedViewTransitions);
            let _saveAppliedTransitions = ()=>$1d34d5c4a288b213$var$persistAppliedTransitions(routerWindow, appliedViewTransitions);
            routerWindow.addEventListener("pagehide", _saveAppliedTransitions);
            removePageHideEventListener = ()=>routerWindow.removeEventListener("pagehide", _saveAppliedTransitions);
        }
        // Kick off initial data load if needed.  Use Pop to avoid modifying history
        // Note we don't do any handling of lazy here.  For SPA's it'll get handled
        // in the normal navigation flow.  For SSR it's expected that lazy modules are
        // resolved prior to router creation since we can't go into a fallbackElement
        // UI for SSR'd apps
        if (!state.initialized) startNavigation($1d34d5c4a288b213$export$e19cd5f9376f8cee.Pop, state.location);
        return router;
    }
    // Clean up a router and it's side effects
    function dispose() {
        if (unlistenHistory) unlistenHistory();
        if (removePageHideEventListener) removePageHideEventListener();
        subscribers.clear();
        pendingNavigationController && pendingNavigationController.abort();
        state.fetchers.forEach((_, key)=>deleteFetcher(key));
        state.blockers.forEach((_, key)=>deleteBlocker(key));
    }
    // Subscribe to state updates for the router
    function subscribe(fn) {
        subscribers.add(fn);
        return ()=>subscribers.delete(fn);
    }
    // Update our state and notify the calling context of the change
    function updateState(newState, viewTransitionOpts) {
        state = $1d34d5c4a288b213$var$_extends({}, state, newState);
        // Prep fetcher cleanup so we can tell the UI which fetcher data entries
        // can be removed
        let completedFetchers = [];
        let deletedFetchersKeys = [];
        if (future.v7_fetcherPersist) state.fetchers.forEach((fetcher, key)=>{
            if (fetcher.state === "idle") {
                if (deletedFetchers.has(key)) // Unmounted from the UI and can be totally removed
                deletedFetchersKeys.push(key);
                else // Returned to idle but still mounted in the UI, so semi-remains for
                // revalidations and such
                completedFetchers.push(key);
            }
        });
        subscribers.forEach((subscriber)=>subscriber(state, {
                deletedFetchers: deletedFetchersKeys,
                unstable_viewTransitionOpts: viewTransitionOpts
            }));
        // Remove idle fetchers from state since we only care about in-flight fetchers.
        if (future.v7_fetcherPersist) {
            completedFetchers.forEach((key)=>state.fetchers.delete(key));
            deletedFetchersKeys.forEach((key)=>deleteFetcher(key));
        }
    }
    // Complete a navigation returning the state.navigation back to the IDLE_NAVIGATION
    // and setting state.[historyAction/location/matches] to the new route.
    // - Location is a required param
    // - Navigation will always be set to IDLE_NAVIGATION
    // - Can pass any other state in newState
    function completeNavigation(location, newState) {
        var _location$state, _location$state2;
        // Deduce if we're in a loading/actionReload state:
        // - We have committed actionData in the store
        // - The current navigation was a mutation submission
        // - We're past the submitting state and into the loading state
        // - The location being loaded is not the result of a redirect
        let isActionReload = state.actionData != null && state.navigation.formMethod != null && $1d34d5c4a288b213$var$isMutationMethod(state.navigation.formMethod) && state.navigation.state === "loading" && ((_location$state = location.state) == null ? void 0 : _location$state._isRedirect) !== true;
        let actionData;
        if (newState.actionData) {
            if (Object.keys(newState.actionData).length > 0) actionData = newState.actionData;
            else // Empty actionData -> clear prior actionData due to an action error
            actionData = null;
        } else if (isActionReload) // Keep the current data if we're wrapping up the action reload
        actionData = state.actionData;
        else // Clear actionData on any other completed navigations
        actionData = null;
        // Always preserve any existing loaderData from re-used routes
        let loaderData = newState.loaderData ? $1d34d5c4a288b213$var$mergeLoaderData(state.loaderData, newState.loaderData, newState.matches || [], newState.errors) : state.loaderData;
        // On a successful navigation we can assume we got through all blockers
        // so we can start fresh
        let blockers = state.blockers;
        if (blockers.size > 0) {
            blockers = new Map(blockers);
            blockers.forEach((_, k)=>blockers.set(k, $1d34d5c4a288b213$export$386d57f03f0b2883));
        }
        // Always respect the user flag.  Otherwise don't reset on mutation
        // submission navigations unless they redirect
        let preventScrollReset = pendingPreventScrollReset === true || state.navigation.formMethod != null && $1d34d5c4a288b213$var$isMutationMethod(state.navigation.formMethod) && ((_location$state2 = location.state) == null ? void 0 : _location$state2._isRedirect) !== true;
        if (inFlightDataRoutes) {
            dataRoutes = inFlightDataRoutes;
            inFlightDataRoutes = undefined;
        }
        if (isUninterruptedRevalidation) ;
        else if (pendingAction === $1d34d5c4a288b213$export$e19cd5f9376f8cee.Pop) ;
        else if (pendingAction === $1d34d5c4a288b213$export$e19cd5f9376f8cee.Push) init.history.push(location, location.state);
        else if (pendingAction === $1d34d5c4a288b213$export$e19cd5f9376f8cee.Replace) init.history.replace(location, location.state);
        let viewTransitionOpts;
        // On POP, enable transitions if they were enabled on the original navigation
        if (pendingAction === $1d34d5c4a288b213$export$e19cd5f9376f8cee.Pop) {
            // Forward takes precedence so they behave like the original navigation
            let priorPaths = appliedViewTransitions.get(state.location.pathname);
            if (priorPaths && priorPaths.has(location.pathname)) viewTransitionOpts = {
                currentLocation: state.location,
                nextLocation: location
            };
            else if (appliedViewTransitions.has(location.pathname)) // If we don't have a previous forward nav, assume we're popping back to
            // the new location and enable if that location previously enabled
            viewTransitionOpts = {
                currentLocation: location,
                nextLocation: state.location
            };
        } else if (pendingViewTransitionEnabled) {
            // Store the applied transition on PUSH/REPLACE
            let toPaths = appliedViewTransitions.get(state.location.pathname);
            if (toPaths) toPaths.add(location.pathname);
            else {
                toPaths = new Set([
                    location.pathname
                ]);
                appliedViewTransitions.set(state.location.pathname, toPaths);
            }
            viewTransitionOpts = {
                currentLocation: state.location,
                nextLocation: location
            };
        }
        updateState($1d34d5c4a288b213$var$_extends({}, newState, {
            actionData: actionData,
            loaderData: loaderData,
            historyAction: pendingAction,
            location: location,
            initialized: true,
            navigation: $1d34d5c4a288b213$export$ed3e14b2f9e105d0,
            revalidation: "idle",
            restoreScrollPosition: getSavedScrollPosition(location, newState.matches || state.matches),
            preventScrollReset: preventScrollReset,
            blockers: blockers
        }), viewTransitionOpts);
        // Reset stateful navigation vars
        pendingAction = $1d34d5c4a288b213$export$e19cd5f9376f8cee.Pop;
        pendingPreventScrollReset = false;
        pendingViewTransitionEnabled = false;
        isUninterruptedRevalidation = false;
        isRevalidationRequired = false;
        cancelledDeferredRoutes = [];
        cancelledFetcherLoads = [];
    }
    // Trigger a navigation event, which can either be a numerical POP or a PUSH
    // replace with an optional submission
    async function navigate(to, opts) {
        if (typeof to === "number") {
            init.history.go(to);
            return;
        }
        let normalizedPath = $1d34d5c4a288b213$var$normalizeTo(state.location, state.matches, basename, future.v7_prependBasename, to, opts == null ? void 0 : opts.fromRouteId, opts == null ? void 0 : opts.relative);
        let { path: path, submission: submission, error: error } = $1d34d5c4a288b213$var$normalizeNavigateOptions(future.v7_normalizeFormMethod, false, normalizedPath, opts);
        let currentLocation = state.location;
        let nextLocation = $1d34d5c4a288b213$var$createLocation(state.location, path, opts && opts.state);
        // When using navigate as a PUSH/REPLACE we aren't reading an already-encoded
        // URL from window.location, so we need to encode it here so the behavior
        // remains the same as POP and non-data-router usages.  new URL() does all
        // the same encoding we'd get from a history.pushState/window.location read
        // without having to touch history
        nextLocation = $1d34d5c4a288b213$var$_extends({}, nextLocation, init.history.encodeLocation(nextLocation));
        let userReplace = opts && opts.replace != null ? opts.replace : undefined;
        let historyAction = $1d34d5c4a288b213$export$e19cd5f9376f8cee.Push;
        if (userReplace === true) historyAction = $1d34d5c4a288b213$export$e19cd5f9376f8cee.Replace;
        else if (userReplace === false) ;
        else if (submission != null && $1d34d5c4a288b213$var$isMutationMethod(submission.formMethod) && submission.formAction === state.location.pathname + state.location.search) // By default on submissions to the current location we REPLACE so that
        // users don't have to double-click the back button to get to the prior
        // location.  If the user redirects to a different location from the
        // action/loader this will be ignored and the redirect will be a PUSH
        historyAction = $1d34d5c4a288b213$export$e19cd5f9376f8cee.Replace;
        let preventScrollReset = opts && "preventScrollReset" in opts ? opts.preventScrollReset === true : undefined;
        let blockerKey = shouldBlockNavigation({
            currentLocation: currentLocation,
            nextLocation: nextLocation,
            historyAction: historyAction
        });
        if (blockerKey) {
            // Put the blocker into a blocked state
            updateBlocker(blockerKey, {
                state: "blocked",
                location: nextLocation,
                proceed () {
                    updateBlocker(blockerKey, {
                        state: "proceeding",
                        proceed: undefined,
                        reset: undefined,
                        location: nextLocation
                    });
                    // Send the same navigation through
                    navigate(to, opts);
                },
                reset () {
                    let blockers = new Map(state.blockers);
                    blockers.set(blockerKey, $1d34d5c4a288b213$export$386d57f03f0b2883);
                    updateState({
                        blockers: blockers
                    });
                }
            });
            return;
        }
        return await startNavigation(historyAction, nextLocation, {
            submission: submission,
            // Send through the formData serialization error if we have one so we can
            // render at the right error boundary after we match routes
            pendingError: error,
            preventScrollReset: preventScrollReset,
            replace: opts && opts.replace,
            enableViewTransition: opts && opts.unstable_viewTransition
        });
    }
    // Revalidate all current loaders.  If a navigation is in progress or if this
    // is interrupted by a navigation, allow this to "succeed" by calling all
    // loaders during the next loader round
    function revalidate() {
        interruptActiveLoads();
        updateState({
            revalidation: "loading"
        });
        // If we're currently submitting an action, we don't need to start a new
        // navigation, we'll just let the follow up loader execution call all loaders
        if (state.navigation.state === "submitting") return;
        // If we're currently in an idle state, start a new navigation for the current
        // action/location and mark it as uninterrupted, which will skip the history
        // update in completeNavigation
        if (state.navigation.state === "idle") {
            startNavigation(state.historyAction, state.location, {
                startUninterruptedRevalidation: true
            });
            return;
        }
        // Otherwise, if we're currently in a loading state, just start a new
        // navigation to the navigation.location but do not trigger an uninterrupted
        // revalidation so that history correctly updates once the navigation completes
        startNavigation(pendingAction || state.historyAction, state.navigation.location, {
            overrideNavigation: state.navigation
        });
    }
    // Start a navigation to the given action/location.  Can optionally provide a
    // overrideNavigation which will override the normalLoad in the case of a redirect
    // navigation
    async function startNavigation(historyAction, location, opts) {
        // Abort any in-progress navigations and start a new one. Unset any ongoing
        // uninterrupted revalidations unless told otherwise, since we want this
        // new navigation to update history normally
        pendingNavigationController && pendingNavigationController.abort();
        pendingNavigationController = null;
        pendingAction = historyAction;
        isUninterruptedRevalidation = (opts && opts.startUninterruptedRevalidation) === true;
        // Save the current scroll position every time we start a new navigation,
        // and track whether we should reset scroll on completion
        saveScrollPosition(state.location, state.matches);
        pendingPreventScrollReset = (opts && opts.preventScrollReset) === true;
        pendingViewTransitionEnabled = (opts && opts.enableViewTransition) === true;
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let loadingNavigation = opts && opts.overrideNavigation;
        let matches = $1d34d5c4a288b213$export$2708184779ceb39d(routesToUse, location, basename);
        // Short circuit with a 404 on the root error boundary if we match nothing
        if (!matches) {
            let error = $1d34d5c4a288b213$var$getInternalRouterError(404, {
                pathname: location.pathname
            });
            let { matches: notFoundMatches, route: route } = $1d34d5c4a288b213$var$getShortCircuitMatches(routesToUse);
            // Cancel all pending deferred on 404s since we don't keep any routes
            cancelActiveDeferreds();
            completeNavigation(location, {
                matches: notFoundMatches,
                loaderData: {},
                errors: {
                    [route.id]: error
                }
            });
            return;
        }
        // Short circuit if it's only a hash change and not a revalidation or
        // mutation submission.
        //
        // Ignore on initial page loads because since the initial load will always
        // be "same hash".  For example, on /page#hash and submit a <Form method="post">
        // which will default to a navigation to /page
        if (state.initialized && !isRevalidationRequired && $1d34d5c4a288b213$var$isHashChangeOnly(state.location, location) && !(opts && opts.submission && $1d34d5c4a288b213$var$isMutationMethod(opts.submission.formMethod))) {
            completeNavigation(location, {
                matches: matches
            });
            return;
        }
        // Create a controller/Request for this navigation
        pendingNavigationController = new AbortController();
        let request = $1d34d5c4a288b213$var$createClientSideRequest(init.history, location, pendingNavigationController.signal, opts && opts.submission);
        let pendingActionData;
        let pendingError;
        if (opts && opts.pendingError) // If we have a pendingError, it means the user attempted a GET submission
        // with binary FormData so assign here and skip to handleLoaders.  That
        // way we handle calling loaders above the boundary etc.  It's not really
        // different from an actionError in that sense.
        pendingError = {
            [$1d34d5c4a288b213$var$findNearestBoundary(matches).route.id]: opts.pendingError
        };
        else if (opts && opts.submission && $1d34d5c4a288b213$var$isMutationMethod(opts.submission.formMethod)) {
            // Call action if we received an action submission
            let actionOutput = await handleAction(request, location, opts.submission, matches, {
                replace: opts.replace
            });
            if (actionOutput.shortCircuited) return;
            pendingActionData = actionOutput.pendingActionData;
            pendingError = actionOutput.pendingActionError;
            loadingNavigation = $1d34d5c4a288b213$var$getLoadingNavigation(location, opts.submission);
            // Create a GET request for the loaders
            request = new Request(request.url, {
                signal: request.signal
            });
        }
        // Call loaders
        let { shortCircuited: shortCircuited, loaderData: loaderData, errors: errors } = await handleLoaders(request, location, matches, loadingNavigation, opts && opts.submission, opts && opts.fetcherSubmission, opts && opts.replace, pendingActionData, pendingError);
        if (shortCircuited) return;
        // Clean up now that the action/loaders have completed.  Don't clean up if
        // we short circuited because pendingNavigationController will have already
        // been assigned to a new controller for the next navigation
        pendingNavigationController = null;
        completeNavigation(location, $1d34d5c4a288b213$var$_extends({
            matches: matches
        }, pendingActionData ? {
            actionData: pendingActionData
        } : {}, {
            loaderData: loaderData,
            errors: errors
        }));
    }
    // Call the action matched by the leaf route for this navigation and handle
    // redirects/errors
    async function handleAction(request, location, submission, matches, opts) {
        if (opts === void 0) opts = {};
        interruptActiveLoads();
        // Put us in a submitting state
        let navigation = $1d34d5c4a288b213$var$getSubmittingNavigation(location, submission);
        updateState({
            navigation: navigation
        });
        // Call our action and get the result
        let result;
        let actionMatch = $1d34d5c4a288b213$var$getTargetMatch(matches, location);
        if (!actionMatch.route.action && !actionMatch.route.lazy) result = {
            type: $1d34d5c4a288b213$var$ResultType.error,
            error: $1d34d5c4a288b213$var$getInternalRouterError(405, {
                method: request.method,
                pathname: location.pathname,
                routeId: actionMatch.route.id
            })
        };
        else {
            result = await $1d34d5c4a288b213$var$callLoaderOrAction("action", request, actionMatch, matches, manifest, mapRouteProperties, basename);
            if (request.signal.aborted) return {
                shortCircuited: true
            };
        }
        if ($1d34d5c4a288b213$var$isRedirectResult(result)) {
            let replace;
            if (opts && opts.replace != null) replace = opts.replace;
            else // If the user didn't explicity indicate replace behavior, replace if
            // we redirected to the exact same location we're currently at to avoid
            // double back-buttons
            replace = result.location === state.location.pathname + state.location.search;
            await startRedirectNavigation(state, result, {
                submission: submission,
                replace: replace
            });
            return {
                shortCircuited: true
            };
        }
        if ($1d34d5c4a288b213$var$isErrorResult(result)) {
            // Store off the pending error - we use it to determine which loaders
            // to call and will commit it when we complete the navigation
            let boundaryMatch = $1d34d5c4a288b213$var$findNearestBoundary(matches, actionMatch.route.id);
            // By default, all submissions are REPLACE navigations, but if the
            // action threw an error that'll be rendered in an errorElement, we fall
            // back to PUSH so that the user can use the back button to get back to
            // the pre-submission form location to try again
            if ((opts && opts.replace) !== true) pendingAction = $1d34d5c4a288b213$export$e19cd5f9376f8cee.Push;
            return {
                // Send back an empty object we can use to clear out any prior actionData
                pendingActionData: {},
                pendingActionError: {
                    [boundaryMatch.route.id]: result.error
                }
            };
        }
        if ($1d34d5c4a288b213$var$isDeferredResult(result)) throw $1d34d5c4a288b213$var$getInternalRouterError(400, {
            type: "defer-action"
        });
        return {
            pendingActionData: {
                [actionMatch.route.id]: result.data
            }
        };
    }
    // Call all applicable loaders for the given matches, handling redirects,
    // errors, etc.
    async function handleLoaders(request, location, matches, overrideNavigation, submission, fetcherSubmission, replace, pendingActionData, pendingError) {
        // Figure out the right navigation we want to use for data loading
        let loadingNavigation = overrideNavigation || $1d34d5c4a288b213$var$getLoadingNavigation(location, submission);
        // If this was a redirect from an action we don't have a "submission" but
        // we have it on the loading navigation so use that if available
        let activeSubmission = submission || fetcherSubmission || $1d34d5c4a288b213$var$getSubmissionFromNavigation(loadingNavigation);
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let [matchesToLoad, revalidatingFetchers] = $1d34d5c4a288b213$var$getMatchesToLoad(init.history, state, matches, activeSubmission, location, isRevalidationRequired, cancelledDeferredRoutes, cancelledFetcherLoads, fetchLoadMatches, fetchRedirectIds, routesToUse, basename, pendingActionData, pendingError);
        // Cancel pending deferreds for no-longer-matched routes or routes we're
        // about to reload.  Note that if this is an action reload we would have
        // already cancelled all pending deferreds so this would be a no-op
        cancelActiveDeferreds((routeId)=>!(matches && matches.some((m)=>m.route.id === routeId)) || matchesToLoad && matchesToLoad.some((m)=>m.route.id === routeId));
        pendingNavigationLoadId = ++incrementingLoadId;
        // Short circuit if we have no loaders to run
        if (matchesToLoad.length === 0 && revalidatingFetchers.length === 0) {
            let updatedFetchers = markFetchRedirectsDone();
            completeNavigation(location, $1d34d5c4a288b213$var$_extends({
                matches: matches,
                loaderData: {},
                // Commit pending error if we're short circuiting
                errors: pendingError || null
            }, pendingActionData ? {
                actionData: pendingActionData
            } : {}, updatedFetchers ? {
                fetchers: new Map(state.fetchers)
            } : {}));
            return {
                shortCircuited: true
            };
        }
        // If this is an uninterrupted revalidation, we remain in our current idle
        // state.  If not, we need to switch to our loading state and load data,
        // preserving any new action data or existing action data (in the case of
        // a revalidation interrupting an actionReload)
        if (!isUninterruptedRevalidation) {
            revalidatingFetchers.forEach((rf)=>{
                let fetcher = state.fetchers.get(rf.key);
                let revalidatingFetcher = $1d34d5c4a288b213$var$getLoadingFetcher(undefined, fetcher ? fetcher.data : undefined);
                state.fetchers.set(rf.key, revalidatingFetcher);
            });
            let actionData = pendingActionData || state.actionData;
            updateState($1d34d5c4a288b213$var$_extends({
                navigation: loadingNavigation
            }, actionData ? Object.keys(actionData).length === 0 ? {
                actionData: null
            } : {
                actionData: actionData
            } : {}, revalidatingFetchers.length > 0 ? {
                fetchers: new Map(state.fetchers)
            } : {}));
        }
        revalidatingFetchers.forEach((rf)=>{
            if (fetchControllers.has(rf.key)) abortFetcher(rf.key);
            if (rf.controller) // Fetchers use an independent AbortController so that aborting a fetcher
            // (via deleteFetcher) does not abort the triggering navigation that
            // triggered the revalidation
            fetchControllers.set(rf.key, rf.controller);
        });
        // Proxy navigation abort through to revalidation fetchers
        let abortPendingFetchRevalidations = ()=>revalidatingFetchers.forEach((f)=>abortFetcher(f.key));
        if (pendingNavigationController) pendingNavigationController.signal.addEventListener("abort", abortPendingFetchRevalidations);
        let { results: results, loaderResults: loaderResults, fetcherResults: fetcherResults } = await callLoadersAndMaybeResolveData(state.matches, matches, matchesToLoad, revalidatingFetchers, request);
        if (request.signal.aborted) return {
            shortCircuited: true
        };
        // Clean up _after_ loaders have completed.  Don't clean up if we short
        // circuited because fetchControllers would have been aborted and
        // reassigned to new controllers for the next navigation
        if (pendingNavigationController) pendingNavigationController.signal.removeEventListener("abort", abortPendingFetchRevalidations);
        revalidatingFetchers.forEach((rf)=>fetchControllers.delete(rf.key));
        // If any loaders returned a redirect Response, start a new REPLACE navigation
        let redirect = $1d34d5c4a288b213$var$findRedirect(results);
        if (redirect) {
            if (redirect.idx >= matchesToLoad.length) {
                // If this redirect came from a fetcher make sure we mark it in
                // fetchRedirectIds so it doesn't get revalidated on the next set of
                // loader executions
                let fetcherKey = revalidatingFetchers[redirect.idx - matchesToLoad.length].key;
                fetchRedirectIds.add(fetcherKey);
            }
            await startRedirectNavigation(state, redirect.result, {
                replace: replace
            });
            return {
                shortCircuited: true
            };
        }
        // Process and commit output from loaders
        let { loaderData: loaderData, errors: errors } = $1d34d5c4a288b213$var$processLoaderData(state, matches, matchesToLoad, loaderResults, pendingError, revalidatingFetchers, fetcherResults, activeDeferreds);
        // Wire up subscribers to update loaderData as promises settle
        activeDeferreds.forEach((deferredData, routeId)=>{
            deferredData.subscribe((aborted)=>{
                // Note: No need to updateState here since the TrackedPromise on
                // loaderData is stable across resolve/reject
                // Remove this instance if we were aborted or if promises have settled
                if (aborted || deferredData.done) activeDeferreds.delete(routeId);
            });
        });
        let updatedFetchers = markFetchRedirectsDone();
        let didAbortFetchLoads = abortStaleFetchLoads(pendingNavigationLoadId);
        let shouldUpdateFetchers = updatedFetchers || didAbortFetchLoads || revalidatingFetchers.length > 0;
        return $1d34d5c4a288b213$var$_extends({
            loaderData: loaderData,
            errors: errors
        }, shouldUpdateFetchers ? {
            fetchers: new Map(state.fetchers)
        } : {});
    }
    function getFetcher(key) {
        if (future.v7_fetcherPersist) {
            activeFetchers.set(key, (activeFetchers.get(key) || 0) + 1);
            // If this fetcher was previously marked for deletion, unmark it since we
            // have a new instance
            if (deletedFetchers.has(key)) deletedFetchers.delete(key);
        }
        return state.fetchers.get(key) || $1d34d5c4a288b213$export$52eace9c284d3585;
    }
    // Trigger a fetcher load/submit for the given fetcher key
    function fetch(key, routeId, href, opts) {
        if (isServer) throw new Error("router.fetch() was called during the server render, but it shouldn't be. You are likely calling a useFetcher() method in the body of your component. Try moving it to a useEffect or a callback.");
        if (fetchControllers.has(key)) abortFetcher(key);
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let normalizedPath = $1d34d5c4a288b213$var$normalizeTo(state.location, state.matches, basename, future.v7_prependBasename, href, routeId, opts == null ? void 0 : opts.relative);
        let matches = $1d34d5c4a288b213$export$2708184779ceb39d(routesToUse, normalizedPath, basename);
        if (!matches) {
            setFetcherError(key, routeId, $1d34d5c4a288b213$var$getInternalRouterError(404, {
                pathname: normalizedPath
            }));
            return;
        }
        let { path: path, submission: submission, error: error } = $1d34d5c4a288b213$var$normalizeNavigateOptions(future.v7_normalizeFormMethod, true, normalizedPath, opts);
        if (error) {
            setFetcherError(key, routeId, error);
            return;
        }
        let match = $1d34d5c4a288b213$var$getTargetMatch(matches, path);
        pendingPreventScrollReset = (opts && opts.preventScrollReset) === true;
        if (submission && $1d34d5c4a288b213$var$isMutationMethod(submission.formMethod)) {
            handleFetcherAction(key, routeId, path, match, matches, submission);
            return;
        }
        // Store off the match so we can call it's shouldRevalidate on subsequent
        // revalidations
        fetchLoadMatches.set(key, {
            routeId: routeId,
            path: path
        });
        handleFetcherLoader(key, routeId, path, match, matches, submission);
    }
    // Call the action for the matched fetcher.submit(), and then handle redirects,
    // errors, and revalidation
    async function handleFetcherAction(key, routeId, path, match, requestMatches, submission) {
        interruptActiveLoads();
        fetchLoadMatches.delete(key);
        if (!match.route.action && !match.route.lazy) {
            let error = $1d34d5c4a288b213$var$getInternalRouterError(405, {
                method: submission.formMethod,
                pathname: path,
                routeId: routeId
            });
            setFetcherError(key, routeId, error);
            return;
        }
        // Put this fetcher into it's submitting state
        let existingFetcher = state.fetchers.get(key);
        let fetcher = $1d34d5c4a288b213$var$getSubmittingFetcher(submission, existingFetcher);
        state.fetchers.set(key, fetcher);
        updateState({
            fetchers: new Map(state.fetchers)
        });
        // Call the action for the fetcher
        let abortController = new AbortController();
        let fetchRequest = $1d34d5c4a288b213$var$createClientSideRequest(init.history, path, abortController.signal, submission);
        fetchControllers.set(key, abortController);
        let originatingLoadId = incrementingLoadId;
        let actionResult = await $1d34d5c4a288b213$var$callLoaderOrAction("action", fetchRequest, match, requestMatches, manifest, mapRouteProperties, basename);
        if (fetchRequest.signal.aborted) {
            // We can delete this so long as we weren't aborted by our own fetcher
            // re-submit which would have put _new_ controller is in fetchControllers
            if (fetchControllers.get(key) === abortController) fetchControllers.delete(key);
            return;
        }
        if (deletedFetchers.has(key)) {
            state.fetchers.set(key, $1d34d5c4a288b213$var$getDoneFetcher(undefined));
            updateState({
                fetchers: new Map(state.fetchers)
            });
            return;
        }
        if ($1d34d5c4a288b213$var$isRedirectResult(actionResult)) {
            fetchControllers.delete(key);
            if (pendingNavigationLoadId > originatingLoadId) {
                // A new navigation was kicked off after our action started, so that
                // should take precedence over this redirect navigation.  We already
                // set isRevalidationRequired so all loaders for the new route should
                // fire unless opted out via shouldRevalidate
                let doneFetcher = $1d34d5c4a288b213$var$getDoneFetcher(undefined);
                state.fetchers.set(key, doneFetcher);
                updateState({
                    fetchers: new Map(state.fetchers)
                });
                return;
            } else {
                fetchRedirectIds.add(key);
                let loadingFetcher = $1d34d5c4a288b213$var$getLoadingFetcher(submission);
                state.fetchers.set(key, loadingFetcher);
                updateState({
                    fetchers: new Map(state.fetchers)
                });
                return startRedirectNavigation(state, actionResult, {
                    fetcherSubmission: submission
                });
            }
        }
        // Process any non-redirect errors thrown
        if ($1d34d5c4a288b213$var$isErrorResult(actionResult)) {
            setFetcherError(key, routeId, actionResult.error);
            return;
        }
        if ($1d34d5c4a288b213$var$isDeferredResult(actionResult)) throw $1d34d5c4a288b213$var$getInternalRouterError(400, {
            type: "defer-action"
        });
        // Start the data load for current matches, or the next location if we're
        // in the middle of a navigation
        let nextLocation = state.navigation.location || state.location;
        let revalidationRequest = $1d34d5c4a288b213$var$createClientSideRequest(init.history, nextLocation, abortController.signal);
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let matches = state.navigation.state !== "idle" ? $1d34d5c4a288b213$export$2708184779ceb39d(routesToUse, state.navigation.location, basename) : state.matches;
        $1d34d5c4a288b213$export$3e9cee6b33872309(matches, "Didn't find any matches after fetcher action");
        let loadId = ++incrementingLoadId;
        fetchReloadIds.set(key, loadId);
        let loadFetcher = $1d34d5c4a288b213$var$getLoadingFetcher(submission, actionResult.data);
        state.fetchers.set(key, loadFetcher);
        let [matchesToLoad, revalidatingFetchers] = $1d34d5c4a288b213$var$getMatchesToLoad(init.history, state, matches, submission, nextLocation, isRevalidationRequired, cancelledDeferredRoutes, cancelledFetcherLoads, fetchLoadMatches, fetchRedirectIds, routesToUse, basename, {
            [match.route.id]: actionResult.data
        }, undefined // No need to send through errors since we short circuit above
        );
        // Put all revalidating fetchers into the loading state, except for the
        // current fetcher which we want to keep in it's current loading state which
        // contains it's action submission info + action data
        revalidatingFetchers.filter((rf)=>rf.key !== key).forEach((rf)=>{
            let staleKey = rf.key;
            let existingFetcher = state.fetchers.get(staleKey);
            let revalidatingFetcher = $1d34d5c4a288b213$var$getLoadingFetcher(undefined, existingFetcher ? existingFetcher.data : undefined);
            state.fetchers.set(staleKey, revalidatingFetcher);
            if (fetchControllers.has(staleKey)) abortFetcher(staleKey);
            if (rf.controller) fetchControllers.set(staleKey, rf.controller);
        });
        updateState({
            fetchers: new Map(state.fetchers)
        });
        let abortPendingFetchRevalidations = ()=>revalidatingFetchers.forEach((rf)=>abortFetcher(rf.key));
        abortController.signal.addEventListener("abort", abortPendingFetchRevalidations);
        let { results: results, loaderResults: loaderResults, fetcherResults: fetcherResults } = await callLoadersAndMaybeResolveData(state.matches, matches, matchesToLoad, revalidatingFetchers, revalidationRequest);
        if (abortController.signal.aborted) return;
        abortController.signal.removeEventListener("abort", abortPendingFetchRevalidations);
        fetchReloadIds.delete(key);
        fetchControllers.delete(key);
        revalidatingFetchers.forEach((r)=>fetchControllers.delete(r.key));
        let redirect = $1d34d5c4a288b213$var$findRedirect(results);
        if (redirect) {
            if (redirect.idx >= matchesToLoad.length) {
                // If this redirect came from a fetcher make sure we mark it in
                // fetchRedirectIds so it doesn't get revalidated on the next set of
                // loader executions
                let fetcherKey = revalidatingFetchers[redirect.idx - matchesToLoad.length].key;
                fetchRedirectIds.add(fetcherKey);
            }
            return startRedirectNavigation(state, redirect.result);
        }
        // Process and commit output from loaders
        let { loaderData: loaderData, errors: errors } = $1d34d5c4a288b213$var$processLoaderData(state, state.matches, matchesToLoad, loaderResults, undefined, revalidatingFetchers, fetcherResults, activeDeferreds);
        // Since we let revalidations complete even if the submitting fetcher was
        // deleted, only put it back to idle if it hasn't been deleted
        if (state.fetchers.has(key)) {
            let doneFetcher = $1d34d5c4a288b213$var$getDoneFetcher(actionResult.data);
            state.fetchers.set(key, doneFetcher);
        }
        abortStaleFetchLoads(loadId);
        // If we are currently in a navigation loading state and this fetcher is
        // more recent than the navigation, we want the newer data so abort the
        // navigation and complete it with the fetcher data
        if (state.navigation.state === "loading" && loadId > pendingNavigationLoadId) {
            $1d34d5c4a288b213$export$3e9cee6b33872309(pendingAction, "Expected pending action");
            pendingNavigationController && pendingNavigationController.abort();
            completeNavigation(state.navigation.location, {
                matches: matches,
                loaderData: loaderData,
                errors: errors,
                fetchers: new Map(state.fetchers)
            });
        } else {
            // otherwise just update with the fetcher data, preserving any existing
            // loaderData for loaders that did not need to reload.  We have to
            // manually merge here since we aren't going through completeNavigation
            updateState({
                errors: errors,
                loaderData: $1d34d5c4a288b213$var$mergeLoaderData(state.loaderData, loaderData, matches, errors),
                fetchers: new Map(state.fetchers)
            });
            isRevalidationRequired = false;
        }
    }
    // Call the matched loader for fetcher.load(), handling redirects, errors, etc.
    async function handleFetcherLoader(key, routeId, path, match, matches, submission) {
        let existingFetcher = state.fetchers.get(key);
        // Put this fetcher into it's loading state
        let loadingFetcher = $1d34d5c4a288b213$var$getLoadingFetcher(submission, existingFetcher ? existingFetcher.data : undefined);
        state.fetchers.set(key, loadingFetcher);
        updateState({
            fetchers: new Map(state.fetchers)
        });
        // Call the loader for this fetcher route match
        let abortController = new AbortController();
        let fetchRequest = $1d34d5c4a288b213$var$createClientSideRequest(init.history, path, abortController.signal);
        fetchControllers.set(key, abortController);
        let originatingLoadId = incrementingLoadId;
        let result = await $1d34d5c4a288b213$var$callLoaderOrAction("loader", fetchRequest, match, matches, manifest, mapRouteProperties, basename);
        // Deferred isn't supported for fetcher loads, await everything and treat it
        // as a normal load.  resolveDeferredData will return undefined if this
        // fetcher gets aborted, so we just leave result untouched and short circuit
        // below if that happens
        if ($1d34d5c4a288b213$var$isDeferredResult(result)) result = await $1d34d5c4a288b213$var$resolveDeferredData(result, fetchRequest.signal, true) || result;
        // We can delete this so long as we weren't aborted by our our own fetcher
        // re-load which would have put _new_ controller is in fetchControllers
        if (fetchControllers.get(key) === abortController) fetchControllers.delete(key);
        if (fetchRequest.signal.aborted) return;
        if (deletedFetchers.has(key)) {
            state.fetchers.set(key, $1d34d5c4a288b213$var$getDoneFetcher(undefined));
            updateState({
                fetchers: new Map(state.fetchers)
            });
            return;
        }
        // If the loader threw a redirect Response, start a new REPLACE navigation
        if ($1d34d5c4a288b213$var$isRedirectResult(result)) {
            if (pendingNavigationLoadId > originatingLoadId) {
                // A new navigation was kicked off after our loader started, so that
                // should take precedence over this redirect navigation
                let doneFetcher = $1d34d5c4a288b213$var$getDoneFetcher(undefined);
                state.fetchers.set(key, doneFetcher);
                updateState({
                    fetchers: new Map(state.fetchers)
                });
                return;
            } else {
                fetchRedirectIds.add(key);
                await startRedirectNavigation(state, result);
                return;
            }
        }
        // Process any non-redirect errors thrown
        if ($1d34d5c4a288b213$var$isErrorResult(result)) {
            setFetcherError(key, routeId, result.error);
            return;
        }
        $1d34d5c4a288b213$export$3e9cee6b33872309(!$1d34d5c4a288b213$var$isDeferredResult(result), "Unhandled fetcher deferred data");
        // Put the fetcher back into an idle state
        let doneFetcher = $1d34d5c4a288b213$var$getDoneFetcher(result.data);
        state.fetchers.set(key, doneFetcher);
        updateState({
            fetchers: new Map(state.fetchers)
        });
    }
    /**
   * Utility function to handle redirects returned from an action or loader.
   * Normally, a redirect "replaces" the navigation that triggered it.  So, for
   * example:
   *
   *  - user is on /a
   *  - user clicks a link to /b
   *  - loader for /b redirects to /c
   *
   * In a non-JS app the browser would track the in-flight navigation to /b and
   * then replace it with /c when it encountered the redirect response.  In
   * the end it would only ever update the URL bar with /c.
   *
   * In client-side routing using pushState/replaceState, we aim to emulate
   * this behavior and we also do not update history until the end of the
   * navigation (including processed redirects).  This means that we never
   * actually touch history until we've processed redirects, so we just use
   * the history action from the original navigation (PUSH or REPLACE).
   */ async function startRedirectNavigation(state, redirect, _temp) {
        let { submission: submission, fetcherSubmission: fetcherSubmission, replace: replace } = _temp === void 0 ? {} : _temp;
        if (redirect.revalidate) isRevalidationRequired = true;
        let redirectLocation = $1d34d5c4a288b213$var$createLocation(state.location, redirect.location, {
            _isRedirect: true
        });
        $1d34d5c4a288b213$export$3e9cee6b33872309(redirectLocation, "Expected a location on the redirect navigation");
        if (isBrowser) {
            let isDocumentReload = false;
            if (redirect.reloadDocument) // Hard reload if the response contained X-Remix-Reload-Document
            isDocumentReload = true;
            else if ($1d34d5c4a288b213$var$ABSOLUTE_URL_REGEX.test(redirect.location)) {
                const url = init.history.createURL(redirect.location);
                isDocumentReload = // Hard reload if it's an absolute URL to a new origin
                url.origin !== routerWindow.location.origin || // Hard reload if it's an absolute URL that does not match our basename
                $1d34d5c4a288b213$export$b69e3301ce081aa3(url.pathname, basename) == null;
            }
            if (isDocumentReload) {
                if (replace) routerWindow.location.replace(redirect.location);
                else routerWindow.location.assign(redirect.location);
                return;
            }
        }
        // There's no need to abort on redirects, since we don't detect the
        // redirect until the action/loaders have settled
        pendingNavigationController = null;
        let redirectHistoryAction = replace === true ? $1d34d5c4a288b213$export$e19cd5f9376f8cee.Replace : $1d34d5c4a288b213$export$e19cd5f9376f8cee.Push;
        // Use the incoming submission if provided, fallback on the active one in
        // state.navigation
        let { formMethod: formMethod, formAction: formAction, formEncType: formEncType } = state.navigation;
        if (!submission && !fetcherSubmission && formMethod && formAction && formEncType) submission = $1d34d5c4a288b213$var$getSubmissionFromNavigation(state.navigation);
        // If this was a 307/308 submission we want to preserve the HTTP method and
        // re-submit the GET/POST/PUT/PATCH/DELETE as a submission navigation to the
        // redirected location
        let activeSubmission = submission || fetcherSubmission;
        if ($1d34d5c4a288b213$var$redirectPreserveMethodStatusCodes.has(redirect.status) && activeSubmission && $1d34d5c4a288b213$var$isMutationMethod(activeSubmission.formMethod)) await startNavigation(redirectHistoryAction, redirectLocation, {
            submission: $1d34d5c4a288b213$var$_extends({}, activeSubmission, {
                formAction: redirect.location
            }),
            // Preserve this flag across redirects
            preventScrollReset: pendingPreventScrollReset
        });
        else {
            // If we have a navigation submission, we will preserve it through the
            // redirect navigation
            let overrideNavigation = $1d34d5c4a288b213$var$getLoadingNavigation(redirectLocation, submission);
            await startNavigation(redirectHistoryAction, redirectLocation, {
                overrideNavigation: overrideNavigation,
                fetcherSubmission: // Send fetcher submissions through for shouldRevalidate
                fetcherSubmission,
                // Preserve this flag across redirects
                preventScrollReset: pendingPreventScrollReset
            });
        }
    }
    async function callLoadersAndMaybeResolveData(currentMatches, matches, matchesToLoad, fetchersToLoad, request) {
        // Call all navigation loaders and revalidating fetcher loaders in parallel,
        // then slice off the results into separate arrays so we can handle them
        // accordingly
        let results = await Promise.all([
            ...matchesToLoad.map((match)=>$1d34d5c4a288b213$var$callLoaderOrAction("loader", request, match, matches, manifest, mapRouteProperties, basename)),
            ...fetchersToLoad.map((f)=>{
                if (f.matches && f.match && f.controller) return $1d34d5c4a288b213$var$callLoaderOrAction("loader", $1d34d5c4a288b213$var$createClientSideRequest(init.history, f.path, f.controller.signal), f.match, f.matches, manifest, mapRouteProperties, basename);
                else {
                    let error = {
                        type: $1d34d5c4a288b213$var$ResultType.error,
                        error: $1d34d5c4a288b213$var$getInternalRouterError(404, {
                            pathname: f.path
                        })
                    };
                    return error;
                }
            })
        ]);
        let loaderResults = results.slice(0, matchesToLoad.length);
        let fetcherResults = results.slice(matchesToLoad.length);
        await Promise.all([
            $1d34d5c4a288b213$var$resolveDeferredResults(currentMatches, matchesToLoad, loaderResults, loaderResults.map(()=>request.signal), false, state.loaderData),
            $1d34d5c4a288b213$var$resolveDeferredResults(currentMatches, fetchersToLoad.map((f)=>f.match), fetcherResults, fetchersToLoad.map((f)=>f.controller ? f.controller.signal : null), true)
        ]);
        return {
            results: results,
            loaderResults: loaderResults,
            fetcherResults: fetcherResults
        };
    }
    function interruptActiveLoads() {
        // Every interruption triggers a revalidation
        isRevalidationRequired = true;
        // Cancel pending route-level deferreds and mark cancelled routes for
        // revalidation
        cancelledDeferredRoutes.push(...cancelActiveDeferreds());
        // Abort in-flight fetcher loads
        fetchLoadMatches.forEach((_, key)=>{
            if (fetchControllers.has(key)) {
                cancelledFetcherLoads.push(key);
                abortFetcher(key);
            }
        });
    }
    function setFetcherError(key, routeId, error) {
        let boundaryMatch = $1d34d5c4a288b213$var$findNearestBoundary(state.matches, routeId);
        deleteFetcher(key);
        updateState({
            errors: {
                [boundaryMatch.route.id]: error
            },
            fetchers: new Map(state.fetchers)
        });
    }
    function deleteFetcher(key) {
        let fetcher = state.fetchers.get(key);
        // Don't abort the controller if this is a deletion of a fetcher.submit()
        // in it's loading phase since - we don't want to abort the corresponding
        // revalidation and want them to complete and land
        if (fetchControllers.has(key) && !(fetcher && fetcher.state === "loading" && fetchReloadIds.has(key))) abortFetcher(key);
        fetchLoadMatches.delete(key);
        fetchReloadIds.delete(key);
        fetchRedirectIds.delete(key);
        deletedFetchers.delete(key);
        state.fetchers.delete(key);
    }
    function deleteFetcherAndUpdateState(key) {
        if (future.v7_fetcherPersist) {
            let count = (activeFetchers.get(key) || 0) - 1;
            if (count <= 0) {
                activeFetchers.delete(key);
                deletedFetchers.add(key);
            } else activeFetchers.set(key, count);
        } else deleteFetcher(key);
        updateState({
            fetchers: new Map(state.fetchers)
        });
    }
    function abortFetcher(key) {
        let controller = fetchControllers.get(key);
        $1d34d5c4a288b213$export$3e9cee6b33872309(controller, "Expected fetch controller: " + key);
        controller.abort();
        fetchControllers.delete(key);
    }
    function markFetchersDone(keys) {
        for (let key of keys){
            let fetcher = getFetcher(key);
            let doneFetcher = $1d34d5c4a288b213$var$getDoneFetcher(fetcher.data);
            state.fetchers.set(key, doneFetcher);
        }
    }
    function markFetchRedirectsDone() {
        let doneKeys = [];
        let updatedFetchers = false;
        for (let key of fetchRedirectIds){
            let fetcher = state.fetchers.get(key);
            $1d34d5c4a288b213$export$3e9cee6b33872309(fetcher, "Expected fetcher: " + key);
            if (fetcher.state === "loading") {
                fetchRedirectIds.delete(key);
                doneKeys.push(key);
                updatedFetchers = true;
            }
        }
        markFetchersDone(doneKeys);
        return updatedFetchers;
    }
    function abortStaleFetchLoads(landedId) {
        let yeetedKeys = [];
        for (let [key, id] of fetchReloadIds)if (id < landedId) {
            let fetcher = state.fetchers.get(key);
            $1d34d5c4a288b213$export$3e9cee6b33872309(fetcher, "Expected fetcher: " + key);
            if (fetcher.state === "loading") {
                abortFetcher(key);
                fetchReloadIds.delete(key);
                yeetedKeys.push(key);
            }
        }
        markFetchersDone(yeetedKeys);
        return yeetedKeys.length > 0;
    }
    function getBlocker(key, fn) {
        let blocker = state.blockers.get(key) || $1d34d5c4a288b213$export$386d57f03f0b2883;
        if (blockerFunctions.get(key) !== fn) blockerFunctions.set(key, fn);
        return blocker;
    }
    function deleteBlocker(key) {
        state.blockers.delete(key);
        blockerFunctions.delete(key);
    }
    // Utility function to update blockers, ensuring valid state transitions
    function updateBlocker(key, newBlocker) {
        let blocker = state.blockers.get(key) || $1d34d5c4a288b213$export$386d57f03f0b2883;
        // Poor mans state machine :)
        // https://mermaid.live/edit#pako:eNqVkc9OwzAMxl8l8nnjAYrEtDIOHEBIgwvKJTReGy3_lDpIqO27k6awMG0XcrLlnz87nwdonESogKXXBuE79rq75XZO3-yHds0RJVuv70YrPlUrCEe2HfrORS3rubqZfuhtpg5C9wk5tZ4VKcRUq88q9Z8RS0-48cE1iHJkL0ugbHuFLus9L6spZy8nX9MP2CNdomVaposqu3fGayT8T8-jJQwhepo_UtpgBQaDEUom04dZhAN1aJBDlUKJBxE1ceB2Smj0Mln-IBW5AFU2dwUiktt_2Qaq2dBfaKdEup85UV7Yd-dKjlnkabl2Pvr0DTkTreM
        $1d34d5c4a288b213$export$3e9cee6b33872309(blocker.state === "unblocked" && newBlocker.state === "blocked" || blocker.state === "blocked" && newBlocker.state === "blocked" || blocker.state === "blocked" && newBlocker.state === "proceeding" || blocker.state === "blocked" && newBlocker.state === "unblocked" || blocker.state === "proceeding" && newBlocker.state === "unblocked", "Invalid blocker state transition: " + blocker.state + " -> " + newBlocker.state);
        let blockers = new Map(state.blockers);
        blockers.set(key, newBlocker);
        updateState({
            blockers: blockers
        });
    }
    function shouldBlockNavigation(_ref2) {
        let { currentLocation: currentLocation, nextLocation: nextLocation, historyAction: historyAction } = _ref2;
        if (blockerFunctions.size === 0) return;
        // We ony support a single active blocker at the moment since we don't have
        // any compelling use cases for multi-blocker yet
        if (blockerFunctions.size > 1) $1d34d5c4a288b213$export$c0e02632e14916fd(false, "A router only supports one blocker at a time");
        let entries = Array.from(blockerFunctions.entries());
        let [blockerKey, blockerFunction] = entries[entries.length - 1];
        let blocker = state.blockers.get(blockerKey);
        if (blocker && blocker.state === "proceeding") // If the blocker is currently proceeding, we don't need to re-check
        // it and can let this navigation continue
        return;
        // At this point, we know we're unblocked/blocked so we need to check the
        // user-provided blocker function
        if (blockerFunction({
            currentLocation: currentLocation,
            nextLocation: nextLocation,
            historyAction: historyAction
        })) return blockerKey;
    }
    function cancelActiveDeferreds(predicate) {
        let cancelledRouteIds = [];
        activeDeferreds.forEach((dfd, routeId)=>{
            if (!predicate || predicate(routeId)) {
                // Cancel the deferred - but do not remove from activeDeferreds here -
                // we rely on the subscribers to do that so our tests can assert proper
                // cleanup via _internalActiveDeferreds
                dfd.cancel();
                cancelledRouteIds.push(routeId);
                activeDeferreds.delete(routeId);
            }
        });
        return cancelledRouteIds;
    }
    // Opt in to capturing and reporting scroll positions during navigations,
    // used by the <ScrollRestoration> component
    function enableScrollRestoration(positions, getPosition, getKey) {
        savedScrollPositions = positions;
        getScrollPosition = getPosition;
        getScrollRestorationKey = getKey || null;
        // Perform initial hydration scroll restoration, since we miss the boat on
        // the initial updateState() because we've not yet rendered <ScrollRestoration/>
        // and therefore have no savedScrollPositions available
        if (!initialScrollRestored && state.navigation === $1d34d5c4a288b213$export$ed3e14b2f9e105d0) {
            initialScrollRestored = true;
            let y = getSavedScrollPosition(state.location, state.matches);
            if (y != null) updateState({
                restoreScrollPosition: y
            });
        }
        return ()=>{
            savedScrollPositions = null;
            getScrollPosition = null;
            getScrollRestorationKey = null;
        };
    }
    function getScrollKey(location, matches) {
        if (getScrollRestorationKey) {
            let key = getScrollRestorationKey(location, matches.map((m)=>$1d34d5c4a288b213$export$b3fac024fad9e8ff(m, state.loaderData)));
            return key || location.key;
        }
        return location.key;
    }
    function saveScrollPosition(location, matches) {
        if (savedScrollPositions && getScrollPosition) {
            let key = getScrollKey(location, matches);
            savedScrollPositions[key] = getScrollPosition();
        }
    }
    function getSavedScrollPosition(location, matches) {
        if (savedScrollPositions) {
            let key = getScrollKey(location, matches);
            let y = savedScrollPositions[key];
            if (typeof y === "number") return y;
        }
        return null;
    }
    function _internalSetRoutes(newRoutes) {
        manifest = {};
        inFlightDataRoutes = $1d34d5c4a288b213$export$4a6d22b32134ea5d(newRoutes, mapRouteProperties, undefined, manifest);
    }
    router = {
        get basename () {
            return basename;
        },
        get state () {
            return state;
        },
        get routes () {
            return dataRoutes;
        },
        get window () {
            return routerWindow;
        },
        initialize: initialize,
        subscribe: subscribe,
        enableScrollRestoration: enableScrollRestoration,
        navigate: navigate,
        fetch: fetch,
        revalidate: revalidate,
        // Passthrough to history-aware createHref used by useHref so we get proper
        // hash-aware URLs in DOM paths
        createHref: (to)=>init.history.createHref(to),
        encodeLocation: (to)=>init.history.encodeLocation(to),
        getFetcher: getFetcher,
        deleteFetcher: deleteFetcherAndUpdateState,
        dispose: dispose,
        getBlocker: getBlocker,
        deleteBlocker: deleteBlocker,
        _internalFetchControllers: fetchControllers,
        _internalActiveDeferreds: activeDeferreds,
        _internalSetRoutes: // TODO: Remove setRoutes, it's temporary to avoid dealing with
        // updating the tree while validating the update algorithm.
        _internalSetRoutes
    };
    return router;
}
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region createStaticHandler
////////////////////////////////////////////////////////////////////////////////
const $1d34d5c4a288b213$export$4d0306f8f6a4585b = Symbol("deferred");
function $1d34d5c4a288b213$export$3336b097a6fbc59a(routes, opts) {
    $1d34d5c4a288b213$export$3e9cee6b33872309(routes.length > 0, "You must provide a non-empty routes array to createStaticHandler");
    let manifest = {};
    let basename = (opts ? opts.basename : null) || "/";
    let mapRouteProperties;
    if (opts != null && opts.mapRouteProperties) mapRouteProperties = opts.mapRouteProperties;
    else if (opts != null && opts.detectErrorBoundary) {
        // If they are still using the deprecated version, wrap it with the new API
        let detectErrorBoundary = opts.detectErrorBoundary;
        mapRouteProperties = (route)=>({
                hasErrorBoundary: detectErrorBoundary(route)
            });
    } else mapRouteProperties = $1d34d5c4a288b213$var$defaultMapRouteProperties;
    let dataRoutes = $1d34d5c4a288b213$export$4a6d22b32134ea5d(routes, mapRouteProperties, undefined, manifest);
    /**
   * The query() method is intended for document requests, in which we want to
   * call an optional action and potentially multiple loaders for all nested
   * routes.  It returns a StaticHandlerContext object, which is very similar
   * to the router state (location, loaderData, actionData, errors, etc.) and
   * also adds SSR-specific information such as the statusCode and headers
   * from action/loaders Responses.
   *
   * It _should_ never throw and should report all errors through the
   * returned context.errors object, properly associating errors to their error
   * boundary.  Additionally, it tracks _deepestRenderedBoundaryId which can be
   * used to emulate React error boundaries during SSr by performing a second
   * pass only down to the boundaryId.
   *
   * The one exception where we do not return a StaticHandlerContext is when a
   * redirect response is returned or thrown from any action/loader.  We
   * propagate that out and return the raw Response so the HTTP server can
   * return it directly.
   */ async function query(request, _temp2) {
        let { requestContext: requestContext } = _temp2 === void 0 ? {} : _temp2;
        let url = new URL(request.url);
        let method = request.method;
        let location = $1d34d5c4a288b213$var$createLocation("", $1d34d5c4a288b213$export$fe53371bee54353d(url), null, "default");
        let matches = $1d34d5c4a288b213$export$2708184779ceb39d(dataRoutes, location, basename);
        // SSR supports HEAD requests while SPA doesn't
        if (!$1d34d5c4a288b213$var$isValidMethod(method) && method !== "HEAD") {
            let error = $1d34d5c4a288b213$var$getInternalRouterError(405, {
                method: method
            });
            let { matches: methodNotAllowedMatches, route: route } = $1d34d5c4a288b213$var$getShortCircuitMatches(dataRoutes);
            return {
                basename: basename,
                location: location,
                matches: methodNotAllowedMatches,
                loaderData: {},
                actionData: null,
                errors: {
                    [route.id]: error
                },
                statusCode: error.status,
                loaderHeaders: {},
                actionHeaders: {},
                activeDeferreds: null
            };
        } else if (!matches) {
            let error = $1d34d5c4a288b213$var$getInternalRouterError(404, {
                pathname: location.pathname
            });
            let { matches: notFoundMatches, route: route } = $1d34d5c4a288b213$var$getShortCircuitMatches(dataRoutes);
            return {
                basename: basename,
                location: location,
                matches: notFoundMatches,
                loaderData: {},
                actionData: null,
                errors: {
                    [route.id]: error
                },
                statusCode: error.status,
                loaderHeaders: {},
                actionHeaders: {},
                activeDeferreds: null
            };
        }
        let result = await queryImpl(request, location, matches, requestContext);
        if ($1d34d5c4a288b213$var$isResponse(result)) return result;
        // When returning StaticHandlerContext, we patch back in the location here
        // since we need it for React Context.  But this helps keep our submit and
        // loadRouteData operating on a Request instead of a Location
        return $1d34d5c4a288b213$var$_extends({
            location: location,
            basename: basename
        }, result);
    }
    /**
   * The queryRoute() method is intended for targeted route requests, either
   * for fetch ?_data requests or resource route requests.  In this case, we
   * are only ever calling a single action or loader, and we are returning the
   * returned value directly.  In most cases, this will be a Response returned
   * from the action/loader, but it may be a primitive or other value as well -
   * and in such cases the calling context should handle that accordingly.
   *
   * We do respect the throw/return differentiation, so if an action/loader
   * throws, then this method will throw the value.  This is important so we
   * can do proper boundary identification in Remix where a thrown Response
   * must go to the Catch Boundary but a returned Response is happy-path.
   *
   * One thing to note is that any Router-initiated Errors that make sense
   * to associate with a status code will be thrown as an ErrorResponse
   * instance which include the raw Error, such that the calling context can
   * serialize the error as they see fit while including the proper response
   * code.  Examples here are 404 and 405 errors that occur prior to reaching
   * any user-defined loaders.
   */ async function queryRoute(request, _temp3) {
        let { routeId: routeId, requestContext: requestContext } = _temp3 === void 0 ? {} : _temp3;
        let url = new URL(request.url);
        let method = request.method;
        let location = $1d34d5c4a288b213$var$createLocation("", $1d34d5c4a288b213$export$fe53371bee54353d(url), null, "default");
        let matches = $1d34d5c4a288b213$export$2708184779ceb39d(dataRoutes, location, basename);
        // SSR supports HEAD requests while SPA doesn't
        if (!$1d34d5c4a288b213$var$isValidMethod(method) && method !== "HEAD" && method !== "OPTIONS") throw $1d34d5c4a288b213$var$getInternalRouterError(405, {
            method: method
        });
        else if (!matches) throw $1d34d5c4a288b213$var$getInternalRouterError(404, {
            pathname: location.pathname
        });
        let match = routeId ? matches.find((m)=>m.route.id === routeId) : $1d34d5c4a288b213$var$getTargetMatch(matches, location);
        if (routeId && !match) throw $1d34d5c4a288b213$var$getInternalRouterError(403, {
            pathname: location.pathname,
            routeId: routeId
        });
        else if (!match) // This should never hit I don't think?
        throw $1d34d5c4a288b213$var$getInternalRouterError(404, {
            pathname: location.pathname
        });
        let result = await queryImpl(request, location, matches, requestContext, match);
        if ($1d34d5c4a288b213$var$isResponse(result)) return result;
        let error = result.errors ? Object.values(result.errors)[0] : undefined;
        if (error !== undefined) // If we got back result.errors, that means the loader/action threw
        // _something_ that wasn't a Response, but it's not guaranteed/required
        // to be an `instanceof Error` either, so we have to use throw here to
        // preserve the "error" state outside of queryImpl.
        throw error;
        // Pick off the right state value to return
        if (result.actionData) return Object.values(result.actionData)[0];
        if (result.loaderData) {
            var _result$activeDeferre;
            let data = Object.values(result.loaderData)[0];
            if ((_result$activeDeferre = result.activeDeferreds) != null && _result$activeDeferre[match.route.id]) data[$1d34d5c4a288b213$export$4d0306f8f6a4585b] = result.activeDeferreds[match.route.id];
            return data;
        }
        return undefined;
    }
    async function queryImpl(request, location, matches, requestContext, routeMatch) {
        $1d34d5c4a288b213$export$3e9cee6b33872309(request.signal, "query()/queryRoute() requests must contain an AbortController signal");
        try {
            if ($1d34d5c4a288b213$var$isMutationMethod(request.method.toLowerCase())) {
                let result = await submit(request, matches, routeMatch || $1d34d5c4a288b213$var$getTargetMatch(matches, location), requestContext, routeMatch != null);
                return result;
            }
            let result = await loadRouteData(request, matches, requestContext, routeMatch);
            return $1d34d5c4a288b213$var$isResponse(result) ? result : $1d34d5c4a288b213$var$_extends({}, result, {
                actionData: null,
                actionHeaders: {}
            });
        } catch (e) {
            // If the user threw/returned a Response in callLoaderOrAction, we throw
            // it to bail out and then return or throw here based on whether the user
            // returned or threw
            if ($1d34d5c4a288b213$var$isQueryRouteResponse(e)) {
                if (e.type === $1d34d5c4a288b213$var$ResultType.error) throw e.response;
                return e.response;
            }
            // Redirects are always returned since they don't propagate to catch
            // boundaries
            if ($1d34d5c4a288b213$var$isRedirectResponse(e)) return e;
            throw e;
        }
    }
    async function submit(request, matches, actionMatch, requestContext, isRouteRequest) {
        let result;
        if (!actionMatch.route.action && !actionMatch.route.lazy) {
            let error = $1d34d5c4a288b213$var$getInternalRouterError(405, {
                method: request.method,
                pathname: new URL(request.url).pathname,
                routeId: actionMatch.route.id
            });
            if (isRouteRequest) throw error;
            result = {
                type: $1d34d5c4a288b213$var$ResultType.error,
                error: error
            };
        } else {
            result = await $1d34d5c4a288b213$var$callLoaderOrAction("action", request, actionMatch, matches, manifest, mapRouteProperties, basename, {
                isStaticRequest: true,
                isRouteRequest: isRouteRequest,
                requestContext: requestContext
            });
            if (request.signal.aborted) {
                let method = isRouteRequest ? "queryRoute" : "query";
                throw new Error(method + "() call aborted: " + request.method + " " + request.url);
            }
        }
        if ($1d34d5c4a288b213$var$isRedirectResult(result)) // Uhhhh - this should never happen, we should always throw these from
        // callLoaderOrAction, but the type narrowing here keeps TS happy and we
        // can get back on the "throw all redirect responses" train here should
        // this ever happen :/
        throw new Response(null, {
            status: result.status,
            headers: {
                Location: result.location
            }
        });
        if ($1d34d5c4a288b213$var$isDeferredResult(result)) {
            let error = $1d34d5c4a288b213$var$getInternalRouterError(400, {
                type: "defer-action"
            });
            if (isRouteRequest) throw error;
            result = {
                type: $1d34d5c4a288b213$var$ResultType.error,
                error: error
            };
        }
        if (isRouteRequest) {
            // Note: This should only be non-Response values if we get here, since
            // isRouteRequest should throw any Response received in callLoaderOrAction
            if ($1d34d5c4a288b213$var$isErrorResult(result)) throw result.error;
            return {
                matches: [
                    actionMatch
                ],
                loaderData: {},
                actionData: {
                    [actionMatch.route.id]: result.data
                },
                errors: null,
                // Note: statusCode + headers are unused here since queryRoute will
                // return the raw Response or value
                statusCode: 200,
                loaderHeaders: {},
                actionHeaders: {},
                activeDeferreds: null
            };
        }
        if ($1d34d5c4a288b213$var$isErrorResult(result)) {
            // Store off the pending error - we use it to determine which loaders
            // to call and will commit it when we complete the navigation
            let boundaryMatch = $1d34d5c4a288b213$var$findNearestBoundary(matches, actionMatch.route.id);
            let context = await loadRouteData(request, matches, requestContext, undefined, {
                [boundaryMatch.route.id]: result.error
            });
            // action status codes take precedence over loader status codes
            return $1d34d5c4a288b213$var$_extends({}, context, {
                statusCode: $1d34d5c4a288b213$export$972111febbeef05b(result.error) ? result.error.status : 500,
                actionData: null,
                actionHeaders: $1d34d5c4a288b213$var$_extends({}, result.headers ? {
                    [actionMatch.route.id]: result.headers
                } : {})
            });
        }
        // Create a GET request for the loaders
        let loaderRequest = new Request(request.url, {
            headers: request.headers,
            redirect: request.redirect,
            signal: request.signal
        });
        let context = await loadRouteData(loaderRequest, matches, requestContext);
        return $1d34d5c4a288b213$var$_extends({}, context, result.statusCode ? {
            statusCode: result.statusCode
        } : {}, {
            actionData: {
                [actionMatch.route.id]: result.data
            },
            actionHeaders: $1d34d5c4a288b213$var$_extends({}, result.headers ? {
                [actionMatch.route.id]: result.headers
            } : {})
        });
    }
    async function loadRouteData(request, matches, requestContext, routeMatch, pendingActionError) {
        let isRouteRequest = routeMatch != null;
        // Short circuit if we have no loaders to run (queryRoute())
        if (isRouteRequest && !(routeMatch != null && routeMatch.route.loader) && !(routeMatch != null && routeMatch.route.lazy)) throw $1d34d5c4a288b213$var$getInternalRouterError(400, {
            method: request.method,
            pathname: new URL(request.url).pathname,
            routeId: routeMatch == null ? void 0 : routeMatch.route.id
        });
        let requestMatches = routeMatch ? [
            routeMatch
        ] : $1d34d5c4a288b213$var$getLoaderMatchesUntilBoundary(matches, Object.keys(pendingActionError || {})[0]);
        let matchesToLoad = requestMatches.filter((m)=>m.route.loader || m.route.lazy);
        // Short circuit if we have no loaders to run (query())
        if (matchesToLoad.length === 0) return {
            matches: matches,
            // Add a null for all matched routes for proper revalidation on the client
            loaderData: matches.reduce((acc, m)=>Object.assign(acc, {
                    [m.route.id]: null
                }), {}),
            errors: pendingActionError || null,
            statusCode: 200,
            loaderHeaders: {},
            activeDeferreds: null
        };
        let results = await Promise.all([
            ...matchesToLoad.map((match)=>$1d34d5c4a288b213$var$callLoaderOrAction("loader", request, match, matches, manifest, mapRouteProperties, basename, {
                    isStaticRequest: true,
                    isRouteRequest: isRouteRequest,
                    requestContext: requestContext
                }))
        ]);
        if (request.signal.aborted) {
            let method = isRouteRequest ? "queryRoute" : "query";
            throw new Error(method + "() call aborted: " + request.method + " " + request.url);
        }
        // Process and commit output from loaders
        let activeDeferreds = new Map();
        let context = $1d34d5c4a288b213$var$processRouteLoaderData(matches, matchesToLoad, results, pendingActionError, activeDeferreds);
        // Add a null for any non-loader matches for proper revalidation on the client
        let executedLoaders = new Set(matchesToLoad.map((match)=>match.route.id));
        matches.forEach((match)=>{
            if (!executedLoaders.has(match.route.id)) context.loaderData[match.route.id] = null;
        });
        return $1d34d5c4a288b213$var$_extends({}, context, {
            matches: matches,
            activeDeferreds: activeDeferreds.size > 0 ? Object.fromEntries(activeDeferreds.entries()) : null
        });
    }
    return {
        dataRoutes: dataRoutes,
        query: query,
        queryRoute: queryRoute
    };
}
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region Helpers
////////////////////////////////////////////////////////////////////////////////
/**
 * Given an existing StaticHandlerContext and an error thrown at render time,
 * provide an updated StaticHandlerContext suitable for a second SSR render
 */ function $1d34d5c4a288b213$export$fec11da027c70692(routes, context, error) {
    let newContext = $1d34d5c4a288b213$var$_extends({}, context, {
        statusCode: 500,
        errors: {
            [context._deepestRenderedBoundaryId || routes[0].id]: error
        }
    });
    return newContext;
}
function $1d34d5c4a288b213$var$isSubmissionNavigation(opts) {
    return opts != null && ("formData" in opts && opts.formData != null || "body" in opts && opts.body !== undefined);
}
function $1d34d5c4a288b213$var$normalizeTo(location, matches, basename, prependBasename, to, fromRouteId, relative) {
    let contextualMatches;
    let activeRouteMatch;
    if (fromRouteId != null && relative !== "path") {
        // Grab matches up to the calling route so our route-relative logic is
        // relative to the correct source route.  When using relative:path,
        // fromRouteId is ignored since that is always relative to the current
        // location path
        contextualMatches = [];
        for (let match of matches){
            contextualMatches.push(match);
            if (match.route.id === fromRouteId) {
                activeRouteMatch = match;
                break;
            }
        }
    } else {
        contextualMatches = matches;
        activeRouteMatch = matches[matches.length - 1];
    }
    // Resolve the relative path
    let path = $1d34d5c4a288b213$export$cae722b0cc860f13(to ? to : ".", $1d34d5c4a288b213$export$90ba53ce1c7fdff2(contextualMatches).map((m)=>m.pathnameBase), $1d34d5c4a288b213$export$b69e3301ce081aa3(location.pathname, basename) || location.pathname, relative === "path");
    // When `to` is not specified we inherit search/hash from the current
    // location, unlike when to="." and we just inherit the path.
    // See https://github.com/remix-run/remix/issues/927
    if (to == null) {
        path.search = location.search;
        path.hash = location.hash;
    }
    // Add an ?index param for matched index routes if we don't already have one
    if ((to == null || to === "" || to === ".") && activeRouteMatch && activeRouteMatch.route.index && !$1d34d5c4a288b213$var$hasNakedIndexQuery(path.search)) path.search = path.search ? path.search.replace(/^\?/, "?index&") : "?index";
    // If we're operating within a basename, prepend it to the pathname.  If
    // this is a root navigation, then just use the raw basename which allows
    // the basename to have full control over the presence of a trailing slash
    // on root actions
    if (prependBasename && basename !== "/") path.pathname = path.pathname === "/" ? basename : $1d34d5c4a288b213$export$86d9a7913e44197e([
        basename,
        path.pathname
    ]);
    return $1d34d5c4a288b213$export$fe53371bee54353d(path);
}
// Normalize navigation options by converting formMethod=GET formData objects to
// URLSearchParams so they behave identically to links with query params
function $1d34d5c4a288b213$var$normalizeNavigateOptions(normalizeFormMethod, isFetcher, path, opts) {
    // Return location verbatim on non-submission navigations
    if (!opts || !$1d34d5c4a288b213$var$isSubmissionNavigation(opts)) return {
        path: path
    };
    if (opts.formMethod && !$1d34d5c4a288b213$var$isValidMethod(opts.formMethod)) return {
        path: path,
        error: $1d34d5c4a288b213$var$getInternalRouterError(405, {
            method: opts.formMethod
        })
    };
    let getInvalidBodyError = ()=>({
            path: path,
            error: $1d34d5c4a288b213$var$getInternalRouterError(400, {
                type: "invalid-body"
            })
        });
    // Create a Submission on non-GET navigations
    let rawFormMethod = opts.formMethod || "get";
    let formMethod = normalizeFormMethod ? rawFormMethod.toUpperCase() : rawFormMethod.toLowerCase();
    let formAction = $1d34d5c4a288b213$var$stripHashFromPath(path);
    if (opts.body !== undefined) {
        if (opts.formEncType === "text/plain") {
            // text only support POST/PUT/PATCH/DELETE submissions
            if (!$1d34d5c4a288b213$var$isMutationMethod(formMethod)) return getInvalidBodyError();
            let text = typeof opts.body === "string" ? opts.body : opts.body instanceof FormData || opts.body instanceof URLSearchParams ? // https://html.spec.whatwg.org/multipage/form-control-infrastructure.html#plain-text-form-data
            Array.from(opts.body.entries()).reduce((acc, _ref3)=>{
                let [name, value] = _ref3;
                return "" + acc + name + "=" + value + "\n";
            }, "") : String(opts.body);
            return {
                path: path,
                submission: {
                    formMethod: formMethod,
                    formAction: formAction,
                    formEncType: opts.formEncType,
                    formData: undefined,
                    json: undefined,
                    text: text
                }
            };
        } else if (opts.formEncType === "application/json") {
            // json only supports POST/PUT/PATCH/DELETE submissions
            if (!$1d34d5c4a288b213$var$isMutationMethod(formMethod)) return getInvalidBodyError();
            try {
                let json = typeof opts.body === "string" ? JSON.parse(opts.body) : opts.body;
                return {
                    path: path,
                    submission: {
                        formMethod: formMethod,
                        formAction: formAction,
                        formEncType: opts.formEncType,
                        formData: undefined,
                        json: json,
                        text: undefined
                    }
                };
            } catch (e) {
                return getInvalidBodyError();
            }
        }
    }
    $1d34d5c4a288b213$export$3e9cee6b33872309(typeof FormData === "function", "FormData is not available in this environment");
    let searchParams;
    let formData;
    if (opts.formData) {
        searchParams = $1d34d5c4a288b213$var$convertFormDataToSearchParams(opts.formData);
        formData = opts.formData;
    } else if (opts.body instanceof FormData) {
        searchParams = $1d34d5c4a288b213$var$convertFormDataToSearchParams(opts.body);
        formData = opts.body;
    } else if (opts.body instanceof URLSearchParams) {
        searchParams = opts.body;
        formData = $1d34d5c4a288b213$var$convertSearchParamsToFormData(searchParams);
    } else if (opts.body == null) {
        searchParams = new URLSearchParams();
        formData = new FormData();
    } else try {
        searchParams = new URLSearchParams(opts.body);
        formData = $1d34d5c4a288b213$var$convertSearchParamsToFormData(searchParams);
    } catch (e) {
        return getInvalidBodyError();
    }
    let submission = {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: opts && opts.formEncType || "application/x-www-form-urlencoded",
        formData: formData,
        json: undefined,
        text: undefined
    };
    if ($1d34d5c4a288b213$var$isMutationMethod(submission.formMethod)) return {
        path: path,
        submission: submission
    };
    // Flatten submission onto URLSearchParams for GET submissions
    let parsedPath = $1d34d5c4a288b213$export$8ccf933b0513f8d0(path);
    // On GET navigation submissions we can drop the ?index param from the
    // resulting location since all loaders will run.  But fetcher GET submissions
    // only run a single loader so we need to preserve any incoming ?index params
    if (isFetcher && parsedPath.search && $1d34d5c4a288b213$var$hasNakedIndexQuery(parsedPath.search)) searchParams.append("index", "");
    parsedPath.search = "?" + searchParams;
    return {
        path: $1d34d5c4a288b213$export$fe53371bee54353d(parsedPath),
        submission: submission
    };
}
// Filter out all routes below any caught error as they aren't going to
// render so we don't need to load them
function $1d34d5c4a288b213$var$getLoaderMatchesUntilBoundary(matches, boundaryId) {
    let boundaryMatches = matches;
    if (boundaryId) {
        let index = matches.findIndex((m)=>m.route.id === boundaryId);
        if (index >= 0) boundaryMatches = matches.slice(0, index);
    }
    return boundaryMatches;
}
function $1d34d5c4a288b213$var$getMatchesToLoad(history, state, matches, submission, location, isRevalidationRequired, cancelledDeferredRoutes, cancelledFetcherLoads, fetchLoadMatches, fetchRedirectIds, routesToUse, basename, pendingActionData, pendingError) {
    let actionResult = pendingError ? Object.values(pendingError)[0] : pendingActionData ? Object.values(pendingActionData)[0] : undefined;
    let currentUrl = history.createURL(state.location);
    let nextUrl = history.createURL(location);
    // Pick navigation matches that are net-new or qualify for revalidation
    let boundaryId = pendingError ? Object.keys(pendingError)[0] : undefined;
    let boundaryMatches = $1d34d5c4a288b213$var$getLoaderMatchesUntilBoundary(matches, boundaryId);
    let navigationMatches = boundaryMatches.filter((match, index)=>{
        if (match.route.lazy) // We haven't loaded this route yet so we don't know if it's got a loader!
        return true;
        if (match.route.loader == null) return false;
        // Always call the loader on new route instances and pending defer cancellations
        if ($1d34d5c4a288b213$var$isNewLoader(state.loaderData, state.matches[index], match) || cancelledDeferredRoutes.some((id)=>id === match.route.id)) return true;
        // This is the default implementation for when we revalidate.  If the route
        // provides it's own implementation, then we give them full control but
        // provide this value so they can leverage it if needed after they check
        // their own specific use cases
        let currentRouteMatch = state.matches[index];
        let nextRouteMatch = match;
        return $1d34d5c4a288b213$var$shouldRevalidateLoader(match, $1d34d5c4a288b213$var$_extends({
            currentUrl: currentUrl,
            currentParams: currentRouteMatch.params,
            nextUrl: nextUrl,
            nextParams: nextRouteMatch.params
        }, submission, {
            actionResult: actionResult,
            defaultShouldRevalidate: // Forced revalidation due to submission, useRevalidator, or X-Remix-Revalidate
            isRevalidationRequired || // Clicked the same link, resubmitted a GET form
            currentUrl.pathname + currentUrl.search === nextUrl.pathname + nextUrl.search || // Search params affect all loaders
            currentUrl.search !== nextUrl.search || $1d34d5c4a288b213$var$isNewRouteInstance(currentRouteMatch, nextRouteMatch)
        }));
    });
    // Pick fetcher.loads that need to be revalidated
    let revalidatingFetchers = [];
    fetchLoadMatches.forEach((f, key)=>{
        // Don't revalidate if fetcher won't be present in the subsequent render
        if (!matches.some((m)=>m.route.id === f.routeId)) return;
        let fetcherMatches = $1d34d5c4a288b213$export$2708184779ceb39d(routesToUse, f.path, basename);
        // If the fetcher path no longer matches, push it in with null matches so
        // we can trigger a 404 in callLoadersAndMaybeResolveData.  Note this is
        // currently only a use-case for Remix HMR where the route tree can change
        // at runtime and remove a route previously loaded via a fetcher
        if (!fetcherMatches) {
            revalidatingFetchers.push({
                key: key,
                routeId: f.routeId,
                path: f.path,
                matches: null,
                match: null,
                controller: null
            });
            return;
        }
        // Revalidating fetchers are decoupled from the route matches since they
        // load from a static href.  They revalidate based on explicit revalidation
        // (submission, useRevalidator, or X-Remix-Revalidate)
        let fetcher = state.fetchers.get(key);
        let fetcherMatch = $1d34d5c4a288b213$var$getTargetMatch(fetcherMatches, f.path);
        let shouldRevalidate = false;
        if (fetchRedirectIds.has(key)) // Never trigger a revalidation of an actively redirecting fetcher
        shouldRevalidate = false;
        else if (cancelledFetcherLoads.includes(key)) // Always revalidate if the fetcher was cancelled
        shouldRevalidate = true;
        else if (fetcher && fetcher.state !== "idle" && fetcher.data === undefined) // If the fetcher hasn't ever completed loading yet, then this isn't a
        // revalidation, it would just be a brand new load if an explicit
        // revalidation is required
        shouldRevalidate = isRevalidationRequired;
        else // Otherwise fall back on any user-defined shouldRevalidate, defaulting
        // to explicit revalidations only
        shouldRevalidate = $1d34d5c4a288b213$var$shouldRevalidateLoader(fetcherMatch, $1d34d5c4a288b213$var$_extends({
            currentUrl: currentUrl,
            currentParams: state.matches[state.matches.length - 1].params,
            nextUrl: nextUrl,
            nextParams: matches[matches.length - 1].params
        }, submission, {
            actionResult: actionResult,
            defaultShouldRevalidate: isRevalidationRequired
        }));
        if (shouldRevalidate) revalidatingFetchers.push({
            key: key,
            routeId: f.routeId,
            path: f.path,
            matches: fetcherMatches,
            match: fetcherMatch,
            controller: new AbortController()
        });
    });
    return [
        navigationMatches,
        revalidatingFetchers
    ];
}
function $1d34d5c4a288b213$var$isNewLoader(currentLoaderData, currentMatch, match) {
    let isNew = // [a] -> [a, b]
    !currentMatch || // [a, b] -> [a, c]
    match.route.id !== currentMatch.route.id;
    // Handle the case that we don't have data for a re-used route, potentially
    // from a prior error or from a cancelled pending deferred
    let isMissingData = currentLoaderData[match.route.id] === undefined;
    // Always load if this is a net-new route or we don't yet have data
    return isNew || isMissingData;
}
function $1d34d5c4a288b213$var$isNewRouteInstance(currentMatch, match) {
    let currentPath = currentMatch.route.path;
    return(// param change for this match, /users/123 -> /users/456
    currentMatch.pathname !== match.pathname || // splat param changed, which is not present in match.path
    // e.g. /files/images/avatar.jpg -> files/finances.xls
    currentPath != null && currentPath.endsWith("*") && currentMatch.params["*"] !== match.params["*"]);
}
function $1d34d5c4a288b213$var$shouldRevalidateLoader(loaderMatch, arg) {
    if (loaderMatch.route.shouldRevalidate) {
        let routeChoice = loaderMatch.route.shouldRevalidate(arg);
        if (typeof routeChoice === "boolean") return routeChoice;
    }
    return arg.defaultShouldRevalidate;
}
/**
 * Execute route.lazy() methods to lazily load route modules (loader, action,
 * shouldRevalidate) and update the routeManifest in place which shares objects
 * with dataRoutes so those get updated as well.
 */ async function $1d34d5c4a288b213$var$loadLazyRouteModule(route, mapRouteProperties, manifest) {
    if (!route.lazy) return;
    let lazyRoute = await route.lazy();
    // If the lazy route function was executed and removed by another parallel
    // call then we can return - first lazy() to finish wins because the return
    // value of lazy is expected to be static
    if (!route.lazy) return;
    let routeToUpdate = manifest[route.id];
    $1d34d5c4a288b213$export$3e9cee6b33872309(routeToUpdate, "No route found in manifest");
    // Update the route in place.  This should be safe because there's no way
    // we could yet be sitting on this route as we can't get there without
    // resolving lazy() first.
    //
    // This is different than the HMR "update" use-case where we may actively be
    // on the route being updated.  The main concern boils down to "does this
    // mutation affect any ongoing navigations or any current state.matches
    // values?".  If not, it should be safe to update in place.
    let routeUpdates = {};
    for(let lazyRouteProperty in lazyRoute){
        let staticRouteValue = routeToUpdate[lazyRouteProperty];
        let isPropertyStaticallyDefined = staticRouteValue !== undefined && // This property isn't static since it should always be updated based
        // on the route updates
        lazyRouteProperty !== "hasErrorBoundary";
        $1d34d5c4a288b213$export$c0e02632e14916fd(!isPropertyStaticallyDefined, 'Route "' + routeToUpdate.id + '" has a static property "' + lazyRouteProperty + '" ' + "defined but its lazy function is also returning a value for this property. " + ('The lazy route property "' + lazyRouteProperty + '" will be ignored.'));
        if (!isPropertyStaticallyDefined && !$1d34d5c4a288b213$var$immutableRouteKeys.has(lazyRouteProperty)) routeUpdates[lazyRouteProperty] = lazyRoute[lazyRouteProperty];
    }
    // Mutate the route with the provided updates.  Do this first so we pass
    // the updated version to mapRouteProperties
    Object.assign(routeToUpdate, routeUpdates);
    // Mutate the `hasErrorBoundary` property on the route based on the route
    // updates and remove the `lazy` function so we don't resolve the lazy
    // route again.
    Object.assign(routeToUpdate, $1d34d5c4a288b213$var$_extends({}, mapRouteProperties(routeToUpdate), {
        lazy: undefined
    }));
}
async function $1d34d5c4a288b213$var$callLoaderOrAction(type, request, match, matches, manifest, mapRouteProperties, basename, opts) {
    if (opts === void 0) opts = {};
    let resultType;
    let result;
    let onReject;
    let runHandler = (handler)=>{
        // Setup a promise we can race against so that abort signals short circuit
        let reject;
        let abortPromise = new Promise((_, r)=>reject = r);
        onReject = ()=>reject();
        request.signal.addEventListener("abort", onReject);
        return Promise.race([
            handler({
                request: request,
                params: match.params,
                context: opts.requestContext
            }),
            abortPromise
        ]);
    };
    try {
        let handler = match.route[type];
        if (match.route.lazy) {
            if (handler) {
                // Run statically defined handler in parallel with lazy()
                let handlerError;
                let values = await Promise.all([
                    // If the handler throws, don't let it immediately bubble out,
                    // since we need to let the lazy() execution finish so we know if this
                    // route has a boundary that can handle the error
                    runHandler(handler).catch((e)=>{
                        handlerError = e;
                    }),
                    $1d34d5c4a288b213$var$loadLazyRouteModule(match.route, mapRouteProperties, manifest)
                ]);
                if (handlerError) throw handlerError;
                result = values[0];
            } else {
                // Load lazy route module, then run any returned handler
                await $1d34d5c4a288b213$var$loadLazyRouteModule(match.route, mapRouteProperties, manifest);
                handler = match.route[type];
                if (handler) // Handler still run even if we got interrupted to maintain consistency
                // with un-abortable behavior of handler execution on non-lazy or
                // previously-lazy-loaded routes
                result = await runHandler(handler);
                else if (type === "action") {
                    let url = new URL(request.url);
                    let pathname = url.pathname + url.search;
                    throw $1d34d5c4a288b213$var$getInternalRouterError(405, {
                        method: request.method,
                        pathname: pathname,
                        routeId: match.route.id
                    });
                } else // lazy() route has no loader to run.  Short circuit here so we don't
                // hit the invariant below that errors on returning undefined.
                return {
                    type: $1d34d5c4a288b213$var$ResultType.data,
                    data: undefined
                };
            }
        } else if (!handler) {
            let url = new URL(request.url);
            let pathname = url.pathname + url.search;
            throw $1d34d5c4a288b213$var$getInternalRouterError(404, {
                pathname: pathname
            });
        } else result = await runHandler(handler);
        $1d34d5c4a288b213$export$3e9cee6b33872309(result !== undefined, "You defined " + (type === "action" ? "an action" : "a loader") + " for route " + ('"' + match.route.id + "\" but didn't return anything from your `" + type + "` ") + "function. Please return a value or `null`.");
    } catch (e) {
        resultType = $1d34d5c4a288b213$var$ResultType.error;
        result = e;
    } finally{
        if (onReject) request.signal.removeEventListener("abort", onReject);
    }
    if ($1d34d5c4a288b213$var$isResponse(result)) {
        let status = result.status;
        // Process redirects
        if ($1d34d5c4a288b213$var$redirectStatusCodes.has(status)) {
            let location = result.headers.get("Location");
            $1d34d5c4a288b213$export$3e9cee6b33872309(location, "Redirects returned/thrown from loaders/actions must have a Location header");
            // Support relative routing in internal redirects
            if (!$1d34d5c4a288b213$var$ABSOLUTE_URL_REGEX.test(location)) location = $1d34d5c4a288b213$var$normalizeTo(new URL(request.url), matches.slice(0, matches.indexOf(match) + 1), basename, true, location);
            else if (!opts.isStaticRequest) {
                // Strip off the protocol+origin for same-origin + same-basename absolute
                // redirects. If this is a static request, we can let it go back to the
                // browser as-is
                let currentUrl = new URL(request.url);
                let url = location.startsWith("//") ? new URL(currentUrl.protocol + location) : new URL(location);
                let isSameBasename = $1d34d5c4a288b213$export$b69e3301ce081aa3(url.pathname, basename) != null;
                if (url.origin === currentUrl.origin && isSameBasename) location = url.pathname + url.search + url.hash;
            }
            // Don't process redirects in the router during static requests requests.
            // Instead, throw the Response and let the server handle it with an HTTP
            // redirect.  We also update the Location header in place in this flow so
            // basename and relative routing is taken into account
            if (opts.isStaticRequest) {
                result.headers.set("Location", location);
                throw result;
            }
            return {
                type: $1d34d5c4a288b213$var$ResultType.redirect,
                status: status,
                location: location,
                revalidate: result.headers.get("X-Remix-Revalidate") !== null,
                reloadDocument: result.headers.get("X-Remix-Reload-Document") !== null
            };
        }
        // For SSR single-route requests, we want to hand Responses back directly
        // without unwrapping.  We do this with the QueryRouteResponse wrapper
        // interface so we can know whether it was returned or thrown
        if (opts.isRouteRequest) {
            let queryRouteResponse = {
                type: resultType === $1d34d5c4a288b213$var$ResultType.error ? $1d34d5c4a288b213$var$ResultType.error : $1d34d5c4a288b213$var$ResultType.data,
                response: result
            };
            throw queryRouteResponse;
        }
        let data;
        let contentType = result.headers.get("Content-Type");
        // Check between word boundaries instead of startsWith() due to the last
        // paragraph of https://httpwg.org/specs/rfc9110.html#field.content-type
        if (contentType && /\bapplication\/json\b/.test(contentType)) data = await result.json();
        else data = await result.text();
        if (resultType === $1d34d5c4a288b213$var$ResultType.error) return {
            type: resultType,
            error: new $1d34d5c4a288b213$export$6c6580e81da25755(status, result.statusText, data),
            headers: result.headers
        };
        return {
            type: $1d34d5c4a288b213$var$ResultType.data,
            data: data,
            statusCode: result.status,
            headers: result.headers
        };
    }
    if (resultType === $1d34d5c4a288b213$var$ResultType.error) return {
        type: resultType,
        error: result
    };
    if ($1d34d5c4a288b213$export$fbcedacb60443473(result)) {
        var _result$init, _result$init2;
        return {
            type: $1d34d5c4a288b213$var$ResultType.deferred,
            deferredData: result,
            statusCode: (_result$init = result.init) == null ? void 0 : _result$init.status,
            headers: ((_result$init2 = result.init) == null ? void 0 : _result$init2.headers) && new Headers(result.init.headers)
        };
    }
    return {
        type: $1d34d5c4a288b213$var$ResultType.data,
        data: result
    };
}
// Utility method for creating the Request instances for loaders/actions during
// client-side navigations and fetches.  During SSR we will always have a
// Request instance from the static handler (query/queryRoute)
function $1d34d5c4a288b213$var$createClientSideRequest(history, location, signal, submission) {
    let url = history.createURL($1d34d5c4a288b213$var$stripHashFromPath(location)).toString();
    let init = {
        signal: signal
    };
    if (submission && $1d34d5c4a288b213$var$isMutationMethod(submission.formMethod)) {
        let { formMethod: formMethod, formEncType: formEncType } = submission;
        // Didn't think we needed this but it turns out unlike other methods, patch
        // won't be properly normalized to uppercase and results in a 405 error.
        // See: https://fetch.spec.whatwg.org/#concept-method
        init.method = formMethod.toUpperCase();
        if (formEncType === "application/json") {
            init.headers = new Headers({
                "Content-Type": formEncType
            });
            init.body = JSON.stringify(submission.json);
        } else if (formEncType === "text/plain") // Content-Type is inferred (https://fetch.spec.whatwg.org/#dom-request)
        init.body = submission.text;
        else if (formEncType === "application/x-www-form-urlencoded" && submission.formData) // Content-Type is inferred (https://fetch.spec.whatwg.org/#dom-request)
        init.body = $1d34d5c4a288b213$var$convertFormDataToSearchParams(submission.formData);
        else // Content-Type is inferred (https://fetch.spec.whatwg.org/#dom-request)
        init.body = submission.formData;
    }
    return new Request(url, init);
}
function $1d34d5c4a288b213$var$convertFormDataToSearchParams(formData) {
    let searchParams = new URLSearchParams();
    for (let [key, value] of formData.entries())// https://html.spec.whatwg.org/multipage/form-control-infrastructure.html#converting-an-entry-list-to-a-list-of-name-value-pairs
    searchParams.append(key, typeof value === "string" ? value : value.name);
    return searchParams;
}
function $1d34d5c4a288b213$var$convertSearchParamsToFormData(searchParams) {
    let formData = new FormData();
    for (let [key, value] of searchParams.entries())formData.append(key, value);
    return formData;
}
function $1d34d5c4a288b213$var$processRouteLoaderData(matches, matchesToLoad, results, pendingError, activeDeferreds) {
    // Fill in loaderData/errors from our loaders
    let loaderData = {};
    let errors = null;
    let statusCode;
    let foundError = false;
    let loaderHeaders = {};
    // Process loader results into state.loaderData/state.errors
    results.forEach((result, index)=>{
        let id = matchesToLoad[index].route.id;
        $1d34d5c4a288b213$export$3e9cee6b33872309(!$1d34d5c4a288b213$var$isRedirectResult(result), "Cannot handle redirect results in processLoaderData");
        if ($1d34d5c4a288b213$var$isErrorResult(result)) {
            // Look upwards from the matched route for the closest ancestor
            // error boundary, defaulting to the root match
            let boundaryMatch = $1d34d5c4a288b213$var$findNearestBoundary(matches, id);
            let error = result.error;
            // If we have a pending action error, we report it at the highest-route
            // that throws a loader error, and then clear it out to indicate that
            // it was consumed
            if (pendingError) {
                error = Object.values(pendingError)[0];
                pendingError = undefined;
            }
            errors = errors || {};
            // Prefer higher error values if lower errors bubble to the same boundary
            if (errors[boundaryMatch.route.id] == null) errors[boundaryMatch.route.id] = error;
            // Clear our any prior loaderData for the throwing route
            loaderData[id] = undefined;
            // Once we find our first (highest) error, we set the status code and
            // prevent deeper status codes from overriding
            if (!foundError) {
                foundError = true;
                statusCode = $1d34d5c4a288b213$export$972111febbeef05b(result.error) ? result.error.status : 500;
            }
            if (result.headers) loaderHeaders[id] = result.headers;
        } else {
            if ($1d34d5c4a288b213$var$isDeferredResult(result)) {
                activeDeferreds.set(id, result.deferredData);
                loaderData[id] = result.deferredData.data;
            } else loaderData[id] = result.data;
            // Error status codes always override success status codes, but if all
            // loaders are successful we take the deepest status code.
            if (result.statusCode != null && result.statusCode !== 200 && !foundError) statusCode = result.statusCode;
            if (result.headers) loaderHeaders[id] = result.headers;
        }
    });
    // If we didn't consume the pending action error (i.e., all loaders
    // resolved), then consume it here.  Also clear out any loaderData for the
    // throwing route
    if (pendingError) {
        errors = pendingError;
        loaderData[Object.keys(pendingError)[0]] = undefined;
    }
    return {
        loaderData: loaderData,
        errors: errors,
        statusCode: statusCode || 200,
        loaderHeaders: loaderHeaders
    };
}
function $1d34d5c4a288b213$var$processLoaderData(state, matches, matchesToLoad, results, pendingError, revalidatingFetchers, fetcherResults, activeDeferreds) {
    let { loaderData: loaderData, errors: errors } = $1d34d5c4a288b213$var$processRouteLoaderData(matches, matchesToLoad, results, pendingError, activeDeferreds);
    // Process results from our revalidating fetchers
    for(let index = 0; index < revalidatingFetchers.length; index++){
        let { key: key, match: match, controller: controller } = revalidatingFetchers[index];
        $1d34d5c4a288b213$export$3e9cee6b33872309(fetcherResults !== undefined && fetcherResults[index] !== undefined, "Did not find corresponding fetcher result");
        let result = fetcherResults[index];
        // Process fetcher non-redirect errors
        if (controller && controller.signal.aborted) continue;
        else if ($1d34d5c4a288b213$var$isErrorResult(result)) {
            let boundaryMatch = $1d34d5c4a288b213$var$findNearestBoundary(state.matches, match == null ? void 0 : match.route.id);
            if (!(errors && errors[boundaryMatch.route.id])) errors = $1d34d5c4a288b213$var$_extends({}, errors, {
                [boundaryMatch.route.id]: result.error
            });
            state.fetchers.delete(key);
        } else if ($1d34d5c4a288b213$var$isRedirectResult(result)) // Should never get here, redirects should get processed above, but we
        // keep this to type narrow to a success result in the else
        $1d34d5c4a288b213$export$3e9cee6b33872309(false, "Unhandled fetcher revalidation redirect");
        else if ($1d34d5c4a288b213$var$isDeferredResult(result)) // Should never get here, deferred data should be awaited for fetchers
        // in resolveDeferredResults
        $1d34d5c4a288b213$export$3e9cee6b33872309(false, "Unhandled fetcher deferred data");
        else {
            let doneFetcher = $1d34d5c4a288b213$var$getDoneFetcher(result.data);
            state.fetchers.set(key, doneFetcher);
        }
    }
    return {
        loaderData: loaderData,
        errors: errors
    };
}
function $1d34d5c4a288b213$var$mergeLoaderData(loaderData, newLoaderData, matches, errors) {
    let mergedLoaderData = $1d34d5c4a288b213$var$_extends({}, newLoaderData);
    for (let match of matches){
        let id = match.route.id;
        if (newLoaderData.hasOwnProperty(id)) {
            if (newLoaderData[id] !== undefined) mergedLoaderData[id] = newLoaderData[id];
        } else if (loaderData[id] !== undefined && match.route.loader) // Preserve existing keys not included in newLoaderData and where a loader
        // wasn't removed by HMR
        mergedLoaderData[id] = loaderData[id];
        if (errors && errors.hasOwnProperty(id)) break;
    }
    return mergedLoaderData;
}
// Find the nearest error boundary, looking upwards from the leaf route (or the
// route specified by routeId) for the closest ancestor error boundary,
// defaulting to the root match
function $1d34d5c4a288b213$var$findNearestBoundary(matches, routeId) {
    let eligibleMatches = routeId ? matches.slice(0, matches.findIndex((m)=>m.route.id === routeId) + 1) : [
        ...matches
    ];
    return eligibleMatches.reverse().find((m)=>m.route.hasErrorBoundary === true) || matches[0];
}
function $1d34d5c4a288b213$var$getShortCircuitMatches(routes) {
    // Prefer a root layout route if present, otherwise shim in a route object
    let route = routes.length === 1 ? routes[0] : routes.find((r)=>r.index || !r.path || r.path === "/") || {
        id: "__shim-error-route__"
    };
    return {
        matches: [
            {
                params: {},
                pathname: "",
                pathnameBase: "",
                route: route
            }
        ],
        route: route
    };
}
function $1d34d5c4a288b213$var$getInternalRouterError(status, _temp4) {
    let { pathname: pathname, routeId: routeId, method: method, type: type } = _temp4 === void 0 ? {} : _temp4;
    let statusText = "Unknown Server Error";
    let errorMessage = "Unknown @remix-run/router error";
    if (status === 400) {
        statusText = "Bad Request";
        if (method && pathname && routeId) errorMessage = "You made a " + method + ' request to "' + pathname + '" but ' + ('did not provide a `loader` for route "' + routeId + '", ') + "so there is no way to handle the request.";
        else if (type === "defer-action") errorMessage = "defer() is not supported in actions";
        else if (type === "invalid-body") errorMessage = "Unable to encode submission body";
    } else if (status === 403) {
        statusText = "Forbidden";
        errorMessage = 'Route "' + routeId + '" does not match URL "' + pathname + '"';
    } else if (status === 404) {
        statusText = "Not Found";
        errorMessage = 'No route matches URL "' + pathname + '"';
    } else if (status === 405) {
        statusText = "Method Not Allowed";
        if (method && pathname && routeId) errorMessage = "You made a " + method.toUpperCase() + ' request to "' + pathname + '" but ' + ('did not provide an `action` for route "' + routeId + '", ') + "so there is no way to handle the request.";
        else if (method) errorMessage = 'Invalid request method "' + method.toUpperCase() + '"';
    }
    return new $1d34d5c4a288b213$export$6c6580e81da25755(status || 500, statusText, new Error(errorMessage), true);
}
// Find any returned redirect errors, starting from the lowest match
function $1d34d5c4a288b213$var$findRedirect(results) {
    for(let i = results.length - 1; i >= 0; i--){
        let result = results[i];
        if ($1d34d5c4a288b213$var$isRedirectResult(result)) return {
            result: result,
            idx: i
        };
    }
}
function $1d34d5c4a288b213$var$stripHashFromPath(path) {
    let parsedPath = typeof path === "string" ? $1d34d5c4a288b213$export$8ccf933b0513f8d0(path) : path;
    return $1d34d5c4a288b213$export$fe53371bee54353d($1d34d5c4a288b213$var$_extends({}, parsedPath, {
        hash: ""
    }));
}
function $1d34d5c4a288b213$var$isHashChangeOnly(a, b) {
    if (a.pathname !== b.pathname || a.search !== b.search) return false;
    if (a.hash === "") // /page -> /page#hash
    return b.hash !== "";
    else if (a.hash === b.hash) // /page#hash -> /page#hash
    return true;
    else if (b.hash !== "") // /page#hash -> /page#other
    return true;
    // If the hash is removed the browser will re-perform a request to the server
    // /page#hash -> /page
    return false;
}
function $1d34d5c4a288b213$var$isDeferredResult(result) {
    return result.type === $1d34d5c4a288b213$var$ResultType.deferred;
}
function $1d34d5c4a288b213$var$isErrorResult(result) {
    return result.type === $1d34d5c4a288b213$var$ResultType.error;
}
function $1d34d5c4a288b213$var$isRedirectResult(result) {
    return (result && result.type) === $1d34d5c4a288b213$var$ResultType.redirect;
}
function $1d34d5c4a288b213$export$fbcedacb60443473(value) {
    let deferred = value;
    return deferred && typeof deferred === "object" && typeof deferred.data === "object" && typeof deferred.subscribe === "function" && typeof deferred.cancel === "function" && typeof deferred.resolveData === "function";
}
function $1d34d5c4a288b213$var$isResponse(value) {
    return value != null && typeof value.status === "number" && typeof value.statusText === "string" && typeof value.headers === "object" && typeof value.body !== "undefined";
}
function $1d34d5c4a288b213$var$isRedirectResponse(result) {
    if (!$1d34d5c4a288b213$var$isResponse(result)) return false;
    let status = result.status;
    let location = result.headers.get("Location");
    return status >= 300 && status <= 399 && location != null;
}
function $1d34d5c4a288b213$var$isQueryRouteResponse(obj) {
    return obj && $1d34d5c4a288b213$var$isResponse(obj.response) && (obj.type === $1d34d5c4a288b213$var$ResultType.data || obj.type === $1d34d5c4a288b213$var$ResultType.error);
}
function $1d34d5c4a288b213$var$isValidMethod(method) {
    return $1d34d5c4a288b213$var$validRequestMethods.has(method.toLowerCase());
}
function $1d34d5c4a288b213$var$isMutationMethod(method) {
    return $1d34d5c4a288b213$var$validMutationMethods.has(method.toLowerCase());
}
async function $1d34d5c4a288b213$var$resolveDeferredResults(currentMatches, matchesToLoad, results, signals, isFetcher, currentLoaderData) {
    for(let index = 0; index < results.length; index++){
        let result = results[index];
        let match = matchesToLoad[index];
        // If we don't have a match, then we can have a deferred result to do
        // anything with.  This is for revalidating fetchers where the route was
        // removed during HMR
        if (!match) continue;
        let currentMatch = currentMatches.find((m)=>m.route.id === match.route.id);
        let isRevalidatingLoader = currentMatch != null && !$1d34d5c4a288b213$var$isNewRouteInstance(currentMatch, match) && (currentLoaderData && currentLoaderData[match.route.id]) !== undefined;
        if ($1d34d5c4a288b213$var$isDeferredResult(result) && (isFetcher || isRevalidatingLoader)) {
            // Note: we do not have to touch activeDeferreds here since we race them
            // against the signal in resolveDeferredData and they'll get aborted
            // there if needed
            let signal = signals[index];
            $1d34d5c4a288b213$export$3e9cee6b33872309(signal, "Expected an AbortSignal for revalidating fetcher deferred result");
            await $1d34d5c4a288b213$var$resolveDeferredData(result, signal, isFetcher).then((result)=>{
                if (result) results[index] = result || results[index];
            });
        }
    }
}
async function $1d34d5c4a288b213$var$resolveDeferredData(result, signal, unwrap) {
    if (unwrap === void 0) unwrap = false;
    let aborted = await result.deferredData.resolveData(signal);
    if (aborted) return;
    if (unwrap) try {
        return {
            type: $1d34d5c4a288b213$var$ResultType.data,
            data: result.deferredData.unwrappedData
        };
    } catch (e) {
        // Handle any TrackedPromise._error values encountered while unwrapping
        return {
            type: $1d34d5c4a288b213$var$ResultType.error,
            error: e
        };
    }
    return {
        type: $1d34d5c4a288b213$var$ResultType.data,
        data: result.deferredData.data
    };
}
function $1d34d5c4a288b213$var$hasNakedIndexQuery(search) {
    return new URLSearchParams(search).getAll("index").some((v)=>v === "");
}
function $1d34d5c4a288b213$var$getTargetMatch(matches, location) {
    let search = typeof location === "string" ? $1d34d5c4a288b213$export$8ccf933b0513f8d0(location).search : location.search;
    if (matches[matches.length - 1].route.index && $1d34d5c4a288b213$var$hasNakedIndexQuery(search || "")) // Return the leaf index route when index is present
    return matches[matches.length - 1];
    // Otherwise grab the deepest "path contributing" match (ignoring index and
    // pathless layout routes)
    let pathMatches = $1d34d5c4a288b213$export$90ba53ce1c7fdff2(matches);
    return pathMatches[pathMatches.length - 1];
}
function $1d34d5c4a288b213$var$getSubmissionFromNavigation(navigation) {
    let { formMethod: formMethod, formAction: formAction, formEncType: formEncType, text: text, formData: formData, json: json } = navigation;
    if (!formMethod || !formAction || !formEncType) return;
    if (text != null) return {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: formEncType,
        formData: undefined,
        json: undefined,
        text: text
    };
    else if (formData != null) return {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: formEncType,
        formData: formData,
        json: undefined,
        text: undefined
    };
    else if (json !== undefined) return {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: formEncType,
        formData: undefined,
        json: json,
        text: undefined
    };
}
function $1d34d5c4a288b213$var$getLoadingNavigation(location, submission) {
    if (submission) {
        let navigation = {
            state: "loading",
            location: location,
            formMethod: submission.formMethod,
            formAction: submission.formAction,
            formEncType: submission.formEncType,
            formData: submission.formData,
            json: submission.json,
            text: submission.text
        };
        return navigation;
    } else {
        let navigation = {
            state: "loading",
            location: location,
            formMethod: undefined,
            formAction: undefined,
            formEncType: undefined,
            formData: undefined,
            json: undefined,
            text: undefined
        };
        return navigation;
    }
}
function $1d34d5c4a288b213$var$getSubmittingNavigation(location, submission) {
    let navigation = {
        state: "submitting",
        location: location,
        formMethod: submission.formMethod,
        formAction: submission.formAction,
        formEncType: submission.formEncType,
        formData: submission.formData,
        json: submission.json,
        text: submission.text
    };
    return navigation;
}
function $1d34d5c4a288b213$var$getLoadingFetcher(submission, data) {
    if (submission) {
        let fetcher = {
            state: "loading",
            formMethod: submission.formMethod,
            formAction: submission.formAction,
            formEncType: submission.formEncType,
            formData: submission.formData,
            json: submission.json,
            text: submission.text,
            data: data
        };
        return fetcher;
    } else {
        let fetcher = {
            state: "loading",
            formMethod: undefined,
            formAction: undefined,
            formEncType: undefined,
            formData: undefined,
            json: undefined,
            text: undefined,
            data: data
        };
        return fetcher;
    }
}
function $1d34d5c4a288b213$var$getSubmittingFetcher(submission, existingFetcher) {
    let fetcher = {
        state: "submitting",
        formMethod: submission.formMethod,
        formAction: submission.formAction,
        formEncType: submission.formEncType,
        formData: submission.formData,
        json: submission.json,
        text: submission.text,
        data: existingFetcher ? existingFetcher.data : undefined
    };
    return fetcher;
}
function $1d34d5c4a288b213$var$getDoneFetcher(data) {
    let fetcher = {
        state: "idle",
        formMethod: undefined,
        formAction: undefined,
        formEncType: undefined,
        formData: undefined,
        json: undefined,
        text: undefined,
        data: data
    };
    return fetcher;
}
function $1d34d5c4a288b213$var$restoreAppliedTransitions(_window, transitions) {
    try {
        let sessionPositions = _window.sessionStorage.getItem($1d34d5c4a288b213$var$TRANSITIONS_STORAGE_KEY);
        if (sessionPositions) {
            let json = JSON.parse(sessionPositions);
            for (let [k, v] of Object.entries(json || {}))if (v && Array.isArray(v)) transitions.set(k, new Set(v || []));
        }
    } catch (e) {
    // no-op, use default empty object
    }
}
function $1d34d5c4a288b213$var$persistAppliedTransitions(_window, transitions) {
    if (transitions.size > 0) {
        let json = {};
        for (let [k, v] of transitions)json[k] = [
            ...v
        ];
        try {
            _window.sessionStorage.setItem($1d34d5c4a288b213$var$TRANSITIONS_STORAGE_KEY, JSON.stringify(json));
        } catch (error) {
            $1d34d5c4a288b213$export$c0e02632e14916fd(false, "Failed to save applied view transitions in sessionStorage (" + error + ").");
        }
    }
}

/**
 * React Router v6.18.0
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ 
var $acw62 = parcelRequire("acw62");

function $7939e29d663dd3ed$var$_extends() {
    $7939e29d663dd3ed$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $7939e29d663dd3ed$var$_extends.apply(this, arguments);
}
// Create react-specific types from the agnostic types in @remix-run/router to
// export from react-router
const $7939e29d663dd3ed$export$3add0d5dce533e2e = /*#__PURE__*/ $acw62.createContext(null);
const $7939e29d663dd3ed$export$145dfa71566a64dc = /*#__PURE__*/ $acw62.createContext(null);
const $7939e29d663dd3ed$var$AwaitContext = /*#__PURE__*/ $acw62.createContext(null);
/**
 * A Navigator is a "location changer"; it's how you get to different locations.
 *
 * Every history instance conforms to the Navigator interface, but the
 * distinction is useful primarily when it comes to the low-level `<Router>` API
 * where both the location and a navigator must be provided separately in order
 * to avoid "tearing" that may occur in a suspense-enabled app if the action
 * and/or location were to be read directly from the history instance.
 */ const $7939e29d663dd3ed$export$26749e8557646306 = /*#__PURE__*/ $acw62.createContext(null);
const $7939e29d663dd3ed$export$c7914228fb69b0f5 = /*#__PURE__*/ $acw62.createContext(null);
const $7939e29d663dd3ed$export$9072aa6dd1f93057 = /*#__PURE__*/ $acw62.createContext({
    outlet: null,
    matches: [],
    isDataRoute: false
});
const $7939e29d663dd3ed$var$RouteErrorContext = /*#__PURE__*/ $acw62.createContext(null);
/**
 * Returns the full href for the given "to" value. This is useful for building
 * custom links that are also accessible and preserve right-click behavior.
 *
 * @see https://reactrouter.com/hooks/use-href
 */ function $7939e29d663dd3ed$export$b66bb29c5006f12f(to, _temp) {
    let { relative: relative } = _temp === void 0 ? {} : _temp;
    !$7939e29d663dd3ed$export$9c954a9d03d32f4a() && (0, $1d34d5c4a288b213$export$3e9cee6b33872309)(false);
    let { basename: basename, navigator: navigator } = $acw62.useContext($7939e29d663dd3ed$export$26749e8557646306);
    let { hash: hash, pathname: pathname, search: search } = $7939e29d663dd3ed$export$e75d2a2d1b3c245b(to, {
        relative: relative
    });
    let joinedPathname = pathname;
    // If we're operating within a basename, prepend it to the pathname prior
    // to creating the href.  If this is a root navigation, then just use the raw
    // basename which allows the basename to have full control over the presence
    // of a trailing slash on root links
    if (basename !== "/") joinedPathname = pathname === "/" ? basename : (0, $1d34d5c4a288b213$export$86d9a7913e44197e)([
        basename,
        pathname
    ]);
    return navigator.createHref({
        pathname: joinedPathname,
        search: search,
        hash: hash
    });
}
/**
 * Returns true if this component is a descendant of a `<Router>`.
 *
 * @see https://reactrouter.com/hooks/use-in-router-context
 */ function $7939e29d663dd3ed$export$9c954a9d03d32f4a() {
    return $acw62.useContext($7939e29d663dd3ed$export$c7914228fb69b0f5) != null;
}
/**
 * Returns the current location object, which represents the current URL in web
 * browsers.
 *
 * Note: If you're using this it may mean you're doing some of your own
 * "routing" in your app, and we'd like to know what your use case is. We may
 * be able to provide something higher-level to better suit your needs.
 *
 * @see https://reactrouter.com/hooks/use-location
 */ function $7939e29d663dd3ed$export$45d76561a5302f2b() {
    !$7939e29d663dd3ed$export$9c954a9d03d32f4a() && (0, $1d34d5c4a288b213$export$3e9cee6b33872309)(false);
    return $acw62.useContext($7939e29d663dd3ed$export$c7914228fb69b0f5).location;
}
/**
 * Returns the current navigation action which describes how the router came to
 * the current location, either by a pop, push, or replace on the history stack.
 *
 * @see https://reactrouter.com/hooks/use-navigation-type
 */ function $7939e29d663dd3ed$export$1b3f31771c5d07c() {
    return $acw62.useContext($7939e29d663dd3ed$export$c7914228fb69b0f5).navigationType;
}
/**
 * Returns a PathMatch object if the given pattern matches the current URL.
 * This is useful for components that need to know "active" state, e.g.
 * `<NavLink>`.
 *
 * @see https://reactrouter.com/hooks/use-match
 */ function $7939e29d663dd3ed$export$6c330e8992e8a295(pattern) {
    !$7939e29d663dd3ed$export$9c954a9d03d32f4a() && (0, $1d34d5c4a288b213$export$3e9cee6b33872309)(false);
    let { pathname: pathname } = $7939e29d663dd3ed$export$45d76561a5302f2b();
    return $acw62.useMemo(()=>(0, $1d34d5c4a288b213$export$81336c211d5ff295)(pattern, pathname), [
        pathname,
        pattern
    ]);
}
/**
 * The interface for the navigate() function returned from useNavigate().
 */ const $7939e29d663dd3ed$var$navigateEffectWarning = "You should call navigate() in a React.useEffect(), not when your component is first rendered.";
// Mute warnings for calls to useNavigate in SSR environments
function $7939e29d663dd3ed$var$useIsomorphicLayoutEffect(cb) {
    let isStatic = $acw62.useContext($7939e29d663dd3ed$export$26749e8557646306).static;
    if (!isStatic) // We should be able to get rid of this once react 18.3 is released
    // See: https://github.com/facebook/react/pull/26395
    // eslint-disable-next-line react-hooks/rules-of-hooks
    $acw62.useLayoutEffect(cb);
}
/**
 * Returns an imperative method for changing the location. Used by `<Link>`s, but
 * may also be used by other elements to change the location.
 *
 * @see https://reactrouter.com/hooks/use-navigate
 */ function $7939e29d663dd3ed$export$9770f232ac06a008() {
    let { isDataRoute: isDataRoute } = $acw62.useContext($7939e29d663dd3ed$export$9072aa6dd1f93057);
    // Conditional usage is OK here because the usage of a data router is static
    // eslint-disable-next-line react-hooks/rules-of-hooks
    return isDataRoute ? $7939e29d663dd3ed$var$useNavigateStable() : $7939e29d663dd3ed$var$useNavigateUnstable();
}
function $7939e29d663dd3ed$var$useNavigateUnstable() {
    !$7939e29d663dd3ed$export$9c954a9d03d32f4a() && (0, $1d34d5c4a288b213$export$3e9cee6b33872309)(false);
    let dataRouterContext = $acw62.useContext($7939e29d663dd3ed$export$3add0d5dce533e2e);
    let { basename: basename, navigator: navigator } = $acw62.useContext($7939e29d663dd3ed$export$26749e8557646306);
    let { matches: matches } = $acw62.useContext($7939e29d663dd3ed$export$9072aa6dd1f93057);
    let { pathname: locationPathname } = $7939e29d663dd3ed$export$45d76561a5302f2b();
    let routePathnamesJson = JSON.stringify((0, $1d34d5c4a288b213$export$90ba53ce1c7fdff2)(matches).map((match)=>match.pathnameBase));
    let activeRef = $acw62.useRef(false);
    $7939e29d663dd3ed$var$useIsomorphicLayoutEffect(()=>{
        activeRef.current = true;
    });
    let navigate = $acw62.useCallback(function(to, options) {
        if (options === void 0) options = {};
        // Short circuit here since if this happens on first render the navigate
        // is useless because we haven't wired up our history listener yet
        if (!activeRef.current) return;
        if (typeof to === "number") {
            navigator.go(to);
            return;
        }
        let path = (0, $1d34d5c4a288b213$export$cae722b0cc860f13)(to, JSON.parse(routePathnamesJson), locationPathname, options.relative === "path");
        // If we're operating within a basename, prepend it to the pathname prior
        // to handing off to history (but only if we're not in a data router,
        // otherwise it'll prepend the basename inside of the router).
        // If this is a root navigation, then we navigate to the raw basename
        // which allows the basename to have full control over the presence of a
        // trailing slash on root links
        if (dataRouterContext == null && basename !== "/") path.pathname = path.pathname === "/" ? basename : (0, $1d34d5c4a288b213$export$86d9a7913e44197e)([
            basename,
            path.pathname
        ]);
        (!!options.replace ? navigator.replace : navigator.push)(path, options.state, options);
    }, [
        basename,
        navigator,
        routePathnamesJson,
        locationPathname,
        dataRouterContext
    ]);
    return navigate;
}
const $7939e29d663dd3ed$var$OutletContext = /*#__PURE__*/ $acw62.createContext(null);
/**
 * Returns the context (if provided) for the child route at this level of the route
 * hierarchy.
 * @see https://reactrouter.com/hooks/use-outlet-context
 */ function $7939e29d663dd3ed$export$4138103a3ae699cc() {
    return $acw62.useContext($7939e29d663dd3ed$var$OutletContext);
}
/**
 * Returns the element for the child route at this level of the route
 * hierarchy. Used internally by `<Outlet>` to render child routes.
 *
 * @see https://reactrouter.com/hooks/use-outlet
 */ function $7939e29d663dd3ed$export$a3be3530d8e40d0b(context) {
    let outlet = $acw62.useContext($7939e29d663dd3ed$export$9072aa6dd1f93057).outlet;
    if (outlet) return /*#__PURE__*/ $acw62.createElement($7939e29d663dd3ed$var$OutletContext.Provider, {
        value: context
    }, outlet);
    return outlet;
}
/**
 * Returns an object of key/value pairs of the dynamic params from the current
 * URL that were matched by the route path.
 *
 * @see https://reactrouter.com/hooks/use-params
 */ function $7939e29d663dd3ed$export$99eaa27ddbbb95ef() {
    let { matches: matches } = $acw62.useContext($7939e29d663dd3ed$export$9072aa6dd1f93057);
    let routeMatch = matches[matches.length - 1];
    return routeMatch ? routeMatch.params : {};
}
/**
 * Resolves the pathname of the given `to` value against the current location.
 *
 * @see https://reactrouter.com/hooks/use-resolved-path
 */ function $7939e29d663dd3ed$export$e75d2a2d1b3c245b(to, _temp2) {
    let { relative: relative } = _temp2 === void 0 ? {} : _temp2;
    let { matches: matches } = $acw62.useContext($7939e29d663dd3ed$export$9072aa6dd1f93057);
    let { pathname: locationPathname } = $7939e29d663dd3ed$export$45d76561a5302f2b();
    let routePathnamesJson = JSON.stringify((0, $1d34d5c4a288b213$export$90ba53ce1c7fdff2)(matches).map((match)=>match.pathnameBase));
    return $acw62.useMemo(()=>(0, $1d34d5c4a288b213$export$cae722b0cc860f13)(to, JSON.parse(routePathnamesJson), locationPathname, relative === "path"), [
        to,
        routePathnamesJson,
        locationPathname,
        relative
    ]);
}
/**
 * Returns the element of the route that matched the current location, prepared
 * with the correct context to render the remainder of the route tree. Route
 * elements in the tree must render an `<Outlet>` to render their child route's
 * element.
 *
 * @see https://reactrouter.com/hooks/use-routes
 */ function $7939e29d663dd3ed$export$5d3fca4a98652595(routes, locationArg) {
    return $7939e29d663dd3ed$export$5fcee62552a12fbf(routes, locationArg);
}
// Internal implementation with accept optional param for RouterProvider usage
function $7939e29d663dd3ed$export$5fcee62552a12fbf(routes, locationArg, dataRouterState) {
    !$7939e29d663dd3ed$export$9c954a9d03d32f4a() && (0, $1d34d5c4a288b213$export$3e9cee6b33872309)(false);
    let { navigator: navigator } = $acw62.useContext($7939e29d663dd3ed$export$26749e8557646306);
    let { matches: parentMatches } = $acw62.useContext($7939e29d663dd3ed$export$9072aa6dd1f93057);
    let routeMatch = parentMatches[parentMatches.length - 1];
    let parentParams = routeMatch ? routeMatch.params : {};
    let parentPathname = routeMatch ? routeMatch.pathname : "/";
    let parentPathnameBase = routeMatch ? routeMatch.pathnameBase : "/";
    let parentRoute = routeMatch && routeMatch.route;
    let locationFromContext = $7939e29d663dd3ed$export$45d76561a5302f2b();
    let location;
    if (locationArg) {
        var _parsedLocationArg$pa;
        let parsedLocationArg = typeof locationArg === "string" ? (0, $1d34d5c4a288b213$export$8ccf933b0513f8d0)(locationArg) : locationArg;
        !(parentPathnameBase === "/" || ((_parsedLocationArg$pa = parsedLocationArg.pathname) == null ? void 0 : _parsedLocationArg$pa.startsWith(parentPathnameBase))) && (0, $1d34d5c4a288b213$export$3e9cee6b33872309)(false);
        location = parsedLocationArg;
    } else location = locationFromContext;
    let pathname = location.pathname || "/";
    let remainingPathname = parentPathnameBase === "/" ? pathname : pathname.slice(parentPathnameBase.length) || "/";
    let matches = (0, $1d34d5c4a288b213$export$2708184779ceb39d)(routes, {
        pathname: remainingPathname
    });
    let renderedMatches = $7939e29d663dd3ed$var$_renderMatches(matches && matches.map((match)=>Object.assign({}, match, {
            params: Object.assign({}, parentParams, match.params),
            pathname: (0, $1d34d5c4a288b213$export$86d9a7913e44197e)([
                parentPathnameBase,
                // Re-encode pathnames that were decoded inside matchRoutes
                navigator.encodeLocation ? navigator.encodeLocation(match.pathname).pathname : match.pathname
            ]),
            pathnameBase: match.pathnameBase === "/" ? parentPathnameBase : (0, $1d34d5c4a288b213$export$86d9a7913e44197e)([
                parentPathnameBase,
                // Re-encode pathnames that were decoded inside matchRoutes
                navigator.encodeLocation ? navigator.encodeLocation(match.pathnameBase).pathname : match.pathnameBase
            ])
        })), parentMatches, dataRouterState);
    // When a user passes in a `locationArg`, the associated routes need to
    // be wrapped in a new `LocationContext.Provider` in order for `useLocation`
    // to use the scoped location instead of the global location.
    if (locationArg && renderedMatches) return /*#__PURE__*/ $acw62.createElement($7939e29d663dd3ed$export$c7914228fb69b0f5.Provider, {
        value: {
            location: $7939e29d663dd3ed$var$_extends({
                pathname: "/",
                search: "",
                hash: "",
                state: null,
                key: "default"
            }, location),
            navigationType: (0, $1d34d5c4a288b213$export$e19cd5f9376f8cee).Pop
        }
    }, renderedMatches);
    return renderedMatches;
}
function $7939e29d663dd3ed$var$DefaultErrorComponent() {
    let error = $7939e29d663dd3ed$export$ed527bf60f6e05f2();
    let message = (0, $1d34d5c4a288b213$export$972111febbeef05b)(error) ? error.status + " " + error.statusText : error instanceof Error ? error.message : JSON.stringify(error);
    let stack = error instanceof Error ? error.stack : null;
    let lightgrey = "rgba(200,200,200, 0.5)";
    let preStyles = {
        padding: "0.5rem",
        backgroundColor: lightgrey
    };
    let codeStyles = {
        padding: "2px 4px",
        backgroundColor: lightgrey
    };
    let devInfo = null;
    return /*#__PURE__*/ $acw62.createElement($acw62.Fragment, null, /*#__PURE__*/ $acw62.createElement("h2", null, "Unexpected Application Error!"), /*#__PURE__*/ $acw62.createElement("h3", {
        style: {
            fontStyle: "italic"
        }
    }, message), stack ? /*#__PURE__*/ $acw62.createElement("pre", {
        style: preStyles
    }, stack) : null, devInfo);
}
const $7939e29d663dd3ed$var$defaultErrorElement = /*#__PURE__*/ $acw62.createElement($7939e29d663dd3ed$var$DefaultErrorComponent, null);
class $7939e29d663dd3ed$var$RenderErrorBoundary extends $acw62.Component {
    constructor(props){
        super(props);
        this.state = {
            location: props.location,
            revalidation: props.revalidation,
            error: props.error
        };
    }
    static getDerivedStateFromError(error) {
        return {
            error: error
        };
    }
    static getDerivedStateFromProps(props, state) {
        // When we get into an error state, the user will likely click "back" to the
        // previous page that didn't have an error. Because this wraps the entire
        // application, that will have no effect--the error page continues to display.
        // This gives us a mechanism to recover from the error when the location changes.
        //
        // Whether we're in an error state or not, we update the location in state
        // so that when we are in an error state, it gets reset when a new location
        // comes in and the user recovers from the error.
        if (state.location !== props.location || state.revalidation !== "idle" && props.revalidation === "idle") return {
            error: props.error,
            location: props.location,
            revalidation: props.revalidation
        };
        // If we're not changing locations, preserve the location but still surface
        // any new errors that may come through. We retain the existing error, we do
        // this because the error provided from the app state may be cleared without
        // the location changing.
        return {
            error: props.error || state.error,
            location: state.location,
            revalidation: props.revalidation || state.revalidation
        };
    }
    componentDidCatch(error, errorInfo) {
        console.error("React Router caught the following error during render", error, errorInfo);
    }
    render() {
        return this.state.error ? /*#__PURE__*/ $acw62.createElement($7939e29d663dd3ed$export$9072aa6dd1f93057.Provider, {
            value: this.props.routeContext
        }, /*#__PURE__*/ $acw62.createElement($7939e29d663dd3ed$var$RouteErrorContext.Provider, {
            value: this.state.error,
            children: this.props.component
        })) : this.props.children;
    }
}
function $7939e29d663dd3ed$var$RenderedRoute(_ref) {
    let { routeContext: routeContext, match: match, children: children } = _ref;
    let dataRouterContext = $acw62.useContext($7939e29d663dd3ed$export$3add0d5dce533e2e);
    // Track how deep we got in our render pass to emulate SSR componentDidCatch
    // in a DataStaticRouter
    if (dataRouterContext && dataRouterContext.static && dataRouterContext.staticContext && (match.route.errorElement || match.route.ErrorBoundary)) dataRouterContext.staticContext._deepestRenderedBoundaryId = match.route.id;
    return /*#__PURE__*/ $acw62.createElement($7939e29d663dd3ed$export$9072aa6dd1f93057.Provider, {
        value: routeContext
    }, children);
}
function $7939e29d663dd3ed$var$_renderMatches(matches, parentMatches, dataRouterState) {
    var _dataRouterState2;
    if (parentMatches === void 0) parentMatches = [];
    if (dataRouterState === void 0) dataRouterState = null;
    if (matches == null) {
        var _dataRouterState;
        if ((_dataRouterState = dataRouterState) != null && _dataRouterState.errors) // Don't bail if we have data router errors so we can render them in the
        // boundary.  Use the pre-matched (or shimmed) matches
        matches = dataRouterState.matches;
        else return null;
    }
    let renderedMatches = matches;
    // If we have data errors, trim matches to the highest error boundary
    let errors = (_dataRouterState2 = dataRouterState) == null ? void 0 : _dataRouterState2.errors;
    if (errors != null) {
        let errorIndex = renderedMatches.findIndex((m)=>m.route.id && (errors == null ? void 0 : errors[m.route.id]));
        !(errorIndex >= 0) && (0, $1d34d5c4a288b213$export$3e9cee6b33872309)(false);
        renderedMatches = renderedMatches.slice(0, Math.min(renderedMatches.length, errorIndex + 1));
    }
    return renderedMatches.reduceRight((outlet, match, index)=>{
        let error = match.route.id ? errors == null ? void 0 : errors[match.route.id] : null;
        // Only data routers handle errors
        let errorElement = null;
        if (dataRouterState) errorElement = match.route.errorElement || $7939e29d663dd3ed$var$defaultErrorElement;
        let matches = parentMatches.concat(renderedMatches.slice(0, index + 1));
        let getChildren = ()=>{
            let children;
            if (error) children = errorElement;
            else if (match.route.Component) // Note: This is a de-optimized path since React won't re-use the
            // ReactElement since it's identity changes with each new
            // React.createElement call.  We keep this so folks can use
            // `<Route Component={...}>` in `<Routes>` but generally `Component`
            // usage is only advised in `RouterProvider` when we can convert it to
            // `element` ahead of time.
            children = /*#__PURE__*/ $acw62.createElement(match.route.Component, null);
            else if (match.route.element) children = match.route.element;
            else children = outlet;
            return /*#__PURE__*/ $acw62.createElement($7939e29d663dd3ed$var$RenderedRoute, {
                match: match,
                routeContext: {
                    outlet: outlet,
                    matches: matches,
                    isDataRoute: dataRouterState != null
                },
                children: children
            });
        };
        // Only wrap in an error boundary within data router usages when we have an
        // ErrorBoundary/errorElement on this route.  Otherwise let it bubble up to
        // an ancestor ErrorBoundary/errorElement
        return dataRouterState && (match.route.ErrorBoundary || match.route.errorElement || index === 0) ? /*#__PURE__*/ $acw62.createElement($7939e29d663dd3ed$var$RenderErrorBoundary, {
            location: dataRouterState.location,
            revalidation: dataRouterState.revalidation,
            component: errorElement,
            error: error,
            children: getChildren(),
            routeContext: {
                outlet: null,
                matches: matches,
                isDataRoute: true
            }
        }) : getChildren();
    }, null);
}
var $7939e29d663dd3ed$var$DataRouterHook = /*#__PURE__*/ function(DataRouterHook) {
    DataRouterHook["UseBlocker"] = "useBlocker";
    DataRouterHook["UseRevalidator"] = "useRevalidator";
    DataRouterHook["UseNavigateStable"] = "useNavigate";
    return DataRouterHook;
}($7939e29d663dd3ed$var$DataRouterHook || {});
var $7939e29d663dd3ed$var$DataRouterStateHook = /*#__PURE__*/ function(DataRouterStateHook) {
    DataRouterStateHook["UseBlocker"] = "useBlocker";
    DataRouterStateHook["UseLoaderData"] = "useLoaderData";
    DataRouterStateHook["UseActionData"] = "useActionData";
    DataRouterStateHook["UseRouteError"] = "useRouteError";
    DataRouterStateHook["UseNavigation"] = "useNavigation";
    DataRouterStateHook["UseRouteLoaderData"] = "useRouteLoaderData";
    DataRouterStateHook["UseMatches"] = "useMatches";
    DataRouterStateHook["UseRevalidator"] = "useRevalidator";
    DataRouterStateHook["UseNavigateStable"] = "useNavigate";
    DataRouterStateHook["UseRouteId"] = "useRouteId";
    return DataRouterStateHook;
}($7939e29d663dd3ed$var$DataRouterStateHook || {});
function $7939e29d663dd3ed$var$getDataRouterConsoleError(hookName) {
    return hookName + " must be used within a data router.  See https://reactrouter.com/routers/picking-a-router.";
}
function $7939e29d663dd3ed$var$useDataRouterContext(hookName) {
    let ctx = $acw62.useContext($7939e29d663dd3ed$export$3add0d5dce533e2e);
    !ctx && (0, $1d34d5c4a288b213$export$3e9cee6b33872309)(false);
    return ctx;
}
function $7939e29d663dd3ed$var$useDataRouterState(hookName) {
    let state = $acw62.useContext($7939e29d663dd3ed$export$145dfa71566a64dc);
    !state && (0, $1d34d5c4a288b213$export$3e9cee6b33872309)(false);
    return state;
}
function $7939e29d663dd3ed$var$useRouteContext(hookName) {
    let route = $acw62.useContext($7939e29d663dd3ed$export$9072aa6dd1f93057);
    !route && (0, $1d34d5c4a288b213$export$3e9cee6b33872309)(false);
    return route;
}
// Internal version with hookName-aware debugging
function $7939e29d663dd3ed$var$useCurrentRouteId(hookName) {
    let route = $7939e29d663dd3ed$var$useRouteContext(hookName);
    let thisRoute = route.matches[route.matches.length - 1];
    !thisRoute.route.id && (0, $1d34d5c4a288b213$export$3e9cee6b33872309)(false);
    return thisRoute.route.id;
}
/**
 * Returns the ID for the nearest contextual route
 */ function $7939e29d663dd3ed$export$5fc8298006ad9e58() {
    return $7939e29d663dd3ed$var$useCurrentRouteId($7939e29d663dd3ed$var$DataRouterStateHook.UseRouteId);
}
/**
 * Returns the current navigation, defaulting to an "idle" navigation when
 * no navigation is in progress
 */ function $7939e29d663dd3ed$export$d0fd4b7106de2769() {
    let state = $7939e29d663dd3ed$var$useDataRouterState($7939e29d663dd3ed$var$DataRouterStateHook.UseNavigation);
    return state.navigation;
}
/**
 * Returns a revalidate function for manually triggering revalidation, as well
 * as the current state of any manual revalidations
 */ function $7939e29d663dd3ed$export$600dc272ed516c15() {
    let dataRouterContext = $7939e29d663dd3ed$var$useDataRouterContext($7939e29d663dd3ed$var$DataRouterHook.UseRevalidator);
    let state = $7939e29d663dd3ed$var$useDataRouterState($7939e29d663dd3ed$var$DataRouterStateHook.UseRevalidator);
    return $acw62.useMemo(()=>({
            revalidate: dataRouterContext.router.revalidate,
            state: state.revalidation
        }), [
        dataRouterContext.router.revalidate,
        state.revalidation
    ]);
}
/**
 * Returns the active route matches, useful for accessing loaderData for
 * parent/child routes or the route "handle" property
 */ function $7939e29d663dd3ed$export$2378eb7f5ff86053() {
    let { matches: matches, loaderData: loaderData } = $7939e29d663dd3ed$var$useDataRouterState($7939e29d663dd3ed$var$DataRouterStateHook.UseMatches);
    return $acw62.useMemo(()=>matches.map((m)=>(0, $1d34d5c4a288b213$export$b3fac024fad9e8ff)(m, loaderData)), [
        matches,
        loaderData
    ]);
}
/**
 * Returns the loader data for the nearest ancestor Route loader
 */ function $7939e29d663dd3ed$export$1448a5050d252c4d() {
    let state = $7939e29d663dd3ed$var$useDataRouterState($7939e29d663dd3ed$var$DataRouterStateHook.UseLoaderData);
    let routeId = $7939e29d663dd3ed$var$useCurrentRouteId($7939e29d663dd3ed$var$DataRouterStateHook.UseLoaderData);
    if (state.errors && state.errors[routeId] != null) {
        console.error("You cannot `useLoaderData` in an errorElement (routeId: " + routeId + ")");
        return undefined;
    }
    return state.loaderData[routeId];
}
/**
 * Returns the loaderData for the given routeId
 */ function $7939e29d663dd3ed$export$fd5d37484eab868d(routeId) {
    let state = $7939e29d663dd3ed$var$useDataRouterState($7939e29d663dd3ed$var$DataRouterStateHook.UseRouteLoaderData);
    return state.loaderData[routeId];
}
/**
 * Returns the action data for the nearest ancestor Route action
 */ function $7939e29d663dd3ed$export$fdc00f3f26066d5e() {
    let state = $7939e29d663dd3ed$var$useDataRouterState($7939e29d663dd3ed$var$DataRouterStateHook.UseActionData);
    let route = $acw62.useContext($7939e29d663dd3ed$export$9072aa6dd1f93057);
    !route && (0, $1d34d5c4a288b213$export$3e9cee6b33872309)(false);
    return Object.values((state == null ? void 0 : state.actionData) || {})[0];
}
/**
 * Returns the nearest ancestor Route error, which could be a loader/action
 * error or a render error.  This is intended to be called from your
 * ErrorBoundary/errorElement to display a proper error message.
 */ function $7939e29d663dd3ed$export$ed527bf60f6e05f2() {
    var _state$errors;
    let error = $acw62.useContext($7939e29d663dd3ed$var$RouteErrorContext);
    let state = $7939e29d663dd3ed$var$useDataRouterState($7939e29d663dd3ed$var$DataRouterStateHook.UseRouteError);
    let routeId = $7939e29d663dd3ed$var$useCurrentRouteId($7939e29d663dd3ed$var$DataRouterStateHook.UseRouteError);
    // If this was a render error, we put it in a RouteError context inside
    // of RenderErrorBoundary
    if (error) return error;
    // Otherwise look for errors from our data router state
    return (_state$errors = state.errors) == null ? void 0 : _state$errors[routeId];
}
/**
 * Returns the happy-path data from the nearest ancestor `<Await />` value
 */ function $7939e29d663dd3ed$export$78a72ddb39bdd145() {
    let value = $acw62.useContext($7939e29d663dd3ed$var$AwaitContext);
    return value == null ? void 0 : value._data;
}
/**
 * Returns the error from the nearest ancestor `<Await />` value
 */ function $7939e29d663dd3ed$export$17f53340677d5831() {
    let value = $acw62.useContext($7939e29d663dd3ed$var$AwaitContext);
    return value == null ? void 0 : value._error;
}
let $7939e29d663dd3ed$var$blockerId = 0;
/**
 * Allow the application to block navigations within the SPA and present the
 * user a confirmation dialog to confirm the navigation.  Mostly used to avoid
 * using half-filled form data.  This does not handle hard-reloads or
 * cross-origin navigations.
 */ function $7939e29d663dd3ed$export$2af03a1de5c0910(shouldBlock) {
    let { router: router, basename: basename } = $7939e29d663dd3ed$var$useDataRouterContext($7939e29d663dd3ed$var$DataRouterHook.UseBlocker);
    let state = $7939e29d663dd3ed$var$useDataRouterState($7939e29d663dd3ed$var$DataRouterStateHook.UseBlocker);
    let [blockerKey, setBlockerKey] = $acw62.useState("");
    let blockerFunction = $acw62.useCallback((arg)=>{
        if (typeof shouldBlock !== "function") return !!shouldBlock;
        if (basename === "/") return shouldBlock(arg);
        // If they provided us a function and we've got an active basename, strip
        // it from the locations we expose to the user to match the behavior of
        // useLocation
        let { currentLocation: currentLocation, nextLocation: nextLocation, historyAction: historyAction } = arg;
        return shouldBlock({
            currentLocation: $7939e29d663dd3ed$var$_extends({}, currentLocation, {
                pathname: (0, $1d34d5c4a288b213$export$b69e3301ce081aa3)(currentLocation.pathname, basename) || currentLocation.pathname
            }),
            nextLocation: $7939e29d663dd3ed$var$_extends({}, nextLocation, {
                pathname: (0, $1d34d5c4a288b213$export$b69e3301ce081aa3)(nextLocation.pathname, basename) || nextLocation.pathname
            }),
            historyAction: historyAction
        });
    }, [
        basename,
        shouldBlock
    ]);
    // This effect is in charge of blocker key assignment and deletion (which is
    // tightly coupled to the key)
    $acw62.useEffect(()=>{
        let key = String(++$7939e29d663dd3ed$var$blockerId);
        setBlockerKey(key);
        return ()=>router.deleteBlocker(key);
    }, [
        router
    ]);
    // This effect handles assigning the blockerFunction.  This is to handle
    // unstable blocker function identities, and happens only after the prior
    // effect so we don't get an orphaned blockerFunction in the router with a
    // key of "".  Until then we just have the IDLE_BLOCKER.
    $acw62.useEffect(()=>{
        if (blockerKey !== "") router.getBlocker(blockerKey, blockerFunction);
    }, [
        router,
        blockerKey,
        blockerFunction
    ]);
    // Prefer the blocker from `state` not `router.state` since DataRouterContext
    // is memoized so this ensures we update on blocker state updates
    return blockerKey && state.blockers.has(blockerKey) ? state.blockers.get(blockerKey) : (0, $1d34d5c4a288b213$export$386d57f03f0b2883);
}
/**
 * Stable version of useNavigate that is used when we are in the context of
 * a RouterProvider.
 */ function $7939e29d663dd3ed$var$useNavigateStable() {
    let { router: router } = $7939e29d663dd3ed$var$useDataRouterContext($7939e29d663dd3ed$var$DataRouterHook.UseNavigateStable);
    let id = $7939e29d663dd3ed$var$useCurrentRouteId($7939e29d663dd3ed$var$DataRouterStateHook.UseNavigateStable);
    let activeRef = $acw62.useRef(false);
    $7939e29d663dd3ed$var$useIsomorphicLayoutEffect(()=>{
        activeRef.current = true;
    });
    let navigate = $acw62.useCallback(function(to, options) {
        if (options === void 0) options = {};
        // Short circuit here since if this happens on first render the navigate
        // is useless because we haven't wired up our router subscriber yet
        if (!activeRef.current) return;
        if (typeof to === "number") router.navigate(to);
        else router.navigate(to, $7939e29d663dd3ed$var$_extends({
            fromRouteId: id
        }, options));
    }, [
        router,
        id
    ]);
    return navigate;
}
const $7939e29d663dd3ed$var$alreadyWarned = {};
function $7939e29d663dd3ed$var$warningOnce(key, cond, message) {
    if (!cond && !$7939e29d663dd3ed$var$alreadyWarned[key]) $7939e29d663dd3ed$var$alreadyWarned[key] = true;
}
/**
  Webpack + React 17 fails to compile on any of the following because webpack
  complains that `startTransition` doesn't exist in `React`:
  * import { startTransition } from "react"
  * import * as React from from "react";
    "startTransition" in React ? React.startTransition(() => setState()) : setState()
  * import * as React from from "react";
    "startTransition" in React ? React["startTransition"](() => setState()) : setState()

  Moving it to a constant such as the following solves the Webpack/React 17 issue:
  * import * as React from from "react";
    const START_TRANSITION = "startTransition";
    START_TRANSITION in React ? React[START_TRANSITION](() => setState()) : setState()

  However, that introduces webpack/terser minification issues in production builds
  in React 18 where minification/obfuscation ends up removing the call of
  React.startTransition entirely from the first half of the ternary.  Grabbing
  this exported reference once up front resolves that issue.

  See https://github.com/remix-run/react-router/issues/10579
*/ const $7939e29d663dd3ed$var$START_TRANSITION = "startTransition";
const $7939e29d663dd3ed$var$startTransitionImpl = $acw62[$7939e29d663dd3ed$var$START_TRANSITION];
/**
 * Given a Remix Router instance, render the appropriate UI
 */ function $7939e29d663dd3ed$export$323e4fc2fa4753fb(_ref) {
    let { fallbackElement: fallbackElement, router: router, future: future } = _ref;
    let [state, setStateImpl] = $acw62.useState(router.state);
    let { v7_startTransition: v7_startTransition } = future || {};
    let setState = $acw62.useCallback((newState)=>{
        if (v7_startTransition && $7939e29d663dd3ed$var$startTransitionImpl) $7939e29d663dd3ed$var$startTransitionImpl(()=>setStateImpl(newState));
        else setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    // Need to use a layout effect here so we are subscribed early enough to
    // pick up on any render-driven redirects/navigations (useEffect/<Navigate>)
    $acw62.useLayoutEffect(()=>router.subscribe(setState), [
        router,
        setState
    ]);
    let navigator = $acw62.useMemo(()=>{
        return {
            createHref: router.createHref,
            encodeLocation: router.encodeLocation,
            go: (n)=>router.navigate(n),
            push: (to, state, opts)=>router.navigate(to, {
                    state: state,
                    preventScrollReset: opts == null ? void 0 : opts.preventScrollReset
                }),
            replace: (to, state, opts)=>router.navigate(to, {
                    replace: true,
                    state: state,
                    preventScrollReset: opts == null ? void 0 : opts.preventScrollReset
                })
        };
    }, [
        router
    ]);
    let basename = router.basename || "/";
    let dataRouterContext = $acw62.useMemo(()=>({
            router: router,
            navigator: navigator,
            static: false,
            basename: basename
        }), [
        router,
        navigator,
        basename
    ]);
    // The fragment and {null} here are important!  We need them to keep React 18's
    // useId happy when we are server-rendering since we may have a <script> here
    // containing the hydrated server-side staticContext (from StaticRouterProvider).
    // useId relies on the component tree structure to generate deterministic id's
    // so we need to ensure it remains the same on the client even though
    // we don't need the <script> tag
    return /*#__PURE__*/ $acw62.createElement($acw62.Fragment, null, /*#__PURE__*/ $acw62.createElement($7939e29d663dd3ed$export$3add0d5dce533e2e.Provider, {
        value: dataRouterContext
    }, /*#__PURE__*/ $acw62.createElement($7939e29d663dd3ed$export$145dfa71566a64dc.Provider, {
        value: state
    }, /*#__PURE__*/ $acw62.createElement($7939e29d663dd3ed$export$55185c17a0fcbe46, {
        basename: basename,
        location: state.location,
        navigationType: state.historyAction,
        navigator: navigator
    }, state.initialized ? /*#__PURE__*/ $acw62.createElement($7939e29d663dd3ed$var$DataRoutes, {
        routes: router.routes,
        state: state
    }) : fallbackElement))), null);
}
function $7939e29d663dd3ed$var$DataRoutes(_ref2) {
    let { routes: routes, state: state } = _ref2;
    return $7939e29d663dd3ed$export$5fcee62552a12fbf(routes, undefined, state);
}
/**
 * A `<Router>` that stores all entries in memory.
 *
 * @see https://reactrouter.com/router-components/memory-router
 */ function $7939e29d663dd3ed$export$ae46f04cfaffe093(_ref3) {
    let { basename: basename, children: children, initialEntries: initialEntries, initialIndex: initialIndex, future: future } = _ref3;
    let historyRef = $acw62.useRef();
    if (historyRef.current == null) historyRef.current = (0, $1d34d5c4a288b213$export$2b76ad033c6e6d08)({
        initialEntries: initialEntries,
        initialIndex: initialIndex,
        v5Compat: true
    });
    let history = historyRef.current;
    let [state, setStateImpl] = $acw62.useState({
        action: history.action,
        location: history.location
    });
    let { v7_startTransition: v7_startTransition } = future || {};
    let setState = $acw62.useCallback((newState)=>{
        v7_startTransition && $7939e29d663dd3ed$var$startTransitionImpl ? $7939e29d663dd3ed$var$startTransitionImpl(()=>setStateImpl(newState)) : setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    $acw62.useLayoutEffect(()=>history.listen(setState), [
        history,
        setState
    ]);
    return /*#__PURE__*/ $acw62.createElement($7939e29d663dd3ed$export$55185c17a0fcbe46, {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history
    });
}
/**
 * Changes the current location.
 *
 * Note: This API is mostly useful in React.Component subclasses that are not
 * able to use hooks. In functional components, we recommend you use the
 * `useNavigate` hook instead.
 *
 * @see https://reactrouter.com/components/navigate
 */ function $7939e29d663dd3ed$export$444b3ab0cb9aec40(_ref4) {
    let { to: to, replace: replace, state: state, relative: relative } = _ref4;
    !$7939e29d663dd3ed$export$9c954a9d03d32f4a() && (0, $1d34d5c4a288b213$export$3e9cee6b33872309)(false);
    let { matches: matches } = $acw62.useContext($7939e29d663dd3ed$export$9072aa6dd1f93057);
    let { pathname: locationPathname } = $7939e29d663dd3ed$export$45d76561a5302f2b();
    let navigate = $7939e29d663dd3ed$export$9770f232ac06a008();
    // Resolve the path outside of the effect so that when effects run twice in
    // StrictMode they navigate to the same place
    let path = (0, $1d34d5c4a288b213$export$cae722b0cc860f13)(to, (0, $1d34d5c4a288b213$export$90ba53ce1c7fdff2)(matches).map((match)=>match.pathnameBase), locationPathname, relative === "path");
    let jsonPath = JSON.stringify(path);
    $acw62.useEffect(()=>navigate(JSON.parse(jsonPath), {
            replace: replace,
            state: state,
            relative: relative
        }), [
        navigate,
        jsonPath,
        relative,
        replace,
        state
    ]);
    return null;
}
/**
 * Renders the child route's element, if there is one.
 *
 * @see https://reactrouter.com/components/outlet
 */ function $7939e29d663dd3ed$export$910ae8079b2c2852(props) {
    return $7939e29d663dd3ed$export$a3be3530d8e40d0b(props.context);
}
/**
 * Declares an element that should be rendered at a certain URL path.
 *
 * @see https://reactrouter.com/components/route
 */ function $7939e29d663dd3ed$export$e7b0ac011bb776c6(_props) {
    (0, $1d34d5c4a288b213$export$3e9cee6b33872309)(false);
}
/**
 * Provides location context for the rest of the app.
 *
 * Note: You usually won't render a `<Router>` directly. Instead, you'll render a
 * router that is more specific to your environment such as a `<BrowserRouter>`
 * in web browsers or a `<StaticRouter>` for server rendering.
 *
 * @see https://reactrouter.com/router-components/router
 */ function $7939e29d663dd3ed$export$55185c17a0fcbe46(_ref5) {
    let { basename: basenameProp = "/", children: children = null, location: locationProp, navigationType: navigationType = (0, $1d34d5c4a288b213$export$e19cd5f9376f8cee).Pop, navigator: navigator, static: staticProp = false } = _ref5;
    !!$7939e29d663dd3ed$export$9c954a9d03d32f4a() && (0, $1d34d5c4a288b213$export$3e9cee6b33872309)(false);
    // Preserve trailing slashes on basename, so we can let the user control
    // the enforcement of trailing slashes throughout the app
    let basename = basenameProp.replace(/^\/*/, "/");
    let navigationContext = $acw62.useMemo(()=>({
            basename: basename,
            navigator: navigator,
            static: staticProp
        }), [
        basename,
        navigator,
        staticProp
    ]);
    if (typeof locationProp === "string") locationProp = (0, $1d34d5c4a288b213$export$8ccf933b0513f8d0)(locationProp);
    let { pathname: pathname = "/", search: search = "", hash: hash = "", state: state = null, key: key = "default" } = locationProp;
    let locationContext = $acw62.useMemo(()=>{
        let trailingPathname = (0, $1d34d5c4a288b213$export$b69e3301ce081aa3)(pathname, basename);
        if (trailingPathname == null) return null;
        return {
            location: {
                pathname: trailingPathname,
                search: search,
                hash: hash,
                state: state,
                key: key
            },
            navigationType: navigationType
        };
    }, [
        basename,
        pathname,
        search,
        hash,
        state,
        key,
        navigationType
    ]);
    if (locationContext == null) return null;
    return /*#__PURE__*/ $acw62.createElement($7939e29d663dd3ed$export$26749e8557646306.Provider, {
        value: navigationContext
    }, /*#__PURE__*/ $acw62.createElement($7939e29d663dd3ed$export$c7914228fb69b0f5.Provider, {
        children: children,
        value: locationContext
    }));
}
/**
 * A container for a nested tree of `<Route>` elements that renders the branch
 * that best matches the current location.
 *
 * @see https://reactrouter.com/components/routes
 */ function $7939e29d663dd3ed$export$3565eb3d00ca5a74(_ref6) {
    let { children: children, location: location } = _ref6;
    return $7939e29d663dd3ed$export$5d3fca4a98652595($7939e29d663dd3ed$export$16da398f5434bdec(children), location);
}
/**
 * Component to use for rendering lazily loaded data from returning defer()
 * in a loader function
 */ function $7939e29d663dd3ed$export$6ddabde395c8c576(_ref7) {
    let { children: children, errorElement: errorElement, resolve: resolve } = _ref7;
    return /*#__PURE__*/ $acw62.createElement($7939e29d663dd3ed$var$AwaitErrorBoundary, {
        resolve: resolve,
        errorElement: errorElement
    }, /*#__PURE__*/ $acw62.createElement($7939e29d663dd3ed$var$ResolveAwait, null, children));
}
var $7939e29d663dd3ed$var$AwaitRenderStatus = /*#__PURE__*/ function(AwaitRenderStatus) {
    AwaitRenderStatus[AwaitRenderStatus["pending"] = 0] = "pending";
    AwaitRenderStatus[AwaitRenderStatus["success"] = 1] = "success";
    AwaitRenderStatus[AwaitRenderStatus["error"] = 2] = "error";
    return AwaitRenderStatus;
}($7939e29d663dd3ed$var$AwaitRenderStatus || {});
const $7939e29d663dd3ed$var$neverSettledPromise = new Promise(()=>{});
class $7939e29d663dd3ed$var$AwaitErrorBoundary extends $acw62.Component {
    constructor(props){
        super(props);
        this.state = {
            error: null
        };
    }
    static getDerivedStateFromError(error) {
        return {
            error: error
        };
    }
    componentDidCatch(error, errorInfo) {
        console.error("<Await> caught the following error during render", error, errorInfo);
    }
    render() {
        let { children: children, errorElement: errorElement, resolve: resolve } = this.props;
        let promise = null;
        let status = $7939e29d663dd3ed$var$AwaitRenderStatus.pending;
        if (!(resolve instanceof Promise)) {
            // Didn't get a promise - provide as a resolved promise
            status = $7939e29d663dd3ed$var$AwaitRenderStatus.success;
            promise = Promise.resolve();
            Object.defineProperty(promise, "_tracked", {
                get: ()=>true
            });
            Object.defineProperty(promise, "_data", {
                get: ()=>resolve
            });
        } else if (this.state.error) {
            // Caught a render error, provide it as a rejected promise
            status = $7939e29d663dd3ed$var$AwaitRenderStatus.error;
            let renderError = this.state.error;
            promise = Promise.reject().catch(()=>{}); // Avoid unhandled rejection warnings
            Object.defineProperty(promise, "_tracked", {
                get: ()=>true
            });
            Object.defineProperty(promise, "_error", {
                get: ()=>renderError
            });
        } else if (resolve._tracked) {
            // Already tracked promise - check contents
            promise = resolve;
            status = promise._error !== undefined ? $7939e29d663dd3ed$var$AwaitRenderStatus.error : promise._data !== undefined ? $7939e29d663dd3ed$var$AwaitRenderStatus.success : $7939e29d663dd3ed$var$AwaitRenderStatus.pending;
        } else {
            // Raw (untracked) promise - track it
            status = $7939e29d663dd3ed$var$AwaitRenderStatus.pending;
            Object.defineProperty(resolve, "_tracked", {
                get: ()=>true
            });
            promise = resolve.then((data)=>Object.defineProperty(resolve, "_data", {
                    get: ()=>data
                }), (error)=>Object.defineProperty(resolve, "_error", {
                    get: ()=>error
                }));
        }
        if (status === $7939e29d663dd3ed$var$AwaitRenderStatus.error && promise._error instanceof (0, $1d34d5c4a288b213$export$42a99a7a4bc0e76a)) // Freeze the UI by throwing a never resolved promise
        throw $7939e29d663dd3ed$var$neverSettledPromise;
        if (status === $7939e29d663dd3ed$var$AwaitRenderStatus.error && !errorElement) // No errorElement, throw to the nearest route-level error boundary
        throw promise._error;
        if (status === $7939e29d663dd3ed$var$AwaitRenderStatus.error) // Render via our errorElement
        return /*#__PURE__*/ $acw62.createElement($7939e29d663dd3ed$var$AwaitContext.Provider, {
            value: promise,
            children: errorElement
        });
        if (status === $7939e29d663dd3ed$var$AwaitRenderStatus.success) // Render children with resolved value
        return /*#__PURE__*/ $acw62.createElement($7939e29d663dd3ed$var$AwaitContext.Provider, {
            value: promise,
            children: children
        });
        // Throw to the suspense boundary
        throw promise;
    }
}
/**
 * @private
 * Indirection to leverage useAsyncValue for a render-prop API on `<Await>`
 */ function $7939e29d663dd3ed$var$ResolveAwait(_ref8) {
    let { children: children } = _ref8;
    let data = $7939e29d663dd3ed$export$78a72ddb39bdd145();
    let toRender = typeof children === "function" ? children(data) : children;
    return /*#__PURE__*/ $acw62.createElement($acw62.Fragment, null, toRender);
}
///////////////////////////////////////////////////////////////////////////////
// UTILS
///////////////////////////////////////////////////////////////////////////////
/**
 * Creates a route config from a React "children" object, which is usually
 * either a `<Route>` element or an array of them. Used internally by
 * `<Routes>` to create a route config from its children.
 *
 * @see https://reactrouter.com/utils/create-routes-from-children
 */ function $7939e29d663dd3ed$export$16da398f5434bdec(children, parentPath) {
    if (parentPath === void 0) parentPath = [];
    let routes = [];
    $acw62.Children.forEach(children, (element, index)=>{
        if (!/*#__PURE__*/ $acw62.isValidElement(element)) // Ignore non-elements. This allows people to more easily inline
        // conditionals in their route config.
        return;
        let treePath = [
            ...parentPath,
            index
        ];
        if (element.type === $acw62.Fragment) {
            // Transparently support React.Fragment and its children.
            routes.push.apply(routes, $7939e29d663dd3ed$export$16da398f5434bdec(element.props.children, treePath));
            return;
        }
        !(element.type === $7939e29d663dd3ed$export$e7b0ac011bb776c6) && (0, $1d34d5c4a288b213$export$3e9cee6b33872309)(false);
        !(!element.props.index || !element.props.children) && (0, $1d34d5c4a288b213$export$3e9cee6b33872309)(false);
        let route = {
            id: element.props.id || treePath.join("-"),
            caseSensitive: element.props.caseSensitive,
            element: element.props.element,
            Component: element.props.Component,
            index: element.props.index,
            path: element.props.path,
            loader: element.props.loader,
            action: element.props.action,
            errorElement: element.props.errorElement,
            ErrorBoundary: element.props.ErrorBoundary,
            hasErrorBoundary: element.props.ErrorBoundary != null || element.props.errorElement != null,
            shouldRevalidate: element.props.shouldRevalidate,
            handle: element.props.handle,
            lazy: element.props.lazy
        };
        if (element.props.children) route.children = $7939e29d663dd3ed$export$16da398f5434bdec(element.props.children, treePath);
        routes.push(route);
    });
    return routes;
}
/**
 * Renders the result of `matchRoutes()` into a React element.
 */ function $7939e29d663dd3ed$export$daf73786167a7f72(matches) {
    return $7939e29d663dd3ed$var$_renderMatches(matches);
}
function $7939e29d663dd3ed$export$52b333d321859367(route) {
    let updates = {
        // Note: this check also occurs in createRoutesFromChildren so update
        // there if you change this -- please and thank you!
        hasErrorBoundary: route.ErrorBoundary != null || route.errorElement != null
    };
    if (route.Component) Object.assign(updates, {
        element: /*#__PURE__*/ $acw62.createElement(route.Component),
        Component: undefined
    });
    if (route.ErrorBoundary) Object.assign(updates, {
        errorElement: /*#__PURE__*/ $acw62.createElement(route.ErrorBoundary),
        ErrorBoundary: undefined
    });
    return updates;
}
function $7939e29d663dd3ed$export$f30f7e456d254e83(routes, opts) {
    return (0, $1d34d5c4a288b213$export$baddd0131ee8c05b)({
        basename: opts == null ? void 0 : opts.basename,
        future: $7939e29d663dd3ed$var$_extends({}, opts == null ? void 0 : opts.future, {
            v7_prependBasename: true
        }),
        history: (0, $1d34d5c4a288b213$export$2b76ad033c6e6d08)({
            initialEntries: opts == null ? void 0 : opts.initialEntries,
            initialIndex: opts == null ? void 0 : opts.initialIndex
        }),
        hydrationData: opts == null ? void 0 : opts.hydrationData,
        routes: routes,
        mapRouteProperties: $7939e29d663dd3ed$export$52b333d321859367
    }).initialize();
}



function $040dbb9c344a508d$var$_extends() {
    $040dbb9c344a508d$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $040dbb9c344a508d$var$_extends.apply(this, arguments);
}
function $040dbb9c344a508d$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
const $040dbb9c344a508d$var$defaultMethod = "get";
const $040dbb9c344a508d$var$defaultEncType = "application/x-www-form-urlencoded";
function $040dbb9c344a508d$var$isHtmlElement(object) {
    return object != null && typeof object.tagName === "string";
}
function $040dbb9c344a508d$var$isButtonElement(object) {
    return $040dbb9c344a508d$var$isHtmlElement(object) && object.tagName.toLowerCase() === "button";
}
function $040dbb9c344a508d$var$isFormElement(object) {
    return $040dbb9c344a508d$var$isHtmlElement(object) && object.tagName.toLowerCase() === "form";
}
function $040dbb9c344a508d$var$isInputElement(object) {
    return $040dbb9c344a508d$var$isHtmlElement(object) && object.tagName.toLowerCase() === "input";
}
function $040dbb9c344a508d$var$isModifiedEvent(event) {
    return !!(event.metaKey || event.altKey || event.ctrlKey || event.shiftKey);
}
function $040dbb9c344a508d$var$shouldProcessLinkClick(event, target) {
    return event.button === 0 && // Ignore everything but left clicks
    (!target || target === "_self") && // Let browser handle "target=_blank" etc.
    !$040dbb9c344a508d$var$isModifiedEvent(event) // Ignore clicks with modifier keys
    ;
}
/**
 * Creates a URLSearchParams object using the given initializer.
 *
 * This is identical to `new URLSearchParams(init)` except it also
 * supports arrays as values in the object form of the initializer
 * instead of just strings. This is convenient when you need multiple
 * values for a given key, but don't want to use an array initializer.
 *
 * For example, instead of:
 *
 *   let searchParams = new URLSearchParams([
 *     ['sort', 'name'],
 *     ['sort', 'price']
 *   ]);
 *
 * you can do:
 *
 *   let searchParams = createSearchParams({
 *     sort: ['name', 'price']
 *   });
 */ function $040dbb9c344a508d$export$a2e4e2dcc7b1f22f(init) {
    if (init === void 0) init = "";
    return new URLSearchParams(typeof init === "string" || Array.isArray(init) || init instanceof URLSearchParams ? init : Object.keys(init).reduce((memo, key)=>{
        let value = init[key];
        return memo.concat(Array.isArray(value) ? value.map((v)=>[
                key,
                v
            ]) : [
            [
                key,
                value
            ]
        ]);
    }, []));
}
function $040dbb9c344a508d$var$getSearchParamsForLocation(locationSearch, defaultSearchParams) {
    let searchParams = $040dbb9c344a508d$export$a2e4e2dcc7b1f22f(locationSearch);
    if (defaultSearchParams) // Use `defaultSearchParams.forEach(...)` here instead of iterating of
    // `defaultSearchParams.keys()` to work-around a bug in Firefox related to
    // web extensions. Relevant Bugzilla tickets:
    // https://bugzilla.mozilla.org/show_bug.cgi?id=1414602
    // https://bugzilla.mozilla.org/show_bug.cgi?id=1023984
    defaultSearchParams.forEach((_, key)=>{
        if (!searchParams.has(key)) defaultSearchParams.getAll(key).forEach((value)=>{
            searchParams.append(key, value);
        });
    });
    return searchParams;
}
// One-time check for submitter support
let $040dbb9c344a508d$var$_formDataSupportsSubmitter = null;
function $040dbb9c344a508d$var$isFormDataSubmitterSupported() {
    if ($040dbb9c344a508d$var$_formDataSupportsSubmitter === null) try {
        new FormData(document.createElement("form"), // @ts-expect-error if FormData supports the submitter parameter, this will throw
        0);
        $040dbb9c344a508d$var$_formDataSupportsSubmitter = false;
    } catch (e) {
        $040dbb9c344a508d$var$_formDataSupportsSubmitter = true;
    }
    return $040dbb9c344a508d$var$_formDataSupportsSubmitter;
}
const $040dbb9c344a508d$var$supportedFormEncTypes = new Set([
    "application/x-www-form-urlencoded",
    "multipart/form-data",
    "text/plain"
]);
function $040dbb9c344a508d$var$getFormEncType(encType) {
    if (encType != null && !$040dbb9c344a508d$var$supportedFormEncTypes.has(encType)) return null;
    return encType;
}
function $040dbb9c344a508d$var$getFormSubmissionInfo(target, basename) {
    let method;
    let action;
    let encType;
    let formData;
    let body;
    if ($040dbb9c344a508d$var$isFormElement(target)) {
        // When grabbing the action from the element, it will have had the basename
        // prefixed to ensure non-JS scenarios work, so strip it since we'll
        // re-prefix in the router
        let attr = target.getAttribute("action");
        action = attr ? (0, $1d34d5c4a288b213$export$b69e3301ce081aa3)(attr, basename) : null;
        method = target.getAttribute("method") || $040dbb9c344a508d$var$defaultMethod;
        encType = $040dbb9c344a508d$var$getFormEncType(target.getAttribute("enctype")) || $040dbb9c344a508d$var$defaultEncType;
        formData = new FormData(target);
    } else if ($040dbb9c344a508d$var$isButtonElement(target) || $040dbb9c344a508d$var$isInputElement(target) && (target.type === "submit" || target.type === "image")) {
        let form = target.form;
        if (form == null) throw new Error('Cannot submit a <button> or <input type="submit"> without a <form>');
        // <button>/<input type="submit"> may override attributes of <form>
        // When grabbing the action from the element, it will have had the basename
        // prefixed to ensure non-JS scenarios work, so strip it since we'll
        // re-prefix in the router
        let attr = target.getAttribute("formaction") || form.getAttribute("action");
        action = attr ? (0, $1d34d5c4a288b213$export$b69e3301ce081aa3)(attr, basename) : null;
        method = target.getAttribute("formmethod") || form.getAttribute("method") || $040dbb9c344a508d$var$defaultMethod;
        encType = $040dbb9c344a508d$var$getFormEncType(target.getAttribute("formenctype")) || $040dbb9c344a508d$var$getFormEncType(form.getAttribute("enctype")) || $040dbb9c344a508d$var$defaultEncType;
        // Build a FormData object populated from a form and submitter
        formData = new FormData(form, target);
        // If this browser doesn't support the `FormData(el, submitter)` format,
        // then tack on the submitter value at the end.  This is a lightweight
        // solution that is not 100% spec compliant.  For complete support in older
        // browsers, consider using the `formdata-submitter-polyfill` package
        if (!$040dbb9c344a508d$var$isFormDataSubmitterSupported()) {
            let { name: name, type: type, value: value } = target;
            if (type === "image") {
                let prefix = name ? name + "." : "";
                formData.append(prefix + "x", "0");
                formData.append(prefix + "y", "0");
            } else if (name) formData.append(name, value);
        }
    } else if ($040dbb9c344a508d$var$isHtmlElement(target)) throw new Error('Cannot submit element that is not <form>, <button>, or <input type="submit|image">');
    else {
        method = $040dbb9c344a508d$var$defaultMethod;
        action = null;
        encType = $040dbb9c344a508d$var$defaultEncType;
        body = target;
    }
    // Send body for <Form encType="text/plain" so we encode it into text
    if (formData && encType === "text/plain") {
        body = formData;
        formData = undefined;
    }
    return {
        action: action,
        method: method.toLowerCase(),
        encType: encType,
        formData: formData,
        body: body
    };
}
const $040dbb9c344a508d$var$_excluded = [
    "onClick",
    "relative",
    "reloadDocument",
    "replace",
    "state",
    "target",
    "to",
    "preventScrollReset",
    "unstable_viewTransition"
], $040dbb9c344a508d$var$_excluded2 = [
    "aria-current",
    "caseSensitive",
    "className",
    "end",
    "style",
    "to",
    "unstable_viewTransition",
    "children"
], $040dbb9c344a508d$var$_excluded3 = [
    "fetcherKey",
    "navigate",
    "reloadDocument",
    "replace",
    "state",
    "method",
    "action",
    "onSubmit",
    "relative",
    "preventScrollReset",
    "unstable_viewTransition"
];
function $040dbb9c344a508d$export$1f3f55432a00e06d(routes, opts) {
    return (0, $1d34d5c4a288b213$export$baddd0131ee8c05b)({
        basename: opts == null ? void 0 : opts.basename,
        future: $040dbb9c344a508d$var$_extends({}, opts == null ? void 0 : opts.future, {
            v7_prependBasename: true
        }),
        history: (0, $1d34d5c4a288b213$export$719fc203c4e16dee)({
            window: opts == null ? void 0 : opts.window
        }),
        hydrationData: (opts == null ? void 0 : opts.hydrationData) || $040dbb9c344a508d$var$parseHydrationData(),
        routes: routes,
        mapRouteProperties: (0, $7939e29d663dd3ed$export$52b333d321859367),
        window: opts == null ? void 0 : opts.window
    }).initialize();
}
function $040dbb9c344a508d$export$1ba7ed8a3a7b3765(routes, opts) {
    return (0, $1d34d5c4a288b213$export$baddd0131ee8c05b)({
        basename: opts == null ? void 0 : opts.basename,
        future: $040dbb9c344a508d$var$_extends({}, opts == null ? void 0 : opts.future, {
            v7_prependBasename: true
        }),
        history: (0, $1d34d5c4a288b213$export$b71fdd3798280242)({
            window: opts == null ? void 0 : opts.window
        }),
        hydrationData: (opts == null ? void 0 : opts.hydrationData) || $040dbb9c344a508d$var$parseHydrationData(),
        routes: routes,
        mapRouteProperties: (0, $7939e29d663dd3ed$export$52b333d321859367),
        window: opts == null ? void 0 : opts.window
    }).initialize();
}
function $040dbb9c344a508d$var$parseHydrationData() {
    var _window;
    let state = (_window = window) == null ? void 0 : _window.__staticRouterHydrationData;
    if (state && state.errors) state = $040dbb9c344a508d$var$_extends({}, state, {
        errors: $040dbb9c344a508d$var$deserializeErrors(state.errors)
    });
    return state;
}
function $040dbb9c344a508d$var$deserializeErrors(errors) {
    if (!errors) return null;
    let entries = Object.entries(errors);
    let serialized = {};
    for (let [key, val] of entries){
        // Hey you!  If you change this, please change the corresponding logic in
        // serializeErrors in react-router-dom/server.tsx :)
        if (val && val.__type === "RouteErrorResponse") serialized[key] = new (0, $1d34d5c4a288b213$export$6c6580e81da25755)(val.status, val.statusText, val.data, val.internal === true);
        else if (val && val.__type === "Error") {
            // Attempt to reconstruct the right type of Error (i.e., ReferenceError)
            if (val.__subType) {
                let ErrorConstructor = window[val.__subType];
                if (typeof ErrorConstructor === "function") try {
                    // @ts-expect-error
                    let error = new ErrorConstructor(val.message);
                    // Wipe away the client-side stack trace.  Nothing to fill it in with
                    // because we don't serialize SSR stack traces for security reasons
                    error.stack = "";
                    serialized[key] = error;
                } catch (e) {
                // no-op - fall through and create a normal Error
                }
            }
            if (serialized[key] == null) {
                let error = new Error(val.message);
                // Wipe away the client-side stack trace.  Nothing to fill it in with
                // because we don't serialize SSR stack traces for security reasons
                error.stack = "";
                serialized[key] = error;
            }
        } else serialized[key] = val;
    }
    return serialized;
}
const $040dbb9c344a508d$export$7ad602f0e94e62d1 = /*#__PURE__*/ $acw62.createContext({
    isTransitioning: false
});
const $040dbb9c344a508d$export$148fd98d095596d4 = /*#__PURE__*/ $acw62.createContext(new Map());
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region Components
////////////////////////////////////////////////////////////////////////////////
/**
  Webpack + React 17 fails to compile on any of the following because webpack
  complains that `startTransition` doesn't exist in `React`:
  * import { startTransition } from "react"
  * import * as React from from "react";
    "startTransition" in React ? React.startTransition(() => setState()) : setState()
  * import * as React from from "react";
    "startTransition" in React ? React["startTransition"](() => setState()) : setState()

  Moving it to a constant such as the following solves the Webpack/React 17 issue:
  * import * as React from from "react";
    const START_TRANSITION = "startTransition";
    START_TRANSITION in React ? React[START_TRANSITION](() => setState()) : setState()

  However, that introduces webpack/terser minification issues in production builds
  in React 18 where minification/obfuscation ends up removing the call of
  React.startTransition entirely from the first half of the ternary.  Grabbing
  this exported reference once up front resolves that issue.

  See https://github.com/remix-run/react-router/issues/10579
*/ const $040dbb9c344a508d$var$START_TRANSITION = "startTransition";
const $040dbb9c344a508d$var$startTransitionImpl = $acw62[$040dbb9c344a508d$var$START_TRANSITION];
function $040dbb9c344a508d$var$startTransitionSafe(cb) {
    if ($040dbb9c344a508d$var$startTransitionImpl) $040dbb9c344a508d$var$startTransitionImpl(cb);
    else cb();
}
class $040dbb9c344a508d$var$Deferred {
    constructor(){
        this.status = "pending";
        this.promise = new Promise((resolve, reject)=>{
            this.resolve = (value)=>{
                if (this.status === "pending") {
                    this.status = "resolved";
                    resolve(value);
                }
            };
            this.reject = (reason)=>{
                if (this.status === "pending") {
                    this.status = "rejected";
                    reject(reason);
                }
            };
        });
    }
}
/**
 * Given a Remix Router instance, render the appropriate UI
 */ function $040dbb9c344a508d$export$323e4fc2fa4753fb(_ref) {
    let { fallbackElement: fallbackElement, router: router, future: future } = _ref;
    let [state, setStateImpl] = $acw62.useState(router.state);
    let [pendingState, setPendingState] = $acw62.useState();
    let [vtContext, setVtContext] = $acw62.useState({
        isTransitioning: false
    });
    let [renderDfd, setRenderDfd] = $acw62.useState();
    let [transition, setTransition] = $acw62.useState();
    let [interruption, setInterruption] = $acw62.useState();
    let fetcherData = $acw62.useRef(new Map());
    let { v7_startTransition: v7_startTransition } = future || {};
    let optInStartTransition = $acw62.useCallback((cb)=>{
        if (v7_startTransition) $040dbb9c344a508d$var$startTransitionSafe(cb);
        else cb();
    }, [
        v7_startTransition
    ]);
    let setState = $acw62.useCallback((newState, _ref2)=>{
        let { deletedFetchers: deletedFetchers, unstable_viewTransitionOpts: viewTransitionOpts } = _ref2;
        deletedFetchers.forEach((key)=>fetcherData.current.delete(key));
        newState.fetchers.forEach((fetcher, key)=>{
            if (fetcher.data !== undefined) fetcherData.current.set(key, fetcher.data);
        });
        if (!viewTransitionOpts || router.window == null || typeof router.window.document.startViewTransition !== "function") // Mid-navigation state update, or startViewTransition isn't available
        optInStartTransition(()=>setStateImpl(newState));
        else if (transition && renderDfd) {
            // Interrupting an in-progress transition, cancel and let everything flush
            // out, and then kick off a new transition from the interruption state
            renderDfd.resolve();
            transition.skipTransition();
            setInterruption({
                state: newState,
                currentLocation: viewTransitionOpts.currentLocation,
                nextLocation: viewTransitionOpts.nextLocation
            });
        } else {
            // Completed navigation update with opted-in view transitions, let 'er rip
            setPendingState(newState);
            setVtContext({
                isTransitioning: true,
                currentLocation: viewTransitionOpts.currentLocation,
                nextLocation: viewTransitionOpts.nextLocation
            });
        }
    }, [
        router.window,
        transition,
        renderDfd,
        fetcherData,
        optInStartTransition
    ]);
    // Need to use a layout effect here so we are subscribed early enough to
    // pick up on any render-driven redirects/navigations (useEffect/<Navigate>)
    $acw62.useLayoutEffect(()=>router.subscribe(setState), [
        router,
        setState
    ]);
    // When we start a view transition, create a Deferred we can use for the
    // eventual "completed" render
    $acw62.useEffect(()=>{
        if (vtContext.isTransitioning) setRenderDfd(new $040dbb9c344a508d$var$Deferred());
    }, [
        vtContext.isTransitioning
    ]);
    // Once the deferred is created, kick off startViewTransition() to update the
    // DOM and then wait on the Deferred to resolve (indicating the DOM update has
    // happened)
    $acw62.useEffect(()=>{
        if (renderDfd && pendingState && router.window) {
            let newState = pendingState;
            let renderPromise = renderDfd.promise;
            let transition = router.window.document.startViewTransition(async ()=>{
                optInStartTransition(()=>setStateImpl(newState));
                await renderPromise;
            });
            transition.finished.finally(()=>{
                setRenderDfd(undefined);
                setTransition(undefined);
                setPendingState(undefined);
                setVtContext({
                    isTransitioning: false
                });
            });
            setTransition(transition);
        }
    }, [
        optInStartTransition,
        pendingState,
        renderDfd,
        router.window
    ]);
    // When the new location finally renders and is committed to the DOM, this
    // effect will run to resolve the transition
    $acw62.useEffect(()=>{
        if (renderDfd && pendingState && state.location.key === pendingState.location.key) renderDfd.resolve();
    }, [
        renderDfd,
        transition,
        state.location,
        pendingState
    ]);
    // If we get interrupted with a new navigation during a transition, we skip
    // the active transition, let it cleanup, then kick it off again here
    $acw62.useEffect(()=>{
        if (!vtContext.isTransitioning && interruption) {
            setPendingState(interruption.state);
            setVtContext({
                isTransitioning: true,
                currentLocation: interruption.currentLocation,
                nextLocation: interruption.nextLocation
            });
            setInterruption(undefined);
        }
    }, [
        vtContext.isTransitioning,
        interruption
    ]);
    let navigator = $acw62.useMemo(()=>{
        return {
            createHref: router.createHref,
            encodeLocation: router.encodeLocation,
            go: (n)=>router.navigate(n),
            push: (to, state, opts)=>router.navigate(to, {
                    state: state,
                    preventScrollReset: opts == null ? void 0 : opts.preventScrollReset
                }),
            replace: (to, state, opts)=>router.navigate(to, {
                    replace: true,
                    state: state,
                    preventScrollReset: opts == null ? void 0 : opts.preventScrollReset
                })
        };
    }, [
        router
    ]);
    let basename = router.basename || "/";
    let dataRouterContext = $acw62.useMemo(()=>({
            router: router,
            navigator: navigator,
            static: false,
            basename: basename
        }), [
        router,
        navigator,
        basename
    ]);
    // The fragment and {null} here are important!  We need them to keep React 18's
    // useId happy when we are server-rendering since we may have a <script> here
    // containing the hydrated server-side staticContext (from StaticRouterProvider).
    // useId relies on the component tree structure to generate deterministic id's
    // so we need to ensure it remains the same on the client even though
    // we don't need the <script> tag
    return /*#__PURE__*/ $acw62.createElement($acw62.Fragment, null, /*#__PURE__*/ $acw62.createElement((0, $7939e29d663dd3ed$export$3add0d5dce533e2e).Provider, {
        value: dataRouterContext
    }, /*#__PURE__*/ $acw62.createElement((0, $7939e29d663dd3ed$export$145dfa71566a64dc).Provider, {
        value: state
    }, /*#__PURE__*/ $acw62.createElement($040dbb9c344a508d$export$148fd98d095596d4.Provider, {
        value: fetcherData.current
    }, /*#__PURE__*/ $acw62.createElement($040dbb9c344a508d$export$7ad602f0e94e62d1.Provider, {
        value: vtContext
    }, /*#__PURE__*/ $acw62.createElement((0, $7939e29d663dd3ed$export$55185c17a0fcbe46), {
        basename: basename,
        location: state.location,
        navigationType: state.historyAction,
        navigator: navigator
    }, state.initialized ? /*#__PURE__*/ $acw62.createElement($040dbb9c344a508d$var$DataRoutes, {
        routes: router.routes,
        state: state
    }) : fallbackElement))))), null);
}
function $040dbb9c344a508d$var$DataRoutes(_ref3) {
    let { routes: routes, state: state } = _ref3;
    return (0, $7939e29d663dd3ed$export$5fcee62552a12fbf)(routes, undefined, state);
}
/**
 * A `<Router>` for use in web browsers. Provides the cleanest URLs.
 */ function $040dbb9c344a508d$export$9ba4e89fdfa1fc54(_ref4) {
    let { basename: basename, children: children, future: future, window: window1 } = _ref4;
    let historyRef = $acw62.useRef();
    if (historyRef.current == null) historyRef.current = (0, $1d34d5c4a288b213$export$719fc203c4e16dee)({
        window: window1,
        v5Compat: true
    });
    let history = historyRef.current;
    let [state, setStateImpl] = $acw62.useState({
        action: history.action,
        location: history.location
    });
    let { v7_startTransition: v7_startTransition } = future || {};
    let setState = $acw62.useCallback((newState)=>{
        v7_startTransition && $040dbb9c344a508d$var$startTransitionImpl ? $040dbb9c344a508d$var$startTransitionImpl(()=>setStateImpl(newState)) : setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    $acw62.useLayoutEffect(()=>history.listen(setState), [
        history,
        setState
    ]);
    return /*#__PURE__*/ $acw62.createElement((0, $7939e29d663dd3ed$export$55185c17a0fcbe46), {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history
    });
}
/**
 * A `<Router>` for use in web browsers. Stores the location in the hash
 * portion of the URL so it is not sent to the server.
 */ function $040dbb9c344a508d$export$7221d69dcfc8e36b(_ref5) {
    let { basename: basename, children: children, future: future, window: window1 } = _ref5;
    let historyRef = $acw62.useRef();
    if (historyRef.current == null) historyRef.current = (0, $1d34d5c4a288b213$export$b71fdd3798280242)({
        window: window1,
        v5Compat: true
    });
    let history = historyRef.current;
    let [state, setStateImpl] = $acw62.useState({
        action: history.action,
        location: history.location
    });
    let { v7_startTransition: v7_startTransition } = future || {};
    let setState = $acw62.useCallback((newState)=>{
        v7_startTransition && $040dbb9c344a508d$var$startTransitionImpl ? $040dbb9c344a508d$var$startTransitionImpl(()=>setStateImpl(newState)) : setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    $acw62.useLayoutEffect(()=>history.listen(setState), [
        history,
        setState
    ]);
    return /*#__PURE__*/ $acw62.createElement((0, $7939e29d663dd3ed$export$55185c17a0fcbe46), {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history
    });
}
/**
 * A `<Router>` that accepts a pre-instantiated history object. It's important
 * to note that using your own history object is highly discouraged and may add
 * two versions of the history library to your bundles unless you use the same
 * version of the history library that React Router uses internally.
 */ function $040dbb9c344a508d$export$eefb0c834599897e(_ref6) {
    let { basename: basename, children: children, future: future, history: history } = _ref6;
    let [state, setStateImpl] = $acw62.useState({
        action: history.action,
        location: history.location
    });
    let { v7_startTransition: v7_startTransition } = future || {};
    let setState = $acw62.useCallback((newState)=>{
        v7_startTransition && $040dbb9c344a508d$var$startTransitionImpl ? $040dbb9c344a508d$var$startTransitionImpl(()=>setStateImpl(newState)) : setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    $acw62.useLayoutEffect(()=>history.listen(setState), [
        history,
        setState
    ]);
    return /*#__PURE__*/ $acw62.createElement((0, $7939e29d663dd3ed$export$55185c17a0fcbe46), {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history
    });
}
const $040dbb9c344a508d$var$isBrowser = typeof window !== "undefined" && typeof window.document !== "undefined" && typeof window.document.createElement !== "undefined";
const $040dbb9c344a508d$var$ABSOLUTE_URL_REGEX = /^(?:[a-z][a-z0-9+.-]*:|\/\/)/i;
/**
 * The public API for rendering a history-aware `<a>`.
 */ const $040dbb9c344a508d$export$a6c7ac8248d6e38a = /*#__PURE__*/ $acw62.forwardRef(function LinkWithRef(_ref7, ref) {
    let { onClick: onClick, relative: relative, reloadDocument: reloadDocument, replace: replace, state: state, target: target, to: to, preventScrollReset: preventScrollReset, unstable_viewTransition: unstable_viewTransition } = _ref7, rest = $040dbb9c344a508d$var$_objectWithoutPropertiesLoose(_ref7, $040dbb9c344a508d$var$_excluded);
    let { basename: basename } = $acw62.useContext((0, $7939e29d663dd3ed$export$26749e8557646306));
    // Rendered into <a href> for absolute URLs
    let absoluteHref;
    let isExternal = false;
    if (typeof to === "string" && $040dbb9c344a508d$var$ABSOLUTE_URL_REGEX.test(to)) {
        // Render the absolute href server- and client-side
        absoluteHref = to;
        // Only check for external origins client-side
        if ($040dbb9c344a508d$var$isBrowser) try {
            let currentUrl = new URL(window.location.href);
            let targetUrl = to.startsWith("//") ? new URL(currentUrl.protocol + to) : new URL(to);
            let path = (0, $1d34d5c4a288b213$export$b69e3301ce081aa3)(targetUrl.pathname, basename);
            if (targetUrl.origin === currentUrl.origin && path != null) // Strip the protocol/origin/basename for same-origin absolute URLs
            to = path + targetUrl.search + targetUrl.hash;
            else isExternal = true;
        } catch (e) {}
    }
    // Rendered into <a href> for relative URLs
    let href = (0, $7939e29d663dd3ed$export$b66bb29c5006f12f)(to, {
        relative: relative
    });
    let internalOnClick = $040dbb9c344a508d$export$67621102c14d847(to, {
        replace: replace,
        state: state,
        target: target,
        preventScrollReset: preventScrollReset,
        relative: relative,
        unstable_viewTransition: unstable_viewTransition
    });
    function handleClick(event) {
        if (onClick) onClick(event);
        if (!event.defaultPrevented) internalOnClick(event);
    }
    return(/*#__PURE__*/ // eslint-disable-next-line jsx-a11y/anchor-has-content
    $acw62.createElement("a", $040dbb9c344a508d$var$_extends({}, rest, {
        href: absoluteHref || href,
        onClick: isExternal || reloadDocument ? onClick : handleClick,
        ref: ref,
        target: target
    })));
});
/**
 * A `<Link>` wrapper that knows if it's "active" or not.
 */ const $040dbb9c344a508d$export$b0d92dbee9b5b60d = /*#__PURE__*/ $acw62.forwardRef(function NavLinkWithRef(_ref8, ref) {
    let { "aria-current": ariaCurrentProp = "page", caseSensitive: caseSensitive = false, className: classNameProp = "", end: end = false, style: styleProp, to: to, unstable_viewTransition: unstable_viewTransition, children: children } = _ref8, rest = $040dbb9c344a508d$var$_objectWithoutPropertiesLoose(_ref8, $040dbb9c344a508d$var$_excluded2);
    let path = (0, $7939e29d663dd3ed$export$e75d2a2d1b3c245b)(to, {
        relative: rest.relative
    });
    let location = (0, $7939e29d663dd3ed$export$45d76561a5302f2b)();
    let routerState = $acw62.useContext((0, $7939e29d663dd3ed$export$145dfa71566a64dc));
    let { navigator: navigator } = $acw62.useContext((0, $7939e29d663dd3ed$export$26749e8557646306));
    let isTransitioning = routerState != null && // Conditional usage is OK here because the usage of a data router is static
    // eslint-disable-next-line react-hooks/rules-of-hooks
    $040dbb9c344a508d$export$328fe15191788e7f(path) && unstable_viewTransition === true;
    let toPathname = navigator.encodeLocation ? navigator.encodeLocation(path).pathname : path.pathname;
    let locationPathname = location.pathname;
    let nextLocationPathname = routerState && routerState.navigation && routerState.navigation.location ? routerState.navigation.location.pathname : null;
    if (!caseSensitive) {
        locationPathname = locationPathname.toLowerCase();
        nextLocationPathname = nextLocationPathname ? nextLocationPathname.toLowerCase() : null;
        toPathname = toPathname.toLowerCase();
    }
    let isActive = locationPathname === toPathname || !end && locationPathname.startsWith(toPathname) && locationPathname.charAt(toPathname.length) === "/";
    let isPending = nextLocationPathname != null && (nextLocationPathname === toPathname || !end && nextLocationPathname.startsWith(toPathname) && nextLocationPathname.charAt(toPathname.length) === "/");
    let renderProps = {
        isActive: isActive,
        isPending: isPending,
        isTransitioning: isTransitioning
    };
    let ariaCurrent = isActive ? ariaCurrentProp : undefined;
    let className;
    if (typeof classNameProp === "function") className = classNameProp(renderProps);
    else // If the className prop is not a function, we use a default `active`
    // class for <NavLink />s that are active. In v5 `active` was the default
    // value for `activeClassName`, but we are removing that API and can still
    // use the old default behavior for a cleaner upgrade path and keep the
    // simple styling rules working as they currently do.
    className = [
        classNameProp,
        isActive ? "active" : null,
        isPending ? "pending" : null,
        isTransitioning ? "transitioning" : null
    ].filter(Boolean).join(" ");
    let style = typeof styleProp === "function" ? styleProp(renderProps) : styleProp;
    return /*#__PURE__*/ $acw62.createElement($040dbb9c344a508d$export$a6c7ac8248d6e38a, $040dbb9c344a508d$var$_extends({}, rest, {
        "aria-current": ariaCurrent,
        className: className,
        ref: ref,
        style: style,
        to: to,
        unstable_viewTransition: unstable_viewTransition
    }), typeof children === "function" ? children(renderProps) : children);
});
/**
 * A `@remix-run/router`-aware `<form>`. It behaves like a normal form except
 * that the interaction with the server is with `fetch` instead of new document
 * requests, allowing components to add nicer UX to the page as the form is
 * submitted and returns with data.
 */ const $040dbb9c344a508d$export$a7fed597f4b8afd8 = /*#__PURE__*/ $acw62.forwardRef((_ref9, forwardedRef)=>{
    let { fetcherKey: fetcherKey, navigate: navigate, reloadDocument: reloadDocument, replace: replace, state: state, method: method = $040dbb9c344a508d$var$defaultMethod, action: action, onSubmit: onSubmit, relative: relative, preventScrollReset: preventScrollReset, unstable_viewTransition: unstable_viewTransition } = _ref9, props = $040dbb9c344a508d$var$_objectWithoutPropertiesLoose(_ref9, $040dbb9c344a508d$var$_excluded3);
    let submit = $040dbb9c344a508d$export$47c85c6e3a081d3();
    let formAction = $040dbb9c344a508d$export$89a6bd6db0d97c56(action, {
        relative: relative
    });
    let formMethod = method.toLowerCase() === "get" ? "get" : "post";
    let submitHandler = (event)=>{
        onSubmit && onSubmit(event);
        if (event.defaultPrevented) return;
        event.preventDefault();
        let submitter = event.nativeEvent.submitter;
        let submitMethod = (submitter == null ? void 0 : submitter.getAttribute("formmethod")) || method;
        submit(submitter || event.currentTarget, {
            fetcherKey: fetcherKey,
            method: submitMethod,
            navigate: navigate,
            replace: replace,
            state: state,
            relative: relative,
            preventScrollReset: preventScrollReset,
            unstable_viewTransition: unstable_viewTransition
        });
    };
    return /*#__PURE__*/ $acw62.createElement("form", $040dbb9c344a508d$var$_extends({
        ref: forwardedRef,
        method: formMethod,
        action: formAction,
        onSubmit: reloadDocument ? onSubmit : submitHandler
    }, props));
});
/**
 * This component will emulate the browser's scroll restoration on location
 * changes.
 */ function $040dbb9c344a508d$export$11aac1aab828f1fa(_ref10) {
    let { getKey: getKey, storageKey: storageKey } = _ref10;
    $040dbb9c344a508d$export$25057cfe5591e3e9({
        getKey: getKey,
        storageKey: storageKey
    });
    return null;
}
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region Hooks
////////////////////////////////////////////////////////////////////////////////
var $040dbb9c344a508d$var$DataRouterHook;
(function(DataRouterHook) {
    DataRouterHook["UseScrollRestoration"] = "useScrollRestoration";
    DataRouterHook["UseSubmit"] = "useSubmit";
    DataRouterHook["UseSubmitFetcher"] = "useSubmitFetcher";
    DataRouterHook["UseFetcher"] = "useFetcher";
    DataRouterHook["useViewTransitionState"] = "useViewTransitionState";
})($040dbb9c344a508d$var$DataRouterHook || ($040dbb9c344a508d$var$DataRouterHook = {}));
var $040dbb9c344a508d$var$DataRouterStateHook;
(function(DataRouterStateHook) {
    DataRouterStateHook["UseFetcher"] = "useFetcher";
    DataRouterStateHook["UseFetchers"] = "useFetchers";
    DataRouterStateHook["UseScrollRestoration"] = "useScrollRestoration";
})($040dbb9c344a508d$var$DataRouterStateHook || ($040dbb9c344a508d$var$DataRouterStateHook = {}));
// Internal hooks
function $040dbb9c344a508d$var$getDataRouterConsoleError(hookName) {
    return hookName + " must be used within a data router.  See https://reactrouter.com/routers/picking-a-router.";
}
function $040dbb9c344a508d$var$useDataRouterContext(hookName) {
    let ctx = $acw62.useContext((0, $7939e29d663dd3ed$export$3add0d5dce533e2e));
    !ctx && (0, $1d34d5c4a288b213$export$3e9cee6b33872309)(false);
    return ctx;
}
function $040dbb9c344a508d$var$useDataRouterState(hookName) {
    let state = $acw62.useContext((0, $7939e29d663dd3ed$export$145dfa71566a64dc));
    !state && (0, $1d34d5c4a288b213$export$3e9cee6b33872309)(false);
    return state;
}
// External hooks
/**
 * Handles the click behavior for router `<Link>` components. This is useful if
 * you need to create custom `<Link>` components with the same click behavior we
 * use in our exported `<Link>`.
 */ function $040dbb9c344a508d$export$67621102c14d847(to, _temp) {
    let { target: target, replace: replaceProp, state: state, preventScrollReset: preventScrollReset, relative: relative, unstable_viewTransition: unstable_viewTransition } = _temp === void 0 ? {} : _temp;
    let navigate = (0, $7939e29d663dd3ed$export$9770f232ac06a008)();
    let location = (0, $7939e29d663dd3ed$export$45d76561a5302f2b)();
    let path = (0, $7939e29d663dd3ed$export$e75d2a2d1b3c245b)(to, {
        relative: relative
    });
    return $acw62.useCallback((event)=>{
        if ($040dbb9c344a508d$var$shouldProcessLinkClick(event, target)) {
            event.preventDefault();
            // If the URL hasn't changed, a regular <a> will do a replace instead of
            // a push, so do the same here unless the replace prop is explicitly set
            let replace = replaceProp !== undefined ? replaceProp : (0, $1d34d5c4a288b213$export$fe53371bee54353d)(location) === (0, $1d34d5c4a288b213$export$fe53371bee54353d)(path);
            navigate(to, {
                replace: replace,
                state: state,
                preventScrollReset: preventScrollReset,
                relative: relative,
                unstable_viewTransition: unstable_viewTransition
            });
        }
    }, [
        location,
        navigate,
        path,
        replaceProp,
        state,
        target,
        to,
        preventScrollReset,
        relative,
        unstable_viewTransition
    ]);
}
/**
 * A convenient wrapper for reading and writing search parameters via the
 * URLSearchParams interface.
 */ function $040dbb9c344a508d$export$f1a78c17382fe22a(defaultInit) {
    let defaultSearchParamsRef = $acw62.useRef($040dbb9c344a508d$export$a2e4e2dcc7b1f22f(defaultInit));
    let hasSetSearchParamsRef = $acw62.useRef(false);
    let location = (0, $7939e29d663dd3ed$export$45d76561a5302f2b)();
    let searchParams = $acw62.useMemo(()=>// Only merge in the defaults if we haven't yet called setSearchParams.
        // Once we call that we want those to take precedence, otherwise you can't
        // remove a param with setSearchParams({}) if it has an initial value
        $040dbb9c344a508d$var$getSearchParamsForLocation(location.search, hasSetSearchParamsRef.current ? null : defaultSearchParamsRef.current), [
        location.search
    ]);
    let navigate = (0, $7939e29d663dd3ed$export$9770f232ac06a008)();
    let setSearchParams = $acw62.useCallback((nextInit, navigateOptions)=>{
        const newSearchParams = $040dbb9c344a508d$export$a2e4e2dcc7b1f22f(typeof nextInit === "function" ? nextInit(searchParams) : nextInit);
        hasSetSearchParamsRef.current = true;
        navigate("?" + newSearchParams, navigateOptions);
    }, [
        navigate,
        searchParams
    ]);
    return [
        searchParams,
        setSearchParams
    ];
}
function $040dbb9c344a508d$var$validateClientSideSubmission() {
    if (typeof document === "undefined") throw new Error("You are calling submit during the server render. Try calling submit within a `useEffect` or callback instead.");
}
let $040dbb9c344a508d$var$fetcherId = 0;
let $040dbb9c344a508d$var$getUniqueFetcherId = ()=>"__" + String(++$040dbb9c344a508d$var$fetcherId) + "__";
/**
 * Returns a function that may be used to programmatically submit a form (or
 * some arbitrary data) to the server.
 */ function $040dbb9c344a508d$export$47c85c6e3a081d3() {
    let { router: router } = $040dbb9c344a508d$var$useDataRouterContext($040dbb9c344a508d$var$DataRouterHook.UseSubmit);
    let { basename: basename } = $acw62.useContext((0, $7939e29d663dd3ed$export$26749e8557646306));
    let currentRouteId = (0, $7939e29d663dd3ed$export$5fc8298006ad9e58)();
    return $acw62.useCallback(function(target, options) {
        if (options === void 0) options = {};
        $040dbb9c344a508d$var$validateClientSideSubmission();
        let { action: action, method: method, encType: encType, formData: formData, body: body } = $040dbb9c344a508d$var$getFormSubmissionInfo(target, basename);
        if (options.navigate === false) {
            let key = options.fetcherKey || $040dbb9c344a508d$var$getUniqueFetcherId();
            router.fetch(key, currentRouteId, options.action || action, {
                preventScrollReset: options.preventScrollReset,
                formData: formData,
                body: body,
                formMethod: options.method || method,
                formEncType: options.encType || encType
            });
        } else router.navigate(options.action || action, {
            preventScrollReset: options.preventScrollReset,
            formData: formData,
            body: body,
            formMethod: options.method || method,
            formEncType: options.encType || encType,
            replace: options.replace,
            state: options.state,
            fromRouteId: currentRouteId,
            unstable_viewTransition: options.unstable_viewTransition
        });
    }, [
        router,
        basename,
        currentRouteId
    ]);
}
// v7: Eventually we should deprecate this entirely in favor of using the
// router method directly?
function $040dbb9c344a508d$export$89a6bd6db0d97c56(action, _temp2) {
    let { relative: relative } = _temp2 === void 0 ? {} : _temp2;
    let { basename: basename } = $acw62.useContext((0, $7939e29d663dd3ed$export$26749e8557646306));
    let routeContext = $acw62.useContext((0, $7939e29d663dd3ed$export$9072aa6dd1f93057));
    !routeContext && (0, $1d34d5c4a288b213$export$3e9cee6b33872309)(false);
    let [match] = routeContext.matches.slice(-1);
    // Shallow clone path so we can modify it below, otherwise we modify the
    // object referenced by useMemo inside useResolvedPath
    let path = $040dbb9c344a508d$var$_extends({}, (0, $7939e29d663dd3ed$export$e75d2a2d1b3c245b)(action ? action : ".", {
        relative: relative
    }));
    // Previously we set the default action to ".". The problem with this is that
    // `useResolvedPath(".")` excludes search params of the resolved URL. This is
    // the intended behavior of when "." is specifically provided as
    // the form action, but inconsistent w/ browsers when the action is omitted.
    // https://github.com/remix-run/remix/issues/927
    let location = (0, $7939e29d663dd3ed$export$45d76561a5302f2b)();
    if (action == null) {
        // Safe to write to this directly here since if action was undefined, we
        // would have called useResolvedPath(".") which will never include a search
        path.search = location.search;
        // When grabbing search params from the URL, remove the automatically
        // inserted ?index param so we match the useResolvedPath search behavior
        // which would not include ?index
        if (match.route.index) {
            let params = new URLSearchParams(path.search);
            params.delete("index");
            path.search = params.toString() ? "?" + params.toString() : "";
        }
    }
    if ((!action || action === ".") && match.route.index) path.search = path.search ? path.search.replace(/^\?/, "?index&") : "?index";
    // If we're operating within a basename, prepend it to the pathname prior
    // to creating the form action.  If this is a root navigation, then just use
    // the raw basename which allows the basename to have full control over the
    // presence of a trailing slash on root actions
    if (basename !== "/") path.pathname = path.pathname === "/" ? basename : (0, $1d34d5c4a288b213$export$86d9a7913e44197e)([
        basename,
        path.pathname
    ]);
    return (0, $1d34d5c4a288b213$export$fe53371bee54353d)(path);
}
// TODO: (v7) Change the useFetcher generic default from `any` to `unknown`
/**
 * Interacts with route loaders and actions without causing a navigation. Great
 * for any interaction that stays on the same page.
 */ function $040dbb9c344a508d$export$5b0d2d9a9921565a(_temp3) {
    var _route$matches;
    let { key: key } = _temp3 === void 0 ? {} : _temp3;
    let { router: router } = $040dbb9c344a508d$var$useDataRouterContext($040dbb9c344a508d$var$DataRouterHook.UseFetcher);
    let state = $040dbb9c344a508d$var$useDataRouterState($040dbb9c344a508d$var$DataRouterStateHook.UseFetcher);
    let fetcherData = $acw62.useContext($040dbb9c344a508d$export$148fd98d095596d4);
    let route = $acw62.useContext((0, $7939e29d663dd3ed$export$9072aa6dd1f93057));
    let routeId = (_route$matches = route.matches[route.matches.length - 1]) == null ? void 0 : _route$matches.route.id;
    !fetcherData && (0, $1d34d5c4a288b213$export$3e9cee6b33872309)(false);
    !route && (0, $1d34d5c4a288b213$export$3e9cee6b33872309)(false);
    !(routeId != null) && (0, $1d34d5c4a288b213$export$3e9cee6b33872309)(false);
    // Fetcher key handling
    let [fetcherKey, setFetcherKey] = $acw62.useState(key || "");
    if (!fetcherKey) setFetcherKey($040dbb9c344a508d$var$getUniqueFetcherId());
    // Registration/cleanup
    $acw62.useEffect(()=>{
        router.getFetcher(fetcherKey);
        return ()=>{
            // Tell the router we've unmounted - if v7_fetcherPersist is enabled this
            // will not delete immediately but instead queue up a delete after the
            // fetcher returns to an `idle` state
            router.deleteFetcher(fetcherKey);
        };
    }, [
        router,
        fetcherKey
    ]);
    // Fetcher additions
    let load = $acw62.useCallback((href)=>{
        !routeId && (0, $1d34d5c4a288b213$export$3e9cee6b33872309)(false);
        router.fetch(fetcherKey, routeId, href);
    }, [
        fetcherKey,
        routeId,
        router
    ]);
    let submitImpl = $040dbb9c344a508d$export$47c85c6e3a081d3();
    let submit = $acw62.useCallback((target, opts)=>{
        submitImpl(target, $040dbb9c344a508d$var$_extends({}, opts, {
            navigate: false,
            fetcherKey: fetcherKey
        }));
    }, [
        fetcherKey,
        submitImpl
    ]);
    let FetcherForm = $acw62.useMemo(()=>{
        let FetcherForm = /*#__PURE__*/ $acw62.forwardRef((props, ref)=>{
            return /*#__PURE__*/ $acw62.createElement($040dbb9c344a508d$export$a7fed597f4b8afd8, $040dbb9c344a508d$var$_extends({}, props, {
                navigate: false,
                fetcherKey: fetcherKey,
                ref: ref
            }));
        });
        return FetcherForm;
    }, [
        fetcherKey
    ]);
    // Exposed FetcherWithComponents
    let fetcher = state.fetchers.get(fetcherKey) || (0, $1d34d5c4a288b213$export$52eace9c284d3585);
    let data = fetcherData.get(fetcherKey);
    let fetcherWithComponents = $acw62.useMemo(()=>$040dbb9c344a508d$var$_extends({
            Form: FetcherForm,
            submit: submit,
            load: load
        }, fetcher, {
            data: data
        }), [
        FetcherForm,
        submit,
        load,
        fetcher,
        data
    ]);
    return fetcherWithComponents;
}
/**
 * Provides all fetchers currently on the page. Useful for layouts and parent
 * routes that need to provide pending/optimistic UI regarding the fetch.
 */ function $040dbb9c344a508d$export$fa996778a3a31087() {
    let state = $040dbb9c344a508d$var$useDataRouterState($040dbb9c344a508d$var$DataRouterStateHook.UseFetchers);
    return Array.from(state.fetchers.entries()).map((_ref11)=>{
        let [key, fetcher] = _ref11;
        return $040dbb9c344a508d$var$_extends({}, fetcher, {
            key: key
        });
    });
}
const $040dbb9c344a508d$var$SCROLL_RESTORATION_STORAGE_KEY = "react-router-scroll-positions";
let $040dbb9c344a508d$var$savedScrollPositions = {};
/**
 * When rendered inside a RouterProvider, will restore scroll positions on navigations
 */ function $040dbb9c344a508d$export$25057cfe5591e3e9(_temp4) {
    let { getKey: getKey, storageKey: storageKey } = _temp4 === void 0 ? {} : _temp4;
    let { router: router } = $040dbb9c344a508d$var$useDataRouterContext($040dbb9c344a508d$var$DataRouterHook.UseScrollRestoration);
    let { restoreScrollPosition: restoreScrollPosition, preventScrollReset: preventScrollReset } = $040dbb9c344a508d$var$useDataRouterState($040dbb9c344a508d$var$DataRouterStateHook.UseScrollRestoration);
    let { basename: basename } = $acw62.useContext((0, $7939e29d663dd3ed$export$26749e8557646306));
    let location = (0, $7939e29d663dd3ed$export$45d76561a5302f2b)();
    let matches = (0, $7939e29d663dd3ed$export$2378eb7f5ff86053)();
    let navigation = (0, $7939e29d663dd3ed$export$d0fd4b7106de2769)();
    // Trigger manual scroll restoration while we're active
    $acw62.useEffect(()=>{
        window.history.scrollRestoration = "manual";
        return ()=>{
            window.history.scrollRestoration = "auto";
        };
    }, []);
    // Save positions on pagehide
    $040dbb9c344a508d$var$usePageHide($acw62.useCallback(()=>{
        if (navigation.state === "idle") {
            let key = (getKey ? getKey(location, matches) : null) || location.key;
            $040dbb9c344a508d$var$savedScrollPositions[key] = window.scrollY;
        }
        try {
            sessionStorage.setItem(storageKey || $040dbb9c344a508d$var$SCROLL_RESTORATION_STORAGE_KEY, JSON.stringify($040dbb9c344a508d$var$savedScrollPositions));
        } catch (error) {}
        window.history.scrollRestoration = "auto";
    }, [
        storageKey,
        getKey,
        navigation.state,
        location,
        matches
    ]));
    // Read in any saved scroll locations
    if (typeof document !== "undefined") {
        // eslint-disable-next-line react-hooks/rules-of-hooks
        $acw62.useLayoutEffect(()=>{
            try {
                let sessionPositions = sessionStorage.getItem(storageKey || $040dbb9c344a508d$var$SCROLL_RESTORATION_STORAGE_KEY);
                if (sessionPositions) $040dbb9c344a508d$var$savedScrollPositions = JSON.parse(sessionPositions);
            } catch (e) {
            // no-op, use default empty object
            }
        }, [
            storageKey
        ]);
        // Enable scroll restoration in the router
        // eslint-disable-next-line react-hooks/rules-of-hooks
        $acw62.useLayoutEffect(()=>{
            let getKeyWithoutBasename = getKey && basename !== "/" ? (location, matches)=>getKey($040dbb9c344a508d$var$_extends({}, location, {
                    pathname: (0, $1d34d5c4a288b213$export$b69e3301ce081aa3)(location.pathname, basename) || location.pathname
                }), matches) : getKey;
            let disableScrollRestoration = router == null ? void 0 : router.enableScrollRestoration($040dbb9c344a508d$var$savedScrollPositions, ()=>window.scrollY, getKeyWithoutBasename);
            return ()=>disableScrollRestoration && disableScrollRestoration();
        }, [
            router,
            basename,
            getKey
        ]);
        // Restore scrolling when state.restoreScrollPosition changes
        // eslint-disable-next-line react-hooks/rules-of-hooks
        $acw62.useLayoutEffect(()=>{
            // Explicit false means don't do anything (used for submissions)
            if (restoreScrollPosition === false) return;
            // been here before, scroll to it
            if (typeof restoreScrollPosition === "number") {
                window.scrollTo(0, restoreScrollPosition);
                return;
            }
            // try to scroll to the hash
            if (location.hash) {
                let el = document.getElementById(decodeURIComponent(location.hash.slice(1)));
                if (el) {
                    el.scrollIntoView();
                    return;
                }
            }
            // Don't reset if this navigation opted out
            if (preventScrollReset === true) return;
            // otherwise go to the top on new locations
            window.scrollTo(0, 0);
        }, [
            location,
            restoreScrollPosition,
            preventScrollReset
        ]);
    }
}
/**
 * Setup a callback to be fired on the window's `beforeunload` event. This is
 * useful for saving some data to `window.localStorage` just before the page
 * refreshes.
 *
 * Note: The `callback` argument should be a function created with
 * `React.useCallback()`.
 */ function $040dbb9c344a508d$export$c0a586b329cae57d(callback, options) {
    let { capture: capture } = options || {};
    $acw62.useEffect(()=>{
        let opts = capture != null ? {
            capture: capture
        } : undefined;
        window.addEventListener("beforeunload", callback, opts);
        return ()=>{
            window.removeEventListener("beforeunload", callback, opts);
        };
    }, [
        callback,
        capture
    ]);
}
/**
 * Setup a callback to be fired on the window's `pagehide` event. This is
 * useful for saving some data to `window.localStorage` just before the page
 * refreshes.  This event is better supported than beforeunload across browsers.
 *
 * Note: The `callback` argument should be a function created with
 * `React.useCallback()`.
 */ function $040dbb9c344a508d$var$usePageHide(callback, options) {
    let { capture: capture } = options || {};
    $acw62.useEffect(()=>{
        let opts = capture != null ? {
            capture: capture
        } : undefined;
        window.addEventListener("pagehide", callback, opts);
        return ()=>{
            window.removeEventListener("pagehide", callback, opts);
        };
    }, [
        callback,
        capture
    ]);
}
/**
 * Wrapper around useBlocker to show a window.confirm prompt to users instead
 * of building a custom UI with useBlocker.
 *
 * Warning: This has *a lot of rough edges* and behaves very differently (and
 * very incorrectly in some cases) across browsers if user click addition
 * back/forward navigations while the confirm is open.  Use at your own risk.
 */ function $040dbb9c344a508d$export$39f4eb3dbd812741(_ref12) {
    let { when: when, message: message } = _ref12;
    let blocker = (0, $7939e29d663dd3ed$export$2af03a1de5c0910)(when);
    $acw62.useEffect(()=>{
        if (blocker.state === "blocked") {
            let proceed = window.confirm(message);
            if (proceed) // This timeout is needed to avoid a weird "race" on POP navigations
            // between the `window.history` revert navigation and the result of
            // `window.confirm`
            setTimeout(blocker.proceed, 0);
            else blocker.reset();
        }
    }, [
        blocker,
        message
    ]);
    $acw62.useEffect(()=>{
        if (blocker.state === "blocked" && !when) blocker.reset();
    }, [
        blocker,
        when
    ]);
}
/**
 * Return a boolean indicating if there is an active view transition to the
 * given href.  You can use this value to render CSS classes or viewTransitionName
 * styles onto your elements
 *
 * @param href The destination href
 * @param [opts.relative] Relative routing type ("route" | "path")
 */ function $040dbb9c344a508d$export$328fe15191788e7f(to, opts) {
    if (opts === void 0) opts = {};
    let vtContext = $acw62.useContext($040dbb9c344a508d$export$7ad602f0e94e62d1);
    !(vtContext != null) && (0, $1d34d5c4a288b213$export$3e9cee6b33872309)(false);
    let { basename: basename } = $040dbb9c344a508d$var$useDataRouterContext($040dbb9c344a508d$var$DataRouterHook.useViewTransitionState);
    let path = (0, $7939e29d663dd3ed$export$e75d2a2d1b3c245b)(to, {
        relative: opts.relative
    });
    if (!vtContext.isTransitioning) return false;
    let currentPath = (0, $1d34d5c4a288b213$export$b69e3301ce081aa3)(vtContext.currentLocation.pathname, basename) || vtContext.currentLocation.pathname;
    let nextPath = (0, $1d34d5c4a288b213$export$b69e3301ce081aa3)(vtContext.nextLocation.pathname, basename) || vtContext.nextLocation.pathname;
    // Transition is active if we're going to or coming from the indicated
    // destination.  This ensures that other PUSH navigations that reverse
    // an indicated transition apply.  I.e., on the list view you have:
    //
    //   <NavLink to="/details/1" unstable_viewTransition>
    //
    // If you click the breadcrumb back to the list view:
    //
    //   <NavLink to="/list" unstable_viewTransition>
    //
    // We should apply the transition because it's indicated as active going
    // from /list -> /details/1 and therefore should be active on the reverse
    // (even though this isn't strictly a POP reverse)
    return (0, $1d34d5c4a288b213$export$81336c211d5ff295)(path.pathname, nextPath) != null || (0, $1d34d5c4a288b213$export$81336c211d5ff295)(path.pathname, currentPath) != null;
}




var $acw62 = parcelRequire("acw62");


var $acw62 = parcelRequire("acw62");
function $15e6d94060e5d8b6$var$r(e) {
    var t, f, n = "";
    if ("string" == typeof e || "number" == typeof e) n += e;
    else if ("object" == typeof e) {
        if (Array.isArray(e)) for(t = 0; t < e.length; t++)e[t] && (f = $15e6d94060e5d8b6$var$r(e[t])) && (n && (n += " "), n += f);
        else for(t in e)e[t] && (n && (n += " "), n += t);
    }
    return n;
}
function $15e6d94060e5d8b6$export$4f5d2d50c9deca37() {
    for(var e, t, f = 0, n = ""; f < arguments.length;)(e = arguments[f++]) && (t = $15e6d94060e5d8b6$var$r(e)) && (n && (n += " "), n += t);
    return n;
}
var $15e6d94060e5d8b6$export$2e2bcd8739ae039 = $15e6d94060e5d8b6$export$4f5d2d50c9deca37;


"use client";
const $ad26fe773541dcd3$var$u = (t)=>"number" == typeof t && !isNaN(t), $ad26fe773541dcd3$var$d = (t)=>"string" == typeof t, $ad26fe773541dcd3$var$p = (t)=>"function" == typeof t, $ad26fe773541dcd3$var$m = (t)=>$ad26fe773541dcd3$var$d(t) || $ad26fe773541dcd3$var$p(t) ? t : null, $ad26fe773541dcd3$var$f = (t)=>(0, $acw62.isValidElement)(t) || $ad26fe773541dcd3$var$d(t) || $ad26fe773541dcd3$var$p(t) || $ad26fe773541dcd3$var$u(t);
function $ad26fe773541dcd3$export$184cca501f1aed7f(t, e, n) {
    void 0 === n && (n = 300);
    const { scrollHeight: o, style: s } = t;
    requestAnimationFrame(()=>{
        s.minHeight = "initial", s.height = o + "px", s.transition = `all ${n}ms`, requestAnimationFrame(()=>{
            s.height = "0", s.padding = "0", s.margin = "0", setTimeout(e, n);
        });
    });
}
function $ad26fe773541dcd3$export$3ff7dc44d332d222(e) {
    let { enter: a, exit: r, appendPosition: i = !1, collapse: l = !0, collapseDuration: c = 300 } = e;
    return function(e) {
        let { children: u, position: d, preventExitTransition: p, done: m, nodeRef: f, isIn: h } = e;
        const y = i ? `${a}--${d}` : a, v = i ? `${r}--${d}` : r, T = (0, $acw62.useRef)(0);
        return (0, $acw62.useLayoutEffect)(()=>{
            const t = f.current, e = y.split(" "), n = (o)=>{
                o.target === f.current && (t.dispatchEvent(new Event("d")), t.removeEventListener("animationend", n), t.removeEventListener("animationcancel", n), 0 === T.current && "animationcancel" !== o.type && t.classList.remove(...e));
            };
            t.classList.add(...e), t.addEventListener("animationend", n), t.addEventListener("animationcancel", n);
        }, []), (0, $acw62.useEffect)(()=>{
            const t = f.current, e = ()=>{
                t.removeEventListener("animationend", e), l ? $ad26fe773541dcd3$export$184cca501f1aed7f(t, m, c) : m();
            };
            h || (p ? e() : (T.current = 1, t.className += ` ${v}`, t.addEventListener("animationend", e)));
        }, [
            h
        ]), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, u);
    };
}
function $ad26fe773541dcd3$var$y(t, e) {
    return null != t ? {
        content: t.content,
        containerId: t.props.containerId,
        id: t.props.toastId,
        theme: t.props.theme,
        type: t.props.type,
        data: t.props.data || {},
        isLoading: t.props.isLoading,
        icon: t.props.icon,
        status: e
    } : {};
}
const $ad26fe773541dcd3$var$v = {
    list: new Map,
    emitQueue: new Map,
    on (t, e) {
        return this.list.has(t) || this.list.set(t, []), this.list.get(t).push(e), this;
    },
    off (t, e) {
        if (e) {
            const n = this.list.get(t).filter((t)=>t !== e);
            return this.list.set(t, n), this;
        }
        return this.list.delete(t), this;
    },
    cancelEmit (t) {
        const e = this.emitQueue.get(t);
        return e && (e.forEach(clearTimeout), this.emitQueue.delete(t)), this;
    },
    emit (t) {
        this.list.has(t) && this.list.get(t).forEach((e)=>{
            const n = setTimeout(()=>{
                e(...[].slice.call(arguments, 1));
            }, 0);
            this.emitQueue.has(t) || this.emitQueue.set(t, []), this.emitQueue.get(t).push(n);
        });
    }
}, $ad26fe773541dcd3$var$T = (e)=>{
    let { theme: n, type: o, ...s } = e;
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("svg", {
        viewBox: "0 0 24 24",
        width: "100%",
        height: "100%",
        fill: "colored" === n ? "currentColor" : `var(--toastify-icon-color-${o})`,
        ...s
    });
}, $ad26fe773541dcd3$export$4f13f83fd8bb1dac = {
    info: function(e) {
        return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($ad26fe773541dcd3$var$T, {
            ...e
        }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
            d: "M12 0a12 12 0 1012 12A12.013 12.013 0 0012 0zm.25 5a1.5 1.5 0 11-1.5 1.5 1.5 1.5 0 011.5-1.5zm2.25 13.5h-4a1 1 0 010-2h.75a.25.25 0 00.25-.25v-4.5a.25.25 0 00-.25-.25h-.75a1 1 0 010-2h1a2 2 0 012 2v4.75a.25.25 0 00.25.25h.75a1 1 0 110 2z"
        }));
    },
    warning: function(e) {
        return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($ad26fe773541dcd3$var$T, {
            ...e
        }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
            d: "M23.32 17.191L15.438 2.184C14.728.833 13.416 0 11.996 0c-1.42 0-2.733.833-3.443 2.184L.533 17.448a4.744 4.744 0 000 4.368C1.243 23.167 2.555 24 3.975 24h16.05C22.22 24 24 22.044 24 19.632c0-.904-.251-1.746-.68-2.44zm-9.622 1.46c0 1.033-.724 1.823-1.698 1.823s-1.698-.79-1.698-1.822v-.043c0-1.028.724-1.822 1.698-1.822s1.698.79 1.698 1.822v.043zm.039-12.285l-.84 8.06c-.057.581-.408.943-.897.943-.49 0-.84-.367-.896-.942l-.84-8.065c-.057-.624.25-1.095.779-1.095h1.91c.528.005.84.476.784 1.1z"
        }));
    },
    success: function(e) {
        return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($ad26fe773541dcd3$var$T, {
            ...e
        }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
            d: "M12 0a12 12 0 1012 12A12.014 12.014 0 0012 0zm6.927 8.2l-6.845 9.289a1.011 1.011 0 01-1.43.188l-4.888-3.908a1 1 0 111.25-1.562l4.076 3.261 6.227-8.451a1 1 0 111.61 1.183z"
        }));
    },
    error: function(e) {
        return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($ad26fe773541dcd3$var$T, {
            ...e
        }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
            d: "M11.983 0a12.206 12.206 0 00-8.51 3.653A11.8 11.8 0 000 12.207 11.779 11.779 0 0011.8 24h.214A12.111 12.111 0 0024 11.791 11.766 11.766 0 0011.983 0zM10.5 16.542a1.476 1.476 0 011.449-1.53h.027a1.527 1.527 0 011.523 1.47 1.475 1.475 0 01-1.449 1.53h-.027a1.529 1.529 0 01-1.523-1.47zM11 12.5v-6a1 1 0 012 0v6a1 1 0 11-2 0z"
        }));
    },
    spinner: function() {
        return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            className: "Toastify__spinner"
        });
    }
};
function $ad26fe773541dcd3$export$b262e13ca2dd2381(t) {
    const [, o] = (0, $acw62.useReducer)((t)=>t + 1, 0), [l, c] = (0, $acw62.useState)([]), g = (0, $acw62.useRef)(null), h = (0, $acw62.useRef)(new Map).current, T = (t)=>-1 !== l.indexOf(t), C = (0, $acw62.useRef)({
        toastKey: 1,
        displayedToast: 0,
        count: 0,
        queue: [],
        props: t,
        containerId: null,
        isToastActive: T,
        getToast: (t)=>h.get(t)
    }).current;
    function b(t) {
        let { containerId: e } = t;
        const { limit: n } = C.props;
        !n || e && C.containerId !== e || (C.count -= C.queue.length, C.queue = []);
    }
    function I(t) {
        c((e)=>null == t ? [] : e.filter((e)=>e !== t));
    }
    function _() {
        const { toastContent: t, toastProps: e, staleId: n } = C.queue.shift();
        O(t, e, n);
    }
    function L(t, n) {
        let { delay: s, staleId: r, ...i } = n;
        if (!$ad26fe773541dcd3$var$f(t) || function(t) {
            return !g.current || C.props.enableMultiContainer && t.containerId !== C.props.containerId || h.has(t.toastId) && null == t.updateId;
        }(i)) return;
        const { toastId: l, updateId: c, data: T } = i, { props: b } = C, L = ()=>I(l), N = null == c;
        N && C.count++;
        const M = {
            ...b,
            style: b.toastStyle,
            key: C.toastKey++,
            ...Object.fromEntries(Object.entries(i).filter((t)=>{
                let [e, n] = t;
                return null != n;
            })),
            toastId: l,
            updateId: c,
            data: T,
            closeToast: L,
            isIn: !1,
            className: $ad26fe773541dcd3$var$m(i.className || b.toastClassName),
            bodyClassName: $ad26fe773541dcd3$var$m(i.bodyClassName || b.bodyClassName),
            progressClassName: $ad26fe773541dcd3$var$m(i.progressClassName || b.progressClassName),
            autoClose: !i.isLoading && (R = i.autoClose, w = b.autoClose, !1 === R || $ad26fe773541dcd3$var$u(R) && R > 0 ? R : w),
            deleteToast () {
                const t = $ad26fe773541dcd3$var$y(h.get(l), "removed");
                h.delete(l), $ad26fe773541dcd3$var$v.emit(4, t);
                const e = C.queue.length;
                if (C.count = null == l ? C.count - C.displayedToast : C.count - 1, C.count < 0 && (C.count = 0), e > 0) {
                    const t = null == l ? C.props.limit : 1;
                    if (1 === e || 1 === t) C.displayedToast++, _();
                    else {
                        const n = t > e ? e : t;
                        C.displayedToast = n;
                        for(let t = 0; t < n; t++)_();
                    }
                } else o();
            }
        };
        var R, w;
        M.iconOut = function(t) {
            let { theme: n, type: o, isLoading: s, icon: r } = t, i = null;
            const l = {
                theme: n,
                type: o
            };
            return !1 === r || ($ad26fe773541dcd3$var$p(r) ? i = r(l) : (0, $acw62.isValidElement)(r) ? i = (0, $acw62.cloneElement)(r, l) : $ad26fe773541dcd3$var$d(r) || $ad26fe773541dcd3$var$u(r) ? i = r : s ? i = $ad26fe773541dcd3$export$4f13f83fd8bb1dac.spinner() : ((t)=>t in $ad26fe773541dcd3$export$4f13f83fd8bb1dac)(o) && (i = $ad26fe773541dcd3$export$4f13f83fd8bb1dac[o](l))), i;
        }(M), $ad26fe773541dcd3$var$p(i.onOpen) && (M.onOpen = i.onOpen), $ad26fe773541dcd3$var$p(i.onClose) && (M.onClose = i.onClose), M.closeButton = b.closeButton, !1 === i.closeButton || $ad26fe773541dcd3$var$f(i.closeButton) ? M.closeButton = i.closeButton : !0 === i.closeButton && (M.closeButton = !$ad26fe773541dcd3$var$f(b.closeButton) || b.closeButton);
        let x = t;
        (0, $acw62.isValidElement)(t) && !$ad26fe773541dcd3$var$d(t.type) ? x = (0, $acw62.cloneElement)(t, {
            closeToast: L,
            toastProps: M,
            data: T
        }) : $ad26fe773541dcd3$var$p(t) && (x = t({
            closeToast: L,
            toastProps: M,
            data: T
        })), b.limit && b.limit > 0 && C.count > b.limit && N ? C.queue.push({
            toastContent: x,
            toastProps: M,
            staleId: r
        }) : $ad26fe773541dcd3$var$u(s) ? setTimeout(()=>{
            O(x, M, r);
        }, s) : O(x, M, r);
    }
    function O(t, e, n) {
        const { toastId: o } = e;
        n && h.delete(n);
        const s = {
            content: t,
            props: e
        };
        h.set(o, s), c((t)=>[
                ...t,
                o
            ].filter((t)=>t !== n)), $ad26fe773541dcd3$var$v.emit(4, $ad26fe773541dcd3$var$y(s, null == s.props.updateId ? "added" : "updated"));
    }
    return (0, $acw62.useEffect)(()=>(C.containerId = t.containerId, $ad26fe773541dcd3$var$v.cancelEmit(3).on(0, L).on(1, (t)=>g.current && I(t)).on(5, b).emit(2, C), ()=>{
            h.clear(), $ad26fe773541dcd3$var$v.emit(3, C);
        }), []), (0, $acw62.useEffect)(()=>{
        C.props = t, C.isToastActive = T, C.displayedToast = l.length;
    }), {
        getToastToRender: function(e) {
            const n = new Map, o = Array.from(h.values());
            return t.newestOnTop && o.reverse(), o.forEach((t)=>{
                const { position: e } = t.props;
                n.has(e) || n.set(e, []), n.get(e).push(t);
            }), Array.from(n, (t)=>e(t[0], t[1]));
        },
        containerRef: g,
        isToastActive: T
    };
}
function $ad26fe773541dcd3$var$b(t) {
    return t.targetTouches && t.targetTouches.length >= 1 ? t.targetTouches[0].clientX : t.clientX;
}
function $ad26fe773541dcd3$var$I(t) {
    return t.targetTouches && t.targetTouches.length >= 1 ? t.targetTouches[0].clientY : t.clientY;
}
function $ad26fe773541dcd3$export$a407b657d3044108(t) {
    const [o, a] = (0, $acw62.useState)(!1), [r, l] = (0, $acw62.useState)(!1), c = (0, $acw62.useRef)(null), u = (0, $acw62.useRef)({
        start: 0,
        x: 0,
        y: 0,
        delta: 0,
        removalDistance: 0,
        canCloseOnClick: !0,
        canDrag: !1,
        boundingRect: null,
        didMove: !1
    }).current, d = (0, $acw62.useRef)(t), { autoClose: m, pauseOnHover: f, closeToast: g, onClick: h, closeOnClick: y } = t;
    function v(e) {
        if (t.draggable) {
            "touchstart" === e.nativeEvent.type && e.nativeEvent.preventDefault(), u.didMove = !1, document.addEventListener("mousemove", _), document.addEventListener("mouseup", L), document.addEventListener("touchmove", _), document.addEventListener("touchend", L);
            const n = c.current;
            u.canCloseOnClick = !0, u.canDrag = !0, u.boundingRect = n.getBoundingClientRect(), n.style.transition = "", u.x = $ad26fe773541dcd3$var$b(e.nativeEvent), u.y = $ad26fe773541dcd3$var$I(e.nativeEvent), "x" === t.draggableDirection ? (u.start = u.x, u.removalDistance = n.offsetWidth * (t.draggablePercent / 100)) : (u.start = u.y, u.removalDistance = n.offsetHeight * (80 === t.draggablePercent ? 1.5 * t.draggablePercent : t.draggablePercent / 100));
        }
    }
    function T(e) {
        if (u.boundingRect) {
            const { top: n, bottom: o, left: s, right: a } = u.boundingRect;
            "touchend" !== e.nativeEvent.type && t.pauseOnHover && u.x >= s && u.x <= a && u.y >= n && u.y <= o ? C() : E();
        }
    }
    function E() {
        a(!0);
    }
    function C() {
        a(!1);
    }
    function _(e) {
        const n = c.current;
        u.canDrag && n && (u.didMove = !0, o && C(), u.x = $ad26fe773541dcd3$var$b(e), u.y = $ad26fe773541dcd3$var$I(e), u.delta = "x" === t.draggableDirection ? u.x - u.start : u.y - u.start, u.start !== u.x && (u.canCloseOnClick = !1), n.style.transform = `translate${t.draggableDirection}(${u.delta}px)`, n.style.opacity = "" + (1 - Math.abs(u.delta / u.removalDistance)));
    }
    function L() {
        document.removeEventListener("mousemove", _), document.removeEventListener("mouseup", L), document.removeEventListener("touchmove", _), document.removeEventListener("touchend", L);
        const e = c.current;
        if (u.canDrag && u.didMove && e) {
            if (u.canDrag = !1, Math.abs(u.delta) > u.removalDistance) return l(!0), void t.closeToast();
            e.style.transition = "transform 0.2s, opacity 0.2s", e.style.transform = `translate${t.draggableDirection}(0)`, e.style.opacity = "1";
        }
    }
    (0, $acw62.useEffect)(()=>{
        d.current = t;
    }), (0, $acw62.useEffect)(()=>(c.current && c.current.addEventListener("d", E, {
            once: !0
        }), $ad26fe773541dcd3$var$p(t.onOpen) && t.onOpen((0, $acw62.isValidElement)(t.children) && t.children.props), ()=>{
            const t = d.current;
            $ad26fe773541dcd3$var$p(t.onClose) && t.onClose((0, $acw62.isValidElement)(t.children) && t.children.props);
        }), []), (0, $acw62.useEffect)(()=>(t.pauseOnFocusLoss && (document.hasFocus() || C(), window.addEventListener("focus", E), window.addEventListener("blur", C)), ()=>{
            t.pauseOnFocusLoss && (window.removeEventListener("focus", E), window.removeEventListener("blur", C));
        }), [
        t.pauseOnFocusLoss
    ]);
    const O = {
        onMouseDown: v,
        onTouchStart: v,
        onMouseUp: T,
        onTouchEnd: T
    };
    return m && f && (O.onMouseEnter = C, O.onMouseLeave = E), y && (O.onClick = (t)=>{
        h && h(t), u.canCloseOnClick && g();
    }), {
        playToast: E,
        pauseToast: C,
        isRunning: o,
        preventExitTransition: r,
        toastRef: c,
        eventHandlers: O
    };
}
function $ad26fe773541dcd3$var$L(e) {
    let { closeToast: n, theme: o, ariaLabel: s = "close" } = e;
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("button", {
        className: `Toastify__close-button Toastify__close-button--${o}`,
        type: "button",
        onClick: (t)=>{
            t.stopPropagation(), n(t);
        },
        "aria-label": s
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("svg", {
        "aria-hidden": "true",
        viewBox: "0 0 14 16"
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        fillRule: "evenodd",
        d: "M7.71 8.23l3.75 3.75-1.48 1.48-3.75-3.75-3.75 3.75L1 11.98l3.75-3.75L1 4.48 2.48 3l3.75 3.75L9.98 3l1.48 1.48-3.75 3.75z"
    })));
}
function $ad26fe773541dcd3$var$O(e) {
    let { delay: n, isRunning: o, closeToast: s, type: a = "default", hide: r, className: i, style: l, controlledProgress: u, progress: d, rtl: m, isIn: f, theme: g } = e;
    const h = r || u && 0 === d, y = {
        ...l,
        animationDuration: `${n}ms`,
        animationPlayState: o ? "running" : "paused",
        opacity: h ? 0 : 1
    };
    u && (y.transform = `scaleX(${d})`);
    const v = (0, $15e6d94060e5d8b6$export$2e2bcd8739ae039)("Toastify__progress-bar", u ? "Toastify__progress-bar--controlled" : "Toastify__progress-bar--animated", `Toastify__progress-bar-theme--${g}`, `Toastify__progress-bar--${a}`, {
        "Toastify__progress-bar--rtl": m
    }), T = $ad26fe773541dcd3$var$p(i) ? i({
        rtl: m,
        type: a,
        defaultClassName: v
    }) : (0, $15e6d94060e5d8b6$export$2e2bcd8739ae039)(v, i);
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        role: "progressbar",
        "aria-hidden": h ? "true" : "false",
        "aria-label": "notification timer",
        className: T,
        style: y,
        [u && d >= 1 ? "onTransitionEnd" : "onAnimationEnd"]: u && d < 1 ? null : ()=>{
            f && s();
        }
    });
}
const $ad26fe773541dcd3$var$N = (n)=>{
    const { isRunning: o, preventExitTransition: s, toastRef: r, eventHandlers: i } = $ad26fe773541dcd3$export$a407b657d3044108(n), { closeButton: l, children: u, autoClose: d, onClick: m, type: f, hideProgressBar: g, closeToast: h, transition: y, position: v, className: T, style: E, bodyClassName: C, bodyStyle: b, progressClassName: I, progressStyle: N, updateId: M, role: R, progress: w, rtl: x, toastId: $, deleteToast: k, isIn: P, isLoading: B, iconOut: D, closeOnClick: A, theme: z } = n, F = (0, $15e6d94060e5d8b6$export$2e2bcd8739ae039)("Toastify__toast", `Toastify__toast-theme--${z}`, `Toastify__toast--${f}`, {
        "Toastify__toast--rtl": x
    }, {
        "Toastify__toast--close-on-click": A
    }), H = $ad26fe773541dcd3$var$p(T) ? T({
        rtl: x,
        position: v,
        type: f,
        defaultClassName: F
    }) : (0, $15e6d94060e5d8b6$export$2e2bcd8739ae039)(F, T), S = !!w || !d, q = {
        closeToast: h,
        type: f,
        theme: z
    };
    let Q = null;
    return !1 === l || (Q = $ad26fe773541dcd3$var$p(l) ? l(q) : (0, $acw62.isValidElement)(l) ? (0, $acw62.cloneElement)(l, q) : $ad26fe773541dcd3$var$L(q)), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(y, {
        isIn: P,
        done: k,
        position: v,
        preventExitTransition: s,
        nodeRef: r
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        id: $,
        onClick: m,
        className: H,
        ...i,
        style: E,
        ref: r
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        ...P && {
            role: R
        },
        className: $ad26fe773541dcd3$var$p(C) ? C({
            type: f
        }) : (0, $15e6d94060e5d8b6$export$2e2bcd8739ae039)("Toastify__toast-body", C),
        style: b
    }, null != D && (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: (0, $15e6d94060e5d8b6$export$2e2bcd8739ae039)("Toastify__toast-icon", {
            "Toastify--animate-icon Toastify__zoom-enter": !B
        })
    }, D), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", null, u)), Q, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($ad26fe773541dcd3$var$O, {
        ...M && !S ? {
            key: `pb-${M}`
        } : {},
        rtl: x,
        theme: z,
        delay: d,
        isRunning: o,
        isIn: P,
        closeToast: h,
        hide: g,
        type: f,
        style: N,
        className: I,
        controlledProgress: S,
        progress: w || 0
    })));
}, $ad26fe773541dcd3$var$M = function(t, e) {
    return void 0 === e && (e = !1), {
        enter: `Toastify--animate Toastify__${t}-enter`,
        exit: `Toastify--animate Toastify__${t}-exit`,
        appendPosition: e
    };
}, $ad26fe773541dcd3$export$d20e79fdc3899e95 = $ad26fe773541dcd3$export$3ff7dc44d332d222($ad26fe773541dcd3$var$M("bounce", !0)), $ad26fe773541dcd3$export$d8dc01b5c85a37b9 = $ad26fe773541dcd3$export$3ff7dc44d332d222($ad26fe773541dcd3$var$M("slide", !0)), $ad26fe773541dcd3$export$65cfd44a2050f99 = $ad26fe773541dcd3$export$3ff7dc44d332d222($ad26fe773541dcd3$var$M("zoom")), $ad26fe773541dcd3$export$4d2fae537bd90431 = $ad26fe773541dcd3$export$3ff7dc44d332d222($ad26fe773541dcd3$var$M("flip")), $ad26fe773541dcd3$export$f2815235e76a62b9 = (0, $acw62.forwardRef)((e, n)=>{
    const { getToastToRender: o, containerRef: a, isToastActive: r } = $ad26fe773541dcd3$export$b262e13ca2dd2381(e), { className: i, style: l, rtl: u, containerId: d } = e;
    function f(t) {
        const e = (0, $15e6d94060e5d8b6$export$2e2bcd8739ae039)("Toastify__toast-container", `Toastify__toast-container--${t}`, {
            "Toastify__toast-container--rtl": u
        });
        return $ad26fe773541dcd3$var$p(i) ? i({
            position: t,
            rtl: u,
            defaultClassName: e
        }) : (0, $15e6d94060e5d8b6$export$2e2bcd8739ae039)(e, $ad26fe773541dcd3$var$m(i));
    }
    return (0, $acw62.useEffect)(()=>{
        n && (n.current = a.current);
    }, []), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        ref: a,
        className: "Toastify",
        id: d
    }, o((e, n)=>{
        const o = n.length ? {
            ...l
        } : {
            ...l,
            pointerEvents: "none"
        };
        return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            className: f(e),
            style: o,
            key: `container-${e}`
        }, n.map((e, o)=>{
            let { content: s, props: a } = e;
            return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($ad26fe773541dcd3$var$N, {
                ...a,
                isIn: r(a.toastId),
                style: {
                    ...a.style,
                    "--nth": o + 1,
                    "--len": n.length
                },
                key: `toast-${a.key}`
            }, s);
        }));
    }));
});
$ad26fe773541dcd3$export$f2815235e76a62b9.displayName = "ToastContainer", $ad26fe773541dcd3$export$f2815235e76a62b9.defaultProps = {
    position: "top-right",
    transition: $ad26fe773541dcd3$export$d20e79fdc3899e95,
    autoClose: 5e3,
    closeButton: $ad26fe773541dcd3$var$L,
    pauseOnHover: !0,
    pauseOnFocusLoss: !0,
    closeOnClick: !0,
    draggable: !0,
    draggablePercent: 80,
    draggableDirection: "x",
    role: "alert",
    theme: "light"
};
let $ad26fe773541dcd3$var$P, $ad26fe773541dcd3$var$B = new Map, $ad26fe773541dcd3$var$D = [], $ad26fe773541dcd3$var$A = 1;
function $ad26fe773541dcd3$var$z() {
    return "" + $ad26fe773541dcd3$var$A++;
}
function $ad26fe773541dcd3$var$F(t) {
    return t && ($ad26fe773541dcd3$var$d(t.toastId) || $ad26fe773541dcd3$var$u(t.toastId)) ? t.toastId : $ad26fe773541dcd3$var$z();
}
function $ad26fe773541dcd3$var$H(t, e) {
    return $ad26fe773541dcd3$var$B.size > 0 ? $ad26fe773541dcd3$var$v.emit(0, t, e) : $ad26fe773541dcd3$var$D.push({
        content: t,
        options: e
    }), e.toastId;
}
function $ad26fe773541dcd3$var$S(t, e) {
    return {
        ...e,
        type: e && e.type || t,
        toastId: $ad26fe773541dcd3$var$F(e)
    };
}
function $ad26fe773541dcd3$var$q(t) {
    return (e, n)=>$ad26fe773541dcd3$var$H(e, $ad26fe773541dcd3$var$S(t, n));
}
function $ad26fe773541dcd3$export$b410431fab84fa58(t, e) {
    return $ad26fe773541dcd3$var$H(t, $ad26fe773541dcd3$var$S("default", e));
}
$ad26fe773541dcd3$export$b410431fab84fa58.loading = (t, e)=>$ad26fe773541dcd3$var$H(t, $ad26fe773541dcd3$var$S("default", {
        isLoading: !0,
        autoClose: !1,
        closeOnClick: !1,
        closeButton: !1,
        draggable: !1,
        ...e
    })), $ad26fe773541dcd3$export$b410431fab84fa58.promise = function(t, e, n) {
    let o, { pending: s, error: a, success: r } = e;
    s && (o = $ad26fe773541dcd3$var$d(s) ? $ad26fe773541dcd3$export$b410431fab84fa58.loading(s, n) : $ad26fe773541dcd3$export$b410431fab84fa58.loading(s.render, {
        ...n,
        ...s
    }));
    const i = {
        isLoading: null,
        autoClose: null,
        closeOnClick: null,
        closeButton: null,
        draggable: null
    }, l = (t, e, s)=>{
        if (null == e) return void $ad26fe773541dcd3$export$b410431fab84fa58.dismiss(o);
        const a = {
            type: t,
            ...i,
            ...n,
            data: s
        }, r = $ad26fe773541dcd3$var$d(e) ? {
            render: e
        } : e;
        return o ? $ad26fe773541dcd3$export$b410431fab84fa58.update(o, {
            ...a,
            ...r
        }) : $ad26fe773541dcd3$export$b410431fab84fa58(r.render, {
            ...a,
            ...r
        }), s;
    }, c = $ad26fe773541dcd3$var$p(t) ? t() : t;
    return c.then((t)=>l("success", r, t)).catch((t)=>l("error", a, t)), c;
}, $ad26fe773541dcd3$export$b410431fab84fa58.success = $ad26fe773541dcd3$var$q("success"), $ad26fe773541dcd3$export$b410431fab84fa58.info = $ad26fe773541dcd3$var$q("info"), $ad26fe773541dcd3$export$b410431fab84fa58.error = $ad26fe773541dcd3$var$q("error"), $ad26fe773541dcd3$export$b410431fab84fa58.warning = $ad26fe773541dcd3$var$q("warning"), $ad26fe773541dcd3$export$b410431fab84fa58.warn = $ad26fe773541dcd3$export$b410431fab84fa58.warning, $ad26fe773541dcd3$export$b410431fab84fa58.dark = (t, e)=>$ad26fe773541dcd3$var$H(t, $ad26fe773541dcd3$var$S("default", {
        theme: "dark",
        ...e
    })), $ad26fe773541dcd3$export$b410431fab84fa58.dismiss = (t)=>{
    $ad26fe773541dcd3$var$B.size > 0 ? $ad26fe773541dcd3$var$v.emit(1, t) : $ad26fe773541dcd3$var$D = $ad26fe773541dcd3$var$D.filter((e)=>null != t && e.options.toastId !== t);
}, $ad26fe773541dcd3$export$b410431fab84fa58.clearWaitingQueue = function(t) {
    return void 0 === t && (t = {}), $ad26fe773541dcd3$var$v.emit(5, t);
}, $ad26fe773541dcd3$export$b410431fab84fa58.isActive = (t)=>{
    let e = !1;
    return $ad26fe773541dcd3$var$B.forEach((n)=>{
        n.isToastActive && n.isToastActive(t) && (e = !0);
    }), e;
}, $ad26fe773541dcd3$export$b410431fab84fa58.update = function(t, e) {
    void 0 === e && (e = {}), setTimeout(()=>{
        const n = function(t, e) {
            let { containerId: n } = e;
            const o = $ad26fe773541dcd3$var$B.get(n || $ad26fe773541dcd3$var$P);
            return o && o.getToast(t);
        }(t, e);
        if (n) {
            const { props: o, content: s } = n, a = {
                delay: 100,
                ...o,
                ...e,
                toastId: e.toastId || t,
                updateId: $ad26fe773541dcd3$var$z()
            };
            a.toastId !== t && (a.staleId = t);
            const r = a.render || s;
            delete a.render, $ad26fe773541dcd3$var$H(r, a);
        }
    }, 0);
}, $ad26fe773541dcd3$export$b410431fab84fa58.done = (t)=>{
    $ad26fe773541dcd3$export$b410431fab84fa58.update(t, {
        progress: 1
    });
}, $ad26fe773541dcd3$export$b410431fab84fa58.onChange = (t)=>($ad26fe773541dcd3$var$v.on(4, t), ()=>{
        $ad26fe773541dcd3$var$v.off(4, t);
    }), $ad26fe773541dcd3$export$b410431fab84fa58.POSITION = {
    TOP_LEFT: "top-left",
    TOP_RIGHT: "top-right",
    TOP_CENTER: "top-center",
    BOTTOM_LEFT: "bottom-left",
    BOTTOM_RIGHT: "bottom-right",
    BOTTOM_CENTER: "bottom-center"
}, $ad26fe773541dcd3$export$b410431fab84fa58.TYPE = {
    INFO: "info",
    SUCCESS: "success",
    WARNING: "warning",
    ERROR: "error",
    DEFAULT: "default"
}, $ad26fe773541dcd3$var$v.on(2, (t)=>{
    $ad26fe773541dcd3$var$P = t.containerId || t, $ad26fe773541dcd3$var$B.set($ad26fe773541dcd3$var$P, t), $ad26fe773541dcd3$var$D.forEach((t)=>{
        $ad26fe773541dcd3$var$v.emit(0, t.content, t.options);
    }), $ad26fe773541dcd3$var$D = [];
}).on(3, (t)=>{
    $ad26fe773541dcd3$var$B.delete(t.containerId || t), 0 === $ad26fe773541dcd3$var$B.size && $ad26fe773541dcd3$var$v.off(0).off(1).off(5);
});


"use strict";
function $e5cb5cefd6507f7e$export$2e2bcd8739ae039(fn, thisArg) {
    return function wrap() {
        return fn.apply(thisArg, arguments);
    };
}


"use strict";
// utils is a library of generic helper functions non-specific to axios
const { toString: $c319b2c832c2914a$var$toString } = Object.prototype;
const { getPrototypeOf: $c319b2c832c2914a$var$getPrototypeOf } = Object;
const $c319b2c832c2914a$var$kindOf = ((cache)=>(thing)=>{
        const str = $c319b2c832c2914a$var$toString.call(thing);
        return cache[str] || (cache[str] = str.slice(8, -1).toLowerCase());
    })(Object.create(null));
const $c319b2c832c2914a$var$kindOfTest = (type)=>{
    type = type.toLowerCase();
    return (thing)=>$c319b2c832c2914a$var$kindOf(thing) === type;
};
const $c319b2c832c2914a$var$typeOfTest = (type)=>(thing)=>typeof thing === type;
/**
 * Determine if a value is an Array
 *
 * @param {Object} val The value to test
 *
 * @returns {boolean} True if value is an Array, otherwise false
 */ const { isArray: $c319b2c832c2914a$var$isArray } = Array;
/**
 * Determine if a value is undefined
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if the value is undefined, otherwise false
 */ const $c319b2c832c2914a$var$isUndefined = $c319b2c832c2914a$var$typeOfTest("undefined");
/**
 * Determine if a value is a Buffer
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a Buffer, otherwise false
 */ function $c319b2c832c2914a$var$isBuffer(val) {
    return val !== null && !$c319b2c832c2914a$var$isUndefined(val) && val.constructor !== null && !$c319b2c832c2914a$var$isUndefined(val.constructor) && $c319b2c832c2914a$var$isFunction(val.constructor.isBuffer) && val.constructor.isBuffer(val);
}
/**
 * Determine if a value is an ArrayBuffer
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is an ArrayBuffer, otherwise false
 */ const $c319b2c832c2914a$var$isArrayBuffer = $c319b2c832c2914a$var$kindOfTest("ArrayBuffer");
/**
 * Determine if a value is a view on an ArrayBuffer
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a view on an ArrayBuffer, otherwise false
 */ function $c319b2c832c2914a$var$isArrayBufferView(val) {
    let result;
    if (typeof ArrayBuffer !== "undefined" && ArrayBuffer.isView) result = ArrayBuffer.isView(val);
    else result = val && val.buffer && $c319b2c832c2914a$var$isArrayBuffer(val.buffer);
    return result;
}
/**
 * Determine if a value is a String
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a String, otherwise false
 */ const $c319b2c832c2914a$var$isString = $c319b2c832c2914a$var$typeOfTest("string");
/**
 * Determine if a value is a Function
 *
 * @param {*} val The value to test
 * @returns {boolean} True if value is a Function, otherwise false
 */ const $c319b2c832c2914a$var$isFunction = $c319b2c832c2914a$var$typeOfTest("function");
/**
 * Determine if a value is a Number
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a Number, otherwise false
 */ const $c319b2c832c2914a$var$isNumber = $c319b2c832c2914a$var$typeOfTest("number");
/**
 * Determine if a value is an Object
 *
 * @param {*} thing The value to test
 *
 * @returns {boolean} True if value is an Object, otherwise false
 */ const $c319b2c832c2914a$var$isObject = (thing)=>thing !== null && typeof thing === "object";
/**
 * Determine if a value is a Boolean
 *
 * @param {*} thing The value to test
 * @returns {boolean} True if value is a Boolean, otherwise false
 */ const $c319b2c832c2914a$var$isBoolean = (thing)=>thing === true || thing === false;
/**
 * Determine if a value is a plain Object
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a plain Object, otherwise false
 */ const $c319b2c832c2914a$var$isPlainObject = (val)=>{
    if ($c319b2c832c2914a$var$kindOf(val) !== "object") return false;
    const prototype = $c319b2c832c2914a$var$getPrototypeOf(val);
    return (prototype === null || prototype === Object.prototype || Object.getPrototypeOf(prototype) === null) && !(Symbol.toStringTag in val) && !(Symbol.iterator in val);
};
/**
 * Determine if a value is a Date
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a Date, otherwise false
 */ const $c319b2c832c2914a$var$isDate = $c319b2c832c2914a$var$kindOfTest("Date");
/**
 * Determine if a value is a File
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a File, otherwise false
 */ const $c319b2c832c2914a$var$isFile = $c319b2c832c2914a$var$kindOfTest("File");
/**
 * Determine if a value is a Blob
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a Blob, otherwise false
 */ const $c319b2c832c2914a$var$isBlob = $c319b2c832c2914a$var$kindOfTest("Blob");
/**
 * Determine if a value is a FileList
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a File, otherwise false
 */ const $c319b2c832c2914a$var$isFileList = $c319b2c832c2914a$var$kindOfTest("FileList");
/**
 * Determine if a value is a Stream
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a Stream, otherwise false
 */ const $c319b2c832c2914a$var$isStream = (val)=>$c319b2c832c2914a$var$isObject(val) && $c319b2c832c2914a$var$isFunction(val.pipe);
/**
 * Determine if a value is a FormData
 *
 * @param {*} thing The value to test
 *
 * @returns {boolean} True if value is an FormData, otherwise false
 */ const $c319b2c832c2914a$var$isFormData = (thing)=>{
    let kind;
    return thing && (typeof FormData === "function" && thing instanceof FormData || $c319b2c832c2914a$var$isFunction(thing.append) && ((kind = $c319b2c832c2914a$var$kindOf(thing)) === "formdata" || // detect form-data instance
    kind === "object" && $c319b2c832c2914a$var$isFunction(thing.toString) && thing.toString() === "[object FormData]"));
};
/**
 * Determine if a value is a URLSearchParams object
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a URLSearchParams object, otherwise false
 */ const $c319b2c832c2914a$var$isURLSearchParams = $c319b2c832c2914a$var$kindOfTest("URLSearchParams");
/**
 * Trim excess whitespace off the beginning and end of a string
 *
 * @param {String} str The String to trim
 *
 * @returns {String} The String freed of excess whitespace
 */ const $c319b2c832c2914a$var$trim = (str)=>str.trim ? str.trim() : str.replace(/^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g, "");
/**
 * Iterate over an Array or an Object invoking a function for each item.
 *
 * If `obj` is an Array callback will be called passing
 * the value, index, and complete array for each item.
 *
 * If 'obj' is an Object callback will be called passing
 * the value, key, and complete object for each property.
 *
 * @param {Object|Array} obj The object to iterate
 * @param {Function} fn The callback to invoke for each item
 *
 * @param {Boolean} [allOwnKeys = false]
 * @returns {any}
 */ function $c319b2c832c2914a$var$forEach(obj, fn, { allOwnKeys: allOwnKeys = false } = {}) {
    // Don't bother if no value provided
    if (obj === null || typeof obj === "undefined") return;
    let i;
    let l;
    // Force an array if not already something iterable
    if (typeof obj !== "object") /*eslint no-param-reassign:0*/ obj = [
        obj
    ];
    if ($c319b2c832c2914a$var$isArray(obj)) // Iterate over array values
    for(i = 0, l = obj.length; i < l; i++)fn.call(null, obj[i], i, obj);
    else {
        // Iterate over object keys
        const keys = allOwnKeys ? Object.getOwnPropertyNames(obj) : Object.keys(obj);
        const len = keys.length;
        let key;
        for(i = 0; i < len; i++){
            key = keys[i];
            fn.call(null, obj[key], key, obj);
        }
    }
}
function $c319b2c832c2914a$var$findKey(obj, key) {
    key = key.toLowerCase();
    const keys = Object.keys(obj);
    let i = keys.length;
    let _key;
    while(i-- > 0){
        _key = keys[i];
        if (key === _key.toLowerCase()) return _key;
    }
    return null;
}
const $c319b2c832c2914a$var$_global = (()=>{
    /*eslint no-undef:0*/ if (typeof globalThis !== "undefined") return globalThis;
    return typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : $parcel$global;
})();
const $c319b2c832c2914a$var$isContextDefined = (context)=>!$c319b2c832c2914a$var$isUndefined(context) && context !== $c319b2c832c2914a$var$_global;
/**
 * Accepts varargs expecting each argument to be an object, then
 * immutably merges the properties of each object and returns result.
 *
 * When multiple objects contain the same key the later object in
 * the arguments list will take precedence.
 *
 * Example:
 *
 * ```js
 * var result = merge({foo: 123}, {foo: 456});
 * console.log(result.foo); // outputs 456
 * ```
 *
 * @param {Object} obj1 Object to merge
 *
 * @returns {Object} Result of all merge properties
 */ function $c319b2c832c2914a$var$merge() {
    const { caseless: caseless } = $c319b2c832c2914a$var$isContextDefined(this) && this || {};
    const result = {};
    const assignValue = (val, key)=>{
        const targetKey = caseless && $c319b2c832c2914a$var$findKey(result, key) || key;
        if ($c319b2c832c2914a$var$isPlainObject(result[targetKey]) && $c319b2c832c2914a$var$isPlainObject(val)) result[targetKey] = $c319b2c832c2914a$var$merge(result[targetKey], val);
        else if ($c319b2c832c2914a$var$isPlainObject(val)) result[targetKey] = $c319b2c832c2914a$var$merge({}, val);
        else if ($c319b2c832c2914a$var$isArray(val)) result[targetKey] = val.slice();
        else result[targetKey] = val;
    };
    for(let i = 0, l = arguments.length; i < l; i++)arguments[i] && $c319b2c832c2914a$var$forEach(arguments[i], assignValue);
    return result;
}
/**
 * Extends object a by mutably adding to it the properties of object b.
 *
 * @param {Object} a The object to be extended
 * @param {Object} b The object to copy properties from
 * @param {Object} thisArg The object to bind function to
 *
 * @param {Boolean} [allOwnKeys]
 * @returns {Object} The resulting value of object a
 */ const $c319b2c832c2914a$var$extend = (a, b, thisArg, { allOwnKeys: allOwnKeys } = {})=>{
    $c319b2c832c2914a$var$forEach(b, (val, key)=>{
        if (thisArg && $c319b2c832c2914a$var$isFunction(val)) a[key] = (0, $e5cb5cefd6507f7e$export$2e2bcd8739ae039)(val, thisArg);
        else a[key] = val;
    }, {
        allOwnKeys: allOwnKeys
    });
    return a;
};
/**
 * Remove byte order marker. This catches EF BB BF (the UTF-8 BOM)
 *
 * @param {string} content with BOM
 *
 * @returns {string} content value without BOM
 */ const $c319b2c832c2914a$var$stripBOM = (content)=>{
    if (content.charCodeAt(0) === 0xFEFF) content = content.slice(1);
    return content;
};
/**
 * Inherit the prototype methods from one constructor into another
 * @param {function} constructor
 * @param {function} superConstructor
 * @param {object} [props]
 * @param {object} [descriptors]
 *
 * @returns {void}
 */ const $c319b2c832c2914a$var$inherits = (constructor, superConstructor, props, descriptors)=>{
    constructor.prototype = Object.create(superConstructor.prototype, descriptors);
    constructor.prototype.constructor = constructor;
    Object.defineProperty(constructor, "super", {
        value: superConstructor.prototype
    });
    props && Object.assign(constructor.prototype, props);
};
/**
 * Resolve object with deep prototype chain to a flat object
 * @param {Object} sourceObj source object
 * @param {Object} [destObj]
 * @param {Function|Boolean} [filter]
 * @param {Function} [propFilter]
 *
 * @returns {Object}
 */ const $c319b2c832c2914a$var$toFlatObject = (sourceObj, destObj, filter, propFilter)=>{
    let props;
    let i;
    let prop;
    const merged = {};
    destObj = destObj || {};
    // eslint-disable-next-line no-eq-null,eqeqeq
    if (sourceObj == null) return destObj;
    do {
        props = Object.getOwnPropertyNames(sourceObj);
        i = props.length;
        while(i-- > 0){
            prop = props[i];
            if ((!propFilter || propFilter(prop, sourceObj, destObj)) && !merged[prop]) {
                destObj[prop] = sourceObj[prop];
                merged[prop] = true;
            }
        }
        sourceObj = filter !== false && $c319b2c832c2914a$var$getPrototypeOf(sourceObj);
    }while (sourceObj && (!filter || filter(sourceObj, destObj)) && sourceObj !== Object.prototype);
    return destObj;
};
/**
 * Determines whether a string ends with the characters of a specified string
 *
 * @param {String} str
 * @param {String} searchString
 * @param {Number} [position= 0]
 *
 * @returns {boolean}
 */ const $c319b2c832c2914a$var$endsWith = (str, searchString, position)=>{
    str = String(str);
    if (position === undefined || position > str.length) position = str.length;
    position -= searchString.length;
    const lastIndex = str.indexOf(searchString, position);
    return lastIndex !== -1 && lastIndex === position;
};
/**
 * Returns new array from array like object or null if failed
 *
 * @param {*} [thing]
 *
 * @returns {?Array}
 */ const $c319b2c832c2914a$var$toArray = (thing)=>{
    if (!thing) return null;
    if ($c319b2c832c2914a$var$isArray(thing)) return thing;
    let i = thing.length;
    if (!$c319b2c832c2914a$var$isNumber(i)) return null;
    const arr = new Array(i);
    while(i-- > 0)arr[i] = thing[i];
    return arr;
};
/**
 * Checking if the Uint8Array exists and if it does, it returns a function that checks if the
 * thing passed in is an instance of Uint8Array
 *
 * @param {TypedArray}
 *
 * @returns {Array}
 */ // eslint-disable-next-line func-names
const $c319b2c832c2914a$var$isTypedArray = ((TypedArray)=>{
    // eslint-disable-next-line func-names
    return (thing)=>{
        return TypedArray && thing instanceof TypedArray;
    };
})(typeof Uint8Array !== "undefined" && $c319b2c832c2914a$var$getPrototypeOf(Uint8Array));
/**
 * For each entry in the object, call the function with the key and value.
 *
 * @param {Object<any, any>} obj - The object to iterate over.
 * @param {Function} fn - The function to call for each entry.
 *
 * @returns {void}
 */ const $c319b2c832c2914a$var$forEachEntry = (obj, fn)=>{
    const generator = obj && obj[Symbol.iterator];
    const iterator = generator.call(obj);
    let result;
    while((result = iterator.next()) && !result.done){
        const pair = result.value;
        fn.call(obj, pair[0], pair[1]);
    }
};
/**
 * It takes a regular expression and a string, and returns an array of all the matches
 *
 * @param {string} regExp - The regular expression to match against.
 * @param {string} str - The string to search.
 *
 * @returns {Array<boolean>}
 */ const $c319b2c832c2914a$var$matchAll = (regExp, str)=>{
    let matches;
    const arr = [];
    while((matches = regExp.exec(str)) !== null)arr.push(matches);
    return arr;
};
/* Checking if the kindOfTest function returns true when passed an HTMLFormElement. */ const $c319b2c832c2914a$var$isHTMLForm = $c319b2c832c2914a$var$kindOfTest("HTMLFormElement");
const $c319b2c832c2914a$var$toCamelCase = (str)=>{
    return str.toLowerCase().replace(/[-_\s]([a-z\d])(\w*)/g, function replacer(m, p1, p2) {
        return p1.toUpperCase() + p2;
    });
};
/* Creating a function that will check if an object has a property. */ const $c319b2c832c2914a$var$hasOwnProperty = (({ hasOwnProperty: hasOwnProperty })=>(obj, prop)=>hasOwnProperty.call(obj, prop))(Object.prototype);
/**
 * Determine if a value is a RegExp object
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a RegExp object, otherwise false
 */ const $c319b2c832c2914a$var$isRegExp = $c319b2c832c2914a$var$kindOfTest("RegExp");
const $c319b2c832c2914a$var$reduceDescriptors = (obj, reducer)=>{
    const descriptors = Object.getOwnPropertyDescriptors(obj);
    const reducedDescriptors = {};
    $c319b2c832c2914a$var$forEach(descriptors, (descriptor, name)=>{
        let ret;
        if ((ret = reducer(descriptor, name, obj)) !== false) reducedDescriptors[name] = ret || descriptor;
    });
    Object.defineProperties(obj, reducedDescriptors);
};
/**
 * Makes all methods read-only
 * @param {Object} obj
 */ const $c319b2c832c2914a$var$freezeMethods = (obj)=>{
    $c319b2c832c2914a$var$reduceDescriptors(obj, (descriptor, name)=>{
        // skip restricted props in strict mode
        if ($c319b2c832c2914a$var$isFunction(obj) && [
            "arguments",
            "caller",
            "callee"
        ].indexOf(name) !== -1) return false;
        const value = obj[name];
        if (!$c319b2c832c2914a$var$isFunction(value)) return;
        descriptor.enumerable = false;
        if ("writable" in descriptor) {
            descriptor.writable = false;
            return;
        }
        if (!descriptor.set) descriptor.set = ()=>{
            throw Error("Can not rewrite read-only method '" + name + "'");
        };
    });
};
const $c319b2c832c2914a$var$toObjectSet = (arrayOrString, delimiter)=>{
    const obj = {};
    const define = (arr)=>{
        arr.forEach((value)=>{
            obj[value] = true;
        });
    };
    $c319b2c832c2914a$var$isArray(arrayOrString) ? define(arrayOrString) : define(String(arrayOrString).split(delimiter));
    return obj;
};
const $c319b2c832c2914a$var$noop = ()=>{};
const $c319b2c832c2914a$var$toFiniteNumber = (value, defaultValue)=>{
    value = +value;
    return Number.isFinite(value) ? value : defaultValue;
};
const $c319b2c832c2914a$var$ALPHA = "abcdefghijklmnopqrstuvwxyz";
const $c319b2c832c2914a$var$DIGIT = "0123456789";
const $c319b2c832c2914a$var$ALPHABET = {
    DIGIT: $c319b2c832c2914a$var$DIGIT,
    ALPHA: $c319b2c832c2914a$var$ALPHA,
    ALPHA_DIGIT: $c319b2c832c2914a$var$ALPHA + $c319b2c832c2914a$var$ALPHA.toUpperCase() + $c319b2c832c2914a$var$DIGIT
};
const $c319b2c832c2914a$var$generateString = (size = 16, alphabet = $c319b2c832c2914a$var$ALPHABET.ALPHA_DIGIT)=>{
    let str = "";
    const { length: length } = alphabet;
    while(size--)str += alphabet[Math.random() * length | 0];
    return str;
};
/**
 * If the thing is a FormData object, return true, otherwise return false.
 *
 * @param {unknown} thing - The thing to check.
 *
 * @returns {boolean}
 */ function $c319b2c832c2914a$var$isSpecCompliantForm(thing) {
    return !!(thing && $c319b2c832c2914a$var$isFunction(thing.append) && thing[Symbol.toStringTag] === "FormData" && thing[Symbol.iterator]);
}
const $c319b2c832c2914a$var$toJSONObject = (obj)=>{
    const stack = new Array(10);
    const visit = (source, i)=>{
        if ($c319b2c832c2914a$var$isObject(source)) {
            if (stack.indexOf(source) >= 0) return;
            if (!("toJSON" in source)) {
                stack[i] = source;
                const target = $c319b2c832c2914a$var$isArray(source) ? [] : {};
                $c319b2c832c2914a$var$forEach(source, (value, key)=>{
                    const reducedValue = visit(value, i + 1);
                    !$c319b2c832c2914a$var$isUndefined(reducedValue) && (target[key] = reducedValue);
                });
                stack[i] = undefined;
                return target;
            }
        }
        return source;
    };
    return visit(obj, 0);
};
const $c319b2c832c2914a$var$isAsyncFn = $c319b2c832c2914a$var$kindOfTest("AsyncFunction");
const $c319b2c832c2914a$var$isThenable = (thing)=>thing && ($c319b2c832c2914a$var$isObject(thing) || $c319b2c832c2914a$var$isFunction(thing)) && $c319b2c832c2914a$var$isFunction(thing.then) && $c319b2c832c2914a$var$isFunction(thing.catch);
var $c319b2c832c2914a$export$2e2bcd8739ae039 = {
    isArray: $c319b2c832c2914a$var$isArray,
    isArrayBuffer: $c319b2c832c2914a$var$isArrayBuffer,
    isBuffer: $c319b2c832c2914a$var$isBuffer,
    isFormData: $c319b2c832c2914a$var$isFormData,
    isArrayBufferView: $c319b2c832c2914a$var$isArrayBufferView,
    isString: $c319b2c832c2914a$var$isString,
    isNumber: $c319b2c832c2914a$var$isNumber,
    isBoolean: $c319b2c832c2914a$var$isBoolean,
    isObject: $c319b2c832c2914a$var$isObject,
    isPlainObject: $c319b2c832c2914a$var$isPlainObject,
    isUndefined: $c319b2c832c2914a$var$isUndefined,
    isDate: $c319b2c832c2914a$var$isDate,
    isFile: $c319b2c832c2914a$var$isFile,
    isBlob: $c319b2c832c2914a$var$isBlob,
    isRegExp: $c319b2c832c2914a$var$isRegExp,
    isFunction: $c319b2c832c2914a$var$isFunction,
    isStream: $c319b2c832c2914a$var$isStream,
    isURLSearchParams: $c319b2c832c2914a$var$isURLSearchParams,
    isTypedArray: $c319b2c832c2914a$var$isTypedArray,
    isFileList: $c319b2c832c2914a$var$isFileList,
    forEach: $c319b2c832c2914a$var$forEach,
    merge: $c319b2c832c2914a$var$merge,
    extend: $c319b2c832c2914a$var$extend,
    trim: $c319b2c832c2914a$var$trim,
    stripBOM: $c319b2c832c2914a$var$stripBOM,
    inherits: $c319b2c832c2914a$var$inherits,
    toFlatObject: $c319b2c832c2914a$var$toFlatObject,
    kindOf: $c319b2c832c2914a$var$kindOf,
    kindOfTest: $c319b2c832c2914a$var$kindOfTest,
    endsWith: $c319b2c832c2914a$var$endsWith,
    toArray: $c319b2c832c2914a$var$toArray,
    forEachEntry: $c319b2c832c2914a$var$forEachEntry,
    matchAll: $c319b2c832c2914a$var$matchAll,
    isHTMLForm: $c319b2c832c2914a$var$isHTMLForm,
    hasOwnProperty: $c319b2c832c2914a$var$hasOwnProperty,
    hasOwnProp: $c319b2c832c2914a$var$hasOwnProperty,
    reduceDescriptors: $c319b2c832c2914a$var$reduceDescriptors,
    freezeMethods: $c319b2c832c2914a$var$freezeMethods,
    toObjectSet: $c319b2c832c2914a$var$toObjectSet,
    toCamelCase: $c319b2c832c2914a$var$toCamelCase,
    noop: $c319b2c832c2914a$var$noop,
    toFiniteNumber: $c319b2c832c2914a$var$toFiniteNumber,
    findKey: $c319b2c832c2914a$var$findKey,
    global: $c319b2c832c2914a$var$_global,
    isContextDefined: $c319b2c832c2914a$var$isContextDefined,
    ALPHABET: $c319b2c832c2914a$var$ALPHABET,
    generateString: $c319b2c832c2914a$var$generateString,
    isSpecCompliantForm: $c319b2c832c2914a$var$isSpecCompliantForm,
    toJSONObject: $c319b2c832c2914a$var$toJSONObject,
    isAsyncFn: $c319b2c832c2914a$var$isAsyncFn,
    isThenable: $c319b2c832c2914a$var$isThenable
};







"use strict";
/**
 * Create an Error with the specified message, config, error code, request and response.
 *
 * @param {string} message The error message.
 * @param {string} [code] The error code (for example, 'ECONNABORTED').
 * @param {Object} [config] The config.
 * @param {Object} [request] The request.
 * @param {Object} [response] The response.
 *
 * @returns {Error} The created error.
 */ function $4e2395edb77acf3a$var$AxiosError(message, code, config, request, response) {
    Error.call(this);
    if (Error.captureStackTrace) Error.captureStackTrace(this, this.constructor);
    else this.stack = new Error().stack;
    this.message = message;
    this.name = "AxiosError";
    code && (this.code = code);
    config && (this.config = config);
    request && (this.request = request);
    response && (this.response = response);
}
(0, $c319b2c832c2914a$export$2e2bcd8739ae039).inherits($4e2395edb77acf3a$var$AxiosError, Error, {
    toJSON: function toJSON() {
        return {
            // Standard
            message: this.message,
            name: this.name,
            // Microsoft
            description: this.description,
            number: this.number,
            // Mozilla
            fileName: this.fileName,
            lineNumber: this.lineNumber,
            columnNumber: this.columnNumber,
            stack: this.stack,
            // Axios
            config: (0, $c319b2c832c2914a$export$2e2bcd8739ae039).toJSONObject(this.config),
            code: this.code,
            status: this.response && this.response.status ? this.response.status : null
        };
    }
});
const $4e2395edb77acf3a$var$prototype = $4e2395edb77acf3a$var$AxiosError.prototype;
const $4e2395edb77acf3a$var$descriptors = {};
[
    "ERR_BAD_OPTION_VALUE",
    "ERR_BAD_OPTION",
    "ECONNABORTED",
    "ETIMEDOUT",
    "ERR_NETWORK",
    "ERR_FR_TOO_MANY_REDIRECTS",
    "ERR_DEPRECATED",
    "ERR_BAD_RESPONSE",
    "ERR_BAD_REQUEST",
    "ERR_CANCELED",
    "ERR_NOT_SUPPORT",
    "ERR_INVALID_URL"
].forEach((code)=>{
    $4e2395edb77acf3a$var$descriptors[code] = {
        value: code
    };
});
Object.defineProperties($4e2395edb77acf3a$var$AxiosError, $4e2395edb77acf3a$var$descriptors);
Object.defineProperty($4e2395edb77acf3a$var$prototype, "isAxiosError", {
    value: true
});
// eslint-disable-next-line func-names
$4e2395edb77acf3a$var$AxiosError.from = (error, code, config, request, response, customProps)=>{
    const axiosError = Object.create($4e2395edb77acf3a$var$prototype);
    (0, $c319b2c832c2914a$export$2e2bcd8739ae039).toFlatObject(error, axiosError, function filter(obj) {
        return obj !== Error.prototype;
    }, (prop)=>{
        return prop !== "isAxiosError";
    });
    $4e2395edb77acf3a$var$AxiosError.call(axiosError, error.message, code, config, request, response);
    axiosError.cause = error;
    axiosError.name = error.name;
    customProps && Object.assign(axiosError, customProps);
    return axiosError;
};
var $4e2395edb77acf3a$export$2e2bcd8739ae039 = $4e2395edb77acf3a$var$AxiosError;


// eslint-disable-next-line strict
var $4023ac50ad132196$export$2e2bcd8739ae039 = null;



var $6ZWSX = parcelRequire("6ZWSX");
var $e6cbd383b18c9625$require$Buffer = $6ZWSX.Buffer;
"use strict";
/**
 * Determines if the given thing is a array or js object.
 *
 * @param {string} thing - The object or array to be visited.
 *
 * @returns {boolean}
 */ function $e6cbd383b18c9625$var$isVisitable(thing) {
    return (0, $c319b2c832c2914a$export$2e2bcd8739ae039).isPlainObject(thing) || (0, $c319b2c832c2914a$export$2e2bcd8739ae039).isArray(thing);
}
/**
 * It removes the brackets from the end of a string
 *
 * @param {string} key - The key of the parameter.
 *
 * @returns {string} the key without the brackets.
 */ function $e6cbd383b18c9625$var$removeBrackets(key) {
    return (0, $c319b2c832c2914a$export$2e2bcd8739ae039).endsWith(key, "[]") ? key.slice(0, -2) : key;
}
/**
 * It takes a path, a key, and a boolean, and returns a string
 *
 * @param {string} path - The path to the current key.
 * @param {string} key - The key of the current object being iterated over.
 * @param {string} dots - If true, the key will be rendered with dots instead of brackets.
 *
 * @returns {string} The path to the current key.
 */ function $e6cbd383b18c9625$var$renderKey(path, key, dots) {
    if (!path) return key;
    return path.concat(key).map(function each(token, i) {
        // eslint-disable-next-line no-param-reassign
        token = $e6cbd383b18c9625$var$removeBrackets(token);
        return !dots && i ? "[" + token + "]" : token;
    }).join(dots ? "." : "");
}
/**
 * If the array is an array and none of its elements are visitable, then it's a flat array.
 *
 * @param {Array<any>} arr - The array to check
 *
 * @returns {boolean}
 */ function $e6cbd383b18c9625$var$isFlatArray(arr) {
    return (0, $c319b2c832c2914a$export$2e2bcd8739ae039).isArray(arr) && !arr.some($e6cbd383b18c9625$var$isVisitable);
}
const $e6cbd383b18c9625$var$predicates = (0, $c319b2c832c2914a$export$2e2bcd8739ae039).toFlatObject((0, $c319b2c832c2914a$export$2e2bcd8739ae039), {}, null, function filter(prop) {
    return /^is[A-Z]/.test(prop);
});
/**
 * Convert a data object to FormData
 *
 * @param {Object} obj
 * @param {?Object} [formData]
 * @param {?Object} [options]
 * @param {Function} [options.visitor]
 * @param {Boolean} [options.metaTokens = true]
 * @param {Boolean} [options.dots = false]
 * @param {?Boolean} [options.indexes = false]
 *
 * @returns {Object}
 **/ /**
 * It converts an object into a FormData object
 *
 * @param {Object<any, any>} obj - The object to convert to form data.
 * @param {string} formData - The FormData object to append to.
 * @param {Object<string, any>} options
 *
 * @returns
 */ function $e6cbd383b18c9625$var$toFormData(obj, formData, options) {
    if (!(0, $c319b2c832c2914a$export$2e2bcd8739ae039).isObject(obj)) throw new TypeError("target must be an object");
    // eslint-disable-next-line no-param-reassign
    formData = formData || new ((0, $4023ac50ad132196$export$2e2bcd8739ae039) || FormData)();
    // eslint-disable-next-line no-param-reassign
    options = (0, $c319b2c832c2914a$export$2e2bcd8739ae039).toFlatObject(options, {
        metaTokens: true,
        dots: false,
        indexes: false
    }, false, function defined(option, source) {
        // eslint-disable-next-line no-eq-null,eqeqeq
        return !(0, $c319b2c832c2914a$export$2e2bcd8739ae039).isUndefined(source[option]);
    });
    const metaTokens = options.metaTokens;
    // eslint-disable-next-line no-use-before-define
    const visitor = options.visitor || defaultVisitor;
    const dots = options.dots;
    const indexes = options.indexes;
    const _Blob = options.Blob || typeof Blob !== "undefined" && Blob;
    const useBlob = _Blob && (0, $c319b2c832c2914a$export$2e2bcd8739ae039).isSpecCompliantForm(formData);
    if (!(0, $c319b2c832c2914a$export$2e2bcd8739ae039).isFunction(visitor)) throw new TypeError("visitor must be a function");
    function convertValue(value) {
        if (value === null) return "";
        if ((0, $c319b2c832c2914a$export$2e2bcd8739ae039).isDate(value)) return value.toISOString();
        if (!useBlob && (0, $c319b2c832c2914a$export$2e2bcd8739ae039).isBlob(value)) throw new (0, $4e2395edb77acf3a$export$2e2bcd8739ae039)("Blob is not supported. Use a Buffer instead.");
        if ((0, $c319b2c832c2914a$export$2e2bcd8739ae039).isArrayBuffer(value) || (0, $c319b2c832c2914a$export$2e2bcd8739ae039).isTypedArray(value)) return useBlob && typeof Blob === "function" ? new Blob([
            value
        ]) : $e6cbd383b18c9625$require$Buffer.from(value);
        return value;
    }
    /**
   * Default visitor.
   *
   * @param {*} value
   * @param {String|Number} key
   * @param {Array<String|Number>} path
   * @this {FormData}
   *
   * @returns {boolean} return true to visit the each prop of the value recursively
   */ function defaultVisitor(value, key, path) {
        let arr = value;
        if (value && !path && typeof value === "object") {
            if ((0, $c319b2c832c2914a$export$2e2bcd8739ae039).endsWith(key, "{}")) {
                // eslint-disable-next-line no-param-reassign
                key = metaTokens ? key : key.slice(0, -2);
                // eslint-disable-next-line no-param-reassign
                value = JSON.stringify(value);
            } else if ((0, $c319b2c832c2914a$export$2e2bcd8739ae039).isArray(value) && $e6cbd383b18c9625$var$isFlatArray(value) || ((0, $c319b2c832c2914a$export$2e2bcd8739ae039).isFileList(value) || (0, $c319b2c832c2914a$export$2e2bcd8739ae039).endsWith(key, "[]")) && (arr = (0, $c319b2c832c2914a$export$2e2bcd8739ae039).toArray(value))) {
                // eslint-disable-next-line no-param-reassign
                key = $e6cbd383b18c9625$var$removeBrackets(key);
                arr.forEach(function each(el, index) {
                    !((0, $c319b2c832c2914a$export$2e2bcd8739ae039).isUndefined(el) || el === null) && formData.append(// eslint-disable-next-line no-nested-ternary
                    indexes === true ? $e6cbd383b18c9625$var$renderKey([
                        key
                    ], index, dots) : indexes === null ? key : key + "[]", convertValue(el));
                });
                return false;
            }
        }
        if ($e6cbd383b18c9625$var$isVisitable(value)) return true;
        formData.append($e6cbd383b18c9625$var$renderKey(path, key, dots), convertValue(value));
        return false;
    }
    const stack = [];
    const exposedHelpers = Object.assign($e6cbd383b18c9625$var$predicates, {
        defaultVisitor: defaultVisitor,
        convertValue: convertValue,
        isVisitable: $e6cbd383b18c9625$var$isVisitable
    });
    function build(value, path) {
        if ((0, $c319b2c832c2914a$export$2e2bcd8739ae039).isUndefined(value)) return;
        if (stack.indexOf(value) !== -1) throw Error("Circular reference detected in " + path.join("."));
        stack.push(value);
        (0, $c319b2c832c2914a$export$2e2bcd8739ae039).forEach(value, function each(el, key) {
            const result = !((0, $c319b2c832c2914a$export$2e2bcd8739ae039).isUndefined(el) || el === null) && visitor.call(formData, el, (0, $c319b2c832c2914a$export$2e2bcd8739ae039).isString(key) ? key.trim() : key, path, exposedHelpers);
            if (result === true) build(el, path ? path.concat(key) : [
                key
            ]);
        });
        stack.pop();
    }
    if (!(0, $c319b2c832c2914a$export$2e2bcd8739ae039).isObject(obj)) throw new TypeError("data must be an object");
    build(obj);
    return formData;
}
var $e6cbd383b18c9625$export$2e2bcd8739ae039 = $e6cbd383b18c9625$var$toFormData;


"use strict";
/**
 * It encodes a string by replacing all characters that are not in the unreserved set with
 * their percent-encoded equivalents
 *
 * @param {string} str - The string to encode.
 *
 * @returns {string} The encoded string.
 */ function $f66f8c7b4f247caf$var$encode(str) {
    const charMap = {
        "!": "%21",
        "'": "%27",
        "(": "%28",
        ")": "%29",
        "~": "%7E",
        "%20": "+",
        "%00": "\x00"
    };
    return encodeURIComponent(str).replace(/[!'()~]|%20|%00/g, function replacer(match) {
        return charMap[match];
    });
}
/**
 * It takes a params object and converts it to a FormData object
 *
 * @param {Object<string, any>} params - The parameters to be converted to a FormData object.
 * @param {Object<string, any>} options - The options object passed to the Axios constructor.
 *
 * @returns {void}
 */ function $f66f8c7b4f247caf$var$AxiosURLSearchParams(params, options) {
    this._pairs = [];
    params && (0, $e6cbd383b18c9625$export$2e2bcd8739ae039)(params, this, options);
}
const $f66f8c7b4f247caf$var$prototype = $f66f8c7b4f247caf$var$AxiosURLSearchParams.prototype;
$f66f8c7b4f247caf$var$prototype.append = function append(name, value) {
    this._pairs.push([
        name,
        value
    ]);
};
$f66f8c7b4f247caf$var$prototype.toString = function toString(encoder) {
    const _encode = encoder ? function(value) {
        return encoder.call(this, value, $f66f8c7b4f247caf$var$encode);
    } : $f66f8c7b4f247caf$var$encode;
    return this._pairs.map(function each(pair) {
        return _encode(pair[0]) + "=" + _encode(pair[1]);
    }, "").join("&");
};
var $f66f8c7b4f247caf$export$2e2bcd8739ae039 = $f66f8c7b4f247caf$var$AxiosURLSearchParams;


"use strict";
/**
 * It replaces all instances of the characters `:`, `$`, `,`, `+`, `[`, and `]` with their
 * URI encoded counterparts
 *
 * @param {string} val The value to be encoded.
 *
 * @returns {string} The encoded value.
 */ function $8df8fedf1c1e4428$var$encode(val) {
    return encodeURIComponent(val).replace(/%3A/gi, ":").replace(/%24/g, "$").replace(/%2C/gi, ",").replace(/%20/g, "+").replace(/%5B/gi, "[").replace(/%5D/gi, "]");
}
function $8df8fedf1c1e4428$export$2e2bcd8739ae039(url, params, options) {
    /*eslint no-param-reassign:0*/ if (!params) return url;
    const _encode = options && options.encode || $8df8fedf1c1e4428$var$encode;
    const serializeFn = options && options.serialize;
    let serializedParams;
    if (serializeFn) serializedParams = serializeFn(params, options);
    else serializedParams = (0, $c319b2c832c2914a$export$2e2bcd8739ae039).isURLSearchParams(params) ? params.toString() : new (0, $f66f8c7b4f247caf$export$2e2bcd8739ae039)(params, options).toString(_encode);
    if (serializedParams) {
        const hashmarkIndex = url.indexOf("#");
        if (hashmarkIndex !== -1) url = url.slice(0, hashmarkIndex);
        url += (url.indexOf("?") === -1 ? "?" : "&") + serializedParams;
    }
    return url;
}



"use strict";
class $5de878cd737ef277$var$InterceptorManager {
    constructor(){
        this.handlers = [];
    }
    /**
   * Add a new interceptor to the stack
   *
   * @param {Function} fulfilled The function to handle `then` for a `Promise`
   * @param {Function} rejected The function to handle `reject` for a `Promise`
   *
   * @return {Number} An ID used to remove interceptor later
   */ use(fulfilled, rejected, options) {
        this.handlers.push({
            fulfilled: fulfilled,
            rejected: rejected,
            synchronous: options ? options.synchronous : false,
            runWhen: options ? options.runWhen : null
        });
        return this.handlers.length - 1;
    }
    /**
   * Remove an interceptor from the stack
   *
   * @param {Number} id The ID that was returned by `use`
   *
   * @returns {Boolean} `true` if the interceptor was removed, `false` otherwise
   */ eject(id) {
        if (this.handlers[id]) this.handlers[id] = null;
    }
    /**
   * Clear all interceptors from the stack
   *
   * @returns {void}
   */ clear() {
        if (this.handlers) this.handlers = [];
    }
    /**
   * Iterate over all the registered interceptors
   *
   * This method is particularly useful for skipping over any
   * interceptors that may have become `null` calling `eject`.
   *
   * @param {Function} fn The function to call for each interceptor
   *
   * @returns {void}
   */ forEach(fn) {
        (0, $c319b2c832c2914a$export$2e2bcd8739ae039).forEach(this.handlers, function forEachHandler(h) {
            if (h !== null) fn(h);
        });
    }
}
var $5de878cd737ef277$export$2e2bcd8739ae039 = $5de878cd737ef277$var$InterceptorManager;





"use strict";
var $51466d41a76e5b4b$export$2e2bcd8739ae039 = {
    silentJSONParsing: true,
    forcedJSONParsing: true,
    clarifyTimeoutError: false
};






"use strict";
var $6eeff4490c995137$export$2e2bcd8739ae039 = typeof URLSearchParams !== "undefined" ? URLSearchParams : (0, $f66f8c7b4f247caf$export$2e2bcd8739ae039);


"use strict";
var $86d275a264afb13f$export$2e2bcd8739ae039 = typeof FormData !== "undefined" ? FormData : null;


"use strict";
var $59c79e94740631e4$export$2e2bcd8739ae039 = typeof Blob !== "undefined" ? Blob : null;


var $2f71637df772b183$export$2e2bcd8739ae039 = {
    isBrowser: true,
    classes: {
        URLSearchParams: $6eeff4490c995137$export$2e2bcd8739ae039,
        FormData: $86d275a264afb13f$export$2e2bcd8739ae039,
        Blob: $59c79e94740631e4$export$2e2bcd8739ae039
    },
    protocols: [
        "http",
        "https",
        "file",
        "blob",
        "url",
        "data"
    ]
};


var $565e85ead8bde60a$exports = {};

$parcel$export($565e85ead8bde60a$exports, "hasBrowserEnv", () => $565e85ead8bde60a$export$c4996c4b7b93b0bf);
$parcel$export($565e85ead8bde60a$exports, "hasStandardBrowserEnv", () => $565e85ead8bde60a$export$c0bcc9250309d66);
$parcel$export($565e85ead8bde60a$exports, "hasStandardBrowserWebWorkerEnv", () => $565e85ead8bde60a$export$c81692cf5af97dac);
const $565e85ead8bde60a$export$c4996c4b7b93b0bf = typeof window !== "undefined" && typeof document !== "undefined";
/**
 * Determine if we're running in a standard browser environment
 *
 * This allows axios to run in a web worker, and react-native.
 * Both environments support XMLHttpRequest, but not fully standard globals.
 *
 * web workers:
 *  typeof window -> undefined
 *  typeof document -> undefined
 *
 * react-native:
 *  navigator.product -> 'ReactNative'
 * nativescript
 *  navigator.product -> 'NativeScript' or 'NS'
 *
 * @returns {boolean}
 */ const $565e85ead8bde60a$export$c0bcc9250309d66 = ((product)=>{
    return $565e85ead8bde60a$export$c4996c4b7b93b0bf && [
        "ReactNative",
        "NativeScript",
        "NS"
    ].indexOf(product) < 0;
})(typeof navigator !== "undefined" && navigator.product);
/**
 * Determine if we're running in a standard browser webWorker environment
 *
 * Although the `isStandardBrowserEnv` method indicates that
 * `allows axios to run in a web worker`, the WebWorker will still be
 * filtered out due to its judgment standard
 * `typeof window !== 'undefined' && typeof document !== 'undefined'`.
 * This leads to a problem when axios post `FormData` in webWorker
 */ const $565e85ead8bde60a$export$c81692cf5af97dac = (()=>{
    return typeof WorkerGlobalScope !== "undefined" && // eslint-disable-next-line no-undef
    self instanceof WorkerGlobalScope && typeof self.importScripts === "function";
})();


var $bb8180acb278e187$export$2e2bcd8739ae039 = {
    ...$565e85ead8bde60a$exports,
    ...(0, $2f71637df772b183$export$2e2bcd8739ae039)
};


"use strict";
function $f6f250f62cadb740$export$2e2bcd8739ae039(data, options) {
    return (0, $e6cbd383b18c9625$export$2e2bcd8739ae039)(data, new (0, $bb8180acb278e187$export$2e2bcd8739ae039).classes.URLSearchParams(), Object.assign({
        visitor: function(value, key, path, helpers) {
            if ((0, $bb8180acb278e187$export$2e2bcd8739ae039).isNode && (0, $c319b2c832c2914a$export$2e2bcd8739ae039).isBuffer(value)) {
                this.append(key, value.toString("base64"));
                return false;
            }
            return helpers.defaultVisitor.apply(this, arguments);
        }
    }, options));
}




"use strict";
/**
 * It takes a string like `foo[x][y][z]` and returns an array like `['foo', 'x', 'y', 'z']
 *
 * @param {string} name - The name of the property to get.
 *
 * @returns An array of strings.
 */ function $5f8142930b3b943f$var$parsePropPath(name) {
    // foo[x][y][z]
    // foo.x.y.z
    // foo-x-y-z
    // foo x y z
    return (0, $c319b2c832c2914a$export$2e2bcd8739ae039).matchAll(/\w+|\[(\w*)]/g, name).map((match)=>{
        return match[0] === "[]" ? "" : match[1] || match[0];
    });
}
/**
 * Convert an array to an object.
 *
 * @param {Array<any>} arr - The array to convert to an object.
 *
 * @returns An object with the same keys and values as the array.
 */ function $5f8142930b3b943f$var$arrayToObject(arr) {
    const obj = {};
    const keys = Object.keys(arr);
    let i;
    const len = keys.length;
    let key;
    for(i = 0; i < len; i++){
        key = keys[i];
        obj[key] = arr[key];
    }
    return obj;
}
/**
 * It takes a FormData object and returns a JavaScript object
 *
 * @param {string} formData The FormData object to convert to JSON.
 *
 * @returns {Object<string, any> | null} The converted object.
 */ function $5f8142930b3b943f$var$formDataToJSON(formData) {
    function buildPath(path, value, target, index) {
        let name = path[index++];
        const isNumericKey = Number.isFinite(+name);
        const isLast = index >= path.length;
        name = !name && (0, $c319b2c832c2914a$export$2e2bcd8739ae039).isArray(target) ? target.length : name;
        if (isLast) {
            if ((0, $c319b2c832c2914a$export$2e2bcd8739ae039).hasOwnProp(target, name)) target[name] = [
                target[name],
                value
            ];
            else target[name] = value;
            return !isNumericKey;
        }
        if (!target[name] || !(0, $c319b2c832c2914a$export$2e2bcd8739ae039).isObject(target[name])) target[name] = [];
        const result = buildPath(path, value, target[name], index);
        if (result && (0, $c319b2c832c2914a$export$2e2bcd8739ae039).isArray(target[name])) target[name] = $5f8142930b3b943f$var$arrayToObject(target[name]);
        return !isNumericKey;
    }
    if ((0, $c319b2c832c2914a$export$2e2bcd8739ae039).isFormData(formData) && (0, $c319b2c832c2914a$export$2e2bcd8739ae039).isFunction(formData.entries)) {
        const obj = {};
        (0, $c319b2c832c2914a$export$2e2bcd8739ae039).forEachEntry(formData, (name, value)=>{
            buildPath($5f8142930b3b943f$var$parsePropPath(name), value, obj, 0);
        });
        return obj;
    }
    return null;
}
var $5f8142930b3b943f$export$2e2bcd8739ae039 = $5f8142930b3b943f$var$formDataToJSON;


"use strict";
/**
 * It takes a string, tries to parse it, and if it fails, it returns the stringified version
 * of the input
 *
 * @param {any} rawValue - The value to be stringified.
 * @param {Function} parser - A function that parses a string into a JavaScript object.
 * @param {Function} encoder - A function that takes a value and returns a string.
 *
 * @returns {string} A stringified version of the rawValue.
 */ function $843bf0209bc94df8$var$stringifySafely(rawValue, parser, encoder) {
    if ((0, $c319b2c832c2914a$export$2e2bcd8739ae039).isString(rawValue)) try {
        (parser || JSON.parse)(rawValue);
        return (0, $c319b2c832c2914a$export$2e2bcd8739ae039).trim(rawValue);
    } catch (e) {
        if (e.name !== "SyntaxError") throw e;
    }
    return (encoder || JSON.stringify)(rawValue);
}
const $843bf0209bc94df8$var$defaults = {
    transitional: (0, $51466d41a76e5b4b$export$2e2bcd8739ae039),
    adapter: [
        "xhr",
        "http"
    ],
    transformRequest: [
        function transformRequest(data, headers) {
            const contentType = headers.getContentType() || "";
            const hasJSONContentType = contentType.indexOf("application/json") > -1;
            const isObjectPayload = (0, $c319b2c832c2914a$export$2e2bcd8739ae039).isObject(data);
            if (isObjectPayload && (0, $c319b2c832c2914a$export$2e2bcd8739ae039).isHTMLForm(data)) data = new FormData(data);
            const isFormData = (0, $c319b2c832c2914a$export$2e2bcd8739ae039).isFormData(data);
            if (isFormData) {
                if (!hasJSONContentType) return data;
                return hasJSONContentType ? JSON.stringify((0, $5f8142930b3b943f$export$2e2bcd8739ae039)(data)) : data;
            }
            if ((0, $c319b2c832c2914a$export$2e2bcd8739ae039).isArrayBuffer(data) || (0, $c319b2c832c2914a$export$2e2bcd8739ae039).isBuffer(data) || (0, $c319b2c832c2914a$export$2e2bcd8739ae039).isStream(data) || (0, $c319b2c832c2914a$export$2e2bcd8739ae039).isFile(data) || (0, $c319b2c832c2914a$export$2e2bcd8739ae039).isBlob(data)) return data;
            if ((0, $c319b2c832c2914a$export$2e2bcd8739ae039).isArrayBufferView(data)) return data.buffer;
            if ((0, $c319b2c832c2914a$export$2e2bcd8739ae039).isURLSearchParams(data)) {
                headers.setContentType("application/x-www-form-urlencoded;charset=utf-8", false);
                return data.toString();
            }
            let isFileList;
            if (isObjectPayload) {
                if (contentType.indexOf("application/x-www-form-urlencoded") > -1) return (0, $f6f250f62cadb740$export$2e2bcd8739ae039)(data, this.formSerializer).toString();
                if ((isFileList = (0, $c319b2c832c2914a$export$2e2bcd8739ae039).isFileList(data)) || contentType.indexOf("multipart/form-data") > -1) {
                    const _FormData = this.env && this.env.FormData;
                    return (0, $e6cbd383b18c9625$export$2e2bcd8739ae039)(isFileList ? {
                        "files[]": data
                    } : data, _FormData && new _FormData(), this.formSerializer);
                }
            }
            if (isObjectPayload || hasJSONContentType) {
                headers.setContentType("application/json", false);
                return $843bf0209bc94df8$var$stringifySafely(data);
            }
            return data;
        }
    ],
    transformResponse: [
        function transformResponse(data) {
            const transitional = this.transitional || $843bf0209bc94df8$var$defaults.transitional;
            const forcedJSONParsing = transitional && transitional.forcedJSONParsing;
            const JSONRequested = this.responseType === "json";
            if (data && (0, $c319b2c832c2914a$export$2e2bcd8739ae039).isString(data) && (forcedJSONParsing && !this.responseType || JSONRequested)) {
                const silentJSONParsing = transitional && transitional.silentJSONParsing;
                const strictJSONParsing = !silentJSONParsing && JSONRequested;
                try {
                    return JSON.parse(data);
                } catch (e) {
                    if (strictJSONParsing) {
                        if (e.name === "SyntaxError") throw (0, $4e2395edb77acf3a$export$2e2bcd8739ae039).from(e, (0, $4e2395edb77acf3a$export$2e2bcd8739ae039).ERR_BAD_RESPONSE, this, null, this.response);
                        throw e;
                    }
                }
            }
            return data;
        }
    ],
    /**
   * A timeout in milliseconds to abort a request. If set to 0 (default) a
   * timeout is not created.
   */ timeout: 0,
    xsrfCookieName: "XSRF-TOKEN",
    xsrfHeaderName: "X-XSRF-TOKEN",
    maxContentLength: -1,
    maxBodyLength: -1,
    env: {
        FormData: (0, $bb8180acb278e187$export$2e2bcd8739ae039).classes.FormData,
        Blob: (0, $bb8180acb278e187$export$2e2bcd8739ae039).classes.Blob
    },
    validateStatus: function validateStatus(status) {
        return status >= 200 && status < 300;
    },
    headers: {
        common: {
            "Accept": "application/json, text/plain, */*",
            "Content-Type": undefined
        }
    }
};
(0, $c319b2c832c2914a$export$2e2bcd8739ae039).forEach([
    "delete",
    "get",
    "head",
    "post",
    "put",
    "patch"
], (method)=>{
    $843bf0209bc94df8$var$defaults.headers[method] = {};
});
var $843bf0209bc94df8$export$2e2bcd8739ae039 = $843bf0209bc94df8$var$defaults;




"use strict";
// RawAxiosHeaders whose duplicates are ignored by node
// c.f. https://nodejs.org/api/http.html#http_message_headers
const $fc026bbf9ee156f1$var$ignoreDuplicateOf = (0, $c319b2c832c2914a$export$2e2bcd8739ae039).toObjectSet([
    "age",
    "authorization",
    "content-length",
    "content-type",
    "etag",
    "expires",
    "from",
    "host",
    "if-modified-since",
    "if-unmodified-since",
    "last-modified",
    "location",
    "max-forwards",
    "proxy-authorization",
    "referer",
    "retry-after",
    "user-agent"
]);
var /**
 * Parse headers into an object
 *
 * ```
 * Date: Wed, 27 Aug 2014 08:58:49 GMT
 * Content-Type: application/json
 * Connection: keep-alive
 * Transfer-Encoding: chunked
 * ```
 *
 * @param {String} rawHeaders Headers needing to be parsed
 *
 * @returns {Object} Headers parsed into an object
 */ $fc026bbf9ee156f1$export$2e2bcd8739ae039 = (rawHeaders)=>{
    const parsed = {};
    let key;
    let val;
    let i;
    rawHeaders && rawHeaders.split("\n").forEach(function parser(line) {
        i = line.indexOf(":");
        key = line.substring(0, i).trim().toLowerCase();
        val = line.substring(i + 1).trim();
        if (!key || parsed[key] && $fc026bbf9ee156f1$var$ignoreDuplicateOf[key]) return;
        if (key === "set-cookie") {
            if (parsed[key]) parsed[key].push(val);
            else parsed[key] = [
                val
            ];
        } else parsed[key] = parsed[key] ? parsed[key] + ", " + val : val;
    });
    return parsed;
};


"use strict";
const $866cce54f6bdfb0c$var$$internals = Symbol("internals");
function $866cce54f6bdfb0c$var$normalizeHeader(header) {
    return header && String(header).trim().toLowerCase();
}
function $866cce54f6bdfb0c$var$normalizeValue(value) {
    if (value === false || value == null) return value;
    return (0, $c319b2c832c2914a$export$2e2bcd8739ae039).isArray(value) ? value.map($866cce54f6bdfb0c$var$normalizeValue) : String(value);
}
function $866cce54f6bdfb0c$var$parseTokens(str) {
    const tokens = Object.create(null);
    const tokensRE = /([^\s,;=]+)\s*(?:=\s*([^,;]+))?/g;
    let match;
    while(match = tokensRE.exec(str))tokens[match[1]] = match[2];
    return tokens;
}
const $866cce54f6bdfb0c$var$isValidHeaderName = (str)=>/^[-_a-zA-Z0-9^`|~,!#$%&'*+.]+$/.test(str.trim());
function $866cce54f6bdfb0c$var$matchHeaderValue(context, value, header, filter, isHeaderNameFilter) {
    if ((0, $c319b2c832c2914a$export$2e2bcd8739ae039).isFunction(filter)) return filter.call(this, value, header);
    if (isHeaderNameFilter) value = header;
    if (!(0, $c319b2c832c2914a$export$2e2bcd8739ae039).isString(value)) return;
    if ((0, $c319b2c832c2914a$export$2e2bcd8739ae039).isString(filter)) return value.indexOf(filter) !== -1;
    if ((0, $c319b2c832c2914a$export$2e2bcd8739ae039).isRegExp(filter)) return filter.test(value);
}
function $866cce54f6bdfb0c$var$formatHeader(header) {
    return header.trim().toLowerCase().replace(/([a-z\d])(\w*)/g, (w, char, str)=>{
        return char.toUpperCase() + str;
    });
}
function $866cce54f6bdfb0c$var$buildAccessors(obj, header) {
    const accessorName = (0, $c319b2c832c2914a$export$2e2bcd8739ae039).toCamelCase(" " + header);
    [
        "get",
        "set",
        "has"
    ].forEach((methodName)=>{
        Object.defineProperty(obj, methodName + accessorName, {
            value: function(arg1, arg2, arg3) {
                return this[methodName].call(this, header, arg1, arg2, arg3);
            },
            configurable: true
        });
    });
}
class $866cce54f6bdfb0c$var$AxiosHeaders {
    constructor(headers){
        headers && this.set(headers);
    }
    set(header, valueOrRewrite, rewrite) {
        const self = this;
        function setHeader(_value, _header, _rewrite) {
            const lHeader = $866cce54f6bdfb0c$var$normalizeHeader(_header);
            if (!lHeader) throw new Error("header name must be a non-empty string");
            const key = (0, $c319b2c832c2914a$export$2e2bcd8739ae039).findKey(self, lHeader);
            if (!key || self[key] === undefined || _rewrite === true || _rewrite === undefined && self[key] !== false) self[key || _header] = $866cce54f6bdfb0c$var$normalizeValue(_value);
        }
        const setHeaders = (headers, _rewrite)=>(0, $c319b2c832c2914a$export$2e2bcd8739ae039).forEach(headers, (_value, _header)=>setHeader(_value, _header, _rewrite));
        if ((0, $c319b2c832c2914a$export$2e2bcd8739ae039).isPlainObject(header) || header instanceof this.constructor) setHeaders(header, valueOrRewrite);
        else if ((0, $c319b2c832c2914a$export$2e2bcd8739ae039).isString(header) && (header = header.trim()) && !$866cce54f6bdfb0c$var$isValidHeaderName(header)) setHeaders((0, $fc026bbf9ee156f1$export$2e2bcd8739ae039)(header), valueOrRewrite);
        else header != null && setHeader(valueOrRewrite, header, rewrite);
        return this;
    }
    get(header, parser) {
        header = $866cce54f6bdfb0c$var$normalizeHeader(header);
        if (header) {
            const key = (0, $c319b2c832c2914a$export$2e2bcd8739ae039).findKey(this, header);
            if (key) {
                const value = this[key];
                if (!parser) return value;
                if (parser === true) return $866cce54f6bdfb0c$var$parseTokens(value);
                if ((0, $c319b2c832c2914a$export$2e2bcd8739ae039).isFunction(parser)) return parser.call(this, value, key);
                if ((0, $c319b2c832c2914a$export$2e2bcd8739ae039).isRegExp(parser)) return parser.exec(value);
                throw new TypeError("parser must be boolean|regexp|function");
            }
        }
    }
    has(header, matcher) {
        header = $866cce54f6bdfb0c$var$normalizeHeader(header);
        if (header) {
            const key = (0, $c319b2c832c2914a$export$2e2bcd8739ae039).findKey(this, header);
            return !!(key && this[key] !== undefined && (!matcher || $866cce54f6bdfb0c$var$matchHeaderValue(this, this[key], key, matcher)));
        }
        return false;
    }
    delete(header, matcher) {
        const self = this;
        let deleted = false;
        function deleteHeader(_header) {
            _header = $866cce54f6bdfb0c$var$normalizeHeader(_header);
            if (_header) {
                const key = (0, $c319b2c832c2914a$export$2e2bcd8739ae039).findKey(self, _header);
                if (key && (!matcher || $866cce54f6bdfb0c$var$matchHeaderValue(self, self[key], key, matcher))) {
                    delete self[key];
                    deleted = true;
                }
            }
        }
        if ((0, $c319b2c832c2914a$export$2e2bcd8739ae039).isArray(header)) header.forEach(deleteHeader);
        else deleteHeader(header);
        return deleted;
    }
    clear(matcher) {
        const keys = Object.keys(this);
        let i = keys.length;
        let deleted = false;
        while(i--){
            const key = keys[i];
            if (!matcher || $866cce54f6bdfb0c$var$matchHeaderValue(this, this[key], key, matcher, true)) {
                delete this[key];
                deleted = true;
            }
        }
        return deleted;
    }
    normalize(format) {
        const self = this;
        const headers = {};
        (0, $c319b2c832c2914a$export$2e2bcd8739ae039).forEach(this, (value, header)=>{
            const key = (0, $c319b2c832c2914a$export$2e2bcd8739ae039).findKey(headers, header);
            if (key) {
                self[key] = $866cce54f6bdfb0c$var$normalizeValue(value);
                delete self[header];
                return;
            }
            const normalized = format ? $866cce54f6bdfb0c$var$formatHeader(header) : String(header).trim();
            if (normalized !== header) delete self[header];
            self[normalized] = $866cce54f6bdfb0c$var$normalizeValue(value);
            headers[normalized] = true;
        });
        return this;
    }
    concat(...targets) {
        return this.constructor.concat(this, ...targets);
    }
    toJSON(asStrings) {
        const obj = Object.create(null);
        (0, $c319b2c832c2914a$export$2e2bcd8739ae039).forEach(this, (value, header)=>{
            value != null && value !== false && (obj[header] = asStrings && (0, $c319b2c832c2914a$export$2e2bcd8739ae039).isArray(value) ? value.join(", ") : value);
        });
        return obj;
    }
    [Symbol.iterator]() {
        return Object.entries(this.toJSON())[Symbol.iterator]();
    }
    toString() {
        return Object.entries(this.toJSON()).map(([header, value])=>header + ": " + value).join("\n");
    }
    get [Symbol.toStringTag]() {
        return "AxiosHeaders";
    }
    static from(thing) {
        return thing instanceof this ? thing : new this(thing);
    }
    static concat(first, ...targets) {
        const computed = new this(first);
        targets.forEach((target)=>computed.set(target));
        return computed;
    }
    static accessor(header) {
        const internals = this[$866cce54f6bdfb0c$var$$internals] = this[$866cce54f6bdfb0c$var$$internals] = {
            accessors: {}
        };
        const accessors = internals.accessors;
        const prototype = this.prototype;
        function defineAccessor(_header) {
            const lHeader = $866cce54f6bdfb0c$var$normalizeHeader(_header);
            if (!accessors[lHeader]) {
                $866cce54f6bdfb0c$var$buildAccessors(prototype, _header);
                accessors[lHeader] = true;
            }
        }
        (0, $c319b2c832c2914a$export$2e2bcd8739ae039).isArray(header) ? header.forEach(defineAccessor) : defineAccessor(header);
        return this;
    }
}
$866cce54f6bdfb0c$var$AxiosHeaders.accessor([
    "Content-Type",
    "Content-Length",
    "Accept",
    "Accept-Encoding",
    "User-Agent",
    "Authorization"
]);
// reserved names hotfix
(0, $c319b2c832c2914a$export$2e2bcd8739ae039).reduceDescriptors($866cce54f6bdfb0c$var$AxiosHeaders.prototype, ({ value: value }, key)=>{
    let mapped = key[0].toUpperCase() + key.slice(1); // map `set` => `Set`
    return {
        get: ()=>value,
        set (headerValue) {
            this[mapped] = headerValue;
        }
    };
});
(0, $c319b2c832c2914a$export$2e2bcd8739ae039).freezeMethods($866cce54f6bdfb0c$var$AxiosHeaders);
var $866cce54f6bdfb0c$export$2e2bcd8739ae039 = $866cce54f6bdfb0c$var$AxiosHeaders;


"use strict";
function $5cf10c777cce5f4f$export$2e2bcd8739ae039(fns, response) {
    const config = this || (0, $843bf0209bc94df8$export$2e2bcd8739ae039);
    const context = response || config;
    const headers = (0, $866cce54f6bdfb0c$export$2e2bcd8739ae039).from(context.headers);
    let data = context.data;
    (0, $c319b2c832c2914a$export$2e2bcd8739ae039).forEach(fns, function transform(fn) {
        data = fn.call(config, data, headers.normalize(), response ? response.status : undefined);
    });
    headers.normalize();
    return data;
}


"use strict";
function $5a60afef8b0dd173$export$2e2bcd8739ae039(value) {
    return !!(value && value.__CANCEL__);
}





"use strict";
/**
 * A `CanceledError` is an object that is thrown when an operation is canceled.
 *
 * @param {string=} message The message.
 * @param {Object=} config The config.
 * @param {Object=} request The request.
 *
 * @returns {CanceledError} The created error.
 */ function $9fd0919e266b4fda$var$CanceledError(message, config, request) {
    // eslint-disable-next-line no-eq-null,eqeqeq
    (0, $4e2395edb77acf3a$export$2e2bcd8739ae039).call(this, message == null ? "canceled" : message, (0, $4e2395edb77acf3a$export$2e2bcd8739ae039).ERR_CANCELED, config, request);
    this.name = "CanceledError";
}
(0, $c319b2c832c2914a$export$2e2bcd8739ae039).inherits($9fd0919e266b4fda$var$CanceledError, (0, $4e2395edb77acf3a$export$2e2bcd8739ae039), {
    __CANCEL__: true
});
var $9fd0919e266b4fda$export$2e2bcd8739ae039 = $9fd0919e266b4fda$var$CanceledError;







"use strict";
function $ecb62d5372993dcf$export$2e2bcd8739ae039(resolve, reject, response) {
    const validateStatus = response.config.validateStatus;
    if (!response.status || !validateStatus || validateStatus(response.status)) resolve(response);
    else reject(new (0, $4e2395edb77acf3a$export$2e2bcd8739ae039)("Request failed with status code " + response.status, [
        (0, $4e2395edb77acf3a$export$2e2bcd8739ae039).ERR_BAD_REQUEST,
        (0, $4e2395edb77acf3a$export$2e2bcd8739ae039).ERR_BAD_RESPONSE
    ][Math.floor(response.status / 100) - 4], response.config, response.request, response));
}




"use strict";
var $65cc14c0704b5541$export$2e2bcd8739ae039 = (0, $bb8180acb278e187$export$2e2bcd8739ae039).hasStandardBrowserEnv ? // Standard browser envs support document.cookie
function standardBrowserEnv() {
    return {
        write: function write(name, value, expires, path, domain, secure) {
            const cookie = [];
            cookie.push(name + "=" + encodeURIComponent(value));
            if ((0, $c319b2c832c2914a$export$2e2bcd8739ae039).isNumber(expires)) cookie.push("expires=" + new Date(expires).toGMTString());
            if ((0, $c319b2c832c2914a$export$2e2bcd8739ae039).isString(path)) cookie.push("path=" + path);
            if ((0, $c319b2c832c2914a$export$2e2bcd8739ae039).isString(domain)) cookie.push("domain=" + domain);
            if (secure === true) cookie.push("secure");
            document.cookie = cookie.join("; ");
        },
        read: function read(name) {
            const match = document.cookie.match(new RegExp("(^|;\\s*)(" + name + ")=([^;]*)"));
            return match ? decodeURIComponent(match[3]) : null;
        },
        remove: function remove(name) {
            this.write(name, "", Date.now() - 86400000);
        }
    };
}() : // Non standard browser env (web workers, react-native) lack needed support.
function nonStandardBrowserEnv() {
    return {
        write: function write() {},
        read: function read() {
            return null;
        },
        remove: function remove() {}
    };
}();



"use strict";
function $8fa91c1a59edb5d9$export$2e2bcd8739ae039(url) {
    // A URL is considered absolute if it begins with "<scheme>://" or "//" (protocol-relative URL).
    // RFC 3986 defines scheme name as a sequence of characters beginning with a letter and followed
    // by any combination of letters, digits, plus, period, or hyphen.
    return /^([a-z][a-z\d+\-.]*:)?\/\//i.test(url);
}


"use strict";
function $b63e12c1e0b9e0be$export$2e2bcd8739ae039(baseURL, relativeURL) {
    return relativeURL ? baseURL.replace(/\/+$/, "") + "/" + relativeURL.replace(/^\/+/, "") : baseURL;
}


"use strict";
function $598acbfafd2c63c5$export$2e2bcd8739ae039(baseURL, requestedURL) {
    if (baseURL && !(0, $8fa91c1a59edb5d9$export$2e2bcd8739ae039)(requestedURL)) return (0, $b63e12c1e0b9e0be$export$2e2bcd8739ae039)(baseURL, requestedURL);
    return requestedURL;
}




"use strict";
var $5eb63b558e1fb85a$export$2e2bcd8739ae039 = (0, $bb8180acb278e187$export$2e2bcd8739ae039).hasStandardBrowserEnv ? // Standard browser envs have full support of the APIs needed to test
// whether the request URL is of the same origin as current location.
function standardBrowserEnv() {
    const msie = /(msie|trident)/i.test(navigator.userAgent);
    const urlParsingNode = document.createElement("a");
    let originURL;
    /**
    * Parse a URL to discover it's components
    *
    * @param {String} url The URL to be parsed
    * @returns {Object}
    */ function resolveURL(url) {
        let href = url;
        if (msie) {
            // IE needs attribute set twice to normalize properties
            urlParsingNode.setAttribute("href", href);
            href = urlParsingNode.href;
        }
        urlParsingNode.setAttribute("href", href);
        // urlParsingNode provides the UrlUtils interface - http://url.spec.whatwg.org/#urlutils
        return {
            href: urlParsingNode.href,
            protocol: urlParsingNode.protocol ? urlParsingNode.protocol.replace(/:$/, "") : "",
            host: urlParsingNode.host,
            search: urlParsingNode.search ? urlParsingNode.search.replace(/^\?/, "") : "",
            hash: urlParsingNode.hash ? urlParsingNode.hash.replace(/^#/, "") : "",
            hostname: urlParsingNode.hostname,
            port: urlParsingNode.port,
            pathname: urlParsingNode.pathname.charAt(0) === "/" ? urlParsingNode.pathname : "/" + urlParsingNode.pathname
        };
    }
    originURL = resolveURL(window.location.href);
    /**
    * Determine if a URL shares the same origin as the current location
    *
    * @param {String} requestURL The URL to test
    * @returns {boolean} True if URL shares the same origin, otherwise false
    */ return function isURLSameOrigin(requestURL) {
        const parsed = (0, $c319b2c832c2914a$export$2e2bcd8739ae039).isString(requestURL) ? resolveURL(requestURL) : requestURL;
        return parsed.protocol === originURL.protocol && parsed.host === originURL.host;
    };
}() : // Non standard browser envs (web workers, react-native) lack needed support.
function nonStandardBrowserEnv() {
    return function isURLSameOrigin() {
        return true;
    };
}();





"use strict";
function $23607f53e4fda918$export$2e2bcd8739ae039(url) {
    const match = /^([-+\w]{1,25})(:?\/\/|:)/.exec(url);
    return match && match[1] || "";
}




"use strict";
/**
 * Calculate data maxRate
 * @param {Number} [samplesCount= 10]
 * @param {Number} [min= 1000]
 * @returns {Function}
 */ function $4a9d49cd0e6b8acc$var$speedometer(samplesCount, min) {
    samplesCount = samplesCount || 10;
    const bytes = new Array(samplesCount);
    const timestamps = new Array(samplesCount);
    let head = 0;
    let tail = 0;
    let firstSampleTS;
    min = min !== undefined ? min : 1000;
    return function push(chunkLength) {
        const now = Date.now();
        const startedAt = timestamps[tail];
        if (!firstSampleTS) firstSampleTS = now;
        bytes[head] = chunkLength;
        timestamps[head] = now;
        let i = tail;
        let bytesCount = 0;
        while(i !== head){
            bytesCount += bytes[i++];
            i = i % samplesCount;
        }
        head = (head + 1) % samplesCount;
        if (head === tail) tail = (tail + 1) % samplesCount;
        if (now - firstSampleTS < min) return;
        const passed = startedAt && now - startedAt;
        return passed ? Math.round(bytesCount * 1000 / passed) : undefined;
    };
}
var $4a9d49cd0e6b8acc$export$2e2bcd8739ae039 = $4a9d49cd0e6b8acc$var$speedometer;


"use strict";
function $79f0a48d5eb7919b$var$progressEventReducer(listener, isDownloadStream) {
    let bytesNotified = 0;
    const _speedometer = (0, $4a9d49cd0e6b8acc$export$2e2bcd8739ae039)(50, 250);
    return (e)=>{
        const loaded = e.loaded;
        const total = e.lengthComputable ? e.total : undefined;
        const progressBytes = loaded - bytesNotified;
        const rate = _speedometer(progressBytes);
        const inRange = loaded <= total;
        bytesNotified = loaded;
        const data = {
            loaded: loaded,
            total: total,
            progress: total ? loaded / total : undefined,
            bytes: progressBytes,
            rate: rate ? rate : undefined,
            estimated: rate && total && inRange ? (total - loaded) / rate : undefined,
            event: e
        };
        data[isDownloadStream ? "download" : "upload"] = true;
        listener(data);
    };
}
const $79f0a48d5eb7919b$var$isXHRAdapterSupported = typeof XMLHttpRequest !== "undefined";
var $79f0a48d5eb7919b$export$2e2bcd8739ae039 = $79f0a48d5eb7919b$var$isXHRAdapterSupported && function(config) {
    return new Promise(function dispatchXhrRequest(resolve, reject) {
        let requestData = config.data;
        const requestHeaders = (0, $866cce54f6bdfb0c$export$2e2bcd8739ae039).from(config.headers).normalize();
        const responseType = config.responseType;
        let onCanceled;
        function done() {
            if (config.cancelToken) config.cancelToken.unsubscribe(onCanceled);
            if (config.signal) config.signal.removeEventListener("abort", onCanceled);
        }
        let contentType;
        if ((0, $c319b2c832c2914a$export$2e2bcd8739ae039).isFormData(requestData)) {
            if ((0, $bb8180acb278e187$export$2e2bcd8739ae039).hasStandardBrowserEnv || (0, $bb8180acb278e187$export$2e2bcd8739ae039).hasStandardBrowserWebWorkerEnv) requestHeaders.setContentType(false); // Let the browser set it
            else if ((contentType = requestHeaders.getContentType()) !== false) {
                // fix semicolon duplication issue for ReactNative FormData implementation
                const [type, ...tokens] = contentType ? contentType.split(";").map((token)=>token.trim()).filter(Boolean) : [];
                requestHeaders.setContentType([
                    type || "multipart/form-data",
                    ...tokens
                ].join("; "));
            }
        }
        let request = new XMLHttpRequest();
        // HTTP basic authentication
        if (config.auth) {
            const username = config.auth.username || "";
            const password = config.auth.password ? unescape(encodeURIComponent(config.auth.password)) : "";
            requestHeaders.set("Authorization", "Basic " + btoa(username + ":" + password));
        }
        const fullPath = (0, $598acbfafd2c63c5$export$2e2bcd8739ae039)(config.baseURL, config.url);
        request.open(config.method.toUpperCase(), (0, $8df8fedf1c1e4428$export$2e2bcd8739ae039)(fullPath, config.params, config.paramsSerializer), true);
        // Set the request timeout in MS
        request.timeout = config.timeout;
        function onloadend() {
            if (!request) return;
            // Prepare the response
            const responseHeaders = (0, $866cce54f6bdfb0c$export$2e2bcd8739ae039).from("getAllResponseHeaders" in request && request.getAllResponseHeaders());
            const responseData = !responseType || responseType === "text" || responseType === "json" ? request.responseText : request.response;
            const response = {
                data: responseData,
                status: request.status,
                statusText: request.statusText,
                headers: responseHeaders,
                config: config,
                request: request
            };
            (0, $ecb62d5372993dcf$export$2e2bcd8739ae039)(function _resolve(value) {
                resolve(value);
                done();
            }, function _reject(err) {
                reject(err);
                done();
            }, response);
            // Clean up request
            request = null;
        }
        if ("onloadend" in request) // Use onloadend if available
        request.onloadend = onloadend;
        else // Listen for ready state to emulate onloadend
        request.onreadystatechange = function handleLoad() {
            if (!request || request.readyState !== 4) return;
            // The request errored out and we didn't get a response, this will be
            // handled by onerror instead
            // With one exception: request that using file: protocol, most browsers
            // will return status as 0 even though it's a successful request
            if (request.status === 0 && !(request.responseURL && request.responseURL.indexOf("file:") === 0)) return;
            // readystate handler is calling before onerror or ontimeout handlers,
            // so we should call onloadend on the next 'tick'
            setTimeout(onloadend);
        };
        // Handle browser request cancellation (as opposed to a manual cancellation)
        request.onabort = function handleAbort() {
            if (!request) return;
            reject(new (0, $4e2395edb77acf3a$export$2e2bcd8739ae039)("Request aborted", (0, $4e2395edb77acf3a$export$2e2bcd8739ae039).ECONNABORTED, config, request));
            // Clean up request
            request = null;
        };
        // Handle low level network errors
        request.onerror = function handleError() {
            // Real errors are hidden from us by the browser
            // onerror should only fire if it's a network error
            reject(new (0, $4e2395edb77acf3a$export$2e2bcd8739ae039)("Network Error", (0, $4e2395edb77acf3a$export$2e2bcd8739ae039).ERR_NETWORK, config, request));
            // Clean up request
            request = null;
        };
        // Handle timeout
        request.ontimeout = function handleTimeout() {
            let timeoutErrorMessage = config.timeout ? "timeout of " + config.timeout + "ms exceeded" : "timeout exceeded";
            const transitional = config.transitional || (0, $51466d41a76e5b4b$export$2e2bcd8739ae039);
            if (config.timeoutErrorMessage) timeoutErrorMessage = config.timeoutErrorMessage;
            reject(new (0, $4e2395edb77acf3a$export$2e2bcd8739ae039)(timeoutErrorMessage, transitional.clarifyTimeoutError ? (0, $4e2395edb77acf3a$export$2e2bcd8739ae039).ETIMEDOUT : (0, $4e2395edb77acf3a$export$2e2bcd8739ae039).ECONNABORTED, config, request));
            // Clean up request
            request = null;
        };
        // Add xsrf header
        // This is only done if running in a standard browser environment.
        // Specifically not if we're in a web worker, or react-native.
        if ((0, $bb8180acb278e187$export$2e2bcd8739ae039).hasStandardBrowserEnv) {
            // Add xsrf header
            // regarding CVE-2023-45857 config.withCredentials condition was removed temporarily
            const xsrfValue = (0, $5eb63b558e1fb85a$export$2e2bcd8739ae039)(fullPath) && config.xsrfCookieName && (0, $65cc14c0704b5541$export$2e2bcd8739ae039).read(config.xsrfCookieName);
            if (xsrfValue) requestHeaders.set(config.xsrfHeaderName, xsrfValue);
        }
        // Remove Content-Type if data is undefined
        requestData === undefined && requestHeaders.setContentType(null);
        // Add headers to the request
        if ("setRequestHeader" in request) (0, $c319b2c832c2914a$export$2e2bcd8739ae039).forEach(requestHeaders.toJSON(), function setRequestHeader(val, key) {
            request.setRequestHeader(key, val);
        });
        // Add withCredentials to request if needed
        if (!(0, $c319b2c832c2914a$export$2e2bcd8739ae039).isUndefined(config.withCredentials)) request.withCredentials = !!config.withCredentials;
        // Add responseType to request if needed
        if (responseType && responseType !== "json") request.responseType = config.responseType;
        // Handle progress if needed
        if (typeof config.onDownloadProgress === "function") request.addEventListener("progress", $79f0a48d5eb7919b$var$progressEventReducer(config.onDownloadProgress, true));
        // Not all browsers support upload events
        if (typeof config.onUploadProgress === "function" && request.upload) request.upload.addEventListener("progress", $79f0a48d5eb7919b$var$progressEventReducer(config.onUploadProgress));
        if (config.cancelToken || config.signal) {
            // Handle cancellation
            // eslint-disable-next-line func-names
            onCanceled = (cancel)=>{
                if (!request) return;
                reject(!cancel || cancel.type ? new (0, $9fd0919e266b4fda$export$2e2bcd8739ae039)(null, config, request) : cancel);
                request.abort();
                request = null;
            };
            config.cancelToken && config.cancelToken.subscribe(onCanceled);
            if (config.signal) config.signal.aborted ? onCanceled() : config.signal.addEventListener("abort", onCanceled);
        }
        const protocol = (0, $23607f53e4fda918$export$2e2bcd8739ae039)(fullPath);
        if (protocol && (0, $bb8180acb278e187$export$2e2bcd8739ae039).protocols.indexOf(protocol) === -1) {
            reject(new (0, $4e2395edb77acf3a$export$2e2bcd8739ae039)("Unsupported protocol " + protocol + ":", (0, $4e2395edb77acf3a$export$2e2bcd8739ae039).ERR_BAD_REQUEST, config));
            return;
        }
        // Send the request
        request.send(requestData || null);
    });
};



const $e8c8c7960873e9ee$var$knownAdapters = {
    http: (0, $4023ac50ad132196$export$2e2bcd8739ae039),
    xhr: (0, $79f0a48d5eb7919b$export$2e2bcd8739ae039)
};
(0, $c319b2c832c2914a$export$2e2bcd8739ae039).forEach($e8c8c7960873e9ee$var$knownAdapters, (fn, value)=>{
    if (fn) {
        try {
            Object.defineProperty(fn, "name", {
                value: value
            });
        } catch (e) {
        // eslint-disable-next-line no-empty
        }
        Object.defineProperty(fn, "adapterName", {
            value: value
        });
    }
});
const $e8c8c7960873e9ee$var$renderReason = (reason)=>`- ${reason}`;
const $e8c8c7960873e9ee$var$isResolvedHandle = (adapter)=>(0, $c319b2c832c2914a$export$2e2bcd8739ae039).isFunction(adapter) || adapter === null || adapter === false;
var $e8c8c7960873e9ee$export$2e2bcd8739ae039 = {
    getAdapter: (adapters)=>{
        adapters = (0, $c319b2c832c2914a$export$2e2bcd8739ae039).isArray(adapters) ? adapters : [
            adapters
        ];
        const { length: length } = adapters;
        let nameOrAdapter;
        let adapter;
        const rejectedReasons = {};
        for(let i = 0; i < length; i++){
            nameOrAdapter = adapters[i];
            let id;
            adapter = nameOrAdapter;
            if (!$e8c8c7960873e9ee$var$isResolvedHandle(nameOrAdapter)) {
                adapter = $e8c8c7960873e9ee$var$knownAdapters[(id = String(nameOrAdapter)).toLowerCase()];
                if (adapter === undefined) throw new (0, $4e2395edb77acf3a$export$2e2bcd8739ae039)(`Unknown adapter '${id}'`);
            }
            if (adapter) break;
            rejectedReasons[id || "#" + i] = adapter;
        }
        if (!adapter) {
            const reasons = Object.entries(rejectedReasons).map(([id, state])=>`adapter ${id} ` + (state === false ? "is not supported by the environment" : "is not available in the build"));
            let s = length ? reasons.length > 1 ? "since :\n" + reasons.map($e8c8c7960873e9ee$var$renderReason).join("\n") : " " + $e8c8c7960873e9ee$var$renderReason(reasons[0]) : "as no adapter specified";
            throw new (0, $4e2395edb77acf3a$export$2e2bcd8739ae039)(`There is no suitable adapter to dispatch the request ` + s, "ERR_NOT_SUPPORT");
        }
        return adapter;
    },
    adapters: $e8c8c7960873e9ee$var$knownAdapters
};


"use strict";
/**
 * Throws a `CanceledError` if cancellation has been requested.
 *
 * @param {Object} config The config that is to be used for the request
 *
 * @returns {void}
 */ function $9b8d10189805ccc0$var$throwIfCancellationRequested(config) {
    if (config.cancelToken) config.cancelToken.throwIfRequested();
    if (config.signal && config.signal.aborted) throw new (0, $9fd0919e266b4fda$export$2e2bcd8739ae039)(null, config);
}
function $9b8d10189805ccc0$export$2e2bcd8739ae039(config) {
    $9b8d10189805ccc0$var$throwIfCancellationRequested(config);
    config.headers = (0, $866cce54f6bdfb0c$export$2e2bcd8739ae039).from(config.headers);
    // Transform request data
    config.data = (0, $5cf10c777cce5f4f$export$2e2bcd8739ae039).call(config, config.transformRequest);
    if ([
        "post",
        "put",
        "patch"
    ].indexOf(config.method) !== -1) config.headers.setContentType("application/x-www-form-urlencoded", false);
    const adapter = (0, $e8c8c7960873e9ee$export$2e2bcd8739ae039).getAdapter(config.adapter || (0, $843bf0209bc94df8$export$2e2bcd8739ae039).adapter);
    return adapter(config).then(function onAdapterResolution(response) {
        $9b8d10189805ccc0$var$throwIfCancellationRequested(config);
        // Transform response data
        response.data = (0, $5cf10c777cce5f4f$export$2e2bcd8739ae039).call(config, config.transformResponse, response);
        response.headers = (0, $866cce54f6bdfb0c$export$2e2bcd8739ae039).from(response.headers);
        return response;
    }, function onAdapterRejection(reason) {
        if (!(0, $5a60afef8b0dd173$export$2e2bcd8739ae039)(reason)) {
            $9b8d10189805ccc0$var$throwIfCancellationRequested(config);
            // Transform response data
            if (reason && reason.response) {
                reason.response.data = (0, $5cf10c777cce5f4f$export$2e2bcd8739ae039).call(config, config.transformResponse, reason.response);
                reason.response.headers = (0, $866cce54f6bdfb0c$export$2e2bcd8739ae039).from(reason.response.headers);
            }
        }
        return Promise.reject(reason);
    });
}




"use strict";
const $f85fda54cd977b19$var$headersToObject = (thing)=>thing instanceof (0, $866cce54f6bdfb0c$export$2e2bcd8739ae039) ? thing.toJSON() : thing;
function $f85fda54cd977b19$export$2e2bcd8739ae039(config1, config2) {
    // eslint-disable-next-line no-param-reassign
    config2 = config2 || {};
    const config = {};
    function getMergedValue(target, source, caseless) {
        if ((0, $c319b2c832c2914a$export$2e2bcd8739ae039).isPlainObject(target) && (0, $c319b2c832c2914a$export$2e2bcd8739ae039).isPlainObject(source)) return (0, $c319b2c832c2914a$export$2e2bcd8739ae039).merge.call({
            caseless: caseless
        }, target, source);
        else if ((0, $c319b2c832c2914a$export$2e2bcd8739ae039).isPlainObject(source)) return (0, $c319b2c832c2914a$export$2e2bcd8739ae039).merge({}, source);
        else if ((0, $c319b2c832c2914a$export$2e2bcd8739ae039).isArray(source)) return source.slice();
        return source;
    }
    // eslint-disable-next-line consistent-return
    function mergeDeepProperties(a, b, caseless) {
        if (!(0, $c319b2c832c2914a$export$2e2bcd8739ae039).isUndefined(b)) return getMergedValue(a, b, caseless);
        else if (!(0, $c319b2c832c2914a$export$2e2bcd8739ae039).isUndefined(a)) return getMergedValue(undefined, a, caseless);
    }
    // eslint-disable-next-line consistent-return
    function valueFromConfig2(a, b) {
        if (!(0, $c319b2c832c2914a$export$2e2bcd8739ae039).isUndefined(b)) return getMergedValue(undefined, b);
    }
    // eslint-disable-next-line consistent-return
    function defaultToConfig2(a, b) {
        if (!(0, $c319b2c832c2914a$export$2e2bcd8739ae039).isUndefined(b)) return getMergedValue(undefined, b);
        else if (!(0, $c319b2c832c2914a$export$2e2bcd8739ae039).isUndefined(a)) return getMergedValue(undefined, a);
    }
    // eslint-disable-next-line consistent-return
    function mergeDirectKeys(a, b, prop) {
        if (prop in config2) return getMergedValue(a, b);
        else if (prop in config1) return getMergedValue(undefined, a);
    }
    const mergeMap = {
        url: valueFromConfig2,
        method: valueFromConfig2,
        data: valueFromConfig2,
        baseURL: defaultToConfig2,
        transformRequest: defaultToConfig2,
        transformResponse: defaultToConfig2,
        paramsSerializer: defaultToConfig2,
        timeout: defaultToConfig2,
        timeoutMessage: defaultToConfig2,
        withCredentials: defaultToConfig2,
        adapter: defaultToConfig2,
        responseType: defaultToConfig2,
        xsrfCookieName: defaultToConfig2,
        xsrfHeaderName: defaultToConfig2,
        onUploadProgress: defaultToConfig2,
        onDownloadProgress: defaultToConfig2,
        decompress: defaultToConfig2,
        maxContentLength: defaultToConfig2,
        maxBodyLength: defaultToConfig2,
        beforeRedirect: defaultToConfig2,
        transport: defaultToConfig2,
        httpAgent: defaultToConfig2,
        httpsAgent: defaultToConfig2,
        cancelToken: defaultToConfig2,
        socketPath: defaultToConfig2,
        responseEncoding: defaultToConfig2,
        validateStatus: mergeDirectKeys,
        headers: (a, b)=>mergeDeepProperties($f85fda54cd977b19$var$headersToObject(a), $f85fda54cd977b19$var$headersToObject(b), true)
    };
    (0, $c319b2c832c2914a$export$2e2bcd8739ae039).forEach(Object.keys(Object.assign({}, config1, config2)), function computeConfigValue(prop) {
        const merge = mergeMap[prop] || mergeDeepProperties;
        const configValue = merge(config1[prop], config2[prop], prop);
        (0, $c319b2c832c2914a$export$2e2bcd8739ae039).isUndefined(configValue) && merge !== mergeDirectKeys || (config[prop] = configValue);
    });
    return config;
}



const $23ff3f1a5c7912d5$export$a4ad2735b021c132 = "1.6.1";



"use strict";
const $85f59389941e7907$var$validators = {};
// eslint-disable-next-line func-names
[
    "object",
    "boolean",
    "number",
    "function",
    "string",
    "symbol"
].forEach((type, i)=>{
    $85f59389941e7907$var$validators[type] = function validator(thing) {
        return typeof thing === type || "a" + (i < 1 ? "n " : " ") + type;
    };
});
const $85f59389941e7907$var$deprecatedWarnings = {};
/**
 * Transitional option validator
 *
 * @param {function|boolean?} validator - set to false if the transitional option has been removed
 * @param {string?} version - deprecated version / removed since version
 * @param {string?} message - some message with additional info
 *
 * @returns {function}
 */ $85f59389941e7907$var$validators.transitional = function transitional(validator, version, message) {
    function formatMessage(opt, desc) {
        return "[Axios v" + (0, $23ff3f1a5c7912d5$export$a4ad2735b021c132) + "] Transitional option '" + opt + "'" + desc + (message ? ". " + message : "");
    }
    // eslint-disable-next-line func-names
    return (value, opt, opts)=>{
        if (validator === false) throw new (0, $4e2395edb77acf3a$export$2e2bcd8739ae039)(formatMessage(opt, " has been removed" + (version ? " in " + version : "")), (0, $4e2395edb77acf3a$export$2e2bcd8739ae039).ERR_DEPRECATED);
        if (version && !$85f59389941e7907$var$deprecatedWarnings[opt]) {
            $85f59389941e7907$var$deprecatedWarnings[opt] = true;
            // eslint-disable-next-line no-console
            console.warn(formatMessage(opt, " has been deprecated since v" + version + " and will be removed in the near future"));
        }
        return validator ? validator(value, opt, opts) : true;
    };
};
/**
 * Assert object's properties type
 *
 * @param {object} options
 * @param {object} schema
 * @param {boolean?} allowUnknown
 *
 * @returns {object}
 */ function $85f59389941e7907$var$assertOptions(options, schema, allowUnknown) {
    if (typeof options !== "object") throw new (0, $4e2395edb77acf3a$export$2e2bcd8739ae039)("options must be an object", (0, $4e2395edb77acf3a$export$2e2bcd8739ae039).ERR_BAD_OPTION_VALUE);
    const keys = Object.keys(options);
    let i = keys.length;
    while(i-- > 0){
        const opt = keys[i];
        const validator = schema[opt];
        if (validator) {
            const value = options[opt];
            const result = value === undefined || validator(value, opt, options);
            if (result !== true) throw new (0, $4e2395edb77acf3a$export$2e2bcd8739ae039)("option " + opt + " must be " + result, (0, $4e2395edb77acf3a$export$2e2bcd8739ae039).ERR_BAD_OPTION_VALUE);
            continue;
        }
        if (allowUnknown !== true) throw new (0, $4e2395edb77acf3a$export$2e2bcd8739ae039)("Unknown option " + opt, (0, $4e2395edb77acf3a$export$2e2bcd8739ae039).ERR_BAD_OPTION);
    }
}
var $85f59389941e7907$export$2e2bcd8739ae039 = {
    assertOptions: $85f59389941e7907$var$assertOptions,
    validators: $85f59389941e7907$var$validators
};



"use strict";
const $a93486d2307f31c3$var$validators = (0, $85f59389941e7907$export$2e2bcd8739ae039).validators;
/**
 * Create a new instance of Axios
 *
 * @param {Object} instanceConfig The default config for the instance
 *
 * @return {Axios} A new instance of Axios
 */ class $a93486d2307f31c3$var$Axios {
    constructor(instanceConfig){
        this.defaults = instanceConfig;
        this.interceptors = {
            request: new (0, $5de878cd737ef277$export$2e2bcd8739ae039)(),
            response: new (0, $5de878cd737ef277$export$2e2bcd8739ae039)()
        };
    }
    /**
   * Dispatch a request
   *
   * @param {String|Object} configOrUrl The config specific for this request (merged with this.defaults)
   * @param {?Object} config
   *
   * @returns {Promise} The Promise to be fulfilled
   */ request(configOrUrl, config) {
        /*eslint no-param-reassign:0*/ // Allow for axios('example/url'[, config]) a la fetch API
        if (typeof configOrUrl === "string") {
            config = config || {};
            config.url = configOrUrl;
        } else config = configOrUrl || {};
        config = (0, $f85fda54cd977b19$export$2e2bcd8739ae039)(this.defaults, config);
        const { transitional: transitional, paramsSerializer: paramsSerializer, headers: headers } = config;
        if (transitional !== undefined) (0, $85f59389941e7907$export$2e2bcd8739ae039).assertOptions(transitional, {
            silentJSONParsing: $a93486d2307f31c3$var$validators.transitional($a93486d2307f31c3$var$validators.boolean),
            forcedJSONParsing: $a93486d2307f31c3$var$validators.transitional($a93486d2307f31c3$var$validators.boolean),
            clarifyTimeoutError: $a93486d2307f31c3$var$validators.transitional($a93486d2307f31c3$var$validators.boolean)
        }, false);
        if (paramsSerializer != null) {
            if ((0, $c319b2c832c2914a$export$2e2bcd8739ae039).isFunction(paramsSerializer)) config.paramsSerializer = {
                serialize: paramsSerializer
            };
            else (0, $85f59389941e7907$export$2e2bcd8739ae039).assertOptions(paramsSerializer, {
                encode: $a93486d2307f31c3$var$validators.function,
                serialize: $a93486d2307f31c3$var$validators.function
            }, true);
        }
        // Set config.method
        config.method = (config.method || this.defaults.method || "get").toLowerCase();
        // Flatten headers
        let contextHeaders = headers && (0, $c319b2c832c2914a$export$2e2bcd8739ae039).merge(headers.common, headers[config.method]);
        headers && (0, $c319b2c832c2914a$export$2e2bcd8739ae039).forEach([
            "delete",
            "get",
            "head",
            "post",
            "put",
            "patch",
            "common"
        ], (method)=>{
            delete headers[method];
        });
        config.headers = (0, $866cce54f6bdfb0c$export$2e2bcd8739ae039).concat(contextHeaders, headers);
        // filter out skipped interceptors
        const requestInterceptorChain = [];
        let synchronousRequestInterceptors = true;
        this.interceptors.request.forEach(function unshiftRequestInterceptors(interceptor) {
            if (typeof interceptor.runWhen === "function" && interceptor.runWhen(config) === false) return;
            synchronousRequestInterceptors = synchronousRequestInterceptors && interceptor.synchronous;
            requestInterceptorChain.unshift(interceptor.fulfilled, interceptor.rejected);
        });
        const responseInterceptorChain = [];
        this.interceptors.response.forEach(function pushResponseInterceptors(interceptor) {
            responseInterceptorChain.push(interceptor.fulfilled, interceptor.rejected);
        });
        let promise;
        let i = 0;
        let len;
        if (!synchronousRequestInterceptors) {
            const chain = [
                (0, $9b8d10189805ccc0$export$2e2bcd8739ae039).bind(this),
                undefined
            ];
            chain.unshift.apply(chain, requestInterceptorChain);
            chain.push.apply(chain, responseInterceptorChain);
            len = chain.length;
            promise = Promise.resolve(config);
            while(i < len)promise = promise.then(chain[i++], chain[i++]);
            return promise;
        }
        len = requestInterceptorChain.length;
        let newConfig = config;
        i = 0;
        while(i < len){
            const onFulfilled = requestInterceptorChain[i++];
            const onRejected = requestInterceptorChain[i++];
            try {
                newConfig = onFulfilled(newConfig);
            } catch (error) {
                onRejected.call(this, error);
                break;
            }
        }
        try {
            promise = (0, $9b8d10189805ccc0$export$2e2bcd8739ae039).call(this, newConfig);
        } catch (error) {
            return Promise.reject(error);
        }
        i = 0;
        len = responseInterceptorChain.length;
        while(i < len)promise = promise.then(responseInterceptorChain[i++], responseInterceptorChain[i++]);
        return promise;
    }
    getUri(config) {
        config = (0, $f85fda54cd977b19$export$2e2bcd8739ae039)(this.defaults, config);
        const fullPath = (0, $598acbfafd2c63c5$export$2e2bcd8739ae039)(config.baseURL, config.url);
        return (0, $8df8fedf1c1e4428$export$2e2bcd8739ae039)(fullPath, config.params, config.paramsSerializer);
    }
}
// Provide aliases for supported request methods
(0, $c319b2c832c2914a$export$2e2bcd8739ae039).forEach([
    "delete",
    "get",
    "head",
    "options"
], function forEachMethodNoData(method) {
    /*eslint func-names:0*/ $a93486d2307f31c3$var$Axios.prototype[method] = function(url, config) {
        return this.request((0, $f85fda54cd977b19$export$2e2bcd8739ae039)(config || {}, {
            method: method,
            url: url,
            data: (config || {}).data
        }));
    };
});
(0, $c319b2c832c2914a$export$2e2bcd8739ae039).forEach([
    "post",
    "put",
    "patch"
], function forEachMethodWithData(method) {
    /*eslint func-names:0*/ function generateHTTPMethod(isForm) {
        return function httpMethod(url, data, config) {
            return this.request((0, $f85fda54cd977b19$export$2e2bcd8739ae039)(config || {}, {
                method: method,
                headers: isForm ? {
                    "Content-Type": "multipart/form-data"
                } : {},
                url: url,
                data: data
            }));
        };
    }
    $a93486d2307f31c3$var$Axios.prototype[method] = generateHTTPMethod();
    $a93486d2307f31c3$var$Axios.prototype[method + "Form"] = generateHTTPMethod(true);
});
var $a93486d2307f31c3$export$2e2bcd8739ae039 = $a93486d2307f31c3$var$Axios;







"use strict";
/**
 * A `CancelToken` is an object that can be used to request cancellation of an operation.
 *
 * @param {Function} executor The executor function.
 *
 * @returns {CancelToken}
 */ class $fb81495929d8a282$var$CancelToken {
    constructor(executor){
        if (typeof executor !== "function") throw new TypeError("executor must be a function.");
        let resolvePromise;
        this.promise = new Promise(function promiseExecutor(resolve) {
            resolvePromise = resolve;
        });
        const token = this;
        // eslint-disable-next-line func-names
        this.promise.then((cancel)=>{
            if (!token._listeners) return;
            let i = token._listeners.length;
            while(i-- > 0)token._listeners[i](cancel);
            token._listeners = null;
        });
        // eslint-disable-next-line func-names
        this.promise.then = (onfulfilled)=>{
            let _resolve;
            // eslint-disable-next-line func-names
            const promise = new Promise((resolve)=>{
                token.subscribe(resolve);
                _resolve = resolve;
            }).then(onfulfilled);
            promise.cancel = function reject() {
                token.unsubscribe(_resolve);
            };
            return promise;
        };
        executor(function cancel(message, config, request) {
            if (token.reason) // Cancellation has already been requested
            return;
            token.reason = new (0, $9fd0919e266b4fda$export$2e2bcd8739ae039)(message, config, request);
            resolvePromise(token.reason);
        });
    }
    /**
   * Throws a `CanceledError` if cancellation has been requested.
   */ throwIfRequested() {
        if (this.reason) throw this.reason;
    }
    /**
   * Subscribe to the cancel signal
   */ subscribe(listener) {
        if (this.reason) {
            listener(this.reason);
            return;
        }
        if (this._listeners) this._listeners.push(listener);
        else this._listeners = [
            listener
        ];
    }
    /**
   * Unsubscribe from the cancel signal
   */ unsubscribe(listener) {
        if (!this._listeners) return;
        const index = this._listeners.indexOf(listener);
        if (index !== -1) this._listeners.splice(index, 1);
    }
    /**
   * Returns an object that contains a new `CancelToken` and a function that, when called,
   * cancels the `CancelToken`.
   */ static source() {
        let cancel;
        const token = new $fb81495929d8a282$var$CancelToken(function executor(c) {
            cancel = c;
        });
        return {
            token: token,
            cancel: cancel
        };
    }
}
var $fb81495929d8a282$export$2e2bcd8739ae039 = $fb81495929d8a282$var$CancelToken;






"use strict";
function $089369673aa7c1c3$export$2e2bcd8739ae039(callback) {
    return function wrap(arr) {
        return callback.apply(null, arr);
    };
}



"use strict";
function $9db8da59db12cd94$export$2e2bcd8739ae039(payload) {
    return (0, $c319b2c832c2914a$export$2e2bcd8739ae039).isObject(payload) && payload.isAxiosError === true;
}




const $f919374d785e9fb8$var$HttpStatusCode = {
    Continue: 100,
    SwitchingProtocols: 101,
    Processing: 102,
    EarlyHints: 103,
    Ok: 200,
    Created: 201,
    Accepted: 202,
    NonAuthoritativeInformation: 203,
    NoContent: 204,
    ResetContent: 205,
    PartialContent: 206,
    MultiStatus: 207,
    AlreadyReported: 208,
    ImUsed: 226,
    MultipleChoices: 300,
    MovedPermanently: 301,
    Found: 302,
    SeeOther: 303,
    NotModified: 304,
    UseProxy: 305,
    Unused: 306,
    TemporaryRedirect: 307,
    PermanentRedirect: 308,
    BadRequest: 400,
    Unauthorized: 401,
    PaymentRequired: 402,
    Forbidden: 403,
    NotFound: 404,
    MethodNotAllowed: 405,
    NotAcceptable: 406,
    ProxyAuthenticationRequired: 407,
    RequestTimeout: 408,
    Conflict: 409,
    Gone: 410,
    LengthRequired: 411,
    PreconditionFailed: 412,
    PayloadTooLarge: 413,
    UriTooLong: 414,
    UnsupportedMediaType: 415,
    RangeNotSatisfiable: 416,
    ExpectationFailed: 417,
    ImATeapot: 418,
    MisdirectedRequest: 421,
    UnprocessableEntity: 422,
    Locked: 423,
    FailedDependency: 424,
    TooEarly: 425,
    UpgradeRequired: 426,
    PreconditionRequired: 428,
    TooManyRequests: 429,
    RequestHeaderFieldsTooLarge: 431,
    UnavailableForLegalReasons: 451,
    InternalServerError: 500,
    NotImplemented: 501,
    BadGateway: 502,
    ServiceUnavailable: 503,
    GatewayTimeout: 504,
    HttpVersionNotSupported: 505,
    VariantAlsoNegotiates: 506,
    InsufficientStorage: 507,
    LoopDetected: 508,
    NotExtended: 510,
    NetworkAuthenticationRequired: 511
};
Object.entries($f919374d785e9fb8$var$HttpStatusCode).forEach(([key, value])=>{
    $f919374d785e9fb8$var$HttpStatusCode[value] = key;
});
var $f919374d785e9fb8$export$2e2bcd8739ae039 = $f919374d785e9fb8$var$HttpStatusCode;


"use strict";
/**
 * Create an instance of Axios
 *
 * @param {Object} defaultConfig The default config for the instance
 *
 * @returns {Axios} A new instance of Axios
 */ function $57966c7e0affc4cb$var$createInstance(defaultConfig) {
    const context = new (0, $a93486d2307f31c3$export$2e2bcd8739ae039)(defaultConfig);
    const instance = (0, $e5cb5cefd6507f7e$export$2e2bcd8739ae039)((0, $a93486d2307f31c3$export$2e2bcd8739ae039).prototype.request, context);
    // Copy axios.prototype to instance
    (0, $c319b2c832c2914a$export$2e2bcd8739ae039).extend(instance, (0, $a93486d2307f31c3$export$2e2bcd8739ae039).prototype, context, {
        allOwnKeys: true
    });
    // Copy context to instance
    (0, $c319b2c832c2914a$export$2e2bcd8739ae039).extend(instance, context, null, {
        allOwnKeys: true
    });
    // Factory for creating new instances
    instance.create = function create(instanceConfig) {
        return $57966c7e0affc4cb$var$createInstance((0, $f85fda54cd977b19$export$2e2bcd8739ae039)(defaultConfig, instanceConfig));
    };
    return instance;
}
// Create the default instance to be exported
const $57966c7e0affc4cb$var$axios = $57966c7e0affc4cb$var$createInstance((0, $843bf0209bc94df8$export$2e2bcd8739ae039));
// Expose Axios class to allow class inheritance
$57966c7e0affc4cb$var$axios.Axios = (0, $a93486d2307f31c3$export$2e2bcd8739ae039);
// Expose Cancel & CancelToken
$57966c7e0affc4cb$var$axios.CanceledError = (0, $9fd0919e266b4fda$export$2e2bcd8739ae039);
$57966c7e0affc4cb$var$axios.CancelToken = (0, $fb81495929d8a282$export$2e2bcd8739ae039);
$57966c7e0affc4cb$var$axios.isCancel = (0, $5a60afef8b0dd173$export$2e2bcd8739ae039);
$57966c7e0affc4cb$var$axios.VERSION = (0, $23ff3f1a5c7912d5$export$a4ad2735b021c132);
$57966c7e0affc4cb$var$axios.toFormData = (0, $e6cbd383b18c9625$export$2e2bcd8739ae039);
// Expose AxiosError class
$57966c7e0affc4cb$var$axios.AxiosError = (0, $4e2395edb77acf3a$export$2e2bcd8739ae039);
// alias for CanceledError for backward compatibility
$57966c7e0affc4cb$var$axios.Cancel = $57966c7e0affc4cb$var$axios.CanceledError;
// Expose all/spread
$57966c7e0affc4cb$var$axios.all = function all(promises) {
    return Promise.all(promises);
};
$57966c7e0affc4cb$var$axios.spread = (0, $089369673aa7c1c3$export$2e2bcd8739ae039);
// Expose isAxiosError
$57966c7e0affc4cb$var$axios.isAxiosError = (0, $9db8da59db12cd94$export$2e2bcd8739ae039);
// Expose mergeConfig
$57966c7e0affc4cb$var$axios.mergeConfig = (0, $f85fda54cd977b19$export$2e2bcd8739ae039);
$57966c7e0affc4cb$var$axios.AxiosHeaders = (0, $866cce54f6bdfb0c$export$2e2bcd8739ae039);
$57966c7e0affc4cb$var$axios.formToJSON = (thing)=>(0, $5f8142930b3b943f$export$2e2bcd8739ae039)((0, $c319b2c832c2914a$export$2e2bcd8739ae039).isHTMLForm(thing) ? new FormData(thing) : thing);
$57966c7e0affc4cb$var$axios.getAdapter = (0, $e8c8c7960873e9ee$export$2e2bcd8739ae039).getAdapter;
$57966c7e0affc4cb$var$axios.HttpStatusCode = (0, $f919374d785e9fb8$export$2e2bcd8739ae039);
$57966c7e0affc4cb$var$axios.default = $57966c7e0affc4cb$var$axios;
var // this module should only have a default export
$57966c7e0affc4cb$export$2e2bcd8739ae039 = $57966c7e0affc4cb$var$axios;


// This module is intended to unwrap Axios default export as named.
// Keep top-level export same with static properties
// so that it can keep same with es module or cjs
const { Axios: $b302555736d21bd7$export$1c00760e9e5a4e95, AxiosError: $b302555736d21bd7$export$c1fbed17c2f6a328, CanceledError: $b302555736d21bd7$export$1ab0c6b20d94fa14, isCancel: $b302555736d21bd7$export$3b22524397b493c6, CancelToken: $b302555736d21bd7$export$fd08e3cb425f0d61, VERSION: $b302555736d21bd7$export$a4ad2735b021c132, all: $b302555736d21bd7$export$84bf76cd7afc7469, Cancel: $b302555736d21bd7$export$848c9b7ead0df967, isAxiosError: $b302555736d21bd7$export$fbafdbe06a5b5a9a, spread: $b302555736d21bd7$export$3ae0fd4797ed47c8, toFormData: $b302555736d21bd7$export$10ae0d317ea97f8b, AxiosHeaders: $b302555736d21bd7$export$4e7d6ff0f3e6520, HttpStatusCode: $b302555736d21bd7$export$a972f69c851492b3, formToJSON: $b302555736d21bd7$export$86d7c59254d6a2c9, getAdapter: $b302555736d21bd7$export$17ddc20a97d669e2, mergeConfig: $b302555736d21bd7$export$7ec1ebcfa9d8bd6a } = (0, $57966c7e0affc4cb$export$2e2bcd8739ae039);



var $gNDby = parcelRequire("gNDby");
const $c3c4612a04ae44e4$export$31adfacaf07ffe63 = "https://cdn.piratesquadnft.com/clients/oogy-blast";
const $c3c4612a04ae44e4$export$8187fb71f6d8e245 = new (0, $gNDby.PublicKey)("MemoSq4gqABAXKb96qnH8TysNcWxMyWCqXgDLGmfcHr");


const $95f58df959e5e0cd$export$aead4c4fc7a7fd3e = async ()=>{
    const response = await (0, $57966c7e0affc4cb$export$2e2bcd8739ae039).get(`${(0, $c3c4612a04ae44e4$export$31adfacaf07ffe63)}/maintenance/status.json`);
    if (response.status !== 200) return;
    return response.data;
};


const $9805619f03ed02ef$export$7f84b2f452f9a348 = window.solana?.isPhantom || window.solana?.isBraveWallet;
const $9805619f03ed02ef$var$regex = /(undefined|false)/g;
const $9805619f03ed02ef$export$91884aa883243770 = (styles, className)=>className.replaceAll($9805619f03ed02ef$var$regex, "").trim().split(/\s+/).reduce((acc, className)=>{
        return `${acc ? `${acc} ` : ""}${styles[className] ?? className}`;
    }, "");
const $9805619f03ed02ef$export$448332262467e042 = (array)=>{
    let currentIndex = array.length, randomIndex;
    while(currentIndex != 0){
        randomIndex = Math.floor(Math.random() * currentIndex);
        currentIndex--;
        [array[currentIndex], array[randomIndex]] = [
            array[randomIndex],
            array[currentIndex]
        ];
    }
    return array;
};
function $9805619f03ed02ef$export$ecfa8810709ab489(length) {
    let result = "";
    const characters = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
    const charactersLength = characters.length;
    let counter = 0;
    while(counter < length){
        result += characters.charAt(Math.floor(Math.random() * charactersLength));
        counter += 1;
    }
    return result;
}
const $9805619f03ed02ef$export$1ae03cd54bd9de7a = (text, replace)=>{
    const generated = [];
    for(let i = 0; i < text.length; i++){
        const char = text.charAt(i);
        if (char.toUpperCase() === char) generated.push(replace);
        generated.push(char.toLowerCase());
    }
    return generated.join("");
};
const $9805619f03ed02ef$export$e772c8ff12451969 = (ms)=>new Promise((r)=>setTimeout(r, ms));
const $9805619f03ed02ef$export$2e1efffb4405e7a8 = (number)=>new Intl.NumberFormat("en-EN").format(number);


const $2b1b88f9a0dfa7a8$export$28055d25e3f96ec1 = ()=>{
    const rawInfo = localStorage.getItem("sessionInfo") ?? undefined;
    if (!rawInfo) return;
    const info = JSON.parse(rawInfo);
    return {
        ...info,
        discordServerJoined: Boolean(info.discordServerJoined)
    };
};
const $2b1b88f9a0dfa7a8$export$b73dafe052ae32d3 = (sessionInfo)=>localStorage.setItem("sessionInfo", JSON.stringify(sessionInfo));
const $2b1b88f9a0dfa7a8$export$1749eeb4c07401df = ()=>localStorage.removeItem("sessionInfo");
const $2b1b88f9a0dfa7a8$export$ee156f6674243a1e = ()=>$2b1b88f9a0dfa7a8$export$28055d25e3f96ec1() !== undefined;
const $2b1b88f9a0dfa7a8$export$fa6a5e6b4dafb306 = (propertyName, value)=>{
    const sessionInfo = $2b1b88f9a0dfa7a8$export$28055d25e3f96ec1();
    if (sessionInfo && value) {
        sessionInfo[propertyName] = value;
        $2b1b88f9a0dfa7a8$export$b73dafe052ae32d3(sessionInfo);
    }
};
const $2b1b88f9a0dfa7a8$export$8e0aeea63de8f9e2 = (propertyName)=>{
    const sessionInfo = $2b1b88f9a0dfa7a8$export$28055d25e3f96ec1();
    if (sessionInfo && sessionInfo[propertyName]) {
        delete sessionInfo[propertyName];
        $2b1b88f9a0dfa7a8$export$b73dafe052ae32d3(sessionInfo);
    }
};
const $2b1b88f9a0dfa7a8$export$8d7ab2c91e5ca67b = (service, id)=>!localStorage.getItem(`maintenance-${service}-${id}`);
const $2b1b88f9a0dfa7a8$export$24bd3293e6899045 = (service, id)=>{
    localStorage.setItem(`maintenance-${service}-${id}`, "hidden");
};




const $b3b1baf40467424d$export$745043c7dc65e495 = {};


const $35a528e84618b070$export$3394aac6a0917ca2 = async (requestConfig, onError)=>{
    let sessionToken = (0, $b3b1baf40467424d$export$745043c7dc65e495).sessionToken;
    if (!sessionToken) {
        (0, $ad26fe773541dcd3$export$b410431fab84fa58).error("Impossible to retrieve the sessionToken, please refresh the page.");
        return;
    }
    let result;
    try {
        result = await (0, $57966c7e0affc4cb$export$2e2bcd8739ae039).request({
            ...requestConfig,
            headers: {
                "Authorization": `Bearer ${sessionToken}`
            }
        });
    } catch (err) {
        if ((0, $57966c7e0affc4cb$export$2e2bcd8739ae039).isAxiosError(err) && err.response?.status === 401) {
            try {
                const response = await (0, $57966c7e0affc4cb$export$2e2bcd8739ae039).post("/api/v1/hub/refresh", undefined, {
                    withCredentials: true
                });
                if (response && (0, $b3b1baf40467424d$export$745043c7dc65e495).setSessionToken) {
                    sessionToken = response.data.sessionToken;
                    (0, $b3b1baf40467424d$export$745043c7dc65e495).sessionToken = sessionToken;
                    (0, $b3b1baf40467424d$export$745043c7dc65e495).setSessionToken(sessionToken);
                    result = await (0, $57966c7e0affc4cb$export$2e2bcd8739ae039).request({
                        ...requestConfig,
                        headers: {
                            "Authorization": `Bearer ${sessionToken}`
                        }
                    });
                    return result;
                }
            } catch (err) {
                console.log(err);
            }
            try {
                (0, $ad26fe773541dcd3$export$b410431fab84fa58).info("Your token is out of date, please sign again the authentification message");
                if ((0, $b3b1baf40467424d$export$745043c7dc65e495).disconnect) (0, $b3b1baf40467424d$export$745043c7dc65e495).disconnect();
            } catch (err) {
                console.log(err);
                if (typeof err === "string") (0, $ad26fe773541dcd3$export$b410431fab84fa58).error(err);
                else (0, $ad26fe773541dcd3$export$b410431fab84fa58).error("Unknown error, please try again or contact the support team");
            }
        } else if (onError) onError(err);
        else if ((0, $57966c7e0affc4cb$export$2e2bcd8739ae039).isAxiosError(err) && typeof err.response?.data === "string") (0, $ad26fe773541dcd3$export$b410431fab84fa58).error(err.response?.data);
        else if (typeof err === "string") (0, $ad26fe773541dcd3$export$b410431fab84fa58).error(err);
        else (0, $ad26fe773541dcd3$export$b410431fab84fa58).error("Unknown error, please try again or contact the support team");
        console.log(err);
    }
    return result;
};
const $35a528e84618b070$export$3ff59198e2333fc6 = async (ledger, publicKey)=>{
    const response = await (0, $57966c7e0affc4cb$export$2e2bcd8739ae039)({
        url: "/api/v1/hub/nonce",
        method: "get",
        params: {
            ledger: ledger,
            publicKey: publicKey
        }
    });
    return response.data;
};
const $35a528e84618b070$export$f8367b7c5d4d854f = async (params)=>{
    const { publicKey: publicKey, nonce: nonce, signature: signature, message: message, signedTx: signedTx } = params;
    const response = await (0, $57966c7e0affc4cb$export$2e2bcd8739ae039).get("/api/v1/hub/connect", {
        params: {
            publicKey: publicKey,
            nonce: nonce,
            signature: signature,
            message: message,
            signedTx: signedTx
        }
    });
    return response;
};
const $35a528e84618b070$export$525389dcb3a09d43 = async (publicKey, signedTx, nonce)=>{
    return await $35a528e84618b070$export$f8367b7c5d4d854f({
        publicKey: publicKey,
        signedTx: signedTx,
        nonce: nonce
    });
};
const $35a528e84618b070$export$d8e5ff8d207947de = async (username, onError)=>{
    const result = await $35a528e84618b070$export$3394aac6a0917ca2({
        url: "/api/v1/hub/username",
        method: "POST",
        data: {
            username: username
        }
    }, onError);
    return result;
};
const $35a528e84618b070$export$a5453f73d7944b35 = async (onError)=>{
    const result = await $35a528e84618b070$export$3394aac6a0917ca2({
        url: "/api/v1/hub/check-connection",
        method: "GET"
    }, onError);
    return result?.data;
};
const $35a528e84618b070$export$df25f2f949bacaf7 = async (onError)=>{
    // localhost
    if (window.location.hostname.includes("localhost")) return {
        status: 200,
        data: {
            local: 1
        }
    };
    const result = await $35a528e84618b070$export$3394aac6a0917ca2({
        url: "/api/v1/hub/servers-list",
        method: "GET"
    }, onError);
    return result;
};
const $35a528e84618b070$export$c0f0d0ce4283a937 = async (serverName)=>{
    const ping = [];
    for(let i = 0; i < 4; i++)try {
        const pingTime = Date.now();
        const pingResponse = await (0, $57966c7e0affc4cb$export$2e2bcd8739ae039).get(`https://${serverName}-i0-blast.oogy.io/ping`, {
            timeout: 500
        });
        if (pingResponse.status === 200) ping.push(Date.now() - pingTime);
    } catch (err) {}
    if (ping.length > 1) return Math.ceil(ping.slice(1).reduce((previous, current)=>previous + current, 0) / (ping.length - 1));
};
const $35a528e84618b070$export$52c1d90f725edc2c = async (score, onError)=>{
    const result = await $35a528e84618b070$export$3394aac6a0917ca2({
        url: "/api/v1/hub/estimated-leaderboard",
        method: "GET",
        params: {
            score: score
        }
    }, onError);
    return result;
};
const $35a528e84618b070$export$36e89c7c246b7b1b = async (onError)=>{
    const result = await $35a528e84618b070$export$3394aac6a0917ca2({
        url: "/api/v1/hub/global-leaderboard",
        method: "GET"
    }, onError);
    return result;
};
const $35a528e84618b070$export$889eec04d93e7849 = async (onError)=>{
    const result = await $35a528e84618b070$export$3394aac6a0917ca2({
        url: "/api/v1/hub/weekly-leaderboard",
        method: "GET"
    }, onError);
    return result;
};
const $35a528e84618b070$export$98b77fd74ac44d44 = async (onError)=>{
    const result = await $35a528e84618b070$export$3394aac6a0917ca2({
        url: "/api/v1/hub/clash-leaderboard",
        method: "GET"
    }, onError);
    return result;
};
const $35a528e84618b070$export$92508f27abff77c2 = async (onError)=>{
    const result = await $35a528e84618b070$export$3394aac6a0917ca2({
        url: "/api/v1/hub/get-credits",
        method: "GET"
    }, onError);
    return result?.data;
};
const $35a528e84618b070$export$ed6a7eb10310bf8 = async (onError)=>{
    const result = await $35a528e84618b070$export$3394aac6a0917ca2({
        url: "/api/v1/hub/account-info",
        method: "GET"
    }, onError);
    return result?.data;
};
const $35a528e84618b070$export$aa6ba60d2e4d6066 = async (onError)=>{
    const result = await $35a528e84618b070$export$3394aac6a0917ca2({
        url: "/api/v1/hub/holded-nfts",
        method: "GET"
    }, onError);
    return result;
};
const $35a528e84618b070$export$ea0cf17b3b0cadbf = async (holder = false, onError)=>{
    const result = await $35a528e84618b070$export$3394aac6a0917ca2({
        url: "/api/v1/hub/current-weekly-prize",
        method: "GET",
        params: {
            holder: holder
        }
    }, onError);
    return result;
};
const $35a528e84618b070$export$680d5e90d764a0e1 = async (holder = false, onError)=>{
    const result = await $35a528e84618b070$export$3394aac6a0917ca2({
        url: "/api/v1/hub/previous-weekly-prize",
        method: "GET",
        params: {
            holder: holder
        }
    }, onError);
    return result;
};
const $35a528e84618b070$export$ad9fce45729b6a0e = async (gems, onError)=>{
    const result = await $35a528e84618b070$export$3394aac6a0917ca2({
        url: "/api/v1/hub/invoice-id",
        method: "GET",
        params: {
            gems: gems
        }
    }, onError);
    return result;
};
const $35a528e84618b070$export$cad5256e969c1910 = async (invoiceId, signature, onError)=>{
    const result = await $35a528e84618b070$export$3394aac6a0917ca2({
        url: "/api/v1/hub/check-invoice-payment",
        method: "GET",
        params: {
            invoiceId: invoiceId,
            signature: signature
        }
    }, onError);
    return result;
};
const $35a528e84618b070$export$59cbea4635bedba3 = async (chestIndex, onError)=>{
    const result = await $35a528e84618b070$export$3394aac6a0917ca2({
        url: "/api/v1/hub/open-chest",
        method: "POST",
        data: {
            chestIndex: chestIndex
        }
    }, onError);
    return result;
};
const $35a528e84618b070$export$547324be4cef41e3 = async (onError)=>{
    const result = await $35a528e84618b070$export$3394aac6a0917ca2({
        url: "/api/v1/hub/character-info",
        method: "GET"
    }, onError);
    return result;
};
const $35a528e84618b070$export$f1209970daa254db = async (name, onError)=>{
    const result = await $35a528e84618b070$export$3394aac6a0917ca2({
        url: "/api/v1/hub/upgrade-character",
        method: "POST",
        data: {
            name: name
        }
    }, onError);
    return result;
};
const $35a528e84618b070$export$ad4eacef1e38433 = async (type, name, onError)=>{
    const result = await $35a528e84618b070$export$3394aac6a0917ca2({
        url: "/api/v1/hub/buy-cosmetic",
        method: "POST",
        data: {
            type: type,
            name: name
        }
    }, onError);
    return result;
};
const $35a528e84618b070$export$571699c739686853 = async (type, name, onError)=>{
    const result = await $35a528e84618b070$export$3394aac6a0917ca2({
        url: "/api/v1/hub/equip-cosmetic",
        method: "POST",
        data: {
            type: type,
            name: name
        }
    }, onError);
    return result;
};
const $35a528e84618b070$export$5c66de07daf88ef5 = async (name, onError)=>{
    const result = await $35a528e84618b070$export$3394aac6a0917ca2({
        url: "/api/v1/hub/buy-weapon",
        method: "POST",
        data: {
            name: name
        }
    }, onError);
    return result;
};
const $35a528e84618b070$export$5abf33b3a23c0859 = async (name, onError)=>{
    const result = await $35a528e84618b070$export$3394aac6a0917ca2({
        url: "/api/v1/hub/equip-weapon",
        method: "POST",
        data: {
            name: name
        }
    }, onError);
    return result;
};
const $35a528e84618b070$export$705f2068f3c1014b = async (name, onError)=>{
    const result = await $35a528e84618b070$export$3394aac6a0917ca2({
        url: "/api/v1/hub/upgrade-weapon",
        method: "POST",
        data: {
            name: name
        }
    }, onError);
    return result;
};
const $35a528e84618b070$export$82c8231841dac5b7 = async (slotId, onError)=>{
    const result = await $35a528e84618b070$export$3394aac6a0917ca2({
        url: "/api/v1/hub/open-chest-slot",
        method: "POST",
        data: {
            slotId: slotId
        }
    }, onError);
    return result;
};
const $35a528e84618b070$export$d13a04717b4c27fa = async (mode, onError)=>{
    const result = await $35a528e84618b070$export$3394aac6a0917ca2({
        url: "/api/v1/hub/buy-energy",
        method: "POST",
        data: {
            mode: mode
        }
    }, onError);
    return result;
};
const $35a528e84618b070$export$37992403e144a117 = async (mode, onError)=>{
    const result = await $35a528e84618b070$export$3394aac6a0917ca2({
        url: "/api/v1/hub/pay-game",
        method: "POST",
        data: {
            mode: mode
        }
    }, onError);
    return result;
};
const $35a528e84618b070$export$33b1c36f2439f24a = async (index, onError)=>{
    const result = await $35a528e84618b070$export$3394aac6a0917ca2({
        url: "/api/v1/hub/burn-chest",
        method: "POST",
        data: {
            index: index
        }
    }, onError);
    return result;
};
const $35a528e84618b070$export$f9acc3183a46a920 = async (index, onError)=>{
    const result = await $35a528e84618b070$export$3394aac6a0917ca2({
        url: "/api/v1/hub/store-chest",
        method: "POST",
        data: {
            index: index
        }
    }, onError);
    return result;
};
const $35a528e84618b070$export$8a18bf6ea8cb2bd9 = async (onError)=>{
    const result = await $35a528e84618b070$export$3394aac6a0917ca2({
        url: "/api/v1/hub/clean-won-chests",
        method: "POST"
    }, onError);
    return result;
};
const $35a528e84618b070$export$c6443615f35b2a2c = async (onError)=>{
    const result = await $35a528e84618b070$export$3394aac6a0917ca2({
        url: "/api/v1/hub/unlock-multiplayer",
        method: "POST"
    }, onError);
    return result;
};
const $35a528e84618b070$export$d26d4d6ef5001f3a = async (onError)=>{
    const result = await $35a528e84618b070$export$3394aac6a0917ca2({
        url: "/api/v1/hub/confirm-club",
        method: "POST"
    }, onError);
    return result;
};
const $35a528e84618b070$export$1b2baf0c7c665732 = async (onError)=>{
    const result = await $35a528e84618b070$export$3394aac6a0917ca2({
        url: "/api/v1/hub/club-clash",
        method: "GET"
    }, onError);
    return result;
};
const $35a528e84618b070$export$ddd1b76aad54589d = async (numberOfVessels, onError)=>{
    const result = await $35a528e84618b070$export$3394aac6a0917ca2({
        url: "/api/v1/hub/deposit-vessels",
        method: "POST",
        data: {
            numberOfVessels: numberOfVessels
        }
    }, onError);
    return result;
};
const $35a528e84618b070$export$783917a48fbd6b16 = async (assetId, signature, onError)=>{
    const result = await $35a528e84618b070$export$3394aac6a0917ca2({
        url: "/api/v1/hub/verify-deposit-vessels",
        method: "GET",
        params: {
            assetId: assetId,
            signature: signature
        }
    }, onError);
    return result;
};
const $35a528e84618b070$export$ae43f0e5ee21df6f = async (name, onError)=>{
    const result = await $35a528e84618b070$export$3394aac6a0917ca2({
        url: "/api/v1/hub/activate-code",
        method: "POST",
        data: {
            name: name
        }
    }, onError);
    return result;
};



var $e5a78797c4262d1f$exports = {};
"use strict";
var $9e6bd5018912b3a9$exports = {};
$9e6bd5018912b3a9$exports = function() {
    var selection = document.getSelection();
    if (!selection.rangeCount) return function() {};
    var active = document.activeElement;
    var ranges = [];
    for(var i = 0; i < selection.rangeCount; i++)ranges.push(selection.getRangeAt(i));
    switch(active.tagName.toUpperCase()){
        case "INPUT":
        case "TEXTAREA":
            active.blur();
            break;
        default:
            active = null;
            break;
    }
    selection.removeAllRanges();
    return function() {
        selection.type === "Caret" && selection.removeAllRanges();
        if (!selection.rangeCount) ranges.forEach(function(range) {
            selection.addRange(range);
        });
        active && active.focus();
    };
};


var $e5a78797c4262d1f$var$clipboardToIE11Formatting = {
    "text/plain": "Text",
    "text/html": "Url",
    "default": "Text"
};
var $e5a78797c4262d1f$var$defaultMessage = "Copy to clipboard: #{key}, Enter";
function $e5a78797c4262d1f$var$format(message) {
    var copyKey = (/mac os x/i.test(navigator.userAgent) ? "\u2318" : "Ctrl") + "+C";
    return message.replace(/#{\s*key\s*}/g, copyKey);
}
function $e5a78797c4262d1f$var$copy(text, options) {
    var debug, message, reselectPrevious, range, selection, mark, success = false;
    if (!options) options = {};
    debug = options.debug || false;
    try {
        reselectPrevious = $9e6bd5018912b3a9$exports();
        range = document.createRange();
        selection = document.getSelection();
        mark = document.createElement("span");
        mark.textContent = text;
        // avoid screen readers from reading out loud the text
        mark.ariaHidden = "true";
        // reset user styles for span element
        mark.style.all = "unset";
        // prevents scrolling to the end of the page
        mark.style.position = "fixed";
        mark.style.top = 0;
        mark.style.clip = "rect(0, 0, 0, 0)";
        // used to preserve spaces and line breaks
        mark.style.whiteSpace = "pre";
        // do not inherit user-select (it may be `none`)
        mark.style.webkitUserSelect = "text";
        mark.style.MozUserSelect = "text";
        mark.style.msUserSelect = "text";
        mark.style.userSelect = "text";
        mark.addEventListener("copy", function(e) {
            e.stopPropagation();
            if (options.format) {
                e.preventDefault();
                if (typeof e.clipboardData === "undefined") {
                    debug && console.warn("unable to use e.clipboardData");
                    debug && console.warn("trying IE specific stuff");
                    window.clipboardData.clearData();
                    var format = $e5a78797c4262d1f$var$clipboardToIE11Formatting[options.format] || $e5a78797c4262d1f$var$clipboardToIE11Formatting["default"];
                    window.clipboardData.setData(format, text);
                } else {
                    e.clipboardData.clearData();
                    e.clipboardData.setData(options.format, text);
                }
            }
            if (options.onCopy) {
                e.preventDefault();
                options.onCopy(e.clipboardData);
            }
        });
        document.body.appendChild(mark);
        range.selectNodeContents(mark);
        selection.addRange(range);
        var successful = document.execCommand("copy");
        if (!successful) throw new Error("copy command was unsuccessful");
        success = true;
    } catch (err) {
        debug && console.error("unable to copy using execCommand: ", err);
        debug && console.warn("trying IE specific stuff");
        try {
            window.clipboardData.setData(options.format || "text", text);
            options.onCopy && options.onCopy(window.clipboardData);
            success = true;
        } catch (err) {
            debug && console.error("unable to copy using clipboardData: ", err);
            debug && console.error("falling back to prompt");
            message = $e5a78797c4262d1f$var$format("message" in options ? options.message : $e5a78797c4262d1f$var$defaultMessage);
            window.prompt(message, text);
        }
    } finally{
        if (selection) {
            if (typeof selection.removeRange == "function") selection.removeRange(range);
            else selection.removeAllRanges();
        }
        if (mark) document.body.removeChild(mark);
        reselectPrevious();
    }
    return success;
}
$e5a78797c4262d1f$exports = $e5a78797c4262d1f$var$copy;



var $acw62 = parcelRequire("acw62");

function $618a8e53233cd9fa$export$2e2bcd8739ae039() {
    $618a8e53233cd9fa$export$2e2bcd8739ae039 = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $618a8e53233cd9fa$export$2e2bcd8739ae039.apply(this, arguments);
}


function $133b6e059b2f6d5e$export$2e2bcd8739ae039(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}


function $0ad5d8b55fe970db$export$2e2bcd8739ae039(o, p) {
    $0ad5d8b55fe970db$export$2e2bcd8739ae039 = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $0ad5d8b55fe970db$export$2e2bcd8739ae039(o, p);
}


function $bbb54ce93eb94a95$export$2e2bcd8739ae039(subClass, superClass) {
    subClass.prototype = Object.create(superClass.prototype);
    subClass.prototype.constructor = subClass;
    (0, $0ad5d8b55fe970db$export$2e2bcd8739ae039)(subClass, superClass);
}



/**
 * Checks if a given element has a CSS class.
 * 
 * @param element the element
 * @param className the CSS class name
 */ function $3c0eef4e7b8d3866$export$2e2bcd8739ae039(element, className) {
    if (element.classList) return !!className && element.classList.contains(className);
    return (" " + (element.className.baseVal || element.className) + " ").indexOf(" " + className + " ") !== -1;
}


function $620ffe1c3bcccf8e$export$2e2bcd8739ae039(element, className) {
    if (element.classList) element.classList.add(className);
    else if (!(0, $3c0eef4e7b8d3866$export$2e2bcd8739ae039)(element, className)) {
        if (typeof element.className === "string") element.className = element.className + " " + className;
        else element.setAttribute("class", (element.className && element.className.baseVal || "") + " " + className);
    }
}


function $c22b31c675df16bf$var$replaceClassName(origClass, classToRemove) {
    return origClass.replace(new RegExp("(^|\\s)" + classToRemove + "(?:\\s|$)", "g"), "$1").replace(/\s+/g, " ").replace(/^\s*|\s*$/g, "");
}
function $c22b31c675df16bf$export$2e2bcd8739ae039(element, className) {
    if (element.classList) element.classList.remove(className);
    else if (typeof element.className === "string") element.className = $c22b31c675df16bf$var$replaceClassName(element.className, className);
    else element.setAttribute("class", $c22b31c675df16bf$var$replaceClassName(element.className && element.className.baseVal || "", className));
}



var $acw62 = parcelRequire("acw62");




var $acw62 = parcelRequire("acw62");

var $9fc60dfb9203246b$export$2e2bcd8739ae039 = {
    disabled: false
};




var $acw62 = parcelRequire("acw62");
var $4c26e32a51d8c622$export$2e2bcd8739ae039 = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createContext(null);


var $37faf39349e00e45$export$7d26bbb1236dafd6 = function forceReflow(node) {
    return node.scrollTop;
};


var $0fef977f04119bf5$export$bb38bb9a1161268 = "unmounted";
var $0fef977f04119bf5$export$84cbff306f539230 = "exited";
var $0fef977f04119bf5$export$df38205c966be359 = "entering";
var $0fef977f04119bf5$export$78e9e6e3e014d60a = "entered";
var $0fef977f04119bf5$export$4aacc83d4d59139f = "exiting";
/**
 * The Transition component lets you describe a transition from one component
 * state to another _over time_ with a simple declarative API. Most commonly
 * it's used to animate the mounting and unmounting of a component, but can also
 * be used to describe in-place transition states as well.
 *
 * ---
 *
 * **Note**: `Transition` is a platform-agnostic base component. If you're using
 * transitions in CSS, you'll probably want to use
 * [`CSSTransition`](https://reactcommunity.org/react-transition-group/css-transition)
 * instead. It inherits all the features of `Transition`, but contains
 * additional features necessary to play nice with CSS transitions (hence the
 * name of the component).
 *
 * ---
 *
 * By default the `Transition` component does not alter the behavior of the
 * component it renders, it only tracks "enter" and "exit" states for the
 * components. It's up to you to give meaning and effect to those states. For
 * example we can add styles to a component when it enters or exits:
 *
 * ```jsx
 * import { Transition } from 'react-transition-group';
 *
 * const duration = 300;
 *
 * const defaultStyle = {
 *   transition: `opacity ${duration}ms ease-in-out`,
 *   opacity: 0,
 * }
 *
 * const transitionStyles = {
 *   entering: { opacity: 1 },
 *   entered:  { opacity: 1 },
 *   exiting:  { opacity: 0 },
 *   exited:  { opacity: 0 },
 * };
 *
 * const Fade = ({ in: inProp }) => (
 *   <Transition in={inProp} timeout={duration}>
 *     {state => (
 *       <div style={{
 *         ...defaultStyle,
 *         ...transitionStyles[state]
 *       }}>
 *         I'm a fade Transition!
 *       </div>
 *     )}
 *   </Transition>
 * );
 * ```
 *
 * There are 4 main states a Transition can be in:
 *  - `'entering'`
 *  - `'entered'`
 *  - `'exiting'`
 *  - `'exited'`
 *
 * Transition state is toggled via the `in` prop. When `true` the component
 * begins the "Enter" stage. During this stage, the component will shift from
 * its current transition state, to `'entering'` for the duration of the
 * transition and then to the `'entered'` stage once it's complete. Let's take
 * the following example (we'll use the
 * [useState](https://reactjs.org/docs/hooks-reference.html#usestate) hook):
 *
 * ```jsx
 * function App() {
 *   const [inProp, setInProp] = useState(false);
 *   return (
 *     <div>
 *       <Transition in={inProp} timeout={500}>
 *         {state => (
 *           // ...
 *         )}
 *       </Transition>
 *       <button onClick={() => setInProp(true)}>
 *         Click to Enter
 *       </button>
 *     </div>
 *   );
 * }
 * ```
 *
 * When the button is clicked the component will shift to the `'entering'` state
 * and stay there for 500ms (the value of `timeout`) before it finally switches
 * to `'entered'`.
 *
 * When `in` is `false` the same thing happens except the state moves from
 * `'exiting'` to `'exited'`.
 */ var $0fef977f04119bf5$var$Transition = /*#__PURE__*/ function(_React$Component) {
    (0, $bbb54ce93eb94a95$export$2e2bcd8739ae039)(Transition, _React$Component);
    function Transition(props, context) {
        var _this;
        _this = _React$Component.call(this, props, context) || this;
        var parentGroup = context; // In the context of a TransitionGroup all enters are really appears
        var appear = parentGroup && !parentGroup.isMounting ? props.enter : props.appear;
        var initialStatus;
        _this.appearStatus = null;
        if (props.in) {
            if (appear) {
                initialStatus = $0fef977f04119bf5$export$84cbff306f539230;
                _this.appearStatus = $0fef977f04119bf5$export$df38205c966be359;
            } else initialStatus = $0fef977f04119bf5$export$78e9e6e3e014d60a;
        } else if (props.unmountOnExit || props.mountOnEnter) initialStatus = $0fef977f04119bf5$export$bb38bb9a1161268;
        else initialStatus = $0fef977f04119bf5$export$84cbff306f539230;
        _this.state = {
            status: initialStatus
        };
        _this.nextCallback = null;
        return _this;
    }
    Transition.getDerivedStateFromProps = function getDerivedStateFromProps(_ref, prevState) {
        var nextIn = _ref.in;
        if (nextIn && prevState.status === $0fef977f04119bf5$export$bb38bb9a1161268) return {
            status: $0fef977f04119bf5$export$84cbff306f539230
        };
        return null;
    } // getSnapshotBeforeUpdate(prevProps) {
    ;
    var _proto = Transition.prototype;
    _proto.componentDidMount = function componentDidMount() {
        this.updateStatus(true, this.appearStatus);
    };
    _proto.componentDidUpdate = function componentDidUpdate(prevProps) {
        var nextStatus = null;
        if (prevProps !== this.props) {
            var status = this.state.status;
            if (this.props.in) {
                if (status !== $0fef977f04119bf5$export$df38205c966be359 && status !== $0fef977f04119bf5$export$78e9e6e3e014d60a) nextStatus = $0fef977f04119bf5$export$df38205c966be359;
            } else if (status === $0fef977f04119bf5$export$df38205c966be359 || status === $0fef977f04119bf5$export$78e9e6e3e014d60a) nextStatus = $0fef977f04119bf5$export$4aacc83d4d59139f;
        }
        this.updateStatus(false, nextStatus);
    };
    _proto.componentWillUnmount = function componentWillUnmount() {
        this.cancelNextCallback();
    };
    _proto.getTimeouts = function getTimeouts() {
        var timeout = this.props.timeout;
        var exit, enter, appear;
        exit = enter = appear = timeout;
        if (timeout != null && typeof timeout !== "number") {
            exit = timeout.exit;
            enter = timeout.enter; // TODO: remove fallback for next major
            appear = timeout.appear !== undefined ? timeout.appear : enter;
        }
        return {
            exit: exit,
            enter: enter,
            appear: appear
        };
    };
    _proto.updateStatus = function updateStatus(mounting, nextStatus) {
        if (mounting === void 0) mounting = false;
        if (nextStatus !== null) {
            // nextStatus will always be ENTERING or EXITING.
            this.cancelNextCallback();
            if (nextStatus === $0fef977f04119bf5$export$df38205c966be359) {
                if (this.props.unmountOnExit || this.props.mountOnEnter) {
                    var node = this.props.nodeRef ? this.props.nodeRef.current : (0, (/*@__PURE__*/$parcel$interopDefault($11492dca620dcaa5$exports))).findDOMNode(this); // https://github.com/reactjs/react-transition-group/pull/749
                    // With unmountOnExit or mountOnEnter, the enter animation should happen at the transition between `exited` and `entering`.
                    // To make the animation happen,  we have to separate each rendering and avoid being processed as batched.
                    if (node) (0, $37faf39349e00e45$export$7d26bbb1236dafd6)(node);
                }
                this.performEnter(mounting);
            } else this.performExit();
        } else if (this.props.unmountOnExit && this.state.status === $0fef977f04119bf5$export$84cbff306f539230) this.setState({
            status: $0fef977f04119bf5$export$bb38bb9a1161268
        });
    };
    _proto.performEnter = function performEnter(mounting) {
        var _this2 = this;
        var enter = this.props.enter;
        var appearing = this.context ? this.context.isMounting : mounting;
        var _ref2 = this.props.nodeRef ? [
            appearing
        ] : [
            (0, (/*@__PURE__*/$parcel$interopDefault($11492dca620dcaa5$exports))).findDOMNode(this),
            appearing
        ], maybeNode = _ref2[0], maybeAppearing = _ref2[1];
        var timeouts = this.getTimeouts();
        var enterTimeout = appearing ? timeouts.appear : timeouts.enter; // no enter animation skip right to ENTERED
        // if we are mounting and running this it means appear _must_ be set
        if (!mounting && !enter || (0, $9fc60dfb9203246b$export$2e2bcd8739ae039).disabled) {
            this.safeSetState({
                status: $0fef977f04119bf5$export$78e9e6e3e014d60a
            }, function() {
                _this2.props.onEntered(maybeNode);
            });
            return;
        }
        this.props.onEnter(maybeNode, maybeAppearing);
        this.safeSetState({
            status: $0fef977f04119bf5$export$df38205c966be359
        }, function() {
            _this2.props.onEntering(maybeNode, maybeAppearing);
            _this2.onTransitionEnd(enterTimeout, function() {
                _this2.safeSetState({
                    status: $0fef977f04119bf5$export$78e9e6e3e014d60a
                }, function() {
                    _this2.props.onEntered(maybeNode, maybeAppearing);
                });
            });
        });
    };
    _proto.performExit = function performExit() {
        var _this3 = this;
        var exit = this.props.exit;
        var timeouts = this.getTimeouts();
        var maybeNode = this.props.nodeRef ? undefined : (0, (/*@__PURE__*/$parcel$interopDefault($11492dca620dcaa5$exports))).findDOMNode(this); // no exit animation skip right to EXITED
        if (!exit || (0, $9fc60dfb9203246b$export$2e2bcd8739ae039).disabled) {
            this.safeSetState({
                status: $0fef977f04119bf5$export$84cbff306f539230
            }, function() {
                _this3.props.onExited(maybeNode);
            });
            return;
        }
        this.props.onExit(maybeNode);
        this.safeSetState({
            status: $0fef977f04119bf5$export$4aacc83d4d59139f
        }, function() {
            _this3.props.onExiting(maybeNode);
            _this3.onTransitionEnd(timeouts.exit, function() {
                _this3.safeSetState({
                    status: $0fef977f04119bf5$export$84cbff306f539230
                }, function() {
                    _this3.props.onExited(maybeNode);
                });
            });
        });
    };
    _proto.cancelNextCallback = function cancelNextCallback() {
        if (this.nextCallback !== null) {
            this.nextCallback.cancel();
            this.nextCallback = null;
        }
    };
    _proto.safeSetState = function safeSetState(nextState, callback) {
        // This shouldn't be necessary, but there are weird race conditions with
        // setState callbacks and unmounting in testing, so always make sure that
        // we can cancel any pending setState callbacks after we unmount.
        callback = this.setNextCallback(callback);
        this.setState(nextState, callback);
    };
    _proto.setNextCallback = function setNextCallback(callback) {
        var _this4 = this;
        var active = true;
        this.nextCallback = function(event) {
            if (active) {
                active = false;
                _this4.nextCallback = null;
                callback(event);
            }
        };
        this.nextCallback.cancel = function() {
            active = false;
        };
        return this.nextCallback;
    };
    _proto.onTransitionEnd = function onTransitionEnd(timeout, handler) {
        this.setNextCallback(handler);
        var node = this.props.nodeRef ? this.props.nodeRef.current : (0, (/*@__PURE__*/$parcel$interopDefault($11492dca620dcaa5$exports))).findDOMNode(this);
        var doesNotHaveTimeoutOrListener = timeout == null && !this.props.addEndListener;
        if (!node || doesNotHaveTimeoutOrListener) {
            setTimeout(this.nextCallback, 0);
            return;
        }
        if (this.props.addEndListener) {
            var _ref3 = this.props.nodeRef ? [
                this.nextCallback
            ] : [
                node,
                this.nextCallback
            ], maybeNode = _ref3[0], maybeNextCallback = _ref3[1];
            this.props.addEndListener(maybeNode, maybeNextCallback);
        }
        if (timeout != null) setTimeout(this.nextCallback, timeout);
    };
    _proto.render = function render() {
        var status = this.state.status;
        if (status === $0fef977f04119bf5$export$bb38bb9a1161268) return null;
        var _this$props = this.props, children = _this$props.children, _in = _this$props.in, _mountOnEnter = _this$props.mountOnEnter, _unmountOnExit = _this$props.unmountOnExit, _appear = _this$props.appear, _enter = _this$props.enter, _exit = _this$props.exit, _timeout = _this$props.timeout, _addEndListener = _this$props.addEndListener, _onEnter = _this$props.onEnter, _onEntering = _this$props.onEntering, _onEntered = _this$props.onEntered, _onExit = _this$props.onExit, _onExiting = _this$props.onExiting, _onExited = _this$props.onExited, _nodeRef = _this$props.nodeRef, childProps = (0, $133b6e059b2f6d5e$export$2e2bcd8739ae039)(_this$props, [
            "children",
            "in",
            "mountOnEnter",
            "unmountOnExit",
            "appear",
            "enter",
            "exit",
            "timeout",
            "addEndListener",
            "onEnter",
            "onEntering",
            "onEntered",
            "onExit",
            "onExiting",
            "onExited",
            "nodeRef"
        ]);
        return(/*#__PURE__*/ // allows for nested Transitions
        (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $4c26e32a51d8c622$export$2e2bcd8739ae039).Provider, {
            value: null
        }, typeof children === "function" ? children(status, childProps) : (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).cloneElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Children.only(children), childProps)));
    };
    return Transition;
}((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Component);
$0fef977f04119bf5$var$Transition.contextType = (0, $4c26e32a51d8c622$export$2e2bcd8739ae039);
$0fef977f04119bf5$var$Transition.propTypes = {}; // Name the function so it is clearer in the documentation
function $0fef977f04119bf5$var$noop() {}
$0fef977f04119bf5$var$Transition.defaultProps = {
    in: false,
    mountOnEnter: false,
    unmountOnExit: false,
    appear: false,
    enter: true,
    exit: true,
    onEnter: $0fef977f04119bf5$var$noop,
    onEntering: $0fef977f04119bf5$var$noop,
    onEntered: $0fef977f04119bf5$var$noop,
    onExit: $0fef977f04119bf5$var$noop,
    onExiting: $0fef977f04119bf5$var$noop,
    onExited: $0fef977f04119bf5$var$noop
};
$0fef977f04119bf5$var$Transition.UNMOUNTED = $0fef977f04119bf5$export$bb38bb9a1161268;
$0fef977f04119bf5$var$Transition.EXITED = $0fef977f04119bf5$export$84cbff306f539230;
$0fef977f04119bf5$var$Transition.ENTERING = $0fef977f04119bf5$export$df38205c966be359;
$0fef977f04119bf5$var$Transition.ENTERED = $0fef977f04119bf5$export$78e9e6e3e014d60a;
$0fef977f04119bf5$var$Transition.EXITING = $0fef977f04119bf5$export$4aacc83d4d59139f;
var $0fef977f04119bf5$export$2e2bcd8739ae039 = $0fef977f04119bf5$var$Transition;




var $ee2e736fe07a2c40$var$_addClass = function addClass(node, classes) {
    return node && classes && classes.split(" ").forEach(function(c) {
        return (0, $620ffe1c3bcccf8e$export$2e2bcd8739ae039)(node, c);
    });
};
var $ee2e736fe07a2c40$var$removeClass = function removeClass(node, classes) {
    return node && classes && classes.split(" ").forEach(function(c) {
        return (0, $c22b31c675df16bf$export$2e2bcd8739ae039)(node, c);
    });
};
/**
 * A transition component inspired by the excellent
 * [ng-animate](https://docs.angularjs.org/api/ngAnimate) library, you should
 * use it if you're using CSS transitions or animations. It's built upon the
 * [`Transition`](https://reactcommunity.org/react-transition-group/transition)
 * component, so it inherits all of its props.
 *
 * `CSSTransition` applies a pair of class names during the `appear`, `enter`,
 * and `exit` states of the transition. The first class is applied and then a
 * second `*-active` class in order to activate the CSS transition. After the
 * transition, matching `*-done` class names are applied to persist the
 * transition state.
 *
 * ```jsx
 * function App() {
 *   const [inProp, setInProp] = useState(false);
 *   return (
 *     <div>
 *       <CSSTransition in={inProp} timeout={200} classNames="my-node">
 *         <div>
 *           {"I'll receive my-node-* classes"}
 *         </div>
 *       </CSSTransition>
 *       <button type="button" onClick={() => setInProp(true)}>
 *         Click to Enter
 *       </button>
 *     </div>
 *   );
 * }
 * ```
 *
 * When the `in` prop is set to `true`, the child component will first receive
 * the class `example-enter`, then the `example-enter-active` will be added in
 * the next tick. `CSSTransition` [forces a
 * reflow](https://github.com/reactjs/react-transition-group/blob/5007303e729a74be66a21c3e2205e4916821524b/src/CSSTransition.js#L208-L215)
 * between before adding the `example-enter-active`. This is an important trick
 * because it allows us to transition between `example-enter` and
 * `example-enter-active` even though they were added immediately one after
 * another. Most notably, this is what makes it possible for us to animate
 * _appearance_.
 *
 * ```css
 * .my-node-enter {
 *   opacity: 0;
 * }
 * .my-node-enter-active {
 *   opacity: 1;
 *   transition: opacity 200ms;
 * }
 * .my-node-exit {
 *   opacity: 1;
 * }
 * .my-node-exit-active {
 *   opacity: 0;
 *   transition: opacity 200ms;
 * }
 * ```
 *
 * `*-active` classes represent which styles you want to animate **to**, so it's
 * important to add `transition` declaration only to them, otherwise transitions
 * might not behave as intended! This might not be obvious when the transitions
 * are symmetrical, i.e. when `*-enter-active` is the same as `*-exit`, like in
 * the example above (minus `transition`), but it becomes apparent in more
 * complex transitions.
 *
 * **Note**: If you're using the
 * [`appear`](http://reactcommunity.org/react-transition-group/transition#Transition-prop-appear)
 * prop, make sure to define styles for `.appear-*` classes as well.
 */ var $ee2e736fe07a2c40$var$CSSTransition = /*#__PURE__*/ function(_React$Component) {
    (0, $bbb54ce93eb94a95$export$2e2bcd8739ae039)(CSSTransition, _React$Component);
    function CSSTransition() {
        var _this;
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _React$Component.call.apply(_React$Component, [
            this
        ].concat(args)) || this;
        _this.appliedClasses = {
            appear: {},
            enter: {},
            exit: {}
        };
        _this.onEnter = function(maybeNode, maybeAppearing) {
            var _this$resolveArgument = _this.resolveArguments(maybeNode, maybeAppearing), node = _this$resolveArgument[0], appearing = _this$resolveArgument[1];
            _this.removeClasses(node, "exit");
            _this.addClass(node, appearing ? "appear" : "enter", "base");
            if (_this.props.onEnter) _this.props.onEnter(maybeNode, maybeAppearing);
        };
        _this.onEntering = function(maybeNode, maybeAppearing) {
            var _this$resolveArgument2 = _this.resolveArguments(maybeNode, maybeAppearing), node = _this$resolveArgument2[0], appearing = _this$resolveArgument2[1];
            var type = appearing ? "appear" : "enter";
            _this.addClass(node, type, "active");
            if (_this.props.onEntering) _this.props.onEntering(maybeNode, maybeAppearing);
        };
        _this.onEntered = function(maybeNode, maybeAppearing) {
            var _this$resolveArgument3 = _this.resolveArguments(maybeNode, maybeAppearing), node = _this$resolveArgument3[0], appearing = _this$resolveArgument3[1];
            var type = appearing ? "appear" : "enter";
            _this.removeClasses(node, type);
            _this.addClass(node, type, "done");
            if (_this.props.onEntered) _this.props.onEntered(maybeNode, maybeAppearing);
        };
        _this.onExit = function(maybeNode) {
            var _this$resolveArgument4 = _this.resolveArguments(maybeNode), node = _this$resolveArgument4[0];
            _this.removeClasses(node, "appear");
            _this.removeClasses(node, "enter");
            _this.addClass(node, "exit", "base");
            if (_this.props.onExit) _this.props.onExit(maybeNode);
        };
        _this.onExiting = function(maybeNode) {
            var _this$resolveArgument5 = _this.resolveArguments(maybeNode), node = _this$resolveArgument5[0];
            _this.addClass(node, "exit", "active");
            if (_this.props.onExiting) _this.props.onExiting(maybeNode);
        };
        _this.onExited = function(maybeNode) {
            var _this$resolveArgument6 = _this.resolveArguments(maybeNode), node = _this$resolveArgument6[0];
            _this.removeClasses(node, "exit");
            _this.addClass(node, "exit", "done");
            if (_this.props.onExited) _this.props.onExited(maybeNode);
        };
        _this.resolveArguments = function(maybeNode, maybeAppearing) {
            return _this.props.nodeRef ? [
                _this.props.nodeRef.current,
                maybeNode
            ] // here `maybeNode` is actually `appearing`
             : [
                maybeNode,
                maybeAppearing
            ];
        };
        _this.getClassNames = function(type) {
            var classNames = _this.props.classNames;
            var isStringClassNames = typeof classNames === "string";
            var prefix = isStringClassNames && classNames ? classNames + "-" : "";
            var baseClassName = isStringClassNames ? "" + prefix + type : classNames[type];
            var activeClassName = isStringClassNames ? baseClassName + "-active" : classNames[type + "Active"];
            var doneClassName = isStringClassNames ? baseClassName + "-done" : classNames[type + "Done"];
            return {
                baseClassName: baseClassName,
                activeClassName: activeClassName,
                doneClassName: doneClassName
            };
        };
        return _this;
    }
    var _proto = CSSTransition.prototype;
    _proto.addClass = function addClass(node, type, phase) {
        var className = this.getClassNames(type)[phase + "ClassName"];
        var _this$getClassNames = this.getClassNames("enter"), doneClassName = _this$getClassNames.doneClassName;
        if (type === "appear" && phase === "done" && doneClassName) className += " " + doneClassName;
         // This is to force a repaint,
        // which is necessary in order to transition styles when adding a class name.
        if (phase === "active") {
            if (node) (0, $37faf39349e00e45$export$7d26bbb1236dafd6)(node);
        }
        if (className) {
            this.appliedClasses[type][phase] = className;
            $ee2e736fe07a2c40$var$_addClass(node, className);
        }
    };
    _proto.removeClasses = function removeClasses(node, type) {
        var _this$appliedClasses$ = this.appliedClasses[type], baseClassName = _this$appliedClasses$.base, activeClassName = _this$appliedClasses$.active, doneClassName = _this$appliedClasses$.done;
        this.appliedClasses[type] = {};
        if (baseClassName) $ee2e736fe07a2c40$var$removeClass(node, baseClassName);
        if (activeClassName) $ee2e736fe07a2c40$var$removeClass(node, activeClassName);
        if (doneClassName) $ee2e736fe07a2c40$var$removeClass(node, doneClassName);
    };
    _proto.render = function render() {
        var _this$props = this.props, _ = _this$props.classNames, props = (0, $133b6e059b2f6d5e$export$2e2bcd8739ae039)(_this$props, [
            "classNames"
        ]);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $0fef977f04119bf5$export$2e2bcd8739ae039), (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, props, {
            onEnter: this.onEnter,
            onEntered: this.onEntered,
            onEntering: this.onEntering,
            onExit: this.onExit,
            onExiting: this.onExiting,
            onExited: this.onExited
        }));
    };
    return CSSTransition;
}((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Component);
$ee2e736fe07a2c40$var$CSSTransition.defaultProps = {
    classNames: ""
};
$ee2e736fe07a2c40$var$CSSTransition.propTypes = {};
var $ee2e736fe07a2c40$export$2e2bcd8739ae039 = $ee2e736fe07a2c40$var$CSSTransition;




function $a43d996a7aa8a839$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $a43d996a7aa8a839$var$_objectSpread2(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $a43d996a7aa8a839$var$ownKeys(Object(source), !0).forEach(function(key) {
            $a43d996a7aa8a839$var$_defineProperty(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : $a43d996a7aa8a839$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $a43d996a7aa8a839$var$_typeof(obj) {
    "@babel/helpers - typeof";
    return $a43d996a7aa8a839$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj) {
        return typeof obj;
    } : function(obj) {
        return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    }, $a43d996a7aa8a839$var$_typeof(obj);
}
function $a43d996a7aa8a839$var$_wrapRegExp() {
    $a43d996a7aa8a839$var$_wrapRegExp = function(re, groups) {
        return new BabelRegExp(re, void 0, groups);
    };
    var _super = RegExp.prototype, _groups = new WeakMap();
    function BabelRegExp(re, flags, groups) {
        var _this = new RegExp(re, flags);
        return _groups.set(_this, groups || _groups.get(re)), $a43d996a7aa8a839$var$_setPrototypeOf(_this, BabelRegExp.prototype);
    }
    function buildGroups(result, re) {
        var g = _groups.get(re);
        return Object.keys(g).reduce(function(groups, name) {
            return groups[name] = result[g[name]], groups;
        }, Object.create(null));
    }
    return $a43d996a7aa8a839$var$_inherits(BabelRegExp, RegExp), BabelRegExp.prototype.exec = function(str) {
        var result = _super.exec.call(this, str);
        return result && (result.groups = buildGroups(result, this)), result;
    }, BabelRegExp.prototype[Symbol.replace] = function(str, substitution) {
        if ("string" == typeof substitution) {
            var groups = _groups.get(this);
            return _super[Symbol.replace].call(this, str, substitution.replace(/\$<([^>]+)>/g, function(_, name) {
                return "$" + groups[name];
            }));
        }
        if ("function" == typeof substitution) {
            var _this = this;
            return _super[Symbol.replace].call(this, str, function() {
                var args = arguments;
                return "object" != typeof args[args.length - 1] && (args = [].slice.call(args)).push(buildGroups(args, _this)), substitution.apply(this, args);
            });
        }
        return _super[Symbol.replace].call(this, str, substitution);
    }, $a43d996a7aa8a839$var$_wrapRegExp.apply(this, arguments);
}
function $a43d996a7aa8a839$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $a43d996a7aa8a839$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $a43d996a7aa8a839$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $a43d996a7aa8a839$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $a43d996a7aa8a839$var$_defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}
function $a43d996a7aa8a839$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $a43d996a7aa8a839$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    Object.defineProperty(subClass, "prototype", {
        writable: false
    });
    if (superClass) $a43d996a7aa8a839$var$_setPrototypeOf(subClass, superClass);
}
function $a43d996a7aa8a839$var$_setPrototypeOf(o, p) {
    $a43d996a7aa8a839$var$_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $a43d996a7aa8a839$var$_setPrototypeOf(o, p);
}
function $a43d996a7aa8a839$var$_slicedToArray(arr, i) {
    return $a43d996a7aa8a839$var$_arrayWithHoles(arr) || $a43d996a7aa8a839$var$_iterableToArrayLimit(arr, i) || $a43d996a7aa8a839$var$_unsupportedIterableToArray(arr, i) || $a43d996a7aa8a839$var$_nonIterableRest();
}
function $a43d996a7aa8a839$var$_toConsumableArray(arr) {
    return $a43d996a7aa8a839$var$_arrayWithoutHoles(arr) || $a43d996a7aa8a839$var$_iterableToArray(arr) || $a43d996a7aa8a839$var$_unsupportedIterableToArray(arr) || $a43d996a7aa8a839$var$_nonIterableSpread();
}
function $a43d996a7aa8a839$var$_arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return $a43d996a7aa8a839$var$_arrayLikeToArray(arr);
}
function $a43d996a7aa8a839$var$_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function $a43d996a7aa8a839$var$_iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function $a43d996a7aa8a839$var$_iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function $a43d996a7aa8a839$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $a43d996a7aa8a839$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $a43d996a7aa8a839$var$_arrayLikeToArray(o, minLen);
}
function $a43d996a7aa8a839$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $a43d996a7aa8a839$var$_nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $a43d996a7aa8a839$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
var $a43d996a7aa8a839$var$noop = function noop() {};
var $a43d996a7aa8a839$var$_WINDOW = {};
var $a43d996a7aa8a839$var$_DOCUMENT = {};
var $a43d996a7aa8a839$var$_MUTATION_OBSERVER = null;
var $a43d996a7aa8a839$var$_PERFORMANCE = {
    mark: $a43d996a7aa8a839$var$noop,
    measure: $a43d996a7aa8a839$var$noop
};
try {
    if (typeof window !== "undefined") $a43d996a7aa8a839$var$_WINDOW = window;
    if (typeof document !== "undefined") $a43d996a7aa8a839$var$_DOCUMENT = document;
    if (typeof MutationObserver !== "undefined") $a43d996a7aa8a839$var$_MUTATION_OBSERVER = MutationObserver;
    if (typeof performance !== "undefined") $a43d996a7aa8a839$var$_PERFORMANCE = performance;
} catch (e) {}
var $a43d996a7aa8a839$var$_ref = $a43d996a7aa8a839$var$_WINDOW.navigator || {}, $a43d996a7aa8a839$var$_ref$userAgent = $a43d996a7aa8a839$var$_ref.userAgent, $a43d996a7aa8a839$var$userAgent = $a43d996a7aa8a839$var$_ref$userAgent === void 0 ? "" : $a43d996a7aa8a839$var$_ref$userAgent;
var $a43d996a7aa8a839$var$WINDOW = $a43d996a7aa8a839$var$_WINDOW;
var $a43d996a7aa8a839$var$DOCUMENT = $a43d996a7aa8a839$var$_DOCUMENT;
var $a43d996a7aa8a839$var$MUTATION_OBSERVER = $a43d996a7aa8a839$var$_MUTATION_OBSERVER;
var $a43d996a7aa8a839$var$PERFORMANCE = $a43d996a7aa8a839$var$_PERFORMANCE;
var $a43d996a7aa8a839$var$IS_BROWSER = !!$a43d996a7aa8a839$var$WINDOW.document;
var $a43d996a7aa8a839$var$IS_DOM = !!$a43d996a7aa8a839$var$DOCUMENT.documentElement && !!$a43d996a7aa8a839$var$DOCUMENT.head && typeof $a43d996a7aa8a839$var$DOCUMENT.addEventListener === "function" && typeof $a43d996a7aa8a839$var$DOCUMENT.createElement === "function";
var $a43d996a7aa8a839$var$IS_IE = ~$a43d996a7aa8a839$var$userAgent.indexOf("MSIE") || ~$a43d996a7aa8a839$var$userAgent.indexOf("Trident/");
var $a43d996a7aa8a839$var$_familyProxy, $a43d996a7aa8a839$var$_familyProxy2, $a43d996a7aa8a839$var$_familyProxy3, $a43d996a7aa8a839$var$_familyProxy4, $a43d996a7aa8a839$var$_familyProxy5;
var $a43d996a7aa8a839$var$NAMESPACE_IDENTIFIER = "___FONT_AWESOME___";
var $a43d996a7aa8a839$var$UNITS_IN_GRID = 16;
var $a43d996a7aa8a839$var$DEFAULT_CSS_PREFIX = "fa";
var $a43d996a7aa8a839$var$DEFAULT_REPLACEMENT_CLASS = "svg-inline--fa";
var $a43d996a7aa8a839$var$DATA_FA_I2SVG = "data-fa-i2svg";
var $a43d996a7aa8a839$var$DATA_FA_PSEUDO_ELEMENT = "data-fa-pseudo-element";
var $a43d996a7aa8a839$var$DATA_FA_PSEUDO_ELEMENT_PENDING = "data-fa-pseudo-element-pending";
var $a43d996a7aa8a839$var$DATA_PREFIX = "data-prefix";
var $a43d996a7aa8a839$var$DATA_ICON = "data-icon";
var $a43d996a7aa8a839$var$HTML_CLASS_I2SVG_BASE_CLASS = "fontawesome-i2svg";
var $a43d996a7aa8a839$var$MUTATION_APPROACH_ASYNC = "async";
var $a43d996a7aa8a839$var$TAGNAMES_TO_SKIP_FOR_PSEUDOELEMENTS = [
    "HTML",
    "HEAD",
    "STYLE",
    "SCRIPT"
];
var $a43d996a7aa8a839$var$PRODUCTION = function() {
    try {
        return true;
    } catch (e) {
        return false;
    }
}();
var $a43d996a7aa8a839$var$FAMILY_CLASSIC = "classic";
var $a43d996a7aa8a839$var$FAMILY_SHARP = "sharp";
var $a43d996a7aa8a839$var$FAMILIES = [
    $a43d996a7aa8a839$var$FAMILY_CLASSIC,
    $a43d996a7aa8a839$var$FAMILY_SHARP
];
function $a43d996a7aa8a839$var$familyProxy(obj) {
    // Defaults to the classic family if family is not available
    return new Proxy(obj, {
        get: function get(target, prop) {
            return prop in target ? target[prop] : target[$a43d996a7aa8a839$var$FAMILY_CLASSIC];
        }
    });
}
var $a43d996a7aa8a839$var$PREFIX_TO_STYLE = $a43d996a7aa8a839$var$familyProxy(($a43d996a7aa8a839$var$_familyProxy = {}, $a43d996a7aa8a839$var$_defineProperty($a43d996a7aa8a839$var$_familyProxy, $a43d996a7aa8a839$var$FAMILY_CLASSIC, {
    "fa": "solid",
    "fas": "solid",
    "fa-solid": "solid",
    "far": "regular",
    "fa-regular": "regular",
    "fal": "light",
    "fa-light": "light",
    "fat": "thin",
    "fa-thin": "thin",
    "fad": "duotone",
    "fa-duotone": "duotone",
    "fab": "brands",
    "fa-brands": "brands",
    "fak": "kit",
    "fa-kit": "kit"
}), $a43d996a7aa8a839$var$_defineProperty($a43d996a7aa8a839$var$_familyProxy, $a43d996a7aa8a839$var$FAMILY_SHARP, {
    "fa": "solid",
    "fass": "solid",
    "fa-solid": "solid",
    "fasr": "regular",
    "fa-regular": "regular",
    "fasl": "light",
    "fa-light": "light"
}), $a43d996a7aa8a839$var$_familyProxy));
var $a43d996a7aa8a839$var$STYLE_TO_PREFIX = $a43d996a7aa8a839$var$familyProxy(($a43d996a7aa8a839$var$_familyProxy2 = {}, $a43d996a7aa8a839$var$_defineProperty($a43d996a7aa8a839$var$_familyProxy2, $a43d996a7aa8a839$var$FAMILY_CLASSIC, {
    "solid": "fas",
    "regular": "far",
    "light": "fal",
    "thin": "fat",
    "duotone": "fad",
    "brands": "fab",
    "kit": "fak"
}), $a43d996a7aa8a839$var$_defineProperty($a43d996a7aa8a839$var$_familyProxy2, $a43d996a7aa8a839$var$FAMILY_SHARP, {
    "solid": "fass",
    "regular": "fasr",
    "light": "fasl"
}), $a43d996a7aa8a839$var$_familyProxy2));
var $a43d996a7aa8a839$var$PREFIX_TO_LONG_STYLE = $a43d996a7aa8a839$var$familyProxy(($a43d996a7aa8a839$var$_familyProxy3 = {}, $a43d996a7aa8a839$var$_defineProperty($a43d996a7aa8a839$var$_familyProxy3, $a43d996a7aa8a839$var$FAMILY_CLASSIC, {
    "fab": "fa-brands",
    "fad": "fa-duotone",
    "fak": "fa-kit",
    "fal": "fa-light",
    "far": "fa-regular",
    "fas": "fa-solid",
    "fat": "fa-thin"
}), $a43d996a7aa8a839$var$_defineProperty($a43d996a7aa8a839$var$_familyProxy3, $a43d996a7aa8a839$var$FAMILY_SHARP, {
    "fass": "fa-solid",
    "fasr": "fa-regular",
    "fasl": "fa-light"
}), $a43d996a7aa8a839$var$_familyProxy3));
var $a43d996a7aa8a839$var$LONG_STYLE_TO_PREFIX = $a43d996a7aa8a839$var$familyProxy(($a43d996a7aa8a839$var$_familyProxy4 = {}, $a43d996a7aa8a839$var$_defineProperty($a43d996a7aa8a839$var$_familyProxy4, $a43d996a7aa8a839$var$FAMILY_CLASSIC, {
    "fa-brands": "fab",
    "fa-duotone": "fad",
    "fa-kit": "fak",
    "fa-light": "fal",
    "fa-regular": "far",
    "fa-solid": "fas",
    "fa-thin": "fat"
}), $a43d996a7aa8a839$var$_defineProperty($a43d996a7aa8a839$var$_familyProxy4, $a43d996a7aa8a839$var$FAMILY_SHARP, {
    "fa-solid": "fass",
    "fa-regular": "fasr",
    "fa-light": "fasl"
}), $a43d996a7aa8a839$var$_familyProxy4));
var $a43d996a7aa8a839$var$ICON_SELECTION_SYNTAX_PATTERN = /fa(s|r|l|t|d|b|k|ss|sr|sl)?[\-\ ]/; // eslint-disable-line no-useless-escape
var $a43d996a7aa8a839$var$LAYERS_TEXT_CLASSNAME = "fa-layers-text";
var $a43d996a7aa8a839$var$FONT_FAMILY_PATTERN = /Font ?Awesome ?([56 ]*)(Solid|Regular|Light|Thin|Duotone|Brands|Free|Pro|Sharp|Kit)?.*/i;
var $a43d996a7aa8a839$var$FONT_WEIGHT_TO_PREFIX = $a43d996a7aa8a839$var$familyProxy(($a43d996a7aa8a839$var$_familyProxy5 = {}, $a43d996a7aa8a839$var$_defineProperty($a43d996a7aa8a839$var$_familyProxy5, $a43d996a7aa8a839$var$FAMILY_CLASSIC, {
    "900": "fas",
    "400": "far",
    "normal": "far",
    "300": "fal",
    "100": "fat"
}), $a43d996a7aa8a839$var$_defineProperty($a43d996a7aa8a839$var$_familyProxy5, $a43d996a7aa8a839$var$FAMILY_SHARP, {
    "900": "fass",
    "400": "fasr",
    "300": "fasl"
}), $a43d996a7aa8a839$var$_familyProxy5));
var $a43d996a7aa8a839$var$oneToTen = [
    1,
    2,
    3,
    4,
    5,
    6,
    7,
    8,
    9,
    10
];
var $a43d996a7aa8a839$var$oneToTwenty = $a43d996a7aa8a839$var$oneToTen.concat([
    11,
    12,
    13,
    14,
    15,
    16,
    17,
    18,
    19,
    20
]);
var $a43d996a7aa8a839$var$ATTRIBUTES_WATCHED_FOR_MUTATION = [
    "class",
    "data-prefix",
    "data-icon",
    "data-fa-transform",
    "data-fa-mask"
];
var $a43d996a7aa8a839$var$DUOTONE_CLASSES = {
    GROUP: "duotone-group",
    SWAP_OPACITY: "swap-opacity",
    PRIMARY: "primary",
    SECONDARY: "secondary"
};
var $a43d996a7aa8a839$var$prefixes = new Set();
Object.keys($a43d996a7aa8a839$var$STYLE_TO_PREFIX[$a43d996a7aa8a839$var$FAMILY_CLASSIC]).map($a43d996a7aa8a839$var$prefixes.add.bind($a43d996a7aa8a839$var$prefixes));
Object.keys($a43d996a7aa8a839$var$STYLE_TO_PREFIX[$a43d996a7aa8a839$var$FAMILY_SHARP]).map($a43d996a7aa8a839$var$prefixes.add.bind($a43d996a7aa8a839$var$prefixes));
var $a43d996a7aa8a839$var$RESERVED_CLASSES = [].concat($a43d996a7aa8a839$var$FAMILIES, $a43d996a7aa8a839$var$_toConsumableArray($a43d996a7aa8a839$var$prefixes), [
    "2xs",
    "xs",
    "sm",
    "lg",
    "xl",
    "2xl",
    "beat",
    "border",
    "fade",
    "beat-fade",
    "bounce",
    "flip-both",
    "flip-horizontal",
    "flip-vertical",
    "flip",
    "fw",
    "inverse",
    "layers-counter",
    "layers-text",
    "layers",
    "li",
    "pull-left",
    "pull-right",
    "pulse",
    "rotate-180",
    "rotate-270",
    "rotate-90",
    "rotate-by",
    "shake",
    "spin-pulse",
    "spin-reverse",
    "spin",
    "stack-1x",
    "stack-2x",
    "stack",
    "ul",
    $a43d996a7aa8a839$var$DUOTONE_CLASSES.GROUP,
    $a43d996a7aa8a839$var$DUOTONE_CLASSES.SWAP_OPACITY,
    $a43d996a7aa8a839$var$DUOTONE_CLASSES.PRIMARY,
    $a43d996a7aa8a839$var$DUOTONE_CLASSES.SECONDARY
]).concat($a43d996a7aa8a839$var$oneToTen.map(function(n) {
    return "".concat(n, "x");
})).concat($a43d996a7aa8a839$var$oneToTwenty.map(function(n) {
    return "w-".concat(n);
}));
var $a43d996a7aa8a839$var$initial = $a43d996a7aa8a839$var$WINDOW.FontAwesomeConfig || {};
function $a43d996a7aa8a839$var$getAttrConfig(attr) {
    var element = $a43d996a7aa8a839$var$DOCUMENT.querySelector("script[" + attr + "]");
    if (element) return element.getAttribute(attr);
}
function $a43d996a7aa8a839$var$coerce(val) {
    // Getting an empty string will occur if the attribute is set on the HTML tag but without a value
    // We'll assume that this is an indication that it should be toggled to true
    if (val === "") return true;
    if (val === "false") return false;
    if (val === "true") return true;
    return val;
}
if ($a43d996a7aa8a839$var$DOCUMENT && typeof $a43d996a7aa8a839$var$DOCUMENT.querySelector === "function") {
    var $a43d996a7aa8a839$var$attrs = [
        [
            "data-family-prefix",
            "familyPrefix"
        ],
        [
            "data-css-prefix",
            "cssPrefix"
        ],
        [
            "data-family-default",
            "familyDefault"
        ],
        [
            "data-style-default",
            "styleDefault"
        ],
        [
            "data-replacement-class",
            "replacementClass"
        ],
        [
            "data-auto-replace-svg",
            "autoReplaceSvg"
        ],
        [
            "data-auto-add-css",
            "autoAddCss"
        ],
        [
            "data-auto-a11y",
            "autoA11y"
        ],
        [
            "data-search-pseudo-elements",
            "searchPseudoElements"
        ],
        [
            "data-observe-mutations",
            "observeMutations"
        ],
        [
            "data-mutate-approach",
            "mutateApproach"
        ],
        [
            "data-keep-original-source",
            "keepOriginalSource"
        ],
        [
            "data-measure-performance",
            "measurePerformance"
        ],
        [
            "data-show-missing-icons",
            "showMissingIcons"
        ]
    ];
    $a43d996a7aa8a839$var$attrs.forEach(function(_ref) {
        var _ref2 = $a43d996a7aa8a839$var$_slicedToArray(_ref, 2), attr = _ref2[0], key = _ref2[1];
        var val = $a43d996a7aa8a839$var$coerce($a43d996a7aa8a839$var$getAttrConfig(attr));
        if (val !== undefined && val !== null) $a43d996a7aa8a839$var$initial[key] = val;
    });
}
var $a43d996a7aa8a839$var$_default = {
    styleDefault: "solid",
    familyDefault: "classic",
    cssPrefix: $a43d996a7aa8a839$var$DEFAULT_CSS_PREFIX,
    replacementClass: $a43d996a7aa8a839$var$DEFAULT_REPLACEMENT_CLASS,
    autoReplaceSvg: true,
    autoAddCss: true,
    autoA11y: true,
    searchPseudoElements: false,
    observeMutations: true,
    mutateApproach: "async",
    keepOriginalSource: true,
    measurePerformance: false,
    showMissingIcons: true
}; // familyPrefix is deprecated but we must still support it if present
if ($a43d996a7aa8a839$var$initial.familyPrefix) $a43d996a7aa8a839$var$initial.cssPrefix = $a43d996a7aa8a839$var$initial.familyPrefix;
var $a43d996a7aa8a839$var$_config = $a43d996a7aa8a839$var$_objectSpread2($a43d996a7aa8a839$var$_objectSpread2({}, $a43d996a7aa8a839$var$_default), $a43d996a7aa8a839$var$initial);
if (!$a43d996a7aa8a839$var$_config.autoReplaceSvg) $a43d996a7aa8a839$var$_config.observeMutations = false;
var $a43d996a7aa8a839$var$config = {};
Object.keys($a43d996a7aa8a839$var$_default).forEach(function(key) {
    Object.defineProperty($a43d996a7aa8a839$var$config, key, {
        enumerable: true,
        set: function set(val) {
            $a43d996a7aa8a839$var$_config[key] = val;
            $a43d996a7aa8a839$var$_onChangeCb.forEach(function(cb) {
                return cb($a43d996a7aa8a839$var$config);
            });
        },
        get: function get() {
            return $a43d996a7aa8a839$var$_config[key];
        }
    });
}); // familyPrefix is deprecated as of 6.2.0 and should be removed in 7.0.0
Object.defineProperty($a43d996a7aa8a839$var$config, "familyPrefix", {
    enumerable: true,
    set: function set(val) {
        $a43d996a7aa8a839$var$_config.cssPrefix = val;
        $a43d996a7aa8a839$var$_onChangeCb.forEach(function(cb) {
            return cb($a43d996a7aa8a839$var$config);
        });
    },
    get: function get() {
        return $a43d996a7aa8a839$var$_config.cssPrefix;
    }
});
$a43d996a7aa8a839$var$WINDOW.FontAwesomeConfig = $a43d996a7aa8a839$var$config;
var $a43d996a7aa8a839$var$_onChangeCb = [];
function $a43d996a7aa8a839$var$onChange(cb) {
    $a43d996a7aa8a839$var$_onChangeCb.push(cb);
    return function() {
        $a43d996a7aa8a839$var$_onChangeCb.splice($a43d996a7aa8a839$var$_onChangeCb.indexOf(cb), 1);
    };
}
var $a43d996a7aa8a839$var$d = $a43d996a7aa8a839$var$UNITS_IN_GRID;
var $a43d996a7aa8a839$var$meaninglessTransform = {
    size: 16,
    x: 0,
    y: 0,
    rotate: 0,
    flipX: false,
    flipY: false
};
function $a43d996a7aa8a839$var$insertCss(css) {
    if (!css || !$a43d996a7aa8a839$var$IS_DOM) return;
    var style = $a43d996a7aa8a839$var$DOCUMENT.createElement("style");
    style.setAttribute("type", "text/css");
    style.innerHTML = css;
    var headChildren = $a43d996a7aa8a839$var$DOCUMENT.head.childNodes;
    var beforeChild = null;
    for(var i = headChildren.length - 1; i > -1; i--){
        var child = headChildren[i];
        var tagName = (child.tagName || "").toUpperCase();
        if ([
            "STYLE",
            "LINK"
        ].indexOf(tagName) > -1) beforeChild = child;
    }
    $a43d996a7aa8a839$var$DOCUMENT.head.insertBefore(style, beforeChild);
    return css;
}
var $a43d996a7aa8a839$var$idPool = "0123456789abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ";
function $a43d996a7aa8a839$var$nextUniqueId() {
    var size = 12;
    var id = "";
    while(size-- > 0)id += $a43d996a7aa8a839$var$idPool[Math.random() * 62 | 0];
    return id;
}
function $a43d996a7aa8a839$var$toArray(obj) {
    var array = [];
    for(var i = (obj || []).length >>> 0; i--;)array[i] = obj[i];
    return array;
}
function $a43d996a7aa8a839$var$classArray(node) {
    if (node.classList) return $a43d996a7aa8a839$var$toArray(node.classList);
    else return (node.getAttribute("class") || "").split(" ").filter(function(i) {
        return i;
    });
}
function $a43d996a7aa8a839$var$htmlEscape(str) {
    return "".concat(str).replace(/&/g, "&amp;").replace(/"/g, "&quot;").replace(/'/g, "&#39;").replace(/</g, "&lt;").replace(/>/g, "&gt;");
}
function $a43d996a7aa8a839$var$joinAttributes(attributes) {
    return Object.keys(attributes || {}).reduce(function(acc, attributeName) {
        return acc + "".concat(attributeName, '="').concat($a43d996a7aa8a839$var$htmlEscape(attributes[attributeName]), '" ');
    }, "").trim();
}
function $a43d996a7aa8a839$var$joinStyles(styles) {
    return Object.keys(styles || {}).reduce(function(acc, styleName) {
        return acc + "".concat(styleName, ": ").concat(styles[styleName].trim(), ";");
    }, "");
}
function $a43d996a7aa8a839$var$transformIsMeaningful(transform) {
    return transform.size !== $a43d996a7aa8a839$var$meaninglessTransform.size || transform.x !== $a43d996a7aa8a839$var$meaninglessTransform.x || transform.y !== $a43d996a7aa8a839$var$meaninglessTransform.y || transform.rotate !== $a43d996a7aa8a839$var$meaninglessTransform.rotate || transform.flipX || transform.flipY;
}
function $a43d996a7aa8a839$var$transformForSvg(_ref) {
    var transform = _ref.transform, containerWidth = _ref.containerWidth, iconWidth = _ref.iconWidth;
    var outer = {
        transform: "translate(".concat(containerWidth / 2, " 256)")
    };
    var innerTranslate = "translate(".concat(transform.x * 32, ", ").concat(transform.y * 32, ") ");
    var innerScale = "scale(".concat(transform.size / 16 * (transform.flipX ? -1 : 1), ", ").concat(transform.size / 16 * (transform.flipY ? -1 : 1), ") ");
    var innerRotate = "rotate(".concat(transform.rotate, " 0 0)");
    var inner = {
        transform: "".concat(innerTranslate, " ").concat(innerScale, " ").concat(innerRotate)
    };
    var path = {
        transform: "translate(".concat(iconWidth / 2 * -1, " -256)")
    };
    return {
        outer: outer,
        inner: inner,
        path: path
    };
}
function $a43d996a7aa8a839$var$transformForCss(_ref2) {
    var transform = _ref2.transform, _ref2$width = _ref2.width, width = _ref2$width === void 0 ? $a43d996a7aa8a839$var$UNITS_IN_GRID : _ref2$width, _ref2$height = _ref2.height, height = _ref2$height === void 0 ? $a43d996a7aa8a839$var$UNITS_IN_GRID : _ref2$height, _ref2$startCentered = _ref2.startCentered, startCentered = _ref2$startCentered === void 0 ? false : _ref2$startCentered;
    var val = "";
    if (startCentered && $a43d996a7aa8a839$var$IS_IE) val += "translate(".concat(transform.x / $a43d996a7aa8a839$var$d - width / 2, "em, ").concat(transform.y / $a43d996a7aa8a839$var$d - height / 2, "em) ");
    else if (startCentered) val += "translate(calc(-50% + ".concat(transform.x / $a43d996a7aa8a839$var$d, "em), calc(-50% + ").concat(transform.y / $a43d996a7aa8a839$var$d, "em)) ");
    else val += "translate(".concat(transform.x / $a43d996a7aa8a839$var$d, "em, ").concat(transform.y / $a43d996a7aa8a839$var$d, "em) ");
    val += "scale(".concat(transform.size / $a43d996a7aa8a839$var$d * (transform.flipX ? -1 : 1), ", ").concat(transform.size / $a43d996a7aa8a839$var$d * (transform.flipY ? -1 : 1), ") ");
    val += "rotate(".concat(transform.rotate, "deg) ");
    return val;
}
var $a43d996a7aa8a839$var$baseStyles = ':root, :host {\n  --fa-font-solid: normal 900 1em/1 "Font Awesome 6 Solid";\n  --fa-font-regular: normal 400 1em/1 "Font Awesome 6 Regular";\n  --fa-font-light: normal 300 1em/1 "Font Awesome 6 Light";\n  --fa-font-thin: normal 100 1em/1 "Font Awesome 6 Thin";\n  --fa-font-duotone: normal 900 1em/1 "Font Awesome 6 Duotone";\n  --fa-font-sharp-solid: normal 900 1em/1 "Font Awesome 6 Sharp";\n  --fa-font-sharp-regular: normal 400 1em/1 "Font Awesome 6 Sharp";\n  --fa-font-sharp-light: normal 300 1em/1 "Font Awesome 6 Sharp";\n  --fa-font-brands: normal 400 1em/1 "Font Awesome 6 Brands";\n}\n\nsvg:not(:root).svg-inline--fa, svg:not(:host).svg-inline--fa {\n  overflow: visible;\n  box-sizing: content-box;\n}\n\n.svg-inline--fa {\n  display: var(--fa-display, inline-block);\n  height: 1em;\n  overflow: visible;\n  vertical-align: -0.125em;\n}\n.svg-inline--fa.fa-2xs {\n  vertical-align: 0.1em;\n}\n.svg-inline--fa.fa-xs {\n  vertical-align: 0em;\n}\n.svg-inline--fa.fa-sm {\n  vertical-align: -0.0714285705em;\n}\n.svg-inline--fa.fa-lg {\n  vertical-align: -0.2em;\n}\n.svg-inline--fa.fa-xl {\n  vertical-align: -0.25em;\n}\n.svg-inline--fa.fa-2xl {\n  vertical-align: -0.3125em;\n}\n.svg-inline--fa.fa-pull-left {\n  margin-right: var(--fa-pull-margin, 0.3em);\n  width: auto;\n}\n.svg-inline--fa.fa-pull-right {\n  margin-left: var(--fa-pull-margin, 0.3em);\n  width: auto;\n}\n.svg-inline--fa.fa-li {\n  width: var(--fa-li-width, 2em);\n  top: 0.25em;\n}\n.svg-inline--fa.fa-fw {\n  width: var(--fa-fw-width, 1.25em);\n}\n\n.fa-layers svg.svg-inline--fa {\n  bottom: 0;\n  left: 0;\n  margin: auto;\n  position: absolute;\n  right: 0;\n  top: 0;\n}\n\n.fa-layers-counter, .fa-layers-text {\n  display: inline-block;\n  position: absolute;\n  text-align: center;\n}\n\n.fa-layers {\n  display: inline-block;\n  height: 1em;\n  position: relative;\n  text-align: center;\n  vertical-align: -0.125em;\n  width: 1em;\n}\n.fa-layers svg.svg-inline--fa {\n  -webkit-transform-origin: center center;\n          transform-origin: center center;\n}\n\n.fa-layers-text {\n  left: 50%;\n  top: 50%;\n  -webkit-transform: translate(-50%, -50%);\n          transform: translate(-50%, -50%);\n  -webkit-transform-origin: center center;\n          transform-origin: center center;\n}\n\n.fa-layers-counter {\n  background-color: var(--fa-counter-background-color, #ff253a);\n  border-radius: var(--fa-counter-border-radius, 1em);\n  box-sizing: border-box;\n  color: var(--fa-inverse, #fff);\n  line-height: var(--fa-counter-line-height, 1);\n  max-width: var(--fa-counter-max-width, 5em);\n  min-width: var(--fa-counter-min-width, 1.5em);\n  overflow: hidden;\n  padding: var(--fa-counter-padding, 0.25em 0.5em);\n  right: var(--fa-right, 0);\n  text-overflow: ellipsis;\n  top: var(--fa-top, 0);\n  -webkit-transform: scale(var(--fa-counter-scale, 0.25));\n          transform: scale(var(--fa-counter-scale, 0.25));\n  -webkit-transform-origin: top right;\n          transform-origin: top right;\n}\n\n.fa-layers-bottom-right {\n  bottom: var(--fa-bottom, 0);\n  right: var(--fa-right, 0);\n  top: auto;\n  -webkit-transform: scale(var(--fa-layers-scale, 0.25));\n          transform: scale(var(--fa-layers-scale, 0.25));\n  -webkit-transform-origin: bottom right;\n          transform-origin: bottom right;\n}\n\n.fa-layers-bottom-left {\n  bottom: var(--fa-bottom, 0);\n  left: var(--fa-left, 0);\n  right: auto;\n  top: auto;\n  -webkit-transform: scale(var(--fa-layers-scale, 0.25));\n          transform: scale(var(--fa-layers-scale, 0.25));\n  -webkit-transform-origin: bottom left;\n          transform-origin: bottom left;\n}\n\n.fa-layers-top-right {\n  top: var(--fa-top, 0);\n  right: var(--fa-right, 0);\n  -webkit-transform: scale(var(--fa-layers-scale, 0.25));\n          transform: scale(var(--fa-layers-scale, 0.25));\n  -webkit-transform-origin: top right;\n          transform-origin: top right;\n}\n\n.fa-layers-top-left {\n  left: var(--fa-left, 0);\n  right: auto;\n  top: var(--fa-top, 0);\n  -webkit-transform: scale(var(--fa-layers-scale, 0.25));\n          transform: scale(var(--fa-layers-scale, 0.25));\n  -webkit-transform-origin: top left;\n          transform-origin: top left;\n}\n\n.fa-1x {\n  font-size: 1em;\n}\n\n.fa-2x {\n  font-size: 2em;\n}\n\n.fa-3x {\n  font-size: 3em;\n}\n\n.fa-4x {\n  font-size: 4em;\n}\n\n.fa-5x {\n  font-size: 5em;\n}\n\n.fa-6x {\n  font-size: 6em;\n}\n\n.fa-7x {\n  font-size: 7em;\n}\n\n.fa-8x {\n  font-size: 8em;\n}\n\n.fa-9x {\n  font-size: 9em;\n}\n\n.fa-10x {\n  font-size: 10em;\n}\n\n.fa-2xs {\n  font-size: 0.625em;\n  line-height: 0.1em;\n  vertical-align: 0.225em;\n}\n\n.fa-xs {\n  font-size: 0.75em;\n  line-height: 0.0833333337em;\n  vertical-align: 0.125em;\n}\n\n.fa-sm {\n  font-size: 0.875em;\n  line-height: 0.0714285718em;\n  vertical-align: 0.0535714295em;\n}\n\n.fa-lg {\n  font-size: 1.25em;\n  line-height: 0.05em;\n  vertical-align: -0.075em;\n}\n\n.fa-xl {\n  font-size: 1.5em;\n  line-height: 0.0416666682em;\n  vertical-align: -0.125em;\n}\n\n.fa-2xl {\n  font-size: 2em;\n  line-height: 0.03125em;\n  vertical-align: -0.1875em;\n}\n\n.fa-fw {\n  text-align: center;\n  width: 1.25em;\n}\n\n.fa-ul {\n  list-style-type: none;\n  margin-left: var(--fa-li-margin, 2.5em);\n  padding-left: 0;\n}\n.fa-ul > li {\n  position: relative;\n}\n\n.fa-li {\n  left: calc(var(--fa-li-width, 2em) * -1);\n  position: absolute;\n  text-align: center;\n  width: var(--fa-li-width, 2em);\n  line-height: inherit;\n}\n\n.fa-border {\n  border-color: var(--fa-border-color, #eee);\n  border-radius: var(--fa-border-radius, 0.1em);\n  border-style: var(--fa-border-style, solid);\n  border-width: var(--fa-border-width, 0.08em);\n  padding: var(--fa-border-padding, 0.2em 0.25em 0.15em);\n}\n\n.fa-pull-left {\n  float: left;\n  margin-right: var(--fa-pull-margin, 0.3em);\n}\n\n.fa-pull-right {\n  float: right;\n  margin-left: var(--fa-pull-margin, 0.3em);\n}\n\n.fa-beat {\n  -webkit-animation-name: fa-beat;\n          animation-name: fa-beat;\n  -webkit-animation-delay: var(--fa-animation-delay, 0s);\n          animation-delay: var(--fa-animation-delay, 0s);\n  -webkit-animation-direction: var(--fa-animation-direction, normal);\n          animation-direction: var(--fa-animation-direction, normal);\n  -webkit-animation-duration: var(--fa-animation-duration, 1s);\n          animation-duration: var(--fa-animation-duration, 1s);\n  -webkit-animation-iteration-count: var(--fa-animation-iteration-count, infinite);\n          animation-iteration-count: var(--fa-animation-iteration-count, infinite);\n  -webkit-animation-timing-function: var(--fa-animation-timing, ease-in-out);\n          animation-timing-function: var(--fa-animation-timing, ease-in-out);\n}\n\n.fa-bounce {\n  -webkit-animation-name: fa-bounce;\n          animation-name: fa-bounce;\n  -webkit-animation-delay: var(--fa-animation-delay, 0s);\n          animation-delay: var(--fa-animation-delay, 0s);\n  -webkit-animation-direction: var(--fa-animation-direction, normal);\n          animation-direction: var(--fa-animation-direction, normal);\n  -webkit-animation-duration: var(--fa-animation-duration, 1s);\n          animation-duration: var(--fa-animation-duration, 1s);\n  -webkit-animation-iteration-count: var(--fa-animation-iteration-count, infinite);\n          animation-iteration-count: var(--fa-animation-iteration-count, infinite);\n  -webkit-animation-timing-function: var(--fa-animation-timing, cubic-bezier(0.28, 0.84, 0.42, 1));\n          animation-timing-function: var(--fa-animation-timing, cubic-bezier(0.28, 0.84, 0.42, 1));\n}\n\n.fa-fade {\n  -webkit-animation-name: fa-fade;\n          animation-name: fa-fade;\n  -webkit-animation-delay: var(--fa-animation-delay, 0s);\n          animation-delay: var(--fa-animation-delay, 0s);\n  -webkit-animation-direction: var(--fa-animation-direction, normal);\n          animation-direction: var(--fa-animation-direction, normal);\n  -webkit-animation-duration: var(--fa-animation-duration, 1s);\n          animation-duration: var(--fa-animation-duration, 1s);\n  -webkit-animation-iteration-count: var(--fa-animation-iteration-count, infinite);\n          animation-iteration-count: var(--fa-animation-iteration-count, infinite);\n  -webkit-animation-timing-function: var(--fa-animation-timing, cubic-bezier(0.4, 0, 0.6, 1));\n          animation-timing-function: var(--fa-animation-timing, cubic-bezier(0.4, 0, 0.6, 1));\n}\n\n.fa-beat-fade {\n  -webkit-animation-name: fa-beat-fade;\n          animation-name: fa-beat-fade;\n  -webkit-animation-delay: var(--fa-animation-delay, 0s);\n          animation-delay: var(--fa-animation-delay, 0s);\n  -webkit-animation-direction: var(--fa-animation-direction, normal);\n          animation-direction: var(--fa-animation-direction, normal);\n  -webkit-animation-duration: var(--fa-animation-duration, 1s);\n          animation-duration: var(--fa-animation-duration, 1s);\n  -webkit-animation-iteration-count: var(--fa-animation-iteration-count, infinite);\n          animation-iteration-count: var(--fa-animation-iteration-count, infinite);\n  -webkit-animation-timing-function: var(--fa-animation-timing, cubic-bezier(0.4, 0, 0.6, 1));\n          animation-timing-function: var(--fa-animation-timing, cubic-bezier(0.4, 0, 0.6, 1));\n}\n\n.fa-flip {\n  -webkit-animation-name: fa-flip;\n          animation-name: fa-flip;\n  -webkit-animation-delay: var(--fa-animation-delay, 0s);\n          animation-delay: var(--fa-animation-delay, 0s);\n  -webkit-animation-direction: var(--fa-animation-direction, normal);\n          animation-direction: var(--fa-animation-direction, normal);\n  -webkit-animation-duration: var(--fa-animation-duration, 1s);\n          animation-duration: var(--fa-animation-duration, 1s);\n  -webkit-animation-iteration-count: var(--fa-animation-iteration-count, infinite);\n          animation-iteration-count: var(--fa-animation-iteration-count, infinite);\n  -webkit-animation-timing-function: var(--fa-animation-timing, ease-in-out);\n          animation-timing-function: var(--fa-animation-timing, ease-in-out);\n}\n\n.fa-shake {\n  -webkit-animation-name: fa-shake;\n          animation-name: fa-shake;\n  -webkit-animation-delay: var(--fa-animation-delay, 0s);\n          animation-delay: var(--fa-animation-delay, 0s);\n  -webkit-animation-direction: var(--fa-animation-direction, normal);\n          animation-direction: var(--fa-animation-direction, normal);\n  -webkit-animation-duration: var(--fa-animation-duration, 1s);\n          animation-duration: var(--fa-animation-duration, 1s);\n  -webkit-animation-iteration-count: var(--fa-animation-iteration-count, infinite);\n          animation-iteration-count: var(--fa-animation-iteration-count, infinite);\n  -webkit-animation-timing-function: var(--fa-animation-timing, linear);\n          animation-timing-function: var(--fa-animation-timing, linear);\n}\n\n.fa-spin {\n  -webkit-animation-name: fa-spin;\n          animation-name: fa-spin;\n  -webkit-animation-delay: var(--fa-animation-delay, 0s);\n          animation-delay: var(--fa-animation-delay, 0s);\n  -webkit-animation-direction: var(--fa-animation-direction, normal);\n          animation-direction: var(--fa-animation-direction, normal);\n  -webkit-animation-duration: var(--fa-animation-duration, 2s);\n          animation-duration: var(--fa-animation-duration, 2s);\n  -webkit-animation-iteration-count: var(--fa-animation-iteration-count, infinite);\n          animation-iteration-count: var(--fa-animation-iteration-count, infinite);\n  -webkit-animation-timing-function: var(--fa-animation-timing, linear);\n          animation-timing-function: var(--fa-animation-timing, linear);\n}\n\n.fa-spin-reverse {\n  --fa-animation-direction: reverse;\n}\n\n.fa-pulse,\n.fa-spin-pulse {\n  -webkit-animation-name: fa-spin;\n          animation-name: fa-spin;\n  -webkit-animation-direction: var(--fa-animation-direction, normal);\n          animation-direction: var(--fa-animation-direction, normal);\n  -webkit-animation-duration: var(--fa-animation-duration, 1s);\n          animation-duration: var(--fa-animation-duration, 1s);\n  -webkit-animation-iteration-count: var(--fa-animation-iteration-count, infinite);\n          animation-iteration-count: var(--fa-animation-iteration-count, infinite);\n  -webkit-animation-timing-function: var(--fa-animation-timing, steps(8));\n          animation-timing-function: var(--fa-animation-timing, steps(8));\n}\n\n@media (prefers-reduced-motion: reduce) {\n  .fa-beat,\n.fa-bounce,\n.fa-fade,\n.fa-beat-fade,\n.fa-flip,\n.fa-pulse,\n.fa-shake,\n.fa-spin,\n.fa-spin-pulse {\n    -webkit-animation-delay: -1ms;\n            animation-delay: -1ms;\n    -webkit-animation-duration: 1ms;\n            animation-duration: 1ms;\n    -webkit-animation-iteration-count: 1;\n            animation-iteration-count: 1;\n    -webkit-transition-delay: 0s;\n            transition-delay: 0s;\n    -webkit-transition-duration: 0s;\n            transition-duration: 0s;\n  }\n}\n@-webkit-keyframes fa-beat {\n  0%, 90% {\n    -webkit-transform: scale(1);\n            transform: scale(1);\n  }\n  45% {\n    -webkit-transform: scale(var(--fa-beat-scale, 1.25));\n            transform: scale(var(--fa-beat-scale, 1.25));\n  }\n}\n@keyframes fa-beat {\n  0%, 90% {\n    -webkit-transform: scale(1);\n            transform: scale(1);\n  }\n  45% {\n    -webkit-transform: scale(var(--fa-beat-scale, 1.25));\n            transform: scale(var(--fa-beat-scale, 1.25));\n  }\n}\n@-webkit-keyframes fa-bounce {\n  0% {\n    -webkit-transform: scale(1, 1) translateY(0);\n            transform: scale(1, 1) translateY(0);\n  }\n  10% {\n    -webkit-transform: scale(var(--fa-bounce-start-scale-x, 1.1), var(--fa-bounce-start-scale-y, 0.9)) translateY(0);\n            transform: scale(var(--fa-bounce-start-scale-x, 1.1), var(--fa-bounce-start-scale-y, 0.9)) translateY(0);\n  }\n  30% {\n    -webkit-transform: scale(var(--fa-bounce-jump-scale-x, 0.9), var(--fa-bounce-jump-scale-y, 1.1)) translateY(var(--fa-bounce-height, -0.5em));\n            transform: scale(var(--fa-bounce-jump-scale-x, 0.9), var(--fa-bounce-jump-scale-y, 1.1)) translateY(var(--fa-bounce-height, -0.5em));\n  }\n  50% {\n    -webkit-transform: scale(var(--fa-bounce-land-scale-x, 1.05), var(--fa-bounce-land-scale-y, 0.95)) translateY(0);\n            transform: scale(var(--fa-bounce-land-scale-x, 1.05), var(--fa-bounce-land-scale-y, 0.95)) translateY(0);\n  }\n  57% {\n    -webkit-transform: scale(1, 1) translateY(var(--fa-bounce-rebound, -0.125em));\n            transform: scale(1, 1) translateY(var(--fa-bounce-rebound, -0.125em));\n  }\n  64% {\n    -webkit-transform: scale(1, 1) translateY(0);\n            transform: scale(1, 1) translateY(0);\n  }\n  100% {\n    -webkit-transform: scale(1, 1) translateY(0);\n            transform: scale(1, 1) translateY(0);\n  }\n}\n@keyframes fa-bounce {\n  0% {\n    -webkit-transform: scale(1, 1) translateY(0);\n            transform: scale(1, 1) translateY(0);\n  }\n  10% {\n    -webkit-transform: scale(var(--fa-bounce-start-scale-x, 1.1), var(--fa-bounce-start-scale-y, 0.9)) translateY(0);\n            transform: scale(var(--fa-bounce-start-scale-x, 1.1), var(--fa-bounce-start-scale-y, 0.9)) translateY(0);\n  }\n  30% {\n    -webkit-transform: scale(var(--fa-bounce-jump-scale-x, 0.9), var(--fa-bounce-jump-scale-y, 1.1)) translateY(var(--fa-bounce-height, -0.5em));\n            transform: scale(var(--fa-bounce-jump-scale-x, 0.9), var(--fa-bounce-jump-scale-y, 1.1)) translateY(var(--fa-bounce-height, -0.5em));\n  }\n  50% {\n    -webkit-transform: scale(var(--fa-bounce-land-scale-x, 1.05), var(--fa-bounce-land-scale-y, 0.95)) translateY(0);\n            transform: scale(var(--fa-bounce-land-scale-x, 1.05), var(--fa-bounce-land-scale-y, 0.95)) translateY(0);\n  }\n  57% {\n    -webkit-transform: scale(1, 1) translateY(var(--fa-bounce-rebound, -0.125em));\n            transform: scale(1, 1) translateY(var(--fa-bounce-rebound, -0.125em));\n  }\n  64% {\n    -webkit-transform: scale(1, 1) translateY(0);\n            transform: scale(1, 1) translateY(0);\n  }\n  100% {\n    -webkit-transform: scale(1, 1) translateY(0);\n            transform: scale(1, 1) translateY(0);\n  }\n}\n@-webkit-keyframes fa-fade {\n  50% {\n    opacity: var(--fa-fade-opacity, 0.4);\n  }\n}\n@keyframes fa-fade {\n  50% {\n    opacity: var(--fa-fade-opacity, 0.4);\n  }\n}\n@-webkit-keyframes fa-beat-fade {\n  0%, 100% {\n    opacity: var(--fa-beat-fade-opacity, 0.4);\n    -webkit-transform: scale(1);\n            transform: scale(1);\n  }\n  50% {\n    opacity: 1;\n    -webkit-transform: scale(var(--fa-beat-fade-scale, 1.125));\n            transform: scale(var(--fa-beat-fade-scale, 1.125));\n  }\n}\n@keyframes fa-beat-fade {\n  0%, 100% {\n    opacity: var(--fa-beat-fade-opacity, 0.4);\n    -webkit-transform: scale(1);\n            transform: scale(1);\n  }\n  50% {\n    opacity: 1;\n    -webkit-transform: scale(var(--fa-beat-fade-scale, 1.125));\n            transform: scale(var(--fa-beat-fade-scale, 1.125));\n  }\n}\n@-webkit-keyframes fa-flip {\n  50% {\n    -webkit-transform: rotate3d(var(--fa-flip-x, 0), var(--fa-flip-y, 1), var(--fa-flip-z, 0), var(--fa-flip-angle, -180deg));\n            transform: rotate3d(var(--fa-flip-x, 0), var(--fa-flip-y, 1), var(--fa-flip-z, 0), var(--fa-flip-angle, -180deg));\n  }\n}\n@keyframes fa-flip {\n  50% {\n    -webkit-transform: rotate3d(var(--fa-flip-x, 0), var(--fa-flip-y, 1), var(--fa-flip-z, 0), var(--fa-flip-angle, -180deg));\n            transform: rotate3d(var(--fa-flip-x, 0), var(--fa-flip-y, 1), var(--fa-flip-z, 0), var(--fa-flip-angle, -180deg));\n  }\n}\n@-webkit-keyframes fa-shake {\n  0% {\n    -webkit-transform: rotate(-15deg);\n            transform: rotate(-15deg);\n  }\n  4% {\n    -webkit-transform: rotate(15deg);\n            transform: rotate(15deg);\n  }\n  8%, 24% {\n    -webkit-transform: rotate(-18deg);\n            transform: rotate(-18deg);\n  }\n  12%, 28% {\n    -webkit-transform: rotate(18deg);\n            transform: rotate(18deg);\n  }\n  16% {\n    -webkit-transform: rotate(-22deg);\n            transform: rotate(-22deg);\n  }\n  20% {\n    -webkit-transform: rotate(22deg);\n            transform: rotate(22deg);\n  }\n  32% {\n    -webkit-transform: rotate(-12deg);\n            transform: rotate(-12deg);\n  }\n  36% {\n    -webkit-transform: rotate(12deg);\n            transform: rotate(12deg);\n  }\n  40%, 100% {\n    -webkit-transform: rotate(0deg);\n            transform: rotate(0deg);\n  }\n}\n@keyframes fa-shake {\n  0% {\n    -webkit-transform: rotate(-15deg);\n            transform: rotate(-15deg);\n  }\n  4% {\n    -webkit-transform: rotate(15deg);\n            transform: rotate(15deg);\n  }\n  8%, 24% {\n    -webkit-transform: rotate(-18deg);\n            transform: rotate(-18deg);\n  }\n  12%, 28% {\n    -webkit-transform: rotate(18deg);\n            transform: rotate(18deg);\n  }\n  16% {\n    -webkit-transform: rotate(-22deg);\n            transform: rotate(-22deg);\n  }\n  20% {\n    -webkit-transform: rotate(22deg);\n            transform: rotate(22deg);\n  }\n  32% {\n    -webkit-transform: rotate(-12deg);\n            transform: rotate(-12deg);\n  }\n  36% {\n    -webkit-transform: rotate(12deg);\n            transform: rotate(12deg);\n  }\n  40%, 100% {\n    -webkit-transform: rotate(0deg);\n            transform: rotate(0deg);\n  }\n}\n@-webkit-keyframes fa-spin {\n  0% {\n    -webkit-transform: rotate(0deg);\n            transform: rotate(0deg);\n  }\n  100% {\n    -webkit-transform: rotate(360deg);\n            transform: rotate(360deg);\n  }\n}\n@keyframes fa-spin {\n  0% {\n    -webkit-transform: rotate(0deg);\n            transform: rotate(0deg);\n  }\n  100% {\n    -webkit-transform: rotate(360deg);\n            transform: rotate(360deg);\n  }\n}\n.fa-rotate-90 {\n  -webkit-transform: rotate(90deg);\n          transform: rotate(90deg);\n}\n\n.fa-rotate-180 {\n  -webkit-transform: rotate(180deg);\n          transform: rotate(180deg);\n}\n\n.fa-rotate-270 {\n  -webkit-transform: rotate(270deg);\n          transform: rotate(270deg);\n}\n\n.fa-flip-horizontal {\n  -webkit-transform: scale(-1, 1);\n          transform: scale(-1, 1);\n}\n\n.fa-flip-vertical {\n  -webkit-transform: scale(1, -1);\n          transform: scale(1, -1);\n}\n\n.fa-flip-both,\n.fa-flip-horizontal.fa-flip-vertical {\n  -webkit-transform: scale(-1, -1);\n          transform: scale(-1, -1);\n}\n\n.fa-rotate-by {\n  -webkit-transform: rotate(var(--fa-rotate-angle, none));\n          transform: rotate(var(--fa-rotate-angle, none));\n}\n\n.fa-stack {\n  display: inline-block;\n  vertical-align: middle;\n  height: 2em;\n  position: relative;\n  width: 2.5em;\n}\n\n.fa-stack-1x,\n.fa-stack-2x {\n  bottom: 0;\n  left: 0;\n  margin: auto;\n  position: absolute;\n  right: 0;\n  top: 0;\n  z-index: var(--fa-stack-z-index, auto);\n}\n\n.svg-inline--fa.fa-stack-1x {\n  height: 1em;\n  width: 1.25em;\n}\n.svg-inline--fa.fa-stack-2x {\n  height: 2em;\n  width: 2.5em;\n}\n\n.fa-inverse {\n  color: var(--fa-inverse, #fff);\n}\n\n.sr-only,\n.fa-sr-only {\n  position: absolute;\n  width: 1px;\n  height: 1px;\n  padding: 0;\n  margin: -1px;\n  overflow: hidden;\n  clip: rect(0, 0, 0, 0);\n  white-space: nowrap;\n  border-width: 0;\n}\n\n.sr-only-focusable:not(:focus),\n.fa-sr-only-focusable:not(:focus) {\n  position: absolute;\n  width: 1px;\n  height: 1px;\n  padding: 0;\n  margin: -1px;\n  overflow: hidden;\n  clip: rect(0, 0, 0, 0);\n  white-space: nowrap;\n  border-width: 0;\n}\n\n.svg-inline--fa .fa-primary {\n  fill: var(--fa-primary-color, currentColor);\n  opacity: var(--fa-primary-opacity, 1);\n}\n\n.svg-inline--fa .fa-secondary {\n  fill: var(--fa-secondary-color, currentColor);\n  opacity: var(--fa-secondary-opacity, 0.4);\n}\n\n.svg-inline--fa.fa-swap-opacity .fa-primary {\n  opacity: var(--fa-secondary-opacity, 0.4);\n}\n\n.svg-inline--fa.fa-swap-opacity .fa-secondary {\n  opacity: var(--fa-primary-opacity, 1);\n}\n\n.svg-inline--fa mask .fa-primary,\n.svg-inline--fa mask .fa-secondary {\n  fill: black;\n}\n\n.fad.fa-inverse,\n.fa-duotone.fa-inverse {\n  color: var(--fa-inverse, #fff);\n}';
function $a43d996a7aa8a839$var$css() {
    var dcp = $a43d996a7aa8a839$var$DEFAULT_CSS_PREFIX;
    var drc = $a43d996a7aa8a839$var$DEFAULT_REPLACEMENT_CLASS;
    var fp = $a43d996a7aa8a839$var$config.cssPrefix;
    var rc = $a43d996a7aa8a839$var$config.replacementClass;
    var s = $a43d996a7aa8a839$var$baseStyles;
    if (fp !== dcp || rc !== drc) {
        var dPatt = new RegExp("\\.".concat(dcp, "\\-"), "g");
        var customPropPatt = new RegExp("\\--".concat(dcp, "\\-"), "g");
        var rPatt = new RegExp("\\.".concat(drc), "g");
        s = s.replace(dPatt, ".".concat(fp, "-")).replace(customPropPatt, "--".concat(fp, "-")).replace(rPatt, ".".concat(rc));
    }
    return s;
}
var $a43d996a7aa8a839$var$_cssInserted = false;
function $a43d996a7aa8a839$var$ensureCss() {
    if ($a43d996a7aa8a839$var$config.autoAddCss && !$a43d996a7aa8a839$var$_cssInserted) {
        $a43d996a7aa8a839$var$insertCss($a43d996a7aa8a839$var$css());
        $a43d996a7aa8a839$var$_cssInserted = true;
    }
}
var $a43d996a7aa8a839$var$InjectCSS = {
    mixout: function mixout() {
        return {
            dom: {
                css: $a43d996a7aa8a839$var$css,
                insertCss: $a43d996a7aa8a839$var$ensureCss
            }
        };
    },
    hooks: function hooks() {
        return {
            beforeDOMElementCreation: function beforeDOMElementCreation() {
                $a43d996a7aa8a839$var$ensureCss();
            },
            beforeI2svg: function beforeI2svg() {
                $a43d996a7aa8a839$var$ensureCss();
            }
        };
    }
};
var $a43d996a7aa8a839$var$w = $a43d996a7aa8a839$var$WINDOW || {};
if (!$a43d996a7aa8a839$var$w[$a43d996a7aa8a839$var$NAMESPACE_IDENTIFIER]) $a43d996a7aa8a839$var$w[$a43d996a7aa8a839$var$NAMESPACE_IDENTIFIER] = {};
if (!$a43d996a7aa8a839$var$w[$a43d996a7aa8a839$var$NAMESPACE_IDENTIFIER].styles) $a43d996a7aa8a839$var$w[$a43d996a7aa8a839$var$NAMESPACE_IDENTIFIER].styles = {};
if (!$a43d996a7aa8a839$var$w[$a43d996a7aa8a839$var$NAMESPACE_IDENTIFIER].hooks) $a43d996a7aa8a839$var$w[$a43d996a7aa8a839$var$NAMESPACE_IDENTIFIER].hooks = {};
if (!$a43d996a7aa8a839$var$w[$a43d996a7aa8a839$var$NAMESPACE_IDENTIFIER].shims) $a43d996a7aa8a839$var$w[$a43d996a7aa8a839$var$NAMESPACE_IDENTIFIER].shims = [];
var $a43d996a7aa8a839$var$namespace = $a43d996a7aa8a839$var$w[$a43d996a7aa8a839$var$NAMESPACE_IDENTIFIER];
var $a43d996a7aa8a839$var$functions = [];
var $a43d996a7aa8a839$var$listener = function listener() {
    $a43d996a7aa8a839$var$DOCUMENT.removeEventListener("DOMContentLoaded", listener);
    $a43d996a7aa8a839$var$loaded = 1;
    $a43d996a7aa8a839$var$functions.map(function(fn) {
        return fn();
    });
};
var $a43d996a7aa8a839$var$loaded = false;
if ($a43d996a7aa8a839$var$IS_DOM) {
    $a43d996a7aa8a839$var$loaded = ($a43d996a7aa8a839$var$DOCUMENT.documentElement.doScroll ? /^loaded|^c/ : /^loaded|^i|^c/).test($a43d996a7aa8a839$var$DOCUMENT.readyState);
    if (!$a43d996a7aa8a839$var$loaded) $a43d996a7aa8a839$var$DOCUMENT.addEventListener("DOMContentLoaded", $a43d996a7aa8a839$var$listener);
}
function $a43d996a7aa8a839$var$domready(fn) {
    if (!$a43d996a7aa8a839$var$IS_DOM) return;
    $a43d996a7aa8a839$var$loaded ? setTimeout(fn, 0) : $a43d996a7aa8a839$var$functions.push(fn);
}
function $a43d996a7aa8a839$var$toHtml(abstractNodes) {
    var tag = abstractNodes.tag, _abstractNodes$attrib = abstractNodes.attributes, attributes = _abstractNodes$attrib === void 0 ? {} : _abstractNodes$attrib, _abstractNodes$childr = abstractNodes.children, children = _abstractNodes$childr === void 0 ? [] : _abstractNodes$childr;
    if (typeof abstractNodes === "string") return $a43d996a7aa8a839$var$htmlEscape(abstractNodes);
    else return "<".concat(tag, " ").concat($a43d996a7aa8a839$var$joinAttributes(attributes), ">").concat(children.map($a43d996a7aa8a839$var$toHtml).join(""), "</").concat(tag, ">");
}
function $a43d996a7aa8a839$var$iconFromMapping(mapping, prefix, iconName) {
    if (mapping && mapping[prefix] && mapping[prefix][iconName]) return {
        prefix: prefix,
        iconName: iconName,
        icon: mapping[prefix][iconName]
    };
}
/**
 * Internal helper to bind a function known to have 4 arguments
 * to a given context.
 */ var $a43d996a7aa8a839$var$bindInternal4 = function bindInternal4(func, thisContext) {
    return function(a, b, c, d) {
        return func.call(thisContext, a, b, c, d);
    };
};
/**
 * # Reduce
 *
 * A fast object `.reduce()` implementation.
 *
 * @param  {Object}   subject      The object to reduce over.
 * @param  {Function} fn           The reducer function.
 * @param  {mixed}    initialValue The initial value for the reducer, defaults to subject[0].
 * @param  {Object}   thisContext  The context for the reducer.
 * @return {mixed}                 The final result.
 */ var $a43d996a7aa8a839$var$reduce = function fastReduceObject(subject, fn, initialValue, thisContext) {
    var keys = Object.keys(subject), length = keys.length, iterator = thisContext !== undefined ? $a43d996a7aa8a839$var$bindInternal4(fn, thisContext) : fn, i, key, result;
    if (initialValue === undefined) {
        i = 1;
        result = subject[keys[0]];
    } else {
        i = 0;
        result = initialValue;
    }
    for(; i < length; i++){
        key = keys[i];
        result = iterator(result, subject[key], key, subject);
    }
    return result;
};
/**
 * ucs2decode() and codePointAt() are both works of Mathias Bynens and licensed under MIT
 *
 * Copyright Mathias Bynens <https://mathiasbynens.be/>

 * Permission is hereby granted, free of charge, to any person obtaining
 * a copy of this software and associated documentation files (the
 * "Software"), to deal in the Software without restriction, including
 * without limitation the rights to use, copy, modify, merge, publish,
 * distribute, sublicense, and/or sell copies of the Software, and to
 * permit persons to whom the Software is furnished to do so, subject to
 * the following conditions:

 * The above copyright notice and this permission notice shall be
 * included in all copies or substantial portions of the Software.

 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND,
 * EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
 * MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND
 * NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE
 * LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION
 * OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION
 * WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.
 */ function $a43d996a7aa8a839$var$ucs2decode(string) {
    var output = [];
    var counter = 0;
    var length = string.length;
    while(counter < length){
        var value = string.charCodeAt(counter++);
        if (value >= 0xD800 && value <= 0xDBFF && counter < length) {
            var extra = string.charCodeAt(counter++);
            if ((extra & 0xFC00) == 0xDC00) // eslint-disable-line eqeqeq
            output.push(((value & 0x3FF) << 10) + (extra & 0x3FF) + 0x10000);
            else {
                output.push(value);
                counter--;
            }
        } else output.push(value);
    }
    return output;
}
function $a43d996a7aa8a839$var$toHex(unicode) {
    var decoded = $a43d996a7aa8a839$var$ucs2decode(unicode);
    return decoded.length === 1 ? decoded[0].toString(16) : null;
}
function $a43d996a7aa8a839$var$codePointAt(string, index) {
    var size = string.length;
    var first = string.charCodeAt(index);
    var second;
    if (first >= 0xD800 && first <= 0xDBFF && size > index + 1) {
        second = string.charCodeAt(index + 1);
        if (second >= 0xDC00 && second <= 0xDFFF) return (first - 0xD800) * 0x400 + second - 0xDC00 + 0x10000;
    }
    return first;
}
function $a43d996a7aa8a839$var$normalizeIcons(icons) {
    return Object.keys(icons).reduce(function(acc, iconName) {
        var icon = icons[iconName];
        var expanded = !!icon.icon;
        if (expanded) acc[icon.iconName] = icon.icon;
        else acc[iconName] = icon;
        return acc;
    }, {});
}
function $a43d996a7aa8a839$var$defineIcons(prefix, icons) {
    var params = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
    var _params$skipHooks = params.skipHooks, skipHooks = _params$skipHooks === void 0 ? false : _params$skipHooks;
    var normalized = $a43d996a7aa8a839$var$normalizeIcons(icons);
    if (typeof $a43d996a7aa8a839$var$namespace.hooks.addPack === "function" && !skipHooks) $a43d996a7aa8a839$var$namespace.hooks.addPack(prefix, $a43d996a7aa8a839$var$normalizeIcons(icons));
    else $a43d996a7aa8a839$var$namespace.styles[prefix] = $a43d996a7aa8a839$var$_objectSpread2($a43d996a7aa8a839$var$_objectSpread2({}, $a43d996a7aa8a839$var$namespace.styles[prefix] || {}), normalized);
    /**
   * Font Awesome 4 used the prefix of `fa` for all icons. With the introduction
   * of new styles we needed to differentiate between them. Prefix `fa` is now an alias
   * for `fas` so we'll ease the upgrade process for our users by automatically defining
   * this as well.
   */ if (prefix === "fas") $a43d996a7aa8a839$var$defineIcons("fa", icons);
}
var $a43d996a7aa8a839$var$duotonePathRe = [
    /*#__PURE__*/ $a43d996a7aa8a839$var$_wrapRegExp(/path d="((?:(?!")[\s\S])+)".*path d="((?:(?!")[\s\S])+)"/, {
        d1: 1,
        d2: 2
    }),
    /*#__PURE__*/ $a43d996a7aa8a839$var$_wrapRegExp(/path class="((?:(?!")[\s\S])+)".*d="((?:(?!")[\s\S])+)".*path class="((?:(?!")[\s\S])+)".*d="((?:(?!")[\s\S])+)"/, {
        cls1: 1,
        d1: 2,
        cls2: 3,
        d2: 4
    }),
    /*#__PURE__*/ $a43d996a7aa8a839$var$_wrapRegExp(/path class="((?:(?!")[\s\S])+)".*d="((?:(?!")[\s\S])+)"/, {
        cls1: 1,
        d1: 2
    })
];
var $a43d996a7aa8a839$var$_LONG_STYLE, $a43d996a7aa8a839$var$_PREFIXES, $a43d996a7aa8a839$var$_PREFIXES_FOR_FAMILY;
var $a43d996a7aa8a839$var$styles = $a43d996a7aa8a839$var$namespace.styles, $a43d996a7aa8a839$var$shims = $a43d996a7aa8a839$var$namespace.shims;
var $a43d996a7aa8a839$var$LONG_STYLE = ($a43d996a7aa8a839$var$_LONG_STYLE = {}, $a43d996a7aa8a839$var$_defineProperty($a43d996a7aa8a839$var$_LONG_STYLE, $a43d996a7aa8a839$var$FAMILY_CLASSIC, Object.values($a43d996a7aa8a839$var$PREFIX_TO_LONG_STYLE[$a43d996a7aa8a839$var$FAMILY_CLASSIC])), $a43d996a7aa8a839$var$_defineProperty($a43d996a7aa8a839$var$_LONG_STYLE, $a43d996a7aa8a839$var$FAMILY_SHARP, Object.values($a43d996a7aa8a839$var$PREFIX_TO_LONG_STYLE[$a43d996a7aa8a839$var$FAMILY_SHARP])), $a43d996a7aa8a839$var$_LONG_STYLE);
var $a43d996a7aa8a839$var$_defaultUsablePrefix = null;
var $a43d996a7aa8a839$var$_byUnicode = {};
var $a43d996a7aa8a839$var$_byLigature = {};
var $a43d996a7aa8a839$var$_byOldName = {};
var $a43d996a7aa8a839$var$_byOldUnicode = {};
var $a43d996a7aa8a839$var$_byAlias = {};
var $a43d996a7aa8a839$var$PREFIXES = ($a43d996a7aa8a839$var$_PREFIXES = {}, $a43d996a7aa8a839$var$_defineProperty($a43d996a7aa8a839$var$_PREFIXES, $a43d996a7aa8a839$var$FAMILY_CLASSIC, Object.keys($a43d996a7aa8a839$var$PREFIX_TO_STYLE[$a43d996a7aa8a839$var$FAMILY_CLASSIC])), $a43d996a7aa8a839$var$_defineProperty($a43d996a7aa8a839$var$_PREFIXES, $a43d996a7aa8a839$var$FAMILY_SHARP, Object.keys($a43d996a7aa8a839$var$PREFIX_TO_STYLE[$a43d996a7aa8a839$var$FAMILY_SHARP])), $a43d996a7aa8a839$var$_PREFIXES);
function $a43d996a7aa8a839$var$isReserved(name) {
    return ~$a43d996a7aa8a839$var$RESERVED_CLASSES.indexOf(name);
}
function $a43d996a7aa8a839$var$getIconName(cssPrefix, cls) {
    var parts = cls.split("-");
    var prefix = parts[0];
    var iconName = parts.slice(1).join("-");
    if (prefix === cssPrefix && iconName !== "" && !$a43d996a7aa8a839$var$isReserved(iconName)) return iconName;
    else return null;
}
var $a43d996a7aa8a839$var$build = function build() {
    var lookup = function lookup(reducer) {
        return $a43d996a7aa8a839$var$reduce($a43d996a7aa8a839$var$styles, function(o, style, prefix) {
            o[prefix] = $a43d996a7aa8a839$var$reduce(style, reducer, {});
            return o;
        }, {});
    };
    $a43d996a7aa8a839$var$_byUnicode = lookup(function(acc, icon, iconName) {
        if (icon[3]) acc[icon[3]] = iconName;
        if (icon[2]) {
            var aliases = icon[2].filter(function(a) {
                return typeof a === "number";
            });
            aliases.forEach(function(alias) {
                acc[alias.toString(16)] = iconName;
            });
        }
        return acc;
    });
    $a43d996a7aa8a839$var$_byLigature = lookup(function(acc, icon, iconName) {
        acc[iconName] = iconName;
        if (icon[2]) {
            var aliases = icon[2].filter(function(a) {
                return typeof a === "string";
            });
            aliases.forEach(function(alias) {
                acc[alias] = iconName;
            });
        }
        return acc;
    });
    $a43d996a7aa8a839$var$_byAlias = lookup(function(acc, icon, iconName) {
        var aliases = icon[2];
        acc[iconName] = iconName;
        aliases.forEach(function(alias) {
            acc[alias] = iconName;
        });
        return acc;
    }); // If we have a Kit, we can't determine if regular is available since we
    // could be auto-fetching it. We'll have to assume that it is available.
    var hasRegular = "far" in $a43d996a7aa8a839$var$styles || $a43d996a7aa8a839$var$config.autoFetchSvg;
    var shimLookups = $a43d996a7aa8a839$var$reduce($a43d996a7aa8a839$var$shims, function(acc, shim) {
        var maybeNameMaybeUnicode = shim[0];
        var prefix = shim[1];
        var iconName = shim[2];
        if (prefix === "far" && !hasRegular) prefix = "fas";
        if (typeof maybeNameMaybeUnicode === "string") acc.names[maybeNameMaybeUnicode] = {
            prefix: prefix,
            iconName: iconName
        };
        if (typeof maybeNameMaybeUnicode === "number") acc.unicodes[maybeNameMaybeUnicode.toString(16)] = {
            prefix: prefix,
            iconName: iconName
        };
        return acc;
    }, {
        names: {},
        unicodes: {}
    });
    $a43d996a7aa8a839$var$_byOldName = shimLookups.names;
    $a43d996a7aa8a839$var$_byOldUnicode = shimLookups.unicodes;
    $a43d996a7aa8a839$var$_defaultUsablePrefix = $a43d996a7aa8a839$var$getCanonicalPrefix($a43d996a7aa8a839$var$config.styleDefault, {
        family: $a43d996a7aa8a839$var$config.familyDefault
    });
};
$a43d996a7aa8a839$var$onChange(function(c) {
    $a43d996a7aa8a839$var$_defaultUsablePrefix = $a43d996a7aa8a839$var$getCanonicalPrefix(c.styleDefault, {
        family: $a43d996a7aa8a839$var$config.familyDefault
    });
});
$a43d996a7aa8a839$var$build();
function $a43d996a7aa8a839$var$byUnicode(prefix, unicode) {
    return ($a43d996a7aa8a839$var$_byUnicode[prefix] || {})[unicode];
}
function $a43d996a7aa8a839$var$byLigature(prefix, ligature) {
    return ($a43d996a7aa8a839$var$_byLigature[prefix] || {})[ligature];
}
function $a43d996a7aa8a839$var$byAlias(prefix, alias) {
    return ($a43d996a7aa8a839$var$_byAlias[prefix] || {})[alias];
}
function $a43d996a7aa8a839$var$byOldName(name) {
    return $a43d996a7aa8a839$var$_byOldName[name] || {
        prefix: null,
        iconName: null
    };
}
function $a43d996a7aa8a839$var$byOldUnicode(unicode) {
    var oldUnicode = $a43d996a7aa8a839$var$_byOldUnicode[unicode];
    var newUnicode = $a43d996a7aa8a839$var$byUnicode("fas", unicode);
    return oldUnicode || (newUnicode ? {
        prefix: "fas",
        iconName: newUnicode
    } : null) || {
        prefix: null,
        iconName: null
    };
}
function $a43d996a7aa8a839$var$getDefaultUsablePrefix() {
    return $a43d996a7aa8a839$var$_defaultUsablePrefix;
}
var $a43d996a7aa8a839$var$emptyCanonicalIcon = function emptyCanonicalIcon() {
    return {
        prefix: null,
        iconName: null,
        rest: []
    };
};
function $a43d996a7aa8a839$var$getCanonicalPrefix(styleOrPrefix) {
    var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var _params$family = params.family, family = _params$family === void 0 ? $a43d996a7aa8a839$var$FAMILY_CLASSIC : _params$family;
    var style = $a43d996a7aa8a839$var$PREFIX_TO_STYLE[family][styleOrPrefix];
    var prefix = $a43d996a7aa8a839$var$STYLE_TO_PREFIX[family][styleOrPrefix] || $a43d996a7aa8a839$var$STYLE_TO_PREFIX[family][style];
    var defined = styleOrPrefix in $a43d996a7aa8a839$var$namespace.styles ? styleOrPrefix : null;
    return prefix || defined || null;
}
var $a43d996a7aa8a839$var$PREFIXES_FOR_FAMILY = ($a43d996a7aa8a839$var$_PREFIXES_FOR_FAMILY = {}, $a43d996a7aa8a839$var$_defineProperty($a43d996a7aa8a839$var$_PREFIXES_FOR_FAMILY, $a43d996a7aa8a839$var$FAMILY_CLASSIC, Object.keys($a43d996a7aa8a839$var$PREFIX_TO_LONG_STYLE[$a43d996a7aa8a839$var$FAMILY_CLASSIC])), $a43d996a7aa8a839$var$_defineProperty($a43d996a7aa8a839$var$_PREFIXES_FOR_FAMILY, $a43d996a7aa8a839$var$FAMILY_SHARP, Object.keys($a43d996a7aa8a839$var$PREFIX_TO_LONG_STYLE[$a43d996a7aa8a839$var$FAMILY_SHARP])), $a43d996a7aa8a839$var$_PREFIXES_FOR_FAMILY);
function $a43d996a7aa8a839$var$getCanonicalIcon(values) {
    var _famProps;
    var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var _params$skipLookups = params.skipLookups, skipLookups = _params$skipLookups === void 0 ? false : _params$skipLookups;
    var famProps = (_famProps = {}, $a43d996a7aa8a839$var$_defineProperty(_famProps, $a43d996a7aa8a839$var$FAMILY_CLASSIC, "".concat($a43d996a7aa8a839$var$config.cssPrefix, "-").concat($a43d996a7aa8a839$var$FAMILY_CLASSIC)), $a43d996a7aa8a839$var$_defineProperty(_famProps, $a43d996a7aa8a839$var$FAMILY_SHARP, "".concat($a43d996a7aa8a839$var$config.cssPrefix, "-").concat($a43d996a7aa8a839$var$FAMILY_SHARP)), _famProps);
    var givenPrefix = null;
    var family = $a43d996a7aa8a839$var$FAMILY_CLASSIC;
    if (values.includes(famProps[$a43d996a7aa8a839$var$FAMILY_CLASSIC]) || values.some(function(v) {
        return $a43d996a7aa8a839$var$PREFIXES_FOR_FAMILY[$a43d996a7aa8a839$var$FAMILY_CLASSIC].includes(v);
    })) family = $a43d996a7aa8a839$var$FAMILY_CLASSIC;
    if (values.includes(famProps[$a43d996a7aa8a839$var$FAMILY_SHARP]) || values.some(function(v) {
        return $a43d996a7aa8a839$var$PREFIXES_FOR_FAMILY[$a43d996a7aa8a839$var$FAMILY_SHARP].includes(v);
    })) family = $a43d996a7aa8a839$var$FAMILY_SHARP;
    var canonical = values.reduce(function(acc, cls) {
        var iconName = $a43d996a7aa8a839$var$getIconName($a43d996a7aa8a839$var$config.cssPrefix, cls);
        if ($a43d996a7aa8a839$var$styles[cls]) {
            cls = $a43d996a7aa8a839$var$LONG_STYLE[family].includes(cls) ? $a43d996a7aa8a839$var$LONG_STYLE_TO_PREFIX[family][cls] : cls;
            givenPrefix = cls;
            acc.prefix = cls;
        } else if ($a43d996a7aa8a839$var$PREFIXES[family].indexOf(cls) > -1) {
            givenPrefix = cls;
            acc.prefix = $a43d996a7aa8a839$var$getCanonicalPrefix(cls, {
                family: family
            });
        } else if (iconName) acc.iconName = iconName;
        else if (cls !== $a43d996a7aa8a839$var$config.replacementClass && cls !== famProps[$a43d996a7aa8a839$var$FAMILY_CLASSIC] && cls !== famProps[$a43d996a7aa8a839$var$FAMILY_SHARP]) acc.rest.push(cls);
        if (!skipLookups && acc.prefix && acc.iconName) {
            var shim = givenPrefix === "fa" ? $a43d996a7aa8a839$var$byOldName(acc.iconName) : {};
            var aliasIconName = $a43d996a7aa8a839$var$byAlias(acc.prefix, acc.iconName);
            if (shim.prefix) givenPrefix = null;
            acc.iconName = shim.iconName || aliasIconName || acc.iconName;
            acc.prefix = shim.prefix || acc.prefix;
            if (acc.prefix === "far" && !$a43d996a7aa8a839$var$styles["far"] && $a43d996a7aa8a839$var$styles["fas"] && !$a43d996a7aa8a839$var$config.autoFetchSvg) // Allow a fallback from the regular style to solid if regular is not available
            // but only if we aren't auto-fetching SVGs
            acc.prefix = "fas";
        }
        return acc;
    }, $a43d996a7aa8a839$var$emptyCanonicalIcon());
    if (values.includes("fa-brands") || values.includes("fab")) canonical.prefix = "fab";
    if (values.includes("fa-duotone") || values.includes("fad")) canonical.prefix = "fad";
    if (!canonical.prefix && family === $a43d996a7aa8a839$var$FAMILY_SHARP && ($a43d996a7aa8a839$var$styles["fass"] || $a43d996a7aa8a839$var$config.autoFetchSvg)) {
        canonical.prefix = "fass";
        canonical.iconName = $a43d996a7aa8a839$var$byAlias(canonical.prefix, canonical.iconName) || canonical.iconName;
    }
    if (canonical.prefix === "fa" || givenPrefix === "fa") // The fa prefix is not canonical. So if it has made it through until this point
    // we will shift it to the correct prefix.
    canonical.prefix = $a43d996a7aa8a839$var$getDefaultUsablePrefix() || "fas";
    return canonical;
}
var $a43d996a7aa8a839$var$Library = /*#__PURE__*/ function() {
    function Library() {
        $a43d996a7aa8a839$var$_classCallCheck(this, Library);
        this.definitions = {};
    }
    $a43d996a7aa8a839$var$_createClass(Library, [
        {
            key: "add",
            value: function add() {
                var _this = this;
                for(var _len = arguments.length, definitions = new Array(_len), _key = 0; _key < _len; _key++)definitions[_key] = arguments[_key];
                var additions = definitions.reduce(this._pullDefinitions, {});
                Object.keys(additions).forEach(function(key) {
                    _this.definitions[key] = $a43d996a7aa8a839$var$_objectSpread2($a43d996a7aa8a839$var$_objectSpread2({}, _this.definitions[key] || {}), additions[key]);
                    $a43d996a7aa8a839$var$defineIcons(key, additions[key]); // TODO can we stop doing this? We can't get the icons by 'fa-solid' any longer so this probably needs to change
                    var longPrefix = $a43d996a7aa8a839$var$PREFIX_TO_LONG_STYLE[$a43d996a7aa8a839$var$FAMILY_CLASSIC][key];
                    if (longPrefix) $a43d996a7aa8a839$var$defineIcons(longPrefix, additions[key]);
                    $a43d996a7aa8a839$var$build();
                });
            }
        },
        {
            key: "reset",
            value: function reset() {
                this.definitions = {};
            }
        },
        {
            key: "_pullDefinitions",
            value: function _pullDefinitions(additions, definition) {
                var normalized = definition.prefix && definition.iconName && definition.icon ? {
                    0: definition
                } : definition;
                Object.keys(normalized).map(function(key) {
                    var _normalized$key = normalized[key], prefix = _normalized$key.prefix, iconName = _normalized$key.iconName, icon = _normalized$key.icon;
                    var aliases = icon[2];
                    if (!additions[prefix]) additions[prefix] = {};
                    if (aliases.length > 0) aliases.forEach(function(alias) {
                        if (typeof alias === "string") additions[prefix][alias] = icon;
                    });
                    additions[prefix][iconName] = icon;
                });
                return additions;
            }
        }
    ]);
    return Library;
}();
var $a43d996a7aa8a839$var$_plugins = [];
var $a43d996a7aa8a839$var$_hooks = {};
var $a43d996a7aa8a839$var$providers = {};
var $a43d996a7aa8a839$var$defaultProviderKeys = Object.keys($a43d996a7aa8a839$var$providers);
function $a43d996a7aa8a839$var$registerPlugins(nextPlugins, _ref) {
    var obj = _ref.mixoutsTo;
    $a43d996a7aa8a839$var$_plugins = nextPlugins;
    $a43d996a7aa8a839$var$_hooks = {};
    Object.keys($a43d996a7aa8a839$var$providers).forEach(function(k) {
        if ($a43d996a7aa8a839$var$defaultProviderKeys.indexOf(k) === -1) delete $a43d996a7aa8a839$var$providers[k];
    });
    $a43d996a7aa8a839$var$_plugins.forEach(function(plugin) {
        var mixout = plugin.mixout ? plugin.mixout() : {};
        Object.keys(mixout).forEach(function(tk) {
            if (typeof mixout[tk] === "function") obj[tk] = mixout[tk];
            if ($a43d996a7aa8a839$var$_typeof(mixout[tk]) === "object") Object.keys(mixout[tk]).forEach(function(sk) {
                if (!obj[tk]) obj[tk] = {};
                obj[tk][sk] = mixout[tk][sk];
            });
        });
        if (plugin.hooks) {
            var hooks = plugin.hooks();
            Object.keys(hooks).forEach(function(hook) {
                if (!$a43d996a7aa8a839$var$_hooks[hook]) $a43d996a7aa8a839$var$_hooks[hook] = [];
                $a43d996a7aa8a839$var$_hooks[hook].push(hooks[hook]);
            });
        }
        if (plugin.provides) plugin.provides($a43d996a7aa8a839$var$providers);
    });
    return obj;
}
function $a43d996a7aa8a839$var$chainHooks(hook, accumulator) {
    for(var _len = arguments.length, args = new Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++)args[_key - 2] = arguments[_key];
    var hookFns = $a43d996a7aa8a839$var$_hooks[hook] || [];
    hookFns.forEach(function(hookFn) {
        accumulator = hookFn.apply(null, [
            accumulator
        ].concat(args)); // eslint-disable-line no-useless-call
    });
    return accumulator;
}
function $a43d996a7aa8a839$var$callHooks(hook) {
    for(var _len2 = arguments.length, args = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++)args[_key2 - 1] = arguments[_key2];
    var hookFns = $a43d996a7aa8a839$var$_hooks[hook] || [];
    hookFns.forEach(function(hookFn) {
        hookFn.apply(null, args);
    });
    return undefined;
}
function $a43d996a7aa8a839$var$callProvided() {
    var hook = arguments[0];
    var args = Array.prototype.slice.call(arguments, 1);
    return $a43d996a7aa8a839$var$providers[hook] ? $a43d996a7aa8a839$var$providers[hook].apply(null, args) : undefined;
}
function $a43d996a7aa8a839$var$findIconDefinition(iconLookup) {
    if (iconLookup.prefix === "fa") iconLookup.prefix = "fas";
    var iconName = iconLookup.iconName;
    var prefix = iconLookup.prefix || $a43d996a7aa8a839$var$getDefaultUsablePrefix();
    if (!iconName) return;
    iconName = $a43d996a7aa8a839$var$byAlias(prefix, iconName) || iconName;
    return $a43d996a7aa8a839$var$iconFromMapping($a43d996a7aa8a839$var$library.definitions, prefix, iconName) || $a43d996a7aa8a839$var$iconFromMapping($a43d996a7aa8a839$var$namespace.styles, prefix, iconName);
}
var $a43d996a7aa8a839$var$library = new $a43d996a7aa8a839$var$Library();
var $a43d996a7aa8a839$var$noAuto = function noAuto() {
    $a43d996a7aa8a839$var$config.autoReplaceSvg = false;
    $a43d996a7aa8a839$var$config.observeMutations = false;
    $a43d996a7aa8a839$var$callHooks("noAuto");
};
var $a43d996a7aa8a839$var$dom = {
    i2svg: function i2svg() {
        var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        if ($a43d996a7aa8a839$var$IS_DOM) {
            $a43d996a7aa8a839$var$callHooks("beforeI2svg", params);
            $a43d996a7aa8a839$var$callProvided("pseudoElements2svg", params);
            return $a43d996a7aa8a839$var$callProvided("i2svg", params);
        } else return Promise.reject("Operation requires a DOM of some kind.");
    },
    watch: function watch() {
        var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        var autoReplaceSvgRoot = params.autoReplaceSvgRoot;
        if ($a43d996a7aa8a839$var$config.autoReplaceSvg === false) $a43d996a7aa8a839$var$config.autoReplaceSvg = true;
        $a43d996a7aa8a839$var$config.observeMutations = true;
        $a43d996a7aa8a839$var$domready(function() {
            $a43d996a7aa8a839$var$autoReplace({
                autoReplaceSvgRoot: autoReplaceSvgRoot
            });
            $a43d996a7aa8a839$var$callHooks("watch", params);
        });
    }
};
var $a43d996a7aa8a839$var$parse = {
    icon: function icon(_icon) {
        if (_icon === null) return null;
        if ($a43d996a7aa8a839$var$_typeof(_icon) === "object" && _icon.prefix && _icon.iconName) return {
            prefix: _icon.prefix,
            iconName: $a43d996a7aa8a839$var$byAlias(_icon.prefix, _icon.iconName) || _icon.iconName
        };
        if (Array.isArray(_icon) && _icon.length === 2) {
            var iconName = _icon[1].indexOf("fa-") === 0 ? _icon[1].slice(3) : _icon[1];
            var prefix = $a43d996a7aa8a839$var$getCanonicalPrefix(_icon[0]);
            return {
                prefix: prefix,
                iconName: $a43d996a7aa8a839$var$byAlias(prefix, iconName) || iconName
            };
        }
        if (typeof _icon === "string" && (_icon.indexOf("".concat($a43d996a7aa8a839$var$config.cssPrefix, "-")) > -1 || _icon.match($a43d996a7aa8a839$var$ICON_SELECTION_SYNTAX_PATTERN))) {
            var canonicalIcon = $a43d996a7aa8a839$var$getCanonicalIcon(_icon.split(" "), {
                skipLookups: true
            });
            return {
                prefix: canonicalIcon.prefix || $a43d996a7aa8a839$var$getDefaultUsablePrefix(),
                iconName: $a43d996a7aa8a839$var$byAlias(canonicalIcon.prefix, canonicalIcon.iconName) || canonicalIcon.iconName
            };
        }
        if (typeof _icon === "string") {
            var _prefix = $a43d996a7aa8a839$var$getDefaultUsablePrefix();
            return {
                prefix: _prefix,
                iconName: $a43d996a7aa8a839$var$byAlias(_prefix, _icon) || _icon
            };
        }
    }
};
var $a43d996a7aa8a839$export$644d8ea042df96a6 = {
    noAuto: $a43d996a7aa8a839$var$noAuto,
    config: $a43d996a7aa8a839$var$config,
    dom: $a43d996a7aa8a839$var$dom,
    parse: $a43d996a7aa8a839$var$parse,
    library: $a43d996a7aa8a839$var$library,
    findIconDefinition: $a43d996a7aa8a839$var$findIconDefinition,
    toHtml: $a43d996a7aa8a839$var$toHtml
};
var $a43d996a7aa8a839$var$autoReplace = function autoReplace() {
    var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var _params$autoReplaceSv = params.autoReplaceSvgRoot, autoReplaceSvgRoot = _params$autoReplaceSv === void 0 ? $a43d996a7aa8a839$var$DOCUMENT : _params$autoReplaceSv;
    if ((Object.keys($a43d996a7aa8a839$var$namespace.styles).length > 0 || $a43d996a7aa8a839$var$config.autoFetchSvg) && $a43d996a7aa8a839$var$IS_DOM && $a43d996a7aa8a839$var$config.autoReplaceSvg) $a43d996a7aa8a839$export$644d8ea042df96a6.dom.i2svg({
        node: autoReplaceSvgRoot
    });
};
function $a43d996a7aa8a839$var$domVariants(val, abstractCreator) {
    Object.defineProperty(val, "abstract", {
        get: abstractCreator
    });
    Object.defineProperty(val, "html", {
        get: function get() {
            return val.abstract.map(function(a) {
                return $a43d996a7aa8a839$var$toHtml(a);
            });
        }
    });
    Object.defineProperty(val, "node", {
        get: function get() {
            if (!$a43d996a7aa8a839$var$IS_DOM) return;
            var container = $a43d996a7aa8a839$var$DOCUMENT.createElement("div");
            container.innerHTML = val.html;
            return container.children;
        }
    });
    return val;
}
function $a43d996a7aa8a839$var$asIcon(_ref) {
    var children = _ref.children, main = _ref.main, mask = _ref.mask, attributes = _ref.attributes, styles = _ref.styles, transform = _ref.transform;
    if ($a43d996a7aa8a839$var$transformIsMeaningful(transform) && main.found && !mask.found) {
        var width = main.width, height = main.height;
        var offset = {
            x: width / height / 2,
            y: 0.5
        };
        attributes["style"] = $a43d996a7aa8a839$var$joinStyles($a43d996a7aa8a839$var$_objectSpread2($a43d996a7aa8a839$var$_objectSpread2({}, styles), {}, {
            "transform-origin": "".concat(offset.x + transform.x / 16, "em ").concat(offset.y + transform.y / 16, "em")
        }));
    }
    return [
        {
            tag: "svg",
            attributes: attributes,
            children: children
        }
    ];
}
function $a43d996a7aa8a839$var$asSymbol(_ref) {
    var prefix = _ref.prefix, iconName = _ref.iconName, children = _ref.children, attributes = _ref.attributes, symbol = _ref.symbol;
    var id = symbol === true ? "".concat(prefix, "-").concat($a43d996a7aa8a839$var$config.cssPrefix, "-").concat(iconName) : symbol;
    return [
        {
            tag: "svg",
            attributes: {
                style: "display: none;"
            },
            children: [
                {
                    tag: "symbol",
                    attributes: $a43d996a7aa8a839$var$_objectSpread2($a43d996a7aa8a839$var$_objectSpread2({}, attributes), {}, {
                        id: id
                    }),
                    children: children
                }
            ]
        }
    ];
}
function $a43d996a7aa8a839$var$makeInlineSvgAbstract(params) {
    var _params$icons = params.icons, main = _params$icons.main, mask = _params$icons.mask, prefix = params.prefix, iconName = params.iconName, transform = params.transform, symbol = params.symbol, title = params.title, maskId = params.maskId, titleId = params.titleId, extra = params.extra, _params$watchable = params.watchable, watchable = _params$watchable === void 0 ? false : _params$watchable;
    var _ref = mask.found ? mask : main, width = _ref.width, height = _ref.height;
    var isUploadedIcon = prefix === "fak";
    var attrClass = [
        $a43d996a7aa8a839$var$config.replacementClass,
        iconName ? "".concat($a43d996a7aa8a839$var$config.cssPrefix, "-").concat(iconName) : ""
    ].filter(function(c) {
        return extra.classes.indexOf(c) === -1;
    }).filter(function(c) {
        return c !== "" || !!c;
    }).concat(extra.classes).join(" ");
    var content = {
        children: [],
        attributes: $a43d996a7aa8a839$var$_objectSpread2($a43d996a7aa8a839$var$_objectSpread2({}, extra.attributes), {}, {
            "data-prefix": prefix,
            "data-icon": iconName,
            "class": attrClass,
            "role": extra.attributes.role || "img",
            "xmlns": "http://www.w3.org/2000/svg",
            "viewBox": "0 0 ".concat(width, " ").concat(height)
        })
    };
    var uploadedIconWidthStyle = isUploadedIcon && !~extra.classes.indexOf("fa-fw") ? {
        width: "".concat(width / height * 1, "em")
    } : {};
    if (watchable) content.attributes[$a43d996a7aa8a839$var$DATA_FA_I2SVG] = "";
    if (title) {
        content.children.push({
            tag: "title",
            attributes: {
                id: content.attributes["aria-labelledby"] || "title-".concat(titleId || $a43d996a7aa8a839$var$nextUniqueId())
            },
            children: [
                title
            ]
        });
        delete content.attributes.title;
    }
    var args = $a43d996a7aa8a839$var$_objectSpread2($a43d996a7aa8a839$var$_objectSpread2({}, content), {}, {
        prefix: prefix,
        iconName: iconName,
        main: main,
        mask: mask,
        maskId: maskId,
        transform: transform,
        symbol: symbol,
        styles: $a43d996a7aa8a839$var$_objectSpread2($a43d996a7aa8a839$var$_objectSpread2({}, uploadedIconWidthStyle), extra.styles)
    });
    var _ref2 = mask.found && main.found ? $a43d996a7aa8a839$var$callProvided("generateAbstractMask", args) || {
        children: [],
        attributes: {}
    } : $a43d996a7aa8a839$var$callProvided("generateAbstractIcon", args) || {
        children: [],
        attributes: {}
    }, children = _ref2.children, attributes = _ref2.attributes;
    args.children = children;
    args.attributes = attributes;
    if (symbol) return $a43d996a7aa8a839$var$asSymbol(args);
    else return $a43d996a7aa8a839$var$asIcon(args);
}
function $a43d996a7aa8a839$var$makeLayersTextAbstract(params) {
    var content = params.content, width = params.width, height = params.height, transform = params.transform, title = params.title, extra = params.extra, _params$watchable2 = params.watchable, watchable = _params$watchable2 === void 0 ? false : _params$watchable2;
    var attributes = $a43d996a7aa8a839$var$_objectSpread2($a43d996a7aa8a839$var$_objectSpread2($a43d996a7aa8a839$var$_objectSpread2({}, extra.attributes), title ? {
        "title": title
    } : {}), {}, {
        "class": extra.classes.join(" ")
    });
    if (watchable) attributes[$a43d996a7aa8a839$var$DATA_FA_I2SVG] = "";
    var styles = $a43d996a7aa8a839$var$_objectSpread2({}, extra.styles);
    if ($a43d996a7aa8a839$var$transformIsMeaningful(transform)) {
        styles["transform"] = $a43d996a7aa8a839$var$transformForCss({
            transform: transform,
            startCentered: true,
            width: width,
            height: height
        });
        styles["-webkit-transform"] = styles["transform"];
    }
    var styleString = $a43d996a7aa8a839$var$joinStyles(styles);
    if (styleString.length > 0) attributes["style"] = styleString;
    var val = [];
    val.push({
        tag: "span",
        attributes: attributes,
        children: [
            content
        ]
    });
    if (title) val.push({
        tag: "span",
        attributes: {
            class: "sr-only"
        },
        children: [
            title
        ]
    });
    return val;
}
function $a43d996a7aa8a839$var$makeLayersCounterAbstract(params) {
    var content = params.content, title = params.title, extra = params.extra;
    var attributes = $a43d996a7aa8a839$var$_objectSpread2($a43d996a7aa8a839$var$_objectSpread2($a43d996a7aa8a839$var$_objectSpread2({}, extra.attributes), title ? {
        "title": title
    } : {}), {}, {
        "class": extra.classes.join(" ")
    });
    var styleString = $a43d996a7aa8a839$var$joinStyles(extra.styles);
    if (styleString.length > 0) attributes["style"] = styleString;
    var val = [];
    val.push({
        tag: "span",
        attributes: attributes,
        children: [
            content
        ]
    });
    if (title) val.push({
        tag: "span",
        attributes: {
            class: "sr-only"
        },
        children: [
            title
        ]
    });
    return val;
}
var $a43d996a7aa8a839$var$styles$1 = $a43d996a7aa8a839$var$namespace.styles;
function $a43d996a7aa8a839$var$asFoundIcon(icon) {
    var width = icon[0];
    var height = icon[1];
    var _icon$slice = icon.slice(4), _icon$slice2 = $a43d996a7aa8a839$var$_slicedToArray(_icon$slice, 1), vectorData = _icon$slice2[0];
    var element = null;
    if (Array.isArray(vectorData)) element = {
        tag: "g",
        attributes: {
            class: "".concat($a43d996a7aa8a839$var$config.cssPrefix, "-").concat($a43d996a7aa8a839$var$DUOTONE_CLASSES.GROUP)
        },
        children: [
            {
                tag: "path",
                attributes: {
                    class: "".concat($a43d996a7aa8a839$var$config.cssPrefix, "-").concat($a43d996a7aa8a839$var$DUOTONE_CLASSES.SECONDARY),
                    fill: "currentColor",
                    d: vectorData[0]
                }
            },
            {
                tag: "path",
                attributes: {
                    class: "".concat($a43d996a7aa8a839$var$config.cssPrefix, "-").concat($a43d996a7aa8a839$var$DUOTONE_CLASSES.PRIMARY),
                    fill: "currentColor",
                    d: vectorData[1]
                }
            }
        ]
    };
    else element = {
        tag: "path",
        attributes: {
            fill: "currentColor",
            d: vectorData
        }
    };
    return {
        found: true,
        width: width,
        height: height,
        icon: element
    };
}
var $a43d996a7aa8a839$var$missingIconResolutionMixin = {
    found: false,
    width: 512,
    height: 512
};
function $a43d996a7aa8a839$var$maybeNotifyMissing(iconName, prefix) {
    if (!$a43d996a7aa8a839$var$PRODUCTION && !$a43d996a7aa8a839$var$config.showMissingIcons && iconName) console.error('Icon with name "'.concat(iconName, '" and prefix "').concat(prefix, '" is missing.'));
}
function $a43d996a7aa8a839$var$findIcon(iconName, prefix) {
    var givenPrefix = prefix;
    if (prefix === "fa" && $a43d996a7aa8a839$var$config.styleDefault !== null) prefix = $a43d996a7aa8a839$var$getDefaultUsablePrefix();
    return new Promise(function(resolve, reject) {
        var val = {
            found: false,
            width: 512,
            height: 512,
            icon: $a43d996a7aa8a839$var$callProvided("missingIconAbstract") || {}
        };
        if (givenPrefix === "fa") {
            var shim = $a43d996a7aa8a839$var$byOldName(iconName) || {};
            iconName = shim.iconName || iconName;
            prefix = shim.prefix || prefix;
        }
        if (iconName && prefix && $a43d996a7aa8a839$var$styles$1[prefix] && $a43d996a7aa8a839$var$styles$1[prefix][iconName]) {
            var icon = $a43d996a7aa8a839$var$styles$1[prefix][iconName];
            return resolve($a43d996a7aa8a839$var$asFoundIcon(icon));
        }
        $a43d996a7aa8a839$var$maybeNotifyMissing(iconName, prefix);
        resolve($a43d996a7aa8a839$var$_objectSpread2($a43d996a7aa8a839$var$_objectSpread2({}, $a43d996a7aa8a839$var$missingIconResolutionMixin), {}, {
            icon: $a43d996a7aa8a839$var$config.showMissingIcons && iconName ? $a43d996a7aa8a839$var$callProvided("missingIconAbstract") || {} : {}
        }));
    });
}
var $a43d996a7aa8a839$var$noop$1 = function noop() {};
var $a43d996a7aa8a839$var$p = $a43d996a7aa8a839$var$config.measurePerformance && $a43d996a7aa8a839$var$PERFORMANCE && $a43d996a7aa8a839$var$PERFORMANCE.mark && $a43d996a7aa8a839$var$PERFORMANCE.measure ? $a43d996a7aa8a839$var$PERFORMANCE : {
    mark: $a43d996a7aa8a839$var$noop$1,
    measure: $a43d996a7aa8a839$var$noop$1
};
var $a43d996a7aa8a839$var$preamble = 'FA "6.4.2"';
var $a43d996a7aa8a839$var$begin = function begin(name) {
    $a43d996a7aa8a839$var$p.mark("".concat($a43d996a7aa8a839$var$preamble, " ").concat(name, " begins"));
    return function() {
        return $a43d996a7aa8a839$var$end(name);
    };
};
var $a43d996a7aa8a839$var$end = function end(name) {
    $a43d996a7aa8a839$var$p.mark("".concat($a43d996a7aa8a839$var$preamble, " ").concat(name, " ends"));
    $a43d996a7aa8a839$var$p.measure("".concat($a43d996a7aa8a839$var$preamble, " ").concat(name), "".concat($a43d996a7aa8a839$var$preamble, " ").concat(name, " begins"), "".concat($a43d996a7aa8a839$var$preamble, " ").concat(name, " ends"));
};
var $a43d996a7aa8a839$var$perf = {
    begin: $a43d996a7aa8a839$var$begin,
    end: $a43d996a7aa8a839$var$end
};
var $a43d996a7aa8a839$var$noop$2 = function noop() {};
function $a43d996a7aa8a839$var$isWatched(node) {
    var i2svg = node.getAttribute ? node.getAttribute($a43d996a7aa8a839$var$DATA_FA_I2SVG) : null;
    return typeof i2svg === "string";
}
function $a43d996a7aa8a839$var$hasPrefixAndIcon(node) {
    var prefix = node.getAttribute ? node.getAttribute($a43d996a7aa8a839$var$DATA_PREFIX) : null;
    var icon = node.getAttribute ? node.getAttribute($a43d996a7aa8a839$var$DATA_ICON) : null;
    return prefix && icon;
}
function $a43d996a7aa8a839$var$hasBeenReplaced(node) {
    return node && node.classList && node.classList.contains && node.classList.contains($a43d996a7aa8a839$var$config.replacementClass);
}
function $a43d996a7aa8a839$var$getMutator() {
    if ($a43d996a7aa8a839$var$config.autoReplaceSvg === true) return $a43d996a7aa8a839$var$mutators.replace;
    var mutator = $a43d996a7aa8a839$var$mutators[$a43d996a7aa8a839$var$config.autoReplaceSvg];
    return mutator || $a43d996a7aa8a839$var$mutators.replace;
}
function $a43d996a7aa8a839$var$createElementNS(tag) {
    return $a43d996a7aa8a839$var$DOCUMENT.createElementNS("http://www.w3.org/2000/svg", tag);
}
function $a43d996a7aa8a839$var$createElement(tag) {
    return $a43d996a7aa8a839$var$DOCUMENT.createElement(tag);
}
function $a43d996a7aa8a839$var$convertSVG(abstractObj) {
    var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var _params$ceFn = params.ceFn, ceFn = _params$ceFn === void 0 ? abstractObj.tag === "svg" ? $a43d996a7aa8a839$var$createElementNS : $a43d996a7aa8a839$var$createElement : _params$ceFn;
    if (typeof abstractObj === "string") return $a43d996a7aa8a839$var$DOCUMENT.createTextNode(abstractObj);
    var tag = ceFn(abstractObj.tag);
    Object.keys(abstractObj.attributes || []).forEach(function(key) {
        tag.setAttribute(key, abstractObj.attributes[key]);
    });
    var children = abstractObj.children || [];
    children.forEach(function(child) {
        tag.appendChild($a43d996a7aa8a839$var$convertSVG(child, {
            ceFn: ceFn
        }));
    });
    return tag;
}
function $a43d996a7aa8a839$var$nodeAsComment(node) {
    var comment = " ".concat(node.outerHTML, " ");
    /* BEGIN.ATTRIBUTION */ comment = "".concat(comment, "Font Awesome fontawesome.com ");
    /* END.ATTRIBUTION */ return comment;
}
var $a43d996a7aa8a839$var$mutators = {
    replace: function replace(mutation) {
        var node = mutation[0];
        if (node.parentNode) {
            mutation[1].forEach(function(_abstract) {
                node.parentNode.insertBefore($a43d996a7aa8a839$var$convertSVG(_abstract), node);
            });
            if (node.getAttribute($a43d996a7aa8a839$var$DATA_FA_I2SVG) === null && $a43d996a7aa8a839$var$config.keepOriginalSource) {
                var comment = $a43d996a7aa8a839$var$DOCUMENT.createComment($a43d996a7aa8a839$var$nodeAsComment(node));
                node.parentNode.replaceChild(comment, node);
            } else node.remove();
        }
    },
    nest: function nest(mutation) {
        var node = mutation[0];
        var _abstract2 = mutation[1]; // If we already have a replaced node we do not want to continue nesting within it.
        // Short-circuit to the standard replacement
        if (~$a43d996a7aa8a839$var$classArray(node).indexOf($a43d996a7aa8a839$var$config.replacementClass)) return $a43d996a7aa8a839$var$mutators.replace(mutation);
        var forSvg = new RegExp("".concat($a43d996a7aa8a839$var$config.cssPrefix, "-.*"));
        delete _abstract2[0].attributes.id;
        if (_abstract2[0].attributes.class) {
            var splitClasses = _abstract2[0].attributes.class.split(" ").reduce(function(acc, cls) {
                if (cls === $a43d996a7aa8a839$var$config.replacementClass || cls.match(forSvg)) acc.toSvg.push(cls);
                else acc.toNode.push(cls);
                return acc;
            }, {
                toNode: [],
                toSvg: []
            });
            _abstract2[0].attributes.class = splitClasses.toSvg.join(" ");
            if (splitClasses.toNode.length === 0) node.removeAttribute("class");
            else node.setAttribute("class", splitClasses.toNode.join(" "));
        }
        var newInnerHTML = _abstract2.map(function(a) {
            return $a43d996a7aa8a839$var$toHtml(a);
        }).join("\n");
        node.setAttribute($a43d996a7aa8a839$var$DATA_FA_I2SVG, "");
        node.innerHTML = newInnerHTML;
    }
};
function $a43d996a7aa8a839$var$performOperationSync(op) {
    op();
}
function $a43d996a7aa8a839$var$perform(mutations, callback) {
    var callbackFunction = typeof callback === "function" ? callback : $a43d996a7aa8a839$var$noop$2;
    if (mutations.length === 0) callbackFunction();
    else {
        var frame = $a43d996a7aa8a839$var$performOperationSync;
        if ($a43d996a7aa8a839$var$config.mutateApproach === $a43d996a7aa8a839$var$MUTATION_APPROACH_ASYNC) frame = $a43d996a7aa8a839$var$WINDOW.requestAnimationFrame || $a43d996a7aa8a839$var$performOperationSync;
        frame(function() {
            var mutator = $a43d996a7aa8a839$var$getMutator();
            var mark = $a43d996a7aa8a839$var$perf.begin("mutate");
            mutations.map(mutator);
            mark();
            callbackFunction();
        });
    }
}
var $a43d996a7aa8a839$var$disabled = false;
function $a43d996a7aa8a839$var$disableObservation() {
    $a43d996a7aa8a839$var$disabled = true;
}
function $a43d996a7aa8a839$var$enableObservation() {
    $a43d996a7aa8a839$var$disabled = false;
}
var $a43d996a7aa8a839$var$mo = null;
function $a43d996a7aa8a839$var$observe(options) {
    if (!$a43d996a7aa8a839$var$MUTATION_OBSERVER) return;
    if (!$a43d996a7aa8a839$var$config.observeMutations) return;
    var _options$treeCallback = options.treeCallback, treeCallback = _options$treeCallback === void 0 ? $a43d996a7aa8a839$var$noop$2 : _options$treeCallback, _options$nodeCallback = options.nodeCallback, nodeCallback = _options$nodeCallback === void 0 ? $a43d996a7aa8a839$var$noop$2 : _options$nodeCallback, _options$pseudoElemen = options.pseudoElementsCallback, pseudoElementsCallback = _options$pseudoElemen === void 0 ? $a43d996a7aa8a839$var$noop$2 : _options$pseudoElemen, _options$observeMutat = options.observeMutationsRoot, observeMutationsRoot = _options$observeMutat === void 0 ? $a43d996a7aa8a839$var$DOCUMENT : _options$observeMutat;
    $a43d996a7aa8a839$var$mo = new $a43d996a7aa8a839$var$MUTATION_OBSERVER(function(objects) {
        if ($a43d996a7aa8a839$var$disabled) return;
        var defaultPrefix = $a43d996a7aa8a839$var$getDefaultUsablePrefix();
        $a43d996a7aa8a839$var$toArray(objects).forEach(function(mutationRecord) {
            if (mutationRecord.type === "childList" && mutationRecord.addedNodes.length > 0 && !$a43d996a7aa8a839$var$isWatched(mutationRecord.addedNodes[0])) {
                if ($a43d996a7aa8a839$var$config.searchPseudoElements) pseudoElementsCallback(mutationRecord.target);
                treeCallback(mutationRecord.target);
            }
            if (mutationRecord.type === "attributes" && mutationRecord.target.parentNode && $a43d996a7aa8a839$var$config.searchPseudoElements) pseudoElementsCallback(mutationRecord.target.parentNode);
            if (mutationRecord.type === "attributes" && $a43d996a7aa8a839$var$isWatched(mutationRecord.target) && ~$a43d996a7aa8a839$var$ATTRIBUTES_WATCHED_FOR_MUTATION.indexOf(mutationRecord.attributeName)) {
                if (mutationRecord.attributeName === "class" && $a43d996a7aa8a839$var$hasPrefixAndIcon(mutationRecord.target)) {
                    var _getCanonicalIcon = $a43d996a7aa8a839$var$getCanonicalIcon($a43d996a7aa8a839$var$classArray(mutationRecord.target)), prefix = _getCanonicalIcon.prefix, iconName = _getCanonicalIcon.iconName;
                    mutationRecord.target.setAttribute($a43d996a7aa8a839$var$DATA_PREFIX, prefix || defaultPrefix);
                    if (iconName) mutationRecord.target.setAttribute($a43d996a7aa8a839$var$DATA_ICON, iconName);
                } else if ($a43d996a7aa8a839$var$hasBeenReplaced(mutationRecord.target)) nodeCallback(mutationRecord.target);
            }
        });
    });
    if (!$a43d996a7aa8a839$var$IS_DOM) return;
    $a43d996a7aa8a839$var$mo.observe(observeMutationsRoot, {
        childList: true,
        attributes: true,
        characterData: true,
        subtree: true
    });
}
function $a43d996a7aa8a839$var$disconnect() {
    if (!$a43d996a7aa8a839$var$mo) return;
    $a43d996a7aa8a839$var$mo.disconnect();
}
function $a43d996a7aa8a839$var$styleParser(node) {
    var style = node.getAttribute("style");
    var val = [];
    if (style) val = style.split(";").reduce(function(acc, style) {
        var styles = style.split(":");
        var prop = styles[0];
        var value = styles.slice(1);
        if (prop && value.length > 0) acc[prop] = value.join(":").trim();
        return acc;
    }, {});
    return val;
}
function $a43d996a7aa8a839$var$classParser(node) {
    var existingPrefix = node.getAttribute("data-prefix");
    var existingIconName = node.getAttribute("data-icon");
    var innerText = node.innerText !== undefined ? node.innerText.trim() : "";
    var val = $a43d996a7aa8a839$var$getCanonicalIcon($a43d996a7aa8a839$var$classArray(node));
    if (!val.prefix) val.prefix = $a43d996a7aa8a839$var$getDefaultUsablePrefix();
    if (existingPrefix && existingIconName) {
        val.prefix = existingPrefix;
        val.iconName = existingIconName;
    }
    if (val.iconName && val.prefix) return val;
    if (val.prefix && innerText.length > 0) val.iconName = $a43d996a7aa8a839$var$byLigature(val.prefix, node.innerText) || $a43d996a7aa8a839$var$byUnicode(val.prefix, $a43d996a7aa8a839$var$toHex(node.innerText));
    if (!val.iconName && $a43d996a7aa8a839$var$config.autoFetchSvg && node.firstChild && node.firstChild.nodeType === Node.TEXT_NODE) val.iconName = node.firstChild.data;
    return val;
}
function $a43d996a7aa8a839$var$attributesParser(node) {
    var extraAttributes = $a43d996a7aa8a839$var$toArray(node.attributes).reduce(function(acc, attr) {
        if (acc.name !== "class" && acc.name !== "style") acc[attr.name] = attr.value;
        return acc;
    }, {});
    var title = node.getAttribute("title");
    var titleId = node.getAttribute("data-fa-title-id");
    if ($a43d996a7aa8a839$var$config.autoA11y) {
        if (title) extraAttributes["aria-labelledby"] = "".concat($a43d996a7aa8a839$var$config.replacementClass, "-title-").concat(titleId || $a43d996a7aa8a839$var$nextUniqueId());
        else {
            extraAttributes["aria-hidden"] = "true";
            extraAttributes["focusable"] = "false";
        }
    }
    return extraAttributes;
}
function $a43d996a7aa8a839$var$blankMeta() {
    return {
        iconName: null,
        title: null,
        titleId: null,
        prefix: null,
        transform: $a43d996a7aa8a839$var$meaninglessTransform,
        symbol: false,
        mask: {
            iconName: null,
            prefix: null,
            rest: []
        },
        maskId: null,
        extra: {
            classes: [],
            styles: {},
            attributes: {}
        }
    };
}
function $a43d996a7aa8a839$var$parseMeta(node) {
    var parser = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {
        styleParser: true
    };
    var _classParser = $a43d996a7aa8a839$var$classParser(node), iconName = _classParser.iconName, prefix = _classParser.prefix, extraClasses = _classParser.rest;
    var extraAttributes = $a43d996a7aa8a839$var$attributesParser(node);
    var pluginMeta = $a43d996a7aa8a839$var$chainHooks("parseNodeAttributes", {}, node);
    var extraStyles = parser.styleParser ? $a43d996a7aa8a839$var$styleParser(node) : [];
    return $a43d996a7aa8a839$var$_objectSpread2({
        iconName: iconName,
        title: node.getAttribute("title"),
        titleId: node.getAttribute("data-fa-title-id"),
        prefix: prefix,
        transform: $a43d996a7aa8a839$var$meaninglessTransform,
        mask: {
            iconName: null,
            prefix: null,
            rest: []
        },
        maskId: null,
        symbol: false,
        extra: {
            classes: extraClasses,
            styles: extraStyles,
            attributes: extraAttributes
        }
    }, pluginMeta);
}
var $a43d996a7aa8a839$var$styles$2 = $a43d996a7aa8a839$var$namespace.styles;
function $a43d996a7aa8a839$var$generateMutation(node) {
    var nodeMeta = $a43d996a7aa8a839$var$config.autoReplaceSvg === "nest" ? $a43d996a7aa8a839$var$parseMeta(node, {
        styleParser: false
    }) : $a43d996a7aa8a839$var$parseMeta(node);
    if (~nodeMeta.extra.classes.indexOf($a43d996a7aa8a839$var$LAYERS_TEXT_CLASSNAME)) return $a43d996a7aa8a839$var$callProvided("generateLayersText", node, nodeMeta);
    else return $a43d996a7aa8a839$var$callProvided("generateSvgReplacementMutation", node, nodeMeta);
}
var $a43d996a7aa8a839$var$knownPrefixes = new Set();
$a43d996a7aa8a839$var$FAMILIES.map(function(family) {
    $a43d996a7aa8a839$var$knownPrefixes.add("fa-".concat(family));
});
Object.keys($a43d996a7aa8a839$var$PREFIX_TO_STYLE[$a43d996a7aa8a839$var$FAMILY_CLASSIC]).map($a43d996a7aa8a839$var$knownPrefixes.add.bind($a43d996a7aa8a839$var$knownPrefixes));
Object.keys($a43d996a7aa8a839$var$PREFIX_TO_STYLE[$a43d996a7aa8a839$var$FAMILY_SHARP]).map($a43d996a7aa8a839$var$knownPrefixes.add.bind($a43d996a7aa8a839$var$knownPrefixes));
$a43d996a7aa8a839$var$knownPrefixes = $a43d996a7aa8a839$var$_toConsumableArray($a43d996a7aa8a839$var$knownPrefixes);
function $a43d996a7aa8a839$var$onTree(root) {
    var callback = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
    if (!$a43d996a7aa8a839$var$IS_DOM) return Promise.resolve();
    var htmlClassList = $a43d996a7aa8a839$var$DOCUMENT.documentElement.classList;
    var hclAdd = function hclAdd(suffix) {
        return htmlClassList.add("".concat($a43d996a7aa8a839$var$HTML_CLASS_I2SVG_BASE_CLASS, "-").concat(suffix));
    };
    var hclRemove = function hclRemove(suffix) {
        return htmlClassList.remove("".concat($a43d996a7aa8a839$var$HTML_CLASS_I2SVG_BASE_CLASS, "-").concat(suffix));
    };
    var prefixes = $a43d996a7aa8a839$var$config.autoFetchSvg ? $a43d996a7aa8a839$var$knownPrefixes : $a43d996a7aa8a839$var$FAMILIES.map(function(f) {
        return "fa-".concat(f);
    }).concat(Object.keys($a43d996a7aa8a839$var$styles$2));
    if (!prefixes.includes("fa")) prefixes.push("fa");
    var prefixesDomQuery = [
        ".".concat($a43d996a7aa8a839$var$LAYERS_TEXT_CLASSNAME, ":not([").concat($a43d996a7aa8a839$var$DATA_FA_I2SVG, "])")
    ].concat(prefixes.map(function(p) {
        return ".".concat(p, ":not([").concat($a43d996a7aa8a839$var$DATA_FA_I2SVG, "])");
    })).join(", ");
    if (prefixesDomQuery.length === 0) return Promise.resolve();
    var candidates = [];
    try {
        candidates = $a43d996a7aa8a839$var$toArray(root.querySelectorAll(prefixesDomQuery));
    } catch (e) {}
    if (candidates.length > 0) {
        hclAdd("pending");
        hclRemove("complete");
    } else return Promise.resolve();
    var mark = $a43d996a7aa8a839$var$perf.begin("onTree");
    var mutations = candidates.reduce(function(acc, node) {
        try {
            var mutation = $a43d996a7aa8a839$var$generateMutation(node);
            if (mutation) acc.push(mutation);
        } catch (e) {
            if (!$a43d996a7aa8a839$var$PRODUCTION) {
                if (e.name === "MissingIcon") console.error(e);
            }
        }
        return acc;
    }, []);
    return new Promise(function(resolve, reject) {
        Promise.all(mutations).then(function(resolvedMutations) {
            $a43d996a7aa8a839$var$perform(resolvedMutations, function() {
                hclAdd("active");
                hclAdd("complete");
                hclRemove("pending");
                if (typeof callback === "function") callback();
                mark();
                resolve();
            });
        }).catch(function(e) {
            mark();
            reject(e);
        });
    });
}
function $a43d996a7aa8a839$var$onNode(node) {
    var callback = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
    $a43d996a7aa8a839$var$generateMutation(node).then(function(mutation) {
        if (mutation) $a43d996a7aa8a839$var$perform([
            mutation
        ], callback);
    });
}
function $a43d996a7aa8a839$var$resolveIcons(next) {
    return function(maybeIconDefinition) {
        var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        var iconDefinition = (maybeIconDefinition || {}).icon ? maybeIconDefinition : $a43d996a7aa8a839$var$findIconDefinition(maybeIconDefinition || {});
        var mask = params.mask;
        if (mask) mask = (mask || {}).icon ? mask : $a43d996a7aa8a839$var$findIconDefinition(mask || {});
        return next(iconDefinition, $a43d996a7aa8a839$var$_objectSpread2($a43d996a7aa8a839$var$_objectSpread2({}, params), {}, {
            mask: mask
        }));
    };
}
var $a43d996a7aa8a839$var$render = function render(iconDefinition) {
    var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var _params$transform = params.transform, transform = _params$transform === void 0 ? $a43d996a7aa8a839$var$meaninglessTransform : _params$transform, _params$symbol = params.symbol, symbol = _params$symbol === void 0 ? false : _params$symbol, _params$mask = params.mask, mask = _params$mask === void 0 ? null : _params$mask, _params$maskId = params.maskId, maskId = _params$maskId === void 0 ? null : _params$maskId, _params$title = params.title, title = _params$title === void 0 ? null : _params$title, _params$titleId = params.titleId, titleId = _params$titleId === void 0 ? null : _params$titleId, _params$classes = params.classes, classes = _params$classes === void 0 ? [] : _params$classes, _params$attributes = params.attributes, attributes = _params$attributes === void 0 ? {} : _params$attributes, _params$styles = params.styles, styles = _params$styles === void 0 ? {} : _params$styles;
    if (!iconDefinition) return;
    var prefix = iconDefinition.prefix, iconName = iconDefinition.iconName, icon = iconDefinition.icon;
    return $a43d996a7aa8a839$var$domVariants($a43d996a7aa8a839$var$_objectSpread2({
        type: "icon"
    }, iconDefinition), function() {
        $a43d996a7aa8a839$var$callHooks("beforeDOMElementCreation", {
            iconDefinition: iconDefinition,
            params: params
        });
        if ($a43d996a7aa8a839$var$config.autoA11y) {
            if (title) attributes["aria-labelledby"] = "".concat($a43d996a7aa8a839$var$config.replacementClass, "-title-").concat(titleId || $a43d996a7aa8a839$var$nextUniqueId());
            else {
                attributes["aria-hidden"] = "true";
                attributes["focusable"] = "false";
            }
        }
        return $a43d996a7aa8a839$var$makeInlineSvgAbstract({
            icons: {
                main: $a43d996a7aa8a839$var$asFoundIcon(icon),
                mask: mask ? $a43d996a7aa8a839$var$asFoundIcon(mask.icon) : {
                    found: false,
                    width: null,
                    height: null,
                    icon: {}
                }
            },
            prefix: prefix,
            iconName: iconName,
            transform: $a43d996a7aa8a839$var$_objectSpread2($a43d996a7aa8a839$var$_objectSpread2({}, $a43d996a7aa8a839$var$meaninglessTransform), transform),
            symbol: symbol,
            title: title,
            maskId: maskId,
            titleId: titleId,
            extra: {
                attributes: attributes,
                styles: styles,
                classes: classes
            }
        });
    });
};
var $a43d996a7aa8a839$var$ReplaceElements = {
    mixout: function mixout() {
        return {
            icon: $a43d996a7aa8a839$var$resolveIcons($a43d996a7aa8a839$var$render)
        };
    },
    hooks: function hooks() {
        return {
            mutationObserverCallbacks: function mutationObserverCallbacks(accumulator) {
                accumulator.treeCallback = $a43d996a7aa8a839$var$onTree;
                accumulator.nodeCallback = $a43d996a7aa8a839$var$onNode;
                return accumulator;
            }
        };
    },
    provides: function provides(providers$$1) {
        providers$$1.i2svg = function(params) {
            var _params$node = params.node, node = _params$node === void 0 ? $a43d996a7aa8a839$var$DOCUMENT : _params$node, _params$callback = params.callback, callback = _params$callback === void 0 ? function() {} : _params$callback;
            return $a43d996a7aa8a839$var$onTree(node, callback);
        };
        providers$$1.generateSvgReplacementMutation = function(node, nodeMeta) {
            var iconName = nodeMeta.iconName, title = nodeMeta.title, titleId = nodeMeta.titleId, prefix = nodeMeta.prefix, transform = nodeMeta.transform, symbol = nodeMeta.symbol, mask = nodeMeta.mask, maskId = nodeMeta.maskId, extra = nodeMeta.extra;
            return new Promise(function(resolve, reject) {
                Promise.all([
                    $a43d996a7aa8a839$var$findIcon(iconName, prefix),
                    mask.iconName ? $a43d996a7aa8a839$var$findIcon(mask.iconName, mask.prefix) : Promise.resolve({
                        found: false,
                        width: 512,
                        height: 512,
                        icon: {}
                    })
                ]).then(function(_ref) {
                    var _ref2 = $a43d996a7aa8a839$var$_slicedToArray(_ref, 2), main = _ref2[0], mask = _ref2[1];
                    resolve([
                        node,
                        $a43d996a7aa8a839$var$makeInlineSvgAbstract({
                            icons: {
                                main: main,
                                mask: mask
                            },
                            prefix: prefix,
                            iconName: iconName,
                            transform: transform,
                            symbol: symbol,
                            maskId: maskId,
                            title: title,
                            titleId: titleId,
                            extra: extra,
                            watchable: true
                        })
                    ]);
                }).catch(reject);
            });
        };
        providers$$1.generateAbstractIcon = function(_ref3) {
            var children = _ref3.children, attributes = _ref3.attributes, main = _ref3.main, transform = _ref3.transform, styles = _ref3.styles;
            var styleString = $a43d996a7aa8a839$var$joinStyles(styles);
            if (styleString.length > 0) attributes["style"] = styleString;
            var nextChild;
            if ($a43d996a7aa8a839$var$transformIsMeaningful(transform)) nextChild = $a43d996a7aa8a839$var$callProvided("generateAbstractTransformGrouping", {
                main: main,
                transform: transform,
                containerWidth: main.width,
                iconWidth: main.width
            });
            children.push(nextChild || main.icon);
            return {
                children: children,
                attributes: attributes
            };
        };
    }
};
var $a43d996a7aa8a839$var$Layers = {
    mixout: function mixout() {
        return {
            layer: function layer(assembler) {
                var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
                var _params$classes = params.classes, classes = _params$classes === void 0 ? [] : _params$classes;
                return $a43d996a7aa8a839$var$domVariants({
                    type: "layer"
                }, function() {
                    $a43d996a7aa8a839$var$callHooks("beforeDOMElementCreation", {
                        assembler: assembler,
                        params: params
                    });
                    var children = [];
                    assembler(function(args) {
                        Array.isArray(args) ? args.map(function(a) {
                            children = children.concat(a.abstract);
                        }) : children = children.concat(args.abstract);
                    });
                    return [
                        {
                            tag: "span",
                            attributes: {
                                class: [
                                    "".concat($a43d996a7aa8a839$var$config.cssPrefix, "-layers")
                                ].concat($a43d996a7aa8a839$var$_toConsumableArray(classes)).join(" ")
                            },
                            children: children
                        }
                    ];
                });
            }
        };
    }
};
var $a43d996a7aa8a839$var$LayersCounter = {
    mixout: function mixout() {
        return {
            counter: function counter(content) {
                var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
                var _params$title = params.title, title = _params$title === void 0 ? null : _params$title, _params$classes = params.classes, classes = _params$classes === void 0 ? [] : _params$classes, _params$attributes = params.attributes, attributes = _params$attributes === void 0 ? {} : _params$attributes, _params$styles = params.styles, styles = _params$styles === void 0 ? {} : _params$styles;
                return $a43d996a7aa8a839$var$domVariants({
                    type: "counter",
                    content: content
                }, function() {
                    $a43d996a7aa8a839$var$callHooks("beforeDOMElementCreation", {
                        content: content,
                        params: params
                    });
                    return $a43d996a7aa8a839$var$makeLayersCounterAbstract({
                        content: content.toString(),
                        title: title,
                        extra: {
                            attributes: attributes,
                            styles: styles,
                            classes: [
                                "".concat($a43d996a7aa8a839$var$config.cssPrefix, "-layers-counter")
                            ].concat($a43d996a7aa8a839$var$_toConsumableArray(classes))
                        }
                    });
                });
            }
        };
    }
};
var $a43d996a7aa8a839$var$LayersText = {
    mixout: function mixout() {
        return {
            text: function text(content) {
                var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
                var _params$transform = params.transform, transform = _params$transform === void 0 ? $a43d996a7aa8a839$var$meaninglessTransform : _params$transform, _params$title = params.title, title = _params$title === void 0 ? null : _params$title, _params$classes = params.classes, classes = _params$classes === void 0 ? [] : _params$classes, _params$attributes = params.attributes, attributes = _params$attributes === void 0 ? {} : _params$attributes, _params$styles = params.styles, styles = _params$styles === void 0 ? {} : _params$styles;
                return $a43d996a7aa8a839$var$domVariants({
                    type: "text",
                    content: content
                }, function() {
                    $a43d996a7aa8a839$var$callHooks("beforeDOMElementCreation", {
                        content: content,
                        params: params
                    });
                    return $a43d996a7aa8a839$var$makeLayersTextAbstract({
                        content: content,
                        transform: $a43d996a7aa8a839$var$_objectSpread2($a43d996a7aa8a839$var$_objectSpread2({}, $a43d996a7aa8a839$var$meaninglessTransform), transform),
                        title: title,
                        extra: {
                            attributes: attributes,
                            styles: styles,
                            classes: [
                                "".concat($a43d996a7aa8a839$var$config.cssPrefix, "-layers-text")
                            ].concat($a43d996a7aa8a839$var$_toConsumableArray(classes))
                        }
                    });
                });
            }
        };
    },
    provides: function provides(providers$$1) {
        providers$$1.generateLayersText = function(node, nodeMeta) {
            var title = nodeMeta.title, transform = nodeMeta.transform, extra = nodeMeta.extra;
            var width = null;
            var height = null;
            if ($a43d996a7aa8a839$var$IS_IE) {
                var computedFontSize = parseInt(getComputedStyle(node).fontSize, 10);
                var boundingClientRect = node.getBoundingClientRect();
                width = boundingClientRect.width / computedFontSize;
                height = boundingClientRect.height / computedFontSize;
            }
            if ($a43d996a7aa8a839$var$config.autoA11y && !title) extra.attributes["aria-hidden"] = "true";
            return Promise.resolve([
                node,
                $a43d996a7aa8a839$var$makeLayersTextAbstract({
                    content: node.innerHTML,
                    width: width,
                    height: height,
                    transform: transform,
                    title: title,
                    extra: extra,
                    watchable: true
                })
            ]);
        };
    }
};
var $a43d996a7aa8a839$var$CLEAN_CONTENT_PATTERN = new RegExp('"', "ug");
var $a43d996a7aa8a839$var$SECONDARY_UNICODE_RANGE = [
    1105920,
    1112319
];
function $a43d996a7aa8a839$var$hexValueFromContent(content) {
    var cleaned = content.replace($a43d996a7aa8a839$var$CLEAN_CONTENT_PATTERN, "");
    var codePoint = $a43d996a7aa8a839$var$codePointAt(cleaned, 0);
    var isPrependTen = codePoint >= $a43d996a7aa8a839$var$SECONDARY_UNICODE_RANGE[0] && codePoint <= $a43d996a7aa8a839$var$SECONDARY_UNICODE_RANGE[1];
    var isDoubled = cleaned.length === 2 ? cleaned[0] === cleaned[1] : false;
    return {
        value: isDoubled ? $a43d996a7aa8a839$var$toHex(cleaned[0]) : $a43d996a7aa8a839$var$toHex(cleaned),
        isSecondary: isPrependTen || isDoubled
    };
}
function $a43d996a7aa8a839$var$replaceForPosition(node, position) {
    var pendingAttribute = "".concat($a43d996a7aa8a839$var$DATA_FA_PSEUDO_ELEMENT_PENDING).concat(position.replace(":", "-"));
    return new Promise(function(resolve, reject) {
        if (node.getAttribute(pendingAttribute) !== null) // This node is already being processed
        return resolve();
        var children = $a43d996a7aa8a839$var$toArray(node.children);
        var alreadyProcessedPseudoElement = children.filter(function(c) {
            return c.getAttribute($a43d996a7aa8a839$var$DATA_FA_PSEUDO_ELEMENT) === position;
        })[0];
        var styles = $a43d996a7aa8a839$var$WINDOW.getComputedStyle(node, position);
        var fontFamily = styles.getPropertyValue("font-family").match($a43d996a7aa8a839$var$FONT_FAMILY_PATTERN);
        var fontWeight = styles.getPropertyValue("font-weight");
        var content = styles.getPropertyValue("content");
        if (alreadyProcessedPseudoElement && !fontFamily) {
            // If we've already processed it but the current computed style does not result in a font-family,
            // that probably means that a class name that was previously present to make the icon has been
            // removed. So we now should delete the icon.
            node.removeChild(alreadyProcessedPseudoElement);
            return resolve();
        } else if (fontFamily && content !== "none" && content !== "") {
            var _content = styles.getPropertyValue("content");
            var family = ~[
                "Sharp"
            ].indexOf(fontFamily[2]) ? $a43d996a7aa8a839$var$FAMILY_SHARP : $a43d996a7aa8a839$var$FAMILY_CLASSIC;
            var prefix = ~[
                "Solid",
                "Regular",
                "Light",
                "Thin",
                "Duotone",
                "Brands",
                "Kit"
            ].indexOf(fontFamily[2]) ? $a43d996a7aa8a839$var$STYLE_TO_PREFIX[family][fontFamily[2].toLowerCase()] : $a43d996a7aa8a839$var$FONT_WEIGHT_TO_PREFIX[family][fontWeight];
            var _hexValueFromContent = $a43d996a7aa8a839$var$hexValueFromContent(_content), hexValue = _hexValueFromContent.value, isSecondary = _hexValueFromContent.isSecondary;
            var isV4 = fontFamily[0].startsWith("FontAwesome");
            var iconName = $a43d996a7aa8a839$var$byUnicode(prefix, hexValue);
            var iconIdentifier = iconName;
            if (isV4) {
                var iconName4 = $a43d996a7aa8a839$var$byOldUnicode(hexValue);
                if (iconName4.iconName && iconName4.prefix) {
                    iconName = iconName4.iconName;
                    prefix = iconName4.prefix;
                }
            } // Only convert the pseudo element in this ::before/::after position into an icon if we haven't
            // already done so with the same prefix and iconName
            if (iconName && !isSecondary && (!alreadyProcessedPseudoElement || alreadyProcessedPseudoElement.getAttribute($a43d996a7aa8a839$var$DATA_PREFIX) !== prefix || alreadyProcessedPseudoElement.getAttribute($a43d996a7aa8a839$var$DATA_ICON) !== iconIdentifier)) {
                node.setAttribute(pendingAttribute, iconIdentifier);
                if (alreadyProcessedPseudoElement) // Delete the old one, since we're replacing it with a new one
                node.removeChild(alreadyProcessedPseudoElement);
                var meta = $a43d996a7aa8a839$var$blankMeta();
                var extra = meta.extra;
                extra.attributes[$a43d996a7aa8a839$var$DATA_FA_PSEUDO_ELEMENT] = position;
                $a43d996a7aa8a839$var$findIcon(iconName, prefix).then(function(main) {
                    var _abstract = $a43d996a7aa8a839$var$makeInlineSvgAbstract($a43d996a7aa8a839$var$_objectSpread2($a43d996a7aa8a839$var$_objectSpread2({}, meta), {}, {
                        icons: {
                            main: main,
                            mask: $a43d996a7aa8a839$var$emptyCanonicalIcon()
                        },
                        prefix: prefix,
                        iconName: iconIdentifier,
                        extra: extra,
                        watchable: true
                    }));
                    var element = $a43d996a7aa8a839$var$DOCUMENT.createElementNS("http://www.w3.org/2000/svg", "svg");
                    if (position === "::before") node.insertBefore(element, node.firstChild);
                    else node.appendChild(element);
                    element.outerHTML = _abstract.map(function(a) {
                        return $a43d996a7aa8a839$var$toHtml(a);
                    }).join("\n");
                    node.removeAttribute(pendingAttribute);
                    resolve();
                }).catch(reject);
            } else resolve();
        } else resolve();
    });
}
function $a43d996a7aa8a839$var$replace(node) {
    return Promise.all([
        $a43d996a7aa8a839$var$replaceForPosition(node, "::before"),
        $a43d996a7aa8a839$var$replaceForPosition(node, "::after")
    ]);
}
function $a43d996a7aa8a839$var$processable(node) {
    return node.parentNode !== document.head && !~$a43d996a7aa8a839$var$TAGNAMES_TO_SKIP_FOR_PSEUDOELEMENTS.indexOf(node.tagName.toUpperCase()) && !node.getAttribute($a43d996a7aa8a839$var$DATA_FA_PSEUDO_ELEMENT) && (!node.parentNode || node.parentNode.tagName !== "svg");
}
function $a43d996a7aa8a839$var$searchPseudoElements(root) {
    if (!$a43d996a7aa8a839$var$IS_DOM) return;
    return new Promise(function(resolve, reject) {
        var operations = $a43d996a7aa8a839$var$toArray(root.querySelectorAll("*")).filter($a43d996a7aa8a839$var$processable).map($a43d996a7aa8a839$var$replace);
        var end = $a43d996a7aa8a839$var$perf.begin("searchPseudoElements");
        $a43d996a7aa8a839$var$disableObservation();
        Promise.all(operations).then(function() {
            end();
            $a43d996a7aa8a839$var$enableObservation();
            resolve();
        }).catch(function() {
            end();
            $a43d996a7aa8a839$var$enableObservation();
            reject();
        });
    });
}
var $a43d996a7aa8a839$var$PseudoElements = {
    hooks: function hooks() {
        return {
            mutationObserverCallbacks: function mutationObserverCallbacks(accumulator) {
                accumulator.pseudoElementsCallback = $a43d996a7aa8a839$var$searchPseudoElements;
                return accumulator;
            }
        };
    },
    provides: function provides(providers$$1) {
        providers$$1.pseudoElements2svg = function(params) {
            var _params$node = params.node, node = _params$node === void 0 ? $a43d996a7aa8a839$var$DOCUMENT : _params$node;
            if ($a43d996a7aa8a839$var$config.searchPseudoElements) $a43d996a7aa8a839$var$searchPseudoElements(node);
        };
    }
};
var $a43d996a7aa8a839$var$_unwatched = false;
var $a43d996a7aa8a839$var$MutationObserver$1 = {
    mixout: function mixout() {
        return {
            dom: {
                unwatch: function unwatch() {
                    $a43d996a7aa8a839$var$disableObservation();
                    $a43d996a7aa8a839$var$_unwatched = true;
                }
            }
        };
    },
    hooks: function hooks() {
        return {
            bootstrap: function bootstrap() {
                $a43d996a7aa8a839$var$observe($a43d996a7aa8a839$var$chainHooks("mutationObserverCallbacks", {}));
            },
            noAuto: function noAuto() {
                $a43d996a7aa8a839$var$disconnect();
            },
            watch: function watch(params) {
                var observeMutationsRoot = params.observeMutationsRoot;
                if ($a43d996a7aa8a839$var$_unwatched) $a43d996a7aa8a839$var$enableObservation();
                else $a43d996a7aa8a839$var$observe($a43d996a7aa8a839$var$chainHooks("mutationObserverCallbacks", {
                    observeMutationsRoot: observeMutationsRoot
                }));
            }
        };
    }
};
var $a43d996a7aa8a839$var$parseTransformString = function parseTransformString(transformString) {
    var transform = {
        size: 16,
        x: 0,
        y: 0,
        flipX: false,
        flipY: false,
        rotate: 0
    };
    return transformString.toLowerCase().split(" ").reduce(function(acc, n) {
        var parts = n.toLowerCase().split("-");
        var first = parts[0];
        var rest = parts.slice(1).join("-");
        if (first && rest === "h") {
            acc.flipX = true;
            return acc;
        }
        if (first && rest === "v") {
            acc.flipY = true;
            return acc;
        }
        rest = parseFloat(rest);
        if (isNaN(rest)) return acc;
        switch(first){
            case "grow":
                acc.size = acc.size + rest;
                break;
            case "shrink":
                acc.size = acc.size - rest;
                break;
            case "left":
                acc.x = acc.x - rest;
                break;
            case "right":
                acc.x = acc.x + rest;
                break;
            case "up":
                acc.y = acc.y - rest;
                break;
            case "down":
                acc.y = acc.y + rest;
                break;
            case "rotate":
                acc.rotate = acc.rotate + rest;
                break;
        }
        return acc;
    }, transform);
};
var $a43d996a7aa8a839$var$PowerTransforms = {
    mixout: function mixout() {
        return {
            parse: {
                transform: function transform(transformString) {
                    return $a43d996a7aa8a839$var$parseTransformString(transformString);
                }
            }
        };
    },
    hooks: function hooks() {
        return {
            parseNodeAttributes: function parseNodeAttributes(accumulator, node) {
                var transformString = node.getAttribute("data-fa-transform");
                if (transformString) accumulator.transform = $a43d996a7aa8a839$var$parseTransformString(transformString);
                return accumulator;
            }
        };
    },
    provides: function provides(providers) {
        providers.generateAbstractTransformGrouping = function(_ref) {
            var main = _ref.main, transform = _ref.transform, containerWidth = _ref.containerWidth, iconWidth = _ref.iconWidth;
            var outer = {
                transform: "translate(".concat(containerWidth / 2, " 256)")
            };
            var innerTranslate = "translate(".concat(transform.x * 32, ", ").concat(transform.y * 32, ") ");
            var innerScale = "scale(".concat(transform.size / 16 * (transform.flipX ? -1 : 1), ", ").concat(transform.size / 16 * (transform.flipY ? -1 : 1), ") ");
            var innerRotate = "rotate(".concat(transform.rotate, " 0 0)");
            var inner = {
                transform: "".concat(innerTranslate, " ").concat(innerScale, " ").concat(innerRotate)
            };
            var path = {
                transform: "translate(".concat(iconWidth / 2 * -1, " -256)")
            };
            var operations = {
                outer: outer,
                inner: inner,
                path: path
            };
            return {
                tag: "g",
                attributes: $a43d996a7aa8a839$var$_objectSpread2({}, operations.outer),
                children: [
                    {
                        tag: "g",
                        attributes: $a43d996a7aa8a839$var$_objectSpread2({}, operations.inner),
                        children: [
                            {
                                tag: main.icon.tag,
                                children: main.icon.children,
                                attributes: $a43d996a7aa8a839$var$_objectSpread2($a43d996a7aa8a839$var$_objectSpread2({}, main.icon.attributes), operations.path)
                            }
                        ]
                    }
                ]
            };
        };
    }
};
var $a43d996a7aa8a839$var$ALL_SPACE = {
    x: 0,
    y: 0,
    width: "100%",
    height: "100%"
};
function $a43d996a7aa8a839$var$fillBlack(_abstract) {
    var force = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
    if (_abstract.attributes && (_abstract.attributes.fill || force)) _abstract.attributes.fill = "black";
    return _abstract;
}
function $a43d996a7aa8a839$var$deGroup(_abstract2) {
    if (_abstract2.tag === "g") return _abstract2.children;
    else return [
        _abstract2
    ];
}
var $a43d996a7aa8a839$var$Masks = {
    hooks: function hooks() {
        return {
            parseNodeAttributes: function parseNodeAttributes(accumulator, node) {
                var maskData = node.getAttribute("data-fa-mask");
                var mask = !maskData ? $a43d996a7aa8a839$var$emptyCanonicalIcon() : $a43d996a7aa8a839$var$getCanonicalIcon(maskData.split(" ").map(function(i) {
                    return i.trim();
                }));
                if (!mask.prefix) mask.prefix = $a43d996a7aa8a839$var$getDefaultUsablePrefix();
                accumulator.mask = mask;
                accumulator.maskId = node.getAttribute("data-fa-mask-id");
                return accumulator;
            }
        };
    },
    provides: function provides(providers) {
        providers.generateAbstractMask = function(_ref) {
            var children = _ref.children, attributes = _ref.attributes, main = _ref.main, mask = _ref.mask, explicitMaskId = _ref.maskId, transform = _ref.transform;
            var mainWidth = main.width, mainPath = main.icon;
            var maskWidth = mask.width, maskPath = mask.icon;
            var trans = $a43d996a7aa8a839$var$transformForSvg({
                transform: transform,
                containerWidth: maskWidth,
                iconWidth: mainWidth
            });
            var maskRect = {
                tag: "rect",
                attributes: $a43d996a7aa8a839$var$_objectSpread2($a43d996a7aa8a839$var$_objectSpread2({}, $a43d996a7aa8a839$var$ALL_SPACE), {}, {
                    fill: "white"
                })
            };
            var maskInnerGroupChildrenMixin = mainPath.children ? {
                children: mainPath.children.map($a43d996a7aa8a839$var$fillBlack)
            } : {};
            var maskInnerGroup = {
                tag: "g",
                attributes: $a43d996a7aa8a839$var$_objectSpread2({}, trans.inner),
                children: [
                    $a43d996a7aa8a839$var$fillBlack($a43d996a7aa8a839$var$_objectSpread2({
                        tag: mainPath.tag,
                        attributes: $a43d996a7aa8a839$var$_objectSpread2($a43d996a7aa8a839$var$_objectSpread2({}, mainPath.attributes), trans.path)
                    }, maskInnerGroupChildrenMixin))
                ]
            };
            var maskOuterGroup = {
                tag: "g",
                attributes: $a43d996a7aa8a839$var$_objectSpread2({}, trans.outer),
                children: [
                    maskInnerGroup
                ]
            };
            var maskId = "mask-".concat(explicitMaskId || $a43d996a7aa8a839$var$nextUniqueId());
            var clipId = "clip-".concat(explicitMaskId || $a43d996a7aa8a839$var$nextUniqueId());
            var maskTag = {
                tag: "mask",
                attributes: $a43d996a7aa8a839$var$_objectSpread2($a43d996a7aa8a839$var$_objectSpread2({}, $a43d996a7aa8a839$var$ALL_SPACE), {}, {
                    id: maskId,
                    maskUnits: "userSpaceOnUse",
                    maskContentUnits: "userSpaceOnUse"
                }),
                children: [
                    maskRect,
                    maskOuterGroup
                ]
            };
            var defs = {
                tag: "defs",
                children: [
                    {
                        tag: "clipPath",
                        attributes: {
                            id: clipId
                        },
                        children: $a43d996a7aa8a839$var$deGroup(maskPath)
                    },
                    maskTag
                ]
            };
            children.push(defs, {
                tag: "rect",
                attributes: $a43d996a7aa8a839$var$_objectSpread2({
                    fill: "currentColor",
                    "clip-path": "url(#".concat(clipId, ")"),
                    mask: "url(#".concat(maskId, ")")
                }, $a43d996a7aa8a839$var$ALL_SPACE)
            });
            return {
                children: children,
                attributes: attributes
            };
        };
    }
};
var $a43d996a7aa8a839$var$MissingIconIndicator = {
    provides: function provides(providers) {
        var reduceMotion = false;
        if ($a43d996a7aa8a839$var$WINDOW.matchMedia) reduceMotion = $a43d996a7aa8a839$var$WINDOW.matchMedia("(prefers-reduced-motion: reduce)").matches;
        providers.missingIconAbstract = function() {
            var gChildren = [];
            var FILL = {
                fill: "currentColor"
            };
            var ANIMATION_BASE = {
                attributeType: "XML",
                repeatCount: "indefinite",
                dur: "2s"
            }; // Ring
            gChildren.push({
                tag: "path",
                attributes: $a43d996a7aa8a839$var$_objectSpread2($a43d996a7aa8a839$var$_objectSpread2({}, FILL), {}, {
                    d: "M156.5,447.7l-12.6,29.5c-18.7-9.5-35.9-21.2-51.5-34.9l22.7-22.7C127.6,430.5,141.5,440,156.5,447.7z M40.6,272H8.5 c1.4,21.2,5.4,41.7,11.7,61.1L50,321.2C45.1,305.5,41.8,289,40.6,272z M40.6,240c1.4-18.8,5.2-37,11.1-54.1l-29.5-12.6 C14.7,194.3,10,216.7,8.5,240H40.6z M64.3,156.5c7.8-14.9,17.2-28.8,28.1-41.5L69.7,92.3c-13.7,15.6-25.5,32.8-34.9,51.5 L64.3,156.5z M397,419.6c-13.9,12-29.4,22.3-46.1,30.4l11.9,29.8c20.7-9.9,39.8-22.6,56.9-37.6L397,419.6z M115,92.4 c13.9-12,29.4-22.3,46.1-30.4l-11.9-29.8c-20.7,9.9-39.8,22.6-56.8,37.6L115,92.4z M447.7,355.5c-7.8,14.9-17.2,28.8-28.1,41.5 l22.7,22.7c13.7-15.6,25.5-32.9,34.9-51.5L447.7,355.5z M471.4,272c-1.4,18.8-5.2,37-11.1,54.1l29.5,12.6 c7.5-21.1,12.2-43.5,13.6-66.8H471.4z M321.2,462c-15.7,5-32.2,8.2-49.2,9.4v32.1c21.2-1.4,41.7-5.4,61.1-11.7L321.2,462z M240,471.4c-18.8-1.4-37-5.2-54.1-11.1l-12.6,29.5c21.1,7.5,43.5,12.2,66.8,13.6V471.4z M462,190.8c5,15.7,8.2,32.2,9.4,49.2h32.1 c-1.4-21.2-5.4-41.7-11.7-61.1L462,190.8z M92.4,397c-12-13.9-22.3-29.4-30.4-46.1l-29.8,11.9c9.9,20.7,22.6,39.8,37.6,56.9 L92.4,397z M272,40.6c18.8,1.4,36.9,5.2,54.1,11.1l12.6-29.5C317.7,14.7,295.3,10,272,8.5V40.6z M190.8,50 c15.7-5,32.2-8.2,49.2-9.4V8.5c-21.2,1.4-41.7,5.4-61.1,11.7L190.8,50z M442.3,92.3L419.6,115c12,13.9,22.3,29.4,30.5,46.1 l29.8-11.9C470,128.5,457.3,109.4,442.3,92.3z M397,92.4l22.7-22.7c-15.6-13.7-32.8-25.5-51.5-34.9l-12.6,29.5 C370.4,72.1,384.4,81.5,397,92.4z"
                })
            });
            var OPACITY_ANIMATE = $a43d996a7aa8a839$var$_objectSpread2($a43d996a7aa8a839$var$_objectSpread2({}, ANIMATION_BASE), {}, {
                attributeName: "opacity"
            });
            var dot = {
                tag: "circle",
                attributes: $a43d996a7aa8a839$var$_objectSpread2($a43d996a7aa8a839$var$_objectSpread2({}, FILL), {}, {
                    cx: "256",
                    cy: "364",
                    r: "28"
                }),
                children: []
            };
            if (!reduceMotion) dot.children.push({
                tag: "animate",
                attributes: $a43d996a7aa8a839$var$_objectSpread2($a43d996a7aa8a839$var$_objectSpread2({}, ANIMATION_BASE), {}, {
                    attributeName: "r",
                    values: "28;14;28;28;14;28;"
                })
            }, {
                tag: "animate",
                attributes: $a43d996a7aa8a839$var$_objectSpread2($a43d996a7aa8a839$var$_objectSpread2({}, OPACITY_ANIMATE), {}, {
                    values: "1;0;1;1;0;1;"
                })
            });
            gChildren.push(dot);
            gChildren.push({
                tag: "path",
                attributes: $a43d996a7aa8a839$var$_objectSpread2($a43d996a7aa8a839$var$_objectSpread2({}, FILL), {}, {
                    opacity: "1",
                    d: "M263.7,312h-16c-6.6,0-12-5.4-12-12c0-71,77.4-63.9,77.4-107.8c0-20-17.8-40.2-57.4-40.2c-29.1,0-44.3,9.6-59.2,28.7 c-3.9,5-11.1,6-16.2,2.4l-13.1-9.2c-5.6-3.9-6.9-11.8-2.6-17.2c21.2-27.2,46.4-44.7,91.2-44.7c52.3,0,97.4,29.8,97.4,80.2 c0,67.6-77.4,63.5-77.4,107.8C275.7,306.6,270.3,312,263.7,312z"
                }),
                children: reduceMotion ? [] : [
                    {
                        tag: "animate",
                        attributes: $a43d996a7aa8a839$var$_objectSpread2($a43d996a7aa8a839$var$_objectSpread2({}, OPACITY_ANIMATE), {}, {
                            values: "1;0;0;0;0;1;"
                        })
                    }
                ]
            });
            if (!reduceMotion) // Exclamation
            gChildren.push({
                tag: "path",
                attributes: $a43d996a7aa8a839$var$_objectSpread2($a43d996a7aa8a839$var$_objectSpread2({}, FILL), {}, {
                    opacity: "0",
                    d: "M232.5,134.5l7,168c0.3,6.4,5.6,11.5,12,11.5h9c6.4,0,11.7-5.1,12-11.5l7-168c0.3-6.8-5.2-12.5-12-12.5h-23 C237.7,122,232.2,127.7,232.5,134.5z"
                }),
                children: [
                    {
                        tag: "animate",
                        attributes: $a43d996a7aa8a839$var$_objectSpread2($a43d996a7aa8a839$var$_objectSpread2({}, OPACITY_ANIMATE), {}, {
                            values: "0;0;1;1;0;0;"
                        })
                    }
                ]
            });
            return {
                tag: "g",
                attributes: {
                    "class": "missing"
                },
                children: gChildren
            };
        };
    }
};
var $a43d996a7aa8a839$var$SvgSymbols = {
    hooks: function hooks() {
        return {
            parseNodeAttributes: function parseNodeAttributes(accumulator, node) {
                var symbolData = node.getAttribute("data-fa-symbol");
                var symbol = symbolData === null ? false : symbolData === "" ? true : symbolData;
                accumulator["symbol"] = symbol;
                return accumulator;
            }
        };
    }
};
var $a43d996a7aa8a839$var$plugins = [
    $a43d996a7aa8a839$var$InjectCSS,
    $a43d996a7aa8a839$var$ReplaceElements,
    $a43d996a7aa8a839$var$Layers,
    $a43d996a7aa8a839$var$LayersCounter,
    $a43d996a7aa8a839$var$LayersText,
    $a43d996a7aa8a839$var$PseudoElements,
    $a43d996a7aa8a839$var$MutationObserver$1,
    $a43d996a7aa8a839$var$PowerTransforms,
    $a43d996a7aa8a839$var$Masks,
    $a43d996a7aa8a839$var$MissingIconIndicator,
    $a43d996a7aa8a839$var$SvgSymbols
];
$a43d996a7aa8a839$var$registerPlugins($a43d996a7aa8a839$var$plugins, {
    mixoutsTo: $a43d996a7aa8a839$export$644d8ea042df96a6
});
var $a43d996a7aa8a839$export$4f8e844b2782642c = $a43d996a7aa8a839$export$644d8ea042df96a6.noAuto;
var $a43d996a7aa8a839$export$e506a1d27d1eaa20 = $a43d996a7aa8a839$export$644d8ea042df96a6.config;
var $a43d996a7aa8a839$export$b839f963c7dc0e34 = $a43d996a7aa8a839$export$644d8ea042df96a6.library;
var $a43d996a7aa8a839$export$df3a06d6289f983e = $a43d996a7aa8a839$export$644d8ea042df96a6.dom;
var $a43d996a7aa8a839$export$98e6a39c04603d36 = $a43d996a7aa8a839$export$644d8ea042df96a6.parse;
var $a43d996a7aa8a839$export$221fed4a47f597a5 = $a43d996a7aa8a839$export$644d8ea042df96a6.findIconDefinition;
var $a43d996a7aa8a839$export$a10125c086a4df16 = $a43d996a7aa8a839$export$644d8ea042df96a6.toHtml;
var $a43d996a7aa8a839$export$1ca1ec8b29a4ce27 = $a43d996a7aa8a839$export$644d8ea042df96a6.icon;
var $a43d996a7aa8a839$export$50a222d9023da98b = $a43d996a7aa8a839$export$644d8ea042df96a6.layer;
var $a43d996a7aa8a839$export$6f093cfa640b7166 = $a43d996a7aa8a839$export$644d8ea042df96a6.text;
var $a43d996a7aa8a839$export$e575061ef2a070eb = $a43d996a7aa8a839$export$644d8ea042df96a6.counter;



var $c9Z8w = parcelRequire("c9Z8w");

var $acw62 = parcelRequire("acw62");
function $e4ec753f5c716375$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $e4ec753f5c716375$var$_objectSpread2(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $e4ec753f5c716375$var$ownKeys(Object(source), !0).forEach(function(key) {
            $e4ec753f5c716375$var$_defineProperty(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : $e4ec753f5c716375$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $e4ec753f5c716375$var$_typeof(obj) {
    "@babel/helpers - typeof";
    return $e4ec753f5c716375$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj) {
        return typeof obj;
    } : function(obj) {
        return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    }, $e4ec753f5c716375$var$_typeof(obj);
}
function $e4ec753f5c716375$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $e4ec753f5c716375$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function $e4ec753f5c716375$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $e4ec753f5c716375$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $e4ec753f5c716375$var$_toConsumableArray(arr) {
    return $e4ec753f5c716375$var$_arrayWithoutHoles(arr) || $e4ec753f5c716375$var$_iterableToArray(arr) || $e4ec753f5c716375$var$_unsupportedIterableToArray(arr) || $e4ec753f5c716375$var$_nonIterableSpread();
}
function $e4ec753f5c716375$var$_arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return $e4ec753f5c716375$var$_arrayLikeToArray(arr);
}
function $e4ec753f5c716375$var$_iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function $e4ec753f5c716375$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $e4ec753f5c716375$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $e4ec753f5c716375$var$_arrayLikeToArray(o, minLen);
}
function $e4ec753f5c716375$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $e4ec753f5c716375$var$_nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
// Get CSS class list from a props object
function $e4ec753f5c716375$var$classList(props) {
    var _classes;
    var beat = props.beat, fade = props.fade, beatFade = props.beatFade, bounce = props.bounce, shake = props.shake, flash = props.flash, spin = props.spin, spinPulse = props.spinPulse, spinReverse = props.spinReverse, pulse = props.pulse, fixedWidth = props.fixedWidth, inverse = props.inverse, border = props.border, listItem = props.listItem, flip = props.flip, size = props.size, rotation = props.rotation, pull = props.pull; // map of CSS class names to properties
    var classes = (_classes = {
        "fa-beat": beat,
        "fa-fade": fade,
        "fa-beat-fade": beatFade,
        "fa-bounce": bounce,
        "fa-shake": shake,
        "fa-flash": flash,
        "fa-spin": spin,
        "fa-spin-reverse": spinReverse,
        "fa-spin-pulse": spinPulse,
        "fa-pulse": pulse,
        "fa-fw": fixedWidth,
        "fa-inverse": inverse,
        "fa-border": border,
        "fa-li": listItem,
        "fa-flip": flip === true,
        "fa-flip-horizontal": flip === "horizontal" || flip === "both",
        "fa-flip-vertical": flip === "vertical" || flip === "both"
    }, $e4ec753f5c716375$var$_defineProperty(_classes, "fa-".concat(size), typeof size !== "undefined" && size !== null), $e4ec753f5c716375$var$_defineProperty(_classes, "fa-rotate-".concat(rotation), typeof rotation !== "undefined" && rotation !== null && rotation !== 0), $e4ec753f5c716375$var$_defineProperty(_classes, "fa-pull-".concat(pull), typeof pull !== "undefined" && pull !== null), $e4ec753f5c716375$var$_defineProperty(_classes, "fa-swap-opacity", props.swapOpacity), _classes); // map over all the keys in the classes object
    // return an array of the keys where the value for the key is not null
    return Object.keys(classes).map(function(key) {
        return classes[key] ? key : null;
    }).filter(function(key) {
        return key;
    });
}
// Camelize taken from humps
// humps is copyright © 2012+ Dom Christie
// Released under the MIT license.
// Performant way to determine if object coerces to a number
function $e4ec753f5c716375$var$_isNumerical(obj) {
    obj = obj - 0; // eslint-disable-next-line no-self-compare
    return obj === obj;
}
function $e4ec753f5c716375$var$camelize(string) {
    if ($e4ec753f5c716375$var$_isNumerical(string)) return string;
     // eslint-disable-next-line no-useless-escape
    string = string.replace(/[\-_\s]+(.)?/g, function(match, chr) {
        return chr ? chr.toUpperCase() : "";
    }); // Ensure 1st char is always lowercase
    return string.substr(0, 1).toLowerCase() + string.substr(1);
}
var $e4ec753f5c716375$var$_excluded = [
    "style"
];
function $e4ec753f5c716375$var$capitalize(val) {
    return val.charAt(0).toUpperCase() + val.slice(1);
}
function $e4ec753f5c716375$var$styleToObject(style) {
    return style.split(";").map(function(s) {
        return s.trim();
    }).filter(function(s) {
        return s;
    }).reduce(function(acc, pair) {
        var i = pair.indexOf(":");
        var prop = $e4ec753f5c716375$var$camelize(pair.slice(0, i));
        var value = pair.slice(i + 1).trim();
        prop.startsWith("webkit") ? acc[$e4ec753f5c716375$var$capitalize(prop)] = value : acc[prop] = value;
        return acc;
    }, {});
}
function $e4ec753f5c716375$var$convert(createElement, element) {
    var extraProps = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
    if (typeof element === "string") return element;
    var children = (element.children || []).map(function(child) {
        return $e4ec753f5c716375$var$convert(createElement, child);
    });
    /* eslint-disable dot-notation */ var mixins = Object.keys(element.attributes || {}).reduce(function(acc, key) {
        var val = element.attributes[key];
        switch(key){
            case "class":
                acc.attrs["className"] = val;
                delete element.attributes["class"];
                break;
            case "style":
                acc.attrs["style"] = $e4ec753f5c716375$var$styleToObject(val);
                break;
            default:
                if (key.indexOf("aria-") === 0 || key.indexOf("data-") === 0) acc.attrs[key.toLowerCase()] = val;
                else acc.attrs[$e4ec753f5c716375$var$camelize(key)] = val;
        }
        return acc;
    }, {
        attrs: {}
    });
    var _extraProps$style = extraProps.style, existingStyle = _extraProps$style === void 0 ? {} : _extraProps$style, remaining = $e4ec753f5c716375$var$_objectWithoutProperties(extraProps, $e4ec753f5c716375$var$_excluded);
    mixins.attrs["style"] = $e4ec753f5c716375$var$_objectSpread2($e4ec753f5c716375$var$_objectSpread2({}, mixins.attrs["style"]), existingStyle);
    /* eslint-enable */ return createElement.apply(void 0, [
        element.tag,
        $e4ec753f5c716375$var$_objectSpread2($e4ec753f5c716375$var$_objectSpread2({}, mixins.attrs), remaining)
    ].concat($e4ec753f5c716375$var$_toConsumableArray(children)));
}
var $e4ec753f5c716375$var$PRODUCTION = false;
try {
    $e4ec753f5c716375$var$PRODUCTION = true;
} catch (e) {}
function $e4ec753f5c716375$var$log() {
    if (!$e4ec753f5c716375$var$PRODUCTION && console && typeof console.error === "function") {
        var _console;
        (_console = console).error.apply(_console, arguments);
    }
}
function $e4ec753f5c716375$var$normalizeIconArgs(icon) {
    // this has everything that it needs to be rendered which means it was probably imported
    // directly from an icon svg package
    if (icon && $e4ec753f5c716375$var$_typeof(icon) === "object" && icon.prefix && icon.iconName && icon.icon) return icon;
    if ((0, $a43d996a7aa8a839$export$98e6a39c04603d36).icon) return (0, $a43d996a7aa8a839$export$98e6a39c04603d36).icon(icon);
     // if the icon is null, there's nothing to do
    if (icon === null) return null;
     // if the icon is an object and has a prefix and an icon name, return it
    if (icon && $e4ec753f5c716375$var$_typeof(icon) === "object" && icon.prefix && icon.iconName) return icon;
     // if it's an array with length of two
    if (Array.isArray(icon) && icon.length === 2) // use the first item as prefix, second as icon name
    return {
        prefix: icon[0],
        iconName: icon[1]
    };
     // if it's a string, use it as the icon name
    if (typeof icon === "string") return {
        prefix: "fas",
        iconName: icon
    };
}
// creates an object with a key of key
// and a value of value
// if certain conditions are met
function $e4ec753f5c716375$var$objectWithKey(key, value) {
    // if the value is a non-empty array
    // or it's not an array but it is truthy
    // then create the object with the key and the value
    // if not, return an empty array
    return Array.isArray(value) && value.length > 0 || !Array.isArray(value) && value ? $e4ec753f5c716375$var$_defineProperty({}, key, value) : {};
}
var $e4ec753f5c716375$export$2b9260d4a45c8710 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).forwardRef(function(props, ref) {
    var iconArgs = props.icon, maskArgs = props.mask, symbol = props.symbol, className = props.className, title = props.title, titleId = props.titleId, maskId = props.maskId;
    var iconLookup = $e4ec753f5c716375$var$normalizeIconArgs(iconArgs);
    var classes = $e4ec753f5c716375$var$objectWithKey("classes", [].concat($e4ec753f5c716375$var$_toConsumableArray($e4ec753f5c716375$var$classList(props)), $e4ec753f5c716375$var$_toConsumableArray(className.split(" "))));
    var transform = $e4ec753f5c716375$var$objectWithKey("transform", typeof props.transform === "string" ? (0, $a43d996a7aa8a839$export$98e6a39c04603d36).transform(props.transform) : props.transform);
    var mask = $e4ec753f5c716375$var$objectWithKey("mask", $e4ec753f5c716375$var$normalizeIconArgs(maskArgs));
    var renderedIcon = (0, $a43d996a7aa8a839$export$1ca1ec8b29a4ce27)(iconLookup, $e4ec753f5c716375$var$_objectSpread2($e4ec753f5c716375$var$_objectSpread2($e4ec753f5c716375$var$_objectSpread2($e4ec753f5c716375$var$_objectSpread2({}, classes), transform), mask), {}, {
        symbol: symbol,
        title: title,
        titleId: titleId,
        maskId: maskId
    }));
    if (!renderedIcon) {
        $e4ec753f5c716375$var$log("Could not find icon", iconLookup);
        return null;
    }
    var abstract = renderedIcon.abstract;
    var extraProps = {
        ref: ref
    };
    Object.keys(props).forEach(function(key) {
        // eslint-disable-next-line no-prototype-builtins
        if (!$e4ec753f5c716375$export$2b9260d4a45c8710.defaultProps.hasOwnProperty(key)) extraProps[key] = props[key];
    });
    return $e4ec753f5c716375$var$convertCurry(abstract[0], extraProps);
});
$e4ec753f5c716375$export$2b9260d4a45c8710.displayName = "FontAwesomeIcon";
$e4ec753f5c716375$export$2b9260d4a45c8710.propTypes = {
    beat: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
    border: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
    beatFade: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
    bounce: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
    className: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
    fade: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
    flash: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
    mask: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).object,
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).array,
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string
    ]),
    maskId: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
    fixedWidth: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
    inverse: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
    flip: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOf([
        true,
        false,
        "horizontal",
        "vertical",
        "both"
    ]),
    icon: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).object,
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).array,
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string
    ]),
    listItem: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
    pull: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOf([
        "right",
        "left"
    ]),
    pulse: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
    rotation: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOf([
        0,
        90,
        180,
        270
    ]),
    shake: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
    size: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOf([
        "2xs",
        "xs",
        "sm",
        "lg",
        "xl",
        "2xl",
        "1x",
        "2x",
        "3x",
        "4x",
        "5x",
        "6x",
        "7x",
        "8x",
        "9x",
        "10x"
    ]),
    spin: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
    spinPulse: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
    spinReverse: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
    symbol: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string
    ]),
    title: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
    titleId: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
    transform: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).object
    ]),
    swapOpacity: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool
};
$e4ec753f5c716375$export$2b9260d4a45c8710.defaultProps = {
    border: false,
    className: "",
    mask: null,
    maskId: null,
    fixedWidth: false,
    inverse: false,
    flip: false,
    icon: null,
    listItem: false,
    pull: null,
    pulse: false,
    rotation: null,
    size: null,
    spin: false,
    spinPulse: false,
    spinReverse: false,
    beat: false,
    fade: false,
    beatFade: false,
    bounce: false,
    shake: false,
    symbol: false,
    title: "",
    titleId: null,
    transform: null,
    swapOpacity: false
};
var $e4ec753f5c716375$var$convertCurry = $e4ec753f5c716375$var$convert.bind(null, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement);


parcelRequire("acw62");
var $f89d8ffbdc18f2ab$export$c9d39ca3bcd93abb;
var $f89d8ffbdc18f2ab$export$b791fe48eec8032a;
/*!
 *  howler.js v2.2.4
 *  howlerjs.com
 *
 *  (c) 2013-2020, James Simpson of GoldFire Studios
 *  goldfirestudios.com
 *
 *  MIT License
 */ (function() {
    "use strict";
    /** Global Methods **/ /***************************************************************************/ /**
   * Create the global controller. All contained methods and properties apply
   * to all sounds that are currently playing or will be in the future.
   */ var HowlerGlobal1 = function() {
        this.init();
    };
    HowlerGlobal1.prototype = {
        /**
     * Initialize the global Howler object.
     * @return {Howler}
     */ init: function() {
            var self = this || Howler1;
            // Create a global ID counter.
            self._counter = 1000;
            // Pool of unlocked HTML5 Audio objects.
            self._html5AudioPool = [];
            self.html5PoolSize = 10;
            // Internal properties.
            self._codecs = {};
            self._howls = [];
            self._muted = false;
            self._volume = 1;
            self._canPlayEvent = "canplaythrough";
            self._navigator = typeof window !== "undefined" && window.navigator ? window.navigator : null;
            // Public properties.
            self.masterGain = null;
            self.noAudio = false;
            self.usingWebAudio = true;
            self.autoSuspend = true;
            self.ctx = null;
            // Set to false to disable the auto audio unlocker.
            self.autoUnlock = true;
            // Setup the various state values for global tracking.
            self._setup();
            return self;
        },
        /**
     * Get/set the global volume for all sounds.
     * @param  {Float} vol Volume from 0.0 to 1.0.
     * @return {Howler/Float}     Returns self or current volume.
     */ volume: function(vol) {
            var self = this || Howler1;
            vol = parseFloat(vol);
            // If we don't have an AudioContext created yet, run the setup.
            if (!self.ctx) setupAudioContext();
            if (typeof vol !== "undefined" && vol >= 0 && vol <= 1) {
                self._volume = vol;
                // Don't update any of the nodes if we are muted.
                if (self._muted) return self;
                // When using Web Audio, we just need to adjust the master gain.
                if (self.usingWebAudio) self.masterGain.gain.setValueAtTime(vol, Howler1.ctx.currentTime);
                // Loop through and change volume for all HTML5 audio nodes.
                for(var i = 0; i < self._howls.length; i++)if (!self._howls[i]._webAudio) {
                    // Get all of the sounds in this Howl group.
                    var ids = self._howls[i]._getSoundIds();
                    // Loop through all sounds and change the volumes.
                    for(var j = 0; j < ids.length; j++){
                        var sound = self._howls[i]._soundById(ids[j]);
                        if (sound && sound._node) sound._node.volume = sound._volume * vol;
                    }
                }
                return self;
            }
            return self._volume;
        },
        /**
     * Handle muting and unmuting globally.
     * @param  {Boolean} muted Is muted or not.
     */ mute: function(muted) {
            var self = this || Howler1;
            // If we don't have an AudioContext created yet, run the setup.
            if (!self.ctx) setupAudioContext();
            self._muted = muted;
            // With Web Audio, we just need to mute the master gain.
            if (self.usingWebAudio) self.masterGain.gain.setValueAtTime(muted ? 0 : self._volume, Howler1.ctx.currentTime);
            // Loop through and mute all HTML5 Audio nodes.
            for(var i = 0; i < self._howls.length; i++)if (!self._howls[i]._webAudio) {
                // Get all of the sounds in this Howl group.
                var ids = self._howls[i]._getSoundIds();
                // Loop through all sounds and mark the audio node as muted.
                for(var j = 0; j < ids.length; j++){
                    var sound = self._howls[i]._soundById(ids[j]);
                    if (sound && sound._node) sound._node.muted = muted ? true : sound._muted;
                }
            }
            return self;
        },
        /**
     * Handle stopping all sounds globally.
     */ stop: function() {
            var self = this || Howler1;
            // Loop through all Howls and stop them.
            for(var i = 0; i < self._howls.length; i++)self._howls[i].stop();
            return self;
        },
        /**
     * Unload and destroy all currently loaded Howl objects.
     * @return {Howler}
     */ unload: function() {
            var self = this || Howler1;
            for(var i = self._howls.length - 1; i >= 0; i--)self._howls[i].unload();
            // Create a new AudioContext to make sure it is fully reset.
            if (self.usingWebAudio && self.ctx && typeof self.ctx.close !== "undefined") {
                self.ctx.close();
                self.ctx = null;
                setupAudioContext();
            }
            return self;
        },
        /**
     * Check for codec support of specific extension.
     * @param  {String} ext Audio file extention.
     * @return {Boolean}
     */ codecs: function(ext) {
            return (this || Howler1)._codecs[ext.replace(/^x-/, "")];
        },
        /**
     * Setup various state values for global tracking.
     * @return {Howler}
     */ _setup: function() {
            var self = this || Howler1;
            // Keeps track of the suspend/resume state of the AudioContext.
            self.state = self.ctx ? self.ctx.state || "suspended" : "suspended";
            // Automatically begin the 30-second suspend process
            self._autoSuspend();
            // Check if audio is available.
            if (!self.usingWebAudio) {
                // No audio is available on this system if noAudio is set to true.
                if (typeof Audio !== "undefined") try {
                    var test = new Audio();
                    // Check if the canplaythrough event is available.
                    if (typeof test.oncanplaythrough === "undefined") self._canPlayEvent = "canplay";
                } catch (e) {
                    self.noAudio = true;
                }
                else self.noAudio = true;
            }
            // Test to make sure audio isn't disabled in Internet Explorer.
            try {
                var test = new Audio();
                if (test.muted) self.noAudio = true;
            } catch (e) {}
            // Check for supported codecs.
            if (!self.noAudio) self._setupCodecs();
            return self;
        },
        /**
     * Check for browser support for various codecs and cache the results.
     * @return {Howler}
     */ _setupCodecs: function() {
            var self = this || Howler1;
            var audioTest = null;
            // Must wrap in a try/catch because IE11 in server mode throws an error.
            try {
                audioTest = typeof Audio !== "undefined" ? new Audio() : null;
            } catch (err) {
                return self;
            }
            if (!audioTest || typeof audioTest.canPlayType !== "function") return self;
            var mpegTest = audioTest.canPlayType("audio/mpeg;").replace(/^no$/, "");
            // Opera version <33 has mixed MP3 support, so we need to check for and block it.
            var ua = self._navigator ? self._navigator.userAgent : "";
            var checkOpera = ua.match(/OPR\/(\d+)/g);
            var isOldOpera = checkOpera && parseInt(checkOpera[0].split("/")[1], 10) < 33;
            var checkSafari = ua.indexOf("Safari") !== -1 && ua.indexOf("Chrome") === -1;
            var safariVersion = ua.match(/Version\/(.*?) /);
            var isOldSafari = checkSafari && safariVersion && parseInt(safariVersion[1], 10) < 15;
            self._codecs = {
                mp3: !!(!isOldOpera && (mpegTest || audioTest.canPlayType("audio/mp3;").replace(/^no$/, ""))),
                mpeg: !!mpegTest,
                opus: !!audioTest.canPlayType('audio/ogg; codecs="opus"').replace(/^no$/, ""),
                ogg: !!audioTest.canPlayType('audio/ogg; codecs="vorbis"').replace(/^no$/, ""),
                oga: !!audioTest.canPlayType('audio/ogg; codecs="vorbis"').replace(/^no$/, ""),
                wav: !!(audioTest.canPlayType('audio/wav; codecs="1"') || audioTest.canPlayType("audio/wav")).replace(/^no$/, ""),
                aac: !!audioTest.canPlayType("audio/aac;").replace(/^no$/, ""),
                caf: !!audioTest.canPlayType("audio/x-caf;").replace(/^no$/, ""),
                m4a: !!(audioTest.canPlayType("audio/x-m4a;") || audioTest.canPlayType("audio/m4a;") || audioTest.canPlayType("audio/aac;")).replace(/^no$/, ""),
                m4b: !!(audioTest.canPlayType("audio/x-m4b;") || audioTest.canPlayType("audio/m4b;") || audioTest.canPlayType("audio/aac;")).replace(/^no$/, ""),
                mp4: !!(audioTest.canPlayType("audio/x-mp4;") || audioTest.canPlayType("audio/mp4;") || audioTest.canPlayType("audio/aac;")).replace(/^no$/, ""),
                weba: !!(!isOldSafari && audioTest.canPlayType('audio/webm; codecs="vorbis"').replace(/^no$/, "")),
                webm: !!(!isOldSafari && audioTest.canPlayType('audio/webm; codecs="vorbis"').replace(/^no$/, "")),
                dolby: !!audioTest.canPlayType('audio/mp4; codecs="ec-3"').replace(/^no$/, ""),
                flac: !!(audioTest.canPlayType("audio/x-flac;") || audioTest.canPlayType("audio/flac;")).replace(/^no$/, "")
            };
            return self;
        },
        /**
     * Some browsers/devices will only allow audio to be played after a user interaction.
     * Attempt to automatically unlock audio on the first user interaction.
     * Concept from: http://paulbakaus.com/tutorials/html5/web-audio-on-ios/
     * @return {Howler}
     */ _unlockAudio: function() {
            var self = this || Howler1;
            // Only run this if Web Audio is supported and it hasn't already been unlocked.
            if (self._audioUnlocked || !self.ctx) return;
            self._audioUnlocked = false;
            self.autoUnlock = false;
            // Some mobile devices/platforms have distortion issues when opening/closing tabs and/or web views.
            // Bugs in the browser (especially Mobile Safari) can cause the sampleRate to change from 44100 to 48000.
            // By calling Howler.unload(), we create a new AudioContext with the correct sampleRate.
            if (!self._mobileUnloaded && self.ctx.sampleRate !== 44100) {
                self._mobileUnloaded = true;
                self.unload();
            }
            // Scratch buffer for enabling iOS to dispose of web audio buffers correctly, as per:
            // http://stackoverflow.com/questions/24119684
            self._scratchBuffer = self.ctx.createBuffer(1, 1, 22050);
            // Call this method on touch start to create and play a buffer,
            // then check if the audio actually played to determine if
            // audio has now been unlocked on iOS, Android, etc.
            var unlock = function(e) {
                // Create a pool of unlocked HTML5 Audio objects that can
                // be used for playing sounds without user interaction. HTML5
                // Audio objects must be individually unlocked, as opposed
                // to the WebAudio API which only needs a single activation.
                // This must occur before WebAudio setup or the source.onended
                // event will not fire.
                while(self._html5AudioPool.length < self.html5PoolSize)try {
                    var audioNode = new Audio();
                    // Mark this Audio object as unlocked to ensure it can get returned
                    // to the unlocked pool when released.
                    audioNode._unlocked = true;
                    // Add the audio node to the pool.
                    self._releaseHtml5Audio(audioNode);
                } catch (e) {
                    self.noAudio = true;
                    break;
                }
                // Loop through any assigned audio nodes and unlock them.
                for(var i = 0; i < self._howls.length; i++)if (!self._howls[i]._webAudio) {
                    // Get all of the sounds in this Howl group.
                    var ids = self._howls[i]._getSoundIds();
                    // Loop through all sounds and unlock the audio nodes.
                    for(var j = 0; j < ids.length; j++){
                        var sound = self._howls[i]._soundById(ids[j]);
                        if (sound && sound._node && !sound._node._unlocked) {
                            sound._node._unlocked = true;
                            sound._node.load();
                        }
                    }
                }
                // Fix Android can not play in suspend state.
                self._autoResume();
                // Create an empty buffer.
                var source = self.ctx.createBufferSource();
                source.buffer = self._scratchBuffer;
                source.connect(self.ctx.destination);
                // Play the empty buffer.
                if (typeof source.start === "undefined") source.noteOn(0);
                else source.start(0);
                // Calling resume() on a stack initiated by user gesture is what actually unlocks the audio on Android Chrome >= 55.
                if (typeof self.ctx.resume === "function") self.ctx.resume();
                // Setup a timeout to check that we are unlocked on the next event loop.
                source.onended = function() {
                    source.disconnect(0);
                    // Update the unlocked state and prevent this check from happening again.
                    self._audioUnlocked = true;
                    // Remove the touch start listener.
                    document.removeEventListener("touchstart", unlock, true);
                    document.removeEventListener("touchend", unlock, true);
                    document.removeEventListener("click", unlock, true);
                    document.removeEventListener("keydown", unlock, true);
                    // Let all sounds know that audio has been unlocked.
                    for(var i = 0; i < self._howls.length; i++)self._howls[i]._emit("unlock");
                };
            };
            // Setup a touch start listener to attempt an unlock in.
            document.addEventListener("touchstart", unlock, true);
            document.addEventListener("touchend", unlock, true);
            document.addEventListener("click", unlock, true);
            document.addEventListener("keydown", unlock, true);
            return self;
        },
        /**
     * Get an unlocked HTML5 Audio object from the pool. If none are left,
     * return a new Audio object and throw a warning.
     * @return {Audio} HTML5 Audio object.
     */ _obtainHtml5Audio: function() {
            var self = this || Howler1;
            // Return the next object from the pool if one exists.
            if (self._html5AudioPool.length) return self._html5AudioPool.pop();
            //.Check if the audio is locked and throw a warning.
            var testPlay = new Audio().play();
            if (testPlay && typeof Promise !== "undefined" && (testPlay instanceof Promise || typeof testPlay.then === "function")) testPlay.catch(function() {
                console.warn("HTML5 Audio pool exhausted, returning potentially locked audio object.");
            });
            return new Audio();
        },
        /**
     * Return an activated HTML5 Audio object to the pool.
     * @return {Howler}
     */ _releaseHtml5Audio: function(audio) {
            var self = this || Howler1;
            // Don't add audio to the pool if we don't know if it has been unlocked.
            if (audio._unlocked) self._html5AudioPool.push(audio);
            return self;
        },
        /**
     * Automatically suspend the Web Audio AudioContext after no sound has played for 30 seconds.
     * This saves processing/energy and fixes various browser-specific bugs with audio getting stuck.
     * @return {Howler}
     */ _autoSuspend: function() {
            var self = this;
            if (!self.autoSuspend || !self.ctx || typeof self.ctx.suspend === "undefined" || !Howler1.usingWebAudio) return;
            // Check if any sounds are playing.
            for(var i = 0; i < self._howls.length; i++){
                if (self._howls[i]._webAudio) for(var j = 0; j < self._howls[i]._sounds.length; j++){
                    if (!self._howls[i]._sounds[j]._paused) return self;
                }
            }
            if (self._suspendTimer) clearTimeout(self._suspendTimer);
            // If no sound has played after 30 seconds, suspend the context.
            self._suspendTimer = setTimeout(function() {
                if (!self.autoSuspend) return;
                self._suspendTimer = null;
                self.state = "suspending";
                // Handle updating the state of the audio context after suspending.
                var handleSuspension = function() {
                    self.state = "suspended";
                    if (self._resumeAfterSuspend) {
                        delete self._resumeAfterSuspend;
                        self._autoResume();
                    }
                };
                // Either the state gets suspended or it is interrupted.
                // Either way, we need to update the state to suspended.
                self.ctx.suspend().then(handleSuspension, handleSuspension);
            }, 30000);
            return self;
        },
        /**
     * Automatically resume the Web Audio AudioContext when a new sound is played.
     * @return {Howler}
     */ _autoResume: function() {
            var self = this;
            if (!self.ctx || typeof self.ctx.resume === "undefined" || !Howler1.usingWebAudio) return;
            if (self.state === "running" && self.ctx.state !== "interrupted" && self._suspendTimer) {
                clearTimeout(self._suspendTimer);
                self._suspendTimer = null;
            } else if (self.state === "suspended" || self.state === "running" && self.ctx.state === "interrupted") {
                self.ctx.resume().then(function() {
                    self.state = "running";
                    // Emit to all Howls that the audio has resumed.
                    for(var i = 0; i < self._howls.length; i++)self._howls[i]._emit("resume");
                });
                if (self._suspendTimer) {
                    clearTimeout(self._suspendTimer);
                    self._suspendTimer = null;
                }
            } else if (self.state === "suspending") self._resumeAfterSuspend = true;
            return self;
        }
    };
    // Setup the global audio controller.
    var Howler1 = new HowlerGlobal1();
    /** Group Methods **/ /***************************************************************************/ /**
   * Create an audio group controller.
   * @param {Object} o Passed in properties for this group.
   */ var Howl1 = function(o) {
        var self = this;
        // Throw an error if no source is provided.
        if (!o.src || o.src.length === 0) {
            console.error("An array of source files must be passed with any new Howl.");
            return;
        }
        self.init(o);
    };
    Howl1.prototype = {
        /**
     * Initialize a new Howl group object.
     * @param  {Object} o Passed in properties for this group.
     * @return {Howl}
     */ init: function(o) {
            var self = this;
            // If we don't have an AudioContext created yet, run the setup.
            if (!Howler1.ctx) setupAudioContext();
            // Setup user-defined default properties.
            self._autoplay = o.autoplay || false;
            self._format = typeof o.format !== "string" ? o.format : [
                o.format
            ];
            self._html5 = o.html5 || false;
            self._muted = o.mute || false;
            self._loop = o.loop || false;
            self._pool = o.pool || 5;
            self._preload = typeof o.preload === "boolean" || o.preload === "metadata" ? o.preload : true;
            self._rate = o.rate || 1;
            self._sprite = o.sprite || {};
            self._src = typeof o.src !== "string" ? o.src : [
                o.src
            ];
            self._volume = o.volume !== undefined ? o.volume : 1;
            self._xhr = {
                method: o.xhr && o.xhr.method ? o.xhr.method : "GET",
                headers: o.xhr && o.xhr.headers ? o.xhr.headers : null,
                withCredentials: o.xhr && o.xhr.withCredentials ? o.xhr.withCredentials : false
            };
            // Setup all other default properties.
            self._duration = 0;
            self._state = "unloaded";
            self._sounds = [];
            self._endTimers = {};
            self._queue = [];
            self._playLock = false;
            // Setup event listeners.
            self._onend = o.onend ? [
                {
                    fn: o.onend
                }
            ] : [];
            self._onfade = o.onfade ? [
                {
                    fn: o.onfade
                }
            ] : [];
            self._onload = o.onload ? [
                {
                    fn: o.onload
                }
            ] : [];
            self._onloaderror = o.onloaderror ? [
                {
                    fn: o.onloaderror
                }
            ] : [];
            self._onplayerror = o.onplayerror ? [
                {
                    fn: o.onplayerror
                }
            ] : [];
            self._onpause = o.onpause ? [
                {
                    fn: o.onpause
                }
            ] : [];
            self._onplay = o.onplay ? [
                {
                    fn: o.onplay
                }
            ] : [];
            self._onstop = o.onstop ? [
                {
                    fn: o.onstop
                }
            ] : [];
            self._onmute = o.onmute ? [
                {
                    fn: o.onmute
                }
            ] : [];
            self._onvolume = o.onvolume ? [
                {
                    fn: o.onvolume
                }
            ] : [];
            self._onrate = o.onrate ? [
                {
                    fn: o.onrate
                }
            ] : [];
            self._onseek = o.onseek ? [
                {
                    fn: o.onseek
                }
            ] : [];
            self._onunlock = o.onunlock ? [
                {
                    fn: o.onunlock
                }
            ] : [];
            self._onresume = [];
            // Web Audio or HTML5 Audio?
            self._webAudio = Howler1.usingWebAudio && !self._html5;
            // Automatically try to enable audio.
            if (typeof Howler1.ctx !== "undefined" && Howler1.ctx && Howler1.autoUnlock) Howler1._unlockAudio();
            // Keep track of this Howl group in the global controller.
            Howler1._howls.push(self);
            // If they selected autoplay, add a play event to the load queue.
            if (self._autoplay) self._queue.push({
                event: "play",
                action: function() {
                    self.play();
                }
            });
            // Load the source file unless otherwise specified.
            if (self._preload && self._preload !== "none") self.load();
            return self;
        },
        /**
     * Load the audio file.
     * @return {Howler}
     */ load: function() {
            var self = this;
            var url = null;
            // If no audio is available, quit immediately.
            if (Howler1.noAudio) {
                self._emit("loaderror", null, "No audio support.");
                return;
            }
            // Make sure our source is in an array.
            if (typeof self._src === "string") self._src = [
                self._src
            ];
            // Loop through the sources and pick the first one that is compatible.
            for(var i = 0; i < self._src.length; i++){
                var ext, str;
                if (self._format && self._format[i]) // If an extension was specified, use that instead.
                ext = self._format[i];
                else {
                    // Make sure the source is a string.
                    str = self._src[i];
                    if (typeof str !== "string") {
                        self._emit("loaderror", null, "Non-string found in selected audio sources - ignoring.");
                        continue;
                    }
                    // Extract the file extension from the URL or base64 data URI.
                    ext = /^data:audio\/([^;,]+);/i.exec(str);
                    if (!ext) ext = /\.([^.]+)$/.exec(str.split("?", 1)[0]);
                    if (ext) ext = ext[1].toLowerCase();
                }
                // Log a warning if no extension was found.
                if (!ext) console.warn('No file extension was found. Consider using the "format" property or specify an extension.');
                // Check if this extension is available.
                if (ext && Howler1.codecs(ext)) {
                    url = self._src[i];
                    break;
                }
            }
            if (!url) {
                self._emit("loaderror", null, "No codec support for selected audio sources.");
                return;
            }
            self._src = url;
            self._state = "loading";
            // If the hosting page is HTTPS and the source isn't,
            // drop down to HTML5 Audio to avoid Mixed Content errors.
            if (window.location.protocol === "https:" && url.slice(0, 5) === "http:") {
                self._html5 = true;
                self._webAudio = false;
            }
            // Create a new sound object and add it to the pool.
            new Sound1(self);
            // Load and decode the audio data for playback.
            if (self._webAudio) loadBuffer(self);
            return self;
        },
        /**
     * Play a sound or resume previous playback.
     * @param  {String/Number} sprite   Sprite name for sprite playback or sound id to continue previous.
     * @param  {Boolean} internal Internal Use: true prevents event firing.
     * @return {Number}          Sound ID.
     */ play: function(sprite, internal) {
            var self = this;
            var id = null;
            // Determine if a sprite, sound id or nothing was passed
            if (typeof sprite === "number") {
                id = sprite;
                sprite = null;
            } else if (typeof sprite === "string" && self._state === "loaded" && !self._sprite[sprite]) // If the passed sprite doesn't exist, do nothing.
            return null;
            else if (typeof sprite === "undefined") {
                // Use the default sound sprite (plays the full audio length).
                sprite = "__default";
                // Check if there is a single paused sound that isn't ended.
                // If there is, play that sound. If not, continue as usual.
                if (!self._playLock) {
                    var num = 0;
                    for(var i = 0; i < self._sounds.length; i++)if (self._sounds[i]._paused && !self._sounds[i]._ended) {
                        num++;
                        id = self._sounds[i]._id;
                    }
                    if (num === 1) sprite = null;
                    else id = null;
                }
            }
            // Get the selected node, or get one from the pool.
            var sound = id ? self._soundById(id) : self._inactiveSound();
            // If the sound doesn't exist, do nothing.
            if (!sound) return null;
            // Select the sprite definition.
            if (id && !sprite) sprite = sound._sprite || "__default";
            // If the sound hasn't loaded, we must wait to get the audio's duration.
            // We also need to wait to make sure we don't run into race conditions with
            // the order of function calls.
            if (self._state !== "loaded") {
                // Set the sprite value on this sound.
                sound._sprite = sprite;
                // Mark this sound as not ended in case another sound is played before this one loads.
                sound._ended = false;
                // Add the sound to the queue to be played on load.
                var soundId = sound._id;
                self._queue.push({
                    event: "play",
                    action: function() {
                        self.play(soundId);
                    }
                });
                return soundId;
            }
            // Don't play the sound if an id was passed and it is already playing.
            if (id && !sound._paused) {
                // Trigger the play event, in order to keep iterating through queue.
                if (!internal) self._loadQueue("play");
                return sound._id;
            }
            // Make sure the AudioContext isn't suspended, and resume it if it is.
            if (self._webAudio) Howler1._autoResume();
            // Determine how long to play for and where to start playing.
            var seek = Math.max(0, sound._seek > 0 ? sound._seek : self._sprite[sprite][0] / 1000);
            var duration = Math.max(0, (self._sprite[sprite][0] + self._sprite[sprite][1]) / 1000 - seek);
            var timeout = duration * 1000 / Math.abs(sound._rate);
            var start = self._sprite[sprite][0] / 1000;
            var stop = (self._sprite[sprite][0] + self._sprite[sprite][1]) / 1000;
            sound._sprite = sprite;
            // Mark the sound as ended instantly so that this async playback
            // doesn't get grabbed by another call to play while this one waits to start.
            sound._ended = false;
            // Update the parameters of the sound.
            var setParams = function() {
                sound._paused = false;
                sound._seek = seek;
                sound._start = start;
                sound._stop = stop;
                sound._loop = !!(sound._loop || self._sprite[sprite][2]);
            };
            // End the sound instantly if seek is at the end.
            if (seek >= stop) {
                self._ended(sound);
                return;
            }
            // Begin the actual playback.
            var node = sound._node;
            if (self._webAudio) {
                // Fire this when the sound is ready to play to begin Web Audio playback.
                var playWebAudio = function() {
                    self._playLock = false;
                    setParams();
                    self._refreshBuffer(sound);
                    // Setup the playback params.
                    var vol = sound._muted || self._muted ? 0 : sound._volume;
                    node.gain.setValueAtTime(vol, Howler1.ctx.currentTime);
                    sound._playStart = Howler1.ctx.currentTime;
                    // Play the sound using the supported method.
                    if (typeof node.bufferSource.start === "undefined") sound._loop ? node.bufferSource.noteGrainOn(0, seek, 86400) : node.bufferSource.noteGrainOn(0, seek, duration);
                    else sound._loop ? node.bufferSource.start(0, seek, 86400) : node.bufferSource.start(0, seek, duration);
                    // Start a new timer if none is present.
                    if (timeout !== Infinity) self._endTimers[sound._id] = setTimeout(self._ended.bind(self, sound), timeout);
                    if (!internal) setTimeout(function() {
                        self._emit("play", sound._id);
                        self._loadQueue();
                    }, 0);
                };
                if (Howler1.state === "running" && Howler1.ctx.state !== "interrupted") playWebAudio();
                else {
                    self._playLock = true;
                    // Wait for the audio context to resume before playing.
                    self.once("resume", playWebAudio);
                    // Cancel the end timer.
                    self._clearTimer(sound._id);
                }
            } else {
                // Fire this when the sound is ready to play to begin HTML5 Audio playback.
                var playHtml5 = function() {
                    node.currentTime = seek;
                    node.muted = sound._muted || self._muted || Howler1._muted || node.muted;
                    node.volume = sound._volume * Howler1.volume();
                    node.playbackRate = sound._rate;
                    // Some browsers will throw an error if this is called without user interaction.
                    try {
                        var play = node.play();
                        // Support older browsers that don't support promises, and thus don't have this issue.
                        if (play && typeof Promise !== "undefined" && (play instanceof Promise || typeof play.then === "function")) {
                            // Implements a lock to prevent DOMException: The play() request was interrupted by a call to pause().
                            self._playLock = true;
                            // Set param values immediately.
                            setParams();
                            // Releases the lock and executes queued actions.
                            play.then(function() {
                                self._playLock = false;
                                node._unlocked = true;
                                if (!internal) self._emit("play", sound._id);
                                else self._loadQueue();
                            }).catch(function() {
                                self._playLock = false;
                                self._emit("playerror", sound._id, "Playback was unable to start. This is most commonly an issue on mobile devices and Chrome where playback was not within a user interaction.");
                                // Reset the ended and paused values.
                                sound._ended = true;
                                sound._paused = true;
                            });
                        } else if (!internal) {
                            self._playLock = false;
                            setParams();
                            self._emit("play", sound._id);
                        }
                        // Setting rate before playing won't work in IE, so we set it again here.
                        node.playbackRate = sound._rate;
                        // If the node is still paused, then we can assume there was a playback issue.
                        if (node.paused) {
                            self._emit("playerror", sound._id, "Playback was unable to start. This is most commonly an issue on mobile devices and Chrome where playback was not within a user interaction.");
                            return;
                        }
                        // Setup the end timer on sprites or listen for the ended event.
                        if (sprite !== "__default" || sound._loop) self._endTimers[sound._id] = setTimeout(self._ended.bind(self, sound), timeout);
                        else {
                            self._endTimers[sound._id] = function() {
                                // Fire ended on this audio node.
                                self._ended(sound);
                                // Clear this listener.
                                node.removeEventListener("ended", self._endTimers[sound._id], false);
                            };
                            node.addEventListener("ended", self._endTimers[sound._id], false);
                        }
                    } catch (err) {
                        self._emit("playerror", sound._id, err);
                    }
                };
                // If this is streaming audio, make sure the src is set and load again.
                if (node.src === "data:audio/wav;base64,UklGRigAAABXQVZFZm10IBIAAAABAAEARKwAAIhYAQACABAAAABkYXRhAgAAAAEA") {
                    node.src = self._src;
                    node.load();
                }
                // Play immediately if ready, or wait for the 'canplaythrough'e vent.
                var loadedNoReadyState = window && window.ejecta || !node.readyState && Howler1._navigator.isCocoonJS;
                if (node.readyState >= 3 || loadedNoReadyState) playHtml5();
                else {
                    self._playLock = true;
                    self._state = "loading";
                    var listener = function() {
                        self._state = "loaded";
                        // Begin playback.
                        playHtml5();
                        // Clear this listener.
                        node.removeEventListener(Howler1._canPlayEvent, listener, false);
                    };
                    node.addEventListener(Howler1._canPlayEvent, listener, false);
                    // Cancel the end timer.
                    self._clearTimer(sound._id);
                }
            }
            return sound._id;
        },
        /**
     * Pause playback and save current position.
     * @param  {Number} id The sound ID (empty to pause all in group).
     * @return {Howl}
     */ pause: function(id) {
            var self = this;
            // If the sound hasn't loaded or a play() promise is pending, add it to the load queue to pause when capable.
            if (self._state !== "loaded" || self._playLock) {
                self._queue.push({
                    event: "pause",
                    action: function() {
                        self.pause(id);
                    }
                });
                return self;
            }
            // If no id is passed, get all ID's to be paused.
            var ids = self._getSoundIds(id);
            for(var i = 0; i < ids.length; i++){
                // Clear the end timer.
                self._clearTimer(ids[i]);
                // Get the sound.
                var sound = self._soundById(ids[i]);
                if (sound && !sound._paused) {
                    // Reset the seek position.
                    sound._seek = self.seek(ids[i]);
                    sound._rateSeek = 0;
                    sound._paused = true;
                    // Stop currently running fades.
                    self._stopFade(ids[i]);
                    if (sound._node) {
                        if (self._webAudio) {
                            // Make sure the sound has been created.
                            if (!sound._node.bufferSource) continue;
                            if (typeof sound._node.bufferSource.stop === "undefined") sound._node.bufferSource.noteOff(0);
                            else sound._node.bufferSource.stop(0);
                            // Clean up the buffer source.
                            self._cleanBuffer(sound._node);
                        } else if (!isNaN(sound._node.duration) || sound._node.duration === Infinity) sound._node.pause();
                    }
                }
                // Fire the pause event, unless `true` is passed as the 2nd argument.
                if (!arguments[1]) self._emit("pause", sound ? sound._id : null);
            }
            return self;
        },
        /**
     * Stop playback and reset to start.
     * @param  {Number} id The sound ID (empty to stop all in group).
     * @param  {Boolean} internal Internal Use: true prevents event firing.
     * @return {Howl}
     */ stop: function(id, internal) {
            var self = this;
            // If the sound hasn't loaded, add it to the load queue to stop when capable.
            if (self._state !== "loaded" || self._playLock) {
                self._queue.push({
                    event: "stop",
                    action: function() {
                        self.stop(id);
                    }
                });
                return self;
            }
            // If no id is passed, get all ID's to be stopped.
            var ids = self._getSoundIds(id);
            for(var i = 0; i < ids.length; i++){
                // Clear the end timer.
                self._clearTimer(ids[i]);
                // Get the sound.
                var sound = self._soundById(ids[i]);
                if (sound) {
                    // Reset the seek position.
                    sound._seek = sound._start || 0;
                    sound._rateSeek = 0;
                    sound._paused = true;
                    sound._ended = true;
                    // Stop currently running fades.
                    self._stopFade(ids[i]);
                    if (sound._node) {
                        if (self._webAudio) // Make sure the sound's AudioBufferSourceNode has been created.
                        {
                            if (sound._node.bufferSource) {
                                if (typeof sound._node.bufferSource.stop === "undefined") sound._node.bufferSource.noteOff(0);
                                else sound._node.bufferSource.stop(0);
                                // Clean up the buffer source.
                                self._cleanBuffer(sound._node);
                            }
                        } else if (!isNaN(sound._node.duration) || sound._node.duration === Infinity) {
                            sound._node.currentTime = sound._start || 0;
                            sound._node.pause();
                            // If this is a live stream, stop download once the audio is stopped.
                            if (sound._node.duration === Infinity) self._clearSound(sound._node);
                        }
                    }
                    if (!internal) self._emit("stop", sound._id);
                }
            }
            return self;
        },
        /**
     * Mute/unmute a single sound or all sounds in this Howl group.
     * @param  {Boolean} muted Set to true to mute and false to unmute.
     * @param  {Number} id    The sound ID to update (omit to mute/unmute all).
     * @return {Howl}
     */ mute: function(muted, id) {
            var self = this;
            // If the sound hasn't loaded, add it to the load queue to mute when capable.
            if (self._state !== "loaded" || self._playLock) {
                self._queue.push({
                    event: "mute",
                    action: function() {
                        self.mute(muted, id);
                    }
                });
                return self;
            }
            // If applying mute/unmute to all sounds, update the group's value.
            if (typeof id === "undefined") {
                if (typeof muted === "boolean") self._muted = muted;
                else return self._muted;
            }
            // If no id is passed, get all ID's to be muted.
            var ids = self._getSoundIds(id);
            for(var i = 0; i < ids.length; i++){
                // Get the sound.
                var sound = self._soundById(ids[i]);
                if (sound) {
                    sound._muted = muted;
                    // Cancel active fade and set the volume to the end value.
                    if (sound._interval) self._stopFade(sound._id);
                    if (self._webAudio && sound._node) sound._node.gain.setValueAtTime(muted ? 0 : sound._volume, Howler1.ctx.currentTime);
                    else if (sound._node) sound._node.muted = Howler1._muted ? true : muted;
                    self._emit("mute", sound._id);
                }
            }
            return self;
        },
        /**
     * Get/set the volume of this sound or of the Howl group. This method can optionally take 0, 1 or 2 arguments.
     *   volume() -> Returns the group's volume value.
     *   volume(id) -> Returns the sound id's current volume.
     *   volume(vol) -> Sets the volume of all sounds in this Howl group.
     *   volume(vol, id) -> Sets the volume of passed sound id.
     * @return {Howl/Number} Returns self or current volume.
     */ volume: function() {
            var self = this;
            var args = arguments;
            var vol, id;
            // Determine the values based on arguments.
            if (args.length === 0) // Return the value of the groups' volume.
            return self._volume;
            else if (args.length === 1 || args.length === 2 && typeof args[1] === "undefined") {
                // First check if this is an ID, and if not, assume it is a new volume.
                var ids = self._getSoundIds();
                var index = ids.indexOf(args[0]);
                if (index >= 0) id = parseInt(args[0], 10);
                else vol = parseFloat(args[0]);
            } else if (args.length >= 2) {
                vol = parseFloat(args[0]);
                id = parseInt(args[1], 10);
            }
            // Update the volume or return the current volume.
            var sound;
            if (typeof vol !== "undefined" && vol >= 0 && vol <= 1) {
                // If the sound hasn't loaded, add it to the load queue to change volume when capable.
                if (self._state !== "loaded" || self._playLock) {
                    self._queue.push({
                        event: "volume",
                        action: function() {
                            self.volume.apply(self, args);
                        }
                    });
                    return self;
                }
                // Set the group volume.
                if (typeof id === "undefined") self._volume = vol;
                // Update one or all volumes.
                id = self._getSoundIds(id);
                for(var i = 0; i < id.length; i++){
                    // Get the sound.
                    sound = self._soundById(id[i]);
                    if (sound) {
                        sound._volume = vol;
                        // Stop currently running fades.
                        if (!args[2]) self._stopFade(id[i]);
                        if (self._webAudio && sound._node && !sound._muted) sound._node.gain.setValueAtTime(vol, Howler1.ctx.currentTime);
                        else if (sound._node && !sound._muted) sound._node.volume = vol * Howler1.volume();
                        self._emit("volume", sound._id);
                    }
                }
            } else {
                sound = id ? self._soundById(id) : self._sounds[0];
                return sound ? sound._volume : 0;
            }
            return self;
        },
        /**
     * Fade a currently playing sound between two volumes (if no id is passed, all sounds will fade).
     * @param  {Number} from The value to fade from (0.0 to 1.0).
     * @param  {Number} to   The volume to fade to (0.0 to 1.0).
     * @param  {Number} len  Time in milliseconds to fade.
     * @param  {Number} id   The sound id (omit to fade all sounds).
     * @return {Howl}
     */ fade: function(from, to, len, id) {
            var self = this;
            // If the sound hasn't loaded, add it to the load queue to fade when capable.
            if (self._state !== "loaded" || self._playLock) {
                self._queue.push({
                    event: "fade",
                    action: function() {
                        self.fade(from, to, len, id);
                    }
                });
                return self;
            }
            // Make sure the to/from/len values are numbers.
            from = Math.min(Math.max(0, parseFloat(from)), 1);
            to = Math.min(Math.max(0, parseFloat(to)), 1);
            len = parseFloat(len);
            // Set the volume to the start position.
            self.volume(from, id);
            // Fade the volume of one or all sounds.
            var ids = self._getSoundIds(id);
            for(var i = 0; i < ids.length; i++){
                // Get the sound.
                var sound = self._soundById(ids[i]);
                // Create a linear fade or fall back to timeouts with HTML5 Audio.
                if (sound) {
                    // Stop the previous fade if no sprite is being used (otherwise, volume handles this).
                    if (!id) self._stopFade(ids[i]);
                    // If we are using Web Audio, let the native methods do the actual fade.
                    if (self._webAudio && !sound._muted) {
                        var currentTime = Howler1.ctx.currentTime;
                        var end = currentTime + len / 1000;
                        sound._volume = from;
                        sound._node.gain.setValueAtTime(from, currentTime);
                        sound._node.gain.linearRampToValueAtTime(to, end);
                    }
                    self._startFadeInterval(sound, from, to, len, ids[i], typeof id === "undefined");
                }
            }
            return self;
        },
        /**
     * Starts the internal interval to fade a sound.
     * @param  {Object} sound Reference to sound to fade.
     * @param  {Number} from The value to fade from (0.0 to 1.0).
     * @param  {Number} to   The volume to fade to (0.0 to 1.0).
     * @param  {Number} len  Time in milliseconds to fade.
     * @param  {Number} id   The sound id to fade.
     * @param  {Boolean} isGroup   If true, set the volume on the group.
     */ _startFadeInterval: function(sound, from, to, len, id, isGroup) {
            var self = this;
            var vol = from;
            var diff = to - from;
            var steps = Math.abs(diff / 0.01);
            var stepLen = Math.max(4, steps > 0 ? len / steps : len);
            var lastTick = Date.now();
            // Store the value being faded to.
            sound._fadeTo = to;
            // Update the volume value on each interval tick.
            sound._interval = setInterval(function() {
                // Update the volume based on the time since the last tick.
                var tick = (Date.now() - lastTick) / len;
                lastTick = Date.now();
                vol += diff * tick;
                // Round to within 2 decimal points.
                vol = Math.round(vol * 100) / 100;
                // Make sure the volume is in the right bounds.
                if (diff < 0) vol = Math.max(to, vol);
                else vol = Math.min(to, vol);
                // Change the volume.
                if (self._webAudio) sound._volume = vol;
                else self.volume(vol, sound._id, true);
                // Set the group's volume.
                if (isGroup) self._volume = vol;
                // When the fade is complete, stop it and fire event.
                if (to < from && vol <= to || to > from && vol >= to) {
                    clearInterval(sound._interval);
                    sound._interval = null;
                    sound._fadeTo = null;
                    self.volume(to, sound._id);
                    self._emit("fade", sound._id);
                }
            }, stepLen);
        },
        /**
     * Internal method that stops the currently playing fade when
     * a new fade starts, volume is changed or the sound is stopped.
     * @param  {Number} id The sound id.
     * @return {Howl}
     */ _stopFade: function(id) {
            var self = this;
            var sound = self._soundById(id);
            if (sound && sound._interval) {
                if (self._webAudio) sound._node.gain.cancelScheduledValues(Howler1.ctx.currentTime);
                clearInterval(sound._interval);
                sound._interval = null;
                self.volume(sound._fadeTo, id);
                sound._fadeTo = null;
                self._emit("fade", id);
            }
            return self;
        },
        /**
     * Get/set the loop parameter on a sound. This method can optionally take 0, 1 or 2 arguments.
     *   loop() -> Returns the group's loop value.
     *   loop(id) -> Returns the sound id's loop value.
     *   loop(loop) -> Sets the loop value for all sounds in this Howl group.
     *   loop(loop, id) -> Sets the loop value of passed sound id.
     * @return {Howl/Boolean} Returns self or current loop value.
     */ loop: function() {
            var self = this;
            var args = arguments;
            var loop, id, sound;
            // Determine the values for loop and id.
            if (args.length === 0) // Return the grou's loop value.
            return self._loop;
            else if (args.length === 1) {
                if (typeof args[0] === "boolean") {
                    loop = args[0];
                    self._loop = loop;
                } else {
                    // Return this sound's loop value.
                    sound = self._soundById(parseInt(args[0], 10));
                    return sound ? sound._loop : false;
                }
            } else if (args.length === 2) {
                loop = args[0];
                id = parseInt(args[1], 10);
            }
            // If no id is passed, get all ID's to be looped.
            var ids = self._getSoundIds(id);
            for(var i = 0; i < ids.length; i++){
                sound = self._soundById(ids[i]);
                if (sound) {
                    sound._loop = loop;
                    if (self._webAudio && sound._node && sound._node.bufferSource) {
                        sound._node.bufferSource.loop = loop;
                        if (loop) {
                            sound._node.bufferSource.loopStart = sound._start || 0;
                            sound._node.bufferSource.loopEnd = sound._stop;
                            // If playing, restart playback to ensure looping updates.
                            if (self.playing(ids[i])) {
                                self.pause(ids[i], true);
                                self.play(ids[i], true);
                            }
                        }
                    }
                }
            }
            return self;
        },
        /**
     * Get/set the playback rate of a sound. This method can optionally take 0, 1 or 2 arguments.
     *   rate() -> Returns the first sound node's current playback rate.
     *   rate(id) -> Returns the sound id's current playback rate.
     *   rate(rate) -> Sets the playback rate of all sounds in this Howl group.
     *   rate(rate, id) -> Sets the playback rate of passed sound id.
     * @return {Howl/Number} Returns self or the current playback rate.
     */ rate: function() {
            var self = this;
            var args = arguments;
            var rate, id;
            // Determine the values based on arguments.
            if (args.length === 0) // We will simply return the current rate of the first node.
            id = self._sounds[0]._id;
            else if (args.length === 1) {
                // First check if this is an ID, and if not, assume it is a new rate value.
                var ids = self._getSoundIds();
                var index = ids.indexOf(args[0]);
                if (index >= 0) id = parseInt(args[0], 10);
                else rate = parseFloat(args[0]);
            } else if (args.length === 2) {
                rate = parseFloat(args[0]);
                id = parseInt(args[1], 10);
            }
            // Update the playback rate or return the current value.
            var sound;
            if (typeof rate === "number") {
                // If the sound hasn't loaded, add it to the load queue to change playback rate when capable.
                if (self._state !== "loaded" || self._playLock) {
                    self._queue.push({
                        event: "rate",
                        action: function() {
                            self.rate.apply(self, args);
                        }
                    });
                    return self;
                }
                // Set the group rate.
                if (typeof id === "undefined") self._rate = rate;
                // Update one or all volumes.
                id = self._getSoundIds(id);
                for(var i = 0; i < id.length; i++){
                    // Get the sound.
                    sound = self._soundById(id[i]);
                    if (sound) {
                        // Keep track of our position when the rate changed and update the playback
                        // start position so we can properly adjust the seek position for time elapsed.
                        if (self.playing(id[i])) {
                            sound._rateSeek = self.seek(id[i]);
                            sound._playStart = self._webAudio ? Howler1.ctx.currentTime : sound._playStart;
                        }
                        sound._rate = rate;
                        // Change the playback rate.
                        if (self._webAudio && sound._node && sound._node.bufferSource) sound._node.bufferSource.playbackRate.setValueAtTime(rate, Howler1.ctx.currentTime);
                        else if (sound._node) sound._node.playbackRate = rate;
                        // Reset the timers.
                        var seek = self.seek(id[i]);
                        var duration = (self._sprite[sound._sprite][0] + self._sprite[sound._sprite][1]) / 1000 - seek;
                        var timeout = duration * 1000 / Math.abs(sound._rate);
                        // Start a new end timer if sound is already playing.
                        if (self._endTimers[id[i]] || !sound._paused) {
                            self._clearTimer(id[i]);
                            self._endTimers[id[i]] = setTimeout(self._ended.bind(self, sound), timeout);
                        }
                        self._emit("rate", sound._id);
                    }
                }
            } else {
                sound = self._soundById(id);
                return sound ? sound._rate : self._rate;
            }
            return self;
        },
        /**
     * Get/set the seek position of a sound. This method can optionally take 0, 1 or 2 arguments.
     *   seek() -> Returns the first sound node's current seek position.
     *   seek(id) -> Returns the sound id's current seek position.
     *   seek(seek) -> Sets the seek position of the first sound node.
     *   seek(seek, id) -> Sets the seek position of passed sound id.
     * @return {Howl/Number} Returns self or the current seek position.
     */ seek: function() {
            var self = this;
            var args = arguments;
            var seek, id;
            // Determine the values based on arguments.
            if (args.length === 0) // We will simply return the current position of the first node.
            {
                if (self._sounds.length) id = self._sounds[0]._id;
            } else if (args.length === 1) {
                // First check if this is an ID, and if not, assume it is a new seek position.
                var ids = self._getSoundIds();
                var index = ids.indexOf(args[0]);
                if (index >= 0) id = parseInt(args[0], 10);
                else if (self._sounds.length) {
                    id = self._sounds[0]._id;
                    seek = parseFloat(args[0]);
                }
            } else if (args.length === 2) {
                seek = parseFloat(args[0]);
                id = parseInt(args[1], 10);
            }
            // If there is no ID, bail out.
            if (typeof id === "undefined") return 0;
            // If the sound hasn't loaded, add it to the load queue to seek when capable.
            if (typeof seek === "number" && (self._state !== "loaded" || self._playLock)) {
                self._queue.push({
                    event: "seek",
                    action: function() {
                        self.seek.apply(self, args);
                    }
                });
                return self;
            }
            // Get the sound.
            var sound = self._soundById(id);
            if (sound) {
                if (typeof seek === "number" && seek >= 0) {
                    // Pause the sound and update position for restarting playback.
                    var playing = self.playing(id);
                    if (playing) self.pause(id, true);
                    // Move the position of the track and cancel timer.
                    sound._seek = seek;
                    sound._ended = false;
                    self._clearTimer(id);
                    // Update the seek position for HTML5 Audio.
                    if (!self._webAudio && sound._node && !isNaN(sound._node.duration)) sound._node.currentTime = seek;
                    // Seek and emit when ready.
                    var seekAndEmit = function() {
                        // Restart the playback if the sound was playing.
                        if (playing) self.play(id, true);
                        self._emit("seek", id);
                    };
                    // Wait for the play lock to be unset before emitting (HTML5 Audio).
                    if (playing && !self._webAudio) {
                        var emitSeek = function() {
                            if (!self._playLock) seekAndEmit();
                            else setTimeout(emitSeek, 0);
                        };
                        setTimeout(emitSeek, 0);
                    } else seekAndEmit();
                } else {
                    if (self._webAudio) {
                        var realTime = self.playing(id) ? Howler1.ctx.currentTime - sound._playStart : 0;
                        var rateSeek = sound._rateSeek ? sound._rateSeek - sound._seek : 0;
                        return sound._seek + (rateSeek + realTime * Math.abs(sound._rate));
                    } else return sound._node.currentTime;
                }
            }
            return self;
        },
        /**
     * Check if a specific sound is currently playing or not (if id is provided), or check if at least one of the sounds in the group is playing or not.
     * @param  {Number}  id The sound id to check. If none is passed, the whole sound group is checked.
     * @return {Boolean} True if playing and false if not.
     */ playing: function(id) {
            var self = this;
            // Check the passed sound ID (if any).
            if (typeof id === "number") {
                var sound = self._soundById(id);
                return sound ? !sound._paused : false;
            }
            // Otherwise, loop through all sounds and check if any are playing.
            for(var i = 0; i < self._sounds.length; i++){
                if (!self._sounds[i]._paused) return true;
            }
            return false;
        },
        /**
     * Get the duration of this sound. Passing a sound id will return the sprite duration.
     * @param  {Number} id The sound id to check. If none is passed, return full source duration.
     * @return {Number} Audio duration in seconds.
     */ duration: function(id) {
            var self = this;
            var duration = self._duration;
            // If we pass an ID, get the sound and return the sprite length.
            var sound = self._soundById(id);
            if (sound) duration = self._sprite[sound._sprite][1] / 1000;
            return duration;
        },
        /**
     * Returns the current loaded state of this Howl.
     * @return {String} 'unloaded', 'loading', 'loaded'
     */ state: function() {
            return this._state;
        },
        /**
     * Unload and destroy the current Howl object.
     * This will immediately stop all sound instances attached to this group.
     */ unload: function() {
            var self = this;
            // Stop playing any active sounds.
            var sounds = self._sounds;
            for(var i = 0; i < sounds.length; i++){
                // Stop the sound if it is currently playing.
                if (!sounds[i]._paused) self.stop(sounds[i]._id);
                // Remove the source or disconnect.
                if (!self._webAudio) {
                    // Set the source to 0-second silence to stop any downloading (except in IE).
                    self._clearSound(sounds[i]._node);
                    // Remove any event listeners.
                    sounds[i]._node.removeEventListener("error", sounds[i]._errorFn, false);
                    sounds[i]._node.removeEventListener(Howler1._canPlayEvent, sounds[i]._loadFn, false);
                    sounds[i]._node.removeEventListener("ended", sounds[i]._endFn, false);
                    // Release the Audio object back to the pool.
                    Howler1._releaseHtml5Audio(sounds[i]._node);
                }
                // Empty out all of the nodes.
                delete sounds[i]._node;
                // Make sure all timers are cleared out.
                self._clearTimer(sounds[i]._id);
            }
            // Remove the references in the global Howler object.
            var index = Howler1._howls.indexOf(self);
            if (index >= 0) Howler1._howls.splice(index, 1);
            // Delete this sound from the cache (if no other Howl is using it).
            var remCache = true;
            for(i = 0; i < Howler1._howls.length; i++)if (Howler1._howls[i]._src === self._src || self._src.indexOf(Howler1._howls[i]._src) >= 0) {
                remCache = false;
                break;
            }
            if (cache && remCache) delete cache[self._src];
            // Clear global errors.
            Howler1.noAudio = false;
            // Clear out `self`.
            self._state = "unloaded";
            self._sounds = [];
            self = null;
            return null;
        },
        /**
     * Listen to a custom event.
     * @param  {String}   event Event name.
     * @param  {Function} fn    Listener to call.
     * @param  {Number}   id    (optional) Only listen to events for this sound.
     * @param  {Number}   once  (INTERNAL) Marks event to fire only once.
     * @return {Howl}
     */ on: function(event, fn, id, once) {
            var self = this;
            var events = self["_on" + event];
            if (typeof fn === "function") events.push(once ? {
                id: id,
                fn: fn,
                once: once
            } : {
                id: id,
                fn: fn
            });
            return self;
        },
        /**
     * Remove a custom event. Call without parameters to remove all events.
     * @param  {String}   event Event name.
     * @param  {Function} fn    Listener to remove. Leave empty to remove all.
     * @param  {Number}   id    (optional) Only remove events for this sound.
     * @return {Howl}
     */ off: function(event, fn, id) {
            var self = this;
            var events = self["_on" + event];
            var i = 0;
            // Allow passing just an event and ID.
            if (typeof fn === "number") {
                id = fn;
                fn = null;
            }
            if (fn || id) // Loop through event store and remove the passed function.
            for(i = 0; i < events.length; i++){
                var isId = id === events[i].id;
                if (fn === events[i].fn && isId || !fn && isId) {
                    events.splice(i, 1);
                    break;
                }
            }
            else if (event) // Clear out all events of this type.
            self["_on" + event] = [];
            else {
                // Clear out all events of every type.
                var keys = Object.keys(self);
                for(i = 0; i < keys.length; i++)if (keys[i].indexOf("_on") === 0 && Array.isArray(self[keys[i]])) self[keys[i]] = [];
            }
            return self;
        },
        /**
     * Listen to a custom event and remove it once fired.
     * @param  {String}   event Event name.
     * @param  {Function} fn    Listener to call.
     * @param  {Number}   id    (optional) Only listen to events for this sound.
     * @return {Howl}
     */ once: function(event, fn, id) {
            var self = this;
            // Setup the event listener.
            self.on(event, fn, id, 1);
            return self;
        },
        /**
     * Emit all events of a specific type and pass the sound id.
     * @param  {String} event Event name.
     * @param  {Number} id    Sound ID.
     * @param  {Number} msg   Message to go with event.
     * @return {Howl}
     */ _emit: function(event, id, msg) {
            var self = this;
            var events = self["_on" + event];
            // Loop through event store and fire all functions.
            for(var i = events.length - 1; i >= 0; i--)// Only fire the listener if the correct ID is used.
            if (!events[i].id || events[i].id === id || event === "load") {
                setTimeout((function(fn) {
                    fn.call(this, id, msg);
                }).bind(self, events[i].fn), 0);
                // If this event was setup with `once`, remove it.
                if (events[i].once) self.off(event, events[i].fn, events[i].id);
            }
            // Pass the event type into load queue so that it can continue stepping.
            self._loadQueue(event);
            return self;
        },
        /**
     * Queue of actions initiated before the sound has loaded.
     * These will be called in sequence, with the next only firing
     * after the previous has finished executing (even if async like play).
     * @return {Howl}
     */ _loadQueue: function(event) {
            var self = this;
            if (self._queue.length > 0) {
                var task = self._queue[0];
                // Remove this task if a matching event was passed.
                if (task.event === event) {
                    self._queue.shift();
                    self._loadQueue();
                }
                // Run the task if no event type is passed.
                if (!event) task.action();
            }
            return self;
        },
        /**
     * Fired when playback ends at the end of the duration.
     * @param  {Sound} sound The sound object to work with.
     * @return {Howl}
     */ _ended: function(sound) {
            var self = this;
            var sprite = sound._sprite;
            // If we are using IE and there was network latency we may be clipping
            // audio before it completes playing. Lets check the node to make sure it
            // believes it has completed, before ending the playback.
            if (!self._webAudio && sound._node && !sound._node.paused && !sound._node.ended && sound._node.currentTime < sound._stop) {
                setTimeout(self._ended.bind(self, sound), 100);
                return self;
            }
            // Should this sound loop?
            var loop = !!(sound._loop || self._sprite[sprite][2]);
            // Fire the ended event.
            self._emit("end", sound._id);
            // Restart the playback for HTML5 Audio loop.
            if (!self._webAudio && loop) self.stop(sound._id, true).play(sound._id);
            // Restart this timer if on a Web Audio loop.
            if (self._webAudio && loop) {
                self._emit("play", sound._id);
                sound._seek = sound._start || 0;
                sound._rateSeek = 0;
                sound._playStart = Howler1.ctx.currentTime;
                var timeout = (sound._stop - sound._start) * 1000 / Math.abs(sound._rate);
                self._endTimers[sound._id] = setTimeout(self._ended.bind(self, sound), timeout);
            }
            // Mark the node as paused.
            if (self._webAudio && !loop) {
                sound._paused = true;
                sound._ended = true;
                sound._seek = sound._start || 0;
                sound._rateSeek = 0;
                self._clearTimer(sound._id);
                // Clean up the buffer source.
                self._cleanBuffer(sound._node);
                // Attempt to auto-suspend AudioContext if no sounds are still playing.
                Howler1._autoSuspend();
            }
            // When using a sprite, end the track.
            if (!self._webAudio && !loop) self.stop(sound._id, true);
            return self;
        },
        /**
     * Clear the end timer for a sound playback.
     * @param  {Number} id The sound ID.
     * @return {Howl}
     */ _clearTimer: function(id) {
            var self = this;
            if (self._endTimers[id]) {
                // Clear the timeout or remove the ended listener.
                if (typeof self._endTimers[id] !== "function") clearTimeout(self._endTimers[id]);
                else {
                    var sound = self._soundById(id);
                    if (sound && sound._node) sound._node.removeEventListener("ended", self._endTimers[id], false);
                }
                delete self._endTimers[id];
            }
            return self;
        },
        /**
     * Return the sound identified by this ID, or return null.
     * @param  {Number} id Sound ID
     * @return {Object}    Sound object or null.
     */ _soundById: function(id) {
            var self = this;
            // Loop through all sounds and find the one with this ID.
            for(var i = 0; i < self._sounds.length; i++){
                if (id === self._sounds[i]._id) return self._sounds[i];
            }
            return null;
        },
        /**
     * Return an inactive sound from the pool or create a new one.
     * @return {Sound} Sound playback object.
     */ _inactiveSound: function() {
            var self = this;
            self._drain();
            // Find the first inactive node to recycle.
            for(var i = 0; i < self._sounds.length; i++){
                if (self._sounds[i]._ended) return self._sounds[i].reset();
            }
            // If no inactive node was found, create a new one.
            return new Sound1(self);
        },
        /**
     * Drain excess inactive sounds from the pool.
     */ _drain: function() {
            var self = this;
            var limit = self._pool;
            var cnt = 0;
            var i = 0;
            // If there are less sounds than the max pool size, we are done.
            if (self._sounds.length < limit) return;
            // Count the number of inactive sounds.
            for(i = 0; i < self._sounds.length; i++)if (self._sounds[i]._ended) cnt++;
            // Remove excess inactive sounds, going in reverse order.
            for(i = self._sounds.length - 1; i >= 0; i--){
                if (cnt <= limit) return;
                if (self._sounds[i]._ended) {
                    // Disconnect the audio source when using Web Audio.
                    if (self._webAudio && self._sounds[i]._node) self._sounds[i]._node.disconnect(0);
                    // Remove sounds until we have the pool size.
                    self._sounds.splice(i, 1);
                    cnt--;
                }
            }
        },
        /**
     * Get all ID's from the sounds pool.
     * @param  {Number} id Only return one ID if one is passed.
     * @return {Array}    Array of IDs.
     */ _getSoundIds: function(id) {
            var self = this;
            if (typeof id === "undefined") {
                var ids = [];
                for(var i = 0; i < self._sounds.length; i++)ids.push(self._sounds[i]._id);
                return ids;
            } else return [
                id
            ];
        },
        /**
     * Load the sound back into the buffer source.
     * @param  {Sound} sound The sound object to work with.
     * @return {Howl}
     */ _refreshBuffer: function(sound) {
            var self = this;
            // Setup the buffer source for playback.
            sound._node.bufferSource = Howler1.ctx.createBufferSource();
            sound._node.bufferSource.buffer = cache[self._src];
            // Connect to the correct node.
            if (sound._panner) sound._node.bufferSource.connect(sound._panner);
            else sound._node.bufferSource.connect(sound._node);
            // Setup looping and playback rate.
            sound._node.bufferSource.loop = sound._loop;
            if (sound._loop) {
                sound._node.bufferSource.loopStart = sound._start || 0;
                sound._node.bufferSource.loopEnd = sound._stop || 0;
            }
            sound._node.bufferSource.playbackRate.setValueAtTime(sound._rate, Howler1.ctx.currentTime);
            return self;
        },
        /**
     * Prevent memory leaks by cleaning up the buffer source after playback.
     * @param  {Object} node Sound's audio node containing the buffer source.
     * @return {Howl}
     */ _cleanBuffer: function(node) {
            var self = this;
            var isIOS = Howler1._navigator && Howler1._navigator.vendor.indexOf("Apple") >= 0;
            if (!node.bufferSource) return self;
            if (Howler1._scratchBuffer && node.bufferSource) {
                node.bufferSource.onended = null;
                node.bufferSource.disconnect(0);
                if (isIOS) try {
                    node.bufferSource.buffer = Howler1._scratchBuffer;
                } catch (e) {}
            }
            node.bufferSource = null;
            return self;
        },
        /**
     * Set the source to a 0-second silence to stop any downloading (except in IE).
     * @param  {Object} node Audio node to clear.
     */ _clearSound: function(node) {
            var checkIE = /MSIE |Trident\//.test(Howler1._navigator && Howler1._navigator.userAgent);
            if (!checkIE) node.src = "data:audio/wav;base64,UklGRigAAABXQVZFZm10IBIAAAABAAEARKwAAIhYAQACABAAAABkYXRhAgAAAAEA";
        }
    };
    /** Single Sound Methods **/ /***************************************************************************/ /**
   * Setup the sound object, which each node attached to a Howl group is contained in.
   * @param {Object} howl The Howl parent group.
   */ var Sound1 = function(howl) {
        this._parent = howl;
        this.init();
    };
    Sound1.prototype = {
        /**
     * Initialize a new Sound object.
     * @return {Sound}
     */ init: function() {
            var self = this;
            var parent = self._parent;
            // Setup the default parameters.
            self._muted = parent._muted;
            self._loop = parent._loop;
            self._volume = parent._volume;
            self._rate = parent._rate;
            self._seek = 0;
            self._paused = true;
            self._ended = true;
            self._sprite = "__default";
            // Generate a unique ID for this sound.
            self._id = ++Howler1._counter;
            // Add itself to the parent's pool.
            parent._sounds.push(self);
            // Create the new node.
            self.create();
            return self;
        },
        /**
     * Create and setup a new sound object, whether HTML5 Audio or Web Audio.
     * @return {Sound}
     */ create: function() {
            var self = this;
            var parent = self._parent;
            var volume = Howler1._muted || self._muted || self._parent._muted ? 0 : self._volume;
            if (parent._webAudio) {
                // Create the gain node for controlling volume (the source will connect to this).
                self._node = typeof Howler1.ctx.createGain === "undefined" ? Howler1.ctx.createGainNode() : Howler1.ctx.createGain();
                self._node.gain.setValueAtTime(volume, Howler1.ctx.currentTime);
                self._node.paused = true;
                self._node.connect(Howler1.masterGain);
            } else if (!Howler1.noAudio) {
                // Get an unlocked Audio object from the pool.
                self._node = Howler1._obtainHtml5Audio();
                // Listen for errors (http://dev.w3.org/html5/spec-author-view/spec.html#mediaerror).
                self._errorFn = self._errorListener.bind(self);
                self._node.addEventListener("error", self._errorFn, false);
                // Listen for 'canplaythrough' event to let us know the sound is ready.
                self._loadFn = self._loadListener.bind(self);
                self._node.addEventListener(Howler1._canPlayEvent, self._loadFn, false);
                // Listen for the 'ended' event on the sound to account for edge-case where
                // a finite sound has a duration of Infinity.
                self._endFn = self._endListener.bind(self);
                self._node.addEventListener("ended", self._endFn, false);
                // Setup the new audio node.
                self._node.src = parent._src;
                self._node.preload = parent._preload === true ? "auto" : parent._preload;
                self._node.volume = volume * Howler1.volume();
                // Begin loading the source.
                self._node.load();
            }
            return self;
        },
        /**
     * Reset the parameters of this sound to the original state (for recycle).
     * @return {Sound}
     */ reset: function() {
            var self = this;
            var parent = self._parent;
            // Reset all of the parameters of this sound.
            self._muted = parent._muted;
            self._loop = parent._loop;
            self._volume = parent._volume;
            self._rate = parent._rate;
            self._seek = 0;
            self._rateSeek = 0;
            self._paused = true;
            self._ended = true;
            self._sprite = "__default";
            // Generate a new ID so that it isn't confused with the previous sound.
            self._id = ++Howler1._counter;
            return self;
        },
        /**
     * HTML5 Audio error listener callback.
     */ _errorListener: function() {
            var self = this;
            // Fire an error event and pass back the code.
            self._parent._emit("loaderror", self._id, self._node.error ? self._node.error.code : 0);
            // Clear the event listener.
            self._node.removeEventListener("error", self._errorFn, false);
        },
        /**
     * HTML5 Audio canplaythrough listener callback.
     */ _loadListener: function() {
            var self = this;
            var parent = self._parent;
            // Round up the duration to account for the lower precision in HTML5 Audio.
            parent._duration = Math.ceil(self._node.duration * 10) / 10;
            // Setup a sprite if none is defined.
            if (Object.keys(parent._sprite).length === 0) parent._sprite = {
                __default: [
                    0,
                    parent._duration * 1000
                ]
            };
            if (parent._state !== "loaded") {
                parent._state = "loaded";
                parent._emit("load");
                parent._loadQueue();
            }
            // Clear the event listener.
            self._node.removeEventListener(Howler1._canPlayEvent, self._loadFn, false);
        },
        /**
     * HTML5 Audio ended listener callback.
     */ _endListener: function() {
            var self = this;
            var parent = self._parent;
            // Only handle the `ended`` event if the duration is Infinity.
            if (parent._duration === Infinity) {
                // Update the parent duration to match the real audio duration.
                // Round up the duration to account for the lower precision in HTML5 Audio.
                parent._duration = Math.ceil(self._node.duration * 10) / 10;
                // Update the sprite that corresponds to the real duration.
                if (parent._sprite.__default[1] === Infinity) parent._sprite.__default[1] = parent._duration * 1000;
                // Run the regular ended method.
                parent._ended(self);
            }
            // Clear the event listener since the duration is now correct.
            self._node.removeEventListener("ended", self._endFn, false);
        }
    };
    /** Helper Methods **/ /***************************************************************************/ var cache = {};
    /**
   * Buffer a sound from URL, Data URI or cache and decode to audio source (Web Audio API).
   * @param  {Howl} self
   */ var loadBuffer = function(self) {
        var url = self._src;
        // Check if the buffer has already been cached and use it instead.
        if (cache[url]) {
            // Set the duration from the cache.
            self._duration = cache[url].duration;
            // Load the sound into this Howl.
            loadSound(self);
            return;
        }
        if (/^data:[^;]+;base64,/.test(url)) {
            // Decode the base64 data URI without XHR, since some browsers don't support it.
            var data = atob(url.split(",")[1]);
            var dataView = new Uint8Array(data.length);
            for(var i = 0; i < data.length; ++i)dataView[i] = data.charCodeAt(i);
            decodeAudioData(dataView.buffer, self);
        } else {
            // Load the buffer from the URL.
            var xhr = new XMLHttpRequest();
            xhr.open(self._xhr.method, url, true);
            xhr.withCredentials = self._xhr.withCredentials;
            xhr.responseType = "arraybuffer";
            // Apply any custom headers to the request.
            if (self._xhr.headers) Object.keys(self._xhr.headers).forEach(function(key) {
                xhr.setRequestHeader(key, self._xhr.headers[key]);
            });
            xhr.onload = function() {
                // Make sure we get a successful response back.
                var code = (xhr.status + "")[0];
                if (code !== "0" && code !== "2" && code !== "3") {
                    self._emit("loaderror", null, "Failed loading audio file with status: " + xhr.status + ".");
                    return;
                }
                decodeAudioData(xhr.response, self);
            };
            xhr.onerror = function() {
                // If there is an error, switch to HTML5 Audio.
                if (self._webAudio) {
                    self._html5 = true;
                    self._webAudio = false;
                    self._sounds = [];
                    delete cache[url];
                    self.load();
                }
            };
            safeXhrSend(xhr);
        }
    };
    /**
   * Send the XHR request wrapped in a try/catch.
   * @param  {Object} xhr XHR to send.
   */ var safeXhrSend = function(xhr) {
        try {
            xhr.send();
        } catch (e) {
            xhr.onerror();
        }
    };
    /**
   * Decode audio data from an array buffer.
   * @param  {ArrayBuffer} arraybuffer The audio data.
   * @param  {Howl}        self
   */ var decodeAudioData = function(arraybuffer, self) {
        // Fire a load error if something broke.
        var error = function() {
            self._emit("loaderror", null, "Decoding audio data failed.");
        };
        // Load the sound on success.
        var success = function(buffer) {
            if (buffer && self._sounds.length > 0) {
                cache[self._src] = buffer;
                loadSound(self, buffer);
            } else error();
        };
        // Decode the buffer into an audio source.
        if (typeof Promise !== "undefined" && Howler1.ctx.decodeAudioData.length === 1) Howler1.ctx.decodeAudioData(arraybuffer).then(success).catch(error);
        else Howler1.ctx.decodeAudioData(arraybuffer, success, error);
    };
    /**
   * Sound is now loaded, so finish setting everything up and fire the loaded event.
   * @param  {Howl} self
   * @param  {Object} buffer The decoded buffer sound source.
   */ var loadSound = function(self, buffer) {
        // Set the duration.
        if (buffer && !self._duration) self._duration = buffer.duration;
        // Setup a sprite if none is defined.
        if (Object.keys(self._sprite).length === 0) self._sprite = {
            __default: [
                0,
                self._duration * 1000
            ]
        };
        // Fire the loaded event.
        if (self._state !== "loaded") {
            self._state = "loaded";
            self._emit("load");
            self._loadQueue();
        }
    };
    /**
   * Setup the audio context when available, or switch to HTML5 Audio mode.
   */ var setupAudioContext = function() {
        // If we have already detected that Web Audio isn't supported, don't run this step again.
        if (!Howler1.usingWebAudio) return;
        // Check if we are using Web Audio and setup the AudioContext if we are.
        try {
            if (typeof AudioContext !== "undefined") Howler1.ctx = new AudioContext();
            else if (typeof webkitAudioContext !== "undefined") Howler1.ctx = new webkitAudioContext();
            else Howler1.usingWebAudio = false;
        } catch (e) {
            Howler1.usingWebAudio = false;
        }
        // If the audio context creation still failed, set using web audio to false.
        if (!Howler1.ctx) Howler1.usingWebAudio = false;
        // Check if a webview is being used on iOS8 or earlier (rather than the browser).
        // If it is, disable Web Audio as it causes crashing.
        var iOS = /iP(hone|od|ad)/.test(Howler1._navigator && Howler1._navigator.platform);
        var appVersion = Howler1._navigator && Howler1._navigator.appVersion.match(/OS (\d+)_(\d+)_?(\d+)?/);
        var version = appVersion ? parseInt(appVersion[1], 10) : null;
        if (iOS && version && version < 9) {
            var safari = /safari/.test(Howler1._navigator && Howler1._navigator.userAgent.toLowerCase());
            if (Howler1._navigator && !safari) Howler1.usingWebAudio = false;
        }
        // Create and expose the master GainNode when using Web Audio (useful for plugins or advanced usage).
        if (Howler1.usingWebAudio) {
            Howler1.masterGain = typeof Howler1.ctx.createGain === "undefined" ? Howler1.ctx.createGainNode() : Howler1.ctx.createGain();
            Howler1.masterGain.gain.setValueAtTime(Howler1._muted ? 0 : Howler1._volume, Howler1.ctx.currentTime);
            Howler1.masterGain.connect(Howler1.ctx.destination);
        }
        // Re-run the setup on Howler.
        Howler1._setup();
    };
    // Add support for AMD (Asynchronous Module Definition) libraries such as require.js.
    if (typeof define === "function" && define.amd) define([], function() {
        return {
            Howler: Howler1,
            Howl: Howl1
        };
    });
    $f89d8ffbdc18f2ab$export$c9d39ca3bcd93abb = Howler1;
    $f89d8ffbdc18f2ab$export$b791fe48eec8032a = Howl1;
    // Add to global in Node.js (for testing, etc).
    if (typeof $parcel$global !== "undefined") {
        $parcel$global.HowlerGlobal = HowlerGlobal1;
        $parcel$global.Howler = Howler1;
        $parcel$global.Howl = Howl1;
        $parcel$global.Sound = Sound1;
    } else if (typeof window !== "undefined") {
        window.HowlerGlobal = HowlerGlobal1;
        window.Howler = Howler1;
        window.Howl = Howl1;
        window.Sound = Sound1;
    }
})();
/*!
 *  Spatial Plugin - Adds support for stereo and 3D audio where Web Audio is supported.
 *  
 *  howler.js v2.2.4
 *  howlerjs.com
 *
 *  (c) 2013-2020, James Simpson of GoldFire Studios
 *  goldfirestudios.com
 *
 *  MIT License
 */ (function() {
    "use strict";
    // Setup default properties.
    HowlerGlobal.prototype._pos = [
        0,
        0,
        0
    ];
    HowlerGlobal.prototype._orientation = [
        0,
        0,
        -1,
        0,
        1,
        0
    ];
    /** Global Methods **/ /***************************************************************************/ /**
   * Helper method to update the stereo panning position of all current Howls.
   * Future Howls will not use this value unless explicitly set.
   * @param  {Number} pan A value of -1.0 is all the way left and 1.0 is all the way right.
   * @return {Howler/Number}     Self or current stereo panning value.
   */ HowlerGlobal.prototype.stereo = function(pan) {
        var self = this;
        // Stop right here if not using Web Audio.
        if (!self.ctx || !self.ctx.listener) return self;
        // Loop through all Howls and update their stereo panning.
        for(var i = self._howls.length - 1; i >= 0; i--)self._howls[i].stereo(pan);
        return self;
    };
    /**
   * Get/set the position of the listener in 3D cartesian space. Sounds using
   * 3D position will be relative to the listener's position.
   * @param  {Number} x The x-position of the listener.
   * @param  {Number} y The y-position of the listener.
   * @param  {Number} z The z-position of the listener.
   * @return {Howler/Array}   Self or current listener position.
   */ HowlerGlobal.prototype.pos = function(x, y, z) {
        var self = this;
        // Stop right here if not using Web Audio.
        if (!self.ctx || !self.ctx.listener) return self;
        // Set the defaults for optional 'y' & 'z'.
        y = typeof y !== "number" ? self._pos[1] : y;
        z = typeof z !== "number" ? self._pos[2] : z;
        if (typeof x === "number") {
            self._pos = [
                x,
                y,
                z
            ];
            if (typeof self.ctx.listener.positionX !== "undefined") {
                self.ctx.listener.positionX.setTargetAtTime(self._pos[0], Howler.ctx.currentTime, 0.1);
                self.ctx.listener.positionY.setTargetAtTime(self._pos[1], Howler.ctx.currentTime, 0.1);
                self.ctx.listener.positionZ.setTargetAtTime(self._pos[2], Howler.ctx.currentTime, 0.1);
            } else self.ctx.listener.setPosition(self._pos[0], self._pos[1], self._pos[2]);
        } else return self._pos;
        return self;
    };
    /**
   * Get/set the direction the listener is pointing in the 3D cartesian space.
   * A front and up vector must be provided. The front is the direction the
   * face of the listener is pointing, and up is the direction the top of the
   * listener is pointing. Thus, these values are expected to be at right angles
   * from each other.
   * @param  {Number} x   The x-orientation of the listener.
   * @param  {Number} y   The y-orientation of the listener.
   * @param  {Number} z   The z-orientation of the listener.
   * @param  {Number} xUp The x-orientation of the top of the listener.
   * @param  {Number} yUp The y-orientation of the top of the listener.
   * @param  {Number} zUp The z-orientation of the top of the listener.
   * @return {Howler/Array}     Returns self or the current orientation vectors.
   */ HowlerGlobal.prototype.orientation = function(x, y, z, xUp, yUp, zUp) {
        var self = this;
        // Stop right here if not using Web Audio.
        if (!self.ctx || !self.ctx.listener) return self;
        // Set the defaults for optional 'y' & 'z'.
        var or = self._orientation;
        y = typeof y !== "number" ? or[1] : y;
        z = typeof z !== "number" ? or[2] : z;
        xUp = typeof xUp !== "number" ? or[3] : xUp;
        yUp = typeof yUp !== "number" ? or[4] : yUp;
        zUp = typeof zUp !== "number" ? or[5] : zUp;
        if (typeof x === "number") {
            self._orientation = [
                x,
                y,
                z,
                xUp,
                yUp,
                zUp
            ];
            if (typeof self.ctx.listener.forwardX !== "undefined") {
                self.ctx.listener.forwardX.setTargetAtTime(x, Howler.ctx.currentTime, 0.1);
                self.ctx.listener.forwardY.setTargetAtTime(y, Howler.ctx.currentTime, 0.1);
                self.ctx.listener.forwardZ.setTargetAtTime(z, Howler.ctx.currentTime, 0.1);
                self.ctx.listener.upX.setTargetAtTime(xUp, Howler.ctx.currentTime, 0.1);
                self.ctx.listener.upY.setTargetAtTime(yUp, Howler.ctx.currentTime, 0.1);
                self.ctx.listener.upZ.setTargetAtTime(zUp, Howler.ctx.currentTime, 0.1);
            } else self.ctx.listener.setOrientation(x, y, z, xUp, yUp, zUp);
        } else return or;
        return self;
    };
    /** Group Methods **/ /***************************************************************************/ /**
   * Add new properties to the core init.
   * @param  {Function} _super Core init method.
   * @return {Howl}
   */ Howl.prototype.init = function(_super) {
        return function(o) {
            var self = this;
            // Setup user-defined default properties.
            self._orientation = o.orientation || [
                1,
                0,
                0
            ];
            self._stereo = o.stereo || null;
            self._pos = o.pos || null;
            self._pannerAttr = {
                coneInnerAngle: typeof o.coneInnerAngle !== "undefined" ? o.coneInnerAngle : 360,
                coneOuterAngle: typeof o.coneOuterAngle !== "undefined" ? o.coneOuterAngle : 360,
                coneOuterGain: typeof o.coneOuterGain !== "undefined" ? o.coneOuterGain : 0,
                distanceModel: typeof o.distanceModel !== "undefined" ? o.distanceModel : "inverse",
                maxDistance: typeof o.maxDistance !== "undefined" ? o.maxDistance : 10000,
                panningModel: typeof o.panningModel !== "undefined" ? o.panningModel : "HRTF",
                refDistance: typeof o.refDistance !== "undefined" ? o.refDistance : 1,
                rolloffFactor: typeof o.rolloffFactor !== "undefined" ? o.rolloffFactor : 1
            };
            // Setup event listeners.
            self._onstereo = o.onstereo ? [
                {
                    fn: o.onstereo
                }
            ] : [];
            self._onpos = o.onpos ? [
                {
                    fn: o.onpos
                }
            ] : [];
            self._onorientation = o.onorientation ? [
                {
                    fn: o.onorientation
                }
            ] : [];
            // Complete initilization with howler.js core's init function.
            return _super.call(this, o);
        };
    }(Howl.prototype.init);
    /**
   * Get/set the stereo panning of the audio source for this sound or all in the group.
   * @param  {Number} pan  A value of -1.0 is all the way left and 1.0 is all the way right.
   * @param  {Number} id (optional) The sound ID. If none is passed, all in group will be updated.
   * @return {Howl/Number}    Returns self or the current stereo panning value.
   */ Howl.prototype.stereo = function(pan, id) {
        var self = this;
        // Stop right here if not using Web Audio.
        if (!self._webAudio) return self;
        // If the sound hasn't loaded, add it to the load queue to change stereo pan when capable.
        if (self._state !== "loaded") {
            self._queue.push({
                event: "stereo",
                action: function() {
                    self.stereo(pan, id);
                }
            });
            return self;
        }
        // Check for PannerStereoNode support and fallback to PannerNode if it doesn't exist.
        var pannerType = typeof Howler.ctx.createStereoPanner === "undefined" ? "spatial" : "stereo";
        // Setup the group's stereo panning if no ID is passed.
        if (typeof id === "undefined") {
            // Return the group's stereo panning if no parameters are passed.
            if (typeof pan === "number") {
                self._stereo = pan;
                self._pos = [
                    pan,
                    0,
                    0
                ];
            } else return self._stereo;
        }
        // Change the streo panning of one or all sounds in group.
        var ids = self._getSoundIds(id);
        for(var i = 0; i < ids.length; i++){
            // Get the sound.
            var sound = self._soundById(ids[i]);
            if (sound) {
                if (typeof pan === "number") {
                    sound._stereo = pan;
                    sound._pos = [
                        pan,
                        0,
                        0
                    ];
                    if (sound._node) {
                        // If we are falling back, make sure the panningModel is equalpower.
                        sound._pannerAttr.panningModel = "equalpower";
                        // Check if there is a panner setup and create a new one if not.
                        if (!sound._panner || !sound._panner.pan) setupPanner(sound, pannerType);
                        if (pannerType === "spatial") {
                            if (typeof sound._panner.positionX !== "undefined") {
                                sound._panner.positionX.setValueAtTime(pan, Howler.ctx.currentTime);
                                sound._panner.positionY.setValueAtTime(0, Howler.ctx.currentTime);
                                sound._panner.positionZ.setValueAtTime(0, Howler.ctx.currentTime);
                            } else sound._panner.setPosition(pan, 0, 0);
                        } else sound._panner.pan.setValueAtTime(pan, Howler.ctx.currentTime);
                    }
                    self._emit("stereo", sound._id);
                } else return sound._stereo;
            }
        }
        return self;
    };
    /**
   * Get/set the 3D spatial position of the audio source for this sound or group relative to the global listener.
   * @param  {Number} x  The x-position of the audio source.
   * @param  {Number} y  The y-position of the audio source.
   * @param  {Number} z  The z-position of the audio source.
   * @param  {Number} id (optional) The sound ID. If none is passed, all in group will be updated.
   * @return {Howl/Array}    Returns self or the current 3D spatial position: [x, y, z].
   */ Howl.prototype.pos = function(x, y, z, id) {
        var self = this;
        // Stop right here if not using Web Audio.
        if (!self._webAudio) return self;
        // If the sound hasn't loaded, add it to the load queue to change position when capable.
        if (self._state !== "loaded") {
            self._queue.push({
                event: "pos",
                action: function() {
                    self.pos(x, y, z, id);
                }
            });
            return self;
        }
        // Set the defaults for optional 'y' & 'z'.
        y = typeof y !== "number" ? 0 : y;
        z = typeof z !== "number" ? -0.5 : z;
        // Setup the group's spatial position if no ID is passed.
        if (typeof id === "undefined") {
            // Return the group's spatial position if no parameters are passed.
            if (typeof x === "number") self._pos = [
                x,
                y,
                z
            ];
            else return self._pos;
        }
        // Change the spatial position of one or all sounds in group.
        var ids = self._getSoundIds(id);
        for(var i = 0; i < ids.length; i++){
            // Get the sound.
            var sound = self._soundById(ids[i]);
            if (sound) {
                if (typeof x === "number") {
                    sound._pos = [
                        x,
                        y,
                        z
                    ];
                    if (sound._node) {
                        // Check if there is a panner setup and create a new one if not.
                        if (!sound._panner || sound._panner.pan) setupPanner(sound, "spatial");
                        if (typeof sound._panner.positionX !== "undefined") {
                            sound._panner.positionX.setValueAtTime(x, Howler.ctx.currentTime);
                            sound._panner.positionY.setValueAtTime(y, Howler.ctx.currentTime);
                            sound._panner.positionZ.setValueAtTime(z, Howler.ctx.currentTime);
                        } else sound._panner.setPosition(x, y, z);
                    }
                    self._emit("pos", sound._id);
                } else return sound._pos;
            }
        }
        return self;
    };
    /**
   * Get/set the direction the audio source is pointing in the 3D cartesian coordinate
   * space. Depending on how direction the sound is, based on the `cone` attributes,
   * a sound pointing away from the listener can be quiet or silent.
   * @param  {Number} x  The x-orientation of the source.
   * @param  {Number} y  The y-orientation of the source.
   * @param  {Number} z  The z-orientation of the source.
   * @param  {Number} id (optional) The sound ID. If none is passed, all in group will be updated.
   * @return {Howl/Array}    Returns self or the current 3D spatial orientation: [x, y, z].
   */ Howl.prototype.orientation = function(x, y, z, id) {
        var self = this;
        // Stop right here if not using Web Audio.
        if (!self._webAudio) return self;
        // If the sound hasn't loaded, add it to the load queue to change orientation when capable.
        if (self._state !== "loaded") {
            self._queue.push({
                event: "orientation",
                action: function() {
                    self.orientation(x, y, z, id);
                }
            });
            return self;
        }
        // Set the defaults for optional 'y' & 'z'.
        y = typeof y !== "number" ? self._orientation[1] : y;
        z = typeof z !== "number" ? self._orientation[2] : z;
        // Setup the group's spatial orientation if no ID is passed.
        if (typeof id === "undefined") {
            // Return the group's spatial orientation if no parameters are passed.
            if (typeof x === "number") self._orientation = [
                x,
                y,
                z
            ];
            else return self._orientation;
        }
        // Change the spatial orientation of one or all sounds in group.
        var ids = self._getSoundIds(id);
        for(var i = 0; i < ids.length; i++){
            // Get the sound.
            var sound = self._soundById(ids[i]);
            if (sound) {
                if (typeof x === "number") {
                    sound._orientation = [
                        x,
                        y,
                        z
                    ];
                    if (sound._node) {
                        // Check if there is a panner setup and create a new one if not.
                        if (!sound._panner) {
                            // Make sure we have a position to setup the node with.
                            if (!sound._pos) sound._pos = self._pos || [
                                0,
                                0,
                                -0.5
                            ];
                            setupPanner(sound, "spatial");
                        }
                        if (typeof sound._panner.orientationX !== "undefined") {
                            sound._panner.orientationX.setValueAtTime(x, Howler.ctx.currentTime);
                            sound._panner.orientationY.setValueAtTime(y, Howler.ctx.currentTime);
                            sound._panner.orientationZ.setValueAtTime(z, Howler.ctx.currentTime);
                        } else sound._panner.setOrientation(x, y, z);
                    }
                    self._emit("orientation", sound._id);
                } else return sound._orientation;
            }
        }
        return self;
    };
    /**
   * Get/set the panner node's attributes for a sound or group of sounds.
   * This method can optionall take 0, 1 or 2 arguments.
   *   pannerAttr() -> Returns the group's values.
   *   pannerAttr(id) -> Returns the sound id's values.
   *   pannerAttr(o) -> Set's the values of all sounds in this Howl group.
   *   pannerAttr(o, id) -> Set's the values of passed sound id.
   *
   *   Attributes:
   *     coneInnerAngle - (360 by default) A parameter for directional audio sources, this is an angle, in degrees,
   *                      inside of which there will be no volume reduction.
   *     coneOuterAngle - (360 by default) A parameter for directional audio sources, this is an angle, in degrees,
   *                      outside of which the volume will be reduced to a constant value of `coneOuterGain`.
   *     coneOuterGain - (0 by default) A parameter for directional audio sources, this is the gain outside of the
   *                     `coneOuterAngle`. It is a linear value in the range `[0, 1]`.
   *     distanceModel - ('inverse' by default) Determines algorithm used to reduce volume as audio moves away from
   *                     listener. Can be `linear`, `inverse` or `exponential.
   *     maxDistance - (10000 by default) The maximum distance between source and listener, after which the volume
   *                   will not be reduced any further.
   *     refDistance - (1 by default) A reference distance for reducing volume as source moves further from the listener.
   *                   This is simply a variable of the distance model and has a different effect depending on which model
   *                   is used and the scale of your coordinates. Generally, volume will be equal to 1 at this distance.
   *     rolloffFactor - (1 by default) How quickly the volume reduces as source moves from listener. This is simply a
   *                     variable of the distance model and can be in the range of `[0, 1]` with `linear` and `[0, ∞]`
   *                     with `inverse` and `exponential`.
   *     panningModel - ('HRTF' by default) Determines which spatialization algorithm is used to position audio.
   *                     Can be `HRTF` or `equalpower`.
   *
   * @return {Howl/Object} Returns self or current panner attributes.
   */ Howl.prototype.pannerAttr = function() {
        var self = this;
        var args = arguments;
        var o, id, sound;
        // Stop right here if not using Web Audio.
        if (!self._webAudio) return self;
        // Determine the values based on arguments.
        if (args.length === 0) // Return the group's panner attribute values.
        return self._pannerAttr;
        else if (args.length === 1) {
            if (typeof args[0] === "object") {
                o = args[0];
                // Set the grou's panner attribute values.
                if (typeof id === "undefined") {
                    if (!o.pannerAttr) o.pannerAttr = {
                        coneInnerAngle: o.coneInnerAngle,
                        coneOuterAngle: o.coneOuterAngle,
                        coneOuterGain: o.coneOuterGain,
                        distanceModel: o.distanceModel,
                        maxDistance: o.maxDistance,
                        refDistance: o.refDistance,
                        rolloffFactor: o.rolloffFactor,
                        panningModel: o.panningModel
                    };
                    self._pannerAttr = {
                        coneInnerAngle: typeof o.pannerAttr.coneInnerAngle !== "undefined" ? o.pannerAttr.coneInnerAngle : self._coneInnerAngle,
                        coneOuterAngle: typeof o.pannerAttr.coneOuterAngle !== "undefined" ? o.pannerAttr.coneOuterAngle : self._coneOuterAngle,
                        coneOuterGain: typeof o.pannerAttr.coneOuterGain !== "undefined" ? o.pannerAttr.coneOuterGain : self._coneOuterGain,
                        distanceModel: typeof o.pannerAttr.distanceModel !== "undefined" ? o.pannerAttr.distanceModel : self._distanceModel,
                        maxDistance: typeof o.pannerAttr.maxDistance !== "undefined" ? o.pannerAttr.maxDistance : self._maxDistance,
                        refDistance: typeof o.pannerAttr.refDistance !== "undefined" ? o.pannerAttr.refDistance : self._refDistance,
                        rolloffFactor: typeof o.pannerAttr.rolloffFactor !== "undefined" ? o.pannerAttr.rolloffFactor : self._rolloffFactor,
                        panningModel: typeof o.pannerAttr.panningModel !== "undefined" ? o.pannerAttr.panningModel : self._panningModel
                    };
                }
            } else {
                // Return this sound's panner attribute values.
                sound = self._soundById(parseInt(args[0], 10));
                return sound ? sound._pannerAttr : self._pannerAttr;
            }
        } else if (args.length === 2) {
            o = args[0];
            id = parseInt(args[1], 10);
        }
        // Update the values of the specified sounds.
        var ids = self._getSoundIds(id);
        for(var i = 0; i < ids.length; i++){
            sound = self._soundById(ids[i]);
            if (sound) {
                // Merge the new values into the sound.
                var pa = sound._pannerAttr;
                pa = {
                    coneInnerAngle: typeof o.coneInnerAngle !== "undefined" ? o.coneInnerAngle : pa.coneInnerAngle,
                    coneOuterAngle: typeof o.coneOuterAngle !== "undefined" ? o.coneOuterAngle : pa.coneOuterAngle,
                    coneOuterGain: typeof o.coneOuterGain !== "undefined" ? o.coneOuterGain : pa.coneOuterGain,
                    distanceModel: typeof o.distanceModel !== "undefined" ? o.distanceModel : pa.distanceModel,
                    maxDistance: typeof o.maxDistance !== "undefined" ? o.maxDistance : pa.maxDistance,
                    refDistance: typeof o.refDistance !== "undefined" ? o.refDistance : pa.refDistance,
                    rolloffFactor: typeof o.rolloffFactor !== "undefined" ? o.rolloffFactor : pa.rolloffFactor,
                    panningModel: typeof o.panningModel !== "undefined" ? o.panningModel : pa.panningModel
                };
                // Create a new panner node if one doesn't already exist.
                var panner = sound._panner;
                if (!panner) {
                    // Make sure we have a position to setup the node with.
                    if (!sound._pos) sound._pos = self._pos || [
                        0,
                        0,
                        -0.5
                    ];
                    // Create a new panner node.
                    setupPanner(sound, "spatial");
                    panner = sound._panner;
                }
                // Update the panner values or create a new panner if none exists.
                panner.coneInnerAngle = pa.coneInnerAngle;
                panner.coneOuterAngle = pa.coneOuterAngle;
                panner.coneOuterGain = pa.coneOuterGain;
                panner.distanceModel = pa.distanceModel;
                panner.maxDistance = pa.maxDistance;
                panner.refDistance = pa.refDistance;
                panner.rolloffFactor = pa.rolloffFactor;
                panner.panningModel = pa.panningModel;
            }
        }
        return self;
    };
    /** Single Sound Methods **/ /***************************************************************************/ /**
   * Add new properties to the core Sound init.
   * @param  {Function} _super Core Sound init method.
   * @return {Sound}
   */ Sound.prototype.init = function(_super) {
        return function() {
            var self = this;
            var parent = self._parent;
            // Setup user-defined default properties.
            self._orientation = parent._orientation;
            self._stereo = parent._stereo;
            self._pos = parent._pos;
            self._pannerAttr = parent._pannerAttr;
            // Complete initilization with howler.js core Sound's init function.
            _super.call(this);
            // If a stereo or position was specified, set it up.
            if (self._stereo) parent.stereo(self._stereo);
            else if (self._pos) parent.pos(self._pos[0], self._pos[1], self._pos[2], self._id);
        };
    }(Sound.prototype.init);
    /**
   * Override the Sound.reset method to clean up properties from the spatial plugin.
   * @param  {Function} _super Sound reset method.
   * @return {Sound}
   */ Sound.prototype.reset = function(_super) {
        return function() {
            var self = this;
            var parent = self._parent;
            // Reset all spatial plugin properties on this sound.
            self._orientation = parent._orientation;
            self._stereo = parent._stereo;
            self._pos = parent._pos;
            self._pannerAttr = parent._pannerAttr;
            // If a stereo or position was specified, set it up.
            if (self._stereo) parent.stereo(self._stereo);
            else if (self._pos) parent.pos(self._pos[0], self._pos[1], self._pos[2], self._id);
            else if (self._panner) {
                // Disconnect the panner.
                self._panner.disconnect(0);
                self._panner = undefined;
                parent._refreshBuffer(self);
            }
            // Complete resetting of the sound.
            return _super.call(this);
        };
    }(Sound.prototype.reset);
    /** Helper Methods **/ /***************************************************************************/ /**
   * Create a new panner node and save it on the sound.
   * @param  {Sound} sound Specific sound to setup panning on.
   * @param {String} type Type of panner to create: 'stereo' or 'spatial'.
   */ var setupPanner = function(sound, type) {
        type = type || "spatial";
        // Create the new panner node.
        if (type === "spatial") {
            sound._panner = Howler.ctx.createPanner();
            sound._panner.coneInnerAngle = sound._pannerAttr.coneInnerAngle;
            sound._panner.coneOuterAngle = sound._pannerAttr.coneOuterAngle;
            sound._panner.coneOuterGain = sound._pannerAttr.coneOuterGain;
            sound._panner.distanceModel = sound._pannerAttr.distanceModel;
            sound._panner.maxDistance = sound._pannerAttr.maxDistance;
            sound._panner.refDistance = sound._pannerAttr.refDistance;
            sound._panner.rolloffFactor = sound._pannerAttr.rolloffFactor;
            sound._panner.panningModel = sound._pannerAttr.panningModel;
            if (typeof sound._panner.positionX !== "undefined") {
                sound._panner.positionX.setValueAtTime(sound._pos[0], Howler.ctx.currentTime);
                sound._panner.positionY.setValueAtTime(sound._pos[1], Howler.ctx.currentTime);
                sound._panner.positionZ.setValueAtTime(sound._pos[2], Howler.ctx.currentTime);
            } else sound._panner.setPosition(sound._pos[0], sound._pos[1], sound._pos[2]);
            if (typeof sound._panner.orientationX !== "undefined") {
                sound._panner.orientationX.setValueAtTime(sound._orientation[0], Howler.ctx.currentTime);
                sound._panner.orientationY.setValueAtTime(sound._orientation[1], Howler.ctx.currentTime);
                sound._panner.orientationZ.setValueAtTime(sound._orientation[2], Howler.ctx.currentTime);
            } else sound._panner.setOrientation(sound._orientation[0], sound._orientation[1], sound._orientation[2]);
        } else {
            sound._panner = Howler.ctx.createStereoPanner();
            sound._panner.pan.setValueAtTime(sound._stereo, Howler.ctx.currentTime);
        }
        sound._panner.connect(sound._node);
        // Update the connections.
        if (!sound._paused) sound._parent.pause(sound._id, true).play(sound._id, true);
    };
})();


const $0426e2dd5e0de94d$export$41baa606ecc5bb4f = window.location.hostname.includes("dev-") || window.location.hostname.includes("localhost") ? "https://cdn.piratesquadnft.com/clients/oogy-blast/game/data-dev" : "https://cdn.piratesquadnft.com/clients/oogy-blast/game/data";
const $0426e2dd5e0de94d$export$24af3971dd36b33f = "https://cdn.piratesquadnft.com/clients/oogy-blast/game/visual";
const $0426e2dd5e0de94d$export$5e7589cedbd7a4e0 = "https://cdn.piratesquadnft.com/clients/oogy-blast/game/visual/animations";
const $0426e2dd5e0de94d$export$bdfbf8dbe6eb267c = "https://cdn.piratesquadnft.com/clients/oogy-blast/game/sound";
const $0426e2dd5e0de94d$export$5b8ff73d01e3bd5 = 15;


// Main
Howler.mute(window.localStorage.getItem("music-muted") === "true");
const $0c69c9c512bb7a3f$var$musicSound = new (0, $f89d8ffbdc18f2ab$export$b791fe48eec8032a)({
    src: [
        `${(0, $0426e2dd5e0de94d$export$bdfbf8dbe6eb267c)}/music/oasys.mp3`
    ],
    volume: 0.10,
    preload: true,
    loop: true
});
const $0c69c9c512bb7a3f$export$31feb4e10852ccbd = ()=>{
    if (!$0c69c9c512bb7a3f$var$musicSound.playing()) $0c69c9c512bb7a3f$var$musicSound.stop().play();
};
const $0c69c9c512bb7a3f$export$2b20361d967f09eb = new (0, $f89d8ffbdc18f2ab$export$b791fe48eec8032a)({
    src: [
        `${(0, $0426e2dd5e0de94d$export$bdfbf8dbe6eb267c)}/ui/button/hover.mp3`
    ],
    volume: 0.2,
    preload: true
});
const $0c69c9c512bb7a3f$export$4db563113ca18f41 = new (0, $f89d8ffbdc18f2ab$export$b791fe48eec8032a)({
    src: [
        `${(0, $0426e2dd5e0de94d$export$bdfbf8dbe6eb267c)}/ui/button/click.mp3`
    ],
    volume: 0.2,
    preload: true
});
const $0c69c9c512bb7a3f$export$cf053497c941917c = new (0, $f89d8ffbdc18f2ab$export$b791fe48eec8032a)({
    src: [
        `${(0, $0426e2dd5e0de94d$export$bdfbf8dbe6eb267c)}/ui/button/click-refused.mp3`
    ],
    volume: 0.2,
    preload: true
});
const $0c69c9c512bb7a3f$export$ea4b3487e453b101 = new (0, $f89d8ffbdc18f2ab$export$b791fe48eec8032a)({
    src: [
        `${(0, $0426e2dd5e0de94d$export$bdfbf8dbe6eb267c)}/ui/button/switch.mp3`
    ],
    volume: 0.2,
    preload: true
});
const $0c69c9c512bb7a3f$export$c8dc8223fac2849e = new (0, $f89d8ffbdc18f2ab$export$b791fe48eec8032a)({
    src: [
        `${(0, $0426e2dd5e0de94d$export$bdfbf8dbe6eb267c)}/ui/open-chest.mp3`
    ],
    volume: 0.15,
    preload: true,
    sprite: {
        open: [
            650,
            8000
        ]
    }
});
const $0c69c9c512bb7a3f$export$d5dc2923b9ea91d1 = new (0, $f89d8ffbdc18f2ab$export$b791fe48eec8032a)({
    src: [
        `${(0, $0426e2dd5e0de94d$export$bdfbf8dbe6eb267c)}/ui/card-flip.mp3`
    ],
    volume: 0.1,
    preload: true
});



var $a52e11e332d75cf3$exports = {};

$parcel$export($a52e11e332d75cf3$exports, "blue", () => $a52e11e332d75cf3$export$2aa0182783e7e9de, (v) => $a52e11e332d75cf3$export$2aa0182783e7e9de = v);
$parcel$export($a52e11e332d75cf3$exports, "button", () => $a52e11e332d75cf3$export$2ba01fb71ed41cb6, (v) => $a52e11e332d75cf3$export$2ba01fb71ed41cb6 = v);
$parcel$export($a52e11e332d75cf3$exports, "children", () => $a52e11e332d75cf3$export$bacb5cc5a11aef16, (v) => $a52e11e332d75cf3$export$bacb5cc5a11aef16 = v);
$parcel$export($a52e11e332d75cf3$exports, "content", () => $a52e11e332d75cf3$export$a7db06668cad9adb, (v) => $a52e11e332d75cf3$export$a7db06668cad9adb = v);
$parcel$export($a52e11e332d75cf3$exports, "floating", () => $a52e11e332d75cf3$export$489731e52ee942d6, (v) => $a52e11e332d75cf3$export$489731e52ee942d6 = v);
$parcel$export($a52e11e332d75cf3$exports, "gray", () => $a52e11e332d75cf3$export$3e2c219d3ab79d01, (v) => $a52e11e332d75cf3$export$3e2c219d3ab79d01 = v);
$parcel$export($a52e11e332d75cf3$exports, "icon", () => $a52e11e332d75cf3$export$1ca1ec8b29a4ce27, (v) => $a52e11e332d75cf3$export$1ca1ec8b29a4ce27 = v);
$parcel$export($a52e11e332d75cf3$exports, "loading", () => $a52e11e332d75cf3$export$46c1c92549715335, (v) => $a52e11e332d75cf3$export$46c1c92549715335 = v);
$parcel$export($a52e11e332d75cf3$exports, "no-color", () => $a52e11e332d75cf3$export$cd7cbe6fdc3d605f, (v) => $a52e11e332d75cf3$export$cd7cbe6fdc3d605f = v);
$parcel$export($a52e11e332d75cf3$exports, "no-padding", () => $a52e11e332d75cf3$export$49ce614873e693f3, (v) => $a52e11e332d75cf3$export$49ce614873e693f3 = v);
$parcel$export($a52e11e332d75cf3$exports, "pink", () => $a52e11e332d75cf3$export$47853bc718611763, (v) => $a52e11e332d75cf3$export$47853bc718611763 = v);
$parcel$export($a52e11e332d75cf3$exports, "selected", () => $a52e11e332d75cf3$export$d90250155de6d7e7, (v) => $a52e11e332d75cf3$export$d90250155de6d7e7 = v);
$parcel$export($a52e11e332d75cf3$exports, "shaded-black", () => $a52e11e332d75cf3$export$b2f325f25d446878, (v) => $a52e11e332d75cf3$export$b2f325f25d446878 = v);
$parcel$export($a52e11e332d75cf3$exports, "small", () => $a52e11e332d75cf3$export$3c17b0e969a90510, (v) => $a52e11e332d75cf3$export$3c17b0e969a90510 = v);
$parcel$export($a52e11e332d75cf3$exports, "success", () => $a52e11e332d75cf3$export$fe7c49d056ea1d88, (v) => $a52e11e332d75cf3$export$fe7c49d056ea1d88 = v);
$parcel$export($a52e11e332d75cf3$exports, "violet", () => $a52e11e332d75cf3$export$8241b7126941c403, (v) => $a52e11e332d75cf3$export$8241b7126941c403 = v);
$parcel$export($a52e11e332d75cf3$exports, "warning", () => $a52e11e332d75cf3$export$491112666e282270, (v) => $a52e11e332d75cf3$export$491112666e282270 = v);
$parcel$export($a52e11e332d75cf3$exports, "xsmall", () => $a52e11e332d75cf3$export$53e73bcd5097e50d, (v) => $a52e11e332d75cf3$export$53e73bcd5097e50d = v);
$parcel$export($a52e11e332d75cf3$exports, "xxsmall", () => $a52e11e332d75cf3$export$fb88774c9f40c6a3, (v) => $a52e11e332d75cf3$export$fb88774c9f40c6a3 = v);
$parcel$export($a52e11e332d75cf3$exports, "yellow", () => $a52e11e332d75cf3$export$594c5a8758200c32, (v) => $a52e11e332d75cf3$export$594c5a8758200c32 = v);
var $a52e11e332d75cf3$export$2aa0182783e7e9de;
var $a52e11e332d75cf3$export$2ba01fb71ed41cb6;
var $a52e11e332d75cf3$export$bacb5cc5a11aef16;
var $a52e11e332d75cf3$export$a7db06668cad9adb;
var $a52e11e332d75cf3$export$489731e52ee942d6;
var $a52e11e332d75cf3$export$3e2c219d3ab79d01;
var $a52e11e332d75cf3$export$1ca1ec8b29a4ce27;
var $a52e11e332d75cf3$export$46c1c92549715335;
var $a52e11e332d75cf3$export$cd7cbe6fdc3d605f;
var $a52e11e332d75cf3$export$49ce614873e693f3;
var $a52e11e332d75cf3$export$47853bc718611763;
var $a52e11e332d75cf3$export$d90250155de6d7e7;
var $a52e11e332d75cf3$export$b2f325f25d446878;
var $a52e11e332d75cf3$export$3c17b0e969a90510;
var $a52e11e332d75cf3$export$fe7c49d056ea1d88;
var $a52e11e332d75cf3$export$8241b7126941c403;
var $a52e11e332d75cf3$export$491112666e282270;
var $a52e11e332d75cf3$export$53e73bcd5097e50d;
var $a52e11e332d75cf3$export$fb88774c9f40c6a3;
var $a52e11e332d75cf3$export$594c5a8758200c32;
$a52e11e332d75cf3$export$2aa0182783e7e9de = `_4QO8gW_blue`;
$a52e11e332d75cf3$export$2ba01fb71ed41cb6 = `_4QO8gW_button`;
$a52e11e332d75cf3$export$bacb5cc5a11aef16 = `_4QO8gW_children`;
$a52e11e332d75cf3$export$a7db06668cad9adb = `_4QO8gW_content`;
$a52e11e332d75cf3$export$489731e52ee942d6 = `_4QO8gW_floating`;
$a52e11e332d75cf3$export$3e2c219d3ab79d01 = `_4QO8gW_gray`;
$a52e11e332d75cf3$export$1ca1ec8b29a4ce27 = `_4QO8gW_icon`;
$a52e11e332d75cf3$export$46c1c92549715335 = `_4QO8gW_loading`;
$a52e11e332d75cf3$export$cd7cbe6fdc3d605f = `_4QO8gW_no-color`;
$a52e11e332d75cf3$export$49ce614873e693f3 = `_4QO8gW_no-padding`;
$a52e11e332d75cf3$export$47853bc718611763 = `_4QO8gW_pink`;
$a52e11e332d75cf3$export$d90250155de6d7e7 = `_4QO8gW_selected`;
$a52e11e332d75cf3$export$b2f325f25d446878 = `_4QO8gW_shaded-black`;
$a52e11e332d75cf3$export$3c17b0e969a90510 = `_4QO8gW_small`;
$a52e11e332d75cf3$export$fe7c49d056ea1d88 = `_4QO8gW_success`;
$a52e11e332d75cf3$export$8241b7126941c403 = `_4QO8gW_violet`;
$a52e11e332d75cf3$export$491112666e282270 = `_4QO8gW_warning`;
$a52e11e332d75cf3$export$53e73bcd5097e50d = `_4QO8gW_xsmall`;
$a52e11e332d75cf3$export$fb88774c9f40c6a3 = `_4QO8gW_xxsmall`;
$a52e11e332d75cf3$export$594c5a8758200c32 = `_4QO8gW_yellow`;


const $6725244138e0595f$export$353f5b6fc5456de1 = ({ children: children, loading: loading, loadingWithChildren: loadingWithChildren = false, className: className, disabled: disabled, onPointerOver: onPointerOver, onPointerUp: onPointerUp, ...props })=>{
    const onPointerOverPrepared = (event)=>{
        if (onPointerOver) onPointerOver(event);
        (0, $0c69c9c512bb7a3f$export$2b20361d967f09eb).play();
    };
    const onPointerUpPrepared = (event)=>{
        if (onPointerUp) onPointerUp(event);
        if (disabled) (0, $0c69c9c512bb7a3f$export$cf053497c941917c).play();
        else (0, $0c69c9c512bb7a3f$export$4db563113ca18f41).play();
    };
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
        className: (0, $9805619f03ed02ef$export$91884aa883243770)((0, (/*@__PURE__*/$parcel$interopDefault($a52e11e332d75cf3$exports))), `button ${loading ? "loading" : ""} ${className ?? ""}`),
        disabled: disabled,
        onPointerOver: onPointerOverPrepared,
        onPointerUp: onPointerUpPrepared,
        ...props,
        children: loading ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
            className: (0, $9805619f03ed02ef$export$91884aa883243770)((0, (/*@__PURE__*/$parcel$interopDefault($a52e11e332d75cf3$exports))), `content ${loadingWithChildren ? "" : "floating"}`),
            children: [
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $e4ec753f5c716375$export$2b9260d4a45c8710), {
                    spin: true,
                    icon: "circle-notch"
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                    className: (0, $9805619f03ed02ef$export$91884aa883243770)((0, (/*@__PURE__*/$parcel$interopDefault($a52e11e332d75cf3$exports))), "children"),
                    children: children
                })
            ]
        }) : children
    });
};
const $6725244138e0595f$export$e1c22a2ee2645e36 = ({ icon: icon, flip: flip, size: size = "1x", className: className, loadingWithChildren: loadingWithChildren, children: children, loading: loading, iconProps: iconProps, ...props })=>{
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)($6725244138e0595f$export$353f5b6fc5456de1, {
        className: (0, $9805619f03ed02ef$export$91884aa883243770)((0, (/*@__PURE__*/$parcel$interopDefault($a52e11e332d75cf3$exports))), `icon ${className}`),
        loading: loading,
        loadingWithChildren: loadingWithChildren,
        ...props,
        children: [
            !loading && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $e4ec753f5c716375$export$2b9260d4a45c8710), {
                flip: flip,
                icon: icon,
                size: size,
                ...iconProps
            }),
            children
        ]
    });
};




var $acw62 = parcelRequire("acw62");

var $08cb8d095f8ecb88$exports = {};

$parcel$export($08cb8d095f8ecb88$exports, "input", () => $08cb8d095f8ecb88$export$b7e3ae3d7c15e42e, (v) => $08cb8d095f8ecb88$export$b7e3ae3d7c15e42e = v);
var $08cb8d095f8ecb88$export$b7e3ae3d7c15e42e;
$08cb8d095f8ecb88$export$b7e3ae3d7c15e42e = `clG-nq_input`;


const $863b21ed6a3b3d61$export$f5b8910cec6cf069 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).forwardRef(({ className: className, ...props }, ref)=>{
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
        ref: ref,
        className: (0, $9805619f03ed02ef$export$91884aa883243770)((0, (/*@__PURE__*/$parcel$interopDefault($08cb8d095f8ecb88$exports))), `input ${className}`),
        ...props
    });
});


var $6d5b5dc473213ba2$exports = {};

$parcel$export($6d5b5dc473213ba2$exports, "background", () => $6d5b5dc473213ba2$export$8ce1fd94bee2f412, (v) => $6d5b5dc473213ba2$export$8ce1fd94bee2f412 = v);
$parcel$export($6d5b5dc473213ba2$exports, "container", () => $6d5b5dc473213ba2$export$34e0f9847d4c02dd, (v) => $6d5b5dc473213ba2$export$34e0f9847d4c02dd = v);
$parcel$export($6d5b5dc473213ba2$exports, "content", () => $6d5b5dc473213ba2$export$a7db06668cad9adb, (v) => $6d5b5dc473213ba2$export$a7db06668cad9adb = v);
$parcel$export($6d5b5dc473213ba2$exports, "cross", () => $6d5b5dc473213ba2$export$bb646b20bb93d339, (v) => $6d5b5dc473213ba2$export$bb646b20bb93d339 = v);
$parcel$export($6d5b5dc473213ba2$exports, "footer", () => $6d5b5dc473213ba2$export$adb608be33961c98, (v) => $6d5b5dc473213ba2$export$adb608be33961c98 = v);
$parcel$export($6d5b5dc473213ba2$exports, "full-size", () => $6d5b5dc473213ba2$export$e1ffd7fb0909744f, (v) => $6d5b5dc473213ba2$export$e1ffd7fb0909744f = v);
$parcel$export($6d5b5dc473213ba2$exports, "image", () => $6d5b5dc473213ba2$export$5c452ff88e35e47d, (v) => $6d5b5dc473213ba2$export$5c452ff88e35e47d = v);
$parcel$export($6d5b5dc473213ba2$exports, "input", () => $6d5b5dc473213ba2$export$b7e3ae3d7c15e42e, (v) => $6d5b5dc473213ba2$export$b7e3ae3d7c15e42e = v);
$parcel$export($6d5b5dc473213ba2$exports, "loading-content", () => $6d5b5dc473213ba2$export$ed555aaf9acd8e82, (v) => $6d5b5dc473213ba2$export$ed555aaf9acd8e82 = v);
$parcel$export($6d5b5dc473213ba2$exports, "loading-modal", () => $6d5b5dc473213ba2$export$66f19efb468ec04a, (v) => $6d5b5dc473213ba2$export$66f19efb468ec04a = v);
$parcel$export($6d5b5dc473213ba2$exports, "modal", () => $6d5b5dc473213ba2$export$96e4b36520c26a2c, (v) => $6d5b5dc473213ba2$export$96e4b36520c26a2c = v);
$parcel$export($6d5b5dc473213ba2$exports, "modal-enter", () => $6d5b5dc473213ba2$export$d70b35ef4da19daf, (v) => $6d5b5dc473213ba2$export$d70b35ef4da19daf = v);
$parcel$export($6d5b5dc473213ba2$exports, "modal-enter-active", () => $6d5b5dc473213ba2$export$a34a66643fc3763e, (v) => $6d5b5dc473213ba2$export$a34a66643fc3763e = v);
$parcel$export($6d5b5dc473213ba2$exports, "modal-exit", () => $6d5b5dc473213ba2$export$7bb7a178e87bb31e, (v) => $6d5b5dc473213ba2$export$7bb7a178e87bb31e = v);
$parcel$export($6d5b5dc473213ba2$exports, "modal-exit-active", () => $6d5b5dc473213ba2$export$748238e7dfe20031, (v) => $6d5b5dc473213ba2$export$748238e7dfe20031 = v);
$parcel$export($6d5b5dc473213ba2$exports, "no-blur", () => $6d5b5dc473213ba2$export$de1d529c926dff05, (v) => $6d5b5dc473213ba2$export$de1d529c926dff05 = v);
$parcel$export($6d5b5dc473213ba2$exports, "title", () => $6d5b5dc473213ba2$export$fb184b623420d9be, (v) => $6d5b5dc473213ba2$export$fb184b623420d9be = v);
$parcel$export($6d5b5dc473213ba2$exports, "window", () => $6d5b5dc473213ba2$export$8291e5b88f90ce4, (v) => $6d5b5dc473213ba2$export$8291e5b88f90ce4 = v);
var $6d5b5dc473213ba2$export$8ce1fd94bee2f412;
var $6d5b5dc473213ba2$export$34e0f9847d4c02dd;
var $6d5b5dc473213ba2$export$a7db06668cad9adb;
var $6d5b5dc473213ba2$export$bb646b20bb93d339;
var $6d5b5dc473213ba2$export$adb608be33961c98;
var $6d5b5dc473213ba2$export$e1ffd7fb0909744f;
var $6d5b5dc473213ba2$export$5c452ff88e35e47d;
var $6d5b5dc473213ba2$export$b7e3ae3d7c15e42e;
var $6d5b5dc473213ba2$export$ed555aaf9acd8e82;
var $6d5b5dc473213ba2$export$66f19efb468ec04a;
var $6d5b5dc473213ba2$export$96e4b36520c26a2c;
var $6d5b5dc473213ba2$export$d70b35ef4da19daf;
var $6d5b5dc473213ba2$export$a34a66643fc3763e;
var $6d5b5dc473213ba2$export$7bb7a178e87bb31e;
var $6d5b5dc473213ba2$export$748238e7dfe20031;
var $6d5b5dc473213ba2$export$de1d529c926dff05;
var $6d5b5dc473213ba2$export$fb184b623420d9be;
var $6d5b5dc473213ba2$export$8291e5b88f90ce4;
$6d5b5dc473213ba2$export$8ce1fd94bee2f412 = `_tFz-q_background`;
$6d5b5dc473213ba2$export$34e0f9847d4c02dd = `_tFz-q_container`;
$6d5b5dc473213ba2$export$a7db06668cad9adb = `_tFz-q_content`;
$6d5b5dc473213ba2$export$bb646b20bb93d339 = `_tFz-q_cross`;
$6d5b5dc473213ba2$export$adb608be33961c98 = `_tFz-q_footer`;
$6d5b5dc473213ba2$export$e1ffd7fb0909744f = `_tFz-q_full-size`;
$6d5b5dc473213ba2$export$5c452ff88e35e47d = `_tFz-q_image`;
$6d5b5dc473213ba2$export$b7e3ae3d7c15e42e = `_tFz-q_input`;
$6d5b5dc473213ba2$export$ed555aaf9acd8e82 = `_tFz-q_loading-content`;
$6d5b5dc473213ba2$export$66f19efb468ec04a = `_tFz-q_loading-modal`;
$6d5b5dc473213ba2$export$96e4b36520c26a2c = `_tFz-q_modal`;
$6d5b5dc473213ba2$export$d70b35ef4da19daf = `_tFz-q_modal-enter`;
$6d5b5dc473213ba2$export$a34a66643fc3763e = `_tFz-q_modal-enter-active`;
$6d5b5dc473213ba2$export$7bb7a178e87bb31e = `_tFz-q_modal-exit`;
$6d5b5dc473213ba2$export$748238e7dfe20031 = `_tFz-q_modal-exit-active`;
$6d5b5dc473213ba2$export$de1d529c926dff05 = `_tFz-q_no-blur`;
$6d5b5dc473213ba2$export$fb184b623420d9be = `_tFz-q_title`;
$6d5b5dc473213ba2$export$8291e5b88f90ce4 = `_tFz-q_window`;


const $207d23274fe2be11$export$a118d25f3bd40bb8 = ({ show: show, children: children, zIndex: zIndex, className: className, onClickBackground: onClickBackground, onExited: onExited, containerClassName: containerClassName, ...props })=>{
    const modalRef = (0, $acw62.useRef)(null);
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $ee2e736fe07a2c40$export$2e2bcd8739ae039), {
        in: show,
        nodeRef: modalRef,
        timeout: 150,
        classNames: {
            enter: (0, $9805619f03ed02ef$export$91884aa883243770)((0, (/*@__PURE__*/$parcel$interopDefault($6d5b5dc473213ba2$exports))), "modal-enter"),
            enterActive: (0, $9805619f03ed02ef$export$91884aa883243770)((0, (/*@__PURE__*/$parcel$interopDefault($6d5b5dc473213ba2$exports))), "modal-enter-active"),
            exit: (0, $9805619f03ed02ef$export$91884aa883243770)((0, (/*@__PURE__*/$parcel$interopDefault($6d5b5dc473213ba2$exports))), "modal-exit"),
            exitActive: (0, $9805619f03ed02ef$export$91884aa883243770)((0, (/*@__PURE__*/$parcel$interopDefault($6d5b5dc473213ba2$exports))), "modal-exit-active")
        },
        onExited: onExited,
        unmountOnExit: true,
        ...props,
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
            ref: modalRef,
            className: (0, $9805619f03ed02ef$export$91884aa883243770)((0, (/*@__PURE__*/$parcel$interopDefault($6d5b5dc473213ba2$exports))), `modal ${className ? className : ""}`),
            style: {
                zIndex: zIndex
            },
            children: [
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                    className: (0, $9805619f03ed02ef$export$91884aa883243770)((0, (/*@__PURE__*/$parcel$interopDefault($6d5b5dc473213ba2$exports))), "background"),
                    onClick: onClickBackground
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                    className: (0, $9805619f03ed02ef$export$91884aa883243770)((0, (/*@__PURE__*/$parcel$interopDefault($6d5b5dc473213ba2$exports))), `container ${containerClassName ? containerClassName : ""}`),
                    children: children
                })
            ]
        })
    });
};
const $207d23274fe2be11$export$6e63c1000ecf9db8 = ({ image: image, title: title, content: content, footer: footer, ...props })=>{
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($207d23274fe2be11$export$a118d25f3bd40bb8, {
        containerClassName: `full-size ${image ? "image" : ""}`,
        ...props,
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
            children: [
                image && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                    src: image
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                    className: (0, $9805619f03ed02ef$export$91884aa883243770)((0, (/*@__PURE__*/$parcel$interopDefault($6d5b5dc473213ba2$exports))), "window"),
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                            className: (0, $9805619f03ed02ef$export$91884aa883243770)((0, (/*@__PURE__*/$parcel$interopDefault($6d5b5dc473213ba2$exports))), "title"),
                            children: title
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                            className: (0, $9805619f03ed02ef$export$91884aa883243770)((0, (/*@__PURE__*/$parcel$interopDefault($6d5b5dc473213ba2$exports))), "content"),
                            children: content
                        }),
                        footer && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                            className: (0, $9805619f03ed02ef$export$91884aa883243770)((0, (/*@__PURE__*/$parcel$interopDefault($6d5b5dc473213ba2$exports))), "footer"),
                            children: footer
                        })
                    ]
                })
            ]
        })
    });
};
const $207d23274fe2be11$export$a530fe7a272dd531 = ({ progress: progress, loadingText: loadingText = "Loading...", className: className, ...props })=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($207d23274fe2be11$export$a118d25f3bd40bb8, {
        ...props,
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
            className: (0, $9805619f03ed02ef$export$91884aa883243770)((0, (/*@__PURE__*/$parcel$interopDefault($6d5b5dc473213ba2$exports))), `modal loading-modal ${className ?? ""}`),
            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: (0, $9805619f03ed02ef$export$91884aa883243770)((0, (/*@__PURE__*/$parcel$interopDefault($6d5b5dc473213ba2$exports))), "loading-content"),
                children: [
                    loadingText,
                    progress !== undefined ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("br", {}),
                            `${progress}%`
                        ]
                    }) : ""
                ]
            })
        })
    });
const $207d23274fe2be11$export$2b77a92f1a5ad772 = ({ closeText: closeText = "close", onClose: onClose, copyText: copyText, text: text, ...props })=>{
    const content = /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7b02d682eb115277$exports.Fragment), {
        children: text
    });
    const footer = /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
        children: [
            copyText && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $6725244138e0595f$export$353f5b6fc5456de1), {
                onClick: ()=>{
                    const copied = (0, (/*@__PURE__*/$parcel$interopDefault($e5a78797c4262d1f$exports)))(copyText);
                    if (copied) (0, $ad26fe773541dcd3$export$b410431fab84fa58).success("Text copied!", {
                        pauseOnFocusLoss: false
                    });
                    else (0, $ad26fe773541dcd3$export$b410431fab84fa58).warn("Impossible to copy the text! Copy manually :-)", {
                        pauseOnFocusLoss: false
                    });
                },
                className: "small",
                children: "copy"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $6725244138e0595f$export$353f5b6fc5456de1), {
                className: (0, $9805619f03ed02ef$export$91884aa883243770)((0, (/*@__PURE__*/$parcel$interopDefault($6d5b5dc473213ba2$exports))), "gray small"),
                onClick: onClose,
                children: closeText
            })
        ]
    });
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($207d23274fe2be11$export$6e63c1000ecf9db8, {
        footer: footer,
        content: content,
        ...props
    });
};
const $207d23274fe2be11$export$8eec1a3a911975a4 = ({ acceptText: acceptText = "ok", refuseText: refuseText, onAccept: onAccept, onRefuse: onRefuse, text: text, ...props })=>{
    const content = /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7b02d682eb115277$exports.Fragment), {
        children: text
    });
    const footer = /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
        children: [
            refuseText && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $6725244138e0595f$export$353f5b6fc5456de1), {
                className: (0, $9805619f03ed02ef$export$91884aa883243770)((0, (/*@__PURE__*/$parcel$interopDefault($6d5b5dc473213ba2$exports))), "gray small"),
                onClick: onRefuse,
                children: refuseText
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $6725244138e0595f$export$353f5b6fc5456de1), {
                onClick: onAccept,
                className: "small",
                children: acceptText
            })
        ]
    });
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($207d23274fe2be11$export$6e63c1000ecf9db8, {
        footer: footer,
        content: content,
        ...props
    });
};
const $207d23274fe2be11$export$635be88faad240d9 = ({ inputProps: inputProps, acceptText: acceptText = "ok", refuseText: refuseText, onAccept: onAccept, onRefuse: onRefuse, text: text, ...props })=>{
    const [value, setValue] = (0, $acw62.useState)("");
    const inputChange = (event)=>{
        setValue(event.target.value);
    };
    const content = /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
        children: [
            text,
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $863b21ed6a3b3d61$export$f5b8910cec6cf069), {
                ...inputProps,
                className: (0, $9805619f03ed02ef$export$91884aa883243770)((0, (/*@__PURE__*/$parcel$interopDefault($6d5b5dc473213ba2$exports))), `${inputProps?.className} input`),
                value: value,
                onChange: inputChange,
                autoFocus: true
            })
        ]
    });
    const footer = /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
        children: [
            refuseText && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $6725244138e0595f$export$353f5b6fc5456de1), {
                className: (0, $9805619f03ed02ef$export$91884aa883243770)((0, (/*@__PURE__*/$parcel$interopDefault($6d5b5dc473213ba2$exports))), "gray small"),
                onClick: onRefuse,
                children: refuseText
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $6725244138e0595f$export$353f5b6fc5456de1), {
                onClick: ()=>onAccept(value),
                className: "small",
                children: acceptText
            })
        ]
    });
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($207d23274fe2be11$export$6e63c1000ecf9db8, {
        footer: footer,
        content: content,
        ...props
    });
};






var $acw62 = parcelRequire("acw62");



const $59b368f70ce80651$export$b500b7f679226a67 = (state, action)=>{
    switch(action.type){
        case "SET_IS_LEDGER":
            if (!action.isLedger) (0, $2b1b88f9a0dfa7a8$export$8e0aeea63de8f9e2)("isLedger");
            else (0, $2b1b88f9a0dfa7a8$export$fa6a5e6b4dafb306)("isLedger", action.isLedger);
            return {
                ...state,
                isLedger: action.isLedger
            };
        case "SET_TWITTER_USERNAME":
            if (!action.twitterUsername) (0, $2b1b88f9a0dfa7a8$export$8e0aeea63de8f9e2)("twitterUsername");
            else (0, $2b1b88f9a0dfa7a8$export$fa6a5e6b4dafb306)("twitterUsername", action.twitterUsername);
            return {
                ...state,
                twitterUsername: action.twitterUsername
            };
        case "SET_DISCORD_USERNAME":
            if (!action.discordUsername) (0, $2b1b88f9a0dfa7a8$export$8e0aeea63de8f9e2)("discordUsername");
            else (0, $2b1b88f9a0dfa7a8$export$fa6a5e6b4dafb306)("discordUsername", action.discordUsername);
            return {
                ...state,
                discordUsername: action.discordUsername
            };
        case "SET_DISCORD_SERVER_JOINED":
            if (!action.discordServerJoined) (0, $2b1b88f9a0dfa7a8$export$8e0aeea63de8f9e2)("discordServerJoined");
            else (0, $2b1b88f9a0dfa7a8$export$fa6a5e6b4dafb306)("discordServerJoined", action.discordServerJoined);
            return {
                ...state,
                discordServerJoined: action.discordServerJoined
            };
        case "SET_USERNAME":
            if (!action.username) (0, $2b1b88f9a0dfa7a8$export$8e0aeea63de8f9e2)("username");
            else (0, $2b1b88f9a0dfa7a8$export$fa6a5e6b4dafb306)("username", action.username);
            return {
                ...state,
                username: action.username
            };
        case "SET_SESSION_TOKEN":
            if (!action.sessionToken) (0, $2b1b88f9a0dfa7a8$export$8e0aeea63de8f9e2)("sessionToken");
            else (0, $2b1b88f9a0dfa7a8$export$fa6a5e6b4dafb306)("sessionToken", action.sessionToken);
            return {
                ...state,
                sessionToken: action.sessionToken
            };
        case "SET_PUBLIC_KEY":
            if (action.publicKey === undefined) (0, $2b1b88f9a0dfa7a8$export$8e0aeea63de8f9e2)("publicKey");
            else (0, $2b1b88f9a0dfa7a8$export$fa6a5e6b4dafb306)("publicKey", action.publicKey);
            return {
                ...state,
                publicKey: action.publicKey
            };
        case "SET_DISCONNECT_WALLET":
            return {
                ...state,
                disconnectWallet: action.disconnectWallet
            };
        case "SET_SHOW_CONNECT_MODAL":
            return {
                ...state,
                showConnectModal: action.showConnectModal
            };
        case "SET_USER_UUID":
            if (action.userUuid === undefined) (0, $2b1b88f9a0dfa7a8$export$8e0aeea63de8f9e2)("userUuid");
            else (0, $2b1b88f9a0dfa7a8$export$fa6a5e6b4dafb306)("userUuid", action.userUuid);
            return {
                ...state,
                userUuid: action.userUuid
            };
        case "SET_LAST_SERVER_URL":
            if (!action.lastServerURL) (0, $2b1b88f9a0dfa7a8$export$8e0aeea63de8f9e2)("lastServerURL");
            else (0, $2b1b88f9a0dfa7a8$export$fa6a5e6b4dafb306)("lastServerURL", action.lastServerURL);
            return {
                ...state,
                lastServerURL: action.lastServerURL
            };
        case "SET_ROOM":
            return {
                ...state,
                room: action.room
            };
        case "SET_ROOM_METADATA":
            return {
                ...state,
                roomMetadata: action.roomMetadata
            };
        case "SET_ROOM_SESSION":
            if (!action.roomSession) (0, $2b1b88f9a0dfa7a8$export$8e0aeea63de8f9e2)("roomSession");
            else (0, $2b1b88f9a0dfa7a8$export$fa6a5e6b4dafb306)("roomSession", action.roomSession);
            return {
                ...state,
                roomSession: action.roomSession
            };
        case "SET_ACCOUNT_INFO":
            if (!action.accountInfo) (0, $2b1b88f9a0dfa7a8$export$8e0aeea63de8f9e2)("accountInfo");
            else (0, $2b1b88f9a0dfa7a8$export$fa6a5e6b4dafb306)("accountInfo", action.accountInfo);
            return {
                ...state,
                accountInfo: action.accountInfo
            };
        case "SET_NAVIGATION":
            return {
                ...state,
                tab: action.tab
            };
        default:
            return state;
    }
};


let $c25623cc446ec3c6$var$initialState = {
    tab: "battle"
};
const $c25623cc446ec3c6$var$info = (0, $2b1b88f9a0dfa7a8$export$28055d25e3f96ec1)();
if ($c25623cc446ec3c6$var$info) {
    $c25623cc446ec3c6$var$initialState = {
        ...$c25623cc446ec3c6$var$initialState,
        ...$c25623cc446ec3c6$var$info
    };
    (0, $b3b1baf40467424d$export$745043c7dc65e495).sessionToken = $c25623cc446ec3c6$var$info.sessionToken;
}
const $c25623cc446ec3c6$export$6a5aa704056d141b = /*#__PURE__*/ (0, $acw62.createContext)({
    state: $c25623cc446ec3c6$var$initialState,
    dispatch: ()=>null
});
const $c25623cc446ec3c6$export$63beeacfc264bbcb = ({ children: children })=>{
    const [state, dispatch] = (0, $acw62.useReducer)((0, $59b368f70ce80651$export$b500b7f679226a67), $c25623cc446ec3c6$var$initialState);
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($c25623cc446ec3c6$export$6a5aa704056d141b.Provider, {
        value: {
            state: state,
            dispatch: dispatch
        },
        children: children
    });
};
const $c25623cc446ec3c6$export$ac8576a9912be18c = ()=>{
    return (0, $acw62.useContext)($c25623cc446ec3c6$export$6a5aa704056d141b);
};


const $4ea79fe64cc4ba62$export$50927ef1fb3dba34 = ()=>{
    const { dispatch: dispatch, state: { disconnectWallet: disconnectWallet } } = (0, $c25623cc446ec3c6$export$ac8576a9912be18c)();
    const navigate = (0, $7939e29d663dd3ed$export$9770f232ac06a008)();
    const disconnect = ()=>{
        dispatch({
            type: "SET_SESSION_TOKEN",
            sessionToken: undefined
        });
        dispatch({
            type: "SET_PUBLIC_KEY",
            publicKey: undefined
        });
        dispatch({
            type: "SET_TWITTER_USERNAME",
            twitterUsername: undefined
        });
        dispatch({
            type: "SET_DISCORD_USERNAME",
            discordUsername: undefined
        });
        //dispatch({type: 'SET_CHAIN', chain: undefined})
        if (disconnectWallet) disconnectWallet();
        (0, $2b1b88f9a0dfa7a8$export$1749eeb4c07401df)();
        navigate("/");
    };
    return {
        disconnect: disconnect
    };
};




var $b15996d86b7e80dd$exports = {};

$parcel$export($b15996d86b7e80dd$exports, "buttons", () => $b15996d86b7e80dd$export$bbea856fdb3e3c5f, (v) => $b15996d86b7e80dd$export$bbea856fdb3e3c5f = v);
$parcel$export($b15996d86b7e80dd$exports, "container", () => $b15996d86b7e80dd$export$34e0f9847d4c02dd, (v) => $b15996d86b7e80dd$export$34e0f9847d4c02dd = v);
$parcel$export($b15996d86b7e80dd$exports, "custom-toast", () => $b15996d86b7e80dd$export$d05917d70147b8b8, (v) => $b15996d86b7e80dd$export$d05917d70147b8b8 = v);
$parcel$export($b15996d86b7e80dd$exports, "hub-layout", () => $b15996d86b7e80dd$export$78eb60493f726b56, (v) => $b15996d86b7e80dd$export$78eb60493f726b56 = v);
$parcel$export($b15996d86b7e80dd$exports, "purple", () => $b15996d86b7e80dd$export$e13cce2a2d16a9d4, (v) => $b15996d86b7e80dd$export$e13cce2a2d16a9d4 = v);
var $b15996d86b7e80dd$export$bbea856fdb3e3c5f;
var $b15996d86b7e80dd$export$34e0f9847d4c02dd;
var $b15996d86b7e80dd$export$d05917d70147b8b8;
var $b15996d86b7e80dd$export$78eb60493f726b56;
var $b15996d86b7e80dd$export$e13cce2a2d16a9d4;
$b15996d86b7e80dd$export$bbea856fdb3e3c5f = `HdTl1G_buttons`;
$b15996d86b7e80dd$export$34e0f9847d4c02dd = `HdTl1G_container`;
$b15996d86b7e80dd$export$d05917d70147b8b8 = `HdTl1G_custom-toast`;
$b15996d86b7e80dd$export$78eb60493f726b56 = `HdTl1G_hub-layout`;
$b15996d86b7e80dd$export$e13cce2a2d16a9d4 = `HdTl1G_purple`;


const $b5ff9c7262ea50db$export$97f984197eab5d2f = ()=>{
    const { disconnect: disconnect } = (0, $4ea79fe64cc4ba62$export$50927ef1fb3dba34)();
    const { state: { sessionToken: sessionToken }, dispatch: dispatch } = (0, $c25623cc446ec3c6$export$ac8576a9912be18c)();
    const [ready, setReady] = (0, $acw62.useState)(false);
    const [maintenance, setMaintenance] = (0, $acw62.useState)();
    const [modalState, setModalState] = (0, $acw62.useState)({
        show: false
    });
    const [confirmState, setConfirmState] = (0, $acw62.useState)({
        show: false
    });
    const [inputState, setInputState] = (0, $acw62.useState)({
        show: false
    });
    const [showLoading, setShowLoading] = (0, $acw62.useState)(false);
    const [loadingProgress, setLoadingProgress] = (0, $acw62.useState)(0);
    const [loadingText, setLoadingText] = (0, $acw62.useState)();
    (0, $acw62.useEffect)(()=>{
        (0, $b3b1baf40467424d$export$745043c7dc65e495).disconnect = disconnect;
        (0, $b3b1baf40467424d$export$745043c7dc65e495).showModal = (props)=>{
            setShowLoading(false);
            setConfirmState({
                show: false
            });
            setInputState({
                show: false
            });
            setModalState({
                show: true,
                ...props
            });
        };
        (0, $b3b1baf40467424d$export$745043c7dc65e495).showConfirm = (props)=>{
            setShowLoading(false);
            setModalState({
                show: false
            });
            setInputState({
                show: false
            });
            setConfirmState({
                show: true,
                ...props
            });
        };
        (0, $b3b1baf40467424d$export$745043c7dc65e495).showInputModal = (props)=>{
            setShowLoading(false);
            setModalState({
                show: false
            });
            setConfirmState({
                show: false
            });
            setInputState({
                show: true,
                ...props
            });
        };
        (0, $b3b1baf40467424d$export$745043c7dc65e495).showLoading = (loading, progress, loadingText)=>{
            setShowLoading(loading);
            setLoadingProgress(progress);
            setLoadingText(loadingText);
        };
        (0, $b3b1baf40467424d$export$745043c7dc65e495).setSessionToken = (sessionToken)=>{
            dispatch({
                type: "SET_SESSION_TOKEN",
                sessionToken: sessionToken
            });
        };
        (0, $b3b1baf40467424d$export$745043c7dc65e495).refreshAccountInfo = async ()=>{
            const accountInfo = await (0, $35a528e84618b070$export$ed6a7eb10310bf8)();
            dispatch({
                type: "SET_ACCOUNT_INFO",
                accountInfo: accountInfo
            });
            return accountInfo;
        };
    }, []);
    (0, $acw62.useEffect)(()=>{
        if ((0, $b3b1baf40467424d$export$745043c7dc65e495).sessionToken && (0, $b3b1baf40467424d$export$745043c7dc65e495).refreshAccountInfo) (0, $b3b1baf40467424d$export$745043c7dc65e495).refreshAccountInfo();
    }, [
        sessionToken
    ]);
    (0, $acw62.useEffect)(()=>{
        const checkMaintenance = async ()=>{
            let result;
            try {
                result = await (0, $95f58df959e5e0cd$export$aead4c4fc7a7fd3e)();
            } catch (err) {
                return false;
            }
            if (!result) return false;
            const service = "hub";
            const maintenanceData = result[service];
            const { fromDate: fromDate, toDate: toDate, id: id, message: message } = maintenanceData;
            if (!fromDate || !toDate || !message) return false;
            if (Date.now() >= new Date(fromDate).getTime() && Date.now() <= new Date(toDate).getTime() && (0, $b3b1baf40467424d$export$745043c7dc65e495).showConfirm) {
                setMaintenance(result.hub);
                (0, $b3b1baf40467424d$export$745043c7dc65e495).showConfirm({
                    title: "Undergoing Maintenance",
                    text: message.replace("${fromDate}", new Date(fromDate).toLocaleString()).replace("${toDate}", new Date(toDate).toLocaleString()),
                    acceptText: "Go to discord",
                    onAccept () {
                        window.location.href = "https://discord.gg/oogy";
                    }
                });
                return true;
            } else if ((0, $2b1b88f9a0dfa7a8$export$8d7ab2c91e5ca67b)(service, id) && Date.now() < new Date(fromDate).getTime() && (0, $b3b1baf40467424d$export$745043c7dc65e495).showConfirm) {
                setMaintenance(undefined);
                (0, $b3b1baf40467424d$export$745043c7dc65e495).showConfirm({
                    title: "Upcoming Maintenance",
                    text: message.replace("${fromDate}", new Date(fromDate).toLocaleString()).replace("${toDate}", new Date(toDate).toLocaleString()),
                    acceptText: "Understood",
                    onAccept () {
                        (0, $2b1b88f9a0dfa7a8$export$24bd3293e6899045)(service, id);
                    }
                });
                return false;
            }
            return false;
        };
        const intervalMaintenance = setInterval(checkMaintenance, 60000);
        checkMaintenance().then((inMaintenance)=>{
            setReady(!inMaintenance);
        });
        return ()=>{
            clearInterval(intervalMaintenance);
        };
    }, []);
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: (0, $9805619f03ed02ef$export$91884aa883243770)((0, (/*@__PURE__*/$parcel$interopDefault($b15996d86b7e80dd$exports))), "hub-layout"),
        children: [
            ready && !maintenance && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7939e29d663dd3ed$export$910ae8079b2c2852), {}),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $207d23274fe2be11$export$2b77a92f1a5ad772), {
                ...modalState,
                onClose: ()=>{
                    if (modalState.onClose) modalState.onClose();
                    setModalState({
                        ...modalState,
                        show: false
                    });
                },
                onHide: ()=>{
                    setModalState({
                        show: false
                    });
                }
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $207d23274fe2be11$export$8eec1a3a911975a4), {
                ...confirmState,
                onAccept: ()=>{
                    if (confirmState.onAccept) confirmState.onAccept();
                    setConfirmState({
                        ...confirmState,
                        show: false
                    });
                },
                onRefuse: ()=>{
                    if (confirmState.onRefuse) confirmState.onRefuse();
                    setConfirmState({
                        ...confirmState,
                        show: false
                    });
                },
                onHide: ()=>{
                    setConfirmState({
                        show: false
                    });
                }
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $207d23274fe2be11$export$635be88faad240d9), {
                ...inputState,
                onAccept: (value)=>{
                    if (inputState.onAccept) inputState.onAccept(value);
                    setInputState({
                        ...inputState,
                        show: false
                    });
                },
                onRefuse: ()=>{
                    if (inputState.onRefuse) inputState.onRefuse();
                    setInputState({
                        ...inputState,
                        show: false
                    });
                },
                onHide: ()=>{
                    setInputState({
                        show: false
                    });
                }
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $207d23274fe2be11$export$a530fe7a272dd531), {
                show: showLoading,
                progress: loadingProgress,
                loadingText: loadingText
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $ad26fe773541dcd3$export$f2815235e76a62b9), {
                toastClassName: (0, $9805619f03ed02ef$export$91884aa883243770)((0, (/*@__PURE__*/$parcel$interopDefault($b15996d86b7e80dd$exports))), "custom-toast"),
                theme: "dark",
                transition: (0, $ad26fe773541dcd3$export$4d2fae537bd90431),
                autoClose: 3000
            })
        ]
    });
};



parcelRequire("acw62");



var $gNDby = parcelRequire("gNDby");

var $acw62 = parcelRequire("acw62");

var $acw62 = parcelRequire("acw62");
const $86c338e4d5b0d511$export$af54d3055d90c64e = (0, $acw62.createContext)({});
function $86c338e4d5b0d511$export$985e8768c0e91dbc() {
    return (0, $acw62.useContext)($86c338e4d5b0d511$export$af54d3055d90c64e);
}


const $95b24e620787a529$export$fd685cf7c99624bd = ({ children: children, endpoint: endpoint, config: config = {
    commitment: "confirmed"
} })=>{
    const connection = (0, $acw62.useMemo)(()=>new (0, $gNDby.Connection)(endpoint, config), [
        endpoint,
        config
    ]);
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $86c338e4d5b0d511$export$af54d3055d90c64e).Provider, {
        value: {
            connection: connection
        }
    }, children);
};


var $3vRz3 = parcelRequire("3vRz3");
class $92c515b2e16b5c4e$export$f46ec6f9dba8711d extends Error {
    // eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
    constructor(message, error){
        super(message);
        this.error = error;
    }
}
class $92c515b2e16b5c4e$export$d65db264eda99cd7 extends $92c515b2e16b5c4e$export$f46ec6f9dba8711d {
    constructor(){
        super(...arguments);
        this.name = "WalletNotReadyError";
    }
}
class $92c515b2e16b5c4e$export$9a551f94af9b0bf8 extends $92c515b2e16b5c4e$export$f46ec6f9dba8711d {
    constructor(){
        super(...arguments);
        this.name = "WalletLoadError";
    }
}
class $92c515b2e16b5c4e$export$9525019988612a5e extends $92c515b2e16b5c4e$export$f46ec6f9dba8711d {
    constructor(){
        super(...arguments);
        this.name = "WalletConfigError";
    }
}
class $92c515b2e16b5c4e$export$38f21f1c810261c7 extends $92c515b2e16b5c4e$export$f46ec6f9dba8711d {
    constructor(){
        super(...arguments);
        this.name = "WalletConnectionError";
    }
}
class $92c515b2e16b5c4e$export$bf7028c52ebda81e extends $92c515b2e16b5c4e$export$f46ec6f9dba8711d {
    constructor(){
        super(...arguments);
        this.name = "WalletDisconnectedError";
    }
}
class $92c515b2e16b5c4e$export$92e2b26fad5723ee extends $92c515b2e16b5c4e$export$f46ec6f9dba8711d {
    constructor(){
        super(...arguments);
        this.name = "WalletDisconnectionError";
    }
}
class $92c515b2e16b5c4e$export$cd6fa2f8e2a8a612 extends $92c515b2e16b5c4e$export$f46ec6f9dba8711d {
    constructor(){
        super(...arguments);
        this.name = "WalletAccountError";
    }
}
class $92c515b2e16b5c4e$export$735bef3bfb0f2c86 extends $92c515b2e16b5c4e$export$f46ec6f9dba8711d {
    constructor(){
        super(...arguments);
        this.name = "WalletPublicKeyError";
    }
}
class $92c515b2e16b5c4e$export$c2957028686b1575 extends $92c515b2e16b5c4e$export$f46ec6f9dba8711d {
    constructor(){
        super(...arguments);
        this.name = "WalletKeypairError";
    }
}
class $92c515b2e16b5c4e$export$313d299817c74896 extends $92c515b2e16b5c4e$export$f46ec6f9dba8711d {
    constructor(){
        super(...arguments);
        this.name = "WalletNotConnectedError";
    }
}
class $92c515b2e16b5c4e$export$769332ac3f90f46c extends $92c515b2e16b5c4e$export$f46ec6f9dba8711d {
    constructor(){
        super(...arguments);
        this.name = "WalletSendTransactionError";
    }
}
class $92c515b2e16b5c4e$export$96f177062fdd8180 extends $92c515b2e16b5c4e$export$f46ec6f9dba8711d {
    constructor(){
        super(...arguments);
        this.name = "WalletSignTransactionError";
    }
}
class $92c515b2e16b5c4e$export$2622c1721bbd4b17 extends $92c515b2e16b5c4e$export$f46ec6f9dba8711d {
    constructor(){
        super(...arguments);
        this.name = "WalletSignMessageError";
    }
}
class $92c515b2e16b5c4e$export$a4c7d3c66e3cdd6c extends $92c515b2e16b5c4e$export$f46ec6f9dba8711d {
    constructor(){
        super(...arguments);
        this.name = "WalletSignInError";
    }
}
class $92c515b2e16b5c4e$export$ec3efbdc71ef5c8c extends $92c515b2e16b5c4e$export$f46ec6f9dba8711d {
    constructor(){
        super(...arguments);
        this.name = "WalletTimeoutError";
    }
}
class $92c515b2e16b5c4e$export$c87b9320dc154c95 extends $92c515b2e16b5c4e$export$f46ec6f9dba8711d {
    constructor(){
        super(...arguments);
        this.name = "WalletWindowBlockedError";
    }
}
class $92c515b2e16b5c4e$export$d02b2d00a97edcea extends $92c515b2e16b5c4e$export$f46ec6f9dba8711d {
    constructor(){
        super(...arguments);
        this.name = "WalletWindowClosedError";
    }
}


var $a27aaf340df890aa$export$2a7b8071105d05b6;
(function(WalletReadyState) {
    /**
     * User-installable wallets can typically be detected by scanning for an API
     * that they've injected into the global context. If such an API is present,
     * we consider the wallet to have been installed.
     */ WalletReadyState["Installed"] = "Installed";
    WalletReadyState["NotDetected"] = "NotDetected";
    /**
     * Loadable wallets are always available to you. Since you can load them at
     * any time, it's meaningless to say that they have been detected.
     */ WalletReadyState["Loadable"] = "Loadable";
    /**
     * If a wallet is not supported on a given platform (eg. server-rendering, or
     * mobile) then it will stay in the `Unsupported` state.
     */ WalletReadyState["Unsupported"] = "Unsupported";
})($a27aaf340df890aa$export$2a7b8071105d05b6 || ($a27aaf340df890aa$export$2a7b8071105d05b6 = {}));
class $a27aaf340df890aa$export$2af1ea2892adc469 extends (0, (/*@__PURE__*/$parcel$interopDefault($3vRz3))) {
    get connected() {
        return !!this.publicKey;
    }
    async autoConnect() {
        await this.connect();
    }
    async prepareTransaction(transaction, connection, options = {}) {
        const publicKey = this.publicKey;
        if (!publicKey) throw new (0, $92c515b2e16b5c4e$export$313d299817c74896)();
        transaction.feePayer = transaction.feePayer || publicKey;
        transaction.recentBlockhash = transaction.recentBlockhash || (await connection.getLatestBlockhash({
            commitment: options.preflightCommitment,
            minContextSlot: options.minContextSlot
        })).blockhash;
        return transaction;
    }
}
function $a27aaf340df890aa$export$378bae4c88e0b46e(detect) {
    // Early return when server-side rendering
    if (typeof window === "undefined" || typeof document === "undefined") return;
    const disposers = [];
    function detectAndDispose() {
        const detected = detect();
        if (detected) for (const dispose of disposers)dispose();
    }
    // Strategy #1: Try detecting every second.
    const interval = // TODO: #334 Replace with idle callback strategy.
    setInterval(detectAndDispose, 1000);
    disposers.push(()=>clearInterval(interval));
    // Strategy #2: Detect as soon as the DOM becomes 'ready'/'interactive'.
    if (// Implies that `DOMContentLoaded` has not yet fired.
    document.readyState === "loading") {
        document.addEventListener("DOMContentLoaded", detectAndDispose, {
            once: true
        });
        disposers.push(()=>document.removeEventListener("DOMContentLoaded", detectAndDispose));
    }
    // Strategy #3: Detect after the `window` has fully loaded.
    if (// If the `complete` state has been reached, we're too late.
    document.readyState !== "complete") {
        window.addEventListener("load", detectAndDispose, {
            once: true
        });
        disposers.push(()=>window.removeEventListener("load", detectAndDispose));
    }
    // Strategy #4: Detect synchronously, now.
    detectAndDispose();
}
function $a27aaf340df890aa$export$bf89b558d1e273a2() {
    // SSR: return false
    if (!navigator) return false;
    const userAgent = navigator.userAgent.toLowerCase();
    // if on iOS the user agent will contain either iPhone or iPad
    // caveat: if requesting desktop site then this won't work
    const isIos = userAgent.includes("iphone") || userAgent.includes("ipad");
    // if in a webview then it will not include Safari
    // note that other iOS browsers also include Safari
    // so we will redirect only if Safari is also included
    const isSafari = userAgent.includes("safari");
    return isIos && isSafari;
}



function $afa5c06c212ba160$export$37ce1cc82e255d8(transaction) {
    return "version" in transaction;
}


class $71b3859dfb523e38$export$9a51bf5d1bea9e98 extends (0, $a27aaf340df890aa$export$2af1ea2892adc469) {
    async sendTransaction(transaction, connection, options = {}) {
        let emit = true;
        try {
            if ((0, $afa5c06c212ba160$export$37ce1cc82e255d8)(transaction)) {
                if (!this.supportedTransactionVersions) throw new (0, $92c515b2e16b5c4e$export$769332ac3f90f46c)(`Sending versioned transactions isn't supported by this wallet`);
                if (!this.supportedTransactionVersions.has(transaction.version)) throw new (0, $92c515b2e16b5c4e$export$769332ac3f90f46c)(`Sending transaction version ${transaction.version} isn't supported by this wallet`);
                try {
                    transaction = await this.signTransaction(transaction);
                    const rawTransaction = transaction.serialize();
                    return await connection.sendRawTransaction(rawTransaction, options);
                } catch (error) {
                    // If the error was thrown by `signTransaction`, rethrow it and don't emit a duplicate event
                    if (error instanceof (0, $92c515b2e16b5c4e$export$96f177062fdd8180)) {
                        emit = false;
                        throw error;
                    }
                    throw new (0, $92c515b2e16b5c4e$export$769332ac3f90f46c)(error?.message, error);
                }
            } else try {
                const { signers: signers, ...sendOptions } = options;
                transaction = await this.prepareTransaction(transaction, connection, sendOptions);
                signers?.length && transaction.partialSign(...signers);
                transaction = await this.signTransaction(transaction);
                const rawTransaction = transaction.serialize();
                return await connection.sendRawTransaction(rawTransaction, sendOptions);
            } catch (error) {
                // If the error was thrown by `signTransaction`, rethrow it and don't emit a duplicate event
                if (error instanceof (0, $92c515b2e16b5c4e$export$96f177062fdd8180)) {
                    emit = false;
                    throw error;
                }
                throw new (0, $92c515b2e16b5c4e$export$769332ac3f90f46c)(error?.message, error);
            }
        } catch (error) {
            if (emit) this.emit("error", error);
            throw error;
        }
    }
    async signAllTransactions(transactions) {
        for (const transaction of transactions)if ((0, $afa5c06c212ba160$export$37ce1cc82e255d8)(transaction)) {
            if (!this.supportedTransactionVersions) throw new (0, $92c515b2e16b5c4e$export$96f177062fdd8180)(`Signing versioned transactions isn't supported by this wallet`);
            if (!this.supportedTransactionVersions.has(transaction.version)) throw new (0, $92c515b2e16b5c4e$export$96f177062fdd8180)(`Signing transaction version ${transaction.version} isn't supported by this wallet`);
        }
        const signedTransactions = [];
        for (const transaction of transactions)signedTransactions.push(await this.signTransaction(transaction));
        return signedTransactions;
    }
}
class $71b3859dfb523e38$export$9db08bcddd106c96 extends $71b3859dfb523e38$export$9a51bf5d1bea9e98 {
}
class $71b3859dfb523e38$export$9779f871ffdb3d87 extends $71b3859dfb523e38$export$9db08bcddd106c96 {
}



var $gNDby = parcelRequire("gNDby");

var $gNDby = parcelRequire("gNDby");
// Typescript `enums` thwart tree-shaking. See https://bargsten.org/jsts/enums/
const $88d5506019c7f5ad$export$93083e877aec7a8a = {
    ERROR_ASSOCIATION_PORT_OUT_OF_RANGE: "ERROR_ASSOCIATION_PORT_OUT_OF_RANGE",
    ERROR_FORBIDDEN_WALLET_BASE_URL: "ERROR_FORBIDDEN_WALLET_BASE_URL",
    ERROR_SECURE_CONTEXT_REQUIRED: "ERROR_SECURE_CONTEXT_REQUIRED",
    ERROR_SESSION_CLOSED: "ERROR_SESSION_CLOSED",
    ERROR_SESSION_TIMEOUT: "ERROR_SESSION_TIMEOUT",
    ERROR_WALLET_NOT_FOUND: "ERROR_WALLET_NOT_FOUND"
};
class $88d5506019c7f5ad$export$d77545679c409b63 extends Error {
    constructor(...args){
        const [code, message, data] = args;
        super(message);
        this.code = code;
        this.data = data;
        this.name = "SolanaMobileWalletAdapterError";
    }
}
// Typescript `enums` thwart tree-shaking. See https://bargsten.org/jsts/enums/
const $88d5506019c7f5ad$export$23d27841621bc1e8 = {
    // Keep these in sync with `mobilewalletadapter/common/ProtocolContract.java`.
    ERROR_AUTHORIZATION_FAILED: -1,
    ERROR_INVALID_PAYLOADS: -2,
    ERROR_NOT_SIGNED: -3,
    ERROR_NOT_SUBMITTED: -4,
    ERROR_TOO_MANY_PAYLOADS: -5,
    ERROR_ATTEST_ORIGIN_ANDROID: -100
};
class $88d5506019c7f5ad$export$58b788f937123c66 extends Error {
    constructor(...args){
        const [jsonRpcMessageId, code, message, data] = args;
        super(message);
        this.code = code;
        this.data = data;
        this.jsonRpcMessageId = jsonRpcMessageId;
        this.name = "SolanaMobileWalletAdapterProtocolError";
    }
}
/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ function $88d5506019c7f5ad$var$__awaiter(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}
function $88d5506019c7f5ad$var$createHelloReq(ecdhPublicKey, associationKeypairPrivateKey) {
    return $88d5506019c7f5ad$var$__awaiter(this, void 0, void 0, function*() {
        const publicKeyBuffer = yield crypto.subtle.exportKey("raw", ecdhPublicKey);
        const signatureBuffer = yield crypto.subtle.sign({
            hash: "SHA-256",
            name: "ECDSA"
        }, associationKeypairPrivateKey, publicKeyBuffer);
        const response = new Uint8Array(publicKeyBuffer.byteLength + signatureBuffer.byteLength);
        response.set(new Uint8Array(publicKeyBuffer), 0);
        response.set(new Uint8Array(signatureBuffer), publicKeyBuffer.byteLength);
        return response;
    });
}
const $88d5506019c7f5ad$var$SEQUENCE_NUMBER_BYTES = 4;
function $88d5506019c7f5ad$var$createSequenceNumberVector(sequenceNumber) {
    if (sequenceNumber >= 4294967296) throw new Error("Outbound sequence number overflow. The maximum sequence number is 32-bytes.");
    const byteArray = new ArrayBuffer($88d5506019c7f5ad$var$SEQUENCE_NUMBER_BYTES);
    const view = new DataView(byteArray);
    view.setUint32(0, sequenceNumber, /* littleEndian */ false);
    return new Uint8Array(byteArray);
}
function $88d5506019c7f5ad$var$generateAssociationKeypair() {
    return $88d5506019c7f5ad$var$__awaiter(this, void 0, void 0, function*() {
        return yield crypto.subtle.generateKey({
            name: "ECDSA",
            namedCurve: "P-256"
        }, false, [
            "sign"
        ]);
    });
}
function $88d5506019c7f5ad$var$generateECDHKeypair() {
    return $88d5506019c7f5ad$var$__awaiter(this, void 0, void 0, function*() {
        return yield crypto.subtle.generateKey({
            name: "ECDH",
            namedCurve: "P-256"
        }, false, [
            "deriveKey",
            "deriveBits"
        ]);
    });
}
const $88d5506019c7f5ad$var$INITIALIZATION_VECTOR_BYTES = 12;
function $88d5506019c7f5ad$var$encryptJsonRpcMessage(jsonRpcMessage, sharedSecret) {
    return $88d5506019c7f5ad$var$__awaiter(this, void 0, void 0, function*() {
        const plaintext = JSON.stringify(jsonRpcMessage);
        const sequenceNumberVector = $88d5506019c7f5ad$var$createSequenceNumberVector(jsonRpcMessage.id);
        const initializationVector = new Uint8Array($88d5506019c7f5ad$var$INITIALIZATION_VECTOR_BYTES);
        crypto.getRandomValues(initializationVector);
        const ciphertext = yield crypto.subtle.encrypt($88d5506019c7f5ad$var$getAlgorithmParams(sequenceNumberVector, initializationVector), sharedSecret, new TextEncoder().encode(plaintext));
        const response = new Uint8Array(sequenceNumberVector.byteLength + initializationVector.byteLength + ciphertext.byteLength);
        response.set(new Uint8Array(sequenceNumberVector), 0);
        response.set(new Uint8Array(initializationVector), sequenceNumberVector.byteLength);
        response.set(new Uint8Array(ciphertext), sequenceNumberVector.byteLength + initializationVector.byteLength);
        return response;
    });
}
function $88d5506019c7f5ad$var$decryptJsonRpcMessage(message, sharedSecret) {
    return $88d5506019c7f5ad$var$__awaiter(this, void 0, void 0, function*() {
        const sequenceNumberVector = message.slice(0, $88d5506019c7f5ad$var$SEQUENCE_NUMBER_BYTES);
        const initializationVector = message.slice($88d5506019c7f5ad$var$SEQUENCE_NUMBER_BYTES, $88d5506019c7f5ad$var$SEQUENCE_NUMBER_BYTES + $88d5506019c7f5ad$var$INITIALIZATION_VECTOR_BYTES);
        const ciphertext = message.slice($88d5506019c7f5ad$var$SEQUENCE_NUMBER_BYTES + $88d5506019c7f5ad$var$INITIALIZATION_VECTOR_BYTES);
        const plaintextBuffer = yield crypto.subtle.decrypt($88d5506019c7f5ad$var$getAlgorithmParams(sequenceNumberVector, initializationVector), sharedSecret, ciphertext);
        const plaintext = $88d5506019c7f5ad$var$getUtf8Decoder().decode(plaintextBuffer);
        const jsonRpcMessage = JSON.parse(plaintext);
        if (Object.hasOwnProperty.call(jsonRpcMessage, "error")) throw new $88d5506019c7f5ad$export$58b788f937123c66(jsonRpcMessage.id, jsonRpcMessage.error.code, jsonRpcMessage.error.message);
        return jsonRpcMessage;
    });
}
function $88d5506019c7f5ad$var$getAlgorithmParams(sequenceNumber, initializationVector) {
    return {
        additionalData: sequenceNumber,
        iv: initializationVector,
        name: "AES-GCM",
        tagLength: 128
    };
}
let $88d5506019c7f5ad$var$_utf8Decoder;
function $88d5506019c7f5ad$var$getUtf8Decoder() {
    if ($88d5506019c7f5ad$var$_utf8Decoder === undefined) $88d5506019c7f5ad$var$_utf8Decoder = new TextDecoder("utf-8");
    return $88d5506019c7f5ad$var$_utf8Decoder;
}
function $88d5506019c7f5ad$var$parseHelloRsp(payloadBuffer, associationPublicKey, ecdhPrivateKey) {
    return $88d5506019c7f5ad$var$__awaiter(this, void 0, void 0, function*() {
        const [associationPublicKeyBuffer, walletPublicKey] = yield Promise.all([
            crypto.subtle.exportKey("raw", associationPublicKey),
            crypto.subtle.importKey("raw", payloadBuffer, {
                name: "ECDH",
                namedCurve: "P-256"
            }, false, [])
        ]);
        const sharedSecret = yield crypto.subtle.deriveBits({
            name: "ECDH",
            public: walletPublicKey
        }, ecdhPrivateKey, 256);
        const ecdhSecretKey = yield crypto.subtle.importKey("raw", sharedSecret, "HKDF", false, [
            "deriveKey"
        ]);
        const aesKeyMaterialVal = yield crypto.subtle.deriveKey({
            name: "HKDF",
            hash: "SHA-256",
            salt: new Uint8Array(associationPublicKeyBuffer),
            info: new Uint8Array()
        }, ecdhSecretKey, {
            name: "AES-GCM",
            length: 128
        }, false, [
            "encrypt",
            "decrypt"
        ]);
        return aesKeyMaterialVal;
    });
}
function $88d5506019c7f5ad$var$getRandomAssociationPort() {
    return $88d5506019c7f5ad$var$assertAssociationPort(49152 + Math.floor(Math.random() * 16384));
}
function $88d5506019c7f5ad$var$assertAssociationPort(port) {
    if (port < 49152 || port > 65535) throw new $88d5506019c7f5ad$export$d77545679c409b63($88d5506019c7f5ad$export$93083e877aec7a8a.ERROR_ASSOCIATION_PORT_OUT_OF_RANGE, `Association port number must be between 49152 and 65535. ${port} given.`, {
        port: port
    });
    return port;
}
// https://stackoverflow.com/a/9458996/802047
function $88d5506019c7f5ad$var$arrayBufferToBase64String(buffer) {
    let binary = "";
    const bytes = new Uint8Array(buffer);
    const len = bytes.byteLength;
    for(let ii = 0; ii < len; ii++)binary += String.fromCharCode(bytes[ii]);
    return window.btoa(binary);
}
function $88d5506019c7f5ad$var$getStringWithURLUnsafeCharactersReplaced(unsafeBase64EncodedString) {
    return unsafeBase64EncodedString.replace(/[/+=]/g, (m)=>({
            "/": "_",
            "+": "-",
            "=": "."
        })[m]);
}
const $88d5506019c7f5ad$var$INTENT_NAME = "solana-wallet";
function $88d5506019c7f5ad$var$getPathParts(pathString) {
    return pathString// Strip leading and trailing slashes
    .replace(/(^\/+|\/+$)/g, "")// Return an array of directories
    .split("/");
}
function $88d5506019c7f5ad$var$getIntentURL(methodPathname, intentUrlBase) {
    let baseUrl = null;
    if (intentUrlBase) {
        try {
            baseUrl = new URL(intentUrlBase);
        } catch (_a) {} // eslint-disable-line no-empty
        if ((baseUrl === null || baseUrl === void 0 ? void 0 : baseUrl.protocol) !== "https:") throw new $88d5506019c7f5ad$export$d77545679c409b63($88d5506019c7f5ad$export$93083e877aec7a8a.ERROR_FORBIDDEN_WALLET_BASE_URL, "Base URLs supplied by wallets must be valid `https` URLs");
    }
    baseUrl || (baseUrl = new URL(`${$88d5506019c7f5ad$var$INTENT_NAME}:/`));
    const pathname = methodPathname.startsWith("/") ? methodPathname : [
        ...$88d5506019c7f5ad$var$getPathParts(baseUrl.pathname),
        ...$88d5506019c7f5ad$var$getPathParts(methodPathname)
    ].join("/");
    return new URL(pathname, baseUrl);
}
function $88d5506019c7f5ad$var$getAssociateAndroidIntentURL(associationPublicKey, putativePort, associationURLBase) {
    return $88d5506019c7f5ad$var$__awaiter(this, void 0, void 0, function*() {
        const associationPort = $88d5506019c7f5ad$var$assertAssociationPort(putativePort);
        const exportedKey = yield crypto.subtle.exportKey("raw", associationPublicKey);
        const encodedKey = $88d5506019c7f5ad$var$arrayBufferToBase64String(exportedKey);
        const url = $88d5506019c7f5ad$var$getIntentURL("v1/associate/local", associationURLBase);
        url.searchParams.set("association", $88d5506019c7f5ad$var$getStringWithURLUnsafeCharactersReplaced(encodedKey));
        url.searchParams.set("port", `${associationPort}`);
        return url;
    });
}
// Typescript `enums` thwart tree-shaking. See https://bargsten.org/jsts/enums/
const $88d5506019c7f5ad$var$Browser = {
    Firefox: 0,
    Other: 1
};
function $88d5506019c7f5ad$var$assertUnreachable(x) {
    return x;
}
function $88d5506019c7f5ad$var$getBrowser() {
    return navigator.userAgent.indexOf("Firefox/") !== -1 ? $88d5506019c7f5ad$var$Browser.Firefox : $88d5506019c7f5ad$var$Browser.Other;
}
function $88d5506019c7f5ad$var$getDetectionPromise() {
    // Chrome and others silently fail if a custom protocol is not supported.
    // For these, we wait to see if the browser is navigated away from in
    // a reasonable amount of time (ie. the native wallet opened).
    return new Promise((resolve, reject)=>{
        function cleanup() {
            clearTimeout(timeoutId);
            window.removeEventListener("blur", handleBlur);
        }
        function handleBlur() {
            cleanup();
            resolve();
        }
        window.addEventListener("blur", handleBlur);
        const timeoutId = setTimeout(()=>{
            cleanup();
            reject();
        }, 2000);
    });
}
let $88d5506019c7f5ad$var$_frame = null;
function $88d5506019c7f5ad$var$launchUrlThroughHiddenFrame(url) {
    if ($88d5506019c7f5ad$var$_frame == null) {
        $88d5506019c7f5ad$var$_frame = document.createElement("iframe");
        $88d5506019c7f5ad$var$_frame.style.display = "none";
        document.body.appendChild($88d5506019c7f5ad$var$_frame);
    }
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    $88d5506019c7f5ad$var$_frame.contentWindow.location.href = url.toString();
}
function $88d5506019c7f5ad$var$startSession(associationPublicKey, associationURLBase) {
    return $88d5506019c7f5ad$var$__awaiter(this, void 0, void 0, function*() {
        const randomAssociationPort = $88d5506019c7f5ad$var$getRandomAssociationPort();
        const associationUrl = yield $88d5506019c7f5ad$var$getAssociateAndroidIntentURL(associationPublicKey, randomAssociationPort, associationURLBase);
        if (associationUrl.protocol === "https:") // The association URL is an Android 'App Link' or iOS 'Universal Link'.
        // These are regular web URLs that are designed to launch an app if it
        // is installed or load the actual target webpage if not.
        window.location.assign(associationUrl);
        else // The association URL has a custom protocol (eg. `solana-wallet:`)
        try {
            const browser = $88d5506019c7f5ad$var$getBrowser();
            switch(browser){
                case $88d5506019c7f5ad$var$Browser.Firefox:
                    // If a custom protocol is not supported in Firefox, it throws.
                    $88d5506019c7f5ad$var$launchUrlThroughHiddenFrame(associationUrl);
                    break;
                case $88d5506019c7f5ad$var$Browser.Other:
                    {
                        const detectionPromise = $88d5506019c7f5ad$var$getDetectionPromise();
                        window.location.assign(associationUrl);
                        yield detectionPromise;
                        break;
                    }
                default:
                    $88d5506019c7f5ad$var$assertUnreachable(browser);
            }
        } catch (e) {
            throw new $88d5506019c7f5ad$export$d77545679c409b63($88d5506019c7f5ad$export$93083e877aec7a8a.ERROR_WALLET_NOT_FOUND, "Found no installed wallet that supports the mobile wallet protocol.");
        }
        return randomAssociationPort;
    });
}
const $88d5506019c7f5ad$var$WEBSOCKET_CONNECTION_CONFIG = {
    /**
     * 300 milliseconds is a generally accepted threshold for what someone
     * would consider an acceptable response time for a user interface
     * after having performed a low-attention tapping task. We set the initial
     * interval at which we wait for the wallet to set up the websocket at
     * half this, as per the Nyquist frequency, with a progressive backoff
     * sequence from there. The total wait time is 30s, which allows for the
     * user to be presented with a disambiguation dialog, select a wallet, and
     * for the wallet app to subsequently start.
     */ retryDelayScheduleMs: [
        150,
        150,
        200,
        500,
        500,
        750,
        750,
        1000
    ],
    timeoutMs: 30000
};
const $88d5506019c7f5ad$var$WEBSOCKET_PROTOCOL = "com.solana.mobilewalletadapter.v1";
function $88d5506019c7f5ad$var$assertSecureContext() {
    if (typeof window === "undefined" || window.isSecureContext !== true) throw new $88d5506019c7f5ad$export$d77545679c409b63($88d5506019c7f5ad$export$93083e877aec7a8a.ERROR_SECURE_CONTEXT_REQUIRED, "The mobile wallet adapter protocol must be used in a secure context (`https`).");
}
function $88d5506019c7f5ad$var$assertSecureEndpointSpecificURI(walletUriBase) {
    let url;
    try {
        url = new URL(walletUriBase);
    } catch (_a) {
        throw new $88d5506019c7f5ad$export$d77545679c409b63($88d5506019c7f5ad$export$93083e877aec7a8a.ERROR_FORBIDDEN_WALLET_BASE_URL, "Invalid base URL supplied by wallet");
    }
    if (url.protocol !== "https:") throw new $88d5506019c7f5ad$export$d77545679c409b63($88d5506019c7f5ad$export$93083e877aec7a8a.ERROR_FORBIDDEN_WALLET_BASE_URL, "Base URLs supplied by wallets must be valid `https` URLs");
}
function $88d5506019c7f5ad$var$getSequenceNumberFromByteArray(byteArray) {
    const view = new DataView(byteArray);
    return view.getUint32(0, /* littleEndian */ false);
}
function $88d5506019c7f5ad$export$dac1bad6146b2469(callback, config) {
    return $88d5506019c7f5ad$var$__awaiter(this, void 0, void 0, function*() {
        $88d5506019c7f5ad$var$assertSecureContext();
        const associationKeypair = yield $88d5506019c7f5ad$var$generateAssociationKeypair();
        const sessionPort = yield $88d5506019c7f5ad$var$startSession(associationKeypair.publicKey, config === null || config === void 0 ? void 0 : config.baseUri);
        const websocketURL = `ws://localhost:${sessionPort}/solana-wallet`;
        let connectionStartTime;
        const getNextRetryDelayMs = (()=>{
            const schedule = [
                ...$88d5506019c7f5ad$var$WEBSOCKET_CONNECTION_CONFIG.retryDelayScheduleMs
            ];
            return ()=>schedule.length > 1 ? schedule.shift() : schedule[0];
        })();
        let nextJsonRpcMessageId = 1;
        let lastKnownInboundSequenceNumber = 0;
        let state = {
            __type: "disconnected"
        };
        return new Promise((resolve, reject)=>{
            let socket;
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            const jsonRpcResponsePromises = {};
            const handleOpen = ()=>$88d5506019c7f5ad$var$__awaiter(this, void 0, void 0, function*() {
                    if (state.__type !== "connecting") {
                        console.warn("Expected adapter state to be `connecting` at the moment the websocket opens. " + `Got \`${state.__type}\`.`);
                        return;
                    }
                    const { associationKeypair: associationKeypair } = state;
                    socket.removeEventListener("open", handleOpen);
                    const ecdhKeypair = yield $88d5506019c7f5ad$var$generateECDHKeypair();
                    socket.send((yield $88d5506019c7f5ad$var$createHelloReq(ecdhKeypair.publicKey, associationKeypair.privateKey)));
                    state = {
                        __type: "hello_req_sent",
                        associationPublicKey: associationKeypair.publicKey,
                        ecdhPrivateKey: ecdhKeypair.privateKey
                    };
                });
            const handleClose = (evt)=>{
                if (evt.wasClean) state = {
                    __type: "disconnected"
                };
                else reject(new $88d5506019c7f5ad$export$d77545679c409b63($88d5506019c7f5ad$export$93083e877aec7a8a.ERROR_SESSION_CLOSED, `The wallet session dropped unexpectedly (${evt.code}: ${evt.reason}).`, {
                    closeEvent: evt
                }));
                disposeSocket();
            };
            const handleError = (_evt)=>$88d5506019c7f5ad$var$__awaiter(this, void 0, void 0, function*() {
                    disposeSocket();
                    if (Date.now() - connectionStartTime >= $88d5506019c7f5ad$var$WEBSOCKET_CONNECTION_CONFIG.timeoutMs) reject(new $88d5506019c7f5ad$export$d77545679c409b63($88d5506019c7f5ad$export$93083e877aec7a8a.ERROR_SESSION_TIMEOUT, `Failed to connect to the wallet websocket on port ${sessionPort}.`));
                    else {
                        yield new Promise((resolve)=>{
                            const retryDelayMs = getNextRetryDelayMs();
                            retryWaitTimeoutId = window.setTimeout(resolve, retryDelayMs);
                        });
                        attemptSocketConnection();
                    }
                });
            const handleMessage = (evt)=>$88d5506019c7f5ad$var$__awaiter(this, void 0, void 0, function*() {
                    const responseBuffer = yield evt.data.arrayBuffer();
                    switch(state.__type){
                        case "connected":
                            try {
                                const sequenceNumberVector = responseBuffer.slice(0, $88d5506019c7f5ad$var$SEQUENCE_NUMBER_BYTES);
                                const sequenceNumber = $88d5506019c7f5ad$var$getSequenceNumberFromByteArray(sequenceNumberVector);
                                if (sequenceNumber !== lastKnownInboundSequenceNumber + 1) throw new Error("Encrypted message has invalid sequence number");
                                lastKnownInboundSequenceNumber = sequenceNumber;
                                const jsonRpcMessage = yield $88d5506019c7f5ad$var$decryptJsonRpcMessage(responseBuffer, state.sharedSecret);
                                const responsePromise = jsonRpcResponsePromises[jsonRpcMessage.id];
                                delete jsonRpcResponsePromises[jsonRpcMessage.id];
                                responsePromise.resolve(jsonRpcMessage.result);
                            } catch (e) {
                                if (e instanceof $88d5506019c7f5ad$export$58b788f937123c66) {
                                    const responsePromise = jsonRpcResponsePromises[e.jsonRpcMessageId];
                                    delete jsonRpcResponsePromises[e.jsonRpcMessageId];
                                    responsePromise.reject(e);
                                } else throw e;
                            }
                            break;
                        case "hello_req_sent":
                            {
                                const sharedSecret = yield $88d5506019c7f5ad$var$parseHelloRsp(responseBuffer, state.associationPublicKey, state.ecdhPrivateKey);
                                state = {
                                    __type: "connected",
                                    sharedSecret: sharedSecret
                                };
                                const wallet = new Proxy({}, {
                                    get (target, p) {
                                        if (target[p] == null) {
                                            const method = p.toString().replace(/[A-Z]/g, (letter)=>`_${letter.toLowerCase()}`).toLowerCase();
                                            target[p] = function(params) {
                                                return $88d5506019c7f5ad$var$__awaiter(this, void 0, void 0, function*() {
                                                    const id = nextJsonRpcMessageId++;
                                                    socket.send((yield $88d5506019c7f5ad$var$encryptJsonRpcMessage({
                                                        id: id,
                                                        jsonrpc: "2.0",
                                                        method: method,
                                                        params: params !== null && params !== void 0 ? params : {}
                                                    }, sharedSecret)));
                                                    return new Promise((resolve, reject)=>{
                                                        jsonRpcResponsePromises[id] = {
                                                            resolve (result) {
                                                                switch(p){
                                                                    case "authorize":
                                                                    case "reauthorize":
                                                                        {
                                                                            const { wallet_uri_base: wallet_uri_base } = result;
                                                                            if (wallet_uri_base != null) try {
                                                                                $88d5506019c7f5ad$var$assertSecureEndpointSpecificURI(wallet_uri_base);
                                                                            } catch (e) {
                                                                                reject(e);
                                                                                return;
                                                                            }
                                                                            break;
                                                                        }
                                                                }
                                                                resolve(result);
                                                            },
                                                            reject: reject
                                                        };
                                                    });
                                                });
                                            };
                                        }
                                        return target[p];
                                    },
                                    defineProperty () {
                                        return false;
                                    },
                                    deleteProperty () {
                                        return false;
                                    }
                                });
                                try {
                                    resolve((yield callback(wallet)));
                                } catch (e) {
                                    reject(e);
                                } finally{
                                    disposeSocket();
                                    socket.close();
                                }
                                break;
                            }
                    }
                });
            let disposeSocket;
            let retryWaitTimeoutId;
            const attemptSocketConnection = ()=>{
                if (disposeSocket) disposeSocket();
                state = {
                    __type: "connecting",
                    associationKeypair: associationKeypair
                };
                if (connectionStartTime === undefined) connectionStartTime = Date.now();
                socket = new WebSocket(websocketURL, [
                    $88d5506019c7f5ad$var$WEBSOCKET_PROTOCOL
                ]);
                socket.addEventListener("open", handleOpen);
                socket.addEventListener("close", handleClose);
                socket.addEventListener("error", handleError);
                socket.addEventListener("message", handleMessage);
                disposeSocket = ()=>{
                    window.clearTimeout(retryWaitTimeoutId);
                    socket.removeEventListener("open", handleOpen);
                    socket.removeEventListener("close", handleClose);
                    socket.removeEventListener("error", handleError);
                    socket.removeEventListener("message", handleMessage);
                };
            };
            attemptSocketConnection();
        });
    });
}



var $bYkMz = parcelRequire("bYkMz");
/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ function $b7eeadd84420d32c$var$__rest(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
function $b7eeadd84420d32c$var$__awaiter(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}
function $b7eeadd84420d32c$var$fromUint8Array(byteArray) {
    return window.btoa(String.fromCharCode.call(null, ...byteArray));
}
function $b7eeadd84420d32c$var$toUint8Array(base64EncodedByteArray) {
    return new Uint8Array(window.atob(base64EncodedByteArray).split("").map((c)=>c.charCodeAt(0)));
}
function $b7eeadd84420d32c$var$getPayloadFromTransaction(transaction) {
    const serializedTransaction = "version" in transaction ? transaction.serialize() : transaction.serialize({
        requireAllSignatures: false,
        verifySignatures: false
    });
    const payload = $b7eeadd84420d32c$var$fromUint8Array(serializedTransaction);
    return payload;
}
function $b7eeadd84420d32c$var$getTransactionFromWireMessage(byteArray) {
    const numSignatures = byteArray[0];
    const messageOffset = numSignatures * (0, $gNDby.SIGNATURE_LENGTH_IN_BYTES) + 1;
    const version = (0, $gNDby.VersionedMessage).deserializeMessageVersion(byteArray.slice(messageOffset, byteArray.length));
    if (version === "legacy") return (0, $gNDby.Transaction).from(byteArray);
    else return (0, $gNDby.VersionedTransaction).deserialize(byteArray);
}
function $b7eeadd84420d32c$export$dac1bad6146b2469(callback, config) {
    return $b7eeadd84420d32c$var$__awaiter(this, void 0, void 0, function*() {
        const augmentedCallback = (wallet)=>{
            const augmentedAPI = new Proxy({}, {
                get (target, p) {
                    if (target[p] == null) switch(p){
                        case "signAndSendTransactions":
                            target[p] = function(_a) {
                                var { minContextSlot: minContextSlot, transactions: transactions } = _a, rest = $b7eeadd84420d32c$var$__rest(_a, [
                                    "minContextSlot",
                                    "transactions"
                                ]);
                                return $b7eeadd84420d32c$var$__awaiter(this, void 0, void 0, function*() {
                                    const payloads = transactions.map($b7eeadd84420d32c$var$getPayloadFromTransaction);
                                    const { signatures: base64EncodedSignatures } = yield wallet.signAndSendTransactions(Object.assign(Object.assign(Object.assign({}, rest), minContextSlot != null ? {
                                        options: {
                                            min_context_slot: minContextSlot
                                        }
                                    } : null), {
                                        payloads: payloads
                                    }));
                                    const signatures = base64EncodedSignatures.map($b7eeadd84420d32c$var$toUint8Array).map((0, (/*@__PURE__*/$parcel$interopDefault($bYkMz))).encode);
                                    return signatures;
                                });
                            };
                            break;
                        case "signMessages":
                            target[p] = function(_a) {
                                var { payloads: payloads } = _a, rest = $b7eeadd84420d32c$var$__rest(_a, [
                                    "payloads"
                                ]);
                                return $b7eeadd84420d32c$var$__awaiter(this, void 0, void 0, function*() {
                                    const base64EncodedPayloads = payloads.map($b7eeadd84420d32c$var$fromUint8Array);
                                    const { signed_payloads: base64EncodedSignedMessages } = yield wallet.signMessages(Object.assign(Object.assign({}, rest), {
                                        payloads: base64EncodedPayloads
                                    }));
                                    const signedMessages = base64EncodedSignedMessages.map($b7eeadd84420d32c$var$toUint8Array);
                                    return signedMessages;
                                });
                            };
                            break;
                        case "signTransactions":
                            target[p] = function(_a) {
                                var { transactions: transactions } = _a, rest = $b7eeadd84420d32c$var$__rest(_a, [
                                    "transactions"
                                ]);
                                return $b7eeadd84420d32c$var$__awaiter(this, void 0, void 0, function*() {
                                    const payloads = transactions.map($b7eeadd84420d32c$var$getPayloadFromTransaction);
                                    const { signed_payloads: base64EncodedCompiledTransactions } = yield wallet.signTransactions(Object.assign(Object.assign({}, rest), {
                                        payloads: payloads
                                    }));
                                    const compiledTransactions = base64EncodedCompiledTransactions.map($b7eeadd84420d32c$var$toUint8Array);
                                    const signedTransactions = compiledTransactions.map($b7eeadd84420d32c$var$getTransactionFromWireMessage);
                                    return signedTransactions;
                                });
                            };
                            break;
                        default:
                            target[p] = wallet[p];
                            break;
                    }
                    return target[p];
                },
                defineProperty () {
                    return false;
                },
                deleteProperty () {
                    return false;
                }
            });
            return callback(augmentedAPI);
        };
        return yield (0, $88d5506019c7f5ad$export$dac1bad6146b2469)(augmentedCallback, config);
    });
}


/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ function $c0734f9a20f45199$var$__awaiter(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}
function $c0734f9a20f45199$var$toUint8Array(base64EncodedByteArray) {
    return new Uint8Array(window.atob(base64EncodedByteArray).split("").map((c)=>c.charCodeAt(0)));
}
function $c0734f9a20f45199$var$getIsSupported() {
    return typeof window !== "undefined" && window.isSecureContext && typeof document !== "undefined" && /android/i.test(navigator.userAgent);
}
const $c0734f9a20f45199$export$f1265e9082f346f1 = "Mobile Wallet Adapter";
const $c0734f9a20f45199$var$SIGNATURE_LENGTH_IN_BYTES = 64;
function $c0734f9a20f45199$var$getPublicKeyFromAddress(address) {
    const publicKeyByteArray = $c0734f9a20f45199$var$toUint8Array(address);
    return new (0, $gNDby.PublicKey)(publicKeyByteArray);
}
function $c0734f9a20f45199$var$isVersionedTransaction(transaction) {
    return "version" in transaction;
}
class $c0734f9a20f45199$export$dec251788b2f5a84 extends (0, $71b3859dfb523e38$export$9db08bcddd106c96) {
    constructor(config){
        super();
        this.supportedTransactionVersions = new Set(// FIXME(#244): We can't actually know what versions are supported until we know which wallet we're talking to.
        [
            "legacy",
            0
        ]);
        this.name = $c0734f9a20f45199$export$f1265e9082f346f1;
        this.url = "https://solanamobile.com/wallets";
        this.icon = "data:image/svg+xml;base64,PHN2ZyBmaWxsPSJub25lIiBoZWlnaHQ9IjI4IiB3aWR0aD0iMjgiIHZpZXdCb3g9Ii0zIDAgMjggMjgiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGcgZmlsbD0iI0RDQjhGRiI+PHBhdGggZD0iTTE3LjQgMTcuNEgxNXYyLjRoMi40di0yLjRabTEuMi05LjZoLTIuNHYyLjRoMi40VjcuOFoiLz48cGF0aCBkPSJNMjEuNiAzVjBoLTIuNHYzaC0zLjZWMGgtMi40djNoLTIuNHY2LjZINC41YTIuMSAyLjEgMCAxIDEgMC00LjJoMi43VjNINC41QTQuNSA0LjUgMCAwIDAgMCA3LjVWMjRoMjEuNnYtNi42aC0yLjR2NC4ySDIuNFYxMS41Yy41LjMgMS4yLjQgMS44LjVoNy41QTYuNiA2LjYgMCAwIDAgMjQgOVYzaC0yLjRabTAgNS43YTQuMiA0LjIgMCAxIDEtOC40IDBWNS40aDguNHYzLjNaIi8+PC9nPjwvc3ZnPg==";
        this._connecting = false;
        /**
         * Every time the connection is recycled in some way (eg. `disconnect()` is called)
         * increment this and use it to make sure that `transact` calls from the previous
         * 'generation' don't continue to do work and throw exceptions.
         */ this._connectionGeneration = 0;
        this._readyState = $c0734f9a20f45199$var$getIsSupported() ? (0, $a27aaf340df890aa$export$2a7b8071105d05b6).Loadable : (0, $a27aaf340df890aa$export$2a7b8071105d05b6).Unsupported;
        this._authorizationResultCache = config.authorizationResultCache;
        this._addressSelector = config.addressSelector;
        this._appIdentity = config.appIdentity;
        this._cluster = config.cluster;
        this._onWalletNotFound = config.onWalletNotFound;
        if (this._readyState !== (0, $a27aaf340df890aa$export$2a7b8071105d05b6).Unsupported) this._authorizationResultCache.get().then((authorizationResult)=>{
            if (authorizationResult) // Having a prior authorization result is, right now, the best
            // indication that a mobile wallet is installed. There is no API
            // we can use to test for whether the association URI is supported.
            this.declareWalletAsInstalled();
        });
    }
    get publicKey() {
        if (this._publicKey == null && this._selectedAddress != null) try {
            this._publicKey = $c0734f9a20f45199$var$getPublicKeyFromAddress(this._selectedAddress);
        } catch (e) {
            throw new (0, $92c515b2e16b5c4e$export$735bef3bfb0f2c86)(e instanceof Error && (e === null || e === void 0 ? void 0 : e.message) || "Unknown error", e);
        }
        return this._publicKey ? this._publicKey : null;
    }
    get connected() {
        return !!this._authorizationResult;
    }
    get connecting() {
        return this._connecting;
    }
    get readyState() {
        return this._readyState;
    }
    declareWalletAsInstalled() {
        if (this._readyState !== (0, $a27aaf340df890aa$export$2a7b8071105d05b6).Installed) this.emit("readyStateChange", this._readyState = (0, $a27aaf340df890aa$export$2a7b8071105d05b6).Installed);
    }
    runWithGuard(callback) {
        return $c0734f9a20f45199$var$__awaiter(this, void 0, void 0, function*() {
            try {
                return yield callback();
            } catch (e) {
                this.emit("error", e);
                throw e;
            }
        });
    }
    /** @deprecated Use `autoConnect()` instead. */ autoConnect_DO_NOT_USE_OR_YOU_WILL_BE_FIRED() {
        return $c0734f9a20f45199$var$__awaiter(this, void 0, void 0, function*() {
            return yield this.autoConnect();
        });
    }
    autoConnect() {
        return $c0734f9a20f45199$var$__awaiter(this, void 0, void 0, function*() {
            if (this.connecting || this.connected) return;
            return yield this.runWithGuard(()=>$c0734f9a20f45199$var$__awaiter(this, void 0, void 0, function*() {
                    if (this._readyState !== (0, $a27aaf340df890aa$export$2a7b8071105d05b6).Installed && this._readyState !== (0, $a27aaf340df890aa$export$2a7b8071105d05b6).Loadable) throw new (0, $92c515b2e16b5c4e$export$d65db264eda99cd7)();
                    this._connecting = true;
                    try {
                        const cachedAuthorizationResult = yield this._authorizationResultCache.get();
                        if (cachedAuthorizationResult) // TODO: Evaluate whether there's any threat to not `awaiting` this expression
                        this.handleAuthorizationResult(cachedAuthorizationResult);
                    } catch (e) {
                        throw new (0, $92c515b2e16b5c4e$export$38f21f1c810261c7)(e instanceof Error && e.message || "Unknown error", e);
                    } finally{
                        this._connecting = false;
                    }
                }));
        });
    }
    connect() {
        return $c0734f9a20f45199$var$__awaiter(this, void 0, void 0, function*() {
            if (this.connecting || this.connected) return;
            return yield this.runWithGuard(()=>$c0734f9a20f45199$var$__awaiter(this, void 0, void 0, function*() {
                    if (this._readyState !== (0, $a27aaf340df890aa$export$2a7b8071105d05b6).Installed && this._readyState !== (0, $a27aaf340df890aa$export$2a7b8071105d05b6).Loadable) throw new (0, $92c515b2e16b5c4e$export$d65db264eda99cd7)();
                    this._connecting = true;
                    try {
                        const cachedAuthorizationResult = yield this._authorizationResultCache.get();
                        if (cachedAuthorizationResult) {
                            // TODO: Evaluate whether there's any threat to not `awaiting` this expression
                            this.handleAuthorizationResult(cachedAuthorizationResult);
                            return;
                        }
                        yield this.transact((wallet)=>$c0734f9a20f45199$var$__awaiter(this, void 0, void 0, function*() {
                                const authorizationResult = yield wallet.authorize({
                                    cluster: this._cluster,
                                    identity: this._appIdentity
                                });
                                // TODO: Evaluate whether there's any threat to not `awaiting` this expression
                                Promise.all([
                                    this._authorizationResultCache.set(authorizationResult),
                                    this.handleAuthorizationResult(authorizationResult)
                                ]);
                            }));
                    } catch (e) {
                        throw new (0, $92c515b2e16b5c4e$export$38f21f1c810261c7)(e instanceof Error && e.message || "Unknown error", e);
                    } finally{
                        this._connecting = false;
                    }
                }));
        });
    }
    handleAuthorizationResult(authorizationResult) {
        var _a;
        return $c0734f9a20f45199$var$__awaiter(this, void 0, void 0, function*() {
            const didPublicKeysChange = // Case 1: We started from having no authorization.
            this._authorizationResult == null || // Case 2: The number of authorized accounts changed.
            ((_a = this._authorizationResult) === null || _a === void 0 ? void 0 : _a.accounts.length) !== authorizationResult.accounts.length || // Case 3: The new list of addresses isn't exactly the same as the old list, in the same order.
            this._authorizationResult.accounts.some((account, ii)=>account.address !== authorizationResult.accounts[ii].address);
            this._authorizationResult = authorizationResult;
            this.declareWalletAsInstalled();
            if (didPublicKeysChange) {
                const nextSelectedAddress = yield this._addressSelector.select(authorizationResult.accounts.map(({ address: address })=>address));
                if (nextSelectedAddress !== this._selectedAddress) {
                    this._selectedAddress = nextSelectedAddress;
                    delete this._publicKey;
                    this.emit("connect", // Having just set `this._selectedAddress`, `this.publicKey` is definitely non-null
                    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                    this.publicKey);
                }
            }
        });
    }
    performReauthorization(wallet, authToken) {
        return $c0734f9a20f45199$var$__awaiter(this, void 0, void 0, function*() {
            try {
                const authorizationResult = yield wallet.reauthorize({
                    auth_token: authToken,
                    identity: this._appIdentity
                });
                // TODO: Evaluate whether there's any threat to not `awaiting` this expression
                Promise.all([
                    this._authorizationResultCache.set(authorizationResult),
                    this.handleAuthorizationResult(authorizationResult)
                ]);
            } catch (e) {
                this.disconnect();
                throw new (0, $92c515b2e16b5c4e$export$bf7028c52ebda81e)(e instanceof Error && (e === null || e === void 0 ? void 0 : e.message) || "Unknown error", e);
            }
        });
    }
    disconnect() {
        return $c0734f9a20f45199$var$__awaiter(this, void 0, void 0, function*() {
            this._authorizationResultCache.clear(); // TODO: Evaluate whether there's any threat to not `awaiting` this expression
            this._connecting = false;
            this._connectionGeneration++;
            delete this._authorizationResult;
            delete this._publicKey;
            delete this._selectedAddress;
            this.emit("disconnect");
        });
    }
    transact(callback) {
        var _a;
        return $c0734f9a20f45199$var$__awaiter(this, void 0, void 0, function*() {
            const walletUriBase = (_a = this._authorizationResult) === null || _a === void 0 ? void 0 : _a.wallet_uri_base;
            const config = walletUriBase ? {
                baseUri: walletUriBase
            } : undefined;
            const currentConnectionGeneration = this._connectionGeneration;
            try {
                return yield (0, $b7eeadd84420d32c$export$dac1bad6146b2469)(callback, config);
            } catch (e) {
                if (this._connectionGeneration !== currentConnectionGeneration) yield new Promise(()=>{}); // Never resolve.
                if (e instanceof Error && e.name === "SolanaMobileWalletAdapterError" && e.code === "ERROR_WALLET_NOT_FOUND") yield this._onWalletNotFound(this);
                throw e;
            }
        });
    }
    assertIsAuthorized() {
        if (!this._authorizationResult || !this._selectedAddress) throw new (0, $92c515b2e16b5c4e$export$313d299817c74896)();
        return {
            authToken: this._authorizationResult.auth_token,
            selectedAddress: this._selectedAddress
        };
    }
    performSignTransactions(transactions) {
        return $c0734f9a20f45199$var$__awaiter(this, void 0, void 0, function*() {
            const { authToken: authToken } = this.assertIsAuthorized();
            try {
                return yield this.transact((wallet)=>$c0734f9a20f45199$var$__awaiter(this, void 0, void 0, function*() {
                        yield this.performReauthorization(wallet, authToken);
                        const signedTransactions = yield wallet.signTransactions({
                            transactions: transactions
                        });
                        return signedTransactions;
                    }));
            } catch (error) {
                throw new (0, $92c515b2e16b5c4e$export$96f177062fdd8180)(error === null || error === void 0 ? void 0 : error.message, error);
            }
        });
    }
    sendTransaction(transaction, connection, options) {
        return $c0734f9a20f45199$var$__awaiter(this, void 0, void 0, function*() {
            return yield this.runWithGuard(()=>$c0734f9a20f45199$var$__awaiter(this, void 0, void 0, function*() {
                    const { authToken: authToken } = this.assertIsAuthorized();
                    const minContextSlot = options === null || options === void 0 ? void 0 : options.minContextSlot;
                    try {
                        return yield this.transact((wallet)=>$c0734f9a20f45199$var$__awaiter(this, void 0, void 0, function*() {
                                function getTargetCommitment() {
                                    let targetCommitment;
                                    switch(connection.commitment){
                                        case "confirmed":
                                        case "finalized":
                                        case "processed":
                                            targetCommitment = connection.commitment;
                                            break;
                                        default:
                                            targetCommitment = "finalized";
                                    }
                                    let targetPreflightCommitment;
                                    switch(options === null || options === void 0 ? void 0 : options.preflightCommitment){
                                        case "confirmed":
                                        case "finalized":
                                        case "processed":
                                            targetPreflightCommitment = options.preflightCommitment;
                                            break;
                                        case undefined:
                                            targetPreflightCommitment = targetCommitment;
                                        default:
                                            targetPreflightCommitment = "finalized";
                                    }
                                    const preflightCommitmentScore = targetPreflightCommitment === "finalized" ? 2 : targetPreflightCommitment === "confirmed" ? 1 : 0;
                                    const targetCommitmentScore = targetCommitment === "finalized" ? 2 : targetCommitment === "confirmed" ? 1 : 0;
                                    return preflightCommitmentScore < targetCommitmentScore ? targetPreflightCommitment : targetCommitment;
                                }
                                const [capabilities, _1, _2] = yield Promise.all([
                                    wallet.getCapabilities(),
                                    this.performReauthorization(wallet, authToken),
                                    $c0734f9a20f45199$var$isVersionedTransaction(transaction) ? null : /**
                                   * Unlike versioned transactions, legacy `Transaction` objects
                                   * may not have an associated `feePayer` or `recentBlockhash`.
                                   * This code exists to patch them up in case they are missing.
                                   */ (()=>$c0734f9a20f45199$var$__awaiter(this, void 0, void 0, function*() {
                                            var _a;
                                            transaction.feePayer || (transaction.feePayer = (_a = this.publicKey) !== null && _a !== void 0 ? _a : undefined);
                                            if (transaction.recentBlockhash == null) {
                                                const { blockhash: blockhash } = yield connection.getLatestBlockhash({
                                                    commitment: getTargetCommitment()
                                                });
                                                transaction.recentBlockhash = blockhash;
                                            }
                                        }))()
                                ]);
                                if (capabilities.supports_sign_and_send_transactions) {
                                    const signatures = yield wallet.signAndSendTransactions({
                                        minContextSlot: minContextSlot,
                                        transactions: [
                                            transaction
                                        ]
                                    });
                                    return signatures[0];
                                } else {
                                    const [signedTransaction] = yield wallet.signTransactions({
                                        transactions: [
                                            transaction
                                        ]
                                    });
                                    if ($c0734f9a20f45199$var$isVersionedTransaction(signedTransaction)) return yield connection.sendTransaction(signedTransaction);
                                    else {
                                        const serializedTransaction = signedTransaction.serialize();
                                        return yield connection.sendRawTransaction(serializedTransaction, Object.assign(Object.assign({}, options), {
                                            preflightCommitment: getTargetCommitment()
                                        }));
                                    }
                                }
                            }));
                    } catch (error) {
                        throw new (0, $92c515b2e16b5c4e$export$769332ac3f90f46c)(error === null || error === void 0 ? void 0 : error.message, error);
                    }
                }));
        });
    }
    signTransaction(transaction) {
        return $c0734f9a20f45199$var$__awaiter(this, void 0, void 0, function*() {
            return yield this.runWithGuard(()=>$c0734f9a20f45199$var$__awaiter(this, void 0, void 0, function*() {
                    const [signedTransaction] = yield this.performSignTransactions([
                        transaction
                    ]);
                    return signedTransaction;
                }));
        });
    }
    signAllTransactions(transactions) {
        return $c0734f9a20f45199$var$__awaiter(this, void 0, void 0, function*() {
            return yield this.runWithGuard(()=>$c0734f9a20f45199$var$__awaiter(this, void 0, void 0, function*() {
                    const signedTransactions = yield this.performSignTransactions(transactions);
                    return signedTransactions;
                }));
        });
    }
    signMessage(message) {
        return $c0734f9a20f45199$var$__awaiter(this, void 0, void 0, function*() {
            return yield this.runWithGuard(()=>$c0734f9a20f45199$var$__awaiter(this, void 0, void 0, function*() {
                    const { authToken: authToken, selectedAddress: selectedAddress } = this.assertIsAuthorized();
                    try {
                        return yield this.transact((wallet)=>$c0734f9a20f45199$var$__awaiter(this, void 0, void 0, function*() {
                                yield this.performReauthorization(wallet, authToken);
                                const [signedMessage] = yield wallet.signMessages({
                                    addresses: [
                                        selectedAddress
                                    ],
                                    payloads: [
                                        message
                                    ]
                                });
                                const signature = signedMessage.slice(-$c0734f9a20f45199$var$SIGNATURE_LENGTH_IN_BYTES);
                                return signature;
                            }));
                    } catch (error) {
                        throw new (0, $92c515b2e16b5c4e$export$2622c1721bbd4b17)(error === null || error === void 0 ? void 0 : error.message, error);
                    }
                }));
        });
    }
}
function $c0734f9a20f45199$export$a299fb0acc11345b() {
    return {
        select (addresses) {
            return $c0734f9a20f45199$var$__awaiter(this, void 0, void 0, function*() {
                return addresses[0];
            });
        }
    };
}
const $c0734f9a20f45199$var$CACHE_KEY = "SolanaMobileWalletAdapterDefaultAuthorizationCache";
function $c0734f9a20f45199$export$4a0b597891770806() {
    let storage;
    try {
        storage = window.localStorage;
    // eslint-disable-next-line no-empty
    } catch (_a) {}
    return {
        clear () {
            return $c0734f9a20f45199$var$__awaiter(this, void 0, void 0, function*() {
                if (!storage) return;
                try {
                    storage.removeItem($c0734f9a20f45199$var$CACHE_KEY);
                // eslint-disable-next-line no-empty
                } catch (_a) {}
            });
        },
        get () {
            return $c0734f9a20f45199$var$__awaiter(this, void 0, void 0, function*() {
                if (!storage) return;
                try {
                    return JSON.parse(storage.getItem($c0734f9a20f45199$var$CACHE_KEY)) || undefined;
                // eslint-disable-next-line no-empty
                } catch (_a) {}
            });
        },
        set (authorizationResult) {
            return $c0734f9a20f45199$var$__awaiter(this, void 0, void 0, function*() {
                if (!storage) return;
                try {
                    storage.setItem($c0734f9a20f45199$var$CACHE_KEY, JSON.stringify(authorizationResult));
                // eslint-disable-next-line no-empty
                } catch (_a) {}
            });
        }
    };
}
function $c0734f9a20f45199$var$defaultWalletNotFoundHandler(mobileWalletAdapter) {
    return $c0734f9a20f45199$var$__awaiter(this, void 0, void 0, function*() {
        if (typeof window !== "undefined") window.location.assign(mobileWalletAdapter.url);
    });
}
function $c0734f9a20f45199$export$e8b9e70cdf783b70() {
    return $c0734f9a20f45199$var$defaultWalletNotFoundHandler;
}



var $iJxGt = parcelRequire("iJxGt");
var $d2raY = parcelRequire("d2raY");
/** Name of the feature. */ const $744408f28809a335$export$cc68487eeb93b1d4 = "standard:connect";
const $744408f28809a335$export$59e6910693f047c2 = $744408f28809a335$export$cc68487eeb93b1d4;

/** Name of the feature. */ const $f4859eee1867cbdd$export$5296443ca9e9fa0f = "standard:events";
const $f4859eee1867cbdd$export$ada873a34909da65 = $f4859eee1867cbdd$export$5296443ca9e9fa0f;


function $c0bcda49505f4253$export$de6946e7c2c87e9a(wallet) {
    return (0, $744408f28809a335$export$cc68487eeb93b1d4) in wallet.features && (0, $f4859eee1867cbdd$export$5296443ca9e9fa0f) in wallet.features && ((0, $iJxGt.SolanaSignAndSendTransaction) in wallet.features || (0, $d2raY.SolanaSignTransaction) in wallet.features);
}


const $05a5d3c47b24c22b$export$c5439c91843266e6 = (0, $c0bcda49505f4253$export$de6946e7c2c87e9a);



var $iJxGt = parcelRequire("iJxGt");/** Name of the feature. */ const $29a99a74b28f2560$export$8adeab75f48a3607 = "solana:signIn";


var $7KE4n = parcelRequire("7KE4n");
var $d2raY = parcelRequire("d2raY");
/** Solana Mainnet (beta) cluster, e.g. https://api.mainnet-beta.solana.com */ const $54a90126d2f96ce7$export$bba9a228295b3963 = "solana:mainnet";
const $54a90126d2f96ce7$export$654cc095bd2e650 = "solana:devnet";
const $54a90126d2f96ce7$export$76575b7bf4de1f40 = "solana:testnet";
const $54a90126d2f96ce7$export$483699a75281444c = "solana:localnet";
const $54a90126d2f96ce7$export$d77e7f94b1f6bf7d = [
    $54a90126d2f96ce7$export$bba9a228295b3963,
    $54a90126d2f96ce7$export$654cc095bd2e650,
    $54a90126d2f96ce7$export$76575b7bf4de1f40,
    $54a90126d2f96ce7$export$483699a75281444c
];
function $54a90126d2f96ce7$export$d8f86f4d3d9fc2b5(chain) {
    return $54a90126d2f96ce7$export$d77e7f94b1f6bf7d.includes(chain);
}


const $bd67609293f84bc3$export$9462d80112b287bf = "https://api.mainnet-beta.solana.com";
const $bd67609293f84bc3$export$2416cc3545b31c3b = "https://api.devnet.solana.com";
const $bd67609293f84bc3$export$fe3dc909dfa57ddb = "https://api.testnet.solana.com";
const $bd67609293f84bc3$export$ec9ed1d68bb4713f = "http://localhost:8899";
function $bd67609293f84bc3$export$43dcd8213c5a5741(endpoint) {
    if (endpoint.includes($bd67609293f84bc3$export$9462d80112b287bf)) return 0, $54a90126d2f96ce7$export$bba9a228295b3963;
    if (/\bdevnet\b/i.test(endpoint)) return 0, $54a90126d2f96ce7$export$654cc095bd2e650;
    if (/\btestnet\b/i.test(endpoint)) return 0, $54a90126d2f96ce7$export$76575b7bf4de1f40;
    if (/\blocalhost\b/i.test(endpoint) || /\b127\.0\.0\.1\b/.test(endpoint)) return 0, $54a90126d2f96ce7$export$483699a75281444c;
    return 0, $54a90126d2f96ce7$export$bba9a228295b3963;
}
function $bd67609293f84bc3$export$c9b15526ee38efba(chain, endpoint) {
    if (endpoint) return endpoint;
    if (chain === (0, $54a90126d2f96ce7$export$bba9a228295b3963)) return $bd67609293f84bc3$export$9462d80112b287bf;
    if (chain === (0, $54a90126d2f96ce7$export$654cc095bd2e650)) return $bd67609293f84bc3$export$2416cc3545b31c3b;
    if (chain === (0, $54a90126d2f96ce7$export$76575b7bf4de1f40)) return $bd67609293f84bc3$export$fe3dc909dfa57ddb;
    if (chain === (0, $54a90126d2f96ce7$export$483699a75281444c)) return $bd67609293f84bc3$export$ec9ed1d68bb4713f;
    return $bd67609293f84bc3$export$9462d80112b287bf;
}

/**
 * TODO: docs
 */ function $89ddb6b3d1c020ef$export$430b2bce150d42d4(commitment) {
    switch(commitment){
        case "processed":
        case "confirmed":
        case "finalized":
        case undefined:
            return commitment;
        case "recent":
            return "processed";
        case "single":
        case "singleGossip":
            return "confirmed";
        case "max":
        case "root":
            return "finalized";
        default:
            return undefined;
    }
}



var $gNDby = parcelRequire("gNDby");
/** Name of the feature. */ const $393285782087969c$export$38dbd4bbb9b696e6 = "standard:disconnect";
const $393285782087969c$export$9e282393ab352bcd = $393285782087969c$export$38dbd4bbb9b696e6;


var $59f593984632af6a$var$__classPrivateFieldSet = undefined && undefined.__classPrivateFieldSet || function(receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value), value;
};
var $59f593984632af6a$var$__classPrivateFieldGet = undefined && undefined.__classPrivateFieldGet || function(receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
};
var $59f593984632af6a$var$_ReadonlyWalletAccount_address, $59f593984632af6a$var$_ReadonlyWalletAccount_publicKey, $59f593984632af6a$var$_ReadonlyWalletAccount_chains, $59f593984632af6a$var$_ReadonlyWalletAccount_features, $59f593984632af6a$var$_ReadonlyWalletAccount_label, $59f593984632af6a$var$_ReadonlyWalletAccount_icon;
class $59f593984632af6a$export$c0ac434c7ac96eb0 {
    /**
     * Create and freeze a read-only account.
     *
     * @param account Account to copy properties from.
     */ constructor(account){
        $59f593984632af6a$var$_ReadonlyWalletAccount_address.set(this, void 0);
        $59f593984632af6a$var$_ReadonlyWalletAccount_publicKey.set(this, void 0);
        $59f593984632af6a$var$_ReadonlyWalletAccount_chains.set(this, void 0);
        $59f593984632af6a$var$_ReadonlyWalletAccount_features.set(this, void 0);
        $59f593984632af6a$var$_ReadonlyWalletAccount_label.set(this, void 0);
        $59f593984632af6a$var$_ReadonlyWalletAccount_icon.set(this, void 0);
        if (new.target === $59f593984632af6a$export$c0ac434c7ac96eb0) Object.freeze(this);
        $59f593984632af6a$var$__classPrivateFieldSet(this, $59f593984632af6a$var$_ReadonlyWalletAccount_address, account.address, "f");
        $59f593984632af6a$var$__classPrivateFieldSet(this, $59f593984632af6a$var$_ReadonlyWalletAccount_publicKey, account.publicKey.slice(), "f");
        $59f593984632af6a$var$__classPrivateFieldSet(this, $59f593984632af6a$var$_ReadonlyWalletAccount_chains, account.chains.slice(), "f");
        $59f593984632af6a$var$__classPrivateFieldSet(this, $59f593984632af6a$var$_ReadonlyWalletAccount_features, account.features.slice(), "f");
        $59f593984632af6a$var$__classPrivateFieldSet(this, $59f593984632af6a$var$_ReadonlyWalletAccount_label, account.label, "f");
        $59f593984632af6a$var$__classPrivateFieldSet(this, $59f593984632af6a$var$_ReadonlyWalletAccount_icon, account.icon, "f");
    }
    /** Implementation of {@link "@wallet-standard/base".WalletAccount.address | WalletAccount::address} */ get address() {
        return $59f593984632af6a$var$__classPrivateFieldGet(this, $59f593984632af6a$var$_ReadonlyWalletAccount_address, "f");
    }
    /** Implementation of {@link "@wallet-standard/base".WalletAccount.publicKey | WalletAccount::publicKey} */ get publicKey() {
        return $59f593984632af6a$var$__classPrivateFieldGet(this, $59f593984632af6a$var$_ReadonlyWalletAccount_publicKey, "f").slice();
    }
    /** Implementation of {@link "@wallet-standard/base".WalletAccount.chains | WalletAccount::chains} */ get chains() {
        return $59f593984632af6a$var$__classPrivateFieldGet(this, $59f593984632af6a$var$_ReadonlyWalletAccount_chains, "f").slice();
    }
    /** Implementation of {@link "@wallet-standard/base".WalletAccount.features | WalletAccount::features} */ get features() {
        return $59f593984632af6a$var$__classPrivateFieldGet(this, $59f593984632af6a$var$_ReadonlyWalletAccount_features, "f").slice();
    }
    /** Implementation of {@link "@wallet-standard/base".WalletAccount.label | WalletAccount::label} */ get label() {
        return $59f593984632af6a$var$__classPrivateFieldGet(this, $59f593984632af6a$var$_ReadonlyWalletAccount_label, "f");
    }
    /** Implementation of {@link "@wallet-standard/base".WalletAccount.icon | WalletAccount::icon} */ get icon() {
        return $59f593984632af6a$var$__classPrivateFieldGet(this, $59f593984632af6a$var$_ReadonlyWalletAccount_icon, "f");
    }
}
$59f593984632af6a$var$_ReadonlyWalletAccount_address = new WeakMap(), $59f593984632af6a$var$_ReadonlyWalletAccount_publicKey = new WeakMap(), $59f593984632af6a$var$_ReadonlyWalletAccount_chains = new WeakMap(), $59f593984632af6a$var$_ReadonlyWalletAccount_features = new WeakMap(), $59f593984632af6a$var$_ReadonlyWalletAccount_label = new WeakMap(), $59f593984632af6a$var$_ReadonlyWalletAccount_icon = new WeakMap();
function $59f593984632af6a$export$234180f8206db11b(a, b) {
    if (a === b) return true;
    const length = a.length;
    if (length !== b.length) return false;
    for(let i = 0; i < length; i++){
        if (a[i] !== b[i]) return false;
    }
    return true;
}
function $59f593984632af6a$export$c663ab80cce302c5(a, b) {
    return $59f593984632af6a$export$234180f8206db11b(a, b);
}
function $59f593984632af6a$export$287dd7971339c972(first, ...others) {
    const length = others.reduce((length, bytes)=>length + bytes.length, first.length);
    const bytes = new Uint8Array(length);
    bytes.set(first, 0);
    for (const other of others)bytes.set(other, bytes.length);
    return bytes;
}
function $59f593984632af6a$export$357523c63a2253b9(source, ...keys) {
    const picked = {};
    for (const key of keys)picked[key] = source[key];
    return picked;
}
function $59f593984632af6a$export$864d727b48066337(callback) {
    try {
        callback();
    } catch (error) {
        console.error(error);
    }
}


var $6663260c56080b45$exports = {};

var $0DhcF = parcelRequire("0DhcF");
var $6663260c56080b45$var$ALPHABET = "123456789ABCDEFGHJKLMNPQRSTUVWXYZabcdefghijkmnopqrstuvwxyz";
$6663260c56080b45$exports = $0DhcF($6663260c56080b45$var$ALPHABET);


var $78422a608777eed2$var$__classPrivateFieldSet = undefined && undefined.__classPrivateFieldSet || function(receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value), value;
};
var $78422a608777eed2$var$__classPrivateFieldGet = undefined && undefined.__classPrivateFieldGet || function(receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
};
var $78422a608777eed2$var$_StandardWalletAdapter_instances, $78422a608777eed2$var$_StandardWalletAdapter_account, $78422a608777eed2$var$_StandardWalletAdapter_publicKey, $78422a608777eed2$var$_StandardWalletAdapter_connecting, $78422a608777eed2$var$_StandardWalletAdapter_disconnecting, $78422a608777eed2$var$_StandardWalletAdapter_off, $78422a608777eed2$var$_StandardWalletAdapter_supportedTransactionVersions, $78422a608777eed2$var$_StandardWalletAdapter_wallet, $78422a608777eed2$var$_StandardWalletAdapter_readyState, $78422a608777eed2$var$_StandardWalletAdapter_connect, $78422a608777eed2$var$_StandardWalletAdapter_connected, $78422a608777eed2$var$_StandardWalletAdapter_disconnected, $78422a608777eed2$var$_StandardWalletAdapter_reset, $78422a608777eed2$var$_StandardWalletAdapter_changed, $78422a608777eed2$var$_StandardWalletAdapter_signTransaction, $78422a608777eed2$var$_StandardWalletAdapter_signAllTransactions, $78422a608777eed2$var$_StandardWalletAdapter_signMessage, $78422a608777eed2$var$_StandardWalletAdapter_signIn;
class $78422a608777eed2$export$e0949de9e32fe3b2 extends (0, $a27aaf340df890aa$export$2af1ea2892adc469) {
    constructor({ wallet: wallet }){
        super();
        $78422a608777eed2$var$_StandardWalletAdapter_instances.add(this);
        $78422a608777eed2$var$_StandardWalletAdapter_account.set(this, void 0);
        $78422a608777eed2$var$_StandardWalletAdapter_publicKey.set(this, void 0);
        $78422a608777eed2$var$_StandardWalletAdapter_connecting.set(this, void 0);
        $78422a608777eed2$var$_StandardWalletAdapter_disconnecting.set(this, void 0);
        $78422a608777eed2$var$_StandardWalletAdapter_off.set(this, void 0);
        $78422a608777eed2$var$_StandardWalletAdapter_supportedTransactionVersions.set(this, void 0);
        $78422a608777eed2$var$_StandardWalletAdapter_wallet.set(this, void 0);
        $78422a608777eed2$var$_StandardWalletAdapter_readyState.set(this, typeof window === "undefined" || typeof document === "undefined" ? (0, $a27aaf340df890aa$export$2a7b8071105d05b6).Unsupported : (0, $a27aaf340df890aa$export$2a7b8071105d05b6).Installed);
        $78422a608777eed2$var$_StandardWalletAdapter_changed.set(this, (properties)=>{
            // If accounts have changed on the wallet, reflect this on the adapter.
            if ("accounts" in properties) {
                const account = $78422a608777eed2$var$__classPrivateFieldGet(this, $78422a608777eed2$var$_StandardWalletAdapter_wallet, "f").accounts[0];
                // If the adapter isn't connected, or is disconnecting, or the first account hasn't changed, do nothing.
                if ($78422a608777eed2$var$__classPrivateFieldGet(this, $78422a608777eed2$var$_StandardWalletAdapter_account, "f") && !$78422a608777eed2$var$__classPrivateFieldGet(this, $78422a608777eed2$var$_StandardWalletAdapter_disconnecting, "f") && account !== $78422a608777eed2$var$__classPrivateFieldGet(this, $78422a608777eed2$var$_StandardWalletAdapter_account, "f")) {
                    // If there's a connected account, connect the adapter. Otherwise, disconnect it.
                    if (account) // Connect the adapter.
                    $78422a608777eed2$var$__classPrivateFieldGet(this, $78422a608777eed2$var$_StandardWalletAdapter_instances, "m", $78422a608777eed2$var$_StandardWalletAdapter_connected).call(this, account);
                    else {
                        // Emit an error because the wallet spontaneously disconnected.
                        this.emit("error", new (0, $92c515b2e16b5c4e$export$bf7028c52ebda81e)());
                        // Disconnect the adapter.
                        $78422a608777eed2$var$__classPrivateFieldGet(this, $78422a608777eed2$var$_StandardWalletAdapter_instances, "m", $78422a608777eed2$var$_StandardWalletAdapter_disconnected).call(this);
                    }
                }
            }
            // After reflecting account changes, if features have changed on the wallet, reflect this on the adapter.
            if ("features" in properties) $78422a608777eed2$var$__classPrivateFieldGet(this, $78422a608777eed2$var$_StandardWalletAdapter_instances, "m", $78422a608777eed2$var$_StandardWalletAdapter_reset).call(this);
        });
        $78422a608777eed2$var$__classPrivateFieldSet(this, $78422a608777eed2$var$_StandardWalletAdapter_wallet, wallet, "f");
        $78422a608777eed2$var$__classPrivateFieldSet(this, $78422a608777eed2$var$_StandardWalletAdapter_account, null, "f");
        $78422a608777eed2$var$__classPrivateFieldSet(this, $78422a608777eed2$var$_StandardWalletAdapter_publicKey, null, "f");
        $78422a608777eed2$var$__classPrivateFieldSet(this, $78422a608777eed2$var$_StandardWalletAdapter_connecting, false, "f");
        $78422a608777eed2$var$__classPrivateFieldSet(this, $78422a608777eed2$var$_StandardWalletAdapter_disconnecting, false, "f");
        $78422a608777eed2$var$__classPrivateFieldSet(this, $78422a608777eed2$var$_StandardWalletAdapter_off, $78422a608777eed2$var$__classPrivateFieldGet(this, $78422a608777eed2$var$_StandardWalletAdapter_wallet, "f").features[0, $f4859eee1867cbdd$export$5296443ca9e9fa0f].on("change", $78422a608777eed2$var$__classPrivateFieldGet(this, $78422a608777eed2$var$_StandardWalletAdapter_changed, "f")), "f");
        $78422a608777eed2$var$__classPrivateFieldGet(this, $78422a608777eed2$var$_StandardWalletAdapter_instances, "m", $78422a608777eed2$var$_StandardWalletAdapter_reset).call(this);
    }
    get name() {
        return $78422a608777eed2$var$__classPrivateFieldGet(this, $78422a608777eed2$var$_StandardWalletAdapter_wallet, "f").name;
    }
    get url() {
        return "https://github.com/solana-labs/wallet-standard";
    }
    get icon() {
        return $78422a608777eed2$var$__classPrivateFieldGet(this, $78422a608777eed2$var$_StandardWalletAdapter_wallet, "f").icon;
    }
    get readyState() {
        return $78422a608777eed2$var$__classPrivateFieldGet(this, $78422a608777eed2$var$_StandardWalletAdapter_readyState, "f");
    }
    get publicKey() {
        return $78422a608777eed2$var$__classPrivateFieldGet(this, $78422a608777eed2$var$_StandardWalletAdapter_publicKey, "f");
    }
    get connecting() {
        return $78422a608777eed2$var$__classPrivateFieldGet(this, $78422a608777eed2$var$_StandardWalletAdapter_connecting, "f");
    }
    get supportedTransactionVersions() {
        return $78422a608777eed2$var$__classPrivateFieldGet(this, $78422a608777eed2$var$_StandardWalletAdapter_supportedTransactionVersions, "f");
    }
    get wallet() {
        return $78422a608777eed2$var$__classPrivateFieldGet(this, $78422a608777eed2$var$_StandardWalletAdapter_wallet, "f");
    }
    get standard() {
        return true;
    }
    destroy() {
        $78422a608777eed2$var$__classPrivateFieldSet(this, $78422a608777eed2$var$_StandardWalletAdapter_account, null, "f");
        $78422a608777eed2$var$__classPrivateFieldSet(this, $78422a608777eed2$var$_StandardWalletAdapter_publicKey, null, "f");
        $78422a608777eed2$var$__classPrivateFieldSet(this, $78422a608777eed2$var$_StandardWalletAdapter_connecting, false, "f");
        $78422a608777eed2$var$__classPrivateFieldSet(this, $78422a608777eed2$var$_StandardWalletAdapter_disconnecting, false, "f");
        const off = $78422a608777eed2$var$__classPrivateFieldGet(this, $78422a608777eed2$var$_StandardWalletAdapter_off, "f");
        if (off) {
            $78422a608777eed2$var$__classPrivateFieldSet(this, $78422a608777eed2$var$_StandardWalletAdapter_off, null, "f");
            off();
        }
    }
    async autoConnect() {
        return $78422a608777eed2$var$__classPrivateFieldGet(this, $78422a608777eed2$var$_StandardWalletAdapter_instances, "m", $78422a608777eed2$var$_StandardWalletAdapter_connect).call(this, {
            silent: true
        });
    }
    async connect() {
        return $78422a608777eed2$var$__classPrivateFieldGet(this, $78422a608777eed2$var$_StandardWalletAdapter_instances, "m", $78422a608777eed2$var$_StandardWalletAdapter_connect).call(this);
    }
    async disconnect() {
        if ((0, $393285782087969c$export$38dbd4bbb9b696e6) in $78422a608777eed2$var$__classPrivateFieldGet(this, $78422a608777eed2$var$_StandardWalletAdapter_wallet, "f").features) try {
            $78422a608777eed2$var$__classPrivateFieldSet(this, $78422a608777eed2$var$_StandardWalletAdapter_disconnecting, true, "f");
            await $78422a608777eed2$var$__classPrivateFieldGet(this, $78422a608777eed2$var$_StandardWalletAdapter_wallet, "f").features[0, $393285782087969c$export$38dbd4bbb9b696e6].disconnect();
        } catch (error) {
            this.emit("error", new (0, $92c515b2e16b5c4e$export$92e2b26fad5723ee)(error?.message, error));
        } finally{
            $78422a608777eed2$var$__classPrivateFieldSet(this, $78422a608777eed2$var$_StandardWalletAdapter_disconnecting, false, "f");
        }
        $78422a608777eed2$var$__classPrivateFieldGet(this, $78422a608777eed2$var$_StandardWalletAdapter_instances, "m", $78422a608777eed2$var$_StandardWalletAdapter_disconnected).call(this);
    }
    async sendTransaction(transaction, connection, options = {}) {
        try {
            const account = $78422a608777eed2$var$__classPrivateFieldGet(this, $78422a608777eed2$var$_StandardWalletAdapter_account, "f");
            if (!account) throw new (0, $92c515b2e16b5c4e$export$313d299817c74896)();
            let feature;
            if ((0, $iJxGt.SolanaSignAndSendTransaction) in $78422a608777eed2$var$__classPrivateFieldGet(this, $78422a608777eed2$var$_StandardWalletAdapter_wallet, "f").features) {
                if (account.features.includes((0, $iJxGt.SolanaSignAndSendTransaction))) feature = (0, $iJxGt.SolanaSignAndSendTransaction);
                else if ((0, $d2raY.SolanaSignTransaction) in $78422a608777eed2$var$__classPrivateFieldGet(this, $78422a608777eed2$var$_StandardWalletAdapter_wallet, "f").features && account.features.includes((0, $d2raY.SolanaSignTransaction))) feature = (0, $d2raY.SolanaSignTransaction);
                else throw new (0, $92c515b2e16b5c4e$export$cd6fa2f8e2a8a612)();
            } else if ((0, $d2raY.SolanaSignTransaction) in $78422a608777eed2$var$__classPrivateFieldGet(this, $78422a608777eed2$var$_StandardWalletAdapter_wallet, "f").features) {
                if (!account.features.includes((0, $d2raY.SolanaSignTransaction))) throw new (0, $92c515b2e16b5c4e$export$cd6fa2f8e2a8a612)();
                feature = (0, $d2raY.SolanaSignTransaction);
            } else throw new (0, $92c515b2e16b5c4e$export$9525019988612a5e)();
            const chain = (0, $bd67609293f84bc3$export$43dcd8213c5a5741)(connection.rpcEndpoint);
            if (!account.chains.includes(chain)) throw new (0, $92c515b2e16b5c4e$export$769332ac3f90f46c)();
            try {
                const { signers: signers, ...sendOptions } = options;
                let serializedTransaction;
                if ((0, $afa5c06c212ba160$export$37ce1cc82e255d8)(transaction)) {
                    signers?.length && transaction.sign(signers);
                    serializedTransaction = transaction.serialize();
                } else {
                    transaction = await this.prepareTransaction(transaction, connection, sendOptions);
                    signers?.length && transaction.partialSign(...signers);
                    serializedTransaction = new Uint8Array(transaction.serialize({
                        requireAllSignatures: false,
                        verifySignatures: false
                    }));
                }
                if (feature === (0, $iJxGt.SolanaSignAndSendTransaction)) {
                    const [output] = await $78422a608777eed2$var$__classPrivateFieldGet(this, $78422a608777eed2$var$_StandardWalletAdapter_wallet, "f").features[0, $iJxGt.SolanaSignAndSendTransaction].signAndSendTransaction({
                        account: account,
                        chain: chain,
                        transaction: serializedTransaction,
                        options: {
                            preflightCommitment: (0, $89ddb6b3d1c020ef$export$430b2bce150d42d4)(sendOptions.preflightCommitment || connection.commitment),
                            skipPreflight: sendOptions.skipPreflight,
                            maxRetries: sendOptions.maxRetries,
                            minContextSlot: sendOptions.minContextSlot
                        }
                    });
                    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                    return (0, (/*@__PURE__*/$parcel$interopDefault($6663260c56080b45$exports))).encode(output.signature);
                } else {
                    const [output] = await $78422a608777eed2$var$__classPrivateFieldGet(this, $78422a608777eed2$var$_StandardWalletAdapter_wallet, "f").features[0, $d2raY.SolanaSignTransaction].signTransaction({
                        account: account,
                        chain: chain,
                        transaction: serializedTransaction,
                        options: {
                            preflightCommitment: (0, $89ddb6b3d1c020ef$export$430b2bce150d42d4)(sendOptions.preflightCommitment || connection.commitment),
                            minContextSlot: sendOptions.minContextSlot
                        }
                    });
                    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                    return await connection.sendRawTransaction(output.signedTransaction, {
                        ...sendOptions,
                        preflightCommitment: (0, $89ddb6b3d1c020ef$export$430b2bce150d42d4)(sendOptions.preflightCommitment || connection.commitment)
                    });
                }
            } catch (error) {
                if (error instanceof (0, $92c515b2e16b5c4e$export$f46ec6f9dba8711d)) throw error;
                throw new (0, $92c515b2e16b5c4e$export$769332ac3f90f46c)(error?.message, error);
            }
        } catch (error) {
            this.emit("error", error);
            throw error;
        }
    }
}
$78422a608777eed2$var$_StandardWalletAdapter_account = new WeakMap(), $78422a608777eed2$var$_StandardWalletAdapter_publicKey = new WeakMap(), $78422a608777eed2$var$_StandardWalletAdapter_connecting = new WeakMap(), $78422a608777eed2$var$_StandardWalletAdapter_disconnecting = new WeakMap(), $78422a608777eed2$var$_StandardWalletAdapter_off = new WeakMap(), $78422a608777eed2$var$_StandardWalletAdapter_supportedTransactionVersions = new WeakMap(), $78422a608777eed2$var$_StandardWalletAdapter_wallet = new WeakMap(), $78422a608777eed2$var$_StandardWalletAdapter_readyState = new WeakMap(), $78422a608777eed2$var$_StandardWalletAdapter_changed = new WeakMap(), $78422a608777eed2$var$_StandardWalletAdapter_instances = new WeakSet(), $78422a608777eed2$var$_StandardWalletAdapter_connect = async function _StandardWalletAdapter_connect(input) {
    try {
        if (this.connected || this.connecting) return;
        if ($78422a608777eed2$var$__classPrivateFieldGet(this, $78422a608777eed2$var$_StandardWalletAdapter_readyState, "f") !== (0, $a27aaf340df890aa$export$2a7b8071105d05b6).Installed) throw new (0, $92c515b2e16b5c4e$export$d65db264eda99cd7)();
        $78422a608777eed2$var$__classPrivateFieldSet(this, $78422a608777eed2$var$_StandardWalletAdapter_connecting, true, "f");
        if (!$78422a608777eed2$var$__classPrivateFieldGet(this, $78422a608777eed2$var$_StandardWalletAdapter_wallet, "f").accounts.length) try {
            await $78422a608777eed2$var$__classPrivateFieldGet(this, $78422a608777eed2$var$_StandardWalletAdapter_wallet, "f").features[0, $744408f28809a335$export$cc68487eeb93b1d4].connect(input);
        } catch (error) {
            throw new (0, $92c515b2e16b5c4e$export$38f21f1c810261c7)(error?.message, error);
        }
        const account = $78422a608777eed2$var$__classPrivateFieldGet(this, $78422a608777eed2$var$_StandardWalletAdapter_wallet, "f").accounts[0];
        if (!account) throw new (0, $92c515b2e16b5c4e$export$cd6fa2f8e2a8a612)();
        $78422a608777eed2$var$__classPrivateFieldGet(this, $78422a608777eed2$var$_StandardWalletAdapter_instances, "m", $78422a608777eed2$var$_StandardWalletAdapter_connected).call(this, account);
    } catch (error) {
        this.emit("error", error);
        throw error;
    } finally{
        $78422a608777eed2$var$__classPrivateFieldSet(this, $78422a608777eed2$var$_StandardWalletAdapter_connecting, false, "f");
    }
}, $78422a608777eed2$var$_StandardWalletAdapter_connected = function _StandardWalletAdapter_connected(account) {
    let publicKey;
    try {
        // Use account.address instead of account.publicKey since address could be a PDA
        publicKey = new (0, $gNDby.PublicKey)(account.address);
    } catch (error) {
        throw new (0, $92c515b2e16b5c4e$export$735bef3bfb0f2c86)(error?.message, error);
    }
    $78422a608777eed2$var$__classPrivateFieldSet(this, $78422a608777eed2$var$_StandardWalletAdapter_account, account, "f");
    $78422a608777eed2$var$__classPrivateFieldSet(this, $78422a608777eed2$var$_StandardWalletAdapter_publicKey, publicKey, "f");
    $78422a608777eed2$var$__classPrivateFieldGet(this, $78422a608777eed2$var$_StandardWalletAdapter_instances, "m", $78422a608777eed2$var$_StandardWalletAdapter_reset).call(this);
    this.emit("connect", publicKey);
}, $78422a608777eed2$var$_StandardWalletAdapter_disconnected = function _StandardWalletAdapter_disconnected() {
    $78422a608777eed2$var$__classPrivateFieldSet(this, $78422a608777eed2$var$_StandardWalletAdapter_account, null, "f");
    $78422a608777eed2$var$__classPrivateFieldSet(this, $78422a608777eed2$var$_StandardWalletAdapter_publicKey, null, "f");
    $78422a608777eed2$var$__classPrivateFieldGet(this, $78422a608777eed2$var$_StandardWalletAdapter_instances, "m", $78422a608777eed2$var$_StandardWalletAdapter_reset).call(this);
    this.emit("disconnect");
}, $78422a608777eed2$var$_StandardWalletAdapter_reset = function _StandardWalletAdapter_reset() {
    const supportedTransactionVersions = (0, $iJxGt.SolanaSignAndSendTransaction) in $78422a608777eed2$var$__classPrivateFieldGet(this, $78422a608777eed2$var$_StandardWalletAdapter_wallet, "f").features ? $78422a608777eed2$var$__classPrivateFieldGet(this, $78422a608777eed2$var$_StandardWalletAdapter_wallet, "f").features[0, $iJxGt.SolanaSignAndSendTransaction].supportedTransactionVersions : $78422a608777eed2$var$__classPrivateFieldGet(this, $78422a608777eed2$var$_StandardWalletAdapter_wallet, "f").features[0, $d2raY.SolanaSignTransaction].supportedTransactionVersions;
    $78422a608777eed2$var$__classPrivateFieldSet(this, $78422a608777eed2$var$_StandardWalletAdapter_supportedTransactionVersions, (0, $59f593984632af6a$export$234180f8206db11b)(supportedTransactionVersions, [
        "legacy"
    ]) ? null : new Set(supportedTransactionVersions), "f");
    if ((0, $d2raY.SolanaSignTransaction) in $78422a608777eed2$var$__classPrivateFieldGet(this, $78422a608777eed2$var$_StandardWalletAdapter_wallet, "f").features && $78422a608777eed2$var$__classPrivateFieldGet(this, $78422a608777eed2$var$_StandardWalletAdapter_account, "f")?.features.includes((0, $d2raY.SolanaSignTransaction))) {
        this.signTransaction = $78422a608777eed2$var$__classPrivateFieldGet(this, $78422a608777eed2$var$_StandardWalletAdapter_instances, "m", $78422a608777eed2$var$_StandardWalletAdapter_signTransaction);
        this.signAllTransactions = $78422a608777eed2$var$__classPrivateFieldGet(this, $78422a608777eed2$var$_StandardWalletAdapter_instances, "m", $78422a608777eed2$var$_StandardWalletAdapter_signAllTransactions);
    } else {
        delete this.signTransaction;
        delete this.signAllTransactions;
    }
    if ((0, $7KE4n.SolanaSignMessage) in $78422a608777eed2$var$__classPrivateFieldGet(this, $78422a608777eed2$var$_StandardWalletAdapter_wallet, "f").features && $78422a608777eed2$var$__classPrivateFieldGet(this, $78422a608777eed2$var$_StandardWalletAdapter_account, "f")?.features.includes((0, $7KE4n.SolanaSignMessage))) this.signMessage = $78422a608777eed2$var$__classPrivateFieldGet(this, $78422a608777eed2$var$_StandardWalletAdapter_instances, "m", $78422a608777eed2$var$_StandardWalletAdapter_signMessage);
    else delete this.signMessage;
    if ((0, $29a99a74b28f2560$export$8adeab75f48a3607) in $78422a608777eed2$var$__classPrivateFieldGet(this, $78422a608777eed2$var$_StandardWalletAdapter_wallet, "f").features) this.signIn = $78422a608777eed2$var$__classPrivateFieldGet(this, $78422a608777eed2$var$_StandardWalletAdapter_instances, "m", $78422a608777eed2$var$_StandardWalletAdapter_signIn);
    else delete this.signIn;
}, $78422a608777eed2$var$_StandardWalletAdapter_signTransaction = async function _StandardWalletAdapter_signTransaction(transaction) {
    try {
        const account = $78422a608777eed2$var$__classPrivateFieldGet(this, $78422a608777eed2$var$_StandardWalletAdapter_account, "f");
        if (!account) throw new (0, $92c515b2e16b5c4e$export$313d299817c74896)();
        if (!((0, $d2raY.SolanaSignTransaction) in $78422a608777eed2$var$__classPrivateFieldGet(this, $78422a608777eed2$var$_StandardWalletAdapter_wallet, "f").features)) throw new (0, $92c515b2e16b5c4e$export$9525019988612a5e)();
        if (!account.features.includes((0, $d2raY.SolanaSignTransaction))) throw new (0, $92c515b2e16b5c4e$export$cd6fa2f8e2a8a612)();
        try {
            const signedTransactions = await $78422a608777eed2$var$__classPrivateFieldGet(this, $78422a608777eed2$var$_StandardWalletAdapter_wallet, "f").features[0, $d2raY.SolanaSignTransaction].signTransaction({
                account: account,
                transaction: (0, $afa5c06c212ba160$export$37ce1cc82e255d8)(transaction) ? transaction.serialize() : new Uint8Array(transaction.serialize({
                    requireAllSignatures: false,
                    verifySignatures: false
                }))
            });
            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            const serializedTransaction = signedTransactions[0].signedTransaction;
            return (0, $afa5c06c212ba160$export$37ce1cc82e255d8)(transaction) ? (0, $gNDby.VersionedTransaction).deserialize(serializedTransaction) : (0, $gNDby.Transaction).from(serializedTransaction);
        } catch (error) {
            if (error instanceof (0, $92c515b2e16b5c4e$export$f46ec6f9dba8711d)) throw error;
            throw new (0, $92c515b2e16b5c4e$export$96f177062fdd8180)(error?.message, error);
        }
    } catch (error) {
        this.emit("error", error);
        throw error;
    }
}, $78422a608777eed2$var$_StandardWalletAdapter_signAllTransactions = async function _StandardWalletAdapter_signAllTransactions(transactions) {
    try {
        const account = $78422a608777eed2$var$__classPrivateFieldGet(this, $78422a608777eed2$var$_StandardWalletAdapter_account, "f");
        if (!account) throw new (0, $92c515b2e16b5c4e$export$313d299817c74896)();
        if (!((0, $d2raY.SolanaSignTransaction) in $78422a608777eed2$var$__classPrivateFieldGet(this, $78422a608777eed2$var$_StandardWalletAdapter_wallet, "f").features)) throw new (0, $92c515b2e16b5c4e$export$9525019988612a5e)();
        if (!account.features.includes((0, $d2raY.SolanaSignTransaction))) throw new (0, $92c515b2e16b5c4e$export$cd6fa2f8e2a8a612)();
        try {
            const signedTransactions = await $78422a608777eed2$var$__classPrivateFieldGet(this, $78422a608777eed2$var$_StandardWalletAdapter_wallet, "f").features[0, $d2raY.SolanaSignTransaction].signTransaction(...transactions.map((transaction)=>({
                    account: account,
                    transaction: (0, $afa5c06c212ba160$export$37ce1cc82e255d8)(transaction) ? transaction.serialize() : new Uint8Array(transaction.serialize({
                        requireAllSignatures: false,
                        verifySignatures: false
                    }))
                })));
            return transactions.map((transaction, index)=>{
                // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                const signedTransaction = signedTransactions[index].signedTransaction;
                return (0, $afa5c06c212ba160$export$37ce1cc82e255d8)(transaction) ? (0, $gNDby.VersionedTransaction).deserialize(signedTransaction) : (0, $gNDby.Transaction).from(signedTransaction);
            });
        } catch (error) {
            throw new (0, $92c515b2e16b5c4e$export$96f177062fdd8180)(error?.message, error);
        }
    } catch (error) {
        this.emit("error", error);
        throw error;
    }
}, $78422a608777eed2$var$_StandardWalletAdapter_signMessage = async function _StandardWalletAdapter_signMessage(message) {
    try {
        const account = $78422a608777eed2$var$__classPrivateFieldGet(this, $78422a608777eed2$var$_StandardWalletAdapter_account, "f");
        if (!account) throw new (0, $92c515b2e16b5c4e$export$313d299817c74896)();
        if (!((0, $7KE4n.SolanaSignMessage) in $78422a608777eed2$var$__classPrivateFieldGet(this, $78422a608777eed2$var$_StandardWalletAdapter_wallet, "f").features)) throw new (0, $92c515b2e16b5c4e$export$9525019988612a5e)();
        if (!account.features.includes((0, $7KE4n.SolanaSignMessage))) throw new (0, $92c515b2e16b5c4e$export$cd6fa2f8e2a8a612)();
        try {
            const signedMessages = await $78422a608777eed2$var$__classPrivateFieldGet(this, $78422a608777eed2$var$_StandardWalletAdapter_wallet, "f").features[0, $7KE4n.SolanaSignMessage].signMessage({
                account: account,
                message: message
            });
            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            return signedMessages[0].signature;
        } catch (error) {
            throw new (0, $92c515b2e16b5c4e$export$2622c1721bbd4b17)(error?.message, error);
        }
    } catch (error) {
        this.emit("error", error);
        throw error;
    }
}, $78422a608777eed2$var$_StandardWalletAdapter_signIn = async function _StandardWalletAdapter_signIn(input = {}) {
    try {
        if (!((0, $29a99a74b28f2560$export$8adeab75f48a3607) in $78422a608777eed2$var$__classPrivateFieldGet(this, $78422a608777eed2$var$_StandardWalletAdapter_wallet, "f").features)) throw new (0, $92c515b2e16b5c4e$export$9525019988612a5e)();
        let output;
        try {
            [output] = await $78422a608777eed2$var$__classPrivateFieldGet(this, $78422a608777eed2$var$_StandardWalletAdapter_wallet, "f").features[0, $29a99a74b28f2560$export$8adeab75f48a3607].signIn(input);
        } catch (error) {
            throw new (0, $92c515b2e16b5c4e$export$a4c7d3c66e3cdd6c)(error?.message, error);
        }
        if (!output) throw new (0, $92c515b2e16b5c4e$export$a4c7d3c66e3cdd6c)();
        $78422a608777eed2$var$__classPrivateFieldGet(this, $78422a608777eed2$var$_StandardWalletAdapter_instances, "m", $78422a608777eed2$var$_StandardWalletAdapter_connected).call(this, output.account);
        return output;
    } catch (error) {
        this.emit("error", error);
        throw error;
    }
};


var $86bcbe742b97bee8$var$__classPrivateFieldSet = undefined && undefined.__classPrivateFieldSet || function(receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value), value;
};
var $86bcbe742b97bee8$var$__classPrivateFieldGet = undefined && undefined.__classPrivateFieldGet || function(receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
};
var $86bcbe742b97bee8$var$_AppReadyEvent_detail;
let $86bcbe742b97bee8$var$wallets = undefined;
const $86bcbe742b97bee8$var$registered = new Set();
const $86bcbe742b97bee8$var$listeners = {};
function $86bcbe742b97bee8$export$ac4d188b6eef3eb7() {
    if ($86bcbe742b97bee8$var$wallets) return $86bcbe742b97bee8$var$wallets;
    $86bcbe742b97bee8$var$wallets = Object.freeze({
        register: $86bcbe742b97bee8$var$register,
        get: $86bcbe742b97bee8$var$get,
        on: $86bcbe742b97bee8$var$on
    });
    if (typeof window === "undefined") return $86bcbe742b97bee8$var$wallets;
    const api = Object.freeze({
        register: $86bcbe742b97bee8$var$register
    });
    try {
        window.addEventListener("wallet-standard:register-wallet", ({ detail: callback })=>callback(api));
    } catch (error) {
        console.error("wallet-standard:register-wallet event listener could not be added\n", error);
    }
    try {
        window.dispatchEvent(new $86bcbe742b97bee8$var$AppReadyEvent(api));
    } catch (error) {
        console.error("wallet-standard:app-ready event could not be dispatched\n", error);
    }
    return $86bcbe742b97bee8$var$wallets;
}
function $86bcbe742b97bee8$var$register(...wallets) {
    // Filter out wallets that have already been registered.
    // This prevents the same wallet from being registered twice, but it also prevents wallets from being
    // unregistered by reusing a reference to the wallet to obtain the unregister function for it.
    wallets = wallets.filter((wallet)=>!$86bcbe742b97bee8$var$registered.has(wallet));
    // If there are no new wallets to register, just return a no-op unregister function.
    // eslint-disable-next-line @typescript-eslint/no-empty-function
    if (!wallets.length) return ()=>{};
    wallets.forEach((wallet)=>$86bcbe742b97bee8$var$registered.add(wallet));
    $86bcbe742b97bee8$var$listeners["register"]?.forEach((listener)=>$86bcbe742b97bee8$var$guard(()=>listener(...wallets)));
    // Return a function that unregisters the registered wallets.
    return function unregister() {
        wallets.forEach((wallet)=>$86bcbe742b97bee8$var$registered.delete(wallet));
        $86bcbe742b97bee8$var$listeners["unregister"]?.forEach((listener)=>$86bcbe742b97bee8$var$guard(()=>listener(...wallets)));
    };
}
function $86bcbe742b97bee8$var$get() {
    return [
        ...$86bcbe742b97bee8$var$registered
    ];
}
function $86bcbe742b97bee8$var$on(event, listener) {
    $86bcbe742b97bee8$var$listeners[event]?.push(listener) || ($86bcbe742b97bee8$var$listeners[event] = [
        listener
    ]);
    // Return a function that removes the event listener.
    return function off() {
        $86bcbe742b97bee8$var$listeners[event] = $86bcbe742b97bee8$var$listeners[event]?.filter((existingListener)=>listener !== existingListener);
    };
}
function $86bcbe742b97bee8$var$guard(callback) {
    try {
        callback();
    } catch (error) {
        console.error(error);
    }
}
class $86bcbe742b97bee8$var$AppReadyEvent extends Event {
    constructor(api){
        super("wallet-standard:app-ready", {
            bubbles: false,
            cancelable: false,
            composed: false
        });
        $86bcbe742b97bee8$var$_AppReadyEvent_detail.set(this, void 0);
        $86bcbe742b97bee8$var$__classPrivateFieldSet(this, $86bcbe742b97bee8$var$_AppReadyEvent_detail, api, "f");
    }
    get detail() {
        return $86bcbe742b97bee8$var$__classPrivateFieldGet(this, $86bcbe742b97bee8$var$_AppReadyEvent_detail, "f");
    }
    get type() {
        return "wallet-standard:app-ready";
    }
    /** @deprecated */ preventDefault() {
        throw new Error("preventDefault cannot be called");
    }
    /** @deprecated */ stopImmediatePropagation() {
        throw new Error("stopImmediatePropagation cannot be called");
    }
    /** @deprecated */ stopPropagation() {
        throw new Error("stopPropagation cannot be called");
    }
}
$86bcbe742b97bee8$var$_AppReadyEvent_detail = new WeakMap();
function $86bcbe742b97bee8$export$2194deb72a59836d() {
    if ($86bcbe742b97bee8$var$wallets) return $86bcbe742b97bee8$var$wallets;
    $86bcbe742b97bee8$var$wallets = $86bcbe742b97bee8$export$ac4d188b6eef3eb7();
    if (typeof window === "undefined") return $86bcbe742b97bee8$var$wallets;
    const callbacks = window.navigator.wallets || [];
    if (!Array.isArray(callbacks)) {
        console.error("window.navigator.wallets is not an array");
        return $86bcbe742b97bee8$var$wallets;
    }
    const { register: register } = $86bcbe742b97bee8$var$wallets;
    const push = (...callbacks)=>callbacks.forEach((callback)=>$86bcbe742b97bee8$var$guard(()=>callback({
                    register: register
                })));
    try {
        Object.defineProperty(window.navigator, "wallets", {
            value: Object.freeze({
                push: push
            })
        });
    } catch (error) {
        console.error("window.navigator.wallets could not be set");
        return $86bcbe742b97bee8$var$wallets;
    }
    push(...callbacks);
    return $86bcbe742b97bee8$var$wallets;
}



var $acw62 = parcelRequire("acw62");
function $49086cb6c557b9e5$export$ca3bd81d254ceecf(adapters) {
    const warnings = $49086cb6c557b9e5$var$useConstant(()=>new Set());
    const { get: get, on: on } = $49086cb6c557b9e5$var$useConstant(()=>(0, $86bcbe742b97bee8$export$2194deb72a59836d)());
    const [standardAdapters, setStandardAdapters] = (0, $acw62.useState)(()=>$49086cb6c557b9e5$var$wrapWalletsWithAdapters(get()));
    (0, $acw62.useEffect)(()=>{
        const listeners = [
            on("register", (...wallets)=>setStandardAdapters((standardAdapters)=>[
                        ...standardAdapters,
                        ...$49086cb6c557b9e5$var$wrapWalletsWithAdapters(wallets)
                    ])),
            on("unregister", (...wallets)=>setStandardAdapters((standardAdapters)=>standardAdapters.filter((standardAdapter)=>wallets.some((wallet)=>wallet === standardAdapter.wallet))))
        ];
        return ()=>listeners.forEach((off)=>off());
    }, [
        on
    ]);
    const prevStandardAdapters = $49086cb6c557b9e5$var$usePrevious(standardAdapters);
    (0, $acw62.useEffect)(()=>{
        if (!prevStandardAdapters) return;
        const currentAdapters = new Set(standardAdapters);
        const removedAdapters = new Set(prevStandardAdapters.filter((previousAdapter)=>!currentAdapters.has(previousAdapter)));
        removedAdapters.forEach((adapter)=>adapter.destroy());
    }, [
        prevStandardAdapters,
        standardAdapters
    ]);
    // eslint-disable-next-line react-hooks/exhaustive-deps
    (0, $acw62.useEffect)(()=>()=>standardAdapters.forEach((adapter)=>adapter.destroy()), []);
    return (0, $acw62.useMemo)(()=>[
            ...standardAdapters,
            ...adapters.filter(({ name: name })=>{
                if (standardAdapters.some((standardAdapter)=>standardAdapter.name === name)) {
                    if (!warnings.has(name)) {
                        warnings.add(name);
                        console.warn(`${name} was registered as a Standard Wallet. The Wallet Adapter for ${name} can be removed from your app.`);
                    }
                    return false;
                }
                return true;
            })
        ], [
        standardAdapters,
        adapters,
        warnings
    ]);
}
function $49086cb6c557b9e5$var$useConstant(fn) {
    const ref = (0, $acw62.useRef)();
    if (!ref.current) ref.current = {
        value: fn()
    };
    return ref.current.value;
}
function $49086cb6c557b9e5$var$usePrevious(state) {
    const ref = (0, $acw62.useRef)();
    (0, $acw62.useEffect)(()=>{
        ref.current = state;
    });
    return ref.current;
}
function $49086cb6c557b9e5$var$wrapWalletsWithAdapters(wallets) {
    return wallets.filter((0, $05a5d3c47b24c22b$export$c5439c91843266e6)).map((wallet)=>new (0, $78422a608777eed2$export$e0949de9e32fe3b2)({
            wallet: wallet
        }));
}



var $acw62 = parcelRequire("acw62");


var $75c7a421bb3832e5$export$7dc6752a22ab011a;
(function(Environment) {
    Environment[Environment["DESKTOP_WEB"] = 0] = "DESKTOP_WEB";
    Environment[Environment["MOBILE_WEB"] = 1] = "MOBILE_WEB";
})($75c7a421bb3832e5$export$7dc6752a22ab011a || ($75c7a421bb3832e5$export$7dc6752a22ab011a = {}));
function $75c7a421bb3832e5$var$isWebView(userAgentString) {
    return /(WebView|Version\/.+(Chrome)\/(\d+)\.(\d+)\.(\d+)\.(\d+)|; wv\).+(Chrome)\/(\d+)\.(\d+)\.(\d+)\.(\d+))/i.test(userAgentString);
}
function $75c7a421bb3832e5$export$2e2bcd8739ae039({ adapters: adapters, userAgentString: userAgentString }) {
    if (adapters.some((adapter)=>adapter.name !== (0, $c0734f9a20f45199$export$f1265e9082f346f1) && adapter.readyState === (0, $a27aaf340df890aa$export$2a7b8071105d05b6).Installed)) /**
         * There are only two ways a browser extension adapter should be able to reach `Installed` status:
         *
         *     1. Its browser extension is installed.
         *     2. The app is running on a mobile wallet's in-app browser.
         *
         * In either case, we consider the environment to be desktop-like.
         */ return $75c7a421bb3832e5$export$7dc6752a22ab011a.DESKTOP_WEB;
    if (userAgentString && // Step 1: Check whether we're on a platform that supports MWA at all.
    /android/i.test(userAgentString) && // Step 2: Determine that we are *not* running in a WebView.
    !$75c7a421bb3832e5$var$isWebView(userAgentString)) return $75c7a421bb3832e5$export$7dc6752a22ab011a.MOBILE_WEB;
    else return $75c7a421bb3832e5$export$7dc6752a22ab011a.DESKTOP_WEB;
}


function $5a1621a149c16912$export$2e2bcd8739ae039(endpoint) {
    if (!endpoint) return "mainnet-beta";
    if (/devnet/i.test(endpoint)) return "devnet";
    else if (/testnet/i.test(endpoint)) return "testnet";
    else return "mainnet-beta";
}




var $acw62 = parcelRequire("acw62");
function $c2fd0e07139613a0$export$86e2cef2561044ac(key, defaultState) {
    const state = (0, $acw62.useState)(()=>{
        try {
            const value = localStorage.getItem(key);
            if (value) return JSON.parse(value);
        } catch (error) {
            if (typeof window !== "undefined") console.error(error);
        }
        return defaultState;
    });
    const value = state[0];
    const isFirstRenderRef = (0, $acw62.useRef)(true);
    (0, $acw62.useEffect)(()=>{
        if (isFirstRenderRef.current) {
            isFirstRenderRef.current = false;
            return;
        }
        try {
            if (value === null) localStorage.removeItem(key);
            else localStorage.setItem(key, JSON.stringify(value));
        } catch (error) {
            if (typeof window !== "undefined") console.error(error);
        }
    }, [
        value,
        key
    ]);
    return state;
}




var $acw62 = parcelRequire("acw62");

class $3c176f8d57de1623$export$3f5ccdf96415785c extends (0, $92c515b2e16b5c4e$export$f46ec6f9dba8711d) {
    constructor(){
        super(...arguments);
        this.name = "WalletNotSelectedError";
    }
}



var $acw62 = parcelRequire("acw62");
const $3aa6d87558212265$var$EMPTY_ARRAY = [];
const $3aa6d87558212265$var$DEFAULT_CONTEXT = {
    autoConnect: false,
    connecting: false,
    connected: false,
    disconnecting: false,
    select () {
        $3aa6d87558212265$var$logMissingProviderError("call", "select");
    },
    connect () {
        return Promise.reject($3aa6d87558212265$var$logMissingProviderError("call", "connect"));
    },
    disconnect () {
        return Promise.reject($3aa6d87558212265$var$logMissingProviderError("call", "disconnect"));
    },
    sendTransaction () {
        return Promise.reject($3aa6d87558212265$var$logMissingProviderError("call", "sendTransaction"));
    },
    signTransaction () {
        return Promise.reject($3aa6d87558212265$var$logMissingProviderError("call", "signTransaction"));
    },
    signAllTransactions () {
        return Promise.reject($3aa6d87558212265$var$logMissingProviderError("call", "signAllTransactions"));
    },
    signMessage () {
        return Promise.reject($3aa6d87558212265$var$logMissingProviderError("call", "signMessage"));
    },
    signIn () {
        return Promise.reject($3aa6d87558212265$var$logMissingProviderError("call", "signIn"));
    }
};
Object.defineProperty($3aa6d87558212265$var$DEFAULT_CONTEXT, "wallets", {
    get () {
        $3aa6d87558212265$var$logMissingProviderError("read", "wallets");
        return $3aa6d87558212265$var$EMPTY_ARRAY;
    }
});
Object.defineProperty($3aa6d87558212265$var$DEFAULT_CONTEXT, "wallet", {
    get () {
        $3aa6d87558212265$var$logMissingProviderError("read", "wallet");
        return null;
    }
});
Object.defineProperty($3aa6d87558212265$var$DEFAULT_CONTEXT, "publicKey", {
    get () {
        $3aa6d87558212265$var$logMissingProviderError("read", "publicKey");
        return null;
    }
});
function $3aa6d87558212265$var$logMissingProviderError(action, property) {
    const error = new Error(`You have tried to ${action} "${property}" on a WalletContext without providing one. ` + "Make sure to render a WalletProvider as an ancestor of the component that uses WalletContext.");
    console.error(error);
    return error;
}
const $3aa6d87558212265$export$19648c908dc8d0bf = (0, $acw62.createContext)($3aa6d87558212265$var$DEFAULT_CONTEXT);
function $3aa6d87558212265$export$c34addee860b0acb() {
    return (0, $acw62.useContext)($3aa6d87558212265$export$19648c908dc8d0bf);
}


function $9230ddfe51f70f6e$export$a50b3c99d691184b({ children: children, wallets: adapters, adapter: adapter, isUnloadingRef: isUnloadingRef, onAutoConnectRequest: onAutoConnectRequest, onConnectError: onConnectError, onError: onError, onSelectWallet: onSelectWallet }) {
    const isConnectingRef = (0, $acw62.useRef)(false);
    const [connecting, setConnecting] = (0, $acw62.useState)(false);
    const isDisconnectingRef = (0, $acw62.useRef)(false);
    const [disconnecting, setDisconnecting] = (0, $acw62.useState)(false);
    const [publicKey, setPublicKey] = (0, $acw62.useState)(()=>adapter?.publicKey ?? null);
    const [connected, setConnected] = (0, $acw62.useState)(()=>adapter?.connected ?? false);
    /**
     * Store the error handlers as refs so that a change in the
     * custom error handler does not recompute other dependencies.
     */ const onErrorRef = (0, $acw62.useRef)(onError);
    (0, $acw62.useEffect)(()=>{
        onErrorRef.current = onError;
        return ()=>{
            onErrorRef.current = undefined;
        };
    }, [
        onError
    ]);
    const handleErrorRef = (0, $acw62.useRef)((error, adapter)=>{
        if (!isUnloadingRef.current) {
            if (onErrorRef.current) onErrorRef.current(error, adapter);
            else {
                console.error(error, adapter);
                if (error instanceof (0, $92c515b2e16b5c4e$export$d65db264eda99cd7) && typeof window !== "undefined" && adapter) window.open(adapter.url, "_blank");
            }
        }
        return error;
    });
    // Wrap adapters to conform to the `Wallet` interface
    const [wallets, setWallets] = (0, $acw62.useState)(()=>adapters.map((adapter)=>({
                adapter: adapter,
                readyState: adapter.readyState
            })).filter(({ readyState: readyState })=>readyState !== (0, $a27aaf340df890aa$export$2a7b8071105d05b6).Unsupported));
    // When the adapters change, start to listen for changes to their `readyState`
    (0, $acw62.useEffect)(()=>{
        // When the adapters change, wrap them to conform to the `Wallet` interface
        setWallets((wallets)=>adapters.map((adapter, index)=>{
                const wallet = wallets[index];
                // If the wallet hasn't changed, return the same instance
                return wallet && wallet.adapter === adapter && wallet.readyState === adapter.readyState ? wallet : {
                    adapter: adapter,
                    readyState: adapter.readyState
                };
            }).filter(({ readyState: readyState })=>readyState !== (0, $a27aaf340df890aa$export$2a7b8071105d05b6).Unsupported));
        function handleReadyStateChange(readyState) {
            setWallets((prevWallets)=>{
                const index = prevWallets.findIndex(({ adapter: adapter })=>adapter === this);
                if (index === -1) return prevWallets;
                // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                const { adapter: adapter } = prevWallets[index];
                return [
                    ...prevWallets.slice(0, index),
                    {
                        adapter: adapter,
                        readyState: readyState
                    },
                    ...prevWallets.slice(index + 1)
                ].filter(({ readyState: readyState })=>readyState !== (0, $a27aaf340df890aa$export$2a7b8071105d05b6).Unsupported);
            });
        }
        adapters.forEach((adapter)=>adapter.on("readyStateChange", handleReadyStateChange, adapter));
        return ()=>{
            adapters.forEach((adapter)=>adapter.off("readyStateChange", handleReadyStateChange, adapter));
        };
    }, [
        adapter,
        adapters
    ]);
    const wallet = (0, $acw62.useMemo)(()=>wallets.find((wallet)=>wallet.adapter === adapter) ?? null, [
        adapter,
        wallets
    ]);
    // Setup and teardown event listeners when the adapter changes
    (0, $acw62.useEffect)(()=>{
        if (!adapter) return;
        const handleConnect = (publicKey)=>{
            setPublicKey(publicKey);
            isConnectingRef.current = false;
            setConnecting(false);
            setConnected(true);
            isDisconnectingRef.current = false;
            setDisconnecting(false);
        };
        const handleDisconnect = ()=>{
            if (isUnloadingRef.current) return;
            setPublicKey(null);
            isConnectingRef.current = false;
            setConnecting(false);
            setConnected(false);
            isDisconnectingRef.current = false;
            setDisconnecting(false);
        };
        const handleError = (error)=>{
            handleErrorRef.current(error, adapter);
        };
        adapter.on("connect", handleConnect);
        adapter.on("disconnect", handleDisconnect);
        adapter.on("error", handleError);
        return ()=>{
            adapter.off("connect", handleConnect);
            adapter.off("disconnect", handleDisconnect);
            adapter.off("error", handleError);
            handleDisconnect();
        };
    }, [
        adapter,
        isUnloadingRef
    ]);
    // When the adapter changes, clear the `autoConnect` tracking flag
    const didAttemptAutoConnectRef = (0, $acw62.useRef)(false);
    (0, $acw62.useEffect)(()=>{
        return ()=>{
            didAttemptAutoConnectRef.current = false;
        };
    }, [
        adapter
    ]);
    // If auto-connect is enabled, request to connect when the adapter changes and is ready
    (0, $acw62.useEffect)(()=>{
        if (didAttemptAutoConnectRef.current || isConnectingRef.current || connected || !onAutoConnectRequest || !(wallet?.readyState === (0, $a27aaf340df890aa$export$2a7b8071105d05b6).Installed || wallet?.readyState === (0, $a27aaf340df890aa$export$2a7b8071105d05b6).Loadable)) return;
        isConnectingRef.current = true;
        setConnecting(true);
        didAttemptAutoConnectRef.current = true;
        (async function() {
            try {
                await onAutoConnectRequest();
            } catch  {
                onConnectError();
            // Drop the error. It will be caught by `handleError` anyway.
            } finally{
                setConnecting(false);
                isConnectingRef.current = false;
            }
        })();
    }, [
        connected,
        onAutoConnectRequest,
        onConnectError,
        wallet
    ]);
    // Send a transaction using the provided connection
    const sendTransaction = (0, $acw62.useCallback)(async (transaction, connection, options)=>{
        if (!adapter) throw handleErrorRef.current(new (0, $3c176f8d57de1623$export$3f5ccdf96415785c)());
        if (!connected) throw handleErrorRef.current(new (0, $92c515b2e16b5c4e$export$313d299817c74896)(), adapter);
        return await adapter.sendTransaction(transaction, connection, options);
    }, [
        adapter,
        connected
    ]);
    // Sign a transaction if the wallet supports it
    const signTransaction = (0, $acw62.useMemo)(()=>adapter && "signTransaction" in adapter ? async (transaction)=>{
            if (!connected) throw handleErrorRef.current(new (0, $92c515b2e16b5c4e$export$313d299817c74896)(), adapter);
            return await adapter.signTransaction(transaction);
        } : undefined, [
        adapter,
        connected
    ]);
    // Sign multiple transactions if the wallet supports it
    const signAllTransactions = (0, $acw62.useMemo)(()=>adapter && "signAllTransactions" in adapter ? async (transactions)=>{
            if (!connected) throw handleErrorRef.current(new (0, $92c515b2e16b5c4e$export$313d299817c74896)(), adapter);
            return await adapter.signAllTransactions(transactions);
        } : undefined, [
        adapter,
        connected
    ]);
    // Sign an arbitrary message if the wallet supports it
    const signMessage = (0, $acw62.useMemo)(()=>adapter && "signMessage" in adapter ? async (message)=>{
            if (!connected) throw handleErrorRef.current(new (0, $92c515b2e16b5c4e$export$313d299817c74896)(), adapter);
            return await adapter.signMessage(message);
        } : undefined, [
        adapter,
        connected
    ]);
    // Sign in if the wallet supports it
    const signIn = (0, $acw62.useMemo)(()=>adapter && "signIn" in adapter ? async (input)=>{
            return await adapter.signIn(input);
        } : undefined, [
        adapter
    ]);
    const handleConnect = (0, $acw62.useCallback)(async ()=>{
        if (isConnectingRef.current || isDisconnectingRef.current || wallet?.adapter.connected) return;
        if (!wallet) throw handleErrorRef.current(new (0, $3c176f8d57de1623$export$3f5ccdf96415785c)());
        const { adapter: adapter, readyState: readyState } = wallet;
        if (!(readyState === (0, $a27aaf340df890aa$export$2a7b8071105d05b6).Installed || readyState === (0, $a27aaf340df890aa$export$2a7b8071105d05b6).Loadable)) throw handleErrorRef.current(new (0, $92c515b2e16b5c4e$export$d65db264eda99cd7)(), adapter);
        isConnectingRef.current = true;
        setConnecting(true);
        try {
            await adapter.connect();
        } catch (e) {
            onConnectError();
            throw e;
        } finally{
            setConnecting(false);
            isConnectingRef.current = false;
        }
    }, [
        onConnectError,
        wallet
    ]);
    const handleDisconnect = (0, $acw62.useCallback)(async ()=>{
        if (isDisconnectingRef.current) return;
        if (!adapter) return;
        isDisconnectingRef.current = true;
        setDisconnecting(true);
        try {
            await adapter.disconnect();
        } finally{
            setDisconnecting(false);
            isDisconnectingRef.current = false;
        }
    }, [
        adapter
    ]);
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $3aa6d87558212265$export$19648c908dc8d0bf).Provider, {
        value: {
            autoConnect: !!onAutoConnectRequest,
            wallets: wallets,
            wallet: wallet,
            publicKey: publicKey,
            connected: connected,
            connecting: connecting,
            disconnecting: disconnecting,
            select: onSelectWallet,
            connect: handleConnect,
            disconnect: handleDisconnect,
            sendTransaction: sendTransaction,
            signTransaction: signTransaction,
            signAllTransactions: signAllTransactions,
            signMessage: signMessage,
            signIn: signIn
        }
    }, children);
}


let $cd8099a814169194$var$_userAgent;
function $cd8099a814169194$var$getUserAgent() {
    if ($cd8099a814169194$var$_userAgent === undefined) $cd8099a814169194$var$_userAgent = globalThis.navigator?.userAgent ?? null;
    return $cd8099a814169194$var$_userAgent;
}
function $cd8099a814169194$var$getIsMobile(adapters) {
    const userAgentString = $cd8099a814169194$var$getUserAgent();
    return (0, $75c7a421bb3832e5$export$2e2bcd8739ae039)({
        adapters: adapters,
        userAgentString: userAgentString
    }) === (0, $75c7a421bb3832e5$export$7dc6752a22ab011a).MOBILE_WEB;
}
function $cd8099a814169194$var$getUriForAppIdentity() {
    const location = globalThis.location;
    if (!location) return;
    return `${location.protocol}//${location.host}`;
}
function $cd8099a814169194$export$717b22fc3a2082b3({ children: children, wallets: adapters, autoConnect: autoConnect, localStorageKey: localStorageKey = "walletName", onError: onError }) {
    const { connection: connection } = (0, $86c338e4d5b0d511$export$985e8768c0e91dbc)();
    const adaptersWithStandardAdapters = (0, $49086cb6c557b9e5$export$ca3bd81d254ceecf)(adapters);
    const mobileWalletAdapter = (0, $acw62.useMemo)(()=>{
        if (!$cd8099a814169194$var$getIsMobile(adaptersWithStandardAdapters)) return null;
        const existingMobileWalletAdapter = adaptersWithStandardAdapters.find((adapter)=>adapter.name === (0, $c0734f9a20f45199$export$f1265e9082f346f1));
        if (existingMobileWalletAdapter) return existingMobileWalletAdapter;
        return new (0, $c0734f9a20f45199$export$dec251788b2f5a84)({
            addressSelector: (0, $c0734f9a20f45199$export$a299fb0acc11345b)(),
            appIdentity: {
                uri: $cd8099a814169194$var$getUriForAppIdentity()
            },
            authorizationResultCache: (0, $c0734f9a20f45199$export$4a0b597891770806)(),
            cluster: (0, $5a1621a149c16912$export$2e2bcd8739ae039)(connection?.rpcEndpoint),
            onWalletNotFound: (0, $c0734f9a20f45199$export$e8b9e70cdf783b70)()
        });
    }, [
        adaptersWithStandardAdapters,
        connection?.rpcEndpoint
    ]);
    const adaptersWithMobileWalletAdapter = (0, $acw62.useMemo)(()=>{
        if (mobileWalletAdapter == null || adaptersWithStandardAdapters.indexOf(mobileWalletAdapter) !== -1) return adaptersWithStandardAdapters;
        return [
            mobileWalletAdapter,
            ...adaptersWithStandardAdapters
        ];
    }, [
        adaptersWithStandardAdapters,
        mobileWalletAdapter
    ]);
    const [walletName, setWalletName] = (0, $c2fd0e07139613a0$export$86e2cef2561044ac)(localStorageKey, $cd8099a814169194$var$getIsMobile(adaptersWithStandardAdapters) ? (0, $c0734f9a20f45199$export$f1265e9082f346f1) : null);
    const adapter = (0, $acw62.useMemo)(()=>adaptersWithMobileWalletAdapter.find((a)=>a.name === walletName) ?? null, [
        adaptersWithMobileWalletAdapter,
        walletName
    ]);
    const changeWallet = (0, $acw62.useCallback)((nextWalletName)=>{
        if (walletName === nextWalletName) return;
        if (adapter && // Selecting a wallet other than the mobile wallet adapter is not
        // sufficient reason to call `disconnect` on the mobile wallet adapter.
        // Calling `disconnect` on the mobile wallet adapter causes the entire
        // authorization store to be wiped.
        adapter.name !== (0, $c0734f9a20f45199$export$f1265e9082f346f1)) adapter.disconnect();
        setWalletName(nextWalletName);
    }, [
        adapter,
        setWalletName,
        walletName
    ]);
    (0, $acw62.useEffect)(()=>{
        if (!adapter) return;
        function handleDisconnect() {
            if (isUnloadingRef.current) return;
            // Leave the adapter selected in the event of a disconnection.
            if (walletName === (0, $c0734f9a20f45199$export$f1265e9082f346f1) && $cd8099a814169194$var$getIsMobile(adaptersWithStandardAdapters)) return;
            setWalletName(null);
        }
        adapter.on("disconnect", handleDisconnect);
        return ()=>{
            adapter.off("disconnect", handleDisconnect);
        };
    }, [
        adapter,
        adaptersWithStandardAdapters,
        setWalletName,
        walletName
    ]);
    const hasUserSelectedAWallet = (0, $acw62.useRef)(false);
    const handleAutoConnectRequest = (0, $acw62.useMemo)(()=>{
        if (!autoConnect || !adapter) return;
        return async ()=>{
            // If autoConnect is true or returns true, use the default autoConnect behavior.
            if (autoConnect === true || await autoConnect(adapter)) {
                if (hasUserSelectedAWallet.current) await adapter.connect();
                else await adapter.autoConnect();
            }
        };
    }, [
        autoConnect,
        adapter
    ]);
    const isUnloadingRef = (0, $acw62.useRef)(false);
    (0, $acw62.useEffect)(()=>{
        if (walletName === (0, $c0734f9a20f45199$export$f1265e9082f346f1) && $cd8099a814169194$var$getIsMobile(adaptersWithStandardAdapters)) {
            isUnloadingRef.current = false;
            return;
        }
        function handleBeforeUnload() {
            isUnloadingRef.current = true;
        }
        /**
         * Some wallets fire disconnection events when the window unloads. Since there's no way to
         * distinguish between a disconnection event received because a user initiated it, and one
         * that was received because they've closed the window, we have to track window unload
         * events themselves. Downstream components use this information to decide whether to act
         * upon or drop wallet events and errors.
         */ window.addEventListener("beforeunload", handleBeforeUnload);
        return ()=>{
            window.removeEventListener("beforeunload", handleBeforeUnload);
        };
    }, [
        adaptersWithStandardAdapters,
        walletName
    ]);
    const handleConnectError = (0, $acw62.useCallback)(()=>{
        if (adapter && adapter.name !== (0, $c0734f9a20f45199$export$f1265e9082f346f1)) // If any error happens while connecting, unset the adapter.
        changeWallet(null);
    }, [
        adapter,
        changeWallet
    ]);
    const selectWallet = (0, $acw62.useCallback)((walletName)=>{
        hasUserSelectedAWallet.current = true;
        changeWallet(walletName);
    }, [
        changeWallet
    ]);
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $9230ddfe51f70f6e$export$a50b3c99d691184b), {
        wallets: adaptersWithMobileWalletAdapter,
        adapter: adapter,
        isUnloadingRef: isUnloadingRef,
        onAutoConnectRequest: handleAutoConnectRequest,
        onConnectError: handleConnectError,
        onError: onError,
        onSelectWallet: selectWallet
    }, children);
}



var $acw62 = parcelRequire("acw62");

var $acw62 = parcelRequire("acw62");
const $ca40ecc6394b8d2e$var$DEFAULT_CONTEXT = {
    setVisible (_open) {
        console.error($ca40ecc6394b8d2e$var$constructMissingProviderErrorMessage("call", "setVisible"));
    },
    visible: false
};
Object.defineProperty($ca40ecc6394b8d2e$var$DEFAULT_CONTEXT, "visible", {
    get () {
        console.error($ca40ecc6394b8d2e$var$constructMissingProviderErrorMessage("read", "visible"));
        return false;
    }
});
function $ca40ecc6394b8d2e$var$constructMissingProviderErrorMessage(action, valueName) {
    return "You have tried to " + ` ${action} "${valueName}"` + " on a WalletModalContext without providing one." + " Make sure to render a WalletModalProvider" + " as an ancestor of the component that uses " + "WalletModalContext";
}
const $ca40ecc6394b8d2e$export$8fa8c0fc3ea86e87 = (0, $acw62.createContext)($ca40ecc6394b8d2e$var$DEFAULT_CONTEXT);
function $ca40ecc6394b8d2e$export$6fdf0454adae214b() {
    return (0, $acw62.useContext)($ca40ecc6394b8d2e$export$8fa8c0fc3ea86e87);
}





var $acw62 = parcelRequire("acw62");


var $acw62 = parcelRequire("acw62");
const $a49dece09ceaa9bd$export$78768a9af065a7b = ({ id: id, children: children, expanded: expanded = false })=>{
    const ref = (0, $acw62.useRef)(null);
    const instant = (0, $acw62.useRef)(true);
    const transition = "height 250ms ease-out";
    const openCollapse = ()=>{
        const node = ref.current;
        if (!node) return;
        requestAnimationFrame(()=>{
            node.style.height = node.scrollHeight + "px";
        });
    };
    const closeCollapse = ()=>{
        const node = ref.current;
        if (!node) return;
        requestAnimationFrame(()=>{
            node.style.height = node.offsetHeight + "px";
            node.style.overflow = "hidden";
            requestAnimationFrame(()=>{
                node.style.height = "0";
            });
        });
    };
    (0, $acw62.useLayoutEffect)(()=>{
        if (expanded) openCollapse();
        else closeCollapse();
    }, [
        expanded
    ]);
    (0, $acw62.useLayoutEffect)(()=>{
        const node = ref.current;
        if (!node) return;
        function handleComplete() {
            if (!node) return;
            node.style.overflow = expanded ? "initial" : "hidden";
            if (expanded) node.style.height = "auto";
        }
        function handleTransitionEnd(event) {
            if (node && event.target === node && event.propertyName === "height") handleComplete();
        }
        if (instant.current) {
            handleComplete();
            instant.current = false;
        }
        node.addEventListener("transitionend", handleTransitionEnd);
        return ()=>node.removeEventListener("transitionend", handleTransitionEnd);
    }, [
        expanded
    ]);
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: "wallet-adapter-collapse",
        id: id,
        ref: ref,
        role: "region",
        style: {
            height: 0,
            transition: instant.current ? undefined : transition
        }
    }, children);
};





var $acw62 = parcelRequire("acw62");

var $acw62 = parcelRequire("acw62");
const $ed43aee2b6d2385b$export$353f5b6fc5456de1 = (props)=>{
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("button", {
        className: `wallet-adapter-button ${props.className || ""}`,
        disabled: props.disabled,
        style: props.style,
        onClick: props.onClick,
        tabIndex: props.tabIndex || 0,
        type: "button"
    }, props.startIcon && (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("i", {
        className: "wallet-adapter-button-start-icon"
    }, props.startIcon), props.children, props.endIcon && (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("i", {
        className: "wallet-adapter-button-end-icon"
    }, props.endIcon));
};



var $acw62 = parcelRequire("acw62");
const $74cea3e5b753b58c$export$deff84e7338ee5a5 = ({ wallet: wallet, ...props })=>{
    return wallet && (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("img", {
        src: wallet.adapter.icon,
        alt: `${wallet.adapter.name} icon`,
        ...props
    });
};


const $d5bc90ea80ec8fbb$export$b6b33106605f17bb = ({ handleClick: handleClick, tabIndex: tabIndex, wallet: wallet })=>{
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("li", null, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $ed43aee2b6d2385b$export$353f5b6fc5456de1), {
        onClick: handleClick,
        startIcon: (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $74cea3e5b753b58c$export$deff84e7338ee5a5), {
            wallet: wallet
        }),
        tabIndex: tabIndex
    }, wallet.adapter.name, wallet.readyState === (0, $a27aaf340df890aa$export$2a7b8071105d05b6).Installed && (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", null, "Detected")));
};



var $acw62 = parcelRequire("acw62");
const $b6b1989aa7a0d175$export$d822b842d2dccc19 = ()=>{
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("svg", {
        width: "97",
        height: "96",
        viewBox: "0 0 97 96",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("circle", {
        cx: "48.5",
        cy: "48",
        r: "48",
        fill: "url(#paint0_linear_880_5115)",
        fillOpacity: "0.1"
    }), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("circle", {
        cx: "48.5",
        cy: "48",
        r: "47",
        stroke: "url(#paint1_linear_880_5115)",
        strokeOpacity: "0.4",
        strokeWidth: "2"
    }), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("g", {
        clipPath: "url(#clip0_880_5115)"
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        d: "M65.5769 28.1523H31.4231C27.6057 28.1523 24.5 31.258 24.5 35.0754V60.9215C24.5 64.7389 27.6057 67.8446 31.4231 67.8446H65.5769C69.3943 67.8446 72.5 64.7389 72.5 60.9215V35.0754C72.5 31.258 69.3943 28.1523 65.5769 28.1523ZM69.7308 52.1523H59.5769C57.2865 52.1523 55.4231 50.289 55.4231 47.9985C55.4231 45.708 57.2864 43.8446 59.5769 43.8446H69.7308V52.1523ZM69.7308 41.0754H59.5769C55.7595 41.0754 52.6539 44.1811 52.6539 47.9985C52.6539 51.8159 55.7595 54.9215 59.5769 54.9215H69.7308V60.9215C69.7308 63.2119 67.8674 65.0754 65.5769 65.0754H31.4231C29.1327 65.0754 27.2692 63.212 27.2692 60.9215V35.0754C27.2692 32.785 29.1326 30.9215 31.4231 30.9215H65.5769C67.8673 30.9215 69.7308 32.7849 69.7308 35.0754V41.0754Z",
        fill: "url(#paint2_linear_880_5115)"
    }), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        d: "M61.4231 46.6172H59.577C58.8123 46.6172 58.1924 47.2371 58.1924 48.0018C58.1924 48.7665 58.8123 49.3863 59.577 49.3863H61.4231C62.1878 49.3863 62.8077 48.7664 62.8077 48.0018C62.8077 47.2371 62.1878 46.6172 61.4231 46.6172Z",
        fill: "url(#paint3_linear_880_5115)"
    })), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("defs", null, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("linearGradient", {
        id: "paint0_linear_880_5115",
        x1: "3.41664",
        y1: "98.0933",
        x2: "103.05",
        y2: "8.42498",
        gradientUnits: "userSpaceOnUse"
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("stop", {
        stopColor: "#9945FF"
    }), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("stop", {
        offset: "0.14",
        stopColor: "#8A53F4"
    }), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("stop", {
        offset: "0.42",
        stopColor: "#6377D6"
    }), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("stop", {
        offset: "0.79",
        stopColor: "#24B0A7"
    }), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("stop", {
        offset: "0.99",
        stopColor: "#00D18C"
    }), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("stop", {
        offset: "1",
        stopColor: "#00D18C"
    })), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("linearGradient", {
        id: "paint1_linear_880_5115",
        x1: "3.41664",
        y1: "98.0933",
        x2: "103.05",
        y2: "8.42498",
        gradientUnits: "userSpaceOnUse"
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("stop", {
        stopColor: "#9945FF"
    }), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("stop", {
        offset: "0.14",
        stopColor: "#8A53F4"
    }), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("stop", {
        offset: "0.42",
        stopColor: "#6377D6"
    }), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("stop", {
        offset: "0.79",
        stopColor: "#24B0A7"
    }), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("stop", {
        offset: "0.99",
        stopColor: "#00D18C"
    }), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("stop", {
        offset: "1",
        stopColor: "#00D18C"
    })), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("linearGradient", {
        id: "paint2_linear_880_5115",
        x1: "25.9583",
        y1: "68.7101",
        x2: "67.2337",
        y2: "23.7879",
        gradientUnits: "userSpaceOnUse"
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("stop", {
        stopColor: "#9945FF"
    }), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("stop", {
        offset: "0.14",
        stopColor: "#8A53F4"
    }), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("stop", {
        offset: "0.42",
        stopColor: "#6377D6"
    }), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("stop", {
        offset: "0.79",
        stopColor: "#24B0A7"
    }), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("stop", {
        offset: "0.99",
        stopColor: "#00D18C"
    }), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("stop", {
        offset: "1",
        stopColor: "#00D18C"
    })), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("linearGradient", {
        id: "paint3_linear_880_5115",
        x1: "58.3326",
        y1: "49.4467",
        x2: "61.0002",
        y2: "45.4453",
        gradientUnits: "userSpaceOnUse"
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("stop", {
        stopColor: "#9945FF"
    }), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("stop", {
        offset: "0.14",
        stopColor: "#8A53F4"
    }), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("stop", {
        offset: "0.42",
        stopColor: "#6377D6"
    }), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("stop", {
        offset: "0.79",
        stopColor: "#24B0A7"
    }), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("stop", {
        offset: "0.99",
        stopColor: "#00D18C"
    }), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("stop", {
        offset: "1",
        stopColor: "#00D18C"
    })), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("clipPath", {
        id: "clip0_880_5115"
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("rect", {
        width: "48",
        height: "48",
        fill: "white",
        transform: "translate(24.5 24)"
    }))));
};


const $1992e5ca812acf06$export$851b8e4aa786e6a1 = ({ className: className = "", container: container = "body" })=>{
    const ref = (0, $acw62.useRef)(null);
    const { wallets: wallets, select: select } = (0, $3aa6d87558212265$export$c34addee860b0acb)();
    const { setVisible: setVisible } = (0, $ca40ecc6394b8d2e$export$6fdf0454adae214b)();
    const [expanded, setExpanded] = (0, $acw62.useState)(false);
    const [fadeIn, setFadeIn] = (0, $acw62.useState)(false);
    const [portal, setPortal] = (0, $acw62.useState)(null);
    const [listedWallets, collapsedWallets] = (0, $acw62.useMemo)(()=>{
        const installed = [];
        const loadable = [];
        const notDetected = [];
        for (const wallet of wallets){
            if (wallet.readyState === (0, $a27aaf340df890aa$export$2a7b8071105d05b6).NotDetected) notDetected.push(wallet);
            else if (wallet.readyState === (0, $a27aaf340df890aa$export$2a7b8071105d05b6).Loadable) loadable.push(wallet);
            else if (wallet.readyState === (0, $a27aaf340df890aa$export$2a7b8071105d05b6).Installed) installed.push(wallet);
        }
        let listed = [];
        let collapsed = [];
        if (installed.length) {
            listed = installed;
            collapsed = [
                ...loadable,
                ...notDetected
            ];
        } else if (loadable.length) {
            listed = loadable;
            collapsed = notDetected;
        } else collapsed = notDetected;
        return [
            listed,
            collapsed
        ];
    }, [
        wallets
    ]);
    const hideModal = (0, $acw62.useCallback)(()=>{
        setFadeIn(false);
        setTimeout(()=>setVisible(false), 150);
    }, [
        setVisible
    ]);
    const handleClose = (0, $acw62.useCallback)((event)=>{
        event.preventDefault();
        hideModal();
    }, [
        hideModal
    ]);
    const handleWalletClick = (0, $acw62.useCallback)((event, walletName)=>{
        select(walletName);
        handleClose(event);
    }, [
        select,
        handleClose
    ]);
    const handleCollapseClick = (0, $acw62.useCallback)(()=>setExpanded(!expanded), [
        expanded
    ]);
    const handleTabKey = (0, $acw62.useCallback)((event)=>{
        const node = ref.current;
        if (!node) return;
        // here we query all focusable elements
        const focusableElements = node.querySelectorAll("button");
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        const firstElement = focusableElements[0];
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        const lastElement = focusableElements[focusableElements.length - 1];
        if (event.shiftKey) // if going backward by pressing tab and firstElement is active, shift focus to last focusable element
        {
            if (document.activeElement === firstElement) {
                lastElement.focus();
                event.preventDefault();
            }
        } else // if going forward by pressing tab and lastElement is active, shift focus to first focusable element
        if (document.activeElement === lastElement) {
            firstElement.focus();
            event.preventDefault();
        }
    }, [
        ref
    ]);
    (0, $acw62.useLayoutEffect)(()=>{
        const handleKeyDown = (event)=>{
            if (event.key === "Escape") hideModal();
            else if (event.key === "Tab") handleTabKey(event);
        };
        // Get original overflow
        const { overflow: overflow } = window.getComputedStyle(document.body);
        // Hack to enable fade in animation after mount
        setTimeout(()=>setFadeIn(true), 0);
        // Prevent scrolling on mount
        document.body.style.overflow = "hidden";
        // Listen for keydown events
        window.addEventListener("keydown", handleKeyDown, false);
        return ()=>{
            // Re-enable scrolling when component unmounts
            document.body.style.overflow = overflow;
            window.removeEventListener("keydown", handleKeyDown, false);
        };
    }, [
        hideModal,
        handleTabKey
    ]);
    (0, $acw62.useLayoutEffect)(()=>setPortal(document.querySelector(container)), [
        container
    ]);
    return portal && (0, $11492dca620dcaa5$exports.createPortal)((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        "aria-labelledby": "wallet-adapter-modal-title",
        "aria-modal": "true",
        className: `wallet-adapter-modal ${fadeIn && "wallet-adapter-modal-fade-in"} ${className}`,
        ref: ref,
        role: "dialog"
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: "wallet-adapter-modal-container"
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: "wallet-adapter-modal-wrapper"
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("button", {
        onClick: handleClose,
        className: "wallet-adapter-modal-button-close"
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("svg", {
        width: "14",
        height: "14"
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        d: "M14 12.461 8.3 6.772l5.234-5.233L12.006 0 6.772 5.234 1.54 0 0 1.539l5.234 5.233L0 12.006l1.539 1.528L6.772 8.3l5.69 5.7L14 12.461z"
    }))), listedWallets.length ? (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("h1", {
        className: "wallet-adapter-modal-title"
    }, "Connect a wallet on Solana to continue"), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("ul", {
        className: "wallet-adapter-modal-list"
    }, listedWallets.map((wallet)=>(0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $d5bc90ea80ec8fbb$export$b6b33106605f17bb), {
            key: wallet.adapter.name,
            handleClick: (event)=>handleWalletClick(event, wallet.adapter.name),
            wallet: wallet
        })), collapsedWallets.length ? (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $a49dece09ceaa9bd$export$78768a9af065a7b), {
        expanded: expanded,
        id: "wallet-adapter-modal-collapse"
    }, collapsedWallets.map((wallet)=>(0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $d5bc90ea80ec8fbb$export$b6b33106605f17bb), {
            key: wallet.adapter.name,
            handleClick: (event)=>handleWalletClick(event, wallet.adapter.name),
            tabIndex: expanded ? 0 : -1,
            wallet: wallet
        }))) : null), collapsedWallets.length ? (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("button", {
        className: "wallet-adapter-modal-list-more",
        onClick: handleCollapseClick,
        tabIndex: 0
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", null, expanded ? "Less " : "More ", "options"), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("svg", {
        width: "13",
        height: "7",
        viewBox: "0 0 13 7",
        xmlns: "http://www.w3.org/2000/svg",
        className: `${expanded ? "wallet-adapter-modal-list-more-icon-rotate" : ""}`
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        d: "M0.71418 1.626L5.83323 6.26188C5.91574 6.33657 6.0181 6.39652 6.13327 6.43762C6.24844 6.47872 6.37371 6.5 6.50048 6.5C6.62725 6.5 6.75252 6.47872 6.8677 6.43762C6.98287 6.39652 7.08523 6.33657 7.16774 6.26188L12.2868 1.626C12.7753 1.1835 12.3703 0.5 11.6195 0.5H1.37997C0.629216 0.5 0.224175 1.1835 0.71418 1.626Z"
    }))) : null) : (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("h1", {
        className: "wallet-adapter-modal-title"
    }, "You'll need a wallet on Solana to continue"), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: "wallet-adapter-modal-middle"
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $b6b1989aa7a0d175$export$d822b842d2dccc19), null)), collapsedWallets.length ? (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("button", {
        className: "wallet-adapter-modal-list-more",
        onClick: handleCollapseClick,
        tabIndex: 0
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", null, expanded ? "Hide " : "Already have a wallet? View ", "options"), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("svg", {
        width: "13",
        height: "7",
        viewBox: "0 0 13 7",
        xmlns: "http://www.w3.org/2000/svg",
        className: `${expanded ? "wallet-adapter-modal-list-more-icon-rotate" : ""}`
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        d: "M0.71418 1.626L5.83323 6.26188C5.91574 6.33657 6.0181 6.39652 6.13327 6.43762C6.24844 6.47872 6.37371 6.5 6.50048 6.5C6.62725 6.5 6.75252 6.47872 6.8677 6.43762C6.98287 6.39652 7.08523 6.33657 7.16774 6.26188L12.2868 1.626C12.7753 1.1835 12.3703 0.5 11.6195 0.5H1.37997C0.629216 0.5 0.224175 1.1835 0.71418 1.626Z"
    }))), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $a49dece09ceaa9bd$export$78768a9af065a7b), {
        expanded: expanded,
        id: "wallet-adapter-modal-collapse"
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("ul", {
        className: "wallet-adapter-modal-list"
    }, collapsedWallets.map((wallet)=>(0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $d5bc90ea80ec8fbb$export$b6b33106605f17bb), {
            key: wallet.adapter.name,
            handleClick: (event)=>handleWalletClick(event, wallet.adapter.name),
            tabIndex: expanded ? 0 : -1,
            wallet: wallet
        }))))) : null))), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: "wallet-adapter-modal-overlay",
        onMouseDown: handleClose
    })), portal);
};


const $d7fa3fcfe186d6c8$export$43bb60413a8a3ee6 = ({ children: children, ...props })=>{
    const [visible, setVisible] = (0, $acw62.useState)(false);
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $ca40ecc6394b8d2e$export$8fa8c0fc3ea86e87).Provider, {
        value: {
            visible: visible,
            setVisible: setVisible
        }
    }, children, visible && (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $1992e5ca812acf06$export$851b8e4aa786e6a1), {
        ...props
    }));
};




parcelRequire("4KAV8");
var $degpm = parcelRequire("degpm");


var $gNDby = parcelRequire("gNDby");


var $6ZWSX = parcelRequire("6ZWSX");
var $1850ff7d0e180dcf$require$Buffer = $6ZWSX.Buffer;
function $1850ff7d0e180dcf$export$11792f2e0d4d6623(account, change) {
    const length = account !== undefined ? change === undefined ? 3 : 4 : 2;
    const derivationPath = $1850ff7d0e180dcf$require$Buffer.alloc(1 + length * 4);
    let offset = derivationPath.writeUInt8(length, 0);
    offset = derivationPath.writeUInt32BE($1850ff7d0e180dcf$var$harden(44), offset); // Using BIP44
    offset = derivationPath.writeUInt32BE($1850ff7d0e180dcf$var$harden(501), offset); // Solana's BIP44 path
    if (account !== undefined) {
        offset = derivationPath.writeUInt32BE($1850ff7d0e180dcf$var$harden(account), offset);
        if (change !== undefined) derivationPath.writeUInt32BE($1850ff7d0e180dcf$var$harden(change), offset);
    }
    return derivationPath;
}
const $1850ff7d0e180dcf$var$BIP32_HARDENED_BIT = 2147483648;
function $1850ff7d0e180dcf$var$harden(n) {
    return (n | $1850ff7d0e180dcf$var$BIP32_HARDENED_BIT) >>> 0;
}
const $1850ff7d0e180dcf$var$INS_GET_PUBKEY = 0x05;
const $1850ff7d0e180dcf$var$INS_SIGN_MESSAGE = 0x06;
const $1850ff7d0e180dcf$var$P1_NON_CONFIRM = 0x00;
const $1850ff7d0e180dcf$var$P1_CONFIRM = 0x01;
const $1850ff7d0e180dcf$var$P2_EXTEND = 0x01;
const $1850ff7d0e180dcf$var$P2_MORE = 0x02;
const $1850ff7d0e180dcf$var$MAX_PAYLOAD = 255;
const $1850ff7d0e180dcf$var$LEDGER_CLA = 0xe0;
async function $1850ff7d0e180dcf$export$889def73691f9837(transport, derivationPath) {
    const bytes = await $1850ff7d0e180dcf$var$send(transport, $1850ff7d0e180dcf$var$INS_GET_PUBKEY, $1850ff7d0e180dcf$var$P1_NON_CONFIRM, derivationPath);
    return new (0, $gNDby.PublicKey)(bytes);
}
async function $1850ff7d0e180dcf$export$6ad02cc4966b42ab(transport, transaction, derivationPath) {
    const paths = $1850ff7d0e180dcf$require$Buffer.alloc(1);
    paths.writeUInt8(1, 0);
    const message = (0, $afa5c06c212ba160$export$37ce1cc82e255d8)(transaction) ? transaction.message.serialize() : transaction.serializeMessage();
    const data = $1850ff7d0e180dcf$require$Buffer.concat([
        paths,
        derivationPath,
        message
    ]);
    return await $1850ff7d0e180dcf$var$send(transport, $1850ff7d0e180dcf$var$INS_SIGN_MESSAGE, $1850ff7d0e180dcf$var$P1_CONFIRM, data);
}
async function $1850ff7d0e180dcf$var$send(transport, instruction, p1, data) {
    let p2 = 0;
    let offset = 0;
    if (data.length > $1850ff7d0e180dcf$var$MAX_PAYLOAD) while(data.length - offset > $1850ff7d0e180dcf$var$MAX_PAYLOAD){
        const buffer = data.slice(offset, offset + $1850ff7d0e180dcf$var$MAX_PAYLOAD);
        const response = await transport.send($1850ff7d0e180dcf$var$LEDGER_CLA, instruction, p1, p2 | $1850ff7d0e180dcf$var$P2_MORE, buffer);
        // @ts-ignore -- TransportStatusError is a constructor Function, not a Class
        if (response.length !== 2) throw new (0, $degpm.TransportStatusError)((0, $degpm.StatusCodes).INCORRECT_DATA);
        p2 |= $1850ff7d0e180dcf$var$P2_EXTEND;
        offset += $1850ff7d0e180dcf$var$MAX_PAYLOAD;
    }
    const buffer = data.slice(offset);
    const response = await transport.send($1850ff7d0e180dcf$var$LEDGER_CLA, instruction, p1, p2, buffer);
    return response.slice(0, response.length - 2);
}


const $82c44154ff55373d$export$d62f303e2f2d9d81 = "Ledger";

class $82c44154ff55373d$export$a497c40f3bcb0641 extends (0, $71b3859dfb523e38$export$9a51bf5d1bea9e98) {
    constructor(config = {}){
        super();
        this.name = $82c44154ff55373d$export$d62f303e2f2d9d81;
        this.url = "https://ledger.com";
        this.icon = "data:image/svg+xml;base64,PHN2ZyB2aWV3Qm94PSIwIDAgMzUgMzUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGcgZmlsbD0iI2ZmZiI+PHBhdGggZD0ibTIzLjU4OCAwaC0xNnYyMS41ODNoMjEuNnYtMTZhNS41ODUgNS41ODUgMCAwIDAgLTUuNi01LjU4M3oiIHRyYW5zZm9ybT0idHJhbnNsYXRlKDUuNzM5KSIvPjxwYXRoIGQ9Im04LjM0MiAwaC0yLjc1N2E1LjU4NSA1LjU4NSAwIDAgMCAtNS41ODUgNS41ODV2Mi43NTdoOC4zNDJ6Ii8+PHBhdGggZD0ibTAgNy41OWg4LjM0MnY4LjM0MmgtOC4zNDJ6IiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgwIDUuNzM5KSIvPjxwYXRoIGQ9Im0xNS4xOCAyMy40NTFoMi43NTdhNS41ODUgNS41ODUgMCAwIDAgNS41ODUtNS42di0yLjY3MWgtOC4zNDJ6IiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgxMS40NzggMTEuNDc4KSIvPjxwYXRoIGQ9Im03LjU5IDE1LjE4aDguMzQydjguMzQyaC04LjM0MnoiIHRyYW5zZm9ybT0idHJhbnNsYXRlKDUuNzM5IDExLjQ3OCkiLz48cGF0aCBkPSJtMCAxNS4xOHYyLjc1N2E1LjU4NSA1LjU4NSAwIDAgMCA1LjU4NSA1LjU4NWgyLjc1N3YtOC4zNDJ6IiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgwIDExLjQ3OCkiLz48L2c+PC9zdmc+";
        this.supportedTransactionVersions = new Set([
            "legacy",
            0
        ]);
        this._readyState = typeof window === "undefined" || typeof document === "undefined" || typeof navigator === "undefined" || !navigator.hid ? (0, $a27aaf340df890aa$export$2a7b8071105d05b6).Unsupported : (0, $a27aaf340df890aa$export$2a7b8071105d05b6).Loadable;
        this._disconnected = ()=>{
            const transport = this._transport;
            if (transport) {
                transport.off("disconnect", this._disconnected);
                this._transport = null;
                this._publicKey = null;
                this.emit("error", new (0, $92c515b2e16b5c4e$export$bf7028c52ebda81e)());
                this.emit("disconnect");
            }
        };
        this._derivationPath = config.derivationPath || (0, $1850ff7d0e180dcf$export$11792f2e0d4d6623)(0, 0);
        this._connecting = false;
        this._transport = null;
        this._publicKey = null;
    }
    get publicKey() {
        return this._publicKey;
    }
    get connecting() {
        return this._connecting;
    }
    get readyState() {
        return this._readyState;
    }
    async connect() {
        try {
            if (this.connected || this.connecting) return;
            if (this._readyState !== (0, $a27aaf340df890aa$export$2a7b8071105d05b6).Loadable) throw new (0, $92c515b2e16b5c4e$export$d65db264eda99cd7)();
            this._connecting = true;
            let TransportWebHIDClass;
            try {
                TransportWebHIDClass = (await (parcelRequire("92h1s"))).default;
            } catch (error) {
                throw new (0, $92c515b2e16b5c4e$export$9a551f94af9b0bf8)(error?.message, error);
            }
            let transport;
            try {
                transport = await TransportWebHIDClass.create();
            } catch (error) {
                throw new (0, $92c515b2e16b5c4e$export$38f21f1c810261c7)(error?.message, error);
            }
            let publicKey;
            try {
                publicKey = await (0, $1850ff7d0e180dcf$export$889def73691f9837)(transport, this._derivationPath);
            } catch (error) {
                throw new (0, $92c515b2e16b5c4e$export$735bef3bfb0f2c86)(error?.message, error);
            }
            transport.on("disconnect", this._disconnected);
            this._transport = transport;
            this._publicKey = publicKey;
            this.emit("connect", publicKey);
        } catch (error) {
            this.emit("error", error);
            throw error;
        } finally{
            this._connecting = false;
        }
    }
    async disconnect() {
        const transport = this._transport;
        if (transport) {
            transport.off("disconnect", this._disconnected);
            this._transport = null;
            this._publicKey = null;
            try {
                await transport.close();
            } catch (error) {
                this.emit("error", new (0, $92c515b2e16b5c4e$export$92e2b26fad5723ee)(error?.message, error));
            }
        }
        this.emit("disconnect");
    }
    async signTransaction(transaction) {
        try {
            const transport = this._transport;
            const publicKey = this._publicKey;
            if (!transport || !publicKey) throw new (0, $92c515b2e16b5c4e$export$313d299817c74896)();
            try {
                const signature = await (0, $1850ff7d0e180dcf$export$6ad02cc4966b42ab)(transport, transaction, this._derivationPath);
                transaction.addSignature(publicKey, signature);
            } catch (error) {
                throw new (0, $92c515b2e16b5c4e$export$96f177062fdd8180)(error?.message, error);
            }
            return transaction;
        } catch (error) {
            this.emit("error", error);
            throw error;
        }
    }
}



var $gNDby = parcelRequire("gNDby");
var $aff560f1983590b4$var$__classPrivateFieldSet = undefined && undefined.__classPrivateFieldSet || function(receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value), value;
};
var $aff560f1983590b4$var$__classPrivateFieldGet = undefined && undefined.__classPrivateFieldGet || function(receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
};
var $aff560f1983590b4$var$_RegisterWalletEvent_detail;
function $aff560f1983590b4$export$ecffa18c0543eceb(wallet) {
    const callback = ({ register: register })=>register(wallet);
    try {
        window.dispatchEvent(new $aff560f1983590b4$var$RegisterWalletEvent(callback));
    } catch (error) {
        console.error("wallet-standard:register-wallet event could not be dispatched\n", error);
    }
    try {
        window.addEventListener("wallet-standard:app-ready", ({ detail: api })=>callback(api));
    } catch (error) {
        console.error("wallet-standard:app-ready event listener could not be added\n", error);
    }
}
class $aff560f1983590b4$var$RegisterWalletEvent extends Event {
    constructor(callback){
        super("wallet-standard:register-wallet", {
            bubbles: false,
            cancelable: false,
            composed: false
        });
        $aff560f1983590b4$var$_RegisterWalletEvent_detail.set(this, void 0);
        $aff560f1983590b4$var$__classPrivateFieldSet(this, $aff560f1983590b4$var$_RegisterWalletEvent_detail, callback, "f");
    }
    get detail() {
        return $aff560f1983590b4$var$__classPrivateFieldGet(this, $aff560f1983590b4$var$_RegisterWalletEvent_detail, "f");
    }
    get type() {
        return "wallet-standard:register-wallet";
    }
    /** @deprecated */ preventDefault() {
        throw new Error("preventDefault cannot be called");
    }
    /** @deprecated */ stopImmediatePropagation() {
        throw new Error("stopImmediatePropagation cannot be called");
    }
    /** @deprecated */ stopPropagation() {
        throw new Error("stopPropagation cannot be called");
    }
}
$aff560f1983590b4$var$_RegisterWalletEvent_detail = new WeakMap();
function $aff560f1983590b4$export$2dd0e8edbdeb04ec(wallet) {
    var _a;
    $aff560f1983590b4$export$ecffa18c0543eceb(wallet);
    try {
        ((_a = window.navigator).wallets || (_a.wallets = [])).push(({ register: register })=>register(wallet));
    } catch (error) {
        console.error("window.navigator.wallets could not be pushed\n", error);
    }
}





var $iJxGt = parcelRequire("iJxGt");
var $7KE4n = parcelRequire("7KE4n");
var $d2raY = parcelRequire("d2raY");

/** @internal */ const $db254428317cd776$export$1ca1ec8b29a4ce27 = "data:image/svg+xml;base64,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";


var $047e59d25887ab3f$var$__classPrivateFieldGet = undefined && undefined.__classPrivateFieldGet || function(receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
};
var $047e59d25887ab3f$var$__classPrivateFieldSet = undefined && undefined.__classPrivateFieldSet || function(receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value), value;
};
var $047e59d25887ab3f$var$_SolflareMetaMaskWallet_instances, $047e59d25887ab3f$var$_SolflareMetaMaskWallet_listeners, $047e59d25887ab3f$var$_SolflareMetaMaskWallet_version, $047e59d25887ab3f$var$_SolflareMetaMaskWallet_name, $047e59d25887ab3f$var$_SolflareMetaMaskWallet_icon, $047e59d25887ab3f$var$_SolflareMetaMaskWallet_solflareMetaMask, $047e59d25887ab3f$var$_SolflareMetaMaskWallet_on, $047e59d25887ab3f$var$_SolflareMetaMaskWallet_emit, $047e59d25887ab3f$var$_SolflareMetaMaskWallet_off, $047e59d25887ab3f$var$_SolflareMetaMaskWallet_connect, $047e59d25887ab3f$var$_SolflareMetaMaskWallet_disconnect, $047e59d25887ab3f$var$_SolflareMetaMaskWallet_signAndSendTransaction, $047e59d25887ab3f$var$_SolflareMetaMaskWallet_signTransaction, $047e59d25887ab3f$var$_SolflareMetaMaskWallet_signMessage;

class $047e59d25887ab3f$export$b9711d1b27bbdcc {
    constructor(){
        $047e59d25887ab3f$var$_SolflareMetaMaskWallet_instances.add(this);
        $047e59d25887ab3f$var$_SolflareMetaMaskWallet_listeners.set(this, {});
        $047e59d25887ab3f$var$_SolflareMetaMaskWallet_version.set(this, "1.0.0");
        $047e59d25887ab3f$var$_SolflareMetaMaskWallet_name.set(this, "MetaMask");
        $047e59d25887ab3f$var$_SolflareMetaMaskWallet_icon.set(this, (0, $db254428317cd776$export$1ca1ec8b29a4ce27));
        $047e59d25887ab3f$var$_SolflareMetaMaskWallet_solflareMetaMask.set(this, null);
        $047e59d25887ab3f$var$_SolflareMetaMaskWallet_on.set(this, (event, listener)=>{
            $047e59d25887ab3f$var$__classPrivateFieldGet(this, $047e59d25887ab3f$var$_SolflareMetaMaskWallet_listeners, "f")[event]?.push(listener) || ($047e59d25887ab3f$var$__classPrivateFieldGet(this, $047e59d25887ab3f$var$_SolflareMetaMaskWallet_listeners, "f")[event] = [
                listener
            ]);
            return ()=>$047e59d25887ab3f$var$__classPrivateFieldGet(this, $047e59d25887ab3f$var$_SolflareMetaMaskWallet_instances, "m", $047e59d25887ab3f$var$_SolflareMetaMaskWallet_off).call(this, event, listener);
        });
        $047e59d25887ab3f$var$_SolflareMetaMaskWallet_connect.set(this, async ()=>{
            if (!$047e59d25887ab3f$var$__classPrivateFieldGet(this, $047e59d25887ab3f$var$_SolflareMetaMaskWallet_solflareMetaMask, "f")) {
                let SolflareMetaMaskClass;
                try {
                    SolflareMetaMaskClass = (await (parcelRequire("fSpOt"))).default;
                } catch (error) {
                    throw new Error("Unable to load Solflare MetaMask SDK");
                }
                $047e59d25887ab3f$var$__classPrivateFieldSet(this, $047e59d25887ab3f$var$_SolflareMetaMaskWallet_solflareMetaMask, new SolflareMetaMaskClass(), "f");
                $047e59d25887ab3f$var$__classPrivateFieldGet(this, $047e59d25887ab3f$var$_SolflareMetaMaskWallet_solflareMetaMask, "f").on("standard_change", (properties)=>$047e59d25887ab3f$var$__classPrivateFieldGet(this, $047e59d25887ab3f$var$_SolflareMetaMaskWallet_instances, "m", $047e59d25887ab3f$var$_SolflareMetaMaskWallet_emit).call(this, "change", properties));
            }
            if (!this.accounts.length) await $047e59d25887ab3f$var$__classPrivateFieldGet(this, $047e59d25887ab3f$var$_SolflareMetaMaskWallet_solflareMetaMask, "f").connect();
            return {
                accounts: this.accounts
            };
        });
        $047e59d25887ab3f$var$_SolflareMetaMaskWallet_disconnect.set(this, async ()=>{
            if (!$047e59d25887ab3f$var$__classPrivateFieldGet(this, $047e59d25887ab3f$var$_SolflareMetaMaskWallet_solflareMetaMask, "f")) return;
            await $047e59d25887ab3f$var$__classPrivateFieldGet(this, $047e59d25887ab3f$var$_SolflareMetaMaskWallet_solflareMetaMask, "f").disconnect();
        });
        $047e59d25887ab3f$var$_SolflareMetaMaskWallet_signAndSendTransaction.set(this, async (...inputs)=>{
            if (!$047e59d25887ab3f$var$__classPrivateFieldGet(this, $047e59d25887ab3f$var$_SolflareMetaMaskWallet_solflareMetaMask, "f")) throw new (0, $92c515b2e16b5c4e$export$313d299817c74896)();
            return await $047e59d25887ab3f$var$__classPrivateFieldGet(this, $047e59d25887ab3f$var$_SolflareMetaMaskWallet_solflareMetaMask, "f").standardSignAndSendTransaction(...inputs);
        });
        $047e59d25887ab3f$var$_SolflareMetaMaskWallet_signTransaction.set(this, async (...inputs)=>{
            if (!$047e59d25887ab3f$var$__classPrivateFieldGet(this, $047e59d25887ab3f$var$_SolflareMetaMaskWallet_solflareMetaMask, "f")) throw new (0, $92c515b2e16b5c4e$export$313d299817c74896)();
            return await $047e59d25887ab3f$var$__classPrivateFieldGet(this, $047e59d25887ab3f$var$_SolflareMetaMaskWallet_solflareMetaMask, "f").standardSignTransaction(...inputs);
        });
        $047e59d25887ab3f$var$_SolflareMetaMaskWallet_signMessage.set(this, async (...inputs)=>{
            if (!$047e59d25887ab3f$var$__classPrivateFieldGet(this, $047e59d25887ab3f$var$_SolflareMetaMaskWallet_solflareMetaMask, "f")) throw new (0, $92c515b2e16b5c4e$export$313d299817c74896)();
            return await $047e59d25887ab3f$var$__classPrivateFieldGet(this, $047e59d25887ab3f$var$_SolflareMetaMaskWallet_solflareMetaMask, "f").standardSignMessage(...inputs);
        });
    }
    get version() {
        return $047e59d25887ab3f$var$__classPrivateFieldGet(this, $047e59d25887ab3f$var$_SolflareMetaMaskWallet_version, "f");
    }
    get name() {
        return $047e59d25887ab3f$var$__classPrivateFieldGet(this, $047e59d25887ab3f$var$_SolflareMetaMaskWallet_name, "f");
    }
    get icon() {
        return $047e59d25887ab3f$var$__classPrivateFieldGet(this, $047e59d25887ab3f$var$_SolflareMetaMaskWallet_icon, "f");
    }
    get chains() {
        return [
            (0, $54a90126d2f96ce7$export$bba9a228295b3963),
            (0, $54a90126d2f96ce7$export$654cc095bd2e650),
            (0, $54a90126d2f96ce7$export$76575b7bf4de1f40)
        ];
    }
    get features() {
        return {
            [(0, $744408f28809a335$export$cc68487eeb93b1d4)]: {
                version: "1.0.0",
                connect: $047e59d25887ab3f$var$__classPrivateFieldGet(this, $047e59d25887ab3f$var$_SolflareMetaMaskWallet_connect, "f")
            },
            [(0, $393285782087969c$export$38dbd4bbb9b696e6)]: {
                version: "1.0.0",
                disconnect: $047e59d25887ab3f$var$__classPrivateFieldGet(this, $047e59d25887ab3f$var$_SolflareMetaMaskWallet_disconnect, "f")
            },
            [(0, $f4859eee1867cbdd$export$5296443ca9e9fa0f)]: {
                version: "1.0.0",
                on: $047e59d25887ab3f$var$__classPrivateFieldGet(this, $047e59d25887ab3f$var$_SolflareMetaMaskWallet_on, "f")
            },
            [(0, $iJxGt.SolanaSignAndSendTransaction)]: {
                version: "1.0.0",
                supportedTransactionVersions: [
                    "legacy",
                    0
                ],
                signAndSendTransaction: $047e59d25887ab3f$var$__classPrivateFieldGet(this, $047e59d25887ab3f$var$_SolflareMetaMaskWallet_signAndSendTransaction, "f")
            },
            [(0, $d2raY.SolanaSignTransaction)]: {
                version: "1.0.0",
                supportedTransactionVersions: [
                    "legacy",
                    0
                ],
                signTransaction: $047e59d25887ab3f$var$__classPrivateFieldGet(this, $047e59d25887ab3f$var$_SolflareMetaMaskWallet_signTransaction, "f")
            },
            [(0, $7KE4n.SolanaSignMessage)]: {
                version: "1.0.0",
                signMessage: $047e59d25887ab3f$var$__classPrivateFieldGet(this, $047e59d25887ab3f$var$_SolflareMetaMaskWallet_signMessage, "f")
            }
        };
    }
    get accounts() {
        return $047e59d25887ab3f$var$__classPrivateFieldGet(this, $047e59d25887ab3f$var$_SolflareMetaMaskWallet_solflareMetaMask, "f") ? $047e59d25887ab3f$var$__classPrivateFieldGet(this, $047e59d25887ab3f$var$_SolflareMetaMaskWallet_solflareMetaMask, "f").standardAccounts : [];
    }
}
$047e59d25887ab3f$var$_SolflareMetaMaskWallet_listeners = new WeakMap(), $047e59d25887ab3f$var$_SolflareMetaMaskWallet_version = new WeakMap(), $047e59d25887ab3f$var$_SolflareMetaMaskWallet_name = new WeakMap(), $047e59d25887ab3f$var$_SolflareMetaMaskWallet_icon = new WeakMap(), $047e59d25887ab3f$var$_SolflareMetaMaskWallet_solflareMetaMask = new WeakMap(), $047e59d25887ab3f$var$_SolflareMetaMaskWallet_on = new WeakMap(), $047e59d25887ab3f$var$_SolflareMetaMaskWallet_connect = new WeakMap(), $047e59d25887ab3f$var$_SolflareMetaMaskWallet_disconnect = new WeakMap(), $047e59d25887ab3f$var$_SolflareMetaMaskWallet_signAndSendTransaction = new WeakMap(), $047e59d25887ab3f$var$_SolflareMetaMaskWallet_signTransaction = new WeakMap(), $047e59d25887ab3f$var$_SolflareMetaMaskWallet_signMessage = new WeakMap(), $047e59d25887ab3f$var$_SolflareMetaMaskWallet_instances = new WeakSet(), $047e59d25887ab3f$var$_SolflareMetaMaskWallet_emit = function _SolflareMetaMaskWallet_emit(event, ...args) {
    // eslint-disable-next-line prefer-spread
    $047e59d25887ab3f$var$__classPrivateFieldGet(this, $047e59d25887ab3f$var$_SolflareMetaMaskWallet_listeners, "f")[event]?.forEach((listener)=>listener.apply(null, args));
}, $047e59d25887ab3f$var$_SolflareMetaMaskWallet_off = function _SolflareMetaMaskWallet_off(event, listener) {
    $047e59d25887ab3f$var$__classPrivateFieldGet(this, $047e59d25887ab3f$var$_SolflareMetaMaskWallet_listeners, "f")[event] = $047e59d25887ab3f$var$__classPrivateFieldGet(this, $047e59d25887ab3f$var$_SolflareMetaMaskWallet_listeners, "f")[event]?.filter((existingListener)=>listener !== existingListener);
};


let $44e588f5cc38e309$var$registered = false;
function $44e588f5cc38e309$var$register() {
    if ($44e588f5cc38e309$var$registered) return;
    (0, $aff560f1983590b4$export$ecffa18c0543eceb)(new (0, $047e59d25887ab3f$export$b9711d1b27bbdcc)());
    $44e588f5cc38e309$var$registered = true;
}
async function $44e588f5cc38e309$export$2dd247ebd3228ce5() {
    const id = "solflare-detect-metamask";
    function postMessage() {
        window.postMessage({
            target: "metamask-contentscript",
            data: {
                name: "metamask-provider",
                data: {
                    id: id,
                    jsonrpc: "2.0",
                    method: "wallet_getSnaps"
                }
            }
        }, window.location.origin);
    }
    function onMessage(event) {
        const message = event.data;
        if (message?.target === "metamask-inpage" && message.data?.name === "metamask-provider") {
            if (message.data.data?.id === id) {
                window.removeEventListener("message", onMessage);
                if (!message.data.data.error) $44e588f5cc38e309$var$register();
            } else postMessage();
        }
    }
    window.addEventListener("message", onMessage);
    window.setTimeout(()=>window.removeEventListener("message", onMessage), 5000);
    postMessage();
}


const $8315e39d7cf92168$export$588524c4690a874f = "Solflare";

class $8315e39d7cf92168$export$9fd69c70c5f8b9b4 extends (0, $71b3859dfb523e38$export$9db08bcddd106c96) {
    constructor(config = {}){
        super();
        this.name = $8315e39d7cf92168$export$588524c4690a874f;
        this.url = "https://solflare.com";
        this.icon = "data:image/svg+xml;base64,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";
        this.supportedTransactionVersions = new Set([
            "legacy",
            0
        ]);
        this._readyState = typeof window === "undefined" || typeof document === "undefined" ? (0, $a27aaf340df890aa$export$2a7b8071105d05b6).Unsupported : (0, $a27aaf340df890aa$export$2a7b8071105d05b6).Loadable;
        this._disconnected = ()=>{
            const wallet = this._wallet;
            if (wallet) {
                wallet.off("disconnect", this._disconnected);
                this._wallet = null;
                this._publicKey = null;
                this.emit("error", new (0, $92c515b2e16b5c4e$export$bf7028c52ebda81e)());
                this.emit("disconnect");
            }
        };
        this._accountChanged = (newPublicKey)=>{
            if (!newPublicKey) return;
            const publicKey = this._publicKey;
            if (!publicKey) return;
            try {
                newPublicKey = new (0, $gNDby.PublicKey)(newPublicKey.toBytes());
            } catch (error) {
                this.emit("error", new (0, $92c515b2e16b5c4e$export$735bef3bfb0f2c86)(error?.message, error));
                return;
            }
            if (publicKey.equals(newPublicKey)) return;
            this._publicKey = newPublicKey;
            this.emit("connect", newPublicKey);
        };
        this._connecting = false;
        this._publicKey = null;
        this._wallet = null;
        this._config = config;
        if (this._readyState !== (0, $a27aaf340df890aa$export$2a7b8071105d05b6).Unsupported) {
            (0, $a27aaf340df890aa$export$378bae4c88e0b46e)(()=>{
                if (window.solflare?.isSolflare || window.SolflareApp) {
                    this._readyState = (0, $a27aaf340df890aa$export$2a7b8071105d05b6).Installed;
                    this.emit("readyStateChange", this._readyState);
                    return true;
                }
                return false;
            });
            (0, $44e588f5cc38e309$export$2dd247ebd3228ce5)();
        }
    }
    get publicKey() {
        return this._publicKey;
    }
    get connecting() {
        return this._connecting;
    }
    get connected() {
        return !!this._wallet?.connected;
    }
    get readyState() {
        return this._readyState;
    }
    async autoConnect() {
        // Skip autoconnect in the Loadable state on iOS
        // We can't redirect to a universal link without user input
        if (!(this.readyState === (0, $a27aaf340df890aa$export$2a7b8071105d05b6).Loadable && (0, $a27aaf340df890aa$export$bf89b558d1e273a2)())) await this.connect();
    }
    async connect() {
        try {
            if (this.connected || this.connecting) return;
            if (this._readyState !== (0, $a27aaf340df890aa$export$2a7b8071105d05b6).Loadable && this._readyState !== (0, $a27aaf340df890aa$export$2a7b8071105d05b6).Installed) throw new (0, $92c515b2e16b5c4e$export$d65db264eda99cd7)();
            // redirect to the Solflare /browse universal link
            // this will open the current URL in the Solflare in-wallet browser
            if (this.readyState === (0, $a27aaf340df890aa$export$2a7b8071105d05b6).Loadable && (0, $a27aaf340df890aa$export$bf89b558d1e273a2)()) {
                const url = encodeURIComponent(window.location.href);
                const ref = encodeURIComponent(window.location.origin);
                window.location.href = `https://solflare.com/ul/v1/browse/${url}?ref=${ref}`;
                return;
            }
            let SolflareClass;
            try {
                SolflareClass = (await (parcelRequire("hSLYn"))).default;
            } catch (error) {
                throw new (0, $92c515b2e16b5c4e$export$9a551f94af9b0bf8)(error?.message, error);
            }
            let wallet;
            try {
                wallet = new SolflareClass({
                    network: this._config.network
                });
            } catch (error) {
                throw new (0, $92c515b2e16b5c4e$export$9525019988612a5e)(error?.message, error);
            }
            this._connecting = true;
            if (!wallet.connected) try {
                await wallet.connect();
            } catch (error) {
                throw new (0, $92c515b2e16b5c4e$export$38f21f1c810261c7)(error?.message, error);
            }
            if (!wallet.publicKey) throw new (0, $92c515b2e16b5c4e$export$38f21f1c810261c7)();
            let publicKey;
            try {
                publicKey = new (0, $gNDby.PublicKey)(wallet.publicKey.toBytes());
            } catch (error) {
                throw new (0, $92c515b2e16b5c4e$export$735bef3bfb0f2c86)(error?.message, error);
            }
            wallet.on("disconnect", this._disconnected);
            wallet.on("accountChanged", this._accountChanged);
            this._wallet = wallet;
            this._publicKey = publicKey;
            this.emit("connect", publicKey);
        } catch (error) {
            this.emit("error", error);
            throw error;
        } finally{
            this._connecting = false;
        }
    }
    async disconnect() {
        const wallet = this._wallet;
        if (wallet) {
            wallet.off("disconnect", this._disconnected);
            wallet.off("accountChanged", this._accountChanged);
            this._wallet = null;
            this._publicKey = null;
            try {
                await wallet.disconnect();
            } catch (error) {
                this.emit("error", new (0, $92c515b2e16b5c4e$export$92e2b26fad5723ee)(error?.message, error));
            }
        }
        this.emit("disconnect");
    }
    async sendTransaction(transaction, connection, options = {}) {
        try {
            const wallet = this._wallet;
            if (!wallet) throw new (0, $92c515b2e16b5c4e$export$313d299817c74896)();
            try {
                const { signers: signers, ...sendOptions } = options;
                if ((0, $afa5c06c212ba160$export$37ce1cc82e255d8)(transaction)) signers?.length && transaction.sign(signers);
                else {
                    transaction = await this.prepareTransaction(transaction, connection, sendOptions);
                    signers?.length && transaction.partialSign(...signers);
                }
                sendOptions.preflightCommitment = sendOptions.preflightCommitment || connection.commitment;
                return await wallet.signAndSendTransaction(transaction, sendOptions);
            } catch (error) {
                if (error instanceof (0, $92c515b2e16b5c4e$export$f46ec6f9dba8711d)) throw error;
                throw new (0, $92c515b2e16b5c4e$export$769332ac3f90f46c)(error?.message, error);
            }
        } catch (error) {
            this.emit("error", error);
            throw error;
        }
    }
    async signTransaction(transaction) {
        try {
            const wallet = this._wallet;
            if (!wallet) throw new (0, $92c515b2e16b5c4e$export$313d299817c74896)();
            try {
                return await wallet.signTransaction(transaction) || transaction;
            } catch (error) {
                throw new (0, $92c515b2e16b5c4e$export$96f177062fdd8180)(error?.message, error);
            }
        } catch (error) {
            this.emit("error", error);
            throw error;
        }
    }
    async signAllTransactions(transactions) {
        try {
            const wallet = this._wallet;
            if (!wallet) throw new (0, $92c515b2e16b5c4e$export$313d299817c74896)();
            try {
                return await wallet.signAllTransactions(transactions) || transactions;
            } catch (error) {
                throw new (0, $92c515b2e16b5c4e$export$96f177062fdd8180)(error?.message, error);
            }
        } catch (error) {
            this.emit("error", error);
            throw error;
        }
    }
    async signMessage(message) {
        try {
            const wallet = this._wallet;
            if (!wallet) throw new (0, $92c515b2e16b5c4e$export$313d299817c74896)();
            try {
                return await wallet.signMessage(message, "utf8");
            } catch (error) {
                throw new (0, $92c515b2e16b5c4e$export$2622c1721bbd4b17)(error?.message, error);
            }
        } catch (error) {
            this.emit("error", error);
            throw error;
        }
    }
}



var $acw62 = parcelRequire("acw62");


const $294bac30bfd1bc92$export$c63833ee7c6e3979 = ()=>{
    const { state: { sessionToken: sessionToken } } = (0, $c25623cc446ec3c6$export$ac8576a9912be18c)();
    const wallets = (0, $acw62.useMemo)(()=>[
            //new SolanaMobileWalletAdapter({
            //  appIdentity: {
            //    name: 'Pirate Squad - Bubble'
            //  },
            //  authorizationResultCache: createDefaultAuthorizationResultCache(),
            //  cluster: WalletAdapterNetwork.Mainnet,
            //  addressSelector: createDefaultAddressSelector(),
            //  onWalletNotFound: (adapter) => {
            //  }
            //}),
            new (0, $8315e39d7cf92168$export$9fd69c70c5f8b9b4)(),
            new (0, $82c44154ff55373d$export$a497c40f3bcb0641)()
        ], []);
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $95b24e620787a529$export$fd685cf7c99624bd), {
        endpoint: "https://rpc.hellomoon.io/9ebf282c-577a-45d4-bf84-6a597eda3091",
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $cd8099a814169194$export$717b22fc3a2082b3), {
            wallets: wallets,
            autoConnect: !!sessionToken,
            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $d7fa3fcfe186d6c8$export$43bb60413a8a3ee6), {
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7939e29d663dd3ed$export$910ae8079b2c2852), {})
            })
        })
    });
};


var $9de1918e63fb5ea5$exports = {};

$parcel$export($9de1918e63fb5ea5$exports, "wallet-layout", () => $9de1918e63fb5ea5$export$4753ff3bf79f81b0, (v) => $9de1918e63fb5ea5$export$4753ff3bf79f81b0 = v);
var $9de1918e63fb5ea5$export$4753ff3bf79f81b0;
$9de1918e63fb5ea5$export$4753ff3bf79f81b0 = `vsoQtq_wallet-layout`;


const $d3a99b82c5bf971f$export$f8d21f2bc604f7bf = ()=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
        className: (0, $9805619f03ed02ef$export$91884aa883243770)((0, (/*@__PURE__*/$parcel$interopDefault($9de1918e63fb5ea5$exports))), "wallet-layout"),
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $294bac30bfd1bc92$export$c63833ee7c6e3979), {})
    });




var $acw62 = parcelRequire("acw62");




parcelRequire("acw62");


const $f0a80ffa61d846a8$export$79b5060180039794 = (props)=>{
    const { dispatch: dispatch } = (0, $c25623cc446ec3c6$export$ac8576a9912be18c)();
    const openConnectModal = (showConnectModal)=>{
        dispatch({
            type: "SET_SHOW_CONNECT_MODAL",
            showConnectModal: showConnectModal
        });
    };
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $6725244138e0595f$export$353f5b6fc5456de1), {
        ...props,
        onClick: ()=>openConnectModal(true),
        children: "SOL Wallet"
    });
};




var $acw62 = parcelRequire("acw62");


var $acw62 = parcelRequire("acw62");
function $5f67c9c0ef44a9a6$export$f244ba8ecf2869d7() {
    const { disconnecting: disconnecting, disconnect: disconnect, wallet: wallet } = (0, $3aa6d87558212265$export$c34addee860b0acb)();
    let buttonState;
    if (disconnecting) buttonState = "disconnecting";
    else if (wallet) buttonState = "has-wallet";
    else buttonState = "no-wallet";
    const handleDisconnectButtonClick = (0, $acw62.useCallback)(()=>{
        disconnect().catch(()=>{
        // Silently catch because any errors are caught by the context `onError` handler
        });
    }, [
        disconnect
    ]);
    return {
        buttonDisabled: buttonState !== "has-wallet",
        buttonState: buttonState,
        onButtonClick: buttonState === "has-wallet" ? handleDisconnectButtonClick : undefined,
        walletIcon: wallet?.adapter.icon,
        walletName: wallet?.adapter.name
    };
}



var $acw62 = parcelRequire("acw62");

var $acw62 = parcelRequire("acw62");


function $b22e3674ed9a2d26$export$a0d4a8038508425f({ walletIcon: walletIcon, walletName: walletName, ...props }) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $ed43aee2b6d2385b$export$353f5b6fc5456de1), {
        ...props,
        className: "wallet-adapter-button-trigger",
        startIcon: walletIcon && walletName ? (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $74cea3e5b753b58c$export$deff84e7338ee5a5), {
            wallet: {
                adapter: {
                    icon: walletIcon,
                    name: walletName
                }
            }
        }) : undefined
    });
}


function $1a3b9cdec25ac6d7$export$1e11104b3267a150({ children: children, disabled: disabled, labels: labels, onClick: onClick, ...props }) {
    const { buttonDisabled: buttonDisabled, buttonState: buttonState, onButtonClick: onButtonClick, walletIcon: walletIcon, walletName: walletName } = (0, $5f67c9c0ef44a9a6$export$f244ba8ecf2869d7)();
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $b22e3674ed9a2d26$export$a0d4a8038508425f), {
        ...props,
        disabled: disabled || buttonDisabled,
        onClick: (e)=>{
            if (onClick) onClick(e);
            if (e.defaultPrevented) return;
            if (onButtonClick) onButtonClick();
        },
        walletIcon: walletIcon,
        walletName: walletName
    }, children ? children : labels[buttonState]);
}


const $8fc8d77258ce4f67$var$LABELS = {
    disconnecting: "Disconnecting ...",
    "has-wallet": "Disconnect",
    "no-wallet": "Disconnect Wallet"
};
function $8fc8d77258ce4f67$export$961aa68bc59bf83d(props) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $1a3b9cdec25ac6d7$export$1e11104b3267a150), {
        ...props,
        labels: $8fc8d77258ce4f67$var$LABELS
    });
}


var $acw62 = parcelRequire("acw62");


var $acw62 = parcelRequire("acw62");
function $f5ec975d3f9bb9fc$export$629f18756d2627db({ onSelectWallet: onSelectWallet }) {
    const { connect: connect, connected: connected, connecting: connecting, disconnect: disconnect, disconnecting: disconnecting, publicKey: publicKey, select: select, wallet: wallet, wallets: wallets } = (0, $3aa6d87558212265$export$c34addee860b0acb)();
    let buttonState;
    if (connecting) buttonState = "connecting";
    else if (connected) buttonState = "connected";
    else if (disconnecting) buttonState = "disconnecting";
    else if (wallet) buttonState = "has-wallet";
    else buttonState = "no-wallet";
    const handleConnect = (0, $acw62.useCallback)(()=>{
        connect().catch(()=>{
        // Silently catch because any errors are caught by the context `onError` handler
        });
    }, [
        connect
    ]);
    const handleDisconnect = (0, $acw62.useCallback)(()=>{
        disconnect().catch(()=>{
        // Silently catch because any errors are caught by the context `onError` handler
        });
    }, [
        disconnect
    ]);
    const handleSelectWallet = (0, $acw62.useCallback)(()=>{
        onSelectWallet({
            onSelectWallet: select,
            wallets: wallets
        });
    }, [
        onSelectWallet,
        select,
        wallets
    ]);
    return {
        buttonState: buttonState,
        onConnect: buttonState === "has-wallet" ? handleConnect : undefined,
        onDisconnect: buttonState !== "disconnecting" && buttonState !== "no-wallet" ? handleDisconnect : undefined,
        onSelectWallet: handleSelectWallet,
        publicKey: publicKey ?? undefined,
        walletIcon: wallet?.adapter.icon,
        walletName: wallet?.adapter.name
    };
}



var $acw62 = parcelRequire("acw62");


function $79c7c16679bb5b21$export$50382f20865178f9({ children: children, labels: labels, ...props }) {
    const { setVisible: setModalVisible } = (0, $ca40ecc6394b8d2e$export$6fdf0454adae214b)();
    const { buttonState: buttonState, onConnect: onConnect, onDisconnect: onDisconnect, publicKey: publicKey, walletIcon: walletIcon, walletName: walletName } = (0, $f5ec975d3f9bb9fc$export$629f18756d2627db)({
        onSelectWallet () {
            setModalVisible(true);
        }
    });
    const [copied, setCopied] = (0, $acw62.useState)(false);
    const [menuOpen, setMenuOpen] = (0, $acw62.useState)(false);
    const ref = (0, $acw62.useRef)(null);
    (0, $acw62.useEffect)(()=>{
        const listener = (event)=>{
            const node = ref.current;
            // Do nothing if clicking dropdown or its descendants
            if (!node || node.contains(event.target)) return;
            setMenuOpen(false);
        };
        document.addEventListener("mousedown", listener);
        document.addEventListener("touchstart", listener);
        return ()=>{
            document.removeEventListener("mousedown", listener);
            document.removeEventListener("touchstart", listener);
        };
    }, []);
    const content = (0, $acw62.useMemo)(()=>{
        if (children) return children;
        else if (publicKey) {
            const base58 = publicKey.toBase58();
            return base58.slice(0, 4) + ".." + base58.slice(-4);
        } else if (buttonState === "connecting" || buttonState === "has-wallet") return labels[buttonState];
        else return labels["no-wallet"];
    }, [
        buttonState,
        children,
        labels,
        publicKey
    ]);
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: "wallet-adapter-dropdown"
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $b22e3674ed9a2d26$export$a0d4a8038508425f), {
        ...props,
        "aria-expanded": menuOpen,
        style: {
            pointerEvents: menuOpen ? "none" : "auto",
            ...props.style
        },
        onClick: ()=>{
            switch(buttonState){
                case "no-wallet":
                    setModalVisible(true);
                    break;
                case "has-wallet":
                    if (onConnect) onConnect();
                    break;
                case "connected":
                    setMenuOpen(true);
                    break;
            }
        },
        walletIcon: walletIcon,
        walletName: walletName
    }, content), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("ul", {
        "aria-label": "dropdown-list",
        className: `wallet-adapter-dropdown-list ${menuOpen && "wallet-adapter-dropdown-list-active"}`,
        ref: ref,
        role: "menu"
    }, publicKey ? (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("li", {
        className: "wallet-adapter-dropdown-list-item",
        onClick: async ()=>{
            await navigator.clipboard.writeText(publicKey.toBase58());
            setCopied(true);
            setTimeout(()=>setCopied(false), 400);
        },
        role: "menuitem"
    }, copied ? labels["copied"] : labels["copy-address"]) : null, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("li", {
        className: "wallet-adapter-dropdown-list-item",
        onClick: ()=>{
            setModalVisible(true);
            setMenuOpen(false);
        },
        role: "menuitem"
    }, labels["change-wallet"]), onDisconnect ? (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("li", {
        className: "wallet-adapter-dropdown-list-item",
        onClick: ()=>{
            onDisconnect();
            setMenuOpen(false);
        },
        role: "menuitem"
    }, labels["disconnect"]) : null));
}


const $b30bad04ca015373$var$LABELS = {
    "change-wallet": "Change wallet",
    connecting: "Connecting ...",
    "copy-address": "Copy address",
    copied: "Copied",
    disconnect: "Disconnect",
    "has-wallet": "Connect",
    "no-wallet": "Select Wallet"
};
function $b30bad04ca015373$export$968d144f04194cbb(props) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $79c7c16679bb5b21$export$50382f20865178f9), {
        ...props,
        labels: $b30bad04ca015373$var$LABELS
    });
}



var $acw62 = parcelRequire("acw62");
var $76c62964b0a424ce$exports = {};
"use strict";
Object.defineProperty($76c62964b0a424ce$exports, "__esModule", {
    value: true
});
function $76c62964b0a424ce$var$_interopDefault(ex) {
    return ex && typeof ex === "object" && "default" in ex ? ex["default"] : ex;
}

var $acw62 = parcelRequire("acw62");
var $76c62964b0a424ce$var$React__default = $76c62964b0a424ce$var$_interopDefault($acw62);

var $b8sjQ = parcelRequire("b8sjQ");
var $76c62964b0a424ce$var$ClientUAInstance = new $b8sjQ();
var $76c62964b0a424ce$var$browser = $76c62964b0a424ce$var$ClientUAInstance.getBrowser();
var $76c62964b0a424ce$var$cpu = $76c62964b0a424ce$var$ClientUAInstance.getCPU();
var $76c62964b0a424ce$var$device = $76c62964b0a424ce$var$ClientUAInstance.getDevice();
var $76c62964b0a424ce$var$engine = $76c62964b0a424ce$var$ClientUAInstance.getEngine();
var $76c62964b0a424ce$var$os = $76c62964b0a424ce$var$ClientUAInstance.getOS();
var $76c62964b0a424ce$var$ua = $76c62964b0a424ce$var$ClientUAInstance.getUA();
var $76c62964b0a424ce$var$setUa = function setUa(userAgentString) {
    return $76c62964b0a424ce$var$ClientUAInstance.setUA(userAgentString);
};
var $76c62964b0a424ce$var$parseUserAgent = function parseUserAgent(userAgent) {
    if (!userAgent) {
        console.error("No userAgent string was provided");
        return;
    }
    var UserAgentInstance = new $b8sjQ(userAgent);
    return {
        UA: UserAgentInstance,
        browser: UserAgentInstance.getBrowser(),
        cpu: UserAgentInstance.getCPU(),
        device: UserAgentInstance.getDevice(),
        engine: UserAgentInstance.getEngine(),
        os: UserAgentInstance.getOS(),
        ua: UserAgentInstance.getUA(),
        setUserAgent: function setUserAgent(userAgentString) {
            return UserAgentInstance.setUA(userAgentString);
        }
    };
};
var $76c62964b0a424ce$var$UAHelper = /*#__PURE__*/ Object.freeze({
    ClientUAInstance: $76c62964b0a424ce$var$ClientUAInstance,
    browser: $76c62964b0a424ce$var$browser,
    cpu: $76c62964b0a424ce$var$cpu,
    device: $76c62964b0a424ce$var$device,
    engine: $76c62964b0a424ce$var$engine,
    os: $76c62964b0a424ce$var$os,
    ua: $76c62964b0a424ce$var$ua,
    setUa: $76c62964b0a424ce$var$setUa,
    parseUserAgent: $76c62964b0a424ce$var$parseUserAgent
});
function $76c62964b0a424ce$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function $76c62964b0a424ce$var$_objectSpread2(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        if (i % 2) $76c62964b0a424ce$var$ownKeys(Object(source), true).forEach(function(key) {
            $76c62964b0a424ce$var$_defineProperty(target, key, source[key]);
        });
        else if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
        else $76c62964b0a424ce$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $76c62964b0a424ce$var$_typeof(obj) {
    "@babel/helpers - typeof";
    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") $76c62964b0a424ce$var$_typeof = function(obj) {
        return typeof obj;
    };
    else $76c62964b0a424ce$var$_typeof = function(obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
    return $76c62964b0a424ce$var$_typeof(obj);
}
function $76c62964b0a424ce$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $76c62964b0a424ce$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $76c62964b0a424ce$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $76c62964b0a424ce$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $76c62964b0a424ce$var$_defineProperties(Constructor, staticProps);
    return Constructor;
}
function $76c62964b0a424ce$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $76c62964b0a424ce$var$_extends() {
    $76c62964b0a424ce$var$_extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $76c62964b0a424ce$var$_extends.apply(this, arguments);
}
function $76c62964b0a424ce$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) $76c62964b0a424ce$var$_setPrototypeOf(subClass, superClass);
}
function $76c62964b0a424ce$var$_getPrototypeOf(o) {
    $76c62964b0a424ce$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $76c62964b0a424ce$var$_getPrototypeOf(o);
}
function $76c62964b0a424ce$var$_setPrototypeOf(o, p) {
    $76c62964b0a424ce$var$_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $76c62964b0a424ce$var$_setPrototypeOf(o, p);
}
function $76c62964b0a424ce$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function $76c62964b0a424ce$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $76c62964b0a424ce$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $76c62964b0a424ce$var$_assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function $76c62964b0a424ce$var$_possibleConstructorReturn(self, call) {
    if (call && (typeof call === "object" || typeof call === "function")) return call;
    else if (call !== void 0) throw new TypeError("Derived constructors may only return object or undefined");
    return $76c62964b0a424ce$var$_assertThisInitialized(self);
}
function $76c62964b0a424ce$var$_slicedToArray(arr, i) {
    return $76c62964b0a424ce$var$_arrayWithHoles(arr) || $76c62964b0a424ce$var$_iterableToArrayLimit(arr, i) || $76c62964b0a424ce$var$_unsupportedIterableToArray(arr, i) || $76c62964b0a424ce$var$_nonIterableRest();
}
function $76c62964b0a424ce$var$_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function $76c62964b0a424ce$var$_iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function $76c62964b0a424ce$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $76c62964b0a424ce$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $76c62964b0a424ce$var$_arrayLikeToArray(o, minLen);
}
function $76c62964b0a424ce$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $76c62964b0a424ce$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
var $76c62964b0a424ce$var$DeviceTypes = {
    Mobile: "mobile",
    Tablet: "tablet",
    SmartTv: "smarttv",
    Console: "console",
    Wearable: "wearable",
    Embedded: "embedded",
    Browser: undefined
};
var $76c62964b0a424ce$var$BrowserTypes = {
    Chrome: "Chrome",
    Firefox: "Firefox",
    Opera: "Opera",
    Yandex: "Yandex",
    Safari: "Safari",
    InternetExplorer: "Internet Explorer",
    Edge: "Edge",
    Chromium: "Chromium",
    Ie: "IE",
    MobileSafari: "Mobile Safari",
    EdgeChromium: "Edge Chromium",
    MIUI: "MIUI Browser",
    SamsungBrowser: "Samsung Browser"
};
var $76c62964b0a424ce$var$OsTypes = {
    IOS: "iOS",
    Android: "Android",
    WindowsPhone: "Windows Phone",
    Windows: "Windows",
    MAC_OS: "Mac OS"
};
var $76c62964b0a424ce$var$InitialDeviceTypes = {
    isMobile: false,
    isTablet: false,
    isBrowser: false,
    isSmartTV: false,
    isConsole: false,
    isWearable: false
};
var $76c62964b0a424ce$var$checkDeviceType = function checkDeviceType(type) {
    switch(type){
        case $76c62964b0a424ce$var$DeviceTypes.Mobile:
            return {
                isMobile: true
            };
        case $76c62964b0a424ce$var$DeviceTypes.Tablet:
            return {
                isTablet: true
            };
        case $76c62964b0a424ce$var$DeviceTypes.SmartTv:
            return {
                isSmartTV: true
            };
        case $76c62964b0a424ce$var$DeviceTypes.Console:
            return {
                isConsole: true
            };
        case $76c62964b0a424ce$var$DeviceTypes.Wearable:
            return {
                isWearable: true
            };
        case $76c62964b0a424ce$var$DeviceTypes.Browser:
            return {
                isBrowser: true
            };
        case $76c62964b0a424ce$var$DeviceTypes.Embedded:
            return {
                isEmbedded: true
            };
        default:
            return $76c62964b0a424ce$var$InitialDeviceTypes;
    }
};
var $76c62964b0a424ce$var$setUserAgent = function setUserAgent(userAgent) {
    return $76c62964b0a424ce$var$setUa(userAgent);
};
var $76c62964b0a424ce$var$setDefaults = function setDefaults(p) {
    var d = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "none";
    return p ? p : d;
};
var $76c62964b0a424ce$var$getNavigatorInstance = function getNavigatorInstance() {
    if (typeof window !== "undefined") {
        if (window.navigator || navigator) return window.navigator || navigator;
    }
    return false;
};
var $76c62964b0a424ce$var$isIOS13Check = function isIOS13Check(type) {
    var nav = $76c62964b0a424ce$var$getNavigatorInstance();
    return nav && nav.platform && (nav.platform.indexOf(type) !== -1 || nav.platform === "MacIntel" && nav.maxTouchPoints > 1 && !window.MSStream);
};
var $76c62964b0a424ce$var$browserPayload = function browserPayload(isBrowser, browser, engine, os, ua) {
    return {
        isBrowser: isBrowser,
        browserMajorVersion: $76c62964b0a424ce$var$setDefaults(browser.major),
        browserFullVersion: $76c62964b0a424ce$var$setDefaults(browser.version),
        browserName: $76c62964b0a424ce$var$setDefaults(browser.name),
        engineName: $76c62964b0a424ce$var$setDefaults(engine.name),
        engineVersion: $76c62964b0a424ce$var$setDefaults(engine.version),
        osName: $76c62964b0a424ce$var$setDefaults(os.name),
        osVersion: $76c62964b0a424ce$var$setDefaults(os.version),
        userAgent: $76c62964b0a424ce$var$setDefaults(ua)
    };
};
var $76c62964b0a424ce$var$mobilePayload = function mobilePayload(type, device, os, ua) {
    return $76c62964b0a424ce$var$_objectSpread2({}, type, {
        vendor: $76c62964b0a424ce$var$setDefaults(device.vendor),
        model: $76c62964b0a424ce$var$setDefaults(device.model),
        os: $76c62964b0a424ce$var$setDefaults(os.name),
        osVersion: $76c62964b0a424ce$var$setDefaults(os.version),
        ua: $76c62964b0a424ce$var$setDefaults(ua)
    });
};
var $76c62964b0a424ce$var$smartTvPayload = function smartTvPayload(isSmartTV, engine, os, ua) {
    return {
        isSmartTV: isSmartTV,
        engineName: $76c62964b0a424ce$var$setDefaults(engine.name),
        engineVersion: $76c62964b0a424ce$var$setDefaults(engine.version),
        osName: $76c62964b0a424ce$var$setDefaults(os.name),
        osVersion: $76c62964b0a424ce$var$setDefaults(os.version),
        userAgent: $76c62964b0a424ce$var$setDefaults(ua)
    };
};
var $76c62964b0a424ce$var$consolePayload = function consolePayload(isConsole, engine, os, ua) {
    return {
        isConsole: isConsole,
        engineName: $76c62964b0a424ce$var$setDefaults(engine.name),
        engineVersion: $76c62964b0a424ce$var$setDefaults(engine.version),
        osName: $76c62964b0a424ce$var$setDefaults(os.name),
        osVersion: $76c62964b0a424ce$var$setDefaults(os.version),
        userAgent: $76c62964b0a424ce$var$setDefaults(ua)
    };
};
var $76c62964b0a424ce$var$wearablePayload = function wearablePayload(isWearable, engine, os, ua) {
    return {
        isWearable: isWearable,
        engineName: $76c62964b0a424ce$var$setDefaults(engine.name),
        engineVersion: $76c62964b0a424ce$var$setDefaults(engine.version),
        osName: $76c62964b0a424ce$var$setDefaults(os.name),
        osVersion: $76c62964b0a424ce$var$setDefaults(os.version),
        userAgent: $76c62964b0a424ce$var$setDefaults(ua)
    };
};
var $76c62964b0a424ce$var$embeddedPayload = function embeddedPayload(isEmbedded, device, engine, os, ua) {
    return {
        isEmbedded: isEmbedded,
        vendor: $76c62964b0a424ce$var$setDefaults(device.vendor),
        model: $76c62964b0a424ce$var$setDefaults(device.model),
        engineName: $76c62964b0a424ce$var$setDefaults(engine.name),
        engineVersion: $76c62964b0a424ce$var$setDefaults(engine.version),
        osName: $76c62964b0a424ce$var$setDefaults(os.name),
        osVersion: $76c62964b0a424ce$var$setDefaults(os.version),
        userAgent: $76c62964b0a424ce$var$setDefaults(ua)
    };
};
function $76c62964b0a424ce$var$deviceDetect(userAgent) {
    var _ref = userAgent ? $76c62964b0a424ce$var$parseUserAgent(userAgent) : $76c62964b0a424ce$var$UAHelper, device = _ref.device, browser = _ref.browser, engine = _ref.engine, os = _ref.os, ua = _ref.ua;
    var type = $76c62964b0a424ce$var$checkDeviceType(device.type);
    var isBrowser = type.isBrowser, isMobile = type.isMobile, isTablet = type.isTablet, isSmartTV = type.isSmartTV, isConsole = type.isConsole, isWearable = type.isWearable, isEmbedded = type.isEmbedded;
    if (isBrowser) return $76c62964b0a424ce$var$browserPayload(isBrowser, browser, engine, os, ua);
    if (isSmartTV) return $76c62964b0a424ce$var$smartTvPayload(isSmartTV, engine, os, ua);
    if (isConsole) return $76c62964b0a424ce$var$consolePayload(isConsole, engine, os, ua);
    if (isMobile) return $76c62964b0a424ce$var$mobilePayload(type, device, os, ua);
    if (isTablet) return $76c62964b0a424ce$var$mobilePayload(type, device, os, ua);
    if (isWearable) return $76c62964b0a424ce$var$wearablePayload(isWearable, engine, os, ua);
    if (isEmbedded) return $76c62964b0a424ce$var$embeddedPayload(isEmbedded, device, engine, os, ua);
}
var $76c62964b0a424ce$var$isMobileType = function isMobileType(_ref) {
    var type = _ref.type;
    return type === $76c62964b0a424ce$var$DeviceTypes.Mobile;
};
var $76c62964b0a424ce$var$isTabletType = function isTabletType(_ref2) {
    var type = _ref2.type;
    return type === $76c62964b0a424ce$var$DeviceTypes.Tablet;
};
var $76c62964b0a424ce$var$isMobileAndTabletType = function isMobileAndTabletType(_ref3) {
    var type = _ref3.type;
    return type === $76c62964b0a424ce$var$DeviceTypes.Mobile || type === $76c62964b0a424ce$var$DeviceTypes.Tablet;
};
var $76c62964b0a424ce$var$isSmartTVType = function isSmartTVType(_ref4) {
    var type = _ref4.type;
    return type === $76c62964b0a424ce$var$DeviceTypes.SmartTv;
};
var $76c62964b0a424ce$var$isBrowserType = function isBrowserType(_ref5) {
    var type = _ref5.type;
    return type === $76c62964b0a424ce$var$DeviceTypes.Browser;
};
var $76c62964b0a424ce$var$isWearableType = function isWearableType(_ref6) {
    var type = _ref6.type;
    return type === $76c62964b0a424ce$var$DeviceTypes.Wearable;
};
var $76c62964b0a424ce$var$isConsoleType = function isConsoleType(_ref7) {
    var type = _ref7.type;
    return type === $76c62964b0a424ce$var$DeviceTypes.Console;
};
var $76c62964b0a424ce$var$isEmbeddedType = function isEmbeddedType(_ref8) {
    var type = _ref8.type;
    return type === $76c62964b0a424ce$var$DeviceTypes.Embedded;
};
var $76c62964b0a424ce$var$getMobileVendor = function getMobileVendor(_ref9) {
    var vendor = _ref9.vendor;
    return $76c62964b0a424ce$var$setDefaults(vendor);
};
var $76c62964b0a424ce$var$getMobileModel = function getMobileModel(_ref10) {
    var model = _ref10.model;
    return $76c62964b0a424ce$var$setDefaults(model);
};
var $76c62964b0a424ce$var$getDeviceType = function getDeviceType(_ref11) {
    var type = _ref11.type;
    return $76c62964b0a424ce$var$setDefaults(type, "browser");
}; // os types
var $76c62964b0a424ce$var$isAndroidType = function isAndroidType(_ref12) {
    var name = _ref12.name;
    return name === $76c62964b0a424ce$var$OsTypes.Android;
};
var $76c62964b0a424ce$var$isWindowsType = function isWindowsType(_ref13) {
    var name = _ref13.name;
    return name === $76c62964b0a424ce$var$OsTypes.Windows;
};
var $76c62964b0a424ce$var$isMacOsType = function isMacOsType(_ref14) {
    var name = _ref14.name;
    return name === $76c62964b0a424ce$var$OsTypes.MAC_OS;
};
var $76c62964b0a424ce$var$isWinPhoneType = function isWinPhoneType(_ref15) {
    var name = _ref15.name;
    return name === $76c62964b0a424ce$var$OsTypes.WindowsPhone;
};
var $76c62964b0a424ce$var$isIOSType = function isIOSType(_ref16) {
    var name = _ref16.name;
    return name === $76c62964b0a424ce$var$OsTypes.IOS;
};
var $76c62964b0a424ce$var$getOsVersion = function getOsVersion(_ref17) {
    var version = _ref17.version;
    return $76c62964b0a424ce$var$setDefaults(version);
};
var $76c62964b0a424ce$var$getOsName = function getOsName(_ref18) {
    var name = _ref18.name;
    return $76c62964b0a424ce$var$setDefaults(name);
}; // browser types
var $76c62964b0a424ce$var$isChromeType = function isChromeType(_ref19) {
    var name = _ref19.name;
    return name === $76c62964b0a424ce$var$BrowserTypes.Chrome;
};
var $76c62964b0a424ce$var$isFirefoxType = function isFirefoxType(_ref20) {
    var name = _ref20.name;
    return name === $76c62964b0a424ce$var$BrowserTypes.Firefox;
};
var $76c62964b0a424ce$var$isChromiumType = function isChromiumType(_ref21) {
    var name = _ref21.name;
    return name === $76c62964b0a424ce$var$BrowserTypes.Chromium;
};
var $76c62964b0a424ce$var$isEdgeType = function isEdgeType(_ref22) {
    var name = _ref22.name;
    return name === $76c62964b0a424ce$var$BrowserTypes.Edge;
};
var $76c62964b0a424ce$var$isYandexType = function isYandexType(_ref23) {
    var name = _ref23.name;
    return name === $76c62964b0a424ce$var$BrowserTypes.Yandex;
};
var $76c62964b0a424ce$var$isSafariType = function isSafariType(_ref24) {
    var name = _ref24.name;
    return name === $76c62964b0a424ce$var$BrowserTypes.Safari || name === $76c62964b0a424ce$var$BrowserTypes.MobileSafari;
};
var $76c62964b0a424ce$var$isMobileSafariType = function isMobileSafariType(_ref25) {
    var name = _ref25.name;
    return name === $76c62964b0a424ce$var$BrowserTypes.MobileSafari;
};
var $76c62964b0a424ce$var$isOperaType = function isOperaType(_ref26) {
    var name = _ref26.name;
    return name === $76c62964b0a424ce$var$BrowserTypes.Opera;
};
var $76c62964b0a424ce$var$isIEType = function isIEType(_ref27) {
    var name = _ref27.name;
    return name === $76c62964b0a424ce$var$BrowserTypes.InternetExplorer || name === $76c62964b0a424ce$var$BrowserTypes.Ie;
};
var $76c62964b0a424ce$var$isMIUIType = function isMIUIType(_ref28) {
    var name = _ref28.name;
    return name === $76c62964b0a424ce$var$BrowserTypes.MIUI;
};
var $76c62964b0a424ce$var$isSamsungBrowserType = function isSamsungBrowserType(_ref29) {
    var name = _ref29.name;
    return name === $76c62964b0a424ce$var$BrowserTypes.SamsungBrowser;
};
var $76c62964b0a424ce$var$getBrowserFullVersion = function getBrowserFullVersion(_ref30) {
    var version = _ref30.version;
    return $76c62964b0a424ce$var$setDefaults(version);
};
var $76c62964b0a424ce$var$getBrowserVersion = function getBrowserVersion(_ref31) {
    var major = _ref31.major;
    return $76c62964b0a424ce$var$setDefaults(major);
};
var $76c62964b0a424ce$var$getBrowserName = function getBrowserName(_ref32) {
    var name = _ref32.name;
    return $76c62964b0a424ce$var$setDefaults(name);
}; // engine types
var $76c62964b0a424ce$var$getEngineName = function getEngineName(_ref33) {
    var name = _ref33.name;
    return $76c62964b0a424ce$var$setDefaults(name);
};
var $76c62964b0a424ce$var$getEngineVersion = function getEngineVersion(_ref34) {
    var version = _ref34.version;
    return $76c62964b0a424ce$var$setDefaults(version);
};
var $76c62964b0a424ce$var$isElectronType = function isElectronType() {
    var nav = $76c62964b0a424ce$var$getNavigatorInstance();
    var ua = nav && nav.userAgent && nav.userAgent.toLowerCase();
    return typeof ua === "string" ? /electron/.test(ua) : false;
};
var $76c62964b0a424ce$var$isEdgeChromiumType = function isEdgeChromiumType(ua) {
    return typeof ua === "string" && ua.indexOf("Edg/") !== -1;
};
var $76c62964b0a424ce$var$getIOS13 = function getIOS13() {
    var nav = $76c62964b0a424ce$var$getNavigatorInstance();
    return nav && (/iPad|iPhone|iPod/.test(nav.platform) || nav.platform === "MacIntel" && nav.maxTouchPoints > 1) && !window.MSStream;
};
var $76c62964b0a424ce$var$getIPad13 = function getIPad13() {
    return $76c62964b0a424ce$var$isIOS13Check("iPad");
};
var $76c62964b0a424ce$var$getIphone13 = function getIphone13() {
    return $76c62964b0a424ce$var$isIOS13Check("iPhone");
};
var $76c62964b0a424ce$var$getIPod13 = function getIPod13() {
    return $76c62964b0a424ce$var$isIOS13Check("iPod");
};
var $76c62964b0a424ce$var$getUseragent = function getUseragent(userAg) {
    return $76c62964b0a424ce$var$setDefaults(userAg);
};
function $76c62964b0a424ce$var$buildSelectorsObject(options) {
    var _ref = options ? options : $76c62964b0a424ce$var$UAHelper, device = _ref.device, browser = _ref.browser, os = _ref.os, engine = _ref.engine, ua = _ref.ua;
    return {
        isSmartTV: $76c62964b0a424ce$var$isSmartTVType(device),
        isConsole: $76c62964b0a424ce$var$isConsoleType(device),
        isWearable: $76c62964b0a424ce$var$isWearableType(device),
        isEmbedded: $76c62964b0a424ce$var$isEmbeddedType(device),
        isMobileSafari: $76c62964b0a424ce$var$isMobileSafariType(browser) || $76c62964b0a424ce$var$getIPad13(),
        isChromium: $76c62964b0a424ce$var$isChromiumType(browser),
        isMobile: $76c62964b0a424ce$var$isMobileAndTabletType(device) || $76c62964b0a424ce$var$getIPad13(),
        isMobileOnly: $76c62964b0a424ce$var$isMobileType(device),
        isTablet: $76c62964b0a424ce$var$isTabletType(device) || $76c62964b0a424ce$var$getIPad13(),
        isBrowser: $76c62964b0a424ce$var$isBrowserType(device),
        isDesktop: $76c62964b0a424ce$var$isBrowserType(device),
        isAndroid: $76c62964b0a424ce$var$isAndroidType(os),
        isWinPhone: $76c62964b0a424ce$var$isWinPhoneType(os),
        isIOS: $76c62964b0a424ce$var$isIOSType(os) || $76c62964b0a424ce$var$getIPad13(),
        isChrome: $76c62964b0a424ce$var$isChromeType(browser),
        isFirefox: $76c62964b0a424ce$var$isFirefoxType(browser),
        isSafari: $76c62964b0a424ce$var$isSafariType(browser),
        isOpera: $76c62964b0a424ce$var$isOperaType(browser),
        isIE: $76c62964b0a424ce$var$isIEType(browser),
        osVersion: $76c62964b0a424ce$var$getOsVersion(os),
        osName: $76c62964b0a424ce$var$getOsName(os),
        fullBrowserVersion: $76c62964b0a424ce$var$getBrowserFullVersion(browser),
        browserVersion: $76c62964b0a424ce$var$getBrowserVersion(browser),
        browserName: $76c62964b0a424ce$var$getBrowserName(browser),
        mobileVendor: $76c62964b0a424ce$var$getMobileVendor(device),
        mobileModel: $76c62964b0a424ce$var$getMobileModel(device),
        engineName: $76c62964b0a424ce$var$getEngineName(engine),
        engineVersion: $76c62964b0a424ce$var$getEngineVersion(engine),
        getUA: $76c62964b0a424ce$var$getUseragent(ua),
        isEdge: $76c62964b0a424ce$var$isEdgeType(browser) || $76c62964b0a424ce$var$isEdgeChromiumType(ua),
        isYandex: $76c62964b0a424ce$var$isYandexType(browser),
        deviceType: $76c62964b0a424ce$var$getDeviceType(device),
        isIOS13: $76c62964b0a424ce$var$getIOS13(),
        isIPad13: $76c62964b0a424ce$var$getIPad13(),
        isIPhone13: $76c62964b0a424ce$var$getIphone13(),
        isIPod13: $76c62964b0a424ce$var$getIPod13(),
        isElectron: $76c62964b0a424ce$var$isElectronType(),
        isEdgeChromium: $76c62964b0a424ce$var$isEdgeChromiumType(ua),
        isLegacyEdge: $76c62964b0a424ce$var$isEdgeType(browser) && !$76c62964b0a424ce$var$isEdgeChromiumType(ua),
        isWindows: $76c62964b0a424ce$var$isWindowsType(os),
        isMacOs: $76c62964b0a424ce$var$isMacOsType(os),
        isMIUI: $76c62964b0a424ce$var$isMIUIType(browser),
        isSamsungBrowser: $76c62964b0a424ce$var$isSamsungBrowserType(browser)
    };
}
var $76c62964b0a424ce$var$isSmartTV = $76c62964b0a424ce$var$isSmartTVType($76c62964b0a424ce$var$device);
var $76c62964b0a424ce$var$isConsole = $76c62964b0a424ce$var$isConsoleType($76c62964b0a424ce$var$device);
var $76c62964b0a424ce$var$isWearable = $76c62964b0a424ce$var$isWearableType($76c62964b0a424ce$var$device);
var $76c62964b0a424ce$var$isEmbedded = $76c62964b0a424ce$var$isEmbeddedType($76c62964b0a424ce$var$device);
var $76c62964b0a424ce$var$isMobileSafari = $76c62964b0a424ce$var$isMobileSafariType($76c62964b0a424ce$var$browser) || $76c62964b0a424ce$var$getIPad13();
var $76c62964b0a424ce$var$isChromium = $76c62964b0a424ce$var$isChromiumType($76c62964b0a424ce$var$browser);
var $76c62964b0a424ce$var$isMobile = $76c62964b0a424ce$var$isMobileAndTabletType($76c62964b0a424ce$var$device) || $76c62964b0a424ce$var$getIPad13();
var $76c62964b0a424ce$var$isMobileOnly = $76c62964b0a424ce$var$isMobileType($76c62964b0a424ce$var$device);
var $76c62964b0a424ce$var$isTablet = $76c62964b0a424ce$var$isTabletType($76c62964b0a424ce$var$device) || $76c62964b0a424ce$var$getIPad13();
var $76c62964b0a424ce$var$isBrowser = $76c62964b0a424ce$var$isBrowserType($76c62964b0a424ce$var$device);
var $76c62964b0a424ce$var$isDesktop = $76c62964b0a424ce$var$isBrowserType($76c62964b0a424ce$var$device);
var $76c62964b0a424ce$var$isAndroid = $76c62964b0a424ce$var$isAndroidType($76c62964b0a424ce$var$os);
var $76c62964b0a424ce$var$isWinPhone = $76c62964b0a424ce$var$isWinPhoneType($76c62964b0a424ce$var$os);
var $76c62964b0a424ce$var$isIOS = $76c62964b0a424ce$var$isIOSType($76c62964b0a424ce$var$os) || $76c62964b0a424ce$var$getIPad13();
var $76c62964b0a424ce$var$isChrome = $76c62964b0a424ce$var$isChromeType($76c62964b0a424ce$var$browser);
var $76c62964b0a424ce$var$isFirefox = $76c62964b0a424ce$var$isFirefoxType($76c62964b0a424ce$var$browser);
var $76c62964b0a424ce$var$isSafari = $76c62964b0a424ce$var$isSafariType($76c62964b0a424ce$var$browser);
var $76c62964b0a424ce$var$isOpera = $76c62964b0a424ce$var$isOperaType($76c62964b0a424ce$var$browser);
var $76c62964b0a424ce$var$isIE = $76c62964b0a424ce$var$isIEType($76c62964b0a424ce$var$browser);
var $76c62964b0a424ce$var$osVersion = $76c62964b0a424ce$var$getOsVersion($76c62964b0a424ce$var$os);
var $76c62964b0a424ce$var$osName = $76c62964b0a424ce$var$getOsName($76c62964b0a424ce$var$os);
var $76c62964b0a424ce$var$fullBrowserVersion = $76c62964b0a424ce$var$getBrowserFullVersion($76c62964b0a424ce$var$browser);
var $76c62964b0a424ce$var$browserVersion = $76c62964b0a424ce$var$getBrowserVersion($76c62964b0a424ce$var$browser);
var $76c62964b0a424ce$var$browserName = $76c62964b0a424ce$var$getBrowserName($76c62964b0a424ce$var$browser);
var $76c62964b0a424ce$var$mobileVendor = $76c62964b0a424ce$var$getMobileVendor($76c62964b0a424ce$var$device);
var $76c62964b0a424ce$var$mobileModel = $76c62964b0a424ce$var$getMobileModel($76c62964b0a424ce$var$device);
var $76c62964b0a424ce$var$engineName = $76c62964b0a424ce$var$getEngineName($76c62964b0a424ce$var$engine);
var $76c62964b0a424ce$var$engineVersion = $76c62964b0a424ce$var$getEngineVersion($76c62964b0a424ce$var$engine);
var $76c62964b0a424ce$var$getUA = $76c62964b0a424ce$var$getUseragent($76c62964b0a424ce$var$ua);
var $76c62964b0a424ce$var$isEdge = $76c62964b0a424ce$var$isEdgeType($76c62964b0a424ce$var$browser) || $76c62964b0a424ce$var$isEdgeChromiumType($76c62964b0a424ce$var$ua);
var $76c62964b0a424ce$var$isYandex = $76c62964b0a424ce$var$isYandexType($76c62964b0a424ce$var$browser);
var $76c62964b0a424ce$var$deviceType = $76c62964b0a424ce$var$getDeviceType($76c62964b0a424ce$var$device);
var $76c62964b0a424ce$var$isIOS13 = $76c62964b0a424ce$var$getIOS13();
var $76c62964b0a424ce$var$isIPad13 = $76c62964b0a424ce$var$getIPad13();
var $76c62964b0a424ce$var$isIPhone13 = $76c62964b0a424ce$var$getIphone13();
var $76c62964b0a424ce$var$isIPod13 = $76c62964b0a424ce$var$getIPod13();
var $76c62964b0a424ce$var$isElectron = $76c62964b0a424ce$var$isElectronType();
var $76c62964b0a424ce$var$isEdgeChromium = $76c62964b0a424ce$var$isEdgeChromiumType($76c62964b0a424ce$var$ua);
var $76c62964b0a424ce$var$isLegacyEdge = $76c62964b0a424ce$var$isEdgeType($76c62964b0a424ce$var$browser) && !$76c62964b0a424ce$var$isEdgeChromiumType($76c62964b0a424ce$var$ua);
var $76c62964b0a424ce$var$isWindows = $76c62964b0a424ce$var$isWindowsType($76c62964b0a424ce$var$os);
var $76c62964b0a424ce$var$isMacOs = $76c62964b0a424ce$var$isMacOsType($76c62964b0a424ce$var$os);
var $76c62964b0a424ce$var$isMIUI = $76c62964b0a424ce$var$isMIUIType($76c62964b0a424ce$var$browser);
var $76c62964b0a424ce$var$isSamsungBrowser = $76c62964b0a424ce$var$isSamsungBrowserType($76c62964b0a424ce$var$browser);
var $76c62964b0a424ce$var$getSelectorsByUserAgent = function getSelectorsByUserAgent(userAgent) {
    if (!userAgent || typeof userAgent !== "string") {
        console.error("No valid user agent string was provided");
        return;
    }
    var _UAHelper$parseUserAg = $76c62964b0a424ce$var$parseUserAgent(userAgent), device = _UAHelper$parseUserAg.device, browser = _UAHelper$parseUserAg.browser, os = _UAHelper$parseUserAg.os, engine = _UAHelper$parseUserAg.engine, ua = _UAHelper$parseUserAg.ua;
    return $76c62964b0a424ce$var$buildSelectorsObject({
        device: device,
        browser: browser,
        os: os,
        engine: engine,
        ua: ua
    });
};
var $76c62964b0a424ce$var$AndroidView = function AndroidView(_ref) {
    var renderWithFragment = _ref.renderWithFragment, children = _ref.children, props = $76c62964b0a424ce$var$_objectWithoutProperties(_ref, [
        "renderWithFragment",
        "children"
    ]);
    return $76c62964b0a424ce$var$isAndroid ? renderWithFragment ? $76c62964b0a424ce$var$React__default.createElement($acw62.Fragment, null, children) : $76c62964b0a424ce$var$React__default.createElement("div", props, children) : null;
};
var $76c62964b0a424ce$var$BrowserView = function BrowserView(_ref2) {
    var renderWithFragment = _ref2.renderWithFragment, children = _ref2.children, props = $76c62964b0a424ce$var$_objectWithoutProperties(_ref2, [
        "renderWithFragment",
        "children"
    ]);
    return $76c62964b0a424ce$var$isBrowser ? renderWithFragment ? $76c62964b0a424ce$var$React__default.createElement($acw62.Fragment, null, children) : $76c62964b0a424ce$var$React__default.createElement("div", props, children) : null;
};
var $76c62964b0a424ce$var$IEView = function IEView(_ref3) {
    var renderWithFragment = _ref3.renderWithFragment, children = _ref3.children, props = $76c62964b0a424ce$var$_objectWithoutProperties(_ref3, [
        "renderWithFragment",
        "children"
    ]);
    return $76c62964b0a424ce$var$isIE ? renderWithFragment ? $76c62964b0a424ce$var$React__default.createElement($acw62.Fragment, null, children) : $76c62964b0a424ce$var$React__default.createElement("div", props, children) : null;
};
var $76c62964b0a424ce$var$IOSView = function IOSView(_ref4) {
    var renderWithFragment = _ref4.renderWithFragment, children = _ref4.children, props = $76c62964b0a424ce$var$_objectWithoutProperties(_ref4, [
        "renderWithFragment",
        "children"
    ]);
    return $76c62964b0a424ce$var$isIOS ? renderWithFragment ? $76c62964b0a424ce$var$React__default.createElement($acw62.Fragment, null, children) : $76c62964b0a424ce$var$React__default.createElement("div", props, children) : null;
};
var $76c62964b0a424ce$var$MobileView = function MobileView(_ref5) {
    var renderWithFragment = _ref5.renderWithFragment, children = _ref5.children, props = $76c62964b0a424ce$var$_objectWithoutProperties(_ref5, [
        "renderWithFragment",
        "children"
    ]);
    return $76c62964b0a424ce$var$isMobile ? renderWithFragment ? $76c62964b0a424ce$var$React__default.createElement($acw62.Fragment, null, children) : $76c62964b0a424ce$var$React__default.createElement("div", props, children) : null;
};
var $76c62964b0a424ce$var$TabletView = function TabletView(_ref6) {
    var renderWithFragment = _ref6.renderWithFragment, children = _ref6.children, props = $76c62964b0a424ce$var$_objectWithoutProperties(_ref6, [
        "renderWithFragment",
        "children"
    ]);
    return $76c62964b0a424ce$var$isTablet ? renderWithFragment ? $76c62964b0a424ce$var$React__default.createElement($acw62.Fragment, null, children) : $76c62964b0a424ce$var$React__default.createElement("div", props, children) : null;
};
var $76c62964b0a424ce$var$WinPhoneView = function WinPhoneView(_ref7) {
    var renderWithFragment = _ref7.renderWithFragment, children = _ref7.children, props = $76c62964b0a424ce$var$_objectWithoutProperties(_ref7, [
        "renderWithFragment",
        "children"
    ]);
    return $76c62964b0a424ce$var$isWinPhone ? renderWithFragment ? $76c62964b0a424ce$var$React__default.createElement($acw62.Fragment, null, children) : $76c62964b0a424ce$var$React__default.createElement("div", props, children) : null;
};
var $76c62964b0a424ce$var$MobileOnlyView = function MobileOnlyView(_ref8) {
    var renderWithFragment = _ref8.renderWithFragment, children = _ref8.children, viewClassName = _ref8.viewClassName, style = _ref8.style, props = $76c62964b0a424ce$var$_objectWithoutProperties(_ref8, [
        "renderWithFragment",
        "children",
        "viewClassName",
        "style"
    ]);
    return $76c62964b0a424ce$var$isMobileOnly ? renderWithFragment ? $76c62964b0a424ce$var$React__default.createElement($acw62.Fragment, null, children) : $76c62964b0a424ce$var$React__default.createElement("div", props, children) : null;
};
var $76c62964b0a424ce$var$SmartTVView = function SmartTVView(_ref9) {
    var renderWithFragment = _ref9.renderWithFragment, children = _ref9.children, props = $76c62964b0a424ce$var$_objectWithoutProperties(_ref9, [
        "renderWithFragment",
        "children"
    ]);
    return $76c62964b0a424ce$var$isSmartTV ? renderWithFragment ? $76c62964b0a424ce$var$React__default.createElement($acw62.Fragment, null, children) : $76c62964b0a424ce$var$React__default.createElement("div", props, children) : null;
};
var $76c62964b0a424ce$var$ConsoleView = function ConsoleView(_ref10) {
    var renderWithFragment = _ref10.renderWithFragment, children = _ref10.children, props = $76c62964b0a424ce$var$_objectWithoutProperties(_ref10, [
        "renderWithFragment",
        "children"
    ]);
    return $76c62964b0a424ce$var$isConsole ? renderWithFragment ? $76c62964b0a424ce$var$React__default.createElement($acw62.Fragment, null, children) : $76c62964b0a424ce$var$React__default.createElement("div", props, children) : null;
};
var $76c62964b0a424ce$var$WearableView = function WearableView(_ref11) {
    var renderWithFragment = _ref11.renderWithFragment, children = _ref11.children, props = $76c62964b0a424ce$var$_objectWithoutProperties(_ref11, [
        "renderWithFragment",
        "children"
    ]);
    return $76c62964b0a424ce$var$isWearable ? renderWithFragment ? $76c62964b0a424ce$var$React__default.createElement($acw62.Fragment, null, children) : $76c62964b0a424ce$var$React__default.createElement("div", props, children) : null;
};
var $76c62964b0a424ce$var$CustomView = function CustomView(_ref12) {
    var renderWithFragment = _ref12.renderWithFragment, children = _ref12.children, viewClassName = _ref12.viewClassName, style = _ref12.style, condition = _ref12.condition, props = $76c62964b0a424ce$var$_objectWithoutProperties(_ref12, [
        "renderWithFragment",
        "children",
        "viewClassName",
        "style",
        "condition"
    ]);
    return condition ? renderWithFragment ? $76c62964b0a424ce$var$React__default.createElement($acw62.Fragment, null, children) : $76c62964b0a424ce$var$React__default.createElement("div", props, children) : null;
};
function $76c62964b0a424ce$var$withOrientationChange(WrappedComponent) {
    return /*#__PURE__*/ function(_React$Component) {
        $76c62964b0a424ce$var$_inherits(_class, _React$Component);
        function _class(props) {
            var _this;
            $76c62964b0a424ce$var$_classCallCheck(this, _class);
            _this = $76c62964b0a424ce$var$_possibleConstructorReturn(this, $76c62964b0a424ce$var$_getPrototypeOf(_class).call(this, props));
            _this.isEventListenerAdded = false;
            _this.handleOrientationChange = _this.handleOrientationChange.bind($76c62964b0a424ce$var$_assertThisInitialized(_this));
            _this.onOrientationChange = _this.onOrientationChange.bind($76c62964b0a424ce$var$_assertThisInitialized(_this));
            _this.onPageLoad = _this.onPageLoad.bind($76c62964b0a424ce$var$_assertThisInitialized(_this));
            _this.state = {
                isLandscape: false,
                isPortrait: false
            };
            return _this;
        }
        $76c62964b0a424ce$var$_createClass(_class, [
            {
                key: "handleOrientationChange",
                value: function handleOrientationChange() {
                    if (!this.isEventListenerAdded) this.isEventListenerAdded = true;
                    var orientation = window.innerWidth > window.innerHeight ? 90 : 0;
                    this.setState({
                        isPortrait: orientation === 0,
                        isLandscape: orientation === 90
                    });
                }
            },
            {
                key: "onOrientationChange",
                value: function onOrientationChange() {
                    this.handleOrientationChange();
                }
            },
            {
                key: "onPageLoad",
                value: function onPageLoad() {
                    this.handleOrientationChange();
                }
            },
            {
                key: "componentDidMount",
                value: function componentDidMount() {
                    if ((typeof window === "undefined" ? "undefined" : $76c62964b0a424ce$var$_typeof(window)) !== undefined && $76c62964b0a424ce$var$isMobile) {
                        if (!this.isEventListenerAdded) {
                            this.handleOrientationChange();
                            window.addEventListener("load", this.onPageLoad, false);
                        } else window.removeEventListener("load", this.onPageLoad, false);
                        window.addEventListener("resize", this.onOrientationChange, false);
                    }
                }
            },
            {
                key: "componentWillUnmount",
                value: function componentWillUnmount() {
                    window.removeEventListener("resize", this.onOrientationChange, false);
                }
            },
            {
                key: "render",
                value: function render() {
                    return $76c62964b0a424ce$var$React__default.createElement(WrappedComponent, $76c62964b0a424ce$var$_extends({}, this.props, {
                        isLandscape: this.state.isLandscape,
                        isPortrait: this.state.isPortrait
                    }));
                }
            }
        ]);
        return _class;
    }($76c62964b0a424ce$var$React__default.Component);
}
function $76c62964b0a424ce$var$useMobileOrientation() {
    var _useState = $acw62.useState(function() {
        var orientation = window.innerWidth > window.innerHeight ? 90 : 0;
        return {
            isPortrait: orientation === 0,
            isLandscape: orientation === 90,
            orientation: orientation === 0 ? "portrait" : "landscape"
        };
    }), _useState2 = $76c62964b0a424ce$var$_slicedToArray(_useState, 2), state = _useState2[0], setState = _useState2[1];
    var handleOrientationChange = $acw62.useCallback(function() {
        var orientation = window.innerWidth > window.innerHeight ? 90 : 0;
        var next = {
            isPortrait: orientation === 0,
            isLandscape: orientation === 90,
            orientation: orientation === 0 ? "portrait" : "landscape"
        };
        state.orientation !== next.orientation && setState(next);
    }, [
        state.orientation
    ]);
    $acw62.useEffect(function() {
        if ((typeof window === "undefined" ? "undefined" : $76c62964b0a424ce$var$_typeof(window)) !== undefined && $76c62964b0a424ce$var$isMobile) {
            handleOrientationChange();
            window.addEventListener("load", handleOrientationChange, false);
            window.addEventListener("resize", handleOrientationChange, false);
        }
        return function() {
            window.removeEventListener("resize", handleOrientationChange, false);
            window.removeEventListener("load", handleOrientationChange, false);
        };
    }, [
        handleOrientationChange
    ]);
    return state;
}
function $76c62964b0a424ce$var$useDeviceData(userAgent) {
    var hookUserAgent = userAgent ? userAgent : window.navigator.userAgent;
    return $76c62964b0a424ce$var$parseUserAgent(hookUserAgent);
}
function $76c62964b0a424ce$var$useDeviceSelectors(userAgent) {
    var hookUserAgent = userAgent ? userAgent : window.navigator.userAgent;
    var deviceData = $76c62964b0a424ce$var$useDeviceData(hookUserAgent);
    var selectors = $76c62964b0a424ce$var$buildSelectorsObject(deviceData);
    return [
        selectors,
        deviceData
    ];
}
$76c62964b0a424ce$exports.AndroidView = $76c62964b0a424ce$var$AndroidView;
$76c62964b0a424ce$exports.BrowserTypes = $76c62964b0a424ce$var$BrowserTypes;
$76c62964b0a424ce$exports.BrowserView = $76c62964b0a424ce$var$BrowserView;
$76c62964b0a424ce$exports.ConsoleView = $76c62964b0a424ce$var$ConsoleView;
$76c62964b0a424ce$exports.CustomView = $76c62964b0a424ce$var$CustomView;
$76c62964b0a424ce$exports.IEView = $76c62964b0a424ce$var$IEView;
$76c62964b0a424ce$exports.IOSView = $76c62964b0a424ce$var$IOSView;
$76c62964b0a424ce$exports.MobileOnlyView = $76c62964b0a424ce$var$MobileOnlyView;
$76c62964b0a424ce$exports.MobileView = $76c62964b0a424ce$var$MobileView;
$76c62964b0a424ce$exports.OsTypes = $76c62964b0a424ce$var$OsTypes;
$76c62964b0a424ce$exports.SmartTVView = $76c62964b0a424ce$var$SmartTVView;
$76c62964b0a424ce$exports.TabletView = $76c62964b0a424ce$var$TabletView;
$76c62964b0a424ce$exports.WearableView = $76c62964b0a424ce$var$WearableView;
$76c62964b0a424ce$exports.WinPhoneView = $76c62964b0a424ce$var$WinPhoneView;
$76c62964b0a424ce$exports.browserName = $76c62964b0a424ce$var$browserName;
$76c62964b0a424ce$exports.browserVersion = $76c62964b0a424ce$var$browserVersion;
$76c62964b0a424ce$exports.deviceDetect = $76c62964b0a424ce$var$deviceDetect;
$76c62964b0a424ce$exports.deviceType = $76c62964b0a424ce$var$deviceType;
$76c62964b0a424ce$exports.engineName = $76c62964b0a424ce$var$engineName;
$76c62964b0a424ce$exports.engineVersion = $76c62964b0a424ce$var$engineVersion;
$76c62964b0a424ce$exports.fullBrowserVersion = $76c62964b0a424ce$var$fullBrowserVersion;
$76c62964b0a424ce$exports.getSelectorsByUserAgent = $76c62964b0a424ce$var$getSelectorsByUserAgent;
$76c62964b0a424ce$exports.getUA = $76c62964b0a424ce$var$getUA;
$76c62964b0a424ce$exports.isAndroid = $76c62964b0a424ce$var$isAndroid;
$76c62964b0a424ce$exports.isBrowser = $76c62964b0a424ce$var$isBrowser;
$76c62964b0a424ce$exports.isChrome = $76c62964b0a424ce$var$isChrome;
$76c62964b0a424ce$exports.isChromium = $76c62964b0a424ce$var$isChromium;
$76c62964b0a424ce$exports.isConsole = $76c62964b0a424ce$var$isConsole;
$76c62964b0a424ce$exports.isDesktop = $76c62964b0a424ce$var$isDesktop;
$76c62964b0a424ce$exports.isEdge = $76c62964b0a424ce$var$isEdge;
$76c62964b0a424ce$exports.isEdgeChromium = $76c62964b0a424ce$var$isEdgeChromium;
$76c62964b0a424ce$exports.isElectron = $76c62964b0a424ce$var$isElectron;
$76c62964b0a424ce$exports.isEmbedded = $76c62964b0a424ce$var$isEmbedded;
$76c62964b0a424ce$exports.isFirefox = $76c62964b0a424ce$var$isFirefox;
$76c62964b0a424ce$exports.isIE = $76c62964b0a424ce$var$isIE;
$76c62964b0a424ce$exports.isIOS = $76c62964b0a424ce$var$isIOS;
$76c62964b0a424ce$exports.isIOS13 = $76c62964b0a424ce$var$isIOS13;
$76c62964b0a424ce$exports.isIPad13 = $76c62964b0a424ce$var$isIPad13;
$76c62964b0a424ce$exports.isIPhone13 = $76c62964b0a424ce$var$isIPhone13;
$76c62964b0a424ce$exports.isIPod13 = $76c62964b0a424ce$var$isIPod13;
$76c62964b0a424ce$exports.isLegacyEdge = $76c62964b0a424ce$var$isLegacyEdge;
$76c62964b0a424ce$exports.isMIUI = $76c62964b0a424ce$var$isMIUI;
$76c62964b0a424ce$exports.isMacOs = $76c62964b0a424ce$var$isMacOs;
$76c62964b0a424ce$exports.isMobile = $76c62964b0a424ce$var$isMobile;
$76c62964b0a424ce$exports.isMobileOnly = $76c62964b0a424ce$var$isMobileOnly;
$76c62964b0a424ce$exports.isMobileSafari = $76c62964b0a424ce$var$isMobileSafari;
$76c62964b0a424ce$exports.isOpera = $76c62964b0a424ce$var$isOpera;
$76c62964b0a424ce$exports.isSafari = $76c62964b0a424ce$var$isSafari;
$76c62964b0a424ce$exports.isSamsungBrowser = $76c62964b0a424ce$var$isSamsungBrowser;
$76c62964b0a424ce$exports.isSmartTV = $76c62964b0a424ce$var$isSmartTV;
$76c62964b0a424ce$exports.isTablet = $76c62964b0a424ce$var$isTablet;
$76c62964b0a424ce$exports.isWearable = $76c62964b0a424ce$var$isWearable;
$76c62964b0a424ce$exports.isWinPhone = $76c62964b0a424ce$var$isWinPhone;
$76c62964b0a424ce$exports.isWindows = $76c62964b0a424ce$var$isWindows;
$76c62964b0a424ce$exports.isYandex = $76c62964b0a424ce$var$isYandex;
$76c62964b0a424ce$exports.mobileModel = $76c62964b0a424ce$var$mobileModel;
$76c62964b0a424ce$exports.mobileVendor = $76c62964b0a424ce$var$mobileVendor;
$76c62964b0a424ce$exports.osName = $76c62964b0a424ce$var$osName;
$76c62964b0a424ce$exports.osVersion = $76c62964b0a424ce$var$osVersion;
$76c62964b0a424ce$exports.parseUserAgent = $76c62964b0a424ce$var$parseUserAgent;
$76c62964b0a424ce$exports.setUserAgent = $76c62964b0a424ce$var$setUserAgent;
$76c62964b0a424ce$exports.useDeviceData = $76c62964b0a424ce$var$useDeviceData;
$76c62964b0a424ce$exports.useDeviceSelectors = $76c62964b0a424ce$var$useDeviceSelectors;
$76c62964b0a424ce$exports.useMobileOrientation = $76c62964b0a424ce$var$useMobileOrientation;
$76c62964b0a424ce$exports.withOrientationChange = $76c62964b0a424ce$var$withOrientationChange;







var $gNDby = parcelRequire("gNDby");

var $bYkMz = parcelRequire("bYkMz");

var $acw62 = parcelRequire("acw62");







var $6ZWSX = parcelRequire("6ZWSX");
var $de3a636aba73d02f$require$Buffer = $6ZWSX.Buffer;
const $de3a636aba73d02f$export$9c8facbb2f608a3d = ()=>{
    const { disconnect: disconnectHub } = (0, $4ea79fe64cc4ba62$export$50927ef1fb3dba34)();
    const { dispatch: dispatch, state: { publicKey: hubPublicKey, isLedger: isLedger } } = (0, $c25623cc446ec3c6$export$ac8576a9912be18c)();
    const { signMessage: signMessage, signTransaction: signTransaction, sendTransaction: sendTransaction, signAllTransactions: signAllTransactions, disconnect: disconnect, publicKey: publicKey, connected: connected, wallet: wallet } = (0, $3aa6d87558212265$export$c34addee860b0acb)();
    const [loading, setLoading] = (0, $acw62.useState)(false);
    const walletConnected = !!wallet;
    const connect = (0, $acw62.useCallback)(async ()=>{
        if (!publicKey) return;
        try {
            setLoading(true);
            let response;
            const { nonce: nonce, tx: createdTx } = await (0, $35a528e84618b070$export$3ff59198e2333fc6)(isLedger, publicKey.toString());
            if (!nonce) {
                (0, $ad26fe773541dcd3$export$b410431fab84fa58).error("Impossible to get a nonce, please try again later or contact the support team.");
                setLoading(false);
                return;
            }
            if (isLedger) {
                if (!signTransaction) return;
                if (!createdTx) {
                    (0, $ad26fe773541dcd3$export$b410431fab84fa58).error("Impossible to get the transaction to sign with your Ledger, please try again later or contact the support team.");
                    setLoading(false);
                    return;
                }
                const tx = (0, $gNDby.Transaction).from($de3a636aba73d02f$require$Buffer.from(createdTx, "base64"));
                const signedTx = await signTransaction(tx);
                response = await (0, $35a528e84618b070$export$f8367b7c5d4d854f)({
                    publicKey: publicKey.toString(),
                    signedTx: signedTx.serialize().toString("base64"),
                    nonce: nonce
                });
            } else {
                if (!signMessage) return;
                const message = "wallet-ownership-verification";
                const signature = await signMessage(new TextEncoder().encode(`${message}_${nonce}`));
                response = await (0, $35a528e84618b070$export$f8367b7c5d4d854f)({
                    publicKey: publicKey.toString(),
                    signature: (0, (/*@__PURE__*/$parcel$interopDefault($bYkMz))).encode(signature),
                    message: message,
                    nonce: nonce
                });
            }
            if (response.status === 401) {
                (0, $ad26fe773541dcd3$export$b410431fab84fa58).error("We cannot verify your wallet ownership, please try again later or contact the support team.");
                disconnectHub();
            } else if (response.status === 404) {
                (0, $ad26fe773541dcd3$export$b410431fab84fa58).error("Request error, please try again later or contact the support team.");
                disconnectHub();
            } else {
                const data = response.data;
                if (data && data.sessionToken) {
                    dispatch({
                        type: "SET_SESSION_TOKEN",
                        sessionToken: data.sessionToken
                    });
                    dispatch({
                        type: "SET_PUBLIC_KEY",
                        publicKey: publicKey.toString()
                    });
                    (0, $2b1b88f9a0dfa7a8$export$b73dafe052ae32d3)({
                        sessionToken: data.sessionToken,
                        publicKey: publicKey.toString(),
                        twitterUsername: data.twitter?.username,
                        discordUsername: data.discord?.username,
                        discordServerJoined: data.discord?.serverJoined,
                        username: data.username,
                        isLedger: isLedger
                    });
                    (0, $b3b1baf40467424d$export$745043c7dc65e495).sessionToken = data.sessionToken;
                    if (data.twitter?.username) dispatch({
                        type: "SET_TWITTER_USERNAME",
                        twitterUsername: data.twitter.username
                    });
                    if (data.discord?.username) dispatch({
                        type: "SET_DISCORD_USERNAME",
                        discordUsername: data.discord.username
                    });
                    if (data.discord?.serverJoined) dispatch({
                        type: "SET_DISCORD_SERVER_JOINED",
                        discordServerJoined: data.discord.serverJoined
                    });
                    if (data.username) dispatch({
                        type: "SET_USERNAME",
                        username: data.username
                    });
                    if (data.userUuid) dispatch({
                        type: "SET_USER_UUID",
                        userUuid: data.userUuid
                    });
                    if ((0, $b3b1baf40467424d$export$745043c7dc65e495).refreshAccountInfo) (0, $b3b1baf40467424d$export$745043c7dc65e495).refreshAccountInfo();
                    setLoading(false);
                    return data;
                } else {
                    (0, $ad26fe773541dcd3$export$b410431fab84fa58).error("Impossible to find the sessionToken, please try again later or contact the support team");
                    disconnectHub();
                }
            }
        } catch (err) {
            if (err instanceof (0, $92c515b2e16b5c4e$export$2622c1721bbd4b17) && err.error.code === -32002) return;
            (0, $ad26fe773541dcd3$export$b410431fab84fa58).info(err?.response?.data?.message ?? "Wallet change or request error, try to connect again or contact the support team");
            disconnectHub();
            console.info(err);
        }
        setLoading(false);
    }, [
        publicKey,
        signMessage
    ]);
    (0, $acw62.useEffect)(()=>{
        if (connected && hubPublicKey && hubPublicKey !== publicKey?.toString()) {
            disconnectHub();
            if ((0, $b3b1baf40467424d$export$745043c7dc65e495).showModal) (0, $b3b1baf40467424d$export$745043c7dc65e495).showModal({
                title: "Disconnected",
                text: "You have been disconnected"
            });
        }
    }, [
        disconnectHub,
        connected,
        publicKey,
        hubPublicKey
    ]);
    return {
        connect: connect,
        disconnect: disconnect,
        signMessage: signMessage,
        signTransaction: signTransaction,
        signAllTransactions: signAllTransactions,
        sendTransaction: sendTransaction,
        connected: connected,
        walletConnected: walletConnected,
        loading: loading,
        publicKey: publicKey?.toString()
    };
};






parcelRequire("acw62");

var $310a2f0f9778ad62$exports = {};

$parcel$export($310a2f0f9778ad62$exports, "round", () => $310a2f0f9778ad62$export$2077e0241d6afd3c, (v) => $310a2f0f9778ad62$export$2077e0241d6afd3c = v);
$parcel$export($310a2f0f9778ad62$exports, "slider", () => $310a2f0f9778ad62$export$b38bf4f33e9e4c25, (v) => $310a2f0f9778ad62$export$b38bf4f33e9e4c25 = v);
$parcel$export($310a2f0f9778ad62$exports, "switch", () => $310a2f0f9778ad62$export$52002a3975269b5d, (v) => $310a2f0f9778ad62$export$52002a3975269b5d = v);
$parcel$export($310a2f0f9778ad62$exports, "toggle", () => $310a2f0f9778ad62$export$e03c1c3201ee8bb7, (v) => $310a2f0f9778ad62$export$e03c1c3201ee8bb7 = v);
var $310a2f0f9778ad62$export$2077e0241d6afd3c;
var $310a2f0f9778ad62$export$b38bf4f33e9e4c25;
var $310a2f0f9778ad62$export$52002a3975269b5d;
var $310a2f0f9778ad62$export$e03c1c3201ee8bb7;
$310a2f0f9778ad62$export$2077e0241d6afd3c = `AtHbqW_round`;
$310a2f0f9778ad62$export$b38bf4f33e9e4c25 = `AtHbqW_slider`;
$310a2f0f9778ad62$export$52002a3975269b5d = `AtHbqW_switch`;
$310a2f0f9778ad62$export$e03c1c3201ee8bb7 = `AtHbqW_toggle`;


const $42a4f4ed7816abde$export$bea8ebba691c5813 = ({ containerClassName: containerClassName, ...props })=>{
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
        className: (0, $9805619f03ed02ef$export$91884aa883243770)((0, (/*@__PURE__*/$parcel$interopDefault($310a2f0f9778ad62$exports))), `toggle ${containerClassName ?? ""}`),
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("label", {
            className: (0, $9805619f03ed02ef$export$91884aa883243770)((0, (/*@__PURE__*/$parcel$interopDefault($310a2f0f9778ad62$exports))), "switch"),
            children: [
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                    type: "checkbox",
                    ...props
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                    className: (0, $9805619f03ed02ef$export$91884aa883243770)((0, (/*@__PURE__*/$parcel$interopDefault($310a2f0f9778ad62$exports))), "slider round")
                })
            ]
        })
    });
};


var $89a7a8309184bc24$exports = {};

$parcel$export($89a7a8309184bc24$exports, "change-wallet", () => $89a7a8309184bc24$export$3d1ada0a76b07757, (v) => $89a7a8309184bc24$export$3d1ada0a76b07757 = v);
$parcel$export($89a7a8309184bc24$exports, "connect-modal", () => $89a7a8309184bc24$export$7bbb6e90649d788f, (v) => $89a7a8309184bc24$export$7bbb6e90649d788f = v);
$parcel$export($89a7a8309184bc24$exports, "connect-modal-overlay", () => $89a7a8309184bc24$export$7d08bffb46dde504, (v) => $89a7a8309184bc24$export$7d08bffb46dde504 = v);
$parcel$export($89a7a8309184bc24$exports, "form", () => $89a7a8309184bc24$export$6210fa4921d2a466, (v) => $89a7a8309184bc24$export$6210fa4921d2a466 = v);
$parcel$export($89a7a8309184bc24$exports, "install-wallet", () => $89a7a8309184bc24$export$e19a438ba9c2977c, (v) => $89a7a8309184bc24$export$e19a438ba9c2977c = v);
$parcel$export($89a7a8309184bc24$exports, "ledger-toggle", () => $89a7a8309184bc24$export$7982c3823f9da97b, (v) => $89a7a8309184bc24$export$7982c3823f9da97b = v);
$parcel$export($89a7a8309184bc24$exports, "toggle", () => $89a7a8309184bc24$export$e03c1c3201ee8bb7, (v) => $89a7a8309184bc24$export$e03c1c3201ee8bb7 = v);
$parcel$export($89a7a8309184bc24$exports, "wallet", () => $89a7a8309184bc24$export$4b6dd4ac026934d2, (v) => $89a7a8309184bc24$export$4b6dd4ac026934d2 = v);
var $89a7a8309184bc24$export$3d1ada0a76b07757;
var $89a7a8309184bc24$export$7bbb6e90649d788f;
var $89a7a8309184bc24$export$7d08bffb46dde504;
var $89a7a8309184bc24$export$6210fa4921d2a466;
var $89a7a8309184bc24$export$e19a438ba9c2977c;
var $89a7a8309184bc24$export$7982c3823f9da97b;
var $89a7a8309184bc24$export$e03c1c3201ee8bb7;
var $89a7a8309184bc24$export$4b6dd4ac026934d2;
$89a7a8309184bc24$export$3d1ada0a76b07757 = `yhrBHW_change-wallet`;
$89a7a8309184bc24$export$7bbb6e90649d788f = `yhrBHW_connect-modal`;
$89a7a8309184bc24$export$7d08bffb46dde504 = `yhrBHW_connect-modal-overlay`;
$89a7a8309184bc24$export$6210fa4921d2a466 = `yhrBHW_form`;
$89a7a8309184bc24$export$e19a438ba9c2977c = `yhrBHW_install-wallet`;
$89a7a8309184bc24$export$7982c3823f9da97b = `yhrBHW_ledger-toggle`;
$89a7a8309184bc24$export$e03c1c3201ee8bb7 = `yhrBHW_toggle`;
$89a7a8309184bc24$export$4b6dd4ac026934d2 = `yhrBHW_wallet`;


const $85353414fe7b2bf6$export$b33e7092bdf63f3f = ({ className: className, onHide: onHide, ...props })=>{
    const { dispatch: dispatch, state: { sessionToken: sessionToken, isLedger: isLedger } } = (0, $c25623cc446ec3c6$export$ac8576a9912be18c)();
    const { connected: connected, connect: connect, walletConnected: walletConnected, loading: loading, disconnect: disconnect, signMessage: signMessage, signTransaction: signTransaction, signAllTransactions: signAllTransactions, sendTransaction: sendTransaction } = (0, $de3a636aba73d02f$export$9c8facbb2f608a3d)();
    (0, $acw62.useEffect)(()=>{
        if (sessionToken || !connected || (0, $2b1b88f9a0dfa7a8$export$ee156f6674243a1e)()) return;
        connect();
    }, [
        connect,
        connected,
        sessionToken
    ]);
    (0, $acw62.useEffect)(()=>{
        onHide();
    }, [
        sessionToken
    ]);
    (0, $acw62.useEffect)(()=>{
        (0, $b3b1baf40467424d$export$745043c7dc65e495).sessionConnect = connect;
        (0, $b3b1baf40467424d$export$745043c7dc65e495).signMessage = signMessage;
        (0, $b3b1baf40467424d$export$745043c7dc65e495).signTransaction = signTransaction;
        (0, $b3b1baf40467424d$export$745043c7dc65e495).signAllTransactions = signAllTransactions;
        (0, $b3b1baf40467424d$export$745043c7dc65e495).sendTransaction = sendTransaction;
    }, [
        connect,
        signMessage,
        signTransaction,
        sendTransaction
    ]);
    (0, $acw62.useEffect)(()=>{
        dispatch({
            type: "SET_DISCONNECT_WALLET",
            disconnectWallet: disconnect
        });
    }, [
        disconnect
    ]);
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $207d23274fe2be11$export$a118d25f3bd40bb8), {
        className: (0, $9805619f03ed02ef$export$91884aa883243770)((0, (/*@__PURE__*/$parcel$interopDefault($89a7a8309184bc24$exports))), `connect-modal-overlay ${className}`),
        ...props,
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
            className: (0, $9805619f03ed02ef$export$91884aa883243770)((0, (/*@__PURE__*/$parcel$interopDefault($89a7a8309184bc24$exports))), "connect-modal"),
            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: (0, $9805619f03ed02ef$export$91884aa883243770)((0, (/*@__PURE__*/$parcel$interopDefault($89a7a8309184bc24$exports))), "wallet"),
                children: !(0, $9805619f03ed02ef$export$7f84b2f452f9a348) ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                    className: (0, $9805619f03ed02ef$export$91884aa883243770)((0, (/*@__PURE__*/$parcel$interopDefault($89a7a8309184bc24$exports))), "install-wallet"),
                    children: (0, $76c62964b0a424ce$exports.isAndroid) ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                children: "To connect, please use the Phantom App browser"
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("a", {
                                href: "https://play.google.com/store/apps/details?id=app.phantom",
                                children: "Open Android app"
                            })
                        ]
                    }) : (0, $76c62964b0a424ce$exports.isIOS) ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                children: "To connect, please use the Phantom App browser"
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("a", {
                                href: "https://apps.apple.com/app/phantom-solana-wallet/1598432977",
                                children: "Open iOS app"
                            })
                        ]
                    }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                children: "To connect, please use the Phantom wallet extension or the Brave browser"
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("a", {
                                href: "https://phantom.app/",
                                children: "Phantom Website"
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("a", {
                                href: "https://brave.com/",
                                children: "Brave Website"
                            })
                        ]
                    })
                }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                    className: (0, $9805619f03ed02ef$export$91884aa883243770)((0, (/*@__PURE__*/$parcel$interopDefault($89a7a8309184bc24$exports))), "form"),
                    children: loading && connected ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                        children: "Please sign and wait..."
                    }) : !connected && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                children: "Connect a Solana wallet"
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $b30bad04ca015373$export$968d144f04194cbb), {
                                children: walletConnected ? "Connect" : "Select wallet"
                            }),
                            walletConnected && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                className: (0, $9805619f03ed02ef$export$91884aa883243770)((0, (/*@__PURE__*/$parcel$interopDefault($89a7a8309184bc24$exports))), "change-wallet"),
                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $8fc8d77258ce4f67$export$961aa68bc59bf83d), {
                                    children: "Change wallet"
                                })
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                                className: (0, $9805619f03ed02ef$export$91884aa883243770)((0, (/*@__PURE__*/$parcel$interopDefault($89a7a8309184bc24$exports))), "ledger-toggle"),
                                onClick: ()=>dispatch({
                                        type: "SET_IS_LEDGER",
                                        isLedger: !isLedger
                                    }),
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $42a4f4ed7816abde$export$bea8ebba691c5813), {
                                        containerClassName: (0, $9805619f03ed02ef$export$91884aa883243770)((0, (/*@__PURE__*/$parcel$interopDefault($89a7a8309184bc24$exports))), "toggle"),
                                        checked: isLedger ?? false,
                                        readOnly: true
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                        children: "Ledger wallet"
                                    })
                                ]
                            })
                        ]
                    })
                })
            })
        })
    });
};



var $c848ab0418c3e881$exports = {};

$parcel$export($c848ab0418c3e881$exports, "button-container", () => $c848ab0418c3e881$export$4f7a98834621a1a, (v) => $c848ab0418c3e881$export$4f7a98834621a1a = v);
$parcel$export($c848ab0418c3e881$exports, "checkmark", () => $c848ab0418c3e881$export$292abbf31ed842a, (v) => $c848ab0418c3e881$export$292abbf31ed842a = v);
$parcel$export($c848ab0418c3e881$exports, "connect-button", () => $c848ab0418c3e881$export$11f55cbb8ac598a1, (v) => $c848ab0418c3e881$export$11f55cbb8ac598a1 = v);
$parcel$export($c848ab0418c3e881$exports, "connection", () => $c848ab0418c3e881$export$412d2991813e589a, (v) => $c848ab0418c3e881$export$412d2991813e589a = v);
$parcel$export($c848ab0418c3e881$exports, "container", () => $c848ab0418c3e881$export$34e0f9847d4c02dd, (v) => $c848ab0418c3e881$export$34e0f9847d4c02dd = v);
$parcel$export($c848ab0418c3e881$exports, "content", () => $c848ab0418c3e881$export$a7db06668cad9adb, (v) => $c848ab0418c3e881$export$a7db06668cad9adb = v);
$parcel$export($c848ab0418c3e881$exports, "dashboard", () => $c848ab0418c3e881$export$a5f98448b9315739, (v) => $c848ab0418c3e881$export$a5f98448b9315739 = v);
$parcel$export($c848ab0418c3e881$exports, "developed-by", () => $c848ab0418c3e881$export$8eab4bf734fdd792, (v) => $c848ab0418c3e881$export$8eab4bf734fdd792 = v);
$parcel$export($c848ab0418c3e881$exports, "limited-height", () => $c848ab0418c3e881$export$5a2bd42ef1303ab2, (v) => $c848ab0418c3e881$export$5a2bd42ef1303ab2 = v);
$parcel$export($c848ab0418c3e881$exports, "logo", () => $c848ab0418c3e881$export$db3c28d99448dcff, (v) => $c848ab0418c3e881$export$db3c28d99448dcff = v);
$parcel$export($c848ab0418c3e881$exports, "permission", () => $c848ab0418c3e881$export$ff398d236afe1183, (v) => $c848ab0418c3e881$export$ff398d236afe1183 = v);
$parcel$export($c848ab0418c3e881$exports, "player-view", () => $c848ab0418c3e881$export$25018de93ad96661, (v) => $c848ab0418c3e881$export$25018de93ad96661 = v);
$parcel$export($c848ab0418c3e881$exports, "terms", () => $c848ab0418c3e881$export$8a21ba990ca4a7cb, (v) => $c848ab0418c3e881$export$8a21ba990ca4a7cb = v);
var $c848ab0418c3e881$export$4f7a98834621a1a;
var $c848ab0418c3e881$export$292abbf31ed842a;
var $c848ab0418c3e881$export$11f55cbb8ac598a1;
var $c848ab0418c3e881$export$412d2991813e589a;
var $c848ab0418c3e881$export$34e0f9847d4c02dd;
var $c848ab0418c3e881$export$a7db06668cad9adb;
var $c848ab0418c3e881$export$a5f98448b9315739;
var $c848ab0418c3e881$export$8eab4bf734fdd792;
var $c848ab0418c3e881$export$5a2bd42ef1303ab2;
var $c848ab0418c3e881$export$db3c28d99448dcff;
var $c848ab0418c3e881$export$ff398d236afe1183;
var $c848ab0418c3e881$export$25018de93ad96661;
var $c848ab0418c3e881$export$8a21ba990ca4a7cb;
$c848ab0418c3e881$export$4f7a98834621a1a = `_4xkGq_button-container`;
$c848ab0418c3e881$export$292abbf31ed842a = `_4xkGq_checkmark`;
$c848ab0418c3e881$export$11f55cbb8ac598a1 = `_4xkGq_connect-button`;
$c848ab0418c3e881$export$412d2991813e589a = `_4xkGq_connection`;
$c848ab0418c3e881$export$34e0f9847d4c02dd = `_4xkGq_container`;
$c848ab0418c3e881$export$a7db06668cad9adb = `_4xkGq_content`;
$c848ab0418c3e881$export$a5f98448b9315739 = `_4xkGq_dashboard`;
$c848ab0418c3e881$export$8eab4bf734fdd792 = `_4xkGq_developed-by`;
$c848ab0418c3e881$export$5a2bd42ef1303ab2 = `_4xkGq_limited-height`;
$c848ab0418c3e881$export$db3c28d99448dcff = `_4xkGq_logo`;
$c848ab0418c3e881$export$ff398d236afe1183 = `_4xkGq_permission`;
$c848ab0418c3e881$export$25018de93ad96661 = `_4xkGq_player-view`;
$c848ab0418c3e881$export$8a21ba990ca4a7cb = `_4xkGq_terms`;





parcelRequire("acw62");

var $e29b61f5a388419e$exports = {};

$parcel$export($e29b61f5a388419e$exports, "background", () => $e29b61f5a388419e$export$8ce1fd94bee2f412, (v) => $e29b61f5a388419e$export$8ce1fd94bee2f412 = v);
$parcel$export($e29b61f5a388419e$exports, "bg-bottom", () => $e29b61f5a388419e$export$ea448b8ccea09295, (v) => $e29b61f5a388419e$export$ea448b8ccea09295 = v);
$parcel$export($e29b61f5a388419e$exports, "bg-middle", () => $e29b61f5a388419e$export$ce8ba153cd42f7bc, (v) => $e29b61f5a388419e$export$ce8ba153cd42f7bc = v);
$parcel$export($e29b61f5a388419e$exports, "bg-top", () => $e29b61f5a388419e$export$11da0b5e0781449c, (v) => $e29b61f5a388419e$export$11da0b5e0781449c = v);
$parcel$export($e29b61f5a388419e$exports, "gradient", () => $e29b61f5a388419e$export$f7d09cddc76f277f, (v) => $e29b61f5a388419e$export$f7d09cddc76f277f = v);
$parcel$export($e29b61f5a388419e$exports, "high", () => $e29b61f5a388419e$export$7cb505ef3217a5c4, (v) => $e29b61f5a388419e$export$7cb505ef3217a5c4 = v);
var $e29b61f5a388419e$export$8ce1fd94bee2f412;
var $e29b61f5a388419e$export$ea448b8ccea09295;
var $e29b61f5a388419e$export$ce8ba153cd42f7bc;
var $e29b61f5a388419e$export$11da0b5e0781449c;
var $e29b61f5a388419e$export$f7d09cddc76f277f;
var $e29b61f5a388419e$export$7cb505ef3217a5c4;
$e29b61f5a388419e$export$8ce1fd94bee2f412 = `DTLfIa_background`;
$e29b61f5a388419e$export$ea448b8ccea09295 = `DTLfIa_bg-bottom`;
$e29b61f5a388419e$export$ce8ba153cd42f7bc = `DTLfIa_bg-middle`;
$e29b61f5a388419e$export$11da0b5e0781449c = `DTLfIa_bg-top`;
$e29b61f5a388419e$export$f7d09cddc76f277f = `DTLfIa_gradient`;
$e29b61f5a388419e$export$7cb505ef3217a5c4 = `DTLfIa_high`;


const $d476126f9afdc959$export$668799e4797757a8 = ({ className: className, ...props })=>{
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: (0, $9805619f03ed02ef$export$91884aa883243770)((0, (/*@__PURE__*/$parcel$interopDefault($e29b61f5a388419e$exports))), `background ${className}`),
        ...props,
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: (0, $9805619f03ed02ef$export$91884aa883243770)((0, (/*@__PURE__*/$parcel$interopDefault($e29b61f5a388419e$exports))), "bg-top"),
                style: {
                    backgroundImage: `url('${(0, $0426e2dd5e0de94d$export$24af3971dd36b33f)}/ui/main-bg-top.png')`
                }
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: (0, $9805619f03ed02ef$export$91884aa883243770)((0, (/*@__PURE__*/$parcel$interopDefault($e29b61f5a388419e$exports))), "gradient")
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: (0, $9805619f03ed02ef$export$91884aa883243770)((0, (/*@__PURE__*/$parcel$interopDefault($e29b61f5a388419e$exports))), "bg-middle"),
                style: {
                    backgroundImage: `url('${(0, $0426e2dd5e0de94d$export$24af3971dd36b33f)}/ui/main-bg-middle.png')`
                }
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: (0, $9805619f03ed02ef$export$91884aa883243770)((0, (/*@__PURE__*/$parcel$interopDefault($e29b61f5a388419e$exports))), "bg-bottom"),
                style: {
                    backgroundImage: `url('${(0, $0426e2dd5e0de94d$export$24af3971dd36b33f)}/ui/main-bg-bottom.png')`
                }
            })
        ]
    });
};


const $d3ab93f8f48fad14$export$fedd53519a0e2bce = ()=>{
    const { state: { sessionToken: sessionToken, showConnectModal: showConnectModal, accountInfo: accountInfo }, dispatch: dispatch } = (0, $c25623cc446ec3c6$export$ac8576a9912be18c)();
    const [timeoutId, setTimeoutId] = (0, $acw62.useState)();
    const [termsChecked, setTermsChecked] = (0, $acw62.useState)();
    const closeConnectModal = ()=>{
        dispatch({
            type: "SET_SHOW_CONNECT_MODAL",
            showConnectModal: false
        });
    };
    (0, $acw62.useEffect)(()=>{
        if (!sessionToken) {
            if ((0, $b3b1baf40467424d$export$745043c7dc65e495).clearGame) (0, $b3b1baf40467424d$export$745043c7dc65e495).clearGame();
            return;
        }
        (0, $35a528e84618b070$export$a5453f73d7944b35)(()=>{
            if ((0, $b3b1baf40467424d$export$745043c7dc65e495).disconnect) (0, $b3b1baf40467424d$export$745043c7dc65e495).disconnect();
        }).then((res)=>{
            dispatch({
                type: "SET_TWITTER_USERNAME",
                twitterUsername: res?.twitter
            });
            dispatch({
                type: "SET_DISCORD_USERNAME",
                discordUsername: res?.discord
            });
        });
        const interval = setInterval(async ()=>{
            const res = await (0, $35a528e84618b070$export$a5453f73d7944b35)();
            dispatch({
                type: "SET_TWITTER_USERNAME",
                twitterUsername: res?.twitter
            });
            dispatch({
                type: "SET_DISCORD_USERNAME",
                discordUsername: res?.discord
            });
        }, 360000);
        return ()=>{
            clearInterval(interval);
        };
    }, [
        sessionToken
    ]);
    (0, $acw62.useEffect)(()=>{
        if (!accountInfo || timeoutId) return;
        const timeDiff = accountInfo.energy.lastUpdate + 7200000 - Date.now();
        setTimeoutId(setTimeout(async ()=>{
            if ((0, $b3b1baf40467424d$export$745043c7dc65e495).refreshAccountInfo) {
                await (0, $b3b1baf40467424d$export$745043c7dc65e495).refreshAccountInfo();
                setTimeoutId(undefined);
            }
        }, timeDiff + 5000));
    }, [
        accountInfo,
        timeoutId
    ]);
    const openTerms = ()=>{
        window.open("https://drive.google.com/file/d/1_yHdH2S2XdiYRTfg613mYH0DOXLBqwx2/view", undefined, "popup");
    };
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: (0, $9805619f03ed02ef$export$91884aa883243770)((0, (/*@__PURE__*/$parcel$interopDefault($c848ab0418c3e881$exports))), "dashboard"),
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: (0, $9805619f03ed02ef$export$91884aa883243770)((0, (/*@__PURE__*/$parcel$interopDefault($c848ab0418c3e881$exports))), "container limited-height"),
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                    className: (0, $9805619f03ed02ef$export$91884aa883243770)((0, (/*@__PURE__*/$parcel$interopDefault($c848ab0418c3e881$exports))), "content overflow-hidden phone-without-padding"),
                    children: sessionToken ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7939e29d663dd3ed$export$910ae8079b2c2852), {}) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: (0, $9805619f03ed02ef$export$91884aa883243770)((0, (/*@__PURE__*/$parcel$interopDefault($c848ab0418c3e881$exports))), "connection"),
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $d476126f9afdc959$export$668799e4797757a8), {}),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                                className: (0, $9805619f03ed02ef$export$91884aa883243770)((0, (/*@__PURE__*/$parcel$interopDefault($c848ab0418c3e881$exports))), "logo"),
                                src: "https://cdn.piratesquadnft.com/clients/oogy-blast/game/visual/ui/logo-atlas.png",
                                alt: "logo"
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: (0, $9805619f03ed02ef$export$91884aa883243770)((0, (/*@__PURE__*/$parcel$interopDefault($c848ab0418c3e881$exports))), "button-container"),
                                children: [
                                    "Connect to play",
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $f0a80ffa61d846a8$export$79b5060180039794), {
                                        className: (0, $9805619f03ed02ef$export$91884aa883243770)((0, (/*@__PURE__*/$parcel$interopDefault($c848ab0418c3e881$exports))), "connect-button"),
                                        disabled: !termsChecked
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("label", {
                                        className: (0, $9805619f03ed02ef$export$91884aa883243770)((0, (/*@__PURE__*/$parcel$interopDefault($c848ab0418c3e881$exports))), "terms"),
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                                                type: "checkbox",
                                                checked: termsChecked,
                                                onChange: (e)=>setTermsChecked(e.target.checked)
                                            }),
                                            "agree to ",
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("a", {
                                                href: "#",
                                                onClick: openTerms,
                                                children: "T&Cs"
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                className: (0, $9805619f03ed02ef$export$91884aa883243770)((0, (/*@__PURE__*/$parcel$interopDefault($c848ab0418c3e881$exports))), "checkmark")
                                            })
                                        ]
                                    })
                                ]
                            })
                        ]
                    })
                })
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $85353414fe7b2bf6$export$b33e7092bdf63f3f), {
                show: showConnectModal,
                onHide: closeConnectModal,
                onClickBackground: closeConnectModal
            })
        ]
    });
};




var $acw62 = parcelRequire("acw62");








var $8ea82a4cc4d506e8$exports = {};

$parcel$export($8ea82a4cc4d506e8$exports, "continue-menu", () => $8ea82a4cc4d506e8$export$b214608bbf199086, (v) => $8ea82a4cc4d506e8$export$b214608bbf199086 = v);
$parcel$export($8ea82a4cc4d506e8$exports, "fade-in", () => $8ea82a4cc4d506e8$export$c95979b960f4acea, (v) => $8ea82a4cc4d506e8$export$c95979b960f4acea = v);
$parcel$export($8ea82a4cc4d506e8$exports, "fadeIn", () => $8ea82a4cc4d506e8$export$82e6205b15e6c637, (v) => $8ea82a4cc4d506e8$export$82e6205b15e6c637 = v);
$parcel$export($8ea82a4cc4d506e8$exports, "game", () => $8ea82a4cc4d506e8$export$119d2a93e2780362, (v) => $8ea82a4cc4d506e8$export$119d2a93e2780362 = v);
$parcel$export($8ea82a4cc4d506e8$exports, "hidden", () => $8ea82a4cc4d506e8$export$73920f18ca706874, (v) => $8ea82a4cc4d506e8$export$73920f18ca706874 = v);
$parcel$export($8ea82a4cc4d506e8$exports, "main-ui", () => $8ea82a4cc4d506e8$export$6d74761ad3ff486d, (v) => $8ea82a4cc4d506e8$export$6d74761ad3ff486d = v);
$parcel$export($8ea82a4cc4d506e8$exports, "navigation", () => $8ea82a4cc4d506e8$export$428e7c787d57587d, (v) => $8ea82a4cc4d506e8$export$428e7c787d57587d = v);
$parcel$export($8ea82a4cc4d506e8$exports, "pause-menu", () => $8ea82a4cc4d506e8$export$881e48a3dd2e86b8, (v) => $8ea82a4cc4d506e8$export$881e48a3dd2e86b8 = v);
$parcel$export($8ea82a4cc4d506e8$exports, "player", () => $8ea82a4cc4d506e8$export$615455393ee443ca, (v) => $8ea82a4cc4d506e8$export$615455393ee443ca = v);
$parcel$export($8ea82a4cc4d506e8$exports, "screen-size", () => $8ea82a4cc4d506e8$export$5f0cb82fdce0f48f, (v) => $8ea82a4cc4d506e8$export$5f0cb82fdce0f48f = v);
$parcel$export($8ea82a4cc4d506e8$exports, "top-bar", () => $8ea82a4cc4d506e8$export$e6bd3ce1c3980ae2, (v) => $8ea82a4cc4d506e8$export$e6bd3ce1c3980ae2 = v);
$parcel$export($8ea82a4cc4d506e8$exports, "ui-container", () => $8ea82a4cc4d506e8$export$96b45b172eb0d9f, (v) => $8ea82a4cc4d506e8$export$96b45b172eb0d9f = v);
var $8ea82a4cc4d506e8$export$b214608bbf199086;
var $8ea82a4cc4d506e8$export$c95979b960f4acea;
var $8ea82a4cc4d506e8$export$82e6205b15e6c637;
var $8ea82a4cc4d506e8$export$119d2a93e2780362;
var $8ea82a4cc4d506e8$export$73920f18ca706874;
var $8ea82a4cc4d506e8$export$6d74761ad3ff486d;
var $8ea82a4cc4d506e8$export$428e7c787d57587d;
var $8ea82a4cc4d506e8$export$881e48a3dd2e86b8;
var $8ea82a4cc4d506e8$export$615455393ee443ca;
var $8ea82a4cc4d506e8$export$5f0cb82fdce0f48f;
var $8ea82a4cc4d506e8$export$e6bd3ce1c3980ae2;
var $8ea82a4cc4d506e8$export$96b45b172eb0d9f;
$8ea82a4cc4d506e8$export$b214608bbf199086 = `elvQeq_continue-menu`;
$8ea82a4cc4d506e8$export$c95979b960f4acea = `elvQeq_fade-in`;
$8ea82a4cc4d506e8$export$82e6205b15e6c637 = `elvQeq_fadeIn`;
$8ea82a4cc4d506e8$export$82e6205b15e6c637;
$8ea82a4cc4d506e8$export$119d2a93e2780362 = `elvQeq_game`;
$8ea82a4cc4d506e8$export$73920f18ca706874 = `elvQeq_hidden`;
$8ea82a4cc4d506e8$export$6d74761ad3ff486d = `elvQeq_main-ui`;
$8ea82a4cc4d506e8$export$428e7c787d57587d = `elvQeq_navigation`;
$8ea82a4cc4d506e8$export$881e48a3dd2e86b8 = `elvQeq_pause-menu`;
$8ea82a4cc4d506e8$export$615455393ee443ca = `elvQeq_player`;
$8ea82a4cc4d506e8$export$5f0cb82fdce0f48f = `elvQeq_screen-size`;
$8ea82a4cc4d506e8$export$e6bd3ce1c3980ae2 = `elvQeq_top-bar`;
$8ea82a4cc4d506e8$export$96b45b172eb0d9f = `elvQeq_ui-container`;


let $c762494680c35543$export$9544d5bb712b01ea;
function $c762494680c35543$export$7fbc60ba12697434(sound) {
    $c762494680c35543$export$9544d5bb712b01ea = sound;
    return sound;
}
function $c762494680c35543$export$8bedcca5bbd73999() {
    return $c762494680c35543$export$9544d5bb712b01ea;
}


var $0fa4b07f86297abd$export$83401e34d5e11bf4 = /* @__PURE__ */ ((ENV2)=>(ENV2[ENV2.WEBGL_LEGACY = 0] = "WEBGL_LEGACY", ENV2[ENV2.WEBGL = 1] = "WEBGL", ENV2[ENV2.WEBGL2 = 2] = "WEBGL2", ENV2))($0fa4b07f86297abd$export$83401e34d5e11bf4 || {}), $0fa4b07f86297abd$export$747c566515e2a1d9 = /* @__PURE__ */ ((RENDERER_TYPE2)=>(RENDERER_TYPE2[RENDERER_TYPE2.UNKNOWN = 0] = "UNKNOWN", RENDERER_TYPE2[RENDERER_TYPE2.WEBGL = 1] = "WEBGL", RENDERER_TYPE2[RENDERER_TYPE2.CANVAS = 2] = "CANVAS", RENDERER_TYPE2))($0fa4b07f86297abd$export$747c566515e2a1d9 || {}), $0fa4b07f86297abd$export$c07ea8ac66dac49 = /* @__PURE__ */ ((BUFFER_BITS2)=>(BUFFER_BITS2[BUFFER_BITS2.COLOR = 16384] = "COLOR", BUFFER_BITS2[BUFFER_BITS2.DEPTH = 256] = "DEPTH", BUFFER_BITS2[BUFFER_BITS2.STENCIL = 1024] = "STENCIL", BUFFER_BITS2))($0fa4b07f86297abd$export$c07ea8ac66dac49 || {}), $0fa4b07f86297abd$export$f821c68fe9beaecf = /* @__PURE__ */ ((BLEND_MODES2)=>(BLEND_MODES2[BLEND_MODES2.NORMAL = 0] = "NORMAL", BLEND_MODES2[BLEND_MODES2.ADD = 1] = "ADD", BLEND_MODES2[BLEND_MODES2.MULTIPLY = 2] = "MULTIPLY", BLEND_MODES2[BLEND_MODES2.SCREEN = 3] = "SCREEN", BLEND_MODES2[BLEND_MODES2.OVERLAY = 4] = "OVERLAY", BLEND_MODES2[BLEND_MODES2.DARKEN = 5] = "DARKEN", BLEND_MODES2[BLEND_MODES2.LIGHTEN = 6] = "LIGHTEN", BLEND_MODES2[BLEND_MODES2.COLOR_DODGE = 7] = "COLOR_DODGE", BLEND_MODES2[BLEND_MODES2.COLOR_BURN = 8] = "COLOR_BURN", BLEND_MODES2[BLEND_MODES2.HARD_LIGHT = 9] = "HARD_LIGHT", BLEND_MODES2[BLEND_MODES2.SOFT_LIGHT = 10] = "SOFT_LIGHT", BLEND_MODES2[BLEND_MODES2.DIFFERENCE = 11] = "DIFFERENCE", BLEND_MODES2[BLEND_MODES2.EXCLUSION = 12] = "EXCLUSION", BLEND_MODES2[BLEND_MODES2.HUE = 13] = "HUE", BLEND_MODES2[BLEND_MODES2.SATURATION = 14] = "SATURATION", BLEND_MODES2[BLEND_MODES2.COLOR = 15] = "COLOR", BLEND_MODES2[BLEND_MODES2.LUMINOSITY = 16] = "LUMINOSITY", BLEND_MODES2[BLEND_MODES2.NORMAL_NPM = 17] = "NORMAL_NPM", BLEND_MODES2[BLEND_MODES2.ADD_NPM = 18] = "ADD_NPM", BLEND_MODES2[BLEND_MODES2.SCREEN_NPM = 19] = "SCREEN_NPM", BLEND_MODES2[BLEND_MODES2.NONE = 20] = "NONE", BLEND_MODES2[BLEND_MODES2.SRC_OVER = 0] = "SRC_OVER", BLEND_MODES2[BLEND_MODES2.SRC_IN = 21] = "SRC_IN", BLEND_MODES2[BLEND_MODES2.SRC_OUT = 22] = "SRC_OUT", BLEND_MODES2[BLEND_MODES2.SRC_ATOP = 23] = "SRC_ATOP", BLEND_MODES2[BLEND_MODES2.DST_OVER = 24] = "DST_OVER", BLEND_MODES2[BLEND_MODES2.DST_IN = 25] = "DST_IN", BLEND_MODES2[BLEND_MODES2.DST_OUT = 26] = "DST_OUT", BLEND_MODES2[BLEND_MODES2.DST_ATOP = 27] = "DST_ATOP", BLEND_MODES2[BLEND_MODES2.ERASE = 26] = "ERASE", BLEND_MODES2[BLEND_MODES2.SUBTRACT = 28] = "SUBTRACT", BLEND_MODES2[BLEND_MODES2.XOR = 29] = "XOR", BLEND_MODES2))($0fa4b07f86297abd$export$f821c68fe9beaecf || {}), $0fa4b07f86297abd$export$91100badd8469338 = /* @__PURE__ */ ((DRAW_MODES2)=>(DRAW_MODES2[DRAW_MODES2.POINTS = 0] = "POINTS", DRAW_MODES2[DRAW_MODES2.LINES = 1] = "LINES", DRAW_MODES2[DRAW_MODES2.LINE_LOOP = 2] = "LINE_LOOP", DRAW_MODES2[DRAW_MODES2.LINE_STRIP = 3] = "LINE_STRIP", DRAW_MODES2[DRAW_MODES2.TRIANGLES = 4] = "TRIANGLES", DRAW_MODES2[DRAW_MODES2.TRIANGLE_STRIP = 5] = "TRIANGLE_STRIP", DRAW_MODES2[DRAW_MODES2.TRIANGLE_FAN = 6] = "TRIANGLE_FAN", DRAW_MODES2))($0fa4b07f86297abd$export$91100badd8469338 || {}), $0fa4b07f86297abd$export$e9c4b7b466aa8274 = /* @__PURE__ */ ((FORMATS2)=>(FORMATS2[FORMATS2.RGBA = 6408] = "RGBA", FORMATS2[FORMATS2.RGB = 6407] = "RGB", FORMATS2[FORMATS2.RG = 33319] = "RG", FORMATS2[FORMATS2.RED = 6403] = "RED", FORMATS2[FORMATS2.RGBA_INTEGER = 36249] = "RGBA_INTEGER", FORMATS2[FORMATS2.RGB_INTEGER = 36248] = "RGB_INTEGER", FORMATS2[FORMATS2.RG_INTEGER = 33320] = "RG_INTEGER", FORMATS2[FORMATS2.RED_INTEGER = 36244] = "RED_INTEGER", FORMATS2[FORMATS2.ALPHA = 6406] = "ALPHA", FORMATS2[FORMATS2.LUMINANCE = 6409] = "LUMINANCE", FORMATS2[FORMATS2.LUMINANCE_ALPHA = 6410] = "LUMINANCE_ALPHA", FORMATS2[FORMATS2.DEPTH_COMPONENT = 6402] = "DEPTH_COMPONENT", FORMATS2[FORMATS2.DEPTH_STENCIL = 34041] = "DEPTH_STENCIL", FORMATS2))($0fa4b07f86297abd$export$e9c4b7b466aa8274 || {}), $0fa4b07f86297abd$export$d1ff3caf57547dc5 = /* @__PURE__ */ ((TARGETS2)=>(TARGETS2[TARGETS2.TEXTURE_2D = 3553] = "TEXTURE_2D", TARGETS2[TARGETS2.TEXTURE_CUBE_MAP = 34067] = "TEXTURE_CUBE_MAP", TARGETS2[TARGETS2.TEXTURE_2D_ARRAY = 35866] = "TEXTURE_2D_ARRAY", TARGETS2[TARGETS2.TEXTURE_CUBE_MAP_POSITIVE_X = 34069] = "TEXTURE_CUBE_MAP_POSITIVE_X", TARGETS2[TARGETS2.TEXTURE_CUBE_MAP_NEGATIVE_X = 34070] = "TEXTURE_CUBE_MAP_NEGATIVE_X", TARGETS2[TARGETS2.TEXTURE_CUBE_MAP_POSITIVE_Y = 34071] = "TEXTURE_CUBE_MAP_POSITIVE_Y", TARGETS2[TARGETS2.TEXTURE_CUBE_MAP_NEGATIVE_Y = 34072] = "TEXTURE_CUBE_MAP_NEGATIVE_Y", TARGETS2[TARGETS2.TEXTURE_CUBE_MAP_POSITIVE_Z = 34073] = "TEXTURE_CUBE_MAP_POSITIVE_Z", TARGETS2[TARGETS2.TEXTURE_CUBE_MAP_NEGATIVE_Z = 34074] = "TEXTURE_CUBE_MAP_NEGATIVE_Z", TARGETS2))($0fa4b07f86297abd$export$d1ff3caf57547dc5 || {}), $0fa4b07f86297abd$export$426db7a6155b7a80 = /* @__PURE__ */ ((TYPES2)=>(TYPES2[TYPES2.UNSIGNED_BYTE = 5121] = "UNSIGNED_BYTE", TYPES2[TYPES2.UNSIGNED_SHORT = 5123] = "UNSIGNED_SHORT", TYPES2[TYPES2.UNSIGNED_SHORT_5_6_5 = 33635] = "UNSIGNED_SHORT_5_6_5", TYPES2[TYPES2.UNSIGNED_SHORT_4_4_4_4 = 32819] = "UNSIGNED_SHORT_4_4_4_4", TYPES2[TYPES2.UNSIGNED_SHORT_5_5_5_1 = 32820] = "UNSIGNED_SHORT_5_5_5_1", TYPES2[TYPES2.UNSIGNED_INT = 5125] = "UNSIGNED_INT", TYPES2[TYPES2.UNSIGNED_INT_10F_11F_11F_REV = 35899] = "UNSIGNED_INT_10F_11F_11F_REV", TYPES2[TYPES2.UNSIGNED_INT_2_10_10_10_REV = 33640] = "UNSIGNED_INT_2_10_10_10_REV", TYPES2[TYPES2.UNSIGNED_INT_24_8 = 34042] = "UNSIGNED_INT_24_8", TYPES2[TYPES2.UNSIGNED_INT_5_9_9_9_REV = 35902] = "UNSIGNED_INT_5_9_9_9_REV", TYPES2[TYPES2.BYTE = 5120] = "BYTE", TYPES2[TYPES2.SHORT = 5122] = "SHORT", TYPES2[TYPES2.INT = 5124] = "INT", TYPES2[TYPES2.FLOAT = 5126] = "FLOAT", TYPES2[TYPES2.FLOAT_32_UNSIGNED_INT_24_8_REV = 36269] = "FLOAT_32_UNSIGNED_INT_24_8_REV", TYPES2[TYPES2.HALF_FLOAT = 36193] = "HALF_FLOAT", TYPES2))($0fa4b07f86297abd$export$426db7a6155b7a80 || {}), $0fa4b07f86297abd$export$8ee8af3637d728f5 = /* @__PURE__ */ ((SAMPLER_TYPES2)=>(SAMPLER_TYPES2[SAMPLER_TYPES2.FLOAT = 0] = "FLOAT", SAMPLER_TYPES2[SAMPLER_TYPES2.INT = 1] = "INT", SAMPLER_TYPES2[SAMPLER_TYPES2.UINT = 2] = "UINT", SAMPLER_TYPES2))($0fa4b07f86297abd$export$8ee8af3637d728f5 || {}), $0fa4b07f86297abd$export$6b734c6a0bba8473 = /* @__PURE__ */ ((SCALE_MODES2)=>(SCALE_MODES2[SCALE_MODES2.NEAREST = 0] = "NEAREST", SCALE_MODES2[SCALE_MODES2.LINEAR = 1] = "LINEAR", SCALE_MODES2))($0fa4b07f86297abd$export$6b734c6a0bba8473 || {}), $0fa4b07f86297abd$export$2ab395cfb0dd2f0f = /* @__PURE__ */ ((WRAP_MODES2)=>(WRAP_MODES2[WRAP_MODES2.CLAMP = 33071] = "CLAMP", WRAP_MODES2[WRAP_MODES2.REPEAT = 10497] = "REPEAT", WRAP_MODES2[WRAP_MODES2.MIRRORED_REPEAT = 33648] = "MIRRORED_REPEAT", WRAP_MODES2))($0fa4b07f86297abd$export$2ab395cfb0dd2f0f || {}), $0fa4b07f86297abd$export$16f6fb5da874bbfd = /* @__PURE__ */ ((MIPMAP_MODES2)=>(MIPMAP_MODES2[MIPMAP_MODES2.OFF = 0] = "OFF", MIPMAP_MODES2[MIPMAP_MODES2.POW2 = 1] = "POW2", MIPMAP_MODES2[MIPMAP_MODES2.ON = 2] = "ON", MIPMAP_MODES2[MIPMAP_MODES2.ON_MANUAL = 3] = "ON_MANUAL", MIPMAP_MODES2))($0fa4b07f86297abd$export$16f6fb5da874bbfd || {}), $0fa4b07f86297abd$export$d56550d454401b73 = /* @__PURE__ */ ((ALPHA_MODES2)=>(ALPHA_MODES2[ALPHA_MODES2.NPM = 0] = "NPM", ALPHA_MODES2[ALPHA_MODES2.UNPACK = 1] = "UNPACK", ALPHA_MODES2[ALPHA_MODES2.PMA = 2] = "PMA", ALPHA_MODES2[ALPHA_MODES2.NO_PREMULTIPLIED_ALPHA = 0] = "NO_PREMULTIPLIED_ALPHA", ALPHA_MODES2[ALPHA_MODES2.PREMULTIPLY_ON_UPLOAD = 1] = "PREMULTIPLY_ON_UPLOAD", ALPHA_MODES2[ALPHA_MODES2.PREMULTIPLIED_ALPHA = 2] = "PREMULTIPLIED_ALPHA", ALPHA_MODES2))($0fa4b07f86297abd$export$d56550d454401b73 || {}), $0fa4b07f86297abd$export$784901839554cbc3 = /* @__PURE__ */ ((CLEAR_MODES2)=>(CLEAR_MODES2[CLEAR_MODES2.NO = 0] = "NO", CLEAR_MODES2[CLEAR_MODES2.YES = 1] = "YES", CLEAR_MODES2[CLEAR_MODES2.AUTO = 2] = "AUTO", CLEAR_MODES2[CLEAR_MODES2.BLEND = 0] = "BLEND", CLEAR_MODES2[CLEAR_MODES2.CLEAR = 1] = "CLEAR", CLEAR_MODES2[CLEAR_MODES2.BLIT = 2] = "BLIT", CLEAR_MODES2))($0fa4b07f86297abd$export$784901839554cbc3 || {}), $0fa4b07f86297abd$export$5c6ba89c1f52b344 = /* @__PURE__ */ ((GC_MODES2)=>(GC_MODES2[GC_MODES2.AUTO = 0] = "AUTO", GC_MODES2[GC_MODES2.MANUAL = 1] = "MANUAL", GC_MODES2))($0fa4b07f86297abd$export$5c6ba89c1f52b344 || {}), $0fa4b07f86297abd$export$d6d3992f3becc879 = /* @__PURE__ */ ((PRECISION2)=>(PRECISION2.LOW = "lowp", PRECISION2.MEDIUM = "mediump", PRECISION2.HIGH = "highp", PRECISION2))($0fa4b07f86297abd$export$d6d3992f3becc879 || {}), $0fa4b07f86297abd$export$dbbea138c5d144 = /* @__PURE__ */ ((MASK_TYPES2)=>(MASK_TYPES2[MASK_TYPES2.NONE = 0] = "NONE", MASK_TYPES2[MASK_TYPES2.SCISSOR = 1] = "SCISSOR", MASK_TYPES2[MASK_TYPES2.STENCIL = 2] = "STENCIL", MASK_TYPES2[MASK_TYPES2.SPRITE = 3] = "SPRITE", MASK_TYPES2[MASK_TYPES2.COLOR = 4] = "COLOR", MASK_TYPES2))($0fa4b07f86297abd$export$dbbea138c5d144 || {}), $0fa4b07f86297abd$export$c306f8e81b8d1ca7 = /* @__PURE__ */ ((COLOR_MASK_BITS2)=>(COLOR_MASK_BITS2[COLOR_MASK_BITS2.RED = 1] = "RED", COLOR_MASK_BITS2[COLOR_MASK_BITS2.GREEN = 2] = "GREEN", COLOR_MASK_BITS2[COLOR_MASK_BITS2.BLUE = 4] = "BLUE", COLOR_MASK_BITS2[COLOR_MASK_BITS2.ALPHA = 8] = "ALPHA", COLOR_MASK_BITS2))($0fa4b07f86297abd$export$c306f8e81b8d1ca7 || {}), $0fa4b07f86297abd$export$1eadd657d5acc2f2 = /* @__PURE__ */ ((MSAA_QUALITY2)=>(MSAA_QUALITY2[MSAA_QUALITY2.NONE = 0] = "NONE", MSAA_QUALITY2[MSAA_QUALITY2.LOW = 2] = "LOW", MSAA_QUALITY2[MSAA_QUALITY2.MEDIUM = 4] = "MEDIUM", MSAA_QUALITY2[MSAA_QUALITY2.HIGH = 8] = "HIGH", MSAA_QUALITY2))($0fa4b07f86297abd$export$1eadd657d5acc2f2 || {}), $0fa4b07f86297abd$export$b595a7e482202b96 = /* @__PURE__ */ ((BUFFER_TYPE2)=>(BUFFER_TYPE2[BUFFER_TYPE2.ELEMENT_ARRAY_BUFFER = 34963] = "ELEMENT_ARRAY_BUFFER", BUFFER_TYPE2[BUFFER_TYPE2.ARRAY_BUFFER = 34962] = "ARRAY_BUFFER", BUFFER_TYPE2[BUFFER_TYPE2.UNIFORM_BUFFER = 35345] = "UNIFORM_BUFFER", BUFFER_TYPE2))($0fa4b07f86297abd$export$b595a7e482202b96 || {});


const $f26c3d8ebd9548ff$export$e467cc3399500025 = {
    /**
   * Creates a canvas element of the given size.
   * This canvas is created using the browser's native canvas element.
   * @param width - width of the canvas
   * @param height - height of the canvas
   */ createCanvas: (width, height)=>{
        const canvas = document.createElement("canvas");
        return canvas.width = width, canvas.height = height, canvas;
    },
    getCanvasRenderingContext2D: ()=>CanvasRenderingContext2D,
    getWebGLRenderingContext: ()=>WebGLRenderingContext,
    getNavigator: ()=>navigator,
    getBaseUrl: ()=>document.baseURI ?? window.location.href,
    getFontFaceSet: ()=>document.fonts,
    fetch: (url, options)=>fetch(url, options),
    parseXML: (xml)=>new DOMParser().parseFromString(xml, "text/xml")
};







const $2808efac47e52be0$export$a5a6e0b888b2c992 = {
    /**
   * This adapter is used to call methods that are platform dependent.
   * For example `document.createElement` only runs on the web but fails in node environments.
   * This allows us to support more platforms by abstracting away specific implementations per platform.
   *
   * By default the adapter is set to work in the browser. However you can create your own
   * by implementing the `IAdapter` interface. See `IAdapter` for more information.
   * @name ADAPTER
   * @memberof PIXI.settings
   * @type {PIXI.IAdapter}
   * @default PIXI.BrowserAdapter
   */ ADAPTER: (0, $f26c3d8ebd9548ff$export$e467cc3399500025),
    /**
   * Default resolution / device pixel ratio of the renderer.
   * @static
   * @name RESOLUTION
   * @memberof PIXI.settings
   * @type {number}
   * @default 1
   */ RESOLUTION: 1,
    /**
   * Enables bitmap creation before image load. This feature is experimental.
   * @static
   * @name CREATE_IMAGE_BITMAP
   * @memberof PIXI.settings
   * @type {boolean}
   * @default false
   */ CREATE_IMAGE_BITMAP: !1,
    /**
   * If true PixiJS will Math.floor() x/y values when rendering, stopping pixel interpolation.
   * Advantages can include sharper image quality (like text) and faster rendering on canvas.
   * The main disadvantage is movement of objects may appear less smooth.
   * @static
   * @memberof PIXI.settings
   * @type {boolean}
   * @default false
   */ ROUND_PIXELS: !1
};


var $3cea489506df71b1$var$appleIphone = /iPhone/i;
var $3cea489506df71b1$var$appleIpod = /iPod/i;
var $3cea489506df71b1$var$appleTablet = /iPad/i;
var $3cea489506df71b1$var$appleUniversal = /\biOS-universal(?:.+)Mac\b/i;
var $3cea489506df71b1$var$androidPhone = /\bAndroid(?:.+)Mobile\b/i;
var $3cea489506df71b1$var$androidTablet = /Android/i;
var $3cea489506df71b1$var$amazonPhone = /(?:SD4930UR|\bSilk(?:.+)Mobile\b)/i;
var $3cea489506df71b1$var$amazonTablet = /Silk/i;
var $3cea489506df71b1$var$windowsPhone = /Windows Phone/i;
var $3cea489506df71b1$var$windowsTablet = /\bWindows(?:.+)ARM\b/i;
var $3cea489506df71b1$var$otherBlackBerry = /BlackBerry/i;
var $3cea489506df71b1$var$otherBlackBerry10 = /BB10/i;
var $3cea489506df71b1$var$otherOpera = /Opera Mini/i;
var $3cea489506df71b1$var$otherChrome = /\b(CriOS|Chrome)(?:.+)Mobile/i;
var $3cea489506df71b1$var$otherFirefox = /Mobile(?:.+)Firefox\b/i;
var $3cea489506df71b1$var$isAppleTabletOnIos13 = function(navigator1) {
    return typeof navigator1 !== "undefined" && navigator1.platform === "MacIntel" && typeof navigator1.maxTouchPoints === "number" && navigator1.maxTouchPoints > 1 && typeof MSStream === "undefined";
};
function $3cea489506df71b1$var$createMatch(userAgent) {
    return function(regex) {
        return regex.test(userAgent);
    };
}
function $3cea489506df71b1$export$2e2bcd8739ae039(param) {
    var nav = {
        userAgent: "",
        platform: "",
        maxTouchPoints: 0
    };
    if (!param && typeof navigator !== "undefined") nav = {
        userAgent: navigator.userAgent,
        platform: navigator.platform,
        maxTouchPoints: navigator.maxTouchPoints || 0
    };
    else if (typeof param === "string") nav.userAgent = param;
    else if (param && param.userAgent) nav = {
        userAgent: param.userAgent,
        platform: param.platform,
        maxTouchPoints: param.maxTouchPoints || 0
    };
    var userAgent = nav.userAgent;
    var tmp = userAgent.split("[FBAN");
    if (typeof tmp[1] !== "undefined") userAgent = tmp[0];
    tmp = userAgent.split("Twitter");
    if (typeof tmp[1] !== "undefined") userAgent = tmp[0];
    var match = $3cea489506df71b1$var$createMatch(userAgent);
    var result = {
        apple: {
            phone: match($3cea489506df71b1$var$appleIphone) && !match($3cea489506df71b1$var$windowsPhone),
            ipod: match($3cea489506df71b1$var$appleIpod),
            tablet: !match($3cea489506df71b1$var$appleIphone) && (match($3cea489506df71b1$var$appleTablet) || $3cea489506df71b1$var$isAppleTabletOnIos13(nav)) && !match($3cea489506df71b1$var$windowsPhone),
            universal: match($3cea489506df71b1$var$appleUniversal),
            device: (match($3cea489506df71b1$var$appleIphone) || match($3cea489506df71b1$var$appleIpod) || match($3cea489506df71b1$var$appleTablet) || match($3cea489506df71b1$var$appleUniversal) || $3cea489506df71b1$var$isAppleTabletOnIos13(nav)) && !match($3cea489506df71b1$var$windowsPhone)
        },
        amazon: {
            phone: match($3cea489506df71b1$var$amazonPhone),
            tablet: !match($3cea489506df71b1$var$amazonPhone) && match($3cea489506df71b1$var$amazonTablet),
            device: match($3cea489506df71b1$var$amazonPhone) || match($3cea489506df71b1$var$amazonTablet)
        },
        android: {
            phone: !match($3cea489506df71b1$var$windowsPhone) && match($3cea489506df71b1$var$amazonPhone) || !match($3cea489506df71b1$var$windowsPhone) && match($3cea489506df71b1$var$androidPhone),
            tablet: !match($3cea489506df71b1$var$windowsPhone) && !match($3cea489506df71b1$var$amazonPhone) && !match($3cea489506df71b1$var$androidPhone) && (match($3cea489506df71b1$var$amazonTablet) || match($3cea489506df71b1$var$androidTablet)),
            device: !match($3cea489506df71b1$var$windowsPhone) && (match($3cea489506df71b1$var$amazonPhone) || match($3cea489506df71b1$var$amazonTablet) || match($3cea489506df71b1$var$androidPhone) || match($3cea489506df71b1$var$androidTablet)) || match(/\bokhttp\b/i)
        },
        windows: {
            phone: match($3cea489506df71b1$var$windowsPhone),
            tablet: match($3cea489506df71b1$var$windowsTablet),
            device: match($3cea489506df71b1$var$windowsPhone) || match($3cea489506df71b1$var$windowsTablet)
        },
        other: {
            blackberry: match($3cea489506df71b1$var$otherBlackBerry),
            blackberry10: match($3cea489506df71b1$var$otherBlackBerry10),
            opera: match($3cea489506df71b1$var$otherOpera),
            firefox: match($3cea489506df71b1$var$otherFirefox),
            chrome: match($3cea489506df71b1$var$otherChrome),
            device: match($3cea489506df71b1$var$otherBlackBerry) || match($3cea489506df71b1$var$otherBlackBerry10) || match($3cea489506df71b1$var$otherOpera) || match($3cea489506df71b1$var$otherFirefox) || match($3cea489506df71b1$var$otherChrome)
        },
        any: false,
        phone: false,
        tablet: false
    };
    result.any = result.apple.device || result.android.device || result.windows.device || result.other.device;
    result.phone = result.apple.phone || result.android.phone || result.windows.phone;
    result.tablet = result.apple.tablet || result.android.tablet || result.windows.tablet;
    return result;
}




const $389fd98f2c1f982f$var$isMobileCall = (0, $3cea489506df71b1$export$2e2bcd8739ae039).default ?? (0, $3cea489506df71b1$export$2e2bcd8739ae039), $389fd98f2c1f982f$export$d0a8044dce8ff2fc = $389fd98f2c1f982f$var$isMobileCall(globalThis.navigator);




var $db31fc3dfae4939b$exports = {};

$parcel$export($db31fc3dfae4939b$exports, "BaseTextureCache", () => $de0ca454f7b7a947$export$cec649a143d060b1);
$parcel$export($db31fc3dfae4939b$exports, "BoundingBox", () => $8c72251601deb182$export$63080c4de6cfc362);
$parcel$export($db31fc3dfae4939b$exports, "CanvasRenderTarget", () => $041ef324d9ecac55$export$525943d4c7cdfa38);
$parcel$export($db31fc3dfae4939b$exports, "DATA_URI", () => $80ce1111ace5f2d1$export$dbafa72958753fce);
$parcel$export($db31fc3dfae4939b$exports, "EventEmitter", () => (/*@__PURE__*/$parcel$interopDefault($162b085ff96d1cb1$exports)));
$parcel$export($db31fc3dfae4939b$exports, "ProgramCache", () => $de0ca454f7b7a947$export$d47c7e291d8b6e2c);
$parcel$export($db31fc3dfae4939b$exports, "TextureCache", () => $de0ca454f7b7a947$export$4254ab7c0971430e);
$parcel$export($db31fc3dfae4939b$exports, "clearTextureCache", () => $de0ca454f7b7a947$export$3ee9cef7c9878d34);
$parcel$export($db31fc3dfae4939b$exports, "correctBlendMode", () => $e6ada961504cf12a$export$3d793623cb0d1905);
$parcel$export($db31fc3dfae4939b$exports, "createIndicesForQuads", () => $b7f909d9d1427beb$export$c56148e1bec42281);
$parcel$export($db31fc3dfae4939b$exports, "decomposeDataUri", () => $6f08a9eba91986fb$export$672224f9983ff723);
$parcel$export($db31fc3dfae4939b$exports, "deprecation", () => $397b7871568e248b$export$afd31d834b512e89);
$parcel$export($db31fc3dfae4939b$exports, "destroyTextureCache", () => $de0ca454f7b7a947$export$b5c9bc385f713d5a);
$parcel$export($db31fc3dfae4939b$exports, "detectVideoAlphaMode", () => $447db3a6235c3d92$export$8df68d58aae31877);
$parcel$export($db31fc3dfae4939b$exports, "determineCrossOrigin", () => $275f34938d76b895$export$292083da55c5b406);
$parcel$export($db31fc3dfae4939b$exports, "earcut", () => (/*@__PURE__*/$parcel$interopDefault($2a9cd57430e113d5$exports)));
$parcel$export($db31fc3dfae4939b$exports, "getBufferType", () => $511acc244d4a69e7$export$adf72b506413cb57);
$parcel$export($db31fc3dfae4939b$exports, "getCanvasBoundingBox", () => $36935cc9fee67cd3$export$550eedf6c679837d);
$parcel$export($db31fc3dfae4939b$exports, "getResolutionOfUrl", () => $3425cf39834caee0$export$8695ab2f322d2637);
$parcel$export($db31fc3dfae4939b$exports, "hex2rgb", () => $e92df336c936c93a$export$858a46ce014e0e87);
$parcel$export($db31fc3dfae4939b$exports, "hex2string", () => $e92df336c936c93a$export$7a57339af2222169);
$parcel$export($db31fc3dfae4939b$exports, "interleaveTypedArrays", () => $e34bf865e0309867$export$1ce3e224e969bb24);
$parcel$export($db31fc3dfae4939b$exports, "isMobile", () => $389fd98f2c1f982f$export$d0a8044dce8ff2fc);
$parcel$export($db31fc3dfae4939b$exports, "isPow2", () => $af2147baf6c30f74$export$eb50b9c078eb6ae7);
$parcel$export($db31fc3dfae4939b$exports, "isWebGLSupported", () => $9f5163a850bf3393$export$83dc396b76015322);
$parcel$export($db31fc3dfae4939b$exports, "log2", () => $af2147baf6c30f74$export$b9fae0bba9d9094d);
$parcel$export($db31fc3dfae4939b$exports, "nextPow2", () => $af2147baf6c30f74$export$f0d90cf68bd426eb);
$parcel$export($db31fc3dfae4939b$exports, "path", () => $6f112ebca2b77b27$export$bb654e07daaf8c3a);
$parcel$export($db31fc3dfae4939b$exports, "premultiplyBlendMode", () => $e6ada961504cf12a$export$799d0d31e2f4c737);
$parcel$export($db31fc3dfae4939b$exports, "premultiplyRgba", () => $e6ada961504cf12a$export$4fa4eaa2922d1869);
$parcel$export($db31fc3dfae4939b$exports, "premultiplyTint", () => $e6ada961504cf12a$export$1ddadce6229d3efd);
$parcel$export($db31fc3dfae4939b$exports, "premultiplyTintToRgba", () => $e6ada961504cf12a$export$c75351d34304eb8c);
$parcel$export($db31fc3dfae4939b$exports, "removeItems", () => $0edf199a0064729e$export$8d47c0e1ce445404);
$parcel$export($db31fc3dfae4939b$exports, "rgb2hex", () => $e92df336c936c93a$export$883528fb0afa7177);
$parcel$export($db31fc3dfae4939b$exports, "sayHello", () => $8ed8006a7e1df906$export$2c6a96c059a06e7c);
$parcel$export($db31fc3dfae4939b$exports, "sign", () => $4036e7f0605a6d07$export$c5552dfdbc7cec71);
$parcel$export($db31fc3dfae4939b$exports, "skipHello", () => $8ed8006a7e1df906$export$702210f86367d7ed);
$parcel$export($db31fc3dfae4939b$exports, "string2hex", () => $e92df336c936c93a$export$f6a774610dbc2f6);
$parcel$export($db31fc3dfae4939b$exports, "trimCanvas", () => $ec6c0b9f62eebcdb$export$658947b9914dd428);
$parcel$export($db31fc3dfae4939b$exports, "uid", () => $9444d853616ed05b$export$e2a22331486dcca0);
$parcel$export($db31fc3dfae4939b$exports, "url", () => $666ed9e374b55afe$export$128fa18b7194ef);

(0, $2808efac47e52be0$export$a5a6e0b888b2c992).RETINA_PREFIX = /@([0-9\.]+)x/;
(0, $2808efac47e52be0$export$a5a6e0b888b2c992).FAIL_IF_MAJOR_PERFORMANCE_CAVEAT = !1;



var $162b085ff96d1cb1$exports = {};
"use strict";
var $162b085ff96d1cb1$var$has = Object.prototype.hasOwnProperty, $162b085ff96d1cb1$var$prefix = "~";
/**
 * Constructor to create a storage for our `EE` objects.
 * An `Events` instance is a plain object whose properties are event names.
 *
 * @constructor
 * @private
 */ function $162b085ff96d1cb1$var$Events() {}
//
// We try to not inherit from `Object.prototype`. In some engines creating an
// instance in this way is faster than calling `Object.create(null)` directly.
// If `Object.create(null)` is not supported we prefix the event names with a
// character to make sure that the built-in object properties are not
// overridden or used as an attack vector.
//
if (Object.create) {
    $162b085ff96d1cb1$var$Events.prototype = Object.create(null);
    //
    // This hack is needed because the `__proto__` property is still inherited in
    // some old browsers like Android 4, iPhone 5.1, Opera 11 and Safari 5.
    //
    if (!new $162b085ff96d1cb1$var$Events().__proto__) $162b085ff96d1cb1$var$prefix = false;
}
/**
 * Representation of a single event listener.
 *
 * @param {Function} fn The listener function.
 * @param {*} context The context to invoke the listener with.
 * @param {Boolean} [once=false] Specify if the listener is a one-time listener.
 * @constructor
 * @private
 */ function $162b085ff96d1cb1$var$EE(fn, context, once) {
    this.fn = fn;
    this.context = context;
    this.once = once || false;
}
/**
 * Add a listener for a given event.
 *
 * @param {EventEmitter} emitter Reference to the `EventEmitter` instance.
 * @param {(String|Symbol)} event The event name.
 * @param {Function} fn The listener function.
 * @param {*} context The context to invoke the listener with.
 * @param {Boolean} once Specify if the listener is a one-time listener.
 * @returns {EventEmitter}
 * @private
 */ function $162b085ff96d1cb1$var$addListener(emitter, event, fn, context, once) {
    if (typeof fn !== "function") throw new TypeError("The listener must be a function");
    var listener = new $162b085ff96d1cb1$var$EE(fn, context || emitter, once), evt = $162b085ff96d1cb1$var$prefix ? $162b085ff96d1cb1$var$prefix + event : event;
    if (!emitter._events[evt]) emitter._events[evt] = listener, emitter._eventsCount++;
    else if (!emitter._events[evt].fn) emitter._events[evt].push(listener);
    else emitter._events[evt] = [
        emitter._events[evt],
        listener
    ];
    return emitter;
}
/**
 * Clear event by name.
 *
 * @param {EventEmitter} emitter Reference to the `EventEmitter` instance.
 * @param {(String|Symbol)} evt The Event name.
 * @private
 */ function $162b085ff96d1cb1$var$clearEvent(emitter, evt) {
    if (--emitter._eventsCount === 0) emitter._events = new $162b085ff96d1cb1$var$Events();
    else delete emitter._events[evt];
}
/**
 * Minimal `EventEmitter` interface that is molded against the Node.js
 * `EventEmitter` interface.
 *
 * @constructor
 * @public
 */ function $162b085ff96d1cb1$var$EventEmitter() {
    this._events = new $162b085ff96d1cb1$var$Events();
    this._eventsCount = 0;
}
/**
 * Return an array listing the events for which the emitter has registered
 * listeners.
 *
 * @returns {Array}
 * @public
 */ $162b085ff96d1cb1$var$EventEmitter.prototype.eventNames = function eventNames() {
    var names = [], events, name;
    if (this._eventsCount === 0) return names;
    for(name in events = this._events)if ($162b085ff96d1cb1$var$has.call(events, name)) names.push($162b085ff96d1cb1$var$prefix ? name.slice(1) : name);
    if (Object.getOwnPropertySymbols) return names.concat(Object.getOwnPropertySymbols(events));
    return names;
};
/**
 * Return the listeners registered for a given event.
 *
 * @param {(String|Symbol)} event The event name.
 * @returns {Array} The registered listeners.
 * @public
 */ $162b085ff96d1cb1$var$EventEmitter.prototype.listeners = function listeners(event) {
    var evt = $162b085ff96d1cb1$var$prefix ? $162b085ff96d1cb1$var$prefix + event : event, handlers = this._events[evt];
    if (!handlers) return [];
    if (handlers.fn) return [
        handlers.fn
    ];
    for(var i = 0, l = handlers.length, ee = new Array(l); i < l; i++)ee[i] = handlers[i].fn;
    return ee;
};
/**
 * Return the number of listeners listening to a given event.
 *
 * @param {(String|Symbol)} event The event name.
 * @returns {Number} The number of listeners.
 * @public
 */ $162b085ff96d1cb1$var$EventEmitter.prototype.listenerCount = function listenerCount(event) {
    var evt = $162b085ff96d1cb1$var$prefix ? $162b085ff96d1cb1$var$prefix + event : event, listeners = this._events[evt];
    if (!listeners) return 0;
    if (listeners.fn) return 1;
    return listeners.length;
};
/**
 * Calls each of the listeners registered for a given event.
 *
 * @param {(String|Symbol)} event The event name.
 * @returns {Boolean} `true` if the event had listeners, else `false`.
 * @public
 */ $162b085ff96d1cb1$var$EventEmitter.prototype.emit = function emit(event, a1, a2, a3, a4, a5) {
    var evt = $162b085ff96d1cb1$var$prefix ? $162b085ff96d1cb1$var$prefix + event : event;
    if (!this._events[evt]) return false;
    var listeners = this._events[evt], len = arguments.length, args, i;
    if (listeners.fn) {
        if (listeners.once) this.removeListener(event, listeners.fn, undefined, true);
        switch(len){
            case 1:
                return listeners.fn.call(listeners.context), true;
            case 2:
                return listeners.fn.call(listeners.context, a1), true;
            case 3:
                return listeners.fn.call(listeners.context, a1, a2), true;
            case 4:
                return listeners.fn.call(listeners.context, a1, a2, a3), true;
            case 5:
                return listeners.fn.call(listeners.context, a1, a2, a3, a4), true;
            case 6:
                return listeners.fn.call(listeners.context, a1, a2, a3, a4, a5), true;
        }
        for(i = 1, args = new Array(len - 1); i < len; i++)args[i - 1] = arguments[i];
        listeners.fn.apply(listeners.context, args);
    } else {
        var length = listeners.length, j;
        for(i = 0; i < length; i++){
            if (listeners[i].once) this.removeListener(event, listeners[i].fn, undefined, true);
            switch(len){
                case 1:
                    listeners[i].fn.call(listeners[i].context);
                    break;
                case 2:
                    listeners[i].fn.call(listeners[i].context, a1);
                    break;
                case 3:
                    listeners[i].fn.call(listeners[i].context, a1, a2);
                    break;
                case 4:
                    listeners[i].fn.call(listeners[i].context, a1, a2, a3);
                    break;
                default:
                    if (!args) for(j = 1, args = new Array(len - 1); j < len; j++)args[j - 1] = arguments[j];
                    listeners[i].fn.apply(listeners[i].context, args);
            }
        }
    }
    return true;
};
/**
 * Add a listener for a given event.
 *
 * @param {(String|Symbol)} event The event name.
 * @param {Function} fn The listener function.
 * @param {*} [context=this] The context to invoke the listener with.
 * @returns {EventEmitter} `this`.
 * @public
 */ $162b085ff96d1cb1$var$EventEmitter.prototype.on = function on(event, fn, context) {
    return $162b085ff96d1cb1$var$addListener(this, event, fn, context, false);
};
/**
 * Add a one-time listener for a given event.
 *
 * @param {(String|Symbol)} event The event name.
 * @param {Function} fn The listener function.
 * @param {*} [context=this] The context to invoke the listener with.
 * @returns {EventEmitter} `this`.
 * @public
 */ $162b085ff96d1cb1$var$EventEmitter.prototype.once = function once(event, fn, context) {
    return $162b085ff96d1cb1$var$addListener(this, event, fn, context, true);
};
/**
 * Remove the listeners of a given event.
 *
 * @param {(String|Symbol)} event The event name.
 * @param {Function} fn Only remove the listeners that match this function.
 * @param {*} context Only remove the listeners that have this context.
 * @param {Boolean} once Only remove one-time listeners.
 * @returns {EventEmitter} `this`.
 * @public
 */ $162b085ff96d1cb1$var$EventEmitter.prototype.removeListener = function removeListener(event, fn, context, once) {
    var evt = $162b085ff96d1cb1$var$prefix ? $162b085ff96d1cb1$var$prefix + event : event;
    if (!this._events[evt]) return this;
    if (!fn) {
        $162b085ff96d1cb1$var$clearEvent(this, evt);
        return this;
    }
    var listeners = this._events[evt];
    if (listeners.fn) {
        if (listeners.fn === fn && (!once || listeners.once) && (!context || listeners.context === context)) $162b085ff96d1cb1$var$clearEvent(this, evt);
    } else {
        for(var i = 0, events = [], length = listeners.length; i < length; i++)if (listeners[i].fn !== fn || once && !listeners[i].once || context && listeners[i].context !== context) events.push(listeners[i]);
        //
        // Reset the array, or remove it completely if we have no more listeners.
        //
        if (events.length) this._events[evt] = events.length === 1 ? events[0] : events;
        else $162b085ff96d1cb1$var$clearEvent(this, evt);
    }
    return this;
};
/**
 * Remove all listeners, or those of the specified event.
 *
 * @param {(String|Symbol)} [event] The event name.
 * @returns {EventEmitter} `this`.
 * @public
 */ $162b085ff96d1cb1$var$EventEmitter.prototype.removeAllListeners = function removeAllListeners(event) {
    var evt;
    if (event) {
        evt = $162b085ff96d1cb1$var$prefix ? $162b085ff96d1cb1$var$prefix + event : event;
        if (this._events[evt]) $162b085ff96d1cb1$var$clearEvent(this, evt);
    } else {
        this._events = new $162b085ff96d1cb1$var$Events();
        this._eventsCount = 0;
    }
    return this;
};
//
// Alias methods names because people roll like that.
//
$162b085ff96d1cb1$var$EventEmitter.prototype.off = $162b085ff96d1cb1$var$EventEmitter.prototype.removeListener;
$162b085ff96d1cb1$var$EventEmitter.prototype.addListener = $162b085ff96d1cb1$var$EventEmitter.prototype.on;
//
// Expose the prefix.
//
$162b085ff96d1cb1$var$EventEmitter.prefixed = $162b085ff96d1cb1$var$prefix;
//
// Allow `EventEmitter` to be imported as module namespace.
//
$162b085ff96d1cb1$var$EventEmitter.EventEmitter = $162b085ff96d1cb1$var$EventEmitter;
$162b085ff96d1cb1$exports = $162b085ff96d1cb1$var$EventEmitter;


var $2a9cd57430e113d5$exports = {};
"use strict";
$2a9cd57430e113d5$exports = $2a9cd57430e113d5$var$earcut;
$2a9cd57430e113d5$exports.default = $2a9cd57430e113d5$var$earcut;
function $2a9cd57430e113d5$var$earcut(data, holeIndices, dim) {
    dim = dim || 2;
    var hasHoles = holeIndices && holeIndices.length, outerLen = hasHoles ? holeIndices[0] * dim : data.length, outerNode = $2a9cd57430e113d5$var$linkedList(data, 0, outerLen, dim, true), triangles = [];
    if (!outerNode || outerNode.next === outerNode.prev) return triangles;
    var minX, minY, maxX, maxY, x, y, invSize;
    if (hasHoles) outerNode = $2a9cd57430e113d5$var$eliminateHoles(data, holeIndices, outerNode, dim);
    // if the shape is not too simple, we'll use z-order curve hash later; calculate polygon bbox
    if (data.length > 80 * dim) {
        minX = maxX = data[0];
        minY = maxY = data[1];
        for(var i = dim; i < outerLen; i += dim){
            x = data[i];
            y = data[i + 1];
            if (x < minX) minX = x;
            if (y < minY) minY = y;
            if (x > maxX) maxX = x;
            if (y > maxY) maxY = y;
        }
        // minX, minY and invSize are later used to transform coords into integers for z-order calculation
        invSize = Math.max(maxX - minX, maxY - minY);
        invSize = invSize !== 0 ? 32767 / invSize : 0;
    }
    $2a9cd57430e113d5$var$earcutLinked(outerNode, triangles, dim, minX, minY, invSize, 0);
    return triangles;
}
// create a circular doubly linked list from polygon points in the specified winding order
function $2a9cd57430e113d5$var$linkedList(data, start, end, dim, clockwise) {
    var i, last;
    if (clockwise === $2a9cd57430e113d5$var$signedArea(data, start, end, dim) > 0) for(i = start; i < end; i += dim)last = $2a9cd57430e113d5$var$insertNode(i, data[i], data[i + 1], last);
    else for(i = end - dim; i >= start; i -= dim)last = $2a9cd57430e113d5$var$insertNode(i, data[i], data[i + 1], last);
    if (last && $2a9cd57430e113d5$var$equals(last, last.next)) {
        $2a9cd57430e113d5$var$removeNode(last);
        last = last.next;
    }
    return last;
}
// eliminate colinear or duplicate points
function $2a9cd57430e113d5$var$filterPoints(start, end) {
    if (!start) return start;
    if (!end) end = start;
    var p = start, again;
    do {
        again = false;
        if (!p.steiner && ($2a9cd57430e113d5$var$equals(p, p.next) || $2a9cd57430e113d5$var$area(p.prev, p, p.next) === 0)) {
            $2a9cd57430e113d5$var$removeNode(p);
            p = end = p.prev;
            if (p === p.next) break;
            again = true;
        } else p = p.next;
    }while (again || p !== end);
    return end;
}
// main ear slicing loop which triangulates a polygon (given as a linked list)
function $2a9cd57430e113d5$var$earcutLinked(ear, triangles, dim, minX, minY, invSize, pass) {
    if (!ear) return;
    // interlink polygon nodes in z-order
    if (!pass && invSize) $2a9cd57430e113d5$var$indexCurve(ear, minX, minY, invSize);
    var stop = ear, prev, next;
    // iterate through ears, slicing them one by one
    while(ear.prev !== ear.next){
        prev = ear.prev;
        next = ear.next;
        if (invSize ? $2a9cd57430e113d5$var$isEarHashed(ear, minX, minY, invSize) : $2a9cd57430e113d5$var$isEar(ear)) {
            // cut off the triangle
            triangles.push(prev.i / dim | 0);
            triangles.push(ear.i / dim | 0);
            triangles.push(next.i / dim | 0);
            $2a9cd57430e113d5$var$removeNode(ear);
            // skipping the next vertex leads to less sliver triangles
            ear = next.next;
            stop = next.next;
            continue;
        }
        ear = next;
        // if we looped through the whole remaining polygon and can't find any more ears
        if (ear === stop) {
            // try filtering points and slicing again
            if (!pass) $2a9cd57430e113d5$var$earcutLinked($2a9cd57430e113d5$var$filterPoints(ear), triangles, dim, minX, minY, invSize, 1);
            else if (pass === 1) {
                ear = $2a9cd57430e113d5$var$cureLocalIntersections($2a9cd57430e113d5$var$filterPoints(ear), triangles, dim);
                $2a9cd57430e113d5$var$earcutLinked(ear, triangles, dim, minX, minY, invSize, 2);
            // as a last resort, try splitting the remaining polygon into two
            } else if (pass === 2) $2a9cd57430e113d5$var$splitEarcut(ear, triangles, dim, minX, minY, invSize);
            break;
        }
    }
}
// check whether a polygon node forms a valid ear with adjacent nodes
function $2a9cd57430e113d5$var$isEar(ear) {
    var a = ear.prev, b = ear, c = ear.next;
    if ($2a9cd57430e113d5$var$area(a, b, c) >= 0) return false; // reflex, can't be an ear
    // now make sure we don't have other points inside the potential ear
    var ax = a.x, bx = b.x, cx = c.x, ay = a.y, by = b.y, cy = c.y;
    // triangle bbox; min & max are calculated like this for speed
    var x0 = ax < bx ? ax < cx ? ax : cx : bx < cx ? bx : cx, y0 = ay < by ? ay < cy ? ay : cy : by < cy ? by : cy, x1 = ax > bx ? ax > cx ? ax : cx : bx > cx ? bx : cx, y1 = ay > by ? ay > cy ? ay : cy : by > cy ? by : cy;
    var p = c.next;
    while(p !== a){
        if (p.x >= x0 && p.x <= x1 && p.y >= y0 && p.y <= y1 && $2a9cd57430e113d5$var$pointInTriangle(ax, ay, bx, by, cx, cy, p.x, p.y) && $2a9cd57430e113d5$var$area(p.prev, p, p.next) >= 0) return false;
        p = p.next;
    }
    return true;
}
function $2a9cd57430e113d5$var$isEarHashed(ear, minX, minY, invSize) {
    var a = ear.prev, b = ear, c = ear.next;
    if ($2a9cd57430e113d5$var$area(a, b, c) >= 0) return false; // reflex, can't be an ear
    var ax = a.x, bx = b.x, cx = c.x, ay = a.y, by = b.y, cy = c.y;
    // triangle bbox; min & max are calculated like this for speed
    var x0 = ax < bx ? ax < cx ? ax : cx : bx < cx ? bx : cx, y0 = ay < by ? ay < cy ? ay : cy : by < cy ? by : cy, x1 = ax > bx ? ax > cx ? ax : cx : bx > cx ? bx : cx, y1 = ay > by ? ay > cy ? ay : cy : by > cy ? by : cy;
    // z-order range for the current triangle bbox;
    var minZ = $2a9cd57430e113d5$var$zOrder(x0, y0, minX, minY, invSize), maxZ = $2a9cd57430e113d5$var$zOrder(x1, y1, minX, minY, invSize);
    var p = ear.prevZ, n = ear.nextZ;
    // look for points inside the triangle in both directions
    while(p && p.z >= minZ && n && n.z <= maxZ){
        if (p.x >= x0 && p.x <= x1 && p.y >= y0 && p.y <= y1 && p !== a && p !== c && $2a9cd57430e113d5$var$pointInTriangle(ax, ay, bx, by, cx, cy, p.x, p.y) && $2a9cd57430e113d5$var$area(p.prev, p, p.next) >= 0) return false;
        p = p.prevZ;
        if (n.x >= x0 && n.x <= x1 && n.y >= y0 && n.y <= y1 && n !== a && n !== c && $2a9cd57430e113d5$var$pointInTriangle(ax, ay, bx, by, cx, cy, n.x, n.y) && $2a9cd57430e113d5$var$area(n.prev, n, n.next) >= 0) return false;
        n = n.nextZ;
    }
    // look for remaining points in decreasing z-order
    while(p && p.z >= minZ){
        if (p.x >= x0 && p.x <= x1 && p.y >= y0 && p.y <= y1 && p !== a && p !== c && $2a9cd57430e113d5$var$pointInTriangle(ax, ay, bx, by, cx, cy, p.x, p.y) && $2a9cd57430e113d5$var$area(p.prev, p, p.next) >= 0) return false;
        p = p.prevZ;
    }
    // look for remaining points in increasing z-order
    while(n && n.z <= maxZ){
        if (n.x >= x0 && n.x <= x1 && n.y >= y0 && n.y <= y1 && n !== a && n !== c && $2a9cd57430e113d5$var$pointInTriangle(ax, ay, bx, by, cx, cy, n.x, n.y) && $2a9cd57430e113d5$var$area(n.prev, n, n.next) >= 0) return false;
        n = n.nextZ;
    }
    return true;
}
// go through all polygon nodes and cure small local self-intersections
function $2a9cd57430e113d5$var$cureLocalIntersections(start, triangles, dim) {
    var p = start;
    do {
        var a = p.prev, b = p.next.next;
        if (!$2a9cd57430e113d5$var$equals(a, b) && $2a9cd57430e113d5$var$intersects(a, p, p.next, b) && $2a9cd57430e113d5$var$locallyInside(a, b) && $2a9cd57430e113d5$var$locallyInside(b, a)) {
            triangles.push(a.i / dim | 0);
            triangles.push(p.i / dim | 0);
            triangles.push(b.i / dim | 0);
            // remove two nodes involved
            $2a9cd57430e113d5$var$removeNode(p);
            $2a9cd57430e113d5$var$removeNode(p.next);
            p = start = b;
        }
        p = p.next;
    }while (p !== start);
    return $2a9cd57430e113d5$var$filterPoints(p);
}
// try splitting polygon into two and triangulate them independently
function $2a9cd57430e113d5$var$splitEarcut(start, triangles, dim, minX, minY, invSize) {
    // look for a valid diagonal that divides the polygon into two
    var a = start;
    do {
        var b = a.next.next;
        while(b !== a.prev){
            if (a.i !== b.i && $2a9cd57430e113d5$var$isValidDiagonal(a, b)) {
                // split the polygon in two by the diagonal
                var c = $2a9cd57430e113d5$var$splitPolygon(a, b);
                // filter colinear points around the cuts
                a = $2a9cd57430e113d5$var$filterPoints(a, a.next);
                c = $2a9cd57430e113d5$var$filterPoints(c, c.next);
                // run earcut on each half
                $2a9cd57430e113d5$var$earcutLinked(a, triangles, dim, minX, minY, invSize, 0);
                $2a9cd57430e113d5$var$earcutLinked(c, triangles, dim, minX, minY, invSize, 0);
                return;
            }
            b = b.next;
        }
        a = a.next;
    }while (a !== start);
}
// link every hole into the outer loop, producing a single-ring polygon without holes
function $2a9cd57430e113d5$var$eliminateHoles(data, holeIndices, outerNode, dim) {
    var queue = [], i, len, start, end, list;
    for(i = 0, len = holeIndices.length; i < len; i++){
        start = holeIndices[i] * dim;
        end = i < len - 1 ? holeIndices[i + 1] * dim : data.length;
        list = $2a9cd57430e113d5$var$linkedList(data, start, end, dim, false);
        if (list === list.next) list.steiner = true;
        queue.push($2a9cd57430e113d5$var$getLeftmost(list));
    }
    queue.sort($2a9cd57430e113d5$var$compareX);
    // process holes from left to right
    for(i = 0; i < queue.length; i++)outerNode = $2a9cd57430e113d5$var$eliminateHole(queue[i], outerNode);
    return outerNode;
}
function $2a9cd57430e113d5$var$compareX(a, b) {
    return a.x - b.x;
}
// find a bridge between vertices that connects hole with an outer ring and and link it
function $2a9cd57430e113d5$var$eliminateHole(hole, outerNode) {
    var bridge = $2a9cd57430e113d5$var$findHoleBridge(hole, outerNode);
    if (!bridge) return outerNode;
    var bridgeReverse = $2a9cd57430e113d5$var$splitPolygon(bridge, hole);
    // filter collinear points around the cuts
    $2a9cd57430e113d5$var$filterPoints(bridgeReverse, bridgeReverse.next);
    return $2a9cd57430e113d5$var$filterPoints(bridge, bridge.next);
}
// David Eberly's algorithm for finding a bridge between hole and outer polygon
function $2a9cd57430e113d5$var$findHoleBridge(hole, outerNode) {
    var p = outerNode, hx = hole.x, hy = hole.y, qx = -Infinity, m;
    // find a segment intersected by a ray from the hole's leftmost point to the left;
    // segment's endpoint with lesser x will be potential connection point
    do {
        if (hy <= p.y && hy >= p.next.y && p.next.y !== p.y) {
            var x = p.x + (hy - p.y) * (p.next.x - p.x) / (p.next.y - p.y);
            if (x <= hx && x > qx) {
                qx = x;
                m = p.x < p.next.x ? p : p.next;
                if (x === hx) return m; // hole touches outer segment; pick leftmost endpoint
            }
        }
        p = p.next;
    }while (p !== outerNode);
    if (!m) return null;
    // look for points inside the triangle of hole point, segment intersection and endpoint;
    // if there are no points found, we have a valid connection;
    // otherwise choose the point of the minimum angle with the ray as connection point
    var stop = m, mx = m.x, my = m.y, tanMin = Infinity, tan;
    p = m;
    do {
        if (hx >= p.x && p.x >= mx && hx !== p.x && $2a9cd57430e113d5$var$pointInTriangle(hy < my ? hx : qx, hy, mx, my, hy < my ? qx : hx, hy, p.x, p.y)) {
            tan = Math.abs(hy - p.y) / (hx - p.x); // tangential
            if ($2a9cd57430e113d5$var$locallyInside(p, hole) && (tan < tanMin || tan === tanMin && (p.x > m.x || p.x === m.x && $2a9cd57430e113d5$var$sectorContainsSector(m, p)))) {
                m = p;
                tanMin = tan;
            }
        }
        p = p.next;
    }while (p !== stop);
    return m;
}
// whether sector in vertex m contains sector in vertex p in the same coordinates
function $2a9cd57430e113d5$var$sectorContainsSector(m, p) {
    return $2a9cd57430e113d5$var$area(m.prev, m, p.prev) < 0 && $2a9cd57430e113d5$var$area(p.next, m, m.next) < 0;
}
// interlink polygon nodes in z-order
function $2a9cd57430e113d5$var$indexCurve(start, minX, minY, invSize) {
    var p = start;
    do {
        if (p.z === 0) p.z = $2a9cd57430e113d5$var$zOrder(p.x, p.y, minX, minY, invSize);
        p.prevZ = p.prev;
        p.nextZ = p.next;
        p = p.next;
    }while (p !== start);
    p.prevZ.nextZ = null;
    p.prevZ = null;
    $2a9cd57430e113d5$var$sortLinked(p);
}
// Simon Tatham's linked list merge sort algorithm
// http://www.chiark.greenend.org.uk/~sgtatham/algorithms/listsort.html
function $2a9cd57430e113d5$var$sortLinked(list) {
    var i, p, q, e, tail, numMerges, pSize, qSize, inSize = 1;
    do {
        p = list;
        list = null;
        tail = null;
        numMerges = 0;
        while(p){
            numMerges++;
            q = p;
            pSize = 0;
            for(i = 0; i < inSize; i++){
                pSize++;
                q = q.nextZ;
                if (!q) break;
            }
            qSize = inSize;
            while(pSize > 0 || qSize > 0 && q){
                if (pSize !== 0 && (qSize === 0 || !q || p.z <= q.z)) {
                    e = p;
                    p = p.nextZ;
                    pSize--;
                } else {
                    e = q;
                    q = q.nextZ;
                    qSize--;
                }
                if (tail) tail.nextZ = e;
                else list = e;
                e.prevZ = tail;
                tail = e;
            }
            p = q;
        }
        tail.nextZ = null;
        inSize *= 2;
    }while (numMerges > 1);
    return list;
}
// z-order of a point given coords and inverse of the longer side of data bbox
function $2a9cd57430e113d5$var$zOrder(x, y, minX, minY, invSize) {
    // coords are transformed into non-negative 15-bit integer range
    x = (x - minX) * invSize | 0;
    y = (y - minY) * invSize | 0;
    x = (x | x << 8) & 0x00FF00FF;
    x = (x | x << 4) & 0x0F0F0F0F;
    x = (x | x << 2) & 0x33333333;
    x = (x | x << 1) & 0x55555555;
    y = (y | y << 8) & 0x00FF00FF;
    y = (y | y << 4) & 0x0F0F0F0F;
    y = (y | y << 2) & 0x33333333;
    y = (y | y << 1) & 0x55555555;
    return x | y << 1;
}
// find the leftmost node of a polygon ring
function $2a9cd57430e113d5$var$getLeftmost(start) {
    var p = start, leftmost = start;
    do {
        if (p.x < leftmost.x || p.x === leftmost.x && p.y < leftmost.y) leftmost = p;
        p = p.next;
    }while (p !== start);
    return leftmost;
}
// check if a point lies within a convex triangle
function $2a9cd57430e113d5$var$pointInTriangle(ax, ay, bx, by, cx, cy, px, py) {
    return (cx - px) * (ay - py) >= (ax - px) * (cy - py) && (ax - px) * (by - py) >= (bx - px) * (ay - py) && (bx - px) * (cy - py) >= (cx - px) * (by - py);
}
// check if a diagonal between two polygon nodes is valid (lies in polygon interior)
function $2a9cd57430e113d5$var$isValidDiagonal(a, b) {
    return a.next.i !== b.i && a.prev.i !== b.i && !$2a9cd57430e113d5$var$intersectsPolygon(a, b) && // dones't intersect other edges
    ($2a9cd57430e113d5$var$locallyInside(a, b) && $2a9cd57430e113d5$var$locallyInside(b, a) && $2a9cd57430e113d5$var$middleInside(a, b) && // locally visible
    ($2a9cd57430e113d5$var$area(a.prev, a, b.prev) || $2a9cd57430e113d5$var$area(a, b.prev, b)) || // does not create opposite-facing sectors
    $2a9cd57430e113d5$var$equals(a, b) && $2a9cd57430e113d5$var$area(a.prev, a, a.next) > 0 && $2a9cd57430e113d5$var$area(b.prev, b, b.next) > 0); // special zero-length case
}
// signed area of a triangle
function $2a9cd57430e113d5$var$area(p, q, r) {
    return (q.y - p.y) * (r.x - q.x) - (q.x - p.x) * (r.y - q.y);
}
// check if two points are equal
function $2a9cd57430e113d5$var$equals(p1, p2) {
    return p1.x === p2.x && p1.y === p2.y;
}
// check if two segments intersect
function $2a9cd57430e113d5$var$intersects(p1, q1, p2, q2) {
    var o1 = $2a9cd57430e113d5$var$sign($2a9cd57430e113d5$var$area(p1, q1, p2));
    var o2 = $2a9cd57430e113d5$var$sign($2a9cd57430e113d5$var$area(p1, q1, q2));
    var o3 = $2a9cd57430e113d5$var$sign($2a9cd57430e113d5$var$area(p2, q2, p1));
    var o4 = $2a9cd57430e113d5$var$sign($2a9cd57430e113d5$var$area(p2, q2, q1));
    if (o1 !== o2 && o3 !== o4) return true; // general case
    if (o1 === 0 && $2a9cd57430e113d5$var$onSegment(p1, p2, q1)) return true; // p1, q1 and p2 are collinear and p2 lies on p1q1
    if (o2 === 0 && $2a9cd57430e113d5$var$onSegment(p1, q2, q1)) return true; // p1, q1 and q2 are collinear and q2 lies on p1q1
    if (o3 === 0 && $2a9cd57430e113d5$var$onSegment(p2, p1, q2)) return true; // p2, q2 and p1 are collinear and p1 lies on p2q2
    if (o4 === 0 && $2a9cd57430e113d5$var$onSegment(p2, q1, q2)) return true; // p2, q2 and q1 are collinear and q1 lies on p2q2
    return false;
}
// for collinear points p, q, r, check if point q lies on segment pr
function $2a9cd57430e113d5$var$onSegment(p, q, r) {
    return q.x <= Math.max(p.x, r.x) && q.x >= Math.min(p.x, r.x) && q.y <= Math.max(p.y, r.y) && q.y >= Math.min(p.y, r.y);
}
function $2a9cd57430e113d5$var$sign(num) {
    return num > 0 ? 1 : num < 0 ? -1 : 0;
}
// check if a polygon diagonal intersects any polygon segments
function $2a9cd57430e113d5$var$intersectsPolygon(a, b) {
    var p = a;
    do {
        if (p.i !== a.i && p.next.i !== a.i && p.i !== b.i && p.next.i !== b.i && $2a9cd57430e113d5$var$intersects(p, p.next, a, b)) return true;
        p = p.next;
    }while (p !== a);
    return false;
}
// check if a polygon diagonal is locally inside the polygon
function $2a9cd57430e113d5$var$locallyInside(a, b) {
    return $2a9cd57430e113d5$var$area(a.prev, a, a.next) < 0 ? $2a9cd57430e113d5$var$area(a, b, a.next) >= 0 && $2a9cd57430e113d5$var$area(a, a.prev, b) >= 0 : $2a9cd57430e113d5$var$area(a, b, a.prev) < 0 || $2a9cd57430e113d5$var$area(a, a.next, b) < 0;
}
// check if the middle point of a polygon diagonal is inside the polygon
function $2a9cd57430e113d5$var$middleInside(a, b) {
    var p = a, inside = false, px = (a.x + b.x) / 2, py = (a.y + b.y) / 2;
    do {
        if (p.y > py !== p.next.y > py && p.next.y !== p.y && px < (p.next.x - p.x) * (py - p.y) / (p.next.y - p.y) + p.x) inside = !inside;
        p = p.next;
    }while (p !== a);
    return inside;
}
// link two polygon vertices with a bridge; if the vertices belong to the same ring, it splits polygon into two;
// if one belongs to the outer ring and another to a hole, it merges it into a single ring
function $2a9cd57430e113d5$var$splitPolygon(a, b) {
    var a2 = new $2a9cd57430e113d5$var$Node(a.i, a.x, a.y), b2 = new $2a9cd57430e113d5$var$Node(b.i, b.x, b.y), an = a.next, bp = b.prev;
    a.next = b;
    b.prev = a;
    a2.next = an;
    an.prev = a2;
    b2.next = a2;
    a2.prev = b2;
    bp.next = b2;
    b2.prev = bp;
    return b2;
}
// create a node and optionally link it with previous one (in a circular doubly linked list)
function $2a9cd57430e113d5$var$insertNode(i, x, y, last) {
    var p = new $2a9cd57430e113d5$var$Node(i, x, y);
    if (!last) {
        p.prev = p;
        p.next = p;
    } else {
        p.next = last.next;
        p.prev = last;
        last.next.prev = p;
        last.next = p;
    }
    return p;
}
function $2a9cd57430e113d5$var$removeNode(p) {
    p.next.prev = p.prev;
    p.prev.next = p.next;
    if (p.prevZ) p.prevZ.nextZ = p.nextZ;
    if (p.nextZ) p.nextZ.prevZ = p.prevZ;
}
function $2a9cd57430e113d5$var$Node(i, x, y) {
    // vertex index in coordinates array
    this.i = i;
    // vertex coordinates
    this.x = x;
    this.y = y;
    // previous and next vertex nodes in a polygon ring
    this.prev = null;
    this.next = null;
    // z-order curve value
    this.z = 0;
    // previous and next nodes in z-order
    this.prevZ = null;
    this.nextZ = null;
    // indicates whether this is a steiner point
    this.steiner = false;
}
// return a percentage difference between the polygon area and its triangulation area;
// used to verify correctness of triangulation
$2a9cd57430e113d5$var$earcut.deviation = function(data, holeIndices, dim, triangles) {
    var hasHoles = holeIndices && holeIndices.length;
    var outerLen = hasHoles ? holeIndices[0] * dim : data.length;
    var polygonArea = Math.abs($2a9cd57430e113d5$var$signedArea(data, 0, outerLen, dim));
    if (hasHoles) for(var i = 0, len = holeIndices.length; i < len; i++){
        var start = holeIndices[i] * dim;
        var end = i < len - 1 ? holeIndices[i + 1] * dim : data.length;
        polygonArea -= Math.abs($2a9cd57430e113d5$var$signedArea(data, start, end, dim));
    }
    var trianglesArea = 0;
    for(i = 0; i < triangles.length; i += 3){
        var a = triangles[i] * dim;
        var b = triangles[i + 1] * dim;
        var c = triangles[i + 2] * dim;
        trianglesArea += Math.abs((data[a] - data[c]) * (data[b + 1] - data[a + 1]) - (data[a] - data[b]) * (data[c + 1] - data[a + 1]));
    }
    return polygonArea === 0 && trianglesArea === 0 ? 0 : Math.abs((trianglesArea - polygonArea) / polygonArea);
};
function $2a9cd57430e113d5$var$signedArea(data, start, end, dim) {
    var sum = 0;
    for(var i = start, j = end - dim; i < end; i += dim){
        sum += (data[j] - data[i]) * (data[i + 1] + data[j + 1]);
        j = i;
    }
    return sum;
}
// turn a polygon in a multi-dimensional array form (e.g. as in GeoJSON) into a form Earcut accepts
$2a9cd57430e113d5$var$earcut.flatten = function(data) {
    var dim = data[0][0].length, result = {
        vertices: [],
        holes: [],
        dimensions: dim
    }, holeIndex = 0;
    for(var i = 0; i < data.length; i++){
        for(var j = 0; j < data[i].length; j++)for(var d = 0; d < dim; d++)result.vertices.push(data[i][j][d]);
        if (i > 0) {
            holeIndex += data[i - 1].length;
            result.holes.push(holeIndex);
        }
    }
    return result;
};



var $1726n = parcelRequire("1726n");
const $397b7871568e248b$var$warnings = {};
function $397b7871568e248b$export$afd31d834b512e89(version, message, ignoreDepth = 3) {
    if ($397b7871568e248b$var$warnings[message]) return;
    let stack = new Error().stack;
    typeof stack > "u" ? console.warn("PixiJS Deprecation Warning: ", `${message}
Deprecated since v${version}`) : (stack = stack.split(`
`).splice(ignoreDepth).join(`
`), console.groupCollapsed ? (console.groupCollapsed("%cPixiJS Deprecation Warning: %c%s", "color:#614108;background:#fffbe6", "font-weight:normal;color:#614108;background:#fffbe6", `${message}
Deprecated since v${version}`), console.warn(stack), console.groupEnd()) : (console.warn("PixiJS Deprecation Warning: ", `${message}
Deprecated since v${version}`), console.warn(stack))), $397b7871568e248b$var$warnings[message] = !0;
}


const $666ed9e374b55afe$export$128fa18b7194ef = {
    /**
   * @deprecated since 7.3.0
   */ get parse () {
        return (0, $397b7871568e248b$export$afd31d834b512e89)("7.3.0", "utils.url.parse is deprecated, use native URL API instead."), $1726n.parse;
    },
    /**
   * @deprecated since 7.3.0
   */ get format () {
        return (0, $397b7871568e248b$export$afd31d834b512e89)("7.3.0", "utils.url.format is deprecated, use native URL API instead."), $1726n.format;
    },
    /**
   * @deprecated since 7.3.0
   */ get resolve () {
        return (0, $397b7871568e248b$export$afd31d834b512e89)("7.3.0", "utils.url.resolve is deprecated, use native URL API instead."), $1726n.resolve;
    }
};



function $6f112ebca2b77b27$var$assertPath(path2) {
    if (typeof path2 != "string") throw new TypeError(`Path must be a string. Received ${JSON.stringify(path2)}`);
}
function $6f112ebca2b77b27$var$removeUrlParams(url) {
    return url.split("?")[0].split("#")[0];
}
function $6f112ebca2b77b27$var$escapeRegExp(string) {
    return string.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
}
function $6f112ebca2b77b27$var$replaceAll(str, find, replace) {
    return str.replace(new RegExp($6f112ebca2b77b27$var$escapeRegExp(find), "g"), replace);
}
function $6f112ebca2b77b27$var$normalizeStringPosix(path2, allowAboveRoot) {
    let res = "", lastSegmentLength = 0, lastSlash = -1, dots = 0, code = -1;
    for(let i = 0; i <= path2.length; ++i){
        if (i < path2.length) code = path2.charCodeAt(i);
        else {
            if (code === 47) break;
            code = 47;
        }
        if (code === 47) {
            if (!(lastSlash === i - 1 || dots === 1)) {
                if (lastSlash !== i - 1 && dots === 2) {
                    if (res.length < 2 || lastSegmentLength !== 2 || res.charCodeAt(res.length - 1) !== 46 || res.charCodeAt(res.length - 2) !== 46) {
                        if (res.length > 2) {
                            const lastSlashIndex = res.lastIndexOf("/");
                            if (lastSlashIndex !== res.length - 1) {
                                lastSlashIndex === -1 ? (res = "", lastSegmentLength = 0) : (res = res.slice(0, lastSlashIndex), lastSegmentLength = res.length - 1 - res.lastIndexOf("/")), lastSlash = i, dots = 0;
                                continue;
                            }
                        } else if (res.length === 2 || res.length === 1) {
                            res = "", lastSegmentLength = 0, lastSlash = i, dots = 0;
                            continue;
                        }
                    }
                    allowAboveRoot && (res.length > 0 ? res += "/.." : res = "..", lastSegmentLength = 2);
                } else res.length > 0 ? res += `/${path2.slice(lastSlash + 1, i)}` : res = path2.slice(lastSlash + 1, i), lastSegmentLength = i - lastSlash - 1;
            }
            lastSlash = i, dots = 0;
        } else code === 46 && dots !== -1 ? ++dots : dots = -1;
    }
    return res;
}
const $6f112ebca2b77b27$export$bb654e07daaf8c3a = {
    /**
   * Converts a path to posix format.
   * @param path - The path to convert to posix
   */ toPosix (path2) {
        return $6f112ebca2b77b27$var$replaceAll(path2, "\\", "/");
    },
    /**
   * Checks if the path is a URL e.g. http://, https://
   * @param path - The path to check
   */ isUrl (path2) {
        return /^https?:/.test(this.toPosix(path2));
    },
    /**
   * Checks if the path is a data URL
   * @param path - The path to check
   */ isDataUrl (path2) {
        return /^data:([a-z]+\/[a-z0-9-+.]+(;[a-z0-9-.!#$%*+.{}|~`]+=[a-z0-9-.!#$%*+.{}()_|~`]+)*)?(;base64)?,([a-z0-9!$&',()*+;=\-._~:@\/?%\s<>]*?)$/i.test(path2);
    },
    /**
   * Checks if the path is a blob URL
   * @param path - The path to check
   */ isBlobUrl (path2) {
        return path2.startsWith("blob:");
    },
    /**
   * Checks if the path has a protocol e.g. http://, https://, file:///, data:, blob:, C:/
   * This will return true for windows file paths
   * @param path - The path to check
   */ hasProtocol (path2) {
        return /^[^/:]+:/.test(this.toPosix(path2));
    },
    /**
   * Returns the protocol of the path e.g. http://, https://, file:///, data:, blob:, C:/
   * @param path - The path to get the protocol from
   */ getProtocol (path2) {
        $6f112ebca2b77b27$var$assertPath(path2), path2 = this.toPosix(path2);
        const matchFile = /^file:\/\/\//.exec(path2);
        if (matchFile) return matchFile[0];
        const matchProtocol = /^[^/:]+:\/{0,2}/.exec(path2);
        return matchProtocol ? matchProtocol[0] : "";
    },
    /**
   * Converts URL to an absolute path.
   * When loading from a Web Worker, we must use absolute paths.
   * If the URL is already absolute we return it as is
   * If it's not, we convert it
   * @param url - The URL to test
   * @param customBaseUrl - The base URL to use
   * @param customRootUrl - The root URL to use
   */ toAbsolute (url, customBaseUrl, customRootUrl) {
        if ($6f112ebca2b77b27$var$assertPath(url), this.isDataUrl(url) || this.isBlobUrl(url)) return url;
        const baseUrl = $6f112ebca2b77b27$var$removeUrlParams(this.toPosix(customBaseUrl ?? (0, $2808efac47e52be0$export$a5a6e0b888b2c992).ADAPTER.getBaseUrl())), rootUrl = $6f112ebca2b77b27$var$removeUrlParams(this.toPosix(customRootUrl ?? this.rootname(baseUrl)));
        return url = this.toPosix(url), url.startsWith("/") ? $6f112ebca2b77b27$export$bb654e07daaf8c3a.join(rootUrl, url.slice(1)) : this.isAbsolute(url) ? url : this.join(baseUrl, url);
    },
    /**
   * Normalizes the given path, resolving '..' and '.' segments
   * @param path - The path to normalize
   */ normalize (path2) {
        if ($6f112ebca2b77b27$var$assertPath(path2), path2.length === 0) return ".";
        if (this.isDataUrl(path2) || this.isBlobUrl(path2)) return path2;
        path2 = this.toPosix(path2);
        let protocol = "";
        const isAbsolute = path2.startsWith("/");
        this.hasProtocol(path2) && (protocol = this.rootname(path2), path2 = path2.slice(protocol.length));
        const trailingSeparator = path2.endsWith("/");
        return path2 = $6f112ebca2b77b27$var$normalizeStringPosix(path2, !1), path2.length > 0 && trailingSeparator && (path2 += "/"), isAbsolute ? `/${path2}` : protocol + path2;
    },
    /**
   * Determines if path is an absolute path.
   * Absolute paths can be urls, data urls, or paths on disk
   * @param path - The path to test
   */ isAbsolute (path2) {
        return $6f112ebca2b77b27$var$assertPath(path2), path2 = this.toPosix(path2), this.hasProtocol(path2) ? !0 : path2.startsWith("/");
    },
    /**
   * Joins all given path segments together using the platform-specific separator as a delimiter,
   * then normalizes the resulting path
   * @param segments - The segments of the path to join
   */ join (...segments) {
        if (segments.length === 0) return ".";
        let joined;
        for(let i = 0; i < segments.length; ++i){
            const arg = segments[i];
            if ($6f112ebca2b77b27$var$assertPath(arg), arg.length > 0) {
                if (joined === void 0) joined = arg;
                else {
                    const prevArg = segments[i - 1] ?? "";
                    this.extname(prevArg) ? joined += `/../${arg}` : joined += `/${arg}`;
                }
            }
        }
        return joined === void 0 ? "." : this.normalize(joined);
    },
    /**
   * Returns the directory name of a path
   * @param path - The path to parse
   */ dirname (path2) {
        if ($6f112ebca2b77b27$var$assertPath(path2), path2.length === 0) return ".";
        path2 = this.toPosix(path2);
        let code = path2.charCodeAt(0);
        const hasRoot = code === 47;
        let end = -1, matchedSlash = !0;
        const proto = this.getProtocol(path2), origpath = path2;
        path2 = path2.slice(proto.length);
        for(let i = path2.length - 1; i >= 1; --i)if (code = path2.charCodeAt(i), code === 47) {
            if (!matchedSlash) {
                end = i;
                break;
            }
        } else matchedSlash = !1;
        return end === -1 ? hasRoot ? "/" : this.isUrl(origpath) ? proto + path2 : proto : hasRoot && end === 1 ? "//" : proto + path2.slice(0, end);
    },
    /**
   * Returns the root of the path e.g. /, C:/, file:///, http://domain.com/
   * @param path - The path to parse
   */ rootname (path2) {
        $6f112ebca2b77b27$var$assertPath(path2), path2 = this.toPosix(path2);
        let root = "";
        if (path2.startsWith("/") ? root = "/" : root = this.getProtocol(path2), this.isUrl(path2)) {
            const index = path2.indexOf("/", root.length);
            index !== -1 ? root = path2.slice(0, index) : root = path2, root.endsWith("/") || (root += "/");
        }
        return root;
    },
    /**
   * Returns the last portion of a path
   * @param path - The path to test
   * @param ext - Optional extension to remove
   */ basename (path2, ext) {
        $6f112ebca2b77b27$var$assertPath(path2), ext && $6f112ebca2b77b27$var$assertPath(ext), path2 = $6f112ebca2b77b27$var$removeUrlParams(this.toPosix(path2));
        let start = 0, end = -1, matchedSlash = !0, i;
        if (ext !== void 0 && ext.length > 0 && ext.length <= path2.length) {
            if (ext.length === path2.length && ext === path2) return "";
            let extIdx = ext.length - 1, firstNonSlashEnd = -1;
            for(i = path2.length - 1; i >= 0; --i){
                const code = path2.charCodeAt(i);
                if (code === 47) {
                    if (!matchedSlash) {
                        start = i + 1;
                        break;
                    }
                } else firstNonSlashEnd === -1 && (matchedSlash = !1, firstNonSlashEnd = i + 1), extIdx >= 0 && (code === ext.charCodeAt(extIdx) ? --extIdx === -1 && (end = i) : (extIdx = -1, end = firstNonSlashEnd));
            }
            return start === end ? end = firstNonSlashEnd : end === -1 && (end = path2.length), path2.slice(start, end);
        }
        for(i = path2.length - 1; i >= 0; --i)if (path2.charCodeAt(i) === 47) {
            if (!matchedSlash) {
                start = i + 1;
                break;
            }
        } else end === -1 && (matchedSlash = !1, end = i + 1);
        return end === -1 ? "" : path2.slice(start, end);
    },
    /**
   * Returns the extension of the path, from the last occurrence of the . (period) character to end of string in the last
   * portion of the path. If there is no . in the last portion of the path, or if there are no . characters other than
   * the first character of the basename of path, an empty string is returned.
   * @param path - The path to parse
   */ extname (path2) {
        $6f112ebca2b77b27$var$assertPath(path2), path2 = $6f112ebca2b77b27$var$removeUrlParams(this.toPosix(path2));
        let startDot = -1, startPart = 0, end = -1, matchedSlash = !0, preDotState = 0;
        for(let i = path2.length - 1; i >= 0; --i){
            const code = path2.charCodeAt(i);
            if (code === 47) {
                if (!matchedSlash) {
                    startPart = i + 1;
                    break;
                }
                continue;
            }
            end === -1 && (matchedSlash = !1, end = i + 1), code === 46 ? startDot === -1 ? startDot = i : preDotState !== 1 && (preDotState = 1) : startDot !== -1 && (preDotState = -1);
        }
        return startDot === -1 || end === -1 || preDotState === 0 || preDotState === 1 && startDot === end - 1 && startDot === startPart + 1 ? "" : path2.slice(startDot, end);
    },
    /**
   * Parses a path into an object containing the 'root', `dir`, `base`, `ext`, and `name` properties.
   * @param path - The path to parse
   */ parse (path2) {
        $6f112ebca2b77b27$var$assertPath(path2);
        const ret = {
            root: "",
            dir: "",
            base: "",
            ext: "",
            name: ""
        };
        if (path2.length === 0) return ret;
        path2 = $6f112ebca2b77b27$var$removeUrlParams(this.toPosix(path2));
        let code = path2.charCodeAt(0);
        const isAbsolute = this.isAbsolute(path2);
        let start;
        const protocol = "";
        ret.root = this.rootname(path2), isAbsolute || this.hasProtocol(path2) ? start = 1 : start = 0;
        let startDot = -1, startPart = 0, end = -1, matchedSlash = !0, i = path2.length - 1, preDotState = 0;
        for(; i >= start; --i){
            if (code = path2.charCodeAt(i), code === 47) {
                if (!matchedSlash) {
                    startPart = i + 1;
                    break;
                }
                continue;
            }
            end === -1 && (matchedSlash = !1, end = i + 1), code === 46 ? startDot === -1 ? startDot = i : preDotState !== 1 && (preDotState = 1) : startDot !== -1 && (preDotState = -1);
        }
        return startDot === -1 || end === -1 || preDotState === 0 || preDotState === 1 && startDot === end - 1 && startDot === startPart + 1 ? end !== -1 && (startPart === 0 && isAbsolute ? ret.base = ret.name = path2.slice(1, end) : ret.base = ret.name = path2.slice(startPart, end)) : (startPart === 0 && isAbsolute ? (ret.name = path2.slice(1, startDot), ret.base = path2.slice(1, end)) : (ret.name = path2.slice(startPart, startDot), ret.base = path2.slice(startPart, end)), ret.ext = path2.slice(startDot, end)), ret.dir = this.dirname(path2), protocol && (ret.dir = protocol + ret.dir), ret;
    },
    sep: "/",
    delimiter: ":"
};



let $447db3a6235c3d92$var$promise;
async function $447db3a6235c3d92$export$8df68d58aae31877() {
    return $447db3a6235c3d92$var$promise ?? ($447db3a6235c3d92$var$promise = (async ()=>{
        const gl = document.createElement("canvas").getContext("webgl");
        if (!gl) return (0, $0fa4b07f86297abd$export$d56550d454401b73).UNPACK;
        const video = await new Promise((resolve)=>{
            const video2 = document.createElement("video");
            video2.onloadeddata = ()=>resolve(video2), video2.onerror = ()=>resolve(null), video2.autoplay = !1, video2.crossOrigin = "anonymous", video2.preload = "auto", video2.src = "data:video/webm;base64,GkXfo59ChoEBQveBAULygQRC84EIQoKEd2VibUKHgQJChYECGFOAZwEAAAAAAAHTEU2bdLpNu4tTq4QVSalmU6yBoU27i1OrhBZUrmtTrIHGTbuMU6uEElTDZ1OsggEXTbuMU6uEHFO7a1OsggG97AEAAAAAAABZAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAVSalmoCrXsYMPQkBNgIRMYXZmV0GETGF2ZkSJiEBEAAAAAAAAFlSua8yuAQAAAAAAAEPXgQFzxYgAAAAAAAAAAZyBACK1nIN1bmSIgQCGhVZfVlA5g4EBI+ODhAJiWgDglLCBArqBApqBAlPAgQFVsIRVuYEBElTDZ9Vzc9JjwItjxYgAAAAAAAAAAWfInEWjh0VOQ09ERVJEh49MYXZjIGxpYnZweC12cDlnyKJFo4hEVVJBVElPTkSHlDAwOjAwOjAwLjA0MDAwMDAwMAAAH0O2dcfngQCgwqGggQAAAIJJg0IAABAAFgA4JBwYSgAAICAAEb///4r+AAB1oZ2mm+6BAaWWgkmDQgAAEAAWADgkHBhKAAAgIABIQBxTu2uRu4+zgQC3iveBAfGCAXHwgQM=", video2.load();
        });
        if (!video) return (0, $0fa4b07f86297abd$export$d56550d454401b73).UNPACK;
        const texture = gl.createTexture();
        gl.bindTexture(gl.TEXTURE_2D, texture);
        const framebuffer = gl.createFramebuffer();
        gl.bindFramebuffer(gl.FRAMEBUFFER, framebuffer), gl.framebufferTexture2D(gl.FRAMEBUFFER, gl.COLOR_ATTACHMENT0, gl.TEXTURE_2D, texture, 0), gl.pixelStorei(gl.UNPACK_PREMULTIPLY_ALPHA_WEBGL, !1), gl.pixelStorei(gl.UNPACK_COLORSPACE_CONVERSION_WEBGL, gl.NONE), gl.texImage2D(gl.TEXTURE_2D, 0, gl.RGBA, gl.RGBA, gl.UNSIGNED_BYTE, video);
        const pixel = new Uint8Array(4);
        return gl.readPixels(0, 0, 1, 1, gl.RGBA, gl.UNSIGNED_BYTE, pixel), gl.deleteFramebuffer(framebuffer), gl.deleteTexture(texture), gl.getExtension("WEBGL_lose_context")?.loseContext(), pixel[0] <= pixel[3] ? (0, $0fa4b07f86297abd$export$d56550d454401b73).PMA : (0, $0fa4b07f86297abd$export$d56550d454401b73).UNPACK;
    })()), $447db3a6235c3d92$var$promise;
}



function $8ed8006a7e1df906$export$702210f86367d7ed() {
    (0, $397b7871568e248b$export$afd31d834b512e89)("7.0.0", "skipHello is deprecated, please use settings.RENDER_OPTIONS.hello");
}
function $8ed8006a7e1df906$export$2c6a96c059a06e7c() {
    (0, $397b7871568e248b$export$afd31d834b512e89)("7.0.0", `sayHello is deprecated, please use Renderer's "hello" option`);
}




let $9f5163a850bf3393$var$supported;
function $9f5163a850bf3393$export$83dc396b76015322() {
    return typeof $9f5163a850bf3393$var$supported > "u" && ($9f5163a850bf3393$var$supported = function() {
        const contextOptions = {
            stencil: !0,
            failIfMajorPerformanceCaveat: (0, $2808efac47e52be0$export$a5a6e0b888b2c992).FAIL_IF_MAJOR_PERFORMANCE_CAVEAT
        };
        try {
            if (!(0, $2808efac47e52be0$export$a5a6e0b888b2c992).ADAPTER.getWebGLRenderingContext()) return !1;
            const canvas = (0, $2808efac47e52be0$export$a5a6e0b888b2c992).ADAPTER.createCanvas();
            let gl = canvas.getContext("webgl", contextOptions) || canvas.getContext("experimental-webgl", contextOptions);
            const success = !!gl?.getContextAttributes()?.stencil;
            if (gl) {
                const loseContext = gl.getExtension("WEBGL_lose_context");
                loseContext && loseContext.loseContext();
            }
            return gl = null, success;
        } catch  {
            return !1;
        }
    }()), $9f5163a850bf3393$var$supported;
}


var $3bb71f89d2bc0c43$var$r = {
    grad: .9,
    turn: 360,
    rad: 360 / (2 * Math.PI)
}, $3bb71f89d2bc0c43$var$t = function(r) {
    return "string" == typeof r ? r.length > 0 : "number" == typeof r;
}, $3bb71f89d2bc0c43$var$n = function(r, t, n) {
    return void 0 === t && (t = 0), void 0 === n && (n = Math.pow(10, t)), Math.round(n * r) / n + 0;
}, $3bb71f89d2bc0c43$var$e = function(r, t, n) {
    return void 0 === t && (t = 0), void 0 === n && (n = 1), r > n ? n : r > t ? r : t;
}, $3bb71f89d2bc0c43$var$u = function(r) {
    return (r = isFinite(r) ? r % 360 : 0) > 0 ? r : r + 360;
}, $3bb71f89d2bc0c43$var$a = function(r) {
    return {
        r: $3bb71f89d2bc0c43$var$e(r.r, 0, 255),
        g: $3bb71f89d2bc0c43$var$e(r.g, 0, 255),
        b: $3bb71f89d2bc0c43$var$e(r.b, 0, 255),
        a: $3bb71f89d2bc0c43$var$e(r.a)
    };
}, $3bb71f89d2bc0c43$var$o = function(r) {
    return {
        r: $3bb71f89d2bc0c43$var$n(r.r),
        g: $3bb71f89d2bc0c43$var$n(r.g),
        b: $3bb71f89d2bc0c43$var$n(r.b),
        a: $3bb71f89d2bc0c43$var$n(r.a, 3)
    };
}, $3bb71f89d2bc0c43$var$i = /^#([0-9a-f]{3,8})$/i, $3bb71f89d2bc0c43$var$s = function(r) {
    var t = r.toString(16);
    return t.length < 2 ? "0" + t : t;
}, $3bb71f89d2bc0c43$var$h = function(r) {
    var t = r.r, n = r.g, e = r.b, u = r.a, a = Math.max(t, n, e), o = a - Math.min(t, n, e), i = o ? a === t ? (n - e) / o : a === n ? 2 + (e - t) / o : 4 + (t - n) / o : 0;
    return {
        h: 60 * (i < 0 ? i + 6 : i),
        s: a ? o / a * 100 : 0,
        v: a / 255 * 100,
        a: u
    };
}, $3bb71f89d2bc0c43$var$b = function(r) {
    var t = r.h, n = r.s, e = r.v, u = r.a;
    t = t / 360 * 6, n /= 100, e /= 100;
    var a = Math.floor(t), o = e * (1 - n), i = e * (1 - (t - a) * n), s = e * (1 - (1 - t + a) * n), h = a % 6;
    return {
        r: 255 * [
            e,
            i,
            o,
            o,
            s,
            e
        ][h],
        g: 255 * [
            s,
            e,
            e,
            i,
            o,
            o
        ][h],
        b: 255 * [
            o,
            o,
            s,
            e,
            e,
            i
        ][h],
        a: u
    };
}, $3bb71f89d2bc0c43$var$g = function(r) {
    return {
        h: $3bb71f89d2bc0c43$var$u(r.h),
        s: $3bb71f89d2bc0c43$var$e(r.s, 0, 100),
        l: $3bb71f89d2bc0c43$var$e(r.l, 0, 100),
        a: $3bb71f89d2bc0c43$var$e(r.a)
    };
}, $3bb71f89d2bc0c43$var$d = function(r) {
    return {
        h: $3bb71f89d2bc0c43$var$n(r.h),
        s: $3bb71f89d2bc0c43$var$n(r.s),
        l: $3bb71f89d2bc0c43$var$n(r.l),
        a: $3bb71f89d2bc0c43$var$n(r.a, 3)
    };
}, $3bb71f89d2bc0c43$var$f = function(r) {
    var t, n, e;
    return $3bb71f89d2bc0c43$var$b((n = (t = r).s, {
        h: t.h,
        s: (n *= ((e = t.l) < 50 ? e : 100 - e) / 100) > 0 ? 2 * n / (e + n) * 100 : 0,
        v: e + n,
        a: t.a
    }));
}, $3bb71f89d2bc0c43$var$c = function(r) {
    var t, n, e, u;
    return {
        h: (t = $3bb71f89d2bc0c43$var$h(r)).h,
        s: (u = (200 - (n = t.s)) * (e = t.v) / 100) > 0 && u < 200 ? n * e / 100 / (u <= 100 ? u : 200 - u) * 100 : 0,
        l: u / 2,
        a: t.a
    };
}, $3bb71f89d2bc0c43$var$l = /^hsla?\(\s*([+-]?\d*\.?\d+)(deg|rad|grad|turn)?\s*,\s*([+-]?\d*\.?\d+)%\s*,\s*([+-]?\d*\.?\d+)%\s*(?:,\s*([+-]?\d*\.?\d+)(%)?\s*)?\)$/i, $3bb71f89d2bc0c43$var$p = /^hsla?\(\s*([+-]?\d*\.?\d+)(deg|rad|grad|turn)?\s+([+-]?\d*\.?\d+)%\s+([+-]?\d*\.?\d+)%\s*(?:\/\s*([+-]?\d*\.?\d+)(%)?\s*)?\)$/i, $3bb71f89d2bc0c43$var$v = /^rgba?\(\s*([+-]?\d*\.?\d+)(%)?\s*,\s*([+-]?\d*\.?\d+)(%)?\s*,\s*([+-]?\d*\.?\d+)(%)?\s*(?:,\s*([+-]?\d*\.?\d+)(%)?\s*)?\)$/i, $3bb71f89d2bc0c43$var$m = /^rgba?\(\s*([+-]?\d*\.?\d+)(%)?\s+([+-]?\d*\.?\d+)(%)?\s+([+-]?\d*\.?\d+)(%)?\s*(?:\/\s*([+-]?\d*\.?\d+)(%)?\s*)?\)$/i, $3bb71f89d2bc0c43$var$y = {
    string: [
        [
            function(r) {
                var t = $3bb71f89d2bc0c43$var$i.exec(r);
                return t ? (r = t[1]).length <= 4 ? {
                    r: parseInt(r[0] + r[0], 16),
                    g: parseInt(r[1] + r[1], 16),
                    b: parseInt(r[2] + r[2], 16),
                    a: 4 === r.length ? $3bb71f89d2bc0c43$var$n(parseInt(r[3] + r[3], 16) / 255, 2) : 1
                } : 6 === r.length || 8 === r.length ? {
                    r: parseInt(r.substr(0, 2), 16),
                    g: parseInt(r.substr(2, 2), 16),
                    b: parseInt(r.substr(4, 2), 16),
                    a: 8 === r.length ? $3bb71f89d2bc0c43$var$n(parseInt(r.substr(6, 2), 16) / 255, 2) : 1
                } : null : null;
            },
            "hex"
        ],
        [
            function(r) {
                var t = $3bb71f89d2bc0c43$var$v.exec(r) || $3bb71f89d2bc0c43$var$m.exec(r);
                return t ? t[2] !== t[4] || t[4] !== t[6] ? null : $3bb71f89d2bc0c43$var$a({
                    r: Number(t[1]) / (t[2] ? 100 / 255 : 1),
                    g: Number(t[3]) / (t[4] ? 100 / 255 : 1),
                    b: Number(t[5]) / (t[6] ? 100 / 255 : 1),
                    a: void 0 === t[7] ? 1 : Number(t[7]) / (t[8] ? 100 : 1)
                }) : null;
            },
            "rgb"
        ],
        [
            function(t) {
                var n = $3bb71f89d2bc0c43$var$l.exec(t) || $3bb71f89d2bc0c43$var$p.exec(t);
                if (!n) return null;
                var e, u, a = $3bb71f89d2bc0c43$var$g({
                    h: (e = n[1], u = n[2], void 0 === u && (u = "deg"), Number(e) * ($3bb71f89d2bc0c43$var$r[u] || 1)),
                    s: Number(n[3]),
                    l: Number(n[4]),
                    a: void 0 === n[5] ? 1 : Number(n[5]) / (n[6] ? 100 : 1)
                });
                return $3bb71f89d2bc0c43$var$f(a);
            },
            "hsl"
        ]
    ],
    object: [
        [
            function(r) {
                var n = r.r, e = r.g, u = r.b, o = r.a, i = void 0 === o ? 1 : o;
                return $3bb71f89d2bc0c43$var$t(n) && $3bb71f89d2bc0c43$var$t(e) && $3bb71f89d2bc0c43$var$t(u) ? $3bb71f89d2bc0c43$var$a({
                    r: Number(n),
                    g: Number(e),
                    b: Number(u),
                    a: Number(i)
                }) : null;
            },
            "rgb"
        ],
        [
            function(r) {
                var n = r.h, e = r.s, u = r.l, a = r.a, o = void 0 === a ? 1 : a;
                if (!$3bb71f89d2bc0c43$var$t(n) || !$3bb71f89d2bc0c43$var$t(e) || !$3bb71f89d2bc0c43$var$t(u)) return null;
                var i = $3bb71f89d2bc0c43$var$g({
                    h: Number(n),
                    s: Number(e),
                    l: Number(u),
                    a: Number(o)
                });
                return $3bb71f89d2bc0c43$var$f(i);
            },
            "hsl"
        ],
        [
            function(r) {
                var n = r.h, a = r.s, o = r.v, i = r.a, s = void 0 === i ? 1 : i;
                if (!$3bb71f89d2bc0c43$var$t(n) || !$3bb71f89d2bc0c43$var$t(a) || !$3bb71f89d2bc0c43$var$t(o)) return null;
                var h = function(r) {
                    return {
                        h: $3bb71f89d2bc0c43$var$u(r.h),
                        s: $3bb71f89d2bc0c43$var$e(r.s, 0, 100),
                        v: $3bb71f89d2bc0c43$var$e(r.v, 0, 100),
                        a: $3bb71f89d2bc0c43$var$e(r.a)
                    };
                }({
                    h: Number(n),
                    s: Number(a),
                    v: Number(o),
                    a: Number(s)
                });
                return $3bb71f89d2bc0c43$var$b(h);
            },
            "hsv"
        ]
    ]
}, $3bb71f89d2bc0c43$var$N = function(r, t) {
    for(var n = 0; n < t.length; n++){
        var e = t[n][0](r);
        if (e) return [
            e,
            t[n][1]
        ];
    }
    return [
        null,
        void 0
    ];
}, $3bb71f89d2bc0c43$var$x = function(r) {
    return "string" == typeof r ? $3bb71f89d2bc0c43$var$N(r.trim(), $3bb71f89d2bc0c43$var$y.string) : "object" == typeof r && null !== r ? $3bb71f89d2bc0c43$var$N(r, $3bb71f89d2bc0c43$var$y.object) : [
        null,
        void 0
    ];
}, $3bb71f89d2bc0c43$export$f61ac8b6f1f46202 = function(r) {
    return $3bb71f89d2bc0c43$var$x(r)[1];
}, $3bb71f89d2bc0c43$var$M = function(r, t) {
    var n = $3bb71f89d2bc0c43$var$c(r);
    return {
        h: n.h,
        s: $3bb71f89d2bc0c43$var$e(n.s + 100 * t, 0, 100),
        l: n.l,
        a: n.a
    };
}, $3bb71f89d2bc0c43$var$H = function(r) {
    return (299 * r.r + 587 * r.g + 114 * r.b) / 1e3 / 255;
}, $3bb71f89d2bc0c43$var$$ = function(r, t) {
    var n = $3bb71f89d2bc0c43$var$c(r);
    return {
        h: n.h,
        s: n.s,
        l: $3bb71f89d2bc0c43$var$e(n.l + 100 * t, 0, 100),
        a: n.a
    };
}, $3bb71f89d2bc0c43$export$4d30ed660ff08d0 = function() {
    function r(r) {
        this.parsed = $3bb71f89d2bc0c43$var$x(r)[0], this.rgba = this.parsed || {
            r: 0,
            g: 0,
            b: 0,
            a: 1
        };
    }
    return r.prototype.isValid = function() {
        return null !== this.parsed;
    }, r.prototype.brightness = function() {
        return $3bb71f89d2bc0c43$var$n($3bb71f89d2bc0c43$var$H(this.rgba), 2);
    }, r.prototype.isDark = function() {
        return $3bb71f89d2bc0c43$var$H(this.rgba) < .5;
    }, r.prototype.isLight = function() {
        return $3bb71f89d2bc0c43$var$H(this.rgba) >= .5;
    }, r.prototype.toHex = function() {
        var r, t, e, u, a, i;
        return r = $3bb71f89d2bc0c43$var$o(this.rgba), t = r.r, e = r.g, u = r.b, i = (a = r.a) < 1 ? $3bb71f89d2bc0c43$var$s($3bb71f89d2bc0c43$var$n(255 * a)) : "", "#" + $3bb71f89d2bc0c43$var$s(t) + $3bb71f89d2bc0c43$var$s(e) + $3bb71f89d2bc0c43$var$s(u) + i;
    }, r.prototype.toRgb = function() {
        return $3bb71f89d2bc0c43$var$o(this.rgba);
    }, r.prototype.toRgbString = function() {
        var r, t, n, e, u;
        return r = $3bb71f89d2bc0c43$var$o(this.rgba), t = r.r, n = r.g, e = r.b, (u = r.a) < 1 ? "rgba(" + t + ", " + n + ", " + e + ", " + u + ")" : "rgb(" + t + ", " + n + ", " + e + ")";
    }, r.prototype.toHsl = function() {
        return $3bb71f89d2bc0c43$var$d($3bb71f89d2bc0c43$var$c(this.rgba));
    }, r.prototype.toHslString = function() {
        var r, t, n, e, u;
        return r = $3bb71f89d2bc0c43$var$d($3bb71f89d2bc0c43$var$c(this.rgba)), t = r.h, n = r.s, e = r.l, (u = r.a) < 1 ? "hsla(" + t + ", " + n + "%, " + e + "%, " + u + ")" : "hsl(" + t + ", " + n + "%, " + e + "%)";
    }, r.prototype.toHsv = function() {
        var r;
        return r = $3bb71f89d2bc0c43$var$h(this.rgba), {
            h: $3bb71f89d2bc0c43$var$n(r.h),
            s: $3bb71f89d2bc0c43$var$n(r.s),
            v: $3bb71f89d2bc0c43$var$n(r.v),
            a: $3bb71f89d2bc0c43$var$n(r.a, 3)
        };
    }, r.prototype.invert = function() {
        var r;
        return $3bb71f89d2bc0c43$export$c8efe09109f9cb9e({
            r: 255 - (r = this.rgba).r,
            g: 255 - r.g,
            b: 255 - r.b,
            a: r.a
        });
    }, r.prototype.saturate = function(r) {
        return void 0 === r && (r = .1), $3bb71f89d2bc0c43$export$c8efe09109f9cb9e($3bb71f89d2bc0c43$var$M(this.rgba, r));
    }, r.prototype.desaturate = function(r) {
        return void 0 === r && (r = .1), $3bb71f89d2bc0c43$export$c8efe09109f9cb9e($3bb71f89d2bc0c43$var$M(this.rgba, -r));
    }, r.prototype.grayscale = function() {
        return $3bb71f89d2bc0c43$export$c8efe09109f9cb9e($3bb71f89d2bc0c43$var$M(this.rgba, -1));
    }, r.prototype.lighten = function(r) {
        return void 0 === r && (r = .1), $3bb71f89d2bc0c43$export$c8efe09109f9cb9e($3bb71f89d2bc0c43$var$$(this.rgba, r));
    }, r.prototype.darken = function(r) {
        return void 0 === r && (r = .1), $3bb71f89d2bc0c43$export$c8efe09109f9cb9e($3bb71f89d2bc0c43$var$$(this.rgba, -r));
    }, r.prototype.rotate = function(r) {
        return void 0 === r && (r = 15), this.hue(this.hue() + r);
    }, r.prototype.alpha = function(r) {
        var t;
        return "number" == typeof r ? $3bb71f89d2bc0c43$export$c8efe09109f9cb9e({
            r: (t = this.rgba).r,
            g: t.g,
            b: t.b,
            a: r
        }) : $3bb71f89d2bc0c43$var$n(this.rgba.a, 3);
    }, r.prototype.hue = function(r) {
        var t = $3bb71f89d2bc0c43$var$c(this.rgba);
        return "number" == typeof r ? $3bb71f89d2bc0c43$export$c8efe09109f9cb9e({
            h: r,
            s: t.s,
            l: t.l,
            a: t.a
        }) : $3bb71f89d2bc0c43$var$n(t.h);
    }, r.prototype.isEqual = function(r) {
        return this.toHex() === $3bb71f89d2bc0c43$export$c8efe09109f9cb9e(r).toHex();
    }, r;
}(), $3bb71f89d2bc0c43$export$c8efe09109f9cb9e = function(r) {
    return r instanceof $3bb71f89d2bc0c43$export$4d30ed660ff08d0 ? r : new $3bb71f89d2bc0c43$export$4d30ed660ff08d0(r);
}, $3bb71f89d2bc0c43$var$S = [], $3bb71f89d2bc0c43$export$8b58be045bf06082 = function(r) {
    r.forEach(function(r) {
        $3bb71f89d2bc0c43$var$S.indexOf(r) < 0 && (r($3bb71f89d2bc0c43$export$4d30ed660ff08d0, $3bb71f89d2bc0c43$var$y), $3bb71f89d2bc0c43$var$S.push(r));
    });
}, $3bb71f89d2bc0c43$export$4385e60b38654f68 = function() {
    return new $3bb71f89d2bc0c43$export$4d30ed660ff08d0({
        r: 255 * Math.random(),
        g: 255 * Math.random(),
        b: 255 * Math.random()
    });
};


function $7cea3a4ab900282e$export$2e2bcd8739ae039(e, f) {
    var a = {
        white: "#ffffff",
        bisque: "#ffe4c4",
        blue: "#0000ff",
        cadetblue: "#5f9ea0",
        chartreuse: "#7fff00",
        chocolate: "#d2691e",
        coral: "#ff7f50",
        antiquewhite: "#faebd7",
        aqua: "#00ffff",
        azure: "#f0ffff",
        whitesmoke: "#f5f5f5",
        papayawhip: "#ffefd5",
        plum: "#dda0dd",
        blanchedalmond: "#ffebcd",
        black: "#000000",
        gold: "#ffd700",
        goldenrod: "#daa520",
        gainsboro: "#dcdcdc",
        cornsilk: "#fff8dc",
        cornflowerblue: "#6495ed",
        burlywood: "#deb887",
        aquamarine: "#7fffd4",
        beige: "#f5f5dc",
        crimson: "#dc143c",
        cyan: "#00ffff",
        darkblue: "#00008b",
        darkcyan: "#008b8b",
        darkgoldenrod: "#b8860b",
        darkkhaki: "#bdb76b",
        darkgray: "#a9a9a9",
        darkgreen: "#006400",
        darkgrey: "#a9a9a9",
        peachpuff: "#ffdab9",
        darkmagenta: "#8b008b",
        darkred: "#8b0000",
        darkorchid: "#9932cc",
        darkorange: "#ff8c00",
        darkslateblue: "#483d8b",
        gray: "#808080",
        darkslategray: "#2f4f4f",
        darkslategrey: "#2f4f4f",
        deeppink: "#ff1493",
        deepskyblue: "#00bfff",
        wheat: "#f5deb3",
        firebrick: "#b22222",
        floralwhite: "#fffaf0",
        ghostwhite: "#f8f8ff",
        darkviolet: "#9400d3",
        magenta: "#ff00ff",
        green: "#008000",
        dodgerblue: "#1e90ff",
        grey: "#808080",
        honeydew: "#f0fff0",
        hotpink: "#ff69b4",
        blueviolet: "#8a2be2",
        forestgreen: "#228b22",
        lawngreen: "#7cfc00",
        indianred: "#cd5c5c",
        indigo: "#4b0082",
        fuchsia: "#ff00ff",
        brown: "#a52a2a",
        maroon: "#800000",
        mediumblue: "#0000cd",
        lightcoral: "#f08080",
        darkturquoise: "#00ced1",
        lightcyan: "#e0ffff",
        ivory: "#fffff0",
        lightyellow: "#ffffe0",
        lightsalmon: "#ffa07a",
        lightseagreen: "#20b2aa",
        linen: "#faf0e6",
        mediumaquamarine: "#66cdaa",
        lemonchiffon: "#fffacd",
        lime: "#00ff00",
        khaki: "#f0e68c",
        mediumseagreen: "#3cb371",
        limegreen: "#32cd32",
        mediumspringgreen: "#00fa9a",
        lightskyblue: "#87cefa",
        lightblue: "#add8e6",
        midnightblue: "#191970",
        lightpink: "#ffb6c1",
        mistyrose: "#ffe4e1",
        moccasin: "#ffe4b5",
        mintcream: "#f5fffa",
        lightslategray: "#778899",
        lightslategrey: "#778899",
        navajowhite: "#ffdead",
        navy: "#000080",
        mediumvioletred: "#c71585",
        powderblue: "#b0e0e6",
        palegoldenrod: "#eee8aa",
        oldlace: "#fdf5e6",
        paleturquoise: "#afeeee",
        mediumturquoise: "#48d1cc",
        mediumorchid: "#ba55d3",
        rebeccapurple: "#663399",
        lightsteelblue: "#b0c4de",
        mediumslateblue: "#7b68ee",
        thistle: "#d8bfd8",
        tan: "#d2b48c",
        orchid: "#da70d6",
        mediumpurple: "#9370db",
        purple: "#800080",
        pink: "#ffc0cb",
        skyblue: "#87ceeb",
        springgreen: "#00ff7f",
        palegreen: "#98fb98",
        red: "#ff0000",
        yellow: "#ffff00",
        slateblue: "#6a5acd",
        lavenderblush: "#fff0f5",
        peru: "#cd853f",
        palevioletred: "#db7093",
        violet: "#ee82ee",
        teal: "#008080",
        slategray: "#708090",
        slategrey: "#708090",
        aliceblue: "#f0f8ff",
        darkseagreen: "#8fbc8f",
        darkolivegreen: "#556b2f",
        greenyellow: "#adff2f",
        seagreen: "#2e8b57",
        seashell: "#fff5ee",
        tomato: "#ff6347",
        silver: "#c0c0c0",
        sienna: "#a0522d",
        lavender: "#e6e6fa",
        lightgreen: "#90ee90",
        orange: "#ffa500",
        orangered: "#ff4500",
        steelblue: "#4682b4",
        royalblue: "#4169e1",
        turquoise: "#40e0d0",
        yellowgreen: "#9acd32",
        salmon: "#fa8072",
        saddlebrown: "#8b4513",
        sandybrown: "#f4a460",
        rosybrown: "#bc8f8f",
        darksalmon: "#e9967a",
        lightgoldenrodyellow: "#fafad2",
        snow: "#fffafa",
        lightgrey: "#d3d3d3",
        lightgray: "#d3d3d3",
        dimgray: "#696969",
        dimgrey: "#696969",
        olivedrab: "#6b8e23",
        olive: "#808000"
    }, r = {};
    for(var d in a)r[a[d]] = d;
    var l = {};
    e.prototype.toName = function(f) {
        if (!(this.rgba.a || this.rgba.r || this.rgba.g || this.rgba.b)) return "transparent";
        var d, i, n = r[this.toHex()];
        if (n) return n;
        if (null == f ? void 0 : f.closest) {
            var o = this.toRgb(), t = 1 / 0, b = "black";
            if (!l.length) for(var c in a)l[c] = new e(a[c]).toRgb();
            for(var g in a){
                var u = (d = o, i = l[g], Math.pow(d.r - i.r, 2) + Math.pow(d.g - i.g, 2) + Math.pow(d.b - i.b, 2));
                u < t && (t = u, b = g);
            }
            return b;
        }
    };
    f.string.push([
        function(f) {
            var r = f.toLowerCase(), d = "transparent" === r ? "#0000" : a[r];
            return d ? new e(d).toRgb() : null;
        },
        "name"
    ]);
}


(0, $3bb71f89d2bc0c43$export$8b58be045bf06082)([
    (0, $7cea3a4ab900282e$export$2e2bcd8739ae039)
]);
const $15154c33c9e19c5f$var$_Color = class _Color2 {
    /**
   * @param {PIXI.ColorSource} value - Optional value to use, if not provided, white is used.
   */ constructor(value = 16777215){
        this._value = null, this._components = new Float32Array(4), this._components.fill(1), this._int = 16777215, this.value = value;
    }
    /** Get red component (0 - 1) */ get red() {
        return this._components[0];
    }
    /** Get green component (0 - 1) */ get green() {
        return this._components[1];
    }
    /** Get blue component (0 - 1) */ get blue() {
        return this._components[2];
    }
    /** Get alpha component (0 - 1) */ get alpha() {
        return this._components[3];
    }
    /**
   * Set the value, suitable for chaining
   * @param value
   * @see PIXI.Color.value
   */ setValue(value) {
        return this.value = value, this;
    }
    /**
   * The current color source.
   *
   * When setting:
   * - Setting to an instance of `Color` will copy its color source and components.
   * - Otherwise, `Color` will try to normalize the color source and set the components.
   *   If the color source is invalid, an `Error` will be thrown and the `Color` will left unchanged.
   *
   * Note: The `null` in the setter's parameter type is added to match the TypeScript rule: return type of getter
   * must be assignable to its setter's parameter type. Setting `value` to `null` will throw an `Error`.
   *
   * When getting:
   * - A return value of `null` means the previous value was overridden (e.g., {@link PIXI.Color.multiply multiply},
   *   {@link PIXI.Color.premultiply premultiply} or {@link PIXI.Color.round round}).
   * - Otherwise, the color source used when setting is returned.
   * @type {PIXI.ColorSource}
   */ set value(value) {
        if (value instanceof _Color2) this._value = this.cloneSource(value._value), this._int = value._int, this._components.set(value._components);
        else {
            if (value === null) throw new Error("Cannot set PIXI.Color#value to null");
            (this._value === null || !this.isSourceEqual(this._value, value)) && (this.normalize(value), this._value = this.cloneSource(value));
        }
    }
    get value() {
        return this._value;
    }
    /**
   * Copy a color source internally.
   * @param value - Color source
   */ cloneSource(value) {
        return typeof value == "string" || typeof value == "number" || value instanceof Number || value === null ? value : Array.isArray(value) || ArrayBuffer.isView(value) ? value.slice(0) : typeof value == "object" && value !== null ? {
            ...value
        } : value;
    }
    /**
   * Equality check for color sources.
   * @param value1 - First color source
   * @param value2 - Second color source
   * @returns `true` if the color sources are equal, `false` otherwise.
   */ isSourceEqual(value1, value2) {
        const type1 = typeof value1;
        if (type1 !== typeof value2) return !1;
        if (type1 === "number" || type1 === "string" || value1 instanceof Number) return value1 === value2;
        if (Array.isArray(value1) && Array.isArray(value2) || ArrayBuffer.isView(value1) && ArrayBuffer.isView(value2)) return value1.length !== value2.length ? !1 : value1.every((v, i)=>v === value2[i]);
        if (value1 !== null && value2 !== null) {
            const keys1 = Object.keys(value1), keys2 = Object.keys(value2);
            return keys1.length !== keys2.length ? !1 : keys1.every((key)=>value1[key] === value2[key]);
        }
        return value1 === value2;
    }
    /**
   * Convert to a RGBA color object.
   * @example
   * import { Color } from 'pixi.js';
   * new Color('white').toRgb(); // returns { r: 1, g: 1, b: 1, a: 1 }
   */ toRgba() {
        const [r, g, b, a] = this._components;
        return {
            r: r,
            g: g,
            b: b,
            a: a
        };
    }
    /**
   * Convert to a RGB color object.
   * @example
   * import { Color } from 'pixi.js';
   * new Color('white').toRgb(); // returns { r: 1, g: 1, b: 1 }
   */ toRgb() {
        const [r, g, b] = this._components;
        return {
            r: r,
            g: g,
            b: b
        };
    }
    /** Convert to a CSS-style rgba string: `rgba(255,255,255,1.0)`. */ toRgbaString() {
        const [r, g, b] = this.toUint8RgbArray();
        return `rgba(${r},${g},${b},${this.alpha})`;
    }
    toUint8RgbArray(out) {
        const [r, g, b] = this._components;
        return out = out ?? [], out[0] = Math.round(r * 255), out[1] = Math.round(g * 255), out[2] = Math.round(b * 255), out;
    }
    toRgbArray(out) {
        out = out ?? [];
        const [r, g, b] = this._components;
        return out[0] = r, out[1] = g, out[2] = b, out;
    }
    /**
   * Convert to a hexadecimal number.
   * @example
   * import { Color } from 'pixi.js';
   * new Color('white').toNumber(); // returns 16777215
   */ toNumber() {
        return this._int;
    }
    /**
   * Convert to a hexadecimal number in little endian format (e.g., BBGGRR).
   * @example
   * import { Color } from 'pixi.js';
   * new Color(0xffcc99).toLittleEndianNumber(); // returns 0x99ccff
   * @returns {number} - The color as a number in little endian format.
   */ toLittleEndianNumber() {
        const value = this._int;
        return (value >> 16) + (value & 65280) + ((value & 255) << 16);
    }
    /**
   * Multiply with another color. This action is destructive, and will
   * override the previous `value` property to be `null`.
   * @param {PIXI.ColorSource} value - The color to multiply by.
   */ multiply(value) {
        const [r, g, b, a] = _Color2.temp.setValue(value)._components;
        return this._components[0] *= r, this._components[1] *= g, this._components[2] *= b, this._components[3] *= a, this.refreshInt(), this._value = null, this;
    }
    /**
   * Converts color to a premultiplied alpha format. This action is destructive, and will
   * override the previous `value` property to be `null`.
   * @param alpha - The alpha to multiply by.
   * @param {boolean} [applyToRGB=true] - Whether to premultiply RGB channels.
   * @returns {PIXI.Color} - Itself.
   */ premultiply(alpha, applyToRGB = !0) {
        return applyToRGB && (this._components[0] *= alpha, this._components[1] *= alpha, this._components[2] *= alpha), this._components[3] = alpha, this.refreshInt(), this._value = null, this;
    }
    /**
   * Premultiplies alpha with current color.
   * @param {number} alpha - The alpha to multiply by.
   * @param {boolean} [applyToRGB=true] - Whether to premultiply RGB channels.
   * @returns {number} tint multiplied by alpha
   */ toPremultiplied(alpha, applyToRGB = !0) {
        if (alpha === 1) return -16777216 + this._int;
        if (alpha === 0) return applyToRGB ? 0 : this._int;
        let r = this._int >> 16 & 255, g = this._int >> 8 & 255, b = this._int & 255;
        return applyToRGB && (r = r * alpha + 0.5 | 0, g = g * alpha + 0.5 | 0, b = b * alpha + 0.5 | 0), (alpha * 255 << 24) + (r << 16) + (g << 8) + b;
    }
    /**
   * Convert to a hexidecimal string.
   * @example
   * import { Color } from 'pixi.js';
   * new Color('white').toHex(); // returns "#ffffff"
   */ toHex() {
        const hexString = this._int.toString(16);
        return `#${"000000".substring(0, 6 - hexString.length) + hexString}`;
    }
    /**
   * Convert to a hexidecimal string with alpha.
   * @example
   * import { Color } from 'pixi.js';
   * new Color('white').toHexa(); // returns "#ffffffff"
   */ toHexa() {
        const alphaString = Math.round(this._components[3] * 255).toString(16);
        return this.toHex() + "00".substring(0, 2 - alphaString.length) + alphaString;
    }
    /**
   * Set alpha, suitable for chaining.
   * @param alpha
   */ setAlpha(alpha) {
        return this._components[3] = this._clamp(alpha), this;
    }
    /**
   * Rounds the specified color according to the step. This action is destructive, and will
   * override the previous `value` property to be `null`. The alpha component is not rounded.
   * @param steps - Number of steps which will be used as a cap when rounding colors
   * @deprecated since 7.3.0
   */ round(steps) {
        const [r, g, b] = this._components;
        return this._components[0] = Math.round(r * steps) / steps, this._components[1] = Math.round(g * steps) / steps, this._components[2] = Math.round(b * steps) / steps, this.refreshInt(), this._value = null, this;
    }
    toArray(out) {
        out = out ?? [];
        const [r, g, b, a] = this._components;
        return out[0] = r, out[1] = g, out[2] = b, out[3] = a, out;
    }
    /**
   * Normalize the input value into rgba
   * @param value - Input value
   */ normalize(value) {
        let r, g, b, a;
        if ((typeof value == "number" || value instanceof Number) && value >= 0 && value <= 16777215) {
            const int = value;
            r = (int >> 16 & 255) / 255, g = (int >> 8 & 255) / 255, b = (int & 255) / 255, a = 1;
        } else if ((Array.isArray(value) || value instanceof Float32Array) && value.length >= 3 && value.length <= 4) value = this._clamp(value), [r, g, b, a = 1] = value;
        else if ((value instanceof Uint8Array || value instanceof Uint8ClampedArray) && value.length >= 3 && value.length <= 4) value = this._clamp(value, 0, 255), [r, g, b, a = 255] = value, r /= 255, g /= 255, b /= 255, a /= 255;
        else if (typeof value == "string" || typeof value == "object") {
            if (typeof value == "string") {
                const match = _Color2.HEX_PATTERN.exec(value);
                match && (value = `#${match[2]}`);
            }
            const color = (0, $3bb71f89d2bc0c43$export$c8efe09109f9cb9e)(value);
            color.isValid() && ({ r: r, g: g, b: b, a: a } = color.rgba, r /= 255, g /= 255, b /= 255);
        }
        if (r !== void 0) this._components[0] = r, this._components[1] = g, this._components[2] = b, this._components[3] = a, this.refreshInt();
        else throw new Error(`Unable to convert color ${value}`);
    }
    /** Refresh the internal color rgb number */ refreshInt() {
        this._clamp(this._components);
        const [r, g, b] = this._components;
        this._int = (r * 255 << 16) + (g * 255 << 8) + (b * 255 | 0);
    }
    /**
   * Clamps values to a range. Will override original values
   * @param value - Value(s) to clamp
   * @param min - Minimum value
   * @param max - Maximum value
   */ _clamp(value, min = 0, max = 1) {
        return typeof value == "number" ? Math.min(Math.max(value, min), max) : (value.forEach((v, i)=>{
            value[i] = Math.min(Math.max(v, min), max);
        }), value);
    }
};
$15154c33c9e19c5f$var$_Color.shared = new $15154c33c9e19c5f$var$_Color(), /**
* Temporary Color object for static uses internally.
* As to not conflict with Color.shared.
* @ignore
*/ $15154c33c9e19c5f$var$_Color.temp = new $15154c33c9e19c5f$var$_Color(), /** Pattern for hex strings */ $15154c33c9e19c5f$var$_Color.HEX_PATTERN = /^(#|0x)?(([a-f0-9]{3}){1,2}([a-f0-9]{2})?)$/i;
let $15154c33c9e19c5f$export$892596cec99bc70e = $15154c33c9e19c5f$var$_Color;





function $e92df336c936c93a$export$858a46ce014e0e87(hex, out = []) {
    return (0, $397b7871568e248b$export$afd31d834b512e89)("7.2.0", "utils.hex2rgb is deprecated, use Color#toRgbArray instead"), (0, $15154c33c9e19c5f$export$892596cec99bc70e).shared.setValue(hex).toRgbArray(out);
}
function $e92df336c936c93a$export$7a57339af2222169(hex) {
    return (0, $397b7871568e248b$export$afd31d834b512e89)("7.2.0", "utils.hex2string is deprecated, use Color#toHex instead"), (0, $15154c33c9e19c5f$export$892596cec99bc70e).shared.setValue(hex).toHex();
}
function $e92df336c936c93a$export$f6a774610dbc2f6(string) {
    return (0, $397b7871568e248b$export$afd31d834b512e89)("7.2.0", "utils.string2hex is deprecated, use Color#toNumber instead"), (0, $15154c33c9e19c5f$export$892596cec99bc70e).shared.setValue(string).toNumber();
}
function $e92df336c936c93a$export$883528fb0afa7177(rgb) {
    return (0, $397b7871568e248b$export$afd31d834b512e89)("7.2.0", "utils.rgb2hex is deprecated, use Color#toNumber instead"), (0, $15154c33c9e19c5f$export$892596cec99bc70e).shared.setValue(rgb).toNumber();
}





function $e6ada961504cf12a$var$mapPremultipliedBlendModes() {
    const pm = [], npm = [];
    for(let i = 0; i < 32; i++)pm[i] = i, npm[i] = i;
    pm[(0, $0fa4b07f86297abd$export$f821c68fe9beaecf).NORMAL_NPM] = (0, $0fa4b07f86297abd$export$f821c68fe9beaecf).NORMAL, pm[(0, $0fa4b07f86297abd$export$f821c68fe9beaecf).ADD_NPM] = (0, $0fa4b07f86297abd$export$f821c68fe9beaecf).ADD, pm[(0, $0fa4b07f86297abd$export$f821c68fe9beaecf).SCREEN_NPM] = (0, $0fa4b07f86297abd$export$f821c68fe9beaecf).SCREEN, npm[(0, $0fa4b07f86297abd$export$f821c68fe9beaecf).NORMAL] = (0, $0fa4b07f86297abd$export$f821c68fe9beaecf).NORMAL_NPM, npm[(0, $0fa4b07f86297abd$export$f821c68fe9beaecf).ADD] = (0, $0fa4b07f86297abd$export$f821c68fe9beaecf).ADD_NPM, npm[(0, $0fa4b07f86297abd$export$f821c68fe9beaecf).SCREEN] = (0, $0fa4b07f86297abd$export$f821c68fe9beaecf).SCREEN_NPM;
    const array = [];
    return array.push(npm), array.push(pm), array;
}
const $e6ada961504cf12a$export$799d0d31e2f4c737 = $e6ada961504cf12a$var$mapPremultipliedBlendModes();
function $e6ada961504cf12a$export$3d793623cb0d1905(blendMode, premultiplied) {
    return $e6ada961504cf12a$export$799d0d31e2f4c737[premultiplied ? 1 : 0][blendMode];
}
function $e6ada961504cf12a$export$4fa4eaa2922d1869(rgb, alpha, out, premultiply = !0) {
    return (0, $397b7871568e248b$export$afd31d834b512e89)("7.2.0", "utils.premultiplyRgba has moved to Color.premultiply"), (0, $15154c33c9e19c5f$export$892596cec99bc70e).shared.setValue(rgb).premultiply(alpha, premultiply).toArray(out ?? new Float32Array(4));
}
function $e6ada961504cf12a$export$1ddadce6229d3efd(tint, alpha) {
    return (0, $397b7871568e248b$export$afd31d834b512e89)("7.2.0", "utils.premultiplyTint has moved to Color.toPremultiplied"), (0, $15154c33c9e19c5f$export$892596cec99bc70e).shared.setValue(tint).toPremultiplied(alpha);
}
function $e6ada961504cf12a$export$c75351d34304eb8c(tint, alpha, out, premultiply = !0) {
    return (0, $397b7871568e248b$export$afd31d834b512e89)("7.2.0", "utils.premultiplyTintToRgba has moved to Color.premultiply"), (0, $15154c33c9e19c5f$export$892596cec99bc70e).shared.setValue(tint).premultiply(alpha, premultiply).toArray(out ?? new Float32Array(4));
}


const $80ce1111ace5f2d1$export$dbafa72958753fce = /^\s*data:(?:([\w-]+)\/([\w+.-]+))?(?:;charset=([\w-]+))?(?:;(base64))?,(.*)/i;


function $b7f909d9d1427beb$export$c56148e1bec42281(size, outBuffer = null) {
    const totalIndices = size * 6;
    if (outBuffer = outBuffer || new Uint16Array(totalIndices), outBuffer.length !== totalIndices) throw new Error(`Out buffer length is incorrect, got ${outBuffer.length} and expected ${totalIndices}`);
    for(let i = 0, j = 0; i < totalIndices; i += 6, j += 4)outBuffer[i + 0] = j + 0, outBuffer[i + 1] = j + 1, outBuffer[i + 2] = j + 2, outBuffer[i + 3] = j + 0, outBuffer[i + 4] = j + 2, outBuffer[i + 5] = j + 3;
    return outBuffer;
}


function $511acc244d4a69e7$export$adf72b506413cb57(array) {
    if (array.BYTES_PER_ELEMENT === 4) return array instanceof Float32Array ? "Float32Array" : array instanceof Uint32Array ? "Uint32Array" : "Int32Array";
    if (array.BYTES_PER_ELEMENT === 2) {
        if (array instanceof Uint16Array) return "Uint16Array";
    } else if (array.BYTES_PER_ELEMENT === 1 && array instanceof Uint8Array) return "Uint8Array";
    return null;
}



const $e34bf865e0309867$var$map = {
    Float32Array: Float32Array,
    Uint32Array: Uint32Array,
    Int32Array: Int32Array,
    Uint8Array: Uint8Array
};
function $e34bf865e0309867$export$1ce3e224e969bb24(arrays, sizes) {
    let outSize = 0, stride = 0;
    const views = {};
    for(let i = 0; i < arrays.length; i++)stride += sizes[i], outSize += arrays[i].length;
    const buffer = new ArrayBuffer(outSize * 4);
    let out = null, littleOffset = 0;
    for(let i = 0; i < arrays.length; i++){
        const size = sizes[i], array = arrays[i], type = (0, $511acc244d4a69e7$export$adf72b506413cb57)(array);
        views[type] || (views[type] = new $e34bf865e0309867$var$map[type](buffer)), out = views[type];
        for(let j = 0; j < array.length; j++){
            const indexStart = (j / size | 0) * stride + littleOffset, index = j % size;
            out[indexStart + index] = array[j];
        }
        littleOffset += size;
    }
    return new Float32Array(buffer);
}


function $af2147baf6c30f74$export$f0d90cf68bd426eb(v) {
    return v += v === 0 ? 1 : 0, --v, v |= v >>> 1, v |= v >>> 2, v |= v >>> 4, v |= v >>> 8, v |= v >>> 16, v + 1;
}
function $af2147baf6c30f74$export$eb50b9c078eb6ae7(v) {
    return !(v & v - 1) && !!v;
}
function $af2147baf6c30f74$export$b9fae0bba9d9094d(v) {
    let r = (v > 65535 ? 1 : 0) << 4;
    v >>>= r;
    let shift = (v > 255 ? 1 : 0) << 3;
    return v >>>= shift, r |= shift, shift = (v > 15 ? 1 : 0) << 2, v >>>= shift, r |= shift, shift = (v > 3 ? 1 : 0) << 1, v >>>= shift, r |= shift, r | v >> 1;
}


function $0edf199a0064729e$export$8d47c0e1ce445404(arr, startIdx, removeCount) {
    const length = arr.length;
    let i;
    if (startIdx >= length || removeCount === 0) return;
    removeCount = startIdx + removeCount > length ? length - startIdx : removeCount;
    const len = length - removeCount;
    for(i = startIdx; i < len; ++i)arr[i] = arr[i + removeCount];
    arr.length = len;
}


function $4036e7f0605a6d07$export$c5552dfdbc7cec71(n) {
    return n === 0 ? 0 : n < 0 ? -1 : 1;
}


let $9444d853616ed05b$var$nextUid = 0;
function $9444d853616ed05b$export$e2a22331486dcca0() {
    return ++$9444d853616ed05b$var$nextUid;
}



const $8c72251601deb182$var$_BoundingBox = class {
    /**
   * @param left - The left coordinate value of the bounding box.
   * @param top - The top coordinate value of the bounding box.
   * @param right - The right coordinate value of the bounding box.
   * @param bottom - The bottom coordinate value of the bounding box.
   */ constructor(left, top, right, bottom){
        this.left = left, this.top = top, this.right = right, this.bottom = bottom;
    }
    /** The width of the bounding box. */ get width() {
        return this.right - this.left;
    }
    /** The height of the bounding box. */ get height() {
        return this.bottom - this.top;
    }
    /** Determines whether the BoundingBox is empty. */ isEmpty() {
        return this.left === this.right || this.top === this.bottom;
    }
};
$8c72251601deb182$var$_BoundingBox.EMPTY = new $8c72251601deb182$var$_BoundingBox(0, 0, 0, 0);
let $8c72251601deb182$export$63080c4de6cfc362 = $8c72251601deb182$var$_BoundingBox;


const $de0ca454f7b7a947$export$d47c7e291d8b6e2c = {}, $de0ca454f7b7a947$export$4254ab7c0971430e = /* @__PURE__ */ Object.create(null), $de0ca454f7b7a947$export$cec649a143d060b1 = /* @__PURE__ */ Object.create(null);
function $de0ca454f7b7a947$export$b5c9bc385f713d5a() {
    let key;
    for(key in $de0ca454f7b7a947$export$4254ab7c0971430e)$de0ca454f7b7a947$export$4254ab7c0971430e[key].destroy();
    for(key in $de0ca454f7b7a947$export$cec649a143d060b1)$de0ca454f7b7a947$export$cec649a143d060b1[key].destroy();
}
function $de0ca454f7b7a947$export$3ee9cef7c9878d34() {
    let key;
    for(key in $de0ca454f7b7a947$export$4254ab7c0971430e)delete $de0ca454f7b7a947$export$4254ab7c0971430e[key];
    for(key in $de0ca454f7b7a947$export$cec649a143d060b1)delete $de0ca454f7b7a947$export$cec649a143d060b1[key];
}



class $041ef324d9ecac55$export$525943d4c7cdfa38 {
    /**
   * @param width - the width for the newly created canvas
   * @param height - the height for the newly created canvas
   * @param {number} [resolution=PIXI.settings.RESOLUTION] - The resolution / device pixel ratio of the canvas
   */ constructor(width, height, resolution){
        this._canvas = (0, $2808efac47e52be0$export$a5a6e0b888b2c992).ADAPTER.createCanvas(), this._context = this._canvas.getContext("2d"), this.resolution = resolution || (0, $2808efac47e52be0$export$a5a6e0b888b2c992).RESOLUTION, this.resize(width, height);
    }
    /**
   * Clears the canvas that was created by the CanvasRenderTarget class.
   * @private
   */ clear() {
        this._checkDestroyed(), this._context.setTransform(1, 0, 0, 1, 0, 0), this._context.clearRect(0, 0, this._canvas.width, this._canvas.height);
    }
    /**
   * Resizes the canvas to the specified width and height.
   * @param desiredWidth - the desired width of the canvas
   * @param desiredHeight - the desired height of the canvas
   */ resize(desiredWidth, desiredHeight) {
        this._checkDestroyed(), this._canvas.width = Math.round(desiredWidth * this.resolution), this._canvas.height = Math.round(desiredHeight * this.resolution);
    }
    /** Destroys this canvas. */ destroy() {
        this._context = null, this._canvas = null;
    }
    /**
   * The width of the canvas buffer in pixels.
   * @member {number}
   */ get width() {
        return this._checkDestroyed(), this._canvas.width;
    }
    set width(val) {
        this._checkDestroyed(), this._canvas.width = Math.round(val);
    }
    /**
   * The height of the canvas buffer in pixels.
   * @member {number}
   */ get height() {
        return this._checkDestroyed(), this._canvas.height;
    }
    set height(val) {
        this._checkDestroyed(), this._canvas.height = Math.round(val);
    }
    /** The Canvas object that belongs to this CanvasRenderTarget. */ get canvas() {
        return this._checkDestroyed(), this._canvas;
    }
    /** A CanvasRenderingContext2D object representing a two-dimensional rendering context. */ get context() {
        return this._checkDestroyed(), this._context;
    }
    _checkDestroyed() {
        if (this._canvas === null) throw new TypeError("The CanvasRenderTarget has already been destroyed");
    }
}



function $36935cc9fee67cd3$var$checkRow(data, width, y) {
    for(let x = 0, index = 4 * y * width; x < width; ++x, index += 4)if (data[index + 3] !== 0) return !1;
    return !0;
}
function $36935cc9fee67cd3$var$checkColumn(data, width, x, top, bottom) {
    const stride = 4 * width;
    for(let y = top, index = top * stride + 4 * x; y <= bottom; ++y, index += stride)if (data[index + 3] !== 0) return !1;
    return !0;
}
function $36935cc9fee67cd3$export$550eedf6c679837d(canvas) {
    const { width: width, height: height } = canvas, context = canvas.getContext("2d", {
        willReadFrequently: !0
    });
    if (context === null) throw new TypeError("Failed to get canvas 2D context");
    const data = context.getImageData(0, 0, width, height).data;
    let left = 0, top = 0, right = width - 1, bottom = height - 1;
    for(; top < height && $36935cc9fee67cd3$var$checkRow(data, width, top);)++top;
    if (top === height) return (0, $8c72251601deb182$export$63080c4de6cfc362).EMPTY;
    for(; $36935cc9fee67cd3$var$checkRow(data, width, bottom);)--bottom;
    for(; $36935cc9fee67cd3$var$checkColumn(data, width, left, top, bottom);)++left;
    for(; $36935cc9fee67cd3$var$checkColumn(data, width, right, top, bottom);)--right;
    return ++right, ++bottom, new (0, $8c72251601deb182$export$63080c4de6cfc362)(left, top, right, bottom);
}



function $ec6c0b9f62eebcdb$export$658947b9914dd428(canvas) {
    const boundingBox = (0, $36935cc9fee67cd3$export$550eedf6c679837d)(canvas), { width: width, height: height } = boundingBox;
    let data = null;
    if (!boundingBox.isEmpty()) {
        const context = canvas.getContext("2d");
        if (context === null) throw new TypeError("Failed to get canvas 2D context");
        data = context.getImageData(boundingBox.left, boundingBox.top, width, height);
    }
    return {
        width: width,
        height: height,
        data: data
    };
}



function $6f08a9eba91986fb$export$672224f9983ff723(dataUri) {
    const dataUriMatch = (0, $80ce1111ace5f2d1$export$dbafa72958753fce).exec(dataUri);
    if (dataUriMatch) return {
        mediaType: dataUriMatch[1] ? dataUriMatch[1].toLowerCase() : void 0,
        subType: dataUriMatch[2] ? dataUriMatch[2].toLowerCase() : void 0,
        charset: dataUriMatch[3] ? dataUriMatch[3].toLowerCase() : void 0,
        encoding: dataUriMatch[4] ? dataUriMatch[4].toLowerCase() : void 0,
        data: dataUriMatch[5]
    };
}


function $275f34938d76b895$export$292083da55c5b406(url, loc = globalThis.location) {
    if (url.startsWith("data:")) return "";
    loc = loc || globalThis.location;
    const parsedUrl = new URL(url, document.baseURI);
    return parsedUrl.hostname !== loc.hostname || parsedUrl.port !== loc.port || parsedUrl.protocol !== loc.protocol ? "anonymous" : "";
}




function $3425cf39834caee0$export$8695ab2f322d2637(url, defaultValue = 1) {
    const resolution = (0, $2808efac47e52be0$export$a5a6e0b888b2c992).RETINA_PREFIX?.exec(url);
    return resolution ? parseFloat(resolution[1]) : defaultValue;
}








var $c90155f6d7d8d8f6$export$4f037c6ec2da4eeb = /* @__PURE__ */ ((ExtensionType2)=>(ExtensionType2.Renderer = "renderer", ExtensionType2.Application = "application", ExtensionType2.RendererSystem = "renderer-webgl-system", ExtensionType2.RendererPlugin = "renderer-webgl-plugin", ExtensionType2.CanvasRendererSystem = "renderer-canvas-system", ExtensionType2.CanvasRendererPlugin = "renderer-canvas-plugin", ExtensionType2.Asset = "asset", ExtensionType2.LoadParser = "load-parser", ExtensionType2.ResolveParser = "resolve-parser", ExtensionType2.CacheParser = "cache-parser", ExtensionType2.DetectionParser = "detection-parser", ExtensionType2))($c90155f6d7d8d8f6$export$4f037c6ec2da4eeb || {});
const $c90155f6d7d8d8f6$var$normalizeExtension = (ext)=>{
    if (typeof ext == "function" || typeof ext == "object" && ext.extension) {
        if (!ext.extension) throw new Error("Extension class must have an extension object");
        ext = {
            ...typeof ext.extension != "object" ? {
                type: ext.extension
            } : ext.extension,
            ref: ext
        };
    }
    if (typeof ext == "object") ext = {
        ...ext
    };
    else throw new Error("Invalid extension type");
    return typeof ext.type == "string" && (ext.type = [
        ext.type
    ]), ext;
}, $c90155f6d7d8d8f6$var$normalizePriority = (ext, defaultPriority)=>$c90155f6d7d8d8f6$var$normalizeExtension(ext).priority ?? defaultPriority, $c90155f6d7d8d8f6$export$cc3e2d3244e01b7f = {
    /** @ignore */ _addHandlers: {},
    /** @ignore */ _removeHandlers: {},
    /** @ignore */ _queue: {},
    /**
   * Remove extensions from PixiJS.
   * @param extensions - Extensions to be removed.
   * @returns {PIXI.extensions} For chaining.
   */ remove (...extensions2) {
        return extensions2.map($c90155f6d7d8d8f6$var$normalizeExtension).forEach((ext)=>{
            ext.type.forEach((type)=>this._removeHandlers[type]?.(ext));
        }), this;
    },
    /**
   * Register new extensions with PixiJS.
   * @param extensions - The spread of extensions to add to PixiJS.
   * @returns {PIXI.extensions} For chaining.
   */ add (...extensions2) {
        return extensions2.map($c90155f6d7d8d8f6$var$normalizeExtension).forEach((ext)=>{
            ext.type.forEach((type)=>{
                const handlers = this._addHandlers, queue = this._queue;
                handlers[type] ? handlers[type](ext) : (queue[type] = queue[type] || [], queue[type].push(ext));
            });
        }), this;
    },
    /**
   * Internal method to handle extensions by name.
   * @param type - The extension type.
   * @param onAdd  - Function for handling when extensions are added/registered passes {@link PIXI.ExtensionFormat}.
   * @param onRemove  - Function for handling when extensions are removed/unregistered passes {@link PIXI.ExtensionFormat}.
   * @returns {PIXI.extensions} For chaining.
   */ handle (type, onAdd, onRemove) {
        const addHandlers = this._addHandlers, removeHandlers = this._removeHandlers;
        if (addHandlers[type] || removeHandlers[type]) throw new Error(`Extension type ${type} already has a handler`);
        addHandlers[type] = onAdd, removeHandlers[type] = onRemove;
        const queue = this._queue;
        return queue[type] && (queue[type].forEach((ext)=>onAdd(ext)), delete queue[type]), this;
    },
    /**
   * Handle a type, but using a map by `name` property.
   * @param type - Type of extension to handle.
   * @param map - The object map of named extensions.
   * @returns {PIXI.extensions} For chaining.
   */ handleByMap (type, map) {
        return this.handle(type, (extension)=>{
            map[extension.name] = extension.ref;
        }, (extension)=>{
            delete map[extension.name];
        });
    },
    /**
   * Handle a type, but using a list of extensions.
   * @param type - Type of extension to handle.
   * @param list - The list of extensions.
   * @param defaultPriority - The default priority to use if none is specified.
   * @returns {PIXI.extensions} For chaining.
   */ handleByList (type, list, defaultPriority = -1) {
        return this.handle(type, (extension)=>{
            list.includes(extension.ref) || (list.push(extension.ref), list.sort((a, b)=>$c90155f6d7d8d8f6$var$normalizePriority(b, defaultPriority) - $c90155f6d7d8d8f6$var$normalizePriority(a, defaultPriority)));
        }, (extension)=>{
            const index = list.indexOf(extension.ref);
            index !== -1 && list.splice(index, 1);
        });
    }
};




class $39a5b11da7fcb4a0$export$4fdbf0662aa3047a {
    constructor(sizeOrBuffer){
        typeof sizeOrBuffer == "number" ? this.rawBinaryData = new ArrayBuffer(sizeOrBuffer) : sizeOrBuffer instanceof Uint8Array ? this.rawBinaryData = sizeOrBuffer.buffer : this.rawBinaryData = sizeOrBuffer, this.uint32View = new Uint32Array(this.rawBinaryData), this.float32View = new Float32Array(this.rawBinaryData);
    }
    /** View on the raw binary data as a `Int8Array`. */ get int8View() {
        return this._int8View || (this._int8View = new Int8Array(this.rawBinaryData)), this._int8View;
    }
    /** View on the raw binary data as a `Uint8Array`. */ get uint8View() {
        return this._uint8View || (this._uint8View = new Uint8Array(this.rawBinaryData)), this._uint8View;
    }
    /**  View on the raw binary data as a `Int16Array`. */ get int16View() {
        return this._int16View || (this._int16View = new Int16Array(this.rawBinaryData)), this._int16View;
    }
    /** View on the raw binary data as a `Uint16Array`. */ get uint16View() {
        return this._uint16View || (this._uint16View = new Uint16Array(this.rawBinaryData)), this._uint16View;
    }
    /** View on the raw binary data as a `Int32Array`. */ get int32View() {
        return this._int32View || (this._int32View = new Int32Array(this.rawBinaryData)), this._int32View;
    }
    /**
   * Returns the view of the given type.
   * @param type - One of `int8`, `uint8`, `int16`,
   *    `uint16`, `int32`, `uint32`, and `float32`.
   * @returns - typed array of given type
   */ view(type) {
        return this[`${type}View`];
    }
    /** Destroys all buffer references. Do not use after calling this. */ destroy() {
        this.rawBinaryData = null, this._int8View = null, this._uint8View = null, this._int16View = null, this._uint16View = null, this._int32View = null, this.uint32View = null, this.float32View = null;
    }
    static sizeOf(type) {
        switch(type){
            case "int8":
            case "uint8":
                return 1;
            case "int16":
            case "uint16":
                return 2;
            case "int32":
            case "uint32":
            case "float32":
                return 4;
            default:
                throw new Error(`${type} isn't a valid view type`);
        }
    }
}


const $5fca4dc2bd25bd24$var$fragTemplate = [
    "precision mediump float;",
    "void main(void){",
    "float test = 0.1;",
    "%forloop%",
    "gl_FragColor = vec4(0.0);",
    "}"
].join(`
`);
function $5fca4dc2bd25bd24$var$generateIfTestSrc(maxIfs) {
    let src = "";
    for(let i = 0; i < maxIfs; ++i)i > 0 && (src += `
else `), i < maxIfs - 1 && (src += `if(test == ${i}.0){}`);
    return src;
}
function $5fca4dc2bd25bd24$export$fb6ad4e758d74cc0(maxIfs, gl) {
    if (maxIfs === 0) throw new Error("Invalid value of `0` passed to `checkMaxIfStatementsInShader`");
    const shader = gl.createShader(gl.FRAGMENT_SHADER);
    for(;;){
        const fragmentSrc = $5fca4dc2bd25bd24$var$fragTemplate.replace(/%forloop%/gi, $5fca4dc2bd25bd24$var$generateIfTestSrc(maxIfs));
        if (gl.shaderSource(shader, fragmentSrc), gl.compileShader(shader), !gl.getShaderParameter(shader, gl.COMPILE_STATUS)) maxIfs = maxIfs / 2 | 0;
        else break;
    }
    return maxIfs;
}



const $2b269c8c39349f63$var$BLEND = 0, $2b269c8c39349f63$var$OFFSET = 1, $2b269c8c39349f63$var$CULLING = 2, $2b269c8c39349f63$var$DEPTH_TEST = 3, $2b269c8c39349f63$var$WINDING = 4, $2b269c8c39349f63$var$DEPTH_MASK = 5;
class $2b269c8c39349f63$export$7254cc27399e90bd {
    constructor(){
        this.data = 0, this.blendMode = (0, $0fa4b07f86297abd$export$f821c68fe9beaecf).NORMAL, this.polygonOffset = 0, this.blend = !0, this.depthMask = !0;
    }
    /**
   * Activates blending of the computed fragment color values.
   * @default true
   */ get blend() {
        return !!(this.data & 1 << $2b269c8c39349f63$var$BLEND);
    }
    set blend(value) {
        !!(this.data & 1 << $2b269c8c39349f63$var$BLEND) !== value && (this.data ^= 1 << $2b269c8c39349f63$var$BLEND);
    }
    /**
   * Activates adding an offset to depth values of polygon's fragments
   * @default false
   */ get offsets() {
        return !!(this.data & 1 << $2b269c8c39349f63$var$OFFSET);
    }
    set offsets(value) {
        !!(this.data & 1 << $2b269c8c39349f63$var$OFFSET) !== value && (this.data ^= 1 << $2b269c8c39349f63$var$OFFSET);
    }
    /**
   * Activates culling of polygons.
   * @default false
   */ get culling() {
        return !!(this.data & 1 << $2b269c8c39349f63$var$CULLING);
    }
    set culling(value) {
        !!(this.data & 1 << $2b269c8c39349f63$var$CULLING) !== value && (this.data ^= 1 << $2b269c8c39349f63$var$CULLING);
    }
    /**
   * Activates depth comparisons and updates to the depth buffer.
   * @default false
   */ get depthTest() {
        return !!(this.data & 1 << $2b269c8c39349f63$var$DEPTH_TEST);
    }
    set depthTest(value) {
        !!(this.data & 1 << $2b269c8c39349f63$var$DEPTH_TEST) !== value && (this.data ^= 1 << $2b269c8c39349f63$var$DEPTH_TEST);
    }
    /**
   * Enables or disables writing to the depth buffer.
   * @default true
   */ get depthMask() {
        return !!(this.data & 1 << $2b269c8c39349f63$var$DEPTH_MASK);
    }
    set depthMask(value) {
        !!(this.data & 1 << $2b269c8c39349f63$var$DEPTH_MASK) !== value && (this.data ^= 1 << $2b269c8c39349f63$var$DEPTH_MASK);
    }
    /**
   * Specifies whether or not front or back-facing polygons can be culled.
   * @default false
   */ get clockwiseFrontFace() {
        return !!(this.data & 1 << $2b269c8c39349f63$var$WINDING);
    }
    set clockwiseFrontFace(value) {
        !!(this.data & 1 << $2b269c8c39349f63$var$WINDING) !== value && (this.data ^= 1 << $2b269c8c39349f63$var$WINDING);
    }
    /**
   * The blend mode to be applied when this state is set. Apply a value of `PIXI.BLEND_MODES.NORMAL` to reset the blend mode.
   * Setting this mode to anything other than NO_BLEND will automatically switch blending on.
   * @default PIXI.BLEND_MODES.NORMAL
   */ get blendMode() {
        return this._blendMode;
    }
    set blendMode(value) {
        this.blend = value !== (0, $0fa4b07f86297abd$export$f821c68fe9beaecf).NONE, this._blendMode = value;
    }
    /**
   * The polygon offset. Setting this property to anything other than 0 will automatically enable polygon offset fill.
   * @default 0
   */ get polygonOffset() {
        return this._polygonOffset;
    }
    set polygonOffset(value) {
        this.offsets = !!value, this._polygonOffset = value;
    }
    static for2d() {
        const state = new $2b269c8c39349f63$export$7254cc27399e90bd();
        return state.depthTest = !1, state.blend = !0, state;
    }
}
$2b269c8c39349f63$export$7254cc27399e90bd.prototype.toString = function() {
    return `[@pixi/core:State blendMode=${this.blendMode} clockwiseFrontFace=${this.clockwiseFrontFace} culling=${this.culling} depthMask=${this.depthMask} polygonOffset=${this.polygonOffset}]`;
};





const $0ab0288141919131$export$7db5d8a07d9761e1 = [];
function $0ab0288141919131$export$5eb9e949a7ff46a7(source, options) {
    if (!source) return null;
    let extension = "";
    if (typeof source == "string") {
        const result = /\.(\w{3,4})(?:$|\?|#)/i.exec(source);
        result && (extension = result[1].toLowerCase());
    }
    for(let i = $0ab0288141919131$export$7db5d8a07d9761e1.length - 1; i >= 0; --i){
        const ResourcePlugin = $0ab0288141919131$export$7db5d8a07d9761e1[i];
        if (ResourcePlugin.test && ResourcePlugin.test(source, extension)) return new ResourcePlugin(source, options);
    }
    throw new Error("Unrecognized source type to auto-detect Resource");
}



class $feae24fa15514cdf$export$571ad3bcba5a0c45 {
    /**
   * @param name - The function name that will be executed on the listeners added to this Runner.
   */ constructor(name){
        this.items = [], this._name = name, this._aliasCount = 0;
    }
    /* eslint-disable jsdoc/require-param, jsdoc/check-param-names */ /**
   * Dispatch/Broadcast Runner to all listeners added to the queue.
   * @param {...any} params - (optional) parameters to pass to each listener
   */ /*  eslint-enable jsdoc/require-param, jsdoc/check-param-names */ emit(a0, a1, a2, a3, a4, a5, a6, a7) {
        if (arguments.length > 8) throw new Error("max arguments reached");
        const { name: name, items: items } = this;
        this._aliasCount++;
        for(let i = 0, len = items.length; i < len; i++)items[i][name](a0, a1, a2, a3, a4, a5, a6, a7);
        return items === this.items && this._aliasCount--, this;
    }
    ensureNonAliasedItems() {
        this._aliasCount > 0 && this.items.length > 1 && (this._aliasCount = 0, this.items = this.items.slice(0));
    }
    /**
   * Add a listener to the Runner
   *
   * Runners do not need to have scope or functions passed to them.
   * All that is required is to pass the listening object and ensure that it has contains a function that has the same name
   * as the name provided to the Runner when it was created.
   *
   * E.g. A listener passed to this Runner will require a 'complete' function.
   *
   * ```js
   * import { Runner } from '@pixi/runner';
   *
   * const complete = new Runner('complete');
   * ```
   *
   * The scope used will be the object itself.
   * @param {any} item - The object that will be listening.
   */ add(item) {
        return item[this._name] && (this.ensureNonAliasedItems(), this.remove(item), this.items.push(item)), this;
    }
    /**
   * Remove a single listener from the dispatch queue.
   * @param {any} item - The listener that you would like to remove.
   */ remove(item) {
        const index = this.items.indexOf(item);
        return index !== -1 && (this.ensureNonAliasedItems(), this.items.splice(index, 1)), this;
    }
    /**
   * Check to see if the listener is already in the Runner
   * @param {any} item - The listener that you would like to check.
   */ contains(item) {
        return this.items.includes(item);
    }
    /** Remove all listeners from the Runner */ removeAll() {
        return this.ensureNonAliasedItems(), this.items.length = 0, this;
    }
    /** Remove all references, don't use after this. */ destroy() {
        this.removeAll(), this.items = null, this._name = null;
    }
    /**
   * `true` if there are no this Runner contains no listeners
   * @readonly
   */ get empty() {
        return this.items.length === 0;
    }
    /**
   * The name of the runner.
   * @readonly
   */ get name() {
        return this._name;
    }
}
Object.defineProperties($feae24fa15514cdf$export$571ad3bcba5a0c45.prototype, {
    /**
   * Alias for `emit`
   * @memberof PIXI.Runner#
   * @method dispatch
   * @see PIXI.Runner#emit
   */ dispatch: {
        value: $feae24fa15514cdf$export$571ad3bcba5a0c45.prototype.emit
    },
    /**
   * Alias for `emit`
   * @memberof PIXI.Runner#
   * @method run
   * @see PIXI.Runner#emit
   */ run: {
        value: $feae24fa15514cdf$export$571ad3bcba5a0c45.prototype.emit
    }
});




class $f0aa4c46d7a26335$export$39a853cfb5a94a63 {
    /**
   * @param width - Width of the resource
   * @param height - Height of the resource
   */ constructor(width = 0, height = 0){
        this._width = width, this._height = height, this.destroyed = !1, this.internal = !1, this.onResize = new (0, $feae24fa15514cdf$export$571ad3bcba5a0c45)("setRealSize"), this.onUpdate = new (0, $feae24fa15514cdf$export$571ad3bcba5a0c45)("update"), this.onError = new (0, $feae24fa15514cdf$export$571ad3bcba5a0c45)("onError");
    }
    /**
   * Bind to a parent BaseTexture
   * @param baseTexture - Parent texture
   */ bind(baseTexture) {
        this.onResize.add(baseTexture), this.onUpdate.add(baseTexture), this.onError.add(baseTexture), (this._width || this._height) && this.onResize.emit(this._width, this._height);
    }
    /**
   * Unbind to a parent BaseTexture
   * @param baseTexture - Parent texture
   */ unbind(baseTexture) {
        this.onResize.remove(baseTexture), this.onUpdate.remove(baseTexture), this.onError.remove(baseTexture);
    }
    /**
   * Trigger a resize event
   * @param width - X dimension
   * @param height - Y dimension
   */ resize(width, height) {
        (width !== this._width || height !== this._height) && (this._width = width, this._height = height, this.onResize.emit(width, height));
    }
    /**
   * Has been validated
   * @readonly
   */ get valid() {
        return !!this._width && !!this._height;
    }
    /** Has been updated trigger event. */ update() {
        this.destroyed || this.onUpdate.emit();
    }
    /**
   * This can be overridden to start preloading a resource
   * or do any other prepare step.
   * @protected
   * @returns Handle the validate event
   */ load() {
        return Promise.resolve(this);
    }
    /**
   * The width of the resource.
   * @readonly
   */ get width() {
        return this._width;
    }
    /**
   * The height of the resource.
   * @readonly
   */ get height() {
        return this._height;
    }
    /**
   * Set the style, optional to override
   * @param _renderer - yeah, renderer!
   * @param _baseTexture - the texture
   * @param _glTexture - texture instance for this webgl context
   * @returns - `true` is success
   */ style(_renderer, _baseTexture, _glTexture) {
        return !1;
    }
    /** Clean up anything, this happens when destroying is ready. */ dispose() {}
    /**
   * Call when destroying resource, unbind any BaseTexture object
   * before calling this method, as reference counts are maintained
   * internally.
   */ destroy() {
        this.destroyed || (this.destroyed = !0, this.dispose(), this.onError.removeAll(), this.onError = null, this.onResize.removeAll(), this.onResize = null, this.onUpdate.removeAll(), this.onUpdate = null);
    }
    /**
   * Abstract, used to auto-detect resource type.
   * @param {*} _source - The source object
   * @param {string} _extension - The extension of source, if set
   */ static test(_source, _extension) {
        return !1;
    }
}


class $62e6c838a658c2fb$export$a79ef781de624449 extends (0, $f0aa4c46d7a26335$export$39a853cfb5a94a63) {
    /**
   * @param source - Source buffer
   * @param options - Options
   * @param {number} options.width - Width of the texture
   * @param {number} options.height - Height of the texture
   * @param {1|2|4|8} [options.unpackAlignment=4] - The alignment of the pixel rows.
   */ constructor(source, options){
        const { width: width, height: height } = options || {};
        if (!width || !height) throw new Error("BufferResource width or height invalid");
        super(width, height), this.data = source, this.unpackAlignment = options.unpackAlignment ?? 4;
    }
    /**
   * Upload the texture to the GPU.
   * @param renderer - Upload to the renderer
   * @param baseTexture - Reference to parent texture
   * @param glTexture - glTexture
   * @returns - true is success
   */ upload(renderer, baseTexture, glTexture) {
        const gl = renderer.gl;
        gl.pixelStorei(gl.UNPACK_ALIGNMENT, this.unpackAlignment), gl.pixelStorei(gl.UNPACK_PREMULTIPLY_ALPHA_WEBGL, baseTexture.alphaMode === (0, $0fa4b07f86297abd$export$d56550d454401b73).UNPACK);
        const width = baseTexture.realWidth, height = baseTexture.realHeight;
        return glTexture.width === width && glTexture.height === height ? gl.texSubImage2D(baseTexture.target, 0, 0, 0, width, height, baseTexture.format, glTexture.type, this.data) : (glTexture.width = width, glTexture.height = height, gl.texImage2D(baseTexture.target, 0, glTexture.internalFormat, width, height, 0, baseTexture.format, glTexture.type, this.data)), !0;
    }
    /** Destroy and don't use after this. */ dispose() {
        this.data = null;
    }
    /**
   * Used to auto-detect the type of resource.
   * @param {*} source - The source object
   * @returns {boolean} `true` if buffer source
   */ static test(source) {
        return source === null || source instanceof Int8Array || source instanceof Uint8Array || source instanceof Uint8ClampedArray || source instanceof Int16Array || source instanceof Uint16Array || source instanceof Int32Array || source instanceof Uint32Array || source instanceof Float32Array;
    }
}



const $30c85657f0c625d5$var$defaultBufferOptions = {
    scaleMode: (0, $0fa4b07f86297abd$export$6b734c6a0bba8473).NEAREST,
    alphaMode: (0, $0fa4b07f86297abd$export$d56550d454401b73).NPM
}, $30c85657f0c625d5$var$_BaseTexture = class _BaseTexture2 extends (0, (/*@__PURE__*/$parcel$interopDefault($162b085ff96d1cb1$exports))) {
    /**
   * @param {PIXI.Resource|HTMLImageElement|HTMLVideoElement|ImageBitmap|ICanvas|string} [resource=null] -
   *        The current resource to use, for things that aren't Resource objects, will be converted
   *        into a Resource.
   * @param options - Collection of options, default options inherited from {@link PIXI.BaseTexture.defaultOptions}.
   * @param {PIXI.MIPMAP_MODES} [options.mipmap] - If mipmapping is enabled for texture
   * @param {number} [options.anisotropicLevel] - Anisotropic filtering level of texture
   * @param {PIXI.WRAP_MODES} [options.wrapMode] - Wrap mode for textures
   * @param {PIXI.SCALE_MODES} [options.scaleMode] - Default scale mode, linear, nearest
   * @param {PIXI.FORMATS} [options.format] - GL format type
   * @param {PIXI.TYPES} [options.type] - GL data type
   * @param {PIXI.TARGETS} [options.target] - GL texture target
   * @param {PIXI.ALPHA_MODES} [options.alphaMode] - Pre multiply the image alpha
   * @param {number} [options.width=0] - Width of the texture
   * @param {number} [options.height=0] - Height of the texture
   * @param {number} [options.resolution=PIXI.settings.RESOLUTION] - Resolution of the base texture
   * @param {object} [options.resourceOptions] - Optional resource options,
   *        see {@link PIXI.autoDetectResource autoDetectResource}
   */ constructor(resource = null, options = null){
        super(), options = Object.assign({}, _BaseTexture2.defaultOptions, options);
        const { alphaMode: alphaMode, mipmap: mipmap, anisotropicLevel: anisotropicLevel, scaleMode: scaleMode, width: width, height: height, wrapMode: wrapMode, format: format, type: type, target: target, resolution: resolution, resourceOptions: resourceOptions } = options;
        resource && !(resource instanceof (0, $f0aa4c46d7a26335$export$39a853cfb5a94a63)) && (resource = (0, $0ab0288141919131$export$5eb9e949a7ff46a7)(resource, resourceOptions), resource.internal = !0), this.resolution = resolution || (0, $2808efac47e52be0$export$a5a6e0b888b2c992).RESOLUTION, this.width = Math.round((width || 0) * this.resolution) / this.resolution, this.height = Math.round((height || 0) * this.resolution) / this.resolution, this._mipmap = mipmap, this.anisotropicLevel = anisotropicLevel, this._wrapMode = wrapMode, this._scaleMode = scaleMode, this.format = format, this.type = type, this.target = target, this.alphaMode = alphaMode, this.uid = (0, $9444d853616ed05b$export$e2a22331486dcca0)(), this.touched = 0, this.isPowerOfTwo = !1, this._refreshPOT(), this._glTextures = {}, this.dirtyId = 0, this.dirtyStyleId = 0, this.cacheId = null, this.valid = width > 0 && height > 0, this.textureCacheIds = [], this.destroyed = !1, this.resource = null, this._batchEnabled = 0, this._batchLocation = 0, this.parentTextureArray = null, this.setResource(resource);
    }
    /**
   * Pixel width of the source of this texture
   * @readonly
   */ get realWidth() {
        return Math.round(this.width * this.resolution);
    }
    /**
   * Pixel height of the source of this texture
   * @readonly
   */ get realHeight() {
        return Math.round(this.height * this.resolution);
    }
    /**
   * Mipmap mode of the texture, affects downscaled images
   * @default PIXI.MIPMAP_MODES.POW2
   */ get mipmap() {
        return this._mipmap;
    }
    set mipmap(value) {
        this._mipmap !== value && (this._mipmap = value, this.dirtyStyleId++);
    }
    /**
   * The scale mode to apply when scaling this texture
   * @default PIXI.SCALE_MODES.LINEAR
   */ get scaleMode() {
        return this._scaleMode;
    }
    set scaleMode(value) {
        this._scaleMode !== value && (this._scaleMode = value, this.dirtyStyleId++);
    }
    /**
   * How the texture wraps
   * @default PIXI.WRAP_MODES.CLAMP
   */ get wrapMode() {
        return this._wrapMode;
    }
    set wrapMode(value) {
        this._wrapMode !== value && (this._wrapMode = value, this.dirtyStyleId++);
    }
    /**
   * Changes style options of BaseTexture
   * @param scaleMode - Pixi scalemode
   * @param mipmap - enable mipmaps
   * @returns - this
   */ setStyle(scaleMode, mipmap) {
        let dirty;
        return scaleMode !== void 0 && scaleMode !== this.scaleMode && (this.scaleMode = scaleMode, dirty = !0), mipmap !== void 0 && mipmap !== this.mipmap && (this.mipmap = mipmap, dirty = !0), dirty && this.dirtyStyleId++, this;
    }
    /**
   * Changes w/h/resolution. Texture becomes valid if width and height are greater than zero.
   * @param desiredWidth - Desired visual width
   * @param desiredHeight - Desired visual height
   * @param resolution - Optionally set resolution
   * @returns - this
   */ setSize(desiredWidth, desiredHeight, resolution) {
        return resolution = resolution || this.resolution, this.setRealSize(desiredWidth * resolution, desiredHeight * resolution, resolution);
    }
    /**
   * Sets real size of baseTexture, preserves current resolution.
   * @param realWidth - Full rendered width
   * @param realHeight - Full rendered height
   * @param resolution - Optionally set resolution
   * @returns - this
   */ setRealSize(realWidth, realHeight, resolution) {
        return this.resolution = resolution || this.resolution, this.width = Math.round(realWidth) / this.resolution, this.height = Math.round(realHeight) / this.resolution, this._refreshPOT(), this.update(), this;
    }
    /**
   * Refresh check for isPowerOfTwo texture based on size
   * @private
   */ _refreshPOT() {
        this.isPowerOfTwo = (0, $af2147baf6c30f74$export$eb50b9c078eb6ae7)(this.realWidth) && (0, $af2147baf6c30f74$export$eb50b9c078eb6ae7)(this.realHeight);
    }
    /**
   * Changes resolution
   * @param resolution - res
   * @returns - this
   */ setResolution(resolution) {
        const oldResolution = this.resolution;
        return oldResolution === resolution ? this : (this.resolution = resolution, this.valid && (this.width = Math.round(this.width * oldResolution) / resolution, this.height = Math.round(this.height * oldResolution) / resolution, this.emit("update", this)), this._refreshPOT(), this);
    }
    /**
   * Sets the resource if it wasn't set. Throws error if resource already present
   * @param resource - that is managing this BaseTexture
   * @returns - this
   */ setResource(resource) {
        if (this.resource === resource) return this;
        if (this.resource) throw new Error("Resource can be set only once");
        return resource.bind(this), this.resource = resource, this;
    }
    /** Invalidates the object. Texture becomes valid if width and height are greater than zero. */ update() {
        this.valid ? (this.dirtyId++, this.dirtyStyleId++, this.emit("update", this)) : this.width > 0 && this.height > 0 && (this.valid = !0, this.emit("loaded", this), this.emit("update", this));
    }
    /**
   * Handle errors with resources.
   * @private
   * @param event - Error event emitted.
   */ onError(event) {
        this.emit("error", this, event);
    }
    /**
   * Destroys this base texture.
   * The method stops if resource doesn't want this texture to be destroyed.
   * Removes texture from all caches.
   * @fires PIXI.BaseTexture#destroyed
   */ destroy() {
        this.resource && (this.resource.unbind(this), this.resource.internal && this.resource.destroy(), this.resource = null), this.cacheId && (delete (0, $de0ca454f7b7a947$export$cec649a143d060b1)[this.cacheId], delete (0, $de0ca454f7b7a947$export$4254ab7c0971430e)[this.cacheId], this.cacheId = null), this.valid = !1, this.dispose(), _BaseTexture2.removeFromCache(this), this.textureCacheIds = null, this.destroyed = !0, this.emit("destroyed", this), this.removeAllListeners();
    }
    /**
   * Frees the texture from WebGL memory without destroying this texture object.
   * This means you can still use the texture later which will upload it to GPU
   * memory again.
   * @fires PIXI.BaseTexture#dispose
   */ dispose() {
        this.emit("dispose", this);
    }
    /** Utility function for BaseTexture|Texture cast. */ castToBaseTexture() {
        return this;
    }
    /**
   * Helper function that creates a base texture based on the source you provide.
   * The source can be - image url, image element, canvas element. If the
   * source is an image url or an image element and not in the base texture
   * cache, it will be created and loaded.
   * @static
   * @param {HTMLImageElement|HTMLVideoElement|ImageBitmap|PIXI.ICanvas|string|string[]} source - The
   *        source to create base texture from.
   * @param options - See {@link PIXI.BaseTexture}'s constructor for options.
   * @param {string} [options.pixiIdPrefix=pixiid] - If a source has no id, this is the prefix of the generated id
   * @param {boolean} [strict] - Enforce strict-mode, see {@link PIXI.settings.STRICT_TEXTURE_CACHE}.
   * @returns {PIXI.BaseTexture} The new base texture.
   */ static from(source, options, strict = (0, $2808efac47e52be0$export$a5a6e0b888b2c992).STRICT_TEXTURE_CACHE) {
        const isFrame = typeof source == "string";
        let cacheId = null;
        if (isFrame) cacheId = source;
        else {
            if (!source._pixiId) {
                const prefix = options?.pixiIdPrefix || "pixiid";
                source._pixiId = `${prefix}_${(0, $9444d853616ed05b$export$e2a22331486dcca0)()}`;
            }
            cacheId = source._pixiId;
        }
        let baseTexture = (0, $de0ca454f7b7a947$export$cec649a143d060b1)[cacheId];
        if (isFrame && strict && !baseTexture) throw new Error(`The cacheId "${cacheId}" does not exist in BaseTextureCache.`);
        return baseTexture || (baseTexture = new _BaseTexture2(source, options), baseTexture.cacheId = cacheId, _BaseTexture2.addToCache(baseTexture, cacheId)), baseTexture;
    }
    /**
   * Create a new Texture with a BufferResource from a typed array.
   * @param buffer - The optional array to use. If no data is provided, a new Float32Array is created.
   * @param width - Width of the resource
   * @param height - Height of the resource
   * @param options - See {@link PIXI.BaseTexture}'s constructor for options.
   *        Default properties are different from the constructor's defaults.
   * @param {PIXI.FORMATS} [options.format] - The format is not given, the type is inferred from the
   *        type of the buffer: `RGBA` if Float32Array, Int8Array, Uint8Array, or Uint8ClampedArray,
   *        otherwise `RGBA_INTEGER`.
   * @param {PIXI.TYPES} [options.type] - The type is not given, the type is inferred from the
   *        type of the buffer. Maps Float32Array to `FLOAT`, Int32Array to `INT`, Uint32Array to
   *        `UNSIGNED_INT`, Int16Array to `SHORT`, Uint16Array to `UNSIGNED_SHORT`, Int8Array to `BYTE`,
   *        Uint8Array/Uint8ClampedArray to `UNSIGNED_BYTE`.
   * @param {PIXI.ALPHA_MODES} [options.alphaMode=PIXI.ALPHA_MODES.NPM]
   * @param {PIXI.SCALE_MODES} [options.scaleMode=PIXI.SCALE_MODES.NEAREST]
   * @returns - The resulting new BaseTexture
   */ static fromBuffer(buffer, width, height, options) {
        buffer = buffer || new Float32Array(width * height * 4);
        const resource = new (0, $62e6c838a658c2fb$export$a79ef781de624449)(buffer, {
            width: width,
            height: height,
            ...options?.resourceOptions
        });
        let format, type;
        return buffer instanceof Float32Array ? (format = (0, $0fa4b07f86297abd$export$e9c4b7b466aa8274).RGBA, type = (0, $0fa4b07f86297abd$export$426db7a6155b7a80).FLOAT) : buffer instanceof Int32Array ? (format = (0, $0fa4b07f86297abd$export$e9c4b7b466aa8274).RGBA_INTEGER, type = (0, $0fa4b07f86297abd$export$426db7a6155b7a80).INT) : buffer instanceof Uint32Array ? (format = (0, $0fa4b07f86297abd$export$e9c4b7b466aa8274).RGBA_INTEGER, type = (0, $0fa4b07f86297abd$export$426db7a6155b7a80).UNSIGNED_INT) : buffer instanceof Int16Array ? (format = (0, $0fa4b07f86297abd$export$e9c4b7b466aa8274).RGBA_INTEGER, type = (0, $0fa4b07f86297abd$export$426db7a6155b7a80).SHORT) : buffer instanceof Uint16Array ? (format = (0, $0fa4b07f86297abd$export$e9c4b7b466aa8274).RGBA_INTEGER, type = (0, $0fa4b07f86297abd$export$426db7a6155b7a80).UNSIGNED_SHORT) : buffer instanceof Int8Array ? (format = (0, $0fa4b07f86297abd$export$e9c4b7b466aa8274).RGBA, type = (0, $0fa4b07f86297abd$export$426db7a6155b7a80).BYTE) : (format = (0, $0fa4b07f86297abd$export$e9c4b7b466aa8274).RGBA, type = (0, $0fa4b07f86297abd$export$426db7a6155b7a80).UNSIGNED_BYTE), resource.internal = !0, new _BaseTexture2(resource, Object.assign({}, $30c85657f0c625d5$var$defaultBufferOptions, {
            type: type,
            format: format
        }, options));
    }
    /**
   * Adds a BaseTexture to the global BaseTextureCache. This cache is shared across the whole PIXI object.
   * @param {PIXI.BaseTexture} baseTexture - The BaseTexture to add to the cache.
   * @param {string} id - The id that the BaseTexture will be stored against.
   */ static addToCache(baseTexture, id) {
        id && (baseTexture.textureCacheIds.includes(id) || baseTexture.textureCacheIds.push(id), (0, $de0ca454f7b7a947$export$cec649a143d060b1)[id] && (0, $de0ca454f7b7a947$export$cec649a143d060b1)[id] !== baseTexture && console.warn(`BaseTexture added to the cache with an id [${id}] that already had an entry`), (0, $de0ca454f7b7a947$export$cec649a143d060b1)[id] = baseTexture);
    }
    /**
   * Remove a BaseTexture from the global BaseTextureCache.
   * @param {string|PIXI.BaseTexture} baseTexture - id of a BaseTexture to be removed, or a BaseTexture instance itself.
   * @returns {PIXI.BaseTexture|null} The BaseTexture that was removed.
   */ static removeFromCache(baseTexture) {
        if (typeof baseTexture == "string") {
            const baseTextureFromCache = (0, $de0ca454f7b7a947$export$cec649a143d060b1)[baseTexture];
            if (baseTextureFromCache) {
                const index = baseTextureFromCache.textureCacheIds.indexOf(baseTexture);
                return index > -1 && baseTextureFromCache.textureCacheIds.splice(index, 1), delete (0, $de0ca454f7b7a947$export$cec649a143d060b1)[baseTexture], baseTextureFromCache;
            }
        } else if (baseTexture?.textureCacheIds) {
            for(let i = 0; i < baseTexture.textureCacheIds.length; ++i)delete (0, $de0ca454f7b7a947$export$cec649a143d060b1)[baseTexture.textureCacheIds[i]];
            return baseTexture.textureCacheIds.length = 0, baseTexture;
        }
        return null;
    }
};
$30c85657f0c625d5$var$_BaseTexture.defaultOptions = {
    /**
   * If mipmapping is enabled for texture.
   * @type {PIXI.MIPMAP_MODES}
   * @default PIXI.MIPMAP_MODES.POW2
   */ mipmap: (0, $0fa4b07f86297abd$export$16f6fb5da874bbfd).POW2,
    /** Anisotropic filtering level of texture */ anisotropicLevel: 0,
    /**
   * Default scale mode, linear, nearest.
   * @type {PIXI.SCALE_MODES}
   * @default PIXI.SCALE_MODES.LINEAR
   */ scaleMode: (0, $0fa4b07f86297abd$export$6b734c6a0bba8473).LINEAR,
    /**
   * Wrap mode for textures.
   * @type {PIXI.WRAP_MODES}
   * @default PIXI.WRAP_MODES.CLAMP
   */ wrapMode: (0, $0fa4b07f86297abd$export$2ab395cfb0dd2f0f).CLAMP,
    /**
   * Pre multiply the image alpha
   * @type {PIXI.ALPHA_MODES}
   * @default PIXI.ALPHA_MODES.UNPACK
   */ alphaMode: (0, $0fa4b07f86297abd$export$d56550d454401b73).UNPACK,
    /**
   * GL texture target
   * @type {PIXI.TARGETS}
   * @default PIXI.TARGETS.TEXTURE_2D
   */ target: (0, $0fa4b07f86297abd$export$d1ff3caf57547dc5).TEXTURE_2D,
    /**
   * GL format type
   * @type {PIXI.FORMATS}
   * @default PIXI.FORMATS.RGBA
   */ format: (0, $0fa4b07f86297abd$export$e9c4b7b466aa8274).RGBA,
    /**
   * GL data type
   * @type {PIXI.TYPES}
   * @default PIXI.TYPES.UNSIGNED_BYTE
   */ type: (0, $0fa4b07f86297abd$export$426db7a6155b7a80).UNSIGNED_BYTE
}, /** Global number of the texture batch, used by multi-texture renderers. */ $30c85657f0c625d5$var$_BaseTexture._globalBatch = 0;
let $30c85657f0c625d5$export$d6306e508f184154 = $30c85657f0c625d5$var$_BaseTexture;



class $8e09e9037c380ee9$export$664fd198634fda29 {
    constructor(){
        this.texArray = null, this.blend = 0, this.type = (0, $0fa4b07f86297abd$export$91100badd8469338).TRIANGLES, this.start = 0, this.size = 0, this.data = null;
    }
}





let $17b501b101b42758$var$UID = 0;
class $17b501b101b42758$export$a143d493d941bafc {
    /**
   * @param {PIXI.IArrayBuffer} data - the data to store in the buffer.
   * @param _static - `true` for static buffer
   * @param index - `true` for index buffer
   */ constructor(data, _static = !0, index = !1){
        this.data = data || new Float32Array(1), this._glBuffers = {}, this._updateID = 0, this.index = index, this.static = _static, this.id = $17b501b101b42758$var$UID++, this.disposeRunner = new (0, $feae24fa15514cdf$export$571ad3bcba5a0c45)("disposeBuffer");
    }
    // TODO could explore flagging only a partial upload?
    /**
   * Flags this buffer as requiring an upload to the GPU.
   * @param {PIXI.IArrayBuffer|number[]} [data] - the data to update in the buffer.
   */ update(data) {
        data instanceof Array && (data = new Float32Array(data)), this.data = data || this.data, this._updateID++;
    }
    /** Disposes WebGL resources that are connected to this geometry. */ dispose() {
        this.disposeRunner.emit(this, !1);
    }
    /** Destroys the buffer. */ destroy() {
        this.dispose(), this.data = null;
    }
    /**
   * Flags whether this is an index buffer.
   *
   * Index buffers are of type `ELEMENT_ARRAY_BUFFER`. Note that setting this property to false will make
   * the buffer of type `ARRAY_BUFFER`.
   *
   * For backwards compatibility.
   */ set index(value) {
        this.type = value ? (0, $0fa4b07f86297abd$export$b595a7e482202b96).ELEMENT_ARRAY_BUFFER : (0, $0fa4b07f86297abd$export$b595a7e482202b96).ARRAY_BUFFER;
    }
    get index() {
        return this.type === (0, $0fa4b07f86297abd$export$b595a7e482202b96).ELEMENT_ARRAY_BUFFER;
    }
    /**
   * Helper function that creates a buffer based on an array or TypedArray
   * @param {ArrayBufferView | number[]} data - the TypedArray that the buffer will store. If this is a regular Array it will be converted to a Float32Array.
   * @returns - A new Buffer based on the data provided.
   */ static from(data) {
        return data instanceof Array && (data = new Float32Array(data)), new $17b501b101b42758$export$a143d493d941bafc(data);
    }
}






class $0d3cc63cf4e2619f$export$ab9c25261cd8c720 {
    /**
   * @param buffer - the id of the buffer that this attribute will look for
   * @param size - the size of the attribute. If you have 2 floats per vertex (eg position x and y) this would be 2.
   * @param normalized - should the data be normalized.
   * @param {PIXI.TYPES} [type=PIXI.TYPES.FLOAT] - what type of number is the attribute. Check {@link PIXI.TYPES} to see the ones available
   * @param [stride=0] - How far apart, in bytes, the start of each value is. (used for interleaving data)
   * @param [start=0] - How far into the array to start reading values (used for interleaving data)
   * @param [instance=false] - Whether the geometry is instanced.
   * @param [divisor=1] - Divisor to use when doing instanced rendering
   */ constructor(buffer, size = 0, normalized = !1, type = (0, $0fa4b07f86297abd$export$426db7a6155b7a80).FLOAT, stride, start, instance, divisor = 1){
        this.buffer = buffer, this.size = size, this.normalized = normalized, this.type = type, this.stride = stride, this.start = start, this.instance = instance, this.divisor = divisor;
    }
    /** Destroys the Attribute. */ destroy() {
        this.buffer = null;
    }
    /**
   * Helper function that creates an Attribute based on the information provided
   * @param buffer - the id of the buffer that this attribute will look for
   * @param [size=0] - the size of the attribute. If you have 2 floats per vertex (eg position x and y) this would be 2
   * @param [normalized=false] - should the data be normalized.
   * @param [type=PIXI.TYPES.FLOAT] - what type of number is the attribute. Check {@link PIXI.TYPES} to see the ones available
   * @param [stride=0] - How far apart, in bytes, the start of each value is. (used for interleaving data)
   * @returns - A new {@link PIXI.Attribute} based on the information provided
   */ static from(buffer, size, normalized, type, stride) {
        return new $0d3cc63cf4e2619f$export$ab9c25261cd8c720(buffer, size, normalized, type, stride);
    }
}




const $11d8da9610c028b1$var$map = {
    Float32Array: Float32Array,
    Uint32Array: Uint32Array,
    Int32Array: Int32Array,
    Uint8Array: Uint8Array
};
function $11d8da9610c028b1$export$1ce3e224e969bb24(arrays, sizes) {
    let outSize = 0, stride = 0;
    const views = {};
    for(let i = 0; i < arrays.length; i++)stride += sizes[i], outSize += arrays[i].length;
    const buffer = new ArrayBuffer(outSize * 4);
    let out = null, littleOffset = 0;
    for(let i = 0; i < arrays.length; i++){
        const size = sizes[i], array = arrays[i], type = (0, $511acc244d4a69e7$export$adf72b506413cb57)(array);
        views[type] || (views[type] = new $11d8da9610c028b1$var$map[type](buffer)), out = views[type];
        for(let j = 0; j < array.length; j++){
            const indexStart = (j / size | 0) * stride + littleOffset, index = j % size;
            out[indexStart + index] = array[j];
        }
        littleOffset += size;
    }
    return new Float32Array(buffer);
}


const $746bc9ae18084e8e$var$byteSizeMap = {
    5126: 4,
    5123: 2,
    5121: 1
};
let $746bc9ae18084e8e$var$UID = 0;
const $746bc9ae18084e8e$var$map = {
    Float32Array: Float32Array,
    Uint32Array: Uint32Array,
    Int32Array: Int32Array,
    Uint8Array: Uint8Array,
    Uint16Array: Uint16Array
};
class $746bc9ae18084e8e$export$2db6c17465f94a2 {
    /**
   * @param buffers - An array of buffers. optional.
   * @param attributes - Of the geometry, optional structure of the attributes layout
   */ constructor(buffers = [], attributes = {}){
        this.buffers = buffers, this.indexBuffer = null, this.attributes = attributes, this.glVertexArrayObjects = {}, this.id = $746bc9ae18084e8e$var$UID++, this.instanced = !1, this.instanceCount = 1, this.disposeRunner = new (0, $feae24fa15514cdf$export$571ad3bcba5a0c45)("disposeGeometry"), this.refCount = 0;
    }
    /**
   *
   * Adds an attribute to the geometry
   * Note: `stride` and `start` should be `undefined` if you dont know them, not 0!
   * @param id - the name of the attribute (matching up to a shader)
   * @param {PIXI.Buffer|number[]} buffer - the buffer that holds the data of the attribute . You can also provide an Array and a buffer will be created from it.
   * @param size - the size of the attribute. If you have 2 floats per vertex (eg position x and y) this would be 2
   * @param normalized - should the data be normalized.
   * @param [type=PIXI.TYPES.FLOAT] - what type of number is the attribute. Check {@link PIXI.TYPES} to see the ones available
   * @param [stride=0] - How far apart, in bytes, the start of each value is. (used for interleaving data)
   * @param [start=0] - How far into the array to start reading values (used for interleaving data)
   * @param instance - Instancing flag
   * @returns - Returns self, useful for chaining.
   */ addAttribute(id, buffer, size = 0, normalized = !1, type, stride, start, instance = !1) {
        if (!buffer) throw new Error("You must pass a buffer when creating an attribute");
        buffer instanceof (0, $17b501b101b42758$export$a143d493d941bafc) || (buffer instanceof Array && (buffer = new Float32Array(buffer)), buffer = new (0, $17b501b101b42758$export$a143d493d941bafc)(buffer));
        const ids = id.split("|");
        if (ids.length > 1) {
            for(let i = 0; i < ids.length; i++)this.addAttribute(ids[i], buffer, size, normalized, type);
            return this;
        }
        let bufferIndex = this.buffers.indexOf(buffer);
        return bufferIndex === -1 && (this.buffers.push(buffer), bufferIndex = this.buffers.length - 1), this.attributes[id] = new (0, $0d3cc63cf4e2619f$export$ab9c25261cd8c720)(bufferIndex, size, normalized, type, stride, start, instance), this.instanced = this.instanced || instance, this;
    }
    /**
   * Returns the requested attribute.
   * @param id - The name of the attribute required
   * @returns - The attribute requested.
   */ getAttribute(id) {
        return this.attributes[id];
    }
    /**
   * Returns the requested buffer.
   * @param id - The name of the buffer required.
   * @returns - The buffer requested.
   */ getBuffer(id) {
        return this.buffers[this.getAttribute(id).buffer];
    }
    /**
   *
   * Adds an index buffer to the geometry
   * The index buffer contains integers, three for each triangle in the geometry, which reference the various attribute buffers (position, colour, UV coordinates, other UV coordinates, normal, …). There is only ONE index buffer.
   * @param {PIXI.Buffer|number[]} [buffer] - The buffer that holds the data of the index buffer. You can also provide an Array and a buffer will be created from it.
   * @returns - Returns self, useful for chaining.
   */ addIndex(buffer) {
        return buffer instanceof (0, $17b501b101b42758$export$a143d493d941bafc) || (buffer instanceof Array && (buffer = new Uint16Array(buffer)), buffer = new (0, $17b501b101b42758$export$a143d493d941bafc)(buffer)), buffer.type = (0, $0fa4b07f86297abd$export$b595a7e482202b96).ELEMENT_ARRAY_BUFFER, this.indexBuffer = buffer, this.buffers.includes(buffer) || this.buffers.push(buffer), this;
    }
    /**
   * Returns the index buffer
   * @returns - The index buffer.
   */ getIndex() {
        return this.indexBuffer;
    }
    /**
   * This function modifies the structure so that all current attributes become interleaved into a single buffer
   * This can be useful if your model remains static as it offers a little performance boost
   * @returns - Returns self, useful for chaining.
   */ interleave() {
        if (this.buffers.length === 1 || this.buffers.length === 2 && this.indexBuffer) return this;
        const arrays = [], sizes = [], interleavedBuffer = new (0, $17b501b101b42758$export$a143d493d941bafc)();
        let i;
        for(i in this.attributes){
            const attribute = this.attributes[i], buffer = this.buffers[attribute.buffer];
            arrays.push(buffer.data), sizes.push(attribute.size * $746bc9ae18084e8e$var$byteSizeMap[attribute.type] / 4), attribute.buffer = 0;
        }
        for(interleavedBuffer.data = (0, $11d8da9610c028b1$export$1ce3e224e969bb24)(arrays, sizes), i = 0; i < this.buffers.length; i++)this.buffers[i] !== this.indexBuffer && this.buffers[i].destroy();
        return this.buffers = [
            interleavedBuffer
        ], this.indexBuffer && this.buffers.push(this.indexBuffer), this;
    }
    /** Get the size of the geometries, in vertices. */ getSize() {
        for(const i in this.attributes){
            const attribute = this.attributes[i];
            return this.buffers[attribute.buffer].data.length / (attribute.stride / 4 || attribute.size);
        }
        return 0;
    }
    /** Disposes WebGL resources that are connected to this geometry. */ dispose() {
        this.disposeRunner.emit(this, !1);
    }
    /** Destroys the geometry. */ destroy() {
        this.dispose(), this.buffers = null, this.indexBuffer = null, this.attributes = null;
    }
    /**
   * Returns a clone of the geometry.
   * @returns - A new clone of this geometry.
   */ clone() {
        const geometry = new $746bc9ae18084e8e$export$2db6c17465f94a2();
        for(let i = 0; i < this.buffers.length; i++)geometry.buffers[i] = new (0, $17b501b101b42758$export$a143d493d941bafc)(this.buffers[i].data.slice(0));
        for(const i in this.attributes){
            const attrib = this.attributes[i];
            geometry.attributes[i] = new (0, $0d3cc63cf4e2619f$export$ab9c25261cd8c720)(attrib.buffer, attrib.size, attrib.normalized, attrib.type, attrib.stride, attrib.start, attrib.instance);
        }
        return this.indexBuffer && (geometry.indexBuffer = geometry.buffers[this.buffers.indexOf(this.indexBuffer)], geometry.indexBuffer.type = (0, $0fa4b07f86297abd$export$b595a7e482202b96).ELEMENT_ARRAY_BUFFER), geometry;
    }
    /**
   * Merges an array of geometries into a new single one.
   *
   * Geometry attribute styles must match for this operation to work.
   * @param geometries - array of geometries to merge
   * @returns - Shiny new geometry!
   */ static merge(geometries) {
        const geometryOut = new $746bc9ae18084e8e$export$2db6c17465f94a2(), arrays = [], sizes = [], offsets = [];
        let geometry;
        for(let i = 0; i < geometries.length; i++){
            geometry = geometries[i];
            for(let j = 0; j < geometry.buffers.length; j++)sizes[j] = sizes[j] || 0, sizes[j] += geometry.buffers[j].data.length, offsets[j] = 0;
        }
        for(let i = 0; i < geometry.buffers.length; i++)arrays[i] = new $746bc9ae18084e8e$var$map[(0, $511acc244d4a69e7$export$adf72b506413cb57)(geometry.buffers[i].data)](sizes[i]), geometryOut.buffers[i] = new (0, $17b501b101b42758$export$a143d493d941bafc)(arrays[i]);
        for(let i = 0; i < geometries.length; i++){
            geometry = geometries[i];
            for(let j = 0; j < geometry.buffers.length; j++)arrays[j].set(geometry.buffers[j].data, offsets[j]), offsets[j] += geometry.buffers[j].data.length;
        }
        if (geometryOut.attributes = geometry.attributes, geometry.indexBuffer) {
            geometryOut.indexBuffer = geometryOut.buffers[geometry.buffers.indexOf(geometry.indexBuffer)], geometryOut.indexBuffer.type = (0, $0fa4b07f86297abd$export$b595a7e482202b96).ELEMENT_ARRAY_BUFFER;
            let offset = 0, stride = 0, offset2 = 0, bufferIndexToCount = 0;
            for(let i = 0; i < geometry.buffers.length; i++)if (geometry.buffers[i] !== geometry.indexBuffer) {
                bufferIndexToCount = i;
                break;
            }
            for(const i in geometry.attributes){
                const attribute = geometry.attributes[i];
                (attribute.buffer | 0) === bufferIndexToCount && (stride += attribute.size * $746bc9ae18084e8e$var$byteSizeMap[attribute.type] / 4);
            }
            for(let i = 0; i < geometries.length; i++){
                const indexBufferData = geometries[i].indexBuffer.data;
                for(let j = 0; j < indexBufferData.length; j++)geometryOut.indexBuffer.data[j + offset2] += offset;
                offset += geometries[i].buffers[bufferIndexToCount].data.length / stride, offset2 += indexBufferData.length;
            }
        }
        return geometryOut;
    }
}


class $8ffbe4cd828c4ebe$export$449e8d355fd68e43 extends (0, $746bc9ae18084e8e$export$2db6c17465f94a2) {
    /**
   * @param {boolean} [_static=false] - Optimization flag, where `false`
   *        is updated every frame, `true` doesn't change frame-to-frame.
   */ constructor(_static = !1){
        super(), this._buffer = new (0, $17b501b101b42758$export$a143d493d941bafc)(null, _static, !1), this._indexBuffer = new (0, $17b501b101b42758$export$a143d493d941bafc)(null, _static, !0), this.addAttribute("aVertexPosition", this._buffer, 2, !1, (0, $0fa4b07f86297abd$export$426db7a6155b7a80).FLOAT).addAttribute("aTextureCoord", this._buffer, 2, !1, (0, $0fa4b07f86297abd$export$426db7a6155b7a80).FLOAT).addAttribute("aColor", this._buffer, 4, !0, (0, $0fa4b07f86297abd$export$426db7a6155b7a80).UNSIGNED_BYTE).addAttribute("aTextureId", this._buffer, 1, !0, (0, $0fa4b07f86297abd$export$426db7a6155b7a80).FLOAT).addIndex(this._indexBuffer);
    }
}


const $e51f17ddb17db7b9$export$59ed0a0a5de1084b = Math.PI * 2, $e51f17ddb17db7b9$export$3f91627dc85c5d57 = 180 / Math.PI, $e51f17ddb17db7b9$export$870617f62e3187f1 = Math.PI / 180;
var $e51f17ddb17db7b9$export$511e1d54a4a8684e = /* @__PURE__ */ ((SHAPES2)=>(SHAPES2[SHAPES2.POLY = 0] = "POLY", SHAPES2[SHAPES2.RECT = 1] = "RECT", SHAPES2[SHAPES2.CIRC = 2] = "CIRC", SHAPES2[SHAPES2.ELIP = 3] = "ELIP", SHAPES2[SHAPES2.RREC = 4] = "RREC", SHAPES2))($e51f17ddb17db7b9$export$511e1d54a4a8684e || {});



class $cf3018b4309864c2$export$baf26146a414f24a {
    /**
   * Creates a new `Point`
   * @param {number} [x=0] - position of the point on the x axis
   * @param {number} [y=0] - position of the point on the y axis
   */ constructor(x = 0, y = 0){
        this.x = 0, this.y = 0, this.x = x, this.y = y;
    }
    /**
   * Creates a clone of this point
   * @returns A clone of this point
   */ clone() {
        return new $cf3018b4309864c2$export$baf26146a414f24a(this.x, this.y);
    }
    /**
   * Copies `x` and `y` from the given point into this point
   * @param p - The point to copy from
   * @returns The point instance itself
   */ copyFrom(p) {
        return this.set(p.x, p.y), this;
    }
    /**
   * Copies this point's x and y into the given point (`p`).
   * @param p - The point to copy to. Can be any of type that is or extends `IPointData`
   * @returns The point (`p`) with values updated
   */ copyTo(p) {
        return p.set(this.x, this.y), p;
    }
    /**
   * Accepts another point (`p`) and returns `true` if the given point is equal to this point
   * @param p - The point to check
   * @returns Returns `true` if both `x` and `y` are equal
   */ equals(p) {
        return p.x === this.x && p.y === this.y;
    }
    /**
   * Sets the point to a new `x` and `y` position.
   * If `y` is omitted, both `x` and `y` will be set to `x`.
   * @param {number} [x=0] - position of the point on the `x` axis
   * @param {number} [y=x] - position of the point on the `y` axis
   * @returns The point instance itself
   */ set(x = 0, y = x) {
        return this.x = x, this.y = y, this;
    }
}
$cf3018b4309864c2$export$baf26146a414f24a.prototype.toString = function() {
    return `[@pixi/math:Point x=${this.x} y=${this.y}]`;
};


const $200f778d7fdbf8ac$var$tempPoints = [
    new (0, $cf3018b4309864c2$export$baf26146a414f24a)(),
    new (0, $cf3018b4309864c2$export$baf26146a414f24a)(),
    new (0, $cf3018b4309864c2$export$baf26146a414f24a)(),
    new (0, $cf3018b4309864c2$export$baf26146a414f24a)()
];
class $200f778d7fdbf8ac$export$4617fb02663045ef {
    /**
   * @param x - The X coordinate of the upper-left corner of the rectangle
   * @param y - The Y coordinate of the upper-left corner of the rectangle
   * @param width - The overall width of the rectangle
   * @param height - The overall height of the rectangle
   */ constructor(x = 0, y = 0, width = 0, height = 0){
        this.x = Number(x), this.y = Number(y), this.width = Number(width), this.height = Number(height), this.type = (0, $e51f17ddb17db7b9$export$511e1d54a4a8684e).RECT;
    }
    /** Returns the left edge of the rectangle. */ get left() {
        return this.x;
    }
    /** Returns the right edge of the rectangle. */ get right() {
        return this.x + this.width;
    }
    /** Returns the top edge of the rectangle. */ get top() {
        return this.y;
    }
    /** Returns the bottom edge of the rectangle. */ get bottom() {
        return this.y + this.height;
    }
    /** A constant empty rectangle. */ static get EMPTY() {
        return new $200f778d7fdbf8ac$export$4617fb02663045ef(0, 0, 0, 0);
    }
    /**
   * Creates a clone of this Rectangle
   * @returns a copy of the rectangle
   */ clone() {
        return new $200f778d7fdbf8ac$export$4617fb02663045ef(this.x, this.y, this.width, this.height);
    }
    /**
   * Copies another rectangle to this one.
   * @param rectangle - The rectangle to copy from.
   * @returns Returns itself.
   */ copyFrom(rectangle) {
        return this.x = rectangle.x, this.y = rectangle.y, this.width = rectangle.width, this.height = rectangle.height, this;
    }
    /**
   * Copies this rectangle to another one.
   * @param rectangle - The rectangle to copy to.
   * @returns Returns given parameter.
   */ copyTo(rectangle) {
        return rectangle.x = this.x, rectangle.y = this.y, rectangle.width = this.width, rectangle.height = this.height, rectangle;
    }
    /**
   * Checks whether the x and y coordinates given are contained within this Rectangle
   * @param x - The X coordinate of the point to test
   * @param y - The Y coordinate of the point to test
   * @returns Whether the x/y coordinates are within this Rectangle
   */ contains(x, y) {
        return this.width <= 0 || this.height <= 0 ? !1 : x >= this.x && x < this.x + this.width && y >= this.y && y < this.y + this.height;
    }
    /**
   * Determines whether the `other` Rectangle transformed by `transform` intersects with `this` Rectangle object.
   * Returns true only if the area of the intersection is >0, this means that Rectangles
   * sharing a side are not overlapping. Another side effect is that an arealess rectangle
   * (width or height equal to zero) can't intersect any other rectangle.
   * @param {Rectangle} other - The Rectangle to intersect with `this`.
   * @param {Matrix} transform - The transformation matrix of `other`.
   * @returns {boolean} A value of `true` if the transformed `other` Rectangle intersects with `this`; otherwise `false`.
   */ intersects(other, transform) {
        if (!transform) {
            const x02 = this.x < other.x ? other.x : this.x;
            if ((this.right > other.right ? other.right : this.right) <= x02) return !1;
            const y02 = this.y < other.y ? other.y : this.y;
            return (this.bottom > other.bottom ? other.bottom : this.bottom) > y02;
        }
        const x0 = this.left, x1 = this.right, y0 = this.top, y1 = this.bottom;
        if (x1 <= x0 || y1 <= y0) return !1;
        const lt = $200f778d7fdbf8ac$var$tempPoints[0].set(other.left, other.top), lb = $200f778d7fdbf8ac$var$tempPoints[1].set(other.left, other.bottom), rt = $200f778d7fdbf8ac$var$tempPoints[2].set(other.right, other.top), rb = $200f778d7fdbf8ac$var$tempPoints[3].set(other.right, other.bottom);
        if (rt.x <= lt.x || lb.y <= lt.y) return !1;
        const s = Math.sign(transform.a * transform.d - transform.b * transform.c);
        if (s === 0 || (transform.apply(lt, lt), transform.apply(lb, lb), transform.apply(rt, rt), transform.apply(rb, rb), Math.max(lt.x, lb.x, rt.x, rb.x) <= x0 || Math.min(lt.x, lb.x, rt.x, rb.x) >= x1 || Math.max(lt.y, lb.y, rt.y, rb.y) <= y0 || Math.min(lt.y, lb.y, rt.y, rb.y) >= y1)) return !1;
        const nx = s * (lb.y - lt.y), ny = s * (lt.x - lb.x), n00 = nx * x0 + ny * y0, n10 = nx * x1 + ny * y0, n01 = nx * x0 + ny * y1, n11 = nx * x1 + ny * y1;
        if (Math.max(n00, n10, n01, n11) <= nx * lt.x + ny * lt.y || Math.min(n00, n10, n01, n11) >= nx * rb.x + ny * rb.y) return !1;
        const mx = s * (lt.y - rt.y), my = s * (rt.x - lt.x), m00 = mx * x0 + my * y0, m10 = mx * x1 + my * y0, m01 = mx * x0 + my * y1, m11 = mx * x1 + my * y1;
        return !(Math.max(m00, m10, m01, m11) <= mx * lt.x + my * lt.y || Math.min(m00, m10, m01, m11) >= mx * rb.x + my * rb.y);
    }
    /**
   * Pads the rectangle making it grow in all directions.
   * If paddingY is omitted, both paddingX and paddingY will be set to paddingX.
   * @param paddingX - The horizontal padding amount.
   * @param paddingY - The vertical padding amount.
   * @returns Returns itself.
   */ pad(paddingX = 0, paddingY = paddingX) {
        return this.x -= paddingX, this.y -= paddingY, this.width += paddingX * 2, this.height += paddingY * 2, this;
    }
    /**
   * Fits this rectangle around the passed one.
   * @param rectangle - The rectangle to fit.
   * @returns Returns itself.
   */ fit(rectangle) {
        const x1 = Math.max(this.x, rectangle.x), x2 = Math.min(this.x + this.width, rectangle.x + rectangle.width), y1 = Math.max(this.y, rectangle.y), y2 = Math.min(this.y + this.height, rectangle.y + rectangle.height);
        return this.x = x1, this.width = Math.max(x2 - x1, 0), this.y = y1, this.height = Math.max(y2 - y1, 0), this;
    }
    /**
   * Enlarges rectangle that way its corners lie on grid
   * @param resolution - resolution
   * @param eps - precision
   * @returns Returns itself.
   */ ceil(resolution = 1, eps = 1e-3) {
        const x2 = Math.ceil((this.x + this.width - eps) * resolution) / resolution, y2 = Math.ceil((this.y + this.height - eps) * resolution) / resolution;
        return this.x = Math.floor((this.x + eps) * resolution) / resolution, this.y = Math.floor((this.y + eps) * resolution) / resolution, this.width = x2 - this.x, this.height = y2 - this.y, this;
    }
    /**
   * Enlarges this rectangle to include the passed rectangle.
   * @param rectangle - The rectangle to include.
   * @returns Returns itself.
   */ enlarge(rectangle) {
        const x1 = Math.min(this.x, rectangle.x), x2 = Math.max(this.x + this.width, rectangle.x + rectangle.width), y1 = Math.min(this.y, rectangle.y), y2 = Math.max(this.y + this.height, rectangle.y + rectangle.height);
        return this.x = x1, this.width = x2 - x1, this.y = y1, this.height = y2 - y1, this;
    }
}
$200f778d7fdbf8ac$export$4617fb02663045ef.prototype.toString = function() {
    return `[@pixi/math:Rectangle x=${this.x} y=${this.y} width=${this.width} height=${this.height}]`;
};


class $076a80b12576921e$export$c89a927ffc67e6fa {
    /**
   * @param x - The X coordinate of the center of this circle
   * @param y - The Y coordinate of the center of this circle
   * @param radius - The radius of the circle
   */ constructor(x = 0, y = 0, radius = 0){
        this.x = x, this.y = y, this.radius = radius, this.type = (0, $e51f17ddb17db7b9$export$511e1d54a4a8684e).CIRC;
    }
    /**
   * Creates a clone of this Circle instance
   * @returns A copy of the Circle
   */ clone() {
        return new $076a80b12576921e$export$c89a927ffc67e6fa(this.x, this.y, this.radius);
    }
    /**
   * Checks whether the x and y coordinates given are contained within this circle
   * @param x - The X coordinate of the point to test
   * @param y - The Y coordinate of the point to test
   * @returns Whether the x/y coordinates are within this Circle
   */ contains(x, y) {
        if (this.radius <= 0) return !1;
        const r2 = this.radius * this.radius;
        let dx = this.x - x, dy = this.y - y;
        return dx *= dx, dy *= dy, dx + dy <= r2;
    }
    /**
   * Returns the framing rectangle of the circle as a Rectangle object
   * @returns The framing rectangle
   */ getBounds() {
        return new (0, $200f778d7fdbf8ac$export$4617fb02663045ef)(this.x - this.radius, this.y - this.radius, this.radius * 2, this.radius * 2);
    }
}
$076a80b12576921e$export$c89a927ffc67e6fa.prototype.toString = function() {
    return `[@pixi/math:Circle x=${this.x} y=${this.y} radius=${this.radius}]`;
};




class $8634cdd921030c11$export$80b0269ab108fa11 {
    /**
   * @param x - The X coordinate of the center of this ellipse
   * @param y - The Y coordinate of the center of this ellipse
   * @param halfWidth - The half width of this ellipse
   * @param halfHeight - The half height of this ellipse
   */ constructor(x = 0, y = 0, halfWidth = 0, halfHeight = 0){
        this.x = x, this.y = y, this.width = halfWidth, this.height = halfHeight, this.type = (0, $e51f17ddb17db7b9$export$511e1d54a4a8684e).ELIP;
    }
    /**
   * Creates a clone of this Ellipse instance
   * @returns {PIXI.Ellipse} A copy of the ellipse
   */ clone() {
        return new $8634cdd921030c11$export$80b0269ab108fa11(this.x, this.y, this.width, this.height);
    }
    /**
   * Checks whether the x and y coordinates given are contained within this ellipse
   * @param x - The X coordinate of the point to test
   * @param y - The Y coordinate of the point to test
   * @returns Whether the x/y coords are within this ellipse
   */ contains(x, y) {
        if (this.width <= 0 || this.height <= 0) return !1;
        let normx = (x - this.x) / this.width, normy = (y - this.y) / this.height;
        return normx *= normx, normy *= normy, normx + normy <= 1;
    }
    /**
   * Returns the framing rectangle of the ellipse as a Rectangle object
   * @returns The framing rectangle
   */ getBounds() {
        return new (0, $200f778d7fdbf8ac$export$4617fb02663045ef)(this.x - this.width, this.y - this.height, this.width, this.height);
    }
}
$8634cdd921030c11$export$80b0269ab108fa11.prototype.toString = function() {
    return `[@pixi/math:Ellipse x=${this.x} y=${this.y} width=${this.width} height=${this.height}]`;
};



class $20fd44ea129d646b$export$7d31b617c820d435 {
    /**
   * @param {PIXI.IPointData[]|number[]} points - This can be an array of Points
   *  that form the polygon, a flat array of numbers that will be interpreted as [x,y, x,y, ...], or
   *  the arguments passed can be all the points of the polygon e.g.
   *  `new Polygon(new Point(), new Point(), ...)`, or the arguments passed can be flat
   *  x,y values e.g. `new Polygon(x,y, x,y, x,y, ...)` where `x` and `y` are Numbers.
   */ constructor(...points){
        let flat = Array.isArray(points[0]) ? points[0] : points;
        if (typeof flat[0] != "number") {
            const p = [];
            for(let i = 0, il = flat.length; i < il; i++)p.push(flat[i].x, flat[i].y);
            flat = p;
        }
        this.points = flat, this.type = (0, $e51f17ddb17db7b9$export$511e1d54a4a8684e).POLY, this.closeStroke = !0;
    }
    /**
   * Creates a clone of this polygon.
   * @returns - A copy of the polygon.
   */ clone() {
        const points = this.points.slice(), polygon = new $20fd44ea129d646b$export$7d31b617c820d435(points);
        return polygon.closeStroke = this.closeStroke, polygon;
    }
    /**
   * Checks whether the x and y coordinates passed to this function are contained within this polygon.
   * @param x - The X coordinate of the point to test.
   * @param y - The Y coordinate of the point to test.
   * @returns - Whether the x/y coordinates are within this polygon.
   */ contains(x, y) {
        let inside = !1;
        const length = this.points.length / 2;
        for(let i = 0, j = length - 1; i < length; j = i++){
            const xi = this.points[i * 2], yi = this.points[i * 2 + 1], xj = this.points[j * 2], yj = this.points[j * 2 + 1];
            yi > y != yj > y && x < (xj - xi) * ((y - yi) / (yj - yi)) + xi && (inside = !inside);
        }
        return inside;
    }
}
$20fd44ea129d646b$export$7d31b617c820d435.prototype.toString = function() {
    return `[@pixi/math:PolygoncloseStroke=${this.closeStroke}points=${this.points.reduce((pointsDesc, currentPoint)=>`${pointsDesc}, ${currentPoint}`, "")}]`;
};




class $4766db92ea4581f8$export$d55ab2e3dc5a4263 {
    /**
   * @param x - The X coordinate of the upper-left corner of the rounded rectangle
   * @param y - The Y coordinate of the upper-left corner of the rounded rectangle
   * @param width - The overall width of this rounded rectangle
   * @param height - The overall height of this rounded rectangle
   * @param radius - Controls the radius of the rounded corners
   */ constructor(x = 0, y = 0, width = 0, height = 0, radius = 20){
        this.x = x, this.y = y, this.width = width, this.height = height, this.radius = radius, this.type = (0, $e51f17ddb17db7b9$export$511e1d54a4a8684e).RREC;
    }
    /**
   * Creates a clone of this Rounded Rectangle.
   * @returns - A copy of the rounded rectangle.
   */ clone() {
        return new $4766db92ea4581f8$export$d55ab2e3dc5a4263(this.x, this.y, this.width, this.height, this.radius);
    }
    /**
   * Checks whether the x and y coordinates given are contained within this Rounded Rectangle
   * @param x - The X coordinate of the point to test.
   * @param y - The Y coordinate of the point to test.
   * @returns - Whether the x/y coordinates are within this Rounded Rectangle.
   */ contains(x, y) {
        if (this.width <= 0 || this.height <= 0) return !1;
        if (x >= this.x && x <= this.x + this.width && y >= this.y && y <= this.y + this.height) {
            const radius = Math.max(0, Math.min(this.radius, Math.min(this.width, this.height) / 2));
            if (y >= this.y + radius && y <= this.y + this.height - radius || x >= this.x + radius && x <= this.x + this.width - radius) return !0;
            let dx = x - (this.x + radius), dy = y - (this.y + radius);
            const radius2 = radius * radius;
            if (dx * dx + dy * dy <= radius2 || (dx = x - (this.x + this.width - radius), dx * dx + dy * dy <= radius2) || (dy = y - (this.y + this.height - radius), dx * dx + dy * dy <= radius2) || (dx = x - (this.x + radius), dx * dx + dy * dy <= radius2)) return !0;
        }
        return !1;
    }
}
$4766db92ea4581f8$export$d55ab2e3dc5a4263.prototype.toString = function() {
    return `[@pixi/math:RoundedRectangle x=${this.x} y=${this.y}width=${this.width} height=${this.height} radius=${this.radius}]`;
};




class $d7da222aa639cde0$export$5b12bf1653c0dd85 {
    /**
   * @param a - x scale
   * @param b - y skew
   * @param c - x skew
   * @param d - y scale
   * @param tx - x translation
   * @param ty - y translation
   */ constructor(a = 1, b = 0, c = 0, d = 1, tx = 0, ty = 0){
        this.array = null, this.a = a, this.b = b, this.c = c, this.d = d, this.tx = tx, this.ty = ty;
    }
    /**
   * Creates a Matrix object based on the given array. The Element to Matrix mapping order is as follows:
   *
   * a = array[0]
   * b = array[1]
   * c = array[3]
   * d = array[4]
   * tx = array[2]
   * ty = array[5]
   * @param array - The array that the matrix will be populated from.
   */ fromArray(array) {
        this.a = array[0], this.b = array[1], this.c = array[3], this.d = array[4], this.tx = array[2], this.ty = array[5];
    }
    /**
   * Sets the matrix properties.
   * @param a - Matrix component
   * @param b - Matrix component
   * @param c - Matrix component
   * @param d - Matrix component
   * @param tx - Matrix component
   * @param ty - Matrix component
   * @returns This matrix. Good for chaining method calls.
   */ set(a, b, c, d, tx, ty) {
        return this.a = a, this.b = b, this.c = c, this.d = d, this.tx = tx, this.ty = ty, this;
    }
    /**
   * Creates an array from the current Matrix object.
   * @param transpose - Whether we need to transpose the matrix or not
   * @param [out=new Float32Array(9)] - If provided the array will be assigned to out
   * @returns The newly created array which contains the matrix
   */ toArray(transpose, out) {
        this.array || (this.array = new Float32Array(9));
        const array = out || this.array;
        return transpose ? (array[0] = this.a, array[1] = this.b, array[2] = 0, array[3] = this.c, array[4] = this.d, array[5] = 0, array[6] = this.tx, array[7] = this.ty, array[8] = 1) : (array[0] = this.a, array[1] = this.c, array[2] = this.tx, array[3] = this.b, array[4] = this.d, array[5] = this.ty, array[6] = 0, array[7] = 0, array[8] = 1), array;
    }
    /**
   * Get a new position with the current transformation applied.
   * Can be used to go from a child's coordinate space to the world coordinate space. (e.g. rendering)
   * @param pos - The origin
   * @param {PIXI.Point} [newPos] - The point that the new position is assigned to (allowed to be same as input)
   * @returns {PIXI.Point} The new point, transformed through this matrix
   */ apply(pos, newPos) {
        newPos = newPos || new (0, $cf3018b4309864c2$export$baf26146a414f24a)();
        const x = pos.x, y = pos.y;
        return newPos.x = this.a * x + this.c * y + this.tx, newPos.y = this.b * x + this.d * y + this.ty, newPos;
    }
    /**
   * Get a new position with the inverse of the current transformation applied.
   * Can be used to go from the world coordinate space to a child's coordinate space. (e.g. input)
   * @param pos - The origin
   * @param {PIXI.Point} [newPos] - The point that the new position is assigned to (allowed to be same as input)
   * @returns {PIXI.Point} The new point, inverse-transformed through this matrix
   */ applyInverse(pos, newPos) {
        newPos = newPos || new (0, $cf3018b4309864c2$export$baf26146a414f24a)();
        const id = 1 / (this.a * this.d + this.c * -this.b), x = pos.x, y = pos.y;
        return newPos.x = this.d * id * x + -this.c * id * y + (this.ty * this.c - this.tx * this.d) * id, newPos.y = this.a * id * y + -this.b * id * x + (-this.ty * this.a + this.tx * this.b) * id, newPos;
    }
    /**
   * Translates the matrix on the x and y.
   * @param x - How much to translate x by
   * @param y - How much to translate y by
   * @returns This matrix. Good for chaining method calls.
   */ translate(x, y) {
        return this.tx += x, this.ty += y, this;
    }
    /**
   * Applies a scale transformation to the matrix.
   * @param x - The amount to scale horizontally
   * @param y - The amount to scale vertically
   * @returns This matrix. Good for chaining method calls.
   */ scale(x, y) {
        return this.a *= x, this.d *= y, this.c *= x, this.b *= y, this.tx *= x, this.ty *= y, this;
    }
    /**
   * Applies a rotation transformation to the matrix.
   * @param angle - The angle in radians.
   * @returns This matrix. Good for chaining method calls.
   */ rotate(angle) {
        const cos = Math.cos(angle), sin = Math.sin(angle), a1 = this.a, c1 = this.c, tx1 = this.tx;
        return this.a = a1 * cos - this.b * sin, this.b = a1 * sin + this.b * cos, this.c = c1 * cos - this.d * sin, this.d = c1 * sin + this.d * cos, this.tx = tx1 * cos - this.ty * sin, this.ty = tx1 * sin + this.ty * cos, this;
    }
    /**
   * Appends the given Matrix to this Matrix.
   * @param matrix - The matrix to append.
   * @returns This matrix. Good for chaining method calls.
   */ append(matrix) {
        const a1 = this.a, b1 = this.b, c1 = this.c, d1 = this.d;
        return this.a = matrix.a * a1 + matrix.b * c1, this.b = matrix.a * b1 + matrix.b * d1, this.c = matrix.c * a1 + matrix.d * c1, this.d = matrix.c * b1 + matrix.d * d1, this.tx = matrix.tx * a1 + matrix.ty * c1 + this.tx, this.ty = matrix.tx * b1 + matrix.ty * d1 + this.ty, this;
    }
    /**
   * Sets the matrix based on all the available properties
   * @param x - Position on the x axis
   * @param y - Position on the y axis
   * @param pivotX - Pivot on the x axis
   * @param pivotY - Pivot on the y axis
   * @param scaleX - Scale on the x axis
   * @param scaleY - Scale on the y axis
   * @param rotation - Rotation in radians
   * @param skewX - Skew on the x axis
   * @param skewY - Skew on the y axis
   * @returns This matrix. Good for chaining method calls.
   */ setTransform(x, y, pivotX, pivotY, scaleX, scaleY, rotation, skewX, skewY) {
        return this.a = Math.cos(rotation + skewY) * scaleX, this.b = Math.sin(rotation + skewY) * scaleX, this.c = -Math.sin(rotation - skewX) * scaleY, this.d = Math.cos(rotation - skewX) * scaleY, this.tx = x - (pivotX * this.a + pivotY * this.c), this.ty = y - (pivotX * this.b + pivotY * this.d), this;
    }
    /**
   * Prepends the given Matrix to this Matrix.
   * @param matrix - The matrix to prepend
   * @returns This matrix. Good for chaining method calls.
   */ prepend(matrix) {
        const tx1 = this.tx;
        if (matrix.a !== 1 || matrix.b !== 0 || matrix.c !== 0 || matrix.d !== 1) {
            const a1 = this.a, c1 = this.c;
            this.a = a1 * matrix.a + this.b * matrix.c, this.b = a1 * matrix.b + this.b * matrix.d, this.c = c1 * matrix.a + this.d * matrix.c, this.d = c1 * matrix.b + this.d * matrix.d;
        }
        return this.tx = tx1 * matrix.a + this.ty * matrix.c + matrix.tx, this.ty = tx1 * matrix.b + this.ty * matrix.d + matrix.ty, this;
    }
    /**
   * Decomposes the matrix (x, y, scaleX, scaleY, and rotation) and sets the properties on to a transform.
   * @param transform - The transform to apply the properties to.
   * @returns The transform with the newly applied properties
   */ decompose(transform) {
        const a = this.a, b = this.b, c = this.c, d = this.d, pivot = transform.pivot, skewX = -Math.atan2(-c, d), skewY = Math.atan2(b, a), delta = Math.abs(skewX + skewY);
        return delta < 1e-5 || Math.abs((0, $e51f17ddb17db7b9$export$59ed0a0a5de1084b) - delta) < 1e-5 ? (transform.rotation = skewY, transform.skew.x = transform.skew.y = 0) : (transform.rotation = 0, transform.skew.x = skewX, transform.skew.y = skewY), transform.scale.x = Math.sqrt(a * a + b * b), transform.scale.y = Math.sqrt(c * c + d * d), transform.position.x = this.tx + (pivot.x * a + pivot.y * c), transform.position.y = this.ty + (pivot.x * b + pivot.y * d), transform;
    }
    /**
   * Inverts this matrix
   * @returns This matrix. Good for chaining method calls.
   */ invert() {
        const a1 = this.a, b1 = this.b, c1 = this.c, d1 = this.d, tx1 = this.tx, n = a1 * d1 - b1 * c1;
        return this.a = d1 / n, this.b = -b1 / n, this.c = -c1 / n, this.d = a1 / n, this.tx = (c1 * this.ty - d1 * tx1) / n, this.ty = -(a1 * this.ty - b1 * tx1) / n, this;
    }
    /**
   * Resets this Matrix to an identity (default) matrix.
   * @returns This matrix. Good for chaining method calls.
   */ identity() {
        return this.a = 1, this.b = 0, this.c = 0, this.d = 1, this.tx = 0, this.ty = 0, this;
    }
    /**
   * Creates a new Matrix object with the same values as this one.
   * @returns A copy of this matrix. Good for chaining method calls.
   */ clone() {
        const matrix = new $d7da222aa639cde0$export$5b12bf1653c0dd85();
        return matrix.a = this.a, matrix.b = this.b, matrix.c = this.c, matrix.d = this.d, matrix.tx = this.tx, matrix.ty = this.ty, matrix;
    }
    /**
   * Changes the values of the given matrix to be the same as the ones in this matrix
   * @param matrix - The matrix to copy to.
   * @returns The matrix given in parameter with its values updated.
   */ copyTo(matrix) {
        return matrix.a = this.a, matrix.b = this.b, matrix.c = this.c, matrix.d = this.d, matrix.tx = this.tx, matrix.ty = this.ty, matrix;
    }
    /**
   * Changes the values of the matrix to be the same as the ones in given matrix
   * @param {PIXI.Matrix} matrix - The matrix to copy from.
   * @returns {PIXI.Matrix} this
   */ copyFrom(matrix) {
        return this.a = matrix.a, this.b = matrix.b, this.c = matrix.c, this.d = matrix.d, this.tx = matrix.tx, this.ty = matrix.ty, this;
    }
    /**
   * A default (identity) matrix
   * @readonly
   */ static get IDENTITY() {
        return new $d7da222aa639cde0$export$5b12bf1653c0dd85();
    }
    /**
   * A temp matrix
   * @readonly
   */ static get TEMP_MATRIX() {
        return new $d7da222aa639cde0$export$5b12bf1653c0dd85();
    }
}
$d7da222aa639cde0$export$5b12bf1653c0dd85.prototype.toString = function() {
    return `[@pixi/math:Matrix a=${this.a} b=${this.b} c=${this.c} d=${this.d} tx=${this.tx} ty=${this.ty}]`;
};


const $6635f7147000f2a6$var$ux = [
    1,
    1,
    0,
    -1,
    -1,
    -1,
    0,
    1,
    1,
    1,
    0,
    -1,
    -1,
    -1,
    0,
    1
], $6635f7147000f2a6$var$uy = [
    0,
    1,
    1,
    1,
    0,
    -1,
    -1,
    -1,
    0,
    1,
    1,
    1,
    0,
    -1,
    -1,
    -1
], $6635f7147000f2a6$var$vx = [
    0,
    -1,
    -1,
    -1,
    0,
    1,
    1,
    1,
    0,
    1,
    1,
    1,
    0,
    -1,
    -1,
    -1
], $6635f7147000f2a6$var$vy = [
    1,
    1,
    0,
    -1,
    -1,
    -1,
    0,
    1,
    -1,
    -1,
    0,
    1,
    1,
    1,
    0,
    -1
], $6635f7147000f2a6$var$rotationCayley = [], $6635f7147000f2a6$var$rotationMatrices = [], $6635f7147000f2a6$var$signum = Math.sign;
function $6635f7147000f2a6$var$init() {
    for(let i = 0; i < 16; i++){
        const row = [];
        $6635f7147000f2a6$var$rotationCayley.push(row);
        for(let j = 0; j < 16; j++){
            const _ux = $6635f7147000f2a6$var$signum($6635f7147000f2a6$var$ux[i] * $6635f7147000f2a6$var$ux[j] + $6635f7147000f2a6$var$vx[i] * $6635f7147000f2a6$var$uy[j]), _uy = $6635f7147000f2a6$var$signum($6635f7147000f2a6$var$uy[i] * $6635f7147000f2a6$var$ux[j] + $6635f7147000f2a6$var$vy[i] * $6635f7147000f2a6$var$uy[j]), _vx = $6635f7147000f2a6$var$signum($6635f7147000f2a6$var$ux[i] * $6635f7147000f2a6$var$vx[j] + $6635f7147000f2a6$var$vx[i] * $6635f7147000f2a6$var$vy[j]), _vy = $6635f7147000f2a6$var$signum($6635f7147000f2a6$var$uy[i] * $6635f7147000f2a6$var$vx[j] + $6635f7147000f2a6$var$vy[i] * $6635f7147000f2a6$var$vy[j]);
            for(let k = 0; k < 16; k++)if ($6635f7147000f2a6$var$ux[k] === _ux && $6635f7147000f2a6$var$uy[k] === _uy && $6635f7147000f2a6$var$vx[k] === _vx && $6635f7147000f2a6$var$vy[k] === _vy) {
                row.push(k);
                break;
            }
        }
    }
    for(let i = 0; i < 16; i++){
        const mat = new (0, $d7da222aa639cde0$export$5b12bf1653c0dd85)();
        mat.set($6635f7147000f2a6$var$ux[i], $6635f7147000f2a6$var$uy[i], $6635f7147000f2a6$var$vx[i], $6635f7147000f2a6$var$vy[i], 0, 0), $6635f7147000f2a6$var$rotationMatrices.push(mat);
    }
}
$6635f7147000f2a6$var$init();
const $6635f7147000f2a6$export$b7bb6a2a8d203102 = {
    /**
   * | Rotation | Direction |
   * |----------|-----------|
   * | 0°       | East      |
   * @readonly
   */ E: 0,
    /**
   * | Rotation | Direction |
   * |----------|-----------|
   * | 45°↻     | Southeast |
   * @readonly
   */ SE: 1,
    /**
   * | Rotation | Direction |
   * |----------|-----------|
   * | 90°↻     | South     |
   * @readonly
   */ S: 2,
    /**
   * | Rotation | Direction |
   * |----------|-----------|
   * | 135°↻    | Southwest |
   * @readonly
   */ SW: 3,
    /**
   * | Rotation | Direction |
   * |----------|-----------|
   * | 180°     | West      |
   * @readonly
   */ W: 4,
    /**
   * | Rotation    | Direction    |
   * |-------------|--------------|
   * | -135°/225°↻ | Northwest    |
   * @readonly
   */ NW: 5,
    /**
   * | Rotation    | Direction    |
   * |-------------|--------------|
   * | -90°/270°↻  | North        |
   * @readonly
   */ N: 6,
    /**
   * | Rotation    | Direction    |
   * |-------------|--------------|
   * | -45°/315°↻  | Northeast    |
   * @readonly
   */ NE: 7,
    /**
   * Reflection about Y-axis.
   * @readonly
   */ MIRROR_VERTICAL: 8,
    /**
   * Reflection about the main diagonal.
   * @readonly
   */ MAIN_DIAGONAL: 10,
    /**
   * Reflection about X-axis.
   * @readonly
   */ MIRROR_HORIZONTAL: 12,
    /**
   * Reflection about reverse diagonal.
   * @readonly
   */ REVERSE_DIAGONAL: 14,
    /**
   * @param {PIXI.GD8Symmetry} ind - sprite rotation angle.
   * @returns {PIXI.GD8Symmetry} The X-component of the U-axis
   *    after rotating the axes.
   */ uX: (ind)=>$6635f7147000f2a6$var$ux[ind],
    /**
   * @param {PIXI.GD8Symmetry} ind - sprite rotation angle.
   * @returns {PIXI.GD8Symmetry} The Y-component of the U-axis
   *    after rotating the axes.
   */ uY: (ind)=>$6635f7147000f2a6$var$uy[ind],
    /**
   * @param {PIXI.GD8Symmetry} ind - sprite rotation angle.
   * @returns {PIXI.GD8Symmetry} The X-component of the V-axis
   *    after rotating the axes.
   */ vX: (ind)=>$6635f7147000f2a6$var$vx[ind],
    /**
   * @param {PIXI.GD8Symmetry} ind - sprite rotation angle.
   * @returns {PIXI.GD8Symmetry} The Y-component of the V-axis
   *    after rotating the axes.
   */ vY: (ind)=>$6635f7147000f2a6$var$vy[ind],
    /**
   * @param {PIXI.GD8Symmetry} rotation - symmetry whose opposite
   *   is needed. Only rotations have opposite symmetries while
   *   reflections don't.
   * @returns {PIXI.GD8Symmetry} The opposite symmetry of `rotation`
   */ inv: (rotation)=>rotation & 8 ? rotation & 15 : -rotation & 7,
    /**
   * Composes the two D8 operations.
   *
   * Taking `^` as reflection:
   *
   * |       | E=0 | S=2 | W=4 | N=6 | E^=8 | S^=10 | W^=12 | N^=14 |
   * |-------|-----|-----|-----|-----|------|-------|-------|-------|
   * | E=0   | E   | S   | W   | N   | E^   | S^    | W^    | N^    |
   * | S=2   | S   | W   | N   | E   | S^   | W^    | N^    | E^    |
   * | W=4   | W   | N   | E   | S   | W^   | N^    | E^    | S^    |
   * | N=6   | N   | E   | S   | W   | N^   | E^    | S^    | W^    |
   * | E^=8  | E^  | N^  | W^  | S^  | E    | N     | W     | S     |
   * | S^=10 | S^  | E^  | N^  | W^  | S    | E     | N     | W     |
   * | W^=12 | W^  | S^  | E^  | N^  | W    | S     | E     | N     |
   * | N^=14 | N^  | W^  | S^  | E^  | N    | W     | S     | E     |
   *
   * [This is a Cayley table]{@link https://en.wikipedia.org/wiki/Cayley_table}
   * @param {PIXI.GD8Symmetry} rotationSecond - Second operation, which
   *   is the row in the above cayley table.
   * @param {PIXI.GD8Symmetry} rotationFirst - First operation, which
   *   is the column in the above cayley table.
   * @returns {PIXI.GD8Symmetry} Composed operation
   */ add: (rotationSecond, rotationFirst)=>$6635f7147000f2a6$var$rotationCayley[rotationSecond][rotationFirst],
    /**
   * Reverse of `add`.
   * @param {PIXI.GD8Symmetry} rotationSecond - Second operation
   * @param {PIXI.GD8Symmetry} rotationFirst - First operation
   * @returns {PIXI.GD8Symmetry} Result
   */ sub: (rotationSecond, rotationFirst)=>$6635f7147000f2a6$var$rotationCayley[rotationSecond][$6635f7147000f2a6$export$b7bb6a2a8d203102.inv(rotationFirst)],
    /**
   * Adds 180 degrees to rotation, which is a commutative
   * operation.
   * @param {number} rotation - The number to rotate.
   * @returns {number} Rotated number
   */ rotate180: (rotation)=>rotation ^ 4,
    /**
   * Checks if the rotation angle is vertical, i.e. south
   * or north. It doesn't work for reflections.
   * @param {PIXI.GD8Symmetry} rotation - The number to check.
   * @returns {boolean} Whether or not the direction is vertical
   */ isVertical: (rotation)=>(rotation & 3) === 2,
    // rotation % 4 === 2
    /**
   * Approximates the vector `V(dx,dy)` into one of the
   * eight directions provided by `groupD8`.
   * @param {number} dx - X-component of the vector
   * @param {number} dy - Y-component of the vector
   * @returns {PIXI.GD8Symmetry} Approximation of the vector into
   *  one of the eight symmetries.
   */ byDirection: (dx, dy)=>Math.abs(dx) * 2 <= Math.abs(dy) ? dy >= 0 ? $6635f7147000f2a6$export$b7bb6a2a8d203102.S : $6635f7147000f2a6$export$b7bb6a2a8d203102.N : Math.abs(dy) * 2 <= Math.abs(dx) ? dx > 0 ? $6635f7147000f2a6$export$b7bb6a2a8d203102.E : $6635f7147000f2a6$export$b7bb6a2a8d203102.W : dy > 0 ? dx > 0 ? $6635f7147000f2a6$export$b7bb6a2a8d203102.SE : $6635f7147000f2a6$export$b7bb6a2a8d203102.SW : dx > 0 ? $6635f7147000f2a6$export$b7bb6a2a8d203102.NE : $6635f7147000f2a6$export$b7bb6a2a8d203102.NW,
    /**
   * Helps sprite to compensate texture packer rotation.
   * @param {PIXI.Matrix} matrix - sprite world matrix
   * @param {PIXI.GD8Symmetry} rotation - The rotation factor to use.
   * @param {number} tx - sprite anchoring
   * @param {number} ty - sprite anchoring
   */ matrixAppendRotationInv: (matrix, rotation, tx = 0, ty = 0)=>{
        const mat = $6635f7147000f2a6$var$rotationMatrices[$6635f7147000f2a6$export$b7bb6a2a8d203102.inv(rotation)];
        mat.tx = tx, mat.ty = ty, matrix.append(mat);
    }
};







class $52576bc20755886a$export$3755aaad3fd42e52 {
    /**
   * Creates a new `ObservablePoint`
   * @param cb - callback function triggered when `x` and/or `y` are changed
   * @param scope - owner of callback
   * @param {number} [x=0] - position of the point on the x axis
   * @param {number} [y=0] - position of the point on the y axis
   */ constructor(cb, scope, x = 0, y = 0){
        this._x = x, this._y = y, this.cb = cb, this.scope = scope;
    }
    /**
   * Creates a clone of this point.
   * The callback and scope params can be overridden otherwise they will default
   * to the clone object's values.
   * @override
   * @param cb - The callback function triggered when `x` and/or `y` are changed
   * @param scope - The owner of the callback
   * @returns a copy of this observable point
   */ clone(cb = this.cb, scope = this.scope) {
        return new $52576bc20755886a$export$3755aaad3fd42e52(cb, scope, this._x, this._y);
    }
    /**
   * Sets the point to a new `x` and `y` position.
   * If `y` is omitted, both `x` and `y` will be set to `x`.
   * @param {number} [x=0] - position of the point on the x axis
   * @param {number} [y=x] - position of the point on the y axis
   * @returns The observable point instance itself
   */ set(x = 0, y = x) {
        return (this._x !== x || this._y !== y) && (this._x = x, this._y = y, this.cb.call(this.scope)), this;
    }
    /**
   * Copies x and y from the given point (`p`)
   * @param p - The point to copy from. Can be any of type that is or extends `IPointData`
   * @returns The observable point instance itself
   */ copyFrom(p) {
        return (this._x !== p.x || this._y !== p.y) && (this._x = p.x, this._y = p.y, this.cb.call(this.scope)), this;
    }
    /**
   * Copies this point's x and y into that of the given point (`p`)
   * @param p - The point to copy to. Can be any of type that is or extends `IPointData`
   * @returns The point (`p`) with values updated
   */ copyTo(p) {
        return p.set(this._x, this._y), p;
    }
    /**
   * Accepts another point (`p`) and returns `true` if the given point is equal to this point
   * @param p - The point to check
   * @returns Returns `true` if both `x` and `y` are equal
   */ equals(p) {
        return p.x === this._x && p.y === this._y;
    }
    /** Position of the observable point on the x axis. */ get x() {
        return this._x;
    }
    set x(value) {
        this._x !== value && (this._x = value, this.cb.call(this.scope));
    }
    /** Position of the observable point on the y axis. */ get y() {
        return this._y;
    }
    set y(value) {
        this._y !== value && (this._y = value, this.cb.call(this.scope));
    }
}
$52576bc20755886a$export$3755aaad3fd42e52.prototype.toString = function() {
    return `[@pixi/math:ObservablePoint x=${this.x} y=${this.y} scope=${this.scope}]`;
};





const $cec25acf758d963f$var$_Transform = class {
    constructor(){
        this.worldTransform = new (0, $d7da222aa639cde0$export$5b12bf1653c0dd85)(), this.localTransform = new (0, $d7da222aa639cde0$export$5b12bf1653c0dd85)(), this.position = new (0, $52576bc20755886a$export$3755aaad3fd42e52)(this.onChange, this, 0, 0), this.scale = new (0, $52576bc20755886a$export$3755aaad3fd42e52)(this.onChange, this, 1, 1), this.pivot = new (0, $52576bc20755886a$export$3755aaad3fd42e52)(this.onChange, this, 0, 0), this.skew = new (0, $52576bc20755886a$export$3755aaad3fd42e52)(this.updateSkew, this, 0, 0), this._rotation = 0, this._cx = 1, this._sx = 0, this._cy = 0, this._sy = 1, this._localID = 0, this._currentLocalID = 0, this._worldID = 0, this._parentID = 0;
    }
    /** Called when a value changes. */ onChange() {
        this._localID++;
    }
    /** Called when the skew or the rotation changes. */ updateSkew() {
        this._cx = Math.cos(this._rotation + this.skew.y), this._sx = Math.sin(this._rotation + this.skew.y), this._cy = -Math.sin(this._rotation - this.skew.x), this._sy = Math.cos(this._rotation - this.skew.x), this._localID++;
    }
    /** Updates the local transformation matrix. */ updateLocalTransform() {
        const lt = this.localTransform;
        this._localID !== this._currentLocalID && (lt.a = this._cx * this.scale.x, lt.b = this._sx * this.scale.x, lt.c = this._cy * this.scale.y, lt.d = this._sy * this.scale.y, lt.tx = this.position.x - (this.pivot.x * lt.a + this.pivot.y * lt.c), lt.ty = this.position.y - (this.pivot.x * lt.b + this.pivot.y * lt.d), this._currentLocalID = this._localID, this._parentID = -1);
    }
    /**
   * Updates the local and the world transformation matrices.
   * @param parentTransform - The parent transform
   */ updateTransform(parentTransform) {
        const lt = this.localTransform;
        if (this._localID !== this._currentLocalID && (lt.a = this._cx * this.scale.x, lt.b = this._sx * this.scale.x, lt.c = this._cy * this.scale.y, lt.d = this._sy * this.scale.y, lt.tx = this.position.x - (this.pivot.x * lt.a + this.pivot.y * lt.c), lt.ty = this.position.y - (this.pivot.x * lt.b + this.pivot.y * lt.d), this._currentLocalID = this._localID, this._parentID = -1), this._parentID !== parentTransform._worldID) {
            const pt = parentTransform.worldTransform, wt = this.worldTransform;
            wt.a = lt.a * pt.a + lt.b * pt.c, wt.b = lt.a * pt.b + lt.b * pt.d, wt.c = lt.c * pt.a + lt.d * pt.c, wt.d = lt.c * pt.b + lt.d * pt.d, wt.tx = lt.tx * pt.a + lt.ty * pt.c + pt.tx, wt.ty = lt.tx * pt.b + lt.ty * pt.d + pt.ty, this._parentID = parentTransform._worldID, this._worldID++;
        }
    }
    /**
   * Decomposes a matrix and sets the transforms properties based on it.
   * @param matrix - The matrix to decompose
   */ setFromMatrix(matrix) {
        matrix.decompose(this), this._localID++;
    }
    /** The rotation of the object in radians. */ get rotation() {
        return this._rotation;
    }
    set rotation(value) {
        this._rotation !== value && (this._rotation = value, this.updateSkew());
    }
};
$cec25acf758d963f$var$_Transform.IDENTITY = new $cec25acf758d963f$var$_Transform();
let $cec25acf758d963f$export$563a914cafbdc389 = $cec25acf758d963f$var$_Transform;
$cec25acf758d963f$export$563a914cafbdc389.prototype.toString = function() {
    return `[@pixi/math:Transform position=(${this.position.x}, ${this.position.y}) rotation=${this.rotation} scale=(${this.scale.x}, ${this.scale.y}) skew=(${this.skew.x}, ${this.skew.y}) ]`;
};







var $30be5db75d830fde$export$2e2bcd8739ae039 = `varying vec2 vTextureCoord;

uniform sampler2D uSampler;

void main(void){
   gl_FragColor *= texture2D(uSampler, vTextureCoord);
}`;


var $6f0344c5ca1f2dad$export$2e2bcd8739ae039 = `attribute vec2 aVertexPosition;
attribute vec2 aTextureCoord;

uniform mat3 projectionMatrix;

varying vec2 vTextureCoord;

void main(void){
   gl_Position = vec4((projectionMatrix * vec3(aVertexPosition, 1.0)).xy, 0.0, 1.0);
   vTextureCoord = aTextureCoord;
}
`;



function $59b0b09c05c49ae6$export$9b5304f4eb007cf0(gl, type, src) {
    const shader = gl.createShader(type);
    return gl.shaderSource(shader, src), gl.compileShader(shader), shader;
}


function $09c91f51b342cc6b$var$booleanArray(size) {
    const array = new Array(size);
    for(let i = 0; i < array.length; i++)array[i] = !1;
    return array;
}
function $09c91f51b342cc6b$export$1a01ae0705bafd37(type, size) {
    switch(type){
        case "float":
            return 0;
        case "vec2":
            return new Float32Array(2 * size);
        case "vec3":
            return new Float32Array(3 * size);
        case "vec4":
            return new Float32Array(4 * size);
        case "int":
        case "uint":
        case "sampler2D":
        case "sampler2DArray":
            return 0;
        case "ivec2":
            return new Int32Array(2 * size);
        case "ivec3":
            return new Int32Array(3 * size);
        case "ivec4":
            return new Int32Array(4 * size);
        case "uvec2":
            return new Uint32Array(2 * size);
        case "uvec3":
            return new Uint32Array(3 * size);
        case "uvec4":
            return new Uint32Array(4 * size);
        case "bool":
            return !1;
        case "bvec2":
            return $09c91f51b342cc6b$var$booleanArray(2 * size);
        case "bvec3":
            return $09c91f51b342cc6b$var$booleanArray(3 * size);
        case "bvec4":
            return $09c91f51b342cc6b$var$booleanArray(4 * size);
        case "mat2":
            return new Float32Array([
                1,
                0,
                0,
                1
            ]);
        case "mat3":
            return new Float32Array([
                1,
                0,
                0,
                0,
                1,
                0,
                0,
                0,
                1
            ]);
        case "mat4":
            return new Float32Array([
                1,
                0,
                0,
                0,
                0,
                1,
                0,
                0,
                0,
                0,
                1,
                0,
                0,
                0,
                0,
                1
            ]);
    }
    return null;
}


const $2fc9b1ca00707202$export$cf9f41a7e506e2d2 = [
    // a float cache layer
    {
        test: (data)=>data.type === "float" && data.size === 1 && !data.isArray,
        code: (name)=>`
            if(uv["${name}"] !== ud["${name}"].value)
            {
                ud["${name}"].value = uv["${name}"]
                gl.uniform1f(ud["${name}"].location, uv["${name}"])
            }
            `
    },
    // handling samplers
    {
        test: (data, uniform)=>// eslint-disable-next-line max-len,no-eq-null,eqeqeq
            (data.type === "sampler2D" || data.type === "samplerCube" || data.type === "sampler2DArray") && data.size === 1 && !data.isArray && (uniform == null || uniform.castToBaseTexture !== void 0),
        code: (name)=>`t = syncData.textureCount++;

            renderer.texture.bind(uv["${name}"], t);

            if(ud["${name}"].value !== t)
            {
                ud["${name}"].value = t;
                gl.uniform1i(ud["${name}"].location, t);
; // eslint-disable-line max-len
            }`
    },
    // uploading pixi matrix object to mat3
    {
        test: (data, uniform)=>data.type === "mat3" && data.size === 1 && !data.isArray && uniform.a !== void 0,
        code: (name)=>// TODO and some smart caching dirty ids here!
            `
            gl.uniformMatrix3fv(ud["${name}"].location, false, uv["${name}"].toArray(true));
            `,
        codeUbo: (name)=>`
                var ${name}_matrix = uv.${name}.toArray(true);

                data[offset] = ${name}_matrix[0];
                data[offset+1] = ${name}_matrix[1];
                data[offset+2] = ${name}_matrix[2];
        
                data[offset + 4] = ${name}_matrix[3];
                data[offset + 5] = ${name}_matrix[4];
                data[offset + 6] = ${name}_matrix[5];
        
                data[offset + 8] = ${name}_matrix[6];
                data[offset + 9] = ${name}_matrix[7];
                data[offset + 10] = ${name}_matrix[8];
            `
    },
    // uploading a pixi point as a vec2 with caching layer
    {
        test: (data, uniform)=>data.type === "vec2" && data.size === 1 && !data.isArray && uniform.x !== void 0,
        code: (name)=>`
                cv = ud["${name}"].value;
                v = uv["${name}"];

                if(cv[0] !== v.x || cv[1] !== v.y)
                {
                    cv[0] = v.x;
                    cv[1] = v.y;
                    gl.uniform2f(ud["${name}"].location, v.x, v.y);
                }`,
        codeUbo: (name)=>`
                v = uv.${name};

                data[offset] = v.x;
                data[offset+1] = v.y;
            `
    },
    // caching layer for a vec2
    {
        test: (data)=>data.type === "vec2" && data.size === 1 && !data.isArray,
        code: (name)=>`
                cv = ud["${name}"].value;
                v = uv["${name}"];

                if(cv[0] !== v[0] || cv[1] !== v[1])
                {
                    cv[0] = v[0];
                    cv[1] = v[1];
                    gl.uniform2f(ud["${name}"].location, v[0], v[1]);
                }
            `
    },
    // upload a pixi rectangle as a vec4 with caching layer
    {
        test: (data, uniform)=>data.type === "vec4" && data.size === 1 && !data.isArray && uniform.width !== void 0,
        code: (name)=>`
                cv = ud["${name}"].value;
                v = uv["${name}"];

                if(cv[0] !== v.x || cv[1] !== v.y || cv[2] !== v.width || cv[3] !== v.height)
                {
                    cv[0] = v.x;
                    cv[1] = v.y;
                    cv[2] = v.width;
                    cv[3] = v.height;
                    gl.uniform4f(ud["${name}"].location, v.x, v.y, v.width, v.height)
                }`,
        codeUbo: (name)=>`
                    v = uv.${name};

                    data[offset] = v.x;
                    data[offset+1] = v.y;
                    data[offset+2] = v.width;
                    data[offset+3] = v.height;
                `
    },
    // upload a pixi color as vec4 with caching layer
    {
        test: (data, uniform)=>data.type === "vec4" && data.size === 1 && !data.isArray && uniform.red !== void 0,
        code: (name)=>`
                cv = ud["${name}"].value;
                v = uv["${name}"];

                if(cv[0] !== v.red || cv[1] !== v.green || cv[2] !== v.blue || cv[3] !== v.alpha)
                {
                    cv[0] = v.red;
                    cv[1] = v.green;
                    cv[2] = v.blue;
                    cv[3] = v.alpha;
                    gl.uniform4f(ud["${name}"].location, v.red, v.green, v.blue, v.alpha)
                }`,
        codeUbo: (name)=>`
                    v = uv.${name};

                    data[offset] = v.red;
                    data[offset+1] = v.green;
                    data[offset+2] = v.blue;
                    data[offset+3] = v.alpha;
                `
    },
    // upload a pixi color as a vec3 with caching layer
    {
        test: (data, uniform)=>data.type === "vec3" && data.size === 1 && !data.isArray && uniform.red !== void 0,
        code: (name)=>`
                cv = ud["${name}"].value;
                v = uv["${name}"];

                if(cv[0] !== v.red || cv[1] !== v.green || cv[2] !== v.blue || cv[3] !== v.a)
                {
                    cv[0] = v.red;
                    cv[1] = v.green;
                    cv[2] = v.blue;
    
                    gl.uniform3f(ud["${name}"].location, v.red, v.green, v.blue)
                }`,
        codeUbo: (name)=>`
                    v = uv.${name};

                    data[offset] = v.red;
                    data[offset+1] = v.green;
                    data[offset+2] = v.blue;
                `
    },
    // a caching layer for vec4 uploading
    {
        test: (data)=>data.type === "vec4" && data.size === 1 && !data.isArray,
        code: (name)=>`
                cv = ud["${name}"].value;
                v = uv["${name}"];

                if(cv[0] !== v[0] || cv[1] !== v[1] || cv[2] !== v[2] || cv[3] !== v[3])
                {
                    cv[0] = v[0];
                    cv[1] = v[1];
                    cv[2] = v[2];
                    cv[3] = v[3];

                    gl.uniform4f(ud["${name}"].location, v[0], v[1], v[2], v[3])
                }`
    }
];


const $3db0a94081cf75de$var$GLSL_TO_SINGLE_SETTERS_CACHED = {
    float: `
    if (cv !== v)
    {
        cu.value = v;
        gl.uniform1f(location, v);
    }`,
    vec2: `
    if (cv[0] !== v[0] || cv[1] !== v[1])
    {
        cv[0] = v[0];
        cv[1] = v[1];

        gl.uniform2f(location, v[0], v[1])
    }`,
    vec3: `
    if (cv[0] !== v[0] || cv[1] !== v[1] || cv[2] !== v[2])
    {
        cv[0] = v[0];
        cv[1] = v[1];
        cv[2] = v[2];

        gl.uniform3f(location, v[0], v[1], v[2])
    }`,
    vec4: `
    if (cv[0] !== v[0] || cv[1] !== v[1] || cv[2] !== v[2] || cv[3] !== v[3])
    {
        cv[0] = v[0];
        cv[1] = v[1];
        cv[2] = v[2];
        cv[3] = v[3];

        gl.uniform4f(location, v[0], v[1], v[2], v[3]);
    }`,
    int: `
    if (cv !== v)
    {
        cu.value = v;

        gl.uniform1i(location, v);
    }`,
    ivec2: `
    if (cv[0] !== v[0] || cv[1] !== v[1])
    {
        cv[0] = v[0];
        cv[1] = v[1];

        gl.uniform2i(location, v[0], v[1]);
    }`,
    ivec3: `
    if (cv[0] !== v[0] || cv[1] !== v[1] || cv[2] !== v[2])
    {
        cv[0] = v[0];
        cv[1] = v[1];
        cv[2] = v[2];

        gl.uniform3i(location, v[0], v[1], v[2]);
    }`,
    ivec4: `
    if (cv[0] !== v[0] || cv[1] !== v[1] || cv[2] !== v[2] || cv[3] !== v[3])
    {
        cv[0] = v[0];
        cv[1] = v[1];
        cv[2] = v[2];
        cv[3] = v[3];

        gl.uniform4i(location, v[0], v[1], v[2], v[3]);
    }`,
    uint: `
    if (cv !== v)
    {
        cu.value = v;

        gl.uniform1ui(location, v);
    }`,
    uvec2: `
    if (cv[0] !== v[0] || cv[1] !== v[1])
    {
        cv[0] = v[0];
        cv[1] = v[1];

        gl.uniform2ui(location, v[0], v[1]);
    }`,
    uvec3: `
    if (cv[0] !== v[0] || cv[1] !== v[1] || cv[2] !== v[2])
    {
        cv[0] = v[0];
        cv[1] = v[1];
        cv[2] = v[2];

        gl.uniform3ui(location, v[0], v[1], v[2]);
    }`,
    uvec4: `
    if (cv[0] !== v[0] || cv[1] !== v[1] || cv[2] !== v[2] || cv[3] !== v[3])
    {
        cv[0] = v[0];
        cv[1] = v[1];
        cv[2] = v[2];
        cv[3] = v[3];

        gl.uniform4ui(location, v[0], v[1], v[2], v[3]);
    }`,
    bool: `
    if (cv !== v)
    {
        cu.value = v;
        gl.uniform1i(location, v);
    }`,
    bvec2: `
    if (cv[0] != v[0] || cv[1] != v[1])
    {
        cv[0] = v[0];
        cv[1] = v[1];

        gl.uniform2i(location, v[0], v[1]);
    }`,
    bvec3: `
    if (cv[0] !== v[0] || cv[1] !== v[1] || cv[2] !== v[2])
    {
        cv[0] = v[0];
        cv[1] = v[1];
        cv[2] = v[2];

        gl.uniform3i(location, v[0], v[1], v[2]);
    }`,
    bvec4: `
    if (cv[0] !== v[0] || cv[1] !== v[1] || cv[2] !== v[2] || cv[3] !== v[3])
    {
        cv[0] = v[0];
        cv[1] = v[1];
        cv[2] = v[2];
        cv[3] = v[3];

        gl.uniform4i(location, v[0], v[1], v[2], v[3]);
    }`,
    mat2: "gl.uniformMatrix2fv(location, false, v)",
    mat3: "gl.uniformMatrix3fv(location, false, v)",
    mat4: "gl.uniformMatrix4fv(location, false, v)",
    sampler2D: `
    if (cv !== v)
    {
        cu.value = v;

        gl.uniform1i(location, v);
    }`,
    samplerCube: `
    if (cv !== v)
    {
        cu.value = v;

        gl.uniform1i(location, v);
    }`,
    sampler2DArray: `
    if (cv !== v)
    {
        cu.value = v;

        gl.uniform1i(location, v);
    }`
}, $3db0a94081cf75de$var$GLSL_TO_ARRAY_SETTERS = {
    float: "gl.uniform1fv(location, v)",
    vec2: "gl.uniform2fv(location, v)",
    vec3: "gl.uniform3fv(location, v)",
    vec4: "gl.uniform4fv(location, v)",
    mat4: "gl.uniformMatrix4fv(location, false, v)",
    mat3: "gl.uniformMatrix3fv(location, false, v)",
    mat2: "gl.uniformMatrix2fv(location, false, v)",
    int: "gl.uniform1iv(location, v)",
    ivec2: "gl.uniform2iv(location, v)",
    ivec3: "gl.uniform3iv(location, v)",
    ivec4: "gl.uniform4iv(location, v)",
    uint: "gl.uniform1uiv(location, v)",
    uvec2: "gl.uniform2uiv(location, v)",
    uvec3: "gl.uniform3uiv(location, v)",
    uvec4: "gl.uniform4uiv(location, v)",
    bool: "gl.uniform1iv(location, v)",
    bvec2: "gl.uniform2iv(location, v)",
    bvec3: "gl.uniform3iv(location, v)",
    bvec4: "gl.uniform4iv(location, v)",
    sampler2D: "gl.uniform1iv(location, v)",
    samplerCube: "gl.uniform1iv(location, v)",
    sampler2DArray: "gl.uniform1iv(location, v)"
};
function $3db0a94081cf75de$export$20c95d1c2d5a6828(group, uniformData) {
    const funcFragments = [
        `
        var v = null;
        var cv = null;
        var cu = null;
        var t = 0;
        var gl = renderer.gl;
    `
    ];
    for(const i in group.uniforms){
        const data = uniformData[i];
        if (!data) {
            group.uniforms[i]?.group === !0 && (group.uniforms[i].ubo ? funcFragments.push(`
                        renderer.shader.syncUniformBufferGroup(uv.${i}, '${i}');
                    `) : funcFragments.push(`
                        renderer.shader.syncUniformGroup(uv.${i}, syncData);
                    `));
            continue;
        }
        const uniform = group.uniforms[i];
        let parsed = !1;
        for(let j = 0; j < (0, $2fc9b1ca00707202$export$cf9f41a7e506e2d2).length; j++)if ((0, $2fc9b1ca00707202$export$cf9f41a7e506e2d2)[j].test(data, uniform)) {
            funcFragments.push((0, $2fc9b1ca00707202$export$cf9f41a7e506e2d2)[j].code(i, uniform)), parsed = !0;
            break;
        }
        if (!parsed) {
            const template = (data.size === 1 && !data.isArray ? $3db0a94081cf75de$var$GLSL_TO_SINGLE_SETTERS_CACHED : $3db0a94081cf75de$var$GLSL_TO_ARRAY_SETTERS)[data.type].replace("location", `ud["${i}"].location`);
            funcFragments.push(`
            cu = ud["${i}"];
            cv = cu.value;
            v = uv["${i}"];
            ${template};`);
        }
    }
    return new Function("ud", "uv", "renderer", "syncData", funcFragments.join(`
`));
}





const $f4ad07ed46961724$var$unknownContext = {};
let $f4ad07ed46961724$var$context = $f4ad07ed46961724$var$unknownContext;
function $f4ad07ed46961724$export$f034b2d55f8df08b() {
    if ($f4ad07ed46961724$var$context === $f4ad07ed46961724$var$unknownContext || $f4ad07ed46961724$var$context?.isContextLost()) {
        const canvas = (0, $2808efac47e52be0$export$a5a6e0b888b2c992).ADAPTER.createCanvas();
        let gl;
        (0, $2808efac47e52be0$export$a5a6e0b888b2c992).PREFER_ENV >= (0, $0fa4b07f86297abd$export$83401e34d5e11bf4).WEBGL2 && (gl = canvas.getContext("webgl2", {})), gl || (gl = canvas.getContext("webgl", {}) || canvas.getContext("experimental-webgl", {}), gl ? gl.getExtension("WEBGL_draw_buffers") : gl = null), $f4ad07ed46961724$var$context = gl;
    }
    return $f4ad07ed46961724$var$context;
}


let $20b8f327db1a6b7b$var$maxFragmentPrecision;
function $20b8f327db1a6b7b$export$428c38e64838140() {
    if (!$20b8f327db1a6b7b$var$maxFragmentPrecision) {
        $20b8f327db1a6b7b$var$maxFragmentPrecision = (0, $0fa4b07f86297abd$export$d6d3992f3becc879).MEDIUM;
        const gl = (0, $f4ad07ed46961724$export$f034b2d55f8df08b)();
        gl && gl.getShaderPrecisionFormat && ($20b8f327db1a6b7b$var$maxFragmentPrecision = gl.getShaderPrecisionFormat(gl.FRAGMENT_SHADER, gl.HIGH_FLOAT).precision ? (0, $0fa4b07f86297abd$export$d6d3992f3becc879).HIGH : (0, $0fa4b07f86297abd$export$d6d3992f3becc879).MEDIUM);
    }
    return $20b8f327db1a6b7b$var$maxFragmentPrecision;
}



function $d440399e6b055e40$var$logPrettyShaderError(gl, shader) {
    const shaderSrc = gl.getShaderSource(shader).split(`
`).map((line, index)=>`${index}: ${line}`), shaderLog = gl.getShaderInfoLog(shader), splitShader = shaderLog.split(`
`), dedupe = {}, lineNumbers = splitShader.map((line)=>parseFloat(line.replace(/^ERROR\: 0\:([\d]+)\:.*$/, "$1"))).filter((n)=>n && !dedupe[n] ? (dedupe[n] = !0, !0) : !1), logArgs = [
        ""
    ];
    lineNumbers.forEach((number)=>{
        shaderSrc[number - 1] = `%c${shaderSrc[number - 1]}%c`, logArgs.push("background: #FF0000; color:#FFFFFF; font-size: 10px", "font-size: 10px");
    });
    const fragmentSourceToLog = shaderSrc.join(`
`);
    logArgs[0] = fragmentSourceToLog, console.error(shaderLog), console.groupCollapsed("click to view full shader code"), console.warn(...logArgs), console.groupEnd();
}
function $d440399e6b055e40$export$4b35d6c62dc992b0(gl, program, vertexShader, fragmentShader) {
    gl.getProgramParameter(program, gl.LINK_STATUS) || (gl.getShaderParameter(vertexShader, gl.COMPILE_STATUS) || $d440399e6b055e40$var$logPrettyShaderError(gl, vertexShader), gl.getShaderParameter(fragmentShader, gl.COMPILE_STATUS) || $d440399e6b055e40$var$logPrettyShaderError(gl, fragmentShader), console.error("PixiJS Error: Could not initialize shader."), gl.getProgramInfoLog(program) !== "" && console.warn("PixiJS Warning: gl.getProgramInfoLog()", gl.getProgramInfoLog(program)));
}


const $df51d09379e4c904$var$GLSL_TO_SIZE = {
    float: 1,
    vec2: 2,
    vec3: 3,
    vec4: 4,
    int: 1,
    ivec2: 2,
    ivec3: 3,
    ivec4: 4,
    uint: 1,
    uvec2: 2,
    uvec3: 3,
    uvec4: 4,
    bool: 1,
    bvec2: 2,
    bvec3: 3,
    bvec4: 4,
    mat2: 4,
    mat3: 9,
    mat4: 16,
    sampler2D: 1
};
function $df51d09379e4c904$export$50ee69a11aa2abdb(type) {
    return $df51d09379e4c904$var$GLSL_TO_SIZE[type];
}


let $c37a6ad59f55be3a$var$GL_TABLE = null;
const $c37a6ad59f55be3a$var$GL_TO_GLSL_TYPES = {
    FLOAT: "float",
    FLOAT_VEC2: "vec2",
    FLOAT_VEC3: "vec3",
    FLOAT_VEC4: "vec4",
    INT: "int",
    INT_VEC2: "ivec2",
    INT_VEC3: "ivec3",
    INT_VEC4: "ivec4",
    UNSIGNED_INT: "uint",
    UNSIGNED_INT_VEC2: "uvec2",
    UNSIGNED_INT_VEC3: "uvec3",
    UNSIGNED_INT_VEC4: "uvec4",
    BOOL: "bool",
    BOOL_VEC2: "bvec2",
    BOOL_VEC3: "bvec3",
    BOOL_VEC4: "bvec4",
    FLOAT_MAT2: "mat2",
    FLOAT_MAT3: "mat3",
    FLOAT_MAT4: "mat4",
    SAMPLER_2D: "sampler2D",
    INT_SAMPLER_2D: "sampler2D",
    UNSIGNED_INT_SAMPLER_2D: "sampler2D",
    SAMPLER_CUBE: "samplerCube",
    INT_SAMPLER_CUBE: "samplerCube",
    UNSIGNED_INT_SAMPLER_CUBE: "samplerCube",
    SAMPLER_2D_ARRAY: "sampler2DArray",
    INT_SAMPLER_2D_ARRAY: "sampler2DArray",
    UNSIGNED_INT_SAMPLER_2D_ARRAY: "sampler2DArray"
};
function $c37a6ad59f55be3a$export$4de3a94418d86ca7(gl, type) {
    if (!$c37a6ad59f55be3a$var$GL_TABLE) {
        const typeNames = Object.keys($c37a6ad59f55be3a$var$GL_TO_GLSL_TYPES);
        $c37a6ad59f55be3a$var$GL_TABLE = {};
        for(let i = 0; i < typeNames.length; ++i){
            const tn = typeNames[i];
            $c37a6ad59f55be3a$var$GL_TABLE[gl[tn]] = $c37a6ad59f55be3a$var$GL_TO_GLSL_TYPES[tn];
        }
    }
    return $c37a6ad59f55be3a$var$GL_TABLE[type];
}



function $fcd54ef04c4b135c$export$c4b85a3b3361e135(src, requestedPrecision, maxSupportedPrecision) {
    if (src.substring(0, 9) !== "precision") {
        let precision = requestedPrecision;
        return requestedPrecision === (0, $0fa4b07f86297abd$export$d6d3992f3becc879).HIGH && maxSupportedPrecision !== (0, $0fa4b07f86297abd$export$d6d3992f3becc879).HIGH && (precision = (0, $0fa4b07f86297abd$export$d6d3992f3becc879).MEDIUM), `precision ${precision} float;
${src}`;
    } else if (maxSupportedPrecision !== (0, $0fa4b07f86297abd$export$d6d3992f3becc879).HIGH && src.substring(0, 15) === "precision highp") return src.replace("precision highp", "precision mediump");
    return src;
}



let $21bdc6701a9d9b85$var$unsafeEval;
function $21bdc6701a9d9b85$export$70c0711f29adc5cf() {
    if (typeof $21bdc6701a9d9b85$var$unsafeEval == "boolean") return $21bdc6701a9d9b85$var$unsafeEval;
    try {
        $21bdc6701a9d9b85$var$unsafeEval = new Function("param1", "param2", "param3", "return param1[param2] === param3;")({
            a: "b"
        }, "a", "b") === !0;
    } catch  {
        $21bdc6701a9d9b85$var$unsafeEval = !1;
    }
    return $21bdc6701a9d9b85$var$unsafeEval;
}






let $35ca18cab1598332$var$UID = 0;
const $35ca18cab1598332$var$nameCache = {}, $35ca18cab1598332$var$_Program = class _Program2 {
    /**
   * @param vertexSrc - The source of the vertex shader.
   * @param fragmentSrc - The source of the fragment shader.
   * @param name - Name for shader
   * @param extra - Extra data for shader
   */ constructor(vertexSrc, fragmentSrc, name = "pixi-shader", extra = {}){
        this.extra = {}, this.id = $35ca18cab1598332$var$UID++, this.vertexSrc = vertexSrc || _Program2.defaultVertexSrc, this.fragmentSrc = fragmentSrc || _Program2.defaultFragmentSrc, this.vertexSrc = this.vertexSrc.trim(), this.fragmentSrc = this.fragmentSrc.trim(), this.extra = extra, this.vertexSrc.substring(0, 8) !== "#version" && (name = name.replace(/\s+/g, "-"), $35ca18cab1598332$var$nameCache[name] ? ($35ca18cab1598332$var$nameCache[name]++, name += `-${$35ca18cab1598332$var$nameCache[name]}`) : $35ca18cab1598332$var$nameCache[name] = 1, this.vertexSrc = `#define SHADER_NAME ${name}
${this.vertexSrc}`, this.fragmentSrc = `#define SHADER_NAME ${name}
${this.fragmentSrc}`, this.vertexSrc = (0, $fcd54ef04c4b135c$export$c4b85a3b3361e135)(this.vertexSrc, _Program2.defaultVertexPrecision, (0, $0fa4b07f86297abd$export$d6d3992f3becc879).HIGH), this.fragmentSrc = (0, $fcd54ef04c4b135c$export$c4b85a3b3361e135)(this.fragmentSrc, _Program2.defaultFragmentPrecision, (0, $20b8f327db1a6b7b$export$428c38e64838140)())), this.glPrograms = {}, this.syncUniforms = null;
    }
    /**
   * The default vertex shader source.
   * @readonly
   */ static get defaultVertexSrc() {
        return 0, $6f0344c5ca1f2dad$export$2e2bcd8739ae039;
    }
    /**
   * The default fragment shader source.
   * @readonly
   */ static get defaultFragmentSrc() {
        return 0, $30be5db75d830fde$export$2e2bcd8739ae039;
    }
    /**
   * A short hand function to create a program based of a vertex and fragment shader.
   *
   * This method will also check to see if there is a cached program.
   * @param vertexSrc - The source of the vertex shader.
   * @param fragmentSrc - The source of the fragment shader.
   * @param name - Name for shader
   * @returns A shiny new PixiJS shader program!
   */ static from(vertexSrc, fragmentSrc, name) {
        const key = vertexSrc + fragmentSrc;
        let program = (0, $de0ca454f7b7a947$export$d47c7e291d8b6e2c)[key];
        return program || ((0, $de0ca454f7b7a947$export$d47c7e291d8b6e2c)[key] = program = new _Program2(vertexSrc, fragmentSrc, name)), program;
    }
};
$35ca18cab1598332$var$_Program.defaultVertexPrecision = (0, $0fa4b07f86297abd$export$d6d3992f3becc879).HIGH, /**
* Default specify float precision in fragment shader.
* iOS is best set at highp due to https://github.com/pixijs/pixijs/issues/3742
* @static
* @type {PIXI.PRECISION}
* @default PIXI.PRECISION.MEDIUM
*/ $35ca18cab1598332$var$_Program.defaultFragmentPrecision = (0, $389fd98f2c1f982f$export$d0a8044dce8ff2fc).apple.device ? (0, $0fa4b07f86297abd$export$d6d3992f3becc879).HIGH : (0, $0fa4b07f86297abd$export$d6d3992f3becc879).MEDIUM;
let $35ca18cab1598332$export$b6c59b989905b650 = $35ca18cab1598332$var$_Program;






let $8380fc86b6e89a36$var$UID = 0;
class $8380fc86b6e89a36$export$6601a7a2dcf79bf5 {
    /**
   * @param {object | Buffer} [uniforms] - Custom uniforms to use to augment the built-in ones. Or a pixi buffer.
   * @param isStatic - Uniforms wont be changed after creation.
   * @param isUbo - If true, will treat this uniform group as a uniform buffer object.
   */ constructor(uniforms, isStatic, isUbo){
        this.group = !0, this.syncUniforms = {}, this.dirtyId = 0, this.id = $8380fc86b6e89a36$var$UID++, this.static = !!isStatic, this.ubo = !!isUbo, uniforms instanceof (0, $17b501b101b42758$export$a143d493d941bafc) ? (this.buffer = uniforms, this.buffer.type = (0, $0fa4b07f86297abd$export$b595a7e482202b96).UNIFORM_BUFFER, this.autoManage = !1, this.ubo = !0) : (this.uniforms = uniforms, this.ubo && (this.buffer = new (0, $17b501b101b42758$export$a143d493d941bafc)(new Float32Array(1)), this.buffer.type = (0, $0fa4b07f86297abd$export$b595a7e482202b96).UNIFORM_BUFFER, this.autoManage = !0));
    }
    update() {
        this.dirtyId++, !this.autoManage && this.buffer && this.buffer.update();
    }
    add(name, uniforms, _static) {
        if (!this.ubo) this.uniforms[name] = new $8380fc86b6e89a36$export$6601a7a2dcf79bf5(uniforms, _static);
        else throw new Error("[UniformGroup] uniform groups in ubo mode cannot be modified, or have uniform groups nested in them");
    }
    static from(uniforms, _static, _ubo) {
        return new $8380fc86b6e89a36$export$6601a7a2dcf79bf5(uniforms, _static, _ubo);
    }
    /**
   * A short hand function for creating a static UBO UniformGroup.
   * @param uniforms - the ubo item
   * @param _static - should this be updated each time it is used? defaults to true here!
   */ static uboFrom(uniforms, _static) {
        return new $8380fc86b6e89a36$export$6601a7a2dcf79bf5(uniforms, _static ?? !0, !0);
    }
}


class $8f87c04218e7eb6d$export$462bb059fed9d9e5 {
    /**
   * @param program - The program the shader will use.
   * @param uniforms - Custom uniforms to use to augment the built-in ones.
   */ constructor(program, uniforms){
        this.uniformBindCount = 0, this.program = program, uniforms ? uniforms instanceof (0, $8380fc86b6e89a36$export$6601a7a2dcf79bf5) ? this.uniformGroup = uniforms : this.uniformGroup = new (0, $8380fc86b6e89a36$export$6601a7a2dcf79bf5)(uniforms) : this.uniformGroup = new (0, $8380fc86b6e89a36$export$6601a7a2dcf79bf5)({}), this.disposeRunner = new (0, $feae24fa15514cdf$export$571ad3bcba5a0c45)("disposeShader");
    }
    // TODO move to shader system..
    checkUniformExists(name, group) {
        if (group.uniforms[name]) return !0;
        for(const i in group.uniforms){
            const uniform = group.uniforms[i];
            if (uniform.group === !0 && this.checkUniformExists(name, uniform)) return !0;
        }
        return !1;
    }
    destroy() {
        this.uniformGroup = null, this.disposeRunner.emit(this), this.disposeRunner.destroy();
    }
    /**
   * Shader uniform values, shortcut for `uniformGroup.uniforms`.
   * @readonly
   */ get uniforms() {
        return this.uniformGroup.uniforms;
    }
    /**
   * A short hand function to create a shader based of a vertex and fragment shader.
   * @param vertexSrc - The source of the vertex shader.
   * @param fragmentSrc - The source of the fragment shader.
   * @param uniforms - Custom uniforms to use to augment the built-in ones.
   * @returns A shiny new PixiJS shader!
   */ static from(vertexSrc, fragmentSrc, uniforms) {
        const program = (0, $35ca18cab1598332$export$b6c59b989905b650).from(vertexSrc, fragmentSrc);
        return new $8f87c04218e7eb6d$export$462bb059fed9d9e5(program, uniforms);
    }
}



class $d8ca48fc5df675c2$export$9a4c4943b6fad72e {
    /**
   * @param vertexSrc - Vertex shader
   * @param fragTemplate - Fragment shader template
   */ constructor(vertexSrc, fragTemplate){
        if (this.vertexSrc = vertexSrc, this.fragTemplate = fragTemplate, this.programCache = {}, this.defaultGroupCache = {}, !fragTemplate.includes("%count%")) throw new Error('Fragment template must contain "%count%".');
        if (!fragTemplate.includes("%forloop%")) throw new Error('Fragment template must contain "%forloop%".');
    }
    generateShader(maxTextures) {
        if (!this.programCache[maxTextures]) {
            const sampleValues = new Int32Array(maxTextures);
            for(let i = 0; i < maxTextures; i++)sampleValues[i] = i;
            this.defaultGroupCache[maxTextures] = (0, $8380fc86b6e89a36$export$6601a7a2dcf79bf5).from({
                uSamplers: sampleValues
            }, !0);
            let fragmentSrc = this.fragTemplate;
            fragmentSrc = fragmentSrc.replace(/%count%/gi, `${maxTextures}`), fragmentSrc = fragmentSrc.replace(/%forloop%/gi, this.generateSampleSrc(maxTextures)), this.programCache[maxTextures] = new (0, $35ca18cab1598332$export$b6c59b989905b650)(this.vertexSrc, fragmentSrc);
        }
        const uniforms = {
            tint: new Float32Array([
                1,
                1,
                1,
                1
            ]),
            translationMatrix: new (0, $d7da222aa639cde0$export$5b12bf1653c0dd85)(),
            default: this.defaultGroupCache[maxTextures]
        };
        return new (0, $8f87c04218e7eb6d$export$462bb059fed9d9e5)(this.programCache[maxTextures], uniforms);
    }
    generateSampleSrc(maxTextures) {
        let src = "";
        src += `
`, src += `
`;
        for(let i = 0; i < maxTextures; i++)i > 0 && (src += `
else `), i < maxTextures - 1 && (src += `if(vTextureId < ${i}.5)`), src += `
{`, src += `
	color = texture2D(uSamplers[${i}], vTextureCoord);`, src += `
}`;
        return src += `
`, src += `
`, src;
    }
}


class $bafdb72a689df8b2$export$aa760e0febf1a758 {
    constructor(){
        this.elements = [], this.ids = [], this.count = 0;
    }
    clear() {
        for(let i = 0; i < this.count; i++)this.elements[i] = null;
        this.count = 0;
    }
}



function $085171d7c2070963$export$b839fdc6a85f84de() {
    return !(0, $389fd98f2c1f982f$export$d0a8044dce8ff2fc).apple.device;
}



function $9857bae3ecce2d2e$export$d7a652ff592da4b4(max) {
    let allowMax = !0;
    const navigator = (0, $2808efac47e52be0$export$a5a6e0b888b2c992).ADAPTER.getNavigator();
    if ((0, $389fd98f2c1f982f$export$d0a8044dce8ff2fc).tablet || (0, $389fd98f2c1f982f$export$d0a8044dce8ff2fc).phone) {
        if ((0, $389fd98f2c1f982f$export$d0a8044dce8ff2fc).apple.device) {
            const match = navigator.userAgent.match(/OS (\d+)_(\d+)?/);
            match && parseInt(match[1], 10) < 11 && (allowMax = !1);
        }
        if ((0, $389fd98f2c1f982f$export$d0a8044dce8ff2fc).android.device) {
            const match = navigator.userAgent.match(/Android\s([0-9.]*)/);
            match && parseInt(match[1], 10) < 7 && (allowMax = !1);
        }
    }
    return allowMax ? max : 4;
}


class $0a2e1c9be4f09a9b$export$ca67b0b0fa758253 {
    /**
   * @param renderer - The renderer this manager works for.
   */ constructor(renderer){
        this.renderer = renderer;
    }
    /** Stub method that should be used to empty the current batch by rendering objects now. */ flush() {}
    /** Generic destruction method that frees all resources. This should be called by subclasses. */ destroy() {
        this.renderer = null;
    }
    /**
   * Stub method that initializes any state required before
   * rendering starts. It is different from the `prerender`
   * signal, which occurs every frame, in that it is called
   * whenever an object requests _this_ renderer specifically.
   */ start() {}
    /** Stops the renderer. It should free up any state and become dormant. */ stop() {
        this.flush();
    }
    /**
   * Keeps the object to render. It doesn't have to be
   * rendered immediately.
   * @param {PIXI.DisplayObject} _object - The object to render.
   */ render(_object) {}
}


var $600aa5781e472c30$export$2e2bcd8739ae039 = `varying vec2 vTextureCoord;
varying vec4 vColor;
varying float vTextureId;
uniform sampler2D uSamplers[%count%];

void main(void){
    vec4 color;
    %forloop%
    gl_FragColor = color * vColor;
}
`;


var $a8c0dee54f469d5d$export$2e2bcd8739ae039 = `precision highp float;
attribute vec2 aVertexPosition;
attribute vec2 aTextureCoord;
attribute vec4 aColor;
attribute float aTextureId;

uniform mat3 projectionMatrix;
uniform mat3 translationMatrix;
uniform vec4 tint;

varying vec2 vTextureCoord;
varying vec4 vColor;
varying float vTextureId;

void main(void){
    gl_Position = vec4((projectionMatrix * translationMatrix * vec3(aVertexPosition, 1.0)).xy, 0.0, 1.0);

    vTextureCoord = aTextureCoord;
    vTextureId = aTextureId;
    vColor = aColor * tint;
}
`;


const $dbdd65a7ea7fcebf$var$_BatchRenderer = class _BatchRenderer2 extends (0, $0a2e1c9be4f09a9b$export$ca67b0b0fa758253) {
    /**
   * This will hook onto the renderer's `contextChange`
   * and `prerender` signals.
   * @param {PIXI.Renderer} renderer - The renderer this works for.
   */ constructor(renderer){
        super(renderer), this.setShaderGenerator(), this.geometryClass = (0, $8ffbe4cd828c4ebe$export$449e8d355fd68e43), this.vertexSize = 6, this.state = (0, $2b269c8c39349f63$export$7254cc27399e90bd).for2d(), this.size = _BatchRenderer2.defaultBatchSize * 4, this._vertexCount = 0, this._indexCount = 0, this._bufferedElements = [], this._bufferedTextures = [], this._bufferSize = 0, this._shader = null, this._packedGeometries = [], this._packedGeometryPoolSize = 2, this._flushId = 0, this._aBuffers = {}, this._iBuffers = {}, this.maxTextures = 1, this.renderer.on("prerender", this.onPrerender, this), renderer.runners.contextChange.add(this), this._dcIndex = 0, this._aIndex = 0, this._iIndex = 0, this._attributeBuffer = null, this._indexBuffer = null, this._tempBoundTextures = [];
    }
    /**
   * The maximum textures that this device supports.
   * @static
   * @default 32
   */ static get defaultMaxTextures() {
        return this._defaultMaxTextures = this._defaultMaxTextures ?? (0, $9857bae3ecce2d2e$export$d7a652ff592da4b4)(32), this._defaultMaxTextures;
    }
    static set defaultMaxTextures(value) {
        this._defaultMaxTextures = value;
    }
    /**
   * Can we upload the same buffer in a single frame?
   * @static
   */ static get canUploadSameBuffer() {
        return this._canUploadSameBuffer = this._canUploadSameBuffer ?? (0, $085171d7c2070963$export$b839fdc6a85f84de)(), this._canUploadSameBuffer;
    }
    static set canUploadSameBuffer(value) {
        this._canUploadSameBuffer = value;
    }
    /**
   * @see PIXI.BatchRenderer#maxTextures
   * @deprecated since 7.1.0
   * @readonly
   */ get MAX_TEXTURES() {
        return (0, $397b7871568e248b$export$afd31d834b512e89)("7.1.0", "BatchRenderer#MAX_TEXTURES renamed to BatchRenderer#maxTextures"), this.maxTextures;
    }
    /**
   * The default vertex shader source
   * @readonly
   */ static get defaultVertexSrc() {
        return 0, $a8c0dee54f469d5d$export$2e2bcd8739ae039;
    }
    /**
   * The default fragment shader source
   * @readonly
   */ static get defaultFragmentTemplate() {
        return 0, $600aa5781e472c30$export$2e2bcd8739ae039;
    }
    /**
   * Set the shader generator.
   * @param {object} [options]
   * @param {string} [options.vertex=PIXI.BatchRenderer.defaultVertexSrc] - Vertex shader source
   * @param {string} [options.fragment=PIXI.BatchRenderer.defaultFragmentTemplate] - Fragment shader template
   */ setShaderGenerator({ vertex: vertex = _BatchRenderer2.defaultVertexSrc, fragment: fragment = _BatchRenderer2.defaultFragmentTemplate } = {}) {
        this.shaderGenerator = new (0, $d8ca48fc5df675c2$export$9a4c4943b6fad72e)(vertex, fragment);
    }
    /**
   * Handles the `contextChange` signal.
   *
   * It calculates `this.maxTextures` and allocating the packed-geometry object pool.
   */ contextChange() {
        const gl = this.renderer.gl;
        (0, $2808efac47e52be0$export$a5a6e0b888b2c992).PREFER_ENV === (0, $0fa4b07f86297abd$export$83401e34d5e11bf4).WEBGL_LEGACY ? this.maxTextures = 1 : (this.maxTextures = Math.min(gl.getParameter(gl.MAX_TEXTURE_IMAGE_UNITS), _BatchRenderer2.defaultMaxTextures), this.maxTextures = (0, $5fca4dc2bd25bd24$export$fb6ad4e758d74cc0)(this.maxTextures, gl)), this._shader = this.shaderGenerator.generateShader(this.maxTextures);
        for(let i = 0; i < this._packedGeometryPoolSize; i++)this._packedGeometries[i] = new this.geometryClass();
        this.initFlushBuffers();
    }
    /** Makes sure that static and dynamic flush pooled objects have correct dimensions. */ initFlushBuffers() {
        const { _drawCallPool: _drawCallPool, _textureArrayPool: _textureArrayPool } = _BatchRenderer2, MAX_SPRITES = this.size / 4, MAX_TA = Math.floor(MAX_SPRITES / this.maxTextures) + 1;
        for(; _drawCallPool.length < MAX_SPRITES;)_drawCallPool.push(new (0, $8e09e9037c380ee9$export$664fd198634fda29)());
        for(; _textureArrayPool.length < MAX_TA;)_textureArrayPool.push(new (0, $bafdb72a689df8b2$export$aa760e0febf1a758)());
        for(let i = 0; i < this.maxTextures; i++)this._tempBoundTextures[i] = null;
    }
    /** Handles the `prerender` signal. It ensures that flushes start from the first geometry object again. */ onPrerender() {
        this._flushId = 0;
    }
    /**
   * Buffers the "batchable" object. It need not be rendered immediately.
   * @param {PIXI.DisplayObject} element - the element to render when
   *    using this renderer
   */ render(element) {
        element._texture.valid && (this._vertexCount + element.vertexData.length / 2 > this.size && this.flush(), this._vertexCount += element.vertexData.length / 2, this._indexCount += element.indices.length, this._bufferedTextures[this._bufferSize] = element._texture.baseTexture, this._bufferedElements[this._bufferSize++] = element);
    }
    buildTexturesAndDrawCalls() {
        const { _bufferedTextures: textures, maxTextures: maxTextures } = this, textureArrays = _BatchRenderer2._textureArrayPool, batch = this.renderer.batch, boundTextures = this._tempBoundTextures, touch = this.renderer.textureGC.count;
        let TICK = ++(0, $30c85657f0c625d5$export$d6306e508f184154)._globalBatch, countTexArrays = 0, texArray = textureArrays[0], start = 0;
        batch.copyBoundTextures(boundTextures, maxTextures);
        for(let i = 0; i < this._bufferSize; ++i){
            const tex = textures[i];
            textures[i] = null, tex._batchEnabled !== TICK && (texArray.count >= maxTextures && (batch.boundArray(texArray, boundTextures, TICK, maxTextures), this.buildDrawCalls(texArray, start, i), start = i, texArray = textureArrays[++countTexArrays], ++TICK), tex._batchEnabled = TICK, tex.touched = touch, texArray.elements[texArray.count++] = tex);
        }
        texArray.count > 0 && (batch.boundArray(texArray, boundTextures, TICK, maxTextures), this.buildDrawCalls(texArray, start, this._bufferSize), ++countTexArrays, ++TICK);
        for(let i = 0; i < boundTextures.length; i++)boundTextures[i] = null;
        (0, $30c85657f0c625d5$export$d6306e508f184154)._globalBatch = TICK;
    }
    /**
   * Populating drawcalls for rendering
   * @param texArray
   * @param start
   * @param finish
   */ buildDrawCalls(texArray, start, finish) {
        const { _bufferedElements: elements, _attributeBuffer: _attributeBuffer, _indexBuffer: _indexBuffer, vertexSize: vertexSize } = this, drawCalls = _BatchRenderer2._drawCallPool;
        let dcIndex = this._dcIndex, aIndex = this._aIndex, iIndex = this._iIndex, drawCall = drawCalls[dcIndex];
        drawCall.start = this._iIndex, drawCall.texArray = texArray;
        for(let i = start; i < finish; ++i){
            const sprite = elements[i], tex = sprite._texture.baseTexture, spriteBlendMode = (0, $e6ada961504cf12a$export$799d0d31e2f4c737)[tex.alphaMode ? 1 : 0][sprite.blendMode];
            elements[i] = null, start < i && drawCall.blend !== spriteBlendMode && (drawCall.size = iIndex - drawCall.start, start = i, drawCall = drawCalls[++dcIndex], drawCall.texArray = texArray, drawCall.start = iIndex), this.packInterleavedGeometry(sprite, _attributeBuffer, _indexBuffer, aIndex, iIndex), aIndex += sprite.vertexData.length / 2 * vertexSize, iIndex += sprite.indices.length, drawCall.blend = spriteBlendMode;
        }
        start < finish && (drawCall.size = iIndex - drawCall.start, ++dcIndex), this._dcIndex = dcIndex, this._aIndex = aIndex, this._iIndex = iIndex;
    }
    /**
   * Bind textures for current rendering
   * @param texArray
   */ bindAndClearTexArray(texArray) {
        const textureSystem = this.renderer.texture;
        for(let j = 0; j < texArray.count; j++)textureSystem.bind(texArray.elements[j], texArray.ids[j]), texArray.elements[j] = null;
        texArray.count = 0;
    }
    updateGeometry() {
        const { _packedGeometries: packedGeometries, _attributeBuffer: attributeBuffer, _indexBuffer: indexBuffer } = this;
        _BatchRenderer2.canUploadSameBuffer ? (packedGeometries[this._flushId]._buffer.update(attributeBuffer.rawBinaryData), packedGeometries[this._flushId]._indexBuffer.update(indexBuffer), this.renderer.geometry.updateBuffers()) : (this._packedGeometryPoolSize <= this._flushId && (this._packedGeometryPoolSize++, packedGeometries[this._flushId] = new this.geometryClass()), packedGeometries[this._flushId]._buffer.update(attributeBuffer.rawBinaryData), packedGeometries[this._flushId]._indexBuffer.update(indexBuffer), this.renderer.geometry.bind(packedGeometries[this._flushId]), this.renderer.geometry.updateBuffers(), this._flushId++);
    }
    drawBatches() {
        const dcCount = this._dcIndex, { gl: gl, state: stateSystem } = this.renderer, drawCalls = _BatchRenderer2._drawCallPool;
        let curTexArray = null;
        for(let i = 0; i < dcCount; i++){
            const { texArray: texArray, type: type, size: size, start: start, blend: blend } = drawCalls[i];
            curTexArray !== texArray && (curTexArray = texArray, this.bindAndClearTexArray(texArray)), this.state.blendMode = blend, stateSystem.set(this.state), gl.drawElements(type, size, gl.UNSIGNED_SHORT, start * 2);
        }
    }
    /** Renders the content _now_ and empties the current batch. */ flush() {
        this._vertexCount !== 0 && (this._attributeBuffer = this.getAttributeBuffer(this._vertexCount), this._indexBuffer = this.getIndexBuffer(this._indexCount), this._aIndex = 0, this._iIndex = 0, this._dcIndex = 0, this.buildTexturesAndDrawCalls(), this.updateGeometry(), this.drawBatches(), this._bufferSize = 0, this._vertexCount = 0, this._indexCount = 0);
    }
    /** Starts a new sprite batch. */ start() {
        this.renderer.state.set(this.state), this.renderer.texture.ensureSamplerType(this.maxTextures), this.renderer.shader.bind(this._shader), _BatchRenderer2.canUploadSameBuffer && this.renderer.geometry.bind(this._packedGeometries[this._flushId]);
    }
    /** Stops and flushes the current batch. */ stop() {
        this.flush();
    }
    /** Destroys this `BatchRenderer`. It cannot be used again. */ destroy() {
        for(let i = 0; i < this._packedGeometryPoolSize; i++)this._packedGeometries[i] && this._packedGeometries[i].destroy();
        this.renderer.off("prerender", this.onPrerender, this), this._aBuffers = null, this._iBuffers = null, this._packedGeometries = null, this._attributeBuffer = null, this._indexBuffer = null, this._shader && (this._shader.destroy(), this._shader = null), super.destroy();
    }
    /**
   * Fetches an attribute buffer from `this._aBuffers` that can hold atleast `size` floats.
   * @param size - minimum capacity required
   * @returns - buffer than can hold atleast `size` floats
   */ getAttributeBuffer(size) {
        const roundedP2 = (0, $af2147baf6c30f74$export$f0d90cf68bd426eb)(Math.ceil(size / 8)), roundedSizeIndex = (0, $af2147baf6c30f74$export$b9fae0bba9d9094d)(roundedP2), roundedSize = roundedP2 * 8;
        this._aBuffers.length <= roundedSizeIndex && (this._iBuffers.length = roundedSizeIndex + 1);
        let buffer = this._aBuffers[roundedSize];
        return buffer || (this._aBuffers[roundedSize] = buffer = new (0, $39a5b11da7fcb4a0$export$4fdbf0662aa3047a)(roundedSize * this.vertexSize * 4)), buffer;
    }
    /**
   * Fetches an index buffer from `this._iBuffers` that can
   * have at least `size` capacity.
   * @param size - minimum required capacity
   * @returns - buffer that can fit `size` indices.
   */ getIndexBuffer(size) {
        const roundedP2 = (0, $af2147baf6c30f74$export$f0d90cf68bd426eb)(Math.ceil(size / 12)), roundedSizeIndex = (0, $af2147baf6c30f74$export$b9fae0bba9d9094d)(roundedP2), roundedSize = roundedP2 * 12;
        this._iBuffers.length <= roundedSizeIndex && (this._iBuffers.length = roundedSizeIndex + 1);
        let buffer = this._iBuffers[roundedSizeIndex];
        return buffer || (this._iBuffers[roundedSizeIndex] = buffer = new Uint16Array(roundedSize)), buffer;
    }
    /**
   * Takes the four batching parameters of `element`, interleaves
   * and pushes them into the batching attribute/index buffers given.
   *
   * It uses these properties: `vertexData` `uvs`, `textureId` and
   * `indicies`. It also uses the "tint" of the base-texture, if
   * present.
   * @param {PIXI.DisplayObject} element - element being rendered
   * @param attributeBuffer - attribute buffer.
   * @param indexBuffer - index buffer
   * @param aIndex - number of floats already in the attribute buffer
   * @param iIndex - number of indices already in `indexBuffer`
   */ packInterleavedGeometry(element, attributeBuffer, indexBuffer, aIndex, iIndex) {
        const { uint32View: uint32View, float32View: float32View } = attributeBuffer, packedVertices = aIndex / this.vertexSize, uvs = element.uvs, indicies = element.indices, vertexData = element.vertexData, textureId = element._texture.baseTexture._batchLocation, alpha = Math.min(element.worldAlpha, 1), argb = (0, $15154c33c9e19c5f$export$892596cec99bc70e).shared.setValue(element._tintRGB).toPremultiplied(alpha, element._texture.baseTexture.alphaMode > 0);
        for(let i = 0; i < vertexData.length; i += 2)float32View[aIndex++] = vertexData[i], float32View[aIndex++] = vertexData[i + 1], float32View[aIndex++] = uvs[i], float32View[aIndex++] = uvs[i + 1], uint32View[aIndex++] = argb, float32View[aIndex++] = textureId;
        for(let i = 0; i < indicies.length; i++)indexBuffer[iIndex++] = packedVertices + indicies[i];
    }
};
$dbdd65a7ea7fcebf$var$_BatchRenderer.defaultBatchSize = 4096, /** @ignore */ $dbdd65a7ea7fcebf$var$_BatchRenderer.extension = {
    name: "batch",
    type: (0, $c90155f6d7d8d8f6$export$4f037c6ec2da4eeb).RendererPlugin
}, /**
* Pool of `BatchDrawCall` objects that `flush` used
* to create "batches" of the objects being rendered.
*
* These are never re-allocated again.
* Shared between all batch renderers because it can be only one "flush" working at the moment.
* @member {PIXI.BatchDrawCall[]}
*/ $dbdd65a7ea7fcebf$var$_BatchRenderer._drawCallPool = [], /**
* Pool of `BatchDrawCall` objects that `flush` used
* to create "batches" of the objects being rendered.
*
* These are never re-allocated again.
* Shared between all batch renderers because it can be only one "flush" working at the moment.
* @member {PIXI.BatchTextureArray[]}
*/ $dbdd65a7ea7fcebf$var$_BatchRenderer._textureArrayPool = [];
let $dbdd65a7ea7fcebf$export$c6a34b759a134e1d = $dbdd65a7ea7fcebf$var$_BatchRenderer;
(0, $c90155f6d7d8d8f6$export$cc3e2d3244e01b7f).add($dbdd65a7ea7fcebf$export$c6a34b759a134e1d);






var $e476f1267c9e4c49$export$2e2bcd8739ae039 = `varying vec2 vTextureCoord;

uniform sampler2D uSampler;

void main(void){
   gl_FragColor = texture2D(uSampler, vTextureCoord);
}
`;


var $418fb95c8ab8b118$export$2e2bcd8739ae039 = `attribute vec2 aVertexPosition;

uniform mat3 projectionMatrix;

varying vec2 vTextureCoord;

uniform vec4 inputSize;
uniform vec4 outputFrame;

vec4 filterVertexPosition( void )
{
    vec2 position = aVertexPosition * max(outputFrame.zw, vec2(0.)) + outputFrame.xy;

    return vec4((projectionMatrix * vec3(position, 1.0)).xy, 0.0, 1.0);
}

vec2 filterTextureCoord( void )
{
    return aVertexPosition * (outputFrame.zw * inputSize.zw);
}

void main(void)
{
    gl_Position = filterVertexPosition();
    vTextureCoord = filterTextureCoord();
}
`;


const $46266bc3fe6194b8$var$_Filter = class _Filter2 extends (0, $8f87c04218e7eb6d$export$462bb059fed9d9e5) {
    /**
   * @param vertexSrc - The source of the vertex shader.
   * @param fragmentSrc - The source of the fragment shader.
   * @param uniforms - Custom uniforms to use to augment the built-in ones.
   */ constructor(vertexSrc, fragmentSrc, uniforms){
        const program = (0, $35ca18cab1598332$export$b6c59b989905b650).from(vertexSrc || _Filter2.defaultVertexSrc, fragmentSrc || _Filter2.defaultFragmentSrc);
        super(program, uniforms), this.padding = 0, this.resolution = _Filter2.defaultResolution, this.multisample = _Filter2.defaultMultisample, this.enabled = !0, this.autoFit = !0, this.state = new (0, $2b269c8c39349f63$export$7254cc27399e90bd)();
    }
    /**
   * Applies the filter
   * @param {PIXI.FilterSystem} filterManager - The renderer to retrieve the filter from
   * @param {PIXI.RenderTexture} input - The input render target.
   * @param {PIXI.RenderTexture} output - The target to output to.
   * @param {PIXI.CLEAR_MODES} [clearMode] - Should the output be cleared before rendering to it.
   * @param {object} [_currentState] - It's current state of filter.
   *        There are some useful properties in the currentState :
   *        target, filters, sourceFrame, destinationFrame, renderTarget, resolution
   */ apply(filterManager, input, output, clearMode, _currentState) {
        filterManager.applyFilter(this, input, output, clearMode);
    }
    /**
   * Sets the blend mode of the filter.
   * @default PIXI.BLEND_MODES.NORMAL
   */ get blendMode() {
        return this.state.blendMode;
    }
    set blendMode(value) {
        this.state.blendMode = value;
    }
    /**
   * The resolution of the filter. Setting this to be lower will lower the quality but
   * increase the performance of the filter.
   * If set to `null` or `0`, the resolution of the current render target is used.
   * @default PIXI.Filter.defaultResolution
   */ get resolution() {
        return this._resolution;
    }
    set resolution(value) {
        this._resolution = value;
    }
    /**
   * The default vertex shader source
   * @readonly
   */ static get defaultVertexSrc() {
        return 0, $418fb95c8ab8b118$export$2e2bcd8739ae039;
    }
    /**
   * The default fragment shader source
   * @readonly
   */ static get defaultFragmentSrc() {
        return 0, $e476f1267c9e4c49$export$2e2bcd8739ae039;
    }
};
$46266bc3fe6194b8$var$_Filter.defaultResolution = 1, /**
* Default filter samples for any filter.
* @static
* @type {PIXI.MSAA_QUALITY|null}
* @default PIXI.MSAA_QUALITY.NONE
*/ $46266bc3fe6194b8$var$_Filter.defaultMultisample = (0, $0fa4b07f86297abd$export$1eadd657d5acc2f2).NONE;
let $46266bc3fe6194b8$export$ec91da630f36d5ea = $46266bc3fe6194b8$var$_Filter;





class $e4a4a9a559bae6fb$export$c69cd65c8827ac23 {
    constructor(){
        this.clearBeforeRender = !0, this._backgroundColor = new (0, $15154c33c9e19c5f$export$892596cec99bc70e)(0), this.alpha = 1;
    }
    /**
   * initiates the background system
   * @param {PIXI.IRendererOptions} options - the options for the background colors
   */ init(options) {
        this.clearBeforeRender = options.clearBeforeRender;
        const { backgroundColor: backgroundColor, background: background, backgroundAlpha: backgroundAlpha } = options, color = background ?? backgroundColor;
        color !== void 0 && (this.color = color), this.alpha = backgroundAlpha;
    }
    /**
   * The background color to fill if not transparent.
   * @member {PIXI.ColorSource}
   */ get color() {
        return this._backgroundColor.value;
    }
    set color(value) {
        this._backgroundColor.setValue(value);
    }
    /**
   * The background color alpha. Setting this to 0 will make the canvas transparent.
   * @member {number}
   */ get alpha() {
        return this._backgroundColor.alpha;
    }
    set alpha(value) {
        this._backgroundColor.setAlpha(value);
    }
    /** The background color object. */ get backgroundColor() {
        return this._backgroundColor;
    }
    destroy() {}
}
$e4a4a9a559bae6fb$export$c69cd65c8827ac23.defaultOptions = {
    /**
   * {@link PIXI.IRendererOptions.backgroundAlpha}
   * @default 1
   * @memberof PIXI.settings.RENDER_OPTIONS
   */ backgroundAlpha: 1,
    /**
   * {@link PIXI.IRendererOptions.backgroundColor}
   * @default 0x000000
   * @memberof PIXI.settings.RENDER_OPTIONS
   */ backgroundColor: 0,
    /**
   * {@link PIXI.IRendererOptions.clearBeforeRender}
   * @default true
   * @memberof PIXI.settings.RENDER_OPTIONS
   */ clearBeforeRender: !0
}, /** @ignore */ $e4a4a9a559bae6fb$export$c69cd65c8827ac23.extension = {
    type: [
        (0, $c90155f6d7d8d8f6$export$4f037c6ec2da4eeb).RendererSystem,
        (0, $c90155f6d7d8d8f6$export$4f037c6ec2da4eeb).CanvasRendererSystem
    ],
    name: "background"
};
(0, $c90155f6d7d8d8f6$export$cc3e2d3244e01b7f).add($e4a4a9a559bae6fb$export$c69cd65c8827ac23);




class $115d0c6d266b6e37$export$beb481275b7bcccc {
    /**
   * @param renderer - The renderer this System works for.
   */ constructor(renderer){
        this.renderer = renderer, this.emptyRenderer = new (0, $0a2e1c9be4f09a9b$export$ca67b0b0fa758253)(renderer), this.currentRenderer = this.emptyRenderer;
    }
    /**
   * Changes the current renderer to the one given in parameter
   * @param objectRenderer - The object renderer to use.
   */ setObjectRenderer(objectRenderer) {
        this.currentRenderer !== objectRenderer && (this.currentRenderer.stop(), this.currentRenderer = objectRenderer, this.currentRenderer.start());
    }
    /**
   * This should be called if you wish to do some custom rendering
   * It will basically render anything that may be batched up such as sprites
   */ flush() {
        this.setObjectRenderer(this.emptyRenderer);
    }
    /** Reset the system to an empty renderer */ reset() {
        this.setObjectRenderer(this.emptyRenderer);
    }
    /**
   * Handy function for batch renderers: copies bound textures in first maxTextures locations to array
   * sets actual _batchLocation for them
   * @param arr - arr copy destination
   * @param maxTextures - number of copied elements
   */ copyBoundTextures(arr, maxTextures) {
        const { boundTextures: boundTextures } = this.renderer.texture;
        for(let i = maxTextures - 1; i >= 0; --i)arr[i] = boundTextures[i] || null, arr[i] && (arr[i]._batchLocation = i);
    }
    /**
   * Assigns batch locations to textures in array based on boundTextures state.
   * All textures in texArray should have `_batchEnabled = _batchId`,
   * and their count should be less than `maxTextures`.
   * @param texArray - textures to bound
   * @param boundTextures - current state of bound textures
   * @param batchId - marker for _batchEnabled param of textures in texArray
   * @param maxTextures - number of texture locations to manipulate
   */ boundArray(texArray, boundTextures, batchId, maxTextures) {
        const { elements: elements, ids: ids, count: count } = texArray;
        let j = 0;
        for(let i = 0; i < count; i++){
            const tex = elements[i], loc = tex._batchLocation;
            if (loc >= 0 && loc < maxTextures && boundTextures[loc] === tex) {
                ids[i] = loc;
                continue;
            }
            for(; j < maxTextures;){
                const bound = boundTextures[j];
                if (bound && bound._batchEnabled === batchId && bound._batchLocation === j) {
                    j++;
                    continue;
                }
                ids[i] = j, tex._batchLocation = j, boundTextures[j] = tex;
                break;
            }
        }
    }
    /**
   * @ignore
   */ destroy() {
        this.renderer = null;
    }
}
$115d0c6d266b6e37$export$beb481275b7bcccc.extension = {
    type: (0, $c90155f6d7d8d8f6$export$4f037c6ec2da4eeb).RendererSystem,
    name: "batch"
};
(0, $c90155f6d7d8d8f6$export$cc3e2d3244e01b7f).add($115d0c6d266b6e37$export$beb481275b7bcccc);





let $d779c9ccd6fe69e4$var$CONTEXT_UID_COUNTER = 0;
class $d779c9ccd6fe69e4$export$fedaac80f6f9518c {
    /** @param renderer - The renderer this System works for. */ constructor(renderer){
        this.renderer = renderer, this.webGLVersion = 1, this.extensions = {}, this.supports = {
            uint32Indices: !1
        }, this.handleContextLost = this.handleContextLost.bind(this), this.handleContextRestored = this.handleContextRestored.bind(this);
    }
    /**
   * `true` if the context is lost
   * @readonly
   */ get isLost() {
        return !this.gl || this.gl.isContextLost();
    }
    /**
   * Handles the context change event.
   * @param {WebGLRenderingContext} gl - New WebGL context.
   */ contextChange(gl) {
        this.gl = gl, this.renderer.gl = gl, this.renderer.CONTEXT_UID = $d779c9ccd6fe69e4$var$CONTEXT_UID_COUNTER++;
    }
    init(options) {
        if (options.context) this.initFromContext(options.context);
        else {
            const alpha = this.renderer.background.alpha < 1, premultipliedAlpha = options.premultipliedAlpha;
            this.preserveDrawingBuffer = options.preserveDrawingBuffer, this.useContextAlpha = options.useContextAlpha, this.powerPreference = options.powerPreference, this.initFromOptions({
                alpha: alpha,
                premultipliedAlpha: premultipliedAlpha,
                antialias: options.antialias,
                stencil: !0,
                preserveDrawingBuffer: options.preserveDrawingBuffer,
                powerPreference: options.powerPreference
            });
        }
    }
    /**
   * Initializes the context.
   * @protected
   * @param {WebGLRenderingContext} gl - WebGL context
   */ initFromContext(gl) {
        this.gl = gl, this.validateContext(gl), this.renderer.gl = gl, this.renderer.CONTEXT_UID = $d779c9ccd6fe69e4$var$CONTEXT_UID_COUNTER++, this.renderer.runners.contextChange.emit(gl);
        const view = this.renderer.view;
        view.addEventListener !== void 0 && (view.addEventListener("webglcontextlost", this.handleContextLost, !1), view.addEventListener("webglcontextrestored", this.handleContextRestored, !1));
    }
    /**
   * Initialize from context options
   * @protected
   * @see https://developer.mozilla.org/en-US/docs/Web/API/HTMLCanvasElement/getContext
   * @param {object} options - context attributes
   */ initFromOptions(options) {
        const gl = this.createContext(this.renderer.view, options);
        this.initFromContext(gl);
    }
    /**
   * Helper class to create a WebGL Context
   * @param canvas - the canvas element that we will get the context from
   * @param options - An options object that gets passed in to the canvas element containing the
   *    context attributes
   * @see https://developer.mozilla.org/en/docs/Web/API/HTMLCanvasElement/getContext
   * @returns {WebGLRenderingContext} the WebGL context
   */ createContext(canvas, options) {
        let gl;
        if ((0, $2808efac47e52be0$export$a5a6e0b888b2c992).PREFER_ENV >= (0, $0fa4b07f86297abd$export$83401e34d5e11bf4).WEBGL2 && (gl = canvas.getContext("webgl2", options)), gl) this.webGLVersion = 2;
        else if (this.webGLVersion = 1, gl = canvas.getContext("webgl", options) || canvas.getContext("experimental-webgl", options), !gl) throw new Error("This browser does not support WebGL. Try using the canvas renderer");
        return this.gl = gl, this.getExtensions(), this.gl;
    }
    /** Auto-populate the {@link PIXI.ContextSystem.extensions extensions}. */ getExtensions() {
        const { gl: gl } = this, common = {
            loseContext: gl.getExtension("WEBGL_lose_context"),
            anisotropicFiltering: gl.getExtension("EXT_texture_filter_anisotropic"),
            floatTextureLinear: gl.getExtension("OES_texture_float_linear"),
            s3tc: gl.getExtension("WEBGL_compressed_texture_s3tc"),
            s3tc_sRGB: gl.getExtension("WEBGL_compressed_texture_s3tc_srgb"),
            // eslint-disable-line camelcase
            etc: gl.getExtension("WEBGL_compressed_texture_etc"),
            etc1: gl.getExtension("WEBGL_compressed_texture_etc1"),
            pvrtc: gl.getExtension("WEBGL_compressed_texture_pvrtc") || gl.getExtension("WEBKIT_WEBGL_compressed_texture_pvrtc"),
            atc: gl.getExtension("WEBGL_compressed_texture_atc"),
            astc: gl.getExtension("WEBGL_compressed_texture_astc")
        };
        this.webGLVersion === 1 ? Object.assign(this.extensions, common, {
            drawBuffers: gl.getExtension("WEBGL_draw_buffers"),
            depthTexture: gl.getExtension("WEBGL_depth_texture"),
            vertexArrayObject: gl.getExtension("OES_vertex_array_object") || gl.getExtension("MOZ_OES_vertex_array_object") || gl.getExtension("WEBKIT_OES_vertex_array_object"),
            uint32ElementIndex: gl.getExtension("OES_element_index_uint"),
            // Floats and half-floats
            floatTexture: gl.getExtension("OES_texture_float"),
            floatTextureLinear: gl.getExtension("OES_texture_float_linear"),
            textureHalfFloat: gl.getExtension("OES_texture_half_float"),
            textureHalfFloatLinear: gl.getExtension("OES_texture_half_float_linear")
        }) : this.webGLVersion === 2 && Object.assign(this.extensions, common, {
            // Floats and half-floats
            colorBufferFloat: gl.getExtension("EXT_color_buffer_float")
        });
    }
    /**
   * Handles a lost webgl context
   * @param {WebGLContextEvent} event - The context lost event.
   */ handleContextLost(event) {
        event.preventDefault(), setTimeout(()=>{
            this.gl.isContextLost() && this.extensions.loseContext && this.extensions.loseContext.restoreContext();
        }, 0);
    }
    /** Handles a restored webgl context. */ handleContextRestored() {
        this.renderer.runners.contextChange.emit(this.gl);
    }
    destroy() {
        const view = this.renderer.view;
        this.renderer = null, view.removeEventListener !== void 0 && (view.removeEventListener("webglcontextlost", this.handleContextLost), view.removeEventListener("webglcontextrestored", this.handleContextRestored)), this.gl.useProgram(null), this.extensions.loseContext && this.extensions.loseContext.loseContext();
    }
    /** Handle the post-render runner event. */ postrender() {
        this.renderer.objectRenderer.renderingToScreen && this.gl.flush();
    }
    /**
   * Validate context.
   * @param {WebGLRenderingContext} gl - Render context.
   */ validateContext(gl) {
        const attributes = gl.getContextAttributes(), isWebGl2 = "WebGL2RenderingContext" in globalThis && gl instanceof globalThis.WebGL2RenderingContext;
        isWebGl2 && (this.webGLVersion = 2), attributes && !attributes.stencil && console.warn("Provided WebGL context does not have a stencil buffer, masks may not render correctly");
        const hasuint32 = isWebGl2 || !!gl.getExtension("OES_element_index_uint");
        this.supports.uint32Indices = hasuint32, hasuint32 || console.warn("Provided WebGL context does not support 32 index buffer, complex graphics may not render correctly");
    }
}
$d779c9ccd6fe69e4$export$fedaac80f6f9518c.defaultOptions = {
    /**
   * {@link PIXI.IRendererOptions.context}
   * @default null
   * @memberof PIXI.settings.RENDER_OPTIONS
   */ context: null,
    /**
   * {@link PIXI.IRendererOptions.antialias}
   * @default false
   * @memberof PIXI.settings.RENDER_OPTIONS
   */ antialias: !1,
    /**
   * {@link PIXI.IRendererOptions.premultipliedAlpha}
   * @default true
   * @memberof PIXI.settings.RENDER_OPTIONS
   */ premultipliedAlpha: !0,
    /**
   * {@link PIXI.IRendererOptions.preserveDrawingBuffer}
   * @default false
   * @memberof PIXI.settings.RENDER_OPTIONS
   */ preserveDrawingBuffer: !1,
    /**
   * {@link PIXI.IRendererOptions.powerPreference}
   * @default default
   * @memberof PIXI.settings.RENDER_OPTIONS
   */ powerPreference: "default"
}, /** @ignore */ $d779c9ccd6fe69e4$export$fedaac80f6f9518c.extension = {
    type: (0, $c90155f6d7d8d8f6$export$4f037c6ec2da4eeb).RendererSystem,
    name: "context"
};
(0, $c90155f6d7d8d8f6$export$cc3e2d3244e01b7f).add($d779c9ccd6fe69e4$export$fedaac80f6f9518c);












class $f90e673e35dcf915$export$eff95f126aa67cfb {
    /**
   * @param width - Width of the frame buffer
   * @param height - Height of the frame buffer
   */ constructor(width, height){
        if (this.width = Math.round(width), this.height = Math.round(height), !this.width || !this.height) throw new Error("Framebuffer width or height is zero");
        this.stencil = !1, this.depth = !1, this.dirtyId = 0, this.dirtyFormat = 0, this.dirtySize = 0, this.depthTexture = null, this.colorTextures = [], this.glFramebuffers = {}, this.disposeRunner = new (0, $feae24fa15514cdf$export$571ad3bcba5a0c45)("disposeFramebuffer"), this.multisample = (0, $0fa4b07f86297abd$export$1eadd657d5acc2f2).NONE;
    }
    /**
   * Reference to the colorTexture.
   * @readonly
   */ get colorTexture() {
        return this.colorTextures[0];
    }
    /**
   * Add texture to the colorTexture array.
   * @param index - Index of the array to add the texture to
   * @param texture - Texture to add to the array
   */ addColorTexture(index = 0, texture) {
        return this.colorTextures[index] = texture || new (0, $30c85657f0c625d5$export$d6306e508f184154)(null, {
            scaleMode: (0, $0fa4b07f86297abd$export$6b734c6a0bba8473).NEAREST,
            resolution: 1,
            mipmap: (0, $0fa4b07f86297abd$export$16f6fb5da874bbfd).OFF,
            width: this.width,
            height: this.height
        }), this.dirtyId++, this.dirtyFormat++, this;
    }
    /**
   * Add a depth texture to the frame buffer.
   * @param texture - Texture to add.
   */ addDepthTexture(texture) {
        return this.depthTexture = texture || new (0, $30c85657f0c625d5$export$d6306e508f184154)(null, {
            scaleMode: (0, $0fa4b07f86297abd$export$6b734c6a0bba8473).NEAREST,
            resolution: 1,
            width: this.width,
            height: this.height,
            mipmap: (0, $0fa4b07f86297abd$export$16f6fb5da874bbfd).OFF,
            format: (0, $0fa4b07f86297abd$export$e9c4b7b466aa8274).DEPTH_COMPONENT,
            type: (0, $0fa4b07f86297abd$export$426db7a6155b7a80).UNSIGNED_SHORT
        }), this.dirtyId++, this.dirtyFormat++, this;
    }
    /** Enable depth on the frame buffer. */ enableDepth() {
        return this.depth = !0, this.dirtyId++, this.dirtyFormat++, this;
    }
    /** Enable stencil on the frame buffer. */ enableStencil() {
        return this.stencil = !0, this.dirtyId++, this.dirtyFormat++, this;
    }
    /**
   * Resize the frame buffer
   * @param width - Width of the frame buffer to resize to
   * @param height - Height of the frame buffer to resize to
   */ resize(width, height) {
        if (width = Math.round(width), height = Math.round(height), !width || !height) throw new Error("Framebuffer width and height must not be zero");
        if (!(width === this.width && height === this.height)) {
            this.width = width, this.height = height, this.dirtyId++, this.dirtySize++;
            for(let i = 0; i < this.colorTextures.length; i++){
                const texture = this.colorTextures[i], resolution = texture.resolution;
                texture.setSize(width / resolution, height / resolution);
            }
            if (this.depthTexture) {
                const resolution = this.depthTexture.resolution;
                this.depthTexture.setSize(width / resolution, height / resolution);
            }
        }
    }
    /** Disposes WebGL resources that are connected to this geometry. */ dispose() {
        this.disposeRunner.emit(this, !1);
    }
    /** Destroys and removes the depth texture added to this framebuffer. */ destroyDepthTexture() {
        this.depthTexture && (this.depthTexture.destroy(), this.depthTexture = null, ++this.dirtyId, ++this.dirtyFormat);
    }
}



class $622a7fb4fda60c0a$export$18d268c71e34cf2c extends (0, $30c85657f0c625d5$export$d6306e508f184154) {
    /**
   * @param options
   * @param {number} [options.width=100] - The width of the base render texture.
   * @param {number} [options.height=100] - The height of the base render texture.
   * @param {PIXI.SCALE_MODES} [options.scaleMode=PIXI.BaseTexture.defaultOptions.scaleMode] - See {@link PIXI.SCALE_MODES}
   *   for possible values.
   * @param {number} [options.resolution=PIXI.settings.RESOLUTION] - The resolution / device pixel ratio
   *   of the texture being generated.
   * @param {PIXI.MSAA_QUALITY} [options.multisample=PIXI.MSAA_QUALITY.NONE] - The number of samples of the frame buffer.
   */ constructor(options = {}){
        if (typeof options == "number") {
            const width = arguments[0], height = arguments[1], scaleMode = arguments[2], resolution = arguments[3];
            options = {
                width: width,
                height: height,
                scaleMode: scaleMode,
                resolution: resolution
            };
        }
        options.width = options.width ?? 100, options.height = options.height ?? 100, options.multisample ?? (options.multisample = (0, $0fa4b07f86297abd$export$1eadd657d5acc2f2).NONE), super(null, options), this.mipmap = (0, $0fa4b07f86297abd$export$16f6fb5da874bbfd).OFF, this.valid = !0, this._clear = new (0, $15154c33c9e19c5f$export$892596cec99bc70e)([
            0,
            0,
            0,
            0
        ]), this.framebuffer = new (0, $f90e673e35dcf915$export$eff95f126aa67cfb)(this.realWidth, this.realHeight).addColorTexture(0, this), this.framebuffer.multisample = options.multisample, this.maskStack = [], this.filterStack = [
            {}
        ];
    }
    /** Color when clearning the texture. */ set clearColor(value) {
        this._clear.setValue(value);
    }
    get clearColor() {
        return this._clear.value;
    }
    /**
   * Color object when clearning the texture.
   * @readonly
   * @since 7.2.0
   */ get clear() {
        return this._clear;
    }
    /**
   * Shortcut to `this.framebuffer.multisample`.
   * @default PIXI.MSAA_QUALITY.NONE
   */ get multisample() {
        return this.framebuffer.multisample;
    }
    set multisample(value) {
        this.framebuffer.multisample = value;
    }
    /**
   * Resizes the BaseRenderTexture.
   * @param desiredWidth - The desired width to resize to.
   * @param desiredHeight - The desired height to resize to.
   */ resize(desiredWidth, desiredHeight) {
        this.framebuffer.resize(desiredWidth * this.resolution, desiredHeight * this.resolution), this.setRealSize(this.framebuffer.width, this.framebuffer.height);
    }
    /**
   * Frees the texture and framebuffer from WebGL memory without destroying this texture object.
   * This means you can still use the texture later which will upload it to GPU
   * memory again.
   * @fires PIXI.BaseTexture#dispose
   */ dispose() {
        this.framebuffer.dispose(), super.dispose();
    }
    /** Destroys this texture. */ destroy() {
        super.destroy(), this.framebuffer.destroyDepthTexture(), this.framebuffer = null;
    }
}











class $06918a51ca7773d0$export$c87b2a1e7e3bb4a6 extends (0, $f0aa4c46d7a26335$export$39a853cfb5a94a63) {
    /**
   * @param {HTMLImageElement|HTMLVideoElement|ImageBitmap|PIXI.ICanvas} source
   */ constructor(source){
        const sourceAny = source, width = sourceAny.naturalWidth || sourceAny.videoWidth || sourceAny.width, height = sourceAny.naturalHeight || sourceAny.videoHeight || sourceAny.height;
        super(width, height), this.source = source, this.noSubImage = !1;
    }
    /**
   * Set cross origin based detecting the url and the crossorigin
   * @param element - Element to apply crossOrigin
   * @param url - URL to check
   * @param crossorigin - Cross origin value to use
   */ static crossOrigin(element, url, crossorigin) {
        crossorigin === void 0 && !url.startsWith("data:") ? element.crossOrigin = (0, $275f34938d76b895$export$292083da55c5b406)(url) : crossorigin !== !1 && (element.crossOrigin = typeof crossorigin == "string" ? crossorigin : "anonymous");
    }
    /**
   * Upload the texture to the GPU.
   * @param renderer - Upload to the renderer
   * @param baseTexture - Reference to parent texture
   * @param glTexture
   * @param {HTMLImageElement|HTMLVideoElement|ImageBitmap|PIXI.ICanvas} [source] - (optional)
   * @returns - true is success
   */ upload(renderer, baseTexture, glTexture, source) {
        const gl = renderer.gl, width = baseTexture.realWidth, height = baseTexture.realHeight;
        if (source = source || this.source, typeof HTMLImageElement < "u" && source instanceof HTMLImageElement) {
            if (!source.complete || source.naturalWidth === 0) return !1;
        } else if (typeof HTMLVideoElement < "u" && source instanceof HTMLVideoElement && source.readyState <= 1) return !1;
        return gl.pixelStorei(gl.UNPACK_PREMULTIPLY_ALPHA_WEBGL, baseTexture.alphaMode === (0, $0fa4b07f86297abd$export$d56550d454401b73).UNPACK), !this.noSubImage && baseTexture.target === gl.TEXTURE_2D && glTexture.width === width && glTexture.height === height ? gl.texSubImage2D(gl.TEXTURE_2D, 0, 0, 0, baseTexture.format, glTexture.type, source) : (glTexture.width = width, glTexture.height = height, gl.texImage2D(baseTexture.target, 0, glTexture.internalFormat, baseTexture.format, glTexture.type, source)), !0;
    }
    /**
   * Checks if source width/height was changed, resize can cause extra baseTexture update.
   * Triggers one update in any case.
   */ update() {
        if (this.destroyed) return;
        const source = this.source, width = source.naturalWidth || source.videoWidth || source.width, height = source.naturalHeight || source.videoHeight || source.height;
        this.resize(width, height), super.update();
    }
    /** Destroy this {@link PIXI.BaseImageResource} */ dispose() {
        this.source = null;
    }
}


class $a04cb98a52ca9adc$export$6d0d25e6e731a9a2 extends (0, $06918a51ca7773d0$export$c87b2a1e7e3bb4a6) {
    /**
   * @param source - image source or URL
   * @param options
   * @param {boolean} [options.autoLoad=true] - start loading process
   * @param {boolean} [options.createBitmap=PIXI.settings.CREATE_IMAGE_BITMAP] - whether its required to create
   *        a bitmap before upload
   * @param {boolean} [options.crossorigin=true] - Load image using cross origin
   * @param {PIXI.ALPHA_MODES} [options.alphaMode=PIXI.ALPHA_MODES.UNPACK] - Premultiply image alpha in bitmap
   */ constructor(source, options){
        if (options = options || {}, typeof source == "string") {
            const imageElement = new Image();
            (0, $06918a51ca7773d0$export$c87b2a1e7e3bb4a6).crossOrigin(imageElement, source, options.crossorigin), imageElement.src = source, source = imageElement;
        }
        super(source), !source.complete && this._width && this._height && (this._width = 0, this._height = 0), this.url = source.src, this._process = null, this.preserveBitmap = !1, this.createBitmap = (options.createBitmap ?? (0, $2808efac47e52be0$export$a5a6e0b888b2c992).CREATE_IMAGE_BITMAP) && !!globalThis.createImageBitmap, this.alphaMode = typeof options.alphaMode == "number" ? options.alphaMode : null, this.bitmap = null, this._load = null, options.autoLoad !== !1 && this.load();
    }
    /**
   * Returns a promise when image will be loaded and processed.
   * @param createBitmap - whether process image into bitmap
   */ load(createBitmap) {
        return this._load ? this._load : (createBitmap !== void 0 && (this.createBitmap = createBitmap), this._load = new Promise((resolve, reject)=>{
            const source = this.source;
            this.url = source.src;
            const completed = ()=>{
                this.destroyed || (source.onload = null, source.onerror = null, this.update(), this._load = null, this.createBitmap ? resolve(this.process()) : resolve(this));
            };
            source.complete && source.src ? completed() : (source.onload = completed, source.onerror = (event)=>{
                reject(event), this.onError.emit(event);
            });
        }), this._load);
    }
    /**
   * Called when we need to convert image into BitmapImage.
   * Can be called multiple times, real promise is cached inside.
   * @returns - Cached promise to fill that bitmap
   */ process() {
        const source = this.source;
        if (this._process !== null) return this._process;
        if (this.bitmap !== null || !globalThis.createImageBitmap) return Promise.resolve(this);
        const createImageBitmap = globalThis.createImageBitmap, cors = !source.crossOrigin || source.crossOrigin === "anonymous";
        return this._process = fetch(source.src, {
            mode: cors ? "cors" : "no-cors"
        }).then((r)=>r.blob()).then((blob)=>createImageBitmap(blob, 0, 0, source.width, source.height, {
                premultiplyAlpha: this.alphaMode === null || this.alphaMode === (0, $0fa4b07f86297abd$export$d56550d454401b73).UNPACK ? "premultiply" : "none"
            })).then((bitmap)=>this.destroyed ? Promise.reject() : (this.bitmap = bitmap, this.update(), this._process = null, Promise.resolve(this))), this._process;
    }
    /**
   * Upload the image resource to GPU.
   * @param renderer - Renderer to upload to
   * @param baseTexture - BaseTexture for this resource
   * @param glTexture - GLTexture to use
   * @returns {boolean} true is success
   */ upload(renderer, baseTexture, glTexture) {
        if (typeof this.alphaMode == "number" && (baseTexture.alphaMode = this.alphaMode), !this.createBitmap) return super.upload(renderer, baseTexture, glTexture);
        if (!this.bitmap && (this.process(), !this.bitmap)) return !1;
        if (super.upload(renderer, baseTexture, glTexture, this.bitmap), !this.preserveBitmap) {
            let flag = !0;
            const glTextures = baseTexture._glTextures;
            for(const key in glTextures){
                const otherTex = glTextures[key];
                if (otherTex !== glTexture && otherTex.dirtyId !== baseTexture.dirtyId) {
                    flag = !1;
                    break;
                }
            }
            flag && (this.bitmap.close && this.bitmap.close(), this.bitmap = null);
        }
        return !0;
    }
    /** Destroys this resource. */ dispose() {
        this.source.onload = null, this.source.onerror = null, super.dispose(), this.bitmap && (this.bitmap.close(), this.bitmap = null), this._process = null, this._load = null;
    }
    /**
   * Used to auto-detect the type of resource.
   * @param {*} source - The source object
   * @returns {boolean} `true` if current environment support HTMLImageElement, and source is string or HTMLImageElement
   */ static test(source) {
        return typeof HTMLImageElement < "u" && (typeof source == "string" || source instanceof HTMLImageElement);
    }
}



class $5b47ee7988950ed4$export$4efdf5c542d7171e {
    constructor(){
        this.x0 = 0, this.y0 = 0, this.x1 = 1, this.y1 = 0, this.x2 = 1, this.y2 = 1, this.x3 = 0, this.y3 = 1, this.uvsFloat32 = new Float32Array(8);
    }
    /**
   * Sets the texture Uvs based on the given frame information.
   * @protected
   * @param frame - The frame of the texture
   * @param baseFrame - The base frame of the texture
   * @param rotate - Rotation of frame, see {@link PIXI.groupD8}
   */ set(frame, baseFrame, rotate) {
        const tw = baseFrame.width, th = baseFrame.height;
        if (rotate) {
            const w2 = frame.width / 2 / tw, h2 = frame.height / 2 / th, cX = frame.x / tw + w2, cY = frame.y / th + h2;
            rotate = (0, $6635f7147000f2a6$export$b7bb6a2a8d203102).add(rotate, (0, $6635f7147000f2a6$export$b7bb6a2a8d203102).NW), this.x0 = cX + w2 * (0, $6635f7147000f2a6$export$b7bb6a2a8d203102).uX(rotate), this.y0 = cY + h2 * (0, $6635f7147000f2a6$export$b7bb6a2a8d203102).uY(rotate), rotate = (0, $6635f7147000f2a6$export$b7bb6a2a8d203102).add(rotate, 2), this.x1 = cX + w2 * (0, $6635f7147000f2a6$export$b7bb6a2a8d203102).uX(rotate), this.y1 = cY + h2 * (0, $6635f7147000f2a6$export$b7bb6a2a8d203102).uY(rotate), rotate = (0, $6635f7147000f2a6$export$b7bb6a2a8d203102).add(rotate, 2), this.x2 = cX + w2 * (0, $6635f7147000f2a6$export$b7bb6a2a8d203102).uX(rotate), this.y2 = cY + h2 * (0, $6635f7147000f2a6$export$b7bb6a2a8d203102).uY(rotate), rotate = (0, $6635f7147000f2a6$export$b7bb6a2a8d203102).add(rotate, 2), this.x3 = cX + w2 * (0, $6635f7147000f2a6$export$b7bb6a2a8d203102).uX(rotate), this.y3 = cY + h2 * (0, $6635f7147000f2a6$export$b7bb6a2a8d203102).uY(rotate);
        } else this.x0 = frame.x / tw, this.y0 = frame.y / th, this.x1 = (frame.x + frame.width) / tw, this.y1 = frame.y / th, this.x2 = (frame.x + frame.width) / tw, this.y2 = (frame.y + frame.height) / th, this.x3 = frame.x / tw, this.y3 = (frame.y + frame.height) / th;
        this.uvsFloat32[0] = this.x0, this.uvsFloat32[1] = this.y0, this.uvsFloat32[2] = this.x1, this.uvsFloat32[3] = this.y1, this.uvsFloat32[4] = this.x2, this.uvsFloat32[5] = this.y2, this.uvsFloat32[6] = this.x3, this.uvsFloat32[7] = this.y3;
    }
}
$5b47ee7988950ed4$export$4efdf5c542d7171e.prototype.toString = function() {
    return `[@pixi/core:TextureUvs x0=${this.x0} y0=${this.y0} x1=${this.x1} y1=${this.y1} x2=${this.x2} y2=${this.y2} x3=${this.x3} y3=${this.y3}]`;
};


const $14896914ad3ae15d$var$DEFAULT_UVS = new (0, $5b47ee7988950ed4$export$4efdf5c542d7171e)();
function $14896914ad3ae15d$var$removeAllHandlers(tex) {
    tex.destroy = function() {}, tex.on = function() {}, tex.once = function() {}, tex.emit = function() {};
}
class $14896914ad3ae15d$export$5431306cf43de24a extends (0, (/*@__PURE__*/$parcel$interopDefault($162b085ff96d1cb1$exports))) {
    /**
   * @param baseTexture - The base texture source to create the texture from
   * @param frame - The rectangle frame of the texture to show
   * @param orig - The area of original texture
   * @param trim - Trimmed rectangle of original texture
   * @param rotate - indicates how the texture was rotated by texture packer. See {@link PIXI.groupD8}
   * @param anchor - Default anchor point used for sprite placement / rotation
   * @param borders - Default borders used for 9-slice scaling. See {@link PIXI.NineSlicePlane}
   */ constructor(baseTexture, frame, orig, trim, rotate, anchor, borders){
        if (super(), this.noFrame = !1, frame || (this.noFrame = !0, frame = new (0, $200f778d7fdbf8ac$export$4617fb02663045ef)(0, 0, 1, 1)), baseTexture instanceof $14896914ad3ae15d$export$5431306cf43de24a && (baseTexture = baseTexture.baseTexture), this.baseTexture = baseTexture, this._frame = frame, this.trim = trim, this.valid = !1, this.destroyed = !1, this._uvs = $14896914ad3ae15d$var$DEFAULT_UVS, this.uvMatrix = null, this.orig = orig || frame, this._rotate = Number(rotate || 0), rotate === !0) this._rotate = 2;
        else if (this._rotate % 2 !== 0) throw new Error("attempt to use diamond-shaped UVs. If you are sure, set rotation manually");
        this.defaultAnchor = anchor ? new (0, $cf3018b4309864c2$export$baf26146a414f24a)(anchor.x, anchor.y) : new (0, $cf3018b4309864c2$export$baf26146a414f24a)(0, 0), this.defaultBorders = borders, this._updateID = 0, this.textureCacheIds = [], baseTexture.valid ? this.noFrame ? baseTexture.valid && this.onBaseTextureUpdated(baseTexture) : this.frame = frame : baseTexture.once("loaded", this.onBaseTextureUpdated, this), this.noFrame && baseTexture.on("update", this.onBaseTextureUpdated, this);
    }
    /**
   * Updates this texture on the gpu.
   *
   * Calls the TextureResource update.
   *
   * If you adjusted `frame` manually, please call `updateUvs()` instead.
   */ update() {
        this.baseTexture.resource && this.baseTexture.resource.update();
    }
    /**
   * Called when the base texture is updated
   * @protected
   * @param baseTexture - The base texture.
   */ onBaseTextureUpdated(baseTexture) {
        if (this.noFrame) {
            if (!this.baseTexture.valid) return;
            this._frame.width = baseTexture.width, this._frame.height = baseTexture.height, this.valid = !0, this.updateUvs();
        } else this.frame = this._frame;
        this.emit("update", this);
    }
    /**
   * Destroys this texture
   * @param [destroyBase=false] - Whether to destroy the base texture as well
   * @fires PIXI.Texture#destroyed
   */ destroy(destroyBase) {
        if (this.baseTexture) {
            if (destroyBase) {
                const { resource: resource } = this.baseTexture;
                resource?.url && (0, $de0ca454f7b7a947$export$4254ab7c0971430e)[resource.url] && $14896914ad3ae15d$export$5431306cf43de24a.removeFromCache(resource.url), this.baseTexture.destroy();
            }
            this.baseTexture.off("loaded", this.onBaseTextureUpdated, this), this.baseTexture.off("update", this.onBaseTextureUpdated, this), this.baseTexture = null;
        }
        this._frame = null, this._uvs = null, this.trim = null, this.orig = null, this.valid = !1, $14896914ad3ae15d$export$5431306cf43de24a.removeFromCache(this), this.textureCacheIds = null, this.destroyed = !0, this.emit("destroyed", this), this.removeAllListeners();
    }
    /**
   * Creates a new texture object that acts the same as this one.
   * @returns - The new texture
   */ clone() {
        const clonedFrame = this._frame.clone(), clonedOrig = this._frame === this.orig ? clonedFrame : this.orig.clone(), clonedTexture = new $14896914ad3ae15d$export$5431306cf43de24a(this.baseTexture, !this.noFrame && clonedFrame, clonedOrig, this.trim?.clone(), this.rotate, this.defaultAnchor, this.defaultBorders);
        return this.noFrame && (clonedTexture._frame = clonedFrame), clonedTexture;
    }
    /**
   * Updates the internal WebGL UV cache. Use it after you change `frame` or `trim` of the texture.
   * Call it after changing the frame
   */ updateUvs() {
        this._uvs === $14896914ad3ae15d$var$DEFAULT_UVS && (this._uvs = new (0, $5b47ee7988950ed4$export$4efdf5c542d7171e)()), this._uvs.set(this._frame, this.baseTexture, this.rotate), this._updateID++;
    }
    /**
   * Helper function that creates a new Texture based on the source you provide.
   * The source can be - frame id, image url, video url, canvas element, video element, base texture
   * @param {string|PIXI.BaseTexture|HTMLImageElement|HTMLVideoElement|ImageBitmap|PIXI.ICanvas} source -
   *        Source or array of sources to create texture from
   * @param options - See {@link PIXI.BaseTexture}'s constructor for options.
   * @param {string} [options.pixiIdPrefix=pixiid] - If a source has no id, this is the prefix of the generated id
   * @param {boolean} [strict] - Enforce strict-mode, see {@link PIXI.settings.STRICT_TEXTURE_CACHE}.
   * @returns {PIXI.Texture} The newly created texture
   */ static from(source, options = {}, strict = (0, $2808efac47e52be0$export$a5a6e0b888b2c992).STRICT_TEXTURE_CACHE) {
        const isFrame = typeof source == "string";
        let cacheId = null;
        if (isFrame) cacheId = source;
        else if (source instanceof (0, $30c85657f0c625d5$export$d6306e508f184154)) {
            if (!source.cacheId) {
                const prefix = options?.pixiIdPrefix || "pixiid";
                source.cacheId = `${prefix}-${(0, $9444d853616ed05b$export$e2a22331486dcca0)()}`, (0, $30c85657f0c625d5$export$d6306e508f184154).addToCache(source, source.cacheId);
            }
            cacheId = source.cacheId;
        } else {
            if (!source._pixiId) {
                const prefix = options?.pixiIdPrefix || "pixiid";
                source._pixiId = `${prefix}_${(0, $9444d853616ed05b$export$e2a22331486dcca0)()}`;
            }
            cacheId = source._pixiId;
        }
        let texture = (0, $de0ca454f7b7a947$export$4254ab7c0971430e)[cacheId];
        if (isFrame && strict && !texture) throw new Error(`The cacheId "${cacheId}" does not exist in TextureCache.`);
        return !texture && !(source instanceof (0, $30c85657f0c625d5$export$d6306e508f184154)) ? (options.resolution || (options.resolution = (0, $3425cf39834caee0$export$8695ab2f322d2637)(source)), texture = new $14896914ad3ae15d$export$5431306cf43de24a(new (0, $30c85657f0c625d5$export$d6306e508f184154)(source, options)), texture.baseTexture.cacheId = cacheId, (0, $30c85657f0c625d5$export$d6306e508f184154).addToCache(texture.baseTexture, cacheId), $14896914ad3ae15d$export$5431306cf43de24a.addToCache(texture, cacheId)) : !texture && source instanceof (0, $30c85657f0c625d5$export$d6306e508f184154) && (texture = new $14896914ad3ae15d$export$5431306cf43de24a(source), $14896914ad3ae15d$export$5431306cf43de24a.addToCache(texture, cacheId)), texture;
    }
    /**
   * Useful for loading textures via URLs. Use instead of `Texture.from` because
   * it does a better job of handling failed URLs more effectively. This also ignores
   * `PIXI.settings.STRICT_TEXTURE_CACHE`. Works for Videos, SVGs, Images.
   * @param url - The remote URL or array of URLs to load.
   * @param options - Optional options to include
   * @returns - A Promise that resolves to a Texture.
   */ static fromURL(url, options) {
        const resourceOptions = Object.assign({
            autoLoad: !1
        }, options?.resourceOptions), texture = $14896914ad3ae15d$export$5431306cf43de24a.from(url, Object.assign({
            resourceOptions: resourceOptions
        }, options), !1), resource = texture.baseTexture.resource;
        return texture.baseTexture.valid ? Promise.resolve(texture) : resource.load().then(()=>Promise.resolve(texture));
    }
    /**
   * Create a new Texture with a BufferResource from a typed array.
   * @param buffer - The optional array to use. If no data is provided, a new Float32Array is created.
   * @param width - Width of the resource
   * @param height - Height of the resource
   * @param options - See {@link PIXI.BaseTexture}'s constructor for options.
   *        Default properties are different from the constructor's defaults.
   * @param {PIXI.FORMATS} [options.format] - The format is not given, the type is inferred from the
   *        type of the buffer: `RGBA` if Float32Array, Int8Array, Uint8Array, or Uint8ClampedArray,
   *        otherwise `RGBA_INTEGER`.
   * @param {PIXI.TYPES} [options.type] - The type is not given, the type is inferred from the
   *        type of the buffer. Maps Float32Array to `FLOAT`, Int32Array to `INT`, Uint32Array to
   *        `UNSIGNED_INT`, Int16Array to `SHORT`, Uint16Array to `UNSIGNED_SHORT`, Int8Array to `BYTE`,
   *        Uint8Array/Uint8ClampedArray to `UNSIGNED_BYTE`.
   * @param {PIXI.ALPHA_MODES} [options.alphaMode=PIXI.ALPHA_MODES.NPM]
   * @param {PIXI.SCALE_MODES} [options.scaleMode=PIXI.SCALE_MODES.NEAREST]
   * @returns - The resulting new BaseTexture
   */ static fromBuffer(buffer, width, height, options) {
        return new $14896914ad3ae15d$export$5431306cf43de24a((0, $30c85657f0c625d5$export$d6306e508f184154).fromBuffer(buffer, width, height, options));
    }
    /**
   * Create a texture from a source and add to the cache.
   * @param {HTMLImageElement|HTMLVideoElement|ImageBitmap|PIXI.ICanvas|string} source - The input source.
   * @param imageUrl - File name of texture, for cache and resolving resolution.
   * @param name - Human readable name for the texture cache. If no name is
   *        specified, only `imageUrl` will be used as the cache ID.
   * @param options
   * @returns - Output texture
   */ static fromLoader(source, imageUrl, name, options) {
        const baseTexture = new (0, $30c85657f0c625d5$export$d6306e508f184154)(source, Object.assign({
            scaleMode: (0, $30c85657f0c625d5$export$d6306e508f184154).defaultOptions.scaleMode,
            resolution: (0, $3425cf39834caee0$export$8695ab2f322d2637)(imageUrl)
        }, options)), { resource: resource } = baseTexture;
        resource instanceof (0, $a04cb98a52ca9adc$export$6d0d25e6e731a9a2) && (resource.url = imageUrl);
        const texture = new $14896914ad3ae15d$export$5431306cf43de24a(baseTexture);
        return name || (name = imageUrl), (0, $30c85657f0c625d5$export$d6306e508f184154).addToCache(texture.baseTexture, name), $14896914ad3ae15d$export$5431306cf43de24a.addToCache(texture, name), name !== imageUrl && ((0, $30c85657f0c625d5$export$d6306e508f184154).addToCache(texture.baseTexture, imageUrl), $14896914ad3ae15d$export$5431306cf43de24a.addToCache(texture, imageUrl)), texture.baseTexture.valid ? Promise.resolve(texture) : new Promise((resolve)=>{
            texture.baseTexture.once("loaded", ()=>resolve(texture));
        });
    }
    /**
   * Adds a Texture to the global TextureCache. This cache is shared across the whole PIXI object.
   * @param texture - The Texture to add to the cache.
   * @param id - The id that the Texture will be stored against.
   */ static addToCache(texture, id) {
        id && (texture.textureCacheIds.includes(id) || texture.textureCacheIds.push(id), (0, $de0ca454f7b7a947$export$4254ab7c0971430e)[id] && (0, $de0ca454f7b7a947$export$4254ab7c0971430e)[id] !== texture && console.warn(`Texture added to the cache with an id [${id}] that already had an entry`), (0, $de0ca454f7b7a947$export$4254ab7c0971430e)[id] = texture);
    }
    /**
   * Remove a Texture from the global TextureCache.
   * @param texture - id of a Texture to be removed, or a Texture instance itself
   * @returns - The Texture that was removed
   */ static removeFromCache(texture) {
        if (typeof texture == "string") {
            const textureFromCache = (0, $de0ca454f7b7a947$export$4254ab7c0971430e)[texture];
            if (textureFromCache) {
                const index = textureFromCache.textureCacheIds.indexOf(texture);
                return index > -1 && textureFromCache.textureCacheIds.splice(index, 1), delete (0, $de0ca454f7b7a947$export$4254ab7c0971430e)[texture], textureFromCache;
            }
        } else if (texture?.textureCacheIds) {
            for(let i = 0; i < texture.textureCacheIds.length; ++i)(0, $de0ca454f7b7a947$export$4254ab7c0971430e)[texture.textureCacheIds[i]] === texture && delete (0, $de0ca454f7b7a947$export$4254ab7c0971430e)[texture.textureCacheIds[i]];
            return texture.textureCacheIds.length = 0, texture;
        }
        return null;
    }
    /**
   * Returns resolution of baseTexture
   * @readonly
   */ get resolution() {
        return this.baseTexture.resolution;
    }
    /**
   * The frame specifies the region of the base texture that this texture uses.
   * Please call `updateUvs()` after you change coordinates of `frame` manually.
   */ get frame() {
        return this._frame;
    }
    set frame(frame) {
        this._frame = frame, this.noFrame = !1;
        const { x: x, y: y, width: width, height: height } = frame, xNotFit = x + width > this.baseTexture.width, yNotFit = y + height > this.baseTexture.height;
        if (xNotFit || yNotFit) {
            const relationship = xNotFit && yNotFit ? "and" : "or", errorX = `X: ${x} + ${width} = ${x + width} > ${this.baseTexture.width}`, errorY = `Y: ${y} + ${height} = ${y + height} > ${this.baseTexture.height}`;
            throw new Error(`Texture Error: frame does not fit inside the base Texture dimensions: ${errorX} ${relationship} ${errorY}`);
        }
        this.valid = width && height && this.baseTexture.valid, !this.trim && !this.rotate && (this.orig = frame), this.valid && this.updateUvs();
    }
    /**
   * Indicates whether the texture is rotated inside the atlas
   * set to 2 to compensate for texture packer rotation
   * set to 6 to compensate for spine packer rotation
   * can be used to rotate or mirror sprites
   * See {@link PIXI.groupD8} for explanation
   */ get rotate() {
        return this._rotate;
    }
    set rotate(rotate) {
        this._rotate = rotate, this.valid && this.updateUvs();
    }
    /** The width of the Texture in pixels. */ get width() {
        return this.orig.width;
    }
    /** The height of the Texture in pixels. */ get height() {
        return this.orig.height;
    }
    /** Utility function for BaseTexture|Texture cast. */ castToBaseTexture() {
        return this.baseTexture;
    }
    /** An empty texture, used often to not have to create multiple empty textures. Can not be destroyed. */ static get EMPTY() {
        return $14896914ad3ae15d$export$5431306cf43de24a._EMPTY || ($14896914ad3ae15d$export$5431306cf43de24a._EMPTY = new $14896914ad3ae15d$export$5431306cf43de24a(new (0, $30c85657f0c625d5$export$d6306e508f184154)()), $14896914ad3ae15d$var$removeAllHandlers($14896914ad3ae15d$export$5431306cf43de24a._EMPTY), $14896914ad3ae15d$var$removeAllHandlers($14896914ad3ae15d$export$5431306cf43de24a._EMPTY.baseTexture)), $14896914ad3ae15d$export$5431306cf43de24a._EMPTY;
    }
    /** A white texture of 16x16 size, used for graphics and other things Can not be destroyed. */ static get WHITE() {
        if (!$14896914ad3ae15d$export$5431306cf43de24a._WHITE) {
            const canvas = (0, $2808efac47e52be0$export$a5a6e0b888b2c992).ADAPTER.createCanvas(16, 16), context = canvas.getContext("2d");
            canvas.width = 16, canvas.height = 16, context.fillStyle = "white", context.fillRect(0, 0, 16, 16), $14896914ad3ae15d$export$5431306cf43de24a._WHITE = new $14896914ad3ae15d$export$5431306cf43de24a((0, $30c85657f0c625d5$export$d6306e508f184154).from(canvas)), $14896914ad3ae15d$var$removeAllHandlers($14896914ad3ae15d$export$5431306cf43de24a._WHITE), $14896914ad3ae15d$var$removeAllHandlers($14896914ad3ae15d$export$5431306cf43de24a._WHITE.baseTexture);
        }
        return $14896914ad3ae15d$export$5431306cf43de24a._WHITE;
    }
}



class $f917e2bbb9b65ecb$export$813984f7330b4d72 extends (0, $14896914ad3ae15d$export$5431306cf43de24a) {
    /**
   * @param baseRenderTexture - The base texture object that this texture uses.
   * @param frame - The rectangle frame of the texture to show.
   */ constructor(baseRenderTexture, frame){
        super(baseRenderTexture, frame), this.valid = !0, this.filterFrame = null, this.filterPoolKey = null, this.updateUvs();
    }
    /**
   * Shortcut to `this.baseTexture.framebuffer`, saves baseTexture cast.
   * @readonly
   */ get framebuffer() {
        return this.baseTexture.framebuffer;
    }
    /**
   * Shortcut to `this.framebuffer.multisample`.
   * @default PIXI.MSAA_QUALITY.NONE
   */ get multisample() {
        return this.framebuffer.multisample;
    }
    set multisample(value) {
        this.framebuffer.multisample = value;
    }
    /**
   * Resizes the RenderTexture.
   * @param desiredWidth - The desired width to resize to.
   * @param desiredHeight - The desired height to resize to.
   * @param resizeBaseTexture - Should the baseTexture.width and height values be resized as well?
   */ resize(desiredWidth, desiredHeight, resizeBaseTexture = !0) {
        const resolution = this.baseTexture.resolution, width = Math.round(desiredWidth * resolution) / resolution, height = Math.round(desiredHeight * resolution) / resolution;
        this.valid = width > 0 && height > 0, this._frame.width = this.orig.width = width, this._frame.height = this.orig.height = height, resizeBaseTexture && this.baseTexture.resize(width, height), this.updateUvs();
    }
    /**
   * Changes the resolution of baseTexture, but does not change framebuffer size.
   * @param resolution - The new resolution to apply to RenderTexture
   */ setResolution(resolution) {
        const { baseTexture: baseTexture } = this;
        baseTexture.resolution !== resolution && (baseTexture.setResolution(resolution), this.resize(baseTexture.width, baseTexture.height, !1));
    }
    /**
   * A short hand way of creating a render texture.
   * @param options - Options
   * @param {number} [options.width=100] - The width of the render texture
   * @param {number} [options.height=100] - The height of the render texture
   * @param {PIXI.SCALE_MODES} [options.scaleMode=PIXI.BaseTexture.defaultOptions.scaleMode] - See {@link PIXI.SCALE_MODES}
   *    for possible values
   * @param {number} [options.resolution=PIXI.settings.RESOLUTION] - The resolution / device pixel ratio of the texture
   *    being generated
   * @param {PIXI.MSAA_QUALITY} [options.multisample=PIXI.MSAA_QUALITY.NONE] - The number of samples of the frame buffer
   * @returns The new render texture
   */ static create(options) {
        return new $f917e2bbb9b65ecb$export$813984f7330b4d72(new (0, $622a7fb4fda60c0a$export$18d268c71e34cf2c)(options));
    }
}


class $d413369fab0a36c0$export$1a441d2b5f37dfd7 {
    /**
   * @param textureOptions - options that will be passed to BaseRenderTexture constructor
   * @param {PIXI.SCALE_MODES} [textureOptions.scaleMode] - See {@link PIXI.SCALE_MODES} for possible values.
   */ constructor(textureOptions){
        this.texturePool = {}, this.textureOptions = textureOptions || {}, this.enableFullScreen = !1, this._pixelsWidth = 0, this._pixelsHeight = 0;
    }
    /**
   * Creates texture with params that were specified in pool constructor.
   * @param realWidth - Width of texture in pixels.
   * @param realHeight - Height of texture in pixels.
   * @param multisample - Number of samples of the framebuffer.
   */ createTexture(realWidth, realHeight, multisample = (0, $0fa4b07f86297abd$export$1eadd657d5acc2f2).NONE) {
        const baseRenderTexture = new (0, $622a7fb4fda60c0a$export$18d268c71e34cf2c)(Object.assign({
            width: realWidth,
            height: realHeight,
            resolution: 1,
            multisample: multisample
        }, this.textureOptions));
        return new (0, $f917e2bbb9b65ecb$export$813984f7330b4d72)(baseRenderTexture);
    }
    /**
   * Gets a Power-of-Two render texture or fullScreen texture
   * @param minWidth - The minimum width of the render texture.
   * @param minHeight - The minimum height of the render texture.
   * @param resolution - The resolution of the render texture.
   * @param multisample - Number of samples of the render texture.
   * @returns The new render texture.
   */ getOptimalTexture(minWidth, minHeight, resolution = 1, multisample = (0, $0fa4b07f86297abd$export$1eadd657d5acc2f2).NONE) {
        let key;
        minWidth = Math.max(Math.ceil(minWidth * resolution - 1e-6), 1), minHeight = Math.max(Math.ceil(minHeight * resolution - 1e-6), 1), !this.enableFullScreen || minWidth !== this._pixelsWidth || minHeight !== this._pixelsHeight ? (minWidth = (0, $af2147baf6c30f74$export$f0d90cf68bd426eb)(minWidth), minHeight = (0, $af2147baf6c30f74$export$f0d90cf68bd426eb)(minHeight), key = ((minWidth & 65535) << 16 | minHeight & 65535) >>> 0, multisample > 1 && (key += multisample * 4294967296)) : key = multisample > 1 ? -multisample : -1, this.texturePool[key] || (this.texturePool[key] = []);
        let renderTexture = this.texturePool[key].pop();
        return renderTexture || (renderTexture = this.createTexture(minWidth, minHeight, multisample)), renderTexture.filterPoolKey = key, renderTexture.setResolution(resolution), renderTexture;
    }
    /**
   * Gets extra texture of the same size as input renderTexture
   *
   * `getFilterTexture(input, 0.5)` or `getFilterTexture(0.5, input)`
   * @param input - renderTexture from which size and resolution will be copied
   * @param resolution - override resolution of the renderTexture
   *  It overrides, it does not multiply
   * @param multisample - number of samples of the renderTexture
   */ getFilterTexture(input, resolution, multisample) {
        const filterTexture = this.getOptimalTexture(input.width, input.height, resolution || input.resolution, multisample || (0, $0fa4b07f86297abd$export$1eadd657d5acc2f2).NONE);
        return filterTexture.filterFrame = input.filterFrame, filterTexture;
    }
    /**
   * Place a render texture back into the pool.
   * @param renderTexture - The renderTexture to free
   */ returnTexture(renderTexture) {
        const key = renderTexture.filterPoolKey;
        renderTexture.filterFrame = null, this.texturePool[key].push(renderTexture);
    }
    /**
   * Alias for returnTexture, to be compliant with FilterSystem interface.
   * @param renderTexture - The renderTexture to free
   */ returnFilterTexture(renderTexture) {
        this.returnTexture(renderTexture);
    }
    /**
   * Clears the pool.
   * @param destroyTextures - Destroy all stored textures.
   */ clear(destroyTextures) {
        if (destroyTextures = destroyTextures !== !1, destroyTextures) for(const i in this.texturePool){
            const textures = this.texturePool[i];
            if (textures) for(let j = 0; j < textures.length; j++)textures[j].destroy(!0);
        }
        this.texturePool = {};
    }
    /**
   * If screen size was changed, drops all screen-sized textures,
   * sets new screen size, sets `enableFullScreen` to true
   *
   * Size is measured in pixels, `renderer.view` can be passed here, not `renderer.screen`
   * @param size - Initial size of screen.
   */ setScreenSize(size) {
        if (!(size.width === this._pixelsWidth && size.height === this._pixelsHeight)) {
            this.enableFullScreen = size.width > 0 && size.height > 0;
            for(const i in this.texturePool){
                if (!(Number(i) < 0)) continue;
                const textures = this.texturePool[i];
                if (textures) for(let j = 0; j < textures.length; j++)textures[j].destroy(!0);
                this.texturePool[i] = [];
            }
            this._pixelsWidth = size.width, this._pixelsHeight = size.height;
        }
    }
}
$d413369fab0a36c0$export$1a441d2b5f37dfd7.SCREEN_KEY = -1;




class $e42a2d232eaa30c2$export$7005c9eb6671414d extends (0, $746bc9ae18084e8e$export$2db6c17465f94a2) {
    constructor(){
        super(), this.addAttribute("aVertexPosition", new Float32Array([
            0,
            0,
            1,
            0,
            1,
            1,
            0,
            1
        ])).addIndex([
            0,
            1,
            3,
            2
        ]);
    }
}




class $5b24a8358280f4cf$export$4f70783f37e4ec0b extends (0, $746bc9ae18084e8e$export$2db6c17465f94a2) {
    constructor(){
        super(), this.vertices = new Float32Array([
            -1,
            -1,
            1,
            -1,
            1,
            1,
            -1,
            1
        ]), this.uvs = new Float32Array([
            0,
            0,
            1,
            0,
            1,
            1,
            0,
            1
        ]), this.vertexBuffer = new (0, $17b501b101b42758$export$a143d493d941bafc)(this.vertices), this.uvBuffer = new (0, $17b501b101b42758$export$a143d493d941bafc)(this.uvs), this.addAttribute("aVertexPosition", this.vertexBuffer).addAttribute("aTextureCoord", this.uvBuffer).addIndex([
            0,
            1,
            2,
            0,
            2,
            3
        ]);
    }
    /**
   * Maps two Rectangle to the quad.
   * @param targetTextureFrame - The first rectangle
   * @param destinationFrame - The second rectangle
   * @returns - Returns itself.
   */ map(targetTextureFrame, destinationFrame) {
        let x = 0, y = 0;
        return this.uvs[0] = x, this.uvs[1] = y, this.uvs[2] = x + destinationFrame.width / targetTextureFrame.width, this.uvs[3] = y, this.uvs[4] = x + destinationFrame.width / targetTextureFrame.width, this.uvs[5] = y + destinationFrame.height / targetTextureFrame.height, this.uvs[6] = x, this.uvs[7] = y + destinationFrame.height / targetTextureFrame.height, x = destinationFrame.x, y = destinationFrame.y, this.vertices[0] = x, this.vertices[1] = y, this.vertices[2] = x + destinationFrame.width, this.vertices[3] = y, this.vertices[4] = x + destinationFrame.width, this.vertices[5] = y + destinationFrame.height, this.vertices[6] = x, this.vertices[7] = y + destinationFrame.height, this.invalidate(), this;
    }
    /**
   * Legacy upload method, just marks buffers dirty.
   * @returns - Returns itself.
   */ invalidate() {
        return this.vertexBuffer._updateID++, this.uvBuffer._updateID++, this;
    }
}




class $cfebffe6eb0fc444$export$ac6e0205a419d6d6 {
    constructor(){
        this.renderTexture = null, this.target = null, this.legacy = !1, this.resolution = 1, this.multisample = (0, $0fa4b07f86297abd$export$1eadd657d5acc2f2).NONE, this.sourceFrame = new (0, $200f778d7fdbf8ac$export$4617fb02663045ef)(), this.destinationFrame = new (0, $200f778d7fdbf8ac$export$4617fb02663045ef)(), this.bindingSourceFrame = new (0, $200f778d7fdbf8ac$export$4617fb02663045ef)(), this.bindingDestinationFrame = new (0, $200f778d7fdbf8ac$export$4617fb02663045ef)(), this.filters = [], this.transform = null;
    }
    /** Clears the state */ clear() {
        this.target = null, this.filters = null, this.renderTexture = null;
    }
}


const $5e2f3acb47ee9206$var$tempPoints = [
    new (0, $cf3018b4309864c2$export$baf26146a414f24a)(),
    new (0, $cf3018b4309864c2$export$baf26146a414f24a)(),
    new (0, $cf3018b4309864c2$export$baf26146a414f24a)(),
    new (0, $cf3018b4309864c2$export$baf26146a414f24a)()
], $5e2f3acb47ee9206$var$tempMatrix = new (0, $d7da222aa639cde0$export$5b12bf1653c0dd85)();
class $5e2f3acb47ee9206$export$e94225c0dfac29cf {
    /**
   * @param renderer - The renderer this System works for.
   */ constructor(renderer){
        this.renderer = renderer, this.defaultFilterStack = [
            {}
        ], this.texturePool = new (0, $d413369fab0a36c0$export$1a441d2b5f37dfd7)(), this.statePool = [], this.quad = new (0, $e42a2d232eaa30c2$export$7005c9eb6671414d)(), this.quadUv = new (0, $5b24a8358280f4cf$export$4f70783f37e4ec0b)(), this.tempRect = new (0, $200f778d7fdbf8ac$export$4617fb02663045ef)(), this.activeState = {}, this.globalUniforms = new (0, $8380fc86b6e89a36$export$6601a7a2dcf79bf5)({
            outputFrame: new (0, $200f778d7fdbf8ac$export$4617fb02663045ef)(),
            inputSize: new Float32Array(4),
            inputPixel: new Float32Array(4),
            inputClamp: new Float32Array(4),
            resolution: 1,
            // legacy variables
            filterArea: new Float32Array(4),
            filterClamp: new Float32Array(4)
        }, !0), this.forceClear = !1, this.useMaxPadding = !1;
    }
    init() {
        this.texturePool.setScreenSize(this.renderer.view);
    }
    /**
   * Pushes a set of filters to be applied later to the system. This will redirect further rendering into an
   * input render-texture for the rest of the filtering pipeline.
   * @param {PIXI.DisplayObject} target - The target of the filter to render.
   * @param filters - The filters to apply.
   */ push(target, filters) {
        const renderer = this.renderer, filterStack = this.defaultFilterStack, state = this.statePool.pop() || new (0, $cfebffe6eb0fc444$export$ac6e0205a419d6d6)(), renderTextureSystem = renderer.renderTexture;
        let currentResolution, currentMultisample;
        if (renderTextureSystem.current) {
            const renderTexture = renderTextureSystem.current;
            currentResolution = renderTexture.resolution, currentMultisample = renderTexture.multisample;
        } else currentResolution = renderer.resolution, currentMultisample = renderer.multisample;
        let resolution = filters[0].resolution || currentResolution, multisample = filters[0].multisample ?? currentMultisample, padding = filters[0].padding, autoFit = filters[0].autoFit, legacy = filters[0].legacy ?? !0;
        for(let i = 1; i < filters.length; i++){
            const filter = filters[i];
            resolution = Math.min(resolution, filter.resolution || currentResolution), multisample = Math.min(multisample, filter.multisample ?? currentMultisample), padding = this.useMaxPadding ? Math.max(padding, filter.padding) : padding + filter.padding, autoFit = autoFit && filter.autoFit, legacy = legacy || (filter.legacy ?? !0);
        }
        filterStack.length === 1 && (this.defaultFilterStack[0].renderTexture = renderTextureSystem.current), filterStack.push(state), state.resolution = resolution, state.multisample = multisample, state.legacy = legacy, state.target = target, state.sourceFrame.copyFrom(target.filterArea || target.getBounds(!0)), state.sourceFrame.pad(padding);
        const sourceFrameProjected = this.tempRect.copyFrom(renderTextureSystem.sourceFrame);
        renderer.projection.transform && this.transformAABB($5e2f3acb47ee9206$var$tempMatrix.copyFrom(renderer.projection.transform).invert(), sourceFrameProjected), autoFit ? (state.sourceFrame.fit(sourceFrameProjected), (state.sourceFrame.width <= 0 || state.sourceFrame.height <= 0) && (state.sourceFrame.width = 0, state.sourceFrame.height = 0)) : state.sourceFrame.intersects(sourceFrameProjected) || (state.sourceFrame.width = 0, state.sourceFrame.height = 0), this.roundFrame(state.sourceFrame, renderTextureSystem.current ? renderTextureSystem.current.resolution : renderer.resolution, renderTextureSystem.sourceFrame, renderTextureSystem.destinationFrame, renderer.projection.transform), state.renderTexture = this.getOptimalFilterTexture(state.sourceFrame.width, state.sourceFrame.height, resolution, multisample), state.filters = filters, state.destinationFrame.width = state.renderTexture.width, state.destinationFrame.height = state.renderTexture.height;
        const destinationFrame = this.tempRect;
        destinationFrame.x = 0, destinationFrame.y = 0, destinationFrame.width = state.sourceFrame.width, destinationFrame.height = state.sourceFrame.height, state.renderTexture.filterFrame = state.sourceFrame, state.bindingSourceFrame.copyFrom(renderTextureSystem.sourceFrame), state.bindingDestinationFrame.copyFrom(renderTextureSystem.destinationFrame), state.transform = renderer.projection.transform, renderer.projection.transform = null, renderTextureSystem.bind(state.renderTexture, state.sourceFrame, destinationFrame), renderer.framebuffer.clear(0, 0, 0, 0);
    }
    /** Pops off the filter and applies it. */ pop() {
        const filterStack = this.defaultFilterStack, state = filterStack.pop(), filters = state.filters;
        this.activeState = state;
        const globalUniforms = this.globalUniforms.uniforms;
        globalUniforms.outputFrame = state.sourceFrame, globalUniforms.resolution = state.resolution;
        const inputSize = globalUniforms.inputSize, inputPixel = globalUniforms.inputPixel, inputClamp = globalUniforms.inputClamp;
        if (inputSize[0] = state.destinationFrame.width, inputSize[1] = state.destinationFrame.height, inputSize[2] = 1 / inputSize[0], inputSize[3] = 1 / inputSize[1], inputPixel[0] = Math.round(inputSize[0] * state.resolution), inputPixel[1] = Math.round(inputSize[1] * state.resolution), inputPixel[2] = 1 / inputPixel[0], inputPixel[3] = 1 / inputPixel[1], inputClamp[0] = 0.5 * inputPixel[2], inputClamp[1] = 0.5 * inputPixel[3], inputClamp[2] = state.sourceFrame.width * inputSize[2] - 0.5 * inputPixel[2], inputClamp[3] = state.sourceFrame.height * inputSize[3] - 0.5 * inputPixel[3], state.legacy) {
            const filterArea = globalUniforms.filterArea;
            filterArea[0] = state.destinationFrame.width, filterArea[1] = state.destinationFrame.height, filterArea[2] = state.sourceFrame.x, filterArea[3] = state.sourceFrame.y, globalUniforms.filterClamp = globalUniforms.inputClamp;
        }
        this.globalUniforms.update();
        const lastState = filterStack[filterStack.length - 1];
        if (this.renderer.framebuffer.blit(), filters.length === 1) filters[0].apply(this, state.renderTexture, lastState.renderTexture, (0, $0fa4b07f86297abd$export$784901839554cbc3).BLEND, state), this.returnFilterTexture(state.renderTexture);
        else {
            let flip = state.renderTexture, flop = this.getOptimalFilterTexture(flip.width, flip.height, state.resolution);
            flop.filterFrame = flip.filterFrame;
            let i = 0;
            for(i = 0; i < filters.length - 1; ++i){
                i === 1 && state.multisample > 1 && (flop = this.getOptimalFilterTexture(flip.width, flip.height, state.resolution), flop.filterFrame = flip.filterFrame), filters[i].apply(this, flip, flop, (0, $0fa4b07f86297abd$export$784901839554cbc3).CLEAR, state);
                const t = flip;
                flip = flop, flop = t;
            }
            filters[i].apply(this, flip, lastState.renderTexture, (0, $0fa4b07f86297abd$export$784901839554cbc3).BLEND, state), i > 1 && state.multisample > 1 && this.returnFilterTexture(state.renderTexture), this.returnFilterTexture(flip), this.returnFilterTexture(flop);
        }
        state.clear(), this.statePool.push(state);
    }
    /**
   * Binds a renderTexture with corresponding `filterFrame`, clears it if mode corresponds.
   * @param filterTexture - renderTexture to bind, should belong to filter pool or filter stack
   * @param clearMode - clearMode, by default its CLEAR/YES. See {@link PIXI.CLEAR_MODES}
   */ bindAndClear(filterTexture, clearMode = (0, $0fa4b07f86297abd$export$784901839554cbc3).CLEAR) {
        const { renderTexture: renderTextureSystem, state: stateSystem } = this.renderer;
        if (filterTexture === this.defaultFilterStack[this.defaultFilterStack.length - 1].renderTexture ? this.renderer.projection.transform = this.activeState.transform : this.renderer.projection.transform = null, filterTexture?.filterFrame) {
            const destinationFrame = this.tempRect;
            destinationFrame.x = 0, destinationFrame.y = 0, destinationFrame.width = filterTexture.filterFrame.width, destinationFrame.height = filterTexture.filterFrame.height, renderTextureSystem.bind(filterTexture, filterTexture.filterFrame, destinationFrame);
        } else filterTexture !== this.defaultFilterStack[this.defaultFilterStack.length - 1].renderTexture ? renderTextureSystem.bind(filterTexture) : this.renderer.renderTexture.bind(filterTexture, this.activeState.bindingSourceFrame, this.activeState.bindingDestinationFrame);
        const autoClear = stateSystem.stateId & 1 || this.forceClear;
        (clearMode === (0, $0fa4b07f86297abd$export$784901839554cbc3).CLEAR || clearMode === (0, $0fa4b07f86297abd$export$784901839554cbc3).BLIT && autoClear) && this.renderer.framebuffer.clear(0, 0, 0, 0);
    }
    /**
   * Draws a filter using the default rendering process.
   *
   * This should be called only by {@link PIXI.Filter#apply}.
   * @param filter - The filter to draw.
   * @param input - The input render target.
   * @param output - The target to output to.
   * @param clearMode - Should the output be cleared before rendering to it
   */ applyFilter(filter, input, output, clearMode) {
        const renderer = this.renderer;
        renderer.state.set(filter.state), this.bindAndClear(output, clearMode), filter.uniforms.uSampler = input, filter.uniforms.filterGlobals = this.globalUniforms, renderer.shader.bind(filter), filter.legacy = !!filter.program.attributeData.aTextureCoord, filter.legacy ? (this.quadUv.map(input._frame, input.filterFrame), renderer.geometry.bind(this.quadUv), renderer.geometry.draw((0, $0fa4b07f86297abd$export$91100badd8469338).TRIANGLES)) : (renderer.geometry.bind(this.quad), renderer.geometry.draw((0, $0fa4b07f86297abd$export$91100badd8469338).TRIANGLE_STRIP));
    }
    /**
   * Multiply _input normalized coordinates_ to this matrix to get _sprite texture normalized coordinates_.
   *
   * Use `outputMatrix * vTextureCoord` in the shader.
   * @param outputMatrix - The matrix to output to.
   * @param {PIXI.Sprite} sprite - The sprite to map to.
   * @returns The mapped matrix.
   */ calculateSpriteMatrix(outputMatrix, sprite) {
        const { sourceFrame: sourceFrame, destinationFrame: destinationFrame } = this.activeState, { orig: orig } = sprite._texture, mappedMatrix = outputMatrix.set(destinationFrame.width, 0, 0, destinationFrame.height, sourceFrame.x, sourceFrame.y), worldTransform = sprite.worldTransform.copyTo((0, $d7da222aa639cde0$export$5b12bf1653c0dd85).TEMP_MATRIX);
        return worldTransform.invert(), mappedMatrix.prepend(worldTransform), mappedMatrix.scale(1 / orig.width, 1 / orig.height), mappedMatrix.translate(sprite.anchor.x, sprite.anchor.y), mappedMatrix;
    }
    /** Destroys this Filter System. */ destroy() {
        this.renderer = null, this.texturePool.clear(!1);
    }
    /**
   * Gets a Power-of-Two render texture or fullScreen texture
   * @param minWidth - The minimum width of the render texture in real pixels.
   * @param minHeight - The minimum height of the render texture in real pixels.
   * @param resolution - The resolution of the render texture.
   * @param multisample - Number of samples of the render texture.
   * @returns - The new render texture.
   */ getOptimalFilterTexture(minWidth, minHeight, resolution = 1, multisample = (0, $0fa4b07f86297abd$export$1eadd657d5acc2f2).NONE) {
        return this.texturePool.getOptimalTexture(minWidth, minHeight, resolution, multisample);
    }
    /**
   * Gets extra render texture to use inside current filter
   * To be compliant with older filters, you can use params in any order
   * @param input - renderTexture from which size and resolution will be copied
   * @param resolution - override resolution of the renderTexture
   * @param multisample - number of samples of the renderTexture
   */ getFilterTexture(input, resolution, multisample) {
        if (typeof input == "number") {
            const swap = input;
            input = resolution, resolution = swap;
        }
        input = input || this.activeState.renderTexture;
        const filterTexture = this.texturePool.getOptimalTexture(input.width, input.height, resolution || input.resolution, multisample || (0, $0fa4b07f86297abd$export$1eadd657d5acc2f2).NONE);
        return filterTexture.filterFrame = input.filterFrame, filterTexture;
    }
    /**
   * Frees a render texture back into the pool.
   * @param renderTexture - The renderTarget to free
   */ returnFilterTexture(renderTexture) {
        this.texturePool.returnTexture(renderTexture);
    }
    /** Empties the texture pool. */ emptyPool() {
        this.texturePool.clear(!0);
    }
    /** Calls `texturePool.resize()`, affects fullScreen renderTextures. */ resize() {
        this.texturePool.setScreenSize(this.renderer.view);
    }
    /**
   * @param matrix - first param
   * @param rect - second param
   */ transformAABB(matrix, rect) {
        const lt = $5e2f3acb47ee9206$var$tempPoints[0], lb = $5e2f3acb47ee9206$var$tempPoints[1], rt = $5e2f3acb47ee9206$var$tempPoints[2], rb = $5e2f3acb47ee9206$var$tempPoints[3];
        lt.set(rect.left, rect.top), lb.set(rect.left, rect.bottom), rt.set(rect.right, rect.top), rb.set(rect.right, rect.bottom), matrix.apply(lt, lt), matrix.apply(lb, lb), matrix.apply(rt, rt), matrix.apply(rb, rb);
        const x0 = Math.min(lt.x, lb.x, rt.x, rb.x), y0 = Math.min(lt.y, lb.y, rt.y, rb.y), x1 = Math.max(lt.x, lb.x, rt.x, rb.x), y1 = Math.max(lt.y, lb.y, rt.y, rb.y);
        rect.x = x0, rect.y = y0, rect.width = x1 - x0, rect.height = y1 - y0;
    }
    roundFrame(frame, resolution, bindingSourceFrame, bindingDestinationFrame, transform) {
        if (!(frame.width <= 0 || frame.height <= 0 || bindingSourceFrame.width <= 0 || bindingSourceFrame.height <= 0)) {
            if (transform) {
                const { a: a, b: b, c: c, d: d } = transform;
                if ((Math.abs(b) > 1e-4 || Math.abs(c) > 1e-4) && (Math.abs(a) > 1e-4 || Math.abs(d) > 1e-4)) return;
            }
            transform = transform ? $5e2f3acb47ee9206$var$tempMatrix.copyFrom(transform) : $5e2f3acb47ee9206$var$tempMatrix.identity(), transform.translate(-bindingSourceFrame.x, -bindingSourceFrame.y).scale(bindingDestinationFrame.width / bindingSourceFrame.width, bindingDestinationFrame.height / bindingSourceFrame.height).translate(bindingDestinationFrame.x, bindingDestinationFrame.y), this.transformAABB(transform, frame), frame.ceil(resolution), this.transformAABB(transform.invert(), frame);
        }
    }
}
$5e2f3acb47ee9206$export$e94225c0dfac29cf.extension = {
    type: (0, $c90155f6d7d8d8f6$export$4f037c6ec2da4eeb).RendererSystem,
    name: "filter"
};
(0, $c90155f6d7d8d8f6$export$cc3e2d3244e01b7f).add($5e2f3acb47ee9206$export$e94225c0dfac29cf);








class $56109b7de209a098$export$47f6dbf489220e22 {
    constructor(framebuffer){
        this.framebuffer = framebuffer, this.stencil = null, this.dirtyId = -1, this.dirtyFormat = -1, this.dirtySize = -1, this.multisample = (0, $0fa4b07f86297abd$export$1eadd657d5acc2f2).NONE, this.msaaBuffer = null, this.blitFramebuffer = null, this.mipLevel = 0;
    }
}


const $a1b748328b74cbd2$var$tempRectangle = new (0, $200f778d7fdbf8ac$export$4617fb02663045ef)();
class $a1b748328b74cbd2$export$3f472331251297cd {
    /**
   * @param renderer - The renderer this System works for.
   */ constructor(renderer){
        this.renderer = renderer, this.managedFramebuffers = [], this.unknownFramebuffer = new (0, $f90e673e35dcf915$export$eff95f126aa67cfb)(10, 10), this.msaaSamples = null;
    }
    /** Sets up the renderer context and necessary buffers. */ contextChange() {
        this.disposeAll(!0);
        const gl = this.gl = this.renderer.gl;
        if (this.CONTEXT_UID = this.renderer.CONTEXT_UID, this.current = this.unknownFramebuffer, this.viewport = new (0, $200f778d7fdbf8ac$export$4617fb02663045ef)(), this.hasMRT = !0, this.writeDepthTexture = !0, this.renderer.context.webGLVersion === 1) {
            let nativeDrawBuffersExtension = this.renderer.context.extensions.drawBuffers, nativeDepthTextureExtension = this.renderer.context.extensions.depthTexture;
            (0, $2808efac47e52be0$export$a5a6e0b888b2c992).PREFER_ENV === (0, $0fa4b07f86297abd$export$83401e34d5e11bf4).WEBGL_LEGACY && (nativeDrawBuffersExtension = null, nativeDepthTextureExtension = null), nativeDrawBuffersExtension ? gl.drawBuffers = (activeTextures)=>nativeDrawBuffersExtension.drawBuffersWEBGL(activeTextures) : (this.hasMRT = !1, gl.drawBuffers = ()=>{}), nativeDepthTextureExtension || (this.writeDepthTexture = !1);
        } else this.msaaSamples = gl.getInternalformatParameter(gl.RENDERBUFFER, gl.RGBA8, gl.SAMPLES);
    }
    /**
   * Bind a framebuffer.
   * @param framebuffer
   * @param frame - frame, default is framebuffer size
   * @param mipLevel - optional mip level to set on the framebuffer - defaults to 0
   */ bind(framebuffer, frame, mipLevel = 0) {
        const { gl: gl } = this;
        if (framebuffer) {
            const fbo = framebuffer.glFramebuffers[this.CONTEXT_UID] || this.initFramebuffer(framebuffer);
            this.current !== framebuffer && (this.current = framebuffer, gl.bindFramebuffer(gl.FRAMEBUFFER, fbo.framebuffer)), fbo.mipLevel !== mipLevel && (framebuffer.dirtyId++, framebuffer.dirtyFormat++, fbo.mipLevel = mipLevel), fbo.dirtyId !== framebuffer.dirtyId && (fbo.dirtyId = framebuffer.dirtyId, fbo.dirtyFormat !== framebuffer.dirtyFormat ? (fbo.dirtyFormat = framebuffer.dirtyFormat, fbo.dirtySize = framebuffer.dirtySize, this.updateFramebuffer(framebuffer, mipLevel)) : fbo.dirtySize !== framebuffer.dirtySize && (fbo.dirtySize = framebuffer.dirtySize, this.resizeFramebuffer(framebuffer)));
            for(let i = 0; i < framebuffer.colorTextures.length; i++){
                const tex = framebuffer.colorTextures[i];
                this.renderer.texture.unbind(tex.parentTextureArray || tex);
            }
            if (framebuffer.depthTexture && this.renderer.texture.unbind(framebuffer.depthTexture), frame) {
                const mipWidth = frame.width >> mipLevel, mipHeight = frame.height >> mipLevel, scale = mipWidth / frame.width;
                this.setViewport(frame.x * scale, frame.y * scale, mipWidth, mipHeight);
            } else {
                const mipWidth = framebuffer.width >> mipLevel, mipHeight = framebuffer.height >> mipLevel;
                this.setViewport(0, 0, mipWidth, mipHeight);
            }
        } else this.current && (this.current = null, gl.bindFramebuffer(gl.FRAMEBUFFER, null)), frame ? this.setViewport(frame.x, frame.y, frame.width, frame.height) : this.setViewport(0, 0, this.renderer.width, this.renderer.height);
    }
    /**
   * Set the WebGLRenderingContext's viewport.
   * @param x - X position of viewport
   * @param y - Y position of viewport
   * @param width - Width of viewport
   * @param height - Height of viewport
   */ setViewport(x, y, width, height) {
        const v = this.viewport;
        x = Math.round(x), y = Math.round(y), width = Math.round(width), height = Math.round(height), (v.width !== width || v.height !== height || v.x !== x || v.y !== y) && (v.x = x, v.y = y, v.width = width, v.height = height, this.gl.viewport(x, y, width, height));
    }
    /**
   * Get the size of the current width and height. Returns object with `width` and `height` values.
   * @readonly
   */ get size() {
        return this.current ? {
            x: 0,
            y: 0,
            width: this.current.width,
            height: this.current.height
        } : {
            x: 0,
            y: 0,
            width: this.renderer.width,
            height: this.renderer.height
        };
    }
    /**
   * Clear the color of the context
   * @param r - Red value from 0 to 1
   * @param g - Green value from 0 to 1
   * @param b - Blue value from 0 to 1
   * @param a - Alpha value from 0 to 1
   * @param {PIXI.BUFFER_BITS} [mask=BUFFER_BITS.COLOR | BUFFER_BITS.DEPTH] - Bitwise OR of masks
   *  that indicate the buffers to be cleared, by default COLOR and DEPTH buffers.
   */ clear(r, g, b, a, mask = (0, $0fa4b07f86297abd$export$c07ea8ac66dac49).COLOR | (0, $0fa4b07f86297abd$export$c07ea8ac66dac49).DEPTH) {
        const { gl: gl } = this;
        gl.clearColor(r, g, b, a), gl.clear(mask);
    }
    /**
   * Initialize framebuffer for this context
   * @protected
   * @param framebuffer
   * @returns - created GLFramebuffer
   */ initFramebuffer(framebuffer) {
        const { gl: gl } = this, fbo = new (0, $56109b7de209a098$export$47f6dbf489220e22)(gl.createFramebuffer());
        return fbo.multisample = this.detectSamples(framebuffer.multisample), framebuffer.glFramebuffers[this.CONTEXT_UID] = fbo, this.managedFramebuffers.push(framebuffer), framebuffer.disposeRunner.add(this), fbo;
    }
    /**
   * Resize the framebuffer
   * @param framebuffer
   * @protected
   */ resizeFramebuffer(framebuffer) {
        const { gl: gl } = this, fbo = framebuffer.glFramebuffers[this.CONTEXT_UID];
        if (fbo.stencil) {
            gl.bindRenderbuffer(gl.RENDERBUFFER, fbo.stencil);
            let stencilFormat;
            this.renderer.context.webGLVersion === 1 ? stencilFormat = gl.DEPTH_STENCIL : framebuffer.depth && framebuffer.stencil ? stencilFormat = gl.DEPTH24_STENCIL8 : framebuffer.depth ? stencilFormat = gl.DEPTH_COMPONENT24 : stencilFormat = gl.STENCIL_INDEX8, fbo.msaaBuffer ? gl.renderbufferStorageMultisample(gl.RENDERBUFFER, fbo.multisample, stencilFormat, framebuffer.width, framebuffer.height) : gl.renderbufferStorage(gl.RENDERBUFFER, stencilFormat, framebuffer.width, framebuffer.height);
        }
        const colorTextures = framebuffer.colorTextures;
        let count = colorTextures.length;
        gl.drawBuffers || (count = Math.min(count, 1));
        for(let i = 0; i < count; i++){
            const texture = colorTextures[i], parentTexture = texture.parentTextureArray || texture;
            this.renderer.texture.bind(parentTexture, 0), i === 0 && fbo.msaaBuffer && (gl.bindRenderbuffer(gl.RENDERBUFFER, fbo.msaaBuffer), gl.renderbufferStorageMultisample(gl.RENDERBUFFER, fbo.multisample, parentTexture._glTextures[this.CONTEXT_UID].internalFormat, framebuffer.width, framebuffer.height));
        }
        framebuffer.depthTexture && this.writeDepthTexture && this.renderer.texture.bind(framebuffer.depthTexture, 0);
    }
    /**
   * Update the framebuffer
   * @param framebuffer
   * @param mipLevel
   * @protected
   */ updateFramebuffer(framebuffer, mipLevel) {
        const { gl: gl } = this, fbo = framebuffer.glFramebuffers[this.CONTEXT_UID], colorTextures = framebuffer.colorTextures;
        let count = colorTextures.length;
        gl.drawBuffers || (count = Math.min(count, 1)), fbo.multisample > 1 && this.canMultisampleFramebuffer(framebuffer) ? fbo.msaaBuffer = fbo.msaaBuffer || gl.createRenderbuffer() : fbo.msaaBuffer && (gl.deleteRenderbuffer(fbo.msaaBuffer), fbo.msaaBuffer = null, fbo.blitFramebuffer && (fbo.blitFramebuffer.dispose(), fbo.blitFramebuffer = null));
        const activeTextures = [];
        for(let i = 0; i < count; i++){
            const texture = colorTextures[i], parentTexture = texture.parentTextureArray || texture;
            this.renderer.texture.bind(parentTexture, 0), i === 0 && fbo.msaaBuffer ? (gl.bindRenderbuffer(gl.RENDERBUFFER, fbo.msaaBuffer), gl.renderbufferStorageMultisample(gl.RENDERBUFFER, fbo.multisample, parentTexture._glTextures[this.CONTEXT_UID].internalFormat, framebuffer.width, framebuffer.height), gl.framebufferRenderbuffer(gl.FRAMEBUFFER, gl.COLOR_ATTACHMENT0, gl.RENDERBUFFER, fbo.msaaBuffer)) : (gl.framebufferTexture2D(gl.FRAMEBUFFER, gl.COLOR_ATTACHMENT0 + i, texture.target, parentTexture._glTextures[this.CONTEXT_UID].texture, mipLevel), activeTextures.push(gl.COLOR_ATTACHMENT0 + i));
        }
        if (activeTextures.length > 1 && gl.drawBuffers(activeTextures), framebuffer.depthTexture && this.writeDepthTexture) {
            const depthTexture = framebuffer.depthTexture;
            this.renderer.texture.bind(depthTexture, 0), gl.framebufferTexture2D(gl.FRAMEBUFFER, gl.DEPTH_ATTACHMENT, gl.TEXTURE_2D, depthTexture._glTextures[this.CONTEXT_UID].texture, mipLevel);
        }
        if ((framebuffer.stencil || framebuffer.depth) && !(framebuffer.depthTexture && this.writeDepthTexture)) {
            fbo.stencil = fbo.stencil || gl.createRenderbuffer();
            let stencilAttachment, stencilFormat;
            this.renderer.context.webGLVersion === 1 ? (stencilAttachment = gl.DEPTH_STENCIL_ATTACHMENT, stencilFormat = gl.DEPTH_STENCIL) : framebuffer.depth && framebuffer.stencil ? (stencilAttachment = gl.DEPTH_STENCIL_ATTACHMENT, stencilFormat = gl.DEPTH24_STENCIL8) : framebuffer.depth ? (stencilAttachment = gl.DEPTH_ATTACHMENT, stencilFormat = gl.DEPTH_COMPONENT24) : (stencilAttachment = gl.STENCIL_ATTACHMENT, stencilFormat = gl.STENCIL_INDEX8), gl.bindRenderbuffer(gl.RENDERBUFFER, fbo.stencil), fbo.msaaBuffer ? gl.renderbufferStorageMultisample(gl.RENDERBUFFER, fbo.multisample, stencilFormat, framebuffer.width, framebuffer.height) : gl.renderbufferStorage(gl.RENDERBUFFER, stencilFormat, framebuffer.width, framebuffer.height), gl.framebufferRenderbuffer(gl.FRAMEBUFFER, stencilAttachment, gl.RENDERBUFFER, fbo.stencil);
        } else fbo.stencil && (gl.deleteRenderbuffer(fbo.stencil), fbo.stencil = null);
    }
    /**
   * Returns true if the frame buffer can be multisampled.
   * @param framebuffer
   */ canMultisampleFramebuffer(framebuffer) {
        return this.renderer.context.webGLVersion !== 1 && framebuffer.colorTextures.length <= 1 && !framebuffer.depthTexture;
    }
    /**
   * Detects number of samples that is not more than a param but as close to it as possible
   * @param samples - number of samples
   * @returns - recommended number of samples
   */ detectSamples(samples) {
        const { msaaSamples: msaaSamples } = this;
        let res = (0, $0fa4b07f86297abd$export$1eadd657d5acc2f2).NONE;
        if (samples <= 1 || msaaSamples === null) return res;
        for(let i = 0; i < msaaSamples.length; i++)if (msaaSamples[i] <= samples) {
            res = msaaSamples[i];
            break;
        }
        return res === 1 && (res = (0, $0fa4b07f86297abd$export$1eadd657d5acc2f2).NONE), res;
    }
    /**
   * Only works with WebGL2
   *
   * blits framebuffer to another of the same or bigger size
   * after that target framebuffer is bound
   *
   * Fails with WebGL warning if blits multisample framebuffer to different size
   * @param framebuffer - by default it blits "into itself", from renderBuffer to texture.
   * @param sourcePixels - source rectangle in pixels
   * @param destPixels - dest rectangle in pixels, assumed to be the same as sourcePixels
   */ blit(framebuffer, sourcePixels, destPixels) {
        const { current: current, renderer: renderer, gl: gl, CONTEXT_UID: CONTEXT_UID } = this;
        if (renderer.context.webGLVersion !== 2 || !current) return;
        const fbo = current.glFramebuffers[CONTEXT_UID];
        if (!fbo) return;
        if (!framebuffer) {
            if (!fbo.msaaBuffer) return;
            const colorTexture = current.colorTextures[0];
            if (!colorTexture) return;
            fbo.blitFramebuffer || (fbo.blitFramebuffer = new (0, $f90e673e35dcf915$export$eff95f126aa67cfb)(current.width, current.height), fbo.blitFramebuffer.addColorTexture(0, colorTexture)), framebuffer = fbo.blitFramebuffer, framebuffer.colorTextures[0] !== colorTexture && (framebuffer.colorTextures[0] = colorTexture, framebuffer.dirtyId++, framebuffer.dirtyFormat++), (framebuffer.width !== current.width || framebuffer.height !== current.height) && (framebuffer.width = current.width, framebuffer.height = current.height, framebuffer.dirtyId++, framebuffer.dirtySize++);
        }
        sourcePixels || (sourcePixels = $a1b748328b74cbd2$var$tempRectangle, sourcePixels.width = current.width, sourcePixels.height = current.height), destPixels || (destPixels = sourcePixels);
        const sameSize = sourcePixels.width === destPixels.width && sourcePixels.height === destPixels.height;
        this.bind(framebuffer), gl.bindFramebuffer(gl.READ_FRAMEBUFFER, fbo.framebuffer), gl.blitFramebuffer(sourcePixels.left, sourcePixels.top, sourcePixels.right, sourcePixels.bottom, destPixels.left, destPixels.top, destPixels.right, destPixels.bottom, gl.COLOR_BUFFER_BIT, sameSize ? gl.NEAREST : gl.LINEAR), gl.bindFramebuffer(gl.READ_FRAMEBUFFER, framebuffer.glFramebuffers[this.CONTEXT_UID].framebuffer);
    }
    /**
   * Disposes framebuffer.
   * @param framebuffer - framebuffer that has to be disposed of
   * @param contextLost - If context was lost, we suppress all delete function calls
   */ disposeFramebuffer(framebuffer, contextLost) {
        const fbo = framebuffer.glFramebuffers[this.CONTEXT_UID], gl = this.gl;
        if (!fbo) return;
        delete framebuffer.glFramebuffers[this.CONTEXT_UID];
        const index = this.managedFramebuffers.indexOf(framebuffer);
        index >= 0 && this.managedFramebuffers.splice(index, 1), framebuffer.disposeRunner.remove(this), contextLost || (gl.deleteFramebuffer(fbo.framebuffer), fbo.msaaBuffer && gl.deleteRenderbuffer(fbo.msaaBuffer), fbo.stencil && gl.deleteRenderbuffer(fbo.stencil)), fbo.blitFramebuffer && this.disposeFramebuffer(fbo.blitFramebuffer, contextLost);
    }
    /**
   * Disposes all framebuffers, but not textures bound to them.
   * @param [contextLost=false] - If context was lost, we suppress all delete function calls
   */ disposeAll(contextLost) {
        const list = this.managedFramebuffers;
        this.managedFramebuffers = [];
        for(let i = 0; i < list.length; i++)this.disposeFramebuffer(list[i], contextLost);
    }
    /**
   * Forcing creation of stencil buffer for current framebuffer, if it wasn't done before.
   * Used by MaskSystem, when its time to use stencil mask for Graphics element.
   *
   * Its an alternative for public lazy `framebuffer.enableStencil`, in case we need stencil without rebind.
   * @private
   */ forceStencil() {
        const framebuffer = this.current;
        if (!framebuffer) return;
        const fbo = framebuffer.glFramebuffers[this.CONTEXT_UID];
        if (!fbo || fbo.stencil && framebuffer.stencil) return;
        framebuffer.stencil = !0;
        const w = framebuffer.width, h = framebuffer.height, gl = this.gl, stencil = fbo.stencil = gl.createRenderbuffer();
        gl.bindRenderbuffer(gl.RENDERBUFFER, stencil);
        let stencilAttachment, stencilFormat;
        this.renderer.context.webGLVersion === 1 ? (stencilAttachment = gl.DEPTH_STENCIL_ATTACHMENT, stencilFormat = gl.DEPTH_STENCIL) : framebuffer.depth ? (stencilAttachment = gl.DEPTH_STENCIL_ATTACHMENT, stencilFormat = gl.DEPTH24_STENCIL8) : (stencilAttachment = gl.STENCIL_ATTACHMENT, stencilFormat = gl.STENCIL_INDEX8), fbo.msaaBuffer ? gl.renderbufferStorageMultisample(gl.RENDERBUFFER, fbo.multisample, stencilFormat, w, h) : gl.renderbufferStorage(gl.RENDERBUFFER, stencilFormat, w, h), gl.framebufferRenderbuffer(gl.FRAMEBUFFER, stencilAttachment, gl.RENDERBUFFER, stencil);
    }
    /** Resets framebuffer stored state, binds screen framebuffer. Should be called before renderTexture reset(). */ reset() {
        this.current = this.unknownFramebuffer, this.viewport = new (0, $200f778d7fdbf8ac$export$4617fb02663045ef)();
    }
    destroy() {
        this.renderer = null;
    }
}
$a1b748328b74cbd2$export$3f472331251297cd.extension = {
    type: (0, $c90155f6d7d8d8f6$export$4f037c6ec2da4eeb).RendererSystem,
    name: "framebuffer"
};
(0, $c90155f6d7d8d8f6$export$cc3e2d3244e01b7f).add($a1b748328b74cbd2$export$3f472331251297cd);





const $64e531ee5070fa2d$var$byteSizeMap = {
    5126: 4,
    5123: 2,
    5121: 1
};
class $64e531ee5070fa2d$export$c83da0f390a7459c {
    /** @param renderer - The renderer this System works for. */ constructor(renderer){
        this.renderer = renderer, this._activeGeometry = null, this._activeVao = null, this.hasVao = !0, this.hasInstance = !0, this.canUseUInt32ElementIndex = !1, this.managedGeometries = {};
    }
    /** Sets up the renderer context and necessary buffers. */ contextChange() {
        this.disposeAll(!0);
        const gl = this.gl = this.renderer.gl, context = this.renderer.context;
        if (this.CONTEXT_UID = this.renderer.CONTEXT_UID, context.webGLVersion !== 2) {
            let nativeVaoExtension = this.renderer.context.extensions.vertexArrayObject;
            (0, $2808efac47e52be0$export$a5a6e0b888b2c992).PREFER_ENV === (0, $0fa4b07f86297abd$export$83401e34d5e11bf4).WEBGL_LEGACY && (nativeVaoExtension = null), nativeVaoExtension ? (gl.createVertexArray = ()=>nativeVaoExtension.createVertexArrayOES(), gl.bindVertexArray = (vao)=>nativeVaoExtension.bindVertexArrayOES(vao), gl.deleteVertexArray = (vao)=>nativeVaoExtension.deleteVertexArrayOES(vao)) : (this.hasVao = !1, gl.createVertexArray = ()=>null, gl.bindVertexArray = ()=>null, gl.deleteVertexArray = ()=>null);
        }
        if (context.webGLVersion !== 2) {
            const instanceExt = gl.getExtension("ANGLE_instanced_arrays");
            instanceExt ? (gl.vertexAttribDivisor = (a, b)=>instanceExt.vertexAttribDivisorANGLE(a, b), gl.drawElementsInstanced = (a, b, c, d, e)=>instanceExt.drawElementsInstancedANGLE(a, b, c, d, e), gl.drawArraysInstanced = (a, b, c, d)=>instanceExt.drawArraysInstancedANGLE(a, b, c, d)) : this.hasInstance = !1;
        }
        this.canUseUInt32ElementIndex = context.webGLVersion === 2 || !!context.extensions.uint32ElementIndex;
    }
    /**
   * Binds geometry so that is can be drawn. Creating a Vao if required
   * @param geometry - Instance of geometry to bind.
   * @param shader - Instance of shader to use vao for.
   */ bind(geometry, shader) {
        shader = shader || this.renderer.shader.shader;
        const { gl: gl } = this;
        let vaos = geometry.glVertexArrayObjects[this.CONTEXT_UID], incRefCount = !1;
        vaos || (this.managedGeometries[geometry.id] = geometry, geometry.disposeRunner.add(this), geometry.glVertexArrayObjects[this.CONTEXT_UID] = vaos = {}, incRefCount = !0);
        const vao = vaos[shader.program.id] || this.initGeometryVao(geometry, shader, incRefCount);
        this._activeGeometry = geometry, this._activeVao !== vao && (this._activeVao = vao, this.hasVao ? gl.bindVertexArray(vao) : this.activateVao(geometry, shader.program)), this.updateBuffers();
    }
    /** Reset and unbind any active VAO and geometry. */ reset() {
        this.unbind();
    }
    /** Update buffers of the currently bound geometry. */ updateBuffers() {
        const geometry = this._activeGeometry, bufferSystem = this.renderer.buffer;
        for(let i = 0; i < geometry.buffers.length; i++){
            const buffer = geometry.buffers[i];
            bufferSystem.update(buffer);
        }
    }
    /**
   * Check compatibility between a geometry and a program
   * @param geometry - Geometry instance.
   * @param program - Program instance.
   */ checkCompatibility(geometry, program) {
        const geometryAttributes = geometry.attributes, shaderAttributes = program.attributeData;
        for(const j in shaderAttributes)if (!geometryAttributes[j]) throw new Error(`shader and geometry incompatible, geometry missing the "${j}" attribute`);
    }
    /**
   * Takes a geometry and program and generates a unique signature for them.
   * @param geometry - To get signature from.
   * @param program - To test geometry against.
   * @returns - Unique signature of the geometry and program
   */ getSignature(geometry, program) {
        const attribs = geometry.attributes, shaderAttributes = program.attributeData, strings = [
            "g",
            geometry.id
        ];
        for(const i in attribs)shaderAttributes[i] && strings.push(i, shaderAttributes[i].location);
        return strings.join("-");
    }
    /**
   * Creates or gets Vao with the same structure as the geometry and stores it on the geometry.
   * If vao is created, it is bound automatically. We use a shader to infer what and how to set up the
   * attribute locations.
   * @param geometry - Instance of geometry to to generate Vao for.
   * @param shader - Instance of the shader.
   * @param incRefCount - Increment refCount of all geometry buffers.
   */ initGeometryVao(geometry, shader, incRefCount = !0) {
        const gl = this.gl, CONTEXT_UID = this.CONTEXT_UID, bufferSystem = this.renderer.buffer, program = shader.program;
        program.glPrograms[CONTEXT_UID] || this.renderer.shader.generateProgram(shader), this.checkCompatibility(geometry, program);
        const signature = this.getSignature(geometry, program), vaoObjectHash = geometry.glVertexArrayObjects[this.CONTEXT_UID];
        let vao = vaoObjectHash[signature];
        if (vao) return vaoObjectHash[program.id] = vao, vao;
        const buffers = geometry.buffers, attributes = geometry.attributes, tempStride = {}, tempStart = {};
        for(const j in buffers)tempStride[j] = 0, tempStart[j] = 0;
        for(const j in attributes)!attributes[j].size && program.attributeData[j] ? attributes[j].size = program.attributeData[j].size : attributes[j].size || console.warn(`PIXI Geometry attribute '${j}' size cannot be determined (likely the bound shader does not have the attribute)`), tempStride[attributes[j].buffer] += attributes[j].size * $64e531ee5070fa2d$var$byteSizeMap[attributes[j].type];
        for(const j in attributes){
            const attribute = attributes[j], attribSize = attribute.size;
            attribute.stride === void 0 && (tempStride[attribute.buffer] === attribSize * $64e531ee5070fa2d$var$byteSizeMap[attribute.type] ? attribute.stride = 0 : attribute.stride = tempStride[attribute.buffer]), attribute.start === void 0 && (attribute.start = tempStart[attribute.buffer], tempStart[attribute.buffer] += attribSize * $64e531ee5070fa2d$var$byteSizeMap[attribute.type]);
        }
        vao = gl.createVertexArray(), gl.bindVertexArray(vao);
        for(let i = 0; i < buffers.length; i++){
            const buffer = buffers[i];
            bufferSystem.bind(buffer), incRefCount && buffer._glBuffers[CONTEXT_UID].refCount++;
        }
        return this.activateVao(geometry, program), vaoObjectHash[program.id] = vao, vaoObjectHash[signature] = vao, gl.bindVertexArray(null), bufferSystem.unbind((0, $0fa4b07f86297abd$export$b595a7e482202b96).ARRAY_BUFFER), vao;
    }
    /**
   * Disposes geometry.
   * @param geometry - Geometry with buffers. Only VAO will be disposed
   * @param [contextLost=false] - If context was lost, we suppress deleteVertexArray
   */ disposeGeometry(geometry, contextLost) {
        if (!this.managedGeometries[geometry.id]) return;
        delete this.managedGeometries[geometry.id];
        const vaos = geometry.glVertexArrayObjects[this.CONTEXT_UID], gl = this.gl, buffers = geometry.buffers, bufferSystem = this.renderer?.buffer;
        if (geometry.disposeRunner.remove(this), !!vaos) {
            if (bufferSystem) for(let i = 0; i < buffers.length; i++){
                const buf = buffers[i]._glBuffers[this.CONTEXT_UID];
                buf && (buf.refCount--, buf.refCount === 0 && !contextLost && bufferSystem.dispose(buffers[i], contextLost));
            }
            if (!contextLost) {
                for(const vaoId in vaos)if (vaoId[0] === "g") {
                    const vao = vaos[vaoId];
                    this._activeVao === vao && this.unbind(), gl.deleteVertexArray(vao);
                }
            }
            delete geometry.glVertexArrayObjects[this.CONTEXT_UID];
        }
    }
    /**
   * Dispose all WebGL resources of all managed geometries.
   * @param [contextLost=false] - If context was lost, we suppress `gl.delete` calls
   */ disposeAll(contextLost) {
        const all = Object.keys(this.managedGeometries);
        for(let i = 0; i < all.length; i++)this.disposeGeometry(this.managedGeometries[all[i]], contextLost);
    }
    /**
   * Activate vertex array object.
   * @param geometry - Geometry instance.
   * @param program - Shader program instance.
   */ activateVao(geometry, program) {
        const gl = this.gl, CONTEXT_UID = this.CONTEXT_UID, bufferSystem = this.renderer.buffer, buffers = geometry.buffers, attributes = geometry.attributes;
        geometry.indexBuffer && bufferSystem.bind(geometry.indexBuffer);
        let lastBuffer = null;
        for(const j in attributes){
            const attribute = attributes[j], buffer = buffers[attribute.buffer], glBuffer = buffer._glBuffers[CONTEXT_UID];
            if (program.attributeData[j]) {
                lastBuffer !== glBuffer && (bufferSystem.bind(buffer), lastBuffer = glBuffer);
                const location = program.attributeData[j].location;
                if (gl.enableVertexAttribArray(location), gl.vertexAttribPointer(location, attribute.size, attribute.type || gl.FLOAT, attribute.normalized, attribute.stride, attribute.start), attribute.instance) {
                    if (this.hasInstance) gl.vertexAttribDivisor(location, attribute.divisor);
                    else throw new Error("geometry error, GPU Instancing is not supported on this device");
                }
            }
        }
    }
    /**
   * Draws the currently bound geometry.
   * @param type - The type primitive to render.
   * @param size - The number of elements to be rendered. If not specified, all vertices after the
   *  starting vertex will be drawn.
   * @param start - The starting vertex in the geometry to start drawing from. If not specified,
   *  drawing will start from the first vertex.
   * @param instanceCount - The number of instances of the set of elements to execute. If not specified,
   *  all instances will be drawn.
   */ draw(type, size, start, instanceCount) {
        const { gl: gl } = this, geometry = this._activeGeometry;
        if (geometry.indexBuffer) {
            const byteSize = geometry.indexBuffer.data.BYTES_PER_ELEMENT, glType = byteSize === 2 ? gl.UNSIGNED_SHORT : gl.UNSIGNED_INT;
            byteSize === 2 || byteSize === 4 && this.canUseUInt32ElementIndex ? geometry.instanced ? gl.drawElementsInstanced(type, size || geometry.indexBuffer.data.length, glType, (start || 0) * byteSize, instanceCount || 1) : gl.drawElements(type, size || geometry.indexBuffer.data.length, glType, (start || 0) * byteSize) : console.warn("unsupported index buffer type: uint32");
        } else geometry.instanced ? gl.drawArraysInstanced(type, start, size || geometry.getSize(), instanceCount || 1) : gl.drawArrays(type, start, size || geometry.getSize());
        return this;
    }
    /** Unbind/reset everything. */ unbind() {
        this.gl.bindVertexArray(null), this._activeVao = null, this._activeGeometry = null;
    }
    destroy() {
        this.renderer = null;
    }
}
$64e531ee5070fa2d$export$c83da0f390a7459c.extension = {
    type: (0, $c90155f6d7d8d8f6$export$4f037c6ec2da4eeb).RendererSystem,
    name: "geometry"
};
(0, $c90155f6d7d8d8f6$export$cc3e2d3244e01b7f).add($64e531ee5070fa2d$export$c83da0f390a7459c);






const $63f378ad73a038ff$var$tempMat = new (0, $d7da222aa639cde0$export$5b12bf1653c0dd85)();
class $63f378ad73a038ff$export$dbea3135e9da48cb {
    /**
   * @param texture - observed texture
   * @param clampMargin - Changes frame clamping, 0.5 by default. Use -0.5 for extra border.
   */ constructor(texture, clampMargin){
        this._texture = texture, this.mapCoord = new (0, $d7da222aa639cde0$export$5b12bf1653c0dd85)(), this.uClampFrame = new Float32Array(4), this.uClampOffset = new Float32Array(2), this._textureID = -1, this._updateID = 0, this.clampOffset = 0, this.clampMargin = typeof clampMargin > "u" ? 0.5 : clampMargin, this.isSimple = !1;
    }
    /** Texture property. */ get texture() {
        return this._texture;
    }
    set texture(value) {
        this._texture = value, this._textureID = -1;
    }
    /**
   * Multiplies uvs array to transform
   * @param uvs - mesh uvs
   * @param [out=uvs] - output
   * @returns - output
   */ multiplyUvs(uvs, out) {
        out === void 0 && (out = uvs);
        const mat = this.mapCoord;
        for(let i = 0; i < uvs.length; i += 2){
            const x = uvs[i], y = uvs[i + 1];
            out[i] = x * mat.a + y * mat.c + mat.tx, out[i + 1] = x * mat.b + y * mat.d + mat.ty;
        }
        return out;
    }
    /**
   * Updates matrices if texture was changed.
   * @param [forceUpdate=false] - if true, matrices will be updated any case
   * @returns - Whether or not it was updated
   */ update(forceUpdate) {
        const tex = this._texture;
        if (!tex || !tex.valid || !forceUpdate && this._textureID === tex._updateID) return !1;
        this._textureID = tex._updateID, this._updateID++;
        const uvs = tex._uvs;
        this.mapCoord.set(uvs.x1 - uvs.x0, uvs.y1 - uvs.y0, uvs.x3 - uvs.x0, uvs.y3 - uvs.y0, uvs.x0, uvs.y0);
        const orig = tex.orig, trim = tex.trim;
        trim && ($63f378ad73a038ff$var$tempMat.set(orig.width / trim.width, 0, 0, orig.height / trim.height, -trim.x / trim.width, -trim.y / trim.height), this.mapCoord.append($63f378ad73a038ff$var$tempMat));
        const texBase = tex.baseTexture, frame = this.uClampFrame, margin = this.clampMargin / texBase.resolution, offset = this.clampOffset;
        return frame[0] = (tex._frame.x + margin + offset) / texBase.width, frame[1] = (tex._frame.y + margin + offset) / texBase.height, frame[2] = (tex._frame.x + tex._frame.width - margin + offset) / texBase.width, frame[3] = (tex._frame.y + tex._frame.height - margin + offset) / texBase.height, this.uClampOffset[0] = offset / texBase.realWidth, this.uClampOffset[1] = offset / texBase.realHeight, this.isSimple = tex._frame.width === texBase.width && tex._frame.height === texBase.height && tex.rotate === 0, !0;
    }
}



var $26128060cdce4897$export$2e2bcd8739ae039 = `varying vec2 vMaskCoord;
varying vec2 vTextureCoord;

uniform sampler2D uSampler;
uniform sampler2D mask;
uniform float alpha;
uniform float npmAlpha;
uniform vec4 maskClamp;

void main(void)
{
    float clip = step(3.5,
        step(maskClamp.x, vMaskCoord.x) +
        step(maskClamp.y, vMaskCoord.y) +
        step(vMaskCoord.x, maskClamp.z) +
        step(vMaskCoord.y, maskClamp.w));

    vec4 original = texture2D(uSampler, vTextureCoord);
    vec4 masky = texture2D(mask, vMaskCoord);
    float alphaMul = 1.0 - npmAlpha * (1.0 - masky.a);

    original *= (alphaMul * masky.r * alpha * clip);

    gl_FragColor = original;
}
`;


var $57b8c277868ad5e8$export$2e2bcd8739ae039 = `attribute vec2 aVertexPosition;
attribute vec2 aTextureCoord;

uniform mat3 projectionMatrix;
uniform mat3 otherMatrix;

varying vec2 vMaskCoord;
varying vec2 vTextureCoord;

void main(void)
{
    gl_Position = vec4((projectionMatrix * vec3(aVertexPosition, 1.0)).xy, 0.0, 1.0);

    vTextureCoord = aTextureCoord;
    vMaskCoord = ( otherMatrix * vec3( aTextureCoord, 1.0)  ).xy;
}
`;


class $0a912a6cc2cd8819$export$6b66f8c14dea0d0 extends (0, $46266bc3fe6194b8$export$ec91da630f36d5ea) {
    /** @ignore */ constructor(vertexSrc, fragmentSrc, uniforms){
        let sprite = null;
        typeof vertexSrc != "string" && fragmentSrc === void 0 && uniforms === void 0 && (sprite = vertexSrc, vertexSrc = void 0, fragmentSrc = void 0, uniforms = void 0), super(vertexSrc || (0, $57b8c277868ad5e8$export$2e2bcd8739ae039), fragmentSrc || (0, $26128060cdce4897$export$2e2bcd8739ae039), uniforms), this.maskSprite = sprite, this.maskMatrix = new (0, $d7da222aa639cde0$export$5b12bf1653c0dd85)();
    }
    /**
   * Sprite mask
   * @type {PIXI.DisplayObject}
   */ get maskSprite() {
        return this._maskSprite;
    }
    set maskSprite(value) {
        this._maskSprite = value, this._maskSprite && (this._maskSprite.renderable = !1);
    }
    /**
   * Applies the filter
   * @param filterManager - The renderer to retrieve the filter from
   * @param input - The input render target.
   * @param output - The target to output to.
   * @param clearMode - Should the output be cleared before rendering to it.
   */ apply(filterManager, input, output, clearMode) {
        const maskSprite = this._maskSprite, tex = maskSprite._texture;
        tex.valid && (tex.uvMatrix || (tex.uvMatrix = new (0, $63f378ad73a038ff$export$dbea3135e9da48cb)(tex, 0)), tex.uvMatrix.update(), this.uniforms.npmAlpha = tex.baseTexture.alphaMode ? 0 : 1, this.uniforms.mask = tex, this.uniforms.otherMatrix = filterManager.calculateSpriteMatrix(this.maskMatrix, maskSprite).prepend(tex.uvMatrix.mapCoord), this.uniforms.alpha = maskSprite.worldAlpha, this.uniforms.maskClamp = tex.uvMatrix.uClampFrame, filterManager.applyFilter(this, input, output, clearMode));
    }
}




class $ad1418603fa0ab6f$export$c75dec3795e98612 {
    /**
   * Create MaskData
   * @param {PIXI.DisplayObject} [maskObject=null] - object that describes the mask
   */ constructor(maskObject = null){
        this.type = (0, $0fa4b07f86297abd$export$dbbea138c5d144).NONE, this.autoDetect = !0, this.maskObject = maskObject || null, this.pooled = !1, this.isMaskData = !0, this.resolution = null, this.multisample = (0, $46266bc3fe6194b8$export$ec91da630f36d5ea).defaultMultisample, this.enabled = !0, this.colorMask = 15, this._filters = null, this._stencilCounter = 0, this._scissorCounter = 0, this._scissorRect = null, this._scissorRectLocal = null, this._colorMask = 15, this._target = null;
    }
    /**
   * The sprite mask filter.
   * If set to `null`, the default sprite mask filter is used.
   * @default null
   */ get filter() {
        return this._filters ? this._filters[0] : null;
    }
    set filter(value) {
        value ? this._filters ? this._filters[0] = value : this._filters = [
            value
        ] : this._filters = null;
    }
    /** Resets the mask data after popMask(). */ reset() {
        this.pooled && (this.maskObject = null, this.type = (0, $0fa4b07f86297abd$export$dbbea138c5d144).NONE, this.autoDetect = !0), this._target = null, this._scissorRectLocal = null;
    }
    /**
   * Copies counters from maskData above, called from pushMask().
   * @param maskAbove
   */ copyCountersOrReset(maskAbove) {
        maskAbove ? (this._stencilCounter = maskAbove._stencilCounter, this._scissorCounter = maskAbove._scissorCounter, this._scissorRect = maskAbove._scissorRect) : (this._stencilCounter = 0, this._scissorCounter = 0, this._scissorRect = null);
    }
}


class $f42a097695a4b3c4$export$a1fbfb1b9cf60ed0 {
    /**
   * @param renderer - The renderer this System works for.
   */ constructor(renderer){
        this.renderer = renderer, this.enableScissor = !0, this.alphaMaskPool = [], this.maskDataPool = [], this.maskStack = [], this.alphaMaskIndex = 0;
    }
    /**
   * Changes the mask stack that is used by this System.
   * @param maskStack - The mask stack
   */ setMaskStack(maskStack) {
        this.maskStack = maskStack, this.renderer.scissor.setMaskStack(maskStack), this.renderer.stencil.setMaskStack(maskStack);
    }
    /**
   * Enables the mask and appends it to the current mask stack.
   *
   * NOTE: The batch renderer should be flushed beforehand to prevent pending renders from being masked.
   * @param {PIXI.DisplayObject} target - Display Object to push the mask to
   * @param {PIXI.MaskData|PIXI.Sprite|PIXI.Graphics|PIXI.DisplayObject} maskDataOrTarget - The masking data.
   */ push(target, maskDataOrTarget) {
        let maskData = maskDataOrTarget;
        if (!maskData.isMaskData) {
            const d = this.maskDataPool.pop() || new (0, $ad1418603fa0ab6f$export$c75dec3795e98612)();
            d.pooled = !0, d.maskObject = maskDataOrTarget, maskData = d;
        }
        const maskAbove = this.maskStack.length !== 0 ? this.maskStack[this.maskStack.length - 1] : null;
        if (maskData.copyCountersOrReset(maskAbove), maskData._colorMask = maskAbove ? maskAbove._colorMask : 15, maskData.autoDetect && this.detect(maskData), maskData._target = target, maskData.type !== (0, $0fa4b07f86297abd$export$dbbea138c5d144).SPRITE && this.maskStack.push(maskData), maskData.enabled) switch(maskData.type){
            case (0, $0fa4b07f86297abd$export$dbbea138c5d144).SCISSOR:
                this.renderer.scissor.push(maskData);
                break;
            case (0, $0fa4b07f86297abd$export$dbbea138c5d144).STENCIL:
                this.renderer.stencil.push(maskData);
                break;
            case (0, $0fa4b07f86297abd$export$dbbea138c5d144).SPRITE:
                maskData.copyCountersOrReset(null), this.pushSpriteMask(maskData);
                break;
            case (0, $0fa4b07f86297abd$export$dbbea138c5d144).COLOR:
                this.pushColorMask(maskData);
                break;
            default:
                break;
        }
        maskData.type === (0, $0fa4b07f86297abd$export$dbbea138c5d144).SPRITE && this.maskStack.push(maskData);
    }
    /**
   * Removes the last mask from the mask stack and doesn't return it.
   *
   * NOTE: The batch renderer should be flushed beforehand to render the masked contents before the mask is removed.
   * @param {PIXI.IMaskTarget} target - Display Object to pop the mask from
   */ pop(target) {
        const maskData = this.maskStack.pop();
        if (!(!maskData || maskData._target !== target)) {
            if (maskData.enabled) switch(maskData.type){
                case (0, $0fa4b07f86297abd$export$dbbea138c5d144).SCISSOR:
                    this.renderer.scissor.pop(maskData);
                    break;
                case (0, $0fa4b07f86297abd$export$dbbea138c5d144).STENCIL:
                    this.renderer.stencil.pop(maskData.maskObject);
                    break;
                case (0, $0fa4b07f86297abd$export$dbbea138c5d144).SPRITE:
                    this.popSpriteMask(maskData);
                    break;
                case (0, $0fa4b07f86297abd$export$dbbea138c5d144).COLOR:
                    this.popColorMask(maskData);
                    break;
                default:
                    break;
            }
            if (maskData.reset(), maskData.pooled && this.maskDataPool.push(maskData), this.maskStack.length !== 0) {
                const maskCurrent = this.maskStack[this.maskStack.length - 1];
                maskCurrent.type === (0, $0fa4b07f86297abd$export$dbbea138c5d144).SPRITE && maskCurrent._filters && (maskCurrent._filters[0].maskSprite = maskCurrent.maskObject);
            }
        }
    }
    /**
   * Sets type of MaskData based on its maskObject.
   * @param maskData
   */ detect(maskData) {
        const maskObject = maskData.maskObject;
        maskObject ? maskObject.isSprite ? maskData.type = (0, $0fa4b07f86297abd$export$dbbea138c5d144).SPRITE : this.enableScissor && this.renderer.scissor.testScissor(maskData) ? maskData.type = (0, $0fa4b07f86297abd$export$dbbea138c5d144).SCISSOR : maskData.type = (0, $0fa4b07f86297abd$export$dbbea138c5d144).STENCIL : maskData.type = (0, $0fa4b07f86297abd$export$dbbea138c5d144).COLOR;
    }
    /**
   * Applies the Mask and adds it to the current filter stack.
   * @param maskData - Sprite to be used as the mask.
   */ pushSpriteMask(maskData) {
        const { maskObject: maskObject } = maskData, target = maskData._target;
        let alphaMaskFilter = maskData._filters;
        alphaMaskFilter || (alphaMaskFilter = this.alphaMaskPool[this.alphaMaskIndex], alphaMaskFilter || (alphaMaskFilter = this.alphaMaskPool[this.alphaMaskIndex] = [
            new (0, $0a912a6cc2cd8819$export$6b66f8c14dea0d0)()
        ])), alphaMaskFilter[0].resolution = maskData.resolution, alphaMaskFilter[0].multisample = maskData.multisample, alphaMaskFilter[0].maskSprite = maskObject;
        const stashFilterArea = target.filterArea;
        target.filterArea = maskObject.getBounds(!0), this.renderer.filter.push(target, alphaMaskFilter), target.filterArea = stashFilterArea, maskData._filters || this.alphaMaskIndex++;
    }
    /**
   * Removes the last filter from the filter stack and doesn't return it.
   * @param maskData - Sprite to be used as the mask.
   */ popSpriteMask(maskData) {
        this.renderer.filter.pop(), maskData._filters ? maskData._filters[0].maskSprite = null : (this.alphaMaskIndex--, this.alphaMaskPool[this.alphaMaskIndex][0].maskSprite = null);
    }
    /**
   * Pushes the color mask.
   * @param maskData - The mask data
   */ pushColorMask(maskData) {
        const currColorMask = maskData._colorMask, nextColorMask = maskData._colorMask = currColorMask & maskData.colorMask;
        nextColorMask !== currColorMask && this.renderer.gl.colorMask((nextColorMask & 1) !== 0, (nextColorMask & 2) !== 0, (nextColorMask & 4) !== 0, (nextColorMask & 8) !== 0);
    }
    /**
   * Pops the color mask.
   * @param maskData - The mask data
   */ popColorMask(maskData) {
        const currColorMask = maskData._colorMask, nextColorMask = this.maskStack.length > 0 ? this.maskStack[this.maskStack.length - 1]._colorMask : 15;
        nextColorMask !== currColorMask && this.renderer.gl.colorMask((nextColorMask & 1) !== 0, (nextColorMask & 2) !== 0, (nextColorMask & 4) !== 0, (nextColorMask & 8) !== 0);
    }
    destroy() {
        this.renderer = null;
    }
}
$f42a097695a4b3c4$export$a1fbfb1b9cf60ed0.extension = {
    type: (0, $c90155f6d7d8d8f6$export$4f037c6ec2da4eeb).RendererSystem,
    name: "mask"
};
(0, $c90155f6d7d8d8f6$export$cc3e2d3244e01b7f).add($f42a097695a4b3c4$export$a1fbfb1b9cf60ed0);





class $4a69d129aac2dc18$export$c83199503f0366e9 {
    /**
   * @param renderer - The renderer this System works for.
   */ constructor(renderer){
        this.renderer = renderer, this.maskStack = [], this.glConst = 0;
    }
    /** Gets count of masks of certain type. */ getStackLength() {
        return this.maskStack.length;
    }
    /**
   * Changes the mask stack that is used by this System.
   * @param {PIXI.MaskData[]} maskStack - The mask stack
   */ setMaskStack(maskStack) {
        const { gl: gl } = this.renderer, curStackLen = this.getStackLength();
        this.maskStack = maskStack;
        const newStackLen = this.getStackLength();
        newStackLen !== curStackLen && (newStackLen === 0 ? gl.disable(this.glConst) : (gl.enable(this.glConst), this._useCurrent()));
    }
    /**
   * Setup renderer to use the current mask data.
   * @private
   */ _useCurrent() {}
    /** Destroys the mask stack. */ destroy() {
        this.renderer = null, this.maskStack = null;
    }
}


const $6cbbf33f26afca8d$var$tempMatrix = new (0, $d7da222aa639cde0$export$5b12bf1653c0dd85)(), $6cbbf33f26afca8d$var$rectPool = [], $6cbbf33f26afca8d$var$_ScissorSystem = class _ScissorSystem2 extends (0, $4a69d129aac2dc18$export$c83199503f0366e9) {
    /**
   * @param {PIXI.Renderer} renderer - The renderer this System works for.
   */ constructor(renderer){
        super(renderer), this.glConst = (0, $2808efac47e52be0$export$a5a6e0b888b2c992).ADAPTER.getWebGLRenderingContext().SCISSOR_TEST;
    }
    getStackLength() {
        const maskData = this.maskStack[this.maskStack.length - 1];
        return maskData ? maskData._scissorCounter : 0;
    }
    /**
   * evaluates _boundsTransformed, _scissorRect for MaskData
   * @param maskData
   */ calcScissorRect(maskData) {
        if (maskData._scissorRectLocal) return;
        const prevData = maskData._scissorRect, { maskObject: maskObject } = maskData, { renderer: renderer } = this, renderTextureSystem = renderer.renderTexture, rect = maskObject.getBounds(!0, $6cbbf33f26afca8d$var$rectPool.pop() ?? new (0, $200f778d7fdbf8ac$export$4617fb02663045ef)());
        this.roundFrameToPixels(rect, renderTextureSystem.current ? renderTextureSystem.current.resolution : renderer.resolution, renderTextureSystem.sourceFrame, renderTextureSystem.destinationFrame, renderer.projection.transform), prevData && rect.fit(prevData), maskData._scissorRectLocal = rect;
    }
    static isMatrixRotated(matrix) {
        if (!matrix) return !1;
        const { a: a, b: b, c: c, d: d } = matrix;
        return (Math.abs(b) > 1e-4 || Math.abs(c) > 1e-4) && (Math.abs(a) > 1e-4 || Math.abs(d) > 1e-4);
    }
    /**
   * Test, whether the object can be scissor mask with current renderer projection.
   * Calls "calcScissorRect()" if its true.
   * @param maskData - mask data
   * @returns whether Whether the object can be scissor mask
   */ testScissor(maskData) {
        const { maskObject: maskObject } = maskData;
        if (!maskObject.isFastRect || !maskObject.isFastRect() || _ScissorSystem2.isMatrixRotated(maskObject.worldTransform) || _ScissorSystem2.isMatrixRotated(this.renderer.projection.transform)) return !1;
        this.calcScissorRect(maskData);
        const rect = maskData._scissorRectLocal;
        return rect.width > 0 && rect.height > 0;
    }
    roundFrameToPixels(frame, resolution, bindingSourceFrame, bindingDestinationFrame, transform) {
        _ScissorSystem2.isMatrixRotated(transform) || (transform = transform ? $6cbbf33f26afca8d$var$tempMatrix.copyFrom(transform) : $6cbbf33f26afca8d$var$tempMatrix.identity(), transform.translate(-bindingSourceFrame.x, -bindingSourceFrame.y).scale(bindingDestinationFrame.width / bindingSourceFrame.width, bindingDestinationFrame.height / bindingSourceFrame.height).translate(bindingDestinationFrame.x, bindingDestinationFrame.y), this.renderer.filter.transformAABB(transform, frame), frame.fit(bindingDestinationFrame), frame.x = Math.round(frame.x * resolution), frame.y = Math.round(frame.y * resolution), frame.width = Math.round(frame.width * resolution), frame.height = Math.round(frame.height * resolution));
    }
    /**
   * Applies the Mask and adds it to the current stencil stack.
   * @author alvin
   * @param maskData - The mask data.
   */ push(maskData) {
        maskData._scissorRectLocal || this.calcScissorRect(maskData);
        const { gl: gl } = this.renderer;
        maskData._scissorRect || gl.enable(gl.SCISSOR_TEST), maskData._scissorCounter++, maskData._scissorRect = maskData._scissorRectLocal, this._useCurrent();
    }
    /**
   * This should be called after a mask is popped off the mask stack. It will rebind the scissor box to be latest with the
   * last mask in the stack.
   *
   * This can also be called when you directly modify the scissor box and want to restore PixiJS state.
   * @param maskData - The mask data.
   */ pop(maskData) {
        const { gl: gl } = this.renderer;
        maskData && $6cbbf33f26afca8d$var$rectPool.push(maskData._scissorRectLocal), this.getStackLength() > 0 ? this._useCurrent() : gl.disable(gl.SCISSOR_TEST);
    }
    /**
   * Setup renderer to use the current scissor data.
   * @private
   */ _useCurrent() {
        const rect = this.maskStack[this.maskStack.length - 1]._scissorRect;
        let y;
        this.renderer.renderTexture.current ? y = rect.y : y = this.renderer.height - rect.height - rect.y, this.renderer.gl.scissor(rect.x, y, rect.width, rect.height);
    }
};
$6cbbf33f26afca8d$var$_ScissorSystem.extension = {
    type: (0, $c90155f6d7d8d8f6$export$4f037c6ec2da4eeb).RendererSystem,
    name: "scissor"
};
let $6cbbf33f26afca8d$export$1851870585e6357f = $6cbbf33f26afca8d$var$_ScissorSystem;
(0, $c90155f6d7d8d8f6$export$cc3e2d3244e01b7f).add($6cbbf33f26afca8d$export$1851870585e6357f);





class $645cad032b0d1bb6$export$d3824b839b1639a2 extends (0, $4a69d129aac2dc18$export$c83199503f0366e9) {
    /**
   * @param renderer - The renderer this System works for.
   */ constructor(renderer){
        super(renderer), this.glConst = (0, $2808efac47e52be0$export$a5a6e0b888b2c992).ADAPTER.getWebGLRenderingContext().STENCIL_TEST;
    }
    getStackLength() {
        const maskData = this.maskStack[this.maskStack.length - 1];
        return maskData ? maskData._stencilCounter : 0;
    }
    /**
   * Applies the Mask and adds it to the current stencil stack.
   * @param maskData - The mask data
   */ push(maskData) {
        const maskObject = maskData.maskObject, { gl: gl } = this.renderer, prevMaskCount = maskData._stencilCounter;
        prevMaskCount === 0 && (this.renderer.framebuffer.forceStencil(), gl.clearStencil(0), gl.clear(gl.STENCIL_BUFFER_BIT), gl.enable(gl.STENCIL_TEST)), maskData._stencilCounter++;
        const colorMask = maskData._colorMask;
        colorMask !== 0 && (maskData._colorMask = 0, gl.colorMask(!1, !1, !1, !1)), gl.stencilFunc(gl.EQUAL, prevMaskCount, 4294967295), gl.stencilOp(gl.KEEP, gl.KEEP, gl.INCR), maskObject.renderable = !0, maskObject.render(this.renderer), this.renderer.batch.flush(), maskObject.renderable = !1, colorMask !== 0 && (maskData._colorMask = colorMask, gl.colorMask((colorMask & 1) !== 0, (colorMask & 2) !== 0, (colorMask & 4) !== 0, (colorMask & 8) !== 0)), this._useCurrent();
    }
    /**
   * Pops stencil mask. MaskData is already removed from stack
   * @param {PIXI.DisplayObject} maskObject - object of popped mask data
   */ pop(maskObject) {
        const gl = this.renderer.gl;
        if (this.getStackLength() === 0) gl.disable(gl.STENCIL_TEST);
        else {
            const maskData = this.maskStack.length !== 0 ? this.maskStack[this.maskStack.length - 1] : null, colorMask = maskData ? maskData._colorMask : 15;
            colorMask !== 0 && (maskData._colorMask = 0, gl.colorMask(!1, !1, !1, !1)), gl.stencilOp(gl.KEEP, gl.KEEP, gl.DECR), maskObject.renderable = !0, maskObject.render(this.renderer), this.renderer.batch.flush(), maskObject.renderable = !1, colorMask !== 0 && (maskData._colorMask = colorMask, gl.colorMask((colorMask & 1) !== 0, (colorMask & 2) !== 0, (colorMask & 4) !== 0, (colorMask & 8) !== 0)), this._useCurrent();
        }
    }
    /**
   * Setup renderer to use the current stencil data.
   * @private
   */ _useCurrent() {
        const gl = this.renderer.gl;
        gl.stencilFunc(gl.EQUAL, this.getStackLength(), 4294967295), gl.stencilOp(gl.KEEP, gl.KEEP, gl.KEEP);
    }
}
$645cad032b0d1bb6$export$d3824b839b1639a2.extension = {
    type: (0, $c90155f6d7d8d8f6$export$4f037c6ec2da4eeb).RendererSystem,
    name: "stencil"
};
(0, $c90155f6d7d8d8f6$export$cc3e2d3244e01b7f).add($645cad032b0d1bb6$export$d3824b839b1639a2);




class $1d046bd4bc00e09f$export$b037d01b38347d8b {
    constructor(renderer){
        this.renderer = renderer, this.plugins = {}, Object.defineProperties(this.plugins, {
            extract: {
                enumerable: !1,
                get () {
                    return (0, $397b7871568e248b$export$afd31d834b512e89)("7.0.0", "renderer.plugins.extract has moved to renderer.extract"), renderer.extract;
                }
            },
            prepare: {
                enumerable: !1,
                get () {
                    return (0, $397b7871568e248b$export$afd31d834b512e89)("7.0.0", "renderer.plugins.prepare has moved to renderer.prepare"), renderer.prepare;
                }
            },
            interaction: {
                enumerable: !1,
                get () {
                    return (0, $397b7871568e248b$export$afd31d834b512e89)("7.0.0", "renderer.plugins.interaction has been deprecated, use renderer.events"), renderer.events;
                }
            }
        });
    }
    /**
   * Initialize the plugins.
   * @protected
   */ init() {
        const staticMap = this.rendererPlugins;
        for(const o in staticMap)this.plugins[o] = new staticMap[o](this.renderer);
    }
    destroy() {
        for(const o in this.plugins)this.plugins[o].destroy(), this.plugins[o] = null;
    }
}
$1d046bd4bc00e09f$export$b037d01b38347d8b.extension = {
    type: [
        (0, $c90155f6d7d8d8f6$export$4f037c6ec2da4eeb).RendererSystem,
        (0, $c90155f6d7d8d8f6$export$4f037c6ec2da4eeb).CanvasRendererSystem
    ],
    name: "_plugin"
};
(0, $c90155f6d7d8d8f6$export$cc3e2d3244e01b7f).add($1d046bd4bc00e09f$export$b037d01b38347d8b);




class $94839b1055c6c665$export$84be2be6fb3066d2 {
    /** @param renderer - The renderer this System works for. */ constructor(renderer){
        this.renderer = renderer, this.destinationFrame = null, this.sourceFrame = null, this.defaultFrame = null, this.projectionMatrix = new (0, $d7da222aa639cde0$export$5b12bf1653c0dd85)(), this.transform = null;
    }
    /**
   * Updates the projection-matrix based on the sourceFrame → destinationFrame mapping provided.
   *
   * NOTE: It is expected you call `renderer.framebuffer.setViewport(destinationFrame)` after this. This is because
   * the framebuffer viewport converts shader vertex output in normalized device coordinates to window coordinates.
   *
   * NOTE-2: {@link PIXI.RenderTextureSystem#bind} updates the projection-matrix when you bind a render-texture.
   * It is expected
   * that you dirty the current bindings when calling this manually.
   * @param destinationFrame - The rectangle in the render-target to render the contents into. If rendering to the canvas,
   *  the origin is on the top-left; if rendering to a render-texture, the origin is on the bottom-left.
   * @param sourceFrame - The rectangle in world space that contains the contents being rendered.
   * @param resolution - The resolution of the render-target, which is the ratio of
   *  world-space (or CSS) pixels to physical pixels.
   * @param root - Whether the render-target is the screen. This is required because rendering to textures
   *  is y-flipped (i.e. upside down relative to the screen).
   */ update(destinationFrame, sourceFrame, resolution, root) {
        this.destinationFrame = destinationFrame || this.destinationFrame || this.defaultFrame, this.sourceFrame = sourceFrame || this.sourceFrame || destinationFrame, this.calculateProjection(this.destinationFrame, this.sourceFrame, resolution, root), this.transform && this.projectionMatrix.append(this.transform);
        const renderer = this.renderer;
        renderer.globalUniforms.uniforms.projectionMatrix = this.projectionMatrix, renderer.globalUniforms.update(), renderer.shader.shader && renderer.shader.syncUniformGroup(renderer.shader.shader.uniforms.globals);
    }
    /**
   * Calculates the `projectionMatrix` to map points inside `sourceFrame` to inside `destinationFrame`.
   * @param _destinationFrame - The destination frame in the render-target.
   * @param sourceFrame - The source frame in world space.
   * @param _resolution - The render-target's resolution, i.e. ratio of CSS to physical pixels.
   * @param root - Whether rendering into the screen. Otherwise, if rendering to a framebuffer, the projection
   *  is y-flipped.
   */ calculateProjection(_destinationFrame, sourceFrame, _resolution, root) {
        const pm = this.projectionMatrix, sign = root ? -1 : 1;
        pm.identity(), pm.a = 1 / sourceFrame.width * 2, pm.d = sign * (1 / sourceFrame.height * 2), pm.tx = -1 - sourceFrame.x * pm.a, pm.ty = -sign - sourceFrame.y * pm.d;
    }
    /**
   * Sets the transform of the active render target to the given matrix.
   * @param _matrix - The transformation matrix
   */ setTransform(_matrix) {}
    destroy() {
        this.renderer = null;
    }
}
$94839b1055c6c665$export$84be2be6fb3066d2.extension = {
    type: (0, $c90155f6d7d8d8f6$export$4f037c6ec2da4eeb).RendererSystem,
    name: "projection"
};
(0, $c90155f6d7d8d8f6$export$cc3e2d3244e01b7f).add($94839b1055c6c665$export$84be2be6fb3066d2);





const $1c8d5efea6dc6da4$var$tempTransform = new (0, $cec25acf758d963f$export$563a914cafbdc389)(), $1c8d5efea6dc6da4$var$tempRect = new (0, $200f778d7fdbf8ac$export$4617fb02663045ef)();
class $1c8d5efea6dc6da4$export$690776504ee197a6 {
    constructor(renderer){
        this.renderer = renderer, this._tempMatrix = new (0, $d7da222aa639cde0$export$5b12bf1653c0dd85)();
    }
    /**
   * A Useful function that returns a texture of the display object that can then be used to create sprites
   * This can be quite useful if your displayObject is complicated and needs to be reused multiple times.
   * @param displayObject - The displayObject the object will be generated from.
   * @param {IGenerateTextureOptions} options - Generate texture options.
   * @param {PIXI.Rectangle} options.region - The region of the displayObject, that shall be rendered,
   *        if no region is specified, defaults to the local bounds of the displayObject.
   * @param {number} [options.resolution] - If not given, the renderer's resolution is used.
   * @param {PIXI.MSAA_QUALITY} [options.multisample] - If not given, the renderer's multisample is used.
   * @returns a shiny new texture of the display object passed in
   */ generateTexture(displayObject, options) {
        const { region: manualRegion, ...textureOptions } = options || {}, region = manualRegion?.copyTo($1c8d5efea6dc6da4$var$tempRect) || displayObject.getLocalBounds($1c8d5efea6dc6da4$var$tempRect, !0), resolution = textureOptions.resolution || this.renderer.resolution;
        region.width = Math.max(region.width, 1 / resolution), region.height = Math.max(region.height, 1 / resolution), textureOptions.width = region.width, textureOptions.height = region.height, textureOptions.resolution = resolution, textureOptions.multisample ?? (textureOptions.multisample = this.renderer.multisample);
        const renderTexture = (0, $f917e2bbb9b65ecb$export$813984f7330b4d72).create(textureOptions);
        this._tempMatrix.tx = -region.x, this._tempMatrix.ty = -region.y;
        const transform = displayObject.transform;
        return displayObject.transform = $1c8d5efea6dc6da4$var$tempTransform, this.renderer.render(displayObject, {
            renderTexture: renderTexture,
            transform: this._tempMatrix,
            skipUpdateTransform: !!displayObject.parent,
            blit: !0
        }), displayObject.transform = transform, renderTexture;
    }
    destroy() {}
}
$1c8d5efea6dc6da4$export$690776504ee197a6.extension = {
    type: [
        (0, $c90155f6d7d8d8f6$export$4f037c6ec2da4eeb).RendererSystem,
        (0, $c90155f6d7d8d8f6$export$4f037c6ec2da4eeb).CanvasRendererSystem
    ],
    name: "textureGenerator"
};
(0, $c90155f6d7d8d8f6$export$cc3e2d3244e01b7f).add($1c8d5efea6dc6da4$export$690776504ee197a6);





const $a4f7f2fb177fc7b2$var$tempRect = new (0, $200f778d7fdbf8ac$export$4617fb02663045ef)(), $a4f7f2fb177fc7b2$var$tempRect2 = new (0, $200f778d7fdbf8ac$export$4617fb02663045ef)();
class $a4f7f2fb177fc7b2$export$5fd756363f54136f {
    /**
   * @param renderer - The renderer this System works for.
   */ constructor(renderer){
        this.renderer = renderer, this.defaultMaskStack = [], this.current = null, this.sourceFrame = new (0, $200f778d7fdbf8ac$export$4617fb02663045ef)(), this.destinationFrame = new (0, $200f778d7fdbf8ac$export$4617fb02663045ef)(), this.viewportFrame = new (0, $200f778d7fdbf8ac$export$4617fb02663045ef)();
    }
    contextChange() {
        const attributes = this.renderer?.gl.getContextAttributes();
        this._rendererPremultipliedAlpha = !!(attributes && attributes.alpha && attributes.premultipliedAlpha);
    }
    /**
   * Bind the current render texture.
   * @param renderTexture - RenderTexture to bind, by default its `null` - the screen.
   * @param sourceFrame - Part of world that is mapped to the renderTexture.
   * @param destinationFrame - Part of renderTexture, by default it has the same size as sourceFrame.
   */ bind(renderTexture = null, sourceFrame, destinationFrame) {
        const renderer = this.renderer;
        this.current = renderTexture;
        let baseTexture, framebuffer, resolution;
        renderTexture ? (baseTexture = renderTexture.baseTexture, resolution = baseTexture.resolution, sourceFrame || ($a4f7f2fb177fc7b2$var$tempRect.width = renderTexture.frame.width, $a4f7f2fb177fc7b2$var$tempRect.height = renderTexture.frame.height, sourceFrame = $a4f7f2fb177fc7b2$var$tempRect), destinationFrame || ($a4f7f2fb177fc7b2$var$tempRect2.x = renderTexture.frame.x, $a4f7f2fb177fc7b2$var$tempRect2.y = renderTexture.frame.y, $a4f7f2fb177fc7b2$var$tempRect2.width = sourceFrame.width, $a4f7f2fb177fc7b2$var$tempRect2.height = sourceFrame.height, destinationFrame = $a4f7f2fb177fc7b2$var$tempRect2), framebuffer = baseTexture.framebuffer) : (resolution = renderer.resolution, sourceFrame || ($a4f7f2fb177fc7b2$var$tempRect.width = renderer._view.screen.width, $a4f7f2fb177fc7b2$var$tempRect.height = renderer._view.screen.height, sourceFrame = $a4f7f2fb177fc7b2$var$tempRect), destinationFrame || (destinationFrame = $a4f7f2fb177fc7b2$var$tempRect, destinationFrame.width = sourceFrame.width, destinationFrame.height = sourceFrame.height));
        const viewportFrame = this.viewportFrame;
        viewportFrame.x = destinationFrame.x * resolution, viewportFrame.y = destinationFrame.y * resolution, viewportFrame.width = destinationFrame.width * resolution, viewportFrame.height = destinationFrame.height * resolution, renderTexture || (viewportFrame.y = renderer.view.height - (viewportFrame.y + viewportFrame.height)), viewportFrame.ceil(), this.renderer.framebuffer.bind(framebuffer, viewportFrame), this.renderer.projection.update(destinationFrame, sourceFrame, resolution, !framebuffer), renderTexture ? this.renderer.mask.setMaskStack(baseTexture.maskStack) : this.renderer.mask.setMaskStack(this.defaultMaskStack), this.sourceFrame.copyFrom(sourceFrame), this.destinationFrame.copyFrom(destinationFrame);
    }
    /**
   * Erases the render texture and fills the drawing area with a colour.
   * @param clearColor - The color as rgba, default to use the renderer backgroundColor
   * @param [mask=BUFFER_BITS.COLOR | BUFFER_BITS.DEPTH] - Bitwise OR of masks
   *  that indicate the buffers to be cleared, by default COLOR and DEPTH buffers.
   */ clear(clearColor, mask) {
        const fallbackColor = this.current ? this.current.baseTexture.clear : this.renderer.background.backgroundColor, color = (0, $15154c33c9e19c5f$export$892596cec99bc70e).shared.setValue(clearColor || fallbackColor);
        (this.current && this.current.baseTexture.alphaMode > 0 || !this.current && this._rendererPremultipliedAlpha) && color.premultiply(color.alpha);
        const destinationFrame = this.destinationFrame, baseFrame = this.current ? this.current.baseTexture : this.renderer._view.screen, clearMask = destinationFrame.width !== baseFrame.width || destinationFrame.height !== baseFrame.height;
        if (clearMask) {
            let { x: x, y: y, width: width, height: height } = this.viewportFrame;
            x = Math.round(x), y = Math.round(y), width = Math.round(width), height = Math.round(height), this.renderer.gl.enable(this.renderer.gl.SCISSOR_TEST), this.renderer.gl.scissor(x, y, width, height);
        }
        this.renderer.framebuffer.clear(color.red, color.green, color.blue, color.alpha, mask), clearMask && this.renderer.scissor.pop();
    }
    resize() {
        this.bind(null);
    }
    /** Resets render-texture state. */ reset() {
        this.bind(null);
    }
    destroy() {
        this.renderer = null;
    }
}
$a4f7f2fb177fc7b2$export$5fd756363f54136f.extension = {
    type: (0, $c90155f6d7d8d8f6$export$4f037c6ec2da4eeb).RendererSystem,
    name: "renderTexture"
};
(0, $c90155f6d7d8d8f6$export$cc3e2d3244e01b7f).add($a4f7f2fb177fc7b2$export$5fd756363f54136f);




class $82d54650eccaccb6$export$181be621ce68aec5 {
}
class $82d54650eccaccb6$export$bf1479c8ce91afd5 {
    /**
   * Makes a new Pixi program.
   * @param program - webgl program
   * @param uniformData - uniforms
   */ constructor(program, uniformData){
        this.program = program, this.uniformData = uniformData, this.uniformGroups = {}, this.uniformDirtyGroups = {}, this.uniformBufferBindings = {};
    }
    /** Destroys this program. */ destroy() {
        this.uniformData = null, this.uniformGroups = null, this.uniformDirtyGroups = null, this.uniformBufferBindings = null, this.program = null;
    }
}






function $c77c2e80e6af2962$export$c73f9ceeec70bdfb(program, gl) {
    const attributes = {}, totalAttributes = gl.getProgramParameter(program, gl.ACTIVE_ATTRIBUTES);
    for(let i = 0; i < totalAttributes; i++){
        const attribData = gl.getActiveAttrib(program, i);
        if (attribData.name.startsWith("gl_")) continue;
        const type = (0, $c37a6ad59f55be3a$export$4de3a94418d86ca7)(gl, attribData.type), data = {
            type: type,
            name: attribData.name,
            size: (0, $df51d09379e4c904$export$50ee69a11aa2abdb)(type),
            location: gl.getAttribLocation(program, attribData.name)
        };
        attributes[attribData.name] = data;
    }
    return attributes;
}




function $ee4e31cd88e5f56d$export$d38fd6033d9429a5(program, gl) {
    const uniforms = {}, totalUniforms = gl.getProgramParameter(program, gl.ACTIVE_UNIFORMS);
    for(let i = 0; i < totalUniforms; i++){
        const uniformData = gl.getActiveUniform(program, i), name = uniformData.name.replace(/\[.*?\]$/, ""), isArray = !!uniformData.name.match(/\[.*?\]$/), type = (0, $c37a6ad59f55be3a$export$4de3a94418d86ca7)(gl, uniformData.type);
        uniforms[name] = {
            name: name,
            index: i,
            type: type,
            size: uniformData.size,
            isArray: isArray,
            value: (0, $09c91f51b342cc6b$export$1a01ae0705bafd37)(type, uniformData.size)
        };
    }
    return uniforms;
}



function $4f2e9093dbf7da08$export$44c84e8c8e54bce9(gl, program) {
    const glVertShader = (0, $59b0b09c05c49ae6$export$9b5304f4eb007cf0)(gl, gl.VERTEX_SHADER, program.vertexSrc), glFragShader = (0, $59b0b09c05c49ae6$export$9b5304f4eb007cf0)(gl, gl.FRAGMENT_SHADER, program.fragmentSrc), webGLProgram = gl.createProgram();
    gl.attachShader(webGLProgram, glVertShader), gl.attachShader(webGLProgram, glFragShader);
    const transformFeedbackVaryings = program.extra?.transformFeedbackVaryings;
    if (transformFeedbackVaryings && (typeof gl.transformFeedbackVaryings != "function" ? console.warn("TransformFeedback is not supported but TransformFeedbackVaryings are given.") : gl.transformFeedbackVaryings(webGLProgram, transformFeedbackVaryings.names, transformFeedbackVaryings.bufferMode === "separate" ? gl.SEPARATE_ATTRIBS : gl.INTERLEAVED_ATTRIBS)), gl.linkProgram(webGLProgram), gl.getProgramParameter(webGLProgram, gl.LINK_STATUS) || (0, $d440399e6b055e40$export$4b35d6c62dc992b0)(gl, webGLProgram, glVertShader, glFragShader), program.attributeData = (0, $c77c2e80e6af2962$export$c73f9ceeec70bdfb)(webGLProgram, gl), program.uniformData = (0, $ee4e31cd88e5f56d$export$d38fd6033d9429a5)(webGLProgram, gl), !/^[ \t]*#[ \t]*version[ \t]+300[ \t]+es[ \t]*$/m.test(program.vertexSrc)) {
        const keys = Object.keys(program.attributeData);
        keys.sort((a, b)=>a > b ? 1 : -1);
        for(let i = 0; i < keys.length; i++)program.attributeData[keys[i]].location = i, gl.bindAttribLocation(webGLProgram, i, keys[i]);
        gl.linkProgram(webGLProgram);
    }
    gl.deleteShader(glVertShader), gl.deleteShader(glFragShader);
    const uniformData = {};
    for(const i in program.uniformData){
        const data = program.uniformData[i];
        uniformData[i] = {
            location: gl.getUniformLocation(webGLProgram, i),
            value: (0, $09c91f51b342cc6b$export$1a01ae0705bafd37)(data.type, data.size)
        };
    }
    return new (0, $82d54650eccaccb6$export$bf1479c8ce91afd5)(webGLProgram, uniformData);
}





function $0eeb1ff219909dd2$var$uboUpdate(_ud, _uv, _renderer, _syncData, buffer) {
    _renderer.buffer.update(buffer);
}
const $0eeb1ff219909dd2$var$UBO_TO_SINGLE_SETTERS = {
    float: `
        data[offset] = v;
    `,
    vec2: `
        data[offset] = v[0];
        data[offset+1] = v[1];
    `,
    vec3: `
        data[offset] = v[0];
        data[offset+1] = v[1];
        data[offset+2] = v[2];

    `,
    vec4: `
        data[offset] = v[0];
        data[offset+1] = v[1];
        data[offset+2] = v[2];
        data[offset+3] = v[3];
    `,
    mat2: `
        data[offset] = v[0];
        data[offset+1] = v[1];

        data[offset+4] = v[2];
        data[offset+5] = v[3];
    `,
    mat3: `
        data[offset] = v[0];
        data[offset+1] = v[1];
        data[offset+2] = v[2];

        data[offset + 4] = v[3];
        data[offset + 5] = v[4];
        data[offset + 6] = v[5];

        data[offset + 8] = v[6];
        data[offset + 9] = v[7];
        data[offset + 10] = v[8];
    `,
    mat4: `
        for(var i = 0; i < 16; i++)
        {
            data[offset + i] = v[i];
        }
    `
}, $0eeb1ff219909dd2$var$GLSL_TO_STD40_SIZE = {
    float: 4,
    vec2: 8,
    vec3: 12,
    vec4: 16,
    int: 4,
    ivec2: 8,
    ivec3: 12,
    ivec4: 16,
    uint: 4,
    uvec2: 8,
    uvec3: 12,
    uvec4: 16,
    bool: 4,
    bvec2: 8,
    bvec3: 12,
    bvec4: 16,
    mat2: 32,
    mat3: 48,
    mat4: 64
};
function $0eeb1ff219909dd2$export$3c4fb828fecb3ead(uniformData) {
    const uboElements = uniformData.map((data)=>({
            data: data,
            offset: 0,
            dataLen: 0,
            dirty: 0
        }));
    let size = 0, chunkSize = 0, offset = 0;
    for(let i = 0; i < uboElements.length; i++){
        const uboElement = uboElements[i];
        if (size = $0eeb1ff219909dd2$var$GLSL_TO_STD40_SIZE[uboElement.data.type], uboElement.data.size > 1 && (size = Math.max(size, 16) * uboElement.data.size), uboElement.dataLen = size, chunkSize % size !== 0 && chunkSize < 16) {
            const lineUpValue = chunkSize % size % 16;
            chunkSize += lineUpValue, offset += lineUpValue;
        }
        chunkSize + size > 16 ? (offset = Math.ceil(offset / 16) * 16, uboElement.offset = offset, offset += size, chunkSize = size) : (uboElement.offset = offset, chunkSize += size, offset += size);
    }
    return offset = Math.ceil(offset / 16) * 16, {
        uboElements: uboElements,
        size: offset
    };
}
function $0eeb1ff219909dd2$export$56f32278ebf30ea0(uniforms, uniformData) {
    const usedUniformDatas = [];
    for(const i in uniforms)uniformData[i] && usedUniformDatas.push(uniformData[i]);
    return usedUniformDatas.sort((a, b)=>a.index - b.index), usedUniformDatas;
}
function $0eeb1ff219909dd2$export$39fbc1d5b3f112e4(group, uniformData) {
    if (!group.autoManage) return {
        size: 0,
        syncFunc: $0eeb1ff219909dd2$var$uboUpdate
    };
    const usedUniformDatas = $0eeb1ff219909dd2$export$56f32278ebf30ea0(group.uniforms, uniformData), { uboElements: uboElements, size: size } = $0eeb1ff219909dd2$export$3c4fb828fecb3ead(usedUniformDatas), funcFragments = [
        `
    var v = null;
    var v2 = null;
    var cv = null;
    var t = 0;
    var gl = renderer.gl
    var index = 0;
    var data = buffer.data;
    `
    ];
    for(let i = 0; i < uboElements.length; i++){
        const uboElement = uboElements[i], uniform = group.uniforms[uboElement.data.name], name = uboElement.data.name;
        let parsed = !1;
        for(let j = 0; j < (0, $2fc9b1ca00707202$export$cf9f41a7e506e2d2).length; j++){
            const uniformParser = (0, $2fc9b1ca00707202$export$cf9f41a7e506e2d2)[j];
            if (uniformParser.codeUbo && uniformParser.test(uboElement.data, uniform)) {
                funcFragments.push(`offset = ${uboElement.offset / 4};`, (0, $2fc9b1ca00707202$export$cf9f41a7e506e2d2)[j].codeUbo(uboElement.data.name, uniform)), parsed = !0;
                break;
            }
        }
        if (!parsed) {
            if (uboElement.data.size > 1) {
                const size2 = (0, $df51d09379e4c904$export$50ee69a11aa2abdb)(uboElement.data.type), rowSize = Math.max($0eeb1ff219909dd2$var$GLSL_TO_STD40_SIZE[uboElement.data.type] / 16, 1), elementSize = size2 / rowSize, remainder = (4 - elementSize % 4) % 4;
                funcFragments.push(`
                cv = ud.${name}.value;
                v = uv.${name};
                offset = ${uboElement.offset / 4};

                t = 0;

                for(var i=0; i < ${uboElement.data.size * rowSize}; i++)
                {
                    for(var j = 0; j < ${elementSize}; j++)
                    {
                        data[offset++] = v[t++];
                    }
                    offset += ${remainder};
                }

                `);
            } else {
                const template = $0eeb1ff219909dd2$var$UBO_TO_SINGLE_SETTERS[uboElement.data.type];
                funcFragments.push(`
                cv = ud.${name}.value;
                v = uv.${name};
                offset = ${uboElement.offset / 4};
                ${template};
                `);
            }
        }
    }
    return funcFragments.push(`
       renderer.buffer.update(buffer);
    `), {
        size: size,
        // eslint-disable-next-line no-new-func
        syncFunc: new Function("ud", "uv", "renderer", "syncData", "buffer", funcFragments.join(`
`))
    };
}




let $e493f55cb4cfdb61$var$UID = 0;
const $e493f55cb4cfdb61$var$defaultSyncData = {
    textureCount: 0,
    uboCount: 0
};
class $e493f55cb4cfdb61$export$d91933f5c44096f4 {
    /** @param renderer - The renderer this System works for. */ constructor(renderer){
        this.destroyed = !1, this.renderer = renderer, this.systemCheck(), this.gl = null, this.shader = null, this.program = null, this.cache = {}, this._uboCache = {}, this.id = $e493f55cb4cfdb61$var$UID++;
    }
    /**
   * Overrideable function by `@pixi/unsafe-eval` to silence
   * throwing an error if platform doesn't support unsafe-evals.
   * @private
   */ systemCheck() {
        if (!(0, $21bdc6701a9d9b85$export$70c0711f29adc5cf)()) throw new Error("Current environment does not allow unsafe-eval, please use @pixi/unsafe-eval module to enable support.");
    }
    contextChange(gl) {
        this.gl = gl, this.reset();
    }
    /**
   * Changes the current shader to the one given in parameter.
   * @param shader - the new shader
   * @param dontSync - false if the shader should automatically sync its uniforms.
   * @returns the glProgram that belongs to the shader.
   */ bind(shader, dontSync) {
        shader.disposeRunner.add(this), shader.uniforms.globals = this.renderer.globalUniforms;
        const program = shader.program, glProgram = program.glPrograms[this.renderer.CONTEXT_UID] || this.generateProgram(shader);
        return this.shader = shader, this.program !== program && (this.program = program, this.gl.useProgram(glProgram.program)), dontSync || ($e493f55cb4cfdb61$var$defaultSyncData.textureCount = 0, $e493f55cb4cfdb61$var$defaultSyncData.uboCount = 0, this.syncUniformGroup(shader.uniformGroup, $e493f55cb4cfdb61$var$defaultSyncData)), glProgram;
    }
    /**
   * Uploads the uniforms values to the currently bound shader.
   * @param uniforms - the uniforms values that be applied to the current shader
   */ setUniforms(uniforms) {
        const shader = this.shader.program, glProgram = shader.glPrograms[this.renderer.CONTEXT_UID];
        shader.syncUniforms(glProgram.uniformData, uniforms, this.renderer);
    }
    /* eslint-disable @typescript-eslint/explicit-module-boundary-types */ /**
   * Syncs uniforms on the group
   * @param group - the uniform group to sync
   * @param syncData - this is data that is passed to the sync function and any nested sync functions
   */ syncUniformGroup(group, syncData) {
        const glProgram = this.getGlProgram();
        (!group.static || group.dirtyId !== glProgram.uniformDirtyGroups[group.id]) && (glProgram.uniformDirtyGroups[group.id] = group.dirtyId, this.syncUniforms(group, glProgram, syncData));
    }
    /**
   * Overrideable by the @pixi/unsafe-eval package to use static syncUniforms instead.
   * @param group
   * @param glProgram
   * @param syncData
   */ syncUniforms(group, glProgram, syncData) {
        (group.syncUniforms[this.shader.program.id] || this.createSyncGroups(group))(glProgram.uniformData, group.uniforms, this.renderer, syncData);
    }
    createSyncGroups(group) {
        const id = this.getSignature(group, this.shader.program.uniformData, "u");
        return this.cache[id] || (this.cache[id] = (0, $3db0a94081cf75de$export$20c95d1c2d5a6828)(group, this.shader.program.uniformData)), group.syncUniforms[this.shader.program.id] = this.cache[id], group.syncUniforms[this.shader.program.id];
    }
    /**
   * Syncs uniform buffers
   * @param group - the uniform buffer group to sync
   * @param name - the name of the uniform buffer
   */ syncUniformBufferGroup(group, name) {
        const glProgram = this.getGlProgram();
        if (!group.static || group.dirtyId !== 0 || !glProgram.uniformGroups[group.id]) {
            group.dirtyId = 0;
            const syncFunc = glProgram.uniformGroups[group.id] || this.createSyncBufferGroup(group, glProgram, name);
            group.buffer.update(), syncFunc(glProgram.uniformData, group.uniforms, this.renderer, $e493f55cb4cfdb61$var$defaultSyncData, group.buffer);
        }
        this.renderer.buffer.bindBufferBase(group.buffer, glProgram.uniformBufferBindings[name]);
    }
    /**
   * Will create a function that uploads a uniform buffer using the STD140 standard.
   * The upload function will then be cached for future calls
   * If a group is manually managed, then a simple upload function is generated
   * @param group - the uniform buffer group to sync
   * @param glProgram - the gl program to attach the uniform bindings to
   * @param name - the name of the uniform buffer (must exist on the shader)
   */ createSyncBufferGroup(group, glProgram, name) {
        const { gl: gl } = this.renderer;
        this.renderer.buffer.bind(group.buffer);
        const uniformBlockIndex = this.gl.getUniformBlockIndex(glProgram.program, name);
        glProgram.uniformBufferBindings[name] = this.shader.uniformBindCount, gl.uniformBlockBinding(glProgram.program, uniformBlockIndex, this.shader.uniformBindCount), this.shader.uniformBindCount++;
        const id = this.getSignature(group, this.shader.program.uniformData, "ubo");
        let uboData = this._uboCache[id];
        if (uboData || (uboData = this._uboCache[id] = (0, $0eeb1ff219909dd2$export$39fbc1d5b3f112e4)(group, this.shader.program.uniformData)), group.autoManage) {
            const data = new Float32Array(uboData.size / 4);
            group.buffer.update(data);
        }
        return glProgram.uniformGroups[group.id] = uboData.syncFunc, glProgram.uniformGroups[group.id];
    }
    /**
   * Takes a uniform group and data and generates a unique signature for them.
   * @param group - The uniform group to get signature of
   * @param group.uniforms
   * @param uniformData - Uniform information generated by the shader
   * @param preFix
   * @returns Unique signature of the uniform group
   */ getSignature(group, uniformData, preFix) {
        const uniforms = group.uniforms, strings = [
            `${preFix}-`
        ];
        for(const i in uniforms)strings.push(i), uniformData[i] && strings.push(uniformData[i].type);
        return strings.join("-");
    }
    /**
   * Returns the underlying GLShade rof the currently bound shader.
   *
   * This can be handy for when you to have a little more control over the setting of your uniforms.
   * @returns The glProgram for the currently bound Shader for this context
   */ getGlProgram() {
        return this.shader ? this.shader.program.glPrograms[this.renderer.CONTEXT_UID] : null;
    }
    /**
   * Generates a glProgram version of the Shader provided.
   * @param shader - The shader that the glProgram will be based on.
   * @returns A shiny new glProgram!
   */ generateProgram(shader) {
        const gl = this.gl, program = shader.program, glProgram = (0, $4f2e9093dbf7da08$export$44c84e8c8e54bce9)(gl, program);
        return program.glPrograms[this.renderer.CONTEXT_UID] = glProgram, glProgram;
    }
    /** Resets ShaderSystem state, does not affect WebGL state. */ reset() {
        this.program = null, this.shader = null;
    }
    /**
   * Disposes shader.
   * If disposing one equals with current shader, set current as null.
   * @param shader - Shader object
   */ disposeShader(shader) {
        this.shader === shader && (this.shader = null);
    }
    /** Destroys this System and removes all its textures. */ destroy() {
        this.renderer = null, this.destroyed = !0;
    }
}
$e493f55cb4cfdb61$export$d91933f5c44096f4.extension = {
    type: (0, $c90155f6d7d8d8f6$export$4f037c6ec2da4eeb).RendererSystem,
    name: "shader"
};
(0, $c90155f6d7d8d8f6$export$cc3e2d3244e01b7f).add($e493f55cb4cfdb61$export$d91933f5c44096f4);



class $418379c9781d33ac$export$8b298d2bda604a05 {
    constructor(renderer){
        this.renderer = renderer;
    }
    /**
   * It all starts here! This initiates every system, passing in the options for any system by name.
   * @param options - the config for the renderer and all its systems
   */ run(options) {
        const { renderer: renderer } = this;
        renderer.runners.init.emit(renderer.options), options.hello && console.log(`PixiJS 7.3.1 - ${renderer.rendererLogId} - https://pixijs.com`), renderer.resize(renderer.screen.width, renderer.screen.height);
    }
    destroy() {}
}
$418379c9781d33ac$export$8b298d2bda604a05.defaultOptions = {
    /**
   * {@link PIXI.IRendererOptions.hello}
   * @default false
   * @memberof PIXI.settings.RENDER_OPTIONS
   */ hello: !1
}, /** @ignore */ $418379c9781d33ac$export$8b298d2bda604a05.extension = {
    type: [
        (0, $c90155f6d7d8d8f6$export$4f037c6ec2da4eeb).RendererSystem,
        (0, $c90155f6d7d8d8f6$export$4f037c6ec2da4eeb).CanvasRendererSystem
    ],
    name: "startup"
};
(0, $c90155f6d7d8d8f6$export$cc3e2d3244e01b7f).add($418379c9781d33ac$export$8b298d2bda604a05);






function $b0455dc13f2a356c$export$57ed86928a8d2aa1(gl, array = []) {
    return array[(0, $0fa4b07f86297abd$export$f821c68fe9beaecf).NORMAL] = [
        gl.ONE,
        gl.ONE_MINUS_SRC_ALPHA
    ], array[(0, $0fa4b07f86297abd$export$f821c68fe9beaecf).ADD] = [
        gl.ONE,
        gl.ONE
    ], array[(0, $0fa4b07f86297abd$export$f821c68fe9beaecf).MULTIPLY] = [
        gl.DST_COLOR,
        gl.ONE_MINUS_SRC_ALPHA,
        gl.ONE,
        gl.ONE_MINUS_SRC_ALPHA
    ], array[(0, $0fa4b07f86297abd$export$f821c68fe9beaecf).SCREEN] = [
        gl.ONE,
        gl.ONE_MINUS_SRC_COLOR,
        gl.ONE,
        gl.ONE_MINUS_SRC_ALPHA
    ], array[(0, $0fa4b07f86297abd$export$f821c68fe9beaecf).OVERLAY] = [
        gl.ONE,
        gl.ONE_MINUS_SRC_ALPHA
    ], array[(0, $0fa4b07f86297abd$export$f821c68fe9beaecf).DARKEN] = [
        gl.ONE,
        gl.ONE_MINUS_SRC_ALPHA
    ], array[(0, $0fa4b07f86297abd$export$f821c68fe9beaecf).LIGHTEN] = [
        gl.ONE,
        gl.ONE_MINUS_SRC_ALPHA
    ], array[(0, $0fa4b07f86297abd$export$f821c68fe9beaecf).COLOR_DODGE] = [
        gl.ONE,
        gl.ONE_MINUS_SRC_ALPHA
    ], array[(0, $0fa4b07f86297abd$export$f821c68fe9beaecf).COLOR_BURN] = [
        gl.ONE,
        gl.ONE_MINUS_SRC_ALPHA
    ], array[(0, $0fa4b07f86297abd$export$f821c68fe9beaecf).HARD_LIGHT] = [
        gl.ONE,
        gl.ONE_MINUS_SRC_ALPHA
    ], array[(0, $0fa4b07f86297abd$export$f821c68fe9beaecf).SOFT_LIGHT] = [
        gl.ONE,
        gl.ONE_MINUS_SRC_ALPHA
    ], array[(0, $0fa4b07f86297abd$export$f821c68fe9beaecf).DIFFERENCE] = [
        gl.ONE,
        gl.ONE_MINUS_SRC_ALPHA
    ], array[(0, $0fa4b07f86297abd$export$f821c68fe9beaecf).EXCLUSION] = [
        gl.ONE,
        gl.ONE_MINUS_SRC_ALPHA
    ], array[(0, $0fa4b07f86297abd$export$f821c68fe9beaecf).HUE] = [
        gl.ONE,
        gl.ONE_MINUS_SRC_ALPHA
    ], array[(0, $0fa4b07f86297abd$export$f821c68fe9beaecf).SATURATION] = [
        gl.ONE,
        gl.ONE_MINUS_SRC_ALPHA
    ], array[(0, $0fa4b07f86297abd$export$f821c68fe9beaecf).COLOR] = [
        gl.ONE,
        gl.ONE_MINUS_SRC_ALPHA
    ], array[(0, $0fa4b07f86297abd$export$f821c68fe9beaecf).LUMINOSITY] = [
        gl.ONE,
        gl.ONE_MINUS_SRC_ALPHA
    ], array[(0, $0fa4b07f86297abd$export$f821c68fe9beaecf).NONE] = [
        0,
        0
    ], array[(0, $0fa4b07f86297abd$export$f821c68fe9beaecf).NORMAL_NPM] = [
        gl.SRC_ALPHA,
        gl.ONE_MINUS_SRC_ALPHA,
        gl.ONE,
        gl.ONE_MINUS_SRC_ALPHA
    ], array[(0, $0fa4b07f86297abd$export$f821c68fe9beaecf).ADD_NPM] = [
        gl.SRC_ALPHA,
        gl.ONE,
        gl.ONE,
        gl.ONE
    ], array[(0, $0fa4b07f86297abd$export$f821c68fe9beaecf).SCREEN_NPM] = [
        gl.SRC_ALPHA,
        gl.ONE_MINUS_SRC_COLOR,
        gl.ONE,
        gl.ONE_MINUS_SRC_ALPHA
    ], array[(0, $0fa4b07f86297abd$export$f821c68fe9beaecf).SRC_IN] = [
        gl.DST_ALPHA,
        gl.ZERO
    ], array[(0, $0fa4b07f86297abd$export$f821c68fe9beaecf).SRC_OUT] = [
        gl.ONE_MINUS_DST_ALPHA,
        gl.ZERO
    ], array[(0, $0fa4b07f86297abd$export$f821c68fe9beaecf).SRC_ATOP] = [
        gl.DST_ALPHA,
        gl.ONE_MINUS_SRC_ALPHA
    ], array[(0, $0fa4b07f86297abd$export$f821c68fe9beaecf).DST_OVER] = [
        gl.ONE_MINUS_DST_ALPHA,
        gl.ONE
    ], array[(0, $0fa4b07f86297abd$export$f821c68fe9beaecf).DST_IN] = [
        gl.ZERO,
        gl.SRC_ALPHA
    ], array[(0, $0fa4b07f86297abd$export$f821c68fe9beaecf).DST_OUT] = [
        gl.ZERO,
        gl.ONE_MINUS_SRC_ALPHA
    ], array[(0, $0fa4b07f86297abd$export$f821c68fe9beaecf).DST_ATOP] = [
        gl.ONE_MINUS_DST_ALPHA,
        gl.SRC_ALPHA
    ], array[(0, $0fa4b07f86297abd$export$f821c68fe9beaecf).XOR] = [
        gl.ONE_MINUS_DST_ALPHA,
        gl.ONE_MINUS_SRC_ALPHA
    ], array[(0, $0fa4b07f86297abd$export$f821c68fe9beaecf).SUBTRACT] = [
        gl.ONE,
        gl.ONE,
        gl.ONE,
        gl.ONE,
        gl.FUNC_REVERSE_SUBTRACT,
        gl.FUNC_ADD
    ], array;
}


const $8b1e6301cb51dd5f$var$BLEND = 0, $8b1e6301cb51dd5f$var$OFFSET = 1, $8b1e6301cb51dd5f$var$CULLING = 2, $8b1e6301cb51dd5f$var$DEPTH_TEST = 3, $8b1e6301cb51dd5f$var$WINDING = 4, $8b1e6301cb51dd5f$var$DEPTH_MASK = 5, $8b1e6301cb51dd5f$var$_StateSystem = class _StateSystem2 {
    constructor(){
        this.gl = null, this.stateId = 0, this.polygonOffset = 0, this.blendMode = (0, $0fa4b07f86297abd$export$f821c68fe9beaecf).NONE, this._blendEq = !1, this.map = [], this.map[$8b1e6301cb51dd5f$var$BLEND] = this.setBlend, this.map[$8b1e6301cb51dd5f$var$OFFSET] = this.setOffset, this.map[$8b1e6301cb51dd5f$var$CULLING] = this.setCullFace, this.map[$8b1e6301cb51dd5f$var$DEPTH_TEST] = this.setDepthTest, this.map[$8b1e6301cb51dd5f$var$WINDING] = this.setFrontFace, this.map[$8b1e6301cb51dd5f$var$DEPTH_MASK] = this.setDepthMask, this.checks = [], this.defaultState = new (0, $2b269c8c39349f63$export$7254cc27399e90bd)(), this.defaultState.blend = !0;
    }
    contextChange(gl) {
        this.gl = gl, this.blendModes = (0, $b0455dc13f2a356c$export$57ed86928a8d2aa1)(gl), this.set(this.defaultState), this.reset();
    }
    /**
   * Sets the current state
   * @param {*} state - The state to set.
   */ set(state) {
        if (state = state || this.defaultState, this.stateId !== state.data) {
            let diff = this.stateId ^ state.data, i = 0;
            for(; diff;)diff & 1 && this.map[i].call(this, !!(state.data & 1 << i)), diff = diff >> 1, i++;
            this.stateId = state.data;
        }
        for(let i = 0; i < this.checks.length; i++)this.checks[i](this, state);
    }
    /**
   * Sets the state, when previous state is unknown.
   * @param {*} state - The state to set
   */ forceState(state) {
        state = state || this.defaultState;
        for(let i = 0; i < this.map.length; i++)this.map[i].call(this, !!(state.data & 1 << i));
        for(let i = 0; i < this.checks.length; i++)this.checks[i](this, state);
        this.stateId = state.data;
    }
    /**
   * Sets whether to enable or disable blending.
   * @param value - Turn on or off WebGl blending.
   */ setBlend(value) {
        this.updateCheck(_StateSystem2.checkBlendMode, value), this.gl[value ? "enable" : "disable"](this.gl.BLEND);
    }
    /**
   * Sets whether to enable or disable polygon offset fill.
   * @param value - Turn on or off webgl polygon offset testing.
   */ setOffset(value) {
        this.updateCheck(_StateSystem2.checkPolygonOffset, value), this.gl[value ? "enable" : "disable"](this.gl.POLYGON_OFFSET_FILL);
    }
    /**
   * Sets whether to enable or disable depth test.
   * @param value - Turn on or off webgl depth testing.
   */ setDepthTest(value) {
        this.gl[value ? "enable" : "disable"](this.gl.DEPTH_TEST);
    }
    /**
   * Sets whether to enable or disable depth mask.
   * @param value - Turn on or off webgl depth mask.
   */ setDepthMask(value) {
        this.gl.depthMask(value);
    }
    /**
   * Sets whether to enable or disable cull face.
   * @param {boolean} value - Turn on or off webgl cull face.
   */ setCullFace(value) {
        this.gl[value ? "enable" : "disable"](this.gl.CULL_FACE);
    }
    /**
   * Sets the gl front face.
   * @param {boolean} value - true is clockwise and false is counter-clockwise
   */ setFrontFace(value) {
        this.gl.frontFace(this.gl[value ? "CW" : "CCW"]);
    }
    /**
   * Sets the blend mode.
   * @param {number} value - The blend mode to set to.
   */ setBlendMode(value) {
        if (value === this.blendMode) return;
        this.blendMode = value;
        const mode = this.blendModes[value], gl = this.gl;
        mode.length === 2 ? gl.blendFunc(mode[0], mode[1]) : gl.blendFuncSeparate(mode[0], mode[1], mode[2], mode[3]), mode.length === 6 ? (this._blendEq = !0, gl.blendEquationSeparate(mode[4], mode[5])) : this._blendEq && (this._blendEq = !1, gl.blendEquationSeparate(gl.FUNC_ADD, gl.FUNC_ADD));
    }
    /**
   * Sets the polygon offset.
   * @param {number} value - the polygon offset
   * @param {number} scale - the polygon offset scale
   */ setPolygonOffset(value, scale) {
        this.gl.polygonOffset(value, scale);
    }
    // used
    /** Resets all the logic and disables the VAOs. */ reset() {
        this.gl.pixelStorei(this.gl.UNPACK_FLIP_Y_WEBGL, !1), this.forceState(this.defaultState), this._blendEq = !0, this.blendMode = -1, this.setBlendMode(0);
    }
    /**
   * Checks to see which updates should be checked based on which settings have been activated.
   *
   * For example, if blend is enabled then we should check the blend modes each time the state is changed
   * or if polygon fill is activated then we need to check if the polygon offset changes.
   * The idea is that we only check what we have too.
   * @param func - the checking function to add or remove
   * @param value - should the check function be added or removed.
   */ updateCheck(func, value) {
        const index = this.checks.indexOf(func);
        value && index === -1 ? this.checks.push(func) : !value && index !== -1 && this.checks.splice(index, 1);
    }
    /**
   * A private little wrapper function that we call to check the blend mode.
   * @param system - the System to perform the state check on
   * @param state - the state that the blendMode will pulled from
   */ static checkBlendMode(system, state) {
        system.setBlendMode(state.blendMode);
    }
    /**
   * A private little wrapper function that we call to check the polygon offset.
   * @param system - the System to perform the state check on
   * @param state - the state that the blendMode will pulled from
   */ static checkPolygonOffset(system, state) {
        system.setPolygonOffset(1, state.polygonOffset);
    }
    /**
   * @ignore
   */ destroy() {
        this.gl = null;
    }
};
$8b1e6301cb51dd5f$var$_StateSystem.extension = {
    type: (0, $c90155f6d7d8d8f6$export$4f037c6ec2da4eeb).RendererSystem,
    name: "state"
};
let $8b1e6301cb51dd5f$export$d47ea6626863db49 = $8b1e6301cb51dd5f$var$_StateSystem;
(0, $c90155f6d7d8d8f6$export$cc3e2d3244e01b7f).add($8b1e6301cb51dd5f$export$d47ea6626863db49);




class $a33f3b42884b2574$export$a12e67a4b4590901 extends (0, (/*@__PURE__*/$parcel$interopDefault($162b085ff96d1cb1$exports))) {
    constructor(){
        super(...arguments), this.runners = {}, this._systemsHash = {};
    }
    /**
   * Set up a system with a collection of SystemClasses and runners.
   * Systems are attached dynamically to this class when added.
   * @param config - the config for the system manager
   */ setup(config) {
        this.addRunners(...config.runners);
        const priority = (config.priority ?? []).filter((key)=>config.systems[key]), orderByPriority = [
            ...priority,
            ...Object.keys(config.systems).filter((key)=>!priority.includes(key))
        ];
        for (const i of orderByPriority)this.addSystem(config.systems[i], i);
    }
    /**
   * Create a bunch of runners based of a collection of ids
   * @param runnerIds - the runner ids to add
   */ addRunners(...runnerIds) {
        runnerIds.forEach((runnerId)=>{
            this.runners[runnerId] = new (0, $feae24fa15514cdf$export$571ad3bcba5a0c45)(runnerId);
        });
    }
    /**
   * Add a new system to the renderer.
   * @param ClassRef - Class reference
   * @param name - Property name for system, if not specified
   *        will use a static `name` property on the class itself. This
   *        name will be assigned as s property on the Renderer so make
   *        sure it doesn't collide with properties on Renderer.
   * @returns Return instance of renderer
   */ addSystem(ClassRef, name) {
        const system = new ClassRef(this);
        if (this[name]) throw new Error(`Whoops! The name "${name}" is already in use`);
        this[name] = system, this._systemsHash[name] = system;
        for(const i in this.runners)this.runners[i].add(system);
        return this;
    }
    /**
   * A function that will run a runner and call the runners function but pass in different options
   * to each system based on there name.
   *
   * E.g. If you have two systems added called `systemA` and `systemB` you could call do the following:
   *
   * ```js
   * system.emitWithCustomOptions(init, {
   *     systemA: {...optionsForA},
   *     systemB: {...optionsForB},
   * });
   * ```
   *
   * `init` would be called on system A passing `optionsForA` and on system B passing `optionsForB`.
   * @param runner - the runner to target
   * @param options - key value options for each system
   */ emitWithCustomOptions(runner, options) {
        const systemHashKeys = Object.keys(this._systemsHash);
        runner.items.forEach((system)=>{
            const systemName = systemHashKeys.find((systemId)=>this._systemsHash[systemId] === system);
            system[runner.name](options[systemName]);
        });
    }
    /** destroy the all runners and systems. Its apps job to */ destroy() {
        Object.values(this.runners).forEach((runner)=>{
            runner.destroy();
        }), this._systemsHash = {};
    }
}




const $6307bf23a1a8c3d8$var$_TextureGCSystem = class _TextureGCSystem2 {
    /** @param renderer - The renderer this System works for. */ constructor(renderer){
        this.renderer = renderer, this.count = 0, this.checkCount = 0, this.maxIdle = _TextureGCSystem2.defaultMaxIdle, this.checkCountMax = _TextureGCSystem2.defaultCheckCountMax, this.mode = _TextureGCSystem2.defaultMode;
    }
    /**
   * Checks to see when the last time a texture was used.
   * If the texture has not been used for a specified amount of time, it will be removed from the GPU.
   */ postrender() {
        this.renderer.objectRenderer.renderingToScreen && (this.count++, this.mode !== (0, $0fa4b07f86297abd$export$5c6ba89c1f52b344).MANUAL && (this.checkCount++, this.checkCount > this.checkCountMax && (this.checkCount = 0, this.run())));
    }
    /**
   * Checks to see when the last time a texture was used.
   * If the texture has not been used for a specified amount of time, it will be removed from the GPU.
   */ run() {
        const tm = this.renderer.texture, managedTextures = tm.managedTextures;
        let wasRemoved = !1;
        for(let i = 0; i < managedTextures.length; i++){
            const texture = managedTextures[i];
            texture.resource && this.count - texture.touched > this.maxIdle && (tm.destroyTexture(texture, !0), managedTextures[i] = null, wasRemoved = !0);
        }
        if (wasRemoved) {
            let j = 0;
            for(let i = 0; i < managedTextures.length; i++)managedTextures[i] !== null && (managedTextures[j++] = managedTextures[i]);
            managedTextures.length = j;
        }
    }
    /**
   * Removes all the textures within the specified displayObject and its children from the GPU.
   * @param {PIXI.DisplayObject} displayObject - the displayObject to remove the textures from.
   */ unload(displayObject) {
        const tm = this.renderer.texture, texture = displayObject._texture;
        texture && !texture.framebuffer && tm.destroyTexture(texture);
        for(let i = displayObject.children.length - 1; i >= 0; i--)this.unload(displayObject.children[i]);
    }
    destroy() {
        this.renderer = null;
    }
};
$6307bf23a1a8c3d8$var$_TextureGCSystem.defaultMode = (0, $0fa4b07f86297abd$export$5c6ba89c1f52b344).AUTO, /**
* Default maximum idle frames before a texture is destroyed by garbage collection.
* @static
* @default 3600
* @see PIXI.TextureGCSystem#maxIdle
*/ $6307bf23a1a8c3d8$var$_TextureGCSystem.defaultMaxIdle = 3600, /**
* Default frames between two garbage collections.
* @static
* @default 600
* @see PIXI.TextureGCSystem#checkCountMax
*/ $6307bf23a1a8c3d8$var$_TextureGCSystem.defaultCheckCountMax = 600, /** @ignore */ $6307bf23a1a8c3d8$var$_TextureGCSystem.extension = {
    type: (0, $c90155f6d7d8d8f6$export$4f037c6ec2da4eeb).RendererSystem,
    name: "textureGC"
};
let $6307bf23a1a8c3d8$export$a47b032752d8e393 = $6307bf23a1a8c3d8$var$_TextureGCSystem;
(0, $c90155f6d7d8d8f6$export$cc3e2d3244e01b7f).add($6307bf23a1a8c3d8$export$a47b032752d8e393);







class $7f6ba4ec0a268a10$export$6c73c2a4561c07a2 {
    constructor(texture){
        this.texture = texture, this.width = -1, this.height = -1, this.dirtyId = -1, this.dirtyStyleId = -1, this.mipmap = !1, this.wrapMode = 33071, this.type = (0, $0fa4b07f86297abd$export$426db7a6155b7a80).UNSIGNED_BYTE, this.internalFormat = (0, $0fa4b07f86297abd$export$e9c4b7b466aa8274).RGBA, this.samplerType = 0;
    }
}



function $ca24ad1d1e75e2a7$export$4d44a566e4889fac(gl) {
    let table;
    return "WebGL2RenderingContext" in globalThis && gl instanceof globalThis.WebGL2RenderingContext ? table = {
        [gl.RGB]: (0, $0fa4b07f86297abd$export$8ee8af3637d728f5).FLOAT,
        [gl.RGBA]: (0, $0fa4b07f86297abd$export$8ee8af3637d728f5).FLOAT,
        [gl.ALPHA]: (0, $0fa4b07f86297abd$export$8ee8af3637d728f5).FLOAT,
        [gl.LUMINANCE]: (0, $0fa4b07f86297abd$export$8ee8af3637d728f5).FLOAT,
        [gl.LUMINANCE_ALPHA]: (0, $0fa4b07f86297abd$export$8ee8af3637d728f5).FLOAT,
        [gl.R8]: (0, $0fa4b07f86297abd$export$8ee8af3637d728f5).FLOAT,
        [gl.R8_SNORM]: (0, $0fa4b07f86297abd$export$8ee8af3637d728f5).FLOAT,
        [gl.RG8]: (0, $0fa4b07f86297abd$export$8ee8af3637d728f5).FLOAT,
        [gl.RG8_SNORM]: (0, $0fa4b07f86297abd$export$8ee8af3637d728f5).FLOAT,
        [gl.RGB8]: (0, $0fa4b07f86297abd$export$8ee8af3637d728f5).FLOAT,
        [gl.RGB8_SNORM]: (0, $0fa4b07f86297abd$export$8ee8af3637d728f5).FLOAT,
        [gl.RGB565]: (0, $0fa4b07f86297abd$export$8ee8af3637d728f5).FLOAT,
        [gl.RGBA4]: (0, $0fa4b07f86297abd$export$8ee8af3637d728f5).FLOAT,
        [gl.RGB5_A1]: (0, $0fa4b07f86297abd$export$8ee8af3637d728f5).FLOAT,
        [gl.RGBA8]: (0, $0fa4b07f86297abd$export$8ee8af3637d728f5).FLOAT,
        [gl.RGBA8_SNORM]: (0, $0fa4b07f86297abd$export$8ee8af3637d728f5).FLOAT,
        [gl.RGB10_A2]: (0, $0fa4b07f86297abd$export$8ee8af3637d728f5).FLOAT,
        [gl.RGB10_A2UI]: (0, $0fa4b07f86297abd$export$8ee8af3637d728f5).FLOAT,
        [gl.SRGB8]: (0, $0fa4b07f86297abd$export$8ee8af3637d728f5).FLOAT,
        [gl.SRGB8_ALPHA8]: (0, $0fa4b07f86297abd$export$8ee8af3637d728f5).FLOAT,
        [gl.R16F]: (0, $0fa4b07f86297abd$export$8ee8af3637d728f5).FLOAT,
        [gl.RG16F]: (0, $0fa4b07f86297abd$export$8ee8af3637d728f5).FLOAT,
        [gl.RGB16F]: (0, $0fa4b07f86297abd$export$8ee8af3637d728f5).FLOAT,
        [gl.RGBA16F]: (0, $0fa4b07f86297abd$export$8ee8af3637d728f5).FLOAT,
        [gl.R32F]: (0, $0fa4b07f86297abd$export$8ee8af3637d728f5).FLOAT,
        [gl.RG32F]: (0, $0fa4b07f86297abd$export$8ee8af3637d728f5).FLOAT,
        [gl.RGB32F]: (0, $0fa4b07f86297abd$export$8ee8af3637d728f5).FLOAT,
        [gl.RGBA32F]: (0, $0fa4b07f86297abd$export$8ee8af3637d728f5).FLOAT,
        [gl.R11F_G11F_B10F]: (0, $0fa4b07f86297abd$export$8ee8af3637d728f5).FLOAT,
        [gl.RGB9_E5]: (0, $0fa4b07f86297abd$export$8ee8af3637d728f5).FLOAT,
        [gl.R8I]: (0, $0fa4b07f86297abd$export$8ee8af3637d728f5).INT,
        [gl.R8UI]: (0, $0fa4b07f86297abd$export$8ee8af3637d728f5).UINT,
        [gl.R16I]: (0, $0fa4b07f86297abd$export$8ee8af3637d728f5).INT,
        [gl.R16UI]: (0, $0fa4b07f86297abd$export$8ee8af3637d728f5).UINT,
        [gl.R32I]: (0, $0fa4b07f86297abd$export$8ee8af3637d728f5).INT,
        [gl.R32UI]: (0, $0fa4b07f86297abd$export$8ee8af3637d728f5).UINT,
        [gl.RG8I]: (0, $0fa4b07f86297abd$export$8ee8af3637d728f5).INT,
        [gl.RG8UI]: (0, $0fa4b07f86297abd$export$8ee8af3637d728f5).UINT,
        [gl.RG16I]: (0, $0fa4b07f86297abd$export$8ee8af3637d728f5).INT,
        [gl.RG16UI]: (0, $0fa4b07f86297abd$export$8ee8af3637d728f5).UINT,
        [gl.RG32I]: (0, $0fa4b07f86297abd$export$8ee8af3637d728f5).INT,
        [gl.RG32UI]: (0, $0fa4b07f86297abd$export$8ee8af3637d728f5).UINT,
        [gl.RGB8I]: (0, $0fa4b07f86297abd$export$8ee8af3637d728f5).INT,
        [gl.RGB8UI]: (0, $0fa4b07f86297abd$export$8ee8af3637d728f5).UINT,
        [gl.RGB16I]: (0, $0fa4b07f86297abd$export$8ee8af3637d728f5).INT,
        [gl.RGB16UI]: (0, $0fa4b07f86297abd$export$8ee8af3637d728f5).UINT,
        [gl.RGB32I]: (0, $0fa4b07f86297abd$export$8ee8af3637d728f5).INT,
        [gl.RGB32UI]: (0, $0fa4b07f86297abd$export$8ee8af3637d728f5).UINT,
        [gl.RGBA8I]: (0, $0fa4b07f86297abd$export$8ee8af3637d728f5).INT,
        [gl.RGBA8UI]: (0, $0fa4b07f86297abd$export$8ee8af3637d728f5).UINT,
        [gl.RGBA16I]: (0, $0fa4b07f86297abd$export$8ee8af3637d728f5).INT,
        [gl.RGBA16UI]: (0, $0fa4b07f86297abd$export$8ee8af3637d728f5).UINT,
        [gl.RGBA32I]: (0, $0fa4b07f86297abd$export$8ee8af3637d728f5).INT,
        [gl.RGBA32UI]: (0, $0fa4b07f86297abd$export$8ee8af3637d728f5).UINT,
        [gl.DEPTH_COMPONENT16]: (0, $0fa4b07f86297abd$export$8ee8af3637d728f5).FLOAT,
        [gl.DEPTH_COMPONENT24]: (0, $0fa4b07f86297abd$export$8ee8af3637d728f5).FLOAT,
        [gl.DEPTH_COMPONENT32F]: (0, $0fa4b07f86297abd$export$8ee8af3637d728f5).FLOAT,
        [gl.DEPTH_STENCIL]: (0, $0fa4b07f86297abd$export$8ee8af3637d728f5).FLOAT,
        [gl.DEPTH24_STENCIL8]: (0, $0fa4b07f86297abd$export$8ee8af3637d728f5).FLOAT,
        [gl.DEPTH32F_STENCIL8]: (0, $0fa4b07f86297abd$export$8ee8af3637d728f5).FLOAT
    } : table = {
        [gl.RGB]: (0, $0fa4b07f86297abd$export$8ee8af3637d728f5).FLOAT,
        [gl.RGBA]: (0, $0fa4b07f86297abd$export$8ee8af3637d728f5).FLOAT,
        [gl.ALPHA]: (0, $0fa4b07f86297abd$export$8ee8af3637d728f5).FLOAT,
        [gl.LUMINANCE]: (0, $0fa4b07f86297abd$export$8ee8af3637d728f5).FLOAT,
        [gl.LUMINANCE_ALPHA]: (0, $0fa4b07f86297abd$export$8ee8af3637d728f5).FLOAT,
        [gl.DEPTH_STENCIL]: (0, $0fa4b07f86297abd$export$8ee8af3637d728f5).FLOAT
    }, table;
}



function $d8227a2e8933841a$export$af038b9b93a51a84(gl) {
    let table;
    return "WebGL2RenderingContext" in globalThis && gl instanceof globalThis.WebGL2RenderingContext ? table = {
        [(0, $0fa4b07f86297abd$export$426db7a6155b7a80).UNSIGNED_BYTE]: {
            [(0, $0fa4b07f86297abd$export$e9c4b7b466aa8274).RGBA]: gl.RGBA8,
            [(0, $0fa4b07f86297abd$export$e9c4b7b466aa8274).RGB]: gl.RGB8,
            [(0, $0fa4b07f86297abd$export$e9c4b7b466aa8274).RG]: gl.RG8,
            [(0, $0fa4b07f86297abd$export$e9c4b7b466aa8274).RED]: gl.R8,
            [(0, $0fa4b07f86297abd$export$e9c4b7b466aa8274).RGBA_INTEGER]: gl.RGBA8UI,
            [(0, $0fa4b07f86297abd$export$e9c4b7b466aa8274).RGB_INTEGER]: gl.RGB8UI,
            [(0, $0fa4b07f86297abd$export$e9c4b7b466aa8274).RG_INTEGER]: gl.RG8UI,
            [(0, $0fa4b07f86297abd$export$e9c4b7b466aa8274).RED_INTEGER]: gl.R8UI,
            [(0, $0fa4b07f86297abd$export$e9c4b7b466aa8274).ALPHA]: gl.ALPHA,
            [(0, $0fa4b07f86297abd$export$e9c4b7b466aa8274).LUMINANCE]: gl.LUMINANCE,
            [(0, $0fa4b07f86297abd$export$e9c4b7b466aa8274).LUMINANCE_ALPHA]: gl.LUMINANCE_ALPHA
        },
        [(0, $0fa4b07f86297abd$export$426db7a6155b7a80).BYTE]: {
            [(0, $0fa4b07f86297abd$export$e9c4b7b466aa8274).RGBA]: gl.RGBA8_SNORM,
            [(0, $0fa4b07f86297abd$export$e9c4b7b466aa8274).RGB]: gl.RGB8_SNORM,
            [(0, $0fa4b07f86297abd$export$e9c4b7b466aa8274).RG]: gl.RG8_SNORM,
            [(0, $0fa4b07f86297abd$export$e9c4b7b466aa8274).RED]: gl.R8_SNORM,
            [(0, $0fa4b07f86297abd$export$e9c4b7b466aa8274).RGBA_INTEGER]: gl.RGBA8I,
            [(0, $0fa4b07f86297abd$export$e9c4b7b466aa8274).RGB_INTEGER]: gl.RGB8I,
            [(0, $0fa4b07f86297abd$export$e9c4b7b466aa8274).RG_INTEGER]: gl.RG8I,
            [(0, $0fa4b07f86297abd$export$e9c4b7b466aa8274).RED_INTEGER]: gl.R8I
        },
        [(0, $0fa4b07f86297abd$export$426db7a6155b7a80).UNSIGNED_SHORT]: {
            [(0, $0fa4b07f86297abd$export$e9c4b7b466aa8274).RGBA_INTEGER]: gl.RGBA16UI,
            [(0, $0fa4b07f86297abd$export$e9c4b7b466aa8274).RGB_INTEGER]: gl.RGB16UI,
            [(0, $0fa4b07f86297abd$export$e9c4b7b466aa8274).RG_INTEGER]: gl.RG16UI,
            [(0, $0fa4b07f86297abd$export$e9c4b7b466aa8274).RED_INTEGER]: gl.R16UI,
            [(0, $0fa4b07f86297abd$export$e9c4b7b466aa8274).DEPTH_COMPONENT]: gl.DEPTH_COMPONENT16
        },
        [(0, $0fa4b07f86297abd$export$426db7a6155b7a80).SHORT]: {
            [(0, $0fa4b07f86297abd$export$e9c4b7b466aa8274).RGBA_INTEGER]: gl.RGBA16I,
            [(0, $0fa4b07f86297abd$export$e9c4b7b466aa8274).RGB_INTEGER]: gl.RGB16I,
            [(0, $0fa4b07f86297abd$export$e9c4b7b466aa8274).RG_INTEGER]: gl.RG16I,
            [(0, $0fa4b07f86297abd$export$e9c4b7b466aa8274).RED_INTEGER]: gl.R16I
        },
        [(0, $0fa4b07f86297abd$export$426db7a6155b7a80).UNSIGNED_INT]: {
            [(0, $0fa4b07f86297abd$export$e9c4b7b466aa8274).RGBA_INTEGER]: gl.RGBA32UI,
            [(0, $0fa4b07f86297abd$export$e9c4b7b466aa8274).RGB_INTEGER]: gl.RGB32UI,
            [(0, $0fa4b07f86297abd$export$e9c4b7b466aa8274).RG_INTEGER]: gl.RG32UI,
            [(0, $0fa4b07f86297abd$export$e9c4b7b466aa8274).RED_INTEGER]: gl.R32UI,
            [(0, $0fa4b07f86297abd$export$e9c4b7b466aa8274).DEPTH_COMPONENT]: gl.DEPTH_COMPONENT24
        },
        [(0, $0fa4b07f86297abd$export$426db7a6155b7a80).INT]: {
            [(0, $0fa4b07f86297abd$export$e9c4b7b466aa8274).RGBA_INTEGER]: gl.RGBA32I,
            [(0, $0fa4b07f86297abd$export$e9c4b7b466aa8274).RGB_INTEGER]: gl.RGB32I,
            [(0, $0fa4b07f86297abd$export$e9c4b7b466aa8274).RG_INTEGER]: gl.RG32I,
            [(0, $0fa4b07f86297abd$export$e9c4b7b466aa8274).RED_INTEGER]: gl.R32I
        },
        [(0, $0fa4b07f86297abd$export$426db7a6155b7a80).FLOAT]: {
            [(0, $0fa4b07f86297abd$export$e9c4b7b466aa8274).RGBA]: gl.RGBA32F,
            [(0, $0fa4b07f86297abd$export$e9c4b7b466aa8274).RGB]: gl.RGB32F,
            [(0, $0fa4b07f86297abd$export$e9c4b7b466aa8274).RG]: gl.RG32F,
            [(0, $0fa4b07f86297abd$export$e9c4b7b466aa8274).RED]: gl.R32F,
            [(0, $0fa4b07f86297abd$export$e9c4b7b466aa8274).DEPTH_COMPONENT]: gl.DEPTH_COMPONENT32F
        },
        [(0, $0fa4b07f86297abd$export$426db7a6155b7a80).HALF_FLOAT]: {
            [(0, $0fa4b07f86297abd$export$e9c4b7b466aa8274).RGBA]: gl.RGBA16F,
            [(0, $0fa4b07f86297abd$export$e9c4b7b466aa8274).RGB]: gl.RGB16F,
            [(0, $0fa4b07f86297abd$export$e9c4b7b466aa8274).RG]: gl.RG16F,
            [(0, $0fa4b07f86297abd$export$e9c4b7b466aa8274).RED]: gl.R16F
        },
        [(0, $0fa4b07f86297abd$export$426db7a6155b7a80).UNSIGNED_SHORT_5_6_5]: {
            [(0, $0fa4b07f86297abd$export$e9c4b7b466aa8274).RGB]: gl.RGB565
        },
        [(0, $0fa4b07f86297abd$export$426db7a6155b7a80).UNSIGNED_SHORT_4_4_4_4]: {
            [(0, $0fa4b07f86297abd$export$e9c4b7b466aa8274).RGBA]: gl.RGBA4
        },
        [(0, $0fa4b07f86297abd$export$426db7a6155b7a80).UNSIGNED_SHORT_5_5_5_1]: {
            [(0, $0fa4b07f86297abd$export$e9c4b7b466aa8274).RGBA]: gl.RGB5_A1
        },
        [(0, $0fa4b07f86297abd$export$426db7a6155b7a80).UNSIGNED_INT_2_10_10_10_REV]: {
            [(0, $0fa4b07f86297abd$export$e9c4b7b466aa8274).RGBA]: gl.RGB10_A2,
            [(0, $0fa4b07f86297abd$export$e9c4b7b466aa8274).RGBA_INTEGER]: gl.RGB10_A2UI
        },
        [(0, $0fa4b07f86297abd$export$426db7a6155b7a80).UNSIGNED_INT_10F_11F_11F_REV]: {
            [(0, $0fa4b07f86297abd$export$e9c4b7b466aa8274).RGB]: gl.R11F_G11F_B10F
        },
        [(0, $0fa4b07f86297abd$export$426db7a6155b7a80).UNSIGNED_INT_5_9_9_9_REV]: {
            [(0, $0fa4b07f86297abd$export$e9c4b7b466aa8274).RGB]: gl.RGB9_E5
        },
        [(0, $0fa4b07f86297abd$export$426db7a6155b7a80).UNSIGNED_INT_24_8]: {
            [(0, $0fa4b07f86297abd$export$e9c4b7b466aa8274).DEPTH_STENCIL]: gl.DEPTH24_STENCIL8
        },
        [(0, $0fa4b07f86297abd$export$426db7a6155b7a80).FLOAT_32_UNSIGNED_INT_24_8_REV]: {
            [(0, $0fa4b07f86297abd$export$e9c4b7b466aa8274).DEPTH_STENCIL]: gl.DEPTH32F_STENCIL8
        }
    } : table = {
        [(0, $0fa4b07f86297abd$export$426db7a6155b7a80).UNSIGNED_BYTE]: {
            [(0, $0fa4b07f86297abd$export$e9c4b7b466aa8274).RGBA]: gl.RGBA,
            [(0, $0fa4b07f86297abd$export$e9c4b7b466aa8274).RGB]: gl.RGB,
            [(0, $0fa4b07f86297abd$export$e9c4b7b466aa8274).ALPHA]: gl.ALPHA,
            [(0, $0fa4b07f86297abd$export$e9c4b7b466aa8274).LUMINANCE]: gl.LUMINANCE,
            [(0, $0fa4b07f86297abd$export$e9c4b7b466aa8274).LUMINANCE_ALPHA]: gl.LUMINANCE_ALPHA
        },
        [(0, $0fa4b07f86297abd$export$426db7a6155b7a80).UNSIGNED_SHORT_5_6_5]: {
            [(0, $0fa4b07f86297abd$export$e9c4b7b466aa8274).RGB]: gl.RGB
        },
        [(0, $0fa4b07f86297abd$export$426db7a6155b7a80).UNSIGNED_SHORT_4_4_4_4]: {
            [(0, $0fa4b07f86297abd$export$e9c4b7b466aa8274).RGBA]: gl.RGBA
        },
        [(0, $0fa4b07f86297abd$export$426db7a6155b7a80).UNSIGNED_SHORT_5_5_5_1]: {
            [(0, $0fa4b07f86297abd$export$e9c4b7b466aa8274).RGBA]: gl.RGBA
        }
    }, table;
}


class $cbe684647a8cd956$export$6312da36f198968 {
    /**
   * @param renderer - The renderer this system works for.
   */ constructor(renderer){
        this.renderer = renderer, this.boundTextures = [], this.currentLocation = -1, this.managedTextures = [], this._unknownBoundTextures = !1, this.unknownTexture = new (0, $30c85657f0c625d5$export$d6306e508f184154)(), this.hasIntegerTextures = !1;
    }
    /** Sets up the renderer context and necessary buffers. */ contextChange() {
        const gl = this.gl = this.renderer.gl;
        this.CONTEXT_UID = this.renderer.CONTEXT_UID, this.webGLVersion = this.renderer.context.webGLVersion, this.internalFormats = (0, $d8227a2e8933841a$export$af038b9b93a51a84)(gl), this.samplerTypes = (0, $ca24ad1d1e75e2a7$export$4d44a566e4889fac)(gl);
        const maxTextures = gl.getParameter(gl.MAX_TEXTURE_IMAGE_UNITS);
        this.boundTextures.length = maxTextures;
        for(let i = 0; i < maxTextures; i++)this.boundTextures[i] = null;
        this.emptyTextures = {};
        const emptyTexture2D = new (0, $7f6ba4ec0a268a10$export$6c73c2a4561c07a2)(gl.createTexture());
        gl.bindTexture(gl.TEXTURE_2D, emptyTexture2D.texture), gl.texImage2D(gl.TEXTURE_2D, 0, gl.RGBA, 1, 1, 0, gl.RGBA, gl.UNSIGNED_BYTE, new Uint8Array(4)), this.emptyTextures[gl.TEXTURE_2D] = emptyTexture2D, this.emptyTextures[gl.TEXTURE_CUBE_MAP] = new (0, $7f6ba4ec0a268a10$export$6c73c2a4561c07a2)(gl.createTexture()), gl.bindTexture(gl.TEXTURE_CUBE_MAP, this.emptyTextures[gl.TEXTURE_CUBE_MAP].texture);
        for(let i = 0; i < 6; i++)gl.texImage2D(gl.TEXTURE_CUBE_MAP_POSITIVE_X + i, 0, gl.RGBA, 1, 1, 0, gl.RGBA, gl.UNSIGNED_BYTE, null);
        gl.texParameteri(gl.TEXTURE_CUBE_MAP, gl.TEXTURE_MAG_FILTER, gl.LINEAR), gl.texParameteri(gl.TEXTURE_CUBE_MAP, gl.TEXTURE_MIN_FILTER, gl.LINEAR);
        for(let i = 0; i < this.boundTextures.length; i++)this.bind(null, i);
    }
    /**
   * Bind a texture to a specific location
   *
   * If you want to unbind something, please use `unbind(texture)` instead of `bind(null, textureLocation)`
   * @param texture - Texture to bind
   * @param [location=0] - Location to bind at
   */ bind(texture, location = 0) {
        const { gl: gl } = this;
        if (texture = texture?.castToBaseTexture(), texture?.valid && !texture.parentTextureArray) {
            texture.touched = this.renderer.textureGC.count;
            const glTexture = texture._glTextures[this.CONTEXT_UID] || this.initTexture(texture);
            this.boundTextures[location] !== texture && (this.currentLocation !== location && (this.currentLocation = location, gl.activeTexture(gl.TEXTURE0 + location)), gl.bindTexture(texture.target, glTexture.texture)), glTexture.dirtyId !== texture.dirtyId ? (this.currentLocation !== location && (this.currentLocation = location, gl.activeTexture(gl.TEXTURE0 + location)), this.updateTexture(texture)) : glTexture.dirtyStyleId !== texture.dirtyStyleId && this.updateTextureStyle(texture), this.boundTextures[location] = texture;
        } else this.currentLocation !== location && (this.currentLocation = location, gl.activeTexture(gl.TEXTURE0 + location)), gl.bindTexture(gl.TEXTURE_2D, this.emptyTextures[gl.TEXTURE_2D].texture), this.boundTextures[location] = null;
    }
    /** Resets texture location and bound textures Actual `bind(null, i)` calls will be performed at next `unbind()` call */ reset() {
        this._unknownBoundTextures = !0, this.hasIntegerTextures = !1, this.currentLocation = -1;
        for(let i = 0; i < this.boundTextures.length; i++)this.boundTextures[i] = this.unknownTexture;
    }
    /**
   * Unbind a texture.
   * @param texture - Texture to bind
   */ unbind(texture) {
        const { gl: gl, boundTextures: boundTextures } = this;
        if (this._unknownBoundTextures) {
            this._unknownBoundTextures = !1;
            for(let i = 0; i < boundTextures.length; i++)boundTextures[i] === this.unknownTexture && this.bind(null, i);
        }
        for(let i = 0; i < boundTextures.length; i++)boundTextures[i] === texture && (this.currentLocation !== i && (gl.activeTexture(gl.TEXTURE0 + i), this.currentLocation = i), gl.bindTexture(texture.target, this.emptyTextures[texture.target].texture), boundTextures[i] = null);
    }
    /**
   * Ensures that current boundTextures all have FLOAT sampler type,
   * see {@link PIXI.SAMPLER_TYPES} for explanation.
   * @param maxTextures - number of locations to check
   */ ensureSamplerType(maxTextures) {
        const { boundTextures: boundTextures, hasIntegerTextures: hasIntegerTextures, CONTEXT_UID: CONTEXT_UID } = this;
        if (hasIntegerTextures) for(let i = maxTextures - 1; i >= 0; --i){
            const tex = boundTextures[i];
            tex && tex._glTextures[CONTEXT_UID].samplerType !== (0, $0fa4b07f86297abd$export$8ee8af3637d728f5).FLOAT && this.renderer.texture.unbind(tex);
        }
    }
    /**
   * Initialize a texture
   * @private
   * @param texture - Texture to initialize
   */ initTexture(texture) {
        const glTexture = new (0, $7f6ba4ec0a268a10$export$6c73c2a4561c07a2)(this.gl.createTexture());
        return glTexture.dirtyId = -1, texture._glTextures[this.CONTEXT_UID] = glTexture, this.managedTextures.push(texture), texture.on("dispose", this.destroyTexture, this), glTexture;
    }
    initTextureType(texture, glTexture) {
        glTexture.internalFormat = this.internalFormats[texture.type]?.[texture.format] ?? texture.format, glTexture.samplerType = this.samplerTypes[glTexture.internalFormat] ?? (0, $0fa4b07f86297abd$export$8ee8af3637d728f5).FLOAT, this.webGLVersion === 2 && texture.type === (0, $0fa4b07f86297abd$export$426db7a6155b7a80).HALF_FLOAT ? glTexture.type = this.gl.HALF_FLOAT : glTexture.type = texture.type;
    }
    /**
   * Update a texture
   * @private
   * @param {PIXI.BaseTexture} texture - Texture to initialize
   */ updateTexture(texture) {
        const glTexture = texture._glTextures[this.CONTEXT_UID];
        if (!glTexture) return;
        const renderer = this.renderer;
        if (this.initTextureType(texture, glTexture), texture.resource?.upload(renderer, texture, glTexture)) glTexture.samplerType !== (0, $0fa4b07f86297abd$export$8ee8af3637d728f5).FLOAT && (this.hasIntegerTextures = !0);
        else {
            const width = texture.realWidth, height = texture.realHeight, gl = renderer.gl;
            (glTexture.width !== width || glTexture.height !== height || glTexture.dirtyId < 0) && (glTexture.width = width, glTexture.height = height, gl.texImage2D(texture.target, 0, glTexture.internalFormat, width, height, 0, texture.format, glTexture.type, null));
        }
        texture.dirtyStyleId !== glTexture.dirtyStyleId && this.updateTextureStyle(texture), glTexture.dirtyId = texture.dirtyId;
    }
    /**
   * Deletes the texture from WebGL
   * @private
   * @param texture - the texture to destroy
   * @param [skipRemove=false] - Whether to skip removing the texture from the TextureManager.
   */ destroyTexture(texture, skipRemove) {
        const { gl: gl } = this;
        if (texture = texture.castToBaseTexture(), texture._glTextures[this.CONTEXT_UID] && (this.unbind(texture), gl.deleteTexture(texture._glTextures[this.CONTEXT_UID].texture), texture.off("dispose", this.destroyTexture, this), delete texture._glTextures[this.CONTEXT_UID], !skipRemove)) {
            const i = this.managedTextures.indexOf(texture);
            i !== -1 && (0, $0edf199a0064729e$export$8d47c0e1ce445404)(this.managedTextures, i, 1);
        }
    }
    /**
   * Update texture style such as mipmap flag
   * @private
   * @param {PIXI.BaseTexture} texture - Texture to update
   */ updateTextureStyle(texture) {
        const glTexture = texture._glTextures[this.CONTEXT_UID];
        glTexture && ((texture.mipmap === (0, $0fa4b07f86297abd$export$16f6fb5da874bbfd).POW2 || this.webGLVersion !== 2) && !texture.isPowerOfTwo ? glTexture.mipmap = !1 : glTexture.mipmap = texture.mipmap >= 1, this.webGLVersion !== 2 && !texture.isPowerOfTwo ? glTexture.wrapMode = (0, $0fa4b07f86297abd$export$2ab395cfb0dd2f0f).CLAMP : glTexture.wrapMode = texture.wrapMode, texture.resource?.style(this.renderer, texture, glTexture) || this.setStyle(texture, glTexture), glTexture.dirtyStyleId = texture.dirtyStyleId);
    }
    /**
   * Set style for texture
   * @private
   * @param texture - Texture to update
   * @param glTexture
   */ setStyle(texture, glTexture) {
        const gl = this.gl;
        if (glTexture.mipmap && texture.mipmap !== (0, $0fa4b07f86297abd$export$16f6fb5da874bbfd).ON_MANUAL && gl.generateMipmap(texture.target), gl.texParameteri(texture.target, gl.TEXTURE_WRAP_S, glTexture.wrapMode), gl.texParameteri(texture.target, gl.TEXTURE_WRAP_T, glTexture.wrapMode), glTexture.mipmap) {
            gl.texParameteri(texture.target, gl.TEXTURE_MIN_FILTER, texture.scaleMode === (0, $0fa4b07f86297abd$export$6b734c6a0bba8473).LINEAR ? gl.LINEAR_MIPMAP_LINEAR : gl.NEAREST_MIPMAP_NEAREST);
            const anisotropicExt = this.renderer.context.extensions.anisotropicFiltering;
            if (anisotropicExt && texture.anisotropicLevel > 0 && texture.scaleMode === (0, $0fa4b07f86297abd$export$6b734c6a0bba8473).LINEAR) {
                const level = Math.min(texture.anisotropicLevel, gl.getParameter(anisotropicExt.MAX_TEXTURE_MAX_ANISOTROPY_EXT));
                gl.texParameterf(texture.target, anisotropicExt.TEXTURE_MAX_ANISOTROPY_EXT, level);
            }
        } else gl.texParameteri(texture.target, gl.TEXTURE_MIN_FILTER, texture.scaleMode === (0, $0fa4b07f86297abd$export$6b734c6a0bba8473).LINEAR ? gl.LINEAR : gl.NEAREST);
        gl.texParameteri(texture.target, gl.TEXTURE_MAG_FILTER, texture.scaleMode === (0, $0fa4b07f86297abd$export$6b734c6a0bba8473).LINEAR ? gl.LINEAR : gl.NEAREST);
    }
    destroy() {
        this.renderer = null;
    }
}
$cbe684647a8cd956$export$6312da36f198968.extension = {
    type: (0, $c90155f6d7d8d8f6$export$4f037c6ec2da4eeb).RendererSystem,
    name: "texture"
};
(0, $c90155f6d7d8d8f6$export$cc3e2d3244e01b7f).add($cbe684647a8cd956$export$6312da36f198968);



class $0521c45bcf7e5f1e$export$82410eeab0646070 {
    /**
   * @param renderer - The renderer this System works for.
   */ constructor(renderer){
        this.renderer = renderer;
    }
    /** Sets up the renderer context and necessary buffers. */ contextChange() {
        this.gl = this.renderer.gl, this.CONTEXT_UID = this.renderer.CONTEXT_UID;
    }
    /**
   * Bind TransformFeedback and buffers
   * @param transformFeedback - TransformFeedback to bind
   */ bind(transformFeedback) {
        const { gl: gl, CONTEXT_UID: CONTEXT_UID } = this, glTransformFeedback = transformFeedback._glTransformFeedbacks[CONTEXT_UID] || this.createGLTransformFeedback(transformFeedback);
        gl.bindTransformFeedback(gl.TRANSFORM_FEEDBACK, glTransformFeedback);
    }
    /** Unbind TransformFeedback */ unbind() {
        const { gl: gl } = this;
        gl.bindTransformFeedback(gl.TRANSFORM_FEEDBACK, null);
    }
    /**
   * Begin TransformFeedback
   * @param drawMode - DrawMode for TransformFeedback
   * @param shader - A Shader used by TransformFeedback. Current bound shader will be used if not provided.
   */ beginTransformFeedback(drawMode, shader) {
        const { gl: gl, renderer: renderer } = this;
        shader && renderer.shader.bind(shader), gl.beginTransformFeedback(drawMode);
    }
    /** End TransformFeedback */ endTransformFeedback() {
        const { gl: gl } = this;
        gl.endTransformFeedback();
    }
    /**
   * Create TransformFeedback and bind buffers
   * @param tf - TransformFeedback
   * @returns WebGLTransformFeedback
   */ createGLTransformFeedback(tf) {
        const { gl: gl, renderer: renderer, CONTEXT_UID: CONTEXT_UID } = this, glTransformFeedback = gl.createTransformFeedback();
        tf._glTransformFeedbacks[CONTEXT_UID] = glTransformFeedback, gl.bindTransformFeedback(gl.TRANSFORM_FEEDBACK, glTransformFeedback);
        for(let i = 0; i < tf.buffers.length; i++){
            const buffer = tf.buffers[i];
            buffer && (renderer.buffer.update(buffer), buffer._glBuffers[CONTEXT_UID].refCount++, gl.bindBufferBase(gl.TRANSFORM_FEEDBACK_BUFFER, i, buffer._glBuffers[CONTEXT_UID].buffer || null));
        }
        return gl.bindTransformFeedback(gl.TRANSFORM_FEEDBACK, null), tf.disposeRunner.add(this), glTransformFeedback;
    }
    /**
   * Disposes TransfromFeedback
   * @param {PIXI.TransformFeedback} tf - TransformFeedback
   * @param {boolean} [contextLost=false] - If context was lost, we suppress delete TransformFeedback
   */ disposeTransformFeedback(tf, contextLost) {
        const glTF = tf._glTransformFeedbacks[this.CONTEXT_UID], gl = this.gl;
        tf.disposeRunner.remove(this);
        const bufferSystem = this.renderer.buffer;
        if (bufferSystem) for(let i = 0; i < tf.buffers.length; i++){
            const buffer = tf.buffers[i];
            if (!buffer) continue;
            const buf = buffer._glBuffers[this.CONTEXT_UID];
            buf && (buf.refCount--, buf.refCount === 0 && !contextLost && bufferSystem.dispose(buffer, contextLost));
        }
        glTF && (contextLost || gl.deleteTransformFeedback(glTF), delete tf._glTransformFeedbacks[this.CONTEXT_UID]);
    }
    destroy() {
        this.renderer = null;
    }
}
$0521c45bcf7e5f1e$export$82410eeab0646070.extension = {
    type: (0, $c90155f6d7d8d8f6$export$4f037c6ec2da4eeb).RendererSystem,
    name: "transformFeedback"
};
(0, $c90155f6d7d8d8f6$export$cc3e2d3244e01b7f).add($0521c45bcf7e5f1e$export$82410eeab0646070);





class $f5195ed6bd771101$export$6f21c3d5af6602af {
    constructor(renderer){
        this.renderer = renderer;
    }
    /**
   * initiates the view system
   * @param {PIXI.ViewOptions} options - the options for the view
   */ init(options) {
        this.screen = new (0, $200f778d7fdbf8ac$export$4617fb02663045ef)(0, 0, options.width, options.height), this.element = options.view || (0, $2808efac47e52be0$export$a5a6e0b888b2c992).ADAPTER.createCanvas(), this.resolution = options.resolution || (0, $2808efac47e52be0$export$a5a6e0b888b2c992).RESOLUTION, this.autoDensity = !!options.autoDensity;
    }
    /**
   * Resizes the screen and canvas to the specified dimensions.
   * @param desiredScreenWidth - The new width of the screen.
   * @param desiredScreenHeight - The new height of the screen.
   */ resizeView(desiredScreenWidth, desiredScreenHeight) {
        this.element.width = Math.round(desiredScreenWidth * this.resolution), this.element.height = Math.round(desiredScreenHeight * this.resolution);
        const screenWidth = this.element.width / this.resolution, screenHeight = this.element.height / this.resolution;
        this.screen.width = screenWidth, this.screen.height = screenHeight, this.autoDensity && (this.element.style.width = `${screenWidth}px`, this.element.style.height = `${screenHeight}px`), this.renderer.emit("resize", screenWidth, screenHeight), this.renderer.runners.resize.emit(this.screen.width, this.screen.height);
    }
    /**
   * Destroys this System and optionally removes the canvas from the dom.
   * @param {boolean} [removeView=false] - Whether to remove the canvas from the DOM.
   */ destroy(removeView) {
        removeView && this.element.parentNode?.removeChild(this.element), this.renderer = null, this.element = null, this.screen = null;
    }
}
$f5195ed6bd771101$export$6f21c3d5af6602af.defaultOptions = {
    /**
   * {@link PIXI.IRendererOptions.width}
   * @default 800
   * @memberof PIXI.settings.RENDER_OPTIONS
   */ width: 800,
    /**
   * {@link PIXI.IRendererOptions.height}
   * @default 600
   * @memberof PIXI.settings.RENDER_OPTIONS
   */ height: 600,
    /**
   * {@link PIXI.IRendererOptions.resolution}
   * @type {number}
   * @default PIXI.settings.RESOLUTION
   * @memberof PIXI.settings.RENDER_OPTIONS
   */ resolution: void 0,
    /**
   * {@link PIXI.IRendererOptions.autoDensity}
   * @default false
   * @memberof PIXI.settings.RENDER_OPTIONS
   */ autoDensity: !1
}, /** @ignore */ $f5195ed6bd771101$export$6f21c3d5af6602af.extension = {
    type: [
        (0, $c90155f6d7d8d8f6$export$4f037c6ec2da4eeb).RendererSystem,
        (0, $c90155f6d7d8d8f6$export$4f037c6ec2da4eeb).CanvasRendererSystem
    ],
    name: "_view"
};
(0, $c90155f6d7d8d8f6$export$cc3e2d3244e01b7f).add($f5195ed6bd771101$export$6f21c3d5af6602af);










(0, $2808efac47e52be0$export$a5a6e0b888b2c992).PREFER_ENV = (0, $0fa4b07f86297abd$export$83401e34d5e11bf4).WEBGL2;
(0, $2808efac47e52be0$export$a5a6e0b888b2c992).STRICT_TEXTURE_CACHE = !1;
(0, $2808efac47e52be0$export$a5a6e0b888b2c992).RENDER_OPTIONS = {
    ...(0, $d779c9ccd6fe69e4$export$fedaac80f6f9518c).defaultOptions,
    ...(0, $e4a4a9a559bae6fb$export$c69cd65c8827ac23).defaultOptions,
    ...(0, $f5195ed6bd771101$export$6f21c3d5af6602af).defaultOptions,
    ...(0, $418379c9781d33ac$export$8b298d2bda604a05).defaultOptions
};
Object.defineProperties((0, $2808efac47e52be0$export$a5a6e0b888b2c992), {
    /**
   * @static
   * @name WRAP_MODE
   * @memberof PIXI.settings
   * @type {PIXI.WRAP_MODES}
   * @deprecated since 7.1.0
   * @see PIXI.BaseTexture.defaultOptions.wrapMode
   */ WRAP_MODE: {
        get () {
            return (0, $30c85657f0c625d5$export$d6306e508f184154).defaultOptions.wrapMode;
        },
        set (value) {
            (0, $397b7871568e248b$export$afd31d834b512e89)("7.1.0", "settings.WRAP_MODE is deprecated, use BaseTexture.defaultOptions.wrapMode"), (0, $30c85657f0c625d5$export$d6306e508f184154).defaultOptions.wrapMode = value;
        }
    },
    /**
   * @static
   * @name SCALE_MODE
   * @memberof PIXI.settings
   * @type {PIXI.SCALE_MODES}
   * @deprecated since 7.1.0
   * @see PIXI.BaseTexture.defaultOptions.scaleMode
   */ SCALE_MODE: {
        get () {
            return (0, $30c85657f0c625d5$export$d6306e508f184154).defaultOptions.scaleMode;
        },
        set (value) {
            (0, $397b7871568e248b$export$afd31d834b512e89)("7.1.0", "settings.SCALE_MODE is deprecated, use BaseTexture.defaultOptions.scaleMode"), (0, $30c85657f0c625d5$export$d6306e508f184154).defaultOptions.scaleMode = value;
        }
    },
    /**
   * @static
   * @name MIPMAP_TEXTURES
   * @memberof PIXI.settings
   * @type {PIXI.MIPMAP_MODES}
   * @deprecated since 7.1.0
   * @see PIXI.BaseTexture.defaultOptions.mipmap
   */ MIPMAP_TEXTURES: {
        get () {
            return (0, $30c85657f0c625d5$export$d6306e508f184154).defaultOptions.mipmap;
        },
        set (value) {
            (0, $397b7871568e248b$export$afd31d834b512e89)("7.1.0", "settings.MIPMAP_TEXTURES is deprecated, use BaseTexture.defaultOptions.mipmap"), (0, $30c85657f0c625d5$export$d6306e508f184154).defaultOptions.mipmap = value;
        }
    },
    /**
   * @static
   * @name ANISOTROPIC_LEVEL
   * @memberof PIXI.settings
   * @type {number}
   * @deprecated since 7.1.0
   * @see PIXI.BaseTexture.defaultOptions.anisotropicLevel
   */ ANISOTROPIC_LEVEL: {
        get () {
            return (0, $30c85657f0c625d5$export$d6306e508f184154).defaultOptions.anisotropicLevel;
        },
        set (value) {
            (0, $397b7871568e248b$export$afd31d834b512e89)("7.1.0", "settings.ANISOTROPIC_LEVEL is deprecated, use BaseTexture.defaultOptions.anisotropicLevel"), (0, $30c85657f0c625d5$export$d6306e508f184154).defaultOptions.anisotropicLevel = value;
        }
    },
    /**
   * Default filter resolution.
   * @static
   * @name FILTER_RESOLUTION
   * @memberof PIXI.settings
   * @deprecated since 7.1.0
   * @type {number|null}
   * @see PIXI.Filter.defaultResolution
   */ FILTER_RESOLUTION: {
        get () {
            return (0, $397b7871568e248b$export$afd31d834b512e89)("7.1.0", "settings.FILTER_RESOLUTION is deprecated, use Filter.defaultResolution"), (0, $46266bc3fe6194b8$export$ec91da630f36d5ea).defaultResolution;
        },
        set (value) {
            (0, $46266bc3fe6194b8$export$ec91da630f36d5ea).defaultResolution = value;
        }
    },
    /**
   * Default filter samples.
   * @static
   * @name FILTER_MULTISAMPLE
   * @memberof PIXI.settings
   * @deprecated since 7.1.0
   * @type {PIXI.MSAA_QUALITY}
   * @see PIXI.Filter.defaultMultisample
   */ FILTER_MULTISAMPLE: {
        get () {
            return (0, $397b7871568e248b$export$afd31d834b512e89)("7.1.0", "settings.FILTER_MULTISAMPLE is deprecated, use Filter.defaultMultisample"), (0, $46266bc3fe6194b8$export$ec91da630f36d5ea).defaultMultisample;
        },
        set (value) {
            (0, $46266bc3fe6194b8$export$ec91da630f36d5ea).defaultMultisample = value;
        }
    },
    /**
   * The maximum textures that this device supports.
   * @static
   * @name SPRITE_MAX_TEXTURES
   * @memberof PIXI.settings
   * @deprecated since 7.1.0
   * @see PIXI.BatchRenderer.defaultMaxTextures
   * @type {number}
   */ SPRITE_MAX_TEXTURES: {
        get () {
            return (0, $dbdd65a7ea7fcebf$export$c6a34b759a134e1d).defaultMaxTextures;
        },
        set (value) {
            (0, $397b7871568e248b$export$afd31d834b512e89)("7.1.0", "settings.SPRITE_MAX_TEXTURES is deprecated, use BatchRenderer.defaultMaxTextures"), (0, $dbdd65a7ea7fcebf$export$c6a34b759a134e1d).defaultMaxTextures = value;
        }
    },
    /**
   * The default sprite batch size.
   *
   * The default aims to balance desktop and mobile devices.
   * @static
   * @name SPRITE_BATCH_SIZE
   * @memberof PIXI.settings
   * @see PIXI.BatchRenderer.defaultBatchSize
   * @deprecated since 7.1.0
   * @type {number}
   */ SPRITE_BATCH_SIZE: {
        get () {
            return (0, $dbdd65a7ea7fcebf$export$c6a34b759a134e1d).defaultBatchSize;
        },
        set (value) {
            (0, $397b7871568e248b$export$afd31d834b512e89)("7.1.0", "settings.SPRITE_BATCH_SIZE is deprecated, use BatchRenderer.defaultBatchSize"), (0, $dbdd65a7ea7fcebf$export$c6a34b759a134e1d).defaultBatchSize = value;
        }
    },
    /**
   * Can we upload the same buffer in a single frame?
   * @static
   * @name CAN_UPLOAD_SAME_BUFFER
   * @memberof PIXI.settings
   * @see PIXI.BatchRenderer.canUploadSameBuffer
   * @deprecated since 7.1.0
   * @type {boolean}
   */ CAN_UPLOAD_SAME_BUFFER: {
        get () {
            return (0, $dbdd65a7ea7fcebf$export$c6a34b759a134e1d).canUploadSameBuffer;
        },
        set (value) {
            (0, $397b7871568e248b$export$afd31d834b512e89)("7.1.0", "settings.CAN_UPLOAD_SAME_BUFFER is deprecated, use BatchRenderer.canUploadSameBuffer"), (0, $dbdd65a7ea7fcebf$export$c6a34b759a134e1d).canUploadSameBuffer = value;
        }
    },
    /**
   * Default Garbage Collection mode.
   * @static
   * @name GC_MODE
   * @memberof PIXI.settings
   * @type {PIXI.GC_MODES}
   * @deprecated since 7.1.0
   * @see PIXI.TextureGCSystem.defaultMode
   */ GC_MODE: {
        get () {
            return (0, $6307bf23a1a8c3d8$export$a47b032752d8e393).defaultMode;
        },
        set (value) {
            (0, $397b7871568e248b$export$afd31d834b512e89)("7.1.0", "settings.GC_MODE is deprecated, use TextureGCSystem.defaultMode"), (0, $6307bf23a1a8c3d8$export$a47b032752d8e393).defaultMode = value;
        }
    },
    /**
   * Default Garbage Collection max idle.
   * @static
   * @name GC_MAX_IDLE
   * @memberof PIXI.settings
   * @type {number}
   * @deprecated since 7.1.0
   * @see PIXI.TextureGCSystem.defaultMaxIdle
   */ GC_MAX_IDLE: {
        get () {
            return (0, $6307bf23a1a8c3d8$export$a47b032752d8e393).defaultMaxIdle;
        },
        set (value) {
            (0, $397b7871568e248b$export$afd31d834b512e89)("7.1.0", "settings.GC_MAX_IDLE is deprecated, use TextureGCSystem.defaultMaxIdle"), (0, $6307bf23a1a8c3d8$export$a47b032752d8e393).defaultMaxIdle = value;
        }
    },
    /**
   * Default Garbage Collection maximum check count.
   * @static
   * @name GC_MAX_CHECK_COUNT
   * @memberof PIXI.settings
   * @type {number}
   * @deprecated since 7.1.0
   * @see PIXI.TextureGCSystem.defaultCheckCountMax
   */ GC_MAX_CHECK_COUNT: {
        get () {
            return (0, $6307bf23a1a8c3d8$export$a47b032752d8e393).defaultCheckCountMax;
        },
        set (value) {
            (0, $397b7871568e248b$export$afd31d834b512e89)("7.1.0", "settings.GC_MAX_CHECK_COUNT is deprecated, use TextureGCSystem.defaultCheckCountMax"), (0, $6307bf23a1a8c3d8$export$a47b032752d8e393).defaultCheckCountMax = value;
        }
    },
    /**
   * Default specify float precision in vertex shader.
   * @static
   * @name PRECISION_VERTEX
   * @memberof PIXI.settings
   * @type {PIXI.PRECISION}
   * @deprecated since 7.1.0
   * @see PIXI.Program.defaultVertexPrecision
   */ PRECISION_VERTEX: {
        get () {
            return (0, $35ca18cab1598332$export$b6c59b989905b650).defaultVertexPrecision;
        },
        set (value) {
            (0, $397b7871568e248b$export$afd31d834b512e89)("7.1.0", "settings.PRECISION_VERTEX is deprecated, use Program.defaultVertexPrecision"), (0, $35ca18cab1598332$export$b6c59b989905b650).defaultVertexPrecision = value;
        }
    },
    /**
   * Default specify float precision in fragment shader.
   * @static
   * @name PRECISION_FRAGMENT
   * @memberof PIXI.settings
   * @type {PIXI.PRECISION}
   * @deprecated since 7.1.0
   * @see PIXI.Program.defaultFragmentPrecision
   */ PRECISION_FRAGMENT: {
        get () {
            return (0, $35ca18cab1598332$export$b6c59b989905b650).defaultFragmentPrecision;
        },
        set (value) {
            (0, $397b7871568e248b$export$afd31d834b512e89)("7.1.0", "settings.PRECISION_FRAGMENT is deprecated, use Program.defaultFragmentPrecision"), (0, $35ca18cab1598332$export$b6c59b989905b650).defaultFragmentPrecision = value;
        }
    }
});










var $6098ce82519589af$export$688aaf132ba9b379 = /* @__PURE__ */ ((UPDATE_PRIORITY2)=>(UPDATE_PRIORITY2[UPDATE_PRIORITY2.INTERACTION = 50] = "INTERACTION", UPDATE_PRIORITY2[UPDATE_PRIORITY2.HIGH = 25] = "HIGH", UPDATE_PRIORITY2[UPDATE_PRIORITY2.NORMAL = 0] = "NORMAL", UPDATE_PRIORITY2[UPDATE_PRIORITY2.LOW = -25] = "LOW", UPDATE_PRIORITY2[UPDATE_PRIORITY2.UTILITY = -50] = "UTILITY", UPDATE_PRIORITY2))($6098ce82519589af$export$688aaf132ba9b379 || {});


class $cc59c509b0c9b86d$export$579021a5759a260f {
    /**
   * Constructor
   * @private
   * @param fn - The listener function to be added for one update
   * @param context - The listener context
   * @param priority - The priority for emitting
   * @param once - If the handler should fire once
   */ constructor(fn, context = null, priority = 0, once = !1){
        this.next = null, this.previous = null, this._destroyed = !1, this.fn = fn, this.context = context, this.priority = priority, this.once = once;
    }
    /**
   * Simple compare function to figure out if a function and context match.
   * @private
   * @param fn - The listener function to be added for one update
   * @param context - The listener context
   * @returns `true` if the listener match the arguments
   */ match(fn, context = null) {
        return this.fn === fn && this.context === context;
    }
    /**
   * Emit by calling the current function.
   * @private
   * @param deltaTime - time since the last emit.
   * @returns Next ticker
   */ emit(deltaTime) {
        this.fn && (this.context ? this.fn.call(this.context, deltaTime) : this.fn(deltaTime));
        const redirect = this.next;
        return this.once && this.destroy(!0), this._destroyed && (this.next = null), redirect;
    }
    /**
   * Connect to the list.
   * @private
   * @param previous - Input node, previous listener
   */ connect(previous) {
        this.previous = previous, previous.next && (previous.next.previous = this), this.next = previous.next, previous.next = this;
    }
    /**
   * Destroy and don't use after this.
   * @private
   * @param hard - `true` to remove the `next` reference, this
   *        is considered a hard destroy. Soft destroy maintains the next reference.
   * @returns The listener to redirect while emitting or removing.
   */ destroy(hard = !1) {
        this._destroyed = !0, this.fn = null, this.context = null, this.previous && (this.previous.next = this.next), this.next && (this.next.previous = this.previous);
        const redirect = this.next;
        return this.next = hard ? null : redirect, this.previous = null, redirect;
    }
}


const $e6b36730368844b1$var$_Ticker = class _Ticker2 {
    constructor(){
        this.autoStart = !1, this.deltaTime = 1, this.lastTime = -1, this.speed = 1, this.started = !1, this._requestId = null, this._maxElapsedMS = 100, this._minElapsedMS = 0, this._protected = !1, this._lastFrame = -1, this._head = new (0, $cc59c509b0c9b86d$export$579021a5759a260f)(null, null, 1 / 0), this.deltaMS = 1 / _Ticker2.targetFPMS, this.elapsedMS = 1 / _Ticker2.targetFPMS, this._tick = (time)=>{
            this._requestId = null, this.started && (this.update(time), this.started && this._requestId === null && this._head.next && (this._requestId = requestAnimationFrame(this._tick)));
        };
    }
    /**
   * Conditionally requests a new animation frame.
   * If a frame has not already been requested, and if the internal
   * emitter has listeners, a new frame is requested.
   * @private
   */ _requestIfNeeded() {
        this._requestId === null && this._head.next && (this.lastTime = performance.now(), this._lastFrame = this.lastTime, this._requestId = requestAnimationFrame(this._tick));
    }
    /**
   * Conditionally cancels a pending animation frame.
   * @private
   */ _cancelIfNeeded() {
        this._requestId !== null && (cancelAnimationFrame(this._requestId), this._requestId = null);
    }
    /**
   * Conditionally requests a new animation frame.
   * If the ticker has been started it checks if a frame has not already
   * been requested, and if the internal emitter has listeners. If these
   * conditions are met, a new frame is requested. If the ticker has not
   * been started, but autoStart is `true`, then the ticker starts now,
   * and continues with the previous conditions to request a new frame.
   * @private
   */ _startIfPossible() {
        this.started ? this._requestIfNeeded() : this.autoStart && this.start();
    }
    /**
   * Register a handler for tick events. Calls continuously unless
   * it is removed or the ticker is stopped.
   * @param fn - The listener function to be added for updates
   * @param context - The listener context
   * @param {number} [priority=PIXI.UPDATE_PRIORITY.NORMAL] - The priority for emitting
   * @returns This instance of a ticker
   */ add(fn, context, priority = (0, $6098ce82519589af$export$688aaf132ba9b379).NORMAL) {
        return this._addListener(new (0, $cc59c509b0c9b86d$export$579021a5759a260f)(fn, context, priority));
    }
    /**
   * Add a handler for the tick event which is only execute once.
   * @param fn - The listener function to be added for one update
   * @param context - The listener context
   * @param {number} [priority=PIXI.UPDATE_PRIORITY.NORMAL] - The priority for emitting
   * @returns This instance of a ticker
   */ addOnce(fn, context, priority = (0, $6098ce82519589af$export$688aaf132ba9b379).NORMAL) {
        return this._addListener(new (0, $cc59c509b0c9b86d$export$579021a5759a260f)(fn, context, priority, !0));
    }
    /**
   * Internally adds the event handler so that it can be sorted by priority.
   * Priority allows certain handler (user, AnimatedSprite, Interaction) to be run
   * before the rendering.
   * @private
   * @param listener - Current listener being added.
   * @returns This instance of a ticker
   */ _addListener(listener) {
        let current = this._head.next, previous = this._head;
        if (!current) listener.connect(previous);
        else {
            for(; current;){
                if (listener.priority > current.priority) {
                    listener.connect(previous);
                    break;
                }
                previous = current, current = current.next;
            }
            listener.previous || listener.connect(previous);
        }
        return this._startIfPossible(), this;
    }
    /**
   * Removes any handlers matching the function and context parameters.
   * If no handlers are left after removing, then it cancels the animation frame.
   * @param fn - The listener function to be removed
   * @param context - The listener context to be removed
   * @returns This instance of a ticker
   */ remove(fn, context) {
        let listener = this._head.next;
        for(; listener;)listener.match(fn, context) ? listener = listener.destroy() : listener = listener.next;
        return this._head.next || this._cancelIfNeeded(), this;
    }
    /**
   * The number of listeners on this ticker, calculated by walking through linked list
   * @readonly
   * @member {number}
   */ get count() {
        if (!this._head) return 0;
        let count = 0, current = this._head;
        for(; current = current.next;)count++;
        return count;
    }
    /** Starts the ticker. If the ticker has listeners a new animation frame is requested at this point. */ start() {
        this.started || (this.started = !0, this._requestIfNeeded());
    }
    /** Stops the ticker. If the ticker has requested an animation frame it is canceled at this point. */ stop() {
        this.started && (this.started = !1, this._cancelIfNeeded());
    }
    /** Destroy the ticker and don't use after this. Calling this method removes all references to internal events. */ destroy() {
        if (!this._protected) {
            this.stop();
            let listener = this._head.next;
            for(; listener;)listener = listener.destroy(!0);
            this._head.destroy(), this._head = null;
        }
    }
    /**
   * Triggers an update. An update entails setting the
   * current {@link PIXI.Ticker#elapsedMS},
   * the current {@link PIXI.Ticker#deltaTime},
   * invoking all listeners with current deltaTime,
   * and then finally setting {@link PIXI.Ticker#lastTime}
   * with the value of currentTime that was provided.
   * This method will be called automatically by animation
   * frame callbacks if the ticker instance has been started
   * and listeners are added.
   * @param {number} [currentTime=performance.now()] - the current time of execution
   */ update(currentTime = performance.now()) {
        let elapsedMS;
        if (currentTime > this.lastTime) {
            if (elapsedMS = this.elapsedMS = currentTime - this.lastTime, elapsedMS > this._maxElapsedMS && (elapsedMS = this._maxElapsedMS), elapsedMS *= this.speed, this._minElapsedMS) {
                const delta = currentTime - this._lastFrame | 0;
                if (delta < this._minElapsedMS) return;
                this._lastFrame = currentTime - delta % this._minElapsedMS;
            }
            this.deltaMS = elapsedMS, this.deltaTime = this.deltaMS * _Ticker2.targetFPMS;
            const head = this._head;
            let listener = head.next;
            for(; listener;)listener = listener.emit(this.deltaTime);
            head.next || this._cancelIfNeeded();
        } else this.deltaTime = this.deltaMS = this.elapsedMS = 0;
        this.lastTime = currentTime;
    }
    /**
   * The frames per second at which this ticker is running.
   * The default is approximately 60 in most modern browsers.
   * **Note:** This does not factor in the value of
   * {@link PIXI.Ticker#speed}, which is specific
   * to scaling {@link PIXI.Ticker#deltaTime}.
   * @member {number}
   * @readonly
   */ get FPS() {
        return 1e3 / this.elapsedMS;
    }
    /**
   * Manages the maximum amount of milliseconds allowed to
   * elapse between invoking {@link PIXI.Ticker#update}.
   * This value is used to cap {@link PIXI.Ticker#deltaTime},
   * but does not effect the measured value of {@link PIXI.Ticker#FPS}.
   * When setting this property it is clamped to a value between
   * `0` and `Ticker.targetFPMS * 1000`.
   * @member {number}
   * @default 10
   */ get minFPS() {
        return 1e3 / this._maxElapsedMS;
    }
    set minFPS(fps) {
        const minFPS = Math.min(this.maxFPS, fps), minFPMS = Math.min(Math.max(0, minFPS) / 1e3, _Ticker2.targetFPMS);
        this._maxElapsedMS = 1 / minFPMS;
    }
    /**
   * Manages the minimum amount of milliseconds required to
   * elapse between invoking {@link PIXI.Ticker#update}.
   * This will effect the measured value of {@link PIXI.Ticker#FPS}.
   * If it is set to `0`, then there is no limit; PixiJS will render as many frames as it can.
   * Otherwise it will be at least `minFPS`
   * @member {number}
   * @default 0
   */ get maxFPS() {
        return this._minElapsedMS ? Math.round(1e3 / this._minElapsedMS) : 0;
    }
    set maxFPS(fps) {
        if (fps === 0) this._minElapsedMS = 0;
        else {
            const maxFPS = Math.max(this.minFPS, fps);
            this._minElapsedMS = 1 / (maxFPS / 1e3);
        }
    }
    /**
   * The shared ticker instance used by {@link PIXI.AnimatedSprite} and by
   * {@link PIXI.VideoResource} to update animation frames / video textures.
   *
   * It may also be used by {@link PIXI.Application} if created with the `sharedTicker` option property set to true.
   *
   * The property {@link PIXI.Ticker#autoStart} is set to `true` for this instance.
   * Please follow the examples for usage, including how to opt-out of auto-starting the shared ticker.
   * @example
   * import { Ticker } from 'pixi.js';
   *
   * const ticker = Ticker.shared;
   * // Set this to prevent starting this ticker when listeners are added.
   * // By default this is true only for the PIXI.Ticker.shared instance.
   * ticker.autoStart = false;
   *
   * // FYI, call this to ensure the ticker is stopped. It should be stopped
   * // if you have not attempted to render anything yet.
   * ticker.stop();
   *
   * // Call this when you are ready for a running shared ticker.
   * ticker.start();
   * @example
   * import { autoDetectRenderer, Container } from 'pixi.js';
   *
   * // You may use the shared ticker to render...
   * const renderer = autoDetectRenderer();
   * const stage = new Container();
   * document.body.appendChild(renderer.view);
   * ticker.add((time) => renderer.render(stage));
   *
   * // Or you can just update it manually.
   * ticker.autoStart = false;
   * ticker.stop();
   * const animate = (time) => {
   *     ticker.update(time);
   *     renderer.render(stage);
   *     requestAnimationFrame(animate);
   * };
   * animate(performance.now());
   * @member {PIXI.Ticker}
   * @static
   */ static get shared() {
        if (!_Ticker2._shared) {
            const shared = _Ticker2._shared = new _Ticker2();
            shared.autoStart = !0, shared._protected = !0;
        }
        return _Ticker2._shared;
    }
    /**
   * The system ticker instance used by {@link PIXI.BasePrepare} for core timing
   * functionality that shouldn't usually need to be paused, unlike the `shared`
   * ticker which drives visual animations and rendering which may want to be paused.
   *
   * The property {@link PIXI.Ticker#autoStart} is set to `true` for this instance.
   * @member {PIXI.Ticker}
   * @static
   */ static get system() {
        if (!_Ticker2._system) {
            const system = _Ticker2._system = new _Ticker2();
            system.autoStart = !0, system._protected = !0;
        }
        return _Ticker2._system;
    }
};
$e6b36730368844b1$var$_Ticker.targetFPMS = 0.06;
let $e6b36730368844b1$export$39c54bcc89dcee11 = $e6b36730368844b1$var$_Ticker;


Object.defineProperties((0, $2808efac47e52be0$export$a5a6e0b888b2c992), {
    /**
   * Target frames per millisecond.
   * @static
   * @name TARGET_FPMS
   * @memberof PIXI.settings
   * @type {number}
   * @deprecated since 7.1.0
   * @see PIXI.Ticker.targetFPMS
   */ TARGET_FPMS: {
        get () {
            return (0, $e6b36730368844b1$export$39c54bcc89dcee11).targetFPMS;
        },
        set (value) {
            (0, $397b7871568e248b$export$afd31d834b512e89)("7.1.0", "settings.TARGET_FPMS is deprecated, use Ticker.targetFPMS"), (0, $e6b36730368844b1$export$39c54bcc89dcee11).targetFPMS = value;
        }
    }
});







class $3e8778b0fb9cdb73$export$50c361ceb4e2f4f0 {
    /**
   * Initialize the plugin with scope of application instance
   * @static
   * @private
   * @param {object} [options] - See application options
   */ static init(options) {
        options = Object.assign({
            autoStart: !0,
            sharedTicker: !1
        }, options), Object.defineProperty(this, "ticker", {
            set (ticker) {
                this._ticker && this._ticker.remove(this.render, this), this._ticker = ticker, ticker && ticker.add(this.render, this, (0, $6098ce82519589af$export$688aaf132ba9b379).LOW);
            },
            get () {
                return this._ticker;
            }
        }), this.stop = ()=>{
            this._ticker.stop();
        }, this.start = ()=>{
            this._ticker.start();
        }, this._ticker = null, this.ticker = options.sharedTicker ? (0, $e6b36730368844b1$export$39c54bcc89dcee11).shared : new (0, $e6b36730368844b1$export$39c54bcc89dcee11)(), options.autoStart && this.start();
    }
    /**
   * Clean up the ticker, scoped to application.
   * @static
   * @private
   */ static destroy() {
        if (this._ticker) {
            const oldTicker = this._ticker;
            this.ticker = null, oldTicker.destroy();
        }
    }
}
$3e8778b0fb9cdb73$export$50c361ceb4e2f4f0.extension = (0, $c90155f6d7d8d8f6$export$4f037c6ec2da4eeb).Application;
(0, $c90155f6d7d8d8f6$export$cc3e2d3244e01b7f).add($3e8778b0fb9cdb73$export$50c361ceb4e2f4f0);






const $d7c11949c329125b$var$renderers = [];
(0, $c90155f6d7d8d8f6$export$cc3e2d3244e01b7f).handleByList((0, $c90155f6d7d8d8f6$export$4f037c6ec2da4eeb).Renderer, $d7c11949c329125b$var$renderers);
function $d7c11949c329125b$export$3583b92ab8150eb6(options) {
    for (const RendererType of $d7c11949c329125b$var$renderers)if (RendererType.test(options)) return new RendererType(options);
    throw new Error("Unable to auto-detect a suitable renderer.");
}

















var $c4e4e2738673abaf$export$2e2bcd8739ae039 = `attribute vec2 aVertexPosition;
attribute vec2 aTextureCoord;

uniform mat3 projectionMatrix;

varying vec2 vTextureCoord;

void main(void)
{
    gl_Position = vec4((projectionMatrix * vec3(aVertexPosition, 1.0)).xy, 0.0, 1.0);
    vTextureCoord = aTextureCoord;
}`;


var $2eed735934bc5927$export$2e2bcd8739ae039 = `attribute vec2 aVertexPosition;

uniform mat3 projectionMatrix;

varying vec2 vTextureCoord;

uniform vec4 inputSize;
uniform vec4 outputFrame;

vec4 filterVertexPosition( void )
{
    vec2 position = aVertexPosition * max(outputFrame.zw, vec2(0.)) + outputFrame.xy;

    return vec4((projectionMatrix * vec3(position, 1.0)).xy, 0.0, 1.0);
}

vec2 filterTextureCoord( void )
{
    return aVertexPosition * (outputFrame.zw * inputSize.zw);
}

void main(void)
{
    gl_Position = filterVertexPosition();
    vTextureCoord = filterTextureCoord();
}
`;


const $cd81e2f0e1d30179$export$4a1a95006fc6b0f1 = (0, $c4e4e2738673abaf$export$2e2bcd8739ae039), $cd81e2f0e1d30179$export$198627d10d1d088f = (0, $2eed735934bc5927$export$2e2bcd8739ae039);







class $a411e722c918e24c$export$714ab7ecf6d70c30 {
    constructor(renderer){
        this.renderer = renderer;
    }
    contextChange(gl) {
        let samples;
        if (this.renderer.context.webGLVersion === 1) {
            const framebuffer = gl.getParameter(gl.FRAMEBUFFER_BINDING);
            gl.bindFramebuffer(gl.FRAMEBUFFER, null), samples = gl.getParameter(gl.SAMPLES), gl.bindFramebuffer(gl.FRAMEBUFFER, framebuffer);
        } else {
            const framebuffer = gl.getParameter(gl.DRAW_FRAMEBUFFER_BINDING);
            gl.bindFramebuffer(gl.DRAW_FRAMEBUFFER, null), samples = gl.getParameter(gl.SAMPLES), gl.bindFramebuffer(gl.DRAW_FRAMEBUFFER, framebuffer);
        }
        samples >= (0, $0fa4b07f86297abd$export$1eadd657d5acc2f2).HIGH ? this.multisample = (0, $0fa4b07f86297abd$export$1eadd657d5acc2f2).HIGH : samples >= (0, $0fa4b07f86297abd$export$1eadd657d5acc2f2).MEDIUM ? this.multisample = (0, $0fa4b07f86297abd$export$1eadd657d5acc2f2).MEDIUM : samples >= (0, $0fa4b07f86297abd$export$1eadd657d5acc2f2).LOW ? this.multisample = (0, $0fa4b07f86297abd$export$1eadd657d5acc2f2).LOW : this.multisample = (0, $0fa4b07f86297abd$export$1eadd657d5acc2f2).NONE;
    }
    destroy() {}
}
$a411e722c918e24c$export$714ab7ecf6d70c30.extension = {
    type: (0, $c90155f6d7d8d8f6$export$4f037c6ec2da4eeb).RendererSystem,
    name: "_multisample"
};
(0, $c90155f6d7d8d8f6$export$cc3e2d3244e01b7f).add($a411e722c918e24c$export$714ab7ecf6d70c30);





class $69c2663b53e875fa$export$5185dfb57661e267 {
    constructor(buffer){
        this.buffer = buffer || null, this.updateID = -1, this.byteLength = -1, this.refCount = 0;
    }
}


class $9eb622695591f0c0$export$4010e50dab7d72d0 {
    /**
   * @param {PIXI.Renderer} renderer - The renderer this System works for.
   */ constructor(renderer){
        this.renderer = renderer, this.managedBuffers = {}, this.boundBufferBases = {};
    }
    /**
   * @ignore
   */ destroy() {
        this.renderer = null;
    }
    /** Sets up the renderer context and necessary buffers. */ contextChange() {
        this.disposeAll(!0), this.gl = this.renderer.gl, this.CONTEXT_UID = this.renderer.CONTEXT_UID;
    }
    /**
   * This binds specified buffer. On first run, it will create the webGL buffers for the context too
   * @param buffer - the buffer to bind to the renderer
   */ bind(buffer) {
        const { gl: gl, CONTEXT_UID: CONTEXT_UID } = this, glBuffer = buffer._glBuffers[CONTEXT_UID] || this.createGLBuffer(buffer);
        gl.bindBuffer(buffer.type, glBuffer.buffer);
    }
    unbind(type) {
        const { gl: gl } = this;
        gl.bindBuffer(type, null);
    }
    /**
   * Binds an uniform buffer to at the given index.
   *
   * A cache is used so a buffer will not be bound again if already bound.
   * @param buffer - the buffer to bind
   * @param index - the base index to bind it to.
   */ bindBufferBase(buffer, index) {
        const { gl: gl, CONTEXT_UID: CONTEXT_UID } = this;
        if (this.boundBufferBases[index] !== buffer) {
            const glBuffer = buffer._glBuffers[CONTEXT_UID] || this.createGLBuffer(buffer);
            this.boundBufferBases[index] = buffer, gl.bindBufferBase(gl.UNIFORM_BUFFER, index, glBuffer.buffer);
        }
    }
    /**
   * Binds a buffer whilst also binding its range.
   * This will make the buffer start from the offset supplied rather than 0 when it is read.
   * @param buffer - the buffer to bind
   * @param index - the base index to bind at, defaults to 0
   * @param offset - the offset to bind at (this is blocks of 256). 0 = 0, 1 = 256, 2 = 512 etc
   */ bindBufferRange(buffer, index, offset) {
        const { gl: gl, CONTEXT_UID: CONTEXT_UID } = this;
        offset = offset || 0;
        const glBuffer = buffer._glBuffers[CONTEXT_UID] || this.createGLBuffer(buffer);
        gl.bindBufferRange(gl.UNIFORM_BUFFER, index || 0, glBuffer.buffer, offset * 256, 256);
    }
    /**
   * Will ensure the data in the buffer is uploaded to the GPU.
   * @param {PIXI.Buffer} buffer - the buffer to update
   */ update(buffer) {
        const { gl: gl, CONTEXT_UID: CONTEXT_UID } = this, glBuffer = buffer._glBuffers[CONTEXT_UID] || this.createGLBuffer(buffer);
        if (buffer._updateID !== glBuffer.updateID) {
            if (glBuffer.updateID = buffer._updateID, gl.bindBuffer(buffer.type, glBuffer.buffer), glBuffer.byteLength >= buffer.data.byteLength) gl.bufferSubData(buffer.type, 0, buffer.data);
            else {
                const drawType = buffer.static ? gl.STATIC_DRAW : gl.DYNAMIC_DRAW;
                glBuffer.byteLength = buffer.data.byteLength, gl.bufferData(buffer.type, buffer.data, drawType);
            }
        }
    }
    /**
   * Disposes buffer
   * @param {PIXI.Buffer} buffer - buffer with data
   * @param {boolean} [contextLost=false] - If context was lost, we suppress deleteVertexArray
   */ dispose(buffer, contextLost) {
        if (!this.managedBuffers[buffer.id]) return;
        delete this.managedBuffers[buffer.id];
        const glBuffer = buffer._glBuffers[this.CONTEXT_UID], gl = this.gl;
        buffer.disposeRunner.remove(this), glBuffer && (contextLost || gl.deleteBuffer(glBuffer.buffer), delete buffer._glBuffers[this.CONTEXT_UID]);
    }
    /**
   * dispose all WebGL resources of all managed buffers
   * @param {boolean} [contextLost=false] - If context was lost, we suppress `gl.delete` calls
   */ disposeAll(contextLost) {
        const all = Object.keys(this.managedBuffers);
        for(let i = 0; i < all.length; i++)this.dispose(this.managedBuffers[all[i]], contextLost);
    }
    /**
   * creates and attaches a GLBuffer object tied to the current context.
   * @param buffer
   * @protected
   */ createGLBuffer(buffer) {
        const { CONTEXT_UID: CONTEXT_UID, gl: gl } = this;
        return buffer._glBuffers[CONTEXT_UID] = new (0, $69c2663b53e875fa$export$5185dfb57661e267)(gl.createBuffer()), this.managedBuffers[buffer.id] = buffer, buffer.disposeRunner.add(this), buffer._glBuffers[CONTEXT_UID];
    }
}
$9eb622695591f0c0$export$4010e50dab7d72d0.extension = {
    type: (0, $c90155f6d7d8d8f6$export$4f037c6ec2da4eeb).RendererSystem,
    name: "buffer"
};
(0, $c90155f6d7d8d8f6$export$cc3e2d3244e01b7f).add($9eb622695591f0c0$export$4010e50dab7d72d0);














class $1d625ef14192e4a0$export$50cc3c4d71ad3547 {
    // renderers scene graph!
    constructor(renderer){
        this.renderer = renderer;
    }
    /**
   * Renders the object to its WebGL view.
   * @param displayObject - The object to be rendered.
   * @param options - the options to be passed to the renderer
   */ render(displayObject, options) {
        const renderer = this.renderer;
        let renderTexture, clear, transform, skipUpdateTransform;
        if (options && (renderTexture = options.renderTexture, clear = options.clear, transform = options.transform, skipUpdateTransform = options.skipUpdateTransform), this.renderingToScreen = !renderTexture, renderer.runners.prerender.emit(), renderer.emit("prerender"), renderer.projection.transform = transform, !renderer.context.isLost) {
            if (renderTexture || (this.lastObjectRendered = displayObject), !skipUpdateTransform) {
                const cacheParent = displayObject.enableTempParent();
                displayObject.updateTransform(), displayObject.disableTempParent(cacheParent);
            }
            renderer.renderTexture.bind(renderTexture), renderer.batch.currentRenderer.start(), (clear ?? renderer.background.clearBeforeRender) && renderer.renderTexture.clear(), displayObject.render(renderer), renderer.batch.currentRenderer.flush(), renderTexture && (options.blit && renderer.framebuffer.blit(), renderTexture.baseTexture.update()), renderer.runners.postrender.emit(), renderer.projection.transform = null, renderer.emit("postrender");
        }
    }
    destroy() {
        this.renderer = null, this.lastObjectRendered = null;
    }
}
$1d625ef14192e4a0$export$50cc3c4d71ad3547.extension = {
    type: (0, $c90155f6d7d8d8f6$export$4f037c6ec2da4eeb).RendererSystem,
    name: "objectRenderer"
};
(0, $c90155f6d7d8d8f6$export$cc3e2d3244e01b7f).add($1d625ef14192e4a0$export$50cc3c4d71ad3547);









const $4197ec581f1662d1$var$_Renderer = class _Renderer2 extends (0, $a33f3b42884b2574$export$a12e67a4b4590901) {
    /**
   * @param {PIXI.IRendererOptions} [options] - See {@link PIXI.settings.RENDER_OPTIONS} for defaults.
   */ constructor(options){
        super(), this.type = (0, $0fa4b07f86297abd$export$747c566515e2a1d9).WEBGL, options = Object.assign({}, (0, $2808efac47e52be0$export$a5a6e0b888b2c992).RENDER_OPTIONS, options), this.gl = null, this.CONTEXT_UID = 0, this.globalUniforms = new (0, $8380fc86b6e89a36$export$6601a7a2dcf79bf5)({
            projectionMatrix: new (0, $d7da222aa639cde0$export$5b12bf1653c0dd85)()
        }, !0);
        const systemConfig = {
            runners: [
                "init",
                "destroy",
                "contextChange",
                "resolutionChange",
                "reset",
                "update",
                "postrender",
                "prerender",
                "resize"
            ],
            systems: _Renderer2.__systems,
            priority: [
                "_view",
                "textureGenerator",
                "background",
                "_plugin",
                "startup",
                // low level WebGL systems
                "context",
                "state",
                "texture",
                "buffer",
                "geometry",
                "framebuffer",
                "transformFeedback",
                // high level pixi specific rendering
                "mask",
                "scissor",
                "stencil",
                "projection",
                "textureGC",
                "filter",
                "renderTexture",
                "batch",
                "objectRenderer",
                "_multisample"
            ]
        };
        this.setup(systemConfig), "useContextAlpha" in options && ((0, $397b7871568e248b$export$afd31d834b512e89)("7.0.0", "options.useContextAlpha is deprecated, use options.premultipliedAlpha and options.backgroundAlpha instead"), options.premultipliedAlpha = options.useContextAlpha && options.useContextAlpha !== "notMultiplied", options.backgroundAlpha = options.useContextAlpha === !1 ? 1 : options.backgroundAlpha), this._plugin.rendererPlugins = _Renderer2.__plugins, this.options = options, this.startup.run(this.options);
    }
    /**
   * Create renderer if WebGL is available. Overrideable
   * by the **@pixi/canvas-renderer** package to allow fallback.
   * throws error if WebGL is not available.
   * @param options
   * @private
   */ static test(options) {
        return options?.forceCanvas ? !1 : (0, $9f5163a850bf3393$export$83dc396b76015322)();
    }
    /**
   * Renders the object to its WebGL view.
   * @param displayObject - The object to be rendered.
   * @param {object} [options] - Object to use for render options.
   * @param {PIXI.RenderTexture} [options.renderTexture] - The render texture to render to.
   * @param {boolean} [options.clear=true] - Should the canvas be cleared before the new render.
   * @param {PIXI.Matrix} [options.transform] - A transform to apply to the render texture before rendering.
   * @param {boolean} [options.skipUpdateTransform=false] - Should we skip the update transform pass?
   */ render(displayObject, options) {
        this.objectRenderer.render(displayObject, options);
    }
    /**
   * Resizes the WebGL view to the specified width and height.
   * @param desiredScreenWidth - The desired width of the screen.
   * @param desiredScreenHeight - The desired height of the screen.
   */ resize(desiredScreenWidth, desiredScreenHeight) {
        this._view.resizeView(desiredScreenWidth, desiredScreenHeight);
    }
    /**
   * Resets the WebGL state so you can render things however you fancy!
   * @returns Returns itself.
   */ reset() {
        return this.runners.reset.emit(), this;
    }
    /** Clear the frame buffer. */ clear() {
        this.renderTexture.bind(), this.renderTexture.clear();
    }
    /**
   * Removes everything from the renderer (event listeners, spritebatch, etc...)
   * @param [removeView=false] - Removes the Canvas element from the DOM.
   *  See: https://github.com/pixijs/pixijs/issues/2233
   */ destroy(removeView = !1) {
        this.runners.destroy.items.reverse(), this.emitWithCustomOptions(this.runners.destroy, {
            _view: removeView
        }), super.destroy();
    }
    /** Collection of plugins */ get plugins() {
        return this._plugin.plugins;
    }
    /** The number of msaa samples of the canvas. */ get multisample() {
        return this._multisample.multisample;
    }
    /**
   * Same as view.width, actual number of pixels in the canvas by horizontal.
   * @member {number}
   * @readonly
   * @default 800
   */ get width() {
        return this._view.element.width;
    }
    /**
   * Same as view.height, actual number of pixels in the canvas by vertical.
   * @default 600
   */ get height() {
        return this._view.element.height;
    }
    /** The resolution / device pixel ratio of the renderer. */ get resolution() {
        return this._view.resolution;
    }
    set resolution(value) {
        this._view.resolution = value, this.runners.resolutionChange.emit(value);
    }
    /** Whether CSS dimensions of canvas view should be resized to screen dimensions automatically. */ get autoDensity() {
        return this._view.autoDensity;
    }
    /** The canvas element that everything is drawn to.*/ get view() {
        return this._view.element;
    }
    /**
   * Measurements of the screen. (0, 0, screenWidth, screenHeight).
   *
   * Its safe to use as filterArea or hitArea for the whole stage.
   * @member {PIXI.Rectangle}
   */ get screen() {
        return this._view.screen;
    }
    /** the last object rendered by the renderer. Useful for other plugins like interaction managers */ get lastObjectRendered() {
        return this.objectRenderer.lastObjectRendered;
    }
    /** Flag if we are rendering to the screen vs renderTexture */ get renderingToScreen() {
        return this.objectRenderer.renderingToScreen;
    }
    /** When logging Pixi to the console, this is the name we will show */ get rendererLogId() {
        return `WebGL ${this.context.webGLVersion}`;
    }
    /**
   * This sets weather the screen is totally cleared between each frame withthe background color and alpha
   * @deprecated since 7.0.0
   */ get clearBeforeRender() {
        return (0, $397b7871568e248b$export$afd31d834b512e89)("7.0.0", "renderer.clearBeforeRender has been deprecated, please use renderer.background.clearBeforeRender instead."), this.background.clearBeforeRender;
    }
    /**
   * Pass-thru setting for the canvas' context `alpha` property. This is typically
   * not something you need to fiddle with. If you want transparency, use `backgroundAlpha`.
   * @deprecated since 7.0.0
   * @member {boolean}
   */ get useContextAlpha() {
        return (0, $397b7871568e248b$export$afd31d834b512e89)("7.0.0", "renderer.useContextAlpha has been deprecated, please use renderer.context.premultipliedAlpha instead."), this.context.useContextAlpha;
    }
    /**
   * readonly drawing buffer preservation
   * we can only know this if Pixi created the context
   * @deprecated since 7.0.0
   */ get preserveDrawingBuffer() {
        return (0, $397b7871568e248b$export$afd31d834b512e89)("7.0.0", "renderer.preserveDrawingBuffer has been deprecated, we cannot truly know this unless pixi created the context"), this.context.preserveDrawingBuffer;
    }
    /**
   * The background color to fill if not transparent
   * @member {number}
   * @deprecated since 7.0.0
   */ get backgroundColor() {
        return (0, $397b7871568e248b$export$afd31d834b512e89)("7.0.0", "renderer.backgroundColor has been deprecated, use renderer.background.color instead."), this.background.color;
    }
    set backgroundColor(value) {
        (0, $397b7871568e248b$export$afd31d834b512e89)("7.0.0", "renderer.backgroundColor has been deprecated, use renderer.background.color instead."), this.background.color = value;
    }
    /**
   * The background color alpha. Setting this to 0 will make the canvas transparent.
   * @member {number}
   * @deprecated since 7.0.0
   */ get backgroundAlpha() {
        return (0, $397b7871568e248b$export$afd31d834b512e89)("7.0.0", "renderer.backgroundAlpha has been deprecated, use renderer.background.alpha instead."), this.background.alpha;
    }
    /**
   * @deprecated since 7.0.0
   */ set backgroundAlpha(value) {
        (0, $397b7871568e248b$export$afd31d834b512e89)("7.0.0", "renderer.backgroundAlpha has been deprecated, use renderer.background.alpha instead."), this.background.alpha = value;
    }
    /**
   * @deprecated since 7.0.0
   */ get powerPreference() {
        return (0, $397b7871568e248b$export$afd31d834b512e89)("7.0.0", "renderer.powerPreference has been deprecated, we can only know this if pixi creates the context"), this.context.powerPreference;
    }
    /**
   * Useful function that returns a texture of the display object that can then be used to create sprites
   * This can be quite useful if your displayObject is complicated and needs to be reused multiple times.
   * @param displayObject - The displayObject the object will be generated from.
   * @param {IGenerateTextureOptions} options - Generate texture options.
   * @param {PIXI.Rectangle} options.region - The region of the displayObject, that shall be rendered,
   *        if no region is specified, defaults to the local bounds of the displayObject.
   * @param {number} [options.resolution] - If not given, the renderer's resolution is used.
   * @param {PIXI.MSAA_QUALITY} [options.multisample] - If not given, the renderer's multisample is used.
   * @returns A texture of the graphics object.
   */ generateTexture(displayObject, options) {
        return this.textureGenerator.generateTexture(displayObject, options);
    }
};
$4197ec581f1662d1$var$_Renderer.extension = {
    type: (0, $c90155f6d7d8d8f6$export$4f037c6ec2da4eeb).Renderer,
    priority: 1
}, /**
* Collection of installed plugins. These are included by default in PIXI, but can be excluded
* by creating a custom build. Consult the README for more information about creating custom
* builds and excluding plugins.
* @private
*/ $4197ec581f1662d1$var$_Renderer.__plugins = {}, /**
* The collection of installed systems.
* @private
*/ $4197ec581f1662d1$var$_Renderer.__systems = {};
let $4197ec581f1662d1$export$88530751e3977073 = $4197ec581f1662d1$var$_Renderer;
(0, $c90155f6d7d8d8f6$export$cc3e2d3244e01b7f).handleByMap((0, $c90155f6d7d8d8f6$export$4f037c6ec2da4eeb).RendererPlugin, $4197ec581f1662d1$export$88530751e3977073.__plugins);
(0, $c90155f6d7d8d8f6$export$cc3e2d3244e01b7f).handleByMap((0, $c90155f6d7d8d8f6$export$4f037c6ec2da4eeb).RendererSystem, $4197ec581f1662d1$export$88530751e3977073.__systems);
(0, $c90155f6d7d8d8f6$export$cc3e2d3244e01b7f).add($4197ec581f1662d1$export$88530751e3977073);






























class $02efb8b7d5be2c31$export$195275694901de82 extends (0, $f0aa4c46d7a26335$export$39a853cfb5a94a63) {
    /**
   * @param length
   * @param options - Options to for Resource constructor
   * @param {number} [options.width] - Width of the resource
   * @param {number} [options.height] - Height of the resource
   */ constructor(length, options){
        const { width: width, height: height } = options || {};
        super(width, height), this.items = [], this.itemDirtyIds = [];
        for(let i = 0; i < length; i++){
            const partTexture = new (0, $30c85657f0c625d5$export$d6306e508f184154)();
            this.items.push(partTexture), this.itemDirtyIds.push(-2);
        }
        this.length = length, this._load = null, this.baseTexture = null;
    }
    /**
   * Used from ArrayResource and CubeResource constructors.
   * @param resources - Can be resources, image elements, canvas, etc. ,
   *  length should be same as constructor length
   * @param options - Detect options for resources
   */ initFromArray(resources, options) {
        for(let i = 0; i < this.length; i++)resources[i] && (resources[i].castToBaseTexture ? this.addBaseTextureAt(resources[i].castToBaseTexture(), i) : resources[i] instanceof (0, $f0aa4c46d7a26335$export$39a853cfb5a94a63) ? this.addResourceAt(resources[i], i) : this.addResourceAt((0, $0ab0288141919131$export$5eb9e949a7ff46a7)(resources[i], options), i));
    }
    /** Destroy this BaseImageResource. */ dispose() {
        for(let i = 0, len = this.length; i < len; i++)this.items[i].destroy();
        this.items = null, this.itemDirtyIds = null, this._load = null;
    }
    /**
   * Set a resource by ID
   * @param resource
   * @param index - Zero-based index of resource to set
   * @returns - Instance for chaining
   */ addResourceAt(resource, index) {
        if (!this.items[index]) throw new Error(`Index ${index} is out of bounds`);
        return resource.valid && !this.valid && this.resize(resource.width, resource.height), this.items[index].setResource(resource), this;
    }
    /**
   * Set the parent base texture.
   * @param baseTexture
   */ bind(baseTexture) {
        if (this.baseTexture !== null) throw new Error("Only one base texture per TextureArray is allowed");
        super.bind(baseTexture);
        for(let i = 0; i < this.length; i++)this.items[i].parentTextureArray = baseTexture, this.items[i].on("update", baseTexture.update, baseTexture);
    }
    /**
   * Unset the parent base texture.
   * @param baseTexture
   */ unbind(baseTexture) {
        super.unbind(baseTexture);
        for(let i = 0; i < this.length; i++)this.items[i].parentTextureArray = null, this.items[i].off("update", baseTexture.update, baseTexture);
    }
    /**
   * Load all the resources simultaneously
   * @returns - When load is resolved
   */ load() {
        if (this._load) return this._load;
        const promises = this.items.map((item)=>item.resource).filter((item)=>item).map((item)=>item.load());
        return this._load = Promise.all(promises).then(()=>{
            const { realWidth: realWidth, realHeight: realHeight } = this.items[0];
            return this.resize(realWidth, realHeight), this.update(), Promise.resolve(this);
        }), this._load;
    }
}


class $24fb56112d0a10b9$export$aa0af7255ee278f1 extends (0, $02efb8b7d5be2c31$export$195275694901de82) {
    /**
   * @param source - Number of items in array or the collection
   *        of image URLs to use. Can also be resources, image elements, canvas, etc.
   * @param options - Options to apply to {@link PIXI.autoDetectResource}
   * @param {number} [options.width] - Width of the resource
   * @param {number} [options.height] - Height of the resource
   */ constructor(source, options){
        const { width: width, height: height } = options || {};
        let urls, length;
        Array.isArray(source) ? (urls = source, length = source.length) : length = source, super(length, {
            width: width,
            height: height
        }), urls && this.initFromArray(urls, options);
    }
    /**
   * Set a baseTexture by ID,
   * ArrayResource just takes resource from it, nothing more
   * @param baseTexture
   * @param index - Zero-based index of resource to set
   * @returns - Instance for chaining
   */ addBaseTextureAt(baseTexture, index) {
        if (baseTexture.resource) this.addResourceAt(baseTexture.resource, index);
        else throw new Error("ArrayResource does not support RenderTexture");
        return this;
    }
    /**
   * Add binding
   * @param baseTexture
   */ bind(baseTexture) {
        super.bind(baseTexture), baseTexture.target = (0, $0fa4b07f86297abd$export$d1ff3caf57547dc5).TEXTURE_2D_ARRAY;
    }
    /**
   * Upload the resources to the GPU.
   * @param renderer
   * @param texture
   * @param glTexture
   * @returns - whether texture was uploaded
   */ upload(renderer, texture, glTexture) {
        const { length: length, itemDirtyIds: itemDirtyIds, items: items } = this, { gl: gl } = renderer;
        glTexture.dirtyId < 0 && gl.texImage3D(gl.TEXTURE_2D_ARRAY, 0, glTexture.internalFormat, this._width, this._height, length, 0, texture.format, glTexture.type, null);
        for(let i = 0; i < length; i++){
            const item = items[i];
            itemDirtyIds[i] < item.dirtyId && (itemDirtyIds[i] = item.dirtyId, item.valid && gl.texSubImage3D(gl.TEXTURE_2D_ARRAY, 0, 0, // xoffset
            0, // yoffset
            i, // zoffset
            item.resource.width, item.resource.height, 1, texture.format, glTexture.type, item.resource.source));
        }
        return !0;
    }
}





class $198319f29fcb3602$export$3bea879ce3e5cb51 extends (0, $06918a51ca7773d0$export$c87b2a1e7e3bb4a6) {
    /**
   * @param source - Canvas element to use
   */ // eslint-disable-next-line @typescript-eslint/no-useless-constructor
    constructor(source){
        super(source);
    }
    /**
   * Used to auto-detect the type of resource.
   * @param {*} source - The source object
   * @returns {boolean} `true` if source is HTMLCanvasElement or OffscreenCanvas
   */ static test(source) {
        const { OffscreenCanvas: OffscreenCanvas } = globalThis;
        return OffscreenCanvas && source instanceof OffscreenCanvas ? !0 : globalThis.HTMLCanvasElement && source instanceof HTMLCanvasElement;
    }
}




const $514fcd05b324d9e8$var$_CubeResource = class _CubeResource2 extends (0, $02efb8b7d5be2c31$export$195275694901de82) {
    /**
   * @param {Array<string|PIXI.Resource>} [source] - Collection of URLs or resources
   *        to use as the sides of the cube.
   * @param options - ImageResource options
   * @param {number} [options.width] - Width of resource
   * @param {number} [options.height] - Height of resource
   * @param {number} [options.autoLoad=true] - Whether to auto-load resources
   * @param {number} [options.linkBaseTexture=true] - In case BaseTextures are supplied,
   *   whether to copy them or use
   */ constructor(source, options){
        const { width: width, height: height, autoLoad: autoLoad, linkBaseTexture: linkBaseTexture } = options || {};
        if (source && source.length !== _CubeResource2.SIDES) throw new Error(`Invalid length. Got ${source.length}, expected 6`);
        super(6, {
            width: width,
            height: height
        });
        for(let i = 0; i < _CubeResource2.SIDES; i++)this.items[i].target = (0, $0fa4b07f86297abd$export$d1ff3caf57547dc5).TEXTURE_CUBE_MAP_POSITIVE_X + i;
        this.linkBaseTexture = linkBaseTexture !== !1, source && this.initFromArray(source, options), autoLoad !== !1 && this.load();
    }
    /**
   * Add binding.
   * @param baseTexture - parent base texture
   */ bind(baseTexture) {
        super.bind(baseTexture), baseTexture.target = (0, $0fa4b07f86297abd$export$d1ff3caf57547dc5).TEXTURE_CUBE_MAP;
    }
    addBaseTextureAt(baseTexture, index, linkBaseTexture) {
        if (linkBaseTexture === void 0 && (linkBaseTexture = this.linkBaseTexture), !this.items[index]) throw new Error(`Index ${index} is out of bounds`);
        if (!this.linkBaseTexture || baseTexture.parentTextureArray || Object.keys(baseTexture._glTextures).length > 0) {
            if (baseTexture.resource) this.addResourceAt(baseTexture.resource, index);
            else throw new Error("CubeResource does not support copying of renderTexture.");
        } else baseTexture.target = (0, $0fa4b07f86297abd$export$d1ff3caf57547dc5).TEXTURE_CUBE_MAP_POSITIVE_X + index, baseTexture.parentTextureArray = this.baseTexture, this.items[index] = baseTexture;
        return baseTexture.valid && !this.valid && this.resize(baseTexture.realWidth, baseTexture.realHeight), this.items[index] = baseTexture, this;
    }
    /**
   * Upload the resource
   * @param renderer
   * @param _baseTexture
   * @param glTexture
   * @returns {boolean} true is success
   */ upload(renderer, _baseTexture, glTexture) {
        const dirty = this.itemDirtyIds;
        for(let i = 0; i < _CubeResource2.SIDES; i++){
            const side = this.items[i];
            (dirty[i] < side.dirtyId || glTexture.dirtyId < _baseTexture.dirtyId) && (side.valid && side.resource ? (side.resource.upload(renderer, side, glTexture), dirty[i] = side.dirtyId) : dirty[i] < -1 && (renderer.gl.texImage2D(side.target, 0, glTexture.internalFormat, _baseTexture.realWidth, _baseTexture.realHeight, 0, _baseTexture.format, glTexture.type, null), dirty[i] = -1));
        }
        return !0;
    }
    /**
   * Used to auto-detect the type of resource.
   * @param {*} source - The source object
   * @returns {boolean} `true` if source is an array of 6 elements
   */ static test(source) {
        return Array.isArray(source) && source.length === _CubeResource2.SIDES;
    }
};
$514fcd05b324d9e8$var$_CubeResource.SIDES = 6;
let $514fcd05b324d9e8$export$c786bc8247db64cb = $514fcd05b324d9e8$var$_CubeResource;





class $ca65fc254ccc82fa$export$422084391f3a58a3 extends (0, $06918a51ca7773d0$export$c87b2a1e7e3bb4a6) {
    /**
   * @param source - ImageBitmap or URL to use.
   * @param options - Options to use.
   */ constructor(source, options){
        options = options || {};
        let baseSource, url, ownsImageBitmap;
        typeof source == "string" ? (baseSource = $ca65fc254ccc82fa$export$422084391f3a58a3.EMPTY, url = source, ownsImageBitmap = !0) : (baseSource = source, url = null, ownsImageBitmap = !1), super(baseSource), this.url = url, this.crossOrigin = options.crossOrigin ?? !0, this.alphaMode = typeof options.alphaMode == "number" ? options.alphaMode : null, this.ownsImageBitmap = options.ownsImageBitmap ?? ownsImageBitmap, this._load = null, options.autoLoad !== !1 && this.load();
    }
    load() {
        return this._load ? this._load : (this._load = new Promise(async (resolve, reject)=>{
            if (this.url === null) {
                resolve(this);
                return;
            }
            try {
                const response = await (0, $2808efac47e52be0$export$a5a6e0b888b2c992).ADAPTER.fetch(this.url, {
                    mode: this.crossOrigin ? "cors" : "no-cors"
                });
                if (this.destroyed) return;
                const imageBlob = await response.blob();
                if (this.destroyed) return;
                const imageBitmap = await createImageBitmap(imageBlob, {
                    premultiplyAlpha: this.alphaMode === null || this.alphaMode === (0, $0fa4b07f86297abd$export$d56550d454401b73).UNPACK ? "premultiply" : "none"
                });
                if (this.destroyed) {
                    imageBitmap.close();
                    return;
                }
                this.source = imageBitmap, this.update(), resolve(this);
            } catch (e) {
                if (this.destroyed) return;
                reject(e), this.onError.emit(e);
            }
        }), this._load);
    }
    /**
   * Upload the image bitmap resource to GPU.
   * @param renderer - Renderer to upload to
   * @param baseTexture - BaseTexture for this resource
   * @param glTexture - GLTexture to use
   * @returns {boolean} true is success
   */ upload(renderer, baseTexture, glTexture) {
        return this.source instanceof ImageBitmap ? (typeof this.alphaMode == "number" && (baseTexture.alphaMode = this.alphaMode), super.upload(renderer, baseTexture, glTexture)) : (this.load(), !1);
    }
    /** Destroys this resource. */ dispose() {
        this.ownsImageBitmap && this.source instanceof ImageBitmap && this.source.close(), super.dispose(), this._load = null;
    }
    /**
   * Used to auto-detect the type of resource.
   * @param {*} source - The source object
   * @returns {boolean} `true` if current environment support ImageBitmap, and source is string or ImageBitmap
   */ static test(source) {
        return !!globalThis.createImageBitmap && typeof ImageBitmap < "u" && (typeof source == "string" || source instanceof ImageBitmap);
    }
    /**
   * ImageBitmap cannot be created synchronously, so a empty placeholder canvas is needed when loading from URLs.
   * Only for internal usage.
   * @returns The cached placeholder canvas.
   */ static get EMPTY() {
        return $ca65fc254ccc82fa$export$422084391f3a58a3._EMPTY = $ca65fc254ccc82fa$export$422084391f3a58a3._EMPTY ?? (0, $2808efac47e52be0$export$a5a6e0b888b2c992).ADAPTER.createCanvas(0, 0), $ca65fc254ccc82fa$export$422084391f3a58a3._EMPTY;
    }
}






const $5be094cb1fca983a$var$_SVGResource = class _SVGResource2 extends (0, $06918a51ca7773d0$export$c87b2a1e7e3bb4a6) {
    /**
   * @param sourceBase64 - Base64 encoded SVG element or URL for SVG file.
   * @param {object} [options] - Options to use
   * @param {number} [options.scale=1] - Scale to apply to SVG. Overridden by...
   * @param {number} [options.width] - Rasterize SVG this wide. Aspect ratio preserved if height not specified.
   * @param {number} [options.height] - Rasterize SVG this high. Aspect ratio preserved if width not specified.
   * @param {boolean} [options.autoLoad=true] - Start loading right away.
   */ constructor(sourceBase64, options){
        options = options || {}, super((0, $2808efac47e52be0$export$a5a6e0b888b2c992).ADAPTER.createCanvas()), this._width = 0, this._height = 0, this.svg = sourceBase64, this.scale = options.scale || 1, this._overrideWidth = options.width, this._overrideHeight = options.height, this._resolve = null, this._crossorigin = options.crossorigin, this._load = null, options.autoLoad !== !1 && this.load();
    }
    load() {
        return this._load ? this._load : (this._load = new Promise((resolve)=>{
            if (this._resolve = ()=>{
                this.update(), resolve(this);
            }, _SVGResource2.SVG_XML.test(this.svg.trim())) {
                if (!btoa) throw new Error("Your browser doesn't support base64 conversions.");
                this.svg = `data:image/svg+xml;base64,${btoa(unescape(encodeURIComponent(this.svg)))}`;
            }
            this._loadSvg();
        }), this._load);
    }
    /** Loads an SVG image from `imageUrl` or `data URL`. */ _loadSvg() {
        const tempImage = new Image();
        (0, $06918a51ca7773d0$export$c87b2a1e7e3bb4a6).crossOrigin(tempImage, this.svg, this._crossorigin), tempImage.src = this.svg, tempImage.onerror = (event)=>{
            this._resolve && (tempImage.onerror = null, this.onError.emit(event));
        }, tempImage.onload = ()=>{
            if (!this._resolve) return;
            const svgWidth = tempImage.width, svgHeight = tempImage.height;
            if (!svgWidth || !svgHeight) throw new Error("The SVG image must have width and height defined (in pixels), canvas API needs them.");
            let width = svgWidth * this.scale, height = svgHeight * this.scale;
            (this._overrideWidth || this._overrideHeight) && (width = this._overrideWidth || this._overrideHeight / svgHeight * svgWidth, height = this._overrideHeight || this._overrideWidth / svgWidth * svgHeight), width = Math.round(width), height = Math.round(height);
            const canvas = this.source;
            canvas.width = width, canvas.height = height, canvas._pixiId = `canvas_${(0, $9444d853616ed05b$export$e2a22331486dcca0)()}`, canvas.getContext("2d").drawImage(tempImage, 0, 0, svgWidth, svgHeight, 0, 0, width, height), this._resolve(), this._resolve = null;
        };
    }
    /**
   * Get size from an svg string using a regular expression.
   * @param svgString - a serialized svg element
   * @returns - image extension
   */ static getSize(svgString) {
        const sizeMatch = _SVGResource2.SVG_SIZE.exec(svgString), size = {};
        return sizeMatch && (size[sizeMatch[1]] = Math.round(parseFloat(sizeMatch[3])), size[sizeMatch[5]] = Math.round(parseFloat(sizeMatch[7]))), size;
    }
    /** Destroys this texture. */ dispose() {
        super.dispose(), this._resolve = null, this._crossorigin = null;
    }
    /**
   * Used to auto-detect the type of resource.
   * @param {*} source - The source object
   * @param {string} extension - The extension of source, if set
   * @returns {boolean} - If the source is a SVG source or data file
   */ static test(source, extension) {
        return extension === "svg" || typeof source == "string" && source.startsWith("data:image/svg+xml") || typeof source == "string" && _SVGResource2.SVG_XML.test(source);
    }
};
$5be094cb1fca983a$var$_SVGResource.SVG_XML = /^(<\?xml[^?]+\?>)?\s*(<!--[^(-->)]*-->)?\s*\<svg/m, /**
* Regular expression for SVG size.
* @example &lt;svg width="100" height="100"&gt;&lt;/svg&gt;
* @readonly
*/ $5be094cb1fca983a$var$_SVGResource.SVG_SIZE = /<svg[^>]*(?:\s(width|height)=('|")(\d*(?:\.\d+)?)(?:px)?('|"))[^>]*(?:\s(width|height)=('|")(\d*(?:\.\d+)?)(?:px)?('|"))[^>]*>/i;
let $5be094cb1fca983a$export$aeb8ac9a3d5d46a0 = $5be094cb1fca983a$var$_SVGResource;




const $8223d3e14a6b8675$var$_VideoResource = class _VideoResource2 extends (0, $06918a51ca7773d0$export$c87b2a1e7e3bb4a6) {
    /**
   * @param {HTMLVideoElement|object|string|Array<string|object>} source - Video element to use.
   * @param {object} [options] - Options to use
   * @param {boolean} [options.autoLoad=true] - Start loading the video immediately
   * @param {boolean} [options.autoPlay=true] - Start playing video immediately
   * @param {number} [options.updateFPS=0] - How many times a second to update the texture from the video.
   * Leave at 0 to update at every render.
   * @param {boolean} [options.crossorigin=true] - Load image using cross origin
   * @param {boolean} [options.loop=false] - Loops the video
   * @param {boolean} [options.muted=false] - Mutes the video audio, useful for autoplay
   * @param {boolean} [options.playsinline=true] - Prevents opening the video on mobile devices
   */ constructor(source, options){
        if (options = options || {}, !(source instanceof HTMLVideoElement)) {
            const videoElement = document.createElement("video");
            options.autoLoad !== !1 && videoElement.setAttribute("preload", "auto"), options.playsinline !== !1 && (videoElement.setAttribute("webkit-playsinline", ""), videoElement.setAttribute("playsinline", "")), options.muted === !0 && (videoElement.setAttribute("muted", ""), videoElement.muted = !0), options.loop === !0 && videoElement.setAttribute("loop", ""), options.autoPlay !== !1 && videoElement.setAttribute("autoplay", ""), typeof source == "string" && (source = [
                source
            ]);
            const firstSrc = source[0].src || source[0];
            (0, $06918a51ca7773d0$export$c87b2a1e7e3bb4a6).crossOrigin(videoElement, firstSrc, options.crossorigin);
            for(let i = 0; i < source.length; ++i){
                const sourceElement = document.createElement("source");
                let { src: src, mime: mime } = source[i];
                if (src = src || source[i], src.startsWith("data:")) mime = src.slice(5, src.indexOf(";"));
                else if (!src.startsWith("blob:")) {
                    const baseSrc = src.split("?").shift().toLowerCase(), ext = baseSrc.slice(baseSrc.lastIndexOf(".") + 1);
                    mime = mime || _VideoResource2.MIME_TYPES[ext] || `video/${ext}`;
                }
                sourceElement.src = src, mime && (sourceElement.type = mime), videoElement.appendChild(sourceElement);
            }
            source = videoElement;
        }
        super(source), this.noSubImage = !0, this._autoUpdate = !0, this._isConnectedToTicker = !1, this._updateFPS = options.updateFPS || 0, this._msToNextUpdate = 0, this.autoPlay = options.autoPlay !== !1, this._videoFrameRequestCallback = this._videoFrameRequestCallback.bind(this), this._videoFrameRequestCallbackHandle = null, this._load = null, this._resolve = null, this._reject = null, this._onCanPlay = this._onCanPlay.bind(this), this._onError = this._onError.bind(this), this._onPlayStart = this._onPlayStart.bind(this), this._onPlayStop = this._onPlayStop.bind(this), this._onSeeked = this._onSeeked.bind(this), options.autoLoad !== !1 && this.load();
    }
    /**
   * Trigger updating of the texture.
   * @param _deltaTime - time delta since last tick
   */ update(_deltaTime = 0) {
        if (!this.destroyed) {
            if (this._updateFPS) {
                const elapsedMS = (0, $e6b36730368844b1$export$39c54bcc89dcee11).shared.elapsedMS * this.source.playbackRate;
                this._msToNextUpdate = Math.floor(this._msToNextUpdate - elapsedMS);
            }
            (!this._updateFPS || this._msToNextUpdate <= 0) && (super.update(), this._msToNextUpdate = this._updateFPS ? Math.floor(1e3 / this._updateFPS) : 0);
        }
    }
    _videoFrameRequestCallback() {
        this.update(), this.destroyed ? this._videoFrameRequestCallbackHandle = null : this._videoFrameRequestCallbackHandle = this.source.requestVideoFrameCallback(this._videoFrameRequestCallback);
    }
    /**
   * Start preloading the video resource.
   * @returns {Promise<void>} Handle the validate event
   */ load() {
        if (this._load) return this._load;
        const source = this.source;
        return (source.readyState === source.HAVE_ENOUGH_DATA || source.readyState === source.HAVE_FUTURE_DATA) && source.width && source.height && (source.complete = !0), source.addEventListener("play", this._onPlayStart), source.addEventListener("pause", this._onPlayStop), source.addEventListener("seeked", this._onSeeked), this._isSourceReady() ? this._onCanPlay() : (source.addEventListener("canplay", this._onCanPlay), source.addEventListener("canplaythrough", this._onCanPlay), source.addEventListener("error", this._onError, !0)), this._load = new Promise((resolve, reject)=>{
            this.valid ? resolve(this) : (this._resolve = resolve, this._reject = reject, source.load());
        }), this._load;
    }
    /**
   * Handle video error events.
   * @param event
   */ _onError(event) {
        this.source.removeEventListener("error", this._onError, !0), this.onError.emit(event), this._reject && (this._reject(event), this._reject = null, this._resolve = null);
    }
    /**
   * Returns true if the underlying source is playing.
   * @returns - True if playing.
   */ _isSourcePlaying() {
        const source = this.source;
        return !source.paused && !source.ended && this._isSourceReady();
    }
    /**
   * Returns true if the underlying source is ready for playing.
   * @returns - True if ready.
   */ _isSourceReady() {
        return this.source.readyState > 2;
    }
    /** Runs the update loop when the video is ready to play. */ _onPlayStart() {
        this.valid || this._onCanPlay(), this._configureAutoUpdate();
    }
    /** Fired when a pause event is triggered, stops the update loop. */ _onPlayStop() {
        this._configureAutoUpdate();
    }
    /** Fired when the video is completed seeking to the current playback position. */ _onSeeked() {
        this._autoUpdate && !this._isSourcePlaying() && (this._msToNextUpdate = 0, this.update(), this._msToNextUpdate = 0);
    }
    /** Fired when the video is loaded and ready to play. */ _onCanPlay() {
        const source = this.source;
        source.removeEventListener("canplay", this._onCanPlay), source.removeEventListener("canplaythrough", this._onCanPlay);
        const valid = this.valid;
        this._msToNextUpdate = 0, this.update(), this._msToNextUpdate = 0, !valid && this._resolve && (this._resolve(this), this._resolve = null, this._reject = null), this._isSourcePlaying() ? this._onPlayStart() : this.autoPlay && source.play();
    }
    /** Destroys this texture. */ dispose() {
        this._configureAutoUpdate();
        const source = this.source;
        source && (source.removeEventListener("play", this._onPlayStart), source.removeEventListener("pause", this._onPlayStop), source.removeEventListener("seeked", this._onSeeked), source.removeEventListener("canplay", this._onCanPlay), source.removeEventListener("canplaythrough", this._onCanPlay), source.removeEventListener("error", this._onError, !0), source.pause(), source.src = "", source.load()), super.dispose();
    }
    /** Should the base texture automatically update itself, set to true by default. */ get autoUpdate() {
        return this._autoUpdate;
    }
    set autoUpdate(value) {
        value !== this._autoUpdate && (this._autoUpdate = value, this._configureAutoUpdate());
    }
    /**
   * How many times a second to update the texture from the video. Leave at 0 to update at every render.
   * A lower fps can help performance, as updating the texture at 60fps on a 30ps video may not be efficient.
   */ get updateFPS() {
        return this._updateFPS;
    }
    set updateFPS(value) {
        value !== this._updateFPS && (this._updateFPS = value, this._configureAutoUpdate());
    }
    _configureAutoUpdate() {
        this._autoUpdate && this._isSourcePlaying() ? !this._updateFPS && this.source.requestVideoFrameCallback ? (this._isConnectedToTicker && ((0, $e6b36730368844b1$export$39c54bcc89dcee11).shared.remove(this.update, this), this._isConnectedToTicker = !1, this._msToNextUpdate = 0), this._videoFrameRequestCallbackHandle === null && (this._videoFrameRequestCallbackHandle = this.source.requestVideoFrameCallback(this._videoFrameRequestCallback))) : (this._videoFrameRequestCallbackHandle !== null && (this.source.cancelVideoFrameCallback(this._videoFrameRequestCallbackHandle), this._videoFrameRequestCallbackHandle = null), this._isConnectedToTicker || ((0, $e6b36730368844b1$export$39c54bcc89dcee11).shared.add(this.update, this), this._isConnectedToTicker = !0, this._msToNextUpdate = 0)) : (this._videoFrameRequestCallbackHandle !== null && (this.source.cancelVideoFrameCallback(this._videoFrameRequestCallbackHandle), this._videoFrameRequestCallbackHandle = null), this._isConnectedToTicker && ((0, $e6b36730368844b1$export$39c54bcc89dcee11).shared.remove(this.update, this), this._isConnectedToTicker = !1, this._msToNextUpdate = 0));
    }
    /**
   * Used to auto-detect the type of resource.
   * @param {*} source - The source object
   * @param {string} extension - The extension of source, if set
   * @returns {boolean} `true` if video source
   */ static test(source, extension) {
        return globalThis.HTMLVideoElement && source instanceof HTMLVideoElement || _VideoResource2.TYPES.includes(extension);
    }
};
$8223d3e14a6b8675$var$_VideoResource.TYPES = [
    "mp4",
    "m4v",
    "webm",
    "ogg",
    "ogv",
    "h264",
    "avi",
    "mov"
], /**
* Map of video MIME types that can't be directly derived from file extensions.
* @readonly
*/ $8223d3e14a6b8675$var$_VideoResource.MIME_TYPES = {
    ogv: "video/ogg",
    mov: "video/quicktime",
    m4v: "video/mp4"
};
let $8223d3e14a6b8675$export$f7dd53bb53e9c0d7 = $8223d3e14a6b8675$var$_VideoResource;





(0, $0ab0288141919131$export$7db5d8a07d9761e1).push((0, $ca65fc254ccc82fa$export$422084391f3a58a3), (0, $a04cb98a52ca9adc$export$6d0d25e6e731a9a2), (0, $198319f29fcb3602$export$3bea879ce3e5cb51), (0, $8223d3e14a6b8675$export$f7dd53bb53e9c0d7), (0, $5be094cb1fca983a$export$aeb8ac9a3d5d46a0), (0, $62e6c838a658c2fb$export$a79ef781de624449), (0, $514fcd05b324d9e8$export$c786bc8247db64cb), (0, $24fb56112d0a10b9$export$aa0af7255ee278f1));








class $8dc69b0fbb51207d$export$1f7c70f8d6979c19 {
    constructor(){
        this._glTransformFeedbacks = {}, this.buffers = [], this.disposeRunner = new (0, $feae24fa15514cdf$export$571ad3bcba5a0c45)("disposeTransformFeedback");
    }
    /**
   * Bind buffer to TransformFeedback
   * @param index - index to bind
   * @param buffer - buffer to bind
   */ bindBuffer(index, buffer) {
        this.buffers[index] = buffer;
    }
    /** Destroy WebGL resources that are connected to this TransformFeedback. */ destroy() {
        this.disposeRunner.emit(this, !1);
    }
}



















const $5b9d76628fb6e222$export$a4ad2735b021c132 = "7.3.1";




let $935c93fffa39f709$var$id = 0;
const $935c93fffa39f709$var$_HTMLAudioInstance = class extends (0, $db31fc3dfae4939b$exports).EventEmitter {
    /** @param parent - Parent element */ constructor(parent){
        super();
        this.id = $935c93fffa39f709$var$id++;
        this.init(parent);
    }
    /**
   * Set a property by name, this makes it easy to chain values
   * @param name - Name of the property to set
   * @param value - Value to set property to
   */ set(name, value) {
        if (this[name] === void 0) throw new Error(`Property with name ${name} does not exist.`);
        else switch(name){
            case "speed":
                this.speed = value;
                break;
            case "volume":
                this.volume = value;
                break;
            case "paused":
                this.paused = value;
                break;
            case "loop":
                this.loop = value;
                break;
            case "muted":
                this.muted = value;
                break;
        }
        return this;
    }
    /** The current playback progress from 0 to 1. */ get progress() {
        const { currentTime: currentTime } = this._source;
        return currentTime / this._duration;
    }
    /** Pauses the sound. */ get paused() {
        return this._paused;
    }
    set paused(paused) {
        this._paused = paused;
        this.refreshPaused();
    }
    /**
   * Reference: http://stackoverflow.com/a/40370077
   * @private
   */ _onPlay() {
        this._playing = true;
    }
    /**
   * Reference: http://stackoverflow.com/a/40370077
   * @private
   */ _onPause() {
        this._playing = false;
    }
    /**
   * Initialize the instance.
   * @param {htmlaudio.HTMLAudioMedia} media - Same as constructor
   */ init(media) {
        this._playing = false;
        this._duration = media.source.duration;
        const source = this._source = media.source.cloneNode(false);
        source.src = media.parent.url;
        source.onplay = this._onPlay.bind(this);
        source.onpause = this._onPause.bind(this);
        media.context.on("refresh", this.refresh, this);
        media.context.on("refreshPaused", this.refreshPaused, this);
        this._media = media;
    }
    /**
   * Stop the sound playing
   * @private
   */ _internalStop() {
        if (this._source && this._playing) {
            this._source.onended = null;
            this._source.pause();
        }
    }
    /** Stop the sound playing */ stop() {
        this._internalStop();
        if (this._source) this.emit("stop");
    }
    /** Set the instance speed from 0 to 1 */ get speed() {
        return this._speed;
    }
    set speed(speed) {
        this._speed = speed;
        this.refresh();
    }
    /** Get the set the volume for this instance from 0 to 1 */ get volume() {
        return this._volume;
    }
    set volume(volume) {
        this._volume = volume;
        this.refresh();
    }
    /** If the sound instance should loop playback */ get loop() {
        return this._loop;
    }
    set loop(loop) {
        this._loop = loop;
        this.refresh();
    }
    /** `true` if the sound is muted */ get muted() {
        return this._muted;
    }
    set muted(muted) {
        this._muted = muted;
        this.refresh();
    }
    /**
   * HTML Audio does not support filters, this is non-functional API.
   */ get filters() {
        console.warn("HTML Audio does not support filters");
        return null;
    }
    set filters(_filters) {
        console.warn("HTML Audio does not support filters");
    }
    /** Call whenever the loop, speed or volume changes */ refresh() {
        const global = this._media.context;
        const sound = this._media.parent;
        this._source.loop = this._loop || sound.loop;
        const globalVolume = global.volume * (global.muted ? 0 : 1);
        const soundVolume = sound.volume * (sound.muted ? 0 : 1);
        const instanceVolume = this._volume * (this._muted ? 0 : 1);
        this._source.volume = instanceVolume * globalVolume * soundVolume;
        this._source.playbackRate = this._speed * global.speed * sound.speed;
    }
    /** Handle changes in paused state, either globally or sound or instance */ refreshPaused() {
        const global = this._media.context;
        const sound = this._media.parent;
        const pausedReal = this._paused || sound.paused || global.paused;
        if (pausedReal !== this._pausedReal) {
            this._pausedReal = pausedReal;
            if (pausedReal) {
                this._internalStop();
                this.emit("paused");
            } else {
                this.emit("resumed");
                this.play({
                    start: this._source.currentTime,
                    end: this._end,
                    volume: this._volume,
                    speed: this._speed,
                    loop: this._loop
                });
            }
            this.emit("pause", pausedReal);
        }
    }
    /** Start playing the sound/ */ play(options) {
        const { start: start, end: end, speed: speed, loop: loop, volume: volume, muted: muted } = options;
        if (end) console.assert(end > start, "End time is before start time");
        this._speed = speed;
        this._volume = volume;
        this._loop = !!loop;
        this._muted = muted;
        this.refresh();
        if (this.loop && end !== null) {
            console.warn('Looping not support when specifying an "end" time');
            this.loop = false;
        }
        this._start = start;
        this._end = end || this._duration;
        this._start = Math.max(0, this._start - $935c93fffa39f709$var$_HTMLAudioInstance.PADDING);
        this._end = Math.min(this._end + $935c93fffa39f709$var$_HTMLAudioInstance.PADDING, this._duration);
        this._source.onloadedmetadata = ()=>{
            if (this._source) {
                this._source.currentTime = start;
                this._source.onloadedmetadata = null;
                this.emit("progress", start, this._duration);
                (0, $e6b36730368844b1$export$39c54bcc89dcee11).shared.add(this._onUpdate, this);
            }
        };
        this._source.onended = this._onComplete.bind(this);
        this._source.play();
        this.emit("start");
    }
    /**
   * Handle time update on sound.
   * @private
   */ _onUpdate() {
        this.emit("progress", this.progress, this._duration);
        if (this._source.currentTime >= this._end && !this._source.loop) this._onComplete();
    }
    /**
   * Callback when completed.
   * @private
   */ _onComplete() {
        (0, $e6b36730368844b1$export$39c54bcc89dcee11).shared.remove(this._onUpdate, this);
        this._internalStop();
        this.emit("progress", 1, this._duration);
        this.emit("end", this);
    }
    /** Don't use after this. */ destroy() {
        (0, $e6b36730368844b1$export$39c54bcc89dcee11).shared.remove(this._onUpdate, this);
        this.removeAllListeners();
        const source = this._source;
        if (source) {
            source.onended = null;
            source.onplay = null;
            source.onpause = null;
            this._internalStop();
        }
        this._source = null;
        this._speed = 1;
        this._volume = 1;
        this._loop = false;
        this._end = null;
        this._start = 0;
        this._duration = 0;
        this._playing = false;
        this._pausedReal = false;
        this._paused = false;
        this._muted = false;
        if (this._media) {
            this._media.context.off("refresh", this.refresh, this);
            this._media.context.off("refreshPaused", this.refreshPaused, this);
            this._media = null;
        }
    }
    /**
   * To string method for instance.
   * @return The string representation of instance.
   */ toString() {
        return `[HTMLAudioInstance id=${this.id}]`;
    }
};
let $935c93fffa39f709$export$5ba2228815fb4afb = $935c93fffa39f709$var$_HTMLAudioInstance;
/** Extra padding, in seconds, to deal with low-latecy of HTMLAudio. */ $935c93fffa39f709$export$5ba2228815fb4afb.PADDING = 0.1;


class $4d4b23680d16a687$export$e5eedbe48857dcd extends (0, $db31fc3dfae4939b$exports).EventEmitter {
    init(parent) {
        this.parent = parent;
        this._source = parent.options.source || new Audio();
        if (parent.url) this._source.src = parent.url;
    }
    // Implement create
    create() {
        return new (0, $935c93fffa39f709$export$5ba2228815fb4afb)(this);
    }
    /**
   * If the audio media is playable (ready).
   * @readonly
   */ get isPlayable() {
        return !!this._source && this._source.readyState === 4;
    }
    /**
   * THe duration of the media in seconds.
   * @readonly
   */ get duration() {
        return this._source.duration;
    }
    /**
   * Reference to the context.
   * @readonly
   */ get context() {
        return this.parent.context;
    }
    /** The collection of filters, does not apply to HTML Audio. */ get filters() {
        return null;
    }
    set filters(_filters) {
        console.warn("HTML Audio does not support filters");
    }
    // Override the destroy
    destroy() {
        this.removeAllListeners();
        this.parent = null;
        if (this._source) {
            this._source.src = "";
            this._source.load();
            this._source = null;
        }
    }
    /**
   * Get the audio source element.
   * @type {HTMLAudioElement}
   * @readonly
   */ get source() {
        return this._source;
    }
    // Implement the method to being preloading
    load(callback) {
        const source = this._source;
        const sound = this.parent;
        if (source.readyState === 4) {
            sound.isLoaded = true;
            const instance = sound.autoPlayStart();
            if (callback) setTimeout(()=>{
                callback(null, sound, instance);
            }, 0);
            return;
        }
        if (!sound.url) {
            callback(new Error("sound.url or sound.source must be set"));
            return;
        }
        source.src = sound.url;
        const onLoad = ()=>{
            removeListeners();
            sound.isLoaded = true;
            const instance = sound.autoPlayStart();
            if (callback) callback(null, sound, instance);
        };
        const onAbort = ()=>{
            removeListeners();
            if (callback) callback(new Error("Sound loading has been aborted"));
        };
        const onError = ()=>{
            removeListeners();
            const message = `Failed to load audio element (code: ${source.error.code})`;
            if (callback) callback(new Error(message));
            else console.error(message);
        };
        const removeListeners = ()=>{
            source.removeEventListener("canplaythrough", onLoad);
            source.removeEventListener("load", onLoad);
            source.removeEventListener("abort", onAbort);
            source.removeEventListener("error", onError);
        };
        source.addEventListener("canplaythrough", onLoad, false);
        source.addEventListener("load", onLoad, false);
        source.addEventListener("abort", onAbort, false);
        source.addEventListener("error", onError, false);
        source.load();
    }
}



class $e86708adb18796fc$export$fae5af5bab2ccf8 {
    /**
   * @param parent - The parent sound
   * @param options - Data associated with object.
   */ constructor(parent, options){
        this.parent = parent;
        Object.assign(this, options);
        this.duration = this.end - this.start;
        console.assert(this.duration > 0, "End time must be after start time");
    }
    /**
   * Play the sound sprite.
   * @param {Function} [complete] - Function call when complete
   * @return Sound instance being played.
   */ play(complete) {
        return this.parent.play({
            complete: complete,
            speed: this.speed || this.parent.speed,
            end: this.end,
            start: this.start,
            loop: this.loop
        });
    }
    /** Destroy and don't use after this */ destroy() {
        this.parent = null;
    }
}


const $f7551ed0f4e817c1$export$cc3e2d3244e01b7f = [
    "ogg",
    "oga",
    "opus",
    "m4a",
    "mp3",
    "mpeg",
    "wav",
    "aiff",
    "wma",
    "mid",
    "caf"
];
const $f7551ed0f4e817c1$export$8114c8bcb5760e77 = [
    "audio/mpeg",
    "audio/ogg"
];
const $f7551ed0f4e817c1$export$5f747a46dc0eb6ee = {};
function $f7551ed0f4e817c1$export$ca906cd9daab0e17(typeOverrides) {
    const overrides = {
        m4a: "audio/mp4",
        oga: "audio/ogg",
        opus: 'audio/ogg; codecs="opus"',
        caf: 'audio/x-caf; codecs="opus"',
        ...typeOverrides || {}
    };
    const audio = document.createElement("audio");
    const formats = {};
    const no = /^no$/;
    $f7551ed0f4e817c1$export$cc3e2d3244e01b7f.forEach((ext)=>{
        const canByExt = audio.canPlayType(`audio/${ext}`).replace(no, "");
        const canByType = overrides[ext] ? audio.canPlayType(overrides[ext]).replace(no, "") : "";
        formats[ext] = !!canByExt || !!canByType;
    });
    Object.assign($f7551ed0f4e817c1$export$5f747a46dc0eb6ee, formats);
}
$f7551ed0f4e817c1$export$ca906cd9daab0e17();





class $ca5d1aca6f689587$export$5caed31a857b7191 {
    /**
   * Dezippering is removed in the future Web Audio API, instead
   * we use the `setValueAtTime` method, however, this is not available
   * in all environments (e.g., Android webview), so we fallback to the `value` setter.
   * @param param - AudioNode parameter object
   * @param value - Value to set
   * @return The value set
   */ static setParamValue(param, value) {
        if (param.setValueAtTime) {
            const context = (0, $c762494680c35543$export$8bedcca5bbd73999)().context;
            param.setValueAtTime(value, context.audioContext.currentTime);
        } else param.value = value;
        return value;
    }
}


let $6c45fd2ac22fa3ab$var$id = 0;
class $6c45fd2ac22fa3ab$export$2af5ef044257da25 extends (0, $db31fc3dfae4939b$exports).EventEmitter {
    constructor(media){
        super();
        this.id = $6c45fd2ac22fa3ab$var$id++;
        this._media = null;
        this._paused = false;
        this._muted = false;
        this._elapsed = 0;
        this.init(media);
    }
    /**
   * Set a property by name, this makes it easy to chain values
   * @param name - Name of the property to set.
   * @param value - Value to set property to.
   */ set(name, value) {
        if (this[name] === void 0) throw new Error(`Property with name ${name} does not exist.`);
        else switch(name){
            case "speed":
                this.speed = value;
                break;
            case "volume":
                this.volume = value;
                break;
            case "muted":
                this.muted = value;
                break;
            case "loop":
                this.loop = value;
                break;
            case "paused":
                this.paused = value;
                break;
        }
        return this;
    }
    /** Stops the instance, don't use after this. */ stop() {
        if (this._source) {
            this._internalStop();
            this.emit("stop");
        }
    }
    /** Set the instance speed from 0 to 1 */ get speed() {
        return this._speed;
    }
    set speed(speed) {
        this._speed = speed;
        this.refresh();
        this._update(true);
    }
    /** Get the set the volume for this instance from 0 to 1 */ get volume() {
        return this._volume;
    }
    set volume(volume) {
        this._volume = volume;
        this.refresh();
    }
    /** `true` if the sound is muted */ get muted() {
        return this._muted;
    }
    set muted(muted) {
        this._muted = muted;
        this.refresh();
    }
    /** If the sound instance should loop playback */ get loop() {
        return this._loop;
    }
    set loop(loop) {
        this._loop = loop;
        this.refresh();
    }
    /** The collection of filters. */ get filters() {
        return this._filters;
    }
    set filters(filters) {
        if (this._filters) {
            this._filters?.filter((filter)=>filter).forEach((filter)=>filter.disconnect());
            this._filters = null;
            this._source.connect(this._gain);
        }
        this._filters = filters?.length ? filters.slice(0) : null;
        this.refresh();
    }
    /** Refresh loop, volume and speed based on changes to parent */ refresh() {
        if (!this._source) return;
        const global = this._media.context;
        const sound = this._media.parent;
        this._source.loop = this._loop || sound.loop;
        const globalVolume = global.volume * (global.muted ? 0 : 1);
        const soundVolume = sound.volume * (sound.muted ? 0 : 1);
        const instanceVolume = this._volume * (this._muted ? 0 : 1);
        (0, $ca5d1aca6f689587$export$5caed31a857b7191).setParamValue(this._gain.gain, instanceVolume * soundVolume * globalVolume);
        (0, $ca5d1aca6f689587$export$5caed31a857b7191).setParamValue(this._source.playbackRate, this._speed * sound.speed * global.speed);
        this.applyFilters();
    }
    /** Connect filters nodes to audio context */ applyFilters() {
        if (this._filters?.length) {
            this._source.disconnect();
            let source = this._source;
            this._filters.forEach((filter)=>{
                source.connect(filter.destination);
                source = filter;
            });
            source.connect(this._gain);
        }
    }
    /** Handle changes in paused state, either globally or sound or instance */ refreshPaused() {
        const global = this._media.context;
        const sound = this._media.parent;
        const pausedReal = this._paused || sound.paused || global.paused;
        if (pausedReal !== this._pausedReal) {
            this._pausedReal = pausedReal;
            if (pausedReal) {
                this._internalStop();
                this.emit("paused");
            } else {
                this.emit("resumed");
                this.play({
                    start: this._elapsed % this._duration,
                    end: this._end,
                    speed: this._speed,
                    loop: this._loop,
                    volume: this._volume
                });
            }
            this.emit("pause", pausedReal);
        }
    }
    /**
   * Plays the sound.
   * @param options - Play options.
   */ play(options) {
        const { start: start, end: end, speed: speed, loop: loop, volume: volume, muted: muted, filters: filters } = options;
        if (end) console.assert(end > start, "End time is before start time");
        this._paused = false;
        const { source: source, gain: gain } = this._media.nodes.cloneBufferSource();
        this._source = source;
        this._gain = gain;
        this._speed = speed;
        this._volume = volume;
        this._loop = !!loop;
        this._muted = muted;
        this._filters = filters;
        this.refresh();
        const duration = this._source.buffer.duration;
        this._duration = duration;
        this._end = end;
        this._lastUpdate = this._now();
        this._elapsed = start;
        this._source.onended = this._onComplete.bind(this);
        if (this._loop) {
            this._source.loopEnd = end;
            this._source.loopStart = start;
            this._source.start(0, start);
        } else if (end) this._source.start(0, start, end - start);
        else this._source.start(0, start);
        this.emit("start");
        this._update(true);
        this.enableTicker(true);
    }
    /** Start the update progress. */ enableTicker(enabled) {
        (0, $e6b36730368844b1$export$39c54bcc89dcee11).shared.remove(this._updateListener, this);
        if (enabled) (0, $e6b36730368844b1$export$39c54bcc89dcee11).shared.add(this._updateListener, this);
    }
    /** The current playback progress from 0 to 1. */ get progress() {
        return this._progress;
    }
    /** Pauses the sound. */ get paused() {
        return this._paused;
    }
    set paused(paused) {
        this._paused = paused;
        this.refreshPaused();
    }
    /** Don't use after this. */ destroy() {
        this.removeAllListeners();
        this._internalStop();
        if (this._gain) {
            this._gain.disconnect();
            this._gain = null;
        }
        if (this._media) {
            this._media.context.events.off("refresh", this.refresh, this);
            this._media.context.events.off("refreshPaused", this.refreshPaused, this);
            this._media = null;
        }
        this._filters?.forEach((filter)=>filter.disconnect());
        this._filters = null;
        this._end = null;
        this._speed = 1;
        this._volume = 1;
        this._loop = false;
        this._elapsed = 0;
        this._duration = 0;
        this._paused = false;
        this._muted = false;
        this._pausedReal = false;
    }
    /**
   * To string method for instance.
   * @return The string representation of instance.
   */ toString() {
        return `[WebAudioInstance id=${this.id}]`;
    }
    /**
   * Get the current time in seconds.
   * @return Seconds since start of context
   */ _now() {
        return this._media.context.audioContext.currentTime;
    }
    /** Callback for update listener */ _updateListener() {
        this._update();
    }
    /** Internal update the progress. */ _update(force = false) {
        if (this._source) {
            const now = this._now();
            const delta = now - this._lastUpdate;
            if (delta > 0 || force) {
                const speed = this._source.playbackRate.value;
                this._elapsed += delta * speed;
                this._lastUpdate = now;
                const duration = this._duration;
                let progress;
                if (this._source.loopStart) {
                    const soundLength = this._source.loopEnd - this._source.loopStart;
                    progress = (this._source.loopStart + this._elapsed % soundLength) / duration;
                } else progress = this._elapsed % duration / duration;
                this._progress = progress;
                this.emit("progress", this._progress, duration);
            }
        }
    }
    /** Initializes the instance. */ init(media) {
        this._media = media;
        media.context.events.on("refresh", this.refresh, this);
        media.context.events.on("refreshPaused", this.refreshPaused, this);
    }
    /** Stops the instance. */ _internalStop() {
        if (this._source) {
            this.enableTicker(false);
            this._source.onended = null;
            this._source.stop(0);
            this._source.disconnect();
            try {
                this._source.buffer = null;
            } catch (err) {
                console.warn("Failed to set AudioBufferSourceNode.buffer to null:", err);
            }
            this._source = null;
        }
    }
    /** Callback when completed. */ _onComplete() {
        if (this._source) {
            this.enableTicker(false);
            this._source.onended = null;
            this._source.disconnect();
            try {
                this._source.buffer = null;
            } catch (err) {
                console.warn("Failed to set AudioBufferSourceNode.buffer to null:", err);
            }
        }
        this._source = null;
        this._progress = 1;
        this.emit("progress", 1, this._duration);
        this.emit("end", this);
    }
}


class $1573cf73c85f1e36$export$d00e1c48fb621173 {
    /**
   * @param input - The source audio node
   * @param output - The output audio node
   */ constructor(input, output){
        this._output = output;
        this._input = input;
    }
    /** The destination output audio node */ get destination() {
        return this._input;
    }
    /** The collection of filters. */ get filters() {
        return this._filters;
    }
    set filters(filters) {
        if (this._filters) {
            this._filters.forEach((filter)=>{
                if (filter) filter.disconnect();
            });
            this._filters = null;
            this._input.connect(this._output);
        }
        if (filters && filters.length) {
            this._filters = filters.slice(0);
            this._input.disconnect();
            let prevFilter = null;
            filters.forEach((filter)=>{
                if (prevFilter === null) this._input.connect(filter.destination);
                else prevFilter.connect(filter.destination);
                prevFilter = filter;
            });
            prevFilter.connect(this._output);
        }
    }
    /** Cleans up. */ destroy() {
        this.filters = null;
        this._input = null;
        this._output = null;
    }
}



const $7fe11e72409537ef$var$_WebAudioNodes = class extends (0, $1573cf73c85f1e36$export$d00e1c48fb621173) {
    /**
   * @param context - The audio context.
   */ constructor(context){
        const audioContext = context.audioContext;
        const bufferSource = audioContext.createBufferSource();
        const gain = audioContext.createGain();
        const analyser = audioContext.createAnalyser();
        bufferSource.connect(analyser);
        analyser.connect(gain);
        gain.connect(context.destination);
        super(analyser, gain);
        this.context = context;
        this.bufferSource = bufferSource;
        this.gain = gain;
        this.analyser = analyser;
    }
    /**
   * Get the script processor node.
   * @readonly
   */ get script() {
        if (!this._script) {
            this._script = this.context.audioContext.createScriptProcessor($7fe11e72409537ef$var$_WebAudioNodes.BUFFER_SIZE);
            this._script.connect(this.context.destination);
        }
        return this._script;
    }
    /** Cleans up. */ destroy() {
        super.destroy();
        this.bufferSource.disconnect();
        if (this._script) this._script.disconnect();
        this.gain.disconnect();
        this.analyser.disconnect();
        this.bufferSource = null;
        this._script = null;
        this.gain = null;
        this.analyser = null;
        this.context = null;
    }
    /**
   * Clones the bufferSource. Used just before playing a sound.
   * @returns {SourceClone} The clone AudioBufferSourceNode.
   */ cloneBufferSource() {
        const orig = this.bufferSource;
        const source = this.context.audioContext.createBufferSource();
        source.buffer = orig.buffer;
        (0, $ca5d1aca6f689587$export$5caed31a857b7191).setParamValue(source.playbackRate, orig.playbackRate.value);
        source.loop = orig.loop;
        const gain = this.context.audioContext.createGain();
        source.connect(gain);
        gain.connect(this.destination);
        return {
            source: source,
            gain: gain
        };
    }
    /**
   * Get buffer size of `ScriptProcessorNode`.
   * @readonly
   */ get bufferSize() {
        return this.script.bufferSize;
    }
};
let $7fe11e72409537ef$export$b248c21a702795c4 = $7fe11e72409537ef$var$_WebAudioNodes;
/**
 * The buffer size for script processor, default is `0` which auto-detects. If you plan to use
 * script node on iOS, you'll need to provide a non-zero amount.
 * @default 0
 */ $7fe11e72409537ef$export$b248c21a702795c4.BUFFER_SIZE = 0;


class $27b9474723706491$export$9ea3865f5a7f2b06 {
    /**
   * Re-initialize without constructing.
   * @param parent - - Instance of parent Sound container
   */ init(parent) {
        this.parent = parent;
        this._nodes = new (0, $7fe11e72409537ef$export$b248c21a702795c4)(this.context);
        this._source = this._nodes.bufferSource;
        this.source = parent.options.source;
    }
    /** Destructor, safer to use `SoundLibrary.remove(alias)` to remove this sound. */ destroy() {
        this.parent = null;
        this._nodes.destroy();
        this._nodes = null;
        try {
            this._source.buffer = null;
        } catch (err) {
            console.warn("Failed to set AudioBufferSourceNode.buffer to null:", err);
        }
        this._source = null;
        this.source = null;
    }
    // Implement create
    create() {
        return new (0, $6c45fd2ac22fa3ab$export$2af5ef044257da25)(this);
    }
    // Implement context
    get context() {
        return this.parent.context;
    }
    // Implement isPlayable
    get isPlayable() {
        return !!this._source && !!this._source.buffer;
    }
    // Implement filters
    get filters() {
        return this._nodes.filters;
    }
    set filters(filters) {
        this._nodes.filters = filters;
    }
    // Implements duration
    get duration() {
        console.assert(this.isPlayable, "Sound not yet playable, no duration");
        return this._source.buffer.duration;
    }
    /** Gets and sets the buffer. */ get buffer() {
        return this._source.buffer;
    }
    set buffer(buffer) {
        this._source.buffer = buffer;
    }
    /** Get the current chained nodes object */ get nodes() {
        return this._nodes;
    }
    // Implements load
    load(callback) {
        if (this.source) this._decode(this.source, callback);
        else if (this.parent.url) this._loadUrl(callback);
        else if (callback) callback(new Error("sound.url or sound.source must be set"));
        else console.error("sound.url or sound.source must be set");
    }
    /** Loads a sound using XHMLHttpRequest object. */ async _loadUrl(callback) {
        const url = this.parent.url;
        const response = await (0, $2808efac47e52be0$export$a5a6e0b888b2c992).ADAPTER.fetch(url);
        this._decode(await response.arrayBuffer(), callback);
    }
    /**
   * Decodes the array buffer.
   * @param arrayBuffer - From load.
   * @param {Function} callback - Callback optional
   */ _decode(arrayBuffer, callback) {
        const audioBufferReadyFn = (err, buffer)=>{
            if (err) {
                if (callback) callback(err);
            } else {
                this.parent.isLoaded = true;
                this.buffer = buffer;
                const instance = this.parent.autoPlayStart();
                if (callback) callback(null, this.parent, instance);
            }
        };
        if (arrayBuffer instanceof AudioBuffer) audioBufferReadyFn(null, arrayBuffer);
        else {
            const context = this.parent.context;
            context.decode(arrayBuffer, audioBufferReadyFn);
        }
    }
}


const $c49e33ab4565eb4d$var$_Sound = class {
    /**
   * Create a new sound instance from source.
   * @param source - Either the path or url to the source file.
   *        or the object of options to use.
   * @return Created sound instance.
   */ static from(source) {
        let options = {};
        if (typeof source === "string") options.url = source;
        else if (source instanceof ArrayBuffer || source instanceof AudioBuffer || source instanceof HTMLAudioElement) options.source = source;
        else if (Array.isArray(source)) options.url = source;
        else options = source;
        options = {
            autoPlay: false,
            singleInstance: false,
            url: null,
            source: null,
            preload: false,
            volume: 1,
            speed: 1,
            complete: null,
            loaded: null,
            loop: false,
            ...options
        };
        Object.freeze(options);
        const media = (0, $c762494680c35543$export$8bedcca5bbd73999)().useLegacy ? new (0, $4d4b23680d16a687$export$e5eedbe48857dcd)() : new (0, $27b9474723706491$export$9ea3865f5a7f2b06)();
        return new $c49e33ab4565eb4d$var$_Sound(media, options);
    }
    /**
   * Use `Sound.from`
   * @ignore
   */ constructor(media, options){
        this.media = media;
        this.options = options;
        this._instances = [];
        this._sprites = {};
        this.media.init(this);
        const complete = options.complete;
        this._autoPlayOptions = complete ? {
            complete: complete
        } : null;
        this.isLoaded = false;
        this._preloadQueue = null;
        this.isPlaying = false;
        this.autoPlay = options.autoPlay;
        this.singleInstance = options.singleInstance;
        this.preload = options.preload || this.autoPlay;
        this.url = Array.isArray(options.url) ? this.preferUrl(options.url) : options.url;
        this.speed = options.speed;
        this.volume = options.volume;
        this.loop = options.loop;
        if (options.sprites) this.addSprites(options.sprites);
        if (this.preload) this._preload(options.loaded);
    }
    /**
   * Internal help for resolving which file to use if there are multiple provide
   * this is especially helpful for working with bundlers (non Assets loading).
   */ preferUrl(urls) {
        const [{ url: url }] = urls.map((url2)=>({
                url: url2,
                ext: (0, $db31fc3dfae4939b$exports).path.extname(url2).slice(1)
            })).sort((a, b)=>(0, $f7551ed0f4e817c1$export$cc3e2d3244e01b7f).indexOf(a.ext) - (0, $f7551ed0f4e817c1$export$cc3e2d3244e01b7f).indexOf(b.ext));
        return url;
    }
    /** Instance of the media context. */ get context() {
        return (0, $c762494680c35543$export$8bedcca5bbd73999)().context;
    }
    /** Stops all the instances of this sound from playing. */ pause() {
        this.isPlaying = false;
        this.paused = true;
        return this;
    }
    /** Resuming all the instances of this sound from playing */ resume() {
        this.isPlaying = this._instances.length > 0;
        this.paused = false;
        return this;
    }
    /** Stops all the instances of this sound from playing. */ get paused() {
        return this._paused;
    }
    set paused(paused) {
        this._paused = paused;
        this.refreshPaused();
    }
    /** The playback rate. */ get speed() {
        return this._speed;
    }
    set speed(speed) {
        this._speed = speed;
        this.refresh();
    }
    /** Set the filters. Only supported with WebAudio. */ get filters() {
        return this.media.filters;
    }
    set filters(filters) {
        this.media.filters = filters;
    }
    /**
   * @ignore
   */ addSprites(source, data) {
        if (typeof source === "object") {
            const results = {};
            for(const alias in source)results[alias] = this.addSprites(alias, source[alias]);
            return results;
        }
        console.assert(!this._sprites[source], `Alias ${source} is already taken`);
        const sprite = new (0, $e86708adb18796fc$export$fae5af5bab2ccf8)(this, data);
        this._sprites[source] = sprite;
        return sprite;
    }
    /** Destructor, safer to use `SoundLibrary.remove(alias)` to remove this sound. */ destroy() {
        this._removeInstances();
        this.removeSprites();
        this.media.destroy();
        this.media = null;
        this._sprites = null;
        this._instances = null;
    }
    /**
   * Remove a sound sprite.
   * @param alias - The unique name of the sound sprite, if alias is omitted, removes all sprites.
   */ removeSprites(alias) {
        if (!alias) for(const name in this._sprites)this.removeSprites(name);
        else {
            const sprite = this._sprites[alias];
            if (sprite !== void 0) {
                sprite.destroy();
                delete this._sprites[alias];
            }
        }
        return this;
    }
    /** If the current sound is playable (loaded). */ get isPlayable() {
        return this.isLoaded && this.media && this.media.isPlayable;
    }
    /** Stops all the instances of this sound from playing. */ stop() {
        if (!this.isPlayable) {
            this.autoPlay = false;
            this._autoPlayOptions = null;
            return this;
        }
        this.isPlaying = false;
        for(let i = this._instances.length - 1; i >= 0; i--)this._instances[i].stop();
        return this;
    }
    // Overloaded function
    play(source, complete) {
        let options;
        if (typeof source === "string") {
            const sprite = source;
            options = {
                sprite: sprite,
                loop: this.loop,
                complete: complete
            };
        } else if (typeof source === "function") {
            options = {};
            options.complete = source;
        } else options = source;
        options = {
            complete: null,
            loaded: null,
            sprite: null,
            end: null,
            start: 0,
            volume: 1,
            speed: 1,
            muted: false,
            loop: false,
            ...options || {}
        };
        if (options.sprite) {
            const alias = options.sprite;
            console.assert(!!this._sprites[alias], `Alias ${alias} is not available`);
            const sprite = this._sprites[alias];
            options.start = sprite.start + (options.start || 0);
            options.end = sprite.end;
            options.speed = sprite.speed || 1;
            options.loop = sprite.loop || options.loop;
            delete options.sprite;
        }
        if (options.offset) options.start = options.offset;
        if (!this.isLoaded) {
            if (this._preloadQueue) return new Promise((resolve)=>{
                this._preloadQueue.push(()=>{
                    resolve(this.play(options));
                });
            });
            this._preloadQueue = [];
            this.autoPlay = true;
            this._autoPlayOptions = options;
            return new Promise((resolve, reject)=>{
                this._preload((err, sound, media)=>{
                    this._preloadQueue.forEach((resolve2)=>resolve2());
                    this._preloadQueue = null;
                    if (err) reject(err);
                    else {
                        if (options.loaded) options.loaded(err, sound, media);
                        resolve(media);
                    }
                });
            });
        }
        if (this.singleInstance || options.singleInstance) this._removeInstances();
        const instance = this._createInstance();
        this._instances.push(instance);
        this.isPlaying = true;
        instance.once("end", ()=>{
            if (options.complete) options.complete(this);
            this._onComplete(instance);
        });
        instance.once("stop", ()=>{
            this._onComplete(instance);
        });
        instance.play(options);
        return instance;
    }
    /** Internal only, speed, loop, volume change occured. */ refresh() {
        const len = this._instances.length;
        for(let i = 0; i < len; i++)this._instances[i].refresh();
    }
    /** Handle changes in paused state. Internal only. */ refreshPaused() {
        const len = this._instances.length;
        for(let i = 0; i < len; i++)this._instances[i].refreshPaused();
    }
    /** Gets and sets the volume. */ get volume() {
        return this._volume;
    }
    set volume(volume) {
        this._volume = volume;
        this.refresh();
    }
    /** Gets and sets the muted flag. */ get muted() {
        return this._muted;
    }
    set muted(muted) {
        this._muted = muted;
        this.refresh();
    }
    /** Gets and sets the looping. */ get loop() {
        return this._loop;
    }
    set loop(loop) {
        this._loop = loop;
        this.refresh();
    }
    /** Starts the preloading of sound. */ _preload(callback) {
        this.media.load(callback);
    }
    /** Gets the list of instances that are currently being played of this sound. */ get instances() {
        return this._instances;
    }
    /** Get the map of sprites. */ get sprites() {
        return this._sprites;
    }
    /** Get the duration of the audio in seconds. */ get duration() {
        return this.media.duration;
    }
    /** Auto play the first instance. */ autoPlayStart() {
        let instance;
        if (this.autoPlay) instance = this.play(this._autoPlayOptions);
        return instance;
    }
    /** Removes all instances. */ _removeInstances() {
        for(let i = this._instances.length - 1; i >= 0; i--)this._poolInstance(this._instances[i]);
        this._instances.length = 0;
    }
    /**
   * Sound instance completed.
   * @param instance
   */ _onComplete(instance) {
        if (this._instances) {
            const index = this._instances.indexOf(instance);
            if (index > -1) this._instances.splice(index, 1);
            this.isPlaying = this._instances.length > 0;
        }
        this._poolInstance(instance);
    }
    /** Create a new instance. */ _createInstance() {
        if ($c49e33ab4565eb4d$var$_Sound._pool.length > 0) {
            const instance = $c49e33ab4565eb4d$var$_Sound._pool.pop();
            instance.init(this.media);
            return instance;
        }
        return this.media.create();
    }
    /**
   * Destroy/recycling the instance object.
   * @param instance - Instance to recycle
   */ _poolInstance(instance) {
        instance.destroy();
        if ($c49e33ab4565eb4d$var$_Sound._pool.indexOf(instance) < 0) $c49e33ab4565eb4d$var$_Sound._pool.push(instance);
    }
};
let $c49e33ab4565eb4d$export$85990f0f98a390bb = $c49e33ab4565eb4d$var$_Sound;
/** Pool of instances */ $c49e33ab4565eb4d$export$85990f0f98a390bb._pool = [];



class $9cc46572c6e21325$export$135605210c0a871c extends (0, $db31fc3dfae4939b$exports).EventEmitter {
    constructor(){
        super(...arguments);
        /** Current global speed from 0 to 1 */ this.speed = 1;
        /** Current muted status of the context */ this.muted = false;
        /** Current volume from 0 to 1  */ this.volume = 1;
        /** Current paused status */ this.paused = false;
    }
    /** Internal trigger when volume, mute or speed changes */ refresh() {
        this.emit("refresh");
    }
    /** Internal trigger paused changes */ refreshPaused() {
        this.emit("refreshPaused");
    }
    /**
   * HTML Audio does not support filters, this is non-functional API.
   */ get filters() {
        console.warn("HTML Audio does not support filters");
        return null;
    }
    set filters(_filters) {
        console.warn("HTML Audio does not support filters");
    }
    /**
   * HTML Audio does not support `audioContext`
   * @readonly
   * @type {AudioContext}
   */ get audioContext() {
        console.warn("HTML Audio does not support audioContext");
        return null;
    }
    /**
   * Toggles the muted state.
   * @return The current muted state.
   */ toggleMute() {
        this.muted = !this.muted;
        this.refresh();
        return this.muted;
    }
    /**
   * Toggles the paused state.
   * @return The current paused state.
   */ togglePause() {
        this.paused = !this.paused;
        this.refreshPaused();
        return this.paused;
    }
    /** Destroy and don't use after this */ destroy() {
        this.removeAllListeners();
    }
}




class $145d2d8774285a5c$export$25289944de7a55e4 extends (0, $1573cf73c85f1e36$export$d00e1c48fb621173) {
    constructor(){
        const win = window;
        const ctx = new $145d2d8774285a5c$export$25289944de7a55e4.AudioContext();
        const compressor = ctx.createDynamicsCompressor();
        const analyser = ctx.createAnalyser();
        analyser.connect(compressor);
        compressor.connect(ctx.destination);
        super(analyser, compressor);
        /** Set to false ignore suspending when window is blurred */ this.autoPause = true;
        this._ctx = ctx;
        this._offlineCtx = new $145d2d8774285a5c$export$25289944de7a55e4.OfflineAudioContext(1, 2, win.OfflineAudioContext ? Math.max(8e3, Math.min(96e3, ctx.sampleRate)) : 44100);
        this.compressor = compressor;
        this.analyser = analyser;
        this.events = new (0, $db31fc3dfae4939b$exports).EventEmitter();
        this.volume = 1;
        this.speed = 1;
        this.muted = false;
        this.paused = false;
        this._locked = ctx.state === "suspended" && ("ontouchstart" in globalThis || "onclick" in globalThis);
        if (this._locked) {
            this._unlock();
            this._unlock = this._unlock.bind(this);
            document.addEventListener("mousedown", this._unlock, true);
            document.addEventListener("touchstart", this._unlock, true);
            document.addEventListener("touchend", this._unlock, true);
        }
        this.onFocus = this.onFocus.bind(this);
        this.onBlur = this.onBlur.bind(this);
        globalThis.addEventListener("focus", this.onFocus);
        globalThis.addEventListener("blur", this.onBlur);
    }
    /** Handle mobile WebAudio context resume */ onFocus() {
        if (!this.autoPause) return;
        const state = this._ctx.state;
        if (state === "suspended" || state === "interrupted" || !this._locked) {
            this.paused = this._pausedOnBlur;
            this.refreshPaused();
        }
    }
    /** Handle mobile WebAudio context suspend */ onBlur() {
        if (!this.autoPause) return;
        if (!this._locked) {
            this._pausedOnBlur = this._paused;
            this.paused = true;
            this.refreshPaused();
        }
    }
    /**
   * Try to unlock audio on iOS. This is triggered from either WebAudio plugin setup (which will work if inside of
   * a `mousedown` or `touchend` event stack), or the first document touchend/mousedown event. If it fails (touchend
   * will fail if the user presses for too long, indicating a scroll event instead of a click event.
   *
   * Note that earlier versions of iOS supported `touchstart` for this, but iOS9 removed this functionality. Adding
   * a `touchstart` event to support older platforms may preclude a `mousedown` even from getting fired on iOS9, so we
   * stick with `mousedown` and `touchend`.
   */ _unlock() {
        if (!this._locked) return;
        this.playEmptySound();
        if (this._ctx.state === "running") {
            document.removeEventListener("mousedown", this._unlock, true);
            document.removeEventListener("touchend", this._unlock, true);
            document.removeEventListener("touchstart", this._unlock, true);
            this._locked = false;
        }
    }
    /**
   * Plays an empty sound in the web audio context.  This is used to enable web audio on iOS devices, as they
   * require the first sound to be played inside of a user initiated event (touch/click).
   */ playEmptySound() {
        const source = this._ctx.createBufferSource();
        source.buffer = this._ctx.createBuffer(1, 1, 22050);
        source.connect(this._ctx.destination);
        source.start(0, 0, 0);
        if (source.context.state === "suspended") source.context.resume();
    }
    /**
   * Get AudioContext class, if not supported returns `null`
   * @type {AudioContext}
   * @readonly
   */ static get AudioContext() {
        const win = window;
        return win.AudioContext || win.webkitAudioContext || null;
    }
    /**
   * Get OfflineAudioContext class, if not supported returns `null`
   * @type {OfflineAudioContext}
   * @readonly
   */ static get OfflineAudioContext() {
        const win = window;
        return win.OfflineAudioContext || win.webkitOfflineAudioContext || null;
    }
    /** Destroy this context. */ destroy() {
        super.destroy();
        const ctx = this._ctx;
        if (typeof ctx.close !== "undefined") ctx.close();
        globalThis.removeEventListener("focus", this.onFocus);
        globalThis.removeEventListener("blur", this.onBlur);
        this.events.removeAllListeners();
        this.analyser.disconnect();
        this.compressor.disconnect();
        this.analyser = null;
        this.compressor = null;
        this.events = null;
        this._offlineCtx = null;
        this._ctx = null;
    }
    /**
   * The WebAudio API AudioContext object.
   * @readonly
   * @type {AudioContext}
   */ get audioContext() {
        return this._ctx;
    }
    /**
   * The WebAudio API OfflineAudioContext object.
   * @readonly
   * @type {OfflineAudioContext}
   */ get offlineContext() {
        return this._offlineCtx;
    }
    /**
   * Pauses all sounds, even though we handle this at the instance
   * level, we'll also pause the audioContext so that the
   * time used to compute progress isn't messed up.
   * @default false
   */ set paused(paused) {
        if (paused && this._ctx.state === "running") this._ctx.suspend();
        else if (!paused && this._ctx.state === "suspended") this._ctx.resume();
        this._paused = paused;
    }
    get paused() {
        return this._paused;
    }
    /** Emit event when muted, volume or speed changes */ refresh() {
        this.events.emit("refresh");
    }
    /** Emit event when muted, volume or speed changes */ refreshPaused() {
        this.events.emit("refreshPaused");
    }
    /**
   * Toggles the muted state.
   * @return The current muted state.
   */ toggleMute() {
        this.muted = !this.muted;
        this.refresh();
        return this.muted;
    }
    /**
   * Toggles the paused state.
   * @return The current muted state.
   */ togglePause() {
        this.paused = !this.paused;
        this.refreshPaused();
        return this._paused;
    }
    /**
   * Decode the audio data
   * @param arrayBuffer - Buffer from loader
   * @param callback - When completed, error and audioBuffer are parameters.
   */ decode(arrayBuffer, callback) {
        const handleError = (err)=>{
            callback(new Error(err?.message || "Unable to decode file"));
        };
        const result = this._offlineCtx.decodeAudioData(arrayBuffer, (buffer)=>{
            callback(null, buffer);
        }, handleError);
        if (result) result.catch(handleError);
    }
}


class $6ac9a6dbfecc7b3b$export$8f62fda960fa1546 {
    constructor(){
        this.init();
    }
    /**
   * Re-initialize the sound library, this will
   * recreate the AudioContext. If there's a hardware-failure
   * call `close` and then `init`.
   * @return Sound instance
   */ init() {
        if (this.supported) this._webAudioContext = new (0, $145d2d8774285a5c$export$25289944de7a55e4)();
        this._htmlAudioContext = new (0, $9cc46572c6e21325$export$135605210c0a871c)();
        this._sounds = {};
        this.useLegacy = !this.supported;
        return this;
    }
    /**
   * The global context to use.
   * @readonly
   */ get context() {
        return this._context;
    }
    /**
   * Apply filters to all sounds. Can be useful
   * for setting global planning or global effects.
   * **Only supported with WebAudio.**
   * @example
   * import { sound, filters } from '@pixi/sound';
   * // Adds a filter to pan all output left
   * sound.filtersAll = [
   *     new filters.StereoFilter(-1)
   * ];
   */ get filtersAll() {
        if (!this.useLegacy) return this._context.filters;
        return [];
    }
    set filtersAll(filtersAll) {
        if (!this.useLegacy) this._context.filters = filtersAll;
    }
    /**
   * `true` if WebAudio is supported on the current browser.
   */ get supported() {
        return (0, $145d2d8774285a5c$export$25289944de7a55e4).AudioContext !== null;
    }
    /**
   * @ignore
   */ add(source, sourceOptions) {
        if (typeof source === "object") {
            const results = {};
            for(const alias in source){
                const options2 = this._getOptions(source[alias], sourceOptions);
                results[alias] = this.add(alias, options2);
            }
            return results;
        }
        console.assert(!this._sounds[source], `Sound with alias ${source} already exists.`);
        if (sourceOptions instanceof (0, $c49e33ab4565eb4d$export$85990f0f98a390bb)) {
            this._sounds[source] = sourceOptions;
            return sourceOptions;
        }
        const options = this._getOptions(sourceOptions);
        const sound = (0, $c49e33ab4565eb4d$export$85990f0f98a390bb).from(options);
        this._sounds[source] = sound;
        return sound;
    }
    /**
   * Internal methods for getting the options object
   * @private
   * @param source - The source options
   * @param overrides - Override default options
   * @return The construction options
   */ _getOptions(source, overrides) {
        let options;
        if (typeof source === "string") options = {
            url: source
        };
        else if (Array.isArray(source)) options = {
            url: source
        };
        else if (source instanceof ArrayBuffer || source instanceof AudioBuffer || source instanceof HTMLAudioElement) options = {
            source: source
        };
        else options = source;
        options = {
            ...options,
            ...overrides || {}
        };
        return options;
    }
    /**
   * Do not use WebAudio, force the use of legacy. This **must** be called before loading any files.
   */ get useLegacy() {
        return this._useLegacy;
    }
    set useLegacy(legacy) {
        this._useLegacy = legacy;
        this._context = !legacy && this.supported ? this._webAudioContext : this._htmlAudioContext;
    }
    /**
   * This disables auto-pause all playback when the window blurs (WebAudio only).
   * This is helpful to keep from playing sounds when the user switches tabs.
   * However, if you're running content within an iframe, this may be undesirable
   * and you should disable (set to `true`) this behavior.
   * @default false
   */ get disableAutoPause() {
        return !this._webAudioContext.autoPause;
    }
    set disableAutoPause(autoPause) {
        this._webAudioContext.autoPause = !autoPause;
    }
    /**
   * Removes a sound by alias.
   * @param alias - The sound alias reference.
   * @return Instance for chaining.
   */ remove(alias) {
        this.exists(alias, true);
        this._sounds[alias].destroy();
        delete this._sounds[alias];
        return this;
    }
    /**
   * Set the global volume for all sounds. To set per-sound volume see {@link SoundLibrary#volume}.
   */ get volumeAll() {
        return this._context.volume;
    }
    set volumeAll(volume) {
        this._context.volume = volume;
        this._context.refresh();
    }
    /**
   * Set the global speed for all sounds. To set per-sound speed see {@link SoundLibrary#speed}.
   */ get speedAll() {
        return this._context.speed;
    }
    set speedAll(speed) {
        this._context.speed = speed;
        this._context.refresh();
    }
    /**
   * Toggle paused property for all sounds.
   * @return `true` if all sounds are paused.
   */ togglePauseAll() {
        return this._context.togglePause();
    }
    /**
   * Pauses any playing sounds.
   * @return Instance for chaining.
   */ pauseAll() {
        this._context.paused = true;
        this._context.refreshPaused();
        return this;
    }
    /**
   * Resumes any sounds.
   * @return Instance for chaining.
   */ resumeAll() {
        this._context.paused = false;
        this._context.refreshPaused();
        return this;
    }
    /**
   * Toggle muted property for all sounds.
   * @return `true` if all sounds are muted.
   */ toggleMuteAll() {
        return this._context.toggleMute();
    }
    /**
   * Mutes all playing sounds.
   * @return Instance for chaining.
   */ muteAll() {
        this._context.muted = true;
        this._context.refresh();
        return this;
    }
    /**
   * Unmutes all playing sounds.
   * @return Instance for chaining.
   */ unmuteAll() {
        this._context.muted = false;
        this._context.refresh();
        return this;
    }
    /**
   * Stops and removes all sounds. They cannot be used after this.
   * @return Instance for chaining.
   */ removeAll() {
        for(const alias in this._sounds){
            this._sounds[alias].destroy();
            delete this._sounds[alias];
        }
        return this;
    }
    /**
   * Stops all sounds.
   * @return Instance for chaining.
   */ stopAll() {
        for(const alias in this._sounds)this._sounds[alias].stop();
        return this;
    }
    /**
   * Checks if a sound by alias exists.
   * @param alias - Check for alias.
   * @param assert - Whether enable console.assert.
   * @return true if the sound exists.
   */ exists(alias, assert = false) {
        const exists = !!this._sounds[alias];
        if (assert) console.assert(exists, `No sound matching alias '${alias}'.`);
        return exists;
    }
    /**
   * Convenience function to check to see if any sound is playing.
   * @returns `true` if any sound is currently playing.
   */ isPlaying() {
        for(const alias in this._sounds){
            if (this._sounds[alias].isPlaying) return true;
        }
        return false;
    }
    /**
   * Find a sound by alias.
   * @param alias - The sound alias reference.
   * @return Sound object.
   */ find(alias) {
        this.exists(alias, true);
        return this._sounds[alias];
    }
    /**
   * Plays a sound.
   * @method play
   * @instance
   * @param {string} alias - The sound alias reference.
   * @param {string} sprite - The alias of the sprite to play.
   * @return {IMediaInstance|null} The sound instance, this cannot be reused
   *         after it is done playing. Returns `null` if the sound has not yet loaded.
   */ /**
   * Plays a sound.
   * @param alias - The sound alias reference.
   * @param {PlayOptions|Function} options - The options or callback when done.
   * @return The sound instance,
   *        this cannot be reused after it is done playing. Returns a Promise if the sound
   *        has not yet loaded.
   */ play(alias, options) {
        return this.find(alias).play(options);
    }
    /**
   * Stops a sound.
   * @param alias - The sound alias reference.
   * @return Sound object.
   */ stop(alias) {
        return this.find(alias).stop();
    }
    /**
   * Pauses a sound.
   * @param alias - The sound alias reference.
   * @return Sound object.
   */ pause(alias) {
        return this.find(alias).pause();
    }
    /**
   * Resumes a sound.
   * @param alias - The sound alias reference.
   * @return Instance for chaining.
   */ resume(alias) {
        return this.find(alias).resume();
    }
    /**
   * Get or set the volume for a sound.
   * @param alias - The sound alias reference.
   * @param volume - Optional current volume to set.
   * @return The current volume.
   */ volume(alias, volume) {
        const sound = this.find(alias);
        if (volume !== void 0) sound.volume = volume;
        return sound.volume;
    }
    /**
   * Get or set the speed for a sound.
   * @param alias - The sound alias reference.
   * @param speed - Optional current speed to set.
   * @return The current speed.
   */ speed(alias, speed) {
        const sound = this.find(alias);
        if (speed !== void 0) sound.speed = speed;
        return sound.speed;
    }
    /**
   * Get the length of a sound in seconds.
   * @param alias - The sound alias reference.
   * @return The current duration in seconds.
   */ duration(alias) {
        return this.find(alias).duration;
    }
    /**
   * Closes the sound library. This will release/destroy
   * the AudioContext(s). Can be used safely if you want to
   * initialize the sound library later. Use `init` method.
   */ close() {
        this.removeAll();
        this._sounds = null;
        if (this._webAudioContext) {
            this._webAudioContext.destroy();
            this._webAudioContext = null;
        }
        if (this._htmlAudioContext) {
            this._htmlAudioContext.destroy();
            this._htmlAudioContext = null;
        }
        this._context = null;
        return this;
    }
}







class $151acf42e94803e2$export$ec91da630f36d5ea {
    /**
   * @param {AudioNode} destination - The audio node to use as the destination for the input AudioNode
   * @param {AudioNode} [source] - Optional output node, defaults to destination node. This is useful
   *        when creating filters which contains multiple AudioNode elements chained together.
   */ constructor(destination, source){
        this.init(destination, source);
    }
    /** Reinitialize */ init(destination, source) {
        this.destination = destination;
        this.source = source || destination;
    }
    /**
   * Connect to the destination.
   * @param {AudioNode} destination - The destination node to connect the output to
   */ connect(destination) {
        this.source?.connect(destination);
    }
    /** Completely disconnect filter from destination and source nodes. */ disconnect() {
        this.source?.disconnect();
    }
    /** Destroy the filter and don't use after this. */ destroy() {
        this.disconnect();
        this.destination = null;
        this.source = null;
    }
}





const $8b779da7de12abc8$var$_EqualizerFilter = class extends (0, $151acf42e94803e2$export$ec91da630f36d5ea) {
    /**
   * @param f32 - Default gain for 32 Hz
   * @param f64 - Default gain for 64 Hz
   * @param f125 - Default gain for 125 Hz
   * @param f250 - Default gain for 250 Hz
   * @param f500 - Default gain for 500 Hz
   * @param f1k - Default gain for 1000 Hz
   * @param f2k - Default gain for 2000 Hz
   * @param f4k - Default gain for 4000 Hz
   * @param f8k - Default gain for 8000 Hz
   * @param f16k - Default gain for 16000 Hz
   */ constructor(f32 = 0, f64 = 0, f125 = 0, f250 = 0, f500 = 0, f1k = 0, f2k = 0, f4k = 0, f8k = 0, f16k = 0){
        let bands = [];
        const equalizerBands = [
            {
                f: $8b779da7de12abc8$var$_EqualizerFilter.F32,
                type: "lowshelf",
                gain: f32
            },
            {
                f: $8b779da7de12abc8$var$_EqualizerFilter.F64,
                type: "peaking",
                gain: f64
            },
            {
                f: $8b779da7de12abc8$var$_EqualizerFilter.F125,
                type: "peaking",
                gain: f125
            },
            {
                f: $8b779da7de12abc8$var$_EqualizerFilter.F250,
                type: "peaking",
                gain: f250
            },
            {
                f: $8b779da7de12abc8$var$_EqualizerFilter.F500,
                type: "peaking",
                gain: f500
            },
            {
                f: $8b779da7de12abc8$var$_EqualizerFilter.F1K,
                type: "peaking",
                gain: f1k
            },
            {
                f: $8b779da7de12abc8$var$_EqualizerFilter.F2K,
                type: "peaking",
                gain: f2k
            },
            {
                f: $8b779da7de12abc8$var$_EqualizerFilter.F4K,
                type: "peaking",
                gain: f4k
            },
            {
                f: $8b779da7de12abc8$var$_EqualizerFilter.F8K,
                type: "peaking",
                gain: f8k
            },
            {
                f: $8b779da7de12abc8$var$_EqualizerFilter.F16K,
                type: "highshelf",
                gain: f16k
            }
        ];
        if (!(0, $c762494680c35543$export$8bedcca5bbd73999)().useLegacy) bands = equalizerBands.map((band)=>{
            const node = (0, $c762494680c35543$export$8bedcca5bbd73999)().context.audioContext.createBiquadFilter();
            node.type = band.type;
            (0, $ca5d1aca6f689587$export$5caed31a857b7191).setParamValue(node.Q, 1);
            node.frequency.value = band.f;
            (0, $ca5d1aca6f689587$export$5caed31a857b7191).setParamValue(node.gain, band.gain);
            return node;
        });
        super(bands[0], bands[bands.length - 1]);
        this.bands = bands;
        this.bandsMap = {};
        for(let i = 0; i < this.bands.length; i++){
            const node = this.bands[i];
            if (i > 0) this.bands[i - 1].connect(node);
            this.bandsMap[node.frequency.value] = node;
        }
    }
    /**
   * Set gain on a specific frequency.
   * @param frequency - The frequency, see EqualizerFilter.F* for bands
   * @param gain - Recommended -40 to 40.
   */ setGain(frequency, gain = 0) {
        if (!this.bandsMap[frequency]) throw new Error(`No band found for frequency ${frequency}`);
        (0, $ca5d1aca6f689587$export$5caed31a857b7191).setParamValue(this.bandsMap[frequency].gain, gain);
    }
    /**
   * Get gain amount on a specific frequency.
   * @return The amount of gain set.
   */ getGain(frequency) {
        if (!this.bandsMap[frequency]) throw new Error(`No band found for frequency ${frequency}`);
        return this.bandsMap[frequency].gain.value;
    }
    /**
   * Gain at 32 Hz frequencey.
   * @default 0
   */ set f32(value) {
        this.setGain($8b779da7de12abc8$var$_EqualizerFilter.F32, value);
    }
    get f32() {
        return this.getGain($8b779da7de12abc8$var$_EqualizerFilter.F32);
    }
    /**
   * Gain at 64 Hz frequencey.
   * @default 0
   */ set f64(value) {
        this.setGain($8b779da7de12abc8$var$_EqualizerFilter.F64, value);
    }
    get f64() {
        return this.getGain($8b779da7de12abc8$var$_EqualizerFilter.F64);
    }
    /**
   * Gain at 125 Hz frequencey.
   * @default 0
   */ set f125(value) {
        this.setGain($8b779da7de12abc8$var$_EqualizerFilter.F125, value);
    }
    get f125() {
        return this.getGain($8b779da7de12abc8$var$_EqualizerFilter.F125);
    }
    /**
   * Gain at 250 Hz frequencey.
   * @default 0
   */ set f250(value) {
        this.setGain($8b779da7de12abc8$var$_EqualizerFilter.F250, value);
    }
    get f250() {
        return this.getGain($8b779da7de12abc8$var$_EqualizerFilter.F250);
    }
    /**
   * Gain at 500 Hz frequencey.
   * @default 0
   */ set f500(value) {
        this.setGain($8b779da7de12abc8$var$_EqualizerFilter.F500, value);
    }
    get f500() {
        return this.getGain($8b779da7de12abc8$var$_EqualizerFilter.F500);
    }
    /**
   * Gain at 1 KHz frequencey.
   * @default 0
   */ set f1k(value) {
        this.setGain($8b779da7de12abc8$var$_EqualizerFilter.F1K, value);
    }
    get f1k() {
        return this.getGain($8b779da7de12abc8$var$_EqualizerFilter.F1K);
    }
    /**
   * Gain at 2 KHz frequencey.
   * @default 0
   */ set f2k(value) {
        this.setGain($8b779da7de12abc8$var$_EqualizerFilter.F2K, value);
    }
    get f2k() {
        return this.getGain($8b779da7de12abc8$var$_EqualizerFilter.F2K);
    }
    /**
   * Gain at 4 KHz frequencey.
   * @default 0
   */ set f4k(value) {
        this.setGain($8b779da7de12abc8$var$_EqualizerFilter.F4K, value);
    }
    get f4k() {
        return this.getGain($8b779da7de12abc8$var$_EqualizerFilter.F4K);
    }
    /**
   * Gain at 8 KHz frequencey.
   * @default 0
   */ set f8k(value) {
        this.setGain($8b779da7de12abc8$var$_EqualizerFilter.F8K, value);
    }
    get f8k() {
        return this.getGain($8b779da7de12abc8$var$_EqualizerFilter.F8K);
    }
    /**
   * Gain at 16 KHz frequencey.
   * @default 0
   */ set f16k(value) {
        this.setGain($8b779da7de12abc8$var$_EqualizerFilter.F16K, value);
    }
    get f16k() {
        return this.getGain($8b779da7de12abc8$var$_EqualizerFilter.F16K);
    }
    /** Reset all frequency bands to have gain of 0 */ reset() {
        this.bands.forEach((band)=>{
            (0, $ca5d1aca6f689587$export$5caed31a857b7191).setParamValue(band.gain, 0);
        });
    }
    destroy() {
        this.bands.forEach((band)=>{
            band.disconnect();
        });
        this.bands = null;
        this.bandsMap = null;
    }
};
let $8b779da7de12abc8$export$da9588c63637d4bd = $8b779da7de12abc8$var$_EqualizerFilter;
/**
 * Band at 32 Hz
 * @readonly
 */ $8b779da7de12abc8$export$da9588c63637d4bd.F32 = 32;
/**
 * Band at 64 Hz
 * @readonly
 */ $8b779da7de12abc8$export$da9588c63637d4bd.F64 = 64;
/**
 * Band at 125 Hz
 * @readonly
 */ $8b779da7de12abc8$export$da9588c63637d4bd.F125 = 125;
/**
 * Band at 250 Hz
 * @readonly
 */ $8b779da7de12abc8$export$da9588c63637d4bd.F250 = 250;
/**
 * Band at 500 Hz
 * @readonly
 */ $8b779da7de12abc8$export$da9588c63637d4bd.F500 = 500;
/**
 * Band at 1000 Hz
 * @readonly
 */ $8b779da7de12abc8$export$da9588c63637d4bd.F1K = 1e3;
/**
 * Band at 2000 Hz
 * @readonly
 */ $8b779da7de12abc8$export$da9588c63637d4bd.F2K = 2e3;
/**
 * Band at 4000 Hz
 * @readonly
 */ $8b779da7de12abc8$export$da9588c63637d4bd.F4K = 4e3;
/**
 * Band at 8000 Hz
 * @readonly
 */ $8b779da7de12abc8$export$da9588c63637d4bd.F8K = 8e3;
/**
 * Band at 16000 Hz
 * @readonly
 */ $8b779da7de12abc8$export$da9588c63637d4bd.F16K = 16e3;




class $c3b1cce56ca03397$export$60a770664ca75ef2 extends (0, $151acf42e94803e2$export$ec91da630f36d5ea) {
    /** @param amount - The amount of distoration from 0 to 1. */ constructor(amount = 0){
        let distortion;
        if (!(0, $c762494680c35543$export$8bedcca5bbd73999)().useLegacy) {
            const { audioContext: audioContext } = (0, $c762494680c35543$export$8bedcca5bbd73999)().context;
            distortion = audioContext.createWaveShaper();
        }
        super(distortion);
        this._distortion = distortion;
        this.amount = amount;
    }
    /** The amount of distortion to set. */ set amount(value) {
        this._amount = value;
        if ((0, $c762494680c35543$export$8bedcca5bbd73999)().useLegacy) return;
        const scaledValue = value * 1e3;
        const samples = 44100;
        const curve = new Float32Array(samples);
        const deg = Math.PI / 180;
        let i = 0;
        let x;
        for(; i < samples; ++i){
            x = i * 2 / samples - 1;
            curve[i] = (3 + scaledValue) * x * 20 * deg / (Math.PI + scaledValue * Math.abs(x));
        }
        this._distortion.curve = curve;
        this._distortion.oversample = "4x";
    }
    get amount() {
        return this._amount;
    }
    destroy() {
        this._distortion = null;
        super.destroy();
    }
}





class $4726057574cd580b$export$3f75220355fd576e extends (0, $151acf42e94803e2$export$ec91da630f36d5ea) {
    /** @param pan - The amount of panning, -1 is left, 1 is right, 0 is centered. */ constructor(pan = 0){
        let stereo;
        let panner;
        let destination;
        if (!(0, $c762494680c35543$export$8bedcca5bbd73999)().useLegacy) {
            const { audioContext: audioContext } = (0, $c762494680c35543$export$8bedcca5bbd73999)().context;
            if (audioContext.createStereoPanner) {
                stereo = audioContext.createStereoPanner();
                destination = stereo;
            } else {
                panner = audioContext.createPanner();
                panner.panningModel = "equalpower";
                destination = panner;
            }
        }
        super(destination);
        this._stereo = stereo;
        this._panner = panner;
        this.pan = pan;
    }
    /** Set the amount of panning, where -1 is left, 1 is right, and 0 is centered */ set pan(value) {
        this._pan = value;
        if (this._stereo) (0, $ca5d1aca6f689587$export$5caed31a857b7191).setParamValue(this._stereo.pan, value);
        else if (this._panner) this._panner.setPosition(value, 0, 1 - Math.abs(value));
    }
    get pan() {
        return this._pan;
    }
    destroy() {
        super.destroy();
        this._stereo = null;
        this._panner = null;
    }
}




class $2f387f5312cea54d$export$cbbc92373fb81e3b extends (0, $151acf42e94803e2$export$ec91da630f36d5ea) {
    /**
   * @param seconds - Seconds for reverb
   * @param decay - The decay length
   * @param reverse - Reverse reverb
   */ constructor(seconds = 3, decay = 2, reverse = false){
        super(null);
        this._seconds = this._clamp(seconds, 1, 50);
        this._decay = this._clamp(decay, 0, 100);
        this._reverse = reverse;
        this._rebuild();
    }
    /**
   * Clamp a value
   * @param value
   * @param min - Minimum value
   * @param max - Maximum value
   * @return Clamped number
   */ _clamp(value, min, max) {
        return Math.min(max, Math.max(min, value));
    }
    /**
   * Length of reverb in seconds from 1 to 50
   * @default 3
   */ get seconds() {
        return this._seconds;
    }
    set seconds(seconds) {
        this._seconds = this._clamp(seconds, 1, 50);
        this._rebuild();
    }
    /**
   * Decay value from 0 to 100
   * @default 2
   */ get decay() {
        return this._decay;
    }
    set decay(decay) {
        this._decay = this._clamp(decay, 0, 100);
        this._rebuild();
    }
    /**
   * Reverse value from 0 to 1
   * @default false
   */ get reverse() {
        return this._reverse;
    }
    set reverse(reverse) {
        this._reverse = reverse;
        this._rebuild();
    }
    /**
   * Utility function for building an impulse response
   * from the module parameters.
   */ _rebuild() {
        if ((0, $c762494680c35543$export$8bedcca5bbd73999)().useLegacy) return;
        const { audioContext: audioContext } = (0, $c762494680c35543$export$8bedcca5bbd73999)().context;
        const rate = audioContext.sampleRate;
        const length = rate * this._seconds;
        const impulse = audioContext.createBuffer(2, length, rate);
        const impulseL = impulse.getChannelData(0);
        const impulseR = impulse.getChannelData(1);
        let n;
        for(let i = 0; i < length; i++){
            n = this._reverse ? length - i : i;
            impulseL[i] = (Math.random() * 2 - 1) * Math.pow(1 - n / length, this._decay);
            impulseR[i] = (Math.random() * 2 - 1) * Math.pow(1 - n / length, this._decay);
        }
        const convolver = audioContext.createConvolver();
        convolver.buffer = impulse;
        this.init(convolver);
    }
}




class $9712c84cec291034$export$6237f62c652e6374 extends (0, $151acf42e94803e2$export$ec91da630f36d5ea) {
    constructor(){
        let merger;
        let splitter;
        if (!(0, $c762494680c35543$export$8bedcca5bbd73999)().useLegacy) {
            const { audioContext: audioContext } = (0, $c762494680c35543$export$8bedcca5bbd73999)().context;
            splitter = audioContext.createChannelSplitter();
            merger = audioContext.createChannelMerger();
            merger.connect(splitter);
        }
        super(merger, splitter);
        this._merger = merger;
    }
    destroy() {
        this._merger?.disconnect();
        this._merger = null;
        super.destroy();
    }
}




class $e65084ad88bcf7d2$export$a54bec6fd61dbe35 extends (0, $151acf42e94803e2$export$ec91da630f36d5ea) {
    constructor(){
        let destination;
        let source;
        if (!(0, $c762494680c35543$export$8bedcca5bbd73999)().useLegacy) {
            const { audioContext: audioContext } = (0, $c762494680c35543$export$8bedcca5bbd73999)().context;
            destination = audioContext.createMediaStreamDestination();
            source = audioContext.createMediaStreamSource(destination.stream);
        }
        super(destination, source);
        this._stream = destination?.stream;
    }
    get stream() {
        return this._stream;
    }
    destroy() {
        this._stream = null;
        super.destroy();
    }
}





class $526b65fc9ec3ffa6$export$e75cce85db5659f7 extends (0, $151acf42e94803e2$export$ec91da630f36d5ea) {
    constructor(){
        let destination;
        let source;
        if (!(0, $c762494680c35543$export$8bedcca5bbd73999)().useLegacy) {
            const { audioContext: audioContext } = (0, $c762494680c35543$export$8bedcca5bbd73999)().context;
            const lpf1 = audioContext.createBiquadFilter();
            const lpf2 = audioContext.createBiquadFilter();
            const hpf1 = audioContext.createBiquadFilter();
            const hpf2 = audioContext.createBiquadFilter();
            lpf1.type = "lowpass";
            (0, $ca5d1aca6f689587$export$5caed31a857b7191).setParamValue(lpf1.frequency, 2e3);
            lpf2.type = "lowpass";
            (0, $ca5d1aca6f689587$export$5caed31a857b7191).setParamValue(lpf2.frequency, 2e3);
            hpf1.type = "highpass";
            (0, $ca5d1aca6f689587$export$5caed31a857b7191).setParamValue(hpf1.frequency, 500);
            hpf2.type = "highpass";
            (0, $ca5d1aca6f689587$export$5caed31a857b7191).setParamValue(hpf2.frequency, 500);
            lpf1.connect(lpf2);
            lpf2.connect(hpf1);
            hpf1.connect(hpf2);
            destination = lpf1;
            source = hpf2;
        }
        super(destination, source);
    }
}












let $4c7b20de48bcd298$export$75d5873f93626b73 = 0;
function $4c7b20de48bcd298$export$24b8a725481a84c8(url, callback) {
    const alias = `alias${$4c7b20de48bcd298$export$75d5873f93626b73++}`;
    (0, $c762494680c35543$export$8bedcca5bbd73999)().add(alias, {
        url: url,
        preload: true,
        autoPlay: true,
        loaded: (err)=>{
            if (err) {
                console.error(err);
                (0, $c762494680c35543$export$8bedcca5bbd73999)().remove(alias);
                if (callback) callback(err);
            }
        },
        complete: ()=>{
            (0, $c762494680c35543$export$8bedcca5bbd73999)().remove(alias);
            if (callback) callback(null);
        }
    });
    return alias;
}




function $aa2fd62cba94abf4$export$b3890eb0ae9dca99(sound, options) {
    const canvas = document.createElement("canvas");
    options = {
        width: 512,
        height: 128,
        fill: "black",
        ...options || {}
    };
    canvas.width = options.width;
    canvas.height = options.height;
    const baseTexture = (0, $30c85657f0c625d5$export$d6306e508f184154).from(canvas);
    if (!(sound.media instanceof (0, $27b9474723706491$export$9ea3865f5a7f2b06))) return baseTexture;
    const media = sound.media;
    console.assert(!!media.buffer, "No buffer found, load first");
    const context = canvas.getContext("2d");
    context.fillStyle = options.fill;
    const data = media.buffer.getChannelData(0);
    const step = Math.ceil(data.length / options.width);
    const amp = options.height / 2;
    for(let i = 0; i < options.width; i++){
        let min = 1;
        let max = -1;
        for(let j = 0; j < step; j++){
            const datum = data[i * step + j];
            if (datum < min) min = datum;
            if (datum > max) max = datum;
        }
        context.fillRect(i, (1 + min) * amp, 1, Math.max(1, (max - min) * amp));
    }
    return baseTexture;
}




function $9cb972e4d4425821$export$174af12dde0cc01(hertz = 200, seconds = 1) {
    const sound = (0, $c49e33ab4565eb4d$export$85990f0f98a390bb).from({
        singleInstance: true
    });
    if (!(sound.media instanceof (0, $27b9474723706491$export$9ea3865f5a7f2b06))) return sound;
    const media = sound.media;
    const context = sound.context;
    const nChannels = 1;
    const sampleRate = 48e3;
    const amplitude = 2;
    const buffer = context.audioContext.createBuffer(nChannels, seconds * sampleRate, sampleRate);
    const fArray = buffer.getChannelData(0);
    for(let i = 0; i < fArray.length; i++){
        const time = i / buffer.sampleRate;
        const angle = hertz * time * Math.PI;
        fArray[i] = Math.sin(angle) * amplitude;
    }
    media.buffer = buffer;
    sound.isLoaded = true;
    return sound;
}








const $49816e9ed1deed6a$var$assetKeyMap = {
    loader: (0, $c90155f6d7d8d8f6$export$4f037c6ec2da4eeb).LoadParser,
    resolver: (0, $c90155f6d7d8d8f6$export$4f037c6ec2da4eeb).ResolveParser,
    cache: (0, $c90155f6d7d8d8f6$export$4f037c6ec2da4eeb).CacheParser,
    detection: (0, $c90155f6d7d8d8f6$export$4f037c6ec2da4eeb).DetectionParser
};
(0, $c90155f6d7d8d8f6$export$cc3e2d3244e01b7f).handle((0, $c90155f6d7d8d8f6$export$4f037c6ec2da4eeb).Asset, (extension)=>{
    const ref = extension.ref;
    Object.entries($49816e9ed1deed6a$var$assetKeyMap).filter(([key])=>!!ref[key]).forEach(([key, type])=>(0, $c90155f6d7d8d8f6$export$cc3e2d3244e01b7f).add(Object.assign(ref[key], // Allow the function to optionally define it's own
        // ExtensionMetadata, the use cases here is priority for LoaderParsers
        {
            extension: ref[key].extension ?? type
        })));
}, (extension)=>{
    const ref = extension.ref;
    Object.keys($49816e9ed1deed6a$var$assetKeyMap).filter((key)=>!!ref[key]).forEach((key)=>(0, $c90155f6d7d8d8f6$export$cc3e2d3244e01b7f).remove(ref[key]));
});



class $e71af446771112c8$export$1949379a83b843d5 {
    /**
   * @param loader
   * @param verbose - should the loader log to the console
   */ constructor(loader, verbose = !1){
        this._loader = loader, this._assetList = [], this._isLoading = !1, this._maxConcurrent = 1, this.verbose = verbose;
    }
    /**
   * Adds an array of assets to load.
   * @param assetUrls - assets to load
   */ add(assetUrls) {
        assetUrls.forEach((a)=>{
            this._assetList.push(a);
        }), this.verbose && console.log("[BackgroundLoader] assets: ", this._assetList), this._isActive && !this._isLoading && this._next();
    }
    /**
   * Loads the next set of assets. Will try to load as many assets as it can at the same time.
   *
   * The max assets it will try to load at one time will be 4.
   */ async _next() {
        if (this._assetList.length && this._isActive) {
            this._isLoading = !0;
            const toLoad = [], toLoadAmount = Math.min(this._assetList.length, this._maxConcurrent);
            for(let i = 0; i < toLoadAmount; i++)toLoad.push(this._assetList.pop());
            await this._loader.load(toLoad), this._isLoading = !1, this._next();
        }
    }
    /**
   * Activate/Deactivate the loading. If set to true then it will immediately continue to load the next asset.
   * @returns whether the class is active
   */ get active() {
        return this._isActive;
    }
    set active(value) {
        this._isActive !== value && (this._isActive = value, value && !this._isLoading && this._next());
    }
}



function $b7a22d284615e514$export$7ff8b059fb914323(url, mimes) {
    if (Array.isArray(mimes)) {
        for (const mime of mimes)if (url.startsWith(`data:${mime}`)) return !0;
        return !1;
    }
    return url.startsWith(`data:${mimes}`);
}



function $09c9bb162e36b2d4$export$fd0180357b95b812(url, extension) {
    const tempURL = url.split("?")[0], ext = (0, $db31fc3dfae4939b$exports).path.extname(tempURL).toLowerCase();
    return Array.isArray(extension) ? extension.includes(ext) : ext === extension;
}


const $7dc81a51635033d6$export$b01be8e180bf3d9b = (input, transform, forceTransform = !1)=>(Array.isArray(input) || (input = [
        input
    ]), transform ? input.map((item)=>typeof item == "string" || forceTransform ? transform(item) : item) : input);


const $a06717d44d10be9c$export$f57b97ef8be10dda = (targetUrl, sourceUrl)=>{
    const searchParams = sourceUrl.split("?")[1];
    return searchParams && (targetUrl += `?${searchParams}`), targetUrl;
};


function $e4c9f40c3444b3b9$var$processX(base, ids, depth, result, tags) {
    const id = ids[depth];
    for(let i = 0; i < id.length; i++){
        const value = id[i];
        depth < ids.length - 1 ? $e4c9f40c3444b3b9$var$processX(base.replace(result[depth], value), ids, depth + 1, result, tags) : tags.push(base.replace(result[depth], value));
    }
}
function $e4c9f40c3444b3b9$export$738117acc6638004(string) {
    const regex = /\{(.*?)\}/g, result = string.match(regex), tags = [];
    if (result) {
        const ids = [];
        result.forEach((vars)=>{
            const split = vars.substring(1, vars.length - 1).split(",");
            ids.push(split);
        }), $e4c9f40c3444b3b9$var$processX(string, ids, 0, result, tags);
    } else tags.push(string);
    return tags;
}


const $a6123fb41c54da70$export$16a80d27953452d4 = (item)=>!Array.isArray(item);





class $36f44157e8bf94de$var$CacheClass {
    constructor(){
        this._parsers = [], this._cache = /* @__PURE__ */ new Map(), this._cacheMap = /* @__PURE__ */ new Map();
    }
    /** Clear all entries. */ reset() {
        this._cacheMap.clear(), this._cache.clear();
    }
    /**
   * Check if the key exists
   * @param key - The key to check
   */ has(key) {
        return this._cache.has(key);
    }
    /**
   * Fetch entry by key
   * @param key - The key of the entry to get
   */ get(key) {
        const result = this._cache.get(key);
        return result || console.warn(`[Assets] Asset id ${key} was not found in the Cache`), result;
    }
    /**
   * Set a value by key or keys name
   * @param key - The key or keys to set
   * @param value - The value to store in the cache or from which cacheable assets will be derived.
   */ set(key, value) {
        const keys = (0, $7dc81a51635033d6$export$b01be8e180bf3d9b)(key);
        let cacheableAssets;
        for(let i = 0; i < this.parsers.length; i++){
            const parser = this.parsers[i];
            if (parser.test(value)) {
                cacheableAssets = parser.getCacheableAssets(keys, value);
                break;
            }
        }
        cacheableAssets || (cacheableAssets = {}, keys.forEach((key2)=>{
            cacheableAssets[key2] = value;
        }));
        const cacheKeys = Object.keys(cacheableAssets), cachedAssets = {
            cacheKeys: cacheKeys,
            keys: keys
        };
        if (keys.forEach((key2)=>{
            this._cacheMap.set(key2, cachedAssets);
        }), cacheKeys.forEach((key2)=>{
            this._cache.has(key2) && this._cache.get(key2) !== value && console.warn("[Cache] already has key:", key2), this._cache.set(key2, cacheableAssets[key2]);
        }), value instanceof (0, $14896914ad3ae15d$export$5431306cf43de24a)) {
            const texture = value;
            keys.forEach((key2)=>{
                texture.baseTexture !== (0, $14896914ad3ae15d$export$5431306cf43de24a).EMPTY.baseTexture && (0, $30c85657f0c625d5$export$d6306e508f184154).addToCache(texture.baseTexture, key2), (0, $14896914ad3ae15d$export$5431306cf43de24a).addToCache(texture, key2);
            });
        }
    }
    /**
   * Remove entry by key
   *
   * This function will also remove any associated alias from the cache also.
   * @param key - The key of the entry to remove
   */ remove(key) {
        if (!this._cacheMap.has(key)) {
            console.warn(`[Assets] Asset id ${key} was not found in the Cache`);
            return;
        }
        const cacheMap = this._cacheMap.get(key);
        cacheMap.cacheKeys.forEach((key2)=>{
            this._cache.delete(key2);
        }), cacheMap.keys.forEach((key2)=>{
            this._cacheMap.delete(key2);
        });
    }
    /** All loader parsers registered */ get parsers() {
        return this._parsers;
    }
}
const $36f44157e8bf94de$export$94affb487e701bf2 = new $36f44157e8bf94de$var$CacheClass();






class $cd5a64b8c87ab093$export$3b0d6d7590275603 {
    constructor(){
        this._parsers = [], this._parsersValidated = !1, this.parsers = new Proxy(this._parsers, {
            set: (target, key, value)=>(this._parsersValidated = !1, target[key] = value, !0)
        }), this.promiseCache = {};
    }
    /** function used for testing */ reset() {
        this._parsersValidated = !1, this.promiseCache = {};
    }
    /**
   * Used internally to generate a promise for the asset to be loaded.
   * @param url - The URL to be loaded
   * @param data - any custom additional information relevant to the asset being loaded
   * @returns - a promise that will resolve to an Asset for example a Texture of a JSON object
   */ _getLoadPromiseAndParser(url, data) {
        const result = {
            promise: null,
            parser: null
        };
        return result.promise = (async ()=>{
            let asset = null, parser = null;
            if (data.loadParser && (parser = this._parserHash[data.loadParser], parser || console.warn(`[Assets] specified load parser "${data.loadParser}" not found while loading ${url}`)), !parser) {
                for(let i = 0; i < this.parsers.length; i++){
                    const parserX = this.parsers[i];
                    if (parserX.load && parserX.test?.(url, data, this)) {
                        parser = parserX;
                        break;
                    }
                }
                if (!parser) return console.warn(`[Assets] ${url} could not be loaded as we don't know how to parse it, ensure the correct parser has been added`), null;
            }
            asset = await parser.load(url, data, this), result.parser = parser;
            for(let i = 0; i < this.parsers.length; i++){
                const parser2 = this.parsers[i];
                parser2.parse && parser2.parse && await parser2.testParse?.(asset, data, this) && (asset = await parser2.parse(asset, data, this) || asset, result.parser = parser2);
            }
            return asset;
        })(), result;
    }
    async load(assetsToLoadIn, onProgress) {
        this._parsersValidated || this._validateParsers();
        let count = 0;
        const assets = {}, singleAsset = (0, $a6123fb41c54da70$export$16a80d27953452d4)(assetsToLoadIn), assetsToLoad = (0, $7dc81a51635033d6$export$b01be8e180bf3d9b)(assetsToLoadIn, (item)=>({
                alias: [
                    item
                ],
                src: item
            })), total = assetsToLoad.length, promises = assetsToLoad.map(async (asset)=>{
            const url = (0, $db31fc3dfae4939b$exports).path.toAbsolute(asset.src);
            if (!assets[asset.src]) try {
                this.promiseCache[url] || (this.promiseCache[url] = this._getLoadPromiseAndParser(url, asset)), assets[asset.src] = await this.promiseCache[url].promise, onProgress && onProgress(++count / total);
            } catch (e) {
                throw delete this.promiseCache[url], delete assets[asset.src], new Error(`[Loader.load] Failed to load ${url}.
${e}`);
            }
        });
        return await Promise.all(promises), singleAsset ? assets[assetsToLoad[0].src] : assets;
    }
    /**
   * Unloads one or more assets. Any unloaded assets will be destroyed, freeing up memory for your app.
   * The parser that created the asset, will be the one that unloads it.
   * @example
   * // Single asset:
   * const asset = await Loader.load('cool.png');
   *
   * await Loader.unload('cool.png');
   *
   * console.log(asset.destroyed); // true
   * @param assetsToUnloadIn - urls that you want to unload, or a single one!
   */ async unload(assetsToUnloadIn) {
        const promises = (0, $7dc81a51635033d6$export$b01be8e180bf3d9b)(assetsToUnloadIn, (item)=>({
                alias: [
                    item
                ],
                src: item
            })).map(async (asset)=>{
            const url = (0, $db31fc3dfae4939b$exports).path.toAbsolute(asset.src), loadPromise = this.promiseCache[url];
            if (loadPromise) {
                const loadedAsset = await loadPromise.promise;
                delete this.promiseCache[url], loadPromise.parser?.unload?.(loadedAsset, asset, this);
            }
        });
        await Promise.all(promises);
    }
    /** validates our parsers, right now it only checks for name conflicts but we can add more here as required! */ _validateParsers() {
        this._parsersValidated = !0, this._parserHash = this._parsers.filter((parser)=>parser.name).reduce((hash, parser)=>(hash[parser.name] && console.warn(`[Assets] loadParser name conflict "${parser.name}"`), {
                ...hash,
                [parser.name]: parser
            }), {});
    }
}


var $ed5d6a4467c2b40c$export$820ed6348c4f2750 = /* @__PURE__ */ ((LoaderParserPriority2)=>(LoaderParserPriority2[LoaderParserPriority2.Low = 0] = "Low", LoaderParserPriority2[LoaderParserPriority2.Normal = 1] = "Normal", LoaderParserPriority2[LoaderParserPriority2.High = 2] = "High", LoaderParserPriority2))($ed5d6a4467c2b40c$export$820ed6348c4f2750 || {});






const $be0d2988204d70ae$var$validJSONExtension = ".json", $be0d2988204d70ae$var$validJSONMIME = "application/json", $be0d2988204d70ae$export$e7c8553478f3aac7 = {
    extension: {
        type: (0, $c90155f6d7d8d8f6$export$4f037c6ec2da4eeb).LoadParser,
        priority: (0, $ed5d6a4467c2b40c$export$820ed6348c4f2750).Low
    },
    name: "loadJson",
    test (url) {
        return (0, $b7a22d284615e514$export$7ff8b059fb914323)(url, $be0d2988204d70ae$var$validJSONMIME) || (0, $09c9bb162e36b2d4$export$fd0180357b95b812)(url, $be0d2988204d70ae$var$validJSONExtension);
    },
    async load (url) {
        return await (await (0, $2808efac47e52be0$export$a5a6e0b888b2c992).ADAPTER.fetch(url)).json();
    }
};
(0, $c90155f6d7d8d8f6$export$cc3e2d3244e01b7f).add($be0d2988204d70ae$export$e7c8553478f3aac7);






const $ddc50119f9a51683$var$validTXTExtension = ".txt", $ddc50119f9a51683$var$validTXTMIME = "text/plain", $ddc50119f9a51683$export$3835b7ee6dbebde8 = {
    name: "loadTxt",
    extension: {
        type: (0, $c90155f6d7d8d8f6$export$4f037c6ec2da4eeb).LoadParser,
        priority: (0, $ed5d6a4467c2b40c$export$820ed6348c4f2750).Low
    },
    test (url) {
        return (0, $b7a22d284615e514$export$7ff8b059fb914323)(url, $ddc50119f9a51683$var$validTXTMIME) || (0, $09c9bb162e36b2d4$export$fd0180357b95b812)(url, $ddc50119f9a51683$var$validTXTExtension);
    },
    async load (url) {
        return await (await (0, $2808efac47e52be0$export$a5a6e0b888b2c992).ADAPTER.fetch(url)).text();
    }
};
(0, $c90155f6d7d8d8f6$export$cc3e2d3244e01b7f).add($ddc50119f9a51683$export$3835b7ee6dbebde8);






const $383ccbbcbb9b34b6$var$validWeights = [
    "normal",
    "bold",
    "100",
    "200",
    "300",
    "400",
    "500",
    "600",
    "700",
    "800",
    "900"
], $383ccbbcbb9b34b6$var$validFontExtensions = [
    ".ttf",
    ".otf",
    ".woff",
    ".woff2"
], $383ccbbcbb9b34b6$var$validFontMIMEs = [
    "font/ttf",
    "font/otf",
    "font/woff",
    "font/woff2"
], $383ccbbcbb9b34b6$var$CSS_IDENT_TOKEN_REGEX = /^(--|-?[A-Z_])[0-9A-Z_-]*$/i;
function $383ccbbcbb9b34b6$export$c461ca8f39d93d9b(url) {
    const ext = (0, $db31fc3dfae4939b$exports).path.extname(url), nameTokens = (0, $db31fc3dfae4939b$exports).path.basename(url, ext).replace(/(-|_)/g, " ").toLowerCase().split(" ").map((word)=>word.charAt(0).toUpperCase() + word.slice(1));
    let valid = nameTokens.length > 0;
    for (const token of nameTokens)if (!token.match($383ccbbcbb9b34b6$var$CSS_IDENT_TOKEN_REGEX)) {
        valid = !1;
        break;
    }
    let fontFamilyName = nameTokens.join(" ");
    return valid || (fontFamilyName = `"${fontFamilyName.replace(/[\\"]/g, "\\$&")}"`), fontFamilyName;
}
const $383ccbbcbb9b34b6$export$129ed93ad26b0298 = {
    extension: {
        type: (0, $c90155f6d7d8d8f6$export$4f037c6ec2da4eeb).LoadParser,
        priority: (0, $ed5d6a4467c2b40c$export$820ed6348c4f2750).Low
    },
    name: "loadWebFont",
    test (url) {
        return (0, $b7a22d284615e514$export$7ff8b059fb914323)(url, $383ccbbcbb9b34b6$var$validFontMIMEs) || (0, $09c9bb162e36b2d4$export$fd0180357b95b812)(url, $383ccbbcbb9b34b6$var$validFontExtensions);
    },
    async load (url, options) {
        const fonts = (0, $2808efac47e52be0$export$a5a6e0b888b2c992).ADAPTER.getFontFaceSet();
        if (fonts) {
            const fontFaces = [], name = options.data?.family ?? $383ccbbcbb9b34b6$export$c461ca8f39d93d9b(url), weights = options.data?.weights?.filter((weight)=>$383ccbbcbb9b34b6$var$validWeights.includes(weight)) ?? [
                "normal"
            ], data = options.data ?? {};
            for(let i = 0; i < weights.length; i++){
                const weight = weights[i], font = new FontFace(name, `url(${encodeURI(url)})`, {
                    ...data,
                    weight: weight
                });
                await font.load(), fonts.add(font), fontFaces.push(font);
            }
            return fontFaces.length === 1 ? fontFaces[0] : fontFaces;
        }
        return console.warn("[loadWebFont] FontFace API is not supported. Skipping loading font"), null;
    },
    unload (font) {
        (Array.isArray(font) ? font : [
            font
        ]).forEach((t)=>(0, $2808efac47e52be0$export$a5a6e0b888b2c992).ADAPTER.getFontFaceSet().delete(t));
    }
};
(0, $c90155f6d7d8d8f6$export$cc3e2d3244e01b7f).add($383ccbbcbb9b34b6$export$129ed93ad26b0298);










let $9564844aff6f68f3$var$UUID = 0, $9564844aff6f68f3$var$MAX_WORKERS;
const $9564844aff6f68f3$var$WHITE_PNG = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAQAAAC1HAwCAAAAC0lEQVR42mP8/x8AAwMCAO+ip1sAAAAASUVORK5CYII=", $9564844aff6f68f3$var$checkImageBitmapCode = {
    id: "checkImageBitmap",
    code: `
    async function checkImageBitmap()
    {
        try
        {
            if (typeof createImageBitmap !== 'function') return false;

            const response = await fetch('${$9564844aff6f68f3$var$WHITE_PNG}');
            const imageBlob =  await response.blob();
            const imageBitmap = await createImageBitmap(imageBlob);

            return imageBitmap.width === 1 && imageBitmap.height === 1;
        }
        catch (e)
        {
            return false;
        }
    }
    checkImageBitmap().then((result) => { self.postMessage(result); });
    `
}, $9564844aff6f68f3$var$workerCode = {
    id: "loadImageBitmap",
    code: `
    async function loadImageBitmap(url)
    {
        const response = await fetch(url);

        if (!response.ok)
        {
            throw new Error(\`[WorkerManager.loadImageBitmap] Failed to fetch \${url}: \`
                + \`\${response.status} \${response.statusText}\`);
        }

        const imageBlob =  await response.blob();
        const imageBitmap = await createImageBitmap(imageBlob);

        return imageBitmap;
    }
    self.onmessage = async (event) =>
    {
        try
        {
            const imageBitmap = await loadImageBitmap(event.data.data[0]);

            self.postMessage({
                data: imageBitmap,
                uuid: event.data.uuid,
                id: event.data.id,
            }, [imageBitmap]);
        }
        catch(e)
        {
            self.postMessage({
                error: e,
                uuid: event.data.uuid,
                id: event.data.id,
            });
        }
    };`
};
let $9564844aff6f68f3$var$workerURL;
class $9564844aff6f68f3$var$WorkerManagerClass {
    constructor(){
        this._initialized = !1, this._createdWorkers = 0, this.workerPool = [], this.queue = [], this.resolveHash = {};
    }
    isImageBitmapSupported() {
        return this._isImageBitmapSupported !== void 0 ? this._isImageBitmapSupported : (this._isImageBitmapSupported = new Promise((resolve)=>{
            const workerURL2 = URL.createObjectURL(new Blob([
                $9564844aff6f68f3$var$checkImageBitmapCode.code
            ], {
                type: "application/javascript"
            })), worker = new Worker(workerURL2);
            worker.addEventListener("message", (event)=>{
                worker.terminate(), URL.revokeObjectURL(workerURL2), resolve(event.data);
            });
        }), this._isImageBitmapSupported);
    }
    loadImageBitmap(src) {
        return this._run("loadImageBitmap", [
            src
        ]);
    }
    async _initWorkers() {
        this._initialized || (this._initialized = !0);
    }
    getWorker() {
        $9564844aff6f68f3$var$MAX_WORKERS === void 0 && ($9564844aff6f68f3$var$MAX_WORKERS = navigator.hardwareConcurrency || 4);
        let worker = this.workerPool.pop();
        return !worker && this._createdWorkers < $9564844aff6f68f3$var$MAX_WORKERS && ($9564844aff6f68f3$var$workerURL || ($9564844aff6f68f3$var$workerURL = URL.createObjectURL(new Blob([
            $9564844aff6f68f3$var$workerCode.code
        ], {
            type: "application/javascript"
        }))), this._createdWorkers++, worker = new Worker($9564844aff6f68f3$var$workerURL), worker.addEventListener("message", (event)=>{
            this.complete(event.data), this.returnWorker(event.target), this.next();
        })), worker;
    }
    returnWorker(worker) {
        this.workerPool.push(worker);
    }
    complete(data) {
        data.error !== void 0 ? this.resolveHash[data.uuid].reject(data.error) : this.resolveHash[data.uuid].resolve(data.data), this.resolveHash[data.uuid] = null;
    }
    async _run(id, args) {
        await this._initWorkers();
        const promise = new Promise((resolve, reject)=>{
            this.queue.push({
                id: id,
                arguments: args,
                resolve: resolve,
                reject: reject
            });
        });
        return this.next(), promise;
    }
    next() {
        if (!this.queue.length) return;
        const worker = this.getWorker();
        if (!worker) return;
        const toDo = this.queue.pop(), id = toDo.id;
        this.resolveHash[$9564844aff6f68f3$var$UUID] = {
            resolve: toDo.resolve,
            reject: toDo.reject
        }, worker.postMessage({
            data: toDo.arguments,
            uuid: $9564844aff6f68f3$var$UUID++,
            id: id
        });
    }
}
const $9564844aff6f68f3$export$bcff6015853c67ce = new $9564844aff6f68f3$var$WorkerManagerClass();




function $7c128909ff22805e$export$37b981a8c575f415(base, loader, url) {
    base.resource.internal = !0;
    const texture = new (0, $14896914ad3ae15d$export$5431306cf43de24a)(base), unload = ()=>{
        delete loader.promiseCache[url], (0, $36f44157e8bf94de$export$94affb487e701bf2).has(url) && (0, $36f44157e8bf94de$export$94affb487e701bf2).remove(url);
    };
    return texture.baseTexture.once("destroyed", ()=>{
        url in loader.promiseCache && (console.warn("[Assets] A BaseTexture managed by Assets was destroyed instead of unloaded! Use Assets.unload() instead of destroying the BaseTexture."), unload());
    }), texture.once("destroyed", ()=>{
        base.destroyed || (console.warn("[Assets] A Texture managed by Assets was destroyed instead of unloaded! Use Assets.unload() instead of destroying the Texture."), unload());
    }), texture;
}


const $2352d9a22f096d70$var$validImageExtensions = [
    ".jpeg",
    ".jpg",
    ".png",
    ".webp",
    ".avif"
], $2352d9a22f096d70$var$validImageMIMEs = [
    "image/jpeg",
    "image/png",
    "image/webp",
    "image/avif"
];
async function $2352d9a22f096d70$export$c614e6247302006d(url) {
    const response = await (0, $2808efac47e52be0$export$a5a6e0b888b2c992).ADAPTER.fetch(url);
    if (!response.ok) throw new Error(`[loadImageBitmap] Failed to fetch ${url}: ${response.status} ${response.statusText}`);
    const imageBlob = await response.blob();
    return await createImageBitmap(imageBlob);
}
const $2352d9a22f096d70$export$897b113ee8307cd0 = {
    name: "loadTextures",
    extension: {
        type: (0, $c90155f6d7d8d8f6$export$4f037c6ec2da4eeb).LoadParser,
        priority: (0, $ed5d6a4467c2b40c$export$820ed6348c4f2750).High
    },
    config: {
        preferWorkers: !0,
        preferCreateImageBitmap: !0,
        crossOrigin: "anonymous"
    },
    test (url) {
        return (0, $b7a22d284615e514$export$7ff8b059fb914323)(url, $2352d9a22f096d70$var$validImageMIMEs) || (0, $09c9bb162e36b2d4$export$fd0180357b95b812)(url, $2352d9a22f096d70$var$validImageExtensions);
    },
    async load (url, asset, loader) {
        const useImageBitmap = globalThis.createImageBitmap && this.config.preferCreateImageBitmap;
        let src;
        useImageBitmap ? this.config.preferWorkers && await (0, $9564844aff6f68f3$export$bcff6015853c67ce).isImageBitmapSupported() ? src = await (0, $9564844aff6f68f3$export$bcff6015853c67ce).loadImageBitmap(url) : src = await $2352d9a22f096d70$export$c614e6247302006d(url) : src = await new Promise((resolve, reject)=>{
            const src2 = new Image();
            src2.crossOrigin = this.config.crossOrigin, src2.src = url, src2.complete ? resolve(src2) : (src2.onload = ()=>resolve(src2), src2.onerror = (e)=>reject(e));
        });
        const options = {
            ...asset.data
        };
        options.resolution ?? (options.resolution = (0, $db31fc3dfae4939b$exports).getResolutionOfUrl(url)), useImageBitmap && options.resourceOptions?.ownsImageBitmap === void 0 && (options.resourceOptions = {
            ...options.resourceOptions
        }, options.resourceOptions.ownsImageBitmap = !0);
        const base = new (0, $30c85657f0c625d5$export$d6306e508f184154)(src, options);
        return base.resource.src = url, (0, $7c128909ff22805e$export$37b981a8c575f415)(base, loader, url);
    },
    unload (texture) {
        texture.destroy(!0);
    }
};
(0, $c90155f6d7d8d8f6$export$cc3e2d3244e01b7f).add($2352d9a22f096d70$export$897b113ee8307cd0);



const $13e47f45322283cb$var$validSVGExtension = ".svg", $13e47f45322283cb$var$validSVGMIME = "image/svg+xml", $13e47f45322283cb$export$c32505ea942c7f01 = {
    extension: {
        type: (0, $c90155f6d7d8d8f6$export$4f037c6ec2da4eeb).LoadParser,
        priority: (0, $ed5d6a4467c2b40c$export$820ed6348c4f2750).High
    },
    name: "loadSVG",
    test (url) {
        return (0, $b7a22d284615e514$export$7ff8b059fb914323)(url, $13e47f45322283cb$var$validSVGMIME) || (0, $09c9bb162e36b2d4$export$fd0180357b95b812)(url, $13e47f45322283cb$var$validSVGExtension);
    },
    async testParse (data) {
        return (0, $5be094cb1fca983a$export$aeb8ac9a3d5d46a0).test(data);
    },
    async parse (asset, data, loader) {
        const src = new (0, $5be094cb1fca983a$export$aeb8ac9a3d5d46a0)(asset, data?.data?.resourceOptions);
        await src.load();
        const base = new (0, $30c85657f0c625d5$export$d6306e508f184154)(src, {
            resolution: (0, $db31fc3dfae4939b$exports).getResolutionOfUrl(asset),
            ...data?.data
        });
        return base.resource.src = data.src, (0, $7c128909ff22805e$export$37b981a8c575f415)(base, loader, data.src);
    },
    async load (url, _options) {
        return (await (0, $2808efac47e52be0$export$a5a6e0b888b2c992).ADAPTER.fetch(url)).text();
    },
    unload: (0, $2352d9a22f096d70$export$897b113ee8307cd0).unload
};
(0, $c90155f6d7d8d8f6$export$cc3e2d3244e01b7f).add($13e47f45322283cb$export$c32505ea942c7f01);








const $fd7e74957a12e349$var$validVideoExtensions = [
    ".mp4",
    ".m4v",
    ".webm",
    ".ogv"
], $fd7e74957a12e349$var$validVideoMIMEs = [
    "video/mp4",
    "video/webm",
    "video/ogg"
], $fd7e74957a12e349$export$d2b008984942555e = {
    name: "loadVideo",
    extension: {
        type: (0, $c90155f6d7d8d8f6$export$4f037c6ec2da4eeb).LoadParser,
        priority: (0, $ed5d6a4467c2b40c$export$820ed6348c4f2750).High
    },
    config: {
        defaultAutoPlay: !0
    },
    test (url) {
        return (0, $b7a22d284615e514$export$7ff8b059fb914323)(url, $fd7e74957a12e349$var$validVideoMIMEs) || (0, $09c9bb162e36b2d4$export$fd0180357b95b812)(url, $fd7e74957a12e349$var$validVideoExtensions);
    },
    async load (url, loadAsset, loader) {
        let texture;
        const blob = await (await (0, $2808efac47e52be0$export$a5a6e0b888b2c992).ADAPTER.fetch(url)).blob(), blobURL = URL.createObjectURL(blob);
        try {
            const options = {
                autoPlay: this.config.defaultAutoPlay,
                ...loadAsset?.data?.resourceOptions
            }, src = new (0, $8223d3e14a6b8675$export$f7dd53bb53e9c0d7)(blobURL, options);
            await src.load();
            const base = new (0, $30c85657f0c625d5$export$d6306e508f184154)(src, {
                alphaMode: await (0, $db31fc3dfae4939b$exports).detectVideoAlphaMode(),
                resolution: (0, $db31fc3dfae4939b$exports).getResolutionOfUrl(url),
                ...loadAsset?.data
            });
            base.resource.src = url, texture = (0, $7c128909ff22805e$export$37b981a8c575f415)(base, loader, url), texture.baseTexture.once("destroyed", ()=>{
                URL.revokeObjectURL(blobURL);
            });
        } catch (e) {
            throw URL.revokeObjectURL(blobURL), e;
        }
        return texture;
    },
    unload (texture) {
        texture.destroy(!0);
    }
};
(0, $c90155f6d7d8d8f6$export$cc3e2d3244e01b7f).add($fd7e74957a12e349$export$d2b008984942555e);













class $9ad8f239a5763478$export$8b4c839865b08288 {
    constructor(){
        this._defaultBundleIdentifierOptions = {
            connector: "-",
            createBundleAssetId: (bundleId, assetId)=>`${bundleId}${this._bundleIdConnector}${assetId}`,
            extractAssetIdFromBundle: (bundleId, assetBundleId)=>assetBundleId.replace(`${bundleId}${this._bundleIdConnector}`, "")
        }, this._bundleIdConnector = this._defaultBundleIdentifierOptions.connector, this._createBundleAssetId = this._defaultBundleIdentifierOptions.createBundleAssetId, this._extractAssetIdFromBundle = this._defaultBundleIdentifierOptions.extractAssetIdFromBundle, this._assetMap = {}, this._preferredOrder = [], this._parsers = [], this._resolverHash = {}, this._bundles = {};
    }
    /**
   * Override how the resolver deals with generating bundle ids.
   * must be called before any bundles are added
   * @param bundleIdentifier - the bundle identifier options
   */ setBundleIdentifier(bundleIdentifier) {
        if (this._bundleIdConnector = bundleIdentifier.connector ?? this._bundleIdConnector, this._createBundleAssetId = bundleIdentifier.createBundleAssetId ?? this._createBundleAssetId, this._extractAssetIdFromBundle = bundleIdentifier.extractAssetIdFromBundle ?? this._extractAssetIdFromBundle, this._extractAssetIdFromBundle("foo", this._createBundleAssetId("foo", "bar")) !== "bar") throw new Error("[Resolver] GenerateBundleAssetId are not working correctly");
    }
    /**
   * Let the resolver know which assets you prefer to use when resolving assets.
   * Multiple prefer user defined rules can be added.
   * @example
   * resolver.prefer({
   *     // first look for something with the correct format, and then then correct resolution
   *     priority: ['format', 'resolution'],
   *     params:{
   *         format:'webp', // prefer webp images
   *         resolution: 2, // prefer a resolution of 2
   *     }
   * })
   * resolver.add('foo', ['bar@2x.webp', 'bar@2x.png', 'bar.webp', 'bar.png']);
   * resolver.resolveUrl('foo') // => 'bar@2x.webp'
   * @param preferOrders - the prefer options
   */ prefer(...preferOrders) {
        preferOrders.forEach((prefer)=>{
            this._preferredOrder.push(prefer), prefer.priority || (prefer.priority = Object.keys(prefer.params));
        }), this._resolverHash = {};
    }
    /**
   * Set the base path to prepend to all urls when resolving
   * @example
   * resolver.basePath = 'https://home.com/';
   * resolver.add('foo', 'bar.ong');
   * resolver.resolveUrl('foo', 'bar.png'); // => 'https://home.com/bar.png'
   * @param basePath - the base path to use
   */ set basePath(basePath) {
        this._basePath = basePath;
    }
    get basePath() {
        return this._basePath;
    }
    /**
   * Set the root path for root-relative URLs. By default the `basePath`'s root is used. If no `basePath` is set, then the
   * default value for browsers is `window.location.origin`
   * @example
   * // Application hosted on https://home.com/some-path/index.html
   * resolver.basePath = 'https://home.com/some-path/';
   * resolver.rootPath = 'https://home.com/';
   * resolver.add('foo', '/bar.png');
   * resolver.resolveUrl('foo', '/bar.png'); // => 'https://home.com/bar.png'
   * @param rootPath - the root path to use
   */ set rootPath(rootPath) {
        this._rootPath = rootPath;
    }
    get rootPath() {
        return this._rootPath;
    }
    /**
   * All the active URL parsers that help the parser to extract information and create
   * an asset object-based on parsing the URL itself.
   *
   * Can be added using the extensions API
   * @example
   * resolver.add('foo', [
   *     {
   *         resolution: 2,
   *         format: 'png',
   *         src: 'image@2x.png',
   *     },
   *     {
   *         resolution:1,
   *         format:'png',
   *         src: 'image.png',
   *     },
   * ]);
   *
   * // With a url parser the information such as resolution and file format could extracted from the url itself:
   * extensions.add({
   *     extension: ExtensionType.ResolveParser,
   *     test: loadTextures.test, // test if url ends in an image
   *     parse: (value: string) =>
   *     ({
   *         resolution: parseFloat(settings.RETINA_PREFIX.exec(value)?.[1] ?? '1'),
   *         format: value.split('.').pop(),
   *         src: value,
   *     }),
   * });
   *
   * // Now resolution and format can be extracted from the url
   * resolver.add('foo', [
   *     'image@2x.png',
   *     'image.png',
   * ]);
   */ get parsers() {
        return this._parsers;
    }
    /** Used for testing, this resets the resolver to its initial state */ reset() {
        this.setBundleIdentifier(this._defaultBundleIdentifierOptions), this._assetMap = {}, this._preferredOrder = [], this._resolverHash = {}, this._rootPath = null, this._basePath = null, this._manifest = null, this._bundles = {}, this._defaultSearchParams = null;
    }
    /**
   * Sets the default URL search parameters for the URL resolver. The urls can be specified as a string or an object.
   * @param searchParams - the default url parameters to append when resolving urls
   */ setDefaultSearchParams(searchParams) {
        if (typeof searchParams == "string") this._defaultSearchParams = searchParams;
        else {
            const queryValues = searchParams;
            this._defaultSearchParams = Object.keys(queryValues).map((key)=>`${encodeURIComponent(key)}=${encodeURIComponent(queryValues[key])}`).join("&");
        }
    }
    /**
   * Returns the aliases for a given asset
   * @param asset - the asset to get the aliases for
   */ getAlias(asset) {
        const { alias: alias, name: name, src: src, srcs: srcs } = asset;
        return (0, $7dc81a51635033d6$export$b01be8e180bf3d9b)(alias || name || src || srcs, (value)=>typeof value == "string" ? value : Array.isArray(value) ? value.map((v)=>v?.src ?? v?.srcs ?? v) : value?.src || value?.srcs ? value.src ?? value.srcs : value, !0);
    }
    /**
   * Add a manifest to the asset resolver. This is a nice way to add all the asset information in one go.
   * generally a manifest would be built using a tool.
   * @param manifest - the manifest to add to the resolver
   */ addManifest(manifest) {
        this._manifest && console.warn("[Resolver] Manifest already exists, this will be overwritten"), this._manifest = manifest, manifest.bundles.forEach((bundle)=>{
            this.addBundle(bundle.name, bundle.assets);
        });
    }
    /**
   * This adds a bundle of assets in one go so that you can resolve them as a group.
   * For example you could add a bundle for each screen in you pixi app
   * @example
   * resolver.addBundle('animals', {
   *     bunny: 'bunny.png',
   *     chicken: 'chicken.png',
   *     thumper: 'thumper.png',
   * });
   *
   * const resolvedAssets = await resolver.resolveBundle('animals');
   * @param bundleId - The id of the bundle to add
   * @param assets - A record of the asset or assets that will be chosen from when loading via the specified key
   */ addBundle(bundleId, assets) {
        const assetNames = [];
        Array.isArray(assets) ? assets.forEach((asset)=>{
            const srcs = asset.src ?? asset.srcs, aliases = asset.alias ?? asset.name;
            let ids;
            if (typeof aliases == "string") {
                const bundleAssetId = this._createBundleAssetId(bundleId, aliases);
                assetNames.push(bundleAssetId), ids = [
                    aliases,
                    bundleAssetId
                ];
            } else {
                const bundleIds = aliases.map((name)=>this._createBundleAssetId(bundleId, name));
                assetNames.push(...bundleIds), ids = [
                    ...aliases,
                    ...bundleIds
                ];
            }
            this.add({
                ...asset,
                alias: ids,
                src: srcs
            });
        }) : Object.keys(assets).forEach((key)=>{
            const aliases = [
                key,
                this._createBundleAssetId(bundleId, key)
            ];
            if (typeof assets[key] == "string") this.add({
                alias: aliases,
                src: assets[key]
            });
            else if (Array.isArray(assets[key])) this.add({
                alias: aliases,
                src: assets[key]
            });
            else {
                const asset = assets[key], assetSrc = asset.src ?? asset.srcs;
                this.add({
                    ...asset,
                    alias: aliases,
                    src: Array.isArray(assetSrc) ? assetSrc : [
                        assetSrc
                    ]
                });
            }
            assetNames.push(...aliases);
        }), this._bundles[bundleId] = assetNames;
    }
    /**
   * Tells the resolver what keys are associated with witch asset.
   * The most important thing the resolver does
   * @example
   * // Single key, single asset:
   * resolver.add({alias: 'foo', src: 'bar.png');
   * resolver.resolveUrl('foo') // => 'bar.png'
   *
   * // Multiple keys, single asset:
   * resolver.add({alias: ['foo', 'boo'], src: 'bar.png'});
   * resolver.resolveUrl('foo') // => 'bar.png'
   * resolver.resolveUrl('boo') // => 'bar.png'
   *
   * // Multiple keys, multiple assets:
   * resolver.add({alias: ['foo', 'boo'], src: ['bar.png', 'bar.webp']});
   * resolver.resolveUrl('foo') // => 'bar.png'
   *
   * // Add custom data attached to the resolver
   * Resolver.add({
   *     alias: 'bunnyBooBooSmooth',
   *     src: 'bunny{png,webp}',
   *     data: { scaleMode:SCALE_MODES.NEAREST }, // Base texture options
   * });
   *
   * resolver.resolve('bunnyBooBooSmooth') // => { src: 'bunny.png', data: { scaleMode: SCALE_MODES.NEAREST } }
   * @param aliases - the key or keys that you will reference when loading this asset
   * @param srcs - the asset or assets that will be chosen from when loading via the specified key
   * @param data - asset-specific data that will be passed to the loaders
   * - Useful if you want to initiate loaded objects with specific data
   * @param format - the format of the asset
   * @param loadParser - the name of the load parser to use
   */ add(aliases, srcs, data, format, loadParser) {
        const assets = [];
        typeof aliases == "string" || Array.isArray(aliases) && typeof aliases[0] == "string" ? ((0, $db31fc3dfae4939b$exports).deprecation("7.2.0", `Assets.add now uses an object instead of individual parameters.
Please use Assets.add({ alias, src, data, format, loadParser }) instead.`), assets.push({
            alias: aliases,
            src: srcs,
            data: data,
            format: format,
            loadParser: loadParser
        })) : Array.isArray(aliases) ? assets.push(...aliases) : assets.push(aliases);
        let keyCheck;
        keyCheck = (key)=>{
            this.hasKey(key) && console.warn(`[Resolver] already has key: ${key} overwriting`);
        }, (0, $7dc81a51635033d6$export$b01be8e180bf3d9b)(assets).forEach((asset)=>{
            const { src: src, srcs: srcs2 } = asset;
            let { data: data2, format: format2, loadParser: loadParser2 } = asset;
            const srcsToUse = (0, $7dc81a51635033d6$export$b01be8e180bf3d9b)(src || srcs2).map((src2)=>typeof src2 == "string" ? (0, $e4c9f40c3444b3b9$export$738117acc6638004)(src2) : Array.isArray(src2) ? src2 : [
                    src2
                ]), aliasesToUse = this.getAlias(asset);
            Array.isArray(aliasesToUse) ? aliasesToUse.forEach(keyCheck) : keyCheck(aliasesToUse);
            const resolvedAssets = [];
            srcsToUse.forEach((srcs3)=>{
                srcs3.forEach((src2)=>{
                    let formattedAsset = {};
                    if (typeof src2 != "object") {
                        formattedAsset.src = src2;
                        for(let i = 0; i < this._parsers.length; i++){
                            const parser = this._parsers[i];
                            if (parser.test(src2)) {
                                formattedAsset = parser.parse(src2);
                                break;
                            }
                        }
                    } else data2 = src2.data ?? data2, format2 = src2.format ?? format2, loadParser2 = src2.loadParser ?? loadParser2, formattedAsset = {
                        ...formattedAsset,
                        ...src2
                    };
                    if (!aliasesToUse) throw new Error(`[Resolver] alias is undefined for this asset: ${formattedAsset.src}`);
                    formattedAsset = this.buildResolvedAsset(formattedAsset, {
                        aliases: aliasesToUse,
                        data: data2,
                        format: format2,
                        loadParser: loadParser2
                    }), resolvedAssets.push(formattedAsset);
                });
            }), aliasesToUse.forEach((alias)=>{
                this._assetMap[alias] = resolvedAssets;
            });
        });
    }
    // TODO: this needs an overload like load did in Assets
    /**
   * If the resolver has had a manifest set via setManifest, this will return the assets urls for
   * a given bundleId or bundleIds.
   * @example
   * // Manifest Example
   * const manifest = {
   *     bundles: [
   *         {
   *             name: 'load-screen',
   *             assets: [
   *                 {
   *                     name: 'background',
   *                     srcs: 'sunset.png',
   *                 },
   *                 {
   *                     name: 'bar',
   *                     srcs: 'load-bar.{png,webp}',
   *                 },
   *             ],
   *         },
   *         {
   *             name: 'game-screen',
   *             assets: [
   *                 {
   *                     name: 'character',
   *                     srcs: 'robot.png',
   *                 },
   *                 {
   *                     name: 'enemy',
   *                     srcs: 'bad-guy.png',
   *                 },
   *             ],
   *         },
   *     ]
   * };
   *
   * resolver.setManifest(manifest);
   * const resolved = resolver.resolveBundle('load-screen');
   * @param bundleIds - The bundle ids to resolve
   * @returns All the bundles assets or a hash of assets for each bundle specified
   */ resolveBundle(bundleIds) {
        const singleAsset = (0, $a6123fb41c54da70$export$16a80d27953452d4)(bundleIds);
        bundleIds = (0, $7dc81a51635033d6$export$b01be8e180bf3d9b)(bundleIds);
        const out = {};
        return bundleIds.forEach((bundleId)=>{
            const assetNames = this._bundles[bundleId];
            if (assetNames) {
                const results = this.resolve(assetNames), assets = {};
                for(const key in results){
                    const asset = results[key];
                    assets[this._extractAssetIdFromBundle(bundleId, key)] = asset;
                }
                out[bundleId] = assets;
            }
        }), singleAsset ? out[bundleIds[0]] : out;
    }
    /**
   * Does exactly what resolve does, but returns just the URL rather than the whole asset object
   * @param key - The key or keys to resolve
   * @returns - The URLs associated with the key(s)
   */ resolveUrl(key) {
        const result = this.resolve(key);
        if (typeof key != "string") {
            const out = {};
            for(const i in result)out[i] = result[i].src;
            return out;
        }
        return result.src;
    }
    resolve(keys) {
        const singleAsset = (0, $a6123fb41c54da70$export$16a80d27953452d4)(keys);
        keys = (0, $7dc81a51635033d6$export$b01be8e180bf3d9b)(keys);
        const result = {};
        return keys.forEach((key)=>{
            if (!this._resolverHash[key]) {
                if (this._assetMap[key]) {
                    let assets = this._assetMap[key];
                    const bestAsset = assets[0], preferredOrder = this._getPreferredOrder(assets);
                    preferredOrder?.priority.forEach((priorityKey)=>{
                        preferredOrder.params[priorityKey].forEach((value)=>{
                            const filteredAssets = assets.filter((asset)=>asset[priorityKey] ? asset[priorityKey] === value : !1);
                            filteredAssets.length && (assets = filteredAssets);
                        });
                    }), this._resolverHash[key] = assets[0] ?? bestAsset;
                } else this._resolverHash[key] = this.buildResolvedAsset({
                    alias: [
                        key
                    ],
                    src: key
                }, {});
            }
            result[key] = this._resolverHash[key];
        }), singleAsset ? result[keys[0]] : result;
    }
    /**
   * Checks if an asset with a given key exists in the resolver
   * @param key - The key of the asset
   */ hasKey(key) {
        return !!this._assetMap[key];
    }
    /**
   * Checks if a bundle with the given key exists in the resolver
   * @param key - The key of the bundle
   */ hasBundle(key) {
        return !!this._bundles[key];
    }
    /**
   * Internal function for figuring out what prefer criteria an asset should use.
   * @param assets
   */ _getPreferredOrder(assets) {
        for(let i = 0; i < assets.length; i++){
            const asset = assets[0], preferred = this._preferredOrder.find((preference)=>preference.params.format.includes(asset.format));
            if (preferred) return preferred;
        }
        return this._preferredOrder[0];
    }
    /**
   * Appends the default url parameters to the url
   * @param url - The url to append the default parameters to
   * @returns - The url with the default parameters appended
   */ _appendDefaultSearchParams(url) {
        if (!this._defaultSearchParams) return url;
        const paramConnector = /\?/.test(url) ? "&" : "?";
        return `${url}${paramConnector}${this._defaultSearchParams}`;
    }
    buildResolvedAsset(formattedAsset, data) {
        const { aliases: aliases, data: assetData, loadParser: loadParser, format: format } = data;
        return (this._basePath || this._rootPath) && (formattedAsset.src = (0, $db31fc3dfae4939b$exports).path.toAbsolute(formattedAsset.src, this._basePath, this._rootPath)), formattedAsset.alias = aliases ?? formattedAsset.alias ?? [
            formattedAsset.src
        ], formattedAsset.src = this._appendDefaultSearchParams(formattedAsset.src), formattedAsset.data = {
            ...assetData || {},
            ...formattedAsset.data
        }, formattedAsset.loadParser = loadParser ?? formattedAsset.loadParser, formattedAsset.format = format ?? formattedAsset.src.split(".").pop(), formattedAsset.srcs = formattedAsset.src, formattedAsset.name = formattedAsset.alias, formattedAsset;
    }
}





class $f9c1af74ba91db41$export$137d4dd907afac85 {
    constructor(){
        this._detections = [], this._initialized = !1, this.resolver = new (0, $9ad8f239a5763478$export$8b4c839865b08288)(), this.loader = new (0, $cd5a64b8c87ab093$export$3b0d6d7590275603)(), this.cache = (0, $36f44157e8bf94de$export$94affb487e701bf2), this._backgroundLoader = new (0, $e71af446771112c8$export$1949379a83b843d5)(this.loader), this._backgroundLoader.active = !0, this.reset();
    }
    /**
   * Best practice is to call this function before any loading commences
   * Initiating is the best time to add any customization to the way things are loaded.
   *
   * you do not need to call this for the Asset class to work, only if you want to set any initial properties
   * @param options - options to initialize the Asset manager with
   */ async init(options = {}) {
        if (this._initialized) {
            console.warn("[Assets]AssetManager already initialized, did you load before calling this Asset.init()?");
            return;
        }
        if (this._initialized = !0, options.defaultSearchParams && this.resolver.setDefaultSearchParams(options.defaultSearchParams), options.basePath && (this.resolver.basePath = options.basePath), options.bundleIdentifier && this.resolver.setBundleIdentifier(options.bundleIdentifier), options.manifest) {
            let manifest = options.manifest;
            typeof manifest == "string" && (manifest = await this.load(manifest)), this.resolver.addManifest(manifest);
        }
        const resolutionPref = options.texturePreference?.resolution ?? 1, resolution = typeof resolutionPref == "number" ? [
            resolutionPref
        ] : resolutionPref, formats = await this._detectFormats({
            preferredFormats: options.texturePreference?.format,
            skipDetections: options.skipDetections,
            detections: this._detections
        });
        this.resolver.prefer({
            params: {
                format: formats,
                resolution: resolution
            }
        }), options.preferences && this.setPreferences(options.preferences);
    }
    /**
   * Allows you to specify how to resolve any assets load requests.
   * There are a few ways to add things here as shown below:
   * @example
   * import { Assets } from 'pixi.js';
   *
   * // Simple
   * Assets.add({alias: 'bunnyBooBoo', src: 'bunny.png'});
   * const bunny = await Assets.load('bunnyBooBoo');
   *
   * // Multiple keys:
   * Assets.add({alias: ['burger', 'chicken'], src: 'bunny.png'});
   *
   * const bunny = await Assets.load('burger');
   * const bunny2 = await Assets.load('chicken');
   *
   * // passing options to to the object
   * Assets.add({
   *     alias: 'bunnyBooBooSmooth',
   *     src: 'bunny{png,webp}',
   *     data: { scaleMode: SCALE_MODES.NEAREST }, // Base texture options
   * });
   *
   * // Multiple assets
   *
   * // The following all do the same thing:
   *
   * Assets.add({alias: 'bunnyBooBoo', src: 'bunny{png,webp}'});
   *
   * Assets.add({
   *     alias: 'bunnyBooBoo',
   *     src: [
   *         'bunny.png',
   *         'bunny.webp',
   *    ],
   * });
   *
   * const bunny = await Assets.load('bunnyBooBoo'); // Will try to load WebP if available
   * @param aliases - the key or keys that you will reference when loading this asset
   * @param srcs - the asset or assets that will be chosen from when loading via the specified key
   * @param data - asset-specific data that will be passed to the loaders
   * - Useful if you want to initiate loaded objects with specific data
   * @param format - the format of the asset
   * @param loadParser - the name of the load parser to use
   */ add(aliases, srcs, data, format, loadParser) {
        this.resolver.add(aliases, srcs, data, format, loadParser);
    }
    async load(urls, onProgress) {
        this._initialized || await this.init();
        const singleAsset = (0, $a6123fb41c54da70$export$16a80d27953452d4)(urls), urlArray = (0, $7dc81a51635033d6$export$b01be8e180bf3d9b)(urls).map((url)=>{
            if (typeof url != "string") {
                const aliases = this.resolver.getAlias(url);
                return aliases.some((alias)=>!this.resolver.hasKey(alias)) && this.add(url), Array.isArray(aliases) ? aliases[0] : aliases;
            }
            return this.resolver.hasKey(url) || this.add({
                alias: url,
                src: url
            }), url;
        }), resolveResults = this.resolver.resolve(urlArray), out = await this._mapLoadToResolve(resolveResults, onProgress);
        return singleAsset ? out[urlArray[0]] : out;
    }
    /**
   * This adds a bundle of assets in one go so that you can load them as a group.
   * For example you could add a bundle for each screen in you pixi app
   * @example
   * import { Assets } from 'pixi.js';
   *
   * Assets.addBundle('animals', {
   *     bunny: 'bunny.png',
   *     chicken: 'chicken.png',
   *     thumper: 'thumper.png',
   * });
   *
   * const assets = await Assets.loadBundle('animals');
   * @param bundleId - the id of the bundle to add
   * @param assets - a record of the asset or assets that will be chosen from when loading via the specified key
   */ addBundle(bundleId, assets) {
        this.resolver.addBundle(bundleId, assets);
    }
    /**
   * Bundles are a way to load multiple assets at once.
   * If a manifest has been provided to the init function then you can load a bundle, or bundles.
   * you can also add bundles via `addBundle`
   * @example
   * import { Assets } from 'pixi.js';
   *
   * // Manifest Example
   * const manifest = {
   *     bundles: [
   *         {
   *             name: 'load-screen',
   *             assets: [
   *                 {
   *                     name: 'background',
   *                     srcs: 'sunset.png',
   *                 },
   *                 {
   *                     name: 'bar',
   *                     srcs: 'load-bar.{png,webp}',
   *                 },
   *             ],
   *         },
   *         {
   *             name: 'game-screen',
   *             assets: [
   *                 {
   *                     name: 'character',
   *                     srcs: 'robot.png',
   *                 },
   *                 {
   *                     name: 'enemy',
   *                     srcs: 'bad-guy.png',
   *                 },
   *             ],
   *         },
   *     ]
   * };
   *
   * await Asset.init({ manifest });
   *
   * // Load a bundle...
   * loadScreenAssets = await Assets.loadBundle('load-screen');
   * // Load another bundle...
   * gameScreenAssets = await Assets.loadBundle('game-screen');
   * @param bundleIds - the bundle id or ids to load
   * @param onProgress - Optional function that is called when progress on asset loading is made.
   * The function is passed a single parameter, `progress`, which represents the percentage (0.0 - 1.0)
   * of the assets loaded. Do not use this function to detect when assets are complete and available,
   * instead use the Promise returned by this function.
   * @returns all the bundles assets or a hash of assets for each bundle specified
   */ async loadBundle(bundleIds, onProgress) {
        this._initialized || await this.init();
        let singleAsset = !1;
        typeof bundleIds == "string" && (singleAsset = !0, bundleIds = [
            bundleIds
        ]);
        const resolveResults = this.resolver.resolveBundle(bundleIds), out = {}, keys = Object.keys(resolveResults);
        let count = 0, total = 0;
        const _onProgress = ()=>{
            onProgress?.(++count / total);
        }, promises = keys.map((bundleId)=>{
            const resolveResult = resolveResults[bundleId];
            return total += Object.keys(resolveResult).length, this._mapLoadToResolve(resolveResult, _onProgress).then((resolveResult2)=>{
                out[bundleId] = resolveResult2;
            });
        });
        return await Promise.all(promises), singleAsset ? out[bundleIds[0]] : out;
    }
    /**
   * Initiate a background load of some assets. It will passively begin to load these assets in the background.
   * So when you actually come to loading them you will get a promise that resolves to the loaded assets immediately
   *
   * An example of this might be that you would background load game assets after your inital load.
   * then when you got to actually load your game screen assets when a player goes to the game - the loading
   * would already have stared or may even be complete, saving you having to show an interim load bar.
   * @example
   * import { Assets } from 'pixi.js';
   *
   * Assets.backgroundLoad('bunny.png');
   *
   * // later on in your app...
   * await Assets.loadBundle('bunny.png'); // Will resolve quicker as loading may have completed!
   * @param urls - the url / urls you want to background load
   */ async backgroundLoad(urls) {
        this._initialized || await this.init(), typeof urls == "string" && (urls = [
            urls
        ]);
        const resolveResults = this.resolver.resolve(urls);
        this._backgroundLoader.add(Object.values(resolveResults));
    }
    /**
   * Initiate a background of a bundle, works exactly like backgroundLoad but for bundles.
   * this can only be used if the loader has been initiated with a manifest
   * @example
   * import { Assets } from 'pixi.js';
   *
   * await Assets.init({
   *     manifest: {
   *         bundles: [
   *             {
   *                 name: 'load-screen',
   *                 assets: [...],
   *             },
   *             ...
   *         ],
   *     },
   * });
   *
   * Assets.backgroundLoadBundle('load-screen');
   *
   * // Later on in your app...
   * await Assets.loadBundle('load-screen'); // Will resolve quicker as loading may have completed!
   * @param bundleIds - the bundleId / bundleIds you want to background load
   */ async backgroundLoadBundle(bundleIds) {
        this._initialized || await this.init(), typeof bundleIds == "string" && (bundleIds = [
            bundleIds
        ]);
        const resolveResults = this.resolver.resolveBundle(bundleIds);
        Object.values(resolveResults).forEach((resolveResult)=>{
            this._backgroundLoader.add(Object.values(resolveResult));
        });
    }
    /**
   * Only intended for development purposes.
   * This will wipe the resolver and caches.
   * You will need to reinitialize the Asset
   */ reset() {
        this.resolver.reset(), this.loader.reset(), this.cache.reset(), this._initialized = !1;
    }
    get(keys) {
        if (typeof keys == "string") return (0, $36f44157e8bf94de$export$94affb487e701bf2).get(keys);
        const assets = {};
        for(let i = 0; i < keys.length; i++)assets[i] = (0, $36f44157e8bf94de$export$94affb487e701bf2).get(keys[i]);
        return assets;
    }
    /**
   * helper function to map resolved assets back to loaded assets
   * @param resolveResults - the resolve results from the resolver
   * @param onProgress - the progress callback
   */ async _mapLoadToResolve(resolveResults, onProgress) {
        const resolveArray = Object.values(resolveResults), resolveKeys = Object.keys(resolveResults);
        this._backgroundLoader.active = !1;
        const loadedAssets = await this.loader.load(resolveArray, onProgress);
        this._backgroundLoader.active = !0;
        const out = {};
        return resolveArray.forEach((resolveResult, i)=>{
            const asset = loadedAssets[resolveResult.src], keys = [
                resolveResult.src
            ];
            resolveResult.alias && keys.push(...resolveResult.alias), out[resolveKeys[i]] = asset, (0, $36f44157e8bf94de$export$94affb487e701bf2).set(keys, asset);
        }), out;
    }
    /**
   * Unload an asset or assets. As the Assets class is responsible for creating the assets via the `load` function
   * this will make sure to destroy any assets and release them from memory.
   * Once unloaded, you will need to load the asset again.
   *
   * Use this to help manage assets if you find that you have a large app and you want to free up memory.
   *
   * - it's up to you as the developer to make sure that textures are not actively being used when you unload them,
   * Pixi won't break but you will end up with missing assets. Not a good look for the user!
   * @example
   * import { Assets } from 'pixi.js';
   *
   * // Load a URL:
   * const myImageTexture = await Assets.load('http://some.url.com/image.png'); // => returns a texture
   *
   * await Assets.unload('http://some.url.com/image.png')
   *
   * // myImageTexture will be destroyed now.
   *
   * // Unload multiple assets:
   * const textures = await Assets.unload(['thumper', 'chicko']);
   * @param urls - the urls to unload
   */ async unload(urls) {
        this._initialized || await this.init();
        const urlArray = (0, $7dc81a51635033d6$export$b01be8e180bf3d9b)(urls).map((url)=>typeof url != "string" ? url.src : url), resolveResults = this.resolver.resolve(urlArray);
        await this._unloadFromResolved(resolveResults);
    }
    /**
   * Bundles are a way to manage multiple assets at once.
   * this will unload all files in a bundle.
   *
   * once a bundle has been unloaded, you need to load it again to have access to the assets.
   * @example
   * import { Assets } from 'pixi.js';
   *
   * Assets.addBundle({
   *     'thumper': 'http://some.url.com/thumper.png',
   * })
   *
   * const assets = await Assets.loadBundle('thumper');
   *
   * // Now to unload...
   *
   * await Assets.unloadBundle('thumper');
   *
   * // All assets in the assets object will now have been destroyed and purged from the cache
   * @param bundleIds - the bundle id or ids to unload
   */ async unloadBundle(bundleIds) {
        this._initialized || await this.init(), bundleIds = (0, $7dc81a51635033d6$export$b01be8e180bf3d9b)(bundleIds);
        const resolveResults = this.resolver.resolveBundle(bundleIds), promises = Object.keys(resolveResults).map((bundleId)=>this._unloadFromResolved(resolveResults[bundleId]));
        await Promise.all(promises);
    }
    async _unloadFromResolved(resolveResult) {
        const resolveArray = Object.values(resolveResult);
        resolveArray.forEach((resolveResult2)=>{
            (0, $36f44157e8bf94de$export$94affb487e701bf2).remove(resolveResult2.src);
        }), await this.loader.unload(resolveArray);
    }
    /**
   * Detects the supported formats for the browser, and returns an array of supported formats, respecting
   * the users preferred formats order.
   * @param options - the options to use when detecting formats
   * @param options.preferredFormats - the preferred formats to use
   * @param options.skipDetections - if we should skip the detections altogether
   * @param options.detections - the detections to use
   * @returns - the detected formats
   */ async _detectFormats(options) {
        let formats = [];
        options.preferredFormats && (formats = Array.isArray(options.preferredFormats) ? options.preferredFormats : [
            options.preferredFormats
        ]);
        for (const detection of options.detections)options.skipDetections || await detection.test() ? formats = await detection.add(formats) : options.skipDetections || (formats = await detection.remove(formats));
        return formats = formats.filter((format, index)=>formats.indexOf(format) === index), formats;
    }
    /** All the detection parsers currently added to the Assets class. */ get detections() {
        return this._detections;
    }
    /**
   * @deprecated since 7.2.0
   * @see {@link Assets.setPreferences}
   */ get preferWorkers() {
        return (0, $2352d9a22f096d70$export$897b113ee8307cd0).config.preferWorkers;
    }
    set preferWorkers(value) {
        (0, $db31fc3dfae4939b$exports).deprecation("7.2.0", "Assets.prefersWorkers is deprecated, use Assets.setPreferences({ preferWorkers: true }) instead."), this.setPreferences({
            preferWorkers: value
        });
    }
    /**
   * General setter for preferences. This is a helper function to set preferences on all parsers.
   * @param preferences - the preferences to set
   */ setPreferences(preferences) {
        this.loader.parsers.forEach((parser)=>{
            parser.config && Object.keys(parser.config).filter((key)=>key in preferences).forEach((key)=>{
                parser.config[key] = preferences[key];
            });
        });
    }
}
const $f9c1af74ba91db41$export$c8eca95e306f7116 = new $f9c1af74ba91db41$export$137d4dd907afac85();
(0, $c90155f6d7d8d8f6$export$cc3e2d3244e01b7f).handleByList((0, $c90155f6d7d8d8f6$export$4f037c6ec2da4eeb).LoadParser, $f9c1af74ba91db41$export$c8eca95e306f7116.loader.parsers).handleByList((0, $c90155f6d7d8d8f6$export$4f037c6ec2da4eeb).ResolveParser, $f9c1af74ba91db41$export$c8eca95e306f7116.resolver.parsers).handleByList((0, $c90155f6d7d8d8f6$export$4f037c6ec2da4eeb).CacheParser, $f9c1af74ba91db41$export$c8eca95e306f7116.cache.parsers).handleByList((0, $c90155f6d7d8d8f6$export$4f037c6ec2da4eeb).DetectionParser, $f9c1af74ba91db41$export$c8eca95e306f7116.detections);






const $db2dc70645bea1a7$export$407b4625a915919d = {
    extension: (0, $c90155f6d7d8d8f6$export$4f037c6ec2da4eeb).CacheParser,
    test: (asset)=>Array.isArray(asset) && asset.every((t)=>t instanceof (0, $14896914ad3ae15d$export$5431306cf43de24a)),
    getCacheableAssets: (keys, asset)=>{
        const out = {};
        return keys.forEach((key)=>{
            asset.forEach((item, i)=>{
                out[key + (i === 0 ? "" : i + 1)] = item;
            });
        }), out;
    }
};
(0, $c90155f6d7d8d8f6$export$cc3e2d3244e01b7f).add($db2dc70645bea1a7$export$407b4625a915919d);







const $04b54256e0a587de$export$a60d2d4a3c570783 = {
    extension: {
        type: (0, $c90155f6d7d8d8f6$export$4f037c6ec2da4eeb).DetectionParser,
        priority: 1
    },
    test: async ()=>{
        const avifData = "data:image/avif;base64,AAAAIGZ0eXBhdmlmAAAAAGF2aWZtaWYxbWlhZk1BMUIAAADybWV0YQAAAAAAAAAoaGRscgAAAAAAAAAAcGljdAAAAAAAAAAAAAAAAGxpYmF2aWYAAAAADnBpdG0AAAAAAAEAAAAeaWxvYwAAAABEAAABAAEAAAABAAABGgAAAB0AAAAoaWluZgAAAAAAAQAAABppbmZlAgAAAAABAABhdjAxQ29sb3IAAAAAamlwcnAAAABLaXBjbwAAABRpc3BlAAAAAAAAAAIAAAACAAAAEHBpeGkAAAAAAwgICAAAAAxhdjFDgQ0MAAAAABNjb2xybmNseAACAAIAAYAAAAAXaXBtYQAAAAAAAAABAAEEAQKDBAAAACVtZGF0EgAKCBgANogQEAwgMg8f8D///8WfhwB8+ErK42A=";
        return new Promise((resolve)=>{
            const avif = new Image();
            avif.onload = ()=>{
                resolve(!0);
            }, avif.onerror = ()=>{
                resolve(!1);
            }, avif.src = avifData;
        });
    },
    add: async (formats)=>[
            ...formats,
            "avif"
        ],
    remove: async (formats)=>formats.filter((f)=>f !== "avif")
};
(0, $c90155f6d7d8d8f6$export$cc3e2d3244e01b7f).add($04b54256e0a587de$export$a60d2d4a3c570783);



const $07535e2d6ce602a4$export$d19529a9ed9823d4 = {
    extension: {
        type: (0, $c90155f6d7d8d8f6$export$4f037c6ec2da4eeb).DetectionParser,
        priority: 0
    },
    test: async ()=>{
        const webpData = "data:image/webp;base64,UklGRh4AAABXRUJQVlA4TBEAAAAvAAAAAAfQ//73v/+BiOh/AAA=";
        return new Promise((resolve)=>{
            const webp = new Image();
            webp.onload = ()=>{
                resolve(!0);
            }, webp.onerror = ()=>{
                resolve(!1);
            }, webp.src = webpData;
        });
    },
    add: async (formats)=>[
            ...formats,
            "webp"
        ],
    remove: async (formats)=>formats.filter((f)=>f !== "webp")
};
(0, $c90155f6d7d8d8f6$export$cc3e2d3244e01b7f).add($07535e2d6ce602a4$export$d19529a9ed9823d4);



const $a6906a5f602387f5$var$imageFormats = [
    "png",
    "jpg",
    "jpeg"
], $a6906a5f602387f5$export$b106d7c2de3b4d89 = {
    extension: {
        type: (0, $c90155f6d7d8d8f6$export$4f037c6ec2da4eeb).DetectionParser,
        priority: -1
    },
    test: ()=>Promise.resolve(!0),
    add: async (formats)=>[
            ...formats,
            ...$a6906a5f602387f5$var$imageFormats
        ],
    remove: async (formats)=>formats.filter((f)=>!$a6906a5f602387f5$var$imageFormats.includes(f))
};
(0, $c90155f6d7d8d8f6$export$cc3e2d3244e01b7f).add($a6906a5f602387f5$export$b106d7c2de3b4d89);



const $8aa9fdfb0f11d548$var$inWorker = "WorkerGlobalScope" in globalThis && globalThis instanceof globalThis.WorkerGlobalScope;
function $8aa9fdfb0f11d548$export$7a571c147b03abb1(mimeType) {
    return $8aa9fdfb0f11d548$var$inWorker ? !1 : document.createElement("video").canPlayType(mimeType) !== "";
}


const $013605652574b847$export$a041d698a1896657 = {
    extension: {
        type: (0, $c90155f6d7d8d8f6$export$4f037c6ec2da4eeb).DetectionParser,
        priority: 0
    },
    test: async ()=>(0, $8aa9fdfb0f11d548$export$7a571c147b03abb1)("video/webm"),
    add: async (formats)=>[
            ...formats,
            "webm"
        ],
    remove: async (formats)=>formats.filter((f)=>f !== "webm")
};
(0, $c90155f6d7d8d8f6$export$cc3e2d3244e01b7f).add($013605652574b847$export$a041d698a1896657);




const $4d541d8e1a6d93fa$export$7726d83fee274e25 = {
    extension: {
        type: (0, $c90155f6d7d8d8f6$export$4f037c6ec2da4eeb).DetectionParser,
        priority: 0
    },
    test: async ()=>(0, $8aa9fdfb0f11d548$export$7a571c147b03abb1)("video/mp4"),
    add: async (formats)=>[
            ...formats,
            "mp4",
            "m4v"
        ],
    remove: async (formats)=>formats.filter((f)=>f !== "mp4" && f !== "m4v")
};
(0, $c90155f6d7d8d8f6$export$cc3e2d3244e01b7f).add($4d541d8e1a6d93fa$export$7726d83fee274e25);




const $67ca5d99a76067f0$export$5a1da481121f806a = {
    extension: {
        type: (0, $c90155f6d7d8d8f6$export$4f037c6ec2da4eeb).DetectionParser,
        priority: 0
    },
    test: async ()=>(0, $8aa9fdfb0f11d548$export$7a571c147b03abb1)("video/ogg"),
    add: async (formats)=>[
            ...formats,
            "ogv"
        ],
    remove: async (formats)=>formats.filter((f)=>f !== "ogv")
};
(0, $c90155f6d7d8d8f6$export$cc3e2d3244e01b7f).add($67ca5d99a76067f0$export$5a1da481121f806a);












const $966f6b766483e963$export$cc356fa83de02bea = {
    extension: (0, $c90155f6d7d8d8f6$export$4f037c6ec2da4eeb).ResolveParser,
    test: (0, $2352d9a22f096d70$export$897b113ee8307cd0).test,
    parse: (value)=>({
            resolution: parseFloat((0, $2808efac47e52be0$export$a5a6e0b888b2c992).RETINA_PREFIX.exec(value)?.[1] ?? "1"),
            format: value.split(".").pop(),
            src: value
        })
};
(0, $c90155f6d7d8d8f6$export$cc3e2d3244e01b7f).add($966f6b766483e963$export$cc356fa83de02bea);







































const $35ee8f4e5726aa8b$var$getAlias = (asset)=>{
    const url = asset.src;
    return asset?.alias?.[0] ?? (0, $db31fc3dfae4939b$exports).path.basename(url, (0, $db31fc3dfae4939b$exports).path.extname(url));
};
const $35ee8f4e5726aa8b$export$ac5ef27803a8e50 = {
    extension: (0, $c90155f6d7d8d8f6$export$4f037c6ec2da4eeb).Asset,
    detection: {
        test: async ()=>true,
        add: async (formats)=>[
                ...formats,
                ...(0, $f7551ed0f4e817c1$export$cc3e2d3244e01b7f).filter((ext)=>(0, $f7551ed0f4e817c1$export$5f747a46dc0eb6ee)[ext])
            ],
        remove: async (formats)=>formats.filter((ext)=>formats.includes(ext))
    },
    loader: {
        extension: {
            type: [
                (0, $c90155f6d7d8d8f6$export$4f037c6ec2da4eeb).LoadParser
            ],
            priority: (0, $ed5d6a4467c2b40c$export$820ed6348c4f2750).High
        },
        /** Should we attempt to load this file? */ test (url) {
            const ext = (0, $db31fc3dfae4939b$exports).path.extname(url).slice(1);
            return !!(0, $f7551ed0f4e817c1$export$5f747a46dc0eb6ee)[ext] || (0, $f7551ed0f4e817c1$export$8114c8bcb5760e77).some((mime)=>url.startsWith(`data:${mime}`));
        },
        /** Load the sound file, this is mostly handled by Sound.from() */ async load (url, asset) {
            const sound = await new Promise((resolve, reject)=>(0, $c49e33ab4565eb4d$export$85990f0f98a390bb).from({
                    ...asset.data,
                    url: url,
                    preload: true,
                    loaded (err, sound2) {
                        if (err) reject(err);
                        else resolve(sound2);
                        asset.data?.loaded?.(err, sound2);
                    }
                }));
            (0, $c762494680c35543$export$8bedcca5bbd73999)().add($35ee8f4e5726aa8b$var$getAlias(asset), sound);
            return sound;
        },
        /** Remove the sound from the library */ async unload (_sound, asset) {
            (0, $c762494680c35543$export$8bedcca5bbd73999)().remove($35ee8f4e5726aa8b$var$getAlias(asset));
        }
    }
};
(0, $c90155f6d7d8d8f6$export$cc3e2d3244e01b7f).add($35ee8f4e5726aa8b$export$ac5ef27803a8e50);





const $52a374576fbfc221$export$eab32dcfc4ded11c = (0, $c762494680c35543$export$7fbc60ba12697434)(new (0, $6ac9a6dbfecc7b3b$export$8f62fda960fa1546)());


var $70e7e2b9a2a71832$exports = {};
(function(globalScope) {
    "use strict";
    /*!
   *  decimal.js v10.4.3
   *  An arbitrary-precision Decimal type for JavaScript.
   *  https://github.com/MikeMcl/decimal.js
   *  Copyright (c) 2022 Michael Mclaughlin <M8ch88l@gmail.com>
   *  MIT Licence
   */ // -----------------------------------  EDITABLE DEFAULTS  ------------------------------------ //
    // The maximum exponent magnitude.
    // The limit on the value of `toExpNeg`, `toExpPos`, `minE` and `maxE`.
    var EXP_LIMIT = 9e15, // The limit on the value of `precision`, and on the value of the first argument to
    // `toDecimalPlaces`, `toExponential`, `toFixed`, `toPrecision` and `toSignificantDigits`.
    MAX_DIGITS = 1e9, // Base conversion alphabet.
    NUMERALS = "0123456789abcdef", // The natural logarithm of 10 (1025 digits).
    LN10 = "2.3025850929940456840179914546843642076011014886287729760333279009675726096773524802359972050895982983419677840422862486334095254650828067566662873690987816894829072083255546808437998948262331985283935053089653777326288461633662222876982198867465436674744042432743651550489343149393914796194044002221051017141748003688084012647080685567743216228355220114804663715659121373450747856947683463616792101806445070648000277502684916746550586856935673420670581136429224554405758925724208241314695689016758940256776311356919292033376587141660230105703089634572075440370847469940168269282808481184289314848524948644871927809676271275775397027668605952496716674183485704422507197965004714951050492214776567636938662976979522110718264549734772662425709429322582798502585509785265383207606726317164309505995087807523710333101197857547331541421808427543863591778117054309827482385045648019095610299291824318237525357709750539565187697510374970888692180205189339507238539205144634197265287286965110862571492198849978748873771345686209167058", // Pi (1025 digits).
    PI = "3.1415926535897932384626433832795028841971693993751058209749445923078164062862089986280348253421170679821480865132823066470938446095505822317253594081284811174502841027019385211055596446229489549303819644288109756659334461284756482337867831652712019091456485669234603486104543266482133936072602491412737245870066063155881748815209209628292540917153643678925903600113305305488204665213841469519415116094330572703657595919530921861173819326117931051185480744623799627495673518857527248912279381830119491298336733624406566430860213949463952247371907021798609437027705392171762931767523846748184676694051320005681271452635608277857713427577896091736371787214684409012249534301465495853710507922796892589235420199561121290219608640344181598136297747713099605187072113499999983729780499510597317328160963185950244594553469083026425223082533446850352619311881710100031378387528865875332083814206171776691473035982534904287554687311595628638823537875937519577818577805321712268066130019278766111959092164201989380952572010654858632789", // The initial configuration properties of the Decimal constructor.
    DEFAULTS = {
        // These values must be integers within the stated ranges (inclusive).
        // Most of these values can be changed at run-time using the `Decimal.config` method.
        // The maximum number of significant digits of the result of a calculation or base conversion.
        // E.g. `Decimal.config({ precision: 20 });`
        precision: 20,
        // The rounding mode used when rounding to `precision`.
        //
        // ROUND_UP         0 Away from zero.
        // ROUND_DOWN       1 Towards zero.
        // ROUND_CEIL       2 Towards +Infinity.
        // ROUND_FLOOR      3 Towards -Infinity.
        // ROUND_HALF_UP    4 Towards nearest neighbour. If equidistant, up.
        // ROUND_HALF_DOWN  5 Towards nearest neighbour. If equidistant, down.
        // ROUND_HALF_EVEN  6 Towards nearest neighbour. If equidistant, towards even neighbour.
        // ROUND_HALF_CEIL  7 Towards nearest neighbour. If equidistant, towards +Infinity.
        // ROUND_HALF_FLOOR 8 Towards nearest neighbour. If equidistant, towards -Infinity.
        //
        // E.g.
        // `Decimal.rounding = 4;`
        // `Decimal.rounding = Decimal.ROUND_HALF_UP;`
        rounding: 4,
        // The modulo mode used when calculating the modulus: a mod n.
        // The quotient (q = a / n) is calculated according to the corresponding rounding mode.
        // The remainder (r) is calculated as: r = a - n * q.
        //
        // UP         0 The remainder is positive if the dividend is negative, else is negative.
        // DOWN       1 The remainder has the same sign as the dividend (JavaScript %).
        // FLOOR      3 The remainder has the same sign as the divisor (Python %).
        // HALF_EVEN  6 The IEEE 754 remainder function.
        // EUCLID     9 Euclidian division. q = sign(n) * floor(a / abs(n)). Always positive.
        //
        // Truncated division (1), floored division (3), the IEEE 754 remainder (6), and Euclidian
        // division (9) are commonly used for the modulus operation. The other rounding modes can also
        // be used, but they may not give useful results.
        modulo: 1,
        // The exponent value at and beneath which `toString` returns exponential notation.
        // JavaScript numbers: -7
        toExpNeg: -7,
        // The exponent value at and above which `toString` returns exponential notation.
        // JavaScript numbers: 21
        toExpPos: 21,
        // The minimum exponent value, beneath which underflow to zero occurs.
        // JavaScript numbers: -324  (5e-324)
        minE: -EXP_LIMIT,
        // The maximum exponent value, above which overflow to Infinity occurs.
        // JavaScript numbers: 308  (1.7976931348623157e+308)
        maxE: EXP_LIMIT,
        // Whether to use cryptographically-secure random number generation, if available.
        crypto: false // true/false
    }, // ----------------------------------- END OF EDITABLE DEFAULTS ------------------------------- //
    Decimal, inexact, noConflict, quadrant, external = true, decimalError = "[DecimalError] ", invalidArgument = decimalError + "Invalid argument: ", precisionLimitExceeded = decimalError + "Precision limit exceeded", cryptoUnavailable = decimalError + "crypto unavailable", tag = "[object Decimal]", mathfloor = Math.floor, mathpow = Math.pow, isBinary = /^0b([01]+(\.[01]*)?|\.[01]+)(p[+-]?\d+)?$/i, isHex = /^0x([0-9a-f]+(\.[0-9a-f]*)?|\.[0-9a-f]+)(p[+-]?\d+)?$/i, isOctal = /^0o([0-7]+(\.[0-7]*)?|\.[0-7]+)(p[+-]?\d+)?$/i, isDecimal = /^(\d+(\.\d*)?|\.\d+)(e[+-]?\d+)?$/i, BASE = 1e7, LOG_BASE = 7, MAX_SAFE_INTEGER = 9007199254740991, LN10_PRECISION = LN10.length - 1, PI_PRECISION = PI.length - 1, // Decimal.prototype object
    P = {
        toStringTag: tag
    };
    // Decimal prototype methods
    /*
   *  absoluteValue             abs
   *  ceil
   *  clampedTo                 clamp
   *  comparedTo                cmp
   *  cosine                    cos
   *  cubeRoot                  cbrt
   *  decimalPlaces             dp
   *  dividedBy                 div
   *  dividedToIntegerBy        divToInt
   *  equals                    eq
   *  floor
   *  greaterThan               gt
   *  greaterThanOrEqualTo      gte
   *  hyperbolicCosine          cosh
   *  hyperbolicSine            sinh
   *  hyperbolicTangent         tanh
   *  inverseCosine             acos
   *  inverseHyperbolicCosine   acosh
   *  inverseHyperbolicSine     asinh
   *  inverseHyperbolicTangent  atanh
   *  inverseSine               asin
   *  inverseTangent            atan
   *  isFinite
   *  isInteger                 isInt
   *  isNaN
   *  isNegative                isNeg
   *  isPositive                isPos
   *  isZero
   *  lessThan                  lt
   *  lessThanOrEqualTo         lte
   *  logarithm                 log
   *  [maximum]                 [max]
   *  [minimum]                 [min]
   *  minus                     sub
   *  modulo                    mod
   *  naturalExponential        exp
   *  naturalLogarithm          ln
   *  negated                   neg
   *  plus                      add
   *  precision                 sd
   *  round
   *  sine                      sin
   *  squareRoot                sqrt
   *  tangent                   tan
   *  times                     mul
   *  toBinary
   *  toDecimalPlaces           toDP
   *  toExponential
   *  toFixed
   *  toFraction
   *  toHexadecimal             toHex
   *  toNearest
   *  toNumber
   *  toOctal
   *  toPower                   pow
   *  toPrecision
   *  toSignificantDigits       toSD
   *  toString
   *  truncated                 trunc
   *  valueOf                   toJSON
   */ /*
   * Return a new Decimal whose value is the absolute value of this Decimal.
   *
   */ P.absoluteValue = P.abs = function() {
        var x = new this.constructor(this);
        if (x.s < 0) x.s = 1;
        return finalise(x);
    };
    /*
   * Return a new Decimal whose value is the value of this Decimal rounded to a whole number in the
   * direction of positive Infinity.
   *
   */ P.ceil = function() {
        return finalise(new this.constructor(this), this.e + 1, 2);
    };
    /*
   * Return a new Decimal whose value is the value of this Decimal clamped to the range
   * delineated by `min` and `max`.
   *
   * min {number|string|Decimal}
   * max {number|string|Decimal}
   *
   */ P.clampedTo = P.clamp = function(min, max) {
        var k, x = this, Ctor = x.constructor;
        min = new Ctor(min);
        max = new Ctor(max);
        if (!min.s || !max.s) return new Ctor(NaN);
        if (min.gt(max)) throw Error(invalidArgument + max);
        k = x.cmp(min);
        return k < 0 ? min : x.cmp(max) > 0 ? max : new Ctor(x);
    };
    /*
   * Return
   *   1    if the value of this Decimal is greater than the value of `y`,
   *  -1    if the value of this Decimal is less than the value of `y`,
   *   0    if they have the same value,
   *   NaN  if the value of either Decimal is NaN.
   *
   */ P.comparedTo = P.cmp = function(y) {
        var i, j, xdL, ydL, x = this, xd = x.d, yd = (y = new x.constructor(y)).d, xs = x.s, ys = y.s;
        // Either NaN or ±Infinity?
        if (!xd || !yd) return !xs || !ys ? NaN : xs !== ys ? xs : xd === yd ? 0 : !xd ^ xs < 0 ? 1 : -1;
        // Either zero?
        if (!xd[0] || !yd[0]) return xd[0] ? xs : yd[0] ? -ys : 0;
        // Signs differ?
        if (xs !== ys) return xs;
        // Compare exponents.
        if (x.e !== y.e) return x.e > y.e ^ xs < 0 ? 1 : -1;
        xdL = xd.length;
        ydL = yd.length;
        // Compare digit by digit.
        for(i = 0, j = xdL < ydL ? xdL : ydL; i < j; ++i){
            if (xd[i] !== yd[i]) return xd[i] > yd[i] ^ xs < 0 ? 1 : -1;
        }
        // Compare lengths.
        return xdL === ydL ? 0 : xdL > ydL ^ xs < 0 ? 1 : -1;
    };
    /*
   * Return a new Decimal whose value is the cosine of the value in radians of this Decimal.
   *
   * Domain: [-Infinity, Infinity]
   * Range: [-1, 1]
   *
   * cos(0)         = 1
   * cos(-0)        = 1
   * cos(Infinity)  = NaN
   * cos(-Infinity) = NaN
   * cos(NaN)       = NaN
   *
   */ P.cosine = P.cos = function() {
        var pr, rm, x = this, Ctor = x.constructor;
        if (!x.d) return new Ctor(NaN);
        // cos(0) = cos(-0) = 1
        if (!x.d[0]) return new Ctor(1);
        pr = Ctor.precision;
        rm = Ctor.rounding;
        Ctor.precision = pr + Math.max(x.e, x.sd()) + LOG_BASE;
        Ctor.rounding = 1;
        x = cosine(Ctor, toLessThanHalfPi(Ctor, x));
        Ctor.precision = pr;
        Ctor.rounding = rm;
        return finalise(quadrant == 2 || quadrant == 3 ? x.neg() : x, pr, rm, true);
    };
    /*
   *
   * Return a new Decimal whose value is the cube root of the value of this Decimal, rounded to
   * `precision` significant digits using rounding mode `rounding`.
   *
   *  cbrt(0)  =  0
   *  cbrt(-0) = -0
   *  cbrt(1)  =  1
   *  cbrt(-1) = -1
   *  cbrt(N)  =  N
   *  cbrt(-I) = -I
   *  cbrt(I)  =  I
   *
   * Math.cbrt(x) = (x < 0 ? -Math.pow(-x, 1/3) : Math.pow(x, 1/3))
   *
   */ P.cubeRoot = P.cbrt = function() {
        var e, m, n, r, rep, s, sd, t, t3, t3plusx, x = this, Ctor = x.constructor;
        if (!x.isFinite() || x.isZero()) return new Ctor(x);
        external = false;
        // Initial estimate.
        s = x.s * mathpow(x.s * x, 1 / 3);
        // Math.cbrt underflow/overflow?
        // Pass x to Math.pow as integer, then adjust the exponent of the result.
        if (!s || Math.abs(s) == 1 / 0) {
            n = digitsToString(x.d);
            e = x.e;
            // Adjust n exponent so it is a multiple of 3 away from x exponent.
            if (s = (e - n.length + 1) % 3) n += s == 1 || s == -2 ? "0" : "00";
            s = mathpow(n, 1 / 3);
            // Rarely, e may be one less than the result exponent value.
            e = mathfloor((e + 1) / 3) - (e % 3 == (e < 0 ? -1 : 2));
            if (s == 1 / 0) n = "5e" + e;
            else {
                n = s.toExponential();
                n = n.slice(0, n.indexOf("e") + 1) + e;
            }
            r = new Ctor(n);
            r.s = x.s;
        } else r = new Ctor(s.toString());
        sd = (e = Ctor.precision) + 3;
        // Halley's method.
        // TODO? Compare Newton's method.
        for(;;){
            t = r;
            t3 = t.times(t).times(t);
            t3plusx = t3.plus(x);
            r = divide(t3plusx.plus(x).times(t), t3plusx.plus(t3), sd + 2, 1);
            // TODO? Replace with for-loop and checkRoundingDigits.
            if (digitsToString(t.d).slice(0, sd) === (n = digitsToString(r.d)).slice(0, sd)) {
                n = n.slice(sd - 3, sd + 1);
                // The 4th rounding digit may be in error by -1 so if the 4 rounding digits are 9999 or 4999
                // , i.e. approaching a rounding boundary, continue the iteration.
                if (n == "9999" || !rep && n == "4999") {
                    // On the first iteration only, check to see if rounding up gives the exact result as the
                    // nines may infinitely repeat.
                    if (!rep) {
                        finalise(t, e + 1, 0);
                        if (t.times(t).times(t).eq(x)) {
                            r = t;
                            break;
                        }
                    }
                    sd += 4;
                    rep = 1;
                } else {
                    // If the rounding digits are null, 0{0,4} or 50{0,3}, check for an exact result.
                    // If not, then there are further digits and m will be truthy.
                    if (!+n || !+n.slice(1) && n.charAt(0) == "5") {
                        // Truncate to the first rounding digit.
                        finalise(r, e + 1, 1);
                        m = !r.times(r).times(r).eq(x);
                    }
                    break;
                }
            }
        }
        external = true;
        return finalise(r, e, Ctor.rounding, m);
    };
    /*
   * Return the number of decimal places of the value of this Decimal.
   *
   */ P.decimalPlaces = P.dp = function() {
        var w, d = this.d, n = NaN;
        if (d) {
            w = d.length - 1;
            n = (w - mathfloor(this.e / LOG_BASE)) * LOG_BASE;
            // Subtract the number of trailing zeros of the last word.
            w = d[w];
            if (w) for(; w % 10 == 0; w /= 10)n--;
            if (n < 0) n = 0;
        }
        return n;
    };
    /*
   *  n / 0 = I
   *  n / N = N
   *  n / I = 0
   *  0 / n = 0
   *  0 / 0 = N
   *  0 / N = N
   *  0 / I = 0
   *  N / n = N
   *  N / 0 = N
   *  N / N = N
   *  N / I = N
   *  I / n = I
   *  I / 0 = I
   *  I / N = N
   *  I / I = N
   *
   * Return a new Decimal whose value is the value of this Decimal divided by `y`, rounded to
   * `precision` significant digits using rounding mode `rounding`.
   *
   */ P.dividedBy = P.div = function(y) {
        return divide(this, new this.constructor(y));
    };
    /*
   * Return a new Decimal whose value is the integer part of dividing the value of this Decimal
   * by the value of `y`, rounded to `precision` significant digits using rounding mode `rounding`.
   *
   */ P.dividedToIntegerBy = P.divToInt = function(y) {
        var x = this, Ctor = x.constructor;
        return finalise(divide(x, new Ctor(y), 0, 1, 1), Ctor.precision, Ctor.rounding);
    };
    /*
   * Return true if the value of this Decimal is equal to the value of `y`, otherwise return false.
   *
   */ P.equals = P.eq = function(y) {
        return this.cmp(y) === 0;
    };
    /*
   * Return a new Decimal whose value is the value of this Decimal rounded to a whole number in the
   * direction of negative Infinity.
   *
   */ P.floor = function() {
        return finalise(new this.constructor(this), this.e + 1, 3);
    };
    /*
   * Return true if the value of this Decimal is greater than the value of `y`, otherwise return
   * false.
   *
   */ P.greaterThan = P.gt = function(y) {
        return this.cmp(y) > 0;
    };
    /*
   * Return true if the value of this Decimal is greater than or equal to the value of `y`,
   * otherwise return false.
   *
   */ P.greaterThanOrEqualTo = P.gte = function(y) {
        var k = this.cmp(y);
        return k == 1 || k === 0;
    };
    /*
   * Return a new Decimal whose value is the hyperbolic cosine of the value in radians of this
   * Decimal.
   *
   * Domain: [-Infinity, Infinity]
   * Range: [1, Infinity]
   *
   * cosh(x) = 1 + x^2/2! + x^4/4! + x^6/6! + ...
   *
   * cosh(0)         = 1
   * cosh(-0)        = 1
   * cosh(Infinity)  = Infinity
   * cosh(-Infinity) = Infinity
   * cosh(NaN)       = NaN
   *
   *  x        time taken (ms)   result
   * 1000      9                 9.8503555700852349694e+433
   * 10000     25                4.4034091128314607936e+4342
   * 100000    171               1.4033316802130615897e+43429
   * 1000000   3817              1.5166076984010437725e+434294
   * 10000000  abandoned after 2 minute wait
   *
   * TODO? Compare performance of cosh(x) = 0.5 * (exp(x) + exp(-x))
   *
   */ P.hyperbolicCosine = P.cosh = function() {
        var k, n, pr, rm, len, x = this, Ctor = x.constructor, one = new Ctor(1);
        if (!x.isFinite()) return new Ctor(x.s ? 1 / 0 : NaN);
        if (x.isZero()) return one;
        pr = Ctor.precision;
        rm = Ctor.rounding;
        Ctor.precision = pr + Math.max(x.e, x.sd()) + 4;
        Ctor.rounding = 1;
        len = x.d.length;
        // Argument reduction: cos(4x) = 1 - 8cos^2(x) + 8cos^4(x) + 1
        // i.e. cos(x) = 1 - cos^2(x/4)(8 - 8cos^2(x/4))
        // Estimate the optimum number of times to use the argument reduction.
        // TODO? Estimation reused from cosine() and may not be optimal here.
        if (len < 32) {
            k = Math.ceil(len / 3);
            n = (1 / tinyPow(4, k)).toString();
        } else {
            k = 16;
            n = "2.3283064365386962890625e-10";
        }
        x = taylorSeries(Ctor, 1, x.times(n), new Ctor(1), true);
        // Reverse argument reduction
        var cosh2_x, i = k, d8 = new Ctor(8);
        for(; i--;){
            cosh2_x = x.times(x);
            x = one.minus(cosh2_x.times(d8.minus(cosh2_x.times(d8))));
        }
        return finalise(x, Ctor.precision = pr, Ctor.rounding = rm, true);
    };
    /*
   * Return a new Decimal whose value is the hyperbolic sine of the value in radians of this
   * Decimal.
   *
   * Domain: [-Infinity, Infinity]
   * Range: [-Infinity, Infinity]
   *
   * sinh(x) = x + x^3/3! + x^5/5! + x^7/7! + ...
   *
   * sinh(0)         = 0
   * sinh(-0)        = -0
   * sinh(Infinity)  = Infinity
   * sinh(-Infinity) = -Infinity
   * sinh(NaN)       = NaN
   *
   * x        time taken (ms)
   * 10       2 ms
   * 100      5 ms
   * 1000     14 ms
   * 10000    82 ms
   * 100000   886 ms            1.4033316802130615897e+43429
   * 200000   2613 ms
   * 300000   5407 ms
   * 400000   8824 ms
   * 500000   13026 ms          8.7080643612718084129e+217146
   * 1000000  48543 ms
   *
   * TODO? Compare performance of sinh(x) = 0.5 * (exp(x) - exp(-x))
   *
   */ P.hyperbolicSine = P.sinh = function() {
        var k, pr, rm, len, x = this, Ctor = x.constructor;
        if (!x.isFinite() || x.isZero()) return new Ctor(x);
        pr = Ctor.precision;
        rm = Ctor.rounding;
        Ctor.precision = pr + Math.max(x.e, x.sd()) + 4;
        Ctor.rounding = 1;
        len = x.d.length;
        if (len < 3) x = taylorSeries(Ctor, 2, x, x, true);
        else {
            // Alternative argument reduction: sinh(3x) = sinh(x)(3 + 4sinh^2(x))
            // i.e. sinh(x) = sinh(x/3)(3 + 4sinh^2(x/3))
            // 3 multiplications and 1 addition
            // Argument reduction: sinh(5x) = sinh(x)(5 + sinh^2(x)(20 + 16sinh^2(x)))
            // i.e. sinh(x) = sinh(x/5)(5 + sinh^2(x/5)(20 + 16sinh^2(x/5)))
            // 4 multiplications and 2 additions
            // Estimate the optimum number of times to use the argument reduction.
            k = 1.4 * Math.sqrt(len);
            k = k > 16 ? 16 : k | 0;
            x = x.times(1 / tinyPow(5, k));
            x = taylorSeries(Ctor, 2, x, x, true);
            // Reverse argument reduction
            var sinh2_x, d5 = new Ctor(5), d16 = new Ctor(16), d20 = new Ctor(20);
            for(; k--;){
                sinh2_x = x.times(x);
                x = x.times(d5.plus(sinh2_x.times(d16.times(sinh2_x).plus(d20))));
            }
        }
        Ctor.precision = pr;
        Ctor.rounding = rm;
        return finalise(x, pr, rm, true);
    };
    /*
   * Return a new Decimal whose value is the hyperbolic tangent of the value in radians of this
   * Decimal.
   *
   * Domain: [-Infinity, Infinity]
   * Range: [-1, 1]
   *
   * tanh(x) = sinh(x) / cosh(x)
   *
   * tanh(0)         = 0
   * tanh(-0)        = -0
   * tanh(Infinity)  = 1
   * tanh(-Infinity) = -1
   * tanh(NaN)       = NaN
   *
   */ P.hyperbolicTangent = P.tanh = function() {
        var pr, rm, x = this, Ctor = x.constructor;
        if (!x.isFinite()) return new Ctor(x.s);
        if (x.isZero()) return new Ctor(x);
        pr = Ctor.precision;
        rm = Ctor.rounding;
        Ctor.precision = pr + 7;
        Ctor.rounding = 1;
        return divide(x.sinh(), x.cosh(), Ctor.precision = pr, Ctor.rounding = rm);
    };
    /*
   * Return a new Decimal whose value is the arccosine (inverse cosine) in radians of the value of
   * this Decimal.
   *
   * Domain: [-1, 1]
   * Range: [0, pi]
   *
   * acos(x) = pi/2 - asin(x)
   *
   * acos(0)       = pi/2
   * acos(-0)      = pi/2
   * acos(1)       = 0
   * acos(-1)      = pi
   * acos(1/2)     = pi/3
   * acos(-1/2)    = 2*pi/3
   * acos(|x| > 1) = NaN
   * acos(NaN)     = NaN
   *
   */ P.inverseCosine = P.acos = function() {
        var halfPi, x = this, Ctor = x.constructor, k = x.abs().cmp(1), pr = Ctor.precision, rm = Ctor.rounding;
        if (k !== -1) return k === 0 ? x.isNeg() ? getPi(Ctor, pr, rm) : new Ctor(0) : new Ctor(NaN);
        if (x.isZero()) return getPi(Ctor, pr + 4, rm).times(0.5);
        // TODO? Special case acos(0.5) = pi/3 and acos(-0.5) = 2*pi/3
        Ctor.precision = pr + 6;
        Ctor.rounding = 1;
        x = x.asin();
        halfPi = getPi(Ctor, pr + 4, rm).times(0.5);
        Ctor.precision = pr;
        Ctor.rounding = rm;
        return halfPi.minus(x);
    };
    /*
   * Return a new Decimal whose value is the inverse of the hyperbolic cosine in radians of the
   * value of this Decimal.
   *
   * Domain: [1, Infinity]
   * Range: [0, Infinity]
   *
   * acosh(x) = ln(x + sqrt(x^2 - 1))
   *
   * acosh(x < 1)     = NaN
   * acosh(NaN)       = NaN
   * acosh(Infinity)  = Infinity
   * acosh(-Infinity) = NaN
   * acosh(0)         = NaN
   * acosh(-0)        = NaN
   * acosh(1)         = 0
   * acosh(-1)        = NaN
   *
   */ P.inverseHyperbolicCosine = P.acosh = function() {
        var pr, rm, x = this, Ctor = x.constructor;
        if (x.lte(1)) return new Ctor(x.eq(1) ? 0 : NaN);
        if (!x.isFinite()) return new Ctor(x);
        pr = Ctor.precision;
        rm = Ctor.rounding;
        Ctor.precision = pr + Math.max(Math.abs(x.e), x.sd()) + 4;
        Ctor.rounding = 1;
        external = false;
        x = x.times(x).minus(1).sqrt().plus(x);
        external = true;
        Ctor.precision = pr;
        Ctor.rounding = rm;
        return x.ln();
    };
    /*
   * Return a new Decimal whose value is the inverse of the hyperbolic sine in radians of the value
   * of this Decimal.
   *
   * Domain: [-Infinity, Infinity]
   * Range: [-Infinity, Infinity]
   *
   * asinh(x) = ln(x + sqrt(x^2 + 1))
   *
   * asinh(NaN)       = NaN
   * asinh(Infinity)  = Infinity
   * asinh(-Infinity) = -Infinity
   * asinh(0)         = 0
   * asinh(-0)        = -0
   *
   */ P.inverseHyperbolicSine = P.asinh = function() {
        var pr, rm, x = this, Ctor = x.constructor;
        if (!x.isFinite() || x.isZero()) return new Ctor(x);
        pr = Ctor.precision;
        rm = Ctor.rounding;
        Ctor.precision = pr + 2 * Math.max(Math.abs(x.e), x.sd()) + 6;
        Ctor.rounding = 1;
        external = false;
        x = x.times(x).plus(1).sqrt().plus(x);
        external = true;
        Ctor.precision = pr;
        Ctor.rounding = rm;
        return x.ln();
    };
    /*
   * Return a new Decimal whose value is the inverse of the hyperbolic tangent in radians of the
   * value of this Decimal.
   *
   * Domain: [-1, 1]
   * Range: [-Infinity, Infinity]
   *
   * atanh(x) = 0.5 * ln((1 + x) / (1 - x))
   *
   * atanh(|x| > 1)   = NaN
   * atanh(NaN)       = NaN
   * atanh(Infinity)  = NaN
   * atanh(-Infinity) = NaN
   * atanh(0)         = 0
   * atanh(-0)        = -0
   * atanh(1)         = Infinity
   * atanh(-1)        = -Infinity
   *
   */ P.inverseHyperbolicTangent = P.atanh = function() {
        var pr, rm, wpr, xsd, x = this, Ctor = x.constructor;
        if (!x.isFinite()) return new Ctor(NaN);
        if (x.e >= 0) return new Ctor(x.abs().eq(1) ? x.s / 0 : x.isZero() ? x : NaN);
        pr = Ctor.precision;
        rm = Ctor.rounding;
        xsd = x.sd();
        if (Math.max(xsd, pr) < 2 * -x.e - 1) return finalise(new Ctor(x), pr, rm, true);
        Ctor.precision = wpr = xsd - x.e;
        x = divide(x.plus(1), new Ctor(1).minus(x), wpr + pr, 1);
        Ctor.precision = pr + 4;
        Ctor.rounding = 1;
        x = x.ln();
        Ctor.precision = pr;
        Ctor.rounding = rm;
        return x.times(0.5);
    };
    /*
   * Return a new Decimal whose value is the arcsine (inverse sine) in radians of the value of this
   * Decimal.
   *
   * Domain: [-Infinity, Infinity]
   * Range: [-pi/2, pi/2]
   *
   * asin(x) = 2*atan(x/(1 + sqrt(1 - x^2)))
   *
   * asin(0)       = 0
   * asin(-0)      = -0
   * asin(1/2)     = pi/6
   * asin(-1/2)    = -pi/6
   * asin(1)       = pi/2
   * asin(-1)      = -pi/2
   * asin(|x| > 1) = NaN
   * asin(NaN)     = NaN
   *
   * TODO? Compare performance of Taylor series.
   *
   */ P.inverseSine = P.asin = function() {
        var halfPi, k, pr, rm, x = this, Ctor = x.constructor;
        if (x.isZero()) return new Ctor(x);
        k = x.abs().cmp(1);
        pr = Ctor.precision;
        rm = Ctor.rounding;
        if (k !== -1) {
            // |x| is 1
            if (k === 0) {
                halfPi = getPi(Ctor, pr + 4, rm).times(0.5);
                halfPi.s = x.s;
                return halfPi;
            }
            // |x| > 1 or x is NaN
            return new Ctor(NaN);
        }
        // TODO? Special case asin(1/2) = pi/6 and asin(-1/2) = -pi/6
        Ctor.precision = pr + 6;
        Ctor.rounding = 1;
        x = x.div(new Ctor(1).minus(x.times(x)).sqrt().plus(1)).atan();
        Ctor.precision = pr;
        Ctor.rounding = rm;
        return x.times(2);
    };
    /*
   * Return a new Decimal whose value is the arctangent (inverse tangent) in radians of the value
   * of this Decimal.
   *
   * Domain: [-Infinity, Infinity]
   * Range: [-pi/2, pi/2]
   *
   * atan(x) = x - x^3/3 + x^5/5 - x^7/7 + ...
   *
   * atan(0)         = 0
   * atan(-0)        = -0
   * atan(1)         = pi/4
   * atan(-1)        = -pi/4
   * atan(Infinity)  = pi/2
   * atan(-Infinity) = -pi/2
   * atan(NaN)       = NaN
   *
   */ P.inverseTangent = P.atan = function() {
        var i, j, k, n, px, t, r, wpr, x2, x = this, Ctor = x.constructor, pr = Ctor.precision, rm = Ctor.rounding;
        if (!x.isFinite()) {
            if (!x.s) return new Ctor(NaN);
            if (pr + 4 <= PI_PRECISION) {
                r = getPi(Ctor, pr + 4, rm).times(0.5);
                r.s = x.s;
                return r;
            }
        } else if (x.isZero()) return new Ctor(x);
        else if (x.abs().eq(1) && pr + 4 <= PI_PRECISION) {
            r = getPi(Ctor, pr + 4, rm).times(0.25);
            r.s = x.s;
            return r;
        }
        Ctor.precision = wpr = pr + 10;
        Ctor.rounding = 1;
        // TODO? if (x >= 1 && pr <= PI_PRECISION) atan(x) = halfPi * x.s - atan(1 / x);
        // Argument reduction
        // Ensure |x| < 0.42
        // atan(x) = 2 * atan(x / (1 + sqrt(1 + x^2)))
        k = Math.min(28, wpr / LOG_BASE + 2 | 0);
        for(i = k; i; --i)x = x.div(x.times(x).plus(1).sqrt().plus(1));
        external = false;
        j = Math.ceil(wpr / LOG_BASE);
        n = 1;
        x2 = x.times(x);
        r = new Ctor(x);
        px = x;
        // atan(x) = x - x^3/3 + x^5/5 - x^7/7 + ...
        for(; i !== -1;){
            px = px.times(x2);
            t = r.minus(px.div(n += 2));
            px = px.times(x2);
            r = t.plus(px.div(n += 2));
            if (r.d[j] !== void 0) for(i = j; r.d[i] === t.d[i] && i--;);
        }
        if (k) r = r.times(2 << k - 1);
        external = true;
        return finalise(r, Ctor.precision = pr, Ctor.rounding = rm, true);
    };
    /*
   * Return true if the value of this Decimal is a finite number, otherwise return false.
   *
   */ P.isFinite = function() {
        return !!this.d;
    };
    /*
   * Return true if the value of this Decimal is an integer, otherwise return false.
   *
   */ P.isInteger = P.isInt = function() {
        return !!this.d && mathfloor(this.e / LOG_BASE) > this.d.length - 2;
    };
    /*
   * Return true if the value of this Decimal is NaN, otherwise return false.
   *
   */ P.isNaN = function() {
        return !this.s;
    };
    /*
   * Return true if the value of this Decimal is negative, otherwise return false.
   *
   */ P.isNegative = P.isNeg = function() {
        return this.s < 0;
    };
    /*
   * Return true if the value of this Decimal is positive, otherwise return false.
   *
   */ P.isPositive = P.isPos = function() {
        return this.s > 0;
    };
    /*
   * Return true if the value of this Decimal is 0 or -0, otherwise return false.
   *
   */ P.isZero = function() {
        return !!this.d && this.d[0] === 0;
    };
    /*
   * Return true if the value of this Decimal is less than `y`, otherwise return false.
   *
   */ P.lessThan = P.lt = function(y) {
        return this.cmp(y) < 0;
    };
    /*
   * Return true if the value of this Decimal is less than or equal to `y`, otherwise return false.
   *
   */ P.lessThanOrEqualTo = P.lte = function(y) {
        return this.cmp(y) < 1;
    };
    /*
   * Return the logarithm of the value of this Decimal to the specified base, rounded to `precision`
   * significant digits using rounding mode `rounding`.
   *
   * If no base is specified, return log[10](arg).
   *
   * log[base](arg) = ln(arg) / ln(base)
   *
   * The result will always be correctly rounded if the base of the log is 10, and 'almost always'
   * otherwise:
   *
   * Depending on the rounding mode, the result may be incorrectly rounded if the first fifteen
   * rounding digits are [49]99999999999999 or [50]00000000000000. In that case, the maximum error
   * between the result and the correctly rounded result will be one ulp (unit in the last place).
   *
   * log[-b](a)       = NaN
   * log[0](a)        = NaN
   * log[1](a)        = NaN
   * log[NaN](a)      = NaN
   * log[Infinity](a) = NaN
   * log[b](0)        = -Infinity
   * log[b](-0)       = -Infinity
   * log[b](-a)       = NaN
   * log[b](1)        = 0
   * log[b](Infinity) = Infinity
   * log[b](NaN)      = NaN
   *
   * [base] {number|string|Decimal} The base of the logarithm.
   *
   */ P.logarithm = P.log = function(base) {
        var isBase10, d, denominator, k, inf, num, sd, r, arg = this, Ctor = arg.constructor, pr = Ctor.precision, rm = Ctor.rounding, guard = 5;
        // Default base is 10.
        if (base == null) {
            base = new Ctor(10);
            isBase10 = true;
        } else {
            base = new Ctor(base);
            d = base.d;
            // Return NaN if base is negative, or non-finite, or is 0 or 1.
            if (base.s < 0 || !d || !d[0] || base.eq(1)) return new Ctor(NaN);
            isBase10 = base.eq(10);
        }
        d = arg.d;
        // Is arg negative, non-finite, 0 or 1?
        if (arg.s < 0 || !d || !d[0] || arg.eq(1)) return new Ctor(d && !d[0] ? -1 / 0 : arg.s != 1 ? NaN : d ? 0 : 1 / 0);
        // The result will have a non-terminating decimal expansion if base is 10 and arg is not an
        // integer power of 10.
        if (isBase10) {
            if (d.length > 1) inf = true;
            else {
                for(k = d[0]; k % 10 === 0;)k /= 10;
                inf = k !== 1;
            }
        }
        external = false;
        sd = pr + guard;
        num = naturalLogarithm(arg, sd);
        denominator = isBase10 ? getLn10(Ctor, sd + 10) : naturalLogarithm(base, sd);
        // The result will have 5 rounding digits.
        r = divide(num, denominator, sd, 1);
        // If at a rounding boundary, i.e. the result's rounding digits are [49]9999 or [50]0000,
        // calculate 10 further digits.
        //
        // If the result is known to have an infinite decimal expansion, repeat this until it is clear
        // that the result is above or below the boundary. Otherwise, if after calculating the 10
        // further digits, the last 14 are nines, round up and assume the result is exact.
        // Also assume the result is exact if the last 14 are zero.
        //
        // Example of a result that will be incorrectly rounded:
        // log[1048576](4503599627370502) = 2.60000000000000009610279511444746...
        // The above result correctly rounded using ROUND_CEIL to 1 decimal place should be 2.7, but it
        // will be given as 2.6 as there are 15 zeros immediately after the requested decimal place, so
        // the exact result would be assumed to be 2.6, which rounded using ROUND_CEIL to 1 decimal
        // place is still 2.6.
        if (checkRoundingDigits(r.d, k = pr, rm)) do {
            sd += 10;
            num = naturalLogarithm(arg, sd);
            denominator = isBase10 ? getLn10(Ctor, sd + 10) : naturalLogarithm(base, sd);
            r = divide(num, denominator, sd, 1);
            if (!inf) {
                // Check for 14 nines from the 2nd rounding digit, as the first may be 4.
                if (+digitsToString(r.d).slice(k + 1, k + 15) + 1 == 1e14) r = finalise(r, pr + 1, 0);
                break;
            }
        }while (checkRoundingDigits(r.d, k += 10, rm));
        external = true;
        return finalise(r, pr, rm);
    };
    /*
   * Return a new Decimal whose value is the maximum of the arguments and the value of this Decimal.
   *
   * arguments {number|string|Decimal}
   *
  P.max = function () {
    Array.prototype.push.call(arguments, this);
    return maxOrMin(this.constructor, arguments, 'lt');
  };
   */ /*
   * Return a new Decimal whose value is the minimum of the arguments and the value of this Decimal.
   *
   * arguments {number|string|Decimal}
   *
  P.min = function () {
    Array.prototype.push.call(arguments, this);
    return maxOrMin(this.constructor, arguments, 'gt');
  };
   */ /*
   *  n - 0 = n
   *  n - N = N
   *  n - I = -I
   *  0 - n = -n
   *  0 - 0 = 0
   *  0 - N = N
   *  0 - I = -I
   *  N - n = N
   *  N - 0 = N
   *  N - N = N
   *  N - I = N
   *  I - n = I
   *  I - 0 = I
   *  I - N = N
   *  I - I = N
   *
   * Return a new Decimal whose value is the value of this Decimal minus `y`, rounded to `precision`
   * significant digits using rounding mode `rounding`.
   *
   */ P.minus = P.sub = function(y) {
        var d, e, i, j, k, len, pr, rm, xd, xe, xLTy, yd, x = this, Ctor = x.constructor;
        y = new Ctor(y);
        // If either is not finite...
        if (!x.d || !y.d) {
            // Return NaN if either is NaN.
            if (!x.s || !y.s) y = new Ctor(NaN);
            else if (x.d) y.s = -y.s;
            else y = new Ctor(y.d || x.s !== y.s ? x : NaN);
            return y;
        }
        // If signs differ...
        if (x.s != y.s) {
            y.s = -y.s;
            return x.plus(y);
        }
        xd = x.d;
        yd = y.d;
        pr = Ctor.precision;
        rm = Ctor.rounding;
        // If either is zero...
        if (!xd[0] || !yd[0]) {
            // Return y negated if x is zero and y is non-zero.
            if (yd[0]) y.s = -y.s;
            else if (xd[0]) y = new Ctor(x);
            else return new Ctor(rm === 3 ? -0 : 0);
            return external ? finalise(y, pr, rm) : y;
        }
        // x and y are finite, non-zero numbers with the same sign.
        // Calculate base 1e7 exponents.
        e = mathfloor(y.e / LOG_BASE);
        xe = mathfloor(x.e / LOG_BASE);
        xd = xd.slice();
        k = xe - e;
        // If base 1e7 exponents differ...
        if (k) {
            xLTy = k < 0;
            if (xLTy) {
                d = xd;
                k = -k;
                len = yd.length;
            } else {
                d = yd;
                e = xe;
                len = xd.length;
            }
            // Numbers with massively different exponents would result in a very high number of
            // zeros needing to be prepended, but this can be avoided while still ensuring correct
            // rounding by limiting the number of zeros to `Math.ceil(pr / LOG_BASE) + 2`.
            i = Math.max(Math.ceil(pr / LOG_BASE), len) + 2;
            if (k > i) {
                k = i;
                d.length = 1;
            }
            // Prepend zeros to equalise exponents.
            d.reverse();
            for(i = k; i--;)d.push(0);
            d.reverse();
        // Base 1e7 exponents equal.
        } else {
            // Check digits to determine which is the bigger number.
            i = xd.length;
            len = yd.length;
            xLTy = i < len;
            if (xLTy) len = i;
            for(i = 0; i < len; i++)if (xd[i] != yd[i]) {
                xLTy = xd[i] < yd[i];
                break;
            }
            k = 0;
        }
        if (xLTy) {
            d = xd;
            xd = yd;
            yd = d;
            y.s = -y.s;
        }
        len = xd.length;
        // Append zeros to `xd` if shorter.
        // Don't add zeros to `yd` if shorter as subtraction only needs to start at `yd` length.
        for(i = yd.length - len; i > 0; --i)xd[len++] = 0;
        // Subtract yd from xd.
        for(i = yd.length; i > k;){
            if (xd[--i] < yd[i]) {
                for(j = i; j && xd[--j] === 0;)xd[j] = BASE - 1;
                --xd[j];
                xd[i] += BASE;
            }
            xd[i] -= yd[i];
        }
        // Remove trailing zeros.
        for(; xd[--len] === 0;)xd.pop();
        // Remove leading zeros and adjust exponent accordingly.
        for(; xd[0] === 0; xd.shift())--e;
        // Zero?
        if (!xd[0]) return new Ctor(rm === 3 ? -0 : 0);
        y.d = xd;
        y.e = getBase10Exponent(xd, e);
        return external ? finalise(y, pr, rm) : y;
    };
    /*
   *   n % 0 =  N
   *   n % N =  N
   *   n % I =  n
   *   0 % n =  0
   *  -0 % n = -0
   *   0 % 0 =  N
   *   0 % N =  N
   *   0 % I =  0
   *   N % n =  N
   *   N % 0 =  N
   *   N % N =  N
   *   N % I =  N
   *   I % n =  N
   *   I % 0 =  N
   *   I % N =  N
   *   I % I =  N
   *
   * Return a new Decimal whose value is the value of this Decimal modulo `y`, rounded to
   * `precision` significant digits using rounding mode `rounding`.
   *
   * The result depends on the modulo mode.
   *
   */ P.modulo = P.mod = function(y) {
        var q, x = this, Ctor = x.constructor;
        y = new Ctor(y);
        // Return NaN if x is ±Infinity or NaN, or y is NaN or ±0.
        if (!x.d || !y.s || y.d && !y.d[0]) return new Ctor(NaN);
        // Return x if y is ±Infinity or x is ±0.
        if (!y.d || x.d && !x.d[0]) return finalise(new Ctor(x), Ctor.precision, Ctor.rounding);
        // Prevent rounding of intermediate calculations.
        external = false;
        if (Ctor.modulo == 9) {
            // Euclidian division: q = sign(y) * floor(x / abs(y))
            // result = x - q * y    where  0 <= result < abs(y)
            q = divide(x, y.abs(), 0, 3, 1);
            q.s *= y.s;
        } else q = divide(x, y, 0, Ctor.modulo, 1);
        q = q.times(y);
        external = true;
        return x.minus(q);
    };
    /*
   * Return a new Decimal whose value is the natural exponential of the value of this Decimal,
   * i.e. the base e raised to the power the value of this Decimal, rounded to `precision`
   * significant digits using rounding mode `rounding`.
   *
   */ P.naturalExponential = P.exp = function() {
        return naturalExponential(this);
    };
    /*
   * Return a new Decimal whose value is the natural logarithm of the value of this Decimal,
   * rounded to `precision` significant digits using rounding mode `rounding`.
   *
   */ P.naturalLogarithm = P.ln = function() {
        return naturalLogarithm(this);
    };
    /*
   * Return a new Decimal whose value is the value of this Decimal negated, i.e. as if multiplied by
   * -1.
   *
   */ P.negated = P.neg = function() {
        var x = new this.constructor(this);
        x.s = -x.s;
        return finalise(x);
    };
    /*
   *  n + 0 = n
   *  n + N = N
   *  n + I = I
   *  0 + n = n
   *  0 + 0 = 0
   *  0 + N = N
   *  0 + I = I
   *  N + n = N
   *  N + 0 = N
   *  N + N = N
   *  N + I = N
   *  I + n = I
   *  I + 0 = I
   *  I + N = N
   *  I + I = I
   *
   * Return a new Decimal whose value is the value of this Decimal plus `y`, rounded to `precision`
   * significant digits using rounding mode `rounding`.
   *
   */ P.plus = P.add = function(y) {
        var carry, d, e, i, k, len, pr, rm, xd, yd, x = this, Ctor = x.constructor;
        y = new Ctor(y);
        // If either is not finite...
        if (!x.d || !y.d) {
            // Return NaN if either is NaN.
            if (!x.s || !y.s) y = new Ctor(NaN);
            else if (!x.d) y = new Ctor(y.d || x.s === y.s ? x : NaN);
            return y;
        }
        // If signs differ...
        if (x.s != y.s) {
            y.s = -y.s;
            return x.minus(y);
        }
        xd = x.d;
        yd = y.d;
        pr = Ctor.precision;
        rm = Ctor.rounding;
        // If either is zero...
        if (!xd[0] || !yd[0]) {
            // Return x if y is zero.
            // Return y if y is non-zero.
            if (!yd[0]) y = new Ctor(x);
            return external ? finalise(y, pr, rm) : y;
        }
        // x and y are finite, non-zero numbers with the same sign.
        // Calculate base 1e7 exponents.
        k = mathfloor(x.e / LOG_BASE);
        e = mathfloor(y.e / LOG_BASE);
        xd = xd.slice();
        i = k - e;
        // If base 1e7 exponents differ...
        if (i) {
            if (i < 0) {
                d = xd;
                i = -i;
                len = yd.length;
            } else {
                d = yd;
                e = k;
                len = xd.length;
            }
            // Limit number of zeros prepended to max(ceil(pr / LOG_BASE), len) + 1.
            k = Math.ceil(pr / LOG_BASE);
            len = k > len ? k + 1 : len + 1;
            if (i > len) {
                i = len;
                d.length = 1;
            }
            // Prepend zeros to equalise exponents. Note: Faster to use reverse then do unshifts.
            d.reverse();
            for(; i--;)d.push(0);
            d.reverse();
        }
        len = xd.length;
        i = yd.length;
        // If yd is longer than xd, swap xd and yd so xd points to the longer array.
        if (len - i < 0) {
            i = len;
            d = yd;
            yd = xd;
            xd = d;
        }
        // Only start adding at yd.length - 1 as the further digits of xd can be left as they are.
        for(carry = 0; i;){
            carry = (xd[--i] = xd[i] + yd[i] + carry) / BASE | 0;
            xd[i] %= BASE;
        }
        if (carry) {
            xd.unshift(carry);
            ++e;
        }
        // Remove trailing zeros.
        // No need to check for zero, as +x + +y != 0 && -x + -y != 0
        for(len = xd.length; xd[--len] == 0;)xd.pop();
        y.d = xd;
        y.e = getBase10Exponent(xd, e);
        return external ? finalise(y, pr, rm) : y;
    };
    /*
   * Return the number of significant digits of the value of this Decimal.
   *
   * [z] {boolean|number} Whether to count integer-part trailing zeros: true, false, 1 or 0.
   *
   */ P.precision = P.sd = function(z) {
        var k, x = this;
        if (z !== void 0 && z !== !!z && z !== 1 && z !== 0) throw Error(invalidArgument + z);
        if (x.d) {
            k = getPrecision(x.d);
            if (z && x.e + 1 > k) k = x.e + 1;
        } else k = NaN;
        return k;
    };
    /*
   * Return a new Decimal whose value is the value of this Decimal rounded to a whole number using
   * rounding mode `rounding`.
   *
   */ P.round = function() {
        var x = this, Ctor = x.constructor;
        return finalise(new Ctor(x), x.e + 1, Ctor.rounding);
    };
    /*
   * Return a new Decimal whose value is the sine of the value in radians of this Decimal.
   *
   * Domain: [-Infinity, Infinity]
   * Range: [-1, 1]
   *
   * sin(x) = x - x^3/3! + x^5/5! - ...
   *
   * sin(0)         = 0
   * sin(-0)        = -0
   * sin(Infinity)  = NaN
   * sin(-Infinity) = NaN
   * sin(NaN)       = NaN
   *
   */ P.sine = P.sin = function() {
        var pr, rm, x = this, Ctor = x.constructor;
        if (!x.isFinite()) return new Ctor(NaN);
        if (x.isZero()) return new Ctor(x);
        pr = Ctor.precision;
        rm = Ctor.rounding;
        Ctor.precision = pr + Math.max(x.e, x.sd()) + LOG_BASE;
        Ctor.rounding = 1;
        x = sine(Ctor, toLessThanHalfPi(Ctor, x));
        Ctor.precision = pr;
        Ctor.rounding = rm;
        return finalise(quadrant > 2 ? x.neg() : x, pr, rm, true);
    };
    /*
   * Return a new Decimal whose value is the square root of this Decimal, rounded to `precision`
   * significant digits using rounding mode `rounding`.
   *
   *  sqrt(-n) =  N
   *  sqrt(N)  =  N
   *  sqrt(-I) =  N
   *  sqrt(I)  =  I
   *  sqrt(0)  =  0
   *  sqrt(-0) = -0
   *
   */ P.squareRoot = P.sqrt = function() {
        var m, n, sd, r, rep, t, x = this, d = x.d, e = x.e, s = x.s, Ctor = x.constructor;
        // Negative/NaN/Infinity/zero?
        if (s !== 1 || !d || !d[0]) return new Ctor(!s || s < 0 && (!d || d[0]) ? NaN : d ? x : 1 / 0);
        external = false;
        // Initial estimate.
        s = Math.sqrt(+x);
        // Math.sqrt underflow/overflow?
        // Pass x to Math.sqrt as integer, then adjust the exponent of the result.
        if (s == 0 || s == 1 / 0) {
            n = digitsToString(d);
            if ((n.length + e) % 2 == 0) n += "0";
            s = Math.sqrt(n);
            e = mathfloor((e + 1) / 2) - (e < 0 || e % 2);
            if (s == 1 / 0) n = "5e" + e;
            else {
                n = s.toExponential();
                n = n.slice(0, n.indexOf("e") + 1) + e;
            }
            r = new Ctor(n);
        } else r = new Ctor(s.toString());
        sd = (e = Ctor.precision) + 3;
        // Newton-Raphson iteration.
        for(;;){
            t = r;
            r = t.plus(divide(x, t, sd + 2, 1)).times(0.5);
            // TODO? Replace with for-loop and checkRoundingDigits.
            if (digitsToString(t.d).slice(0, sd) === (n = digitsToString(r.d)).slice(0, sd)) {
                n = n.slice(sd - 3, sd + 1);
                // The 4th rounding digit may be in error by -1 so if the 4 rounding digits are 9999 or
                // 4999, i.e. approaching a rounding boundary, continue the iteration.
                if (n == "9999" || !rep && n == "4999") {
                    // On the first iteration only, check to see if rounding up gives the exact result as the
                    // nines may infinitely repeat.
                    if (!rep) {
                        finalise(t, e + 1, 0);
                        if (t.times(t).eq(x)) {
                            r = t;
                            break;
                        }
                    }
                    sd += 4;
                    rep = 1;
                } else {
                    // If the rounding digits are null, 0{0,4} or 50{0,3}, check for an exact result.
                    // If not, then there are further digits and m will be truthy.
                    if (!+n || !+n.slice(1) && n.charAt(0) == "5") {
                        // Truncate to the first rounding digit.
                        finalise(r, e + 1, 1);
                        m = !r.times(r).eq(x);
                    }
                    break;
                }
            }
        }
        external = true;
        return finalise(r, e, Ctor.rounding, m);
    };
    /*
   * Return a new Decimal whose value is the tangent of the value in radians of this Decimal.
   *
   * Domain: [-Infinity, Infinity]
   * Range: [-Infinity, Infinity]
   *
   * tan(0)         = 0
   * tan(-0)        = -0
   * tan(Infinity)  = NaN
   * tan(-Infinity) = NaN
   * tan(NaN)       = NaN
   *
   */ P.tangent = P.tan = function() {
        var pr, rm, x = this, Ctor = x.constructor;
        if (!x.isFinite()) return new Ctor(NaN);
        if (x.isZero()) return new Ctor(x);
        pr = Ctor.precision;
        rm = Ctor.rounding;
        Ctor.precision = pr + 10;
        Ctor.rounding = 1;
        x = x.sin();
        x.s = 1;
        x = divide(x, new Ctor(1).minus(x.times(x)).sqrt(), pr + 10, 0);
        Ctor.precision = pr;
        Ctor.rounding = rm;
        return finalise(quadrant == 2 || quadrant == 4 ? x.neg() : x, pr, rm, true);
    };
    /*
   *  n * 0 = 0
   *  n * N = N
   *  n * I = I
   *  0 * n = 0
   *  0 * 0 = 0
   *  0 * N = N
   *  0 * I = N
   *  N * n = N
   *  N * 0 = N
   *  N * N = N
   *  N * I = N
   *  I * n = I
   *  I * 0 = N
   *  I * N = N
   *  I * I = I
   *
   * Return a new Decimal whose value is this Decimal times `y`, rounded to `precision` significant
   * digits using rounding mode `rounding`.
   *
   */ P.times = P.mul = function(y) {
        var carry, e, i, k, r, rL, t, xdL, ydL, x = this, Ctor = x.constructor, xd = x.d, yd = (y = new Ctor(y)).d;
        y.s *= x.s;
        // If either is NaN, ±Infinity or ±0...
        if (!xd || !xd[0] || !yd || !yd[0]) return new Ctor(!y.s || xd && !xd[0] && !yd || yd && !yd[0] && !xd ? NaN : !xd || !yd ? y.s / 0 : y.s * 0);
        e = mathfloor(x.e / LOG_BASE) + mathfloor(y.e / LOG_BASE);
        xdL = xd.length;
        ydL = yd.length;
        // Ensure xd points to the longer array.
        if (xdL < ydL) {
            r = xd;
            xd = yd;
            yd = r;
            rL = xdL;
            xdL = ydL;
            ydL = rL;
        }
        // Initialise the result array with zeros.
        r = [];
        rL = xdL + ydL;
        for(i = rL; i--;)r.push(0);
        // Multiply!
        for(i = ydL; --i >= 0;){
            carry = 0;
            for(k = xdL + i; k > i;){
                t = r[k] + yd[i] * xd[k - i - 1] + carry;
                r[k--] = t % BASE | 0;
                carry = t / BASE | 0;
            }
            r[k] = (r[k] + carry) % BASE | 0;
        }
        // Remove trailing zeros.
        for(; !r[--rL];)r.pop();
        if (carry) ++e;
        else r.shift();
        y.d = r;
        y.e = getBase10Exponent(r, e);
        return external ? finalise(y, Ctor.precision, Ctor.rounding) : y;
    };
    /*
   * Return a string representing the value of this Decimal in base 2, round to `sd` significant
   * digits using rounding mode `rm`.
   *
   * If the optional `sd` argument is present then return binary exponential notation.
   *
   * [sd] {number} Significant digits. Integer, 1 to MAX_DIGITS inclusive.
   * [rm] {number} Rounding mode. Integer, 0 to 8 inclusive.
   *
   */ P.toBinary = function(sd, rm) {
        return toStringBinary(this, 2, sd, rm);
    };
    /*
   * Return a new Decimal whose value is the value of this Decimal rounded to a maximum of `dp`
   * decimal places using rounding mode `rm` or `rounding` if `rm` is omitted.
   *
   * If `dp` is omitted, return a new Decimal whose value is the value of this Decimal.
   *
   * [dp] {number} Decimal places. Integer, 0 to MAX_DIGITS inclusive.
   * [rm] {number} Rounding mode. Integer, 0 to 8 inclusive.
   *
   */ P.toDecimalPlaces = P.toDP = function(dp, rm) {
        var x = this, Ctor = x.constructor;
        x = new Ctor(x);
        if (dp === void 0) return x;
        checkInt32(dp, 0, MAX_DIGITS);
        if (rm === void 0) rm = Ctor.rounding;
        else checkInt32(rm, 0, 8);
        return finalise(x, dp + x.e + 1, rm);
    };
    /*
   * Return a string representing the value of this Decimal in exponential notation rounded to
   * `dp` fixed decimal places using rounding mode `rounding`.
   *
   * [dp] {number} Decimal places. Integer, 0 to MAX_DIGITS inclusive.
   * [rm] {number} Rounding mode. Integer, 0 to 8 inclusive.
   *
   */ P.toExponential = function(dp, rm) {
        var str, x = this, Ctor = x.constructor;
        if (dp === void 0) str = finiteToString(x, true);
        else {
            checkInt32(dp, 0, MAX_DIGITS);
            if (rm === void 0) rm = Ctor.rounding;
            else checkInt32(rm, 0, 8);
            x = finalise(new Ctor(x), dp + 1, rm);
            str = finiteToString(x, true, dp + 1);
        }
        return x.isNeg() && !x.isZero() ? "-" + str : str;
    };
    /*
   * Return a string representing the value of this Decimal in normal (fixed-point) notation to
   * `dp` fixed decimal places and rounded using rounding mode `rm` or `rounding` if `rm` is
   * omitted.
   *
   * As with JavaScript numbers, (-0).toFixed(0) is '0', but e.g. (-0.00001).toFixed(0) is '-0'.
   *
   * [dp] {number} Decimal places. Integer, 0 to MAX_DIGITS inclusive.
   * [rm] {number} Rounding mode. Integer, 0 to 8 inclusive.
   *
   * (-0).toFixed(0) is '0', but (-0.1).toFixed(0) is '-0'.
   * (-0).toFixed(1) is '0.0', but (-0.01).toFixed(1) is '-0.0'.
   * (-0).toFixed(3) is '0.000'.
   * (-0.5).toFixed(0) is '-0'.
   *
   */ P.toFixed = function(dp, rm) {
        var str, y, x = this, Ctor = x.constructor;
        if (dp === void 0) str = finiteToString(x);
        else {
            checkInt32(dp, 0, MAX_DIGITS);
            if (rm === void 0) rm = Ctor.rounding;
            else checkInt32(rm, 0, 8);
            y = finalise(new Ctor(x), dp + x.e + 1, rm);
            str = finiteToString(y, false, dp + y.e + 1);
        }
        // To determine whether to add the minus sign look at the value before it was rounded,
        // i.e. look at `x` rather than `y`.
        return x.isNeg() && !x.isZero() ? "-" + str : str;
    };
    /*
   * Return an array representing the value of this Decimal as a simple fraction with an integer
   * numerator and an integer denominator.
   *
   * The denominator will be a positive non-zero value less than or equal to the specified maximum
   * denominator. If a maximum denominator is not specified, the denominator will be the lowest
   * value necessary to represent the number exactly.
   *
   * [maxD] {number|string|Decimal} Maximum denominator. Integer >= 1 and < Infinity.
   *
   */ P.toFraction = function(maxD) {
        var d, d0, d1, d2, e, k, n, n0, n1, pr, q, r, x = this, xd = x.d, Ctor = x.constructor;
        if (!xd) return new Ctor(x);
        n1 = d0 = new Ctor(1);
        d1 = n0 = new Ctor(0);
        d = new Ctor(d1);
        e = d.e = getPrecision(xd) - x.e - 1;
        k = e % LOG_BASE;
        d.d[0] = mathpow(10, k < 0 ? LOG_BASE + k : k);
        if (maxD == null) // d is 10**e, the minimum max-denominator needed.
        maxD = e > 0 ? d : n1;
        else {
            n = new Ctor(maxD);
            if (!n.isInt() || n.lt(n1)) throw Error(invalidArgument + n);
            maxD = n.gt(d) ? e > 0 ? d : n1 : n;
        }
        external = false;
        n = new Ctor(digitsToString(xd));
        pr = Ctor.precision;
        Ctor.precision = e = xd.length * LOG_BASE * 2;
        for(;;){
            q = divide(n, d, 0, 1, 1);
            d2 = d0.plus(q.times(d1));
            if (d2.cmp(maxD) == 1) break;
            d0 = d1;
            d1 = d2;
            d2 = n1;
            n1 = n0.plus(q.times(d2));
            n0 = d2;
            d2 = d;
            d = n.minus(q.times(d2));
            n = d2;
        }
        d2 = divide(maxD.minus(d0), d1, 0, 1, 1);
        n0 = n0.plus(d2.times(n1));
        d0 = d0.plus(d2.times(d1));
        n0.s = n1.s = x.s;
        // Determine which fraction is closer to x, n0/d0 or n1/d1?
        r = divide(n1, d1, e, 1).minus(x).abs().cmp(divide(n0, d0, e, 1).minus(x).abs()) < 1 ? [
            n1,
            d1
        ] : [
            n0,
            d0
        ];
        Ctor.precision = pr;
        external = true;
        return r;
    };
    /*
   * Return a string representing the value of this Decimal in base 16, round to `sd` significant
   * digits using rounding mode `rm`.
   *
   * If the optional `sd` argument is present then return binary exponential notation.
   *
   * [sd] {number} Significant digits. Integer, 1 to MAX_DIGITS inclusive.
   * [rm] {number} Rounding mode. Integer, 0 to 8 inclusive.
   *
   */ P.toHexadecimal = P.toHex = function(sd, rm) {
        return toStringBinary(this, 16, sd, rm);
    };
    /*
   * Returns a new Decimal whose value is the nearest multiple of `y` in the direction of rounding
   * mode `rm`, or `Decimal.rounding` if `rm` is omitted, to the value of this Decimal.
   *
   * The return value will always have the same sign as this Decimal, unless either this Decimal
   * or `y` is NaN, in which case the return value will be also be NaN.
   *
   * The return value is not affected by the value of `precision`.
   *
   * y {number|string|Decimal} The magnitude to round to a multiple of.
   * [rm] {number} Rounding mode. Integer, 0 to 8 inclusive.
   *
   * 'toNearest() rounding mode not an integer: {rm}'
   * 'toNearest() rounding mode out of range: {rm}'
   *
   */ P.toNearest = function(y, rm) {
        var x = this, Ctor = x.constructor;
        x = new Ctor(x);
        if (y == null) {
            // If x is not finite, return x.
            if (!x.d) return x;
            y = new Ctor(1);
            rm = Ctor.rounding;
        } else {
            y = new Ctor(y);
            if (rm === void 0) rm = Ctor.rounding;
            else checkInt32(rm, 0, 8);
            // If x is not finite, return x if y is not NaN, else NaN.
            if (!x.d) return y.s ? x : y;
            // If y is not finite, return Infinity with the sign of x if y is Infinity, else NaN.
            if (!y.d) {
                if (y.s) y.s = x.s;
                return y;
            }
        }
        // If y is not zero, calculate the nearest multiple of y to x.
        if (y.d[0]) {
            external = false;
            x = divide(x, y, 0, rm, 1).times(y);
            external = true;
            finalise(x);
        // If y is zero, return zero with the sign of x.
        } else {
            y.s = x.s;
            x = y;
        }
        return x;
    };
    /*
   * Return the value of this Decimal converted to a number primitive.
   * Zero keeps its sign.
   *
   */ P.toNumber = function() {
        return +this;
    };
    /*
   * Return a string representing the value of this Decimal in base 8, round to `sd` significant
   * digits using rounding mode `rm`.
   *
   * If the optional `sd` argument is present then return binary exponential notation.
   *
   * [sd] {number} Significant digits. Integer, 1 to MAX_DIGITS inclusive.
   * [rm] {number} Rounding mode. Integer, 0 to 8 inclusive.
   *
   */ P.toOctal = function(sd, rm) {
        return toStringBinary(this, 8, sd, rm);
    };
    /*
   * Return a new Decimal whose value is the value of this Decimal raised to the power `y`, rounded
   * to `precision` significant digits using rounding mode `rounding`.
   *
   * ECMAScript compliant.
   *
   *   pow(x, NaN)                           = NaN
   *   pow(x, ±0)                            = 1

   *   pow(NaN, non-zero)                    = NaN
   *   pow(abs(x) > 1, +Infinity)            = +Infinity
   *   pow(abs(x) > 1, -Infinity)            = +0
   *   pow(abs(x) == 1, ±Infinity)           = NaN
   *   pow(abs(x) < 1, +Infinity)            = +0
   *   pow(abs(x) < 1, -Infinity)            = +Infinity
   *   pow(+Infinity, y > 0)                 = +Infinity
   *   pow(+Infinity, y < 0)                 = +0
   *   pow(-Infinity, odd integer > 0)       = -Infinity
   *   pow(-Infinity, even integer > 0)      = +Infinity
   *   pow(-Infinity, odd integer < 0)       = -0
   *   pow(-Infinity, even integer < 0)      = +0
   *   pow(+0, y > 0)                        = +0
   *   pow(+0, y < 0)                        = +Infinity
   *   pow(-0, odd integer > 0)              = -0
   *   pow(-0, even integer > 0)             = +0
   *   pow(-0, odd integer < 0)              = -Infinity
   *   pow(-0, even integer < 0)             = +Infinity
   *   pow(finite x < 0, finite non-integer) = NaN
   *
   * For non-integer or very large exponents pow(x, y) is calculated using
   *
   *   x^y = exp(y*ln(x))
   *
   * Assuming the first 15 rounding digits are each equally likely to be any digit 0-9, the
   * probability of an incorrectly rounded result
   * P([49]9{14} | [50]0{14}) = 2 * 0.2 * 10^-14 = 4e-15 = 1/2.5e+14
   * i.e. 1 in 250,000,000,000,000
   *
   * If a result is incorrectly rounded the maximum error will be 1 ulp (unit in last place).
   *
   * y {number|string|Decimal} The power to which to raise this Decimal.
   *
   */ P.toPower = P.pow = function(y) {
        var e, k, pr, r, rm, s, x = this, Ctor = x.constructor, yn = +(y = new Ctor(y));
        // Either ±Infinity, NaN or ±0?
        if (!x.d || !y.d || !x.d[0] || !y.d[0]) return new Ctor(mathpow(+x, yn));
        x = new Ctor(x);
        if (x.eq(1)) return x;
        pr = Ctor.precision;
        rm = Ctor.rounding;
        if (y.eq(1)) return finalise(x, pr, rm);
        // y exponent
        e = mathfloor(y.e / LOG_BASE);
        // If y is a small integer use the 'exponentiation by squaring' algorithm.
        if (e >= y.d.length - 1 && (k = yn < 0 ? -yn : yn) <= MAX_SAFE_INTEGER) {
            r = intPow(Ctor, x, k, pr);
            return y.s < 0 ? new Ctor(1).div(r) : finalise(r, pr, rm);
        }
        s = x.s;
        // if x is negative
        if (s < 0) {
            // if y is not an integer
            if (e < y.d.length - 1) return new Ctor(NaN);
            // Result is positive if x is negative and the last digit of integer y is even.
            if ((y.d[e] & 1) == 0) s = 1;
            // if x.eq(-1)
            if (x.e == 0 && x.d[0] == 1 && x.d.length == 1) {
                x.s = s;
                return x;
            }
        }
        // Estimate result exponent.
        // x^y = 10^e,  where e = y * log10(x)
        // log10(x) = log10(x_significand) + x_exponent
        // log10(x_significand) = ln(x_significand) / ln(10)
        k = mathpow(+x, yn);
        e = k == 0 || !isFinite(k) ? mathfloor(yn * (Math.log("0." + digitsToString(x.d)) / Math.LN10 + x.e + 1)) : new Ctor(k + "").e;
        // Exponent estimate may be incorrect e.g. x: 0.999999999999999999, y: 2.29, e: 0, r.e: -1.
        // Overflow/underflow?
        if (e > Ctor.maxE + 1 || e < Ctor.minE - 1) return new Ctor(e > 0 ? s / 0 : 0);
        external = false;
        Ctor.rounding = x.s = 1;
        // Estimate the extra guard digits needed to ensure five correct rounding digits from
        // naturalLogarithm(x). Example of failure without these extra digits (precision: 10):
        // new Decimal(2.32456).pow('2087987436534566.46411')
        // should be 1.162377823e+764914905173815, but is 1.162355823e+764914905173815
        k = Math.min(12, (e + "").length);
        // r = x^y = exp(y*ln(x))
        r = naturalExponential(y.times(naturalLogarithm(x, pr + k)), pr);
        // r may be Infinity, e.g. (0.9999999999999999).pow(-1e+40)
        if (r.d) {
            // Truncate to the required precision plus five rounding digits.
            r = finalise(r, pr + 5, 1);
            // If the rounding digits are [49]9999 or [50]0000 increase the precision by 10 and recalculate
            // the result.
            if (checkRoundingDigits(r.d, pr, rm)) {
                e = pr + 10;
                // Truncate to the increased precision plus five rounding digits.
                r = finalise(naturalExponential(y.times(naturalLogarithm(x, e + k)), e), e + 5, 1);
                // Check for 14 nines from the 2nd rounding digit (the first rounding digit may be 4 or 9).
                if (+digitsToString(r.d).slice(pr + 1, pr + 15) + 1 == 1e14) r = finalise(r, pr + 1, 0);
            }
        }
        r.s = s;
        external = true;
        Ctor.rounding = rm;
        return finalise(r, pr, rm);
    };
    /*
   * Return a string representing the value of this Decimal rounded to `sd` significant digits
   * using rounding mode `rounding`.
   *
   * Return exponential notation if `sd` is less than the number of digits necessary to represent
   * the integer part of the value in normal notation.
   *
   * [sd] {number} Significant digits. Integer, 1 to MAX_DIGITS inclusive.
   * [rm] {number} Rounding mode. Integer, 0 to 8 inclusive.
   *
   */ P.toPrecision = function(sd, rm) {
        var str, x = this, Ctor = x.constructor;
        if (sd === void 0) str = finiteToString(x, x.e <= Ctor.toExpNeg || x.e >= Ctor.toExpPos);
        else {
            checkInt32(sd, 1, MAX_DIGITS);
            if (rm === void 0) rm = Ctor.rounding;
            else checkInt32(rm, 0, 8);
            x = finalise(new Ctor(x), sd, rm);
            str = finiteToString(x, sd <= x.e || x.e <= Ctor.toExpNeg, sd);
        }
        return x.isNeg() && !x.isZero() ? "-" + str : str;
    };
    /*
   * Return a new Decimal whose value is the value of this Decimal rounded to a maximum of `sd`
   * significant digits using rounding mode `rm`, or to `precision` and `rounding` respectively if
   * omitted.
   *
   * [sd] {number} Significant digits. Integer, 1 to MAX_DIGITS inclusive.
   * [rm] {number} Rounding mode. Integer, 0 to 8 inclusive.
   *
   * 'toSD() digits out of range: {sd}'
   * 'toSD() digits not an integer: {sd}'
   * 'toSD() rounding mode not an integer: {rm}'
   * 'toSD() rounding mode out of range: {rm}'
   *
   */ P.toSignificantDigits = P.toSD = function(sd, rm) {
        var x = this, Ctor = x.constructor;
        if (sd === void 0) {
            sd = Ctor.precision;
            rm = Ctor.rounding;
        } else {
            checkInt32(sd, 1, MAX_DIGITS);
            if (rm === void 0) rm = Ctor.rounding;
            else checkInt32(rm, 0, 8);
        }
        return finalise(new Ctor(x), sd, rm);
    };
    /*
   * Return a string representing the value of this Decimal.
   *
   * Return exponential notation if this Decimal has a positive exponent equal to or greater than
   * `toExpPos`, or a negative exponent equal to or less than `toExpNeg`.
   *
   */ P.toString = function() {
        var x = this, Ctor = x.constructor, str = finiteToString(x, x.e <= Ctor.toExpNeg || x.e >= Ctor.toExpPos);
        return x.isNeg() && !x.isZero() ? "-" + str : str;
    };
    /*
   * Return a new Decimal whose value is the value of this Decimal truncated to a whole number.
   *
   */ P.truncated = P.trunc = function() {
        return finalise(new this.constructor(this), this.e + 1, 1);
    };
    /*
   * Return a string representing the value of this Decimal.
   * Unlike `toString`, negative zero will include the minus sign.
   *
   */ P.valueOf = P.toJSON = function() {
        var x = this, Ctor = x.constructor, str = finiteToString(x, x.e <= Ctor.toExpNeg || x.e >= Ctor.toExpPos);
        return x.isNeg() ? "-" + str : str;
    };
    // Helper functions for Decimal.prototype (P) and/or Decimal methods, and their callers.
    /*
   *  digitsToString           P.cubeRoot, P.logarithm, P.squareRoot, P.toFraction, P.toPower,
   *                           finiteToString, naturalExponential, naturalLogarithm
   *  checkInt32               P.toDecimalPlaces, P.toExponential, P.toFixed, P.toNearest,
   *                           P.toPrecision, P.toSignificantDigits, toStringBinary, random
   *  checkRoundingDigits      P.logarithm, P.toPower, naturalExponential, naturalLogarithm
   *  convertBase              toStringBinary, parseOther
   *  cos                      P.cos
   *  divide                   P.atanh, P.cubeRoot, P.dividedBy, P.dividedToIntegerBy,
   *                           P.logarithm, P.modulo, P.squareRoot, P.tan, P.tanh, P.toFraction,
   *                           P.toNearest, toStringBinary, naturalExponential, naturalLogarithm,
   *                           taylorSeries, atan2, parseOther
   *  finalise                 P.absoluteValue, P.atan, P.atanh, P.ceil, P.cos, P.cosh,
   *                           P.cubeRoot, P.dividedToIntegerBy, P.floor, P.logarithm, P.minus,
   *                           P.modulo, P.negated, P.plus, P.round, P.sin, P.sinh, P.squareRoot,
   *                           P.tan, P.times, P.toDecimalPlaces, P.toExponential, P.toFixed,
   *                           P.toNearest, P.toPower, P.toPrecision, P.toSignificantDigits,
   *                           P.truncated, divide, getLn10, getPi, naturalExponential,
   *                           naturalLogarithm, ceil, floor, round, trunc
   *  finiteToString           P.toExponential, P.toFixed, P.toPrecision, P.toString, P.valueOf,
   *                           toStringBinary
   *  getBase10Exponent        P.minus, P.plus, P.times, parseOther
   *  getLn10                  P.logarithm, naturalLogarithm
   *  getPi                    P.acos, P.asin, P.atan, toLessThanHalfPi, atan2
   *  getPrecision             P.precision, P.toFraction
   *  getZeroString            digitsToString, finiteToString
   *  intPow                   P.toPower, parseOther
   *  isOdd                    toLessThanHalfPi
   *  maxOrMin                 max, min
   *  naturalExponential       P.naturalExponential, P.toPower
   *  naturalLogarithm         P.acosh, P.asinh, P.atanh, P.logarithm, P.naturalLogarithm,
   *                           P.toPower, naturalExponential
   *  nonFiniteToString        finiteToString, toStringBinary
   *  parseDecimal             Decimal
   *  parseOther               Decimal
   *  sin                      P.sin
   *  taylorSeries             P.cosh, P.sinh, cos, sin
   *  toLessThanHalfPi         P.cos, P.sin
   *  toStringBinary           P.toBinary, P.toHexadecimal, P.toOctal
   *  truncate                 intPow
   *
   *  Throws:                  P.logarithm, P.precision, P.toFraction, checkInt32, getLn10, getPi,
   *                           naturalLogarithm, config, parseOther, random, Decimal
   */ function digitsToString(d) {
        var i, k, ws, indexOfLastWord = d.length - 1, str = "", w = d[0];
        if (indexOfLastWord > 0) {
            str += w;
            for(i = 1; i < indexOfLastWord; i++){
                ws = d[i] + "";
                k = LOG_BASE - ws.length;
                if (k) str += getZeroString(k);
                str += ws;
            }
            w = d[i];
            ws = w + "";
            k = LOG_BASE - ws.length;
            if (k) str += getZeroString(k);
        } else if (w === 0) return "0";
        // Remove trailing zeros of last w.
        for(; w % 10 === 0;)w /= 10;
        return str + w;
    }
    function checkInt32(i, min, max) {
        if (i !== ~~i || i < min || i > max) throw Error(invalidArgument + i);
    }
    /*
   * Check 5 rounding digits if `repeating` is null, 4 otherwise.
   * `repeating == null` if caller is `log` or `pow`,
   * `repeating != null` if caller is `naturalLogarithm` or `naturalExponential`.
   */ function checkRoundingDigits(d, i, rm, repeating) {
        var di, k, r, rd;
        // Get the length of the first word of the array d.
        for(k = d[0]; k >= 10; k /= 10)--i;
        // Is the rounding digit in the first word of d?
        if (--i < 0) {
            i += LOG_BASE;
            di = 0;
        } else {
            di = Math.ceil((i + 1) / LOG_BASE);
            i %= LOG_BASE;
        }
        // i is the index (0 - 6) of the rounding digit.
        // E.g. if within the word 3487563 the first rounding digit is 5,
        // then i = 4, k = 1000, rd = 3487563 % 1000 = 563
        k = mathpow(10, LOG_BASE - i);
        rd = d[di] % k | 0;
        if (repeating == null) {
            if (i < 3) {
                if (i == 0) rd = rd / 100 | 0;
                else if (i == 1) rd = rd / 10 | 0;
                r = rm < 4 && rd == 99999 || rm > 3 && rd == 49999 || rd == 50000 || rd == 0;
            } else r = (rm < 4 && rd + 1 == k || rm > 3 && rd + 1 == k / 2) && (d[di + 1] / k / 100 | 0) == mathpow(10, i - 2) - 1 || (rd == k / 2 || rd == 0) && (d[di + 1] / k / 100 | 0) == 0;
        } else if (i < 4) {
            if (i == 0) rd = rd / 1000 | 0;
            else if (i == 1) rd = rd / 100 | 0;
            else if (i == 2) rd = rd / 10 | 0;
            r = (repeating || rm < 4) && rd == 9999 || !repeating && rm > 3 && rd == 4999;
        } else r = ((repeating || rm < 4) && rd + 1 == k || !repeating && rm > 3 && rd + 1 == k / 2) && (d[di + 1] / k / 1000 | 0) == mathpow(10, i - 3) - 1;
        return r;
    }
    // Convert string of `baseIn` to an array of numbers of `baseOut`.
    // Eg. convertBase('255', 10, 16) returns [15, 15].
    // Eg. convertBase('ff', 16, 10) returns [2, 5, 5].
    function convertBase(str, baseIn, baseOut) {
        var j, arr = [
            0
        ], arrL, i = 0, strL = str.length;
        for(; i < strL;){
            for(arrL = arr.length; arrL--;)arr[arrL] *= baseIn;
            arr[0] += NUMERALS.indexOf(str.charAt(i++));
            for(j = 0; j < arr.length; j++)if (arr[j] > baseOut - 1) {
                if (arr[j + 1] === void 0) arr[j + 1] = 0;
                arr[j + 1] += arr[j] / baseOut | 0;
                arr[j] %= baseOut;
            }
        }
        return arr.reverse();
    }
    /*
   * cos(x) = 1 - x^2/2! + x^4/4! - ...
   * |x| < pi/2
   *
   */ function cosine(Ctor, x) {
        var k, len, y;
        if (x.isZero()) return x;
        // Argument reduction: cos(4x) = 8*(cos^4(x) - cos^2(x)) + 1
        // i.e. cos(x) = 8*(cos^4(x/4) - cos^2(x/4)) + 1
        // Estimate the optimum number of times to use the argument reduction.
        len = x.d.length;
        if (len < 32) {
            k = Math.ceil(len / 3);
            y = (1 / tinyPow(4, k)).toString();
        } else {
            k = 16;
            y = "2.3283064365386962890625e-10";
        }
        Ctor.precision += k;
        x = taylorSeries(Ctor, 1, x.times(y), new Ctor(1));
        // Reverse argument reduction
        for(var i = k; i--;){
            var cos2x = x.times(x);
            x = cos2x.times(cos2x).minus(cos2x).times(8).plus(1);
        }
        Ctor.precision -= k;
        return x;
    }
    /*
   * Perform division in the specified base.
   */ var divide = function() {
        // Assumes non-zero x and k, and hence non-zero result.
        function multiplyInteger(x, k, base) {
            var temp, carry = 0, i = x.length;
            for(x = x.slice(); i--;){
                temp = x[i] * k + carry;
                x[i] = temp % base | 0;
                carry = temp / base | 0;
            }
            if (carry) x.unshift(carry);
            return x;
        }
        function compare(a, b, aL, bL) {
            var i, r;
            if (aL != bL) r = aL > bL ? 1 : -1;
            else {
                for(i = r = 0; i < aL; i++)if (a[i] != b[i]) {
                    r = a[i] > b[i] ? 1 : -1;
                    break;
                }
            }
            return r;
        }
        function subtract(a, b, aL, base) {
            var i = 0;
            // Subtract b from a.
            for(; aL--;){
                a[aL] -= i;
                i = a[aL] < b[aL] ? 1 : 0;
                a[aL] = i * base + a[aL] - b[aL];
            }
            // Remove leading zeros.
            for(; !a[0] && a.length > 1;)a.shift();
        }
        return function(x, y, pr, rm, dp, base) {
            var cmp, e, i, k, logBase, more, prod, prodL, q, qd, rem, remL, rem0, sd, t, xi, xL, yd0, yL, yz, Ctor = x.constructor, sign = x.s == y.s ? 1 : -1, xd = x.d, yd = y.d;
            // Either NaN, Infinity or 0?
            if (!xd || !xd[0] || !yd || !yd[0]) return new Ctor(!x.s || !y.s || (xd ? yd && xd[0] == yd[0] : !yd) ? NaN : // Return ±0 if x is 0 or y is ±Infinity, or return ±Infinity as y is 0.
            xd && xd[0] == 0 || !yd ? sign * 0 : sign / 0);
            if (base) {
                logBase = 1;
                e = x.e - y.e;
            } else {
                base = BASE;
                logBase = LOG_BASE;
                e = mathfloor(x.e / logBase) - mathfloor(y.e / logBase);
            }
            yL = yd.length;
            xL = xd.length;
            q = new Ctor(sign);
            qd = q.d = [];
            // Result exponent may be one less than e.
            // The digit array of a Decimal from toStringBinary may have trailing zeros.
            for(i = 0; yd[i] == (xd[i] || 0); i++);
            if (yd[i] > (xd[i] || 0)) e--;
            if (pr == null) {
                sd = pr = Ctor.precision;
                rm = Ctor.rounding;
            } else if (dp) sd = pr + (x.e - y.e) + 1;
            else sd = pr;
            if (sd < 0) {
                qd.push(1);
                more = true;
            } else {
                // Convert precision in number of base 10 digits to base 1e7 digits.
                sd = sd / logBase + 2 | 0;
                i = 0;
                // divisor < 1e7
                if (yL == 1) {
                    k = 0;
                    yd = yd[0];
                    sd++;
                    // k is the carry.
                    for(; (i < xL || k) && sd--; i++){
                        t = k * base + (xd[i] || 0);
                        qd[i] = t / yd | 0;
                        k = t % yd | 0;
                    }
                    more = k || i < xL;
                // divisor >= 1e7
                } else {
                    // Normalise xd and yd so highest order digit of yd is >= base/2
                    k = base / (yd[0] + 1) | 0;
                    if (k > 1) {
                        yd = multiplyInteger(yd, k, base);
                        xd = multiplyInteger(xd, k, base);
                        yL = yd.length;
                        xL = xd.length;
                    }
                    xi = yL;
                    rem = xd.slice(0, yL);
                    remL = rem.length;
                    // Add zeros to make remainder as long as divisor.
                    for(; remL < yL;)rem[remL++] = 0;
                    yz = yd.slice();
                    yz.unshift(0);
                    yd0 = yd[0];
                    if (yd[1] >= base / 2) ++yd0;
                    do {
                        k = 0;
                        // Compare divisor and remainder.
                        cmp = compare(yd, rem, yL, remL);
                        // If divisor < remainder.
                        if (cmp < 0) {
                            // Calculate trial digit, k.
                            rem0 = rem[0];
                            if (yL != remL) rem0 = rem0 * base + (rem[1] || 0);
                            // k will be how many times the divisor goes into the current remainder.
                            k = rem0 / yd0 | 0;
                            //  Algorithm:
                            //  1. product = divisor * trial digit (k)
                            //  2. if product > remainder: product -= divisor, k--
                            //  3. remainder -= product
                            //  4. if product was < remainder at 2:
                            //    5. compare new remainder and divisor
                            //    6. If remainder > divisor: remainder -= divisor, k++
                            if (k > 1) {
                                if (k >= base) k = base - 1;
                                // product = divisor * trial digit.
                                prod = multiplyInteger(yd, k, base);
                                prodL = prod.length;
                                remL = rem.length;
                                // Compare product and remainder.
                                cmp = compare(prod, rem, prodL, remL);
                                // product > remainder.
                                if (cmp == 1) {
                                    k--;
                                    // Subtract divisor from product.
                                    subtract(prod, yL < prodL ? yz : yd, prodL, base);
                                }
                            } else {
                                // cmp is -1.
                                // If k is 0, there is no need to compare yd and rem again below, so change cmp to 1
                                // to avoid it. If k is 1 there is a need to compare yd and rem again below.
                                if (k == 0) cmp = k = 1;
                                prod = yd.slice();
                            }
                            prodL = prod.length;
                            if (prodL < remL) prod.unshift(0);
                            // Subtract product from remainder.
                            subtract(rem, prod, remL, base);
                            // If product was < previous remainder.
                            if (cmp == -1) {
                                remL = rem.length;
                                // Compare divisor and new remainder.
                                cmp = compare(yd, rem, yL, remL);
                                // If divisor < new remainder, subtract divisor from remainder.
                                if (cmp < 1) {
                                    k++;
                                    // Subtract divisor from remainder.
                                    subtract(rem, yL < remL ? yz : yd, remL, base);
                                }
                            }
                            remL = rem.length;
                        } else if (cmp === 0) {
                            k++;
                            rem = [
                                0
                            ];
                        } // if cmp === 1, k will be 0
                        // Add the next digit, k, to the result array.
                        qd[i++] = k;
                        // Update the remainder.
                        if (cmp && rem[0]) rem[remL++] = xd[xi] || 0;
                        else {
                            rem = [
                                xd[xi]
                            ];
                            remL = 1;
                        }
                    }while ((xi++ < xL || rem[0] !== void 0) && sd--);
                    more = rem[0] !== void 0;
                }
                // Leading zero?
                if (!qd[0]) qd.shift();
            }
            // logBase is 1 when divide is being used for base conversion.
            if (logBase == 1) {
                q.e = e;
                inexact = more;
            } else {
                // To calculate q.e, first get the number of digits of qd[0].
                for(i = 1, k = qd[0]; k >= 10; k /= 10)i++;
                q.e = i + e * logBase - 1;
                finalise(q, dp ? pr + q.e + 1 : pr, rm, more);
            }
            return q;
        };
    }();
    /*
   * Round `x` to `sd` significant digits using rounding mode `rm`.
   * Check for over/under-flow.
   */ function finalise(x, sd, rm, isTruncated) {
        var digits, i, j, k, rd, roundUp, w, xd, xdi, Ctor = x.constructor;
        // Don't round if sd is null or undefined.
        out: if (sd != null) {
            xd = x.d;
            // Infinity/NaN.
            if (!xd) return x;
            // rd: the rounding digit, i.e. the digit after the digit that may be rounded up.
            // w: the word of xd containing rd, a base 1e7 number.
            // xdi: the index of w within xd.
            // digits: the number of digits of w.
            // i: what would be the index of rd within w if all the numbers were 7 digits long (i.e. if
            // they had leading zeros)
            // j: if > 0, the actual index of rd within w (if < 0, rd is a leading zero).
            // Get the length of the first word of the digits array xd.
            for(digits = 1, k = xd[0]; k >= 10; k /= 10)digits++;
            i = sd - digits;
            // Is the rounding digit in the first word of xd?
            if (i < 0) {
                i += LOG_BASE;
                j = sd;
                w = xd[xdi = 0];
                // Get the rounding digit at index j of w.
                rd = w / mathpow(10, digits - j - 1) % 10 | 0;
            } else {
                xdi = Math.ceil((i + 1) / LOG_BASE);
                k = xd.length;
                if (xdi >= k) {
                    if (isTruncated) {
                        // Needed by `naturalExponential`, `naturalLogarithm` and `squareRoot`.
                        for(; k++ <= xdi;)xd.push(0);
                        w = rd = 0;
                        digits = 1;
                        i %= LOG_BASE;
                        j = i - LOG_BASE + 1;
                    } else break out;
                } else {
                    w = k = xd[xdi];
                    // Get the number of digits of w.
                    for(digits = 1; k >= 10; k /= 10)digits++;
                    // Get the index of rd within w.
                    i %= LOG_BASE;
                    // Get the index of rd within w, adjusted for leading zeros.
                    // The number of leading zeros of w is given by LOG_BASE - digits.
                    j = i - LOG_BASE + digits;
                    // Get the rounding digit at index j of w.
                    rd = j < 0 ? 0 : w / mathpow(10, digits - j - 1) % 10 | 0;
                }
            }
            // Are there any non-zero digits after the rounding digit?
            isTruncated = isTruncated || sd < 0 || xd[xdi + 1] !== void 0 || (j < 0 ? w : w % mathpow(10, digits - j - 1));
            // The expression `w % mathpow(10, digits - j - 1)` returns all the digits of w to the right
            // of the digit at (left-to-right) index j, e.g. if w is 908714 and j is 2, the expression
            // will give 714.
            roundUp = rm < 4 ? (rd || isTruncated) && (rm == 0 || rm == (x.s < 0 ? 3 : 2)) : rd > 5 || rd == 5 && (rm == 4 || isTruncated || rm == 6 && (i > 0 ? j > 0 ? w / mathpow(10, digits - j) : 0 : xd[xdi - 1]) % 10 & 1 || rm == (x.s < 0 ? 8 : 7));
            if (sd < 1 || !xd[0]) {
                xd.length = 0;
                if (roundUp) {
                    // Convert sd to decimal places.
                    sd -= x.e + 1;
                    // 1, 0.1, 0.01, 0.001, 0.0001 etc.
                    xd[0] = mathpow(10, (LOG_BASE - sd % LOG_BASE) % LOG_BASE);
                    x.e = -sd || 0;
                } else // Zero.
                xd[0] = x.e = 0;
                return x;
            }
            // Remove excess digits.
            if (i == 0) {
                xd.length = xdi;
                k = 1;
                xdi--;
            } else {
                xd.length = xdi + 1;
                k = mathpow(10, LOG_BASE - i);
                // E.g. 56700 becomes 56000 if 7 is the rounding digit.
                // j > 0 means i > number of leading zeros of w.
                xd[xdi] = j > 0 ? (w / mathpow(10, digits - j) % mathpow(10, j) | 0) * k : 0;
            }
            if (roundUp) {
                for(;;)// Is the digit to be rounded up in the first word of xd?
                if (xdi == 0) {
                    // i will be the length of xd[0] before k is added.
                    for(i = 1, j = xd[0]; j >= 10; j /= 10)i++;
                    j = xd[0] += k;
                    for(k = 1; j >= 10; j /= 10)k++;
                    // if i != k the length has increased.
                    if (i != k) {
                        x.e++;
                        if (xd[0] == BASE) xd[0] = 1;
                    }
                    break;
                } else {
                    xd[xdi] += k;
                    if (xd[xdi] != BASE) break;
                    xd[xdi--] = 0;
                    k = 1;
                }
            }
            // Remove trailing zeros.
            for(i = xd.length; xd[--i] === 0;)xd.pop();
        }
        if (external) {
            // Overflow?
            if (x.e > Ctor.maxE) {
                // Infinity.
                x.d = null;
                x.e = NaN;
            // Underflow?
            } else if (x.e < Ctor.minE) {
                // Zero.
                x.e = 0;
                x.d = [
                    0
                ];
            // Ctor.underflow = true;
            } // else Ctor.underflow = false;
        }
        return x;
    }
    function finiteToString(x, isExp, sd) {
        if (!x.isFinite()) return nonFiniteToString(x);
        var k, e = x.e, str = digitsToString(x.d), len = str.length;
        if (isExp) {
            if (sd && (k = sd - len) > 0) str = str.charAt(0) + "." + str.slice(1) + getZeroString(k);
            else if (len > 1) str = str.charAt(0) + "." + str.slice(1);
            str = str + (x.e < 0 ? "e" : "e+") + x.e;
        } else if (e < 0) {
            str = "0." + getZeroString(-e - 1) + str;
            if (sd && (k = sd - len) > 0) str += getZeroString(k);
        } else if (e >= len) {
            str += getZeroString(e + 1 - len);
            if (sd && (k = sd - e - 1) > 0) str = str + "." + getZeroString(k);
        } else {
            if ((k = e + 1) < len) str = str.slice(0, k) + "." + str.slice(k);
            if (sd && (k = sd - len) > 0) {
                if (e + 1 === len) str += ".";
                str += getZeroString(k);
            }
        }
        return str;
    }
    // Calculate the base 10 exponent from the base 1e7 exponent.
    function getBase10Exponent(digits, e) {
        var w = digits[0];
        // Add the number of digits of the first word of the digits array.
        for(e *= LOG_BASE; w >= 10; w /= 10)e++;
        return e;
    }
    function getLn10(Ctor, sd, pr) {
        if (sd > LN10_PRECISION) {
            // Reset global state in case the exception is caught.
            external = true;
            if (pr) Ctor.precision = pr;
            throw Error(precisionLimitExceeded);
        }
        return finalise(new Ctor(LN10), sd, 1, true);
    }
    function getPi(Ctor, sd, rm) {
        if (sd > PI_PRECISION) throw Error(precisionLimitExceeded);
        return finalise(new Ctor(PI), sd, rm, true);
    }
    function getPrecision(digits) {
        var w = digits.length - 1, len = w * LOG_BASE + 1;
        w = digits[w];
        // If non-zero...
        if (w) {
            // Subtract the number of trailing zeros of the last word.
            for(; w % 10 == 0; w /= 10)len--;
            // Add the number of digits of the first word.
            for(w = digits[0]; w >= 10; w /= 10)len++;
        }
        return len;
    }
    function getZeroString(k) {
        var zs = "";
        for(; k--;)zs += "0";
        return zs;
    }
    /*
   * Return a new Decimal whose value is the value of Decimal `x` to the power `n`, where `n` is an
   * integer of type number.
   *
   * Implements 'exponentiation by squaring'. Called by `pow` and `parseOther`.
   *
   */ function intPow(Ctor, x, n, pr) {
        var isTruncated, r = new Ctor(1), // Max n of 9007199254740991 takes 53 loop iterations.
        // Maximum digits array length; leaves [28, 34] guard digits.
        k = Math.ceil(pr / LOG_BASE + 4);
        external = false;
        for(;;){
            if (n % 2) {
                r = r.times(x);
                if (truncate(r.d, k)) isTruncated = true;
            }
            n = mathfloor(n / 2);
            if (n === 0) {
                // To ensure correct rounding when r.d is truncated, increment the last word if it is zero.
                n = r.d.length - 1;
                if (isTruncated && r.d[n] === 0) ++r.d[n];
                break;
            }
            x = x.times(x);
            truncate(x.d, k);
        }
        external = true;
        return r;
    }
    function isOdd(n) {
        return n.d[n.d.length - 1] & 1;
    }
    /*
   * Handle `max` and `min`. `ltgt` is 'lt' or 'gt'.
   */ function maxOrMin(Ctor, args, ltgt) {
        var y, x = new Ctor(args[0]), i = 0;
        for(; ++i < args.length;){
            y = new Ctor(args[i]);
            if (!y.s) {
                x = y;
                break;
            } else if (x[ltgt](y)) x = y;
        }
        return x;
    }
    /*
   * Return a new Decimal whose value is the natural exponential of `x` rounded to `sd` significant
   * digits.
   *
   * Taylor/Maclaurin series.
   *
   * exp(x) = x^0/0! + x^1/1! + x^2/2! + x^3/3! + ...
   *
   * Argument reduction:
   *   Repeat x = x / 32, k += 5, until |x| < 0.1
   *   exp(x) = exp(x / 2^k)^(2^k)
   *
   * Previously, the argument was initially reduced by
   * exp(x) = exp(r) * 10^k  where r = x - k * ln10, k = floor(x / ln10)
   * to first put r in the range [0, ln10], before dividing by 32 until |x| < 0.1, but this was
   * found to be slower than just dividing repeatedly by 32 as above.
   *
   * Max integer argument: exp('20723265836946413') = 6.3e+9000000000000000
   * Min integer argument: exp('-20723265836946411') = 1.2e-9000000000000000
   * (Math object integer min/max: Math.exp(709) = 8.2e+307, Math.exp(-745) = 5e-324)
   *
   *  exp(Infinity)  = Infinity
   *  exp(-Infinity) = 0
   *  exp(NaN)       = NaN
   *  exp(±0)        = 1
   *
   *  exp(x) is non-terminating for any finite, non-zero x.
   *
   *  The result will always be correctly rounded.
   *
   */ function naturalExponential(x, sd) {
        var denominator, guard, j, pow, sum, t, wpr, rep = 0, i = 0, k = 0, Ctor = x.constructor, rm = Ctor.rounding, pr = Ctor.precision;
        // 0/NaN/Infinity?
        if (!x.d || !x.d[0] || x.e > 17) return new Ctor(x.d ? !x.d[0] ? 1 : x.s < 0 ? 0 : 1 / 0 : x.s ? x.s < 0 ? 0 : x : 0 / 0);
        if (sd == null) {
            external = false;
            wpr = pr;
        } else wpr = sd;
        t = new Ctor(0.03125);
        // while abs(x) >= 0.1
        while(x.e > -2){
            // x = x / 2^5
            x = x.times(t);
            k += 5;
        }
        // Use 2 * log10(2^k) + 5 (empirically derived) to estimate the increase in precision
        // necessary to ensure the first 4 rounding digits are correct.
        guard = Math.log(mathpow(2, k)) / Math.LN10 * 2 + 5 | 0;
        wpr += guard;
        denominator = pow = sum = new Ctor(1);
        Ctor.precision = wpr;
        for(;;){
            pow = finalise(pow.times(x), wpr, 1);
            denominator = denominator.times(++i);
            t = sum.plus(divide(pow, denominator, wpr, 1));
            if (digitsToString(t.d).slice(0, wpr) === digitsToString(sum.d).slice(0, wpr)) {
                j = k;
                while(j--)sum = finalise(sum.times(sum), wpr, 1);
                // Check to see if the first 4 rounding digits are [49]999.
                // If so, repeat the summation with a higher precision, otherwise
                // e.g. with precision: 18, rounding: 1
                // exp(18.404272462595034083567793919843761) = 98372560.1229999999 (should be 98372560.123)
                // `wpr - guard` is the index of first rounding digit.
                if (sd == null) {
                    if (rep < 3 && checkRoundingDigits(sum.d, wpr - guard, rm, rep)) {
                        Ctor.precision = wpr += 10;
                        denominator = pow = t = new Ctor(1);
                        i = 0;
                        rep++;
                    } else return finalise(sum, Ctor.precision = pr, rm, external = true);
                } else {
                    Ctor.precision = pr;
                    return sum;
                }
            }
            sum = t;
        }
    }
    /*
   * Return a new Decimal whose value is the natural logarithm of `x` rounded to `sd` significant
   * digits.
   *
   *  ln(-n)        = NaN
   *  ln(0)         = -Infinity
   *  ln(-0)        = -Infinity
   *  ln(1)         = 0
   *  ln(Infinity)  = Infinity
   *  ln(-Infinity) = NaN
   *  ln(NaN)       = NaN
   *
   *  ln(n) (n != 1) is non-terminating.
   *
   */ function naturalLogarithm(y, sd) {
        var c, c0, denominator, e, numerator, rep, sum, t, wpr, x1, x2, n = 1, guard = 10, x = y, xd = x.d, Ctor = x.constructor, rm = Ctor.rounding, pr = Ctor.precision;
        // Is x negative or Infinity, NaN, 0 or 1?
        if (x.s < 0 || !xd || !xd[0] || !x.e && xd[0] == 1 && xd.length == 1) return new Ctor(xd && !xd[0] ? -1 / 0 : x.s != 1 ? NaN : xd ? 0 : x);
        if (sd == null) {
            external = false;
            wpr = pr;
        } else wpr = sd;
        Ctor.precision = wpr += guard;
        c = digitsToString(xd);
        c0 = c.charAt(0);
        if (Math.abs(e = x.e) < 1.5e15) {
            // Argument reduction.
            // The series converges faster the closer the argument is to 1, so using
            // ln(a^b) = b * ln(a),   ln(a) = ln(a^b) / b
            // multiply the argument by itself until the leading digits of the significand are 7, 8, 9,
            // 10, 11, 12 or 13, recording the number of multiplications so the sum of the series can
            // later be divided by this number, then separate out the power of 10 using
            // ln(a*10^b) = ln(a) + b*ln(10).
            // max n is 21 (gives 0.9, 1.0 or 1.1) (9e15 / 21 = 4.2e14).
            //while (c0 < 9 && c0 != 1 || c0 == 1 && c.charAt(1) > 1) {
            // max n is 6 (gives 0.7 - 1.3)
            while(c0 < 7 && c0 != 1 || c0 == 1 && c.charAt(1) > 3){
                x = x.times(y);
                c = digitsToString(x.d);
                c0 = c.charAt(0);
                n++;
            }
            e = x.e;
            if (c0 > 1) {
                x = new Ctor("0." + c);
                e++;
            } else x = new Ctor(c0 + "." + c.slice(1));
        } else {
            // The argument reduction method above may result in overflow if the argument y is a massive
            // number with exponent >= 1500000000000000 (9e15 / 6 = 1.5e15), so instead recall this
            // function using ln(x*10^e) = ln(x) + e*ln(10).
            t = getLn10(Ctor, wpr + 2, pr).times(e + "");
            x = naturalLogarithm(new Ctor(c0 + "." + c.slice(1)), wpr - guard).plus(t);
            Ctor.precision = pr;
            return sd == null ? finalise(x, pr, rm, external = true) : x;
        }
        // x1 is x reduced to a value near 1.
        x1 = x;
        // Taylor series.
        // ln(y) = ln((1 + x)/(1 - x)) = 2(x + x^3/3 + x^5/5 + x^7/7 + ...)
        // where x = (y - 1)/(y + 1)    (|x| < 1)
        sum = numerator = x = divide(x.minus(1), x.plus(1), wpr, 1);
        x2 = finalise(x.times(x), wpr, 1);
        denominator = 3;
        for(;;){
            numerator = finalise(numerator.times(x2), wpr, 1);
            t = sum.plus(divide(numerator, new Ctor(denominator), wpr, 1));
            if (digitsToString(t.d).slice(0, wpr) === digitsToString(sum.d).slice(0, wpr)) {
                sum = sum.times(2);
                // Reverse the argument reduction. Check that e is not 0 because, besides preventing an
                // unnecessary calculation, -0 + 0 = +0 and to ensure correct rounding -0 needs to stay -0.
                if (e !== 0) sum = sum.plus(getLn10(Ctor, wpr + 2, pr).times(e + ""));
                sum = divide(sum, new Ctor(n), wpr, 1);
                // Is rm > 3 and the first 4 rounding digits 4999, or rm < 4 (or the summation has
                // been repeated previously) and the first 4 rounding digits 9999?
                // If so, restart the summation with a higher precision, otherwise
                // e.g. with precision: 12, rounding: 1
                // ln(135520028.6126091714265381533) = 18.7246299999 when it should be 18.72463.
                // `wpr - guard` is the index of first rounding digit.
                if (sd == null) {
                    if (checkRoundingDigits(sum.d, wpr - guard, rm, rep)) {
                        Ctor.precision = wpr += guard;
                        t = numerator = x = divide(x1.minus(1), x1.plus(1), wpr, 1);
                        x2 = finalise(x.times(x), wpr, 1);
                        denominator = rep = 1;
                    } else return finalise(sum, Ctor.precision = pr, rm, external = true);
                } else {
                    Ctor.precision = pr;
                    return sum;
                }
            }
            sum = t;
            denominator += 2;
        }
    }
    // ±Infinity, NaN.
    function nonFiniteToString(x) {
        // Unsigned.
        return String(x.s * x.s / 0);
    }
    /*
   * Parse the value of a new Decimal `x` from string `str`.
   */ function parseDecimal(x, str) {
        var e, i, len;
        // Decimal point?
        if ((e = str.indexOf(".")) > -1) str = str.replace(".", "");
        // Exponential form?
        if ((i = str.search(/e/i)) > 0) {
            // Determine exponent.
            if (e < 0) e = i;
            e += +str.slice(i + 1);
            str = str.substring(0, i);
        } else if (e < 0) // Integer.
        e = str.length;
        // Determine leading zeros.
        for(i = 0; str.charCodeAt(i) === 48; i++);
        // Determine trailing zeros.
        for(len = str.length; str.charCodeAt(len - 1) === 48; --len);
        str = str.slice(i, len);
        if (str) {
            len -= i;
            x.e = e = e - i - 1;
            x.d = [];
            // Transform base
            // e is the base 10 exponent.
            // i is where to slice str to get the first word of the digits array.
            i = (e + 1) % LOG_BASE;
            if (e < 0) i += LOG_BASE;
            if (i < len) {
                if (i) x.d.push(+str.slice(0, i));
                for(len -= LOG_BASE; i < len;)x.d.push(+str.slice(i, i += LOG_BASE));
                str = str.slice(i);
                i = LOG_BASE - str.length;
            } else i -= len;
            for(; i--;)str += "0";
            x.d.push(+str);
            if (external) {
                // Overflow?
                if (x.e > x.constructor.maxE) {
                    // Infinity.
                    x.d = null;
                    x.e = NaN;
                // Underflow?
                } else if (x.e < x.constructor.minE) {
                    // Zero.
                    x.e = 0;
                    x.d = [
                        0
                    ];
                // x.constructor.underflow = true;
                } // else x.constructor.underflow = false;
            }
        } else {
            // Zero.
            x.e = 0;
            x.d = [
                0
            ];
        }
        return x;
    }
    /*
   * Parse the value of a new Decimal `x` from a string `str`, which is not a decimal value.
   */ function parseOther(x, str) {
        var base, Ctor, divisor, i, isFloat, len, p, xd, xe;
        if (str.indexOf("_") > -1) {
            str = str.replace(/(\d)_(?=\d)/g, "$1");
            if (isDecimal.test(str)) return parseDecimal(x, str);
        } else if (str === "Infinity" || str === "NaN") {
            if (!+str) x.s = NaN;
            x.e = NaN;
            x.d = null;
            return x;
        }
        if (isHex.test(str)) {
            base = 16;
            str = str.toLowerCase();
        } else if (isBinary.test(str)) base = 2;
        else if (isOctal.test(str)) base = 8;
        else throw Error(invalidArgument + str);
        // Is there a binary exponent part?
        i = str.search(/p/i);
        if (i > 0) {
            p = +str.slice(i + 1);
            str = str.substring(2, i);
        } else str = str.slice(2);
        // Convert `str` as an integer then divide the result by `base` raised to a power such that the
        // fraction part will be restored.
        i = str.indexOf(".");
        isFloat = i >= 0;
        Ctor = x.constructor;
        if (isFloat) {
            str = str.replace(".", "");
            len = str.length;
            i = len - i;
            // log[10](16) = 1.2041... , log[10](88) = 1.9444....
            divisor = intPow(Ctor, new Ctor(base), i, i * 2);
        }
        xd = convertBase(str, base, BASE);
        xe = xd.length - 1;
        // Remove trailing zeros.
        for(i = xe; xd[i] === 0; --i)xd.pop();
        if (i < 0) return new Ctor(x.s * 0);
        x.e = getBase10Exponent(xd, xe);
        x.d = xd;
        external = false;
        // At what precision to perform the division to ensure exact conversion?
        // maxDecimalIntegerPartDigitCount = ceil(log[10](b) * otherBaseIntegerPartDigitCount)
        // log[10](2) = 0.30103, log[10](8) = 0.90309, log[10](16) = 1.20412
        // E.g. ceil(1.2 * 3) = 4, so up to 4 decimal digits are needed to represent 3 hex int digits.
        // maxDecimalFractionPartDigitCount = {Hex:4|Oct:3|Bin:1} * otherBaseFractionPartDigitCount
        // Therefore using 4 * the number of digits of str will always be enough.
        if (isFloat) x = divide(x, divisor, len * 4);
        // Multiply by the binary exponent part if present.
        if (p) x = x.times(Math.abs(p) < 54 ? mathpow(2, p) : Decimal.pow(2, p));
        external = true;
        return x;
    }
    /*
   * sin(x) = x - x^3/3! + x^5/5! - ...
   * |x| < pi/2
   *
   */ function sine(Ctor, x) {
        var k, len = x.d.length;
        if (len < 3) return x.isZero() ? x : taylorSeries(Ctor, 2, x, x);
        // Argument reduction: sin(5x) = 16*sin^5(x) - 20*sin^3(x) + 5*sin(x)
        // i.e. sin(x) = 16*sin^5(x/5) - 20*sin^3(x/5) + 5*sin(x/5)
        // and  sin(x) = sin(x/5)(5 + sin^2(x/5)(16sin^2(x/5) - 20))
        // Estimate the optimum number of times to use the argument reduction.
        k = 1.4 * Math.sqrt(len);
        k = k > 16 ? 16 : k | 0;
        x = x.times(1 / tinyPow(5, k));
        x = taylorSeries(Ctor, 2, x, x);
        // Reverse argument reduction
        var sin2_x, d5 = new Ctor(5), d16 = new Ctor(16), d20 = new Ctor(20);
        for(; k--;){
            sin2_x = x.times(x);
            x = x.times(d5.plus(sin2_x.times(d16.times(sin2_x).minus(d20))));
        }
        return x;
    }
    // Calculate Taylor series for `cos`, `cosh`, `sin` and `sinh`.
    function taylorSeries(Ctor, n, x, y, isHyperbolic) {
        var j, t, u, x2, i = 1, pr = Ctor.precision, k = Math.ceil(pr / LOG_BASE);
        external = false;
        x2 = x.times(x);
        u = new Ctor(y);
        for(;;){
            t = divide(u.times(x2), new Ctor(n++ * n++), pr, 1);
            u = isHyperbolic ? y.plus(t) : y.minus(t);
            y = divide(t.times(x2), new Ctor(n++ * n++), pr, 1);
            t = u.plus(y);
            if (t.d[k] !== void 0) {
                for(j = k; t.d[j] === u.d[j] && j--;);
                if (j == -1) break;
            }
            j = u;
            u = y;
            y = t;
            t = j;
            i++;
        }
        external = true;
        t.d.length = k + 1;
        return t;
    }
    // Exponent e must be positive and non-zero.
    function tinyPow(b, e) {
        var n = b;
        while(--e)n *= b;
        return n;
    }
    // Return the absolute value of `x` reduced to less than or equal to half pi.
    function toLessThanHalfPi(Ctor, x) {
        var t, isNeg = x.s < 0, pi = getPi(Ctor, Ctor.precision, 1), halfPi = pi.times(0.5);
        x = x.abs();
        if (x.lte(halfPi)) {
            quadrant = isNeg ? 4 : 1;
            return x;
        }
        t = x.divToInt(pi);
        if (t.isZero()) quadrant = isNeg ? 3 : 2;
        else {
            x = x.minus(t.times(pi));
            // 0 <= x < pi
            if (x.lte(halfPi)) {
                quadrant = isOdd(t) ? isNeg ? 2 : 3 : isNeg ? 4 : 1;
                return x;
            }
            quadrant = isOdd(t) ? isNeg ? 1 : 4 : isNeg ? 3 : 2;
        }
        return x.minus(pi).abs();
    }
    /*
   * Return the value of Decimal `x` as a string in base `baseOut`.
   *
   * If the optional `sd` argument is present include a binary exponent suffix.
   */ function toStringBinary(x, baseOut, sd, rm) {
        var base, e, i, k, len, roundUp, str, xd, y, Ctor = x.constructor, isExp = sd !== void 0;
        if (isExp) {
            checkInt32(sd, 1, MAX_DIGITS);
            if (rm === void 0) rm = Ctor.rounding;
            else checkInt32(rm, 0, 8);
        } else {
            sd = Ctor.precision;
            rm = Ctor.rounding;
        }
        if (!x.isFinite()) str = nonFiniteToString(x);
        else {
            str = finiteToString(x);
            i = str.indexOf(".");
            // Use exponential notation according to `toExpPos` and `toExpNeg`? No, but if required:
            // maxBinaryExponent = floor((decimalExponent + 1) * log[2](10))
            // minBinaryExponent = floor(decimalExponent * log[2](10))
            // log[2](10) = 3.321928094887362347870319429489390175864
            if (isExp) {
                base = 2;
                if (baseOut == 16) sd = sd * 4 - 3;
                else if (baseOut == 8) sd = sd * 3 - 2;
            } else base = baseOut;
            // Convert the number as an integer then divide the result by its base raised to a power such
            // that the fraction part will be restored.
            // Non-integer.
            if (i >= 0) {
                str = str.replace(".", "");
                y = new Ctor(1);
                y.e = str.length - i;
                y.d = convertBase(finiteToString(y), 10, base);
                y.e = y.d.length;
            }
            xd = convertBase(str, 10, base);
            e = len = xd.length;
            // Remove trailing zeros.
            for(; xd[--len] == 0;)xd.pop();
            if (!xd[0]) str = isExp ? "0p+0" : "0";
            else {
                if (i < 0) e--;
                else {
                    x = new Ctor(x);
                    x.d = xd;
                    x.e = e;
                    x = divide(x, y, sd, rm, 0, base);
                    xd = x.d;
                    e = x.e;
                    roundUp = inexact;
                }
                // The rounding digit, i.e. the digit after the digit that may be rounded up.
                i = xd[sd];
                k = base / 2;
                roundUp = roundUp || xd[sd + 1] !== void 0;
                roundUp = rm < 4 ? (i !== void 0 || roundUp) && (rm === 0 || rm === (x.s < 0 ? 3 : 2)) : i > k || i === k && (rm === 4 || roundUp || rm === 6 && xd[sd - 1] & 1 || rm === (x.s < 0 ? 8 : 7));
                xd.length = sd;
                if (roundUp) // Rounding up may mean the previous digit has to be rounded up and so on.
                for(; ++xd[--sd] > base - 1;){
                    xd[sd] = 0;
                    if (!sd) {
                        ++e;
                        xd.unshift(1);
                    }
                }
                // Determine trailing zeros.
                for(len = xd.length; !xd[len - 1]; --len);
                // E.g. [4, 11, 15] becomes 4bf.
                for(i = 0, str = ""; i < len; i++)str += NUMERALS.charAt(xd[i]);
                // Add binary exponent suffix?
                if (isExp) {
                    if (len > 1) {
                        if (baseOut == 16 || baseOut == 8) {
                            i = baseOut == 16 ? 4 : 3;
                            for(--len; len % i; len++)str += "0";
                            xd = convertBase(str, base, baseOut);
                            for(len = xd.length; !xd[len - 1]; --len);
                            // xd[0] will always be be 1
                            for(i = 1, str = "1."; i < len; i++)str += NUMERALS.charAt(xd[i]);
                        } else str = str.charAt(0) + "." + str.slice(1);
                    }
                    str = str + (e < 0 ? "p" : "p+") + e;
                } else if (e < 0) {
                    for(; ++e;)str = "0" + str;
                    str = "0." + str;
                } else {
                    if (++e > len) for(e -= len; e--;)str += "0";
                    else if (e < len) str = str.slice(0, e) + "." + str.slice(e);
                }
            }
            str = (baseOut == 16 ? "0x" : baseOut == 2 ? "0b" : baseOut == 8 ? "0o" : "") + str;
        }
        return x.s < 0 ? "-" + str : str;
    }
    // Does not strip trailing zeros.
    function truncate(arr, len) {
        if (arr.length > len) {
            arr.length = len;
            return true;
        }
    }
    // Decimal methods
    /*
   *  abs
   *  acos
   *  acosh
   *  add
   *  asin
   *  asinh
   *  atan
   *  atanh
   *  atan2
   *  cbrt
   *  ceil
   *  clamp
   *  clone
   *  config
   *  cos
   *  cosh
   *  div
   *  exp
   *  floor
   *  hypot
   *  ln
   *  log
   *  log2
   *  log10
   *  max
   *  min
   *  mod
   *  mul
   *  pow
   *  random
   *  round
   *  set
   *  sign
   *  sin
   *  sinh
   *  sqrt
   *  sub
   *  sum
   *  tan
   *  tanh
   *  trunc
   */ /*
   * Return a new Decimal whose value is the absolute value of `x`.
   *
   * x {number|string|Decimal}
   *
   */ function abs(x) {
        return new this(x).abs();
    }
    /*
   * Return a new Decimal whose value is the arccosine in radians of `x`.
   *
   * x {number|string|Decimal}
   *
   */ function acos(x) {
        return new this(x).acos();
    }
    /*
   * Return a new Decimal whose value is the inverse of the hyperbolic cosine of `x`, rounded to
   * `precision` significant digits using rounding mode `rounding`.
   *
   * x {number|string|Decimal} A value in radians.
   *
   */ function acosh(x) {
        return new this(x).acosh();
    }
    /*
   * Return a new Decimal whose value is the sum of `x` and `y`, rounded to `precision` significant
   * digits using rounding mode `rounding`.
   *
   * x {number|string|Decimal}
   * y {number|string|Decimal}
   *
   */ function add(x, y) {
        return new this(x).plus(y);
    }
    /*
   * Return a new Decimal whose value is the arcsine in radians of `x`, rounded to `precision`
   * significant digits using rounding mode `rounding`.
   *
   * x {number|string|Decimal}
   *
   */ function asin(x) {
        return new this(x).asin();
    }
    /*
   * Return a new Decimal whose value is the inverse of the hyperbolic sine of `x`, rounded to
   * `precision` significant digits using rounding mode `rounding`.
   *
   * x {number|string|Decimal} A value in radians.
   *
   */ function asinh(x) {
        return new this(x).asinh();
    }
    /*
   * Return a new Decimal whose value is the arctangent in radians of `x`, rounded to `precision`
   * significant digits using rounding mode `rounding`.
   *
   * x {number|string|Decimal}
   *
   */ function atan(x) {
        return new this(x).atan();
    }
    /*
   * Return a new Decimal whose value is the inverse of the hyperbolic tangent of `x`, rounded to
   * `precision` significant digits using rounding mode `rounding`.
   *
   * x {number|string|Decimal} A value in radians.
   *
   */ function atanh(x) {
        return new this(x).atanh();
    }
    /*
   * Return a new Decimal whose value is the arctangent in radians of `y/x` in the range -pi to pi
   * (inclusive), rounded to `precision` significant digits using rounding mode `rounding`.
   *
   * Domain: [-Infinity, Infinity]
   * Range: [-pi, pi]
   *
   * y {number|string|Decimal} The y-coordinate.
   * x {number|string|Decimal} The x-coordinate.
   *
   * atan2(±0, -0)               = ±pi
   * atan2(±0, +0)               = ±0
   * atan2(±0, -x)               = ±pi for x > 0
   * atan2(±0, x)                = ±0 for x > 0
   * atan2(-y, ±0)               = -pi/2 for y > 0
   * atan2(y, ±0)                = pi/2 for y > 0
   * atan2(±y, -Infinity)        = ±pi for finite y > 0
   * atan2(±y, +Infinity)        = ±0 for finite y > 0
   * atan2(±Infinity, x)         = ±pi/2 for finite x
   * atan2(±Infinity, -Infinity) = ±3*pi/4
   * atan2(±Infinity, +Infinity) = ±pi/4
   * atan2(NaN, x) = NaN
   * atan2(y, NaN) = NaN
   *
   */ function atan2(y, x) {
        y = new this(y);
        x = new this(x);
        var r, pr = this.precision, rm = this.rounding, wpr = pr + 4;
        // Either NaN
        if (!y.s || !x.s) r = new this(NaN);
        else if (!y.d && !x.d) {
            r = getPi(this, wpr, 1).times(x.s > 0 ? 0.25 : 0.75);
            r.s = y.s;
        // x is ±Infinity or y is ±0
        } else if (!x.d || y.isZero()) {
            r = x.s < 0 ? getPi(this, pr, rm) : new this(0);
            r.s = y.s;
        // y is ±Infinity or x is ±0
        } else if (!y.d || x.isZero()) {
            r = getPi(this, wpr, 1).times(0.5);
            r.s = y.s;
        // Both non-zero and finite
        } else if (x.s < 0) {
            this.precision = wpr;
            this.rounding = 1;
            r = this.atan(divide(y, x, wpr, 1));
            x = getPi(this, wpr, 1);
            this.precision = pr;
            this.rounding = rm;
            r = y.s < 0 ? r.minus(x) : r.plus(x);
        } else r = this.atan(divide(y, x, wpr, 1));
        return r;
    }
    /*
   * Return a new Decimal whose value is the cube root of `x`, rounded to `precision` significant
   * digits using rounding mode `rounding`.
   *
   * x {number|string|Decimal}
   *
   */ function cbrt(x) {
        return new this(x).cbrt();
    }
    /*
   * Return a new Decimal whose value is `x` rounded to an integer using `ROUND_CEIL`.
   *
   * x {number|string|Decimal}
   *
   */ function ceil(x) {
        return finalise(x = new this(x), x.e + 1, 2);
    }
    /*
   * Return a new Decimal whose value is `x` clamped to the range delineated by `min` and `max`.
   *
   * x {number|string|Decimal}
   * min {number|string|Decimal}
   * max {number|string|Decimal}
   *
   */ function clamp(x, min, max) {
        return new this(x).clamp(min, max);
    }
    /*
   * Configure global settings for a Decimal constructor.
   *
   * `obj` is an object with one or more of the following properties,
   *
   *   precision  {number}
   *   rounding   {number}
   *   toExpNeg   {number}
   *   toExpPos   {number}
   *   maxE       {number}
   *   minE       {number}
   *   modulo     {number}
   *   crypto     {boolean|number}
   *   defaults   {true}
   *
   * E.g. Decimal.config({ precision: 20, rounding: 4 })
   *
   */ function config(obj) {
        if (!obj || typeof obj !== "object") throw Error(decimalError + "Object expected");
        var i, p, v, useDefaults = obj.defaults === true, ps = [
            "precision",
            1,
            MAX_DIGITS,
            "rounding",
            0,
            8,
            "toExpNeg",
            -EXP_LIMIT,
            0,
            "toExpPos",
            0,
            EXP_LIMIT,
            "maxE",
            0,
            EXP_LIMIT,
            "minE",
            -EXP_LIMIT,
            0,
            "modulo",
            0,
            9
        ];
        for(i = 0; i < ps.length; i += 3){
            if (p = ps[i], useDefaults) this[p] = DEFAULTS[p];
            if ((v = obj[p]) !== void 0) {
                if (mathfloor(v) === v && v >= ps[i + 1] && v <= ps[i + 2]) this[p] = v;
                else throw Error(invalidArgument + p + ": " + v);
            }
        }
        if (p = "crypto", useDefaults) this[p] = DEFAULTS[p];
        if ((v = obj[p]) !== void 0) {
            if (v === true || v === false || v === 0 || v === 1) {
                if (v) {
                    if (typeof crypto != "undefined" && crypto && (crypto.getRandomValues || crypto.randomBytes)) this[p] = true;
                    else throw Error(cryptoUnavailable);
                } else this[p] = false;
            } else throw Error(invalidArgument + p + ": " + v);
        }
        return this;
    }
    /*
   * Return a new Decimal whose value is the cosine of `x`, rounded to `precision` significant
   * digits using rounding mode `rounding`.
   *
   * x {number|string|Decimal} A value in radians.
   *
   */ function cos(x) {
        return new this(x).cos();
    }
    /*
   * Return a new Decimal whose value is the hyperbolic cosine of `x`, rounded to precision
   * significant digits using rounding mode `rounding`.
   *
   * x {number|string|Decimal} A value in radians.
   *
   */ function cosh(x) {
        return new this(x).cosh();
    }
    /*
   * Create and return a Decimal constructor with the same configuration properties as this Decimal
   * constructor.
   *
   */ function clone(obj) {
        var i, p, ps;
        /*
     * The Decimal constructor and exported function.
     * Return a new Decimal instance.
     *
     * v {number|string|Decimal} A numeric value.
     *
     */ function Decimal(v) {
            var e, i, t, x = this;
            // Decimal called without new.
            if (!(x instanceof Decimal)) return new Decimal(v);
            // Retain a reference to this Decimal constructor, and shadow Decimal.prototype.constructor
            // which points to Object.
            x.constructor = Decimal;
            // Duplicate.
            if (isDecimalInstance(v)) {
                x.s = v.s;
                if (external) {
                    if (!v.d || v.e > Decimal.maxE) {
                        // Infinity.
                        x.e = NaN;
                        x.d = null;
                    } else if (v.e < Decimal.minE) {
                        // Zero.
                        x.e = 0;
                        x.d = [
                            0
                        ];
                    } else {
                        x.e = v.e;
                        x.d = v.d.slice();
                    }
                } else {
                    x.e = v.e;
                    x.d = v.d ? v.d.slice() : v.d;
                }
                return;
            }
            t = typeof v;
            if (t === "number") {
                if (v === 0) {
                    x.s = 1 / v < 0 ? -1 : 1;
                    x.e = 0;
                    x.d = [
                        0
                    ];
                    return;
                }
                if (v < 0) {
                    v = -v;
                    x.s = -1;
                } else x.s = 1;
                // Fast path for small integers.
                if (v === ~~v && v < 1e7) {
                    for(e = 0, i = v; i >= 10; i /= 10)e++;
                    if (external) {
                        if (e > Decimal.maxE) {
                            x.e = NaN;
                            x.d = null;
                        } else if (e < Decimal.minE) {
                            x.e = 0;
                            x.d = [
                                0
                            ];
                        } else {
                            x.e = e;
                            x.d = [
                                v
                            ];
                        }
                    } else {
                        x.e = e;
                        x.d = [
                            v
                        ];
                    }
                    return;
                // Infinity, NaN.
                } else if (v * 0 !== 0) {
                    if (!v) x.s = NaN;
                    x.e = NaN;
                    x.d = null;
                    return;
                }
                return parseDecimal(x, v.toString());
            } else if (t !== "string") throw Error(invalidArgument + v);
            // Minus sign?
            if ((i = v.charCodeAt(0)) === 45) {
                v = v.slice(1);
                x.s = -1;
            } else {
                // Plus sign?
                if (i === 43) v = v.slice(1);
                x.s = 1;
            }
            return isDecimal.test(v) ? parseDecimal(x, v) : parseOther(x, v);
        }
        Decimal.prototype = P;
        Decimal.ROUND_UP = 0;
        Decimal.ROUND_DOWN = 1;
        Decimal.ROUND_CEIL = 2;
        Decimal.ROUND_FLOOR = 3;
        Decimal.ROUND_HALF_UP = 4;
        Decimal.ROUND_HALF_DOWN = 5;
        Decimal.ROUND_HALF_EVEN = 6;
        Decimal.ROUND_HALF_CEIL = 7;
        Decimal.ROUND_HALF_FLOOR = 8;
        Decimal.EUCLID = 9;
        Decimal.config = Decimal.set = config;
        Decimal.clone = clone;
        Decimal.isDecimal = isDecimalInstance;
        Decimal.abs = abs;
        Decimal.acos = acos;
        Decimal.acosh = acosh; // ES6
        Decimal.add = add;
        Decimal.asin = asin;
        Decimal.asinh = asinh; // ES6
        Decimal.atan = atan;
        Decimal.atanh = atanh; // ES6
        Decimal.atan2 = atan2;
        Decimal.cbrt = cbrt; // ES6
        Decimal.ceil = ceil;
        Decimal.clamp = clamp;
        Decimal.cos = cos;
        Decimal.cosh = cosh; // ES6
        Decimal.div = div;
        Decimal.exp = exp;
        Decimal.floor = floor;
        Decimal.hypot = hypot; // ES6
        Decimal.ln = ln;
        Decimal.log = log;
        Decimal.log10 = log10; // ES6
        Decimal.log2 = log2; // ES6
        Decimal.max = max;
        Decimal.min = min;
        Decimal.mod = mod;
        Decimal.mul = mul;
        Decimal.pow = pow;
        Decimal.random = random;
        Decimal.round = round;
        Decimal.sign = sign; // ES6
        Decimal.sin = sin;
        Decimal.sinh = sinh; // ES6
        Decimal.sqrt = sqrt;
        Decimal.sub = sub;
        Decimal.sum = sum;
        Decimal.tan = tan;
        Decimal.tanh = tanh; // ES6
        Decimal.trunc = trunc; // ES6
        if (obj === void 0) obj = {};
        if (obj) {
            if (obj.defaults !== true) {
                ps = [
                    "precision",
                    "rounding",
                    "toExpNeg",
                    "toExpPos",
                    "maxE",
                    "minE",
                    "modulo",
                    "crypto"
                ];
                for(i = 0; i < ps.length;)if (!obj.hasOwnProperty(p = ps[i++])) obj[p] = this[p];
            }
        }
        Decimal.config(obj);
        return Decimal;
    }
    /*
   * Return a new Decimal whose value is `x` divided by `y`, rounded to `precision` significant
   * digits using rounding mode `rounding`.
   *
   * x {number|string|Decimal}
   * y {number|string|Decimal}
   *
   */ function div(x, y) {
        return new this(x).div(y);
    }
    /*
   * Return a new Decimal whose value is the natural exponential of `x`, rounded to `precision`
   * significant digits using rounding mode `rounding`.
   *
   * x {number|string|Decimal} The power to which to raise the base of the natural log.
   *
   */ function exp(x) {
        return new this(x).exp();
    }
    /*
   * Return a new Decimal whose value is `x` round to an integer using `ROUND_FLOOR`.
   *
   * x {number|string|Decimal}
   *
   */ function floor(x) {
        return finalise(x = new this(x), x.e + 1, 3);
    }
    /*
   * Return a new Decimal whose value is the square root of the sum of the squares of the arguments,
   * rounded to `precision` significant digits using rounding mode `rounding`.
   *
   * hypot(a, b, ...) = sqrt(a^2 + b^2 + ...)
   *
   * arguments {number|string|Decimal}
   *
   */ function hypot() {
        var i, n, t = new this(0);
        external = false;
        for(i = 0; i < arguments.length;){
            n = new this(arguments[i++]);
            if (!n.d) {
                if (n.s) {
                    external = true;
                    return new this(1 / 0);
                }
                t = n;
            } else if (t.d) t = t.plus(n.times(n));
        }
        external = true;
        return t.sqrt();
    }
    /*
   * Return true if object is a Decimal instance (where Decimal is any Decimal constructor),
   * otherwise return false.
   *
   */ function isDecimalInstance(obj) {
        return obj instanceof Decimal || obj && obj.toStringTag === tag || false;
    }
    /*
   * Return a new Decimal whose value is the natural logarithm of `x`, rounded to `precision`
   * significant digits using rounding mode `rounding`.
   *
   * x {number|string|Decimal}
   *
   */ function ln(x) {
        return new this(x).ln();
    }
    /*
   * Return a new Decimal whose value is the log of `x` to the base `y`, or to base 10 if no base
   * is specified, rounded to `precision` significant digits using rounding mode `rounding`.
   *
   * log[y](x)
   *
   * x {number|string|Decimal} The argument of the logarithm.
   * y {number|string|Decimal} The base of the logarithm.
   *
   */ function log(x, y) {
        return new this(x).log(y);
    }
    /*
   * Return a new Decimal whose value is the base 2 logarithm of `x`, rounded to `precision`
   * significant digits using rounding mode `rounding`.
   *
   * x {number|string|Decimal}
   *
   */ function log2(x) {
        return new this(x).log(2);
    }
    /*
   * Return a new Decimal whose value is the base 10 logarithm of `x`, rounded to `precision`
   * significant digits using rounding mode `rounding`.
   *
   * x {number|string|Decimal}
   *
   */ function log10(x) {
        return new this(x).log(10);
    }
    /*
   * Return a new Decimal whose value is the maximum of the arguments.
   *
   * arguments {number|string|Decimal}
   *
   */ function max() {
        return maxOrMin(this, arguments, "lt");
    }
    /*
   * Return a new Decimal whose value is the minimum of the arguments.
   *
   * arguments {number|string|Decimal}
   *
   */ function min() {
        return maxOrMin(this, arguments, "gt");
    }
    /*
   * Return a new Decimal whose value is `x` modulo `y`, rounded to `precision` significant digits
   * using rounding mode `rounding`.
   *
   * x {number|string|Decimal}
   * y {number|string|Decimal}
   *
   */ function mod(x, y) {
        return new this(x).mod(y);
    }
    /*
   * Return a new Decimal whose value is `x` multiplied by `y`, rounded to `precision` significant
   * digits using rounding mode `rounding`.
   *
   * x {number|string|Decimal}
   * y {number|string|Decimal}
   *
   */ function mul(x, y) {
        return new this(x).mul(y);
    }
    /*
   * Return a new Decimal whose value is `x` raised to the power `y`, rounded to precision
   * significant digits using rounding mode `rounding`.
   *
   * x {number|string|Decimal} The base.
   * y {number|string|Decimal} The exponent.
   *
   */ function pow(x, y) {
        return new this(x).pow(y);
    }
    /*
   * Returns a new Decimal with a random value equal to or greater than 0 and less than 1, and with
   * `sd`, or `Decimal.precision` if `sd` is omitted, significant digits (or less if trailing zeros
   * are produced).
   *
   * [sd] {number} Significant digits. Integer, 0 to MAX_DIGITS inclusive.
   *
   */ function random(sd) {
        var d, e, k, n, i = 0, r = new this(1), rd = [];
        if (sd === void 0) sd = this.precision;
        else checkInt32(sd, 1, MAX_DIGITS);
        k = Math.ceil(sd / LOG_BASE);
        if (!this.crypto) for(; i < k;)rd[i++] = Math.random() * 1e7 | 0;
        else if (crypto.getRandomValues) {
            d = crypto.getRandomValues(new Uint32Array(k));
            for(; i < k;){
                n = d[i];
                // 0 <= n < 4294967296
                // Probability n >= 4.29e9, is 4967296 / 4294967296 = 0.00116 (1 in 865).
                if (n >= 4.29e9) d[i] = crypto.getRandomValues(new Uint32Array(1))[0];
                else // 0 <= n <= 4289999999
                // 0 <= (n % 1e7) <= 9999999
                rd[i++] = n % 1e7;
            }
        // Node.js supporting crypto.randomBytes.
        } else if (crypto.randomBytes) {
            // buffer
            d = crypto.randomBytes(k *= 4);
            for(; i < k;){
                // 0 <= n < 2147483648
                n = d[i] + (d[i + 1] << 8) + (d[i + 2] << 16) + ((d[i + 3] & 0x7f) << 24);
                // Probability n >= 2.14e9, is 7483648 / 2147483648 = 0.0035 (1 in 286).
                if (n >= 2.14e9) crypto.randomBytes(4).copy(d, i);
                else {
                    // 0 <= n <= 2139999999
                    // 0 <= (n % 1e7) <= 9999999
                    rd.push(n % 1e7);
                    i += 4;
                }
            }
            i = k / 4;
        } else throw Error(cryptoUnavailable);
        k = rd[--i];
        sd %= LOG_BASE;
        // Convert trailing digits to zeros according to sd.
        if (k && sd) {
            n = mathpow(10, LOG_BASE - sd);
            rd[i] = (k / n | 0) * n;
        }
        // Remove trailing words which are zero.
        for(; rd[i] === 0; i--)rd.pop();
        // Zero?
        if (i < 0) {
            e = 0;
            rd = [
                0
            ];
        } else {
            e = -1;
            // Remove leading words which are zero and adjust exponent accordingly.
            for(; rd[0] === 0; e -= LOG_BASE)rd.shift();
            // Count the digits of the first word of rd to determine leading zeros.
            for(k = 1, n = rd[0]; n >= 10; n /= 10)k++;
            // Adjust the exponent for leading zeros of the first word of rd.
            if (k < LOG_BASE) e -= LOG_BASE - k;
        }
        r.e = e;
        r.d = rd;
        return r;
    }
    /*
   * Return a new Decimal whose value is `x` rounded to an integer using rounding mode `rounding`.
   *
   * To emulate `Math.round`, set rounding to 7 (ROUND_HALF_CEIL).
   *
   * x {number|string|Decimal}
   *
   */ function round(x) {
        return finalise(x = new this(x), x.e + 1, this.rounding);
    }
    /*
   * Return
   *   1    if x > 0,
   *  -1    if x < 0,
   *   0    if x is 0,
   *  -0    if x is -0,
   *   NaN  otherwise
   *
   * x {number|string|Decimal}
   *
   */ function sign(x) {
        x = new this(x);
        return x.d ? x.d[0] ? x.s : 0 * x.s : x.s || NaN;
    }
    /*
   * Return a new Decimal whose value is the sine of `x`, rounded to `precision` significant digits
   * using rounding mode `rounding`.
   *
   * x {number|string|Decimal} A value in radians.
   *
   */ function sin(x) {
        return new this(x).sin();
    }
    /*
   * Return a new Decimal whose value is the hyperbolic sine of `x`, rounded to `precision`
   * significant digits using rounding mode `rounding`.
   *
   * x {number|string|Decimal} A value in radians.
   *
   */ function sinh(x) {
        return new this(x).sinh();
    }
    /*
   * Return a new Decimal whose value is the square root of `x`, rounded to `precision` significant
   * digits using rounding mode `rounding`.
   *
   * x {number|string|Decimal}
   *
   */ function sqrt(x) {
        return new this(x).sqrt();
    }
    /*
   * Return a new Decimal whose value is `x` minus `y`, rounded to `precision` significant digits
   * using rounding mode `rounding`.
   *
   * x {number|string|Decimal}
   * y {number|string|Decimal}
   *
   */ function sub(x, y) {
        return new this(x).sub(y);
    }
    /*
   * Return a new Decimal whose value is the sum of the arguments, rounded to `precision`
   * significant digits using rounding mode `rounding`.
   *
   * Only the result is rounded, not the intermediate calculations.
   *
   * arguments {number|string|Decimal}
   *
   */ function sum() {
        var i = 0, args = arguments, x = new this(args[i]);
        external = false;
        for(; x.s && ++i < args.length;)x = x.plus(args[i]);
        external = true;
        return finalise(x, this.precision, this.rounding);
    }
    /*
   * Return a new Decimal whose value is the tangent of `x`, rounded to `precision` significant
   * digits using rounding mode `rounding`.
   *
   * x {number|string|Decimal} A value in radians.
   *
   */ function tan(x) {
        return new this(x).tan();
    }
    /*
   * Return a new Decimal whose value is the hyperbolic tangent of `x`, rounded to `precision`
   * significant digits using rounding mode `rounding`.
   *
   * x {number|string|Decimal} A value in radians.
   *
   */ function tanh(x) {
        return new this(x).tanh();
    }
    /*
   * Return a new Decimal whose value is `x` truncated to an integer.
   *
   * x {number|string|Decimal}
   *
   */ function trunc(x) {
        return finalise(x = new this(x), x.e + 1, 1);
    }
    // Create and configure initial Decimal constructor.
    Decimal = clone(DEFAULTS);
    Decimal.prototype.constructor = Decimal;
    Decimal["default"] = Decimal.Decimal = Decimal;
    // Create the internal constants from their string values.
    LN10 = new Decimal(LN10);
    PI = new Decimal(PI);
    // Export.
    // AMD.
    if (typeof define == "function" && define.amd) define(function() {
        return Decimal;
    });
    else if (0, $70e7e2b9a2a71832$exports) {
        if (typeof Symbol == "function" && typeof Symbol.iterator == "symbol") {
            P[Symbol["for"]("nodejs.util.inspect.custom")] = P.toString;
            P[Symbol.toStringTag] = "Decimal";
        }
        $70e7e2b9a2a71832$exports = Decimal;
    // Browser.
    } else {
        if (!globalScope) globalScope = typeof self != "undefined" && self && self.self == self ? self : window;
        noConflict = globalScope.Decimal;
        Decimal.noConflict = function() {
            globalScope.Decimal = noConflict;
            return Decimal;
        };
        globalScope.Decimal = Decimal;
    }
})($70e7e2b9a2a71832$exports);


var $45b41de5de61a03d$exports = {};
/* Font Face Observer v2.3.0 - © Bram Stein. License: BSD-3-Clause */ (function() {
    function p(a, c) {
        document.addEventListener ? a.addEventListener("scroll", c, !1) : a.attachEvent("scroll", c);
    }
    function u(a) {
        document.body ? a() : document.addEventListener ? document.addEventListener("DOMContentLoaded", function b() {
            document.removeEventListener("DOMContentLoaded", b);
            a();
        }) : document.attachEvent("onreadystatechange", function g() {
            if ("interactive" == document.readyState || "complete" == document.readyState) document.detachEvent("onreadystatechange", g), a();
        });
    }
    function w(a) {
        this.g = document.createElement("div");
        this.g.setAttribute("aria-hidden", "true");
        this.g.appendChild(document.createTextNode(a));
        this.h = document.createElement("span");
        this.i = document.createElement("span");
        this.m = document.createElement("span");
        this.j = document.createElement("span");
        this.l = -1;
        this.h.style.cssText = "max-width:none;display:inline-block;position:absolute;height:100%;width:100%;overflow:scroll;font-size:16px;";
        this.i.style.cssText = "max-width:none;display:inline-block;position:absolute;height:100%;width:100%;overflow:scroll;font-size:16px;";
        this.j.style.cssText = "max-width:none;display:inline-block;position:absolute;height:100%;width:100%;overflow:scroll;font-size:16px;";
        this.m.style.cssText = "display:inline-block;width:200%;height:200%;font-size:16px;max-width:none;";
        this.h.appendChild(this.m);
        this.i.appendChild(this.j);
        this.g.appendChild(this.h);
        this.g.appendChild(this.i);
    }
    function x(a, c) {
        a.g.style.cssText = "max-width:none;min-width:20px;min-height:20px;display:inline-block;overflow:hidden;position:absolute;width:auto;margin:0;padding:0;top:-999px;white-space:nowrap;font-synthesis:none;font:" + c + ";";
    }
    function B(a) {
        var c = a.g.offsetWidth, b = c + 100;
        a.j.style.width = b + "px";
        a.i.scrollLeft = b;
        a.h.scrollLeft = a.h.scrollWidth + 100;
        return a.l !== c ? (a.l = c, !0) : !1;
    }
    function C(a, c) {
        function b() {
            var e = g;
            B(e) && null !== e.g.parentNode && c(e.l);
        }
        var g = a;
        p(a.h, b);
        p(a.i, b);
        B(a);
    }
    function D(a, c, b) {
        c = c || {};
        b = b || window;
        this.family = a;
        this.style = c.style || "normal";
        this.weight = c.weight || "normal";
        this.stretch = c.stretch || "normal";
        this.context = b;
    }
    var E = null, F = null, G = null, H = null;
    function I(a) {
        null === F && (M(a) && /Apple/.test(window.navigator.vendor) ? (a = /AppleWebKit\/([0-9]+)(?:\.([0-9]+))(?:\.([0-9]+))/.exec(window.navigator.userAgent), F = !!a && 603 > parseInt(a[1], 10)) : F = !1);
        return F;
    }
    function M(a) {
        null === H && (H = !!a.document.fonts);
        return H;
    }
    function N(a, c) {
        var b = a.style, g = a.weight;
        if (null === G) {
            var e = document.createElement("div");
            try {
                e.style.font = "condensed 100px sans-serif";
            } catch (q) {}
            G = "" !== e.style.font;
        }
        return [
            b,
            g,
            G ? a.stretch : "",
            "100px",
            c
        ].join(" ");
    }
    D.prototype.load = function(a, c) {
        var b = this, g = a || "BESbswy", e = 0, q = c || 3E3, J = (new Date).getTime();
        return new Promise(function(K, L) {
            if (M(b.context) && !I(b.context)) {
                var O = new Promise(function(r, t) {
                    function h() {
                        (new Date).getTime() - J >= q ? t(Error("" + q + "ms timeout exceeded")) : b.context.document.fonts.load(N(b, '"' + b.family + '"'), g).then(function(n) {
                            1 <= n.length ? r() : setTimeout(h, 25);
                        }, t);
                    }
                    h();
                }), P = new Promise(function(r, t) {
                    e = setTimeout(function() {
                        t(Error("" + q + "ms timeout exceeded"));
                    }, q);
                });
                Promise.race([
                    P,
                    O
                ]).then(function() {
                    clearTimeout(e);
                    K(b);
                }, L);
            } else u(function() {
                function r() {
                    var d;
                    if (d = -1 != k && -1 != l || -1 != k && -1 != m || -1 != l && -1 != m) (d = k != l && k != m && l != m) || (null === E && (d = /AppleWebKit\/([0-9]+)(?:\.([0-9]+))/.exec(window.navigator.userAgent), E = !!d && (536 > parseInt(d[1], 10) || 536 === parseInt(d[1], 10) && 11 >= parseInt(d[2], 10))), d = E && (k == y && l == y && m == y || k == z && l == z && m == z || k == A && l == A && m == A)), d = !d;
                    d && (null !== f.parentNode && f.parentNode.removeChild(f), clearTimeout(e), K(b));
                }
                function t() {
                    if ((new Date).getTime() - J >= q) null !== f.parentNode && f.parentNode.removeChild(f), L(Error("" + q + "ms timeout exceeded"));
                    else {
                        var d = b.context.document.hidden;
                        if (!0 === d || void 0 === d) k = h.g.offsetWidth, l = n.g.offsetWidth, m = v.g.offsetWidth, r();
                        e = setTimeout(t, 50);
                    }
                }
                var h = new w(g), n = new w(g), v = new w(g), k = -1, l = -1, m = -1, y = -1, z = -1, A = -1, f = document.createElement("div");
                f.dir = "ltr";
                x(h, N(b, "sans-serif"));
                x(n, N(b, "serif"));
                x(v, N(b, "monospace"));
                f.appendChild(h.g);
                f.appendChild(n.g);
                f.appendChild(v.g);
                b.context.document.body.appendChild(f);
                y = h.g.offsetWidth;
                z = n.g.offsetWidth;
                A = v.g.offsetWidth;
                t();
                C(h, function(d) {
                    k = d;
                    r();
                });
                x(h, N(b, '"' + b.family + '",sans-serif'));
                C(n, function(d) {
                    l = d;
                    r();
                });
                x(n, N(b, '"' + b.family + '",serif'));
                C(v, function(d) {
                    m = d;
                    r();
                });
                x(v, N(b, '"' + b.family + '",monospace'));
            });
        });
    };
    $45b41de5de61a03d$exports = D;
})();



var $hKNIR = parcelRequire("hKNIR");
/*!
 * CSSPlugin 3.12.2
 * https://greensock.com
 *
 * Copyright 2008-2023, GreenSock. All rights reserved.
 * Subject to the terms at https://greensock.com/standard-license or for
 * Club GreenSock members, the agreement issued with that membership.
 * @author: Jack Doyle, jack@greensock.com
*/ /* eslint-disable */ 
var $hKNIR = parcelRequire("hKNIR");
var $68b3cc8973e9e281$var$_win, $68b3cc8973e9e281$var$_doc, $68b3cc8973e9e281$var$_docElement, $68b3cc8973e9e281$var$_pluginInitted, $68b3cc8973e9e281$var$_tempDiv, $68b3cc8973e9e281$var$_tempDivStyler, $68b3cc8973e9e281$var$_recentSetterPlugin, $68b3cc8973e9e281$var$_reverting, $68b3cc8973e9e281$var$_windowExists = function _windowExists() {
    return typeof window !== "undefined";
}, $68b3cc8973e9e281$var$_transformProps = {}, $68b3cc8973e9e281$var$_RAD2DEG = 180 / Math.PI, $68b3cc8973e9e281$var$_DEG2RAD = Math.PI / 180, $68b3cc8973e9e281$var$_atan2 = Math.atan2, $68b3cc8973e9e281$var$_bigNum = 1e8, $68b3cc8973e9e281$var$_capsExp = /([A-Z])/g, $68b3cc8973e9e281$var$_horizontalExp = /(left|right|width|margin|padding|x)/i, $68b3cc8973e9e281$var$_complexExp = /[\s,\(]\S/, $68b3cc8973e9e281$var$_propertyAliases = {
    autoAlpha: "opacity,visibility",
    scale: "scaleX,scaleY",
    alpha: "opacity"
}, $68b3cc8973e9e281$var$_renderCSSProp = function _renderCSSProp(ratio, data) {
    return data.set(data.t, data.p, Math.round((data.s + data.c * ratio) * 10000) / 10000 + data.u, data);
}, $68b3cc8973e9e281$var$_renderPropWithEnd = function _renderPropWithEnd(ratio, data) {
    return data.set(data.t, data.p, ratio === 1 ? data.e : Math.round((data.s + data.c * ratio) * 10000) / 10000 + data.u, data);
}, $68b3cc8973e9e281$var$_renderCSSPropWithBeginning = function _renderCSSPropWithBeginning(ratio, data) {
    return data.set(data.t, data.p, ratio ? Math.round((data.s + data.c * ratio) * 10000) / 10000 + data.u : data.b, data);
}, //if units change, we need a way to render the original unit/value when the tween goes all the way back to the beginning (ratio:0)
$68b3cc8973e9e281$var$_renderRoundedCSSProp = function _renderRoundedCSSProp(ratio, data) {
    var value = data.s + data.c * ratio;
    data.set(data.t, data.p, ~~(value + (value < 0 ? -0.5 : .5)) + data.u, data);
}, $68b3cc8973e9e281$var$_renderNonTweeningValue = function _renderNonTweeningValue(ratio, data) {
    return data.set(data.t, data.p, ratio ? data.e : data.b, data);
}, $68b3cc8973e9e281$var$_renderNonTweeningValueOnlyAtEnd = function _renderNonTweeningValueOnlyAtEnd(ratio, data) {
    return data.set(data.t, data.p, ratio !== 1 ? data.b : data.e, data);
}, $68b3cc8973e9e281$var$_setterCSSStyle = function _setterCSSStyle(target, property, value) {
    return target.style[property] = value;
}, $68b3cc8973e9e281$var$_setterCSSProp = function _setterCSSProp(target, property, value) {
    return target.style.setProperty(property, value);
}, $68b3cc8973e9e281$var$_setterTransform = function _setterTransform(target, property, value) {
    return target._gsap[property] = value;
}, $68b3cc8973e9e281$var$_setterScale = function _setterScale(target, property, value) {
    return target._gsap.scaleX = target._gsap.scaleY = value;
}, $68b3cc8973e9e281$var$_setterScaleWithRender = function _setterScaleWithRender(target, property, value, data, ratio) {
    var cache = target._gsap;
    cache.scaleX = cache.scaleY = value;
    cache.renderTransform(ratio, cache);
}, $68b3cc8973e9e281$var$_setterTransformWithRender = function _setterTransformWithRender(target, property, value, data, ratio) {
    var cache = target._gsap;
    cache[property] = value;
    cache.renderTransform(ratio, cache);
}, $68b3cc8973e9e281$var$_transformProp = "transform", $68b3cc8973e9e281$var$_transformOriginProp = $68b3cc8973e9e281$var$_transformProp + "Origin", $68b3cc8973e9e281$var$_saveStyle = function _saveStyle(property, isNotCSS) {
    var _this = this;
    var target = this.target, style = target.style;
    if (property in $68b3cc8973e9e281$var$_transformProps && style) {
        this.tfm = this.tfm || {};
        if (property !== "transform") {
            property = $68b3cc8973e9e281$var$_propertyAliases[property] || property;
            ~property.indexOf(",") ? property.split(",").forEach(function(a) {
                return _this.tfm[a] = $68b3cc8973e9e281$var$_get(target, a);
            }) : this.tfm[property] = target._gsap.x ? target._gsap[property] : $68b3cc8973e9e281$var$_get(target, property); // note: scale would map to "scaleX,scaleY", thus we loop and apply them both.
        } else return $68b3cc8973e9e281$var$_propertyAliases.transform.split(",").forEach(function(p) {
            return _saveStyle.call(_this, p, isNotCSS);
        });
        if (this.props.indexOf($68b3cc8973e9e281$var$_transformProp) >= 0) return;
        if (target._gsap.svg) {
            this.svgo = target.getAttribute("data-svg-origin");
            this.props.push($68b3cc8973e9e281$var$_transformOriginProp, isNotCSS, "");
        }
        property = $68b3cc8973e9e281$var$_transformProp;
    }
    (style || isNotCSS) && this.props.push(property, isNotCSS, style[property]);
}, $68b3cc8973e9e281$var$_removeIndependentTransforms = function _removeIndependentTransforms(style) {
    if (style.translate) {
        style.removeProperty("translate");
        style.removeProperty("scale");
        style.removeProperty("rotate");
    }
}, $68b3cc8973e9e281$var$_revertStyle = function _revertStyle() {
    var props = this.props, target = this.target, style = target.style, cache = target._gsap, i, p;
    for(i = 0; i < props.length; i += 3)// stored like this: property, isNotCSS, value
    props[i + 1] ? target[props[i]] = props[i + 2] : props[i + 2] ? style[props[i]] = props[i + 2] : style.removeProperty(props[i].substr(0, 2) === "--" ? props[i] : props[i].replace($68b3cc8973e9e281$var$_capsExp, "-$1").toLowerCase());
    if (this.tfm) {
        for(p in this.tfm)cache[p] = this.tfm[p];
        if (cache.svg) {
            cache.renderTransform();
            target.setAttribute("data-svg-origin", this.svgo || "");
        }
        i = $68b3cc8973e9e281$var$_reverting();
        if ((!i || !i.isStart) && !style[$68b3cc8973e9e281$var$_transformProp]) {
            $68b3cc8973e9e281$var$_removeIndependentTransforms(style);
            cache.uncache = 1; // if it's a startAt that's being reverted in the _initTween() of the core, we don't need to uncache transforms. This is purely a performance optimization.
        }
    }
}, $68b3cc8973e9e281$var$_getStyleSaver = function _getStyleSaver(target, properties) {
    var saver = {
        target: target,
        props: [],
        revert: $68b3cc8973e9e281$var$_revertStyle,
        save: $68b3cc8973e9e281$var$_saveStyle
    };
    target._gsap || (0, $hKNIR.gsap).core.getCache(target); // just make sure there's a _gsap cache defined because we read from it in _saveStyle() and it's more efficient to just check it here once.
    properties && properties.split(",").forEach(function(p) {
        return saver.save(p);
    });
    return saver;
}, $68b3cc8973e9e281$var$_supports3D, $68b3cc8973e9e281$export$a232bb0480ae674a = function _createElement(type, ns) {
    var e = $68b3cc8973e9e281$var$_doc.createElementNS ? $68b3cc8973e9e281$var$_doc.createElementNS((ns || "http://www.w3.org/1999/xhtml").replace(/^https/, "http"), type) : $68b3cc8973e9e281$var$_doc.createElement(type); //some servers swap in https for http in the namespace which can break things, making "style" inaccessible.
    return e.style ? e : $68b3cc8973e9e281$var$_doc.createElement(type); //some environments won't allow access to the element's style when created with a namespace in which case we default to the standard createElement() to work around the issue. Also note that when GSAP is embedded directly inside an SVG file, createElement() won't allow access to the style object in Firefox (see https://greensock.com/forums/topic/20215-problem-using-tweenmax-in-standalone-self-containing-svg-file-err-cannot-set-property-csstext-of-undefined/).
}, $68b3cc8973e9e281$var$_getComputedProperty = function _getComputedProperty(target, property, skipPrefixFallback) {
    var cs = getComputedStyle(target);
    return cs[property] || cs.getPropertyValue(property.replace($68b3cc8973e9e281$var$_capsExp, "-$1").toLowerCase()) || cs.getPropertyValue(property) || !skipPrefixFallback && _getComputedProperty(target, $68b3cc8973e9e281$export$8cbef5dd49a09c8b(property) || property, 1) || ""; //css variables may not need caps swapped out for dashes and lowercase.
}, $68b3cc8973e9e281$var$_prefixes = "O,Moz,ms,Ms,Webkit".split(","), $68b3cc8973e9e281$export$8cbef5dd49a09c8b = function _checkPropPrefix(property, element, preferPrefix) {
    var e = element || $68b3cc8973e9e281$var$_tempDiv, s = e.style, i = 5;
    if (property in s && !preferPrefix) return property;
    property = property.charAt(0).toUpperCase() + property.substr(1);
    while(i-- && !($68b3cc8973e9e281$var$_prefixes[i] + property in s));
    return i < 0 ? null : (i === 3 ? "ms" : i >= 0 ? $68b3cc8973e9e281$var$_prefixes[i] : "") + property;
}, $68b3cc8973e9e281$var$_initCore = function _initCore() {
    if ($68b3cc8973e9e281$var$_windowExists() && window.document) {
        $68b3cc8973e9e281$var$_win = window;
        $68b3cc8973e9e281$var$_doc = $68b3cc8973e9e281$var$_win.document;
        $68b3cc8973e9e281$var$_docElement = $68b3cc8973e9e281$var$_doc.documentElement;
        $68b3cc8973e9e281$var$_tempDiv = $68b3cc8973e9e281$export$a232bb0480ae674a("div") || {
            style: {}
        };
        $68b3cc8973e9e281$var$_tempDivStyler = $68b3cc8973e9e281$export$a232bb0480ae674a("div");
        $68b3cc8973e9e281$var$_transformProp = $68b3cc8973e9e281$export$8cbef5dd49a09c8b($68b3cc8973e9e281$var$_transformProp);
        $68b3cc8973e9e281$var$_transformOriginProp = $68b3cc8973e9e281$var$_transformProp + "Origin";
        $68b3cc8973e9e281$var$_tempDiv.style.cssText = "border-width:0;line-height:0;position:absolute;padding:0"; //make sure to override certain properties that may contaminate measurements, in case the user has overreaching style sheets.
        $68b3cc8973e9e281$var$_supports3D = !!$68b3cc8973e9e281$export$8cbef5dd49a09c8b("perspective");
        $68b3cc8973e9e281$var$_reverting = (0, $hKNIR.gsap).core.reverting;
        $68b3cc8973e9e281$var$_pluginInitted = 1;
    }
}, $68b3cc8973e9e281$var$_getBBoxHack = function _getBBoxHack(swapIfPossible) {
    //works around issues in some browsers (like Firefox) that don't correctly report getBBox() on SVG elements inside a <defs> element and/or <mask>. We try creating an SVG, adding it to the documentElement and toss the element in there so that it's definitely part of the rendering tree, then grab the bbox and if it works, we actually swap out the original getBBox() method for our own that does these extra steps whenever getBBox is needed. This helps ensure that performance is optimal (only do all these extra steps when absolutely necessary...most elements don't need it).
    var svg = $68b3cc8973e9e281$export$a232bb0480ae674a("svg", this.ownerSVGElement && this.ownerSVGElement.getAttribute("xmlns") || "http://www.w3.org/2000/svg"), oldParent = this.parentNode, oldSibling = this.nextSibling, oldCSS = this.style.cssText, bbox;
    $68b3cc8973e9e281$var$_docElement.appendChild(svg);
    svg.appendChild(this);
    this.style.display = "block";
    if (swapIfPossible) try {
        bbox = this.getBBox();
        this._gsapBBox = this.getBBox; //store the original
        this.getBBox = _getBBoxHack;
    } catch (e) {}
    else if (this._gsapBBox) bbox = this._gsapBBox();
    if (oldParent) {
        if (oldSibling) oldParent.insertBefore(this, oldSibling);
        else oldParent.appendChild(this);
    }
    $68b3cc8973e9e281$var$_docElement.removeChild(svg);
    this.style.cssText = oldCSS;
    return bbox;
}, $68b3cc8973e9e281$var$_getAttributeFallbacks = function _getAttributeFallbacks(target, attributesArray) {
    var i = attributesArray.length;
    while(i--){
        if (target.hasAttribute(attributesArray[i])) return target.getAttribute(attributesArray[i]);
    }
}, $68b3cc8973e9e281$export$41bc7c2d1e04f11b = function _getBBox(target) {
    var bounds;
    try {
        bounds = target.getBBox(); //Firefox throws errors if you try calling getBBox() on an SVG element that's not rendered (like in a <symbol> or <defs>). https://bugzilla.mozilla.org/show_bug.cgi?id=612118
    } catch (error) {
        bounds = $68b3cc8973e9e281$var$_getBBoxHack.call(target, true);
    }
    bounds && (bounds.width || bounds.height) || target.getBBox === $68b3cc8973e9e281$var$_getBBoxHack || (bounds = $68b3cc8973e9e281$var$_getBBoxHack.call(target, true)); //some browsers (like Firefox) misreport the bounds if the element has zero width and height (it just assumes it's at x:0, y:0), thus we need to manually grab the position in that case.
    return bounds && !bounds.width && !bounds.x && !bounds.y ? {
        x: +$68b3cc8973e9e281$var$_getAttributeFallbacks(target, [
            "x",
            "cx",
            "x1"
        ]) || 0,
        y: +$68b3cc8973e9e281$var$_getAttributeFallbacks(target, [
            "y",
            "cy",
            "y1"
        ]) || 0,
        width: 0,
        height: 0
    } : bounds;
}, $68b3cc8973e9e281$var$_isSVG = function _isSVG(e) {
    return !!(e.getCTM && (!e.parentNode || e.ownerSVGElement) && $68b3cc8973e9e281$export$41bc7c2d1e04f11b(e));
}, //reports if the element is an SVG on which getBBox() actually works
$68b3cc8973e9e281$var$_removeProperty = function _removeProperty(target, property) {
    if (property) {
        var style = target.style;
        if (property in $68b3cc8973e9e281$var$_transformProps && property !== $68b3cc8973e9e281$var$_transformOriginProp) property = $68b3cc8973e9e281$var$_transformProp;
        if (style.removeProperty) {
            if (property.substr(0, 2) === "ms" || property.substr(0, 6) === "webkit") //Microsoft and some Webkit browsers don't conform to the standard of capitalizing the first prefix character, so we adjust so that when we prefix the caps with a dash, it's correct (otherwise it'd be "ms-transform" instead of "-ms-transform" for IE9, for example)
            property = "-" + property;
            style.removeProperty(property.replace($68b3cc8973e9e281$var$_capsExp, "-$1").toLowerCase());
        } else //note: old versions of IE use "removeAttribute()" instead of "removeProperty()"
        style.removeAttribute(property);
    }
}, $68b3cc8973e9e281$var$_addNonTweeningPT = function _addNonTweeningPT(plugin, target, property, beginning, end, onlySetAtEnd) {
    var pt = new (0, $hKNIR.PropTween)(plugin._pt, target, property, 0, 1, onlySetAtEnd ? $68b3cc8973e9e281$var$_renderNonTweeningValueOnlyAtEnd : $68b3cc8973e9e281$var$_renderNonTweeningValue);
    plugin._pt = pt;
    pt.b = beginning;
    pt.e = end;
    plugin._props.push(property);
    return pt;
}, $68b3cc8973e9e281$var$_nonConvertibleUnits = {
    deg: 1,
    rad: 1,
    turn: 1
}, $68b3cc8973e9e281$var$_nonStandardLayouts = {
    grid: 1,
    flex: 1
}, //takes a single value like 20px and converts it to the unit specified, like "%", returning only the numeric amount.
$68b3cc8973e9e281$var$_convertToUnit = function _convertToUnit(target, property, value, unit) {
    var curValue = parseFloat(value) || 0, curUnit = (value + "").trim().substr((curValue + "").length) || "px", // some browsers leave extra whitespace at the beginning of CSS variables, hence the need to trim()
    style = $68b3cc8973e9e281$var$_tempDiv.style, horizontal = $68b3cc8973e9e281$var$_horizontalExp.test(property), isRootSVG = target.tagName.toLowerCase() === "svg", measureProperty = (isRootSVG ? "client" : "offset") + (horizontal ? "Width" : "Height"), amount = 100, toPixels = unit === "px", toPercent = unit === "%", px, parent, cache, isSVG;
    if (unit === curUnit || !curValue || $68b3cc8973e9e281$var$_nonConvertibleUnits[unit] || $68b3cc8973e9e281$var$_nonConvertibleUnits[curUnit]) return curValue;
    curUnit !== "px" && !toPixels && (curValue = _convertToUnit(target, property, value, "px"));
    isSVG = target.getCTM && $68b3cc8973e9e281$var$_isSVG(target);
    if ((toPercent || curUnit === "%") && ($68b3cc8973e9e281$var$_transformProps[property] || ~property.indexOf("adius"))) {
        px = isSVG ? target.getBBox()[horizontal ? "width" : "height"] : target[measureProperty];
        return (0, $hKNIR._round)(toPercent ? curValue / px * amount : curValue / 100 * px);
    }
    style[horizontal ? "width" : "height"] = amount + (toPixels ? curUnit : unit);
    parent = ~property.indexOf("adius") || unit === "em" && target.appendChild && !isRootSVG ? target : target.parentNode;
    if (isSVG) parent = (target.ownerSVGElement || {}).parentNode;
    if (!parent || parent === $68b3cc8973e9e281$var$_doc || !parent.appendChild) parent = $68b3cc8973e9e281$var$_doc.body;
    cache = parent._gsap;
    if (cache && toPercent && cache.width && horizontal && cache.time === (0, $hKNIR._ticker).time && !cache.uncache) return (0, $hKNIR._round)(curValue / cache.width * amount);
    else {
        (toPercent || curUnit === "%") && !$68b3cc8973e9e281$var$_nonStandardLayouts[$68b3cc8973e9e281$var$_getComputedProperty(parent, "display")] && (style.position = $68b3cc8973e9e281$var$_getComputedProperty(target, "position"));
        parent === target && (style.position = "static"); // like for borderRadius, if it's a % we must have it relative to the target itself but that may not have position: relative or position: absolute in which case it'd go up the chain until it finds its offsetParent (bad). position: static protects against that.
        parent.appendChild($68b3cc8973e9e281$var$_tempDiv);
        px = $68b3cc8973e9e281$var$_tempDiv[measureProperty];
        parent.removeChild($68b3cc8973e9e281$var$_tempDiv);
        style.position = "absolute";
        if (horizontal && toPercent) {
            cache = (0, $hKNIR._getCache)(parent);
            cache.time = (0, $hKNIR._ticker).time;
            cache.width = parent[measureProperty];
        }
    }
    return (0, $hKNIR._round)(toPixels ? px * curValue / amount : px && curValue ? amount / px * curValue : 0);
}, $68b3cc8973e9e281$var$_get = function _get(target, property, unit, uncache) {
    var value;
    $68b3cc8973e9e281$var$_pluginInitted || $68b3cc8973e9e281$var$_initCore();
    if (property in $68b3cc8973e9e281$var$_propertyAliases && property !== "transform") {
        property = $68b3cc8973e9e281$var$_propertyAliases[property];
        if (~property.indexOf(",")) property = property.split(",")[0];
    }
    if ($68b3cc8973e9e281$var$_transformProps[property] && property !== "transform") {
        value = $68b3cc8973e9e281$var$_parseTransform(target, uncache);
        value = property !== "transformOrigin" ? value[property] : value.svg ? value.origin : $68b3cc8973e9e281$var$_firstTwoOnly($68b3cc8973e9e281$var$_getComputedProperty(target, $68b3cc8973e9e281$var$_transformOriginProp)) + " " + value.zOrigin + "px";
    } else {
        value = target.style[property];
        if (!value || value === "auto" || uncache || ~(value + "").indexOf("calc(")) value = $68b3cc8973e9e281$var$_specialProps[property] && $68b3cc8973e9e281$var$_specialProps[property](target, property, unit) || $68b3cc8973e9e281$var$_getComputedProperty(target, property) || (0, $hKNIR._getProperty)(target, property) || (property === "opacity" ? 1 : 0); // note: some browsers, like Firefox, don't report borderRadius correctly! Instead, it only reports every corner like  borderTopLeftRadius
    }
    return unit && !~(value + "").trim().indexOf(" ") ? $68b3cc8973e9e281$var$_convertToUnit(target, property, value, unit) + unit : value;
}, $68b3cc8973e9e281$var$_tweenComplexCSSString = function _tweenComplexCSSString(target, prop, start, end) {
    // note: we call _tweenComplexCSSString.call(pluginInstance...) to ensure that it's scoped properly. We may call it from within a plugin too, thus "this" would refer to the plugin.
    if (!start || start === "none") {
        // some browsers like Safari actually PREFER the prefixed property and mis-report the unprefixed value like clipPath (BUG). In other words, even though clipPath exists in the style ("clipPath" in target.style) and it's set in the CSS properly (along with -webkit-clip-path), Safari reports clipPath as "none" whereas WebkitClipPath reports accurately like "ellipse(100% 0% at 50% 0%)", so in this case we must SWITCH to using the prefixed property instead. See https://greensock.com/forums/topic/18310-clippath-doesnt-work-on-ios/
        var p = $68b3cc8973e9e281$export$8cbef5dd49a09c8b(prop, target, 1), s = p && $68b3cc8973e9e281$var$_getComputedProperty(target, p, 1);
        if (s && s !== start) {
            prop = p;
            start = s;
        } else if (prop === "borderColor") start = $68b3cc8973e9e281$var$_getComputedProperty(target, "borderTopColor"); // Firefox bug: always reports "borderColor" as "", so we must fall back to borderTopColor. See https://greensock.com/forums/topic/24583-how-to-return-colors-that-i-had-after-reverse/
    }
    var pt = new (0, $hKNIR.PropTween)(this._pt, target.style, prop, 0, 1, (0, $hKNIR._renderComplexString)), index = 0, matchIndex = 0, a, result, startValues, startNum, color, startValue, endValue, endNum, chunk, endUnit, startUnit, endValues;
    pt.b = start;
    pt.e = end;
    start += ""; // ensure values are strings
    end += "";
    if (end === "auto") {
        target.style[prop] = end;
        end = $68b3cc8973e9e281$var$_getComputedProperty(target, prop) || end;
        target.style[prop] = start;
    }
    a = [
        start,
        end
    ];
    (0, $hKNIR._colorStringFilter)(a); // pass an array with the starting and ending values and let the filter do whatever it needs to the values. If colors are found, it returns true and then we must match where the color shows up order-wise because for things like boxShadow, sometimes the browser provides the computed values with the color FIRST, but the user provides it with the color LAST, so flip them if necessary. Same for drop-shadow().
    start = a[0];
    end = a[1];
    startValues = start.match((0, $hKNIR._numWithUnitExp)) || [];
    endValues = end.match((0, $hKNIR._numWithUnitExp)) || [];
    if (endValues.length) {
        while(result = (0, $hKNIR._numWithUnitExp).exec(end)){
            endValue = result[0];
            chunk = end.substring(index, result.index);
            if (color) color = (color + 1) % 5;
            else if (chunk.substr(-5) === "rgba(" || chunk.substr(-5) === "hsla(") color = 1;
            if (endValue !== (startValue = startValues[matchIndex++] || "")) {
                startNum = parseFloat(startValue) || 0;
                startUnit = startValue.substr((startNum + "").length);
                endValue.charAt(1) === "=" && (endValue = (0, $hKNIR._parseRelative)(startNum, endValue) + startUnit);
                endNum = parseFloat(endValue);
                endUnit = endValue.substr((endNum + "").length);
                index = (0, $hKNIR._numWithUnitExp).lastIndex - endUnit.length;
                if (!endUnit) {
                    //if something like "perspective:300" is passed in and we must add a unit to the end
                    endUnit = endUnit || (0, $hKNIR._config).units[prop] || startUnit;
                    if (index === end.length) {
                        end += endUnit;
                        pt.e += endUnit;
                    }
                }
                if (startUnit !== endUnit) startNum = $68b3cc8973e9e281$var$_convertToUnit(target, prop, startValue, endUnit) || 0;
                 // these nested PropTweens are handled in a special way - we'll never actually call a render or setter method on them. We'll just loop through them in the parent complex string PropTween's render method.
                pt._pt = {
                    _next: pt._pt,
                    p: chunk || matchIndex === 1 ? chunk : ",",
                    //note: SVG spec allows omission of comma/space when a negative sign is wedged between two numbers, like 2.5-5.3 instead of 2.5,-5.3 but when tweening, the negative value may switch to positive, so we insert the comma just in case.
                    s: startNum,
                    c: endNum - startNum,
                    m: color && color < 4 || prop === "zIndex" ? Math.round : 0
                };
            }
        }
        pt.c = index < end.length ? end.substring(index, end.length) : ""; //we use the "c" of the PropTween to store the final part of the string (after the last number)
    } else pt.r = prop === "display" && end === "none" ? $68b3cc8973e9e281$var$_renderNonTweeningValueOnlyAtEnd : $68b3cc8973e9e281$var$_renderNonTweeningValue;
    (0, $hKNIR._relExp).test(end) && (pt.e = 0); //if the end string contains relative values or dynamic random(...) values, delete the end it so that on the final render we don't actually set it to the string with += or -= characters (forces it to use the calculated value).
    this._pt = pt; //start the linked list with this new PropTween. Remember, we call _tweenComplexCSSString.call(pluginInstance...) to ensure that it's scoped properly. We may call it from within another plugin too, thus "this" would refer to the plugin.
    return pt;
}, $68b3cc8973e9e281$var$_keywordToPercent = {
    top: "0%",
    bottom: "100%",
    left: "0%",
    right: "100%",
    center: "50%"
}, $68b3cc8973e9e281$var$_convertKeywordsToPercentages = function _convertKeywordsToPercentages(value) {
    var split = value.split(" "), x = split[0], y = split[1] || "50%";
    if (x === "top" || x === "bottom" || y === "left" || y === "right") {
        //the user provided them in the wrong order, so flip them
        value = x;
        x = y;
        y = value;
    }
    split[0] = $68b3cc8973e9e281$var$_keywordToPercent[x] || x;
    split[1] = $68b3cc8973e9e281$var$_keywordToPercent[y] || y;
    return split.join(" ");
}, $68b3cc8973e9e281$var$_renderClearProps = function _renderClearProps(ratio, data) {
    if (data.tween && data.tween._time === data.tween._dur) {
        var target = data.t, style = target.style, props = data.u, cache = target._gsap, prop, clearTransforms, i;
        if (props === "all" || props === true) {
            style.cssText = "";
            clearTransforms = 1;
        } else {
            props = props.split(",");
            i = props.length;
            while(--i > -1){
                prop = props[i];
                if ($68b3cc8973e9e281$var$_transformProps[prop]) {
                    clearTransforms = 1;
                    prop = prop === "transformOrigin" ? $68b3cc8973e9e281$var$_transformOriginProp : $68b3cc8973e9e281$var$_transformProp;
                }
                $68b3cc8973e9e281$var$_removeProperty(target, prop);
            }
        }
        if (clearTransforms) {
            $68b3cc8973e9e281$var$_removeProperty(target, $68b3cc8973e9e281$var$_transformProp);
            if (cache) {
                cache.svg && target.removeAttribute("transform");
                $68b3cc8973e9e281$var$_parseTransform(target, 1); // force all the cached values back to "normal"/identity, otherwise if there's another tween that's already set to render transforms on this element, it could display the wrong values.
                cache.uncache = 1;
                $68b3cc8973e9e281$var$_removeIndependentTransforms(style);
            }
        }
    }
}, // note: specialProps should return 1 if (and only if) they have a non-zero priority. It indicates we need to sort the linked list.
$68b3cc8973e9e281$var$_specialProps = {
    clearProps: function clearProps(plugin, target, property, endValue, tween) {
        if (tween.data !== "isFromStart") {
            var pt = plugin._pt = new (0, $hKNIR.PropTween)(plugin._pt, target, property, 0, 0, $68b3cc8973e9e281$var$_renderClearProps);
            pt.u = endValue;
            pt.pr = -10;
            pt.tween = tween;
            plugin._props.push(property);
            return 1;
        }
    }
}, /*
 * --------------------------------------------------------------------------------------
 * TRANSFORMS
 * --------------------------------------------------------------------------------------
 */ $68b3cc8973e9e281$var$_identity2DMatrix = [
    1,
    0,
    0,
    1,
    0,
    0
], $68b3cc8973e9e281$var$_rotationalProperties = {}, $68b3cc8973e9e281$var$_isNullTransform = function _isNullTransform(value) {
    return value === "matrix(1, 0, 0, 1, 0, 0)" || value === "none" || !value;
}, $68b3cc8973e9e281$var$_getComputedTransformMatrixAsArray = function _getComputedTransformMatrixAsArray(target) {
    var matrixString = $68b3cc8973e9e281$var$_getComputedProperty(target, $68b3cc8973e9e281$var$_transformProp);
    return $68b3cc8973e9e281$var$_isNullTransform(matrixString) ? $68b3cc8973e9e281$var$_identity2DMatrix : matrixString.substr(7).match((0, $hKNIR._numExp)).map((0, $hKNIR._round));
}, $68b3cc8973e9e281$var$_getMatrix = function _getMatrix(target, force2D) {
    var cache = target._gsap || (0, $hKNIR._getCache)(target), style = target.style, matrix = $68b3cc8973e9e281$var$_getComputedTransformMatrixAsArray(target), parent, nextSibling, temp, addedToDOM;
    if (cache.svg && target.getAttribute("transform")) {
        temp = target.transform.baseVal.consolidate().matrix; //ensures that even complex values like "translate(50,60) rotate(135,0,0)" are parsed because it mashes it into a matrix.
        matrix = [
            temp.a,
            temp.b,
            temp.c,
            temp.d,
            temp.e,
            temp.f
        ];
        return matrix.join(",") === "1,0,0,1,0,0" ? $68b3cc8973e9e281$var$_identity2DMatrix : matrix;
    } else if (matrix === $68b3cc8973e9e281$var$_identity2DMatrix && !target.offsetParent && target !== $68b3cc8973e9e281$var$_docElement && !cache.svg) {
        //note: if offsetParent is null, that means the element isn't in the normal document flow, like if it has display:none or one of its ancestors has display:none). Firefox returns null for getComputedStyle() if the element is in an iframe that has display:none. https://bugzilla.mozilla.org/show_bug.cgi?id=548397
        //browsers don't report transforms accurately unless the element is in the DOM and has a display value that's not "none". Firefox and Microsoft browsers have a partial bug where they'll report transforms even if display:none BUT not any percentage-based values like translate(-50%, 8px) will be reported as if it's translate(0, 8px).
        temp = style.display;
        style.display = "block";
        parent = target.parentNode;
        if (!parent || !target.offsetParent) {
            // note: in 3.3.0 we switched target.offsetParent to _doc.body.contains(target) to avoid [sometimes unnecessary] MutationObserver calls but that wasn't adequate because there are edge cases where nested position: fixed elements need to get reparented to accurately sense transforms. See https://github.com/greensock/GSAP/issues/388 and https://github.com/greensock/GSAP/issues/375
            addedToDOM = 1; //flag
            nextSibling = target.nextElementSibling;
            $68b3cc8973e9e281$var$_docElement.appendChild(target); //we must add it to the DOM in order to get values properly
        }
        matrix = $68b3cc8973e9e281$var$_getComputedTransformMatrixAsArray(target);
        temp ? style.display = temp : $68b3cc8973e9e281$var$_removeProperty(target, "display");
        if (addedToDOM) nextSibling ? parent.insertBefore(target, nextSibling) : parent ? parent.appendChild(target) : $68b3cc8973e9e281$var$_docElement.removeChild(target);
    }
    return force2D && matrix.length > 6 ? [
        matrix[0],
        matrix[1],
        matrix[4],
        matrix[5],
        matrix[12],
        matrix[13]
    ] : matrix;
}, $68b3cc8973e9e281$var$_applySVGOrigin = function _applySVGOrigin(target, origin, originIsAbsolute, smooth, matrixArray, pluginToAddPropTweensTo) {
    var cache = target._gsap, matrix = matrixArray || $68b3cc8973e9e281$var$_getMatrix(target, true), xOriginOld = cache.xOrigin || 0, yOriginOld = cache.yOrigin || 0, xOffsetOld = cache.xOffset || 0, yOffsetOld = cache.yOffset || 0, a = matrix[0], b = matrix[1], c = matrix[2], d = matrix[3], tx = matrix[4], ty = matrix[5], originSplit = origin.split(" "), xOrigin = parseFloat(originSplit[0]) || 0, yOrigin = parseFloat(originSplit[1]) || 0, bounds, determinant, x, y;
    if (!originIsAbsolute) {
        bounds = $68b3cc8973e9e281$export$41bc7c2d1e04f11b(target);
        xOrigin = bounds.x + (~originSplit[0].indexOf("%") ? xOrigin / 100 * bounds.width : xOrigin);
        yOrigin = bounds.y + (~(originSplit[1] || originSplit[0]).indexOf("%") ? yOrigin / 100 * bounds.height : yOrigin);
    } else if (matrix !== $68b3cc8973e9e281$var$_identity2DMatrix && (determinant = a * d - b * c)) {
        //if it's zero (like if scaleX and scaleY are zero), skip it to avoid errors with dividing by zero.
        x = xOrigin * (d / determinant) + yOrigin * (-c / determinant) + (c * ty - d * tx) / determinant;
        y = xOrigin * (-b / determinant) + yOrigin * (a / determinant) - (a * ty - b * tx) / determinant;
        xOrigin = x;
        yOrigin = y;
    }
    if (smooth || smooth !== false && cache.smooth) {
        tx = xOrigin - xOriginOld;
        ty = yOrigin - yOriginOld;
        cache.xOffset = xOffsetOld + (tx * a + ty * c) - tx;
        cache.yOffset = yOffsetOld + (tx * b + ty * d) - ty;
    } else cache.xOffset = cache.yOffset = 0;
    cache.xOrigin = xOrigin;
    cache.yOrigin = yOrigin;
    cache.smooth = !!smooth;
    cache.origin = origin;
    cache.originIsAbsolute = !!originIsAbsolute;
    target.style[$68b3cc8973e9e281$var$_transformOriginProp] = "0px 0px"; //otherwise, if someone sets  an origin via CSS, it will likely interfere with the SVG transform attribute ones (because remember, we're baking the origin into the matrix() value).
    if (pluginToAddPropTweensTo) {
        $68b3cc8973e9e281$var$_addNonTweeningPT(pluginToAddPropTweensTo, cache, "xOrigin", xOriginOld, xOrigin);
        $68b3cc8973e9e281$var$_addNonTweeningPT(pluginToAddPropTweensTo, cache, "yOrigin", yOriginOld, yOrigin);
        $68b3cc8973e9e281$var$_addNonTweeningPT(pluginToAddPropTweensTo, cache, "xOffset", xOffsetOld, cache.xOffset);
        $68b3cc8973e9e281$var$_addNonTweeningPT(pluginToAddPropTweensTo, cache, "yOffset", yOffsetOld, cache.yOffset);
    }
    target.setAttribute("data-svg-origin", xOrigin + " " + yOrigin);
}, $68b3cc8973e9e281$var$_parseTransform = function _parseTransform(target, uncache) {
    var cache = target._gsap || new (0, $hKNIR.GSCache)(target);
    if ("x" in cache && !uncache && !cache.uncache) return cache;
    var style = target.style, invertedScaleX = cache.scaleX < 0, px = "px", deg = "deg", cs = getComputedStyle(target), origin = $68b3cc8973e9e281$var$_getComputedProperty(target, $68b3cc8973e9e281$var$_transformOriginProp) || "0", x, y, z, scaleX, scaleY, rotation, rotationX, rotationY, skewX, skewY, perspective, xOrigin, yOrigin, matrix, angle, cos, sin, a, b, c, d, a12, a22, t1, t2, t3, a13, a23, a33, a42, a43, a32;
    x = y = z = rotation = rotationX = rotationY = skewX = skewY = perspective = 0;
    scaleX = scaleY = 1;
    cache.svg = !!(target.getCTM && $68b3cc8973e9e281$var$_isSVG(target));
    if (cs.translate) {
        // accommodate independent transforms by combining them into normal ones.
        if (cs.translate !== "none" || cs.scale !== "none" || cs.rotate !== "none") style[$68b3cc8973e9e281$var$_transformProp] = (cs.translate !== "none" ? "translate3d(" + (cs.translate + " 0 0").split(" ").slice(0, 3).join(", ") + ") " : "") + (cs.rotate !== "none" ? "rotate(" + cs.rotate + ") " : "") + (cs.scale !== "none" ? "scale(" + cs.scale.split(" ").join(",") + ") " : "") + (cs[$68b3cc8973e9e281$var$_transformProp] !== "none" ? cs[$68b3cc8973e9e281$var$_transformProp] : "");
        style.scale = style.rotate = style.translate = "none";
    }
    matrix = $68b3cc8973e9e281$var$_getMatrix(target, cache.svg);
    if (cache.svg) {
        if (cache.uncache) {
            // if cache.uncache is true (and maybe if origin is 0,0), we need to set element.style.transformOrigin = (cache.xOrigin - bbox.x) + "px " + (cache.yOrigin - bbox.y) + "px". Previously we let the data-svg-origin stay instead, but when introducing revert(), it complicated things.
            t2 = target.getBBox();
            origin = cache.xOrigin - t2.x + "px " + (cache.yOrigin - t2.y) + "px";
            t1 = "";
        } else t1 = !uncache && target.getAttribute("data-svg-origin"); //  Remember, to work around browser inconsistencies we always force SVG elements' transformOrigin to 0,0 and offset the translation accordingly.
        $68b3cc8973e9e281$var$_applySVGOrigin(target, t1 || origin, !!t1 || cache.originIsAbsolute, cache.smooth !== false, matrix);
    }
    xOrigin = cache.xOrigin || 0;
    yOrigin = cache.yOrigin || 0;
    if (matrix !== $68b3cc8973e9e281$var$_identity2DMatrix) {
        a = matrix[0]; //a11
        b = matrix[1]; //a21
        c = matrix[2]; //a31
        d = matrix[3]; //a41
        x = a12 = matrix[4];
        y = a22 = matrix[5]; //2D matrix
        if (matrix.length === 6) {
            scaleX = Math.sqrt(a * a + b * b);
            scaleY = Math.sqrt(d * d + c * c);
            rotation = a || b ? $68b3cc8973e9e281$var$_atan2(b, a) * $68b3cc8973e9e281$var$_RAD2DEG : 0; //note: if scaleX is 0, we cannot accurately measure rotation. Same for skewX with a scaleY of 0. Therefore, we default to the previously recorded value (or zero if that doesn't exist).
            skewX = c || d ? $68b3cc8973e9e281$var$_atan2(c, d) * $68b3cc8973e9e281$var$_RAD2DEG + rotation : 0;
            skewX && (scaleY *= Math.abs(Math.cos(skewX * $68b3cc8973e9e281$var$_DEG2RAD)));
            if (cache.svg) {
                x -= xOrigin - (xOrigin * a + yOrigin * c);
                y -= yOrigin - (xOrigin * b + yOrigin * d);
            } //3D matrix
        } else {
            a32 = matrix[6];
            a42 = matrix[7];
            a13 = matrix[8];
            a23 = matrix[9];
            a33 = matrix[10];
            a43 = matrix[11];
            x = matrix[12];
            y = matrix[13];
            z = matrix[14];
            angle = $68b3cc8973e9e281$var$_atan2(a32, a33);
            rotationX = angle * $68b3cc8973e9e281$var$_RAD2DEG; //rotationX
            if (angle) {
                cos = Math.cos(-angle);
                sin = Math.sin(-angle);
                t1 = a12 * cos + a13 * sin;
                t2 = a22 * cos + a23 * sin;
                t3 = a32 * cos + a33 * sin;
                a13 = a12 * -sin + a13 * cos;
                a23 = a22 * -sin + a23 * cos;
                a33 = a32 * -sin + a33 * cos;
                a43 = a42 * -sin + a43 * cos;
                a12 = t1;
                a22 = t2;
                a32 = t3;
            } //rotationY
            angle = $68b3cc8973e9e281$var$_atan2(-c, a33);
            rotationY = angle * $68b3cc8973e9e281$var$_RAD2DEG;
            if (angle) {
                cos = Math.cos(-angle);
                sin = Math.sin(-angle);
                t1 = a * cos - a13 * sin;
                t2 = b * cos - a23 * sin;
                t3 = c * cos - a33 * sin;
                a43 = d * sin + a43 * cos;
                a = t1;
                b = t2;
                c = t3;
            } //rotationZ
            angle = $68b3cc8973e9e281$var$_atan2(b, a);
            rotation = angle * $68b3cc8973e9e281$var$_RAD2DEG;
            if (angle) {
                cos = Math.cos(angle);
                sin = Math.sin(angle);
                t1 = a * cos + b * sin;
                t2 = a12 * cos + a22 * sin;
                b = b * cos - a * sin;
                a22 = a22 * cos - a12 * sin;
                a = t1;
                a12 = t2;
            }
            if (rotationX && Math.abs(rotationX) + Math.abs(rotation) > 359.9) {
                //when rotationY is set, it will often be parsed as 180 degrees different than it should be, and rotationX and rotation both being 180 (it looks the same), so we adjust for that here.
                rotationX = rotation = 0;
                rotationY = 180 - rotationY;
            }
            scaleX = (0, $hKNIR._round)(Math.sqrt(a * a + b * b + c * c));
            scaleY = (0, $hKNIR._round)(Math.sqrt(a22 * a22 + a32 * a32));
            angle = $68b3cc8973e9e281$var$_atan2(a12, a22);
            skewX = Math.abs(angle) > 0.0002 ? angle * $68b3cc8973e9e281$var$_RAD2DEG : 0;
            perspective = a43 ? 1 / (a43 < 0 ? -a43 : a43) : 0;
        }
        if (cache.svg) {
            //sense if there are CSS transforms applied on an SVG element in which case we must overwrite them when rendering. The transform attribute is more reliable cross-browser, but we can't just remove the CSS ones because they may be applied in a CSS rule somewhere (not just inline).
            t1 = target.getAttribute("transform");
            cache.forceCSS = target.setAttribute("transform", "") || !$68b3cc8973e9e281$var$_isNullTransform($68b3cc8973e9e281$var$_getComputedProperty(target, $68b3cc8973e9e281$var$_transformProp));
            t1 && target.setAttribute("transform", t1);
        }
    }
    if (Math.abs(skewX) > 90 && Math.abs(skewX) < 270) {
        if (invertedScaleX) {
            scaleX *= -1;
            skewX += rotation <= 0 ? 180 : -180;
            rotation += rotation <= 0 ? 180 : -180;
        } else {
            scaleY *= -1;
            skewX += skewX <= 0 ? 180 : -180;
        }
    }
    uncache = uncache || cache.uncache;
    cache.x = x - ((cache.xPercent = x && (!uncache && cache.xPercent || (Math.round(target.offsetWidth / 2) === Math.round(-x) ? -50 : 0))) ? target.offsetWidth * cache.xPercent / 100 : 0) + px;
    cache.y = y - ((cache.yPercent = y && (!uncache && cache.yPercent || (Math.round(target.offsetHeight / 2) === Math.round(-y) ? -50 : 0))) ? target.offsetHeight * cache.yPercent / 100 : 0) + px;
    cache.z = z + px;
    cache.scaleX = (0, $hKNIR._round)(scaleX);
    cache.scaleY = (0, $hKNIR._round)(scaleY);
    cache.rotation = (0, $hKNIR._round)(rotation) + deg;
    cache.rotationX = (0, $hKNIR._round)(rotationX) + deg;
    cache.rotationY = (0, $hKNIR._round)(rotationY) + deg;
    cache.skewX = skewX + deg;
    cache.skewY = skewY + deg;
    cache.transformPerspective = perspective + px;
    if (cache.zOrigin = parseFloat(origin.split(" ")[2]) || 0) style[$68b3cc8973e9e281$var$_transformOriginProp] = $68b3cc8973e9e281$var$_firstTwoOnly(origin);
    cache.xOffset = cache.yOffset = 0;
    cache.force3D = (0, $hKNIR._config).force3D;
    cache.renderTransform = cache.svg ? $68b3cc8973e9e281$var$_renderSVGTransforms : $68b3cc8973e9e281$var$_supports3D ? $68b3cc8973e9e281$var$_renderCSSTransforms : $68b3cc8973e9e281$var$_renderNon3DTransforms;
    cache.uncache = 0;
    return cache;
}, $68b3cc8973e9e281$var$_firstTwoOnly = function _firstTwoOnly(value) {
    return (value = value.split(" "))[0] + " " + value[1];
}, //for handling transformOrigin values, stripping out the 3rd dimension
$68b3cc8973e9e281$var$_addPxTranslate = function _addPxTranslate(target, start, value) {
    var unit = (0, $hKNIR.getUnit)(start);
    return (0, $hKNIR._round)(parseFloat(start) + parseFloat($68b3cc8973e9e281$var$_convertToUnit(target, "x", value + "px", unit))) + unit;
}, $68b3cc8973e9e281$var$_renderNon3DTransforms = function _renderNon3DTransforms(ratio, cache) {
    cache.z = "0px";
    cache.rotationY = cache.rotationX = "0deg";
    cache.force3D = 0;
    $68b3cc8973e9e281$var$_renderCSSTransforms(ratio, cache);
}, $68b3cc8973e9e281$var$_zeroDeg = "0deg", $68b3cc8973e9e281$var$_zeroPx = "0px", $68b3cc8973e9e281$var$_endParenthesis = ") ", $68b3cc8973e9e281$var$_renderCSSTransforms = function _renderCSSTransforms(ratio, cache) {
    var _ref = cache || this, xPercent = _ref.xPercent, yPercent = _ref.yPercent, x = _ref.x, y = _ref.y, z = _ref.z, rotation = _ref.rotation, rotationY = _ref.rotationY, rotationX = _ref.rotationX, skewX = _ref.skewX, skewY = _ref.skewY, scaleX = _ref.scaleX, scaleY = _ref.scaleY, transformPerspective = _ref.transformPerspective, force3D = _ref.force3D, target = _ref.target, zOrigin = _ref.zOrigin, transforms = "", use3D = force3D === "auto" && ratio && ratio !== 1 || force3D === true; // Safari has a bug that causes it not to render 3D transform-origin values properly, so we force the z origin to 0, record it in the cache, and then do the math here to offset the translate values accordingly (basically do the 3D transform-origin part manually)
    if (zOrigin && (rotationX !== $68b3cc8973e9e281$var$_zeroDeg || rotationY !== $68b3cc8973e9e281$var$_zeroDeg)) {
        var angle = parseFloat(rotationY) * $68b3cc8973e9e281$var$_DEG2RAD, a13 = Math.sin(angle), a33 = Math.cos(angle), cos;
        angle = parseFloat(rotationX) * $68b3cc8973e9e281$var$_DEG2RAD;
        cos = Math.cos(angle);
        x = $68b3cc8973e9e281$var$_addPxTranslate(target, x, a13 * cos * -zOrigin);
        y = $68b3cc8973e9e281$var$_addPxTranslate(target, y, -Math.sin(angle) * -zOrigin);
        z = $68b3cc8973e9e281$var$_addPxTranslate(target, z, a33 * cos * -zOrigin + zOrigin);
    }
    if (transformPerspective !== $68b3cc8973e9e281$var$_zeroPx) transforms += "perspective(" + transformPerspective + $68b3cc8973e9e281$var$_endParenthesis;
    if (xPercent || yPercent) transforms += "translate(" + xPercent + "%, " + yPercent + "%) ";
    if (use3D || x !== $68b3cc8973e9e281$var$_zeroPx || y !== $68b3cc8973e9e281$var$_zeroPx || z !== $68b3cc8973e9e281$var$_zeroPx) transforms += z !== $68b3cc8973e9e281$var$_zeroPx || use3D ? "translate3d(" + x + ", " + y + ", " + z + ") " : "translate(" + x + ", " + y + $68b3cc8973e9e281$var$_endParenthesis;
    if (rotation !== $68b3cc8973e9e281$var$_zeroDeg) transforms += "rotate(" + rotation + $68b3cc8973e9e281$var$_endParenthesis;
    if (rotationY !== $68b3cc8973e9e281$var$_zeroDeg) transforms += "rotateY(" + rotationY + $68b3cc8973e9e281$var$_endParenthesis;
    if (rotationX !== $68b3cc8973e9e281$var$_zeroDeg) transforms += "rotateX(" + rotationX + $68b3cc8973e9e281$var$_endParenthesis;
    if (skewX !== $68b3cc8973e9e281$var$_zeroDeg || skewY !== $68b3cc8973e9e281$var$_zeroDeg) transforms += "skew(" + skewX + ", " + skewY + $68b3cc8973e9e281$var$_endParenthesis;
    if (scaleX !== 1 || scaleY !== 1) transforms += "scale(" + scaleX + ", " + scaleY + $68b3cc8973e9e281$var$_endParenthesis;
    target.style[$68b3cc8973e9e281$var$_transformProp] = transforms || "translate(0, 0)";
}, $68b3cc8973e9e281$var$_renderSVGTransforms = function _renderSVGTransforms(ratio, cache) {
    var _ref2 = cache || this, xPercent = _ref2.xPercent, yPercent = _ref2.yPercent, x = _ref2.x, y = _ref2.y, rotation = _ref2.rotation, skewX = _ref2.skewX, skewY = _ref2.skewY, scaleX = _ref2.scaleX, scaleY = _ref2.scaleY, target = _ref2.target, xOrigin = _ref2.xOrigin, yOrigin = _ref2.yOrigin, xOffset = _ref2.xOffset, yOffset = _ref2.yOffset, forceCSS = _ref2.forceCSS, tx = parseFloat(x), ty = parseFloat(y), a11, a21, a12, a22, temp;
    rotation = parseFloat(rotation);
    skewX = parseFloat(skewX);
    skewY = parseFloat(skewY);
    if (skewY) {
        //for performance reasons, we combine all skewing into the skewX and rotation values. Remember, a skewY of 10 degrees looks the same as a rotation of 10 degrees plus a skewX of 10 degrees.
        skewY = parseFloat(skewY);
        skewX += skewY;
        rotation += skewY;
    }
    if (rotation || skewX) {
        rotation *= $68b3cc8973e9e281$var$_DEG2RAD;
        skewX *= $68b3cc8973e9e281$var$_DEG2RAD;
        a11 = Math.cos(rotation) * scaleX;
        a21 = Math.sin(rotation) * scaleX;
        a12 = Math.sin(rotation - skewX) * -scaleY;
        a22 = Math.cos(rotation - skewX) * scaleY;
        if (skewX) {
            skewY *= $68b3cc8973e9e281$var$_DEG2RAD;
            temp = Math.tan(skewX - skewY);
            temp = Math.sqrt(1 + temp * temp);
            a12 *= temp;
            a22 *= temp;
            if (skewY) {
                temp = Math.tan(skewY);
                temp = Math.sqrt(1 + temp * temp);
                a11 *= temp;
                a21 *= temp;
            }
        }
        a11 = (0, $hKNIR._round)(a11);
        a21 = (0, $hKNIR._round)(a21);
        a12 = (0, $hKNIR._round)(a12);
        a22 = (0, $hKNIR._round)(a22);
    } else {
        a11 = scaleX;
        a22 = scaleY;
        a21 = a12 = 0;
    }
    if (tx && !~(x + "").indexOf("px") || ty && !~(y + "").indexOf("px")) {
        tx = $68b3cc8973e9e281$var$_convertToUnit(target, "x", x, "px");
        ty = $68b3cc8973e9e281$var$_convertToUnit(target, "y", y, "px");
    }
    if (xOrigin || yOrigin || xOffset || yOffset) {
        tx = (0, $hKNIR._round)(tx + xOrigin - (xOrigin * a11 + yOrigin * a12) + xOffset);
        ty = (0, $hKNIR._round)(ty + yOrigin - (xOrigin * a21 + yOrigin * a22) + yOffset);
    }
    if (xPercent || yPercent) {
        //The SVG spec doesn't support percentage-based translation in the "transform" attribute, so we merge it into the translation to simulate it.
        temp = target.getBBox();
        tx = (0, $hKNIR._round)(tx + xPercent / 100 * temp.width);
        ty = (0, $hKNIR._round)(ty + yPercent / 100 * temp.height);
    }
    temp = "matrix(" + a11 + "," + a21 + "," + a12 + "," + a22 + "," + tx + "," + ty + ")";
    target.setAttribute("transform", temp);
    forceCSS && (target.style[$68b3cc8973e9e281$var$_transformProp] = temp); //some browsers prioritize CSS transforms over the transform attribute. When we sense that the user has CSS transforms applied, we must overwrite them this way (otherwise some browser simply won't render the transform attribute changes!)
}, $68b3cc8973e9e281$var$_addRotationalPropTween = function _addRotationalPropTween(plugin, target, property, startNum, endValue) {
    var cap = 360, isString = (0, $hKNIR._isString)(endValue), endNum = parseFloat(endValue) * (isString && ~endValue.indexOf("rad") ? $68b3cc8973e9e281$var$_RAD2DEG : 1), change = endNum - startNum, finalValue = startNum + change + "deg", direction, pt;
    if (isString) {
        direction = endValue.split("_")[1];
        if (direction === "short") {
            change %= cap;
            if (change !== change % (cap / 2)) change += change < 0 ? cap : -cap;
        }
        if (direction === "cw" && change < 0) change = (change + cap * $68b3cc8973e9e281$var$_bigNum) % cap - ~~(change / cap) * cap;
        else if (direction === "ccw" && change > 0) change = (change - cap * $68b3cc8973e9e281$var$_bigNum) % cap - ~~(change / cap) * cap;
    }
    plugin._pt = pt = new (0, $hKNIR.PropTween)(plugin._pt, target, property, startNum, change, $68b3cc8973e9e281$var$_renderPropWithEnd);
    pt.e = finalValue;
    pt.u = "deg";
    plugin._props.push(property);
    return pt;
}, $68b3cc8973e9e281$var$_assign = function _assign(target, source) {
    // Internet Explorer doesn't have Object.assign(), so we recreate it here.
    for(var p in source)target[p] = source[p];
    return target;
}, $68b3cc8973e9e281$var$_addRawTransformPTs = function _addRawTransformPTs(plugin, transforms, target) {
    //for handling cases where someone passes in a whole transform string, like transform: "scale(2, 3) rotate(20deg) translateY(30em)"
    var startCache = $68b3cc8973e9e281$var$_assign({}, target._gsap), exclude = "perspective,force3D,transformOrigin,svgOrigin", style = target.style, endCache, p, startValue, endValue, startNum, endNum, startUnit, endUnit;
    if (startCache.svg) {
        startValue = target.getAttribute("transform");
        target.setAttribute("transform", "");
        style[$68b3cc8973e9e281$var$_transformProp] = transforms;
        endCache = $68b3cc8973e9e281$var$_parseTransform(target, 1);
        $68b3cc8973e9e281$var$_removeProperty(target, $68b3cc8973e9e281$var$_transformProp);
        target.setAttribute("transform", startValue);
    } else {
        startValue = getComputedStyle(target)[$68b3cc8973e9e281$var$_transformProp];
        style[$68b3cc8973e9e281$var$_transformProp] = transforms;
        endCache = $68b3cc8973e9e281$var$_parseTransform(target, 1);
        style[$68b3cc8973e9e281$var$_transformProp] = startValue;
    }
    for(p in $68b3cc8973e9e281$var$_transformProps){
        startValue = startCache[p];
        endValue = endCache[p];
        if (startValue !== endValue && exclude.indexOf(p) < 0) {
            //tweening to no perspective gives very unintuitive results - just keep the same perspective in that case.
            startUnit = (0, $hKNIR.getUnit)(startValue);
            endUnit = (0, $hKNIR.getUnit)(endValue);
            startNum = startUnit !== endUnit ? $68b3cc8973e9e281$var$_convertToUnit(target, p, startValue, endUnit) : parseFloat(startValue);
            endNum = parseFloat(endValue);
            plugin._pt = new (0, $hKNIR.PropTween)(plugin._pt, endCache, p, startNum, endNum - startNum, $68b3cc8973e9e281$var$_renderCSSProp);
            plugin._pt.u = endUnit || 0;
            plugin._props.push(p);
        }
    }
    $68b3cc8973e9e281$var$_assign(endCache, startCache);
}; // handle splitting apart padding, margin, borderWidth, and borderRadius into their 4 components. Firefox, for example, won't report borderRadius correctly - it will only do borderTopLeftRadius and the other corners. We also want to handle paddingTop, marginLeft, borderRightWidth, etc.
(0, $hKNIR._forEachName)("padding,margin,Width,Radius", function(name, index) {
    var t = "Top", r = "Right", b = "Bottom", l = "Left", props = (index < 3 ? [
        t,
        r,
        b,
        l
    ] : [
        t + l,
        t + r,
        b + r,
        b + l
    ]).map(function(side) {
        return index < 2 ? name + side : "border" + side + name;
    });
    $68b3cc8973e9e281$var$_specialProps[index > 1 ? "border" + name : name] = function(plugin, target, property, endValue, tween) {
        var a, vars;
        if (arguments.length < 4) {
            // getter, passed target, property, and unit (from _get())
            a = props.map(function(prop) {
                return $68b3cc8973e9e281$var$_get(plugin, prop, property);
            });
            vars = a.join(" ");
            return vars.split(a[0]).length === 5 ? a[0] : vars;
        }
        a = (endValue + "").split(" ");
        vars = {};
        props.forEach(function(prop, i) {
            return vars[prop] = a[i] = a[i] || a[(i - 1) / 2 | 0];
        });
        plugin.init(target, vars, tween);
    };
});
var $68b3cc8973e9e281$export$855822f522f18eef = {
    name: "css",
    register: $68b3cc8973e9e281$var$_initCore,
    targetTest: function targetTest(target) {
        return target.style && target.nodeType;
    },
    init: function init(target, vars, tween, index, targets) {
        var props = this._props, style = target.style, startAt = tween.vars.startAt, startValue, endValue, endNum, startNum, type, specialProp, p, startUnit, endUnit, relative, isTransformRelated, transformPropTween, cache, smooth, hasPriority, inlineProps;
        $68b3cc8973e9e281$var$_pluginInitted || $68b3cc8973e9e281$var$_initCore(); // we may call init() multiple times on the same plugin instance, like when adding special properties, so make sure we don't overwrite the revert data or inlineProps
        this.styles = this.styles || $68b3cc8973e9e281$var$_getStyleSaver(target);
        inlineProps = this.styles.props;
        this.tween = tween;
        for(p in vars){
            if (p === "autoRound") continue;
            endValue = vars[p];
            if ((0, $hKNIR._plugins)[p] && (0, $hKNIR._checkPlugin)(p, vars, tween, index, target, targets)) continue;
            type = typeof endValue;
            specialProp = $68b3cc8973e9e281$var$_specialProps[p];
            if (type === "function") {
                endValue = endValue.call(tween, index, target, targets);
                type = typeof endValue;
            }
            if (type === "string" && ~endValue.indexOf("random(")) endValue = (0, $hKNIR._replaceRandom)(endValue);
            if (specialProp) specialProp(this, target, p, endValue, tween) && (hasPriority = 1);
            else if (p.substr(0, 2) === "--") {
                //CSS variable
                startValue = (getComputedStyle(target).getPropertyValue(p) + "").trim();
                endValue += "";
                (0, $hKNIR._colorExp).lastIndex = 0;
                if (!(0, $hKNIR._colorExp).test(startValue)) {
                    // colors don't have units
                    startUnit = (0, $hKNIR.getUnit)(startValue);
                    endUnit = (0, $hKNIR.getUnit)(endValue);
                }
                endUnit ? startUnit !== endUnit && (startValue = $68b3cc8973e9e281$var$_convertToUnit(target, p, startValue, endUnit) + endUnit) : startUnit && (endValue += startUnit);
                this.add(style, "setProperty", startValue, endValue, index, targets, 0, 0, p);
                props.push(p);
                inlineProps.push(p, 0, style[p]);
            } else if (type !== "undefined") {
                if (startAt && p in startAt) {
                    // in case someone hard-codes a complex value as the start, like top: "calc(2vh / 2)". Without this, it'd use the computed value (always in px)
                    startValue = typeof startAt[p] === "function" ? startAt[p].call(tween, index, target, targets) : startAt[p];
                    (0, $hKNIR._isString)(startValue) && ~startValue.indexOf("random(") && (startValue = (0, $hKNIR._replaceRandom)(startValue));
                    (0, $hKNIR.getUnit)(startValue + "") || (startValue += (0, $hKNIR._config).units[p] || (0, $hKNIR.getUnit)($68b3cc8973e9e281$var$_get(target, p)) || ""); // for cases when someone passes in a unitless value like {x: 100}; if we try setting translate(100, 0px) it won't work.
                    (startValue + "").charAt(1) === "=" && (startValue = $68b3cc8973e9e281$var$_get(target, p)); // can't work with relative values
                } else startValue = $68b3cc8973e9e281$var$_get(target, p);
                startNum = parseFloat(startValue);
                relative = type === "string" && endValue.charAt(1) === "=" && endValue.substr(0, 2);
                relative && (endValue = endValue.substr(2));
                endNum = parseFloat(endValue);
                if (p in $68b3cc8973e9e281$var$_propertyAliases) {
                    if (p === "autoAlpha") {
                        //special case where we control the visibility along with opacity. We still allow the opacity value to pass through and get tweened.
                        if (startNum === 1 && $68b3cc8973e9e281$var$_get(target, "visibility") === "hidden" && endNum) //if visibility is initially set to "hidden", we should interpret that as intent to make opacity 0 (a convenience)
                        startNum = 0;
                        inlineProps.push("visibility", 0, style.visibility);
                        $68b3cc8973e9e281$var$_addNonTweeningPT(this, style, "visibility", startNum ? "inherit" : "hidden", endNum ? "inherit" : "hidden", !endNum);
                    }
                    if (p !== "scale" && p !== "transform") {
                        p = $68b3cc8973e9e281$var$_propertyAliases[p];
                        ~p.indexOf(",") && (p = p.split(",")[0]);
                    }
                }
                isTransformRelated = p in $68b3cc8973e9e281$var$_transformProps; //--- TRANSFORM-RELATED ---
                if (isTransformRelated) {
                    this.styles.save(p);
                    if (!transformPropTween) {
                        cache = target._gsap;
                        cache.renderTransform && !vars.parseTransform || $68b3cc8973e9e281$var$_parseTransform(target, vars.parseTransform); // if, for example, gsap.set(... {transform:"translateX(50vw)"}), the _get() call doesn't parse the transform, thus cache.renderTransform won't be set yet so force the parsing of the transform here.
                        smooth = vars.smoothOrigin !== false && cache.smooth;
                        transformPropTween = this._pt = new (0, $hKNIR.PropTween)(this._pt, style, $68b3cc8973e9e281$var$_transformProp, 0, 1, cache.renderTransform, cache, 0, -1); //the first time through, create the rendering PropTween so that it runs LAST (in the linked list, we keep adding to the beginning)
                        transformPropTween.dep = 1; //flag it as dependent so that if things get killed/overwritten and this is the only PropTween left, we can safely kill the whole tween.
                    }
                    if (p === "scale") {
                        this._pt = new (0, $hKNIR.PropTween)(this._pt, cache, "scaleY", cache.scaleY, (relative ? (0, $hKNIR._parseRelative)(cache.scaleY, relative + endNum) : endNum) - cache.scaleY || 0, $68b3cc8973e9e281$var$_renderCSSProp);
                        this._pt.u = 0;
                        props.push("scaleY", p);
                        p += "X";
                    } else if (p === "transformOrigin") {
                        inlineProps.push($68b3cc8973e9e281$var$_transformOriginProp, 0, style[$68b3cc8973e9e281$var$_transformOriginProp]);
                        endValue = $68b3cc8973e9e281$var$_convertKeywordsToPercentages(endValue); //in case something like "left top" or "bottom right" is passed in. Convert to percentages.
                        if (cache.svg) $68b3cc8973e9e281$var$_applySVGOrigin(target, endValue, 0, smooth, 0, this);
                        else {
                            endUnit = parseFloat(endValue.split(" ")[2]) || 0; //handle the zOrigin separately!
                            endUnit !== cache.zOrigin && $68b3cc8973e9e281$var$_addNonTweeningPT(this, cache, "zOrigin", cache.zOrigin, endUnit);
                            $68b3cc8973e9e281$var$_addNonTweeningPT(this, style, p, $68b3cc8973e9e281$var$_firstTwoOnly(startValue), $68b3cc8973e9e281$var$_firstTwoOnly(endValue));
                        }
                        continue;
                    } else if (p === "svgOrigin") {
                        $68b3cc8973e9e281$var$_applySVGOrigin(target, endValue, 1, smooth, 0, this);
                        continue;
                    } else if (p in $68b3cc8973e9e281$var$_rotationalProperties) {
                        $68b3cc8973e9e281$var$_addRotationalPropTween(this, cache, p, startNum, relative ? (0, $hKNIR._parseRelative)(startNum, relative + endValue) : endValue);
                        continue;
                    } else if (p === "smoothOrigin") {
                        $68b3cc8973e9e281$var$_addNonTweeningPT(this, cache, "smooth", cache.smooth, endValue);
                        continue;
                    } else if (p === "force3D") {
                        cache[p] = endValue;
                        continue;
                    } else if (p === "transform") {
                        $68b3cc8973e9e281$var$_addRawTransformPTs(this, endValue, target);
                        continue;
                    }
                } else if (!(p in style)) p = $68b3cc8973e9e281$export$8cbef5dd49a09c8b(p) || p;
                if (isTransformRelated || (endNum || endNum === 0) && (startNum || startNum === 0) && !$68b3cc8973e9e281$var$_complexExp.test(endValue) && p in style) {
                    startUnit = (startValue + "").substr((startNum + "").length);
                    endNum || (endNum = 0); // protect against NaN
                    endUnit = (0, $hKNIR.getUnit)(endValue) || (p in (0, $hKNIR._config).units ? (0, $hKNIR._config).units[p] : startUnit);
                    startUnit !== endUnit && (startNum = $68b3cc8973e9e281$var$_convertToUnit(target, p, startValue, endUnit));
                    this._pt = new (0, $hKNIR.PropTween)(this._pt, isTransformRelated ? cache : style, p, startNum, (relative ? (0, $hKNIR._parseRelative)(startNum, relative + endNum) : endNum) - startNum, !isTransformRelated && (endUnit === "px" || p === "zIndex") && vars.autoRound !== false ? $68b3cc8973e9e281$var$_renderRoundedCSSProp : $68b3cc8973e9e281$var$_renderCSSProp);
                    this._pt.u = endUnit || 0;
                    if (startUnit !== endUnit && endUnit !== "%") {
                        //when the tween goes all the way back to the beginning, we need to revert it to the OLD/ORIGINAL value (with those units). We record that as a "b" (beginning) property and point to a render method that handles that. (performance optimization)
                        this._pt.b = startValue;
                        this._pt.r = $68b3cc8973e9e281$var$_renderCSSPropWithBeginning;
                    }
                } else if (!(p in style)) {
                    if (p in target) //maybe it's not a style - it could be a property added directly to an element in which case we'll try to animate that.
                    this.add(target, p, startValue || target[p], relative ? relative + endValue : endValue, index, targets);
                    else if (p !== "parseTransform") {
                        (0, $hKNIR._missingPlugin)(p, endValue);
                        continue;
                    }
                } else $68b3cc8973e9e281$var$_tweenComplexCSSString.call(this, target, p, startValue, relative ? relative + endValue : endValue);
                isTransformRelated || (p in style ? inlineProps.push(p, 0, style[p]) : inlineProps.push(p, 1, startValue || target[p]));
                props.push(p);
            }
        }
        hasPriority && (0, $hKNIR._sortPropTweensByPriority)(this);
    },
    render: function render(ratio, data) {
        if (data.tween._time || !$68b3cc8973e9e281$var$_reverting()) {
            var pt = data._pt;
            while(pt){
                pt.r(ratio, pt.d);
                pt = pt._next;
            }
        } else data.styles.revert();
    },
    get: $68b3cc8973e9e281$var$_get,
    aliases: $68b3cc8973e9e281$var$_propertyAliases,
    getSetter: function getSetter(target, property, plugin) {
        //returns a setter function that accepts target, property, value and applies it accordingly. Remember, properties like "x" aren't as simple as target.style.property = value because they've got to be applied to a proxy object and then merged into a transform string in a renderer.
        var p = $68b3cc8973e9e281$var$_propertyAliases[property];
        p && p.indexOf(",") < 0 && (property = p);
        return property in $68b3cc8973e9e281$var$_transformProps && property !== $68b3cc8973e9e281$var$_transformOriginProp && (target._gsap.x || $68b3cc8973e9e281$var$_get(target, "x")) ? plugin && $68b3cc8973e9e281$var$_recentSetterPlugin === plugin ? property === "scale" ? $68b3cc8973e9e281$var$_setterScale : $68b3cc8973e9e281$var$_setterTransform : ($68b3cc8973e9e281$var$_recentSetterPlugin = plugin || {}, property === "scale" ? $68b3cc8973e9e281$var$_setterScaleWithRender : $68b3cc8973e9e281$var$_setterTransformWithRender) : target.style && !(0, $hKNIR._isUndefined)(target.style[property]) ? $68b3cc8973e9e281$var$_setterCSSStyle : ~property.indexOf("-") ? $68b3cc8973e9e281$var$_setterCSSProp : (0, $hKNIR._getSetter)(target, property);
    },
    core: {
        _removeProperty: $68b3cc8973e9e281$var$_removeProperty,
        _getMatrix: $68b3cc8973e9e281$var$_getMatrix
    }
};
(0, $hKNIR.gsap).utils.checkPrefix = $68b3cc8973e9e281$export$8cbef5dd49a09c8b;
(0, $hKNIR.gsap).core.getStyleSaver = $68b3cc8973e9e281$var$_getStyleSaver;
(function(positionAndScale, rotation, others, aliases) {
    var all = (0, $hKNIR._forEachName)(positionAndScale + "," + rotation + "," + others, function(name) {
        $68b3cc8973e9e281$var$_transformProps[name] = 1;
    });
    (0, $hKNIR._forEachName)(rotation, function(name) {
        (0, $hKNIR._config).units[name] = "deg";
        $68b3cc8973e9e281$var$_rotationalProperties[name] = 1;
    });
    $68b3cc8973e9e281$var$_propertyAliases[all[13]] = positionAndScale + "," + rotation;
    (0, $hKNIR._forEachName)(aliases, function(name) {
        var split = name.split(":");
        $68b3cc8973e9e281$var$_propertyAliases[split[1]] = all[split[0]];
    });
})("x,y,z,scale,scaleX,scaleY,xPercent,yPercent", "rotation,rotationX,rotationY,skewX,skewY", "transform,transformOrigin,svgOrigin,force3D,smoothOrigin,transformPerspective", "0:translateX,1:translateY,2:translateZ,8:rotate,8:rotationZ,8:rotateZ,9:rotateX,10:rotateY");
(0, $hKNIR._forEachName)("x,y,z,top,right,bottom,left,width,height,fontSize,padding,margin,perspective", function(name) {
    (0, $hKNIR._config).units[name] = "px";
});
(0, $hKNIR.gsap).registerPlugin($68b3cc8973e9e281$export$855822f522f18eef);


var $52be045d3cbb2b80$export$99ee26438460406a = (0, $hKNIR.gsap).registerPlugin((0, $68b3cc8973e9e281$export$855822f522f18eef)) || (0, $hKNIR.gsap), // to protect from tree shaking
$52be045d3cbb2b80$export$7b23975ad686bf91 = $52be045d3cbb2b80$export$99ee26438460406a.core.Tween;







class $816971236b5d7d99$export$c4e9d269599ab4b4 {
    constructor(){
        this.minX = 1 / 0, this.minY = 1 / 0, this.maxX = -1 / 0, this.maxY = -1 / 0, this.rect = null, this.updateID = -1;
    }
    /**
   * Checks if bounds are empty.
   * @returns - True if empty.
   */ isEmpty() {
        return this.minX > this.maxX || this.minY > this.maxY;
    }
    /** Clears the bounds and resets. */ clear() {
        this.minX = 1 / 0, this.minY = 1 / 0, this.maxX = -1 / 0, this.maxY = -1 / 0;
    }
    /**
   * Can return Rectangle.EMPTY constant, either construct new rectangle, either use your rectangle
   * It is not guaranteed that it will return tempRect
   * @param rect - Temporary object will be used if AABB is not empty
   * @returns - A rectangle of the bounds
   */ getRectangle(rect) {
        return this.minX > this.maxX || this.minY > this.maxY ? (0, $200f778d7fdbf8ac$export$4617fb02663045ef).EMPTY : (rect = rect || new (0, $200f778d7fdbf8ac$export$4617fb02663045ef)(0, 0, 1, 1), rect.x = this.minX, rect.y = this.minY, rect.width = this.maxX - this.minX, rect.height = this.maxY - this.minY, rect);
    }
    /**
   * This function should be inlined when its possible.
   * @param point - The point to add.
   */ addPoint(point) {
        this.minX = Math.min(this.minX, point.x), this.maxX = Math.max(this.maxX, point.x), this.minY = Math.min(this.minY, point.y), this.maxY = Math.max(this.maxY, point.y);
    }
    /**
   * Adds a point, after transformed. This should be inlined when its possible.
   * @param matrix
   * @param point
   */ addPointMatrix(matrix, point) {
        const { a: a, b: b, c: c, d: d, tx: tx, ty: ty } = matrix, x = a * point.x + c * point.y + tx, y = b * point.x + d * point.y + ty;
        this.minX = Math.min(this.minX, x), this.maxX = Math.max(this.maxX, x), this.minY = Math.min(this.minY, y), this.maxY = Math.max(this.maxY, y);
    }
    /**
   * Adds a quad, not transformed
   * @param vertices - The verts to add.
   */ addQuad(vertices) {
        let minX = this.minX, minY = this.minY, maxX = this.maxX, maxY = this.maxY, x = vertices[0], y = vertices[1];
        minX = x < minX ? x : minX, minY = y < minY ? y : minY, maxX = x > maxX ? x : maxX, maxY = y > maxY ? y : maxY, x = vertices[2], y = vertices[3], minX = x < minX ? x : minX, minY = y < minY ? y : minY, maxX = x > maxX ? x : maxX, maxY = y > maxY ? y : maxY, x = vertices[4], y = vertices[5], minX = x < minX ? x : minX, minY = y < minY ? y : minY, maxX = x > maxX ? x : maxX, maxY = y > maxY ? y : maxY, x = vertices[6], y = vertices[7], minX = x < minX ? x : minX, minY = y < minY ? y : minY, maxX = x > maxX ? x : maxX, maxY = y > maxY ? y : maxY, this.minX = minX, this.minY = minY, this.maxX = maxX, this.maxY = maxY;
    }
    /**
   * Adds sprite frame, transformed.
   * @param transform - transform to apply
   * @param x0 - left X of frame
   * @param y0 - top Y of frame
   * @param x1 - right X of frame
   * @param y1 - bottom Y of frame
   */ addFrame(transform, x0, y0, x1, y1) {
        this.addFrameMatrix(transform.worldTransform, x0, y0, x1, y1);
    }
    /**
   * Adds sprite frame, multiplied by matrix
   * @param matrix - matrix to apply
   * @param x0 - left X of frame
   * @param y0 - top Y of frame
   * @param x1 - right X of frame
   * @param y1 - bottom Y of frame
   */ addFrameMatrix(matrix, x0, y0, x1, y1) {
        const a = matrix.a, b = matrix.b, c = matrix.c, d = matrix.d, tx = matrix.tx, ty = matrix.ty;
        let minX = this.minX, minY = this.minY, maxX = this.maxX, maxY = this.maxY, x = a * x0 + c * y0 + tx, y = b * x0 + d * y0 + ty;
        minX = x < minX ? x : minX, minY = y < minY ? y : minY, maxX = x > maxX ? x : maxX, maxY = y > maxY ? y : maxY, x = a * x1 + c * y0 + tx, y = b * x1 + d * y0 + ty, minX = x < minX ? x : minX, minY = y < minY ? y : minY, maxX = x > maxX ? x : maxX, maxY = y > maxY ? y : maxY, x = a * x0 + c * y1 + tx, y = b * x0 + d * y1 + ty, minX = x < minX ? x : minX, minY = y < minY ? y : minY, maxX = x > maxX ? x : maxX, maxY = y > maxY ? y : maxY, x = a * x1 + c * y1 + tx, y = b * x1 + d * y1 + ty, minX = x < minX ? x : minX, minY = y < minY ? y : minY, maxX = x > maxX ? x : maxX, maxY = y > maxY ? y : maxY, this.minX = minX, this.minY = minY, this.maxX = maxX, this.maxY = maxY;
    }
    /**
   * Adds screen vertices from array
   * @param vertexData - calculated vertices
   * @param beginOffset - begin offset
   * @param endOffset - end offset, excluded
   */ addVertexData(vertexData, beginOffset, endOffset) {
        let minX = this.minX, minY = this.minY, maxX = this.maxX, maxY = this.maxY;
        for(let i = beginOffset; i < endOffset; i += 2){
            const x = vertexData[i], y = vertexData[i + 1];
            minX = x < minX ? x : minX, minY = y < minY ? y : minY, maxX = x > maxX ? x : maxX, maxY = y > maxY ? y : maxY;
        }
        this.minX = minX, this.minY = minY, this.maxX = maxX, this.maxY = maxY;
    }
    /**
   * Add an array of mesh vertices
   * @param transform - mesh transform
   * @param vertices - mesh coordinates in array
   * @param beginOffset - begin offset
   * @param endOffset - end offset, excluded
   */ addVertices(transform, vertices, beginOffset, endOffset) {
        this.addVerticesMatrix(transform.worldTransform, vertices, beginOffset, endOffset);
    }
    /**
   * Add an array of mesh vertices.
   * @param matrix - mesh matrix
   * @param vertices - mesh coordinates in array
   * @param beginOffset - begin offset
   * @param endOffset - end offset, excluded
   * @param padX - x padding
   * @param padY - y padding
   */ addVerticesMatrix(matrix, vertices, beginOffset, endOffset, padX = 0, padY = padX) {
        const a = matrix.a, b = matrix.b, c = matrix.c, d = matrix.d, tx = matrix.tx, ty = matrix.ty;
        let minX = this.minX, minY = this.minY, maxX = this.maxX, maxY = this.maxY;
        for(let i = beginOffset; i < endOffset; i += 2){
            const rawX = vertices[i], rawY = vertices[i + 1], x = a * rawX + c * rawY + tx, y = d * rawY + b * rawX + ty;
            minX = Math.min(minX, x - padX), maxX = Math.max(maxX, x + padX), minY = Math.min(minY, y - padY), maxY = Math.max(maxY, y + padY);
        }
        this.minX = minX, this.minY = minY, this.maxX = maxX, this.maxY = maxY;
    }
    /**
   * Adds other {@link PIXI.Bounds}.
   * @param bounds - The Bounds to be added
   */ addBounds(bounds) {
        const minX = this.minX, minY = this.minY, maxX = this.maxX, maxY = this.maxY;
        this.minX = bounds.minX < minX ? bounds.minX : minX, this.minY = bounds.minY < minY ? bounds.minY : minY, this.maxX = bounds.maxX > maxX ? bounds.maxX : maxX, this.maxY = bounds.maxY > maxY ? bounds.maxY : maxY;
    }
    /**
   * Adds other Bounds, masked with Bounds.
   * @param bounds - The Bounds to be added.
   * @param mask - TODO
   */ addBoundsMask(bounds, mask) {
        const _minX = bounds.minX > mask.minX ? bounds.minX : mask.minX, _minY = bounds.minY > mask.minY ? bounds.minY : mask.minY, _maxX = bounds.maxX < mask.maxX ? bounds.maxX : mask.maxX, _maxY = bounds.maxY < mask.maxY ? bounds.maxY : mask.maxY;
        if (_minX <= _maxX && _minY <= _maxY) {
            const minX = this.minX, minY = this.minY, maxX = this.maxX, maxY = this.maxY;
            this.minX = _minX < minX ? _minX : minX, this.minY = _minY < minY ? _minY : minY, this.maxX = _maxX > maxX ? _maxX : maxX, this.maxY = _maxY > maxY ? _maxY : maxY;
        }
    }
    /**
   * Adds other Bounds, multiplied by matrix. Bounds shouldn't be empty.
   * @param bounds - other bounds
   * @param matrix - multiplicator
   */ addBoundsMatrix(bounds, matrix) {
        this.addFrameMatrix(matrix, bounds.minX, bounds.minY, bounds.maxX, bounds.maxY);
    }
    /**
   * Adds other Bounds, masked with Rectangle.
   * @param bounds - TODO
   * @param area - TODO
   */ addBoundsArea(bounds, area) {
        const _minX = bounds.minX > area.x ? bounds.minX : area.x, _minY = bounds.minY > area.y ? bounds.minY : area.y, _maxX = bounds.maxX < area.x + area.width ? bounds.maxX : area.x + area.width, _maxY = bounds.maxY < area.y + area.height ? bounds.maxY : area.y + area.height;
        if (_minX <= _maxX && _minY <= _maxY) {
            const minX = this.minX, minY = this.minY, maxX = this.maxX, maxY = this.maxY;
            this.minX = _minX < minX ? _minX : minX, this.minY = _minY < minY ? _minY : minY, this.maxX = _maxX > maxX ? _maxX : maxX, this.maxY = _maxY > maxY ? _maxY : maxY;
        }
    }
    /**
   * Pads bounds object, making it grow in all directions.
   * If paddingY is omitted, both paddingX and paddingY will be set to paddingX.
   * @param paddingX - The horizontal padding amount.
   * @param paddingY - The vertical padding amount.
   */ pad(paddingX = 0, paddingY = paddingX) {
        this.isEmpty() || (this.minX -= paddingX, this.maxX += paddingX, this.minY -= paddingY, this.maxY += paddingY);
    }
    /**
   * Adds padded frame. (x0, y0) should be strictly less than (x1, y1)
   * @param x0 - left X of frame
   * @param y0 - top Y of frame
   * @param x1 - right X of frame
   * @param y1 - bottom Y of frame
   * @param padX - padding X
   * @param padY - padding Y
   */ addFramePad(x0, y0, x1, y1, padX, padY) {
        x0 -= padX, y0 -= padY, x1 += padX, y1 += padY, this.minX = this.minX < x0 ? this.minX : x0, this.maxX = this.maxX > x1 ? this.maxX : x1, this.minY = this.minY < y0 ? this.minY : y0, this.maxY = this.maxY > y1 ? this.maxY : y1;
    }
}


class $469c1c392031bfb3$export$1f679544f90d7d7c extends (0, $db31fc3dfae4939b$exports).EventEmitter {
    constructor(){
        super(), this.tempDisplayObjectParent = null, this.transform = new (0, $cec25acf758d963f$export$563a914cafbdc389)(), this.alpha = 1, this.visible = !0, this.renderable = !0, this.cullable = !1, this.cullArea = null, this.parent = null, this.worldAlpha = 1, this._lastSortedIndex = 0, this._zIndex = 0, this.filterArea = null, this.filters = null, this._enabledFilters = null, this._bounds = new (0, $816971236b5d7d99$export$c4e9d269599ab4b4)(), this._localBounds = null, this._boundsID = 0, this._boundsRect = null, this._localBoundsRect = null, this._mask = null, this._maskRefCount = 0, this._destroyed = !1, this.isSprite = !1, this.isMask = !1;
    }
    /**
   * Mixes all enumerable properties and methods from a source object to DisplayObject.
   * @param source - The source of properties and methods to mix in.
   */ static mixin(source) {
        const keys = Object.keys(source);
        for(let i = 0; i < keys.length; ++i){
            const propertyName = keys[i];
            Object.defineProperty($469c1c392031bfb3$export$1f679544f90d7d7c.prototype, propertyName, Object.getOwnPropertyDescriptor(source, propertyName));
        }
    }
    /**
   * Fired when this DisplayObject is added to a Container.
   * @instance
   * @event added
   * @param {PIXI.Container} container - The container added to.
   */ /**
   * Fired when this DisplayObject is removed from a Container.
   * @instance
   * @event removed
   * @param {PIXI.Container} container - The container removed from.
   */ /**
   * Fired when this DisplayObject is destroyed. This event is emitted once
   * destroy is finished.
   * @instance
   * @event destroyed
   */ /** Readonly flag for destroyed display objects. */ get destroyed() {
        return this._destroyed;
    }
    /** Recursively updates transform of all objects from the root to this one internal function for toLocal() */ _recursivePostUpdateTransform() {
        this.parent ? (this.parent._recursivePostUpdateTransform(), this.transform.updateTransform(this.parent.transform)) : this.transform.updateTransform(this._tempDisplayObjectParent.transform);
    }
    /** Updates the object transform for rendering. TODO - Optimization pass! */ updateTransform() {
        this._boundsID++, this.transform.updateTransform(this.parent.transform), this.worldAlpha = this.alpha * this.parent.worldAlpha;
    }
    /**
   * Calculates and returns the (world) bounds of the display object as a [Rectangle]{@link PIXI.Rectangle}.
   *
   * This method is expensive on containers with a large subtree (like the stage). This is because the bounds
   * of a container depend on its children's bounds, which recursively causes all bounds in the subtree to
   * be recalculated. The upside, however, is that calling `getBounds` once on a container will indeed update
   * the bounds of all children (the whole subtree, in fact). This side effect should be exploited by using
   * `displayObject._bounds.getRectangle()` when traversing through all the bounds in a scene graph. Otherwise,
   * calling `getBounds` on each object in a subtree will cause the total cost to increase quadratically as
   * its height increases.
   *
   * The transforms of all objects in a container's **subtree** and of all **ancestors** are updated.
   * The world bounds of all display objects in a container's **subtree** will also be recalculated.
   *
   * The `_bounds` object stores the last calculation of the bounds. You can use to entirely skip bounds
   * calculation if needed.
   *
   * ```js
   * const lastCalculatedBounds = displayObject._bounds.getRectangle(optionalRect);
   * ```
   *
   * Do know that usage of `getLocalBounds` can corrupt the `_bounds` of children (the whole subtree, actually). This
   * is a known issue that has not been solved. See [getLocalBounds]{@link PIXI.DisplayObject#getLocalBounds} for more
   * details.
   *
   * `getBounds` should be called with `skipUpdate` equal to `true` in a render() call. This is because the transforms
   * are guaranteed to be update-to-date. In fact, recalculating inside a render() call may cause corruption in certain
   * cases.
   * @param skipUpdate - Setting to `true` will stop the transforms of the scene graph from
   *  being updated. This means the calculation returned MAY be out of date BUT will give you a
   *  nice performance boost.
   * @param rect - Optional rectangle to store the result of the bounds calculation.
   * @returns - The minimum axis-aligned rectangle in world space that fits around this object.
   */ getBounds(skipUpdate, rect) {
        return skipUpdate || (this.parent ? (this._recursivePostUpdateTransform(), this.updateTransform()) : (this.parent = this._tempDisplayObjectParent, this.updateTransform(), this.parent = null)), this._bounds.updateID !== this._boundsID && (this.calculateBounds(), this._bounds.updateID = this._boundsID), rect || (this._boundsRect || (this._boundsRect = new (0, $200f778d7fdbf8ac$export$4617fb02663045ef)()), rect = this._boundsRect), this._bounds.getRectangle(rect);
    }
    /**
   * Retrieves the local bounds of the displayObject as a rectangle object.
   * @param rect - Optional rectangle to store the result of the bounds calculation.
   * @returns - The rectangular bounding area.
   */ getLocalBounds(rect) {
        rect || (this._localBoundsRect || (this._localBoundsRect = new (0, $200f778d7fdbf8ac$export$4617fb02663045ef)()), rect = this._localBoundsRect), this._localBounds || (this._localBounds = new (0, $816971236b5d7d99$export$c4e9d269599ab4b4)());
        const transformRef = this.transform, parentRef = this.parent;
        this.parent = null, this._tempDisplayObjectParent.worldAlpha = parentRef?.worldAlpha ?? 1, this.transform = this._tempDisplayObjectParent.transform;
        const worldBounds = this._bounds, worldBoundsID = this._boundsID;
        this._bounds = this._localBounds;
        const bounds = this.getBounds(!1, rect);
        return this.parent = parentRef, this.transform = transformRef, this._bounds = worldBounds, this._bounds.updateID += this._boundsID - worldBoundsID, bounds;
    }
    /**
   * Calculates the global position of the display object.
   * @param position - The world origin to calculate from.
   * @param point - A Point object in which to store the value, optional
   *  (otherwise will create a new Point).
   * @param skipUpdate - Should we skip the update transform.
   * @returns - A point object representing the position of this object.
   */ toGlobal(position, point, skipUpdate = !1) {
        return skipUpdate || (this._recursivePostUpdateTransform(), this.parent ? this.displayObjectUpdateTransform() : (this.parent = this._tempDisplayObjectParent, this.displayObjectUpdateTransform(), this.parent = null)), this.worldTransform.apply(position, point);
    }
    /**
   * Calculates the local position of the display object relative to another point.
   * @param position - The world origin to calculate from.
   * @param from - The DisplayObject to calculate the global position from.
   * @param point - A Point object in which to store the value, optional
   *  (otherwise will create a new Point).
   * @param skipUpdate - Should we skip the update transform
   * @returns - A point object representing the position of this object
   */ toLocal(position, from, point, skipUpdate) {
        return from && (position = from.toGlobal(position, point, skipUpdate)), skipUpdate || (this._recursivePostUpdateTransform(), this.parent ? this.displayObjectUpdateTransform() : (this.parent = this._tempDisplayObjectParent, this.displayObjectUpdateTransform(), this.parent = null)), this.worldTransform.applyInverse(position, point);
    }
    /**
   * Set the parent Container of this DisplayObject.
   * @param container - The Container to add this DisplayObject to.
   * @returns - The Container that this DisplayObject was added to.
   */ setParent(container) {
        if (!container || !container.addChild) throw new Error("setParent: Argument must be a Container");
        return container.addChild(this), container;
    }
    /** Remove the DisplayObject from its parent Container. If the DisplayObject has no parent, do nothing. */ removeFromParent() {
        this.parent?.removeChild(this);
    }
    /**
   * Convenience function to set the position, scale, skew and pivot at once.
   * @param x - The X position
   * @param y - The Y position
   * @param scaleX - The X scale value
   * @param scaleY - The Y scale value
   * @param rotation - The rotation
   * @param skewX - The X skew value
   * @param skewY - The Y skew value
   * @param pivotX - The X pivot value
   * @param pivotY - The Y pivot value
   * @returns - The DisplayObject instance
   */ setTransform(x = 0, y = 0, scaleX = 1, scaleY = 1, rotation = 0, skewX = 0, skewY = 0, pivotX = 0, pivotY = 0) {
        return this.position.x = x, this.position.y = y, this.scale.x = scaleX || 1, this.scale.y = scaleY || 1, this.rotation = rotation, this.skew.x = skewX, this.skew.y = skewY, this.pivot.x = pivotX, this.pivot.y = pivotY, this;
    }
    /**
   * Base destroy method for generic display objects. This will automatically
   * remove the display object from its parent Container as well as remove
   * all current event listeners and internal references. Do not use a DisplayObject
   * after calling `destroy()`.
   * @param _options
   */ destroy(_options) {
        this.removeFromParent(), this._destroyed = !0, this.transform = null, this.parent = null, this._bounds = null, this.mask = null, this.cullArea = null, this.filters = null, this.filterArea = null, this.hitArea = null, this.eventMode = "auto", this.interactiveChildren = !1, this.emit("destroyed"), this.removeAllListeners();
    }
    /**
   * @protected
   * @member {PIXI.Container}
   */ get _tempDisplayObjectParent() {
        return this.tempDisplayObjectParent === null && (this.tempDisplayObjectParent = new $469c1c392031bfb3$export$a35515d77cade20d()), this.tempDisplayObjectParent;
    }
    /**
   * Used in Renderer, cacheAsBitmap and other places where you call an `updateTransform` on root.
   *
   * ```js
   * const cacheParent = elem.enableTempParent();
   * elem.updateTransform();
   * elem.disableTempParent(cacheParent);
   * ```
   * @returns - Current parent
   */ enableTempParent() {
        const myParent = this.parent;
        return this.parent = this._tempDisplayObjectParent, myParent;
    }
    /**
   * Pair method for `enableTempParent`
   * @param cacheParent - Actual parent of element
   */ disableTempParent(cacheParent) {
        this.parent = cacheParent;
    }
    /**
   * The position of the displayObject on the x axis relative to the local coordinates of the parent.
   * An alias to position.x
   */ get x() {
        return this.position.x;
    }
    set x(value) {
        this.transform.position.x = value;
    }
    /**
   * The position of the displayObject on the y axis relative to the local coordinates of the parent.
   * An alias to position.y
   */ get y() {
        return this.position.y;
    }
    set y(value) {
        this.transform.position.y = value;
    }
    /**
   * Current transform of the object based on world (parent) factors.
   * @readonly
   */ get worldTransform() {
        return this.transform.worldTransform;
    }
    /**
   * Current transform of the object based on local factors: position, scale, other stuff.
   * @readonly
   */ get localTransform() {
        return this.transform.localTransform;
    }
    /**
   * The coordinate of the object relative to the local coordinates of the parent.
   * @since 4.0.0
   */ get position() {
        return this.transform.position;
    }
    set position(value) {
        this.transform.position.copyFrom(value);
    }
    /**
   * The scale factors of this object along the local coordinate axes.
   *
   * The default scale is (1, 1).
   * @since 4.0.0
   */ get scale() {
        return this.transform.scale;
    }
    set scale(value) {
        this.transform.scale.copyFrom(value);
    }
    /**
   * The center of rotation, scaling, and skewing for this display object in its local space. The `position`
   * is the projection of `pivot` in the parent's local space.
   *
   * By default, the pivot is the origin (0, 0).
   * @since 4.0.0
   */ get pivot() {
        return this.transform.pivot;
    }
    set pivot(value) {
        this.transform.pivot.copyFrom(value);
    }
    /**
   * The skew factor for the object in radians.
   * @since 4.0.0
   */ get skew() {
        return this.transform.skew;
    }
    set skew(value) {
        this.transform.skew.copyFrom(value);
    }
    /**
   * The rotation of the object in radians.
   * 'rotation' and 'angle' have the same effect on a display object; rotation is in radians, angle is in degrees.
   */ get rotation() {
        return this.transform.rotation;
    }
    set rotation(value) {
        this.transform.rotation = value;
    }
    /**
   * The angle of the object in degrees.
   * 'rotation' and 'angle' have the same effect on a display object; rotation is in radians, angle is in degrees.
   */ get angle() {
        return this.transform.rotation * (0, $e51f17ddb17db7b9$export$3f91627dc85c5d57);
    }
    set angle(value) {
        this.transform.rotation = value * (0, $e51f17ddb17db7b9$export$870617f62e3187f1);
    }
    /**
   * The zIndex of the displayObject.
   *
   * If a container has the sortableChildren property set to true, children will be automatically
   * sorted by zIndex value; a higher value will mean it will be moved towards the end of the array,
   * and thus rendered on top of other display objects within the same container.
   * @see PIXI.Container#sortableChildren
   */ get zIndex() {
        return this._zIndex;
    }
    set zIndex(value) {
        this._zIndex = value, this.parent && (this.parent.sortDirty = !0);
    }
    /**
   * Indicates if the object is globally visible.
   * @readonly
   */ get worldVisible() {
        let item = this;
        do {
            if (!item.visible) return !1;
            item = item.parent;
        }while (item);
        return !0;
    }
    /**
   * Sets a mask for the displayObject. A mask is an object that limits the visibility of an
   * object to the shape of the mask applied to it. In PixiJS a regular mask must be a
   * {@link PIXI.Graphics} or a {@link PIXI.Sprite} object. This allows for much faster masking in canvas as it
   * utilities shape clipping. Furthermore, a mask of an object must be in the subtree of its parent.
   * Otherwise, `getLocalBounds` may calculate incorrect bounds, which makes the container's width and height wrong.
   * To remove a mask, set this property to `null`.
   *
   * For sprite mask both alpha and red channel are used. Black mask is the same as transparent mask.
   * @example
   * import { Graphics, Sprite } from 'pixi.js';
   *
   * const graphics = new Graphics();
   * graphics.beginFill(0xFF3300);
   * graphics.drawRect(50, 250, 100, 100);
   * graphics.endFill();
   *
   * const sprite = new Sprite(texture);
   * sprite.mask = graphics;
   * @todo At the moment, CanvasRenderer doesn't support Sprite as mask.
   */ get mask() {
        return this._mask;
    }
    set mask(value) {
        if (this._mask !== value) {
            if (this._mask) {
                const maskObject = this._mask.isMaskData ? this._mask.maskObject : this._mask;
                maskObject && (maskObject._maskRefCount--, maskObject._maskRefCount === 0 && (maskObject.renderable = !0, maskObject.isMask = !1));
            }
            if (this._mask = value, this._mask) {
                const maskObject = this._mask.isMaskData ? this._mask.maskObject : this._mask;
                maskObject && (maskObject._maskRefCount === 0 && (maskObject.renderable = !1, maskObject.isMask = !0), maskObject._maskRefCount++);
            }
        }
    }
}
class $469c1c392031bfb3$export$a35515d77cade20d extends $469c1c392031bfb3$export$1f679544f90d7d7c {
    constructor(){
        super(...arguments), this.sortDirty = null;
    }
}
$469c1c392031bfb3$export$1f679544f90d7d7c.prototype.displayObjectUpdateTransform = $469c1c392031bfb3$export$1f679544f90d7d7c.prototype.updateTransform;


const $68e6944de5989822$var$tempMatrix = new (0, $d7da222aa639cde0$export$5b12bf1653c0dd85)();
function $68e6944de5989822$var$sortChildren(a, b) {
    return a.zIndex === b.zIndex ? a._lastSortedIndex - b._lastSortedIndex : a.zIndex - b.zIndex;
}
const $68e6944de5989822$var$_Container = class _Container2 extends (0, $469c1c392031bfb3$export$1f679544f90d7d7c) {
    constructor(){
        super(), this.children = [], this.sortableChildren = _Container2.defaultSortableChildren, this.sortDirty = !1;
    }
    /**
   * Overridable method that can be used by Container subclasses whenever the children array is modified.
   * @param _length
   */ onChildrenChange(_length) {}
    /**
   * Adds one or more children to the container.
   *
   * Multiple items can be added like so: `myContainer.addChild(thingOne, thingTwo, thingThree)`
   * @param {...PIXI.DisplayObject} children - The DisplayObject(s) to add to the container
   * @returns {PIXI.DisplayObject} - The first child that was added.
   */ addChild(...children) {
        if (children.length > 1) for(let i = 0; i < children.length; i++)this.addChild(children[i]);
        else {
            const child = children[0];
            child.parent && child.parent.removeChild(child), child.parent = this, this.sortDirty = !0, child.transform._parentID = -1, this.children.push(child), this._boundsID++, this.onChildrenChange(this.children.length - 1), this.emit("childAdded", child, this, this.children.length - 1), child.emit("added", this);
        }
        return children[0];
    }
    /**
   * Adds a child to the container at a specified index. If the index is out of bounds an error will be thrown.
   * If the child is already in this container, it will be moved to the specified index.
   * @param {PIXI.DisplayObject} child - The child to add.
   * @param {number} index - The absolute index where the child will be positioned at the end of the operation.
   * @returns {PIXI.DisplayObject} The child that was added.
   */ addChildAt(child, index) {
        if (index < 0 || index > this.children.length) throw new Error(`${child}addChildAt: The index ${index} supplied is out of bounds ${this.children.length}`);
        return child.parent && child.parent.removeChild(child), child.parent = this, this.sortDirty = !0, child.transform._parentID = -1, this.children.splice(index, 0, child), this._boundsID++, this.onChildrenChange(index), child.emit("added", this), this.emit("childAdded", child, this, index), child;
    }
    /**
   * Swaps the position of 2 Display Objects within this container.
   * @param child - First display object to swap
   * @param child2 - Second display object to swap
   */ swapChildren(child, child2) {
        if (child === child2) return;
        const index1 = this.getChildIndex(child), index2 = this.getChildIndex(child2);
        this.children[index1] = child2, this.children[index2] = child, this.onChildrenChange(index1 < index2 ? index1 : index2);
    }
    /**
   * Returns the index position of a child DisplayObject instance
   * @param child - The DisplayObject instance to identify
   * @returns - The index position of the child display object to identify
   */ getChildIndex(child) {
        const index = this.children.indexOf(child);
        if (index === -1) throw new Error("The supplied DisplayObject must be a child of the caller");
        return index;
    }
    /**
   * Changes the position of an existing child in the display object container
   * @param child - The child DisplayObject instance for which you want to change the index number
   * @param index - The resulting index number for the child display object
   */ setChildIndex(child, index) {
        if (index < 0 || index >= this.children.length) throw new Error(`The index ${index} supplied is out of bounds ${this.children.length}`);
        const currentIndex = this.getChildIndex(child);
        (0, $db31fc3dfae4939b$exports).removeItems(this.children, currentIndex, 1), this.children.splice(index, 0, child), this.onChildrenChange(index);
    }
    /**
   * Returns the child at the specified index
   * @param index - The index to get the child at
   * @returns - The child at the given index, if any.
   */ getChildAt(index) {
        if (index < 0 || index >= this.children.length) throw new Error(`getChildAt: Index (${index}) does not exist.`);
        return this.children[index];
    }
    /**
   * Removes one or more children from the container.
   * @param {...PIXI.DisplayObject} children - The DisplayObject(s) to remove
   * @returns {PIXI.DisplayObject} The first child that was removed.
   */ removeChild(...children) {
        if (children.length > 1) for(let i = 0; i < children.length; i++)this.removeChild(children[i]);
        else {
            const child = children[0], index = this.children.indexOf(child);
            if (index === -1) return null;
            child.parent = null, child.transform._parentID = -1, (0, $db31fc3dfae4939b$exports).removeItems(this.children, index, 1), this._boundsID++, this.onChildrenChange(index), child.emit("removed", this), this.emit("childRemoved", child, this, index);
        }
        return children[0];
    }
    /**
   * Removes a child from the specified index position.
   * @param index - The index to get the child from
   * @returns The child that was removed.
   */ removeChildAt(index) {
        const child = this.getChildAt(index);
        return child.parent = null, child.transform._parentID = -1, (0, $db31fc3dfae4939b$exports).removeItems(this.children, index, 1), this._boundsID++, this.onChildrenChange(index), child.emit("removed", this), this.emit("childRemoved", child, this, index), child;
    }
    /**
   * Removes all children from this container that are within the begin and end indexes.
   * @param beginIndex - The beginning position.
   * @param endIndex - The ending position. Default value is size of the container.
   * @returns - List of removed children
   */ removeChildren(beginIndex = 0, endIndex = this.children.length) {
        const begin = beginIndex, end = endIndex, range = end - begin;
        let removed;
        if (range > 0 && range <= end) {
            removed = this.children.splice(begin, range);
            for(let i = 0; i < removed.length; ++i)removed[i].parent = null, removed[i].transform && (removed[i].transform._parentID = -1);
            this._boundsID++, this.onChildrenChange(beginIndex);
            for(let i = 0; i < removed.length; ++i)removed[i].emit("removed", this), this.emit("childRemoved", removed[i], this, i);
            return removed;
        } else if (range === 0 && this.children.length === 0) return [];
        throw new RangeError("removeChildren: numeric values are outside the acceptable range.");
    }
    /** Sorts children by zIndex. Previous order is maintained for 2 children with the same zIndex. */ sortChildren() {
        let sortRequired = !1;
        for(let i = 0, j = this.children.length; i < j; ++i){
            const child = this.children[i];
            child._lastSortedIndex = i, !sortRequired && child.zIndex !== 0 && (sortRequired = !0);
        }
        sortRequired && this.children.length > 1 && this.children.sort($68e6944de5989822$var$sortChildren), this.sortDirty = !1;
    }
    /** Updates the transform on all children of this container for rendering. */ updateTransform() {
        this.sortableChildren && this.sortDirty && this.sortChildren(), this._boundsID++, this.transform.updateTransform(this.parent.transform), this.worldAlpha = this.alpha * this.parent.worldAlpha;
        for(let i = 0, j = this.children.length; i < j; ++i){
            const child = this.children[i];
            child.visible && child.updateTransform();
        }
    }
    /**
   * Recalculates the bounds of the container.
   *
   * This implementation will automatically fit the children's bounds into the calculation. Each child's bounds
   * is limited to its mask's bounds or filterArea, if any is applied.
   */ calculateBounds() {
        this._bounds.clear(), this._calculateBounds();
        for(let i = 0; i < this.children.length; i++){
            const child = this.children[i];
            if (!(!child.visible || !child.renderable)) {
                if (child.calculateBounds(), child._mask) {
                    const maskObject = child._mask.isMaskData ? child._mask.maskObject : child._mask;
                    maskObject ? (maskObject.calculateBounds(), this._bounds.addBoundsMask(child._bounds, maskObject._bounds)) : this._bounds.addBounds(child._bounds);
                } else child.filterArea ? this._bounds.addBoundsArea(child._bounds, child.filterArea) : this._bounds.addBounds(child._bounds);
            }
        }
        this._bounds.updateID = this._boundsID;
    }
    /**
   * Retrieves the local bounds of the displayObject as a rectangle object.
   *
   * Calling `getLocalBounds` may invalidate the `_bounds` of the whole subtree below. If using it inside a render()
   * call, it is advised to call `getBounds()` immediately after to recalculate the world bounds of the subtree.
   * @param rect - Optional rectangle to store the result of the bounds calculation.
   * @param skipChildrenUpdate - Setting to `true` will stop re-calculation of children transforms,
   *  it was default behaviour of pixi 4.0-5.2 and caused many problems to users.
   * @returns - The rectangular bounding area.
   */ getLocalBounds(rect, skipChildrenUpdate = !1) {
        const result = super.getLocalBounds(rect);
        if (!skipChildrenUpdate) for(let i = 0, j = this.children.length; i < j; ++i){
            const child = this.children[i];
            child.visible && child.updateTransform();
        }
        return result;
    }
    /**
   * Recalculates the content bounds of this object. This should be overriden to
   * calculate the bounds of this specific object (not including children).
   * @protected
   */ _calculateBounds() {}
    /**
   * Renders this object and its children with culling.
   * @protected
   * @param {PIXI.Renderer} renderer - The renderer
   */ _renderWithCulling(renderer) {
        const sourceFrame = renderer.renderTexture.sourceFrame;
        if (!(sourceFrame.width > 0 && sourceFrame.height > 0)) return;
        let bounds, transform;
        this.cullArea ? (bounds = this.cullArea, transform = this.worldTransform) : this._render !== _Container2.prototype._render && (bounds = this.getBounds(!0));
        const projectionTransform = renderer.projection.transform;
        if (projectionTransform && (transform ? (transform = $68e6944de5989822$var$tempMatrix.copyFrom(transform), transform.prepend(projectionTransform)) : transform = projectionTransform), bounds && sourceFrame.intersects(bounds, transform)) this._render(renderer);
        else if (this.cullArea) return;
        for(let i = 0, j = this.children.length; i < j; ++i){
            const child = this.children[i], childCullable = child.cullable;
            child.cullable = childCullable || !this.cullArea, child.render(renderer), child.cullable = childCullable;
        }
    }
    /**
   * Renders the object using the WebGL renderer.
   *
   * The [_render]{@link PIXI.Container#_render} method is be overriden for rendering the contents of the
   * container itself. This `render` method will invoke it, and also invoke the `render` methods of all
   * children afterward.
   *
   * If `renderable` or `visible` is false or if `worldAlpha` is not positive or if `cullable` is true and
   * the bounds of this object are out of frame, this implementation will entirely skip rendering.
   * See {@link PIXI.DisplayObject} for choosing between `renderable` or `visible`. Generally,
   * setting alpha to zero is not recommended for purely skipping rendering.
   *
   * When your scene becomes large (especially when it is larger than can be viewed in a single screen), it is
   * advised to employ **culling** to automatically skip rendering objects outside of the current screen.
   * See [cullable]{@link PIXI.DisplayObject#cullable} and [cullArea]{@link PIXI.DisplayObject#cullArea}.
   * Other culling methods might be better suited for a large number static objects; see
   * [@pixi-essentials/cull]{@link https://www.npmjs.com/package/@pixi-essentials/cull} and
   * [pixi-cull]{@link https://www.npmjs.com/package/pixi-cull}.
   *
   * The [renderAdvanced]{@link PIXI.Container#renderAdvanced} method is internally used when when masking or
   * filtering is applied on a container. This does, however, break batching and can affect performance when
   * masking and filtering is applied extensively throughout the scene graph.
   * @param renderer - The renderer
   */ render(renderer) {
        if (!(!this.visible || this.worldAlpha <= 0 || !this.renderable)) {
            if (this._mask || this.filters?.length) this.renderAdvanced(renderer);
            else if (this.cullable) this._renderWithCulling(renderer);
            else {
                this._render(renderer);
                for(let i = 0, j = this.children.length; i < j; ++i)this.children[i].render(renderer);
            }
        }
    }
    /**
   * Render the object using the WebGL renderer and advanced features.
   * @param renderer - The renderer
   */ renderAdvanced(renderer) {
        const filters = this.filters, mask = this._mask;
        if (filters) {
            this._enabledFilters || (this._enabledFilters = []), this._enabledFilters.length = 0;
            for(let i = 0; i < filters.length; i++)filters[i].enabled && this._enabledFilters.push(filters[i]);
        }
        const flush = filters && this._enabledFilters?.length || mask && (!mask.isMaskData || mask.enabled && (mask.autoDetect || mask.type !== (0, $0fa4b07f86297abd$export$dbbea138c5d144).NONE));
        if (flush && renderer.batch.flush(), filters && this._enabledFilters?.length && renderer.filter.push(this, this._enabledFilters), mask && renderer.mask.push(this, this._mask), this.cullable) this._renderWithCulling(renderer);
        else {
            this._render(renderer);
            for(let i = 0, j = this.children.length; i < j; ++i)this.children[i].render(renderer);
        }
        flush && renderer.batch.flush(), mask && renderer.mask.pop(this), filters && this._enabledFilters?.length && renderer.filter.pop();
    }
    /**
   * To be overridden by the subclasses.
   * @param _renderer - The renderer
   */ _render(_renderer) {}
    /**
   * Removes all internal references and listeners as well as removes children from the display list.
   * Do not use a Container after calling `destroy`.
   * @param options - Options parameter. A boolean will act as if all options
   *  have been set to that value
   * @param {boolean} [options.children=false] - if set to true, all the children will have their destroy
   *  method called as well. 'options' will be passed on to those calls.
   * @param {boolean} [options.texture=false] - Only used for child Sprites if options.children is set to true
   *  Should it destroy the texture of the child sprite
   * @param {boolean} [options.baseTexture=false] - Only used for child Sprites if options.children is set to true
   *  Should it destroy the base texture of the child sprite
   */ destroy(options) {
        super.destroy(), this.sortDirty = !1;
        const destroyChildren = typeof options == "boolean" ? options : options?.children, oldChildren = this.removeChildren(0, this.children.length);
        if (destroyChildren) for(let i = 0; i < oldChildren.length; ++i)oldChildren[i].destroy(options);
    }
    /** The width of the Container, setting this will actually modify the scale to achieve the value set. */ get width() {
        return this.scale.x * this.getLocalBounds().width;
    }
    set width(value) {
        const width = this.getLocalBounds().width;
        width !== 0 ? this.scale.x = value / width : this.scale.x = 1, this._width = value;
    }
    /** The height of the Container, setting this will actually modify the scale to achieve the value set. */ get height() {
        return this.scale.y * this.getLocalBounds().height;
    }
    set height(value) {
        const height = this.getLocalBounds().height;
        height !== 0 ? this.scale.y = value / height : this.scale.y = 1, this._height = value;
    }
};
$68e6944de5989822$var$_Container.defaultSortableChildren = !1;
let $68e6944de5989822$export$42a852a2b6b56249 = $68e6944de5989822$var$_Container;
$68e6944de5989822$export$42a852a2b6b56249.prototype.containerUpdateTransform = $68e6944de5989822$export$42a852a2b6b56249.prototype.updateTransform;


Object.defineProperties((0, $2808efac47e52be0$export$a5a6e0b888b2c992), {
    /**
   * Sets the default value for the container property 'sortableChildren'.
   * @static
   * @name SORTABLE_CHILDREN
   * @memberof PIXI.settings
   * @deprecated since 7.1.0
   * @type {boolean}
   * @see PIXI.Container.defaultSortableChildren
   */ SORTABLE_CHILDREN: {
        get () {
            return (0, $68e6944de5989822$export$42a852a2b6b56249).defaultSortableChildren;
        },
        set (value) {
            (0, $db31fc3dfae4939b$exports).deprecation("7.1.0", "settings.SORTABLE_CHILDREN is deprecated, use Container.defaultSortableChildren"), (0, $68e6944de5989822$export$42a852a2b6b56249).defaultSortableChildren = value;
        }
    }
});







var $b4245adbfe6bbe42$var$S = Object.defineProperty;
var $b4245adbfe6bbe42$var$M = (c, r, t)=>r in c ? $b4245adbfe6bbe42$var$S(c, r, {
        enumerable: !0,
        configurable: !0,
        writable: !0,
        value: t
    }) : c[r] = t;
var $b4245adbfe6bbe42$var$o = (c, r, t)=>($b4245adbfe6bbe42$var$M(c, typeof r != "symbol" ? r + "" : r, t), t);
class $b4245adbfe6bbe42$export$901cf72dabf2112a {
    constructor(r){
        $b4245adbfe6bbe42$var$o(this, "parent");
        $b4245adbfe6bbe42$var$o(this, "paused");
        this.parent = r, this.paused = !1;
    }
    destroy() {}
    down(r) {
        return !1;
    }
    move(r) {
        return !1;
    }
    up(r) {
        return !1;
    }
    wheel(r) {
        return !1;
    }
    update(r) {}
    resize() {}
    reset() {}
    pause() {
        this.paused = !0;
    }
    resume() {
        this.paused = !1;
    }
}
var $b4245adbfe6bbe42$var$C = typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : typeof $parcel$global < "u" ? $parcel$global : typeof self < "u" ? self : {}, $b4245adbfe6bbe42$var$H = {
    exports: {}
};
(function(c, r) {
    (function() {
        var t, i;
        i = function(e) {
            return c.exports = e;
        }, t = {
            linear: function(e, n, s, h) {
                return s * e / h + n;
            },
            easeInQuad: function(e, n, s, h) {
                return s * (e /= h) * e + n;
            },
            easeOutQuad: function(e, n, s, h) {
                return -s * (e /= h) * (e - 2) + n;
            },
            easeInOutQuad: function(e, n, s, h) {
                return (e /= h / 2) < 1 ? s / 2 * e * e + n : -s / 2 * (--e * (e - 2) - 1) + n;
            },
            easeInCubic: function(e, n, s, h) {
                return s * (e /= h) * e * e + n;
            },
            easeOutCubic: function(e, n, s, h) {
                return s * ((e = e / h - 1) * e * e + 1) + n;
            },
            easeInOutCubic: function(e, n, s, h) {
                return (e /= h / 2) < 1 ? s / 2 * e * e * e + n : s / 2 * ((e -= 2) * e * e + 2) + n;
            },
            easeInQuart: function(e, n, s, h) {
                return s * (e /= h) * e * e * e + n;
            },
            easeOutQuart: function(e, n, s, h) {
                return -s * ((e = e / h - 1) * e * e * e - 1) + n;
            },
            easeInOutQuart: function(e, n, s, h) {
                return (e /= h / 2) < 1 ? s / 2 * e * e * e * e + n : -s / 2 * ((e -= 2) * e * e * e - 2) + n;
            },
            easeInQuint: function(e, n, s, h) {
                return s * (e /= h) * e * e * e * e + n;
            },
            easeOutQuint: function(e, n, s, h) {
                return s * ((e = e / h - 1) * e * e * e * e + 1) + n;
            },
            easeInOutQuint: function(e, n, s, h) {
                return (e /= h / 2) < 1 ? s / 2 * e * e * e * e * e + n : s / 2 * ((e -= 2) * e * e * e * e + 2) + n;
            },
            easeInSine: function(e, n, s, h) {
                return -s * Math.cos(e / h * (Math.PI / 2)) + s + n;
            },
            easeOutSine: function(e, n, s, h) {
                return s * Math.sin(e / h * (Math.PI / 2)) + n;
            },
            easeInOutSine: function(e, n, s, h) {
                return -s / 2 * (Math.cos(Math.PI * e / h) - 1) + n;
            },
            easeInExpo: function(e, n, s, h) {
                return e === 0 ? n : s * Math.pow(2, 10 * (e / h - 1)) + n;
            },
            easeOutExpo: function(e, n, s, h) {
                return e === h ? n + s : s * (-Math.pow(2, -10 * e / h) + 1) + n;
            },
            easeInOutExpo: function(e, n, s, h) {
                return (e /= h / 2) < 1 ? s / 2 * Math.pow(2, 10 * (e - 1)) + n : s / 2 * (-Math.pow(2, -10 * --e) + 2) + n;
            },
            easeInCirc: function(e, n, s, h) {
                return -s * (Math.sqrt(1 - (e /= h) * e) - 1) + n;
            },
            easeOutCirc: function(e, n, s, h) {
                return s * Math.sqrt(1 - (e = e / h - 1) * e) + n;
            },
            easeInOutCirc: function(e, n, s, h) {
                return (e /= h / 2) < 1 ? -s / 2 * (Math.sqrt(1 - e * e) - 1) + n : s / 2 * (Math.sqrt(1 - (e -= 2) * e) + 1) + n;
            },
            easeInElastic: function(e, n, s, h) {
                var a, p, l;
                return l = 1.70158, p = 0, a = s, e === 0 || (e /= h), p || (p = h * 0.3), a < Math.abs(s) ? (a = s, l = p / 4) : l = p / (2 * Math.PI) * Math.asin(s / a), -(a * Math.pow(2, 10 * (e -= 1)) * Math.sin((e * h - l) * (2 * Math.PI) / p)) + n;
            },
            easeOutElastic: function(e, n, s, h) {
                var a, p, l;
                return l = 1.70158, p = 0, a = s, e === 0 || (e /= h), p || (p = h * 0.3), a < Math.abs(s) ? (a = s, l = p / 4) : l = p / (2 * Math.PI) * Math.asin(s / a), a * Math.pow(2, -10 * e) * Math.sin((e * h - l) * (2 * Math.PI) / p) + s + n;
            },
            easeInOutElastic: function(e, n, s, h) {
                var a, p, l;
                return l = 1.70158, p = 0, a = s, e === 0 || (e /= h / 2), p || (p = h * (0.3 * 1.5)), a < Math.abs(s) ? (a = s, l = p / 4) : l = p / (2 * Math.PI) * Math.asin(s / a), e < 1 ? -0.5 * (a * Math.pow(2, 10 * (e -= 1)) * Math.sin((e * h - l) * (2 * Math.PI) / p)) + n : a * Math.pow(2, -10 * (e -= 1)) * Math.sin((e * h - l) * (2 * Math.PI) / p) * 0.5 + s + n;
            },
            easeInBack: function(e, n, s, h, a) {
                return a === void 0 && (a = 1.70158), s * (e /= h) * e * ((a + 1) * e - a) + n;
            },
            easeOutBack: function(e, n, s, h, a) {
                return a === void 0 && (a = 1.70158), s * ((e = e / h - 1) * e * ((a + 1) * e + a) + 1) + n;
            },
            easeInOutBack: function(e, n, s, h, a) {
                return a === void 0 && (a = 1.70158), (e /= h / 2) < 1 ? s / 2 * (e * e * (((a *= 1.525) + 1) * e - a)) + n : s / 2 * ((e -= 2) * e * (((a *= 1.525) + 1) * e + a) + 2) + n;
            },
            easeInBounce: function(e, n, s, h) {
                var a;
                return a = t.easeOutBounce(h - e, 0, s, h), s - a + n;
            },
            easeOutBounce: function(e, n, s, h) {
                return (e /= h) < 1 / 2.75 ? s * (7.5625 * e * e) + n : e < 2 / 2.75 ? s * (7.5625 * (e -= 1.5 / 2.75) * e + 0.75) + n : e < 2.5 / 2.75 ? s * (7.5625 * (e -= 2.25 / 2.75) * e + 0.9375) + n : s * (7.5625 * (e -= 2.625 / 2.75) * e + 0.984375) + n;
            },
            easeInOutBounce: function(e, n, s, h) {
                var a;
                return e < h / 2 ? (a = t.easeInBounce(e * 2, 0, s, h), a * 0.5 + n) : (a = t.easeOutBounce(e * 2 - h, 0, s, h), a * 0.5 + s * 0.5 + n);
            }
        }, i(t);
    }).call($b4245adbfe6bbe42$var$C);
})($b4245adbfe6bbe42$var$H);
const $b4245adbfe6bbe42$var$b = $b4245adbfe6bbe42$var$H.exports;
function $b4245adbfe6bbe42$var$W(c, r) {
    if (c) {
        if (typeof c == "function") return c;
        if (typeof c == "string") return $b4245adbfe6bbe42$var$b[c];
    } else return $b4245adbfe6bbe42$var$b[r];
}
const $b4245adbfe6bbe42$var$I = {
    removeOnInterrupt: !1,
    ease: "linear",
    time: 1e3
};
class $b4245adbfe6bbe42$export$83a1293bbde53b95 extends $b4245adbfe6bbe42$export$901cf72dabf2112a {
    constructor(t, i = {}){
        super(t);
        $b4245adbfe6bbe42$var$o(this, "options");
        $b4245adbfe6bbe42$var$o(this, "startX");
        $b4245adbfe6bbe42$var$o(this, "startY");
        $b4245adbfe6bbe42$var$o(this, "deltaX");
        $b4245adbfe6bbe42$var$o(this, "deltaY");
        $b4245adbfe6bbe42$var$o(this, "keepCenter");
        $b4245adbfe6bbe42$var$o(this, "startWidth", null);
        $b4245adbfe6bbe42$var$o(this, "startHeight", null);
        $b4245adbfe6bbe42$var$o(this, "deltaWidth", null);
        $b4245adbfe6bbe42$var$o(this, "deltaHeight", null);
        $b4245adbfe6bbe42$var$o(this, "width", null);
        $b4245adbfe6bbe42$var$o(this, "height", null);
        $b4245adbfe6bbe42$var$o(this, "time", 0);
        this.options = Object.assign({}, $b4245adbfe6bbe42$var$I, i), this.options.ease = $b4245adbfe6bbe42$var$W(this.options.ease), this.setupPosition(), this.setupZoom(), this.time = 0;
    }
    setupPosition() {
        typeof this.options.position < "u" ? (this.startX = this.parent.center.x, this.startY = this.parent.center.y, this.deltaX = this.options.position.x - this.parent.center.x, this.deltaY = this.options.position.y - this.parent.center.y, this.keepCenter = !1) : this.keepCenter = !0;
    }
    setupZoom() {
        this.width = null, this.height = null, typeof this.options.scale < "u" ? this.width = this.parent.screenWidth / this.options.scale : typeof this.options.scaleX < "u" || typeof this.options.scaleY < "u" ? (typeof this.options.scaleX < "u" && (this.width = this.parent.screenWidth / this.options.scaleX), typeof this.options.scaleY < "u" && (this.height = this.parent.screenHeight / this.options.scaleY)) : (typeof this.options.width < "u" && (this.width = this.options.width), typeof this.options.height < "u" && (this.height = this.options.height)), this.width !== null && (this.startWidth = this.parent.screenWidthInWorldPixels, this.deltaWidth = this.width - this.startWidth), this.height !== null && (this.startHeight = this.parent.screenHeightInWorldPixels, this.deltaHeight = this.height - this.startHeight);
    }
    down() {
        return this.options.removeOnInterrupt && this.parent.plugins.remove("animate"), !1;
    }
    complete() {
        this.parent.plugins.remove("animate"), this.width !== null && this.parent.fitWidth(this.width, this.keepCenter, this.height === null), this.height !== null && this.parent.fitHeight(this.height, this.keepCenter, this.width === null), !this.keepCenter && this.options.position && this.parent.moveCenter(this.options.position), this.parent.emit("animate-end", this.parent), this.options.callbackOnComplete && this.options.callbackOnComplete(this.parent);
    }
    update(t) {
        if (this.paused) return;
        this.time += t;
        const i = new (0, $cf3018b4309864c2$export$baf26146a414f24a)(this.parent.scale.x, this.parent.scale.y);
        if (this.time >= this.options.time) {
            const e = this.parent.width, n = this.parent.height;
            this.complete(), (e !== this.parent.width || n !== this.parent.height) && this.parent.emit("zoomed", {
                viewport: this.parent,
                original: i,
                type: "animate"
            });
        } else {
            const e = this.options.ease(this.time, 0, 1, this.options.time);
            if (this.width !== null) {
                const n = this.startWidth, s = this.deltaWidth;
                this.parent.fitWidth(n + s * e, this.keepCenter, this.height === null);
            }
            if (this.height !== null) {
                const n = this.startHeight, s = this.deltaHeight;
                this.parent.fitHeight(n + s * e, this.keepCenter, this.width === null);
            }
            if (this.width === null ? this.parent.scale.x = this.parent.scale.y : this.height === null && (this.parent.scale.y = this.parent.scale.x), !this.keepCenter) {
                const n = this.startX, s = this.startY, h = this.deltaX, a = this.deltaY, p = new (0, $cf3018b4309864c2$export$baf26146a414f24a)(this.parent.x, this.parent.y);
                this.parent.moveCenter(n + h * e, s + a * e), this.parent.emit("moved", {
                    viewport: this.parent,
                    original: p,
                    type: "animate"
                });
            }
            (this.width || this.height) && this.parent.emit("zoomed", {
                viewport: this.parent,
                original: i,
                type: "animate"
            });
        }
    }
}
const $b4245adbfe6bbe42$var$Y = {
    sides: "all",
    friction: 0.5,
    time: 150,
    ease: "easeInOutSine",
    underflow: "center",
    bounceBox: null
};
class $b4245adbfe6bbe42$export$d20e79fdc3899e95 extends $b4245adbfe6bbe42$export$901cf72dabf2112a {
    constructor(t, i = {}){
        super(t);
        $b4245adbfe6bbe42$var$o(this, "options");
        $b4245adbfe6bbe42$var$o(this, "left");
        $b4245adbfe6bbe42$var$o(this, "top");
        $b4245adbfe6bbe42$var$o(this, "right");
        $b4245adbfe6bbe42$var$o(this, "bottom");
        $b4245adbfe6bbe42$var$o(this, "underflowX");
        $b4245adbfe6bbe42$var$o(this, "underflowY");
        $b4245adbfe6bbe42$var$o(this, "ease");
        $b4245adbfe6bbe42$var$o(this, "toX");
        $b4245adbfe6bbe42$var$o(this, "toY");
        this.options = Object.assign({}, $b4245adbfe6bbe42$var$Y, i), this.ease = $b4245adbfe6bbe42$var$W(this.options.ease, "easeInOutSine"), this.options.sides ? this.options.sides === "all" ? this.top = this.bottom = this.left = this.right = !0 : this.options.sides === "horizontal" ? (this.right = this.left = !0, this.top = this.bottom = !1) : this.options.sides === "vertical" ? (this.left = this.right = !1, this.top = this.bottom = !0) : (this.top = this.options.sides.indexOf("top") !== -1, this.bottom = this.options.sides.indexOf("bottom") !== -1, this.left = this.options.sides.indexOf("left") !== -1, this.right = this.options.sides.indexOf("right") !== -1) : this.left = this.top = this.right = this.bottom = !1;
        const e = this.options.underflow.toLowerCase();
        e === "center" ? (this.underflowX = 0, this.underflowY = 0) : (this.underflowX = e.indexOf("left") !== -1 ? -1 : e.indexOf("right") !== -1 ? 1 : 0, this.underflowY = e.indexOf("top") !== -1 ? -1 : e.indexOf("bottom") !== -1 ? 1 : 0), this.reset();
    }
    isActive() {
        return this.toX !== null || this.toY !== null;
    }
    down() {
        return this.toX = this.toY = null, !1;
    }
    up() {
        return this.bounce(), !1;
    }
    update(t) {
        if (!this.paused) {
            if (this.bounce(), this.toX) {
                const i = this.toX;
                i.time += t, this.parent.emit("moved", {
                    viewport: this.parent,
                    type: "bounce-x"
                }), i.time >= this.options.time ? (this.parent.x = i.end, this.toX = null, this.parent.emit("bounce-x-end", this.parent)) : this.parent.x = this.ease(i.time, i.start, i.delta, this.options.time);
            }
            if (this.toY) {
                const i = this.toY;
                i.time += t, this.parent.emit("moved", {
                    viewport: this.parent,
                    type: "bounce-y"
                }), i.time >= this.options.time ? (this.parent.y = i.end, this.toY = null, this.parent.emit("bounce-y-end", this.parent)) : this.parent.y = this.ease(i.time, i.start, i.delta, this.options.time);
            }
        }
    }
    calcUnderflowX() {
        let t;
        switch(this.underflowX){
            case -1:
                t = 0;
                break;
            case 1:
                t = this.parent.screenWidth - this.parent.screenWorldWidth;
                break;
            default:
                t = (this.parent.screenWidth - this.parent.screenWorldWidth) / 2;
        }
        return t;
    }
    calcUnderflowY() {
        let t;
        switch(this.underflowY){
            case -1:
                t = 0;
                break;
            case 1:
                t = this.parent.screenHeight - this.parent.screenWorldHeight;
                break;
            default:
                t = (this.parent.screenHeight - this.parent.screenWorldHeight) / 2;
        }
        return t;
    }
    oob() {
        const t = this.options.bounceBox;
        if (t) {
            const i = typeof t.x > "u" ? 0 : t.x, e = typeof t.y > "u" ? 0 : t.y, n = typeof t.width > "u" ? this.parent.worldWidth : t.width, s = typeof t.height > "u" ? this.parent.worldHeight : t.height;
            return {
                left: this.parent.left < i,
                right: this.parent.right > n,
                top: this.parent.top < e,
                bottom: this.parent.bottom > s,
                topLeft: new (0, $cf3018b4309864c2$export$baf26146a414f24a)(i * this.parent.scale.x, e * this.parent.scale.y),
                bottomRight: new (0, $cf3018b4309864c2$export$baf26146a414f24a)(n * this.parent.scale.x - this.parent.screenWidth, s * this.parent.scale.y - this.parent.screenHeight)
            };
        }
        return {
            left: this.parent.left < 0,
            right: this.parent.right > this.parent.worldWidth,
            top: this.parent.top < 0,
            bottom: this.parent.bottom > this.parent.worldHeight,
            topLeft: new (0, $cf3018b4309864c2$export$baf26146a414f24a)(0, 0),
            bottomRight: new (0, $cf3018b4309864c2$export$baf26146a414f24a)(this.parent.worldWidth * this.parent.scale.x - this.parent.screenWidth, this.parent.worldHeight * this.parent.scale.y - this.parent.screenHeight)
        };
    }
    bounce() {
        var s, h;
        if (this.paused) return;
        let t, i = this.parent.plugins.get("decelerate", !0);
        i && (i.x || i.y) && (i.x && i.percentChangeX === ((s = i.options) == null ? void 0 : s.friction) || i.y && i.percentChangeY === ((h = i.options) == null ? void 0 : h.friction)) && (t = this.oob(), (t.left && this.left || t.right && this.right) && (i.percentChangeX = this.options.friction), (t.top && this.top || t.bottom && this.bottom) && (i.percentChangeY = this.options.friction));
        const e = this.parent.plugins.get("drag", !0) || {}, n = this.parent.plugins.get("pinch", !0) || {};
        if (i = i || {}, !(e != null && e.active) && !(n != null && n.active) && (!this.toX || !this.toY) && (!i.x || !i.y)) {
            t = t || this.oob();
            const a = t.topLeft, p = t.bottomRight;
            if (!this.toX && !i.x) {
                let l = null;
                t.left && this.left ? l = this.parent.screenWorldWidth < this.parent.screenWidth ? this.calcUnderflowX() : -a.x : t.right && this.right && (l = this.parent.screenWorldWidth < this.parent.screenWidth ? this.calcUnderflowX() : -p.x), l !== null && this.parent.x !== l && (this.toX = {
                    time: 0,
                    start: this.parent.x,
                    delta: l - this.parent.x,
                    end: l
                }, this.parent.emit("bounce-x-start", this.parent));
            }
            if (!this.toY && !i.y) {
                let l = null;
                t.top && this.top ? l = this.parent.screenWorldHeight < this.parent.screenHeight ? this.calcUnderflowY() : -a.y : t.bottom && this.bottom && (l = this.parent.screenWorldHeight < this.parent.screenHeight ? this.calcUnderflowY() : -p.y), l !== null && this.parent.y !== l && (this.toY = {
                    time: 0,
                    start: this.parent.y,
                    delta: l - this.parent.y,
                    end: l
                }, this.parent.emit("bounce-y-start", this.parent));
            }
        }
    }
    reset() {
        this.toX = this.toY = null, this.bounce();
    }
}
const $b4245adbfe6bbe42$var$z = {
    left: !1,
    right: !1,
    top: !1,
    bottom: !1,
    direction: null,
    underflow: "center"
};
class $b4245adbfe6bbe42$export$90534cad35a14134 extends $b4245adbfe6bbe42$export$901cf72dabf2112a {
    constructor(t, i = {}){
        super(t);
        $b4245adbfe6bbe42$var$o(this, "options");
        $b4245adbfe6bbe42$var$o(this, "last");
        $b4245adbfe6bbe42$var$o(this, "noUnderflow");
        $b4245adbfe6bbe42$var$o(this, "underflowX");
        $b4245adbfe6bbe42$var$o(this, "underflowY");
        this.options = Object.assign({}, $b4245adbfe6bbe42$var$z, i), this.options.direction && (this.options.left = this.options.direction === "x" || this.options.direction === "all" ? !0 : null, this.options.right = this.options.direction === "x" || this.options.direction === "all" ? !0 : null, this.options.top = this.options.direction === "y" || this.options.direction === "all" ? !0 : null, this.options.bottom = this.options.direction === "y" || this.options.direction === "all" ? !0 : null), this.parseUnderflow(), this.last = {
            x: null,
            y: null,
            scaleX: null,
            scaleY: null
        }, this.update();
    }
    parseUnderflow() {
        const t = this.options.underflow.toLowerCase();
        t === "none" ? this.noUnderflow = !0 : t === "center" ? (this.underflowX = this.underflowY = 0, this.noUnderflow = !1) : (this.underflowX = t.indexOf("left") !== -1 ? -1 : t.indexOf("right") !== -1 ? 1 : 0, this.underflowY = t.indexOf("top") !== -1 ? -1 : t.indexOf("bottom") !== -1 ? 1 : 0, this.noUnderflow = !1);
    }
    move() {
        return this.update(), !1;
    }
    update() {
        if (this.paused || this.parent.x === this.last.x && this.parent.y === this.last.y && this.parent.scale.x === this.last.scaleX && this.parent.scale.y === this.last.scaleY) return;
        const t = new (0, $cf3018b4309864c2$export$baf26146a414f24a)(this.parent.x, this.parent.y), i = this.parent.plugins.decelerate || {};
        if (this.options.left !== null || this.options.right !== null) {
            let e = !1;
            if (!this.noUnderflow && this.parent.screenWorldWidth < this.parent.screenWidth) switch(this.underflowX){
                case -1:
                    this.parent.x !== 0 && (this.parent.x = 0, e = !0);
                    break;
                case 1:
                    this.parent.x !== this.parent.screenWidth - this.parent.screenWorldWidth && (this.parent.x = this.parent.screenWidth - this.parent.screenWorldWidth, e = !0);
                    break;
                default:
                    this.parent.x !== (this.parent.screenWidth - this.parent.screenWorldWidth) / 2 && (this.parent.x = (this.parent.screenWidth - this.parent.screenWorldWidth) / 2, e = !0);
            }
            else this.options.left !== null && this.parent.left < (this.options.left === !0 ? 0 : this.options.left) && (this.parent.x = -(this.options.left === !0 ? 0 : this.options.left) * this.parent.scale.x, i.x = 0, e = !0), this.options.right !== null && this.parent.right > (this.options.right === !0 ? this.parent.worldWidth : this.options.right) && (this.parent.x = -(this.options.right === !0 ? this.parent.worldWidth : this.options.right) * this.parent.scale.x + this.parent.screenWidth, i.x = 0, e = !0);
            e && this.parent.emit("moved", {
                viewport: this.parent,
                original: t,
                type: "clamp-x"
            });
        }
        if (this.options.top !== null || this.options.bottom !== null) {
            let e = !1;
            if (!this.noUnderflow && this.parent.screenWorldHeight < this.parent.screenHeight) switch(this.underflowY){
                case -1:
                    this.parent.y !== 0 && (this.parent.y = 0, e = !0);
                    break;
                case 1:
                    this.parent.y !== this.parent.screenHeight - this.parent.screenWorldHeight && (this.parent.y = this.parent.screenHeight - this.parent.screenWorldHeight, e = !0);
                    break;
                default:
                    this.parent.y !== (this.parent.screenHeight - this.parent.screenWorldHeight) / 2 && (this.parent.y = (this.parent.screenHeight - this.parent.screenWorldHeight) / 2, e = !0);
            }
            else this.options.top !== null && this.parent.top < (this.options.top === !0 ? 0 : this.options.top) && (this.parent.y = -(this.options.top === !0 ? 0 : this.options.top) * this.parent.scale.y, i.y = 0, e = !0), this.options.bottom !== null && this.parent.bottom > (this.options.bottom === !0 ? this.parent.worldHeight : this.options.bottom) && (this.parent.y = -(this.options.bottom === !0 ? this.parent.worldHeight : this.options.bottom) * this.parent.scale.y + this.parent.screenHeight, i.y = 0, e = !0);
            e && this.parent.emit("moved", {
                viewport: this.parent,
                original: t,
                type: "clamp-y"
            });
        }
        this.last.x = this.parent.x, this.last.y = this.parent.y, this.last.scaleX = this.parent.scale.x, this.last.scaleY = this.parent.scale.y;
    }
    reset() {
        this.update();
    }
}
const $b4245adbfe6bbe42$var$_ = {
    minWidth: null,
    minHeight: null,
    maxWidth: null,
    maxHeight: null,
    minScale: null,
    maxScale: null
};
class $b4245adbfe6bbe42$export$220d7a3461bca2df extends $b4245adbfe6bbe42$export$901cf72dabf2112a {
    constructor(t, i = {}){
        super(t);
        $b4245adbfe6bbe42$var$o(this, "options");
        this.options = Object.assign({}, $b4245adbfe6bbe42$var$_, i), this.clamp();
    }
    resize() {
        this.clamp();
    }
    clamp() {
        if (!this.paused) {
            if (this.options.minWidth || this.options.minHeight || this.options.maxWidth || this.options.maxHeight) {
                let t = this.parent.worldScreenWidth, i = this.parent.worldScreenHeight;
                if (this.options.minWidth !== null && t < this.options.minWidth) {
                    const e = this.parent.scale.x;
                    this.parent.fitWidth(this.options.minWidth, !1, !1, !0), this.parent.scale.y *= this.parent.scale.x / e, t = this.parent.worldScreenWidth, i = this.parent.worldScreenHeight, this.parent.emit("zoomed", {
                        viewport: this.parent,
                        type: "clamp-zoom"
                    });
                }
                if (this.options.maxWidth !== null && t > this.options.maxWidth) {
                    const e = this.parent.scale.x;
                    this.parent.fitWidth(this.options.maxWidth, !1, !1, !0), this.parent.scale.y *= this.parent.scale.x / e, t = this.parent.worldScreenWidth, i = this.parent.worldScreenHeight, this.parent.emit("zoomed", {
                        viewport: this.parent,
                        type: "clamp-zoom"
                    });
                }
                if (this.options.minHeight !== null && i < this.options.minHeight) {
                    const e = this.parent.scale.y;
                    this.parent.fitHeight(this.options.minHeight, !1, !1, !0), this.parent.scale.x *= this.parent.scale.y / e, t = this.parent.worldScreenWidth, i = this.parent.worldScreenHeight, this.parent.emit("zoomed", {
                        viewport: this.parent,
                        type: "clamp-zoom"
                    });
                }
                if (this.options.maxHeight !== null && i > this.options.maxHeight) {
                    const e = this.parent.scale.y;
                    this.parent.fitHeight(this.options.maxHeight, !1, !1, !0), this.parent.scale.x *= this.parent.scale.y / e, this.parent.emit("zoomed", {
                        viewport: this.parent,
                        type: "clamp-zoom"
                    });
                }
            } else if (this.options.minScale || this.options.maxScale) {
                const t = {
                    x: null,
                    y: null
                }, i = {
                    x: null,
                    y: null
                };
                if (typeof this.options.minScale == "number") t.x = this.options.minScale, t.y = this.options.minScale;
                else if (this.options.minScale !== null) {
                    const s = this.options.minScale;
                    t.x = typeof s.x > "u" ? null : s.x, t.y = typeof s.y > "u" ? null : s.y;
                }
                if (typeof this.options.maxScale == "number") i.x = this.options.maxScale, i.y = this.options.maxScale;
                else if (this.options.maxScale !== null) {
                    const s = this.options.maxScale;
                    i.x = typeof s.x > "u" ? null : s.x, i.y = typeof s.y > "u" ? null : s.y;
                }
                let e = this.parent.scale.x, n = this.parent.scale.y;
                t.x !== null && e < t.x && (e = t.x), i.x !== null && e > i.x && (e = i.x), t.y !== null && n < t.y && (n = t.y), i.y !== null && n > i.y && (n = i.y), (e !== this.parent.scale.x || n !== this.parent.scale.y) && (this.parent.scale.set(e, n), this.parent.emit("zoomed", {
                    viewport: this.parent,
                    type: "clamp-zoom"
                }));
            }
        }
    }
    reset() {
        this.clamp();
    }
}
const $b4245adbfe6bbe42$var$D = {
    friction: 0.98,
    bounce: 0.8,
    minSpeed: 0.01
}, $b4245adbfe6bbe42$var$g = 16;
class $b4245adbfe6bbe42$export$4bbb5144deae3118 extends $b4245adbfe6bbe42$export$901cf72dabf2112a {
    constructor(t, i = {}){
        super(t);
        $b4245adbfe6bbe42$var$o(this, "options");
        $b4245adbfe6bbe42$var$o(this, "x");
        $b4245adbfe6bbe42$var$o(this, "y");
        $b4245adbfe6bbe42$var$o(this, "percentChangeX");
        $b4245adbfe6bbe42$var$o(this, "percentChangeY");
        $b4245adbfe6bbe42$var$o(this, "saved");
        $b4245adbfe6bbe42$var$o(this, "timeSinceRelease");
        this.options = Object.assign({}, $b4245adbfe6bbe42$var$D, i), this.saved = [], this.timeSinceRelease = 0, this.reset(), this.parent.on("moved", (e)=>this.handleMoved(e));
    }
    down() {
        return this.saved = [], this.x = this.y = null, !1;
    }
    isActive() {
        return !!(this.x || this.y);
    }
    move() {
        if (this.paused) return !1;
        const t = this.parent.input.count();
        return (t === 1 || t > 1 && !this.parent.plugins.get("pinch", !0)) && (this.saved.push({
            x: this.parent.x,
            y: this.parent.y,
            time: performance.now()
        }), this.saved.length > 60 && this.saved.splice(0, 30)), !1;
    }
    handleMoved(t) {
        if (this.saved.length) {
            const i = this.saved[this.saved.length - 1];
            t.type === "clamp-x" && t.original ? i.x === t.original.x && (i.x = this.parent.x) : t.type === "clamp-y" && t.original && i.y === t.original.y && (i.y = this.parent.y);
        }
    }
    up() {
        if (this.parent.input.count() === 0 && this.saved.length) {
            const t = performance.now();
            for (const i of this.saved)if (i.time >= t - 100) {
                const e = t - i.time;
                this.x = (this.parent.x - i.x) / e, this.y = (this.parent.y - i.y) / e, this.percentChangeX = this.percentChangeY = this.options.friction, this.timeSinceRelease = 0;
                break;
            }
        }
        return !1;
    }
    activate(t) {
        t = t || {}, typeof t.x < "u" && (this.x = t.x, this.percentChangeX = this.options.friction), typeof t.y < "u" && (this.y = t.y, this.percentChangeY = this.options.friction);
    }
    update(t) {
        if (this.paused) return;
        const i = this.x || this.y, e = this.timeSinceRelease, n = this.timeSinceRelease + t;
        if (this.x) {
            const s = this.percentChangeX, h = Math.log(s);
            this.parent.x += this.x * $b4245adbfe6bbe42$var$g / h * (Math.pow(s, n / $b4245adbfe6bbe42$var$g) - Math.pow(s, e / $b4245adbfe6bbe42$var$g)), this.x *= Math.pow(this.percentChangeX, t / $b4245adbfe6bbe42$var$g);
        }
        if (this.y) {
            const s = this.percentChangeY, h = Math.log(s);
            this.parent.y += this.y * $b4245adbfe6bbe42$var$g / h * (Math.pow(s, n / $b4245adbfe6bbe42$var$g) - Math.pow(s, e / $b4245adbfe6bbe42$var$g)), this.y *= Math.pow(this.percentChangeY, t / $b4245adbfe6bbe42$var$g);
        }
        this.timeSinceRelease += t, this.x && this.y ? Math.abs(this.x) < this.options.minSpeed && Math.abs(this.y) < this.options.minSpeed && (this.x = 0, this.y = 0) : (Math.abs(this.x || 0) < this.options.minSpeed && (this.x = 0), Math.abs(this.y || 0) < this.options.minSpeed && (this.y = 0)), i && this.parent.emit("moved", {
            viewport: this.parent,
            type: "decelerate"
        });
    }
    reset() {
        this.x = this.y = null;
    }
}
const $b4245adbfe6bbe42$var$L = {
    direction: "all",
    pressDrag: !0,
    wheel: !0,
    wheelScroll: 1,
    reverse: !1,
    clampWheel: !1,
    underflow: "center",
    factor: 1,
    mouseButtons: "all",
    keyToPress: null,
    ignoreKeyToPressOnTouch: !1,
    lineHeight: 20,
    wheelSwapAxes: !1
};
class $b4245adbfe6bbe42$export$b48985bba8f530f5 extends $b4245adbfe6bbe42$export$901cf72dabf2112a {
    constructor(t, i = {}){
        super(t);
        $b4245adbfe6bbe42$var$o(this, "options");
        $b4245adbfe6bbe42$var$o(this, "moved");
        $b4245adbfe6bbe42$var$o(this, "reverse");
        $b4245adbfe6bbe42$var$o(this, "xDirection");
        $b4245adbfe6bbe42$var$o(this, "yDirection");
        $b4245adbfe6bbe42$var$o(this, "keyIsPressed");
        $b4245adbfe6bbe42$var$o(this, "mouse");
        $b4245adbfe6bbe42$var$o(this, "underflowX");
        $b4245adbfe6bbe42$var$o(this, "underflowY");
        $b4245adbfe6bbe42$var$o(this, "last");
        $b4245adbfe6bbe42$var$o(this, "current");
        $b4245adbfe6bbe42$var$o(this, "windowEventHandlers", []);
        this.options = Object.assign({}, $b4245adbfe6bbe42$var$L, i), this.moved = !1, this.reverse = this.options.reverse ? 1 : -1, this.xDirection = !this.options.direction || this.options.direction === "all" || this.options.direction === "x", this.yDirection = !this.options.direction || this.options.direction === "all" || this.options.direction === "y", this.keyIsPressed = !1, this.parseUnderflow(), this.mouseButtons(this.options.mouseButtons), this.options.keyToPress && this.handleKeyPresses(this.options.keyToPress);
    }
    handleKeyPresses(t) {
        const i = (n)=>{
            t.includes(n.code) && (this.keyIsPressed = !0);
        }, e = (n)=>{
            t.includes(n.code) && (this.keyIsPressed = !1);
        };
        this.addWindowEventHandler("keyup", e), this.addWindowEventHandler("keydown", i);
    }
    addWindowEventHandler(t, i) {
        window.addEventListener(t, i), this.windowEventHandlers.push({
            event: t,
            handler: i
        });
    }
    destroy() {
        this.windowEventHandlers.forEach(({ event: t, handler: i })=>{
            window.removeEventListener(t, i);
        });
    }
    mouseButtons(t) {
        !t || t === "all" ? this.mouse = [
            !0,
            !0,
            !0
        ] : this.mouse = [
            t.indexOf("left") !== -1,
            t.indexOf("middle") !== -1,
            t.indexOf("right") !== -1
        ];
    }
    parseUnderflow() {
        const t = this.options.underflow.toLowerCase();
        t === "center" ? (this.underflowX = 0, this.underflowY = 0) : (t.includes("left") ? this.underflowX = -1 : t.includes("right") ? this.underflowX = 1 : this.underflowX = 0, t.includes("top") ? this.underflowY = -1 : t.includes("bottom") ? this.underflowY = 1 : this.underflowY = 0);
    }
    checkButtons(t) {
        const i = t.pointerType === "mouse", e = this.parent.input.count();
        return !!((e === 1 || e > 1 && !this.parent.plugins.get("pinch", !0)) && (!i || this.mouse[t.button]));
    }
    checkKeyPress(t) {
        return !this.options.keyToPress || this.keyIsPressed || this.options.ignoreKeyToPressOnTouch && t.data.pointerType === "touch";
    }
    down(t) {
        return this.paused || !this.options.pressDrag ? !1 : this.checkButtons(t) && this.checkKeyPress(t) ? (this.last = {
            x: t.global.x,
            y: t.global.y
        }, this.current = t.pointerId, !0) : (this.last = null, !1);
    }
    get active() {
        return this.moved;
    }
    move(t) {
        if (this.paused || !this.options.pressDrag) return !1;
        if (this.last && this.current === t.data.pointerId) {
            const i = t.global.x, e = t.global.y, n = this.parent.input.count();
            if (n === 1 || n > 1 && !this.parent.plugins.get("pinch", !0)) {
                const s = i - this.last.x, h = e - this.last.y;
                if (this.moved || this.xDirection && this.parent.input.checkThreshold(s) || this.yDirection && this.parent.input.checkThreshold(h)) {
                    const a = {
                        x: i,
                        y: e
                    };
                    return this.xDirection && (this.parent.x += (a.x - this.last.x) * this.options.factor), this.yDirection && (this.parent.y += (a.y - this.last.y) * this.options.factor), this.last = a, this.moved || this.parent.emit("drag-start", {
                        event: t,
                        screen: new (0, $cf3018b4309864c2$export$baf26146a414f24a)(this.last.x, this.last.y),
                        world: this.parent.toWorld(new (0, $cf3018b4309864c2$export$baf26146a414f24a)(this.last.x, this.last.y)),
                        viewport: this.parent
                    }), this.moved = !0, this.parent.emit("moved", {
                        viewport: this.parent,
                        type: "drag"
                    }), !0;
                }
            } else this.moved = !1;
        }
        return !1;
    }
    up(t) {
        if (this.paused) return !1;
        const i = this.parent.input.touches;
        if (i.length === 1) {
            const e = i[0];
            return e.last && (this.last = {
                x: e.last.x,
                y: e.last.y
            }, this.current = e.id), this.moved = !1, !0;
        } else if (this.last && this.moved) {
            const e = new (0, $cf3018b4309864c2$export$baf26146a414f24a)(this.last.x, this.last.y);
            return this.parent.emit("drag-end", {
                event: t,
                screen: e,
                world: this.parent.toWorld(e),
                viewport: this.parent
            }), this.last = null, this.moved = !1, !0;
        }
        return !1;
    }
    wheel(t) {
        if (this.paused) return !1;
        if (this.options.wheel) {
            const i = this.parent.plugins.get("wheel", !0);
            if (!i || !i.options.wheelZoom && !t.ctrlKey) {
                const e = t.deltaMode ? this.options.lineHeight : 1, n = [
                    t.deltaX,
                    t.deltaY
                ], [s, h] = this.options.wheelSwapAxes ? n.reverse() : n;
                return this.xDirection && (this.parent.x += s * e * this.options.wheelScroll * this.reverse), this.yDirection && (this.parent.y += h * e * this.options.wheelScroll * this.reverse), this.options.clampWheel && this.clamp(), this.parent.emit("wheel-scroll", this.parent), this.parent.emit("moved", {
                    viewport: this.parent,
                    type: "wheel"
                }), this.parent.options.passiveWheel || t.preventDefault(), this.parent.options.stopPropagation && t.stopPropagation(), !0;
            }
        }
        return !1;
    }
    resume() {
        this.last = null, this.paused = !1;
    }
    clamp() {
        const t = this.parent.plugins.get("decelerate", !0) || {};
        if (this.options.clampWheel !== "y") {
            if (this.parent.screenWorldWidth < this.parent.screenWidth) switch(this.underflowX){
                case -1:
                    this.parent.x = 0;
                    break;
                case 1:
                    this.parent.x = this.parent.screenWidth - this.parent.screenWorldWidth;
                    break;
                default:
                    this.parent.x = (this.parent.screenWidth - this.parent.screenWorldWidth) / 2;
            }
            else this.parent.left < 0 ? (this.parent.x = 0, t.x = 0) : this.parent.right > this.parent.worldWidth && (this.parent.x = -this.parent.worldWidth * this.parent.scale.x + this.parent.screenWidth, t.x = 0);
        }
        if (this.options.clampWheel !== "x") {
            if (this.parent.screenWorldHeight < this.parent.screenHeight) switch(this.underflowY){
                case -1:
                    this.parent.y = 0;
                    break;
                case 1:
                    this.parent.y = this.parent.screenHeight - this.parent.screenWorldHeight;
                    break;
                default:
                    this.parent.y = (this.parent.screenHeight - this.parent.screenWorldHeight) / 2;
            }
            else this.parent.top < 0 && (this.parent.y = 0, t.y = 0), this.parent.bottom > this.parent.worldHeight && (this.parent.y = -this.parent.worldHeight * this.parent.scale.y + this.parent.screenHeight, t.y = 0);
        }
    }
}
const $b4245adbfe6bbe42$var$V = {
    speed: 0,
    acceleration: null,
    radius: null
};
class $b4245adbfe6bbe42$export$455f05776f1ba8ba extends $b4245adbfe6bbe42$export$901cf72dabf2112a {
    constructor(t, i, e = {}){
        super(t);
        $b4245adbfe6bbe42$var$o(this, "options");
        $b4245adbfe6bbe42$var$o(this, "target");
        $b4245adbfe6bbe42$var$o(this, "velocity");
        this.target = i, this.options = Object.assign({}, $b4245adbfe6bbe42$var$V, e), this.velocity = {
            x: 0,
            y: 0
        };
    }
    update(t) {
        if (this.paused) return;
        const i = this.parent.center;
        let e = this.target.x, n = this.target.y;
        if (this.options.radius) {
            if (Math.sqrt(Math.pow(this.target.y - i.y, 2) + Math.pow(this.target.x - i.x, 2)) > this.options.radius) {
                const p = Math.atan2(this.target.y - i.y, this.target.x - i.x);
                e = this.target.x - Math.cos(p) * this.options.radius, n = this.target.y - Math.sin(p) * this.options.radius;
            } else return;
        }
        const s = e - i.x, h = n - i.y;
        if (s || h) {
            if (this.options.speed) {
                if (this.options.acceleration) {
                    const a = Math.atan2(n - i.y, e - i.x), p = Math.sqrt(Math.pow(s, 2) + Math.pow(h, 2));
                    if (p) {
                        const l = (Math.pow(this.velocity.x, 2) + Math.pow(this.velocity.y, 2)) / (2 * this.options.acceleration);
                        p > l ? this.velocity = {
                            x: Math.min(this.velocity.x + (this.options.acceleration * t, this.options.speed)),
                            y: Math.min(this.velocity.y + (this.options.acceleration * t, this.options.speed))
                        } : this.velocity = {
                            x: Math.max(this.velocity.x - this.options.acceleration * this.options.speed, 0),
                            y: Math.max(this.velocity.y - this.options.acceleration * this.options.speed, 0)
                        };
                        const d = Math.cos(a) * this.velocity.x, m = Math.sin(a) * this.velocity.y, y = Math.abs(d) > Math.abs(s) ? e : i.x + d, x = Math.abs(m) > Math.abs(h) ? n : i.y + m;
                        this.parent.moveCenter(y, x), this.parent.emit("moved", {
                            viewport: this.parent,
                            type: "follow"
                        });
                    }
                } else {
                    const a = Math.atan2(n - i.y, e - i.x), p = Math.cos(a) * this.options.speed, l = Math.sin(a) * this.options.speed, d = Math.abs(p) > Math.abs(s) ? e : i.x + p, m = Math.abs(l) > Math.abs(h) ? n : i.y + l;
                    this.parent.moveCenter(d, m), this.parent.emit("moved", {
                        viewport: this.parent,
                        type: "follow"
                    });
                }
            } else this.parent.moveCenter(e, n), this.parent.emit("moved", {
                viewport: this.parent,
                type: "follow"
            });
        }
    }
}
const $b4245adbfe6bbe42$var$B = {
    radius: null,
    distance: null,
    top: null,
    bottom: null,
    left: null,
    right: null,
    speed: 8,
    reverse: !1,
    noDecelerate: !1,
    linear: !1,
    allowButtons: !1
};
class $b4245adbfe6bbe42$export$dd505d2e20e3eaaf extends $b4245adbfe6bbe42$export$901cf72dabf2112a {
    constructor(t, i = {}){
        super(t);
        $b4245adbfe6bbe42$var$o(this, "options");
        $b4245adbfe6bbe42$var$o(this, "reverse");
        $b4245adbfe6bbe42$var$o(this, "radiusSquared");
        $b4245adbfe6bbe42$var$o(this, "left");
        $b4245adbfe6bbe42$var$o(this, "top");
        $b4245adbfe6bbe42$var$o(this, "right");
        $b4245adbfe6bbe42$var$o(this, "bottom");
        $b4245adbfe6bbe42$var$o(this, "horizontal");
        $b4245adbfe6bbe42$var$o(this, "vertical");
        this.options = Object.assign({}, $b4245adbfe6bbe42$var$B, i), this.reverse = this.options.reverse ? 1 : -1, this.radiusSquared = typeof this.options.radius == "number" ? Math.pow(this.options.radius, 2) : null, this.resize();
    }
    resize() {
        const t = this.options.distance;
        t !== null ? (this.left = t, this.top = t, this.right = this.parent.screenWidth - t, this.bottom = this.parent.screenHeight - t) : this.options.radius || (this.left = this.options.left, this.top = this.options.top, this.right = this.options.right === null ? null : this.parent.screenWidth - this.options.right, this.bottom = this.options.bottom === null ? null : this.parent.screenHeight - this.options.bottom);
    }
    down() {
        return this.paused || this.options.allowButtons || (this.horizontal = this.vertical = null), !1;
    }
    move(t) {
        if (this.paused || t.pointerType !== "mouse" && t.pointerId !== 1 || !this.options.allowButtons && t.buttons !== 0) return !1;
        const i = t.global.x, e = t.global.y;
        if (this.radiusSquared) {
            const n = this.parent.toScreen(this.parent.center);
            if (Math.pow(n.x - i, 2) + Math.pow(n.y - e, 2) >= this.radiusSquared) {
                const h = Math.atan2(n.y - e, n.x - i);
                this.options.linear ? (this.horizontal = Math.round(Math.cos(h)) * this.options.speed * this.reverse * 0.06, this.vertical = Math.round(Math.sin(h)) * this.options.speed * this.reverse * 0.06) : (this.horizontal = Math.cos(h) * this.options.speed * this.reverse * 0.06, this.vertical = Math.sin(h) * this.options.speed * this.reverse * 0.06);
            } else this.horizontal && this.decelerateHorizontal(), this.vertical && this.decelerateVertical(), this.horizontal = this.vertical = 0;
        } else this.left !== null && i < this.left ? this.horizontal = Number(this.reverse) * this.options.speed * 0.06 : this.right !== null && i > this.right ? this.horizontal = -1 * this.reverse * this.options.speed * 0.06 : (this.decelerateHorizontal(), this.horizontal = 0), this.top !== null && e < this.top ? this.vertical = Number(this.reverse) * this.options.speed * 0.06 : this.bottom !== null && e > this.bottom ? this.vertical = -1 * this.reverse * this.options.speed * 0.06 : (this.decelerateVertical(), this.vertical = 0);
        return !1;
    }
    decelerateHorizontal() {
        const t = this.parent.plugins.get("decelerate", !0);
        this.horizontal && t && !this.options.noDecelerate && t.activate({
            x: this.horizontal * this.options.speed * this.reverse / (1e3 / 60)
        });
    }
    decelerateVertical() {
        const t = this.parent.plugins.get("decelerate", !0);
        this.vertical && t && !this.options.noDecelerate && t.activate({
            y: this.vertical * this.options.speed * this.reverse / (1e3 / 60)
        });
    }
    up() {
        return this.paused || (this.horizontal && this.decelerateHorizontal(), this.vertical && this.decelerateVertical(), this.horizontal = this.vertical = null), !1;
    }
    update() {
        if (!this.paused && (this.horizontal || this.vertical)) {
            const t = this.parent.center;
            this.horizontal && (t.x += this.horizontal * this.options.speed), this.vertical && (t.y += this.vertical * this.options.speed), this.parent.moveCenter(t), this.parent.emit("moved", {
                viewport: this.parent,
                type: "mouse-edges"
            });
        }
    }
}
const $b4245adbfe6bbe42$var$Z = {
    noDrag: !1,
    percent: 1,
    center: null,
    factor: 1,
    axis: "all"
};
class $b4245adbfe6bbe42$export$826ae541ddf1527b extends $b4245adbfe6bbe42$export$901cf72dabf2112a {
    constructor(t, i = {}){
        super(t);
        $b4245adbfe6bbe42$var$o(this, "options");
        $b4245adbfe6bbe42$var$o(this, "active", !1);
        $b4245adbfe6bbe42$var$o(this, "pinching", !1);
        $b4245adbfe6bbe42$var$o(this, "moved", !1);
        $b4245adbfe6bbe42$var$o(this, "lastCenter");
        this.options = Object.assign({}, $b4245adbfe6bbe42$var$Z, i);
    }
    down() {
        return this.parent.input.count() >= 2 ? (this.active = !0, !0) : !1;
    }
    isAxisX() {
        return [
            "all",
            "x"
        ].includes(this.options.axis);
    }
    isAxisY() {
        return [
            "all",
            "y"
        ].includes(this.options.axis);
    }
    move(t) {
        if (this.paused || !this.active) return !1;
        const i = t.global.x, e = t.global.y, n = this.parent.input.touches;
        if (n.length >= 2) {
            const s = n[0], h = n[1], a = s.last && h.last ? Math.sqrt(Math.pow(h.last.x - s.last.x, 2) + Math.pow(h.last.y - s.last.y, 2)) : null;
            if (s.id === t.pointerId ? s.last = {
                x: i,
                y: e,
                data: t
            } : h.id === t.pointerId && (h.last = {
                x: i,
                y: e,
                data: t
            }), a) {
                let p;
                const l = new (0, $cf3018b4309864c2$export$baf26146a414f24a)(s.last.x + (h.last.x - s.last.x) / 2, s.last.y + (h.last.y - s.last.y) / 2);
                this.options.center || (p = this.parent.toLocal(l));
                let d = Math.sqrt(Math.pow(h.last.x - s.last.x, 2) + Math.pow(h.last.y - s.last.y, 2));
                d = d === 0 ? d = 1e-10 : d;
                const m = (1 - a / d) * this.options.percent * (this.isAxisX() ? this.parent.scale.x : this.parent.scale.y);
                this.isAxisX() && (this.parent.scale.x += m), this.isAxisY() && (this.parent.scale.y += m), this.parent.emit("zoomed", {
                    viewport: this.parent,
                    type: "pinch",
                    center: l
                });
                const y = this.parent.plugins.get("clamp-zoom", !0);
                if (y && y.clamp(), this.options.center) this.parent.moveCenter(this.options.center);
                else {
                    const x = this.parent.toGlobal(p);
                    this.parent.x += (l.x - x.x) * this.options.factor, this.parent.y += (l.y - x.y) * this.options.factor, this.parent.emit("moved", {
                        viewport: this.parent,
                        type: "pinch"
                    });
                }
                !this.options.noDrag && this.lastCenter && (this.parent.x += (l.x - this.lastCenter.x) * this.options.factor, this.parent.y += (l.y - this.lastCenter.y) * this.options.factor, this.parent.emit("moved", {
                    viewport: this.parent,
                    type: "pinch"
                })), this.lastCenter = l, this.moved = !0;
            } else this.pinching || (this.parent.emit("pinch-start", this.parent), this.pinching = !0);
            return !0;
        }
        return !1;
    }
    up() {
        return this.pinching && this.parent.input.touches.length <= 1 ? (this.active = !1, this.lastCenter = null, this.pinching = !1, this.moved = !1, this.parent.emit("pinch-end", this.parent), !0) : !1;
    }
}
const $b4245adbfe6bbe42$var$j = {
    topLeft: !1,
    friction: 0.8,
    time: 1e3,
    ease: "easeInOutSine",
    interrupt: !0,
    removeOnComplete: !1,
    removeOnInterrupt: !1,
    forceStart: !1
};
class $b4245adbfe6bbe42$export$4dbf1f67c012298b extends $b4245adbfe6bbe42$export$901cf72dabf2112a {
    constructor(t, i, e, n = {}){
        super(t);
        $b4245adbfe6bbe42$var$o(this, "options");
        $b4245adbfe6bbe42$var$o(this, "ease");
        $b4245adbfe6bbe42$var$o(this, "x");
        $b4245adbfe6bbe42$var$o(this, "y");
        $b4245adbfe6bbe42$var$o(this, "percent");
        $b4245adbfe6bbe42$var$o(this, "snapping");
        $b4245adbfe6bbe42$var$o(this, "deltaX");
        $b4245adbfe6bbe42$var$o(this, "deltaY");
        $b4245adbfe6bbe42$var$o(this, "startX");
        $b4245adbfe6bbe42$var$o(this, "startY");
        this.options = Object.assign({}, $b4245adbfe6bbe42$var$j, n), this.ease = $b4245adbfe6bbe42$var$W(n.ease, "easeInOutSine"), this.x = i, this.y = e, this.options.forceStart && this.snapStart();
    }
    snapStart() {
        this.percent = 0, this.snapping = {
            time: 0
        };
        const t = this.options.topLeft ? this.parent.corner : this.parent.center;
        this.deltaX = this.x - t.x, this.deltaY = this.y - t.y, this.startX = t.x, this.startY = t.y, this.parent.emit("snap-start", this.parent);
    }
    wheel() {
        return this.options.removeOnInterrupt && this.parent.plugins.remove("snap"), !1;
    }
    down() {
        return this.options.removeOnInterrupt ? this.parent.plugins.remove("snap") : this.options.interrupt && (this.snapping = null), !1;
    }
    up() {
        if (this.parent.input.count() === 0) {
            const t = this.parent.plugins.get("decelerate", !0);
            t && (t.x || t.y) && (t.percentChangeX = t.percentChangeY = this.options.friction);
        }
        return !1;
    }
    update(t) {
        if (!this.paused && !(this.options.interrupt && this.parent.input.count() !== 0)) {
            if (this.snapping) {
                const i = this.snapping;
                i.time += t;
                let e, n, s;
                const h = this.startX, a = this.startY, p = this.deltaX, l = this.deltaY;
                if (i.time > this.options.time) e = !0, n = h + p, s = a + l;
                else {
                    const d = this.ease(i.time, 0, 1, this.options.time);
                    n = h + p * d, s = a + l * d;
                }
                this.options.topLeft ? this.parent.moveCorner(n, s) : this.parent.moveCenter(n, s), this.parent.emit("moved", {
                    viewport: this.parent,
                    type: "snap"
                }), e && (this.options.removeOnComplete && this.parent.plugins.remove("snap"), this.parent.emit("snap-end", this.parent), this.snapping = null);
            } else {
                const i = this.options.topLeft ? this.parent.corner : this.parent.center;
                (i.x !== this.x || i.y !== this.y) && this.snapStart();
            }
        }
    }
}
const $b4245adbfe6bbe42$var$K = {
    width: 0,
    height: 0,
    time: 1e3,
    ease: "easeInOutSine",
    center: null,
    interrupt: !0,
    removeOnComplete: !1,
    removeOnInterrupt: !1,
    forceStart: !1,
    noMove: !1
};
class $b4245adbfe6bbe42$export$8d3b89b6e4db7cd0 extends $b4245adbfe6bbe42$export$901cf72dabf2112a {
    constructor(t, i = {}){
        super(t);
        $b4245adbfe6bbe42$var$o(this, "options");
        $b4245adbfe6bbe42$var$o(this, "ease");
        $b4245adbfe6bbe42$var$o(this, "xScale");
        $b4245adbfe6bbe42$var$o(this, "yScale");
        $b4245adbfe6bbe42$var$o(this, "xIndependent");
        $b4245adbfe6bbe42$var$o(this, "yIndependent");
        $b4245adbfe6bbe42$var$o(this, "snapping");
        this.options = Object.assign({}, $b4245adbfe6bbe42$var$K, i), this.ease = $b4245adbfe6bbe42$var$W(this.options.ease), this.xIndependent = !1, this.yIndependent = !1, this.xScale = 0, this.yScale = 0, this.options.width > 0 && (this.xScale = t.screenWidth / this.options.width, this.xIndependent = !0), this.options.height > 0 && (this.yScale = t.screenHeight / this.options.height, this.yIndependent = !0), this.xScale = this.xIndependent ? this.xScale : this.yScale, this.yScale = this.yIndependent ? this.yScale : this.xScale, this.options.time === 0 ? (t.container.scale.x = this.xScale, t.container.scale.y = this.yScale, this.options.removeOnComplete && this.parent.plugins.remove("snap-zoom")) : i.forceStart && this.createSnapping();
    }
    createSnapping() {
        const t = this.parent.worldScreenWidth, i = this.parent.worldScreenHeight, e = this.parent.screenWidth / this.xScale, n = this.parent.screenHeight / this.yScale;
        this.snapping = {
            time: 0,
            startX: t,
            startY: i,
            deltaX: e - t,
            deltaY: n - i
        }, this.parent.emit("snap-zoom-start", this.parent);
    }
    resize() {
        this.snapping = null, this.options.width > 0 && (this.xScale = this.parent.screenWidth / this.options.width), this.options.height > 0 && (this.yScale = this.parent.screenHeight / this.options.height), this.xScale = this.xIndependent ? this.xScale : this.yScale, this.yScale = this.yIndependent ? this.yScale : this.xScale;
    }
    wheel() {
        return this.options.removeOnInterrupt && this.parent.plugins.remove("snap-zoom"), !1;
    }
    down() {
        return this.options.removeOnInterrupt ? this.parent.plugins.remove("snap-zoom") : this.options.interrupt && (this.snapping = null), !1;
    }
    update(t) {
        if (this.paused || this.options.interrupt && this.parent.input.count() !== 0) return;
        let i;
        if (!this.options.center && !this.options.noMove && (i = this.parent.center), !this.snapping) (this.parent.scale.x !== this.xScale || this.parent.scale.y !== this.yScale) && this.createSnapping();
        else if (this.snapping) {
            const e = this.snapping;
            if (e.time += t, e.time >= this.options.time) this.parent.scale.set(this.xScale, this.yScale), this.options.removeOnComplete && this.parent.plugins.remove("snap-zoom"), this.parent.emit("snap-zoom-end", this.parent), this.snapping = null;
            else {
                const s = this.snapping, h = this.ease(s.time, s.startX, s.deltaX, this.options.time), a = this.ease(s.time, s.startY, s.deltaY, this.options.time);
                this.parent.scale.x = this.parent.screenWidth / h, this.parent.scale.y = this.parent.screenHeight / a;
            }
            const n = this.parent.plugins.get("clamp-zoom", !0);
            n && n.clamp(), this.options.noMove || (this.options.center ? this.parent.moveCenter(this.options.center) : this.parent.moveCenter(i));
        }
    }
    resume() {
        this.snapping = null, super.resume();
    }
}
const $b4245adbfe6bbe42$var$Q = {
    percent: 0.1,
    smooth: !1,
    interrupt: !0,
    reverse: !1,
    center: null,
    lineHeight: 20,
    axis: "all",
    keyToPress: null,
    trackpadPinch: !1,
    wheelZoom: !0
};
class $b4245adbfe6bbe42$export$ae16e1bcb40d6793 extends $b4245adbfe6bbe42$export$901cf72dabf2112a {
    constructor(t, i = {}){
        super(t);
        $b4245adbfe6bbe42$var$o(this, "options");
        $b4245adbfe6bbe42$var$o(this, "smoothing");
        $b4245adbfe6bbe42$var$o(this, "smoothingCenter");
        $b4245adbfe6bbe42$var$o(this, "smoothingCount");
        $b4245adbfe6bbe42$var$o(this, "keyIsPressed");
        this.options = Object.assign({}, $b4245adbfe6bbe42$var$Q, i), this.keyIsPressed = !1, this.options.keyToPress && this.handleKeyPresses(this.options.keyToPress);
    }
    handleKeyPresses(t) {
        window.addEventListener("keydown", (i)=>{
            t.includes(i.code) && (this.keyIsPressed = !0);
        }), window.addEventListener("keyup", (i)=>{
            t.includes(i.code) && (this.keyIsPressed = !1);
        });
    }
    checkKeyPress() {
        return !this.options.keyToPress || this.keyIsPressed;
    }
    down() {
        return this.options.interrupt && (this.smoothing = null), !1;
    }
    isAxisX() {
        return [
            "all",
            "x"
        ].includes(this.options.axis);
    }
    isAxisY() {
        return [
            "all",
            "y"
        ].includes(this.options.axis);
    }
    update() {
        if (this.smoothing) {
            const t = this.smoothingCenter, i = this.smoothing;
            let e;
            this.options.center || (e = this.parent.toLocal(t)), this.isAxisX() && (this.parent.scale.x += i.x), this.isAxisY() && (this.parent.scale.y += i.y), this.parent.emit("zoomed", {
                viewport: this.parent,
                type: "wheel"
            });
            const n = this.parent.plugins.get("clamp-zoom", !0);
            if (n && n.clamp(), this.options.center) this.parent.moveCenter(this.options.center);
            else {
                const s = this.parent.toGlobal(e);
                this.parent.x += t.x - s.x, this.parent.y += t.y - s.y;
            }
            this.parent.emit("moved", {
                viewport: this.parent,
                type: "wheel"
            }), this.smoothingCount++, this.smoothingCount >= this.options.smooth && (this.smoothing = null);
        }
    }
    pinch(t) {
        if (this.paused) return;
        const i = this.parent.input.getPointerPosition(t), e = -t.deltaY * (t.deltaMode ? this.options.lineHeight : 1) / 200, n = Math.pow(2, (1 + this.options.percent) * e);
        let s;
        this.options.center || (s = this.parent.toLocal(i)), this.isAxisX() && (this.parent.scale.x *= n), this.isAxisY() && (this.parent.scale.y *= n), this.parent.emit("zoomed", {
            viewport: this.parent,
            type: "wheel"
        });
        const h = this.parent.plugins.get("clamp-zoom", !0);
        if (h && h.clamp(), this.options.center) this.parent.moveCenter(this.options.center);
        else {
            const a = this.parent.toGlobal(s);
            this.parent.x += i.x - a.x, this.parent.y += i.y - a.y;
        }
        this.parent.emit("moved", {
            viewport: this.parent,
            type: "wheel"
        }), this.parent.emit("wheel-start", {
            event: t,
            viewport: this.parent
        });
    }
    wheel(t) {
        if (this.paused || !this.checkKeyPress()) return !1;
        if (t.ctrlKey && this.options.trackpadPinch) this.pinch(t);
        else if (this.options.wheelZoom) {
            const i = this.parent.input.getPointerPosition(t), n = (this.options.reverse ? -1 : 1) * -t.deltaY * (t.deltaMode ? this.options.lineHeight : 1) / 500, s = Math.pow(2, (1 + this.options.percent) * n);
            if (this.options.smooth) {
                const h = {
                    x: this.smoothing ? this.smoothing.x * (this.options.smooth - this.smoothingCount) : 0,
                    y: this.smoothing ? this.smoothing.y * (this.options.smooth - this.smoothingCount) : 0
                };
                this.smoothing = {
                    x: ((this.parent.scale.x + h.x) * s - this.parent.scale.x) / this.options.smooth,
                    y: ((this.parent.scale.y + h.y) * s - this.parent.scale.y) / this.options.smooth
                }, this.smoothingCount = 0, this.smoothingCenter = i;
            } else {
                let h;
                this.options.center || (h = this.parent.toLocal(i)), this.isAxisX() && (this.parent.scale.x *= s), this.isAxisY() && (this.parent.scale.y *= s), this.parent.emit("zoomed", {
                    viewport: this.parent,
                    type: "wheel"
                });
                const a = this.parent.plugins.get("clamp-zoom", !0);
                if (a && a.clamp(), this.options.center) this.parent.moveCenter(this.options.center);
                else {
                    const p = this.parent.toGlobal(h);
                    this.parent.x += i.x - p.x, this.parent.y += i.y - p.y;
                }
            }
            this.parent.emit("moved", {
                viewport: this.parent,
                type: "wheel"
            }), this.parent.emit("wheel-start", {
                event: t,
                viewport: this.parent
            });
        }
        return !this.parent.options.passiveWheel;
    }
}
class $b4245adbfe6bbe42$export$2da2653229140a6c {
    constructor(r){
        $b4245adbfe6bbe42$var$o(this, "viewport");
        $b4245adbfe6bbe42$var$o(this, "clickedAvailable");
        $b4245adbfe6bbe42$var$o(this, "isMouseDown");
        $b4245adbfe6bbe42$var$o(this, "last");
        $b4245adbfe6bbe42$var$o(this, "wheelFunction");
        $b4245adbfe6bbe42$var$o(this, "touches");
        this.viewport = r, this.touches = [], this.addListeners();
    }
    addListeners() {
        this.viewport.eventMode = "static", this.viewport.forceHitArea || (this.viewport.hitArea = new (0, $200f778d7fdbf8ac$export$4617fb02663045ef)(0, 0, this.viewport.worldWidth, this.viewport.worldHeight)), this.viewport.on("pointerdown", this.down, this), this.viewport.options.allowPreserveDragOutside ? this.viewport.on("globalpointermove", this.move, this) : this.viewport.on("pointermove", this.move, this), this.viewport.on("pointerup", this.up, this), this.viewport.on("pointerupoutside", this.up, this), this.viewport.on("pointercancel", this.up, this), this.viewport.options.allowPreserveDragOutside || this.viewport.on("pointerleave", this.up, this), this.wheelFunction = (r)=>this.handleWheel(r), this.viewport.options.events.domElement.addEventListener("wheel", this.wheelFunction, {
            passive: this.viewport.options.passiveWheel
        }), this.isMouseDown = !1;
    }
    destroy() {
        this.viewport.options.events.domElement.removeEventListener("wheel", this.wheelFunction);
    }
    down(r) {
        if (this.viewport.pause || !this.viewport.worldVisible) return;
        if (r.pointerType === "mouse" ? this.isMouseDown = !0 : this.get(r.pointerId) || this.touches.push({
            id: r.pointerId,
            last: null
        }), this.count() === 1) {
            this.last = r.global.clone();
            const i = this.viewport.plugins.get("decelerate", !0), e = this.viewport.plugins.get("bounce", !0);
            (!i || !i.isActive()) && (!e || !e.isActive()) ? this.clickedAvailable = !0 : this.clickedAvailable = !1;
        } else this.clickedAvailable = !1;
        this.viewport.plugins.down(r) && this.viewport.options.stopPropagation && r.stopPropagation();
    }
    clear() {
        this.isMouseDown = !1, this.touches = [], this.last = null;
    }
    checkThreshold(r) {
        return Math.abs(r) >= this.viewport.threshold;
    }
    move(r) {
        if (this.viewport.pause || !this.viewport.worldVisible) return;
        const t = this.viewport.plugins.move(r);
        if (this.clickedAvailable && this.last) {
            const i = r.global.x - this.last.x, e = r.global.y - this.last.y;
            (this.checkThreshold(i) || this.checkThreshold(e)) && (this.clickedAvailable = !1);
        }
        t && this.viewport.options.stopPropagation && r.stopPropagation();
    }
    up(r) {
        if (this.viewport.pause || !this.viewport.worldVisible) return;
        r.pointerType === "mouse" && (this.isMouseDown = !1), r.pointerType !== "mouse" && this.remove(r.pointerId);
        const t = this.viewport.plugins.up(r);
        this.clickedAvailable && this.count() === 0 && this.last && (this.viewport.emit("clicked", {
            event: r,
            screen: this.last,
            world: this.viewport.toWorld(this.last),
            viewport: this.viewport
        }), this.clickedAvailable = !1), t && this.viewport.options.stopPropagation && r.stopPropagation();
    }
    getPointerPosition(r) {
        const t = new (0, $cf3018b4309864c2$export$baf26146a414f24a)();
        return this.viewport.options.events.mapPositionToPoint(t, r.clientX, r.clientY), t;
    }
    handleWheel(r) {
        if (this.viewport.pause || !this.viewport.worldVisible) return;
        const t = this.viewport.toLocal(this.getPointerPosition(r));
        this.viewport.left <= t.x && t.x <= this.viewport.right && this.viewport.top <= t.y && t.y <= this.viewport.bottom && this.viewport.plugins.wheel(r) && !this.viewport.options.passiveWheel && r.preventDefault();
    }
    pause() {
        this.touches = [], this.isMouseDown = !1;
    }
    get(r) {
        for (const t of this.touches)if (t.id === r) return t;
        return null;
    }
    remove(r) {
        for(let t = 0; t < this.touches.length; t++)if (this.touches[t].id === r) {
            this.touches.splice(t, 1);
            return;
        }
    }
    count() {
        return (this.isMouseDown ? 1 : 0) + this.touches.length;
    }
}
const $b4245adbfe6bbe42$var$w = [
    "drag",
    "pinch",
    "wheel",
    "follow",
    "mouse-edges",
    "decelerate",
    "animate",
    "bounce",
    "snap-zoom",
    "clamp-zoom",
    "snap",
    "clamp"
];
class $b4245adbfe6bbe42$export$f2c0a16002429d72 {
    constructor(r){
        $b4245adbfe6bbe42$var$o(this, "plugins");
        $b4245adbfe6bbe42$var$o(this, "list");
        $b4245adbfe6bbe42$var$o(this, "viewport");
        this.viewport = r, this.list = [], this.plugins = {};
    }
    add(r, t, i = $b4245adbfe6bbe42$var$w.length) {
        const e = this.plugins[r];
        e && e.destroy(), this.plugins[r] = t;
        const n = $b4245adbfe6bbe42$var$w.indexOf(r);
        n !== -1 && $b4245adbfe6bbe42$var$w.splice(n, 1), $b4245adbfe6bbe42$var$w.splice(i, 0, r), this.sort();
    }
    get(r, t) {
        var i;
        return t && (i = this.plugins[r]) != null && i.paused ? null : this.plugins[r];
    }
    update(r) {
        for (const t of this.list)t.update(r);
    }
    resize() {
        for (const r of this.list)r.resize();
    }
    reset() {
        for (const r of this.list)r.reset();
    }
    removeAll() {
        this.list.forEach((r)=>{
            r.destroy();
        }), this.plugins = {}, this.sort();
    }
    remove(r) {
        var t;
        this.plugins[r] && ((t = this.plugins[r]) == null || t.destroy(), delete this.plugins[r], this.viewport.emit("plugin-remove", r), this.sort());
    }
    pause(r) {
        var t;
        (t = this.plugins[r]) == null || t.pause();
    }
    resume(r) {
        var t;
        (t = this.plugins[r]) == null || t.resume();
    }
    sort() {
        this.list = [];
        for (const r of $b4245adbfe6bbe42$var$w)this.plugins[r] && this.list.push(this.plugins[r]);
    }
    down(r) {
        let t = !1;
        for (const i of this.list)i.down(r) && (t = !0);
        return t;
    }
    move(r) {
        let t = !1;
        for (const i of this.viewport.plugins.list)i.move(r) && (t = !0);
        return t;
    }
    up(r) {
        let t = !1;
        for (const i of this.list)i.up(r) && (t = !0);
        return t;
    }
    wheel(r) {
        let t = !1;
        for (const i of this.list)i.wheel(r) && (t = !0);
        return t;
    }
}
const $b4245adbfe6bbe42$var$et = {
    screenWidth: window.innerWidth,
    screenHeight: window.innerHeight,
    worldWidth: null,
    worldHeight: null,
    threshold: 5,
    passiveWheel: !0,
    stopPropagation: !1,
    forceHitArea: null,
    noTicker: !1,
    disableOnContextMenu: !1,
    ticker: (0, $e6b36730368844b1$export$39c54bcc89dcee11).shared,
    allowPreserveDragOutside: !1
};
class $b4245adbfe6bbe42$export$d5c6c08dc2d3ca7 extends (0, $68e6944de5989822$export$42a852a2b6b56249) {
    constructor(t){
        super();
        $b4245adbfe6bbe42$var$o(this, "moving");
        $b4245adbfe6bbe42$var$o(this, "screenWidth");
        $b4245adbfe6bbe42$var$o(this, "screenHeight");
        $b4245adbfe6bbe42$var$o(this, "threshold");
        $b4245adbfe6bbe42$var$o(this, "input");
        $b4245adbfe6bbe42$var$o(this, "plugins");
        $b4245adbfe6bbe42$var$o(this, "zooming");
        $b4245adbfe6bbe42$var$o(this, "lastViewport");
        $b4245adbfe6bbe42$var$o(this, "options");
        $b4245adbfe6bbe42$var$o(this, "_dirty");
        $b4245adbfe6bbe42$var$o(this, "_forceHitArea");
        $b4245adbfe6bbe42$var$o(this, "_hitAreaDefault");
        $b4245adbfe6bbe42$var$o(this, "_pause");
        $b4245adbfe6bbe42$var$o(this, "tickerFunction");
        $b4245adbfe6bbe42$var$o(this, "_worldWidth");
        $b4245adbfe6bbe42$var$o(this, "_worldHeight");
        $b4245adbfe6bbe42$var$o(this, "_disableOnContextMenu", (t)=>t.preventDefault());
        this.options = {
            ...$b4245adbfe6bbe42$var$et,
            ...t
        }, this.screenWidth = this.options.screenWidth, this.screenHeight = this.options.screenHeight, this._worldWidth = this.options.worldWidth, this._worldHeight = this.options.worldHeight, this.forceHitArea = this.options.forceHitArea, this.threshold = this.options.threshold, this.options.disableOnContextMenu && this.options.events.domElement.addEventListener("contextmenu", this._disableOnContextMenu), this.options.noTicker || (this.tickerFunction = ()=>this.update(this.options.ticker.elapsedMS), this.options.ticker.add(this.tickerFunction)), this.input = new $b4245adbfe6bbe42$export$2da2653229140a6c(this), this.plugins = new $b4245adbfe6bbe42$export$f2c0a16002429d72(this);
    }
    destroy(t) {
        !this.options.noTicker && this.tickerFunction && this.options.ticker.remove(this.tickerFunction), this.options.disableOnContextMenu && this.options.events.domElement.removeEventListener("contextmenu", this._disableOnContextMenu), this.input.destroy(), super.destroy(t);
    }
    update(t) {
        this.pause || (this.plugins.update(t), this.lastViewport && (this.lastViewport.x !== this.x || this.lastViewport.y !== this.y ? this.moving = !0 : this.moving && (this.emit("moved-end", this), this.moving = !1), this.lastViewport.scaleX !== this.scale.x || this.lastViewport.scaleY !== this.scale.y ? this.zooming = !0 : this.zooming && (this.emit("zoomed-end", this), this.zooming = !1)), this.forceHitArea || (this._hitAreaDefault = new (0, $200f778d7fdbf8ac$export$4617fb02663045ef)(this.left, this.top, this.worldScreenWidth, this.worldScreenHeight), this.hitArea = this._hitAreaDefault), this._dirty = this._dirty || !this.lastViewport || this.lastViewport.x !== this.x || this.lastViewport.y !== this.y || this.lastViewport.scaleX !== this.scale.x || this.lastViewport.scaleY !== this.scale.y, this.lastViewport = {
            x: this.x,
            y: this.y,
            scaleX: this.scale.x,
            scaleY: this.scale.y
        }, this.emit("frame-end", this));
    }
    resize(t = window.innerWidth, i = window.innerHeight, e, n) {
        this.screenWidth = t, this.screenHeight = i, typeof e < "u" && (this._worldWidth = e), typeof n < "u" && (this._worldHeight = n), this.plugins.resize(), this.dirty = !0;
    }
    get worldWidth() {
        return this._worldWidth ? this._worldWidth : this.width / this.scale.x;
    }
    set worldWidth(t) {
        this._worldWidth = t, this.plugins.resize();
    }
    get worldHeight() {
        return this._worldHeight ? this._worldHeight : this.height / this.scale.y;
    }
    set worldHeight(t) {
        this._worldHeight = t, this.plugins.resize();
    }
    getVisibleBounds() {
        return new (0, $200f778d7fdbf8ac$export$4617fb02663045ef)(this.left, this.top, this.worldScreenWidth, this.worldScreenHeight);
    }
    toWorld(t, i) {
        return arguments.length === 2 ? this.toLocal(new (0, $cf3018b4309864c2$export$baf26146a414f24a)(t, i)) : this.toLocal(t);
    }
    toScreen(t, i) {
        return arguments.length === 2 ? this.toGlobal(new (0, $cf3018b4309864c2$export$baf26146a414f24a)(t, i)) : this.toGlobal(t);
    }
    get worldScreenWidth() {
        return this.screenWidth / this.scale.x;
    }
    get worldScreenHeight() {
        return this.screenHeight / this.scale.y;
    }
    get screenWorldWidth() {
        return this.worldWidth * this.scale.x;
    }
    get screenWorldHeight() {
        return this.worldHeight * this.scale.y;
    }
    get center() {
        return new (0, $cf3018b4309864c2$export$baf26146a414f24a)(this.worldScreenWidth / 2 - this.x / this.scale.x, this.worldScreenHeight / 2 - this.y / this.scale.y);
    }
    set center(t) {
        this.moveCenter(t);
    }
    moveCenter(...t) {
        let i, e;
        typeof t[0] == "number" ? (i = t[0], e = t[1]) : (i = t[0].x, e = t[0].y);
        const n = (this.worldScreenWidth / 2 - i) * this.scale.x, s = (this.worldScreenHeight / 2 - e) * this.scale.y;
        return (this.x !== n || this.y !== s) && (this.position.set(n, s), this.plugins.reset(), this.dirty = !0), this;
    }
    get corner() {
        return new (0, $cf3018b4309864c2$export$baf26146a414f24a)(-this.x / this.scale.x, -this.y / this.scale.y);
    }
    set corner(t) {
        this.moveCorner(t);
    }
    moveCorner(...t) {
        let i, e;
        return t.length === 1 ? (i = -t[0].x * this.scale.x, e = -t[0].y * this.scale.y) : (i = -t[0] * this.scale.x, e = -t[1] * this.scale.y), (i !== this.x || e !== this.y) && (this.position.set(i, e), this.plugins.reset(), this.dirty = !0), this;
    }
    get screenWidthInWorldPixels() {
        return this.screenWidth / this.scale.x;
    }
    get screenHeightInWorldPixels() {
        return this.screenHeight / this.scale.y;
    }
    findFitWidth(t) {
        return this.screenWidth / t;
    }
    findFitHeight(t) {
        return this.screenHeight / t;
    }
    findFit(t, i) {
        const e = this.screenWidth / t, n = this.screenHeight / i;
        return Math.min(e, n);
    }
    findCover(t, i) {
        const e = this.screenWidth / t, n = this.screenHeight / i;
        return Math.max(e, n);
    }
    fitWidth(t = this.worldWidth, i, e = !0, n) {
        let s;
        i && (s = this.center), this.scale.x = this.screenWidth / t, e && (this.scale.y = this.scale.x);
        const h = this.plugins.get("clamp-zoom", !0);
        return !n && h && h.clamp(), i && s && this.moveCenter(s), this;
    }
    fitHeight(t = this.worldHeight, i, e = !0, n) {
        let s;
        i && (s = this.center), this.scale.y = this.screenHeight / t, e && (this.scale.x = this.scale.y);
        const h = this.plugins.get("clamp-zoom", !0);
        return !n && h && h.clamp(), i && s && this.moveCenter(s), this;
    }
    fitWorld(t) {
        let i;
        t && (i = this.center), this.scale.x = this.screenWidth / this.worldWidth, this.scale.y = this.screenHeight / this.worldHeight, this.scale.x < this.scale.y ? this.scale.y = this.scale.x : this.scale.x = this.scale.y;
        const e = this.plugins.get("clamp-zoom", !0);
        return e && e.clamp(), t && i && this.moveCenter(i), this;
    }
    fit(t, i = this.worldWidth, e = this.worldHeight) {
        let n;
        t && (n = this.center), this.scale.x = this.screenWidth / i, this.scale.y = this.screenHeight / e, this.scale.x < this.scale.y ? this.scale.y = this.scale.x : this.scale.x = this.scale.y;
        const s = this.plugins.get("clamp-zoom", !0);
        return s && s.clamp(), t && n && this.moveCenter(n), this;
    }
    setZoom(t, i) {
        let e;
        i && (e = this.center), this.scale.set(t);
        const n = this.plugins.get("clamp-zoom", !0);
        return n && n.clamp(), i && e && this.moveCenter(e), this;
    }
    zoomPercent(t, i) {
        return this.setZoom(this.scale.x + this.scale.x * t, i);
    }
    zoom(t, i) {
        return this.fitWidth(t + this.worldScreenWidth, i), this;
    }
    get scaled() {
        return this.scale.x;
    }
    set scaled(t) {
        this.setZoom(t, !0);
    }
    snapZoom(t) {
        return this.plugins.add("snap-zoom", new $b4245adbfe6bbe42$export$8d3b89b6e4db7cd0(this, t)), this;
    }
    OOB() {
        return {
            left: this.left < 0,
            right: this.right > this.worldWidth,
            top: this.top < 0,
            bottom: this.bottom > this.worldHeight,
            cornerPoint: new (0, $cf3018b4309864c2$export$baf26146a414f24a)(this.worldWidth * this.scale.x - this.screenWidth, this.worldHeight * this.scale.y - this.screenHeight)
        };
    }
    get right() {
        return -this.x / this.scale.x + this.worldScreenWidth;
    }
    set right(t) {
        this.x = -t * this.scale.x + this.screenWidth, this.plugins.reset();
    }
    get left() {
        return -this.x / this.scale.x;
    }
    set left(t) {
        this.x = -t * this.scale.x, this.plugins.reset();
    }
    get top() {
        return -this.y / this.scale.y;
    }
    set top(t) {
        this.y = -t * this.scale.y, this.plugins.reset();
    }
    get bottom() {
        return -this.y / this.scale.y + this.worldScreenHeight;
    }
    set bottom(t) {
        this.y = -t * this.scale.y + this.screenHeight, this.plugins.reset();
    }
    get dirty() {
        return !!this._dirty;
    }
    set dirty(t) {
        this._dirty = t;
    }
    get forceHitArea() {
        return this._forceHitArea;
    }
    set forceHitArea(t) {
        t ? (this._forceHitArea = t, this.hitArea = t) : (this._forceHitArea = null, this.hitArea = new (0, $200f778d7fdbf8ac$export$4617fb02663045ef)(0, 0, this.worldWidth, this.worldHeight));
    }
    drag(t) {
        return this.plugins.add("drag", new $b4245adbfe6bbe42$export$b48985bba8f530f5(this, t)), this;
    }
    clamp(t) {
        return this.plugins.add("clamp", new $b4245adbfe6bbe42$export$90534cad35a14134(this, t)), this;
    }
    decelerate(t) {
        return this.plugins.add("decelerate", new $b4245adbfe6bbe42$export$4bbb5144deae3118(this, t)), this;
    }
    bounce(t) {
        return this.plugins.add("bounce", new $b4245adbfe6bbe42$export$d20e79fdc3899e95(this, t)), this;
    }
    pinch(t) {
        return this.plugins.add("pinch", new $b4245adbfe6bbe42$export$826ae541ddf1527b(this, t)), this;
    }
    snap(t, i, e) {
        return this.plugins.add("snap", new $b4245adbfe6bbe42$export$4dbf1f67c012298b(this, t, i, e)), this;
    }
    follow(t, i) {
        return this.plugins.add("follow", new $b4245adbfe6bbe42$export$455f05776f1ba8ba(this, t, i)), this;
    }
    wheel(t) {
        return this.plugins.add("wheel", new $b4245adbfe6bbe42$export$ae16e1bcb40d6793(this, t)), this;
    }
    animate(t) {
        return this.plugins.add("animate", new $b4245adbfe6bbe42$export$83a1293bbde53b95(this, t)), this;
    }
    clampZoom(t) {
        return this.plugins.add("clamp-zoom", new $b4245adbfe6bbe42$export$220d7a3461bca2df(this, t)), this;
    }
    mouseEdges(t) {
        return this.plugins.add("mouse-edges", new $b4245adbfe6bbe42$export$dd505d2e20e3eaaf(this, t)), this;
    }
    get pause() {
        return !!this._pause;
    }
    set pause(t) {
        this._pause = t, this.lastViewport = null, this.moving = !1, this.zooming = !1, t && this.input.pause();
    }
    ensureVisible(t, i, e, n, s) {
        s && (e > this.worldScreenWidth || n > this.worldScreenHeight) && (this.fit(!0, e, n), this.emit("zoomed", {
            viewport: this,
            type: "ensureVisible"
        }));
        let h = !1;
        t < this.left ? (this.left = t, h = !0) : t + e > this.right && (this.right = t + e, h = !0), i < this.top ? (this.top = i, h = !0) : i + n > this.bottom && (this.bottom = i + n, h = !0), h && this.emit("moved", {
            viewport: this,
            type: "ensureVisible"
        });
    }
}






const $e4c5b2569bd3a8d2$var$tempPoint = new (0, $cf3018b4309864c2$export$baf26146a414f24a)(), $e4c5b2569bd3a8d2$var$indices = new Uint16Array([
    0,
    1,
    2,
    0,
    2,
    3
]);
class $e4c5b2569bd3a8d2$export$3075603db8e6204c extends (0, $68e6944de5989822$export$42a852a2b6b56249) {
    /** @param texture - The texture for this sprite. */ constructor(texture){
        super(), this._anchor = new (0, $52576bc20755886a$export$3755aaad3fd42e52)(this._onAnchorUpdate, this, texture ? texture.defaultAnchor.x : 0, texture ? texture.defaultAnchor.y : 0), this._texture = null, this._width = 0, this._height = 0, this._tintColor = new (0, $15154c33c9e19c5f$export$892596cec99bc70e)(16777215), this._tintRGB = null, this.tint = 16777215, this.blendMode = (0, $0fa4b07f86297abd$export$f821c68fe9beaecf).NORMAL, this._cachedTint = 16777215, this.uvs = null, this.texture = texture || (0, $14896914ad3ae15d$export$5431306cf43de24a).EMPTY, this.vertexData = new Float32Array(8), this.vertexTrimmedData = null, this._transformID = -1, this._textureID = -1, this._transformTrimmedID = -1, this._textureTrimmedID = -1, this.indices = $e4c5b2569bd3a8d2$var$indices, this.pluginName = "batch", this.isSprite = !0, this._roundPixels = (0, $2808efac47e52be0$export$a5a6e0b888b2c992).ROUND_PIXELS;
    }
    /** When the texture is updated, this event will fire to update the scale and frame. */ _onTextureUpdate() {
        this._textureID = -1, this._textureTrimmedID = -1, this._cachedTint = 16777215, this._width && (this.scale.x = (0, $db31fc3dfae4939b$exports).sign(this.scale.x) * this._width / this._texture.orig.width), this._height && (this.scale.y = (0, $db31fc3dfae4939b$exports).sign(this.scale.y) * this._height / this._texture.orig.height);
    }
    /** Called when the anchor position updates. */ _onAnchorUpdate() {
        this._transformID = -1, this._transformTrimmedID = -1;
    }
    /** Calculates worldTransform * vertices, store it in vertexData. */ calculateVertices() {
        const texture = this._texture;
        if (this._transformID === this.transform._worldID && this._textureID === texture._updateID) return;
        this._textureID !== texture._updateID && (this.uvs = this._texture._uvs.uvsFloat32), this._transformID = this.transform._worldID, this._textureID = texture._updateID;
        const wt = this.transform.worldTransform, a = wt.a, b = wt.b, c = wt.c, d = wt.d, tx = wt.tx, ty = wt.ty, vertexData = this.vertexData, trim = texture.trim, orig = texture.orig, anchor = this._anchor;
        let w0 = 0, w1 = 0, h0 = 0, h1 = 0;
        if (trim ? (w1 = trim.x - anchor._x * orig.width, w0 = w1 + trim.width, h1 = trim.y - anchor._y * orig.height, h0 = h1 + trim.height) : (w1 = -anchor._x * orig.width, w0 = w1 + orig.width, h1 = -anchor._y * orig.height, h0 = h1 + orig.height), vertexData[0] = a * w1 + c * h1 + tx, vertexData[1] = d * h1 + b * w1 + ty, vertexData[2] = a * w0 + c * h1 + tx, vertexData[3] = d * h1 + b * w0 + ty, vertexData[4] = a * w0 + c * h0 + tx, vertexData[5] = d * h0 + b * w0 + ty, vertexData[6] = a * w1 + c * h0 + tx, vertexData[7] = d * h0 + b * w1 + ty, this._roundPixels) {
            const resolution = (0, $2808efac47e52be0$export$a5a6e0b888b2c992).RESOLUTION;
            for(let i = 0; i < vertexData.length; ++i)vertexData[i] = Math.round(vertexData[i] * resolution) / resolution;
        }
    }
    /**
   * Calculates worldTransform * vertices for a non texture with a trim. store it in vertexTrimmedData.
   *
   * This is used to ensure that the true width and height of a trimmed texture is respected.
   */ calculateTrimmedVertices() {
        if (!this.vertexTrimmedData) this.vertexTrimmedData = new Float32Array(8);
        else if (this._transformTrimmedID === this.transform._worldID && this._textureTrimmedID === this._texture._updateID) return;
        this._transformTrimmedID = this.transform._worldID, this._textureTrimmedID = this._texture._updateID;
        const texture = this._texture, vertexData = this.vertexTrimmedData, orig = texture.orig, anchor = this._anchor, wt = this.transform.worldTransform, a = wt.a, b = wt.b, c = wt.c, d = wt.d, tx = wt.tx, ty = wt.ty, w1 = -anchor._x * orig.width, w0 = w1 + orig.width, h1 = -anchor._y * orig.height, h0 = h1 + orig.height;
        if (vertexData[0] = a * w1 + c * h1 + tx, vertexData[1] = d * h1 + b * w1 + ty, vertexData[2] = a * w0 + c * h1 + tx, vertexData[3] = d * h1 + b * w0 + ty, vertexData[4] = a * w0 + c * h0 + tx, vertexData[5] = d * h0 + b * w0 + ty, vertexData[6] = a * w1 + c * h0 + tx, vertexData[7] = d * h0 + b * w1 + ty, this._roundPixels) {
            const resolution = (0, $2808efac47e52be0$export$a5a6e0b888b2c992).RESOLUTION;
            for(let i = 0; i < vertexData.length; ++i)vertexData[i] = Math.round(vertexData[i] * resolution) / resolution;
        }
    }
    /**
   *
   * Renders the object using the WebGL renderer
   * @param renderer - The webgl renderer to use.
   */ _render(renderer) {
        this.calculateVertices(), renderer.batch.setObjectRenderer(renderer.plugins[this.pluginName]), renderer.plugins[this.pluginName].render(this);
    }
    /** Updates the bounds of the sprite. */ _calculateBounds() {
        const trim = this._texture.trim, orig = this._texture.orig;
        !trim || trim.width === orig.width && trim.height === orig.height ? (this.calculateVertices(), this._bounds.addQuad(this.vertexData)) : (this.calculateTrimmedVertices(), this._bounds.addQuad(this.vertexTrimmedData));
    }
    /**
   * Gets the local bounds of the sprite object.
   * @param rect - Optional output rectangle.
   * @returns The bounds.
   */ getLocalBounds(rect) {
        return this.children.length === 0 ? (this._localBounds || (this._localBounds = new (0, $816971236b5d7d99$export$c4e9d269599ab4b4)()), this._localBounds.minX = this._texture.orig.width * -this._anchor._x, this._localBounds.minY = this._texture.orig.height * -this._anchor._y, this._localBounds.maxX = this._texture.orig.width * (1 - this._anchor._x), this._localBounds.maxY = this._texture.orig.height * (1 - this._anchor._y), rect || (this._localBoundsRect || (this._localBoundsRect = new (0, $200f778d7fdbf8ac$export$4617fb02663045ef)()), rect = this._localBoundsRect), this._localBounds.getRectangle(rect)) : super.getLocalBounds.call(this, rect);
    }
    /**
   * Tests if a point is inside this sprite
   * @param point - the point to test
   * @returns The result of the test
   */ containsPoint(point) {
        this.worldTransform.applyInverse(point, $e4c5b2569bd3a8d2$var$tempPoint);
        const width = this._texture.orig.width, height = this._texture.orig.height, x1 = -width * this.anchor.x;
        let y1 = 0;
        return $e4c5b2569bd3a8d2$var$tempPoint.x >= x1 && $e4c5b2569bd3a8d2$var$tempPoint.x < x1 + width && (y1 = -height * this.anchor.y, $e4c5b2569bd3a8d2$var$tempPoint.y >= y1 && $e4c5b2569bd3a8d2$var$tempPoint.y < y1 + height);
    }
    /**
   * Destroys this sprite and optionally its texture and children.
   * @param options - Options parameter. A boolean will act as if all options
   *  have been set to that value
   * @param [options.children=false] - if set to true, all the children will have their destroy
   *      method called as well. 'options' will be passed on to those calls.
   * @param [options.texture=false] - Should it destroy the current texture of the sprite as well
   * @param [options.baseTexture=false] - Should it destroy the base texture of the sprite as well
   */ destroy(options) {
        if (super.destroy(options), this._texture.off("update", this._onTextureUpdate, this), this._anchor = null, typeof options == "boolean" ? options : options?.texture) {
            const destroyBaseTexture = typeof options == "boolean" ? options : options?.baseTexture;
            this._texture.destroy(!!destroyBaseTexture);
        }
        this._texture = null;
    }
    // some helper functions..
    /**
   * Helper function that creates a new sprite based on the source you provide.
   * The source can be - frame id, image url, video url, canvas element, video element, base texture
   * @param {string|PIXI.Texture|HTMLImageElement|HTMLVideoElement|ImageBitmap|PIXI.ICanvas} source
   *     - Source to create texture from
   * @param {object} [options] - See {@link PIXI.BaseTexture}'s constructor for options.
   * @returns The newly created sprite
   */ static from(source, options) {
        const texture = source instanceof (0, $14896914ad3ae15d$export$5431306cf43de24a) ? source : (0, $14896914ad3ae15d$export$5431306cf43de24a).from(source, options);
        return new $e4c5b2569bd3a8d2$export$3075603db8e6204c(texture);
    }
    /**
   * If true PixiJS will Math.floor() x/y values when rendering, stopping pixel interpolation.
   *
   * Advantages can include sharper image quality (like text) and faster rendering on canvas.
   * The main disadvantage is movement of objects may appear less smooth.
   *
   * To set the global default, change {@link PIXI.settings.ROUND_PIXELS}.
   * @default false
   */ set roundPixels(value) {
        this._roundPixels !== value && (this._transformID = -1, this._transformTrimmedID = -1), this._roundPixels = value;
    }
    get roundPixels() {
        return this._roundPixels;
    }
    /** The width of the sprite, setting this will actually modify the scale to achieve the value set. */ get width() {
        return Math.abs(this.scale.x) * this._texture.orig.width;
    }
    set width(value) {
        const s = (0, $db31fc3dfae4939b$exports).sign(this.scale.x) || 1;
        this.scale.x = s * value / this._texture.orig.width, this._width = value;
    }
    /** The height of the sprite, setting this will actually modify the scale to achieve the value set. */ get height() {
        return Math.abs(this.scale.y) * this._texture.orig.height;
    }
    set height(value) {
        const s = (0, $db31fc3dfae4939b$exports).sign(this.scale.y) || 1;
        this.scale.y = s * value / this._texture.orig.height, this._height = value;
    }
    /**
   * The anchor sets the origin point of the sprite. The default value is taken from the {@link PIXI.Texture|Texture}
   * and passed to the constructor.
   *
   * The default is `(0,0)`, this means the sprite's origin is the top left.
   *
   * Setting the anchor to `(0.5,0.5)` means the sprite's origin is centered.
   *
   * Setting the anchor to `(1,1)` would mean the sprite's origin point will be the bottom right corner.
   *
   * If you pass only single parameter, it will set both x and y to the same value as shown in the example below.
   * @example
   * import { Sprite } from 'pixi.js';
   *
   * const sprite = new Sprite(Texture.WHITE);
   * sprite.anchor.set(0.5); // This will set the origin to center. (0.5) is same as (0.5, 0.5).
   */ get anchor() {
        return this._anchor;
    }
    set anchor(value) {
        this._anchor.copyFrom(value);
    }
    /**
   * The tint applied to the sprite. This is a hex value.
   *
   * A value of 0xFFFFFF will remove any tint effect.
   * @default 0xFFFFFF
   */ get tint() {
        return this._tintColor.value;
    }
    set tint(value) {
        this._tintColor.setValue(value), this._tintRGB = this._tintColor.toLittleEndianNumber();
    }
    /**
   * Get the tint as a RGB integer.
   * @ignore
   */ get tintValue() {
        return this._tintColor.toNumber();
    }
    /** The texture that the sprite is using. */ get texture() {
        return this._texture;
    }
    set texture(value) {
        this._texture !== value && (this._texture && this._texture.off("update", this._onTextureUpdate, this), this._texture = value || (0, $14896914ad3ae15d$export$5431306cf43de24a).EMPTY, this._cachedTint = 16777215, this._textureID = -1, this._textureTrimmedID = -1, value && (value.baseTexture.valid ? this._onTextureUpdate() : value.once("update", this._onTextureUpdate, this)));
    }
}




const $d730b65d4ece79ba$var$_tempMatrix = new (0, $d7da222aa639cde0$export$5b12bf1653c0dd85)();
(0, $469c1c392031bfb3$export$1f679544f90d7d7c).prototype._cacheAsBitmap = !1;
(0, $469c1c392031bfb3$export$1f679544f90d7d7c).prototype._cacheData = null;
(0, $469c1c392031bfb3$export$1f679544f90d7d7c).prototype._cacheAsBitmapResolution = null;
(0, $469c1c392031bfb3$export$1f679544f90d7d7c).prototype._cacheAsBitmapMultisample = null;
class $d730b65d4ece79ba$export$3e19bdfd927f283c {
    constructor(){
        this.textureCacheId = null, this.originalRender = null, this.originalRenderCanvas = null, this.originalCalculateBounds = null, this.originalGetLocalBounds = null, this.originalUpdateTransform = null, this.originalDestroy = null, this.originalMask = null, this.originalFilterArea = null, this.originalContainsPoint = null, this.sprite = null;
    }
}
Object.defineProperties((0, $469c1c392031bfb3$export$1f679544f90d7d7c).prototype, {
    /**
   * The resolution to use for cacheAsBitmap. By default this will use the renderer's resolution
   * but can be overriden for performance. Lower values will reduce memory usage at the expense
   * of render quality. A falsey value of `null` or `0` will default to the renderer's resolution.
   * If `cacheAsBitmap` is set to `true`, this will re-render with the new resolution.
   * @member {number|null} cacheAsBitmapResolution
   * @memberof PIXI.DisplayObject#
   * @default null
   */ cacheAsBitmapResolution: {
        get () {
            return this._cacheAsBitmapResolution;
        },
        set (resolution) {
            resolution !== this._cacheAsBitmapResolution && (this._cacheAsBitmapResolution = resolution, this.cacheAsBitmap && (this.cacheAsBitmap = !1, this.cacheAsBitmap = !0));
        }
    },
    /**
   * The number of samples to use for cacheAsBitmap. If set to `null`, the renderer's
   * sample count is used.
   * If `cacheAsBitmap` is set to `true`, this will re-render with the new number of samples.
   * @member {number|null} cacheAsBitmapMultisample
   * @memberof PIXI.DisplayObject#
   * @default null
   */ cacheAsBitmapMultisample: {
        get () {
            return this._cacheAsBitmapMultisample;
        },
        set (multisample) {
            multisample !== this._cacheAsBitmapMultisample && (this._cacheAsBitmapMultisample = multisample, this.cacheAsBitmap && (this.cacheAsBitmap = !1, this.cacheAsBitmap = !0));
        }
    },
    /**
   * Set this to true if you want this display object to be cached as a bitmap.
   * This basically takes a snapshot of the display object as it is at that moment. It can
   * provide a performance benefit for complex static displayObjects.
   * To remove simply set this property to `false`
   *
   * IMPORTANT GOTCHA - Make sure that all your textures are preloaded BEFORE setting this property to true
   * as it will take a snapshot of what is currently there. If the textures have not loaded then they will not appear.
   * @member {boolean}
   * @memberof PIXI.DisplayObject#
   */ cacheAsBitmap: {
        get () {
            return this._cacheAsBitmap;
        },
        set (value) {
            if (this._cacheAsBitmap === value) return;
            this._cacheAsBitmap = value;
            let data;
            value ? (this._cacheData || (this._cacheData = new $d730b65d4ece79ba$export$3e19bdfd927f283c()), data = this._cacheData, data.originalRender = this.render, data.originalRenderCanvas = this.renderCanvas, data.originalUpdateTransform = this.updateTransform, data.originalCalculateBounds = this.calculateBounds, data.originalGetLocalBounds = this.getLocalBounds, data.originalDestroy = this.destroy, data.originalContainsPoint = this.containsPoint, data.originalMask = this._mask, data.originalFilterArea = this.filterArea, this.render = this._renderCached, this.renderCanvas = this._renderCachedCanvas, this.destroy = this._cacheAsBitmapDestroy) : (data = this._cacheData, data.sprite && this._destroyCachedDisplayObject(), this.render = data.originalRender, this.renderCanvas = data.originalRenderCanvas, this.calculateBounds = data.originalCalculateBounds, this.getLocalBounds = data.originalGetLocalBounds, this.destroy = data.originalDestroy, this.updateTransform = data.originalUpdateTransform, this.containsPoint = data.originalContainsPoint, this._mask = data.originalMask, this.filterArea = data.originalFilterArea);
        }
    }
});
(0, $469c1c392031bfb3$export$1f679544f90d7d7c).prototype._renderCached = function(renderer) {
    !this.visible || this.worldAlpha <= 0 || !this.renderable || (this._initCachedDisplayObject(renderer), this._cacheData.sprite.transform._worldID = this.transform._worldID, this._cacheData.sprite.worldAlpha = this.worldAlpha, this._cacheData.sprite._render(renderer));
};
(0, $469c1c392031bfb3$export$1f679544f90d7d7c).prototype._initCachedDisplayObject = function(renderer) {
    if (this._cacheData?.sprite) return;
    const cacheAlpha = this.alpha;
    this.alpha = 1, renderer.batch.flush();
    const bounds = this.getLocalBounds(new (0, $200f778d7fdbf8ac$export$4617fb02663045ef)(), !0);
    if (this.filters?.length) {
        const padding = this.filters[0].padding;
        bounds.pad(padding);
    }
    const resolution = this.cacheAsBitmapResolution || renderer.resolution;
    bounds.ceil(resolution), bounds.width = Math.max(bounds.width, 1 / resolution), bounds.height = Math.max(bounds.height, 1 / resolution);
    const cachedRenderTexture = renderer.renderTexture.current, cachedSourceFrame = renderer.renderTexture.sourceFrame.clone(), cachedDestinationFrame = renderer.renderTexture.destinationFrame.clone(), cachedProjectionTransform = renderer.projection.transform, renderTexture = (0, $f917e2bbb9b65ecb$export$813984f7330b4d72).create({
        width: bounds.width,
        height: bounds.height,
        resolution: resolution,
        multisample: this.cacheAsBitmapMultisample ?? renderer.multisample
    }), textureCacheId = `cacheAsBitmap_${(0, $db31fc3dfae4939b$exports).uid()}`;
    this._cacheData.textureCacheId = textureCacheId, (0, $30c85657f0c625d5$export$d6306e508f184154).addToCache(renderTexture.baseTexture, textureCacheId), (0, $14896914ad3ae15d$export$5431306cf43de24a).addToCache(renderTexture, textureCacheId);
    const m = this.transform.localTransform.copyTo($d730b65d4ece79ba$var$_tempMatrix).invert().translate(-bounds.x, -bounds.y);
    this.render = this._cacheData.originalRender, renderer.render(this, {
        renderTexture: renderTexture,
        clear: !0,
        transform: m,
        skipUpdateTransform: !1
    }), renderer.framebuffer.blit(), renderer.projection.transform = cachedProjectionTransform, renderer.renderTexture.bind(cachedRenderTexture, cachedSourceFrame, cachedDestinationFrame), this.render = this._renderCached, this.updateTransform = this.displayObjectUpdateTransform, this.calculateBounds = this._calculateCachedBounds, this.getLocalBounds = this._getCachedLocalBounds, this._mask = null, this.filterArea = null, this.alpha = cacheAlpha;
    const cachedSprite = new (0, $e4c5b2569bd3a8d2$export$3075603db8e6204c)(renderTexture);
    cachedSprite.transform.worldTransform = this.transform.worldTransform, cachedSprite.anchor.x = -(bounds.x / bounds.width), cachedSprite.anchor.y = -(bounds.y / bounds.height), cachedSprite.alpha = cacheAlpha, cachedSprite._bounds = this._bounds, this._cacheData.sprite = cachedSprite, this.transform._parentID = -1, this.parent ? this.updateTransform() : (this.enableTempParent(), this.updateTransform(), this.disableTempParent(null)), this.containsPoint = cachedSprite.containsPoint.bind(cachedSprite);
};
(0, $469c1c392031bfb3$export$1f679544f90d7d7c).prototype._renderCachedCanvas = function(renderer) {
    !this.visible || this.worldAlpha <= 0 || !this.renderable || (this._initCachedDisplayObjectCanvas(renderer), this._cacheData.sprite.worldAlpha = this.worldAlpha, this._cacheData.sprite._renderCanvas(renderer));
};
(0, $469c1c392031bfb3$export$1f679544f90d7d7c).prototype._initCachedDisplayObjectCanvas = function(renderer) {
    if (this._cacheData?.sprite) return;
    const bounds = this.getLocalBounds(new (0, $200f778d7fdbf8ac$export$4617fb02663045ef)(), !0), cacheAlpha = this.alpha;
    this.alpha = 1;
    const cachedRenderTarget = renderer.canvasContext.activeContext, cachedProjectionTransform = renderer._projTransform, resolution = this.cacheAsBitmapResolution || renderer.resolution;
    bounds.ceil(resolution), bounds.width = Math.max(bounds.width, 1 / resolution), bounds.height = Math.max(bounds.height, 1 / resolution);
    const renderTexture = (0, $f917e2bbb9b65ecb$export$813984f7330b4d72).create({
        width: bounds.width,
        height: bounds.height,
        resolution: resolution
    }), textureCacheId = `cacheAsBitmap_${(0, $db31fc3dfae4939b$exports).uid()}`;
    this._cacheData.textureCacheId = textureCacheId, (0, $30c85657f0c625d5$export$d6306e508f184154).addToCache(renderTexture.baseTexture, textureCacheId), (0, $14896914ad3ae15d$export$5431306cf43de24a).addToCache(renderTexture, textureCacheId);
    const m = $d730b65d4ece79ba$var$_tempMatrix;
    this.transform.localTransform.copyTo(m), m.invert(), m.tx -= bounds.x, m.ty -= bounds.y, this.renderCanvas = this._cacheData.originalRenderCanvas, renderer.render(this, {
        renderTexture: renderTexture,
        clear: !0,
        transform: m,
        skipUpdateTransform: !1
    }), renderer.canvasContext.activeContext = cachedRenderTarget, renderer._projTransform = cachedProjectionTransform, this.renderCanvas = this._renderCachedCanvas, this.updateTransform = this.displayObjectUpdateTransform, this.calculateBounds = this._calculateCachedBounds, this.getLocalBounds = this._getCachedLocalBounds, this._mask = null, this.filterArea = null, this.alpha = cacheAlpha;
    const cachedSprite = new (0, $e4c5b2569bd3a8d2$export$3075603db8e6204c)(renderTexture);
    cachedSprite.transform.worldTransform = this.transform.worldTransform, cachedSprite.anchor.x = -(bounds.x / bounds.width), cachedSprite.anchor.y = -(bounds.y / bounds.height), cachedSprite.alpha = cacheAlpha, cachedSprite._bounds = this._bounds, this._cacheData.sprite = cachedSprite, this.transform._parentID = -1, this.parent ? this.updateTransform() : (this.parent = renderer._tempDisplayObjectParent, this.updateTransform(), this.parent = null), this.containsPoint = cachedSprite.containsPoint.bind(cachedSprite);
};
(0, $469c1c392031bfb3$export$1f679544f90d7d7c).prototype._calculateCachedBounds = function() {
    this._bounds.clear(), this._cacheData.sprite.transform._worldID = this.transform._worldID, this._cacheData.sprite._calculateBounds(), this._bounds.updateID = this._boundsID;
};
(0, $469c1c392031bfb3$export$1f679544f90d7d7c).prototype._getCachedLocalBounds = function() {
    return this._cacheData.sprite.getLocalBounds(null);
};
(0, $469c1c392031bfb3$export$1f679544f90d7d7c).prototype._destroyCachedDisplayObject = function() {
    this._cacheData.sprite._texture.destroy(!0), this._cacheData.sprite = null, (0, $30c85657f0c625d5$export$d6306e508f184154).removeFromCache(this._cacheData.textureCacheId), (0, $14896914ad3ae15d$export$5431306cf43de24a).removeFromCache(this._cacheData.textureCacheId), this._cacheData.textureCacheId = null;
};
(0, $469c1c392031bfb3$export$1f679544f90d7d7c).prototype._cacheAsBitmapDestroy = function(options) {
    this.cacheAsBitmap = !1, this.destroy(options);
};



(0, $469c1c392031bfb3$export$1f679544f90d7d7c).prototype.name = null;
(0, $68e6944de5989822$export$42a852a2b6b56249).prototype.getChildByName = function(name, deep) {
    for(let i = 0, j = this.children.length; i < j; i++)if (this.children[i].name === name) return this.children[i];
    if (deep) for(let i = 0, j = this.children.length; i < j; i++){
        const child = this.children[i];
        if (!child.getChildByName) continue;
        const target = child.getChildByName(name, !0);
        if (target) return target;
    }
    return null;
};




(0, $469c1c392031bfb3$export$1f679544f90d7d7c).prototype.getGlobalPosition = function(point = new (0, $cf3018b4309864c2$export$baf26146a414f24a)(), skipUpdate = !1) {
    return this.parent ? this.parent.toGlobal(this.position, point, skipUpdate) : (point.x = this.position.x, point.y = this.position.y), point;
};




var $78af93bd8a0c79fb$export$2e2bcd8739ae039 = `varying vec2 vTextureCoord;

uniform sampler2D uSampler;
uniform float uAlpha;

void main(void)
{
   gl_FragColor = texture2D(uSampler, vTextureCoord) * uAlpha;
}
`;


class $185693a8f7b67b9f$export$adbaa0de008b0d7a extends (0, $46266bc3fe6194b8$export$ec91da630f36d5ea) {
    /**
   * @param alpha - Amount of alpha from 0 to 1, where 0 is transparent
   */ constructor(alpha = 1){
        super((0, $cd81e2f0e1d30179$export$4a1a95006fc6b0f1), (0, $78af93bd8a0c79fb$export$2e2bcd8739ae039), {
            uAlpha: 1
        }), this.alpha = alpha;
    }
    /**
   * Coefficient for alpha multiplication
   * @default 1
   */ get alpha() {
        return this.uniforms.uAlpha;
    }
    set alpha(value) {
        this.uniforms.uAlpha = value;
    }
}






const $c9d99a560095ff95$var$GAUSSIAN_VALUES = {
    5: [
        0.153388,
        0.221461,
        0.250301
    ],
    7: [
        0.071303,
        0.131514,
        0.189879,
        0.214607
    ],
    9: [
        0.028532,
        0.067234,
        0.124009,
        0.179044,
        0.20236
    ],
    11: [
        93e-4,
        0.028002,
        0.065984,
        0.121703,
        0.175713,
        0.198596
    ],
    13: [
        2406e-6,
        9255e-6,
        0.027867,
        0.065666,
        0.121117,
        0.174868,
        0.197641
    ],
    15: [
        489e-6,
        2403e-6,
        9246e-6,
        0.02784,
        0.065602,
        0.120999,
        0.174697,
        0.197448
    ]
}, $c9d99a560095ff95$var$fragTemplate = [
    "varying vec2 vBlurTexCoords[%size%];",
    "uniform sampler2D uSampler;",
    "void main(void)",
    "{",
    "    gl_FragColor = vec4(0.0);",
    "    %blur%",
    "}"
].join(`
`);
function $c9d99a560095ff95$export$1b0dcf101eb6a1c9(kernelSize) {
    const kernel = $c9d99a560095ff95$var$GAUSSIAN_VALUES[kernelSize], halfLength = kernel.length;
    let fragSource = $c9d99a560095ff95$var$fragTemplate, blurLoop = "";
    const template = "gl_FragColor += texture2D(uSampler, vBlurTexCoords[%index%]) * %value%;";
    let value;
    for(let i = 0; i < kernelSize; i++){
        let blur = template.replace("%index%", i.toString());
        value = i, i >= halfLength && (value = kernelSize - i - 1), blur = blur.replace("%value%", kernel[value].toString()), blurLoop += blur, blurLoop += `
`;
    }
    return fragSource = fragSource.replace("%blur%", blurLoop), fragSource = fragSource.replace("%size%", kernelSize.toString()), fragSource;
}


const $e31be87370f7b160$var$vertTemplate = `
    attribute vec2 aVertexPosition;

    uniform mat3 projectionMatrix;

    uniform float strength;

    varying vec2 vBlurTexCoords[%size%];

    uniform vec4 inputSize;
    uniform vec4 outputFrame;

    vec4 filterVertexPosition( void )
    {
        vec2 position = aVertexPosition * max(outputFrame.zw, vec2(0.)) + outputFrame.xy;

        return vec4((projectionMatrix * vec3(position, 1.0)).xy, 0.0, 1.0);
    }

    vec2 filterTextureCoord( void )
    {
        return aVertexPosition * (outputFrame.zw * inputSize.zw);
    }

    void main(void)
    {
        gl_Position = filterVertexPosition();

        vec2 textureCoord = filterTextureCoord();
        %blur%
    }`;
function $e31be87370f7b160$export$7a7fb9d9d09c33af(kernelSize, x) {
    const halfLength = Math.ceil(kernelSize / 2);
    let vertSource = $e31be87370f7b160$var$vertTemplate, blurLoop = "", template;
    x ? template = "vBlurTexCoords[%index%] =  textureCoord + vec2(%sampleIndex% * strength, 0.0);" : template = "vBlurTexCoords[%index%] =  textureCoord + vec2(0.0, %sampleIndex% * strength);";
    for(let i = 0; i < kernelSize; i++){
        let blur = template.replace("%index%", i.toString());
        blur = blur.replace("%sampleIndex%", `${i - (halfLength - 1)}.0`), blurLoop += blur, blurLoop += `
`;
    }
    return vertSource = vertSource.replace("%blur%", blurLoop), vertSource = vertSource.replace("%size%", kernelSize.toString()), vertSource;
}


class $62a86b1a01dbfe3b$export$b100a8e8116621cf extends (0, $46266bc3fe6194b8$export$ec91da630f36d5ea) {
    /**
   * @param horizontal - Do pass along the x-axis (`true`) or y-axis (`false`).
   * @param strength - The strength of the blur filter.
   * @param quality - The quality of the blur filter.
   * @param {number|null} [resolution=PIXI.Filter.defaultResolution] - The resolution of the blur filter.
   * @param kernelSize - The kernelSize of the blur filter.Options: 5, 7, 9, 11, 13, 15.
   */ constructor(horizontal, strength = 8, quality = 4, resolution = (0, $46266bc3fe6194b8$export$ec91da630f36d5ea).defaultResolution, kernelSize = 5){
        const vertSrc = (0, $e31be87370f7b160$export$7a7fb9d9d09c33af)(kernelSize, horizontal), fragSrc = (0, $c9d99a560095ff95$export$1b0dcf101eb6a1c9)(kernelSize);
        super(// vertex shader
        vertSrc, // fragment shader
        fragSrc), this.horizontal = horizontal, this.resolution = resolution, this._quality = 0, this.quality = quality, this.blur = strength;
    }
    /**
   * Applies the filter.
   * @param filterManager - The manager.
   * @param input - The input target.
   * @param output - The output target.
   * @param clearMode - How to clear
   */ apply(filterManager, input, output, clearMode) {
        if (output ? this.horizontal ? this.uniforms.strength = 1 / output.width * (output.width / input.width) : this.uniforms.strength = 1 / output.height * (output.height / input.height) : this.horizontal ? this.uniforms.strength = 1 / filterManager.renderer.width * (filterManager.renderer.width / input.width) : this.uniforms.strength = 1 / filterManager.renderer.height * (filterManager.renderer.height / input.height), this.uniforms.strength *= this.strength, this.uniforms.strength /= this.passes, this.passes === 1) filterManager.applyFilter(this, input, output, clearMode);
        else {
            const renderTarget = filterManager.getFilterTexture(), renderer = filterManager.renderer;
            let flip = input, flop = renderTarget;
            this.state.blend = !1, filterManager.applyFilter(this, flip, flop, (0, $0fa4b07f86297abd$export$784901839554cbc3).CLEAR);
            for(let i = 1; i < this.passes - 1; i++){
                filterManager.bindAndClear(flip, (0, $0fa4b07f86297abd$export$784901839554cbc3).BLIT), this.uniforms.uSampler = flop;
                const temp = flop;
                flop = flip, flip = temp, renderer.shader.bind(this), renderer.geometry.draw(5);
            }
            this.state.blend = !0, filterManager.applyFilter(this, flop, output, clearMode), filterManager.returnFilterTexture(renderTarget);
        }
    }
    /**
   * Sets the strength of both the blur.
   * @default 16
   */ get blur() {
        return this.strength;
    }
    set blur(value) {
        this.padding = 1 + Math.abs(value) * 2, this.strength = value;
    }
    /**
   * Sets the quality of the blur by modifying the number of passes. More passes means higher
   * quality bluring but the lower the performance.
   * @default 4
   */ get quality() {
        return this._quality;
    }
    set quality(value) {
        this._quality = value, this.passes = value;
    }
}


class $8669a89c307e6d7c$export$424348d09d827f49 extends (0, $46266bc3fe6194b8$export$ec91da630f36d5ea) {
    /**
   * @param strength - The strength of the blur filter.
   * @param quality - The quality of the blur filter.
   * @param {number|null} [resolution=PIXI.Filter.defaultResolution] - The resolution of the blur filter.
   * @param kernelSize - The kernelSize of the blur filter.Options: 5, 7, 9, 11, 13, 15.
   */ constructor(strength = 8, quality = 4, resolution = (0, $46266bc3fe6194b8$export$ec91da630f36d5ea).defaultResolution, kernelSize = 5){
        super(), this._repeatEdgePixels = !1, this.blurXFilter = new (0, $62a86b1a01dbfe3b$export$b100a8e8116621cf)(!0, strength, quality, resolution, kernelSize), this.blurYFilter = new (0, $62a86b1a01dbfe3b$export$b100a8e8116621cf)(!1, strength, quality, resolution, kernelSize), this.resolution = resolution, this.quality = quality, this.blur = strength, this.repeatEdgePixels = !1;
    }
    /**
   * Applies the filter.
   * @param filterManager - The manager.
   * @param input - The input target.
   * @param output - The output target.
   * @param clearMode - How to clear
   */ apply(filterManager, input, output, clearMode) {
        const xStrength = Math.abs(this.blurXFilter.strength), yStrength = Math.abs(this.blurYFilter.strength);
        if (xStrength && yStrength) {
            const renderTarget = filterManager.getFilterTexture();
            this.blurXFilter.apply(filterManager, input, renderTarget, (0, $0fa4b07f86297abd$export$784901839554cbc3).CLEAR), this.blurYFilter.apply(filterManager, renderTarget, output, clearMode), filterManager.returnFilterTexture(renderTarget);
        } else yStrength ? this.blurYFilter.apply(filterManager, input, output, clearMode) : this.blurXFilter.apply(filterManager, input, output, clearMode);
    }
    updatePadding() {
        this._repeatEdgePixels ? this.padding = 0 : this.padding = Math.max(Math.abs(this.blurXFilter.strength), Math.abs(this.blurYFilter.strength)) * 2;
    }
    /**
   * Sets the strength of both the blurX and blurY properties simultaneously
   * @default 2
   */ get blur() {
        return this.blurXFilter.blur;
    }
    set blur(value) {
        this.blurXFilter.blur = this.blurYFilter.blur = value, this.updatePadding();
    }
    /**
   * Sets the number of passes for blur. More passes means higher quality bluring.
   * @default 1
   */ get quality() {
        return this.blurXFilter.quality;
    }
    set quality(value) {
        this.blurXFilter.quality = this.blurYFilter.quality = value;
    }
    /**
   * Sets the strength of the blurX property
   * @default 2
   */ get blurX() {
        return this.blurXFilter.blur;
    }
    set blurX(value) {
        this.blurXFilter.blur = value, this.updatePadding();
    }
    /**
   * Sets the strength of the blurY property
   * @default 2
   */ get blurY() {
        return this.blurYFilter.blur;
    }
    set blurY(value) {
        this.blurYFilter.blur = value, this.updatePadding();
    }
    /**
   * Sets the blendmode of the filter
   * @default PIXI.BLEND_MODES.NORMAL
   */ get blendMode() {
        return this.blurYFilter.blendMode;
    }
    set blendMode(value) {
        this.blurYFilter.blendMode = value;
    }
    /**
   * If set to true the edge of the target will be clamped
   * @default false
   */ get repeatEdgePixels() {
        return this._repeatEdgePixels;
    }
    set repeatEdgePixels(value) {
        this._repeatEdgePixels = value, this.updatePadding();
    }
}






var $aa98d3bcf005e395$export$2e2bcd8739ae039 = `varying vec2 vTextureCoord;
uniform sampler2D uSampler;
uniform float m[20];
uniform float uAlpha;

void main(void)
{
    vec4 c = texture2D(uSampler, vTextureCoord);

    if (uAlpha == 0.0) {
        gl_FragColor = c;
        return;
    }

    // Un-premultiply alpha before applying the color matrix. See issue #3539.
    if (c.a > 0.0) {
      c.rgb /= c.a;
    }

    vec4 result;

    result.r = (m[0] * c.r);
        result.r += (m[1] * c.g);
        result.r += (m[2] * c.b);
        result.r += (m[3] * c.a);
        result.r += m[4];

    result.g = (m[5] * c.r);
        result.g += (m[6] * c.g);
        result.g += (m[7] * c.b);
        result.g += (m[8] * c.a);
        result.g += m[9];

    result.b = (m[10] * c.r);
       result.b += (m[11] * c.g);
       result.b += (m[12] * c.b);
       result.b += (m[13] * c.a);
       result.b += m[14];

    result.a = (m[15] * c.r);
       result.a += (m[16] * c.g);
       result.a += (m[17] * c.b);
       result.a += (m[18] * c.a);
       result.a += m[19];

    vec3 rgb = mix(c.rgb, result.rgb, uAlpha);

    // Premultiply alpha again.
    rgb *= result.a;

    gl_FragColor = vec4(rgb, result.a);
}
`;


class $3c619bef5e4d7ae6$export$6547db23997fcec5 extends (0, $46266bc3fe6194b8$export$ec91da630f36d5ea) {
    constructor(){
        const uniforms = {
            m: new Float32Array([
                1,
                0,
                0,
                0,
                0,
                0,
                1,
                0,
                0,
                0,
                0,
                0,
                1,
                0,
                0,
                0,
                0,
                0,
                1,
                0
            ]),
            uAlpha: 1
        };
        super((0, $cd81e2f0e1d30179$export$198627d10d1d088f), (0, $aa98d3bcf005e395$export$2e2bcd8739ae039), uniforms), this.alpha = 1;
    }
    /**
   * Transforms current matrix and set the new one
   * @param {number[]} matrix - 5x4 matrix
   * @param multiply - if true, current matrix and matrix are multiplied. If false,
   *  just set the current matrix with @param matrix
   */ _loadMatrix(matrix, multiply = !1) {
        let newMatrix = matrix;
        multiply && (this._multiply(newMatrix, this.uniforms.m, matrix), newMatrix = this._colorMatrix(newMatrix)), this.uniforms.m = newMatrix;
    }
    /**
   * Multiplies two mat5's
   * @private
   * @param out - 5x4 matrix the receiving matrix
   * @param a - 5x4 matrix the first operand
   * @param b - 5x4 matrix the second operand
   * @returns {number[]} 5x4 matrix
   */ _multiply(out, a, b) {
        return out[0] = a[0] * b[0] + a[1] * b[5] + a[2] * b[10] + a[3] * b[15], out[1] = a[0] * b[1] + a[1] * b[6] + a[2] * b[11] + a[3] * b[16], out[2] = a[0] * b[2] + a[1] * b[7] + a[2] * b[12] + a[3] * b[17], out[3] = a[0] * b[3] + a[1] * b[8] + a[2] * b[13] + a[3] * b[18], out[4] = a[0] * b[4] + a[1] * b[9] + a[2] * b[14] + a[3] * b[19] + a[4], out[5] = a[5] * b[0] + a[6] * b[5] + a[7] * b[10] + a[8] * b[15], out[6] = a[5] * b[1] + a[6] * b[6] + a[7] * b[11] + a[8] * b[16], out[7] = a[5] * b[2] + a[6] * b[7] + a[7] * b[12] + a[8] * b[17], out[8] = a[5] * b[3] + a[6] * b[8] + a[7] * b[13] + a[8] * b[18], out[9] = a[5] * b[4] + a[6] * b[9] + a[7] * b[14] + a[8] * b[19] + a[9], out[10] = a[10] * b[0] + a[11] * b[5] + a[12] * b[10] + a[13] * b[15], out[11] = a[10] * b[1] + a[11] * b[6] + a[12] * b[11] + a[13] * b[16], out[12] = a[10] * b[2] + a[11] * b[7] + a[12] * b[12] + a[13] * b[17], out[13] = a[10] * b[3] + a[11] * b[8] + a[12] * b[13] + a[13] * b[18], out[14] = a[10] * b[4] + a[11] * b[9] + a[12] * b[14] + a[13] * b[19] + a[14], out[15] = a[15] * b[0] + a[16] * b[5] + a[17] * b[10] + a[18] * b[15], out[16] = a[15] * b[1] + a[16] * b[6] + a[17] * b[11] + a[18] * b[16], out[17] = a[15] * b[2] + a[16] * b[7] + a[17] * b[12] + a[18] * b[17], out[18] = a[15] * b[3] + a[16] * b[8] + a[17] * b[13] + a[18] * b[18], out[19] = a[15] * b[4] + a[16] * b[9] + a[17] * b[14] + a[18] * b[19] + a[19], out;
    }
    /**
   * Create a Float32 Array and normalize the offset component to 0-1
   * @param {number[]} matrix - 5x4 matrix
   * @returns {number[]} 5x4 matrix with all values between 0-1
   */ _colorMatrix(matrix) {
        const m = new Float32Array(matrix);
        return m[4] /= 255, m[9] /= 255, m[14] /= 255, m[19] /= 255, m;
    }
    /**
   * Adjusts brightness
   * @param b - value of the brigthness (0-1, where 0 is black)
   * @param multiply - if true, current matrix and matrix are multiplied. If false,
   *  just set the current matrix with @param matrix
   */ brightness(b, multiply) {
        const matrix = [
            b,
            0,
            0,
            0,
            0,
            0,
            b,
            0,
            0,
            0,
            0,
            0,
            b,
            0,
            0,
            0,
            0,
            0,
            1,
            0
        ];
        this._loadMatrix(matrix, multiply);
    }
    /**
   * Sets each channel on the diagonal of the color matrix.
   * This can be used to achieve a tinting effect on Containers similar to the tint field of some
   * display objects like Sprite, Text, Graphics, and Mesh.
   * @param color - Color of the tint. This is a hex value.
   * @param multiply - if true, current matrix and matrix are multiplied. If false,
   *  just set the current matrix with @param matrix
   */ tint(color, multiply) {
        const [r, g, b] = (0, $15154c33c9e19c5f$export$892596cec99bc70e).shared.setValue(color).toArray(), matrix = [
            r,
            0,
            0,
            0,
            0,
            0,
            g,
            0,
            0,
            0,
            0,
            0,
            b,
            0,
            0,
            0,
            0,
            0,
            1,
            0
        ];
        this._loadMatrix(matrix, multiply);
    }
    /**
   * Set the matrices in grey scales
   * @param scale - value of the grey (0-1, where 0 is black)
   * @param multiply - if true, current matrix and matrix are multiplied. If false,
   *  just set the current matrix with @param matrix
   */ greyscale(scale, multiply) {
        const matrix = [
            scale,
            scale,
            scale,
            0,
            0,
            scale,
            scale,
            scale,
            0,
            0,
            scale,
            scale,
            scale,
            0,
            0,
            0,
            0,
            0,
            1,
            0
        ];
        this._loadMatrix(matrix, multiply);
    }
    /**
   * Set the black and white matrice.
   * @param multiply - if true, current matrix and matrix are multiplied. If false,
   *  just set the current matrix with @param matrix
   */ blackAndWhite(multiply) {
        const matrix = [
            0.3,
            0.6,
            0.1,
            0,
            0,
            0.3,
            0.6,
            0.1,
            0,
            0,
            0.3,
            0.6,
            0.1,
            0,
            0,
            0,
            0,
            0,
            1,
            0
        ];
        this._loadMatrix(matrix, multiply);
    }
    /**
   * Set the hue property of the color
   * @param rotation - in degrees
   * @param multiply - if true, current matrix and matrix are multiplied. If false,
   *  just set the current matrix with @param matrix
   */ hue(rotation, multiply) {
        rotation = (rotation || 0) / 180 * Math.PI;
        const cosR = Math.cos(rotation), sinR = Math.sin(rotation), sqrt = Math.sqrt, w = 1 / 3, sqrW = sqrt(w), a00 = cosR + (1 - cosR) * w, a01 = w * (1 - cosR) - sqrW * sinR, a02 = w * (1 - cosR) + sqrW * sinR, a10 = w * (1 - cosR) + sqrW * sinR, a11 = cosR + w * (1 - cosR), a12 = w * (1 - cosR) - sqrW * sinR, a20 = w * (1 - cosR) - sqrW * sinR, a21 = w * (1 - cosR) + sqrW * sinR, a22 = cosR + w * (1 - cosR), matrix = [
            a00,
            a01,
            a02,
            0,
            0,
            a10,
            a11,
            a12,
            0,
            0,
            a20,
            a21,
            a22,
            0,
            0,
            0,
            0,
            0,
            1,
            0
        ];
        this._loadMatrix(matrix, multiply);
    }
    /**
   * Set the contrast matrix, increase the separation between dark and bright
   * Increase contrast : shadows darker and highlights brighter
   * Decrease contrast : bring the shadows up and the highlights down
   * @param amount - value of the contrast (0-1)
   * @param multiply - if true, current matrix and matrix are multiplied. If false,
   *  just set the current matrix with @param matrix
   */ contrast(amount, multiply) {
        const v = (amount || 0) + 1, o = -0.5 * (v - 1), matrix = [
            v,
            0,
            0,
            0,
            o,
            0,
            v,
            0,
            0,
            o,
            0,
            0,
            v,
            0,
            o,
            0,
            0,
            0,
            1,
            0
        ];
        this._loadMatrix(matrix, multiply);
    }
    /**
   * Set the saturation matrix, increase the separation between colors
   * Increase saturation : increase contrast, brightness, and sharpness
   * @param amount - The saturation amount (0-1)
   * @param multiply - if true, current matrix and matrix are multiplied. If false,
   *  just set the current matrix with @param matrix
   */ saturate(amount = 0, multiply) {
        const x = amount * 2 / 3 + 1, y = (x - 1) * -0.5, matrix = [
            x,
            y,
            y,
            0,
            0,
            y,
            x,
            y,
            0,
            0,
            y,
            y,
            x,
            0,
            0,
            0,
            0,
            0,
            1,
            0
        ];
        this._loadMatrix(matrix, multiply);
    }
    /** Desaturate image (remove color) Call the saturate function */ desaturate() {
        this.saturate(-1);
    }
    /**
   * Negative image (inverse of classic rgb matrix)
   * @param multiply - if true, current matrix and matrix are multiplied. If false,
   *  just set the current matrix with @param matrix
   */ negative(multiply) {
        const matrix = [
            -1,
            0,
            0,
            1,
            0,
            0,
            -1,
            0,
            1,
            0,
            0,
            0,
            -1,
            1,
            0,
            0,
            0,
            0,
            1,
            0
        ];
        this._loadMatrix(matrix, multiply);
    }
    /**
   * Sepia image
   * @param multiply - if true, current matrix and matrix are multiplied. If false,
   *  just set the current matrix with @param matrix
   */ sepia(multiply) {
        const matrix = [
            0.393,
            0.7689999,
            0.18899999,
            0,
            0,
            0.349,
            0.6859999,
            0.16799999,
            0,
            0,
            0.272,
            0.5339999,
            0.13099999,
            0,
            0,
            0,
            0,
            0,
            1,
            0
        ];
        this._loadMatrix(matrix, multiply);
    }
    /**
   * Color motion picture process invented in 1916 (thanks Dominic Szablewski)
   * @param multiply - if true, current matrix and matrix are multiplied. If false,
   *  just set the current matrix with @param matrix
   */ technicolor(multiply) {
        const matrix = [
            1.9125277891456083,
            -0.8545344976951645,
            -0.09155508482755585,
            0,
            11.793603434377337,
            -0.3087833385928097,
            1.7658908555458428,
            -0.10601743074722245,
            0,
            -70.35205161461398,
            -0.231103377548616,
            -0.7501899197440212,
            1.847597816108189,
            0,
            30.950940869491138,
            0,
            0,
            0,
            1,
            0
        ];
        this._loadMatrix(matrix, multiply);
    }
    /**
   * Polaroid filter
   * @param multiply - if true, current matrix and matrix are multiplied. If false,
   *  just set the current matrix with @param matrix
   */ polaroid(multiply) {
        const matrix = [
            1.438,
            -0.062,
            -0.062,
            0,
            0,
            -0.122,
            1.378,
            -0.122,
            0,
            0,
            -0.016,
            -0.016,
            1.483,
            0,
            0,
            0,
            0,
            0,
            1,
            0
        ];
        this._loadMatrix(matrix, multiply);
    }
    /**
   * Filter who transforms : Red -> Blue and Blue -> Red
   * @param multiply - if true, current matrix and matrix are multiplied. If false,
   *  just set the current matrix with @param matrix
   */ toBGR(multiply) {
        const matrix = [
            0,
            0,
            1,
            0,
            0,
            0,
            1,
            0,
            0,
            0,
            1,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            1,
            0
        ];
        this._loadMatrix(matrix, multiply);
    }
    /**
   * Color reversal film introduced by Eastman Kodak in 1935. (thanks Dominic Szablewski)
   * @param multiply - if true, current matrix and matrix are multiplied. If false,
   *  just set the current matrix with @param matrix
   */ kodachrome(multiply) {
        const matrix = [
            1.1285582396593525,
            -0.3967382283601348,
            -0.03992559172921793,
            0,
            63.72958762196502,
            -0.16404339962244616,
            1.0835251566291304,
            -0.05498805115633132,
            0,
            24.732407896706203,
            -0.16786010706155763,
            -0.5603416277695248,
            1.6014850761964943,
            0,
            35.62982807460946,
            0,
            0,
            0,
            1,
            0
        ];
        this._loadMatrix(matrix, multiply);
    }
    /**
   * Brown delicious browni filter (thanks Dominic Szablewski)
   * @param multiply - if true, current matrix and matrix are multiplied. If false,
   *  just set the current matrix with @param matrix
   */ browni(multiply) {
        const matrix = [
            0.5997023498159715,
            0.34553243048391263,
            -0.2708298674538042,
            0,
            47.43192855600873,
            -0.037703249837783157,
            0.8609577587992641,
            0.15059552388459913,
            0,
            -36.96841498319127,
            0.24113635128153335,
            -0.07441037908422492,
            0.44972182064877153,
            0,
            -7.562075277591283,
            0,
            0,
            0,
            1,
            0
        ];
        this._loadMatrix(matrix, multiply);
    }
    /**
   * Vintage filter (thanks Dominic Szablewski)
   * @param multiply - if true, current matrix and matrix are multiplied. If false,
   *  just set the current matrix with @param matrix
   */ vintage(multiply) {
        const matrix = [
            0.6279345635605994,
            0.3202183420819367,
            -0.03965408211312453,
            0,
            9.651285835294123,
            0.02578397704808868,
            0.6441188644374771,
            0.03259127616149294,
            0,
            7.462829176470591,
            0.0466055556782719,
            -0.0851232987247891,
            0.5241648018700465,
            0,
            5.159190588235296,
            0,
            0,
            0,
            1,
            0
        ];
        this._loadMatrix(matrix, multiply);
    }
    /**
   * We don't know exactly what it does, kind of gradient map, but funny to play with!
   * @param desaturation - Tone values.
   * @param toned - Tone values.
   * @param lightColor - Tone values, example: `0xFFE580`
   * @param darkColor - Tone values, example: `0xFFE580`
   * @param multiply - if true, current matrix and matrix are multiplied. If false,
   *  just set the current matrix with @param matrix
   */ colorTone(desaturation, toned, lightColor, darkColor, multiply) {
        desaturation = desaturation || 0.2, toned = toned || 0.15, lightColor = lightColor || 16770432, darkColor = darkColor || 3375104;
        const temp = (0, $15154c33c9e19c5f$export$892596cec99bc70e).shared, [lR, lG, lB] = temp.setValue(lightColor).toArray(), [dR, dG, dB] = temp.setValue(darkColor).toArray(), matrix = [
            0.3,
            0.59,
            0.11,
            0,
            0,
            lR,
            lG,
            lB,
            desaturation,
            0,
            dR,
            dG,
            dB,
            toned,
            0,
            lR - dR,
            lG - dG,
            lB - dB,
            0,
            0
        ];
        this._loadMatrix(matrix, multiply);
    }
    /**
   * Night effect
   * @param intensity - The intensity of the night effect.
   * @param multiply - if true, current matrix and matrix are multiplied. If false,
   *  just set the current matrix with @param matrix
   */ night(intensity, multiply) {
        intensity = intensity || 0.1;
        const matrix = [
            intensity * -2,
            -intensity,
            0,
            0,
            0,
            -intensity,
            0,
            intensity,
            0,
            0,
            0,
            intensity,
            intensity * 2,
            0,
            0,
            0,
            0,
            0,
            1,
            0
        ];
        this._loadMatrix(matrix, multiply);
    }
    /**
   * Predator effect
   *
   * Erase the current matrix by setting a new indepent one
   * @param amount - how much the predator feels his future victim
   * @param multiply - if true, current matrix and matrix are multiplied. If false,
   *  just set the current matrix with @param matrix
   */ predator(amount, multiply) {
        const matrix = [
            // row 1
            11.224130630493164 * amount,
            -4.794486999511719 * amount,
            -2.8746118545532227 * amount,
            0 * amount,
            0.40342438220977783 * amount,
            // row 2
            -3.6330697536468506 * amount,
            9.193157196044922 * amount,
            -2.951810836791992 * amount,
            0 * amount,
            -1.316135048866272 * amount,
            // row 3
            -3.2184197902679443 * amount,
            -4.2375030517578125 * amount,
            7.476448059082031 * amount,
            0 * amount,
            0.8044459223747253 * amount,
            // row 4
            0,
            0,
            0,
            1,
            0
        ];
        this._loadMatrix(matrix, multiply);
    }
    /**
   * LSD effect
   *
   * Multiply the current matrix
   * @param multiply - if true, current matrix and matrix are multiplied. If false,
   *  just set the current matrix with @param matrix
   */ lsd(multiply) {
        const matrix = [
            2,
            -0.4,
            0.5,
            0,
            0,
            -0.5,
            2,
            -0.4,
            0,
            0,
            -0.4,
            -0.5,
            3,
            0,
            0,
            0,
            0,
            0,
            1,
            0
        ];
        this._loadMatrix(matrix, multiply);
    }
    /** Erase the current matrix by setting the default one. */ reset() {
        const matrix = [
            1,
            0,
            0,
            0,
            0,
            0,
            1,
            0,
            0,
            0,
            0,
            0,
            1,
            0,
            0,
            0,
            0,
            0,
            1,
            0
        ];
        this._loadMatrix(matrix, !1);
    }
    /**
   * The matrix of the color matrix filter
   * @member {number[]}
   * @default [1, 0, 0, 0, 0, 0, 1, 0, 0, 0, 0, 0, 1, 0, 0, 0, 0, 0, 1, 0]
   */ get matrix() {
        return this.uniforms.m;
    }
    set matrix(value) {
        this.uniforms.m = value;
    }
    /**
   * The opacity value to use when mixing the original and resultant colors.
   *
   * When the value is 0, the original color is used without modification.
   * When the value is 1, the result color is used.
   * When in the range (0, 1) the color is interpolated between the original and result by this amount.
   * @default 1
   */ get alpha() {
        return this.uniforms.uAlpha;
    }
    set alpha(value) {
        this.uniforms.uAlpha = value;
    }
}
$3c619bef5e4d7ae6$export$6547db23997fcec5.prototype.grayscale = $3c619bef5e4d7ae6$export$6547db23997fcec5.prototype.greyscale;





var $5b61c210c17cecaf$export$2e2bcd8739ae039 = `varying vec2 vFilterCoord;
varying vec2 vTextureCoord;

uniform vec2 scale;
uniform mat2 rotation;
uniform sampler2D uSampler;
uniform sampler2D mapSampler;

uniform highp vec4 inputSize;
uniform vec4 inputClamp;

void main(void)
{
  vec4 map =  texture2D(mapSampler, vFilterCoord);

  map -= 0.5;
  map.xy = scale * inputSize.zw * (rotation * map.xy);

  gl_FragColor = texture2D(uSampler, clamp(vec2(vTextureCoord.x + map.x, vTextureCoord.y + map.y), inputClamp.xy, inputClamp.zw));
}
`;


var $1699d6c99d37b8fb$export$2e2bcd8739ae039 = `attribute vec2 aVertexPosition;

uniform mat3 projectionMatrix;
uniform mat3 filterMatrix;

varying vec2 vTextureCoord;
varying vec2 vFilterCoord;

uniform vec4 inputSize;
uniform vec4 outputFrame;

vec4 filterVertexPosition( void )
{
    vec2 position = aVertexPosition * max(outputFrame.zw, vec2(0.)) + outputFrame.xy;

    return vec4((projectionMatrix * vec3(position, 1.0)).xy, 0.0, 1.0);
}

vec2 filterTextureCoord( void )
{
    return aVertexPosition * (outputFrame.zw * inputSize.zw);
}

void main(void)
{
	gl_Position = filterVertexPosition();
	vTextureCoord = filterTextureCoord();
	vFilterCoord = ( filterMatrix * vec3( vTextureCoord, 1.0)  ).xy;
}
`;


class $814bffbda74da0e4$export$8ebf3229158e2895 extends (0, $46266bc3fe6194b8$export$ec91da630f36d5ea) {
    /**
   * @param {PIXI.Sprite} sprite - The sprite used for the displacement map. (make sure its added to the scene!)
   * @param scale - The scale of the displacement
   */ constructor(sprite, scale){
        const maskMatrix = new (0, $d7da222aa639cde0$export$5b12bf1653c0dd85)();
        sprite.renderable = !1, super((0, $1699d6c99d37b8fb$export$2e2bcd8739ae039), (0, $5b61c210c17cecaf$export$2e2bcd8739ae039), {
            mapSampler: sprite._texture,
            filterMatrix: maskMatrix,
            scale: {
                x: 1,
                y: 1
            },
            rotation: new Float32Array([
                1,
                0,
                0,
                1
            ])
        }), this.maskSprite = sprite, this.maskMatrix = maskMatrix, scale == null && (scale = 20), this.scale = new (0, $cf3018b4309864c2$export$baf26146a414f24a)(scale, scale);
    }
    /**
   * Applies the filter.
   * @param filterManager - The manager.
   * @param input - The input target.
   * @param output - The output target.
   * @param clearMode - clearMode.
   */ apply(filterManager, input, output, clearMode) {
        this.uniforms.filterMatrix = filterManager.calculateSpriteMatrix(this.maskMatrix, this.maskSprite), this.uniforms.scale.x = this.scale.x, this.uniforms.scale.y = this.scale.y;
        const wt = this.maskSprite.worldTransform, lenX = Math.sqrt(wt.a * wt.a + wt.b * wt.b), lenY = Math.sqrt(wt.c * wt.c + wt.d * wt.d);
        lenX !== 0 && lenY !== 0 && (this.uniforms.rotation[0] = wt.a / lenX, this.uniforms.rotation[1] = wt.b / lenX, this.uniforms.rotation[2] = wt.c / lenY, this.uniforms.rotation[3] = wt.d / lenY), filterManager.applyFilter(this, input, output, clearMode);
    }
    /** The texture used for the displacement map. Must be power of 2 sized texture. */ get map() {
        return this.uniforms.mapSampler;
    }
    set map(value) {
        this.uniforms.mapSampler = value;
    }
}





var $4d2947d19a238bce$export$2e2bcd8739ae039 = `varying vec2 v_rgbNW;
varying vec2 v_rgbNE;
varying vec2 v_rgbSW;
varying vec2 v_rgbSE;
varying vec2 v_rgbM;

varying vec2 vFragCoord;
uniform sampler2D uSampler;
uniform highp vec4 inputSize;


/**
 Basic FXAA implementation based on the code on geeks3d.com with the
 modification that the texture2DLod stuff was removed since it's
 unsupported by WebGL.

 --

 From:
 https://github.com/mitsuhiko/webgl-meincraft

 Copyright (c) 2011 by Armin Ronacher.

 Some rights reserved.

 Redistribution and use in source and binary forms, with or without
 modification, are permitted provided that the following conditions are
 met:

 * Redistributions of source code must retain the above copyright
 notice, this list of conditions and the following disclaimer.

 * Redistributions in binary form must reproduce the above
 copyright notice, this list of conditions and the following
 disclaimer in the documentation and/or other materials provided
 with the distribution.

 * The names of the contributors may not be used to endorse or
 promote products derived from this software without specific
 prior written permission.

 THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS
 "AS IS" AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT
 LIMITED TO, THE IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR
 A PARTICULAR PURPOSE ARE DISCLAIMED. IN NO EVENT SHALL THE COPYRIGHT
 OWNER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL,
 SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT
 LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE,
 DATA, OR PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY
 THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT
 (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE
 OF THIS SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
 */

#ifndef FXAA_REDUCE_MIN
#define FXAA_REDUCE_MIN   (1.0/ 128.0)
#endif
#ifndef FXAA_REDUCE_MUL
#define FXAA_REDUCE_MUL   (1.0 / 8.0)
#endif
#ifndef FXAA_SPAN_MAX
#define FXAA_SPAN_MAX     8.0
#endif

//optimized version for mobile, where dependent
//texture reads can be a bottleneck
vec4 fxaa(sampler2D tex, vec2 fragCoord, vec2 inverseVP,
          vec2 v_rgbNW, vec2 v_rgbNE,
          vec2 v_rgbSW, vec2 v_rgbSE,
          vec2 v_rgbM) {
    vec4 color;
    vec3 rgbNW = texture2D(tex, v_rgbNW).xyz;
    vec3 rgbNE = texture2D(tex, v_rgbNE).xyz;
    vec3 rgbSW = texture2D(tex, v_rgbSW).xyz;
    vec3 rgbSE = texture2D(tex, v_rgbSE).xyz;
    vec4 texColor = texture2D(tex, v_rgbM);
    vec3 rgbM  = texColor.xyz;
    vec3 luma = vec3(0.299, 0.587, 0.114);
    float lumaNW = dot(rgbNW, luma);
    float lumaNE = dot(rgbNE, luma);
    float lumaSW = dot(rgbSW, luma);
    float lumaSE = dot(rgbSE, luma);
    float lumaM  = dot(rgbM,  luma);
    float lumaMin = min(lumaM, min(min(lumaNW, lumaNE), min(lumaSW, lumaSE)));
    float lumaMax = max(lumaM, max(max(lumaNW, lumaNE), max(lumaSW, lumaSE)));

    mediump vec2 dir;
    dir.x = -((lumaNW + lumaNE) - (lumaSW + lumaSE));
    dir.y =  ((lumaNW + lumaSW) - (lumaNE + lumaSE));

    float dirReduce = max((lumaNW + lumaNE + lumaSW + lumaSE) *
                          (0.25 * FXAA_REDUCE_MUL), FXAA_REDUCE_MIN);

    float rcpDirMin = 1.0 / (min(abs(dir.x), abs(dir.y)) + dirReduce);
    dir = min(vec2(FXAA_SPAN_MAX, FXAA_SPAN_MAX),
              max(vec2(-FXAA_SPAN_MAX, -FXAA_SPAN_MAX),
                  dir * rcpDirMin)) * inverseVP;

    vec3 rgbA = 0.5 * (
                       texture2D(tex, fragCoord * inverseVP + dir * (1.0 / 3.0 - 0.5)).xyz +
                       texture2D(tex, fragCoord * inverseVP + dir * (2.0 / 3.0 - 0.5)).xyz);
    vec3 rgbB = rgbA * 0.5 + 0.25 * (
                                     texture2D(tex, fragCoord * inverseVP + dir * -0.5).xyz +
                                     texture2D(tex, fragCoord * inverseVP + dir * 0.5).xyz);

    float lumaB = dot(rgbB, luma);
    if ((lumaB < lumaMin) || (lumaB > lumaMax))
        color = vec4(rgbA, texColor.a);
    else
        color = vec4(rgbB, texColor.a);
    return color;
}

void main() {

      vec4 color;

      color = fxaa(uSampler, vFragCoord, inputSize.zw, v_rgbNW, v_rgbNE, v_rgbSW, v_rgbSE, v_rgbM);

      gl_FragColor = color;
}
`;


var $12fe928be3bd8cdb$export$2e2bcd8739ae039 = `
attribute vec2 aVertexPosition;

uniform mat3 projectionMatrix;

varying vec2 v_rgbNW;
varying vec2 v_rgbNE;
varying vec2 v_rgbSW;
varying vec2 v_rgbSE;
varying vec2 v_rgbM;

varying vec2 vFragCoord;

uniform vec4 inputSize;
uniform vec4 outputFrame;

vec4 filterVertexPosition( void )
{
    vec2 position = aVertexPosition * max(outputFrame.zw, vec2(0.)) + outputFrame.xy;

    return vec4((projectionMatrix * vec3(position, 1.0)).xy, 0.0, 1.0);
}

void texcoords(vec2 fragCoord, vec2 inverseVP,
               out vec2 v_rgbNW, out vec2 v_rgbNE,
               out vec2 v_rgbSW, out vec2 v_rgbSE,
               out vec2 v_rgbM) {
    v_rgbNW = (fragCoord + vec2(-1.0, -1.0)) * inverseVP;
    v_rgbNE = (fragCoord + vec2(1.0, -1.0)) * inverseVP;
    v_rgbSW = (fragCoord + vec2(-1.0, 1.0)) * inverseVP;
    v_rgbSE = (fragCoord + vec2(1.0, 1.0)) * inverseVP;
    v_rgbM = vec2(fragCoord * inverseVP);
}

void main(void) {

   gl_Position = filterVertexPosition();

   vFragCoord = aVertexPosition * outputFrame.zw;

   texcoords(vFragCoord, inputSize.zw, v_rgbNW, v_rgbNE, v_rgbSW, v_rgbSE, v_rgbM);
}
`;


class $daafbc72d978913c$export$86086ddb5389b795 extends (0, $46266bc3fe6194b8$export$ec91da630f36d5ea) {
    constructor(){
        super((0, $12fe928be3bd8cdb$export$2e2bcd8739ae039), (0, $4d2947d19a238bce$export$2e2bcd8739ae039));
    }
}





var $2b911d49d25f2f31$export$2e2bcd8739ae039 = `precision highp float;

varying vec2 vTextureCoord;
varying vec4 vColor;

uniform float uNoise;
uniform float uSeed;
uniform sampler2D uSampler;

float rand(vec2 co)
{
    return fract(sin(dot(co.xy, vec2(12.9898, 78.233))) * 43758.5453);
}

void main()
{
    vec4 color = texture2D(uSampler, vTextureCoord);
    float randomValue = rand(gl_FragCoord.xy * uSeed);
    float diff = (randomValue - 0.5) * uNoise;

    // Un-premultiply alpha before applying the color matrix. See issue #3539.
    if (color.a > 0.0) {
        color.rgb /= color.a;
    }

    color.r += diff;
    color.g += diff;
    color.b += diff;

    // Premultiply alpha again.
    color.rgb *= color.a;

    gl_FragColor = color;
}
`;


class $d544e3d7663ce166$export$2d7a5b72233a5183 extends (0, $46266bc3fe6194b8$export$ec91da630f36d5ea) {
    /**
   * @param {number} [noise=0.5] - The noise intensity, should be a normalized value in the range [0, 1].
   * @param {number} [seed] - A random seed for the noise generation. Default is `Math.random()`.
   */ constructor(noise = 0.5, seed = Math.random()){
        super((0, $cd81e2f0e1d30179$export$198627d10d1d088f), (0, $2b911d49d25f2f31$export$2e2bcd8739ae039), {
            uNoise: 0,
            uSeed: 0
        }), this.noise = noise, this.seed = seed;
    }
    /**
   * The amount of noise to apply, this value should be in the range (0, 1].
   * @default 0.5
   */ get noise() {
        return this.uniforms.uNoise;
    }
    set noise(value) {
        this.uniforms.uNoise = value;
    }
    /** A seed value to apply to the random noise generation. `Math.random()` is a good value to use. */ get seed() {
        return this.uniforms.uSeed;
    }
    set seed(value) {
        this.uniforms.uSeed = value;
    }
}




const $f51db16734035d18$export$82462a21aead86ed = {
    AlphaFilter: /**
   * @class
   * @memberof PIXI.filters
   * @deprecated since 7.1.0
   * @see PIXI.AlphaFilter
   */ $185693a8f7b67b9f$export$adbaa0de008b0d7a,
    BlurFilter: /**
   * @class
   * @memberof PIXI.filters
   * @deprecated since 7.1.0
   * @see PIXI.BlurFilter
   */ $8669a89c307e6d7c$export$424348d09d827f49,
    BlurFilterPass: /**
   * @class
   * @memberof PIXI.filters
   * @deprecated since 7.1.0
   * @see PIXI.BlurFilterPass
   */ $62a86b1a01dbfe3b$export$b100a8e8116621cf,
    ColorMatrixFilter: /**
   * @class
   * @memberof PIXI.filters
   * @deprecated since 7.1.0
   * @see PIXI.ColorMatrixFilter
   */ $3c619bef5e4d7ae6$export$6547db23997fcec5,
    DisplacementFilter: /**
   * @class
   * @memberof PIXI.filters
   * @deprecated since 7.1.0
   * @see PIXI.DisplacementFilter
   */ $814bffbda74da0e4$export$8ebf3229158e2895,
    FXAAFilter: /**
   * @class
   * @memberof PIXI.filters
   * @deprecated since 7.1.0
   * @see PIXI.FXAAFilter
   */ $daafbc72d978913c$export$86086ddb5389b795,
    NoiseFilter: /**
   * @class
   * @memberof PIXI.filters
   * @deprecated since 7.1.0
   * @see PIXI.NoiseFilter
   */ $d544e3d7663ce166$export$2d7a5b72233a5183
};
Object.entries($f51db16734035d18$export$82462a21aead86ed).forEach(([key, FilterClass])=>{
    Object.defineProperty($f51db16734035d18$export$82462a21aead86ed, key, {
        get () {
            return (0, $db31fc3dfae4939b$exports).deprecation("7.1.0", `filters.${key} has moved to ${key}`), FilterClass;
        }
    });
});






class $b87dcaf20591be16$var$EventsTickerClass {
    constructor(){
        this.interactionFrequency = 10, this._deltaTime = 0, this._didMove = !1, this.tickerAdded = !1, this._pauseUpdate = !0;
    }
    /**
   * Initializes the event ticker.
   * @param events - The event system.
   */ init(events) {
        this.removeTickerListener(), this.events = events, this.interactionFrequency = 10, this._deltaTime = 0, this._didMove = !1, this.tickerAdded = !1, this._pauseUpdate = !0;
    }
    /** Whether to pause the update checks or not. */ get pauseUpdate() {
        return this._pauseUpdate;
    }
    set pauseUpdate(paused) {
        this._pauseUpdate = paused;
    }
    /** Adds the ticker listener. */ addTickerListener() {
        this.tickerAdded || !this.domElement || ((0, $e6b36730368844b1$export$39c54bcc89dcee11).system.add(this.tickerUpdate, this, (0, $6098ce82519589af$export$688aaf132ba9b379).INTERACTION), this.tickerAdded = !0);
    }
    /** Removes the ticker listener. */ removeTickerListener() {
        this.tickerAdded && ((0, $e6b36730368844b1$export$39c54bcc89dcee11).system.remove(this.tickerUpdate, this), this.tickerAdded = !1);
    }
    /** Sets flag to not fire extra events when the user has already moved there mouse */ pointerMoved() {
        this._didMove = !0;
    }
    /** Updates the state of interactive objects. */ update() {
        if (!this.domElement || this._pauseUpdate) return;
        if (this._didMove) {
            this._didMove = !1;
            return;
        }
        const rootPointerEvent = this.events.rootPointerEvent;
        this.events.supportsTouchEvents && rootPointerEvent.pointerType === "touch" || globalThis.document.dispatchEvent(new PointerEvent("pointermove", {
            clientX: rootPointerEvent.clientX,
            clientY: rootPointerEvent.clientY
        }));
    }
    /**
   * Updates the state of interactive objects if at least {@link interactionFrequency}
   * milliseconds have passed since the last invocation.
   *
   * Invoked by a throttled ticker update from {@link PIXI.Ticker.system}.
   * @param deltaTime - time delta since the last call
   */ tickerUpdate(deltaTime) {
        this._deltaTime += deltaTime, !(this._deltaTime < this.interactionFrequency) && (this._deltaTime = 0, this.update());
    }
}
const $b87dcaf20591be16$export$57a493ed609e53ea = new $b87dcaf20591be16$var$EventsTickerClass();




class $9fcd20bd50e66930$export$5d10db92bb959d8a {
    /**
   * @param manager - The event boundary which manages this event. Propagation can only occur
   *  within the boundary's jurisdiction.
   */ constructor(manager){
        this.bubbles = !0, this.cancelBubble = !0, this.cancelable = !1, this.composed = !1, this.defaultPrevented = !1, this.eventPhase = $9fcd20bd50e66930$export$5d10db92bb959d8a.prototype.NONE, this.propagationStopped = !1, this.propagationImmediatelyStopped = !1, this.layer = new (0, $cf3018b4309864c2$export$baf26146a414f24a)(), this.page = new (0, $cf3018b4309864c2$export$baf26146a414f24a)(), this.NONE = 0, this.CAPTURING_PHASE = 1, this.AT_TARGET = 2, this.BUBBLING_PHASE = 3, this.manager = manager;
    }
    /** @readonly */ get layerX() {
        return this.layer.x;
    }
    /** @readonly */ get layerY() {
        return this.layer.y;
    }
    /** @readonly */ get pageX() {
        return this.page.x;
    }
    /** @readonly */ get pageY() {
        return this.page.y;
    }
    /**
   * Fallback for the deprecated @code{PIXI.InteractionEvent.data}.
   * @deprecated since 7.0.0
   */ get data() {
        return this;
    }
    /** The propagation path for this event. Alias for {@link PIXI.EventBoundary.propagationPath}. */ composedPath() {
        return this.manager && (!this.path || this.path[this.path.length - 1] !== this.target) && (this.path = this.target ? this.manager.propagationPath(this.target) : []), this.path;
    }
    /**
   * Unimplemented method included for implementing the DOM interface {@code Event}. It will throw an {@code Error}.
   * @deprecated
   * @param _type
   * @param _bubbles
   * @param _cancelable
   */ initEvent(_type, _bubbles, _cancelable) {
        throw new Error("initEvent() is a legacy DOM API. It is not implemented in the Federated Events API.");
    }
    /**
   * Unimplemented method included for implementing the DOM interface {@code UIEvent}. It will throw an {@code Error}.
   * @deprecated
   * @param _typeArg
   * @param _bubblesArg
   * @param _cancelableArg
   * @param _viewArg
   * @param _detailArg
   */ initUIEvent(_typeArg, _bubblesArg, _cancelableArg, _viewArg, _detailArg) {
        throw new Error("initUIEvent() is a legacy DOM API. It is not implemented in the Federated Events API.");
    }
    /** Prevent default behavior of PixiJS and the user agent. */ preventDefault() {
        this.nativeEvent instanceof Event && this.nativeEvent.cancelable && this.nativeEvent.preventDefault(), this.defaultPrevented = !0;
    }
    /**
   * Stop this event from propagating to any addition listeners, including on the
   * {@link PIXI.FederatedEventTarget.currentTarget currentTarget} and also the following
   * event targets on the propagation path.
   */ stopImmediatePropagation() {
        this.propagationImmediatelyStopped = !0;
    }
    /**
   * Stop this event from propagating to the next {@link PIXI.FederatedEventTarget}. The rest of the listeners
   * on the {@link PIXI.FederatedEventTarget.currentTarget currentTarget} will still be notified.
   */ stopPropagation() {
        this.propagationStopped = !0;
    }
}


class $78dff7d12b7eab6d$export$aeb79caab92d155a extends (0, $9fcd20bd50e66930$export$5d10db92bb959d8a) {
    constructor(){
        super(...arguments), this.client = new (0, $cf3018b4309864c2$export$baf26146a414f24a)(), this.movement = new (0, $cf3018b4309864c2$export$baf26146a414f24a)(), this.offset = new (0, $cf3018b4309864c2$export$baf26146a414f24a)(), this.global = new (0, $cf3018b4309864c2$export$baf26146a414f24a)(), this.screen = new (0, $cf3018b4309864c2$export$baf26146a414f24a)();
    }
    /** @readonly */ get clientX() {
        return this.client.x;
    }
    /** @readonly */ get clientY() {
        return this.client.y;
    }
    /**
   * Alias for {@link PIXI.FederatedMouseEvent.clientX this.clientX}.
   * @readonly
   */ get x() {
        return this.clientX;
    }
    /**
   * Alias for {@link PIXI.FederatedMouseEvent.clientY this.clientY}.
   * @readonly
   */ get y() {
        return this.clientY;
    }
    /** @readonly */ get movementX() {
        return this.movement.x;
    }
    /** @readonly */ get movementY() {
        return this.movement.y;
    }
    /** @readonly */ get offsetX() {
        return this.offset.x;
    }
    /** @readonly */ get offsetY() {
        return this.offset.y;
    }
    /** @readonly */ get globalX() {
        return this.global.x;
    }
    /** @readonly */ get globalY() {
        return this.global.y;
    }
    /**
   * The pointer coordinates in the renderer's screen. Alias for {@code screen.x}.
   * @readonly
   */ get screenX() {
        return this.screen.x;
    }
    /**
   * The pointer coordinates in the renderer's screen. Alias for {@code screen.y}.
   * @readonly
   */ get screenY() {
        return this.screen.y;
    }
    /**
   * This will return the local coordinates of the specified displayObject for this InteractionData
   * @param {PIXI.DisplayObject} displayObject - The DisplayObject that you would like the local
   *  coords off
   * @param {PIXI.IPointData} point - A Point object in which to store the value, optional (otherwise
   *  will create a new point)
   * @param {PIXI.IPointData} globalPos - A Point object containing your custom global coords, optional
   *  (otherwise will use the current global coords)
   * @returns - A point containing the coordinates of the InteractionData position relative
   *  to the DisplayObject
   */ getLocalPosition(displayObject, point, globalPos) {
        return displayObject.worldTransform.applyInverse(globalPos || this.global, point);
    }
    /**
   * Whether the modifier key was pressed when this event natively occurred.
   * @param key - The modifier key.
   */ getModifierState(key) {
        return "getModifierState" in this.nativeEvent && this.nativeEvent.getModifierState(key);
    }
    /**
   * Not supported.
   * @param _typeArg
   * @param _canBubbleArg
   * @param _cancelableArg
   * @param _viewArg
   * @param _detailArg
   * @param _screenXArg
   * @param _screenYArg
   * @param _clientXArg
   * @param _clientYArg
   * @param _ctrlKeyArg
   * @param _altKeyArg
   * @param _shiftKeyArg
   * @param _metaKeyArg
   * @param _buttonArg
   * @param _relatedTargetArg
   * @deprecated since 7.0.0
   */ // eslint-disable-next-line max-params
    initMouseEvent(_typeArg, _canBubbleArg, _cancelableArg, _viewArg, _detailArg, _screenXArg, _screenYArg, _clientXArg, _clientYArg, _ctrlKeyArg, _altKeyArg, _shiftKeyArg, _metaKeyArg, _buttonArg, _relatedTargetArg) {
        throw new Error("Method not implemented.");
    }
}



class $257a72d091e53320$export$44ac16aa0ab81db6 extends (0, $78dff7d12b7eab6d$export$aeb79caab92d155a) {
    constructor(){
        super(...arguments), this.width = 0, this.height = 0, this.isPrimary = !1;
    }
    // Only included for completeness for now
    getCoalescedEvents() {
        return this.type === "pointermove" || this.type === "mousemove" || this.type === "touchmove" ? [
            this
        ] : [];
    }
    // Only included for completeness for now
    getPredictedEvents() {
        throw new Error("getPredictedEvents is not supported!");
    }
}



class $2bd74162fbb6f53f$export$1fd8b94eb532974d extends (0, $78dff7d12b7eab6d$export$aeb79caab92d155a) {
    constructor(){
        super(...arguments), this.DOM_DELTA_PIXEL = 0, this.DOM_DELTA_LINE = 1, this.DOM_DELTA_PAGE = 2;
    }
}
$2bd74162fbb6f53f$export$1fd8b94eb532974d.DOM_DELTA_PIXEL = 0, /** Units specified in lines. */ $2bd74162fbb6f53f$export$1fd8b94eb532974d.DOM_DELTA_LINE = 1, /** Units specified in pages. */ $2bd74162fbb6f53f$export$1fd8b94eb532974d.DOM_DELTA_PAGE = 2;


const $ed3feb9d7d584957$var$PROPAGATION_LIMIT = 2048, $ed3feb9d7d584957$var$tempHitLocation = new (0, $cf3018b4309864c2$export$baf26146a414f24a)(), $ed3feb9d7d584957$var$tempLocalMapping = new (0, $cf3018b4309864c2$export$baf26146a414f24a)();
class $ed3feb9d7d584957$export$532e8c243078d2cd {
    /**
   * @param rootTarget - The holder of the event boundary.
   */ constructor(rootTarget){
        this.dispatch = new (0, $db31fc3dfae4939b$exports).EventEmitter(), this.moveOnAll = !1, this.enableGlobalMoveEvents = !0, this.mappingState = {
            trackingData: {}
        }, this.eventPool = /* @__PURE__ */ new Map(), this._allInteractiveElements = [], this._hitElements = [], this._isPointerMoveEvent = !1, this.rootTarget = rootTarget, this.hitPruneFn = this.hitPruneFn.bind(this), this.hitTestFn = this.hitTestFn.bind(this), this.mapPointerDown = this.mapPointerDown.bind(this), this.mapPointerMove = this.mapPointerMove.bind(this), this.mapPointerOut = this.mapPointerOut.bind(this), this.mapPointerOver = this.mapPointerOver.bind(this), this.mapPointerUp = this.mapPointerUp.bind(this), this.mapPointerUpOutside = this.mapPointerUpOutside.bind(this), this.mapWheel = this.mapWheel.bind(this), this.mappingTable = {}, this.addEventMapping("pointerdown", this.mapPointerDown), this.addEventMapping("pointermove", this.mapPointerMove), this.addEventMapping("pointerout", this.mapPointerOut), this.addEventMapping("pointerleave", this.mapPointerOut), this.addEventMapping("pointerover", this.mapPointerOver), this.addEventMapping("pointerup", this.mapPointerUp), this.addEventMapping("pointerupoutside", this.mapPointerUpOutside), this.addEventMapping("wheel", this.mapWheel);
    }
    /**
   * Adds an event mapping for the event `type` handled by `fn`.
   *
   * Event mappings can be used to implement additional or custom events. They take an event
   * coming from the upstream scene (or directly from the {@link PIXI.EventSystem}) and dispatch new downstream events
   * generally trickling down and bubbling up to {@link PIXI.EventBoundary.rootTarget this.rootTarget}.
   *
   * To modify the semantics of existing events, the built-in mapping methods of EventBoundary should be overridden
   * instead.
   * @param type - The type of upstream event to map.
   * @param fn - The mapping method. The context of this function must be bound manually, if desired.
   */ addEventMapping(type, fn) {
        this.mappingTable[type] || (this.mappingTable[type] = []), this.mappingTable[type].push({
            fn: fn,
            priority: 0
        }), this.mappingTable[type].sort((a, b)=>a.priority - b.priority);
    }
    /**
   * Dispatches the given event
   * @param e
   * @param type
   */ dispatchEvent(e, type) {
        e.propagationStopped = !1, e.propagationImmediatelyStopped = !1, this.propagate(e, type), this.dispatch.emit(type || e.type, e);
    }
    /**
   * Maps the given upstream event through the event boundary and propagates it downstream.
   * @param e
   */ mapEvent(e) {
        if (!this.rootTarget) return;
        const mappers = this.mappingTable[e.type];
        if (mappers) for(let i = 0, j = mappers.length; i < j; i++)mappers[i].fn(e);
        else console.warn(`[EventBoundary]: Event mapping not defined for ${e.type}`);
    }
    /**
   * Finds the DisplayObject that is the target of a event at the given coordinates.
   *
   * The passed (x,y) coordinates are in the world space above this event boundary.
   * @param x
   * @param y
   */ hitTest(x, y) {
        (0, $b87dcaf20591be16$export$57a493ed609e53ea).pauseUpdate = !0;
        const fn = this._isPointerMoveEvent && this.enableGlobalMoveEvents ? "hitTestMoveRecursive" : "hitTestRecursive", invertedPath = this[fn](this.rootTarget, this.rootTarget.eventMode, $ed3feb9d7d584957$var$tempHitLocation.set(x, y), this.hitTestFn, this.hitPruneFn);
        return invertedPath && invertedPath[0];
    }
    /**
   * Propagate the passed event from from {@link PIXI.EventBoundary.rootTarget this.rootTarget} to its
   * target {@code e.target}.
   * @param e - The event to propagate.
   * @param type
   */ propagate(e, type) {
        if (!e.target) return;
        const composedPath = e.composedPath();
        e.eventPhase = e.CAPTURING_PHASE;
        for(let i = 0, j = composedPath.length - 1; i < j; i++)if (e.currentTarget = composedPath[i], this.notifyTarget(e, type), e.propagationStopped || e.propagationImmediatelyStopped) return;
        if (e.eventPhase = e.AT_TARGET, e.currentTarget = e.target, this.notifyTarget(e, type), !(e.propagationStopped || e.propagationImmediatelyStopped)) {
            e.eventPhase = e.BUBBLING_PHASE;
            for(let i = composedPath.length - 2; i >= 0; i--)if (e.currentTarget = composedPath[i], this.notifyTarget(e, type), e.propagationStopped || e.propagationImmediatelyStopped) return;
        }
    }
    /**
   * Emits the event {@code e} to all interactive display objects. The event is propagated in the bubbling phase always.
   *
   * This is used in the `globalpointermove` event.
   * @param e - The emitted event.
   * @param type - The listeners to notify.
   * @param targets - The targets to notify.
   */ all(e, type, targets = this._allInteractiveElements) {
        if (targets.length === 0) return;
        e.eventPhase = e.BUBBLING_PHASE;
        const events = Array.isArray(type) ? type : [
            type
        ];
        for(let i = targets.length - 1; i >= 0; i--)events.forEach((event)=>{
            e.currentTarget = targets[i], this.notifyTarget(e, event);
        });
    }
    /**
   * Finds the propagation path from {@link PIXI.EventBoundary.rootTarget rootTarget} to the passed
   * {@code target}. The last element in the path is {@code target}.
   * @param target
   */ propagationPath(target) {
        const propagationPath = [
            target
        ];
        for(let i = 0; i < $ed3feb9d7d584957$var$PROPAGATION_LIMIT && target !== this.rootTarget; i++){
            if (!target.parent) throw new Error("Cannot find propagation path to disconnected target");
            propagationPath.push(target.parent), target = target.parent;
        }
        return propagationPath.reverse(), propagationPath;
    }
    hitTestMoveRecursive(currentTarget, eventMode, location, testFn, pruneFn, ignore = !1) {
        let shouldReturn = !1;
        if (this._interactivePrune(currentTarget)) return null;
        if ((currentTarget.eventMode === "dynamic" || eventMode === "dynamic") && ((0, $b87dcaf20591be16$export$57a493ed609e53ea).pauseUpdate = !1), currentTarget.interactiveChildren && currentTarget.children) {
            const children = currentTarget.children;
            for(let i = children.length - 1; i >= 0; i--){
                const child = children[i], nestedHit = this.hitTestMoveRecursive(child, this._isInteractive(eventMode) ? eventMode : child.eventMode, location, testFn, pruneFn, ignore || pruneFn(currentTarget, location));
                if (nestedHit) {
                    if (nestedHit.length > 0 && !nestedHit[nestedHit.length - 1].parent) continue;
                    const isInteractive = currentTarget.isInteractive();
                    (nestedHit.length > 0 || isInteractive) && (isInteractive && this._allInteractiveElements.push(currentTarget), nestedHit.push(currentTarget)), this._hitElements.length === 0 && (this._hitElements = nestedHit), shouldReturn = !0;
                }
            }
        }
        const isInteractiveMode = this._isInteractive(eventMode), isInteractiveTarget = currentTarget.isInteractive();
        return isInteractiveTarget && isInteractiveTarget && this._allInteractiveElements.push(currentTarget), ignore || this._hitElements.length > 0 ? null : shouldReturn ? this._hitElements : isInteractiveMode && !pruneFn(currentTarget, location) && testFn(currentTarget, location) ? isInteractiveTarget ? [
            currentTarget
        ] : [] : null;
    }
    /**
   * Recursive implementation for {@link PIXI.EventBoundary.hitTest hitTest}.
   * @param currentTarget - The DisplayObject that is to be hit tested.
   * @param eventMode - The event mode for the `currentTarget` or one of its parents.
   * @param location - The location that is being tested for overlap.
   * @param testFn - Callback that determines whether the target passes hit testing. This callback
   *  can assume that `pruneFn` failed to prune the display object.
   * @param pruneFn - Callback that determiness whether the target and all of its children
   *  cannot pass the hit test. It is used as a preliminary optimization to prune entire subtrees
   *  of the scene graph.
   * @returns An array holding the hit testing target and all its ancestors in order. The first element
   *  is the target itself and the last is {@link PIXI.EventBoundary.rootTarget rootTarget}. This is the opposite
   *  order w.r.t. the propagation path. If no hit testing target is found, null is returned.
   */ hitTestRecursive(currentTarget, eventMode, location, testFn, pruneFn) {
        if (this._interactivePrune(currentTarget) || pruneFn(currentTarget, location)) return null;
        if ((currentTarget.eventMode === "dynamic" || eventMode === "dynamic") && ((0, $b87dcaf20591be16$export$57a493ed609e53ea).pauseUpdate = !1), currentTarget.interactiveChildren && currentTarget.children) {
            const children = currentTarget.children;
            for(let i = children.length - 1; i >= 0; i--){
                const child = children[i], nestedHit = this.hitTestRecursive(child, this._isInteractive(eventMode) ? eventMode : child.eventMode, location, testFn, pruneFn);
                if (nestedHit) {
                    if (nestedHit.length > 0 && !nestedHit[nestedHit.length - 1].parent) continue;
                    const isInteractive = currentTarget.isInteractive();
                    return (nestedHit.length > 0 || isInteractive) && nestedHit.push(currentTarget), nestedHit;
                }
            }
        }
        const isInteractiveMode = this._isInteractive(eventMode), isInteractiveTarget = currentTarget.isInteractive();
        return isInteractiveMode && testFn(currentTarget, location) ? isInteractiveTarget ? [
            currentTarget
        ] : [] : null;
    }
    _isInteractive(int) {
        return int === "static" || int === "dynamic";
    }
    _interactivePrune(displayObject) {
        return !!(!displayObject || displayObject.isMask || !displayObject.visible || !displayObject.renderable || displayObject.eventMode === "none" || displayObject.eventMode === "passive" && !displayObject.interactiveChildren || displayObject.isMask);
    }
    /**
   * Checks whether the display object or any of its children cannot pass the hit test at all.
   *
   * {@link PIXI.EventBoundary}'s implementation uses the {@link PIXI.DisplayObject.hitArea hitArea}
   * and {@link PIXI.DisplayObject._mask} for pruning.
   * @param displayObject
   * @param location
   */ hitPruneFn(displayObject, location) {
        if (displayObject.hitArea && (displayObject.worldTransform.applyInverse(location, $ed3feb9d7d584957$var$tempLocalMapping), !displayObject.hitArea.contains($ed3feb9d7d584957$var$tempLocalMapping.x, $ed3feb9d7d584957$var$tempLocalMapping.y))) return !0;
        if (displayObject._mask) {
            const maskObject = displayObject._mask.isMaskData ? displayObject._mask.maskObject : displayObject._mask;
            if (maskObject && !maskObject.containsPoint?.(location)) return !0;
        }
        return !1;
    }
    /**
   * Checks whether the display object passes hit testing for the given location.
   * @param displayObject
   * @param location
   * @returns - Whether `displayObject` passes hit testing for `location`.
   */ hitTestFn(displayObject, location) {
        return displayObject.eventMode === "passive" ? !1 : displayObject.hitArea ? !0 : displayObject.containsPoint ? displayObject.containsPoint(location) : !1;
    }
    /**
   * Notify all the listeners to the event's `currentTarget`.
   *
   * If the `currentTarget` contains the property `on<type>`, then it is called here,
   * simulating the behavior from version 6.x and prior.
   * @param e - The event passed to the target.
   * @param type
   */ notifyTarget(e, type) {
        type = type ?? e.type;
        const handlerKey = `on${type}`;
        e.currentTarget[handlerKey]?.(e);
        const key = e.eventPhase === e.CAPTURING_PHASE || e.eventPhase === e.AT_TARGET ? `${type}capture` : type;
        this.notifyListeners(e, key), e.eventPhase === e.AT_TARGET && this.notifyListeners(e, type);
    }
    /**
   * Maps the upstream `pointerdown` events to a downstream `pointerdown` event.
   *
   * `touchstart`, `rightdown`, `mousedown` events are also dispatched for specific pointer types.
   * @param from
   */ mapPointerDown(from) {
        if (!(from instanceof (0, $257a72d091e53320$export$44ac16aa0ab81db6))) {
            console.warn("EventBoundary cannot map a non-pointer event as a pointer event");
            return;
        }
        const e = this.createPointerEvent(from);
        if (this.dispatchEvent(e, "pointerdown"), e.pointerType === "touch") this.dispatchEvent(e, "touchstart");
        else if (e.pointerType === "mouse" || e.pointerType === "pen") {
            const isRightButton = e.button === 2;
            this.dispatchEvent(e, isRightButton ? "rightdown" : "mousedown");
        }
        const trackingData = this.trackingData(from.pointerId);
        trackingData.pressTargetsByButton[from.button] = e.composedPath(), this.freeEvent(e);
    }
    /**
   * Maps the upstream `pointermove` to downstream `pointerout`, `pointerover`, and `pointermove` events, in that order.
   *
   * The tracking data for the specific pointer has an updated `overTarget`. `mouseout`, `mouseover`,
   * `mousemove`, and `touchmove` events are fired as well for specific pointer types.
   * @param from - The upstream `pointermove` event.
   */ mapPointerMove(from) {
        if (!(from instanceof (0, $257a72d091e53320$export$44ac16aa0ab81db6))) {
            console.warn("EventBoundary cannot map a non-pointer event as a pointer event");
            return;
        }
        this._allInteractiveElements.length = 0, this._hitElements.length = 0, this._isPointerMoveEvent = !0;
        const e = this.createPointerEvent(from);
        this._isPointerMoveEvent = !1;
        const isMouse = e.pointerType === "mouse" || e.pointerType === "pen", trackingData = this.trackingData(from.pointerId), outTarget = this.findMountedTarget(trackingData.overTargets);
        if (trackingData.overTargets?.length > 0 && outTarget !== e.target) {
            const outType = from.type === "mousemove" ? "mouseout" : "pointerout", outEvent = this.createPointerEvent(from, outType, outTarget);
            if (this.dispatchEvent(outEvent, "pointerout"), isMouse && this.dispatchEvent(outEvent, "mouseout"), !e.composedPath().includes(outTarget)) {
                const leaveEvent = this.createPointerEvent(from, "pointerleave", outTarget);
                for(leaveEvent.eventPhase = leaveEvent.AT_TARGET; leaveEvent.target && !e.composedPath().includes(leaveEvent.target);)leaveEvent.currentTarget = leaveEvent.target, this.notifyTarget(leaveEvent), isMouse && this.notifyTarget(leaveEvent, "mouseleave"), leaveEvent.target = leaveEvent.target.parent;
                this.freeEvent(leaveEvent);
            }
            this.freeEvent(outEvent);
        }
        if (outTarget !== e.target) {
            const overType = from.type === "mousemove" ? "mouseover" : "pointerover", overEvent = this.clonePointerEvent(e, overType);
            this.dispatchEvent(overEvent, "pointerover"), isMouse && this.dispatchEvent(overEvent, "mouseover");
            let overTargetAncestor = outTarget?.parent;
            for(; overTargetAncestor && overTargetAncestor !== this.rootTarget.parent && overTargetAncestor !== e.target;)overTargetAncestor = overTargetAncestor.parent;
            if (!overTargetAncestor || overTargetAncestor === this.rootTarget.parent) {
                const enterEvent = this.clonePointerEvent(e, "pointerenter");
                for(enterEvent.eventPhase = enterEvent.AT_TARGET; enterEvent.target && enterEvent.target !== outTarget && enterEvent.target !== this.rootTarget.parent;)enterEvent.currentTarget = enterEvent.target, this.notifyTarget(enterEvent), isMouse && this.notifyTarget(enterEvent, "mouseenter"), enterEvent.target = enterEvent.target.parent;
                this.freeEvent(enterEvent);
            }
            this.freeEvent(overEvent);
        }
        const allMethods = [], allowGlobalPointerEvents = this.enableGlobalMoveEvents ?? !0;
        this.moveOnAll ? allMethods.push("pointermove") : this.dispatchEvent(e, "pointermove"), allowGlobalPointerEvents && allMethods.push("globalpointermove"), e.pointerType === "touch" && (this.moveOnAll ? allMethods.splice(1, 0, "touchmove") : this.dispatchEvent(e, "touchmove"), allowGlobalPointerEvents && allMethods.push("globaltouchmove")), isMouse && (this.moveOnAll ? allMethods.splice(1, 0, "mousemove") : this.dispatchEvent(e, "mousemove"), allowGlobalPointerEvents && allMethods.push("globalmousemove"), this.cursor = e.target?.cursor), allMethods.length > 0 && this.all(e, allMethods), this._allInteractiveElements.length = 0, this._hitElements.length = 0, trackingData.overTargets = e.composedPath(), this.freeEvent(e);
    }
    /**
   * Maps the upstream `pointerover` to downstream `pointerover` and `pointerenter` events, in that order.
   *
   * The tracking data for the specific pointer gets a new `overTarget`.
   * @param from - The upstream `pointerover` event.
   */ mapPointerOver(from) {
        if (!(from instanceof (0, $257a72d091e53320$export$44ac16aa0ab81db6))) {
            console.warn("EventBoundary cannot map a non-pointer event as a pointer event");
            return;
        }
        const trackingData = this.trackingData(from.pointerId), e = this.createPointerEvent(from), isMouse = e.pointerType === "mouse" || e.pointerType === "pen";
        this.dispatchEvent(e, "pointerover"), isMouse && this.dispatchEvent(e, "mouseover"), e.pointerType === "mouse" && (this.cursor = e.target?.cursor);
        const enterEvent = this.clonePointerEvent(e, "pointerenter");
        for(enterEvent.eventPhase = enterEvent.AT_TARGET; enterEvent.target && enterEvent.target !== this.rootTarget.parent;)enterEvent.currentTarget = enterEvent.target, this.notifyTarget(enterEvent), isMouse && this.notifyTarget(enterEvent, "mouseenter"), enterEvent.target = enterEvent.target.parent;
        trackingData.overTargets = e.composedPath(), this.freeEvent(e), this.freeEvent(enterEvent);
    }
    /**
   * Maps the upstream `pointerout` to downstream `pointerout`, `pointerleave` events, in that order.
   *
   * The tracking data for the specific pointer is cleared of a `overTarget`.
   * @param from - The upstream `pointerout` event.
   */ mapPointerOut(from) {
        if (!(from instanceof (0, $257a72d091e53320$export$44ac16aa0ab81db6))) {
            console.warn("EventBoundary cannot map a non-pointer event as a pointer event");
            return;
        }
        const trackingData = this.trackingData(from.pointerId);
        if (trackingData.overTargets) {
            const isMouse = from.pointerType === "mouse" || from.pointerType === "pen", outTarget = this.findMountedTarget(trackingData.overTargets), outEvent = this.createPointerEvent(from, "pointerout", outTarget);
            this.dispatchEvent(outEvent), isMouse && this.dispatchEvent(outEvent, "mouseout");
            const leaveEvent = this.createPointerEvent(from, "pointerleave", outTarget);
            for(leaveEvent.eventPhase = leaveEvent.AT_TARGET; leaveEvent.target && leaveEvent.target !== this.rootTarget.parent;)leaveEvent.currentTarget = leaveEvent.target, this.notifyTarget(leaveEvent), isMouse && this.notifyTarget(leaveEvent, "mouseleave"), leaveEvent.target = leaveEvent.target.parent;
            trackingData.overTargets = null, this.freeEvent(outEvent), this.freeEvent(leaveEvent);
        }
        this.cursor = null;
    }
    /**
   * Maps the upstream `pointerup` event to downstream `pointerup`, `pointerupoutside`,
   * and `click`/`rightclick`/`pointertap` events, in that order.
   *
   * The `pointerupoutside` event bubbles from the original `pointerdown` target to the most specific
   * ancestor of the `pointerdown` and `pointerup` targets, which is also the `click` event's target. `touchend`,
   * `rightup`, `mouseup`, `touchendoutside`, `rightupoutside`, `mouseupoutside`, and `tap` are fired as well for
   * specific pointer types.
   * @param from - The upstream `pointerup` event.
   */ mapPointerUp(from) {
        if (!(from instanceof (0, $257a72d091e53320$export$44ac16aa0ab81db6))) {
            console.warn("EventBoundary cannot map a non-pointer event as a pointer event");
            return;
        }
        const now = performance.now(), e = this.createPointerEvent(from);
        if (this.dispatchEvent(e, "pointerup"), e.pointerType === "touch") this.dispatchEvent(e, "touchend");
        else if (e.pointerType === "mouse" || e.pointerType === "pen") {
            const isRightButton = e.button === 2;
            this.dispatchEvent(e, isRightButton ? "rightup" : "mouseup");
        }
        const trackingData = this.trackingData(from.pointerId), pressTarget = this.findMountedTarget(trackingData.pressTargetsByButton[from.button]);
        let clickTarget = pressTarget;
        if (pressTarget && !e.composedPath().includes(pressTarget)) {
            let currentTarget = pressTarget;
            for(; currentTarget && !e.composedPath().includes(currentTarget);){
                if (e.currentTarget = currentTarget, this.notifyTarget(e, "pointerupoutside"), e.pointerType === "touch") this.notifyTarget(e, "touchendoutside");
                else if (e.pointerType === "mouse" || e.pointerType === "pen") {
                    const isRightButton = e.button === 2;
                    this.notifyTarget(e, isRightButton ? "rightupoutside" : "mouseupoutside");
                }
                currentTarget = currentTarget.parent;
            }
            delete trackingData.pressTargetsByButton[from.button], clickTarget = currentTarget;
        }
        if (clickTarget) {
            const clickEvent = this.clonePointerEvent(e, "click");
            clickEvent.target = clickTarget, clickEvent.path = null, trackingData.clicksByButton[from.button] || (trackingData.clicksByButton[from.button] = {
                clickCount: 0,
                target: clickEvent.target,
                timeStamp: now
            });
            const clickHistory = trackingData.clicksByButton[from.button];
            if (clickHistory.target === clickEvent.target && now - clickHistory.timeStamp < 200 ? ++clickHistory.clickCount : clickHistory.clickCount = 1, clickHistory.target = clickEvent.target, clickHistory.timeStamp = now, clickEvent.detail = clickHistory.clickCount, clickEvent.pointerType === "mouse") {
                const isRightButton = clickEvent.button === 2;
                this.dispatchEvent(clickEvent, isRightButton ? "rightclick" : "click");
            } else clickEvent.pointerType === "touch" && this.dispatchEvent(clickEvent, "tap");
            this.dispatchEvent(clickEvent, "pointertap"), this.freeEvent(clickEvent);
        }
        this.freeEvent(e);
    }
    /**
   * Maps the upstream `pointerupoutside` event to a downstream `pointerupoutside` event, bubbling from the original
   * `pointerdown` target to `rootTarget`.
   *
   * (The most specific ancestor of the `pointerdown` event and the `pointerup` event must the
   * `{@link PIXI.EventBoundary}'s root because the `pointerup` event occurred outside of the boundary.)
   *
   * `touchendoutside`, `mouseupoutside`, and `rightupoutside` events are fired as well for specific pointer
   * types. The tracking data for the specific pointer is cleared of a `pressTarget`.
   * @param from - The upstream `pointerupoutside` event.
   */ mapPointerUpOutside(from) {
        if (!(from instanceof (0, $257a72d091e53320$export$44ac16aa0ab81db6))) {
            console.warn("EventBoundary cannot map a non-pointer event as a pointer event");
            return;
        }
        const trackingData = this.trackingData(from.pointerId), pressTarget = this.findMountedTarget(trackingData.pressTargetsByButton[from.button]), e = this.createPointerEvent(from);
        if (pressTarget) {
            let currentTarget = pressTarget;
            for(; currentTarget;)e.currentTarget = currentTarget, this.notifyTarget(e, "pointerupoutside"), e.pointerType === "touch" ? this.notifyTarget(e, "touchendoutside") : (e.pointerType === "mouse" || e.pointerType === "pen") && this.notifyTarget(e, e.button === 2 ? "rightupoutside" : "mouseupoutside"), currentTarget = currentTarget.parent;
            delete trackingData.pressTargetsByButton[from.button];
        }
        this.freeEvent(e);
    }
    /**
   * Maps the upstream `wheel` event to a downstream `wheel` event.
   * @param from - The upstream `wheel` event.
   */ mapWheel(from) {
        if (!(from instanceof (0, $2bd74162fbb6f53f$export$1fd8b94eb532974d))) {
            console.warn("EventBoundary cannot map a non-wheel event as a wheel event");
            return;
        }
        const wheelEvent = this.createWheelEvent(from);
        this.dispatchEvent(wheelEvent), this.freeEvent(wheelEvent);
    }
    /**
   * Finds the most specific event-target in the given propagation path that is still mounted in the scene graph.
   *
   * This is used to find the correct `pointerup` and `pointerout` target in the case that the original `pointerdown`
   * or `pointerover` target was unmounted from the scene graph.
   * @param propagationPath - The propagation path was valid in the past.
   * @returns - The most specific event-target still mounted at the same location in the scene graph.
   */ findMountedTarget(propagationPath) {
        if (!propagationPath) return null;
        let currentTarget = propagationPath[0];
        for(let i = 1; i < propagationPath.length && propagationPath[i].parent === currentTarget; i++)currentTarget = propagationPath[i];
        return currentTarget;
    }
    /**
   * Creates an event whose {@code originalEvent} is {@code from}, with an optional `type` and `target` override.
   *
   * The event is allocated using {@link PIXI.EventBoundary#allocateEvent this.allocateEvent}.
   * @param from - The {@code originalEvent} for the returned event.
   * @param [type=from.type] - The type of the returned event.
   * @param target - The target of the returned event.
   */ createPointerEvent(from, type, target) {
        const event = this.allocateEvent((0, $257a72d091e53320$export$44ac16aa0ab81db6));
        return this.copyPointerData(from, event), this.copyMouseData(from, event), this.copyData(from, event), event.nativeEvent = from.nativeEvent, event.originalEvent = from, event.target = target ?? this.hitTest(event.global.x, event.global.y) ?? this._hitElements[0], typeof type == "string" && (event.type = type), event;
    }
    /**
   * Creates a wheel event whose {@code originalEvent} is {@code from}.
   *
   * The event is allocated using {@link PIXI.EventBoundary#allocateEvent this.allocateEvent}.
   * @param from - The upstream wheel event.
   */ createWheelEvent(from) {
        const event = this.allocateEvent((0, $2bd74162fbb6f53f$export$1fd8b94eb532974d));
        return this.copyWheelData(from, event), this.copyMouseData(from, event), this.copyData(from, event), event.nativeEvent = from.nativeEvent, event.originalEvent = from, event.target = this.hitTest(event.global.x, event.global.y), event;
    }
    /**
   * Clones the event {@code from}, with an optional {@code type} override.
   *
   * The event is allocated using {@link PIXI.EventBoundary#allocateEvent this.allocateEvent}.
   * @param from - The event to clone.
   * @param [type=from.type] - The type of the returned event.
   */ clonePointerEvent(from, type) {
        const event = this.allocateEvent((0, $257a72d091e53320$export$44ac16aa0ab81db6));
        return event.nativeEvent = from.nativeEvent, event.originalEvent = from.originalEvent, this.copyPointerData(from, event), this.copyMouseData(from, event), this.copyData(from, event), event.target = from.target, event.path = from.composedPath().slice(), event.type = type ?? event.type, event;
    }
    /**
   * Copies wheel {@link PIXI.FederatedWheelEvent} data from {@code from} into {@code to}.
   *
   * The following properties are copied:
   * + deltaMode
   * + deltaX
   * + deltaY
   * + deltaZ
   * @param from
   * @param to
   */ copyWheelData(from, to) {
        to.deltaMode = from.deltaMode, to.deltaX = from.deltaX, to.deltaY = from.deltaY, to.deltaZ = from.deltaZ;
    }
    /**
   * Copies pointer {@link PIXI.FederatedPointerEvent} data from {@code from} into {@code to}.
   *
   * The following properties are copied:
   * + pointerId
   * + width
   * + height
   * + isPrimary
   * + pointerType
   * + pressure
   * + tangentialPressure
   * + tiltX
   * + tiltY
   * @param from
   * @param to
   */ copyPointerData(from, to) {
        from instanceof (0, $257a72d091e53320$export$44ac16aa0ab81db6) && to instanceof (0, $257a72d091e53320$export$44ac16aa0ab81db6) && (to.pointerId = from.pointerId, to.width = from.width, to.height = from.height, to.isPrimary = from.isPrimary, to.pointerType = from.pointerType, to.pressure = from.pressure, to.tangentialPressure = from.tangentialPressure, to.tiltX = from.tiltX, to.tiltY = from.tiltY, to.twist = from.twist);
    }
    /**
   * Copies mouse {@link PIXI.FederatedMouseEvent} data from {@code from} to {@code to}.
   *
   * The following properties are copied:
   * + altKey
   * + button
   * + buttons
   * + clientX
   * + clientY
   * + metaKey
   * + movementX
   * + movementY
   * + pageX
   * + pageY
   * + x
   * + y
   * + screen
   * + shiftKey
   * + global
   * @param from
   * @param to
   */ copyMouseData(from, to) {
        from instanceof (0, $78dff7d12b7eab6d$export$aeb79caab92d155a) && to instanceof (0, $78dff7d12b7eab6d$export$aeb79caab92d155a) && (to.altKey = from.altKey, to.button = from.button, to.buttons = from.buttons, to.client.copyFrom(from.client), to.ctrlKey = from.ctrlKey, to.metaKey = from.metaKey, to.movement.copyFrom(from.movement), to.screen.copyFrom(from.screen), to.shiftKey = from.shiftKey, to.global.copyFrom(from.global));
    }
    /**
   * Copies base {@link PIXI.FederatedEvent} data from {@code from} into {@code to}.
   *
   * The following properties are copied:
   * + isTrusted
   * + srcElement
   * + timeStamp
   * + type
   * @param from - The event to copy data from.
   * @param to - The event to copy data into.
   */ copyData(from, to) {
        to.isTrusted = from.isTrusted, to.srcElement = from.srcElement, to.timeStamp = performance.now(), to.type = from.type, to.detail = from.detail, to.view = from.view, to.which = from.which, to.layer.copyFrom(from.layer), to.page.copyFrom(from.page);
    }
    /**
   * @param id - The pointer ID.
   * @returns The tracking data stored for the given pointer. If no data exists, a blank
   *  state will be created.
   */ trackingData(id) {
        return this.mappingState.trackingData[id] || (this.mappingState.trackingData[id] = {
            pressTargetsByButton: {},
            clicksByButton: {},
            overTarget: null
        }), this.mappingState.trackingData[id];
    }
    /**
   * Allocate a specific type of event from {@link PIXI.EventBoundary#eventPool this.eventPool}.
   *
   * This allocation is constructor-agnostic, as long as it only takes one argument - this event
   * boundary.
   * @param constructor - The event's constructor.
   */ allocateEvent(constructor) {
        this.eventPool.has(constructor) || this.eventPool.set(constructor, []);
        const event = this.eventPool.get(constructor).pop() || new constructor(this);
        return event.eventPhase = event.NONE, event.currentTarget = null, event.path = null, event.target = null, event;
    }
    /**
   * Frees the event and puts it back into the event pool.
   *
   * It is illegal to reuse the event until it is allocated again, using `this.allocateEvent`.
   *
   * It is also advised that events not allocated from {@link PIXI.EventBoundary#allocateEvent this.allocateEvent}
   * not be freed. This is because of the possibility that the same event is freed twice, which can cause
   * it to be allocated twice & result in overwriting.
   * @param event - The event to be freed.
   * @throws Error if the event is managed by another event boundary.
   */ freeEvent(event) {
        if (event.manager !== this) throw new Error("It is illegal to free an event not managed by this EventBoundary!");
        const constructor = event.constructor;
        this.eventPool.has(constructor) || this.eventPool.set(constructor, []), this.eventPool.get(constructor).push(event);
    }
    /**
   * Similar to {@link PIXI.EventEmitter.emit}, except it stops if the `propagationImmediatelyStopped` flag
   * is set on the event.
   * @param e - The event to call each listener with.
   * @param type - The event key.
   */ notifyListeners(e, type) {
        const listeners = e.currentTarget._events[type];
        if (listeners && e.currentTarget.isInteractive()) {
            if ("fn" in listeners) listeners.once && e.currentTarget.removeListener(type, listeners.fn, void 0, !0), listeners.fn.call(listeners.context, e);
            else for(let i = 0, j = listeners.length; i < j && !e.propagationImmediatelyStopped; i++)listeners[i].once && e.currentTarget.removeListener(type, listeners[i].fn, void 0, !0), listeners[i].fn.call(listeners[i].context, e);
        }
    }
}







const $5117ae1344c23bad$var$MOUSE_POINTER_ID = 1, $5117ae1344c23bad$var$TOUCH_TO_POINTER = {
    touchstart: "pointerdown",
    touchend: "pointerup",
    touchendoutside: "pointerupoutside",
    touchmove: "pointermove",
    touchcancel: "pointercancel"
}, $5117ae1344c23bad$var$_EventSystem = class _EventSystem2 {
    /**
   * @param {PIXI.Renderer} renderer
   */ constructor(renderer){
        this.supportsTouchEvents = "ontouchstart" in globalThis, this.supportsPointerEvents = !!globalThis.PointerEvent, this.domElement = null, this.resolution = 1, this.renderer = renderer, this.rootBoundary = new (0, $ed3feb9d7d584957$export$532e8c243078d2cd)(null), (0, $b87dcaf20591be16$export$57a493ed609e53ea).init(this), this.autoPreventDefault = !0, this.eventsAdded = !1, this.rootPointerEvent = new (0, $257a72d091e53320$export$44ac16aa0ab81db6)(null), this.rootWheelEvent = new (0, $2bd74162fbb6f53f$export$1fd8b94eb532974d)(null), this.cursorStyles = {
            default: "inherit",
            pointer: "pointer"
        }, this.features = new Proxy({
            ..._EventSystem2.defaultEventFeatures
        }, {
            set: (target, key, value)=>(key === "globalMove" && (this.rootBoundary.enableGlobalMoveEvents = value), target[key] = value, !0)
        }), this.onPointerDown = this.onPointerDown.bind(this), this.onPointerMove = this.onPointerMove.bind(this), this.onPointerUp = this.onPointerUp.bind(this), this.onPointerOverOut = this.onPointerOverOut.bind(this), this.onWheel = this.onWheel.bind(this);
    }
    /**
   * The default interaction mode for all display objects.
   * @see PIXI.DisplayObject.eventMode
   * @type {PIXI.EventMode}
   * @readonly
   * @since 7.2.0
   */ static get defaultEventMode() {
        return this._defaultEventMode;
    }
    /**
   * Runner init called, view is available at this point.
   * @ignore
   */ init(options) {
        const { view: view, resolution: resolution } = this.renderer;
        this.setTargetElement(view), this.resolution = resolution, _EventSystem2._defaultEventMode = options.eventMode ?? "auto", Object.assign(this.features, options.eventFeatures ?? {}), this.rootBoundary.enableGlobalMoveEvents = this.features.globalMove;
    }
    /**
   * Handle changing resolution.
   * @ignore
   */ resolutionChange(resolution) {
        this.resolution = resolution;
    }
    /** Destroys all event listeners and detaches the renderer. */ destroy() {
        this.setTargetElement(null), this.renderer = null;
    }
    /**
   * Sets the current cursor mode, handling any callbacks or CSS style changes.
   * @param mode - cursor mode, a key from the cursorStyles dictionary
   */ setCursor(mode) {
        mode = mode || "default";
        let applyStyles = !0;
        if (globalThis.OffscreenCanvas && this.domElement instanceof OffscreenCanvas && (applyStyles = !1), this.currentCursor === mode) return;
        this.currentCursor = mode;
        const style = this.cursorStyles[mode];
        if (style) switch(typeof style){
            case "string":
                applyStyles && (this.domElement.style.cursor = style);
                break;
            case "function":
                style(mode);
                break;
            case "object":
                applyStyles && Object.assign(this.domElement.style, style);
                break;
        }
        else applyStyles && typeof mode == "string" && !Object.prototype.hasOwnProperty.call(this.cursorStyles, mode) && (this.domElement.style.cursor = mode);
    }
    /**
   * The global pointer event.
   * Useful for getting the pointer position without listening to events.
   * @since 7.2.0
   */ get pointer() {
        return this.rootPointerEvent;
    }
    /**
   * Event handler for pointer down events on {@link PIXI.EventSystem#domElement this.domElement}.
   * @param nativeEvent - The native mouse/pointer/touch event.
   */ onPointerDown(nativeEvent) {
        if (!this.features.click) return;
        this.rootBoundary.rootTarget = this.renderer.lastObjectRendered;
        const events = this.normalizeToPointerData(nativeEvent);
        this.autoPreventDefault && events[0].isNormalized && (nativeEvent.cancelable || !("cancelable" in nativeEvent)) && nativeEvent.preventDefault();
        for(let i = 0, j = events.length; i < j; i++){
            const nativeEvent2 = events[i], federatedEvent = this.bootstrapEvent(this.rootPointerEvent, nativeEvent2);
            this.rootBoundary.mapEvent(federatedEvent);
        }
        this.setCursor(this.rootBoundary.cursor);
    }
    /**
   * Event handler for pointer move events on on {@link PIXI.EventSystem#domElement this.domElement}.
   * @param nativeEvent - The native mouse/pointer/touch events.
   */ onPointerMove(nativeEvent) {
        if (!this.features.move) return;
        this.rootBoundary.rootTarget = this.renderer.lastObjectRendered, (0, $b87dcaf20591be16$export$57a493ed609e53ea).pointerMoved();
        const normalizedEvents = this.normalizeToPointerData(nativeEvent);
        for(let i = 0, j = normalizedEvents.length; i < j; i++){
            const event = this.bootstrapEvent(this.rootPointerEvent, normalizedEvents[i]);
            this.rootBoundary.mapEvent(event);
        }
        this.setCursor(this.rootBoundary.cursor);
    }
    /**
   * Event handler for pointer up events on {@link PIXI.EventSystem#domElement this.domElement}.
   * @param nativeEvent - The native mouse/pointer/touch event.
   */ onPointerUp(nativeEvent) {
        if (!this.features.click) return;
        this.rootBoundary.rootTarget = this.renderer.lastObjectRendered;
        let target = nativeEvent.target;
        nativeEvent.composedPath && nativeEvent.composedPath().length > 0 && (target = nativeEvent.composedPath()[0]);
        const outside = target !== this.domElement ? "outside" : "", normalizedEvents = this.normalizeToPointerData(nativeEvent);
        for(let i = 0, j = normalizedEvents.length; i < j; i++){
            const event = this.bootstrapEvent(this.rootPointerEvent, normalizedEvents[i]);
            event.type += outside, this.rootBoundary.mapEvent(event);
        }
        this.setCursor(this.rootBoundary.cursor);
    }
    /**
   * Event handler for pointer over & out events on {@link PIXI.EventSystem#domElement this.domElement}.
   * @param nativeEvent - The native mouse/pointer/touch event.
   */ onPointerOverOut(nativeEvent) {
        if (!this.features.click) return;
        this.rootBoundary.rootTarget = this.renderer.lastObjectRendered;
        const normalizedEvents = this.normalizeToPointerData(nativeEvent);
        for(let i = 0, j = normalizedEvents.length; i < j; i++){
            const event = this.bootstrapEvent(this.rootPointerEvent, normalizedEvents[i]);
            this.rootBoundary.mapEvent(event);
        }
        this.setCursor(this.rootBoundary.cursor);
    }
    /**
   * Passive handler for `wheel` events on {@link PIXI.EventSystem.domElement this.domElement}.
   * @param nativeEvent - The native wheel event.
   */ onWheel(nativeEvent) {
        if (!this.features.wheel) return;
        const wheelEvent = this.normalizeWheelEvent(nativeEvent);
        this.rootBoundary.rootTarget = this.renderer.lastObjectRendered, this.rootBoundary.mapEvent(wheelEvent);
    }
    /**
   * Sets the {@link PIXI.EventSystem#domElement domElement} and binds event listeners.
   *
   * To deregister the current DOM element without setting a new one, pass {@code null}.
   * @param element - The new DOM element.
   */ setTargetElement(element) {
        this.removeEvents(), this.domElement = element, (0, $b87dcaf20591be16$export$57a493ed609e53ea).domElement = element, this.addEvents();
    }
    /** Register event listeners on {@link PIXI.Renderer#domElement this.domElement}. */ addEvents() {
        if (this.eventsAdded || !this.domElement) return;
        (0, $b87dcaf20591be16$export$57a493ed609e53ea).addTickerListener();
        const style = this.domElement.style;
        style && (globalThis.navigator.msPointerEnabled ? (style.msContentZooming = "none", style.msTouchAction = "none") : this.supportsPointerEvents && (style.touchAction = "none")), this.supportsPointerEvents ? (globalThis.document.addEventListener("pointermove", this.onPointerMove, !0), this.domElement.addEventListener("pointerdown", this.onPointerDown, !0), this.domElement.addEventListener("pointerleave", this.onPointerOverOut, !0), this.domElement.addEventListener("pointerover", this.onPointerOverOut, !0), globalThis.addEventListener("pointerup", this.onPointerUp, !0)) : (globalThis.document.addEventListener("mousemove", this.onPointerMove, !0), this.domElement.addEventListener("mousedown", this.onPointerDown, !0), this.domElement.addEventListener("mouseout", this.onPointerOverOut, !0), this.domElement.addEventListener("mouseover", this.onPointerOverOut, !0), globalThis.addEventListener("mouseup", this.onPointerUp, !0), this.supportsTouchEvents && (this.domElement.addEventListener("touchstart", this.onPointerDown, !0), this.domElement.addEventListener("touchend", this.onPointerUp, !0), this.domElement.addEventListener("touchmove", this.onPointerMove, !0))), this.domElement.addEventListener("wheel", this.onWheel, {
            passive: !0,
            capture: !0
        }), this.eventsAdded = !0;
    }
    /** Unregister event listeners on {@link PIXI.EventSystem#domElement this.domElement}. */ removeEvents() {
        if (!this.eventsAdded || !this.domElement) return;
        (0, $b87dcaf20591be16$export$57a493ed609e53ea).removeTickerListener();
        const style = this.domElement.style;
        globalThis.navigator.msPointerEnabled ? (style.msContentZooming = "", style.msTouchAction = "") : this.supportsPointerEvents && (style.touchAction = ""), this.supportsPointerEvents ? (globalThis.document.removeEventListener("pointermove", this.onPointerMove, !0), this.domElement.removeEventListener("pointerdown", this.onPointerDown, !0), this.domElement.removeEventListener("pointerleave", this.onPointerOverOut, !0), this.domElement.removeEventListener("pointerover", this.onPointerOverOut, !0), globalThis.removeEventListener("pointerup", this.onPointerUp, !0)) : (globalThis.document.removeEventListener("mousemove", this.onPointerMove, !0), this.domElement.removeEventListener("mousedown", this.onPointerDown, !0), this.domElement.removeEventListener("mouseout", this.onPointerOverOut, !0), this.domElement.removeEventListener("mouseover", this.onPointerOverOut, !0), globalThis.removeEventListener("mouseup", this.onPointerUp, !0), this.supportsTouchEvents && (this.domElement.removeEventListener("touchstart", this.onPointerDown, !0), this.domElement.removeEventListener("touchend", this.onPointerUp, !0), this.domElement.removeEventListener("touchmove", this.onPointerMove, !0))), this.domElement.removeEventListener("wheel", this.onWheel, !0), this.domElement = null, this.eventsAdded = !1;
    }
    /**
   * Maps x and y coords from a DOM object and maps them correctly to the PixiJS view. The
   * resulting value is stored in the point. This takes into account the fact that the DOM
   * element could be scaled and positioned anywhere on the screen.
   * @param  {PIXI.IPointData} point - the point that the result will be stored in
   * @param  {number} x - the x coord of the position to map
   * @param  {number} y - the y coord of the position to map
   */ mapPositionToPoint(point, x, y) {
        const rect = this.domElement.isConnected ? this.domElement.getBoundingClientRect() : {
            x: 0,
            y: 0,
            width: this.domElement.width,
            height: this.domElement.height,
            left: 0,
            top: 0
        }, resolutionMultiplier = 1 / this.resolution;
        point.x = (x - rect.left) * (this.domElement.width / rect.width) * resolutionMultiplier, point.y = (y - rect.top) * (this.domElement.height / rect.height) * resolutionMultiplier;
    }
    /**
   * Ensures that the original event object contains all data that a regular pointer event would have
   * @param event - The original event data from a touch or mouse event
   * @returns An array containing a single normalized pointer event, in the case of a pointer
   *  or mouse event, or a multiple normalized pointer events if there are multiple changed touches
   */ normalizeToPointerData(event) {
        const normalizedEvents = [];
        if (this.supportsTouchEvents && event instanceof TouchEvent) for(let i = 0, li = event.changedTouches.length; i < li; i++){
            const touch = event.changedTouches[i];
            typeof touch.button > "u" && (touch.button = 0), typeof touch.buttons > "u" && (touch.buttons = 1), typeof touch.isPrimary > "u" && (touch.isPrimary = event.touches.length === 1 && event.type === "touchstart"), typeof touch.width > "u" && (touch.width = touch.radiusX || 1), typeof touch.height > "u" && (touch.height = touch.radiusY || 1), typeof touch.tiltX > "u" && (touch.tiltX = 0), typeof touch.tiltY > "u" && (touch.tiltY = 0), typeof touch.pointerType > "u" && (touch.pointerType = "touch"), typeof touch.pointerId > "u" && (touch.pointerId = touch.identifier || 0), typeof touch.pressure > "u" && (touch.pressure = touch.force || 0.5), typeof touch.twist > "u" && (touch.twist = 0), typeof touch.tangentialPressure > "u" && (touch.tangentialPressure = 0), typeof touch.layerX > "u" && (touch.layerX = touch.offsetX = touch.clientX), typeof touch.layerY > "u" && (touch.layerY = touch.offsetY = touch.clientY), touch.isNormalized = !0, touch.type = event.type, normalizedEvents.push(touch);
        }
        else if (!globalThis.MouseEvent || event instanceof MouseEvent && (!this.supportsPointerEvents || !(event instanceof globalThis.PointerEvent))) {
            const tempEvent = event;
            typeof tempEvent.isPrimary > "u" && (tempEvent.isPrimary = !0), typeof tempEvent.width > "u" && (tempEvent.width = 1), typeof tempEvent.height > "u" && (tempEvent.height = 1), typeof tempEvent.tiltX > "u" && (tempEvent.tiltX = 0), typeof tempEvent.tiltY > "u" && (tempEvent.tiltY = 0), typeof tempEvent.pointerType > "u" && (tempEvent.pointerType = "mouse"), typeof tempEvent.pointerId > "u" && (tempEvent.pointerId = $5117ae1344c23bad$var$MOUSE_POINTER_ID), typeof tempEvent.pressure > "u" && (tempEvent.pressure = 0.5), typeof tempEvent.twist > "u" && (tempEvent.twist = 0), typeof tempEvent.tangentialPressure > "u" && (tempEvent.tangentialPressure = 0), tempEvent.isNormalized = !0, normalizedEvents.push(tempEvent);
        } else normalizedEvents.push(event);
        return normalizedEvents;
    }
    /**
   * Normalizes the native {@link https://w3c.github.io/uievents/#interface-wheelevent WheelEvent}.
   *
   * The returned {@link PIXI.FederatedWheelEvent} is a shared instance. It will not persist across
   * multiple native wheel events.
   * @param nativeEvent - The native wheel event that occurred on the canvas.
   * @returns A federated wheel event.
   */ normalizeWheelEvent(nativeEvent) {
        const event = this.rootWheelEvent;
        return this.transferMouseData(event, nativeEvent), event.deltaX = nativeEvent.deltaX, event.deltaY = nativeEvent.deltaY, event.deltaZ = nativeEvent.deltaZ, event.deltaMode = nativeEvent.deltaMode, this.mapPositionToPoint(event.screen, nativeEvent.clientX, nativeEvent.clientY), event.global.copyFrom(event.screen), event.offset.copyFrom(event.screen), event.nativeEvent = nativeEvent, event.type = nativeEvent.type, event;
    }
    /**
   * Normalizes the `nativeEvent` into a federateed {@link PIXI.FederatedPointerEvent}.
   * @param event
   * @param nativeEvent
   */ bootstrapEvent(event, nativeEvent) {
        return event.originalEvent = null, event.nativeEvent = nativeEvent, event.pointerId = nativeEvent.pointerId, event.width = nativeEvent.width, event.height = nativeEvent.height, event.isPrimary = nativeEvent.isPrimary, event.pointerType = nativeEvent.pointerType, event.pressure = nativeEvent.pressure, event.tangentialPressure = nativeEvent.tangentialPressure, event.tiltX = nativeEvent.tiltX, event.tiltY = nativeEvent.tiltY, event.twist = nativeEvent.twist, this.transferMouseData(event, nativeEvent), this.mapPositionToPoint(event.screen, nativeEvent.clientX, nativeEvent.clientY), event.global.copyFrom(event.screen), event.offset.copyFrom(event.screen), event.isTrusted = nativeEvent.isTrusted, event.type === "pointerleave" && (event.type = "pointerout"), event.type.startsWith("mouse") && (event.type = event.type.replace("mouse", "pointer")), event.type.startsWith("touch") && (event.type = $5117ae1344c23bad$var$TOUCH_TO_POINTER[event.type] || event.type), event;
    }
    /**
   * Transfers base & mouse event data from the {@code nativeEvent} to the federated event.
   * @param event
   * @param nativeEvent
   */ transferMouseData(event, nativeEvent) {
        event.isTrusted = nativeEvent.isTrusted, event.srcElement = nativeEvent.srcElement, event.timeStamp = performance.now(), event.type = nativeEvent.type, event.altKey = nativeEvent.altKey, event.button = nativeEvent.button, event.buttons = nativeEvent.buttons, event.client.x = nativeEvent.clientX, event.client.y = nativeEvent.clientY, event.ctrlKey = nativeEvent.ctrlKey, event.metaKey = nativeEvent.metaKey, event.movement.x = nativeEvent.movementX, event.movement.y = nativeEvent.movementY, event.page.x = nativeEvent.pageX, event.page.y = nativeEvent.pageY, event.relatedTarget = null, event.shiftKey = nativeEvent.shiftKey;
    }
};
$5117ae1344c23bad$var$_EventSystem.extension = {
    name: "events",
    type: [
        (0, $c90155f6d7d8d8f6$export$4f037c6ec2da4eeb).RendererSystem,
        (0, $c90155f6d7d8d8f6$export$4f037c6ec2da4eeb).CanvasRendererSystem
    ]
}, /**
* The event features that are enabled by the EventSystem
* This option only is available when using **@pixi/events** package
* (included in the **pixi.js** and **pixi.js-legacy** bundle), otherwise it will be ignored.
* @since 7.2.0
*/ $5117ae1344c23bad$var$_EventSystem.defaultEventFeatures = {
    move: !0,
    globalMove: !0,
    click: !0,
    wheel: !0
};
let $5117ae1344c23bad$export$bf477d624b56bf15 = $5117ae1344c23bad$var$_EventSystem;
(0, $c90155f6d7d8d8f6$export$cc3e2d3244e01b7f).add($5117ae1344c23bad$export$bf477d624b56bf15);









function $c44e7574abbf3cbc$var$convertEventModeToInteractiveMode(mode) {
    return mode === "dynamic" || mode === "static";
}
const $c44e7574abbf3cbc$export$6a5b99a7f30af1d9 = {
    /**
   * Property-based event handler for the `click` event.
   * @memberof PIXI.DisplayObject#
   * @default null
   * @example
   * this.onclick = (event) => {
   *  //some function here that happens on click
   * }
   */ onclick: null,
    /**
   * Property-based event handler for the `mousedown` event.
   * @memberof PIXI.DisplayObject#
   * @default null
   * @example
   * this.onmousedown = (event) => {
   *  //some function here that happens on mousedown
   * }
   */ onmousedown: null,
    /**
   * Property-based event handler for the `mouseenter` event.
   * @memberof PIXI.DisplayObject#
   * @default null
   * @example
   * this.onmouseenter = (event) => {
   *  //some function here that happens on mouseenter
   * }
   */ onmouseenter: null,
    /**
   * Property-based event handler for the `mouseleave` event.
   * @memberof PIXI.DisplayObject#
   * @default null
   * @example
   * this.onmouseleave = (event) => {
   *  //some function here that happens on mouseleave
   * }
   */ onmouseleave: null,
    /**
   * Property-based event handler for the `mousemove` event.
   * @memberof PIXI.DisplayObject#
   * @default null
   * @example
   * this.onmousemove = (event) => {
   *  //some function here that happens on mousemove
   * }
   */ onmousemove: null,
    /**
   * Property-based event handler for the `globalmousemove` event.
   * @memberof PIXI.DisplayObject#
   * @default null
   * @example
   * this.onglobalmousemove = (event) => {
   *  //some function here that happens on globalmousemove
   * }
   */ onglobalmousemove: null,
    /**
   * Property-based event handler for the `mouseout` event.
   * @memberof PIXI.DisplayObject#
   * @default null
   * @example
   * this.onmouseout = (event) => {
   *  //some function here that happens on mouseout
   * }
   */ onmouseout: null,
    /**
   * Property-based event handler for the `mouseover` event.
   * @memberof PIXI.DisplayObject#
   * @default null
   * @example
   * this.onmouseover = (event) => {
   *  //some function here that happens on mouseover
   * }
   */ onmouseover: null,
    /**
   * Property-based event handler for the `mouseup` event.
   * @memberof PIXI.DisplayObject#
   * @default null
   * @example
   * this.onmouseup = (event) => {
   *  //some function here that happens on mouseup
   * }
   */ onmouseup: null,
    /**
   * Property-based event handler for the `mouseupoutside` event.
   * @memberof PIXI.DisplayObject#
   * @default null
   * @example
   * this.onmouseupoutside = (event) => {
   *  //some function here that happens on mouseupoutside
   * }
   */ onmouseupoutside: null,
    /**
   * Property-based event handler for the `pointercancel` event.
   * @memberof PIXI.DisplayObject#
   * @default null
   * @example
   * this.onpointercancel = (event) => {
   *  //some function here that happens on pointercancel
   * }
   */ onpointercancel: null,
    /**
   * Property-based event handler for the `pointerdown` event.
   * @memberof PIXI.DisplayObject#
   * @default null
   * @example
   * this.onpointerdown = (event) => {
   *  //some function here that happens on pointerdown
   * }
   */ onpointerdown: null,
    /**
   * Property-based event handler for the `pointerenter` event.
   * @memberof PIXI.DisplayObject#
   * @default null
   * @example
   * this.onpointerenter = (event) => {
   *  //some function here that happens on pointerenter
   * }
   */ onpointerenter: null,
    /**
   * Property-based event handler for the `pointerleave` event.
   * @memberof PIXI.DisplayObject#
   * @default null
   * @example
   * this.onpointerleave = (event) => {
   *  //some function here that happens on pointerleave
   * }
   */ onpointerleave: null,
    /**
   * Property-based event handler for the `pointermove` event.
   * @memberof PIXI.DisplayObject#
   * @default null
   * @example
   * this.onpointermove = (event) => {
   *  //some function here that happens on pointermove
   * }
   */ onpointermove: null,
    /**
   * Property-based event handler for the `globalpointermove` event.
   * @memberof PIXI.DisplayObject#
   * @default null
   * @example
   * this.onglobalpointermove = (event) => {
   *  //some function here that happens on globalpointermove
   * }
   */ onglobalpointermove: null,
    /**
   * Property-based event handler for the `pointerout` event.
   * @memberof PIXI.DisplayObject#
   * @default null
   * @example
   * this.onpointerout = (event) => {
   *  //some function here that happens on pointerout
   * }
   */ onpointerout: null,
    /**
   * Property-based event handler for the `pointerover` event.
   * @memberof PIXI.DisplayObject#
   * @default null
   * @example
   * this.onpointerover = (event) => {
   *  //some function here that happens on pointerover
   * }
   */ onpointerover: null,
    /**
   * Property-based event handler for the `pointertap` event.
   * @memberof PIXI.DisplayObject#
   * @default null
   * @example
   * this.onpointertap = (event) => {
   *  //some function here that happens on pointertap
   * }
   */ onpointertap: null,
    /**
   * Property-based event handler for the `pointerup` event.
   * @memberof PIXI.DisplayObject#
   * @default null
   * @example
   * this.onpointerup = (event) => {
   *  //some function here that happens on pointerup
   * }
   */ onpointerup: null,
    /**
   * Property-based event handler for the `pointerupoutside` event.
   * @memberof PIXI.DisplayObject#
   * @default null
   * @example
   * this.onpointerupoutside = (event) => {
   *  //some function here that happens on pointerupoutside
   * }
   */ onpointerupoutside: null,
    /**
   * Property-based event handler for the `rightclick` event.
   * @memberof PIXI.DisplayObject#
   * @default null
   * @example
   * this.onrightclick = (event) => {
   *  //some function here that happens on rightclick
   * }
   */ onrightclick: null,
    /**
   * Property-based event handler for the `rightdown` event.
   * @memberof PIXI.DisplayObject#
   * @default null
   * @example
   * this.onrightdown = (event) => {
   *  //some function here that happens on rightdown
   * }
   */ onrightdown: null,
    /**
   * Property-based event handler for the `rightup` event.
   * @memberof PIXI.DisplayObject#
   * @default null
   * @example
   * this.onrightup = (event) => {
   *  //some function here that happens on rightup
   * }
   */ onrightup: null,
    /**
   * Property-based event handler for the `rightupoutside` event.
   * @memberof PIXI.DisplayObject#
   * @default null
   * @example
   * this.onrightupoutside = (event) => {
   *  //some function here that happens on rightupoutside
   * }
   */ onrightupoutside: null,
    /**
   * Property-based event handler for the `tap` event.
   * @memberof PIXI.DisplayObject#
   * @default null
   * @example
   * this.ontap = (event) => {
   *  //some function here that happens on tap
   * }
   */ ontap: null,
    /**
   * Property-based event handler for the `touchcancel` event.
   * @memberof PIXI.DisplayObject#
   * @default null
   * @example
   * this.ontouchcancel = (event) => {
   *  //some function here that happens on touchcancel
   * }
   */ ontouchcancel: null,
    /**
   * Property-based event handler for the `touchend` event.
   * @memberof PIXI.DisplayObject#
   * @default null
   * @example
   * this.ontouchend = (event) => {
   *  //some function here that happens on touchend
   * }
   */ ontouchend: null,
    /**
   * Property-based event handler for the `touchendoutside` event.
   * @memberof PIXI.DisplayObject#
   * @default null
   * @example
   * this.ontouchendoutside = (event) => {
   *  //some function here that happens on touchendoutside
   * }
   */ ontouchendoutside: null,
    /**
   * Property-based event handler for the `touchmove` event.
   * @memberof PIXI.DisplayObject#
   * @default null
   * @example
   * this.ontouchmove = (event) => {
   *  //some function here that happens on touchmove
   * }
   */ ontouchmove: null,
    /**
   * Property-based event handler for the `globaltouchmove` event.
   * @memberof PIXI.DisplayObject#
   * @default null
   * @example
   * this.onglobaltouchmove = (event) => {
   *  //some function here that happens on globaltouchmove
   * }
   */ onglobaltouchmove: null,
    /**
   * Property-based event handler for the `touchstart` event.
   * @memberof PIXI.DisplayObject#
   * @default null
   * @example
   * this.ontouchstart = (event) => {
   *  //some function here that happens on touchstart
   * }
   */ ontouchstart: null,
    /**
   * Property-based event handler for the `wheel` event.
   * @memberof PIXI.DisplayObject#
   * @default null
   * @example
   * this.onwheel = (event) => {
   *  //some function here that happens on wheel
   * }
   */ onwheel: null,
    /**
   * @ignore
   */ _internalInteractive: void 0,
    /**
   * Enable interaction events for the DisplayObject. Touch, pointer and mouse
   * @memberof PIXI.DisplayObject#
   */ get interactive () {
        return this._internalInteractive ?? $c44e7574abbf3cbc$var$convertEventModeToInteractiveMode((0, $5117ae1344c23bad$export$bf477d624b56bf15).defaultEventMode);
    },
    set interactive (value){
        (0, $db31fc3dfae4939b$exports).deprecation("7.2.0", // eslint-disable-next-line max-len
        "Setting interactive is deprecated, use eventMode = 'none'/'passive'/'auto'/'static'/'dynamic' instead."), this._internalInteractive = value, this.eventMode = value ? "static" : "auto";
    },
    /**
   * @ignore
   */ _internalEventMode: void 0,
    /**
   * Enable interaction events for the DisplayObject. Touch, pointer and mouse.
   * This now replaces the `interactive` property.
   * There are 5 types of interaction settings:
   * - `'none'`: Ignores all interaction events, even on its children.
   * - `'passive'`: Does not emit events and ignores all hit testing on itself and non-interactive children.
   * Interactive children will still emit events.
   * - `'auto'`: Does not emit events but is hit tested if parent is interactive. Same as `interactive = false` in v7
   * - `'static'`: Emit events and is hit tested. Same as `interaction = true` in v7
   * - `'dynamic'`: Emits events and is hit tested but will also receive mock interaction events fired from a ticker to
   * allow for interaction when the mouse isn't moving
   * @example
   * import { Sprite } from 'pixi.js';
   *
   * const sprite = new Sprite(texture);
   * sprite.eventMode = 'static';
   * sprite.on('tap', (event) => {
   *     // Handle event
   * });
   * @memberof PIXI.DisplayObject#
   * @since 7.2.0
   */ get eventMode () {
        return this._internalEventMode ?? (0, $5117ae1344c23bad$export$bf477d624b56bf15).defaultEventMode;
    },
    set eventMode (value){
        this._internalInteractive = $c44e7574abbf3cbc$var$convertEventModeToInteractiveMode(value), this._internalEventMode = value;
    },
    /**
   * Determines if the displayObject is interactive or not
   * @returns {boolean} Whether the displayObject is interactive or not
   * @memberof PIXI.DisplayObject#
   * @since 7.2.0
   * @example
   * import { Sprite } from 'pixi.js';
   * const sprite = new Sprite(texture);
   * sprite.eventMode = 'static';
   * sprite.isInteractive(); // true
   *
   * sprite.eventMode = 'dynamic';
   * sprite.isInteractive(); // true
   *
   * sprite.eventMode = 'none';
   * sprite.isInteractive(); // false
   *
   * sprite.eventMode = 'passive';
   * sprite.isInteractive(); // false
   *
   * sprite.eventMode = 'auto';
   * sprite.isInteractive(); // false
   */ isInteractive () {
        return this.eventMode === "static" || this.eventMode === "dynamic";
    },
    /**
   * Determines if the children to the displayObject can be clicked/touched
   * Setting this to false allows PixiJS to bypass a recursive `hitTest` function
   * @memberof PIXI.Container#
   */ interactiveChildren: !0,
    /**
   * Interaction shape. Children will be hit first, then this shape will be checked.
   * Setting this will cause this shape to be checked in hit tests rather than the displayObject's bounds.
   * @example
   * import { Rectangle, Sprite } from 'pixi.js';
   *
   * const sprite = new Sprite(texture);
   * sprite.interactive = true;
   * sprite.hitArea = new Rectangle(0, 0, 100, 100);
   * @member {PIXI.IHitArea}
   * @memberof PIXI.DisplayObject#
   */ hitArea: null,
    /**
   * Unlike `on` or `addListener` which are methods from EventEmitter, `addEventListener`
   * seeks to be compatible with the DOM's `addEventListener` with support for options.
   * **IMPORTANT:** _Only_ available if using the `@pixi/events` package.
   * @memberof PIXI.DisplayObject
   * @param type - The type of event to listen to.
   * @param listener - The listener callback or object.
   * @param options - Listener options, used for capture phase.
   * @example
   * // Tell the user whether they did a single, double, triple, or nth click.
   * button.addEventListener('click', {
   *     handleEvent(e): {
   *         let prefix;
   *
   *         switch (e.detail) {
   *             case 1: prefix = 'single'; break;
   *             case 2: prefix = 'double'; break;
   *             case 3: prefix = 'triple'; break;
   *             default: prefix = e.detail + 'th'; break;
   *         }
   *
   *         console.log('That was a ' + prefix + 'click');
   *     }
   * });
   *
   * // But skip the first click!
   * button.parent.addEventListener('click', function blockClickOnce(e) {
   *     e.stopImmediatePropagation();
   *     button.parent.removeEventListener('click', blockClickOnce, true);
   * }, {
   *     capture: true,
   * });
   */ addEventListener (type, listener, options) {
        const capture = typeof options == "boolean" && options || typeof options == "object" && options.capture, context = typeof listener == "function" ? void 0 : listener;
        type = capture ? `${type}capture` : type, listener = typeof listener == "function" ? listener : listener.handleEvent, this.on(type, listener, context);
    },
    /**
   * Unlike `off` or `removeListener` which are methods from EventEmitter, `removeEventListener`
   * seeks to be compatible with the DOM's `removeEventListener` with support for options.
   * **IMPORTANT:** _Only_ available if using the `@pixi/events` package.
   * @memberof PIXI.DisplayObject
   * @param type - The type of event the listener is bound to.
   * @param listener - The listener callback or object.
   * @param options - The original listener options. This is required to deregister a capture phase listener.
   */ removeEventListener (type, listener, options) {
        const capture = typeof options == "boolean" && options || typeof options == "object" && options.capture, context = typeof listener == "function" ? void 0 : listener;
        type = capture ? `${type}capture` : type, listener = typeof listener == "function" ? listener : listener.handleEvent, this.off(type, listener, context);
    },
    /**
   * Dispatch the event on this {@link PIXI.DisplayObject} using the event's {@link PIXI.EventBoundary}.
   *
   * The target of the event is set to `this` and the `defaultPrevented` flag is cleared before dispatch.
   *
   * **IMPORTANT:** _Only_ available if using the `@pixi/events` package.
   * @memberof PIXI.DisplayObject
   * @param e - The event to dispatch.
   * @returns Whether the {@link PIXI.FederatedEvent.preventDefault preventDefault}() method was not invoked.
   * @example
   * // Reuse a click event!
   * button.dispatchEvent(clickEvent);
   */ dispatchEvent (e) {
        if (!(e instanceof (0, $9fcd20bd50e66930$export$5d10db92bb959d8a))) throw new Error("DisplayObject cannot propagate events outside of the Federated Events API");
        return e.defaultPrevented = !1, e.path = null, e.target = this, e.manager.dispatchEvent(e), !e.defaultPrevented;
    }
};
(0, $469c1c392031bfb3$export$1f679544f90d7d7c).mixin($c44e7574abbf3cbc$export$6a5b99a7f30af1d9);







const $1c8a411b42a62b84$export$2c6c5fc5694bba8e = {
    /**
   *  Flag for if the object is accessible. If true AccessibilityManager will overlay a
   *   shadow div with attributes set
   * @member {boolean}
   * @memberof PIXI.DisplayObject#
   */ accessible: !1,
    /**
   * Sets the title attribute of the shadow div
   * If accessibleTitle AND accessibleHint has not been this will default to 'displayObject [tabIndex]'
   * @member {?string}
   * @memberof PIXI.DisplayObject#
   */ accessibleTitle: null,
    /**
   * Sets the aria-label attribute of the shadow div
   * @member {string}
   * @memberof PIXI.DisplayObject#
   */ accessibleHint: null,
    /**
   * @member {number}
   * @memberof PIXI.DisplayObject#
   * @private
   * @todo Needs docs.
   */ tabIndex: 0,
    /**
   * @member {boolean}
   * @memberof PIXI.DisplayObject#
   * @todo Needs docs.
   */ _accessibleActive: !1,
    /**
   * @member {boolean}
   * @memberof PIXI.DisplayObject#
   * @todo Needs docs.
   */ _accessibleDiv: null,
    /**
   * Specify the type of div the accessible layer is. Screen readers treat the element differently
   * depending on this type. Defaults to button.
   * @member {string}
   * @memberof PIXI.DisplayObject#
   * @default 'button'
   */ accessibleType: "button",
    /**
   * Specify the pointer-events the accessible div will use
   * Defaults to auto.
   * @member {string}
   * @memberof PIXI.DisplayObject#
   * @default 'auto'
   */ accessiblePointerEvents: "auto",
    /**
   * Setting to false will prevent any children inside this container to
   * be accessible. Defaults to true.
   * @member {boolean}
   * @memberof PIXI.DisplayObject#
   * @default true
   */ accessibleChildren: !0,
    renderId: -1
};


(0, $469c1c392031bfb3$export$1f679544f90d7d7c).mixin((0, $1c8a411b42a62b84$export$2c6c5fc5694bba8e));
const $e91fc16b72f19b4d$var$KEY_CODE_TAB = 9, $e91fc16b72f19b4d$var$DIV_TOUCH_SIZE = 100, $e91fc16b72f19b4d$var$DIV_TOUCH_POS_X = 0, $e91fc16b72f19b4d$var$DIV_TOUCH_POS_Y = 0, $e91fc16b72f19b4d$var$DIV_TOUCH_ZINDEX = 2, $e91fc16b72f19b4d$var$DIV_HOOK_SIZE = 1, $e91fc16b72f19b4d$var$DIV_HOOK_POS_X = -1000, $e91fc16b72f19b4d$var$DIV_HOOK_POS_Y = -1000, $e91fc16b72f19b4d$var$DIV_HOOK_ZINDEX = 2;
class $e91fc16b72f19b4d$export$a2c2de1efa8671eb {
    // 2fps
    /**
   * @param {PIXI.CanvasRenderer|PIXI.Renderer} renderer - A reference to the current renderer
   */ constructor(renderer){
        this.debug = !1, this._isActive = !1, this._isMobileAccessibility = !1, this.pool = [], this.renderId = 0, this.children = [], this.androidUpdateCount = 0, this.androidUpdateFrequency = 500, this._hookDiv = null, ((0, $db31fc3dfae4939b$exports).isMobile.tablet || (0, $db31fc3dfae4939b$exports).isMobile.phone) && this.createTouchHook();
        const div = document.createElement("div");
        div.style.width = `${$e91fc16b72f19b4d$var$DIV_TOUCH_SIZE}px`, div.style.height = `${$e91fc16b72f19b4d$var$DIV_TOUCH_SIZE}px`, div.style.position = "absolute", div.style.top = `${$e91fc16b72f19b4d$var$DIV_TOUCH_POS_X}px`, div.style.left = `${$e91fc16b72f19b4d$var$DIV_TOUCH_POS_Y}px`, div.style.zIndex = $e91fc16b72f19b4d$var$DIV_TOUCH_ZINDEX.toString(), this.div = div, this.renderer = renderer, this._onKeyDown = this._onKeyDown.bind(this), this._onMouseMove = this._onMouseMove.bind(this), globalThis.addEventListener("keydown", this._onKeyDown, !1);
    }
    /**
   * Value of `true` if accessibility is currently active and accessibility layers are showing.
   * @member {boolean}
   * @readonly
   */ get isActive() {
        return this._isActive;
    }
    /**
   * Value of `true` if accessibility is enabled for touch devices.
   * @member {boolean}
   * @readonly
   */ get isMobileAccessibility() {
        return this._isMobileAccessibility;
    }
    /**
   * Creates the touch hooks.
   * @private
   */ createTouchHook() {
        const hookDiv = document.createElement("button");
        hookDiv.style.width = `${$e91fc16b72f19b4d$var$DIV_HOOK_SIZE}px`, hookDiv.style.height = `${$e91fc16b72f19b4d$var$DIV_HOOK_SIZE}px`, hookDiv.style.position = "absolute", hookDiv.style.top = `${$e91fc16b72f19b4d$var$DIV_HOOK_POS_X}px`, hookDiv.style.left = `${$e91fc16b72f19b4d$var$DIV_HOOK_POS_Y}px`, hookDiv.style.zIndex = $e91fc16b72f19b4d$var$DIV_HOOK_ZINDEX.toString(), hookDiv.style.backgroundColor = "#FF0000", hookDiv.title = "select to enable accessibility for this content", hookDiv.addEventListener("focus", ()=>{
            this._isMobileAccessibility = !0, this.activate(), this.destroyTouchHook();
        }), document.body.appendChild(hookDiv), this._hookDiv = hookDiv;
    }
    /**
   * Destroys the touch hooks.
   * @private
   */ destroyTouchHook() {
        this._hookDiv && (document.body.removeChild(this._hookDiv), this._hookDiv = null);
    }
    /**
   * Activating will cause the Accessibility layer to be shown.
   * This is called when a user presses the tab key.
   * @private
   */ activate() {
        this._isActive || (this._isActive = !0, globalThis.document.addEventListener("mousemove", this._onMouseMove, !0), globalThis.removeEventListener("keydown", this._onKeyDown, !1), this.renderer.on("postrender", this.update, this), this.renderer.view.parentNode?.appendChild(this.div));
    }
    /**
   * Deactivating will cause the Accessibility layer to be hidden.
   * This is called when a user moves the mouse.
   * @private
   */ deactivate() {
        !this._isActive || this._isMobileAccessibility || (this._isActive = !1, globalThis.document.removeEventListener("mousemove", this._onMouseMove, !0), globalThis.addEventListener("keydown", this._onKeyDown, !1), this.renderer.off("postrender", this.update), this.div.parentNode?.removeChild(this.div));
    }
    /**
   * This recursive function will run through the scene graph and add any new accessible objects to the DOM layer.
   * @private
   * @param {PIXI.Container} displayObject - The DisplayObject to check.
   */ updateAccessibleObjects(displayObject) {
        if (!displayObject.visible || !displayObject.accessibleChildren) return;
        displayObject.accessible && displayObject.isInteractive() && (displayObject._accessibleActive || this.addChild(displayObject), displayObject.renderId = this.renderId);
        const children = displayObject.children;
        if (children) for(let i = 0; i < children.length; i++)this.updateAccessibleObjects(children[i]);
    }
    /**
   * Before each render this function will ensure that all divs are mapped correctly to their DisplayObjects.
   * @private
   */ update() {
        const now = performance.now();
        if ((0, $db31fc3dfae4939b$exports).isMobile.android.device && now < this.androidUpdateCount || (this.androidUpdateCount = now + this.androidUpdateFrequency, !this.renderer.renderingToScreen)) return;
        this.renderer.lastObjectRendered && this.updateAccessibleObjects(this.renderer.lastObjectRendered);
        const { x: x, y: y, width: width, height: height } = this.renderer.view.getBoundingClientRect(), { width: viewWidth, height: viewHeight, resolution: resolution } = this.renderer, sx = width / viewWidth * resolution, sy = height / viewHeight * resolution;
        let div = this.div;
        div.style.left = `${x}px`, div.style.top = `${y}px`, div.style.width = `${viewWidth}px`, div.style.height = `${viewHeight}px`;
        for(let i = 0; i < this.children.length; i++){
            const child = this.children[i];
            if (child.renderId !== this.renderId) child._accessibleActive = !1, (0, $db31fc3dfae4939b$exports).removeItems(this.children, i, 1), this.div.removeChild(child._accessibleDiv), this.pool.push(child._accessibleDiv), child._accessibleDiv = null, i--;
            else {
                div = child._accessibleDiv;
                let hitArea = child.hitArea;
                const wt = child.worldTransform;
                child.hitArea ? (div.style.left = `${(wt.tx + hitArea.x * wt.a) * sx}px`, div.style.top = `${(wt.ty + hitArea.y * wt.d) * sy}px`, div.style.width = `${hitArea.width * wt.a * sx}px`, div.style.height = `${hitArea.height * wt.d * sy}px`) : (hitArea = child.getBounds(), this.capHitArea(hitArea), div.style.left = `${hitArea.x * sx}px`, div.style.top = `${hitArea.y * sy}px`, div.style.width = `${hitArea.width * sx}px`, div.style.height = `${hitArea.height * sy}px`, div.title !== child.accessibleTitle && child.accessibleTitle !== null && (div.title = child.accessibleTitle), div.getAttribute("aria-label") !== child.accessibleHint && child.accessibleHint !== null && div.setAttribute("aria-label", child.accessibleHint)), (child.accessibleTitle !== div.title || child.tabIndex !== div.tabIndex) && (div.title = child.accessibleTitle, div.tabIndex = child.tabIndex, this.debug && this.updateDebugHTML(div));
            }
        }
        this.renderId++;
    }
    /**
   * private function that will visually add the information to the
   * accessability div
   * @param {HTMLElement} div -
   */ updateDebugHTML(div) {
        div.innerHTML = `type: ${div.type}</br> title : ${div.title}</br> tabIndex: ${div.tabIndex}`;
    }
    /**
   * Adjust the hit area based on the bounds of a display object
   * @param {PIXI.Rectangle} hitArea - Bounds of the child
   */ capHitArea(hitArea) {
        hitArea.x < 0 && (hitArea.width += hitArea.x, hitArea.x = 0), hitArea.y < 0 && (hitArea.height += hitArea.y, hitArea.y = 0);
        const { width: viewWidth, height: viewHeight } = this.renderer;
        hitArea.x + hitArea.width > viewWidth && (hitArea.width = viewWidth - hitArea.x), hitArea.y + hitArea.height > viewHeight && (hitArea.height = viewHeight - hitArea.y);
    }
    /**
   * Adds a DisplayObject to the accessibility manager
   * @private
   * @param {PIXI.DisplayObject} displayObject - The child to make accessible.
   */ addChild(displayObject) {
        let div = this.pool.pop();
        div || (div = document.createElement("button"), div.style.width = `${$e91fc16b72f19b4d$var$DIV_TOUCH_SIZE}px`, div.style.height = `${$e91fc16b72f19b4d$var$DIV_TOUCH_SIZE}px`, div.style.backgroundColor = this.debug ? "rgba(255,255,255,0.5)" : "transparent", div.style.position = "absolute", div.style.zIndex = $e91fc16b72f19b4d$var$DIV_TOUCH_ZINDEX.toString(), div.style.borderStyle = "none", navigator.userAgent.toLowerCase().includes("chrome") ? div.setAttribute("aria-live", "off") : div.setAttribute("aria-live", "polite"), navigator.userAgent.match(/rv:.*Gecko\//) ? div.setAttribute("aria-relevant", "additions") : div.setAttribute("aria-relevant", "text"), div.addEventListener("click", this._onClick.bind(this)), div.addEventListener("focus", this._onFocus.bind(this)), div.addEventListener("focusout", this._onFocusOut.bind(this))), div.style.pointerEvents = displayObject.accessiblePointerEvents, div.type = displayObject.accessibleType, displayObject.accessibleTitle && displayObject.accessibleTitle !== null ? div.title = displayObject.accessibleTitle : (!displayObject.accessibleHint || displayObject.accessibleHint === null) && (div.title = `displayObject ${displayObject.tabIndex}`), displayObject.accessibleHint && displayObject.accessibleHint !== null && div.setAttribute("aria-label", displayObject.accessibleHint), this.debug && this.updateDebugHTML(div), displayObject._accessibleActive = !0, displayObject._accessibleDiv = div, div.displayObject = displayObject, this.children.push(displayObject), this.div.appendChild(displayObject._accessibleDiv), displayObject._accessibleDiv.tabIndex = displayObject.tabIndex;
    }
    /**
   * Dispatch events with the EventSystem.
   * @param e
   * @param type
   * @private
   */ _dispatchEvent(e, type) {
        const { displayObject: target } = e.target, boundry = this.renderer.events.rootBoundary, event = Object.assign(new (0, $9fcd20bd50e66930$export$5d10db92bb959d8a)(boundry), {
            target: target
        });
        boundry.rootTarget = this.renderer.lastObjectRendered, type.forEach((type2)=>boundry.dispatchEvent(event, type2));
    }
    /**
   * Maps the div button press to pixi's EventSystem (click)
   * @private
   * @param {MouseEvent} e - The click event.
   */ _onClick(e) {
        this._dispatchEvent(e, [
            "click",
            "pointertap",
            "tap"
        ]);
    }
    /**
   * Maps the div focus events to pixi's EventSystem (mouseover)
   * @private
   * @param {FocusEvent} e - The focus event.
   */ _onFocus(e) {
        e.target.getAttribute("aria-live") || e.target.setAttribute("aria-live", "assertive"), this._dispatchEvent(e, [
            "mouseover"
        ]);
    }
    /**
   * Maps the div focus events to pixi's EventSystem (mouseout)
   * @private
   * @param {FocusEvent} e - The focusout event.
   */ _onFocusOut(e) {
        e.target.getAttribute("aria-live") || e.target.setAttribute("aria-live", "polite"), this._dispatchEvent(e, [
            "mouseout"
        ]);
    }
    /**
   * Is called when a key is pressed
   * @private
   * @param {KeyboardEvent} e - The keydown event.
   */ _onKeyDown(e) {
        e.keyCode === $e91fc16b72f19b4d$var$KEY_CODE_TAB && this.activate();
    }
    /**
   * Is called when the mouse moves across the renderer element
   * @private
   * @param {MouseEvent} e - The mouse event.
   */ _onMouseMove(e) {
        e.movementX === 0 && e.movementY === 0 || this.deactivate();
    }
    /** Destroys the accessibility manager */ destroy() {
        this.destroyTouchHook(), this.div = null, globalThis.document.removeEventListener("mousemove", this._onMouseMove, !0), globalThis.removeEventListener("keydown", this._onKeyDown), this.pool = null, this.children = null, this.renderer = null;
    }
}
$e91fc16b72f19b4d$export$a2c2de1efa8671eb.extension = {
    name: "accessibility",
    type: [
        (0, $c90155f6d7d8d8f6$export$4f037c6ec2da4eeb).RendererPlugin,
        (0, $c90155f6d7d8d8f6$export$4f037c6ec2da4eeb).CanvasRendererPlugin
    ]
};
(0, $c90155f6d7d8d8f6$export$cc3e2d3244e01b7f).add($e91fc16b72f19b4d$export$a2c2de1efa8671eb);







const $f3c45d23c8a4ee00$var$_Application = class _Application2 {
    /**
   * @param options - The optional application and renderer parameters.
   */ constructor(options){
        this.stage = new (0, $68e6944de5989822$export$42a852a2b6b56249)(), options = Object.assign({
            forceCanvas: !1
        }, options), this.renderer = (0, $d7c11949c329125b$export$3583b92ab8150eb6)(options), _Application2._plugins.forEach((plugin)=>{
            plugin.init.call(this, options);
        });
    }
    /** Render the current stage. */ render() {
        this.renderer.render(this.stage);
    }
    /**
   * Reference to the renderer's canvas element.
   * @member {PIXI.ICanvas}
   * @readonly
   */ get view() {
        return this.renderer?.view;
    }
    /**
   * Reference to the renderer's screen rectangle. Its safe to use as `filterArea` or `hitArea` for the whole screen.
   * @member {PIXI.Rectangle}
   * @readonly
   */ get screen() {
        return this.renderer?.screen;
    }
    /**
   * Destroy and don't use after this.
   * @param {boolean} [removeView=false] - Automatically remove canvas from DOM.
   * @param {object|boolean} [stageOptions] - Options parameter. A boolean will act as if all options
   *  have been set to that value
   * @param {boolean} [stageOptions.children=false] - if set to true, all the children will have their destroy
   *  method called as well. 'stageOptions' will be passed on to those calls.
   * @param {boolean} [stageOptions.texture=false] - Only used for child Sprites if stageOptions.children is set
   *  to true. Should it destroy the texture of the child sprite
   * @param {boolean} [stageOptions.baseTexture=false] - Only used for child Sprites if stageOptions.children is set
   *  to true. Should it destroy the base texture of the child sprite
   */ destroy(removeView, stageOptions) {
        const plugins = _Application2._plugins.slice(0);
        plugins.reverse(), plugins.forEach((plugin)=>{
            plugin.destroy.call(this);
        }), this.stage.destroy(stageOptions), this.stage = null, this.renderer.destroy(removeView), this.renderer = null;
    }
};
$f3c45d23c8a4ee00$var$_Application._plugins = [];
let $f3c45d23c8a4ee00$export$16975c34e60e1e61 = $f3c45d23c8a4ee00$var$_Application;
(0, $c90155f6d7d8d8f6$export$cc3e2d3244e01b7f).handleByList((0, $c90155f6d7d8d8f6$export$4f037c6ec2da4eeb).Application, $f3c45d23c8a4ee00$export$16975c34e60e1e61._plugins);



class $60e1c4838a057d28$export$6453cd852defe94a {
    /**
   * Initialize the plugin with scope of application instance
   * @static
   * @private
   * @param {object} [options] - See application options
   */ static init(options) {
        Object.defineProperty(this, "resizeTo", /**
       * The HTML element or window to automatically resize the
       * renderer's view element to match width and height.
       * @member {Window|HTMLElement}
       * @name resizeTo
       * @memberof PIXI.Application#
       */ {
            set (dom) {
                globalThis.removeEventListener("resize", this.queueResize), this._resizeTo = dom, dom && (globalThis.addEventListener("resize", this.queueResize), this.resize());
            },
            get () {
                return this._resizeTo;
            }
        }), this.queueResize = ()=>{
            this._resizeTo && (this.cancelResize(), this._resizeId = requestAnimationFrame(()=>this.resize()));
        }, this.cancelResize = ()=>{
            this._resizeId && (cancelAnimationFrame(this._resizeId), this._resizeId = null);
        }, this.resize = ()=>{
            if (!this._resizeTo) return;
            this.cancelResize();
            let width, height;
            if (this._resizeTo === globalThis.window) width = globalThis.innerWidth, height = globalThis.innerHeight;
            else {
                const { clientWidth: clientWidth, clientHeight: clientHeight } = this._resizeTo;
                width = clientWidth, height = clientHeight;
            }
            this.renderer.resize(width, height), this.render();
        }, this._resizeId = null, this._resizeTo = null, this.resizeTo = options.resizeTo || null;
    }
    /**
   * Clean up the ticker, scoped to application
   * @static
   * @private
   */ static destroy() {
        globalThis.removeEventListener("resize", this.queueResize), this.cancelResize(), this.cancelResize = null, this.queueResize = null, this.resizeTo = null, this.resize = null;
    }
}
$60e1c4838a057d28$export$6453cd852defe94a.extension = (0, $c90155f6d7d8d8f6$export$4f037c6ec2da4eeb).Application;
(0, $c90155f6d7d8d8f6$export$cc3e2d3244e01b7f).add($60e1c4838a057d28$export$6453cd852defe94a);





var $32d419410ae253bf$export$9a3c57b95f3e5f5d = /* @__PURE__ */ ((INTERNAL_FORMATS2)=>(INTERNAL_FORMATS2[INTERNAL_FORMATS2.COMPRESSED_RGB_S3TC_DXT1_EXT = 33776] = "COMPRESSED_RGB_S3TC_DXT1_EXT", INTERNAL_FORMATS2[INTERNAL_FORMATS2.COMPRESSED_RGBA_S3TC_DXT1_EXT = 33777] = "COMPRESSED_RGBA_S3TC_DXT1_EXT", INTERNAL_FORMATS2[INTERNAL_FORMATS2.COMPRESSED_RGBA_S3TC_DXT3_EXT = 33778] = "COMPRESSED_RGBA_S3TC_DXT3_EXT", INTERNAL_FORMATS2[INTERNAL_FORMATS2.COMPRESSED_RGBA_S3TC_DXT5_EXT = 33779] = "COMPRESSED_RGBA_S3TC_DXT5_EXT", INTERNAL_FORMATS2[INTERNAL_FORMATS2.COMPRESSED_SRGB_ALPHA_S3TC_DXT1_EXT = 35917] = "COMPRESSED_SRGB_ALPHA_S3TC_DXT1_EXT", INTERNAL_FORMATS2[INTERNAL_FORMATS2.COMPRESSED_SRGB_ALPHA_S3TC_DXT3_EXT = 35918] = "COMPRESSED_SRGB_ALPHA_S3TC_DXT3_EXT", INTERNAL_FORMATS2[INTERNAL_FORMATS2.COMPRESSED_SRGB_ALPHA_S3TC_DXT5_EXT = 35919] = "COMPRESSED_SRGB_ALPHA_S3TC_DXT5_EXT", INTERNAL_FORMATS2[INTERNAL_FORMATS2.COMPRESSED_SRGB_S3TC_DXT1_EXT = 35916] = "COMPRESSED_SRGB_S3TC_DXT1_EXT", INTERNAL_FORMATS2[INTERNAL_FORMATS2.COMPRESSED_R11_EAC = 37488] = "COMPRESSED_R11_EAC", INTERNAL_FORMATS2[INTERNAL_FORMATS2.COMPRESSED_SIGNED_R11_EAC = 37489] = "COMPRESSED_SIGNED_R11_EAC", INTERNAL_FORMATS2[INTERNAL_FORMATS2.COMPRESSED_RG11_EAC = 37490] = "COMPRESSED_RG11_EAC", INTERNAL_FORMATS2[INTERNAL_FORMATS2.COMPRESSED_SIGNED_RG11_EAC = 37491] = "COMPRESSED_SIGNED_RG11_EAC", INTERNAL_FORMATS2[INTERNAL_FORMATS2.COMPRESSED_RGB8_ETC2 = 37492] = "COMPRESSED_RGB8_ETC2", INTERNAL_FORMATS2[INTERNAL_FORMATS2.COMPRESSED_RGBA8_ETC2_EAC = 37496] = "COMPRESSED_RGBA8_ETC2_EAC", INTERNAL_FORMATS2[INTERNAL_FORMATS2.COMPRESSED_SRGB8_ETC2 = 37493] = "COMPRESSED_SRGB8_ETC2", INTERNAL_FORMATS2[INTERNAL_FORMATS2.COMPRESSED_SRGB8_ALPHA8_ETC2_EAC = 37497] = "COMPRESSED_SRGB8_ALPHA8_ETC2_EAC", INTERNAL_FORMATS2[INTERNAL_FORMATS2.COMPRESSED_RGB8_PUNCHTHROUGH_ALPHA1_ETC2 = 37494] = "COMPRESSED_RGB8_PUNCHTHROUGH_ALPHA1_ETC2", INTERNAL_FORMATS2[INTERNAL_FORMATS2.COMPRESSED_SRGB8_PUNCHTHROUGH_ALPHA1_ETC2 = 37495] = "COMPRESSED_SRGB8_PUNCHTHROUGH_ALPHA1_ETC2", INTERNAL_FORMATS2[INTERNAL_FORMATS2.COMPRESSED_RGB_PVRTC_4BPPV1_IMG = 35840] = "COMPRESSED_RGB_PVRTC_4BPPV1_IMG", INTERNAL_FORMATS2[INTERNAL_FORMATS2.COMPRESSED_RGBA_PVRTC_4BPPV1_IMG = 35842] = "COMPRESSED_RGBA_PVRTC_4BPPV1_IMG", INTERNAL_FORMATS2[INTERNAL_FORMATS2.COMPRESSED_RGB_PVRTC_2BPPV1_IMG = 35841] = "COMPRESSED_RGB_PVRTC_2BPPV1_IMG", INTERNAL_FORMATS2[INTERNAL_FORMATS2.COMPRESSED_RGBA_PVRTC_2BPPV1_IMG = 35843] = "COMPRESSED_RGBA_PVRTC_2BPPV1_IMG", INTERNAL_FORMATS2[INTERNAL_FORMATS2.COMPRESSED_RGB_ETC1_WEBGL = 36196] = "COMPRESSED_RGB_ETC1_WEBGL", INTERNAL_FORMATS2[INTERNAL_FORMATS2.COMPRESSED_RGB_ATC_WEBGL = 35986] = "COMPRESSED_RGB_ATC_WEBGL", INTERNAL_FORMATS2[INTERNAL_FORMATS2.COMPRESSED_RGBA_ATC_EXPLICIT_ALPHA_WEBGL = 35986] = "COMPRESSED_RGBA_ATC_EXPLICIT_ALPHA_WEBGL", INTERNAL_FORMATS2[INTERNAL_FORMATS2.COMPRESSED_RGBA_ATC_INTERPOLATED_ALPHA_WEBGL = 34798] = "COMPRESSED_RGBA_ATC_INTERPOLATED_ALPHA_WEBGL", INTERNAL_FORMATS2[INTERNAL_FORMATS2.COMPRESSED_RGBA_ASTC_4x4_KHR = 37808] = "COMPRESSED_RGBA_ASTC_4x4_KHR", INTERNAL_FORMATS2))($32d419410ae253bf$export$9a3c57b95f3e5f5d || {});
const $32d419410ae253bf$export$fb888e587c979eee = {
    // WEBGL_compressed_texture_s3tc
    33776: 0.5,
    33777: 0.5,
    33778: 1,
    33779: 1,
    // WEBGL_compressed_texture_s3tc
    35916: 0.5,
    35917: 0.5,
    35918: 1,
    35919: 1,
    // WEBGL_compressed_texture_etc
    37488: 0.5,
    37489: 0.5,
    37490: 1,
    37491: 1,
    37492: 0.5,
    37496: 1,
    37493: 0.5,
    37497: 1,
    37494: 0.5,
    // ~~
    37495: 0.5,
    // ~~
    // WEBGL_compressed_texture_pvrtc
    35840: 0.5,
    35842: 0.5,
    35841: 0.25,
    35843: 0.25,
    // WEBGL_compressed_texture_etc1
    36196: 0.5,
    // @see https://www.khronos.org/registry/OpenGL/extensions/AMD/AMD_compressed_ATC_texture.txt
    // WEBGL_compressed_texture_atc
    35986: 0.5,
    35986: 1,
    34798: 1,
    // @see https://registry.khronos.org/OpenGL/extensions/KHR/KHR_texture_compression_astc_hdr.txt
    // WEBGL_compressed_texture_astc
    /* eslint-disable-next-line camelcase */ 37808: 1
};





let $e8748af1e6505391$var$storedGl, $e8748af1e6505391$var$extensions;
function $e8748af1e6505391$var$getCompressedTextureExtensions() {
    $e8748af1e6505391$var$extensions = {
        s3tc: $e8748af1e6505391$var$storedGl.getExtension("WEBGL_compressed_texture_s3tc"),
        s3tc_sRGB: $e8748af1e6505391$var$storedGl.getExtension("WEBGL_compressed_texture_s3tc_srgb"),
        /* eslint-disable-line camelcase */ etc: $e8748af1e6505391$var$storedGl.getExtension("WEBGL_compressed_texture_etc"),
        etc1: $e8748af1e6505391$var$storedGl.getExtension("WEBGL_compressed_texture_etc1"),
        pvrtc: $e8748af1e6505391$var$storedGl.getExtension("WEBGL_compressed_texture_pvrtc") || $e8748af1e6505391$var$storedGl.getExtension("WEBKIT_WEBGL_compressed_texture_pvrtc"),
        atc: $e8748af1e6505391$var$storedGl.getExtension("WEBGL_compressed_texture_atc"),
        astc: $e8748af1e6505391$var$storedGl.getExtension("WEBGL_compressed_texture_astc")
    };
}
const $e8748af1e6505391$export$82cf9629b7380430 = {
    extension: {
        type: (0, $c90155f6d7d8d8f6$export$4f037c6ec2da4eeb).DetectionParser,
        priority: 2
    },
    test: async ()=>{
        const gl = (0, $2808efac47e52be0$export$a5a6e0b888b2c992).ADAPTER.createCanvas().getContext("webgl");
        return gl ? ($e8748af1e6505391$var$storedGl = gl, !0) : (console.warn("WebGL not available for compressed textures."), !1);
    },
    add: async (formats)=>{
        $e8748af1e6505391$var$extensions || $e8748af1e6505391$var$getCompressedTextureExtensions();
        const textureFormats = [];
        for(const extensionName in $e8748af1e6505391$var$extensions)$e8748af1e6505391$var$extensions[extensionName] && textureFormats.push(extensionName);
        return [
            ...textureFormats,
            ...formats
        ];
    },
    remove: async (formats)=>($e8748af1e6505391$var$extensions || $e8748af1e6505391$var$getCompressedTextureExtensions(), formats.filter((f)=>!(f in $e8748af1e6505391$var$extensions)))
};
(0, $c90155f6d7d8d8f6$export$cc3e2d3244e01b7f).add($e8748af1e6505391$export$82cf9629b7380430);






class $88b0648a924c3e40$export$f257f839012584a2 extends (0, $62e6c838a658c2fb$export$a79ef781de624449) {
    /**
   * @param source - The buffer/URL of the texture file.
   * @param {PIXI.IBlobResourceOptions} [options]
   * @param {boolean} [options.autoLoad=false] - Whether to fetch the data immediately;
   *  you can fetch it later via {@link PIXI.BlobResource#load}.
   * @param {number} [options.width=1] - The width in pixels.
   * @param {number} [options.height=1] - The height in pixels.
   * @param {1|2|4|8} [options.unpackAlignment=4] - The alignment of the pixel rows.
   */ constructor(source, options = {
        width: 1,
        height: 1,
        autoLoad: !0
    }){
        let origin, data;
        typeof source == "string" ? (origin = source, data = new Uint8Array()) : (origin = null, data = source), super(data, options), this.origin = origin, this.buffer = data ? new (0, $39a5b11da7fcb4a0$export$4fdbf0662aa3047a)(data) : null, this._load = null, this.loaded = !1, this.origin !== null && options.autoLoad !== !1 && this.load(), this.origin === null && this.buffer && (this._load = Promise.resolve(this), this.loaded = !0, this.onBlobLoaded(this.buffer.rawBinaryData));
    }
    onBlobLoaded(_data) {}
    /** Loads the blob */ load() {
        return this._load ? this._load : (this._load = fetch(this.origin).then((response)=>response.blob()).then((blob)=>blob.arrayBuffer()).then((arrayBuffer)=>(this.data = new Uint32Array(arrayBuffer), this.buffer = new (0, $39a5b11da7fcb4a0$export$4fdbf0662aa3047a)(arrayBuffer), this.loaded = !0, this.onBlobLoaded(arrayBuffer), this.update(), this)), this._load);
    }
}




class $67f6042ca5c6f0f8$export$1982af6892f05657 extends (0, $88b0648a924c3e40$export$f257f839012584a2) {
    /**
   * @param source - the buffer/URL holding the compressed texture data
   * @param options
   * @param {PIXI.INTERNAL_FORMATS} options.format - the compression format
   * @param {number} options.width - the image width in pixels.
   * @param {number} options.height - the image height in pixels.
   * @param {number} [options.level=1] - the mipmap levels stored in the compressed texture, including level 0.
   * @param {number} [options.levelBuffers] - the buffers for each mipmap level. `CompressedTextureResource` can allows you
   *      to pass `null` for `source`, for cases where each level is stored in non-contiguous memory.
   */ constructor(source, options){
        super(source, options), this.format = options.format, this.levels = options.levels || 1, this._width = options.width, this._height = options.height, this._extension = $67f6042ca5c6f0f8$export$1982af6892f05657._formatToExtension(this.format), (options.levelBuffers || this.buffer) && (this._levelBuffers = options.levelBuffers || $67f6042ca5c6f0f8$export$1982af6892f05657._createLevelBuffers(source instanceof Uint8Array ? source : this.buffer.uint8View, this.format, this.levels, 4, 4, // PVRTC has 8x4 blocks in 2bpp mode
        this.width, this.height));
    }
    /**
   * @override
   * @param renderer - A reference to the current renderer
   * @param _texture - the texture
   * @param _glTexture - texture instance for this webgl context
   */ upload(renderer, _texture, _glTexture) {
        const gl = renderer.gl;
        if (!renderer.context.extensions[this._extension]) throw new Error(`${this._extension} textures are not supported on the current machine`);
        if (!this._levelBuffers) return !1;
        gl.pixelStorei(gl.UNPACK_ALIGNMENT, 4);
        for(let i = 0, j = this.levels; i < j; i++){
            const { levelID: levelID, levelWidth: levelWidth, levelHeight: levelHeight, levelBuffer: levelBuffer } = this._levelBuffers[i];
            gl.compressedTexImage2D(gl.TEXTURE_2D, levelID, this.format, levelWidth, levelHeight, 0, levelBuffer);
        }
        return !0;
    }
    /** @protected */ onBlobLoaded() {
        this._levelBuffers = $67f6042ca5c6f0f8$export$1982af6892f05657._createLevelBuffers(this.buffer.uint8View, this.format, this.levels, 4, 4, // PVRTC has 8x4 blocks in 2bpp mode
        this.width, this.height);
    }
    /**
   * Returns the key (to ContextSystem#extensions) for the WebGL extension supporting the compression format
   * @private
   * @param format - the compression format to get the extension for.
   */ static _formatToExtension(format) {
        if (format >= 33776 && format <= 33779) return "s3tc";
        if (format >= 37488 && format <= 37497) return "etc";
        if (format >= 35840 && format <= 35843) return "pvrtc";
        if (format >= 36196) return "etc1";
        if (format >= 35986 && format <= 34798) return "atc";
        throw new Error("Invalid (compressed) texture format given!");
    }
    /**
   * Pre-creates buffer views for each mipmap level
   * @private
   * @param buffer -
   * @param format - compression formats
   * @param levels - mipmap levels
   * @param blockWidth -
   * @param blockHeight -
   * @param imageWidth - width of the image in pixels
   * @param imageHeight - height of the image in pixels
   */ static _createLevelBuffers(buffer, format, levels, blockWidth, blockHeight, imageWidth, imageHeight) {
        const buffers = new Array(levels);
        let offset = buffer.byteOffset, levelWidth = imageWidth, levelHeight = imageHeight, alignedLevelWidth = levelWidth + blockWidth - 1 & ~(blockWidth - 1), alignedLevelHeight = levelHeight + blockHeight - 1 & ~(blockHeight - 1), levelSize = alignedLevelWidth * alignedLevelHeight * (0, $32d419410ae253bf$export$fb888e587c979eee)[format];
        for(let i = 0; i < levels; i++)buffers[i] = {
            levelID: i,
            levelWidth: levels > 1 ? levelWidth : alignedLevelWidth,
            levelHeight: levels > 1 ? levelHeight : alignedLevelHeight,
            levelBuffer: new Uint8Array(buffer.buffer, offset, levelSize)
        }, offset += levelSize, levelWidth = levelWidth >> 1 || 1, levelHeight = levelHeight >> 1 || 1, alignedLevelWidth = levelWidth + blockWidth - 1 & ~(blockWidth - 1), alignedLevelHeight = levelHeight + blockHeight - 1 & ~(blockHeight - 1), levelSize = alignedLevelWidth * alignedLevelHeight * (0, $32d419410ae253bf$export$fb888e587c979eee)[format];
        return buffers;
    }
}





const $c74fab5d0d29e716$var$DDS_MAGIC_SIZE = 4, $c74fab5d0d29e716$var$DDS_HEADER_SIZE = 124, $c74fab5d0d29e716$var$DDS_HEADER_PF_SIZE = 32, $c74fab5d0d29e716$var$DDS_HEADER_DX10_SIZE = 20, $c74fab5d0d29e716$var$DDS_MAGIC = 542327876, $c74fab5d0d29e716$var$DDS_FIELDS = {
    SIZE: 1,
    FLAGS: 2,
    HEIGHT: 3,
    WIDTH: 4,
    MIPMAP_COUNT: 7,
    PIXEL_FORMAT: 19
}, $c74fab5d0d29e716$var$DDS_PF_FIELDS = {
    SIZE: 0,
    FLAGS: 1,
    FOURCC: 2,
    RGB_BITCOUNT: 3,
    R_BIT_MASK: 4,
    G_BIT_MASK: 5,
    B_BIT_MASK: 6,
    A_BIT_MASK: 7
}, $c74fab5d0d29e716$var$DDS_DX10_FIELDS = {
    DXGI_FORMAT: 0,
    RESOURCE_DIMENSION: 1,
    MISC_FLAG: 2,
    ARRAY_SIZE: 3,
    MISC_FLAGS2: 4
}, $c74fab5d0d29e716$var$PF_FLAGS = 1, $c74fab5d0d29e716$var$DDPF_ALPHA = 2, $c74fab5d0d29e716$var$DDPF_FOURCC = 4, $c74fab5d0d29e716$var$DDPF_RGB = 64, $c74fab5d0d29e716$var$DDPF_YUV = 512, $c74fab5d0d29e716$var$DDPF_LUMINANCE = 131072, $c74fab5d0d29e716$var$FOURCC_DXT1 = 827611204, $c74fab5d0d29e716$var$FOURCC_DXT3 = 861165636, $c74fab5d0d29e716$var$FOURCC_DXT5 = 894720068, $c74fab5d0d29e716$var$FOURCC_DX10 = 808540228, $c74fab5d0d29e716$var$DDS_RESOURCE_MISC_TEXTURECUBE = 4, $c74fab5d0d29e716$var$FOURCC_TO_FORMAT = {
    [$c74fab5d0d29e716$var$FOURCC_DXT1]: (0, $32d419410ae253bf$export$9a3c57b95f3e5f5d).COMPRESSED_RGBA_S3TC_DXT1_EXT,
    [$c74fab5d0d29e716$var$FOURCC_DXT3]: (0, $32d419410ae253bf$export$9a3c57b95f3e5f5d).COMPRESSED_RGBA_S3TC_DXT3_EXT,
    [$c74fab5d0d29e716$var$FOURCC_DXT5]: (0, $32d419410ae253bf$export$9a3c57b95f3e5f5d).COMPRESSED_RGBA_S3TC_DXT5_EXT
}, $c74fab5d0d29e716$var$DXGI_TO_FORMAT = {
    // WEBGL_compressed_texture_s3tc
    70: (0, $32d419410ae253bf$export$9a3c57b95f3e5f5d).COMPRESSED_RGBA_S3TC_DXT1_EXT,
    71: (0, $32d419410ae253bf$export$9a3c57b95f3e5f5d).COMPRESSED_RGBA_S3TC_DXT1_EXT,
    73: (0, $32d419410ae253bf$export$9a3c57b95f3e5f5d).COMPRESSED_RGBA_S3TC_DXT3_EXT,
    74: (0, $32d419410ae253bf$export$9a3c57b95f3e5f5d).COMPRESSED_RGBA_S3TC_DXT3_EXT,
    76: (0, $32d419410ae253bf$export$9a3c57b95f3e5f5d).COMPRESSED_RGBA_S3TC_DXT5_EXT,
    77: (0, $32d419410ae253bf$export$9a3c57b95f3e5f5d).COMPRESSED_RGBA_S3TC_DXT5_EXT,
    // WEBGL_compressed_texture_s3tc_srgb
    72: (0, $32d419410ae253bf$export$9a3c57b95f3e5f5d).COMPRESSED_SRGB_ALPHA_S3TC_DXT1_EXT,
    75: (0, $32d419410ae253bf$export$9a3c57b95f3e5f5d).COMPRESSED_SRGB_ALPHA_S3TC_DXT3_EXT,
    78: (0, $32d419410ae253bf$export$9a3c57b95f3e5f5d).COMPRESSED_SRGB_ALPHA_S3TC_DXT5_EXT
};
function $c74fab5d0d29e716$export$cddc4925efe88ac(arrayBuffer) {
    const data = new Uint32Array(arrayBuffer);
    if (data[0] !== $c74fab5d0d29e716$var$DDS_MAGIC) throw new Error("Invalid DDS file magic word");
    const header = new Uint32Array(arrayBuffer, 0, $c74fab5d0d29e716$var$DDS_HEADER_SIZE / Uint32Array.BYTES_PER_ELEMENT), height = header[$c74fab5d0d29e716$var$DDS_FIELDS.HEIGHT], width = header[$c74fab5d0d29e716$var$DDS_FIELDS.WIDTH], mipmapCount = header[$c74fab5d0d29e716$var$DDS_FIELDS.MIPMAP_COUNT], pixelFormat = new Uint32Array(arrayBuffer, $c74fab5d0d29e716$var$DDS_FIELDS.PIXEL_FORMAT * Uint32Array.BYTES_PER_ELEMENT, $c74fab5d0d29e716$var$DDS_HEADER_PF_SIZE / Uint32Array.BYTES_PER_ELEMENT), formatFlags = pixelFormat[$c74fab5d0d29e716$var$PF_FLAGS];
    if (formatFlags & $c74fab5d0d29e716$var$DDPF_FOURCC) {
        const fourCC = pixelFormat[$c74fab5d0d29e716$var$DDS_PF_FIELDS.FOURCC];
        if (fourCC !== $c74fab5d0d29e716$var$FOURCC_DX10) {
            const internalFormat2 = $c74fab5d0d29e716$var$FOURCC_TO_FORMAT[fourCC], dataOffset2 = $c74fab5d0d29e716$var$DDS_MAGIC_SIZE + $c74fab5d0d29e716$var$DDS_HEADER_SIZE, texData = new Uint8Array(arrayBuffer, dataOffset2);
            return [
                new (0, $67f6042ca5c6f0f8$export$1982af6892f05657)(texData, {
                    format: internalFormat2,
                    width: width,
                    height: height,
                    levels: mipmapCount
                })
            ];
        }
        const dx10Offset = $c74fab5d0d29e716$var$DDS_MAGIC_SIZE + $c74fab5d0d29e716$var$DDS_HEADER_SIZE, dx10Header = new Uint32Array(data.buffer, dx10Offset, $c74fab5d0d29e716$var$DDS_HEADER_DX10_SIZE / Uint32Array.BYTES_PER_ELEMENT), dxgiFormat = dx10Header[$c74fab5d0d29e716$var$DDS_DX10_FIELDS.DXGI_FORMAT], resourceDimension = dx10Header[$c74fab5d0d29e716$var$DDS_DX10_FIELDS.RESOURCE_DIMENSION], miscFlag = dx10Header[$c74fab5d0d29e716$var$DDS_DX10_FIELDS.MISC_FLAG], arraySize = dx10Header[$c74fab5d0d29e716$var$DDS_DX10_FIELDS.ARRAY_SIZE], internalFormat = $c74fab5d0d29e716$var$DXGI_TO_FORMAT[dxgiFormat];
        if (internalFormat === void 0) throw new Error(`DDSParser cannot parse texture data with DXGI format ${dxgiFormat}`);
        if (miscFlag === $c74fab5d0d29e716$var$DDS_RESOURCE_MISC_TEXTURECUBE) throw new Error("DDSParser does not support cubemap textures");
        if (resourceDimension === 6) throw new Error("DDSParser does not supported 3D texture data");
        const imageBuffers = new Array(), dataOffset = $c74fab5d0d29e716$var$DDS_MAGIC_SIZE + $c74fab5d0d29e716$var$DDS_HEADER_SIZE + $c74fab5d0d29e716$var$DDS_HEADER_DX10_SIZE;
        if (arraySize === 1) imageBuffers.push(new Uint8Array(arrayBuffer, dataOffset));
        else {
            const pixelSize = (0, $32d419410ae253bf$export$fb888e587c979eee)[internalFormat];
            let imageSize = 0, levelWidth = width, levelHeight = height;
            for(let i = 0; i < mipmapCount; i++){
                const alignedLevelWidth = Math.max(1, levelWidth + 3 & -4), alignedLevelHeight = Math.max(1, levelHeight + 3 & -4), levelSize = alignedLevelWidth * alignedLevelHeight * pixelSize;
                imageSize += levelSize, levelWidth = levelWidth >>> 1, levelHeight = levelHeight >>> 1;
            }
            let imageOffset = dataOffset;
            for(let i = 0; i < arraySize; i++)imageBuffers.push(new Uint8Array(arrayBuffer, imageOffset, imageSize)), imageOffset += imageSize;
        }
        return imageBuffers.map((buffer)=>new (0, $67f6042ca5c6f0f8$export$1982af6892f05657)(buffer, {
                format: internalFormat,
                width: width,
                height: height,
                levels: mipmapCount
            }));
    }
    throw formatFlags & $c74fab5d0d29e716$var$DDPF_RGB ? new Error("DDSParser does not support uncompressed texture data.") : formatFlags & $c74fab5d0d29e716$var$DDPF_YUV ? new Error("DDSParser does not supported YUV uncompressed texture data.") : formatFlags & $c74fab5d0d29e716$var$DDPF_LUMINANCE ? new Error("DDSParser does not support single-channel (lumninance) texture data!") : formatFlags & $c74fab5d0d29e716$var$DDPF_ALPHA ? new Error("DDSParser does not support single-channel (alpha) texture data!") : new Error("DDSParser failed to load a texture file due to an unknown reason!");
}






const $3f53aba0bdd5b262$var$FILE_IDENTIFIER = [
    171,
    75,
    84,
    88,
    32,
    49,
    49,
    187,
    13,
    10,
    26,
    10
], $3f53aba0bdd5b262$var$ENDIANNESS = 67305985, $3f53aba0bdd5b262$var$KTX_FIELDS = {
    FILE_IDENTIFIER: 0,
    ENDIANNESS: 12,
    GL_TYPE: 16,
    GL_TYPE_SIZE: 20,
    GL_FORMAT: 24,
    GL_INTERNAL_FORMAT: 28,
    GL_BASE_INTERNAL_FORMAT: 32,
    PIXEL_WIDTH: 36,
    PIXEL_HEIGHT: 40,
    PIXEL_DEPTH: 44,
    NUMBER_OF_ARRAY_ELEMENTS: 48,
    NUMBER_OF_FACES: 52,
    NUMBER_OF_MIPMAP_LEVELS: 56,
    BYTES_OF_KEY_VALUE_DATA: 60
}, $3f53aba0bdd5b262$var$FILE_HEADER_SIZE = 64, $3f53aba0bdd5b262$export$96c88eb9c7372a0b = {
    [(0, $0fa4b07f86297abd$export$426db7a6155b7a80).UNSIGNED_BYTE]: 1,
    [(0, $0fa4b07f86297abd$export$426db7a6155b7a80).UNSIGNED_SHORT]: 2,
    [(0, $0fa4b07f86297abd$export$426db7a6155b7a80).INT]: 4,
    [(0, $0fa4b07f86297abd$export$426db7a6155b7a80).UNSIGNED_INT]: 4,
    [(0, $0fa4b07f86297abd$export$426db7a6155b7a80).FLOAT]: 4,
    [(0, $0fa4b07f86297abd$export$426db7a6155b7a80).HALF_FLOAT]: 8
}, $3f53aba0bdd5b262$export$ace48b1390b9b0c2 = {
    [(0, $0fa4b07f86297abd$export$e9c4b7b466aa8274).RGBA]: 4,
    [(0, $0fa4b07f86297abd$export$e9c4b7b466aa8274).RGB]: 3,
    [(0, $0fa4b07f86297abd$export$e9c4b7b466aa8274).RG]: 2,
    [(0, $0fa4b07f86297abd$export$e9c4b7b466aa8274).RED]: 1,
    [(0, $0fa4b07f86297abd$export$e9c4b7b466aa8274).LUMINANCE]: 1,
    [(0, $0fa4b07f86297abd$export$e9c4b7b466aa8274).LUMINANCE_ALPHA]: 2,
    [(0, $0fa4b07f86297abd$export$e9c4b7b466aa8274).ALPHA]: 1
}, $3f53aba0bdd5b262$export$2ca26443044e8798 = {
    [(0, $0fa4b07f86297abd$export$426db7a6155b7a80).UNSIGNED_SHORT_4_4_4_4]: 2,
    [(0, $0fa4b07f86297abd$export$426db7a6155b7a80).UNSIGNED_SHORT_5_5_5_1]: 2,
    [(0, $0fa4b07f86297abd$export$426db7a6155b7a80).UNSIGNED_SHORT_5_6_5]: 2
};
function $3f53aba0bdd5b262$export$58a6abed7fd55190(url, arrayBuffer, loadKeyValueData = !1) {
    const dataView = new DataView(arrayBuffer);
    if (!$3f53aba0bdd5b262$var$validate(url, dataView)) return null;
    const littleEndian = dataView.getUint32($3f53aba0bdd5b262$var$KTX_FIELDS.ENDIANNESS, !0) === $3f53aba0bdd5b262$var$ENDIANNESS, glType = dataView.getUint32($3f53aba0bdd5b262$var$KTX_FIELDS.GL_TYPE, littleEndian), glFormat = dataView.getUint32($3f53aba0bdd5b262$var$KTX_FIELDS.GL_FORMAT, littleEndian), glInternalFormat = dataView.getUint32($3f53aba0bdd5b262$var$KTX_FIELDS.GL_INTERNAL_FORMAT, littleEndian), pixelWidth = dataView.getUint32($3f53aba0bdd5b262$var$KTX_FIELDS.PIXEL_WIDTH, littleEndian), pixelHeight = dataView.getUint32($3f53aba0bdd5b262$var$KTX_FIELDS.PIXEL_HEIGHT, littleEndian) || 1, pixelDepth = dataView.getUint32($3f53aba0bdd5b262$var$KTX_FIELDS.PIXEL_DEPTH, littleEndian) || 1, numberOfArrayElements = dataView.getUint32($3f53aba0bdd5b262$var$KTX_FIELDS.NUMBER_OF_ARRAY_ELEMENTS, littleEndian) || 1, numberOfFaces = dataView.getUint32($3f53aba0bdd5b262$var$KTX_FIELDS.NUMBER_OF_FACES, littleEndian), numberOfMipmapLevels = dataView.getUint32($3f53aba0bdd5b262$var$KTX_FIELDS.NUMBER_OF_MIPMAP_LEVELS, littleEndian), bytesOfKeyValueData = dataView.getUint32($3f53aba0bdd5b262$var$KTX_FIELDS.BYTES_OF_KEY_VALUE_DATA, littleEndian);
    if (pixelHeight === 0 || pixelDepth !== 1) throw new Error("Only 2D textures are supported");
    if (numberOfFaces !== 1) throw new Error("CubeTextures are not supported by KTXLoader yet!");
    if (numberOfArrayElements !== 1) throw new Error("WebGL does not support array textures");
    const blockWidth = 4, blockHeight = 4, alignedWidth = pixelWidth + 3 & -4, alignedHeight = pixelHeight + 3 & -4, imageBuffers = new Array(numberOfArrayElements);
    let imagePixels = pixelWidth * pixelHeight;
    glType === 0 && (imagePixels = alignedWidth * alignedHeight);
    let imagePixelByteSize;
    if (glType !== 0 ? $3f53aba0bdd5b262$export$96c88eb9c7372a0b[glType] ? imagePixelByteSize = $3f53aba0bdd5b262$export$96c88eb9c7372a0b[glType] * $3f53aba0bdd5b262$export$ace48b1390b9b0c2[glFormat] : imagePixelByteSize = $3f53aba0bdd5b262$export$2ca26443044e8798[glType] : imagePixelByteSize = (0, $32d419410ae253bf$export$fb888e587c979eee)[glInternalFormat], imagePixelByteSize === void 0) throw new Error("Unable to resolve the pixel format stored in the *.ktx file!");
    const kvData = loadKeyValueData ? $3f53aba0bdd5b262$var$parseKvData(dataView, bytesOfKeyValueData, littleEndian) : null;
    let mipByteSize = imagePixels * imagePixelByteSize, mipWidth = pixelWidth, mipHeight = pixelHeight, alignedMipWidth = alignedWidth, alignedMipHeight = alignedHeight, imageOffset = $3f53aba0bdd5b262$var$FILE_HEADER_SIZE + bytesOfKeyValueData;
    for(let mipmapLevel = 0; mipmapLevel < numberOfMipmapLevels; mipmapLevel++){
        const imageSize = dataView.getUint32(imageOffset, littleEndian);
        let elementOffset = imageOffset + 4;
        for(let arrayElement = 0; arrayElement < numberOfArrayElements; arrayElement++){
            let mips = imageBuffers[arrayElement];
            mips || (mips = imageBuffers[arrayElement] = new Array(numberOfMipmapLevels)), mips[mipmapLevel] = {
                levelID: mipmapLevel,
                // don't align mipWidth when texture not compressed! (glType not zero)
                levelWidth: numberOfMipmapLevels > 1 || glType !== 0 ? mipWidth : alignedMipWidth,
                levelHeight: numberOfMipmapLevels > 1 || glType !== 0 ? mipHeight : alignedMipHeight,
                levelBuffer: new Uint8Array(arrayBuffer, elementOffset, mipByteSize)
            }, elementOffset += mipByteSize;
        }
        imageOffset += imageSize + 4, imageOffset = imageOffset % 4 !== 0 ? imageOffset + 4 - imageOffset % 4 : imageOffset, mipWidth = mipWidth >> 1 || 1, mipHeight = mipHeight >> 1 || 1, alignedMipWidth = mipWidth + blockWidth - 1 & ~(blockWidth - 1), alignedMipHeight = mipHeight + blockHeight - 1 & ~(blockHeight - 1), mipByteSize = alignedMipWidth * alignedMipHeight * imagePixelByteSize;
    }
    return glType !== 0 ? {
        uncompressed: imageBuffers.map((levelBuffers)=>{
            let buffer = levelBuffers[0].levelBuffer, convertToInt = !1;
            return glType === (0, $0fa4b07f86297abd$export$426db7a6155b7a80).FLOAT ? buffer = new Float32Array(levelBuffers[0].levelBuffer.buffer, levelBuffers[0].levelBuffer.byteOffset, levelBuffers[0].levelBuffer.byteLength / 4) : glType === (0, $0fa4b07f86297abd$export$426db7a6155b7a80).UNSIGNED_INT ? (convertToInt = !0, buffer = new Uint32Array(levelBuffers[0].levelBuffer.buffer, levelBuffers[0].levelBuffer.byteOffset, levelBuffers[0].levelBuffer.byteLength / 4)) : glType === (0, $0fa4b07f86297abd$export$426db7a6155b7a80).INT && (convertToInt = !0, buffer = new Int32Array(levelBuffers[0].levelBuffer.buffer, levelBuffers[0].levelBuffer.byteOffset, levelBuffers[0].levelBuffer.byteLength / 4)), {
                resource: new (0, $62e6c838a658c2fb$export$a79ef781de624449)(buffer, {
                    width: levelBuffers[0].levelWidth,
                    height: levelBuffers[0].levelHeight
                }),
                type: glType,
                format: convertToInt ? $3f53aba0bdd5b262$var$convertFormatToInteger(glFormat) : glFormat
            };
        }),
        kvData: kvData
    } : {
        compressed: imageBuffers.map((levelBuffers)=>new (0, $67f6042ca5c6f0f8$export$1982af6892f05657)(null, {
                format: glInternalFormat,
                width: pixelWidth,
                height: pixelHeight,
                levels: numberOfMipmapLevels,
                levelBuffers: levelBuffers
            })),
        kvData: kvData
    };
}
function $3f53aba0bdd5b262$var$validate(url, dataView) {
    for(let i = 0; i < $3f53aba0bdd5b262$var$FILE_IDENTIFIER.length; i++)if (dataView.getUint8(i) !== $3f53aba0bdd5b262$var$FILE_IDENTIFIER[i]) return console.error(`${url} is not a valid *.ktx file!`), !1;
    return !0;
}
function $3f53aba0bdd5b262$var$convertFormatToInteger(format) {
    switch(format){
        case (0, $0fa4b07f86297abd$export$e9c4b7b466aa8274).RGBA:
            return (0, $0fa4b07f86297abd$export$e9c4b7b466aa8274).RGBA_INTEGER;
        case (0, $0fa4b07f86297abd$export$e9c4b7b466aa8274).RGB:
            return (0, $0fa4b07f86297abd$export$e9c4b7b466aa8274).RGB_INTEGER;
        case (0, $0fa4b07f86297abd$export$e9c4b7b466aa8274).RG:
            return (0, $0fa4b07f86297abd$export$e9c4b7b466aa8274).RG_INTEGER;
        case (0, $0fa4b07f86297abd$export$e9c4b7b466aa8274).RED:
            return (0, $0fa4b07f86297abd$export$e9c4b7b466aa8274).RED_INTEGER;
        default:
            return format;
    }
}
function $3f53aba0bdd5b262$var$parseKvData(dataView, bytesOfKeyValueData, littleEndian) {
    const kvData = /* @__PURE__ */ new Map();
    let bytesIntoKeyValueData = 0;
    for(; bytesIntoKeyValueData < bytesOfKeyValueData;){
        const keyAndValueByteSize = dataView.getUint32($3f53aba0bdd5b262$var$FILE_HEADER_SIZE + bytesIntoKeyValueData, littleEndian), keyAndValueByteOffset = $3f53aba0bdd5b262$var$FILE_HEADER_SIZE + bytesIntoKeyValueData + 4, valuePadding = 3 - (keyAndValueByteSize + 3) % 4;
        if (keyAndValueByteSize === 0 || keyAndValueByteSize > bytesOfKeyValueData - bytesIntoKeyValueData) {
            console.error("KTXLoader: keyAndValueByteSize out of bounds");
            break;
        }
        let keyNulByte = 0;
        for(; keyNulByte < keyAndValueByteSize && dataView.getUint8(keyAndValueByteOffset + keyNulByte) !== 0; keyNulByte++);
        if (keyNulByte === -1) {
            console.error("KTXLoader: Failed to find null byte terminating kvData key");
            break;
        }
        const key = new TextDecoder().decode(new Uint8Array(dataView.buffer, keyAndValueByteOffset, keyNulByte)), value = new DataView(dataView.buffer, keyAndValueByteOffset + keyNulByte + 1, keyAndValueByteSize - keyNulByte - 1);
        kvData.set(key, value), bytesIntoKeyValueData += 4 + keyAndValueByteSize + valuePadding;
    }
    return kvData;
}





const $ea6b083f631e8a83$export$20ea358dd867fe3e = {
    extension: {
        type: (0, $c90155f6d7d8d8f6$export$4f037c6ec2da4eeb).LoadParser,
        priority: (0, $ed5d6a4467c2b40c$export$820ed6348c4f2750).High
    },
    name: "loadDDS",
    test (url) {
        return (0, $09c9bb162e36b2d4$export$fd0180357b95b812)(url, ".dds");
    },
    async load (url, asset, loader) {
        const arrayBuffer = await (await (0, $2808efac47e52be0$export$a5a6e0b888b2c992).ADAPTER.fetch(url)).arrayBuffer(), textures = (0, $c74fab5d0d29e716$export$cddc4925efe88ac)(arrayBuffer).map((resource)=>{
            const base = new (0, $30c85657f0c625d5$export$d6306e508f184154)(resource, {
                mipmap: (0, $0fa4b07f86297abd$export$16f6fb5da874bbfd).OFF,
                alphaMode: (0, $0fa4b07f86297abd$export$d56550d454401b73).NO_PREMULTIPLIED_ALPHA,
                resolution: (0, $db31fc3dfae4939b$exports).getResolutionOfUrl(url),
                ...asset.data
            });
            return (0, $7c128909ff22805e$export$37b981a8c575f415)(base, loader, url);
        });
        return textures.length === 1 ? textures[0] : textures;
    },
    unload (texture) {
        Array.isArray(texture) ? texture.forEach((t)=>t.destroy(!0)) : texture.destroy(!0);
    }
};
(0, $c90155f6d7d8d8f6$export$cc3e2d3244e01b7f).add($ea6b083f631e8a83$export$20ea358dd867fe3e);






const $d042bf8212f46b8a$export$e59f5413434dd0e3 = {
    extension: {
        type: (0, $c90155f6d7d8d8f6$export$4f037c6ec2da4eeb).LoadParser,
        priority: (0, $ed5d6a4467c2b40c$export$820ed6348c4f2750).High
    },
    name: "loadKTX",
    test (url) {
        return (0, $09c9bb162e36b2d4$export$fd0180357b95b812)(url, ".ktx");
    },
    async load (url, asset, loader) {
        const arrayBuffer = await (await (0, $2808efac47e52be0$export$a5a6e0b888b2c992).ADAPTER.fetch(url)).arrayBuffer(), { compressed: compressed, uncompressed: uncompressed, kvData: kvData } = (0, $3f53aba0bdd5b262$export$58a6abed7fd55190)(url, arrayBuffer), resources = compressed ?? uncompressed, options = {
            mipmap: (0, $0fa4b07f86297abd$export$16f6fb5da874bbfd).OFF,
            alphaMode: (0, $0fa4b07f86297abd$export$d56550d454401b73).NO_PREMULTIPLIED_ALPHA,
            resolution: (0, $db31fc3dfae4939b$exports).getResolutionOfUrl(url),
            ...asset.data
        }, textures = resources.map((resource)=>{
            resources === uncompressed && Object.assign(options, {
                type: resource.type,
                format: resource.format
            });
            const res = resource.resource ?? resource, base = new (0, $30c85657f0c625d5$export$d6306e508f184154)(res, options);
            return base.ktxKeyValueData = kvData, (0, $7c128909ff22805e$export$37b981a8c575f415)(base, loader, url);
        });
        return textures.length === 1 ? textures[0] : textures;
    },
    unload (texture) {
        Array.isArray(texture) ? texture.forEach((t)=>t.destroy(!0)) : texture.destroy(!0);
    }
};
(0, $c90155f6d7d8d8f6$export$cc3e2d3244e01b7f).add($d042bf8212f46b8a$export$e59f5413434dd0e3);



const $e7a6663e56dde6b9$export$513de45dc484f3ba = {
    extension: (0, $c90155f6d7d8d8f6$export$4f037c6ec2da4eeb).ResolveParser,
    test: (value)=>{
        const extension = value.split("?")[0].split(".").pop();
        return [
            "basis",
            "ktx",
            "dds"
        ].includes(extension);
    },
    parse: (value)=>{
        if (value.split("?")[0].split(".").pop() === "ktx") {
            const extensions2 = [
                ".s3tc.ktx",
                ".s3tc_sRGB.ktx",
                ".etc.ktx",
                ".etc1.ktx",
                ".pvrt.ktx",
                ".atc.ktx",
                ".astc.ktx"
            ];
            if (extensions2.some((ext)=>value.endsWith(ext))) return {
                resolution: parseFloat((0, $2808efac47e52be0$export$a5a6e0b888b2c992).RETINA_PREFIX.exec(value)?.[1] ?? "1"),
                format: extensions2.find((ext)=>value.endsWith(ext)),
                src: value
            };
        }
        return {
            resolution: parseFloat((0, $2808efac47e52be0$export$a5a6e0b888b2c992).RETINA_PREFIX.exec(value)?.[1] ?? "1"),
            format: value.split(".").pop(),
            src: value
        };
    }
};
(0, $c90155f6d7d8d8f6$export$cc3e2d3244e01b7f).add($e7a6663e56dde6b9$export$513de45dc484f3ba);




















const $384e1a480fecc63f$var$TEMP_RECT = new (0, $200f778d7fdbf8ac$export$4617fb02663045ef)(), $384e1a480fecc63f$var$BYTES_PER_PIXEL = 4, $384e1a480fecc63f$var$_Extract = class _Extract2 {
    /**
   * @param renderer - A reference to the current renderer
   */ constructor(renderer){
        this.renderer = renderer, this._rendererPremultipliedAlpha = !1;
    }
    contextChange() {
        const attributes = this.renderer?.gl.getContextAttributes();
        this._rendererPremultipliedAlpha = !!(attributes && attributes.alpha && attributes.premultipliedAlpha);
    }
    /**
   * Will return a HTML Image of the target
   * @param target - A displayObject or renderTexture
   *  to convert. If left empty will use the main renderer
   * @param format - Image format, e.g. "image/jpeg" or "image/webp".
   * @param quality - JPEG or Webp compression from 0 to 1. Default is 0.92.
   * @param frame - The frame the extraction is restricted to.
   * @returns - HTML Image of the target
   */ async image(target, format, quality, frame) {
        const image = new Image();
        return image.src = await this.base64(target, format, quality, frame), image;
    }
    /**
   * Will return a base64 encoded string of this target. It works by calling
   *  `Extract.canvas` and then running toDataURL on that.
   * @param target - A displayObject or renderTexture
   *  to convert. If left empty will use the main renderer
   * @param format - Image format, e.g. "image/jpeg" or "image/webp".
   * @param quality - JPEG or Webp compression from 0 to 1. Default is 0.92.
   * @param frame - The frame the extraction is restricted to.
   * @returns - A base64 encoded string of the texture.
   */ async base64(target, format, quality, frame) {
        const canvas = this.canvas(target, frame);
        if (canvas.toBlob !== void 0) return new Promise((resolve, reject)=>{
            canvas.toBlob((blob)=>{
                if (!blob) {
                    reject(new Error("ICanvas.toBlob failed!"));
                    return;
                }
                const reader = new FileReader();
                reader.onload = ()=>resolve(reader.result), reader.onerror = reject, reader.readAsDataURL(blob);
            }, format, quality);
        });
        if (canvas.toDataURL !== void 0) return canvas.toDataURL(format, quality);
        if (canvas.convertToBlob !== void 0) {
            const blob = await canvas.convertToBlob({
                type: format,
                quality: quality
            });
            return new Promise((resolve, reject)=>{
                const reader = new FileReader();
                reader.onload = ()=>resolve(reader.result), reader.onerror = reject, reader.readAsDataURL(blob);
            });
        }
        throw new Error("Extract.base64() requires ICanvas.toDataURL, ICanvas.toBlob, or ICanvas.convertToBlob to be implemented");
    }
    /**
   * Creates a Canvas element, renders this target to it and then returns it.
   * @param target - A displayObject or renderTexture
   *  to convert. If left empty will use the main renderer
   * @param frame - The frame the extraction is restricted to.
   * @returns - A Canvas element with the texture rendered on.
   */ canvas(target, frame) {
        const { pixels: pixels, width: width, height: height, flipY: flipY, premultipliedAlpha: premultipliedAlpha } = this._rawPixels(target, frame);
        flipY && _Extract2._flipY(pixels, width, height), premultipliedAlpha && _Extract2._unpremultiplyAlpha(pixels);
        const canvasBuffer = new (0, $db31fc3dfae4939b$exports).CanvasRenderTarget(width, height, 1), imageData = new ImageData(new Uint8ClampedArray(pixels.buffer), width, height);
        return canvasBuffer.context.putImageData(imageData, 0, 0), canvasBuffer.canvas;
    }
    /**
   * Will return a one-dimensional array containing the pixel data of the entire texture in RGBA
   * order, with integer values between 0 and 255 (included).
   * @param target - A displayObject or renderTexture
   *  to convert. If left empty will use the main renderer
   * @param frame - The frame the extraction is restricted to.
   * @returns - One-dimensional array containing the pixel data of the entire texture
   */ pixels(target, frame) {
        const { pixels: pixels, width: width, height: height, flipY: flipY, premultipliedAlpha: premultipliedAlpha } = this._rawPixels(target, frame);
        return flipY && _Extract2._flipY(pixels, width, height), premultipliedAlpha && _Extract2._unpremultiplyAlpha(pixels), pixels;
    }
    _rawPixels(target, frame) {
        const renderer = this.renderer;
        if (!renderer) throw new Error("The Extract has already been destroyed");
        let resolution, flipY = !1, premultipliedAlpha = !1, renderTexture, generated = !1;
        target && (target instanceof (0, $f917e2bbb9b65ecb$export$813984f7330b4d72) ? renderTexture = target : (renderTexture = renderer.generateTexture(target, {
            region: frame,
            resolution: renderer.resolution,
            multisample: renderer.multisample
        }), generated = !0, frame && ($384e1a480fecc63f$var$TEMP_RECT.width = frame.width, $384e1a480fecc63f$var$TEMP_RECT.height = frame.height, frame = $384e1a480fecc63f$var$TEMP_RECT)));
        const gl = renderer.gl;
        if (renderTexture) {
            if (resolution = renderTexture.baseTexture.resolution, frame = frame ?? renderTexture.frame, flipY = !1, premultipliedAlpha = renderTexture.baseTexture.alphaMode > 0 && renderTexture.baseTexture.format === (0, $0fa4b07f86297abd$export$e9c4b7b466aa8274).RGBA, !generated) {
                renderer.renderTexture.bind(renderTexture);
                const fbo = renderTexture.framebuffer.glFramebuffers[renderer.CONTEXT_UID];
                fbo.blitFramebuffer && renderer.framebuffer.bind(fbo.blitFramebuffer);
            }
        } else resolution = renderer.resolution, frame || (frame = $384e1a480fecc63f$var$TEMP_RECT, frame.width = renderer.width / resolution, frame.height = renderer.height / resolution), flipY = !0, premultipliedAlpha = this._rendererPremultipliedAlpha, renderer.renderTexture.bind();
        const width = Math.max(Math.round(frame.width * resolution), 1), height = Math.max(Math.round(frame.height * resolution), 1), pixels = new Uint8Array($384e1a480fecc63f$var$BYTES_PER_PIXEL * width * height);
        return gl.readPixels(Math.round(frame.x * resolution), Math.round(frame.y * resolution), width, height, gl.RGBA, gl.UNSIGNED_BYTE, pixels), generated && renderTexture?.destroy(!0), {
            pixels: pixels,
            width: width,
            height: height,
            flipY: flipY,
            premultipliedAlpha: premultipliedAlpha
        };
    }
    /** Destroys the extract. */ destroy() {
        this.renderer = null;
    }
    static _flipY(pixels, width, height) {
        const w = width << 2, h = height >> 1, temp = new Uint8Array(w);
        for(let y = 0; y < h; y++){
            const t = y * w, b = (height - y - 1) * w;
            temp.set(pixels.subarray(t, t + w)), pixels.copyWithin(t, b, b + w), pixels.set(temp, b);
        }
    }
    static _unpremultiplyAlpha(pixels) {
        pixels instanceof Uint8ClampedArray && (pixels = new Uint8Array(pixels.buffer));
        const n = pixels.length;
        for(let i = 0; i < n; i += 4){
            const alpha = pixels[i + 3];
            if (alpha !== 0) {
                const a = 255.001 / alpha;
                pixels[i] = pixels[i] * a + 0.5, pixels[i + 1] = pixels[i + 1] * a + 0.5, pixels[i + 2] = pixels[i + 2] * a + 0.5;
            }
        }
    }
};
$384e1a480fecc63f$var$_Extract.extension = {
    name: "extract",
    type: (0, $c90155f6d7d8d8f6$export$4f037c6ec2da4eeb).RendererSystem
};
let $384e1a480fecc63f$export$296daa4fd2384194 = $384e1a480fecc63f$var$_Extract;
(0, $c90155f6d7d8d8f6$export$cc3e2d3244e01b7f).add($384e1a480fecc63f$export$296daa4fd2384194);












const $f71d82f68e674a31$export$a3541b2d8ecbfcf2 = {
    build (graphicsData) {
        const points = graphicsData.points;
        let x, y, dx, dy, rx, ry;
        if (graphicsData.type === (0, $e51f17ddb17db7b9$export$511e1d54a4a8684e).CIRC) {
            const circle = graphicsData.shape;
            x = circle.x, y = circle.y, rx = ry = circle.radius, dx = dy = 0;
        } else if (graphicsData.type === (0, $e51f17ddb17db7b9$export$511e1d54a4a8684e).ELIP) {
            const ellipse = graphicsData.shape;
            x = ellipse.x, y = ellipse.y, rx = ellipse.width, ry = ellipse.height, dx = dy = 0;
        } else {
            const roundedRect = graphicsData.shape, halfWidth = roundedRect.width / 2, halfHeight = roundedRect.height / 2;
            x = roundedRect.x + halfWidth, y = roundedRect.y + halfHeight, rx = ry = Math.max(0, Math.min(roundedRect.radius, Math.min(halfWidth, halfHeight))), dx = halfWidth - rx, dy = halfHeight - ry;
        }
        if (!(rx >= 0 && ry >= 0 && dx >= 0 && dy >= 0)) {
            points.length = 0;
            return;
        }
        const n = Math.ceil(2.3 * Math.sqrt(rx + ry)), m = n * 8 + (dx ? 4 : 0) + (dy ? 4 : 0);
        if (points.length = m, m === 0) return;
        if (n === 0) {
            points.length = 8, points[0] = points[6] = x + dx, points[1] = points[3] = y + dy, points[2] = points[4] = x - dx, points[5] = points[7] = y - dy;
            return;
        }
        let j1 = 0, j2 = n * 4 + (dx ? 2 : 0) + 2, j3 = j2, j4 = m;
        {
            const x0 = dx + rx, y0 = dy, x1 = x + x0, x2 = x - x0, y1 = y + y0;
            if (points[j1++] = x1, points[j1++] = y1, points[--j2] = y1, points[--j2] = x2, dy) {
                const y2 = y - y0;
                points[j3++] = x2, points[j3++] = y2, points[--j4] = y2, points[--j4] = x1;
            }
        }
        for(let i = 1; i < n; i++){
            const a = Math.PI / 2 * (i / n), x0 = dx + Math.cos(a) * rx, y0 = dy + Math.sin(a) * ry, x1 = x + x0, x2 = x - x0, y1 = y + y0, y2 = y - y0;
            points[j1++] = x1, points[j1++] = y1, points[--j2] = y1, points[--j2] = x2, points[j3++] = x2, points[j3++] = y2, points[--j4] = y2, points[--j4] = x1;
        }
        {
            const x0 = dx, y0 = dy + ry, x1 = x + x0, x2 = x - x0, y1 = y + y0, y2 = y - y0;
            points[j1++] = x1, points[j1++] = y1, points[--j4] = y2, points[--j4] = x1, dx && (points[j1++] = x2, points[j1++] = y1, points[--j4] = y2, points[--j4] = x2);
        }
    },
    triangulate (graphicsData, graphicsGeometry) {
        const points = graphicsData.points, verts = graphicsGeometry.points, indices = graphicsGeometry.indices;
        if (points.length === 0) return;
        let vertPos = verts.length / 2;
        const center = vertPos;
        let x, y;
        if (graphicsData.type !== (0, $e51f17ddb17db7b9$export$511e1d54a4a8684e).RREC) {
            const circle = graphicsData.shape;
            x = circle.x, y = circle.y;
        } else {
            const roundedRect = graphicsData.shape;
            x = roundedRect.x + roundedRect.width / 2, y = roundedRect.y + roundedRect.height / 2;
        }
        const matrix = graphicsData.matrix;
        verts.push(graphicsData.matrix ? matrix.a * x + matrix.c * y + matrix.tx : x, graphicsData.matrix ? matrix.b * x + matrix.d * y + matrix.ty : y), vertPos++, verts.push(points[0], points[1]);
        for(let i = 2; i < points.length; i += 2)verts.push(points[i], points[i + 1]), indices.push(vertPos++, center, vertPos);
        indices.push(center + 1, center, vertPos);
    }
};



function $f450577c45ecadd3$var$fixOrientation(points, hole = !1) {
    const m = points.length;
    if (m < 6) return;
    let area = 0;
    for(let i = 0, x1 = points[m - 2], y1 = points[m - 1]; i < m; i += 2){
        const x2 = points[i], y2 = points[i + 1];
        area += (x2 - x1) * (y2 + y1), x1 = x2, y1 = y2;
    }
    if (!hole && area > 0 || hole && area <= 0) {
        const n = m / 2;
        for(let i = n + n % 2; i < m; i += 2){
            const i1 = m - i - 2, i2 = m - i - 1, i3 = i, i4 = i + 1;
            [points[i1], points[i3]] = [
                points[i3],
                points[i1]
            ], [points[i2], points[i4]] = [
                points[i4],
                points[i2]
            ];
        }
    }
}
const $f450577c45ecadd3$export$7de1a57618f21e1f = {
    build (graphicsData) {
        graphicsData.points = graphicsData.shape.points.slice();
    },
    triangulate (graphicsData, graphicsGeometry) {
        let points = graphicsData.points;
        const holes = graphicsData.holes, verts = graphicsGeometry.points, indices = graphicsGeometry.indices;
        if (points.length >= 6) {
            $f450577c45ecadd3$var$fixOrientation(points, !1);
            const holeArray = [];
            for(let i = 0; i < holes.length; i++){
                const hole = holes[i];
                $f450577c45ecadd3$var$fixOrientation(hole.points, !0), holeArray.push(points.length / 2), points = points.concat(hole.points);
            }
            const triangles = (0, $db31fc3dfae4939b$exports).earcut(points, holeArray, 2);
            if (!triangles) return;
            const vertPos = verts.length / 2;
            for(let i = 0; i < triangles.length; i += 3)indices.push(triangles[i] + vertPos), indices.push(triangles[i + 1] + vertPos), indices.push(triangles[i + 2] + vertPos);
            for(let i = 0; i < points.length; i++)verts.push(points[i]);
        }
    }
};


const $e83822c3f394221c$export$cbe813d11f2192b2 = {
    build (graphicsData) {
        const rectData = graphicsData.shape, x = rectData.x, y = rectData.y, width = rectData.width, height = rectData.height, points = graphicsData.points;
        points.length = 0, width >= 0 && height >= 0 && points.push(x, y, x + width, y, x + width, y + height, x, y + height);
    },
    triangulate (graphicsData, graphicsGeometry) {
        const points = graphicsData.points, verts = graphicsGeometry.points;
        if (points.length === 0) return;
        const vertPos = verts.length / 2;
        verts.push(points[0], points[1], points[2], points[3], points[6], points[7], points[4], points[5]), graphicsGeometry.indices.push(vertPos, vertPos + 1, vertPos + 2, vertPos + 1, vertPos + 2, vertPos + 3);
    }
};



const $40bd08db6a5be367$export$4b54fce47d2ae7f4 = {
    build (graphicsData) {
        (0, $f71d82f68e674a31$export$a3541b2d8ecbfcf2).build(graphicsData);
    },
    triangulate (graphicsData, graphicsGeometry) {
        (0, $f71d82f68e674a31$export$a3541b2d8ecbfcf2).triangulate(graphicsData, graphicsGeometry);
    }
};



var $81b141585dec6314$export$c6a6e344be1302e7 = /* @__PURE__ */ ((LINE_JOIN2)=>(LINE_JOIN2.MITER = "miter", LINE_JOIN2.BEVEL = "bevel", LINE_JOIN2.ROUND = "round", LINE_JOIN2))($81b141585dec6314$export$c6a6e344be1302e7 || {}), $81b141585dec6314$export$b113e22c48c75d2e = /* @__PURE__ */ ((LINE_CAP2)=>(LINE_CAP2.BUTT = "butt", LINE_CAP2.ROUND = "round", LINE_CAP2.SQUARE = "square", LINE_CAP2))($81b141585dec6314$export$b113e22c48c75d2e || {});
const $81b141585dec6314$export$6894093bf294bea5 = {
    adaptive: !0,
    maxLength: 10,
    minSegments: 8,
    maxSegments: 2048,
    epsilon: 1e-4,
    _segmentsCount (length, defaultSegments = 20) {
        if (!this.adaptive || !length || isNaN(length)) return defaultSegments;
        let result = Math.ceil(length / this.maxLength);
        return result < this.minSegments ? result = this.minSegments : result > this.maxSegments && (result = this.maxSegments), result;
    }
}, $81b141585dec6314$export$8331f8d2be429f2c = $81b141585dec6314$export$6894093bf294bea5;


class $3562e10fcd414675$export$e6c43ec4db262573 {
    /**
   * Calculate information of the arc for {@link PIXI.Graphics.arcTo}.
   * @private
   * @param x1 - The x-coordinate of the first control point of the arc
   * @param y1 - The y-coordinate of the first control point of the arc
   * @param x2 - The x-coordinate of the second control point of the arc
   * @param y2 - The y-coordinate of the second control point of the arc
   * @param radius - The radius of the arc
   * @param points - Collection of points to add to
   * @returns - If the arc length is valid, return center of circle, radius and other info otherwise `null`.
   */ static curveTo(x1, y1, x2, y2, radius, points) {
        const fromX = points[points.length - 2], a1 = points[points.length - 1] - y1, b1 = fromX - x1, a2 = y2 - y1, b2 = x2 - x1, mm = Math.abs(a1 * b2 - b1 * a2);
        if (mm < 1e-8 || radius === 0) return (points[points.length - 2] !== x1 || points[points.length - 1] !== y1) && points.push(x1, y1), null;
        const dd = a1 * a1 + b1 * b1, cc = a2 * a2 + b2 * b2, tt = a1 * a2 + b1 * b2, k1 = radius * Math.sqrt(dd) / mm, k2 = radius * Math.sqrt(cc) / mm, j1 = k1 * tt / dd, j2 = k2 * tt / cc, cx = k1 * b2 + k2 * b1, cy = k1 * a2 + k2 * a1, px = b1 * (k2 + j1), py = a1 * (k2 + j1), qx = b2 * (k1 + j2), qy = a2 * (k1 + j2), startAngle = Math.atan2(py - cy, px - cx), endAngle = Math.atan2(qy - cy, qx - cx);
        return {
            cx: cx + x1,
            cy: cy + y1,
            radius: radius,
            startAngle: startAngle,
            endAngle: endAngle,
            anticlockwise: b1 * a2 > b2 * a1
        };
    }
    /**
   * The arc method creates an arc/curve (used to create circles, or parts of circles).
   * @private
   * @param _startX - Start x location of arc
   * @param _startY - Start y location of arc
   * @param cx - The x-coordinate of the center of the circle
   * @param cy - The y-coordinate of the center of the circle
   * @param radius - The radius of the circle
   * @param startAngle - The starting angle, in radians (0 is at the 3 o'clock position
   *  of the arc's circle)
   * @param endAngle - The ending angle, in radians
   * @param _anticlockwise - Specifies whether the drawing should be
   *  counter-clockwise or clockwise. False is default, and indicates clockwise, while true
   *  indicates counter-clockwise.
   * @param points - Collection of points to add to
   */ static arc(_startX, _startY, cx, cy, radius, startAngle, endAngle, _anticlockwise, points) {
        const sweep = endAngle - startAngle, n = (0, $81b141585dec6314$export$6894093bf294bea5)._segmentsCount(Math.abs(sweep) * radius, Math.ceil(Math.abs(sweep) / (0, $e51f17ddb17db7b9$export$59ed0a0a5de1084b)) * 40), theta = sweep / (n * 2), theta2 = theta * 2, cTheta = Math.cos(theta), sTheta = Math.sin(theta), segMinus = n - 1, remainder = segMinus % 1 / segMinus;
        for(let i = 0; i <= segMinus; ++i){
            const real = i + remainder * i, angle = theta + startAngle + theta2 * real, c = Math.cos(angle), s = -Math.sin(angle);
            points.push((cTheta * c + sTheta * s) * radius + cx, (cTheta * -s + sTheta * c) * radius + cy);
        }
    }
}


class $75d55c217e234cb6$export$3abbb88a93faeec2 {
    constructor(){
        this.reset();
    }
    /**
   * Begin batch part.
   * @param style
   * @param startIndex
   * @param attribStart
   */ begin(style, startIndex, attribStart) {
        this.reset(), this.style = style, this.start = startIndex, this.attribStart = attribStart;
    }
    /**
   * End batch part.
   * @param endIndex
   * @param endAttrib
   */ end(endIndex, endAttrib) {
        this.attribSize = endAttrib - this.attribStart, this.size = endIndex - this.start;
    }
    reset() {
        this.style = null, this.size = 0, this.start = 0, this.attribStart = 0, this.attribSize = 0;
    }
}



class $cf49506e28d24ed4$export$994e59e1556c01e9 {
    /**
   * Calculate length of bezier curve.
   * Analytical solution is impossible, since it involves an integral that does not integrate in general.
   * Therefore numerical solution is used.
   * @private
   * @param fromX - Starting point x
   * @param fromY - Starting point y
   * @param cpX - Control point x
   * @param cpY - Control point y
   * @param cpX2 - Second Control point x
   * @param cpY2 - Second Control point y
   * @param toX - Destination point x
   * @param toY - Destination point y
   * @returns - Length of bezier curve
   */ static curveLength(fromX, fromY, cpX, cpY, cpX2, cpY2, toX, toY) {
        let result = 0, t = 0, t2 = 0, t3 = 0, nt = 0, nt2 = 0, nt3 = 0, x = 0, y = 0, dx = 0, dy = 0, prevX = fromX, prevY = fromY;
        for(let i = 1; i <= 10; ++i)t = i / 10, t2 = t * t, t3 = t2 * t, nt = 1 - t, nt2 = nt * nt, nt3 = nt2 * nt, x = nt3 * fromX + 3 * nt2 * t * cpX + 3 * nt * t2 * cpX2 + t3 * toX, y = nt3 * fromY + 3 * nt2 * t * cpY + 3 * nt * t2 * cpY2 + t3 * toY, dx = prevX - x, dy = prevY - y, prevX = x, prevY = y, result += Math.sqrt(dx * dx + dy * dy);
        return result;
    }
    /**
   * Calculate the points for a bezier curve and then draws it.
   *
   * Ignored from docs since it is not directly exposed.
   * @ignore
   * @param cpX - Control point x
   * @param cpY - Control point y
   * @param cpX2 - Second Control point x
   * @param cpY2 - Second Control point y
   * @param toX - Destination point x
   * @param toY - Destination point y
   * @param points - Path array to push points into
   */ static curveTo(cpX, cpY, cpX2, cpY2, toX, toY, points) {
        const fromX = points[points.length - 2], fromY = points[points.length - 1];
        points.length -= 2;
        const n = (0, $81b141585dec6314$export$6894093bf294bea5)._segmentsCount($cf49506e28d24ed4$export$994e59e1556c01e9.curveLength(fromX, fromY, cpX, cpY, cpX2, cpY2, toX, toY));
        let dt = 0, dt2 = 0, dt3 = 0, t2 = 0, t3 = 0;
        points.push(fromX, fromY);
        for(let i = 1, j = 0; i <= n; ++i)j = i / n, dt = 1 - j, dt2 = dt * dt, dt3 = dt2 * dt, t2 = j * j, t3 = t2 * j, points.push(dt3 * fromX + 3 * dt2 * j * cpX + 3 * dt * t2 * cpX2 + t3 * toX, dt3 * fromY + 3 * dt2 * j * cpY + 3 * dt * t2 * cpY2 + t3 * toY);
    }
}




function $7c547149d5ee39e0$var$square(x, y, nx, ny, innerWeight, outerWeight, clockwise, verts) {
    const ix = x - nx * innerWeight, iy = y - ny * innerWeight, ox = x + nx * outerWeight, oy = y + ny * outerWeight;
    let exx, eyy;
    clockwise ? (exx = ny, eyy = -nx) : (exx = -ny, eyy = nx);
    const eix = ix + exx, eiy = iy + eyy, eox = ox + exx, eoy = oy + eyy;
    return verts.push(eix, eiy, eox, eoy), 2;
}
function $7c547149d5ee39e0$var$round(cx, cy, sx, sy, ex, ey, verts, clockwise) {
    const cx2p0x = sx - cx, cy2p0y = sy - cy;
    let angle0 = Math.atan2(cx2p0x, cy2p0y), angle1 = Math.atan2(ex - cx, ey - cy);
    clockwise && angle0 < angle1 ? angle0 += Math.PI * 2 : !clockwise && angle0 > angle1 && (angle1 += Math.PI * 2);
    let startAngle = angle0;
    const angleDiff = angle1 - angle0, absAngleDiff = Math.abs(angleDiff), radius = Math.sqrt(cx2p0x * cx2p0x + cy2p0y * cy2p0y), segCount = (15 * absAngleDiff * Math.sqrt(radius) / Math.PI >> 0) + 1, angleInc = angleDiff / segCount;
    if (startAngle += angleInc, clockwise) {
        verts.push(cx, cy, sx, sy);
        for(let i = 1, angle = startAngle; i < segCount; i++, angle += angleInc)verts.push(cx, cy, cx + Math.sin(angle) * radius, cy + Math.cos(angle) * radius);
        verts.push(cx, cy, ex, ey);
    } else {
        verts.push(sx, sy, cx, cy);
        for(let i = 1, angle = startAngle; i < segCount; i++, angle += angleInc)verts.push(cx + Math.sin(angle) * radius, cy + Math.cos(angle) * radius, cx, cy);
        verts.push(ex, ey, cx, cy);
    }
    return segCount * 2;
}
function $7c547149d5ee39e0$var$buildNonNativeLine(graphicsData, graphicsGeometry) {
    const shape = graphicsData.shape;
    let points = graphicsData.points || shape.points.slice();
    const eps = graphicsGeometry.closePointEps;
    if (points.length === 0) return;
    const style = graphicsData.lineStyle, firstPoint = new (0, $cf3018b4309864c2$export$baf26146a414f24a)(points[0], points[1]), lastPoint = new (0, $cf3018b4309864c2$export$baf26146a414f24a)(points[points.length - 2], points[points.length - 1]), closedShape = shape.type !== (0, $e51f17ddb17db7b9$export$511e1d54a4a8684e).POLY || shape.closeStroke, closedPath = Math.abs(firstPoint.x - lastPoint.x) < eps && Math.abs(firstPoint.y - lastPoint.y) < eps;
    if (closedShape) {
        points = points.slice(), closedPath && (points.pop(), points.pop(), lastPoint.set(points[points.length - 2], points[points.length - 1]));
        const midPointX = (firstPoint.x + lastPoint.x) * 0.5, midPointY = (lastPoint.y + firstPoint.y) * 0.5;
        points.unshift(midPointX, midPointY), points.push(midPointX, midPointY);
    }
    const verts = graphicsGeometry.points, length = points.length / 2;
    let indexCount = points.length;
    const indexStart = verts.length / 2, width = style.width / 2, widthSquared = width * width, miterLimitSquared = style.miterLimit * style.miterLimit;
    let x0 = points[0], y0 = points[1], x1 = points[2], y1 = points[3], x2 = 0, y2 = 0, perpx = -(y0 - y1), perpy = x0 - x1, perp1x = 0, perp1y = 0, dist = Math.sqrt(perpx * perpx + perpy * perpy);
    perpx /= dist, perpy /= dist, perpx *= width, perpy *= width;
    const ratio = style.alignment, innerWeight = (1 - ratio) * 2, outerWeight = ratio * 2;
    closedShape || (style.cap === (0, $81b141585dec6314$export$b113e22c48c75d2e).ROUND ? indexCount += $7c547149d5ee39e0$var$round(x0 - perpx * (innerWeight - outerWeight) * 0.5, y0 - perpy * (innerWeight - outerWeight) * 0.5, x0 - perpx * innerWeight, y0 - perpy * innerWeight, x0 + perpx * outerWeight, y0 + perpy * outerWeight, verts, !0) + 2 : style.cap === (0, $81b141585dec6314$export$b113e22c48c75d2e).SQUARE && (indexCount += $7c547149d5ee39e0$var$square(x0, y0, perpx, perpy, innerWeight, outerWeight, !0, verts))), verts.push(x0 - perpx * innerWeight, y0 - perpy * innerWeight, x0 + perpx * outerWeight, y0 + perpy * outerWeight);
    for(let i = 1; i < length - 1; ++i){
        x0 = points[(i - 1) * 2], y0 = points[(i - 1) * 2 + 1], x1 = points[i * 2], y1 = points[i * 2 + 1], x2 = points[(i + 1) * 2], y2 = points[(i + 1) * 2 + 1], perpx = -(y0 - y1), perpy = x0 - x1, dist = Math.sqrt(perpx * perpx + perpy * perpy), perpx /= dist, perpy /= dist, perpx *= width, perpy *= width, perp1x = -(y1 - y2), perp1y = x1 - x2, dist = Math.sqrt(perp1x * perp1x + perp1y * perp1y), perp1x /= dist, perp1y /= dist, perp1x *= width, perp1y *= width;
        const dx0 = x1 - x0, dy0 = y0 - y1, dx1 = x1 - x2, dy1 = y2 - y1, dot = dx0 * dx1 + dy0 * dy1, cross = dy0 * dx1 - dy1 * dx0, clockwise = cross < 0;
        if (Math.abs(cross) < 1e-3 * Math.abs(dot)) {
            verts.push(x1 - perpx * innerWeight, y1 - perpy * innerWeight, x1 + perpx * outerWeight, y1 + perpy * outerWeight), dot >= 0 && (style.join === (0, $81b141585dec6314$export$c6a6e344be1302e7).ROUND ? indexCount += $7c547149d5ee39e0$var$round(x1, y1, x1 - perpx * innerWeight, y1 - perpy * innerWeight, x1 - perp1x * innerWeight, y1 - perp1y * innerWeight, verts, !1) + 4 : indexCount += 2, verts.push(x1 - perp1x * outerWeight, y1 - perp1y * outerWeight, x1 + perp1x * innerWeight, y1 + perp1y * innerWeight));
            continue;
        }
        const c1 = (-perpx + x0) * (-perpy + y1) - (-perpx + x1) * (-perpy + y0), c2 = (-perp1x + x2) * (-perp1y + y1) - (-perp1x + x1) * (-perp1y + y2), px = (dx0 * c2 - dx1 * c1) / cross, py = (dy1 * c1 - dy0 * c2) / cross, pdist = (px - x1) * (px - x1) + (py - y1) * (py - y1), imx = x1 + (px - x1) * innerWeight, imy = y1 + (py - y1) * innerWeight, omx = x1 - (px - x1) * outerWeight, omy = y1 - (py - y1) * outerWeight, smallerInsideSegmentSq = Math.min(dx0 * dx0 + dy0 * dy0, dx1 * dx1 + dy1 * dy1), insideWeight = clockwise ? innerWeight : outerWeight, smallerInsideDiagonalSq = smallerInsideSegmentSq + insideWeight * insideWeight * widthSquared, insideMiterOk = pdist <= smallerInsideDiagonalSq;
        let join = style.join;
        if (join === (0, $81b141585dec6314$export$c6a6e344be1302e7).MITER && pdist / widthSquared > miterLimitSquared && (join = (0, $81b141585dec6314$export$c6a6e344be1302e7).BEVEL), insideMiterOk) switch(join){
            case (0, $81b141585dec6314$export$c6a6e344be1302e7).MITER:
                verts.push(imx, imy, omx, omy);
                break;
            case (0, $81b141585dec6314$export$c6a6e344be1302e7).BEVEL:
                clockwise ? verts.push(imx, imy, // inner miter point
                x1 + perpx * outerWeight, y1 + perpy * outerWeight, // first segment's outer vertex
                imx, imy, // inner miter point
                x1 + perp1x * outerWeight, y1 + perp1y * outerWeight) : verts.push(x1 - perpx * innerWeight, y1 - perpy * innerWeight, // first segment's inner vertex
                omx, omy, // outer miter point
                x1 - perp1x * innerWeight, y1 - perp1y * innerWeight, // second segment's outer vertex
                omx, omy), indexCount += 2;
                break;
            case (0, $81b141585dec6314$export$c6a6e344be1302e7).ROUND:
                clockwise ? (verts.push(imx, imy, x1 + perpx * outerWeight, y1 + perpy * outerWeight), indexCount += $7c547149d5ee39e0$var$round(x1, y1, x1 + perpx * outerWeight, y1 + perpy * outerWeight, x1 + perp1x * outerWeight, y1 + perp1y * outerWeight, verts, !0) + 4, verts.push(imx, imy, x1 + perp1x * outerWeight, y1 + perp1y * outerWeight)) : (verts.push(x1 - perpx * innerWeight, y1 - perpy * innerWeight, omx, omy), indexCount += $7c547149d5ee39e0$var$round(x1, y1, x1 - perpx * innerWeight, y1 - perpy * innerWeight, x1 - perp1x * innerWeight, y1 - perp1y * innerWeight, verts, !1) + 4, verts.push(x1 - perp1x * innerWeight, y1 - perp1y * innerWeight, omx, omy));
                break;
        }
        else {
            switch(verts.push(x1 - perpx * innerWeight, y1 - perpy * innerWeight, // first segment's inner vertex
            x1 + perpx * outerWeight, y1 + perpy * outerWeight), join){
                case (0, $81b141585dec6314$export$c6a6e344be1302e7).MITER:
                    clockwise ? verts.push(omx, omy, // inner miter point
                    omx, omy) : verts.push(imx, imy, // outer miter point
                    imx, imy), indexCount += 2;
                    break;
                case (0, $81b141585dec6314$export$c6a6e344be1302e7).ROUND:
                    clockwise ? indexCount += $7c547149d5ee39e0$var$round(x1, y1, x1 + perpx * outerWeight, y1 + perpy * outerWeight, x1 + perp1x * outerWeight, y1 + perp1y * outerWeight, verts, !0) + 2 : indexCount += $7c547149d5ee39e0$var$round(x1, y1, x1 - perpx * innerWeight, y1 - perpy * innerWeight, x1 - perp1x * innerWeight, y1 - perp1y * innerWeight, verts, !1) + 2;
                    break;
            }
            verts.push(x1 - perp1x * innerWeight, y1 - perp1y * innerWeight, // second segment's inner vertex
            x1 + perp1x * outerWeight, y1 + perp1y * outerWeight), indexCount += 2;
        }
    }
    x0 = points[(length - 2) * 2], y0 = points[(length - 2) * 2 + 1], x1 = points[(length - 1) * 2], y1 = points[(length - 1) * 2 + 1], perpx = -(y0 - y1), perpy = x0 - x1, dist = Math.sqrt(perpx * perpx + perpy * perpy), perpx /= dist, perpy /= dist, perpx *= width, perpy *= width, verts.push(x1 - perpx * innerWeight, y1 - perpy * innerWeight, x1 + perpx * outerWeight, y1 + perpy * outerWeight), closedShape || (style.cap === (0, $81b141585dec6314$export$b113e22c48c75d2e).ROUND ? indexCount += $7c547149d5ee39e0$var$round(x1 - perpx * (innerWeight - outerWeight) * 0.5, y1 - perpy * (innerWeight - outerWeight) * 0.5, x1 - perpx * innerWeight, y1 - perpy * innerWeight, x1 + perpx * outerWeight, y1 + perpy * outerWeight, verts, !1) + 2 : style.cap === (0, $81b141585dec6314$export$b113e22c48c75d2e).SQUARE && (indexCount += $7c547149d5ee39e0$var$square(x1, y1, perpx, perpy, innerWeight, outerWeight, !1, verts)));
    const indices = graphicsGeometry.indices, eps2 = (0, $81b141585dec6314$export$6894093bf294bea5).epsilon * (0, $81b141585dec6314$export$6894093bf294bea5).epsilon;
    for(let i = indexStart; i < indexCount + indexStart - 2; ++i)x0 = verts[i * 2], y0 = verts[i * 2 + 1], x1 = verts[(i + 1) * 2], y1 = verts[(i + 1) * 2 + 1], x2 = verts[(i + 2) * 2], y2 = verts[(i + 2) * 2 + 1], !(Math.abs(x0 * (y1 - y2) + x1 * (y2 - y0) + x2 * (y0 - y1)) < eps2) && indices.push(i, i + 1, i + 2);
}
function $7c547149d5ee39e0$var$buildNativeLine(graphicsData, graphicsGeometry) {
    let i = 0;
    const shape = graphicsData.shape, points = graphicsData.points || shape.points, closedShape = shape.type !== (0, $e51f17ddb17db7b9$export$511e1d54a4a8684e).POLY || shape.closeStroke;
    if (points.length === 0) return;
    const verts = graphicsGeometry.points, indices = graphicsGeometry.indices, length = points.length / 2, startIndex = verts.length / 2;
    let currentIndex = startIndex;
    for(verts.push(points[0], points[1]), i = 1; i < length; i++)verts.push(points[i * 2], points[i * 2 + 1]), indices.push(currentIndex, currentIndex + 1), currentIndex++;
    closedShape && indices.push(currentIndex, startIndex);
}
function $7c547149d5ee39e0$export$45986ccf08e93b0b(graphicsData, graphicsGeometry) {
    graphicsData.lineStyle.native ? $7c547149d5ee39e0$var$buildNativeLine(graphicsData, graphicsGeometry) : $7c547149d5ee39e0$var$buildNonNativeLine(graphicsData, graphicsGeometry);
}



class $e761c398f91aa887$export$616649c7d4fcacf2 {
    /**
   * Calculate length of quadratic curve
   * @see {@link http://www.malczak.linuxpl.com/blog/quadratic-bezier-curve-length/}
   * for the detailed explanation of math behind this.
   * @private
   * @param fromX - x-coordinate of curve start point
   * @param fromY - y-coordinate of curve start point
   * @param cpX - x-coordinate of curve control point
   * @param cpY - y-coordinate of curve control point
   * @param toX - x-coordinate of curve end point
   * @param toY - y-coordinate of curve end point
   * @returns - Length of quadratic curve
   */ static curveLength(fromX, fromY, cpX, cpY, toX, toY) {
        const ax = fromX - 2 * cpX + toX, ay = fromY - 2 * cpY + toY, bx = 2 * cpX - 2 * fromX, by = 2 * cpY - 2 * fromY, a = 4 * (ax * ax + ay * ay), b = 4 * (ax * bx + ay * by), c = bx * bx + by * by, s = 2 * Math.sqrt(a + b + c), a2 = Math.sqrt(a), a32 = 2 * a * a2, c2 = 2 * Math.sqrt(c), ba = b / a2;
        return (a32 * s + a2 * b * (s - c2) + (4 * c * a - b * b) * Math.log((2 * a2 + ba + s) / (ba + c2))) / (4 * a32);
    }
    /**
   * Calculate the points for a quadratic bezier curve and then draws it.
   * Based on: https://stackoverflow.com/questions/785097/how-do-i-implement-a-bezier-curve-in-c
   * @private
   * @param cpX - Control point x
   * @param cpY - Control point y
   * @param toX - Destination point x
   * @param toY - Destination point y
   * @param points - Points to add segments to.
   */ static curveTo(cpX, cpY, toX, toY, points) {
        const fromX = points[points.length - 2], fromY = points[points.length - 1], n = (0, $81b141585dec6314$export$6894093bf294bea5)._segmentsCount($e761c398f91aa887$export$616649c7d4fcacf2.curveLength(fromX, fromY, cpX, cpY, toX, toY));
        let xa = 0, ya = 0;
        for(let i = 1; i <= n; ++i){
            const j = i / n;
            xa = fromX + (cpX - fromX) * j, ya = fromY + (cpY - fromY) * j, points.push(xa + (cpX + (toX - cpX) * j - xa) * j, ya + (cpY + (toY - cpY) * j - ya) * j);
        }
    }
}


const $2334e14b6fd79541$export$b738057f7c88a634 = {
    [(0, $e51f17ddb17db7b9$export$511e1d54a4a8684e).POLY]: (0, $f450577c45ecadd3$export$7de1a57618f21e1f),
    [(0, $e51f17ddb17db7b9$export$511e1d54a4a8684e).CIRC]: (0, $f71d82f68e674a31$export$a3541b2d8ecbfcf2),
    [(0, $e51f17ddb17db7b9$export$511e1d54a4a8684e).ELIP]: (0, $f71d82f68e674a31$export$a3541b2d8ecbfcf2),
    [(0, $e51f17ddb17db7b9$export$511e1d54a4a8684e).RECT]: (0, $e83822c3f394221c$export$cbe813d11f2192b2),
    [(0, $e51f17ddb17db7b9$export$511e1d54a4a8684e).RREC]: (0, $40bd08db6a5be367$export$4b54fce47d2ae7f4)
}, $2334e14b6fd79541$export$78aca0cfc72b8d6 = [], $2334e14b6fd79541$export$e520c68c6872beed = [];








class $48557fa3c725274f$export$94accce0eb494446 {
    /**
   * @param {PIXI.Circle|PIXI.Ellipse|PIXI.Polygon|PIXI.Rectangle|PIXI.RoundedRectangle} shape - The shape object to draw.
   * @param fillStyle - the width of the line to draw
   * @param lineStyle - the color of the line to draw
   * @param matrix - Transform matrix
   */ constructor(shape, fillStyle = null, lineStyle = null, matrix = null){
        this.points = [], this.holes = [], this.shape = shape, this.lineStyle = lineStyle, this.fillStyle = fillStyle, this.matrix = matrix, this.type = shape.type;
    }
    /**
   * Creates a new GraphicsData object with the same values as this one.
   * @returns - Cloned GraphicsData object
   */ clone() {
        return new $48557fa3c725274f$export$94accce0eb494446(this.shape, this.fillStyle, this.lineStyle, this.matrix);
    }
    /** Destroys the Graphics data. */ destroy() {
        this.shape = null, this.holes.length = 0, this.holes = null, this.points.length = 0, this.points = null, this.lineStyle = null, this.fillStyle = null;
    }
}






const $0aa553924edd94e7$var$tmpPoint = new (0, $cf3018b4309864c2$export$baf26146a414f24a)(), $0aa553924edd94e7$var$_GraphicsGeometry = class _GraphicsGeometry2 extends (0, $8ffbe4cd828c4ebe$export$449e8d355fd68e43) {
    // eslint-disable-next-line @typescript-eslint/no-useless-constructor
    constructor(){
        super(), this.closePointEps = 1e-4, this.boundsPadding = 0, this.uvsFloat32 = null, this.indicesUint16 = null, this.batchable = !1, this.points = [], this.colors = [], this.uvs = [], this.indices = [], this.textureIds = [], this.graphicsData = [], this.drawCalls = [], this.batchDirty = -1, this.batches = [], this.dirty = 0, this.cacheDirty = -1, this.clearDirty = 0, this.shapeIndex = 0, this._bounds = new (0, $816971236b5d7d99$export$c4e9d269599ab4b4)(), this.boundsDirty = -1;
    }
    /**
   * Get the current bounds of the graphic geometry.
   *
   * Since 6.5.0, bounds of the graphics geometry are calculated based on the vertices of generated geometry.
   * Since shapes or strokes with full transparency (`alpha: 0`) will not generate geometry, they are not considered
   * when calculating bounds for the graphics geometry. See PR [#8343]{@link https://github.com/pixijs/pixijs/pull/8343}
   * and issue [#8623]{@link https://github.com/pixijs/pixijs/pull/8623}.
   * @readonly
   */ get bounds() {
        return this.updateBatches(), this.boundsDirty !== this.dirty && (this.boundsDirty = this.dirty, this.calculateBounds()), this._bounds;
    }
    /** Call if you changed graphicsData manually. Empties all batch buffers. */ invalidate() {
        this.boundsDirty = -1, this.dirty++, this.batchDirty++, this.shapeIndex = 0, this.points.length = 0, this.colors.length = 0, this.uvs.length = 0, this.indices.length = 0, this.textureIds.length = 0;
        for(let i = 0; i < this.drawCalls.length; i++)this.drawCalls[i].texArray.clear(), (0, $2334e14b6fd79541$export$e520c68c6872beed).push(this.drawCalls[i]);
        this.drawCalls.length = 0;
        for(let i = 0; i < this.batches.length; i++){
            const batchPart = this.batches[i];
            batchPart.reset(), (0, $2334e14b6fd79541$export$78aca0cfc72b8d6).push(batchPart);
        }
        this.batches.length = 0;
    }
    /**
   * Clears the graphics that were drawn to this Graphics object, and resets fill and line style settings.
   * @returns - This GraphicsGeometry object. Good for chaining method calls
   */ clear() {
        return this.graphicsData.length > 0 && (this.invalidate(), this.clearDirty++, this.graphicsData.length = 0), this;
    }
    /**
   * Draws the given shape to this Graphics object. Can be any of Circle, Rectangle, Ellipse, Line or Polygon.
   * @param {PIXI.Circle|PIXI.Ellipse|PIXI.Polygon|PIXI.Rectangle|PIXI.RoundedRectangle} shape - The shape object to draw.
   * @param fillStyle - Defines style of the fill.
   * @param lineStyle - Defines style of the lines.
   * @param matrix - Transform applied to the points of the shape.
   * @returns - Returns geometry for chaining.
   */ drawShape(shape, fillStyle = null, lineStyle = null, matrix = null) {
        const data = new (0, $48557fa3c725274f$export$94accce0eb494446)(shape, fillStyle, lineStyle, matrix);
        return this.graphicsData.push(data), this.dirty++, this;
    }
    /**
   * Draws the given shape to this Graphics object. Can be any of Circle, Rectangle, Ellipse, Line or Polygon.
   * @param {PIXI.Circle|PIXI.Ellipse|PIXI.Polygon|PIXI.Rectangle|PIXI.RoundedRectangle} shape - The shape object to draw.
   * @param matrix - Transform applied to the points of the shape.
   * @returns - Returns geometry for chaining.
   */ drawHole(shape, matrix = null) {
        if (!this.graphicsData.length) return null;
        const data = new (0, $48557fa3c725274f$export$94accce0eb494446)(shape, null, null, matrix), lastShape = this.graphicsData[this.graphicsData.length - 1];
        return data.lineStyle = lastShape.lineStyle, lastShape.holes.push(data), this.dirty++, this;
    }
    /** Destroys the GraphicsGeometry object. */ destroy() {
        super.destroy();
        for(let i = 0; i < this.graphicsData.length; ++i)this.graphicsData[i].destroy();
        this.points.length = 0, this.points = null, this.colors.length = 0, this.colors = null, this.uvs.length = 0, this.uvs = null, this.indices.length = 0, this.indices = null, this.indexBuffer.destroy(), this.indexBuffer = null, this.graphicsData.length = 0, this.graphicsData = null, this.drawCalls.length = 0, this.drawCalls = null, this.batches.length = 0, this.batches = null, this._bounds = null;
    }
    /**
   * Check to see if a point is contained within this geometry.
   * @param point - Point to check if it's contained.
   * @returns {boolean} `true` if the point is contained within geometry.
   */ containsPoint(point) {
        const graphicsData = this.graphicsData;
        for(let i = 0; i < graphicsData.length; ++i){
            const data = graphicsData[i];
            if (data.fillStyle.visible && data.shape && (data.matrix ? data.matrix.applyInverse(point, $0aa553924edd94e7$var$tmpPoint) : $0aa553924edd94e7$var$tmpPoint.copyFrom(point), data.shape.contains($0aa553924edd94e7$var$tmpPoint.x, $0aa553924edd94e7$var$tmpPoint.y))) {
                let hitHole = !1;
                if (data.holes) {
                    for(let i2 = 0; i2 < data.holes.length; i2++)if (data.holes[i2].shape.contains($0aa553924edd94e7$var$tmpPoint.x, $0aa553924edd94e7$var$tmpPoint.y)) {
                        hitHole = !0;
                        break;
                    }
                }
                if (!hitHole) return !0;
            }
        }
        return !1;
    }
    /**
   * Generates intermediate batch data. Either gets converted to drawCalls
   * or used to convert to batch objects directly by the Graphics object.
   */ updateBatches() {
        if (!this.graphicsData.length) {
            this.batchable = !0;
            return;
        }
        if (!this.validateBatching()) return;
        this.cacheDirty = this.dirty;
        const uvs = this.uvs, graphicsData = this.graphicsData;
        let batchPart = null, currentStyle = null;
        this.batches.length > 0 && (batchPart = this.batches[this.batches.length - 1], currentStyle = batchPart.style);
        for(let i = this.shapeIndex; i < graphicsData.length; i++){
            this.shapeIndex++;
            const data = graphicsData[i], fillStyle = data.fillStyle, lineStyle = data.lineStyle;
            (0, $2334e14b6fd79541$export$b738057f7c88a634)[data.type].build(data), data.matrix && this.transformPoints(data.points, data.matrix), (fillStyle.visible || lineStyle.visible) && this.processHoles(data.holes);
            for(let j = 0; j < 2; j++){
                const style = j === 0 ? fillStyle : lineStyle;
                if (!style.visible) continue;
                const nextTexture = style.texture.baseTexture, index2 = this.indices.length, attribIndex = this.points.length / 2;
                nextTexture.wrapMode = (0, $0fa4b07f86297abd$export$2ab395cfb0dd2f0f).REPEAT, j === 0 ? this.processFill(data) : this.processLine(data);
                const size = this.points.length / 2 - attribIndex;
                size !== 0 && (batchPart && !this._compareStyles(currentStyle, style) && (batchPart.end(index2, attribIndex), batchPart = null), batchPart || (batchPart = (0, $2334e14b6fd79541$export$78aca0cfc72b8d6).pop() || new (0, $75d55c217e234cb6$export$3abbb88a93faeec2)(), batchPart.begin(style, index2, attribIndex), this.batches.push(batchPart), currentStyle = style), this.addUvs(this.points, uvs, style.texture, attribIndex, size, style.matrix));
            }
        }
        const index = this.indices.length, attrib = this.points.length / 2;
        if (batchPart && batchPart.end(index, attrib), this.batches.length === 0) {
            this.batchable = !0;
            return;
        }
        const need32 = attrib > 65535;
        this.indicesUint16 && this.indices.length === this.indicesUint16.length && need32 === this.indicesUint16.BYTES_PER_ELEMENT > 2 ? this.indicesUint16.set(this.indices) : this.indicesUint16 = need32 ? new Uint32Array(this.indices) : new Uint16Array(this.indices), this.batchable = this.isBatchable(), this.batchable ? this.packBatches() : this.buildDrawCalls();
    }
    /**
   * Affinity check
   * @param styleA
   * @param styleB
   */ _compareStyles(styleA, styleB) {
        return !(!styleA || !styleB || styleA.texture.baseTexture !== styleB.texture.baseTexture || styleA.color + styleA.alpha !== styleB.color + styleB.alpha || !!styleA.native != !!styleB.native);
    }
    /** Test geometry for batching process. */ validateBatching() {
        if (this.dirty === this.cacheDirty || !this.graphicsData.length) return !1;
        for(let i = 0, l = this.graphicsData.length; i < l; i++){
            const data = this.graphicsData[i], fill = data.fillStyle, line = data.lineStyle;
            if (fill && !fill.texture.baseTexture.valid || line && !line.texture.baseTexture.valid) return !1;
        }
        return !0;
    }
    /** Offset the indices so that it works with the batcher. */ packBatches() {
        this.batchDirty++, this.uvsFloat32 = new Float32Array(this.uvs);
        const batches = this.batches;
        for(let i = 0, l = batches.length; i < l; i++){
            const batch = batches[i];
            for(let j = 0; j < batch.size; j++){
                const index = batch.start + j;
                this.indicesUint16[index] = this.indicesUint16[index] - batch.attribStart;
            }
        }
    }
    /**
   * Checks to see if this graphics geometry can be batched.
   * Currently it needs to be small enough and not contain any native lines.
   */ isBatchable() {
        if (this.points.length > 131070) return !1;
        const batches = this.batches;
        for(let i = 0; i < batches.length; i++)if (batches[i].style.native) return !1;
        return this.points.length < _GraphicsGeometry2.BATCHABLE_SIZE * 2;
    }
    /** Converts intermediate batches data to drawCalls. */ buildDrawCalls() {
        let TICK = ++(0, $30c85657f0c625d5$export$d6306e508f184154)._globalBatch;
        for(let i = 0; i < this.drawCalls.length; i++)this.drawCalls[i].texArray.clear(), (0, $2334e14b6fd79541$export$e520c68c6872beed).push(this.drawCalls[i]);
        this.drawCalls.length = 0;
        const colors = this.colors, textureIds = this.textureIds;
        let currentGroup = (0, $2334e14b6fd79541$export$e520c68c6872beed).pop();
        currentGroup || (currentGroup = new (0, $8e09e9037c380ee9$export$664fd198634fda29)(), currentGroup.texArray = new (0, $bafdb72a689df8b2$export$aa760e0febf1a758)()), currentGroup.texArray.count = 0, currentGroup.start = 0, currentGroup.size = 0, currentGroup.type = (0, $0fa4b07f86297abd$export$91100badd8469338).TRIANGLES;
        let textureCount = 0, currentTexture = null, textureId = 0, native = !1, drawMode = (0, $0fa4b07f86297abd$export$91100badd8469338).TRIANGLES, index = 0;
        this.drawCalls.push(currentGroup);
        for(let i = 0; i < this.batches.length; i++){
            const data = this.batches[i], maxTextures = 8, style = data.style, nextTexture = style.texture.baseTexture;
            native !== !!style.native && (native = !!style.native, drawMode = native ? (0, $0fa4b07f86297abd$export$91100badd8469338).LINES : (0, $0fa4b07f86297abd$export$91100badd8469338).TRIANGLES, currentTexture = null, textureCount = maxTextures, TICK++), currentTexture !== nextTexture && (currentTexture = nextTexture, nextTexture._batchEnabled !== TICK && (textureCount === maxTextures && (TICK++, textureCount = 0, currentGroup.size > 0 && (currentGroup = (0, $2334e14b6fd79541$export$e520c68c6872beed).pop(), currentGroup || (currentGroup = new (0, $8e09e9037c380ee9$export$664fd198634fda29)(), currentGroup.texArray = new (0, $bafdb72a689df8b2$export$aa760e0febf1a758)()), this.drawCalls.push(currentGroup)), currentGroup.start = index, currentGroup.size = 0, currentGroup.texArray.count = 0, currentGroup.type = drawMode), nextTexture.touched = 1, nextTexture._batchEnabled = TICK, nextTexture._batchLocation = textureCount, nextTexture.wrapMode = (0, $0fa4b07f86297abd$export$2ab395cfb0dd2f0f).REPEAT, currentGroup.texArray.elements[currentGroup.texArray.count++] = nextTexture, textureCount++)), currentGroup.size += data.size, index += data.size, textureId = nextTexture._batchLocation, this.addColors(colors, style.color, style.alpha, data.attribSize, data.attribStart), this.addTextureIds(textureIds, textureId, data.attribSize, data.attribStart);
        }
        (0, $30c85657f0c625d5$export$d6306e508f184154)._globalBatch = TICK, this.packAttributes();
    }
    /** Packs attributes to single buffer. */ packAttributes() {
        const verts = this.points, uvs = this.uvs, colors = this.colors, textureIds = this.textureIds, glPoints = new ArrayBuffer(verts.length * 12), f32 = new Float32Array(glPoints), u32 = new Uint32Array(glPoints);
        let p = 0;
        for(let i = 0; i < verts.length / 2; i++)f32[p++] = verts[i * 2], f32[p++] = verts[i * 2 + 1], f32[p++] = uvs[i * 2], f32[p++] = uvs[i * 2 + 1], u32[p++] = colors[i], f32[p++] = textureIds[i];
        this._buffer.update(glPoints), this._indexBuffer.update(this.indicesUint16);
    }
    /**
   * Process fill part of Graphics.
   * @param data
   */ processFill(data) {
        data.holes.length ? (0, $f450577c45ecadd3$export$7de1a57618f21e1f).triangulate(data, this) : (0, $2334e14b6fd79541$export$b738057f7c88a634)[data.type].triangulate(data, this);
    }
    /**
   * Process line part of Graphics.
   * @param data
   */ processLine(data) {
        (0, $7c547149d5ee39e0$export$45986ccf08e93b0b)(data, this);
        for(let i = 0; i < data.holes.length; i++)(0, $7c547149d5ee39e0$export$45986ccf08e93b0b)(data.holes[i], this);
    }
    /**
   * Process the holes data.
   * @param holes
   */ processHoles(holes) {
        for(let i = 0; i < holes.length; i++){
            const hole = holes[i];
            (0, $2334e14b6fd79541$export$b738057f7c88a634)[hole.type].build(hole), hole.matrix && this.transformPoints(hole.points, hole.matrix);
        }
    }
    /** Update the local bounds of the object. Expensive to use performance-wise. */ calculateBounds() {
        const bounds = this._bounds;
        bounds.clear(), bounds.addVertexData(this.points, 0, this.points.length), bounds.pad(this.boundsPadding, this.boundsPadding);
    }
    /**
   * Transform points using matrix.
   * @param points - Points to transform
   * @param matrix - Transform matrix
   */ transformPoints(points, matrix) {
        for(let i = 0; i < points.length / 2; i++){
            const x = points[i * 2], y = points[i * 2 + 1];
            points[i * 2] = matrix.a * x + matrix.c * y + matrix.tx, points[i * 2 + 1] = matrix.b * x + matrix.d * y + matrix.ty;
        }
    }
    /**
   * Add colors.
   * @param colors - List of colors to add to
   * @param color - Color to add
   * @param alpha - Alpha to use
   * @param size - Number of colors to add
   * @param offset
   */ addColors(colors, color, alpha, size, offset = 0) {
        const bgr = (0, $15154c33c9e19c5f$export$892596cec99bc70e).shared.setValue(color).toLittleEndianNumber(), result = (0, $15154c33c9e19c5f$export$892596cec99bc70e).shared.setValue(bgr).toPremultiplied(alpha);
        colors.length = Math.max(colors.length, offset + size);
        for(let i = 0; i < size; i++)colors[offset + i] = result;
    }
    /**
   * Add texture id that the shader/fragment wants to use.
   * @param textureIds
   * @param id
   * @param size
   * @param offset
   */ addTextureIds(textureIds, id, size, offset = 0) {
        textureIds.length = Math.max(textureIds.length, offset + size);
        for(let i = 0; i < size; i++)textureIds[offset + i] = id;
    }
    /**
   * Generates the UVs for a shape.
   * @param verts - Vertices
   * @param uvs - UVs
   * @param texture - Reference to Texture
   * @param start - Index buffer start index.
   * @param size - The size/length for index buffer.
   * @param matrix - Optional transform for all points.
   */ addUvs(verts, uvs, texture, start, size, matrix = null) {
        let index = 0;
        const uvsStart = uvs.length, frame = texture.frame;
        for(; index < size;){
            let x = verts[(start + index) * 2], y = verts[(start + index) * 2 + 1];
            if (matrix) {
                const nx = matrix.a * x + matrix.c * y + matrix.tx;
                y = matrix.b * x + matrix.d * y + matrix.ty, x = nx;
            }
            index++, uvs.push(x / frame.width, y / frame.height);
        }
        const baseTexture = texture.baseTexture;
        (frame.width < baseTexture.width || frame.height < baseTexture.height) && this.adjustUvs(uvs, texture, uvsStart, size);
    }
    /**
   * Modify uvs array according to position of texture region
   * Does not work with rotated or trimmed textures
   * @param uvs - array
   * @param texture - region
   * @param start - starting index for uvs
   * @param size - how many points to adjust
   */ adjustUvs(uvs, texture, start, size) {
        const baseTexture = texture.baseTexture, eps = 1e-6, finish = start + size * 2, frame = texture.frame, scaleX = frame.width / baseTexture.width, scaleY = frame.height / baseTexture.height;
        let offsetX = frame.x / frame.width, offsetY = frame.y / frame.height, minX = Math.floor(uvs[start] + eps), minY = Math.floor(uvs[start + 1] + eps);
        for(let i = start + 2; i < finish; i += 2)minX = Math.min(minX, Math.floor(uvs[i] + eps)), minY = Math.min(minY, Math.floor(uvs[i + 1] + eps));
        offsetX -= minX, offsetY -= minY;
        for(let i = start; i < finish; i += 2)uvs[i] = (uvs[i] + offsetX) * scaleX, uvs[i + 1] = (uvs[i + 1] + offsetY) * scaleY;
    }
};
$0aa553924edd94e7$var$_GraphicsGeometry.BATCHABLE_SIZE = 100;
let $0aa553924edd94e7$export$c707987b44ce3a12 = $0aa553924edd94e7$var$_GraphicsGeometry;



class $10996af849f67cfb$export$c42b166860ccdbd8 {
    constructor(){
        this.color = 16777215, this.alpha = 1, this.texture = (0, $14896914ad3ae15d$export$5431306cf43de24a).WHITE, this.matrix = null, this.visible = !1, this.reset();
    }
    /** Clones the object */ clone() {
        const obj = new $10996af849f67cfb$export$c42b166860ccdbd8();
        return obj.color = this.color, obj.alpha = this.alpha, obj.texture = this.texture, obj.matrix = this.matrix, obj.visible = this.visible, obj;
    }
    /** Reset */ reset() {
        this.color = 16777215, this.alpha = 1, this.texture = (0, $14896914ad3ae15d$export$5431306cf43de24a).WHITE, this.matrix = null, this.visible = !1;
    }
    /** Destroy and don't use after this. */ destroy() {
        this.texture = null, this.matrix = null;
    }
}




class $e6f408e74bfd1ff8$export$5d24e00cfde59887 extends (0, $10996af849f67cfb$export$c42b166860ccdbd8) {
    constructor(){
        super(...arguments), this.width = 0, this.alignment = 0.5, this.native = !1, this.cap = (0, $81b141585dec6314$export$b113e22c48c75d2e).BUTT, this.join = (0, $81b141585dec6314$export$c6a6e344be1302e7).MITER, this.miterLimit = 10;
    }
    /** Clones the object. */ clone() {
        const obj = new $e6f408e74bfd1ff8$export$5d24e00cfde59887();
        return obj.color = this.color, obj.alpha = this.alpha, obj.texture = this.texture, obj.matrix = this.matrix, obj.visible = this.visible, obj.width = this.width, obj.alignment = this.alignment, obj.native = this.native, obj.cap = this.cap, obj.join = this.join, obj.miterLimit = this.miterLimit, obj;
    }
    /** Reset the line style to default. */ reset() {
        super.reset(), this.color = 0, this.alignment = 0.5, this.width = 0, this.native = !1, this.cap = (0, $81b141585dec6314$export$b113e22c48c75d2e).BUTT, this.join = (0, $81b141585dec6314$export$c6a6e344be1302e7).MITER, this.miterLimit = 10;
    }
}






const $48ce8a7de6645907$var$DEFAULT_SHADERS = {}, $48ce8a7de6645907$var$_Graphics = class _Graphics2 extends (0, $68e6944de5989822$export$42a852a2b6b56249) {
    /**
   * @param geometry - Geometry to use, if omitted will create a new GraphicsGeometry instance.
   */ constructor(geometry = null){
        super(), this.shader = null, this.pluginName = "batch", this.currentPath = null, this.batches = [], this.batchTint = -1, this.batchDirty = -1, this.vertexData = null, this._fillStyle = new (0, $10996af849f67cfb$export$c42b166860ccdbd8)(), this._lineStyle = new (0, $e6f408e74bfd1ff8$export$5d24e00cfde59887)(), this._matrix = null, this._holeMode = !1, this.state = (0, $2b269c8c39349f63$export$7254cc27399e90bd).for2d(), this._geometry = geometry || new (0, $0aa553924edd94e7$export$c707987b44ce3a12)(), this._geometry.refCount++, this._transformID = -1, this._tintColor = new (0, $15154c33c9e19c5f$export$892596cec99bc70e)(16777215), this.blendMode = (0, $0fa4b07f86297abd$export$f821c68fe9beaecf).NORMAL;
    }
    /**
   * Includes vertex positions, face indices, normals, colors, UVs, and
   * custom attributes within buffers, reducing the cost of passing all
   * this data to the GPU. Can be shared between multiple Mesh or Graphics objects.
   * @readonly
   */ get geometry() {
        return this._geometry;
    }
    /**
   * Creates a new Graphics object with the same values as this one.
   * Note that only the geometry of the object is cloned, not its transform (position,scale,etc)
   * @returns - A clone of the graphics object
   */ clone() {
        return this.finishPoly(), new _Graphics2(this._geometry);
    }
    /**
   * The blend mode to be applied to the graphic shape. Apply a value of
   * `PIXI.BLEND_MODES.NORMAL` to reset the blend mode.  Note that, since each
   * primitive in the GraphicsGeometry list is rendered sequentially, modes
   * such as `PIXI.BLEND_MODES.ADD` and `PIXI.BLEND_MODES.MULTIPLY` will
   * be applied per-primitive.
   * @default PIXI.BLEND_MODES.NORMAL
   */ set blendMode(value) {
        this.state.blendMode = value;
    }
    get blendMode() {
        return this.state.blendMode;
    }
    /**
   * The tint applied to each graphic shape. This is a hex value. A value of
   * 0xFFFFFF will remove any tint effect.
   * @default 0xFFFFFF
   */ get tint() {
        return this._tintColor.value;
    }
    set tint(value) {
        this._tintColor.setValue(value);
    }
    /**
   * The current fill style.
   * @readonly
   */ get fill() {
        return this._fillStyle;
    }
    /**
   * The current line style.
   * @readonly
   */ get line() {
        return this._lineStyle;
    }
    lineStyle(options = null, color = 0, alpha, alignment = 0.5, native = !1) {
        return typeof options == "number" && (options = {
            width: options,
            color: color,
            alpha: alpha,
            alignment: alignment,
            native: native
        }), this.lineTextureStyle(options);
    }
    /**
   * Like line style but support texture for line fill.
   * @param [options] - Collection of options for setting line style.
   * @param {number} [options.width=0] - width of the line to draw, will update the objects stored style
   * @param {PIXI.Texture} [options.texture=PIXI.Texture.WHITE] - Texture to use
   * @param {PIXI.ColorSource} [options.color=0x0] - color of the line to draw, will update the objects stored style.
   *  Default 0xFFFFFF if texture present.
   * @param {number} [options.alpha=1] - alpha of the line to draw, will update the objects stored style
   * @param {PIXI.Matrix} [options.matrix=null] - Texture matrix to transform texture
   * @param {number} [options.alignment=0.5] - alignment of the line to draw, (0 = inner, 0.5 = middle, 1 = outer).
   *        WebGL only.
   * @param {boolean} [options.native=false] - If true the lines will be draw using LINES instead of TRIANGLE_STRIP
   * @param {PIXI.LINE_CAP}[options.cap=PIXI.LINE_CAP.BUTT] - line cap style
   * @param {PIXI.LINE_JOIN}[options.join=PIXI.LINE_JOIN.MITER] - line join style
   * @param {number}[options.miterLimit=10] - miter limit ratio
   * @returns {PIXI.Graphics} This Graphics object. Good for chaining method calls
   */ lineTextureStyle(options) {
        const defaultLineStyleOptions = {
            width: 0,
            texture: (0, $14896914ad3ae15d$export$5431306cf43de24a).WHITE,
            color: options?.texture ? 16777215 : 0,
            matrix: null,
            alignment: 0.5,
            native: !1,
            cap: (0, $81b141585dec6314$export$b113e22c48c75d2e).BUTT,
            join: (0, $81b141585dec6314$export$c6a6e344be1302e7).MITER,
            miterLimit: 10
        };
        options = Object.assign(defaultLineStyleOptions, options), this.normalizeColor(options), this.currentPath && this.startPoly();
        const visible = options.width > 0 && options.alpha > 0;
        return visible ? (options.matrix && (options.matrix = options.matrix.clone(), options.matrix.invert()), Object.assign(this._lineStyle, {
            visible: visible
        }, options)) : this._lineStyle.reset(), this;
    }
    /**
   * Start a polygon object internally.
   * @protected
   */ startPoly() {
        if (this.currentPath) {
            const points = this.currentPath.points, len = this.currentPath.points.length;
            len > 2 && (this.drawShape(this.currentPath), this.currentPath = new (0, $20fd44ea129d646b$export$7d31b617c820d435)(), this.currentPath.closeStroke = !1, this.currentPath.points.push(points[len - 2], points[len - 1]));
        } else this.currentPath = new (0, $20fd44ea129d646b$export$7d31b617c820d435)(), this.currentPath.closeStroke = !1;
    }
    /**
   * Finish the polygon object.
   * @protected
   */ finishPoly() {
        this.currentPath && (this.currentPath.points.length > 2 ? (this.drawShape(this.currentPath), this.currentPath = null) : this.currentPath.points.length = 0);
    }
    /**
   * Moves the current drawing position to x, y.
   * @param x - the X coordinate to move to
   * @param y - the Y coordinate to move to
   * @returns - This Graphics object. Good for chaining method calls
   */ moveTo(x, y) {
        return this.startPoly(), this.currentPath.points[0] = x, this.currentPath.points[1] = y, this;
    }
    /**
   * Draws a line using the current line style from the current drawing position to (x, y);
   * The current drawing position is then set to (x, y).
   * @param x - the X coordinate to draw to
   * @param y - the Y coordinate to draw to
   * @returns - This Graphics object. Good for chaining method calls
   */ lineTo(x, y) {
        this.currentPath || this.moveTo(0, 0);
        const points = this.currentPath.points, fromX = points[points.length - 2], fromY = points[points.length - 1];
        return (fromX !== x || fromY !== y) && points.push(x, y), this;
    }
    /**
   * Initialize the curve
   * @param x
   * @param y
   */ _initCurve(x = 0, y = 0) {
        this.currentPath ? this.currentPath.points.length === 0 && (this.currentPath.points = [
            x,
            y
        ]) : this.moveTo(x, y);
    }
    /**
   * Calculate the points for a quadratic bezier curve and then draws it.
   * Based on: https://stackoverflow.com/questions/785097/how-do-i-implement-a-bezier-curve-in-c
   * @param cpX - Control point x
   * @param cpY - Control point y
   * @param toX - Destination point x
   * @param toY - Destination point y
   * @returns - This Graphics object. Good for chaining method calls
   */ quadraticCurveTo(cpX, cpY, toX, toY) {
        this._initCurve();
        const points = this.currentPath.points;
        return points.length === 0 && this.moveTo(0, 0), (0, $e761c398f91aa887$export$616649c7d4fcacf2).curveTo(cpX, cpY, toX, toY, points), this;
    }
    /**
   * Calculate the points for a bezier curve and then draws it.
   * @param cpX - Control point x
   * @param cpY - Control point y
   * @param cpX2 - Second Control point x
   * @param cpY2 - Second Control point y
   * @param toX - Destination point x
   * @param toY - Destination point y
   * @returns This Graphics object. Good for chaining method calls
   */ bezierCurveTo(cpX, cpY, cpX2, cpY2, toX, toY) {
        return this._initCurve(), (0, $cf49506e28d24ed4$export$994e59e1556c01e9).curveTo(cpX, cpY, cpX2, cpY2, toX, toY, this.currentPath.points), this;
    }
    /**
   * The `arcTo` method creates an arc/curve between two tangents on the canvas.
   * The first tangent is from the start point to the first control point,
   * and the second tangent is from the first control point to the second control point.
   * Note that the second control point is not necessarily the end point of the arc.
   *
   * "borrowed" from https://code.google.com/p/fxcanvas/ - thanks google!
   * @param x1 - The x-coordinate of the first control point of the arc
   * @param y1 - The y-coordinate of the first control point of the arc
   * @param x2 - The x-coordinate of the second control point of the arc
   * @param y2 - The y-coordinate of the second control point of the arc
   * @param radius - The radius of the arc
   * @returns - This Graphics object. Good for chaining method calls
   */ arcTo(x1, y1, x2, y2, radius) {
        this._initCurve(x1, y1);
        const points = this.currentPath.points, result = (0, $3562e10fcd414675$export$e6c43ec4db262573).curveTo(x1, y1, x2, y2, radius, points);
        if (result) {
            const { cx: cx, cy: cy, radius: radius2, startAngle: startAngle, endAngle: endAngle, anticlockwise: anticlockwise } = result;
            this.arc(cx, cy, radius2, startAngle, endAngle, anticlockwise);
        }
        return this;
    }
    /**
   * The arc method creates an arc/curve (used to create circles, or parts of circles).
   * @param cx - The x-coordinate of the center of the circle
   * @param cy - The y-coordinate of the center of the circle
   * @param radius - The radius of the circle
   * @param startAngle - The starting angle, in radians (0 is at the 3 o'clock position
   *  of the arc's circle)
   * @param endAngle - The ending angle, in radians
   * @param anticlockwise - Specifies whether the drawing should be
   *  counter-clockwise or clockwise. False is default, and indicates clockwise, while true
   *  indicates counter-clockwise.
   * @returns - This Graphics object. Good for chaining method calls
   */ arc(cx, cy, radius, startAngle, endAngle, anticlockwise = !1) {
        if (startAngle === endAngle) return this;
        if (!anticlockwise && endAngle <= startAngle ? endAngle += (0, $e51f17ddb17db7b9$export$59ed0a0a5de1084b) : anticlockwise && startAngle <= endAngle && (startAngle += (0, $e51f17ddb17db7b9$export$59ed0a0a5de1084b)), endAngle - startAngle === 0) return this;
        const startX = cx + Math.cos(startAngle) * radius, startY = cy + Math.sin(startAngle) * radius, eps = this._geometry.closePointEps;
        let points = this.currentPath ? this.currentPath.points : null;
        if (points) {
            const xDiff = Math.abs(points[points.length - 2] - startX), yDiff = Math.abs(points[points.length - 1] - startY);
            xDiff < eps && yDiff < eps || points.push(startX, startY);
        } else this.moveTo(startX, startY), points = this.currentPath.points;
        return (0, $3562e10fcd414675$export$e6c43ec4db262573).arc(startX, startY, cx, cy, radius, startAngle, endAngle, anticlockwise, points), this;
    }
    /**
   * Specifies a simple one-color fill that subsequent calls to other Graphics methods
   * (such as lineTo() or drawCircle()) use when drawing.
   * @param {PIXI.ColorSource} color - the color of the fill
   * @param alpha - the alpha of the fill, will override the color's alpha
   * @returns - This Graphics object. Suitable for chaining method calls
   */ beginFill(color = 0, alpha) {
        return this.beginTextureFill({
            texture: (0, $14896914ad3ae15d$export$5431306cf43de24a).WHITE,
            color: color,
            alpha: alpha
        });
    }
    /**
   * Normalize the color input from options for line style or fill
   * @param {PIXI.IFillStyleOptions} options - Fill style object.
   */ normalizeColor(options) {
        const temp = (0, $15154c33c9e19c5f$export$892596cec99bc70e).shared.setValue(options.color ?? 0);
        options.color = temp.toNumber(), options.alpha ?? (options.alpha = temp.alpha);
    }
    /**
   * Begin the texture fill.
   * Note: The wrap mode of the texture is forced to REPEAT on render.
   * @param options - Fill style object.
   * @param {PIXI.Texture} [options.texture=PIXI.Texture.WHITE] - Texture to fill
   * @param {PIXI.ColorSource} [options.color=0xffffff] - Background to fill behind texture
   * @param {number} [options.alpha] - Alpha of fill, overrides the color's alpha
   * @param {PIXI.Matrix} [options.matrix=null] - Transform matrix
   * @returns {PIXI.Graphics} This Graphics object. Good for chaining method calls
   */ beginTextureFill(options) {
        const defaultOptions = {
            texture: (0, $14896914ad3ae15d$export$5431306cf43de24a).WHITE,
            color: 16777215,
            matrix: null
        };
        options = Object.assign(defaultOptions, options), this.normalizeColor(options), this.currentPath && this.startPoly();
        const visible = options.alpha > 0;
        return visible ? (options.matrix && (options.matrix = options.matrix.clone(), options.matrix.invert()), Object.assign(this._fillStyle, {
            visible: visible
        }, options)) : this._fillStyle.reset(), this;
    }
    /**
   * Applies a fill to the lines and shapes that were added since the last call to the beginFill() method.
   * @returns - This Graphics object. Good for chaining method calls
   */ endFill() {
        return this.finishPoly(), this._fillStyle.reset(), this;
    }
    /**
   * Draws a rectangle shape.
   * @param x - The X coord of the top-left of the rectangle
   * @param y - The Y coord of the top-left of the rectangle
   * @param width - The width of the rectangle
   * @param height - The height of the rectangle
   * @returns - This Graphics object. Good for chaining method calls
   */ drawRect(x, y, width, height) {
        return this.drawShape(new (0, $200f778d7fdbf8ac$export$4617fb02663045ef)(x, y, width, height));
    }
    /**
   * Draw a rectangle shape with rounded/beveled corners.
   * @param x - The X coord of the top-left of the rectangle
   * @param y - The Y coord of the top-left of the rectangle
   * @param width - The width of the rectangle
   * @param height - The height of the rectangle
   * @param radius - Radius of the rectangle corners
   * @returns - This Graphics object. Good for chaining method calls
   */ drawRoundedRect(x, y, width, height, radius) {
        return this.drawShape(new (0, $4766db92ea4581f8$export$d55ab2e3dc5a4263)(x, y, width, height, radius));
    }
    /**
   * Draws a circle.
   * @param x - The X coordinate of the center of the circle
   * @param y - The Y coordinate of the center of the circle
   * @param radius - The radius of the circle
   * @returns - This Graphics object. Good for chaining method calls
   */ drawCircle(x, y, radius) {
        return this.drawShape(new (0, $076a80b12576921e$export$c89a927ffc67e6fa)(x, y, radius));
    }
    /**
   * Draws an ellipse.
   * @param x - The X coordinate of the center of the ellipse
   * @param y - The Y coordinate of the center of the ellipse
   * @param width - The half width of the ellipse
   * @param height - The half height of the ellipse
   * @returns - This Graphics object. Good for chaining method calls
   */ drawEllipse(x, y, width, height) {
        return this.drawShape(new (0, $8634cdd921030c11$export$80b0269ab108fa11)(x, y, width, height));
    }
    /**
   * Draws a polygon using the given path.
   * @param {number[]|PIXI.IPointData[]|PIXI.Polygon} path - The path data used to construct the polygon.
   * @returns - This Graphics object. Good for chaining method calls
   */ drawPolygon(...path) {
        let points, closeStroke = !0;
        const poly = path[0];
        poly.points ? (closeStroke = poly.closeStroke, points = poly.points) : Array.isArray(path[0]) ? points = path[0] : points = path;
        const shape = new (0, $20fd44ea129d646b$export$7d31b617c820d435)(points);
        return shape.closeStroke = closeStroke, this.drawShape(shape), this;
    }
    /**
   * Draw any shape.
   * @param {PIXI.Circle|PIXI.Ellipse|PIXI.Polygon|PIXI.Rectangle|PIXI.RoundedRectangle} shape - Shape to draw
   * @returns - This Graphics object. Good for chaining method calls
   */ drawShape(shape) {
        return this._holeMode ? this._geometry.drawHole(shape, this._matrix) : this._geometry.drawShape(shape, this._fillStyle.clone(), this._lineStyle.clone(), this._matrix), this;
    }
    /**
   * Clears the graphics that were drawn to this Graphics object, and resets fill and line style settings.
   * @returns - This Graphics object. Good for chaining method calls
   */ clear() {
        return this._geometry.clear(), this._lineStyle.reset(), this._fillStyle.reset(), this._boundsID++, this._matrix = null, this._holeMode = !1, this.currentPath = null, this;
    }
    /**
   * True if graphics consists of one rectangle, and thus, can be drawn like a Sprite and
   * masked with gl.scissor.
   * @returns - True if only 1 rect.
   */ isFastRect() {
        const data = this._geometry.graphicsData;
        return data.length === 1 && data[0].shape.type === (0, $e51f17ddb17db7b9$export$511e1d54a4a8684e).RECT && !data[0].matrix && !data[0].holes.length && !(data[0].lineStyle.visible && data[0].lineStyle.width);
    }
    /**
   * Renders the object using the WebGL renderer
   * @param renderer - The renderer
   */ _render(renderer) {
        this.finishPoly();
        const geometry = this._geometry;
        geometry.updateBatches(), geometry.batchable ? (this.batchDirty !== geometry.batchDirty && this._populateBatches(), this._renderBatched(renderer)) : (renderer.batch.flush(), this._renderDirect(renderer));
    }
    /** Populating batches for rendering. */ _populateBatches() {
        const geometry = this._geometry, blendMode = this.blendMode, len = geometry.batches.length;
        this.batchTint = -1, this._transformID = -1, this.batchDirty = geometry.batchDirty, this.batches.length = len, this.vertexData = new Float32Array(geometry.points);
        for(let i = 0; i < len; i++){
            const gI = geometry.batches[i], color = gI.style.color, vertexData = new Float32Array(this.vertexData.buffer, gI.attribStart * 8, gI.attribSize * 2), uvs = new Float32Array(geometry.uvsFloat32.buffer, gI.attribStart * 8, gI.attribSize * 2), indices = new Uint16Array(geometry.indicesUint16.buffer, gI.start * 2, gI.size), batch = {
                vertexData: vertexData,
                blendMode: blendMode,
                indices: indices,
                uvs: uvs,
                _batchRGB: (0, $15154c33c9e19c5f$export$892596cec99bc70e).shared.setValue(color).toRgbArray(),
                _tintRGB: color,
                _texture: gI.style.texture,
                alpha: gI.style.alpha,
                worldAlpha: 1
            };
            this.batches[i] = batch;
        }
    }
    /**
   * Renders the batches using the BathedRenderer plugin
   * @param renderer - The renderer
   */ _renderBatched(renderer) {
        if (this.batches.length) {
            renderer.batch.setObjectRenderer(renderer.plugins[this.pluginName]), this.calculateVertices(), this.calculateTints();
            for(let i = 0, l = this.batches.length; i < l; i++){
                const batch = this.batches[i];
                batch.worldAlpha = this.worldAlpha * batch.alpha, renderer.plugins[this.pluginName].render(batch);
            }
        }
    }
    /**
   * Renders the graphics direct
   * @param renderer - The renderer
   */ _renderDirect(renderer) {
        const shader = this._resolveDirectShader(renderer), geometry = this._geometry, worldAlpha = this.worldAlpha, uniforms = shader.uniforms, drawCalls = geometry.drawCalls;
        uniforms.translationMatrix = this.transform.worldTransform, (0, $15154c33c9e19c5f$export$892596cec99bc70e).shared.setValue(this._tintColor).premultiply(worldAlpha).toArray(uniforms.tint), renderer.shader.bind(shader), renderer.geometry.bind(geometry, shader), renderer.state.set(this.state);
        for(let i = 0, l = drawCalls.length; i < l; i++)this._renderDrawCallDirect(renderer, geometry.drawCalls[i]);
    }
    /**
   * Renders specific DrawCall
   * @param renderer
   * @param drawCall
   */ _renderDrawCallDirect(renderer, drawCall) {
        const { texArray: texArray, type: type, size: size, start: start } = drawCall, groupTextureCount = texArray.count;
        for(let j = 0; j < groupTextureCount; j++)renderer.texture.bind(texArray.elements[j], j);
        renderer.geometry.draw(type, size, start);
    }
    /**
   * Resolves shader for direct rendering
   * @param renderer - The renderer
   */ _resolveDirectShader(renderer) {
        let shader = this.shader;
        const pluginName = this.pluginName;
        if (!shader) {
            if (!$48ce8a7de6645907$var$DEFAULT_SHADERS[pluginName]) {
                const { maxTextures: maxTextures } = renderer.plugins[pluginName], sampleValues = new Int32Array(maxTextures);
                for(let i = 0; i < maxTextures; i++)sampleValues[i] = i;
                const uniforms = {
                    tint: new Float32Array([
                        1,
                        1,
                        1,
                        1
                    ]),
                    translationMatrix: new (0, $d7da222aa639cde0$export$5b12bf1653c0dd85)(),
                    default: (0, $8380fc86b6e89a36$export$6601a7a2dcf79bf5).from({
                        uSamplers: sampleValues
                    }, !0)
                }, program = renderer.plugins[pluginName]._shader.program;
                $48ce8a7de6645907$var$DEFAULT_SHADERS[pluginName] = new (0, $8f87c04218e7eb6d$export$462bb059fed9d9e5)(program, uniforms);
            }
            shader = $48ce8a7de6645907$var$DEFAULT_SHADERS[pluginName];
        }
        return shader;
    }
    /**
   * Retrieves the bounds of the graphic shape as a rectangle object.
   * @see PIXI.GraphicsGeometry#bounds
   */ _calculateBounds() {
        this.finishPoly();
        const geometry = this._geometry;
        if (!geometry.graphicsData.length) return;
        const { minX: minX, minY: minY, maxX: maxX, maxY: maxY } = geometry.bounds;
        this._bounds.addFrame(this.transform, minX, minY, maxX, maxY);
    }
    /**
   * Tests if a point is inside this graphics object
   * @param point - the point to test
   * @returns - the result of the test
   */ containsPoint(point) {
        return this.worldTransform.applyInverse(point, _Graphics2._TEMP_POINT), this._geometry.containsPoint(_Graphics2._TEMP_POINT);
    }
    /** Recalculate the tint by applying tint to batches using Graphics tint. */ calculateTints() {
        if (this.batchTint !== this.tint) {
            this.batchTint = this._tintColor.toNumber();
            for(let i = 0; i < this.batches.length; i++){
                const batch = this.batches[i];
                batch._tintRGB = (0, $15154c33c9e19c5f$export$892596cec99bc70e).shared.setValue(this._tintColor).multiply(batch._batchRGB).toLittleEndianNumber();
            }
        }
    }
    /** If there's a transform update or a change to the shape of the geometry, recalculate the vertices. */ calculateVertices() {
        const wtID = this.transform._worldID;
        if (this._transformID === wtID) return;
        this._transformID = wtID;
        const wt = this.transform.worldTransform, a = wt.a, b = wt.b, c = wt.c, d = wt.d, tx = wt.tx, ty = wt.ty, data = this._geometry.points, vertexData = this.vertexData;
        let count = 0;
        for(let i = 0; i < data.length; i += 2){
            const x = data[i], y = data[i + 1];
            vertexData[count++] = a * x + c * y + tx, vertexData[count++] = d * y + b * x + ty;
        }
    }
    /**
   * Closes the current path.
   * @returns - Returns itself.
   */ closePath() {
        const currentPath = this.currentPath;
        return currentPath && (currentPath.closeStroke = !0, this.finishPoly()), this;
    }
    /**
   * Apply a matrix to the positional data.
   * @param matrix - Matrix to use for transform current shape.
   * @returns - Returns itself.
   */ setMatrix(matrix) {
        return this._matrix = matrix, this;
    }
    /**
   * Begin adding holes to the last draw shape
   * IMPORTANT: holes must be fully inside a shape to work
   * Also weirdness ensues if holes overlap!
   * Ellipses, Circles, Rectangles and Rounded Rectangles cannot be holes or host for holes in CanvasRenderer,
   * please use `moveTo` `lineTo`, `quadraticCurveTo` if you rely on pixi-legacy bundle.
   * @returns - Returns itself.
   */ beginHole() {
        return this.finishPoly(), this._holeMode = !0, this;
    }
    /**
   * End adding holes to the last draw shape.
   * @returns - Returns itself.
   */ endHole() {
        return this.finishPoly(), this._holeMode = !1, this;
    }
    /**
   * Destroys the Graphics object.
   * @param options - Options parameter. A boolean will act as if all
   *  options have been set to that value
   * @param {boolean} [options.children=false] - if set to true, all the children will have
   *  their destroy method called as well. 'options' will be passed on to those calls.
   * @param {boolean} [options.texture=false] - Only used for child Sprites if options.children is set to true
   *  Should it destroy the texture of the child sprite
   * @param {boolean} [options.baseTexture=false] - Only used for child Sprites if options.children is set to true
   *  Should it destroy the base texture of the child sprite
   */ destroy(options) {
        this._geometry.refCount--, this._geometry.refCount === 0 && this._geometry.dispose(), this._matrix = null, this.currentPath = null, this._lineStyle.destroy(), this._lineStyle = null, this._fillStyle.destroy(), this._fillStyle = null, this._geometry = null, this.shader = null, this.vertexData = null, this.batches.length = 0, this.batches = null, super.destroy(options);
    }
};
$48ce8a7de6645907$var$_Graphics.curves = (0, $81b141585dec6314$export$6894093bf294bea5), /**
* Temporary point to use for containsPoint.
* @private
*/ $48ce8a7de6645907$var$_Graphics._TEMP_POINT = new (0, $cf3018b4309864c2$export$baf26146a414f24a)();
let $48ce8a7de6645907$export$29d3e417456abdad = $48ce8a7de6645907$var$_Graphics;















const $1513713af4e93954$export$efc72ad5bf88689 = {
    buildPoly: $f450577c45ecadd3$export$7de1a57618f21e1f,
    buildCircle: $f71d82f68e674a31$export$a3541b2d8ecbfcf2,
    buildRectangle: $e83822c3f394221c$export$cbe813d11f2192b2,
    buildRoundedRectangle: $40bd08db6a5be367$export$4b54fce47d2ae7f4,
    buildLine: $7c547149d5ee39e0$export$45986ccf08e93b0b,
    ArcUtils: $3562e10fcd414675$export$e6c43ec4db262573,
    BezierUtils: $cf49506e28d24ed4$export$994e59e1556c01e9,
    QuadraticUtils: $e761c398f91aa887$export$616649c7d4fcacf2,
    BatchPart: $75d55c217e234cb6$export$3abbb88a93faeec2,
    FILL_COMMANDS: $2334e14b6fd79541$export$b738057f7c88a634,
    BATCH_POOL: $2334e14b6fd79541$export$78aca0cfc72b8d6,
    DRAW_CALL_POOL: $2334e14b6fd79541$export$e520c68c6872beed
};




class $0721d43c7d436f83$export$49cc356fa6ba0e7b {
    /**
   * @param uvBuffer - Buffer with normalized uv's
   * @param uvMatrix - Material UV matrix
   */ constructor(uvBuffer, uvMatrix){
        this.uvBuffer = uvBuffer, this.uvMatrix = uvMatrix, this.data = null, this._bufferUpdateId = -1, this._textureUpdateId = -1, this._updateID = 0;
    }
    /**
   * Updates
   * @param forceUpdate - force the update
   */ update(forceUpdate) {
        if (!forceUpdate && this._bufferUpdateId === this.uvBuffer._updateID && this._textureUpdateId === this.uvMatrix._updateID) return;
        this._bufferUpdateId = this.uvBuffer._updateID, this._textureUpdateId = this.uvMatrix._updateID;
        const data = this.uvBuffer.data;
        (!this.data || this.data.length !== data.length) && (this.data = new Float32Array(data.length)), this.uvMatrix.multiplyUvs(data, this.data), this._updateID++;
    }
}


const $d349b6eff78111bd$var$tempPoint = new (0, $cf3018b4309864c2$export$baf26146a414f24a)(), $d349b6eff78111bd$var$tempPolygon = new (0, $20fd44ea129d646b$export$7d31b617c820d435)(), $d349b6eff78111bd$var$_Mesh = class _Mesh2 extends (0, $68e6944de5989822$export$42a852a2b6b56249) {
    /**
   * @param geometry - The geometry the mesh will use.
   * @param {PIXI.MeshMaterial} shader - The shader the mesh will use.
   * @param state - The state that the WebGL context is required to be in to render the mesh
   *        if no state is provided, uses {@link PIXI.State.for2d} to create a 2D state for PixiJS.
   * @param drawMode - The drawMode, can be any of the {@link PIXI.DRAW_MODES} constants.
   */ constructor(geometry, shader, state, drawMode = (0, $0fa4b07f86297abd$export$91100badd8469338).TRIANGLES){
        super(), this.geometry = geometry, this.shader = shader, this.state = state || (0, $2b269c8c39349f63$export$7254cc27399e90bd).for2d(), this.drawMode = drawMode, this.start = 0, this.size = 0, this.uvs = null, this.indices = null, this.vertexData = new Float32Array(1), this.vertexDirty = -1, this._transformID = -1, this._roundPixels = (0, $2808efac47e52be0$export$a5a6e0b888b2c992).ROUND_PIXELS, this.batchUvs = null;
    }
    /**
   * Includes vertex positions, face indices, normals, colors, UVs, and
   * custom attributes within buffers, reducing the cost of passing all
   * this data to the GPU. Can be shared between multiple Mesh objects.
   */ get geometry() {
        return this._geometry;
    }
    set geometry(value) {
        this._geometry !== value && (this._geometry && (this._geometry.refCount--, this._geometry.refCount === 0 && this._geometry.dispose()), this._geometry = value, this._geometry && this._geometry.refCount++, this.vertexDirty = -1);
    }
    /**
   * To change mesh uv's, change its uvBuffer data and increment its _updateID.
   * @readonly
   */ get uvBuffer() {
        return this.geometry.buffers[1];
    }
    /**
   * To change mesh vertices, change its uvBuffer data and increment its _updateID.
   * Incrementing _updateID is optional because most of Mesh objects do it anyway.
   * @readonly
   */ get verticesBuffer() {
        return this.geometry.buffers[0];
    }
    /** Alias for {@link PIXI.Mesh#shader}. */ set material(value) {
        this.shader = value;
    }
    get material() {
        return this.shader;
    }
    /**
   * The blend mode to be applied to the Mesh. Apply a value of
   * `PIXI.BLEND_MODES.NORMAL` to reset the blend mode.
   * @default PIXI.BLEND_MODES.NORMAL;
   */ set blendMode(value) {
        this.state.blendMode = value;
    }
    get blendMode() {
        return this.state.blendMode;
    }
    /**
   * If true PixiJS will Math.floor() x/y values when rendering, stopping pixel interpolation.
   * Advantages can include sharper image quality (like text) and faster rendering on canvas.
   * The main disadvantage is movement of objects may appear less smooth.
   * To set the global default, change {@link PIXI.settings.ROUND_PIXELS}
   * @default false
   */ set roundPixels(value) {
        this._roundPixels !== value && (this._transformID = -1), this._roundPixels = value;
    }
    get roundPixels() {
        return this._roundPixels;
    }
    /**
   * The multiply tint applied to the Mesh. This is a hex value. A value of
   * `0xFFFFFF` will remove any tint effect.
   *
   * Null for non-MeshMaterial shaders
   * @default 0xFFFFFF
   */ get tint() {
        return "tint" in this.shader ? this.shader.tint : null;
    }
    set tint(value) {
        this.shader.tint = value;
    }
    /**
   * The tint color as a RGB integer
   * @ignore
   */ get tintValue() {
        return this.shader.tintValue;
    }
    /** The texture that the Mesh uses. Null for non-MeshMaterial shaders */ get texture() {
        return "texture" in this.shader ? this.shader.texture : null;
    }
    set texture(value) {
        this.shader.texture = value;
    }
    /**
   * Standard renderer draw.
   * @param renderer - Instance to renderer.
   */ _render(renderer) {
        const vertices = this.geometry.buffers[0].data;
        this.shader.batchable && this.drawMode === (0, $0fa4b07f86297abd$export$91100badd8469338).TRIANGLES && vertices.length < _Mesh2.BATCHABLE_SIZE * 2 ? this._renderToBatch(renderer) : this._renderDefault(renderer);
    }
    /**
   * Standard non-batching way of rendering.
   * @param renderer - Instance to renderer.
   */ _renderDefault(renderer) {
        const shader = this.shader;
        shader.alpha = this.worldAlpha, shader.update && shader.update(), renderer.batch.flush(), shader.uniforms.translationMatrix = this.transform.worldTransform.toArray(!0), renderer.shader.bind(shader), renderer.state.set(this.state), renderer.geometry.bind(this.geometry, shader), renderer.geometry.draw(this.drawMode, this.size, this.start, this.geometry.instanceCount);
    }
    /**
   * Rendering by using the Batch system.
   * @param renderer - Instance to renderer.
   */ _renderToBatch(renderer) {
        const geometry = this.geometry, shader = this.shader;
        shader.uvMatrix && (shader.uvMatrix.update(), this.calculateUvs()), this.calculateVertices(), this.indices = geometry.indexBuffer.data, this._tintRGB = shader._tintRGB, this._texture = shader.texture;
        const pluginName = this.material.pluginName;
        renderer.batch.setObjectRenderer(renderer.plugins[pluginName]), renderer.plugins[pluginName].render(this);
    }
    /** Updates vertexData field based on transform and vertices. */ calculateVertices() {
        const verticesBuffer = this.geometry.buffers[0], vertices = verticesBuffer.data, vertexDirtyId = verticesBuffer._updateID;
        if (vertexDirtyId === this.vertexDirty && this._transformID === this.transform._worldID) return;
        this._transformID = this.transform._worldID, this.vertexData.length !== vertices.length && (this.vertexData = new Float32Array(vertices.length));
        const wt = this.transform.worldTransform, a = wt.a, b = wt.b, c = wt.c, d = wt.d, tx = wt.tx, ty = wt.ty, vertexData = this.vertexData;
        for(let i = 0; i < vertexData.length / 2; i++){
            const x = vertices[i * 2], y = vertices[i * 2 + 1];
            vertexData[i * 2] = a * x + c * y + tx, vertexData[i * 2 + 1] = b * x + d * y + ty;
        }
        if (this._roundPixels) {
            const resolution = (0, $2808efac47e52be0$export$a5a6e0b888b2c992).RESOLUTION;
            for(let i = 0; i < vertexData.length; ++i)vertexData[i] = Math.round(vertexData[i] * resolution) / resolution;
        }
        this.vertexDirty = vertexDirtyId;
    }
    /** Updates uv field based on from geometry uv's or batchUvs. */ calculateUvs() {
        const geomUvs = this.geometry.buffers[1], shader = this.shader;
        shader.uvMatrix.isSimple ? this.uvs = geomUvs.data : (this.batchUvs || (this.batchUvs = new (0, $0721d43c7d436f83$export$49cc356fa6ba0e7b)(geomUvs, shader.uvMatrix)), this.batchUvs.update(), this.uvs = this.batchUvs.data);
    }
    /**
   * Updates the bounds of the mesh as a rectangle. The bounds calculation takes the worldTransform into account.
   * there must be a aVertexPosition attribute present in the geometry for bounds to be calculated correctly.
   */ _calculateBounds() {
        this.calculateVertices(), this._bounds.addVertexData(this.vertexData, 0, this.vertexData.length);
    }
    /**
   * Tests if a point is inside this mesh. Works only for PIXI.DRAW_MODES.TRIANGLES.
   * @param point - The point to test.
   * @returns - The result of the test.
   */ containsPoint(point) {
        if (!this.getBounds().contains(point.x, point.y)) return !1;
        this.worldTransform.applyInverse(point, $d349b6eff78111bd$var$tempPoint);
        const vertices = this.geometry.getBuffer("aVertexPosition").data, points = $d349b6eff78111bd$var$tempPolygon.points, indices = this.geometry.getIndex().data, len = indices.length, step = this.drawMode === 4 ? 3 : 1;
        for(let i = 0; i + 2 < len; i += step){
            const ind0 = indices[i] * 2, ind1 = indices[i + 1] * 2, ind2 = indices[i + 2] * 2;
            if (points[0] = vertices[ind0], points[1] = vertices[ind0 + 1], points[2] = vertices[ind1], points[3] = vertices[ind1 + 1], points[4] = vertices[ind2], points[5] = vertices[ind2 + 1], $d349b6eff78111bd$var$tempPolygon.contains($d349b6eff78111bd$var$tempPoint.x, $d349b6eff78111bd$var$tempPoint.y)) return !0;
        }
        return !1;
    }
    destroy(options) {
        super.destroy(options), this._cachedTexture && (this._cachedTexture.destroy(), this._cachedTexture = null), this.geometry = null, this.shader = null, this.state = null, this.uvs = null, this.indices = null, this.vertexData = null;
    }
};
$d349b6eff78111bd$var$_Mesh.BATCHABLE_SIZE = 100;
let $d349b6eff78111bd$export$e176487c05830cc5 = $d349b6eff78111bd$var$_Mesh;




class $bd4ec874676d5696$export$8d075a36a73d54bc extends (0, $746bc9ae18084e8e$export$2db6c17465f94a2) {
    /**
   * @param {Float32Array|number[]} [vertices] - Positional data on geometry.
   * @param {Float32Array|number[]} [uvs] - Texture UVs.
   * @param {Uint16Array|number[]} [index] - IndexBuffer
   */ constructor(vertices, uvs, index){
        super();
        const verticesBuffer = new (0, $17b501b101b42758$export$a143d493d941bafc)(vertices), uvsBuffer = new (0, $17b501b101b42758$export$a143d493d941bafc)(uvs, !0), indexBuffer = new (0, $17b501b101b42758$export$a143d493d941bafc)(index, !0, !0);
        this.addAttribute("aVertexPosition", verticesBuffer, 2, !1, (0, $0fa4b07f86297abd$export$426db7a6155b7a80).FLOAT).addAttribute("aTextureCoord", uvsBuffer, 2, !1, (0, $0fa4b07f86297abd$export$426db7a6155b7a80).FLOAT).addIndex(indexBuffer), this._updateId = -1;
    }
    /**
   * If the vertex position is updated.
   * @readonly
   * @private
   */ get vertexDirtyId() {
        return this.buffers[0]._updateID;
    }
}



var $3a26bd9719db9cc0$export$2e2bcd8739ae039 = `varying vec2 vTextureCoord;
uniform vec4 uColor;

uniform sampler2D uSampler;

void main(void)
{
    gl_FragColor = texture2D(uSampler, vTextureCoord) * uColor;
}
`;


var $744f9e83845f62e0$export$2e2bcd8739ae039 = `attribute vec2 aVertexPosition;
attribute vec2 aTextureCoord;

uniform mat3 projectionMatrix;
uniform mat3 translationMatrix;
uniform mat3 uTextureMatrix;

varying vec2 vTextureCoord;

void main(void)
{
    gl_Position = vec4((projectionMatrix * translationMatrix * vec3(aVertexPosition, 1.0)).xy, 0.0, 1.0);

    vTextureCoord = (uTextureMatrix * vec3(aTextureCoord, 1.0)).xy;
}
`;


class $a6a1d7526e98bf89$export$d552dadfd66cc650 extends (0, $8f87c04218e7eb6d$export$462bb059fed9d9e5) {
    /**
   * @param uSampler - Texture that material uses to render.
   * @param options - Additional options
   * @param {number} [options.alpha=1] - Default alpha.
   * @param {PIXI.ColorSource} [options.tint=0xFFFFFF] - Default tint.
   * @param {string} [options.pluginName='batch'] - Renderer plugin for batching.
   * @param {PIXI.Program} [options.program=0xFFFFFF] - Custom program.
   * @param {object} [options.uniforms] - Custom uniforms.
   */ constructor(uSampler, options){
        const uniforms = {
            uSampler: uSampler,
            alpha: 1,
            uTextureMatrix: (0, $d7da222aa639cde0$export$5b12bf1653c0dd85).IDENTITY,
            uColor: new Float32Array([
                1,
                1,
                1,
                1
            ])
        };
        options = Object.assign({
            tint: 16777215,
            alpha: 1,
            pluginName: "batch"
        }, options), options.uniforms && Object.assign(uniforms, options.uniforms), super(options.program || (0, $35ca18cab1598332$export$b6c59b989905b650).from((0, $744f9e83845f62e0$export$2e2bcd8739ae039), (0, $3a26bd9719db9cc0$export$2e2bcd8739ae039)), uniforms), this._colorDirty = !1, this.uvMatrix = new (0, $63f378ad73a038ff$export$dbea3135e9da48cb)(uSampler), this.batchable = options.program === void 0, this.pluginName = options.pluginName, this._tintColor = new (0, $15154c33c9e19c5f$export$892596cec99bc70e)(options.tint), this._tintRGB = this._tintColor.toLittleEndianNumber(), this._colorDirty = !0, this.alpha = options.alpha;
    }
    /** Reference to the texture being rendered. */ get texture() {
        return this.uniforms.uSampler;
    }
    set texture(value) {
        this.uniforms.uSampler !== value && (!this.uniforms.uSampler.baseTexture.alphaMode != !value.baseTexture.alphaMode && (this._colorDirty = !0), this.uniforms.uSampler = value, this.uvMatrix.texture = value);
    }
    /**
   * This gets automatically set by the object using this.
   * @default 1
   */ set alpha(value) {
        value !== this._alpha && (this._alpha = value, this._colorDirty = !0);
    }
    get alpha() {
        return this._alpha;
    }
    /**
   * Multiply tint for the material.
   * @default 0xFFFFFF
   */ set tint(value) {
        value !== this.tint && (this._tintColor.setValue(value), this._tintRGB = this._tintColor.toLittleEndianNumber(), this._colorDirty = !0);
    }
    get tint() {
        return this._tintColor.value;
    }
    /**
   * Get the internal number from tint color
   * @ignore
   */ get tintValue() {
        return this._tintColor.toNumber();
    }
    /** Gets called automatically by the Mesh. Intended to be overridden for custom {@link PIXI.MeshMaterial} objects. */ update() {
        if (this._colorDirty) {
            this._colorDirty = !1;
            const applyToChannels = this.texture.baseTexture.alphaMode;
            (0, $15154c33c9e19c5f$export$892596cec99bc70e).shared.setValue(this._tintColor).premultiply(this._alpha, applyToChannels).toArray(this.uniforms.uColor);
        }
        this.uvMatrix.update() && (this.uniforms.uTextureMatrix = this.uvMatrix.mapCoord);
    }
}





class $dea5b6c987719597$export$967d831af31f69ce extends (0, $bd4ec874676d5696$export$8d075a36a73d54bc) {
    /**
   * @param width - The width of the plane.
   * @param height - The height of the plane.
   * @param segWidth - Number of horizontal segments.
   * @param segHeight - Number of vertical segments.
   */ constructor(width = 100, height = 100, segWidth = 10, segHeight = 10){
        super(), this.segWidth = segWidth, this.segHeight = segHeight, this.width = width, this.height = height, this.build();
    }
    /**
   * Refreshes plane coordinates
   * @private
   */ build() {
        const total = this.segWidth * this.segHeight, verts = [], uvs = [], indices = [], segmentsX = this.segWidth - 1, segmentsY = this.segHeight - 1, sizeX = this.width / segmentsX, sizeY = this.height / segmentsY;
        for(let i = 0; i < total; i++){
            const x = i % this.segWidth, y = i / this.segWidth | 0;
            verts.push(x * sizeX, y * sizeY), uvs.push(x / segmentsX, y / segmentsY);
        }
        const totalSub = segmentsX * segmentsY;
        for(let i = 0; i < totalSub; i++){
            const xpos = i % segmentsX, ypos = i / segmentsX | 0, value = ypos * this.segWidth + xpos, value2 = ypos * this.segWidth + xpos + 1, value3 = (ypos + 1) * this.segWidth + xpos, value4 = (ypos + 1) * this.segWidth + xpos + 1;
            indices.push(value, value2, value3, value2, value4, value3);
        }
        this.buffers[0].data = new Float32Array(verts), this.buffers[1].data = new Float32Array(uvs), this.indexBuffer.data = new Uint16Array(indices), this.buffers[0].update(), this.buffers[1].update(), this.indexBuffer.update();
    }
}



class $45227671e68cf0b6$export$6a9827483976bf64 extends (0, $bd4ec874676d5696$export$8d075a36a73d54bc) {
    /**
   * @param width - The width (i.e., thickness) of the rope.
   * @param points - An array of {@link PIXI.Point} objects to construct this rope.
   * @param textureScale - By default the rope texture will be stretched to match
   *     rope length. If textureScale is positive this value will be treated as a scaling
   *     factor and the texture will preserve its aspect ratio instead. To create a tiling rope
   *     set baseTexture.wrapMode to {@link PIXI.WRAP_MODES.REPEAT} and use a power of two texture,
   *     then set textureScale=1 to keep the original texture pixel size.
   *     In order to reduce alpha channel artifacts provide a larger texture and downsample -
   *     i.e. set textureScale=0.5 to scale it down twice.
   */ constructor(width = 200, points, textureScale = 0){
        super(new Float32Array(points.length * 4), new Float32Array(points.length * 4), new Uint16Array((points.length - 1) * 6)), this.points = points, this._width = width, this.textureScale = textureScale, this.build();
    }
    /**
   * The width (i.e., thickness) of the rope.
   * @readonly
   */ get width() {
        return this._width;
    }
    /** Refreshes Rope indices and uvs */ build() {
        const points = this.points;
        if (!points) return;
        const vertexBuffer = this.getBuffer("aVertexPosition"), uvBuffer = this.getBuffer("aTextureCoord"), indexBuffer = this.getIndex();
        if (points.length < 1) return;
        vertexBuffer.data.length / 4 !== points.length && (vertexBuffer.data = new Float32Array(points.length * 4), uvBuffer.data = new Float32Array(points.length * 4), indexBuffer.data = new Uint16Array((points.length - 1) * 6));
        const uvs = uvBuffer.data, indices = indexBuffer.data;
        uvs[0] = 0, uvs[1] = 0, uvs[2] = 0, uvs[3] = 1;
        let amount = 0, prev = points[0];
        const textureWidth = this._width * this.textureScale, total = points.length;
        for(let i = 0; i < total; i++){
            const index = i * 4;
            if (this.textureScale > 0) {
                const dx = prev.x - points[i].x, dy = prev.y - points[i].y, distance = Math.sqrt(dx * dx + dy * dy);
                prev = points[i], amount += distance / textureWidth;
            } else amount = i / (total - 1);
            uvs[index] = amount, uvs[index + 1] = 0, uvs[index + 2] = amount, uvs[index + 3] = 1;
        }
        let indexCount = 0;
        for(let i = 0; i < total - 1; i++){
            const index = i * 2;
            indices[indexCount++] = index, indices[indexCount++] = index + 1, indices[indexCount++] = index + 2, indices[indexCount++] = index + 2, indices[indexCount++] = index + 1, indices[indexCount++] = index + 3;
        }
        uvBuffer.update(), indexBuffer.update(), this.updateVertices();
    }
    /** refreshes vertices of Rope mesh */ updateVertices() {
        const points = this.points;
        if (points.length < 1) return;
        let lastPoint = points[0], nextPoint, perpX = 0, perpY = 0;
        const vertices = this.buffers[0].data, total = points.length, halfWidth = this.textureScale > 0 ? this.textureScale * this._width / 2 : this._width / 2;
        for(let i = 0; i < total; i++){
            const point = points[i], index = i * 4;
            i < points.length - 1 ? nextPoint = points[i + 1] : nextPoint = point, perpY = -(nextPoint.x - lastPoint.x), perpX = nextPoint.y - lastPoint.y;
            let ratio = (1 - i / (total - 1)) * 10;
            ratio > 1 && (ratio = 1);
            const perpLength = Math.sqrt(perpX * perpX + perpY * perpY);
            perpLength < 1e-6 ? (perpX = 0, perpY = 0) : (perpX /= perpLength, perpY /= perpLength, perpX *= halfWidth, perpY *= halfWidth), vertices[index] = point.x + perpX, vertices[index + 1] = point.y + perpY, vertices[index + 2] = point.x - perpX, vertices[index + 3] = point.y - perpY, lastPoint = point;
        }
        this.buffers[0].update();
    }
    update() {
        this.textureScale > 0 ? this.build() : this.updateVertices();
    }
}






class $35bfa1c2b0fedd01$export$d47c1aa7111669b9 extends (0, $d349b6eff78111bd$export$e176487c05830cc5) {
    /**
   * @param texture - The texture to use on the SimplePlane.
   * @param verticesX - The number of vertices in the x-axis
   * @param verticesY - The number of vertices in the y-axis
   */ constructor(texture, verticesX, verticesY){
        const planeGeometry = new (0, $dea5b6c987719597$export$967d831af31f69ce)(texture.width, texture.height, verticesX, verticesY), meshMaterial = new (0, $a6a1d7526e98bf89$export$d552dadfd66cc650)((0, $14896914ad3ae15d$export$5431306cf43de24a).WHITE);
        super(planeGeometry, meshMaterial), this.texture = texture, this.autoResize = !0;
    }
    /**
   * Method used for overrides, to do something in case texture frame was changed.
   * Meshes based on plane can override it and change more details based on texture.
   */ textureUpdated() {
        this._textureID = this.shader.texture._updateID;
        const geometry = this.geometry, { width: width, height: height } = this.shader.texture;
        this.autoResize && (geometry.width !== width || geometry.height !== height) && (geometry.width = this.shader.texture.width, geometry.height = this.shader.texture.height, geometry.build());
    }
    set texture(value) {
        this.shader.texture !== value && (this.shader.texture = value, this._textureID = -1, value.baseTexture.valid ? this.textureUpdated() : value.once("update", this.textureUpdated, this));
    }
    get texture() {
        return this.shader.texture;
    }
    _render(renderer) {
        this._textureID !== this.shader.texture._updateID && this.textureUpdated(), super._render(renderer);
    }
    destroy(options) {
        this.shader.texture.off("update", this.textureUpdated, this), super.destroy(options);
    }
}


const $071f623d6ae0f457$var$DEFAULT_BORDER_SIZE = 10;
class $071f623d6ae0f457$export$acdf4cb3f489544e extends (0, $35bfa1c2b0fedd01$export$d47c1aa7111669b9) {
    /**
   * @param texture - The texture to use on the NineSlicePlane.
   * @param {number} [leftWidth=10] - size of the left vertical bar (A)
   * @param {number} [topHeight=10] - size of the top horizontal bar (C)
   * @param {number} [rightWidth=10] - size of the right vertical bar (B)
   * @param {number} [bottomHeight=10] - size of the bottom horizontal bar (D)
   */ constructor(texture, leftWidth, topHeight, rightWidth, bottomHeight){
        super((0, $14896914ad3ae15d$export$5431306cf43de24a).WHITE, 4, 4), this._origWidth = texture.orig.width, this._origHeight = texture.orig.height, this._width = this._origWidth, this._height = this._origHeight, this._leftWidth = leftWidth ?? texture.defaultBorders?.left ?? $071f623d6ae0f457$var$DEFAULT_BORDER_SIZE, this._rightWidth = rightWidth ?? texture.defaultBorders?.right ?? $071f623d6ae0f457$var$DEFAULT_BORDER_SIZE, this._topHeight = topHeight ?? texture.defaultBorders?.top ?? $071f623d6ae0f457$var$DEFAULT_BORDER_SIZE, this._bottomHeight = bottomHeight ?? texture.defaultBorders?.bottom ?? $071f623d6ae0f457$var$DEFAULT_BORDER_SIZE, this.texture = texture;
    }
    textureUpdated() {
        this._textureID = this.shader.texture._updateID, this._refresh();
    }
    get vertices() {
        return this.geometry.getBuffer("aVertexPosition").data;
    }
    set vertices(value) {
        this.geometry.getBuffer("aVertexPosition").data = value;
    }
    /** Updates the horizontal vertices. */ updateHorizontalVertices() {
        const vertices = this.vertices, scale = this._getMinScale();
        vertices[9] = vertices[11] = vertices[13] = vertices[15] = this._topHeight * scale, vertices[17] = vertices[19] = vertices[21] = vertices[23] = this._height - this._bottomHeight * scale, vertices[25] = vertices[27] = vertices[29] = vertices[31] = this._height;
    }
    /** Updates the vertical vertices. */ updateVerticalVertices() {
        const vertices = this.vertices, scale = this._getMinScale();
        vertices[2] = vertices[10] = vertices[18] = vertices[26] = this._leftWidth * scale, vertices[4] = vertices[12] = vertices[20] = vertices[28] = this._width - this._rightWidth * scale, vertices[6] = vertices[14] = vertices[22] = vertices[30] = this._width;
    }
    /**
   * Returns the smaller of a set of vertical and horizontal scale of nine slice corners.
   * @returns Smaller number of vertical and horizontal scale.
   */ _getMinScale() {
        const w = this._leftWidth + this._rightWidth, scaleW = this._width > w ? 1 : this._width / w, h = this._topHeight + this._bottomHeight, scaleH = this._height > h ? 1 : this._height / h;
        return Math.min(scaleW, scaleH);
    }
    /** The width of the NineSlicePlane, setting this will actually modify the vertices and UV's of this plane. */ get width() {
        return this._width;
    }
    set width(value) {
        this._width = value, this._refresh();
    }
    /** The height of the NineSlicePlane, setting this will actually modify the vertices and UV's of this plane. */ get height() {
        return this._height;
    }
    set height(value) {
        this._height = value, this._refresh();
    }
    /** The width of the left column. */ get leftWidth() {
        return this._leftWidth;
    }
    set leftWidth(value) {
        this._leftWidth = value, this._refresh();
    }
    /** The width of the right column. */ get rightWidth() {
        return this._rightWidth;
    }
    set rightWidth(value) {
        this._rightWidth = value, this._refresh();
    }
    /** The height of the top row. */ get topHeight() {
        return this._topHeight;
    }
    set topHeight(value) {
        this._topHeight = value, this._refresh();
    }
    /** The height of the bottom row. */ get bottomHeight() {
        return this._bottomHeight;
    }
    set bottomHeight(value) {
        this._bottomHeight = value, this._refresh();
    }
    /** Refreshes NineSlicePlane coords. All of them. */ _refresh() {
        const texture = this.texture, uvs = this.geometry.buffers[1].data;
        this._origWidth = texture.orig.width, this._origHeight = texture.orig.height;
        const _uvw = 1 / this._origWidth, _uvh = 1 / this._origHeight;
        uvs[0] = uvs[8] = uvs[16] = uvs[24] = 0, uvs[1] = uvs[3] = uvs[5] = uvs[7] = 0, uvs[6] = uvs[14] = uvs[22] = uvs[30] = 1, uvs[25] = uvs[27] = uvs[29] = uvs[31] = 1, uvs[2] = uvs[10] = uvs[18] = uvs[26] = _uvw * this._leftWidth, uvs[4] = uvs[12] = uvs[20] = uvs[28] = 1 - _uvw * this._rightWidth, uvs[9] = uvs[11] = uvs[13] = uvs[15] = _uvh * this._topHeight, uvs[17] = uvs[19] = uvs[21] = uvs[23] = 1 - _uvh * this._bottomHeight, this.updateHorizontalVertices(), this.updateVerticalVertices(), this.geometry.buffers[0].update(), this.geometry.buffers[1].update();
    }
}




class $7c845697fd87c580$export$81b9e78682e7feca extends (0, $d349b6eff78111bd$export$e176487c05830cc5) {
    /**
   * @param texture - The texture to use
   * @param {Float32Array} [vertices] - if you want to specify the vertices
   * @param {Float32Array} [uvs] - if you want to specify the uvs
   * @param {Uint16Array} [indices] - if you want to specify the indices
   * @param drawMode - the drawMode, can be any of the Mesh.DRAW_MODES consts
   */ constructor(texture = (0, $14896914ad3ae15d$export$5431306cf43de24a).EMPTY, vertices, uvs, indices, drawMode){
        const geometry = new (0, $bd4ec874676d5696$export$8d075a36a73d54bc)(vertices, uvs, indices);
        geometry.getBuffer("aVertexPosition").static = !1;
        const meshMaterial = new (0, $a6a1d7526e98bf89$export$d552dadfd66cc650)(texture);
        super(geometry, meshMaterial, null, drawMode), this.autoUpdate = !0;
    }
    /**
   * Collection of vertices data.
   * @type {Float32Array}
   */ get vertices() {
        return this.geometry.getBuffer("aVertexPosition").data;
    }
    set vertices(value) {
        this.geometry.getBuffer("aVertexPosition").data = value;
    }
    _render(renderer) {
        this.autoUpdate && this.geometry.getBuffer("aVertexPosition").update(), super._render(renderer);
    }
}






class $f95ecabd13ccb84f$export$f009a14c3f00879e extends (0, $d349b6eff78111bd$export$e176487c05830cc5) {
    /**
   * Note: The wrap mode of the texture is set to REPEAT if `textureScale` is positive.
   * @param texture - The texture to use on the rope.
   * @param points - An array of {@link PIXI.Point} objects to construct this rope.
   * @param {number} textureScale - Optional. Positive values scale rope texture
   * keeping its aspect ratio. You can reduce alpha channel artifacts by providing a larger texture
   * and downsampling here. If set to zero, texture will be stretched instead.
   */ constructor(texture, points, textureScale = 0){
        const ropeGeometry = new (0, $45227671e68cf0b6$export$6a9827483976bf64)(texture.height, points, textureScale), meshMaterial = new (0, $a6a1d7526e98bf89$export$d552dadfd66cc650)(texture);
        textureScale > 0 && (texture.baseTexture.wrapMode = (0, $0fa4b07f86297abd$export$2ab395cfb0dd2f0f).REPEAT), super(ropeGeometry, meshMaterial), this.autoUpdate = !0;
    }
    _render(renderer) {
        const geometry = this.geometry;
        (this.autoUpdate || geometry._width !== this.shader.texture.height) && (geometry._width = this.shader.texture.height, geometry.update()), super._render(renderer);
    }
}






class $f88d384678abf2b7$export$e63bf72b2cfda112 extends (0, $68e6944de5989822$export$42a852a2b6b56249) {
    /**
   * @param maxSize - The maximum number of particles that can be rendered by the container.
   *  Affects size of allocated buffers.
   * @param properties - The properties of children that should be uploaded to the gpu and applied.
   * @param {boolean} [properties.vertices=false] - When true, vertices be uploaded and applied.
   *                  if sprite's ` scale/anchor/trim/frame/orig` is dynamic, please set `true`.
   * @param {boolean} [properties.position=true] - When true, position be uploaded and applied.
   * @param {boolean} [properties.rotation=false] - When true, rotation be uploaded and applied.
   * @param {boolean} [properties.uvs=false] - When true, uvs be uploaded and applied.
   * @param {boolean} [properties.tint=false] - When true, alpha and tint be uploaded and applied.
   * @param {number} [batchSize=16384] - Number of particles per batch. If less than maxSize, it uses maxSize instead.
   * @param {boolean} [autoResize=false] - If true, container allocates more batches in case
   *  there are more than `maxSize` particles.
   */ constructor(maxSize = 1500, properties, batchSize = 16384, autoResize = !1){
        super();
        const maxBatchSize = 16384;
        batchSize > maxBatchSize && (batchSize = maxBatchSize), this._properties = [
            !1,
            !0,
            !1,
            !1,
            !1
        ], this._maxSize = maxSize, this._batchSize = batchSize, this._buffers = null, this._bufferUpdateIDs = [], this._updateID = 0, this.interactiveChildren = !1, this.blendMode = (0, $0fa4b07f86297abd$export$f821c68fe9beaecf).NORMAL, this.autoResize = autoResize, this.roundPixels = !0, this.baseTexture = null, this.setProperties(properties), this._tintColor = new (0, $15154c33c9e19c5f$export$892596cec99bc70e)(0), this.tintRgb = new Float32Array(3), this.tint = 16777215;
    }
    /**
   * Sets the private properties array to dynamic / static based on the passed properties object
   * @param properties - The properties to be uploaded
   */ setProperties(properties) {
        properties && (this._properties[0] = "vertices" in properties || "scale" in properties ? !!properties.vertices || !!properties.scale : this._properties[0], this._properties[1] = "position" in properties ? !!properties.position : this._properties[1], this._properties[2] = "rotation" in properties ? !!properties.rotation : this._properties[2], this._properties[3] = "uvs" in properties ? !!properties.uvs : this._properties[3], this._properties[4] = "tint" in properties || "alpha" in properties ? !!properties.tint || !!properties.alpha : this._properties[4]);
    }
    updateTransform() {
        this.displayObjectUpdateTransform();
    }
    /**
   * The tint applied to the container. This is a hex value.
   * A value of 0xFFFFFF will remove any tint effect.
   * IMPORTANT: This is a WebGL only feature and will be ignored by the canvas renderer.
   * @default 0xFFFFFF
   */ get tint() {
        return this._tintColor.value;
    }
    set tint(value) {
        this._tintColor.setValue(value), this._tintColor.toRgbArray(this.tintRgb);
    }
    /**
   * Renders the container using the WebGL renderer.
   * @param renderer - The WebGL renderer.
   */ render(renderer) {
        !this.visible || this.worldAlpha <= 0 || !this.children.length || !this.renderable || (this.baseTexture || (this.baseTexture = this.children[0]._texture.baseTexture, this.baseTexture.valid || this.baseTexture.once("update", ()=>this.onChildrenChange(0))), renderer.batch.setObjectRenderer(renderer.plugins.particle), renderer.plugins.particle.render(this));
    }
    /**
   * Set the flag that static data should be updated to true
   * @param smallestChildIndex - The smallest child index.
   */ onChildrenChange(smallestChildIndex) {
        const bufferIndex = Math.floor(smallestChildIndex / this._batchSize);
        for(; this._bufferUpdateIDs.length < bufferIndex;)this._bufferUpdateIDs.push(0);
        this._bufferUpdateIDs[bufferIndex] = ++this._updateID;
    }
    dispose() {
        if (this._buffers) {
            for(let i = 0; i < this._buffers.length; ++i)this._buffers[i].destroy();
            this._buffers = null;
        }
    }
    /**
   * Destroys the container
   * @param options - Options parameter. A boolean will act as if all options
   *  have been set to that value
   * @param {boolean} [options.children=false] - if set to true, all the children will have their
   *  destroy method called as well. 'options' will be passed on to those calls.
   * @param {boolean} [options.texture=false] - Only used for child Sprites if options.children is set to true
   *  Should it destroy the texture of the child sprite
   * @param {boolean} [options.baseTexture=false] - Only used for child Sprites if options.children is set to true
   *  Should it destroy the base texture of the child sprite
   */ destroy(options) {
        super.destroy(options), this.dispose(), this._properties = null, this._buffers = null, this._bufferUpdateIDs = null;
    }
}




class $114044dcfa5e3cb0$export$ef6bb3c375ab2229 {
    /**
   * @param {object} properties - The properties to upload.
   * @param {boolean[]} dynamicPropertyFlags - Flags for which properties are dynamic.
   * @param {number} size - The size of the batch.
   */ constructor(properties, dynamicPropertyFlags, size){
        this.geometry = new (0, $746bc9ae18084e8e$export$2db6c17465f94a2)(), this.indexBuffer = null, this.size = size, this.dynamicProperties = [], this.staticProperties = [];
        for(let i = 0; i < properties.length; ++i){
            let property = properties[i];
            property = {
                attributeName: property.attributeName,
                size: property.size,
                uploadFunction: property.uploadFunction,
                type: property.type || (0, $0fa4b07f86297abd$export$426db7a6155b7a80).FLOAT,
                offset: property.offset
            }, dynamicPropertyFlags[i] ? this.dynamicProperties.push(property) : this.staticProperties.push(property);
        }
        this.staticStride = 0, this.staticBuffer = null, this.staticData = null, this.staticDataUint32 = null, this.dynamicStride = 0, this.dynamicBuffer = null, this.dynamicData = null, this.dynamicDataUint32 = null, this._updateID = 0, this.initBuffers();
    }
    /** Sets up the renderer context and necessary buffers. */ initBuffers() {
        const geometry = this.geometry;
        let dynamicOffset = 0;
        this.indexBuffer = new (0, $17b501b101b42758$export$a143d493d941bafc)((0, $db31fc3dfae4939b$exports).createIndicesForQuads(this.size), !0, !0), geometry.addIndex(this.indexBuffer), this.dynamicStride = 0;
        for(let i = 0; i < this.dynamicProperties.length; ++i){
            const property = this.dynamicProperties[i];
            property.offset = dynamicOffset, dynamicOffset += property.size, this.dynamicStride += property.size;
        }
        const dynBuffer = new ArrayBuffer(this.size * this.dynamicStride * 16);
        this.dynamicData = new Float32Array(dynBuffer), this.dynamicDataUint32 = new Uint32Array(dynBuffer), this.dynamicBuffer = new (0, $17b501b101b42758$export$a143d493d941bafc)(this.dynamicData, !1, !1);
        let staticOffset = 0;
        this.staticStride = 0;
        for(let i = 0; i < this.staticProperties.length; ++i){
            const property = this.staticProperties[i];
            property.offset = staticOffset, staticOffset += property.size, this.staticStride += property.size;
        }
        const statBuffer = new ArrayBuffer(this.size * this.staticStride * 16);
        this.staticData = new Float32Array(statBuffer), this.staticDataUint32 = new Uint32Array(statBuffer), this.staticBuffer = new (0, $17b501b101b42758$export$a143d493d941bafc)(this.staticData, !0, !1);
        for(let i = 0; i < this.dynamicProperties.length; ++i){
            const property = this.dynamicProperties[i];
            geometry.addAttribute(property.attributeName, this.dynamicBuffer, 0, property.type === (0, $0fa4b07f86297abd$export$426db7a6155b7a80).UNSIGNED_BYTE, property.type, this.dynamicStride * 4, property.offset * 4);
        }
        for(let i = 0; i < this.staticProperties.length; ++i){
            const property = this.staticProperties[i];
            geometry.addAttribute(property.attributeName, this.staticBuffer, 0, property.type === (0, $0fa4b07f86297abd$export$426db7a6155b7a80).UNSIGNED_BYTE, property.type, this.staticStride * 4, property.offset * 4);
        }
    }
    /**
   * Uploads the dynamic properties.
   * @param children - The children to upload.
   * @param startIndex - The index to start at.
   * @param amount - The number to upload.
   */ uploadDynamic(children, startIndex, amount) {
        for(let i = 0; i < this.dynamicProperties.length; i++){
            const property = this.dynamicProperties[i];
            property.uploadFunction(children, startIndex, amount, property.type === (0, $0fa4b07f86297abd$export$426db7a6155b7a80).UNSIGNED_BYTE ? this.dynamicDataUint32 : this.dynamicData, this.dynamicStride, property.offset);
        }
        this.dynamicBuffer._updateID++;
    }
    /**
   * Uploads the static properties.
   * @param children - The children to upload.
   * @param startIndex - The index to start at.
   * @param amount - The number to upload.
   */ uploadStatic(children, startIndex, amount) {
        for(let i = 0; i < this.staticProperties.length; i++){
            const property = this.staticProperties[i];
            property.uploadFunction(children, startIndex, amount, property.type === (0, $0fa4b07f86297abd$export$426db7a6155b7a80).UNSIGNED_BYTE ? this.staticDataUint32 : this.staticData, this.staticStride, property.offset);
        }
        this.staticBuffer._updateID++;
    }
    /** Destroys the ParticleBuffer. */ destroy() {
        this.indexBuffer = null, this.dynamicProperties = null, this.dynamicBuffer = null, this.dynamicData = null, this.dynamicDataUint32 = null, this.staticProperties = null, this.staticBuffer = null, this.staticData = null, this.staticDataUint32 = null, this.geometry.destroy();
    }
}


var $16e6d5e0e669640c$export$2e2bcd8739ae039 = `varying vec2 vTextureCoord;
varying vec4 vColor;

uniform sampler2D uSampler;

void main(void){
    vec4 color = texture2D(uSampler, vTextureCoord) * vColor;
    gl_FragColor = color;
}`;


var $b2311882e46ccfe7$export$2e2bcd8739ae039 = `attribute vec2 aVertexPosition;
attribute vec2 aTextureCoord;
attribute vec4 aColor;

attribute vec2 aPositionCoord;
attribute float aRotation;

uniform mat3 translationMatrix;
uniform vec4 uColor;

varying vec2 vTextureCoord;
varying vec4 vColor;

void main(void){
    float x = (aVertexPosition.x) * cos(aRotation) - (aVertexPosition.y) * sin(aRotation);
    float y = (aVertexPosition.x) * sin(aRotation) + (aVertexPosition.y) * cos(aRotation);

    vec2 v = vec2(x, y);
    v = v + aPositionCoord;

    gl_Position = vec4((translationMatrix * vec3(v, 1.0)).xy, 0.0, 1.0);

    vTextureCoord = aTextureCoord;
    vColor = aColor * uColor;
}
`;


class $4353158ed3ef33a8$export$42cbb08a275c7ff9 extends (0, $0a2e1c9be4f09a9b$export$ca67b0b0fa758253) {
    /**
   * @param renderer - The renderer this sprite batch works for.
   */ constructor(renderer){
        super(renderer), this.shader = null, this.properties = null, this.tempMatrix = new (0, $d7da222aa639cde0$export$5b12bf1653c0dd85)(), this.properties = [
            // verticesData
            {
                attributeName: "aVertexPosition",
                size: 2,
                uploadFunction: this.uploadVertices,
                offset: 0
            },
            // positionData
            {
                attributeName: "aPositionCoord",
                size: 2,
                uploadFunction: this.uploadPosition,
                offset: 0
            },
            // rotationData
            {
                attributeName: "aRotation",
                size: 1,
                uploadFunction: this.uploadRotation,
                offset: 0
            },
            // uvsData
            {
                attributeName: "aTextureCoord",
                size: 2,
                uploadFunction: this.uploadUvs,
                offset: 0
            },
            // tintData
            {
                attributeName: "aColor",
                size: 1,
                type: (0, $0fa4b07f86297abd$export$426db7a6155b7a80).UNSIGNED_BYTE,
                uploadFunction: this.uploadTint,
                offset: 0
            }
        ], this.shader = (0, $8f87c04218e7eb6d$export$462bb059fed9d9e5).from((0, $b2311882e46ccfe7$export$2e2bcd8739ae039), (0, $16e6d5e0e669640c$export$2e2bcd8739ae039), {}), this.state = (0, $2b269c8c39349f63$export$7254cc27399e90bd).for2d();
    }
    /**
   * Renders the particle container object.
   * @param container - The container to render using this ParticleRenderer.
   */ render(container) {
        const children = container.children, maxSize = container._maxSize, batchSize = container._batchSize, renderer = this.renderer;
        let totalChildren = children.length;
        if (totalChildren === 0) return;
        totalChildren > maxSize && !container.autoResize && (totalChildren = maxSize);
        let buffers = container._buffers;
        buffers || (buffers = container._buffers = this.generateBuffers(container));
        const baseTexture = children[0]._texture.baseTexture, premultiplied = baseTexture.alphaMode > 0;
        this.state.blendMode = (0, $db31fc3dfae4939b$exports).correctBlendMode(container.blendMode, premultiplied), renderer.state.set(this.state);
        const gl = renderer.gl, m = container.worldTransform.copyTo(this.tempMatrix);
        m.prepend(renderer.globalUniforms.uniforms.projectionMatrix), this.shader.uniforms.translationMatrix = m.toArray(!0), this.shader.uniforms.uColor = (0, $15154c33c9e19c5f$export$892596cec99bc70e).shared.setValue(container.tintRgb).premultiply(container.worldAlpha, premultiplied).toArray(this.shader.uniforms.uColor), this.shader.uniforms.uSampler = baseTexture, this.renderer.shader.bind(this.shader);
        let updateStatic = !1;
        for(let i = 0, j = 0; i < totalChildren; i += batchSize, j += 1){
            let amount = totalChildren - i;
            amount > batchSize && (amount = batchSize), j >= buffers.length && buffers.push(this._generateOneMoreBuffer(container));
            const buffer = buffers[j];
            buffer.uploadDynamic(children, i, amount);
            const bid = container._bufferUpdateIDs[j] || 0;
            updateStatic = updateStatic || buffer._updateID < bid, updateStatic && (buffer._updateID = container._updateID, buffer.uploadStatic(children, i, amount)), renderer.geometry.bind(buffer.geometry), gl.drawElements(gl.TRIANGLES, amount * 6, gl.UNSIGNED_SHORT, 0);
        }
    }
    /**
   * Creates one particle buffer for each child in the container we want to render and updates internal properties.
   * @param container - The container to render using this ParticleRenderer
   * @returns - The buffers
   */ generateBuffers(container) {
        const buffers = [], size = container._maxSize, batchSize = container._batchSize, dynamicPropertyFlags = container._properties;
        for(let i = 0; i < size; i += batchSize)buffers.push(new (0, $114044dcfa5e3cb0$export$ef6bb3c375ab2229)(this.properties, dynamicPropertyFlags, batchSize));
        return buffers;
    }
    /**
   * Creates one more particle buffer, because container has autoResize feature.
   * @param container - The container to render using this ParticleRenderer
   * @returns - The generated buffer
   */ _generateOneMoreBuffer(container) {
        const batchSize = container._batchSize, dynamicPropertyFlags = container._properties;
        return new (0, $114044dcfa5e3cb0$export$ef6bb3c375ab2229)(this.properties, dynamicPropertyFlags, batchSize);
    }
    /**
   * Uploads the vertices.
   * @param children - the array of sprites to render
   * @param startIndex - the index to start from in the children array
   * @param amount - the amount of children that will have their vertices uploaded
   * @param array - The vertices to upload.
   * @param stride - Stride to use for iteration.
   * @param offset - Offset to start at.
   */ uploadVertices(children, startIndex, amount, array, stride, offset) {
        let w0 = 0, w1 = 0, h0 = 0, h1 = 0;
        for(let i = 0; i < amount; ++i){
            const sprite = children[startIndex + i], texture = sprite._texture, sx = sprite.scale.x, sy = sprite.scale.y, trim = texture.trim, orig = texture.orig;
            trim ? (w1 = trim.x - sprite.anchor.x * orig.width, w0 = w1 + trim.width, h1 = trim.y - sprite.anchor.y * orig.height, h0 = h1 + trim.height) : (w0 = orig.width * (1 - sprite.anchor.x), w1 = orig.width * -sprite.anchor.x, h0 = orig.height * (1 - sprite.anchor.y), h1 = orig.height * -sprite.anchor.y), array[offset] = w1 * sx, array[offset + 1] = h1 * sy, array[offset + stride] = w0 * sx, array[offset + stride + 1] = h1 * sy, array[offset + stride * 2] = w0 * sx, array[offset + stride * 2 + 1] = h0 * sy, array[offset + stride * 3] = w1 * sx, array[offset + stride * 3 + 1] = h0 * sy, offset += stride * 4;
        }
    }
    /**
   * Uploads the position.
   * @param children - the array of sprites to render
   * @param startIndex - the index to start from in the children array
   * @param amount - the amount of children that will have their positions uploaded
   * @param array - The vertices to upload.
   * @param stride - Stride to use for iteration.
   * @param offset - Offset to start at.
   */ uploadPosition(children, startIndex, amount, array, stride, offset) {
        for(let i = 0; i < amount; i++){
            const spritePosition = children[startIndex + i].position;
            array[offset] = spritePosition.x, array[offset + 1] = spritePosition.y, array[offset + stride] = spritePosition.x, array[offset + stride + 1] = spritePosition.y, array[offset + stride * 2] = spritePosition.x, array[offset + stride * 2 + 1] = spritePosition.y, array[offset + stride * 3] = spritePosition.x, array[offset + stride * 3 + 1] = spritePosition.y, offset += stride * 4;
        }
    }
    /**
   * Uploads the rotation.
   * @param children - the array of sprites to render
   * @param startIndex - the index to start from in the children array
   * @param amount - the amount of children that will have their rotation uploaded
   * @param array - The vertices to upload.
   * @param stride - Stride to use for iteration.
   * @param offset - Offset to start at.
   */ uploadRotation(children, startIndex, amount, array, stride, offset) {
        for(let i = 0; i < amount; i++){
            const spriteRotation = children[startIndex + i].rotation;
            array[offset] = spriteRotation, array[offset + stride] = spriteRotation, array[offset + stride * 2] = spriteRotation, array[offset + stride * 3] = spriteRotation, offset += stride * 4;
        }
    }
    /**
   * Uploads the UVs.
   * @param children - the array of sprites to render
   * @param startIndex - the index to start from in the children array
   * @param amount - the amount of children that will have their rotation uploaded
   * @param array - The vertices to upload.
   * @param stride - Stride to use for iteration.
   * @param offset - Offset to start at.
   */ uploadUvs(children, startIndex, amount, array, stride, offset) {
        for(let i = 0; i < amount; ++i){
            const textureUvs = children[startIndex + i]._texture._uvs;
            textureUvs ? (array[offset] = textureUvs.x0, array[offset + 1] = textureUvs.y0, array[offset + stride] = textureUvs.x1, array[offset + stride + 1] = textureUvs.y1, array[offset + stride * 2] = textureUvs.x2, array[offset + stride * 2 + 1] = textureUvs.y2, array[offset + stride * 3] = textureUvs.x3, array[offset + stride * 3 + 1] = textureUvs.y3, offset += stride * 4) : (array[offset] = 0, array[offset + 1] = 0, array[offset + stride] = 0, array[offset + stride + 1] = 0, array[offset + stride * 2] = 0, array[offset + stride * 2 + 1] = 0, array[offset + stride * 3] = 0, array[offset + stride * 3 + 1] = 0, offset += stride * 4);
        }
    }
    /**
   * Uploads the tint.
   * @param children - the array of sprites to render
   * @param startIndex - the index to start from in the children array
   * @param amount - the amount of children that will have their rotation uploaded
   * @param array - The vertices to upload.
   * @param stride - Stride to use for iteration.
   * @param offset - Offset to start at.
   */ uploadTint(children, startIndex, amount, array, stride, offset) {
        for(let i = 0; i < amount; ++i){
            const sprite = children[startIndex + i], result = (0, $15154c33c9e19c5f$export$892596cec99bc70e).shared.setValue(sprite._tintRGB).toPremultiplied(sprite.alpha, sprite.texture.baseTexture.alphaMode > 0);
            array[offset] = result, array[offset + stride] = result, array[offset + stride * 2] = result, array[offset + stride * 3] = result, offset += stride * 4;
        }
    }
    /** Destroys the ParticleRenderer. */ destroy() {
        super.destroy(), this.shader && (this.shader.destroy(), this.shader = null), this.tempMatrix = null;
    }
}
$4353158ed3ef33a8$export$42cbb08a275c7ff9.extension = {
    name: "particle",
    type: (0, $c90155f6d7d8d8f6$export$4f037c6ec2da4eeb).RendererPlugin
};
(0, $c90155f6d7d8d8f6$export$cc3e2d3244e01b7f).add($4353158ed3ef33a8$export$42cbb08a275c7ff9);







var $029097fab1db53a0$export$131daa784848984 = /* @__PURE__ */ ((TEXT_GRADIENT2)=>(TEXT_GRADIENT2[TEXT_GRADIENT2.LINEAR_VERTICAL = 0] = "LINEAR_VERTICAL", TEXT_GRADIENT2[TEXT_GRADIENT2.LINEAR_HORIZONTAL = 1] = "LINEAR_HORIZONTAL", TEXT_GRADIENT2))($029097fab1db53a0$export$131daa784848984 || {});






const $31f48a8131702733$var$contextSettings = {
    // TextMetrics requires getImageData readback for measuring fonts.
    willReadFrequently: !0
}, $31f48a8131702733$var$_TextMetrics = class _TextMetrics2 {
    /**
   * Checking that we can use modern canvas 2D API.
   *
   * Note: This is an unstable API, Chrome < 94 use `textLetterSpacing`, later versions use `letterSpacing`.
   * @see PIXI.TextMetrics.experimentalLetterSpacing
   * @see https://developer.mozilla.org/en-US/docs/Web/API/CanvasRenderingContext2D/letterSpacing
   * @see https://developer.chrome.com/origintrials/#/view_trial/3585991203293757441
   */ static get experimentalLetterSpacingSupported() {
        let result = _TextMetrics2._experimentalLetterSpacingSupported;
        if (result !== void 0) {
            const proto = (0, $2808efac47e52be0$export$a5a6e0b888b2c992).ADAPTER.getCanvasRenderingContext2D().prototype;
            result = _TextMetrics2._experimentalLetterSpacingSupported = "letterSpacing" in proto || "textLetterSpacing" in proto;
        }
        return result;
    }
    /**
   * @param text - the text that was measured
   * @param style - the style that was measured
   * @param width - the measured width of the text
   * @param height - the measured height of the text
   * @param lines - an array of the lines of text broken by new lines and wrapping if specified in style
   * @param lineWidths - an array of the line widths for each line matched to `lines`
   * @param lineHeight - the measured line height for this style
   * @param maxLineWidth - the maximum line width for all measured lines
   * @param {PIXI.IFontMetrics} fontProperties - the font properties object from TextMetrics.measureFont
   */ constructor(text, style, width, height, lines, lineWidths, lineHeight, maxLineWidth, fontProperties){
        this.text = text, this.style = style, this.width = width, this.height = height, this.lines = lines, this.lineWidths = lineWidths, this.lineHeight = lineHeight, this.maxLineWidth = maxLineWidth, this.fontProperties = fontProperties;
    }
    /**
   * Measures the supplied string of text and returns a Rectangle.
   * @param text - The text to measure.
   * @param style - The text style to use for measuring
   * @param wordWrap - Override for if word-wrap should be applied to the text.
   * @param canvas - optional specification of the canvas to use for measuring.
   * @returns Measured width and height of the text.
   */ static measureText(text, style, wordWrap, canvas = _TextMetrics2._canvas) {
        wordWrap = wordWrap ?? style.wordWrap;
        const font = style.toFontString(), fontProperties = _TextMetrics2.measureFont(font);
        fontProperties.fontSize === 0 && (fontProperties.fontSize = style.fontSize, fontProperties.ascent = style.fontSize);
        const context = canvas.getContext("2d", $31f48a8131702733$var$contextSettings);
        context.font = font;
        const lines = (wordWrap ? _TextMetrics2.wordWrap(text, style, canvas) : text).split(/(?:\r\n|\r|\n)/), lineWidths = new Array(lines.length);
        let maxLineWidth = 0;
        for(let i = 0; i < lines.length; i++){
            const lineWidth = _TextMetrics2._measureText(lines[i], style.letterSpacing, context);
            lineWidths[i] = lineWidth, maxLineWidth = Math.max(maxLineWidth, lineWidth);
        }
        let width = maxLineWidth + style.strokeThickness;
        style.dropShadow && (width += style.dropShadowDistance);
        const lineHeight = style.lineHeight || fontProperties.fontSize + style.strokeThickness;
        let height = Math.max(lineHeight, fontProperties.fontSize + style.strokeThickness * 2) + style.leading + (lines.length - 1) * (lineHeight + style.leading);
        return style.dropShadow && (height += style.dropShadowDistance), new _TextMetrics2(text, style, width, height, lines, lineWidths, lineHeight + style.leading, maxLineWidth, fontProperties);
    }
    static _measureText(text, letterSpacing, context) {
        let useExperimentalLetterSpacing = !1;
        _TextMetrics2.experimentalLetterSpacingSupported && (_TextMetrics2.experimentalLetterSpacing ? (context.letterSpacing = `${letterSpacing}px`, context.textLetterSpacing = `${letterSpacing}px`, useExperimentalLetterSpacing = !0) : (context.letterSpacing = "0px", context.textLetterSpacing = "0px"));
        let width = context.measureText(text).width;
        return width > 0 && (useExperimentalLetterSpacing ? width -= letterSpacing : width += (_TextMetrics2.graphemeSegmenter(text).length - 1) * letterSpacing), width;
    }
    /**
   * Applies newlines to a string to have it optimally fit into the horizontal
   * bounds set by the Text object's wordWrapWidth property.
   * @param text - String to apply word wrapping to
   * @param style - the style to use when wrapping
   * @param canvas - optional specification of the canvas to use for measuring.
   * @returns New string with new lines applied where required
   */ static wordWrap(text, style, canvas = _TextMetrics2._canvas) {
        const context = canvas.getContext("2d", $31f48a8131702733$var$contextSettings);
        let width = 0, line = "", lines = "";
        const cache = /* @__PURE__ */ Object.create(null), { letterSpacing: letterSpacing, whiteSpace: whiteSpace } = style, collapseSpaces = _TextMetrics2.collapseSpaces(whiteSpace), collapseNewlines = _TextMetrics2.collapseNewlines(whiteSpace);
        let canPrependSpaces = !collapseSpaces;
        const wordWrapWidth = style.wordWrapWidth + letterSpacing, tokens = _TextMetrics2.tokenize(text);
        for(let i = 0; i < tokens.length; i++){
            let token = tokens[i];
            if (_TextMetrics2.isNewline(token)) {
                if (!collapseNewlines) {
                    lines += _TextMetrics2.addLine(line), canPrependSpaces = !collapseSpaces, line = "", width = 0;
                    continue;
                }
                token = " ";
            }
            if (collapseSpaces) {
                const currIsBreakingSpace = _TextMetrics2.isBreakingSpace(token), lastIsBreakingSpace = _TextMetrics2.isBreakingSpace(line[line.length - 1]);
                if (currIsBreakingSpace && lastIsBreakingSpace) continue;
            }
            const tokenWidth = _TextMetrics2.getFromCache(token, letterSpacing, cache, context);
            if (tokenWidth > wordWrapWidth) {
                if (line !== "" && (lines += _TextMetrics2.addLine(line), line = "", width = 0), _TextMetrics2.canBreakWords(token, style.breakWords)) {
                    const characters = _TextMetrics2.wordWrapSplit(token);
                    for(let j = 0; j < characters.length; j++){
                        let char = characters[j], lastChar = char, k = 1;
                        for(; characters[j + k];){
                            const nextChar = characters[j + k];
                            if (!_TextMetrics2.canBreakChars(lastChar, nextChar, token, j, style.breakWords)) char += nextChar;
                            else break;
                            lastChar = nextChar, k++;
                        }
                        j += k - 1;
                        const characterWidth = _TextMetrics2.getFromCache(char, letterSpacing, cache, context);
                        characterWidth + width > wordWrapWidth && (lines += _TextMetrics2.addLine(line), canPrependSpaces = !1, line = "", width = 0), line += char, width += characterWidth;
                    }
                } else {
                    line.length > 0 && (lines += _TextMetrics2.addLine(line), line = "", width = 0);
                    const isLastToken = i === tokens.length - 1;
                    lines += _TextMetrics2.addLine(token, !isLastToken), canPrependSpaces = !1, line = "", width = 0;
                }
            } else tokenWidth + width > wordWrapWidth && (canPrependSpaces = !1, lines += _TextMetrics2.addLine(line), line = "", width = 0), (line.length > 0 || !_TextMetrics2.isBreakingSpace(token) || canPrependSpaces) && (line += token, width += tokenWidth);
        }
        return lines += _TextMetrics2.addLine(line, !1), lines;
    }
    /**
   * Convienience function for logging each line added during the wordWrap method.
   * @param line    - The line of text to add
   * @param newLine - Add new line character to end
   * @returns A formatted line
   */ static addLine(line, newLine = !0) {
        return line = _TextMetrics2.trimRight(line), line = newLine ? `${line}
` : line, line;
    }
    /**
   * Gets & sets the widths of calculated characters in a cache object
   * @param key            - The key
   * @param letterSpacing  - The letter spacing
   * @param cache          - The cache
   * @param context        - The canvas context
   * @returns The from cache.
   */ static getFromCache(key, letterSpacing, cache, context) {
        let width = cache[key];
        return typeof width != "number" && (width = _TextMetrics2._measureText(key, letterSpacing, context) + letterSpacing, cache[key] = width), width;
    }
    /**
   * Determines whether we should collapse breaking spaces.
   * @param whiteSpace - The TextStyle property whiteSpace
   * @returns Should collapse
   */ static collapseSpaces(whiteSpace) {
        return whiteSpace === "normal" || whiteSpace === "pre-line";
    }
    /**
   * Determines whether we should collapse newLine chars.
   * @param whiteSpace - The white space
   * @returns should collapse
   */ static collapseNewlines(whiteSpace) {
        return whiteSpace === "normal";
    }
    /**
   * Trims breaking whitespaces from string.
   * @param text - The text
   * @returns Trimmed string
   */ static trimRight(text) {
        if (typeof text != "string") return "";
        for(let i = text.length - 1; i >= 0; i--){
            const char = text[i];
            if (!_TextMetrics2.isBreakingSpace(char)) break;
            text = text.slice(0, -1);
        }
        return text;
    }
    /**
   * Determines if char is a newline.
   * @param char - The character
   * @returns True if newline, False otherwise.
   */ static isNewline(char) {
        return typeof char != "string" ? !1 : _TextMetrics2._newlines.includes(char.charCodeAt(0));
    }
    /**
   * Determines if char is a breaking whitespace.
   *
   * It allows one to determine whether char should be a breaking whitespace
   * For example certain characters in CJK langs or numbers.
   * It must return a boolean.
   * @param char - The character
   * @param [_nextChar] - The next character
   * @returns True if whitespace, False otherwise.
   */ static isBreakingSpace(char, _nextChar) {
        return typeof char != "string" ? !1 : _TextMetrics2._breakingSpaces.includes(char.charCodeAt(0));
    }
    /**
   * Splits a string into words, breaking-spaces and newLine characters
   * @param text - The text
   * @returns A tokenized array
   */ static tokenize(text) {
        const tokens = [];
        let token = "";
        if (typeof text != "string") return tokens;
        for(let i = 0; i < text.length; i++){
            const char = text[i], nextChar = text[i + 1];
            if (_TextMetrics2.isBreakingSpace(char, nextChar) || _TextMetrics2.isNewline(char)) {
                token !== "" && (tokens.push(token), token = ""), tokens.push(char);
                continue;
            }
            token += char;
        }
        return token !== "" && tokens.push(token), tokens;
    }
    /**
   * Overridable helper method used internally by TextMetrics, exposed to allow customizing the class's behavior.
   *
   * It allows one to customise which words should break
   * Examples are if the token is CJK or numbers.
   * It must return a boolean.
   * @param _token - The token
   * @param breakWords - The style attr break words
   * @returns Whether to break word or not
   */ static canBreakWords(_token, breakWords) {
        return breakWords;
    }
    /**
   * Overridable helper method used internally by TextMetrics, exposed to allow customizing the class's behavior.
   *
   * It allows one to determine whether a pair of characters
   * should be broken by newlines
   * For example certain characters in CJK langs or numbers.
   * It must return a boolean.
   * @param _char - The character
   * @param _nextChar - The next character
   * @param _token - The token/word the characters are from
   * @param _index - The index in the token of the char
   * @param _breakWords - The style attr break words
   * @returns whether to break word or not
   */ static canBreakChars(_char, _nextChar, _token, _index, _breakWords) {
        return !0;
    }
    /**
   * Overridable helper method used internally by TextMetrics, exposed to allow customizing the class's behavior.
   *
   * It is called when a token (usually a word) has to be split into separate pieces
   * in order to determine the point to break a word.
   * It must return an array of characters.
   * @param token - The token to split
   * @returns The characters of the token
   * @see TextMetrics.graphemeSegmenter
   */ static wordWrapSplit(token) {
        return _TextMetrics2.graphemeSegmenter(token);
    }
    /**
   * Calculates the ascent, descent and fontSize of a given font-style
   * @param font - String representing the style of the font
   * @returns Font properties object
   */ static measureFont(font) {
        if (_TextMetrics2._fonts[font]) return _TextMetrics2._fonts[font];
        const properties = {
            ascent: 0,
            descent: 0,
            fontSize: 0
        }, canvas = _TextMetrics2._canvas, context = _TextMetrics2._context;
        context.font = font;
        const metricsString = _TextMetrics2.METRICS_STRING + _TextMetrics2.BASELINE_SYMBOL, width = Math.ceil(context.measureText(metricsString).width);
        let baseline = Math.ceil(context.measureText(_TextMetrics2.BASELINE_SYMBOL).width);
        const height = Math.ceil(_TextMetrics2.HEIGHT_MULTIPLIER * baseline);
        if (baseline = baseline * _TextMetrics2.BASELINE_MULTIPLIER | 0, width === 0 || height === 0) return _TextMetrics2._fonts[font] = properties, properties;
        canvas.width = width, canvas.height = height, context.fillStyle = "#f00", context.fillRect(0, 0, width, height), context.font = font, context.textBaseline = "alphabetic", context.fillStyle = "#000", context.fillText(metricsString, 0, baseline);
        const imagedata = context.getImageData(0, 0, width, height).data, pixels = imagedata.length, line = width * 4;
        let i = 0, idx = 0, stop = !1;
        for(i = 0; i < baseline; ++i){
            for(let j = 0; j < line; j += 4)if (imagedata[idx + j] !== 255) {
                stop = !0;
                break;
            }
            if (!stop) idx += line;
            else break;
        }
        for(properties.ascent = baseline - i, idx = pixels - line, stop = !1, i = height; i > baseline; --i){
            for(let j = 0; j < line; j += 4)if (imagedata[idx + j] !== 255) {
                stop = !0;
                break;
            }
            if (!stop) idx -= line;
            else break;
        }
        return properties.descent = i - baseline, properties.fontSize = properties.ascent + properties.descent, _TextMetrics2._fonts[font] = properties, properties;
    }
    /**
   * Clear font metrics in metrics cache.
   * @param {string} [font] - font name. If font name not set then clear cache for all fonts.
   */ static clearMetrics(font = "") {
        font ? delete _TextMetrics2._fonts[font] : _TextMetrics2._fonts = {};
    }
    /**
   * Cached canvas element for measuring text
   * TODO: this should be private, but isn't because of backward compat, will fix later.
   * @ignore
   */ static get _canvas() {
        if (!_TextMetrics2.__canvas) {
            let canvas;
            try {
                const c = new OffscreenCanvas(0, 0);
                if (c.getContext("2d", $31f48a8131702733$var$contextSettings)?.measureText) return _TextMetrics2.__canvas = c, c;
                canvas = (0, $2808efac47e52be0$export$a5a6e0b888b2c992).ADAPTER.createCanvas();
            } catch  {
                canvas = (0, $2808efac47e52be0$export$a5a6e0b888b2c992).ADAPTER.createCanvas();
            }
            canvas.width = canvas.height = 10, _TextMetrics2.__canvas = canvas;
        }
        return _TextMetrics2.__canvas;
    }
    /**
   * TODO: this should be private, but isn't because of backward compat, will fix later.
   * @ignore
   */ static get _context() {
        return _TextMetrics2.__context || (_TextMetrics2.__context = _TextMetrics2._canvas.getContext("2d", $31f48a8131702733$var$contextSettings)), _TextMetrics2.__context;
    }
};
$31f48a8131702733$var$_TextMetrics.METRICS_STRING = "|\xc9q\xc5", /** Baseline symbol for calculate font metrics. */ $31f48a8131702733$var$_TextMetrics.BASELINE_SYMBOL = "M", /** Baseline multiplier for calculate font metrics. */ $31f48a8131702733$var$_TextMetrics.BASELINE_MULTIPLIER = 1.4, /** Height multiplier for setting height of canvas to calculate font metrics. */ $31f48a8131702733$var$_TextMetrics.HEIGHT_MULTIPLIER = 2, /**
* A Unicode "character", or "grapheme cluster", can be composed of multiple Unicode code points,
* such as letters with diacritical marks (e.g. `'\u0065\u0301'`, letter e with acute)
* or emojis with modifiers (e.g. `'\uD83E\uDDD1\u200D\uD83D\uDCBB'`, technologist).
* The new `Intl.Segmenter` API in ES2022 can split the string into grapheme clusters correctly. If it is not available,
* PixiJS will fallback to use the iterator of String, which can only spilt the string into code points.
* If you want to get full functionality in environments that don't support `Intl.Segmenter` (such as Firefox),
* you can use other libraries such as [grapheme-splitter]{@link https://www.npmjs.com/package/grapheme-splitter}
* or [graphemer]{@link https://www.npmjs.com/package/graphemer} to create a polyfill. Since these libraries can be
* relatively large in size to handle various Unicode grapheme clusters properly, PixiJS won't use them directly.
*/ $31f48a8131702733$var$_TextMetrics.graphemeSegmenter = (()=>{
    if (typeof Intl?.Segmenter == "function") {
        const segmenter = new Intl.Segmenter();
        return (s)=>[
                ...segmenter.segment(s)
            ].map((x)=>x.segment);
    }
    return (s)=>[
            ...s
        ];
})(), /**
* New rendering behavior for letter-spacing which uses Chrome's new native API. This will
* lead to more accurate letter-spacing results because it does not try to manually draw
* each character. However, this Chrome API is experimental and may not serve all cases yet.
* @see PIXI.TextMetrics.experimentalLetterSpacingSupported
*/ $31f48a8131702733$var$_TextMetrics.experimentalLetterSpacing = !1, /** Cache of {@see PIXI.TextMetrics.FontMetrics} objects. */ $31f48a8131702733$var$_TextMetrics._fonts = {}, /** Cache of new line chars. */ $31f48a8131702733$var$_TextMetrics._newlines = [
    10,
    // line feed
    13
], /** Cache of breaking spaces. */ $31f48a8131702733$var$_TextMetrics._breakingSpaces = [
    9,
    // character tabulation
    32,
    // space
    8192,
    // en quad
    8193,
    // em quad
    8194,
    // en space
    8195,
    // em space
    8196,
    // three-per-em space
    8197,
    // four-per-em space
    8198,
    // six-per-em space
    8200,
    // punctuation space
    8201,
    // thin space
    8202,
    // hair space
    8287,
    // medium mathematical space
    12288
];
let $31f48a8131702733$export$4c5a129a59e1ef34 = $31f48a8131702733$var$_TextMetrics;




const $3d453260a3c8e0f7$var$genericFontFamilies = [
    "serif",
    "sans-serif",
    "monospace",
    "cursive",
    "fantasy",
    "system-ui"
], $3d453260a3c8e0f7$var$_TextStyle = class _TextStyle2 {
    /**
   * @param style - TextStyle properties to be set on the text. See {@link PIXI.TextStyle.defaultStyle}
   *       for the default values.
   */ constructor(style){
        this.styleID = 0, this.reset(), $3d453260a3c8e0f7$var$deepCopyProperties(this, style, style);
    }
    /**
   * Creates a new TextStyle object with the same values as this one.
   * Note that the only the properties of the object are cloned.
   *
   * @return New cloned TextStyle object
   */ clone() {
        const clonedProperties = {};
        return $3d453260a3c8e0f7$var$deepCopyProperties(clonedProperties, this, _TextStyle2.defaultStyle), new _TextStyle2(clonedProperties);
    }
    /** Resets all properties to the defaults specified in TextStyle.prototype._default */ reset() {
        $3d453260a3c8e0f7$var$deepCopyProperties(this, _TextStyle2.defaultStyle, _TextStyle2.defaultStyle);
    }
    /**
   * Alignment for multiline text, does not affect single line text.
   *
   * @member {'left'|'center'|'right'|'justify'}
   */ get align() {
        return this._align;
    }
    set align(align) {
        this._align !== align && (this._align = align, this.styleID++);
    }
    /** Indicates if lines can be wrapped within words, it needs wordWrap to be set to true. */ get breakWords() {
        return this._breakWords;
    }
    set breakWords(breakWords) {
        this._breakWords !== breakWords && (this._breakWords = breakWords, this.styleID++);
    }
    /** Set a drop shadow for the text. */ get dropShadow() {
        return this._dropShadow;
    }
    set dropShadow(dropShadow) {
        this._dropShadow !== dropShadow && (this._dropShadow = dropShadow, this.styleID++);
    }
    /** Set alpha for the drop shadow. */ get dropShadowAlpha() {
        return this._dropShadowAlpha;
    }
    set dropShadowAlpha(dropShadowAlpha) {
        this._dropShadowAlpha !== dropShadowAlpha && (this._dropShadowAlpha = dropShadowAlpha, this.styleID++);
    }
    /** Set a angle of the drop shadow. */ get dropShadowAngle() {
        return this._dropShadowAngle;
    }
    set dropShadowAngle(dropShadowAngle) {
        this._dropShadowAngle !== dropShadowAngle && (this._dropShadowAngle = dropShadowAngle, this.styleID++);
    }
    /** Set a shadow blur radius. */ get dropShadowBlur() {
        return this._dropShadowBlur;
    }
    set dropShadowBlur(dropShadowBlur) {
        this._dropShadowBlur !== dropShadowBlur && (this._dropShadowBlur = dropShadowBlur, this.styleID++);
    }
    /** A fill style to be used on the dropshadow e.g., 'red', '#00FF00'. */ get dropShadowColor() {
        return this._dropShadowColor;
    }
    set dropShadowColor(dropShadowColor) {
        const outputColor = $3d453260a3c8e0f7$var$getColor(dropShadowColor);
        this._dropShadowColor !== outputColor && (this._dropShadowColor = outputColor, this.styleID++);
    }
    /** Set a distance of the drop shadow. */ get dropShadowDistance() {
        return this._dropShadowDistance;
    }
    set dropShadowDistance(dropShadowDistance) {
        this._dropShadowDistance !== dropShadowDistance && (this._dropShadowDistance = dropShadowDistance, this.styleID++);
    }
    /**
   * A canvas fillstyle that will be used on the text e.g., 'red', '#00FF00'.
   *
   * Can be an array to create a gradient e.g., `['#000000','#FFFFFF']`
   * {@link https://developer.mozilla.org/en-US/docs/Web/API/CanvasRenderingContext2D/fillStyle|MDN}
   *
   * @member {string|string[]|number|number[]|CanvasGradient|CanvasPattern}
   */ get fill() {
        return this._fill;
    }
    set fill(fill) {
        const outputColor = $3d453260a3c8e0f7$var$getColor(fill);
        this._fill !== outputColor && (this._fill = outputColor, this.styleID++);
    }
    /**
   * If fill is an array of colours to create a gradient, this can change the type/direction of the gradient.
   *
   * @type {PIXI.TEXT_GRADIENT}
   */ get fillGradientType() {
        return this._fillGradientType;
    }
    set fillGradientType(fillGradientType) {
        this._fillGradientType !== fillGradientType && (this._fillGradientType = fillGradientType, this.styleID++);
    }
    /**
   * If fill is an array of colours to create a gradient, this array can set the stop points
   * (numbers between 0 and 1) for the color, overriding the default behaviour of evenly spacing them.
   */ get fillGradientStops() {
        return this._fillGradientStops;
    }
    set fillGradientStops(fillGradientStops) {
        $3d453260a3c8e0f7$var$areArraysEqual(this._fillGradientStops, fillGradientStops) || (this._fillGradientStops = fillGradientStops, this.styleID++);
    }
    /**
   * The font family, can be a single font name, or a list of names where the first
   * is the preferred font.
   */ get fontFamily() {
        return this._fontFamily;
    }
    set fontFamily(fontFamily) {
        this.fontFamily !== fontFamily && (this._fontFamily = fontFamily, this.styleID++);
    }
    /**
   * The font size
   * (as a number it converts to px, but as a string, equivalents are '26px','20pt','160%' or '1.6em')
   */ get fontSize() {
        return this._fontSize;
    }
    set fontSize(fontSize) {
        this._fontSize !== fontSize && (this._fontSize = fontSize, this.styleID++);
    }
    /**
   * The font style.
   *
   * @member {'normal'|'italic'|'oblique'}
   */ get fontStyle() {
        return this._fontStyle;
    }
    set fontStyle(fontStyle) {
        this._fontStyle !== fontStyle && (this._fontStyle = fontStyle, this.styleID++);
    }
    /**
   * The font variant.
   *
   * @member {'normal'|'small-caps'}
   */ get fontVariant() {
        return this._fontVariant;
    }
    set fontVariant(fontVariant) {
        this._fontVariant !== fontVariant && (this._fontVariant = fontVariant, this.styleID++);
    }
    /**
   * The font weight.
   *
   * @member {'normal'|'bold'|'bolder'|'lighter'|'100'|'200'|'300'|'400'|'500'|'600'|'700'|'800'|'900'}
   */ get fontWeight() {
        return this._fontWeight;
    }
    set fontWeight(fontWeight) {
        this._fontWeight !== fontWeight && (this._fontWeight = fontWeight, this.styleID++);
    }
    /** The amount of spacing between letters, default is 0. */ get letterSpacing() {
        return this._letterSpacing;
    }
    set letterSpacing(letterSpacing) {
        this._letterSpacing !== letterSpacing && (this._letterSpacing = letterSpacing, this.styleID++);
    }
    /** The line height, a number that represents the vertical space that a letter uses. */ get lineHeight() {
        return this._lineHeight;
    }
    set lineHeight(lineHeight) {
        this._lineHeight !== lineHeight && (this._lineHeight = lineHeight, this.styleID++);
    }
    /** The space between lines. */ get leading() {
        return this._leading;
    }
    set leading(leading) {
        this._leading !== leading && (this._leading = leading, this.styleID++);
    }
    /**
   * The lineJoin property sets the type of corner created, it can resolve spiked text issues.
   * Default is 'miter' (creates a sharp corner).
   *
   * @member {'miter'|'round'|'bevel'}
   */ get lineJoin() {
        return this._lineJoin;
    }
    set lineJoin(lineJoin) {
        this._lineJoin !== lineJoin && (this._lineJoin = lineJoin, this.styleID++);
    }
    /**
   * The miter limit to use when using the 'miter' lineJoin mode.
   *
   * This can reduce or increase the spikiness of rendered text.
   */ get miterLimit() {
        return this._miterLimit;
    }
    set miterLimit(miterLimit) {
        this._miterLimit !== miterLimit && (this._miterLimit = miterLimit, this.styleID++);
    }
    /**
   * Occasionally some fonts are cropped. Adding some padding will prevent this from happening
   * by adding padding to all sides of the text.
   */ get padding() {
        return this._padding;
    }
    set padding(padding) {
        this._padding !== padding && (this._padding = padding, this.styleID++);
    }
    /**
   * A canvas fillstyle that will be used on the text stroke, e.g., 'blue', '#FCFF00'
   */ get stroke() {
        return this._stroke;
    }
    set stroke(stroke) {
        const outputColor = $3d453260a3c8e0f7$var$getColor(stroke);
        this._stroke !== outputColor && (this._stroke = outputColor, this.styleID++);
    }
    /**
   * A number that represents the thickness of the stroke.
   *
   * @default 0
   */ get strokeThickness() {
        return this._strokeThickness;
    }
    set strokeThickness(strokeThickness) {
        this._strokeThickness !== strokeThickness && (this._strokeThickness = strokeThickness, this.styleID++);
    }
    /**
   * The baseline of the text that is rendered.
   *
   * @member {'alphabetic'|'top'|'hanging'|'middle'|'ideographic'|'bottom'}
   */ get textBaseline() {
        return this._textBaseline;
    }
    set textBaseline(textBaseline) {
        this._textBaseline !== textBaseline && (this._textBaseline = textBaseline, this.styleID++);
    }
    /** Trim transparent borders. */ get trim() {
        return this._trim;
    }
    set trim(trim) {
        this._trim !== trim && (this._trim = trim, this.styleID++);
    }
    /**
   * How newlines and spaces should be handled.
   * Default is 'pre' (preserve, preserve).
   *
   *  value       | New lines     |   Spaces
   *  ---         | ---           |   ---
   * 'normal'     | Collapse      |   Collapse
   * 'pre'        | Preserve      |   Preserve
   * 'pre-line'   | Preserve      |   Collapse
   *
   * @member {'normal'|'pre'|'pre-line'}
   */ get whiteSpace() {
        return this._whiteSpace;
    }
    set whiteSpace(whiteSpace) {
        this._whiteSpace !== whiteSpace && (this._whiteSpace = whiteSpace, this.styleID++);
    }
    /** Indicates if word wrap should be used. */ get wordWrap() {
        return this._wordWrap;
    }
    set wordWrap(wordWrap) {
        this._wordWrap !== wordWrap && (this._wordWrap = wordWrap, this.styleID++);
    }
    /** The width at which text will wrap, it needs wordWrap to be set to true. */ get wordWrapWidth() {
        return this._wordWrapWidth;
    }
    set wordWrapWidth(wordWrapWidth) {
        this._wordWrapWidth !== wordWrapWidth && (this._wordWrapWidth = wordWrapWidth, this.styleID++);
    }
    /**
   * Generates a font style string to use for `TextMetrics.measureFont()`.
   *
   * @return Font style string, for passing to `TextMetrics.measureFont()`
   */ toFontString() {
        const fontSizeString = typeof this.fontSize == "number" ? `${this.fontSize}px` : this.fontSize;
        let fontFamilies = this.fontFamily;
        Array.isArray(this.fontFamily) || (fontFamilies = this.fontFamily.split(","));
        for(let i = fontFamilies.length - 1; i >= 0; i--){
            let fontFamily = fontFamilies[i].trim();
            !/([\"\'])[^\'\"]+\1/.test(fontFamily) && !$3d453260a3c8e0f7$var$genericFontFamilies.includes(fontFamily) && (fontFamily = `"${fontFamily}"`), fontFamilies[i] = fontFamily;
        }
        return `${this.fontStyle} ${this.fontVariant} ${this.fontWeight} ${fontSizeString} ${fontFamilies.join(",")}`;
    }
};
$3d453260a3c8e0f7$var$_TextStyle.defaultStyle = {
    /**
   * See {@link PIXI.TextStyle.align}
   * @type {'left'|'center'|'right'|'justify'}
   */ align: "left",
    /** See {@link PIXI.TextStyle.breakWords} */ breakWords: !1,
    /** See {@link PIXI.TextStyle.dropShadow} */ dropShadow: !1,
    /** See {@link PIXI.TextStyle.dropShadowAlpha} */ dropShadowAlpha: 1,
    /**
   * See {@link PIXI.TextStyle.dropShadowAngle}
   * @type {number}
   * @default Math.PI / 6
   */ dropShadowAngle: Math.PI / 6,
    /** See {@link PIXI.TextStyle.dropShadowBlur} */ dropShadowBlur: 0,
    /**
   * See {@link PIXI.TextStyle.dropShadowColor}
   * @type {string|number}
   */ dropShadowColor: "black",
    /** See {@link PIXI.TextStyle.dropShadowDistance} */ dropShadowDistance: 5,
    /**
   * See {@link PIXI.TextStyle.fill}
   * @type {string|string[]|number|number[]|CanvasGradient|CanvasPattern}
   */ fill: "black",
    /**
   * See {@link PIXI.TextStyle.fillGradientType}
   * @type {PIXI.TEXT_GRADIENT}
   * @default PIXI.TEXT_GRADIENT.LINEAR_VERTICAL
   */ fillGradientType: (0, $029097fab1db53a0$export$131daa784848984).LINEAR_VERTICAL,
    /**
   * See {@link PIXI.TextStyle.fillGradientStops}
   * @type {number[]}
   * @default []
   */ fillGradientStops: [],
    /**
   * See {@link PIXI.TextStyle.fontFamily}
   * @type {string|string[]}
   */ fontFamily: "Arial",
    /**
   * See {@link PIXI.TextStyle.fontSize}
   * @type {number|string} 
   */ fontSize: 26,
    /**
   * See {@link PIXI.TextStyle.fontStyle}
   * @type {'normal'|'italic'|'oblique'}
   */ fontStyle: "normal",
    /**
   * See {@link PIXI.TextStyle.fontVariant}
   * @type {'normal'|'small-caps'}
   */ fontVariant: "normal",
    /**
   * See {@link PIXI.TextStyle.fontWeight}
   * @type {'normal'|'bold'|'bolder'|'lighter'|'100'|'200'|'300'|'400'|'500'|'600'|'700'|'800'|'900'}
   */ fontWeight: "normal",
    /** See {@link PIXI.TextStyle.leading} */ leading: 0,
    /** See {@link PIXI.TextStyle.letterSpacing} */ letterSpacing: 0,
    /** See {@link PIXI.TextStyle.lineHeight} */ lineHeight: 0,
    /**
   * See {@link PIXI.TextStyle.lineJoin}
   * @type {'miter'|'round'|'bevel'}
   */ lineJoin: "miter",
    /** See {@link PIXI.TextStyle.miterLimit} */ miterLimit: 10,
    /** See {@link PIXI.TextStyle.padding} */ padding: 0,
    /**
   * See {@link PIXI.TextStyle.stroke}
   * @type {string|number}
   */ stroke: "black",
    /** See {@link PIXI.TextStyle.strokeThickness} */ strokeThickness: 0,
    /**
   * See {@link PIXI.TextStyle.textBaseline} 
   * @type {'alphabetic'|'top'|'hanging'|'middle'|'ideographic'|'bottom'}
   */ textBaseline: "alphabetic",
    /** See {@link PIXI.TextStyle.trim} */ trim: !1,
    /**
   * See {@link PIXI.TextStyle.whiteSpace}
   * @type {'normal'|'pre'|'pre-line'}
   */ whiteSpace: "pre",
    /** See {@link PIXI.TextStyle.wordWrap} */ wordWrap: !1,
    /** See {@link PIXI.TextStyle.wordWrapWidth} */ wordWrapWidth: 100
};
let $3d453260a3c8e0f7$export$1df879243bf2e42d = $3d453260a3c8e0f7$var$_TextStyle;
function $3d453260a3c8e0f7$var$getColor(color) {
    const temp = (0, $15154c33c9e19c5f$export$892596cec99bc70e).shared, format = (color2)=>{
        const res = temp.setValue(color2);
        return res.alpha === 1 ? res.toHex() : res.toRgbaString();
    };
    return Array.isArray(color) ? color.map(format) : format(color);
}
function $3d453260a3c8e0f7$var$areArraysEqual(array1, array2) {
    if (!Array.isArray(array1) || !Array.isArray(array2) || array1.length !== array2.length) return !1;
    for(let i = 0; i < array1.length; ++i)if (array1[i] !== array2[i]) return !1;
    return !0;
}
function $3d453260a3c8e0f7$var$deepCopyProperties(target, source, propertyObj) {
    for(const prop in propertyObj)Array.isArray(source[prop]) ? target[prop] = source[prop].slice() : target[prop] = source[prop];
}


const $f4ede730be703e5d$var$defaultDestroyOptions = {
    texture: !0,
    children: !1,
    baseTexture: !0
}, $f4ede730be703e5d$var$_Text = class _Text2 extends (0, $e4c5b2569bd3a8d2$export$3075603db8e6204c) {
    /**
   * @param text - The string that you would like the text to display
   * @param style - The style parameters
   * @param canvas - The canvas element for drawing text
   */ constructor(text, style, canvas){
        let ownCanvas = !1;
        canvas || (canvas = (0, $2808efac47e52be0$export$a5a6e0b888b2c992).ADAPTER.createCanvas(), ownCanvas = !0), canvas.width = 3, canvas.height = 3;
        const texture = (0, $14896914ad3ae15d$export$5431306cf43de24a).from(canvas);
        texture.orig = new (0, $200f778d7fdbf8ac$export$4617fb02663045ef)(), texture.trim = new (0, $200f778d7fdbf8ac$export$4617fb02663045ef)(), super(texture), this._ownCanvas = ownCanvas, this.canvas = canvas, this.context = canvas.getContext("2d", {
            // required for trimming to work without warnings
            willReadFrequently: !0
        }), this._resolution = _Text2.defaultResolution ?? (0, $2808efac47e52be0$export$a5a6e0b888b2c992).RESOLUTION, this._autoResolution = _Text2.defaultAutoResolution, this._text = null, this._style = null, this._styleListener = null, this._font = "", this.text = text, this.style = style, this.localStyleID = -1;
    }
    /**
   * @see PIXI.TextMetrics.experimentalLetterSpacing
   * @deprecated since 7.1.0
   */ static get experimentalLetterSpacing() {
        return (0, $31f48a8131702733$export$4c5a129a59e1ef34).experimentalLetterSpacing;
    }
    static set experimentalLetterSpacing(value) {
        (0, $db31fc3dfae4939b$exports).deprecation("7.1.0", "Text.experimentalLetterSpacing is deprecated, use TextMetrics.experimentalLetterSpacing"), (0, $31f48a8131702733$export$4c5a129a59e1ef34).experimentalLetterSpacing = value;
    }
    /**
   * Renders text to its canvas, and updates its texture.
   *
   * By default this is used internally to ensure the texture is correct before rendering,
   * but it can be used called externally, for example from this class to 'pre-generate' the texture from a piece of text,
   * and then shared across multiple Sprites.
   * @param respectDirty - Whether to abort updating the text if the Text isn't dirty and the function is called.
   */ updateText(respectDirty) {
        const style = this._style;
        if (this.localStyleID !== style.styleID && (this.dirty = !0, this.localStyleID = style.styleID), !this.dirty && respectDirty) return;
        this._font = this._style.toFontString();
        const context = this.context, measured = (0, $31f48a8131702733$export$4c5a129a59e1ef34).measureText(this._text || " ", this._style, this._style.wordWrap, this.canvas), width = measured.width, height = measured.height, lines = measured.lines, lineHeight = measured.lineHeight, lineWidths = measured.lineWidths, maxLineWidth = measured.maxLineWidth, fontProperties = measured.fontProperties;
        this.canvas.width = Math.ceil(Math.ceil(Math.max(1, width) + style.padding * 2) * this._resolution), this.canvas.height = Math.ceil(Math.ceil(Math.max(1, height) + style.padding * 2) * this._resolution), context.scale(this._resolution, this._resolution), context.clearRect(0, 0, this.canvas.width, this.canvas.height), context.font = this._font, context.lineWidth = style.strokeThickness, context.textBaseline = style.textBaseline, context.lineJoin = style.lineJoin, context.miterLimit = style.miterLimit;
        let linePositionX, linePositionY;
        const passesCount = style.dropShadow ? 2 : 1;
        for(let i = 0; i < passesCount; ++i){
            const isShadowPass = style.dropShadow && i === 0, dsOffsetText = isShadowPass ? Math.ceil(Math.max(1, height) + style.padding * 2) : 0, dsOffsetShadow = dsOffsetText * this._resolution;
            if (isShadowPass) {
                context.fillStyle = "black", context.strokeStyle = "black";
                const dropShadowColor = style.dropShadowColor, dropShadowBlur = style.dropShadowBlur * this._resolution, dropShadowDistance = style.dropShadowDistance * this._resolution;
                context.shadowColor = (0, $15154c33c9e19c5f$export$892596cec99bc70e).shared.setValue(dropShadowColor).setAlpha(style.dropShadowAlpha).toRgbaString(), context.shadowBlur = dropShadowBlur, context.shadowOffsetX = Math.cos(style.dropShadowAngle) * dropShadowDistance, context.shadowOffsetY = Math.sin(style.dropShadowAngle) * dropShadowDistance + dsOffsetShadow;
            } else context.fillStyle = this._generateFillStyle(style, lines, measured), context.strokeStyle = style.stroke, context.shadowColor = "black", context.shadowBlur = 0, context.shadowOffsetX = 0, context.shadowOffsetY = 0;
            let linePositionYShift = (lineHeight - fontProperties.fontSize) / 2;
            lineHeight - fontProperties.fontSize < 0 && (linePositionYShift = 0);
            for(let i2 = 0; i2 < lines.length; i2++)linePositionX = style.strokeThickness / 2, linePositionY = style.strokeThickness / 2 + i2 * lineHeight + fontProperties.ascent + linePositionYShift, style.align === "right" ? linePositionX += maxLineWidth - lineWidths[i2] : style.align === "center" && (linePositionX += (maxLineWidth - lineWidths[i2]) / 2), style.stroke && style.strokeThickness && this.drawLetterSpacing(lines[i2], linePositionX + style.padding, linePositionY + style.padding - dsOffsetText, !0), style.fill && this.drawLetterSpacing(lines[i2], linePositionX + style.padding, linePositionY + style.padding - dsOffsetText);
        }
        this.updateTexture();
    }
    /**
   * Render the text with letter-spacing.
   * @param text - The text to draw
   * @param x - Horizontal position to draw the text
   * @param y - Vertical position to draw the text
   * @param isStroke - Is this drawing for the outside stroke of the
   *  text? If not, it's for the inside fill
   */ drawLetterSpacing(text, x, y, isStroke = !1) {
        const letterSpacing = this._style.letterSpacing;
        let useExperimentalLetterSpacing = !1;
        if ((0, $31f48a8131702733$export$4c5a129a59e1ef34).experimentalLetterSpacingSupported && ((0, $31f48a8131702733$export$4c5a129a59e1ef34).experimentalLetterSpacing ? (this.context.letterSpacing = `${letterSpacing}px`, this.context.textLetterSpacing = `${letterSpacing}px`, useExperimentalLetterSpacing = !0) : (this.context.letterSpacing = "0px", this.context.textLetterSpacing = "0px")), letterSpacing === 0 || useExperimentalLetterSpacing) {
            isStroke ? this.context.strokeText(text, x, y) : this.context.fillText(text, x, y);
            return;
        }
        let currentPosition = x;
        const stringArray = (0, $31f48a8131702733$export$4c5a129a59e1ef34).graphemeSegmenter(text);
        let previousWidth = this.context.measureText(text).width, currentWidth = 0;
        for(let i = 0; i < stringArray.length; ++i){
            const currentChar = stringArray[i];
            isStroke ? this.context.strokeText(currentChar, currentPosition, y) : this.context.fillText(currentChar, currentPosition, y);
            let textStr = "";
            for(let j = i + 1; j < stringArray.length; ++j)textStr += stringArray[j];
            currentWidth = this.context.measureText(textStr).width, currentPosition += previousWidth - currentWidth + letterSpacing, previousWidth = currentWidth;
        }
    }
    /** Updates texture size based on canvas size. */ updateTexture() {
        const canvas = this.canvas;
        if (this._style.trim) {
            const trimmed = (0, $db31fc3dfae4939b$exports).trimCanvas(canvas);
            trimmed.data && (canvas.width = trimmed.width, canvas.height = trimmed.height, this.context.putImageData(trimmed.data, 0, 0));
        }
        const texture = this._texture, style = this._style, padding = style.trim ? 0 : style.padding, baseTexture = texture.baseTexture;
        texture.trim.width = texture._frame.width = canvas.width / this._resolution, texture.trim.height = texture._frame.height = canvas.height / this._resolution, texture.trim.x = -padding, texture.trim.y = -padding, texture.orig.width = texture._frame.width - padding * 2, texture.orig.height = texture._frame.height - padding * 2, this._onTextureUpdate(), baseTexture.setRealSize(canvas.width, canvas.height, this._resolution), texture.updateUvs(), this.dirty = !1;
    }
    /**
   * Renders the object using the WebGL renderer
   * @param renderer - The renderer
   */ _render(renderer) {
        this._autoResolution && this._resolution !== renderer.resolution && (this._resolution = renderer.resolution, this.dirty = !0), this.updateText(!0), super._render(renderer);
    }
    /** Updates the transform on all children of this container for rendering. */ updateTransform() {
        this.updateText(!0), super.updateTransform();
    }
    getBounds(skipUpdate, rect) {
        return this.updateText(!0), this._textureID === -1 && (skipUpdate = !1), super.getBounds(skipUpdate, rect);
    }
    /**
   * Gets the local bounds of the text object.
   * @param rect - The output rectangle.
   * @returns The bounds.
   */ getLocalBounds(rect) {
        return this.updateText(!0), super.getLocalBounds.call(this, rect);
    }
    /** Calculates the bounds of the Text as a rectangle. The bounds calculation takes the worldTransform into account. */ _calculateBounds() {
        this.calculateVertices(), this._bounds.addQuad(this.vertexData);
    }
    /**
   * Generates the fill style. Can automatically generate a gradient based on the fill style being an array
   * @param style - The style.
   * @param lines - The lines of text.
   * @param metrics
   * @returns The fill style
   */ _generateFillStyle(style, lines, metrics) {
        const fillStyle = style.fill;
        if (Array.isArray(fillStyle)) {
            if (fillStyle.length === 1) return fillStyle[0];
        } else return fillStyle;
        let gradient;
        const dropShadowCorrection = style.dropShadow ? style.dropShadowDistance : 0, padding = style.padding || 0, width = this.canvas.width / this._resolution - dropShadowCorrection - padding * 2, height = this.canvas.height / this._resolution - dropShadowCorrection - padding * 2, fill = fillStyle.slice(), fillGradientStops = style.fillGradientStops.slice();
        if (!fillGradientStops.length) {
            const lengthPlus1 = fill.length + 1;
            for(let i = 1; i < lengthPlus1; ++i)fillGradientStops.push(i / lengthPlus1);
        }
        if (fill.unshift(fillStyle[0]), fillGradientStops.unshift(0), fill.push(fillStyle[fillStyle.length - 1]), fillGradientStops.push(1), style.fillGradientType === (0, $029097fab1db53a0$export$131daa784848984).LINEAR_VERTICAL) {
            gradient = this.context.createLinearGradient(width / 2, padding, width / 2, height + padding);
            const textHeight = metrics.fontProperties.fontSize + style.strokeThickness;
            for(let i = 0; i < lines.length; i++){
                const lastLineBottom = metrics.lineHeight * (i - 1) + textHeight, thisLineTop = metrics.lineHeight * i;
                let thisLineGradientStart = thisLineTop;
                i > 0 && lastLineBottom > thisLineTop && (thisLineGradientStart = (thisLineTop + lastLineBottom) / 2);
                const thisLineBottom = thisLineTop + textHeight, nextLineTop = metrics.lineHeight * (i + 1);
                let thisLineGradientEnd = thisLineBottom;
                i + 1 < lines.length && nextLineTop < thisLineBottom && (thisLineGradientEnd = (thisLineBottom + nextLineTop) / 2);
                const gradStopLineHeight = (thisLineGradientEnd - thisLineGradientStart) / height;
                for(let j = 0; j < fill.length; j++){
                    let lineStop = 0;
                    typeof fillGradientStops[j] == "number" ? lineStop = fillGradientStops[j] : lineStop = j / fill.length;
                    let globalStop = Math.min(1, Math.max(0, thisLineGradientStart / height + lineStop * gradStopLineHeight));
                    globalStop = Number(globalStop.toFixed(5)), gradient.addColorStop(globalStop, fill[j]);
                }
            }
        } else {
            gradient = this.context.createLinearGradient(padding, height / 2, width + padding, height / 2);
            const totalIterations = fill.length + 1;
            let currentIteration = 1;
            for(let i = 0; i < fill.length; i++){
                let stop;
                typeof fillGradientStops[i] == "number" ? stop = fillGradientStops[i] : stop = currentIteration / totalIterations, gradient.addColorStop(stop, fill[i]), currentIteration++;
            }
        }
        return gradient;
    }
    /**
   * Destroys this text object.
   *
   * Note* Unlike a Sprite, a Text object will automatically destroy its baseTexture and texture as
   * the majority of the time the texture will not be shared with any other Sprites.
   * @param options - Options parameter. A boolean will act as if all options
   *  have been set to that value
   * @param {boolean} [options.children=false] - if set to true, all the children will have their
   *  destroy method called as well. 'options' will be passed on to those calls.
   * @param {boolean} [options.texture=true] - Should it destroy the current texture of the sprite as well
   * @param {boolean} [options.baseTexture=true] - Should it destroy the base texture of the sprite as well
   */ destroy(options) {
        typeof options == "boolean" && (options = {
            children: options
        }), options = Object.assign({}, $f4ede730be703e5d$var$defaultDestroyOptions, options), super.destroy(options), this._ownCanvas && (this.canvas.height = this.canvas.width = 0), this.context = null, this.canvas = null, this._style = null;
    }
    /** The width of the Text, setting this will actually modify the scale to achieve the value set. */ get width() {
        return this.updateText(!0), Math.abs(this.scale.x) * this._texture.orig.width;
    }
    set width(value) {
        this.updateText(!0);
        const s = (0, $db31fc3dfae4939b$exports).sign(this.scale.x) || 1;
        this.scale.x = s * value / this._texture.orig.width, this._width = value;
    }
    /** The height of the Text, setting this will actually modify the scale to achieve the value set. */ get height() {
        return this.updateText(!0), Math.abs(this.scale.y) * this._texture.orig.height;
    }
    set height(value) {
        this.updateText(!0);
        const s = (0, $db31fc3dfae4939b$exports).sign(this.scale.y) || 1;
        this.scale.y = s * value / this._texture.orig.height, this._height = value;
    }
    /**
   * Set the style of the text.
   *
   * Set up an event listener to listen for changes on the style object and mark the text as dirty.
   *
   * If setting the `style` can also be partial {@link PIXI.ITextStyle}.
   */ get style() {
        return this._style;
    }
    set style(style) {
        style = style || {}, style instanceof (0, $3d453260a3c8e0f7$export$1df879243bf2e42d) ? this._style = style : this._style = new (0, $3d453260a3c8e0f7$export$1df879243bf2e42d)(style), this.localStyleID = -1, this.dirty = !0;
    }
    /** Set the copy for the text object. To split a line you can use '\n'. */ get text() {
        return this._text;
    }
    set text(text) {
        text = String(text ?? ""), this._text !== text && (this._text = text, this.dirty = !0);
    }
    /**
   * The resolution / device pixel ratio of the canvas.
   *
   * This is set to automatically match the renderer resolution by default, but can be overridden by setting manually.
   * @default 1
   */ get resolution() {
        return this._resolution;
    }
    set resolution(value) {
        this._autoResolution = !1, this._resolution !== value && (this._resolution = value, this.dirty = !0);
    }
};
$f4ede730be703e5d$var$_Text.defaultAutoResolution = !0;
let $f4ede730be703e5d$export$5f1af8db9871e1d6 = $f4ede730be703e5d$var$_Text;






class $acf9c20bc4090bce$export$29966907153718d8 {
    /**
   * @param maxItemsPerFrame - The maximum number of items that can be prepared each frame.
   */ constructor(maxItemsPerFrame){
        this.maxItemsPerFrame = maxItemsPerFrame, this.itemsLeft = 0;
    }
    /** Resets any counting properties to start fresh on a new frame. */ beginFrame() {
        this.itemsLeft = this.maxItemsPerFrame;
    }
    /**
   * Checks to see if another item can be uploaded. This should only be called once per item.
   * @returns If the item is allowed to be uploaded.
   */ allowedToUpload() {
        return this.itemsLeft-- > 0;
    }
}


function $a5568f1f273bfaca$var$findMultipleBaseTextures(item, queue) {
    let result = !1;
    if (item?._textures?.length) {
        for(let i = 0; i < item._textures.length; i++)if (item._textures[i] instanceof (0, $14896914ad3ae15d$export$5431306cf43de24a)) {
            const baseTexture = item._textures[i].baseTexture;
            queue.includes(baseTexture) || (queue.push(baseTexture), result = !0);
        }
    }
    return result;
}
function $a5568f1f273bfaca$var$findBaseTexture(item, queue) {
    if (item.baseTexture instanceof (0, $30c85657f0c625d5$export$d6306e508f184154)) {
        const texture = item.baseTexture;
        return queue.includes(texture) || queue.push(texture), !0;
    }
    return !1;
}
function $a5568f1f273bfaca$var$findTexture(item, queue) {
    if (item._texture && item._texture instanceof (0, $14896914ad3ae15d$export$5431306cf43de24a)) {
        const texture = item._texture.baseTexture;
        return queue.includes(texture) || queue.push(texture), !0;
    }
    return !1;
}
function $a5568f1f273bfaca$var$drawText(_helper, item) {
    return item instanceof (0, $f4ede730be703e5d$export$5f1af8db9871e1d6) ? (item.updateText(!0), !0) : !1;
}
function $a5568f1f273bfaca$var$calculateTextStyle(_helper, item) {
    if (item instanceof (0, $3d453260a3c8e0f7$export$1df879243bf2e42d)) {
        const font = item.toFontString();
        return (0, $31f48a8131702733$export$4c5a129a59e1ef34).measureFont(font), !0;
    }
    return !1;
}
function $a5568f1f273bfaca$var$findText(item, queue) {
    if (item instanceof (0, $f4ede730be703e5d$export$5f1af8db9871e1d6)) {
        queue.includes(item.style) || queue.push(item.style), queue.includes(item) || queue.push(item);
        const texture = item._texture.baseTexture;
        return queue.includes(texture) || queue.push(texture), !0;
    }
    return !1;
}
function $a5568f1f273bfaca$var$findTextStyle(item, queue) {
    return item instanceof (0, $3d453260a3c8e0f7$export$1df879243bf2e42d) ? (queue.includes(item) || queue.push(item), !0) : !1;
}
const $a5568f1f273bfaca$var$_BasePrepare = class _BasePrepare2 {
    /**
   * @param {PIXI.IRenderer} renderer - A reference to the current renderer
   */ constructor(renderer){
        this.limiter = new (0, $acf9c20bc4090bce$export$29966907153718d8)(_BasePrepare2.uploadsPerFrame), this.renderer = renderer, this.uploadHookHelper = null, this.queue = [], this.addHooks = [], this.uploadHooks = [], this.completes = [], this.ticking = !1, this.delayedTick = ()=>{
            this.queue && this.prepareItems();
        }, this.registerFindHook($a5568f1f273bfaca$var$findText), this.registerFindHook($a5568f1f273bfaca$var$findTextStyle), this.registerFindHook($a5568f1f273bfaca$var$findMultipleBaseTextures), this.registerFindHook($a5568f1f273bfaca$var$findBaseTexture), this.registerFindHook($a5568f1f273bfaca$var$findTexture), this.registerUploadHook($a5568f1f273bfaca$var$drawText), this.registerUploadHook($a5568f1f273bfaca$var$calculateTextStyle);
    }
    /**
   * Upload all the textures and graphics to the GPU.
   * @method PIXI.BasePrepare#upload
   * @param {PIXI.DisplayObject|PIXI.Container|PIXI.BaseTexture|PIXI.Texture|PIXI.Graphics|PIXI.Text} [item] -
   *        Container or display object to search for items to upload or the items to upload themselves,
   *        or optionally ommitted, if items have been added using {@link PIXI.BasePrepare#add `prepare.add`}.
   */ upload(item) {
        return new Promise((resolve)=>{
            item && this.add(item), this.queue.length ? (this.completes.push(resolve), this.ticking || (this.ticking = !0, (0, $e6b36730368844b1$export$39c54bcc89dcee11).system.addOnce(this.tick, this, (0, $6098ce82519589af$export$688aaf132ba9b379).UTILITY))) : resolve();
        });
    }
    /**
   * Handle tick update
   * @private
   */ tick() {
        setTimeout(this.delayedTick, 0);
    }
    /**
   * Actually prepare items. This is handled outside of the tick because it will take a while
   * and we do NOT want to block the current animation frame from rendering.
   * @private
   */ prepareItems() {
        for(this.limiter.beginFrame(); this.queue.length && this.limiter.allowedToUpload();){
            const item = this.queue[0];
            let uploaded = !1;
            if (item && !item._destroyed) {
                for(let i = 0, len = this.uploadHooks.length; i < len; i++)if (this.uploadHooks[i](this.uploadHookHelper, item)) {
                    this.queue.shift(), uploaded = !0;
                    break;
                }
            }
            uploaded || this.queue.shift();
        }
        if (this.queue.length) (0, $e6b36730368844b1$export$39c54bcc89dcee11).system.addOnce(this.tick, this, (0, $6098ce82519589af$export$688aaf132ba9b379).UTILITY);
        else {
            this.ticking = !1;
            const completes = this.completes.slice(0);
            this.completes.length = 0;
            for(let i = 0, len = completes.length; i < len; i++)completes[i]();
        }
    }
    /**
   * Adds hooks for finding items.
   * @param {Function} addHook - Function call that takes two parameters: `item:*, queue:Array`
   *          function must return `true` if it was able to add item to the queue.
   * @returns Instance of plugin for chaining.
   */ registerFindHook(addHook) {
        return addHook && this.addHooks.push(addHook), this;
    }
    /**
   * Adds hooks for uploading items.
   * @param {Function} uploadHook - Function call that takes two parameters: `prepare:CanvasPrepare, item:*` and
   *          function must return `true` if it was able to handle upload of item.
   * @returns Instance of plugin for chaining.
   */ registerUploadHook(uploadHook) {
        return uploadHook && this.uploadHooks.push(uploadHook), this;
    }
    /**
   * Manually add an item to the uploading queue.
   * @param {PIXI.DisplayObject|PIXI.Container|PIXI.BaseTexture|PIXI.Texture|PIXI.Graphics|PIXI.Text|*} item - Object to
   *        add to the queue
   * @returns Instance of plugin for chaining.
   */ add(item) {
        for(let i = 0, len = this.addHooks.length; i < len && !this.addHooks[i](item, this.queue); i++);
        if (item instanceof (0, $68e6944de5989822$export$42a852a2b6b56249)) for(let i = item.children.length - 1; i >= 0; i--)this.add(item.children[i]);
        return this;
    }
    /** Destroys the plugin, don't use after this. */ destroy() {
        this.ticking && (0, $e6b36730368844b1$export$39c54bcc89dcee11).system.remove(this.tick, this), this.ticking = !1, this.addHooks = null, this.uploadHooks = null, this.renderer = null, this.completes = null, this.queue = null, this.limiter = null, this.uploadHookHelper = null;
    }
};
$a5568f1f273bfaca$var$_BasePrepare.uploadsPerFrame = 4;
let $a5568f1f273bfaca$export$189fb89547161769 = $a5568f1f273bfaca$var$_BasePrepare;


Object.defineProperties((0, $2808efac47e52be0$export$a5a6e0b888b2c992), {
    /**
   * Default number of uploads per frame using prepare plugin.
   * @static
   * @memberof PIXI.settings
   * @name UPLOADS_PER_FRAME
   * @deprecated since 7.1.0
   * @see PIXI.BasePrepare.uploadsPerFrame
   * @type {number}
   */ UPLOADS_PER_FRAME: {
        get () {
            return (0, $a5568f1f273bfaca$export$189fb89547161769).uploadsPerFrame;
        },
        set (value) {
            (0, $db31fc3dfae4939b$exports).deprecation("7.1.0", "settings.UPLOADS_PER_FRAME is deprecated, use prepare.BasePrepare.uploadsPerFrame"), (0, $a5568f1f273bfaca$export$189fb89547161769).uploadsPerFrame = value;
        }
    }
});







function $3da363ceb3088449$var$uploadBaseTextures(renderer, item) {
    return item instanceof (0, $30c85657f0c625d5$export$d6306e508f184154) ? (item._glTextures[renderer.CONTEXT_UID] || renderer.texture.bind(item), !0) : !1;
}
function $3da363ceb3088449$var$uploadGraphics(renderer, item) {
    if (!(item instanceof (0, $48ce8a7de6645907$export$29d3e417456abdad))) return !1;
    const { geometry: geometry } = item;
    item.finishPoly(), geometry.updateBatches();
    const { batches: batches } = geometry;
    for(let i = 0; i < batches.length; i++){
        const { texture: texture } = batches[i].style;
        texture && $3da363ceb3088449$var$uploadBaseTextures(renderer, texture.baseTexture);
    }
    return geometry.batchable || renderer.geometry.bind(geometry, item._resolveDirectShader(renderer)), !0;
}
function $3da363ceb3088449$var$findGraphics(item, queue) {
    return item instanceof (0, $48ce8a7de6645907$export$29d3e417456abdad) ? (queue.push(item), !0) : !1;
}
class $3da363ceb3088449$export$6475b8f46e7e39d6 extends (0, $a5568f1f273bfaca$export$189fb89547161769) {
    /**
   * @param {PIXI.Renderer} renderer - A reference to the current renderer
   */ constructor(renderer){
        super(renderer), this.uploadHookHelper = this.renderer, this.registerFindHook($3da363ceb3088449$var$findGraphics), this.registerUploadHook($3da363ceb3088449$var$uploadBaseTextures), this.registerUploadHook($3da363ceb3088449$var$uploadGraphics);
    }
}
$3da363ceb3088449$export$6475b8f46e7e39d6.extension = {
    name: "prepare",
    type: (0, $c90155f6d7d8d8f6$export$4f037c6ec2da4eeb).RendererSystem
};
(0, $c90155f6d7d8d8f6$export$cc3e2d3244e01b7f).add($3da363ceb3088449$export$6475b8f46e7e39d6);


class $db25109ff1621543$export$82e43921ff85c600 {
    /** @param maxMilliseconds - The maximum milliseconds that can be spent preparing items each frame. */ constructor(maxMilliseconds){
        this.maxMilliseconds = maxMilliseconds, this.frameStart = 0;
    }
    /** Resets any counting properties to start fresh on a new frame. */ beginFrame() {
        this.frameStart = Date.now();
    }
    /**
   * Checks to see if another item can be uploaded. This should only be called once per item.
   * @returns - If the item is allowed to be uploaded.
   */ allowedToUpload() {
        return Date.now() - this.frameStart < this.maxMilliseconds;
    }
}







class $bcc7eddf04636882$export$dae599798687ad3c extends (0, $e4c5b2569bd3a8d2$export$3075603db8e6204c) {
    /**
   * @param textures - An array of {@link PIXI.Texture} or frame
   *  objects that make up the animation.
   * @param {boolean} [autoUpdate=true] - Whether to use Ticker.shared to auto update animation time.
   */ constructor(textures, autoUpdate = !0){
        super(textures[0] instanceof (0, $14896914ad3ae15d$export$5431306cf43de24a) ? textures[0] : textures[0].texture), this._textures = null, this._durations = null, this._autoUpdate = autoUpdate, this._isConnectedToTicker = !1, this.animationSpeed = 1, this.loop = !0, this.updateAnchor = !1, this.onComplete = null, this.onFrameChange = null, this.onLoop = null, this._currentTime = 0, this._playing = !1, this._previousFrame = null, this.textures = textures;
    }
    /** Stops the AnimatedSprite. */ stop() {
        this._playing && (this._playing = !1, this._autoUpdate && this._isConnectedToTicker && ((0, $e6b36730368844b1$export$39c54bcc89dcee11).shared.remove(this.update, this), this._isConnectedToTicker = !1));
    }
    /** Plays the AnimatedSprite. */ play() {
        this._playing || (this._playing = !0, this._autoUpdate && !this._isConnectedToTicker && ((0, $e6b36730368844b1$export$39c54bcc89dcee11).shared.add(this.update, this, (0, $6098ce82519589af$export$688aaf132ba9b379).HIGH), this._isConnectedToTicker = !0));
    }
    /**
   * Stops the AnimatedSprite and goes to a specific frame.
   * @param frameNumber - Frame index to stop at.
   */ gotoAndStop(frameNumber) {
        this.stop(), this.currentFrame = frameNumber;
    }
    /**
   * Goes to a specific frame and begins playing the AnimatedSprite.
   * @param frameNumber - Frame index to start at.
   */ gotoAndPlay(frameNumber) {
        this.currentFrame = frameNumber, this.play();
    }
    /**
   * Updates the object transform for rendering.
   * @param deltaTime - Time since last tick.
   */ update(deltaTime) {
        if (!this._playing) return;
        const elapsed = this.animationSpeed * deltaTime, previousFrame = this.currentFrame;
        if (this._durations !== null) {
            let lag = this._currentTime % 1 * this._durations[this.currentFrame];
            for(lag += elapsed / 60 * 1e3; lag < 0;)this._currentTime--, lag += this._durations[this.currentFrame];
            const sign = Math.sign(this.animationSpeed * deltaTime);
            for(this._currentTime = Math.floor(this._currentTime); lag >= this._durations[this.currentFrame];)lag -= this._durations[this.currentFrame] * sign, this._currentTime += sign;
            this._currentTime += lag / this._durations[this.currentFrame];
        } else this._currentTime += elapsed;
        this._currentTime < 0 && !this.loop ? (this.gotoAndStop(0), this.onComplete && this.onComplete()) : this._currentTime >= this._textures.length && !this.loop ? (this.gotoAndStop(this._textures.length - 1), this.onComplete && this.onComplete()) : previousFrame !== this.currentFrame && (this.loop && this.onLoop && (this.animationSpeed > 0 && this.currentFrame < previousFrame || this.animationSpeed < 0 && this.currentFrame > previousFrame) && this.onLoop(), this.updateTexture());
    }
    /** Updates the displayed texture to match the current frame index. */ updateTexture() {
        const currentFrame = this.currentFrame;
        this._previousFrame !== currentFrame && (this._previousFrame = currentFrame, this._texture = this._textures[currentFrame], this._textureID = -1, this._textureTrimmedID = -1, this._cachedTint = 16777215, this.uvs = this._texture._uvs.uvsFloat32, this.updateAnchor && this._anchor.copyFrom(this._texture.defaultAnchor), this.onFrameChange && this.onFrameChange(this.currentFrame));
    }
    /**
   * Stops the AnimatedSprite and destroys it.
   * @param {object|boolean} [options] - Options parameter. A boolean will act as if all options
   *  have been set to that value.
   * @param {boolean} [options.children=false] - If set to true, all the children will have their destroy
   *      method called as well. 'options' will be passed on to those calls.
   * @param {boolean} [options.texture=false] - Should it destroy the current texture of the sprite as well.
   * @param {boolean} [options.baseTexture=false] - Should it destroy the base texture of the sprite as well.
   */ destroy(options) {
        this.stop(), super.destroy(options), this.onComplete = null, this.onFrameChange = null, this.onLoop = null;
    }
    /**
   * A short hand way of creating an AnimatedSprite from an array of frame ids.
   * @param frames - The array of frames ids the AnimatedSprite will use as its texture frames.
   * @returns - The new animated sprite with the specified frames.
   */ static fromFrames(frames) {
        const textures = [];
        for(let i = 0; i < frames.length; ++i)textures.push((0, $14896914ad3ae15d$export$5431306cf43de24a).from(frames[i]));
        return new $bcc7eddf04636882$export$dae599798687ad3c(textures);
    }
    /**
   * A short hand way of creating an AnimatedSprite from an array of image ids.
   * @param images - The array of image urls the AnimatedSprite will use as its texture frames.
   * @returns The new animate sprite with the specified images as frames.
   */ static fromImages(images) {
        const textures = [];
        for(let i = 0; i < images.length; ++i)textures.push((0, $14896914ad3ae15d$export$5431306cf43de24a).from(images[i]));
        return new $bcc7eddf04636882$export$dae599798687ad3c(textures);
    }
    /**
   * The total number of frames in the AnimatedSprite. This is the same as number of textures
   * assigned to the AnimatedSprite.
   * @readonly
   * @default 0
   */ get totalFrames() {
        return this._textures.length;
    }
    /** The array of textures used for this AnimatedSprite. */ get textures() {
        return this._textures;
    }
    set textures(value) {
        if (value[0] instanceof (0, $14896914ad3ae15d$export$5431306cf43de24a)) this._textures = value, this._durations = null;
        else {
            this._textures = [], this._durations = [];
            for(let i = 0; i < value.length; i++)this._textures.push(value[i].texture), this._durations.push(value[i].time);
        }
        this._previousFrame = null, this.gotoAndStop(0), this.updateTexture();
    }
    /** The AnimatedSprite's current frame index. */ get currentFrame() {
        let currentFrame = Math.floor(this._currentTime) % this._textures.length;
        return currentFrame < 0 && (currentFrame += this._textures.length), currentFrame;
    }
    set currentFrame(value) {
        if (value < 0 || value > this.totalFrames - 1) throw new Error(`[AnimatedSprite]: Invalid frame index value ${value}, expected to be between 0 and totalFrames ${this.totalFrames}.`);
        const previousFrame = this.currentFrame;
        this._currentTime = value, previousFrame !== this.currentFrame && this.updateTexture();
    }
    /**
   * Indicates if the AnimatedSprite is currently playing.
   * @readonly
   */ get playing() {
        return this._playing;
    }
    /** Whether to use Ticker.shared to auto update animation time. */ get autoUpdate() {
        return this._autoUpdate;
    }
    set autoUpdate(value) {
        value !== this._autoUpdate && (this._autoUpdate = value, !this._autoUpdate && this._isConnectedToTicker ? ((0, $e6b36730368844b1$export$39c54bcc89dcee11).shared.remove(this.update, this), this._isConnectedToTicker = !1) : this._autoUpdate && !this._isConnectedToTicker && this._playing && ((0, $e6b36730368844b1$export$39c54bcc89dcee11).shared.add(this.update, this), this._isConnectedToTicker = !0));
    }
}






const $ea853049c58b0073$var$tempPoint = new (0, $cf3018b4309864c2$export$baf26146a414f24a)();
class $ea853049c58b0073$export$db8370cd1ebcc819 extends (0, $e4c5b2569bd3a8d2$export$3075603db8e6204c) {
    /**
   * Note: The wrap mode of the texture is forced to REPEAT on render if the size of the texture
   * is a power of two, the texture's wrap mode is CLAMP, and the texture hasn't been bound yet.
   * @param texture - The texture of the tiling sprite.
   * @param width - The width of the tiling sprite.
   * @param height - The height of the tiling sprite.
   */ constructor(texture, width = 100, height = 100){
        super(texture), this.tileTransform = new (0, $cec25acf758d963f$export$563a914cafbdc389)(), this._width = width, this._height = height, this.uvMatrix = this.texture.uvMatrix || new (0, $63f378ad73a038ff$export$dbea3135e9da48cb)(texture), this.pluginName = "tilingSprite", this.uvRespectAnchor = !1;
    }
    /**
   * Changes frame clamping in corresponding textureTransform, shortcut
   * Change to -0.5 to add a pixel to the edge, recommended for transparent trimmed textures in atlas
   * @default 0.5
   * @member {number}
   */ get clampMargin() {
        return this.uvMatrix.clampMargin;
    }
    set clampMargin(value) {
        this.uvMatrix.clampMargin = value, this.uvMatrix.update(!0);
    }
    /** The scaling of the image that is being tiled. */ get tileScale() {
        return this.tileTransform.scale;
    }
    set tileScale(value) {
        this.tileTransform.scale.copyFrom(value);
    }
    /** The offset of the image that is being tiled. */ get tilePosition() {
        return this.tileTransform.position;
    }
    set tilePosition(value) {
        this.tileTransform.position.copyFrom(value);
    }
    /**
   * @protected
   */ _onTextureUpdate() {
        this.uvMatrix && (this.uvMatrix.texture = this._texture), this._cachedTint = 16777215;
    }
    /**
   * Renders the object using the WebGL renderer
   * @param renderer - The renderer
   */ _render(renderer) {
        const texture = this._texture;
        !texture || !texture.valid || (this.tileTransform.updateLocalTransform(), this.uvMatrix.update(), renderer.batch.setObjectRenderer(renderer.plugins[this.pluginName]), renderer.plugins[this.pluginName].render(this));
    }
    /** Updates the bounds of the tiling sprite. */ _calculateBounds() {
        const minX = this._width * -this._anchor._x, minY = this._height * -this._anchor._y, maxX = this._width * (1 - this._anchor._x), maxY = this._height * (1 - this._anchor._y);
        this._bounds.addFrame(this.transform, minX, minY, maxX, maxY);
    }
    /**
   * Gets the local bounds of the sprite object.
   * @param rect - Optional output rectangle.
   * @returns The bounds.
   */ getLocalBounds(rect) {
        return this.children.length === 0 ? (this._bounds.minX = this._width * -this._anchor._x, this._bounds.minY = this._height * -this._anchor._y, this._bounds.maxX = this._width * (1 - this._anchor._x), this._bounds.maxY = this._height * (1 - this._anchor._y), rect || (this._localBoundsRect || (this._localBoundsRect = new (0, $200f778d7fdbf8ac$export$4617fb02663045ef)()), rect = this._localBoundsRect), this._bounds.getRectangle(rect)) : super.getLocalBounds.call(this, rect);
    }
    /**
   * Checks if a point is inside this tiling sprite.
   * @param point - The point to check.
   * @returns Whether or not the sprite contains the point.
   */ containsPoint(point) {
        this.worldTransform.applyInverse(point, $ea853049c58b0073$var$tempPoint);
        const width = this._width, height = this._height, x1 = -width * this.anchor._x;
        if ($ea853049c58b0073$var$tempPoint.x >= x1 && $ea853049c58b0073$var$tempPoint.x < x1 + width) {
            const y1 = -height * this.anchor._y;
            if ($ea853049c58b0073$var$tempPoint.y >= y1 && $ea853049c58b0073$var$tempPoint.y < y1 + height) return !0;
        }
        return !1;
    }
    /**
   * Destroys this sprite and optionally its texture and children
   * @param {object|boolean} [options] - Options parameter. A boolean will act as if all options
   *  have been set to that value
   * @param {boolean} [options.children=false] - if set to true, all the children will have their destroy
   *      method called as well. 'options' will be passed on to those calls.
   * @param {boolean} [options.texture=false] - Should it destroy the current texture of the sprite as well
   * @param {boolean} [options.baseTexture=false] - Should it destroy the base texture of the sprite as well
   */ destroy(options) {
        super.destroy(options), this.tileTransform = null, this.uvMatrix = null;
    }
    /**
   * Helper function that creates a new tiling sprite based on the source you provide.
   * The source can be - frame id, image url, video url, canvas element, video element, base texture
   * @static
   * @param {string|PIXI.Texture|HTMLCanvasElement|HTMLVideoElement} source - Source to create texture from
   * @param {object} options - See {@link PIXI.BaseTexture}'s constructor for options.
   * @param {number} options.width - required width of the tiling sprite
   * @param {number} options.height - required height of the tiling sprite
   * @returns {PIXI.TilingSprite} The newly created texture
   */ static from(source, options) {
        const texture = source instanceof (0, $14896914ad3ae15d$export$5431306cf43de24a) ? source : (0, $14896914ad3ae15d$export$5431306cf43de24a).from(source, options);
        return new $ea853049c58b0073$export$db8370cd1ebcc819(texture, options.width, options.height);
    }
    /** The width of the sprite, setting this will actually modify the scale to achieve the value set. */ get width() {
        return this._width;
    }
    set width(value) {
        this._width = value;
    }
    /** The height of the TilingSprite, setting this will actually modify the scale to achieve the value set. */ get height() {
        return this._height;
    }
    set height(value) {
        this._height = value;
    }
}



var $3c443640cb5e8a4d$export$2e2bcd8739ae039 = `#version 300 es
#define SHADER_NAME Tiling-Sprite-100

precision lowp float;

in vec2 vTextureCoord;

out vec4 fragmentColor;

uniform sampler2D uSampler;
uniform vec4 uColor;
uniform mat3 uMapCoord;
uniform vec4 uClampFrame;
uniform vec2 uClampOffset;

void main(void)
{
    vec2 coord = vTextureCoord + ceil(uClampOffset - vTextureCoord);
    coord = (uMapCoord * vec3(coord, 1.0)).xy;
    vec2 unclamped = coord;
    coord = clamp(coord, uClampFrame.xy, uClampFrame.zw);

    vec4 texSample = texture(uSampler, coord, unclamped == coord ? 0.0f : -32.0f);// lod-bias very negative to force lod 0

    fragmentColor = texSample * uColor;
}
`;


var $c9e680a62a234b74$export$2e2bcd8739ae039 = `#version 300 es
#define SHADER_NAME Tiling-Sprite-300

precision lowp float;

in vec2 aVertexPosition;
in vec2 aTextureCoord;

uniform mat3 projectionMatrix;
uniform mat3 translationMatrix;
uniform mat3 uTransform;

out vec2 vTextureCoord;

void main(void)
{
    gl_Position = vec4((projectionMatrix * translationMatrix * vec3(aVertexPosition, 1.0)).xy, 0.0, 1.0);

    vTextureCoord = (uTransform * vec3(aTextureCoord, 1.0)).xy;
}
`;


var $1d1523042091b3ae$export$2e2bcd8739ae039 = `#version 100
#ifdef GL_EXT_shader_texture_lod
    #extension GL_EXT_shader_texture_lod : enable
#endif
#define SHADER_NAME Tiling-Sprite-100

precision lowp float;

varying vec2 vTextureCoord;

uniform sampler2D uSampler;
uniform vec4 uColor;
uniform mat3 uMapCoord;
uniform vec4 uClampFrame;
uniform vec2 uClampOffset;

void main(void)
{
    vec2 coord = vTextureCoord + ceil(uClampOffset - vTextureCoord);
    coord = (uMapCoord * vec3(coord, 1.0)).xy;
    vec2 unclamped = coord;
    coord = clamp(coord, uClampFrame.xy, uClampFrame.zw);

    #ifdef GL_EXT_shader_texture_lod
        vec4 texSample = unclamped == coord
            ? texture2D(uSampler, coord) 
            : texture2DLodEXT(uSampler, coord, 0);
    #else
        vec4 texSample = texture2D(uSampler, coord);
    #endif

    gl_FragColor = texSample * uColor;
}
`;


var $1c14668f1037723d$export$2e2bcd8739ae039 = `#version 100
#define SHADER_NAME Tiling-Sprite-100

precision lowp float;

attribute vec2 aVertexPosition;
attribute vec2 aTextureCoord;

uniform mat3 projectionMatrix;
uniform mat3 translationMatrix;
uniform mat3 uTransform;

varying vec2 vTextureCoord;

void main(void)
{
    gl_Position = vec4((projectionMatrix * translationMatrix * vec3(aVertexPosition, 1.0)).xy, 0.0, 1.0);

    vTextureCoord = (uTransform * vec3(aTextureCoord, 1.0)).xy;
}
`;


var $d4d9fd083c0150e0$export$2e2bcd8739ae039 = `#version 100
#define SHADER_NAME Tiling-Sprite-Simple-100

precision lowp float;

varying vec2 vTextureCoord;

uniform sampler2D uSampler;
uniform vec4 uColor;

void main(void)
{
    vec4 texSample = texture2D(uSampler, vTextureCoord);
    gl_FragColor = texSample * uColor;
}
`;


const $a73e229650bd9327$var$tempMat = new (0, $d7da222aa639cde0$export$5b12bf1653c0dd85)();
class $a73e229650bd9327$export$8b7f6ad84090f14c extends (0, $0a2e1c9be4f09a9b$export$ca67b0b0fa758253) {
    /**
   * constructor for renderer
   * @param {PIXI.Renderer} renderer - The renderer this tiling awesomeness works for.
   */ constructor(renderer){
        super(renderer), renderer.runners.contextChange.add(this), this.quad = new (0, $5b24a8358280f4cf$export$4f70783f37e4ec0b)(), this.state = (0, $2b269c8c39349f63$export$7254cc27399e90bd).for2d();
    }
    /** Creates shaders when context is initialized. */ contextChange() {
        const renderer = this.renderer, uniforms = {
            globals: renderer.globalUniforms
        };
        this.simpleShader = (0, $8f87c04218e7eb6d$export$462bb059fed9d9e5).from((0, $1c14668f1037723d$export$2e2bcd8739ae039), (0, $d4d9fd083c0150e0$export$2e2bcd8739ae039), uniforms), this.shader = renderer.context.webGLVersion > 1 ? (0, $8f87c04218e7eb6d$export$462bb059fed9d9e5).from((0, $c9e680a62a234b74$export$2e2bcd8739ae039), (0, $3c443640cb5e8a4d$export$2e2bcd8739ae039), uniforms) : (0, $8f87c04218e7eb6d$export$462bb059fed9d9e5).from((0, $1c14668f1037723d$export$2e2bcd8739ae039), (0, $1d1523042091b3ae$export$2e2bcd8739ae039), uniforms);
    }
    /**
   * @param {PIXI.TilingSprite} ts - tilingSprite to be rendered
   */ render(ts) {
        const renderer = this.renderer, quad = this.quad;
        let vertices = quad.vertices;
        vertices[0] = vertices[6] = ts._width * -ts.anchor.x, vertices[1] = vertices[3] = ts._height * -ts.anchor.y, vertices[2] = vertices[4] = ts._width * (1 - ts.anchor.x), vertices[5] = vertices[7] = ts._height * (1 - ts.anchor.y);
        const anchorX = ts.uvRespectAnchor ? ts.anchor.x : 0, anchorY = ts.uvRespectAnchor ? ts.anchor.y : 0;
        vertices = quad.uvs, vertices[0] = vertices[6] = -anchorX, vertices[1] = vertices[3] = -anchorY, vertices[2] = vertices[4] = 1 - anchorX, vertices[5] = vertices[7] = 1 - anchorY, quad.invalidate();
        const tex = ts._texture, baseTex = tex.baseTexture, premultiplied = baseTex.alphaMode > 0, lt = ts.tileTransform.localTransform, uv = ts.uvMatrix;
        let isSimple = baseTex.isPowerOfTwo && tex.frame.width === baseTex.width && tex.frame.height === baseTex.height;
        isSimple && (baseTex._glTextures[renderer.CONTEXT_UID] ? isSimple = baseTex.wrapMode !== (0, $0fa4b07f86297abd$export$2ab395cfb0dd2f0f).CLAMP : baseTex.wrapMode === (0, $0fa4b07f86297abd$export$2ab395cfb0dd2f0f).CLAMP && (baseTex.wrapMode = (0, $0fa4b07f86297abd$export$2ab395cfb0dd2f0f).REPEAT));
        const shader = isSimple ? this.simpleShader : this.shader, w = tex.width, h = tex.height, W = ts._width, H = ts._height;
        $a73e229650bd9327$var$tempMat.set(lt.a * w / W, lt.b * w / H, lt.c * h / W, lt.d * h / H, lt.tx / W, lt.ty / H), $a73e229650bd9327$var$tempMat.invert(), isSimple ? $a73e229650bd9327$var$tempMat.prepend(uv.mapCoord) : (shader.uniforms.uMapCoord = uv.mapCoord.toArray(!0), shader.uniforms.uClampFrame = uv.uClampFrame, shader.uniforms.uClampOffset = uv.uClampOffset), shader.uniforms.uTransform = $a73e229650bd9327$var$tempMat.toArray(!0), shader.uniforms.uColor = (0, $15154c33c9e19c5f$export$892596cec99bc70e).shared.setValue(ts.tint).premultiply(ts.worldAlpha, premultiplied).toArray(shader.uniforms.uColor), shader.uniforms.translationMatrix = ts.transform.worldTransform.toArray(!0), shader.uniforms.uSampler = tex, renderer.shader.bind(shader), renderer.geometry.bind(quad), this.state.blendMode = (0, $db31fc3dfae4939b$exports).correctBlendMode(ts.blendMode, premultiplied), renderer.state.set(this.state), renderer.geometry.draw(this.renderer.gl.TRIANGLES, 6, 0);
    }
}
$a73e229650bd9327$export$8b7f6ad84090f14c.extension = {
    name: "tilingSprite",
    type: (0, $c90155f6d7d8d8f6$export$4f037c6ec2da4eeb).RendererPlugin
};
(0, $c90155f6d7d8d8f6$export$cc3e2d3244e01b7f).add($a73e229650bd9327$export$8b7f6ad84090f14c);





const $c5bfb7c3d79186ab$var$_Spritesheet = class _Spritesheet2 {
    /**
   * @param texture - Reference to the source BaseTexture object.
   * @param {object} data - Spritesheet image data.
   * @param resolutionFilename - The filename to consider when determining
   *        the resolution of the spritesheet. If not provided, the imageUrl will
   *        be used on the BaseTexture.
   */ constructor(texture, data, resolutionFilename = null){
        this.linkedSheets = [], this._texture = texture instanceof (0, $14896914ad3ae15d$export$5431306cf43de24a) ? texture : null, this.baseTexture = texture instanceof (0, $30c85657f0c625d5$export$d6306e508f184154) ? texture : this._texture.baseTexture, this.textures = {}, this.animations = {}, this.data = data;
        const resource = this.baseTexture.resource;
        this.resolution = this._updateResolution(resolutionFilename || (resource ? resource.url : null)), this._frames = this.data.frames, this._frameKeys = Object.keys(this._frames), this._batchIndex = 0, this._callback = null;
    }
    /**
   * Generate the resolution from the filename or fallback
   * to the meta.scale field of the JSON data.
   * @param resolutionFilename - The filename to use for resolving
   *        the default resolution.
   * @returns Resolution to use for spritesheet.
   */ _updateResolution(resolutionFilename = null) {
        const { scale: scale } = this.data.meta;
        let resolution = (0, $db31fc3dfae4939b$exports).getResolutionOfUrl(resolutionFilename, null);
        return resolution === null && (resolution = parseFloat(scale ?? "1")), resolution !== 1 && this.baseTexture.setResolution(resolution), resolution;
    }
    /**
   * Parser spritesheet from loaded data. This is done asynchronously
   * to prevent creating too many Texture within a single process.
   * @method PIXI.Spritesheet#parse
   */ parse() {
        return new Promise((resolve)=>{
            this._callback = resolve, this._batchIndex = 0, this._frameKeys.length <= _Spritesheet2.BATCH_SIZE ? (this._processFrames(0), this._processAnimations(), this._parseComplete()) : this._nextBatch();
        });
    }
    /**
   * Process a batch of frames
   * @param initialFrameIndex - The index of frame to start.
   */ _processFrames(initialFrameIndex) {
        let frameIndex = initialFrameIndex;
        const maxFrames = _Spritesheet2.BATCH_SIZE;
        for(; frameIndex - initialFrameIndex < maxFrames && frameIndex < this._frameKeys.length;){
            const i = this._frameKeys[frameIndex], data = this._frames[i], rect = data.frame;
            if (rect) {
                let frame = null, trim = null;
                const sourceSize = data.trimmed !== !1 && data.sourceSize ? data.sourceSize : data.frame, orig = new (0, $200f778d7fdbf8ac$export$4617fb02663045ef)(0, 0, Math.floor(sourceSize.w) / this.resolution, Math.floor(sourceSize.h) / this.resolution);
                data.rotated ? frame = new (0, $200f778d7fdbf8ac$export$4617fb02663045ef)(Math.floor(rect.x) / this.resolution, Math.floor(rect.y) / this.resolution, Math.floor(rect.h) / this.resolution, Math.floor(rect.w) / this.resolution) : frame = new (0, $200f778d7fdbf8ac$export$4617fb02663045ef)(Math.floor(rect.x) / this.resolution, Math.floor(rect.y) / this.resolution, Math.floor(rect.w) / this.resolution, Math.floor(rect.h) / this.resolution), data.trimmed !== !1 && data.spriteSourceSize && (trim = new (0, $200f778d7fdbf8ac$export$4617fb02663045ef)(Math.floor(data.spriteSourceSize.x) / this.resolution, Math.floor(data.spriteSourceSize.y) / this.resolution, Math.floor(rect.w) / this.resolution, Math.floor(rect.h) / this.resolution)), this.textures[i] = new (0, $14896914ad3ae15d$export$5431306cf43de24a)(this.baseTexture, frame, orig, trim, data.rotated ? 2 : 0, data.anchor, data.borders), (0, $14896914ad3ae15d$export$5431306cf43de24a).addToCache(this.textures[i], i.toString());
            }
            frameIndex++;
        }
    }
    /** Parse animations config. */ _processAnimations() {
        const animations = this.data.animations || {};
        for(const animName in animations){
            this.animations[animName] = [];
            for(let i = 0; i < animations[animName].length; i++){
                const frameName = animations[animName][i];
                this.animations[animName].push(this.textures[frameName]);
            }
        }
    }
    /** The parse has completed. */ _parseComplete() {
        const callback = this._callback;
        this._callback = null, this._batchIndex = 0, callback.call(this, this.textures);
    }
    /** Begin the next batch of textures. */ _nextBatch() {
        this._processFrames(this._batchIndex * _Spritesheet2.BATCH_SIZE), this._batchIndex++, setTimeout(()=>{
            this._batchIndex * _Spritesheet2.BATCH_SIZE < this._frameKeys.length ? this._nextBatch() : (this._processAnimations(), this._parseComplete());
        }, 0);
    }
    /**
   * Destroy Spritesheet and don't use after this.
   * @param {boolean} [destroyBase=false] - Whether to destroy the base texture as well
   */ destroy(destroyBase = !1) {
        for(const i in this.textures)this.textures[i].destroy();
        this._frames = null, this._frameKeys = null, this.data = null, this.textures = null, destroyBase && (this._texture?.destroy(), this.baseTexture.destroy()), this._texture = null, this.baseTexture = null, this.linkedSheets = [];
    }
};
$c5bfb7c3d79186ab$var$_Spritesheet.BATCH_SIZE = 1e3;
let $c5bfb7c3d79186ab$export$674d2eb4debbef0c = $c5bfb7c3d79186ab$var$_Spritesheet;





const $739a7fe01b5ceb57$var$validImages = [
    "jpg",
    "png",
    "jpeg",
    "avif",
    "webp"
];
function $739a7fe01b5ceb57$var$getCacheableAssets(keys, asset, ignoreMultiPack) {
    const out = {};
    if (keys.forEach((key)=>{
        out[key] = asset;
    }), Object.keys(asset.textures).forEach((key)=>{
        out[key] = asset.textures[key];
    }), !ignoreMultiPack) {
        const basePath = (0, $db31fc3dfae4939b$exports).path.dirname(keys[0]);
        asset.linkedSheets.forEach((item, i)=>{
            const out2 = $739a7fe01b5ceb57$var$getCacheableAssets([
                `${basePath}/${asset.data.meta.related_multi_packs[i]}`
            ], item, !0);
            Object.assign(out, out2);
        });
    }
    return out;
}
const $739a7fe01b5ceb57$export$46dcda4f1cdd80fe = {
    extension: (0, $c90155f6d7d8d8f6$export$4f037c6ec2da4eeb).Asset,
    /** Handle the caching of the related Spritesheet Textures */ cache: {
        test: (asset)=>asset instanceof (0, $c5bfb7c3d79186ab$export$674d2eb4debbef0c),
        getCacheableAssets: (keys, asset)=>$739a7fe01b5ceb57$var$getCacheableAssets(keys, asset, !1)
    },
    /** Resolve the the resolution of the asset. */ resolver: {
        test: (value)=>{
            const split = value.split("?")[0].split("."), extension = split.pop(), format = split.pop();
            return extension === "json" && $739a7fe01b5ceb57$var$validImages.includes(format);
        },
        parse: (value)=>{
            const split = value.split(".");
            return {
                resolution: parseFloat((0, $2808efac47e52be0$export$a5a6e0b888b2c992).RETINA_PREFIX.exec(value)?.[1] ?? "1"),
                format: split[split.length - 2],
                src: value
            };
        }
    },
    /**
   * Loader plugin that parses sprite sheets!
   * once the JSON has been loaded this checks to see if the JSON is spritesheet data.
   * If it is, we load the spritesheets image and parse the data into PIXI.Spritesheet
   * All textures in the sprite sheet are then added to the cache
   * @ignore
   */ loader: {
        name: "spritesheetLoader",
        extension: {
            type: (0, $c90155f6d7d8d8f6$export$4f037c6ec2da4eeb).LoadParser,
            priority: (0, $ed5d6a4467c2b40c$export$820ed6348c4f2750).Normal
        },
        async testParse (asset, options) {
            return (0, $db31fc3dfae4939b$exports).path.extname(options.src).toLowerCase() === ".json" && !!asset.frames;
        },
        async parse (asset, options, loader) {
            let basePath = (0, $db31fc3dfae4939b$exports).path.dirname(options.src);
            basePath && basePath.lastIndexOf("/") !== basePath.length - 1 && (basePath += "/");
            let imagePath = basePath + asset.meta.image;
            imagePath = (0, $a06717d44d10be9c$export$f57b97ef8be10dda)(imagePath, options.src);
            const texture = (await loader.load([
                imagePath
            ]))[imagePath], spritesheet = new (0, $c5bfb7c3d79186ab$export$674d2eb4debbef0c)(texture.baseTexture, asset, options.src);
            await spritesheet.parse();
            const multiPacks = asset?.meta?.related_multi_packs;
            if (Array.isArray(multiPacks)) {
                const promises = [];
                for (const item of multiPacks){
                    if (typeof item != "string") continue;
                    let itemUrl = basePath + item;
                    options.data?.ignoreMultiPack || (itemUrl = (0, $a06717d44d10be9c$export$f57b97ef8be10dda)(itemUrl, options.src), promises.push(loader.load({
                        src: itemUrl,
                        data: {
                            ignoreMultiPack: !0
                        }
                    })));
                }
                const res = await Promise.all(promises);
                spritesheet.linkedSheets = res, res.forEach((item)=>{
                    item.linkedSheets = [
                        spritesheet
                    ].concat(spritesheet.linkedSheets.filter((sp)=>sp !== item));
                });
            }
            return spritesheet;
        },
        unload (spritesheet) {
            spritesheet.destroy(!0);
        }
    }
};
(0, $c90155f6d7d8d8f6$export$cc3e2d3244e01b7f).add($739a7fe01b5ceb57$export$46dcda4f1cdd80fe);







class $d89d96868060daf7$export$2fb2a0e272ba703b {
    constructor(){
        this.info = [], this.common = [], this.page = [], this.char = [], this.kerning = [], this.distanceField = [];
    }
}



class $16e192692c700f9c$export$ff5bf922eba68a09 {
    /**
   * Check if resource refers to txt font data.
   * @param data
   * @returns - True if resource could be treated as font data, false otherwise.
   */ static test(data) {
        return typeof data == "string" && data.startsWith("info face=");
    }
    /**
   * Convert text font data to a javascript object.
   * @param txt - Raw string data to be converted
   * @returns - Parsed font data
   */ static parse(txt) {
        const items = txt.match(/^[a-z]+\s+.+$/gm), rawData = {
            info: [],
            common: [],
            page: [],
            char: [],
            chars: [],
            kerning: [],
            kernings: [],
            distanceField: []
        };
        for(const i in items){
            const name = items[i].match(/^[a-z]+/gm)[0], attributeList = items[i].match(/[a-zA-Z]+=([^\s"']+|"([^"]*)")/gm), itemData = {};
            for(const i2 in attributeList){
                const split = attributeList[i2].split("="), key = split[0], strValue = split[1].replace(/"/gm, ""), floatValue = parseFloat(strValue), value = isNaN(floatValue) ? strValue : floatValue;
                itemData[key] = value;
            }
            rawData[name].push(itemData);
        }
        const font = new (0, $d89d96868060daf7$export$2fb2a0e272ba703b)();
        return rawData.info.forEach((info)=>font.info.push({
                face: info.face,
                size: parseInt(info.size, 10)
            })), rawData.common.forEach((common)=>font.common.push({
                lineHeight: parseInt(common.lineHeight, 10)
            })), rawData.page.forEach((page)=>font.page.push({
                id: parseInt(page.id, 10),
                file: page.file
            })), rawData.char.forEach((char)=>font.char.push({
                id: parseInt(char.id, 10),
                page: parseInt(char.page, 10),
                x: parseInt(char.x, 10),
                y: parseInt(char.y, 10),
                width: parseInt(char.width, 10),
                height: parseInt(char.height, 10),
                xoffset: parseInt(char.xoffset, 10),
                yoffset: parseInt(char.yoffset, 10),
                xadvance: parseInt(char.xadvance, 10)
            })), rawData.kerning.forEach((kerning)=>font.kerning.push({
                first: parseInt(kerning.first, 10),
                second: parseInt(kerning.second, 10),
                amount: parseInt(kerning.amount, 10)
            })), rawData.distanceField.forEach((df)=>font.distanceField.push({
                distanceRange: parseInt(df.distanceRange, 10),
                fieldType: df.fieldType
            })), font;
    }
}



class $88cebda3b7a3dbb3$export$4e1527335cae8d18 {
    /**
   * Check if resource refers to xml font data.
   * @param data
   * @returns - True if resource could be treated as font data, false otherwise.
   */ static test(data) {
        const xml = data;
        return typeof data != "string" && "getElementsByTagName" in data && xml.getElementsByTagName("page").length && xml.getElementsByTagName("info")[0].getAttribute("face") !== null;
    }
    /**
   * Convert the XML into BitmapFontData that we can use.
   * @param xml
   * @returns - Data to use for BitmapFont
   */ static parse(xml) {
        const data = new (0, $d89d96868060daf7$export$2fb2a0e272ba703b)(), info = xml.getElementsByTagName("info"), common = xml.getElementsByTagName("common"), page = xml.getElementsByTagName("page"), char = xml.getElementsByTagName("char"), kerning = xml.getElementsByTagName("kerning"), distanceField = xml.getElementsByTagName("distanceField");
        for(let i = 0; i < info.length; i++)data.info.push({
            face: info[i].getAttribute("face"),
            size: parseInt(info[i].getAttribute("size"), 10)
        });
        for(let i = 0; i < common.length; i++)data.common.push({
            lineHeight: parseInt(common[i].getAttribute("lineHeight"), 10)
        });
        for(let i = 0; i < page.length; i++)data.page.push({
            id: parseInt(page[i].getAttribute("id"), 10) || 0,
            file: page[i].getAttribute("file")
        });
        for(let i = 0; i < char.length; i++){
            const letter = char[i];
            data.char.push({
                id: parseInt(letter.getAttribute("id"), 10),
                page: parseInt(letter.getAttribute("page"), 10) || 0,
                x: parseInt(letter.getAttribute("x"), 10),
                y: parseInt(letter.getAttribute("y"), 10),
                width: parseInt(letter.getAttribute("width"), 10),
                height: parseInt(letter.getAttribute("height"), 10),
                xoffset: parseInt(letter.getAttribute("xoffset"), 10),
                yoffset: parseInt(letter.getAttribute("yoffset"), 10),
                xadvance: parseInt(letter.getAttribute("xadvance"), 10)
            });
        }
        for(let i = 0; i < kerning.length; i++)data.kerning.push({
            first: parseInt(kerning[i].getAttribute("first"), 10),
            second: parseInt(kerning[i].getAttribute("second"), 10),
            amount: parseInt(kerning[i].getAttribute("amount"), 10)
        });
        for(let i = 0; i < distanceField.length; i++)data.distanceField.push({
            fieldType: distanceField[i].getAttribute("fieldType"),
            distanceRange: parseInt(distanceField[i].getAttribute("distanceRange"), 10)
        });
        return data;
    }
}




class $06a116739660aa3e$export$9322acbf234f5703 {
    /**
   * Check if resource refers to text xml font data.
   * @param data
   * @returns - True if resource could be treated as font data, false otherwise.
   */ static test(data) {
        return typeof data == "string" && data.includes("<font>") ? (0, $88cebda3b7a3dbb3$export$4e1527335cae8d18).test((0, $2808efac47e52be0$export$a5a6e0b888b2c992).ADAPTER.parseXML(data)) : !1;
    }
    /**
   * Convert the text XML into BitmapFontData that we can use.
   * @param xmlTxt
   * @returns - Data to use for BitmapFont
   */ static parse(xmlTxt) {
        return (0, $88cebda3b7a3dbb3$export$4e1527335cae8d18).parse((0, $2808efac47e52be0$export$a5a6e0b888b2c992).ADAPTER.parseXML(xmlTxt));
    }
}


const $6f3b1d57c2baac5a$var$formats = [
    (0, $16e192692c700f9c$export$ff5bf922eba68a09),
    (0, $88cebda3b7a3dbb3$export$4e1527335cae8d18),
    (0, $06a116739660aa3e$export$9322acbf234f5703)
];
function $6f3b1d57c2baac5a$export$260d11d424c8eebd(data) {
    for(let i = 0; i < $6f3b1d57c2baac5a$var$formats.length; i++)if ($6f3b1d57c2baac5a$var$formats[i].test(data)) return $6f3b1d57c2baac5a$var$formats[i];
    return null;
}




function $05d52b2222c872a0$export$f6a80096f20930c(canvas, context, style, resolution, lines, metrics) {
    const fillStyle = style.fill;
    if (Array.isArray(fillStyle)) {
        if (fillStyle.length === 1) return fillStyle[0];
    } else return fillStyle;
    let gradient;
    const dropShadowCorrection = style.dropShadow ? style.dropShadowDistance : 0, padding = style.padding || 0, width = canvas.width / resolution - dropShadowCorrection - padding * 2, height = canvas.height / resolution - dropShadowCorrection - padding * 2, fill = fillStyle.slice(), fillGradientStops = style.fillGradientStops.slice();
    if (!fillGradientStops.length) {
        const lengthPlus1 = fill.length + 1;
        for(let i = 1; i < lengthPlus1; ++i)fillGradientStops.push(i / lengthPlus1);
    }
    if (fill.unshift(fillStyle[0]), fillGradientStops.unshift(0), fill.push(fillStyle[fillStyle.length - 1]), fillGradientStops.push(1), style.fillGradientType === (0, $029097fab1db53a0$export$131daa784848984).LINEAR_VERTICAL) {
        gradient = context.createLinearGradient(width / 2, padding, width / 2, height + padding);
        let lastIterationStop = 0;
        const gradStopLineHeight = (metrics.fontProperties.fontSize + style.strokeThickness) / height;
        for(let i = 0; i < lines.length; i++){
            const thisLineTop = metrics.lineHeight * i;
            for(let j = 0; j < fill.length; j++){
                let lineStop = 0;
                typeof fillGradientStops[j] == "number" ? lineStop = fillGradientStops[j] : lineStop = j / fill.length;
                const globalStop = thisLineTop / height + lineStop * gradStopLineHeight;
                let clampedStop = Math.max(lastIterationStop, globalStop);
                clampedStop = Math.min(clampedStop, 1), gradient.addColorStop(clampedStop, fill[j]), lastIterationStop = clampedStop;
            }
        }
    } else {
        gradient = context.createLinearGradient(padding, height / 2, width + padding, height / 2);
        const totalIterations = fill.length + 1;
        let currentIteration = 1;
        for(let i = 0; i < fill.length; i++){
            let stop;
            typeof fillGradientStops[i] == "number" ? stop = fillGradientStops[i] : stop = currentIteration / totalIterations, gradient.addColorStop(stop, fill[i]), currentIteration++;
        }
    }
    return gradient;
}


function $a6b896a81c3c1241$export$d41775f6694ba493(canvas, context, metrics, x, y, resolution, style) {
    const char = metrics.text, fontProperties = metrics.fontProperties;
    context.translate(x, y), context.scale(resolution, resolution);
    const tx = style.strokeThickness / 2, ty = -(style.strokeThickness / 2);
    if (context.font = style.toFontString(), context.lineWidth = style.strokeThickness, context.textBaseline = style.textBaseline, context.lineJoin = style.lineJoin, context.miterLimit = style.miterLimit, context.fillStyle = (0, $05d52b2222c872a0$export$f6a80096f20930c)(canvas, context, style, resolution, [
        char
    ], metrics), context.strokeStyle = style.stroke, style.dropShadow) {
        const dropShadowColor = style.dropShadowColor, dropShadowBlur = style.dropShadowBlur * resolution, dropShadowDistance = style.dropShadowDistance * resolution;
        context.shadowColor = (0, $15154c33c9e19c5f$export$892596cec99bc70e).shared.setValue(dropShadowColor).setAlpha(style.dropShadowAlpha).toRgbaString(), context.shadowBlur = dropShadowBlur, context.shadowOffsetX = Math.cos(style.dropShadowAngle) * dropShadowDistance, context.shadowOffsetY = Math.sin(style.dropShadowAngle) * dropShadowDistance;
    } else context.shadowColor = "black", context.shadowBlur = 0, context.shadowOffsetX = 0, context.shadowOffsetY = 0;
    style.stroke && style.strokeThickness && context.strokeText(char, tx, ty + metrics.lineHeight - fontProperties.descent), style.fill && context.fillText(char, tx, ty + metrics.lineHeight - fontProperties.descent), context.setTransform(1, 0, 0, 1, 0, 0), context.fillStyle = "rgba(0, 0, 0, 0)";
}


function $6528b85dcf3159cf$export$ee42a04f33018f4b(str) {
    return str.codePointAt ? str.codePointAt(0) : str.charCodeAt(0);
}



function $a9f1638343675db0$export$b2c801ee49e0a334(text) {
    return Array.from ? Array.from(text) : text.split("");
}


function $651078c72f426a12$export$221291e5031b03d8(chars) {
    typeof chars == "string" && (chars = [
        chars
    ]);
    const result = [];
    for(let i = 0, j = chars.length; i < j; i++){
        const item = chars[i];
        if (Array.isArray(item)) {
            if (item.length !== 2) throw new Error(`[BitmapFont]: Invalid character range length, expecting 2 got ${item.length}.`);
            const startCode = item[0].charCodeAt(0), endCode = item[1].charCodeAt(0);
            if (endCode < startCode) throw new Error("[BitmapFont]: Invalid character range.");
            for(let i2 = startCode, j2 = endCode; i2 <= j2; i2++)result.push(String.fromCharCode(i2));
        } else result.push(...(0, $a9f1638343675db0$export$b2c801ee49e0a334)(item));
    }
    if (result.length === 0) throw new Error("[BitmapFont]: Empty set when resolving characters.");
    return result;
}








const $f9598d071f8144d5$var$_BitmapFont = class _BitmapFont2 {
    /**
   * @param data
   * @param textures
   * @param ownsTextures - Setting to `true` will destroy page textures
   *        when the font is uninstalled.
   */ constructor(data, textures, ownsTextures){
        const [info] = data.info, [common] = data.common, [page] = data.page, [distanceField] = data.distanceField, res = (0, $db31fc3dfae4939b$exports).getResolutionOfUrl(page.file), pageTextures = {};
        this._ownsTextures = ownsTextures, this.font = info.face, this.size = info.size, this.lineHeight = common.lineHeight / res, this.chars = {}, this.pageTextures = pageTextures;
        for(let i = 0; i < data.page.length; i++){
            const { id: id, file: file } = data.page[i];
            pageTextures[id] = textures instanceof Array ? textures[i] : textures[file], distanceField?.fieldType && distanceField.fieldType !== "none" && (pageTextures[id].baseTexture.alphaMode = (0, $0fa4b07f86297abd$export$d56550d454401b73).NO_PREMULTIPLIED_ALPHA, pageTextures[id].baseTexture.mipmap = (0, $0fa4b07f86297abd$export$16f6fb5da874bbfd).OFF);
        }
        for(let i = 0; i < data.char.length; i++){
            const { id: id, page: page2 } = data.char[i];
            let { x: x, y: y, width: width, height: height, xoffset: xoffset, yoffset: yoffset, xadvance: xadvance } = data.char[i];
            x /= res, y /= res, width /= res, height /= res, xoffset /= res, yoffset /= res, xadvance /= res;
            const rect = new (0, $200f778d7fdbf8ac$export$4617fb02663045ef)(x + pageTextures[page2].frame.x / res, y + pageTextures[page2].frame.y / res, width, height);
            this.chars[id] = {
                xOffset: xoffset,
                yOffset: yoffset,
                xAdvance: xadvance,
                kerning: {},
                texture: new (0, $14896914ad3ae15d$export$5431306cf43de24a)(pageTextures[page2].baseTexture, rect),
                page: page2
            };
        }
        for(let i = 0; i < data.kerning.length; i++){
            let { first: first, second: second, amount: amount } = data.kerning[i];
            first /= res, second /= res, amount /= res, this.chars[second] && (this.chars[second].kerning[first] = amount);
        }
        this.distanceFieldRange = distanceField?.distanceRange, this.distanceFieldType = distanceField?.fieldType?.toLowerCase() ?? "none";
    }
    /** Remove references to created glyph textures. */ destroy() {
        for(const id in this.chars)this.chars[id].texture.destroy(), this.chars[id].texture = null;
        for(const id in this.pageTextures)this._ownsTextures && this.pageTextures[id].destroy(!0), this.pageTextures[id] = null;
        this.chars = null, this.pageTextures = null;
    }
    /**
   * Register a new bitmap font.
   * @param data - The
   *        characters map that could be provided as xml or raw string.
   * @param textures - List of textures for each page.
   * @param ownsTextures - Set to `true` to destroy page textures
   *        when the font is uninstalled. By default fonts created with
   *        `BitmapFont.from` or from the `BitmapFontLoader` are `true`.
   * @returns {PIXI.BitmapFont} Result font object with font, size, lineHeight
   *         and char fields.
   */ static install(data, textures, ownsTextures) {
        let fontData;
        if (data instanceof (0, $d89d96868060daf7$export$2fb2a0e272ba703b)) fontData = data;
        else {
            const format = (0, $6f3b1d57c2baac5a$export$260d11d424c8eebd)(data);
            if (!format) throw new Error("Unrecognized data format for font.");
            fontData = format.parse(data);
        }
        textures instanceof (0, $14896914ad3ae15d$export$5431306cf43de24a) && (textures = [
            textures
        ]);
        const font = new _BitmapFont2(fontData, textures, ownsTextures);
        return _BitmapFont2.available[font.font] = font, font;
    }
    /**
   * Remove bitmap font by name.
   * @param name - Name of the font to uninstall.
   */ static uninstall(name) {
        const font = _BitmapFont2.available[name];
        if (!font) throw new Error(`No font found named '${name}'`);
        font.destroy(), delete _BitmapFont2.available[name];
    }
    /**
   * Generates a bitmap-font for the given style and character set. This does not support
   * kernings yet. With `style` properties, only the following non-layout properties are used:
   *
   * - {@link PIXI.TextStyle#dropShadow|dropShadow}
   * - {@link PIXI.TextStyle#dropShadowDistance|dropShadowDistance}
   * - {@link PIXI.TextStyle#dropShadowColor|dropShadowColor}
   * - {@link PIXI.TextStyle#dropShadowBlur|dropShadowBlur}
   * - {@link PIXI.TextStyle#dropShadowAngle|dropShadowAngle}
   * - {@link PIXI.TextStyle#fill|fill}
   * - {@link PIXI.TextStyle#fillGradientStops|fillGradientStops}
   * - {@link PIXI.TextStyle#fillGradientType|fillGradientType}
   * - {@link PIXI.TextStyle#fontFamily|fontFamily}
   * - {@link PIXI.TextStyle#fontSize|fontSize}
   * - {@link PIXI.TextStyle#fontVariant|fontVariant}
   * - {@link PIXI.TextStyle#fontWeight|fontWeight}
   * - {@link PIXI.TextStyle#lineJoin|lineJoin}
   * - {@link PIXI.TextStyle#miterLimit|miterLimit}
   * - {@link PIXI.TextStyle#stroke|stroke}
   * - {@link PIXI.TextStyle#strokeThickness|strokeThickness}
   * - {@link PIXI.TextStyle#textBaseline|textBaseline}
   * @param name - The name of the custom font to use with BitmapText.
   * @param textStyle - Style options to render with BitmapFont.
   * @param options - Setup options for font or name of the font.
   * @returns Font generated by style options.
   * @example
   * import { BitmapFont, BitmapText } from 'pixi.js';
   *
   * BitmapFont.from('TitleFont', {
   *     fontFamily: 'Arial',
   *     fontSize: 12,
   *     strokeThickness: 2,
   *     fill: 'purple',
   * });
   *
   * const title = new BitmapText('This is the title', { fontName: 'TitleFont' });
   */ static from(name, textStyle, options) {
        if (!name) throw new Error("[BitmapFont] Property `name` is required.");
        const { chars: chars, padding: padding, resolution: resolution, textureWidth: textureWidth, textureHeight: textureHeight, ...baseOptions } = Object.assign({}, _BitmapFont2.defaultOptions, options), charsList = (0, $651078c72f426a12$export$221291e5031b03d8)(chars), style = textStyle instanceof (0, $3d453260a3c8e0f7$export$1df879243bf2e42d) ? textStyle : new (0, $3d453260a3c8e0f7$export$1df879243bf2e42d)(textStyle), lineWidth = textureWidth, fontData = new (0, $d89d96868060daf7$export$2fb2a0e272ba703b)();
        fontData.info[0] = {
            face: style.fontFamily,
            size: style.fontSize
        }, fontData.common[0] = {
            lineHeight: style.fontSize
        };
        let positionX = 0, positionY = 0, canvas, context, baseTexture, maxCharHeight = 0;
        const baseTextures = [], textures = [];
        for(let i = 0; i < charsList.length; i++){
            canvas || (canvas = (0, $2808efac47e52be0$export$a5a6e0b888b2c992).ADAPTER.createCanvas(), canvas.width = textureWidth, canvas.height = textureHeight, context = canvas.getContext("2d"), baseTexture = new (0, $30c85657f0c625d5$export$d6306e508f184154)(canvas, {
                resolution: resolution,
                ...baseOptions
            }), baseTextures.push(baseTexture), textures.push(new (0, $14896914ad3ae15d$export$5431306cf43de24a)(baseTexture)), fontData.page.push({
                id: textures.length - 1,
                file: ""
            }));
            const character = charsList[i], metrics = (0, $31f48a8131702733$export$4c5a129a59e1ef34).measureText(character, style, !1, canvas), width = metrics.width, height = Math.ceil(metrics.height), textureGlyphWidth = Math.ceil((style.fontStyle === "italic" ? 2 : 1) * width);
            if (positionY >= textureHeight - height * resolution) {
                if (positionY === 0) throw new Error(`[BitmapFont] textureHeight ${textureHeight}px is too small (fontFamily: '${style.fontFamily}', fontSize: ${style.fontSize}px, char: '${character}')`);
                --i, canvas = null, context = null, baseTexture = null, positionY = 0, positionX = 0, maxCharHeight = 0;
                continue;
            }
            if (maxCharHeight = Math.max(height + metrics.fontProperties.descent, maxCharHeight), textureGlyphWidth * resolution + positionX >= lineWidth) {
                if (positionX === 0) throw new Error(`[BitmapFont] textureWidth ${textureWidth}px is too small (fontFamily: '${style.fontFamily}', fontSize: ${style.fontSize}px, char: '${character}')`);
                --i, positionY += maxCharHeight * resolution, positionY = Math.ceil(positionY), positionX = 0, maxCharHeight = 0;
                continue;
            }
            (0, $a6b896a81c3c1241$export$d41775f6694ba493)(canvas, context, metrics, positionX, positionY, resolution, style);
            const id = (0, $6528b85dcf3159cf$export$ee42a04f33018f4b)(metrics.text);
            fontData.char.push({
                id: id,
                page: textures.length - 1,
                x: positionX / resolution,
                y: positionY / resolution,
                width: textureGlyphWidth,
                height: height,
                xoffset: 0,
                yoffset: 0,
                xadvance: width - (style.dropShadow ? style.dropShadowDistance : 0) - (style.stroke ? style.strokeThickness : 0)
            }), positionX += (textureGlyphWidth + 2 * padding) * resolution, positionX = Math.ceil(positionX);
        }
        if (!options?.skipKerning) for(let i = 0, len = charsList.length; i < len; i++){
            const first = charsList[i];
            for(let j = 0; j < len; j++){
                const second = charsList[j], c1 = context.measureText(first).width, c2 = context.measureText(second).width, amount = context.measureText(first + second).width - (c1 + c2);
                amount && fontData.kerning.push({
                    first: (0, $6528b85dcf3159cf$export$ee42a04f33018f4b)(first),
                    second: (0, $6528b85dcf3159cf$export$ee42a04f33018f4b)(second),
                    amount: amount
                });
            }
        }
        const font = new _BitmapFont2(fontData, textures, !0);
        return _BitmapFont2.available[name] !== void 0 && _BitmapFont2.uninstall(name), _BitmapFont2.available[name] = font, font;
    }
};
$f9598d071f8144d5$var$_BitmapFont.ALPHA = [
    [
        "a",
        "z"
    ],
    [
        "A",
        "Z"
    ],
    " "
], /**
* This character set includes all decimal digits (from 0 to 9).
* @type {string[][]}
* @example
* BitmapFont.from('ExampleFont', style, { chars: BitmapFont.NUMERIC })
*/ $f9598d071f8144d5$var$_BitmapFont.NUMERIC = [
    [
        "0",
        "9"
    ]
], /**
* This character set is the union of `BitmapFont.ALPHA` and `BitmapFont.NUMERIC`.
* @type {string[][]}
*/ $f9598d071f8144d5$var$_BitmapFont.ALPHANUMERIC = [
    [
        "a",
        "z"
    ],
    [
        "A",
        "Z"
    ],
    [
        "0",
        "9"
    ],
    " "
], /**
* This character set consists of all the ASCII table.
* @member {string[][]}
* @see http://www.asciitable.com/
*/ $f9598d071f8144d5$var$_BitmapFont.ASCII = [
    [
        " ",
        "~"
    ]
], /**
* Collection of default options when using `BitmapFont.from`.
* @property {number} [resolution=1] -
* @property {number} [textureWidth=512] -
* @property {number} [textureHeight=512] -
* @property {number} [padding=4] -
* @property {string|string[]|string[][]} chars = PIXI.BitmapFont.ALPHANUMERIC
*/ $f9598d071f8144d5$var$_BitmapFont.defaultOptions = {
    resolution: 1,
    textureWidth: 512,
    textureHeight: 512,
    padding: 4,
    chars: $f9598d071f8144d5$var$_BitmapFont.ALPHANUMERIC
}, /** Collection of available/installed fonts. */ $f9598d071f8144d5$var$_BitmapFont.available = {};
let $f9598d071f8144d5$export$17957a09927cadc7 = $f9598d071f8144d5$var$_BitmapFont;







var $e282e2f8c488a501$export$2e2bcd8739ae039 = `// Pixi texture info\r
varying vec2 vTextureCoord;\r
uniform sampler2D uSampler;\r
\r
// Tint\r
uniform vec4 uColor;\r
\r
// on 2D applications fwidth is screenScale / glyphAtlasScale * distanceFieldRange\r
uniform float uFWidth;\r
\r
void main(void) {\r
\r
  // To stack MSDF and SDF we need a non-pre-multiplied-alpha texture.\r
  vec4 texColor = texture2D(uSampler, vTextureCoord);\r
\r
  // MSDF\r
  float median = texColor.r + texColor.g + texColor.b -\r
                  min(texColor.r, min(texColor.g, texColor.b)) -\r
                  max(texColor.r, max(texColor.g, texColor.b));\r
  // SDF\r
  median = min(median, texColor.a);\r
\r
  float screenPxDistance = uFWidth * (median - 0.5);\r
  float alpha = clamp(screenPxDistance + 0.5, 0.0, 1.0);\r
  if (median < 0.01) {\r
    alpha = 0.0;\r
  } else if (median > 0.99) {\r
    alpha = 1.0;\r
  }\r
\r
  // Gamma correction for coverage-like alpha\r
  float luma = dot(uColor.rgb, vec3(0.299, 0.587, 0.114));\r
  float gamma = mix(1.0, 1.0 / 2.2, luma);\r
  float coverage = pow(uColor.a * alpha, gamma);  \r
\r
  // NPM Textures, NPM outputs\r
  gl_FragColor = vec4(uColor.rgb, coverage);\r
}\r
`;


var $3a603077fdf7e911$export$2e2bcd8739ae039 = `// Mesh material default fragment\r
attribute vec2 aVertexPosition;\r
attribute vec2 aTextureCoord;\r
\r
uniform mat3 projectionMatrix;\r
uniform mat3 translationMatrix;\r
uniform mat3 uTextureMatrix;\r
\r
varying vec2 vTextureCoord;\r
\r
void main(void)\r
{\r
    gl_Position = vec4((projectionMatrix * translationMatrix * vec3(aVertexPosition, 1.0)).xy, 0.0, 1.0);\r
\r
    vTextureCoord = (uTextureMatrix * vec3(aTextureCoord, 1.0)).xy;\r
}\r
`;





const $801d0b128be534a4$var$pageMeshDataDefaultPageMeshData = [], $801d0b128be534a4$var$pageMeshDataMSDFPageMeshData = [], $801d0b128be534a4$var$charRenderDataPool = [], $801d0b128be534a4$var$_BitmapText = class _BitmapText2 extends (0, $68e6944de5989822$export$42a852a2b6b56249) {
    /**
   * @param text - A string that you would like the text to display.
   * @param style - The style parameters.
   * @param {string} style.fontName - The installed BitmapFont name.
   * @param {number} [style.fontSize] - The size of the font in pixels, e.g. 24. If undefined,
   *.     this will default to the BitmapFont size.
   * @param {string} [style.align='left'] - Alignment for multiline text ('left', 'center', 'right' or 'justify'),
   *      does not affect single line text.
   * @param {PIXI.ColorSource} [style.tint=0xFFFFFF] - The tint color.
   * @param {number} [style.letterSpacing=0] - The amount of spacing between letters.
   * @param {number} [style.maxWidth=0] - The max width of the text before line wrapping.
   */ constructor(text, style = {}){
        super();
        const { align: align, tint: tint, maxWidth: maxWidth, letterSpacing: letterSpacing, fontName: fontName, fontSize: fontSize } = Object.assign({}, _BitmapText2.styleDefaults, style);
        if (!(0, $f9598d071f8144d5$export$17957a09927cadc7).available[fontName]) throw new Error(`Missing BitmapFont "${fontName}"`);
        this._activePagesMeshData = [], this._textWidth = 0, this._textHeight = 0, this._align = align, this._tintColor = new (0, $15154c33c9e19c5f$export$892596cec99bc70e)(tint), this._font = void 0, this._fontName = fontName, this._fontSize = fontSize, this.text = text, this._maxWidth = maxWidth, this._maxLineHeight = 0, this._letterSpacing = letterSpacing, this._anchor = new (0, $52576bc20755886a$export$3755aaad3fd42e52)(()=>{
            this.dirty = !0;
        }, this, 0, 0), this._roundPixels = (0, $2808efac47e52be0$export$a5a6e0b888b2c992).ROUND_PIXELS, this.dirty = !0, this._resolution = (0, $2808efac47e52be0$export$a5a6e0b888b2c992).RESOLUTION, this._autoResolution = !0, this._textureCache = {};
    }
    /** Renders text and updates it when needed. This should only be called if the BitmapFont is regenerated. */ updateText() {
        const data = (0, $f9598d071f8144d5$export$17957a09927cadc7).available[this._fontName], fontSize = this.fontSize, scale = fontSize / data.size, pos = new (0, $cf3018b4309864c2$export$baf26146a414f24a)(), chars = [], lineWidths = [], lineSpaces = [], text = this._text.replace(/(?:\r\n|\r)/g, `
`) || " ", charsInput = (0, $a9f1638343675db0$export$b2c801ee49e0a334)(text), maxWidth = this._maxWidth * data.size / fontSize, pageMeshDataPool = data.distanceFieldType === "none" ? $801d0b128be534a4$var$pageMeshDataDefaultPageMeshData : $801d0b128be534a4$var$pageMeshDataMSDFPageMeshData;
        let prevCharCode = null, lastLineWidth = 0, maxLineWidth = 0, line = 0, lastBreakPos = -1, lastBreakWidth = 0, spacesRemoved = 0, maxLineHeight = 0, spaceCount = 0;
        for(let i = 0; i < charsInput.length; i++){
            const char = charsInput[i], charCode = (0, $6528b85dcf3159cf$export$ee42a04f33018f4b)(char);
            if (/(?:\s)/.test(char) && (lastBreakPos = i, lastBreakWidth = lastLineWidth, spaceCount++), char === "\r" || char === `
`) {
                lineWidths.push(lastLineWidth), lineSpaces.push(-1), maxLineWidth = Math.max(maxLineWidth, lastLineWidth), ++line, ++spacesRemoved, pos.x = 0, pos.y += data.lineHeight, prevCharCode = null, spaceCount = 0;
                continue;
            }
            const charData = data.chars[charCode];
            if (!charData) continue;
            prevCharCode && charData.kerning[prevCharCode] && (pos.x += charData.kerning[prevCharCode]);
            const charRenderData = $801d0b128be534a4$var$charRenderDataPool.pop() || {
                texture: (0, $14896914ad3ae15d$export$5431306cf43de24a).EMPTY,
                line: 0,
                charCode: 0,
                prevSpaces: 0,
                position: new (0, $cf3018b4309864c2$export$baf26146a414f24a)()
            };
            charRenderData.texture = charData.texture, charRenderData.line = line, charRenderData.charCode = charCode, charRenderData.position.x = Math.round(pos.x + charData.xOffset + this._letterSpacing / 2), charRenderData.position.y = Math.round(pos.y + charData.yOffset), charRenderData.prevSpaces = spaceCount, chars.push(charRenderData), lastLineWidth = charRenderData.position.x + Math.max(charData.xAdvance - charData.xOffset, charData.texture.orig.width), pos.x += charData.xAdvance + this._letterSpacing, maxLineHeight = Math.max(maxLineHeight, charData.yOffset + charData.texture.height), prevCharCode = charCode, lastBreakPos !== -1 && maxWidth > 0 && pos.x > maxWidth && (++spacesRemoved, (0, $db31fc3dfae4939b$exports).removeItems(chars, 1 + lastBreakPos - spacesRemoved, 1 + i - lastBreakPos), i = lastBreakPos, lastBreakPos = -1, lineWidths.push(lastBreakWidth), lineSpaces.push(chars.length > 0 ? chars[chars.length - 1].prevSpaces : 0), maxLineWidth = Math.max(maxLineWidth, lastBreakWidth), line++, pos.x = 0, pos.y += data.lineHeight, prevCharCode = null, spaceCount = 0);
        }
        const lastChar = charsInput[charsInput.length - 1];
        lastChar !== "\r" && lastChar !== `
` && (/(?:\s)/.test(lastChar) && (lastLineWidth = lastBreakWidth), lineWidths.push(lastLineWidth), maxLineWidth = Math.max(maxLineWidth, lastLineWidth), lineSpaces.push(-1));
        const lineAlignOffsets = [];
        for(let i = 0; i <= line; i++){
            let alignOffset = 0;
            this._align === "right" ? alignOffset = maxLineWidth - lineWidths[i] : this._align === "center" ? alignOffset = (maxLineWidth - lineWidths[i]) / 2 : this._align === "justify" && (alignOffset = lineSpaces[i] < 0 ? 0 : (maxLineWidth - lineWidths[i]) / lineSpaces[i]), lineAlignOffsets.push(alignOffset);
        }
        const lenChars = chars.length, pagesMeshData = {}, newPagesMeshData = [], activePagesMeshData = this._activePagesMeshData;
        pageMeshDataPool.push(...activePagesMeshData);
        for(let i = 0; i < lenChars; i++){
            const texture = chars[i].texture, baseTextureUid = texture.baseTexture.uid;
            if (!pagesMeshData[baseTextureUid]) {
                let pageMeshData = pageMeshDataPool.pop();
                if (!pageMeshData) {
                    const geometry = new (0, $bd4ec874676d5696$export$8d075a36a73d54bc)();
                    let material, meshBlendMode;
                    data.distanceFieldType === "none" ? (material = new (0, $a6a1d7526e98bf89$export$d552dadfd66cc650)((0, $14896914ad3ae15d$export$5431306cf43de24a).EMPTY), meshBlendMode = (0, $0fa4b07f86297abd$export$f821c68fe9beaecf).NORMAL) : (material = new (0, $a6a1d7526e98bf89$export$d552dadfd66cc650)((0, $14896914ad3ae15d$export$5431306cf43de24a).EMPTY, {
                        program: (0, $35ca18cab1598332$export$b6c59b989905b650).from((0, $3a603077fdf7e911$export$2e2bcd8739ae039), (0, $e282e2f8c488a501$export$2e2bcd8739ae039)),
                        uniforms: {
                            uFWidth: 0
                        }
                    }), meshBlendMode = (0, $0fa4b07f86297abd$export$f821c68fe9beaecf).NORMAL_NPM);
                    const mesh = new (0, $d349b6eff78111bd$export$e176487c05830cc5)(geometry, material);
                    mesh.blendMode = meshBlendMode, pageMeshData = {
                        index: 0,
                        indexCount: 0,
                        vertexCount: 0,
                        uvsCount: 0,
                        total: 0,
                        mesh: mesh,
                        vertices: null,
                        uvs: null,
                        indices: null
                    };
                }
                pageMeshData.index = 0, pageMeshData.indexCount = 0, pageMeshData.vertexCount = 0, pageMeshData.uvsCount = 0, pageMeshData.total = 0;
                const { _textureCache: _textureCache } = this;
                _textureCache[baseTextureUid] = _textureCache[baseTextureUid] || new (0, $14896914ad3ae15d$export$5431306cf43de24a)(texture.baseTexture), pageMeshData.mesh.texture = _textureCache[baseTextureUid], pageMeshData.mesh.tint = this._tintColor.value, newPagesMeshData.push(pageMeshData), pagesMeshData[baseTextureUid] = pageMeshData;
            }
            pagesMeshData[baseTextureUid].total++;
        }
        for(let i = 0; i < activePagesMeshData.length; i++)newPagesMeshData.includes(activePagesMeshData[i]) || this.removeChild(activePagesMeshData[i].mesh);
        for(let i = 0; i < newPagesMeshData.length; i++)newPagesMeshData[i].mesh.parent !== this && this.addChild(newPagesMeshData[i].mesh);
        this._activePagesMeshData = newPagesMeshData;
        for(const i in pagesMeshData){
            const pageMeshData = pagesMeshData[i], total = pageMeshData.total;
            if (!(pageMeshData.indices?.length > 6 * total) || pageMeshData.vertices.length < (0, $d349b6eff78111bd$export$e176487c05830cc5).BATCHABLE_SIZE * 2) pageMeshData.vertices = new Float32Array(8 * total), pageMeshData.uvs = new Float32Array(8 * total), pageMeshData.indices = new Uint16Array(6 * total);
            else {
                const total2 = pageMeshData.total, vertices = pageMeshData.vertices;
                for(let i2 = total2 * 8; i2 < vertices.length; i2++)vertices[i2] = 0;
            }
            pageMeshData.mesh.size = 6 * total;
        }
        for(let i = 0; i < lenChars; i++){
            const char = chars[i];
            let offset = char.position.x + lineAlignOffsets[char.line] * (this._align === "justify" ? char.prevSpaces : 1);
            this._roundPixels && (offset = Math.round(offset));
            const xPos = offset * scale, yPos = char.position.y * scale, texture = char.texture, pageMesh = pagesMeshData[texture.baseTexture.uid], textureFrame = texture.frame, textureUvs = texture._uvs, index = pageMesh.index++;
            pageMesh.indices[index * 6 + 0] = 0 + index * 4, pageMesh.indices[index * 6 + 1] = 1 + index * 4, pageMesh.indices[index * 6 + 2] = 2 + index * 4, pageMesh.indices[index * 6 + 3] = 0 + index * 4, pageMesh.indices[index * 6 + 4] = 2 + index * 4, pageMesh.indices[index * 6 + 5] = 3 + index * 4, pageMesh.vertices[index * 8 + 0] = xPos, pageMesh.vertices[index * 8 + 1] = yPos, pageMesh.vertices[index * 8 + 2] = xPos + textureFrame.width * scale, pageMesh.vertices[index * 8 + 3] = yPos, pageMesh.vertices[index * 8 + 4] = xPos + textureFrame.width * scale, pageMesh.vertices[index * 8 + 5] = yPos + textureFrame.height * scale, pageMesh.vertices[index * 8 + 6] = xPos, pageMesh.vertices[index * 8 + 7] = yPos + textureFrame.height * scale, pageMesh.uvs[index * 8 + 0] = textureUvs.x0, pageMesh.uvs[index * 8 + 1] = textureUvs.y0, pageMesh.uvs[index * 8 + 2] = textureUvs.x1, pageMesh.uvs[index * 8 + 3] = textureUvs.y1, pageMesh.uvs[index * 8 + 4] = textureUvs.x2, pageMesh.uvs[index * 8 + 5] = textureUvs.y2, pageMesh.uvs[index * 8 + 6] = textureUvs.x3, pageMesh.uvs[index * 8 + 7] = textureUvs.y3;
        }
        this._textWidth = maxLineWidth * scale, this._textHeight = (pos.y + data.lineHeight) * scale;
        for(const i in pagesMeshData){
            const pageMeshData = pagesMeshData[i];
            if (this.anchor.x !== 0 || this.anchor.y !== 0) {
                let vertexCount = 0;
                const anchorOffsetX = this._textWidth * this.anchor.x, anchorOffsetY = this._textHeight * this.anchor.y;
                for(let i2 = 0; i2 < pageMeshData.total; i2++)pageMeshData.vertices[vertexCount++] -= anchorOffsetX, pageMeshData.vertices[vertexCount++] -= anchorOffsetY, pageMeshData.vertices[vertexCount++] -= anchorOffsetX, pageMeshData.vertices[vertexCount++] -= anchorOffsetY, pageMeshData.vertices[vertexCount++] -= anchorOffsetX, pageMeshData.vertices[vertexCount++] -= anchorOffsetY, pageMeshData.vertices[vertexCount++] -= anchorOffsetX, pageMeshData.vertices[vertexCount++] -= anchorOffsetY;
            }
            this._maxLineHeight = maxLineHeight * scale;
            const vertexBuffer = pageMeshData.mesh.geometry.getBuffer("aVertexPosition"), textureBuffer = pageMeshData.mesh.geometry.getBuffer("aTextureCoord"), indexBuffer = pageMeshData.mesh.geometry.getIndex();
            vertexBuffer.data = pageMeshData.vertices, textureBuffer.data = pageMeshData.uvs, indexBuffer.data = pageMeshData.indices, vertexBuffer.update(), textureBuffer.update(), indexBuffer.update();
        }
        for(let i = 0; i < chars.length; i++)$801d0b128be534a4$var$charRenderDataPool.push(chars[i]);
        this._font = data, this.dirty = !1;
    }
    updateTransform() {
        this.validate(), this.containerUpdateTransform();
    }
    _render(renderer) {
        this._autoResolution && this._resolution !== renderer.resolution && (this._resolution = renderer.resolution, this.dirty = !0);
        const { distanceFieldRange: distanceFieldRange, distanceFieldType: distanceFieldType, size: size } = (0, $f9598d071f8144d5$export$17957a09927cadc7).available[this._fontName];
        if (distanceFieldType !== "none") {
            const { a: a, b: b, c: c, d: d } = this.worldTransform, dx = Math.sqrt(a * a + b * b), dy = Math.sqrt(c * c + d * d), worldScale = (Math.abs(dx) + Math.abs(dy)) / 2, fontScale = this.fontSize / size, resolution = renderer._view.resolution;
            for (const mesh of this._activePagesMeshData)mesh.mesh.shader.uniforms.uFWidth = worldScale * distanceFieldRange * fontScale * resolution;
        }
        super._render(renderer);
    }
    /**
   * Validates text before calling parent's getLocalBounds
   * @returns - The rectangular bounding area
   */ getLocalBounds() {
        return this.validate(), super.getLocalBounds();
    }
    /**
   * Updates text when needed
   * @private
   */ validate() {
        const font = (0, $f9598d071f8144d5$export$17957a09927cadc7).available[this._fontName];
        if (!font) throw new Error(`Missing BitmapFont "${this._fontName}"`);
        this._font !== font && (this.dirty = !0), this.dirty && this.updateText();
    }
    /**
   * The tint of the BitmapText object.
   * @default 0xffffff
   */ get tint() {
        return this._tintColor.value;
    }
    set tint(value) {
        if (this.tint !== value) {
            this._tintColor.setValue(value);
            for(let i = 0; i < this._activePagesMeshData.length; i++)this._activePagesMeshData[i].mesh.tint = value;
        }
    }
    /**
   * The alignment of the BitmapText object.
   * @member {string}
   * @default 'left'
   */ get align() {
        return this._align;
    }
    set align(value) {
        this._align !== value && (this._align = value, this.dirty = !0);
    }
    /** The name of the BitmapFont. */ get fontName() {
        return this._fontName;
    }
    set fontName(value) {
        if (!(0, $f9598d071f8144d5$export$17957a09927cadc7).available[value]) throw new Error(`Missing BitmapFont "${value}"`);
        this._fontName !== value && (this._fontName = value, this.dirty = !0);
    }
    /** The size of the font to display. */ get fontSize() {
        return this._fontSize ?? (0, $f9598d071f8144d5$export$17957a09927cadc7).available[this._fontName].size;
    }
    set fontSize(value) {
        this._fontSize !== value && (this._fontSize = value, this.dirty = !0);
    }
    /**
   * The anchor sets the origin point of the text.
   *
   * The default is `(0,0)`, this means the text's origin is the top left.
   *
   * Setting the anchor to `(0.5,0.5)` means the text's origin is centered.
   *
   * Setting the anchor to `(1,1)` would mean the text's origin point will be the bottom right corner.
   */ get anchor() {
        return this._anchor;
    }
    set anchor(value) {
        typeof value == "number" ? this._anchor.set(value) : this._anchor.copyFrom(value);
    }
    /** The text of the BitmapText object. */ get text() {
        return this._text;
    }
    set text(text) {
        text = String(text ?? ""), this._text !== text && (this._text = text, this.dirty = !0);
    }
    /**
   * The max width of this bitmap text in pixels. If the text provided is longer than the
   * value provided, line breaks will be automatically inserted in the last whitespace.
   * Disable by setting the value to 0.
   */ get maxWidth() {
        return this._maxWidth;
    }
    set maxWidth(value) {
        this._maxWidth !== value && (this._maxWidth = value, this.dirty = !0);
    }
    /**
   * The max line height. This is useful when trying to use the total height of the Text,
   * i.e. when trying to vertically align.
   * @readonly
   */ get maxLineHeight() {
        return this.validate(), this._maxLineHeight;
    }
    /**
   * The width of the overall text, different from fontSize,
   * which is defined in the style object.
   * @readonly
   */ get textWidth() {
        return this.validate(), this._textWidth;
    }
    /** Additional space between characters. */ get letterSpacing() {
        return this._letterSpacing;
    }
    set letterSpacing(value) {
        this._letterSpacing !== value && (this._letterSpacing = value, this.dirty = !0);
    }
    /**
   * If true PixiJS will Math.floor() x/y values when rendering, stopping pixel interpolation.
   * Advantages can include sharper image quality (like text) and faster rendering on canvas.
   * The main disadvantage is movement of objects may appear less smooth.
   * To set the global default, change {@link PIXI.settings.ROUND_PIXELS}
   * @default PIXI.settings.ROUND_PIXELS
   */ get roundPixels() {
        return this._roundPixels;
    }
    set roundPixels(value) {
        value !== this._roundPixels && (this._roundPixels = value, this.dirty = !0);
    }
    /**
   * The height of the overall text, different from fontSize,
   * which is defined in the style object.
   * @readonly
   */ get textHeight() {
        return this.validate(), this._textHeight;
    }
    /**
   * The resolution / device pixel ratio of the canvas.
   *
   * This is set to automatically match the renderer resolution by default, but can be overridden by setting manually.
   * @default 1
   */ get resolution() {
        return this._resolution;
    }
    set resolution(value) {
        this._autoResolution = !1, this._resolution !== value && (this._resolution = value, this.dirty = !0);
    }
    destroy(options) {
        const { _textureCache: _textureCache } = this, pageMeshDataPool = (0, $f9598d071f8144d5$export$17957a09927cadc7).available[this._fontName].distanceFieldType === "none" ? $801d0b128be534a4$var$pageMeshDataDefaultPageMeshData : $801d0b128be534a4$var$pageMeshDataMSDFPageMeshData;
        pageMeshDataPool.push(...this._activePagesMeshData);
        for (const pageMeshData of this._activePagesMeshData)this.removeChild(pageMeshData.mesh);
        this._activePagesMeshData = [], pageMeshDataPool.filter((page)=>_textureCache[page.mesh.texture.baseTexture.uid]).forEach((page)=>{
            page.mesh.texture = (0, $14896914ad3ae15d$export$5431306cf43de24a).EMPTY;
        });
        for(const id in _textureCache)_textureCache[id].destroy(), delete _textureCache[id];
        this._font = null, this._tintColor = null, this._textureCache = null, super.destroy(options);
    }
};
$801d0b128be534a4$var$_BitmapText.styleDefaults = {
    align: "left",
    tint: 16777215,
    maxWidth: 0,
    letterSpacing: 0
};
let $801d0b128be534a4$export$ae0da96467efdba0 = $801d0b128be534a4$var$_BitmapText;











const $75f5ddf00ebc0061$var$validExtensions = [
    ".xml",
    ".fnt"
], $75f5ddf00ebc0061$export$402edee29ac8bed4 = {
    extension: {
        type: (0, $c90155f6d7d8d8f6$export$4f037c6ec2da4eeb).LoadParser,
        priority: (0, $ed5d6a4467c2b40c$export$820ed6348c4f2750).Normal
    },
    name: "loadBitmapFont",
    test (url) {
        return $75f5ddf00ebc0061$var$validExtensions.includes((0, $db31fc3dfae4939b$exports).path.extname(url).toLowerCase());
    },
    async testParse (data) {
        return (0, $16e192692c700f9c$export$ff5bf922eba68a09).test(data) || (0, $06a116739660aa3e$export$9322acbf234f5703).test(data);
    },
    async parse (asset, data, loader) {
        const fontData = (0, $16e192692c700f9c$export$ff5bf922eba68a09).test(asset) ? (0, $16e192692c700f9c$export$ff5bf922eba68a09).parse(asset) : (0, $06a116739660aa3e$export$9322acbf234f5703).parse(asset), { src: src } = data, { page: pages } = fontData, textureUrls = [];
        for(let i = 0; i < pages.length; ++i){
            const pageFile = pages[i].file;
            let imagePath = (0, $db31fc3dfae4939b$exports).path.join((0, $db31fc3dfae4939b$exports).path.dirname(src), pageFile);
            imagePath = (0, $a06717d44d10be9c$export$f57b97ef8be10dda)(imagePath, src), textureUrls.push(imagePath);
        }
        const loadedTextures = await loader.load(textureUrls), textures = textureUrls.map((url)=>loadedTextures[url]);
        return (0, $f9598d071f8144d5$export$17957a09927cadc7).install(fontData, textures, !0);
    },
    async load (url, _options) {
        return (await (0, $2808efac47e52be0$export$a5a6e0b888b2c992).ADAPTER.fetch(url)).text();
    },
    unload (bitmapFont) {
        bitmapFont.destroy();
    }
};
(0, $c90155f6d7d8d8f6$export$cc3e2d3244e01b7f).add($75f5ddf00ebc0061$export$402edee29ac8bed4);












const $b4dbb5e76ff5db99$var$_HTMLTextStyle = class _HTMLTextStyle2 extends (0, $3d453260a3c8e0f7$export$1df879243bf2e42d) {
    constructor(){
        super(...arguments), this._fonts = [], this._overrides = [], this._stylesheet = "", this.fontsDirty = !1;
    }
    /**
   * Convert a TextStyle to HTMLTextStyle
   * @param originalStyle
   * @example
   * import {TextStyle } from 'pixi.js';
   * import {HTMLTextStyle} from '@pixi/text-html';
   * const style = new TextStyle();
   * const htmlStyle = HTMLTextStyle.from(style);
   */ static from(originalStyle) {
        return new _HTMLTextStyle2(Object.keys(_HTMLTextStyle2.defaultOptions).reduce((obj, prop)=>({
                ...obj,
                [prop]: originalStyle[prop]
            }), {}));
    }
    /** Clear the current font */ cleanFonts() {
        this._fonts.length > 0 && (this._fonts.forEach((font)=>{
            URL.revokeObjectURL(font.src), font.refs--, font.refs === 0 && (font.fontFace && document.fonts.delete(font.fontFace), delete _HTMLTextStyle2.availableFonts[font.originalUrl]);
        }), this.fontFamily = "Arial", this._fonts.length = 0, this.styleID++, this.fontsDirty = !0);
    }
    /**
   * Because of how HTMLText renders, fonts need to be imported
   * @param url
   * @param options
   */ loadFont(url, options = {}) {
        const { availableFonts: availableFonts } = _HTMLTextStyle2;
        if (availableFonts[url]) {
            const font = availableFonts[url];
            return this._fonts.push(font), font.refs++, this.styleID++, this.fontsDirty = !0, Promise.resolve();
        }
        return (0, $2808efac47e52be0$export$a5a6e0b888b2c992).ADAPTER.fetch(url).then((response)=>response.blob()).then(async (blob)=>new Promise((resolve, reject)=>{
                const src = URL.createObjectURL(blob), reader = new FileReader();
                reader.onload = ()=>resolve([
                        src,
                        reader.result
                    ]), reader.onerror = reject, reader.readAsDataURL(blob);
            })).then(async ([src, dataSrc])=>{
            const font = Object.assign({
                family: (0, $db31fc3dfae4939b$exports).path.basename(url, (0, $db31fc3dfae4939b$exports).path.extname(url)),
                weight: "normal",
                style: "normal",
                display: "auto",
                src: src,
                dataSrc: dataSrc,
                refs: 1,
                originalUrl: url,
                fontFace: null
            }, options);
            availableFonts[url] = font, this._fonts.push(font), this.styleID++;
            const fontFace = new FontFace(font.family, `url(${font.src})`, {
                weight: font.weight,
                style: font.style,
                display: font.display
            });
            font.fontFace = fontFace, await fontFace.load(), document.fonts.add(fontFace), await document.fonts.ready, this.styleID++, this.fontsDirty = !0;
        });
    }
    /**
   * Add a style override, this can be any CSS property
   * it will override any built-in style. This is the
   * property and the value as a string (e.g., `color: red`).
   * This will override any other internal style.
   * @param {string} value - CSS style(s) to add.
   * @example
   * style.addOverride('background-color: red');
   */ addOverride(...value) {
        const toAdd = value.filter((v)=>!this._overrides.includes(v));
        toAdd.length > 0 && (this._overrides.push(...toAdd), this.styleID++);
    }
    /**
   * Remove any overrides that match the value.
   * @param {string} value - CSS style to remove.
   * @example
   * style.removeOverride('background-color: red');
   */ removeOverride(...value) {
        const toRemove = value.filter((v)=>this._overrides.includes(v));
        toRemove.length > 0 && (this._overrides = this._overrides.filter((v)=>!toRemove.includes(v)), this.styleID++);
    }
    /**
   * Internally converts all of the style properties into CSS equivalents.
   * @param scale
   * @returns The CSS style string, for setting `style` property of root HTMLElement.
   */ toCSS(scale) {
        return [
            `transform: scale(${scale})`,
            "transform-origin: top left",
            "display: inline-block",
            `color: ${this.normalizeColor(this.fill)}`,
            `font-size: ${this.fontSize}px`,
            `font-family: ${this.fontFamily}`,
            `font-weight: ${this.fontWeight}`,
            `font-style: ${this.fontStyle}`,
            `font-variant: ${this.fontVariant}`,
            `letter-spacing: ${this.letterSpacing}px`,
            `text-align: ${this.align}`,
            `padding: ${this.padding}px`,
            `white-space: ${this.whiteSpace}`,
            ...this.lineHeight ? [
                `line-height: ${this.lineHeight}px`
            ] : [],
            ...this.wordWrap ? [
                `word-wrap: ${this.breakWords ? "break-all" : "break-word"}`,
                `max-width: ${this.wordWrapWidth}px`
            ] : [],
            ...this.strokeThickness ? [
                `-webkit-text-stroke-width: ${this.strokeThickness}px`,
                `-webkit-text-stroke-color: ${this.normalizeColor(this.stroke)}`,
                `text-stroke-width: ${this.strokeThickness}px`,
                `text-stroke-color: ${this.normalizeColor(this.stroke)}`,
                "paint-order: stroke"
            ] : [],
            ...this.dropShadow ? [
                this.dropShadowToCSS()
            ] : [],
            ...this._overrides
        ].join(";");
    }
    /** Get the font CSS styles from the loaded font, If available. */ toGlobalCSS() {
        return this._fonts.reduce((result, font)=>`${result}
            @font-face {
                font-family: "${font.family}";
                src: url('${font.dataSrc}');
                font-weight: ${font.weight};
                font-style: ${font.style};
                font-display: ${font.display};
            }`, this._stylesheet);
    }
    /** Internal stylesheet contents, useful for creating rules for rendering */ get stylesheet() {
        return this._stylesheet;
    }
    set stylesheet(value) {
        this._stylesheet !== value && (this._stylesheet = value, this.styleID++);
    }
    /**
   * Convert numerical colors into hex-strings
   * @param color
   */ normalizeColor(color) {
        return Array.isArray(color) && (color = (0, $db31fc3dfae4939b$exports).rgb2hex(color)), typeof color == "number" ? (0, $db31fc3dfae4939b$exports).hex2string(color) : color;
    }
    /** Convert the internal drop-shadow settings to CSS text-shadow */ dropShadowToCSS() {
        let color = this.normalizeColor(this.dropShadowColor);
        const alpha = this.dropShadowAlpha, x = Math.round(Math.cos(this.dropShadowAngle) * this.dropShadowDistance), y = Math.round(Math.sin(this.dropShadowAngle) * this.dropShadowDistance);
        color.startsWith("#") && alpha < 1 && (color += (alpha * 255 | 0).toString(16).padStart(2, "0"));
        const position = `${x}px ${y}px`;
        return this.dropShadowBlur > 0 ? `text-shadow: ${position} ${this.dropShadowBlur}px ${color}` : `text-shadow: ${position} ${color}`;
    }
    /** Resets all properties to the defaults specified in TextStyle.prototype._default */ reset() {
        Object.assign(this, _HTMLTextStyle2.defaultOptions);
    }
    /**
   * Called after the image is loaded but before drawing to the canvas.
   * Mostly used to handle Safari's font loading bug.
   * @ignore
   */ onBeforeDraw() {
        const { fontsDirty: prevFontsDirty } = this;
        return this.fontsDirty = !1, this.isSafari && this._fonts.length > 0 && prevFontsDirty ? new Promise((resolve)=>setTimeout(resolve, 100)) : Promise.resolve();
    }
    /**
   * Proving that Safari is the new IE
   * @ignore
   */ get isSafari() {
        const { userAgent: userAgent } = (0, $2808efac47e52be0$export$a5a6e0b888b2c992).ADAPTER.getNavigator();
        return /^((?!chrome|android).)*safari/i.test(userAgent);
    }
    set fillGradientStops(_value) {
        console.warn("[HTMLTextStyle] fillGradientStops is not supported by HTMLText");
    }
    get fillGradientStops() {
        return super.fillGradientStops;
    }
    set fillGradientType(_value) {
        console.warn("[HTMLTextStyle] fillGradientType is not supported by HTMLText");
    }
    get fillGradientType() {
        return super.fillGradientType;
    }
    set miterLimit(_value) {
        console.warn("[HTMLTextStyle] miterLimit is not supported by HTMLText");
    }
    get miterLimit() {
        return super.miterLimit;
    }
    set trim(_value) {
        console.warn("[HTMLTextStyle] trim is not supported by HTMLText");
    }
    get trim() {
        return super.trim;
    }
    set textBaseline(_value) {
        console.warn("[HTMLTextStyle] textBaseline is not supported by HTMLText");
    }
    get textBaseline() {
        return super.textBaseline;
    }
    set leading(_value) {
        console.warn("[HTMLTextStyle] leading is not supported by HTMLText");
    }
    get leading() {
        return super.leading;
    }
    set lineJoin(_value) {
        console.warn("[HTMLTextStyle] lineJoin is not supported by HTMLText");
    }
    get lineJoin() {
        return super.lineJoin;
    }
};
$b4dbb5e76ff5db99$var$_HTMLTextStyle.availableFonts = {}, /**
* List of default options, these are largely the same as TextStyle,
* with the exception of whiteSpace, which is set to 'normal' by default.
*/ $b4dbb5e76ff5db99$var$_HTMLTextStyle.defaultOptions = {
    /** Align */ align: "left",
    /** Break words */ breakWords: !1,
    /** Drop shadow */ dropShadow: !1,
    /** Drop shadow alpha */ dropShadowAlpha: 1,
    /**
   * Drop shadow angle
   * @type {number}
   * @default Math.PI / 6
   */ dropShadowAngle: Math.PI / 6,
    /** Drop shadow blur */ dropShadowBlur: 0,
    /** Drop shadow color */ dropShadowColor: "black",
    /** Drop shadow distance */ dropShadowDistance: 5,
    /** Fill */ fill: "black",
    /** Font family */ fontFamily: "Arial",
    /** Font size */ fontSize: 26,
    /** Font style */ fontStyle: "normal",
    /** Font variant */ fontVariant: "normal",
    /** Font weight */ fontWeight: "normal",
    /** Letter spacing */ letterSpacing: 0,
    /** Line height */ lineHeight: 0,
    /** Padding */ padding: 0,
    /** Stroke */ stroke: "black",
    /** Stroke thickness */ strokeThickness: 0,
    /** White space */ whiteSpace: "normal",
    /** Word wrap */ wordWrap: !1,
    /** Word wrap width */ wordWrapWidth: 100
};
let $b4dbb5e76ff5db99$export$a2664b42ece43c6c = $b4dbb5e76ff5db99$var$_HTMLTextStyle;


const $258b817458577350$var$_HTMLText = class _HTMLText2 extends (0, $e4c5b2569bd3a8d2$export$3075603db8e6204c) {
    /**
   * @param {string} [text] - Text contents
   * @param {PIXI.HTMLTextStyle|PIXI.TextStyle|PIXI.ITextStyle} [style] - Style setting to use.
   *        Strongly recommend using an HTMLTextStyle object. Providing a PIXI.TextStyle
   *        will convert the TextStyle to an HTMLTextStyle and will no longer be linked.
   */ constructor(text = "", style = {}){
        super((0, $14896914ad3ae15d$export$5431306cf43de24a).EMPTY), this._text = null, this._style = null, this._autoResolution = !0, this.localStyleID = -1, this.dirty = !1, this._updateID = 0, this.ownsStyle = !1;
        const image = new Image(), texture = (0, $14896914ad3ae15d$export$5431306cf43de24a).from(image, {
            scaleMode: (0, $2808efac47e52be0$export$a5a6e0b888b2c992).SCALE_MODE,
            resourceOptions: {
                autoLoad: !1
            }
        });
        texture.orig = new (0, $200f778d7fdbf8ac$export$4617fb02663045ef)(), texture.trim = new (0, $200f778d7fdbf8ac$export$4617fb02663045ef)(), this.texture = texture;
        const nssvg = "http://www.w3.org/2000/svg", nsxhtml = "http://www.w3.org/1999/xhtml", svgRoot = document.createElementNS(nssvg, "svg"), foreignObject = document.createElementNS(nssvg, "foreignObject"), domElement = document.createElementNS(nsxhtml, "div"), styleElement = document.createElementNS(nsxhtml, "style");
        foreignObject.setAttribute("width", "10000"), foreignObject.setAttribute("height", "10000"), foreignObject.style.overflow = "hidden", svgRoot.appendChild(foreignObject), this.maxWidth = _HTMLText2.defaultMaxWidth, this.maxHeight = _HTMLText2.defaultMaxHeight, this._domElement = domElement, this._styleElement = styleElement, this._svgRoot = svgRoot, this._foreignObject = foreignObject, this._foreignObject.appendChild(styleElement), this._foreignObject.appendChild(domElement), this._image = image, this._loadImage = new Image(), this._autoResolution = _HTMLText2.defaultAutoResolution, this._resolution = _HTMLText2.defaultResolution ?? (0, $2808efac47e52be0$export$a5a6e0b888b2c992).RESOLUTION, this.text = text, this.style = style;
    }
    /**
   * Calculate the size of the output text without actually drawing it.
   * This includes the `padding` in the `style` object.
   * This can be used as a fast-pass to do things like text-fitting.
   * @param {object} [overrides] - Overrides for the text, style, and resolution.
   * @param {string} [overrides.text] - The text to measure, if not specified, the current text is used.
   * @param {PIXI.HTMLTextStyle} [overrides.style] - The style to measure, if not specified, the current style is used.
   * @param {number} [overrides.resolution] - The resolution to measure, if not specified, the current resolution is used.
   * @returns {PIXI.ISize} Width and height of the measured text.
   */ measureText(overrides) {
        const { text: text, style: style, resolution: resolution } = Object.assign({
            text: this._text,
            style: this._style,
            resolution: this._resolution
        }, overrides);
        Object.assign(this._domElement, {
            innerHTML: text,
            style: style.toCSS(resolution)
        }), this._styleElement.textContent = style.toGlobalCSS(), document.body.appendChild(this._svgRoot);
        const contentBounds = this._domElement.getBoundingClientRect();
        this._svgRoot.remove();
        const { width: width, height: height } = contentBounds;
        (width > this.maxWidth || height > this.maxHeight) && console.warn("[HTMLText] Large expanse of text, increase HTMLText.maxWidth or HTMLText.maxHeight property.");
        const contentWidth = Math.min(this.maxWidth, Math.ceil(width)), contentHeight = Math.min(this.maxHeight, Math.ceil(height));
        return this._svgRoot.setAttribute("width", contentWidth.toString()), this._svgRoot.setAttribute("height", contentHeight.toString()), text !== this._text && (this._domElement.innerHTML = this._text), style !== this._style && (Object.assign(this._domElement, {
            style: this._style?.toCSS(resolution)
        }), this._styleElement.textContent = this._style?.toGlobalCSS()), {
            width: contentWidth + style.padding * 2,
            height: contentHeight + style.padding * 2
        };
    }
    /**
   * Manually refresh the text.
   * @public
   * @param {boolean} respectDirty - Whether to abort updating the
   *        text if the Text isn't dirty and the function is called.
   */ async updateText(respectDirty = !0) {
        const { style: style, _image: image, _loadImage: loadImage } = this;
        if (this.localStyleID !== style.styleID && (this.dirty = !0, this.localStyleID = style.styleID), !this.dirty && respectDirty) return;
        const { width: width, height: height } = this.measureText();
        image.width = loadImage.width = Math.ceil(Math.max(1, width)), image.height = loadImage.height = Math.ceil(Math.max(1, height)), this._updateID++;
        const updateID = this._updateID;
        await new Promise((resolve)=>{
            loadImage.onload = async ()=>{
                if (updateID < this._updateID) {
                    resolve();
                    return;
                }
                await style.onBeforeDraw(), image.src = loadImage.src, loadImage.onload = null, loadImage.src = "", this.updateTexture(), resolve();
            };
            const svgURL = new XMLSerializer().serializeToString(this._svgRoot);
            loadImage.src = `data:image/svg+xml;charset=utf8,${encodeURIComponent(svgURL)}`;
        });
    }
    /** The raw image element that is rendered under-the-hood. */ get source() {
        return this._image;
    }
    /**
   * Update the texture resource.
   * @private
   */ updateTexture() {
        const { style: style, texture: texture, _image: image, resolution: resolution } = this, { padding: padding } = style, { baseTexture: baseTexture } = texture;
        texture.trim.width = texture._frame.width = image.width / resolution, texture.trim.height = texture._frame.height = image.height / resolution, texture.trim.x = -padding, texture.trim.y = -padding, texture.orig.width = texture._frame.width - padding * 2, texture.orig.height = texture._frame.height - padding * 2, this._onTextureUpdate(), baseTexture.setRealSize(image.width, image.height, resolution), this.dirty = !1;
    }
    /**
   * Renders the object using the WebGL renderer
   * @param {PIXI.Renderer} renderer - The renderer
   * @private
   */ _render(renderer) {
        this._autoResolution && this._resolution !== renderer.resolution && (this._resolution = renderer.resolution, this.dirty = !0), this.updateText(!0), super._render(renderer);
    }
    /**
   * Renders the object using the Canvas Renderer.
   * @private
   * @param {PIXI.CanvasRenderer} renderer - The renderer
   */ _renderCanvas(renderer) {
        this._autoResolution && this._resolution !== renderer.resolution && (this._resolution = renderer.resolution, this.dirty = !0), this.updateText(!0), super._renderCanvas(renderer);
    }
    /**
   * Get the local bounds.
   * @param {PIXI.Rectangle} rect - Input rectangle.
   * @returns {PIXI.Rectangle} Local bounds
   */ getLocalBounds(rect) {
        return this.updateText(!0), super.getLocalBounds(rect);
    }
    _calculateBounds() {
        this.updateText(!0), this.calculateVertices(), this._bounds.addQuad(this.vertexData);
    }
    /**
   * Handle dirty style changes
   * @private
   */ _onStyleChange() {
        this.dirty = !0;
    }
    /**
   * Destroy this Text object. Don't use after calling.
   * @param {boolean|object} options - Same as Sprite destroy options.
   */ destroy(options) {
        typeof options == "boolean" && (options = {
            children: options
        }), options = Object.assign({}, _HTMLText2.defaultDestroyOptions, options), super.destroy(options);
        const forceClear = null;
        this.ownsStyle && this._style?.cleanFonts(), this._style = forceClear, this._svgRoot?.remove(), this._svgRoot = forceClear, this._domElement?.remove(), this._domElement = forceClear, this._foreignObject?.remove(), this._foreignObject = forceClear, this._styleElement?.remove(), this._styleElement = forceClear, this._loadImage.src = "", this._loadImage.onload = null, this._loadImage = forceClear, this._image.src = "", this._image = forceClear;
    }
    /**
   * Get the width in pixels.
   * @member {number}
   */ get width() {
        return this.updateText(!0), Math.abs(this.scale.x) * this._image.width / this.resolution;
    }
    set width(value) {
        this.updateText(!0);
        const s = (0, $db31fc3dfae4939b$exports).sign(this.scale.x) || 1;
        this.scale.x = s * value / this._image.width / this.resolution, this._width = value;
    }
    /**
   * Get the height in pixels.
   * @member {number}
   */ get height() {
        return this.updateText(!0), Math.abs(this.scale.y) * this._image.height / this.resolution;
    }
    set height(value) {
        this.updateText(!0);
        const s = (0, $db31fc3dfae4939b$exports).sign(this.scale.y) || 1;
        this.scale.y = s * value / this._image.height / this.resolution, this._height = value;
    }
    /** The base style to render with text. */ get style() {
        return this._style;
    }
    set style(style) {
        this._style !== style && (style = style || {}, style instanceof (0, $b4dbb5e76ff5db99$export$a2664b42ece43c6c) ? (this.ownsStyle = !1, this._style = style) : style instanceof (0, $3d453260a3c8e0f7$export$1df879243bf2e42d) ? (console.warn("[HTMLText] Cloning TextStyle, if this is not what you want, use HTMLTextStyle"), this.ownsStyle = !0, this._style = (0, $b4dbb5e76ff5db99$export$a2664b42ece43c6c).from(style)) : (this.ownsStyle = !0, this._style = new (0, $b4dbb5e76ff5db99$export$a2664b42ece43c6c)(style)), this.localStyleID = -1, this.dirty = !0);
    }
    /**
   * Contents of text. This can be HTML text and include tags.
   * @example
   * const text = new HTMLText('This is a <em>styled</em> text!');
   * @member {string}
   */ get text() {
        return this._text;
    }
    set text(text) {
        text = String(text === "" || text === null || text === void 0 ? " " : text), text = this.sanitiseText(text), this._text !== text && (this._text = text, this.dirty = !0);
    }
    /**
   * The resolution / device pixel ratio of the canvas.
   * This is set to automatically match the renderer resolution by default, but can be overridden by setting manually.
   * @member {number}
   * @default 1
   */ get resolution() {
        return this._resolution;
    }
    set resolution(value) {
        this._autoResolution = !1, this._resolution !== value && (this._resolution = value, this.dirty = !0);
    }
    /**
   * Sanitise text - replace `<br>` with `<br/>`, `&nbsp;` with `&#160;`
   * @param text
   * @see https://www.sitepoint.com/community/t/xhtml-1-0-transitional-xml-parsing-error-entity-nbsp-not-defined/3392/3
   */ sanitiseText(text) {
        return text.replace(/<br>/gi, "<br/>").replace(/<hr>/gi, "<hr/>").replace(/&nbsp;/gi, "&#160;");
    }
};
$258b817458577350$var$_HTMLText.defaultDestroyOptions = {
    texture: !0,
    children: !1,
    baseTexture: !0
}, /** Default maxWidth, set at construction */ $258b817458577350$var$_HTMLText.defaultMaxWidth = 2024, /** Default maxHeight, set at construction */ $258b817458577350$var$_HTMLText.defaultMaxHeight = 2024, /** Default autoResolution for all HTMLText objects */ $258b817458577350$var$_HTMLText.defaultAutoResolution = !0;
let $258b817458577350$export$4b42bbc5a42896a1 = $258b817458577350$var$_HTMLText;











var $hKNIR = parcelRequire("hKNIR");

var $49736469f58fc92b$export$d2385d4b1e3b9d1a;
(function(Monster) {
    Monster["Bat"] = "bat";
    Monster["FlyingDeer"] = "flying_deer";
    Monster["Ghost"] = "ghost";
    Monster["Ogre"] = "ogre";
    Monster["Rainbow"] = "rainbow";
    Monster["Spider"] = "spider";
    // new
    Monster["Blue1"] = "blue_monster_1";
    Monster["Blue2"] = "blue_monster_2";
    Monster["Blue3"] = "blue_monster_3";
    Monster["Pink1"] = "pink_monster_1";
    Monster["Pink2"] = "pink_monster_2";
    Monster["Pink3"] = "pink_monster_3";
    Monster["Red1"] = "red_monster_1";
    Monster["Red2"] = "red_monster_2";
    Monster["Crier"] = "crier";
    Monster["Klaus"] = "klaus";
    // Bosses
    Monster["Boss1"] = "boss_1";
    Monster["Boss2"] = "boss_2";
    Monster["Yeti"] = "yeti";
})($49736469f58fc92b$export$d2385d4b1e3b9d1a || ($49736469f58fc92b$export$d2385d4b1e3b9d1a = {}));
var $49736469f58fc92b$export$f90411c24f6aebf8;
(function(Bullet) {
    Bullet["Yellow"] = "yellow";
    Bullet["Blue"] = "blue";
    Bullet["Red"] = "red";
    Bullet["Pink"] = "pink";
    Bullet["Slime"] = "slime";
    Bullet["Card"] = "card";
    Bullet["Rocket"] = "rocket";
    Bullet["Boss1"] = "boss_1";
    Bullet["Boss2"] = "boss_2";
    Bullet["Yeti"] = "yeti";
    Bullet["XSMAS"] = "xmas";
    Bullet["Carrot"] = "carrot";
    Bullet["Flame"] = "flame";
    Bullet["Riffle"] = "riffle";
})($49736469f58fc92b$export$f90411c24f6aebf8 || ($49736469f58fc92b$export$f90411c24f6aebf8 = {}));
var $49736469f58fc92b$export$a0b1da4b3d9a7c29;
(function(Weapon) {
    Weapon["CommonBlaster"] = "COMMON_BLASTER";
    Weapon["EpicBlaster"] = "EPIC_BLASTER";
    Weapon["FabledBlaster"] = "FABLED_BLASTER";
    Weapon["Shotgun"] = "SHOTGUN";
    Weapon["MachineGun"] = "MACHINE_GUN";
    Weapon["NinjaStar"] = "NINJA_STAR";
    Weapon["XMAS23"] = "XM_AS_23";
    Weapon["Carrot"] = "CAR_98";
    Weapon["Flamethrower"] = "FLAMETHROWER";
    Weapon["GanAutoRifle"] = "GAN_AUTO_RIFLE";
})($49736469f58fc92b$export$a0b1da4b3d9a7c29 || ($49736469f58fc92b$export$a0b1da4b3d9a7c29 = {}));
var $49736469f58fc92b$export$118171a82d109c04;
(function(Skill) {
    Skill["Defensive"] = "defensive";
    Skill["Lightning"] = "lightning";
    Skill["HealingDrone"] = "healing-drone";
    Skill["RocketDrone"] = "rocket-drone";
})($49736469f58fc92b$export$118171a82d109c04 || ($49736469f58fc92b$export$118171a82d109c04 = {}));
var $49736469f58fc92b$export$f23cdcd4167bcde7;
(function(Aura) {
    Aura["Heal"] = "heal";
    Aura["Shield"] = "shield";
})($49736469f58fc92b$export$f23cdcd4167bcde7 || ($49736469f58fc92b$export$f23cdcd4167bcde7 = {}));
var $49736469f58fc92b$export$31daa950d4530805;
(function(AOE) {
    AOE["Invisible"] = "invisible";
    AOE["Poison"] = "poison";
    AOE["Electricity"] = "electricity";
})($49736469f58fc92b$export$31daa950d4530805 || ($49736469f58fc92b$export$31daa950d4530805 = {}));
var $49736469f58fc92b$export$6d08773d2e66f8f2;
(function(Item) {
    Item["SmallXP"] = "small-xp";
    Item["BigXP"] = "big-xp";
    Item["MysteryBox"] = "mystery-box";
    Item["Heal"] = "heal";
    Item["Shield"] = "shield";
    Item["Bomb"] = "bomb";
    Item["Gem"] = "gem";
    Item["ChestCommon"] = "chest-common";
    Item["ChestRare"] = "chest-rare";
    Item["ChestFabled"] = "chest-fabled";
    Item["ChestZombie"] = "chest-zombie";
})($49736469f58fc92b$export$6d08773d2e66f8f2 || ($49736469f58fc92b$export$6d08773d2e66f8f2 = {}));
var $49736469f58fc92b$export$f33286854e75f828;
(function(ChestType) {
    ChestType["Common"] = "common";
    ChestType["Rare"] = "rare";
    ChestType["Fabled"] = "fabled";
    ChestType["Zombie"] = "zombie";
})($49736469f58fc92b$export$f33286854e75f828 || ($49736469f58fc92b$export$f33286854e75f828 = {}));
var $49736469f58fc92b$export$93445e7da77bf239;
(function(SoundName) {
    // Music
    SoundName["MainTheme"] = "main-theme";
    SoundName["MainTheme2"] = "main-theme-2";
    SoundName["GameEnded"] = "game-ended";
    SoundName["GamePause"] = "game-pause";
    SoundName["GameToggle"] = "game-toggle";
    // UI
    //ButtonClick = 'click',
    // Game
    SoundName["ItemBomb"] = "item-bomb";
    SoundName["ItemShield"] = "item-shield";
    SoundName["ItemMysteryBox"] = "item-mystery-box";
    SoundName["SkillDefensiveZone"] = "skill-defensive";
    SoundName["SkillHealingDrone"] = "skill-healing-drone";
    SoundName["SkillRocketDrone"] = "skill-rocket-drone";
    SoundName["SkillLightning"] = "skill-lightning";
    SoundName["WeaponBlaster"] = "weapon-blaster";
    SoundName["WeaponNinjaStar"] = "weapon-ninja-star";
    SoundName["WeaponShotgun"] = "weapon-shotgun";
    SoundName["WeaponFlame"] = "weapon-flame";
    SoundName["Impact"] = "impact";
    // Bosses
    SoundName["YetiStomp"] = "stomp";
    SoundName["YetiIceSpike"] = "ice-spike";
    SoundName["YetiIceBlast"] = "ice-blast";
    SoundName["YetiSummon"] = "summon";
})($49736469f58fc92b$export$93445e7da77bf239 || ($49736469f58fc92b$export$93445e7da77bf239 = {}));


var $d2df721d77c502e4$exports = {};

$parcel$export($d2df721d77c502e4$exports, "Attachment", () => $9892e6452670f32b$export$71e4db985cfcf9e3);
$parcel$export($d2df721d77c502e4$exports, "VertexAttachment", () => $9892e6452670f32b$export$66d3a0c3be55e044);
$parcel$export($d2df721d77c502e4$exports, "BoundingBoxAttachment", () => $63a6fc6d003ab8b1$export$9538c439c6b85ad2);
$parcel$export($d2df721d77c502e4$exports, "ClippingAttachment", () => $faf5f501ea017e7d$export$838805e22b9b55f1);
$parcel$export($d2df721d77c502e4$exports, "MeshAttachment", () => $2085f04ed3d5f336$export$3f1c1692adfcf3e2);
$parcel$export($d2df721d77c502e4$exports, "PathAttachment", () => $7aafbf7cd242ca5e$export$d285e3ec07b32800);
$parcel$export($d2df721d77c502e4$exports, "PointAttachment", () => $ec38bb05db75a9af$export$1b528cde44a6ab5);
$parcel$export($d2df721d77c502e4$exports, "RegionAttachment", () => $47a62d8b9e0a7455$export$d0fc51466fa6d530);
$parcel$export($d2df721d77c502e4$exports, "Sequence", () => $37628ed40604134f$export$edde1bcb1b2b310e);
$parcel$export($d2df721d77c502e4$exports, "SequenceMode", () => $37628ed40604134f$export$2d839466c6120eb9);
$parcel$export($d2df721d77c502e4$exports, "SequenceModeValues", () => $37628ed40604134f$export$3d518da8d966a9f5);
$parcel$export($d2df721d77c502e4$exports, "AlphaTimeline", () => $fd5e2eaf5f163d40$export$2211be7c5ccde97b);
$parcel$export($d2df721d77c502e4$exports, "Animation", () => $fd5e2eaf5f163d40$export$c35d437ae5945fcd);
$parcel$export($d2df721d77c502e4$exports, "AttachmentTimeline", () => $fd5e2eaf5f163d40$export$7f2bfc5bd27cb43d);
$parcel$export($d2df721d77c502e4$exports, "CurveTimeline", () => $fd5e2eaf5f163d40$export$4094e7414845f78f);
$parcel$export($d2df721d77c502e4$exports, "CurveTimeline1", () => $fd5e2eaf5f163d40$export$ea4b0b6c1bc191c5);
$parcel$export($d2df721d77c502e4$exports, "CurveTimeline2", () => $fd5e2eaf5f163d40$export$d380b930c0f765ae);
$parcel$export($d2df721d77c502e4$exports, "DeformTimeline", () => $fd5e2eaf5f163d40$export$6968d40e5689ad6b);
$parcel$export($d2df721d77c502e4$exports, "DrawOrderTimeline", () => $fd5e2eaf5f163d40$export$ece1f7c41d051e83);
$parcel$export($d2df721d77c502e4$exports, "EventTimeline", () => $fd5e2eaf5f163d40$export$4f4bca996c586084);
$parcel$export($d2df721d77c502e4$exports, "IkConstraintTimeline", () => $fd5e2eaf5f163d40$export$73d125cd89dead44);
$parcel$export($d2df721d77c502e4$exports, "PathConstraintMixTimeline", () => $fd5e2eaf5f163d40$export$ea67b41755485038);
$parcel$export($d2df721d77c502e4$exports, "PathConstraintPositionTimeline", () => $fd5e2eaf5f163d40$export$7ce7e67fd9cc52ed);
$parcel$export($d2df721d77c502e4$exports, "PathConstraintSpacingTimeline", () => $fd5e2eaf5f163d40$export$17ee50c08a07e62b);
$parcel$export($d2df721d77c502e4$exports, "RGB2Timeline", () => $fd5e2eaf5f163d40$export$a12960afd309a230);
$parcel$export($d2df721d77c502e4$exports, "RGBA2Timeline", () => $fd5e2eaf5f163d40$export$6fc6620d97c53689);
$parcel$export($d2df721d77c502e4$exports, "RGBATimeline", () => $fd5e2eaf5f163d40$export$84cf3a3e225bcbdc);
$parcel$export($d2df721d77c502e4$exports, "RGBTimeline", () => $fd5e2eaf5f163d40$export$e179fb669ddccfa9);
$parcel$export($d2df721d77c502e4$exports, "RotateTimeline", () => $fd5e2eaf5f163d40$export$b7ecb8f68b3e130b);
$parcel$export($d2df721d77c502e4$exports, "ScaleTimeline", () => $fd5e2eaf5f163d40$export$be544e22f6ad7737);
$parcel$export($d2df721d77c502e4$exports, "ScaleXTimeline", () => $fd5e2eaf5f163d40$export$407a9cf4df59ebda);
$parcel$export($d2df721d77c502e4$exports, "ScaleYTimeline", () => $fd5e2eaf5f163d40$export$cc13ceba88ef3794);
$parcel$export($d2df721d77c502e4$exports, "SequenceTimeline", () => $fd5e2eaf5f163d40$export$2687f324e8496672);
$parcel$export($d2df721d77c502e4$exports, "ShearTimeline", () => $fd5e2eaf5f163d40$export$4da82436a1a0d773);
$parcel$export($d2df721d77c502e4$exports, "ShearXTimeline", () => $fd5e2eaf5f163d40$export$2392b1c4c21acaf8);
$parcel$export($d2df721d77c502e4$exports, "ShearYTimeline", () => $fd5e2eaf5f163d40$export$f65148e1d95352fd);
$parcel$export($d2df721d77c502e4$exports, "Timeline", () => $fd5e2eaf5f163d40$export$e6a97ba2cae5bb94);
$parcel$export($d2df721d77c502e4$exports, "TransformConstraintTimeline", () => $fd5e2eaf5f163d40$export$a7a393c2ad815ac7);
$parcel$export($d2df721d77c502e4$exports, "TranslateTimeline", () => $fd5e2eaf5f163d40$export$eb93bf27829ae703);
$parcel$export($d2df721d77c502e4$exports, "TranslateXTimeline", () => $fd5e2eaf5f163d40$export$cf49491eb4394eca);
$parcel$export($d2df721d77c502e4$exports, "TranslateYTimeline", () => $fd5e2eaf5f163d40$export$6540b7ba297d3e41);
$parcel$export($d2df721d77c502e4$exports, "AnimationState", () => $02bea3975cac0842$export$d0f7a26c90cc1562);
$parcel$export($d2df721d77c502e4$exports, "AnimationStateAdapter", () => $02bea3975cac0842$export$31af0cf42be5a74d);
$parcel$export($d2df721d77c502e4$exports, "EventQueue", () => $02bea3975cac0842$export$2fc6338444a158e6);
$parcel$export($d2df721d77c502e4$exports, "EventType", () => $02bea3975cac0842$export$3d7865934588d77e);
$parcel$export($d2df721d77c502e4$exports, "TrackEntry", () => $02bea3975cac0842$export$6fd48f25bc0ee658);
$parcel$export($d2df721d77c502e4$exports, "AnimationStateData", () => $c7965d26af0af10e$export$90d7167cc0605975);
$parcel$export($d2df721d77c502e4$exports, "AtlasAttachmentLoader", () => $e1f9342c07c31bce$export$2ff9add835475d95);
$parcel$export($d2df721d77c502e4$exports, "Bone", () => $aa12cb1aa94e7136$export$b127726e56765aa4);
$parcel$export($d2df721d77c502e4$exports, "BoneData", () => $b873069de67ba47c$export$7d85d96cf093e12f);
$parcel$export($d2df721d77c502e4$exports, "ConstraintData", () => $6e2eadc25b36742c$export$b826e1ab3af63566);
$parcel$export($d2df721d77c502e4$exports, "Event", () => $b69dd53da9706657$export$d61e24a684f9e51);
$parcel$export($d2df721d77c502e4$exports, "EventData", () => $57711e45b8cfda24$export$a5cf049e34c3d11e);
$parcel$export($d2df721d77c502e4$exports, "IkConstraint", () => $d2a70cbd94aab7f0$export$3c158c80ff28c177);
$parcel$export($d2df721d77c502e4$exports, "IkConstraintData", () => $439d8ab836629982$export$adcb08b651fc712e);
$parcel$export($d2df721d77c502e4$exports, "PathConstraint", () => $84e4987bdc6c81a2$export$cb4f92fb0c018828);
$parcel$export($d2df721d77c502e4$exports, "PathConstraintData", () => $07612ba9b2d17d60$export$d2629ab80d5dd5ba);
$parcel$export($d2df721d77c502e4$exports, "SpacingMode", () => $07612ba9b2d17d60$export$34ce760ad2b0be4b);
$parcel$export($d2df721d77c502e4$exports, "Skeleton", () => $ee28c57a028fa6c5$export$8f31e4c4a37b8e9c);
$parcel$export($d2df721d77c502e4$exports, "SkeletonBinary", () => $64725297a8c20f8e$export$a7f7eaf4e9fce9ef);
$parcel$export($d2df721d77c502e4$exports, "SkeletonBounds", () => $28af5678b986c54f$export$119f1746fc062f5e);
$parcel$export($d2df721d77c502e4$exports, "SkeletonData", () => $41c3b615da9f888b$export$e8f362f163550575);
$parcel$export($d2df721d77c502e4$exports, "SkeletonJson", () => $3cdefcdf845023bf$export$8913b5e618c6d2f3);
$parcel$export($d2df721d77c502e4$exports, "Skin", () => $e029b89e8e37c790$export$b8e0f93a76772233);
$parcel$export($d2df721d77c502e4$exports, "SkinEntry", () => $e029b89e8e37c790$export$18ca51770a196b7d);
$parcel$export($d2df721d77c502e4$exports, "Slot", () => $84a54693e6ede946$export$8c6ed5c666ac1360);
$parcel$export($d2df721d77c502e4$exports, "SlotData", () => $3dc896cad7bb3460$export$a4cce1bf50208679);
$parcel$export($d2df721d77c502e4$exports, "TransformConstraint", () => $1cb7773c39a19bab$export$a2d8268faabf5c52);
$parcel$export($d2df721d77c502e4$exports, "TransformConstraintData", () => $7c37517de6acc018$export$823fbc29771afdb5);
$parcel$export($d2df721d77c502e4$exports, "Spine", () => $784388461c50e8a6$export$ce0a100797286aea);
var $4b0ad7d1400b5e69$export$86cfdc1f02eaf37a = /* @__PURE__ */ ((AttachmentType2)=>{
    AttachmentType2[AttachmentType2["Region"] = 0] = "Region";
    AttachmentType2[AttachmentType2["BoundingBox"] = 1] = "BoundingBox";
    AttachmentType2[AttachmentType2["Mesh"] = 2] = "Mesh";
    AttachmentType2[AttachmentType2["LinkedMesh"] = 3] = "LinkedMesh";
    AttachmentType2[AttachmentType2["Path"] = 4] = "Path";
    AttachmentType2[AttachmentType2["Point"] = 5] = "Point";
    AttachmentType2[AttachmentType2["Clipping"] = 6] = "Clipping";
    return AttachmentType2;
})($4b0ad7d1400b5e69$export$86cfdc1f02eaf37a || {});


class $76f67eeea63ddac1$export$c8e921ea3330f774 {
    constructor(data, strings = new Array(), index = 0, buffer = new DataView(data.buffer)){
        this.strings = strings;
        this.index = index;
        this.buffer = buffer;
    }
    readByte() {
        return this.buffer.getInt8(this.index++);
    }
    readUnsignedByte() {
        return this.buffer.getUint8(this.index++);
    }
    readShort() {
        const value = this.buffer.getInt16(this.index);
        this.index += 2;
        return value;
    }
    readInt32() {
        const value = this.buffer.getInt32(this.index);
        this.index += 4;
        return value;
    }
    readInt(optimizePositive) {
        let b = this.readByte();
        let result = b & 127;
        if ((b & 128) != 0) {
            b = this.readByte();
            result |= (b & 127) << 7;
            if ((b & 128) != 0) {
                b = this.readByte();
                result |= (b & 127) << 14;
                if ((b & 128) != 0) {
                    b = this.readByte();
                    result |= (b & 127) << 21;
                    if ((b & 128) != 0) {
                        b = this.readByte();
                        result |= (b & 127) << 28;
                    }
                }
            }
        }
        return optimizePositive ? result : result >>> 1 ^ -(result & 1);
    }
    readStringRef() {
        const index = this.readInt(true);
        return index == 0 ? null : this.strings[index - 1];
    }
    readString() {
        let byteCount = this.readInt(true);
        switch(byteCount){
            case 0:
                return null;
            case 1:
                return "";
        }
        byteCount--;
        let chars = "";
        for(let i = 0; i < byteCount;){
            const b = this.readUnsignedByte();
            switch(b >> 4){
                case 12:
                case 13:
                    chars += String.fromCharCode((b & 31) << 6 | this.readByte() & 63);
                    i += 2;
                    break;
                case 14:
                    chars += String.fromCharCode((b & 15) << 12 | (this.readByte() & 63) << 6 | this.readByte() & 63);
                    i += 3;
                    break;
                default:
                    chars += String.fromCharCode(b);
                    i++;
            }
        }
        return chars;
    }
    readFloat() {
        const value = this.buffer.getFloat32(this.index);
        this.index += 4;
        return value;
    }
    readBoolean() {
        return this.readByte() != 0;
    }
}


var $bbcccedbc883e405$export$ccab779a50275a35 = /* @__PURE__ */ ((MixBlend2)=>{
    MixBlend2[MixBlend2["setup"] = 0] = "setup";
    MixBlend2[MixBlend2["first"] = 1] = "first";
    MixBlend2[MixBlend2["replace"] = 2] = "replace";
    MixBlend2[MixBlend2["add"] = 3] = "add";
    return MixBlend2;
})($bbcccedbc883e405$export$ccab779a50275a35 || {});
var $bbcccedbc883e405$export$52fc338c0bb328ba = /* @__PURE__ */ ((MixDirection2)=>{
    MixDirection2[MixDirection2["mixIn"] = 0] = "mixIn";
    MixDirection2[MixDirection2["mixOut"] = 1] = "mixOut";
    return MixDirection2;
})($bbcccedbc883e405$export$52fc338c0bb328ba || {});


var $2c8db927dc4fcff5$export$34d637c671e1e906 = /* @__PURE__ */ ((PositionMode2)=>{
    PositionMode2[PositionMode2["Fixed"] = 0] = "Fixed";
    PositionMode2[PositionMode2["Percent"] = 1] = "Percent";
    return PositionMode2;
})($2c8db927dc4fcff5$export$34d637c671e1e906 || {});
var $2c8db927dc4fcff5$export$a2a23846581ac82c = /* @__PURE__ */ ((RotateMode2)=>{
    RotateMode2[RotateMode2["Tangent"] = 0] = "Tangent";
    RotateMode2[RotateMode2["Chain"] = 1] = "Chain";
    RotateMode2[RotateMode2["ChainScale"] = 2] = "ChainScale";
    return RotateMode2;
})($2c8db927dc4fcff5$export$a2a23846581ac82c || {});


var $ccc5aebc60cbf024$export$4c408f82786a534d = /* @__PURE__ */ ((TransformMode2)=>{
    TransformMode2[TransformMode2["Normal"] = 0] = "Normal";
    TransformMode2[TransformMode2["OnlyTranslation"] = 1] = "OnlyTranslation";
    TransformMode2[TransformMode2["NoRotationOrReflection"] = 2] = "NoRotationOrReflection";
    TransformMode2[TransformMode2["NoScale"] = 3] = "NoScale";
    TransformMode2[TransformMode2["NoScaleOrReflection"] = 4] = "NoScaleOrReflection";
    return TransformMode2;
})($ccc5aebc60cbf024$export$4c408f82786a534d || {});



function $da7c172fd45678b4$export$e3d7a2209578a6c9(text) {
    switch(text.toLowerCase()){
        case "nearest":
            return $da7c172fd45678b4$export$f389c48fc54053be.Nearest;
        case "linear":
            return $da7c172fd45678b4$export$f389c48fc54053be.Linear;
        case "mipmap":
            return $da7c172fd45678b4$export$f389c48fc54053be.MipMap;
        case "mipmapnearestnearest":
            return $da7c172fd45678b4$export$f389c48fc54053be.MipMapNearestNearest;
        case "mipmaplinearnearest":
            return $da7c172fd45678b4$export$f389c48fc54053be.MipMapLinearNearest;
        case "mipmapnearestlinear":
            return $da7c172fd45678b4$export$f389c48fc54053be.MipMapNearestLinear;
        case "mipmaplinearlinear":
            return $da7c172fd45678b4$export$f389c48fc54053be.MipMapLinearLinear;
        default:
            throw new Error(`Unknown texture filter ${text}`);
    }
}
function $da7c172fd45678b4$export$8a50851d9618daa9(text) {
    switch(text.toLowerCase()){
        case "mirroredtepeat":
            return $da7c172fd45678b4$export$522a1d31bfb74ba3.MirroredRepeat;
        case "clamptoedge":
            return $da7c172fd45678b4$export$522a1d31bfb74ba3.ClampToEdge;
        case "repeat":
            return $da7c172fd45678b4$export$522a1d31bfb74ba3.Repeat;
        default:
            throw new Error(`Unknown texture wrap ${text}`);
    }
}
var $da7c172fd45678b4$export$f389c48fc54053be = /* @__PURE__ */ ((TextureFilter2)=>{
    TextureFilter2[TextureFilter2["Nearest"] = 9728] = "Nearest";
    TextureFilter2[TextureFilter2["Linear"] = 9729] = "Linear";
    TextureFilter2[TextureFilter2["MipMap"] = 9987] = "MipMap";
    TextureFilter2[TextureFilter2["MipMapNearestNearest"] = 9984] = "MipMapNearestNearest";
    TextureFilter2[TextureFilter2["MipMapLinearNearest"] = 9985] = "MipMapLinearNearest";
    TextureFilter2[TextureFilter2["MipMapNearestLinear"] = 9986] = "MipMapNearestLinear";
    TextureFilter2[TextureFilter2["MipMapLinearLinear"] = 9987] = "MipMapLinearLinear";
    return TextureFilter2;
})($da7c172fd45678b4$export$f389c48fc54053be || {});
var $da7c172fd45678b4$export$522a1d31bfb74ba3 = /* @__PURE__ */ ((TextureWrap2)=>{
    TextureWrap2[TextureWrap2["MirroredRepeat"] = 33648] = "MirroredRepeat";
    TextureWrap2[TextureWrap2["ClampToEdge"] = 33071] = "ClampToEdge";
    TextureWrap2[TextureWrap2["Repeat"] = 10497] = "Repeat";
    return TextureWrap2;
})($da7c172fd45678b4$export$522a1d31bfb74ba3 || {});
class $da7c172fd45678b4$export$e7d46317c6b644d1 {
    constructor(){
        // thats for overrides
        this.size = null;
        this.names = null;
        this.values = null;
        this.renderObject = null;
    }
    get width() {
        const tex = this.texture;
        if (tex.trim) return tex.trim.width;
        return tex.orig.width;
    }
    get height() {
        const tex = this.texture;
        if (tex.trim) return tex.trim.height;
        return tex.orig.height;
    }
    get u() {
        return this.texture._uvs.x0;
    }
    get v() {
        return this.texture._uvs.y0;
    }
    get u2() {
        return this.texture._uvs.x2;
    }
    get v2() {
        return this.texture._uvs.y2;
    }
    get offsetX() {
        const tex = this.texture;
        return tex.trim ? tex.trim.x : 0;
    }
    get offsetY() {
        return this.spineOffsetY;
    }
    get pixiOffsetY() {
        const tex = this.texture;
        return tex.trim ? tex.trim.y : 0;
    }
    get spineOffsetY() {
        const tex = this.texture;
        return this.originalHeight - this.height - (tex.trim ? tex.trim.y : 0);
    }
    get originalWidth() {
        return this.texture.orig.width;
    }
    get originalHeight() {
        return this.texture.orig.height;
    }
    get x() {
        return this.texture.frame.x;
    }
    get y() {
        return this.texture.frame.y;
    }
    get rotate() {
        return this.texture.rotate !== 0;
    }
    get degrees() {
        return (360 - this.texture.rotate * 45) % 360;
    }
}


class $54adb83dd77388e1$var$RegionFields {
    constructor(){
        this.x = 0;
        this.y = 0;
        this.width = 0;
        this.height = 0;
        this.offsetX = 0;
        this.offsetY = 0;
        this.originalWidth = 0;
        this.originalHeight = 0;
        this.rotate = 0;
        this.index = 0;
    }
}
class $54adb83dd77388e1$export$1ffc3159823e6649 {
    constructor(atlasText, textureLoader, callback){
        this.pages = new Array();
        this.regions = new Array();
        if (atlasText) this.addSpineAtlas(atlasText, textureLoader, callback);
    }
    addTexture(name, texture) {
        const pages = this.pages;
        let page = null;
        for(let i = 0; i < pages.length; i++)if (pages[i].baseTexture === texture.baseTexture) {
            page = pages[i];
            break;
        }
        if (page === null) {
            page = new $54adb83dd77388e1$export$1a5db136de4137c2();
            page.name = "texturePage";
            const baseTexture = texture.baseTexture;
            page.width = baseTexture.realWidth;
            page.height = baseTexture.realHeight;
            page.baseTexture = baseTexture;
            page.minFilter = page.magFilter = (0, $da7c172fd45678b4$export$f389c48fc54053be).Nearest;
            page.uWrap = (0, $da7c172fd45678b4$export$522a1d31bfb74ba3).ClampToEdge;
            page.vWrap = (0, $da7c172fd45678b4$export$522a1d31bfb74ba3).ClampToEdge;
            pages.push(page);
        }
        const region = new $54adb83dd77388e1$export$6c0770e21c633916();
        region.name = name;
        region.page = page;
        region.texture = texture;
        region.index = -1;
        this.regions.push(region);
        return region;
    }
    addTextureHash(textures, stripExtension) {
        for(const key in textures)if (textures.hasOwnProperty(key)) this.addTexture(stripExtension && key.indexOf(".") !== -1 ? key.substr(0, key.lastIndexOf(".")) : key, textures[key]);
    }
    addSpineAtlas(atlasText, textureLoader, callback) {
        return this.load(atlasText, textureLoader, callback);
    }
    load(atlasText, textureLoader, callback) {
        if (textureLoader == null) throw new Error("textureLoader cannot be null.");
        const reader = new $54adb83dd77388e1$var$TextureAtlasReader(atlasText);
        const entry = new Array(4);
        let page = null;
        const pageFields = {};
        let region = null;
        pageFields.size = ()=>{
            page.width = parseInt(entry[1]);
            page.height = parseInt(entry[2]);
        };
        pageFields.format = ()=>{};
        pageFields.filter = ()=>{
            page.minFilter = (0, $da7c172fd45678b4$export$e3d7a2209578a6c9)(entry[1]);
            page.magFilter = (0, $da7c172fd45678b4$export$e3d7a2209578a6c9)(entry[2]);
        };
        pageFields.repeat = ()=>{
            if (entry[1].indexOf("x") != -1) page.uWrap = (0, $da7c172fd45678b4$export$522a1d31bfb74ba3).Repeat;
            if (entry[1].indexOf("y") != -1) page.vWrap = (0, $da7c172fd45678b4$export$522a1d31bfb74ba3).Repeat;
        };
        pageFields.pma = ()=>{
            page.pma = entry[1] == "true";
        };
        const regionFields = {};
        regionFields.xy = ()=>{
            region.x = parseInt(entry[1]);
            region.y = parseInt(entry[2]);
        };
        regionFields.size = ()=>{
            region.width = parseInt(entry[1]);
            region.height = parseInt(entry[2]);
        };
        regionFields.bounds = ()=>{
            region.x = parseInt(entry[1]);
            region.y = parseInt(entry[2]);
            region.width = parseInt(entry[3]);
            region.height = parseInt(entry[4]);
        };
        regionFields.offset = ()=>{
            region.offsetX = parseInt(entry[1]);
            region.offsetY = parseInt(entry[2]);
        };
        regionFields.orig = ()=>{
            region.originalWidth = parseInt(entry[1]);
            region.originalHeight = parseInt(entry[2]);
        };
        regionFields.offsets = ()=>{
            region.offsetX = parseInt(entry[1]);
            region.offsetY = parseInt(entry[2]);
            region.originalWidth = parseInt(entry[3]);
            region.originalHeight = parseInt(entry[4]);
        };
        regionFields.rotate = ()=>{
            const rotateValue = entry[1];
            let rotate = 0;
            if (rotateValue.toLocaleLowerCase() == "true") rotate = 6;
            else if (rotateValue.toLocaleLowerCase() == "false") rotate = 0;
            else rotate = (720 - parseFloat(rotateValue)) % 360 / 45;
            region.rotate = rotate;
        };
        regionFields.index = ()=>{
            region.index = parseInt(entry[1]);
        };
        let line = reader.readLine();
        while(line != null && line.trim().length == 0)line = reader.readLine();
        while(true){
            if (line == null || line.trim().length == 0) break;
            if (reader.readEntry(entry, line) == 0) break;
            line = reader.readLine();
        }
        const iterateParser = ()=>{
            while(true){
                if (line == null) return callback && callback(this);
                if (line.trim().length == 0) {
                    page = null;
                    line = reader.readLine();
                } else if (page === null) {
                    page = new $54adb83dd77388e1$export$1a5db136de4137c2();
                    page.name = line.trim();
                    while(true){
                        if (reader.readEntry(entry, line = reader.readLine()) == 0) break;
                        const field = pageFields[entry[0]];
                        if (field) field();
                    }
                    this.pages.push(page);
                    textureLoader(page.name, (texture)=>{
                        if (texture === null) {
                            this.pages.splice(this.pages.indexOf(page), 1);
                            return callback && callback(null);
                        }
                        page.baseTexture = texture;
                        if (page.pma) texture.alphaMode = (0, $0fa4b07f86297abd$export$d56550d454401b73).PMA;
                        if (!texture.valid) texture.setSize(page.width, page.height);
                        page.setFilters();
                        if (!page.width || !page.height) {
                            page.width = texture.realWidth;
                            page.height = texture.realHeight;
                            if (!page.width || !page.height) console.log(`ERROR spine atlas page ${page.name}: meshes wont work if you dont specify size in atlas (http://www.html5gamedevs.com/topic/18888-pixi-spines-and-meshes/?p=107121)`);
                        }
                        iterateParser();
                    });
                    break;
                } else {
                    region = new $54adb83dd77388e1$var$RegionFields();
                    const atlasRegion = new $54adb83dd77388e1$export$6c0770e21c633916();
                    atlasRegion.name = line;
                    atlasRegion.page = page;
                    let names = null;
                    let values = null;
                    while(true){
                        const count = reader.readEntry(entry, line = reader.readLine());
                        if (count == 0) break;
                        const field = regionFields[entry[0]];
                        if (field) field();
                        else {
                            if (names == null) {
                                names = [];
                                values = [];
                            }
                            names.push(entry[0]);
                            const entryValues = [];
                            for(let i = 0; i < count; i++)entryValues.push(parseInt(entry[i + 1]));
                            values.push(entryValues);
                        }
                    }
                    if (region.originalWidth == 0 && region.originalHeight == 0) {
                        region.originalWidth = region.width;
                        region.originalHeight = region.height;
                    }
                    const resolution = page.baseTexture.resolution;
                    region.x /= resolution;
                    region.y /= resolution;
                    region.width /= resolution;
                    region.height /= resolution;
                    region.originalWidth /= resolution;
                    region.originalHeight /= resolution;
                    region.offsetX /= resolution;
                    region.offsetY /= resolution;
                    const swapWH = region.rotate % 4 !== 0;
                    const frame = new (0, $200f778d7fdbf8ac$export$4617fb02663045ef)(region.x, region.y, swapWH ? region.height : region.width, swapWH ? region.width : region.height);
                    const orig = new (0, $200f778d7fdbf8ac$export$4617fb02663045ef)(0, 0, region.originalWidth, region.originalHeight);
                    const trim = new (0, $200f778d7fdbf8ac$export$4617fb02663045ef)(region.offsetX, region.originalHeight - region.height - region.offsetY, region.width, region.height);
                    atlasRegion.texture = new (0, $14896914ad3ae15d$export$5431306cf43de24a)(atlasRegion.page.baseTexture, frame, orig, trim, region.rotate);
                    atlasRegion.index = region.index;
                    atlasRegion.texture.updateUvs();
                    this.regions.push(atlasRegion);
                }
            }
        };
        iterateParser();
    }
    findRegion(name) {
        for(let i = 0; i < this.regions.length; i++){
            if (this.regions[i].name == name) return this.regions[i];
        }
        return null;
    }
    dispose() {
        for(let i = 0; i < this.pages.length; i++)this.pages[i].baseTexture.dispose();
    }
}
class $54adb83dd77388e1$var$TextureAtlasReader {
    constructor(text){
        this.index = 0;
        this.lines = text.split(/\r\n|\r|\n/);
    }
    readLine() {
        if (this.index >= this.lines.length) return null;
        return this.lines[this.index++];
    }
    readEntry(entry, line) {
        if (line == null) return 0;
        line = line.trim();
        if (line.length == 0) return 0;
        const colon = line.indexOf(":");
        if (colon == -1) return 0;
        entry[0] = line.substr(0, colon).trim();
        for(let i = 1, lastMatch = colon + 1;; i++){
            const comma = line.indexOf(",", lastMatch);
            if (comma == -1) {
                entry[i] = line.substr(lastMatch).trim();
                return i;
            }
            entry[i] = line.substr(lastMatch, comma - lastMatch).trim();
            lastMatch = comma + 1;
            if (i == 4) return 4;
        }
    }
}
class $54adb83dd77388e1$export$1a5db136de4137c2 {
    constructor(){
        this.minFilter = (0, $da7c172fd45678b4$export$f389c48fc54053be).Nearest;
        this.magFilter = (0, $da7c172fd45678b4$export$f389c48fc54053be).Nearest;
        this.uWrap = (0, $da7c172fd45678b4$export$522a1d31bfb74ba3).ClampToEdge;
        this.vWrap = (0, $da7c172fd45678b4$export$522a1d31bfb74ba3).ClampToEdge;
    }
    setFilters() {
        const tex = this.baseTexture;
        const filter = this.minFilter;
        if (filter == (0, $da7c172fd45678b4$export$f389c48fc54053be).Linear) tex.scaleMode = (0, $0fa4b07f86297abd$export$6b734c6a0bba8473).LINEAR;
        else if (this.minFilter == (0, $da7c172fd45678b4$export$f389c48fc54053be).Nearest) tex.scaleMode = (0, $0fa4b07f86297abd$export$6b734c6a0bba8473).NEAREST;
        else {
            tex.mipmap = (0, $0fa4b07f86297abd$export$16f6fb5da874bbfd).POW2;
            if (filter == (0, $da7c172fd45678b4$export$f389c48fc54053be).MipMapNearestNearest) tex.scaleMode = (0, $0fa4b07f86297abd$export$6b734c6a0bba8473).NEAREST;
            else tex.scaleMode = (0, $0fa4b07f86297abd$export$6b734c6a0bba8473).LINEAR;
        }
    }
}
class $54adb83dd77388e1$export$6c0770e21c633916 extends (0, $da7c172fd45678b4$export$e7d46317c6b644d1) {
}



class $8804784813ffae81$export$270182061f11fa81 {
    constructor(){
        this.array = new Array();
    }
    add(value) {
        const contains = this.contains(value);
        this.array[value | 0] = value | 0;
        return !contains;
    }
    contains(value) {
        return this.array[value | 0] != void 0;
    }
    remove(value) {
        this.array[value | 0] = void 0;
    }
    clear() {
        this.array.length = 0;
    }
}
class $8804784813ffae81$export$1a41fd2ab8394c46 {
    constructor(){
        this.entries = {};
        this.size = 0;
    }
    add(value) {
        const contains = this.entries[value];
        this.entries[value] = true;
        if (!contains) {
            this.size++;
            return true;
        }
        return false;
    }
    addAll(values) {
        const oldSize = this.size;
        for(let i = 0, n = values.length; i < n; i++)this.add(values[i]);
        return oldSize != this.size;
    }
    contains(value) {
        return this.entries[value];
    }
    clear() {
        this.entries = {};
        this.size = 0;
    }
}
const $8804784813ffae81$var$_Color = class {
    constructor(r = 0, g = 0, b = 0, a = 0){
        this.r = r;
        this.g = g;
        this.b = b;
        this.a = a;
    }
    set(r, g, b, a) {
        this.r = r;
        this.g = g;
        this.b = b;
        this.a = a;
        return this.clamp();
    }
    setFromColor(c) {
        this.r = c.r;
        this.g = c.g;
        this.b = c.b;
        this.a = c.a;
        return this;
    }
    setFromString(hex) {
        hex = hex.charAt(0) == "#" ? hex.substr(1) : hex;
        this.r = parseInt(hex.substr(0, 2), 16) / 255;
        this.g = parseInt(hex.substr(2, 2), 16) / 255;
        this.b = parseInt(hex.substr(4, 2), 16) / 255;
        this.a = hex.length != 8 ? 1 : parseInt(hex.substr(6, 2), 16) / 255;
        return this;
    }
    add(r, g, b, a) {
        this.r += r;
        this.g += g;
        this.b += b;
        this.a += a;
        return this.clamp();
    }
    clamp() {
        if (this.r < 0) this.r = 0;
        else if (this.r > 1) this.r = 1;
        if (this.g < 0) this.g = 0;
        else if (this.g > 1) this.g = 1;
        if (this.b < 0) this.b = 0;
        else if (this.b > 1) this.b = 1;
        if (this.a < 0) this.a = 0;
        else if (this.a > 1) this.a = 1;
        return this;
    }
    static rgba8888ToColor(color, value) {
        color.r = ((value & 4278190080) >>> 24) / 255;
        color.g = ((value & 16711680) >>> 16) / 255;
        color.b = ((value & 65280) >>> 8) / 255;
        color.a = (value & 255) / 255;
    }
    static rgb888ToColor(color, value) {
        color.r = ((value & 16711680) >>> 16) / 255;
        color.g = ((value & 65280) >>> 8) / 255;
        color.b = (value & 255) / 255;
    }
    static fromString(hex) {
        return new $8804784813ffae81$var$_Color().setFromString(hex);
    }
};
let $8804784813ffae81$export$892596cec99bc70e = $8804784813ffae81$var$_Color;
$8804784813ffae81$export$892596cec99bc70e.WHITE = new $8804784813ffae81$var$_Color(1, 1, 1, 1);
$8804784813ffae81$export$892596cec99bc70e.RED = new $8804784813ffae81$var$_Color(1, 0, 0, 1);
$8804784813ffae81$export$892596cec99bc70e.GREEN = new $8804784813ffae81$var$_Color(0, 1, 0, 1);
$8804784813ffae81$export$892596cec99bc70e.BLUE = new $8804784813ffae81$var$_Color(0, 0, 1, 1);
$8804784813ffae81$export$892596cec99bc70e.MAGENTA = new $8804784813ffae81$var$_Color(1, 0, 1, 1);
const $8804784813ffae81$var$_MathUtils = class {
    static clamp(value, min, max) {
        if (value < min) return min;
        if (value > max) return max;
        return value;
    }
    static cosDeg(degrees) {
        return Math.cos(degrees * $8804784813ffae81$var$_MathUtils.degRad);
    }
    static sinDeg(degrees) {
        return Math.sin(degrees * $8804784813ffae81$var$_MathUtils.degRad);
    }
    static signum(value) {
        return Math.sign(value);
    }
    static toInt(x) {
        return x > 0 ? Math.floor(x) : Math.ceil(x);
    }
    static cbrt(x) {
        const y = Math.pow(Math.abs(x), 1 / 3);
        return x < 0 ? -y : y;
    }
    static randomTriangular(min, max) {
        return $8804784813ffae81$var$_MathUtils.randomTriangularWith(min, max, (min + max) * 0.5);
    }
    static randomTriangularWith(min, max, mode) {
        const u = Math.random();
        const d = max - min;
        if (u <= (mode - min) / d) return min + Math.sqrt(u * d * (mode - min));
        return max - Math.sqrt((1 - u) * d * (max - mode));
    }
    static isPowerOfTwo(value) {
        return value && (value & value - 1) === 0;
    }
};
let $8804784813ffae81$export$6a7ef315a0d1ef07 = $8804784813ffae81$var$_MathUtils;
$8804784813ffae81$export$6a7ef315a0d1ef07.PI = 3.1415927;
$8804784813ffae81$export$6a7ef315a0d1ef07.PI2 = $8804784813ffae81$var$_MathUtils.PI * 2;
$8804784813ffae81$export$6a7ef315a0d1ef07.radiansToDegrees = 180 / $8804784813ffae81$var$_MathUtils.PI;
$8804784813ffae81$export$6a7ef315a0d1ef07.radDeg = $8804784813ffae81$var$_MathUtils.radiansToDegrees;
$8804784813ffae81$export$6a7ef315a0d1ef07.degreesToRadians = $8804784813ffae81$var$_MathUtils.PI / 180;
$8804784813ffae81$export$6a7ef315a0d1ef07.degRad = $8804784813ffae81$var$_MathUtils.degreesToRadians;
class $8804784813ffae81$export$b0cc4f9860136880 {
    apply(start, end, a) {
        return start + (end - start) * this.applyInternal(a);
    }
}
class $8804784813ffae81$export$ce28d653ec559ee extends $8804784813ffae81$export$b0cc4f9860136880 {
    constructor(power){
        super();
        this.power = 2;
        this.power = power;
    }
    applyInternal(a) {
        if (a <= 0.5) return Math.pow(a * 2, this.power) / 2;
        return Math.pow((a - 1) * 2, this.power) / (this.power % 2 == 0 ? -2 : 2) + 1;
    }
}
class $8804784813ffae81$export$4834f341f53dca5c extends $8804784813ffae81$export$ce28d653ec559ee {
    applyInternal(a) {
        return Math.pow(a - 1, this.power) * (this.power % 2 == 0 ? -1 : 1) + 1;
    }
}
const $8804784813ffae81$var$_Utils = class {
    static arrayCopy(source, sourceStart, dest, destStart, numElements) {
        for(let i = sourceStart, j = destStart; i < sourceStart + numElements; i++, j++)dest[j] = source[i];
    }
    static arrayFill(array, fromIndex, toIndex, value) {
        for(let i = fromIndex; i < toIndex; i++)array[i] = value;
    }
    static setArraySize(array, size, value = 0) {
        const oldSize = array.length;
        if (oldSize == size) return array;
        array.length = size;
        if (oldSize < size) for(let i = oldSize; i < size; i++)array[i] = value;
        return array;
    }
    static ensureArrayCapacity(array, size, value = 0) {
        if (array.length >= size) return array;
        return $8804784813ffae81$var$_Utils.setArraySize(array, size, value);
    }
    static newArray(size, defaultValue) {
        const array = new Array(size);
        for(let i = 0; i < size; i++)array[i] = defaultValue;
        return array;
    }
    static newFloatArray(size) {
        if ($8804784813ffae81$var$_Utils.SUPPORTS_TYPED_ARRAYS) return new Float32Array(size);
        const array = new Array(size);
        for(let i = 0; i < array.length; i++)array[i] = 0;
        return array;
    }
    static newShortArray(size) {
        if ($8804784813ffae81$var$_Utils.SUPPORTS_TYPED_ARRAYS) return new Int16Array(size);
        const array = new Array(size);
        for(let i = 0; i < array.length; i++)array[i] = 0;
        return array;
    }
    static toFloatArray(array) {
        return $8804784813ffae81$var$_Utils.SUPPORTS_TYPED_ARRAYS ? new Float32Array(array) : array;
    }
    static toSinglePrecision(value) {
        return $8804784813ffae81$var$_Utils.SUPPORTS_TYPED_ARRAYS ? Math.fround(value) : value;
    }
    // This function is used to fix WebKit 602 specific issue described at http://esotericsoftware.com/forum/iOS-10-disappearing-graphics-10109
    static webkit602BugfixHelper(alpha, blend) {}
    static contains(array, element, identity = true) {
        for(let i = 0; i < array.length; i++){
            if (array[i] == element) return true;
        }
        return false;
    }
    static enumValue(type, name) {
        return type[name[0].toUpperCase() + name.slice(1)];
    }
};
let $8804784813ffae81$export$d2ca453b913dcdea = $8804784813ffae81$var$_Utils;
$8804784813ffae81$export$d2ca453b913dcdea.SUPPORTS_TYPED_ARRAYS = typeof Float32Array !== "undefined";
class $8804784813ffae81$export$d19db7c5e7bdee05 {
    static logBones(skeleton) {
        for(let i = 0; i < skeleton.bones.length; i++){
            const bone = skeleton.bones[i];
            const mat = bone.matrix;
            console.log(`${bone.data.name}, ${mat.a}, ${mat.b}, ${mat.c}, ${mat.d}, ${mat.tx}, ${mat.ty}`);
        }
    }
}
class $8804784813ffae81$export$14963ee5c8637e11 {
    constructor(instantiator){
        this.items = new Array();
        this.instantiator = instantiator;
    }
    obtain() {
        return this.items.length > 0 ? this.items.pop() : this.instantiator();
    }
    free(item) {
        if (item.reset) item.reset();
        this.items.push(item);
    }
    freeAll(items) {
        for(let i = 0; i < items.length; i++)this.free(items[i]);
    }
    clear() {
        this.items.length = 0;
    }
}
class $8804784813ffae81$export$c977b3e384af9ae1 {
    constructor(x = 0, y = 0){
        this.x = x;
        this.y = y;
    }
    set(x, y) {
        this.x = x;
        this.y = y;
        return this;
    }
    length() {
        const x = this.x;
        const y = this.y;
        return Math.sqrt(x * x + y * y);
    }
    normalize() {
        const len = this.length();
        if (len != 0) {
            this.x /= len;
            this.y /= len;
        }
        return this;
    }
}
class $8804784813ffae81$export$ab19517904b64359 {
    constructor(){
        this.maxDelta = 0.064;
        this.framesPerSecond = 0;
        this.delta = 0;
        this.totalTime = 0;
        this.lastTime = Date.now() / 1e3;
        this.frameCount = 0;
        this.frameTime = 0;
    }
    update() {
        const now = Date.now() / 1e3;
        this.delta = now - this.lastTime;
        this.frameTime += this.delta;
        this.totalTime += this.delta;
        if (this.delta > this.maxDelta) this.delta = this.maxDelta;
        this.lastTime = now;
        this.frameCount++;
        if (this.frameTime > 1) {
            this.framesPerSecond = this.frameCount / this.frameTime;
            this.frameTime = 0;
            this.frameCount = 0;
        }
    }
}
class $8804784813ffae81$export$a88e0a4e9fe51345 {
    constructor(windowSize = 32){
        this.addedValues = 0;
        this.lastValue = 0;
        this.mean = 0;
        this.dirty = true;
        this.values = new Array(windowSize);
    }
    hasEnoughData() {
        return this.addedValues >= this.values.length;
    }
    addValue(value) {
        if (this.addedValues < this.values.length) this.addedValues++;
        this.values[this.lastValue++] = value;
        if (this.lastValue > this.values.length - 1) this.lastValue = 0;
        this.dirty = true;
    }
    getMean() {
        if (this.hasEnoughData()) {
            if (this.dirty) {
                let mean = 0;
                for(let i = 0; i < this.values.length; i++)mean += this.values[i];
                this.mean = mean / this.values.length;
                this.dirty = false;
            }
            return this.mean;
        }
        return 0;
    }
}




class $f207f4fe652f3622$export$a40a4b6b6d62719b {
    constructor(){
        /** The left edge of the axis aligned bounding box. */ this.minX = 0;
        /** The bottom edge of the axis aligned bounding box. */ this.minY = 0;
        /** The right edge of the axis aligned bounding box. */ this.maxX = 0;
        /** The top edge of the axis aligned bounding box. */ this.maxY = 0;
        /** The visible bounding boxes. */ this.boundingBoxes = new Array();
        /** The world vertices for the bounding box polygons. */ this.polygons = new Array();
        this.polygonPool = new (0, $8804784813ffae81$export$14963ee5c8637e11)(()=>(0, $8804784813ffae81$export$d2ca453b913dcdea).newFloatArray(16));
    }
    /** Clears any previous polygons, finds all visible bounding box attachments, and computes the world vertices for each bounding
   * box's polygon.
   * @param updateAabb If true, the axis aligned bounding box containing all the polygons is computed. If false, the
   *           SkeletonBounds AABB methods will always return true. */ update(skeleton, updateAabb) {
        if (!skeleton) throw new Error("skeleton cannot be null.");
        const boundingBoxes = this.boundingBoxes;
        const polygons = this.polygons;
        const polygonPool = this.polygonPool;
        const slots = skeleton.slots;
        const slotCount = slots.length;
        boundingBoxes.length = 0;
        polygonPool.freeAll(polygons);
        polygons.length = 0;
        for(let i = 0; i < slotCount; i++){
            const slot = slots[i];
            if (!slot.bone.active) continue;
            const attachment = slot.getAttachment();
            if (attachment != null && attachment.type === (0, $4b0ad7d1400b5e69$export$86cfdc1f02eaf37a).BoundingBox) {
                const boundingBox = attachment;
                boundingBoxes.push(boundingBox);
                let polygon = polygonPool.obtain();
                if (polygon.length != boundingBox.worldVerticesLength) polygon = (0, $8804784813ffae81$export$d2ca453b913dcdea).newFloatArray(boundingBox.worldVerticesLength);
                polygons.push(polygon);
                boundingBox.computeWorldVertices(slot, 0, boundingBox.worldVerticesLength, polygon, 0, 2);
            }
        }
        if (updateAabb) this.aabbCompute();
        else {
            this.minX = Number.POSITIVE_INFINITY;
            this.minY = Number.POSITIVE_INFINITY;
            this.maxX = Number.NEGATIVE_INFINITY;
            this.maxY = Number.NEGATIVE_INFINITY;
        }
    }
    aabbCompute() {
        let minX = Number.POSITIVE_INFINITY;
        let minY = Number.POSITIVE_INFINITY;
        let maxX = Number.NEGATIVE_INFINITY;
        let maxY = Number.NEGATIVE_INFINITY;
        const polygons = this.polygons;
        for(let i = 0, n = polygons.length; i < n; i++){
            const polygon = polygons[i];
            const vertices = polygon;
            for(let ii = 0, nn = polygon.length; ii < nn; ii += 2){
                const x = vertices[ii];
                const y = vertices[ii + 1];
                minX = Math.min(minX, x);
                minY = Math.min(minY, y);
                maxX = Math.max(maxX, x);
                maxY = Math.max(maxY, y);
            }
        }
        this.minX = minX;
        this.minY = minY;
        this.maxX = maxX;
        this.maxY = maxY;
    }
    /** Returns true if the axis aligned bounding box contains the point. */ aabbContainsPoint(x, y) {
        return x >= this.minX && x <= this.maxX && y >= this.minY && y <= this.maxY;
    }
    /** Returns true if the axis aligned bounding box intersects the line segment. */ aabbIntersectsSegment(x1, y1, x2, y2) {
        const minX = this.minX;
        const minY = this.minY;
        const maxX = this.maxX;
        const maxY = this.maxY;
        if (x1 <= minX && x2 <= minX || y1 <= minY && y2 <= minY || x1 >= maxX && x2 >= maxX || y1 >= maxY && y2 >= maxY) return false;
        const m = (y2 - y1) / (x2 - x1);
        let y = m * (minX - x1) + y1;
        if (y > minY && y < maxY) return true;
        y = m * (maxX - x1) + y1;
        if (y > minY && y < maxY) return true;
        let x = (minY - y1) / m + x1;
        if (x > minX && x < maxX) return true;
        x = (maxY - y1) / m + x1;
        if (x > minX && x < maxX) return true;
        return false;
    }
    /** Returns true if the axis aligned bounding box intersects the axis aligned bounding box of the specified bounds. */ aabbIntersectsSkeleton(bounds) {
        return this.minX < bounds.maxX && this.maxX > bounds.minX && this.minY < bounds.maxY && this.maxY > bounds.minY;
    }
    /** Returns the first bounding box attachment that contains the point, or null. When doing many checks, it is usually more
   * efficient to only call this method if {@link #aabbContainsPoint(float, float)} returns true.
   * Cannot be done here because BoundingBoxAttachment is not a thing yet*/ containsPoint(x, y) {
        const polygons = this.polygons;
        for(let i = 0, n = polygons.length; i < n; i++){
            if (this.containsPointPolygon(polygons[i], x, y)) return this.boundingBoxes[i];
        }
        return null;
    }
    /** Returns true if the polygon contains the point. */ containsPointPolygon(polygon, x, y) {
        const vertices = polygon;
        const nn = polygon.length;
        let prevIndex = nn - 2;
        let inside = false;
        for(let ii = 0; ii < nn; ii += 2){
            const vertexY = vertices[ii + 1];
            const prevY = vertices[prevIndex + 1];
            if (vertexY < y && prevY >= y || prevY < y && vertexY >= y) {
                const vertexX = vertices[ii];
                if (vertexX + (y - vertexY) / (prevY - vertexY) * (vertices[prevIndex] - vertexX) < x) inside = !inside;
            }
            prevIndex = ii;
        }
        return inside;
    }
    /** Returns the first bounding box attachment that contains any part of the line segment, or null. When doing many checks, it
   * is usually more efficient to only call this method if {@link #aabbIntersectsSegment()} returns
   * true. */ intersectsSegment(x1, y1, x2, y2) {
        const polygons = this.polygons;
        for(let i = 0, n = polygons.length; i < n; i++){
            if (this.intersectsSegmentPolygon(polygons[i], x1, y1, x2, y2)) return this.boundingBoxes[i];
        }
        return null;
    }
    /** Returns true if the polygon contains any part of the line segment. */ intersectsSegmentPolygon(polygon, x1, y1, x2, y2) {
        const vertices = polygon;
        const nn = polygon.length;
        const width12 = x1 - x2;
        const height12 = y1 - y2;
        const det1 = x1 * y2 - y1 * x2;
        let x3 = vertices[nn - 2];
        let y3 = vertices[nn - 1];
        for(let ii = 0; ii < nn; ii += 2){
            const x4 = vertices[ii];
            const y4 = vertices[ii + 1];
            const det2 = x3 * y4 - y3 * x4;
            const width34 = x3 - x4;
            const height34 = y3 - y4;
            const det3 = width12 * height34 - height12 * width34;
            const x = (det1 * width34 - width12 * det2) / det3;
            if ((x >= x3 && x <= x4 || x >= x4 && x <= x3) && (x >= x1 && x <= x2 || x >= x2 && x <= x1)) {
                const y = (det1 * height34 - height12 * det2) / det3;
                if ((y >= y3 && y <= y4 || y >= y4 && y <= y3) && (y >= y1 && y <= y2 || y >= y2 && y <= y1)) return true;
            }
            x3 = x4;
            y3 = y4;
        }
        return false;
    }
    /** Returns the polygon for the specified bounding box, or null. */ getPolygon(boundingBox) {
        if (!boundingBox) throw new Error("boundingBox cannot be null.");
        const index = this.boundingBoxes.indexOf(boundingBox);
        return index == -1 ? null : this.polygons[index];
    }
    /** The width of the axis aligned bounding box. */ getWidth() {
        return this.maxX - this.minX;
    }
    /** The height of the axis aligned bounding box. */ getHeight() {
        return this.maxY - this.minY;
    }
}


const $1840f66876ded594$export$a5a6e0b888b2c992 = {
    yDown: true,
    /**
   * pixi-spine gives option to not fail at certain parsing errors
   * spine-ts fails here
   */ FAIL_ON_NON_EXISTING_SKIN: false,
    /**
   * past Spine.globalAutoUpdate
   */ GLOBAL_AUTO_UPDATE: true,
    /**
   * past Spine.globalDelayLimit
   */ GLOBAL_DELAY_LIMIT: 0
};











const $c67a865880ede3c3$var$tempRgb = [
    0,
    0,
    0
];
class $c67a865880ede3c3$export$46dc8ebfc84ff722 extends (0, $e4c5b2569bd3a8d2$export$3075603db8e6204c) {
    constructor(){
        super(...arguments);
        this.region = null;
        this.attachment = null;
    }
}
class $c67a865880ede3c3$export$37a64c87f11cff18 extends (0, $7c845697fd87c580$export$81b9e78682e7feca) {
    constructor(texture, vertices, uvs, indices, drawMode){
        super(texture, vertices, uvs, indices, drawMode);
        this.region = null;
        this.attachment = null;
    }
}
const $c67a865880ede3c3$var$_SpineBase = class extends (0, $68e6944de5989822$export$42a852a2b6b56249) {
    constructor(spineData){
        super();
        if (!spineData) throw new Error("The spineData param is required.");
        if (typeof spineData === "string") throw new Error('spineData param cant be string. Please use spine.Spine.fromAtlas("YOUR_RESOURCE_NAME") from now on.');
        this.spineData = spineData;
        this.createSkeleton(spineData);
        this.slotContainers = [];
        this.tempClipContainers = [];
        for(let i = 0, n = this.skeleton.slots.length; i < n; i++){
            const slot = this.skeleton.slots[i];
            const attachment = slot.getAttachment();
            const slotContainer = this.newContainer();
            this.slotContainers.push(slotContainer);
            this.addChild(slotContainer);
            this.tempClipContainers.push(null);
            if (!attachment) continue;
            if (attachment.type === (0, $4b0ad7d1400b5e69$export$86cfdc1f02eaf37a).Region) {
                const spriteName = attachment.name;
                const sprite = this.createSprite(slot, attachment, spriteName);
                slot.currentSprite = sprite;
                slot.currentSpriteName = spriteName;
                slotContainer.addChild(sprite);
            } else if (attachment.type === (0, $4b0ad7d1400b5e69$export$86cfdc1f02eaf37a).Mesh) {
                const mesh = this.createMesh(slot, attachment);
                slot.currentMesh = mesh;
                slot.currentMeshId = attachment.id;
                slot.currentMeshName = attachment.name;
                slotContainer.addChild(mesh);
            } else if (attachment.type === (0, $4b0ad7d1400b5e69$export$86cfdc1f02eaf37a).Clipping) {
                this.createGraphics(slot, attachment);
                slotContainer.addChild(slot.clippingContainer);
                slotContainer.addChild(slot.currentGraphics);
            }
        }
        this.tintRgb = new Float32Array([
            1,
            1,
            1
        ]);
        this.autoUpdate = true;
        this.visible = true;
    }
    get debug() {
        return this._debug;
    }
    set debug(value) {
        if (value == this._debug) return;
        this._debug?.unregisterSpine(this);
        value?.registerSpine(this);
        this._debug = value;
    }
    /**
   * If this flag is set to true, the spine animation will be automatically updated every
   * time the object id drawn. The down side of this approach is that the delta time is
   * automatically calculated and you could miss out on cool effects like slow motion,
   * pause, skip ahead and the sorts. Most of these effects can be achieved even with
   * autoUpdate enabled but are harder to achieve.
   *
   * @member {boolean}
   * @memberof spine.Spine#
   * @default true
   */ get autoUpdate() {
        return this._autoUpdate;
    }
    set autoUpdate(value) {
        if (value !== this._autoUpdate) {
            this._autoUpdate = value;
            this.updateTransform = value ? $c67a865880ede3c3$var$_SpineBase.prototype.autoUpdateTransform : (0, $68e6944de5989822$export$42a852a2b6b56249).prototype.updateTransform;
        }
    }
    /**
   * The tint applied to the spine object. This is a hex value. A value of 0xFFFFFF will remove any tint effect.
   *
   * @member {number}
   * @memberof spine.Spine#
   * @default 0xFFFFFF
   */ get tint() {
        return (0, $db31fc3dfae4939b$exports).rgb2hex(this.tintRgb);
    }
    set tint(value) {
        this.tintRgb = (0, $db31fc3dfae4939b$exports).hex2rgb(value, this.tintRgb);
    }
    /**
   * Limit value for the update dt with Spine.globalDelayLimit
   * that can be overridden with localDelayLimit
   * @return {number} - Maximum processed dt value for the update
   */ get delayLimit() {
        const limit = typeof this.localDelayLimit !== "undefined" ? this.localDelayLimit : (0, $1840f66876ded594$export$a5a6e0b888b2c992).GLOBAL_DELAY_LIMIT;
        return limit || Number.MAX_VALUE;
    }
    /**
   * Update the spine skeleton and its animations by delta time (dt)
   *
   * @param dt {number} Delta time. Time by which the animation should be updated
   */ update(dt) {
        const delayLimit = this.delayLimit;
        if (dt > delayLimit) dt = delayLimit;
        this.state.update(dt);
        this.state.apply(this.skeleton);
        if (!this.skeleton) return;
        this.skeleton.updateWorldTransform();
        const slots = this.skeleton.slots;
        const globalClr = this.color;
        let light = null;
        let dark = null;
        if (globalClr) {
            light = globalClr.light;
            dark = globalClr.dark;
        } else light = this.tintRgb;
        for(let i = 0, n = slots.length; i < n; i++){
            const slot = slots[i];
            const attachment = slot.getAttachment();
            const slotContainer = this.slotContainers[i];
            if (!attachment) {
                slotContainer.visible = false;
                continue;
            }
            let spriteColor = null;
            if (attachment.sequence) attachment.sequence.apply(slot, attachment);
            let region = attachment.region;
            const attColor = attachment.color;
            switch(attachment != null && attachment.type){
                case (0, $4b0ad7d1400b5e69$export$86cfdc1f02eaf37a).Region:
                    const transform = slotContainer.transform;
                    transform.setFromMatrix(slot.bone.matrix);
                    region = attachment.region;
                    if (slot.currentMesh) {
                        slot.currentMesh.visible = false;
                        slot.currentMesh = null;
                        slot.currentMeshId = void 0;
                        slot.currentMeshName = void 0;
                    }
                    if (!region) {
                        if (slot.currentSprite) slot.currentSprite.renderable = false;
                        break;
                    }
                    if (!slot.currentSpriteName || slot.currentSpriteName !== attachment.name) {
                        const spriteName = attachment.name;
                        if (slot.currentSprite) slot.currentSprite.visible = false;
                        slot.sprites = slot.sprites || {};
                        if (slot.sprites[spriteName] !== void 0) slot.sprites[spriteName].visible = true;
                        else {
                            const sprite = this.createSprite(slot, attachment, spriteName);
                            slotContainer.addChild(sprite);
                        }
                        slot.currentSprite = slot.sprites[spriteName];
                        slot.currentSpriteName = spriteName;
                    }
                    slot.currentSprite.renderable = true;
                    if (!slot.hackRegion) this.setSpriteRegion(attachment, slot.currentSprite, region);
                    if (slot.currentSprite.color) spriteColor = slot.currentSprite.color;
                    else {
                        $c67a865880ede3c3$var$tempRgb[0] = light[0] * slot.color.r * attColor.r;
                        $c67a865880ede3c3$var$tempRgb[1] = light[1] * slot.color.g * attColor.g;
                        $c67a865880ede3c3$var$tempRgb[2] = light[2] * slot.color.b * attColor.b;
                        slot.currentSprite.tint = (0, $db31fc3dfae4939b$exports).rgb2hex($c67a865880ede3c3$var$tempRgb);
                    }
                    slot.currentSprite.blendMode = slot.blendMode;
                    break;
                case (0, $4b0ad7d1400b5e69$export$86cfdc1f02eaf37a).Mesh:
                    if (slot.currentSprite) {
                        slot.currentSprite.visible = false;
                        slot.currentSprite = null;
                        slot.currentSpriteName = void 0;
                        const transform2 = new (0, $cec25acf758d963f$export$563a914cafbdc389)();
                        transform2._parentID = -1;
                        transform2._worldID = slotContainer.transform._worldID;
                        slotContainer.transform = transform2;
                    }
                    if (!region) {
                        if (slot.currentMesh) slot.currentMesh.renderable = false;
                        break;
                    }
                    const id = attachment.id;
                    if (slot.currentMeshId === void 0 || slot.currentMeshId !== id) {
                        const meshId = id;
                        if (slot.currentMesh) slot.currentMesh.visible = false;
                        slot.meshes = slot.meshes || {};
                        if (slot.meshes[meshId] !== void 0) slot.meshes[meshId].visible = true;
                        else {
                            const mesh = this.createMesh(slot, attachment);
                            slotContainer.addChild(mesh);
                        }
                        slot.currentMesh = slot.meshes[meshId];
                        slot.currentMeshName = attachment.name;
                        slot.currentMeshId = meshId;
                    }
                    slot.currentMesh.renderable = true;
                    attachment.computeWorldVerticesOld(slot, slot.currentMesh.vertices);
                    if (slot.currentMesh.color) spriteColor = slot.currentMesh.color;
                    else {
                        $c67a865880ede3c3$var$tempRgb[0] = light[0] * slot.color.r * attColor.r;
                        $c67a865880ede3c3$var$tempRgb[1] = light[1] * slot.color.g * attColor.g;
                        $c67a865880ede3c3$var$tempRgb[2] = light[2] * slot.color.b * attColor.b;
                        slot.currentMesh.tint = (0, $db31fc3dfae4939b$exports).rgb2hex($c67a865880ede3c3$var$tempRgb);
                    }
                    slot.currentMesh.blendMode = slot.blendMode;
                    if (!slot.hackRegion) this.setMeshRegion(attachment, slot.currentMesh, region);
                    break;
                case (0, $4b0ad7d1400b5e69$export$86cfdc1f02eaf37a).Clipping:
                    if (!slot.currentGraphics) {
                        this.createGraphics(slot, attachment);
                        slotContainer.addChild(slot.clippingContainer);
                        slotContainer.addChild(slot.currentGraphics);
                    }
                    this.updateGraphics(slot, attachment);
                    slotContainer.alpha = 1;
                    slotContainer.visible = true;
                    continue;
                default:
                    slotContainer.visible = false;
                    continue;
            }
            slotContainer.visible = true;
            if (spriteColor) {
                let r0 = slot.color.r * attColor.r;
                let g0 = slot.color.g * attColor.g;
                let b0 = slot.color.b * attColor.b;
                spriteColor.setLight(light[0] * r0 + dark[0] * (1 - r0), light[1] * g0 + dark[1] * (1 - g0), light[2] * b0 + dark[2] * (1 - b0));
                if (slot.darkColor) {
                    r0 = slot.darkColor.r;
                    g0 = slot.darkColor.g;
                    b0 = slot.darkColor.b;
                } else {
                    r0 = 0;
                    g0 = 0;
                    b0 = 0;
                }
                spriteColor.setDark(light[0] * r0 + dark[0] * (1 - r0), light[1] * g0 + dark[1] * (1 - g0), light[2] * b0 + dark[2] * (1 - b0));
            }
            slotContainer.alpha = slot.color.a;
        }
        const drawOrder = this.skeleton.drawOrder;
        let clippingAttachment = null;
        let clippingContainer = null;
        for(let i = 0, n = drawOrder.length; i < n; i++){
            const slot = slots[drawOrder[i].data.index];
            const slotContainer = this.slotContainers[drawOrder[i].data.index];
            if (!clippingContainer) {
                if (slotContainer.parent !== null && slotContainer.parent !== this) {
                    slotContainer.parent.removeChild(slotContainer);
                    slotContainer.parent = this;
                }
            }
            if (slot.currentGraphics && slot.getAttachment()) {
                clippingContainer = slot.clippingContainer;
                clippingAttachment = slot.getAttachment();
                clippingContainer.children.length = 0;
                this.children[i] = slotContainer;
                if (clippingAttachment.endSlot === slot.data) clippingAttachment.endSlot = null;
            } else if (clippingContainer) {
                let c = this.tempClipContainers[i];
                if (!c) {
                    c = this.tempClipContainers[i] = this.newContainer();
                    c.visible = false;
                }
                this.children[i] = c;
                slotContainer.parent = null;
                clippingContainer.addChild(slotContainer);
                if (clippingAttachment.endSlot == slot.data) {
                    clippingContainer.renderable = true;
                    clippingContainer = null;
                    clippingAttachment = null;
                }
            } else this.children[i] = slotContainer;
        }
        this._debug?.renderDebug(this);
    }
    setSpriteRegion(attachment, sprite, region) {
        if (sprite.attachment === attachment && sprite.region === region) return;
        sprite.region = region;
        sprite.attachment = attachment;
        sprite.texture = region.texture;
        sprite.rotation = attachment.rotation * (0, $8804784813ffae81$export$6a7ef315a0d1ef07).degRad;
        sprite.position.x = attachment.x;
        sprite.position.y = attachment.y;
        sprite.alpha = attachment.color.a;
        if (!region.size) {
            sprite.scale.x = attachment.scaleX * attachment.width / region.originalWidth;
            sprite.scale.y = -attachment.scaleY * attachment.height / region.originalHeight;
        } else {
            sprite.scale.x = region.size.width / region.originalWidth;
            sprite.scale.y = -region.size.height / region.originalHeight;
        }
    }
    setMeshRegion(attachment, mesh, region) {
        if (mesh.attachment === attachment && mesh.region === region) return;
        mesh.region = region;
        mesh.attachment = attachment;
        mesh.texture = region.texture;
        region.texture.updateUvs();
        mesh.uvBuffer.update(attachment.regionUVs);
    }
    /**
   * When autoupdate is set to yes this function is used as pixi's updateTransform function
   *
   * @private
   */ autoUpdateTransform() {
        if ((0, $1840f66876ded594$export$a5a6e0b888b2c992).GLOBAL_AUTO_UPDATE) {
            this.lastTime = this.lastTime || Date.now();
            const timeDelta = (Date.now() - this.lastTime) * 1e-3;
            this.lastTime = Date.now();
            this.update(timeDelta);
        } else this.lastTime = 0;
        (0, $68e6944de5989822$export$42a852a2b6b56249).prototype.updateTransform.call(this);
    }
    /**
   * Create a new sprite to be used with core.RegionAttachment
   *
   * @param slot {spine.Slot} The slot to which the attachment is parented
   * @param attachment {spine.RegionAttachment} The attachment that the sprite will represent
   * @private
   */ createSprite(slot, attachment, defName) {
        let region = attachment.region;
        if (slot.hackAttachment === attachment) region = slot.hackRegion;
        const texture = region ? region.texture : null;
        const sprite = this.newSprite(texture);
        sprite.anchor.set(0.5);
        if (region) this.setSpriteRegion(attachment, sprite, attachment.region);
        slot.sprites = slot.sprites || {};
        slot.sprites[defName] = sprite;
        return sprite;
    }
    /**
   * Creates a Strip from the spine data
   * @param slot {spine.Slot} The slot to which the attachment is parented
   * @param attachment {spine.RegionAttachment} The attachment that the sprite will represent
   * @private
   */ createMesh(slot, attachment) {
        let region = attachment.region;
        if (slot.hackAttachment === attachment) {
            region = slot.hackRegion;
            slot.hackAttachment = null;
            slot.hackRegion = null;
        }
        const strip = this.newMesh(region ? region.texture : null, new Float32Array(attachment.regionUVs.length), attachment.regionUVs, new Uint16Array(attachment.triangles), (0, $0fa4b07f86297abd$export$91100badd8469338).TRIANGLES);
        if (typeof strip._canvasPadding !== "undefined") strip._canvasPadding = 1.5;
        strip.alpha = attachment.color.a;
        strip.region = attachment.region;
        if (region) this.setMeshRegion(attachment, strip, region);
        slot.meshes = slot.meshes || {};
        slot.meshes[attachment.id] = strip;
        return strip;
    }
    // @ts-ignore
    createGraphics(slot, clip) {
        const graphics = this.newGraphics();
        const poly = new (0, $20fd44ea129d646b$export$7d31b617c820d435)([]);
        graphics.clear();
        graphics.beginFill(16777215, 1);
        graphics.drawPolygon(poly);
        graphics.renderable = false;
        slot.currentGraphics = graphics;
        slot.clippingContainer = this.newContainer();
        slot.clippingContainer.mask = slot.currentGraphics;
        return graphics;
    }
    updateGraphics(slot, clip) {
        const geom = slot.currentGraphics.geometry;
        const vertices = geom.graphicsData[0].shape.points;
        const n = clip.worldVerticesLength;
        vertices.length = n;
        clip.computeWorldVertices(slot, 0, n, vertices, 0, 2);
        geom.invalidate();
    }
    /**
   * Changes texture in attachment in specific slot.
   *
   * PIXI runtime feature, it was made to satisfy our users.
   *
   * @param slotIndex {number}
   * @param [texture = null] {PIXI.Texture} If null, take default (original) texture
   * @param [size = null] {PIXI.Point} sometimes we need new size for region attachment, you can pass 'texture.orig' there
   * @returns {boolean} Success flag
   */ hackTextureBySlotIndex(slotIndex, texture = null, size = null) {
        const slot = this.skeleton.slots[slotIndex];
        if (!slot) return false;
        const attachment = slot.getAttachment();
        let region = attachment.region;
        if (texture) {
            region = new (0, $da7c172fd45678b4$export$e7d46317c6b644d1)();
            region.texture = texture;
            region.size = size;
            slot.hackRegion = region;
            slot.hackAttachment = attachment;
        } else {
            slot.hackRegion = null;
            slot.hackAttachment = null;
        }
        if (slot.currentSprite) this.setSpriteRegion(attachment, slot.currentSprite, region);
        else if (slot.currentMesh) this.setMeshRegion(attachment, slot.currentMesh, region);
        return true;
    }
    /**
   * Changes texture in attachment in specific slot.
   *
   * PIXI runtime feature, it was made to satisfy our users.
   *
   * @param slotName {string}
   * @param [texture = null] {PIXI.Texture} If null, take default (original) texture
   * @param [size = null] {PIXI.Point} sometimes we need new size for region attachment, you can pass 'texture.orig' there
   * @returns {boolean} Success flag
   */ hackTextureBySlotName(slotName, texture = null, size = null) {
        const index = this.skeleton.findSlotIndex(slotName);
        if (index == -1) return false;
        return this.hackTextureBySlotIndex(index, texture, size);
    }
    /**
   * Changes texture of an attachment
   *
   * PIXI runtime feature, it was made to satisfy our users.
   *
   * @param slotName {string}
   * @param attachmentName {string}
   * @param [texture = null] {PIXI.Texture} If null, take default (original) texture
   * @param [size = null] {PIXI.Point} sometimes we need new size for region attachment, you can pass 'texture.orig' there
   * @returns {boolean} Success flag
   */ hackTextureAttachment(slotName, attachmentName, texture, size = null) {
        const slotIndex = this.skeleton.findSlotIndex(slotName);
        const attachment = this.skeleton.getAttachmentByName(slotName, attachmentName);
        attachment.region.texture = texture;
        const slot = this.skeleton.slots[slotIndex];
        if (!slot) return false;
        const currentAttachment = slot.getAttachment();
        if (attachmentName === currentAttachment.name) {
            let region = attachment.region;
            if (texture) {
                region = new (0, $da7c172fd45678b4$export$e7d46317c6b644d1)();
                region.texture = texture;
                region.size = size;
                slot.hackRegion = region;
                slot.hackAttachment = currentAttachment;
            } else {
                slot.hackRegion = null;
                slot.hackAttachment = null;
            }
            if (slot.currentSprite && slot.currentSprite.region != region) {
                this.setSpriteRegion(currentAttachment, slot.currentSprite, region);
                slot.currentSprite.region = region;
            } else if (slot.currentMesh && slot.currentMesh.region != region) this.setMeshRegion(currentAttachment, slot.currentMesh, region);
            return true;
        }
        return false;
    }
    // those methods can be overriden to spawn different classes
    newContainer() {
        return new (0, $68e6944de5989822$export$42a852a2b6b56249)();
    }
    newSprite(tex) {
        return new $c67a865880ede3c3$export$46dc8ebfc84ff722(tex);
    }
    newGraphics() {
        return new (0, $48ce8a7de6645907$export$29d3e417456abdad)();
    }
    newMesh(texture, vertices, uvs, indices, drawMode) {
        return new $c67a865880ede3c3$export$37a64c87f11cff18(texture, vertices, uvs, indices, drawMode);
    }
    transformHack() {
        return 1;
    }
    /**
   * Hack for pixi-display and pixi-lights. Every attachment name ending with a suffix will be added to different layer
   * @param nameSuffix
   * @param group
   * @param outGroup
   */ hackAttachmentGroups(nameSuffix, group, outGroup) {
        if (!nameSuffix) return void 0;
        const list_d = [];
        const list_n = [];
        for(let i = 0, len = this.skeleton.slots.length; i < len; i++){
            const slot = this.skeleton.slots[i];
            const name = slot.currentSpriteName || slot.currentMeshName || "";
            const target = slot.currentSprite || slot.currentMesh;
            if (name.endsWith(nameSuffix)) {
                target.parentGroup = group;
                list_n.push(target);
            } else if (outGroup && target) {
                target.parentGroup = outGroup;
                list_d.push(target);
            }
        }
        return [
            list_d,
            list_n
        ];
    }
    destroy(options) {
        this.debug = null;
        for(let i = 0, n = this.skeleton.slots.length; i < n; i++){
            const slot = this.skeleton.slots[i];
            for(const name in slot.meshes)slot.meshes[name].destroy(options);
            slot.meshes = null;
            for(const name in slot.sprites)slot.sprites[name].destroy(options);
            slot.sprites = null;
        }
        for(let i = 0, n = this.slotContainers.length; i < n; i++)this.slotContainers[i].destroy(options);
        this.spineData = null;
        this.skeleton = null;
        this.slotContainers = null;
        this.stateData = null;
        this.state = null;
        this.tempClipContainers = null;
        super.destroy(options);
    }
};
let $c67a865880ede3c3$export$4093f9922f3d2512 = $c67a865880ede3c3$var$_SpineBase;
$c67a865880ede3c3$export$4093f9922f3d2512.clippingPolygon = [];
Object.defineProperty($c67a865880ede3c3$export$4093f9922f3d2512.prototype, "visible", {
    get () {
        return this._visible;
    },
    set (value) {
        if (value !== this._visible) {
            this._visible = value;
            if (value) this.lastTime = 0;
        }
    }
});






class $1b2ed3b4b3f5031d$export$e5d479851d866fc2 {
    constructor(){
        this.registeredSpines = /* @__PURE__ */ new Map();
        this.drawDebug = true;
        this.drawMeshHull = true;
        this.drawMeshTriangles = true;
        this.drawBones = true;
        this.drawPaths = true;
        this.drawBoundingBoxes = true;
        this.drawClipping = true;
        this.drawRegionAttachments = true;
        this.lineWidth = 1;
        this.regionAttachmentsColor = 30975;
        this.meshHullColor = 30975;
        this.meshTrianglesColor = 16763904;
        this.clippingPolygonColor = 16711935;
        this.boundingBoxesRectColor = 65280;
        this.boundingBoxesPolygonColor = 65280;
        this.boundingBoxesCircleColor = 65280;
        this.pathsCurveColor = 16711680;
        this.pathsLineColor = 16711935;
        this.skeletonXYColor = 16711680;
        this.bonesColor = 61132;
    }
    /**
   * The debug is attached by force to each spine object. So we need to create it inside the spine when we get the first update
   */ registerSpine(spine) {
        if (this.registeredSpines.has(spine)) console.warn("SpineDebugRenderer.registerSpine() - this spine is already registered!", spine);
        const debugDisplayObjects = {
            parentDebugContainer: new (0, $68e6944de5989822$export$42a852a2b6b56249)(),
            bones: new (0, $68e6944de5989822$export$42a852a2b6b56249)(),
            skeletonXY: new (0, $48ce8a7de6645907$export$29d3e417456abdad)(),
            regionAttachmentsShape: new (0, $48ce8a7de6645907$export$29d3e417456abdad)(),
            meshTrianglesLine: new (0, $48ce8a7de6645907$export$29d3e417456abdad)(),
            meshHullLine: new (0, $48ce8a7de6645907$export$29d3e417456abdad)(),
            clippingPolygon: new (0, $48ce8a7de6645907$export$29d3e417456abdad)(),
            boundingBoxesRect: new (0, $48ce8a7de6645907$export$29d3e417456abdad)(),
            boundingBoxesCircle: new (0, $48ce8a7de6645907$export$29d3e417456abdad)(),
            boundingBoxesPolygon: new (0, $48ce8a7de6645907$export$29d3e417456abdad)(),
            pathsCurve: new (0, $48ce8a7de6645907$export$29d3e417456abdad)(),
            pathsLine: new (0, $48ce8a7de6645907$export$29d3e417456abdad)()
        };
        debugDisplayObjects.parentDebugContainer.addChild(debugDisplayObjects.bones);
        debugDisplayObjects.parentDebugContainer.addChild(debugDisplayObjects.skeletonXY);
        debugDisplayObjects.parentDebugContainer.addChild(debugDisplayObjects.regionAttachmentsShape);
        debugDisplayObjects.parentDebugContainer.addChild(debugDisplayObjects.meshTrianglesLine);
        debugDisplayObjects.parentDebugContainer.addChild(debugDisplayObjects.meshHullLine);
        debugDisplayObjects.parentDebugContainer.addChild(debugDisplayObjects.clippingPolygon);
        debugDisplayObjects.parentDebugContainer.addChild(debugDisplayObjects.boundingBoxesRect);
        debugDisplayObjects.parentDebugContainer.addChild(debugDisplayObjects.boundingBoxesCircle);
        debugDisplayObjects.parentDebugContainer.addChild(debugDisplayObjects.boundingBoxesPolygon);
        debugDisplayObjects.parentDebugContainer.addChild(debugDisplayObjects.pathsCurve);
        debugDisplayObjects.parentDebugContainer.addChild(debugDisplayObjects.pathsLine);
        spine.addChild(debugDisplayObjects.parentDebugContainer);
        this.registeredSpines.set(spine, debugDisplayObjects);
    }
    renderDebug(spine) {
        if (!this.registeredSpines.has(spine)) this.registerSpine(spine);
        const debugDisplayObjects = this.registeredSpines.get(spine);
        debugDisplayObjects.skeletonXY.clear();
        debugDisplayObjects.regionAttachmentsShape.clear();
        debugDisplayObjects.meshTrianglesLine.clear();
        debugDisplayObjects.meshHullLine.clear();
        debugDisplayObjects.clippingPolygon.clear();
        debugDisplayObjects.boundingBoxesRect.clear();
        debugDisplayObjects.boundingBoxesCircle.clear();
        debugDisplayObjects.boundingBoxesPolygon.clear();
        debugDisplayObjects.pathsCurve.clear();
        debugDisplayObjects.pathsLine.clear();
        for(let len = debugDisplayObjects.bones.children.length; len > 0; len--)debugDisplayObjects.bones.children[len - 1].destroy({
            children: true,
            texture: true,
            baseTexture: true
        });
        const scale = spine.scale.x || spine.scale.y || 1;
        const lineWidth = this.lineWidth / scale;
        if (this.drawBones) this.drawBonesFunc(spine, debugDisplayObjects, lineWidth, scale);
        if (this.drawPaths) this.drawPathsFunc(spine, debugDisplayObjects, lineWidth);
        if (this.drawBoundingBoxes) this.drawBoundingBoxesFunc(spine, debugDisplayObjects, lineWidth);
        if (this.drawClipping) this.drawClippingFunc(spine, debugDisplayObjects, lineWidth);
        if (this.drawMeshHull || this.drawMeshTriangles) this.drawMeshHullAndMeshTriangles(spine, debugDisplayObjects, lineWidth);
        if (this.drawRegionAttachments) this.drawRegionAttachmentsFunc(spine, debugDisplayObjects, lineWidth);
    }
    drawBonesFunc(spine, debugDisplayObjects, lineWidth, scale) {
        const skeleton = spine.skeleton;
        const skeletonX = skeleton.x;
        const skeletonY = skeleton.y;
        const bones = skeleton.bones;
        debugDisplayObjects.skeletonXY.lineStyle(lineWidth, this.skeletonXYColor, 1);
        for(let i = 0, len = bones.length; i < len; i++){
            const bone = bones[i];
            const boneLen = bone.data.length;
            const starX = skeletonX + bone.matrix.tx;
            const starY = skeletonY + bone.matrix.ty;
            const endX = skeletonX + boneLen * bone.matrix.a + bone.matrix.tx;
            const endY = skeletonY + boneLen * bone.matrix.b + bone.matrix.ty;
            if (bone.data.name === "root" || bone.data.parent === null) continue;
            const w = Math.abs(starX - endX);
            const h = Math.abs(starY - endY);
            const a2 = Math.pow(w, 2);
            const b = h;
            const b2 = Math.pow(h, 2);
            const c = Math.sqrt(a2 + b2);
            const c2 = Math.pow(c, 2);
            const rad = Math.PI / 180;
            const B = Math.acos((c2 + b2 - a2) / (2 * b * c)) || 0;
            if (c === 0) continue;
            const gp = new (0, $48ce8a7de6645907$export$29d3e417456abdad)();
            debugDisplayObjects.bones.addChild(gp);
            const refRation = c / 50 / scale;
            gp.beginFill(this.bonesColor, 1);
            gp.drawPolygon(0, 0, 0 - refRation, c - refRation * 3, 0, c - refRation, 0 + refRation, c - refRation * 3);
            gp.endFill();
            gp.x = starX;
            gp.y = starY;
            gp.pivot.y = c;
            let rotation = 0;
            if (starX < endX && starY < endY) rotation = -B + 180 * rad;
            else if (starX > endX && starY < endY) rotation = 180 * rad + B;
            else if (starX > endX && starY > endY) rotation = -B;
            else if (starX < endX && starY > endY) rotation = B;
            else if (starY === endY && starX < endX) rotation = 90 * rad;
            else if (starY === endY && starX > endX) rotation = -90 * rad;
            else if (starX === endX && starY < endY) rotation = 180 * rad;
            else if (starX === endX && starY > endY) rotation = 0;
            gp.rotation = rotation;
            gp.lineStyle(lineWidth + refRation / 2.4, this.bonesColor, 1);
            gp.beginFill(0, 0.6);
            gp.drawCircle(0, c, refRation * 1.2);
            gp.endFill();
        }
        const startDotSize = lineWidth * 3;
        debugDisplayObjects.skeletonXY.moveTo(skeletonX - startDotSize, skeletonY - startDotSize);
        debugDisplayObjects.skeletonXY.lineTo(skeletonX + startDotSize, skeletonY + startDotSize);
        debugDisplayObjects.skeletonXY.moveTo(skeletonX + startDotSize, skeletonY - startDotSize);
        debugDisplayObjects.skeletonXY.lineTo(skeletonX - startDotSize, skeletonY + startDotSize);
    }
    drawRegionAttachmentsFunc(spine, debugDisplayObjects, lineWidth) {
        const skeleton = spine.skeleton;
        const slots = skeleton.slots;
        debugDisplayObjects.regionAttachmentsShape.lineStyle(lineWidth, this.regionAttachmentsColor, 1);
        for(let i = 0, len = slots.length; i < len; i++){
            const slot = slots[i];
            const attachment = slot.getAttachment();
            if (attachment == null || attachment.type !== (0, $4b0ad7d1400b5e69$export$86cfdc1f02eaf37a).Region) continue;
            const regionAttachment = attachment;
            const vertices = new Float32Array(8);
            if (regionAttachment.updateOffset) regionAttachment.updateOffset();
            regionAttachment.computeWorldVertices(slot, vertices, 0, 2);
            debugDisplayObjects.regionAttachmentsShape.drawPolygon(Array.from(vertices.slice(0, 8)));
        }
    }
    drawMeshHullAndMeshTriangles(spine, debugDisplayObjects, lineWidth) {
        const skeleton = spine.skeleton;
        const slots = skeleton.slots;
        debugDisplayObjects.meshHullLine.lineStyle(lineWidth, this.meshHullColor, 1);
        debugDisplayObjects.meshTrianglesLine.lineStyle(lineWidth, this.meshTrianglesColor, 1);
        for(let i = 0, len = slots.length; i < len; i++){
            const slot = slots[i];
            if (!slot.bone.active) continue;
            const attachment = slot.getAttachment();
            if (attachment == null || attachment.type !== (0, $4b0ad7d1400b5e69$export$86cfdc1f02eaf37a).Mesh) continue;
            const meshAttachment = attachment;
            const vertices = new Float32Array(meshAttachment.worldVerticesLength);
            const triangles = meshAttachment.triangles;
            let hullLength = meshAttachment.hullLength;
            meshAttachment.computeWorldVertices(slot, 0, meshAttachment.worldVerticesLength, vertices, 0, 2);
            if (this.drawMeshTriangles) for(let i2 = 0, len2 = triangles.length; i2 < len2; i2 += 3){
                const v1 = triangles[i2] * 2;
                const v2 = triangles[i2 + 1] * 2;
                const v3 = triangles[i2 + 2] * 2;
                debugDisplayObjects.meshTrianglesLine.moveTo(vertices[v1], vertices[v1 + 1]);
                debugDisplayObjects.meshTrianglesLine.lineTo(vertices[v2], vertices[v2 + 1]);
                debugDisplayObjects.meshTrianglesLine.lineTo(vertices[v3], vertices[v3 + 1]);
            }
            if (this.drawMeshHull && hullLength > 0) {
                hullLength = (hullLength >> 1) * 2;
                let lastX = vertices[hullLength - 2];
                let lastY = vertices[hullLength - 1];
                for(let i2 = 0, len2 = hullLength; i2 < len2; i2 += 2){
                    const x = vertices[i2];
                    const y = vertices[i2 + 1];
                    debugDisplayObjects.meshHullLine.moveTo(x, y);
                    debugDisplayObjects.meshHullLine.lineTo(lastX, lastY);
                    lastX = x;
                    lastY = y;
                }
            }
        }
    }
    drawClippingFunc(spine, debugDisplayObjects, lineWidth) {
        const skeleton = spine.skeleton;
        const slots = skeleton.slots;
        debugDisplayObjects.clippingPolygon.lineStyle(lineWidth, this.clippingPolygonColor, 1);
        for(let i = 0, len = slots.length; i < len; i++){
            const slot = slots[i];
            if (!slot.bone.active) continue;
            const attachment = slot.getAttachment();
            if (attachment == null || attachment.type !== (0, $4b0ad7d1400b5e69$export$86cfdc1f02eaf37a).Clipping) continue;
            const clippingAttachment = attachment;
            const nn = clippingAttachment.worldVerticesLength;
            const world = new Float32Array(nn);
            clippingAttachment.computeWorldVertices(slot, 0, nn, world, 0, 2);
            debugDisplayObjects.clippingPolygon.drawPolygon(Array.from(world));
        }
    }
    drawBoundingBoxesFunc(spine, debugDisplayObjects, lineWidth) {
        debugDisplayObjects.boundingBoxesRect.lineStyle(lineWidth, this.boundingBoxesRectColor, 5);
        const bounds = new (0, $f207f4fe652f3622$export$a40a4b6b6d62719b)();
        bounds.update(spine.skeleton, true);
        debugDisplayObjects.boundingBoxesRect.drawRect(bounds.minX, bounds.minY, bounds.getWidth(), bounds.getHeight());
        const polygons = bounds.polygons;
        const drawPolygon = (polygonVertices, _offset, count)=>{
            debugDisplayObjects.boundingBoxesPolygon.lineStyle(lineWidth, this.boundingBoxesPolygonColor, 1);
            debugDisplayObjects.boundingBoxesPolygon.beginFill(this.boundingBoxesPolygonColor, 0.1);
            if (count < 3) throw new Error("Polygon must contain at least 3 vertices");
            const paths = [];
            const dotSize = lineWidth * 2;
            for(let i = 0, len = polygonVertices.length; i < len; i += 2){
                const x1 = polygonVertices[i];
                const y1 = polygonVertices[i + 1];
                debugDisplayObjects.boundingBoxesCircle.lineStyle(0);
                debugDisplayObjects.boundingBoxesCircle.beginFill(this.boundingBoxesCircleColor);
                debugDisplayObjects.boundingBoxesCircle.drawCircle(x1, y1, dotSize);
                debugDisplayObjects.boundingBoxesCircle.endFill();
                paths.push(x1, y1);
            }
            debugDisplayObjects.boundingBoxesPolygon.drawPolygon(paths);
            debugDisplayObjects.boundingBoxesPolygon.endFill();
        };
        for(let i = 0, len = polygons.length; i < len; i++){
            const polygon = polygons[i];
            drawPolygon(polygon, 0, polygon.length);
        }
    }
    drawPathsFunc(spine, debugDisplayObjects, lineWidth) {
        const skeleton = spine.skeleton;
        const slots = skeleton.slots;
        debugDisplayObjects.pathsCurve.lineStyle(lineWidth, this.pathsCurveColor, 1);
        debugDisplayObjects.pathsLine.lineStyle(lineWidth, this.pathsLineColor, 1);
        for(let i = 0, len = slots.length; i < len; i++){
            const slot = slots[i];
            if (!slot.bone.active) continue;
            const attachment = slot.getAttachment();
            if (attachment == null || attachment.type !== (0, $4b0ad7d1400b5e69$export$86cfdc1f02eaf37a).Path) continue;
            const pathAttachment = attachment;
            let nn = pathAttachment.worldVerticesLength;
            const world = new Float32Array(nn);
            pathAttachment.computeWorldVertices(slot, 0, nn, world, 0, 2);
            let x1 = world[2];
            let y1 = world[3];
            let x2 = 0;
            let y2 = 0;
            if (pathAttachment.closed) {
                const cx1 = world[0];
                const cy1 = world[1];
                const cx2 = world[nn - 2];
                const cy2 = world[nn - 1];
                x2 = world[nn - 4];
                y2 = world[nn - 3];
                debugDisplayObjects.pathsCurve.moveTo(x1, y1);
                debugDisplayObjects.pathsCurve.bezierCurveTo(cx1, cy1, cx2, cy2, x2, y2);
                debugDisplayObjects.pathsLine.moveTo(x1, y1);
                debugDisplayObjects.pathsLine.lineTo(cx1, cy1);
                debugDisplayObjects.pathsLine.moveTo(x2, y2);
                debugDisplayObjects.pathsLine.lineTo(cx2, cy2);
            }
            nn -= 4;
            for(let ii = 4; ii < nn; ii += 6){
                const cx1 = world[ii];
                const cy1 = world[ii + 1];
                const cx2 = world[ii + 2];
                const cy2 = world[ii + 3];
                x2 = world[ii + 4];
                y2 = world[ii + 5];
                debugDisplayObjects.pathsCurve.moveTo(x1, y1);
                debugDisplayObjects.pathsCurve.bezierCurveTo(cx1, cy1, cx2, cy2, x2, y2);
                debugDisplayObjects.pathsLine.moveTo(x1, y1);
                debugDisplayObjects.pathsLine.lineTo(cx1, cy1);
                debugDisplayObjects.pathsLine.moveTo(x2, y2);
                debugDisplayObjects.pathsLine.lineTo(cx2, cy2);
                x1 = x2;
                y1 = y2;
            }
        }
    }
    unregisterSpine(spine) {
        if (!this.registeredSpines.has(spine)) console.warn("SpineDebugRenderer.unregisterSpine() - spine is not registered, can't unregister!", spine);
        const debugDisplayObjects = this.registeredSpines.get(spine);
        debugDisplayObjects.parentDebugContainer.destroy({
            baseTexture: true,
            children: true,
            texture: true
        });
        this.registeredSpines.delete(spine);
    }
}




class $9892e6452670f32b$export$71e4db985cfcf9e3 {
    constructor(name){
        if (!name) throw new Error("name cannot be null.");
        this.name = name;
    }
}
const $9892e6452670f32b$var$_VertexAttachment = class extends $9892e6452670f32b$export$71e4db985cfcf9e3 {
    constructor(name){
        super(name);
        /** The unique ID for this attachment. */ this.id = $9892e6452670f32b$var$_VertexAttachment.nextID++;
        /** The bones which affect the {@link #getVertices()}. The array entries are, for each vertex, the number of bones affecting
     * the vertex followed by that many bone indices, which is the index of the bone in {@link Skeleton#bones}. Will be null
     * if this attachment has no weights. */ this.bones = null;
        /** The vertex positions in the bone's coordinate system. For a non-weighted attachment, the values are `x,y`
     * entries for each vertex. For a weighted attachment, the values are `x,y,weight` entries for each bone affecting
     * each vertex. */ this.vertices = [];
        /** The maximum number of world vertex values that can be output by
     * {@link #computeWorldVertices()} using the `count` parameter. */ this.worldVerticesLength = 0;
        /** Timelines for the timeline attachment are also applied to this attachment.
     * May be null if no attachment-specific timelines should be applied. */ this.timelineAttachment = this;
    }
    computeWorldVerticesOld(slot, worldVertices) {
        this.computeWorldVertices(slot, 0, this.worldVerticesLength, worldVertices, 0, 2);
    }
    /** Transforms the attachment's local {@link #vertices} to world coordinates. If the slot's {@link Slot#deform} is
   * not empty, it is used to deform the vertices.
   *
   * See [World transforms](http://esotericsoftware.com/spine-runtime-skeletons#World-transforms) in the Spine
   * Runtimes Guide.
   * @param start The index of the first {@link #vertices} value to transform. Each vertex has 2 values, x and y.
   * @param count The number of world vertex values to output. Must be <= {@link #worldVerticesLength} - `start`.
   * @param worldVertices The output world vertices. Must have a length >= `offset` + `count` *
   *           `stride` / 2.
   * @param offset The `worldVertices` index to begin writing values.
   * @param stride The number of `worldVertices` entries between the value pairs written. */ computeWorldVertices(slot, start, count, worldVertices, offset, stride) {
        count = offset + (count >> 1) * stride;
        const skeleton = slot.bone.skeleton;
        const deformArray = slot.deform;
        let vertices = this.vertices;
        const bones = this.bones;
        if (!bones) {
            if (deformArray.length > 0) vertices = deformArray;
            const mat = slot.bone.matrix;
            const x = mat.tx;
            const y = mat.ty;
            const a = mat.a;
            const b = mat.c;
            const c = mat.b;
            const d = mat.d;
            for(let v2 = start, w = offset; w < count; v2 += 2, w += stride){
                const vx = vertices[v2];
                const vy = vertices[v2 + 1];
                worldVertices[w] = vx * a + vy * b + x;
                worldVertices[w + 1] = vx * c + vy * d + y;
            }
            return;
        }
        let v = 0;
        let skip = 0;
        for(let i = 0; i < start; i += 2){
            const n = bones[v];
            v += n + 1;
            skip += n;
        }
        const skeletonBones = skeleton.bones;
        if (deformArray.length == 0) for(let w = offset, b = skip * 3; w < count; w += stride){
            let wx = 0;
            let wy = 0;
            let n = bones[v++];
            n += v;
            for(; v < n; v++, b += 3){
                const mat = skeletonBones[bones[v]].matrix;
                const vx = vertices[b];
                const vy = vertices[b + 1];
                const weight = vertices[b + 2];
                wx += (vx * mat.a + vy * mat.c + mat.tx) * weight;
                wy += (vx * mat.b + vy * mat.d + mat.ty) * weight;
            }
            worldVertices[w] = wx;
            worldVertices[w + 1] = wy;
        }
        else {
            const deform = deformArray;
            for(let w = offset, b = skip * 3, f = skip << 1; w < count; w += stride){
                let wx = 0;
                let wy = 0;
                let n = bones[v++];
                n += v;
                for(; v < n; v++, b += 3, f += 2){
                    const mat = skeletonBones[bones[v]].matrix;
                    const vx = vertices[b] + deform[f];
                    const vy = vertices[b + 1] + deform[f + 1];
                    const weight = vertices[b + 2];
                    wx += (vx * mat.a + vy * mat.c + mat.tx) * weight;
                    wy += (vx * mat.b + vy * mat.d + mat.ty) * weight;
                }
                worldVertices[w] = wx;
                worldVertices[w + 1] = wy;
            }
        }
    }
    /** Does not copy id (generated) or name (set on construction). **/ copyTo(attachment) {
        if (this.bones) {
            attachment.bones = new Array(this.bones.length);
            (0, $8804784813ffae81$export$d2ca453b913dcdea).arrayCopy(this.bones, 0, attachment.bones, 0, this.bones.length);
        } else attachment.bones = null;
        if (this.vertices) {
            attachment.vertices = (0, $8804784813ffae81$export$d2ca453b913dcdea).newFloatArray(this.vertices.length);
            (0, $8804784813ffae81$export$d2ca453b913dcdea).arrayCopy(this.vertices, 0, attachment.vertices, 0, this.vertices.length);
        }
        attachment.worldVerticesLength = this.worldVerticesLength;
        attachment.timelineAttachment = this.timelineAttachment;
    }
};
let $9892e6452670f32b$export$66d3a0c3be55e044 = $9892e6452670f32b$var$_VertexAttachment;
$9892e6452670f32b$export$66d3a0c3be55e044.nextID = 0;




class $63a6fc6d003ab8b1$export$9538c439c6b85ad2 extends (0, $9892e6452670f32b$export$66d3a0c3be55e044) {
    constructor(name){
        super(name);
        this.type = (0, $4b0ad7d1400b5e69$export$86cfdc1f02eaf37a).BoundingBox;
        this.color = new (0, $8804784813ffae81$export$892596cec99bc70e)(1, 1, 1, 1);
    }
    copy() {
        const copy = new $63a6fc6d003ab8b1$export$9538c439c6b85ad2(this.name);
        this.copyTo(copy);
        copy.color.setFromColor(this.color);
        return copy;
    }
}




class $faf5f501ea017e7d$export$838805e22b9b55f1 extends (0, $9892e6452670f32b$export$66d3a0c3be55e044) {
    // ce3a3aff
    constructor(name){
        super(name);
        this.type = (0, $4b0ad7d1400b5e69$export$86cfdc1f02eaf37a).Clipping;
        /** Clipping is performed between the clipping polygon's slot and the end slot. Returns null if clipping is done until the end of
     * the skeleton's rendering. */ this.endSlot = null;
        // Nonessential.
        /** The color of the clipping polygon as it was in Spine. Available only when nonessential data was exported. Clipping polygons
     * are not usually rendered at runtime. */ this.color = new (0, $8804784813ffae81$export$892596cec99bc70e)(0.2275, 0.2275, 0.8078, 1);
    }
    copy() {
        const copy = new $faf5f501ea017e7d$export$838805e22b9b55f1(this.name);
        this.copyTo(copy);
        copy.endSlot = this.endSlot;
        copy.color.setFromColor(this.color);
        return copy;
    }
}




class $2085f04ed3d5f336$export$3f1c1692adfcf3e2 extends (0, $9892e6452670f32b$export$66d3a0c3be55e044) {
    constructor(name, path){
        super(name);
        this.type = (0, $4b0ad7d1400b5e69$export$86cfdc1f02eaf37a).Mesh;
        this.region = null;
        /** Triplets of vertex indices which describe the mesh's triangulation. */ this.triangles = [];
        /** The color to tint the mesh. */ this.color = new (0, $8804784813ffae81$export$892596cec99bc70e)(1, 1, 1, 1);
        /** The width of the mesh's image. Available only when nonessential data was exported. */ this.width = 0;
        /** The height of the mesh's image. Available only when nonessential data was exported. */ this.height = 0;
        /** The number of entries at the beginning of {@link #vertices} that make up the mesh hull. */ this.hullLength = 0;
        /** Vertex index pairs describing edges for controling triangulation. Mesh triangles will never cross edges. Only available if
     * nonessential data was exported. Triangulation is not performed at runtime. */ this.edges = [];
        this.parentMesh = null;
        this.sequence = null;
        this.tempColor = new (0, $8804784813ffae81$export$892596cec99bc70e)(0, 0, 0, 0);
        this.path = path;
    }
    /** The parent mesh if this is a linked mesh, else null. A linked mesh shares the {@link #bones}, {@link #vertices},
   * {@link #regionUVs}, {@link #triangles}, {@link #hullLength}, {@link #edges}, {@link #width}, and {@link #height} with the
   * parent mesh, but may have a different {@link #name} or {@link #path} (and therefore a different texture). */ getParentMesh() {
        return this.parentMesh;
    }
    /** @param parentMesh May be null. */ setParentMesh(parentMesh) {
        this.parentMesh = parentMesh;
        if (parentMesh) {
            this.bones = parentMesh.bones;
            this.vertices = parentMesh.vertices;
            this.worldVerticesLength = parentMesh.worldVerticesLength;
            this.regionUVs = parentMesh.regionUVs;
            this.triangles = parentMesh.triangles;
            this.hullLength = parentMesh.hullLength;
            this.worldVerticesLength = parentMesh.worldVerticesLength;
        }
    }
    copy() {
        if (this.parentMesh) return this.newLinkedMesh();
        const copy = new $2085f04ed3d5f336$export$3f1c1692adfcf3e2(this.name, this.path);
        copy.region = this.region;
        copy.color.setFromColor(this.color);
        this.copyTo(copy);
        copy.regionUVs = new Float32Array(this.regionUVs.length);
        (0, $8804784813ffae81$export$d2ca453b913dcdea).arrayCopy(this.regionUVs, 0, copy.regionUVs, 0, this.regionUVs.length);
        copy.triangles = new Array(this.triangles.length);
        (0, $8804784813ffae81$export$d2ca453b913dcdea).arrayCopy(this.triangles, 0, copy.triangles, 0, this.triangles.length);
        copy.hullLength = this.hullLength;
        copy.sequence = this.sequence != null ? this.sequence.copy() : null;
        if (this.edges) {
            copy.edges = new Array(this.edges.length);
            (0, $8804784813ffae81$export$d2ca453b913dcdea).arrayCopy(this.edges, 0, copy.edges, 0, this.edges.length);
        }
        copy.width = this.width;
        copy.height = this.height;
        return copy;
    }
    computeWorldVertices(slot, start, count, worldVertices, offset, stride) {
        if (this.sequence != null) this.sequence.apply(slot, this);
        super.computeWorldVertices(slot, start, count, worldVertices, offset, stride);
    }
    /** Returns a new mesh with the {@link #parentMesh} set to this mesh's parent mesh, if any, else to this mesh. **/ newLinkedMesh() {
        const copy = new $2085f04ed3d5f336$export$3f1c1692adfcf3e2(this.name, this.path);
        copy.region = this.region;
        copy.color.setFromColor(this.color);
        copy.timelineAttachment = this.timelineAttachment;
        copy.setParentMesh(this.parentMesh ? this.parentMesh : this);
        return copy;
    }
}




class $7aafbf7cd242ca5e$export$d285e3ec07b32800 extends (0, $9892e6452670f32b$export$66d3a0c3be55e044) {
    constructor(name){
        super(name);
        this.type = (0, $4b0ad7d1400b5e69$export$86cfdc1f02eaf37a).Path;
        /** The lengths along the path in the setup pose from the start of the path to the end of each Bezier curve. */ this.lengths = [];
        /** If true, the start and end knots are connected. */ this.closed = false;
        /** If true, additional calculations are performed to make calculating positions along the path more accurate. If false, fewer
     * calculations are performed but calculating positions along the path is less accurate. */ this.constantSpeed = false;
        /** The color of the path as it was in Spine. Available only when nonessential data was exported. Paths are not usually
     * rendered at runtime. */ this.color = new (0, $8804784813ffae81$export$892596cec99bc70e)(1, 1, 1, 1);
    }
    copy() {
        const copy = new $7aafbf7cd242ca5e$export$d285e3ec07b32800(this.name);
        this.copyTo(copy);
        copy.lengths = new Array(this.lengths.length);
        (0, $8804784813ffae81$export$d2ca453b913dcdea).arrayCopy(this.lengths, 0, copy.lengths, 0, this.lengths.length);
        copy.closed = closed;
        copy.constantSpeed = this.constantSpeed;
        copy.color.setFromColor(this.color);
        return copy;
    }
}




class $ec38bb05db75a9af$export$1b528cde44a6ab5 extends (0, $9892e6452670f32b$export$66d3a0c3be55e044) {
    constructor(name){
        super(name);
        this.type = (0, $4b0ad7d1400b5e69$export$86cfdc1f02eaf37a).Point;
        this.x = 0;
        this.y = 0;
        this.rotation = 0;
        /** The color of the point attachment as it was in Spine. Available only when nonessential data was exported. Point attachments
     * are not usually rendered at runtime. */ this.color = new (0, $8804784813ffae81$export$892596cec99bc70e)(0.38, 0.94, 0, 1);
    }
    computeWorldPosition(bone, point) {
        const mat = bone.matrix;
        point.x = this.x * mat.a + this.y * mat.c + bone.worldX;
        point.y = this.x * mat.b + this.y * mat.d + bone.worldY;
        return point;
    }
    computeWorldRotation(bone) {
        const mat = bone.matrix;
        const cos = (0, $8804784813ffae81$export$6a7ef315a0d1ef07).cosDeg(this.rotation);
        const sin = (0, $8804784813ffae81$export$6a7ef315a0d1ef07).sinDeg(this.rotation);
        const x = cos * mat.a + sin * mat.c;
        const y = cos * mat.b + sin * mat.d;
        return Math.atan2(y, x) * (0, $8804784813ffae81$export$6a7ef315a0d1ef07).radDeg;
    }
    copy() {
        const copy = new $ec38bb05db75a9af$export$1b528cde44a6ab5(this.name);
        copy.x = this.x;
        copy.y = this.y;
        copy.rotation = this.rotation;
        copy.color.setFromColor(this.color);
        return copy;
    }
}




const $47a62d8b9e0a7455$var$_RegionAttachment = class extends (0, $9892e6452670f32b$export$71e4db985cfcf9e3) {
    constructor(name, path){
        super(name);
        this.type = (0, $4b0ad7d1400b5e69$export$86cfdc1f02eaf37a).Region;
        /** The local x translation. */ this.x = 0;
        /** The local y translation. */ this.y = 0;
        /** The local scaleX. */ this.scaleX = 1;
        /** The local scaleY. */ this.scaleY = 1;
        /** The local rotation. */ this.rotation = 0;
        /** The width of the region attachment in Spine. */ this.width = 0;
        /** The height of the region attachment in Spine. */ this.height = 0;
        /** The color to tint the region attachment. */ this.color = new (0, $8804784813ffae81$export$892596cec99bc70e)(1, 1, 1, 1);
        this.rendererObject = null;
        this.region = null;
        this.sequence = null;
        /** For each of the 4 vertices, a pair of <code>x,y</code> values that is the local position of the vertex.
     *
     * See {@link #updateOffset()}. */ this.offset = (0, $8804784813ffae81$export$d2ca453b913dcdea).newFloatArray(8);
        this.uvs = (0, $8804784813ffae81$export$d2ca453b913dcdea).newFloatArray(8);
        this.tempColor = new (0, $8804784813ffae81$export$892596cec99bc70e)(1, 1, 1, 1);
        this.path = path;
    }
    /** Calculates the {@link #offset} using the region settings. Must be called after changing region settings. */ updateRegion() {
        if (!this.region) throw new Error("Region not set.");
        const region = this.region;
        const regionScaleX = this.width / this.region.originalWidth * this.scaleX;
        const regionScaleY = this.height / this.region.originalHeight * this.scaleY;
        const localX = -this.width / 2 * this.scaleX + this.region.offsetX * regionScaleX;
        const localY = -this.height / 2 * this.scaleY + this.region.offsetY * regionScaleY;
        const localX2 = localX + this.region.width * regionScaleX;
        const localY2 = localY + this.region.height * regionScaleY;
        const radians = this.rotation * Math.PI / 180;
        const cos = Math.cos(radians);
        const sin = Math.sin(radians);
        const x = this.x;
        const y = this.y;
        const localXCos = localX * cos + x;
        const localXSin = localX * sin;
        const localYCos = localY * cos + y;
        const localYSin = localY * sin;
        const localX2Cos = localX2 * cos + x;
        const localX2Sin = localX2 * sin;
        const localY2Cos = localY2 * cos + y;
        const localY2Sin = localY2 * sin;
        const offset = this.offset;
        offset[0] = localXCos - localYSin;
        offset[1] = localYCos + localXSin;
        offset[2] = localXCos - localY2Sin;
        offset[3] = localY2Cos + localXSin;
        offset[4] = localX2Cos - localY2Sin;
        offset[5] = localY2Cos + localX2Sin;
        offset[6] = localX2Cos - localYSin;
        offset[7] = localYCos + localX2Sin;
        const uvs = this.uvs;
        if (region.degrees == 90) {
            uvs[2] = region.u;
            uvs[3] = region.v2;
            uvs[4] = region.u;
            uvs[5] = region.v;
            uvs[6] = region.u2;
            uvs[7] = region.v;
            uvs[0] = region.u2;
            uvs[1] = region.v2;
        } else {
            uvs[0] = region.u;
            uvs[1] = region.v2;
            uvs[2] = region.u;
            uvs[3] = region.v;
            uvs[4] = region.u2;
            uvs[5] = region.v;
            uvs[6] = region.u2;
            uvs[7] = region.v2;
        }
    }
    /** Transforms the attachment's four vertices to world coordinates. If the attachment has a {@link #sequence}, the region may
   * be changed.
   * <p>
   * See <a href="http://esotericsoftware.com/spine-runtime-skeletons#World-transforms">World transforms</a> in the Spine
   * Runtimes Guide.
   * @param worldVertices The output world vertices. Must have a length >= <code>offset</code> + 8.
   * @param offset The <code>worldVertices</code> index to begin writing values.
   * @param stride The number of <code>worldVertices</code> entries between the value pairs written. */ computeWorldVertices(slot, worldVertices, offset, stride) {
        if (this.sequence != null) this.sequence.apply(slot, this);
        const bone = slot.bone;
        const vertexOffset = this.offset;
        const mat = bone.matrix;
        const x = mat.tx;
        const y = mat.ty;
        const a = mat.a;
        const b = mat.c;
        const c = mat.b;
        const d = mat.d;
        let offsetX = 0;
        let offsetY = 0;
        offsetX = vertexOffset[0];
        offsetY = vertexOffset[1];
        worldVertices[offset] = offsetX * a + offsetY * b + x;
        worldVertices[offset + 1] = offsetX * c + offsetY * d + y;
        offset += stride;
        offsetX = vertexOffset[2];
        offsetY = vertexOffset[3];
        worldVertices[offset] = offsetX * a + offsetY * b + x;
        worldVertices[offset + 1] = offsetX * c + offsetY * d + y;
        offset += stride;
        offsetX = vertexOffset[4];
        offsetY = vertexOffset[5];
        worldVertices[offset] = offsetX * a + offsetY * b + x;
        worldVertices[offset + 1] = offsetX * c + offsetY * d + y;
        offset += stride;
        offsetX = vertexOffset[6];
        offsetY = vertexOffset[7];
        worldVertices[offset] = offsetX * a + offsetY * b + x;
        worldVertices[offset + 1] = offsetX * c + offsetY * d + y;
    }
    copy() {
        const copy = new $47a62d8b9e0a7455$var$_RegionAttachment(this.name, this.path);
        copy.region = this.region;
        copy.rendererObject = this.rendererObject;
        copy.x = this.x;
        copy.y = this.y;
        copy.scaleX = this.scaleX;
        copy.scaleY = this.scaleY;
        copy.rotation = this.rotation;
        copy.width = this.width;
        copy.height = this.height;
        (0, $8804784813ffae81$export$d2ca453b913dcdea).arrayCopy(this.uvs, 0, copy.uvs, 0, 8);
        (0, $8804784813ffae81$export$d2ca453b913dcdea).arrayCopy(this.offset, 0, copy.offset, 0, 8);
        copy.color.setFromColor(this.color);
        copy.sequence = this.sequence != null ? this.sequence.copy() : null;
        return copy;
    }
};
let $47a62d8b9e0a7455$export$d0fc51466fa6d530 = $47a62d8b9e0a7455$var$_RegionAttachment;
$47a62d8b9e0a7455$export$d0fc51466fa6d530.X1 = 0;
$47a62d8b9e0a7455$export$d0fc51466fa6d530.Y1 = 1;
$47a62d8b9e0a7455$export$d0fc51466fa6d530.C1R = 2;
$47a62d8b9e0a7455$export$d0fc51466fa6d530.C1G = 3;
$47a62d8b9e0a7455$export$d0fc51466fa6d530.C1B = 4;
$47a62d8b9e0a7455$export$d0fc51466fa6d530.C1A = 5;
$47a62d8b9e0a7455$export$d0fc51466fa6d530.U1 = 6;
$47a62d8b9e0a7455$export$d0fc51466fa6d530.V1 = 7;
$47a62d8b9e0a7455$export$d0fc51466fa6d530.X2 = 8;
$47a62d8b9e0a7455$export$d0fc51466fa6d530.Y2 = 9;
$47a62d8b9e0a7455$export$d0fc51466fa6d530.C2R = 10;
$47a62d8b9e0a7455$export$d0fc51466fa6d530.C2G = 11;
$47a62d8b9e0a7455$export$d0fc51466fa6d530.C2B = 12;
$47a62d8b9e0a7455$export$d0fc51466fa6d530.C2A = 13;
$47a62d8b9e0a7455$export$d0fc51466fa6d530.U2 = 14;
$47a62d8b9e0a7455$export$d0fc51466fa6d530.V2 = 15;
$47a62d8b9e0a7455$export$d0fc51466fa6d530.X3 = 16;
$47a62d8b9e0a7455$export$d0fc51466fa6d530.Y3 = 17;
$47a62d8b9e0a7455$export$d0fc51466fa6d530.C3R = 18;
$47a62d8b9e0a7455$export$d0fc51466fa6d530.C3G = 19;
$47a62d8b9e0a7455$export$d0fc51466fa6d530.C3B = 20;
$47a62d8b9e0a7455$export$d0fc51466fa6d530.C3A = 21;
$47a62d8b9e0a7455$export$d0fc51466fa6d530.U3 = 22;
$47a62d8b9e0a7455$export$d0fc51466fa6d530.V3 = 23;
$47a62d8b9e0a7455$export$d0fc51466fa6d530.X4 = 24;
$47a62d8b9e0a7455$export$d0fc51466fa6d530.Y4 = 25;
$47a62d8b9e0a7455$export$d0fc51466fa6d530.C4R = 26;
$47a62d8b9e0a7455$export$d0fc51466fa6d530.C4G = 27;
$47a62d8b9e0a7455$export$d0fc51466fa6d530.C4B = 28;
$47a62d8b9e0a7455$export$d0fc51466fa6d530.C4A = 29;
$47a62d8b9e0a7455$export$d0fc51466fa6d530.U4 = 30;
$47a62d8b9e0a7455$export$d0fc51466fa6d530.V4 = 31;



const $37628ed40604134f$var$_Sequence = class {
    constructor(count){
        this.id = $37628ed40604134f$var$_Sequence.nextID();
        this.start = 0;
        this.digits = 0;
        /** The index of the region to show for the setup pose. */ this.setupIndex = 0;
        this.regions = new Array(count);
    }
    copy() {
        const copy = new $37628ed40604134f$var$_Sequence(this.regions.length);
        (0, $8804784813ffae81$export$d2ca453b913dcdea).arrayCopy(this.regions, 0, copy.regions, 0, this.regions.length);
        copy.start = this.start;
        copy.digits = this.digits;
        copy.setupIndex = this.setupIndex;
        return copy;
    }
    apply(slot, attachment) {
        let index = slot.sequenceIndex;
        if (index == -1) index = this.setupIndex;
        if (index >= this.regions.length) index = this.regions.length - 1;
        const region = this.regions[index];
        if (attachment.region != region) attachment.region = region;
    }
    getPath(basePath, index) {
        let result = basePath;
        const frame = (this.start + index).toString();
        for(let i = this.digits - frame.length; i > 0; i--)result += "0";
        result += frame;
        return result;
    }
    static nextID() {
        return $37628ed40604134f$var$_Sequence._nextID++;
    }
};
let $37628ed40604134f$export$edde1bcb1b2b310e = $37628ed40604134f$var$_Sequence;
$37628ed40604134f$export$edde1bcb1b2b310e._nextID = 0;
var $37628ed40604134f$export$2d839466c6120eb9 = /* @__PURE__ */ ((SequenceMode2)=>{
    SequenceMode2[SequenceMode2["hold"] = 0] = "hold";
    SequenceMode2[SequenceMode2["once"] = 1] = "once";
    SequenceMode2[SequenceMode2["loop"] = 2] = "loop";
    SequenceMode2[SequenceMode2["pingpong"] = 3] = "pingpong";
    SequenceMode2[SequenceMode2["onceReverse"] = 4] = "onceReverse";
    SequenceMode2[SequenceMode2["loopReverse"] = 5] = "loopReverse";
    SequenceMode2[SequenceMode2["pingpongReverse"] = 6] = "pingpongReverse";
    return SequenceMode2;
})($37628ed40604134f$export$2d839466c6120eb9 || {});
const $37628ed40604134f$export$3d518da8d966a9f5 = [
    0 /* hold */ ,
    1 /* once */ ,
    2 /* loop */ ,
    3 /* pingpong */ ,
    4 /* onceReverse */ ,
    5 /* loopReverse */ ,
    6 /* pingpongReverse */ 
];






class $fd5e2eaf5f163d40$export$c35d437ae5945fcd {
    constructor(name, timelines, duration){
        this.timelines = [];
        this.timelineIds = new (0, $8804784813ffae81$export$1a41fd2ab8394c46)();
        if (!name) throw new Error("name cannot be null.");
        this.name = name;
        this.setTimelines(timelines);
        this.duration = duration;
    }
    setTimelines(timelines) {
        if (!timelines) throw new Error("timelines cannot be null.");
        this.timelines = timelines;
        this.timelineIds.clear();
        for(let i = 0; i < timelines.length; i++)this.timelineIds.addAll(timelines[i].getPropertyIds());
    }
    hasTimeline(ids) {
        for(let i = 0; i < ids.length; i++)if (this.timelineIds.contains(ids[i])) return true;
        return false;
    }
    /** Applies all the animation's timelines to the specified skeleton.
   *
   * See Timeline {@link Timeline#apply(Skeleton, float, float, Array, float, MixBlend, MixDirection)}.
   * @param loop If true, the animation repeats after {@link #getDuration()}.
   * @param events May be null to ignore fired events. */ apply(skeleton, lastTime, time, loop, events, alpha, blend, direction) {
        if (!skeleton) throw new Error("skeleton cannot be null.");
        if (loop && this.duration != 0) {
            time %= this.duration;
            if (lastTime > 0) lastTime %= this.duration;
        }
        const timelines = this.timelines;
        for(let i = 0, n = timelines.length; i < n; i++)timelines[i].apply(skeleton, lastTime, time, events, alpha, blend, direction);
    }
}
const $fd5e2eaf5f163d40$var$Property = {
    rotate: 0,
    x: 1,
    y: 2,
    scaleX: 3,
    scaleY: 4,
    shearX: 5,
    shearY: 6,
    rgb: 7,
    alpha: 8,
    rgb2: 9,
    attachment: 10,
    deform: 11,
    event: 12,
    drawOrder: 13,
    ikConstraint: 14,
    transformConstraint: 15,
    pathConstraintPosition: 16,
    pathConstraintSpacing: 17,
    pathConstraintMix: 18,
    sequence: 19
};
class $fd5e2eaf5f163d40$export$e6a97ba2cae5bb94 {
    constructor(frameCount, propertyIds){
        this.propertyIds = propertyIds;
        this.frames = (0, $8804784813ffae81$export$d2ca453b913dcdea).newFloatArray(frameCount * this.getFrameEntries());
    }
    getPropertyIds() {
        return this.propertyIds;
    }
    getFrameEntries() {
        return 1;
    }
    getFrameCount() {
        return this.frames.length / this.getFrameEntries();
    }
    getDuration() {
        return this.frames[this.frames.length - this.getFrameEntries()];
    }
    static search1(frames, time) {
        const n = frames.length;
        for(let i = 1; i < n; i++)if (frames[i] > time) return i - 1;
        return n - 1;
    }
    static search(frames, time, step) {
        const n = frames.length;
        for(let i = step; i < n; i += step)if (frames[i] > time) return i - step;
        return n - step;
    }
}
class $fd5e2eaf5f163d40$export$4094e7414845f78f extends $fd5e2eaf5f163d40$export$e6a97ba2cae5bb94 {
    // type, x, y, ...
    constructor(frameCount, bezierCount, propertyIds){
        super(frameCount, propertyIds);
        this.curves = (0, $8804784813ffae81$export$d2ca453b913dcdea).newFloatArray(frameCount + bezierCount * 18);
        this.curves[frameCount - 1] = 1;
    }
    /** Sets the specified key frame to linear interpolation. */ setLinear(frame) {
        this.curves[frame] = 0;
    }
    /** Sets the specified key frame to stepped interpolation. */ setStepped(frame) {
        this.curves[frame] = 1;
    }
    /** Shrinks the storage for Bezier curves, for use when <code>bezierCount</code> (specified in the constructor) was larger
   * than the actual number of Bezier curves. */ shrink(bezierCount) {
        const size = this.getFrameCount() + bezierCount * 18;
        if (this.curves.length > size) {
            const newCurves = (0, $8804784813ffae81$export$d2ca453b913dcdea).newFloatArray(size);
            (0, $8804784813ffae81$export$d2ca453b913dcdea).arrayCopy(this.curves, 0, newCurves, 0, size);
            this.curves = newCurves;
        }
    }
    /** Stores the segments for the specified Bezier curve. For timelines that modify multiple values, there may be more than
   * one curve per frame.
   * @param bezier The ordinal of this Bezier curve for this timeline, between 0 and <code>bezierCount - 1</code> (specified
   *           in the constructor), inclusive.
   * @param frame Between 0 and <code>frameCount - 1</code>, inclusive.
   * @param value The index of the value for this frame that this curve is used for.
   * @param time1 The time for the first key.
   * @param value1 The value for the first key.
   * @param cx1 The time for the first Bezier handle.
   * @param cy1 The value for the first Bezier handle.
   * @param cx2 The time of the second Bezier handle.
   * @param cy2 The value for the second Bezier handle.
   * @param time2 The time for the second key.
   * @param value2 The value for the second key. */ setBezier(bezier, frame, value, time1, value1, cx1, cy1, cx2, cy2, time2, value2) {
        const curves = this.curves;
        let i = this.getFrameCount() + bezier * 18;
        if (value == 0) curves[frame] = 2 + i;
        const tmpx = (time1 - cx1 * 2 + cx2) * 0.03;
        const tmpy = (value1 - cy1 * 2 + cy2) * 0.03;
        const dddx = ((cx1 - cx2) * 3 - time1 + time2) * 6e-3;
        const dddy = ((cy1 - cy2) * 3 - value1 + value2) * 6e-3;
        let ddx = tmpx * 2 + dddx;
        let ddy = tmpy * 2 + dddy;
        let dx = (cx1 - time1) * 0.3 + tmpx + dddx * 0.16666667;
        let dy = (cy1 - value1) * 0.3 + tmpy + dddy * 0.16666667;
        let x = time1 + dx;
        let y = value1 + dy;
        for(let n = i + 18; i < n; i += 2){
            curves[i] = x;
            curves[i + 1] = y;
            dx += ddx;
            dy += ddy;
            ddx += dddx;
            ddy += dddy;
            x += dx;
            y += dy;
        }
    }
    /** Returns the Bezier interpolated value for the specified time.
   * @param frameIndex The index into {@link #getFrames()} for the values of the frame before <code>time</code>.
   * @param valueOffset The offset from <code>frameIndex</code> to the value this curve is used for.
   * @param i The index of the Bezier segments. See {@link #getCurveType(int)}. */ getBezierValue(time, frameIndex, valueOffset, i) {
        const curves = this.curves;
        if (curves[i] > time) {
            const x2 = this.frames[frameIndex];
            const y2 = this.frames[frameIndex + valueOffset];
            return y2 + (time - x2) / (curves[i] - x2) * (curves[i + 1] - y2);
        }
        const n = i + 18;
        for(i += 2; i < n; i += 2)if (curves[i] >= time) {
            const x2 = curves[i - 2];
            const y2 = curves[i - 1];
            return y2 + (time - x2) / (curves[i] - x2) * (curves[i + 1] - y2);
        }
        frameIndex += this.getFrameEntries();
        const x = curves[n - 2];
        const y = curves[n - 1];
        return y + (time - x) / (this.frames[frameIndex] - x) * (this.frames[frameIndex + valueOffset] - y);
    }
}
class $fd5e2eaf5f163d40$export$ea4b0b6c1bc191c5 extends $fd5e2eaf5f163d40$export$4094e7414845f78f {
    constructor(frameCount, bezierCount, propertyId){
        super(frameCount, bezierCount, [
            propertyId
        ]);
    }
    getFrameEntries() {
        return 2;
    }
    /** Sets the time and value for the specified frame.
   * @param frame Between 0 and <code>frameCount</code>, inclusive.
   * @param time The frame time in seconds. */ setFrame(frame, time, value) {
        frame <<= 1;
        this.frames[frame] = time;
        this.frames[frame + 1] = value;
    }
    /** Returns the interpolated value for the specified time. */ getCurveValue(time) {
        const frames = this.frames;
        let i = frames.length - 2;
        for(let ii = 2; ii <= i; ii += 2)if (frames[ii] > time) {
            i = ii - 2;
            break;
        }
        const curveType = this.curves[i >> 1];
        switch(curveType){
            case 0:
                const before = frames[i];
                const value = frames[i + 1];
                return value + (time - before) / (frames[i + 2] - before) * (frames[i + 2 + 1] - value);
            case 1:
                return frames[i + 1];
        }
        return this.getBezierValue(time, i, 1, curveType - 2);
    }
}
class $fd5e2eaf5f163d40$export$d380b930c0f765ae extends $fd5e2eaf5f163d40$export$4094e7414845f78f {
    /** @param bezierCount The maximum number of Bezier curves. See {@link #shrink(int)}.
   * @param propertyIds Unique identifiers for the properties the timeline modifies. */ constructor(frameCount, bezierCount, propertyId1, propertyId2){
        super(frameCount, bezierCount, [
            propertyId1,
            propertyId2
        ]);
    }
    getFrameEntries() {
        return 3;
    }
    /** Sets the time and values for the specified frame.
   * @param frame Between 0 and <code>frameCount</code>, inclusive.
   * @param time The frame time in seconds. */ setFrame(frame, time, value1, value2) {
        frame *= 3;
        this.frames[frame] = time;
        this.frames[frame + 1] = value1;
        this.frames[frame + 2] = value2;
    }
}
class $fd5e2eaf5f163d40$export$b7ecb8f68b3e130b extends $fd5e2eaf5f163d40$export$ea4b0b6c1bc191c5 {
    constructor(frameCount, bezierCount, boneIndex){
        super(frameCount, bezierCount, `${$fd5e2eaf5f163d40$var$Property.rotate}|${boneIndex}`);
        this.boneIndex = 0;
        this.boneIndex = boneIndex;
    }
    apply(skeleton, lastTime, time, events, alpha, blend, direction) {
        const bone = skeleton.bones[this.boneIndex];
        if (!bone.active) return;
        const frames = this.frames;
        if (time < frames[0]) {
            switch(blend){
                case (0, $bbcccedbc883e405$export$ccab779a50275a35).setup:
                    bone.rotation = bone.data.rotation;
                    return;
                case (0, $bbcccedbc883e405$export$ccab779a50275a35).first:
                    bone.rotation += (bone.data.rotation - bone.rotation) * alpha;
            }
            return;
        }
        let r = this.getCurveValue(time);
        switch(blend){
            case (0, $bbcccedbc883e405$export$ccab779a50275a35).setup:
                bone.rotation = bone.data.rotation + r * alpha;
                break;
            case (0, $bbcccedbc883e405$export$ccab779a50275a35).first:
            case (0, $bbcccedbc883e405$export$ccab779a50275a35).replace:
                r += bone.data.rotation - bone.rotation;
            case (0, $bbcccedbc883e405$export$ccab779a50275a35).add:
                bone.rotation += r * alpha;
        }
    }
}
class $fd5e2eaf5f163d40$export$eb93bf27829ae703 extends $fd5e2eaf5f163d40$export$d380b930c0f765ae {
    constructor(frameCount, bezierCount, boneIndex){
        super(frameCount, bezierCount, `${$fd5e2eaf5f163d40$var$Property.x}|${boneIndex}`, `${$fd5e2eaf5f163d40$var$Property.y}|${boneIndex}`);
        this.boneIndex = 0;
        this.boneIndex = boneIndex;
    }
    apply(skeleton, lastTime, time, events, alpha, blend, direction) {
        const bone = skeleton.bones[this.boneIndex];
        if (!bone.active) return;
        const frames = this.frames;
        if (time < frames[0]) {
            switch(blend){
                case (0, $bbcccedbc883e405$export$ccab779a50275a35).setup:
                    bone.x = bone.data.x;
                    bone.y = bone.data.y;
                    return;
                case (0, $bbcccedbc883e405$export$ccab779a50275a35).first:
                    bone.x += (bone.data.x - bone.x) * alpha;
                    bone.y += (bone.data.y - bone.y) * alpha;
            }
            return;
        }
        let x = 0;
        let y = 0;
        const i = $fd5e2eaf5f163d40$export$e6a97ba2cae5bb94.search(frames, time, 3);
        const curveType = this.curves[i / 3];
        switch(curveType){
            case 0:
                const before = frames[i];
                x = frames[i + 1];
                y = frames[i + 2];
                const t = (time - before) / (frames[i + 3] - before);
                x += (frames[i + 3 + 1] - x) * t;
                y += (frames[i + 3 + 2] - y) * t;
                break;
            case 1:
                x = frames[i + 1];
                y = frames[i + 2];
                break;
            default:
                x = this.getBezierValue(time, i, 1, curveType - 2);
                y = this.getBezierValue(time, i, 2, curveType + 18 - 2);
        }
        switch(blend){
            case (0, $bbcccedbc883e405$export$ccab779a50275a35).setup:
                bone.x = bone.data.x + x * alpha;
                bone.y = bone.data.y + y * alpha;
                break;
            case (0, $bbcccedbc883e405$export$ccab779a50275a35).first:
            case (0, $bbcccedbc883e405$export$ccab779a50275a35).replace:
                bone.x += (bone.data.x + x - bone.x) * alpha;
                bone.y += (bone.data.y + y - bone.y) * alpha;
                break;
            case (0, $bbcccedbc883e405$export$ccab779a50275a35).add:
                bone.x += x * alpha;
                bone.y += y * alpha;
        }
    }
}
class $fd5e2eaf5f163d40$export$cf49491eb4394eca extends $fd5e2eaf5f163d40$export$ea4b0b6c1bc191c5 {
    constructor(frameCount, bezierCount, boneIndex){
        super(frameCount, bezierCount, `${$fd5e2eaf5f163d40$var$Property.x}|${boneIndex}`);
        this.boneIndex = 0;
        this.boneIndex = boneIndex;
    }
    apply(skeleton, lastTime, time, events, alpha, blend, direction) {
        const bone = skeleton.bones[this.boneIndex];
        if (!bone.active) return;
        const frames = this.frames;
        if (time < frames[0]) {
            switch(blend){
                case (0, $bbcccedbc883e405$export$ccab779a50275a35).setup:
                    bone.x = bone.data.x;
                    return;
                case (0, $bbcccedbc883e405$export$ccab779a50275a35).first:
                    bone.x += (bone.data.x - bone.x) * alpha;
            }
            return;
        }
        const x = this.getCurveValue(time);
        switch(blend){
            case (0, $bbcccedbc883e405$export$ccab779a50275a35).setup:
                bone.x = bone.data.x + x * alpha;
                break;
            case (0, $bbcccedbc883e405$export$ccab779a50275a35).first:
            case (0, $bbcccedbc883e405$export$ccab779a50275a35).replace:
                bone.x += (bone.data.x + x - bone.x) * alpha;
                break;
            case (0, $bbcccedbc883e405$export$ccab779a50275a35).add:
                bone.x += x * alpha;
        }
    }
}
class $fd5e2eaf5f163d40$export$6540b7ba297d3e41 extends $fd5e2eaf5f163d40$export$ea4b0b6c1bc191c5 {
    constructor(frameCount, bezierCount, boneIndex){
        super(frameCount, bezierCount, `${$fd5e2eaf5f163d40$var$Property.y}|${boneIndex}`);
        this.boneIndex = 0;
        this.boneIndex = boneIndex;
    }
    apply(skeleton, lastTime, time, events, alpha, blend, direction) {
        const bone = skeleton.bones[this.boneIndex];
        if (!bone.active) return;
        const frames = this.frames;
        if (time < frames[0]) {
            switch(blend){
                case (0, $bbcccedbc883e405$export$ccab779a50275a35).setup:
                    bone.y = bone.data.y;
                    return;
                case (0, $bbcccedbc883e405$export$ccab779a50275a35).first:
                    bone.y += (bone.data.y - bone.y) * alpha;
            }
            return;
        }
        const y = this.getCurveValue(time);
        switch(blend){
            case (0, $bbcccedbc883e405$export$ccab779a50275a35).setup:
                bone.y = bone.data.y + y * alpha;
                break;
            case (0, $bbcccedbc883e405$export$ccab779a50275a35).first:
            case (0, $bbcccedbc883e405$export$ccab779a50275a35).replace:
                bone.y += (bone.data.y + y - bone.y) * alpha;
                break;
            case (0, $bbcccedbc883e405$export$ccab779a50275a35).add:
                bone.y += y * alpha;
        }
    }
}
class $fd5e2eaf5f163d40$export$be544e22f6ad7737 extends $fd5e2eaf5f163d40$export$d380b930c0f765ae {
    constructor(frameCount, bezierCount, boneIndex){
        super(frameCount, bezierCount, `${$fd5e2eaf5f163d40$var$Property.scaleX}|${boneIndex}`, `${$fd5e2eaf5f163d40$var$Property.scaleY}|${boneIndex}`);
        this.boneIndex = 0;
        this.boneIndex = boneIndex;
    }
    apply(skeleton, lastTime, time, events, alpha, blend, direction) {
        const bone = skeleton.bones[this.boneIndex];
        if (!bone.active) return;
        const frames = this.frames;
        if (time < frames[0]) {
            switch(blend){
                case (0, $bbcccedbc883e405$export$ccab779a50275a35).setup:
                    bone.scaleX = bone.data.scaleX;
                    bone.scaleY = bone.data.scaleY;
                    return;
                case (0, $bbcccedbc883e405$export$ccab779a50275a35).first:
                    bone.scaleX += (bone.data.scaleX - bone.scaleX) * alpha;
                    bone.scaleY += (bone.data.scaleY - bone.scaleY) * alpha;
            }
            return;
        }
        let x;
        let y;
        const i = $fd5e2eaf5f163d40$export$e6a97ba2cae5bb94.search(frames, time, 3);
        const curveType = this.curves[i / 3];
        switch(curveType){
            case 0:
                const before = frames[i];
                x = frames[i + 1];
                y = frames[i + 2];
                const t = (time - before) / (frames[i + 3] - before);
                x += (frames[i + 3 + 1] - x) * t;
                y += (frames[i + 3 + 2] - y) * t;
                break;
            case 1:
                x = frames[i + 1];
                y = frames[i + 2];
                break;
            default:
                x = this.getBezierValue(time, i, 1, curveType - 2);
                y = this.getBezierValue(time, i, 2, curveType + 18 - 2);
        }
        x *= bone.data.scaleX;
        y *= bone.data.scaleY;
        if (alpha == 1) {
            if (blend == (0, $bbcccedbc883e405$export$ccab779a50275a35).add) {
                bone.scaleX += x - bone.data.scaleX;
                bone.scaleY += y - bone.data.scaleY;
            } else {
                bone.scaleX = x;
                bone.scaleY = y;
            }
        } else {
            let bx = 0;
            let by = 0;
            if (direction == (0, $bbcccedbc883e405$export$52fc338c0bb328ba).mixOut) switch(blend){
                case (0, $bbcccedbc883e405$export$ccab779a50275a35).setup:
                    bx = bone.data.scaleX;
                    by = bone.data.scaleY;
                    bone.scaleX = bx + (Math.abs(x) * (0, $8804784813ffae81$export$6a7ef315a0d1ef07).signum(bx) - bx) * alpha;
                    bone.scaleY = by + (Math.abs(y) * (0, $8804784813ffae81$export$6a7ef315a0d1ef07).signum(by) - by) * alpha;
                    break;
                case (0, $bbcccedbc883e405$export$ccab779a50275a35).first:
                case (0, $bbcccedbc883e405$export$ccab779a50275a35).replace:
                    bx = bone.scaleX;
                    by = bone.scaleY;
                    bone.scaleX = bx + (Math.abs(x) * (0, $8804784813ffae81$export$6a7ef315a0d1ef07).signum(bx) - bx) * alpha;
                    bone.scaleY = by + (Math.abs(y) * (0, $8804784813ffae81$export$6a7ef315a0d1ef07).signum(by) - by) * alpha;
                    break;
                case (0, $bbcccedbc883e405$export$ccab779a50275a35).add:
                    bone.scaleX += (x - bone.data.scaleX) * alpha;
                    bone.scaleY += (y - bone.data.scaleY) * alpha;
            }
            else switch(blend){
                case (0, $bbcccedbc883e405$export$ccab779a50275a35).setup:
                    bx = Math.abs(bone.data.scaleX) * (0, $8804784813ffae81$export$6a7ef315a0d1ef07).signum(x);
                    by = Math.abs(bone.data.scaleY) * (0, $8804784813ffae81$export$6a7ef315a0d1ef07).signum(y);
                    bone.scaleX = bx + (x - bx) * alpha;
                    bone.scaleY = by + (y - by) * alpha;
                    break;
                case (0, $bbcccedbc883e405$export$ccab779a50275a35).first:
                case (0, $bbcccedbc883e405$export$ccab779a50275a35).replace:
                    bx = Math.abs(bone.scaleX) * (0, $8804784813ffae81$export$6a7ef315a0d1ef07).signum(x);
                    by = Math.abs(bone.scaleY) * (0, $8804784813ffae81$export$6a7ef315a0d1ef07).signum(y);
                    bone.scaleX = bx + (x - bx) * alpha;
                    bone.scaleY = by + (y - by) * alpha;
                    break;
                case (0, $bbcccedbc883e405$export$ccab779a50275a35).add:
                    bone.scaleX += (x - bone.data.scaleX) * alpha;
                    bone.scaleY += (y - bone.data.scaleY) * alpha;
            }
        }
    }
}
class $fd5e2eaf5f163d40$export$407a9cf4df59ebda extends $fd5e2eaf5f163d40$export$ea4b0b6c1bc191c5 {
    constructor(frameCount, bezierCount, boneIndex){
        super(frameCount, bezierCount, `${$fd5e2eaf5f163d40$var$Property.scaleX}|${boneIndex}`);
        this.boneIndex = 0;
        this.boneIndex = boneIndex;
    }
    apply(skeleton, lastTime, time, events, alpha, blend, direction) {
        const bone = skeleton.bones[this.boneIndex];
        if (!bone.active) return;
        const frames = this.frames;
        if (time < frames[0]) {
            switch(blend){
                case (0, $bbcccedbc883e405$export$ccab779a50275a35).setup:
                    bone.scaleX = bone.data.scaleX;
                    return;
                case (0, $bbcccedbc883e405$export$ccab779a50275a35).first:
                    bone.scaleX += (bone.data.scaleX - bone.scaleX) * alpha;
            }
            return;
        }
        const x = this.getCurveValue(time) * bone.data.scaleX;
        if (alpha == 1) {
            if (blend == (0, $bbcccedbc883e405$export$ccab779a50275a35).add) bone.scaleX += x - bone.data.scaleX;
            else bone.scaleX = x;
        } else {
            let bx = 0;
            if (direction == (0, $bbcccedbc883e405$export$52fc338c0bb328ba).mixOut) switch(blend){
                case (0, $bbcccedbc883e405$export$ccab779a50275a35).setup:
                    bx = bone.data.scaleX;
                    bone.scaleX = bx + (Math.abs(x) * (0, $8804784813ffae81$export$6a7ef315a0d1ef07).signum(bx) - bx) * alpha;
                    break;
                case (0, $bbcccedbc883e405$export$ccab779a50275a35).first:
                case (0, $bbcccedbc883e405$export$ccab779a50275a35).replace:
                    bx = bone.scaleX;
                    bone.scaleX = bx + (Math.abs(x) * (0, $8804784813ffae81$export$6a7ef315a0d1ef07).signum(bx) - bx) * alpha;
                    break;
                case (0, $bbcccedbc883e405$export$ccab779a50275a35).add:
                    bone.scaleX += (x - bone.data.scaleX) * alpha;
            }
            else switch(blend){
                case (0, $bbcccedbc883e405$export$ccab779a50275a35).setup:
                    bx = Math.abs(bone.data.scaleX) * (0, $8804784813ffae81$export$6a7ef315a0d1ef07).signum(x);
                    bone.scaleX = bx + (x - bx) * alpha;
                    break;
                case (0, $bbcccedbc883e405$export$ccab779a50275a35).first:
                case (0, $bbcccedbc883e405$export$ccab779a50275a35).replace:
                    bx = Math.abs(bone.scaleX) * (0, $8804784813ffae81$export$6a7ef315a0d1ef07).signum(x);
                    bone.scaleX = bx + (x - bx) * alpha;
                    break;
                case (0, $bbcccedbc883e405$export$ccab779a50275a35).add:
                    bone.scaleX += (x - bone.data.scaleX) * alpha;
            }
        }
    }
}
class $fd5e2eaf5f163d40$export$cc13ceba88ef3794 extends $fd5e2eaf5f163d40$export$ea4b0b6c1bc191c5 {
    constructor(frameCount, bezierCount, boneIndex){
        super(frameCount, bezierCount, `${$fd5e2eaf5f163d40$var$Property.scaleY}|${boneIndex}`);
        this.boneIndex = 0;
        this.boneIndex = boneIndex;
    }
    apply(skeleton, lastTime, time, events, alpha, blend, direction) {
        const bone = skeleton.bones[this.boneIndex];
        if (!bone.active) return;
        const frames = this.frames;
        if (time < frames[0]) {
            switch(blend){
                case (0, $bbcccedbc883e405$export$ccab779a50275a35).setup:
                    bone.scaleY = bone.data.scaleY;
                    return;
                case (0, $bbcccedbc883e405$export$ccab779a50275a35).first:
                    bone.scaleY += (bone.data.scaleY - bone.scaleY) * alpha;
            }
            return;
        }
        const y = this.getCurveValue(time) * bone.data.scaleY;
        if (alpha == 1) {
            if (blend == (0, $bbcccedbc883e405$export$ccab779a50275a35).add) bone.scaleY += y - bone.data.scaleY;
            else bone.scaleY = y;
        } else {
            let by = 0;
            if (direction == (0, $bbcccedbc883e405$export$52fc338c0bb328ba).mixOut) switch(blend){
                case (0, $bbcccedbc883e405$export$ccab779a50275a35).setup:
                    by = bone.data.scaleY;
                    bone.scaleY = by + (Math.abs(y) * (0, $8804784813ffae81$export$6a7ef315a0d1ef07).signum(by) - by) * alpha;
                    break;
                case (0, $bbcccedbc883e405$export$ccab779a50275a35).first:
                case (0, $bbcccedbc883e405$export$ccab779a50275a35).replace:
                    by = bone.scaleY;
                    bone.scaleY = by + (Math.abs(y) * (0, $8804784813ffae81$export$6a7ef315a0d1ef07).signum(by) - by) * alpha;
                    break;
                case (0, $bbcccedbc883e405$export$ccab779a50275a35).add:
                    bone.scaleY += (y - bone.data.scaleY) * alpha;
            }
            else switch(blend){
                case (0, $bbcccedbc883e405$export$ccab779a50275a35).setup:
                    by = Math.abs(bone.data.scaleY) * (0, $8804784813ffae81$export$6a7ef315a0d1ef07).signum(y);
                    bone.scaleY = by + (y - by) * alpha;
                    break;
                case (0, $bbcccedbc883e405$export$ccab779a50275a35).first:
                case (0, $bbcccedbc883e405$export$ccab779a50275a35).replace:
                    by = Math.abs(bone.scaleY) * (0, $8804784813ffae81$export$6a7ef315a0d1ef07).signum(y);
                    bone.scaleY = by + (y - by) * alpha;
                    break;
                case (0, $bbcccedbc883e405$export$ccab779a50275a35).add:
                    bone.scaleY += (y - bone.data.scaleY) * alpha;
            }
        }
    }
}
class $fd5e2eaf5f163d40$export$4da82436a1a0d773 extends $fd5e2eaf5f163d40$export$d380b930c0f765ae {
    constructor(frameCount, bezierCount, boneIndex){
        super(frameCount, bezierCount, `${$fd5e2eaf5f163d40$var$Property.shearX}|${boneIndex}`, `${$fd5e2eaf5f163d40$var$Property.shearY}|${boneIndex}`);
        this.boneIndex = 0;
        this.boneIndex = boneIndex;
    }
    apply(skeleton, lastTime, time, events, alpha, blend, direction) {
        const bone = skeleton.bones[this.boneIndex];
        if (!bone.active) return;
        const frames = this.frames;
        if (time < frames[0]) {
            switch(blend){
                case (0, $bbcccedbc883e405$export$ccab779a50275a35).setup:
                    bone.shearX = bone.data.shearX;
                    bone.shearY = bone.data.shearY;
                    return;
                case (0, $bbcccedbc883e405$export$ccab779a50275a35).first:
                    bone.shearX += (bone.data.shearX - bone.shearX) * alpha;
                    bone.shearY += (bone.data.shearY - bone.shearY) * alpha;
            }
            return;
        }
        let x = 0;
        let y = 0;
        const i = $fd5e2eaf5f163d40$export$e6a97ba2cae5bb94.search(frames, time, 3);
        const curveType = this.curves[i / 3];
        switch(curveType){
            case 0:
                const before = frames[i];
                x = frames[i + 1];
                y = frames[i + 2];
                const t = (time - before) / (frames[i + 3] - before);
                x += (frames[i + 3 + 1] - x) * t;
                y += (frames[i + 3 + 2] - y) * t;
                break;
            case 1:
                x = frames[i + 1];
                y = frames[i + 2];
                break;
            default:
                x = this.getBezierValue(time, i, 1, curveType - 2);
                y = this.getBezierValue(time, i, 2, curveType + 18 - 2);
        }
        switch(blend){
            case (0, $bbcccedbc883e405$export$ccab779a50275a35).setup:
                bone.shearX = bone.data.shearX + x * alpha;
                bone.shearY = bone.data.shearY + y * alpha;
                break;
            case (0, $bbcccedbc883e405$export$ccab779a50275a35).first:
            case (0, $bbcccedbc883e405$export$ccab779a50275a35).replace:
                bone.shearX += (bone.data.shearX + x - bone.shearX) * alpha;
                bone.shearY += (bone.data.shearY + y - bone.shearY) * alpha;
                break;
            case (0, $bbcccedbc883e405$export$ccab779a50275a35).add:
                bone.shearX += x * alpha;
                bone.shearY += y * alpha;
        }
    }
}
class $fd5e2eaf5f163d40$export$2392b1c4c21acaf8 extends $fd5e2eaf5f163d40$export$ea4b0b6c1bc191c5 {
    constructor(frameCount, bezierCount, boneIndex){
        super(frameCount, bezierCount, `${$fd5e2eaf5f163d40$var$Property.shearX}|${boneIndex}`);
        this.boneIndex = 0;
        this.boneIndex = boneIndex;
    }
    apply(skeleton, lastTime, time, events, alpha, blend, direction) {
        const bone = skeleton.bones[this.boneIndex];
        if (!bone.active) return;
        const frames = this.frames;
        if (time < frames[0]) {
            switch(blend){
                case (0, $bbcccedbc883e405$export$ccab779a50275a35).setup:
                    bone.shearX = bone.data.shearX;
                    return;
                case (0, $bbcccedbc883e405$export$ccab779a50275a35).first:
                    bone.shearX += (bone.data.shearX - bone.shearX) * alpha;
            }
            return;
        }
        const x = this.getCurveValue(time);
        switch(blend){
            case (0, $bbcccedbc883e405$export$ccab779a50275a35).setup:
                bone.shearX = bone.data.shearX + x * alpha;
                break;
            case (0, $bbcccedbc883e405$export$ccab779a50275a35).first:
            case (0, $bbcccedbc883e405$export$ccab779a50275a35).replace:
                bone.shearX += (bone.data.shearX + x - bone.shearX) * alpha;
                break;
            case (0, $bbcccedbc883e405$export$ccab779a50275a35).add:
                bone.shearX += x * alpha;
        }
    }
}
class $fd5e2eaf5f163d40$export$f65148e1d95352fd extends $fd5e2eaf5f163d40$export$ea4b0b6c1bc191c5 {
    constructor(frameCount, bezierCount, boneIndex){
        super(frameCount, bezierCount, `${$fd5e2eaf5f163d40$var$Property.shearY}|${boneIndex}`);
        this.boneIndex = 0;
        this.boneIndex = boneIndex;
    }
    apply(skeleton, lastTime, time, events, alpha, blend, direction) {
        const bone = skeleton.bones[this.boneIndex];
        if (!bone.active) return;
        const frames = this.frames;
        if (time < frames[0]) {
            switch(blend){
                case (0, $bbcccedbc883e405$export$ccab779a50275a35).setup:
                    bone.shearY = bone.data.shearY;
                    return;
                case (0, $bbcccedbc883e405$export$ccab779a50275a35).first:
                    bone.shearY += (bone.data.shearY - bone.shearY) * alpha;
            }
            return;
        }
        const y = this.getCurveValue(time);
        switch(blend){
            case (0, $bbcccedbc883e405$export$ccab779a50275a35).setup:
                bone.shearY = bone.data.shearY + y * alpha;
                break;
            case (0, $bbcccedbc883e405$export$ccab779a50275a35).first:
            case (0, $bbcccedbc883e405$export$ccab779a50275a35).replace:
                bone.shearY += (bone.data.shearY + y - bone.shearY) * alpha;
                break;
            case (0, $bbcccedbc883e405$export$ccab779a50275a35).add:
                bone.shearY += y * alpha;
        }
    }
}
class $fd5e2eaf5f163d40$export$84cf3a3e225bcbdc extends $fd5e2eaf5f163d40$export$4094e7414845f78f {
    constructor(frameCount, bezierCount, slotIndex){
        super(frameCount, bezierCount, [
            `${$fd5e2eaf5f163d40$var$Property.rgb}|${slotIndex}`,
            `${$fd5e2eaf5f163d40$var$Property.alpha}|${slotIndex}`
        ]);
        this.slotIndex = 0;
        this.slotIndex = slotIndex;
    }
    getFrameEntries() {
        return 5;
    }
    /** Sets the time in seconds, red, green, blue, and alpha for the specified key frame. */ setFrame(frame, time, r, g, b, a) {
        frame *= 5;
        this.frames[frame] = time;
        this.frames[frame + 1] = r;
        this.frames[frame + 2] = g;
        this.frames[frame + 3] = b;
        this.frames[frame + 4] = a;
    }
    apply(skeleton, lastTime, time, events, alpha, blend, direction) {
        const slot = skeleton.slots[this.slotIndex];
        if (!slot.bone.active) return;
        const frames = this.frames;
        const color = slot.color;
        if (time < frames[0]) {
            const setup = slot.data.color;
            switch(blend){
                case (0, $bbcccedbc883e405$export$ccab779a50275a35).setup:
                    color.setFromColor(setup);
                    return;
                case (0, $bbcccedbc883e405$export$ccab779a50275a35).first:
                    color.add((setup.r - color.r) * alpha, (setup.g - color.g) * alpha, (setup.b - color.b) * alpha, (setup.a - color.a) * alpha);
            }
            return;
        }
        let r = 0;
        let g = 0;
        let b = 0;
        let a = 0;
        const i = $fd5e2eaf5f163d40$export$e6a97ba2cae5bb94.search(frames, time, 5);
        const curveType = this.curves[i / 5];
        switch(curveType){
            case 0:
                const before = frames[i];
                r = frames[i + 1];
                g = frames[i + 2];
                b = frames[i + 3];
                a = frames[i + 4];
                const t = (time - before) / (frames[i + 5] - before);
                r += (frames[i + 5 + 1] - r) * t;
                g += (frames[i + 5 + 2] - g) * t;
                b += (frames[i + 5 + 3] - b) * t;
                a += (frames[i + 5 + 4] - a) * t;
                break;
            case 1:
                r = frames[i + 1];
                g = frames[i + 2];
                b = frames[i + 3];
                a = frames[i + 4];
                break;
            default:
                r = this.getBezierValue(time, i, 1, curveType - 2);
                g = this.getBezierValue(time, i, 2, curveType + 18 - 2);
                b = this.getBezierValue(time, i, 3, curveType + 36 - 2);
                a = this.getBezierValue(time, i, 4, curveType + 54 - 2);
        }
        if (alpha == 1) color.set(r, g, b, a);
        else {
            if (blend == (0, $bbcccedbc883e405$export$ccab779a50275a35).setup) color.setFromColor(slot.data.color);
            color.add((r - color.r) * alpha, (g - color.g) * alpha, (b - color.b) * alpha, (a - color.a) * alpha);
        }
    }
}
class $fd5e2eaf5f163d40$export$e179fb669ddccfa9 extends $fd5e2eaf5f163d40$export$4094e7414845f78f {
    constructor(frameCount, bezierCount, slotIndex){
        super(frameCount, bezierCount, [
            `${$fd5e2eaf5f163d40$var$Property.rgb}|${slotIndex}`
        ]);
        this.slotIndex = 0;
        this.slotIndex = slotIndex;
    }
    getFrameEntries() {
        return 4;
    }
    /** Sets the time in seconds, red, green, blue, and alpha for the specified key frame. */ setFrame(frame, time, r, g, b) {
        frame <<= 2;
        this.frames[frame] = time;
        this.frames[frame + 1] = r;
        this.frames[frame + 2] = g;
        this.frames[frame + 3] = b;
    }
    apply(skeleton, lastTime, time, events, alpha, blend, direction) {
        const slot = skeleton.slots[this.slotIndex];
        if (!slot.bone.active) return;
        const frames = this.frames;
        const color = slot.color;
        if (time < frames[0]) {
            const setup = slot.data.color;
            switch(blend){
                case (0, $bbcccedbc883e405$export$ccab779a50275a35).setup:
                    color.r = setup.r;
                    color.g = setup.g;
                    color.b = setup.b;
                    return;
                case (0, $bbcccedbc883e405$export$ccab779a50275a35).first:
                    color.r += (setup.r - color.r) * alpha;
                    color.g += (setup.g - color.g) * alpha;
                    color.b += (setup.b - color.b) * alpha;
            }
            return;
        }
        let r = 0;
        let g = 0;
        let b = 0;
        const i = $fd5e2eaf5f163d40$export$e6a97ba2cae5bb94.search(frames, time, 4);
        const curveType = this.curves[i >> 2];
        switch(curveType){
            case 0:
                const before = frames[i];
                r = frames[i + 1];
                g = frames[i + 2];
                b = frames[i + 3];
                const t = (time - before) / (frames[i + 4] - before);
                r += (frames[i + 4 + 1] - r) * t;
                g += (frames[i + 4 + 2] - g) * t;
                b += (frames[i + 4 + 3] - b) * t;
                break;
            case 1:
                r = frames[i + 1];
                g = frames[i + 2];
                b = frames[i + 3];
                break;
            default:
                r = this.getBezierValue(time, i, 1, curveType - 2);
                g = this.getBezierValue(time, i, 2, curveType + 18 - 2);
                b = this.getBezierValue(time, i, 3, curveType + 36 - 2);
        }
        if (alpha == 1) {
            color.r = r;
            color.g = g;
            color.b = b;
        } else {
            if (blend == (0, $bbcccedbc883e405$export$ccab779a50275a35).setup) {
                const setup = slot.data.color;
                color.r = setup.r;
                color.g = setup.g;
                color.b = setup.b;
            }
            color.r += (r - color.r) * alpha;
            color.g += (g - color.g) * alpha;
            color.b += (b - color.b) * alpha;
        }
    }
}
class $fd5e2eaf5f163d40$export$2211be7c5ccde97b extends $fd5e2eaf5f163d40$export$ea4b0b6c1bc191c5 {
    constructor(frameCount, bezierCount, slotIndex){
        super(frameCount, bezierCount, `${$fd5e2eaf5f163d40$var$Property.alpha}|${slotIndex}`);
        this.slotIndex = 0;
        this.slotIndex = slotIndex;
    }
    apply(skeleton, lastTime, time, events, alpha, blend, direction) {
        const slot = skeleton.slots[this.slotIndex];
        if (!slot.bone.active) return;
        const color = slot.color;
        if (time < this.frames[0]) {
            const setup = slot.data.color;
            switch(blend){
                case (0, $bbcccedbc883e405$export$ccab779a50275a35).setup:
                    color.a = setup.a;
                    return;
                case (0, $bbcccedbc883e405$export$ccab779a50275a35).first:
                    color.a += (setup.a - color.a) * alpha;
            }
            return;
        }
        const a = this.getCurveValue(time);
        if (alpha == 1) color.a = a;
        else {
            if (blend == (0, $bbcccedbc883e405$export$ccab779a50275a35).setup) color.a = slot.data.color.a;
            color.a += (a - color.a) * alpha;
        }
    }
}
class $fd5e2eaf5f163d40$export$6fc6620d97c53689 extends $fd5e2eaf5f163d40$export$4094e7414845f78f {
    constructor(frameCount, bezierCount, slotIndex){
        super(frameCount, bezierCount, [
            `${$fd5e2eaf5f163d40$var$Property.rgb}|${slotIndex}`,
            `${$fd5e2eaf5f163d40$var$Property.alpha}|${slotIndex}`,
            `${$fd5e2eaf5f163d40$var$Property.rgb2}|${slotIndex}`
        ]);
        this.slotIndex = 0;
        this.slotIndex = slotIndex;
    }
    getFrameEntries() {
        return 8;
    }
    /** Sets the time in seconds, light, and dark colors for the specified key frame. */ setFrame(frame, time, r, g, b, a, r2, g2, b2) {
        frame <<= 3;
        this.frames[frame] = time;
        this.frames[frame + 1] = r;
        this.frames[frame + 2] = g;
        this.frames[frame + 3] = b;
        this.frames[frame + 4] = a;
        this.frames[frame + 5] = r2;
        this.frames[frame + 6] = g2;
        this.frames[frame + 7] = b2;
    }
    apply(skeleton, lastTime, time, events, alpha, blend, direction) {
        const slot = skeleton.slots[this.slotIndex];
        if (!slot.bone.active) return;
        const frames = this.frames;
        const light = slot.color;
        const dark = slot.darkColor;
        if (time < frames[0]) {
            const setupLight = slot.data.color;
            const setupDark = slot.data.darkColor;
            switch(blend){
                case (0, $bbcccedbc883e405$export$ccab779a50275a35).setup:
                    light.setFromColor(setupLight);
                    dark.r = setupDark.r;
                    dark.g = setupDark.g;
                    dark.b = setupDark.b;
                    return;
                case (0, $bbcccedbc883e405$export$ccab779a50275a35).first:
                    light.add((setupLight.r - light.r) * alpha, (setupLight.g - light.g) * alpha, (setupLight.b - light.b) * alpha, (setupLight.a - light.a) * alpha);
                    dark.r += (setupDark.r - dark.r) * alpha;
                    dark.g += (setupDark.g - dark.g) * alpha;
                    dark.b += (setupDark.b - dark.b) * alpha;
            }
            return;
        }
        let r = 0;
        let g = 0;
        let b = 0;
        let a = 0;
        let r2 = 0;
        let g2 = 0;
        let b2 = 0;
        const i = $fd5e2eaf5f163d40$export$e6a97ba2cae5bb94.search(frames, time, 8);
        const curveType = this.curves[i >> 3];
        switch(curveType){
            case 0:
                const before = frames[i];
                r = frames[i + 1];
                g = frames[i + 2];
                b = frames[i + 3];
                a = frames[i + 4];
                r2 = frames[i + 5];
                g2 = frames[i + 6];
                b2 = frames[i + 7];
                const t = (time - before) / (frames[i + 8] - before);
                r += (frames[i + 8 + 1] - r) * t;
                g += (frames[i + 8 + 2] - g) * t;
                b += (frames[i + 8 + 3] - b) * t;
                a += (frames[i + 8 + 4] - a) * t;
                r2 += (frames[i + 8 + 5] - r2) * t;
                g2 += (frames[i + 8 + 6] - g2) * t;
                b2 += (frames[i + 8 + 7] - b2) * t;
                break;
            case 1:
                r = frames[i + 1];
                g = frames[i + 2];
                b = frames[i + 3];
                a = frames[i + 4];
                r2 = frames[i + 5];
                g2 = frames[i + 6];
                b2 = frames[i + 7];
                break;
            default:
                r = this.getBezierValue(time, i, 1, curveType - 2);
                g = this.getBezierValue(time, i, 2, curveType + 18 - 2);
                b = this.getBezierValue(time, i, 3, curveType + 36 - 2);
                a = this.getBezierValue(time, i, 4, curveType + 54 - 2);
                r2 = this.getBezierValue(time, i, 5, curveType + 72 - 2);
                g2 = this.getBezierValue(time, i, 6, curveType + 90 - 2);
                b2 = this.getBezierValue(time, i, 7, curveType + 108 - 2);
        }
        if (alpha == 1) {
            light.set(r, g, b, a);
            dark.r = r2;
            dark.g = g2;
            dark.b = b2;
        } else {
            if (blend == (0, $bbcccedbc883e405$export$ccab779a50275a35).setup) {
                light.setFromColor(slot.data.color);
                const setupDark = slot.data.darkColor;
                dark.r = setupDark.r;
                dark.g = setupDark.g;
                dark.b = setupDark.b;
            }
            light.add((r - light.r) * alpha, (g - light.g) * alpha, (b - light.b) * alpha, (a - light.a) * alpha);
            dark.r += (r2 - dark.r) * alpha;
            dark.g += (g2 - dark.g) * alpha;
            dark.b += (b2 - dark.b) * alpha;
        }
    }
}
class $fd5e2eaf5f163d40$export$a12960afd309a230 extends $fd5e2eaf5f163d40$export$4094e7414845f78f {
    constructor(frameCount, bezierCount, slotIndex){
        super(frameCount, bezierCount, [
            `${$fd5e2eaf5f163d40$var$Property.rgb}|${slotIndex}`,
            `${$fd5e2eaf5f163d40$var$Property.rgb2}|${slotIndex}`
        ]);
        this.slotIndex = 0;
        this.slotIndex = slotIndex;
    }
    getFrameEntries() {
        return 7;
    }
    /** Sets the time in seconds, light, and dark colors for the specified key frame. */ setFrame(frame, time, r, g, b, r2, g2, b2) {
        frame *= 7;
        this.frames[frame] = time;
        this.frames[frame + 1] = r;
        this.frames[frame + 2] = g;
        this.frames[frame + 3] = b;
        this.frames[frame + 4] = r2;
        this.frames[frame + 5] = g2;
        this.frames[frame + 6] = b2;
    }
    apply(skeleton, lastTime, time, events, alpha, blend, direction) {
        const slot = skeleton.slots[this.slotIndex];
        if (!slot.bone.active) return;
        const frames = this.frames;
        const light = slot.color;
        const dark = slot.darkColor;
        if (time < frames[0]) {
            const setupLight = slot.data.color;
            const setupDark = slot.data.darkColor;
            switch(blend){
                case (0, $bbcccedbc883e405$export$ccab779a50275a35).setup:
                    light.r = setupLight.r;
                    light.g = setupLight.g;
                    light.b = setupLight.b;
                    dark.r = setupDark.r;
                    dark.g = setupDark.g;
                    dark.b = setupDark.b;
                    return;
                case (0, $bbcccedbc883e405$export$ccab779a50275a35).first:
                    light.r += (setupLight.r - light.r) * alpha;
                    light.g += (setupLight.g - light.g) * alpha;
                    light.b += (setupLight.b - light.b) * alpha;
                    dark.r += (setupDark.r - dark.r) * alpha;
                    dark.g += (setupDark.g - dark.g) * alpha;
                    dark.b += (setupDark.b - dark.b) * alpha;
            }
            return;
        }
        let r = 0;
        let g = 0;
        let b = 0;
        let r2 = 0;
        let g2 = 0;
        let b2 = 0;
        const i = $fd5e2eaf5f163d40$export$e6a97ba2cae5bb94.search(frames, time, 7);
        const curveType = this.curves[i / 7];
        switch(curveType){
            case 0:
                const before = frames[i];
                r = frames[i + 1];
                g = frames[i + 2];
                b = frames[i + 3];
                r2 = frames[i + 4];
                g2 = frames[i + 5];
                b2 = frames[i + 6];
                const t = (time - before) / (frames[i + 7] - before);
                r += (frames[i + 7 + 1] - r) * t;
                g += (frames[i + 7 + 2] - g) * t;
                b += (frames[i + 7 + 3] - b) * t;
                r2 += (frames[i + 7 + 4] - r2) * t;
                g2 += (frames[i + 7 + 5] - g2) * t;
                b2 += (frames[i + 7 + 6] - b2) * t;
                break;
            case 1:
                r = frames[i + 1];
                g = frames[i + 2];
                b = frames[i + 3];
                r2 = frames[i + 4];
                g2 = frames[i + 5];
                b2 = frames[i + 6];
                break;
            default:
                r = this.getBezierValue(time, i, 1, curveType - 2);
                g = this.getBezierValue(time, i, 2, curveType + 18 - 2);
                b = this.getBezierValue(time, i, 3, curveType + 36 - 2);
                r2 = this.getBezierValue(time, i, 4, curveType + 54 - 2);
                g2 = this.getBezierValue(time, i, 5, curveType + 72 - 2);
                b2 = this.getBezierValue(time, i, 6, curveType + 90 - 2);
        }
        if (alpha == 1) {
            light.r = r;
            light.g = g;
            light.b = b;
            dark.r = r2;
            dark.g = g2;
            dark.b = b2;
        } else {
            if (blend == (0, $bbcccedbc883e405$export$ccab779a50275a35).setup) {
                const setupLight = slot.data.color;
                const setupDark = slot.data.darkColor;
                light.r = setupLight.r;
                light.g = setupLight.g;
                light.b = setupLight.b;
                dark.r = setupDark.r;
                dark.g = setupDark.g;
                dark.b = setupDark.b;
            }
            light.r += (r - light.r) * alpha;
            light.g += (g - light.g) * alpha;
            light.b += (b - light.b) * alpha;
            dark.r += (r2 - dark.r) * alpha;
            dark.g += (g2 - dark.g) * alpha;
            dark.b += (b2 - dark.b) * alpha;
        }
    }
}
class $fd5e2eaf5f163d40$export$7f2bfc5bd27cb43d extends $fd5e2eaf5f163d40$export$e6a97ba2cae5bb94 {
    constructor(frameCount, slotIndex){
        super(frameCount, [
            `${$fd5e2eaf5f163d40$var$Property.attachment}|${slotIndex}`
        ]);
        this.slotIndex = 0;
        this.slotIndex = slotIndex;
        this.attachmentNames = new Array(frameCount);
    }
    getFrameCount() {
        return this.frames.length;
    }
    /** Sets the time in seconds and the attachment name for the specified key frame. */ setFrame(frame, time, attachmentName) {
        this.frames[frame] = time;
        this.attachmentNames[frame] = attachmentName;
    }
    apply(skeleton, lastTime, time, events, alpha, blend, direction) {
        const slot = skeleton.slots[this.slotIndex];
        if (!slot.bone.active) return;
        if (direction == (0, $bbcccedbc883e405$export$52fc338c0bb328ba).mixOut) {
            if (blend == (0, $bbcccedbc883e405$export$ccab779a50275a35).setup) this.setAttachment(skeleton, slot, slot.data.attachmentName);
            return;
        }
        if (time < this.frames[0]) {
            if (blend == (0, $bbcccedbc883e405$export$ccab779a50275a35).setup || blend == (0, $bbcccedbc883e405$export$ccab779a50275a35).first) this.setAttachment(skeleton, slot, slot.data.attachmentName);
            return;
        }
        this.setAttachment(skeleton, slot, this.attachmentNames[$fd5e2eaf5f163d40$export$e6a97ba2cae5bb94.search1(this.frames, time)]);
    }
    setAttachment(skeleton, slot, attachmentName) {
        slot.setAttachment(!attachmentName ? null : skeleton.getAttachment(this.slotIndex, attachmentName));
    }
}
class $fd5e2eaf5f163d40$export$6968d40e5689ad6b extends $fd5e2eaf5f163d40$export$4094e7414845f78f {
    constructor(frameCount, bezierCount, slotIndex, attachment){
        super(frameCount, bezierCount, [
            `${$fd5e2eaf5f163d40$var$Property.deform}|${slotIndex}|${attachment.id}`
        ]);
        this.slotIndex = 0;
        this.slotIndex = slotIndex;
        this.attachment = attachment;
        this.vertices = new Array(frameCount);
    }
    getFrameCount() {
        return this.frames.length;
    }
    /** Sets the time in seconds and the vertices for the specified key frame.
   * @param vertices Vertex positions for an unweighted VertexAttachment, or deform offsets if it has weights. */ setFrame(frame, time, vertices) {
        this.frames[frame] = time;
        this.vertices[frame] = vertices;
    }
    /** @param value1 Ignored (0 is used for a deform timeline).
   * @param value2 Ignored (1 is used for a deform timeline). */ setBezier(bezier, frame, value, time1, value1, cx1, cy1, cx2, cy2, time2, value2) {
        const curves = this.curves;
        let i = this.getFrameCount() + bezier * 18;
        if (value == 0) curves[frame] = 2 + i;
        const tmpx = (time1 - cx1 * 2 + cx2) * 0.03;
        const tmpy = cy2 * 0.03 - cy1 * 0.06;
        const dddx = ((cx1 - cx2) * 3 - time1 + time2) * 6e-3;
        const dddy = (cy1 - cy2 + 0.33333333) * 0.018;
        let ddx = tmpx * 2 + dddx;
        let ddy = tmpy * 2 + dddy;
        let dx = (cx1 - time1) * 0.3 + tmpx + dddx * 0.16666667;
        let dy = cy1 * 0.3 + tmpy + dddy * 0.16666667;
        let x = time1 + dx;
        let y = dy;
        for(let n = i + 18; i < n; i += 2){
            curves[i] = x;
            curves[i + 1] = y;
            dx += ddx;
            dy += ddy;
            ddx += dddx;
            ddy += dddy;
            x += dx;
            y += dy;
        }
    }
    getCurvePercent(time, frame) {
        const curves = this.curves;
        let i = curves[frame];
        switch(i){
            case 0:
                const x2 = this.frames[frame];
                return (time - x2) / (this.frames[frame + this.getFrameEntries()] - x2);
            case 1:
                return 0;
        }
        i -= 2;
        if (curves[i] > time) {
            const x2 = this.frames[frame];
            return curves[i + 1] * (time - x2) / (curves[i] - x2);
        }
        const n = i + 18;
        for(i += 2; i < n; i += 2)if (curves[i] >= time) {
            const x2 = curves[i - 2];
            const y2 = curves[i - 1];
            return y2 + (time - x2) / (curves[i] - x2) * (curves[i + 1] - y2);
        }
        const x = curves[n - 2];
        const y = curves[n - 1];
        return y + (1 - y) * (time - x) / (this.frames[frame + this.getFrameEntries()] - x);
    }
    apply(skeleton, lastTime, time, firedEvents, alpha, blend, direction) {
        const slot = skeleton.slots[this.slotIndex];
        if (!slot.bone.active) return;
        const slotAttachment = slot.getAttachment();
        if (!slotAttachment) return;
        if (!(slotAttachment instanceof (0, $9892e6452670f32b$export$66d3a0c3be55e044)) || slotAttachment.timelineAttachment != this.attachment) return;
        const deform = slot.deform;
        if (deform.length == 0) blend = (0, $bbcccedbc883e405$export$ccab779a50275a35).setup;
        const vertices = this.vertices;
        const vertexCount = vertices[0].length;
        const frames = this.frames;
        if (time < frames[0]) {
            switch(blend){
                case (0, $bbcccedbc883e405$export$ccab779a50275a35).setup:
                    deform.length = 0;
                    return;
                case (0, $bbcccedbc883e405$export$ccab779a50275a35).first:
                    if (alpha == 1) {
                        deform.length = 0;
                        return;
                    }
                    deform.length = vertexCount;
                    const vertexAttachment = slotAttachment;
                    if (!vertexAttachment.bones) {
                        const setupVertices = vertexAttachment.vertices;
                        for(let i = 0; i < vertexCount; i++)deform[i] += (setupVertices[i] - deform[i]) * alpha;
                    } else {
                        alpha = 1 - alpha;
                        for(let i = 0; i < vertexCount; i++)deform[i] *= alpha;
                    }
            }
            return;
        }
        deform.length = vertexCount;
        if (time >= frames[frames.length - 1]) {
            const lastVertices = vertices[frames.length - 1];
            if (alpha == 1) {
                if (blend == (0, $bbcccedbc883e405$export$ccab779a50275a35).add) {
                    const vertexAttachment = slotAttachment;
                    if (!vertexAttachment.bones) {
                        const setupVertices = vertexAttachment.vertices;
                        for(let i = 0; i < vertexCount; i++)deform[i] += lastVertices[i] - setupVertices[i];
                    } else for(let i = 0; i < vertexCount; i++)deform[i] += lastVertices[i];
                } else (0, $8804784813ffae81$export$d2ca453b913dcdea).arrayCopy(lastVertices, 0, deform, 0, vertexCount);
            } else switch(blend){
                case (0, $bbcccedbc883e405$export$ccab779a50275a35).setup:
                    {
                        const vertexAttachment2 = slotAttachment;
                        if (!vertexAttachment2.bones) {
                            const setupVertices = vertexAttachment2.vertices;
                            for(let i = 0; i < vertexCount; i++){
                                const setup = setupVertices[i];
                                deform[i] = setup + (lastVertices[i] - setup) * alpha;
                            }
                        } else for(let i = 0; i < vertexCount; i++)deform[i] = lastVertices[i] * alpha;
                        break;
                    }
                case (0, $bbcccedbc883e405$export$ccab779a50275a35).first:
                case (0, $bbcccedbc883e405$export$ccab779a50275a35).replace:
                    for(let i = 0; i < vertexCount; i++)deform[i] += (lastVertices[i] - deform[i]) * alpha;
                    break;
                case (0, $bbcccedbc883e405$export$ccab779a50275a35).add:
                    const vertexAttachment = slotAttachment;
                    if (!vertexAttachment.bones) {
                        const setupVertices = vertexAttachment.vertices;
                        for(let i = 0; i < vertexCount; i++)deform[i] += (lastVertices[i] - setupVertices[i]) * alpha;
                    } else for(let i = 0; i < vertexCount; i++)deform[i] += lastVertices[i] * alpha;
            }
            return;
        }
        const frame = $fd5e2eaf5f163d40$export$e6a97ba2cae5bb94.search1(frames, time);
        const percent = this.getCurvePercent(time, frame);
        const prevVertices = vertices[frame];
        const nextVertices = vertices[frame + 1];
        if (alpha == 1) {
            if (blend == (0, $bbcccedbc883e405$export$ccab779a50275a35).add) {
                const vertexAttachment = slotAttachment;
                if (!vertexAttachment.bones) {
                    const setupVertices = vertexAttachment.vertices;
                    for(let i = 0; i < vertexCount; i++){
                        const prev = prevVertices[i];
                        deform[i] += prev + (nextVertices[i] - prev) * percent - setupVertices[i];
                    }
                } else for(let i = 0; i < vertexCount; i++){
                    const prev = prevVertices[i];
                    deform[i] += prev + (nextVertices[i] - prev) * percent;
                }
            } else for(let i = 0; i < vertexCount; i++){
                const prev = prevVertices[i];
                deform[i] = prev + (nextVertices[i] - prev) * percent;
            }
        } else switch(blend){
            case (0, $bbcccedbc883e405$export$ccab779a50275a35).setup:
                {
                    const vertexAttachment2 = slotAttachment;
                    if (!vertexAttachment2.bones) {
                        const setupVertices = vertexAttachment2.vertices;
                        for(let i = 0; i < vertexCount; i++){
                            const prev = prevVertices[i];
                            const setup = setupVertices[i];
                            deform[i] = setup + (prev + (nextVertices[i] - prev) * percent - setup) * alpha;
                        }
                    } else for(let i = 0; i < vertexCount; i++){
                        const prev = prevVertices[i];
                        deform[i] = (prev + (nextVertices[i] - prev) * percent) * alpha;
                    }
                    break;
                }
            case (0, $bbcccedbc883e405$export$ccab779a50275a35).first:
            case (0, $bbcccedbc883e405$export$ccab779a50275a35).replace:
                for(let i = 0; i < vertexCount; i++){
                    const prev = prevVertices[i];
                    deform[i] += (prev + (nextVertices[i] - prev) * percent - deform[i]) * alpha;
                }
                break;
            case (0, $bbcccedbc883e405$export$ccab779a50275a35).add:
                const vertexAttachment = slotAttachment;
                if (!vertexAttachment.bones) {
                    const setupVertices = vertexAttachment.vertices;
                    for(let i = 0; i < vertexCount; i++){
                        const prev = prevVertices[i];
                        deform[i] += (prev + (nextVertices[i] - prev) * percent - setupVertices[i]) * alpha;
                    }
                } else for(let i = 0; i < vertexCount; i++){
                    const prev = prevVertices[i];
                    deform[i] += (prev + (nextVertices[i] - prev) * percent) * alpha;
                }
        }
    }
}
const $fd5e2eaf5f163d40$var$_EventTimeline = class extends $fd5e2eaf5f163d40$export$e6a97ba2cae5bb94 {
    constructor(frameCount){
        super(frameCount, $fd5e2eaf5f163d40$var$_EventTimeline.propertyIds);
        this.events = new Array(frameCount);
    }
    getFrameCount() {
        return this.frames.length;
    }
    /** Sets the time in seconds and the event for the specified key frame. */ setFrame(frame, event) {
        this.frames[frame] = event.time;
        this.events[frame] = event;
    }
    /** Fires events for frames > `lastTime` and <= `time`. */ apply(skeleton, lastTime, time, firedEvents, alpha, blend, direction) {
        if (!firedEvents) return;
        const frames = this.frames;
        const frameCount = this.frames.length;
        if (lastTime > time) {
            this.apply(skeleton, lastTime, Number.MAX_VALUE, firedEvents, alpha, blend, direction);
            lastTime = -1;
        } else if (lastTime >= frames[frameCount - 1]) return;
        if (time < frames[0]) return;
        let i = 0;
        if (lastTime < frames[0]) i = 0;
        else {
            i = $fd5e2eaf5f163d40$export$e6a97ba2cae5bb94.search1(frames, lastTime) + 1;
            const frameTime = frames[i];
            while(i > 0){
                if (frames[i - 1] != frameTime) break;
                i--;
            }
        }
        for(; i < frameCount && time >= frames[i]; i++)firedEvents.push(this.events[i]);
    }
};
let $fd5e2eaf5f163d40$export$4f4bca996c586084 = $fd5e2eaf5f163d40$var$_EventTimeline;
$fd5e2eaf5f163d40$export$4f4bca996c586084.propertyIds = [
    `${$fd5e2eaf5f163d40$var$Property.event}`
];
const $fd5e2eaf5f163d40$var$_DrawOrderTimeline = class extends $fd5e2eaf5f163d40$export$e6a97ba2cae5bb94 {
    constructor(frameCount){
        super(frameCount, $fd5e2eaf5f163d40$var$_DrawOrderTimeline.propertyIds);
        this.drawOrders = new Array(frameCount);
    }
    getFrameCount() {
        return this.frames.length;
    }
    /** Sets the time in seconds and the draw order for the specified key frame.
   * @param drawOrder For each slot in {@link Skeleton#slots}, the index of the new draw order. May be null to use setup pose
   *           draw order. */ setFrame(frame, time, drawOrder) {
        this.frames[frame] = time;
        this.drawOrders[frame] = drawOrder;
    }
    apply(skeleton, lastTime, time, firedEvents, alpha, blend, direction) {
        if (direction == (0, $bbcccedbc883e405$export$52fc338c0bb328ba).mixOut) {
            if (blend == (0, $bbcccedbc883e405$export$ccab779a50275a35).setup) (0, $8804784813ffae81$export$d2ca453b913dcdea).arrayCopy(skeleton.slots, 0, skeleton.drawOrder, 0, skeleton.slots.length);
            return;
        }
        if (time < this.frames[0]) {
            if (blend == (0, $bbcccedbc883e405$export$ccab779a50275a35).setup || blend == (0, $bbcccedbc883e405$export$ccab779a50275a35).first) (0, $8804784813ffae81$export$d2ca453b913dcdea).arrayCopy(skeleton.slots, 0, skeleton.drawOrder, 0, skeleton.slots.length);
            return;
        }
        const idx = $fd5e2eaf5f163d40$export$e6a97ba2cae5bb94.search1(this.frames, time);
        const drawOrderToSetupIndex = this.drawOrders[idx];
        if (!drawOrderToSetupIndex) (0, $8804784813ffae81$export$d2ca453b913dcdea).arrayCopy(skeleton.slots, 0, skeleton.drawOrder, 0, skeleton.slots.length);
        else {
            const drawOrder = skeleton.drawOrder;
            const slots = skeleton.slots;
            for(let i = 0, n = drawOrderToSetupIndex.length; i < n; i++)drawOrder[i] = slots[drawOrderToSetupIndex[i]];
        }
    }
};
let $fd5e2eaf5f163d40$export$ece1f7c41d051e83 = $fd5e2eaf5f163d40$var$_DrawOrderTimeline;
$fd5e2eaf5f163d40$export$ece1f7c41d051e83.propertyIds = [
    `${$fd5e2eaf5f163d40$var$Property.drawOrder}`
];
class $fd5e2eaf5f163d40$export$73d125cd89dead44 extends $fd5e2eaf5f163d40$export$4094e7414845f78f {
    constructor(frameCount, bezierCount, ikConstraintIndex){
        super(frameCount, bezierCount, [
            `${$fd5e2eaf5f163d40$var$Property.ikConstraint}|${ikConstraintIndex}`
        ]);
        /** The index of the IK constraint slot in {@link Skeleton#ikConstraints} that will be changed. */ this.ikConstraintIndex = 0;
        this.ikConstraintIndex = ikConstraintIndex;
    }
    getFrameEntries() {
        return 6;
    }
    /** Sets the time in seconds, mix, softness, bend direction, compress, and stretch for the specified key frame. */ setFrame(frame, time, mix, softness, bendDirection, compress, stretch) {
        frame *= 6;
        this.frames[frame] = time;
        this.frames[frame + 1] = mix;
        this.frames[frame + 2] = softness;
        this.frames[frame + 3] = bendDirection;
        this.frames[frame + 4] = compress ? 1 : 0;
        this.frames[frame + 5] = stretch ? 1 : 0;
    }
    apply(skeleton, lastTime, time, firedEvents, alpha, blend, direction) {
        const constraint = skeleton.ikConstraints[this.ikConstraintIndex];
        if (!constraint.active) return;
        const frames = this.frames;
        if (time < frames[0]) {
            switch(blend){
                case (0, $bbcccedbc883e405$export$ccab779a50275a35).setup:
                    constraint.mix = constraint.data.mix;
                    constraint.softness = constraint.data.softness;
                    constraint.bendDirection = constraint.data.bendDirection;
                    constraint.compress = constraint.data.compress;
                    constraint.stretch = constraint.data.stretch;
                    return;
                case (0, $bbcccedbc883e405$export$ccab779a50275a35).first:
                    constraint.mix += (constraint.data.mix - constraint.mix) * alpha;
                    constraint.softness += (constraint.data.softness - constraint.softness) * alpha;
                    constraint.bendDirection = constraint.data.bendDirection;
                    constraint.compress = constraint.data.compress;
                    constraint.stretch = constraint.data.stretch;
            }
            return;
        }
        let mix = 0;
        let softness = 0;
        const i = $fd5e2eaf5f163d40$export$e6a97ba2cae5bb94.search(frames, time, 6);
        const curveType = this.curves[i / 6];
        switch(curveType){
            case 0:
                const before = frames[i];
                mix = frames[i + 1];
                softness = frames[i + 2];
                const t = (time - before) / (frames[i + 6] - before);
                mix += (frames[i + 6 + 1] - mix) * t;
                softness += (frames[i + 6 + 2] - softness) * t;
                break;
            case 1:
                mix = frames[i + 1];
                softness = frames[i + 2];
                break;
            default:
                mix = this.getBezierValue(time, i, 1, curveType - 2);
                softness = this.getBezierValue(time, i, 2, curveType + 18 - 2);
        }
        if (blend == (0, $bbcccedbc883e405$export$ccab779a50275a35).setup) {
            constraint.mix = constraint.data.mix + (mix - constraint.data.mix) * alpha;
            constraint.softness = constraint.data.softness + (softness - constraint.data.softness) * alpha;
            if (direction == (0, $bbcccedbc883e405$export$52fc338c0bb328ba).mixOut) {
                constraint.bendDirection = constraint.data.bendDirection;
                constraint.compress = constraint.data.compress;
                constraint.stretch = constraint.data.stretch;
            } else {
                constraint.bendDirection = frames[i + 3];
                constraint.compress = frames[i + 4] != 0;
                constraint.stretch = frames[i + 5] != 0;
            }
        } else {
            constraint.mix += (mix - constraint.mix) * alpha;
            constraint.softness += (softness - constraint.softness) * alpha;
            if (direction == (0, $bbcccedbc883e405$export$52fc338c0bb328ba).mixIn) {
                constraint.bendDirection = frames[i + 3];
                constraint.compress = frames[i + 4] != 0;
                constraint.stretch = frames[i + 5] != 0;
            }
        }
    }
}
class $fd5e2eaf5f163d40$export$a7a393c2ad815ac7 extends $fd5e2eaf5f163d40$export$4094e7414845f78f {
    constructor(frameCount, bezierCount, transformConstraintIndex){
        super(frameCount, bezierCount, [
            `${$fd5e2eaf5f163d40$var$Property.transformConstraint}|${transformConstraintIndex}`
        ]);
        /** The index of the transform constraint slot in {@link Skeleton#transformConstraints} that will be changed. */ this.transformConstraintIndex = 0;
        this.transformConstraintIndex = transformConstraintIndex;
    }
    getFrameEntries() {
        return 7;
    }
    /** The time in seconds, rotate mix, translate mix, scale mix, and shear mix for the specified key frame. */ setFrame(frame, time, mixRotate, mixX, mixY, mixScaleX, mixScaleY, mixShearY) {
        const frames = this.frames;
        frame *= 7;
        frames[frame] = time;
        frames[frame + 1] = mixRotate;
        frames[frame + 2] = mixX;
        frames[frame + 3] = mixY;
        frames[frame + 4] = mixScaleX;
        frames[frame + 5] = mixScaleY;
        frames[frame + 6] = mixShearY;
    }
    apply(skeleton, lastTime, time, firedEvents, alpha, blend, direction) {
        const constraint = skeleton.transformConstraints[this.transformConstraintIndex];
        if (!constraint.active) return;
        const frames = this.frames;
        if (time < frames[0]) {
            const data = constraint.data;
            switch(blend){
                case (0, $bbcccedbc883e405$export$ccab779a50275a35).setup:
                    constraint.mixRotate = data.mixRotate;
                    constraint.mixX = data.mixX;
                    constraint.mixY = data.mixY;
                    constraint.mixScaleX = data.mixScaleX;
                    constraint.mixScaleY = data.mixScaleY;
                    constraint.mixShearY = data.mixShearY;
                    return;
                case (0, $bbcccedbc883e405$export$ccab779a50275a35).first:
                    constraint.mixRotate += (data.mixRotate - constraint.mixRotate) * alpha;
                    constraint.mixX += (data.mixX - constraint.mixX) * alpha;
                    constraint.mixY += (data.mixY - constraint.mixY) * alpha;
                    constraint.mixScaleX += (data.mixScaleX - constraint.mixScaleX) * alpha;
                    constraint.mixScaleY += (data.mixScaleY - constraint.mixScaleY) * alpha;
                    constraint.mixShearY += (data.mixShearY - constraint.mixShearY) * alpha;
            }
            return;
        }
        let rotate;
        let x;
        let y;
        let scaleX;
        let scaleY;
        let shearY;
        const i = $fd5e2eaf5f163d40$export$e6a97ba2cae5bb94.search(frames, time, 7);
        const curveType = this.curves[i / 7];
        switch(curveType){
            case 0:
                const before = frames[i];
                rotate = frames[i + 1];
                x = frames[i + 2];
                y = frames[i + 3];
                scaleX = frames[i + 4];
                scaleY = frames[i + 5];
                shearY = frames[i + 6];
                const t = (time - before) / (frames[i + 7] - before);
                rotate += (frames[i + 7 + 1] - rotate) * t;
                x += (frames[i + 7 + 2] - x) * t;
                y += (frames[i + 7 + 3] - y) * t;
                scaleX += (frames[i + 7 + 4] - scaleX) * t;
                scaleY += (frames[i + 7 + 5] - scaleY) * t;
                shearY += (frames[i + 7 + 6] - shearY) * t;
                break;
            case 1:
                rotate = frames[i + 1];
                x = frames[i + 2];
                y = frames[i + 3];
                scaleX = frames[i + 4];
                scaleY = frames[i + 5];
                shearY = frames[i + 6];
                break;
            default:
                rotate = this.getBezierValue(time, i, 1, curveType - 2);
                x = this.getBezierValue(time, i, 2, curveType + 18 - 2);
                y = this.getBezierValue(time, i, 3, curveType + 36 - 2);
                scaleX = this.getBezierValue(time, i, 4, curveType + 54 - 2);
                scaleY = this.getBezierValue(time, i, 5, curveType + 72 - 2);
                shearY = this.getBezierValue(time, i, 6, curveType + 90 - 2);
        }
        if (blend == (0, $bbcccedbc883e405$export$ccab779a50275a35).setup) {
            const data = constraint.data;
            constraint.mixRotate = data.mixRotate + (rotate - data.mixRotate) * alpha;
            constraint.mixX = data.mixX + (x - data.mixX) * alpha;
            constraint.mixY = data.mixY + (y - data.mixY) * alpha;
            constraint.mixScaleX = data.mixScaleX + (scaleX - data.mixScaleX) * alpha;
            constraint.mixScaleY = data.mixScaleY + (scaleY - data.mixScaleY) * alpha;
            constraint.mixShearY = data.mixShearY + (shearY - data.mixShearY) * alpha;
        } else {
            constraint.mixRotate += (rotate - constraint.mixRotate) * alpha;
            constraint.mixX += (x - constraint.mixX) * alpha;
            constraint.mixY += (y - constraint.mixY) * alpha;
            constraint.mixScaleX += (scaleX - constraint.mixScaleX) * alpha;
            constraint.mixScaleY += (scaleY - constraint.mixScaleY) * alpha;
            constraint.mixShearY += (shearY - constraint.mixShearY) * alpha;
        }
    }
}
class $fd5e2eaf5f163d40$export$7ce7e67fd9cc52ed extends $fd5e2eaf5f163d40$export$ea4b0b6c1bc191c5 {
    constructor(frameCount, bezierCount, pathConstraintIndex){
        super(frameCount, bezierCount, `${$fd5e2eaf5f163d40$var$Property.pathConstraintPosition}|${pathConstraintIndex}`);
        /** The index of the path constraint slot in {@link Skeleton#pathConstraints} that will be changed. */ this.pathConstraintIndex = 0;
        this.pathConstraintIndex = pathConstraintIndex;
    }
    apply(skeleton, lastTime, time, firedEvents, alpha, blend, direction) {
        const constraint = skeleton.pathConstraints[this.pathConstraintIndex];
        if (!constraint.active) return;
        const frames = this.frames;
        if (time < frames[0]) {
            switch(blend){
                case (0, $bbcccedbc883e405$export$ccab779a50275a35).setup:
                    constraint.position = constraint.data.position;
                    return;
                case (0, $bbcccedbc883e405$export$ccab779a50275a35).first:
                    constraint.position += (constraint.data.position - constraint.position) * alpha;
            }
            return;
        }
        const position = this.getCurveValue(time);
        if (blend == (0, $bbcccedbc883e405$export$ccab779a50275a35).setup) constraint.position = constraint.data.position + (position - constraint.data.position) * alpha;
        else constraint.position += (position - constraint.position) * alpha;
    }
}
class $fd5e2eaf5f163d40$export$17ee50c08a07e62b extends $fd5e2eaf5f163d40$export$ea4b0b6c1bc191c5 {
    constructor(frameCount, bezierCount, pathConstraintIndex){
        super(frameCount, bezierCount, `${$fd5e2eaf5f163d40$var$Property.pathConstraintSpacing}|${pathConstraintIndex}`);
        /** The index of the path constraint slot in {@link Skeleton#getPathConstraints()} that will be changed. */ this.pathConstraintIndex = 0;
        this.pathConstraintIndex = pathConstraintIndex;
    }
    apply(skeleton, lastTime, time, firedEvents, alpha, blend, direction) {
        const constraint = skeleton.pathConstraints[this.pathConstraintIndex];
        if (!constraint.active) return;
        const frames = this.frames;
        if (time < frames[0]) {
            switch(blend){
                case (0, $bbcccedbc883e405$export$ccab779a50275a35).setup:
                    constraint.spacing = constraint.data.spacing;
                    return;
                case (0, $bbcccedbc883e405$export$ccab779a50275a35).first:
                    constraint.spacing += (constraint.data.spacing - constraint.spacing) * alpha;
            }
            return;
        }
        const spacing = this.getCurveValue(time);
        if (blend == (0, $bbcccedbc883e405$export$ccab779a50275a35).setup) constraint.spacing = constraint.data.spacing + (spacing - constraint.data.spacing) * alpha;
        else constraint.spacing += (spacing - constraint.spacing) * alpha;
    }
}
class $fd5e2eaf5f163d40$export$ea67b41755485038 extends $fd5e2eaf5f163d40$export$4094e7414845f78f {
    constructor(frameCount, bezierCount, pathConstraintIndex){
        super(frameCount, bezierCount, [
            `${$fd5e2eaf5f163d40$var$Property.pathConstraintMix}|${pathConstraintIndex}`
        ]);
        /** The index of the path constraint slot in {@link Skeleton#getPathConstraints()} that will be changed. */ this.pathConstraintIndex = 0;
        this.pathConstraintIndex = pathConstraintIndex;
    }
    getFrameEntries() {
        return 4;
    }
    setFrame(frame, time, mixRotate, mixX, mixY) {
        const frames = this.frames;
        frame <<= 2;
        frames[frame] = time;
        frames[frame + 1] = mixRotate;
        frames[frame + 2] = mixX;
        frames[frame + 3] = mixY;
    }
    apply(skeleton, lastTime, time, firedEvents, alpha, blend, direction) {
        const constraint = skeleton.pathConstraints[this.pathConstraintIndex];
        if (!constraint.active) return;
        const frames = this.frames;
        if (time < frames[0]) {
            switch(blend){
                case (0, $bbcccedbc883e405$export$ccab779a50275a35).setup:
                    constraint.mixRotate = constraint.data.mixRotate;
                    constraint.mixX = constraint.data.mixX;
                    constraint.mixY = constraint.data.mixY;
                    return;
                case (0, $bbcccedbc883e405$export$ccab779a50275a35).first:
                    constraint.mixRotate += (constraint.data.mixRotate - constraint.mixRotate) * alpha;
                    constraint.mixX += (constraint.data.mixX - constraint.mixX) * alpha;
                    constraint.mixY += (constraint.data.mixY - constraint.mixY) * alpha;
            }
            return;
        }
        let rotate;
        let x;
        let y;
        const i = $fd5e2eaf5f163d40$export$e6a97ba2cae5bb94.search(frames, time, 4);
        const curveType = this.curves[i >> 2];
        switch(curveType){
            case 0:
                const before = frames[i];
                rotate = frames[i + 1];
                x = frames[i + 2];
                y = frames[i + 3];
                const t = (time - before) / (frames[i + 4] - before);
                rotate += (frames[i + 4 + 1] - rotate) * t;
                x += (frames[i + 4 + 2] - x) * t;
                y += (frames[i + 4 + 3] - y) * t;
                break;
            case 1:
                rotate = frames[i + 1];
                x = frames[i + 2];
                y = frames[i + 3];
                break;
            default:
                rotate = this.getBezierValue(time, i, 1, curveType - 2);
                x = this.getBezierValue(time, i, 2, curveType + 18 - 2);
                y = this.getBezierValue(time, i, 3, curveType + 36 - 2);
        }
        if (blend == (0, $bbcccedbc883e405$export$ccab779a50275a35).setup) {
            const data = constraint.data;
            constraint.mixRotate = data.mixRotate + (rotate - data.mixRotate) * alpha;
            constraint.mixX = data.mixX + (x - data.mixX) * alpha;
            constraint.mixY = data.mixY + (y - data.mixY) * alpha;
        } else {
            constraint.mixRotate += (rotate - constraint.mixRotate) * alpha;
            constraint.mixX += (x - constraint.mixX) * alpha;
            constraint.mixY += (y - constraint.mixY) * alpha;
        }
    }
}
const $fd5e2eaf5f163d40$var$_SequenceTimeline = class extends $fd5e2eaf5f163d40$export$e6a97ba2cae5bb94 {
    constructor(frameCount, slotIndex, attachment){
        super(frameCount, [
            `${$fd5e2eaf5f163d40$var$Property.sequence}|${slotIndex}|${attachment.sequence.id}`
        ]);
        this.slotIndex = slotIndex;
        this.attachment = attachment;
    }
    getFrameEntries() {
        return $fd5e2eaf5f163d40$var$_SequenceTimeline.ENTRIES;
    }
    getSlotIndex() {
        return this.slotIndex;
    }
    getAttachment() {
        return this.attachment;
    }
    /** Sets the time, mode, index, and frame time for the specified frame.
   * @param frame Between 0 and <code>frameCount</code>, inclusive.
   * @param time Seconds between frames. */ setFrame(frame, time, mode, index, delay) {
        const frames = this.frames;
        frame *= $fd5e2eaf5f163d40$var$_SequenceTimeline.ENTRIES;
        frames[frame] = time;
        frames[frame + $fd5e2eaf5f163d40$var$_SequenceTimeline.MODE] = mode | index << 4;
        frames[frame + $fd5e2eaf5f163d40$var$_SequenceTimeline.DELAY] = delay;
    }
    apply(skeleton, lastTime, time, events, alpha, blend, direction) {
        const slot = skeleton.slots[this.slotIndex];
        if (!slot.bone.active) return;
        const slotAttachment = slot.attachment;
        const attachment = this.attachment;
        if (slotAttachment != attachment) {
            if (!(slotAttachment instanceof (0, $9892e6452670f32b$export$66d3a0c3be55e044)) || slotAttachment.timelineAttachment != attachment) return;
        }
        const frames = this.frames;
        if (time < frames[0]) {
            if (blend == (0, $bbcccedbc883e405$export$ccab779a50275a35).setup || blend == (0, $bbcccedbc883e405$export$ccab779a50275a35).first) slot.sequenceIndex = -1;
            return;
        }
        const i = $fd5e2eaf5f163d40$export$e6a97ba2cae5bb94.search(frames, time, $fd5e2eaf5f163d40$var$_SequenceTimeline.ENTRIES);
        const before = frames[i];
        const modeAndIndex = frames[i + $fd5e2eaf5f163d40$var$_SequenceTimeline.MODE];
        const delay = frames[i + $fd5e2eaf5f163d40$var$_SequenceTimeline.DELAY];
        if (!this.attachment.sequence) return;
        let index = modeAndIndex >> 4;
        const count = this.attachment.sequence.regions.length;
        const mode = (0, $37628ed40604134f$export$3d518da8d966a9f5)[modeAndIndex & 15];
        if (mode != (0, $37628ed40604134f$export$2d839466c6120eb9).hold) {
            index += (time - before) / delay + 1e-5 | 0;
            switch(mode){
                case (0, $37628ed40604134f$export$2d839466c6120eb9).once:
                    index = Math.min(count - 1, index);
                    break;
                case (0, $37628ed40604134f$export$2d839466c6120eb9).loop:
                    index %= count;
                    break;
                case (0, $37628ed40604134f$export$2d839466c6120eb9).pingpong:
                    {
                        const n = (count << 1) - 2;
                        index = n == 0 ? 0 : index % n;
                        if (index >= count) index = n - index;
                        break;
                    }
                case (0, $37628ed40604134f$export$2d839466c6120eb9).onceReverse:
                    index = Math.max(count - 1 - index, 0);
                    break;
                case (0, $37628ed40604134f$export$2d839466c6120eb9).loopReverse:
                    index = count - 1 - index % count;
                    break;
                case (0, $37628ed40604134f$export$2d839466c6120eb9).pingpongReverse:
                    {
                        const n = (count << 1) - 2;
                        index = n == 0 ? 0 : (index + count - 1) % n;
                        if (index >= count) index = n - index;
                    }
            }
        }
        slot.sequenceIndex = index;
    }
};
let $fd5e2eaf5f163d40$export$2687f324e8496672 = $fd5e2eaf5f163d40$var$_SequenceTimeline;
$fd5e2eaf5f163d40$export$2687f324e8496672.ENTRIES = 3;
$fd5e2eaf5f163d40$export$2687f324e8496672.MODE = 1;
$fd5e2eaf5f163d40$export$2687f324e8496672.DELAY = 2;




const $02bea3975cac0842$var$_AnimationState = class {
    constructor(data){
        /** The list of tracks that currently have animations, which may contain null entries. */ this.tracks = new Array();
        /** Multiplier for the delta time when the animation state is updated, causing time for all animations and mixes to play slower
     * or faster. Defaults to 1.
     *
     * See TrackEntry {@link TrackEntry#timeScale} for affecting a single animation. */ this.timeScale = 1;
        this.unkeyedState = 0;
        this.events = new Array();
        this.listeners = new Array();
        this.queue = new $02bea3975cac0842$export$2fc6338444a158e6(this);
        this.propertyIDs = new (0, $8804784813ffae81$export$1a41fd2ab8394c46)();
        this.animationsChanged = false;
        this.trackEntryPool = new (0, $8804784813ffae81$export$14963ee5c8637e11)(()=>new $02bea3975cac0842$export$6fd48f25bc0ee658());
        this.data = data;
    }
    static emptyAnimation() {
        return $02bea3975cac0842$var$_AnimationState._emptyAnimation;
    }
    /** Increments each track entry {@link TrackEntry#trackTime()}, setting queued animations as current if needed. */ update(delta) {
        delta *= this.timeScale;
        const tracks = this.tracks;
        for(let i = 0, n = tracks.length; i < n; i++){
            const current = tracks[i];
            if (!current) continue;
            current.animationLast = current.nextAnimationLast;
            current.trackLast = current.nextTrackLast;
            let currentDelta = delta * current.timeScale;
            if (current.delay > 0) {
                current.delay -= currentDelta;
                if (current.delay > 0) continue;
                currentDelta = -current.delay;
                current.delay = 0;
            }
            let next = current.next;
            if (next) {
                const nextTime = current.trackLast - next.delay;
                if (nextTime >= 0) {
                    next.delay = 0;
                    next.trackTime += current.timeScale == 0 ? 0 : (nextTime / current.timeScale + delta) * next.timeScale;
                    current.trackTime += currentDelta;
                    this.setCurrent(i, next, true);
                    while(next.mixingFrom){
                        next.mixTime += delta;
                        next = next.mixingFrom;
                    }
                    continue;
                }
            } else if (current.trackLast >= current.trackEnd && !current.mixingFrom) {
                tracks[i] = null;
                this.queue.end(current);
                this.clearNext(current);
                continue;
            }
            if (current.mixingFrom && this.updateMixingFrom(current, delta)) {
                let from = current.mixingFrom;
                current.mixingFrom = null;
                if (from) from.mixingTo = null;
                while(from){
                    this.queue.end(from);
                    from = from.mixingFrom;
                }
            }
            current.trackTime += currentDelta;
        }
        this.queue.drain();
    }
    /** Returns true when all mixing from entries are complete. */ updateMixingFrom(to, delta) {
        const from = to.mixingFrom;
        if (!from) return true;
        const finished = this.updateMixingFrom(from, delta);
        from.animationLast = from.nextAnimationLast;
        from.trackLast = from.nextTrackLast;
        if (to.mixTime > 0 && to.mixTime >= to.mixDuration) {
            if (from.totalAlpha == 0 || to.mixDuration == 0) {
                to.mixingFrom = from.mixingFrom;
                if (from.mixingFrom) from.mixingFrom.mixingTo = to;
                to.interruptAlpha = from.interruptAlpha;
                this.queue.end(from);
            }
            return finished;
        }
        from.trackTime += delta * from.timeScale;
        to.mixTime += delta;
        return false;
    }
    /** Poses the skeleton using the track entry animations. There are no side effects other than invoking listeners, so the
   * animation state can be applied to multiple skeletons to pose them identically.
   * @returns True if any animations were applied. */ apply(skeleton) {
        if (!skeleton) throw new Error("skeleton cannot be null.");
        if (this.animationsChanged) this._animationsChanged();
        const events = this.events;
        const tracks = this.tracks;
        let applied = false;
        for(let i = 0, n = tracks.length; i < n; i++){
            const current = tracks[i];
            if (!current || current.delay > 0) continue;
            applied = true;
            const blend = i == 0 ? (0, $bbcccedbc883e405$export$ccab779a50275a35).first : current.mixBlend;
            let mix = current.alpha;
            if (current.mixingFrom) mix *= this.applyMixingFrom(current, skeleton, blend);
            else if (current.trackTime >= current.trackEnd && !current.next) mix = 0;
            const animationLast = current.animationLast;
            const animationTime = current.getAnimationTime();
            let applyTime = animationTime;
            let applyEvents = events;
            if (current.reverse) {
                applyTime = current.animation.duration - applyTime;
                applyEvents = null;
            }
            const timelines = current.animation.timelines;
            const timelineCount = timelines.length;
            if (i == 0 && mix == 1 || blend == (0, $bbcccedbc883e405$export$ccab779a50275a35).add) for(let ii = 0; ii < timelineCount; ii++){
                (0, $8804784813ffae81$export$d2ca453b913dcdea).webkit602BugfixHelper(mix, blend);
                const timeline = timelines[ii];
                if (timeline instanceof (0, $fd5e2eaf5f163d40$export$7f2bfc5bd27cb43d)) this.applyAttachmentTimeline(timeline, skeleton, applyTime, blend, true);
                else timeline.apply(skeleton, animationLast, applyTime, applyEvents, mix, blend, (0, $bbcccedbc883e405$export$52fc338c0bb328ba).mixIn);
            }
            else {
                const timelineMode = current.timelineMode;
                const shortestRotation = current.shortestRotation;
                const firstFrame = !shortestRotation && current.timelinesRotation.length != timelineCount << 1;
                if (firstFrame) current.timelinesRotation.length = timelineCount << 1;
                for(let ii = 0; ii < timelineCount; ii++){
                    const timeline = timelines[ii];
                    const timelineBlend = timelineMode[ii] == $02bea3975cac0842$var$SUBSEQUENT ? blend : (0, $bbcccedbc883e405$export$ccab779a50275a35).setup;
                    if (!shortestRotation && timeline instanceof (0, $fd5e2eaf5f163d40$export$b7ecb8f68b3e130b)) this.applyRotateTimeline(timeline, skeleton, applyTime, mix, timelineBlend, current.timelinesRotation, ii << 1, firstFrame);
                    else if (timeline instanceof (0, $fd5e2eaf5f163d40$export$7f2bfc5bd27cb43d)) this.applyAttachmentTimeline(timeline, skeleton, applyTime, blend, true);
                    else {
                        (0, $8804784813ffae81$export$d2ca453b913dcdea).webkit602BugfixHelper(mix, blend);
                        timeline.apply(skeleton, animationLast, applyTime, applyEvents, mix, timelineBlend, (0, $bbcccedbc883e405$export$52fc338c0bb328ba).mixIn);
                    }
                }
            }
            this.queueEvents(current, animationTime);
            events.length = 0;
            current.nextAnimationLast = animationTime;
            current.nextTrackLast = current.trackTime;
        }
        const setupState = this.unkeyedState + $02bea3975cac0842$var$SETUP;
        const slots = skeleton.slots;
        for(let i = 0, n = skeleton.slots.length; i < n; i++){
            const slot = slots[i];
            if (slot.attachmentState == setupState) {
                const attachmentName = slot.data.attachmentName;
                slot.setAttachment(!attachmentName ? null : skeleton.getAttachment(slot.data.index, attachmentName));
            }
        }
        this.unkeyedState += 2;
        this.queue.drain();
        return applied;
    }
    applyMixingFrom(to, skeleton, blend) {
        const from = to.mixingFrom;
        if (from.mixingFrom) this.applyMixingFrom(from, skeleton, blend);
        let mix = 0;
        if (to.mixDuration == 0) {
            mix = 1;
            if (blend == (0, $bbcccedbc883e405$export$ccab779a50275a35).first) blend = (0, $bbcccedbc883e405$export$ccab779a50275a35).setup;
        } else {
            mix = to.mixTime / to.mixDuration;
            if (mix > 1) mix = 1;
            if (blend != (0, $bbcccedbc883e405$export$ccab779a50275a35).first) blend = from.mixBlend;
        }
        const attachments = mix < from.attachmentThreshold;
        const drawOrder = mix < from.drawOrderThreshold;
        const timelines = from.animation.timelines;
        const timelineCount = timelines.length;
        const alphaHold = from.alpha * to.interruptAlpha;
        const alphaMix = alphaHold * (1 - mix);
        const animationLast = from.animationLast;
        const animationTime = from.getAnimationTime();
        let applyTime = animationTime;
        let events = null;
        if (from.reverse) applyTime = from.animation.duration - applyTime;
        else if (mix < from.eventThreshold) events = this.events;
        if (blend == (0, $bbcccedbc883e405$export$ccab779a50275a35).add) for(let i = 0; i < timelineCount; i++)timelines[i].apply(skeleton, animationLast, applyTime, events, alphaMix, blend, (0, $bbcccedbc883e405$export$52fc338c0bb328ba).mixOut);
        else {
            const timelineMode = from.timelineMode;
            const timelineHoldMix = from.timelineHoldMix;
            const shortestRotation = from.shortestRotation;
            const firstFrame = !shortestRotation && from.timelinesRotation.length != timelineCount << 1;
            if (firstFrame) from.timelinesRotation.length = timelineCount << 1;
            from.totalAlpha = 0;
            for(let i = 0; i < timelineCount; i++){
                const timeline = timelines[i];
                let direction = (0, $bbcccedbc883e405$export$52fc338c0bb328ba).mixOut;
                let timelineBlend;
                let alpha = 0;
                switch(timelineMode[i]){
                    case $02bea3975cac0842$var$SUBSEQUENT:
                        if (!drawOrder && timeline instanceof (0, $fd5e2eaf5f163d40$export$ece1f7c41d051e83)) continue;
                        timelineBlend = blend;
                        alpha = alphaMix;
                        break;
                    case $02bea3975cac0842$var$FIRST:
                        timelineBlend = (0, $bbcccedbc883e405$export$ccab779a50275a35).setup;
                        alpha = alphaMix;
                        break;
                    case $02bea3975cac0842$var$HOLD_SUBSEQUENT:
                        timelineBlend = blend;
                        alpha = alphaHold;
                        break;
                    case $02bea3975cac0842$var$HOLD_FIRST:
                        timelineBlend = (0, $bbcccedbc883e405$export$ccab779a50275a35).setup;
                        alpha = alphaHold;
                        break;
                    default:
                        timelineBlend = (0, $bbcccedbc883e405$export$ccab779a50275a35).setup;
                        const holdMix = timelineHoldMix[i];
                        alpha = alphaHold * Math.max(0, 1 - holdMix.mixTime / holdMix.mixDuration);
                        break;
                }
                from.totalAlpha += alpha;
                if (!shortestRotation && timeline instanceof (0, $fd5e2eaf5f163d40$export$b7ecb8f68b3e130b)) this.applyRotateTimeline(timeline, skeleton, applyTime, alpha, timelineBlend, from.timelinesRotation, i << 1, firstFrame);
                else if (timeline instanceof (0, $fd5e2eaf5f163d40$export$7f2bfc5bd27cb43d)) this.applyAttachmentTimeline(timeline, skeleton, applyTime, timelineBlend, attachments);
                else {
                    (0, $8804784813ffae81$export$d2ca453b913dcdea).webkit602BugfixHelper(alpha, blend);
                    if (drawOrder && timeline instanceof (0, $fd5e2eaf5f163d40$export$ece1f7c41d051e83) && timelineBlend == (0, $bbcccedbc883e405$export$ccab779a50275a35).setup) direction = (0, $bbcccedbc883e405$export$52fc338c0bb328ba).mixIn;
                    timeline.apply(skeleton, animationLast, applyTime, events, alpha, timelineBlend, direction);
                }
            }
        }
        if (to.mixDuration > 0) this.queueEvents(from, animationTime);
        this.events.length = 0;
        from.nextAnimationLast = animationTime;
        from.nextTrackLast = from.trackTime;
        return mix;
    }
    applyAttachmentTimeline(timeline, skeleton, time, blend, attachments) {
        const slot = skeleton.slots[timeline.slotIndex];
        if (!slot.bone.active) return;
        if (time < timeline.frames[0]) {
            if (blend == (0, $bbcccedbc883e405$export$ccab779a50275a35).setup || blend == (0, $bbcccedbc883e405$export$ccab779a50275a35).first) this.setAttachment(skeleton, slot, slot.data.attachmentName, attachments);
        } else this.setAttachment(skeleton, slot, timeline.attachmentNames[(0, $fd5e2eaf5f163d40$export$e6a97ba2cae5bb94).search1(timeline.frames, time)], attachments);
        if (slot.attachmentState <= this.unkeyedState) slot.attachmentState = this.unkeyedState + $02bea3975cac0842$var$SETUP;
    }
    setAttachment(skeleton, slot, attachmentName, attachments) {
        slot.setAttachment(!attachmentName ? null : skeleton.getAttachment(slot.data.index, attachmentName));
        if (attachments) slot.attachmentState = this.unkeyedState + $02bea3975cac0842$var$CURRENT;
    }
    applyRotateTimeline(timeline, skeleton, time, alpha, blend, timelinesRotation, i, firstFrame) {
        if (firstFrame) timelinesRotation[i] = 0;
        if (alpha == 1) {
            timeline.apply(skeleton, 0, time, null, 1, blend, (0, $bbcccedbc883e405$export$52fc338c0bb328ba).mixIn);
            return;
        }
        const bone = skeleton.bones[timeline.boneIndex];
        if (!bone.active) return;
        const frames = timeline.frames;
        let r1 = 0;
        let r2 = 0;
        if (time < frames[0]) switch(blend){
            case (0, $bbcccedbc883e405$export$ccab779a50275a35).setup:
                bone.rotation = bone.data.rotation;
            default:
                return;
            case (0, $bbcccedbc883e405$export$ccab779a50275a35).first:
                r1 = bone.rotation;
                r2 = bone.data.rotation;
        }
        else {
            r1 = blend == (0, $bbcccedbc883e405$export$ccab779a50275a35).setup ? bone.data.rotation : bone.rotation;
            r2 = bone.data.rotation + timeline.getCurveValue(time);
        }
        let total = 0;
        let diff = r2 - r1;
        diff -= (16384 - (16384.499999999996 - diff / 360 | 0)) * 360;
        if (diff == 0) total = timelinesRotation[i];
        else {
            let lastTotal = 0;
            let lastDiff = 0;
            if (firstFrame) {
                lastTotal = 0;
                lastDiff = diff;
            } else {
                lastTotal = timelinesRotation[i];
                lastDiff = timelinesRotation[i + 1];
            }
            const current = diff > 0;
            let dir = lastTotal >= 0;
            if ((0, $8804784813ffae81$export$6a7ef315a0d1ef07).signum(lastDiff) != (0, $8804784813ffae81$export$6a7ef315a0d1ef07).signum(diff) && Math.abs(lastDiff) <= 90) {
                if (Math.abs(lastTotal) > 180) lastTotal += 360 * (0, $8804784813ffae81$export$6a7ef315a0d1ef07).signum(lastTotal);
                dir = current;
            }
            total = diff + lastTotal - lastTotal % 360;
            if (dir != current) total += 360 * (0, $8804784813ffae81$export$6a7ef315a0d1ef07).signum(lastTotal);
            timelinesRotation[i] = total;
        }
        timelinesRotation[i + 1] = diff;
        bone.rotation = r1 + total * alpha;
    }
    queueEvents(entry, animationTime) {
        const animationStart = entry.animationStart;
        const animationEnd = entry.animationEnd;
        const duration = animationEnd - animationStart;
        const trackLastWrapped = entry.trackLast % duration;
        const events = this.events;
        let i = 0;
        const n = events.length;
        for(; i < n; i++){
            const event = events[i];
            if (event.time < trackLastWrapped) break;
            if (event.time > animationEnd) continue;
            this.queue.event(entry, event);
        }
        let complete = false;
        if (entry.loop) complete = duration == 0 || trackLastWrapped > entry.trackTime % duration;
        else complete = animationTime >= animationEnd && entry.animationLast < animationEnd;
        if (complete) this.queue.complete(entry);
        for(; i < n; i++){
            const event = events[i];
            if (event.time < animationStart) continue;
            this.queue.event(entry, event);
        }
    }
    /** Removes all animations from all tracks, leaving skeletons in their current pose.
   *
   * It may be desired to use {@link AnimationState#setEmptyAnimation()} to mix the skeletons back to the setup pose,
   * rather than leaving them in their current pose. */ clearTracks() {
        const oldDrainDisabled = this.queue.drainDisabled;
        this.queue.drainDisabled = true;
        for(let i = 0, n = this.tracks.length; i < n; i++)this.clearTrack(i);
        this.tracks.length = 0;
        this.queue.drainDisabled = oldDrainDisabled;
        this.queue.drain();
    }
    /** Removes all animations from the track, leaving skeletons in their current pose.
   *
   * It may be desired to use {@link AnimationState#setEmptyAnimation()} to mix the skeletons back to the setup pose,
   * rather than leaving them in their current pose. */ clearTrack(trackIndex) {
        if (trackIndex >= this.tracks.length) return;
        const current = this.tracks[trackIndex];
        if (!current) return;
        this.queue.end(current);
        this.clearNext(current);
        let entry = current;
        while(true){
            const from = entry.mixingFrom;
            if (!from) break;
            this.queue.end(from);
            entry.mixingFrom = null;
            entry.mixingTo = null;
            entry = from;
        }
        this.tracks[current.trackIndex] = null;
        this.queue.drain();
    }
    setCurrent(index, current, interrupt) {
        const from = this.expandToIndex(index);
        this.tracks[index] = current;
        current.previous = null;
        if (from) {
            if (interrupt) this.queue.interrupt(from);
            current.mixingFrom = from;
            from.mixingTo = current;
            current.mixTime = 0;
            if (from.mixingFrom && from.mixDuration > 0) current.interruptAlpha *= Math.min(1, from.mixTime / from.mixDuration);
            from.timelinesRotation.length = 0;
        }
        this.queue.start(current);
    }
    /** Sets an animation by name.
   *
   * See {@link #setAnimationWith()}. */ setAnimation(trackIndex, animationName, loop = false) {
        const animation = this.data.skeletonData.findAnimation(animationName);
        if (!animation) throw new Error(`Animation not found: ${animationName}`);
        return this.setAnimationWith(trackIndex, animation, loop);
    }
    /** Sets the current animation for a track, discarding any queued animations. If the formerly current track entry was never
   * applied to a skeleton, it is replaced (not mixed from).
   * @param loop If true, the animation will repeat. If false it will not, instead its last frame is applied if played beyond its
   *           duration. In either case {@link TrackEntry#trackEnd} determines when the track is cleared.
   * @returns A track entry to allow further customization of animation playback. References to the track entry must not be kept
   *         after the {@link AnimationStateListener#dispose()} event occurs. */ setAnimationWith(trackIndex, animation, loop = false) {
        if (!animation) throw new Error("animation cannot be null.");
        let interrupt = true;
        let current = this.expandToIndex(trackIndex);
        if (current) {
            if (current.nextTrackLast == -1) {
                this.tracks[trackIndex] = current.mixingFrom;
                this.queue.interrupt(current);
                this.queue.end(current);
                this.clearNext(current);
                current = current.mixingFrom;
                interrupt = false;
            } else this.clearNext(current);
        }
        const entry = this.trackEntry(trackIndex, animation, loop, current);
        this.setCurrent(trackIndex, entry, interrupt);
        this.queue.drain();
        return entry;
    }
    /** Queues an animation by name.
   *
   * See {@link #addAnimationWith()}. */ addAnimation(trackIndex, animationName, loop = false, delay = 0) {
        const animation = this.data.skeletonData.findAnimation(animationName);
        if (!animation) throw new Error(`Animation not found: ${animationName}`);
        return this.addAnimationWith(trackIndex, animation, loop, delay);
    }
    /** Adds an animation to be played after the current or last queued animation for a track. If the track is empty, it is
   * equivalent to calling {@link #setAnimationWith()}.
   * @param delay If > 0, sets {@link TrackEntry#delay}. If <= 0, the delay set is the duration of the previous track entry
   *           minus any mix duration (from the {@link AnimationStateData}) plus the specified `delay` (ie the mix
   *           ends at (`delay` = 0) or before (`delay` < 0) the previous track entry duration). If the
   *           previous entry is looping, its next loop completion is used instead of its duration.
   * @returns A track entry to allow further customization of animation playback. References to the track entry must not be kept
   *         after the {@link AnimationStateListener#dispose()} event occurs. */ addAnimationWith(trackIndex, animation, loop = false, delay = 0) {
        if (!animation) throw new Error("animation cannot be null.");
        let last = this.expandToIndex(trackIndex);
        if (last) while(last.next)last = last.next;
        const entry = this.trackEntry(trackIndex, animation, loop, last);
        if (!last) {
            this.setCurrent(trackIndex, entry, true);
            this.queue.drain();
        } else {
            last.next = entry;
            entry.previous = last;
            if (delay <= 0) delay += last.getTrackComplete() - entry.mixDuration;
        }
        entry.delay = delay;
        return entry;
    }
    /** Sets an empty animation for a track, discarding any queued animations, and sets the track entry's
   * {@link TrackEntry#mixduration}. An empty animation has no timelines and serves as a placeholder for mixing in or out.
   *
   * Mixing out is done by setting an empty animation with a mix duration using either {@link #setEmptyAnimation()},
   * {@link #setEmptyAnimations()}, or {@link #addEmptyAnimation()}. Mixing to an empty animation causes
   * the previous animation to be applied less and less over the mix duration. Properties keyed in the previous animation
   * transition to the value from lower tracks or to the setup pose value if no lower tracks key the property. A mix duration of
   * 0 still mixes out over one frame.
   *
   * Mixing in is done by first setting an empty animation, then adding an animation using
   * {@link #addAnimation()} and on the returned track entry, set the
   * {@link TrackEntry#setMixDuration()}. Mixing from an empty animation causes the new animation to be applied more and
   * more over the mix duration. Properties keyed in the new animation transition from the value from lower tracks or from the
   * setup pose value if no lower tracks key the property to the value keyed in the new animation. */ setEmptyAnimation(trackIndex, mixDuration = 0) {
        const entry = this.setAnimationWith(trackIndex, $02bea3975cac0842$var$_AnimationState.emptyAnimation(), false);
        entry.mixDuration = mixDuration;
        entry.trackEnd = mixDuration;
        return entry;
    }
    /** Adds an empty animation to be played after the current or last queued animation for a track, and sets the track entry's
   * {@link TrackEntry#mixDuration}. If the track is empty, it is equivalent to calling
   * {@link #setEmptyAnimation()}.
   *
   * See {@link #setEmptyAnimation()}.
   * @param delay If > 0, sets {@link TrackEntry#delay}. If <= 0, the delay set is the duration of the previous track entry
   *           minus any mix duration plus the specified `delay` (ie the mix ends at (`delay` = 0) or
   *           before (`delay` < 0) the previous track entry duration). If the previous entry is looping, its next
   *           loop completion is used instead of its duration.
   * @return A track entry to allow further customization of animation playback. References to the track entry must not be kept
   *         after the {@link AnimationStateListener#dispose()} event occurs. */ addEmptyAnimation(trackIndex, mixDuration = 0, delay = 0) {
        const entry = this.addAnimationWith(trackIndex, $02bea3975cac0842$var$_AnimationState.emptyAnimation(), false, delay);
        if (delay <= 0) entry.delay += entry.mixDuration - mixDuration;
        entry.mixDuration = mixDuration;
        entry.trackEnd = mixDuration;
        return entry;
    }
    /** Sets an empty animation for every track, discarding any queued animations, and mixes to it over the specified mix
   * duration. */ setEmptyAnimations(mixDuration = 0) {
        const oldDrainDisabled = this.queue.drainDisabled;
        this.queue.drainDisabled = true;
        for(let i = 0, n = this.tracks.length; i < n; i++){
            const current = this.tracks[i];
            if (current) this.setEmptyAnimation(current.trackIndex, mixDuration);
        }
        this.queue.drainDisabled = oldDrainDisabled;
        this.queue.drain();
    }
    expandToIndex(index) {
        if (index < this.tracks.length) return this.tracks[index];
        (0, $8804784813ffae81$export$d2ca453b913dcdea).ensureArrayCapacity(this.tracks, index + 1, null);
        this.tracks.length = index + 1;
        return null;
    }
    /** @param last May be null. */ trackEntry(trackIndex, animation, loop, last) {
        const entry = this.trackEntryPool.obtain();
        entry.reset();
        entry.trackIndex = trackIndex;
        entry.animation = animation;
        entry.loop = loop;
        entry.holdPrevious = false;
        entry.reverse = false;
        entry.shortestRotation = false;
        entry.eventThreshold = 0;
        entry.attachmentThreshold = 0;
        entry.drawOrderThreshold = 0;
        entry.animationStart = 0;
        entry.animationEnd = animation.duration;
        entry.animationLast = -1;
        entry.nextAnimationLast = -1;
        entry.delay = 0;
        entry.trackTime = 0;
        entry.trackLast = -1;
        entry.nextTrackLast = -1;
        entry.trackEnd = Number.MAX_VALUE;
        entry.timeScale = 1;
        entry.alpha = 1;
        entry.mixTime = 0;
        entry.mixDuration = !last ? 0 : this.data.getMix(last.animation, animation);
        entry.interruptAlpha = 1;
        entry.totalAlpha = 0;
        entry.mixBlend = (0, $bbcccedbc883e405$export$ccab779a50275a35).replace;
        return entry;
    }
    /** Removes the {@link TrackEntry#getNext() next entry} and all entries after it for the specified entry. */ clearNext(entry) {
        let next = entry.next;
        while(next){
            this.queue.dispose(next);
            next = next.next;
        }
        entry.next = null;
    }
    _animationsChanged() {
        this.animationsChanged = false;
        this.propertyIDs.clear();
        const tracks = this.tracks;
        for(let i = 0, n = tracks.length; i < n; i++){
            let entry = tracks[i];
            if (!entry) continue;
            while(entry.mixingFrom)entry = entry.mixingFrom;
            do {
                if (!entry.mixingTo || entry.mixBlend != (0, $bbcccedbc883e405$export$ccab779a50275a35).add) this.computeHold(entry);
                entry = entry.mixingTo;
            }while (entry);
        }
    }
    computeHold(entry) {
        const to = entry.mixingTo;
        const timelines = entry.animation.timelines;
        const timelinesCount = entry.animation.timelines.length;
        const timelineMode = entry.timelineMode;
        timelineMode.length = timelinesCount;
        const timelineHoldMix = entry.timelineHoldMix;
        timelineHoldMix.length = 0;
        const propertyIDs = this.propertyIDs;
        if (to && to.holdPrevious) {
            for(let i = 0; i < timelinesCount; i++)timelineMode[i] = propertyIDs.addAll(timelines[i].getPropertyIds()) ? $02bea3975cac0842$var$HOLD_FIRST : $02bea3975cac0842$var$HOLD_SUBSEQUENT;
            return;
        }
        outer: for(let i = 0; i < timelinesCount; i++){
            const timeline = timelines[i];
            const ids = timeline.getPropertyIds();
            if (!propertyIDs.addAll(ids)) timelineMode[i] = $02bea3975cac0842$var$SUBSEQUENT;
            else if (!to || timeline instanceof (0, $fd5e2eaf5f163d40$export$7f2bfc5bd27cb43d) || timeline instanceof (0, $fd5e2eaf5f163d40$export$ece1f7c41d051e83) || timeline instanceof (0, $fd5e2eaf5f163d40$export$4f4bca996c586084) || !to.animation.hasTimeline(ids)) timelineMode[i] = $02bea3975cac0842$var$FIRST;
            else {
                for(let next = to.mixingTo; next; next = next.mixingTo){
                    if (next.animation.hasTimeline(ids)) continue;
                    if (entry.mixDuration > 0) {
                        timelineMode[i] = $02bea3975cac0842$var$HOLD_MIX;
                        timelineHoldMix[i] = next;
                        continue outer;
                    }
                    break;
                }
                timelineMode[i] = $02bea3975cac0842$var$HOLD_FIRST;
            }
        }
    }
    /** Returns the track entry for the animation currently playing on the track, or null if no animation is currently playing. */ getCurrent(trackIndex) {
        if (trackIndex >= this.tracks.length) return null;
        return this.tracks[trackIndex];
    }
    /** Adds a listener to receive events for all track entries. */ addListener(listener) {
        if (!listener) throw new Error("listener cannot be null.");
        this.listeners.push(listener);
    }
    /** Removes the listener added with {@link #addListener()}. */ removeListener(listener) {
        const index = this.listeners.indexOf(listener);
        if (index >= 0) this.listeners.splice(index, 1);
    }
    /** Removes all listeners added with {@link #addListener()}. */ clearListeners() {
        this.listeners.length = 0;
    }
    /** Discards all listener notifications that have not yet been delivered. This can be useful to call from an
   * {@link AnimationStateListener} when it is known that further notifications that may have been already queued for delivery
   * are not wanted because new animations are being set. */ clearListenerNotifications() {
        this.queue.clear();
    }
    setAnimationByName(trackIndex, animationName, loop) {
        if (!$02bea3975cac0842$var$_AnimationState.deprecatedWarning1) {
            $02bea3975cac0842$var$_AnimationState.deprecatedWarning1 = true;
            console.warn("Spine Deprecation Warning: AnimationState.setAnimationByName is deprecated, please use setAnimation from now on.");
        }
        this.setAnimation(trackIndex, animationName, loop);
    }
    addAnimationByName(trackIndex, animationName, loop, delay) {
        if (!$02bea3975cac0842$var$_AnimationState.deprecatedWarning2) {
            $02bea3975cac0842$var$_AnimationState.deprecatedWarning2 = true;
            console.warn("Spine Deprecation Warning: AnimationState.addAnimationByName is deprecated, please use addAnimation from now on.");
        }
        this.addAnimation(trackIndex, animationName, loop, delay);
    }
    hasAnimation(animationName) {
        const animation = this.data.skeletonData.findAnimation(animationName);
        return animation !== null;
    }
    hasAnimationByName(animationName) {
        if (!$02bea3975cac0842$var$_AnimationState.deprecatedWarning3) {
            $02bea3975cac0842$var$_AnimationState.deprecatedWarning3 = true;
            console.warn("Spine Deprecation Warning: AnimationState.hasAnimationByName is deprecated, please use hasAnimation from now on.");
        }
        return this.hasAnimation(animationName);
    }
};
let $02bea3975cac0842$export$d0f7a26c90cc1562 = $02bea3975cac0842$var$_AnimationState;
$02bea3975cac0842$export$d0f7a26c90cc1562._emptyAnimation = new (0, $fd5e2eaf5f163d40$export$c35d437ae5945fcd)("<empty>", [], 0);
$02bea3975cac0842$export$d0f7a26c90cc1562.deprecatedWarning1 = false;
$02bea3975cac0842$export$d0f7a26c90cc1562.deprecatedWarning2 = false;
$02bea3975cac0842$export$d0f7a26c90cc1562.deprecatedWarning3 = false;
const $02bea3975cac0842$var$_TrackEntry = class {
    constructor(){
        /** The animation to apply for this track entry. */ this.animation = null;
        this.previous = null;
        /** The animation queued to start after this animation, or null. `next` makes up a linked list. */ this.next = null;
        /** The track entry for the previous animation when mixing from the previous animation to this animation, or null if no
     * mixing is currently occuring. When mixing from multiple animations, `mixingFrom` makes up a linked list. */ this.mixingFrom = null;
        /** The track entry for the next animation when mixing from this animation to the next animation, or null if no mixing is
     * currently occuring. When mixing to multiple animations, `mixingTo` makes up a linked list. */ this.mixingTo = null;
        /** The listener for events generated by this track entry, or null.
     *
     * A track entry returned from {@link AnimationState#setAnimation()} is already the current animation
     * for the track, so the track entry listener {@link AnimationStateListener#start()} will not be called. */ this.listener = null;
        /** The index of the track where this track entry is either current or queued.
     *
     * See {@link AnimationState#getCurrent()}. */ this.trackIndex = 0;
        /** If true, the animation will repeat. If false it will not, instead its last frame is applied if played beyond its
     * duration. */ this.loop = false;
        /** If true, when mixing from the previous animation to this animation, the previous animation is applied as normal instead
     * of being mixed out.
     *
     * When mixing between animations that key the same property, if a lower track also keys that property then the value will
     * briefly dip toward the lower track value during the mix. This happens because the first animation mixes from 100% to 0%
     * while the second animation mixes from 0% to 100%. Setting `holdPrevious` to true applies the first animation
     * at 100% during the mix so the lower track value is overwritten. Such dipping does not occur on the lowest track which
     * keys the property, only when a higher track also keys the property.
     *
     * Snapping will occur if `holdPrevious` is true and this animation does not key all the same properties as the
     * previous animation. */ this.holdPrevious = false;
        this.reverse = false;
        this.shortestRotation = false;
        /** When the mix percentage ({@link #mixTime} / {@link #mixDuration}) is less than the
     * `eventThreshold`, event timelines are applied while this animation is being mixed out. Defaults to 0, so event
     * timelines are not applied while this animation is being mixed out. */ this.eventThreshold = 0;
        /** When the mix percentage ({@link #mixtime} / {@link #mixDuration}) is less than the
     * `attachmentThreshold`, attachment timelines are applied while this animation is being mixed out. Defaults to
     * 0, so attachment timelines are not applied while this animation is being mixed out. */ this.attachmentThreshold = 0;
        /** When the mix percentage ({@link #mixTime} / {@link #mixDuration}) is less than the
     * `drawOrderThreshold`, draw order timelines are applied while this animation is being mixed out. Defaults to 0,
     * so draw order timelines are not applied while this animation is being mixed out. */ this.drawOrderThreshold = 0;
        /** Seconds when this animation starts, both initially and after looping. Defaults to 0.
     *
     * When changing the `animationStart` time, it often makes sense to set {@link #animationLast} to the same
     * value to prevent timeline keys before the start time from triggering. */ this.animationStart = 0;
        /** Seconds for the last frame of this animation. Non-looping animations won't play past this time. Looping animations will
     * loop back to {@link #animationStart} at this time. Defaults to the animation {@link Animation#duration}. */ this.animationEnd = 0;
        /** The time in seconds this animation was last applied. Some timelines use this for one-time triggers. Eg, when this
     * animation is applied, event timelines will fire all events between the `animationLast` time (exclusive) and
     * `animationTime` (inclusive). Defaults to -1 to ensure triggers on frame 0 happen the first time this animation
     * is applied. */ this.animationLast = 0;
        this.nextAnimationLast = 0;
        /** Seconds to postpone playing the animation. When this track entry is the current track entry, `delay`
     * postpones incrementing the {@link #trackTime}. When this track entry is queued, `delay` is the time from
     * the start of the previous animation to when this track entry will become the current track entry (ie when the previous
     * track entry {@link TrackEntry#trackTime} >= this track entry's `delay`).
     *
     * {@link #timeScale} affects the delay. */ this.delay = 0;
        /** Current time in seconds this track entry has been the current track entry. The track time determines
     * {@link #animationTime}. The track time can be set to start the animation at a time other than 0, without affecting
     * looping. */ this.trackTime = 0;
        this.trackLast = 0;
        this.nextTrackLast = 0;
        /** The track time in seconds when this animation will be removed from the track. Defaults to the highest possible float
     * value, meaning the animation will be applied until a new animation is set or the track is cleared. If the track end time
     * is reached, no other animations are queued for playback, and mixing from any previous animations is complete, then the
     * properties keyed by the animation are set to the setup pose and the track is cleared.
     *
     * It may be desired to use {@link AnimationState#addEmptyAnimation()} rather than have the animation
     * abruptly cease being applied. */ this.trackEnd = 0;
        /** Multiplier for the delta time when this track entry is updated, causing time for this animation to pass slower or
     * faster. Defaults to 1.
     *
     * {@link #mixTime} is not affected by track entry time scale, so {@link #mixDuration} may need to be adjusted to
     * match the animation speed.
     *
     * When using {@link AnimationState#addAnimation()} with a `delay` <= 0, note the
     * {@link #delay} is set using the mix duration from the {@link AnimationStateData}, assuming time scale to be 1. If
     * the time scale is not 1, the delay may need to be adjusted.
     *
     * See AnimationState {@link AnimationState#timeScale} for affecting all animations. */ this.timeScale = 0;
        /** Values < 1 mix this animation with the skeleton's current pose (usually the pose resulting from lower tracks). Defaults
     * to 1, which overwrites the skeleton's current pose with this animation.
     *
     * Typically track 0 is used to completely pose the skeleton, then alpha is used on higher tracks. It doesn't make sense to
     * use alpha on track 0 if the skeleton pose is from the last frame render. */ this.alpha = 0;
        /** Seconds from 0 to the {@link #getMixDuration()} when mixing from the previous animation to this animation. May be
     * slightly more than `mixDuration` when the mix is complete. */ this.mixTime = 0;
        /** Seconds for mixing from the previous animation to this animation. Defaults to the value provided by AnimationStateData
     * {@link AnimationStateData#getMix()} based on the animation before this animation (if any).
     *
     * A mix duration of 0 still mixes out over one frame to provide the track entry being mixed out a chance to revert the
     * properties it was animating.
     *
     * The `mixDuration` can be set manually rather than use the value from
     * {@link AnimationStateData#getMix()}. In that case, the `mixDuration` can be set for a new
     * track entry only before {@link AnimationState#update(float)} is first called.
     *
     * When using {@link AnimationState#addAnimation()} with a `delay` <= 0, note the
     * {@link #delay} is set using the mix duration from the {@link AnimationStateData}, not a mix duration set
     * afterward. */ this.mixDuration = 0;
        this.interruptAlpha = 0;
        this.totalAlpha = 0;
        /** Controls how properties keyed in the animation are mixed with lower tracks. Defaults to {@link MixBlend#replace}, which
     * replaces the values from the lower tracks with the animation values. {@link MixBlend#add} adds the animation values to
     * the values from the lower tracks.
     *
     * The `mixBlend` can be set for a new track entry only before {@link AnimationState#apply()} is first
     * called. */ this.mixBlend = (0, $bbcccedbc883e405$export$ccab779a50275a35).replace;
        this.timelineMode = new Array();
        this.timelineHoldMix = new Array();
        this.timelinesRotation = new Array();
    }
    reset() {
        this.next = null;
        this.previous = null;
        this.mixingFrom = null;
        this.mixingTo = null;
        this.animation = null;
        this.listener = null;
        this.timelineMode.length = 0;
        this.timelineHoldMix.length = 0;
        this.timelinesRotation.length = 0;
    }
    /** Uses {@link #trackTime} to compute the `animationTime`, which is between {@link #animationStart}
   * and {@link #animationEnd}. When the `trackTime` is 0, the `animationTime` is equal to the
   * `animationStart` time. */ getAnimationTime() {
        if (this.loop) {
            const duration = this.animationEnd - this.animationStart;
            if (duration == 0) return this.animationStart;
            return this.trackTime % duration + this.animationStart;
        }
        return Math.min(this.trackTime + this.animationStart, this.animationEnd);
    }
    setAnimationLast(animationLast) {
        this.animationLast = animationLast;
        this.nextAnimationLast = animationLast;
    }
    /** Returns true if at least one loop has been completed.
   *
   * See {@link AnimationStateListener#complete()}. */ isComplete() {
        return this.trackTime >= this.animationEnd - this.animationStart;
    }
    /** Resets the rotation directions for mixing this entry's rotate timelines. This can be useful to avoid bones rotating the
   * long way around when using {@link #alpha} and starting animations on other tracks.
   *
   * Mixing with {@link MixBlend#replace} involves finding a rotation between two others, which has two possible solutions:
   * the short way or the long way around. The two rotations likely change over time, so which direction is the short or long
   * way also changes. If the short way was always chosen, bones would flip to the other side when that direction became the
   * long way. TrackEntry chooses the short way the first time it is applied and remembers that direction. */ resetRotationDirections() {
        this.timelinesRotation.length = 0;
    }
    getTrackComplete() {
        const duration = this.animationEnd - this.animationStart;
        if (duration != 0) {
            if (this.loop) return duration * (1 + (this.trackTime / duration | 0));
            if (this.trackTime < duration) return duration;
        }
        return this.trackTime;
    }
    get time() {
        if (!$02bea3975cac0842$var$_TrackEntry.deprecatedWarning1) {
            $02bea3975cac0842$var$_TrackEntry.deprecatedWarning1 = true;
            console.warn("Spine Deprecation Warning: TrackEntry.time is deprecated, please use trackTime from now on.");
        }
        return this.trackTime;
    }
    set time(value) {
        if (!$02bea3975cac0842$var$_TrackEntry.deprecatedWarning1) {
            $02bea3975cac0842$var$_TrackEntry.deprecatedWarning1 = true;
            console.warn("Spine Deprecation Warning: TrackEntry.time is deprecated, please use trackTime from now on.");
        }
        this.trackTime = value;
    }
    get endTime() {
        if (!$02bea3975cac0842$var$_TrackEntry.deprecatedWarning2) {
            $02bea3975cac0842$var$_TrackEntry.deprecatedWarning2 = true;
            console.warn("Spine Deprecation Warning: TrackEntry.endTime is deprecated, please use trackEnd from now on.");
        }
        return this.trackTime;
    }
    set endTime(value) {
        if (!$02bea3975cac0842$var$_TrackEntry.deprecatedWarning2) {
            $02bea3975cac0842$var$_TrackEntry.deprecatedWarning2 = true;
            console.warn("Spine Deprecation Warning: TrackEntry.endTime is deprecated, please use trackEnd from now on.");
        }
        this.trackTime = value;
    }
    loopsCount() {
        return Math.floor(this.trackTime / this.trackEnd);
    }
};
let $02bea3975cac0842$export$6fd48f25bc0ee658 = $02bea3975cac0842$var$_TrackEntry;
$02bea3975cac0842$export$6fd48f25bc0ee658.deprecatedWarning1 = false;
$02bea3975cac0842$export$6fd48f25bc0ee658.deprecatedWarning2 = false;
class $02bea3975cac0842$export$2fc6338444a158e6 {
    constructor(animState){
        this.objects = [];
        this.drainDisabled = false;
        this.animState = animState;
    }
    start(entry) {
        this.objects.push($02bea3975cac0842$export$3d7865934588d77e.start);
        this.objects.push(entry);
        this.animState.animationsChanged = true;
    }
    interrupt(entry) {
        this.objects.push($02bea3975cac0842$export$3d7865934588d77e.interrupt);
        this.objects.push(entry);
    }
    end(entry) {
        this.objects.push($02bea3975cac0842$export$3d7865934588d77e.end);
        this.objects.push(entry);
        this.animState.animationsChanged = true;
    }
    dispose(entry) {
        this.objects.push($02bea3975cac0842$export$3d7865934588d77e.dispose);
        this.objects.push(entry);
    }
    complete(entry) {
        this.objects.push($02bea3975cac0842$export$3d7865934588d77e.complete);
        this.objects.push(entry);
    }
    event(entry, event) {
        this.objects.push($02bea3975cac0842$export$3d7865934588d77e.event);
        this.objects.push(entry);
        this.objects.push(event);
    }
    drain() {
        if (this.drainDisabled) return;
        this.drainDisabled = true;
        const objects = this.objects;
        const listeners = this.animState.listeners;
        for(let i = 0; i < objects.length; i += 2){
            const type = objects[i];
            const entry = objects[i + 1];
            switch(type){
                case $02bea3975cac0842$export$3d7865934588d77e.start:
                    if (entry.listener && entry.listener.start) entry.listener.start(entry);
                    for(let ii = 0; ii < listeners.length; ii++){
                        const listener = listeners[ii];
                        if (listener.start) listener.start(entry);
                    }
                    break;
                case $02bea3975cac0842$export$3d7865934588d77e.interrupt:
                    if (entry.listener && entry.listener.interrupt) entry.listener.interrupt(entry);
                    for(let ii = 0; ii < listeners.length; ii++){
                        const listener = listeners[ii];
                        if (listener.interrupt) listener.interrupt(entry);
                    }
                    break;
                case $02bea3975cac0842$export$3d7865934588d77e.end:
                    if (entry.listener && entry.listener.end) entry.listener.end(entry);
                    for(let ii = 0; ii < listeners.length; ii++){
                        const listener = listeners[ii];
                        if (listener.end) listener.end(entry);
                    }
                case $02bea3975cac0842$export$3d7865934588d77e.dispose:
                    if (entry.listener && entry.listener.dispose) entry.listener.dispose(entry);
                    for(let ii = 0; ii < listeners.length; ii++){
                        const listener = listeners[ii];
                        if (listener.dispose) listener.dispose(entry);
                    }
                    this.animState.trackEntryPool.free(entry);
                    break;
                case $02bea3975cac0842$export$3d7865934588d77e.complete:
                    if (entry.listener && entry.listener.complete) entry.listener.complete(entry);
                    for(let ii = 0; ii < listeners.length; ii++){
                        const listener = listeners[ii];
                        if (listener.complete) listener.complete(entry);
                    }
                    break;
                case $02bea3975cac0842$export$3d7865934588d77e.event:
                    const event = objects[i++ + 2];
                    if (entry.listener && entry.listener.event) entry.listener.event(entry, event);
                    for(let ii = 0; ii < listeners.length; ii++){
                        const listener = listeners[ii];
                        if (listener.event) listener.event(entry, event);
                    }
                    break;
            }
        }
        this.clear();
        this.drainDisabled = false;
    }
    clear() {
        this.objects.length = 0;
    }
}
var $02bea3975cac0842$export$3d7865934588d77e = /* @__PURE__ */ ((EventType2)=>{
    EventType2[EventType2["start"] = 0] = "start";
    EventType2[EventType2["interrupt"] = 1] = "interrupt";
    EventType2[EventType2["end"] = 2] = "end";
    EventType2[EventType2["dispose"] = 3] = "dispose";
    EventType2[EventType2["complete"] = 4] = "complete";
    EventType2[EventType2["event"] = 5] = "event";
    return EventType2;
})($02bea3975cac0842$export$3d7865934588d77e || {});
class $02bea3975cac0842$export$31af0cf42be5a74d {
    start(entry) {}
    interrupt(entry) {}
    end(entry) {}
    dispose(entry) {}
    complete(entry) {}
    event(entry, event) {}
}
const $02bea3975cac0842$var$SUBSEQUENT = 0;
const $02bea3975cac0842$var$FIRST = 1;
const $02bea3975cac0842$var$HOLD_SUBSEQUENT = 2;
const $02bea3975cac0842$var$HOLD_FIRST = 3;
const $02bea3975cac0842$var$HOLD_MIX = 4;
const $02bea3975cac0842$var$SETUP = 1;
const $02bea3975cac0842$var$CURRENT = 2;


class $c7965d26af0af10e$export$90d7167cc0605975 {
    constructor(skeletonData){
        this.animationToMixTime = {};
        /** The mix duration to use when no mix duration has been defined between two animations. */ this.defaultMix = 0;
        if (!skeletonData) throw new Error("skeletonData cannot be null.");
        this.skeletonData = skeletonData;
    }
    /** Sets a mix duration by animation name.
   *
   * See {@link #setMixWith()}. */ setMix(fromName, toName, duration) {
        const from = this.skeletonData.findAnimation(fromName);
        if (!from) throw new Error(`Animation not found: ${fromName}`);
        const to = this.skeletonData.findAnimation(toName);
        if (!to) throw new Error(`Animation not found: ${toName}`);
        this.setMixWith(from, to, duration);
    }
    /** Sets the mix duration when changing from the specified animation to the other.
   *
   * See {@link TrackEntry#mixDuration}. */ setMixWith(from, to, duration) {
        if (!from) throw new Error("from cannot be null.");
        if (!to) throw new Error("to cannot be null.");
        const key = `${from.name}.${to.name}`;
        this.animationToMixTime[key] = duration;
    }
    /** Returns the mix duration to use when changing from the specified animation to the other, or the {@link #defaultMix} if
   * no mix duration has been set. */ getMix(from, to) {
        const key = `${from.name}.${to.name}`;
        const value = this.animationToMixTime[key];
        return value === void 0 ? this.defaultMix : value;
    }
}










class $e1f9342c07c31bce$export$2ff9add835475d95 {
    constructor(atlas){
        this.atlas = atlas;
    }
    loadSequence(name, basePath, sequence) {
        const regions = sequence.regions;
        for(let i = 0, n = regions.length; i < n; i++){
            const path = sequence.getPath(basePath, i);
            const region = this.atlas.findRegion(path);
            if (region == null) throw new Error(`Region not found in atlas: ${path} (sequence: ${name})`);
            regions[i] = region;
            regions[i].renderObject = regions[i];
        }
    }
    newRegionAttachment(skin, name, path, sequence) {
        const attachment = new (0, $47a62d8b9e0a7455$export$d0fc51466fa6d530)(name, path);
        if (sequence != null) this.loadSequence(name, path, sequence);
        else {
            const region = this.atlas.findRegion(path);
            if (!region) throw new Error(`Region not found in atlas: ${path} (region attachment: ${name})`);
            region.renderObject = region;
            attachment.region = region;
        }
        return attachment;
    }
    newMeshAttachment(skin, name, path, sequence) {
        const attachment = new (0, $2085f04ed3d5f336$export$3f1c1692adfcf3e2)(name, path);
        if (sequence != null) this.loadSequence(name, path, sequence);
        else {
            const region = this.atlas.findRegion(path);
            if (!region) throw new Error(`Region not found in atlas: ${path} (mesh attachment: ${name})`);
            region.renderObject = region;
            attachment.region = region;
        }
        return attachment;
    }
    newBoundingBoxAttachment(skin, name) {
        return new (0, $63a6fc6d003ab8b1$export$9538c439c6b85ad2)(name);
    }
    newPathAttachment(skin, name) {
        return new (0, $7aafbf7cd242ca5e$export$d285e3ec07b32800)(name);
    }
    newPointAttachment(skin, name) {
        return new (0, $ec38bb05db75a9af$export$1b528cde44a6ab5)(name);
    }
    newClippingAttachment(skin, name) {
        return new (0, $faf5f501ea017e7d$export$838805e22b9b55f1)(name);
    }
}




class $aa12cb1aa94e7136$export$b127726e56765aa4 {
    /** @param parent May be null. */ constructor(data, skeleton, parent){
        // be careful! Spine b,c is c,b in pixi matrix
        this.matrix = new (0, $d7da222aa639cde0$export$5b12bf1653c0dd85)();
        /** The parent bone, or null if this is the root bone. */ this.parent = null;
        /** The immediate children of this bone. */ this.children = new Array();
        /** The local x translation. */ this.x = 0;
        /** The local y translation. */ this.y = 0;
        /** The local rotation in degrees, counter clockwise. */ this.rotation = 0;
        /** The local scaleX. */ this.scaleX = 0;
        /** The local scaleY. */ this.scaleY = 0;
        /** The local shearX. */ this.shearX = 0;
        /** The local shearY. */ this.shearY = 0;
        /** The applied local x translation. */ this.ax = 0;
        /** The applied local y translation. */ this.ay = 0;
        /** The applied local rotation in degrees, counter clockwise. */ this.arotation = 0;
        /** The applied local scaleX. */ this.ascaleX = 0;
        /** The applied local scaleY. */ this.ascaleY = 0;
        /** The applied local shearX. */ this.ashearX = 0;
        /** The applied local shearY. */ this.ashearY = 0;
        this.sorted = false;
        this.active = false;
        if (!data) throw new Error("data cannot be null.");
        if (!skeleton) throw new Error("skeleton cannot be null.");
        this.data = data;
        this.skeleton = skeleton;
        this.parent = parent;
        this.setToSetupPose();
    }
    get worldX() {
        return this.matrix.tx;
    }
    get worldY() {
        return this.matrix.ty;
    }
    /** Returns false when the bone has not been computed because {@link BoneData#skinRequired} is true and the
   * {@link Skeleton#skin active skin} does not {@link Skin#bones contain} this bone. */ isActive() {
        return this.active;
    }
    /** Computes the world transform using the parent bone and this bone's local applied transform. */ update() {
        this.updateWorldTransformWith(this.ax, this.ay, this.arotation, this.ascaleX, this.ascaleY, this.ashearX, this.ashearY);
    }
    /** Computes the world transform using the parent bone and this bone's local transform.
   *
   * See {@link #updateWorldTransformWith()}. */ updateWorldTransform() {
        this.updateWorldTransformWith(this.x, this.y, this.rotation, this.scaleX, this.scaleY, this.shearX, this.shearY);
    }
    /** Computes the world transform using the parent bone and the specified local transform. The applied transform is set to the
   * specified local transform. Child bones are not updated.
   *
   * See [World transforms](http://esotericsoftware.com/spine-runtime-skeletons#World-transforms) in the Spine
   * Runtimes Guide. */ updateWorldTransformWith(x, y, rotation, scaleX, scaleY, shearX, shearY) {
        this.ax = x;
        this.ay = y;
        this.arotation = rotation;
        this.ascaleX = scaleX;
        this.ascaleY = scaleY;
        this.ashearX = shearX;
        this.ashearY = shearY;
        const parent = this.parent;
        const m = this.matrix;
        const sx = this.skeleton.scaleX;
        const sy = (0, $1840f66876ded594$export$a5a6e0b888b2c992).yDown ? -this.skeleton.scaleY : this.skeleton.scaleY;
        if (!parent) {
            const skeleton = this.skeleton;
            const rotationY = rotation + 90 + shearY;
            m.a = (0, $8804784813ffae81$export$6a7ef315a0d1ef07).cosDeg(rotation + shearX) * scaleX * sx;
            m.c = (0, $8804784813ffae81$export$6a7ef315a0d1ef07).cosDeg(rotationY) * scaleY * sx;
            m.b = (0, $8804784813ffae81$export$6a7ef315a0d1ef07).sinDeg(rotation + shearX) * scaleX * sy;
            m.d = (0, $8804784813ffae81$export$6a7ef315a0d1ef07).sinDeg(rotationY) * scaleY * sy;
            m.tx = x * sx + skeleton.x;
            m.ty = y * sy + skeleton.y;
            return;
        }
        let pa = parent.matrix.a;
        let pb = parent.matrix.c;
        let pc = parent.matrix.b;
        let pd = parent.matrix.d;
        m.tx = pa * x + pb * y + parent.matrix.tx;
        m.ty = pc * x + pd * y + parent.matrix.ty;
        switch(this.data.transformMode){
            case (0, $ccc5aebc60cbf024$export$4c408f82786a534d).Normal:
                {
                    const rotationY = rotation + 90 + shearY;
                    const la = (0, $8804784813ffae81$export$6a7ef315a0d1ef07).cosDeg(rotation + shearX) * scaleX;
                    const lb = (0, $8804784813ffae81$export$6a7ef315a0d1ef07).cosDeg(rotationY) * scaleY;
                    const lc = (0, $8804784813ffae81$export$6a7ef315a0d1ef07).sinDeg(rotation + shearX) * scaleX;
                    const ld = (0, $8804784813ffae81$export$6a7ef315a0d1ef07).sinDeg(rotationY) * scaleY;
                    m.a = pa * la + pb * lc;
                    m.c = pa * lb + pb * ld;
                    m.b = pc * la + pd * lc;
                    m.d = pc * lb + pd * ld;
                    return;
                }
            case (0, $ccc5aebc60cbf024$export$4c408f82786a534d).OnlyTranslation:
                {
                    const rotationY = rotation + 90 + shearY;
                    m.a = (0, $8804784813ffae81$export$6a7ef315a0d1ef07).cosDeg(rotation + shearX) * scaleX;
                    m.c = (0, $8804784813ffae81$export$6a7ef315a0d1ef07).cosDeg(rotationY) * scaleY;
                    m.b = (0, $8804784813ffae81$export$6a7ef315a0d1ef07).sinDeg(rotation + shearX) * scaleX;
                    m.d = (0, $8804784813ffae81$export$6a7ef315a0d1ef07).sinDeg(rotationY) * scaleY;
                    break;
                }
            case (0, $ccc5aebc60cbf024$export$4c408f82786a534d).NoRotationOrReflection:
                {
                    let s = pa * pa + pc * pc;
                    let prx = 0;
                    if (s > 1e-4) {
                        s = Math.abs(pa * pd - pb * pc) / s;
                        pa /= sx;
                        pc /= sy;
                        pb = pc * s;
                        pd = pa * s;
                        prx = Math.atan2(pc, pa) * (0, $8804784813ffae81$export$6a7ef315a0d1ef07).radDeg;
                    } else {
                        pa = 0;
                        pc = 0;
                        prx = 90 - Math.atan2(pd, pb) * (0, $8804784813ffae81$export$6a7ef315a0d1ef07).radDeg;
                    }
                    const rx = rotation + shearX - prx;
                    const ry = rotation + shearY - prx + 90;
                    const la = (0, $8804784813ffae81$export$6a7ef315a0d1ef07).cosDeg(rx) * scaleX;
                    const lb = (0, $8804784813ffae81$export$6a7ef315a0d1ef07).cosDeg(ry) * scaleY;
                    const lc = (0, $8804784813ffae81$export$6a7ef315a0d1ef07).sinDeg(rx) * scaleX;
                    const ld = (0, $8804784813ffae81$export$6a7ef315a0d1ef07).sinDeg(ry) * scaleY;
                    m.a = pa * la - pb * lc;
                    m.c = pa * lb - pb * ld;
                    m.b = pc * la + pd * lc;
                    m.d = pc * lb + pd * ld;
                    break;
                }
            case (0, $ccc5aebc60cbf024$export$4c408f82786a534d).NoScale:
            case (0, $ccc5aebc60cbf024$export$4c408f82786a534d).NoScaleOrReflection:
                {
                    const cos = (0, $8804784813ffae81$export$6a7ef315a0d1ef07).cosDeg(rotation);
                    const sin = (0, $8804784813ffae81$export$6a7ef315a0d1ef07).sinDeg(rotation);
                    let za = (pa * cos + pb * sin) / sx;
                    let zc = (pc * cos + pd * sin) / sy;
                    let s = Math.sqrt(za * za + zc * zc);
                    if (s > 1e-5) s = 1 / s;
                    za *= s;
                    zc *= s;
                    s = Math.sqrt(za * za + zc * zc);
                    if (this.data.transformMode == (0, $ccc5aebc60cbf024$export$4c408f82786a534d).NoScale && pa * pd - pb * pc < 0 != (sx < 0 != sy < 0)) s = -s;
                    const r = Math.PI / 2 + Math.atan2(zc, za);
                    const zb = Math.cos(r) * s;
                    const zd = Math.sin(r) * s;
                    const la = (0, $8804784813ffae81$export$6a7ef315a0d1ef07).cosDeg(shearX) * scaleX;
                    const lb = (0, $8804784813ffae81$export$6a7ef315a0d1ef07).cosDeg(90 + shearY) * scaleY;
                    const lc = (0, $8804784813ffae81$export$6a7ef315a0d1ef07).sinDeg(shearX) * scaleX;
                    const ld = (0, $8804784813ffae81$export$6a7ef315a0d1ef07).sinDeg(90 + shearY) * scaleY;
                    m.a = za * la + zb * lc;
                    m.c = za * lb + zb * ld;
                    m.b = zc * la + zd * lc;
                    m.d = zc * lb + zd * ld;
                    break;
                }
        }
        m.a *= sx;
        m.c *= sx;
        m.b *= sy;
        m.d *= sy;
    }
    /** Sets this bone's local transform to the setup pose. */ setToSetupPose() {
        const data = this.data;
        this.x = data.x;
        this.y = data.y;
        this.rotation = data.rotation;
        this.scaleX = data.scaleX;
        this.scaleY = data.scaleY;
        this.shearX = data.shearX;
        this.shearY = data.shearY;
    }
    /** The world rotation for the X axis, calculated using {@link #a} and {@link #c}. */ getWorldRotationX() {
        return Math.atan2(this.matrix.b, this.matrix.a) * (0, $8804784813ffae81$export$6a7ef315a0d1ef07).radDeg;
    }
    /** The world rotation for the Y axis, calculated using {@link #b} and {@link #d}. */ getWorldRotationY() {
        return Math.atan2(this.matrix.d, this.matrix.c) * (0, $8804784813ffae81$export$6a7ef315a0d1ef07).radDeg;
    }
    /** The magnitude (always positive) of the world scale X, calculated using {@link #a} and {@link #c}. */ getWorldScaleX() {
        const m = this.matrix;
        return Math.sqrt(m.a * m.a + m.b * m.b);
    }
    /** The magnitude (always positive) of the world scale Y, calculated using {@link #b} and {@link #d}. */ getWorldScaleY() {
        const m = this.matrix;
        return Math.sqrt(m.c * m.c + m.d * m.d);
    }
    /** Computes the applied transform values from the world transform.
   *
   * If the world transform is modified (by a constraint, {@link #rotateWorld(float)}, etc) then this method should be called so
   * the applied transform matches the world transform. The applied transform may be needed by other code (eg to apply other
   * constraints).
   *
   * Some information is ambiguous in the world transform, such as -1,-1 scale versus 180 rotation. The applied transform after
   * calling this method is equivalent to the local transform used to compute the world transform, but may not be identical. */ updateAppliedTransform() {
        const parent = this.parent;
        const m = this.matrix;
        if (!parent) {
            this.ax = m.tx - this.skeleton.x;
            this.ay = m.ty - this.skeleton.y;
            this.arotation = Math.atan2(m.b, m.a) * (0, $8804784813ffae81$export$6a7ef315a0d1ef07).radDeg;
            this.ascaleX = Math.sqrt(m.a * m.a + m.b * m.b);
            this.ascaleY = Math.sqrt(m.c * m.c + m.d * m.d);
            this.ashearX = 0;
            this.ashearY = Math.atan2(m.a * m.c + m.b * m.d, m.a * m.d - m.b * m.c) * (0, $8804784813ffae81$export$6a7ef315a0d1ef07).radDeg;
            return;
        }
        const pm = parent.matrix;
        const pid = 1 / (pm.a * pm.d - pm.b * pm.c);
        const dx = m.tx - pm.tx;
        const dy = m.ty - pm.ty;
        this.ax = dx * pm.d * pid - dy * pm.c * pid;
        this.ay = dy * pm.a * pid - dx * pm.b * pid;
        const ia = pid * pm.d;
        const id = pid * pm.a;
        const ib = pid * pm.c;
        const ic = pid * pm.b;
        const ra = ia * m.a - ib * m.b;
        const rb = ia * m.c - ib * m.d;
        const rc = id * m.b - ic * m.a;
        const rd = id * m.d - ic * m.c;
        this.ashearX = 0;
        this.ascaleX = Math.sqrt(ra * ra + rc * rc);
        if (this.ascaleX > 1e-4) {
            const det = ra * rd - rb * rc;
            this.ascaleY = det / this.ascaleX;
            this.ashearY = Math.atan2(ra * rb + rc * rd, det) * (0, $8804784813ffae81$export$6a7ef315a0d1ef07).radDeg;
            this.arotation = Math.atan2(rc, ra) * (0, $8804784813ffae81$export$6a7ef315a0d1ef07).radDeg;
        } else {
            this.ascaleX = 0;
            this.ascaleY = Math.sqrt(rb * rb + rd * rd);
            this.ashearY = 0;
            this.arotation = 90 - Math.atan2(rd, rb) * (0, $8804784813ffae81$export$6a7ef315a0d1ef07).radDeg;
        }
    }
    /** Transforms a point from world coordinates to the bone's local coordinates. */ worldToLocal(world) {
        const m = this.matrix;
        const a = m.a;
        const b = m.c;
        const c = m.b;
        const d = m.d;
        const invDet = 1 / (a * d - b * c);
        const x = world.x - m.tx;
        const y = world.y - m.ty;
        world.x = x * d * invDet - y * b * invDet;
        world.y = y * a * invDet - x * c * invDet;
        return world;
    }
    /** Transforms a point from the bone's local coordinates to world coordinates. */ localToWorld(local) {
        const m = this.matrix;
        const x = local.x;
        const y = local.y;
        local.x = x * m.a + y * m.c + m.tx;
        local.y = x * m.b + y * m.d + m.ty;
        return local;
    }
    /** Transforms a world rotation to a local rotation. */ worldToLocalRotation(worldRotation) {
        const sin = (0, $8804784813ffae81$export$6a7ef315a0d1ef07).sinDeg(worldRotation);
        const cos = (0, $8804784813ffae81$export$6a7ef315a0d1ef07).cosDeg(worldRotation);
        const mat = this.matrix;
        return Math.atan2(mat.a * sin - mat.b * cos, mat.d * cos - mat.c * sin) * (0, $8804784813ffae81$export$6a7ef315a0d1ef07).radDeg;
    }
    /** Transforms a local rotation to a world rotation. */ localToWorldRotation(localRotation) {
        localRotation -= this.rotation - this.shearX;
        const sin = (0, $8804784813ffae81$export$6a7ef315a0d1ef07).sinDeg(localRotation);
        const cos = (0, $8804784813ffae81$export$6a7ef315a0d1ef07).cosDeg(localRotation);
        const mat = this.matrix;
        return Math.atan2(cos * mat.b + sin * mat.d, cos * mat.a + sin * mat.c) * (0, $8804784813ffae81$export$6a7ef315a0d1ef07).radDeg;
    }
    /** Rotates the world transform the specified amount.
   * <p>
   * After changes are made to the world transform, {@link #updateAppliedTransform()} should be called and {@link #update()} will
   * need to be called on any child bones, recursively. */ rotateWorld(degrees) {
        const mat = this.matrix;
        const a = mat.a;
        const b = mat.c;
        const c = mat.b;
        const d = mat.d;
        const cos = (0, $8804784813ffae81$export$6a7ef315a0d1ef07).cosDeg(degrees);
        const sin = (0, $8804784813ffae81$export$6a7ef315a0d1ef07).sinDeg(degrees);
        mat.a = cos * a - sin * c;
        mat.c = cos * b - sin * d;
        mat.b = sin * a + cos * c;
        mat.d = sin * b + cos * d;
    }
}



class $b873069de67ba47c$export$7d85d96cf093e12f {
    constructor(index, name, parent){
        /** The index of the bone in {@link Skeleton#getBones()}. */ this.index = 0;
        /** @returns May be null. */ this.parent = null;
        /** The bone's length. */ this.length = 0;
        /** The local x translation. */ this.x = 0;
        /** The local y translation. */ this.y = 0;
        /** The local rotation. */ this.rotation = 0;
        /** The local scaleX. */ this.scaleX = 1;
        /** The local scaleY. */ this.scaleY = 1;
        /** The local shearX. */ this.shearX = 0;
        /** The local shearX. */ this.shearY = 0;
        /** The transform mode for how parent world transforms affect this bone. */ this.transformMode = (0, $ccc5aebc60cbf024$export$4c408f82786a534d).Normal;
        /** When true, {@link Skeleton#updateWorldTransform()} only updates this bone if the {@link Skeleton#skin} contains this
     * bone.
     * @see Skin#bones */ this.skinRequired = false;
        /** The color of the bone as it was in Spine. Available only when nonessential data was exported. Bones are not usually
     * rendered at runtime. */ this.color = new (0, $8804784813ffae81$export$892596cec99bc70e)();
        if (index < 0) throw new Error("index must be >= 0.");
        if (!name) throw new Error("name cannot be null.");
        this.index = index;
        this.name = name;
        this.parent = parent;
    }
}


class $6e2eadc25b36742c$export$b826e1ab3af63566 {
    constructor(name, order, skinRequired){
        this.name = name;
        this.order = order;
        this.skinRequired = skinRequired;
    }
}


class $b69dd53da9706657$export$d61e24a684f9e51 {
    constructor(time, data){
        this.intValue = 0;
        this.floatValue = 0;
        this.stringValue = null;
        this.time = 0;
        this.volume = 0;
        this.balance = 0;
        if (!data) throw new Error("data cannot be null.");
        this.time = time;
        this.data = data;
    }
}


class $57711e45b8cfda24$export$a5cf049e34c3d11e {
    constructor(name){
        this.intValue = 0;
        this.floatValue = 0;
        this.stringValue = null;
        this.audioPath = null;
        this.volume = 0;
        this.balance = 0;
        this.name = name;
    }
}



class $d2a70cbd94aab7f0$export$3c158c80ff28c177 {
    constructor(data, skeleton){
        /** Controls the bend direction of the IK bones, either 1 or -1. */ this.bendDirection = 0;
        /** When true and only a single bone is being constrained, if the target is too close, the bone is scaled to reach it. */ this.compress = false;
        /** When true, if the target is out of range, the parent bone is scaled to reach it. If more than one bone is being constrained
     * and the parent bone has local nonuniform scale, stretch is not applied. */ this.stretch = false;
        /** A percentage (0-1) that controls the mix between the constrained and unconstrained rotations. */ this.mix = 1;
        /** For two bone IK, the distance from the maximum reach of the bones that rotation will slow. */ this.softness = 0;
        this.active = false;
        if (!data) throw new Error("data cannot be null.");
        if (!skeleton) throw new Error("skeleton cannot be null.");
        this.data = data;
        this.mix = data.mix;
        this.softness = data.softness;
        this.bendDirection = data.bendDirection;
        this.compress = data.compress;
        this.stretch = data.stretch;
        this.bones = new Array();
        for(let i = 0; i < data.bones.length; i++){
            const bone = skeleton.findBone(data.bones[i].name);
            if (!bone) throw new Error(`Couldn't find bone ${data.bones[i].name}`);
            this.bones.push(bone);
        }
        const target = skeleton.findBone(data.target.name);
        if (!target) throw new Error(`Couldn't find bone ${data.target.name}`);
        this.target = target;
    }
    isActive() {
        return this.active;
    }
    update() {
        if (this.mix == 0) return;
        const target = this.target;
        const bones = this.bones;
        switch(bones.length){
            case 1:
                this.apply1(bones[0], target.worldX, target.worldY, this.compress, this.stretch, this.data.uniform, this.mix);
                break;
            case 2:
                this.apply2(bones[0], bones[1], target.worldX, target.worldY, this.bendDirection, this.stretch, this.data.uniform, this.softness, this.mix);
                break;
        }
    }
    /** Applies 1 bone IK. The target is specified in the world coordinate system. */ apply1(bone, targetX, targetY, compress, stretch, uniform, alpha) {
        const p = bone.parent.matrix;
        if (!p) throw new Error("IK bone must have parent.");
        const pa = p.a;
        let pb = p.c;
        const pc = p.b;
        let pd = p.d;
        let rotationIK = -bone.ashearX - bone.arotation;
        let tx = 0;
        let ty = 0;
        const skelX = bone.skeleton.scaleX;
        const skelY = (0, $1840f66876ded594$export$a5a6e0b888b2c992).yDown ? -bone.skeleton.scaleY : bone.skeleton.scaleY;
        switch(bone.data.transformMode){
            case (0, $ccc5aebc60cbf024$export$4c408f82786a534d).OnlyTranslation:
                tx = targetX - bone.worldX;
                ty = targetY - bone.worldY;
                if ((0, $1840f66876ded594$export$a5a6e0b888b2c992).yDown) ty = -ty;
                break;
            case (0, $ccc5aebc60cbf024$export$4c408f82786a534d).NoRotationOrReflection:
                const s = Math.abs(pa * pd - pb * pc) / (pa * pa + pc * pc);
                const sa = pa / skelX;
                const sc = pc / skelY;
                pb = -sc * s * skelX;
                pd = sa * s * skelY;
                rotationIK += Math.atan2(sc, sa) * (0, $8804784813ffae81$export$6a7ef315a0d1ef07).radDeg;
            default:
                const x = targetX - p.tx;
                const y = targetY - p.ty;
                const d = pa * pd - pb * pc;
                tx = (x * pd - y * pb) / d - bone.ax;
                ty = (y * pa - x * pc) / d - bone.ay;
        }
        rotationIK += Math.atan2(ty, tx) * (0, $8804784813ffae81$export$6a7ef315a0d1ef07).radDeg;
        if (bone.ascaleX < 0) rotationIK += 180;
        if (rotationIK > 180) rotationIK -= 360;
        else if (rotationIK < -180) rotationIK += 360;
        let sx = bone.ascaleX;
        let sy = bone.ascaleY;
        if (compress || stretch) {
            switch(bone.data.transformMode){
                case (0, $ccc5aebc60cbf024$export$4c408f82786a534d).NoScale:
                case (0, $ccc5aebc60cbf024$export$4c408f82786a534d).NoScaleOrReflection:
                    tx = targetX - bone.worldX;
                    ty = targetY - bone.worldY;
            }
            const b = bone.data.length * sx;
            const dd = Math.sqrt(tx * tx + ty * ty);
            if (compress && dd < b || stretch && dd > b && b > 1e-4) {
                const s = (dd / b - 1) * alpha + 1;
                sx *= s;
                if (uniform) sy *= s;
            }
        }
        bone.updateWorldTransformWith(bone.ax, bone.ay, bone.arotation + rotationIK * alpha, sx, sy, bone.ashearX, bone.ashearY);
    }
    /** Applies 2 bone IK. The target is specified in the world coordinate system.
   * @param child A direct descendant of the parent bone. */ apply2(parent, child, targetX, targetY, bendDir, stretch, uniform, softness, alpha) {
        const px = parent.ax;
        const py = parent.ay;
        let psx = parent.ascaleX;
        let psy = parent.ascaleY;
        let sx = psx;
        let sy = psy;
        let csx = child.ascaleX;
        const pmat = parent.matrix;
        let os1 = 0;
        let os2 = 0;
        let s2 = 0;
        if (psx < 0) {
            psx = -psx;
            os1 = 180;
            s2 = -1;
        } else {
            os1 = 0;
            s2 = 1;
        }
        if (psy < 0) {
            psy = -psy;
            s2 = -s2;
        }
        if (csx < 0) {
            csx = -csx;
            os2 = 180;
        } else os2 = 0;
        const cx = child.ax;
        let cy = 0;
        let cwx = 0;
        let cwy = 0;
        let a = pmat.a;
        let b = pmat.c;
        let c = pmat.b;
        let d = pmat.d;
        const u = Math.abs(psx - psy) <= 1e-4;
        if (!u || stretch) {
            cy = 0;
            cwx = a * cx + pmat.tx;
            cwy = c * cx + pmat.ty;
        } else {
            cy = child.ay;
            cwx = a * cx + b * cy + pmat.tx;
            cwy = c * cx + d * cy + pmat.ty;
        }
        const pp = parent.parent.matrix;
        if (!pp) throw new Error("IK parent must itself have a parent.");
        a = pp.a;
        b = pp.c;
        c = pp.b;
        d = pp.d;
        const id = 1 / (a * d - b * c);
        let x = cwx - pp.tx;
        let y = cwy - pp.ty;
        const dx = (x * d - y * b) * id - px;
        const dy = (y * a - x * c) * id - py;
        const l1 = Math.sqrt(dx * dx + dy * dy);
        let l2 = child.data.length * csx;
        let a1;
        let a2;
        if (l1 < 1e-4) {
            this.apply1(parent, targetX, targetY, false, stretch, false, alpha);
            child.updateWorldTransformWith(cx, cy, 0, child.ascaleX, child.ascaleY, child.ashearX, child.ashearY);
            return;
        }
        x = targetX - pp.tx;
        y = targetY - pp.ty;
        let tx = (x * d - y * b) * id - px;
        let ty = (y * a - x * c) * id - py;
        let dd = tx * tx + ty * ty;
        if (softness != 0) {
            softness *= psx * (csx + 1) * 0.5;
            const td = Math.sqrt(dd);
            const sd = td - l1 - l2 * psx + softness;
            if (sd > 0) {
                let p = Math.min(1, sd / (softness * 2)) - 1;
                p = (sd - softness * (1 - p * p)) / td;
                tx -= p * tx;
                ty -= p * ty;
                dd = tx * tx + ty * ty;
            }
        }
        outer: if (u) {
            l2 *= psx;
            let cos = (dd - l1 * l1 - l2 * l2) / (2 * l1 * l2);
            if (cos < -1) {
                cos = -1;
                a2 = Math.PI * bendDir;
            } else if (cos > 1) {
                cos = 1;
                a2 = 0;
                if (stretch) {
                    a = (Math.sqrt(dd) / (l1 + l2) - 1) * alpha + 1;
                    sx *= a;
                    if (uniform) sy *= a;
                }
            } else a2 = Math.acos(cos) * bendDir;
            a = l1 + l2 * cos;
            b = l2 * Math.sin(a2);
            a1 = Math.atan2(ty * a - tx * b, tx * a + ty * b);
        } else {
            a = psx * l2;
            b = psy * l2;
            const aa = a * a;
            const bb = b * b;
            const ta = Math.atan2(ty, tx);
            c = bb * l1 * l1 + aa * dd - aa * bb;
            const c1 = -2 * bb * l1;
            const c2 = bb - aa;
            d = c1 * c1 - 4 * c2 * c;
            if (d >= 0) {
                let q = Math.sqrt(d);
                if (c1 < 0) q = -q;
                q = -(c1 + q) * 0.5;
                const r0 = q / c2;
                const r1 = c / q;
                const r = Math.abs(r0) < Math.abs(r1) ? r0 : r1;
                if (r * r <= dd) {
                    y = Math.sqrt(dd - r * r) * bendDir;
                    a1 = ta - Math.atan2(y, r);
                    a2 = Math.atan2(y / psy, (r - l1) / psx);
                    break outer;
                }
            }
            let minAngle = (0, $8804784813ffae81$export$6a7ef315a0d1ef07).PI;
            let minX = l1 - a;
            let minDist = minX * minX;
            let minY = 0;
            let maxAngle = 0;
            let maxX = l1 + a;
            let maxDist = maxX * maxX;
            let maxY = 0;
            c = -a * l1 / (aa - bb);
            if (c >= -1 && c <= 1) {
                c = Math.acos(c);
                x = a * Math.cos(c) + l1;
                y = b * Math.sin(c);
                d = x * x + y * y;
                if (d < minDist) {
                    minAngle = c;
                    minDist = d;
                    minX = x;
                    minY = y;
                }
                if (d > maxDist) {
                    maxAngle = c;
                    maxDist = d;
                    maxX = x;
                    maxY = y;
                }
            }
            if (dd <= (minDist + maxDist) * 0.5) {
                a1 = ta - Math.atan2(minY * bendDir, minX);
                a2 = minAngle * bendDir;
            } else {
                a1 = ta - Math.atan2(maxY * bendDir, maxX);
                a2 = maxAngle * bendDir;
            }
        }
        const os = Math.atan2(cy, cx) * s2;
        let rotation = parent.arotation;
        a1 = (a1 - os) * (0, $8804784813ffae81$export$6a7ef315a0d1ef07).radDeg + os1 - rotation;
        if (a1 > 180) a1 -= 360;
        else if (a1 < -180) a1 += 360;
        parent.updateWorldTransformWith(px, py, rotation + a1 * alpha, sx, sy, 0, 0);
        rotation = child.arotation;
        a2 = ((a2 + os) * (0, $8804784813ffae81$export$6a7ef315a0d1ef07).radDeg - child.ashearX) * s2 + os2 - rotation;
        if (a2 > 180) a2 -= 360;
        else if (a2 < -180) a2 += 360;
        child.updateWorldTransformWith(cx, cy, rotation + a2 * alpha, child.ascaleX, child.ascaleY, child.ashearX, child.ashearY);
    }
}



class $439d8ab836629982$export$adcb08b651fc712e extends (0, $6e2eadc25b36742c$export$b826e1ab3af63566) {
    constructor(name){
        super(name, 0, false);
        /** The bones that are constrained by this IK constraint. */ this.bones = new Array();
        /** The bone that is the IK target. */ this._target = null;
        /** Controls the bend direction of the IK bones, either 1 or -1. */ this.bendDirection = 1;
        /** When true and only a single bone is being constrained, if the target is too close, the bone is scaled to reach it. */ this.compress = false;
        /** When true, if the target is out of range, the parent bone is scaled to reach it. If more than one bone is being constrained
     * and the parent bone has local nonuniform scale, stretch is not applied. */ this.stretch = false;
        /** When true, only a single bone is being constrained, and {@link #getCompress()} or {@link #getStretch()} is used, the bone
     * is scaled on both the X and Y axes. */ this.uniform = false;
        /** A percentage (0-1) that controls the mix between the constrained and unconstrained rotations. */ this.mix = 1;
        /** For two bone IK, the distance from the maximum reach of the bones that rotation will slow. */ this.softness = 0;
    }
    set target(boneData) {
        this._target = boneData;
    }
    get target() {
        if (!this._target) throw new Error("BoneData not set.");
        else return this._target;
    }
}









class $07612ba9b2d17d60$export$d2629ab80d5dd5ba extends (0, $6e2eadc25b36742c$export$b826e1ab3af63566) {
    constructor(name){
        super(name, 0, false);
        /** The bones that will be modified by this path constraint. */ this.bones = new Array();
        /** The slot whose path attachment will be used to constrained the bones. */ this._target = null;
        /** The mode for positioning the first bone on the path. */ this.positionMode = (0, $2c8db927dc4fcff5$export$34d637c671e1e906).Fixed;
        /** The mode for positioning the bones after the first bone on the path. */ this.spacingMode = $07612ba9b2d17d60$export$34ce760ad2b0be4b.Fixed;
        /** The mode for adjusting the rotation of the bones. */ this.rotateMode = (0, $2c8db927dc4fcff5$export$a2a23846581ac82c).Chain;
        /** An offset added to the constrained bone rotation. */ this.offsetRotation = 0;
        /** The position along the path. */ this.position = 0;
        /** The spacing between bones. */ this.spacing = 0;
        this.mixRotate = 0;
        this.mixX = 0;
        this.mixY = 0;
    }
    set target(slotData) {
        this._target = slotData;
    }
    get target() {
        if (!this._target) throw new Error("SlotData not set.");
        else return this._target;
    }
}
var $07612ba9b2d17d60$export$34ce760ad2b0be4b = /* @__PURE__ */ ((SpacingMode2)=>{
    SpacingMode2[SpacingMode2["Length"] = 0] = "Length";
    SpacingMode2[SpacingMode2["Fixed"] = 1] = "Fixed";
    SpacingMode2[SpacingMode2["Percent"] = 2] = "Percent";
    SpacingMode2[SpacingMode2["Proportional"] = 3] = "Proportional";
    return SpacingMode2;
})($07612ba9b2d17d60$export$34ce760ad2b0be4b || {});


const $84e4987bdc6c81a2$var$_PathConstraint = class {
    constructor(data, skeleton){
        /** The position along the path. */ this.position = 0;
        /** The spacing between bones. */ this.spacing = 0;
        this.mixRotate = 0;
        this.mixX = 0;
        this.mixY = 0;
        this.spaces = new Array();
        this.positions = new Array();
        this.world = new Array();
        this.curves = new Array();
        this.lengths = new Array();
        this.segments = new Array();
        this.active = false;
        if (!data) throw new Error("data cannot be null.");
        if (!skeleton) throw new Error("skeleton cannot be null.");
        this.data = data;
        this.bones = new Array();
        for(let i = 0, n = data.bones.length; i < n; i++){
            const bone = skeleton.findBone(data.bones[i].name);
            if (!bone) throw new Error(`Couldn't find bone ${data.bones[i].name}.`);
            this.bones.push(bone);
        }
        const target = skeleton.findSlot(data.target.name);
        if (!target) throw new Error(`Couldn't find target bone ${data.target.name}`);
        this.target = target;
        this.position = data.position;
        this.spacing = data.spacing;
        this.mixRotate = data.mixRotate;
        this.mixX = data.mixX;
        this.mixY = data.mixY;
    }
    isActive() {
        return this.active;
    }
    update() {
        const attachment = this.target.getAttachment();
        if (!(attachment instanceof (0, $7aafbf7cd242ca5e$export$d285e3ec07b32800))) return;
        const mixRotate = this.mixRotate;
        const mixX = this.mixX;
        const mixY = this.mixY;
        if (mixRotate == 0 && mixX == 0 && mixY == 0) return;
        const data = this.data;
        const tangents = data.rotateMode == (0, $2c8db927dc4fcff5$export$a2a23846581ac82c).Tangent;
        const scale = data.rotateMode == (0, $2c8db927dc4fcff5$export$a2a23846581ac82c).ChainScale;
        const bones = this.bones;
        const boneCount = bones.length;
        const spacesCount = tangents ? boneCount : boneCount + 1;
        const spaces = (0, $8804784813ffae81$export$d2ca453b913dcdea).setArraySize(this.spaces, spacesCount);
        const lengths = scale ? this.lengths = (0, $8804784813ffae81$export$d2ca453b913dcdea).setArraySize(this.lengths, boneCount) : [];
        const spacing = this.spacing;
        switch(data.spacingMode){
            case (0, $07612ba9b2d17d60$export$34ce760ad2b0be4b).Percent:
                if (scale) for(let i = 0, n = spacesCount - 1; i < n; i++){
                    const bone = bones[i];
                    const setupLength = bone.data.length;
                    if (setupLength < $84e4987bdc6c81a2$var$_PathConstraint.epsilon) lengths[i] = 0;
                    else {
                        const x = setupLength * bone.matrix.a;
                        const y = setupLength * bone.matrix.b;
                        lengths[i] = Math.sqrt(x * x + y * y);
                    }
                }
                (0, $8804784813ffae81$export$d2ca453b913dcdea).arrayFill(spaces, 1, spacesCount, spacing);
                break;
            case (0, $07612ba9b2d17d60$export$34ce760ad2b0be4b).Proportional:
                let sum = 0;
                for(let i = 0, n = spacesCount - 1; i < n;){
                    const bone = bones[i];
                    const setupLength = bone.data.length;
                    if (setupLength < $84e4987bdc6c81a2$var$_PathConstraint.epsilon) {
                        if (scale) lengths[i] = 0;
                        spaces[++i] = spacing;
                    } else {
                        const x = setupLength * bone.matrix.a;
                        const y = setupLength * bone.matrix.b;
                        const length = Math.sqrt(x * x + y * y);
                        if (scale) lengths[i] = length;
                        spaces[++i] = length;
                        sum += length;
                    }
                }
                if (sum > 0) {
                    sum = spacesCount / sum * spacing;
                    for(let i = 1; i < spacesCount; i++)spaces[i] *= sum;
                }
                break;
            default:
                const lengthSpacing = data.spacingMode == (0, $07612ba9b2d17d60$export$34ce760ad2b0be4b).Length;
                for(let i = 0, n = spacesCount - 1; i < n;){
                    const bone = bones[i];
                    const setupLength = bone.data.length;
                    if (setupLength < $84e4987bdc6c81a2$var$_PathConstraint.epsilon) {
                        if (scale) lengths[i] = 0;
                        spaces[++i] = spacing;
                    } else {
                        const x = setupLength * bone.matrix.a;
                        const y = setupLength * bone.matrix.b;
                        const length = Math.sqrt(x * x + y * y);
                        if (scale) lengths[i] = length;
                        spaces[++i] = (lengthSpacing ? setupLength + spacing : spacing) * length / setupLength;
                    }
                }
        }
        const positions = this.computeWorldPositions(attachment, spacesCount, tangents);
        let boneX = positions[0];
        let boneY = positions[1];
        let offsetRotation = data.offsetRotation;
        let tip = false;
        if (offsetRotation == 0) tip = data.rotateMode == (0, $2c8db927dc4fcff5$export$a2a23846581ac82c).Chain;
        else {
            tip = false;
            const p = this.target.bone.matrix;
            offsetRotation *= p.a * p.d - p.b * p.c > 0 ? (0, $8804784813ffae81$export$6a7ef315a0d1ef07).degRad : -(0, $8804784813ffae81$export$6a7ef315a0d1ef07).degRad;
        }
        for(let i = 0, p = 3; i < boneCount; i++, p += 3){
            const bone = bones[i];
            const mat = bone.matrix;
            mat.tx += (boneX - mat.tx) * mixX;
            mat.ty += (boneY - mat.ty) * mixY;
            const x = positions[p];
            const y = positions[p + 1];
            const dx = x - boneX;
            const dy = y - boneY;
            if (scale) {
                const length = lengths[i];
                if (length != 0) {
                    const s = (Math.sqrt(dx * dx + dy * dy) / length - 1) * mixRotate + 1;
                    mat.a *= s;
                    mat.b *= s;
                }
            }
            boneX = x;
            boneY = y;
            if (mixRotate > 0) {
                const a = mat.a;
                const b = mat.c;
                const c = mat.b;
                const d = mat.d;
                let r = 0;
                let cos = 0;
                let sin = 0;
                if (tangents) r = positions[p - 1];
                else if (spaces[i + 1] == 0) r = positions[p + 2];
                else r = Math.atan2(dy, dx);
                r -= Math.atan2(c, a);
                if (tip) {
                    cos = Math.cos(r);
                    sin = Math.sin(r);
                    const length = bone.data.length;
                    boneX += (length * (cos * a - sin * c) - dx) * mixRotate;
                    boneY += (length * (sin * a + cos * c) - dy) * mixRotate;
                } else r += offsetRotation;
                if (r > (0, $8804784813ffae81$export$6a7ef315a0d1ef07).PI) r -= (0, $8804784813ffae81$export$6a7ef315a0d1ef07).PI2;
                else if (r < -(0, $8804784813ffae81$export$6a7ef315a0d1ef07).PI) r += (0, $8804784813ffae81$export$6a7ef315a0d1ef07).PI2;
                r *= mixRotate;
                cos = Math.cos(r);
                sin = Math.sin(r);
                mat.a = cos * a - sin * c;
                mat.c = cos * b - sin * d;
                mat.b = sin * a + cos * c;
                mat.d = sin * b + cos * d;
            }
            bone.updateAppliedTransform();
        }
    }
    computeWorldPositions(path, spacesCount, tangents) {
        const target = this.target;
        let position = this.position;
        const spaces = this.spaces;
        const out = (0, $8804784813ffae81$export$d2ca453b913dcdea).setArraySize(this.positions, spacesCount * 3 + 2);
        let world = this.world;
        const closed = path.closed;
        let verticesLength = path.worldVerticesLength;
        let curveCount = verticesLength / 6;
        let prevCurve = $84e4987bdc6c81a2$var$_PathConstraint.NONE;
        if (!path.constantSpeed) {
            const lengths = path.lengths;
            curveCount -= closed ? 1 : 2;
            const pathLength2 = lengths[curveCount];
            if (this.data.positionMode == (0, $2c8db927dc4fcff5$export$34d637c671e1e906).Percent) position *= pathLength2;
            let multiplier2;
            switch(this.data.spacingMode){
                case (0, $07612ba9b2d17d60$export$34ce760ad2b0be4b).Percent:
                    multiplier2 = pathLength2;
                    break;
                case (0, $07612ba9b2d17d60$export$34ce760ad2b0be4b).Proportional:
                    multiplier2 = pathLength2 / spacesCount;
                    break;
                default:
                    multiplier2 = 1;
            }
            world = (0, $8804784813ffae81$export$d2ca453b913dcdea).setArraySize(this.world, 8);
            for(let i = 0, o = 0, curve = 0; i < spacesCount; i++, o += 3){
                const space = spaces[i] * multiplier2;
                position += space;
                let p = position;
                if (closed) {
                    p %= pathLength2;
                    if (p < 0) p += pathLength2;
                    curve = 0;
                } else if (p < 0) {
                    if (prevCurve != $84e4987bdc6c81a2$var$_PathConstraint.BEFORE) {
                        prevCurve = $84e4987bdc6c81a2$var$_PathConstraint.BEFORE;
                        path.computeWorldVertices(target, 2, 4, world, 0, 2);
                    }
                    this.addBeforePosition(p, world, 0, out, o);
                    continue;
                } else if (p > pathLength2) {
                    if (prevCurve != $84e4987bdc6c81a2$var$_PathConstraint.AFTER) {
                        prevCurve = $84e4987bdc6c81a2$var$_PathConstraint.AFTER;
                        path.computeWorldVertices(target, verticesLength - 6, 4, world, 0, 2);
                    }
                    this.addAfterPosition(p - pathLength2, world, 0, out, o);
                    continue;
                }
                for(;; curve++){
                    const length = lengths[curve];
                    if (p > length) continue;
                    if (curve == 0) p /= length;
                    else {
                        const prev = lengths[curve - 1];
                        p = (p - prev) / (length - prev);
                    }
                    break;
                }
                if (curve != prevCurve) {
                    prevCurve = curve;
                    if (closed && curve == curveCount) {
                        path.computeWorldVertices(target, verticesLength - 4, 4, world, 0, 2);
                        path.computeWorldVertices(target, 0, 4, world, 4, 2);
                    } else path.computeWorldVertices(target, curve * 6 + 2, 8, world, 0, 2);
                }
                this.addCurvePosition(p, world[0], world[1], world[2], world[3], world[4], world[5], world[6], world[7], out, o, tangents || i > 0 && space == 0);
            }
            return out;
        }
        if (closed) {
            verticesLength += 2;
            world = (0, $8804784813ffae81$export$d2ca453b913dcdea).setArraySize(this.world, verticesLength);
            path.computeWorldVertices(target, 2, verticesLength - 4, world, 0, 2);
            path.computeWorldVertices(target, 0, 2, world, verticesLength - 4, 2);
            world[verticesLength - 2] = world[0];
            world[verticesLength - 1] = world[1];
        } else {
            curveCount--;
            verticesLength -= 4;
            world = (0, $8804784813ffae81$export$d2ca453b913dcdea).setArraySize(this.world, verticesLength);
            path.computeWorldVertices(target, 2, verticesLength, world, 0, 2);
        }
        const curves = (0, $8804784813ffae81$export$d2ca453b913dcdea).setArraySize(this.curves, curveCount);
        let pathLength = 0;
        let x1 = world[0];
        let y1 = world[1];
        let cx1 = 0;
        let cy1 = 0;
        let cx2 = 0;
        let cy2 = 0;
        let x2 = 0;
        let y2 = 0;
        let tmpx = 0;
        let tmpy = 0;
        let dddfx = 0;
        let dddfy = 0;
        let ddfx = 0;
        let ddfy = 0;
        let dfx = 0;
        let dfy = 0;
        for(let i = 0, w = 2; i < curveCount; i++, w += 6){
            cx1 = world[w];
            cy1 = world[w + 1];
            cx2 = world[w + 2];
            cy2 = world[w + 3];
            x2 = world[w + 4];
            y2 = world[w + 5];
            tmpx = (x1 - cx1 * 2 + cx2) * 0.1875;
            tmpy = (y1 - cy1 * 2 + cy2) * 0.1875;
            dddfx = ((cx1 - cx2) * 3 - x1 + x2) * 0.09375;
            dddfy = ((cy1 - cy2) * 3 - y1 + y2) * 0.09375;
            ddfx = tmpx * 2 + dddfx;
            ddfy = tmpy * 2 + dddfy;
            dfx = (cx1 - x1) * 0.75 + tmpx + dddfx * 0.16666667;
            dfy = (cy1 - y1) * 0.75 + tmpy + dddfy * 0.16666667;
            pathLength += Math.sqrt(dfx * dfx + dfy * dfy);
            dfx += ddfx;
            dfy += ddfy;
            ddfx += dddfx;
            ddfy += dddfy;
            pathLength += Math.sqrt(dfx * dfx + dfy * dfy);
            dfx += ddfx;
            dfy += ddfy;
            pathLength += Math.sqrt(dfx * dfx + dfy * dfy);
            dfx += ddfx + dddfx;
            dfy += ddfy + dddfy;
            pathLength += Math.sqrt(dfx * dfx + dfy * dfy);
            curves[i] = pathLength;
            x1 = x2;
            y1 = y2;
        }
        if (this.data.positionMode == (0, $2c8db927dc4fcff5$export$34d637c671e1e906).Percent) position *= pathLength;
        let multiplier;
        switch(this.data.spacingMode){
            case (0, $07612ba9b2d17d60$export$34ce760ad2b0be4b).Percent:
                multiplier = pathLength;
                break;
            case (0, $07612ba9b2d17d60$export$34ce760ad2b0be4b).Proportional:
                multiplier = pathLength / spacesCount;
                break;
            default:
                multiplier = 1;
        }
        const segments = this.segments;
        let curveLength = 0;
        for(let i = 0, o = 0, curve = 0, segment = 0; i < spacesCount; i++, o += 3){
            const space = spaces[i] * multiplier;
            position += space;
            let p = position;
            if (closed) {
                p %= pathLength;
                if (p < 0) p += pathLength;
                curve = 0;
            } else if (p < 0) {
                this.addBeforePosition(p, world, 0, out, o);
                continue;
            } else if (p > pathLength) {
                this.addAfterPosition(p - pathLength, world, verticesLength - 4, out, o);
                continue;
            }
            for(;; curve++){
                const length = curves[curve];
                if (p > length) continue;
                if (curve == 0) p /= length;
                else {
                    const prev = curves[curve - 1];
                    p = (p - prev) / (length - prev);
                }
                break;
            }
            if (curve != prevCurve) {
                prevCurve = curve;
                let ii = curve * 6;
                x1 = world[ii];
                y1 = world[ii + 1];
                cx1 = world[ii + 2];
                cy1 = world[ii + 3];
                cx2 = world[ii + 4];
                cy2 = world[ii + 5];
                x2 = world[ii + 6];
                y2 = world[ii + 7];
                tmpx = (x1 - cx1 * 2 + cx2) * 0.03;
                tmpy = (y1 - cy1 * 2 + cy2) * 0.03;
                dddfx = ((cx1 - cx2) * 3 - x1 + x2) * 6e-3;
                dddfy = ((cy1 - cy2) * 3 - y1 + y2) * 6e-3;
                ddfx = tmpx * 2 + dddfx;
                ddfy = tmpy * 2 + dddfy;
                dfx = (cx1 - x1) * 0.3 + tmpx + dddfx * 0.16666667;
                dfy = (cy1 - y1) * 0.3 + tmpy + dddfy * 0.16666667;
                curveLength = Math.sqrt(dfx * dfx + dfy * dfy);
                segments[0] = curveLength;
                for(ii = 1; ii < 8; ii++){
                    dfx += ddfx;
                    dfy += ddfy;
                    ddfx += dddfx;
                    ddfy += dddfy;
                    curveLength += Math.sqrt(dfx * dfx + dfy * dfy);
                    segments[ii] = curveLength;
                }
                dfx += ddfx;
                dfy += ddfy;
                curveLength += Math.sqrt(dfx * dfx + dfy * dfy);
                segments[8] = curveLength;
                dfx += ddfx + dddfx;
                dfy += ddfy + dddfy;
                curveLength += Math.sqrt(dfx * dfx + dfy * dfy);
                segments[9] = curveLength;
                segment = 0;
            }
            p *= curveLength;
            for(;; segment++){
                const length = segments[segment];
                if (p > length) continue;
                if (segment == 0) p /= length;
                else {
                    const prev = segments[segment - 1];
                    p = segment + (p - prev) / (length - prev);
                }
                break;
            }
            this.addCurvePosition(p * 0.1, x1, y1, cx1, cy1, cx2, cy2, x2, y2, out, o, tangents || i > 0 && space == 0);
        }
        return out;
    }
    addBeforePosition(p, temp, i, out, o) {
        const x1 = temp[i];
        const y1 = temp[i + 1];
        const dx = temp[i + 2] - x1;
        const dy = temp[i + 3] - y1;
        const r = Math.atan2(dy, dx);
        out[o] = x1 + p * Math.cos(r);
        out[o + 1] = y1 + p * Math.sin(r);
        out[o + 2] = r;
    }
    addAfterPosition(p, temp, i, out, o) {
        const x1 = temp[i + 2];
        const y1 = temp[i + 3];
        const dx = x1 - temp[i];
        const dy = y1 - temp[i + 1];
        const r = Math.atan2(dy, dx);
        out[o] = x1 + p * Math.cos(r);
        out[o + 1] = y1 + p * Math.sin(r);
        out[o + 2] = r;
    }
    addCurvePosition(p, x1, y1, cx1, cy1, cx2, cy2, x2, y2, out, o, tangents) {
        if (p == 0 || isNaN(p)) {
            out[o] = x1;
            out[o + 1] = y1;
            out[o + 2] = Math.atan2(cy1 - y1, cx1 - x1);
            return;
        }
        const tt = p * p;
        const ttt = tt * p;
        const u = 1 - p;
        const uu = u * u;
        const uuu = uu * u;
        const ut = u * p;
        const ut3 = ut * 3;
        const uut3 = u * ut3;
        const utt3 = ut3 * p;
        const x = x1 * uuu + cx1 * uut3 + cx2 * utt3 + x2 * ttt;
        const y = y1 * uuu + cy1 * uut3 + cy2 * utt3 + y2 * ttt;
        out[o] = x;
        out[o + 1] = y;
        if (tangents) {
            if (p < 1e-3) out[o + 2] = Math.atan2(cy1 - y1, cx1 - x1);
            else out[o + 2] = Math.atan2(y - (y1 * uu + cy1 * ut * 2 + cy2 * tt), x - (x1 * uu + cx1 * ut * 2 + cx2 * tt));
        }
    }
};
let $84e4987bdc6c81a2$export$cb4f92fb0c018828 = $84e4987bdc6c81a2$var$_PathConstraint;
$84e4987bdc6c81a2$export$cb4f92fb0c018828.NONE = -1;
$84e4987bdc6c81a2$export$cb4f92fb0c018828.BEFORE = -2;
$84e4987bdc6c81a2$export$cb4f92fb0c018828.AFTER = -3;
$84e4987bdc6c81a2$export$cb4f92fb0c018828.epsilon = 1e-5;












class $84a54693e6ede946$export$8c6ed5c666ac1360 {
    constructor(data, bone){
        /** The dark color used to tint the slot's attachment for two color tinting, or null if two color tinting is not used. The dark
     * color's alpha is not used. */ this.darkColor = null;
        this.attachment = null;
        this.attachmentState = 0;
        /** The index of the texture region to display when the slot's attachment has a {@link Sequence}. -1 represents the
     * {@link Sequence#getSetupIndex()}. */ this.sequenceIndex = -1;
        /** Values to deform the slot's attachment. For an unweighted mesh, the entries are local positions for each vertex. For a
     * weighted mesh, the entries are an offset for each vertex which will be added to the mesh's local vertex positions.
     *
     * See {@link VertexAttachment#computeWorldVertices()} and {@link DeformTimeline}. */ this.deform = new Array();
        if (!data) throw new Error("data cannot be null.");
        if (!bone) throw new Error("bone cannot be null.");
        this.data = data;
        this.bone = bone;
        this.color = new (0, $8804784813ffae81$export$892596cec99bc70e)();
        this.darkColor = !data.darkColor ? null : new (0, $8804784813ffae81$export$892596cec99bc70e)();
        this.setToSetupPose();
        this.blendMode = this.data.blendMode;
    }
    /** The skeleton this slot belongs to. */ getSkeleton() {
        return this.bone.skeleton;
    }
    /** The current attachment for the slot, or null if the slot has no attachment. */ getAttachment() {
        return this.attachment;
    }
    /** Sets the slot's attachment and, if the attachment changed, resets {@link #sequenceIndex} and clears the {@link #deform}.
   * The deform is not cleared if the old attachment has the same {@link VertexAttachment#getTimelineAttachment()} as the
   * specified attachment. */ setAttachment(attachment) {
        if (this.attachment == attachment) return;
        if (!(attachment instanceof (0, $9892e6452670f32b$export$66d3a0c3be55e044)) || !(this.attachment instanceof (0, $9892e6452670f32b$export$66d3a0c3be55e044)) || attachment.timelineAttachment != this.attachment.timelineAttachment) this.deform.length = 0;
        this.attachment = attachment;
        this.sequenceIndex = -1;
    }
    /** Sets this slot to the setup pose. */ setToSetupPose() {
        this.color.setFromColor(this.data.color);
        if (this.darkColor) this.darkColor.setFromColor(this.data.darkColor);
        if (!this.data.attachmentName) this.attachment = null;
        else {
            this.attachment = null;
            this.setAttachment(this.bone.skeleton.getAttachment(this.data.index, this.data.attachmentName));
        }
    }
}




class $1cb7773c39a19bab$export$a2d8268faabf5c52 {
    constructor(data, skeleton){
        this.mixRotate = 0;
        this.mixX = 0;
        this.mixY = 0;
        this.mixScaleX = 0;
        this.mixScaleY = 0;
        this.mixShearY = 0;
        this.temp = new (0, $8804784813ffae81$export$c977b3e384af9ae1)();
        this.active = false;
        if (!data) throw new Error("data cannot be null.");
        if (!skeleton) throw new Error("skeleton cannot be null.");
        this.data = data;
        this.mixRotate = data.mixRotate;
        this.mixX = data.mixX;
        this.mixY = data.mixY;
        this.mixScaleX = data.mixScaleX;
        this.mixScaleY = data.mixScaleY;
        this.mixShearY = data.mixShearY;
        this.bones = new Array();
        for(let i = 0; i < data.bones.length; i++){
            const bone = skeleton.findBone(data.bones[i].name);
            if (!bone) throw new Error(`Couldn't find bone ${data.bones[i].name}.`);
            this.bones.push(bone);
        }
        const target = skeleton.findBone(data.target.name);
        if (!target) throw new Error(`Couldn't find target bone ${data.target.name}.`);
        this.target = target;
    }
    isActive() {
        return this.active;
    }
    update() {
        if (this.mixRotate == 0 && this.mixX == 0 && this.mixY == 0 && this.mixScaleX == 0 && this.mixScaleX == 0 && this.mixShearY == 0) return;
        if (this.data.local) {
            if (this.data.relative) this.applyRelativeLocal();
            else this.applyAbsoluteLocal();
        } else if (this.data.relative) this.applyRelativeWorld();
        else this.applyAbsoluteWorld();
    }
    applyAbsoluteWorld() {
        const mixRotate = this.mixRotate;
        const mixX = this.mixX;
        const mixY = this.mixY;
        const mixScaleX = this.mixScaleX;
        const mixScaleY = this.mixScaleY;
        const mixShearY = this.mixShearY;
        const translate = mixX != 0 || mixY != 0;
        const target = this.target;
        const targetMat = target.matrix;
        const ta = targetMat.a;
        const tb = targetMat.c;
        const tc = targetMat.b;
        const td = targetMat.d;
        const degRadReflect = ta * td - tb * tc > 0 ? (0, $8804784813ffae81$export$6a7ef315a0d1ef07).degRad : -(0, $8804784813ffae81$export$6a7ef315a0d1ef07).degRad;
        const offsetRotation = this.data.offsetRotation * degRadReflect;
        const offsetShearY = this.data.offsetShearY * degRadReflect;
        const bones = this.bones;
        for(let i = 0, n = bones.length; i < n; i++){
            const bone = bones[i];
            const mat = bone.matrix;
            if (mixRotate != 0) {
                const a = mat.a;
                const b = mat.c;
                const c = mat.b;
                const d = mat.d;
                let r = Math.atan2(tc, ta) - Math.atan2(c, a) + offsetRotation;
                if (r > (0, $8804784813ffae81$export$6a7ef315a0d1ef07).PI) r -= (0, $8804784813ffae81$export$6a7ef315a0d1ef07).PI2;
                else if (r < -(0, $8804784813ffae81$export$6a7ef315a0d1ef07).PI) r += (0, $8804784813ffae81$export$6a7ef315a0d1ef07).PI2;
                r *= mixRotate;
                const cos = Math.cos(r);
                const sin = Math.sin(r);
                mat.a = cos * a - sin * c;
                mat.c = cos * b - sin * d;
                mat.b = sin * a + cos * c;
                mat.d = sin * b + cos * d;
            }
            if (translate) {
                const temp = this.temp;
                target.localToWorld(temp.set(this.data.offsetX, this.data.offsetY));
                mat.tx += (temp.x - mat.tx) * mixX;
                mat.ty += (temp.y - mat.ty) * mixY;
            }
            if (mixScaleX != 0) {
                let s = Math.sqrt(mat.a * mat.a + mat.b * mat.b);
                if (s != 0) s = (s + (Math.sqrt(ta * ta + tc * tc) - s + this.data.offsetScaleX) * mixScaleX) / s;
                mat.a *= s;
                mat.b *= s;
            }
            if (mixScaleY != 0) {
                let s = Math.sqrt(mat.c * mat.c + mat.d * mat.d);
                if (s != 0) s = (s + (Math.sqrt(tb * tb + td * td) - s + this.data.offsetScaleY) * mixScaleY) / s;
                mat.c *= s;
                mat.d *= s;
            }
            if (mixShearY > 0) {
                const b = mat.c;
                const d = mat.d;
                const by = Math.atan2(d, b);
                let r = Math.atan2(td, tb) - Math.atan2(tc, ta) - (by - Math.atan2(mat.b, mat.a));
                if (r > (0, $8804784813ffae81$export$6a7ef315a0d1ef07).PI) r -= (0, $8804784813ffae81$export$6a7ef315a0d1ef07).PI2;
                else if (r < -(0, $8804784813ffae81$export$6a7ef315a0d1ef07).PI) r += (0, $8804784813ffae81$export$6a7ef315a0d1ef07).PI2;
                r = by + (r + offsetShearY) * mixShearY;
                const s = Math.sqrt(b * b + d * d);
                mat.c = Math.cos(r) * s;
                mat.d = Math.sin(r) * s;
            }
            bone.updateAppliedTransform();
        }
    }
    applyRelativeWorld() {
        const mixRotate = this.mixRotate;
        const mixX = this.mixX;
        const mixY = this.mixY;
        const mixScaleX = this.mixScaleX;
        const mixScaleY = this.mixScaleY;
        const mixShearY = this.mixShearY;
        const translate = mixX != 0 || mixY != 0;
        const target = this.target;
        const targetMat = target.matrix;
        const ta = targetMat.a;
        const tb = targetMat.c;
        const tc = targetMat.b;
        const td = targetMat.d;
        const degRadReflect = ta * td - tb * tc > 0 ? (0, $8804784813ffae81$export$6a7ef315a0d1ef07).degRad : -(0, $8804784813ffae81$export$6a7ef315a0d1ef07).degRad;
        const offsetRotation = this.data.offsetRotation * degRadReflect;
        const offsetShearY = this.data.offsetShearY * degRadReflect;
        const bones = this.bones;
        for(let i = 0, n = bones.length; i < n; i++){
            const bone = bones[i];
            const mat = bone.matrix;
            if (mixRotate != 0) {
                const a = mat.a;
                const b = mat.c;
                const c = mat.b;
                const d = mat.d;
                let r = Math.atan2(tc, ta) + offsetRotation;
                if (r > (0, $8804784813ffae81$export$6a7ef315a0d1ef07).PI) r -= (0, $8804784813ffae81$export$6a7ef315a0d1ef07).PI2;
                else if (r < -(0, $8804784813ffae81$export$6a7ef315a0d1ef07).PI) r += (0, $8804784813ffae81$export$6a7ef315a0d1ef07).PI2;
                r *= mixRotate;
                const cos = Math.cos(r);
                const sin = Math.sin(r);
                mat.a = cos * a - sin * c;
                mat.c = cos * b - sin * d;
                mat.b = sin * a + cos * c;
                mat.d = sin * b + cos * d;
            }
            if (translate) {
                const temp = this.temp;
                target.localToWorld(temp.set(this.data.offsetX, this.data.offsetY));
                mat.tx += temp.x * mixX;
                mat.ty += temp.y * mixY;
            }
            if (mixScaleX != 0) {
                const s = (Math.sqrt(ta * ta + tc * tc) - 1 + this.data.offsetScaleX) * mixScaleX + 1;
                mat.a *= s;
                mat.b *= s;
            }
            if (mixScaleY != 0) {
                const s = (Math.sqrt(tb * tb + td * td) - 1 + this.data.offsetScaleY) * mixScaleY + 1;
                mat.c *= s;
                mat.d *= s;
            }
            if (mixShearY > 0) {
                let r = Math.atan2(td, tb) - Math.atan2(tc, ta);
                if (r > (0, $8804784813ffae81$export$6a7ef315a0d1ef07).PI) r -= (0, $8804784813ffae81$export$6a7ef315a0d1ef07).PI2;
                else if (r < -(0, $8804784813ffae81$export$6a7ef315a0d1ef07).PI) r += (0, $8804784813ffae81$export$6a7ef315a0d1ef07).PI2;
                const b = mat.c;
                const d = mat.d;
                r = Math.atan2(d, b) + (r - (0, $8804784813ffae81$export$6a7ef315a0d1ef07).PI / 2 + offsetShearY) * mixShearY;
                const s = Math.sqrt(b * b + d * d);
                mat.c = Math.cos(r) * s;
                mat.d = Math.sin(r) * s;
            }
            bone.updateAppliedTransform();
        }
    }
    applyAbsoluteLocal() {
        const mixRotate = this.mixRotate;
        const mixX = this.mixX;
        const mixY = this.mixY;
        const mixScaleX = this.mixScaleX;
        const mixScaleY = this.mixScaleY;
        const mixShearY = this.mixShearY;
        const target = this.target;
        const bones = this.bones;
        for(let i = 0, n = bones.length; i < n; i++){
            const bone = bones[i];
            let rotation = bone.arotation;
            if (mixRotate != 0) {
                let r = target.arotation - rotation + this.data.offsetRotation;
                r -= (16384 - (16384.499999999996 - r / 360 | 0)) * 360;
                rotation += r * mixRotate;
            }
            let x = bone.ax;
            let y = bone.ay;
            x += (target.ax - x + this.data.offsetX) * mixX;
            y += (target.ay - y + this.data.offsetY) * mixY;
            let scaleX = bone.ascaleX;
            let scaleY = bone.ascaleY;
            if (mixScaleX != 0 && scaleX != 0) scaleX = (scaleX + (target.ascaleX - scaleX + this.data.offsetScaleX) * mixScaleX) / scaleX;
            if (mixScaleY != 0 && scaleY != 0) scaleY = (scaleY + (target.ascaleY - scaleY + this.data.offsetScaleY) * mixScaleY) / scaleY;
            let shearY = bone.ashearY;
            if (mixShearY != 0) {
                let r = target.ashearY - shearY + this.data.offsetShearY;
                r -= (16384 - (16384.499999999996 - r / 360 | 0)) * 360;
                shearY += r * mixShearY;
            }
            bone.updateWorldTransformWith(x, y, rotation, scaleX, scaleY, bone.ashearX, shearY);
        }
    }
    applyRelativeLocal() {
        const mixRotate = this.mixRotate;
        const mixX = this.mixX;
        const mixY = this.mixY;
        const mixScaleX = this.mixScaleX;
        const mixScaleY = this.mixScaleY;
        const mixShearY = this.mixShearY;
        const target = this.target;
        const bones = this.bones;
        for(let i = 0, n = bones.length; i < n; i++){
            const bone = bones[i];
            const rotation = bone.arotation + (target.arotation + this.data.offsetRotation) * mixRotate;
            const x = bone.ax + (target.ax + this.data.offsetX) * mixX;
            const y = bone.ay + (target.ay + this.data.offsetY) * mixY;
            const scaleX = bone.ascaleX * ((target.ascaleX - 1 + this.data.offsetScaleX) * mixScaleX + 1);
            const scaleY = bone.ascaleY * ((target.ascaleY - 1 + this.data.offsetScaleY) * mixScaleY + 1);
            const shearY = bone.ashearY + (target.ashearY + this.data.offsetShearY) * mixShearY;
            bone.updateWorldTransformWith(x, y, rotation, scaleX, scaleY, bone.ashearX, shearY);
        }
    }
}



const $ee28c57a028fa6c5$var$_Skeleton = class {
    constructor(data){
        /** The list of bones and constraints, sorted in the order they should be updated, as computed by {@link #updateCache()}. */ this._updateCache = new Array();
        /** The skeleton's current skin. May be null. */ this.skin = null;
        /** Scales the entire skeleton on the X axis. This affects all bones, even if the bone's transform mode disallows scale
     * inheritance. */ this.scaleX = 1;
        /** Scales the entire skeleton on the Y axis. This affects all bones, even if the bone's transform mode disallows scale
     * inheritance. */ this.scaleY = 1;
        /** Sets the skeleton X position, which is added to the root bone worldX position. */ this.x = 0;
        /** Sets the skeleton Y position, which is added to the root bone worldY position. */ this.y = 0;
        if (!data) throw new Error("data cannot be null.");
        this.data = data;
        this.bones = new Array();
        for(let i = 0; i < data.bones.length; i++){
            const boneData = data.bones[i];
            let bone;
            if (!boneData.parent) bone = new (0, $aa12cb1aa94e7136$export$b127726e56765aa4)(boneData, this, null);
            else {
                const parent = this.bones[boneData.parent.index];
                bone = new (0, $aa12cb1aa94e7136$export$b127726e56765aa4)(boneData, this, parent);
                parent.children.push(bone);
            }
            this.bones.push(bone);
        }
        this.slots = new Array();
        this.drawOrder = new Array();
        for(let i = 0; i < data.slots.length; i++){
            const slotData = data.slots[i];
            const bone = this.bones[slotData.boneData.index];
            const slot = new (0, $84a54693e6ede946$export$8c6ed5c666ac1360)(slotData, bone);
            this.slots.push(slot);
            this.drawOrder.push(slot);
        }
        this.ikConstraints = new Array();
        for(let i = 0; i < data.ikConstraints.length; i++){
            const ikConstraintData = data.ikConstraints[i];
            this.ikConstraints.push(new (0, $d2a70cbd94aab7f0$export$3c158c80ff28c177)(ikConstraintData, this));
        }
        this.transformConstraints = new Array();
        for(let i = 0; i < data.transformConstraints.length; i++){
            const transformConstraintData = data.transformConstraints[i];
            this.transformConstraints.push(new (0, $1cb7773c39a19bab$export$a2d8268faabf5c52)(transformConstraintData, this));
        }
        this.pathConstraints = new Array();
        for(let i = 0; i < data.pathConstraints.length; i++){
            const pathConstraintData = data.pathConstraints[i];
            this.pathConstraints.push(new (0, $84e4987bdc6c81a2$export$cb4f92fb0c018828)(pathConstraintData, this));
        }
        this.color = new (0, $8804784813ffae81$export$892596cec99bc70e)(1, 1, 1, 1);
        this.updateCache();
    }
    /** Caches information about bones and constraints. Must be called if the {@link #getSkin()} is modified or if bones,
   * constraints, or weighted path attachments are added or removed. */ updateCache() {
        const updateCache = this._updateCache;
        updateCache.length = 0;
        const bones = this.bones;
        for(let i = 0, n = bones.length; i < n; i++){
            const bone = bones[i];
            bone.sorted = bone.data.skinRequired;
            bone.active = !bone.sorted;
        }
        if (this.skin) {
            const skinBones = this.skin.bones;
            for(let i = 0, n = this.skin.bones.length; i < n; i++){
                let bone = this.bones[skinBones[i].index];
                do {
                    bone.sorted = false;
                    bone.active = true;
                    bone = bone.parent;
                }while (bone);
            }
        }
        const ikConstraints = this.ikConstraints;
        const transformConstraints = this.transformConstraints;
        const pathConstraints = this.pathConstraints;
        const ikCount = ikConstraints.length;
        const transformCount = transformConstraints.length;
        const pathCount = pathConstraints.length;
        const constraintCount = ikCount + transformCount + pathCount;
        outer: for(let i = 0; i < constraintCount; i++){
            for(let ii = 0; ii < ikCount; ii++){
                const constraint = ikConstraints[ii];
                if (constraint.data.order == i) {
                    this.sortIkConstraint(constraint);
                    continue outer;
                }
            }
            for(let ii = 0; ii < transformCount; ii++){
                const constraint = transformConstraints[ii];
                if (constraint.data.order == i) {
                    this.sortTransformConstraint(constraint);
                    continue outer;
                }
            }
            for(let ii = 0; ii < pathCount; ii++){
                const constraint = pathConstraints[ii];
                if (constraint.data.order == i) {
                    this.sortPathConstraint(constraint);
                    continue outer;
                }
            }
        }
        for(let i = 0, n = bones.length; i < n; i++)this.sortBone(bones[i]);
    }
    sortIkConstraint(constraint) {
        constraint.active = constraint.target.isActive() && (!constraint.data.skinRequired || this.skin && (0, $8804784813ffae81$export$d2ca453b913dcdea).contains(this.skin.constraints, constraint.data, true));
        if (!constraint.active) return;
        const target = constraint.target;
        this.sortBone(target);
        const constrained = constraint.bones;
        const parent = constrained[0];
        this.sortBone(parent);
        if (constrained.length == 1) {
            this._updateCache.push(constraint);
            this.sortReset(parent.children);
        } else {
            const child = constrained[constrained.length - 1];
            this.sortBone(child);
            this._updateCache.push(constraint);
            this.sortReset(parent.children);
            child.sorted = true;
        }
    }
    sortPathConstraint(constraint) {
        constraint.active = constraint.target.bone.isActive() && (!constraint.data.skinRequired || this.skin && (0, $8804784813ffae81$export$d2ca453b913dcdea).contains(this.skin.constraints, constraint.data, true));
        if (!constraint.active) return;
        const slot = constraint.target;
        const slotIndex = slot.data.index;
        const slotBone = slot.bone;
        if (this.skin) this.sortPathConstraintAttachment(this.skin, slotIndex, slotBone);
        if (this.data.defaultSkin && this.data.defaultSkin != this.skin) this.sortPathConstraintAttachment(this.data.defaultSkin, slotIndex, slotBone);
        for(let i = 0, n = this.data.skins.length; i < n; i++)this.sortPathConstraintAttachment(this.data.skins[i], slotIndex, slotBone);
        const attachment = slot.getAttachment();
        if (attachment instanceof (0, $7aafbf7cd242ca5e$export$d285e3ec07b32800)) this.sortPathConstraintAttachmentWith(attachment, slotBone);
        const constrained = constraint.bones;
        const boneCount = constrained.length;
        for(let i = 0; i < boneCount; i++)this.sortBone(constrained[i]);
        this._updateCache.push(constraint);
        for(let i = 0; i < boneCount; i++)this.sortReset(constrained[i].children);
        for(let i = 0; i < boneCount; i++)constrained[i].sorted = true;
    }
    sortTransformConstraint(constraint) {
        constraint.active = constraint.target.isActive() && (!constraint.data.skinRequired || this.skin && (0, $8804784813ffae81$export$d2ca453b913dcdea).contains(this.skin.constraints, constraint.data, true));
        if (!constraint.active) return;
        this.sortBone(constraint.target);
        const constrained = constraint.bones;
        const boneCount = constrained.length;
        if (constraint.data.local) for(let i = 0; i < boneCount; i++){
            const child = constrained[i];
            this.sortBone(child.parent);
            this.sortBone(child);
        }
        else for(let i = 0; i < boneCount; i++)this.sortBone(constrained[i]);
        this._updateCache.push(constraint);
        for(let i = 0; i < boneCount; i++)this.sortReset(constrained[i].children);
        for(let i = 0; i < boneCount; i++)constrained[i].sorted = true;
    }
    sortPathConstraintAttachment(skin, slotIndex, slotBone) {
        const attachments = skin.attachments[slotIndex];
        if (!attachments) return;
        for(const key in attachments)this.sortPathConstraintAttachmentWith(attachments[key], slotBone);
    }
    sortPathConstraintAttachmentWith(attachment, slotBone) {
        if (!(attachment instanceof (0, $7aafbf7cd242ca5e$export$d285e3ec07b32800))) return;
        const pathBones = attachment.bones;
        if (!pathBones) this.sortBone(slotBone);
        else {
            const bones = this.bones;
            for(let i = 0, n = pathBones.length; i < n;){
                let nn = pathBones[i++];
                nn += i;
                while(i < nn)this.sortBone(bones[pathBones[i++]]);
            }
        }
    }
    sortBone(bone) {
        if (!bone) return;
        if (bone.sorted) return;
        const parent = bone.parent;
        if (parent) this.sortBone(parent);
        bone.sorted = true;
        this._updateCache.push(bone);
    }
    sortReset(bones) {
        for(let i = 0, n = bones.length; i < n; i++){
            const bone = bones[i];
            if (!bone.active) continue;
            if (bone.sorted) this.sortReset(bone.children);
            bone.sorted = false;
        }
    }
    /** Updates the world transform for each bone and applies all constraints.
   *
   * See [World transforms](http://esotericsoftware.com/spine-runtime-skeletons#World-transforms) in the Spine
   * Runtimes Guide. */ updateWorldTransform() {
        const bones = this.bones;
        for(let i = 0, n = bones.length; i < n; i++){
            const bone = bones[i];
            bone.ax = bone.x;
            bone.ay = bone.y;
            bone.arotation = bone.rotation;
            bone.ascaleX = bone.scaleX;
            bone.ascaleY = bone.scaleY;
            bone.ashearX = bone.shearX;
            bone.ashearY = bone.shearY;
        }
        const updateCache = this._updateCache;
        for(let i = 0, n = updateCache.length; i < n; i++)updateCache[i].update();
    }
    updateWorldTransformWith(parent) {
        const rootBone = this.getRootBone();
        const pa = parent.matrix.a;
        const pb = parent.matrix.c;
        const pc = parent.matrix.b;
        const pd = parent.matrix.d;
        rootBone.matrix.tx = pa * this.x + pb * this.y + parent.worldX;
        rootBone.matrix.ty = pc * this.x + pd * this.y + parent.worldY;
        const rotationY = rootBone.rotation + 90 + rootBone.shearY;
        const la = (0, $8804784813ffae81$export$6a7ef315a0d1ef07).cosDeg(rootBone.rotation + rootBone.shearX) * rootBone.scaleX;
        const lb = (0, $8804784813ffae81$export$6a7ef315a0d1ef07).cosDeg(rotationY) * rootBone.scaleY;
        const lc = (0, $8804784813ffae81$export$6a7ef315a0d1ef07).sinDeg(rootBone.rotation + rootBone.shearX) * rootBone.scaleX;
        const ld = (0, $8804784813ffae81$export$6a7ef315a0d1ef07).sinDeg(rotationY) * rootBone.scaleY;
        const sx = this.scaleX;
        const sy = (0, $1840f66876ded594$export$a5a6e0b888b2c992).yDown ? -this.scaleY : this.scaleY;
        rootBone.matrix.a = (pa * la + pb * lc) * sx;
        rootBone.matrix.c = (pa * lb + pb * ld) * sx;
        rootBone.matrix.b = (pc * la + pd * lc) * sy;
        rootBone.matrix.d = (pc * lb + pd * ld) * sy;
        const updateCache = this._updateCache;
        for(let i = 0, n = updateCache.length; i < n; i++){
            const updatable = updateCache[i];
            if (updatable != rootBone) updatable.update();
        }
    }
    /** Sets the bones, constraints, and slots to their setup pose values. */ setToSetupPose() {
        this.setBonesToSetupPose();
        this.setSlotsToSetupPose();
    }
    /** Sets the bones and constraints to their setup pose values. */ setBonesToSetupPose() {
        const bones = this.bones;
        for(let i = 0, n = bones.length; i < n; i++)bones[i].setToSetupPose();
        const ikConstraints = this.ikConstraints;
        for(let i = 0, n = ikConstraints.length; i < n; i++){
            const constraint = ikConstraints[i];
            constraint.mix = constraint.data.mix;
            constraint.softness = constraint.data.softness;
            constraint.bendDirection = constraint.data.bendDirection;
            constraint.compress = constraint.data.compress;
            constraint.stretch = constraint.data.stretch;
        }
        const transformConstraints = this.transformConstraints;
        for(let i = 0, n = transformConstraints.length; i < n; i++){
            const constraint = transformConstraints[i];
            const data = constraint.data;
            constraint.mixRotate = data.mixRotate;
            constraint.mixX = data.mixX;
            constraint.mixY = data.mixY;
            constraint.mixScaleX = data.mixScaleX;
            constraint.mixScaleY = data.mixScaleY;
            constraint.mixShearY = data.mixShearY;
        }
        const pathConstraints = this.pathConstraints;
        for(let i = 0, n = pathConstraints.length; i < n; i++){
            const constraint = pathConstraints[i];
            const data = constraint.data;
            constraint.position = data.position;
            constraint.spacing = data.spacing;
            constraint.mixRotate = data.mixRotate;
            constraint.mixX = data.mixX;
            constraint.mixY = data.mixY;
        }
    }
    /** Sets the slots and draw order to their setup pose values. */ setSlotsToSetupPose() {
        const slots = this.slots;
        (0, $8804784813ffae81$export$d2ca453b913dcdea).arrayCopy(slots, 0, this.drawOrder, 0, slots.length);
        for(let i = 0, n = slots.length; i < n; i++)slots[i].setToSetupPose();
    }
    /** @returns May return null. */ getRootBone() {
        if (this.bones.length == 0) return null;
        return this.bones[0];
    }
    /** @returns May be null. */ findBone(boneName) {
        if (!boneName) throw new Error("boneName cannot be null.");
        const bones = this.bones;
        for(let i = 0, n = bones.length; i < n; i++){
            const bone = bones[i];
            if (bone.data.name == boneName) return bone;
        }
        return null;
    }
    /** @returns -1 if the bone was not found. */ findBoneIndex(boneName) {
        if (!boneName) throw new Error("boneName cannot be null.");
        const bones = this.bones;
        for(let i = 0, n = bones.length; i < n; i++)if (bones[i].data.name == boneName) return i;
        return -1;
    }
    /** Finds a slot by comparing each slot's name. It is more efficient to cache the results of this method than to call it
   * repeatedly.
   * @returns May be null. */ findSlot(slotName) {
        if (!slotName) throw new Error("slotName cannot be null.");
        const slots = this.slots;
        for(let i = 0, n = slots.length; i < n; i++){
            const slot = slots[i];
            if (slot.data.name == slotName) return slot;
        }
        return null;
    }
    /** @returns -1 if the bone was not found. */ findSlotIndex(slotName) {
        if (!slotName) throw new Error("slotName cannot be null.");
        const slots = this.slots;
        for(let i = 0, n = slots.length; i < n; i++)if (slots[i].data.name == slotName) return i;
        return -1;
    }
    /** Sets a skin by name.
   *
   * See {@link #setSkin()}. */ setSkinByName(skinName) {
        const skin = this.data.findSkin(skinName);
        if (!skin) throw new Error(`Skin not found: ${skinName}`);
        this.setSkin(skin);
    }
    /** Sets the skin used to look up attachments before looking in the {@link SkeletonData#defaultSkin default skin}. If the
   * skin is changed, {@link #updateCache()} is called.
   *
   * Attachments from the new skin are attached if the corresponding attachment from the old skin was attached. If there was no
   * old skin, each slot's setup mode attachment is attached from the new skin.
   *
   * After changing the skin, the visible attachments can be reset to those attached in the setup pose by calling
   * {@link #setSlotsToSetupPose()}. Also, often {@link AnimationState#apply()} is called before the next time the
   * skeleton is rendered to allow any attachment keys in the current animation(s) to hide or show attachments from the new skin.
   * @param newSkin May be null. */ setSkin(newSkin) {
        if (newSkin == this.skin) return;
        if (newSkin) {
            if (this.skin) newSkin.attachAll(this, this.skin);
            else {
                const slots = this.slots;
                for(let i = 0, n = slots.length; i < n; i++){
                    const slot = slots[i];
                    const name = slot.data.attachmentName;
                    if (name) {
                        const attachment = newSkin.getAttachment(i, name);
                        if (attachment) slot.setAttachment(attachment);
                    }
                }
            }
        }
        this.skin = newSkin;
        this.updateCache();
    }
    /** Finds an attachment by looking in the {@link #skin} and {@link SkeletonData#defaultSkin} using the slot name and attachment
   * name.
   *
   * See {@link #getAttachment()}.
   * @returns May be null. */ getAttachmentByName(slotName, attachmentName) {
        const slot = this.data.findSlot(slotName);
        if (!slot) throw new Error(`Can't find slot with name ${slotName}`);
        return this.getAttachment(slot.index, attachmentName);
    }
    /** Finds an attachment by looking in the {@link #skin} and {@link SkeletonData#defaultSkin} using the slot index and
   * attachment name. First the skin is checked and if the attachment was not found, the default skin is checked.
   *
   * See [Runtime skins](http://esotericsoftware.com/spine-runtime-skins) in the Spine Runtimes Guide.
   * @returns May be null. */ getAttachment(slotIndex, attachmentName) {
        if (!attachmentName) throw new Error("attachmentName cannot be null.");
        if (this.skin) {
            const attachment = this.skin.getAttachment(slotIndex, attachmentName);
            if (attachment) return attachment;
        }
        if (this.data.defaultSkin) return this.data.defaultSkin.getAttachment(slotIndex, attachmentName);
        return null;
    }
    /** A convenience method to set an attachment by finding the slot with {@link #findSlot()}, finding the attachment with
   * {@link #getAttachment()}, then setting the slot's {@link Slot#attachment}.
   * @param attachmentName May be null to clear the slot's attachment. */ setAttachment(slotName, attachmentName) {
        if (!slotName) throw new Error("slotName cannot be null.");
        const slots = this.slots;
        for(let i = 0, n = slots.length; i < n; i++){
            const slot = slots[i];
            if (slot.data.name == slotName) {
                let attachment = null;
                if (attachmentName) {
                    attachment = this.getAttachment(i, attachmentName);
                    if (!attachment) throw new Error(`Attachment not found: ${attachmentName}, for slot: ${slotName}`);
                }
                slot.setAttachment(attachment);
                return;
            }
        }
        throw new Error(`Slot not found: ${slotName}`);
    }
    /** Finds an IK constraint by comparing each IK constraint's name. It is more efficient to cache the results of this method
   * than to call it repeatedly.
   * @return May be null. */ findIkConstraint(constraintName) {
        if (!constraintName) throw new Error("constraintName cannot be null.");
        const ikConstraints = this.ikConstraints;
        for(let i = 0, n = ikConstraints.length; i < n; i++){
            const ikConstraint = ikConstraints[i];
            if (ikConstraint.data.name == constraintName) return ikConstraint;
        }
        return null;
    }
    /** Finds a transform constraint by comparing each transform constraint's name. It is more efficient to cache the results of
   * this method than to call it repeatedly.
   * @return May be null. */ findTransformConstraint(constraintName) {
        if (!constraintName) throw new Error("constraintName cannot be null.");
        const transformConstraints = this.transformConstraints;
        for(let i = 0, n = transformConstraints.length; i < n; i++){
            const constraint = transformConstraints[i];
            if (constraint.data.name == constraintName) return constraint;
        }
        return null;
    }
    /** Finds a path constraint by comparing each path constraint's name. It is more efficient to cache the results of this method
   * than to call it repeatedly.
   * @return May be null. */ findPathConstraint(constraintName) {
        if (!constraintName) throw new Error("constraintName cannot be null.");
        const pathConstraints = this.pathConstraints;
        for(let i = 0, n = pathConstraints.length; i < n; i++){
            const constraint = pathConstraints[i];
            if (constraint.data.name == constraintName) return constraint;
        }
        return null;
    }
    /** Returns the axis aligned bounding box (AABB) of the region and mesh attachments for the current pose as `{ x: number, y: number, width: number, height: number }`.
   * Note that this method will create temporary objects which can add to garbage collection pressure. Use `getBounds()` if garbage collection is a concern. */ getBoundsRect() {
        const offset = new (0, $8804784813ffae81$export$c977b3e384af9ae1)();
        const size = new (0, $8804784813ffae81$export$c977b3e384af9ae1)();
        this.getBounds(offset, size);
        return {
            x: offset.x,
            y: offset.y,
            width: size.x,
            height: size.y
        };
    }
    /** Returns the axis aligned bounding box (AABB) of the region and mesh attachments for the current pose.
   * @param offset An output value, the distance from the skeleton origin to the bottom left corner of the AABB.
   * @param size An output value, the width and height of the AABB.
   * @param temp Working memory to temporarily store attachments' computed world vertices. */ getBounds(offset, size, temp = new Array(2)) {
        if (!offset) throw new Error("offset cannot be null.");
        if (!size) throw new Error("size cannot be null.");
        const drawOrder = this.drawOrder;
        let minX = Number.POSITIVE_INFINITY;
        let minY = Number.POSITIVE_INFINITY;
        let maxX = Number.NEGATIVE_INFINITY;
        let maxY = Number.NEGATIVE_INFINITY;
        for(let i = 0, n = drawOrder.length; i < n; i++){
            const slot = drawOrder[i];
            if (!slot.bone.active) continue;
            let verticesLength = 0;
            let vertices = null;
            const attachment = slot.getAttachment();
            if (attachment instanceof (0, $47a62d8b9e0a7455$export$d0fc51466fa6d530)) {
                verticesLength = 8;
                vertices = (0, $8804784813ffae81$export$d2ca453b913dcdea).setArraySize(temp, verticesLength, 0);
                attachment.computeWorldVertices(slot, vertices, 0, 2);
            } else if (attachment instanceof (0, $2085f04ed3d5f336$export$3f1c1692adfcf3e2)) {
                const mesh = attachment;
                verticesLength = mesh.worldVerticesLength;
                vertices = (0, $8804784813ffae81$export$d2ca453b913dcdea).setArraySize(temp, verticesLength, 0);
                mesh.computeWorldVertices(slot, 0, verticesLength, vertices, 0, 2);
            }
            if (vertices) for(let ii = 0, nn = vertices.length; ii < nn; ii += 2){
                const x = vertices[ii];
                const y = vertices[ii + 1];
                minX = Math.min(minX, x);
                minY = Math.min(minY, y);
                maxX = Math.max(maxX, x);
                maxY = Math.max(maxY, y);
            }
        }
        offset.set(minX, minY);
        size.set(maxX - minX, maxY - minY);
    }
    get flipX() {
        return this.scaleX == -1;
    }
    set flipX(value) {
        if (!$ee28c57a028fa6c5$var$_Skeleton.deprecatedWarning1) {
            $ee28c57a028fa6c5$var$_Skeleton.deprecatedWarning1 = true;
            console.warn("Spine Deprecation Warning: `Skeleton.flipX/flipY` was deprecated, please use scaleX/scaleY");
        }
        this.scaleX = value ? 1 : -1;
    }
    get flipY() {
        return this.scaleY == -1;
    }
    set flipY(value) {
        if (!$ee28c57a028fa6c5$var$_Skeleton.deprecatedWarning1) {
            $ee28c57a028fa6c5$var$_Skeleton.deprecatedWarning1 = true;
            console.warn("Spine Deprecation Warning: `Skeleton.flipX/flipY` was deprecated, please use scaleX/scaleY");
        }
        this.scaleY = value ? 1 : -1;
    }
};
let $ee28c57a028fa6c5$export$8f31e4c4a37b8e9c = $ee28c57a028fa6c5$var$_Skeleton;
$ee28c57a028fa6c5$export$8f31e4c4a37b8e9c.deprecatedWarning1 = false;




class $41c3b615da9f888b$export$e8f362f163550575 {
    constructor(){
        /** The skeleton's name, which by default is the name of the skeleton data file, if possible. May be null. */ this.name = null;
        /** The skeleton's bones, sorted parent first. The root bone is always the first bone. */ this.bones = new Array();
        // Ordered parents first.
        /** The skeleton's slots. */ this.slots = new Array();
        // Setup pose draw order.
        this.skins = new Array();
        /** The skeleton's default skin. By default this skin contains all attachments that were not in a skin in Spine.
     *
     * See {@link Skeleton#getAttachmentByName()}.
     * May be null. */ this.defaultSkin = null;
        /** The skeleton's events. */ this.events = new Array();
        /** The skeleton's animations. */ this.animations = new Array();
        /** The skeleton's IK constraints. */ this.ikConstraints = new Array();
        /** The skeleton's transform constraints. */ this.transformConstraints = new Array();
        /** The skeleton's path constraints. */ this.pathConstraints = new Array();
        /** The X coordinate of the skeleton's axis aligned bounding box in the setup pose. */ this.x = 0;
        /** The Y coordinate of the skeleton's axis aligned bounding box in the setup pose. */ this.y = 0;
        /** The width of the skeleton's axis aligned bounding box in the setup pose. */ this.width = 0;
        /** The height of the skeleton's axis aligned bounding box in the setup pose. */ this.height = 0;
        /** The Spine version used to export the skeleton data, or null. */ this.version = null;
        /** The skeleton data hash. This value will change if any of the skeleton data has changed. May be null. */ this.hash = null;
        // Nonessential
        /** The dopesheet FPS in Spine. Available only when nonessential data was exported. */ this.fps = 0;
        /** The path to the images directory as defined in Spine. Available only when nonessential data was exported. May be null. */ this.imagesPath = null;
        /** The path to the audio directory as defined in Spine. Available only when nonessential data was exported. May be null. */ this.audioPath = null;
    }
    /** Finds a bone by comparing each bone's name. It is more efficient to cache the results of this method than to call it
   * multiple times.
   * @returns May be null. */ findBone(boneName) {
        if (!boneName) throw new Error("boneName cannot be null.");
        const bones = this.bones;
        for(let i = 0, n = bones.length; i < n; i++){
            const bone = bones[i];
            if (bone.name == boneName) return bone;
        }
        return null;
    }
    /** removed from spine-ts runtime **/ findBoneIndex(boneName) {
        if (!boneName) throw new Error("boneName cannot be null.");
        const bones = this.bones;
        for(let i = 0, n = bones.length; i < n; i++)if (bones[i].name == boneName) return i;
        return -1;
    }
    /** Finds a slot by comparing each slot's name. It is more efficient to cache the results of this method than to call it
   * multiple times.
   * @returns May be null. */ findSlot(slotName) {
        if (!slotName) throw new Error("slotName cannot be null.");
        const slots = this.slots;
        for(let i = 0, n = slots.length; i < n; i++){
            const slot = slots[i];
            if (slot.name == slotName) return slot;
        }
        return null;
    }
    /** removed from spine-ts runtime **/ findSlotIndex(slotName) {
        if (!slotName) throw new Error("slotName cannot be null.");
        const slots = this.slots;
        for(let i = 0, n = slots.length; i < n; i++)if (slots[i].name == slotName) return i;
        return -1;
    }
    /** Finds a skin by comparing each skin's name. It is more efficient to cache the results of this method than to call it
   * multiple times.
   * @returns May be null. */ findSkin(skinName) {
        if (!skinName) throw new Error("skinName cannot be null.");
        const skins = this.skins;
        for(let i = 0, n = skins.length; i < n; i++){
            const skin = skins[i];
            if (skin.name == skinName) return skin;
        }
        return null;
    }
    /** Finds an event by comparing each events's name. It is more efficient to cache the results of this method than to call it
   * multiple times.
   * @returns May be null. */ findEvent(eventDataName) {
        if (!eventDataName) throw new Error("eventDataName cannot be null.");
        const events = this.events;
        for(let i = 0, n = events.length; i < n; i++){
            const event = events[i];
            if (event.name == eventDataName) return event;
        }
        return null;
    }
    /** Finds an animation by comparing each animation's name. It is more efficient to cache the results of this method than to
   * call it multiple times.
   * @returns May be null. */ findAnimation(animationName) {
        if (!animationName) throw new Error("animationName cannot be null.");
        const animations = this.animations;
        for(let i = 0, n = animations.length; i < n; i++){
            const animation = animations[i];
            if (animation.name == animationName) return animation;
        }
        return null;
    }
    /** Finds an IK constraint by comparing each IK constraint's name. It is more efficient to cache the results of this method
   * than to call it multiple times.
   * @return May be null. */ findIkConstraint(constraintName) {
        if (!constraintName) throw new Error("constraintName cannot be null.");
        const ikConstraints = this.ikConstraints;
        for(let i = 0, n = ikConstraints.length; i < n; i++){
            const constraint = ikConstraints[i];
            if (constraint.name == constraintName) return constraint;
        }
        return null;
    }
    /** Finds a transform constraint by comparing each transform constraint's name. It is more efficient to cache the results of
   * this method than to call it multiple times.
   * @return May be null. */ findTransformConstraint(constraintName) {
        if (!constraintName) throw new Error("constraintName cannot be null.");
        const transformConstraints = this.transformConstraints;
        for(let i = 0, n = transformConstraints.length; i < n; i++){
            const constraint = transformConstraints[i];
            if (constraint.name == constraintName) return constraint;
        }
        return null;
    }
    /** Finds a path constraint by comparing each path constraint's name. It is more efficient to cache the results of this method
   * than to call it multiple times.
   * @return May be null. */ findPathConstraint(constraintName) {
        if (!constraintName) throw new Error("constraintName cannot be null.");
        const pathConstraints = this.pathConstraints;
        for(let i = 0, n = pathConstraints.length; i < n; i++){
            const constraint = pathConstraints[i];
            if (constraint.name == constraintName) return constraint;
        }
        return null;
    }
    /** removed from spine-ts runtime **/ findPathConstraintIndex(pathConstraintName) {
        if (pathConstraintName == null) throw new Error("pathConstraintName cannot be null.");
        const pathConstraints = this.pathConstraints;
        for(let i = 0, n = pathConstraints.length; i < n; i++)if (pathConstraints[i].name == pathConstraintName) return i;
        return -1;
    }
}




class $3dc896cad7bb3460$export$a4cce1bf50208679 {
    constructor(index, name, boneData){
        /** The index of the slot in {@link Skeleton#getSlots()}. */ this.index = 0;
        /** The color used to tint the slot's attachment. If {@link #getDarkColor()} is set, this is used as the light color for two
     * color tinting. */ this.color = new (0, $8804784813ffae81$export$892596cec99bc70e)(1, 1, 1, 1);
        /** The dark color used to tint the slot's attachment for two color tinting, or null if two color tinting is not used. The dark
     * color's alpha is not used. */ this.darkColor = null;
        /** The name of the attachment that is visible for this slot in the setup pose, or null if no attachment is visible. */ this.attachmentName = null;
        /** The blend mode for drawing the slot's attachment. */ this.blendMode = (0, $0fa4b07f86297abd$export$f821c68fe9beaecf).NORMAL;
        if (index < 0) throw new Error("index must be >= 0.");
        if (!name) throw new Error("name cannot be null.");
        if (!boneData) throw new Error("boneData cannot be null.");
        this.index = index;
        this.name = name;
        this.boneData = boneData;
    }
}





class $7c37517de6acc018$export$823fbc29771afdb5 extends (0, $6e2eadc25b36742c$export$b826e1ab3af63566) {
    constructor(name){
        super(name, 0, false);
        /** The bones that will be modified by this transform constraint. */ this.bones = new Array();
        /** The target bone whose world transform will be copied to the constrained bones. */ this._target = null;
        this.mixRotate = 0;
        this.mixX = 0;
        this.mixY = 0;
        this.mixScaleX = 0;
        this.mixScaleY = 0;
        this.mixShearY = 0;
        /** An offset added to the constrained bone rotation. */ this.offsetRotation = 0;
        /** An offset added to the constrained bone X translation. */ this.offsetX = 0;
        /** An offset added to the constrained bone Y translation. */ this.offsetY = 0;
        /** An offset added to the constrained bone scaleX. */ this.offsetScaleX = 0;
        /** An offset added to the constrained bone scaleY. */ this.offsetScaleY = 0;
        /** An offset added to the constrained bone shearY. */ this.offsetShearY = 0;
        this.relative = false;
        this.local = false;
    }
    set target(boneData) {
        this._target = boneData;
    }
    get target() {
        if (!this._target) throw new Error("BoneData not set.");
        else return this._target;
    }
}








class $e029b89e8e37c790$export$18ca51770a196b7d {
    constructor(slotIndex, name, attachment){
        this.slotIndex = slotIndex;
        this.name = name;
        this.attachment = attachment;
    }
}
class $e029b89e8e37c790$export$b8e0f93a76772233 {
    constructor(name){
        this.attachments = new Array();
        this.bones = Array();
        this.constraints = new Array();
        if (!name) throw new Error("name cannot be null.");
        this.name = name;
    }
    /** Adds an attachment to the skin for the specified slot index and name. */ setAttachment(slotIndex, name, attachment) {
        if (!attachment) throw new Error("attachment cannot be null.");
        const attachments = this.attachments;
        if (slotIndex >= attachments.length) attachments.length = slotIndex + 1;
        if (!attachments[slotIndex]) attachments[slotIndex] = {};
        attachments[slotIndex][name] = attachment;
    }
    /** Adds all attachments, bones, and constraints from the specified skin to this skin. */ addSkin(skin) {
        for(let i = 0; i < skin.bones.length; i++){
            const bone = skin.bones[i];
            let contained = false;
            for(let ii = 0; ii < this.bones.length; ii++)if (this.bones[ii] == bone) {
                contained = true;
                break;
            }
            if (!contained) this.bones.push(bone);
        }
        for(let i = 0; i < skin.constraints.length; i++){
            const constraint = skin.constraints[i];
            let contained = false;
            for(let ii = 0; ii < this.constraints.length; ii++)if (this.constraints[ii] == constraint) {
                contained = true;
                break;
            }
            if (!contained) this.constraints.push(constraint);
        }
        const attachments = skin.getAttachments();
        for(let i = 0; i < attachments.length; i++){
            const attachment = attachments[i];
            this.setAttachment(attachment.slotIndex, attachment.name, attachment.attachment);
        }
    }
    /** Adds all bones and constraints and copies of all attachments from the specified skin to this skin. Mesh attachments are not
   * copied, instead a new linked mesh is created. The attachment copies can be modified without affecting the originals. */ copySkin(skin) {
        for(let i = 0; i < skin.bones.length; i++){
            const bone = skin.bones[i];
            let contained = false;
            for(let ii = 0; ii < this.bones.length; ii++)if (this.bones[ii] == bone) {
                contained = true;
                break;
            }
            if (!contained) this.bones.push(bone);
        }
        for(let i = 0; i < skin.constraints.length; i++){
            const constraint = skin.constraints[i];
            let contained = false;
            for(let ii = 0; ii < this.constraints.length; ii++)if (this.constraints[ii] == constraint) {
                contained = true;
                break;
            }
            if (!contained) this.constraints.push(constraint);
        }
        const attachments = skin.getAttachments();
        for(let i = 0; i < attachments.length; i++){
            const attachment = attachments[i];
            if (!attachment.attachment) continue;
            if (attachment.attachment instanceof (0, $2085f04ed3d5f336$export$3f1c1692adfcf3e2)) {
                attachment.attachment = attachment.attachment.newLinkedMesh();
                this.setAttachment(attachment.slotIndex, attachment.name, attachment.attachment);
            } else {
                attachment.attachment = attachment.attachment.copy();
                this.setAttachment(attachment.slotIndex, attachment.name, attachment.attachment);
            }
        }
    }
    /** Returns the attachment for the specified slot index and name, or null. */ getAttachment(slotIndex, name) {
        const dictionary = this.attachments[slotIndex];
        return dictionary ? dictionary[name] : null;
    }
    /** Removes the attachment in the skin for the specified slot index and name, if any. */ removeAttachment(slotIndex, name) {
        const dictionary = this.attachments[slotIndex];
        if (dictionary) delete dictionary[name];
    }
    /** Returns all attachments in this skin. */ getAttachments() {
        const entries = new Array();
        for(let i = 0; i < this.attachments.length; i++){
            const slotAttachments = this.attachments[i];
            if (slotAttachments) for(const name in slotAttachments){
                const attachment = slotAttachments[name];
                if (attachment) entries.push(new $e029b89e8e37c790$export$18ca51770a196b7d(i, name, attachment));
            }
        }
        return entries;
    }
    /** Returns all attachments in this skin for the specified slot index. */ getAttachmentsForSlot(slotIndex, attachments) {
        const slotAttachments = this.attachments[slotIndex];
        if (slotAttachments) for(const name in slotAttachments){
            const attachment = slotAttachments[name];
            if (attachment) attachments.push(new $e029b89e8e37c790$export$18ca51770a196b7d(slotIndex, name, attachment));
        }
    }
    /** Clears all attachments, bones, and constraints. */ clear() {
        this.attachments.length = 0;
        this.bones.length = 0;
        this.constraints.length = 0;
    }
    /** Attach each attachment in this skin if the corresponding attachment in the old skin is currently attached. */ attachAll(skeleton, oldSkin) {
        let slotIndex = 0;
        for(let i = 0; i < skeleton.slots.length; i++){
            const slot = skeleton.slots[i];
            const slotAttachment = slot.getAttachment();
            if (slotAttachment && slotIndex < oldSkin.attachments.length) {
                const dictionary = oldSkin.attachments[slotIndex];
                for(const key in dictionary){
                    const skinAttachment = dictionary[key];
                    if (slotAttachment == skinAttachment) {
                        const attachment = this.getAttachment(slotIndex, key);
                        if (attachment) slot.setAttachment(attachment);
                        break;
                    }
                }
            }
            slotIndex++;
        }
    }
}








class $64725297a8c20f8e$export$a7f7eaf4e9fce9ef {
    constructor(attachmentLoader){
        this.ver40 = false;
        /** Scales bone positions, image sizes, and translations as they are loaded. This allows different size images to be used at
     * runtime than were used in Spine.
     *
     * See [Scaling](http://esotericsoftware.com/spine-loading-skeleton-data#Scaling) in the Spine Runtimes Guide. */ this.scale = 1;
        this.linkedMeshes = new Array();
        this.attachmentLoader = attachmentLoader;
    }
    readSkeletonData(binary) {
        const scale = this.scale;
        const skeletonData = new (0, $41c3b615da9f888b$export$e8f362f163550575)();
        skeletonData.name = "";
        const input = new (0, $76f67eeea63ddac1$export$c8e921ea3330f774)(binary);
        const lowHash = input.readInt32();
        const highHash = input.readInt32();
        skeletonData.hash = highHash == 0 && lowHash == 0 ? null : highHash.toString(16) + lowHash.toString(16);
        skeletonData.version = input.readString();
        const verShort = skeletonData.version.substr(0, 3);
        if (verShort !== "4.0" && verShort !== "4.1") {
            const error = `Spine 4.1 loader cant load version ${skeletonData.version}. Please configure your pixi-spine bundle`;
            console.error(error);
        }
        this.ver40 = verShort === "4.0";
        skeletonData.x = input.readFloat();
        skeletonData.y = input.readFloat();
        skeletonData.width = input.readFloat();
        skeletonData.height = input.readFloat();
        const nonessential = input.readBoolean();
        if (nonessential) {
            skeletonData.fps = input.readFloat();
            skeletonData.imagesPath = input.readString();
            skeletonData.audioPath = input.readString();
        }
        let n = 0;
        n = input.readInt(true);
        for(let i = 0; i < n; i++){
            const str = input.readString();
            if (!str) throw new Error("String in string table must not be null.");
            input.strings.push(str);
        }
        n = input.readInt(true);
        for(let i = 0; i < n; i++){
            const name = input.readString();
            if (!name) throw new Error("Bone name must not be null.");
            const parent = i == 0 ? null : skeletonData.bones[input.readInt(true)];
            const data = new (0, $b873069de67ba47c$export$7d85d96cf093e12f)(i, name, parent);
            data.rotation = input.readFloat();
            data.x = input.readFloat() * scale;
            data.y = input.readFloat() * scale;
            data.scaleX = input.readFloat();
            data.scaleY = input.readFloat();
            data.shearX = input.readFloat();
            data.shearY = input.readFloat();
            data.length = input.readFloat() * scale;
            data.transformMode = input.readInt(true);
            data.skinRequired = input.readBoolean();
            if (nonessential) (0, $8804784813ffae81$export$892596cec99bc70e).rgba8888ToColor(data.color, input.readInt32());
            skeletonData.bones.push(data);
        }
        n = input.readInt(true);
        for(let i = 0; i < n; i++){
            const slotName = input.readString();
            if (!slotName) throw new Error("Slot name must not be null.");
            const boneData = skeletonData.bones[input.readInt(true)];
            const data = new (0, $3dc896cad7bb3460$export$a4cce1bf50208679)(i, slotName, boneData);
            (0, $8804784813ffae81$export$892596cec99bc70e).rgba8888ToColor(data.color, input.readInt32());
            const darkColor = input.readInt32();
            if (darkColor != -1) (0, $8804784813ffae81$export$892596cec99bc70e).rgb888ToColor(data.darkColor = new (0, $8804784813ffae81$export$892596cec99bc70e)(), darkColor);
            data.attachmentName = input.readStringRef();
            data.blendMode = input.readInt(true);
            skeletonData.slots.push(data);
        }
        n = input.readInt(true);
        for(let i = 0, nn; i < n; i++){
            const name = input.readString();
            if (!name) throw new Error("IK constraint data name must not be null.");
            const data = new (0, $439d8ab836629982$export$adcb08b651fc712e)(name);
            data.order = input.readInt(true);
            data.skinRequired = input.readBoolean();
            nn = input.readInt(true);
            for(let ii = 0; ii < nn; ii++)data.bones.push(skeletonData.bones[input.readInt(true)]);
            data.target = skeletonData.bones[input.readInt(true)];
            data.mix = input.readFloat();
            data.softness = input.readFloat() * scale;
            data.bendDirection = input.readByte();
            data.compress = input.readBoolean();
            data.stretch = input.readBoolean();
            data.uniform = input.readBoolean();
            skeletonData.ikConstraints.push(data);
        }
        n = input.readInt(true);
        for(let i = 0, nn; i < n; i++){
            const name = input.readString();
            if (!name) throw new Error("Transform constraint data name must not be null.");
            const data = new (0, $7c37517de6acc018$export$823fbc29771afdb5)(name);
            data.order = input.readInt(true);
            data.skinRequired = input.readBoolean();
            nn = input.readInt(true);
            for(let ii = 0; ii < nn; ii++)data.bones.push(skeletonData.bones[input.readInt(true)]);
            data.target = skeletonData.bones[input.readInt(true)];
            data.local = input.readBoolean();
            data.relative = input.readBoolean();
            data.offsetRotation = input.readFloat();
            data.offsetX = input.readFloat() * scale;
            data.offsetY = input.readFloat() * scale;
            data.offsetScaleX = input.readFloat();
            data.offsetScaleY = input.readFloat();
            data.offsetShearY = input.readFloat();
            data.mixRotate = input.readFloat();
            data.mixX = input.readFloat();
            data.mixY = input.readFloat();
            data.mixScaleX = input.readFloat();
            data.mixScaleY = input.readFloat();
            data.mixShearY = input.readFloat();
            skeletonData.transformConstraints.push(data);
        }
        n = input.readInt(true);
        for(let i = 0, nn; i < n; i++){
            const name = input.readString();
            if (!name) throw new Error("Path constraint data name must not be null.");
            const data = new (0, $07612ba9b2d17d60$export$d2629ab80d5dd5ba)(name);
            data.order = input.readInt(true);
            data.skinRequired = input.readBoolean();
            nn = input.readInt(true);
            for(let ii = 0; ii < nn; ii++)data.bones.push(skeletonData.bones[input.readInt(true)]);
            data.target = skeletonData.slots[input.readInt(true)];
            data.positionMode = input.readInt(true);
            data.spacingMode = input.readInt(true);
            data.rotateMode = input.readInt(true);
            data.offsetRotation = input.readFloat();
            data.position = input.readFloat();
            if (data.positionMode == (0, $2c8db927dc4fcff5$export$34d637c671e1e906).Fixed) data.position *= scale;
            data.spacing = input.readFloat();
            if (data.spacingMode == (0, $07612ba9b2d17d60$export$34ce760ad2b0be4b).Length || data.spacingMode == (0, $07612ba9b2d17d60$export$34ce760ad2b0be4b).Fixed) data.spacing *= scale;
            data.mixRotate = input.readFloat();
            data.mixX = input.readFloat();
            data.mixY = input.readFloat();
            skeletonData.pathConstraints.push(data);
        }
        const defaultSkin = this.readSkin(input, skeletonData, true, nonessential);
        if (defaultSkin) {
            skeletonData.defaultSkin = defaultSkin;
            skeletonData.skins.push(defaultSkin);
        }
        {
            let i = skeletonData.skins.length;
            (0, $8804784813ffae81$export$d2ca453b913dcdea).setArraySize(skeletonData.skins, n = i + input.readInt(true));
            for(; i < n; i++){
                const skin = this.readSkin(input, skeletonData, false, nonessential);
                if (!skin) throw new Error("readSkin() should not have returned null.");
                skeletonData.skins[i] = skin;
            }
        }
        n = this.linkedMeshes.length;
        for(let i = 0; i < n; i++){
            const linkedMesh = this.linkedMeshes[i];
            const skin = !linkedMesh.skin ? skeletonData.defaultSkin : skeletonData.findSkin(linkedMesh.skin);
            if (!skin) throw new Error("Not skin found for linked mesh.");
            if (!linkedMesh.parent) throw new Error("Linked mesh parent must not be null");
            const parent = skin.getAttachment(linkedMesh.slotIndex, linkedMesh.parent);
            if (!parent) throw new Error(`Parent mesh not found: ${linkedMesh.parent}`);
            linkedMesh.mesh.timelineAttachment = linkedMesh.inheritTimeline ? parent : linkedMesh.mesh;
            linkedMesh.mesh.setParentMesh(parent);
        }
        this.linkedMeshes.length = 0;
        n = input.readInt(true);
        for(let i = 0; i < n; i++){
            const eventName = input.readStringRef();
            if (!eventName) throw new Error();
            const data = new (0, $57711e45b8cfda24$export$a5cf049e34c3d11e)(eventName);
            data.intValue = input.readInt(false);
            data.floatValue = input.readFloat();
            data.stringValue = input.readString();
            data.audioPath = input.readString();
            if (data.audioPath) {
                data.volume = input.readFloat();
                data.balance = input.readFloat();
            }
            skeletonData.events.push(data);
        }
        n = input.readInt(true);
        for(let i = 0; i < n; i++){
            const animationName = input.readString();
            if (!animationName) throw new Error("Animatio name must not be null.");
            skeletonData.animations.push(this.readAnimation(input, animationName, skeletonData));
        }
        return skeletonData;
    }
    readSkin(input, skeletonData, defaultSkin, nonessential) {
        let skin = null;
        let slotCount = 0;
        if (defaultSkin) {
            slotCount = input.readInt(true);
            if (slotCount == 0) return null;
            skin = new (0, $e029b89e8e37c790$export$b8e0f93a76772233)("default");
        } else {
            const skinName = input.readStringRef();
            if (!skinName) throw new Error("Skin name must not be null.");
            skin = new (0, $e029b89e8e37c790$export$b8e0f93a76772233)(skinName);
            skin.bones.length = input.readInt(true);
            for(let i = 0, n = skin.bones.length; i < n; i++)skin.bones[i] = skeletonData.bones[input.readInt(true)];
            for(let i = 0, n = input.readInt(true); i < n; i++)skin.constraints.push(skeletonData.ikConstraints[input.readInt(true)]);
            for(let i = 0, n = input.readInt(true); i < n; i++)skin.constraints.push(skeletonData.transformConstraints[input.readInt(true)]);
            for(let i = 0, n = input.readInt(true); i < n; i++)skin.constraints.push(skeletonData.pathConstraints[input.readInt(true)]);
            slotCount = input.readInt(true);
        }
        for(let i = 0; i < slotCount; i++){
            const slotIndex = input.readInt(true);
            for(let ii = 0, nn = input.readInt(true); ii < nn; ii++){
                const name = input.readStringRef();
                if (!name) throw new Error("Attachment name must not be null");
                const attachment = this.readAttachment(input, skeletonData, skin, slotIndex, name, nonessential);
                if (attachment) skin.setAttachment(slotIndex, name, attachment);
            }
        }
        return skin;
    }
    readAttachment(input, skeletonData, skin, slotIndex, attachmentName, nonessential) {
        const scale = this.scale;
        let name = input.readStringRef();
        if (!name) name = attachmentName;
        switch(input.readByte()){
            case (0, $4b0ad7d1400b5e69$export$86cfdc1f02eaf37a).Region:
                {
                    let path = input.readStringRef();
                    const rotation = input.readFloat();
                    const x = input.readFloat();
                    const y = input.readFloat();
                    const scaleX = input.readFloat();
                    const scaleY = input.readFloat();
                    const width = input.readFloat();
                    const height = input.readFloat();
                    const color = input.readInt32();
                    const sequence = this.readSequence(input);
                    if (!path) path = name;
                    const region = this.attachmentLoader.newRegionAttachment(skin, name, path, sequence);
                    if (!region) return null;
                    region.path = path;
                    region.x = x * scale;
                    region.y = y * scale;
                    region.scaleX = scaleX;
                    region.scaleY = scaleY;
                    region.rotation = rotation;
                    region.width = width * scale;
                    region.height = height * scale;
                    (0, $8804784813ffae81$export$892596cec99bc70e).rgba8888ToColor(region.color, color);
                    region.sequence = sequence;
                    if (sequence == null) region.updateRegion();
                    return region;
                }
            case (0, $4b0ad7d1400b5e69$export$86cfdc1f02eaf37a).BoundingBox:
                {
                    const vertexCount = input.readInt(true);
                    const vertices = this.readVertices(input, vertexCount);
                    const color = nonessential ? input.readInt32() : 0;
                    const box = this.attachmentLoader.newBoundingBoxAttachment(skin, name);
                    if (!box) return null;
                    box.worldVerticesLength = vertexCount << 1;
                    box.vertices = vertices.vertices;
                    box.bones = vertices.bones;
                    if (nonessential) (0, $8804784813ffae81$export$892596cec99bc70e).rgba8888ToColor(box.color, color);
                    return box;
                }
            case (0, $4b0ad7d1400b5e69$export$86cfdc1f02eaf37a).Mesh:
                {
                    let path = input.readStringRef();
                    const color = input.readInt32();
                    const vertexCount = input.readInt(true);
                    const uvs = this.readFloatArray(input, vertexCount << 1, 1);
                    const triangles = this.readShortArray(input);
                    const vertices = this.readVertices(input, vertexCount);
                    const hullLength = input.readInt(true);
                    const sequence = this.readSequence(input);
                    let edges = [];
                    let width = 0;
                    let height = 0;
                    if (nonessential) {
                        edges = this.readShortArray(input);
                        width = input.readFloat();
                        height = input.readFloat();
                    }
                    if (!path) path = name;
                    const mesh = this.attachmentLoader.newMeshAttachment(skin, name, path, sequence);
                    if (!mesh) return null;
                    mesh.path = path;
                    (0, $8804784813ffae81$export$892596cec99bc70e).rgba8888ToColor(mesh.color, color);
                    mesh.bones = vertices.bones;
                    mesh.vertices = vertices.vertices;
                    mesh.worldVerticesLength = vertexCount << 1;
                    mesh.triangles = triangles;
                    mesh.regionUVs = new Float32Array(uvs);
                    mesh.hullLength = hullLength << 1;
                    mesh.sequence = sequence;
                    if (nonessential) {
                        mesh.edges = edges;
                        mesh.width = width * scale;
                        mesh.height = height * scale;
                    }
                    return mesh;
                }
            case (0, $4b0ad7d1400b5e69$export$86cfdc1f02eaf37a).LinkedMesh:
                {
                    let path = input.readStringRef();
                    const color = input.readInt32();
                    const skinName = input.readStringRef();
                    const parent = input.readStringRef();
                    const inheritTimelines = input.readBoolean();
                    const sequence = this.readSequence(input);
                    let width = 0;
                    let height = 0;
                    if (nonessential) {
                        width = input.readFloat();
                        height = input.readFloat();
                    }
                    if (!path) path = name;
                    const mesh = this.attachmentLoader.newMeshAttachment(skin, name, path, sequence);
                    if (!mesh) return null;
                    mesh.path = path;
                    (0, $8804784813ffae81$export$892596cec99bc70e).rgba8888ToColor(mesh.color, color);
                    mesh.sequence = sequence;
                    if (nonessential) {
                        mesh.width = width * scale;
                        mesh.height = height * scale;
                    }
                    this.linkedMeshes.push(new $64725297a8c20f8e$var$LinkedMesh(mesh, skinName, slotIndex, parent, inheritTimelines));
                    return mesh;
                }
            case (0, $4b0ad7d1400b5e69$export$86cfdc1f02eaf37a).Path:
                {
                    const closed = input.readBoolean();
                    const constantSpeed = input.readBoolean();
                    const vertexCount = input.readInt(true);
                    const vertices = this.readVertices(input, vertexCount);
                    const lengths = (0, $8804784813ffae81$export$d2ca453b913dcdea).newArray(vertexCount / 3, 0);
                    for(let i = 0, n = lengths.length; i < n; i++)lengths[i] = input.readFloat() * scale;
                    const color = nonessential ? input.readInt32() : 0;
                    const path = this.attachmentLoader.newPathAttachment(skin, name);
                    if (!path) return null;
                    path.closed = closed;
                    path.constantSpeed = constantSpeed;
                    path.worldVerticesLength = vertexCount << 1;
                    path.vertices = vertices.vertices;
                    path.bones = vertices.bones;
                    path.lengths = lengths;
                    if (nonessential) (0, $8804784813ffae81$export$892596cec99bc70e).rgba8888ToColor(path.color, color);
                    return path;
                }
            case (0, $4b0ad7d1400b5e69$export$86cfdc1f02eaf37a).Point:
                {
                    const rotation = input.readFloat();
                    const x = input.readFloat();
                    const y = input.readFloat();
                    const color = nonessential ? input.readInt32() : 0;
                    const point = this.attachmentLoader.newPointAttachment(skin, name);
                    if (!point) return null;
                    point.x = x * scale;
                    point.y = y * scale;
                    point.rotation = rotation;
                    if (nonessential) (0, $8804784813ffae81$export$892596cec99bc70e).rgba8888ToColor(point.color, color);
                    return point;
                }
            case (0, $4b0ad7d1400b5e69$export$86cfdc1f02eaf37a).Clipping:
                {
                    const endSlotIndex = input.readInt(true);
                    const vertexCount = input.readInt(true);
                    const vertices = this.readVertices(input, vertexCount);
                    const color = nonessential ? input.readInt32() : 0;
                    const clip = this.attachmentLoader.newClippingAttachment(skin, name);
                    if (!clip) return null;
                    clip.endSlot = skeletonData.slots[endSlotIndex];
                    clip.worldVerticesLength = vertexCount << 1;
                    clip.vertices = vertices.vertices;
                    clip.bones = vertices.bones;
                    if (nonessential) (0, $8804784813ffae81$export$892596cec99bc70e).rgba8888ToColor(clip.color, color);
                    return clip;
                }
        }
        return null;
    }
    readSequence(input) {
        if (this.ver40 || !input.readBoolean()) return null;
        const sequence = new (0, $37628ed40604134f$export$edde1bcb1b2b310e)(input.readInt(true));
        sequence.start = input.readInt(true);
        sequence.digits = input.readInt(true);
        sequence.setupIndex = input.readInt(true);
        return sequence;
    }
    readDeformTimelineType(input) {
        if (this.ver40) return $64725297a8c20f8e$var$ATTACHMENT_DEFORM;
        return input.readByte();
    }
    readVertices(input, vertexCount) {
        const scale = this.scale;
        const verticesLength = vertexCount << 1;
        const vertices = new $64725297a8c20f8e$var$Vertices();
        if (!input.readBoolean()) {
            vertices.vertices = this.readFloatArray(input, verticesLength, scale);
            return vertices;
        }
        const weights = new Array();
        const bonesArray = new Array();
        for(let i = 0; i < vertexCount; i++){
            const boneCount = input.readInt(true);
            bonesArray.push(boneCount);
            for(let ii = 0; ii < boneCount; ii++){
                bonesArray.push(input.readInt(true));
                weights.push(input.readFloat() * scale);
                weights.push(input.readFloat() * scale);
                weights.push(input.readFloat());
            }
        }
        vertices.vertices = (0, $8804784813ffae81$export$d2ca453b913dcdea).toFloatArray(weights);
        vertices.bones = bonesArray;
        return vertices;
    }
    readFloatArray(input, n, scale) {
        const array = new Array(n);
        if (scale == 1) for(let i = 0; i < n; i++)array[i] = input.readFloat();
        else for(let i = 0; i < n; i++)array[i] = input.readFloat() * scale;
        return array;
    }
    readShortArray(input) {
        const n = input.readInt(true);
        const array = new Array(n);
        for(let i = 0; i < n; i++)array[i] = input.readShort();
        return array;
    }
    readAnimation(input, name, skeletonData) {
        input.readInt(true);
        const timelines = new Array();
        const scale = this.scale;
        for(let i = 0, n = input.readInt(true); i < n; i++){
            const slotIndex = input.readInt(true);
            for(let ii = 0, nn = input.readInt(true); ii < nn; ii++){
                const timelineType = input.readByte();
                const frameCount = input.readInt(true);
                const frameLast = frameCount - 1;
                switch(timelineType){
                    case $64725297a8c20f8e$var$SLOT_ATTACHMENT:
                        {
                            const timeline = new (0, $fd5e2eaf5f163d40$export$7f2bfc5bd27cb43d)(frameCount, slotIndex);
                            for(let frame = 0; frame < frameCount; frame++)timeline.setFrame(frame, input.readFloat(), input.readStringRef());
                            timelines.push(timeline);
                            break;
                        }
                    case $64725297a8c20f8e$var$SLOT_RGBA:
                        {
                            const bezierCount = input.readInt(true);
                            const timeline = new (0, $fd5e2eaf5f163d40$export$84cf3a3e225bcbdc)(frameCount, bezierCount, slotIndex);
                            let time = input.readFloat();
                            let r = input.readUnsignedByte() / 255;
                            let g = input.readUnsignedByte() / 255;
                            let b = input.readUnsignedByte() / 255;
                            let a = input.readUnsignedByte() / 255;
                            for(let frame = 0, bezier = 0;; frame++){
                                timeline.setFrame(frame, time, r, g, b, a);
                                if (frame == frameLast) break;
                                const time2 = input.readFloat();
                                const r2 = input.readUnsignedByte() / 255;
                                const g2 = input.readUnsignedByte() / 255;
                                const b2 = input.readUnsignedByte() / 255;
                                const a2 = input.readUnsignedByte() / 255;
                                switch(input.readByte()){
                                    case $64725297a8c20f8e$var$CURVE_STEPPED:
                                        timeline.setStepped(frame);
                                        break;
                                    case $64725297a8c20f8e$var$CURVE_BEZIER:
                                        $64725297a8c20f8e$var$setBezier(input, timeline, bezier++, frame, 0, time, time2, r, r2, 1);
                                        $64725297a8c20f8e$var$setBezier(input, timeline, bezier++, frame, 1, time, time2, g, g2, 1);
                                        $64725297a8c20f8e$var$setBezier(input, timeline, bezier++, frame, 2, time, time2, b, b2, 1);
                                        $64725297a8c20f8e$var$setBezier(input, timeline, bezier++, frame, 3, time, time2, a, a2, 1);
                                }
                                time = time2;
                                r = r2;
                                g = g2;
                                b = b2;
                                a = a2;
                            }
                            timelines.push(timeline);
                            break;
                        }
                    case $64725297a8c20f8e$var$SLOT_RGB:
                        {
                            const bezierCount = input.readInt(true);
                            const timeline = new (0, $fd5e2eaf5f163d40$export$e179fb669ddccfa9)(frameCount, bezierCount, slotIndex);
                            let time = input.readFloat();
                            let r = input.readUnsignedByte() / 255;
                            let g = input.readUnsignedByte() / 255;
                            let b = input.readUnsignedByte() / 255;
                            for(let frame = 0, bezier = 0;; frame++){
                                timeline.setFrame(frame, time, r, g, b);
                                if (frame == frameLast) break;
                                const time2 = input.readFloat();
                                const r2 = input.readUnsignedByte() / 255;
                                const g2 = input.readUnsignedByte() / 255;
                                const b2 = input.readUnsignedByte() / 255;
                                switch(input.readByte()){
                                    case $64725297a8c20f8e$var$CURVE_STEPPED:
                                        timeline.setStepped(frame);
                                        break;
                                    case $64725297a8c20f8e$var$CURVE_BEZIER:
                                        $64725297a8c20f8e$var$setBezier(input, timeline, bezier++, frame, 0, time, time2, r, r2, 1);
                                        $64725297a8c20f8e$var$setBezier(input, timeline, bezier++, frame, 1, time, time2, g, g2, 1);
                                        $64725297a8c20f8e$var$setBezier(input, timeline, bezier++, frame, 2, time, time2, b, b2, 1);
                                }
                                time = time2;
                                r = r2;
                                g = g2;
                                b = b2;
                            }
                            timelines.push(timeline);
                            break;
                        }
                    case $64725297a8c20f8e$var$SLOT_RGBA2:
                        {
                            const bezierCount = input.readInt(true);
                            const timeline = new (0, $fd5e2eaf5f163d40$export$6fc6620d97c53689)(frameCount, bezierCount, slotIndex);
                            let time = input.readFloat();
                            let r = input.readUnsignedByte() / 255;
                            let g = input.readUnsignedByte() / 255;
                            let b = input.readUnsignedByte() / 255;
                            let a = input.readUnsignedByte() / 255;
                            let r2 = input.readUnsignedByte() / 255;
                            let g2 = input.readUnsignedByte() / 255;
                            let b2 = input.readUnsignedByte() / 255;
                            for(let frame = 0, bezier = 0;; frame++){
                                timeline.setFrame(frame, time, r, g, b, a, r2, g2, b2);
                                if (frame == frameLast) break;
                                const time2 = input.readFloat();
                                const nr = input.readUnsignedByte() / 255;
                                const ng = input.readUnsignedByte() / 255;
                                const nb = input.readUnsignedByte() / 255;
                                const na = input.readUnsignedByte() / 255;
                                const nr2 = input.readUnsignedByte() / 255;
                                const ng2 = input.readUnsignedByte() / 255;
                                const nb2 = input.readUnsignedByte() / 255;
                                switch(input.readByte()){
                                    case $64725297a8c20f8e$var$CURVE_STEPPED:
                                        timeline.setStepped(frame);
                                        break;
                                    case $64725297a8c20f8e$var$CURVE_BEZIER:
                                        $64725297a8c20f8e$var$setBezier(input, timeline, bezier++, frame, 0, time, time2, r, nr, 1);
                                        $64725297a8c20f8e$var$setBezier(input, timeline, bezier++, frame, 1, time, time2, g, ng, 1);
                                        $64725297a8c20f8e$var$setBezier(input, timeline, bezier++, frame, 2, time, time2, b, nb, 1);
                                        $64725297a8c20f8e$var$setBezier(input, timeline, bezier++, frame, 3, time, time2, a, na, 1);
                                        $64725297a8c20f8e$var$setBezier(input, timeline, bezier++, frame, 4, time, time2, r2, nr2, 1);
                                        $64725297a8c20f8e$var$setBezier(input, timeline, bezier++, frame, 5, time, time2, g2, ng2, 1);
                                        $64725297a8c20f8e$var$setBezier(input, timeline, bezier++, frame, 6, time, time2, b2, nb2, 1);
                                }
                                time = time2;
                                r = nr;
                                g = ng;
                                b = nb;
                                a = na;
                                r2 = nr2;
                                g2 = ng2;
                                b2 = nb2;
                            }
                            timelines.push(timeline);
                            break;
                        }
                    case $64725297a8c20f8e$var$SLOT_RGB2:
                        {
                            const bezierCount = input.readInt(true);
                            const timeline = new (0, $fd5e2eaf5f163d40$export$a12960afd309a230)(frameCount, bezierCount, slotIndex);
                            let time = input.readFloat();
                            let r = input.readUnsignedByte() / 255;
                            let g = input.readUnsignedByte() / 255;
                            let b = input.readUnsignedByte() / 255;
                            let r2 = input.readUnsignedByte() / 255;
                            let g2 = input.readUnsignedByte() / 255;
                            let b2 = input.readUnsignedByte() / 255;
                            for(let frame = 0, bezier = 0;; frame++){
                                timeline.setFrame(frame, time, r, g, b, r2, g2, b2);
                                if (frame == frameLast) break;
                                const time2 = input.readFloat();
                                const nr = input.readUnsignedByte() / 255;
                                const ng = input.readUnsignedByte() / 255;
                                const nb = input.readUnsignedByte() / 255;
                                const nr2 = input.readUnsignedByte() / 255;
                                const ng2 = input.readUnsignedByte() / 255;
                                const nb2 = input.readUnsignedByte() / 255;
                                switch(input.readByte()){
                                    case $64725297a8c20f8e$var$CURVE_STEPPED:
                                        timeline.setStepped(frame);
                                        break;
                                    case $64725297a8c20f8e$var$CURVE_BEZIER:
                                        $64725297a8c20f8e$var$setBezier(input, timeline, bezier++, frame, 0, time, time2, r, nr, 1);
                                        $64725297a8c20f8e$var$setBezier(input, timeline, bezier++, frame, 1, time, time2, g, ng, 1);
                                        $64725297a8c20f8e$var$setBezier(input, timeline, bezier++, frame, 2, time, time2, b, nb, 1);
                                        $64725297a8c20f8e$var$setBezier(input, timeline, bezier++, frame, 3, time, time2, r2, nr2, 1);
                                        $64725297a8c20f8e$var$setBezier(input, timeline, bezier++, frame, 4, time, time2, g2, ng2, 1);
                                        $64725297a8c20f8e$var$setBezier(input, timeline, bezier++, frame, 5, time, time2, b2, nb2, 1);
                                }
                                time = time2;
                                r = nr;
                                g = ng;
                                b = nb;
                                r2 = nr2;
                                g2 = ng2;
                                b2 = nb2;
                            }
                            timelines.push(timeline);
                            break;
                        }
                    case $64725297a8c20f8e$var$SLOT_ALPHA:
                        {
                            const timeline = new (0, $fd5e2eaf5f163d40$export$2211be7c5ccde97b)(frameCount, input.readInt(true), slotIndex);
                            let time = input.readFloat();
                            let a = input.readUnsignedByte() / 255;
                            for(let frame = 0, bezier = 0;; frame++){
                                timeline.setFrame(frame, time, a);
                                if (frame == frameLast) break;
                                const time2 = input.readFloat();
                                const a2 = input.readUnsignedByte() / 255;
                                switch(input.readByte()){
                                    case $64725297a8c20f8e$var$CURVE_STEPPED:
                                        timeline.setStepped(frame);
                                        break;
                                    case $64725297a8c20f8e$var$CURVE_BEZIER:
                                        $64725297a8c20f8e$var$setBezier(input, timeline, bezier++, frame, 0, time, time2, a, a2, 1);
                                }
                                time = time2;
                                a = a2;
                            }
                            timelines.push(timeline);
                        }
                }
            }
        }
        for(let i = 0, n = input.readInt(true); i < n; i++){
            const boneIndex = input.readInt(true);
            for(let ii = 0, nn = input.readInt(true); ii < nn; ii++){
                const type = input.readByte();
                const frameCount = input.readInt(true);
                const bezierCount = input.readInt(true);
                switch(type){
                    case $64725297a8c20f8e$var$BONE_ROTATE:
                        timelines.push($64725297a8c20f8e$var$readTimeline1(input, new (0, $fd5e2eaf5f163d40$export$b7ecb8f68b3e130b)(frameCount, bezierCount, boneIndex), 1));
                        break;
                    case $64725297a8c20f8e$var$BONE_TRANSLATE:
                        timelines.push($64725297a8c20f8e$var$readTimeline2(input, new (0, $fd5e2eaf5f163d40$export$eb93bf27829ae703)(frameCount, bezierCount, boneIndex), scale));
                        break;
                    case $64725297a8c20f8e$var$BONE_TRANSLATEX:
                        timelines.push($64725297a8c20f8e$var$readTimeline1(input, new (0, $fd5e2eaf5f163d40$export$cf49491eb4394eca)(frameCount, bezierCount, boneIndex), scale));
                        break;
                    case $64725297a8c20f8e$var$BONE_TRANSLATEY:
                        timelines.push($64725297a8c20f8e$var$readTimeline1(input, new (0, $fd5e2eaf5f163d40$export$6540b7ba297d3e41)(frameCount, bezierCount, boneIndex), scale));
                        break;
                    case $64725297a8c20f8e$var$BONE_SCALE:
                        timelines.push($64725297a8c20f8e$var$readTimeline2(input, new (0, $fd5e2eaf5f163d40$export$be544e22f6ad7737)(frameCount, bezierCount, boneIndex), 1));
                        break;
                    case $64725297a8c20f8e$var$BONE_SCALEX:
                        timelines.push($64725297a8c20f8e$var$readTimeline1(input, new (0, $fd5e2eaf5f163d40$export$407a9cf4df59ebda)(frameCount, bezierCount, boneIndex), 1));
                        break;
                    case $64725297a8c20f8e$var$BONE_SCALEY:
                        timelines.push($64725297a8c20f8e$var$readTimeline1(input, new (0, $fd5e2eaf5f163d40$export$cc13ceba88ef3794)(frameCount, bezierCount, boneIndex), 1));
                        break;
                    case $64725297a8c20f8e$var$BONE_SHEAR:
                        timelines.push($64725297a8c20f8e$var$readTimeline2(input, new (0, $fd5e2eaf5f163d40$export$4da82436a1a0d773)(frameCount, bezierCount, boneIndex), 1));
                        break;
                    case $64725297a8c20f8e$var$BONE_SHEARX:
                        timelines.push($64725297a8c20f8e$var$readTimeline1(input, new (0, $fd5e2eaf5f163d40$export$2392b1c4c21acaf8)(frameCount, bezierCount, boneIndex), 1));
                        break;
                    case $64725297a8c20f8e$var$BONE_SHEARY:
                        timelines.push($64725297a8c20f8e$var$readTimeline1(input, new (0, $fd5e2eaf5f163d40$export$f65148e1d95352fd)(frameCount, bezierCount, boneIndex), 1));
                }
            }
        }
        for(let i = 0, n = input.readInt(true); i < n; i++){
            const index = input.readInt(true);
            const frameCount = input.readInt(true);
            const frameLast = frameCount - 1;
            const timeline = new (0, $fd5e2eaf5f163d40$export$73d125cd89dead44)(frameCount, input.readInt(true), index);
            let time = input.readFloat();
            let mix = input.readFloat();
            let softness = input.readFloat() * scale;
            for(let frame = 0, bezier = 0;; frame++){
                timeline.setFrame(frame, time, mix, softness, input.readByte(), input.readBoolean(), input.readBoolean());
                if (frame == frameLast) break;
                const time2 = input.readFloat();
                const mix2 = input.readFloat();
                const softness2 = input.readFloat() * scale;
                switch(input.readByte()){
                    case $64725297a8c20f8e$var$CURVE_STEPPED:
                        timeline.setStepped(frame);
                        break;
                    case $64725297a8c20f8e$var$CURVE_BEZIER:
                        $64725297a8c20f8e$var$setBezier(input, timeline, bezier++, frame, 0, time, time2, mix, mix2, 1);
                        $64725297a8c20f8e$var$setBezier(input, timeline, bezier++, frame, 1, time, time2, softness, softness2, scale);
                }
                time = time2;
                mix = mix2;
                softness = softness2;
            }
            timelines.push(timeline);
        }
        for(let i = 0, n = input.readInt(true); i < n; i++){
            const index = input.readInt(true);
            const frameCount = input.readInt(true);
            const frameLast = frameCount - 1;
            const timeline = new (0, $fd5e2eaf5f163d40$export$a7a393c2ad815ac7)(frameCount, input.readInt(true), index);
            let time = input.readFloat();
            let mixRotate = input.readFloat();
            let mixX = input.readFloat();
            let mixY = input.readFloat();
            let mixScaleX = input.readFloat();
            let mixScaleY = input.readFloat();
            let mixShearY = input.readFloat();
            for(let frame = 0, bezier = 0;; frame++){
                timeline.setFrame(frame, time, mixRotate, mixX, mixY, mixScaleX, mixScaleY, mixShearY);
                if (frame == frameLast) break;
                const time2 = input.readFloat();
                const mixRotate2 = input.readFloat();
                const mixX2 = input.readFloat();
                const mixY2 = input.readFloat();
                const mixScaleX2 = input.readFloat();
                const mixScaleY2 = input.readFloat();
                const mixShearY2 = input.readFloat();
                switch(input.readByte()){
                    case $64725297a8c20f8e$var$CURVE_STEPPED:
                        timeline.setStepped(frame);
                        break;
                    case $64725297a8c20f8e$var$CURVE_BEZIER:
                        $64725297a8c20f8e$var$setBezier(input, timeline, bezier++, frame, 0, time, time2, mixRotate, mixRotate2, 1);
                        $64725297a8c20f8e$var$setBezier(input, timeline, bezier++, frame, 1, time, time2, mixX, mixX2, 1);
                        $64725297a8c20f8e$var$setBezier(input, timeline, bezier++, frame, 2, time, time2, mixY, mixY2, 1);
                        $64725297a8c20f8e$var$setBezier(input, timeline, bezier++, frame, 3, time, time2, mixScaleX, mixScaleX2, 1);
                        $64725297a8c20f8e$var$setBezier(input, timeline, bezier++, frame, 4, time, time2, mixScaleY, mixScaleY2, 1);
                        $64725297a8c20f8e$var$setBezier(input, timeline, bezier++, frame, 5, time, time2, mixShearY, mixShearY2, 1);
                }
                time = time2;
                mixRotate = mixRotate2;
                mixX = mixX2;
                mixY = mixY2;
                mixScaleX = mixScaleX2;
                mixScaleY = mixScaleY2;
                mixShearY = mixShearY2;
            }
            timelines.push(timeline);
        }
        for(let i = 0, n = input.readInt(true); i < n; i++){
            const index = input.readInt(true);
            const data = skeletonData.pathConstraints[index];
            for(let ii = 0, nn = input.readInt(true); ii < nn; ii++)switch(input.readByte()){
                case $64725297a8c20f8e$var$PATH_POSITION:
                    timelines.push($64725297a8c20f8e$var$readTimeline1(input, new (0, $fd5e2eaf5f163d40$export$7ce7e67fd9cc52ed)(input.readInt(true), input.readInt(true), index), data.positionMode == (0, $2c8db927dc4fcff5$export$34d637c671e1e906).Fixed ? scale : 1));
                    break;
                case $64725297a8c20f8e$var$PATH_SPACING:
                    timelines.push($64725297a8c20f8e$var$readTimeline1(input, new (0, $fd5e2eaf5f163d40$export$17ee50c08a07e62b)(input.readInt(true), input.readInt(true), index), data.spacingMode == (0, $07612ba9b2d17d60$export$34ce760ad2b0be4b).Length || data.spacingMode == (0, $07612ba9b2d17d60$export$34ce760ad2b0be4b).Fixed ? scale : 1));
                    break;
                case $64725297a8c20f8e$var$PATH_MIX:
                    const timeline = new (0, $fd5e2eaf5f163d40$export$ea67b41755485038)(input.readInt(true), input.readInt(true), index);
                    let time = input.readFloat();
                    let mixRotate = input.readFloat();
                    let mixX = input.readFloat();
                    let mixY = input.readFloat();
                    for(let frame = 0, bezier = 0, frameLast = timeline.getFrameCount() - 1;; frame++){
                        timeline.setFrame(frame, time, mixRotate, mixX, mixY);
                        if (frame == frameLast) break;
                        const time2 = input.readFloat();
                        const mixRotate2 = input.readFloat();
                        const mixX2 = input.readFloat();
                        const mixY2 = input.readFloat();
                        switch(input.readByte()){
                            case $64725297a8c20f8e$var$CURVE_STEPPED:
                                timeline.setStepped(frame);
                                break;
                            case $64725297a8c20f8e$var$CURVE_BEZIER:
                                $64725297a8c20f8e$var$setBezier(input, timeline, bezier++, frame, 0, time, time2, mixRotate, mixRotate2, 1);
                                $64725297a8c20f8e$var$setBezier(input, timeline, bezier++, frame, 1, time, time2, mixX, mixX2, 1);
                                $64725297a8c20f8e$var$setBezier(input, timeline, bezier++, frame, 2, time, time2, mixY, mixY2, 1);
                        }
                        time = time2;
                        mixRotate = mixRotate2;
                        mixX = mixX2;
                        mixY = mixY2;
                    }
                    timelines.push(timeline);
            }
        }
        for(let i = 0, n = input.readInt(true); i < n; i++){
            const skin = skeletonData.skins[input.readInt(true)];
            for(let ii = 0, nn = input.readInt(true); ii < nn; ii++){
                const slotIndex = input.readInt(true);
                for(let iii = 0, nnn = input.readInt(true); iii < nnn; iii++){
                    const attachmentName = input.readStringRef();
                    if (!attachmentName) throw new Error("attachmentName must not be null.");
                    const attachment = skin.getAttachment(slotIndex, attachmentName);
                    const timelineType = this.readDeformTimelineType(input);
                    const frameCount = input.readInt(true);
                    const frameLast = frameCount - 1;
                    switch(timelineType){
                        case $64725297a8c20f8e$var$ATTACHMENT_DEFORM:
                            {
                                const vertexAttachment = attachment;
                                const weighted = vertexAttachment.bones;
                                const vertices = vertexAttachment.vertices;
                                const deformLength = weighted ? vertices.length / 3 * 2 : vertices.length;
                                const bezierCount = input.readInt(true);
                                const timeline = new (0, $fd5e2eaf5f163d40$export$6968d40e5689ad6b)(frameCount, bezierCount, slotIndex, vertexAttachment);
                                let time = input.readFloat();
                                for(let frame = 0, bezier = 0;; frame++){
                                    let deform;
                                    let end = input.readInt(true);
                                    if (end == 0) deform = weighted ? (0, $8804784813ffae81$export$d2ca453b913dcdea).newFloatArray(deformLength) : vertices;
                                    else {
                                        deform = (0, $8804784813ffae81$export$d2ca453b913dcdea).newFloatArray(deformLength);
                                        const start = input.readInt(true);
                                        end += start;
                                        if (scale == 1) for(let v = start; v < end; v++)deform[v] = input.readFloat();
                                        else for(let v = start; v < end; v++)deform[v] = input.readFloat() * scale;
                                        if (!weighted) for(let v = 0, vn = deform.length; v < vn; v++)deform[v] += vertices[v];
                                    }
                                    timeline.setFrame(frame, time, deform);
                                    if (frame == frameLast) break;
                                    const time2 = input.readFloat();
                                    switch(input.readByte()){
                                        case $64725297a8c20f8e$var$CURVE_STEPPED:
                                            timeline.setStepped(frame);
                                            break;
                                        case $64725297a8c20f8e$var$CURVE_BEZIER:
                                            $64725297a8c20f8e$var$setBezier(input, timeline, bezier++, frame, 0, time, time2, 0, 1, 1);
                                    }
                                    time = time2;
                                }
                                timelines.push(timeline);
                                break;
                            }
                        case $64725297a8c20f8e$var$ATTACHMENT_SEQUENCE:
                            {
                                const timeline = new (0, $fd5e2eaf5f163d40$export$2687f324e8496672)(frameCount, slotIndex, attachment);
                                for(let frame = 0; frame < frameCount; frame++){
                                    const time = input.readFloat();
                                    const modeAndIndex = input.readInt32();
                                    timeline.setFrame(frame, time, (0, $37628ed40604134f$export$3d518da8d966a9f5)[modeAndIndex & 15], modeAndIndex >> 4, input.readFloat());
                                }
                                timelines.push(timeline);
                                break;
                            }
                    }
                }
            }
        }
        const drawOrderCount = input.readInt(true);
        if (drawOrderCount > 0) {
            const timeline = new (0, $fd5e2eaf5f163d40$export$ece1f7c41d051e83)(drawOrderCount);
            const slotCount = skeletonData.slots.length;
            for(let i = 0; i < drawOrderCount; i++){
                const time = input.readFloat();
                const offsetCount = input.readInt(true);
                const drawOrder = (0, $8804784813ffae81$export$d2ca453b913dcdea).newArray(slotCount, 0);
                for(let ii = slotCount - 1; ii >= 0; ii--)drawOrder[ii] = -1;
                const unchanged = (0, $8804784813ffae81$export$d2ca453b913dcdea).newArray(slotCount - offsetCount, 0);
                let originalIndex = 0;
                let unchangedIndex = 0;
                for(let ii = 0; ii < offsetCount; ii++){
                    const slotIndex = input.readInt(true);
                    while(originalIndex != slotIndex)unchanged[unchangedIndex++] = originalIndex++;
                    drawOrder[originalIndex + input.readInt(true)] = originalIndex++;
                }
                while(originalIndex < slotCount)unchanged[unchangedIndex++] = originalIndex++;
                for(let ii = slotCount - 1; ii >= 0; ii--)if (drawOrder[ii] == -1) drawOrder[ii] = unchanged[--unchangedIndex];
                timeline.setFrame(i, time, drawOrder);
            }
            timelines.push(timeline);
        }
        const eventCount = input.readInt(true);
        if (eventCount > 0) {
            const timeline = new (0, $fd5e2eaf5f163d40$export$4f4bca996c586084)(eventCount);
            for(let i = 0; i < eventCount; i++){
                const time = input.readFloat();
                const eventData = skeletonData.events[input.readInt(true)];
                const event = new (0, $b69dd53da9706657$export$d61e24a684f9e51)(time, eventData);
                event.intValue = input.readInt(false);
                event.floatValue = input.readFloat();
                event.stringValue = input.readBoolean() ? input.readString() : eventData.stringValue;
                if (event.data.audioPath) {
                    event.volume = input.readFloat();
                    event.balance = input.readFloat();
                }
                timeline.setFrame(i, event);
            }
            timelines.push(timeline);
        }
        let duration = 0;
        for(let i = 0, n = timelines.length; i < n; i++)duration = Math.max(duration, timelines[i].getDuration());
        return new (0, $fd5e2eaf5f163d40$export$c35d437ae5945fcd)(name, timelines, duration);
    }
}
$64725297a8c20f8e$export$a7f7eaf4e9fce9ef.BlendModeValues = [
    (0, $0fa4b07f86297abd$export$f821c68fe9beaecf).NORMAL,
    (0, $0fa4b07f86297abd$export$f821c68fe9beaecf).ADD,
    (0, $0fa4b07f86297abd$export$f821c68fe9beaecf).MULTIPLY,
    (0, $0fa4b07f86297abd$export$f821c68fe9beaecf).SCREEN
];
class $64725297a8c20f8e$var$LinkedMesh {
    constructor(mesh, skin, slotIndex, parent, inheritDeform){
        this.mesh = mesh;
        this.skin = skin;
        this.slotIndex = slotIndex;
        this.parent = parent;
        this.inheritTimeline = inheritDeform;
    }
}
class $64725297a8c20f8e$var$Vertices {
    constructor(bones = null, vertices = null){
        this.bones = bones;
        this.vertices = vertices;
    }
}
function $64725297a8c20f8e$var$readTimeline1(input, timeline, scale) {
    let time = input.readFloat();
    let value = input.readFloat() * scale;
    for(let frame = 0, bezier = 0, frameLast = timeline.getFrameCount() - 1;; frame++){
        timeline.setFrame(frame, time, value);
        if (frame == frameLast) break;
        const time2 = input.readFloat();
        const value2 = input.readFloat() * scale;
        switch(input.readByte()){
            case $64725297a8c20f8e$var$CURVE_STEPPED:
                timeline.setStepped(frame);
                break;
            case $64725297a8c20f8e$var$CURVE_BEZIER:
                $64725297a8c20f8e$var$setBezier(input, timeline, bezier++, frame, 0, time, time2, value, value2, scale);
        }
        time = time2;
        value = value2;
    }
    return timeline;
}
function $64725297a8c20f8e$var$readTimeline2(input, timeline, scale) {
    let time = input.readFloat();
    let value1 = input.readFloat() * scale;
    let value2 = input.readFloat() * scale;
    for(let frame = 0, bezier = 0, frameLast = timeline.getFrameCount() - 1;; frame++){
        timeline.setFrame(frame, time, value1, value2);
        if (frame == frameLast) break;
        const time2 = input.readFloat();
        const nvalue1 = input.readFloat() * scale;
        const nvalue2 = input.readFloat() * scale;
        switch(input.readByte()){
            case $64725297a8c20f8e$var$CURVE_STEPPED:
                timeline.setStepped(frame);
                break;
            case $64725297a8c20f8e$var$CURVE_BEZIER:
                $64725297a8c20f8e$var$setBezier(input, timeline, bezier++, frame, 0, time, time2, value1, nvalue1, scale);
                $64725297a8c20f8e$var$setBezier(input, timeline, bezier++, frame, 1, time, time2, value2, nvalue2, scale);
        }
        time = time2;
        value1 = nvalue1;
        value2 = nvalue2;
    }
    return timeline;
}
function $64725297a8c20f8e$var$setBezier(input, timeline, bezier, frame, value, time1, time2, value1, value2, scale) {
    timeline.setBezier(bezier, frame, value, time1, value1, input.readFloat(), input.readFloat() * scale, input.readFloat(), input.readFloat() * scale, time2, value2);
}
const $64725297a8c20f8e$var$BONE_ROTATE = 0;
const $64725297a8c20f8e$var$BONE_TRANSLATE = 1;
const $64725297a8c20f8e$var$BONE_TRANSLATEX = 2;
const $64725297a8c20f8e$var$BONE_TRANSLATEY = 3;
const $64725297a8c20f8e$var$BONE_SCALE = 4;
const $64725297a8c20f8e$var$BONE_SCALEX = 5;
const $64725297a8c20f8e$var$BONE_SCALEY = 6;
const $64725297a8c20f8e$var$BONE_SHEAR = 7;
const $64725297a8c20f8e$var$BONE_SHEARX = 8;
const $64725297a8c20f8e$var$BONE_SHEARY = 9;
const $64725297a8c20f8e$var$SLOT_ATTACHMENT = 0;
const $64725297a8c20f8e$var$SLOT_RGBA = 1;
const $64725297a8c20f8e$var$SLOT_RGB = 2;
const $64725297a8c20f8e$var$SLOT_RGBA2 = 3;
const $64725297a8c20f8e$var$SLOT_RGB2 = 4;
const $64725297a8c20f8e$var$SLOT_ALPHA = 5;
const $64725297a8c20f8e$var$ATTACHMENT_DEFORM = 0;
const $64725297a8c20f8e$var$ATTACHMENT_SEQUENCE = 1;
const $64725297a8c20f8e$var$PATH_POSITION = 0;
const $64725297a8c20f8e$var$PATH_SPACING = 1;
const $64725297a8c20f8e$var$PATH_MIX = 2;
const $64725297a8c20f8e$var$CURVE_STEPPED = 1;
const $64725297a8c20f8e$var$CURVE_BEZIER = 2;



class $28af5678b986c54f$export$119f1746fc062f5e extends (0, $f207f4fe652f3622$export$a40a4b6b6d62719b) {
}
















class $3cdefcdf845023bf$export$8913b5e618c6d2f3 {
    constructor(attachmentLoader){
        /** Scales bone positions, image sizes, and translations as they are loaded. This allows different size images to be used at
     * runtime than were used in Spine.
     *
     * See [Scaling](http://esotericsoftware.com/spine-loading-skeleton-data#Scaling) in the Spine Runtimes Guide. */ this.scale = 1;
        this.linkedMeshes = new Array();
        this.attachmentLoader = attachmentLoader;
    }
    readSkeletonData(json) {
        const scale = this.scale;
        const skeletonData = new (0, $41c3b615da9f888b$export$e8f362f163550575)();
        const root = typeof json === "string" ? JSON.parse(json) : json;
        const skeletonMap = root.skeleton;
        if (skeletonMap) {
            skeletonData.hash = skeletonMap.hash;
            skeletonData.version = skeletonMap.spine;
            const verShort = skeletonData.version.substr(0, 3);
            if (verShort !== "4.0" && verShort !== "4.1") {
                const error = `Spine 4.1 loader cant load version ${skeletonMap.spine}. Please configure your pixi-spine bundle`;
                console.error(error);
            }
            skeletonData.x = skeletonMap.x;
            skeletonData.y = skeletonMap.y;
            skeletonData.width = skeletonMap.width;
            skeletonData.height = skeletonMap.height;
            skeletonData.fps = skeletonMap.fps;
            skeletonData.imagesPath = skeletonMap.images;
        }
        if (root.bones) for(let i = 0; i < root.bones.length; i++){
            const boneMap = root.bones[i];
            let parent = null;
            const parentName = $3cdefcdf845023bf$var$getValue(boneMap, "parent", null);
            if (parentName != null) {
                parent = skeletonData.findBone(parentName);
                if (parent == null) throw new Error(`Parent bone not found: ${parentName}`);
            }
            const data = new (0, $b873069de67ba47c$export$7d85d96cf093e12f)(skeletonData.bones.length, boneMap.name, parent);
            data.length = $3cdefcdf845023bf$var$getValue(boneMap, "length", 0) * scale;
            data.x = $3cdefcdf845023bf$var$getValue(boneMap, "x", 0) * scale;
            data.y = $3cdefcdf845023bf$var$getValue(boneMap, "y", 0) * scale;
            data.rotation = $3cdefcdf845023bf$var$getValue(boneMap, "rotation", 0);
            data.scaleX = $3cdefcdf845023bf$var$getValue(boneMap, "scaleX", 1);
            data.scaleY = $3cdefcdf845023bf$var$getValue(boneMap, "scaleY", 1);
            data.shearX = $3cdefcdf845023bf$var$getValue(boneMap, "shearX", 0);
            data.shearY = $3cdefcdf845023bf$var$getValue(boneMap, "shearY", 0);
            data.transformMode = (0, $8804784813ffae81$export$d2ca453b913dcdea).enumValue((0, $ccc5aebc60cbf024$export$4c408f82786a534d), $3cdefcdf845023bf$var$getValue(boneMap, "transform", "Normal"));
            data.skinRequired = $3cdefcdf845023bf$var$getValue(boneMap, "skin", false);
            const color = $3cdefcdf845023bf$var$getValue(boneMap, "color", null);
            if (color) data.color.setFromString(color);
            skeletonData.bones.push(data);
        }
        if (root.slots) for(let i = 0; i < root.slots.length; i++){
            const slotMap = root.slots[i];
            const boneData = skeletonData.findBone(slotMap.bone);
            if (!boneData) throw new Error(`Couldn't find bone ${slotMap.bone} for slot ${slotMap.name}`);
            const data = new (0, $3dc896cad7bb3460$export$a4cce1bf50208679)(skeletonData.slots.length, slotMap.name, boneData);
            const color = $3cdefcdf845023bf$var$getValue(slotMap, "color", null);
            if (color) data.color.setFromString(color);
            const dark = $3cdefcdf845023bf$var$getValue(slotMap, "dark", null);
            if (dark) data.darkColor = (0, $8804784813ffae81$export$892596cec99bc70e).fromString(dark);
            data.attachmentName = $3cdefcdf845023bf$var$getValue(slotMap, "attachment", null);
            data.blendMode = $3cdefcdf845023bf$export$8913b5e618c6d2f3.blendModeFromString($3cdefcdf845023bf$var$getValue(slotMap, "blend", "normal"));
            skeletonData.slots.push(data);
        }
        if (root.ik) for(let i = 0; i < root.ik.length; i++){
            const constraintMap = root.ik[i];
            const data = new (0, $439d8ab836629982$export$adcb08b651fc712e)(constraintMap.name);
            data.order = $3cdefcdf845023bf$var$getValue(constraintMap, "order", 0);
            data.skinRequired = $3cdefcdf845023bf$var$getValue(constraintMap, "skin", false);
            for(let ii = 0; ii < constraintMap.bones.length; ii++){
                const boneName = constraintMap.bones[ii];
                const bone = skeletonData.findBone(boneName);
                if (bone == null) throw new Error(`IK bone not found: ${boneName}`);
                data.bones.push(bone);
            }
            data.target = skeletonData.findBone(constraintMap.target);
            data.mix = $3cdefcdf845023bf$var$getValue(constraintMap, "mix", 1);
            data.softness = $3cdefcdf845023bf$var$getValue(constraintMap, "softness", 0) * scale;
            data.bendDirection = $3cdefcdf845023bf$var$getValue(constraintMap, "bendPositive", true) ? 1 : -1;
            data.compress = $3cdefcdf845023bf$var$getValue(constraintMap, "compress", false);
            data.stretch = $3cdefcdf845023bf$var$getValue(constraintMap, "stretch", false);
            data.uniform = $3cdefcdf845023bf$var$getValue(constraintMap, "uniform", false);
            skeletonData.ikConstraints.push(data);
        }
        if (root.transform) for(let i = 0; i < root.transform.length; i++){
            const constraintMap = root.transform[i];
            const data = new (0, $7c37517de6acc018$export$823fbc29771afdb5)(constraintMap.name);
            data.order = $3cdefcdf845023bf$var$getValue(constraintMap, "order", 0);
            data.skinRequired = $3cdefcdf845023bf$var$getValue(constraintMap, "skin", false);
            for(let ii = 0; ii < constraintMap.bones.length; ii++){
                const boneName = constraintMap.bones[ii];
                const bone = skeletonData.findBone(boneName);
                if (!bone) throw new Error(`Couldn't find bone ${boneName} for transform constraint ${constraintMap.name}.`);
                data.bones.push(bone);
            }
            const targetName = constraintMap.target;
            const target = skeletonData.findBone(targetName);
            if (!target) throw new Error(`Couldn't find target bone ${targetName} for transform constraint ${constraintMap.name}.`);
            data.target = target;
            data.local = $3cdefcdf845023bf$var$getValue(constraintMap, "local", false);
            data.relative = $3cdefcdf845023bf$var$getValue(constraintMap, "relative", false);
            data.offsetRotation = $3cdefcdf845023bf$var$getValue(constraintMap, "rotation", 0);
            data.offsetX = $3cdefcdf845023bf$var$getValue(constraintMap, "x", 0) * scale;
            data.offsetY = $3cdefcdf845023bf$var$getValue(constraintMap, "y", 0) * scale;
            data.offsetScaleX = $3cdefcdf845023bf$var$getValue(constraintMap, "scaleX", 0);
            data.offsetScaleY = $3cdefcdf845023bf$var$getValue(constraintMap, "scaleY", 0);
            data.offsetShearY = $3cdefcdf845023bf$var$getValue(constraintMap, "shearY", 0);
            data.mixRotate = $3cdefcdf845023bf$var$getValue(constraintMap, "mixRotate", 1);
            data.mixX = $3cdefcdf845023bf$var$getValue(constraintMap, "mixX", 1);
            data.mixY = $3cdefcdf845023bf$var$getValue(constraintMap, "mixY", data.mixX);
            data.mixScaleX = $3cdefcdf845023bf$var$getValue(constraintMap, "mixScaleX", 1);
            data.mixScaleY = $3cdefcdf845023bf$var$getValue(constraintMap, "mixScaleY", data.mixScaleX);
            data.mixShearY = $3cdefcdf845023bf$var$getValue(constraintMap, "mixShearY", 1);
            skeletonData.transformConstraints.push(data);
        }
        if (root.path) for(let i = 0; i < root.path.length; i++){
            const constraintMap = root.path[i];
            const data = new (0, $07612ba9b2d17d60$export$d2629ab80d5dd5ba)(constraintMap.name);
            data.order = $3cdefcdf845023bf$var$getValue(constraintMap, "order", 0);
            data.skinRequired = $3cdefcdf845023bf$var$getValue(constraintMap, "skin", false);
            for(let ii = 0; ii < constraintMap.bones.length; ii++){
                const boneName = constraintMap.bones[ii];
                const bone = skeletonData.findBone(boneName);
                if (!bone) throw new Error(`Couldn't find bone ${boneName} for path constraint ${constraintMap.name}.`);
                data.bones.push(bone);
            }
            const targetName = constraintMap.target;
            const target = skeletonData.findSlot(targetName);
            if (!target) throw new Error(`Couldn't find target slot ${targetName} for path constraint ${constraintMap.name}.`);
            data.target = target;
            data.positionMode = (0, $8804784813ffae81$export$d2ca453b913dcdea).enumValue((0, $2c8db927dc4fcff5$export$34d637c671e1e906), $3cdefcdf845023bf$var$getValue(constraintMap, "positionMode", "Percent"));
            data.spacingMode = (0, $8804784813ffae81$export$d2ca453b913dcdea).enumValue((0, $07612ba9b2d17d60$export$34ce760ad2b0be4b), $3cdefcdf845023bf$var$getValue(constraintMap, "spacingMode", "Length"));
            data.rotateMode = (0, $8804784813ffae81$export$d2ca453b913dcdea).enumValue((0, $2c8db927dc4fcff5$export$a2a23846581ac82c), $3cdefcdf845023bf$var$getValue(constraintMap, "rotateMode", "Tangent"));
            data.offsetRotation = $3cdefcdf845023bf$var$getValue(constraintMap, "rotation", 0);
            data.position = $3cdefcdf845023bf$var$getValue(constraintMap, "position", 0);
            if (data.positionMode == (0, $2c8db927dc4fcff5$export$34d637c671e1e906).Fixed) data.position *= scale;
            data.spacing = $3cdefcdf845023bf$var$getValue(constraintMap, "spacing", 0);
            if (data.spacingMode == (0, $07612ba9b2d17d60$export$34ce760ad2b0be4b).Length || data.spacingMode == (0, $07612ba9b2d17d60$export$34ce760ad2b0be4b).Fixed) data.spacing *= scale;
            data.mixRotate = $3cdefcdf845023bf$var$getValue(constraintMap, "mixRotate", 1);
            data.mixX = $3cdefcdf845023bf$var$getValue(constraintMap, "mixX", 1);
            data.mixY = $3cdefcdf845023bf$var$getValue(constraintMap, "mixY", data.mixX);
            skeletonData.pathConstraints.push(data);
        }
        if (root.skins) for(let i = 0; i < root.skins.length; i++){
            const skinMap = root.skins[i];
            const skin = new (0, $e029b89e8e37c790$export$b8e0f93a76772233)(skinMap.name);
            if (skinMap.bones) for(let ii = 0; ii < skinMap.bones.length; ii++){
                const boneName = skinMap.bones[ii];
                const bone = skeletonData.findBone(boneName);
                if (!bone) throw new Error(`Couldn't find bone ${boneName} for skin ${skinMap.name}.`);
                skin.bones.push(bone);
            }
            if (skinMap.ik) for(let ii = 0; ii < skinMap.ik.length; ii++){
                const constraintName = skinMap.ik[ii];
                const constraint = skeletonData.findIkConstraint(constraintName);
                if (!constraint) throw new Error(`Couldn't find IK constraint ${constraintName} for skin ${skinMap.name}.`);
                skin.constraints.push(constraint);
            }
            if (skinMap.transform) for(let ii = 0; ii < skinMap.transform.length; ii++){
                const constraintName = skinMap.transform[ii];
                const constraint = skeletonData.findTransformConstraint(constraintName);
                if (!constraint) throw new Error(`Couldn't find transform constraint ${constraintName} for skin ${skinMap.name}.`);
                skin.constraints.push(constraint);
            }
            if (skinMap.path) for(let ii = 0; ii < skinMap.path.length; ii++){
                const constraintName = skinMap.path[ii];
                const constraint = skeletonData.findPathConstraint(constraintName);
                if (!constraint) throw new Error(`Couldn't find path constraint ${constraintName} for skin ${skinMap.name}.`);
                skin.constraints.push(constraint);
            }
            for(const slotName in skinMap.attachments){
                const slot = skeletonData.findSlot(slotName);
                if (!slot) throw new Error(`Couldn't find slot ${slotName} for skin ${skinMap.name}.`);
                const slotMap = skinMap.attachments[slotName];
                for(const entryName in slotMap){
                    const attachment = this.readAttachment(slotMap[entryName], skin, slot.index, entryName, skeletonData);
                    if (attachment) skin.setAttachment(slot.index, entryName, attachment);
                }
            }
            skeletonData.skins.push(skin);
            if (skin.name == "default") skeletonData.defaultSkin = skin;
        }
        for(let i = 0, n = this.linkedMeshes.length; i < n; i++){
            const linkedMesh = this.linkedMeshes[i];
            const skin = !linkedMesh.skin ? skeletonData.defaultSkin : skeletonData.findSkin(linkedMesh.skin);
            if (!skin) throw new Error(`Skin not found: ${linkedMesh.skin}`);
            const parent = skin.getAttachment(linkedMesh.slotIndex, linkedMesh.parent);
            if (!parent) throw new Error(`Parent mesh not found: ${linkedMesh.parent}`);
            linkedMesh.mesh.timelineAttachment = linkedMesh.inheritTimeline ? parent : linkedMesh.mesh;
            linkedMesh.mesh.setParentMesh(parent);
        }
        this.linkedMeshes.length = 0;
        if (root.events) for(const eventName in root.events){
            const eventMap = root.events[eventName];
            const data = new (0, $57711e45b8cfda24$export$a5cf049e34c3d11e)(eventName);
            data.intValue = $3cdefcdf845023bf$var$getValue(eventMap, "int", 0);
            data.floatValue = $3cdefcdf845023bf$var$getValue(eventMap, "float", 0);
            data.stringValue = $3cdefcdf845023bf$var$getValue(eventMap, "string", "");
            data.audioPath = $3cdefcdf845023bf$var$getValue(eventMap, "audio", null);
            if (data.audioPath) {
                data.volume = $3cdefcdf845023bf$var$getValue(eventMap, "volume", 1);
                data.balance = $3cdefcdf845023bf$var$getValue(eventMap, "balance", 0);
            }
            skeletonData.events.push(data);
        }
        if (root.animations) for(const animationName in root.animations){
            const animationMap = root.animations[animationName];
            this.readAnimation(animationMap, animationName, skeletonData);
        }
        return skeletonData;
    }
    readAttachment(map, skin, slotIndex, name, skeletonData) {
        const scale = this.scale;
        name = $3cdefcdf845023bf$var$getValue(map, "name", name);
        switch($3cdefcdf845023bf$var$getValue(map, "type", "region")){
            case "region":
                {
                    const path = $3cdefcdf845023bf$var$getValue(map, "path", name);
                    const sequence = this.readSequence($3cdefcdf845023bf$var$getValue(map, "sequence", null));
                    const region = this.attachmentLoader.newRegionAttachment(skin, name, path, sequence);
                    if (!region) return null;
                    region.path = path;
                    region.x = $3cdefcdf845023bf$var$getValue(map, "x", 0) * scale;
                    region.y = $3cdefcdf845023bf$var$getValue(map, "y", 0) * scale;
                    region.scaleX = $3cdefcdf845023bf$var$getValue(map, "scaleX", 1);
                    region.scaleY = $3cdefcdf845023bf$var$getValue(map, "scaleY", 1);
                    region.rotation = $3cdefcdf845023bf$var$getValue(map, "rotation", 0);
                    region.width = map.width * scale;
                    region.height = map.height * scale;
                    region.sequence = sequence;
                    const color = $3cdefcdf845023bf$var$getValue(map, "color", null);
                    if (color) region.color.setFromString(color);
                    return region;
                }
            case "boundingbox":
                {
                    const box = this.attachmentLoader.newBoundingBoxAttachment(skin, name);
                    if (!box) return null;
                    this.readVertices(map, box, map.vertexCount << 1);
                    const color = $3cdefcdf845023bf$var$getValue(map, "color", null);
                    if (color) box.color.setFromString(color);
                    return box;
                }
            case "mesh":
            case "linkedmesh":
                {
                    const path = $3cdefcdf845023bf$var$getValue(map, "path", name);
                    const sequence = this.readSequence($3cdefcdf845023bf$var$getValue(map, "sequence", null));
                    const mesh = this.attachmentLoader.newMeshAttachment(skin, name, path, sequence);
                    if (!mesh) return null;
                    mesh.path = path;
                    const color = $3cdefcdf845023bf$var$getValue(map, "color", null);
                    if (color) mesh.color.setFromString(color);
                    mesh.width = $3cdefcdf845023bf$var$getValue(map, "width", 0) * scale;
                    mesh.height = $3cdefcdf845023bf$var$getValue(map, "height", 0) * scale;
                    mesh.sequence = sequence;
                    const parent = $3cdefcdf845023bf$var$getValue(map, "parent", null);
                    if (parent) {
                        this.linkedMeshes.push(new $3cdefcdf845023bf$var$LinkedMesh(mesh, $3cdefcdf845023bf$var$getValue(map, "skin", null), slotIndex, parent, $3cdefcdf845023bf$var$getValue(map, "timelines", true)));
                        return mesh;
                    }
                    const uvs = map.uvs;
                    this.readVertices(map, mesh, uvs.length);
                    mesh.triangles = map.triangles;
                    mesh.regionUVs = new Float32Array(uvs);
                    mesh.edges = $3cdefcdf845023bf$var$getValue(map, "edges", null);
                    mesh.hullLength = $3cdefcdf845023bf$var$getValue(map, "hull", 0) * 2;
                    return mesh;
                }
            case "path":
                {
                    const path = this.attachmentLoader.newPathAttachment(skin, name);
                    if (!path) return null;
                    path.closed = $3cdefcdf845023bf$var$getValue(map, "closed", false);
                    path.constantSpeed = $3cdefcdf845023bf$var$getValue(map, "constantSpeed", true);
                    const vertexCount = map.vertexCount;
                    this.readVertices(map, path, vertexCount << 1);
                    const lengths = (0, $8804784813ffae81$export$d2ca453b913dcdea).newArray(vertexCount / 3, 0);
                    for(let i = 0; i < map.lengths.length; i++)lengths[i] = map.lengths[i] * scale;
                    path.lengths = lengths;
                    const color = $3cdefcdf845023bf$var$getValue(map, "color", null);
                    if (color) path.color.setFromString(color);
                    return path;
                }
            case "point":
                {
                    const point = this.attachmentLoader.newPointAttachment(skin, name);
                    if (!point) return null;
                    point.x = $3cdefcdf845023bf$var$getValue(map, "x", 0) * scale;
                    point.y = $3cdefcdf845023bf$var$getValue(map, "y", 0) * scale;
                    point.rotation = $3cdefcdf845023bf$var$getValue(map, "rotation", 0);
                    const color = $3cdefcdf845023bf$var$getValue(map, "color", null);
                    if (color) point.color.setFromString(color);
                    return point;
                }
            case "clipping":
                {
                    const clip = this.attachmentLoader.newClippingAttachment(skin, name);
                    if (!clip) return null;
                    const end = $3cdefcdf845023bf$var$getValue(map, "end", null);
                    if (end != null) {
                        const slot = skeletonData.findSlot(end);
                        if (slot == null) throw new Error(`Clipping end slot not found: ${end}`);
                        clip.endSlot = slot;
                    }
                    const vertexCount = map.vertexCount;
                    this.readVertices(map, clip, vertexCount << 1);
                    const color = $3cdefcdf845023bf$var$getValue(map, "color", null);
                    if (color) clip.color.setFromString(color);
                    return clip;
                }
        }
        return null;
    }
    readSequence(map) {
        if (map == null) return null;
        const sequence = new (0, $37628ed40604134f$export$edde1bcb1b2b310e)($3cdefcdf845023bf$var$getValue(map, "count", 0));
        sequence.start = $3cdefcdf845023bf$var$getValue(map, "start", 1);
        sequence.digits = $3cdefcdf845023bf$var$getValue(map, "digits", 0);
        sequence.setupIndex = $3cdefcdf845023bf$var$getValue(map, "setup", 0);
        return sequence;
    }
    readVertices(map, attachment, verticesLength) {
        const scale = this.scale;
        attachment.worldVerticesLength = verticesLength;
        const vertices = map.vertices;
        if (verticesLength == vertices.length) {
            const scaledVertices = (0, $8804784813ffae81$export$d2ca453b913dcdea).toFloatArray(vertices);
            if (scale != 1) for(let i = 0, n = vertices.length; i < n; i++)scaledVertices[i] *= scale;
            attachment.vertices = scaledVertices;
            return;
        }
        const weights = new Array();
        const bones = new Array();
        for(let i = 0, n = vertices.length; i < n;){
            const boneCount = vertices[i++];
            bones.push(boneCount);
            for(let nn = i + boneCount * 4; i < nn; i += 4){
                bones.push(vertices[i]);
                weights.push(vertices[i + 1] * scale);
                weights.push(vertices[i + 2] * scale);
                weights.push(vertices[i + 3]);
            }
        }
        attachment.bones = bones;
        attachment.vertices = (0, $8804784813ffae81$export$d2ca453b913dcdea).toFloatArray(weights);
    }
    readAnimation(map, name, skeletonData) {
        const scale = this.scale;
        const timelines = new Array();
        if (map.slots) for(const slotName in map.slots){
            const slotMap = map.slots[slotName];
            const slot = skeletonData.findSlot(slotName);
            if (!slot) throw new Error(`Slot not found: ${slotName}`);
            const slotIndex = slot.index;
            for(const timelineName in slotMap){
                const timelineMap = slotMap[timelineName];
                if (!timelineMap) continue;
                const frames = timelineMap.length;
                if (timelineName == "attachment") {
                    const timeline = new (0, $fd5e2eaf5f163d40$export$7f2bfc5bd27cb43d)(frames, slotIndex);
                    for(let frame = 0; frame < frames; frame++){
                        const keyMap = timelineMap[frame];
                        timeline.setFrame(frame, $3cdefcdf845023bf$var$getValue(keyMap, "time", 0), $3cdefcdf845023bf$var$getValue(keyMap, "name", null));
                    }
                    timelines.push(timeline);
                } else if (timelineName == "rgba") {
                    const timeline = new (0, $fd5e2eaf5f163d40$export$84cf3a3e225bcbdc)(frames, frames << 2, slotIndex);
                    let keyMap = timelineMap[0];
                    let time = $3cdefcdf845023bf$var$getValue(keyMap, "time", 0);
                    let color = (0, $8804784813ffae81$export$892596cec99bc70e).fromString(keyMap.color);
                    for(let frame = 0, bezier = 0;; frame++){
                        timeline.setFrame(frame, time, color.r, color.g, color.b, color.a);
                        const nextMap = timelineMap[frame + 1];
                        if (!nextMap) {
                            timeline.shrink(bezier);
                            break;
                        }
                        const time2 = $3cdefcdf845023bf$var$getValue(nextMap, "time", 0);
                        const newColor = (0, $8804784813ffae81$export$892596cec99bc70e).fromString(nextMap.color);
                        const curve = keyMap.curve;
                        if (curve) {
                            bezier = $3cdefcdf845023bf$var$readCurve(curve, timeline, bezier, frame, 0, time, time2, color.r, newColor.r, 1);
                            bezier = $3cdefcdf845023bf$var$readCurve(curve, timeline, bezier, frame, 1, time, time2, color.g, newColor.g, 1);
                            bezier = $3cdefcdf845023bf$var$readCurve(curve, timeline, bezier, frame, 2, time, time2, color.b, newColor.b, 1);
                            bezier = $3cdefcdf845023bf$var$readCurve(curve, timeline, bezier, frame, 3, time, time2, color.a, newColor.a, 1);
                        }
                        time = time2;
                        color = newColor;
                        keyMap = nextMap;
                    }
                    timelines.push(timeline);
                } else if (timelineName == "rgb") {
                    const timeline = new (0, $fd5e2eaf5f163d40$export$e179fb669ddccfa9)(frames, frames * 3, slotIndex);
                    let keyMap = timelineMap[0];
                    let time = $3cdefcdf845023bf$var$getValue(keyMap, "time", 0);
                    let color = (0, $8804784813ffae81$export$892596cec99bc70e).fromString(keyMap.color);
                    for(let frame = 0, bezier = 0;; frame++){
                        timeline.setFrame(frame, time, color.r, color.g, color.b);
                        const nextMap = timelineMap[frame + 1];
                        if (!nextMap) {
                            timeline.shrink(bezier);
                            break;
                        }
                        const time2 = $3cdefcdf845023bf$var$getValue(nextMap, "time", 0);
                        const newColor = (0, $8804784813ffae81$export$892596cec99bc70e).fromString(nextMap.color);
                        const curve = keyMap.curve;
                        if (curve) {
                            bezier = $3cdefcdf845023bf$var$readCurve(curve, timeline, bezier, frame, 0, time, time2, color.r, newColor.r, 1);
                            bezier = $3cdefcdf845023bf$var$readCurve(curve, timeline, bezier, frame, 1, time, time2, color.g, newColor.g, 1);
                            bezier = $3cdefcdf845023bf$var$readCurve(curve, timeline, bezier, frame, 2, time, time2, color.b, newColor.b, 1);
                        }
                        time = time2;
                        color = newColor;
                        keyMap = nextMap;
                    }
                    timelines.push(timeline);
                } else if (timelineName == "alpha") timelines.push($3cdefcdf845023bf$var$readTimeline1(timelineMap, new (0, $fd5e2eaf5f163d40$export$2211be7c5ccde97b)(frames, frames, slotIndex), 0, 1));
                else if (timelineName == "rgba2") {
                    const timeline = new (0, $fd5e2eaf5f163d40$export$6fc6620d97c53689)(frames, frames * 7, slotIndex);
                    let keyMap = timelineMap[0];
                    let time = $3cdefcdf845023bf$var$getValue(keyMap, "time", 0);
                    let color = (0, $8804784813ffae81$export$892596cec99bc70e).fromString(keyMap.light);
                    let color2 = (0, $8804784813ffae81$export$892596cec99bc70e).fromString(keyMap.dark);
                    for(let frame = 0, bezier = 0;; frame++){
                        timeline.setFrame(frame, time, color.r, color.g, color.b, color.a, color2.r, color2.g, color2.b);
                        const nextMap = timelineMap[frame + 1];
                        if (!nextMap) {
                            timeline.shrink(bezier);
                            break;
                        }
                        const time2 = $3cdefcdf845023bf$var$getValue(nextMap, "time", 0);
                        const newColor = (0, $8804784813ffae81$export$892596cec99bc70e).fromString(nextMap.light);
                        const newColor2 = (0, $8804784813ffae81$export$892596cec99bc70e).fromString(nextMap.dark);
                        const curve = keyMap.curve;
                        if (curve) {
                            bezier = $3cdefcdf845023bf$var$readCurve(curve, timeline, bezier, frame, 0, time, time2, color.r, newColor.r, 1);
                            bezier = $3cdefcdf845023bf$var$readCurve(curve, timeline, bezier, frame, 1, time, time2, color.g, newColor.g, 1);
                            bezier = $3cdefcdf845023bf$var$readCurve(curve, timeline, bezier, frame, 2, time, time2, color.b, newColor.b, 1);
                            bezier = $3cdefcdf845023bf$var$readCurve(curve, timeline, bezier, frame, 3, time, time2, color.a, newColor.a, 1);
                            bezier = $3cdefcdf845023bf$var$readCurve(curve, timeline, bezier, frame, 4, time, time2, color2.r, newColor2.r, 1);
                            bezier = $3cdefcdf845023bf$var$readCurve(curve, timeline, bezier, frame, 5, time, time2, color2.g, newColor2.g, 1);
                            bezier = $3cdefcdf845023bf$var$readCurve(curve, timeline, bezier, frame, 6, time, time2, color2.b, newColor2.b, 1);
                        }
                        time = time2;
                        color = newColor;
                        color2 = newColor2;
                        keyMap = nextMap;
                    }
                    timelines.push(timeline);
                } else if (timelineName == "rgb2") {
                    const timeline = new (0, $fd5e2eaf5f163d40$export$a12960afd309a230)(frames, frames * 6, slotIndex);
                    let keyMap = timelineMap[0];
                    let time = $3cdefcdf845023bf$var$getValue(keyMap, "time", 0);
                    let color = (0, $8804784813ffae81$export$892596cec99bc70e).fromString(keyMap.light);
                    let color2 = (0, $8804784813ffae81$export$892596cec99bc70e).fromString(keyMap.dark);
                    for(let frame = 0, bezier = 0;; frame++){
                        timeline.setFrame(frame, time, color.r, color.g, color.b, color2.r, color2.g, color2.b);
                        const nextMap = timelineMap[frame + 1];
                        if (!nextMap) {
                            timeline.shrink(bezier);
                            break;
                        }
                        const time2 = $3cdefcdf845023bf$var$getValue(nextMap, "time", 0);
                        const newColor = (0, $8804784813ffae81$export$892596cec99bc70e).fromString(nextMap.light);
                        const newColor2 = (0, $8804784813ffae81$export$892596cec99bc70e).fromString(nextMap.dark);
                        const curve = keyMap.curve;
                        if (curve) {
                            bezier = $3cdefcdf845023bf$var$readCurve(curve, timeline, bezier, frame, 0, time, time2, color.r, newColor.r, 1);
                            bezier = $3cdefcdf845023bf$var$readCurve(curve, timeline, bezier, frame, 1, time, time2, color.g, newColor.g, 1);
                            bezier = $3cdefcdf845023bf$var$readCurve(curve, timeline, bezier, frame, 2, time, time2, color.b, newColor.b, 1);
                            bezier = $3cdefcdf845023bf$var$readCurve(curve, timeline, bezier, frame, 3, time, time2, color2.r, newColor2.r, 1);
                            bezier = $3cdefcdf845023bf$var$readCurve(curve, timeline, bezier, frame, 4, time, time2, color2.g, newColor2.g, 1);
                            bezier = $3cdefcdf845023bf$var$readCurve(curve, timeline, bezier, frame, 5, time, time2, color2.b, newColor2.b, 1);
                        }
                        time = time2;
                        color = newColor;
                        color2 = newColor2;
                        keyMap = nextMap;
                    }
                    timelines.push(timeline);
                }
            }
        }
        if (map.bones) for(const boneName in map.bones){
            const boneMap = map.bones[boneName];
            const bone = skeletonData.findBone(boneName);
            if (!bone) throw new Error(`Bone not found: ${boneName}`);
            const boneIndex = bone.index;
            for(const timelineName in boneMap){
                const timelineMap = boneMap[timelineName];
                const frames = timelineMap.length;
                if (frames == 0) continue;
                if (timelineName === "rotate") timelines.push($3cdefcdf845023bf$var$readTimeline1(timelineMap, new (0, $fd5e2eaf5f163d40$export$b7ecb8f68b3e130b)(frames, frames, boneIndex), 0, 1));
                else if (timelineName === "translate") {
                    const timeline = new (0, $fd5e2eaf5f163d40$export$eb93bf27829ae703)(frames, frames << 1, boneIndex);
                    timelines.push($3cdefcdf845023bf$var$readTimeline2(timelineMap, timeline, "x", "y", 0, scale));
                } else if (timelineName === "translatex") {
                    const timeline = new (0, $fd5e2eaf5f163d40$export$cf49491eb4394eca)(frames, frames, boneIndex);
                    timelines.push($3cdefcdf845023bf$var$readTimeline1(timelineMap, timeline, 0, scale));
                } else if (timelineName === "translatey") {
                    const timeline = new (0, $fd5e2eaf5f163d40$export$6540b7ba297d3e41)(frames, frames, boneIndex);
                    timelines.push($3cdefcdf845023bf$var$readTimeline1(timelineMap, timeline, 0, scale));
                } else if (timelineName === "scale") {
                    const timeline = new (0, $fd5e2eaf5f163d40$export$be544e22f6ad7737)(frames, frames << 1, boneIndex);
                    timelines.push($3cdefcdf845023bf$var$readTimeline2(timelineMap, timeline, "x", "y", 1, 1));
                } else if (timelineName === "scalex") {
                    const timeline = new (0, $fd5e2eaf5f163d40$export$407a9cf4df59ebda)(frames, frames, boneIndex);
                    timelines.push($3cdefcdf845023bf$var$readTimeline1(timelineMap, timeline, 1, 1));
                } else if (timelineName === "scaley") {
                    const timeline = new (0, $fd5e2eaf5f163d40$export$cc13ceba88ef3794)(frames, frames, boneIndex);
                    timelines.push($3cdefcdf845023bf$var$readTimeline1(timelineMap, timeline, 1, 1));
                } else if (timelineName === "shear") {
                    const timeline = new (0, $fd5e2eaf5f163d40$export$4da82436a1a0d773)(frames, frames << 1, boneIndex);
                    timelines.push($3cdefcdf845023bf$var$readTimeline2(timelineMap, timeline, "x", "y", 0, 1));
                } else if (timelineName === "shearx") {
                    const timeline = new (0, $fd5e2eaf5f163d40$export$2392b1c4c21acaf8)(frames, frames, boneIndex);
                    timelines.push($3cdefcdf845023bf$var$readTimeline1(timelineMap, timeline, 0, 1));
                } else if (timelineName === "sheary") {
                    const timeline = new (0, $fd5e2eaf5f163d40$export$f65148e1d95352fd)(frames, frames, boneIndex);
                    timelines.push($3cdefcdf845023bf$var$readTimeline1(timelineMap, timeline, 0, 1));
                }
            }
        }
        if (map.ik) for(const constraintName in map.ik){
            const constraintMap = map.ik[constraintName];
            let keyMap = constraintMap[0];
            if (!keyMap) continue;
            const constraint = skeletonData.findIkConstraint(constraintName);
            if (!constraint) throw new Error(`IK Constraint not found: ${constraintName}`);
            const constraintIndex = skeletonData.ikConstraints.indexOf(constraint);
            const timeline = new (0, $fd5e2eaf5f163d40$export$73d125cd89dead44)(constraintMap.length, constraintMap.length << 1, constraintIndex);
            let time = $3cdefcdf845023bf$var$getValue(keyMap, "time", 0);
            let mix = $3cdefcdf845023bf$var$getValue(keyMap, "mix", 1);
            let softness = $3cdefcdf845023bf$var$getValue(keyMap, "softness", 0) * scale;
            for(let frame = 0, bezier = 0;; frame++){
                timeline.setFrame(frame, time, mix, softness, $3cdefcdf845023bf$var$getValue(keyMap, "bendPositive", true) ? 1 : -1, $3cdefcdf845023bf$var$getValue(keyMap, "compress", false), $3cdefcdf845023bf$var$getValue(keyMap, "stretch", false));
                const nextMap = constraintMap[frame + 1];
                if (!nextMap) {
                    timeline.shrink(bezier);
                    break;
                }
                const time2 = $3cdefcdf845023bf$var$getValue(nextMap, "time", 0);
                const mix2 = $3cdefcdf845023bf$var$getValue(nextMap, "mix", 1);
                const softness2 = $3cdefcdf845023bf$var$getValue(nextMap, "softness", 0) * scale;
                const curve = keyMap.curve;
                if (curve) {
                    bezier = $3cdefcdf845023bf$var$readCurve(curve, timeline, bezier, frame, 0, time, time2, mix, mix2, 1);
                    bezier = $3cdefcdf845023bf$var$readCurve(curve, timeline, bezier, frame, 1, time, time2, softness, softness2, scale);
                }
                time = time2;
                mix = mix2;
                softness = softness2;
                keyMap = nextMap;
            }
            timelines.push(timeline);
        }
        if (map.transform) for(const constraintName in map.transform){
            const timelineMap = map.transform[constraintName];
            let keyMap = timelineMap[0];
            if (!keyMap) continue;
            const constraint = skeletonData.findTransformConstraint(constraintName);
            if (!constraint) throw new Error(`Transform constraint not found: ${constraintName}`);
            const constraintIndex = skeletonData.transformConstraints.indexOf(constraint);
            const timeline = new (0, $fd5e2eaf5f163d40$export$a7a393c2ad815ac7)(timelineMap.length, timelineMap.length * 6, constraintIndex);
            let time = $3cdefcdf845023bf$var$getValue(keyMap, "time", 0);
            let mixRotate = $3cdefcdf845023bf$var$getValue(keyMap, "mixRotate", 1);
            let mixX = $3cdefcdf845023bf$var$getValue(keyMap, "mixX", 1);
            let mixY = $3cdefcdf845023bf$var$getValue(keyMap, "mixY", mixX);
            let mixScaleX = $3cdefcdf845023bf$var$getValue(keyMap, "mixScaleX", 1);
            let mixScaleY = $3cdefcdf845023bf$var$getValue(keyMap, "mixScaleY", mixScaleX);
            const mixShearY = $3cdefcdf845023bf$var$getValue(keyMap, "mixShearY", 1);
            for(let frame = 0, bezier = 0;; frame++){
                timeline.setFrame(frame, time, mixRotate, mixX, mixY, mixScaleX, mixScaleY, mixShearY);
                const nextMap = timelineMap[frame + 1];
                if (!nextMap) {
                    timeline.shrink(bezier);
                    break;
                }
                const time2 = $3cdefcdf845023bf$var$getValue(nextMap, "time", 0);
                const mixRotate2 = $3cdefcdf845023bf$var$getValue(nextMap, "mixRotate", 1);
                const mixX2 = $3cdefcdf845023bf$var$getValue(nextMap, "mixX", 1);
                const mixY2 = $3cdefcdf845023bf$var$getValue(nextMap, "mixY", mixX2);
                const mixScaleX2 = $3cdefcdf845023bf$var$getValue(nextMap, "mixScaleX", 1);
                const mixScaleY2 = $3cdefcdf845023bf$var$getValue(nextMap, "mixScaleY", mixScaleX2);
                const mixShearY2 = $3cdefcdf845023bf$var$getValue(nextMap, "mixShearY", 1);
                const curve = keyMap.curve;
                if (curve) {
                    bezier = $3cdefcdf845023bf$var$readCurve(curve, timeline, bezier, frame, 0, time, time2, mixRotate, mixRotate2, 1);
                    bezier = $3cdefcdf845023bf$var$readCurve(curve, timeline, bezier, frame, 1, time, time2, mixX, mixX2, 1);
                    bezier = $3cdefcdf845023bf$var$readCurve(curve, timeline, bezier, frame, 2, time, time2, mixY, mixY2, 1);
                    bezier = $3cdefcdf845023bf$var$readCurve(curve, timeline, bezier, frame, 3, time, time2, mixScaleX, mixScaleX2, 1);
                    bezier = $3cdefcdf845023bf$var$readCurve(curve, timeline, bezier, frame, 4, time, time2, mixScaleY, mixScaleY2, 1);
                    bezier = $3cdefcdf845023bf$var$readCurve(curve, timeline, bezier, frame, 5, time, time2, mixShearY, mixShearY2, 1);
                }
                time = time2;
                mixRotate = mixRotate2;
                mixX = mixX2;
                mixY = mixY2;
                mixScaleX = mixScaleX2;
                mixScaleY = mixScaleY2;
                mixScaleX = mixScaleX2;
                keyMap = nextMap;
            }
            timelines.push(timeline);
        }
        if (map.path) for(const constraintName in map.path){
            const constraintMap = map.path[constraintName];
            const constraint = skeletonData.findPathConstraint(constraintName);
            if (!constraint) throw new Error(`Path constraint not found: ${constraintName}`);
            const constraintIndex = skeletonData.pathConstraints.indexOf(constraint);
            for(const timelineName in constraintMap){
                const timelineMap = constraintMap[timelineName];
                let keyMap = timelineMap[0];
                if (!keyMap) continue;
                const frames = timelineMap.length;
                if (timelineName === "position") {
                    const timeline = new (0, $fd5e2eaf5f163d40$export$7ce7e67fd9cc52ed)(frames, frames, constraintIndex);
                    timelines.push($3cdefcdf845023bf$var$readTimeline1(timelineMap, timeline, 0, constraint.positionMode == (0, $2c8db927dc4fcff5$export$34d637c671e1e906).Fixed ? scale : 1));
                } else if (timelineName === "spacing") {
                    const timeline = new (0, $fd5e2eaf5f163d40$export$17ee50c08a07e62b)(frames, frames, constraintIndex);
                    timelines.push($3cdefcdf845023bf$var$readTimeline1(timelineMap, timeline, 0, constraint.spacingMode == (0, $07612ba9b2d17d60$export$34ce760ad2b0be4b).Length || constraint.spacingMode == (0, $07612ba9b2d17d60$export$34ce760ad2b0be4b).Fixed ? scale : 1));
                } else if (timelineName === "mix") {
                    const timeline = new (0, $fd5e2eaf5f163d40$export$ea67b41755485038)(frames, frames * 3, constraintIndex);
                    let time = $3cdefcdf845023bf$var$getValue(keyMap, "time", 0);
                    let mixRotate = $3cdefcdf845023bf$var$getValue(keyMap, "mixRotate", 1);
                    let mixX = $3cdefcdf845023bf$var$getValue(keyMap, "mixX", 1);
                    let mixY = $3cdefcdf845023bf$var$getValue(keyMap, "mixY", mixX);
                    for(let frame = 0, bezier = 0;; frame++){
                        timeline.setFrame(frame, time, mixRotate, mixX, mixY);
                        const nextMap = timelineMap[frame + 1];
                        if (!nextMap) {
                            timeline.shrink(bezier);
                            break;
                        }
                        const time2 = $3cdefcdf845023bf$var$getValue(nextMap, "time", 0);
                        const mixRotate2 = $3cdefcdf845023bf$var$getValue(nextMap, "mixRotate", 1);
                        const mixX2 = $3cdefcdf845023bf$var$getValue(nextMap, "mixX", 1);
                        const mixY2 = $3cdefcdf845023bf$var$getValue(nextMap, "mixY", mixX2);
                        const curve = keyMap.curve;
                        if (curve) {
                            bezier = $3cdefcdf845023bf$var$readCurve(curve, timeline, bezier, frame, 0, time, time2, mixRotate, mixRotate2, 1);
                            bezier = $3cdefcdf845023bf$var$readCurve(curve, timeline, bezier, frame, 1, time, time2, mixX, mixX2, 1);
                            bezier = $3cdefcdf845023bf$var$readCurve(curve, timeline, bezier, frame, 2, time, time2, mixY, mixY2, 1);
                        }
                        time = time2;
                        mixRotate = mixRotate2;
                        mixX = mixX2;
                        mixY = mixY2;
                        keyMap = nextMap;
                    }
                    timelines.push(timeline);
                }
            }
        }
        if (map.deform) {
            map.attachments = {};
            for(const deformName in map.deform){
                const deformMap = map.deform[deformName];
                const outMap = map.attachments[deformName] = {};
                for(const slotName in deformMap){
                    const slotMap = deformMap[slotName];
                    const outMap2 = outMap[slotName] = {};
                    for(const innerMapName in slotMap)outMap2[innerMapName] = {
                        deform: slotMap[innerMapName]
                    };
                }
            }
        }
        if (map.attachments) for(const attachmentsName in map.attachments){
            const attachmentsMap = map.attachments[attachmentsName];
            const skin = skeletonData.findSkin(attachmentsName);
            if (skin == null) {
                if ((0, $1840f66876ded594$export$a5a6e0b888b2c992).FAIL_ON_NON_EXISTING_SKIN) throw new Error(`Skin not found: ${attachmentsName}`);
                else continue;
            }
            for(const slotMapName in attachmentsMap){
                const slotMap = attachmentsMap[slotMapName];
                const slot = skeletonData.findSlot(slotMapName);
                if (!slot) throw new Error(`Slot not found: ${slotMapName}`);
                const slotIndex = slot.index;
                for(const attachmentMapName in slotMap){
                    const attachmentMap = slotMap[attachmentMapName];
                    const attachment = skin.getAttachment(slotIndex, attachmentMapName);
                    for(const timelineMapName in attachmentMap){
                        const timelineMap = attachmentMap[timelineMapName];
                        let keyMap = timelineMap[0];
                        if (!keyMap) continue;
                        if (timelineMapName == "deform") {
                            const weighted = attachment.bones;
                            const vertices = attachment.vertices;
                            const deformLength = weighted ? vertices.length / 3 * 2 : vertices.length;
                            const timeline = new (0, $fd5e2eaf5f163d40$export$6968d40e5689ad6b)(timelineMap.length, timelineMap.length, slotIndex, attachment);
                            let time = $3cdefcdf845023bf$var$getValue(keyMap, "time", 0);
                            for(let frame = 0, bezier = 0;; frame++){
                                let deform;
                                const verticesValue = $3cdefcdf845023bf$var$getValue(keyMap, "vertices", null);
                                if (!verticesValue) deform = weighted ? (0, $8804784813ffae81$export$d2ca453b913dcdea).newFloatArray(deformLength) : vertices;
                                else {
                                    deform = (0, $8804784813ffae81$export$d2ca453b913dcdea).newFloatArray(deformLength);
                                    const start = $3cdefcdf845023bf$var$getValue(keyMap, "offset", 0);
                                    (0, $8804784813ffae81$export$d2ca453b913dcdea).arrayCopy(verticesValue, 0, deform, start, verticesValue.length);
                                    if (scale != 1) for(let i = start, n = i + verticesValue.length; i < n; i++)deform[i] *= scale;
                                    if (!weighted) for(let i = 0; i < deformLength; i++)deform[i] += vertices[i];
                                }
                                timeline.setFrame(frame, time, deform);
                                const nextMap = timelineMap[frame + 1];
                                if (!nextMap) {
                                    timeline.shrink(bezier);
                                    break;
                                }
                                const time2 = $3cdefcdf845023bf$var$getValue(nextMap, "time", 0);
                                const curve = keyMap.curve;
                                if (curve) bezier = $3cdefcdf845023bf$var$readCurve(curve, timeline, bezier, frame, 0, time, time2, 0, 1, 1);
                                time = time2;
                                keyMap = nextMap;
                            }
                            timelines.push(timeline);
                        } else if (timelineMapName == "sequence") {
                            const timeline = new (0, $fd5e2eaf5f163d40$export$2687f324e8496672)(timelineMap.length, slotIndex, attachment);
                            let lastDelay = 0;
                            for(let frame = 0; frame < timelineMap.length; frame++){
                                const delay = $3cdefcdf845023bf$var$getValue(keyMap, "delay", lastDelay);
                                const time = $3cdefcdf845023bf$var$getValue(keyMap, "time", 0);
                                const mode = (0, $37628ed40604134f$export$2d839466c6120eb9)[$3cdefcdf845023bf$var$getValue(keyMap, "mode", "hold")];
                                const index = $3cdefcdf845023bf$var$getValue(keyMap, "index", 0);
                                timeline.setFrame(frame, time, mode, index, delay);
                                lastDelay = delay;
                                keyMap = timelineMap[frame + 1];
                            }
                            timelines.push(timeline);
                        }
                    }
                }
            }
        }
        if (map.drawOrder) {
            const timeline = new (0, $fd5e2eaf5f163d40$export$ece1f7c41d051e83)(map.drawOrder.length);
            const slotCount = skeletonData.slots.length;
            let frame = 0;
            for(let i = 0; i < map.drawOrder.length; i++, frame++){
                const drawOrderMap = map.drawOrder[i];
                let drawOrder = null;
                const offsets = $3cdefcdf845023bf$var$getValue(drawOrderMap, "offsets", null);
                if (offsets) {
                    drawOrder = (0, $8804784813ffae81$export$d2ca453b913dcdea).newArray(slotCount, -1);
                    const unchanged = (0, $8804784813ffae81$export$d2ca453b913dcdea).newArray(slotCount - offsets.length, 0);
                    let originalIndex = 0;
                    let unchangedIndex = 0;
                    for(let ii = 0; ii < offsets.length; ii++){
                        const offsetMap = offsets[ii];
                        const slot = skeletonData.findSlot(offsetMap.slot);
                        if (!slot) throw new Error(`Slot not found: ${slot}`);
                        const slotIndex = slot.index;
                        while(originalIndex != slotIndex)unchanged[unchangedIndex++] = originalIndex++;
                        drawOrder[originalIndex + offsetMap.offset] = originalIndex++;
                    }
                    while(originalIndex < slotCount)unchanged[unchangedIndex++] = originalIndex++;
                    for(let ii = slotCount - 1; ii >= 0; ii--)if (drawOrder[ii] == -1) drawOrder[ii] = unchanged[--unchangedIndex];
                }
                timeline.setFrame(frame, $3cdefcdf845023bf$var$getValue(drawOrderMap, "time", 0), drawOrder);
            }
            timelines.push(timeline);
        }
        if (map.events) {
            const timeline = new (0, $fd5e2eaf5f163d40$export$4f4bca996c586084)(map.events.length);
            let frame = 0;
            for(let i = 0; i < map.events.length; i++, frame++){
                const eventMap = map.events[i];
                const eventData = skeletonData.findEvent(eventMap.name);
                if (!eventData) throw new Error(`Event not found: ${eventMap.name}`);
                const event = new (0, $b69dd53da9706657$export$d61e24a684f9e51)((0, $8804784813ffae81$export$d2ca453b913dcdea).toSinglePrecision($3cdefcdf845023bf$var$getValue(eventMap, "time", 0)), eventData);
                event.intValue = $3cdefcdf845023bf$var$getValue(eventMap, "int", eventData.intValue);
                event.floatValue = $3cdefcdf845023bf$var$getValue(eventMap, "float", eventData.floatValue);
                event.stringValue = $3cdefcdf845023bf$var$getValue(eventMap, "string", eventData.stringValue);
                if (event.data.audioPath) {
                    event.volume = $3cdefcdf845023bf$var$getValue(eventMap, "volume", 1);
                    event.balance = $3cdefcdf845023bf$var$getValue(eventMap, "balance", 0);
                }
                timeline.setFrame(frame, event);
            }
            timelines.push(timeline);
        }
        let duration = 0;
        for(let i = 0, n = timelines.length; i < n; i++)duration = Math.max(duration, timelines[i].getDuration());
        if (isNaN(duration)) throw new Error("Error while parsing animation, duration is NaN");
        skeletonData.animations.push(new (0, $fd5e2eaf5f163d40$export$c35d437ae5945fcd)(name, timelines, duration));
    }
    static blendModeFromString(str) {
        str = str.toLowerCase();
        if (str == "normal") return (0, $0fa4b07f86297abd$export$f821c68fe9beaecf).NORMAL;
        if (str == "additive") return (0, $0fa4b07f86297abd$export$f821c68fe9beaecf).ADD;
        if (str == "multiply") return (0, $0fa4b07f86297abd$export$f821c68fe9beaecf).MULTIPLY;
        if (str == "screen") return (0, $0fa4b07f86297abd$export$f821c68fe9beaecf).SCREEN;
        throw new Error(`Unknown blend mode: ${str}`);
    }
}
class $3cdefcdf845023bf$var$LinkedMesh {
    constructor(mesh, skin, slotIndex, parent, inheritDeform){
        this.mesh = mesh;
        this.skin = skin;
        this.slotIndex = slotIndex;
        this.parent = parent;
        this.inheritTimeline = inheritDeform;
    }
}
function $3cdefcdf845023bf$var$readTimeline1(keys, timeline, defaultValue, scale) {
    let keyMap = keys[0];
    let time = $3cdefcdf845023bf$var$getValue(keyMap, "time", 0);
    let value = $3cdefcdf845023bf$var$getValue(keyMap, "value", defaultValue) * scale;
    let bezier = 0;
    for(let frame = 0;; frame++){
        timeline.setFrame(frame, time, value);
        const nextMap = keys[frame + 1];
        if (!nextMap) {
            timeline.shrink(bezier);
            return timeline;
        }
        const time2 = $3cdefcdf845023bf$var$getValue(nextMap, "time", 0);
        const value2 = $3cdefcdf845023bf$var$getValue(nextMap, "value", defaultValue) * scale;
        if (keyMap.curve) bezier = $3cdefcdf845023bf$var$readCurve(keyMap.curve, timeline, bezier, frame, 0, time, time2, value, value2, scale);
        time = time2;
        value = value2;
        keyMap = nextMap;
    }
}
function $3cdefcdf845023bf$var$readTimeline2(keys, timeline, name1, name2, defaultValue, scale) {
    let keyMap = keys[0];
    let time = $3cdefcdf845023bf$var$getValue(keyMap, "time", 0);
    let value1 = $3cdefcdf845023bf$var$getValue(keyMap, name1, defaultValue) * scale;
    let value2 = $3cdefcdf845023bf$var$getValue(keyMap, name2, defaultValue) * scale;
    let bezier = 0;
    for(let frame = 0;; frame++){
        timeline.setFrame(frame, time, value1, value2);
        const nextMap = keys[frame + 1];
        if (!nextMap) {
            timeline.shrink(bezier);
            return timeline;
        }
        const time2 = $3cdefcdf845023bf$var$getValue(nextMap, "time", 0);
        const nvalue1 = $3cdefcdf845023bf$var$getValue(nextMap, name1, defaultValue) * scale;
        const nvalue2 = $3cdefcdf845023bf$var$getValue(nextMap, name2, defaultValue) * scale;
        const curve = keyMap.curve;
        if (curve) {
            bezier = $3cdefcdf845023bf$var$readCurve(curve, timeline, bezier, frame, 0, time, time2, value1, nvalue1, scale);
            bezier = $3cdefcdf845023bf$var$readCurve(curve, timeline, bezier, frame, 1, time, time2, value2, nvalue2, scale);
        }
        time = time2;
        value1 = nvalue1;
        value2 = nvalue2;
        keyMap = nextMap;
    }
}
function $3cdefcdf845023bf$var$readCurve(curve, timeline, bezier, frame, value, time1, time2, value1, value2, scale) {
    if (curve == "stepped") {
        timeline.setStepped(frame);
        return bezier;
    }
    const i = value << 2;
    const cx1 = curve[i];
    const cy1 = curve[i + 1] * scale;
    const cx2 = curve[i + 2];
    const cy2 = curve[i + 3] * scale;
    timeline.setBezier(bezier, frame, value, time1, value1, cx1, cy1, cx2, cy2, time2, value2);
    return bezier + 1;
}
function $3cdefcdf845023bf$var$getValue(map, property, defaultValue) {
    return map[property] !== void 0 ? map[property] : defaultValue;
}











class $784388461c50e8a6$export$ce0a100797286aea extends (0, $c67a865880ede3c3$export$4093f9922f3d2512) {
    createSkeleton(spineData) {
        this.skeleton = new (0, $ee28c57a028fa6c5$export$8f31e4c4a37b8e9c)(spineData);
        this.skeleton.updateWorldTransform();
        this.stateData = new (0, $c7965d26af0af10e$export$90d7167cc0605975)(spineData);
        this.state = new (0, $02bea3975cac0842$export$d0f7a26c90cc1562)(this.stateData);
    }
}






/*!
 * @pixi/particle-emitter - v5.0.8
 * Compiled Mon, 28 Nov 2022 04:01:38 UTC
 *
 * @pixi/particle-emitter is licensed under the MIT License.
 * http://www.opensource.org/licenses/mit-license
 */ 





/**
 * A single node in a PropertyList.
 */ class $8d042d4853269042$export$c87c56924d182f24 {
    /**
     * @param value The value for this node
     * @param time The time for this node, between 0-1
     * @param [ease] Custom ease for this list. Only relevant for the first node.
     */ constructor(value, time, ease){
        this.value = value;
        this.time = time;
        this.next = null;
        this.isStepped = false;
        if (ease) this.ease = typeof ease === "function" ? ease : $8d042d4853269042$var$generateEase(ease);
        else this.ease = null;
    }
    /**
     * Creates a list of property values from a data object {list, isStepped} with a list of objects in
     * the form {value, time}. Alternatively, the data object can be in the deprecated form of
     * {start, end}.
     * @param data The data for the list.
     * @param data.list The array of value and time objects.
     * @param data.isStepped If the list is stepped rather than interpolated.
     * @param data.ease Custom ease for this list.
     * @return The first node in the list
     */ // eslint-disable-next-line max-len
    static createList(data) {
        if ("list" in data) {
            const array = data.list;
            let node;
            const { value: value, time: time } = array[0];
            // eslint-disable-next-line max-len
            const first = node = new $8d042d4853269042$export$c87c56924d182f24(typeof value === "string" ? $8d042d4853269042$var$hexToRGB(value) : value, time, data.ease);
            // only set up subsequent nodes if there are a bunch or the 2nd one is different from the first
            if (array.length > 2 || array.length === 2 && array[1].value !== value) for(let i = 1; i < array.length; ++i){
                const { value: value, time: time } = array[i];
                node.next = new $8d042d4853269042$export$c87c56924d182f24(typeof value === "string" ? $8d042d4853269042$var$hexToRGB(value) : value, time);
                node = node.next;
            }
            first.isStepped = !!data.isStepped;
            return first;
        }
        // Handle deprecated version here
        const start = new $8d042d4853269042$export$c87c56924d182f24(typeof data.start === "string" ? $8d042d4853269042$var$hexToRGB(data.start) : data.start, 0);
        // only set up a next value if it is different from the starting value
        if (data.end !== data.start) start.next = new $8d042d4853269042$export$c87c56924d182f24(typeof data.end === "string" ? $8d042d4853269042$var$hexToRGB(data.end) : data.end, 1);
        return start;
    }
}
/**
 * The method used by behaviors to fetch textures. Defaults to Texture.from.
 */ // get Texture.from(), only supports V5 and V6 with individual packages
// eslint-disable-next-line prefer-const
let $8d042d4853269042$var$GetTextureFromString = (0, $14896914ad3ae15d$export$5431306cf43de24a).from;
/**
 * If errors and warnings should be logged within the library.
 */ const $8d042d4853269042$var$verbose = false;
const $8d042d4853269042$var$DEG_TO_RADS = Math.PI / 180;
/**
 * Rotates a point by a given angle.
 * @param angle The angle to rotate by in radians
 * @param p The point to rotate around 0,0.
 */ function $8d042d4853269042$var$rotatePoint(angle, p) {
    if (!angle) return;
    const s = Math.sin(angle);
    const c = Math.cos(angle);
    const xnew = p.x * c - p.y * s;
    const ynew = p.x * s + p.y * c;
    p.x = xnew;
    p.y = ynew;
}
/**
 * Combines separate color components (0-255) into a single uint color.
 * @param r The red value of the color
 * @param g The green value of the color
 * @param b The blue value of the color
 * @return The color in the form of 0xRRGGBB
 */ function $8d042d4853269042$var$combineRGBComponents(r, g, b /* , a*/ ) {
    return /* a << 24 |*/ r << 16 | g << 8 | b;
}
/**
 * Returns the length (or magnitude) of this point.
 * @param point The point to measure length
 * @return The length of this point.
 */ function $8d042d4853269042$var$length(point) {
    return Math.sqrt(point.x * point.x + point.y * point.y);
}
/**
 * Reduces the point to a length of 1.
 * @param point The point to normalize
 */ function $8d042d4853269042$var$normalize(point) {
    const oneOverLen = 1 / $8d042d4853269042$var$length(point);
    point.x *= oneOverLen;
    point.y *= oneOverLen;
}
/**
 * Multiplies the x and y values of this point by a value.
 * @param point The point to scaleBy
 * @param value The value to scale by.
 */ function $8d042d4853269042$var$scaleBy(point, value) {
    point.x *= value;
    point.y *= value;
}
/**
 * Converts a hex string from "#AARRGGBB", "#RRGGBB", "0xAARRGGBB", "0xRRGGBB",
 * "AARRGGBB", or "RRGGBB" to an object of ints of 0-255, as
 * {r, g, b, (a)}.
 * @param color The input color string.
 * @param output An object to put the output in. If omitted, a new object is created.
 * @return The object with r, g, and b properties, possibly with an a property.
 */ function $8d042d4853269042$var$hexToRGB(color, output) {
    if (!output) output = {};
    if (color.charAt(0) === "#") color = color.substr(1);
    else if (color.indexOf("0x") === 0) color = color.substr(2);
    let alpha;
    if (color.length === 8) {
        alpha = color.substr(0, 2);
        color = color.substr(2);
    }
    output.r = parseInt(color.substr(0, 2), 16); // Red
    output.g = parseInt(color.substr(2, 2), 16); // Green
    output.b = parseInt(color.substr(4, 2), 16); // Blue
    if (alpha) output.a = parseInt(alpha, 16);
    return output;
}
/**
 * Generates a custom ease function, based on the GreenSock custom ease, as demonstrated
 * by the related tool at http://www.greensock.com/customease/.
 * @param segments An array of segments, as created by
 * http://www.greensock.com/customease/.
 * @return A function that calculates the percentage of change at
 *                    a given point in time (0-1 inclusive).
 */ function $8d042d4853269042$var$generateEase(segments) {
    const qty = segments.length;
    const oneOverQty = 1 / qty;
    /*
        * Calculates the percentage of change at a given point in time (0-1 inclusive).
        * @param {Number} time The time of the ease, 0-1 inclusive.
        * @return {Number} The percentage of the change, 0-1 inclusive (unless your
        *                  ease goes outside those bounds).
        */ // eslint-disable-next-line func-names
    return function(time) {
        const i = qty * time | 0; // do a quick floor operation
        const t = (time - i * oneOverQty) * qty;
        const s = segments[i] || segments[qty - 1];
        return s.s + t * (2 * (1 - t) * (s.cp - s.s) + t * (s.e - s.s));
    };
}
/**
 * Gets a blend mode, ensuring that it is valid.
 * @param name The name of the blend mode to get.
 * @return The blend mode as specified in the PIXI.BLEND_MODES enumeration.
 */ function $8d042d4853269042$var$getBlendMode(name) {
    if (!name) return (0, $0fa4b07f86297abd$export$f821c68fe9beaecf).NORMAL;
    name = name.toUpperCase().replace(/ /g, "_");
    return (0, $0fa4b07f86297abd$export$f821c68fe9beaecf)[name] || (0, $0fa4b07f86297abd$export$f821c68fe9beaecf).NORMAL;
}
/**
 * Converts a list of {value, time} objects starting at time 0 and ending at time 1 into an evenly
 * spaced stepped list of PropertyNodes for color values. This is primarily to handle conversion of
 * linear gradients to fewer colors, allowing for some optimization for Canvas2d fallbacks.
 * @param list The list of data to convert.
 * @param [numSteps=10] The number of steps to use.
 * @return The blend mode as specified in the PIXI.blendModes enumeration.
 */ function $8d042d4853269042$var$createSteppedGradient(list, numSteps = 10) {
    if (typeof numSteps !== "number" || numSteps <= 0) numSteps = 10;
    const first = new $8d042d4853269042$export$c87c56924d182f24($8d042d4853269042$var$hexToRGB(list[0].value), list[0].time);
    first.isStepped = true;
    let currentNode = first;
    let current = list[0];
    let nextIndex = 1;
    let next = list[nextIndex];
    for(let i = 1; i < numSteps; ++i){
        let lerp = i / numSteps;
        // ensure we are on the right segment, if multiple
        while(lerp > next.time){
            current = next;
            next = list[++nextIndex];
        }
        // convert the lerp value to the segment range
        lerp = (lerp - current.time) / (next.time - current.time);
        const curVal = $8d042d4853269042$var$hexToRGB(current.value);
        const nextVal = $8d042d4853269042$var$hexToRGB(next.value);
        const output = {
            r: (nextVal.r - curVal.r) * lerp + curVal.r,
            g: (nextVal.g - curVal.g) * lerp + curVal.g,
            b: (nextVal.b - curVal.b) * lerp + curVal.b
        };
        currentNode.next = new $8d042d4853269042$export$c87c56924d182f24(output, i / numSteps);
        currentNode = currentNode.next;
    }
    // we don't need to have a PropertyNode for time of 1, because in a stepped version at that point
    // the particle has died of old age
    return first;
}
var $8d042d4853269042$export$12596d4170f7600e = {
    __proto__: null,
    GetTextureFromString: $8d042d4853269042$var$GetTextureFromString,
    verbose: $8d042d4853269042$var$verbose,
    DEG_TO_RADS: $8d042d4853269042$var$DEG_TO_RADS,
    rotatePoint: $8d042d4853269042$var$rotatePoint,
    combineRGBComponents: $8d042d4853269042$var$combineRGBComponents,
    length: $8d042d4853269042$var$length,
    normalize: $8d042d4853269042$var$normalize,
    scaleBy: $8d042d4853269042$var$scaleBy,
    hexToRGB: $8d042d4853269042$var$hexToRGB,
    generateEase: $8d042d4853269042$var$generateEase,
    getBlendMode: $8d042d4853269042$var$getBlendMode,
    createSteppedGradient: $8d042d4853269042$var$createSteppedGradient
};
/**
 * An individual particle image. You shouldn't have to deal with these.
 */ class $8d042d4853269042$export$c36c68baa13912a5 extends (0, $e4c5b2569bd3a8d2$export$3075603db8e6204c) {
    /**
     * @param emitter The emitter that controls this particle.
     */ constructor(emitter){
        // start off the sprite with a blank texture, since we are going to replace it
        // later when the particle is initialized.
        super();
        // initialize LinkedListChild props so they are included in underlying JS class definition
        this.prevChild = this.nextChild = null;
        this.emitter = emitter;
        this.config = {};
        // particles should be centered
        this.anchor.x = this.anchor.y = 0.5;
        this.maxLife = 0;
        this.age = 0;
        this.agePercent = 0;
        this.oneOverLife = 0;
        this.next = null;
        this.prev = null;
        // save often used functions on the instance instead of the prototype for better speed
        this.init = this.init;
        this.kill = this.kill;
    }
    /**
     * Initializes the particle for use, based on the properties that have to
     * have been set already on the particle.
     */ init(maxLife) {
        this.maxLife = maxLife;
        // reset the age
        this.age = this.agePercent = 0;
        // reset the sprite props
        this.rotation = 0;
        this.position.x = this.position.y = 0;
        this.scale.x = this.scale.y = 1;
        this.tint = 0xffffff;
        this.alpha = 1;
        // save our lerp helper
        this.oneOverLife = 1 / this.maxLife;
        // ensure visibility
        this.visible = true;
    }
    /**
     * Kills the particle, removing it from the display list
     * and telling the emitter to recycle it.
     */ kill() {
        this.emitter.recycle(this);
    }
    /**
     * Destroys the particle, removing references and preventing future use.
     */ destroy() {
        if (this.parent) this.parent.removeChild(this);
        this.emitter = this.next = this.prev = null;
        super.destroy();
    }
}
/**
 * Standard behavior order values, specifying when/how they are used. Other numeric values can be used,
 * but only the Spawn value will be handled in a special way. All other values will be sorted numerically.
 * Behaviors with the same value will not be given any specific sort order, as they are assumed to not
 * interfere with each other.
 */ var $8d042d4853269042$var$BehaviorOrder;
(function(BehaviorOrder) {
    /**
     * Spawn - initial placement and/or rotation. This happens before rotation/translation due to
     * emitter rotation/position is applied.
     */ BehaviorOrder[BehaviorOrder["Spawn"] = 0] = "Spawn";
    /**
     * Normal priority, for things that don't matter when they are applied.
     */ BehaviorOrder[BehaviorOrder["Normal"] = 2] = "Normal";
    /**
     * Delayed priority, for things that need to read other values in order to act correctly.
     */ BehaviorOrder[BehaviorOrder["Late"] = 5] = "Late";
})($8d042d4853269042$var$BehaviorOrder || ($8d042d4853269042$var$BehaviorOrder = {}));
// get the shared ticker, only supports V5 and V6 with individual packages
/**
 * @hidden
 */ const $8d042d4853269042$var$ticker = (0, $e6b36730368844b1$export$39c54bcc89dcee11).shared;
/**
 * Key used in sorted order to determine when to set particle position from the emitter position
 * and rotation.
 */ const $8d042d4853269042$var$PositionParticle = Symbol("Position particle per emitter position");
/**
 * A particle emitter.
 */ class $8d042d4853269042$export$4293555f241ae35a {
    /**
     * @param particleParent The container to add the particles to.
     * @param particleImages A texture or array of textures to use
     *                       for the particles. Strings will be turned
     *                       into textures via Texture.from().
     * @param config A configuration object containing settings for the emitter.
     * @param config.emit If config.emit is explicitly passed as false, the
     *                    Emitter will start disabled.
     * @param config.autoUpdate If config.autoUpdate is explicitly passed as
     *                          true, the Emitter will automatically call
     *                          update via the PIXI shared ticker.
     */ constructor(particleParent, config){
        this.initBehaviors = [];
        this.updateBehaviors = [];
        this.recycleBehaviors = [];
        // properties for individual particles
        this.minLifetime = 0;
        this.maxLifetime = 0;
        this.customEase = null;
        // properties for spawning particles
        this._frequency = 1;
        this.spawnChance = 1;
        this.maxParticles = 1000;
        this.emitterLifetime = -1;
        this.spawnPos = new (0, $cf3018b4309864c2$export$baf26146a414f24a)();
        this.particlesPerWave = 1;
        // emitter properties
        this.rotation = 0;
        this.ownerPos = new (0, $cf3018b4309864c2$export$baf26146a414f24a)();
        this._prevEmitterPos = new (0, $cf3018b4309864c2$export$baf26146a414f24a)();
        this._prevPosIsValid = false;
        this._posChanged = false;
        this._parent = null;
        this.addAtBack = false;
        this.particleCount = 0;
        this._emit = false;
        this._spawnTimer = 0;
        this._emitterLife = -1;
        this._activeParticlesFirst = null;
        this._activeParticlesLast = null;
        this._poolFirst = null;
        this._origConfig = null;
        this._autoUpdate = false;
        this._destroyWhenComplete = false;
        this._completeCallback = null;
        // set the initial parent
        this.parent = particleParent;
        if (config) this.init(config);
        // save often used functions on the instance instead of the prototype for better speed
        this.recycle = this.recycle;
        this.update = this.update;
        this.rotate = this.rotate;
        this.updateSpawnPos = this.updateSpawnPos;
        this.updateOwnerPos = this.updateOwnerPos;
    }
    /**
     * Registers a new behavior, so that it will be recognized when initializing emitters.
     * Behaviors registered later with duplicate types will override older ones, although there is no limit on
     * the allowed types.
     * @param constructor The behavior class to register.
     */ static registerBehavior(constructor) {
        $8d042d4853269042$export$4293555f241ae35a.knownBehaviors[constructor.type] = constructor;
    }
    /**
     * Time between particle spawns in seconds. If this value is not a number greater than 0,
     * it will be set to 1 (particle per second) to prevent infinite loops.
     */ get frequency() {
        return this._frequency;
    }
    set frequency(value) {
        // do some error checking to prevent infinite loops
        if (typeof value === "number" && value > 0) this._frequency = value;
        else this._frequency = 1;
    }
    /**
    * The container to add particles to. Settings this will dump any active particles.
    */ get parent() {
        return this._parent;
    }
    set parent(value) {
        this.cleanup();
        this._parent = value;
    }
    /**
     * Sets up the emitter based on the config settings.
     * @param config A configuration object containing settings for the emitter.
     */ init(config) {
        if (!config) return;
        // clean up any existing particles
        this.cleanup();
        // store the original config and particle images, in case we need to re-initialize
        // when the particle constructor is changed
        this._origConfig = config;
        // /////////////////////////
        // Particle Properties    //
        // /////////////////////////
        // set up the lifetime
        this.minLifetime = config.lifetime.min;
        this.maxLifetime = config.lifetime.max;
        // use the custom ease if provided
        if (config.ease) this.customEase = typeof config.ease === "function" ? config.ease : $8d042d4853269042$var$generateEase(config.ease);
        else this.customEase = null;
        // ////////////////////////
        // Emitter Properties    //
        // ////////////////////////
        // reset spawn type specific settings
        this.particlesPerWave = 1;
        if (config.particlesPerWave && config.particlesPerWave > 1) this.particlesPerWave = config.particlesPerWave;
        // set the spawning frequency
        this.frequency = config.frequency;
        this.spawnChance = typeof config.spawnChance === "number" && config.spawnChance > 0 ? config.spawnChance : 1;
        // set the emitter lifetime
        this.emitterLifetime = config.emitterLifetime || -1;
        // set the max particles
        this.maxParticles = config.maxParticles > 0 ? config.maxParticles : 1000;
        // determine if we should add the particle at the back of the list or not
        this.addAtBack = !!config.addAtBack;
        // reset the emitter position and rotation variables
        this.rotation = 0;
        this.ownerPos.set(0);
        if (config.pos) this.spawnPos.copyFrom(config.pos);
        else this.spawnPos.set(0);
        this._prevEmitterPos.copyFrom(this.spawnPos);
        // previous emitter position is invalid and should not be used for interpolation
        this._prevPosIsValid = false;
        // start emitting
        this._spawnTimer = 0;
        this.emit = config.emit === undefined ? true : !!config.emit;
        this.autoUpdate = !!config.autoUpdate;
        // ////////////////////////
        // Behaviors             //
        // ////////////////////////
        const behaviors = config.behaviors.map((data)=>{
            const constructor = $8d042d4853269042$export$4293555f241ae35a.knownBehaviors[data.type];
            if (!constructor) {
                console.error(`Unknown behavior: ${data.type}`);
                return null;
            }
            return new constructor(data.config);
        }).filter((b)=>!!b);
        behaviors.push($8d042d4853269042$var$PositionParticle);
        behaviors.sort((a, b)=>{
            if (a === $8d042d4853269042$var$PositionParticle) return b.order === $8d042d4853269042$var$BehaviorOrder.Spawn ? 1 : -1;
            else if (b === $8d042d4853269042$var$PositionParticle) return a.order === $8d042d4853269042$var$BehaviorOrder.Spawn ? -1 : 1;
            return a.order - b.order;
        });
        this.initBehaviors = behaviors.slice();
        this.updateBehaviors = behaviors.filter((b)=>b !== $8d042d4853269042$var$PositionParticle && b.updateParticle);
        this.recycleBehaviors = behaviors.filter((b)=>b !== $8d042d4853269042$var$PositionParticle && b.recycleParticle);
    }
    /**
     * Gets the instantiated behavior of the specified type, if it is present on this emitter.
     * @param type The behavior type to find.
     */ getBehavior(type) {
        // bail if we don't know about such an emitter
        if (!$8d042d4853269042$export$4293555f241ae35a.knownBehaviors[type]) return null;
        // find one that is an instance of the specified type
        return this.initBehaviors.find((b)=>b instanceof $8d042d4853269042$export$4293555f241ae35a.knownBehaviors[type]) || null;
    }
    /**
     * Fills the pool with the specified number of particles, so that they don't have to be instantiated later.
     * @param count The number of particles to create.
     */ fillPool(count) {
        for(; count > 0; --count){
            const p = new $8d042d4853269042$export$c36c68baa13912a5(this);
            p.next = this._poolFirst;
            this._poolFirst = p;
        }
    }
    /**
     * Recycles an individual particle. For internal use only.
     * @param particle The particle to recycle.
     * @param fromCleanup If this is being called to manually clean up all particles.
     * @internal
     */ recycle(particle, fromCleanup = false) {
        for(let i = 0; i < this.recycleBehaviors.length; ++i)this.recycleBehaviors[i].recycleParticle(particle, !fromCleanup);
        if (particle.next) particle.next.prev = particle.prev;
        if (particle.prev) particle.prev.next = particle.next;
        if (particle === this._activeParticlesLast) this._activeParticlesLast = particle.prev;
        if (particle === this._activeParticlesFirst) this._activeParticlesFirst = particle.next;
        // add to pool
        particle.prev = null;
        particle.next = this._poolFirst;
        this._poolFirst = particle;
        // remove child from display, or make it invisible if it is in a ParticleContainer
        if (particle.parent) particle.parent.removeChild(particle);
        // decrease count
        --this.particleCount;
    }
    /**
     * Sets the rotation of the emitter to a new value. This rotates the spawn position in addition
     * to particle direction.
     * @param newRot The new rotation, in degrees.
     */ rotate(newRot) {
        if (this.rotation === newRot) return;
        // caclulate the difference in rotation for rotating spawnPos
        const diff = newRot - this.rotation;
        this.rotation = newRot;
        // rotate spawnPos
        $8d042d4853269042$var$rotatePoint(diff, this.spawnPos);
        // mark the position as having changed
        this._posChanged = true;
    }
    /**
     * Changes the spawn position of the emitter.
     * @param x The new x value of the spawn position for the emitter.
     * @param y The new y value of the spawn position for the emitter.
     */ updateSpawnPos(x, y) {
        this._posChanged = true;
        this.spawnPos.x = x;
        this.spawnPos.y = y;
    }
    /**
     * Changes the position of the emitter's owner. You should call this if you are adding
     * particles to the world container that your emitter's owner is moving around in.
     * @param x The new x value of the emitter's owner.
     * @param y The new y value of the emitter's owner.
     */ updateOwnerPos(x, y) {
        this._posChanged = true;
        this.ownerPos.x = x;
        this.ownerPos.y = y;
    }
    /**
     * Prevents emitter position interpolation in the next update.
     * This should be used if you made a major position change of your emitter's owner
     * that was not normal movement.
     */ resetPositionTracking() {
        this._prevPosIsValid = false;
    }
    /**
     * If particles should be emitted during update() calls. Setting this to false
     * stops new particles from being created, but allows existing ones to die out.
     */ get emit() {
        return this._emit;
    }
    set emit(value) {
        this._emit = !!value;
        this._emitterLife = this.emitterLifetime;
    }
    /**
     * If the update function is called automatically from the shared ticker.
     * Setting this to false requires calling the update function manually.
     */ get autoUpdate() {
        return this._autoUpdate;
    }
    set autoUpdate(value) {
        if (this._autoUpdate && !value) $8d042d4853269042$var$ticker.remove(this.update, this);
        else if (!this._autoUpdate && value) $8d042d4853269042$var$ticker.add(this.update, this);
        this._autoUpdate = !!value;
    }
    /**
     * Starts emitting particles, sets autoUpdate to true, and sets up the Emitter to destroy itself
     * when particle emission is complete.
     * @param callback Callback for when emission is complete (all particles have died off)
     */ playOnceAndDestroy(callback) {
        this.autoUpdate = true;
        this.emit = true;
        this._destroyWhenComplete = true;
        this._completeCallback = callback;
    }
    /**
     * Starts emitting particles and optionally calls a callback when particle emission is complete.
     * @param callback Callback for when emission is complete (all particles have died off)
     */ playOnce(callback) {
        this.emit = true;
        this._completeCallback = callback;
    }
    /**
     * Updates all particles spawned by this emitter and emits new ones.
     * @param delta Time elapsed since the previous frame, in __seconds__.
     */ update(delta) {
        if (this._autoUpdate) delta = $8d042d4853269042$var$ticker.elapsedMS * 0.001;
        // if we don't have a parent to add particles to, then don't do anything.
        // this also works as a isDestroyed check
        if (!this._parent) return;
        // == update existing particles ==
        // update all particle lifetimes before turning them over to behaviors
        for(let particle = this._activeParticlesFirst, next; particle; particle = next){
            // save next particle in case we recycle this one
            next = particle.next;
            // increase age
            particle.age += delta;
            // recycle particle if it is too old
            if (particle.age > particle.maxLife || particle.age < 0) this.recycle(particle);
            else {
                // determine our interpolation value
                let lerp = particle.age * particle.oneOverLife; // lifetime / maxLife;
                // global ease affects all interpolation calculations
                if (this.customEase) {
                    if (this.customEase.length === 4) // the t, b, c, d parameters that some tween libraries use
                    // (time, initial value, end value, duration)
                    lerp = this.customEase(lerp, 0, 1, 1);
                    else // the simplified version that we like that takes
                    // one parameter, time from 0-1. TweenJS eases provide this usage.
                    lerp = this.customEase(lerp);
                }
                // set age percent for all interpolation calculations
                particle.agePercent = lerp;
                // let each behavior run wild on the active particles
                for(let i = 0; i < this.updateBehaviors.length; ++i)if (this.updateBehaviors[i].updateParticle(particle, delta)) {
                    this.recycle(particle);
                    break;
                }
            }
        }
        let prevX;
        let prevY;
        // if the previous position is valid, store these for later interpolation
        if (this._prevPosIsValid) {
            prevX = this._prevEmitterPos.x;
            prevY = this._prevEmitterPos.y;
        }
        // store current position of the emitter as local variables
        const curX = this.ownerPos.x + this.spawnPos.x;
        const curY = this.ownerPos.y + this.spawnPos.y;
        // spawn new particles
        if (this._emit) {
            // decrease spawn timer
            this._spawnTimer -= delta < 0 ? 0 : delta;
            // while _spawnTimer < 0, we have particles to spawn
            while(this._spawnTimer <= 0){
                // determine if the emitter should stop spawning
                if (this._emitterLife >= 0) {
                    this._emitterLife -= this._frequency;
                    if (this._emitterLife <= 0) {
                        this._spawnTimer = 0;
                        this._emitterLife = 0;
                        this.emit = false;
                        break;
                    }
                }
                // determine if we have hit the particle limit
                if (this.particleCount >= this.maxParticles) {
                    this._spawnTimer += this._frequency;
                    continue;
                }
                let emitPosX;
                let emitPosY;
                // If the position has changed and this isn't the first spawn,
                // interpolate the spawn position
                if (this._prevPosIsValid && this._posChanged) {
                    // 1 - _spawnTimer / delta, but _spawnTimer is negative
                    const lerp = 1 + this._spawnTimer / delta;
                    emitPosX = (curX - prevX) * lerp + prevX;
                    emitPosY = (curY - prevY) * lerp + prevY;
                } else {
                    emitPosX = curX;
                    emitPosY = curY;
                }
                let waveFirst = null;
                let waveLast = null;
                // create enough particles to fill the wave
                for(let len = Math.min(this.particlesPerWave, this.maxParticles - this.particleCount), i = 0; i < len; ++i){
                    // see if we actually spawn one
                    if (this.spawnChance < 1 && Math.random() >= this.spawnChance) continue;
                    // determine the particle lifetime
                    let lifetime;
                    if (this.minLifetime === this.maxLifetime) lifetime = this.minLifetime;
                    else lifetime = Math.random() * (this.maxLifetime - this.minLifetime) + this.minLifetime;
                    // only make the particle if it wouldn't immediately destroy itself
                    if (-this._spawnTimer >= lifetime) continue;
                    // create particle
                    let p;
                    if (this._poolFirst) {
                        p = this._poolFirst;
                        this._poolFirst = this._poolFirst.next;
                        p.next = null;
                    } else p = new $8d042d4853269042$export$c36c68baa13912a5(this);
                    // initialize particle
                    p.init(lifetime);
                    // add the particle to the display list
                    if (this.addAtBack) this._parent.addChildAt(p, 0);
                    else this._parent.addChild(p);
                    // add particles to list of ones in this wave
                    if (waveFirst) {
                        waveLast.next = p;
                        p.prev = waveLast;
                        waveLast = p;
                    } else waveLast = waveFirst = p;
                    // increase our particle count
                    ++this.particleCount;
                }
                if (waveFirst) {
                    // add particle to list of active particles
                    if (this._activeParticlesLast) {
                        this._activeParticlesLast.next = waveFirst;
                        waveFirst.prev = this._activeParticlesLast;
                        this._activeParticlesLast = waveLast;
                    } else {
                        this._activeParticlesFirst = waveFirst;
                        this._activeParticlesLast = waveLast;
                    }
                    // run behavior init on particles
                    for(let i = 0; i < this.initBehaviors.length; ++i){
                        const behavior = this.initBehaviors[i];
                        // if we hit our special key, interrupt behaviors to apply
                        // emitter position/rotation
                        if (behavior === $8d042d4853269042$var$PositionParticle) for(let particle = waveFirst, next; particle; particle = next){
                            // save next particle in case we recycle this one
                            next = particle.next;
                            // rotate the particle's position by the emitter's rotation
                            if (this.rotation !== 0) {
                                $8d042d4853269042$var$rotatePoint(this.rotation, particle.position);
                                particle.rotation += this.rotation;
                            }
                            // offset by the emitter's position
                            particle.position.x += emitPosX;
                            particle.position.y += emitPosY;
                            // also, just update the particle's age properties while we are looping through
                            particle.age += -this._spawnTimer;
                            // determine our interpolation value
                            let lerp = particle.age * particle.oneOverLife; // lifetime / maxLife;
                            // global ease affects all interpolation calculations
                            if (this.customEase) {
                                if (this.customEase.length === 4) // the t, b, c, d parameters that some tween libraries use
                                // (time, initial value, end value, duration)
                                lerp = this.customEase(lerp, 0, 1, 1);
                                else // the simplified version that we like that takes
                                // one parameter, time from 0-1. TweenJS eases provide this usage.
                                lerp = this.customEase(lerp);
                            }
                            // set age percent for all interpolation calculations
                            particle.agePercent = lerp;
                        }
                        else behavior.initParticles(waveFirst);
                    }
                    for(let particle = waveFirst, next; particle; particle = next){
                        // save next particle in case we recycle this one
                        next = particle.next;
                        // now update the particles by the time passed, so the particles are spread out properly
                        for(let i = 0; i < this.updateBehaviors.length; ++i)// we want a positive delta, because a negative delta messes things up
                        if (this.updateBehaviors[i].updateParticle(particle, -this._spawnTimer)) {
                            // bail if the particle got reycled
                            this.recycle(particle);
                            break;
                        }
                    }
                }
                // increase timer and continue on to any other particles that need to be created
                this._spawnTimer += this._frequency;
            }
        }
        // if the position changed before this update, then keep track of that
        if (this._posChanged) {
            this._prevEmitterPos.x = curX;
            this._prevEmitterPos.y = curY;
            this._prevPosIsValid = true;
            this._posChanged = false;
        }
        // if we are all done and should destroy ourselves, take care of that
        if (!this._emit && !this._activeParticlesFirst) {
            if (this._completeCallback) {
                const cb = this._completeCallback;
                this._completeCallback = null;
                cb();
            }
            if (this._destroyWhenComplete) this.destroy();
        }
    }
    /**
     * Emits a single wave of particles, using standard spawnChance & particlesPerWave settings. Does not affect
     * regular spawning through the frequency, and ignores the emit property. The max particle count is respected, however,
     * so if there are already too many particles then nothing will happen.
     */ emitNow() {
        const emitPosX = this.ownerPos.x + this.spawnPos.x;
        const emitPosY = this.ownerPos.y + this.spawnPos.y;
        let waveFirst = null;
        let waveLast = null;
        // create enough particles to fill the wave
        for(let len = Math.min(this.particlesPerWave, this.maxParticles - this.particleCount), i = 0; i < len; ++i){
            // see if we actually spawn one
            if (this.spawnChance < 1 && Math.random() >= this.spawnChance) continue;
            // create particle
            let p;
            if (this._poolFirst) {
                p = this._poolFirst;
                this._poolFirst = this._poolFirst.next;
                p.next = null;
            } else p = new $8d042d4853269042$export$c36c68baa13912a5(this);
            let lifetime;
            if (this.minLifetime === this.maxLifetime) lifetime = this.minLifetime;
            else lifetime = Math.random() * (this.maxLifetime - this.minLifetime) + this.minLifetime;
            // initialize particle
            p.init(lifetime);
            // add the particle to the display list
            if (this.addAtBack) this._parent.addChildAt(p, 0);
            else this._parent.addChild(p);
            // add particles to list of ones in this wave
            if (waveFirst) {
                waveLast.next = p;
                p.prev = waveLast;
                waveLast = p;
            } else waveLast = waveFirst = p;
            // increase our particle count
            ++this.particleCount;
        }
        if (waveFirst) {
            // add particle to list of active particles
            if (this._activeParticlesLast) {
                this._activeParticlesLast.next = waveFirst;
                waveFirst.prev = this._activeParticlesLast;
                this._activeParticlesLast = waveLast;
            } else {
                this._activeParticlesFirst = waveFirst;
                this._activeParticlesLast = waveLast;
            }
            // run behavior init on particles
            for(let i = 0; i < this.initBehaviors.length; ++i){
                const behavior = this.initBehaviors[i];
                // if we hit our special key, interrupt behaviors to apply
                // emitter position/rotation
                if (behavior === $8d042d4853269042$var$PositionParticle) for(let particle = waveFirst, next; particle; particle = next){
                    // save next particle in case we recycle this one
                    next = particle.next;
                    // rotate the particle's position by the emitter's rotation
                    if (this.rotation !== 0) {
                        $8d042d4853269042$var$rotatePoint(this.rotation, particle.position);
                        particle.rotation += this.rotation;
                    }
                    // offset by the emitter's position
                    particle.position.x += emitPosX;
                    particle.position.y += emitPosY;
                }
                else behavior.initParticles(waveFirst);
            }
        }
    }
    /**
     * Kills all active particles immediately.
     */ cleanup() {
        let particle;
        let next;
        for(particle = this._activeParticlesFirst; particle; particle = next){
            next = particle.next;
            this.recycle(particle, true);
        }
        this._activeParticlesFirst = this._activeParticlesLast = null;
        this.particleCount = 0;
    }
    /**
     * If this emitter has been destroyed. Note that a destroyed emitter can still be reused, after
     * having a new parent set and being reinitialized.
     */ get destroyed() {
        return !(this._parent && this.initBehaviors.length);
    }
    /**
     * Destroys the emitter and all of its particles.
     */ destroy() {
        // make sure we aren't still listening to any tickers
        this.autoUpdate = false;
        // puts all active particles in the pool, and removes them from the particle parent
        this.cleanup();
        // wipe the pool clean
        let next;
        for(let particle = this._poolFirst; particle; particle = next){
            // store next value so we don't lose it in our destroy call
            next = particle.next;
            particle.destroy();
        }
        this._poolFirst = this._parent = this.spawnPos = this.ownerPos = this.customEase = this._completeCallback = null;
        this.initBehaviors.length = this.updateBehaviors.length = this.recycleBehaviors.length = 0;
    }
}
$8d042d4853269042$export$4293555f241ae35a.knownBehaviors = {};
/**
 * A SpawnShape that randomly picks locations inside a rectangle.
 *
 * Example config:
 * ```javascript
 * {
 *     type: 'rect',
 *     data: {
 *          x: 0,
 *          y: 0,
 *          w: 10,
 *          h: 100
 *     }
 * }
 * ```
 */ class $8d042d4853269042$var$Rectangle {
    constructor(config){
        this.x = config.x;
        this.y = config.y;
        this.w = config.w;
        this.h = config.h;
    }
    getRandPos(particle) {
        // place the particle at a random point in the rectangle
        particle.x = Math.random() * this.w + this.x;
        particle.y = Math.random() * this.h + this.y;
    }
}
$8d042d4853269042$var$Rectangle.type = "rect";
$8d042d4853269042$var$Rectangle.editorConfig = null;
/**
 * A class for spawning particles in a circle or ring.
 * Can optionally apply rotation to particles so that they are aimed away from the center of the circle.
 *
 * Example config:
 * ```javascript
 * {
 *     type: 'torus',
 *     data: {
 *          radius: 30,
 *          x: 0,
 *          y: 0,
 *          innerRadius: 10,
 *          rotation: true
 *     }
 * }
 * ```
 */ class $8d042d4853269042$var$Torus {
    constructor(config){
        this.x = config.x || 0;
        this.y = config.y || 0;
        this.radius = config.radius;
        this.innerRadius = config.innerRadius || 0;
        this.rotation = !!config.affectRotation;
    }
    getRandPos(particle) {
        // place the particle at a random radius in the ring
        if (this.innerRadius !== this.radius) particle.x = Math.random() * (this.radius - this.innerRadius) + this.innerRadius;
        else particle.x = this.radius;
        particle.y = 0;
        // rotate the point to a random angle in the circle
        const angle = Math.random() * Math.PI * 2;
        if (this.rotation) particle.rotation += angle;
        $8d042d4853269042$var$rotatePoint(angle, particle.position);
        // now add in the center of the torus
        particle.position.x += this.x;
        particle.position.y += this.y;
    }
}
$8d042d4853269042$var$Torus.type = "torus";
$8d042d4853269042$var$Torus.editorConfig = null;
/**
 * A spawn shape that picks a random position along a series of line segments. If those
 * line segments form a polygon, particles will only be placed on the perimeter of that polygon.
 *
 * Example config:
 * ```javascript
 * {
 *      type: 'polygonalChain',
 *      data: [
 *          [{x: 0, y: 0}, {x: 10, y: 10}, {x: 20, y: 0}],
 *          [{x: 0, y, -10}, {x: 10, y: 0}, {x: 20, y: -10}]
 *      ]
 * }
 * ```
 */ class $8d042d4853269042$var$PolygonalChain {
    /**
     * @param data Point data for polygon chains. Either a list of points for a single chain, or a list of chains.
     */ constructor(data){
        this.segments = [];
        this.countingLengths = [];
        this.totalLength = 0;
        this.init(data);
    }
    /**
     * @param data Point data for polygon chains. Either a list of points for a single chain, or a list of chains.
     */ init(data) {
        // if data is not present, set up a segment of length 0
        if (!data || !data.length) this.segments.push({
            p1: {
                x: 0,
                y: 0
            },
            p2: {
                x: 0,
                y: 0
            },
            l: 0
        });
        else if (Array.isArray(data[0])) // list of segment chains, each defined as a list of points
        for(let i = 0; i < data.length; ++i){
            // loop through the chain, connecting points
            const chain = data[i];
            let prevPoint = chain[0];
            for(let j = 1; j < chain.length; ++j){
                const second = chain[j];
                this.segments.push({
                    p1: prevPoint,
                    p2: second,
                    l: 0
                });
                prevPoint = second;
            }
        }
        else {
            let prevPoint = data[0];
            // list of points
            for(let i = 1; i < data.length; ++i){
                const second = data[i];
                this.segments.push({
                    p1: prevPoint,
                    p2: second,
                    l: 0
                });
                prevPoint = second;
            }
        }
        // now go through our segments to calculate the lengths so that we
        // can set up a nice weighted random distribution
        for(let i = 0; i < this.segments.length; ++i){
            const { p1: p1, p2: p2 } = this.segments[i];
            const segLength = Math.sqrt((p2.x - p1.x) * (p2.x - p1.x) + (p2.y - p1.y) * (p2.y - p1.y));
            // save length so we can turn a random number into a 0-1 interpolation value later
            this.segments[i].l = segLength;
            this.totalLength += segLength;
            // keep track of the length so far, counting up
            this.countingLengths.push(this.totalLength);
        }
    }
    /**
     * Gets a random point in the chain.
     * @param out The point to store the selected position in.
     */ getRandPos(out) {
        // select a random spot in the length of the chain
        const rand = Math.random() * this.totalLength;
        let chosenSeg;
        let lerp;
        // if only one segment, it wins
        if (this.segments.length === 1) {
            chosenSeg = this.segments[0];
            lerp = rand;
        } else {
            // otherwise, go through countingLengths until we have determined
            // which segment we chose
            for(let i = 0; i < this.countingLengths.length; ++i)if (rand < this.countingLengths[i]) {
                chosenSeg = this.segments[i];
                // set lerp equal to the length into that segment
                // (i.e. the remainder after subtracting all the segments before it)
                lerp = i === 0 ? rand : rand - this.countingLengths[i - 1];
                break;
            }
        }
        // divide lerp by the segment length, to result in a 0-1 number.
        lerp /= chosenSeg.l || 1;
        const { p1: p1, p2: p2 } = chosenSeg;
        // now calculate the position in the segment that the lerp value represents
        out.x = p1.x + lerp * (p2.x - p1.x);
        out.y = p1.y + lerp * (p2.y - p1.y);
    }
}
$8d042d4853269042$var$PolygonalChain.type = "polygonalChain";
$8d042d4853269042$var$PolygonalChain.editorConfig = null;
var $8d042d4853269042$var$index = {
    __proto__: null,
    Rectangle: $8d042d4853269042$var$Rectangle,
    Torus: $8d042d4853269042$var$Torus,
    PolygonalChain: $8d042d4853269042$var$PolygonalChain
};
var $8d042d4853269042$var$Types = {
    __proto__: null
};
/**
 * A Movement behavior that handles movement by applying a constant acceleration to all particles.
 *
 * Example configuration:
 * ```javascript
 * {
 *     "type": "moveAcceleration",
 *     "config": {
 *          "accel": {
 *               "x": 0,
 *               "y": 2000
 *          },
 *          "minStart": 600,
 *          "maxStart": 600,
 *          "rotate": true
 *     }
 *}
 * ```
 */ class $8d042d4853269042$var$AccelerationBehavior {
    constructor(config){
        var _a;
        // doesn't _really_ need to be late, but doing so ensures that we can override any
        // rotation behavior that is mistakenly added
        this.order = $8d042d4853269042$var$BehaviorOrder.Late;
        this.minStart = config.minStart;
        this.maxStart = config.maxStart;
        this.accel = config.accel;
        this.rotate = !!config.rotate;
        this.maxSpeed = (_a = config.maxSpeed) !== null && _a !== void 0 ? _a : 0;
    }
    initParticles(first) {
        let next = first;
        while(next){
            const speed = Math.random() * (this.maxStart - this.minStart) + this.minStart;
            if (!next.config.velocity) next.config.velocity = new (0, $cf3018b4309864c2$export$baf26146a414f24a)(speed, 0);
            else next.config.velocity.set(speed, 0);
            $8d042d4853269042$var$rotatePoint(next.rotation, next.config.velocity);
            next = next.next;
        }
    }
    updateParticle(particle, deltaSec) {
        const vel = particle.config.velocity;
        const oldVX = vel.x;
        const oldVY = vel.y;
        vel.x += this.accel.x * deltaSec;
        vel.y += this.accel.y * deltaSec;
        if (this.maxSpeed) {
            const currentSpeed = $8d042d4853269042$var$length(vel);
            // if we are going faster than we should, clamp at the max speed
            // DO NOT recalculate vector length
            if (currentSpeed > this.maxSpeed) $8d042d4853269042$var$scaleBy(vel, this.maxSpeed / currentSpeed);
        }
        // calculate position delta by the midpoint between our old velocity and our new velocity
        particle.x += (oldVX + vel.x) / 2 * deltaSec;
        particle.y += (oldVY + vel.y) / 2 * deltaSec;
        if (this.rotate) particle.rotation = Math.atan2(vel.y, vel.x);
    }
}
$8d042d4853269042$var$AccelerationBehavior.type = "moveAcceleration";
$8d042d4853269042$var$AccelerationBehavior.editorConfig = null;
function $8d042d4853269042$var$intValueSimple(lerp) {
    if (this.ease) lerp = this.ease(lerp);
    return (this.first.next.value - this.first.value) * lerp + this.first.value;
}
function $8d042d4853269042$var$intColorSimple(lerp) {
    if (this.ease) lerp = this.ease(lerp);
    const curVal = this.first.value;
    const nextVal = this.first.next.value;
    const r = (nextVal.r - curVal.r) * lerp + curVal.r;
    const g = (nextVal.g - curVal.g) * lerp + curVal.g;
    const b = (nextVal.b - curVal.b) * lerp + curVal.b;
    return $8d042d4853269042$var$combineRGBComponents(r, g, b);
}
function $8d042d4853269042$var$intValueComplex(lerp) {
    if (this.ease) lerp = this.ease(lerp);
    // make sure we are on the right segment
    let current = this.first;
    let next = current.next;
    while(lerp > next.time){
        current = next;
        next = next.next;
    }
    // convert the lerp value to the segment range
    lerp = (lerp - current.time) / (next.time - current.time);
    return (next.value - current.value) * lerp + current.value;
}
function $8d042d4853269042$var$intColorComplex(lerp) {
    if (this.ease) lerp = this.ease(lerp);
    // make sure we are on the right segment
    let current = this.first;
    let next = current.next;
    while(lerp > next.time){
        current = next;
        next = next.next;
    }
    // convert the lerp value to the segment range
    lerp = (lerp - current.time) / (next.time - current.time);
    const curVal = current.value;
    const nextVal = next.value;
    const r = (nextVal.r - curVal.r) * lerp + curVal.r;
    const g = (nextVal.g - curVal.g) * lerp + curVal.g;
    const b = (nextVal.b - curVal.b) * lerp + curVal.b;
    return $8d042d4853269042$var$combineRGBComponents(r, g, b);
}
function $8d042d4853269042$var$intValueStepped(lerp) {
    if (this.ease) lerp = this.ease(lerp);
    // make sure we are on the right segment
    let current = this.first;
    while(current.next && lerp > current.next.time)current = current.next;
    return current.value;
}
function $8d042d4853269042$var$intColorStepped(lerp) {
    if (this.ease) lerp = this.ease(lerp);
    // make sure we are on the right segment
    let current = this.first;
    while(current.next && lerp > current.next.time)current = current.next;
    const curVal = current.value;
    return $8d042d4853269042$var$combineRGBComponents(curVal.r, curVal.g, curVal.b);
}
/**
 * Singly linked list container for keeping track of interpolated properties for particles.
 * Each Particle will have one of these for each interpolated property.
 */ class $8d042d4853269042$export$4e0d1ad7ad6a0802 {
    /**
     * @param isColor If this list handles color values
     */ constructor(isColor = false){
        this.first = null;
        this.isColor = !!isColor;
        this.interpolate = null;
        this.ease = null;
    }
    /**
     * Resets the list for use.
     * @param first The first node in the list.
     * @param first.isStepped If the values should be stepped instead of interpolated linearly.
     */ reset(first) {
        this.first = first;
        const isSimple = first.next && first.next.time >= 1;
        if (isSimple) this.interpolate = this.isColor ? $8d042d4853269042$var$intColorSimple : $8d042d4853269042$var$intValueSimple;
        else if (first.isStepped) this.interpolate = this.isColor ? $8d042d4853269042$var$intColorStepped : $8d042d4853269042$var$intValueStepped;
        else this.interpolate = this.isColor ? $8d042d4853269042$var$intColorComplex : $8d042d4853269042$var$intValueComplex;
        this.ease = this.first.ease;
    }
}
/**
 * An Alpha behavior that applies an interpolated or stepped list of values to the particle's opacity.
 *
 * Example config:
 * ```javascript
 * {
 *     type: 'alpha',
 *     config: {
 *         alpha: {
 *              list: [{value: 0, time: 0}, {value: 1, time: 0.25}, {value: 0, time: 1}]
 *         },
 *     }
 * }
 * ```
 */ class $8d042d4853269042$var$AlphaBehavior {
    constructor(config){
        this.order = $8d042d4853269042$var$BehaviorOrder.Normal;
        this.list = new $8d042d4853269042$export$4e0d1ad7ad6a0802(false);
        this.list.reset($8d042d4853269042$export$c87c56924d182f24.createList(config.alpha));
    }
    initParticles(first) {
        let next = first;
        while(next){
            next.alpha = this.list.first.value;
            next = next.next;
        }
    }
    updateParticle(particle) {
        particle.alpha = this.list.interpolate(particle.agePercent);
    }
}
$8d042d4853269042$var$AlphaBehavior.type = "alpha";
$8d042d4853269042$var$AlphaBehavior.editorConfig = null;
/**
 * An Alpha behavior that applies a static value to the particle's opacity at particle initialization.
 *
 * Example config:
 * ```javascript
 * {
 *     type: 'alphaStatic',
 *     config: {
 *         alpha: 0.75,
 *     }
 * }
 * ```
 */ class $8d042d4853269042$var$StaticAlphaBehavior {
    constructor(config){
        this.order = $8d042d4853269042$var$BehaviorOrder.Normal;
        this.value = config.alpha;
    }
    initParticles(first) {
        let next = first;
        while(next){
            next.alpha = this.value;
            next = next.next;
        }
    }
}
$8d042d4853269042$var$StaticAlphaBehavior.type = "alphaStatic";
$8d042d4853269042$var$StaticAlphaBehavior.editorConfig = null;
function $8d042d4853269042$var$getTextures(textures) {
    const outTextures = [];
    for(let j = 0; j < textures.length; ++j){
        let tex = textures[j];
        if (typeof tex === "string") outTextures.push($8d042d4853269042$var$GetTextureFromString(tex));
        else if (tex instanceof (0, $14896914ad3ae15d$export$5431306cf43de24a)) outTextures.push(tex);
        else {
            let dupe = tex.count || 1;
            if (typeof tex.texture === "string") tex = $8d042d4853269042$var$GetTextureFromString(tex.texture);
            else tex = tex.texture;
            for(; dupe > 0; --dupe)outTextures.push(tex);
        }
    }
    return outTextures;
}
/**
 * A Texture behavior that picks a random animation for each particle to play.
 * See {@link AnimatedParticleArt} for detailed configuration info.
 *
 * Example config:
 * ```javascript
 * {
 *     type: 'animatedRandom',
 *     config: {
 *         anims: [
 *              {
 *                  framerate: 25,
 *                  loop: true,
 *                  textures: ['frame1', 'frame2', 'frame3']
 *              },
 *              {
 *                  framerate: 25,
 *                  loop: true,
 *                  textures: ['frame3', 'frame2', 'frame1']
 *              }
 *         ],
 *     }
 * }
 * ```
 */ class $8d042d4853269042$var$RandomAnimatedTextureBehavior {
    constructor(config){
        this.order = $8d042d4853269042$var$BehaviorOrder.Normal;
        this.anims = [];
        for(let i = 0; i < config.anims.length; ++i){
            const anim = config.anims[i];
            const textures = $8d042d4853269042$var$getTextures(anim.textures);
            // eslint-disable-next-line no-nested-ternary
            const framerate = anim.framerate < 0 ? -1 : anim.framerate > 0 ? anim.framerate : 60;
            const parsedAnim = {
                textures: textures,
                duration: framerate > 0 ? textures.length / framerate : 0,
                framerate: framerate,
                loop: framerate > 0 ? !!anim.loop : false
            };
            this.anims.push(parsedAnim);
        }
    }
    initParticles(first) {
        let next = first;
        while(next){
            const index = Math.floor(Math.random() * this.anims.length);
            const anim = next.config.anim = this.anims[index];
            next.texture = anim.textures[0];
            next.config.animElapsed = 0;
            // if anim should match particle life exactly
            if (anim.framerate === -1) {
                next.config.animDuration = next.maxLife;
                next.config.animFramerate = anim.textures.length / next.maxLife;
            } else {
                next.config.animDuration = anim.duration;
                next.config.animFramerate = anim.framerate;
            }
            next = next.next;
        }
    }
    updateParticle(particle, deltaSec) {
        const config = particle.config;
        const anim = config.anim;
        config.animElapsed += deltaSec;
        if (config.animElapsed >= config.animDuration) {
            // loop elapsed back around
            if (config.anim.loop) config.animElapsed = config.animElapsed % config.animDuration;
            else config.animElapsed = config.animDuration - 0.000001;
        }
        // add a very small number to the frame and then floor it to avoid
        // the frame being one short due to floating point errors.
        const frame = config.animElapsed * config.animFramerate + 0.0000001 | 0;
        // in the very rare case that framerate * elapsed math ends up going past the end, use the last texture
        particle.texture = anim.textures[frame] || anim.textures[anim.textures.length - 1] || (0, $14896914ad3ae15d$export$5431306cf43de24a).EMPTY;
    }
}
$8d042d4853269042$var$RandomAnimatedTextureBehavior.type = "animatedRandom";
$8d042d4853269042$var$RandomAnimatedTextureBehavior.editorConfig = null;
/**
 * A Texture behavior that uses a single animation for each particle to play.
 * See {@link AnimatedParticleArt} for detailed configuration info.
 *
 * Example config:
 * ```javascript
 * {
 *     type: 'animatedSingle',
 *     config: {
 *         anim: {
 *              framerate: 25,
 *              loop: true,
 *              textures: ['frame1', 'frame2', 'frame3']
 *         }
 *     }
 * }
 * ```
 */ class $8d042d4853269042$var$SingleAnimatedTextureBehavior {
    constructor(config){
        this.order = $8d042d4853269042$var$BehaviorOrder.Normal;
        const anim = config.anim;
        const textures = $8d042d4853269042$var$getTextures(anim.textures);
        // eslint-disable-next-line no-nested-ternary
        const framerate = anim.framerate < 0 ? -1 : anim.framerate > 0 ? anim.framerate : 60;
        this.anim = {
            textures: textures,
            duration: framerate > 0 ? textures.length / framerate : 0,
            framerate: framerate,
            loop: framerate > 0 ? !!anim.loop : false
        };
    }
    initParticles(first) {
        let next = first;
        const anim = this.anim;
        while(next){
            next.texture = anim.textures[0];
            next.config.animElapsed = 0;
            // if anim should match particle life exactly
            if (anim.framerate === -1) {
                next.config.animDuration = next.maxLife;
                next.config.animFramerate = anim.textures.length / next.maxLife;
            } else {
                next.config.animDuration = anim.duration;
                next.config.animFramerate = anim.framerate;
            }
            next = next.next;
        }
    }
    updateParticle(particle, deltaSec) {
        const anim = this.anim;
        const config = particle.config;
        config.animElapsed += deltaSec;
        if (config.animElapsed >= config.animDuration) {
            // loop elapsed back around
            if (anim.loop) config.animElapsed = config.animElapsed % config.animDuration;
            else config.animElapsed = config.animDuration - 0.000001;
        }
        // add a very small number to the frame and then floor it to avoid
        // the frame being one short due to floating point errors.
        const frame = config.animElapsed * config.animFramerate + 0.0000001 | 0;
        // in the very rare case that framerate * elapsed math ends up going past the end, use the last texture
        particle.texture = anim.textures[frame] || anim.textures[anim.textures.length - 1] || (0, $14896914ad3ae15d$export$5431306cf43de24a).EMPTY;
    }
}
$8d042d4853269042$var$SingleAnimatedTextureBehavior.type = "animatedSingle";
$8d042d4853269042$var$SingleAnimatedTextureBehavior.editorConfig = null;
/**
 * A Blend Mode behavior that applies a blend mode value to the particle at initialization.
 *
 * Example config:
 * ```javascript
 * {
 *     type: 'blendMode',
 *     config: {
 *         blendMode: 'multiply',
 *     }
 * }
 * ```
 */ class $8d042d4853269042$var$BlendModeBehavior {
    constructor(config){
        this.order = $8d042d4853269042$var$BehaviorOrder.Normal;
        this.value = config.blendMode;
    }
    initParticles(first) {
        let next = first;
        while(next){
            next.blendMode = $8d042d4853269042$var$getBlendMode(this.value);
            next = next.next;
        }
    }
}
$8d042d4853269042$var$BlendModeBehavior.type = "blendMode";
$8d042d4853269042$var$BlendModeBehavior.editorConfig = null;
/**
 * A Spawn behavior that sends particles out from a single point or ring, and is capable of evenly spacing
 * the particle's starting angles.
 *
 * Example config:
 * ```javascript
 * {
 *     type: 'spawnBurst',
 *     config: {
 *          spacing: 90,
 *          start: 0,
 *          distance: 40,
 *     }
 * }
 * ```
 */ class $8d042d4853269042$var$BurstSpawnBehavior {
    constructor(config){
        this.order = $8d042d4853269042$var$BehaviorOrder.Spawn;
        this.spacing = config.spacing * $8d042d4853269042$var$DEG_TO_RADS;
        this.start = config.start * $8d042d4853269042$var$DEG_TO_RADS;
        this.distance = config.distance;
    }
    initParticles(first) {
        let count = 0;
        let next = first;
        while(next){
            let angle;
            if (this.spacing) angle = this.start + this.spacing * count;
            else angle = Math.random() * Math.PI * 2;
            next.rotation = angle;
            if (this.distance) {
                next.position.x = this.distance;
                $8d042d4853269042$var$rotatePoint(angle, next.position);
            }
            next = next.next;
            ++count;
        }
    }
}
$8d042d4853269042$var$BurstSpawnBehavior.type = "spawnBurst";
$8d042d4853269042$var$BurstSpawnBehavior.editorConfig = null;
/**
 * A Color behavior that applies an interpolated or stepped list of values to the particle's tint property.
 *
 * Example config:
 * ```javascript
 * {
 *     type: 'color',
 *     config: {
 *         color: {
 *              list: [{value: '#ff0000' time: 0}, {value: '#00ff00', time: 0.5}, {value: '#0000ff', time: 1}]
 *         },
 *     }
 * }
 * ```
 */ class $8d042d4853269042$var$ColorBehavior {
    constructor(config){
        this.order = $8d042d4853269042$var$BehaviorOrder.Normal;
        this.list = new $8d042d4853269042$export$4e0d1ad7ad6a0802(true);
        this.list.reset($8d042d4853269042$export$c87c56924d182f24.createList(config.color));
    }
    initParticles(first) {
        let next = first;
        const color = this.list.first.value;
        const tint = $8d042d4853269042$var$combineRGBComponents(color.r, color.g, color.b);
        while(next){
            next.tint = tint;
            next = next.next;
        }
    }
    updateParticle(particle) {
        particle.tint = this.list.interpolate(particle.agePercent);
    }
}
$8d042d4853269042$var$ColorBehavior.type = "color";
$8d042d4853269042$var$ColorBehavior.editorConfig = null;
/**
 * A Color behavior that applies a single color to the particle's tint property at initialization.
 *
 * Example config:
 * ```javascript
 * {
 *     type: 'colorStatic',
 *     config: {
 *         color: '#ffff00',
 *     }
 * }
 * ```
 */ class $8d042d4853269042$var$StaticColorBehavior {
    constructor(config){
        this.order = $8d042d4853269042$var$BehaviorOrder.Normal;
        let color = config.color;
        if (color.charAt(0) === "#") color = color.substr(1);
        else if (color.indexOf("0x") === 0) color = color.substr(2);
        this.value = parseInt(color, 16);
    }
    initParticles(first) {
        let next = first;
        while(next){
            next.tint = this.value;
            next = next.next;
        }
    }
}
$8d042d4853269042$var$StaticColorBehavior.type = "colorStatic";
$8d042d4853269042$var$StaticColorBehavior.editorConfig = null;
/**
 * A Texture behavior that assigns a texture to each particle from its list, in order, before looping around to the first
 * texture again. String values will be converted to textures with {@link ParticleUtils.GetTextureFromString}.
 *
 * Example config:
 * ```javascript
 * {
 *     type: 'textureOrdered',
 *     config: {
 *         textures: ["myTex1Id", "myTex2Id", "myTex3Id", "myTex4Id"],
 *     }
 * }
 * ```
 */ class $8d042d4853269042$var$OrderedTextureBehavior {
    constructor(config){
        this.order = $8d042d4853269042$var$BehaviorOrder.Normal;
        this.index = 0;
        this.textures = config.textures.map((tex)=>typeof tex === "string" ? $8d042d4853269042$var$GetTextureFromString(tex) : tex);
    }
    initParticles(first) {
        let next = first;
        while(next){
            next.texture = this.textures[this.index];
            if (++this.index >= this.textures.length) this.index = 0;
            next = next.next;
        }
    }
}
$8d042d4853269042$var$OrderedTextureBehavior.type = "textureOrdered";
$8d042d4853269042$var$OrderedTextureBehavior.editorConfig = null;
/**
 * A helper point for math things.
 * @hidden
 */ const $8d042d4853269042$var$helperPoint = new (0, $cf3018b4309864c2$export$baf26146a414f24a)();
/**
 * A hand picked list of Math functions (and a couple properties) that are
 * allowable. They should be used without the preceding "Math."
 * @hidden
 */ const $8d042d4853269042$var$MATH_FUNCS = [
    "E",
    "LN2",
    "LN10",
    "LOG2E",
    "LOG10E",
    "PI",
    "SQRT1_2",
    "SQRT2",
    "abs",
    "acos",
    "acosh",
    "asin",
    "asinh",
    "atan",
    "atanh",
    "atan2",
    "cbrt",
    "ceil",
    "cos",
    "cosh",
    "exp",
    "expm1",
    "floor",
    "fround",
    "hypot",
    "log",
    "log1p",
    "log10",
    "log2",
    "max",
    "min",
    "pow",
    "random",
    "round",
    "sign",
    "sin",
    "sinh",
    "sqrt",
    "tan",
    "tanh"
];
/**
 * create an actual regular expression object from the string
 * @hidden
 */ const $8d042d4853269042$var$WHITELISTER = new RegExp([
    // Allow the 4 basic operations, parentheses and all numbers/decimals, as well
    // as 'x', for the variable usage.
    "[01234567890\\.\\*\\-\\+\\/\\(\\)x ,]"
].concat($8d042d4853269042$var$MATH_FUNCS).join("|"), "g");
/**
 * Parses a string into a function for path following.
 * This involves whitelisting the string for safety, inserting "Math." to math function
 * names, and using `new Function()` to generate a function.
 * @hidden
 * @param pathString The string to parse.
 * @return The path function - takes x, outputs y.
 */ function $8d042d4853269042$var$parsePath(pathString) {
    const matches = pathString.match($8d042d4853269042$var$WHITELISTER);
    for(let i = matches.length - 1; i >= 0; --i)if ($8d042d4853269042$var$MATH_FUNCS.indexOf(matches[i]) >= 0) matches[i] = `Math.${matches[i]}`;
    pathString = matches.join("");
    // eslint-disable-next-line no-new-func
    return new Function("x", `return ${pathString};`);
}
/**
 * A particle that follows a path defined by an algebraic expression, e.g. "sin(x)" or
 * "5x + 3".
 * To use this class, the behavior config must have a "path" string or function.
 *
 * A string should have "x" in it to represent movement (from the
 * speed settings of the behavior). It may have numbers, parentheses, the four basic
 * operations, and any Math functions or properties (without the preceding "Math.").
 * The overall movement of the particle and the expression value become x and y positions for
 * the particle, respectively. The final position is rotated by the spawn rotation/angle of
 * the particle.
 *
 * A function merely needs to accept the "x" argument and output the a corresponding "y" value.
 *
 * Some example paths:
 *
 * * `"sin(x/10) * 20"` A sine wave path.
 * * `"cos(x/100) * 30"` Particles curve counterclockwise (for medium speed/low lifetime particles)
 * * `"pow(x/10, 2) / 2"` Particles curve clockwise (remember, +y is down).
 * * `(x) => Math.floor(x) * 3` Supplying an existing function should look like this
 *
 * Example configuration:
 * ```javascript
 * {
 *     "type": "movePath",
 *     "config": {
 *          "path": "round(sin(x) * 2",
 *          "speed": {
 *              "list": [{value: 10, time: 0}, {value: 100, time: 0.25}, {value: 0, time: 1}],
 *          },
 *          "minMult": 0.8
 *     }
 *}
 */ class $8d042d4853269042$var$PathBehavior {
    constructor(config){
        var _a;
        // *MUST* happen after other behaviors do initialization so that we can read initial transformations
        this.order = $8d042d4853269042$var$BehaviorOrder.Late;
        if (config.path) {
            if (typeof config.path === "function") this.path = config.path;
            else try {
                this.path = $8d042d4853269042$var$parsePath(config.path);
            } catch (e) {
                this.path = null;
            }
        } else // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
        this.path = (x)=>x;
        this.list = new $8d042d4853269042$export$4e0d1ad7ad6a0802(false);
        this.list.reset($8d042d4853269042$export$c87c56924d182f24.createList(config.speed));
        this.minMult = (_a = config.minMult) !== null && _a !== void 0 ? _a : 1;
    }
    initParticles(first) {
        let next = first;
        while(next){
            /*
             * The initial rotation in degrees of the particle, because the direction of the path
             * is based on that.
             */ next.config.initRotation = next.rotation;
            /* The initial position of the particle, as all path movement is added to that. */ if (!next.config.initPosition) next.config.initPosition = new (0, $cf3018b4309864c2$export$baf26146a414f24a)(next.x, next.y);
            else next.config.initPosition.copyFrom(next.position);
            /* Total single directional movement, due to speed. */ next.config.movement = 0;
            // also do speed multiplier, since this includes basic speed movement
            const mult = Math.random() * (1 - this.minMult) + this.minMult;
            next.config.speedMult = mult;
            next = next.next;
        }
    }
    updateParticle(particle, deltaSec) {
        // increase linear movement based on speed
        const speed = this.list.interpolate(particle.agePercent) * particle.config.speedMult;
        particle.config.movement += speed * deltaSec;
        // set up the helper point for rotation
        $8d042d4853269042$var$helperPoint.x = particle.config.movement;
        $8d042d4853269042$var$helperPoint.y = this.path($8d042d4853269042$var$helperPoint.x);
        $8d042d4853269042$var$rotatePoint(particle.config.initRotation, $8d042d4853269042$var$helperPoint);
        particle.position.x = particle.config.initPosition.x + $8d042d4853269042$var$helperPoint.x;
        particle.position.y = particle.config.initPosition.y + $8d042d4853269042$var$helperPoint.y;
    }
}
$8d042d4853269042$var$PathBehavior.type = "movePath";
$8d042d4853269042$var$PathBehavior.editorConfig = null;
/**
 * A Spawn behavior that sends particles out from a single point at the emitter's position.
 *
 * Example config:
 * ```javascript
 * {
 *     type: 'spawnPoint',
 *     config: {}
 * }
 * ```
 */ class $8d042d4853269042$var$PointSpawnBehavior {
    constructor(){
        this.order = $8d042d4853269042$var$BehaviorOrder.Spawn;
    }
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    initParticles(_first) {
    // really just a no-op
    }
}
$8d042d4853269042$var$PointSpawnBehavior.type = "spawnPoint";
$8d042d4853269042$var$PointSpawnBehavior.editorConfig = null;
/**
 * A Texture behavior that assigns a random texture to each particle from its list.
 * String values will be converted to textures with {@link ParticleUtils.GetTextureFromString}.
 *
 * Example config:
 * ```javascript
 * {
 *     type: 'textureRandom',
 *     config: {
 *         textures: ["myTex1Id", "myTex2Id", "myTex3Id", "myTex4Id"],
 *     }
 * }
 * ```
 */ class $8d042d4853269042$var$RandomTextureBehavior {
    constructor(config){
        this.order = $8d042d4853269042$var$BehaviorOrder.Normal;
        this.textures = config.textures.map((tex)=>typeof tex === "string" ? $8d042d4853269042$var$GetTextureFromString(tex) : tex);
    }
    initParticles(first) {
        let next = first;
        while(next){
            const index = Math.floor(Math.random() * this.textures.length);
            next.texture = this.textures[index];
            next = next.next;
        }
    }
}
$8d042d4853269042$var$RandomTextureBehavior.type = "textureRandom";
$8d042d4853269042$var$RandomTextureBehavior.editorConfig = null;
/**
 * A Rotation behavior that handles starting rotation, rotation speed, and rotational acceleration.
 *
 * Example configuration:
 * ```javascript
 * {
 *     "type": "rotation",
 *     "config": {
 *          "minStart": 0,
 *          "maxStart": 180,
 *          "minSpeed": 30,
 *          "maxSpeed": 45,
 *          "accel": 20
 *     }
 *}
 * ```
 */ class $8d042d4853269042$var$RotationBehavior {
    constructor(config){
        this.order = $8d042d4853269042$var$BehaviorOrder.Normal;
        this.minStart = config.minStart * $8d042d4853269042$var$DEG_TO_RADS;
        this.maxStart = config.maxStart * $8d042d4853269042$var$DEG_TO_RADS;
        this.minSpeed = config.minSpeed * $8d042d4853269042$var$DEG_TO_RADS;
        this.maxSpeed = config.maxSpeed * $8d042d4853269042$var$DEG_TO_RADS;
        this.accel = config.accel * $8d042d4853269042$var$DEG_TO_RADS;
    }
    initParticles(first) {
        let next = first;
        while(next){
            if (this.minStart === this.maxStart) next.rotation += this.maxStart;
            else next.rotation += Math.random() * (this.maxStart - this.minStart) + this.minStart;
            next.config.rotSpeed = Math.random() * (this.maxSpeed - this.minSpeed) + this.minSpeed;
            next = next.next;
        }
    }
    updateParticle(particle, deltaSec) {
        if (this.accel) {
            const oldSpeed = particle.config.rotSpeed;
            particle.config.rotSpeed += this.accel * deltaSec;
            particle.rotation += (particle.config.rotSpeed + oldSpeed) / 2 * deltaSec;
        } else particle.rotation += particle.config.rotSpeed * deltaSec;
    }
}
$8d042d4853269042$var$RotationBehavior.type = "rotation";
$8d042d4853269042$var$RotationBehavior.editorConfig = null;
/**
 * A Rotation behavior that handles starting rotation.
 *
 * Example configuration:
 * ```javascript
 * {
 *     "type": "rotationStatic",
 *     "config": {
 *          "min": 0,
 *          "max": 180,
 *     }
 *}
 * ```
 */ class $8d042d4853269042$var$StaticRotationBehavior {
    constructor(config){
        this.order = $8d042d4853269042$var$BehaviorOrder.Normal;
        this.min = config.min * $8d042d4853269042$var$DEG_TO_RADS;
        this.max = config.max * $8d042d4853269042$var$DEG_TO_RADS;
    }
    initParticles(first) {
        let next = first;
        while(next){
            if (this.min === this.max) next.rotation += this.max;
            else next.rotation += Math.random() * (this.max - this.min) + this.min;
            next = next.next;
        }
    }
}
$8d042d4853269042$var$StaticRotationBehavior.type = "rotationStatic";
$8d042d4853269042$var$StaticRotationBehavior.editorConfig = null;
/**
 * A Rotation behavior that blocks all rotation caused by spawn settings,
 * by resetting it to the specified rotation (or 0).
 *
 * Example configuration:
 * ```javascript
 * {
 *     "type": "noRotation",
 *     "config": {
 *          "rotation": 0
 *     }
 *}
 * ```
 */ class $8d042d4853269042$var$NoRotationBehavior {
    constructor(config){
        this.order = $8d042d4853269042$var$BehaviorOrder.Late + 1;
        this.rotation = (config.rotation || 0) * $8d042d4853269042$var$DEG_TO_RADS;
    }
    initParticles(first) {
        let next = first;
        while(next){
            next.rotation = this.rotation;
            next = next.next;
        }
    }
}
$8d042d4853269042$var$NoRotationBehavior.type = "noRotation";
$8d042d4853269042$var$NoRotationBehavior.editorConfig = null;
/**
 * A Scale behavior that applies an interpolated or stepped list of values to the particle's x & y scale.
 *
 * Example config:
 * ```javascript
 * {
 *     type: 'scale',
 *     config: {
 *          scale: {
 *              list: [{value: 0, time: 0}, {value: 1, time: 0.25}, {value: 0, time: 1}],
 *              isStepped: true
 *          },
 *          minMult: 0.5
 *     }
 * }
 * ```
 */ class $8d042d4853269042$var$ScaleBehavior {
    constructor(config){
        var _a;
        this.order = $8d042d4853269042$var$BehaviorOrder.Normal;
        this.list = new $8d042d4853269042$export$4e0d1ad7ad6a0802(false);
        this.list.reset($8d042d4853269042$export$c87c56924d182f24.createList(config.scale));
        this.minMult = (_a = config.minMult) !== null && _a !== void 0 ? _a : 1;
    }
    initParticles(first) {
        let next = first;
        while(next){
            const mult = Math.random() * (1 - this.minMult) + this.minMult;
            next.config.scaleMult = mult;
            next.scale.x = next.scale.y = this.list.first.value * mult;
            next = next.next;
        }
    }
    updateParticle(particle) {
        particle.scale.x = particle.scale.y = this.list.interpolate(particle.agePercent) * particle.config.scaleMult;
    }
}
$8d042d4853269042$var$ScaleBehavior.type = "scale";
$8d042d4853269042$var$ScaleBehavior.editorConfig = null;
/**
 * A Scale behavior that applies a randomly picked value to the particle's x & y scale at initialization.
 *
 * Example config:
 * ```javascript
 * {
 *     type: 'scaleStatic',
 *     config: {
 *         min: 0.25,
 *         max: 0.75,
 *     }
 * }
 * ```
 */ class $8d042d4853269042$var$StaticScaleBehavior {
    constructor(config){
        this.order = $8d042d4853269042$var$BehaviorOrder.Normal;
        this.min = config.min;
        this.max = config.max;
    }
    initParticles(first) {
        let next = first;
        while(next){
            const scale = Math.random() * (this.max - this.min) + this.min;
            next.scale.x = next.scale.y = scale;
            next = next.next;
        }
    }
}
$8d042d4853269042$var$StaticScaleBehavior.type = "scaleStatic";
$8d042d4853269042$var$StaticScaleBehavior.editorConfig = null;
/**
 * A Spawn behavior that places (and optionally rotates) particles according to a
 * specified shape. Additional shapes can be registered with {@link registerShape | SpawnShape.registerShape()}.
 * Additional shapes must implement the {@link SpawnShape} interface, and their class must match the
 * {@link SpawnShapeClass} interface.
 * Shapes included by default are:
 * * {@link Rectangle}
 * * {@link Torus}
 * * {@link PolygonalChain}
 *
 * Example config:
 * ```javascript
 * {
 *     type: 'spawnShape',
 *     config: {
 *          type: 'rect',
 *          data: {
 *              x: 0,
 *              y: 0,
 *              width: 20,
 *              height: 300,
 *          }
 *     }
 * }
 * ```
 */ class $8d042d4853269042$var$ShapeSpawnBehavior {
    constructor(config){
        this.order = $8d042d4853269042$var$BehaviorOrder.Spawn;
        const ShapeClass = $8d042d4853269042$var$ShapeSpawnBehavior.shapes[config.type];
        if (!ShapeClass) throw new Error(`No shape found with type '${config.type}'`);
        this.shape = new ShapeClass(config.data);
    }
    /**
     * Registers a shape to be used by the ShapeSpawn behavior.
     * @param constructor The shape class constructor to use, with a static `type` property to reference it by.
     * @param typeOverride An optional type override, primarily for registering a shape under multiple names.
     */ static registerShape(constructor, typeOverride) {
        $8d042d4853269042$var$ShapeSpawnBehavior.shapes[typeOverride || constructor.type] = constructor;
    }
    initParticles(first) {
        let next = first;
        while(next){
            this.shape.getRandPos(next);
            next = next.next;
        }
    }
}
$8d042d4853269042$var$ShapeSpawnBehavior.type = "spawnShape";
$8d042d4853269042$var$ShapeSpawnBehavior.editorConfig = null;
/**
 * Dictionary of all registered shape classes.
 */ $8d042d4853269042$var$ShapeSpawnBehavior.shapes = {};
$8d042d4853269042$var$ShapeSpawnBehavior.registerShape($8d042d4853269042$var$PolygonalChain);
$8d042d4853269042$var$ShapeSpawnBehavior.registerShape($8d042d4853269042$var$Rectangle);
$8d042d4853269042$var$ShapeSpawnBehavior.registerShape($8d042d4853269042$var$Torus);
$8d042d4853269042$var$ShapeSpawnBehavior.registerShape($8d042d4853269042$var$Torus, "circle");
/**
 * A Textuure behavior that assigns a single texture to each particle.
 * String values will be converted to textures with {@link ParticleUtils.GetTextureFromString}.
 *
 * Example config:
 * ```javascript
 * {
 *     type: 'textureSingle',
 *     config: {
 *         texture: Texture.from('myTexId'),
 *     }
 * }
 * ```
 */ class $8d042d4853269042$var$SingleTextureBehavior {
    constructor(config){
        this.order = $8d042d4853269042$var$BehaviorOrder.Normal;
        this.texture = typeof config.texture === "string" ? $8d042d4853269042$var$GetTextureFromString(config.texture) : config.texture;
    }
    initParticles(first) {
        let next = first;
        while(next){
            next.texture = this.texture;
            next = next.next;
        }
    }
}
$8d042d4853269042$var$SingleTextureBehavior.type = "textureSingle";
$8d042d4853269042$var$SingleTextureBehavior.editorConfig = null;
/**
 * A Movement behavior that uses an interpolated or stepped list of values for a particles speed at any given moment.
 * Movement direction is controlled by the particle's starting rotation.
 *
 * Example config:
 * ```javascript
 * {
 *     type: 'moveSpeed',
 *     config: {
 *          speed: {
 *              list: [{value: 10, time: 0}, {value: 100, time: 0.25}, {value: 0, time: 1}],
 *          },
 *          minMult: 0.8
 *     }
 * }
 * ```
 */ class $8d042d4853269042$var$SpeedBehavior {
    constructor(config){
        var _a;
        this.order = $8d042d4853269042$var$BehaviorOrder.Late;
        this.list = new $8d042d4853269042$export$4e0d1ad7ad6a0802(false);
        this.list.reset($8d042d4853269042$export$c87c56924d182f24.createList(config.speed));
        this.minMult = (_a = config.minMult) !== null && _a !== void 0 ? _a : 1;
    }
    initParticles(first) {
        let next = first;
        while(next){
            const mult = Math.random() * (1 - this.minMult) + this.minMult;
            next.config.speedMult = mult;
            if (!next.config.velocity) next.config.velocity = new (0, $cf3018b4309864c2$export$baf26146a414f24a)(this.list.first.value * mult, 0);
            else next.config.velocity.set(this.list.first.value * mult, 0);
            $8d042d4853269042$var$rotatePoint(next.rotation, next.config.velocity);
            next = next.next;
        }
    }
    updateParticle(particle, deltaSec) {
        const speed = this.list.interpolate(particle.agePercent) * particle.config.speedMult;
        const vel = particle.config.velocity;
        $8d042d4853269042$var$normalize(vel);
        $8d042d4853269042$var$scaleBy(vel, speed);
        particle.x += vel.x * deltaSec;
        particle.y += vel.y * deltaSec;
    }
}
$8d042d4853269042$var$SpeedBehavior.type = "moveSpeed";
$8d042d4853269042$var$SpeedBehavior.editorConfig = null;
/**
 * A Movement behavior that uses a randomly picked constant speed throughout a particle's lifetime.
 * Movement direction is controlled by the particle's starting rotation.
 *
 * Example config:
 * ```javascript
 * {
 *     type: 'moveSpeedStatic',
 *     config: {
 *          min: 100,
 *          max: 150
 *     }
 * }
 * ```
 */ class $8d042d4853269042$var$StaticSpeedBehavior {
    constructor(config){
        this.order = $8d042d4853269042$var$BehaviorOrder.Late;
        this.min = config.min;
        this.max = config.max;
    }
    initParticles(first) {
        let next = first;
        while(next){
            const speed = Math.random() * (this.max - this.min) + this.min;
            if (!next.config.velocity) next.config.velocity = new (0, $cf3018b4309864c2$export$baf26146a414f24a)(speed, 0);
            else next.config.velocity.set(speed, 0);
            $8d042d4853269042$var$rotatePoint(next.rotation, next.config.velocity);
            next = next.next;
        }
    }
    updateParticle(particle, deltaSec) {
        const velocity = particle.config.velocity;
        particle.x += velocity.x * deltaSec;
        particle.y += velocity.y * deltaSec;
    }
}
$8d042d4853269042$var$StaticSpeedBehavior.type = "moveSpeedStatic";
$8d042d4853269042$var$StaticSpeedBehavior.editorConfig = null;
// export support types for external use
var $8d042d4853269042$export$633dab6afbc6f609 = {
    __proto__: null,
    spawnShapes: $8d042d4853269042$var$index,
    editor: $8d042d4853269042$var$Types,
    get BehaviorOrder () {
        return $8d042d4853269042$var$BehaviorOrder;
    },
    AccelerationBehavior: $8d042d4853269042$var$AccelerationBehavior,
    AlphaBehavior: $8d042d4853269042$var$AlphaBehavior,
    StaticAlphaBehavior: $8d042d4853269042$var$StaticAlphaBehavior,
    RandomAnimatedTextureBehavior: $8d042d4853269042$var$RandomAnimatedTextureBehavior,
    SingleAnimatedTextureBehavior: $8d042d4853269042$var$SingleAnimatedTextureBehavior,
    BlendModeBehavior: $8d042d4853269042$var$BlendModeBehavior,
    BurstSpawnBehavior: $8d042d4853269042$var$BurstSpawnBehavior,
    ColorBehavior: $8d042d4853269042$var$ColorBehavior,
    StaticColorBehavior: $8d042d4853269042$var$StaticColorBehavior,
    OrderedTextureBehavior: $8d042d4853269042$var$OrderedTextureBehavior,
    PathBehavior: $8d042d4853269042$var$PathBehavior,
    PointSpawnBehavior: $8d042d4853269042$var$PointSpawnBehavior,
    RandomTextureBehavior: $8d042d4853269042$var$RandomTextureBehavior,
    RotationBehavior: $8d042d4853269042$var$RotationBehavior,
    StaticRotationBehavior: $8d042d4853269042$var$StaticRotationBehavior,
    NoRotationBehavior: $8d042d4853269042$var$NoRotationBehavior,
    ScaleBehavior: $8d042d4853269042$var$ScaleBehavior,
    StaticScaleBehavior: $8d042d4853269042$var$StaticScaleBehavior,
    ShapeSpawnBehavior: $8d042d4853269042$var$ShapeSpawnBehavior,
    SingleTextureBehavior: $8d042d4853269042$var$SingleTextureBehavior,
    SpeedBehavior: $8d042d4853269042$var$SpeedBehavior,
    StaticSpeedBehavior: $8d042d4853269042$var$StaticSpeedBehavior
};
/**
 * Converts emitter configuration from pre-5.0.0 library values into the current version.
 *
 * Example usage:
 * ```javascript
 * const emitter = new Emitter(myContainer, upgradeConfig(myOldConfig, [myTexture, myOtherTexture]));
 * ```
 * @param config The old emitter config to upgrade.
 * @param art The old art values as would have been passed into the Emitter constructor or `Emitter.init()`
 */ // eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
function $8d042d4853269042$export$d323910b637c58b8(config, art) {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t, _u, _v, _w;
    // just ensure we aren't given any V3 config data
    if ("behaviors" in config) return config;
    const out = {
        lifetime: config.lifetime,
        ease: config.ease,
        particlesPerWave: config.particlesPerWave,
        frequency: config.frequency,
        spawnChance: config.spawnChance,
        emitterLifetime: config.emitterLifetime,
        maxParticles: config.maxParticles,
        addAtBack: config.addAtBack,
        pos: config.pos,
        emit: config.emit,
        autoUpdate: config.autoUpdate,
        behaviors: []
    };
    // set up the alpha
    if (config.alpha) {
        if ("start" in config.alpha) {
            if (config.alpha.start === config.alpha.end) {
                if (config.alpha.start !== 1) out.behaviors.push({
                    type: "alphaStatic",
                    config: {
                        alpha: config.alpha.start
                    }
                });
            } else {
                const list = {
                    list: [
                        {
                            time: 0,
                            value: config.alpha.start
                        },
                        {
                            time: 1,
                            value: config.alpha.end
                        }
                    ]
                };
                out.behaviors.push({
                    type: "alpha",
                    config: {
                        alpha: list
                    }
                });
            }
        } else if (config.alpha.list.length === 1) {
            if (config.alpha.list[0].value !== 1) out.behaviors.push({
                type: "alphaStatic",
                config: {
                    alpha: config.alpha.list[0].value
                }
            });
        } else out.behaviors.push({
            type: "alpha",
            config: {
                alpha: config.alpha
            }
        });
    }
    // acceleration movement
    if (config.acceleration && (config.acceleration.x || config.acceleration.y)) {
        let minStart;
        let maxStart;
        if ("start" in config.speed) {
            minStart = config.speed.start * ((_a = config.speed.minimumSpeedMultiplier) !== null && _a !== void 0 ? _a : 1);
            maxStart = config.speed.start;
        } else {
            minStart = config.speed.list[0].value * ((_b = config.minimumSpeedMultiplier) !== null && _b !== void 0 ? _b : 1);
            maxStart = config.speed.list[0].value;
        }
        out.behaviors.push({
            type: "moveAcceleration",
            config: {
                accel: config.acceleration,
                minStart: minStart,
                maxStart: maxStart,
                rotate: !config.noRotation,
                maxSpeed: config.maxSpeed
            }
        });
    } else if ((_c = config.extraData) === null || _c === void 0 ? void 0 : _c.path) {
        let list;
        let mult;
        if ("start" in config.speed) {
            mult = (_d = config.speed.minimumSpeedMultiplier) !== null && _d !== void 0 ? _d : 1;
            if (config.speed.start === config.speed.end) list = {
                list: [
                    {
                        time: 0,
                        value: config.speed.start
                    }
                ]
            };
            else list = {
                list: [
                    {
                        time: 0,
                        value: config.speed.start
                    },
                    {
                        time: 1,
                        value: config.speed.end
                    }
                ]
            };
        } else {
            list = config.speed;
            mult = (_e = config.minimumSpeedMultiplier) !== null && _e !== void 0 ? _e : 1;
        }
        out.behaviors.push({
            type: "movePath",
            config: {
                path: config.extraData.path,
                speed: list,
                minMult: mult
            }
        });
    } else if (config.speed) {
        if ("start" in config.speed) {
            if (config.speed.start === config.speed.end) out.behaviors.push({
                type: "moveSpeedStatic",
                config: {
                    min: config.speed.start * ((_f = config.speed.minimumSpeedMultiplier) !== null && _f !== void 0 ? _f : 1),
                    max: config.speed.start
                }
            });
            else {
                const list = {
                    list: [
                        {
                            time: 0,
                            value: config.speed.start
                        },
                        {
                            time: 1,
                            value: config.speed.end
                        }
                    ]
                };
                out.behaviors.push({
                    type: "moveSpeed",
                    config: {
                        speed: list,
                        minMult: config.speed.minimumSpeedMultiplier
                    }
                });
            }
        } else if (config.speed.list.length === 1) out.behaviors.push({
            type: "moveSpeedStatic",
            config: {
                min: config.speed.list[0].value * ((_g = config.minimumSpeedMultiplier) !== null && _g !== void 0 ? _g : 1),
                max: config.speed.list[0].value
            }
        });
        else out.behaviors.push({
            type: "moveSpeed",
            config: {
                speed: config.speed,
                minMult: (_h = config.minimumSpeedMultiplier) !== null && _h !== void 0 ? _h : 1
            }
        });
    }
    // scale
    if (config.scale) {
        if ("start" in config.scale) {
            const mult = (_j = config.scale.minimumScaleMultiplier) !== null && _j !== void 0 ? _j : 1;
            if (config.scale.start === config.scale.end) out.behaviors.push({
                type: "scaleStatic",
                config: {
                    min: config.scale.start * mult,
                    max: config.scale.start
                }
            });
            else {
                const list = {
                    list: [
                        {
                            time: 0,
                            value: config.scale.start
                        },
                        {
                            time: 1,
                            value: config.scale.end
                        }
                    ]
                };
                out.behaviors.push({
                    type: "scale",
                    config: {
                        scale: list,
                        minMult: mult
                    }
                });
            }
        } else if (config.scale.list.length === 1) {
            const mult = (_k = config.minimumScaleMultiplier) !== null && _k !== void 0 ? _k : 1;
            const scale = config.scale.list[0].value;
            out.behaviors.push({
                type: "scaleStatic",
                config: {
                    min: scale * mult,
                    max: scale
                }
            });
        } else out.behaviors.push({
            type: "scale",
            config: {
                scale: config.scale,
                minMult: (_l = config.minimumScaleMultiplier) !== null && _l !== void 0 ? _l : 1
            }
        });
    }
    // color
    if (config.color) {
        if ("start" in config.color) {
            if (config.color.start === config.color.end) {
                if (config.color.start !== "ffffff") out.behaviors.push({
                    type: "colorStatic",
                    config: {
                        color: config.color.start
                    }
                });
            } else {
                const list = {
                    list: [
                        {
                            time: 0,
                            value: config.color.start
                        },
                        {
                            time: 1,
                            value: config.color.end
                        }
                    ]
                };
                out.behaviors.push({
                    type: "color",
                    config: {
                        color: list
                    }
                });
            }
        } else if (config.color.list.length === 1) {
            if (config.color.list[0].value !== "ffffff") out.behaviors.push({
                type: "colorStatic",
                config: {
                    color: config.color.list[0].value
                }
            });
        } else out.behaviors.push({
            type: "color",
            config: {
                color: config.color
            }
        });
    }
    // rotation
    if (config.rotationAcceleration || ((_m = config.rotationSpeed) === null || _m === void 0 ? void 0 : _m.min) || ((_o = config.rotationSpeed) === null || _o === void 0 ? void 0 : _o.max)) out.behaviors.push({
        type: "rotation",
        config: {
            accel: config.rotationAcceleration || 0,
            minSpeed: ((_p = config.rotationSpeed) === null || _p === void 0 ? void 0 : _p.min) || 0,
            maxSpeed: ((_q = config.rotationSpeed) === null || _q === void 0 ? void 0 : _q.max) || 0,
            minStart: ((_r = config.startRotation) === null || _r === void 0 ? void 0 : _r.min) || 0,
            maxStart: ((_s = config.startRotation) === null || _s === void 0 ? void 0 : _s.max) || 0
        }
    });
    else if (((_t = config.startRotation) === null || _t === void 0 ? void 0 : _t.min) || ((_u = config.startRotation) === null || _u === void 0 ? void 0 : _u.max)) out.behaviors.push({
        type: "rotationStatic",
        config: {
            min: ((_v = config.startRotation) === null || _v === void 0 ? void 0 : _v.min) || 0,
            max: ((_w = config.startRotation) === null || _w === void 0 ? void 0 : _w.max) || 0
        }
    });
    if (config.noRotation) out.behaviors.push({
        type: "noRotation",
        config: {}
    });
    // blend mode
    if (config.blendMode && config.blendMode !== "normal") out.behaviors.push({
        type: "blendMode",
        config: {
            blendMode: config.blendMode
        }
    });
    // animated
    if (Array.isArray(art) && typeof art[0] !== "string" && "framerate" in art[0]) {
        for(let i = 0; i < art.length; ++i)if (art[i].framerate === "matchLife") art[i].framerate = -1;
        out.behaviors.push({
            type: "animatedRandom",
            config: {
                anims: art
            }
        });
    } else if (typeof art !== "string" && "framerate" in art) {
        if (art.framerate === "matchLife") art.framerate = -1;
        out.behaviors.push({
            type: "animatedSingle",
            config: {
                anim: art
            }
        });
    } else if (config.orderedArt && Array.isArray(art)) out.behaviors.push({
        type: "textureOrdered",
        config: {
            textures: art
        }
    });
    else if (Array.isArray(art)) out.behaviors.push({
        type: "textureRandom",
        config: {
            textures: art
        }
    });
    else out.behaviors.push({
        type: "textureSingle",
        config: {
            texture: art
        }
    });
    // spawn burst
    if (config.spawnType === "burst") out.behaviors.push({
        type: "spawnBurst",
        config: {
            start: config.angleStart || 0,
            spacing: config.particleSpacing,
            // older formats bursted from a single point
            distance: 0
        }
    });
    else if (config.spawnType === "point") out.behaviors.push({
        type: "spawnPoint",
        config: {}
    });
    else {
        let shape;
        if (config.spawnType === "ring") shape = {
            type: "torus",
            data: {
                x: config.spawnCircle.x,
                y: config.spawnCircle.y,
                radius: config.spawnCircle.r,
                innerRadius: config.spawnCircle.minR,
                affectRotation: true
            }
        };
        else if (config.spawnType === "circle") shape = {
            type: "torus",
            data: {
                x: config.spawnCircle.x,
                y: config.spawnCircle.y,
                radius: config.spawnCircle.r,
                innerRadius: 0,
                affectRotation: false
            }
        };
        else if (config.spawnType === "rect") shape = {
            type: "rect",
            data: config.spawnRect
        };
        else if (config.spawnType === "polygonalChain") shape = {
            type: "polygonalChain",
            data: config.spawnPolygon
        };
        if (shape) out.behaviors.push({
            type: "spawnShape",
            config: shape
        });
    }
    return out;
}
/**
 * A semi-experimental Container that uses a doubly linked list to manage children instead of an
 * array. This means that adding/removing children often is not the same performance hit that
 * it would to be continually pushing/splicing.
 * However, this is primarily intended to be used for heavy particle usage, and may not handle
 * edge cases well if used as a complete Container replacement.
 */ class $8d042d4853269042$export$e1310c54113e40a9 extends (0, $68e6944de5989822$export$42a852a2b6b56249) {
    constructor(){
        super(...arguments);
        this._firstChild = null;
        this._lastChild = null;
        this._childCount = 0;
    }
    get firstChild() {
        return this._firstChild;
    }
    get lastChild() {
        return this._lastChild;
    }
    get childCount() {
        return this._childCount;
    }
    addChild(...children) {
        // if there is only one argument we can bypass looping through the them
        if (children.length > 1) // loop through the array and add all children
        for(let i = 0; i < children.length; i++)// eslint-disable-next-line prefer-rest-params
        this.addChild(children[i]);
        else {
            const child = children[0];
            // if the child has a parent then lets remove it as PixiJS objects can only exist in one place
            if (child.parent) child.parent.removeChild(child);
            child.parent = this;
            this.sortDirty = true;
            // ensure child transform will be recalculated
            child.transform._parentID = -1;
            // add to list if we have a list
            if (this._lastChild) {
                this._lastChild.nextChild = child;
                child.prevChild = this._lastChild;
                this._lastChild = child;
            } else this._firstChild = this._lastChild = child;
            // update child count
            ++this._childCount;
            // ensure bounds will be recalculated
            this._boundsID++;
            // TODO - lets either do all callbacks or all events.. not both!
            this.onChildrenChange();
            this.emit("childAdded", child, this, this._childCount);
            child.emit("added", this);
        }
        return children[0];
    }
    addChildAt(child, index) {
        if (index < 0 || index > this._childCount) throw new Error(`addChildAt: The index ${index} supplied is out of bounds ${this._childCount}`);
        if (child.parent) child.parent.removeChild(child);
        child.parent = this;
        this.sortDirty = true;
        // ensure child transform will be recalculated
        child.transform._parentID = -1;
        const c = child;
        // if no children, do basic initialization
        if (!this._firstChild) this._firstChild = this._lastChild = c;
        else if (index === 0) {
            this._firstChild.prevChild = c;
            c.nextChild = this._firstChild;
            this._firstChild = c;
        } else if (index === this._childCount) {
            this._lastChild.nextChild = c;
            c.prevChild = this._lastChild;
            this._lastChild = c;
        } else {
            let i = 0;
            let target = this._firstChild;
            while(i < index){
                target = target.nextChild;
                ++i;
            }
            // insert before the target that we found at the specified index
            target.prevChild.nextChild = c;
            c.prevChild = target.prevChild;
            c.nextChild = target;
            target.prevChild = c;
        }
        // update child count
        ++this._childCount;
        // ensure bounds will be recalculated
        this._boundsID++;
        // TODO - lets either do all callbacks or all events.. not both!
        this.onChildrenChange(index);
        child.emit("added", this);
        this.emit("childAdded", child, this, index);
        return child;
    }
    /**
     * Adds a child to the container to be rendered below another child.
     *
     * @param child The child to add
     * @param relative - The current child to add the new child relative to.
     * @return The child that was added.
     */ addChildBelow(child, relative) {
        if (relative.parent !== this) throw new Error(`addChildBelow: The relative target must be a child of this parent`);
        if (child.parent) child.parent.removeChild(child);
        child.parent = this;
        this.sortDirty = true;
        // ensure child transform will be recalculated
        child.transform._parentID = -1;
        // insert before the target that we were given
        relative.prevChild.nextChild = child;
        child.prevChild = relative.prevChild;
        child.nextChild = relative;
        relative.prevChild = child;
        if (this._firstChild === relative) this._firstChild = child;
        // update child count
        ++this._childCount;
        // ensure bounds will be recalculated
        this._boundsID++;
        // TODO - lets either do all callbacks or all events.. not both!
        this.onChildrenChange();
        this.emit("childAdded", child, this, this._childCount);
        child.emit("added", this);
        return child;
    }
    /**
     * Adds a child to the container to be rendered above another child.
     *
     * @param child The child to add
     * @param relative - The current child to add the new child relative to.
     * @return The child that was added.
     */ addChildAbove(child, relative) {
        if (relative.parent !== this) throw new Error(`addChildBelow: The relative target must be a child of this parent`);
        if (child.parent) child.parent.removeChild(child);
        child.parent = this;
        this.sortDirty = true;
        // ensure child transform will be recalculated
        child.transform._parentID = -1;
        // insert after the target that we were given
        relative.nextChild.prevChild = child;
        child.nextChild = relative.nextChild;
        child.prevChild = relative;
        relative.nextChild = child;
        if (this._lastChild === relative) this._lastChild = child;
        // update child count
        ++this._childCount;
        // ensure bounds will be recalculated
        this._boundsID++;
        // TODO - lets either do all callbacks or all events.. not both!
        this.onChildrenChange();
        this.emit("childAdded", child, this, this._childCount);
        child.emit("added", this);
        return child;
    }
    swapChildren(child, child2) {
        if (child === child2 || child.parent !== this || child2.parent !== this) return;
        const { prevChild: prevChild, nextChild: nextChild } = child;
        child.prevChild = child2.prevChild;
        child.nextChild = child2.nextChild;
        child2.prevChild = prevChild;
        child2.nextChild = nextChild;
        if (this._firstChild === child) this._firstChild = child2;
        else if (this._firstChild === child2) this._firstChild = child;
        if (this._lastChild === child) this._lastChild = child2;
        else if (this._lastChild === child2) this._lastChild = child;
        this.onChildrenChange();
    }
    getChildIndex(child) {
        let index = 0;
        let test = this._firstChild;
        while(test){
            if (test === child) break;
            test = test.nextChild;
            ++index;
        }
        if (!test) throw new Error("The supplied DisplayObject must be a child of the caller");
        return index;
    }
    setChildIndex(child, index) {
        if (index < 0 || index >= this._childCount) throw new Error(`The index ${index} supplied is out of bounds ${this._childCount}`);
        if (child.parent !== this) throw new Error("The supplied DisplayObject must be a child of the caller");
        // remove child
        if (child.nextChild) child.nextChild.prevChild = child.prevChild;
        if (child.prevChild) child.prevChild.nextChild = child.nextChild;
        if (this._firstChild === child) this._firstChild = child.nextChild;
        if (this._lastChild === child) this._lastChild = child.prevChild;
        child.nextChild = null;
        child.prevChild = null;
        // do addChildAt
        if (!this._firstChild) this._firstChild = this._lastChild = child;
        else if (index === 0) {
            this._firstChild.prevChild = child;
            child.nextChild = this._firstChild;
            this._firstChild = child;
        } else if (index === this._childCount) {
            this._lastChild.nextChild = child;
            child.prevChild = this._lastChild;
            this._lastChild = child;
        } else {
            let i = 0;
            let target = this._firstChild;
            while(i < index){
                target = target.nextChild;
                ++i;
            }
            target.prevChild.nextChild = child;
            child.prevChild = target.prevChild;
            child.nextChild = target;
            target.prevChild = child;
        }
        this.onChildrenChange(index);
    }
    removeChild(...children) {
        // if there is only one argument we can bypass looping through the them
        if (children.length > 1) // loop through the arguments property and remove all children
        for(let i = 0; i < children.length; i++)this.removeChild(children[i]);
        else {
            const child = children[0];
            // bail if not actually our child
            if (child.parent !== this) return null;
            child.parent = null;
            // ensure child transform will be recalculated
            child.transform._parentID = -1;
            // swap out child references
            if (child.nextChild) child.nextChild.prevChild = child.prevChild;
            if (child.prevChild) child.prevChild.nextChild = child.nextChild;
            if (this._firstChild === child) this._firstChild = child.nextChild;
            if (this._lastChild === child) this._lastChild = child.prevChild;
            // clear sibling references
            child.nextChild = null;
            child.prevChild = null;
            // update child count
            --this._childCount;
            // ensure bounds will be recalculated
            this._boundsID++;
            // TODO - lets either do all callbacks or all events.. not both!
            this.onChildrenChange();
            child.emit("removed", this);
            // eslint-disable-next-line @typescript-eslint/ban-ts-comment
            // @ts-ignore
            this.emit("childRemoved", child, this);
        }
        return children[0];
    }
    getChildAt(index) {
        if (index < 0 || index >= this._childCount) throw new Error(`getChildAt: Index (${index}) does not exist.`);
        if (index === 0) return this._firstChild;
        else if (index === this._childCount) return this._lastChild;
        // otherwise we have to start counting through the children to find the right one
        // - SLOW, only provided to fully support the possibility of use
        let i = 0;
        let target = this._firstChild;
        while(i < index){
            target = target.nextChild;
            ++i;
        }
        return target;
    }
    removeChildAt(index) {
        const child = this.getChildAt(index);
        // ensure child transform will be recalculated..
        child.parent = null;
        child.transform._parentID = -1;
        // swap out child references
        if (child.nextChild) child.nextChild.prevChild = child.prevChild;
        if (child.prevChild) child.prevChild.nextChild = child.nextChild;
        if (this._firstChild === child) this._firstChild = child.nextChild;
        if (this._lastChild === child) this._lastChild = child.prevChild;
        // clear sibling references
        child.nextChild = null;
        child.prevChild = null;
        // update child count
        --this._childCount;
        // ensure bounds will be recalculated
        this._boundsID++;
        // TODO - lets either do all callbacks or all events.. not both!
        this.onChildrenChange(index);
        child.emit("removed", this);
        this.emit("childRemoved", child, this, index);
        return child;
    }
    removeChildren(beginIndex = 0, endIndex = this._childCount) {
        const begin = beginIndex;
        // because Container.destroy() has removeChildren(0, this.children.count), assume that an end index of 0
        // should actually be _childCount.
        if (endIndex === 0 && this._childCount > 0) endIndex = this._childCount;
        const end = endIndex;
        const range = end - begin;
        if (range > 0 && range <= end) {
            const removed = [];
            let child = this._firstChild;
            for(let i = 0; i <= end && child; ++i, child = child.nextChild)if (i >= begin) removed.push(child);
            // child before removed section
            const prevChild = removed[0].prevChild;
            // child after removed section
            const nextChild = removed[removed.length - 1].nextChild;
            if (!nextChild) // if we removed the last child, then the new last child is the one before
            // the removed section
            this._lastChild = prevChild;
            else // otherwise, stitch the child before the section to the child after
            nextChild.prevChild = prevChild;
            if (!prevChild) // if we removed the first child, then the new first child is the one after
            // the removed section
            this._firstChild = nextChild;
            else // otherwise stich the child after the section to the one before
            prevChild.nextChild = nextChild;
            for(let i = 0; i < removed.length; ++i){
                // clear parenting and sibling references for all removed children
                removed[i].parent = null;
                if (removed[i].transform) removed[i].transform._parentID = -1;
                removed[i].nextChild = null;
                removed[i].prevChild = null;
            }
            this._boundsID++;
            this.onChildrenChange(beginIndex);
            for(let i = 0; i < removed.length; ++i){
                removed[i].emit("removed", this);
                this.emit("childRemoved", removed[i], this, i);
            }
            return removed;
        } else if (range === 0 && this._childCount === 0) return [];
        throw new RangeError("removeChildren: numeric values are outside the acceptable range.");
    }
    /**
     * Updates the transform on all children of this container for rendering.
     * Copied from and overrides PixiJS v5 method (v4 method is identical)
     */ updateTransform() {
        this._boundsID++;
        this.transform.updateTransform(this.parent.transform);
        // TODO: check render flags, how to process stuff here
        this.worldAlpha = this.alpha * this.parent.worldAlpha;
        let child;
        let next;
        for(child = this._firstChild; child; child = next){
            next = child.nextChild;
            if (child.visible) child.updateTransform();
        }
    }
    /**
     * Recalculates the bounds of the container.
     * Copied from and overrides PixiJS v5 method (v4 method is identical)
     */ calculateBounds() {
        this._bounds.clear();
        this._calculateBounds();
        let child;
        let next;
        for(child = this._firstChild; child; child = next){
            next = child.nextChild;
            if (!child.visible || !child.renderable) continue;
            child.calculateBounds();
            // TODO: filter+mask, need to mask both somehow
            if (child._mask) {
                const maskObject = child._mask.maskObject || child._mask;
                maskObject.calculateBounds();
                this._bounds.addBoundsMask(child._bounds, maskObject._bounds);
            } else if (child.filterArea) this._bounds.addBoundsArea(child._bounds, child.filterArea);
            else this._bounds.addBounds(child._bounds);
        }
        this._bounds.updateID = this._boundsID;
    }
    /**
     * Retrieves the local bounds of the displayObject as a rectangle object. Copied from and overrides PixiJS v5 method
     */ getLocalBounds(rect, skipChildrenUpdate = false) {
        // skip Container's getLocalBounds, go directly to DisplayObject
        const result = (0, $469c1c392031bfb3$export$1f679544f90d7d7c).prototype.getLocalBounds.call(this, rect);
        if (!skipChildrenUpdate) {
            let child;
            let next;
            for(child = this._firstChild; child; child = next){
                next = child.nextChild;
                if (child.visible) child.updateTransform();
            }
        }
        return result;
    }
    /**
     * Renders the object using the WebGL renderer. Copied from and overrides PixiJS v5 method
     */ render(renderer) {
        // if the object is not visible or the alpha is 0 then no need to render this element
        if (!this.visible || this.worldAlpha <= 0 || !this.renderable) return;
        // do a quick check to see if this element has a mask or a filter.
        if (this._mask || this.filters && this.filters.length) this.renderAdvanced(renderer);
        else {
            this._render(renderer);
            let child;
            let next;
            // simple render children!
            for(child = this._firstChild; child; child = next){
                next = child.nextChild;
                child.render(renderer);
            }
        }
    }
    /**
     * Render the object using the WebGL renderer and advanced features. Copied from and overrides PixiJS v5 method
     */ renderAdvanced(renderer) {
        renderer.batch.flush();
        const filters = this.filters;
        const mask = this._mask;
        // _enabledFilters note: As of development, _enabledFilters is not documented in pixi.js
        // types but is in code of current release (5.2.4).
        // push filter first as we need to ensure the stencil buffer is correct for any masking
        if (filters) {
            if (!this._enabledFilters) this._enabledFilters = [];
            this._enabledFilters.length = 0;
            for(let i = 0; i < filters.length; i++)if (filters[i].enabled) this._enabledFilters.push(filters[i]);
            if (this._enabledFilters.length) renderer.filter.push(this, this._enabledFilters);
        }
        if (mask) renderer.mask.push(this, this._mask);
        // add this object to the batch, only rendered if it has a texture.
        this._render(renderer);
        let child;
        let next;
        // now loop through the children and make sure they get rendered
        for(child = this._firstChild; child; child = next){
            next = child.nextChild;
            child.render(renderer);
        }
        renderer.batch.flush();
        if (mask) renderer.mask.pop(this);
        if (filters && this._enabledFilters && this._enabledFilters.length) renderer.filter.pop();
    }
    /**
     * Renders the object using the Canvas renderer. Copied from and overrides PixiJS Canvas mixin in V5 and V6.
     */ // eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
    renderCanvas(renderer) {
        // if not visible or the alpha is 0 then no need to render this
        if (!this.visible || this.worldAlpha <= 0 || !this.renderable) return;
        if (this._mask) renderer.maskManager.pushMask(this._mask);
        this._renderCanvas(renderer);
        let child;
        let next;
        for(child = this._firstChild; child; child = next){
            next = child.nextChild;
            child.renderCanvas(renderer);
        }
        if (this._mask) renderer.maskManager.popMask(renderer);
    }
}
$8d042d4853269042$export$4293555f241ae35a.registerBehavior($8d042d4853269042$var$AccelerationBehavior);
$8d042d4853269042$export$4293555f241ae35a.registerBehavior($8d042d4853269042$var$AlphaBehavior);
$8d042d4853269042$export$4293555f241ae35a.registerBehavior($8d042d4853269042$var$StaticAlphaBehavior);
$8d042d4853269042$export$4293555f241ae35a.registerBehavior($8d042d4853269042$var$RandomAnimatedTextureBehavior);
$8d042d4853269042$export$4293555f241ae35a.registerBehavior($8d042d4853269042$var$SingleAnimatedTextureBehavior);
$8d042d4853269042$export$4293555f241ae35a.registerBehavior($8d042d4853269042$var$BlendModeBehavior);
$8d042d4853269042$export$4293555f241ae35a.registerBehavior($8d042d4853269042$var$BurstSpawnBehavior);
$8d042d4853269042$export$4293555f241ae35a.registerBehavior($8d042d4853269042$var$ColorBehavior);
$8d042d4853269042$export$4293555f241ae35a.registerBehavior($8d042d4853269042$var$StaticColorBehavior);
$8d042d4853269042$export$4293555f241ae35a.registerBehavior($8d042d4853269042$var$OrderedTextureBehavior);
$8d042d4853269042$export$4293555f241ae35a.registerBehavior($8d042d4853269042$var$PathBehavior);
$8d042d4853269042$export$4293555f241ae35a.registerBehavior($8d042d4853269042$var$PointSpawnBehavior);
$8d042d4853269042$export$4293555f241ae35a.registerBehavior($8d042d4853269042$var$RandomTextureBehavior);
$8d042d4853269042$export$4293555f241ae35a.registerBehavior($8d042d4853269042$var$RotationBehavior);
$8d042d4853269042$export$4293555f241ae35a.registerBehavior($8d042d4853269042$var$StaticRotationBehavior);
$8d042d4853269042$export$4293555f241ae35a.registerBehavior($8d042d4853269042$var$NoRotationBehavior);
$8d042d4853269042$export$4293555f241ae35a.registerBehavior($8d042d4853269042$var$ScaleBehavior);
$8d042d4853269042$export$4293555f241ae35a.registerBehavior($8d042d4853269042$var$StaticScaleBehavior);
$8d042d4853269042$export$4293555f241ae35a.registerBehavior($8d042d4853269042$var$ShapeSpawnBehavior);
$8d042d4853269042$export$4293555f241ae35a.registerBehavior($8d042d4853269042$var$SingleTextureBehavior);
$8d042d4853269042$export$4293555f241ae35a.registerBehavior($8d042d4853269042$var$SpeedBehavior);
$8d042d4853269042$export$4293555f241ae35a.registerBehavior($8d042d4853269042$var$StaticSpeedBehavior);


const $1d09b31ec7c46785$export$ac29247a87680f97 = (container, x, y, textures)=>{
    //const triangle = new Graphics()
    //  .beginFill(0xe8e8e8)
    //  .drawPolygon(x, y, x - 100 * ratio, y - 200 * ratio, x + 100 * ratio, y - 200 * ratio)
    //  .endFill()
    //container.addChild(triangle)
    return new (0, $8d042d4853269042$export$4293555f241ae35a)(container, {
        lifetime: {
            min: 0.2,
            max: 0.48
        },
        frequency: 0.0005,
        maxParticles: 3000,
        addAtBack: false,
        pos: {
            x: x,
            y: y
        },
        behaviors: [
            {
                type: "alpha",
                config: {
                    alpha: {
                        list: [
                            {
                                time: 0,
                                value: 0.62
                            },
                            {
                                time: 1,
                                value: 0
                            }
                        ]
                    }
                }
            },
            {
                type: "moveSpeedStatic",
                config: {
                    min: 500,
                    max: 750
                }
            },
            {
                type: "scale",
                config: {
                    scale: {
                        list: [
                            {
                                time: 0,
                                value: 0.5
                            },
                            {
                                time: 1,
                                value: 0.75
                            }
                        ]
                    },
                    minMult: 1
                }
            },
            {
                type: "color",
                config: {
                    color: {
                        list: [
                            {
                                time: 0,
                                value: "fff191"
                            },
                            {
                                time: 1,
                                value: "ff622c"
                            }
                        ]
                    }
                }
            },
            {
                type: "rotation",
                config: {
                    accel: 0,
                    minSpeed: 50,
                    maxSpeed: 200,
                    minStart: 74,
                    maxStart: 105
                }
            },
            {
                type: "textureRandom",
                config: {
                    textures: textures
                }
            },
            //{
            //  type: 'spawnBurst',
            //  config: {
            //    spacing: 5,
            //    start: 0,
            //    distance: 1,
            //  }
            //},
            {
                type: "spawnShape",
                config: {
                    type: "torus",
                    data: {
                        x: 0,
                        y: 0,
                        radius: 10,
                        innerRadius: 0,
                        affectRotation: false
                    }
                }
            }
        ]
    });
};


let $2ae84a41eb5f30ec$export$8e361a1ffbebf172 = {
    loading: false,
    exited: false,
    orientation: {},
    references: {
        bullets: new Map(),
        guns: new Map(),
        items: new Map(),
        monsters: new Map(),
        skills: new Map(),
        players: new Map(),
        particles: new Map(),
        ui: {
            level: {
                auras: new Map(),
                healthBars: new Map(),
                shootingBars: new Map(),
                usernames: new Map(),
                aoe: new Map(),
                pointers: new Map(),
                revives: new Map(),
                shadows: new Map(),
                waitingDots: new Map(),
                icecube: new Map(),
                teamView: new Map(),
                countdowns: [],
                sticks: {}
            }
        }
    },
    latency: {
        pingTime: 0,
        history: []
    },
    external: {
        getSessionToken: ()=>undefined
    }
};
const $2ae84a41eb5f30ec$export$efbfeda1e6657cf0 = ()=>{
    $2ae84a41eb5f30ec$export$8e361a1ffbebf172 = {
        ...$2ae84a41eb5f30ec$export$8e361a1ffbebf172,
        loading: false,
        exited: false,
        orientation: {},
        references: {
            bullets: new Map(),
            guns: new Map(),
            items: new Map(),
            monsters: new Map(),
            skills: new Map(),
            players: new Map(),
            particles: new Map(),
            ui: {
                level: {
                    auras: new Map(),
                    aoe: new Map(),
                    usernames: new Map(),
                    healthBars: new Map(),
                    shootingBars: new Map(),
                    pointers: new Map(),
                    revives: new Map(),
                    shadows: new Map(),
                    waitingDots: new Map(),
                    icecube: new Map(),
                    teamView: new Map(),
                    countdowns: [],
                    sticks: {}
                }
            }
        },
        latency: {
            pingTime: 0,
            history: []
        }
    };
};




const $08054706be28954e$export$5082664ed3e64ee8 = (x1, y1, x2, y2)=>Math.sqrt((x1 - x2) ** 2 + (y1 - y2) ** 2);
const $08054706be28954e$export$3922d1ccb8631cd8 = (from, to, x, y, r0, r1, width, height)=>{
    const c = document.createElement("canvas");
    c.width = width;
    c.height = height;
    const ctx = c.getContext("2d");
    const grd = ctx.createRadialGradient(x, y, r0, x, y, r1);
    grd.addColorStop(0, from);
    grd.addColorStop(0.8, to);
    ctx.fillStyle = grd;
    ctx.fillRect(0, 0, width, height);
    return (0, $14896914ad3ae15d$export$5431306cf43de24a).from(c);
};
const $08054706be28954e$export$46def8197cf4dd4c = (from, to, x1, y1, x2, y2, width, height)=>{
    const c = document.createElement("canvas");
    c.width = width;
    c.height = height;
    const ctx = c.getContext("2d");
    const grd = ctx.createLinearGradient(x1, y1, x2, y2);
    grd.addColorStop(0, from);
    grd.addColorStop(1, to);
    ctx.fillStyle = grd;
    ctx.fillRect(0, 0, width, height);
    return (0, $14896914ad3ae15d$export$5431306cf43de24a).from(c);
};
const $08054706be28954e$export$d4967e94c672b608 = (width, height, gap, backgroundColor, barColor, rounded)=>{
    let background;
    if (rounded) background = new (0, $48ce8a7de6645907$export$29d3e417456abdad)().beginFill(backgroundColor).drawRoundedRect(0, 0, width, height, height).endFill();
    else background = new (0, $48ce8a7de6645907$export$29d3e417456abdad)().beginFill(backgroundColor).drawRect(0, 0, width, height).endFill();
    background.cacheAsBitmap = true;
    let bar;
    if (rounded) bar = new (0, $48ce8a7de6645907$export$29d3e417456abdad)().beginFill(barColor).drawRoundedRect(width / 2 + gap, gap, width - 2 * gap, height - 2 * gap, height).endFill();
    else bar = new (0, $48ce8a7de6645907$export$29d3e417456abdad)().beginFill(barColor).drawRect(width / 2 + gap, gap, width - 2 * gap, height - 2 * gap).endFill();
    bar.pivot.set(width / 2 + gap, 0);
    bar.x = gap;
    const container = new (0, $68e6944de5989822$export$42a852a2b6b56249)();
    container.addChild(background, bar);
    return {
        container: container,
        background: background,
        bar: bar
    };
};
const $08054706be28954e$export$c9fcf1a7df975d78 = (degrees)=>degrees * (Math.PI / 180);
const $08054706be28954e$export$c41dd2a8460d3196 = (radians)=>radians * (180 / Math.PI);
const $08054706be28954e$export$b402ad477cba9c4a = ()=>$08054706be28954e$export$e692ebd4cea17cf3() / 480;
const $08054706be28954e$export$c1e6623c5820660e = ()=>$08054706be28954e$export$4e851fc33b36a5f0() / 969;
const $08054706be28954e$export$e692ebd4cea17cf3 = ()=>{
    if (!(0, $2ae84a41eb5f30ec$export$8e361a1ffbebf172).app) return 0;
    return (0, $2ae84a41eb5f30ec$export$8e361a1ffbebf172).app.view.parentNode.offsetWidth;
};
const $08054706be28954e$export$4e851fc33b36a5f0 = ()=>{
    if (!(0, $2ae84a41eb5f30ec$export$8e361a1ffbebf172).app) return 0;
    return (0, $2ae84a41eb5f30ec$export$8e361a1ffbebf172).app.view.parentNode.offsetHeight;
};
const $08054706be28954e$export$afd58ae2e5ad6fa2 = (x1, y1, x2, y2)=>{
    return -Math.atan2(x2 - x1, y2 - y1) + Math.PI / 2;
};
const $08054706be28954e$export$7777bc9cf3a47d2c = (element, data, delta)=>{
    const { x: x, y: y } = element;
    const { x: newX, y: newY } = data;
    const { dx: dx, dy: dy } = data;
    let computedX = x + dx * delta;
    let computedY = y + dy * delta;
    const differenceX = newX - computedX;
    const differenceY = newY - computedY;
    computedX += differenceX * delta;
    computedY += differenceY * delta;
    return {
        computedX: computedX,
        computedY: computedY
    };
};
const $08054706be28954e$export$8440e95db1cffa85 = (a, b)=>{
    let dx = a.x - b.x;
    let dy = a.y - b.y;
    const dist = Math.hypot(dx, dy);
    dx /= dist;
    dy /= dist;
    return {
        dx: dx,
        dy: dy
    };
};


const $01e69bafe2fbba11$export$8d529c6207f87a36 = (playerSchema)=>{
    if (!(0, $2ae84a41eb5f30ec$export$8e361a1ffbebf172).viewport || !(0, $2ae84a41eb5f30ec$export$8e361a1ffbebf172).resources) return;
    const playerSpine = new (0, $784388461c50e8a6$export$ce0a100797286aea)((0, $2ae84a41eb5f30ec$export$8e361a1ffbebf172).resources.player.spineData);
    const skinCombined = new (0, $e029b89e8e37c790$export$b8e0f93a76772233)("combined");
    if (playerSchema.cosmetics.outfits) {
        const outfits = playerSpine.skeleton.data.findSkin(`OUTFITS/${playerSchema.cosmetics.outfits}`);
        if (outfits) skinCombined.addSkin(outfits);
    } else {
        if (playerSchema.cosmetics.eyes) {
            const eyes = playerSpine.skeleton.data.findSkin(`EYES/${playerSchema.cosmetics.eyes}`);
            if (eyes) skinCombined.addSkin(eyes);
        }
        if (playerSchema.cosmetics.head) {
            const head = playerSpine.skeleton.data.findSkin(`HEAD/${playerSchema.cosmetics.head}`);
            if (head) skinCombined.addSkin(head);
        }
        if (playerSchema.cosmetics.top) {
            const top = playerSpine.skeleton.data.findSkin(`TOP/${playerSchema.cosmetics.top}`);
            if (top) skinCombined.addSkin(top);
        }
        if (playerSchema.cosmetics.mouth) {
            const mouth = playerSpine.skeleton.data.findSkin(`MOUTH/${playerSchema.cosmetics.mouth}`);
            if (mouth) skinCombined.addSkin(mouth);
        }
    }
    if (playerSchema.cosmetics.fur) {
        const fur = playerSpine.skeleton.data.findSkin(`FUR/${playerSchema.cosmetics.fur ?? "ORANGE"}`);
        if (playerSchema.cosmetics.outfits) {
            fur.removeAttachment(10, "FUR/DARK/LEFT HAND");
            fur.removeAttachment(11, "FUR/DARK/LEFT HAND");
            if ([
                "ANDY",
                "BRYAN",
                "JUSTIN"
            ].includes(playerSchema.cosmetics.outfits)) {
                fur.removeAttachment(16, "Pink/Pink_back ear");
                fur.removeAttachment(20, "Pink/Pink_front ear");
            }
        }
        if (fur) skinCombined.addSkin(fur);
    }
    playerSpine.skeleton.setSkin(skinCombined);
    const ratio = Math.min(playerSchema.width / playerSpine.width, playerSchema.height / playerSpine.height);
    playerSpine.scale.set(ratio, ratio);
    playerSpine.position.set(playerSchema.x + playerSchema.width / 2, playerSchema.y + playerSpine.height);
    playerSpine.state.setAnimation(0, "IDLE", true);
    (0, $2ae84a41eb5f30ec$export$8e361a1ffbebf172).references.players.set(playerSchema.clientId, {
        element: playerSpine,
        lastShootingTime: Date.now(),
        schema: playerSchema
    });
    playerSpine.zIndex = 12;
    //setTimeout(() => {
    //  const graphic = new Graphics()
    //    .beginFill(0xff0000).drawRect(playerSchema.x, playerSchema.y, playerSchema.width, playerSchema.height).endFill()
    //    .beginFill(0x00ff00).drawRect(playerSchema.x + playerSchema.boundingX, playerSchema.y + playerSchema.boundingY, playerSchema.boundingWidth, playerSchema.boundingHeight).endFill()
    //  graphic.zIndex = 12
    //  gameState.viewport!.addChild(graphic)
    //}, 2000)
    const width = playerSpine.width * 0.8;
    const height = 12;
    const gap = 3;
    const { container: healthContainer, bar: healthBar } = (0, $08054706be28954e$export$d4967e94c672b608)(width, height, gap, 0x111111, playerSchema.color === "#000000" ? 0x33ff33 : parseInt(playerSchema.color.replace(/^#/, ""), 16));
    healthContainer.position.set(playerSpine.x - width / 2, playerSpine.y);
    healthContainer.zIndex = 12;
    (0, $2ae84a41eb5f30ec$export$8e361a1ffbebf172).viewport.addChild(healthContainer);
    (0, $2ae84a41eb5f30ec$export$8e361a1ffbebf172).references.ui.level.healthBars.set(playerSchema.clientId, {
        container: healthContainer,
        bar: healthBar
    });
    if (playerSchema.clientId === (0, $2ae84a41eb5f30ec$export$8e361a1ffbebf172).level?.state.localPlayer.clientId) {
        const { container: shootingContainer, bar: shootingBar } = (0, $08054706be28954e$export$d4967e94c672b608)(width, 9, gap, 0x111111, 0xffb266);
        shootingContainer.position.set(healthContainer.x, healthContainer.y + height - gap);
        shootingContainer.zIndex = 12;
        (0, $2ae84a41eb5f30ec$export$8e361a1ffbebf172).viewport.addChild(shootingContainer);
        (0, $2ae84a41eb5f30ec$export$8e361a1ffbebf172).references.ui.level.shootingBars.set(playerSchema.clientId, {
            container: shootingContainer,
            bar: shootingBar
        });
    }
    // Username
    const style = new (0, $3d453260a3c8e0f7$export$1df879243bf2e42d)({
        fontFamily: "Supersonic Rocketship",
        fontWeight: "400",
        letterSpacing: 3,
        fill: 0xffffff,
        fontSize: Math.min(Math.max(12, 6 * (0, $08054706be28954e$export$b402ad477cba9c4a)()), 14),
        dropShadow: true,
        dropShadowDistance: 2,
        dropShadowColor: 0x000000,
        dropShadowAlpha: 0.9,
        dropShadowAngle: 1.5,
        align: "center",
        stroke: 0x000000,
        strokeThickness: 1
    });
    const username = new (0, $f4ede730be703e5d$export$5f1af8db9871e1d6)(playerSchema.name.slice(0, 12), style);
    const metrics = (0, $31f48a8131702733$export$4c5a129a59e1ef34).measureText(username.text, username.style);
    username.style = style;
    username.x = playerSpine.x - metrics.width / 2;
    username.y = playerSpine.y - playerSpine.height - metrics.height;
    username.alpha = 0.5;
    username.zIndex = Number.MAX_SAFE_INTEGER - 10;
    (0, $2ae84a41eb5f30ec$export$8e361a1ffbebf172).references.ui.level.usernames.set(playerSchema.clientId, username);
    // Pointer
    if (playerSchema.clientId !== (0, $2ae84a41eb5f30ec$export$8e361a1ffbebf172).level?.state.localPlayer.clientId) {
        const pointer = new (0, $48ce8a7de6645907$export$29d3e417456abdad)().beginFill(playerSchema.color).lineStyle({
            width: Math.min(2, 1 * (0, $08054706be28954e$export$b402ad477cba9c4a)()),
            color: 0x000000
        }).moveTo(-10, 10).lineTo(10, 0).lineTo(-10, -10).closePath().endFill();
        pointer.zIndex = Number.MAX_SAFE_INTEGER - 6;
        (0, $2ae84a41eb5f30ec$export$8e361a1ffbebf172).references.ui.level.pointers.set(playerSchema.clientId, pointer);
        (0, $2ae84a41eb5f30ec$export$8e361a1ffbebf172).viewport.addChild(pointer);
    }
    // Shadow
    const shadow = new (0, $48ce8a7de6645907$export$29d3e417456abdad)().beginFill(0xffffff).drawEllipse(0, 0, playerSpine.width * 1.4 * ratio, playerSpine.width * ratio * 1.4 / 4).endFill();
    shadow.tint = playerSchema.color;
    shadow.alpha = 0.4;
    shadow.zIndex = 11;
    shadow.position.set(playerSpine.x, playerSpine.y);
    (0, $2ae84a41eb5f30ec$export$8e361a1ffbebf172).references.ui.level.shadows.set(playerSchema.clientId, shadow);
    (0, $2ae84a41eb5f30ec$export$8e361a1ffbebf172).viewport.addChild(shadow);
    // GUN
    const gunSpine = new (0, $784388461c50e8a6$export$ce0a100797286aea)((0, $2ae84a41eb5f30ec$export$8e361a1ffbebf172).resources.gun.spineData);
    gunSpine.skeleton.setSkinByName(`GUN/${playerSchema.weapon.type.toUpperCase()}`);
    gunSpine.state.setAnimation(0, "GUN_IDLE", true);
    switch(playerSchema.weapon.type){
        case (0, $49736469f58fc92b$export$a0b1da4b3d9a7c29).MachineGun:
        case (0, $49736469f58fc92b$export$a0b1da4b3d9a7c29).CommonBlaster:
        case (0, $49736469f58fc92b$export$a0b1da4b3d9a7c29).EpicBlaster:
        case (0, $49736469f58fc92b$export$a0b1da4b3d9a7c29).FabledBlaster:
        case (0, $49736469f58fc92b$export$a0b1da4b3d9a7c29).GanAutoRifle:
        case (0, $49736469f58fc92b$export$a0b1da4b3d9a7c29).Shotgun:
            gunSpine.pivot.y -= 67.7;
            break;
        case (0, $49736469f58fc92b$export$a0b1da4b3d9a7c29).XMAS23:
            gunSpine.pivot.y -= 80;
            break;
        case (0, $49736469f58fc92b$export$a0b1da4b3d9a7c29).Carrot:
            gunSpine.pivot.y -= 90;
            break;
        case (0, $49736469f58fc92b$export$a0b1da4b3d9a7c29).Flamethrower:
            gunSpine.pivot.y -= 50;
            break;
        case (0, $49736469f58fc92b$export$a0b1da4b3d9a7c29).NinjaStar:
            gunSpine.pivot.x = 0;
            gunSpine.pivot.y = 0;
            break;
    }
    if (playerSchema.weapon.type === (0, $49736469f58fc92b$export$a0b1da4b3d9a7c29).Flamethrower) {
        const particlesContainer = new (0, $68e6944de5989822$export$42a852a2b6b56249)();
        particlesContainer.zIndex = 95;
        (0, $2ae84a41eb5f30ec$export$8e361a1ffbebf172).viewport.addChild(particlesContainer);
        const emitter = (0, $1d09b31ec7c46785$export$ac29247a87680f97)(particlesContainer, 0, 50, [
            (0, $2ae84a41eb5f30ec$export$8e361a1ffbebf172).resources.fireParticle,
            (0, $2ae84a41eb5f30ec$export$8e361a1ffbebf172).resources.circleParticle
        ]);
        emitter.rotate(-Math.PI / 2 - 0.1);
        emitter.playOnceAndDestroy();
        (0, $2ae84a41eb5f30ec$export$8e361a1ffbebf172).references.particles.set(playerSchema.clientId, {
            container: particlesContainer,
            emitter: emitter
        });
    }
    gunSpine.position.set(playerSpine.x, playerSpine.y);
    gunSpine.scale.set(playerSpine.scale.x, playerSpine.scale.y);
    gunSpine.zIndex = 13;
    (0, $2ae84a41eb5f30ec$export$8e361a1ffbebf172).references.guns.set(playerSchema.clientId, gunSpine);
    (0, $2ae84a41eb5f30ec$export$8e361a1ffbebf172).viewport.addChild(playerSpine, gunSpine, username);
    if (playerSchema.clientId === (0, $2ae84a41eb5f30ec$export$8e361a1ffbebf172).level?.state.localPlayer.clientId) (0, $2ae84a41eb5f30ec$export$8e361a1ffbebf172).viewport.follow(playerSpine);
    return {
        playerSpine: playerSpine,
        gunSpine: gunSpine
    };
};
const $01e69bafe2fbba11$export$b92f1b9d5073a87b = (delta)=>{
    if ((0, $2ae84a41eb5f30ec$export$8e361a1ffbebf172).level?.state.ended) return;
    (0, $2ae84a41eb5f30ec$export$8e361a1ffbebf172).references.players.forEach((player, clientId)=>{
        if (!(0, $2ae84a41eb5f30ec$export$8e361a1ffbebf172).level) return;
        const playerSpine = player?.element;
        const gunSpine = (0, $2ae84a41eb5f30ec$export$8e361a1ffbebf172).references.guns.get(clientId);
        const username = (0, $2ae84a41eb5f30ec$export$8e361a1ffbebf172).references.ui.level.usernames.get(clientId);
        if (!playerSpine || !gunSpine || !username) return;
        // Username
        if (player.schema.life <= 0 || player.schema.dead) {
            username.x = playerSpine.x - username.width / 2 - playerSpine.height * 0.4;
            username.y = playerSpine.y - playerSpine.width / 2 - username.height;
        } else {
            username.x = playerSpine.x - username.width / 2;
            username.y = playerSpine.y - playerSpine.height - username.height;
        }
        // POINTERS
        if (player.schema.clientId === (0, $2ae84a41eb5f30ec$export$8e361a1ffbebf172).level.state.localPlayer.clientId) (0, $2ae84a41eb5f30ec$export$8e361a1ffbebf172).references.players.forEach((currentPlayer)=>{
            if (!currentPlayer) return;
            const pointer = (0, $2ae84a41eb5f30ec$export$8e361a1ffbebf172).references.ui.level.pointers.get(currentPlayer.schema.clientId);
            if (currentPlayer.schema.dead && pointer) {
                (0, $2ae84a41eb5f30ec$export$8e361a1ffbebf172).references.ui.level.pointers.delete(currentPlayer.schema.clientId);
                pointer.destroy();
                return;
            }
            if (currentPlayer.schema.clientId === player.schema.clientId || !pointer) return;
            const coords = {
                x: currentPlayer.element.x,
                y: currentPlayer.element.y
            };
            if (currentPlayer.schema.life <= 0) {
                coords.x -= playerSpine.height * 0.4;
                coords.y += playerSpine.height / 2;
            }
            const { dx: dx, dy: dy } = (0, $08054706be28954e$export$8440e95db1cffa85)(coords, player.element);
            const angle = (0, $08054706be28954e$export$afd58ae2e5ad6fa2)(0, 0, dx, dy);
            pointer.rotation = angle;
            pointer.position.set(player.element.x + 75 * dx, player.element.y + 75 * dy - player.element.height / 2);
        });
        //Shadow
        $01e69bafe2fbba11$export$f5c9f43142e3a83e(clientId);
        if (player.schema.life <= 0 || player.schema.dead) return;
        const { x: x, y: y } = playerSpine;
        let { x: newX, y: newY } = player.schema;
        const { width: width, dx: dx, dy: dy, speed: speed } = player.schema;
        newX += width / 2;
        newY += playerSpine.height;
        let computedX = x + dx * speed * delta;
        let computedY = y + dy * speed * delta;
        const differenceX = newX - computedX;
        const differenceY = newY - computedY;
        computedX += differenceX * delta * 0.02;
        computedY += differenceY * delta * 0.02;
        if (Math.abs(differenceX) > 100 || Math.abs(differenceX) < 0.02) computedX = newX;
        if (Math.abs(differenceY) > 100 || Math.abs(differenceY) < 0.02) computedY = newY;
        playerSpine.zIndex = 30 + Math.floor(computedY);
        // PLAYER
        playerSpine.position.set(computedX, computedY);
        const widthBar = playerSpine.width * 0.8;
        const heightBar = 12;
        const gapBar = 3;
        (0, $2ae84a41eb5f30ec$export$8e361a1ffbebf172).references.ui.level.healthBars.get(player.schema.clientId)?.container.position.set(computedX - widthBar / 2, computedY + 10);
        (0, $2ae84a41eb5f30ec$export$8e361a1ffbebf172).references.ui.level.shootingBars.get(player.schema.clientId)?.container.position.set(computedX - widthBar / 2, computedY + heightBar - gapBar + 10);
        // GUN 
        gunSpine.position.set(playerSpine.x, playerSpine.y - 0.25 * player.element.height);
        gunSpine.zIndex = playerSpine.zIndex + 1;
        // WAITING DOTS
        const dots = (0, $2ae84a41eb5f30ec$export$8e361a1ffbebf172).references.ui.level.waitingDots.get(player.schema.clientId);
        if (dots) dots.position.set(player.element.x - dots.width / 2, player.element.y - player.element.height - 35);
    });
};
const $01e69bafe2fbba11$export$f5c9f43142e3a83e = (clientId)=>{
    const player = (0, $2ae84a41eb5f30ec$export$8e361a1ffbebf172).references.players.get(clientId);
    const shadow = (0, $2ae84a41eb5f30ec$export$8e361a1ffbebf172).references.ui.level.shadows.get(clientId);
    if (!player || !shadow) return;
    if (player.schema.life <= 0 || player.schema.dead) {
        shadow.position.set(player.element.x - player.element.height * 0.4, player.element.y + player.element.height / 2 - shadow.height / 2);
        shadow.scale.set(1.5, 1.5);
        shadow.tint = 0xEC2727;
    } else {
        shadow.position.set(player.element.x, player.element.y);
        shadow.scale.set(1, 1);
        shadow.tint = player.schema.color;
    }
};



const $67df0d5a88b62b5d$export$3c53c96c8e7d5e6f = (room, scaleX, scaleY)=>{
    room.send("zoom", {
        scaleX: scaleX,
        scaleY: scaleY
    });
};
const $67df0d5a88b62b5d$export$8a856ecbecbdbcba = (room, moving, angle)=>{
    room.send("move", {
        moving: moving,
        angle: angle
    });
};
const $67df0d5a88b62b5d$export$69ce10523301c053 = (room, pause)=>{
    room.send("pause", pause);
};
const $67df0d5a88b62b5d$export$92e964eb1ed51a5 = (room)=>{
    room.send("pay-to-revive");
};
const $67df0d5a88b62b5d$export$b427202c7761bd = (room, angle)=>{
    room.send("fire-at", angle);
};
const $67df0d5a88b62b5d$export$7995a6e010531143 = (room, selectedIndex)=>{
    room.send("validate-new-level", selectedIndex);
};
const $67df0d5a88b62b5d$export$3ad06ec560c39e68 = (room)=>{
    (0, $2ae84a41eb5f30ec$export$8e361a1ffbebf172).latency.pingTime = new Date().getTime();
    room.send("ping");
};








const $bf5e1bcc1f1c3d40$export$a56500bd31d6d39d = (soundName)=>{
    Object.entries((0, $49736469f58fc92b$export$93445e7da77bf239)).filter((entry)=>entry[0].toLowerCase().includes("maintheme") && entry[0].toLowerCase() !== soundName.toLowerCase()).forEach((entry)=>{
        if ((0, $52a374576fbfc221$export$eab32dcfc4ded11c).find(entry[1])?.isPlaying) (0, $52a374576fbfc221$export$eab32dcfc4ded11c).find(entry[1]).stop();
    });
    const currentMusic = (0, $52a374576fbfc221$export$eab32dcfc4ded11c).find(soundName);
    if (!currentMusic.isPlaying && currentMusic.isLoaded) currentMusic.play();
};
const $bf5e1bcc1f1c3d40$export$83360306068d88f4 = ()=>{
    return window.localStorage.getItem("music-muted") === "true";
};
const $bf5e1bcc1f1c3d40$export$9fb19176558f2ffa = (force)=>{
    const status = $bf5e1bcc1f1c3d40$export$83360306068d88f4();
    //Object.entries(SoundName).filter((entry) => !entry[0].toLowerCase().includes('maintheme')).forEach((entry) => {
    Object.entries((0, $49736469f58fc92b$export$93445e7da77bf239)).forEach((entry)=>{
        (0, $52a374576fbfc221$export$eab32dcfc4ded11c).find(entry[1]).muted = force !== undefined ? force : !status;
    });
    window.localStorage.setItem("music-muted", String(force !== undefined ? force : !status));
};
const $bf5e1bcc1f1c3d40$export$e7a4972e465134b1 = (onProgress, onComplete)=>{
    if ((0, $52a374576fbfc221$export$eab32dcfc4ded11c).exists((0, $49736469f58fc92b$export$93445e7da77bf239).MainTheme)) {
        if (onProgress) onProgress(100);
        if (onComplete) onComplete();
        return;
    }
    const nbSounds = Object.keys((0, $49736469f58fc92b$export$93445e7da77bf239)).length;
    let soundLoaded = 0;
    const loaded = (error)=>{
        //if (gameState.exited) return
        if (error) console.error(error);
        if (error && !(0, $2ae84a41eb5f30ec$export$8e361a1ffbebf172).exited) {
            (0, $2ae84a41eb5f30ec$export$8e361a1ffbebf172).exited = true;
            (0, $2ae84a41eb5f30ec$export$8e361a1ffbebf172).external.clearGame();
            (0, $2ae84a41eb5f30ec$export$8e361a1ffbebf172).external.showLoading(false);
            (0, $2ae84a41eb5f30ec$export$8e361a1ffbebf172).external.showModal({
                title: "Error",
                text: "Impossible to load the sound resources, please check your internet connection and refresh the page"
            });
        }
        ++soundLoaded;
        if (soundLoaded === nbSounds && onComplete) onComplete();
        else if (onProgress) onProgress(soundLoaded / nbSounds * 100);
    };
    try {
        $bf5e1bcc1f1c3d40$var$loadMusics(loaded);
        $bf5e1bcc1f1c3d40$var$loadItems(loaded);
        $bf5e1bcc1f1c3d40$var$loadGame(loaded);
        $bf5e1bcc1f1c3d40$var$loadWeapons(loaded);
        $bf5e1bcc1f1c3d40$var$loadSkills(loaded);
        $bf5e1bcc1f1c3d40$var$loadBosses(loaded);
    } catch (err) {
        console.error(err);
    }
    if ($bf5e1bcc1f1c3d40$export$83360306068d88f4()) $bf5e1bcc1f1c3d40$export$9fb19176558f2ffa(true);
//if (isSFXMuted()) {
//  toggleMuteSFX(true)
//}
};
const $bf5e1bcc1f1c3d40$export$ccd4e8223abfd366 = (a, b, sound, localPlayerSound = false, options)=>{
    const volume = 1 - Math.max(0, Math.min(1, (0, $08054706be28954e$export$5082664ed3e64ee8)(a.x, a.y, b.x, b.y) / Math.max((0, $08054706be28954e$export$e692ebd4cea17cf3)(), (0, $08054706be28954e$export$4e851fc33b36a5f0)())));
    const pan = Math.min(1, Math.max(-1, (b.x - a.x) / (0, $08054706be28954e$export$e692ebd4cea17cf3)()));
    sound.play({
        volume: volume * (localPlayerSound ? 1 : 0.5),
        filters: [
            new (0, $4726057574cd580b$export$3f75220355fd576e)(pan)
        ],
        ...options
    });
};
const $bf5e1bcc1f1c3d40$var$loadMusics = (loaded)=>{
    (0, $52a374576fbfc221$export$eab32dcfc4ded11c).add((0, $49736469f58fc92b$export$93445e7da77bf239).MainTheme, {
        preload: true,
        url: (0, $0426e2dd5e0de94d$export$bdfbf8dbe6eb267c) + "/music/theme-2.mp3",
        volume: 0.08,
        loop: true,
        loaded: loaded
    });
    (0, $52a374576fbfc221$export$eab32dcfc4ded11c).add((0, $49736469f58fc92b$export$93445e7da77bf239).MainTheme2, {
        preload: true,
        url: (0, $0426e2dd5e0de94d$export$bdfbf8dbe6eb267c) + "/music/clash.mp3",
        volume: 0.08,
        loop: true,
        loaded: loaded
    });
};
const $bf5e1bcc1f1c3d40$var$loadItems = (loaded)=>{
    (0, $52a374576fbfc221$export$eab32dcfc4ded11c).add((0, $49736469f58fc92b$export$93445e7da77bf239).ItemBomb, {
        preload: true,
        url: (0, $0426e2dd5e0de94d$export$bdfbf8dbe6eb267c) + "/game/items/bomb.mp3",
        volume: 0.10,
        loaded: loaded
    });
    (0, $52a374576fbfc221$export$eab32dcfc4ded11c).add((0, $49736469f58fc92b$export$93445e7da77bf239).ItemShield, {
        preload: true,
        url: (0, $0426e2dd5e0de94d$export$bdfbf8dbe6eb267c) + "/game/items/shield.mp3",
        volume: 0.2,
        loaded: loaded
    });
    (0, $52a374576fbfc221$export$eab32dcfc4ded11c).add((0, $49736469f58fc92b$export$93445e7da77bf239).ItemMysteryBox, {
        preload: true,
        url: (0, $0426e2dd5e0de94d$export$bdfbf8dbe6eb267c) + "/ui/open-chest.mp3",
        volume: 0.1,
        loaded: loaded
    });
};
const $bf5e1bcc1f1c3d40$var$loadSkills = (loaded)=>{
    (0, $52a374576fbfc221$export$eab32dcfc4ded11c).add((0, $49736469f58fc92b$export$93445e7da77bf239).SkillDefensiveZone, {
        preload: true,
        url: (0, $0426e2dd5e0de94d$export$bdfbf8dbe6eb267c) + "/game/skills/electricity-sparks.mp3",
        volume: 0.1,
        loaded: loaded
    });
    (0, $52a374576fbfc221$export$eab32dcfc4ded11c).add((0, $49736469f58fc92b$export$93445e7da77bf239).SkillHealingDrone, {
        preload: true,
        url: (0, $0426e2dd5e0de94d$export$bdfbf8dbe6eb267c) + "/game/skills/heal.mp3",
        volume: 0.2,
        loaded: loaded
    });
    (0, $52a374576fbfc221$export$eab32dcfc4ded11c).add((0, $49736469f58fc92b$export$93445e7da77bf239).SkillLightning, {
        preload: true,
        url: (0, $0426e2dd5e0de94d$export$bdfbf8dbe6eb267c) + "/game/skills/lightning.mp3",
        volume: 0.3,
        loaded: loaded
    });
    (0, $52a374576fbfc221$export$eab32dcfc4ded11c).add((0, $49736469f58fc92b$export$93445e7da77bf239).SkillRocketDrone, {
        preload: true,
        url: (0, $0426e2dd5e0de94d$export$bdfbf8dbe6eb267c) + "/game/skills/rocket-explosion.mp3",
        volume: 0.3,
        loaded: loaded
    });
};
const $bf5e1bcc1f1c3d40$var$loadBosses = (loaded)=>{
    (0, $52a374576fbfc221$export$eab32dcfc4ded11c).add((0, $49736469f58fc92b$export$93445e7da77bf239).YetiIceBlast, {
        preload: true,
        url: (0, $0426e2dd5e0de94d$export$bdfbf8dbe6eb267c) + "/game/bosses/yeti/ice-blast.mp3",
        volume: 0.1,
        loaded: loaded
    });
    (0, $52a374576fbfc221$export$eab32dcfc4ded11c).add((0, $49736469f58fc92b$export$93445e7da77bf239).YetiIceSpike, {
        preload: true,
        url: (0, $0426e2dd5e0de94d$export$bdfbf8dbe6eb267c) + "/game/bosses/yeti/ice-spike.mp3",
        volume: 0.1,
        loaded: loaded
    });
    (0, $52a374576fbfc221$export$eab32dcfc4ded11c).add((0, $49736469f58fc92b$export$93445e7da77bf239).YetiStomp, {
        preload: true,
        url: (0, $0426e2dd5e0de94d$export$bdfbf8dbe6eb267c) + "/game/bosses/yeti/stomp.mp3",
        volume: 0.1,
        loaded: loaded
    });
    (0, $52a374576fbfc221$export$eab32dcfc4ded11c).add((0, $49736469f58fc92b$export$93445e7da77bf239).YetiSummon, {
        preload: true,
        url: (0, $0426e2dd5e0de94d$export$bdfbf8dbe6eb267c) + "/game/bosses/yeti/summon.mp3",
        volume: 0.1,
        loaded: loaded
    });
};
const $bf5e1bcc1f1c3d40$var$loadWeapons = (loaded)=>{
    (0, $52a374576fbfc221$export$eab32dcfc4ded11c).add((0, $49736469f58fc92b$export$93445e7da77bf239).WeaponBlaster, {
        preload: true,
        url: (0, $0426e2dd5e0de94d$export$bdfbf8dbe6eb267c) + "/game/weapons/blaster.mp3",
        volume: 0.02,
        loaded: loaded
    });
    (0, $52a374576fbfc221$export$eab32dcfc4ded11c).add((0, $49736469f58fc92b$export$93445e7da77bf239).WeaponNinjaStar, {
        preload: true,
        url: (0, $0426e2dd5e0de94d$export$bdfbf8dbe6eb267c) + "/game/weapons/ninja-star.mp3",
        volume: 0.04,
        loaded: loaded
    });
    (0, $52a374576fbfc221$export$eab32dcfc4ded11c).add((0, $49736469f58fc92b$export$93445e7da77bf239).WeaponShotgun, {
        preload: true,
        url: (0, $0426e2dd5e0de94d$export$bdfbf8dbe6eb267c) + "/game/weapons/shotgun.mp3",
        volume: 0.02,
        loaded: loaded
    });
    (0, $52a374576fbfc221$export$eab32dcfc4ded11c).add((0, $49736469f58fc92b$export$93445e7da77bf239).WeaponFlame, {
        preload: true,
        url: (0, $0426e2dd5e0de94d$export$bdfbf8dbe6eb267c) + "/game/weapons/flame.mp3",
        volume: 0.08,
        loaded: loaded
    });
    (0, $52a374576fbfc221$export$eab32dcfc4ded11c).add((0, $49736469f58fc92b$export$93445e7da77bf239).Impact, {
        preload: true,
        url: (0, $0426e2dd5e0de94d$export$bdfbf8dbe6eb267c) + "/game/weapons/impact.mp3",
        volume: 0.2,
        loaded: loaded
    });
};
const $bf5e1bcc1f1c3d40$var$loadGame = (loaded)=>{
    (0, $52a374576fbfc221$export$eab32dcfc4ded11c).add((0, $49736469f58fc92b$export$93445e7da77bf239).GameEnded, {
        preload: true,
        url: (0, $0426e2dd5e0de94d$export$bdfbf8dbe6eb267c) + "/game/ended.mp3",
        volume: 0.20,
        loaded: loaded
    });
    (0, $52a374576fbfc221$export$eab32dcfc4ded11c).add((0, $49736469f58fc92b$export$93445e7da77bf239).GamePause, {
        preload: true,
        url: (0, $0426e2dd5e0de94d$export$bdfbf8dbe6eb267c) + "/ui/button/click.mp3",
        volume: 0.25,
        loaded: loaded
    });
    (0, $52a374576fbfc221$export$eab32dcfc4ded11c).add((0, $49736469f58fc92b$export$93445e7da77bf239).GameToggle, {
        preload: true,
        url: (0, $0426e2dd5e0de94d$export$bdfbf8dbe6eb267c) + "/ui/button/switch.mp3",
        volume: 0.25,
        loaded: loaded
    });
};





const $644b60ca123b58dd$var$cachedTextTextures = {};
const $644b60ca123b58dd$export$eb0ce734bfb81799 = (textToShow, size = 24, color = 0xFFFFFF, stroke)=>{
    const textureKey = `${textToShow}-${size}-${color}-${stroke}`;
    if (!$644b60ca123b58dd$var$cachedTextTextures[textureKey]) {
        const obj = {
            fontFamily: "Cees Hand",
            fontWeight: "500",
            fill: color,
            fontSize: size
        };
        if (stroke !== undefined) {
            obj.stroke = stroke;
            obj.strokeThickness = 2 * (0, $08054706be28954e$export$b402ad477cba9c4a)();
        }
        const style = new (0, $3d453260a3c8e0f7$export$1df879243bf2e42d)(obj);
        const text = new (0, $f4ede730be703e5d$export$5f1af8db9871e1d6)(textToShow, style);
        const textMetrics = (0, $31f48a8131702733$export$4c5a129a59e1ef34).measureText(text.text, style);
        text.updateText(true);
        $644b60ca123b58dd$var$cachedTextTextures[textureKey] = {
            texture: text.texture,
            metrics: textMetrics
        };
    }
    return $644b60ca123b58dd$var$cachedTextTextures[textureKey];
};




const $8a8733686822a976$export$8040e0894456b767 = (room)=>{
    if (!(0, $2ae84a41eb5f30ec$export$8e361a1ffbebf172).app || !(0, $2ae84a41eb5f30ec$export$8e361a1ffbebf172).viewport || !(0, $2ae84a41eb5f30ec$export$8e361a1ffbebf172).resources) return;
    if ((0, $389fd98f2c1f982f$export$d0a8044dce8ff2fc).any) (0, $2ae84a41eb5f30ec$export$8e361a1ffbebf172).viewport.zoom(350);
    else (0, $2ae84a41eb5f30ec$export$8e361a1ffbebf172).viewport.zoom(200);
    (0, $67df0d5a88b62b5d$export$3c53c96c8e7d5e6f)(room, (0, $2ae84a41eb5f30ec$export$8e361a1ffbebf172).viewport.scale.x, (0, $2ae84a41eb5f30ec$export$8e361a1ffbebf172).viewport.scale.y);
    // Main container
    const topContainer = $8a8733686822a976$var$initTopContainer();
    if (!topContainer) return;
    // Clock
    $8a8733686822a976$var$initClock(topContainer);
    // Menu button
    $8a8733686822a976$var$initMenuButton(topContainer);
    // Score
    const scoreSprite = $8a8733686822a976$var$initScore(topContainer);
    if (!scoreSprite) return;
    // Kills
    const killContainer = $8a8733686822a976$var$initGems(topContainer, scoreSprite);
    if (!killContainer) return;
    // Level progress
    $8a8733686822a976$var$initLevelProgress(topContainer, killContainer);
    topContainer.zIndex = 20;
    (0, $2ae84a41eb5f30ec$export$8e361a1ffbebf172).app.stage.addChild(topContainer);
    (0, $2ae84a41eb5f30ec$export$8e361a1ffbebf172).references.topContainer = topContainer;
};
const $8a8733686822a976$var$initTopContainer = ()=>{
    if (!(0, $2ae84a41eb5f30ec$export$8e361a1ffbebf172).viewport) return undefined;
    const container = new (0, $68e6944de5989822$export$42a852a2b6b56249)();
    container.x = 0;
    container.y = 0;
    //container.sortableChildren = true
    (0, $2ae84a41eb5f30ec$export$8e361a1ffbebf172).references.ui.level.container = container;
    return container;
};
const $8a8733686822a976$var$initMenuButton = (container)=>{
    if (!(0, $2ae84a41eb5f30ec$export$8e361a1ffbebf172).viewport || !(0, $2ae84a41eb5f30ec$export$8e361a1ffbebf172).resources) return;
    const menuButton = new $e4c5b2569bd3a8d2$export$3075603db8e6204c((0, $2ae84a41eb5f30ec$export$8e361a1ffbebf172).resources.menu);
    menuButton.eventMode = "static";
    menuButton.cursor = "pointer";
    menuButton.on("pointertap", (event)=>{
        (0, $52a374576fbfc221$export$eab32dcfc4ded11c).find((0, $49736469f58fc92b$export$93445e7da77bf239).GamePause).play();
        $8a8733686822a976$export$f60a53667efadef8();
        event.stopPropagation();
    });
    const ratio = Math.min(40, 40 * (0, $08054706be28954e$export$b402ad477cba9c4a)()) / menuButton.height;
    menuButton.scale.set(ratio, ratio);
    menuButton.x = (0, $08054706be28954e$export$e692ebd4cea17cf3)() - menuButton.width - (0, $0426e2dd5e0de94d$export$5b8ff73d01e3bd5) * (0, $08054706be28954e$export$c1e6623c5820660e)();
    menuButton.y = (0, $0426e2dd5e0de94d$export$5b8ff73d01e3bd5) * (0, $08054706be28954e$export$c1e6623c5820660e)();
    container.addChild(menuButton);
};
const $8a8733686822a976$var$initClock = (container)=>{
    if (!(0, $2ae84a41eb5f30ec$export$8e361a1ffbebf172).viewport || !(0, $2ae84a41eb5f30ec$export$8e361a1ffbebf172).resources) return;
    // Container
    const clockContainer = new $e4c5b2569bd3a8d2$export$3075603db8e6204c((0, $2ae84a41eb5f30ec$export$8e361a1ffbebf172).resources["clock-container"]);
    const ratioClockContainer = Math.min(40, 40 * (0, $08054706be28954e$export$b402ad477cba9c4a)()) / clockContainer.height;
    clockContainer.scale.set(ratioClockContainer, ratioClockContainer);
    clockContainer.x = (0, $08054706be28954e$export$e692ebd4cea17cf3)() / 2 - clockContainer.width / 2;
    clockContainer.y = (0, $0426e2dd5e0de94d$export$5b8ff73d01e3bd5) * (0, $08054706be28954e$export$c1e6623c5820660e)();
    // Sub container
    const timeSubContainer = new (0, $68e6944de5989822$export$42a852a2b6b56249)();
    const bg = new (0, $48ce8a7de6645907$export$29d3e417456abdad)().beginFill(0xffffff, 0.00001).drawRect(0, 0, clockContainer.width * 0.38 / ratioClockContainer, clockContainer.height * 0.65 / ratioClockContainer).endFill();
    timeSubContainer.addChild(bg);
    timeSubContainer.x = clockContainer.width * 0.1 / ratioClockContainer;
    timeSubContainer.y = clockContainer.height / ratioClockContainer * 0.15;
    // Clock
    const clock = new $e4c5b2569bd3a8d2$export$3075603db8e6204c((0, $2ae84a41eb5f30ec$export$8e361a1ffbebf172).resources.clock);
    const ratioClock = timeSubContainer.height / clock.height;
    clock.scale.set(ratioClock, ratioClock);
    timeSubContainer.addChild(clock);
    // Time
    const timeStyle = new (0, $3d453260a3c8e0f7$export$1df879243bf2e42d)({
        fontFamily: "More Sugar",
        fontWeight: "400",
        fill: 0xffffff,
        fontSize: 38,
        align: "center"
    });
    const timeText = new (0, $f4ede730be703e5d$export$5f1af8db9871e1d6)("60", timeStyle);
    const timeMetrics = (0, $31f48a8131702733$export$4c5a129a59e1ef34).measureText(timeText.text, timeText.style);
    timeText.style = timeStyle;
    timeText.x = clock.width * 1.2;
    timeText.y = timeSubContainer.height / 2 - timeMetrics.height / 2;
    timeSubContainer.addChild(timeText);
    (0, $2ae84a41eb5f30ec$export$8e361a1ffbebf172).references.ui.level.time = timeText;
    // Sub container
    const monsterSubContainer = new (0, $68e6944de5989822$export$42a852a2b6b56249)();
    const bgMonster = new (0, $48ce8a7de6645907$export$29d3e417456abdad)().beginFill(0xffffff, 0.00001).drawRect(0, 0, clockContainer.width * 0.38 / ratioClockContainer, clockContainer.height * 0.65 / ratioClockContainer).endFill();
    monsterSubContainer.addChild(bgMonster);
    monsterSubContainer.x = clockContainer.width * 0.52 / ratioClockContainer;
    monsterSubContainer.y = clockContainer.height / ratioClockContainer * 0.15;
    // Monster
    const monster = new $e4c5b2569bd3a8d2$export$3075603db8e6204c((0, $2ae84a41eb5f30ec$export$8e361a1ffbebf172).resources.monster);
    const ratioMonster = monsterSubContainer.height / monster.height;
    monster.scale.set(ratioMonster, ratioMonster);
    monsterSubContainer.addChild(monster);
    // Monster count
    const monsterStyle = new (0, $3d453260a3c8e0f7$export$1df879243bf2e42d)({
        fontFamily: "More Sugar",
        fontWeight: "400",
        fill: 0xffffff,
        fontSize: 38,
        align: "center"
    });
    const monsterText = new (0, $f4ede730be703e5d$export$5f1af8db9871e1d6)("0", monsterStyle);
    const monsterMetrics = (0, $31f48a8131702733$export$4c5a129a59e1ef34).measureText(monsterText.text, monsterText.style);
    monsterText.style = monsterStyle;
    monsterText.x = monster.width * 1.2;
    monsterText.y = monsterSubContainer.height / 2 - monsterMetrics.height / 2;
    monsterSubContainer.addChild(monsterText);
    (0, $2ae84a41eb5f30ec$export$8e361a1ffbebf172).references.ui.level.monsterCount = monsterText;
    // End
    clockContainer.addChild(timeSubContainer, monsterSubContainer);
    container.addChild(clockContainer);
    return clockContainer;
};
const $8a8733686822a976$var$initScore = (container)=>{
    if (!(0, $2ae84a41eb5f30ec$export$8e361a1ffbebf172).viewport || !(0, $2ae84a41eb5f30ec$export$8e361a1ffbebf172).resources) return;
    // Container
    const scoreContainer = new $e4c5b2569bd3a8d2$export$3075603db8e6204c((0, $2ae84a41eb5f30ec$export$8e361a1ffbebf172).resources["score-container"]);
    const ratioScoreContainer = Math.min(40, 30 * (0, $08054706be28954e$export$b402ad477cba9c4a)()) / scoreContainer.height;
    scoreContainer.scale.set(ratioScoreContainer, ratioScoreContainer);
    scoreContainer.x = (0, $0426e2dd5e0de94d$export$5b8ff73d01e3bd5) * 1.5 * (0, $08054706be28954e$export$c1e6623c5820660e)();
    scoreContainer.y = (0, $0426e2dd5e0de94d$export$5b8ff73d01e3bd5) * (0, $08054706be28954e$export$c1e6623c5820660e)();
    // Trophy
    const trophy = new $e4c5b2569bd3a8d2$export$3075603db8e6204c((0, $2ae84a41eb5f30ec$export$8e361a1ffbebf172).resources.trophy);
    const ratioTrophy = scoreContainer.height / trophy.height * 1.2;
    trophy.scale.set(ratioTrophy, ratioTrophy);
    trophy.x = scoreContainer.x - Math.min(10, 10 * (0, $08054706be28954e$export$c1e6623c5820660e)());
    trophy.y = scoreContainer.y + scoreContainer.height / 2 - trophy.height / 2;
    // Score
    const scoreCountStyle = new (0, $3d453260a3c8e0f7$export$1df879243bf2e42d)({
        fontFamily: "More Sugar",
        fontWeight: "400",
        fill: 0xffffff,
        fontSize: 20 * ratioScoreContainer,
        align: "center"
    });
    const scoreCountText = new (0, $f4ede730be703e5d$export$5f1af8db9871e1d6)("0", scoreCountStyle);
    const scoreCountMetrics = (0, $31f48a8131702733$export$4c5a129a59e1ef34).measureText(scoreCountText.text, scoreCountText.style);
    scoreCountText.style = scoreCountStyle;
    scoreCountText.x = scoreContainer.x + (scoreContainer.width - trophy.width + 15) / 2 + trophy.width / 2;
    scoreCountText.y = scoreContainer.y + (scoreContainer.height / 1.70 - scoreCountMetrics.height / 2);
    (0, $2ae84a41eb5f30ec$export$8e361a1ffbebf172).references.ui.level.scoreCount = scoreCountText;
    container.addChild(scoreContainer, trophy, scoreCountText);
    return scoreContainer;
};
const $8a8733686822a976$var$initGems = (container, scoreContainer)=>{
    if (!(0, $2ae84a41eb5f30ec$export$8e361a1ffbebf172).viewport || !(0, $2ae84a41eb5f30ec$export$8e361a1ffbebf172).resources) return;
    // Container
    const gemsContainer = new $e4c5b2569bd3a8d2$export$3075603db8e6204c((0, $2ae84a41eb5f30ec$export$8e361a1ffbebf172).resources["score-container"]);
    const ratioGemsContainer = Math.min(40, 30 * (0, $08054706be28954e$export$b402ad477cba9c4a)()) / gemsContainer.height;
    gemsContainer.scale.set(ratioGemsContainer, ratioGemsContainer);
    gemsContainer.x = (0, $0426e2dd5e0de94d$export$5b8ff73d01e3bd5) * 1.5 * (0, $08054706be28954e$export$c1e6623c5820660e)();
    gemsContainer.y = scoreContainer.y + scoreContainer.height + (0, $0426e2dd5e0de94d$export$5b8ff73d01e3bd5) * (0, $08054706be28954e$export$c1e6623c5820660e)();
    // Gem
    const gem = new $e4c5b2569bd3a8d2$export$3075603db8e6204c((0, $2ae84a41eb5f30ec$export$8e361a1ffbebf172).resources.gem);
    const ratioGem = gemsContainer.height / gem.height * 1.2;
    gem.scale.set(ratioGem, ratioGem);
    gem.x = gemsContainer.x - Math.min(10, 10 * (0, $08054706be28954e$export$b402ad477cba9c4a)());
    gem.y = gemsContainer.y + gemsContainer.height / 2 - gem.height / 2;
    // Gems
    const gemsCountStyle = new (0, $3d453260a3c8e0f7$export$1df879243bf2e42d)({
        fontFamily: "More Sugar",
        fontWeight: "400",
        fill: 0xffffff,
        fontSize: 20 * ratioGemsContainer,
        align: "center"
    });
    const gemsCountText = new (0, $f4ede730be703e5d$export$5f1af8db9871e1d6)("0", gemsCountStyle);
    const gemsCountMetrics = (0, $31f48a8131702733$export$4c5a129a59e1ef34).measureText(gemsCountText.text, gemsCountText.style);
    gemsCountText.style = gemsCountStyle;
    gemsCountText.x = gemsContainer.x + (gemsContainer.width - gem.width + 15) / 2 + gem.width / 2;
    gemsCountText.y = gemsContainer.y + (gemsContainer.height / 1.70 - gemsCountMetrics.height / 2);
    (0, $2ae84a41eb5f30ec$export$8e361a1ffbebf172).references.ui.level.gemsCount = gemsCountText;
    container.addChild(gemsContainer, gem, gemsCountText);
    return gemsContainer;
};
const $8a8733686822a976$var$initLevelProgress = (container, killContainer)=>{
    if (!(0, $2ae84a41eb5f30ec$export$8e361a1ffbebf172).viewport || !(0, $2ae84a41eb5f30ec$export$8e361a1ffbebf172).resources) return;
    // Container
    const levelProgress = new $e4c5b2569bd3a8d2$export$3075603db8e6204c((0, $2ae84a41eb5f30ec$export$8e361a1ffbebf172).resources["level-progress"]);
    const ratioLevelProgress = Math.min(40, 30 * (0, $08054706be28954e$export$b402ad477cba9c4a)()) / levelProgress.height;
    levelProgress.scale.set(ratioLevelProgress * Math.min(1, (0, $08054706be28954e$export$b402ad477cba9c4a)() * 1.2), ratioLevelProgress);
    levelProgress.x = (0, $08054706be28954e$export$e692ebd4cea17cf3)() / 2 - levelProgress.width / 2;
    levelProgress.y = killContainer.y;
    // Star
    const star = new $e4c5b2569bd3a8d2$export$3075603db8e6204c((0, $2ae84a41eb5f30ec$export$8e361a1ffbebf172).resources.star);
    const ratioStar = levelProgress.height / star.height * 1.1;
    star.scale.set(ratioStar, ratioStar);
    star.x = levelProgress.x + levelProgress.width - star.width + Math.min(10, 10 * (0, $08054706be28954e$export$b402ad477cba9c4a)());
    star.y = levelProgress.y + levelProgress.height / 2 - star.height / 2;
    // Texture
    const barTexture = new $e4c5b2569bd3a8d2$export$3075603db8e6204c((0, $2ae84a41eb5f30ec$export$8e361a1ffbebf172).resources["level-bar-bg"]);
    const ratioBarTextureWidth = levelProgress.width / barTexture.width * 0.72;
    const ratioBarTextureHeight = levelProgress.height / barTexture.height * 0.52;
    barTexture.scale.set(ratioBarTextureWidth, ratioBarTextureHeight);
    barTexture.x = levelProgress.x + levelProgress.width - barTexture.width - Math.min(15, 15 * (0, $08054706be28954e$export$b402ad477cba9c4a)());
    barTexture.y = levelProgress.y + levelProgress.height * 0.34;
    barTexture.alpha = 0.15;
    (0, $2ae84a41eb5f30ec$export$8e361a1ffbebf172).references.ui.level.levelBars = barTexture;
    // Violet
    const violetBg = new (0, $e4c5b2569bd3a8d2$export$3075603db8e6204c)((0, $08054706be28954e$export$46def8197cf4dd4c)("#D803A9", "#FF5FDC", 0, 0, barTexture.width, 0, barTexture.width, barTexture.height));
    violetBg.position.set(barTexture.x, barTexture.y);
    // Mask
    const levelMask = new (0, $48ce8a7de6645907$export$29d3e417456abdad)();
    levelMask.position.set(barTexture.x, barTexture.y);
    barTexture.mask = levelMask;
    violetBg.mask = levelMask;
    (0, $2ae84a41eb5f30ec$export$8e361a1ffbebf172).references.ui.level.levelMask = levelMask;
    // Flask
    const flask = new $e4c5b2569bd3a8d2$export$3075603db8e6204c((0, $2ae84a41eb5f30ec$export$8e361a1ffbebf172).resources["level-flask"]);
    const ratioFlask = levelProgress.height / flask.height * 1.2;
    flask.scale.set(ratioFlask, ratioFlask);
    flask.x = barTexture.x - flask.width / 3;
    flask.y = levelProgress.y + levelProgress.height / 2 - flask.height * 0.54;
    // Level
    const levelStyle = new (0, $3d453260a3c8e0f7$export$1df879243bf2e42d)({
        fontFamily: "More Sugar",
        fontWeight: "400",
        fill: 0xffffff,
        fontSize: 20 * ratioLevelProgress,
        align: "center"
    });
    const levelText = new (0, $f4ede730be703e5d$export$5f1af8db9871e1d6)("Lv.1", levelStyle);
    const levelMetrics = (0, $31f48a8131702733$export$4c5a129a59e1ef34).measureText(levelText.text, levelText.style);
    levelText.style = levelStyle;
    levelText.x = levelProgress.x + Math.min(10, 10 * (0, $08054706be28954e$export$b402ad477cba9c4a)());
    levelText.y = levelProgress.y + (levelProgress.height / 2 - levelMetrics.height / 2);
    (0, $2ae84a41eb5f30ec$export$8e361a1ffbebf172).references.ui.level.levelCount = levelText;
    container.addChild(levelProgress, violetBg, barTexture, levelMask, star, flask, levelText);
};
const $8a8733686822a976$export$5c853c5f828a43c2 = ()=>{
    if (!(0, $2ae84a41eb5f30ec$export$8e361a1ffbebf172).viewport || !(0, $2ae84a41eb5f30ec$export$8e361a1ffbebf172).resources) return;
    let i = 1;
    if ((0, $2ae84a41eb5f30ec$export$8e361a1ffbebf172).references.players.size <= 1) return;
    (0, $2ae84a41eb5f30ec$export$8e361a1ffbebf172).references.players.forEach((player)=>{
        if (!player) return;
        const index = i++;
        const container = new (0, $68e6944de5989822$export$42a852a2b6b56249)();
        // Background
        const background = new $e4c5b2569bd3a8d2$export$3075603db8e6204c((0, $2ae84a41eb5f30ec$export$8e361a1ffbebf172).resources["score-container"]);
        const ratioBackground = Math.min(40, 30 * (0, $08054706be28954e$export$b402ad477cba9c4a)()) / background.height;
        background.scale.set(ratioBackground, ratioBackground);
        background.x = (0, $08054706be28954e$export$e692ebd4cea17cf3)() - (0, $0426e2dd5e0de94d$export$5b8ff73d01e3bd5) * 1.5 * (0, $08054706be28954e$export$c1e6623c5820660e)() - background.width;
        background.y = (0, $0426e2dd5e0de94d$export$5b8ff73d01e3bd5) * (0, $08054706be28954e$export$c1e6623c5820660e)() + (background.height + (0, $0426e2dd5e0de94d$export$5b8ff73d01e3bd5)) * index;
        // Color
        const color = new (0, $48ce8a7de6645907$export$29d3e417456abdad)().beginFill(player.schema.color).drawCircle(background.x + background.width * 0.15, background.y + background.height / 2, background.height * 0.35).endFill();
        // Username
        const usernameStyle = new (0, $3d453260a3c8e0f7$export$1df879243bf2e42d)({
            fontFamily: "More Sugar",
            fontWeight: "400",
            fill: 0xffffff,
            fontSize: 16 * ratioBackground,
            align: "center"
        });
        const usernameText = new (0, $f4ede730be703e5d$export$5f1af8db9871e1d6)(`${player.schema.name.slice(0, 9)}${player.schema.name.length > 9 ? "..." : ""}`, usernameStyle);
        const usernameMetrics = (0, $31f48a8131702733$export$4c5a129a59e1ef34).measureText(usernameText.text, usernameText.style);
        usernameText.style = usernameStyle;
        usernameText.x = background.x + background.width * 0.3;
        usernameText.y = background.y + (background.height / 1.8 - usernameMetrics.height / 2);
        // Health
        const width = background.width * 0.65;
        const height = Math.min(12, 12 * (0, $08054706be28954e$export$b402ad477cba9c4a)());
        const gap = Math.min(3, 3 * (0, $08054706be28954e$export$b402ad477cba9c4a)());
        const { container: healthContainer, bar: healthBar } = (0, $08054706be28954e$export$d4967e94c672b608)(width, height, gap, 0x111111, player.schema.color === "#000000" ? 0x33ff33 : parseInt(player.schema.color.replace(/^#/, ""), 16), true);
        healthContainer.position.set(background.x + background.width * 0.325, background.y - healthContainer.height / 2);
        // Revive
        const styleRevive = new (0, $3d453260a3c8e0f7$export$1df879243bf2e42d)({
            fontFamily: "Supersonic Rocketship",
            fontWeight: "400",
            letterSpacing: 3,
            fill: 0xEC2727,
            fontSize: Math.min(18, 14 * (0, $08054706be28954e$export$b402ad477cba9c4a)()),
            dropShadow: true,
            dropShadowDistance: 2,
            dropShadowColor: 0xffffff,
            dropShadowAlpha: 0.9,
            dropShadowAngle: 1.5,
            align: "center",
            stroke: 0xffffff,
            strokeThickness: Math.min(3, 2 * (0, $08054706be28954e$export$b402ad477cba9c4a)())
        });
        const reviveText = new (0, $f4ede730be703e5d$export$5f1af8db9871e1d6)("REVIVE", styleRevive);
        const reviveMetrics = (0, $31f48a8131702733$export$4c5a129a59e1ef34).measureText(reviveText.text, reviveText.style);
        reviveText.style = styleRevive;
        reviveText.x = healthContainer.x + healthContainer.width / 2 - reviveMetrics.width / 2;
        reviveText.y = healthContainer.y + healthContainer.height / 2 - reviveMetrics.height / 2;
        reviveText.alpha = 0;
        container.addChild(background, color, usernameText, healthContainer);
        (0, $2ae84a41eb5f30ec$export$8e361a1ffbebf172).references.ui.level.teamView.set(player.schema.clientId, {
            container: container,
            healthBar: healthBar,
            reviveText: reviveText
        });
        (0, $2ae84a41eb5f30ec$export$8e361a1ffbebf172).app?.stage.addChild(container, reviveText);
    });
};
const $8a8733686822a976$export$a287bde569066e49 = (x, y, radius, duration)=>{
    if (!(0, $2ae84a41eb5f30ec$export$8e361a1ffbebf172).viewport) return;
    const graphics = new (0, $48ce8a7de6645907$export$29d3e417456abdad)().beginFill(0x000000).drawCircle(0, 0, radius).endFill();
    graphics.position.set(x, y);
    graphics.zIndex = 12;
    graphics.alpha = 0;
    (0, $52be045d3cbb2b80$export$99ee26438460406a).to(graphics, {
        duration: duration / 1000,
        alpha: 0.1
    }).then(()=>{
        graphics.destroy();
    });
    (0, $2ae84a41eb5f30ec$export$8e361a1ffbebf172).viewport.addChild(graphics);
};
const $8a8733686822a976$export$6f8677da01a898f6 = ()=>{
    if (!(0, $2ae84a41eb5f30ec$export$8e361a1ffbebf172).references.ui.level.latencyCount) return;
    const latencyText = (0, $2ae84a41eb5f30ec$export$8e361a1ffbebf172).references.ui.level.latencyCount;
    latencyText.text = `${Math.round((0, $2ae84a41eb5f30ec$export$8e361a1ffbebf172).latency.history.reduce((acc, value)=>acc + value) / (0, $2ae84a41eb5f30ec$export$8e361a1ffbebf172).latency.history.length)} ms`;
};
const $8a8733686822a976$export$e5d5e1c1822b6e56 = (count)=>{
    if (!(0, $2ae84a41eb5f30ec$export$8e361a1ffbebf172).references.ui.level.time) return;
    const timeText = (0, $2ae84a41eb5f30ec$export$8e361a1ffbebf172).references.ui.level.time;
    timeText.style.fill = count <= 15 ? 0xFF0000 : count <= 30 ? 0xFFB822 : 0xFFFFFF;
    timeText.text = `${count}`;
};
const $8a8733686822a976$export$ea34a7d3c083e44a = (count)=>{
    if (!(0, $2ae84a41eb5f30ec$export$8e361a1ffbebf172).references.ui.level.monsterCount) return;
    const timeText = (0, $2ae84a41eb5f30ec$export$8e361a1ffbebf172).references.ui.level.monsterCount;
    timeText.text = `${count}`;
};
const $8a8733686822a976$export$ffd8e13d6b0d8fb0 = (count)=>{
    if (!(0, $2ae84a41eb5f30ec$export$8e361a1ffbebf172).references.ui.level.scoreCount) return;
    const counterText = (0, $2ae84a41eb5f30ec$export$8e361a1ffbebf172).references.ui.level.scoreCount;
    const previousMetrics = (0, $31f48a8131702733$export$4c5a129a59e1ef34).measureText(`${counterText.text}`, counterText.style);
    const sizeDifference = String(count).length - counterText.text.length;
    counterText.text = `${count}`;
    const newMetrics = (0, $31f48a8131702733$export$4c5a129a59e1ef34).measureText(`${counterText.text}`, counterText.style);
    if (sizeDifference > 0) counterText.x -= (newMetrics.width - previousMetrics.width) / 2;
};
const $8a8733686822a976$export$788e700ffeb7528a = (count)=>{
    if (!(0, $2ae84a41eb5f30ec$export$8e361a1ffbebf172).references.ui.level.gemsCount) return;
    const counterText = (0, $2ae84a41eb5f30ec$export$8e361a1ffbebf172).references.ui.level.gemsCount;
    const previousMetrics = (0, $31f48a8131702733$export$4c5a129a59e1ef34).measureText(`${counterText.text}`, counterText.style);
    const sizeDifference = String(count).length - counterText.text.length;
    counterText.text = `${count}`;
    const newMetrics = (0, $31f48a8131702733$export$4c5a129a59e1ef34).measureText(`${counterText.text}`, counterText.style);
    if (sizeDifference > 0) counterText.x -= (newMetrics.width - previousMetrics.width) / 2;
};
const $8a8733686822a976$export$37a16b981197c6e9 = (count)=>{
    if (!(0, $2ae84a41eb5f30ec$export$8e361a1ffbebf172).references.ui.level.levelCount) return;
    const counterText = (0, $2ae84a41eb5f30ec$export$8e361a1ffbebf172).references.ui.level.levelCount;
    const previousMetrics = (0, $31f48a8131702733$export$4c5a129a59e1ef34).measureText(`Lv.${counterText.text}`, counterText.style);
    const sizeDifference = String(count).length - counterText.text.length;
    counterText.text = `Lv.${count}`;
    const newMetrics = (0, $31f48a8131702733$export$4c5a129a59e1ef34).measureText(`${counterText.text}`, counterText.style);
    if (sizeDifference > 0) counterText.x -= (newMetrics.width - previousMetrics.width) / 2;
};
const $8a8733686822a976$export$68137314df9d883c = (progress)=>{
    if (!(0, $2ae84a41eb5f30ec$export$8e361a1ffbebf172).references.ui.level.levelMask || !(0, $2ae84a41eb5f30ec$export$8e361a1ffbebf172).references.ui.level.levelBars) return;
    const bars = (0, $2ae84a41eb5f30ec$export$8e361a1ffbebf172).references.ui.level.levelBars;
    const mask = (0, $2ae84a41eb5f30ec$export$8e361a1ffbebf172).references.ui.level.levelMask;
    bars.alpha = progress === 0 ? 0 : 0.15;
    mask.clear().beginFill(0xffffff).drawRoundedRect(0, 0, bars.width * progress, bars.height, bars.height).endFill();
};
const $8a8733686822a976$export$633e056fc36fb213 = (playerSchema, difference)=>{
    if (!(0, $2ae84a41eb5f30ec$export$8e361a1ffbebf172).level || !(0, $2ae84a41eb5f30ec$export$8e361a1ffbebf172).viewport) return;
    if (difference > 0) // damage
    $8a8733686822a976$export$bf46dab662f54bbd(playerSchema, `${difference}`, 0xff0000);
    else if (difference < 0) // heal
    $8a8733686822a976$export$bf46dab662f54bbd(playerSchema, `${difference}`, 0x4C9900);
    const healthBar = (0, $2ae84a41eb5f30ec$export$8e361a1ffbebf172).references.ui.level.healthBars.get(playerSchema.clientId);
    if (healthBar) healthBar.bar.scale.x = Math.max(playerSchema.life / playerSchema.maxLife, 0);
    const teamView = (0, $2ae84a41eb5f30ec$export$8e361a1ffbebf172).references.ui.level.teamView.get(playerSchema.clientId);
    if (teamView) teamView.healthBar.scale.x = Math.max(playerSchema.life / playerSchema.maxLife, 0);
};
const $8a8733686822a976$export$2381fbdf6303e9b9 = (monster)=>{
    if (!(0, $2ae84a41eb5f30ec$export$8e361a1ffbebf172).level || !(0, $2ae84a41eb5f30ec$export$8e361a1ffbebf172).viewport) return;
    const healthBar = (0, $2ae84a41eb5f30ec$export$8e361a1ffbebf172).references.ui.level.healthBars.get(monster.uid);
    if (healthBar) healthBar.bar.scale.x = Math.max(monster.life / monster.maxLife, 0);
};
const $8a8733686822a976$export$fccac230130a63bf = (name, type, monsterCount)=>{
    const color = type === "boss" ? 0x9D6EDF : type === "zombie" ? 0x59D79A : 0xEA6ADC;
    if (monsterCount) $8a8733686822a976$export$ea34a7d3c083e44a(monsterCount);
    const style = new (0, $3d453260a3c8e0f7$export$1df879243bf2e42d)({
        fontFamily: "Supersonic Rocketship",
        fontWeight: "400",
        letterSpacing: 3,
        fill: 0xffffff,
        fontSize: Math.min(Math.max(44, 22 * (0, $08054706be28954e$export$b402ad477cba9c4a)()), 60),
        dropShadow: true,
        dropShadowDistance: 4,
        dropShadowColor: 0x000000,
        dropShadowAlpha: 0.9,
        dropShadowAngle: 1.5,
        align: "center",
        stroke: 0x000000,
        strokeThickness: Math.max(4, 2 * (0, $08054706be28954e$export$b402ad477cba9c4a)())
    });
    const text = new (0, $f4ede730be703e5d$export$5f1af8db9871e1d6)(name.toUpperCase(), style);
    const metrics = (0, $31f48a8131702733$export$4c5a129a59e1ef34).measureText(text.text, text.style);
    text.style = style;
    text.x = (0, $08054706be28954e$export$e692ebd4cea17cf3)() / 2 - metrics.width / 2;
    text.y = (0, $08054706be28954e$export$4e851fc33b36a5f0)() / 4 - metrics.height / 2;
    (0, $2ae84a41eb5f30ec$export$8e361a1ffbebf172).app?.stage.addChild(text);
    (0, $52be045d3cbb2b80$export$99ee26438460406a).to(text, {
        duration: 1,
        alpha: 1
    }).then(()=>{
        (0, $52be045d3cbb2b80$export$99ee26438460406a).to(text, {
            delay: 1,
            duration: 1,
            alpha: 0
        }).then(()=>{
            text.destroy();
        });
    });
};
const $8a8733686822a976$export$b3008e0376379461 = (clientId)=>{
    const player = (0, $2ae84a41eb5f30ec$export$8e361a1ffbebf172).references.players.get(clientId);
    if (!player) return;
    $8a8733686822a976$export$d6ada3c2d2863dab(clientId);
    const style = new (0, $3d453260a3c8e0f7$export$1df879243bf2e42d)({
        fontFamily: "Supersonic Rocketship",
        fontWeight: "400",
        letterSpacing: 3,
        fill: 0xEC2727,
        fontSize: Math.min(Math.max(22, 11 * (0, $08054706be28954e$export$b402ad477cba9c4a)()), 30),
        dropShadow: true,
        dropShadowDistance: 2,
        dropShadowColor: 0xffffff,
        dropShadowAlpha: 0.9,
        dropShadowAngle: 1.5,
        align: "center",
        stroke: 0xffffff,
        strokeThickness: Math.max(2, 1 * (0, $08054706be28954e$export$b402ad477cba9c4a)())
    });
    const text = new (0, $f4ede730be703e5d$export$5f1af8db9871e1d6)("REVIVE", style);
    const metrics = (0, $31f48a8131702733$export$4c5a129a59e1ef34).measureText(text.text, text.style);
    text.style = style;
    text.x = player.element.x - metrics.height * 2.3;
    text.y = player.element.y - player.element.height;
    text.zIndex = Number.MAX_SAFE_INTEGER - 5;
    (0, $2ae84a41eb5f30ec$export$8e361a1ffbebf172).references.ui.level.revives.set(clientId, {
        ...(0, $2ae84a41eb5f30ec$export$8e361a1ffbebf172).references.ui.level.revives.get(clientId),
        text: text
    });
    text.alpha = 0;
    (0, $2ae84a41eb5f30ec$export$8e361a1ffbebf172).viewport?.addChild(text);
    (0, $52be045d3cbb2b80$export$99ee26438460406a).to(text, {
        duration: 1,
        alpha: 1,
        repeat: -1,
        yoyo: true
    });
};
const $8a8733686822a976$export$992c49b3c534515c = (clientId, max, left)=>{
    const player = (0, $2ae84a41eb5f30ec$export$8e361a1ffbebf172).references.players.get(clientId);
    if (!(0, $2ae84a41eb5f30ec$export$8e361a1ffbebf172).viewport || !player) return;
    if (!(0, $2ae84a41eb5f30ec$export$8e361a1ffbebf172).references.ui.level.revives.get(clientId)?.graphics) {
        const container = new (0, $68e6944de5989822$export$42a852a2b6b56249)();
        const graphics = new $48ce8a7de6645907$export$29d3e417456abdad();
        graphics.x = 10 * (0, $08054706be28954e$export$b402ad477cba9c4a)();
        graphics.y = 10 * (0, $08054706be28954e$export$b402ad477cba9c4a)();
        container.x = player.element.x - player.element.height * 0.8;
        container.y = player.element.y - player.element.width * 0.4;
        container.addChild(graphics);
        (0, $2ae84a41eb5f30ec$export$8e361a1ffbebf172).references.ui.level.revives.set(clientId, {
            ...(0, $2ae84a41eb5f30ec$export$8e361a1ffbebf172).references.ui.level.revives.get(clientId),
            graphics: graphics,
            max: max,
            left: left,
            container: container
        });
        container.zIndex = 11;
        (0, $2ae84a41eb5f30ec$export$8e361a1ffbebf172).viewport.addChild(container);
    } else (0, $2ae84a41eb5f30ec$export$8e361a1ffbebf172).references.ui.level.revives.set(clientId, {
        ...(0, $2ae84a41eb5f30ec$export$8e361a1ffbebf172).references.ui.level.revives.get(clientId),
        max: max,
        left: left
    });
};
const $8a8733686822a976$export$5eab396bc76aace8 = (clientId)=>{
    const obj = (0, $2ae84a41eb5f30ec$export$8e361a1ffbebf172).references.ui.level.revives.get(clientId);
    if (!obj) return;
    obj.container?.destroy();
    (0, $2ae84a41eb5f30ec$export$8e361a1ffbebf172).references.ui.level.revives.set(clientId, {
        ...(0, $2ae84a41eb5f30ec$export$8e361a1ffbebf172).references.ui.level.revives.get(clientId),
        graphics: undefined,
        max: undefined,
        left: undefined,
        container: undefined
    });
};
const $8a8733686822a976$export$1e36c547a9c2b135 = (clientId)=>{
    const player = (0, $2ae84a41eb5f30ec$export$8e361a1ffbebf172).references.players.get(clientId);
    const gun = (0, $2ae84a41eb5f30ec$export$8e361a1ffbebf172).references.guns.get(clientId);
    const healthBar = (0, $2ae84a41eb5f30ec$export$8e361a1ffbebf172).references.ui.level.healthBars.get(clientId);
    const shootingBar = (0, $2ae84a41eb5f30ec$export$8e361a1ffbebf172).references.ui.level.shootingBars.get(clientId);
    const obj = (0, $2ae84a41eb5f30ec$export$8e361a1ffbebf172).references.ui.level.revives.get(clientId);
    const teamView = (0, $2ae84a41eb5f30ec$export$8e361a1ffbebf172).references.ui.level.teamView.get(clientId);
    if (!obj || !player || !gun || !healthBar || !teamView) return;
    player.element.state.setAnimationByName(0, "IDLE", true);
    player.element.rotation = 0;
    gun.alpha = 1;
    healthBar.container.alpha = 1;
    if (shootingBar) shootingBar.container.alpha = 1;
    teamView.container.alpha = 1;
    teamView.reviveText.alpha = 0;
    obj.text?.destroy();
    $8a8733686822a976$export$5eab396bc76aace8(clientId);
    const particleContainer = (0, $2ae84a41eb5f30ec$export$8e361a1ffbebf172).references.particles.get(clientId)?.container;
    if (particleContainer) particleContainer.alpha = 1;
    (0, $2ae84a41eb5f30ec$export$8e361a1ffbebf172).references.ui.level.revives.delete(clientId);
};
const $8a8733686822a976$export$d6ada3c2d2863dab = (clientId)=>{
    const player = (0, $2ae84a41eb5f30ec$export$8e361a1ffbebf172).references.players.get(clientId);
    const gun = (0, $2ae84a41eb5f30ec$export$8e361a1ffbebf172).references.guns.get(clientId);
    const healthBar = (0, $2ae84a41eb5f30ec$export$8e361a1ffbebf172).references.ui.level.healthBars.get(clientId);
    const shootingBar = (0, $2ae84a41eb5f30ec$export$8e361a1ffbebf172).references.ui.level.shootingBars.get(clientId);
    const teamView = (0, $2ae84a41eb5f30ec$export$8e361a1ffbebf172).references.ui.level.teamView.get(clientId);
    if (!player || !gun || !healthBar || !teamView) return;
    player.element.state.clearTrack(0);
    player.element.rotation = -Math.PI / 2;
    gun.alpha = 0;
    healthBar.container.alpha = 0;
    if (shootingBar) shootingBar.container.alpha = 0;
    teamView.container.alpha = 0.3;
    if (player.schema.dead) teamView.reviveText.alpha = 0;
    else teamView.reviveText.alpha = 1;
    const particleContainer = (0, $2ae84a41eb5f30ec$export$8e361a1ffbebf172).references.particles.get(clientId)?.container;
    if (particleContainer) particleContainer.alpha = 0;
    (0, $01e69bafe2fbba11$export$f5c9f43142e3a83e)(clientId);
};
const $8a8733686822a976$export$bf46dab662f54bbd = (element, text, color, stroke, scaleSize = 1)=>{
    if (!(0, $2ae84a41eb5f30ec$export$8e361a1ffbebf172).viewport) return;
    const textTexture = (0, $644b60ca123b58dd$export$eb0ce734bfb81799)(text, Math.max(6 * (0, $08054706be28954e$export$b402ad477cba9c4a)(), (0, $389fd98f2c1f982f$export$d0a8044dce8ff2fc).any ? 24 : 6) * scaleSize, color, stroke ?? 0xffffff);
    const scoreText = new (0, $e4c5b2569bd3a8d2$export$3075603db8e6204c)(textTexture.texture);
    scoreText.x = element.x + element.width / 2 - textTexture.metrics.width / 2;
    scoreText.y = element.y + element.height / 2 - textTexture.metrics.height / 2;
    scoreText.zIndex = Number.MAX_SAFE_INTEGER - 1;
    (0, $2ae84a41eb5f30ec$export$8e361a1ffbebf172).viewport.addChild(scoreText);
    (0, $52be045d3cbb2b80$export$99ee26438460406a).to(scoreText, {
        duration: 1,
        y: scoreText.y - textTexture.metrics.height,
        alpha: 0,
        onComplete () {
            scoreText.destroy();
        }
    });
};
const $8a8733686822a976$var$stickRadius = 50;
const $8a8733686822a976$export$e0c3b93ccbc60b76 = (x, y, pointerId, id)=>{
    if (!(0, $2ae84a41eb5f30ec$export$8e361a1ffbebf172).app || Object.values((0, $2ae84a41eb5f30ec$export$8e361a1ffbebf172).references.ui.level.sticks).find((stick)=>stick.id === id)) return;
    // bg
    const background = new (0, $48ce8a7de6645907$export$29d3e417456abdad)().lineStyle(2, 0xffffff, 0.3).beginFill(0x000000, 0.3).drawCircle(0, 0, $8a8733686822a976$var$stickRadius).endFill();
    background.eventMode = "none";
    background.position.set(x, y);
    // stick
    const stick = new (0, $48ce8a7de6645907$export$29d3e417456abdad)().lineStyle(2, 0xffffff, 1).beginFill(id === 0 ? 0xDD47A7 : 0x00B2FF).drawCircle(x, y, $8a8733686822a976$var$stickRadius * 0.4).endFill();
    stick.alpha = 0.75;
    stick.eventMode = "none";
    const oogy = new (0, $e4c5b2569bd3a8d2$export$3075603db8e6204c)((0, $2ae84a41eb5f30ec$export$8e361a1ffbebf172).resources["white-oogy"]);
    const oogyRatio = $8a8733686822a976$var$stickRadius * 0.4 / oogy.width;
    oogy.scale.set(oogyRatio, oogyRatio);
    oogy.position.set(x - oogy.width / 2, y - oogy.height / 2);
    stick.addChild(oogy);
    stick.cacheAsBitmap = true;
    background.addChild(stick);
    // obj
    (0, $2ae84a41eb5f30ec$export$8e361a1ffbebf172).references.ui.level.sticks[pointerId] = {
        id: id,
        background: background,
        stick: stick
    };
    (0, $2ae84a41eb5f30ec$export$8e361a1ffbebf172).app.stage.addChild(background, stick);
};
const $8a8733686822a976$export$3649cb3ade304ba8 = (x, y, pointerId)=>{
    if (!(0, $2ae84a41eb5f30ec$export$8e361a1ffbebf172).app || !(0, $2ae84a41eb5f30ec$export$8e361a1ffbebf172).viewport || !(0, $2ae84a41eb5f30ec$export$8e361a1ffbebf172).references.ui.level.sticks[pointerId]) return;
    const { background: background, stick: stick, id: id } = (0, $2ae84a41eb5f30ec$export$8e361a1ffbebf172).references.ui.level.sticks[pointerId];
    if (stick) {
        const { dx: dx, dy: dy } = (0, $08054706be28954e$export$8440e95db1cffa85)({
            x: x,
            y: y
        }, {
            x: background.x,
            y: background.y
        });
        const distance = Math.min($8a8733686822a976$var$stickRadius, (0, $08054706be28954e$export$5082664ed3e64ee8)(x, y, background.x, background.y));
        stick.x = dx * distance;
        stick.y = dy * distance;
    }
    return {
        id: id,
        coords: (0, $2ae84a41eb5f30ec$export$8e361a1ffbebf172).viewport.toLocal(background)
    };
};
const $8a8733686822a976$export$5bb7848590a7cd2a = (pointerId)=>{
    if (!(0, $2ae84a41eb5f30ec$export$8e361a1ffbebf172).app) return;
    const { id: id } = (0, $2ae84a41eb5f30ec$export$8e361a1ffbebf172).references.ui.level.sticks[pointerId];
    const obj = Object.values((0, $2ae84a41eb5f30ec$export$8e361a1ffbebf172).references.ui.level.sticks).find((stick)=>stick.id === id);
    if (!obj) return;
    obj.background.destroy();
    obj.stick.destroy();
    delete (0, $2ae84a41eb5f30ec$export$8e361a1ffbebf172).references.ui.level.sticks[pointerId];
    return id;
};
const $8a8733686822a976$export$8f9876f977727097 = (name, sprite, time)=>{
    if (!(0, $2ae84a41eb5f30ec$export$8e361a1ffbebf172).app) return;
    const entry = (0, $2ae84a41eb5f30ec$export$8e361a1ffbebf172).references.ui.level.countdowns?.find((countdown)=>countdown.name === name);
    if (entry) {
        entry.startingTime = new Date().getTime();
        entry.endingTime = entry.startingTime + time;
    } else {
        const container = new (0, $68e6944de5989822$export$42a852a2b6b56249)();
        const graphics = new $48ce8a7de6645907$export$29d3e417456abdad();
        graphics.x = 10 * (0, $08054706be28954e$export$b402ad477cba9c4a)();
        graphics.y = 10 * (0, $08054706be28954e$export$b402ad477cba9c4a)();
        container.x = 20 * (0, $08054706be28954e$export$b402ad477cba9c4a)();
        container.y = ((0, $2ae84a41eb5f30ec$export$8e361a1ffbebf172).references.ui.level.countdowns ?? []).length * 50 + (0, $08054706be28954e$export$4e851fc33b36a5f0)() * 0.15;
        sprite.x = 10 * (0, $08054706be28954e$export$b402ad477cba9c4a)() - sprite.width / 2;
        sprite.y = 10 * (0, $08054706be28954e$export$b402ad477cba9c4a)() - sprite.height / 2;
        container.addChild(sprite);
        container.addChild(graphics);
        if (!(0, $2ae84a41eb5f30ec$export$8e361a1ffbebf172).references.ui.level.countdowns) (0, $2ae84a41eb5f30ec$export$8e361a1ffbebf172).references.ui.level.countdowns = [];
        (0, $2ae84a41eb5f30ec$export$8e361a1ffbebf172).references.ui.level.countdowns.push({
            name: name,
            graphics: graphics,
            startingTime: new Date().getTime(),
            endingTime: new Date().getTime() + time,
            container: container
        });
        (0, $2ae84a41eb5f30ec$export$8e361a1ffbebf172).app.stage.addChild(container);
    }
};
const $8a8733686822a976$export$91391bfb6aaf2396 = async (level, skills)=>{
    if (!(0, $2ae84a41eb5f30ec$export$8e361a1ffbebf172).app) return;
    const container = new (0, $68e6944de5989822$export$42a852a2b6b56249)();
    container.alpha = 0;
    (0, $52be045d3cbb2b80$export$99ee26438460406a).to(container, {
        duration: 1,
        alpha: 1
    });
    // Title
    const title = new (0, $e4c5b2569bd3a8d2$export$3075603db8e6204c)((0, $2ae84a41eb5f30ec$export$8e361a1ffbebf172).resources["skills-title"]);
    const ratioTitle = Math.min(468, (0, $08054706be28954e$export$e692ebd4cea17cf3)()) / title.width;
    title.scale.set(ratioTitle, ratioTitle);
    title.y = (0, $08054706be28954e$export$4e851fc33b36a5f0)() * 0.15;
    container.x = (0, $08054706be28954e$export$e692ebd4cea17cf3)() / 2 - title.width / 2;
    // Title text
    const style = new (0, $3d453260a3c8e0f7$export$1df879243bf2e42d)({
        fontFamily: "Cees Hand",
        fontWeight: "400",
        fill: 0xffffff,
        fontSize: Math.min(Math.max(30, 15 * (0, $08054706be28954e$export$b402ad477cba9c4a)()), 36),
        align: "center"
    });
    const text = new (0, $f4ede730be703e5d$export$5f1af8db9871e1d6)("Choice of skill", style);
    const metrics = (0, $31f48a8131702733$export$4c5a129a59e1ef34).measureText(text.text, text.style);
    text.x = title.x + title.width / 2 - metrics.width / 2;
    text.y = title.y + title.height / 2 - metrics.height / 2;
    // Level text
    const levelStyle = new (0, $3d453260a3c8e0f7$export$1df879243bf2e42d)({
        fontFamily: "Cees Hand",
        fontWeight: "400",
        fill: 0xffffff,
        fontSize: Math.min(Math.max(20, 20 * (0, $08054706be28954e$export$b402ad477cba9c4a)()), 26),
        align: "center"
    });
    const levelText = new (0, $f4ede730be703e5d$export$5f1af8db9871e1d6)(`Level ${level}`, levelStyle);
    const metricsLevel = (0, $31f48a8131702733$export$4c5a129a59e1ef34).measureText(levelText.text, levelText.style);
    levelText.x = title.x + title.width / 2 - metricsLevel.width / 2;
    levelText.y = title.y - metricsLevel.height / 2;
    // Star
    const star = new (0, $e4c5b2569bd3a8d2$export$3075603db8e6204c)((0, $2ae84a41eb5f30ec$export$8e361a1ffbebf172).resources["skills-star"]);
    const ratioStar = Math.min(80, 80 * (0, $08054706be28954e$export$b402ad477cba9c4a)()) / star.width;
    star.scale.set(ratioStar, ratioStar);
    star.x = levelText.x + metricsLevel.width / 2 - star.width / 2;
    star.y = levelText.y - star.height * 1.25;
    // Star light
    const starLight = new (0, $e4c5b2569bd3a8d2$export$3075603db8e6204c)((0, $2ae84a41eb5f30ec$export$8e361a1ffbebf172).resources["star-light"]);
    const ratioStarLight = star.width * 1.5 / starLight.width;
    starLight.pivot.set(starLight.width / 2, starLight.height / 2);
    starLight.scale.set(ratioStarLight, ratioStarLight);
    starLight.x = star.x + star.width / 2;
    starLight.y = star.y + star.height / 2;
    (0, $52be045d3cbb2b80$export$99ee26438460406a).to(starLight, {
        ease: (0, $hKNIR.Linear).easeIn,
        duration: 1,
        rotation: Math.PI,
        repeat: -1
    });
    // Bg
    const bg = new (0, $48ce8a7de6645907$export$29d3e417456abdad)().beginFill(0x000000, 0.8).drawRect(-(0, $08054706be28954e$export$e692ebd4cea17cf3)(), -(0, $08054706be28954e$export$4e851fc33b36a5f0)(), 2 * (0, $08054706be28954e$export$e692ebd4cea17cf3)(), 2 * (0, $08054706be28954e$export$4e851fc33b36a5f0)()).endFill();
    // Timer
    const styleTimer = new (0, $3d453260a3c8e0f7$export$1df879243bf2e42d)({
        fontFamily: "Supersonic Rocketship",
        letterSpacing: 2,
        fontWeight: "400",
        fill: 0xffffff,
        fontSize: 34,
        align: "center"
    });
    let counter = 10;
    const textTimer = new (0, $f4ede730be703e5d$export$5f1af8db9871e1d6)(`${counter}`, styleTimer);
    const metricsTimer = (0, $31f48a8131702733$export$4c5a129a59e1ef34).measureText(textTimer.text, textTimer.style);
    textTimer.x = title.width / 2 - metricsTimer.width / 2;
    textTimer.y = (0, $08054706be28954e$export$4e851fc33b36a5f0)() - metricsTimer.height;
    setInterval(()=>{
        textTimer.text = --counter;
        if (counter === 0) {
            (0, $2ae84a41eb5f30ec$export$8e361a1ffbebf172).references.ui.skillMenu = undefined;
            container.destroy();
        }
    }, 1000);
    container.addChild(bg, title, text, levelText, starLight, star, textTimer);
    // Skills
    skills.forEach((entry, index)=>{
        const skill = new (0, $e4c5b2569bd3a8d2$export$3075603db8e6204c)((0, $2ae84a41eb5f30ec$export$8e361a1ffbebf172).resources[`skills-${entry.name}`]);
        const width = Math.min(468, (0, $08054706be28954e$export$e692ebd4cea17cf3)()) / 3;
        const ratioSkill = width / skill.width;
        skill.scale.set(ratioSkill, ratioSkill);
        skill.x = index * width * 1.5 + 0.25 * width;
        skill.y = (0, $08054706be28954e$export$4e851fc33b36a5f0)() / 1.75 - skill.height / 2;
        skill.eventMode = "static";
        skill.addEventListener("pointerup", ()=>{
            if (!(0, $2ae84a41eb5f30ec$export$8e361a1ffbebf172).room) return;
            (0, $67df0d5a88b62b5d$export$7995a6e010531143)((0, $2ae84a41eb5f30ec$export$8e361a1ffbebf172).room, index);
            container.destroy();
        });
        // Stars
        const starsContainer = new (0, $68e6944de5989822$export$42a852a2b6b56249)();
        for(let i = 0; i < 3; i++){
            const star = new (0, $e4c5b2569bd3a8d2$export$3075603db8e6204c)((0, $2ae84a41eb5f30ec$export$8e361a1ffbebf172).resources[entry.level > i ? "skills-star-full" : "skills-star-empty"]);
            const ratioStar = Math.min(20, 20 * (0, $08054706be28954e$export$b402ad477cba9c4a)()) / star.width;
            star.scale.set(ratioStar, ratioStar);
            star.x = i * 22;
            star.y = 0;
            starsContainer.addChild(star);
        }
        starsContainer.x = skill.x + skill.width / 2 - starsContainer.width / 2;
        starsContainer.y = skill.y + skill.height * 0.9;
        // Text
        const style = new (0, $3d453260a3c8e0f7$export$1df879243bf2e42d)({
            fontFamily: "Supersonic Rocketship",
            letterSpacing: 2,
            fontWeight: "400",
            fill: 0xffffff,
            fontSize: Math.min(Math.max(14, 14 * (0, $08054706be28954e$export$b402ad477cba9c4a)()), 18),
            align: "center",
            wordWrapWidth: skill.width
        });
        const textName = new (0, $f4ede730be703e5d$export$5f1af8db9871e1d6)(entry.name.replaceAll("-", " ").toUpperCase(), style);
        const metrics = (0, $31f48a8131702733$export$4c5a129a59e1ef34).measureText(textName.text, textName.style);
        textName.x = skill.x + skill.width / 2 - metrics.width / 2;
        textName.y = skill.y - 30;
        // Text
        const styleDescription = new (0, $3d453260a3c8e0f7$export$1df879243bf2e42d)({
            fontFamily: "Cees Hand",
            fontWeight: "400",
            fill: 0xffffff,
            fontSize: Math.min(Math.max(11, 11 * (0, $08054706be28954e$export$b402ad477cba9c4a)()), 16),
            align: "center",
            wordWrap: true,
            wordWrapWidth: skill.width
        });
        const text = new (0, $f4ede730be703e5d$export$5f1af8db9871e1d6)(entry.description, styleDescription);
        text.x = skill.x;
        text.y = skill.y + skill.height + 30;
        text.alpha = 0.6;
        container.addChild(skill, text, textName, starsContainer);
    });
    (0, $2ae84a41eb5f30ec$export$8e361a1ffbebf172).references.ui.skillMenu = container;
    container.zIndex = Number.MAX_SAFE_INTEGER;
    (0, $2ae84a41eb5f30ec$export$8e361a1ffbebf172).app.stage.addChild(container);
};
const $8a8733686822a976$export$47689854a9f10c34 = ()=>{
    if ((0, $2ae84a41eb5f30ec$export$8e361a1ffbebf172).references.ui.skillMenu) {
        (0, $2ae84a41eb5f30ec$export$8e361a1ffbebf172).references.ui.skillMenu.destroy();
        (0, $2ae84a41eb5f30ec$export$8e361a1ffbebf172).references.ui.skillMenu = undefined;
    }
};
const $8a8733686822a976$export$3aa3f29d6ab8aca1 = (playerSchema)=>{
    if (!(0, $2ae84a41eb5f30ec$export$8e361a1ffbebf172).viewport) return;
    const player = (0, $2ae84a41eb5f30ec$export$8e361a1ffbebf172).references.players.get(playerSchema.clientId);
    if (player && !(0, $2ae84a41eb5f30ec$export$8e361a1ffbebf172).references.ui.level.waitingDots.has(playerSchema.clientId)) {
        const dot1 = new (0, $48ce8a7de6645907$export$29d3e417456abdad)().beginFill(0x000000).drawCircle(0, 0, 5).endFill();
        const dot2 = new (0, $48ce8a7de6645907$export$29d3e417456abdad)().beginFill(0x000000).drawCircle(12, 0, 5).endFill();
        const dot3 = new (0, $48ce8a7de6645907$export$29d3e417456abdad)().beginFill(0x000000).drawCircle(24, 0, 5).endFill();
        dot1.alpha = 0;
        (0, $52be045d3cbb2b80$export$99ee26438460406a).to(dot1, {
            duration: 0.5,
            alpha: 1,
            yoyo: true,
            repeat: -1
        });
        dot2.alpha = 0;
        (0, $52be045d3cbb2b80$export$99ee26438460406a).to(dot2, {
            delay: 0.15,
            duration: 0.5,
            alpha: 1,
            yoyo: true,
            repeat: -1
        });
        dot3.alpha = 0;
        (0, $52be045d3cbb2b80$export$99ee26438460406a).to(dot3, {
            delay: 0.3,
            duration: 0.5,
            alpha: 1,
            yoyo: true,
            repeat: -1
        });
        const container = new (0, $68e6944de5989822$export$42a852a2b6b56249)();
        container.addChild(dot1, dot2, dot3);
        container.position.set(player.element.x - container.width / 2, player.element.y - player.element.height);
        container.zIndex = Number.MAX_SAFE_INTEGER - 10;
        (0, $2ae84a41eb5f30ec$export$8e361a1ffbebf172).references.ui.level.waitingDots.set(playerSchema.clientId, container);
        (0, $2ae84a41eb5f30ec$export$8e361a1ffbebf172).viewport.addChild(container);
    }
};
const $8a8733686822a976$export$6da15a9e776b5804 = (playerSchema)=>{
    const dots = (0, $2ae84a41eb5f30ec$export$8e361a1ffbebf172).references.ui.level.waitingDots.get(playerSchema.clientId);
    if (dots) {
        dots.destroy();
        (0, $2ae84a41eb5f30ec$export$8e361a1ffbebf172).references.ui.level.waitingDots.delete(playerSchema.clientId);
    }
};
const $8a8733686822a976$export$95f0f433472cf002 = (playerSchema)=>{
    if (!(0, $2ae84a41eb5f30ec$export$8e361a1ffbebf172).viewport) return;
    const player = (0, $2ae84a41eb5f30ec$export$8e361a1ffbebf172).references.players.get(playerSchema.clientId);
    if (player && !(0, $2ae84a41eb5f30ec$export$8e361a1ffbebf172).references.ui.level.icecube.has(playerSchema.clientId)) {
        const icecube = new (0, $e4c5b2569bd3a8d2$export$3075603db8e6204c)((0, $2ae84a41eb5f30ec$export$8e361a1ffbebf172).resources["icecube"]);
        const ratio = player.element.height / icecube.height * 1.4;
        icecube.scale.set(ratio, ratio);
        icecube.position.set(player.element.x - icecube.width / 2, player.element.y - icecube.height * 0.75);
        icecube.zIndex = Number.MAX_SAFE_INTEGER - player.element.zIndex + 1;
        (0, $2ae84a41eb5f30ec$export$8e361a1ffbebf172).references.ui.level.icecube.set(playerSchema.clientId, icecube);
        (0, $2ae84a41eb5f30ec$export$8e361a1ffbebf172).viewport.addChild(icecube);
    }
};
const $8a8733686822a976$export$b2b81cfa586767da = (playerSchema)=>{
    const icecube = (0, $2ae84a41eb5f30ec$export$8e361a1ffbebf172).references.ui.level.icecube.get(playerSchema.clientId);
    if (icecube) {
        icecube.destroy();
        (0, $2ae84a41eb5f30ec$export$8e361a1ffbebf172).references.ui.level.icecube.delete(playerSchema.clientId);
    }
};
const $8a8733686822a976$export$fce127d9d81d46ea = async (scoreValue, gems)=>{
    if (!(0, $2ae84a41eb5f30ec$export$8e361a1ffbebf172).level || !(0, $2ae84a41eb5f30ec$export$8e361a1ffbebf172).room || !(0, $2ae84a41eb5f30ec$export$8e361a1ffbebf172).app) return;
    (0, $2ae84a41eb5f30ec$export$8e361a1ffbebf172).external.showContinueMenu(true, (accepted)=>{
        if (!(0, $2ae84a41eb5f30ec$export$8e361a1ffbebf172).room) return;
        if (accepted) (0, $67df0d5a88b62b5d$export$92e964eb1ed51a5)((0, $2ae84a41eb5f30ec$export$8e361a1ffbebf172).room);
        else $8a8733686822a976$export$8024b47973af95ca(scoreValue, gems);
    });
};
const $8a8733686822a976$export$8024b47973af95ca = async (scoreValue, gems)=>{
    if (!(0, $2ae84a41eb5f30ec$export$8e361a1ffbebf172).app) return;
    (0, $2ae84a41eb5f30ec$export$8e361a1ffbebf172).external.showScoreMenu(scoreValue, gems);
    (0, $2ae84a41eb5f30ec$export$8e361a1ffbebf172).external.clearGame();
};
const $8a8733686822a976$export$f60a53667efadef8 = ()=>{
    if (!(0, $2ae84a41eb5f30ec$export$8e361a1ffbebf172).level || !(0, $2ae84a41eb5f30ec$export$8e361a1ffbebf172).room || !(0, $2ae84a41eb5f30ec$export$8e361a1ffbebf172).app) return;
    if ((0, $2ae84a41eb5f30ec$export$8e361a1ffbebf172).external.showPauseMenu) (0, $2ae84a41eb5f30ec$export$8e361a1ffbebf172).external.showPauseMenu(true, (muted)=>(0, $bf5e1bcc1f1c3d40$export$9fb19176558f2ffa)(muted));
};
const $8a8733686822a976$export$8102788c7b12d931 = ()=>{
    console.error("TODO hide continue menu");
};
const $8a8733686822a976$export$58784523761d3dbf = ()=>{
    console.error("TODO hide score menu");
};
const $8a8733686822a976$export$5077b2c5a115b59f = ()=>{
    console.error("TODO hide pause menu");
};






const $05e42dce750e973a$export$eee678d37a72577b = (room)=>{
    if (!(0, $2ae84a41eb5f30ec$export$8e361a1ffbebf172).level) return;
    (0, $5e6922f6744fcb9a$export$e553497b10624e79)(true, (0, $2ae84a41eb5f30ec$export$8e361a1ffbebf172).level.state.worldSize, (0, $2ae84a41eb5f30ec$export$8e361a1ffbebf172).level.state.worldSize);
    $05e42dce750e973a$export$c35ec80eadb71440();
    //initBackground('')
    (0, $8a8733686822a976$export$8040e0894456b767)(room);
    $05e42dce750e973a$export$1ccca6cde2544380();
    //gameState.level.state.players.forEach((player) => initPlayer(player.schema))
    // Init initial elements
    $05e42dce750e973a$var$initPlayers();
    $05e42dce750e973a$var$initItems();
    $05e42dce750e973a$var$initMonsters();
    //gameState.viewport!.moveCenter(getGameWidth() / 2, -getGameHeight() / 2)
    (0, $2ae84a41eb5f30ec$export$8e361a1ffbebf172).external.showLoading(false);
    (0, $2ae84a41eb5f30ec$export$8e361a1ffbebf172).loading = false;
// TEST
//gameState.level.state.ended = true
//showScoreMenu()
};
const $05e42dce750e973a$export$7861a7baf584a226 = ()=>{
    (0, $8a8733686822a976$export$5c853c5f828a43c2)();
};
const $05e42dce750e973a$var$initPlayers = ()=>{
    if (!(0, $2ae84a41eb5f30ec$export$8e361a1ffbebf172).references.players) return;
    (0, $2ae84a41eb5f30ec$export$8e361a1ffbebf172).references.players.forEach((info)=>{
        if (!(0, $2ae84a41eb5f30ec$export$8e361a1ffbebf172).viewport || !info?.element) return;
        (0, $2ae84a41eb5f30ec$export$8e361a1ffbebf172).viewport.addChild(info.element);
    });
};
const $05e42dce750e973a$var$initItems = ()=>{
    if (!(0, $2ae84a41eb5f30ec$export$8e361a1ffbebf172).references.items) return;
    (0, $2ae84a41eb5f30ec$export$8e361a1ffbebf172).references.items.forEach((info)=>{
        if (!(0, $2ae84a41eb5f30ec$export$8e361a1ffbebf172).viewport || !info?.element) return;
        (0, $2ae84a41eb5f30ec$export$8e361a1ffbebf172).viewport.addChild(info.element);
    });
};
const $05e42dce750e973a$var$initMonsters = ()=>{
    if (!(0, $2ae84a41eb5f30ec$export$8e361a1ffbebf172).references.monsters) return;
    (0, $2ae84a41eb5f30ec$export$8e361a1ffbebf172).references.monsters.forEach((monster)=>{
        if (!(0, $2ae84a41eb5f30ec$export$8e361a1ffbebf172).viewport || !monster?.container) return;
        (0, $2ae84a41eb5f30ec$export$8e361a1ffbebf172).viewport.addChild(monster.container);
    });
};
const $05e42dce750e973a$export$1197e9ca544859c8 = ()=>{
    (0, $2ae84a41eb5f30ec$export$8e361a1ffbebf172).references.players.forEach((player)=>{
        if (player) try {
            player.element.destroy();
        } catch  {}
    });
    (0, $2ae84a41eb5f30ec$export$8e361a1ffbebf172).references.monsters.forEach((monster)=>{
        if (monster) try {
            monster.container.destroy();
        } catch  {}
    });
    (0, $2ae84a41eb5f30ec$export$8e361a1ffbebf172).references.items.forEach((item)=>{
        if (item) try {
            item.element.destroy();
        } catch  {}
    });
    (0, $2ae84a41eb5f30ec$export$8e361a1ffbebf172).references.bullets.forEach((bullet)=>{
        if (bullet) try {
            bullet.element.destroy();
        } catch  {}
    });
    (0, $2ae84a41eb5f30ec$export$8e361a1ffbebf172).references.guns.forEach((gun)=>{
        if (gun) try {
            gun.destroy();
        } catch  {}
    });
    (0, $2ae84a41eb5f30ec$export$8e361a1ffbebf172).references.skills.forEach((guns)=>{
        guns.forEach((gun)=>{
            try {
                gun.element?.destroy();
            } catch  {}
        });
    });
    (0, $2ae84a41eb5f30ec$export$8e361a1ffbebf172).references.ui.level.auras.forEach((auras)=>{
        auras.forEach((aura)=>{
            try {
                aura.destroy();
            } catch  {}
        });
    });
    (0, $2ae84a41eb5f30ec$export$8e361a1ffbebf172).references.ui.level.healthBars.forEach((healthBar)=>{
        try {
            healthBar.container.destroy();
        } catch  {}
    });
    (0, $2ae84a41eb5f30ec$export$8e361a1ffbebf172).references.ui.level.shootingBars.forEach((shootingBar)=>{
        try {
            shootingBar.container.destroy();
        } catch  {}
    });
    (0, $2ae84a41eb5f30ec$export$8e361a1ffbebf172).references.ui.level.revives.forEach((revive)=>{
        try {
            revive.container?.destroy();
            revive.text?.destroy();
        } catch  {}
    });
    (0, $2ae84a41eb5f30ec$export$8e361a1ffbebf172).references.ui.level.pointers.forEach((pointer)=>{
        try {
            pointer.destroy();
        } catch  {}
    });
    (0, $2ae84a41eb5f30ec$export$8e361a1ffbebf172).references.ui.level.shadows.forEach((shadow)=>{
        try {
            shadow.destroy();
        } catch  {}
    });
    (0, $2ae84a41eb5f30ec$export$8e361a1ffbebf172).references.ui.level.waitingDots.forEach((waitingDots)=>{
        try {
            waitingDots.destroy();
        } catch  {}
    });
    (0, $2ae84a41eb5f30ec$export$8e361a1ffbebf172).references.ui.level.countdowns.forEach((countdown)=>{
        try {
            countdown.graphics.destroy();
        } catch  {}
    });
    (0, $2ae84a41eb5f30ec$export$8e361a1ffbebf172).references.players = new Map();
    (0, $2ae84a41eb5f30ec$export$8e361a1ffbebf172).references.monsters = new Map();
    (0, $2ae84a41eb5f30ec$export$8e361a1ffbebf172).references.items = new Map();
    (0, $2ae84a41eb5f30ec$export$8e361a1ffbebf172).references.bullets = new Map();
    (0, $2ae84a41eb5f30ec$export$8e361a1ffbebf172).references.guns = new Map();
    (0, $2ae84a41eb5f30ec$export$8e361a1ffbebf172).references.skills = new Map();
    (0, $2ae84a41eb5f30ec$export$8e361a1ffbebf172).references.ui.level.auras = new Map();
    (0, $2ae84a41eb5f30ec$export$8e361a1ffbebf172).references.ui.level.healthBars = new Map();
    (0, $2ae84a41eb5f30ec$export$8e361a1ffbebf172).references.ui.level.shootingBars = new Map();
    (0, $2ae84a41eb5f30ec$export$8e361a1ffbebf172).references.ui.level.revives = new Map();
    (0, $2ae84a41eb5f30ec$export$8e361a1ffbebf172).references.ui.level.pointers = new Map();
    (0, $2ae84a41eb5f30ec$export$8e361a1ffbebf172).references.ui.level.shadows = new Map();
    (0, $2ae84a41eb5f30ec$export$8e361a1ffbebf172).references.ui.level.waitingDots = new Map();
    (0, $2ae84a41eb5f30ec$export$8e361a1ffbebf172).references.ui.level.countdowns = [];
    (0, $2ae84a41eb5f30ec$export$8e361a1ffbebf172).references.ui.level.sticks = [];
};
const $05e42dce750e973a$export$c35ec80eadb71440 = ()=>{
    if (!(0, $2ae84a41eb5f30ec$export$8e361a1ffbebf172).level) return;
    (0, $bf5e1bcc1f1c3d40$export$9fb19176558f2ffa)((0, $bf5e1bcc1f1c3d40$export$83360306068d88f4)());
};
const $05e42dce750e973a$var$movement = new Set();
let $05e42dce750e973a$var$shootingAngleTimeout;
let $05e42dce750e973a$var$previousShootingAngle = 0;
const $05e42dce750e973a$export$1ccca6cde2544380 = ()=>{
    if (!(0, $2ae84a41eb5f30ec$export$8e361a1ffbebf172).viewport || !(0, $2ae84a41eb5f30ec$export$8e361a1ffbebf172).room) return;
    const room = (0, $2ae84a41eb5f30ec$export$8e361a1ffbebf172).room;
    if ((0, $389fd98f2c1f982f$export$d0a8044dce8ff2fc).any) {
        (0, $2ae84a41eb5f30ec$export$8e361a1ffbebf172).viewport.on("pointerdown", (event)=>{
            if (!(0, $2ae84a41eb5f30ec$export$8e361a1ffbebf172).viewport || !(0, $2ae84a41eb5f30ec$export$8e361a1ffbebf172).level) return;
            const playerSpine = (0, $2ae84a41eb5f30ec$export$8e361a1ffbebf172).references.players.get((0, $2ae84a41eb5f30ec$export$8e361a1ffbebf172).level.state.localPlayer.clientId)?.element;
            const gunSpine = (0, $2ae84a41eb5f30ec$export$8e361a1ffbebf172).references.guns.get((0, $2ae84a41eb5f30ec$export$8e361a1ffbebf172).level.state.localPlayer.clientId);
            if (!playerSpine || !gunSpine) return;
            const id = (0, $2ae84a41eb5f30ec$export$8e361a1ffbebf172).viewport.screenWidth / 2 > event.x ? 0 : 1;
            if (id === 0) {
                playerSpine.state.setAnimation(0, "WALK", true);
                gunSpine.state.setAnimation(0, "GUN_WALK", true);
            }
            (0, $8a8733686822a976$export$e0c3b93ccbc60b76)(event.x, event.y, event.pointerId, id);
        });
        (0, $2ae84a41eb5f30ec$export$8e361a1ffbebf172).viewport.on("pointermove", (event)=>{
            if (!(0, $2ae84a41eb5f30ec$export$8e361a1ffbebf172).level) return;
            const gunSpine = (0, $2ae84a41eb5f30ec$export$8e361a1ffbebf172).references.guns.get((0, $2ae84a41eb5f30ec$export$8e361a1ffbebf172).level.state.localPlayer.clientId);
            if ((0, $2ae84a41eb5f30ec$export$8e361a1ffbebf172).level.state.ended || !gunSpine || !(0, $2ae84a41eb5f30ec$export$8e361a1ffbebf172).viewport) return;
            const result = (0, $8a8733686822a976$export$3649cb3ade304ba8)(event.x, event.y, event.pointerId);
            if (!result) return;
            const x = gunSpine.x;
            const y = gunSpine.y;
            let { x: x2, y: y2 } = (0, $2ae84a41eb5f30ec$export$8e361a1ffbebf172).viewport.toLocal(event);
            x2 -= result.coords.x - x;
            y2 -= result.coords.y - y;
            if (result.id === 0) $05e42dce750e973a$var$updateMovementMobile((0, $08054706be28954e$export$afd58ae2e5ad6fa2)(x, y, x2, y2));
            else $05e42dce750e973a$export$ac9f316b305b015e(x, y, x2, y2, room);
        });
        (0, $2ae84a41eb5f30ec$export$8e361a1ffbebf172).viewport.on("pointerup", (event)=>{
            if (!(0, $2ae84a41eb5f30ec$export$8e361a1ffbebf172).viewport || !(0, $2ae84a41eb5f30ec$export$8e361a1ffbebf172).level) return;
            const playerSpine = (0, $2ae84a41eb5f30ec$export$8e361a1ffbebf172).references.players.get((0, $2ae84a41eb5f30ec$export$8e361a1ffbebf172).level.state.localPlayer.clientId)?.element;
            const gunSpine = (0, $2ae84a41eb5f30ec$export$8e361a1ffbebf172).references.guns.get((0, $2ae84a41eb5f30ec$export$8e361a1ffbebf172).level.state.localPlayer.clientId);
            if (!playerSpine || !gunSpine) return;
            const id = (0, $8a8733686822a976$export$5bb7848590a7cd2a)(event.pointerId);
            if (id === 0) {
                (0, $67df0d5a88b62b5d$export$8a856ecbecbdbcba)(room, false, $05e42dce750e973a$var$previousMobileMovementAngle);
                playerSpine.state.setAnimation(0, "IDLE", true);
                gunSpine.state.setAnimation(0, "GUN_IDLE", true);
            }
        });
        (0, $2ae84a41eb5f30ec$export$8e361a1ffbebf172).viewport.on("pointerupoutside", (event)=>{
            if (!(0, $2ae84a41eb5f30ec$export$8e361a1ffbebf172).viewport) return;
            const id = (0, $8a8733686822a976$export$5bb7848590a7cd2a)(event.pointerId);
            if (id === 0) (0, $67df0d5a88b62b5d$export$8a856ecbecbdbcba)(room, false, $05e42dce750e973a$var$previousMobileMovementAngle);
        });
    } else {
        (0, $2ae84a41eb5f30ec$export$8e361a1ffbebf172).viewport.on("pointermove", (event)=>{
            if (!(0, $2ae84a41eb5f30ec$export$8e361a1ffbebf172).level) return;
            const playerSpine = (0, $2ae84a41eb5f30ec$export$8e361a1ffbebf172).references.players.get((0, $2ae84a41eb5f30ec$export$8e361a1ffbebf172).level.state.localPlayer.clientId)?.element;
            const gunSpine = (0, $2ae84a41eb5f30ec$export$8e361a1ffbebf172).references.guns.get((0, $2ae84a41eb5f30ec$export$8e361a1ffbebf172).level.state.localPlayer.clientId);
            if ((0, $2ae84a41eb5f30ec$export$8e361a1ffbebf172).level.state.ended || !playerSpine || !gunSpine || !(0, $2ae84a41eb5f30ec$export$8e361a1ffbebf172).viewport) return;
            const x = gunSpine.x;
            const y = gunSpine.y;
            const { x: x2, y: y2 } = (0, $2ae84a41eb5f30ec$export$8e361a1ffbebf172).viewport.toLocal(event);
            //sound.play(SoundName.Shoot)
            $05e42dce750e973a$export$ac9f316b305b015e(x, y, x2, y2, room);
        });
        document.addEventListener("keydown", $05e42dce750e973a$var$onKeyDown);
        document.addEventListener("keyup", $05e42dce750e973a$var$onKeyUp);
    }
};
const $05e42dce750e973a$export$ac9f316b305b015e = (x, y, x2, y2, room)=>{
    if (!(0, $2ae84a41eb5f30ec$export$8e361a1ffbebf172).level) return;
    const playerSchema = (0, $2ae84a41eb5f30ec$export$8e361a1ffbebf172).references.players.get((0, $2ae84a41eb5f30ec$export$8e361a1ffbebf172).level.state.localPlayer.clientId)?.schema;
    const playerSpine = (0, $2ae84a41eb5f30ec$export$8e361a1ffbebf172).references.players.get((0, $2ae84a41eb5f30ec$export$8e361a1ffbebf172).level.state.localPlayer.clientId)?.element;
    const gunSpine = (0, $2ae84a41eb5f30ec$export$8e361a1ffbebf172).references.guns.get((0, $2ae84a41eb5f30ec$export$8e361a1ffbebf172).level.state.localPlayer.clientId);
    if ((0, $2ae84a41eb5f30ec$export$8e361a1ffbebf172).level.state.ended || !playerSpine || !gunSpine || !playerSchema || !(0, $2ae84a41eb5f30ec$export$8e361a1ffbebf172).viewport) return;
    if (playerSchema.frozen) return;
    //sound.play(SoundName.Shoot)
    const angle = (0, $08054706be28954e$export$afd58ae2e5ad6fa2)(x, y, x2, y2);
    if (Math.abs(Math.abs(angle) - Math.abs($05e42dce750e973a$var$previousShootingAngle)) > 0.02) {
        clearTimeout($05e42dce750e973a$var$shootingAngleTimeout);
        $05e42dce750e973a$var$previousShootingAngle = angle;
        (0, $67df0d5a88b62b5d$export$b427202c7761bd)(room, angle);
    } else {
        clearTimeout($05e42dce750e973a$var$shootingAngleTimeout);
        $05e42dce750e973a$var$shootingAngleTimeout = setTimeout(()=>{
            $05e42dce750e973a$var$previousShootingAngle = angle;
            (0, $67df0d5a88b62b5d$export$b427202c7761bd)(room, angle);
        }, 100);
    }
    const preparedAngle = angle + Math.PI / 2;
    if (preparedAngle < Math.PI) {
        playerSpine.skeleton.scaleX = 1;
        gunSpine.skeleton.scaleX = 1;
    } else {
        playerSpine.skeleton.scaleX = -1;
        gunSpine.skeleton.scaleX = -1;
    }
    gunSpine.rotation = angle < Math.PI / 2 ? angle : angle - Math.PI;
    const emitter = (0, $2ae84a41eb5f30ec$export$8e361a1ffbebf172).references.particles.get((0, $2ae84a41eb5f30ec$export$8e361a1ffbebf172).level.state.localPlayer.clientId)?.emitter;
    if (emitter) emitter.rotate(angle - Math.PI / 2 - 0.1);
};
const $05e42dce750e973a$export$816913e06fd3bcf5 = ()=>{
    if (!(0, $2ae84a41eb5f30ec$export$8e361a1ffbebf172).level) return;
    const player = (0, $2ae84a41eb5f30ec$export$8e361a1ffbebf172).references.players.get((0, $2ae84a41eb5f30ec$export$8e361a1ffbebf172).level.state.localPlayer.clientId);
    if (!player) return;
    const shootingBar = (0, $2ae84a41eb5f30ec$export$8e361a1ffbebf172).references.ui.level.shootingBars.get(player.schema.clientId);
    if (!shootingBar) return;
    // Shooting progress
    const progress = (Date.now() - player.lastShootingTime) / player.schema.weapon.shootingCooldown;
    shootingBar.bar.scale.x = Math.min(1, progress);
    // Circular countdown
    (0, $2ae84a41eb5f30ec$export$8e361a1ffbebf172).references.ui.level.revives.forEach(({ container: container, max: max, left: left, graphics: graphics }, clientId)=>{
        if (!(0, $2ae84a41eb5f30ec$export$8e361a1ffbebf172).app || !max || !left || !container || !graphics) return;
        const completion = 1 - left / max;
        if (completion >= 1 || left <= 0) (0, $8a8733686822a976$export$5eab396bc76aace8)(clientId);
        else graphics.clear().lineStyle(3 * (0, $08054706be28954e$export$b402ad477cba9c4a)(), 0x601a15, 0.5).arc(0, 0, 20 * (0, $08054706be28954e$export$b402ad477cba9c4a)(), 0, 360 * (1 - completion) * Math.PI / 180, false);
    });
};
const $05e42dce750e973a$var$onKeyDown = (event)=>{
    switch(event.code){
        case "KeyW":
        case "ArrowUp":
            $05e42dce750e973a$var$movement.add("t");
            $05e42dce750e973a$var$movement.delete("b");
            break;
        case "KeyA":
        case "ArrowLeft":
            $05e42dce750e973a$var$movement.add("l");
            $05e42dce750e973a$var$movement.delete("r");
            break;
        case "KeyS":
        case "ArrowDown":
            $05e42dce750e973a$var$movement.add("b");
            $05e42dce750e973a$var$movement.delete("t");
            break;
        case "KeyD":
        case "ArrowRight":
            $05e42dce750e973a$var$movement.add("r");
            $05e42dce750e973a$var$movement.delete("l");
            break;
    }
    $05e42dce750e973a$var$updateMovementKeyboard();
};
const $05e42dce750e973a$var$onKeyUp = (event)=>{
    if (!(0, $2ae84a41eb5f30ec$export$8e361a1ffbebf172).level) return;
    switch(event.code){
        case "KeyW":
        case "ArrowUp":
            $05e42dce750e973a$var$movement.delete("t");
            break;
        case "KeyA":
        case "ArrowLeft":
            $05e42dce750e973a$var$movement.delete("l");
            break;
        case "KeyS":
        case "ArrowDown":
            $05e42dce750e973a$var$movement.delete("b");
            break;
        case "KeyD":
        case "ArrowRight":
            $05e42dce750e973a$var$movement.delete("r");
            break;
    }
    $05e42dce750e973a$var$updateMovementKeyboard();
};
const $05e42dce750e973a$var$updateMovementKeyboard = ()=>{
    if (!(0, $2ae84a41eb5f30ec$export$8e361a1ffbebf172).room || !(0, $2ae84a41eb5f30ec$export$8e361a1ffbebf172).level) return;
    const playerSchema = (0, $2ae84a41eb5f30ec$export$8e361a1ffbebf172).references.players.get((0, $2ae84a41eb5f30ec$export$8e361a1ffbebf172).level.state.localPlayer.clientId)?.schema;
    const playerSpine = (0, $2ae84a41eb5f30ec$export$8e361a1ffbebf172).references.players.get((0, $2ae84a41eb5f30ec$export$8e361a1ffbebf172).level.state.localPlayer.clientId)?.element;
    const gunSpine = (0, $2ae84a41eb5f30ec$export$8e361a1ffbebf172).references.guns.get((0, $2ae84a41eb5f30ec$export$8e361a1ffbebf172).level.state.localPlayer.clientId);
    if (!playerSpine || !gunSpine || !playerSchema) return;
    let angle = 0;
    if ($05e42dce750e973a$var$movement.has("t")) {
        angle = 270;
        if ($05e42dce750e973a$var$movement.has("l")) angle -= 45;
        else if ($05e42dce750e973a$var$movement.has("r")) angle += 45;
    } else if ($05e42dce750e973a$var$movement.has("b")) {
        angle = 90;
        if ($05e42dce750e973a$var$movement.has("l")) angle += 45;
        else if ($05e42dce750e973a$var$movement.has("r")) angle -= 45;
    } else if ($05e42dce750e973a$var$movement.has("l")) angle = 180;
    else if ($05e42dce750e973a$var$movement.has("r")) angle = 0;
    if (playerSchema.frozen) return;
    if ($05e42dce750e973a$var$movement.size > 0) {
        if (playerSpine.state.tracks[0]?.animation?.name === "IDLE") {
            playerSpine.state.setAnimation(0, "WALK", true);
            gunSpine.state.setAnimation(0, "GUN_WALK", true);
        }
    } else if (playerSpine.state.tracks[0]?.animation?.name === "WALK") {
        playerSpine.state.setAnimation(0, "IDLE", true);
        gunSpine.state.setAnimation(0, "GUN_IDLE", true);
    }
    (0, $67df0d5a88b62b5d$export$8a856ecbecbdbcba)((0, $2ae84a41eb5f30ec$export$8e361a1ffbebf172).room, $05e42dce750e973a$var$movement.size > 0, (0, $08054706be28954e$export$c9fcf1a7df975d78)(angle));
};
let $05e42dce750e973a$var$previousMobileMovementAngle = 0;
const $05e42dce750e973a$var$updateMovementMobile = (angle)=>{
    if (!(0, $2ae84a41eb5f30ec$export$8e361a1ffbebf172).room || !(0, $2ae84a41eb5f30ec$export$8e361a1ffbebf172).level) return;
    const playerSchema = (0, $2ae84a41eb5f30ec$export$8e361a1ffbebf172).references.players.get((0, $2ae84a41eb5f30ec$export$8e361a1ffbebf172).level.state.localPlayer.clientId)?.schema;
    const playerSpine = (0, $2ae84a41eb5f30ec$export$8e361a1ffbebf172).references.players.get((0, $2ae84a41eb5f30ec$export$8e361a1ffbebf172).level.state.localPlayer.clientId)?.element;
    const gunSpine = (0, $2ae84a41eb5f30ec$export$8e361a1ffbebf172).references.guns.get((0, $2ae84a41eb5f30ec$export$8e361a1ffbebf172).level.state.localPlayer.clientId);
    if (!playerSpine || !gunSpine || !playerSchema) return;
    const degrees = (0, $08054706be28954e$export$c41dd2a8460d3196)(angle) + 90;
    if (!playerSchema.frozen && Math.abs($05e42dce750e973a$var$previousMobileMovementAngle - degrees) > 5) {
        $05e42dce750e973a$var$previousMobileMovementAngle = degrees;
        (0, $67df0d5a88b62b5d$export$8a856ecbecbdbcba)((0, $2ae84a41eb5f30ec$export$8e361a1ffbebf172).room, true, angle);
    }
};
const $05e42dce750e973a$export$665e313beff80f41 = async ()=>{
    if (!(0, $2ae84a41eb5f30ec$export$8e361a1ffbebf172).level || !(0, $2ae84a41eb5f30ec$export$8e361a1ffbebf172).app) return;
    (0, $2ae84a41eb5f30ec$export$8e361a1ffbebf172).app.stage.removeAllListeners();
    (0, $2ae84a41eb5f30ec$export$8e361a1ffbebf172).viewport?.removeAllListeners();
    document.removeEventListener("keydown", $05e42dce750e973a$var$onKeyDown);
    document.removeEventListener("keyup", $05e42dce750e973a$var$onKeyUp);
};









const $065042de654ce1e3$export$6bfe48b773b8c251 = (aoeSchema)=>{
    switch(aoeSchema.type){
        case (0, $49736469f58fc92b$export$31daa950d4530805).Electricity:
            $065042de654ce1e3$var$showElectricityAOE(aoeSchema, undefined, (0, $49736469f58fc92b$export$93445e7da77bf239).SkillDefensiveZone);
            break;
        case (0, $49736469f58fc92b$export$31daa950d4530805).Poison:
            $065042de654ce1e3$var$showPoisonAOE(aoeSchema);
            break;
    }
};
const $065042de654ce1e3$export$4c85909d0d563c34 = (aoeSchema)=>{
    const aoe = (0, $2ae84a41eb5f30ec$export$8e361a1ffbebf172).references.ui.level.aoe.get(aoeSchema.uid);
    if (aoe) try {
        (0, $2ae84a41eb5f30ec$export$8e361a1ffbebf172).references.ui.level.aoe.delete(aoeSchema.uid);
        aoe.destroy();
    } catch (err) {}
};
const $065042de654ce1e3$var$showElectricityAOE = (aoeSchema, tint, soundName)=>{
    if (!(0, $2ae84a41eb5f30ec$export$8e361a1ffbebf172).viewport) return;
    const aoe = new (0, $784388461c50e8a6$export$ce0a100797286aea)((0, $2ae84a41eb5f30ec$export$8e361a1ffbebf172).resources["electricity-aoe"].spineData);
    if (tint) aoe.tint = tint;
    const auraRatio = aoeSchema.width / aoe.width * 2;
    aoe.pivot.x -= aoe.height * 0.03;
    aoe.pivot.y -= aoe.height * 0.29;
    aoe.alpha = 0.1;
    aoe.scale.set(auraRatio, auraRatio);
    aoe.x = aoeSchema.x;
    aoe.y = aoeSchema.y;
    aoe.zIndex = 12;
    aoe.state.setAnimation(0, "IDLE", true);
    (0, $52be045d3cbb2b80$export$99ee26438460406a).to(aoe, {
        delay: aoeSchema.waveCooldown / 1000 * (aoeSchema.maxWaves - 1),
        duration: aoeSchema.waveCooldown / 1000,
        alpha: 0,
        onComplete () {
            aoe.destroy();
        }
    });
    (0, $2ae84a41eb5f30ec$export$8e361a1ffbebf172).references.ui.level.aoe.set((0, $49736469f58fc92b$export$31daa950d4530805).Electricity, aoe);
    (0, $2ae84a41eb5f30ec$export$8e361a1ffbebf172).viewport.addChild(aoe);
    if (soundName) {
        const localPlayer = (0, $2ae84a41eb5f30ec$export$8e361a1ffbebf172).level?.state.localPlayer;
        if (!localPlayer) return;
        const sparksSound = (0, $52a374576fbfc221$export$eab32dcfc4ded11c).find(soundName);
        if (sparksSound) (0, $bf5e1bcc1f1c3d40$export$ccd4e8223abfd366)(localPlayer, aoe, sparksSound);
    }
};
const $065042de654ce1e3$var$showPoisonAOE = (aoeSchema)=>{
    $065042de654ce1e3$var$showElectricityAOE(aoeSchema, 0x33ff33);
};







const $306846f4386fc4d8$export$e16ca81dc50a9aa2 = (playerSchema, type)=>{
    switch(type){
        case (0, $49736469f58fc92b$export$f23cdcd4167bcde7).Heal:
            $306846f4386fc4d8$export$9f9cb8bc86028783(playerSchema);
            break;
        case (0, $49736469f58fc92b$export$f23cdcd4167bcde7).Shield:
            $306846f4386fc4d8$export$f9786a98d6ddc3a3(playerSchema);
            break;
    }
};
const $306846f4386fc4d8$export$d41c20423d67868d = (playerSchema, type)=>{
    const auras = (0, $2ae84a41eb5f30ec$export$8e361a1ffbebf172).references.ui.level.auras.get(playerSchema.clientId);
    if (!auras) return;
    const aura = auras.get(type);
    if (aura) try {
        auras.delete(type);
        aura.destroy();
    } catch (err) {}
};
const $306846f4386fc4d8$export$9f9cb8bc86028783 = (playerSchema)=>{
    if (!(0, $2ae84a41eb5f30ec$export$8e361a1ffbebf172).viewport) return;
    const playerSpine = (0, $2ae84a41eb5f30ec$export$8e361a1ffbebf172).references.players.get(playerSchema.clientId)?.element;
    let auras = (0, $2ae84a41eb5f30ec$export$8e361a1ffbebf172).references.ui.level.auras.get(playerSchema.clientId);
    if (!auras) {
        auras = new Map();
        (0, $2ae84a41eb5f30ec$export$8e361a1ffbebf172).references.ui.level.auras.set(playerSchema.clientId, auras);
    }
    if (!playerSpine) return;
    const aura = new (0, $784388461c50e8a6$export$ce0a100797286aea)((0, $2ae84a41eb5f30ec$export$8e361a1ffbebf172).resources["heal-aura"].spineData);
    const auraRatio = Math.max(playerSpine.width / aura.width, playerSpine.height / aura.height) * 1.2;
    aura.pivot.y -= playerSpine.height / 2;
    aura.alpha = 0.75;
    aura.scale.set(auraRatio, auraRatio);
    aura.x = playerSpine.x;
    aura.y = playerSpine.y;
    aura.zIndex = Number.MAX_SAFE_INTEGER;
    aura.state.addListener({
        complete (entry) {
            if (entry.animation?.name === "IDLE") setTimeout(()=>{
                try {
                    aura.destroy();
                    auras?.delete((0, $49736469f58fc92b$export$f23cdcd4167bcde7).Heal);
                // eslint-disable-next-line no-empty
                } catch  {}
            });
        }
    });
    aura.state.setAnimation(0, "IDLE");
    auras.set((0, $49736469f58fc92b$export$f23cdcd4167bcde7).Heal, aura);
    (0, $2ae84a41eb5f30ec$export$8e361a1ffbebf172).viewport.addChild(aura);
    const localPlayer = (0, $2ae84a41eb5f30ec$export$8e361a1ffbebf172).level?.state.localPlayer;
    if (!localPlayer) return;
    const healSound = (0, $52a374576fbfc221$export$eab32dcfc4ded11c).find((0, $49736469f58fc92b$export$93445e7da77bf239).SkillHealingDrone);
    if (healSound) (0, $bf5e1bcc1f1c3d40$export$ccd4e8223abfd366)(localPlayer, aura, healSound);
};
const $306846f4386fc4d8$export$f9786a98d6ddc3a3 = (playerSchema)=>{
    if (!(0, $2ae84a41eb5f30ec$export$8e361a1ffbebf172).viewport) return;
    const playerSpine = (0, $2ae84a41eb5f30ec$export$8e361a1ffbebf172).references.players.get(playerSchema.clientId)?.element;
    let auras = (0, $2ae84a41eb5f30ec$export$8e361a1ffbebf172).references.ui.level.auras.get(playerSchema.clientId);
    if (!auras) {
        auras = new Map();
        (0, $2ae84a41eb5f30ec$export$8e361a1ffbebf172).references.ui.level.auras.set(playerSchema.clientId, auras);
    }
    if (!playerSpine) return;
    const aura = new (0, $784388461c50e8a6$export$ce0a100797286aea)((0, $2ae84a41eb5f30ec$export$8e361a1ffbebf172).resources["power-aura"].spineData);
    const auraRatio = Math.max(playerSpine.width / aura.width, playerSpine.height / aura.height) * 2;
    aura.pivot.y -= playerSpine.height / 2;
    aura.alpha = 0.75;
    aura.scale.set(auraRatio, auraRatio);
    aura.x = playerSpine.x;
    aura.y = playerSpine.y;
    aura.zIndex = 12;
    aura.state.setAnimation(0, "IDLE", true);
    auras.set((0, $49736469f58fc92b$export$f23cdcd4167bcde7).Shield, aura);
    (0, $2ae84a41eb5f30ec$export$8e361a1ffbebf172).viewport.addChild(aura);
    const localPlayer = (0, $2ae84a41eb5f30ec$export$8e361a1ffbebf172).level?.state.localPlayer;
    if (!localPlayer) return;
    const shieldSound = (0, $52a374576fbfc221$export$eab32dcfc4ded11c).find((0, $49736469f58fc92b$export$93445e7da77bf239).ItemShield);
    if (shieldSound) (0, $bf5e1bcc1f1c3d40$export$ccd4e8223abfd366)(localPlayer, aura, shieldSound);
};
const $306846f4386fc4d8$export$93438e5c7112cadf = (delta)=>{
    if (!(0, $2ae84a41eb5f30ec$export$8e361a1ffbebf172).level || (0, $2ae84a41eb5f30ec$export$8e361a1ffbebf172).level.state.ended) return;
    (0, $2ae84a41eb5f30ec$export$8e361a1ffbebf172).references.players.forEach((_, clientId)=>{
        const auras = (0, $2ae84a41eb5f30ec$export$8e361a1ffbebf172).references.ui.level.auras.get(clientId);
        if (!auras || auras.size === 0) return;
        const playerSpine = (0, $2ae84a41eb5f30ec$export$8e361a1ffbebf172).references.players.get(clientId)?.element;
        if (!playerSpine) return;
        auras.forEach((aura)=>{
            aura.x = playerSpine.x;
            aura.y = playerSpine.y;
        });
    });
};





const $aaefdfdf2979f735$export$5ca18fec3e208ab3 = (name)=>{
    if (!(0, $2ae84a41eb5f30ec$export$8e361a1ffbebf172).viewport || !(0, $2ae84a41eb5f30ec$export$8e361a1ffbebf172).resources || !(0, $2ae84a41eb5f30ec$export$8e361a1ffbebf172).level) return;
    const sprite = new (0, $ea853049c58b0073$export$db8370cd1ebcc819)((0, $2ae84a41eb5f30ec$export$8e361a1ffbebf172).resources[`level-bg-${name}`], (0, $2ae84a41eb5f30ec$export$8e361a1ffbebf172).level.state.worldSize, (0, $2ae84a41eb5f30ec$export$8e361a1ffbebf172).level.state.worldSize);
    sprite.zIndex = 1;
    //sprite.alpha = 0.7
    if ((0, $2ae84a41eb5f30ec$export$8e361a1ffbebf172).references.ui.level.background) {
        sprite.zIndex = 0;
        (0, $52be045d3cbb2b80$export$99ee26438460406a).to((0, $2ae84a41eb5f30ec$export$8e361a1ffbebf172).references.ui.level.background, {
            duration: 1,
            alpha: 0
        }).then(()=>{
            (0, $2ae84a41eb5f30ec$export$8e361a1ffbebf172).references.ui.level.background?.destroy();
            (0, $2ae84a41eb5f30ec$export$8e361a1ffbebf172).references.ui.level.background = sprite;
            sprite.zIndex = 1;
        });
    } else (0, $2ae84a41eb5f30ec$export$8e361a1ffbebf172).references.ui.level.background = sprite;
    (0, $2ae84a41eb5f30ec$export$8e361a1ffbebf172).viewport.addChild(sprite);
};









const $09e18a5b5cfd97a5$export$55f9a21552db92bd = (bulletSchema, launchingElement)=>{
    let element;
    let ratio;
    switch(bulletSchema.type){
        case (0, $49736469f58fc92b$export$f90411c24f6aebf8).Yellow:
        case (0, $49736469f58fc92b$export$f90411c24f6aebf8).Blue:
        case (0, $49736469f58fc92b$export$f90411c24f6aebf8).Pink:
        case (0, $49736469f58fc92b$export$f90411c24f6aebf8).Red:
        case (0, $49736469f58fc92b$export$f90411c24f6aebf8).XSMAS:
        case (0, $49736469f58fc92b$export$f90411c24f6aebf8).Riffle:
        case (0, $49736469f58fc92b$export$f90411c24f6aebf8).Slime:
            element = new (0, $e4c5b2569bd3a8d2$export$3075603db8e6204c)((0, $2ae84a41eb5f30ec$export$8e361a1ffbebf172).resources[`${bulletSchema.type}-bullet`]);
            ratio = Math.max(bulletSchema.width / element.width, bulletSchema.height / element.height);
            element.pivot.set(0, element.height / 2);
            element.scale.set(ratio, ratio);
            element.position.set(launchingElement ? launchingElement.x : bulletSchema.x, launchingElement ? launchingElement.y : bulletSchema.y);
            element.zIndex = 10;
            break;
        case (0, $49736469f58fc92b$export$f90411c24f6aebf8).Carrot:
            element = new (0, $e4c5b2569bd3a8d2$export$3075603db8e6204c)((0, $2ae84a41eb5f30ec$export$8e361a1ffbebf172).resources[`${bulletSchema.type}-bullet`]);
            ratio = Math.max(bulletSchema.width / element.width, bulletSchema.height / element.height) * 1.45;
            element.pivot.set(0, element.height / 2);
            element.scale.set(ratio, ratio);
            element.position.set(launchingElement ? launchingElement.x : bulletSchema.x, launchingElement ? launchingElement.y : bulletSchema.y);
            element.zIndex = 10;
            break;
        case (0, $49736469f58fc92b$export$f90411c24f6aebf8).Card:
            element = new (0, $e4c5b2569bd3a8d2$export$3075603db8e6204c)((0, $2ae84a41eb5f30ec$export$8e361a1ffbebf172).resources[`${bulletSchema.type}-bullet`]);
            ratio = Math.max(bulletSchema.width / element.width, bulletSchema.height / element.height);
            element.pivot.set(element.width / 2, element.height / 2);
            element.scale.set(ratio, ratio);
            element.position.set(launchingElement ? launchingElement.x : bulletSchema.x, launchingElement ? launchingElement.y : bulletSchema.y);
            element.zIndex = 10;
            break;
        case (0, $49736469f58fc92b$export$f90411c24f6aebf8).Boss1:
        case (0, $49736469f58fc92b$export$f90411c24f6aebf8).Rocket:
            element = new (0, $784388461c50e8a6$export$ce0a100797286aea)((0, $2ae84a41eb5f30ec$export$8e361a1ffbebf172).resources[`${bulletSchema.type}-bullet`].spineData);
            ratio = Math.max(bulletSchema.width / element.width, bulletSchema.height / element.height);
            //element.pivot.set(element.width / 2, element.height / 2)
            element.scale.set(ratio, ratio);
            element.position.set(bulletSchema.x, bulletSchema.y);
            element.state.setAnimationByName(0, "IDLE", true);
            element.zIndex = Number.MAX_SAFE_INTEGER - 2;
            break;
        case (0, $49736469f58fc92b$export$f90411c24f6aebf8).Boss2:
        case (0, $49736469f58fc92b$export$f90411c24f6aebf8).Yeti:
            element = new (0, $e4c5b2569bd3a8d2$export$3075603db8e6204c)((0, $2ae84a41eb5f30ec$export$8e361a1ffbebf172).resources[`${bulletSchema.type}-bullet`]);
            ratio = Math.max(bulletSchema.width / element.width, bulletSchema.height / element.height);
            element.pivot.set(element.width / 2, element.height / 2);
            element.scale.set(ratio, ratio);
            element.position.set(bulletSchema.x, bulletSchema.y);
            element.zIndex = Number.MAX_SAFE_INTEGER - 2;
            break;
    }
    return element;
};
const $09e18a5b5cfd97a5$export$77053d071c37a130 = (bulletSchema)=>{
    if (!(0, $2ae84a41eb5f30ec$export$8e361a1ffbebf172).viewport || !(0, $2ae84a41eb5f30ec$export$8e361a1ffbebf172).level) return;
    let launchingElement;
    if (bulletSchema.fromPlayerId) {
        const playerState = (0, $2ae84a41eb5f30ec$export$8e361a1ffbebf172).references.players.get(bulletSchema.fromPlayerId);
        if (bulletSchema.type === (0, $49736469f58fc92b$export$f90411c24f6aebf8).Rocket) launchingElement = (0, $2ae84a41eb5f30ec$export$8e361a1ffbebf172).references.skills.get(bulletSchema.fromPlayerId)?.get((0, $49736469f58fc92b$export$118171a82d109c04).RocketDrone)?.element;
        else launchingElement = (0, $2ae84a41eb5f30ec$export$8e361a1ffbebf172).references.guns.get(bulletSchema.fromPlayerId);
        if (playerState && bulletSchema.type !== (0, $49736469f58fc92b$export$f90411c24f6aebf8).Rocket && bulletSchema.fromPlayerId && bulletSchema.fromPlayerId === (0, $2ae84a41eb5f30ec$export$8e361a1ffbebf172).level.state.localPlayer?.clientId) playerState.lastShootingTime = Date.now();
    }
    const bulletList = (0, $2ae84a41eb5f30ec$export$8e361a1ffbebf172).references.bullets;
    const bullet = $09e18a5b5cfd97a5$export$55f9a21552db92bd(bulletSchema, launchingElement);
    if (!bullet) return;
    const data = {
        element: bullet,
        schema: bulletSchema
    };
    bulletList.set(bulletSchema.uid, data);
    (0, $2ae84a41eb5f30ec$export$8e361a1ffbebf172).viewport.addChild(bullet);
    return data;
};
const $09e18a5b5cfd97a5$export$93459cb00f314e10 = (bullet, sound)=>{
    if (!(0, $2ae84a41eb5f30ec$export$8e361a1ffbebf172).references.bullets) return;
    if (sound) sound.play();
    const localBullet = (0, $2ae84a41eb5f30ec$export$8e361a1ffbebf172).references.bullets.get(bullet.uid);
    if (localBullet) {
        (0, $2ae84a41eb5f30ec$export$8e361a1ffbebf172).references.bullets.delete(bullet.uid);
        localBullet.element.destroy();
    }
};
const $09e18a5b5cfd97a5$export$4971bcc2704b21ab = (x, y, width, height)=>{
    if (!(0, $2ae84a41eb5f30ec$export$8e361a1ffbebf172).viewport) return;
    const explosion = new (0, $784388461c50e8a6$export$ce0a100797286aea)((0, $2ae84a41eb5f30ec$export$8e361a1ffbebf172).resources["rocket-explosion"].spineData);
    const explosionRatio = width / explosion.width;
    explosion.scale.set(explosionRatio, explosionRatio);
    explosion.x = x;
    explosion.y = y;
    explosion.zIndex = Number.MAX_SAFE_INTEGER;
    explosion.state.addListener({
        complete (entry) {
            if (entry.animation?.name === "EXPLOSION") setTimeout(()=>{
                try {
                    explosion.destroy();
                // eslint-disable-next-line no-empty
                } catch  {}
            });
        }
    });
    explosion.state.setAnimation(0, "EXPLOSION");
    (0, $2ae84a41eb5f30ec$export$8e361a1ffbebf172).viewport.addChild(explosion);
    const localPlayer = (0, $2ae84a41eb5f30ec$export$8e361a1ffbebf172).level?.state.localPlayer;
    if (!localPlayer) return;
    const explosionSound = (0, $52a374576fbfc221$export$eab32dcfc4ded11c).find((0, $49736469f58fc92b$export$93445e7da77bf239).SkillRocketDrone);
    if (explosionSound) (0, $bf5e1bcc1f1c3d40$export$ccd4e8223abfd366)(localPlayer, explosion, explosionSound);
};
const $09e18a5b5cfd97a5$export$9d806718d0c89581 = (x, y)=>{
    const localPlayer = (0, $2ae84a41eb5f30ec$export$8e361a1ffbebf172).level?.state.localPlayer;
    if (!localPlayer) return;
    const impactSound = (0, $52a374576fbfc221$export$eab32dcfc4ded11c).find((0, $49736469f58fc92b$export$93445e7da77bf239).Impact);
    if (impactSound) (0, $bf5e1bcc1f1c3d40$export$ccd4e8223abfd366)(localPlayer, {
        x: x,
        y: y
    }, impactSound);
};
const $09e18a5b5cfd97a5$export$c5d039b432737f65 = (delta)=>{
    const bulletsList = (0, $2ae84a41eb5f30ec$export$8e361a1ffbebf172).references.bullets;
    if (!(0, $2ae84a41eb5f30ec$export$8e361a1ffbebf172).viewport || !(0, $2ae84a41eb5f30ec$export$8e361a1ffbebf172).level || !bulletsList) return;
    bulletsList.forEach((bullet)=>{
        if (!bullet) return;
        const delta01 = delta * (bullet.schema.ellipticMovement ? 0.2 : 0.02);
        const { x: x, y: y } = bullet.element;
        const { dx: dx, dy: dy } = bullet.schema;
        let newX = bullet.schema.x - bullet.schema.boundingWidth / 2;
        let newY = bullet.schema.y - bullet.schema.boundingHeight / 2;
        if (bullet.schema.type === (0, $49736469f58fc92b$export$f90411c24f6aebf8).Boss1 || bullet.schema.type === (0, $49736469f58fc92b$export$f90411c24f6aebf8).Boss2 || bullet.schema.type === (0, $49736469f58fc92b$export$f90411c24f6aebf8).Yeti) {
            newX = bullet.schema.x + bullet.schema.boundingWidth / 2;
            newY = bullet.schema.y + bullet.schema.boundingHeight / 2;
        } else {
            newX = bullet.schema.x - bullet.schema.boundingWidth / 2;
            newY = bullet.schema.y - bullet.schema.boundingHeight / 2;
        }
        let computedX = x + dx * delta;
        let computedY = y + dy * delta;
        const differenceX = newX - computedX;
        const differenceY = newY - computedY;
        computedX += differenceX * delta01;
        computedY += differenceY * delta01;
        //if (Math.abs(differenceX) > 100 || Math.abs(differenceX) < 0.01) {
        //  computedX = newX
        //}
        //if (Math.abs(differenceY) > 100 || Math.abs(differenceY) < 0.01) {
        //  computedY = newY
        //}
        if (bullet.schema.type === (0, $49736469f58fc92b$export$f90411c24f6aebf8).Card) bullet.element.rotation += 0.2 * delta;
        else if (bullet.schema.type !== (0, $49736469f58fc92b$export$f90411c24f6aebf8).Boss1 && bullet.schema.type !== (0, $49736469f58fc92b$export$f90411c24f6aebf8).Boss2 && bullet.schema.type !== (0, $49736469f58fc92b$export$f90411c24f6aebf8).Yeti) {
            const angle = (0, $08054706be28954e$export$afd58ae2e5ad6fa2)(0, 0, dx, dy);
            bullet.element.rotation = angle;
            if (bullet.schema.type === (0, $49736469f58fc92b$export$f90411c24f6aebf8).Rocket) bullet.element.rotation += Math.PI / 2;
        } else if (bullet.schema.type === (0, $49736469f58fc92b$export$f90411c24f6aebf8).Boss2 || bullet.schema.type === (0, $49736469f58fc92b$export$f90411c24f6aebf8).Yeti) bullet.element.rotation += Math.PI / 100;
        //const graphic = new Graphics()
        //  .beginFill(0xff0000).drawRect(bullet.schema.x, bullet.schema.y, bullet.schema.width, bullet.schema.height).endFill()
        //  .beginFill(0x00ff00).drawRect(bullet.schema.x + bullet.schema.boundingX, bullet.schema.y + bullet.schema.boundingY, bullet.schema.boundingWidth, bullet.schema.boundingHeight).endFill()
        //graphic.zIndex = 12
        //gameState.viewport!.addChild(graphic)
        bullet.element.position.set(computedX, computedY);
    });
};




const $9c219c64d8a8122c$export$639b0385a7bd2365 = (x, y, params)=>{
    if (!(0, $2ae84a41eb5f30ec$export$8e361a1ffbebf172).viewport) return;
    const spine = new (0, $784388461c50e8a6$export$ce0a100797286aea)((0, $2ae84a41eb5f30ec$export$8e361a1ffbebf172).resources["yeti-icewave"].spineData);
    spine.state.addListener({
        complete (entry) {
            if (entry.animation?.name === "animation") setTimeout(()=>{
                try {
                    console.log(spine.height);
                    spine.destroy();
                } catch  {}
            });
        }
    });
    spine.state.setAnimation(0, "animation");
    const ratio = params.size / 1082;
    spine.scale.set(ratio, ratio);
    spine.position.set(x, y);
    spine.zIndex = 12;
    (0, $2ae84a41eb5f30ec$export$8e361a1ffbebf172).viewport.addChild(spine);
//const localPlayer = gameState.level?.state.localPlayer
//if (!localPlayer) return
//const lightningSound = sound.find(SoundName.SkillLightning)
//if (lightningSound) {
//  playSpatialSound(localPlayer, spine, lightningSound)
//}
};







const $36a90f63d0ec761f$export$c2733958554eb961 = (x, y, mode)=>{
    if (!(0, $2ae84a41eb5f30ec$export$8e361a1ffbebf172).viewport) return;
    const spine = new (0, $784388461c50e8a6$export$ce0a100797286aea)((0, $2ae84a41eb5f30ec$export$8e361a1ffbebf172).resources[mode === "normal" ? "lightning-effect" : "boss_1_lightning"].spineData);
    const random = Math.random() < 0.5 ? 1 : -1;
    spine.state.addListener({
        complete (entry) {
            if (entry.animation?.name === "ATTACK") setTimeout(()=>{
                try {
                    spine.destroy();
                } catch  {}
            });
        }
    });
    spine.state.setAnimation(0, "ATTACK");
    spine.position.set(x, y);
    spine.skeleton.scaleX = random;
    spine.zIndex = Number.MAX_SAFE_INTEGER - 2;
    (0, $2ae84a41eb5f30ec$export$8e361a1ffbebf172).viewport.addChild(spine);
    const localPlayer = (0, $2ae84a41eb5f30ec$export$8e361a1ffbebf172).level?.state.localPlayer;
    if (!localPlayer) return;
    const lightningSound = (0, $52a374576fbfc221$export$eab32dcfc4ded11c).find((0, $49736469f58fc92b$export$93445e7da77bf239).SkillLightning);
    if (lightningSound) (0, $bf5e1bcc1f1c3d40$export$ccd4e8223abfd366)(localPlayer, spine, lightningSound);
};




const $2d4ab6a6eeed1a6e$export$d27d994d19dac3a3 = (x, y, params)=>{
    if (!(0, $2ae84a41eb5f30ec$export$8e361a1ffbebf172).viewport) return;
    const spine = new (0, $784388461c50e8a6$export$ce0a100797286aea)((0, $2ae84a41eb5f30ec$export$8e361a1ffbebf172).resources["yeti-spike"].spineData);
    spine.state.addListener({
        complete (entry) {
            if (entry.animation?.name === "animation") setTimeout(()=>{
                try {
                    spine.destroy();
                } catch  {}
            });
        }
    });
    spine.state.setAnimation(0, "animation");
    const ratio = params.size / spine.width;
    spine.scale.set(ratio, ratio);
    spine.position.set(x, y);
    spine.zIndex = 12;
    spine.alpha = 0.85;
    (0, $2ae84a41eb5f30ec$export$8e361a1ffbebf172).viewport.addChild(spine);
//const localPlayer = gameState.level?.state.localPlayer
//if (!localPlayer) return
//const lightningSound = sound.find(SoundName.SkillLightning)
//if (lightningSound) {
//  playSpatialSound(localPlayer, spine, lightningSound)
//}
};









const $44b699cfe818306c$export$bcc2111d3ccd3d6e = (item)=>{
    if (!(0, $2ae84a41eb5f30ec$export$8e361a1ffbebf172).viewport || !(0, $2ae84a41eb5f30ec$export$8e361a1ffbebf172).resources) return;
    let element;
    let ratio;
    switch(item.type){
        case (0, $49736469f58fc92b$export$6d08773d2e66f8f2).ChestCommon:
        case (0, $49736469f58fc92b$export$6d08773d2e66f8f2).ChestRare:
        case (0, $49736469f58fc92b$export$6d08773d2e66f8f2).ChestFabled:
        case (0, $49736469f58fc92b$export$6d08773d2e66f8f2).ChestZombie:
            element = new (0, $784388461c50e8a6$export$ce0a100797286aea)((0, $2ae84a41eb5f30ec$export$8e361a1ffbebf172).resources["chests"].spineData);
            ratio = Math.max(item.width / element.width, item.height / element.height);
            element.scale.set(ratio, ratio);
            element.state.setAnimation(0, "IDLE", true);
            element.skeleton?.setSkinByName(`CHEST/${item.type.split("-")[1].toUpperCase()}`);
            element.position.set(item.x, item.y);
            element.zIndex = Math.max(13, element.y + element.height);
            break;
        case (0, $49736469f58fc92b$export$6d08773d2e66f8f2).MysteryBox:
            element = new (0, $784388461c50e8a6$export$ce0a100797286aea)((0, $2ae84a41eb5f30ec$export$8e361a1ffbebf172).resources["item-mystery-box"].spineData);
            ratio = Math.max(item.width / element.width, item.height / element.height);
            element.scale.set(ratio, ratio);
            element.state.setAnimation(0, "IDLE", true);
            element.position.set(item.x, item.y);
            element.zIndex = Math.max(13, element.y + element.height);
            break;
        default:
            element = new (0, $e4c5b2569bd3a8d2$export$3075603db8e6204c)((0, $2ae84a41eb5f30ec$export$8e361a1ffbebf172).resources[`item-${item.type}`]);
            ratio = Math.max(item.width / element.width, item.height / element.height);
            element.scale.set(ratio, ratio);
            element.position.set(item.x, item.y);
            element.zIndex = Math.max(13, element.y + element.height * 1.5);
    }
    //setTimeout(() => {
    //  const graphic = new Graphics()
    //    .beginFill(0xff0000).drawRect(item.x, item.y, item.width, item.height).endFill()
    //    .beginFill(0x00ff00).drawRect(item.x + item.boundingX, item.y + item.boundingY, item.boundingWidth, item.boundingHeight).endFill()
    //  graphic.zIndex = 12
    //  gameState.viewport!.addChild(graphic)
    //}, 2000)
    return element;
};
const $44b699cfe818306c$export$fb9705de59d96855 = (itemSchema)=>{
    if (!(0, $2ae84a41eb5f30ec$export$8e361a1ffbebf172).viewport || !(0, $2ae84a41eb5f30ec$export$8e361a1ffbebf172).level) return;
    const itemsList = (0, $2ae84a41eb5f30ec$export$8e361a1ffbebf172).references.items;
    const item = $44b699cfe818306c$export$bcc2111d3ccd3d6e(itemSchema);
    if (item) {
        const data = {
            schema: itemSchema,
            element: item
        };
        itemsList.set(itemSchema.uid, data);
        (0, $2ae84a41eb5f30ec$export$8e361a1ffbebf172).viewport.addChild(item);
        return data;
    }
};
const $44b699cfe818306c$export$fe2d9b4e03920b4c = (schema)=>{
    if (!(0, $2ae84a41eb5f30ec$export$8e361a1ffbebf172).references.items) return;
    const localItem = (0, $2ae84a41eb5f30ec$export$8e361a1ffbebf172).references.items.get(schema.uid);
    if (localItem) {
        (0, $2ae84a41eb5f30ec$export$8e361a1ffbebf172).references.items.delete(schema.uid);
        const element = localItem.element;
        switch(localItem.schema.type){
            case (0, $49736469f58fc92b$export$6d08773d2e66f8f2).MysteryBox:
                $44b699cfe818306c$var$openMysteryBox(localItem.element);
                break;
            case (0, $49736469f58fc92b$export$6d08773d2e66f8f2).Bomb:
                $44b699cfe818306c$var$bombExplode();
                element.destroy();
                break;
            default:
                element.destroy();
        }
    }
};
const $44b699cfe818306c$export$dbeaaf250e4d0a92 = (clientId, type)=>{
    const localPlayer = (0, $2ae84a41eb5f30ec$export$8e361a1ffbebf172).level?.state.localPlayer;
    const player = (0, $2ae84a41eb5f30ec$export$8e361a1ffbebf172).references.players.get(clientId);
    if (!player || !localPlayer) return;
    let itemSound = undefined;
    const options = {};
    switch(type){
        case (0, $49736469f58fc92b$export$6d08773d2e66f8f2).Bomb:
            itemSound = (0, $52a374576fbfc221$export$eab32dcfc4ded11c).find((0, $49736469f58fc92b$export$93445e7da77bf239).ItemBomb);
            break;
        case (0, $49736469f58fc92b$export$6d08773d2e66f8f2).MysteryBox:
            itemSound = (0, $52a374576fbfc221$export$eab32dcfc4ded11c).find((0, $49736469f58fc92b$export$93445e7da77bf239).ItemBomb);
            options.start = 0.6;
            break;
    }
    if (itemSound && itemSound.instances.length < 3 && (!itemSound.instances[itemSound.instances.length - 1] || itemSound.instances[itemSound.instances.length - 1].progress > 0.25)) (0, $bf5e1bcc1f1c3d40$export$ccd4e8223abfd366)(localPlayer, player.schema, itemSound, localPlayer.clientId === player.schema.clientId, options);
};
const $44b699cfe818306c$var$openMysteryBox = (element)=>{
    element.state.addListener({
        complete (entry) {
            if (entry.animation?.name === "OPEN") setTimeout(()=>{
                try {
                    element.destroy();
                // eslint-disable-next-line no-empty
                } catch  {}
            });
        }
    });
    element.state.setAnimation(0, "OPEN");
};
const $44b699cfe818306c$var$bombExplode = ()=>{
    if (!(0, $2ae84a41eb5f30ec$export$8e361a1ffbebf172).viewport) return;
    const flash = new (0, $48ce8a7de6645907$export$29d3e417456abdad)().beginFill(0xffffff).drawRect(0, 0, (0, $2ae84a41eb5f30ec$export$8e361a1ffbebf172).viewport.worldWidth, (0, $2ae84a41eb5f30ec$export$8e361a1ffbebf172).viewport.worldHeight).endFill();
    flash.alpha = 0.5;
    flash.zIndex = Number.MAX_SAFE_INTEGER;
    (0, $2ae84a41eb5f30ec$export$8e361a1ffbebf172).viewport.addChild(flash);
    (0, $52be045d3cbb2b80$export$99ee26438460406a).to(flash, {
        duration: 1,
        alpha: 0,
        onComplete () {
            flash.destroy();
        }
    });
};
const $44b699cfe818306c$export$c7d78f87941eb2fc = (delta)=>{
    const itemsList = (0, $2ae84a41eb5f30ec$export$8e361a1ffbebf172).references.items;
    if (!(0, $2ae84a41eb5f30ec$export$8e361a1ffbebf172).viewport || !(0, $2ae84a41eb5f30ec$export$8e361a1ffbebf172).level || !itemsList) return;
    const delta01 = delta * 0.01;
    itemsList.forEach((item)=>{
        if (!item) return;
        const { x: x, y: y } = item.element;
        const { x: newX, y: newY, dx: dx, dy: dy } = item.schema;
        let computedX = x + dx * delta;
        let computedY = y + dy * delta;
        const differenceX = newX - computedX;
        const differenceY = newY - computedY;
        computedX += differenceX * delta01;
        computedY += differenceY * delta01;
        item.element.position.set(computedX, computedY);
    });
};









const $edd21dfd225447d1$export$7b2260086b783d8e = (monster)=>{
    if (!(0, $2ae84a41eb5f30ec$export$8e361a1ffbebf172).viewport || !(0, $2ae84a41eb5f30ec$export$8e361a1ffbebf172).resources) return;
    const container = new (0, $68e6944de5989822$export$42a852a2b6b56249)();
    let element;
    let ratio = 1;
    if (monster.isBoss) {
        element = new (0, $784388461c50e8a6$export$ce0a100797286aea)((0, $2ae84a41eb5f30ec$export$8e361a1ffbebf172).resources[monster.type].spineData);
        element.state.setAnimation(0, "IDLE", true);
        ratio = monster.width / element.width;
        element.scale.set(ratio, ratio);
        container.position.set(monster.x + monster.width / 2, monster.y + monster.height / 2 + monster.boundingHeight / 2);
    } else {
        element = (0, $bcc7eddf04636882$export$dae599798687ad3c).fromFrames(Object.values((0, $2ae84a41eb5f30ec$export$8e361a1ffbebf172).resources[monster.type].data.animations)[0]);
        ratio = Math.min(monster.width / element.width, monster.height / element.height);
        element.pivot.set(element.width / 2, element.height / 2);
        element.scale.set(ratio, ratio);
        element.animationSpeed = 0.5;
        element.loop = true;
        element.play();
        element.position.set(monster.width / 2, monster.height / 2);
        container.position.set(monster.x, monster.y);
    }
    element.zIndex = 30 + Math.floor(monster.y);
    const widthResized = monster.boundingWidth * 0.6;
    const heighResized = widthResized / 5;
    if (!monster.isBoss) {
        const graphics = new (0, $48ce8a7de6645907$export$29d3e417456abdad)().beginFill(0x333333, 0.3).drawEllipse(monster.boundingX + monster.boundingWidth / 2, monster.boundingY + monster.boundingHeight + heighResized / 2, widthResized, heighResized).endFill();
        graphics.cacheAsBitmap = true;
        container.addChild(graphics);
    }
    element.name = `monster-${monster.uid}`;
    container.addChild(element);
    if (monster.isElite || monster.isBoss) {
        const width = element.width * 0.6;
        const height = 12;
        const gap = 3;
        const { container: lifeContainer, bar: bar } = (0, $08054706be28954e$export$d4967e94c672b608)(width, height, gap, 0x111111, 0xff3333);
        lifeContainer.position.set(monster.isBoss ? -width / 2 : element.width * 0.2, monster.isBoss ? 10 : monster.boundingY + monster.boundingHeight + 10);
        lifeContainer.name = `life-${monster.uid}`;
        container.addChild(lifeContainer);
        (0, $2ae84a41eb5f30ec$export$8e361a1ffbebf172).references.ui.level.healthBars.set(monster.uid, {
            container: lifeContainer,
            bar: bar
        });
    }
    return container;
};
const $edd21dfd225447d1$export$39df637d52cbf9c2 = (monsterSchema)=>{
    if (!(0, $2ae84a41eb5f30ec$export$8e361a1ffbebf172).viewport || !(0, $2ae84a41eb5f30ec$export$8e361a1ffbebf172).level) return;
    const monstersList = (0, $2ae84a41eb5f30ec$export$8e361a1ffbebf172).references.monsters;
    const monsterContainer = $edd21dfd225447d1$export$7b2260086b783d8e(monsterSchema);
    if (monsterContainer) {
        monsterContainer.zIndex = 11;
        const data = {
            container: monsterContainer,
            schema: monsterSchema
        };
        monstersList.set(monsterSchema.uid, data);
        //setTimeout(() => {
        //  const graphic = new Graphics()
        //    .beginFill(0xff0000).drawRect(monsterSchema.x, monsterSchema.y, monsterSchema.width, monsterSchema.height).endFill()
        //    .beginFill(0x0000ff).drawRect(monsterContainer.x, monsterContainer.y, monsterContainer.width, monsterContainer.height).endFill()
        //    .beginFill(0x00ff00).drawRect(monsterSchema.x + monsterSchema.boundingX, monsterSchema.y + monsterSchema.boundingY, monsterSchema.boundingWidth, monsterSchema.boundingHeight).endFill()
        //  graphic.zIndex = 12
        //  gameState.viewport!.addChild(graphic)
        //}, 0)
        (0, $2ae84a41eb5f30ec$export$8e361a1ffbebf172).viewport.addChild(monsterContainer);
        return data;
    }
};
const $edd21dfd225447d1$export$ce43310d2ed1cfa3 = (schema, sound)=>{
    if (!(0, $2ae84a41eb5f30ec$export$8e361a1ffbebf172).references.monsters) return;
    const localMonster = (0, $2ae84a41eb5f30ec$export$8e361a1ffbebf172).references.monsters.get(schema.uid);
    if (localMonster) {
        (0, $2ae84a41eb5f30ec$export$8e361a1ffbebf172).references.monsters.delete(schema.uid);
        const sprite = localMonster.container;
        if (sound) sound.play();
        sprite.destroy();
    }
};
const $edd21dfd225447d1$export$150dec8ee18afdd5 = (monsterUid, animation, loop = false, playPreviousAnimationAfterCompletion = false)=>{
    if (!(0, $2ae84a41eb5f30ec$export$8e361a1ffbebf172).references.monsters) return;
    const localMonster = (0, $2ae84a41eb5f30ec$export$8e361a1ffbebf172).references.monsters.get(monsterUid);
    if (localMonster) {
        const element = localMonster.container.getChildByName(`monster-${monsterUid}`);
        if (element?.state.setAnimation && element?.state.hasAnimationByName(animation)) {
            const previousAnimation = element.state.getCurrent(0);
            element.state.setAnimation(0, animation, loop);
            if (playPreviousAnimationAfterCompletion && previousAnimation.animation?.name) element.state.addAnimation(previousAnimation.trackIndex, previousAnimation.animation.name, previousAnimation.loop);
        }
    }
};
const $edd21dfd225447d1$export$a64e01919fe425f5 = (delta)=>{
    if (!(0, $2ae84a41eb5f30ec$export$8e361a1ffbebf172).viewport || !(0, $2ae84a41eb5f30ec$export$8e361a1ffbebf172).level || (0, $2ae84a41eb5f30ec$export$8e361a1ffbebf172).level.state.ended || !(0, $2ae84a41eb5f30ec$export$8e361a1ffbebf172).references.monsters) return;
    const delta01 = delta * 0.01;
    for (const [, monster] of (0, $2ae84a41eb5f30ec$export$8e361a1ffbebf172).references.monsters){
        if (!monster) continue;
        const container = monster.container;
        const element = container.getChildByName(`monster-${monster.schema.uid}`);
        //const graphic = new Graphics()
        //  .beginFill(0xff0000).drawRect(monster.schema.x, monster.schema.y, monster.schema.width, monster.schema.height).endFill()
        //  .beginFill(0x0000ff).drawRect(element.x, element.y, element.width, element.height).endFill()
        //  .beginFill(0x00ff00).drawRect(monster.schema.x + monster.schema.boundingX, monster.schema.y + monster.schema.boundingY, monster.schema.boundingWidth, monster.schema.boundingHeight).endFill()
        //graphic.zIndex = 12
        //gameState.viewport!.addChild(graphic)
        const newX = monster.schema.isBoss ? monster.schema.x + monster.schema.width / 2 : monster.schema.x;
        const newY = monster.schema.isBoss ? monster.schema.y + monster.schema.height / 2 + monster.schema.boundingHeight / 2 : monster.schema.y;
        const { dx: dx, dy: dy, speed: speed } = monster.schema;
        const globalPosition = (0, $2ae84a41eb5f30ec$export$8e361a1ffbebf172).viewport.toGlobal(container);
        if (globalPosition.x <= -200 || globalPosition.x > (0, $2ae84a41eb5f30ec$export$8e361a1ffbebf172).viewport.screenWidth + 200 || globalPosition.y <= -200 || globalPosition.y > (0, $2ae84a41eb5f30ec$export$8e361a1ffbebf172).viewport.screenHeight + 200) {
            container.renderable = false;
            container.visible = false;
            container.position.set(newX, newY);
            continue;
        } else {
            container.renderable = true;
            container.visible = true;
        }
        const { x: x, y: y } = container;
        let computedX = x + dx * speed * delta;
        let computedY = y + dy * speed * delta;
        const differenceX = newX - computedX;
        const differenceY = newY - computedY;
        computedX += differenceX * delta01;
        computedY += differenceY * delta01;
        container.zIndex = 30 + computedY + monster.schema.boundingHeight;
        element.scale.x = monster.schema.orientation === "l" ? Math.abs(element.scale.x) : -Math.abs(element.scale.x);
        if (monster.schema.type === (0, $49736469f58fc92b$export$d2385d4b1e3b9d1a).Yeti || monster.schema.type === (0, $49736469f58fc92b$export$d2385d4b1e3b9d1a).Rainbow) element.scale.x = -element.scale.x;
        if (Math.abs(differenceX) > 100 || Math.abs(differenceX) < 0.02) computedX = newX;
        if (Math.abs(differenceY) > 100 || Math.abs(differenceY) < 0.02) computedY = newY;
        container.position.set(computedX, computedY);
    }
};







const $1363c356f1a52b50$export$992dd955a7e36e69 = (playerSchema, skillSchema, type)=>{
    let skills = (0, $2ae84a41eb5f30ec$export$8e361a1ffbebf172).references.skills.get(playerSchema.clientId);
    if (!skills) {
        skills = new Map();
        (0, $2ae84a41eb5f30ec$export$8e361a1ffbebf172).references.skills.set(playerSchema.clientId, skills);
    }
    let element;
    switch(type){
        case (0, $49736469f58fc92b$export$118171a82d109c04).HealingDrone:
        case (0, $49736469f58fc92b$export$118171a82d109c04).RocketDrone:
            element = $1363c356f1a52b50$var$showDrone(playerSchema, skillSchema, type);
            break;
    }
    const data = {
        element: element,
        schema: skillSchema
    };
    skills.set(type, data);
    return data;
};
const $1363c356f1a52b50$var$showDrone = (playerSchema, skillSchema, skill)=>{
    if (!(0, $2ae84a41eb5f30ec$export$8e361a1ffbebf172).viewport) return;
    const playerSpine = (0, $2ae84a41eb5f30ec$export$8e361a1ffbebf172).references.players.get(playerSchema.clientId)?.element;
    if (!playerSpine) return;
    const drone = new (0, $784388461c50e8a6$export$ce0a100797286aea)((0, $2ae84a41eb5f30ec$export$8e361a1ffbebf172).resources[skill].spineData);
    const droneRatio = playerSpine.width / drone.width * 1.25;
    drone.scale.set(droneRatio, droneRatio);
    drone.x = skillSchema.x;
    drone.y = skillSchema.y;
    drone.zIndex = Number.MAX_SAFE_INTEGER - 2;
    drone.state.setAnimation(0, "FLYING", true);
    (0, $2ae84a41eb5f30ec$export$8e361a1ffbebf172).viewport.addChild(drone);
    return drone;
};
const $1363c356f1a52b50$export$16bfbaf4ee7130aa = (delta)=>{
    if (!(0, $2ae84a41eb5f30ec$export$8e361a1ffbebf172).level || (0, $2ae84a41eb5f30ec$export$8e361a1ffbebf172).level.state.ended) return;
    (0, $2ae84a41eb5f30ec$export$8e361a1ffbebf172).references.players.forEach((player, clientId)=>{
        if (!player) return;
        const skills = (0, $2ae84a41eb5f30ec$export$8e361a1ffbebf172).references.skills.get(clientId);
        if (!skills) return;
        skills.forEach((skill, type)=>{
            $1363c356f1a52b50$export$37e1a524556b358a(player.schema, skill.schema, type, delta);
        });
    });
};
const $1363c356f1a52b50$export$37e1a524556b358a = (playerSchema, skillSchema, type, delta)=>{
    $1363c356f1a52b50$var$UPDATED_SKILL_LOGIC[type](playerSchema, skillSchema, delta);
};
const $1363c356f1a52b50$export$db68f856f620204e = (playerSchema, type)=>{
    $1363c356f1a52b50$var$REMOVE_SKILL_LOGIC[type](playerSchema);
};
const $1363c356f1a52b50$var$UPDATED_SKILL_LOGIC = {
    [(0, $49736469f58fc92b$export$118171a82d109c04).Defensive] (playerSchema, skillSchema, delta) {
    //showDefensiveAura(playerSchema, skillSchema)
    },
    [(0, $49736469f58fc92b$export$118171a82d109c04).Lightning] () {
    //console.log('update lightning')
    },
    [(0, $49736469f58fc92b$export$118171a82d109c04).HealingDrone] (playerSchema, skillSchema, delta) {
        const skill = (0, $2ae84a41eb5f30ec$export$8e361a1ffbebf172).references.skills.get(playerSchema.clientId)?.get((0, $49736469f58fc92b$export$118171a82d109c04).HealingDrone);
        if (!skill || !skill.element) return;
        const { computedX: computedX, computedY: computedY } = (0, $08054706be28954e$export$7777bc9cf3a47d2c)(skill.element, skill.schema, delta * 0.05);
        skill.element.position.set(computedX, computedY);
    },
    [(0, $49736469f58fc92b$export$118171a82d109c04).RocketDrone] (playerSchema, skillSchema, delta) {
        const skill = (0, $2ae84a41eb5f30ec$export$8e361a1ffbebf172).references.skills.get(playerSchema.clientId)?.get((0, $49736469f58fc92b$export$118171a82d109c04).RocketDrone);
        if (!skill || !skill.element) return;
        const { computedX: computedX, computedY: computedY } = (0, $08054706be28954e$export$7777bc9cf3a47d2c)(skill.element, skill.schema, delta * 0.05);
        skill.element.position.set(computedX, computedY);
    }
};
const $1363c356f1a52b50$var$REMOVE_SKILL_LOGIC = {
    [(0, $49736469f58fc92b$export$118171a82d109c04).Defensive] (playerSchema) {
    //removeAura(playerSchema, Aura.Defensive)
    },
    [(0, $49736469f58fc92b$export$118171a82d109c04).Lightning] () {
    //console.log('remove lightning')
    },
    [(0, $49736469f58fc92b$export$118171a82d109c04).HealingDrone] () {
    //console.log('')
    },
    [(0, $49736469f58fc92b$export$118171a82d109c04).RocketDrone] () {
    //console.log('')
    }
};








const $1483ee9ebdea058c$export$b3f5871a07312b75 = (clientId)=>{
    const localPlayer = (0, $2ae84a41eb5f30ec$export$8e361a1ffbebf172).level?.state.localPlayer;
    const player = (0, $2ae84a41eb5f30ec$export$8e361a1ffbebf172).references.players.get(clientId);
    if (!player || !localPlayer) return;
    let weaponSound = undefined;
    const options = {};
    switch(player.schema.weapon.type){
        case (0, $49736469f58fc92b$export$a0b1da4b3d9a7c29).CommonBlaster:
        case (0, $49736469f58fc92b$export$a0b1da4b3d9a7c29).EpicBlaster:
        case (0, $49736469f58fc92b$export$a0b1da4b3d9a7c29).FabledBlaster:
        case (0, $49736469f58fc92b$export$a0b1da4b3d9a7c29).MachineGun:
        case (0, $49736469f58fc92b$export$a0b1da4b3d9a7c29).Carrot:
        case (0, $49736469f58fc92b$export$a0b1da4b3d9a7c29).GanAutoRifle:
        case (0, $49736469f58fc92b$export$a0b1da4b3d9a7c29).XMAS23:
            weaponSound = (0, $52a374576fbfc221$export$eab32dcfc4ded11c).find((0, $49736469f58fc92b$export$93445e7da77bf239).WeaponBlaster);
            break;
        case (0, $49736469f58fc92b$export$a0b1da4b3d9a7c29).NinjaStar:
            weaponSound = (0, $52a374576fbfc221$export$eab32dcfc4ded11c).find((0, $49736469f58fc92b$export$93445e7da77bf239).WeaponNinjaStar);
            break;
        case (0, $49736469f58fc92b$export$a0b1da4b3d9a7c29).Shotgun:
            weaponSound = (0, $52a374576fbfc221$export$eab32dcfc4ded11c).find((0, $49736469f58fc92b$export$93445e7da77bf239).WeaponShotgun);
            break;
        case (0, $49736469f58fc92b$export$a0b1da4b3d9a7c29).Flamethrower:
            weaponSound = (0, $52a374576fbfc221$export$eab32dcfc4ded11c).find((0, $49736469f58fc92b$export$93445e7da77bf239).WeaponFlame);
            options.loop = true;
            break;
    }
    if (weaponSound && weaponSound.instances.length < 3 && (!weaponSound.instances[weaponSound.instances.length - 1] || weaponSound.instances[weaponSound.instances.length - 1].progress > 0.25)) (0, $bf5e1bcc1f1c3d40$export$ccd4e8223abfd366)(localPlayer, player.schema, weaponSound, localPlayer.clientId === player.schema.clientId, options);
};


const $8b91dc769ad86d51$export$9e0aba4a2d0bac1d = (room, localPlayer)=>{
    console.log("on connect");
    const level = room.state.level;
    (0, $2ae84a41eb5f30ec$export$8e361a1ffbebf172).level = {
        state: {
            lastPauseTimestamp: 0,
            totalTime: 0,
            canMove: level.canMove,
            ended: false,
            won: false,
            worldSize: level.worldSize,
            waveStarted: false,
            localPlayer: localPlayer
        }
    };
    (0, $05e42dce750e973a$export$eee678d37a72577b)(room);
    $8b91dc769ad86d51$var$initServerListener(room, localPlayer);
    (0, $05e42dce750e973a$export$7861a7baf584a226)();
    $8b91dc769ad86d51$var$initServerMessage(room);
};
const $8b91dc769ad86d51$var$initServerListener = (room, localPlayer)=>{
    room.state.players.onAdd((player)=>{
        const playerInfo = (0, $01e69bafe2fbba11$export$8d529c6207f87a36)(player);
        player.listen("dx", (value)=>{
            if (!playerInfo || player.clientId === localPlayer.clientId) return;
            if (Math.abs(value) > 0.1) {
                playerInfo.playerSpine.state.setAnimation(0, "WALK", true);
                playerInfo.gunSpine.state.setAnimation(0, "GUN_WALK", true);
            } else {
                playerInfo.playerSpine.state.setAnimation(0, "IDLE", true);
                playerInfo.gunSpine.state.setAnimation(0, "GUN_IDLE", true);
            }
        });
        player.listen("dy", (value)=>{
            if (!playerInfo || player.clientId === localPlayer.clientId) return;
            if (Math.abs(value) > 0.1) {
                playerInfo.playerSpine.state.setAnimation(0, "WALK", true);
                playerInfo.gunSpine.state.setAnimation(0, "GUN_WALK", true);
            } else {
                playerInfo.playerSpine.state.setAnimation(0, "IDLE", true);
                playerInfo.gunSpine.state.setAnimation(0, "GUN_IDLE", true);
            }
        });
        player.listen("life", (currentValue, previousValue)=>{
            const difference = previousValue - currentValue;
            (0, $8a8733686822a976$export$633e056fc36fb213)(player, difference);
        });
        if (player !== localPlayer) player.listen("shootingAngle", (angle)=>{
            if (!playerInfo) return;
            const preparedAngle = angle + Math.PI / 2;
            playerInfo.playerSpine.skeleton.scaleX = preparedAngle < Math.PI ? Math.abs(playerInfo.playerSpine.skeleton.scaleX) : preparedAngle > Math.PI ? -Math.abs(playerInfo.playerSpine.skeleton.scaleX) : playerInfo.playerSpine.skeleton.scaleX;
            if (preparedAngle < Math.PI) playerInfo.gunSpine.skeleton.scaleX = 1;
            else playerInfo.gunSpine.skeleton.scaleX = -1;
            playerInfo.gunSpine.rotation = angle < Math.PI / 2 ? angle : angle - Math.PI;
            if ((0, $2ae84a41eb5f30ec$export$8e361a1ffbebf172).level) {
                const emitter = (0, $2ae84a41eb5f30ec$export$8e361a1ffbebf172).references.particles.get(player.clientId)?.emitter;
                if (emitter) emitter.rotate(angle - Math.PI / 2 - 0.1);
            }
        });
        player.auras.onAdd((_, type)=>{
            (0, $306846f4386fc4d8$export$e16ca81dc50a9aa2)(player, type);
        });
        player.auras.onRemove((_, type)=>{
            (0, $306846f4386fc4d8$export$d41c20423d67868d)(player, type);
        });
        player.skills.onAdd((skillSchema, type)=>{
            (0, $1363c356f1a52b50$export$992dd955a7e36e69)(player, skillSchema, type);
        });
        player.skills.onRemove((_, type)=>{
            (0, $1363c356f1a52b50$export$db68f856f620204e)(player, type);
        });
        player.listen("waitingSkillUnlock", (waitingSkillUnlock)=>{
            if (waitingSkillUnlock) (0, $8a8733686822a976$export$3aa3f29d6ab8aca1)(player);
            else (0, $8a8733686822a976$export$6da15a9e776b5804)(player);
        });
        player.listen("frozen", (frozen)=>{
            if (!playerInfo) return;
            if (frozen) {
                playerInfo.playerSpine.state.setAnimation(0, "IDLE", false);
                playerInfo.gunSpine.state.setAnimation(0, "GUN_IDLE", false);
                (0, $8a8733686822a976$export$95f0f433472cf002)(player);
            } else (0, $8a8733686822a976$export$b2b81cfa586767da)(player);
        });
    });
    room.state.level.items.onAdd((item)=>{
        if (!item.visibleForClientId || item.visibleForClientId === localPlayer.clientId) (0, $44b699cfe818306c$export$fb9705de59d96855)(item);
    });
    room.state.level.items.onRemove((item)=>{
        (0, $44b699cfe818306c$export$fe2d9b4e03920b4c)(item);
    });
    room.state.level.aoe.onAdd((aoe)=>{
        (0, $065042de654ce1e3$export$6bfe48b773b8c251)(aoe);
    });
    room.state.level.aoe.onRemove((aoe)=>{
        (0, $065042de654ce1e3$export$4c85909d0d563c34)(aoe);
    });
    room.state.level.monsters.onAdd((monster)=>{
        (0, $edd21dfd225447d1$export$39df637d52cbf9c2)(monster);
        monster.listen("life", ()=>{
            (0, $8a8733686822a976$export$2381fbdf6303e9b9)(monster);
        });
    });
    room.state.level.monsters.onRemove((monster)=>{
        (0, $edd21dfd225447d1$export$ce43310d2ed1cfa3)(monster);
    });
    room.state.level.bullets.onAdd((bullet)=>{
        (0, $09e18a5b5cfd97a5$export$77053d071c37a130)(bullet);
    });
    room.state.level.bullets.onRemove((bullet)=>{
        (0, $09e18a5b5cfd97a5$export$93459cb00f314e10)(bullet);
    });
    room.state.level.listen("canMove", (value)=>{
        if (!(0, $2ae84a41eb5f30ec$export$8e361a1ffbebf172).level) return;
        (0, $2ae84a41eb5f30ec$export$8e361a1ffbebf172).level.state.canMove = value;
    });
    room.state.level.listen("background", (value)=>{
        (0, $aaefdfdf2979f735$export$5ca18fec3e208ab3)(value);
    });
    room.state.listen("ended", (value)=>{
        if (!(0, $2ae84a41eb5f30ec$export$8e361a1ffbebf172).level) return;
        (0, $2ae84a41eb5f30ec$export$8e361a1ffbebf172).level.state.ended = value;
        console.log("ended", value);
    });
    room.state.listen("wave", (value)=>{
        console.log("wave", value);
    });
    room.state.listen("waveTimeLeft", (value)=>{
        (0, $8a8733686822a976$export$e5d5e1c1822b6e56)(value);
    });
    room.state.listen("remainingMonsters", (value)=>{
        (0, $8a8733686822a976$export$ea34a7d3c083e44a)(value);
    });
    // ONLY FOR LOCAL PLAYER
    localPlayer.listen("score", (value)=>{
        (0, $8a8733686822a976$export$ffd8e13d6b0d8fb0)(value);
    });
    localPlayer.listen("gems", (value)=>{
        (0, $8a8733686822a976$export$788e700ffeb7528a)(value);
    });
    localPlayer.listen("level", (currentValue)=>{
        (0, $8a8733686822a976$export$37a16b981197c6e9)(currentValue + 1);
    });
    localPlayer.listen("experience", (currentValue)=>{
        (0, $8a8733686822a976$export$68137314df9d883c)(currentValue / localPlayer.nextLevelExperience);
    });
};
const $8b91dc769ad86d51$var$initServerMessage = (room)=>{
    room.onMessage("start-wave", ({ name: name, type: type, monsterCount: monsterCount })=>{
        if (!(0, $2ae84a41eb5f30ec$export$8e361a1ffbebf172).level) return;
        (0, $2ae84a41eb5f30ec$export$8e361a1ffbebf172).level.state.waveStarted = true;
    });
    room.onMessage("new-wave", ({ name: name, type: type, monsterCount: monsterCount })=>{
        if (!(0, $2ae84a41eb5f30ec$export$8e361a1ffbebf172).level) return;
        (0, $2ae84a41eb5f30ec$export$8e361a1ffbebf172).level.state.waveStarted = false;
        (0, $8a8733686822a976$export$fccac230130a63bf)(name, type, monsterCount);
    });
    room.onMessage("item-touched", ({ clientId: clientId, type: type })=>{
        (0, $44b699cfe818306c$export$dbeaaf250e4d0a92)(clientId, type);
    });
    room.onMessage("explosion", ({ x: x, y: y, width: width, height: height })=>{
        (0, $09e18a5b5cfd97a5$export$4971bcc2704b21ab)(x, y, width, height);
    });
    room.onMessage("weapon-firing", ({ clientId: clientId })=>{
        (0, $1483ee9ebdea058c$export$b3f5871a07312b75)(clientId);
    });
    room.onMessage("bullet-collided", ({ x: x, y: y })=>{
        (0, $09e18a5b5cfd97a5$export$9d806718d0c89581)(x, y);
    });
    room.onMessage("monster-killed", ({ monsterUid: monsterUid })=>{
        const monster = (0, $2ae84a41eb5f30ec$export$8e361a1ffbebf172).references.monsters.get(monsterUid);
        if (!monster) return;
        (0, $8a8733686822a976$export$2381fbdf6303e9b9)(monster.schema);
    });
    room.onMessage("hit-monster", ({ monsterUid: monsterUid, damages: damages, critical: critical })=>{
        const monster = (0, $2ae84a41eb5f30ec$export$8e361a1ffbebf172).references.monsters.get(monsterUid);
        if (!monster) return;
        if (damages > 0) {
            if (monster.schema.isBoss) (0, $8a8733686822a976$export$bf46dab662f54bbd)({
                x: monster.container.x,
                y: monster.container.y,
                width: 0,
                height: 0
            }, `${damages}`, critical ? 0xEC2727 : 0x666666, 0xffffff, critical ? 1.5 : 1);
            else (0, $8a8733686822a976$export$bf46dab662f54bbd)(monster.container, `${damages}`, critical ? 0xEC2727 : 0x666666, 0xffffff, critical ? 1.5 : 1);
        }
        (0, $8a8733686822a976$export$2381fbdf6303e9b9)(monster.schema);
    });
    room.onMessage("revive", ({ clientId: clientId, revived: revived })=>{
        if (revived) (0, $8a8733686822a976$export$1e36c547a9c2b135)(clientId);
    });
    room.onMessage("play-sound", ({ soundName: soundName, volume: volume, from: from })=>{
        const localPlayer = (0, $2ae84a41eb5f30ec$export$8e361a1ffbebf172).level?.state.localPlayer;
        if (!localPlayer) return;
        const playedSound = (0, $52a374576fbfc221$export$eab32dcfc4ded11c).find(soundName);
        if (playedSound) {
            console.log(localPlayer, from, playedSound, false, {
                volume: volume ?? 1
            });
            (0, $bf5e1bcc1f1c3d40$export$ccd4e8223abfd366)(localPlayer, from, playedSound, false, {
                volume: volume ?? 1
            });
        }
    });
    room.onMessage("need-to-be-revive", ({ clientId: clientId, score: score, gems: gems })=>{
        if (room.state.players.size === 1 && (0, $2ae84a41eb5f30ec$export$8e361a1ffbebf172).level?.state.localPlayer.clientId === clientId) (0, $8a8733686822a976$export$fce127d9d81d46ea)(score, gems);
        else (0, $8a8733686822a976$export$b3008e0376379461)(clientId);
    });
    room.onMessage("start-reviving", ({ clientId: clientId, max: max, left: left })=>{
        (0, $8a8733686822a976$export$992c49b3c534515c)(clientId, max, left);
    });
    room.onMessage("stop-reviving", ({ clientId: clientId })=>{
        (0, $8a8733686822a976$export$5eab396bc76aace8)(clientId);
    });
    room.onMessage("dead", ({ clientId: clientId, score: score, gems: gems, won: won })=>{
        (0, $8a8733686822a976$export$d6ada3c2d2863dab)(clientId);
        if ((0, $2ae84a41eb5f30ec$export$8e361a1ffbebf172).level?.state.localPlayer.clientId === clientId) {
            //sound.stopAll().play(SoundName.GameWin)
            (0, $8a8733686822a976$export$fccac230130a63bf)(won ? "Mission accomplished" : "Game Over", "normal");
            (0, $8a8733686822a976$export$47689854a9f10c34)();
            setTimeout(()=>{
                (0, $8a8733686822a976$export$8024b47973af95ca)(score, gems);
            }, 4000);
        }
    });
    room.onMessage("effect", ({ effect: effect, x: x, y: y, params: params })=>{
        if (effect.includes("lightning")) (0, $36a90f63d0ec761f$export$c2733958554eb961)(x, y, effect.includes("green") ? "green" : "normal");
        else if (effect.includes("icewave")) (0, $9c219c64d8a8122c$export$639b0385a7bd2365)(x, y, params);
        else if (effect.includes("spike")) (0, $2d4ab6a6eeed1a6e$export$d27d994d19dac3a3)(x, y, params);
    });
    room.onMessage("show-target", ({ x: x, y: y, radius: radius, duration: duration })=>{
        (0, $8a8733686822a976$export$a287bde569066e49)(x, y, radius, duration);
    });
    room.onMessage("set-monster-animation", ({ monsterUid: monsterUid, animation: animation, loop: loop, playPreviousAnimationAfterCompletion: playPreviousAnimationAfterCompletion })=>{
        (0, $edd21dfd225447d1$export$150dec8ee18afdd5)(monsterUid, animation, loop, playPreviousAnimationAfterCompletion);
    });
    room.onMessage("new-level", (message)=>{
        (0, $8a8733686822a976$export$91391bfb6aaf2396)(message.level, message.skills);
    });
    room.onMessage("new-level-forced", ()=>{
        (0, $8a8733686822a976$export$47689854a9f10c34)();
    });
//room.onMessage('pong', () => {
//  if (!gameState.level) return
//  const tmp = new Date().getTime()
//  gameState.latency.history = [...gameState.latency.history.slice(0, 9), tmp - gameState.latency.pingTime]
//  if (gameState.level.state.paused) {
//    setTimeout(() => {
//      pingMessage(room)
//    }, 100)
//  }
//  updateLatencyCount()
//  //console.log('DEAD, score:', score)
//})
};
const $8b91dc769ad86d51$export$1c91c4b074f3fd21 = (err)=>{
    (0, $2ae84a41eb5f30ec$export$8e361a1ffbebf172).external.showLoading(false);
    (0, $2ae84a41eb5f30ec$export$8e361a1ffbebf172).external.showModal({
        title: "Impossible to connect to the game",
        text: err.message ? `(code ${err.code}) ${err.message}. You request has been refused, please try to refresh the page or unlock your wallet again` : ""
    });
    console.error(err);
};
const $8b91dc769ad86d51$export$cb58a432bf104627 = (code)=>{
    if (code !== 1000) (0, $2ae84a41eb5f30ec$export$8e361a1ffbebf172).room = undefined;
};
const $8b91dc769ad86d51$export$aba067a2a21e981e = async ()=>{
    if (!(0, $2ae84a41eb5f30ec$export$8e361a1ffbebf172).room) return;
    try {
        await (0, $2ae84a41eb5f30ec$export$8e361a1ffbebf172).room.leave(true);
    } catch (err) {
        console.error(err);
    }
    (0, $2ae84a41eb5f30ec$export$8e361a1ffbebf172).room = undefined;
};









const $1b4d76a6b55405ff$var$spineTextureAtlasLoader = {
    extension: (0, $c90155f6d7d8d8f6$export$4f037c6ec2da4eeb).Asset,
    // cache: {
    //     test: (asset: RawAtlas | TextureAtlas) => asset instanceof TextureAtlas,
    //     getCacheableAssets: (keys: string[], asset: RawAtlas | TextureAtlas) => getCacheableAssets(keys, asset),
    // },
    loader: {
        extension: {
            type: (0, $c90155f6d7d8d8f6$export$4f037c6ec2da4eeb).LoadParser,
            priority: (0, $ed5d6a4467c2b40c$export$820ed6348c4f2750).Normal
        },
        test (url) {
            return (0, $09c9bb162e36b2d4$export$fd0180357b95b812)(url, ".atlas");
        },
        async load (url) {
            const response = await (0, $2808efac47e52be0$export$a5a6e0b888b2c992).ADAPTER.fetch(url);
            const txt = await response.text();
            return txt;
        },
        testParse (asset, options) {
            const isExtensionRight = (0, $09c9bb162e36b2d4$export$fd0180357b95b812)(options.src, ".atlas");
            const isString = typeof asset === "string";
            return Promise.resolve(isExtensionRight && isString);
        },
        async parse (asset, options, loader) {
            const metadata = options.data;
            let basePath = (0, $db31fc3dfae4939b$exports).path.dirname(options.src);
            if (basePath && basePath.lastIndexOf("/") !== basePath.length - 1) basePath += "/";
            let resolve = null;
            let reject = null;
            const retPromise = new Promise((res, rej)=>{
                resolve = res;
                reject = rej;
            });
            let retval;
            const resolveCallback = (newAtlas)=>{
                if (!newAtlas) reject("Something went terribly wrong loading a spine .atlas file\nMost likely your texture failed to load.");
                resolve(retval);
            };
            if (metadata.image || metadata.images) {
                const pages = Object.assign(metadata.image ? {
                    default: metadata.image
                } : {}, metadata.images);
                retval = new (0, $54adb83dd77388e1$export$1ffc3159823e6649)(asset, (line, callback)=>{
                    const page = pages[line] || pages.default;
                    if (page && page.baseTexture) callback(page.baseTexture);
                    else callback(page);
                }, resolveCallback);
            } else retval = new (0, $54adb83dd77388e1$export$1ffc3159823e6649)(asset, $1b4d76a6b55405ff$export$b89d18d957f56f8c(loader, basePath, metadata.imageMetadata), resolveCallback);
            return await retPromise;
        },
        unload (atlas) {
            atlas.dispose();
        }
    }
};
const $1b4d76a6b55405ff$export$b89d18d957f56f8c = (loader, atlasBasePath, imageMetadata)=>{
    return async (pageName, textureLoadedCallback)=>{
        const url = (0, $db31fc3dfae4939b$exports).path.normalize([
            ...atlasBasePath.split((0, $db31fc3dfae4939b$exports).path.sep),
            pageName
        ].join((0, $db31fc3dfae4939b$exports).path.sep));
        const texture = await loader.load({
            src: url,
            data: imageMetadata
        });
        textureLoadedCallback(texture.baseTexture);
    };
};
(0, $c90155f6d7d8d8f6$export$cc3e2d3244e01b7f).add($1b4d76a6b55405ff$var$spineTextureAtlasLoader);






function $eaeac13ae525399a$var$isJson(resource) {
    return resource.hasOwnProperty("bones");
}
function $eaeac13ae525399a$var$isBuffer(resource) {
    return resource instanceof ArrayBuffer;
}
class $eaeac13ae525399a$export$2a2aa2d35c27e626 {
    constructor(){}
    installLoader() {
        const spineAdapter = this;
        const spineLoaderExtension = {
            extension: (0, $c90155f6d7d8d8f6$export$4f037c6ec2da4eeb).Asset,
            loader: {
                extension: {
                    type: (0, $c90155f6d7d8d8f6$export$4f037c6ec2da4eeb).LoadParser,
                    priority: (0, $ed5d6a4467c2b40c$export$820ed6348c4f2750).Normal
                },
                // #region Downloading skel buffer data
                test (url) {
                    return (0, $09c9bb162e36b2d4$export$fd0180357b95b812)(url, ".skel");
                },
                async load (url) {
                    const response = await (0, $2808efac47e52be0$export$a5a6e0b888b2c992).ADAPTER.fetch(url);
                    const buffer = await response.arrayBuffer();
                    return buffer;
                },
                // #endregion
                // #region Parsing spine data
                testParse (asset, options) {
                    const isJsonSpineModel = (0, $09c9bb162e36b2d4$export$fd0180357b95b812)(options.src, ".json") && $eaeac13ae525399a$var$isJson(asset);
                    const isBinarySpineModel = (0, $09c9bb162e36b2d4$export$fd0180357b95b812)(options.src, ".skel") && $eaeac13ae525399a$var$isBuffer(asset);
                    const isMetadataAngry = options.data?.spineAtlas === false;
                    return Promise.resolve(isJsonSpineModel && !isMetadataAngry || isBinarySpineModel);
                },
                async parse (asset, loadAsset, loader) {
                    const fileExt = (0, $db31fc3dfae4939b$exports).path.extname(loadAsset.src).toLowerCase();
                    const fileName = (0, $db31fc3dfae4939b$exports).path.basename(loadAsset.src, fileExt);
                    let basePath = (0, $db31fc3dfae4939b$exports).path.dirname(loadAsset.src);
                    if (basePath && basePath.lastIndexOf("/") !== basePath.length - 1) basePath += "/";
                    const isJsonSpineModel = (0, $09c9bb162e36b2d4$export$fd0180357b95b812)(loadAsset.src, ".json") && $eaeac13ae525399a$var$isJson(asset);
                    let parser = null;
                    let dataToParse = asset;
                    if (isJsonSpineModel) parser = spineAdapter.createJsonParser();
                    else {
                        parser = spineAdapter.createBinaryParser();
                        dataToParse = new Uint8Array(asset);
                    }
                    const metadata = loadAsset.data || {};
                    const metadataSkeletonScale = metadata?.spineSkeletonScale ?? null;
                    if (metadataSkeletonScale) parser.scale = metadataSkeletonScale;
                    const metadataAtlas = metadata.spineAtlas;
                    if (metadataAtlas && metadataAtlas.pages) return spineAdapter.parseData(parser, metadataAtlas, dataToParse);
                    const textAtlas = metadata.atlasRawData;
                    if (textAtlas) {
                        let auxResolve = null;
                        let auxReject = null;
                        const atlasPromise = new Promise((resolve, reject)=>{
                            auxResolve = resolve;
                            auxReject = reject;
                        });
                        const atlas = new (0, $54adb83dd77388e1$export$1ffc3159823e6649)(textAtlas, (0, $1b4d76a6b55405ff$export$b89d18d957f56f8c)(loader, basePath, metadata.imageMetadata), (newAtlas)=>{
                            if (!newAtlas) auxReject("Something went terribly wrong loading a spine .atlas file\nMost likely your texture failed to load.");
                            auxResolve(atlas);
                        });
                        const textureAtlas2 = await atlasPromise;
                        return spineAdapter.parseData(parser, textureAtlas2, dataToParse);
                    }
                    let atlasPath = metadata.spineAtlasFile;
                    if (!atlasPath) atlasPath = `${basePath + fileName}.atlas`;
                    const textureAtlas = await loader.load({
                        src: atlasPath,
                        data: metadata,
                        alias: metadata.spineAtlasAlias
                    });
                    return spineAdapter.parseData(parser, textureAtlas, dataToParse);
                }
            }
        };
        (0, $c90155f6d7d8d8f6$export$cc3e2d3244e01b7f).add(spineLoaderExtension);
        return spineLoaderExtension;
    }
}






var $2ae1fe659dc46dd2$exports = {};

$parcel$export($2ae1fe659dc46dd2$exports, "Attachment", () => $0081823d79d97c28$export$71e4db985cfcf9e3);
$parcel$export($2ae1fe659dc46dd2$exports, "VertexAttachment", () => $0081823d79d97c28$export$66d3a0c3be55e044);
$parcel$export($2ae1fe659dc46dd2$exports, "BoundingBoxAttachment", () => $ae0315e0b7337cf8$export$9538c439c6b85ad2);
$parcel$export($2ae1fe659dc46dd2$exports, "ClippingAttachment", () => $a1af353be281720a$export$838805e22b9b55f1);
$parcel$export($2ae1fe659dc46dd2$exports, "MeshAttachment", () => $72698e89a18058e1$export$3f1c1692adfcf3e2);
$parcel$export($2ae1fe659dc46dd2$exports, "PathAttachment", () => $ce5645df4e682fb4$export$d285e3ec07b32800);
$parcel$export($2ae1fe659dc46dd2$exports, "PointAttachment", () => $5ba7a9dafefb646c$export$1b528cde44a6ab5);
$parcel$export($2ae1fe659dc46dd2$exports, "RegionAttachment", () => $33f8c953c70470fb$export$d0fc51466fa6d530);
$parcel$export($2ae1fe659dc46dd2$exports, "JitterEffect", () => $fbc310730cadd3fd$export$fcba7f85d07a2c99);
$parcel$export($2ae1fe659dc46dd2$exports, "SwirlEffect", () => $f53431ec7c0efb37$export$bf3ff70e38c4c145);
$parcel$export($2ae1fe659dc46dd2$exports, "Animation", () => $a99189e38c28e5fb$export$c35d437ae5945fcd);
$parcel$export($2ae1fe659dc46dd2$exports, "AttachmentTimeline", () => $a99189e38c28e5fb$export$7f2bfc5bd27cb43d);
$parcel$export($2ae1fe659dc46dd2$exports, "ColorTimeline", () => $a99189e38c28e5fb$export$565fcb3610070d7f);
$parcel$export($2ae1fe659dc46dd2$exports, "CurveTimeline", () => $a99189e38c28e5fb$export$4094e7414845f78f);
$parcel$export($2ae1fe659dc46dd2$exports, "DeformTimeline", () => $a99189e38c28e5fb$export$6968d40e5689ad6b);
$parcel$export($2ae1fe659dc46dd2$exports, "DrawOrderTimeline", () => $a99189e38c28e5fb$export$ece1f7c41d051e83);
$parcel$export($2ae1fe659dc46dd2$exports, "EventTimeline", () => $a99189e38c28e5fb$export$4f4bca996c586084);
$parcel$export($2ae1fe659dc46dd2$exports, "IkConstraintTimeline", () => $a99189e38c28e5fb$export$73d125cd89dead44);
$parcel$export($2ae1fe659dc46dd2$exports, "PathConstraintMixTimeline", () => $a99189e38c28e5fb$export$ea67b41755485038);
$parcel$export($2ae1fe659dc46dd2$exports, "PathConstraintPositionTimeline", () => $a99189e38c28e5fb$export$7ce7e67fd9cc52ed);
$parcel$export($2ae1fe659dc46dd2$exports, "PathConstraintSpacingTimeline", () => $a99189e38c28e5fb$export$17ee50c08a07e62b);
$parcel$export($2ae1fe659dc46dd2$exports, "RotateTimeline", () => $a99189e38c28e5fb$export$b7ecb8f68b3e130b);
$parcel$export($2ae1fe659dc46dd2$exports, "ScaleTimeline", () => $a99189e38c28e5fb$export$be544e22f6ad7737);
$parcel$export($2ae1fe659dc46dd2$exports, "ShearTimeline", () => $a99189e38c28e5fb$export$4da82436a1a0d773);
$parcel$export($2ae1fe659dc46dd2$exports, "TimelineType", () => $a99189e38c28e5fb$export$11f4f8480e4dd7d2);
$parcel$export($2ae1fe659dc46dd2$exports, "TransformConstraintTimeline", () => $a99189e38c28e5fb$export$a7a393c2ad815ac7);
$parcel$export($2ae1fe659dc46dd2$exports, "TranslateTimeline", () => $a99189e38c28e5fb$export$eb93bf27829ae703);
$parcel$export($2ae1fe659dc46dd2$exports, "TwoColorTimeline", () => $a99189e38c28e5fb$export$938c1752e1b56539);
$parcel$export($2ae1fe659dc46dd2$exports, "AnimationState", () => $96f986fcae8ada8f$export$d0f7a26c90cc1562);
$parcel$export($2ae1fe659dc46dd2$exports, "AnimationStateAdapter", () => $96f986fcae8ada8f$export$31af0cf42be5a74d);
$parcel$export($2ae1fe659dc46dd2$exports, "EventQueue", () => $96f986fcae8ada8f$export$2fc6338444a158e6);
$parcel$export($2ae1fe659dc46dd2$exports, "EventType", () => $96f986fcae8ada8f$export$3d7865934588d77e);
$parcel$export($2ae1fe659dc46dd2$exports, "TrackEntry", () => $96f986fcae8ada8f$export$6fd48f25bc0ee658);
$parcel$export($2ae1fe659dc46dd2$exports, "AnimationStateData", () => $d7ff5e5c79580615$export$90d7167cc0605975);
$parcel$export($2ae1fe659dc46dd2$exports, "AtlasAttachmentLoader", () => $951b74e6d7b02e7a$export$2ff9add835475d95);
$parcel$export($2ae1fe659dc46dd2$exports, "Bone", () => $e11d34c987b6465b$export$b127726e56765aa4);
$parcel$export($2ae1fe659dc46dd2$exports, "BoneData", () => $53352ede0f332990$export$7d85d96cf093e12f);
$parcel$export($2ae1fe659dc46dd2$exports, "ConstraintData", () => $9feaa1f370017dae$export$b826e1ab3af63566);
$parcel$export($2ae1fe659dc46dd2$exports, "Event", () => $9457b24b76fdec68$export$d61e24a684f9e51);
$parcel$export($2ae1fe659dc46dd2$exports, "EventData", () => $6449a1e1fcf4967a$export$a5cf049e34c3d11e);
$parcel$export($2ae1fe659dc46dd2$exports, "IkConstraint", () => $bcf6acc583d42db0$export$3c158c80ff28c177);
$parcel$export($2ae1fe659dc46dd2$exports, "IkConstraintData", () => $c7dead7a06471124$export$adcb08b651fc712e);
$parcel$export($2ae1fe659dc46dd2$exports, "PathConstraint", () => $6362190055f451a7$export$cb4f92fb0c018828);
$parcel$export($2ae1fe659dc46dd2$exports, "PathConstraintData", () => $f3db500d9e578f13$export$d2629ab80d5dd5ba);
$parcel$export($2ae1fe659dc46dd2$exports, "SpacingMode", () => $f3db500d9e578f13$export$34ce760ad2b0be4b);
$parcel$export($2ae1fe659dc46dd2$exports, "Skeleton", () => $5b6659a17eaf6fe5$export$8f31e4c4a37b8e9c);
$parcel$export($2ae1fe659dc46dd2$exports, "SkeletonBinary", () => $cd7869ac723b60bd$export$a7f7eaf4e9fce9ef);
$parcel$export($2ae1fe659dc46dd2$exports, "SkeletonBounds", () => $88b9d0ae7c827eed$export$119f1746fc062f5e);
$parcel$export($2ae1fe659dc46dd2$exports, "SkeletonData", () => $55d718d92918b306$export$e8f362f163550575);
$parcel$export($2ae1fe659dc46dd2$exports, "SkeletonJson", () => $d82ca02a4894c3a8$export$8913b5e618c6d2f3);
$parcel$export($2ae1fe659dc46dd2$exports, "Skin", () => $4e95b87485e4f6dc$export$b8e0f93a76772233);
$parcel$export($2ae1fe659dc46dd2$exports, "SkinEntry", () => $4e95b87485e4f6dc$export$18ca51770a196b7d);
$parcel$export($2ae1fe659dc46dd2$exports, "Slot", () => $c7d1007eccfe6d2d$export$8c6ed5c666ac1360);
$parcel$export($2ae1fe659dc46dd2$exports, "SlotData", () => $2cfe2e8ef95dfc1b$export$a4cce1bf50208679);
$parcel$export($2ae1fe659dc46dd2$exports, "TransformConstraint", () => $9c06c865703471d6$export$a2d8268faabf5c52);
$parcel$export($2ae1fe659dc46dd2$exports, "TransformConstraintData", () => $0afd2e509d2277c4$export$823fbc29771afdb5);
$parcel$export($2ae1fe659dc46dd2$exports, "Spine", () => $b5b5641aeb82be9c$export$ce0a100797286aea);

class $0081823d79d97c28$export$71e4db985cfcf9e3 {
    constructor(name){
        if (name == null) throw new Error("name cannot be null.");
        this.name = name;
    }
}
const $0081823d79d97c28$var$_VertexAttachment = class extends $0081823d79d97c28$export$71e4db985cfcf9e3 {
    constructor(name){
        super(name);
        this.id = ($0081823d79d97c28$var$_VertexAttachment.nextID++ & 65535) << 11;
        this.worldVerticesLength = 0;
        this.deformAttachment = this;
    }
    computeWorldVerticesOld(slot, worldVertices) {
        this.computeWorldVertices(slot, 0, this.worldVerticesLength, worldVertices, 0, 2);
    }
    /** Transforms local vertices to world coordinates.
   * @param start The index of the first local vertex value to transform. Each vertex has 2 values, x and y.
   * @param count The number of world vertex values to output. Must be <= {@link #getWorldVerticesLength()} - start.
   * @param worldVertices The output world vertices. Must have a length >= offset + count.
   * @param offset The worldVertices index to begin writing values. */ computeWorldVertices(slot, start, count, worldVertices, offset, stride) {
        count = offset + (count >> 1) * stride;
        const skeleton = slot.bone.skeleton;
        const deformArray = slot.deform;
        let vertices = this.vertices;
        const bones = this.bones;
        if (bones == null) {
            if (deformArray.length > 0) vertices = deformArray;
            const mat = slot.bone.matrix;
            const x = mat.tx;
            const y = mat.ty;
            const a = mat.a;
            const b = mat.c;
            const c = mat.b;
            const d = mat.d;
            for(let v2 = start, w = offset; w < count; v2 += 2, w += stride){
                const vx = vertices[v2];
                const vy = vertices[v2 + 1];
                worldVertices[w] = vx * a + vy * b + x;
                worldVertices[w + 1] = vx * c + vy * d + y;
            }
            return;
        }
        let v = 0;
        let skip = 0;
        for(let i = 0; i < start; i += 2){
            const n = bones[v];
            v += n + 1;
            skip += n;
        }
        const skeletonBones = skeleton.bones;
        if (deformArray.length == 0) for(let w = offset, b = skip * 3; w < count; w += stride){
            let wx = 0;
            let wy = 0;
            let n = bones[v++];
            n += v;
            for(; v < n; v++, b += 3){
                const mat = skeletonBones[bones[v]].matrix;
                const vx = vertices[b];
                const vy = vertices[b + 1];
                const weight = vertices[b + 2];
                wx += (vx * mat.a + vy * mat.c + mat.tx) * weight;
                wy += (vx * mat.b + vy * mat.d + mat.ty) * weight;
            }
            worldVertices[w] = wx;
            worldVertices[w + 1] = wy;
        }
        else {
            const deform = deformArray;
            for(let w = offset, b = skip * 3, f = skip << 1; w < count; w += stride){
                let wx = 0;
                let wy = 0;
                let n = bones[v++];
                n += v;
                for(; v < n; v++, b += 3, f += 2){
                    const mat = skeletonBones[bones[v]].matrix;
                    const vx = vertices[b] + deform[f];
                    const vy = vertices[b + 1] + deform[f + 1];
                    const weight = vertices[b + 2];
                    wx += (vx * mat.a + vy * mat.c + mat.tx) * weight;
                    wy += (vx * mat.b + vy * mat.d + mat.ty) * weight;
                }
                worldVertices[w] = wx;
                worldVertices[w + 1] = wy;
            }
        }
    }
    copyTo(attachment) {
        if (this.bones != null) {
            attachment.bones = new Array(this.bones.length);
            (0, $8804784813ffae81$export$d2ca453b913dcdea).arrayCopy(this.bones, 0, attachment.bones, 0, this.bones.length);
        } else attachment.bones = null;
        if (this.vertices != null) {
            attachment.vertices = (0, $8804784813ffae81$export$d2ca453b913dcdea).newFloatArray(this.vertices.length);
            (0, $8804784813ffae81$export$d2ca453b913dcdea).arrayCopy(this.vertices, 0, attachment.vertices, 0, this.vertices.length);
        } else attachment.vertices = null;
        attachment.worldVerticesLength = this.worldVerticesLength;
        attachment.deformAttachment = this.deformAttachment;
    }
};
let $0081823d79d97c28$export$66d3a0c3be55e044 = $0081823d79d97c28$var$_VertexAttachment;
$0081823d79d97c28$export$66d3a0c3be55e044.nextID = 0;




class $ae0315e0b7337cf8$export$9538c439c6b85ad2 extends (0, $0081823d79d97c28$export$66d3a0c3be55e044) {
    constructor(name){
        super(name);
        this.type = (0, $4b0ad7d1400b5e69$export$86cfdc1f02eaf37a).BoundingBox;
        this.color = new (0, $8804784813ffae81$export$892596cec99bc70e)(1, 1, 1, 1);
    }
    copy() {
        const copy = new $ae0315e0b7337cf8$export$9538c439c6b85ad2(this.name);
        this.copyTo(copy);
        copy.color.setFromColor(this.color);
        return copy;
    }
}




class $a1af353be281720a$export$838805e22b9b55f1 extends (0, $0081823d79d97c28$export$66d3a0c3be55e044) {
    // ce3a3aff
    constructor(name){
        super(name);
        this.type = (0, $4b0ad7d1400b5e69$export$86cfdc1f02eaf37a).Clipping;
        // Nonessential.
        this.color = new (0, $8804784813ffae81$export$892596cec99bc70e)(0.2275, 0.2275, 0.8078, 1);
    }
    copy() {
        const copy = new $a1af353be281720a$export$838805e22b9b55f1(this.name);
        this.copyTo(copy);
        copy.endSlot = this.endSlot;
        copy.color.setFromColor(this.color);
        return copy;
    }
}




class $72698e89a18058e1$export$3f1c1692adfcf3e2 extends (0, $0081823d79d97c28$export$66d3a0c3be55e044) {
    constructor(name){
        super(name);
        this.type = (0, $4b0ad7d1400b5e69$export$86cfdc1f02eaf37a).Mesh;
        this.color = new (0, $8804784813ffae81$export$892596cec99bc70e)(1, 1, 1, 1);
        this.tempColor = new (0, $8804784813ffae81$export$892596cec99bc70e)(0, 0, 0, 0);
    }
    getParentMesh() {
        return this.parentMesh;
    }
    /** @param parentMesh May be null. */ setParentMesh(parentMesh) {
        this.parentMesh = parentMesh;
        if (parentMesh != null) {
            this.bones = parentMesh.bones;
            this.vertices = parentMesh.vertices;
            this.worldVerticesLength = parentMesh.worldVerticesLength;
            this.regionUVs = parentMesh.regionUVs;
            this.triangles = parentMesh.triangles;
            this.hullLength = parentMesh.hullLength;
            this.worldVerticesLength = parentMesh.worldVerticesLength;
        }
    }
    copy() {
        if (this.parentMesh != null) return this.newLinkedMesh();
        const copy = new $72698e89a18058e1$export$3f1c1692adfcf3e2(this.name);
        copy.region = this.region;
        copy.path = this.path;
        copy.color.setFromColor(this.color);
        this.copyTo(copy);
        copy.regionUVs = new Float32Array(this.regionUVs.length);
        (0, $8804784813ffae81$export$d2ca453b913dcdea).arrayCopy(this.regionUVs, 0, copy.regionUVs, 0, this.regionUVs.length);
        copy.triangles = new Array(this.triangles.length);
        (0, $8804784813ffae81$export$d2ca453b913dcdea).arrayCopy(this.triangles, 0, copy.triangles, 0, this.triangles.length);
        copy.hullLength = this.hullLength;
        if (this.edges != null) {
            copy.edges = new Array(this.edges.length);
            (0, $8804784813ffae81$export$d2ca453b913dcdea).arrayCopy(this.edges, 0, copy.edges, 0, this.edges.length);
        }
        copy.width = this.width;
        copy.height = this.height;
        return copy;
    }
    newLinkedMesh() {
        const copy = new $72698e89a18058e1$export$3f1c1692adfcf3e2(this.name);
        copy.region = this.region;
        copy.path = this.path;
        copy.color.setFromColor(this.color);
        copy.deformAttachment = this.deformAttachment;
        copy.setParentMesh(this.parentMesh != null ? this.parentMesh : this);
        return copy;
    }
}




class $ce5645df4e682fb4$export$d285e3ec07b32800 extends (0, $0081823d79d97c28$export$66d3a0c3be55e044) {
    constructor(name){
        super(name);
        this.type = (0, $4b0ad7d1400b5e69$export$86cfdc1f02eaf37a).Path;
        this.closed = false;
        this.constantSpeed = false;
        this.color = new (0, $8804784813ffae81$export$892596cec99bc70e)(1, 1, 1, 1);
    }
    copy() {
        const copy = new $ce5645df4e682fb4$export$d285e3ec07b32800(this.name);
        this.copyTo(copy);
        copy.lengths = new Array(this.lengths.length);
        (0, $8804784813ffae81$export$d2ca453b913dcdea).arrayCopy(this.lengths, 0, copy.lengths, 0, this.lengths.length);
        copy.closed = closed;
        copy.constantSpeed = this.constantSpeed;
        copy.color.setFromColor(this.color);
        return copy;
    }
}




class $5ba7a9dafefb646c$export$1b528cde44a6ab5 extends (0, $0081823d79d97c28$export$66d3a0c3be55e044) {
    constructor(name){
        super(name);
        this.type = (0, $4b0ad7d1400b5e69$export$86cfdc1f02eaf37a).Point;
        this.color = new (0, $8804784813ffae81$export$892596cec99bc70e)(0.38, 0.94, 0, 1);
    }
    computeWorldPosition(bone, point) {
        const mat = bone.matrix;
        point.x = this.x * mat.a + this.y * mat.c + bone.worldX;
        point.y = this.x * mat.b + this.y * mat.d + bone.worldY;
        return point;
    }
    computeWorldRotation(bone) {
        const mat = bone.matrix;
        const cos = (0, $8804784813ffae81$export$6a7ef315a0d1ef07).cosDeg(this.rotation);
        const sin = (0, $8804784813ffae81$export$6a7ef315a0d1ef07).sinDeg(this.rotation);
        const x = cos * mat.a + sin * mat.c;
        const y = cos * mat.b + sin * mat.d;
        return Math.atan2(y, x) * (0, $8804784813ffae81$export$6a7ef315a0d1ef07).radDeg;
    }
    copy() {
        const copy = new $5ba7a9dafefb646c$export$1b528cde44a6ab5(this.name);
        copy.x = this.x;
        copy.y = this.y;
        copy.rotation = this.rotation;
        copy.color.setFromColor(this.color);
        return copy;
    }
}





class $c7d1007eccfe6d2d$export$8c6ed5c666ac1360 {
    constructor(data, bone){
        this.deform = new Array();
        if (data == null) throw new Error("data cannot be null.");
        if (bone == null) throw new Error("bone cannot be null.");
        this.data = data;
        this.bone = bone;
        this.color = new (0, $8804784813ffae81$export$892596cec99bc70e)();
        this.darkColor = data.darkColor == null ? null : new (0, $8804784813ffae81$export$892596cec99bc70e)();
        this.setToSetupPose();
        this.blendMode = this.data.blendMode;
    }
    /** @return May be null. */ getAttachment() {
        return this.attachment;
    }
    /** Sets the attachment and if it changed, resets {@link #getAttachmentTime()} and clears {@link #getAttachmentVertices()}.
   * @param attachment May be null. */ setAttachment(attachment) {
        if (this.attachment == attachment) return;
        this.attachment = attachment;
        this.attachmentTime = this.bone.skeleton.time;
        this.deform.length = 0;
    }
    setAttachmentTime(time) {
        this.attachmentTime = this.bone.skeleton.time - time;
    }
    /** Returns the time since the attachment was set. */ getAttachmentTime() {
        return this.bone.skeleton.time - this.attachmentTime;
    }
    setToSetupPose() {
        this.color.setFromColor(this.data.color);
        if (this.darkColor != null) this.darkColor.setFromColor(this.data.darkColor);
        if (this.data.attachmentName == null) this.attachment = null;
        else {
            this.attachment = null;
            this.setAttachment(this.bone.skeleton.getAttachment(this.data.index, this.data.attachmentName));
        }
    }
}


const $33f8c953c70470fb$var$_RegionAttachment = class extends (0, $0081823d79d97c28$export$71e4db985cfcf9e3) {
    constructor(name){
        super(name);
        this.type = (0, $4b0ad7d1400b5e69$export$86cfdc1f02eaf37a).Region;
        this.x = 0;
        this.y = 0;
        this.scaleX = 1;
        this.scaleY = 1;
        this.rotation = 0;
        this.width = 0;
        this.height = 0;
        this.color = new (0, $8804784813ffae81$export$892596cec99bc70e)(1, 1, 1, 1);
        this.offset = (0, $8804784813ffae81$export$d2ca453b913dcdea).newFloatArray(8);
        this.uvs = (0, $8804784813ffae81$export$d2ca453b913dcdea).newFloatArray(8);
        this.tempColor = new (0, $8804784813ffae81$export$892596cec99bc70e)(1, 1, 1, 1);
    }
    updateOffset() {
        const regionScaleX = this.width / this.region.originalWidth * this.scaleX;
        const regionScaleY = this.height / this.region.originalHeight * this.scaleY;
        const localX = -this.width / 2 * this.scaleX + this.region.offsetX * regionScaleX;
        const localY = -this.height / 2 * this.scaleY + this.region.offsetY * regionScaleY;
        const localX2 = localX + this.region.width * regionScaleX;
        const localY2 = localY + this.region.height * regionScaleY;
        const radians = this.rotation * Math.PI / 180;
        const cos = Math.cos(radians);
        const sin = Math.sin(radians);
        const localXCos = localX * cos + this.x;
        const localXSin = localX * sin;
        const localYCos = localY * cos + this.y;
        const localYSin = localY * sin;
        const localX2Cos = localX2 * cos + this.x;
        const localX2Sin = localX2 * sin;
        const localY2Cos = localY2 * cos + this.y;
        const localY2Sin = localY2 * sin;
        const offset = this.offset;
        offset[$33f8c953c70470fb$var$_RegionAttachment.OX1] = localXCos - localYSin;
        offset[$33f8c953c70470fb$var$_RegionAttachment.OY1] = localYCos + localXSin;
        offset[$33f8c953c70470fb$var$_RegionAttachment.OX2] = localXCos - localY2Sin;
        offset[$33f8c953c70470fb$var$_RegionAttachment.OY2] = localY2Cos + localXSin;
        offset[$33f8c953c70470fb$var$_RegionAttachment.OX3] = localX2Cos - localY2Sin;
        offset[$33f8c953c70470fb$var$_RegionAttachment.OY3] = localY2Cos + localX2Sin;
        offset[$33f8c953c70470fb$var$_RegionAttachment.OX4] = localX2Cos - localYSin;
        offset[$33f8c953c70470fb$var$_RegionAttachment.OY4] = localYCos + localX2Sin;
    }
    setRegion(region) {
        this.region = region;
        const uvs = this.uvs;
        if (region.rotate) {
            uvs[2] = region.u;
            uvs[3] = region.v2;
            uvs[4] = region.u;
            uvs[5] = region.v;
            uvs[6] = region.u2;
            uvs[7] = region.v;
            uvs[0] = region.u2;
            uvs[1] = region.v2;
        } else {
            uvs[0] = region.u;
            uvs[1] = region.v2;
            uvs[2] = region.u;
            uvs[3] = region.v;
            uvs[4] = region.u2;
            uvs[5] = region.v;
            uvs[6] = region.u2;
            uvs[7] = region.v2;
        }
    }
    computeWorldVertices(bone, worldVertices, offset, stride) {
        const vertexOffset = this.offset;
        const mat = bone instanceof (0, $c7d1007eccfe6d2d$export$8c6ed5c666ac1360) ? bone.bone.matrix : bone.matrix;
        const x = mat.tx;
        const y = mat.ty;
        const a = mat.a;
        const b = mat.c;
        const c = mat.b;
        const d = mat.d;
        let offsetX = 0;
        let offsetY = 0;
        offsetX = vertexOffset[$33f8c953c70470fb$var$_RegionAttachment.OX1];
        offsetY = vertexOffset[$33f8c953c70470fb$var$_RegionAttachment.OY1];
        worldVertices[offset] = offsetX * a + offsetY * b + x;
        worldVertices[offset + 1] = offsetX * c + offsetY * d + y;
        offset += stride;
        offsetX = vertexOffset[$33f8c953c70470fb$var$_RegionAttachment.OX2];
        offsetY = vertexOffset[$33f8c953c70470fb$var$_RegionAttachment.OY2];
        worldVertices[offset] = offsetX * a + offsetY * b + x;
        worldVertices[offset + 1] = offsetX * c + offsetY * d + y;
        offset += stride;
        offsetX = vertexOffset[$33f8c953c70470fb$var$_RegionAttachment.OX3];
        offsetY = vertexOffset[$33f8c953c70470fb$var$_RegionAttachment.OY3];
        worldVertices[offset] = offsetX * a + offsetY * b + x;
        worldVertices[offset + 1] = offsetX * c + offsetY * d + y;
        offset += stride;
        offsetX = vertexOffset[$33f8c953c70470fb$var$_RegionAttachment.OX4];
        offsetY = vertexOffset[$33f8c953c70470fb$var$_RegionAttachment.OY4];
        worldVertices[offset] = offsetX * a + offsetY * b + x;
        worldVertices[offset + 1] = offsetX * c + offsetY * d + y;
    }
    copy() {
        const copy = new $33f8c953c70470fb$var$_RegionAttachment(this.name);
        copy.region = this.region;
        copy.rendererObject = this.rendererObject;
        copy.path = this.path;
        copy.x = this.x;
        copy.y = this.y;
        copy.scaleX = this.scaleX;
        copy.scaleY = this.scaleY;
        copy.rotation = this.rotation;
        copy.width = this.width;
        copy.height = this.height;
        (0, $8804784813ffae81$export$d2ca453b913dcdea).arrayCopy(this.uvs, 0, copy.uvs, 0, 8);
        (0, $8804784813ffae81$export$d2ca453b913dcdea).arrayCopy(this.offset, 0, copy.offset, 0, 8);
        copy.color.setFromColor(this.color);
        return copy;
    }
};
let $33f8c953c70470fb$export$d0fc51466fa6d530 = $33f8c953c70470fb$var$_RegionAttachment;
$33f8c953c70470fb$export$d0fc51466fa6d530.OX1 = 0;
$33f8c953c70470fb$export$d0fc51466fa6d530.OY1 = 1;
$33f8c953c70470fb$export$d0fc51466fa6d530.OX2 = 2;
$33f8c953c70470fb$export$d0fc51466fa6d530.OY2 = 3;
$33f8c953c70470fb$export$d0fc51466fa6d530.OX3 = 4;
$33f8c953c70470fb$export$d0fc51466fa6d530.OY3 = 5;
$33f8c953c70470fb$export$d0fc51466fa6d530.OX4 = 6;
$33f8c953c70470fb$export$d0fc51466fa6d530.OY4 = 7;
$33f8c953c70470fb$export$d0fc51466fa6d530.X1 = 0;
$33f8c953c70470fb$export$d0fc51466fa6d530.Y1 = 1;
$33f8c953c70470fb$export$d0fc51466fa6d530.C1R = 2;
$33f8c953c70470fb$export$d0fc51466fa6d530.C1G = 3;
$33f8c953c70470fb$export$d0fc51466fa6d530.C1B = 4;
$33f8c953c70470fb$export$d0fc51466fa6d530.C1A = 5;
$33f8c953c70470fb$export$d0fc51466fa6d530.U1 = 6;
$33f8c953c70470fb$export$d0fc51466fa6d530.V1 = 7;
$33f8c953c70470fb$export$d0fc51466fa6d530.X2 = 8;
$33f8c953c70470fb$export$d0fc51466fa6d530.Y2 = 9;
$33f8c953c70470fb$export$d0fc51466fa6d530.C2R = 10;
$33f8c953c70470fb$export$d0fc51466fa6d530.C2G = 11;
$33f8c953c70470fb$export$d0fc51466fa6d530.C2B = 12;
$33f8c953c70470fb$export$d0fc51466fa6d530.C2A = 13;
$33f8c953c70470fb$export$d0fc51466fa6d530.U2 = 14;
$33f8c953c70470fb$export$d0fc51466fa6d530.V2 = 15;
$33f8c953c70470fb$export$d0fc51466fa6d530.X3 = 16;
$33f8c953c70470fb$export$d0fc51466fa6d530.Y3 = 17;
$33f8c953c70470fb$export$d0fc51466fa6d530.C3R = 18;
$33f8c953c70470fb$export$d0fc51466fa6d530.C3G = 19;
$33f8c953c70470fb$export$d0fc51466fa6d530.C3B = 20;
$33f8c953c70470fb$export$d0fc51466fa6d530.C3A = 21;
$33f8c953c70470fb$export$d0fc51466fa6d530.U3 = 22;
$33f8c953c70470fb$export$d0fc51466fa6d530.V3 = 23;
$33f8c953c70470fb$export$d0fc51466fa6d530.X4 = 24;
$33f8c953c70470fb$export$d0fc51466fa6d530.Y4 = 25;
$33f8c953c70470fb$export$d0fc51466fa6d530.C4R = 26;
$33f8c953c70470fb$export$d0fc51466fa6d530.C4G = 27;
$33f8c953c70470fb$export$d0fc51466fa6d530.C4B = 28;
$33f8c953c70470fb$export$d0fc51466fa6d530.C4A = 29;
$33f8c953c70470fb$export$d0fc51466fa6d530.U4 = 30;
$33f8c953c70470fb$export$d0fc51466fa6d530.V4 = 31;



class $fbc310730cadd3fd$export$fcba7f85d07a2c99 {
    constructor(jitterX, jitterY){
        this.jitterX = 0;
        this.jitterY = 0;
        this.jitterX = jitterX;
        this.jitterY = jitterY;
    }
    begin(skeleton) {}
    transform(position, uv, light, dark) {
        position.x += (0, $8804784813ffae81$export$6a7ef315a0d1ef07).randomTriangular(-this.jitterX, this.jitterY);
        position.y += (0, $8804784813ffae81$export$6a7ef315a0d1ef07).randomTriangular(-this.jitterX, this.jitterY);
    }
    end() {}
}



const $f53431ec7c0efb37$var$_SwirlEffect = class {
    constructor(radius){
        this.centerX = 0;
        this.centerY = 0;
        this.radius = 0;
        this.angle = 0;
        this.worldX = 0;
        this.worldY = 0;
        this.radius = radius;
    }
    begin(skeleton) {
        this.worldX = skeleton.x + this.centerX;
        this.worldY = skeleton.y + this.centerY;
    }
    transform(position, uv, light, dark) {
        const radAngle = this.angle * (0, $8804784813ffae81$export$6a7ef315a0d1ef07).degreesToRadians;
        const x = position.x - this.worldX;
        const y = position.y - this.worldY;
        const dist = Math.sqrt(x * x + y * y);
        if (dist < this.radius) {
            const theta = $f53431ec7c0efb37$var$_SwirlEffect.interpolation.apply(0, radAngle, (this.radius - dist) / this.radius);
            const cos = Math.cos(theta);
            const sin = Math.sin(theta);
            position.x = cos * x - sin * y + this.worldX;
            position.y = sin * x + cos * y + this.worldY;
        }
    }
    end() {}
};
let $f53431ec7c0efb37$export$bf3ff70e38c4c145 = $f53431ec7c0efb37$var$_SwirlEffect;
$f53431ec7c0efb37$export$bf3ff70e38c4c145.interpolation = new (0, $8804784813ffae81$export$4834f341f53dca5c)(2);





class $a99189e38c28e5fb$export$c35d437ae5945fcd {
    constructor(name, timelines, duration){
        if (name == null) throw new Error("name cannot be null.");
        if (timelines == null) throw new Error("timelines cannot be null.");
        this.name = name;
        this.timelines = timelines;
        this.timelineIds = [];
        for(let i = 0; i < timelines.length; i++)this.timelineIds[timelines[i].getPropertyId()] = true;
        this.duration = duration;
    }
    hasTimeline(id) {
        return this.timelineIds[id] == true;
    }
    /** Applies all the animation's timelines to the specified skeleton.
   *
   * See Timeline {@link Timeline#apply(Skeleton, float, float, Array, float, MixBlend, MixDirection)}.
   * @param loop If true, the animation repeats after {@link #getDuration()}.
   * @param events May be null to ignore fired events. */ apply(skeleton, lastTime, time, loop, events, alpha, blend, direction) {
        if (skeleton == null) throw new Error("skeleton cannot be null.");
        if (loop && this.duration != 0) {
            time %= this.duration;
            if (lastTime > 0) lastTime %= this.duration;
        }
        const timelines = this.timelines;
        for(let i = 0, n = timelines.length; i < n; i++)timelines[i].apply(skeleton, lastTime, time, events, alpha, blend, direction);
    }
    /** @param target After the first and before the last value.
   * @returns index of first value greater than the target. */ static binarySearch(values, target, step = 1) {
        let low = 0;
        let high = values.length / step - 2;
        if (high == 0) return step;
        let current = high >>> 1;
        while(true){
            if (values[(current + 1) * step] <= target) low = current + 1;
            else high = current;
            if (low == high) return (low + 1) * step;
            current = low + high >>> 1;
        }
    }
    static linearSearch(values, target, step) {
        for(let i = 0, last = values.length - step; i <= last; i += step)if (values[i] > target) return i;
        return -1;
    }
}
var $a99189e38c28e5fb$export$11f4f8480e4dd7d2 = /* @__PURE__ */ ((TimelineType2)=>{
    TimelineType2[TimelineType2["rotate"] = 0] = "rotate";
    TimelineType2[TimelineType2["translate"] = 1] = "translate";
    TimelineType2[TimelineType2["scale"] = 2] = "scale";
    TimelineType2[TimelineType2["shear"] = 3] = "shear";
    TimelineType2[TimelineType2["attachment"] = 4] = "attachment";
    TimelineType2[TimelineType2["color"] = 5] = "color";
    TimelineType2[TimelineType2["deform"] = 6] = "deform";
    TimelineType2[TimelineType2["event"] = 7] = "event";
    TimelineType2[TimelineType2["drawOrder"] = 8] = "drawOrder";
    TimelineType2[TimelineType2["ikConstraint"] = 9] = "ikConstraint";
    TimelineType2[TimelineType2["transformConstraint"] = 10] = "transformConstraint";
    TimelineType2[TimelineType2["pathConstraintPosition"] = 11] = "pathConstraintPosition";
    TimelineType2[TimelineType2["pathConstraintSpacing"] = 12] = "pathConstraintSpacing";
    TimelineType2[TimelineType2["pathConstraintMix"] = 13] = "pathConstraintMix";
    TimelineType2[TimelineType2["twoColor"] = 14] = "twoColor";
    return TimelineType2;
})($a99189e38c28e5fb$export$11f4f8480e4dd7d2 || {});
const $a99189e38c28e5fb$var$_CurveTimeline = class {
    constructor(frameCount){
        if (frameCount <= 0) throw new Error(`frameCount must be > 0: ${frameCount}`);
        this.curves = (0, $8804784813ffae81$export$d2ca453b913dcdea).newFloatArray((frameCount - 1) * $a99189e38c28e5fb$var$_CurveTimeline.BEZIER_SIZE);
    }
    /** The number of key frames for this timeline. */ getFrameCount() {
        return this.curves.length / $a99189e38c28e5fb$var$_CurveTimeline.BEZIER_SIZE + 1;
    }
    /** Sets the specified key frame to linear interpolation. */ setLinear(frameIndex) {
        this.curves[frameIndex * $a99189e38c28e5fb$var$_CurveTimeline.BEZIER_SIZE] = $a99189e38c28e5fb$var$_CurveTimeline.LINEAR;
    }
    /** Sets the specified key frame to stepped interpolation. */ setStepped(frameIndex) {
        this.curves[frameIndex * $a99189e38c28e5fb$var$_CurveTimeline.BEZIER_SIZE] = $a99189e38c28e5fb$var$_CurveTimeline.STEPPED;
    }
    /** Returns the interpolation type for the specified key frame.
   * @returns Linear is 0, stepped is 1, Bezier is 2. */ getCurveType(frameIndex) {
        const index = frameIndex * $a99189e38c28e5fb$var$_CurveTimeline.BEZIER_SIZE;
        if (index == this.curves.length) return $a99189e38c28e5fb$var$_CurveTimeline.LINEAR;
        const type = this.curves[index];
        if (type == $a99189e38c28e5fb$var$_CurveTimeline.LINEAR) return $a99189e38c28e5fb$var$_CurveTimeline.LINEAR;
        if (type == $a99189e38c28e5fb$var$_CurveTimeline.STEPPED) return $a99189e38c28e5fb$var$_CurveTimeline.STEPPED;
        return $a99189e38c28e5fb$var$_CurveTimeline.BEZIER;
    }
    /** Sets the specified key frame to Bezier interpolation. `cx1` and `cx2` are from 0 to 1,
   * representing the percent of time between the two key frames. `cy1` and `cy2` are the percent of the
   * difference between the key frame's values. */ setCurve(frameIndex, cx1, cy1, cx2, cy2) {
        const tmpx = (-cx1 * 2 + cx2) * 0.03;
        const tmpy = (-cy1 * 2 + cy2) * 0.03;
        const dddfx = ((cx1 - cx2) * 3 + 1) * 6e-3;
        const dddfy = ((cy1 - cy2) * 3 + 1) * 6e-3;
        let ddfx = tmpx * 2 + dddfx;
        let ddfy = tmpy * 2 + dddfy;
        let dfx = cx1 * 0.3 + tmpx + dddfx * 0.16666667;
        let dfy = cy1 * 0.3 + tmpy + dddfy * 0.16666667;
        let i = frameIndex * $a99189e38c28e5fb$var$_CurveTimeline.BEZIER_SIZE;
        const curves = this.curves;
        curves[i++] = $a99189e38c28e5fb$var$_CurveTimeline.BEZIER;
        let x = dfx;
        let y = dfy;
        for(let n = i + $a99189e38c28e5fb$var$_CurveTimeline.BEZIER_SIZE - 1; i < n; i += 2){
            curves[i] = x;
            curves[i + 1] = y;
            dfx += ddfx;
            dfy += ddfy;
            ddfx += dddfx;
            ddfy += dddfy;
            x += dfx;
            y += dfy;
        }
    }
    /** Returns the interpolated percentage for the specified key frame and linear percentage. */ getCurvePercent(frameIndex, percent) {
        percent = (0, $8804784813ffae81$export$6a7ef315a0d1ef07).clamp(percent, 0, 1);
        const curves = this.curves;
        let i = frameIndex * $a99189e38c28e5fb$var$_CurveTimeline.BEZIER_SIZE;
        const type = curves[i];
        if (type == $a99189e38c28e5fb$var$_CurveTimeline.LINEAR) return percent;
        if (type == $a99189e38c28e5fb$var$_CurveTimeline.STEPPED) return 0;
        i++;
        let x = 0;
        for(let start = i, n = i + $a99189e38c28e5fb$var$_CurveTimeline.BEZIER_SIZE - 1; i < n; i += 2){
            x = curves[i];
            if (x >= percent) {
                let prevX;
                let prevY;
                if (i == start) {
                    prevX = 0;
                    prevY = 0;
                } else {
                    prevX = curves[i - 2];
                    prevY = curves[i - 1];
                }
                return prevY + (curves[i + 1] - prevY) * (percent - prevX) / (x - prevX);
            }
        }
        const y = curves[i - 1];
        return y + (1 - y) * (percent - x) / (1 - x);
    }
};
let $a99189e38c28e5fb$export$4094e7414845f78f = $a99189e38c28e5fb$var$_CurveTimeline;
$a99189e38c28e5fb$export$4094e7414845f78f.LINEAR = 0;
$a99189e38c28e5fb$export$4094e7414845f78f.STEPPED = 1;
$a99189e38c28e5fb$export$4094e7414845f78f.BEZIER = 2;
$a99189e38c28e5fb$export$4094e7414845f78f.BEZIER_SIZE = 19;
const $a99189e38c28e5fb$var$_RotateTimeline = class extends $a99189e38c28e5fb$export$4094e7414845f78f {
    // time, degrees, ...
    constructor(frameCount){
        super(frameCount);
        this.frames = (0, $8804784813ffae81$export$d2ca453b913dcdea).newFloatArray(frameCount << 1);
    }
    getPropertyId() {
        return 0 + this.boneIndex;
    }
    /** Sets the time and angle of the specified keyframe. */ setFrame(frameIndex, time, degrees) {
        frameIndex <<= 1;
        this.frames[frameIndex] = time;
        this.frames[frameIndex + $a99189e38c28e5fb$var$_RotateTimeline.ROTATION] = degrees;
    }
    apply(skeleton, lastTime, time, events, alpha, blend, direction) {
        const frames = this.frames;
        const bone = skeleton.bones[this.boneIndex];
        if (!bone.active) return;
        if (time < frames[0]) {
            switch(blend){
                case (0, $bbcccedbc883e405$export$ccab779a50275a35).setup:
                    bone.rotation = bone.data.rotation;
                    return;
                case (0, $bbcccedbc883e405$export$ccab779a50275a35).first:
                    const r2 = bone.data.rotation - bone.rotation;
                    bone.rotation += (r2 - (16384 - (16384.499999999996 - r2 / 360 | 0)) * 360) * alpha;
            }
            return;
        }
        if (time >= frames[frames.length - $a99189e38c28e5fb$var$_RotateTimeline.ENTRIES]) {
            let r2 = frames[frames.length + $a99189e38c28e5fb$var$_RotateTimeline.PREV_ROTATION];
            switch(blend){
                case (0, $bbcccedbc883e405$export$ccab779a50275a35).setup:
                    bone.rotation = bone.data.rotation + r2 * alpha;
                    break;
                case (0, $bbcccedbc883e405$export$ccab779a50275a35).first:
                case (0, $bbcccedbc883e405$export$ccab779a50275a35).replace:
                    r2 += bone.data.rotation - bone.rotation;
                    r2 -= (16384 - (16384.499999999996 - r2 / 360 | 0)) * 360;
                case (0, $bbcccedbc883e405$export$ccab779a50275a35).add:
                    bone.rotation += r2 * alpha;
            }
            return;
        }
        const frame = $a99189e38c28e5fb$export$c35d437ae5945fcd.binarySearch(frames, time, $a99189e38c28e5fb$var$_RotateTimeline.ENTRIES);
        const prevRotation = frames[frame + $a99189e38c28e5fb$var$_RotateTimeline.PREV_ROTATION];
        const frameTime = frames[frame];
        const percent = this.getCurvePercent((frame >> 1) - 1, 1 - (time - frameTime) / (frames[frame + $a99189e38c28e5fb$var$_RotateTimeline.PREV_TIME] - frameTime));
        let r = frames[frame + $a99189e38c28e5fb$var$_RotateTimeline.ROTATION] - prevRotation;
        r = prevRotation + (r - (16384 - (16384.499999999996 - r / 360 | 0)) * 360) * percent;
        switch(blend){
            case (0, $bbcccedbc883e405$export$ccab779a50275a35).setup:
                bone.rotation = bone.data.rotation + (r - (16384 - (16384.499999999996 - r / 360 | 0)) * 360) * alpha;
                break;
            case (0, $bbcccedbc883e405$export$ccab779a50275a35).first:
            case (0, $bbcccedbc883e405$export$ccab779a50275a35).replace:
                r += bone.data.rotation - bone.rotation;
            case (0, $bbcccedbc883e405$export$ccab779a50275a35).add:
                bone.rotation += (r - (16384 - (16384.499999999996 - r / 360 | 0)) * 360) * alpha;
        }
    }
};
let $a99189e38c28e5fb$export$b7ecb8f68b3e130b = $a99189e38c28e5fb$var$_RotateTimeline;
$a99189e38c28e5fb$export$b7ecb8f68b3e130b.ENTRIES = 2;
$a99189e38c28e5fb$export$b7ecb8f68b3e130b.PREV_TIME = -2;
$a99189e38c28e5fb$export$b7ecb8f68b3e130b.PREV_ROTATION = -1;
$a99189e38c28e5fb$export$b7ecb8f68b3e130b.ROTATION = 1;
const $a99189e38c28e5fb$var$_TranslateTimeline = class extends $a99189e38c28e5fb$export$4094e7414845f78f {
    // time, x, y, ...
    constructor(frameCount){
        super(frameCount);
        this.frames = (0, $8804784813ffae81$export$d2ca453b913dcdea).newFloatArray(frameCount * $a99189e38c28e5fb$var$_TranslateTimeline.ENTRIES);
    }
    getPropertyId() {
        return 16777216 + this.boneIndex;
    }
    /** Sets the time in seconds, x, and y values for the specified key frame. */ setFrame(frameIndex, time, x, y) {
        frameIndex *= $a99189e38c28e5fb$var$_TranslateTimeline.ENTRIES;
        this.frames[frameIndex] = time;
        this.frames[frameIndex + $a99189e38c28e5fb$var$_TranslateTimeline.X] = x;
        this.frames[frameIndex + $a99189e38c28e5fb$var$_TranslateTimeline.Y] = y;
    }
    apply(skeleton, lastTime, time, events, alpha, blend, direction) {
        const frames = this.frames;
        const bone = skeleton.bones[this.boneIndex];
        if (!bone.active) return;
        if (time < frames[0]) {
            switch(blend){
                case (0, $bbcccedbc883e405$export$ccab779a50275a35).setup:
                    bone.x = bone.data.x;
                    bone.y = bone.data.y;
                    return;
                case (0, $bbcccedbc883e405$export$ccab779a50275a35).first:
                    bone.x += (bone.data.x - bone.x) * alpha;
                    bone.y += (bone.data.y - bone.y) * alpha;
            }
            return;
        }
        let x = 0;
        let y = 0;
        if (time >= frames[frames.length - $a99189e38c28e5fb$var$_TranslateTimeline.ENTRIES]) {
            x = frames[frames.length + $a99189e38c28e5fb$var$_TranslateTimeline.PREV_X];
            y = frames[frames.length + $a99189e38c28e5fb$var$_TranslateTimeline.PREV_Y];
        } else {
            const frame = $a99189e38c28e5fb$export$c35d437ae5945fcd.binarySearch(frames, time, $a99189e38c28e5fb$var$_TranslateTimeline.ENTRIES);
            x = frames[frame + $a99189e38c28e5fb$var$_TranslateTimeline.PREV_X];
            y = frames[frame + $a99189e38c28e5fb$var$_TranslateTimeline.PREV_Y];
            const frameTime = frames[frame];
            const percent = this.getCurvePercent(frame / $a99189e38c28e5fb$var$_TranslateTimeline.ENTRIES - 1, 1 - (time - frameTime) / (frames[frame + $a99189e38c28e5fb$var$_TranslateTimeline.PREV_TIME] - frameTime));
            x += (frames[frame + $a99189e38c28e5fb$var$_TranslateTimeline.X] - x) * percent;
            y += (frames[frame + $a99189e38c28e5fb$var$_TranslateTimeline.Y] - y) * percent;
        }
        switch(blend){
            case (0, $bbcccedbc883e405$export$ccab779a50275a35).setup:
                bone.x = bone.data.x + x * alpha;
                bone.y = bone.data.y + y * alpha;
                break;
            case (0, $bbcccedbc883e405$export$ccab779a50275a35).first:
            case (0, $bbcccedbc883e405$export$ccab779a50275a35).replace:
                bone.x += (bone.data.x + x - bone.x) * alpha;
                bone.y += (bone.data.y + y - bone.y) * alpha;
                break;
            case (0, $bbcccedbc883e405$export$ccab779a50275a35).add:
                bone.x += x * alpha;
                bone.y += y * alpha;
        }
    }
};
let $a99189e38c28e5fb$export$eb93bf27829ae703 = $a99189e38c28e5fb$var$_TranslateTimeline;
$a99189e38c28e5fb$export$eb93bf27829ae703.ENTRIES = 3;
$a99189e38c28e5fb$export$eb93bf27829ae703.PREV_TIME = -3;
$a99189e38c28e5fb$export$eb93bf27829ae703.PREV_X = -2;
$a99189e38c28e5fb$export$eb93bf27829ae703.PREV_Y = -1;
$a99189e38c28e5fb$export$eb93bf27829ae703.X = 1;
$a99189e38c28e5fb$export$eb93bf27829ae703.Y = 2;
class $a99189e38c28e5fb$export$be544e22f6ad7737 extends $a99189e38c28e5fb$export$eb93bf27829ae703 {
    constructor(frameCount){
        super(frameCount);
    }
    getPropertyId() {
        return 33554432 + this.boneIndex;
    }
    apply(skeleton, lastTime, time, events, alpha, blend, direction) {
        const frames = this.frames;
        const bone = skeleton.bones[this.boneIndex];
        if (!bone.active) return;
        if (time < frames[0]) {
            switch(blend){
                case (0, $bbcccedbc883e405$export$ccab779a50275a35).setup:
                    bone.scaleX = bone.data.scaleX;
                    bone.scaleY = bone.data.scaleY;
                    return;
                case (0, $bbcccedbc883e405$export$ccab779a50275a35).first:
                    bone.scaleX += (bone.data.scaleX - bone.scaleX) * alpha;
                    bone.scaleY += (bone.data.scaleY - bone.scaleY) * alpha;
            }
            return;
        }
        let x = 0;
        let y = 0;
        if (time >= frames[frames.length - $a99189e38c28e5fb$export$be544e22f6ad7737.ENTRIES]) {
            x = frames[frames.length + $a99189e38c28e5fb$export$be544e22f6ad7737.PREV_X] * bone.data.scaleX;
            y = frames[frames.length + $a99189e38c28e5fb$export$be544e22f6ad7737.PREV_Y] * bone.data.scaleY;
        } else {
            const frame = $a99189e38c28e5fb$export$c35d437ae5945fcd.binarySearch(frames, time, $a99189e38c28e5fb$export$be544e22f6ad7737.ENTRIES);
            x = frames[frame + $a99189e38c28e5fb$export$be544e22f6ad7737.PREV_X];
            y = frames[frame + $a99189e38c28e5fb$export$be544e22f6ad7737.PREV_Y];
            const frameTime = frames[frame];
            const percent = this.getCurvePercent(frame / $a99189e38c28e5fb$export$be544e22f6ad7737.ENTRIES - 1, 1 - (time - frameTime) / (frames[frame + $a99189e38c28e5fb$export$be544e22f6ad7737.PREV_TIME] - frameTime));
            x = (x + (frames[frame + $a99189e38c28e5fb$export$be544e22f6ad7737.X] - x) * percent) * bone.data.scaleX;
            y = (y + (frames[frame + $a99189e38c28e5fb$export$be544e22f6ad7737.Y] - y) * percent) * bone.data.scaleY;
        }
        if (alpha == 1) {
            if (blend == (0, $bbcccedbc883e405$export$ccab779a50275a35).add) {
                bone.scaleX += x - bone.data.scaleX;
                bone.scaleY += y - bone.data.scaleY;
            } else {
                bone.scaleX = x;
                bone.scaleY = y;
            }
        } else {
            let bx = 0;
            let by = 0;
            if (direction == (0, $bbcccedbc883e405$export$52fc338c0bb328ba).mixOut) switch(blend){
                case (0, $bbcccedbc883e405$export$ccab779a50275a35).setup:
                    bx = bone.data.scaleX;
                    by = bone.data.scaleY;
                    bone.scaleX = bx + (Math.abs(x) * (0, $8804784813ffae81$export$6a7ef315a0d1ef07).signum(bx) - bx) * alpha;
                    bone.scaleY = by + (Math.abs(y) * (0, $8804784813ffae81$export$6a7ef315a0d1ef07).signum(by) - by) * alpha;
                    break;
                case (0, $bbcccedbc883e405$export$ccab779a50275a35).first:
                case (0, $bbcccedbc883e405$export$ccab779a50275a35).replace:
                    bx = bone.scaleX;
                    by = bone.scaleY;
                    bone.scaleX = bx + (Math.abs(x) * (0, $8804784813ffae81$export$6a7ef315a0d1ef07).signum(bx) - bx) * alpha;
                    bone.scaleY = by + (Math.abs(y) * (0, $8804784813ffae81$export$6a7ef315a0d1ef07).signum(by) - by) * alpha;
                    break;
                case (0, $bbcccedbc883e405$export$ccab779a50275a35).add:
                    bx = bone.scaleX;
                    by = bone.scaleY;
                    bone.scaleX = bx + (Math.abs(x) * (0, $8804784813ffae81$export$6a7ef315a0d1ef07).signum(bx) - bone.data.scaleX) * alpha;
                    bone.scaleY = by + (Math.abs(y) * (0, $8804784813ffae81$export$6a7ef315a0d1ef07).signum(by) - bone.data.scaleY) * alpha;
            }
            else switch(blend){
                case (0, $bbcccedbc883e405$export$ccab779a50275a35).setup:
                    bx = Math.abs(bone.data.scaleX) * (0, $8804784813ffae81$export$6a7ef315a0d1ef07).signum(x);
                    by = Math.abs(bone.data.scaleY) * (0, $8804784813ffae81$export$6a7ef315a0d1ef07).signum(y);
                    bone.scaleX = bx + (x - bx) * alpha;
                    bone.scaleY = by + (y - by) * alpha;
                    break;
                case (0, $bbcccedbc883e405$export$ccab779a50275a35).first:
                case (0, $bbcccedbc883e405$export$ccab779a50275a35).replace:
                    bx = Math.abs(bone.scaleX) * (0, $8804784813ffae81$export$6a7ef315a0d1ef07).signum(x);
                    by = Math.abs(bone.scaleY) * (0, $8804784813ffae81$export$6a7ef315a0d1ef07).signum(y);
                    bone.scaleX = bx + (x - bx) * alpha;
                    bone.scaleY = by + (y - by) * alpha;
                    break;
                case (0, $bbcccedbc883e405$export$ccab779a50275a35).add:
                    bx = (0, $8804784813ffae81$export$6a7ef315a0d1ef07).signum(x);
                    by = (0, $8804784813ffae81$export$6a7ef315a0d1ef07).signum(y);
                    bone.scaleX = Math.abs(bone.scaleX) * bx + (x - Math.abs(bone.data.scaleX) * bx) * alpha;
                    bone.scaleY = Math.abs(bone.scaleY) * by + (y - Math.abs(bone.data.scaleY) * by) * alpha;
            }
        }
    }
}
class $a99189e38c28e5fb$export$4da82436a1a0d773 extends $a99189e38c28e5fb$export$eb93bf27829ae703 {
    constructor(frameCount){
        super(frameCount);
    }
    getPropertyId() {
        return 50331648 + this.boneIndex;
    }
    apply(skeleton, lastTime, time, events, alpha, blend, direction) {
        const frames = this.frames;
        const bone = skeleton.bones[this.boneIndex];
        if (!bone.active) return;
        if (time < frames[0]) {
            switch(blend){
                case (0, $bbcccedbc883e405$export$ccab779a50275a35).setup:
                    bone.shearX = bone.data.shearX;
                    bone.shearY = bone.data.shearY;
                    return;
                case (0, $bbcccedbc883e405$export$ccab779a50275a35).first:
                    bone.shearX += (bone.data.shearX - bone.shearX) * alpha;
                    bone.shearY += (bone.data.shearY - bone.shearY) * alpha;
            }
            return;
        }
        let x = 0;
        let y = 0;
        if (time >= frames[frames.length - $a99189e38c28e5fb$export$4da82436a1a0d773.ENTRIES]) {
            x = frames[frames.length + $a99189e38c28e5fb$export$4da82436a1a0d773.PREV_X];
            y = frames[frames.length + $a99189e38c28e5fb$export$4da82436a1a0d773.PREV_Y];
        } else {
            const frame = $a99189e38c28e5fb$export$c35d437ae5945fcd.binarySearch(frames, time, $a99189e38c28e5fb$export$4da82436a1a0d773.ENTRIES);
            x = frames[frame + $a99189e38c28e5fb$export$4da82436a1a0d773.PREV_X];
            y = frames[frame + $a99189e38c28e5fb$export$4da82436a1a0d773.PREV_Y];
            const frameTime = frames[frame];
            const percent = this.getCurvePercent(frame / $a99189e38c28e5fb$export$4da82436a1a0d773.ENTRIES - 1, 1 - (time - frameTime) / (frames[frame + $a99189e38c28e5fb$export$4da82436a1a0d773.PREV_TIME] - frameTime));
            x = x + (frames[frame + $a99189e38c28e5fb$export$4da82436a1a0d773.X] - x) * percent;
            y = y + (frames[frame + $a99189e38c28e5fb$export$4da82436a1a0d773.Y] - y) * percent;
        }
        switch(blend){
            case (0, $bbcccedbc883e405$export$ccab779a50275a35).setup:
                bone.shearX = bone.data.shearX + x * alpha;
                bone.shearY = bone.data.shearY + y * alpha;
                break;
            case (0, $bbcccedbc883e405$export$ccab779a50275a35).first:
            case (0, $bbcccedbc883e405$export$ccab779a50275a35).replace:
                bone.shearX += (bone.data.shearX + x - bone.shearX) * alpha;
                bone.shearY += (bone.data.shearY + y - bone.shearY) * alpha;
                break;
            case (0, $bbcccedbc883e405$export$ccab779a50275a35).add:
                bone.shearX += x * alpha;
                bone.shearY += y * alpha;
        }
    }
}
const $a99189e38c28e5fb$var$_ColorTimeline = class extends $a99189e38c28e5fb$export$4094e7414845f78f {
    // time, r, g, b, a, ...
    constructor(frameCount){
        super(frameCount);
        this.frames = (0, $8804784813ffae81$export$d2ca453b913dcdea).newFloatArray(frameCount * $a99189e38c28e5fb$var$_ColorTimeline.ENTRIES);
    }
    getPropertyId() {
        return 83886080 + this.slotIndex;
    }
    /** Sets the time in seconds, red, green, blue, and alpha for the specified key frame. */ setFrame(frameIndex, time, r, g, b, a) {
        frameIndex *= $a99189e38c28e5fb$var$_ColorTimeline.ENTRIES;
        this.frames[frameIndex] = time;
        this.frames[frameIndex + $a99189e38c28e5fb$var$_ColorTimeline.R] = r;
        this.frames[frameIndex + $a99189e38c28e5fb$var$_ColorTimeline.G] = g;
        this.frames[frameIndex + $a99189e38c28e5fb$var$_ColorTimeline.B] = b;
        this.frames[frameIndex + $a99189e38c28e5fb$var$_ColorTimeline.A] = a;
    }
    apply(skeleton, lastTime, time, events, alpha, blend, direction) {
        const slot = skeleton.slots[this.slotIndex];
        if (!slot.bone.active) return;
        const frames = this.frames;
        if (time < frames[0]) {
            switch(blend){
                case (0, $bbcccedbc883e405$export$ccab779a50275a35).setup:
                    slot.color.setFromColor(slot.data.color);
                    return;
                case (0, $bbcccedbc883e405$export$ccab779a50275a35).first:
                    const color = slot.color;
                    const setup = slot.data.color;
                    color.add((setup.r - color.r) * alpha, (setup.g - color.g) * alpha, (setup.b - color.b) * alpha, (setup.a - color.a) * alpha);
            }
            return;
        }
        let r = 0;
        let g = 0;
        let b = 0;
        let a = 0;
        if (time >= frames[frames.length - $a99189e38c28e5fb$var$_ColorTimeline.ENTRIES]) {
            const i = frames.length;
            r = frames[i + $a99189e38c28e5fb$var$_ColorTimeline.PREV_R];
            g = frames[i + $a99189e38c28e5fb$var$_ColorTimeline.PREV_G];
            b = frames[i + $a99189e38c28e5fb$var$_ColorTimeline.PREV_B];
            a = frames[i + $a99189e38c28e5fb$var$_ColorTimeline.PREV_A];
        } else {
            const frame = $a99189e38c28e5fb$export$c35d437ae5945fcd.binarySearch(frames, time, $a99189e38c28e5fb$var$_ColorTimeline.ENTRIES);
            r = frames[frame + $a99189e38c28e5fb$var$_ColorTimeline.PREV_R];
            g = frames[frame + $a99189e38c28e5fb$var$_ColorTimeline.PREV_G];
            b = frames[frame + $a99189e38c28e5fb$var$_ColorTimeline.PREV_B];
            a = frames[frame + $a99189e38c28e5fb$var$_ColorTimeline.PREV_A];
            const frameTime = frames[frame];
            const percent = this.getCurvePercent(frame / $a99189e38c28e5fb$var$_ColorTimeline.ENTRIES - 1, 1 - (time - frameTime) / (frames[frame + $a99189e38c28e5fb$var$_ColorTimeline.PREV_TIME] - frameTime));
            r += (frames[frame + $a99189e38c28e5fb$var$_ColorTimeline.R] - r) * percent;
            g += (frames[frame + $a99189e38c28e5fb$var$_ColorTimeline.G] - g) * percent;
            b += (frames[frame + $a99189e38c28e5fb$var$_ColorTimeline.B] - b) * percent;
            a += (frames[frame + $a99189e38c28e5fb$var$_ColorTimeline.A] - a) * percent;
        }
        if (alpha == 1) slot.color.set(r, g, b, a);
        else {
            const color = slot.color;
            if (blend == (0, $bbcccedbc883e405$export$ccab779a50275a35).setup) color.setFromColor(slot.data.color);
            color.add((r - color.r) * alpha, (g - color.g) * alpha, (b - color.b) * alpha, (a - color.a) * alpha);
        }
    }
};
let $a99189e38c28e5fb$export$565fcb3610070d7f = $a99189e38c28e5fb$var$_ColorTimeline;
$a99189e38c28e5fb$export$565fcb3610070d7f.ENTRIES = 5;
$a99189e38c28e5fb$export$565fcb3610070d7f.PREV_TIME = -5;
$a99189e38c28e5fb$export$565fcb3610070d7f.PREV_R = -4;
$a99189e38c28e5fb$export$565fcb3610070d7f.PREV_G = -3;
$a99189e38c28e5fb$export$565fcb3610070d7f.PREV_B = -2;
$a99189e38c28e5fb$export$565fcb3610070d7f.PREV_A = -1;
$a99189e38c28e5fb$export$565fcb3610070d7f.R = 1;
$a99189e38c28e5fb$export$565fcb3610070d7f.G = 2;
$a99189e38c28e5fb$export$565fcb3610070d7f.B = 3;
$a99189e38c28e5fb$export$565fcb3610070d7f.A = 4;
const $a99189e38c28e5fb$var$_TwoColorTimeline = class extends $a99189e38c28e5fb$export$4094e7414845f78f {
    // time, r, g, b, a, r2, g2, b2, ...
    constructor(frameCount){
        super(frameCount);
        this.frames = (0, $8804784813ffae81$export$d2ca453b913dcdea).newFloatArray(frameCount * $a99189e38c28e5fb$var$_TwoColorTimeline.ENTRIES);
    }
    getPropertyId() {
        return 234881024 + this.slotIndex;
    }
    /** Sets the time in seconds, light, and dark colors for the specified key frame. */ setFrame(frameIndex, time, r, g, b, a, r2, g2, b2) {
        frameIndex *= $a99189e38c28e5fb$var$_TwoColorTimeline.ENTRIES;
        this.frames[frameIndex] = time;
        this.frames[frameIndex + $a99189e38c28e5fb$var$_TwoColorTimeline.R] = r;
        this.frames[frameIndex + $a99189e38c28e5fb$var$_TwoColorTimeline.G] = g;
        this.frames[frameIndex + $a99189e38c28e5fb$var$_TwoColorTimeline.B] = b;
        this.frames[frameIndex + $a99189e38c28e5fb$var$_TwoColorTimeline.A] = a;
        this.frames[frameIndex + $a99189e38c28e5fb$var$_TwoColorTimeline.R2] = r2;
        this.frames[frameIndex + $a99189e38c28e5fb$var$_TwoColorTimeline.G2] = g2;
        this.frames[frameIndex + $a99189e38c28e5fb$var$_TwoColorTimeline.B2] = b2;
    }
    apply(skeleton, lastTime, time, events, alpha, blend, direction) {
        const slot = skeleton.slots[this.slotIndex];
        if (!slot.bone.active) return;
        const frames = this.frames;
        if (time < frames[0]) {
            switch(blend){
                case (0, $bbcccedbc883e405$export$ccab779a50275a35).setup:
                    slot.color.setFromColor(slot.data.color);
                    slot.darkColor.setFromColor(slot.data.darkColor);
                    return;
                case (0, $bbcccedbc883e405$export$ccab779a50275a35).first:
                    const light = slot.color;
                    const dark = slot.darkColor;
                    const setupLight = slot.data.color;
                    const setupDark = slot.data.darkColor;
                    light.add((setupLight.r - light.r) * alpha, (setupLight.g - light.g) * alpha, (setupLight.b - light.b) * alpha, (setupLight.a - light.a) * alpha);
                    dark.add((setupDark.r - dark.r) * alpha, (setupDark.g - dark.g) * alpha, (setupDark.b - dark.b) * alpha, 0);
            }
            return;
        }
        let r = 0;
        let g = 0;
        let b = 0;
        let a = 0;
        let r2 = 0;
        let g2 = 0;
        let b2 = 0;
        if (time >= frames[frames.length - $a99189e38c28e5fb$var$_TwoColorTimeline.ENTRIES]) {
            const i = frames.length;
            r = frames[i + $a99189e38c28e5fb$var$_TwoColorTimeline.PREV_R];
            g = frames[i + $a99189e38c28e5fb$var$_TwoColorTimeline.PREV_G];
            b = frames[i + $a99189e38c28e5fb$var$_TwoColorTimeline.PREV_B];
            a = frames[i + $a99189e38c28e5fb$var$_TwoColorTimeline.PREV_A];
            r2 = frames[i + $a99189e38c28e5fb$var$_TwoColorTimeline.PREV_R2];
            g2 = frames[i + $a99189e38c28e5fb$var$_TwoColorTimeline.PREV_G2];
            b2 = frames[i + $a99189e38c28e5fb$var$_TwoColorTimeline.PREV_B2];
        } else {
            const frame = $a99189e38c28e5fb$export$c35d437ae5945fcd.binarySearch(frames, time, $a99189e38c28e5fb$var$_TwoColorTimeline.ENTRIES);
            r = frames[frame + $a99189e38c28e5fb$var$_TwoColorTimeline.PREV_R];
            g = frames[frame + $a99189e38c28e5fb$var$_TwoColorTimeline.PREV_G];
            b = frames[frame + $a99189e38c28e5fb$var$_TwoColorTimeline.PREV_B];
            a = frames[frame + $a99189e38c28e5fb$var$_TwoColorTimeline.PREV_A];
            r2 = frames[frame + $a99189e38c28e5fb$var$_TwoColorTimeline.PREV_R2];
            g2 = frames[frame + $a99189e38c28e5fb$var$_TwoColorTimeline.PREV_G2];
            b2 = frames[frame + $a99189e38c28e5fb$var$_TwoColorTimeline.PREV_B2];
            const frameTime = frames[frame];
            const percent = this.getCurvePercent(frame / $a99189e38c28e5fb$var$_TwoColorTimeline.ENTRIES - 1, 1 - (time - frameTime) / (frames[frame + $a99189e38c28e5fb$var$_TwoColorTimeline.PREV_TIME] - frameTime));
            r += (frames[frame + $a99189e38c28e5fb$var$_TwoColorTimeline.R] - r) * percent;
            g += (frames[frame + $a99189e38c28e5fb$var$_TwoColorTimeline.G] - g) * percent;
            b += (frames[frame + $a99189e38c28e5fb$var$_TwoColorTimeline.B] - b) * percent;
            a += (frames[frame + $a99189e38c28e5fb$var$_TwoColorTimeline.A] - a) * percent;
            r2 += (frames[frame + $a99189e38c28e5fb$var$_TwoColorTimeline.R2] - r2) * percent;
            g2 += (frames[frame + $a99189e38c28e5fb$var$_TwoColorTimeline.G2] - g2) * percent;
            b2 += (frames[frame + $a99189e38c28e5fb$var$_TwoColorTimeline.B2] - b2) * percent;
        }
        if (alpha == 1) {
            slot.color.set(r, g, b, a);
            slot.darkColor.set(r2, g2, b2, 1);
        } else {
            const light = slot.color;
            const dark = slot.darkColor;
            if (blend == (0, $bbcccedbc883e405$export$ccab779a50275a35).setup) {
                light.setFromColor(slot.data.color);
                dark.setFromColor(slot.data.darkColor);
            }
            light.add((r - light.r) * alpha, (g - light.g) * alpha, (b - light.b) * alpha, (a - light.a) * alpha);
            dark.add((r2 - dark.r) * alpha, (g2 - dark.g) * alpha, (b2 - dark.b) * alpha, 0);
        }
    }
};
let $a99189e38c28e5fb$export$938c1752e1b56539 = $a99189e38c28e5fb$var$_TwoColorTimeline;
$a99189e38c28e5fb$export$938c1752e1b56539.ENTRIES = 8;
$a99189e38c28e5fb$export$938c1752e1b56539.PREV_TIME = -8;
$a99189e38c28e5fb$export$938c1752e1b56539.PREV_R = -7;
$a99189e38c28e5fb$export$938c1752e1b56539.PREV_G = -6;
$a99189e38c28e5fb$export$938c1752e1b56539.PREV_B = -5;
$a99189e38c28e5fb$export$938c1752e1b56539.PREV_A = -4;
$a99189e38c28e5fb$export$938c1752e1b56539.PREV_R2 = -3;
$a99189e38c28e5fb$export$938c1752e1b56539.PREV_G2 = -2;
$a99189e38c28e5fb$export$938c1752e1b56539.PREV_B2 = -1;
$a99189e38c28e5fb$export$938c1752e1b56539.R = 1;
$a99189e38c28e5fb$export$938c1752e1b56539.G = 2;
$a99189e38c28e5fb$export$938c1752e1b56539.B = 3;
$a99189e38c28e5fb$export$938c1752e1b56539.A = 4;
$a99189e38c28e5fb$export$938c1752e1b56539.R2 = 5;
$a99189e38c28e5fb$export$938c1752e1b56539.G2 = 6;
$a99189e38c28e5fb$export$938c1752e1b56539.B2 = 7;
class $a99189e38c28e5fb$export$7f2bfc5bd27cb43d {
    constructor(frameCount){
        this.frames = (0, $8804784813ffae81$export$d2ca453b913dcdea).newFloatArray(frameCount);
        this.attachmentNames = new Array(frameCount);
    }
    getPropertyId() {
        return 67108864 + this.slotIndex;
    }
    /** The number of key frames for this timeline. */ getFrameCount() {
        return this.frames.length;
    }
    /** Sets the time in seconds and the attachment name for the specified key frame. */ setFrame(frameIndex, time, attachmentName) {
        this.frames[frameIndex] = time;
        this.attachmentNames[frameIndex] = attachmentName;
    }
    apply(skeleton, lastTime, time, events, alpha, blend, direction) {
        const slot = skeleton.slots[this.slotIndex];
        if (!slot.bone.active) return;
        if (direction == (0, $bbcccedbc883e405$export$52fc338c0bb328ba).mixOut) {
            if (blend == (0, $bbcccedbc883e405$export$ccab779a50275a35).setup) this.setAttachment(skeleton, slot, slot.data.attachmentName);
            return;
        }
        const frames = this.frames;
        if (time < frames[0]) {
            if (blend == (0, $bbcccedbc883e405$export$ccab779a50275a35).setup || blend == (0, $bbcccedbc883e405$export$ccab779a50275a35).first) this.setAttachment(skeleton, slot, slot.data.attachmentName);
            return;
        }
        let frameIndex = 0;
        if (time >= frames[frames.length - 1]) frameIndex = frames.length - 1;
        else frameIndex = $a99189e38c28e5fb$export$c35d437ae5945fcd.binarySearch(frames, time, 1) - 1;
        const attachmentName = this.attachmentNames[frameIndex];
        skeleton.slots[this.slotIndex].setAttachment(attachmentName == null ? null : skeleton.getAttachment(this.slotIndex, attachmentName));
    }
    setAttachment(skeleton, slot, attachmentName) {
        slot.setAttachment(attachmentName == null ? null : skeleton.getAttachment(this.slotIndex, attachmentName));
    }
}
let $a99189e38c28e5fb$var$zeros = null;
class $a99189e38c28e5fb$export$6968d40e5689ad6b extends $a99189e38c28e5fb$export$4094e7414845f78f {
    constructor(frameCount){
        super(frameCount);
        this.frames = (0, $8804784813ffae81$export$d2ca453b913dcdea).newFloatArray(frameCount);
        this.frameVertices = new Array(frameCount);
        if ($a99189e38c28e5fb$var$zeros == null) $a99189e38c28e5fb$var$zeros = (0, $8804784813ffae81$export$d2ca453b913dcdea).newFloatArray(64);
    }
    getPropertyId() {
        return 805306368 + Number(this.attachment.id) + this.slotIndex;
    }
    /** Sets the time in seconds and the vertices for the specified key frame.
   * @param vertices Vertex positions for an unweighted VertexAttachment, or deform offsets if it has weights. */ setFrame(frameIndex, time, vertices) {
        this.frames[frameIndex] = time;
        this.frameVertices[frameIndex] = vertices;
    }
    apply(skeleton, lastTime, time, firedEvents, alpha, blend, direction) {
        const slot = skeleton.slots[this.slotIndex];
        if (!slot.bone.active) return;
        const slotAttachment = slot.getAttachment();
        if (!(slotAttachment instanceof (0, $0081823d79d97c28$export$66d3a0c3be55e044)) || !(slotAttachment.deformAttachment == this.attachment)) return;
        const deformArray = slot.deform;
        if (deformArray.length == 0) blend = (0, $bbcccedbc883e405$export$ccab779a50275a35).setup;
        const frameVertices = this.frameVertices;
        const vertexCount = frameVertices[0].length;
        const frames = this.frames;
        if (time < frames[0]) {
            const vertexAttachment = slotAttachment;
            switch(blend){
                case (0, $bbcccedbc883e405$export$ccab779a50275a35).setup:
                    deformArray.length = 0;
                    return;
                case (0, $bbcccedbc883e405$export$ccab779a50275a35).first:
                    if (alpha == 1) {
                        deformArray.length = 0;
                        break;
                    }
                    const deform2 = (0, $8804784813ffae81$export$d2ca453b913dcdea).setArraySize(deformArray, vertexCount);
                    if (vertexAttachment.bones == null) {
                        const setupVertices = vertexAttachment.vertices;
                        for(let i = 0; i < vertexCount; i++)deform2[i] += (setupVertices[i] - deform2[i]) * alpha;
                    } else {
                        alpha = 1 - alpha;
                        for(let i = 0; i < vertexCount; i++)deform2[i] *= alpha;
                    }
            }
            return;
        }
        const deform = (0, $8804784813ffae81$export$d2ca453b913dcdea).setArraySize(deformArray, vertexCount);
        if (time >= frames[frames.length - 1]) {
            const lastVertices = frameVertices[frames.length - 1];
            if (alpha == 1) {
                if (blend == (0, $bbcccedbc883e405$export$ccab779a50275a35).add) {
                    const vertexAttachment = slotAttachment;
                    if (vertexAttachment.bones == null) {
                        const setupVertices = vertexAttachment.vertices;
                        for(let i = 0; i < vertexCount; i++)deform[i] += lastVertices[i] - setupVertices[i];
                    } else for(let i = 0; i < vertexCount; i++)deform[i] += lastVertices[i];
                } else (0, $8804784813ffae81$export$d2ca453b913dcdea).arrayCopy(lastVertices, 0, deform, 0, vertexCount);
            } else switch(blend){
                case (0, $bbcccedbc883e405$export$ccab779a50275a35).setup:
                    {
                        const vertexAttachment2 = slotAttachment;
                        if (vertexAttachment2.bones == null) {
                            const setupVertices = vertexAttachment2.vertices;
                            for(let i = 0; i < vertexCount; i++){
                                const setup = setupVertices[i];
                                deform[i] = setup + (lastVertices[i] - setup) * alpha;
                            }
                        } else for(let i = 0; i < vertexCount; i++)deform[i] = lastVertices[i] * alpha;
                        break;
                    }
                case (0, $bbcccedbc883e405$export$ccab779a50275a35).first:
                case (0, $bbcccedbc883e405$export$ccab779a50275a35).replace:
                    for(let i = 0; i < vertexCount; i++)deform[i] += (lastVertices[i] - deform[i]) * alpha;
                    break;
                case (0, $bbcccedbc883e405$export$ccab779a50275a35).add:
                    const vertexAttachment = slotAttachment;
                    if (vertexAttachment.bones == null) {
                        const setupVertices = vertexAttachment.vertices;
                        for(let i = 0; i < vertexCount; i++)deform[i] += (lastVertices[i] - setupVertices[i]) * alpha;
                    } else for(let i = 0; i < vertexCount; i++)deform[i] += lastVertices[i] * alpha;
            }
            return;
        }
        const frame = $a99189e38c28e5fb$export$c35d437ae5945fcd.binarySearch(frames, time);
        const prevVertices = frameVertices[frame - 1];
        const nextVertices = frameVertices[frame];
        const frameTime = frames[frame];
        const percent = this.getCurvePercent(frame - 1, 1 - (time - frameTime) / (frames[frame - 1] - frameTime));
        if (alpha == 1) {
            if (blend == (0, $bbcccedbc883e405$export$ccab779a50275a35).add) {
                const vertexAttachment = slotAttachment;
                if (vertexAttachment.bones == null) {
                    const setupVertices = vertexAttachment.vertices;
                    for(let i = 0; i < vertexCount; i++){
                        const prev = prevVertices[i];
                        deform[i] += prev + (nextVertices[i] - prev) * percent - setupVertices[i];
                    }
                } else for(let i = 0; i < vertexCount; i++){
                    const prev = prevVertices[i];
                    deform[i] += prev + (nextVertices[i] - prev) * percent;
                }
            } else for(let i = 0; i < vertexCount; i++){
                const prev = prevVertices[i];
                deform[i] = prev + (nextVertices[i] - prev) * percent;
            }
        } else switch(blend){
            case (0, $bbcccedbc883e405$export$ccab779a50275a35).setup:
                {
                    const vertexAttachment2 = slotAttachment;
                    if (vertexAttachment2.bones == null) {
                        const setupVertices = vertexAttachment2.vertices;
                        for(let i = 0; i < vertexCount; i++){
                            const prev = prevVertices[i];
                            const setup = setupVertices[i];
                            deform[i] = setup + (prev + (nextVertices[i] - prev) * percent - setup) * alpha;
                        }
                    } else for(let i = 0; i < vertexCount; i++){
                        const prev = prevVertices[i];
                        deform[i] = (prev + (nextVertices[i] - prev) * percent) * alpha;
                    }
                    break;
                }
            case (0, $bbcccedbc883e405$export$ccab779a50275a35).first:
            case (0, $bbcccedbc883e405$export$ccab779a50275a35).replace:
                for(let i = 0; i < vertexCount; i++){
                    const prev = prevVertices[i];
                    deform[i] += (prev + (nextVertices[i] - prev) * percent - deform[i]) * alpha;
                }
                break;
            case (0, $bbcccedbc883e405$export$ccab779a50275a35).add:
                const vertexAttachment = slotAttachment;
                if (vertexAttachment.bones == null) {
                    const setupVertices = vertexAttachment.vertices;
                    for(let i = 0; i < vertexCount; i++){
                        const prev = prevVertices[i];
                        deform[i] += (prev + (nextVertices[i] - prev) * percent - setupVertices[i]) * alpha;
                    }
                } else for(let i = 0; i < vertexCount; i++){
                    const prev = prevVertices[i];
                    deform[i] += (prev + (nextVertices[i] - prev) * percent) * alpha;
                }
        }
    }
}
class $a99189e38c28e5fb$export$4f4bca996c586084 {
    constructor(frameCount){
        this.frames = (0, $8804784813ffae81$export$d2ca453b913dcdea).newFloatArray(frameCount);
        this.events = new Array(frameCount);
    }
    getPropertyId() {
        return 117440512;
    }
    /** The number of key frames for this timeline. */ getFrameCount() {
        return this.frames.length;
    }
    /** Sets the time in seconds and the event for the specified key frame. */ setFrame(frameIndex, event) {
        this.frames[frameIndex] = event.time;
        this.events[frameIndex] = event;
    }
    /** Fires events for frames > `lastTime` and <= `time`. */ apply(skeleton, lastTime, time, firedEvents, alpha, blend, direction) {
        if (firedEvents == null) return;
        const frames = this.frames;
        const frameCount = this.frames.length;
        if (lastTime > time) {
            this.apply(skeleton, lastTime, Number.MAX_VALUE, firedEvents, alpha, blend, direction);
            lastTime = -1;
        } else if (lastTime >= frames[frameCount - 1]) return;
        if (time < frames[0]) return;
        let frame = 0;
        if (lastTime < frames[0]) frame = 0;
        else {
            frame = $a99189e38c28e5fb$export$c35d437ae5945fcd.binarySearch(frames, lastTime);
            const frameTime = frames[frame];
            while(frame > 0){
                if (frames[frame - 1] != frameTime) break;
                frame--;
            }
        }
        for(; frame < frameCount && time >= frames[frame]; frame++)firedEvents.push(this.events[frame]);
    }
}
class $a99189e38c28e5fb$export$ece1f7c41d051e83 {
    constructor(frameCount){
        this.frames = (0, $8804784813ffae81$export$d2ca453b913dcdea).newFloatArray(frameCount);
        this.drawOrders = new Array(frameCount);
    }
    getPropertyId() {
        return 134217728;
    }
    /** The number of key frames for this timeline. */ getFrameCount() {
        return this.frames.length;
    }
    /** Sets the time in seconds and the draw order for the specified key frame.
   * @param drawOrder For each slot in {@link Skeleton#slots}, the index of the new draw order. May be null to use setup pose
   *           draw order. */ setFrame(frameIndex, time, drawOrder) {
        this.frames[frameIndex] = time;
        this.drawOrders[frameIndex] = drawOrder;
    }
    apply(skeleton, lastTime, time, firedEvents, alpha, blend, direction) {
        const drawOrder = skeleton.drawOrder;
        const slots = skeleton.slots;
        if (direction == (0, $bbcccedbc883e405$export$52fc338c0bb328ba).mixOut && blend == (0, $bbcccedbc883e405$export$ccab779a50275a35).setup) {
            (0, $8804784813ffae81$export$d2ca453b913dcdea).arrayCopy(skeleton.slots, 0, skeleton.drawOrder, 0, skeleton.slots.length);
            return;
        }
        const frames = this.frames;
        if (time < frames[0]) {
            if (blend == (0, $bbcccedbc883e405$export$ccab779a50275a35).setup || blend == (0, $bbcccedbc883e405$export$ccab779a50275a35).first) (0, $8804784813ffae81$export$d2ca453b913dcdea).arrayCopy(skeleton.slots, 0, skeleton.drawOrder, 0, skeleton.slots.length);
            return;
        }
        let frame = 0;
        if (time >= frames[frames.length - 1]) frame = frames.length - 1;
        else frame = $a99189e38c28e5fb$export$c35d437ae5945fcd.binarySearch(frames, time) - 1;
        const drawOrderToSetupIndex = this.drawOrders[frame];
        if (drawOrderToSetupIndex == null) (0, $8804784813ffae81$export$d2ca453b913dcdea).arrayCopy(slots, 0, drawOrder, 0, slots.length);
        else for(let i = 0, n = drawOrderToSetupIndex.length; i < n; i++)drawOrder[i] = slots[drawOrderToSetupIndex[i]];
    }
}
const $a99189e38c28e5fb$var$_IkConstraintTimeline = class extends $a99189e38c28e5fb$export$4094e7414845f78f {
    // time, mix, softness, bendDirection, compress, stretch, ...
    constructor(frameCount){
        super(frameCount);
        this.frames = (0, $8804784813ffae81$export$d2ca453b913dcdea).newFloatArray(frameCount * $a99189e38c28e5fb$var$_IkConstraintTimeline.ENTRIES);
    }
    getPropertyId() {
        return 150994944 + this.ikConstraintIndex;
    }
    /** Sets the time in seconds, mix, softness, bend direction, compress, and stretch for the specified key frame. */ setFrame(frameIndex, time, mix, softness, bendDirection, compress, stretch) {
        frameIndex *= $a99189e38c28e5fb$var$_IkConstraintTimeline.ENTRIES;
        this.frames[frameIndex] = time;
        this.frames[frameIndex + $a99189e38c28e5fb$var$_IkConstraintTimeline.MIX] = mix;
        this.frames[frameIndex + $a99189e38c28e5fb$var$_IkConstraintTimeline.SOFTNESS] = softness;
        this.frames[frameIndex + $a99189e38c28e5fb$var$_IkConstraintTimeline.BEND_DIRECTION] = bendDirection;
        this.frames[frameIndex + $a99189e38c28e5fb$var$_IkConstraintTimeline.COMPRESS] = compress ? 1 : 0;
        this.frames[frameIndex + $a99189e38c28e5fb$var$_IkConstraintTimeline.STRETCH] = stretch ? 1 : 0;
    }
    apply(skeleton, lastTime, time, firedEvents, alpha, blend, direction) {
        const frames = this.frames;
        const constraint = skeleton.ikConstraints[this.ikConstraintIndex];
        if (!constraint.active) return;
        if (time < frames[0]) {
            switch(blend){
                case (0, $bbcccedbc883e405$export$ccab779a50275a35).setup:
                    constraint.mix = constraint.data.mix;
                    constraint.softness = constraint.data.softness;
                    constraint.bendDirection = constraint.data.bendDirection;
                    constraint.compress = constraint.data.compress;
                    constraint.stretch = constraint.data.stretch;
                    return;
                case (0, $bbcccedbc883e405$export$ccab779a50275a35).first:
                    constraint.mix += (constraint.data.mix - constraint.mix) * alpha;
                    constraint.softness += (constraint.data.softness - constraint.softness) * alpha;
                    constraint.bendDirection = constraint.data.bendDirection;
                    constraint.compress = constraint.data.compress;
                    constraint.stretch = constraint.data.stretch;
            }
            return;
        }
        if (time >= frames[frames.length - $a99189e38c28e5fb$var$_IkConstraintTimeline.ENTRIES]) {
            if (blend == (0, $bbcccedbc883e405$export$ccab779a50275a35).setup) {
                constraint.mix = constraint.data.mix + (frames[frames.length + $a99189e38c28e5fb$var$_IkConstraintTimeline.PREV_MIX] - constraint.data.mix) * alpha;
                constraint.softness = constraint.data.softness + (frames[frames.length + $a99189e38c28e5fb$var$_IkConstraintTimeline.PREV_SOFTNESS] - constraint.data.softness) * alpha;
                if (direction == (0, $bbcccedbc883e405$export$52fc338c0bb328ba).mixOut) {
                    constraint.bendDirection = constraint.data.bendDirection;
                    constraint.compress = constraint.data.compress;
                    constraint.stretch = constraint.data.stretch;
                } else {
                    constraint.bendDirection = frames[frames.length + $a99189e38c28e5fb$var$_IkConstraintTimeline.PREV_BEND_DIRECTION];
                    constraint.compress = frames[frames.length + $a99189e38c28e5fb$var$_IkConstraintTimeline.PREV_COMPRESS] != 0;
                    constraint.stretch = frames[frames.length + $a99189e38c28e5fb$var$_IkConstraintTimeline.PREV_STRETCH] != 0;
                }
            } else {
                constraint.mix += (frames[frames.length + $a99189e38c28e5fb$var$_IkConstraintTimeline.PREV_MIX] - constraint.mix) * alpha;
                constraint.softness += (frames[frames.length + $a99189e38c28e5fb$var$_IkConstraintTimeline.PREV_SOFTNESS] - constraint.softness) * alpha;
                if (direction == (0, $bbcccedbc883e405$export$52fc338c0bb328ba).mixIn) {
                    constraint.bendDirection = frames[frames.length + $a99189e38c28e5fb$var$_IkConstraintTimeline.PREV_BEND_DIRECTION];
                    constraint.compress = frames[frames.length + $a99189e38c28e5fb$var$_IkConstraintTimeline.PREV_COMPRESS] != 0;
                    constraint.stretch = frames[frames.length + $a99189e38c28e5fb$var$_IkConstraintTimeline.PREV_STRETCH] != 0;
                }
            }
            return;
        }
        const frame = $a99189e38c28e5fb$export$c35d437ae5945fcd.binarySearch(frames, time, $a99189e38c28e5fb$var$_IkConstraintTimeline.ENTRIES);
        const mix = frames[frame + $a99189e38c28e5fb$var$_IkConstraintTimeline.PREV_MIX];
        const softness = frames[frame + $a99189e38c28e5fb$var$_IkConstraintTimeline.PREV_SOFTNESS];
        const frameTime = frames[frame];
        const percent = this.getCurvePercent(frame / $a99189e38c28e5fb$var$_IkConstraintTimeline.ENTRIES - 1, 1 - (time - frameTime) / (frames[frame + $a99189e38c28e5fb$var$_IkConstraintTimeline.PREV_TIME] - frameTime));
        if (blend == (0, $bbcccedbc883e405$export$ccab779a50275a35).setup) {
            constraint.mix = constraint.data.mix + (mix + (frames[frame + $a99189e38c28e5fb$var$_IkConstraintTimeline.MIX] - mix) * percent - constraint.data.mix) * alpha;
            constraint.softness = constraint.data.softness + (softness + (frames[frame + $a99189e38c28e5fb$var$_IkConstraintTimeline.SOFTNESS] - softness) * percent - constraint.data.softness) * alpha;
            if (direction == (0, $bbcccedbc883e405$export$52fc338c0bb328ba).mixOut) {
                constraint.bendDirection = constraint.data.bendDirection;
                constraint.compress = constraint.data.compress;
                constraint.stretch = constraint.data.stretch;
            } else {
                constraint.bendDirection = frames[frame + $a99189e38c28e5fb$var$_IkConstraintTimeline.PREV_BEND_DIRECTION];
                constraint.compress = frames[frame + $a99189e38c28e5fb$var$_IkConstraintTimeline.PREV_COMPRESS] != 0;
                constraint.stretch = frames[frame + $a99189e38c28e5fb$var$_IkConstraintTimeline.PREV_STRETCH] != 0;
            }
        } else {
            constraint.mix += (mix + (frames[frame + $a99189e38c28e5fb$var$_IkConstraintTimeline.MIX] - mix) * percent - constraint.mix) * alpha;
            constraint.softness += (softness + (frames[frame + $a99189e38c28e5fb$var$_IkConstraintTimeline.SOFTNESS] - softness) * percent - constraint.softness) * alpha;
            if (direction == (0, $bbcccedbc883e405$export$52fc338c0bb328ba).mixIn) {
                constraint.bendDirection = frames[frame + $a99189e38c28e5fb$var$_IkConstraintTimeline.PREV_BEND_DIRECTION];
                constraint.compress = frames[frame + $a99189e38c28e5fb$var$_IkConstraintTimeline.PREV_COMPRESS] != 0;
                constraint.stretch = frames[frame + $a99189e38c28e5fb$var$_IkConstraintTimeline.PREV_STRETCH] != 0;
            }
        }
    }
};
let $a99189e38c28e5fb$export$73d125cd89dead44 = $a99189e38c28e5fb$var$_IkConstraintTimeline;
$a99189e38c28e5fb$export$73d125cd89dead44.ENTRIES = 6;
$a99189e38c28e5fb$export$73d125cd89dead44.PREV_TIME = -6;
$a99189e38c28e5fb$export$73d125cd89dead44.PREV_MIX = -5;
$a99189e38c28e5fb$export$73d125cd89dead44.PREV_SOFTNESS = -4;
$a99189e38c28e5fb$export$73d125cd89dead44.PREV_BEND_DIRECTION = -3;
$a99189e38c28e5fb$export$73d125cd89dead44.PREV_COMPRESS = -2;
$a99189e38c28e5fb$export$73d125cd89dead44.PREV_STRETCH = -1;
$a99189e38c28e5fb$export$73d125cd89dead44.MIX = 1;
$a99189e38c28e5fb$export$73d125cd89dead44.SOFTNESS = 2;
$a99189e38c28e5fb$export$73d125cd89dead44.BEND_DIRECTION = 3;
$a99189e38c28e5fb$export$73d125cd89dead44.COMPRESS = 4;
$a99189e38c28e5fb$export$73d125cd89dead44.STRETCH = 5;
const $a99189e38c28e5fb$var$_TransformConstraintTimeline = class extends $a99189e38c28e5fb$export$4094e7414845f78f {
    // time, rotate mix, translate mix, scale mix, shear mix, ...
    constructor(frameCount){
        super(frameCount);
        this.frames = (0, $8804784813ffae81$export$d2ca453b913dcdea).newFloatArray(frameCount * $a99189e38c28e5fb$var$_TransformConstraintTimeline.ENTRIES);
    }
    getPropertyId() {
        return 167772160 + this.transformConstraintIndex;
    }
    /** The time in seconds, rotate mix, translate mix, scale mix, and shear mix for the specified key frame. */ setFrame(frameIndex, time, rotateMix, translateMix, scaleMix, shearMix) {
        frameIndex *= $a99189e38c28e5fb$var$_TransformConstraintTimeline.ENTRIES;
        this.frames[frameIndex] = time;
        this.frames[frameIndex + $a99189e38c28e5fb$var$_TransformConstraintTimeline.ROTATE] = rotateMix;
        this.frames[frameIndex + $a99189e38c28e5fb$var$_TransformConstraintTimeline.TRANSLATE] = translateMix;
        this.frames[frameIndex + $a99189e38c28e5fb$var$_TransformConstraintTimeline.SCALE] = scaleMix;
        this.frames[frameIndex + $a99189e38c28e5fb$var$_TransformConstraintTimeline.SHEAR] = shearMix;
    }
    apply(skeleton, lastTime, time, firedEvents, alpha, blend, direction) {
        const frames = this.frames;
        const constraint = skeleton.transformConstraints[this.transformConstraintIndex];
        if (!constraint.active) return;
        if (time < frames[0]) {
            const data = constraint.data;
            switch(blend){
                case (0, $bbcccedbc883e405$export$ccab779a50275a35).setup:
                    constraint.rotateMix = data.rotateMix;
                    constraint.translateMix = data.translateMix;
                    constraint.scaleMix = data.scaleMix;
                    constraint.shearMix = data.shearMix;
                    return;
                case (0, $bbcccedbc883e405$export$ccab779a50275a35).first:
                    constraint.rotateMix += (data.rotateMix - constraint.rotateMix) * alpha;
                    constraint.translateMix += (data.translateMix - constraint.translateMix) * alpha;
                    constraint.scaleMix += (data.scaleMix - constraint.scaleMix) * alpha;
                    constraint.shearMix += (data.shearMix - constraint.shearMix) * alpha;
            }
            return;
        }
        let rotate = 0;
        let translate = 0;
        let scale = 0;
        let shear = 0;
        if (time >= frames[frames.length - $a99189e38c28e5fb$var$_TransformConstraintTimeline.ENTRIES]) {
            const i = frames.length;
            rotate = frames[i + $a99189e38c28e5fb$var$_TransformConstraintTimeline.PREV_ROTATE];
            translate = frames[i + $a99189e38c28e5fb$var$_TransformConstraintTimeline.PREV_TRANSLATE];
            scale = frames[i + $a99189e38c28e5fb$var$_TransformConstraintTimeline.PREV_SCALE];
            shear = frames[i + $a99189e38c28e5fb$var$_TransformConstraintTimeline.PREV_SHEAR];
        } else {
            const frame = $a99189e38c28e5fb$export$c35d437ae5945fcd.binarySearch(frames, time, $a99189e38c28e5fb$var$_TransformConstraintTimeline.ENTRIES);
            rotate = frames[frame + $a99189e38c28e5fb$var$_TransformConstraintTimeline.PREV_ROTATE];
            translate = frames[frame + $a99189e38c28e5fb$var$_TransformConstraintTimeline.PREV_TRANSLATE];
            scale = frames[frame + $a99189e38c28e5fb$var$_TransformConstraintTimeline.PREV_SCALE];
            shear = frames[frame + $a99189e38c28e5fb$var$_TransformConstraintTimeline.PREV_SHEAR];
            const frameTime = frames[frame];
            const percent = this.getCurvePercent(frame / $a99189e38c28e5fb$var$_TransformConstraintTimeline.ENTRIES - 1, 1 - (time - frameTime) / (frames[frame + $a99189e38c28e5fb$var$_TransformConstraintTimeline.PREV_TIME] - frameTime));
            rotate += (frames[frame + $a99189e38c28e5fb$var$_TransformConstraintTimeline.ROTATE] - rotate) * percent;
            translate += (frames[frame + $a99189e38c28e5fb$var$_TransformConstraintTimeline.TRANSLATE] - translate) * percent;
            scale += (frames[frame + $a99189e38c28e5fb$var$_TransformConstraintTimeline.SCALE] - scale) * percent;
            shear += (frames[frame + $a99189e38c28e5fb$var$_TransformConstraintTimeline.SHEAR] - shear) * percent;
        }
        if (blend == (0, $bbcccedbc883e405$export$ccab779a50275a35).setup) {
            const data = constraint.data;
            constraint.rotateMix = data.rotateMix + (rotate - data.rotateMix) * alpha;
            constraint.translateMix = data.translateMix + (translate - data.translateMix) * alpha;
            constraint.scaleMix = data.scaleMix + (scale - data.scaleMix) * alpha;
            constraint.shearMix = data.shearMix + (shear - data.shearMix) * alpha;
        } else {
            constraint.rotateMix += (rotate - constraint.rotateMix) * alpha;
            constraint.translateMix += (translate - constraint.translateMix) * alpha;
            constraint.scaleMix += (scale - constraint.scaleMix) * alpha;
            constraint.shearMix += (shear - constraint.shearMix) * alpha;
        }
    }
};
let $a99189e38c28e5fb$export$a7a393c2ad815ac7 = $a99189e38c28e5fb$var$_TransformConstraintTimeline;
$a99189e38c28e5fb$export$a7a393c2ad815ac7.ENTRIES = 5;
$a99189e38c28e5fb$export$a7a393c2ad815ac7.PREV_TIME = -5;
$a99189e38c28e5fb$export$a7a393c2ad815ac7.PREV_ROTATE = -4;
$a99189e38c28e5fb$export$a7a393c2ad815ac7.PREV_TRANSLATE = -3;
$a99189e38c28e5fb$export$a7a393c2ad815ac7.PREV_SCALE = -2;
$a99189e38c28e5fb$export$a7a393c2ad815ac7.PREV_SHEAR = -1;
$a99189e38c28e5fb$export$a7a393c2ad815ac7.ROTATE = 1;
$a99189e38c28e5fb$export$a7a393c2ad815ac7.TRANSLATE = 2;
$a99189e38c28e5fb$export$a7a393c2ad815ac7.SCALE = 3;
$a99189e38c28e5fb$export$a7a393c2ad815ac7.SHEAR = 4;
const $a99189e38c28e5fb$var$_PathConstraintPositionTimeline = class extends $a99189e38c28e5fb$export$4094e7414845f78f {
    // time, position, ...
    constructor(frameCount){
        super(frameCount);
        this.frames = (0, $8804784813ffae81$export$d2ca453b913dcdea).newFloatArray(frameCount * $a99189e38c28e5fb$var$_PathConstraintPositionTimeline.ENTRIES);
    }
    getPropertyId() {
        return 184549376 + this.pathConstraintIndex;
    }
    /** Sets the time in seconds and path constraint position for the specified key frame. */ setFrame(frameIndex, time, value) {
        frameIndex *= $a99189e38c28e5fb$var$_PathConstraintPositionTimeline.ENTRIES;
        this.frames[frameIndex] = time;
        this.frames[frameIndex + $a99189e38c28e5fb$var$_PathConstraintPositionTimeline.VALUE] = value;
    }
    apply(skeleton, lastTime, time, firedEvents, alpha, blend, direction) {
        const frames = this.frames;
        const constraint = skeleton.pathConstraints[this.pathConstraintIndex];
        if (!constraint.active) return;
        if (time < frames[0]) {
            switch(blend){
                case (0, $bbcccedbc883e405$export$ccab779a50275a35).setup:
                    constraint.position = constraint.data.position;
                    return;
                case (0, $bbcccedbc883e405$export$ccab779a50275a35).first:
                    constraint.position += (constraint.data.position - constraint.position) * alpha;
            }
            return;
        }
        let position = 0;
        if (time >= frames[frames.length - $a99189e38c28e5fb$var$_PathConstraintPositionTimeline.ENTRIES]) position = frames[frames.length + $a99189e38c28e5fb$var$_PathConstraintPositionTimeline.PREV_VALUE];
        else {
            const frame = $a99189e38c28e5fb$export$c35d437ae5945fcd.binarySearch(frames, time, $a99189e38c28e5fb$var$_PathConstraintPositionTimeline.ENTRIES);
            position = frames[frame + $a99189e38c28e5fb$var$_PathConstraintPositionTimeline.PREV_VALUE];
            const frameTime = frames[frame];
            const percent = this.getCurvePercent(frame / $a99189e38c28e5fb$var$_PathConstraintPositionTimeline.ENTRIES - 1, 1 - (time - frameTime) / (frames[frame + $a99189e38c28e5fb$var$_PathConstraintPositionTimeline.PREV_TIME] - frameTime));
            position += (frames[frame + $a99189e38c28e5fb$var$_PathConstraintPositionTimeline.VALUE] - position) * percent;
        }
        if (blend == (0, $bbcccedbc883e405$export$ccab779a50275a35).setup) constraint.position = constraint.data.position + (position - constraint.data.position) * alpha;
        else constraint.position += (position - constraint.position) * alpha;
    }
};
let $a99189e38c28e5fb$export$7ce7e67fd9cc52ed = $a99189e38c28e5fb$var$_PathConstraintPositionTimeline;
$a99189e38c28e5fb$export$7ce7e67fd9cc52ed.ENTRIES = 2;
$a99189e38c28e5fb$export$7ce7e67fd9cc52ed.PREV_TIME = -2;
$a99189e38c28e5fb$export$7ce7e67fd9cc52ed.PREV_VALUE = -1;
$a99189e38c28e5fb$export$7ce7e67fd9cc52ed.VALUE = 1;
class $a99189e38c28e5fb$export$17ee50c08a07e62b extends $a99189e38c28e5fb$export$7ce7e67fd9cc52ed {
    constructor(frameCount){
        super(frameCount);
    }
    getPropertyId() {
        return 201326592 + this.pathConstraintIndex;
    }
    apply(skeleton, lastTime, time, firedEvents, alpha, blend, direction) {
        const frames = this.frames;
        const constraint = skeleton.pathConstraints[this.pathConstraintIndex];
        if (!constraint.active) return;
        if (time < frames[0]) {
            switch(blend){
                case (0, $bbcccedbc883e405$export$ccab779a50275a35).setup:
                    constraint.spacing = constraint.data.spacing;
                    return;
                case (0, $bbcccedbc883e405$export$ccab779a50275a35).first:
                    constraint.spacing += (constraint.data.spacing - constraint.spacing) * alpha;
            }
            return;
        }
        let spacing = 0;
        if (time >= frames[frames.length - $a99189e38c28e5fb$export$17ee50c08a07e62b.ENTRIES]) spacing = frames[frames.length + $a99189e38c28e5fb$export$17ee50c08a07e62b.PREV_VALUE];
        else {
            const frame = $a99189e38c28e5fb$export$c35d437ae5945fcd.binarySearch(frames, time, $a99189e38c28e5fb$export$17ee50c08a07e62b.ENTRIES);
            spacing = frames[frame + $a99189e38c28e5fb$export$17ee50c08a07e62b.PREV_VALUE];
            const frameTime = frames[frame];
            const percent = this.getCurvePercent(frame / $a99189e38c28e5fb$export$17ee50c08a07e62b.ENTRIES - 1, 1 - (time - frameTime) / (frames[frame + $a99189e38c28e5fb$export$17ee50c08a07e62b.PREV_TIME] - frameTime));
            spacing += (frames[frame + $a99189e38c28e5fb$export$17ee50c08a07e62b.VALUE] - spacing) * percent;
        }
        if (blend == (0, $bbcccedbc883e405$export$ccab779a50275a35).setup) constraint.spacing = constraint.data.spacing + (spacing - constraint.data.spacing) * alpha;
        else constraint.spacing += (spacing - constraint.spacing) * alpha;
    }
}
const $a99189e38c28e5fb$var$_PathConstraintMixTimeline = class extends $a99189e38c28e5fb$export$4094e7414845f78f {
    // time, rotate mix, translate mix, ...
    constructor(frameCount){
        super(frameCount);
        this.frames = (0, $8804784813ffae81$export$d2ca453b913dcdea).newFloatArray(frameCount * $a99189e38c28e5fb$var$_PathConstraintMixTimeline.ENTRIES);
    }
    getPropertyId() {
        return 218103808 + this.pathConstraintIndex;
    }
    /** The time in seconds, rotate mix, and translate mix for the specified key frame. */ setFrame(frameIndex, time, rotateMix, translateMix) {
        frameIndex *= $a99189e38c28e5fb$var$_PathConstraintMixTimeline.ENTRIES;
        this.frames[frameIndex] = time;
        this.frames[frameIndex + $a99189e38c28e5fb$var$_PathConstraintMixTimeline.ROTATE] = rotateMix;
        this.frames[frameIndex + $a99189e38c28e5fb$var$_PathConstraintMixTimeline.TRANSLATE] = translateMix;
    }
    apply(skeleton, lastTime, time, firedEvents, alpha, blend, direction) {
        const frames = this.frames;
        const constraint = skeleton.pathConstraints[this.pathConstraintIndex];
        if (!constraint.active) return;
        if (time < frames[0]) {
            switch(blend){
                case (0, $bbcccedbc883e405$export$ccab779a50275a35).setup:
                    constraint.rotateMix = constraint.data.rotateMix;
                    constraint.translateMix = constraint.data.translateMix;
                    return;
                case (0, $bbcccedbc883e405$export$ccab779a50275a35).first:
                    constraint.rotateMix += (constraint.data.rotateMix - constraint.rotateMix) * alpha;
                    constraint.translateMix += (constraint.data.translateMix - constraint.translateMix) * alpha;
            }
            return;
        }
        let rotate = 0;
        let translate = 0;
        if (time >= frames[frames.length - $a99189e38c28e5fb$var$_PathConstraintMixTimeline.ENTRIES]) {
            rotate = frames[frames.length + $a99189e38c28e5fb$var$_PathConstraintMixTimeline.PREV_ROTATE];
            translate = frames[frames.length + $a99189e38c28e5fb$var$_PathConstraintMixTimeline.PREV_TRANSLATE];
        } else {
            const frame = $a99189e38c28e5fb$export$c35d437ae5945fcd.binarySearch(frames, time, $a99189e38c28e5fb$var$_PathConstraintMixTimeline.ENTRIES);
            rotate = frames[frame + $a99189e38c28e5fb$var$_PathConstraintMixTimeline.PREV_ROTATE];
            translate = frames[frame + $a99189e38c28e5fb$var$_PathConstraintMixTimeline.PREV_TRANSLATE];
            const frameTime = frames[frame];
            const percent = this.getCurvePercent(frame / $a99189e38c28e5fb$var$_PathConstraintMixTimeline.ENTRIES - 1, 1 - (time - frameTime) / (frames[frame + $a99189e38c28e5fb$var$_PathConstraintMixTimeline.PREV_TIME] - frameTime));
            rotate += (frames[frame + $a99189e38c28e5fb$var$_PathConstraintMixTimeline.ROTATE] - rotate) * percent;
            translate += (frames[frame + $a99189e38c28e5fb$var$_PathConstraintMixTimeline.TRANSLATE] - translate) * percent;
        }
        if (blend == (0, $bbcccedbc883e405$export$ccab779a50275a35).setup) {
            constraint.rotateMix = constraint.data.rotateMix + (rotate - constraint.data.rotateMix) * alpha;
            constraint.translateMix = constraint.data.translateMix + (translate - constraint.data.translateMix) * alpha;
        } else {
            constraint.rotateMix += (rotate - constraint.rotateMix) * alpha;
            constraint.translateMix += (translate - constraint.translateMix) * alpha;
        }
    }
};
let $a99189e38c28e5fb$export$ea67b41755485038 = $a99189e38c28e5fb$var$_PathConstraintMixTimeline;
$a99189e38c28e5fb$export$ea67b41755485038.ENTRIES = 3;
$a99189e38c28e5fb$export$ea67b41755485038.PREV_TIME = -3;
$a99189e38c28e5fb$export$ea67b41755485038.PREV_ROTATE = -2;
$a99189e38c28e5fb$export$ea67b41755485038.PREV_TRANSLATE = -1;
$a99189e38c28e5fb$export$ea67b41755485038.ROTATE = 1;
$a99189e38c28e5fb$export$ea67b41755485038.TRANSLATE = 2;




const $96f986fcae8ada8f$var$_AnimationState = class {
    constructor(data){
        /** The list of tracks that currently have animations, which may contain null entries. */ this.tracks = new Array();
        /** Multiplier for the delta time when the animation state is updated, causing time for all animations and mixes to play slower
     * or faster. Defaults to 1.
     *
     * See TrackEntry {@link TrackEntry#timeScale} for affecting a single animation. */ this.timeScale = 1;
        this.unkeyedState = 0;
        this.events = new Array();
        this.listeners = new Array();
        this.queue = new $96f986fcae8ada8f$export$2fc6338444a158e6(this);
        this.propertyIDs = new (0, $8804784813ffae81$export$270182061f11fa81)();
        this.animationsChanged = false;
        this.trackEntryPool = new (0, $8804784813ffae81$export$14963ee5c8637e11)(()=>new $96f986fcae8ada8f$export$6fd48f25bc0ee658());
        this.data = data;
    }
    /** Increments each track entry {@link TrackEntry#trackTime()}, setting queued animations as current if needed. */ update(delta) {
        delta *= this.timeScale;
        const tracks = this.tracks;
        for(let i = 0, n = tracks.length; i < n; i++){
            const current = tracks[i];
            if (current == null) continue;
            current.animationLast = current.nextAnimationLast;
            current.trackLast = current.nextTrackLast;
            let currentDelta = delta * current.timeScale;
            if (current.delay > 0) {
                current.delay -= currentDelta;
                if (current.delay > 0) continue;
                currentDelta = -current.delay;
                current.delay = 0;
            }
            let next = current.next;
            if (next != null) {
                const nextTime = current.trackLast - next.delay;
                if (nextTime >= 0) {
                    next.delay = 0;
                    next.trackTime += current.timeScale == 0 ? 0 : (nextTime / current.timeScale + delta) * next.timeScale;
                    current.trackTime += currentDelta;
                    this.setCurrent(i, next, true);
                    while(next.mixingFrom != null){
                        next.mixTime += delta;
                        next = next.mixingFrom;
                    }
                    continue;
                }
            } else if (current.trackLast >= current.trackEnd && current.mixingFrom == null) {
                tracks[i] = null;
                this.queue.end(current);
                this.disposeNext(current);
                continue;
            }
            if (current.mixingFrom != null && this.updateMixingFrom(current, delta)) {
                let from = current.mixingFrom;
                current.mixingFrom = null;
                if (from != null) from.mixingTo = null;
                while(from != null){
                    this.queue.end(from);
                    from = from.mixingFrom;
                }
            }
            current.trackTime += currentDelta;
        }
        this.queue.drain();
    }
    /** Returns true when all mixing from entries are complete. */ updateMixingFrom(to, delta) {
        const from = to.mixingFrom;
        if (from == null) return true;
        const finished = this.updateMixingFrom(from, delta);
        from.animationLast = from.nextAnimationLast;
        from.trackLast = from.nextTrackLast;
        if (to.mixTime > 0 && to.mixTime >= to.mixDuration) {
            if (from.totalAlpha == 0 || to.mixDuration == 0) {
                to.mixingFrom = from.mixingFrom;
                if (from.mixingFrom != null) from.mixingFrom.mixingTo = to;
                to.interruptAlpha = from.interruptAlpha;
                this.queue.end(from);
            }
            return finished;
        }
        from.trackTime += delta * from.timeScale;
        to.mixTime += delta;
        return false;
    }
    /** Poses the skeleton using the track entry animations. There are no side effects other than invoking listeners, so the
   * animation state can be applied to multiple skeletons to pose them identically.
   * @returns True if any animations were applied. */ apply(skeleton) {
        if (skeleton == null) throw new Error("skeleton cannot be null.");
        if (this.animationsChanged) this._animationsChanged();
        const events = this.events;
        const tracks = this.tracks;
        let applied = false;
        for(let i = 0, n = tracks.length; i < n; i++){
            const current = tracks[i];
            if (current == null || current.delay > 0) continue;
            applied = true;
            const blend = i == 0 ? (0, $bbcccedbc883e405$export$ccab779a50275a35).first : current.mixBlend;
            let mix = current.alpha;
            if (current.mixingFrom != null) mix *= this.applyMixingFrom(current, skeleton, blend);
            else if (current.trackTime >= current.trackEnd && current.next == null) mix = 0;
            const animationLast = current.animationLast;
            const animationTime = current.getAnimationTime();
            const timelineCount = current.animation.timelines.length;
            const timelines = current.animation.timelines;
            if (i == 0 && mix == 1 || blend == (0, $bbcccedbc883e405$export$ccab779a50275a35).add) for(let ii = 0; ii < timelineCount; ii++){
                (0, $8804784813ffae81$export$d2ca453b913dcdea).webkit602BugfixHelper(mix, blend);
                const timeline = timelines[ii];
                if (timeline instanceof (0, $a99189e38c28e5fb$export$7f2bfc5bd27cb43d)) this.applyAttachmentTimeline(timeline, skeleton, animationTime, blend, true);
                else timeline.apply(skeleton, animationLast, animationTime, events, mix, blend, (0, $bbcccedbc883e405$export$52fc338c0bb328ba).mixIn);
            }
            else {
                const timelineMode = current.timelineMode;
                const firstFrame = current.timelinesRotation.length == 0;
                if (firstFrame) (0, $8804784813ffae81$export$d2ca453b913dcdea).setArraySize(current.timelinesRotation, timelineCount << 1, null);
                const timelinesRotation = current.timelinesRotation;
                for(let ii = 0; ii < timelineCount; ii++){
                    const timeline = timelines[ii];
                    const timelineBlend = timelineMode[ii] == $96f986fcae8ada8f$var$_AnimationState.SUBSEQUENT ? blend : (0, $bbcccedbc883e405$export$ccab779a50275a35).setup;
                    if (timeline instanceof (0, $a99189e38c28e5fb$export$b7ecb8f68b3e130b)) this.applyRotateTimeline(timeline, skeleton, animationTime, mix, timelineBlend, timelinesRotation, ii << 1, firstFrame);
                    else if (timeline instanceof (0, $a99189e38c28e5fb$export$7f2bfc5bd27cb43d)) this.applyAttachmentTimeline(timeline, skeleton, animationTime, blend, true);
                    else {
                        (0, $8804784813ffae81$export$d2ca453b913dcdea).webkit602BugfixHelper(mix, blend);
                        timeline.apply(skeleton, animationLast, animationTime, events, mix, timelineBlend, (0, $bbcccedbc883e405$export$52fc338c0bb328ba).mixIn);
                    }
                }
            }
            this.queueEvents(current, animationTime);
            events.length = 0;
            current.nextAnimationLast = animationTime;
            current.nextTrackLast = current.trackTime;
        }
        const setupState = this.unkeyedState + $96f986fcae8ada8f$var$_AnimationState.SETUP;
        const slots = skeleton.slots;
        for(let i = 0, n = skeleton.slots.length; i < n; i++){
            const slot = slots[i];
            if (slot.attachmentState == setupState) {
                const attachmentName = slot.data.attachmentName;
                slot.setAttachment(attachmentName == null ? null : skeleton.getAttachment(slot.data.index, attachmentName));
            }
        }
        this.unkeyedState += 2;
        this.queue.drain();
        return applied;
    }
    applyMixingFrom(to, skeleton, blend) {
        const from = to.mixingFrom;
        if (from.mixingFrom != null) this.applyMixingFrom(from, skeleton, blend);
        let mix = 0;
        if (to.mixDuration == 0) {
            mix = 1;
            if (blend == (0, $bbcccedbc883e405$export$ccab779a50275a35).first) blend = (0, $bbcccedbc883e405$export$ccab779a50275a35).setup;
        } else {
            mix = to.mixTime / to.mixDuration;
            if (mix > 1) mix = 1;
            if (blend != (0, $bbcccedbc883e405$export$ccab779a50275a35).first) blend = from.mixBlend;
        }
        const events = mix < from.eventThreshold ? this.events : null;
        const attachments = mix < from.attachmentThreshold;
        const drawOrder = mix < from.drawOrderThreshold;
        const animationLast = from.animationLast;
        const animationTime = from.getAnimationTime();
        const timelineCount = from.animation.timelines.length;
        const timelines = from.animation.timelines;
        const alphaHold = from.alpha * to.interruptAlpha;
        const alphaMix = alphaHold * (1 - mix);
        if (blend == (0, $bbcccedbc883e405$export$ccab779a50275a35).add) for(let i = 0; i < timelineCount; i++)timelines[i].apply(skeleton, animationLast, animationTime, events, alphaMix, blend, (0, $bbcccedbc883e405$export$52fc338c0bb328ba).mixOut);
        else {
            const timelineMode = from.timelineMode;
            const timelineHoldMix = from.timelineHoldMix;
            const firstFrame = from.timelinesRotation.length == 0;
            if (firstFrame) (0, $8804784813ffae81$export$d2ca453b913dcdea).setArraySize(from.timelinesRotation, timelineCount << 1, null);
            const timelinesRotation = from.timelinesRotation;
            from.totalAlpha = 0;
            for(let i = 0; i < timelineCount; i++){
                const timeline = timelines[i];
                let direction = (0, $bbcccedbc883e405$export$52fc338c0bb328ba).mixOut;
                let timelineBlend;
                let alpha = 0;
                switch(timelineMode[i]){
                    case $96f986fcae8ada8f$var$_AnimationState.SUBSEQUENT:
                        if (!drawOrder && timeline instanceof (0, $a99189e38c28e5fb$export$ece1f7c41d051e83)) continue;
                        timelineBlend = blend;
                        alpha = alphaMix;
                        break;
                    case $96f986fcae8ada8f$var$_AnimationState.FIRST:
                        timelineBlend = (0, $bbcccedbc883e405$export$ccab779a50275a35).setup;
                        alpha = alphaMix;
                        break;
                    case $96f986fcae8ada8f$var$_AnimationState.HOLD_SUBSEQUENT:
                        timelineBlend = blend;
                        alpha = alphaHold;
                        break;
                    case $96f986fcae8ada8f$var$_AnimationState.HOLD_FIRST:
                        timelineBlend = (0, $bbcccedbc883e405$export$ccab779a50275a35).setup;
                        alpha = alphaHold;
                        break;
                    default:
                        timelineBlend = (0, $bbcccedbc883e405$export$ccab779a50275a35).setup;
                        const holdMix = timelineHoldMix[i];
                        alpha = alphaHold * Math.max(0, 1 - holdMix.mixTime / holdMix.mixDuration);
                        break;
                }
                from.totalAlpha += alpha;
                if (timeline instanceof (0, $a99189e38c28e5fb$export$b7ecb8f68b3e130b)) this.applyRotateTimeline(timeline, skeleton, animationTime, alpha, timelineBlend, timelinesRotation, i << 1, firstFrame);
                else if (timeline instanceof (0, $a99189e38c28e5fb$export$7f2bfc5bd27cb43d)) this.applyAttachmentTimeline(timeline, skeleton, animationTime, timelineBlend, attachments);
                else {
                    (0, $8804784813ffae81$export$d2ca453b913dcdea).webkit602BugfixHelper(alpha, blend);
                    if (drawOrder && timeline instanceof (0, $a99189e38c28e5fb$export$ece1f7c41d051e83) && timelineBlend == (0, $bbcccedbc883e405$export$ccab779a50275a35).setup) direction = (0, $bbcccedbc883e405$export$52fc338c0bb328ba).mixIn;
                    timeline.apply(skeleton, animationLast, animationTime, events, alpha, timelineBlend, direction);
                }
            }
        }
        if (to.mixDuration > 0) this.queueEvents(from, animationTime);
        this.events.length = 0;
        from.nextAnimationLast = animationTime;
        from.nextTrackLast = from.trackTime;
        return mix;
    }
    applyAttachmentTimeline(timeline, skeleton, time, blend, attachments) {
        const slot = skeleton.slots[timeline.slotIndex];
        if (!slot.bone.active) return;
        const frames = timeline.frames;
        if (time < frames[0]) {
            if (blend == (0, $bbcccedbc883e405$export$ccab779a50275a35).setup || blend == (0, $bbcccedbc883e405$export$ccab779a50275a35).first) this.setAttachment(skeleton, slot, slot.data.attachmentName, attachments);
        } else {
            let frameIndex;
            if (time >= frames[frames.length - 1]) frameIndex = frames.length - 1;
            else frameIndex = (0, $a99189e38c28e5fb$export$c35d437ae5945fcd).binarySearch(frames, time) - 1;
            this.setAttachment(skeleton, slot, timeline.attachmentNames[frameIndex], attachments);
        }
        if (slot.attachmentState <= this.unkeyedState) slot.attachmentState = this.unkeyedState + $96f986fcae8ada8f$var$_AnimationState.SETUP;
    }
    setAttachment(skeleton, slot, attachmentName, attachments) {
        slot.setAttachment(attachmentName == null ? null : skeleton.getAttachment(slot.data.index, attachmentName));
        if (attachments) slot.attachmentState = this.unkeyedState + $96f986fcae8ada8f$var$_AnimationState.CURRENT;
    }
    applyRotateTimeline(timeline, skeleton, time, alpha, blend, timelinesRotation, i, firstFrame) {
        if (firstFrame) timelinesRotation[i] = 0;
        if (alpha == 1) {
            timeline.apply(skeleton, 0, time, null, 1, blend, (0, $bbcccedbc883e405$export$52fc338c0bb328ba).mixIn);
            return;
        }
        const rotateTimeline = timeline;
        const frames = rotateTimeline.frames;
        const bone = skeleton.bones[rotateTimeline.boneIndex];
        if (!bone.active) return;
        let r1 = 0;
        let r2 = 0;
        if (time < frames[0]) switch(blend){
            case (0, $bbcccedbc883e405$export$ccab779a50275a35).setup:
                bone.rotation = bone.data.rotation;
            default:
                return;
            case (0, $bbcccedbc883e405$export$ccab779a50275a35).first:
                r1 = bone.rotation;
                r2 = bone.data.rotation;
        }
        else {
            r1 = blend == (0, $bbcccedbc883e405$export$ccab779a50275a35).setup ? bone.data.rotation : bone.rotation;
            if (time >= frames[frames.length - (0, $a99189e38c28e5fb$export$b7ecb8f68b3e130b).ENTRIES]) r2 = bone.data.rotation + frames[frames.length + (0, $a99189e38c28e5fb$export$b7ecb8f68b3e130b).PREV_ROTATION];
            else {
                const frame = (0, $a99189e38c28e5fb$export$c35d437ae5945fcd).binarySearch(frames, time, (0, $a99189e38c28e5fb$export$b7ecb8f68b3e130b).ENTRIES);
                const prevRotation = frames[frame + (0, $a99189e38c28e5fb$export$b7ecb8f68b3e130b).PREV_ROTATION];
                const frameTime = frames[frame];
                const percent = rotateTimeline.getCurvePercent((frame >> 1) - 1, 1 - (time - frameTime) / (frames[frame + (0, $a99189e38c28e5fb$export$b7ecb8f68b3e130b).PREV_TIME] - frameTime));
                r2 = frames[frame + (0, $a99189e38c28e5fb$export$b7ecb8f68b3e130b).ROTATION] - prevRotation;
                r2 -= (16384 - (16384.499999999996 - r2 / 360 | 0)) * 360;
                r2 = prevRotation + r2 * percent + bone.data.rotation;
                r2 -= (16384 - (16384.499999999996 - r2 / 360 | 0)) * 360;
            }
        }
        let total = 0;
        let diff = r2 - r1;
        diff -= (16384 - (16384.499999999996 - diff / 360 | 0)) * 360;
        if (diff == 0) total = timelinesRotation[i];
        else {
            let lastTotal = 0;
            let lastDiff = 0;
            if (firstFrame) {
                lastTotal = 0;
                lastDiff = diff;
            } else {
                lastTotal = timelinesRotation[i];
                lastDiff = timelinesRotation[i + 1];
            }
            const current = diff > 0;
            let dir = lastTotal >= 0;
            if ((0, $8804784813ffae81$export$6a7ef315a0d1ef07).signum(lastDiff) != (0, $8804784813ffae81$export$6a7ef315a0d1ef07).signum(diff) && Math.abs(lastDiff) <= 90) {
                if (Math.abs(lastTotal) > 180) lastTotal += 360 * (0, $8804784813ffae81$export$6a7ef315a0d1ef07).signum(lastTotal);
                dir = current;
            }
            total = diff + lastTotal - lastTotal % 360;
            if (dir != current) total += 360 * (0, $8804784813ffae81$export$6a7ef315a0d1ef07).signum(lastTotal);
            timelinesRotation[i] = total;
        }
        timelinesRotation[i + 1] = diff;
        r1 += total * alpha;
        bone.rotation = r1 - (16384 - (16384.499999999996 - r1 / 360 | 0)) * 360;
    }
    queueEvents(entry, animationTime) {
        const animationStart = entry.animationStart;
        const animationEnd = entry.animationEnd;
        const duration = animationEnd - animationStart;
        const trackLastWrapped = entry.trackLast % duration;
        const events = this.events;
        let i = 0;
        const n = events.length;
        for(; i < n; i++){
            const event = events[i];
            if (event.time < trackLastWrapped) break;
            if (event.time > animationEnd) continue;
            this.queue.event(entry, event);
        }
        let complete = false;
        if (entry.loop) complete = duration == 0 || trackLastWrapped > entry.trackTime % duration;
        else complete = animationTime >= animationEnd && entry.animationLast < animationEnd;
        if (complete) this.queue.complete(entry);
        for(; i < n; i++){
            const event = events[i];
            if (event.time < animationStart) continue;
            this.queue.event(entry, events[i]);
        }
    }
    /** Removes all animations from all tracks, leaving skeletons in their current pose.
   *
   * It may be desired to use {@link AnimationState#setEmptyAnimation()} to mix the skeletons back to the setup pose,
   * rather than leaving them in their current pose. */ clearTracks() {
        const oldDrainDisabled = this.queue.drainDisabled;
        this.queue.drainDisabled = true;
        for(let i = 0, n = this.tracks.length; i < n; i++)this.clearTrack(i);
        this.tracks.length = 0;
        this.queue.drainDisabled = oldDrainDisabled;
        this.queue.drain();
    }
    /** Removes all animations from the track, leaving skeletons in their current pose.
   *
   * It may be desired to use {@link AnimationState#setEmptyAnimation()} to mix the skeletons back to the setup pose,
   * rather than leaving them in their current pose. */ clearTrack(trackIndex) {
        if (trackIndex >= this.tracks.length) return;
        const current = this.tracks[trackIndex];
        if (current == null) return;
        this.queue.end(current);
        this.disposeNext(current);
        let entry = current;
        while(true){
            const from = entry.mixingFrom;
            if (from == null) break;
            this.queue.end(from);
            entry.mixingFrom = null;
            entry.mixingTo = null;
            entry = from;
        }
        this.tracks[current.trackIndex] = null;
        this.queue.drain();
    }
    setCurrent(index, current, interrupt) {
        const from = this.expandToIndex(index);
        this.tracks[index] = current;
        if (from != null) {
            if (interrupt) this.queue.interrupt(from);
            current.mixingFrom = from;
            from.mixingTo = current;
            current.mixTime = 0;
            if (from.mixingFrom != null && from.mixDuration > 0) current.interruptAlpha *= Math.min(1, from.mixTime / from.mixDuration);
            from.timelinesRotation.length = 0;
        }
        this.queue.start(current);
    }
    /** Sets an animation by name.
   *
   * {@link #setAnimationWith(}. */ setAnimation(trackIndex, animationName, loop) {
        const animation = this.data.skeletonData.findAnimation(animationName);
        if (animation == null) throw new Error(`Animation not found: ${animationName}`);
        return this.setAnimationWith(trackIndex, animation, loop);
    }
    /** Sets the current animation for a track, discarding any queued animations. If the formerly current track entry was never
   * applied to a skeleton, it is replaced (not mixed from).
   * @param loop If true, the animation will repeat. If false it will not, instead its last frame is applied if played beyond its
   *           duration. In either case {@link TrackEntry#trackEnd} determines when the track is cleared.
   * @returns A track entry to allow further customization of animation playback. References to the track entry must not be kept
   *         after the {@link AnimationStateListener#dispose()} event occurs. */ setAnimationWith(trackIndex, animation, loop) {
        if (animation == null) throw new Error("animation cannot be null.");
        let interrupt = true;
        let current = this.expandToIndex(trackIndex);
        if (current != null) {
            if (current.nextTrackLast == -1) {
                this.tracks[trackIndex] = current.mixingFrom;
                this.queue.interrupt(current);
                this.queue.end(current);
                this.disposeNext(current);
                current = current.mixingFrom;
                interrupt = false;
            } else this.disposeNext(current);
        }
        const entry = this.trackEntry(trackIndex, animation, loop, current);
        this.setCurrent(trackIndex, entry, interrupt);
        this.queue.drain();
        return entry;
    }
    /** Queues an animation by name.
   *
   * See {@link #addAnimationWith()}. */ addAnimation(trackIndex, animationName, loop, delay) {
        const animation = this.data.skeletonData.findAnimation(animationName);
        if (animation == null) throw new Error(`Animation not found: ${animationName}`);
        return this.addAnimationWith(trackIndex, animation, loop, delay);
    }
    /** Adds an animation to be played after the current or last queued animation for a track. If the track is empty, it is
   * equivalent to calling {@link #setAnimationWith()}.
   * @param delay If > 0, sets {@link TrackEntry#delay}. If <= 0, the delay set is the duration of the previous track entry
   *           minus any mix duration (from the {@link AnimationStateData}) plus the specified `delay` (ie the mix
   *           ends at (`delay` = 0) or before (`delay` < 0) the previous track entry duration). If the
   *           previous entry is looping, its next loop completion is used instead of its duration.
   * @returns A track entry to allow further customization of animation playback. References to the track entry must not be kept
   *         after the {@link AnimationStateListener#dispose()} event occurs. */ addAnimationWith(trackIndex, animation, loop, delay) {
        if (animation == null) throw new Error("animation cannot be null.");
        let last = this.expandToIndex(trackIndex);
        if (last != null) while(last.next != null)last = last.next;
        const entry = this.trackEntry(trackIndex, animation, loop, last);
        if (last == null) {
            this.setCurrent(trackIndex, entry, true);
            this.queue.drain();
        } else {
            last.next = entry;
            if (delay <= 0) {
                const duration = last.animationEnd - last.animationStart;
                if (duration != 0) {
                    if (last.loop) delay += duration * (1 + (last.trackTime / duration | 0));
                    else delay += Math.max(duration, last.trackTime);
                    delay -= this.data.getMix(last.animation, animation);
                } else delay = last.trackTime;
            }
        }
        entry.delay = delay;
        return entry;
    }
    /** Sets an empty animation for a track, discarding any queued animations, and sets the track entry's
   * {@link TrackEntry#mixduration}. An empty animation has no timelines and serves as a placeholder for mixing in or out.
   *
   * Mixing out is done by setting an empty animation with a mix duration using either {@link #setEmptyAnimation()},
   * {@link #setEmptyAnimations()}, or {@link #addEmptyAnimation()}. Mixing to an empty animation causes
   * the previous animation to be applied less and less over the mix duration. Properties keyed in the previous animation
   * transition to the value from lower tracks or to the setup pose value if no lower tracks key the property. A mix duration of
   * 0 still mixes out over one frame.
   *
   * Mixing in is done by first setting an empty animation, then adding an animation using
   * {@link #addAnimation()} and on the returned track entry, set the
   * {@link TrackEntry#setMixDuration()}. Mixing from an empty animation causes the new animation to be applied more and
   * more over the mix duration. Properties keyed in the new animation transition from the value from lower tracks or from the
   * setup pose value if no lower tracks key the property to the value keyed in the new animation. */ setEmptyAnimation(trackIndex, mixDuration) {
        const entry = this.setAnimationWith(trackIndex, $96f986fcae8ada8f$var$_AnimationState.emptyAnimation, false);
        entry.mixDuration = mixDuration;
        entry.trackEnd = mixDuration;
        return entry;
    }
    /** Adds an empty animation to be played after the current or last queued animation for a track, and sets the track entry's
   * {@link TrackEntry#mixDuration}. If the track is empty, it is equivalent to calling
   * {@link #setEmptyAnimation()}.
   *
   * See {@link #setEmptyAnimation()}.
   * @param delay If > 0, sets {@link TrackEntry#delay}. If <= 0, the delay set is the duration of the previous track entry
   *           minus any mix duration plus the specified `delay` (ie the mix ends at (`delay` = 0) or
   *           before (`delay` < 0) the previous track entry duration). If the previous entry is looping, its next
   *           loop completion is used instead of its duration.
   * @return A track entry to allow further customization of animation playback. References to the track entry must not be kept
   *         after the {@link AnimationStateListener#dispose()} event occurs. */ addEmptyAnimation(trackIndex, mixDuration, delay) {
        if (delay <= 0) delay -= mixDuration;
        const entry = this.addAnimationWith(trackIndex, $96f986fcae8ada8f$var$_AnimationState.emptyAnimation, false, delay);
        entry.mixDuration = mixDuration;
        entry.trackEnd = mixDuration;
        return entry;
    }
    /** Sets an empty animation for every track, discarding any queued animations, and mixes to it over the specified mix
   * duration. */ setEmptyAnimations(mixDuration) {
        const oldDrainDisabled = this.queue.drainDisabled;
        this.queue.drainDisabled = true;
        for(let i = 0, n = this.tracks.length; i < n; i++){
            const current = this.tracks[i];
            if (current != null) this.setEmptyAnimation(current.trackIndex, mixDuration);
        }
        this.queue.drainDisabled = oldDrainDisabled;
        this.queue.drain();
    }
    expandToIndex(index) {
        if (index < this.tracks.length) return this.tracks[index];
        (0, $8804784813ffae81$export$d2ca453b913dcdea).ensureArrayCapacity(this.tracks, index + 1, null);
        this.tracks.length = index + 1;
        return null;
    }
    /** @param last May be null. */ trackEntry(trackIndex, animation, loop, last) {
        const entry = this.trackEntryPool.obtain();
        entry.trackIndex = trackIndex;
        entry.animation = animation;
        entry.loop = loop;
        entry.holdPrevious = false;
        entry.eventThreshold = 0;
        entry.attachmentThreshold = 0;
        entry.drawOrderThreshold = 0;
        entry.animationStart = 0;
        entry.animationEnd = animation.duration;
        entry.animationLast = -1;
        entry.nextAnimationLast = -1;
        entry.delay = 0;
        entry.trackTime = 0;
        entry.trackLast = -1;
        entry.nextTrackLast = -1;
        entry.trackEnd = Number.MAX_VALUE;
        entry.timeScale = 1;
        entry.alpha = 1;
        entry.interruptAlpha = 1;
        entry.mixTime = 0;
        entry.mixDuration = last == null ? 0 : this.data.getMix(last.animation, animation);
        entry.mixBlend = (0, $bbcccedbc883e405$export$ccab779a50275a35).replace;
        return entry;
    }
    disposeNext(entry) {
        let next = entry.next;
        while(next != null){
            this.queue.dispose(next);
            next = next.next;
        }
        entry.next = null;
    }
    _animationsChanged() {
        this.animationsChanged = false;
        this.propertyIDs.clear();
        for(let i = 0, n = this.tracks.length; i < n; i++){
            let entry = this.tracks[i];
            if (entry == null) continue;
            while(entry.mixingFrom != null)entry = entry.mixingFrom;
            do {
                if (entry.mixingFrom == null || entry.mixBlend != (0, $bbcccedbc883e405$export$ccab779a50275a35).add) this.computeHold(entry);
                entry = entry.mixingTo;
            }while (entry != null);
        }
    }
    computeHold(entry) {
        const to = entry.mixingTo;
        const timelines = entry.animation.timelines;
        const timelinesCount = entry.animation.timelines.length;
        const timelineMode = (0, $8804784813ffae81$export$d2ca453b913dcdea).setArraySize(entry.timelineMode, timelinesCount);
        entry.timelineHoldMix.length = 0;
        const timelineDipMix = (0, $8804784813ffae81$export$d2ca453b913dcdea).setArraySize(entry.timelineHoldMix, timelinesCount);
        const propertyIDs = this.propertyIDs;
        if (to != null && to.holdPrevious) {
            for(let i = 0; i < timelinesCount; i++)timelineMode[i] = propertyIDs.add(timelines[i].getPropertyId()) ? $96f986fcae8ada8f$var$_AnimationState.HOLD_FIRST : $96f986fcae8ada8f$var$_AnimationState.HOLD_SUBSEQUENT;
            return;
        }
        outer: for(let i = 0; i < timelinesCount; i++){
            const timeline = timelines[i];
            const id = timeline.getPropertyId();
            if (!propertyIDs.add(id)) timelineMode[i] = $96f986fcae8ada8f$var$_AnimationState.SUBSEQUENT;
            else if (to == null || timeline instanceof (0, $a99189e38c28e5fb$export$7f2bfc5bd27cb43d) || timeline instanceof (0, $a99189e38c28e5fb$export$ece1f7c41d051e83) || timeline instanceof (0, $a99189e38c28e5fb$export$4f4bca996c586084) || !to.animation.hasTimeline(id)) timelineMode[i] = $96f986fcae8ada8f$var$_AnimationState.FIRST;
            else {
                for(let next = to.mixingTo; next != null; next = next.mixingTo){
                    if (next.animation.hasTimeline(id)) continue;
                    if (entry.mixDuration > 0) {
                        timelineMode[i] = $96f986fcae8ada8f$var$_AnimationState.HOLD_MIX;
                        timelineDipMix[i] = next;
                        continue outer;
                    }
                    break;
                }
                timelineMode[i] = $96f986fcae8ada8f$var$_AnimationState.HOLD_FIRST;
            }
        }
    }
    /** Returns the track entry for the animation currently playing on the track, or null if no animation is currently playing. */ getCurrent(trackIndex) {
        if (trackIndex >= this.tracks.length) return null;
        return this.tracks[trackIndex];
    }
    /** Adds a listener to receive events for all track entries. */ addListener(listener) {
        if (listener == null) throw new Error("listener cannot be null.");
        this.listeners.push(listener);
    }
    /** Removes the listener added with {@link #addListener()}. */ removeListener(listener) {
        const index = this.listeners.indexOf(listener);
        if (index >= 0) this.listeners.splice(index, 1);
    }
    /** Removes all listeners added with {@link #addListener()}. */ clearListeners() {
        this.listeners.length = 0;
    }
    /** Discards all listener notifications that have not yet been delivered. This can be useful to call from an
   * {@link AnimationStateListener} when it is known that further notifications that may have been already queued for delivery
   * are not wanted because new animations are being set. */ clearListenerNotifications() {
        this.queue.clear();
    }
    setAnimationByName(trackIndex, animationName, loop) {
        if (!$96f986fcae8ada8f$var$_AnimationState.deprecatedWarning1) {
            $96f986fcae8ada8f$var$_AnimationState.deprecatedWarning1 = true;
            console.warn("Spine Deprecation Warning: AnimationState.setAnimationByName is deprecated, please use setAnimation from now on.");
        }
        this.setAnimation(trackIndex, animationName, loop);
    }
    addAnimationByName(trackIndex, animationName, loop, delay) {
        if (!$96f986fcae8ada8f$var$_AnimationState.deprecatedWarning2) {
            $96f986fcae8ada8f$var$_AnimationState.deprecatedWarning2 = true;
            console.warn("Spine Deprecation Warning: AnimationState.addAnimationByName is deprecated, please use addAnimation from now on.");
        }
        this.addAnimation(trackIndex, animationName, loop, delay);
    }
    hasAnimation(animationName) {
        const animation = this.data.skeletonData.findAnimation(animationName);
        return animation !== null;
    }
    hasAnimationByName(animationName) {
        if (!$96f986fcae8ada8f$var$_AnimationState.deprecatedWarning3) {
            $96f986fcae8ada8f$var$_AnimationState.deprecatedWarning3 = true;
            console.warn("Spine Deprecation Warning: AnimationState.hasAnimationByName is deprecated, please use hasAnimation from now on.");
        }
        return this.hasAnimation(animationName);
    }
};
let $96f986fcae8ada8f$export$d0f7a26c90cc1562 = $96f986fcae8ada8f$var$_AnimationState;
$96f986fcae8ada8f$export$d0f7a26c90cc1562.emptyAnimation = new (0, $a99189e38c28e5fb$export$c35d437ae5945fcd)("<empty>", [], 0);
/** 1. A previously applied timeline has set this property.
 *
 * Result: Mix from the current pose to the timeline pose. */ $96f986fcae8ada8f$export$d0f7a26c90cc1562.SUBSEQUENT = 0;
/** 1. This is the first timeline to set this property.
 * 2. The next track entry applied after this one does not have a timeline to set this property.
 *
 * Result: Mix from the setup pose to the timeline pose. */ $96f986fcae8ada8f$export$d0f7a26c90cc1562.FIRST = 1;
/** 1) A previously applied timeline has set this property.<br>
 * 2) The next track entry to be applied does have a timeline to set this property.<br>
 * 3) The next track entry after that one does not have a timeline to set this property.<br>
 * Result: Mix from the current pose to the timeline pose, but do not mix out. This avoids "dipping" when crossfading
 * animations that key the same property. A subsequent timeline will set this property using a mix. */ $96f986fcae8ada8f$export$d0f7a26c90cc1562.HOLD_SUBSEQUENT = 2;
/** 1) This is the first timeline to set this property.<br>
 * 2) The next track entry to be applied does have a timeline to set this property.<br>
 * 3) The next track entry after that one does not have a timeline to set this property.<br>
 * Result: Mix from the setup pose to the timeline pose, but do not mix out. This avoids "dipping" when crossfading animations
 * that key the same property. A subsequent timeline will set this property using a mix. */ $96f986fcae8ada8f$export$d0f7a26c90cc1562.HOLD_FIRST = 3;
/** 1. This is the first timeline to set this property.
 * 2. The next track entry to be applied does have a timeline to set this property.
 * 3. The next track entry after that one does have a timeline to set this property.
 * 4. timelineHoldMix stores the first subsequent track entry that does not have a timeline to set this property.
 *
 * Result: The same as HOLD except the mix percentage from the timelineHoldMix track entry is used. This handles when more than
 * 2 track entries in a row have a timeline that sets the same property.
 *
 * Eg, A -> B -> C -> D where A, B, and C have a timeline setting same property, but D does not. When A is applied, to avoid
 * "dipping" A is not mixed out, however D (the first entry that doesn't set the property) mixing in is used to mix out A
 * (which affects B and C). Without using D to mix out, A would be applied fully until mixing completes, then snap into
 * place. */ $96f986fcae8ada8f$export$d0f7a26c90cc1562.HOLD_MIX = 4;
$96f986fcae8ada8f$export$d0f7a26c90cc1562.SETUP = 1;
$96f986fcae8ada8f$export$d0f7a26c90cc1562.CURRENT = 2;
$96f986fcae8ada8f$export$d0f7a26c90cc1562.deprecatedWarning1 = false;
$96f986fcae8ada8f$export$d0f7a26c90cc1562.deprecatedWarning2 = false;
$96f986fcae8ada8f$export$d0f7a26c90cc1562.deprecatedWarning3 = false;
const $96f986fcae8ada8f$var$_TrackEntry = class {
    constructor(){
        /** Controls how properties keyed in the animation are mixed with lower tracks. Defaults to {@link MixBlend#replace}, which
     * replaces the values from the lower tracks with the animation values. {@link MixBlend#add} adds the animation values to
     * the values from the lower tracks.
     *
     * The `mixBlend` can be set for a new track entry only before {@link AnimationState#apply()} is first
     * called. */ this.mixBlend = (0, $bbcccedbc883e405$export$ccab779a50275a35).replace;
        this.timelineMode = new Array();
        this.timelineHoldMix = new Array();
        this.timelinesRotation = new Array();
    }
    reset() {
        this.next = null;
        this.mixingFrom = null;
        this.mixingTo = null;
        this.animation = null;
        this.listener = null;
        this.timelineMode.length = 0;
        this.timelineHoldMix.length = 0;
        this.timelinesRotation.length = 0;
    }
    /** Uses {@link #trackTime} to compute the `animationTime`, which is between {@link #animationStart}
   * and {@link #animationEnd}. When the `trackTime` is 0, the `animationTime` is equal to the
   * `animationStart` time. */ getAnimationTime() {
        if (this.loop) {
            const duration = this.animationEnd - this.animationStart;
            if (duration == 0) return this.animationStart;
            return this.trackTime % duration + this.animationStart;
        }
        return Math.min(this.trackTime + this.animationStart, this.animationEnd);
    }
    setAnimationLast(animationLast) {
        this.animationLast = animationLast;
        this.nextAnimationLast = animationLast;
    }
    /** Returns true if at least one loop has been completed.
   *
   * See {@link AnimationStateListener#complete()}. */ isComplete() {
        return this.trackTime >= this.animationEnd - this.animationStart;
    }
    /** Resets the rotation directions for mixing this entry's rotate timelines. This can be useful to avoid bones rotating the
   * long way around when using {@link #alpha} and starting animations on other tracks.
   *
   * Mixing with {@link MixBlend#replace} involves finding a rotation between two others, which has two possible solutions:
   * the short way or the long way around. The two rotations likely change over time, so which direction is the short or long
   * way also changes. If the short way was always chosen, bones would flip to the other side when that direction became the
   * long way. TrackEntry chooses the short way the first time it is applied and remembers that direction. */ resetRotationDirections() {
        this.timelinesRotation.length = 0;
    }
    get time() {
        if (!$96f986fcae8ada8f$var$_TrackEntry.deprecatedWarning1) {
            $96f986fcae8ada8f$var$_TrackEntry.deprecatedWarning1 = true;
            console.warn("Spine Deprecation Warning: TrackEntry.time is deprecated, please use trackTime from now on.");
        }
        return this.trackTime;
    }
    set time(value) {
        if (!$96f986fcae8ada8f$var$_TrackEntry.deprecatedWarning1) {
            $96f986fcae8ada8f$var$_TrackEntry.deprecatedWarning1 = true;
            console.warn("Spine Deprecation Warning: TrackEntry.time is deprecated, please use trackTime from now on.");
        }
        this.trackTime = value;
    }
    get endTime() {
        if (!$96f986fcae8ada8f$var$_TrackEntry.deprecatedWarning2) {
            $96f986fcae8ada8f$var$_TrackEntry.deprecatedWarning2 = true;
            console.warn("Spine Deprecation Warning: TrackEntry.endTime is deprecated, please use trackEnd from now on.");
        }
        return this.trackTime;
    }
    set endTime(value) {
        if (!$96f986fcae8ada8f$var$_TrackEntry.deprecatedWarning2) {
            $96f986fcae8ada8f$var$_TrackEntry.deprecatedWarning2 = true;
            console.warn("Spine Deprecation Warning: TrackEntry.endTime is deprecated, please use trackEnd from now on.");
        }
        this.trackTime = value;
    }
    loopsCount() {
        return Math.floor(this.trackTime / this.trackEnd);
    }
};
let $96f986fcae8ada8f$export$6fd48f25bc0ee658 = $96f986fcae8ada8f$var$_TrackEntry;
$96f986fcae8ada8f$export$6fd48f25bc0ee658.deprecatedWarning1 = false;
$96f986fcae8ada8f$export$6fd48f25bc0ee658.deprecatedWarning2 = false;
const $96f986fcae8ada8f$var$_EventQueue = class {
    constructor(animState){
        this.objects = [];
        this.drainDisabled = false;
        this.animState = animState;
    }
    start(entry) {
        this.objects.push($96f986fcae8ada8f$export$3d7865934588d77e.start);
        this.objects.push(entry);
        this.animState.animationsChanged = true;
    }
    interrupt(entry) {
        this.objects.push($96f986fcae8ada8f$export$3d7865934588d77e.interrupt);
        this.objects.push(entry);
    }
    end(entry) {
        this.objects.push($96f986fcae8ada8f$export$3d7865934588d77e.end);
        this.objects.push(entry);
        this.animState.animationsChanged = true;
    }
    dispose(entry) {
        this.objects.push($96f986fcae8ada8f$export$3d7865934588d77e.dispose);
        this.objects.push(entry);
    }
    complete(entry) {
        this.objects.push($96f986fcae8ada8f$export$3d7865934588d77e.complete);
        this.objects.push(entry);
    }
    event(entry, event) {
        this.objects.push($96f986fcae8ada8f$export$3d7865934588d77e.event);
        this.objects.push(entry);
        this.objects.push(event);
    }
    deprecateStuff() {
        if (!$96f986fcae8ada8f$var$_EventQueue.deprecatedWarning1) {
            $96f986fcae8ada8f$var$_EventQueue.deprecatedWarning1 = true;
            console.warn("Spine Deprecation Warning: onComplete, onStart, onEnd, onEvent art deprecated, please use listeners from now on. 'state.addListener({ complete: function(track, event) { } })'");
        }
        return true;
    }
    drain() {
        if (this.drainDisabled) return;
        this.drainDisabled = true;
        const objects = this.objects;
        const listeners = this.animState.listeners;
        for(let i = 0; i < objects.length; i += 2){
            const type = objects[i];
            const entry = objects[i + 1];
            switch(type){
                case $96f986fcae8ada8f$export$3d7865934588d77e.start:
                    if (entry.listener != null && entry.listener.start) entry.listener.start(entry);
                    for(let ii = 0; ii < listeners.length; ii++)if (listeners[ii].start) listeners[ii].start(entry);
                    entry.onStart && this.deprecateStuff() && entry.onStart(entry.trackIndex);
                    this.animState.onStart && this.deprecateStuff() && this.deprecateStuff && this.animState.onStart(entry.trackIndex);
                    break;
                case $96f986fcae8ada8f$export$3d7865934588d77e.interrupt:
                    if (entry.listener != null && entry.listener.interrupt) entry.listener.interrupt(entry);
                    for(let ii = 0; ii < listeners.length; ii++)if (listeners[ii].interrupt) listeners[ii].interrupt(entry);
                    break;
                case $96f986fcae8ada8f$export$3d7865934588d77e.end:
                    if (entry.listener != null && entry.listener.end) entry.listener.end(entry);
                    for(let ii = 0; ii < listeners.length; ii++)if (listeners[ii].end) listeners[ii].end(entry);
                    entry.onEnd && this.deprecateStuff() && entry.onEnd(entry.trackIndex);
                    this.animState.onEnd && this.deprecateStuff() && this.animState.onEnd(entry.trackIndex);
                case $96f986fcae8ada8f$export$3d7865934588d77e.dispose:
                    if (entry.listener != null && entry.listener.dispose) entry.listener.dispose(entry);
                    for(let ii = 0; ii < listeners.length; ii++)if (listeners[ii].dispose) listeners[ii].dispose(entry);
                    this.animState.trackEntryPool.free(entry);
                    break;
                case $96f986fcae8ada8f$export$3d7865934588d77e.complete:
                    if (entry.listener != null && entry.listener.complete) entry.listener.complete(entry);
                    for(let ii = 0; ii < listeners.length; ii++)if (listeners[ii].complete) listeners[ii].complete(entry);
                    const count = (0, $8804784813ffae81$export$6a7ef315a0d1ef07).toInt(entry.loopsCount());
                    entry.onComplete && this.deprecateStuff() && entry.onComplete(entry.trackIndex, count);
                    this.animState.onComplete && this.deprecateStuff() && this.animState.onComplete(entry.trackIndex, count);
                    break;
                case $96f986fcae8ada8f$export$3d7865934588d77e.event:
                    const event = objects[i++ + 2];
                    if (entry.listener != null && entry.listener.event) entry.listener.event(entry, event);
                    for(let ii = 0; ii < listeners.length; ii++)if (listeners[ii].event) listeners[ii].event(entry, event);
                    entry.onEvent && this.deprecateStuff() && entry.onEvent(entry.trackIndex, event);
                    this.animState.onEvent && this.deprecateStuff() && this.animState.onEvent(entry.trackIndex, event);
                    break;
            }
        }
        this.clear();
        this.drainDisabled = false;
    }
    clear() {
        this.objects.length = 0;
    }
};
let $96f986fcae8ada8f$export$2fc6338444a158e6 = $96f986fcae8ada8f$var$_EventQueue;
$96f986fcae8ada8f$export$2fc6338444a158e6.deprecatedWarning1 = false;
var $96f986fcae8ada8f$export$3d7865934588d77e = /* @__PURE__ */ ((EventType2)=>{
    EventType2[EventType2["start"] = 0] = "start";
    EventType2[EventType2["interrupt"] = 1] = "interrupt";
    EventType2[EventType2["end"] = 2] = "end";
    EventType2[EventType2["dispose"] = 3] = "dispose";
    EventType2[EventType2["complete"] = 4] = "complete";
    EventType2[EventType2["event"] = 5] = "event";
    return EventType2;
})($96f986fcae8ada8f$export$3d7865934588d77e || {});
class $96f986fcae8ada8f$export$31af0cf42be5a74d {
    start(entry) {}
    interrupt(entry) {}
    end(entry) {}
    dispose(entry) {}
    complete(entry) {}
    event(entry, event) {}
}


const $d7ff5e5c79580615$var$_AnimationStateData = class {
    constructor(skeletonData){
        this.animationToMixTime = {};
        this.defaultMix = 0;
        if (skeletonData == null) throw new Error("skeletonData cannot be null.");
        this.skeletonData = skeletonData;
    }
    setMix(fromName, toName, duration) {
        const from = this.skeletonData.findAnimation(fromName);
        if (from == null) throw new Error(`Animation not found: ${fromName}`);
        const to = this.skeletonData.findAnimation(toName);
        if (to == null) throw new Error(`Animation not found: ${toName}`);
        this.setMixWith(from, to, duration);
    }
    setMixByName(fromName, toName, duration) {
        if (!$d7ff5e5c79580615$var$_AnimationStateData.deprecatedWarning1) {
            $d7ff5e5c79580615$var$_AnimationStateData.deprecatedWarning1 = true;
            console.warn("Deprecation Warning: AnimationStateData.setMixByName is deprecated, please use setMix from now on.");
        }
        this.setMix(fromName, toName, duration);
    }
    setMixWith(from, to, duration) {
        if (from == null) throw new Error("from cannot be null.");
        if (to == null) throw new Error("to cannot be null.");
        const key = `${from.name}.${to.name}`;
        this.animationToMixTime[key] = duration;
    }
    getMix(from, to) {
        const key = `${from.name}.${to.name}`;
        const value = this.animationToMixTime[key];
        return value === void 0 ? this.defaultMix : value;
    }
};
let $d7ff5e5c79580615$export$90d7167cc0605975 = $d7ff5e5c79580615$var$_AnimationStateData;
$d7ff5e5c79580615$export$90d7167cc0605975.deprecatedWarning1 = false;









class $951b74e6d7b02e7a$export$2ff9add835475d95 {
    constructor(atlas){
        this.atlas = atlas;
    }
    /** @return May be null to not load an attachment. */ newRegionAttachment(skin, name, path) {
        const region = this.atlas.findRegion(path);
        if (region == null) throw new Error(`Region not found in atlas: ${path} (region attachment: ${name})`);
        const attachment = new (0, $33f8c953c70470fb$export$d0fc51466fa6d530)(name);
        attachment.region = region;
        return attachment;
    }
    /** @return May be null to not load an attachment. */ newMeshAttachment(skin, name, path) {
        const region = this.atlas.findRegion(path);
        if (region == null) throw new Error(`Region not found in atlas: ${path} (mesh attachment: ${name})`);
        const attachment = new (0, $72698e89a18058e1$export$3f1c1692adfcf3e2)(name);
        attachment.region = region;
        return attachment;
    }
    /** @return May be null to not load an attachment. */ newBoundingBoxAttachment(skin, name) {
        return new (0, $ae0315e0b7337cf8$export$9538c439c6b85ad2)(name);
    }
    /** @return May be null to not load an attachment */ newPathAttachment(skin, name) {
        return new (0, $ce5645df4e682fb4$export$d285e3ec07b32800)(name);
    }
    newPointAttachment(skin, name) {
        return new (0, $5ba7a9dafefb646c$export$1b528cde44a6ab5)(name);
    }
    newClippingAttachment(skin, name) {
        return new (0, $a1af353be281720a$export$838805e22b9b55f1)(name);
    }
}




class $e11d34c987b6465b$export$b127726e56765aa4 {
    /** @param parent May be null. */ constructor(data, skeleton, parent){
        // be careful! Spine b,c is c,b in pixi matrix
        this.matrix = new (0, $d7da222aa639cde0$export$5b12bf1653c0dd85)();
        this.children = new Array();
        this.x = 0;
        this.y = 0;
        this.rotation = 0;
        this.scaleX = 0;
        this.scaleY = 0;
        this.shearX = 0;
        this.shearY = 0;
        this.ax = 0;
        this.ay = 0;
        this.arotation = 0;
        this.ascaleX = 0;
        this.ascaleY = 0;
        this.ashearX = 0;
        this.ashearY = 0;
        this.appliedValid = false;
        this.sorted = false;
        this.active = false;
        if (data == null) throw new Error("data cannot be null.");
        if (skeleton == null) throw new Error("skeleton cannot be null.");
        this.data = data;
        this.skeleton = skeleton;
        this.parent = parent;
        this.setToSetupPose();
    }
    get worldX() {
        return this.matrix.tx;
    }
    get worldY() {
        return this.matrix.ty;
    }
    isActive() {
        return this.active;
    }
    /** Same as {@link #updateWorldTransform()}. This method exists for Bone to implement {@link Updatable}. */ update() {
        this.updateWorldTransformWith(this.x, this.y, this.rotation, this.scaleX, this.scaleY, this.shearX, this.shearY);
    }
    /** Computes the world transform using the parent bone and this bone's local transform. */ updateWorldTransform() {
        this.updateWorldTransformWith(this.x, this.y, this.rotation, this.scaleX, this.scaleY, this.shearX, this.shearY);
    }
    /** Computes the world transform using the parent bone and the specified local transform. */ updateWorldTransformWith(x, y, rotation, scaleX, scaleY, shearX, shearY) {
        this.ax = x;
        this.ay = y;
        this.arotation = rotation;
        this.ascaleX = scaleX;
        this.ascaleY = scaleY;
        this.ashearX = shearX;
        this.ashearY = shearY;
        this.appliedValid = true;
        const parent = this.parent;
        const m = this.matrix;
        const sx = this.skeleton.scaleX;
        const sy = (0, $1840f66876ded594$export$a5a6e0b888b2c992).yDown ? -this.skeleton.scaleY : this.skeleton.scaleY;
        if (parent == null) {
            const skeleton = this.skeleton;
            const rotationY = rotation + 90 + shearY;
            m.a = (0, $8804784813ffae81$export$6a7ef315a0d1ef07).cosDeg(rotation + shearX) * scaleX * sx;
            m.c = (0, $8804784813ffae81$export$6a7ef315a0d1ef07).cosDeg(rotationY) * scaleY * sx;
            m.b = (0, $8804784813ffae81$export$6a7ef315a0d1ef07).sinDeg(rotation + shearX) * scaleX * sy;
            m.d = (0, $8804784813ffae81$export$6a7ef315a0d1ef07).sinDeg(rotationY) * scaleY * sy;
            m.tx = x * sx + skeleton.x;
            m.ty = y * sy + skeleton.y;
            return;
        }
        let pa = parent.matrix.a;
        let pb = parent.matrix.c;
        let pc = parent.matrix.b;
        let pd = parent.matrix.d;
        m.tx = pa * x + pb * y + parent.matrix.tx;
        m.ty = pc * x + pd * y + parent.matrix.ty;
        switch(this.data.transformMode){
            case (0, $ccc5aebc60cbf024$export$4c408f82786a534d).Normal:
                {
                    const rotationY = rotation + 90 + shearY;
                    const la = (0, $8804784813ffae81$export$6a7ef315a0d1ef07).cosDeg(rotation + shearX) * scaleX;
                    const lb = (0, $8804784813ffae81$export$6a7ef315a0d1ef07).cosDeg(rotationY) * scaleY;
                    const lc = (0, $8804784813ffae81$export$6a7ef315a0d1ef07).sinDeg(rotation + shearX) * scaleX;
                    const ld = (0, $8804784813ffae81$export$6a7ef315a0d1ef07).sinDeg(rotationY) * scaleY;
                    m.a = pa * la + pb * lc;
                    m.c = pa * lb + pb * ld;
                    m.b = pc * la + pd * lc;
                    m.d = pc * lb + pd * ld;
                    return;
                }
            case (0, $ccc5aebc60cbf024$export$4c408f82786a534d).OnlyTranslation:
                {
                    const rotationY = rotation + 90 + shearY;
                    m.a = (0, $8804784813ffae81$export$6a7ef315a0d1ef07).cosDeg(rotation + shearX) * scaleX;
                    m.c = (0, $8804784813ffae81$export$6a7ef315a0d1ef07).cosDeg(rotationY) * scaleY;
                    m.b = (0, $8804784813ffae81$export$6a7ef315a0d1ef07).sinDeg(rotation + shearX) * scaleX;
                    m.d = (0, $8804784813ffae81$export$6a7ef315a0d1ef07).sinDeg(rotationY) * scaleY;
                    break;
                }
            case (0, $ccc5aebc60cbf024$export$4c408f82786a534d).NoRotationOrReflection:
                {
                    let s = pa * pa + pc * pc;
                    let prx = 0;
                    if (s > 1e-4) {
                        s = Math.abs(pa * pd - pb * pc) / s;
                        pa /= this.skeleton.scaleX;
                        pc /= this.skeleton.scaleY;
                        pb = pc * s;
                        pd = pa * s;
                        prx = Math.atan2(pc, pa) * (0, $8804784813ffae81$export$6a7ef315a0d1ef07).radDeg;
                    } else {
                        pa = 0;
                        pc = 0;
                        prx = 90 - Math.atan2(pd, pb) * (0, $8804784813ffae81$export$6a7ef315a0d1ef07).radDeg;
                    }
                    const rx = rotation + shearX - prx;
                    const ry = rotation + shearY - prx + 90;
                    const la = (0, $8804784813ffae81$export$6a7ef315a0d1ef07).cosDeg(rx) * scaleX;
                    const lb = (0, $8804784813ffae81$export$6a7ef315a0d1ef07).cosDeg(ry) * scaleY;
                    const lc = (0, $8804784813ffae81$export$6a7ef315a0d1ef07).sinDeg(rx) * scaleX;
                    const ld = (0, $8804784813ffae81$export$6a7ef315a0d1ef07).sinDeg(ry) * scaleY;
                    m.a = pa * la - pb * lc;
                    m.c = pa * lb - pb * ld;
                    m.b = pc * la + pd * lc;
                    m.d = pc * lb + pd * ld;
                    break;
                }
            case (0, $ccc5aebc60cbf024$export$4c408f82786a534d).NoScale:
            case (0, $ccc5aebc60cbf024$export$4c408f82786a534d).NoScaleOrReflection:
                {
                    const cos = (0, $8804784813ffae81$export$6a7ef315a0d1ef07).cosDeg(rotation);
                    const sin = (0, $8804784813ffae81$export$6a7ef315a0d1ef07).sinDeg(rotation);
                    let za = (pa * cos + pb * sin) / sx;
                    let zc = (pc * cos + pd * sin) / sy;
                    let s = Math.sqrt(za * za + zc * zc);
                    if (s > 1e-5) s = 1 / s;
                    za *= s;
                    zc *= s;
                    s = Math.sqrt(za * za + zc * zc);
                    if (this.data.transformMode == (0, $ccc5aebc60cbf024$export$4c408f82786a534d).NoScale && pa * pd - pb * pc < 0 != ((0, $1840f66876ded594$export$a5a6e0b888b2c992).yDown ? this.skeleton.scaleX < 0 != this.skeleton.scaleY > 0 : this.skeleton.scaleX < 0 != this.skeleton.scaleY < 0)) s = -s;
                    const r = Math.PI / 2 + Math.atan2(zc, za);
                    const zb = Math.cos(r) * s;
                    const zd = Math.sin(r) * s;
                    const la = (0, $8804784813ffae81$export$6a7ef315a0d1ef07).cosDeg(shearX) * scaleX;
                    const lb = (0, $8804784813ffae81$export$6a7ef315a0d1ef07).cosDeg(90 + shearY) * scaleY;
                    const lc = (0, $8804784813ffae81$export$6a7ef315a0d1ef07).sinDeg(shearX) * scaleX;
                    const ld = (0, $8804784813ffae81$export$6a7ef315a0d1ef07).sinDeg(90 + shearY) * scaleY;
                    m.a = za * la + zb * lc;
                    m.c = za * lb + zb * ld;
                    m.b = zc * la + zd * lc;
                    m.d = zc * lb + zd * ld;
                    break;
                }
        }
        m.a *= sx;
        m.c *= sx;
        m.b *= sy;
        m.d *= sy;
    }
    setToSetupPose() {
        const data = this.data;
        this.x = data.x;
        this.y = data.y;
        this.rotation = data.rotation;
        this.scaleX = data.scaleX;
        this.scaleY = data.scaleY;
        this.shearX = data.shearX;
        this.shearY = data.shearY;
    }
    getWorldRotationX() {
        return Math.atan2(this.matrix.b, this.matrix.a) * (0, $8804784813ffae81$export$6a7ef315a0d1ef07).radDeg;
    }
    getWorldRotationY() {
        return Math.atan2(this.matrix.d, this.matrix.c) * (0, $8804784813ffae81$export$6a7ef315a0d1ef07).radDeg;
    }
    getWorldScaleX() {
        const m = this.matrix;
        return Math.sqrt(m.a * m.a + m.c * m.c);
    }
    getWorldScaleY() {
        const m = this.matrix;
        return Math.sqrt(m.b * m.b + m.d * m.d);
    }
    /** Computes the individual applied transform values from the world transform. This can be useful to perform processing using
   * the applied transform after the world transform has been modified directly (eg, by a constraint).
   * <p>
   * Some information is ambiguous in the world transform, such as -1,-1 scale versus 180 rotation. */ updateAppliedTransform() {
        this.appliedValid = true;
        const parent = this.parent;
        const m = this.matrix;
        if (parent == null) {
            this.ax = m.tx;
            this.ay = m.ty;
            this.arotation = Math.atan2(m.b, m.a) * (0, $8804784813ffae81$export$6a7ef315a0d1ef07).radDeg;
            this.ascaleX = Math.sqrt(m.a * m.a + m.b * m.b);
            this.ascaleY = Math.sqrt(m.c * m.c + m.d * m.d);
            this.ashearX = 0;
            this.ashearY = Math.atan2(m.a * m.c + m.b * m.d, m.a * m.d - m.b * m.c) * (0, $8804784813ffae81$export$6a7ef315a0d1ef07).radDeg;
            return;
        }
        const pm = parent.matrix;
        const pid = 1 / (pm.a * pm.d - pm.b * pm.c);
        const dx = m.tx - pm.tx;
        const dy = m.ty - pm.ty;
        this.ax = dx * pm.d * pid - dy * pm.c * pid;
        this.ay = dy * pm.a * pid - dx * pm.b * pid;
        const ia = pid * pm.d;
        const id = pid * pm.a;
        const ib = pid * pm.c;
        const ic = pid * pm.b;
        const ra = ia * m.a - ib * m.b;
        const rb = ia * m.c - ib * m.d;
        const rc = id * m.b - ic * m.a;
        const rd = id * m.d - ic * m.c;
        this.ashearX = 0;
        this.ascaleX = Math.sqrt(ra * ra + rc * rc);
        if (this.ascaleX > 1e-4) {
            const det = ra * rd - rb * rc;
            this.ascaleY = det / this.ascaleX;
            this.ashearY = Math.atan2(ra * rb + rc * rd, det) * (0, $8804784813ffae81$export$6a7ef315a0d1ef07).radDeg;
            this.arotation = Math.atan2(rc, ra) * (0, $8804784813ffae81$export$6a7ef315a0d1ef07).radDeg;
        } else {
            this.ascaleX = 0;
            this.ascaleY = Math.sqrt(rb * rb + rd * rd);
            this.ashearY = 0;
            this.arotation = 90 - Math.atan2(rd, rb) * (0, $8804784813ffae81$export$6a7ef315a0d1ef07).radDeg;
        }
    }
    worldToLocal(world) {
        const m = this.matrix;
        const a = m.a;
        const b = m.c;
        const c = m.b;
        const d = m.d;
        const invDet = 1 / (a * d - b * c);
        const x = world.x - m.tx;
        const y = world.y - m.ty;
        world.x = x * d * invDet - y * b * invDet;
        world.y = y * a * invDet - x * c * invDet;
        return world;
    }
    localToWorld(local) {
        const m = this.matrix;
        const x = local.x;
        const y = local.y;
        local.x = x * m.a + y * m.c + m.tx;
        local.y = x * m.b + y * m.d + m.ty;
        return local;
    }
    worldToLocalRotation(worldRotation) {
        const sin = (0, $8804784813ffae81$export$6a7ef315a0d1ef07).sinDeg(worldRotation);
        const cos = (0, $8804784813ffae81$export$6a7ef315a0d1ef07).cosDeg(worldRotation);
        const mat = this.matrix;
        return Math.atan2(mat.a * sin - mat.b * cos, mat.d * cos - mat.c * sin) * (0, $8804784813ffae81$export$6a7ef315a0d1ef07).radDeg;
    }
    localToWorldRotation(localRotation) {
        const sin = (0, $8804784813ffae81$export$6a7ef315a0d1ef07).sinDeg(localRotation);
        const cos = (0, $8804784813ffae81$export$6a7ef315a0d1ef07).cosDeg(localRotation);
        const mat = this.matrix;
        return Math.atan2(cos * mat.b + sin * mat.d, cos * mat.a + sin * mat.c) * (0, $8804784813ffae81$export$6a7ef315a0d1ef07).radDeg;
    }
    rotateWorld(degrees) {
        const mat = this.matrix;
        const a = mat.a;
        const b = mat.c;
        const c = mat.b;
        const d = mat.d;
        const cos = (0, $8804784813ffae81$export$6a7ef315a0d1ef07).cosDeg(degrees);
        const sin = (0, $8804784813ffae81$export$6a7ef315a0d1ef07).sinDeg(degrees);
        mat.a = cos * a - sin * c;
        mat.c = cos * b - sin * d;
        mat.b = sin * a + cos * c;
        mat.d = sin * b + cos * d;
        this.appliedValid = false;
    }
}



class $53352ede0f332990$export$7d85d96cf093e12f {
    constructor(index, name, parent){
        this.x = 0;
        this.y = 0;
        this.rotation = 0;
        this.scaleX = 1;
        this.scaleY = 1;
        this.shearX = 0;
        this.shearY = 0;
        this.transformMode = (0, $ccc5aebc60cbf024$export$4c408f82786a534d).Normal;
        this.skinRequired = false;
        this.color = new (0, $8804784813ffae81$export$892596cec99bc70e)();
        if (index < 0) throw new Error("index must be >= 0.");
        if (name == null) throw new Error("name cannot be null.");
        this.index = index;
        this.name = name;
        this.parent = parent;
    }
}


class $9feaa1f370017dae$export$b826e1ab3af63566 {
    constructor(name, order, skinRequired){
        this.name = name;
        this.order = order;
        this.skinRequired = skinRequired;
    }
}


class $9457b24b76fdec68$export$d61e24a684f9e51 {
    constructor(time, data){
        if (data == null) throw new Error("data cannot be null.");
        this.time = time;
        this.data = data;
    }
}


class $6449a1e1fcf4967a$export$a5cf049e34c3d11e {
    constructor(name){
        this.name = name;
    }
}



class $bcf6acc583d42db0$export$3c158c80ff28c177 {
    constructor(data, skeleton){
        this.bendDirection = 0;
        this.compress = false;
        this.stretch = false;
        this.mix = 1;
        this.softness = 0;
        this.active = false;
        if (data == null) throw new Error("data cannot be null.");
        if (skeleton == null) throw new Error("skeleton cannot be null.");
        this.data = data;
        this.mix = data.mix;
        this.softness = data.softness;
        this.bendDirection = data.bendDirection;
        this.compress = data.compress;
        this.stretch = data.stretch;
        this.bones = new Array();
        for(let i = 0; i < data.bones.length; i++)this.bones.push(skeleton.findBone(data.bones[i].name));
        this.target = skeleton.findBone(data.target.name);
    }
    isActive() {
        return this.active;
    }
    apply() {
        this.update();
    }
    update() {
        const target = this.target;
        const bones = this.bones;
        switch(bones.length){
            case 1:
                this.apply1(bones[0], target.worldX, target.worldY, this.compress, this.stretch, this.data.uniform, this.mix);
                break;
            case 2:
                this.apply2(bones[0], bones[1], target.worldX, target.worldY, this.bendDirection, this.stretch, this.softness, this.mix);
                break;
        }
    }
    /** Adjusts the bone rotation so the tip is as close to the target position as possible. The target is specified in the world
   * coordinate system. */ apply1(bone, targetX, targetY, compress, stretch, uniform, alpha) {
        if (!bone.appliedValid) bone.updateAppliedTransform();
        const p = bone.parent.matrix;
        const pa = p.a;
        let pb = p.c;
        const pc = p.b;
        let pd = p.d;
        let rotationIK = -bone.ashearX - bone.arotation;
        let tx = 0;
        let ty = 0;
        switch(bone.data.transformMode){
            case (0, $ccc5aebc60cbf024$export$4c408f82786a534d).OnlyTranslation:
                tx = targetX - bone.worldX;
                ty = targetY - bone.worldY;
                break;
            case (0, $ccc5aebc60cbf024$export$4c408f82786a534d).NoRotationOrReflection:
                const s = Math.abs(pa * pd - pb * pc) / (pa * pa + pc * pc);
                const sa = pa / bone.skeleton.scaleX;
                const sc = pc / bone.skeleton.scaleY;
                pb = -sc * s * bone.skeleton.scaleX;
                pd = sa * s * bone.skeleton.scaleY;
                rotationIK += Math.atan2(sc, sa) * (0, $8804784813ffae81$export$6a7ef315a0d1ef07).radDeg;
            default:
                const x = targetX - p.tx;
                const y = targetY - p.ty;
                const d = pa * pd - pb * pc;
                tx = (x * pd - y * pb) / d - bone.ax;
                ty = (y * pa - x * pc) / d - bone.ay;
        }
        rotationIK += Math.atan2(ty, tx) * (0, $8804784813ffae81$export$6a7ef315a0d1ef07).radDeg;
        if (bone.ascaleX < 0) rotationIK += 180;
        if (rotationIK > 180) rotationIK -= 360;
        else if (rotationIK < -180) rotationIK += 360;
        let sx = bone.ascaleX;
        let sy = bone.ascaleY;
        if (compress || stretch) {
            switch(bone.data.transformMode){
                case (0, $ccc5aebc60cbf024$export$4c408f82786a534d).NoScale:
                case (0, $ccc5aebc60cbf024$export$4c408f82786a534d).NoScaleOrReflection:
                    tx = targetX - bone.worldX;
                    ty = targetY - bone.worldY;
            }
            const b = bone.data.length * sx;
            const dd = Math.sqrt(tx * tx + ty * ty);
            if (compress && dd < b || stretch && dd > b && b > 1e-4) {
                const s = (dd / b - 1) * alpha + 1;
                sx *= s;
                if (uniform) sy *= s;
            }
        }
        bone.updateWorldTransformWith(bone.ax, bone.ay, bone.arotation + rotationIK * alpha, sx, sy, bone.ashearX, bone.ashearY);
    }
    /** Adjusts the parent and child bone rotations so the tip of the child is as close to the target position as possible. The
   * target is specified in the world coordinate system.
   * @param child A direct descendant of the parent bone. */ apply2(parent, child, targetX, targetY, bendDir, stretch, softness, alpha) {
        if (alpha == 0) {
            child.updateWorldTransform();
            return;
        }
        if (!parent.appliedValid) parent.updateAppliedTransform();
        if (!child.appliedValid) child.updateAppliedTransform();
        const px = parent.ax;
        const py = parent.ay;
        let psx = parent.ascaleX;
        let sx = psx;
        let psy = parent.ascaleY;
        let csx = child.ascaleX;
        const pmat = parent.matrix;
        let os1 = 0;
        let os2 = 0;
        let s2 = 0;
        if (psx < 0) {
            psx = -psx;
            os1 = 180;
            s2 = -1;
        } else {
            os1 = 0;
            s2 = 1;
        }
        if (psy < 0) {
            psy = -psy;
            s2 = -s2;
        }
        if (csx < 0) {
            csx = -csx;
            os2 = 180;
        } else os2 = 0;
        const cx = child.ax;
        let cy = 0;
        let cwx = 0;
        let cwy = 0;
        let a = pmat.a;
        let b = pmat.c;
        let c = pmat.b;
        let d = pmat.d;
        const u = Math.abs(psx - psy) <= 1e-4;
        if (!u) {
            cy = 0;
            cwx = a * cx + pmat.tx;
            cwy = c * cx + pmat.ty;
        } else {
            cy = child.ay;
            cwx = a * cx + b * cy + pmat.tx;
            cwy = c * cx + d * cy + pmat.ty;
        }
        const pp = parent.parent.matrix;
        a = pp.a;
        b = pp.c;
        c = pp.b;
        d = pp.d;
        const id = 1 / (a * d - b * c);
        let x = cwx - pp.tx;
        let y = cwy - pp.ty;
        const dx = (x * d - y * b) * id - px;
        const dy = (y * a - x * c) * id - py;
        const l1 = Math.sqrt(dx * dx + dy * dy);
        let l2 = child.data.length * csx;
        let a1;
        let a2;
        if (l1 < 1e-4) {
            this.apply1(parent, targetX, targetY, false, stretch, false, alpha);
            child.updateWorldTransformWith(cx, cy, 0, child.ascaleX, child.ascaleY, child.ashearX, child.ashearY);
            return;
        }
        x = targetX - pp.tx;
        y = targetY - pp.ty;
        let tx = (x * d - y * b) * id - px;
        let ty = (y * a - x * c) * id - py;
        let dd = tx * tx + ty * ty;
        if (softness != 0) {
            softness *= psx * (csx + 1) / 2;
            const td = Math.sqrt(dd);
            const sd = td - l1 - l2 * psx + softness;
            if (sd > 0) {
                let p = Math.min(1, sd / (softness * 2)) - 1;
                p = (sd - softness * (1 - p * p)) / td;
                tx -= p * tx;
                ty -= p * ty;
                dd = tx * tx + ty * ty;
            }
        }
        outer: if (u) {
            l2 *= psx;
            let cos = (dd - l1 * l1 - l2 * l2) / (2 * l1 * l2);
            if (cos < -1) cos = -1;
            else if (cos > 1) {
                cos = 1;
                if (stretch) sx *= (Math.sqrt(dd) / (l1 + l2) - 1) * alpha + 1;
            }
            a2 = Math.acos(cos) * bendDir;
            a = l1 + l2 * cos;
            b = l2 * Math.sin(a2);
            a1 = Math.atan2(ty * a - tx * b, tx * a + ty * b);
        } else {
            a = psx * l2;
            b = psy * l2;
            const aa = a * a;
            const bb = b * b;
            const ta = Math.atan2(ty, tx);
            c = bb * l1 * l1 + aa * dd - aa * bb;
            const c1 = -2 * bb * l1;
            const c2 = bb - aa;
            d = c1 * c1 - 4 * c2 * c;
            if (d >= 0) {
                let q = Math.sqrt(d);
                if (c1 < 0) q = -q;
                q = -(c1 + q) / 2;
                const r0 = q / c2;
                const r1 = c / q;
                const r = Math.abs(r0) < Math.abs(r1) ? r0 : r1;
                if (r * r <= dd) {
                    y = Math.sqrt(dd - r * r) * bendDir;
                    a1 = ta - Math.atan2(y, r);
                    a2 = Math.atan2(y / psy, (r - l1) / psx);
                    break outer;
                }
            }
            let minAngle = (0, $8804784813ffae81$export$6a7ef315a0d1ef07).PI;
            let minX = l1 - a;
            let minDist = minX * minX;
            let minY = 0;
            let maxAngle = 0;
            let maxX = l1 + a;
            let maxDist = maxX * maxX;
            let maxY = 0;
            c = -a * l1 / (aa - bb);
            if (c >= -1 && c <= 1) {
                c = Math.acos(c);
                x = a * Math.cos(c) + l1;
                y = b * Math.sin(c);
                d = x * x + y * y;
                if (d < minDist) {
                    minAngle = c;
                    minDist = d;
                    minX = x;
                    minY = y;
                }
                if (d > maxDist) {
                    maxAngle = c;
                    maxDist = d;
                    maxX = x;
                    maxY = y;
                }
            }
            if (dd <= (minDist + maxDist) / 2) {
                a1 = ta - Math.atan2(minY * bendDir, minX);
                a2 = minAngle * bendDir;
            } else {
                a1 = ta - Math.atan2(maxY * bendDir, maxX);
                a2 = maxAngle * bendDir;
            }
        }
        const os = Math.atan2(cy, cx) * s2;
        let rotation = parent.arotation;
        a1 = (a1 - os) * (0, $8804784813ffae81$export$6a7ef315a0d1ef07).radDeg + os1 - rotation;
        if (a1 > 180) a1 -= 360;
        else if (a1 < -180) a1 += 360;
        parent.updateWorldTransformWith(px, py, rotation + a1 * alpha, sx, parent.ascaleY, 0, 0);
        rotation = child.arotation;
        a2 = ((a2 + os) * (0, $8804784813ffae81$export$6a7ef315a0d1ef07).radDeg - child.ashearX) * s2 + os2 - rotation;
        if (a2 > 180) a2 -= 360;
        else if (a2 < -180) a2 += 360;
        child.updateWorldTransformWith(cx, cy, rotation + a2 * alpha, child.ascaleX, child.ascaleY, child.ashearX, child.ashearY);
    }
}



class $c7dead7a06471124$export$adcb08b651fc712e extends (0, $9feaa1f370017dae$export$b826e1ab3af63566) {
    constructor(name){
        super(name, 0, false);
        this.bones = new Array();
        this.bendDirection = 1;
        this.compress = false;
        this.stretch = false;
        this.uniform = false;
        this.mix = 1;
        this.softness = 0;
    }
}







class $f3db500d9e578f13$export$d2629ab80d5dd5ba extends (0, $9feaa1f370017dae$export$b826e1ab3af63566) {
    constructor(name){
        super(name, 0, false);
        this.bones = new Array();
    }
}
var $f3db500d9e578f13$export$34ce760ad2b0be4b = /* @__PURE__ */ ((SpacingMode2)=>{
    SpacingMode2[SpacingMode2["Length"] = 0] = "Length";
    SpacingMode2[SpacingMode2["Fixed"] = 1] = "Fixed";
    SpacingMode2[SpacingMode2["Percent"] = 2] = "Percent";
    return SpacingMode2;
})($f3db500d9e578f13$export$34ce760ad2b0be4b || {});


const $6362190055f451a7$var$_PathConstraint = class {
    constructor(data, skeleton){
        this.position = 0;
        this.spacing = 0;
        this.rotateMix = 0;
        this.translateMix = 0;
        this.spaces = new Array();
        this.positions = new Array();
        this.world = new Array();
        this.curves = new Array();
        this.lengths = new Array();
        this.segments = new Array();
        this.active = false;
        if (data == null) throw new Error("data cannot be null.");
        if (skeleton == null) throw new Error("skeleton cannot be null.");
        this.data = data;
        this.bones = new Array();
        for(let i = 0, n = data.bones.length; i < n; i++)this.bones.push(skeleton.findBone(data.bones[i].name));
        this.target = skeleton.findSlot(data.target.name);
        this.position = data.position;
        this.spacing = data.spacing;
        this.rotateMix = data.rotateMix;
        this.translateMix = data.translateMix;
    }
    isActive() {
        return this.active;
    }
    apply() {
        this.update();
    }
    update() {
        const attachment = this.target.getAttachment();
        if (!(attachment instanceof (0, $ce5645df4e682fb4$export$d285e3ec07b32800))) return;
        const rotateMix = this.rotateMix;
        const translateMix = this.translateMix;
        const translate = translateMix > 0;
        const rotate = rotateMix > 0;
        if (!translate && !rotate) return;
        const data = this.data;
        const spacingMode = data.spacingMode;
        const lengthSpacing = spacingMode == (0, $f3db500d9e578f13$export$34ce760ad2b0be4b).Length;
        const rotateMode = data.rotateMode;
        const tangents = rotateMode == (0, $2c8db927dc4fcff5$export$a2a23846581ac82c).Tangent;
        const scale = rotateMode == (0, $2c8db927dc4fcff5$export$a2a23846581ac82c).ChainScale;
        const boneCount = this.bones.length;
        const spacesCount = tangents ? boneCount : boneCount + 1;
        const bones = this.bones;
        const spaces = (0, $8804784813ffae81$export$d2ca453b913dcdea).setArraySize(this.spaces, spacesCount);
        let lengths = null;
        const spacing = this.spacing;
        if (scale || lengthSpacing) {
            if (scale) lengths = (0, $8804784813ffae81$export$d2ca453b913dcdea).setArraySize(this.lengths, boneCount);
            for(let i = 0, n = spacesCount - 1; i < n;){
                const bone = bones[i];
                const setupLength = bone.data.length;
                if (setupLength < $6362190055f451a7$var$_PathConstraint.epsilon) {
                    if (scale) lengths[i] = 0;
                    spaces[++i] = 0;
                } else {
                    const x = setupLength * bone.matrix.a;
                    const y = setupLength * bone.matrix.b;
                    const length = Math.sqrt(x * x + y * y);
                    if (scale) lengths[i] = length;
                    spaces[++i] = (lengthSpacing ? setupLength + spacing : spacing) * length / setupLength;
                }
            }
        } else for(let i = 1; i < spacesCount; i++)spaces[i] = spacing;
        const positions = this.computeWorldPositions(attachment, spacesCount, tangents, data.positionMode == (0, $2c8db927dc4fcff5$export$34d637c671e1e906).Percent, spacingMode == (0, $f3db500d9e578f13$export$34ce760ad2b0be4b).Percent);
        let boneX = positions[0];
        let boneY = positions[1];
        let offsetRotation = data.offsetRotation;
        let tip = false;
        if (offsetRotation == 0) tip = rotateMode == (0, $2c8db927dc4fcff5$export$a2a23846581ac82c).Chain;
        else {
            tip = false;
            const p = this.target.bone.matrix;
            offsetRotation *= p.a * p.d - p.b * p.c > 0 ? (0, $8804784813ffae81$export$6a7ef315a0d1ef07).degRad : -(0, $8804784813ffae81$export$6a7ef315a0d1ef07).degRad;
        }
        for(let i = 0, p = 3; i < boneCount; i++, p += 3){
            const bone = bones[i];
            const mat = bone.matrix;
            mat.tx += (boneX - mat.tx) * translateMix;
            mat.ty += (boneY - mat.ty) * translateMix;
            const x = positions[p];
            const y = positions[p + 1];
            const dx = x - boneX;
            const dy = y - boneY;
            if (scale) {
                const length = lengths[i];
                if (length != 0) {
                    const s = (Math.sqrt(dx * dx + dy * dy) / length - 1) * rotateMix + 1;
                    mat.a *= s;
                    mat.b *= s;
                }
            }
            boneX = x;
            boneY = y;
            if (rotate) {
                const a = mat.a;
                const b = mat.c;
                const c = mat.b;
                const d = mat.d;
                let r = 0;
                let cos = 0;
                let sin = 0;
                if (tangents) {
                    if (tangents) r = positions[p - 1];
                    else if (spaces[i + 1] == 0) r = positions[p + 2];
                    else r = Math.atan2(dy, dx);
                }
                r -= Math.atan2(c, a);
                if (tip) {
                    cos = Math.cos(r);
                    sin = Math.sin(r);
                    const length = bone.data.length;
                    boneX += (length * (cos * a - sin * c) - dx) * rotateMix;
                    boneY += (length * (sin * a + cos * c) - dy) * rotateMix;
                } else r += offsetRotation;
                if (r > (0, $8804784813ffae81$export$6a7ef315a0d1ef07).PI) r -= (0, $8804784813ffae81$export$6a7ef315a0d1ef07).PI2;
                else if (r < -(0, $8804784813ffae81$export$6a7ef315a0d1ef07).PI) r += (0, $8804784813ffae81$export$6a7ef315a0d1ef07).PI2;
                r *= rotateMix;
                cos = Math.cos(r);
                sin = Math.sin(r);
                mat.a = cos * a - sin * c;
                mat.c = cos * b - sin * d;
                mat.b = sin * a + cos * c;
                mat.d = sin * b + cos * d;
            }
            bone.appliedValid = false;
        }
    }
    computeWorldPositions(path, spacesCount, tangents, percentPosition, percentSpacing) {
        const target = this.target;
        let position = this.position;
        const spaces = this.spaces;
        const out = (0, $8804784813ffae81$export$d2ca453b913dcdea).setArraySize(this.positions, spacesCount * 3 + 2);
        let world = null;
        const closed = path.closed;
        let verticesLength = path.worldVerticesLength;
        let curveCount = verticesLength / 6;
        let prevCurve = $6362190055f451a7$var$_PathConstraint.NONE;
        if (!path.constantSpeed) {
            const lengths = path.lengths;
            curveCount -= closed ? 1 : 2;
            const pathLength2 = lengths[curveCount];
            if (percentPosition) position *= pathLength2;
            if (percentSpacing) for(let i = 0; i < spacesCount; i++)spaces[i] *= pathLength2;
            world = (0, $8804784813ffae81$export$d2ca453b913dcdea).setArraySize(this.world, 8);
            for(let i = 0, o = 0, curve = 0; i < spacesCount; i++, o += 3){
                const space = spaces[i];
                position += space;
                let p = position;
                if (closed) {
                    p %= pathLength2;
                    if (p < 0) p += pathLength2;
                    curve = 0;
                } else if (p < 0) {
                    if (prevCurve != $6362190055f451a7$var$_PathConstraint.BEFORE) {
                        prevCurve = $6362190055f451a7$var$_PathConstraint.BEFORE;
                        path.computeWorldVertices(target, 2, 4, world, 0, 2);
                    }
                    this.addBeforePosition(p, world, 0, out, o);
                    continue;
                } else if (p > pathLength2) {
                    if (prevCurve != $6362190055f451a7$var$_PathConstraint.AFTER) {
                        prevCurve = $6362190055f451a7$var$_PathConstraint.AFTER;
                        path.computeWorldVertices(target, verticesLength - 6, 4, world, 0, 2);
                    }
                    this.addAfterPosition(p - pathLength2, world, 0, out, o);
                    continue;
                }
                for(;; curve++){
                    const length = lengths[curve];
                    if (p > length) continue;
                    if (curve == 0) p /= length;
                    else {
                        const prev = lengths[curve - 1];
                        p = (p - prev) / (length - prev);
                    }
                    break;
                }
                if (curve != prevCurve) {
                    prevCurve = curve;
                    if (closed && curve == curveCount) {
                        path.computeWorldVertices(target, verticesLength - 4, 4, world, 0, 2);
                        path.computeWorldVertices(target, 0, 4, world, 4, 2);
                    } else path.computeWorldVertices(target, curve * 6 + 2, 8, world, 0, 2);
                }
                this.addCurvePosition(p, world[0], world[1], world[2], world[3], world[4], world[5], world[6], world[7], out, o, tangents || i > 0 && space == 0);
            }
            return out;
        }
        if (closed) {
            verticesLength += 2;
            world = (0, $8804784813ffae81$export$d2ca453b913dcdea).setArraySize(this.world, verticesLength);
            path.computeWorldVertices(target, 2, verticesLength - 4, world, 0, 2);
            path.computeWorldVertices(target, 0, 2, world, verticesLength - 4, 2);
            world[verticesLength - 2] = world[0];
            world[verticesLength - 1] = world[1];
        } else {
            curveCount--;
            verticesLength -= 4;
            world = (0, $8804784813ffae81$export$d2ca453b913dcdea).setArraySize(this.world, verticesLength);
            path.computeWorldVertices(target, 2, verticesLength, world, 0, 2);
        }
        const curves = (0, $8804784813ffae81$export$d2ca453b913dcdea).setArraySize(this.curves, curveCount);
        let pathLength = 0;
        let x1 = world[0];
        let y1 = world[1];
        let cx1 = 0;
        let cy1 = 0;
        let cx2 = 0;
        let cy2 = 0;
        let x2 = 0;
        let y2 = 0;
        let tmpx = 0;
        let tmpy = 0;
        let dddfx = 0;
        let dddfy = 0;
        let ddfx = 0;
        let ddfy = 0;
        let dfx = 0;
        let dfy = 0;
        for(let i = 0, w = 2; i < curveCount; i++, w += 6){
            cx1 = world[w];
            cy1 = world[w + 1];
            cx2 = world[w + 2];
            cy2 = world[w + 3];
            x2 = world[w + 4];
            y2 = world[w + 5];
            tmpx = (x1 - cx1 * 2 + cx2) * 0.1875;
            tmpy = (y1 - cy1 * 2 + cy2) * 0.1875;
            dddfx = ((cx1 - cx2) * 3 - x1 + x2) * 0.09375;
            dddfy = ((cy1 - cy2) * 3 - y1 + y2) * 0.09375;
            ddfx = tmpx * 2 + dddfx;
            ddfy = tmpy * 2 + dddfy;
            dfx = (cx1 - x1) * 0.75 + tmpx + dddfx * 0.16666667;
            dfy = (cy1 - y1) * 0.75 + tmpy + dddfy * 0.16666667;
            pathLength += Math.sqrt(dfx * dfx + dfy * dfy);
            dfx += ddfx;
            dfy += ddfy;
            ddfx += dddfx;
            ddfy += dddfy;
            pathLength += Math.sqrt(dfx * dfx + dfy * dfy);
            dfx += ddfx;
            dfy += ddfy;
            pathLength += Math.sqrt(dfx * dfx + dfy * dfy);
            dfx += ddfx + dddfx;
            dfy += ddfy + dddfy;
            pathLength += Math.sqrt(dfx * dfx + dfy * dfy);
            curves[i] = pathLength;
            x1 = x2;
            y1 = y2;
        }
        if (percentPosition) position *= pathLength;
        if (percentSpacing) for(let i = 0; i < spacesCount; i++)spaces[i] *= pathLength;
        const segments = this.segments;
        let curveLength = 0;
        for(let i = 0, o = 0, curve = 0, segment = 0; i < spacesCount; i++, o += 3){
            const space = spaces[i];
            position += space;
            let p = position;
            if (closed) {
                p %= pathLength;
                if (p < 0) p += pathLength;
                curve = 0;
            } else if (p < 0) {
                this.addBeforePosition(p, world, 0, out, o);
                continue;
            } else if (p > pathLength) {
                this.addAfterPosition(p - pathLength, world, verticesLength - 4, out, o);
                continue;
            }
            for(;; curve++){
                const length = curves[curve];
                if (p > length) continue;
                if (curve == 0) p /= length;
                else {
                    const prev = curves[curve - 1];
                    p = (p - prev) / (length - prev);
                }
                break;
            }
            if (curve != prevCurve) {
                prevCurve = curve;
                let ii = curve * 6;
                x1 = world[ii];
                y1 = world[ii + 1];
                cx1 = world[ii + 2];
                cy1 = world[ii + 3];
                cx2 = world[ii + 4];
                cy2 = world[ii + 5];
                x2 = world[ii + 6];
                y2 = world[ii + 7];
                tmpx = (x1 - cx1 * 2 + cx2) * 0.03;
                tmpy = (y1 - cy1 * 2 + cy2) * 0.03;
                dddfx = ((cx1 - cx2) * 3 - x1 + x2) * 6e-3;
                dddfy = ((cy1 - cy2) * 3 - y1 + y2) * 6e-3;
                ddfx = tmpx * 2 + dddfx;
                ddfy = tmpy * 2 + dddfy;
                dfx = (cx1 - x1) * 0.3 + tmpx + dddfx * 0.16666667;
                dfy = (cy1 - y1) * 0.3 + tmpy + dddfy * 0.16666667;
                curveLength = Math.sqrt(dfx * dfx + dfy * dfy);
                segments[0] = curveLength;
                for(ii = 1; ii < 8; ii++){
                    dfx += ddfx;
                    dfy += ddfy;
                    ddfx += dddfx;
                    ddfy += dddfy;
                    curveLength += Math.sqrt(dfx * dfx + dfy * dfy);
                    segments[ii] = curveLength;
                }
                dfx += ddfx;
                dfy += ddfy;
                curveLength += Math.sqrt(dfx * dfx + dfy * dfy);
                segments[8] = curveLength;
                dfx += ddfx + dddfx;
                dfy += ddfy + dddfy;
                curveLength += Math.sqrt(dfx * dfx + dfy * dfy);
                segments[9] = curveLength;
                segment = 0;
            }
            p *= curveLength;
            for(;; segment++){
                const length = segments[segment];
                if (p > length) continue;
                if (segment == 0) p /= length;
                else {
                    const prev = segments[segment - 1];
                    p = segment + (p - prev) / (length - prev);
                }
                break;
            }
            this.addCurvePosition(p * 0.1, x1, y1, cx1, cy1, cx2, cy2, x2, y2, out, o, tangents || i > 0 && space == 0);
        }
        return out;
    }
    addBeforePosition(p, temp, i, out, o) {
        const x1 = temp[i];
        const y1 = temp[i + 1];
        const dx = temp[i + 2] - x1;
        const dy = temp[i + 3] - y1;
        const r = Math.atan2(dy, dx);
        out[o] = x1 + p * Math.cos(r);
        out[o + 1] = y1 + p * Math.sin(r);
        out[o + 2] = r;
    }
    addAfterPosition(p, temp, i, out, o) {
        const x1 = temp[i + 2];
        const y1 = temp[i + 3];
        const dx = x1 - temp[i];
        const dy = y1 - temp[i + 1];
        const r = Math.atan2(dy, dx);
        out[o] = x1 + p * Math.cos(r);
        out[o + 1] = y1 + p * Math.sin(r);
        out[o + 2] = r;
    }
    addCurvePosition(p, x1, y1, cx1, cy1, cx2, cy2, x2, y2, out, o, tangents) {
        if (p == 0 || isNaN(p)) p = 1e-4;
        const tt = p * p;
        const ttt = tt * p;
        const u = 1 - p;
        const uu = u * u;
        const uuu = uu * u;
        const ut = u * p;
        const ut3 = ut * 3;
        const uut3 = u * ut3;
        const utt3 = ut3 * p;
        const x = x1 * uuu + cx1 * uut3 + cx2 * utt3 + x2 * ttt;
        const y = y1 * uuu + cy1 * uut3 + cy2 * utt3 + y2 * ttt;
        out[o] = x;
        out[o + 1] = y;
        if (tangents) out[o + 2] = Math.atan2(y - (y1 * uu + cy1 * ut * 2 + cy2 * tt), x - (x1 * uu + cx1 * ut * 2 + cx2 * tt));
    }
};
let $6362190055f451a7$export$cb4f92fb0c018828 = $6362190055f451a7$var$_PathConstraint;
$6362190055f451a7$export$cb4f92fb0c018828.NONE = -1;
$6362190055f451a7$export$cb4f92fb0c018828.BEFORE = -2;
$6362190055f451a7$export$cb4f92fb0c018828.AFTER = -3;
$6362190055f451a7$export$cb4f92fb0c018828.epsilon = 1e-5;












class $9c06c865703471d6$export$a2d8268faabf5c52 {
    constructor(data, skeleton){
        this.rotateMix = 0;
        this.translateMix = 0;
        this.scaleMix = 0;
        this.shearMix = 0;
        this.temp = new (0, $8804784813ffae81$export$c977b3e384af9ae1)();
        this.active = false;
        if (data == null) throw new Error("data cannot be null.");
        if (skeleton == null) throw new Error("skeleton cannot be null.");
        this.data = data;
        this.rotateMix = data.rotateMix;
        this.translateMix = data.translateMix;
        this.scaleMix = data.scaleMix;
        this.shearMix = data.shearMix;
        this.bones = new Array();
        for(let i = 0; i < data.bones.length; i++)this.bones.push(skeleton.findBone(data.bones[i].name));
        this.target = skeleton.findBone(data.target.name);
    }
    isActive() {
        return this.active;
    }
    apply() {
        this.update();
    }
    update() {
        if (this.data.local) {
            if (this.data.relative) this.applyRelativeLocal();
            else this.applyAbsoluteLocal();
        } else if (this.data.relative) this.applyRelativeWorld();
        else this.applyAbsoluteWorld();
    }
    applyAbsoluteWorld() {
        const rotateMix = this.rotateMix;
        const translateMix = this.translateMix;
        const scaleMix = this.scaleMix;
        const shearMix = this.shearMix;
        const target = this.target;
        const targetMat = target.matrix;
        const ta = targetMat.a;
        const tb = targetMat.c;
        const tc = targetMat.b;
        const td = targetMat.d;
        const degRadReflect = ta * td - tb * tc > 0 ? (0, $8804784813ffae81$export$6a7ef315a0d1ef07).degRad : -(0, $8804784813ffae81$export$6a7ef315a0d1ef07).degRad;
        const offsetRotation = this.data.offsetRotation * degRadReflect;
        const offsetShearY = this.data.offsetShearY * degRadReflect;
        const bones = this.bones;
        for(let i = 0, n = bones.length; i < n; i++){
            const bone = bones[i];
            let modified = false;
            const mat = bone.matrix;
            if (rotateMix != 0) {
                const a = mat.a;
                const b = mat.c;
                const c = mat.b;
                const d = mat.d;
                let r = Math.atan2(tc, ta) - Math.atan2(c, a) + offsetRotation;
                if (r > (0, $8804784813ffae81$export$6a7ef315a0d1ef07).PI) r -= (0, $8804784813ffae81$export$6a7ef315a0d1ef07).PI2;
                else if (r < -(0, $8804784813ffae81$export$6a7ef315a0d1ef07).PI) r += (0, $8804784813ffae81$export$6a7ef315a0d1ef07).PI2;
                r *= rotateMix;
                const cos = Math.cos(r);
                const sin = Math.sin(r);
                mat.a = cos * a - sin * c;
                mat.c = cos * b - sin * d;
                mat.b = sin * a + cos * c;
                mat.d = sin * b + cos * d;
                modified = true;
            }
            if (translateMix != 0) {
                const temp = this.temp;
                target.localToWorld(temp.set(this.data.offsetX, this.data.offsetY));
                mat.tx += (temp.x - mat.tx) * translateMix;
                mat.ty += (temp.y - mat.ty) * translateMix;
                modified = true;
            }
            if (scaleMix > 0) {
                let s = Math.sqrt(mat.a * mat.a + mat.b * mat.b);
                let ts = Math.sqrt(ta * ta + tc * tc);
                if (s > 1e-5) s = (s + (ts - s + this.data.offsetScaleX) * scaleMix) / s;
                mat.a *= s;
                mat.b *= s;
                s = Math.sqrt(mat.c * mat.c + mat.d * mat.d);
                ts = Math.sqrt(tb * tb + td * td);
                if (s > 1e-5) s = (s + (ts - s + this.data.offsetScaleY) * scaleMix) / s;
                mat.c *= s;
                mat.d *= s;
                modified = true;
            }
            if (shearMix > 0) {
                const b = mat.c;
                const d = mat.d;
                const by = Math.atan2(d, b);
                let r = Math.atan2(td, tb) - Math.atan2(tc, ta) - (by - Math.atan2(mat.b, mat.a));
                if (r > (0, $8804784813ffae81$export$6a7ef315a0d1ef07).PI) r -= (0, $8804784813ffae81$export$6a7ef315a0d1ef07).PI2;
                else if (r < -(0, $8804784813ffae81$export$6a7ef315a0d1ef07).PI) r += (0, $8804784813ffae81$export$6a7ef315a0d1ef07).PI2;
                r = by + (r + offsetShearY) * shearMix;
                const s = Math.sqrt(b * b + d * d);
                mat.c = Math.cos(r) * s;
                mat.d = Math.sin(r) * s;
                modified = true;
            }
            if (modified) bone.appliedValid = false;
        }
    }
    applyRelativeWorld() {
        const rotateMix = this.rotateMix;
        const translateMix = this.translateMix;
        const scaleMix = this.scaleMix;
        const shearMix = this.shearMix;
        const target = this.target;
        const targetMat = target.matrix;
        const ta = targetMat.a;
        const tb = targetMat.c;
        const tc = targetMat.b;
        const td = targetMat.d;
        const degRadReflect = ta * td - tb * tc > 0 ? (0, $8804784813ffae81$export$6a7ef315a0d1ef07).degRad : -(0, $8804784813ffae81$export$6a7ef315a0d1ef07).degRad;
        const offsetRotation = this.data.offsetRotation * degRadReflect;
        const offsetShearY = this.data.offsetShearY * degRadReflect;
        const bones = this.bones;
        for(let i = 0, n = bones.length; i < n; i++){
            const bone = bones[i];
            let modified = false;
            const mat = bone.matrix;
            if (rotateMix != 0) {
                const a = mat.a;
                const b = mat.c;
                const c = mat.b;
                const d = mat.d;
                let r = Math.atan2(tc, ta) + offsetRotation;
                if (r > (0, $8804784813ffae81$export$6a7ef315a0d1ef07).PI) r -= (0, $8804784813ffae81$export$6a7ef315a0d1ef07).PI2;
                else if (r < -(0, $8804784813ffae81$export$6a7ef315a0d1ef07).PI) r += (0, $8804784813ffae81$export$6a7ef315a0d1ef07).PI2;
                r *= rotateMix;
                const cos = Math.cos(r);
                const sin = Math.sin(r);
                mat.a = cos * a - sin * c;
                mat.c = cos * b - sin * d;
                mat.b = sin * a + cos * c;
                mat.d = sin * b + cos * d;
                modified = true;
            }
            if (translateMix != 0) {
                const temp = this.temp;
                target.localToWorld(temp.set(this.data.offsetX, this.data.offsetY));
                mat.tx += temp.x * translateMix;
                mat.ty += temp.y * translateMix;
                modified = true;
            }
            if (scaleMix > 0) {
                let s = (Math.sqrt(ta * ta + tc * tc) - 1 + this.data.offsetScaleX) * scaleMix + 1;
                mat.a *= s;
                mat.b *= s;
                s = (Math.sqrt(tb * tb + td * td) - 1 + this.data.offsetScaleY) * scaleMix + 1;
                mat.c *= s;
                mat.d *= s;
                modified = true;
            }
            if (shearMix > 0) {
                let r = Math.atan2(td, tb) - Math.atan2(tc, ta);
                if (r > (0, $8804784813ffae81$export$6a7ef315a0d1ef07).PI) r -= (0, $8804784813ffae81$export$6a7ef315a0d1ef07).PI2;
                else if (r < -(0, $8804784813ffae81$export$6a7ef315a0d1ef07).PI) r += (0, $8804784813ffae81$export$6a7ef315a0d1ef07).PI2;
                const b = mat.c;
                const d = mat.d;
                r = Math.atan2(d, b) + (r - (0, $8804784813ffae81$export$6a7ef315a0d1ef07).PI / 2 + offsetShearY) * shearMix;
                const s = Math.sqrt(b * b + d * d);
                mat.c = Math.cos(r) * s;
                mat.d = Math.sin(r) * s;
                modified = true;
            }
            if (modified) bone.appliedValid = false;
        }
    }
    applyAbsoluteLocal() {
        const rotateMix = this.rotateMix;
        const translateMix = this.translateMix;
        const scaleMix = this.scaleMix;
        const shearMix = this.shearMix;
        const target = this.target;
        if (!target.appliedValid) target.updateAppliedTransform();
        const bones = this.bones;
        for(let i = 0, n = bones.length; i < n; i++){
            const bone = bones[i];
            if (!bone.appliedValid) bone.updateAppliedTransform();
            let rotation = bone.arotation;
            if (rotateMix != 0) {
                let r = target.arotation - rotation + this.data.offsetRotation;
                r -= (16384 - (16384.499999999996 - r / 360 | 0)) * 360;
                rotation += r * rotateMix;
            }
            let x = bone.ax;
            let y = bone.ay;
            if (translateMix != 0) {
                x += (target.ax - x + this.data.offsetX) * translateMix;
                y += (target.ay - y + this.data.offsetY) * translateMix;
            }
            let scaleX = bone.ascaleX;
            let scaleY = bone.ascaleY;
            if (scaleMix > 0) {
                if (scaleX > 1e-5) scaleX = (scaleX + (target.ascaleX - scaleX + this.data.offsetScaleX) * scaleMix) / scaleX;
                if (scaleY > 1e-5) scaleY = (scaleY + (target.ascaleY - scaleY + this.data.offsetScaleY) * scaleMix) / scaleY;
            }
            const shearY = bone.ashearY;
            if (shearMix > 0) {
                let r = target.ashearY - shearY + this.data.offsetShearY;
                r -= (16384 - (16384.499999999996 - r / 360 | 0)) * 360;
                bone.shearY += r * shearMix;
            }
            bone.updateWorldTransformWith(x, y, rotation, scaleX, scaleY, bone.ashearX, shearY);
        }
    }
    applyRelativeLocal() {
        const rotateMix = this.rotateMix;
        const translateMix = this.translateMix;
        const scaleMix = this.scaleMix;
        const shearMix = this.shearMix;
        const target = this.target;
        if (!target.appliedValid) target.updateAppliedTransform();
        const bones = this.bones;
        for(let i = 0, n = bones.length; i < n; i++){
            const bone = bones[i];
            if (!bone.appliedValid) bone.updateAppliedTransform();
            let rotation = bone.arotation;
            if (rotateMix != 0) rotation += (target.arotation + this.data.offsetRotation) * rotateMix;
            let x = bone.ax;
            let y = bone.ay;
            if (translateMix != 0) {
                x += (target.ax + this.data.offsetX) * translateMix;
                y += (target.ay + this.data.offsetY) * translateMix;
            }
            let scaleX = bone.ascaleX;
            let scaleY = bone.ascaleY;
            if (scaleMix > 0) {
                if (scaleX > 1e-5) scaleX *= (target.ascaleX - 1 + this.data.offsetScaleX) * scaleMix + 1;
                if (scaleY > 1e-5) scaleY *= (target.ascaleY - 1 + this.data.offsetScaleY) * scaleMix + 1;
            }
            let shearY = bone.ashearY;
            if (shearMix > 0) shearY += (target.ashearY + this.data.offsetShearY) * shearMix;
            bone.updateWorldTransformWith(x, y, rotation, scaleX, scaleY, bone.ashearX, shearY);
        }
    }
}



const $5b6659a17eaf6fe5$var$_Skeleton = class {
    constructor(data){
        this._updateCache = new Array();
        this.updateCacheReset = new Array();
        this.time = 0;
        this.scaleX = 1;
        this.scaleY = 1;
        this.x = 0;
        this.y = 0;
        if (data == null) throw new Error("data cannot be null.");
        this.data = data;
        this.bones = new Array();
        for(let i = 0; i < data.bones.length; i++){
            const boneData = data.bones[i];
            let bone;
            if (boneData.parent == null) bone = new (0, $e11d34c987b6465b$export$b127726e56765aa4)(boneData, this, null);
            else {
                const parent = this.bones[boneData.parent.index];
                bone = new (0, $e11d34c987b6465b$export$b127726e56765aa4)(boneData, this, parent);
                parent.children.push(bone);
            }
            this.bones.push(bone);
        }
        this.slots = new Array();
        this.drawOrder = new Array();
        for(let i = 0; i < data.slots.length; i++){
            const slotData = data.slots[i];
            const bone = this.bones[slotData.boneData.index];
            const slot = new (0, $c7d1007eccfe6d2d$export$8c6ed5c666ac1360)(slotData, bone);
            this.slots.push(slot);
            this.drawOrder.push(slot);
        }
        this.ikConstraints = new Array();
        for(let i = 0; i < data.ikConstraints.length; i++){
            const ikConstraintData = data.ikConstraints[i];
            this.ikConstraints.push(new (0, $bcf6acc583d42db0$export$3c158c80ff28c177)(ikConstraintData, this));
        }
        this.transformConstraints = new Array();
        for(let i = 0; i < data.transformConstraints.length; i++){
            const transformConstraintData = data.transformConstraints[i];
            this.transformConstraints.push(new (0, $9c06c865703471d6$export$a2d8268faabf5c52)(transformConstraintData, this));
        }
        this.pathConstraints = new Array();
        for(let i = 0; i < data.pathConstraints.length; i++){
            const pathConstraintData = data.pathConstraints[i];
            this.pathConstraints.push(new (0, $6362190055f451a7$export$cb4f92fb0c018828)(pathConstraintData, this));
        }
        this.color = new (0, $8804784813ffae81$export$892596cec99bc70e)(1, 1, 1, 1);
        this.updateCache();
    }
    updateCache() {
        const updateCache = this._updateCache;
        updateCache.length = 0;
        this.updateCacheReset.length = 0;
        const bones = this.bones;
        for(let i = 0, n = bones.length; i < n; i++){
            const bone = bones[i];
            bone.sorted = bone.data.skinRequired;
            bone.active = !bone.sorted;
        }
        if (this.skin != null) {
            const skinBones = this.skin.bones;
            for(let i = 0, n = this.skin.bones.length; i < n; i++){
                let bone = this.bones[skinBones[i].index];
                do {
                    bone.sorted = false;
                    bone.active = true;
                    bone = bone.parent;
                }while (bone != null);
            }
        }
        const ikConstraints = this.ikConstraints;
        const transformConstraints = this.transformConstraints;
        const pathConstraints = this.pathConstraints;
        const ikCount = ikConstraints.length;
        const transformCount = transformConstraints.length;
        const pathCount = pathConstraints.length;
        const constraintCount = ikCount + transformCount + pathCount;
        outer: for(let i = 0; i < constraintCount; i++){
            for(let ii = 0; ii < ikCount; ii++){
                const constraint = ikConstraints[ii];
                if (constraint.data.order == i) {
                    this.sortIkConstraint(constraint);
                    continue outer;
                }
            }
            for(let ii = 0; ii < transformCount; ii++){
                const constraint = transformConstraints[ii];
                if (constraint.data.order == i) {
                    this.sortTransformConstraint(constraint);
                    continue outer;
                }
            }
            for(let ii = 0; ii < pathCount; ii++){
                const constraint = pathConstraints[ii];
                if (constraint.data.order == i) {
                    this.sortPathConstraint(constraint);
                    continue outer;
                }
            }
        }
        for(let i = 0, n = bones.length; i < n; i++)this.sortBone(bones[i]);
    }
    sortIkConstraint(constraint) {
        constraint.active = constraint.target.isActive() && (!constraint.data.skinRequired || this.skin != null && (0, $8804784813ffae81$export$d2ca453b913dcdea).contains(this.skin.constraints, constraint.data, true));
        if (!constraint.active) return;
        const target = constraint.target;
        this.sortBone(target);
        const constrained = constraint.bones;
        const parent = constrained[0];
        this.sortBone(parent);
        if (constrained.length > 1) {
            const child = constrained[constrained.length - 1];
            if (!(this._updateCache.indexOf(child) > -1)) this.updateCacheReset.push(child);
        }
        this._updateCache.push(constraint);
        this.sortReset(parent.children);
        constrained[constrained.length - 1].sorted = true;
    }
    sortPathConstraint(constraint) {
        constraint.active = constraint.target.bone.isActive() && (!constraint.data.skinRequired || this.skin != null && (0, $8804784813ffae81$export$d2ca453b913dcdea).contains(this.skin.constraints, constraint.data, true));
        if (!constraint.active) return;
        const slot = constraint.target;
        const slotIndex = slot.data.index;
        const slotBone = slot.bone;
        if (this.skin != null) this.sortPathConstraintAttachment(this.skin, slotIndex, slotBone);
        if (this.data.defaultSkin != null && this.data.defaultSkin != this.skin) this.sortPathConstraintAttachment(this.data.defaultSkin, slotIndex, slotBone);
        for(let i = 0, n = this.data.skins.length; i < n; i++)this.sortPathConstraintAttachment(this.data.skins[i], slotIndex, slotBone);
        const attachment = slot.getAttachment();
        if (attachment instanceof (0, $ce5645df4e682fb4$export$d285e3ec07b32800)) this.sortPathConstraintAttachmentWith(attachment, slotBone);
        const constrained = constraint.bones;
        const boneCount = constrained.length;
        for(let i = 0; i < boneCount; i++)this.sortBone(constrained[i]);
        this._updateCache.push(constraint);
        for(let i = 0; i < boneCount; i++)this.sortReset(constrained[i].children);
        for(let i = 0; i < boneCount; i++)constrained[i].sorted = true;
    }
    sortTransformConstraint(constraint) {
        constraint.active = constraint.target.isActive() && (!constraint.data.skinRequired || this.skin != null && (0, $8804784813ffae81$export$d2ca453b913dcdea).contains(this.skin.constraints, constraint.data, true));
        if (!constraint.active) return;
        this.sortBone(constraint.target);
        const constrained = constraint.bones;
        const boneCount = constrained.length;
        if (constraint.data.local) for(let i = 0; i < boneCount; i++){
            const child = constrained[i];
            this.sortBone(child.parent);
            if (!(this._updateCache.indexOf(child) > -1)) this.updateCacheReset.push(child);
        }
        else for(let i = 0; i < boneCount; i++)this.sortBone(constrained[i]);
        this._updateCache.push(constraint);
        for(let ii = 0; ii < boneCount; ii++)this.sortReset(constrained[ii].children);
        for(let ii = 0; ii < boneCount; ii++)constrained[ii].sorted = true;
    }
    sortPathConstraintAttachment(skin, slotIndex, slotBone) {
        const attachments = skin.attachments[slotIndex];
        if (!attachments) return;
        for(const key in attachments)this.sortPathConstraintAttachmentWith(attachments[key], slotBone);
    }
    sortPathConstraintAttachmentWith(attachment, slotBone) {
        if (!(attachment instanceof (0, $ce5645df4e682fb4$export$d285e3ec07b32800))) return;
        const pathBones = attachment.bones;
        if (pathBones == null) this.sortBone(slotBone);
        else {
            const bones = this.bones;
            let i = 0;
            while(i < pathBones.length){
                const boneCount = pathBones[i++];
                for(let n = i + boneCount; i < n; i++){
                    const boneIndex = pathBones[i];
                    this.sortBone(bones[boneIndex]);
                }
            }
        }
    }
    sortBone(bone) {
        if (bone.sorted) return;
        const parent = bone.parent;
        if (parent != null) this.sortBone(parent);
        bone.sorted = true;
        this._updateCache.push(bone);
    }
    sortReset(bones) {
        for(let i = 0, n = bones.length; i < n; i++){
            const bone = bones[i];
            if (!bone.active) continue;
            if (bone.sorted) this.sortReset(bone.children);
            bone.sorted = false;
        }
    }
    /** Updates the world transform for each bone and applies constraints. */ updateWorldTransform() {
        const updateCacheReset = this.updateCacheReset;
        for(let i = 0, n = updateCacheReset.length; i < n; i++){
            const bone = updateCacheReset[i];
            bone.ax = bone.x;
            bone.ay = bone.y;
            bone.arotation = bone.rotation;
            bone.ascaleX = bone.scaleX;
            bone.ascaleY = bone.scaleY;
            bone.ashearX = bone.shearX;
            bone.ashearY = bone.shearY;
            bone.appliedValid = true;
        }
        const updateCache = this._updateCache;
        for(let i = 0, n = updateCache.length; i < n; i++)updateCache[i].update();
    }
    /** Sets the bones, constraints, and slots to their setup pose values. */ setToSetupPose() {
        this.setBonesToSetupPose();
        this.setSlotsToSetupPose();
    }
    /** Sets the bones and constraints to their setup pose values. */ setBonesToSetupPose() {
        const bones = this.bones;
        for(let i = 0, n = bones.length; i < n; i++)bones[i].setToSetupPose();
        const ikConstraints = this.ikConstraints;
        for(let i = 0, n = ikConstraints.length; i < n; i++){
            const constraint = ikConstraints[i];
            constraint.mix = constraint.data.mix;
            constraint.softness = constraint.data.softness;
            constraint.bendDirection = constraint.data.bendDirection;
            constraint.compress = constraint.data.compress;
            constraint.stretch = constraint.data.stretch;
        }
        const transformConstraints = this.transformConstraints;
        for(let i = 0, n = transformConstraints.length; i < n; i++){
            const constraint = transformConstraints[i];
            const data = constraint.data;
            constraint.rotateMix = data.rotateMix;
            constraint.translateMix = data.translateMix;
            constraint.scaleMix = data.scaleMix;
            constraint.shearMix = data.shearMix;
        }
        const pathConstraints = this.pathConstraints;
        for(let i = 0, n = pathConstraints.length; i < n; i++){
            const constraint = pathConstraints[i];
            const data = constraint.data;
            constraint.position = data.position;
            constraint.spacing = data.spacing;
            constraint.rotateMix = data.rotateMix;
            constraint.translateMix = data.translateMix;
        }
    }
    setSlotsToSetupPose() {
        const slots = this.slots;
        (0, $8804784813ffae81$export$d2ca453b913dcdea).arrayCopy(slots, 0, this.drawOrder, 0, slots.length);
        for(let i = 0, n = slots.length; i < n; i++)slots[i].setToSetupPose();
    }
    /** @return May return null. */ getRootBone() {
        if (this.bones.length == 0) return null;
        return this.bones[0];
    }
    /** @return May be null. */ findBone(boneName) {
        if (boneName == null) throw new Error("boneName cannot be null.");
        const bones = this.bones;
        for(let i = 0, n = bones.length; i < n; i++){
            const bone = bones[i];
            if (bone.data.name == boneName) return bone;
        }
        return null;
    }
    /** @return -1 if the bone was not found. */ findBoneIndex(boneName) {
        if (boneName == null) throw new Error("boneName cannot be null.");
        const bones = this.bones;
        for(let i = 0, n = bones.length; i < n; i++)if (bones[i].data.name == boneName) return i;
        return -1;
    }
    /** @return May be null. */ findSlot(slotName) {
        if (slotName == null) throw new Error("slotName cannot be null.");
        const slots = this.slots;
        for(let i = 0, n = slots.length; i < n; i++){
            const slot = slots[i];
            if (slot.data.name == slotName) return slot;
        }
        return null;
    }
    /** @return -1 if the bone was not found. */ findSlotIndex(slotName) {
        if (slotName == null) throw new Error("slotName cannot be null.");
        const slots = this.slots;
        for(let i = 0, n = slots.length; i < n; i++)if (slots[i].data.name == slotName) return i;
        return -1;
    }
    /** Sets a skin by name.
   * @see #setSkin(Skin) */ setSkinByName(skinName) {
        const skin = this.data.findSkin(skinName);
        if (skin == null) throw new Error(`Skin not found: ${skinName}`);
        this.setSkin(skin);
    }
    /** Sets the skin used to look up attachments before looking in the {@link SkeletonData#getDefaultSkin() default skin}.
   * Attachments from the new skin are attached if the corresponding attachment from the old skin was attached. If there was no
   * old skin, each slot's setup mode attachment is attached from the new skin.
   * @param newSkin May be null. */ setSkin(newSkin) {
        if (newSkin == this.skin) return;
        if (newSkin != null) {
            if (this.skin != null) newSkin.attachAll(this, this.skin);
            else {
                const slots = this.slots;
                for(let i = 0, n = slots.length; i < n; i++){
                    const slot = slots[i];
                    const name = slot.data.attachmentName;
                    if (name != null) {
                        const attachment = newSkin.getAttachment(i, name);
                        if (attachment != null) slot.setAttachment(attachment);
                    }
                }
            }
        }
        this.skin = newSkin;
        this.updateCache();
    }
    /** @return May be null. */ getAttachmentByName(slotName, attachmentName) {
        return this.getAttachment(this.data.findSlotIndex(slotName), attachmentName);
    }
    /** @return May be null. */ getAttachment(slotIndex, attachmentName) {
        if (attachmentName == null) throw new Error("attachmentName cannot be null.");
        if (this.skin != null) {
            const attachment = this.skin.getAttachment(slotIndex, attachmentName);
            if (attachment != null) return attachment;
        }
        if (this.data.defaultSkin != null) return this.data.defaultSkin.getAttachment(slotIndex, attachmentName);
        return null;
    }
    /** @param attachmentName May be null. */ setAttachment(slotName, attachmentName) {
        if (slotName == null) throw new Error("slotName cannot be null.");
        const slots = this.slots;
        for(let i = 0, n = slots.length; i < n; i++){
            const slot = slots[i];
            if (slot.data.name == slotName) {
                let attachment = null;
                if (attachmentName != null) {
                    attachment = this.getAttachment(i, attachmentName);
                    if (attachment == null) throw new Error(`Attachment not found: ${attachmentName}, for slot: ${slotName}`);
                }
                slot.setAttachment(attachment);
                return;
            }
        }
        throw new Error(`Slot not found: ${slotName}`);
    }
    /** @return May be null. */ findIkConstraint(constraintName) {
        if (constraintName == null) throw new Error("constraintName cannot be null.");
        const ikConstraints = this.ikConstraints;
        for(let i = 0, n = ikConstraints.length; i < n; i++){
            const ikConstraint = ikConstraints[i];
            if (ikConstraint.data.name == constraintName) return ikConstraint;
        }
        return null;
    }
    /** @return May be null. */ findTransformConstraint(constraintName) {
        if (constraintName == null) throw new Error("constraintName cannot be null.");
        const transformConstraints = this.transformConstraints;
        for(let i = 0, n = transformConstraints.length; i < n; i++){
            const constraint = transformConstraints[i];
            if (constraint.data.name == constraintName) return constraint;
        }
        return null;
    }
    /** @return May be null. */ findPathConstraint(constraintName) {
        if (constraintName == null) throw new Error("constraintName cannot be null.");
        const pathConstraints = this.pathConstraints;
        for(let i = 0, n = pathConstraints.length; i < n; i++){
            const constraint = pathConstraints[i];
            if (constraint.data.name == constraintName) return constraint;
        }
        return null;
    }
    /** Returns the axis aligned bounding box (AABB) of the region and mesh attachments for the current pose.
   * @param offset The distance from the skeleton origin to the bottom left corner of the AABB.
   * @param size The width and height of the AABB.
   * @param temp Working memory */ getBounds(offset, size, temp = new Array(2)) {
        if (offset == null) throw new Error("offset cannot be null.");
        if (size == null) throw new Error("size cannot be null.");
        const drawOrder = this.drawOrder;
        let minX = Number.POSITIVE_INFINITY;
        let minY = Number.POSITIVE_INFINITY;
        let maxX = Number.NEGATIVE_INFINITY;
        let maxY = Number.NEGATIVE_INFINITY;
        for(let i = 0, n = drawOrder.length; i < n; i++){
            const slot = drawOrder[i];
            if (!slot.bone.active) continue;
            let verticesLength = 0;
            let vertices = null;
            const attachment = slot.getAttachment();
            if (attachment instanceof (0, $33f8c953c70470fb$export$d0fc51466fa6d530)) {
                verticesLength = 8;
                vertices = (0, $8804784813ffae81$export$d2ca453b913dcdea).setArraySize(temp, verticesLength, 0);
                attachment.computeWorldVertices(slot.bone, vertices, 0, 2);
            } else if (attachment instanceof (0, $72698e89a18058e1$export$3f1c1692adfcf3e2)) {
                const mesh = attachment;
                verticesLength = mesh.worldVerticesLength;
                vertices = (0, $8804784813ffae81$export$d2ca453b913dcdea).setArraySize(temp, verticesLength, 0);
                mesh.computeWorldVertices(slot, 0, verticesLength, vertices, 0, 2);
            }
            if (vertices != null) for(let ii = 0, nn = vertices.length; ii < nn; ii += 2){
                const x = vertices[ii];
                const y = vertices[ii + 1];
                minX = Math.min(minX, x);
                minY = Math.min(minY, y);
                maxX = Math.max(maxX, x);
                maxY = Math.max(maxY, y);
            }
        }
        offset.set(minX, minY);
        size.set(maxX - minX, maxY - minY);
    }
    update(delta) {
        this.time += delta;
    }
    get flipX() {
        return this.scaleX == -1;
    }
    set flipX(value) {
        if (!$5b6659a17eaf6fe5$var$_Skeleton.deprecatedWarning1) {
            $5b6659a17eaf6fe5$var$_Skeleton.deprecatedWarning1 = true;
            console.warn("Spine Deprecation Warning: `Skeleton.flipX/flipY` was deprecated, please use scaleX/scaleY");
        }
        this.scaleX = value ? 1 : -1;
    }
    get flipY() {
        return this.scaleY == -1;
    }
    set flipY(value) {
        if (!$5b6659a17eaf6fe5$var$_Skeleton.deprecatedWarning1) {
            $5b6659a17eaf6fe5$var$_Skeleton.deprecatedWarning1 = true;
            console.warn("Spine Deprecation Warning: `Skeleton.flipX/flipY` was deprecated, please use scaleX/scaleY");
        }
        this.scaleY = value ? 1 : -1;
    }
};
let $5b6659a17eaf6fe5$export$8f31e4c4a37b8e9c = $5b6659a17eaf6fe5$var$_Skeleton;
$5b6659a17eaf6fe5$export$8f31e4c4a37b8e9c.deprecatedWarning1 = false;



class $55d718d92918b306$export$e8f362f163550575 {
    constructor(){
        this.bones = new Array();
        // Ordered parents first.
        this.slots = new Array();
        // Setup pose draw order.
        this.skins = new Array();
        this.events = new Array();
        this.animations = new Array();
        this.ikConstraints = new Array();
        this.transformConstraints = new Array();
        this.pathConstraints = new Array();
        // Nonessential
        this.fps = 0;
    }
    findBone(boneName) {
        if (boneName == null) throw new Error("boneName cannot be null.");
        const bones = this.bones;
        for(let i = 0, n = bones.length; i < n; i++){
            const bone = bones[i];
            if (bone.name == boneName) return bone;
        }
        return null;
    }
    findBoneIndex(boneName) {
        if (boneName == null) throw new Error("boneName cannot be null.");
        const bones = this.bones;
        for(let i = 0, n = bones.length; i < n; i++)if (bones[i].name == boneName) return i;
        return -1;
    }
    findSlot(slotName) {
        if (slotName == null) throw new Error("slotName cannot be null.");
        const slots = this.slots;
        for(let i = 0, n = slots.length; i < n; i++){
            const slot = slots[i];
            if (slot.name == slotName) return slot;
        }
        return null;
    }
    findSlotIndex(slotName) {
        if (slotName == null) throw new Error("slotName cannot be null.");
        const slots = this.slots;
        for(let i = 0, n = slots.length; i < n; i++)if (slots[i].name == slotName) return i;
        return -1;
    }
    findSkin(skinName) {
        if (skinName == null) throw new Error("skinName cannot be null.");
        const skins = this.skins;
        for(let i = 0, n = skins.length; i < n; i++){
            const skin = skins[i];
            if (skin.name == skinName) return skin;
        }
        return null;
    }
    findEvent(eventDataName) {
        if (eventDataName == null) throw new Error("eventDataName cannot be null.");
        const events = this.events;
        for(let i = 0, n = events.length; i < n; i++){
            const event = events[i];
            if (event.name == eventDataName) return event;
        }
        return null;
    }
    findAnimation(animationName) {
        if (animationName == null) throw new Error("animationName cannot be null.");
        const animations = this.animations;
        for(let i = 0, n = animations.length; i < n; i++){
            const animation = animations[i];
            if (animation.name == animationName) return animation;
        }
        return null;
    }
    findIkConstraint(constraintName) {
        if (constraintName == null) throw new Error("constraintName cannot be null.");
        const ikConstraints = this.ikConstraints;
        for(let i = 0, n = ikConstraints.length; i < n; i++){
            const constraint = ikConstraints[i];
            if (constraint.name == constraintName) return constraint;
        }
        return null;
    }
    findTransformConstraint(constraintName) {
        if (constraintName == null) throw new Error("constraintName cannot be null.");
        const transformConstraints = this.transformConstraints;
        for(let i = 0, n = transformConstraints.length; i < n; i++){
            const constraint = transformConstraints[i];
            if (constraint.name == constraintName) return constraint;
        }
        return null;
    }
    findPathConstraint(constraintName) {
        if (constraintName == null) throw new Error("constraintName cannot be null.");
        const pathConstraints = this.pathConstraints;
        for(let i = 0, n = pathConstraints.length; i < n; i++){
            const constraint = pathConstraints[i];
            if (constraint.name == constraintName) return constraint;
        }
        return null;
    }
    findPathConstraintIndex(pathConstraintName) {
        if (pathConstraintName == null) throw new Error("pathConstraintName cannot be null.");
        const pathConstraints = this.pathConstraints;
        for(let i = 0, n = pathConstraints.length; i < n; i++)if (pathConstraints[i].name == pathConstraintName) return i;
        return -1;
    }
}



class $2cfe2e8ef95dfc1b$export$a4cce1bf50208679 {
    constructor(index, name, boneData){
        this.color = new (0, $8804784813ffae81$export$892596cec99bc70e)(1, 1, 1, 1);
        if (index < 0) throw new Error("index must be >= 0.");
        if (name == null) throw new Error("name cannot be null.");
        if (boneData == null) throw new Error("boneData cannot be null.");
        this.index = index;
        this.name = name;
        this.boneData = boneData;
    }
}





class $0afd2e509d2277c4$export$823fbc29771afdb5 extends (0, $9feaa1f370017dae$export$b826e1ab3af63566) {
    constructor(name){
        super(name, 0, false);
        this.bones = new Array();
        this.rotateMix = 0;
        this.translateMix = 0;
        this.scaleMix = 0;
        this.shearMix = 0;
        this.offsetRotation = 0;
        this.offsetX = 0;
        this.offsetY = 0;
        this.offsetScaleX = 0;
        this.offsetScaleY = 0;
        this.offsetShearY = 0;
        this.relative = false;
        this.local = false;
    }
}







class $4e95b87485e4f6dc$export$18ca51770a196b7d {
    constructor(slotIndex, name, attachment){
        this.slotIndex = slotIndex;
        this.name = name;
        this.attachment = attachment;
    }
}
class $4e95b87485e4f6dc$export$b8e0f93a76772233 {
    constructor(name){
        this.attachments = new Array();
        this.bones = Array();
        this.constraints = new Array();
        if (name == null) throw new Error("name cannot be null.");
        this.name = name;
    }
    setAttachment(slotIndex, name, attachment) {
        if (attachment == null) throw new Error("attachment cannot be null.");
        const attachments = this.attachments;
        if (slotIndex >= attachments.length) attachments.length = slotIndex + 1;
        if (!attachments[slotIndex]) attachments[slotIndex] = {};
        attachments[slotIndex][name] = attachment;
    }
    addSkin(skin) {
        for(let i = 0; i < skin.bones.length; i++){
            const bone = skin.bones[i];
            let contained = false;
            for(let j = 0; j < this.bones.length; j++)if (this.bones[j] == bone) {
                contained = true;
                break;
            }
            if (!contained) this.bones.push(bone);
        }
        for(let i = 0; i < skin.constraints.length; i++){
            const constraint = skin.constraints[i];
            let contained = false;
            for(let j = 0; j < this.constraints.length; j++)if (this.constraints[j] == constraint) {
                contained = true;
                break;
            }
            if (!contained) this.constraints.push(constraint);
        }
        const attachments = skin.getAttachments();
        for(let i = 0; i < attachments.length; i++){
            const attachment = attachments[i];
            this.setAttachment(attachment.slotIndex, attachment.name, attachment.attachment);
        }
    }
    copySkin(skin) {
        for(let i = 0; i < skin.bones.length; i++){
            const bone = skin.bones[i];
            let contained = false;
            for(let j = 0; j < this.bones.length; j++)if (this.bones[j] == bone) {
                contained = true;
                break;
            }
            if (!contained) this.bones.push(bone);
        }
        for(let i = 0; i < skin.constraints.length; i++){
            const constraint = skin.constraints[i];
            let contained = false;
            for(let j = 0; j < this.constraints.length; j++)if (this.constraints[j] == constraint) {
                contained = true;
                break;
            }
            if (!contained) this.constraints.push(constraint);
        }
        const attachments = skin.getAttachments();
        for(let i = 0; i < attachments.length; i++){
            const attachment = attachments[i];
            if (attachment.attachment == null) continue;
            if (attachment.attachment instanceof (0, $72698e89a18058e1$export$3f1c1692adfcf3e2)) {
                attachment.attachment = attachment.attachment.newLinkedMesh();
                this.setAttachment(attachment.slotIndex, attachment.name, attachment.attachment);
            } else {
                attachment.attachment = attachment.attachment.copy();
                this.setAttachment(attachment.slotIndex, attachment.name, attachment.attachment);
            }
        }
    }
    /** @return May be null. */ getAttachment(slotIndex, name) {
        const dictionary = this.attachments[slotIndex];
        return dictionary ? dictionary[name] : null;
    }
    removeAttachment(slotIndex, name) {
        const dictionary = this.attachments[slotIndex];
        if (dictionary) dictionary[name] = null;
    }
    getAttachments() {
        const entries = new Array();
        for(let i = 0; i < this.attachments.length; i++){
            const slotAttachments = this.attachments[i];
            if (slotAttachments) for(const name in slotAttachments){
                const attachment = slotAttachments[name];
                if (attachment) entries.push(new $4e95b87485e4f6dc$export$18ca51770a196b7d(i, name, attachment));
            }
        }
        return entries;
    }
    getAttachmentsForSlot(slotIndex, attachments) {
        const slotAttachments = this.attachments[slotIndex];
        if (slotAttachments) for(const name in slotAttachments){
            const attachment = slotAttachments[name];
            if (attachment) attachments.push(new $4e95b87485e4f6dc$export$18ca51770a196b7d(slotIndex, name, attachment));
        }
    }
    clear() {
        this.attachments.length = 0;
        this.bones.length = 0;
        this.constraints.length = 0;
    }
    /** Attach each attachment in this skin if the corresponding attachment in the old skin is currently attached. */ attachAll(skeleton, oldSkin) {
        let slotIndex = 0;
        for(let i = 0; i < skeleton.slots.length; i++){
            const slot = skeleton.slots[i];
            const slotAttachment = slot.getAttachment();
            if (slotAttachment && slotIndex < oldSkin.attachments.length) {
                const dictionary = oldSkin.attachments[slotIndex];
                for(const key in dictionary){
                    const skinAttachment = dictionary[key];
                    if (slotAttachment == skinAttachment) {
                        const attachment = this.getAttachment(slotIndex, key);
                        if (attachment != null) slot.setAttachment(attachment);
                        break;
                    }
                }
            }
            slotIndex++;
        }
    }
}






const $cd7869ac723b60bd$var$_SkeletonBinary = class {
    constructor(attachmentLoader){
        this.scale = 1;
        this.linkedMeshes = new Array();
        this.attachmentLoader = attachmentLoader;
    }
    readSkeletonData(binary) {
        const scale = this.scale;
        const skeletonData = new (0, $55d718d92918b306$export$e8f362f163550575)();
        skeletonData.name = "";
        const input = new (0, $76f67eeea63ddac1$export$c8e921ea3330f774)(binary);
        skeletonData.hash = input.readString();
        skeletonData.version = input.readString();
        if (skeletonData.version === "3.8.75") {
            const error = `Unsupported skeleton data, 3.8.75 is deprecated, please export with a newer version of Spine.`;
            console.error(error);
        }
        skeletonData.x = input.readFloat();
        skeletonData.y = input.readFloat();
        skeletonData.width = input.readFloat();
        skeletonData.height = input.readFloat();
        const nonessential = input.readBoolean();
        if (nonessential) {
            skeletonData.fps = input.readFloat();
            skeletonData.imagesPath = input.readString();
            skeletonData.audioPath = input.readString();
        }
        let n = 0;
        n = input.readInt(true);
        for(let i = 0; i < n; i++)input.strings.push(input.readString());
        n = input.readInt(true);
        for(let i = 0; i < n; i++){
            const name = input.readString();
            const parent = i == 0 ? null : skeletonData.bones[input.readInt(true)];
            const data = new (0, $53352ede0f332990$export$7d85d96cf093e12f)(i, name, parent);
            data.rotation = input.readFloat();
            data.x = input.readFloat() * scale;
            data.y = input.readFloat() * scale;
            data.scaleX = input.readFloat();
            data.scaleY = input.readFloat();
            data.shearX = input.readFloat();
            data.shearY = input.readFloat();
            data.length = input.readFloat() * scale;
            data.transformMode = $cd7869ac723b60bd$var$_SkeletonBinary.TransformModeValues[input.readInt(true)];
            data.skinRequired = input.readBoolean();
            if (nonessential) (0, $8804784813ffae81$export$892596cec99bc70e).rgba8888ToColor(data.color, input.readInt32());
            skeletonData.bones.push(data);
        }
        n = input.readInt(true);
        for(let i = 0; i < n; i++){
            const slotName = input.readString();
            const boneData = skeletonData.bones[input.readInt(true)];
            const data = new (0, $2cfe2e8ef95dfc1b$export$a4cce1bf50208679)(i, slotName, boneData);
            (0, $8804784813ffae81$export$892596cec99bc70e).rgba8888ToColor(data.color, input.readInt32());
            const darkColor = input.readInt32();
            if (darkColor != -1) (0, $8804784813ffae81$export$892596cec99bc70e).rgb888ToColor(data.darkColor = new (0, $8804784813ffae81$export$892596cec99bc70e)(), darkColor);
            data.attachmentName = input.readStringRef();
            data.blendMode = $cd7869ac723b60bd$var$_SkeletonBinary.BlendModeValues[input.readInt(true)];
            skeletonData.slots.push(data);
        }
        n = input.readInt(true);
        for(let i = 0, nn; i < n; i++){
            const data = new (0, $c7dead7a06471124$export$adcb08b651fc712e)(input.readString());
            data.order = input.readInt(true);
            data.skinRequired = input.readBoolean();
            nn = input.readInt(true);
            for(let ii = 0; ii < nn; ii++)data.bones.push(skeletonData.bones[input.readInt(true)]);
            data.target = skeletonData.bones[input.readInt(true)];
            data.mix = input.readFloat();
            data.softness = input.readFloat() * scale;
            data.bendDirection = input.readByte();
            data.compress = input.readBoolean();
            data.stretch = input.readBoolean();
            data.uniform = input.readBoolean();
            skeletonData.ikConstraints.push(data);
        }
        n = input.readInt(true);
        for(let i = 0, nn; i < n; i++){
            const data = new (0, $0afd2e509d2277c4$export$823fbc29771afdb5)(input.readString());
            data.order = input.readInt(true);
            data.skinRequired = input.readBoolean();
            nn = input.readInt(true);
            for(let ii = 0; ii < nn; ii++)data.bones.push(skeletonData.bones[input.readInt(true)]);
            data.target = skeletonData.bones[input.readInt(true)];
            data.local = input.readBoolean();
            data.relative = input.readBoolean();
            data.offsetRotation = input.readFloat();
            data.offsetX = input.readFloat() * scale;
            data.offsetY = input.readFloat() * scale;
            data.offsetScaleX = input.readFloat();
            data.offsetScaleY = input.readFloat();
            data.offsetShearY = input.readFloat();
            data.rotateMix = input.readFloat();
            data.translateMix = input.readFloat();
            data.scaleMix = input.readFloat();
            data.shearMix = input.readFloat();
            skeletonData.transformConstraints.push(data);
        }
        n = input.readInt(true);
        for(let i = 0, nn; i < n; i++){
            const data = new (0, $f3db500d9e578f13$export$d2629ab80d5dd5ba)(input.readString());
            data.order = input.readInt(true);
            data.skinRequired = input.readBoolean();
            nn = input.readInt(true);
            for(let ii = 0; ii < nn; ii++)data.bones.push(skeletonData.bones[input.readInt(true)]);
            data.target = skeletonData.slots[input.readInt(true)];
            data.positionMode = $cd7869ac723b60bd$var$_SkeletonBinary.PositionModeValues[input.readInt(true)];
            data.spacingMode = $cd7869ac723b60bd$var$_SkeletonBinary.SpacingModeValues[input.readInt(true)];
            data.rotateMode = $cd7869ac723b60bd$var$_SkeletonBinary.RotateModeValues[input.readInt(true)];
            data.offsetRotation = input.readFloat();
            data.position = input.readFloat();
            if (data.positionMode == (0, $2c8db927dc4fcff5$export$34d637c671e1e906).Fixed) data.position *= scale;
            data.spacing = input.readFloat();
            if (data.spacingMode == (0, $f3db500d9e578f13$export$34ce760ad2b0be4b).Length || data.spacingMode == (0, $f3db500d9e578f13$export$34ce760ad2b0be4b).Fixed) data.spacing *= scale;
            data.rotateMix = input.readFloat();
            data.translateMix = input.readFloat();
            skeletonData.pathConstraints.push(data);
        }
        const defaultSkin = this.readSkin(input, skeletonData, true, nonessential);
        if (defaultSkin != null) {
            skeletonData.defaultSkin = defaultSkin;
            skeletonData.skins.push(defaultSkin);
        }
        {
            let i = skeletonData.skins.length;
            (0, $8804784813ffae81$export$d2ca453b913dcdea).setArraySize(skeletonData.skins, n = i + input.readInt(true));
            for(; i < n; i++)skeletonData.skins[i] = this.readSkin(input, skeletonData, false, nonessential);
        }
        n = this.linkedMeshes.length;
        for(let i = 0; i < n; i++){
            const linkedMesh = this.linkedMeshes[i];
            const skin = linkedMesh.skin == null ? skeletonData.defaultSkin : skeletonData.findSkin(linkedMesh.skin);
            if (skin == null) throw new Error(`Skin not found: ${linkedMesh.skin}`);
            const parent = skin.getAttachment(linkedMesh.slotIndex, linkedMesh.parent);
            if (parent == null) throw new Error(`Parent mesh not found: ${linkedMesh.parent}`);
            linkedMesh.mesh.deformAttachment = linkedMesh.inheritDeform ? parent : linkedMesh.mesh;
            linkedMesh.mesh.setParentMesh(parent);
        }
        this.linkedMeshes.length = 0;
        n = input.readInt(true);
        for(let i = 0; i < n; i++){
            const data = new (0, $6449a1e1fcf4967a$export$a5cf049e34c3d11e)(input.readStringRef());
            data.intValue = input.readInt(false);
            data.floatValue = input.readFloat();
            data.stringValue = input.readString();
            data.audioPath = input.readString();
            if (data.audioPath != null) {
                data.volume = input.readFloat();
                data.balance = input.readFloat();
            }
            skeletonData.events.push(data);
        }
        n = input.readInt(true);
        for(let i = 0; i < n; i++)skeletonData.animations.push(this.readAnimation(input, input.readString(), skeletonData));
        return skeletonData;
    }
    readSkin(input, skeletonData, defaultSkin, nonessential) {
        let skin = null;
        let slotCount = 0;
        if (defaultSkin) {
            slotCount = input.readInt(true);
            if (slotCount == 0) return null;
            skin = new (0, $4e95b87485e4f6dc$export$b8e0f93a76772233)("default");
        } else {
            skin = new (0, $4e95b87485e4f6dc$export$b8e0f93a76772233)(input.readStringRef());
            skin.bones.length = input.readInt(true);
            for(let i = 0, n = skin.bones.length; i < n; i++)skin.bones[i] = skeletonData.bones[input.readInt(true)];
            for(let i = 0, n = input.readInt(true); i < n; i++)skin.constraints.push(skeletonData.ikConstraints[input.readInt(true)]);
            for(let i = 0, n = input.readInt(true); i < n; i++)skin.constraints.push(skeletonData.transformConstraints[input.readInt(true)]);
            for(let i = 0, n = input.readInt(true); i < n; i++)skin.constraints.push(skeletonData.pathConstraints[input.readInt(true)]);
            slotCount = input.readInt(true);
        }
        for(let i = 0; i < slotCount; i++){
            const slotIndex = input.readInt(true);
            for(let ii = 0, nn = input.readInt(true); ii < nn; ii++){
                const name = input.readStringRef();
                const attachment = this.readAttachment(input, skeletonData, skin, slotIndex, name, nonessential);
                if (attachment != null) skin.setAttachment(slotIndex, name, attachment);
            }
        }
        return skin;
    }
    readAttachment(input, skeletonData, skin, slotIndex, attachmentName, nonessential) {
        const scale = this.scale;
        let name = input.readStringRef();
        if (name == null) name = attachmentName;
        const typeIndex = input.readByte();
        const type = $cd7869ac723b60bd$var$_SkeletonBinary.AttachmentTypeValues[typeIndex];
        switch(type){
            case (0, $4b0ad7d1400b5e69$export$86cfdc1f02eaf37a).Region:
                {
                    let path = input.readStringRef();
                    const rotation = input.readFloat();
                    const x = input.readFloat();
                    const y = input.readFloat();
                    const scaleX = input.readFloat();
                    const scaleY = input.readFloat();
                    const width = input.readFloat();
                    const height = input.readFloat();
                    const color = input.readInt32();
                    if (path == null) path = name;
                    const region = this.attachmentLoader.newRegionAttachment(skin, name, path);
                    if (region == null) return null;
                    region.path = path;
                    region.x = x * scale;
                    region.y = y * scale;
                    region.scaleX = scaleX;
                    region.scaleY = scaleY;
                    region.rotation = rotation;
                    region.width = width * scale;
                    region.height = height * scale;
                    (0, $8804784813ffae81$export$892596cec99bc70e).rgba8888ToColor(region.color, color);
                    return region;
                }
            case (0, $4b0ad7d1400b5e69$export$86cfdc1f02eaf37a).BoundingBox:
                {
                    const vertexCount = input.readInt(true);
                    const vertices = this.readVertices(input, vertexCount);
                    const color = nonessential ? input.readInt32() : 0;
                    const box = this.attachmentLoader.newBoundingBoxAttachment(skin, name);
                    if (box == null) return null;
                    box.worldVerticesLength = vertexCount << 1;
                    box.vertices = vertices.vertices;
                    box.bones = vertices.bones;
                    if (nonessential) (0, $8804784813ffae81$export$892596cec99bc70e).rgba8888ToColor(box.color, color);
                    return box;
                }
            case (0, $4b0ad7d1400b5e69$export$86cfdc1f02eaf37a).Mesh:
                {
                    let path = input.readStringRef();
                    const color = input.readInt32();
                    const vertexCount = input.readInt(true);
                    const uvs = this.readFloatArray(input, vertexCount << 1, 1);
                    const triangles = this.readShortArray(input);
                    const vertices = this.readVertices(input, vertexCount);
                    const hullLength = input.readInt(true);
                    let edges = null;
                    let width = 0;
                    let height = 0;
                    if (nonessential) {
                        edges = this.readShortArray(input);
                        width = input.readFloat();
                        height = input.readFloat();
                    }
                    if (path == null) path = name;
                    const mesh = this.attachmentLoader.newMeshAttachment(skin, name, path);
                    if (mesh == null) return null;
                    mesh.path = path;
                    (0, $8804784813ffae81$export$892596cec99bc70e).rgba8888ToColor(mesh.color, color);
                    mesh.bones = vertices.bones;
                    mesh.vertices = vertices.vertices;
                    mesh.worldVerticesLength = vertexCount << 1;
                    mesh.triangles = triangles;
                    mesh.regionUVs = new Float32Array(uvs);
                    mesh.hullLength = hullLength << 1;
                    if (nonessential) {
                        mesh.edges = edges;
                        mesh.width = width * scale;
                        mesh.height = height * scale;
                    }
                    return mesh;
                }
            case (0, $4b0ad7d1400b5e69$export$86cfdc1f02eaf37a).LinkedMesh:
                {
                    let path = input.readStringRef();
                    const color = input.readInt32();
                    const skinName = input.readStringRef();
                    const parent = input.readStringRef();
                    const inheritDeform = input.readBoolean();
                    let width = 0;
                    let height = 0;
                    if (nonessential) {
                        width = input.readFloat();
                        height = input.readFloat();
                    }
                    if (path == null) path = name;
                    const mesh = this.attachmentLoader.newMeshAttachment(skin, name, path);
                    if (mesh == null) return null;
                    mesh.path = path;
                    (0, $8804784813ffae81$export$892596cec99bc70e).rgba8888ToColor(mesh.color, color);
                    if (nonessential) {
                        mesh.width = width * scale;
                        mesh.height = height * scale;
                    }
                    this.linkedMeshes.push(new $cd7869ac723b60bd$var$LinkedMesh(mesh, skinName, slotIndex, parent, inheritDeform));
                    return mesh;
                }
            case (0, $4b0ad7d1400b5e69$export$86cfdc1f02eaf37a).Path:
                {
                    const closed = input.readBoolean();
                    const constantSpeed = input.readBoolean();
                    const vertexCount = input.readInt(true);
                    const vertices = this.readVertices(input, vertexCount);
                    const lengths = (0, $8804784813ffae81$export$d2ca453b913dcdea).newArray(vertexCount / 3, 0);
                    for(let i = 0, n = lengths.length; i < n; i++)lengths[i] = input.readFloat() * scale;
                    const color = nonessential ? input.readInt32() : 0;
                    const path = this.attachmentLoader.newPathAttachment(skin, name);
                    if (path == null) return null;
                    path.closed = closed;
                    path.constantSpeed = constantSpeed;
                    path.worldVerticesLength = vertexCount << 1;
                    path.vertices = vertices.vertices;
                    path.bones = vertices.bones;
                    path.lengths = lengths;
                    if (nonessential) (0, $8804784813ffae81$export$892596cec99bc70e).rgba8888ToColor(path.color, color);
                    return path;
                }
            case (0, $4b0ad7d1400b5e69$export$86cfdc1f02eaf37a).Point:
                {
                    const rotation = input.readFloat();
                    const x = input.readFloat();
                    const y = input.readFloat();
                    const color = nonessential ? input.readInt32() : 0;
                    const point = this.attachmentLoader.newPointAttachment(skin, name);
                    if (point == null) return null;
                    point.x = x * scale;
                    point.y = y * scale;
                    point.rotation = rotation;
                    if (nonessential) (0, $8804784813ffae81$export$892596cec99bc70e).rgba8888ToColor(point.color, color);
                    return point;
                }
            case (0, $4b0ad7d1400b5e69$export$86cfdc1f02eaf37a).Clipping:
                {
                    const endSlotIndex = input.readInt(true);
                    const vertexCount = input.readInt(true);
                    const vertices = this.readVertices(input, vertexCount);
                    const color = nonessential ? input.readInt32() : 0;
                    const clip = this.attachmentLoader.newClippingAttachment(skin, name);
                    if (clip == null) return null;
                    clip.endSlot = skeletonData.slots[endSlotIndex];
                    clip.worldVerticesLength = vertexCount << 1;
                    clip.vertices = vertices.vertices;
                    clip.bones = vertices.bones;
                    if (nonessential) (0, $8804784813ffae81$export$892596cec99bc70e).rgba8888ToColor(clip.color, color);
                    return clip;
                }
        }
        return null;
    }
    readVertices(input, vertexCount) {
        const verticesLength = vertexCount << 1;
        const vertices = new $cd7869ac723b60bd$var$Vertices();
        const scale = this.scale;
        if (!input.readBoolean()) {
            vertices.vertices = this.readFloatArray(input, verticesLength, scale);
            return vertices;
        }
        const weights = new Array();
        const bonesArray = new Array();
        for(let i = 0; i < vertexCount; i++){
            const boneCount = input.readInt(true);
            bonesArray.push(boneCount);
            for(let ii = 0; ii < boneCount; ii++){
                bonesArray.push(input.readInt(true));
                weights.push(input.readFloat() * scale);
                weights.push(input.readFloat() * scale);
                weights.push(input.readFloat());
            }
        }
        vertices.vertices = (0, $8804784813ffae81$export$d2ca453b913dcdea).toFloatArray(weights);
        vertices.bones = bonesArray;
        return vertices;
    }
    readFloatArray(input, n, scale) {
        const array = new Array(n);
        if (scale == 1) for(let i = 0; i < n; i++)array[i] = input.readFloat();
        else for(let i = 0; i < n; i++)array[i] = input.readFloat() * scale;
        return array;
    }
    readShortArray(input) {
        const n = input.readInt(true);
        const array = new Array(n);
        for(let i = 0; i < n; i++)array[i] = input.readShort();
        return array;
    }
    readAnimation(input, name, skeletonData) {
        const timelines = new Array();
        const scale = this.scale;
        let duration = 0;
        const tempColor1 = new (0, $8804784813ffae81$export$892596cec99bc70e)();
        const tempColor2 = new (0, $8804784813ffae81$export$892596cec99bc70e)();
        for(let i = 0, n = input.readInt(true); i < n; i++){
            const slotIndex = input.readInt(true);
            for(let ii = 0, nn = input.readInt(true); ii < nn; ii++){
                const timelineType = input.readByte();
                const frameCount = input.readInt(true);
                switch(timelineType){
                    case $cd7869ac723b60bd$var$_SkeletonBinary.SLOT_ATTACHMENT:
                        {
                            const timeline = new (0, $a99189e38c28e5fb$export$7f2bfc5bd27cb43d)(frameCount);
                            timeline.slotIndex = slotIndex;
                            for(let frameIndex = 0; frameIndex < frameCount; frameIndex++)timeline.setFrame(frameIndex, input.readFloat(), input.readStringRef());
                            timelines.push(timeline);
                            duration = Math.max(duration, timeline.frames[frameCount - 1]);
                            break;
                        }
                    case $cd7869ac723b60bd$var$_SkeletonBinary.SLOT_COLOR:
                        {
                            const timeline = new (0, $a99189e38c28e5fb$export$565fcb3610070d7f)(frameCount);
                            timeline.slotIndex = slotIndex;
                            for(let frameIndex = 0; frameIndex < frameCount; frameIndex++){
                                const time = input.readFloat();
                                (0, $8804784813ffae81$export$892596cec99bc70e).rgba8888ToColor(tempColor1, input.readInt32());
                                timeline.setFrame(frameIndex, time, tempColor1.r, tempColor1.g, tempColor1.b, tempColor1.a);
                                if (frameIndex < frameCount - 1) this.readCurve(input, frameIndex, timeline);
                            }
                            timelines.push(timeline);
                            duration = Math.max(duration, timeline.frames[(frameCount - 1) * (0, $a99189e38c28e5fb$export$565fcb3610070d7f).ENTRIES]);
                            break;
                        }
                    case $cd7869ac723b60bd$var$_SkeletonBinary.SLOT_TWO_COLOR:
                        {
                            const timeline = new (0, $a99189e38c28e5fb$export$938c1752e1b56539)(frameCount);
                            timeline.slotIndex = slotIndex;
                            for(let frameIndex = 0; frameIndex < frameCount; frameIndex++){
                                const time = input.readFloat();
                                (0, $8804784813ffae81$export$892596cec99bc70e).rgba8888ToColor(tempColor1, input.readInt32());
                                (0, $8804784813ffae81$export$892596cec99bc70e).rgb888ToColor(tempColor2, input.readInt32());
                                timeline.setFrame(frameIndex, time, tempColor1.r, tempColor1.g, tempColor1.b, tempColor1.a, tempColor2.r, tempColor2.g, tempColor2.b);
                                if (frameIndex < frameCount - 1) this.readCurve(input, frameIndex, timeline);
                            }
                            timelines.push(timeline);
                            duration = Math.max(duration, timeline.frames[(frameCount - 1) * (0, $a99189e38c28e5fb$export$938c1752e1b56539).ENTRIES]);
                            break;
                        }
                }
            }
        }
        for(let i = 0, n = input.readInt(true); i < n; i++){
            const boneIndex = input.readInt(true);
            for(let ii = 0, nn = input.readInt(true); ii < nn; ii++){
                const timelineType = input.readByte();
                const frameCount = input.readInt(true);
                switch(timelineType){
                    case $cd7869ac723b60bd$var$_SkeletonBinary.BONE_ROTATE:
                        {
                            const timeline = new (0, $a99189e38c28e5fb$export$b7ecb8f68b3e130b)(frameCount);
                            timeline.boneIndex = boneIndex;
                            for(let frameIndex = 0; frameIndex < frameCount; frameIndex++){
                                timeline.setFrame(frameIndex, input.readFloat(), input.readFloat());
                                if (frameIndex < frameCount - 1) this.readCurve(input, frameIndex, timeline);
                            }
                            timelines.push(timeline);
                            duration = Math.max(duration, timeline.frames[(frameCount - 1) * (0, $a99189e38c28e5fb$export$b7ecb8f68b3e130b).ENTRIES]);
                            break;
                        }
                    case $cd7869ac723b60bd$var$_SkeletonBinary.BONE_TRANSLATE:
                    case $cd7869ac723b60bd$var$_SkeletonBinary.BONE_SCALE:
                    case $cd7869ac723b60bd$var$_SkeletonBinary.BONE_SHEAR:
                        {
                            let timeline;
                            let timelineScale = 1;
                            if (timelineType == $cd7869ac723b60bd$var$_SkeletonBinary.BONE_SCALE) timeline = new (0, $a99189e38c28e5fb$export$be544e22f6ad7737)(frameCount);
                            else if (timelineType == $cd7869ac723b60bd$var$_SkeletonBinary.BONE_SHEAR) timeline = new (0, $a99189e38c28e5fb$export$4da82436a1a0d773)(frameCount);
                            else {
                                timeline = new (0, $a99189e38c28e5fb$export$eb93bf27829ae703)(frameCount);
                                timelineScale = scale;
                            }
                            timeline.boneIndex = boneIndex;
                            for(let frameIndex = 0; frameIndex < frameCount; frameIndex++){
                                timeline.setFrame(frameIndex, input.readFloat(), input.readFloat() * timelineScale, input.readFloat() * timelineScale);
                                if (frameIndex < frameCount - 1) this.readCurve(input, frameIndex, timeline);
                            }
                            timelines.push(timeline);
                            duration = Math.max(duration, timeline.frames[(frameCount - 1) * (0, $a99189e38c28e5fb$export$eb93bf27829ae703).ENTRIES]);
                            break;
                        }
                }
            }
        }
        for(let i = 0, n = input.readInt(true); i < n; i++){
            const index = input.readInt(true);
            const frameCount = input.readInt(true);
            const timeline = new (0, $a99189e38c28e5fb$export$73d125cd89dead44)(frameCount);
            timeline.ikConstraintIndex = index;
            for(let frameIndex = 0; frameIndex < frameCount; frameIndex++){
                timeline.setFrame(frameIndex, input.readFloat(), input.readFloat(), input.readFloat() * scale, input.readByte(), input.readBoolean(), input.readBoolean());
                if (frameIndex < frameCount - 1) this.readCurve(input, frameIndex, timeline);
            }
            timelines.push(timeline);
            duration = Math.max(duration, timeline.frames[(frameCount - 1) * (0, $a99189e38c28e5fb$export$73d125cd89dead44).ENTRIES]);
        }
        for(let i = 0, n = input.readInt(true); i < n; i++){
            const index = input.readInt(true);
            const frameCount = input.readInt(true);
            const timeline = new (0, $a99189e38c28e5fb$export$a7a393c2ad815ac7)(frameCount);
            timeline.transformConstraintIndex = index;
            for(let frameIndex = 0; frameIndex < frameCount; frameIndex++){
                timeline.setFrame(frameIndex, input.readFloat(), input.readFloat(), input.readFloat(), input.readFloat(), input.readFloat());
                if (frameIndex < frameCount - 1) this.readCurve(input, frameIndex, timeline);
            }
            timelines.push(timeline);
            duration = Math.max(duration, timeline.frames[(frameCount - 1) * (0, $a99189e38c28e5fb$export$a7a393c2ad815ac7).ENTRIES]);
        }
        for(let i = 0, n = input.readInt(true); i < n; i++){
            const index = input.readInt(true);
            const data = skeletonData.pathConstraints[index];
            for(let ii = 0, nn = input.readInt(true); ii < nn; ii++){
                const timelineType = input.readByte();
                const frameCount = input.readInt(true);
                switch(timelineType){
                    case $cd7869ac723b60bd$var$_SkeletonBinary.PATH_POSITION:
                    case $cd7869ac723b60bd$var$_SkeletonBinary.PATH_SPACING:
                        {
                            let timeline;
                            let timelineScale = 1;
                            if (timelineType == $cd7869ac723b60bd$var$_SkeletonBinary.PATH_SPACING) {
                                timeline = new (0, $a99189e38c28e5fb$export$17ee50c08a07e62b)(frameCount);
                                if (data.spacingMode == (0, $f3db500d9e578f13$export$34ce760ad2b0be4b).Length || data.spacingMode == (0, $f3db500d9e578f13$export$34ce760ad2b0be4b).Fixed) timelineScale = scale;
                            } else {
                                timeline = new (0, $a99189e38c28e5fb$export$7ce7e67fd9cc52ed)(frameCount);
                                if (data.positionMode == (0, $2c8db927dc4fcff5$export$34d637c671e1e906).Fixed) timelineScale = scale;
                            }
                            timeline.pathConstraintIndex = index;
                            for(let frameIndex = 0; frameIndex < frameCount; frameIndex++){
                                timeline.setFrame(frameIndex, input.readFloat(), input.readFloat() * timelineScale);
                                if (frameIndex < frameCount - 1) this.readCurve(input, frameIndex, timeline);
                            }
                            timelines.push(timeline);
                            duration = Math.max(duration, timeline.frames[(frameCount - 1) * (0, $a99189e38c28e5fb$export$7ce7e67fd9cc52ed).ENTRIES]);
                            break;
                        }
                    case $cd7869ac723b60bd$var$_SkeletonBinary.PATH_MIX:
                        {
                            const timeline = new (0, $a99189e38c28e5fb$export$ea67b41755485038)(frameCount);
                            timeline.pathConstraintIndex = index;
                            for(let frameIndex = 0; frameIndex < frameCount; frameIndex++){
                                timeline.setFrame(frameIndex, input.readFloat(), input.readFloat(), input.readFloat());
                                if (frameIndex < frameCount - 1) this.readCurve(input, frameIndex, timeline);
                            }
                            timelines.push(timeline);
                            duration = Math.max(duration, timeline.frames[(frameCount - 1) * (0, $a99189e38c28e5fb$export$ea67b41755485038).ENTRIES]);
                            break;
                        }
                }
            }
        }
        for(let i = 0, n = input.readInt(true); i < n; i++){
            const skin = skeletonData.skins[input.readInt(true)];
            for(let ii = 0, nn = input.readInt(true); ii < nn; ii++){
                const slotIndex = input.readInt(true);
                for(let iii = 0, nnn = input.readInt(true); iii < nnn; iii++){
                    const attachment = skin.getAttachment(slotIndex, input.readStringRef());
                    const weighted = attachment.bones != null;
                    const vertices = attachment.vertices;
                    const deformLength = weighted ? vertices.length / 3 * 2 : vertices.length;
                    const frameCount = input.readInt(true);
                    const timeline = new (0, $a99189e38c28e5fb$export$6968d40e5689ad6b)(frameCount);
                    timeline.slotIndex = slotIndex;
                    timeline.attachment = attachment;
                    for(let frameIndex = 0; frameIndex < frameCount; frameIndex++){
                        const time = input.readFloat();
                        let deform;
                        let end = input.readInt(true);
                        if (end == 0) deform = weighted ? (0, $8804784813ffae81$export$d2ca453b913dcdea).newFloatArray(deformLength) : vertices;
                        else {
                            deform = (0, $8804784813ffae81$export$d2ca453b913dcdea).newFloatArray(deformLength);
                            const start = input.readInt(true);
                            end += start;
                            if (scale == 1) for(let v = start; v < end; v++)deform[v] = input.readFloat();
                            else for(let v = start; v < end; v++)deform[v] = input.readFloat() * scale;
                            if (!weighted) for(let v = 0, vn = deform.length; v < vn; v++)deform[v] += vertices[v];
                        }
                        timeline.setFrame(frameIndex, time, deform);
                        if (frameIndex < frameCount - 1) this.readCurve(input, frameIndex, timeline);
                    }
                    timelines.push(timeline);
                    duration = Math.max(duration, timeline.frames[frameCount - 1]);
                }
            }
        }
        const drawOrderCount = input.readInt(true);
        if (drawOrderCount > 0) {
            const timeline = new (0, $a99189e38c28e5fb$export$ece1f7c41d051e83)(drawOrderCount);
            const slotCount = skeletonData.slots.length;
            for(let i = 0; i < drawOrderCount; i++){
                const time = input.readFloat();
                const offsetCount = input.readInt(true);
                const drawOrder = (0, $8804784813ffae81$export$d2ca453b913dcdea).newArray(slotCount, 0);
                for(let ii = slotCount - 1; ii >= 0; ii--)drawOrder[ii] = -1;
                const unchanged = (0, $8804784813ffae81$export$d2ca453b913dcdea).newArray(slotCount - offsetCount, 0);
                let originalIndex = 0;
                let unchangedIndex = 0;
                for(let ii = 0; ii < offsetCount; ii++){
                    const slotIndex = input.readInt(true);
                    while(originalIndex != slotIndex)unchanged[unchangedIndex++] = originalIndex++;
                    drawOrder[originalIndex + input.readInt(true)] = originalIndex++;
                }
                while(originalIndex < slotCount)unchanged[unchangedIndex++] = originalIndex++;
                for(let ii = slotCount - 1; ii >= 0; ii--)if (drawOrder[ii] == -1) drawOrder[ii] = unchanged[--unchangedIndex];
                timeline.setFrame(i, time, drawOrder);
            }
            timelines.push(timeline);
            duration = Math.max(duration, timeline.frames[drawOrderCount - 1]);
        }
        const eventCount = input.readInt(true);
        if (eventCount > 0) {
            const timeline = new (0, $a99189e38c28e5fb$export$4f4bca996c586084)(eventCount);
            for(let i = 0; i < eventCount; i++){
                const time = input.readFloat();
                const eventData = skeletonData.events[input.readInt(true)];
                const event = new (0, $9457b24b76fdec68$export$d61e24a684f9e51)(time, eventData);
                event.intValue = input.readInt(false);
                event.floatValue = input.readFloat();
                event.stringValue = input.readBoolean() ? input.readString() : eventData.stringValue;
                if (event.data.audioPath != null) {
                    event.volume = input.readFloat();
                    event.balance = input.readFloat();
                }
                timeline.setFrame(i, event);
            }
            timelines.push(timeline);
            duration = Math.max(duration, timeline.frames[eventCount - 1]);
        }
        return new (0, $a99189e38c28e5fb$export$c35d437ae5945fcd)(name, timelines, duration);
    }
    readCurve(input, frameIndex, timeline) {
        switch(input.readByte()){
            case $cd7869ac723b60bd$var$_SkeletonBinary.CURVE_STEPPED:
                timeline.setStepped(frameIndex);
                break;
            case $cd7869ac723b60bd$var$_SkeletonBinary.CURVE_BEZIER:
                this.setCurve(timeline, frameIndex, input.readFloat(), input.readFloat(), input.readFloat(), input.readFloat());
                break;
        }
    }
    setCurve(timeline, frameIndex, cx1, cy1, cx2, cy2) {
        timeline.setCurve(frameIndex, cx1, cy1, cx2, cy2);
    }
};
let $cd7869ac723b60bd$export$a7f7eaf4e9fce9ef = $cd7869ac723b60bd$var$_SkeletonBinary;
$cd7869ac723b60bd$export$a7f7eaf4e9fce9ef.AttachmentTypeValues = [
    0,
    1,
    2,
    3,
    4,
    5,
    6
];
$cd7869ac723b60bd$export$a7f7eaf4e9fce9ef.TransformModeValues = [
    (0, $ccc5aebc60cbf024$export$4c408f82786a534d).Normal,
    (0, $ccc5aebc60cbf024$export$4c408f82786a534d).OnlyTranslation,
    (0, $ccc5aebc60cbf024$export$4c408f82786a534d).NoRotationOrReflection,
    (0, $ccc5aebc60cbf024$export$4c408f82786a534d).NoScale,
    (0, $ccc5aebc60cbf024$export$4c408f82786a534d).NoScaleOrReflection
];
$cd7869ac723b60bd$export$a7f7eaf4e9fce9ef.PositionModeValues = [
    (0, $2c8db927dc4fcff5$export$34d637c671e1e906).Fixed,
    (0, $2c8db927dc4fcff5$export$34d637c671e1e906).Percent
];
$cd7869ac723b60bd$export$a7f7eaf4e9fce9ef.SpacingModeValues = [
    (0, $f3db500d9e578f13$export$34ce760ad2b0be4b).Length,
    (0, $f3db500d9e578f13$export$34ce760ad2b0be4b).Fixed,
    (0, $f3db500d9e578f13$export$34ce760ad2b0be4b).Percent
];
$cd7869ac723b60bd$export$a7f7eaf4e9fce9ef.RotateModeValues = [
    (0, $2c8db927dc4fcff5$export$a2a23846581ac82c).Tangent,
    (0, $2c8db927dc4fcff5$export$a2a23846581ac82c).Chain,
    (0, $2c8db927dc4fcff5$export$a2a23846581ac82c).ChainScale
];
$cd7869ac723b60bd$export$a7f7eaf4e9fce9ef.BlendModeValues = [
    (0, $0fa4b07f86297abd$export$f821c68fe9beaecf).NORMAL,
    (0, $0fa4b07f86297abd$export$f821c68fe9beaecf).ADD,
    (0, $0fa4b07f86297abd$export$f821c68fe9beaecf).MULTIPLY,
    (0, $0fa4b07f86297abd$export$f821c68fe9beaecf).SCREEN
];
$cd7869ac723b60bd$export$a7f7eaf4e9fce9ef.BONE_ROTATE = 0;
$cd7869ac723b60bd$export$a7f7eaf4e9fce9ef.BONE_TRANSLATE = 1;
$cd7869ac723b60bd$export$a7f7eaf4e9fce9ef.BONE_SCALE = 2;
$cd7869ac723b60bd$export$a7f7eaf4e9fce9ef.BONE_SHEAR = 3;
$cd7869ac723b60bd$export$a7f7eaf4e9fce9ef.SLOT_ATTACHMENT = 0;
$cd7869ac723b60bd$export$a7f7eaf4e9fce9ef.SLOT_COLOR = 1;
$cd7869ac723b60bd$export$a7f7eaf4e9fce9ef.SLOT_TWO_COLOR = 2;
$cd7869ac723b60bd$export$a7f7eaf4e9fce9ef.PATH_POSITION = 0;
$cd7869ac723b60bd$export$a7f7eaf4e9fce9ef.PATH_SPACING = 1;
$cd7869ac723b60bd$export$a7f7eaf4e9fce9ef.PATH_MIX = 2;
$cd7869ac723b60bd$export$a7f7eaf4e9fce9ef.CURVE_LINEAR = 0;
$cd7869ac723b60bd$export$a7f7eaf4e9fce9ef.CURVE_STEPPED = 1;
$cd7869ac723b60bd$export$a7f7eaf4e9fce9ef.CURVE_BEZIER = 2;
class $cd7869ac723b60bd$var$LinkedMesh {
    constructor(mesh, skin, slotIndex, parent, inheritDeform){
        this.mesh = mesh;
        this.skin = skin;
        this.slotIndex = slotIndex;
        this.parent = parent;
        this.inheritDeform = inheritDeform;
    }
}
class $cd7869ac723b60bd$var$Vertices {
    constructor(bones = null, vertices = null){
        this.bones = bones;
        this.vertices = vertices;
    }
}



class $88b9d0ae7c827eed$export$119f1746fc062f5e extends (0, $f207f4fe652f3622$export$a40a4b6b6d62719b) {
}















class $d82ca02a4894c3a8$export$8913b5e618c6d2f3 {
    constructor(attachmentLoader){
        this.scale = 1;
        this.linkedMeshes = new Array();
        this.attachmentLoader = attachmentLoader;
    }
    readSkeletonData(json) {
        const scale = this.scale;
        const skeletonData = new (0, $55d718d92918b306$export$e8f362f163550575)();
        const root = typeof json === "string" ? JSON.parse(json) : json;
        const skeletonMap = root.skeleton;
        if (skeletonMap != null) {
            skeletonData.hash = skeletonMap.hash;
            skeletonData.version = skeletonMap.spine;
            if (skeletonData.version.substr(0, 3) !== "3.8") {
                const error = `Spine 3.8 loader cant load version ${skeletonMap.spine}. Please configure your pixi-spine bundle`;
                console.error(error);
            }
            if (skeletonData.version === "3.8.75") {
                const error = `Unsupported skeleton data, 3.8.75 is deprecated, please export with a newer version of Spine.`;
                console.error(error);
            }
            skeletonData.x = skeletonMap.x;
            skeletonData.y = skeletonMap.y;
            skeletonData.width = skeletonMap.width;
            skeletonData.height = skeletonMap.height;
            skeletonData.fps = skeletonMap.fps;
            skeletonData.imagesPath = skeletonMap.images;
        }
        if (root.bones) for(let i = 0; i < root.bones.length; i++){
            const boneMap = root.bones[i];
            let parent = null;
            const parentName = this.getValue(boneMap, "parent", null);
            if (parentName != null) {
                parent = skeletonData.findBone(parentName);
                if (parent == null) throw new Error(`Parent bone not found: ${parentName}`);
            }
            const data = new (0, $53352ede0f332990$export$7d85d96cf093e12f)(skeletonData.bones.length, boneMap.name, parent);
            data.length = this.getValue(boneMap, "length", 0) * scale;
            data.x = this.getValue(boneMap, "x", 0) * scale;
            data.y = this.getValue(boneMap, "y", 0) * scale;
            data.rotation = this.getValue(boneMap, "rotation", 0);
            data.scaleX = this.getValue(boneMap, "scaleX", 1);
            data.scaleY = this.getValue(boneMap, "scaleY", 1);
            data.shearX = this.getValue(boneMap, "shearX", 0);
            data.shearY = this.getValue(boneMap, "shearY", 0);
            data.transformMode = $d82ca02a4894c3a8$export$8913b5e618c6d2f3.transformModeFromString(this.getValue(boneMap, "transform", "normal"));
            data.skinRequired = this.getValue(boneMap, "skin", false);
            skeletonData.bones.push(data);
        }
        if (root.slots) for(let i = 0; i < root.slots.length; i++){
            const slotMap = root.slots[i];
            const slotName = slotMap.name;
            const boneName = slotMap.bone;
            const boneData = skeletonData.findBone(boneName);
            if (boneData == null) throw new Error(`Slot bone not found: ${boneName}`);
            const data = new (0, $2cfe2e8ef95dfc1b$export$a4cce1bf50208679)(skeletonData.slots.length, slotName, boneData);
            const color = this.getValue(slotMap, "color", null);
            if (color != null) data.color.setFromString(color);
            const dark = this.getValue(slotMap, "dark", null);
            if (dark != null) {
                data.darkColor = new (0, $8804784813ffae81$export$892596cec99bc70e)(1, 1, 1, 1);
                data.darkColor.setFromString(dark);
            }
            data.attachmentName = this.getValue(slotMap, "attachment", null);
            data.blendMode = $d82ca02a4894c3a8$export$8913b5e618c6d2f3.blendModeFromString(this.getValue(slotMap, "blend", "normal"));
            skeletonData.slots.push(data);
        }
        if (root.ik) for(let i = 0; i < root.ik.length; i++){
            const constraintMap = root.ik[i];
            const data = new (0, $c7dead7a06471124$export$adcb08b651fc712e)(constraintMap.name);
            data.order = this.getValue(constraintMap, "order", 0);
            data.skinRequired = this.getValue(constraintMap, "skin", false);
            for(let j = 0; j < constraintMap.bones.length; j++){
                const boneName = constraintMap.bones[j];
                const bone = skeletonData.findBone(boneName);
                if (bone == null) throw new Error(`IK bone not found: ${boneName}`);
                data.bones.push(bone);
            }
            const targetName = constraintMap.target;
            data.target = skeletonData.findBone(targetName);
            if (data.target == null) throw new Error(`IK target bone not found: ${targetName}`);
            data.mix = this.getValue(constraintMap, "mix", 1);
            data.softness = this.getValue(constraintMap, "softness", 0) * scale;
            data.bendDirection = this.getValue(constraintMap, "bendPositive", true) ? 1 : -1;
            data.compress = this.getValue(constraintMap, "compress", false);
            data.stretch = this.getValue(constraintMap, "stretch", false);
            data.uniform = this.getValue(constraintMap, "uniform", false);
            skeletonData.ikConstraints.push(data);
        }
        if (root.transform) for(let i = 0; i < root.transform.length; i++){
            const constraintMap = root.transform[i];
            const data = new (0, $0afd2e509d2277c4$export$823fbc29771afdb5)(constraintMap.name);
            data.order = this.getValue(constraintMap, "order", 0);
            data.skinRequired = this.getValue(constraintMap, "skin", false);
            for(let j = 0; j < constraintMap.bones.length; j++){
                const boneName = constraintMap.bones[j];
                const bone = skeletonData.findBone(boneName);
                if (bone == null) throw new Error(`Transform constraint bone not found: ${boneName}`);
                data.bones.push(bone);
            }
            const targetName = constraintMap.target;
            data.target = skeletonData.findBone(targetName);
            if (data.target == null) throw new Error(`Transform constraint target bone not found: ${targetName}`);
            data.local = this.getValue(constraintMap, "local", false);
            data.relative = this.getValue(constraintMap, "relative", false);
            data.offsetRotation = this.getValue(constraintMap, "rotation", 0);
            data.offsetX = this.getValue(constraintMap, "x", 0) * scale;
            data.offsetY = this.getValue(constraintMap, "y", 0) * scale;
            data.offsetScaleX = this.getValue(constraintMap, "scaleX", 0);
            data.offsetScaleY = this.getValue(constraintMap, "scaleY", 0);
            data.offsetShearY = this.getValue(constraintMap, "shearY", 0);
            data.rotateMix = this.getValue(constraintMap, "rotateMix", 1);
            data.translateMix = this.getValue(constraintMap, "translateMix", 1);
            data.scaleMix = this.getValue(constraintMap, "scaleMix", 1);
            data.shearMix = this.getValue(constraintMap, "shearMix", 1);
            skeletonData.transformConstraints.push(data);
        }
        if (root.path) for(let i = 0; i < root.path.length; i++){
            const constraintMap = root.path[i];
            const data = new (0, $f3db500d9e578f13$export$d2629ab80d5dd5ba)(constraintMap.name);
            data.order = this.getValue(constraintMap, "order", 0);
            data.skinRequired = this.getValue(constraintMap, "skin", false);
            for(let j = 0; j < constraintMap.bones.length; j++){
                const boneName = constraintMap.bones[j];
                const bone = skeletonData.findBone(boneName);
                if (bone == null) throw new Error(`Transform constraint bone not found: ${boneName}`);
                data.bones.push(bone);
            }
            const targetName = constraintMap.target;
            data.target = skeletonData.findSlot(targetName);
            if (data.target == null) throw new Error(`Path target slot not found: ${targetName}`);
            data.positionMode = $d82ca02a4894c3a8$export$8913b5e618c6d2f3.positionModeFromString(this.getValue(constraintMap, "positionMode", "percent"));
            data.spacingMode = $d82ca02a4894c3a8$export$8913b5e618c6d2f3.spacingModeFromString(this.getValue(constraintMap, "spacingMode", "length"));
            data.rotateMode = $d82ca02a4894c3a8$export$8913b5e618c6d2f3.rotateModeFromString(this.getValue(constraintMap, "rotateMode", "tangent"));
            data.offsetRotation = this.getValue(constraintMap, "rotation", 0);
            data.position = this.getValue(constraintMap, "position", 0);
            if (data.positionMode == (0, $2c8db927dc4fcff5$export$34d637c671e1e906).Fixed) data.position *= scale;
            data.spacing = this.getValue(constraintMap, "spacing", 0);
            if (data.spacingMode == (0, $f3db500d9e578f13$export$34ce760ad2b0be4b).Length || data.spacingMode == (0, $f3db500d9e578f13$export$34ce760ad2b0be4b).Fixed) data.spacing *= scale;
            data.rotateMix = this.getValue(constraintMap, "rotateMix", 1);
            data.translateMix = this.getValue(constraintMap, "translateMix", 1);
            skeletonData.pathConstraints.push(data);
        }
        if (root.skins) for(let i = 0; i < root.skins.length; i++){
            const skinMap = root.skins[i];
            const skin = new (0, $4e95b87485e4f6dc$export$b8e0f93a76772233)(skinMap.name);
            if (skinMap.bones) for(let ii = 0; ii < skinMap.bones.length; ii++){
                const bone = skeletonData.findBone(skinMap.bones[ii]);
                if (bone == null) throw new Error(`Skin bone not found: ${skinMap.bones[i]}`);
                skin.bones.push(bone);
            }
            if (skinMap.ik) for(let ii = 0; ii < skinMap.ik.length; ii++){
                const constraint = skeletonData.findIkConstraint(skinMap.ik[ii]);
                if (constraint == null) throw new Error(`Skin IK constraint not found: ${skinMap.ik[i]}`);
                skin.constraints.push(constraint);
            }
            if (skinMap.transform) for(let ii = 0; ii < skinMap.transform.length; ii++){
                const constraint = skeletonData.findTransformConstraint(skinMap.transform[ii]);
                if (constraint == null) throw new Error(`Skin transform constraint not found: ${skinMap.transform[i]}`);
                skin.constraints.push(constraint);
            }
            if (skinMap.path) for(let ii = 0; ii < skinMap.path.length; ii++){
                const constraint = skeletonData.findPathConstraint(skinMap.path[ii]);
                if (constraint == null) throw new Error(`Skin path constraint not found: ${skinMap.path[i]}`);
                skin.constraints.push(constraint);
            }
            for(const slotName in skinMap.attachments){
                const slot = skeletonData.findSlot(slotName);
                if (slot == null) throw new Error(`Slot not found: ${slotName}`);
                const slotMap = skinMap.attachments[slotName];
                for(const entryName in slotMap){
                    const attachment = this.readAttachment(slotMap[entryName], skin, slot.index, entryName, skeletonData);
                    if (attachment != null) skin.setAttachment(slot.index, entryName, attachment);
                }
            }
            skeletonData.skins.push(skin);
            if (skin.name == "default") skeletonData.defaultSkin = skin;
        }
        for(let i = 0, n = this.linkedMeshes.length; i < n; i++){
            const linkedMesh = this.linkedMeshes[i];
            const skin = linkedMesh.skin == null ? skeletonData.defaultSkin : skeletonData.findSkin(linkedMesh.skin);
            if (skin == null) throw new Error(`Skin not found: ${linkedMesh.skin}`);
            const parent = skin.getAttachment(linkedMesh.slotIndex, linkedMesh.parent);
            if (parent == null) throw new Error(`Parent mesh not found: ${linkedMesh.parent}`);
            linkedMesh.mesh.deformAttachment = linkedMesh.inheritDeform ? parent : linkedMesh.mesh;
            linkedMesh.mesh.setParentMesh(parent);
        }
        this.linkedMeshes.length = 0;
        if (root.events) for(const eventName in root.events){
            const eventMap = root.events[eventName];
            const data = new (0, $6449a1e1fcf4967a$export$a5cf049e34c3d11e)(eventName);
            data.intValue = this.getValue(eventMap, "int", 0);
            data.floatValue = this.getValue(eventMap, "float", 0);
            data.stringValue = this.getValue(eventMap, "string", "");
            data.audioPath = this.getValue(eventMap, "audio", null);
            if (data.audioPath != null) {
                data.volume = this.getValue(eventMap, "volume", 1);
                data.balance = this.getValue(eventMap, "balance", 0);
            }
            skeletonData.events.push(data);
        }
        if (root.animations) for(const animationName in root.animations){
            const animationMap = root.animations[animationName];
            this.readAnimation(animationMap, animationName, skeletonData);
        }
        return skeletonData;
    }
    readAttachment(map, skin, slotIndex, name, skeletonData) {
        const scale = this.scale;
        name = this.getValue(map, "name", name);
        const type = this.getValue(map, "type", "region");
        switch(type){
            case "region":
                {
                    const path = this.getValue(map, "path", name);
                    const region = this.attachmentLoader.newRegionAttachment(skin, name, path);
                    if (region == null) return null;
                    region.path = path;
                    region.x = this.getValue(map, "x", 0) * scale;
                    region.y = this.getValue(map, "y", 0) * scale;
                    region.scaleX = this.getValue(map, "scaleX", 1);
                    region.scaleY = this.getValue(map, "scaleY", 1);
                    region.rotation = this.getValue(map, "rotation", 0);
                    region.width = map.width * scale;
                    region.height = map.height * scale;
                    const color = this.getValue(map, "color", null);
                    if (color != null) region.color.setFromString(color);
                    return region;
                }
            case "boundingbox":
                {
                    const box = this.attachmentLoader.newBoundingBoxAttachment(skin, name);
                    if (box == null) return null;
                    this.readVertices(map, box, map.vertexCount << 1);
                    const color = this.getValue(map, "color", null);
                    if (color != null) box.color.setFromString(color);
                    return box;
                }
            case "mesh":
            case "linkedmesh":
                {
                    const path = this.getValue(map, "path", name);
                    const mesh = this.attachmentLoader.newMeshAttachment(skin, name, path);
                    if (mesh == null) return null;
                    mesh.path = path;
                    const color = this.getValue(map, "color", null);
                    if (color != null) mesh.color.setFromString(color);
                    mesh.width = this.getValue(map, "width", 0) * scale;
                    mesh.height = this.getValue(map, "height", 0) * scale;
                    const parent = this.getValue(map, "parent", null);
                    if (parent != null) {
                        this.linkedMeshes.push(new $d82ca02a4894c3a8$var$LinkedMesh(mesh, this.getValue(map, "skin", null), slotIndex, parent, this.getValue(map, "deform", true)));
                        return mesh;
                    }
                    const uvs = map.uvs;
                    this.readVertices(map, mesh, uvs.length);
                    mesh.triangles = map.triangles;
                    mesh.regionUVs = new Float32Array(uvs);
                    mesh.edges = this.getValue(map, "edges", null);
                    mesh.hullLength = this.getValue(map, "hull", 0) * 2;
                    return mesh;
                }
            case "path":
                {
                    const path = this.attachmentLoader.newPathAttachment(skin, name);
                    if (path == null) return null;
                    path.closed = this.getValue(map, "closed", false);
                    path.constantSpeed = this.getValue(map, "constantSpeed", true);
                    const vertexCount = map.vertexCount;
                    this.readVertices(map, path, vertexCount << 1);
                    const lengths = (0, $8804784813ffae81$export$d2ca453b913dcdea).newArray(vertexCount / 3, 0);
                    for(let i = 0; i < map.lengths.length; i++)lengths[i] = map.lengths[i] * scale;
                    path.lengths = lengths;
                    const color = this.getValue(map, "color", null);
                    if (color != null) path.color.setFromString(color);
                    return path;
                }
            case "point":
                {
                    const point = this.attachmentLoader.newPointAttachment(skin, name);
                    if (point == null) return null;
                    point.x = this.getValue(map, "x", 0) * scale;
                    point.y = this.getValue(map, "y", 0) * scale;
                    point.rotation = this.getValue(map, "rotation", 0);
                    const color = this.getValue(map, "color", null);
                    if (color != null) point.color.setFromString(color);
                    return point;
                }
            case "clipping":
                {
                    const clip = this.attachmentLoader.newClippingAttachment(skin, name);
                    if (clip == null) return null;
                    const end = this.getValue(map, "end", null);
                    if (end != null) {
                        const slot = skeletonData.findSlot(end);
                        if (slot == null) throw new Error(`Clipping end slot not found: ${end}`);
                        clip.endSlot = slot;
                    }
                    const vertexCount = map.vertexCount;
                    this.readVertices(map, clip, vertexCount << 1);
                    const color = this.getValue(map, "color", null);
                    if (color != null) clip.color.setFromString(color);
                    return clip;
                }
        }
        return null;
    }
    readVertices(map, attachment, verticesLength) {
        const scale = this.scale;
        attachment.worldVerticesLength = verticesLength;
        const vertices = map.vertices;
        if (verticesLength == vertices.length) {
            const scaledVertices = (0, $8804784813ffae81$export$d2ca453b913dcdea).toFloatArray(vertices);
            if (scale != 1) for(let i = 0, n = vertices.length; i < n; i++)scaledVertices[i] *= scale;
            attachment.vertices = scaledVertices;
            return;
        }
        const weights = new Array();
        const bones = new Array();
        for(let i = 0, n = vertices.length; i < n;){
            const boneCount = vertices[i++];
            bones.push(boneCount);
            for(let nn = i + boneCount * 4; i < nn; i += 4){
                bones.push(vertices[i]);
                weights.push(vertices[i + 1] * scale);
                weights.push(vertices[i + 2] * scale);
                weights.push(vertices[i + 3]);
            }
        }
        attachment.bones = bones;
        attachment.vertices = (0, $8804784813ffae81$export$d2ca453b913dcdea).toFloatArray(weights);
    }
    readAnimation(map, name, skeletonData) {
        const scale = this.scale;
        const timelines = new Array();
        let duration = 0;
        if (map.slots) for(const slotName in map.slots){
            const slotMap = map.slots[slotName];
            const slotIndex = skeletonData.findSlotIndex(slotName);
            if (slotIndex == -1) throw new Error(`Slot not found: ${slotName}`);
            for(const timelineName in slotMap){
                const timelineMap = slotMap[timelineName];
                if (timelineName == "attachment") {
                    const timeline = new (0, $a99189e38c28e5fb$export$7f2bfc5bd27cb43d)(timelineMap.length);
                    timeline.slotIndex = slotIndex;
                    let frameIndex = 0;
                    for(let i = 0; i < timelineMap.length; i++){
                        const valueMap = timelineMap[i];
                        timeline.setFrame(frameIndex++, this.getValue(valueMap, "time", 0), valueMap.name);
                    }
                    timelines.push(timeline);
                    duration = Math.max(duration, timeline.frames[timeline.getFrameCount() - 1]);
                } else if (timelineName == "color") {
                    const timeline = new (0, $a99189e38c28e5fb$export$565fcb3610070d7f)(timelineMap.length);
                    timeline.slotIndex = slotIndex;
                    let frameIndex = 0;
                    for(let i = 0; i < timelineMap.length; i++){
                        const valueMap = timelineMap[i];
                        const color = new (0, $8804784813ffae81$export$892596cec99bc70e)();
                        color.setFromString(valueMap.color || "ffffffff");
                        timeline.setFrame(frameIndex, this.getValue(valueMap, "time", 0), color.r, color.g, color.b, color.a);
                        this.readCurve(valueMap, timeline, frameIndex);
                        frameIndex++;
                    }
                    timelines.push(timeline);
                    duration = Math.max(duration, timeline.frames[(timeline.getFrameCount() - 1) * (0, $a99189e38c28e5fb$export$565fcb3610070d7f).ENTRIES]);
                } else if (timelineName == "twoColor") {
                    const timeline = new (0, $a99189e38c28e5fb$export$938c1752e1b56539)(timelineMap.length);
                    timeline.slotIndex = slotIndex;
                    let frameIndex = 0;
                    for(let i = 0; i < timelineMap.length; i++){
                        const valueMap = timelineMap[i];
                        const light = new (0, $8804784813ffae81$export$892596cec99bc70e)();
                        const dark = new (0, $8804784813ffae81$export$892596cec99bc70e)();
                        light.setFromString(valueMap.light);
                        dark.setFromString(valueMap.dark);
                        timeline.setFrame(frameIndex, this.getValue(valueMap, "time", 0), light.r, light.g, light.b, light.a, dark.r, dark.g, dark.b);
                        this.readCurve(valueMap, timeline, frameIndex);
                        frameIndex++;
                    }
                    timelines.push(timeline);
                    duration = Math.max(duration, timeline.frames[(timeline.getFrameCount() - 1) * (0, $a99189e38c28e5fb$export$938c1752e1b56539).ENTRIES]);
                } else throw new Error(`Invalid timeline type for a slot: ${timelineName} (${slotName})`);
            }
        }
        if (map.bones) for(const boneName in map.bones){
            const boneMap = map.bones[boneName];
            const boneIndex = skeletonData.findBoneIndex(boneName);
            if (boneIndex == -1) throw new Error(`Bone not found: ${boneName}`);
            for(const timelineName in boneMap){
                const timelineMap = boneMap[timelineName];
                if (timelineName === "rotate") {
                    const timeline = new (0, $a99189e38c28e5fb$export$b7ecb8f68b3e130b)(timelineMap.length);
                    timeline.boneIndex = boneIndex;
                    let frameIndex = 0;
                    for(let i = 0; i < timelineMap.length; i++){
                        const valueMap = timelineMap[i];
                        timeline.setFrame(frameIndex, this.getValue(valueMap, "time", 0), this.getValue(valueMap, "angle", 0));
                        this.readCurve(valueMap, timeline, frameIndex);
                        frameIndex++;
                    }
                    timelines.push(timeline);
                    duration = Math.max(duration, timeline.frames[(timeline.getFrameCount() - 1) * (0, $a99189e38c28e5fb$export$b7ecb8f68b3e130b).ENTRIES]);
                } else if (timelineName === "translate" || timelineName === "scale" || timelineName === "shear") {
                    let timeline = null;
                    let timelineScale = 1;
                    let defaultValue = 0;
                    if (timelineName === "scale") {
                        timeline = new (0, $a99189e38c28e5fb$export$be544e22f6ad7737)(timelineMap.length);
                        defaultValue = 1;
                    } else if (timelineName === "shear") timeline = new (0, $a99189e38c28e5fb$export$4da82436a1a0d773)(timelineMap.length);
                    else {
                        timeline = new (0, $a99189e38c28e5fb$export$eb93bf27829ae703)(timelineMap.length);
                        timelineScale = scale;
                    }
                    timeline.boneIndex = boneIndex;
                    let frameIndex = 0;
                    for(let i = 0; i < timelineMap.length; i++){
                        const valueMap = timelineMap[i];
                        const x = this.getValue(valueMap, "x", defaultValue);
                        const y = this.getValue(valueMap, "y", defaultValue);
                        timeline.setFrame(frameIndex, this.getValue(valueMap, "time", 0), x * timelineScale, y * timelineScale);
                        this.readCurve(valueMap, timeline, frameIndex);
                        frameIndex++;
                    }
                    timelines.push(timeline);
                    duration = Math.max(duration, timeline.frames[(timeline.getFrameCount() - 1) * (0, $a99189e38c28e5fb$export$eb93bf27829ae703).ENTRIES]);
                } else throw new Error(`Invalid timeline type for a bone: ${timelineName} (${boneName})`);
            }
        }
        if (map.ik) for(const constraintName in map.ik){
            const constraintMap = map.ik[constraintName];
            const constraint = skeletonData.findIkConstraint(constraintName);
            const timeline = new (0, $a99189e38c28e5fb$export$73d125cd89dead44)(constraintMap.length);
            timeline.ikConstraintIndex = skeletonData.ikConstraints.indexOf(constraint);
            let frameIndex = 0;
            for(let i = 0; i < constraintMap.length; i++){
                const valueMap = constraintMap[i];
                timeline.setFrame(frameIndex, this.getValue(valueMap, "time", 0), this.getValue(valueMap, "mix", 1), this.getValue(valueMap, "softness", 0) * scale, this.getValue(valueMap, "bendPositive", true) ? 1 : -1, this.getValue(valueMap, "compress", false), this.getValue(valueMap, "stretch", false));
                this.readCurve(valueMap, timeline, frameIndex);
                frameIndex++;
            }
            timelines.push(timeline);
            duration = Math.max(duration, timeline.frames[(timeline.getFrameCount() - 1) * (0, $a99189e38c28e5fb$export$73d125cd89dead44).ENTRIES]);
        }
        if (map.transform) for(const constraintName in map.transform){
            const constraintMap = map.transform[constraintName];
            const constraint = skeletonData.findTransformConstraint(constraintName);
            const timeline = new (0, $a99189e38c28e5fb$export$a7a393c2ad815ac7)(constraintMap.length);
            timeline.transformConstraintIndex = skeletonData.transformConstraints.indexOf(constraint);
            let frameIndex = 0;
            for(let i = 0; i < constraintMap.length; i++){
                const valueMap = constraintMap[i];
                timeline.setFrame(frameIndex, this.getValue(valueMap, "time", 0), this.getValue(valueMap, "rotateMix", 1), this.getValue(valueMap, "translateMix", 1), this.getValue(valueMap, "scaleMix", 1), this.getValue(valueMap, "shearMix", 1));
                this.readCurve(valueMap, timeline, frameIndex);
                frameIndex++;
            }
            timelines.push(timeline);
            duration = Math.max(duration, timeline.frames[(timeline.getFrameCount() - 1) * (0, $a99189e38c28e5fb$export$a7a393c2ad815ac7).ENTRIES]);
        }
        if (map.path) for(const constraintName in map.path){
            const constraintMap = map.path[constraintName];
            const index = skeletonData.findPathConstraintIndex(constraintName);
            if (index == -1) throw new Error(`Path constraint not found: ${constraintName}`);
            const data = skeletonData.pathConstraints[index];
            for(const timelineName in constraintMap){
                const timelineMap = constraintMap[timelineName];
                if (timelineName === "position" || timelineName === "spacing") {
                    let timeline = null;
                    let timelineScale = 1;
                    if (timelineName === "spacing") {
                        timeline = new (0, $a99189e38c28e5fb$export$17ee50c08a07e62b)(timelineMap.length);
                        if (data.spacingMode == (0, $f3db500d9e578f13$export$34ce760ad2b0be4b).Length || data.spacingMode == (0, $f3db500d9e578f13$export$34ce760ad2b0be4b).Fixed) timelineScale = scale;
                    } else {
                        timeline = new (0, $a99189e38c28e5fb$export$7ce7e67fd9cc52ed)(timelineMap.length);
                        if (data.positionMode == (0, $2c8db927dc4fcff5$export$34d637c671e1e906).Fixed) timelineScale = scale;
                    }
                    timeline.pathConstraintIndex = index;
                    let frameIndex = 0;
                    for(let i = 0; i < timelineMap.length; i++){
                        const valueMap = timelineMap[i];
                        timeline.setFrame(frameIndex, this.getValue(valueMap, "time", 0), this.getValue(valueMap, timelineName, 0) * timelineScale);
                        this.readCurve(valueMap, timeline, frameIndex);
                        frameIndex++;
                    }
                    timelines.push(timeline);
                    duration = Math.max(duration, timeline.frames[(timeline.getFrameCount() - 1) * (0, $a99189e38c28e5fb$export$7ce7e67fd9cc52ed).ENTRIES]);
                } else if (timelineName === "mix") {
                    const timeline = new (0, $a99189e38c28e5fb$export$ea67b41755485038)(timelineMap.length);
                    timeline.pathConstraintIndex = index;
                    let frameIndex = 0;
                    for(let i = 0; i < timelineMap.length; i++){
                        const valueMap = timelineMap[i];
                        timeline.setFrame(frameIndex, this.getValue(valueMap, "time", 0), this.getValue(valueMap, "rotateMix", 1), this.getValue(valueMap, "translateMix", 1));
                        this.readCurve(valueMap, timeline, frameIndex);
                        frameIndex++;
                    }
                    timelines.push(timeline);
                    duration = Math.max(duration, timeline.frames[(timeline.getFrameCount() - 1) * (0, $a99189e38c28e5fb$export$ea67b41755485038).ENTRIES]);
                }
            }
        }
        if (map.deform) for(const deformName in map.deform){
            const deformMap = map.deform[deformName];
            const skin = skeletonData.findSkin(deformName);
            if (skin == null) {
                if ((0, $1840f66876ded594$export$a5a6e0b888b2c992).FAIL_ON_NON_EXISTING_SKIN) throw new Error(`Skin not found: ${deformName}`);
                else continue;
            }
            for(const slotName in deformMap){
                const slotMap = deformMap[slotName];
                const slotIndex = skeletonData.findSlotIndex(slotName);
                if (slotIndex == -1) throw new Error(`Slot not found: ${slotMap.name}`);
                for(const timelineName in slotMap){
                    const timelineMap = slotMap[timelineName];
                    const attachment = skin.getAttachment(slotIndex, timelineName);
                    if (attachment == null) throw new Error(`Deform attachment not found: ${timelineMap.name}`);
                    const weighted = attachment.bones != null;
                    const vertices = attachment.vertices;
                    const deformLength = weighted ? vertices.length / 3 * 2 : vertices.length;
                    const timeline = new (0, $a99189e38c28e5fb$export$6968d40e5689ad6b)(timelineMap.length);
                    timeline.slotIndex = slotIndex;
                    timeline.attachment = attachment;
                    let frameIndex = 0;
                    for(let j = 0; j < timelineMap.length; j++){
                        const valueMap = timelineMap[j];
                        let deform;
                        const verticesValue = this.getValue(valueMap, "vertices", null);
                        if (verticesValue == null) deform = weighted ? (0, $8804784813ffae81$export$d2ca453b913dcdea).newFloatArray(deformLength) : vertices;
                        else {
                            deform = (0, $8804784813ffae81$export$d2ca453b913dcdea).newFloatArray(deformLength);
                            const start = this.getValue(valueMap, "offset", 0);
                            (0, $8804784813ffae81$export$d2ca453b913dcdea).arrayCopy(verticesValue, 0, deform, start, verticesValue.length);
                            if (scale != 1) for(let i = start, n = i + verticesValue.length; i < n; i++)deform[i] *= scale;
                            if (!weighted) for(let i = 0; i < deformLength; i++)deform[i] += vertices[i];
                        }
                        timeline.setFrame(frameIndex, this.getValue(valueMap, "time", 0), deform);
                        this.readCurve(valueMap, timeline, frameIndex);
                        frameIndex++;
                    }
                    timelines.push(timeline);
                    duration = Math.max(duration, timeline.frames[timeline.getFrameCount() - 1]);
                }
            }
        }
        let drawOrderNode = map.drawOrder;
        if (drawOrderNode == null) drawOrderNode = map.draworder;
        if (drawOrderNode != null) {
            const timeline = new (0, $a99189e38c28e5fb$export$ece1f7c41d051e83)(drawOrderNode.length);
            const slotCount = skeletonData.slots.length;
            let frameIndex = 0;
            for(let j = 0; j < drawOrderNode.length; j++){
                const drawOrderMap = drawOrderNode[j];
                let drawOrder = null;
                const offsets = this.getValue(drawOrderMap, "offsets", null);
                if (offsets != null) {
                    drawOrder = (0, $8804784813ffae81$export$d2ca453b913dcdea).newArray(slotCount, -1);
                    const unchanged = (0, $8804784813ffae81$export$d2ca453b913dcdea).newArray(slotCount - offsets.length, 0);
                    let originalIndex = 0;
                    let unchangedIndex = 0;
                    for(let i = 0; i < offsets.length; i++){
                        const offsetMap = offsets[i];
                        const slotIndex = skeletonData.findSlotIndex(offsetMap.slot);
                        if (slotIndex == -1) throw new Error(`Slot not found: ${offsetMap.slot}`);
                        while(originalIndex != slotIndex)unchanged[unchangedIndex++] = originalIndex++;
                        drawOrder[originalIndex + offsetMap.offset] = originalIndex++;
                    }
                    while(originalIndex < slotCount)unchanged[unchangedIndex++] = originalIndex++;
                    for(let i = slotCount - 1; i >= 0; i--)if (drawOrder[i] == -1) drawOrder[i] = unchanged[--unchangedIndex];
                }
                timeline.setFrame(frameIndex++, this.getValue(drawOrderMap, "time", 0), drawOrder);
            }
            timelines.push(timeline);
            duration = Math.max(duration, timeline.frames[timeline.getFrameCount() - 1]);
        }
        if (map.events) {
            const timeline = new (0, $a99189e38c28e5fb$export$4f4bca996c586084)(map.events.length);
            let frameIndex = 0;
            for(let i = 0; i < map.events.length; i++){
                const eventMap = map.events[i];
                const eventData = skeletonData.findEvent(eventMap.name);
                if (eventData == null) throw new Error(`Event not found: ${eventMap.name}`);
                const event = new (0, $9457b24b76fdec68$export$d61e24a684f9e51)((0, $8804784813ffae81$export$d2ca453b913dcdea).toSinglePrecision(this.getValue(eventMap, "time", 0)), eventData);
                event.intValue = this.getValue(eventMap, "int", eventData.intValue);
                event.floatValue = this.getValue(eventMap, "float", eventData.floatValue);
                event.stringValue = this.getValue(eventMap, "string", eventData.stringValue);
                if (event.data.audioPath != null) {
                    event.volume = this.getValue(eventMap, "volume", 1);
                    event.balance = this.getValue(eventMap, "balance", 0);
                }
                timeline.setFrame(frameIndex++, event);
            }
            timelines.push(timeline);
            duration = Math.max(duration, timeline.frames[timeline.getFrameCount() - 1]);
        }
        if (isNaN(duration)) throw new Error("Error while parsing animation, duration is NaN");
        skeletonData.animations.push(new (0, $a99189e38c28e5fb$export$c35d437ae5945fcd)(name, timelines, duration));
    }
    readCurve(map, timeline, frameIndex) {
        if (!map.hasOwnProperty("curve")) return;
        if (map.curve === "stepped") timeline.setStepped(frameIndex);
        else {
            const curve = map.curve;
            timeline.setCurve(frameIndex, curve, this.getValue(map, "c2", 0), this.getValue(map, "c3", 1), this.getValue(map, "c4", 1));
        }
    }
    getValue(map, prop, defaultValue) {
        return map[prop] !== void 0 ? map[prop] : defaultValue;
    }
    static blendModeFromString(str) {
        str = str.toLowerCase();
        if (str == "normal") return (0, $0fa4b07f86297abd$export$f821c68fe9beaecf).NORMAL;
        if (str == "additive") return (0, $0fa4b07f86297abd$export$f821c68fe9beaecf).ADD;
        if (str == "multiply") return (0, $0fa4b07f86297abd$export$f821c68fe9beaecf).MULTIPLY;
        if (str == "screen") return (0, $0fa4b07f86297abd$export$f821c68fe9beaecf).SCREEN;
        throw new Error(`Unknown blend mode: ${str}`);
    }
    static positionModeFromString(str) {
        str = str.toLowerCase();
        if (str == "fixed") return (0, $2c8db927dc4fcff5$export$34d637c671e1e906).Fixed;
        if (str == "percent") return (0, $2c8db927dc4fcff5$export$34d637c671e1e906).Percent;
        throw new Error(`Unknown position mode: ${str}`);
    }
    static spacingModeFromString(str) {
        str = str.toLowerCase();
        if (str == "length") return (0, $f3db500d9e578f13$export$34ce760ad2b0be4b).Length;
        if (str == "fixed") return (0, $f3db500d9e578f13$export$34ce760ad2b0be4b).Fixed;
        if (str == "percent") return (0, $f3db500d9e578f13$export$34ce760ad2b0be4b).Percent;
        throw new Error(`Unknown position mode: ${str}`);
    }
    static rotateModeFromString(str) {
        str = str.toLowerCase();
        if (str == "tangent") return (0, $2c8db927dc4fcff5$export$a2a23846581ac82c).Tangent;
        if (str == "chain") return (0, $2c8db927dc4fcff5$export$a2a23846581ac82c).Chain;
        if (str == "chainscale") return (0, $2c8db927dc4fcff5$export$a2a23846581ac82c).ChainScale;
        throw new Error(`Unknown rotate mode: ${str}`);
    }
    static transformModeFromString(str) {
        str = str.toLowerCase();
        if (str == "normal") return (0, $ccc5aebc60cbf024$export$4c408f82786a534d).Normal;
        if (str == "onlytranslation") return (0, $ccc5aebc60cbf024$export$4c408f82786a534d).OnlyTranslation;
        if (str == "norotationorreflection") return (0, $ccc5aebc60cbf024$export$4c408f82786a534d).NoRotationOrReflection;
        if (str == "noscale") return (0, $ccc5aebc60cbf024$export$4c408f82786a534d).NoScale;
        if (str == "noscaleorreflection") return (0, $ccc5aebc60cbf024$export$4c408f82786a534d).NoScaleOrReflection;
        throw new Error(`Unknown transform mode: ${str}`);
    }
}
class $d82ca02a4894c3a8$var$LinkedMesh {
    constructor(mesh, skin, slotIndex, parent, inheritDeform){
        this.mesh = mesh;
        this.skin = skin;
        this.slotIndex = slotIndex;
        this.parent = parent;
        this.inheritDeform = inheritDeform;
    }
}











class $b5b5641aeb82be9c$export$ce0a100797286aea extends (0, $c67a865880ede3c3$export$4093f9922f3d2512) {
    createSkeleton(spineData) {
        this.skeleton = new (0, $5b6659a17eaf6fe5$export$8f31e4c4a37b8e9c)(spineData);
        this.skeleton.updateWorldTransform();
        this.stateData = new (0, $d7ff5e5c79580615$export$90d7167cc0605975)(spineData);
        this.state = new (0, $96f986fcae8ada8f$export$d0f7a26c90cc1562)(this.stateData);
    }
}




var $1c5acf04f9b75c28$exports = {};

$parcel$export($1c5acf04f9b75c28$exports, "Attachment", () => $47016c9c5bcec983$export$71e4db985cfcf9e3);
$parcel$export($1c5acf04f9b75c28$exports, "VertexAttachment", () => $47016c9c5bcec983$export$66d3a0c3be55e044);
$parcel$export($1c5acf04f9b75c28$exports, "BoundingBoxAttachment", () => $03ebceacc01e1eb0$export$9538c439c6b85ad2);
$parcel$export($1c5acf04f9b75c28$exports, "ClippingAttachment", () => $80a02a4045299491$export$838805e22b9b55f1);
$parcel$export($1c5acf04f9b75c28$exports, "MeshAttachment", () => $768f0ee4496fce9b$export$3f1c1692adfcf3e2);
$parcel$export($1c5acf04f9b75c28$exports, "PathAttachment", () => $193cdc10edd05e64$export$d285e3ec07b32800);
$parcel$export($1c5acf04f9b75c28$exports, "PointAttachment", () => $1ce5a549b119c5f2$export$1b528cde44a6ab5);
$parcel$export($1c5acf04f9b75c28$exports, "RegionAttachment", () => $194dfe6c9cdc5a8c$export$d0fc51466fa6d530);
$parcel$export($1c5acf04f9b75c28$exports, "JitterEffect", () => $67c04dab902b471d$export$fcba7f85d07a2c99);
$parcel$export($1c5acf04f9b75c28$exports, "SwirlEffect", () => $37ada00811672ec8$export$bf3ff70e38c4c145);
$parcel$export($1c5acf04f9b75c28$exports, "Animation", () => $5d5d4780b16fb6da$export$c35d437ae5945fcd);
$parcel$export($1c5acf04f9b75c28$exports, "AttachmentTimeline", () => $5d5d4780b16fb6da$export$7f2bfc5bd27cb43d);
$parcel$export($1c5acf04f9b75c28$exports, "ColorTimeline", () => $5d5d4780b16fb6da$export$565fcb3610070d7f);
$parcel$export($1c5acf04f9b75c28$exports, "CurveTimeline", () => $5d5d4780b16fb6da$export$4094e7414845f78f);
$parcel$export($1c5acf04f9b75c28$exports, "DeformTimeline", () => $5d5d4780b16fb6da$export$6968d40e5689ad6b);
$parcel$export($1c5acf04f9b75c28$exports, "DrawOrderTimeline", () => $5d5d4780b16fb6da$export$ece1f7c41d051e83);
$parcel$export($1c5acf04f9b75c28$exports, "EventTimeline", () => $5d5d4780b16fb6da$export$4f4bca996c586084);
$parcel$export($1c5acf04f9b75c28$exports, "IkConstraintTimeline", () => $5d5d4780b16fb6da$export$73d125cd89dead44);
$parcel$export($1c5acf04f9b75c28$exports, "PathConstraintMixTimeline", () => $5d5d4780b16fb6da$export$ea67b41755485038);
$parcel$export($1c5acf04f9b75c28$exports, "PathConstraintPositionTimeline", () => $5d5d4780b16fb6da$export$7ce7e67fd9cc52ed);
$parcel$export($1c5acf04f9b75c28$exports, "PathConstraintSpacingTimeline", () => $5d5d4780b16fb6da$export$17ee50c08a07e62b);
$parcel$export($1c5acf04f9b75c28$exports, "RotateTimeline", () => $5d5d4780b16fb6da$export$b7ecb8f68b3e130b);
$parcel$export($1c5acf04f9b75c28$exports, "ScaleTimeline", () => $5d5d4780b16fb6da$export$be544e22f6ad7737);
$parcel$export($1c5acf04f9b75c28$exports, "ShearTimeline", () => $5d5d4780b16fb6da$export$4da82436a1a0d773);
$parcel$export($1c5acf04f9b75c28$exports, "TimelineType", () => $5d5d4780b16fb6da$export$11f4f8480e4dd7d2);
$parcel$export($1c5acf04f9b75c28$exports, "TransformConstraintTimeline", () => $5d5d4780b16fb6da$export$a7a393c2ad815ac7);
$parcel$export($1c5acf04f9b75c28$exports, "TranslateTimeline", () => $5d5d4780b16fb6da$export$eb93bf27829ae703);
$parcel$export($1c5acf04f9b75c28$exports, "TwoColorTimeline", () => $5d5d4780b16fb6da$export$938c1752e1b56539);
$parcel$export($1c5acf04f9b75c28$exports, "AnimationState", () => $aaa386b4abc834f7$export$d0f7a26c90cc1562);
$parcel$export($1c5acf04f9b75c28$exports, "AnimationStateAdapter2", () => $aaa386b4abc834f7$export$3816040169c70f4f);
$parcel$export($1c5acf04f9b75c28$exports, "EventQueue", () => $aaa386b4abc834f7$export$2fc6338444a158e6);
$parcel$export($1c5acf04f9b75c28$exports, "EventType", () => $aaa386b4abc834f7$export$3d7865934588d77e);
$parcel$export($1c5acf04f9b75c28$exports, "TrackEntry", () => $aaa386b4abc834f7$export$6fd48f25bc0ee658);
$parcel$export($1c5acf04f9b75c28$exports, "AnimationStateData", () => $2694fad3c1cf0f47$export$90d7167cc0605975);
$parcel$export($1c5acf04f9b75c28$exports, "AtlasAttachmentLoader", () => $396085795b03eddd$export$2ff9add835475d95);
$parcel$export($1c5acf04f9b75c28$exports, "Bone", () => $e2f8673bf53faa5e$export$b127726e56765aa4);
$parcel$export($1c5acf04f9b75c28$exports, "BoneData", () => $a5b6524b51430054$export$7d85d96cf093e12f);
$parcel$export($1c5acf04f9b75c28$exports, "Event", () => $c7ea2d215007ce13$export$d61e24a684f9e51);
$parcel$export($1c5acf04f9b75c28$exports, "EventData", () => $a9b3b2867f4818f5$export$a5cf049e34c3d11e);
$parcel$export($1c5acf04f9b75c28$exports, "IkConstraint", () => $15dc54730e7fffe4$export$3c158c80ff28c177);
$parcel$export($1c5acf04f9b75c28$exports, "IkConstraintData", () => $33de7df150c186a2$export$adcb08b651fc712e);
$parcel$export($1c5acf04f9b75c28$exports, "PathConstraint", () => $84bfe255fc6dec07$export$cb4f92fb0c018828);
$parcel$export($1c5acf04f9b75c28$exports, "PathConstraintData", () => $6be2e6fd947029e3$export$d2629ab80d5dd5ba);
$parcel$export($1c5acf04f9b75c28$exports, "SpacingMode", () => $6be2e6fd947029e3$export$34ce760ad2b0be4b);
$parcel$export($1c5acf04f9b75c28$exports, "Skeleton", () => $6eee187fdca9d523$export$8f31e4c4a37b8e9c);
$parcel$export($1c5acf04f9b75c28$exports, "SkeletonBounds", () => $f2afa1d5b3278a6e$export$119f1746fc062f5e);
$parcel$export($1c5acf04f9b75c28$exports, "SkeletonData", () => $05cacac1abb1a224$export$e8f362f163550575);
$parcel$export($1c5acf04f9b75c28$exports, "SkeletonJson", () => $60109c85cd5986cc$export$8913b5e618c6d2f3);
$parcel$export($1c5acf04f9b75c28$exports, "Skin", () => $d75f12246b931247$export$b8e0f93a76772233);
$parcel$export($1c5acf04f9b75c28$exports, "Slot", () => $2eeaf0a953c05635$export$8c6ed5c666ac1360);
$parcel$export($1c5acf04f9b75c28$exports, "SlotData", () => $5f798cbede6d2ed4$export$a4cce1bf50208679);
$parcel$export($1c5acf04f9b75c28$exports, "TransformConstraint", () => $00508ebb97eb18da$export$a2d8268faabf5c52);
$parcel$export($1c5acf04f9b75c28$exports, "TransformConstraintData", () => $8d84975dd7f91171$export$823fbc29771afdb5);
$parcel$export($1c5acf04f9b75c28$exports, "Spine", () => $e6d9166e037f46b1$export$ce0a100797286aea);
class $47016c9c5bcec983$export$71e4db985cfcf9e3 {
    constructor(name){
        if (name == null) throw new Error("name cannot be null.");
        this.name = name;
    }
}
const $47016c9c5bcec983$var$_VertexAttachment = class extends $47016c9c5bcec983$export$71e4db985cfcf9e3 {
    constructor(name){
        super(name);
        this.id = ($47016c9c5bcec983$var$_VertexAttachment.nextID++ & 65535) << 11;
        this.worldVerticesLength = 0;
    }
    computeWorldVerticesOld(slot, worldVertices) {
        this.computeWorldVertices(slot, 0, this.worldVerticesLength, worldVertices, 0, 2);
    }
    /** Transforms local vertices to world coordinates.
   * @param start The index of the first local vertex value to transform. Each vertex has 2 values, x and y.
   * @param count The number of world vertex values to output. Must be <= {@link #getWorldVerticesLength()} - start.
   * @param worldVertices The output world vertices. Must have a length >= offset + count.
   * @param offset The worldVertices index to begin writing values. */ computeWorldVertices(slot, start, count, worldVertices, offset, stride) {
        count = offset + (count >> 1) * stride;
        const skeleton = slot.bone.skeleton;
        const deformArray = slot.attachmentVertices;
        let vertices = this.vertices;
        const bones = this.bones;
        if (bones == null) {
            if (deformArray.length > 0) vertices = deformArray;
            const mat = slot.bone.matrix;
            const x = mat.tx;
            const y = mat.ty;
            const a = mat.a;
            const b = mat.c;
            const c = mat.b;
            const d = mat.d;
            for(let v2 = start, w = offset; w < count; v2 += 2, w += stride){
                const vx = vertices[v2];
                const vy = vertices[v2 + 1];
                worldVertices[w] = vx * a + vy * b + x;
                worldVertices[w + 1] = vx * c + vy * d + y;
            }
            return;
        }
        let v = 0;
        let skip = 0;
        for(let i = 0; i < start; i += 2){
            const n = bones[v];
            v += n + 1;
            skip += n;
        }
        const skeletonBones = skeleton.bones;
        if (deformArray.length == 0) for(let w = offset, b = skip * 3; w < count; w += stride){
            let wx = 0;
            let wy = 0;
            let n = bones[v++];
            n += v;
            for(; v < n; v++, b += 3){
                const mat = skeletonBones[bones[v]].matrix;
                const vx = vertices[b];
                const vy = vertices[b + 1];
                const weight = vertices[b + 2];
                wx += (vx * mat.a + vy * mat.c + mat.tx) * weight;
                wy += (vx * mat.b + vy * mat.d + mat.ty) * weight;
            }
            worldVertices[w] = wx;
            worldVertices[w + 1] = wy;
        }
        else {
            const deform = deformArray;
            for(let w = offset, b = skip * 3, f = skip << 1; w < count; w += stride){
                let wx = 0;
                let wy = 0;
                let n = bones[v++];
                n += v;
                for(; v < n; v++, b += 3, f += 2){
                    const mat = skeletonBones[bones[v]].matrix;
                    const vx = vertices[b] + deform[f];
                    const vy = vertices[b + 1] + deform[f + 1];
                    const weight = vertices[b + 2];
                    wx += (vx * mat.a + vy * mat.c + mat.tx) * weight;
                    wy += (vx * mat.b + vy * mat.d + mat.ty) * weight;
                }
                worldVertices[w] = wx;
                worldVertices[w + 1] = wy;
            }
        }
    }
    /** Returns true if a deform originally applied to the specified attachment should be applied to this attachment. */ applyDeform(sourceAttachment) {
        return this == sourceAttachment;
    }
};
let $47016c9c5bcec983$export$66d3a0c3be55e044 = $47016c9c5bcec983$var$_VertexAttachment;
$47016c9c5bcec983$export$66d3a0c3be55e044.nextID = 0;




class $03ebceacc01e1eb0$export$9538c439c6b85ad2 extends (0, $47016c9c5bcec983$export$66d3a0c3be55e044) {
    constructor(name){
        super(name);
        this.type = (0, $4b0ad7d1400b5e69$export$86cfdc1f02eaf37a).BoundingBox;
        this.color = new (0, $8804784813ffae81$export$892596cec99bc70e)(1, 1, 1, 1);
    }
}




class $80a02a4045299491$export$838805e22b9b55f1 extends (0, $47016c9c5bcec983$export$66d3a0c3be55e044) {
    // ce3a3aff
    constructor(name){
        super(name);
        this.type = (0, $4b0ad7d1400b5e69$export$86cfdc1f02eaf37a).Clipping;
        // Nonessential.
        this.color = new (0, $8804784813ffae81$export$892596cec99bc70e)(0.2275, 0.2275, 0.8078, 1);
    }
}




class $768f0ee4496fce9b$export$3f1c1692adfcf3e2 extends (0, $47016c9c5bcec983$export$66d3a0c3be55e044) {
    constructor(name){
        super(name);
        this.type = (0, $4b0ad7d1400b5e69$export$86cfdc1f02eaf37a).Mesh;
        this.color = new (0, $8804784813ffae81$export$892596cec99bc70e)(1, 1, 1, 1);
        this.inheritDeform = false;
        this.tempColor = new (0, $8804784813ffae81$export$892596cec99bc70e)(0, 0, 0, 0);
    }
    applyDeform(sourceAttachment) {
        return this == sourceAttachment || this.inheritDeform && this.parentMesh == sourceAttachment;
    }
    getParentMesh() {
        return this.parentMesh;
    }
    /** @param parentMesh May be null. */ setParentMesh(parentMesh) {
        this.parentMesh = parentMesh;
        if (parentMesh != null) {
            this.bones = parentMesh.bones;
            this.vertices = parentMesh.vertices;
            this.worldVerticesLength = parentMesh.worldVerticesLength;
            this.regionUVs = parentMesh.regionUVs;
            this.triangles = parentMesh.triangles;
            this.hullLength = parentMesh.hullLength;
            this.worldVerticesLength = parentMesh.worldVerticesLength;
        }
    }
}




class $193cdc10edd05e64$export$d285e3ec07b32800 extends (0, $47016c9c5bcec983$export$66d3a0c3be55e044) {
    constructor(name){
        super(name);
        this.type = (0, $4b0ad7d1400b5e69$export$86cfdc1f02eaf37a).Path;
        this.closed = false;
        this.constantSpeed = false;
        this.color = new (0, $8804784813ffae81$export$892596cec99bc70e)(1, 1, 1, 1);
    }
}




class $1ce5a549b119c5f2$export$1b528cde44a6ab5 extends (0, $47016c9c5bcec983$export$66d3a0c3be55e044) {
    constructor(name){
        super(name);
        this.type = (0, $4b0ad7d1400b5e69$export$86cfdc1f02eaf37a).Point;
        this.color = new (0, $8804784813ffae81$export$892596cec99bc70e)(0.38, 0.94, 0, 1);
    }
    computeWorldPosition(bone, point) {
        const mat = bone.matrix;
        point.x = this.x * mat.a + this.y * mat.c + bone.worldX;
        point.y = this.x * mat.b + this.y * mat.d + bone.worldY;
        return point;
    }
    computeWorldRotation(bone) {
        const mat = bone.matrix;
        const cos = (0, $8804784813ffae81$export$6a7ef315a0d1ef07).cosDeg(this.rotation);
        const sin = (0, $8804784813ffae81$export$6a7ef315a0d1ef07).sinDeg(this.rotation);
        const x = cos * mat.a + sin * mat.c;
        const y = cos * mat.b + sin * mat.d;
        return Math.atan2(y, x) * (0, $8804784813ffae81$export$6a7ef315a0d1ef07).radDeg;
    }
}





class $2eeaf0a953c05635$export$8c6ed5c666ac1360 {
    constructor(data, bone){
        this.attachmentVertices = new Array();
        if (data == null) throw new Error("data cannot be null.");
        if (bone == null) throw new Error("bone cannot be null.");
        this.data = data;
        this.bone = bone;
        this.color = new (0, $8804784813ffae81$export$892596cec99bc70e)();
        this.darkColor = data.darkColor == null ? null : new (0, $8804784813ffae81$export$892596cec99bc70e)();
        this.setToSetupPose();
        this.blendMode = this.data.blendMode;
    }
    /** @return May be null. */ getAttachment() {
        return this.attachment;
    }
    /** Sets the attachment and if it changed, resets {@link #getAttachmentTime()} and clears {@link #getAttachmentVertices()}.
   * @param attachment May be null. */ setAttachment(attachment) {
        if (this.attachment == attachment) return;
        this.attachment = attachment;
        this.attachmentTime = this.bone.skeleton.time;
        this.attachmentVertices.length = 0;
    }
    setAttachmentTime(time) {
        this.attachmentTime = this.bone.skeleton.time - time;
    }
    /** Returns the time since the attachment was set. */ getAttachmentTime() {
        return this.bone.skeleton.time - this.attachmentTime;
    }
    setToSetupPose() {
        this.color.setFromColor(this.data.color);
        if (this.darkColor != null) this.darkColor.setFromColor(this.data.darkColor);
        if (this.data.attachmentName == null) this.attachment = null;
        else {
            this.attachment = null;
            this.setAttachment(this.bone.skeleton.getAttachment(this.data.index, this.data.attachmentName));
        }
    }
}


const $194dfe6c9cdc5a8c$var$_RegionAttachment = class extends (0, $47016c9c5bcec983$export$71e4db985cfcf9e3) {
    constructor(name){
        super(name);
        this.type = (0, $4b0ad7d1400b5e69$export$86cfdc1f02eaf37a).Region;
        this.x = 0;
        this.y = 0;
        this.scaleX = 1;
        this.scaleY = 1;
        this.rotation = 0;
        this.width = 0;
        this.height = 0;
        this.color = new (0, $8804784813ffae81$export$892596cec99bc70e)(1, 1, 1, 1);
        this.offset = (0, $8804784813ffae81$export$d2ca453b913dcdea).newFloatArray(8);
        this.uvs = (0, $8804784813ffae81$export$d2ca453b913dcdea).newFloatArray(8);
        this.tempColor = new (0, $8804784813ffae81$export$892596cec99bc70e)(1, 1, 1, 1);
    }
    updateOffset() {
        const regionScaleX = this.width / this.region.originalWidth * this.scaleX;
        const regionScaleY = this.height / this.region.originalHeight * this.scaleY;
        const localX = -this.width / 2 * this.scaleX + this.region.offsetX * regionScaleX;
        const localY = -this.height / 2 * this.scaleY + this.region.offsetY * regionScaleY;
        const localX2 = localX + this.region.width * regionScaleX;
        const localY2 = localY + this.region.height * regionScaleY;
        const radians = this.rotation * Math.PI / 180;
        const cos = Math.cos(radians);
        const sin = Math.sin(radians);
        const localXCos = localX * cos + this.x;
        const localXSin = localX * sin;
        const localYCos = localY * cos + this.y;
        const localYSin = localY * sin;
        const localX2Cos = localX2 * cos + this.x;
        const localX2Sin = localX2 * sin;
        const localY2Cos = localY2 * cos + this.y;
        const localY2Sin = localY2 * sin;
        const offset = this.offset;
        offset[$194dfe6c9cdc5a8c$var$_RegionAttachment.OX1] = localXCos - localYSin;
        offset[$194dfe6c9cdc5a8c$var$_RegionAttachment.OY1] = localYCos + localXSin;
        offset[$194dfe6c9cdc5a8c$var$_RegionAttachment.OX2] = localXCos - localY2Sin;
        offset[$194dfe6c9cdc5a8c$var$_RegionAttachment.OY2] = localY2Cos + localXSin;
        offset[$194dfe6c9cdc5a8c$var$_RegionAttachment.OX3] = localX2Cos - localY2Sin;
        offset[$194dfe6c9cdc5a8c$var$_RegionAttachment.OY3] = localY2Cos + localX2Sin;
        offset[$194dfe6c9cdc5a8c$var$_RegionAttachment.OX4] = localX2Cos - localYSin;
        offset[$194dfe6c9cdc5a8c$var$_RegionAttachment.OY4] = localYCos + localX2Sin;
    }
    setRegion(region) {
        this.region = region;
        const uvs = this.uvs;
        if (region.rotate) {
            uvs[2] = region.u;
            uvs[3] = region.v2;
            uvs[4] = region.u;
            uvs[5] = region.v;
            uvs[6] = region.u2;
            uvs[7] = region.v;
            uvs[0] = region.u2;
            uvs[1] = region.v2;
        } else {
            uvs[0] = region.u;
            uvs[1] = region.v2;
            uvs[2] = region.u;
            uvs[3] = region.v;
            uvs[4] = region.u2;
            uvs[5] = region.v;
            uvs[6] = region.u2;
            uvs[7] = region.v2;
        }
    }
    computeWorldVertices(bone, worldVertices, offset, stride) {
        const vertexOffset = this.offset;
        const mat = bone instanceof (0, $2eeaf0a953c05635$export$8c6ed5c666ac1360) ? bone.bone.matrix : bone.matrix;
        const x = mat.tx;
        const y = mat.ty;
        const a = mat.a;
        const b = mat.c;
        const c = mat.b;
        const d = mat.d;
        let offsetX = 0;
        let offsetY = 0;
        offsetX = vertexOffset[$194dfe6c9cdc5a8c$var$_RegionAttachment.OX1];
        offsetY = vertexOffset[$194dfe6c9cdc5a8c$var$_RegionAttachment.OY1];
        worldVertices[offset] = offsetX * a + offsetY * b + x;
        worldVertices[offset + 1] = offsetX * c + offsetY * d + y;
        offset += stride;
        offsetX = vertexOffset[$194dfe6c9cdc5a8c$var$_RegionAttachment.OX2];
        offsetY = vertexOffset[$194dfe6c9cdc5a8c$var$_RegionAttachment.OY2];
        worldVertices[offset] = offsetX * a + offsetY * b + x;
        worldVertices[offset + 1] = offsetX * c + offsetY * d + y;
        offset += stride;
        offsetX = vertexOffset[$194dfe6c9cdc5a8c$var$_RegionAttachment.OX3];
        offsetY = vertexOffset[$194dfe6c9cdc5a8c$var$_RegionAttachment.OY3];
        worldVertices[offset] = offsetX * a + offsetY * b + x;
        worldVertices[offset + 1] = offsetX * c + offsetY * d + y;
        offset += stride;
        offsetX = vertexOffset[$194dfe6c9cdc5a8c$var$_RegionAttachment.OX4];
        offsetY = vertexOffset[$194dfe6c9cdc5a8c$var$_RegionAttachment.OY4];
        worldVertices[offset] = offsetX * a + offsetY * b + x;
        worldVertices[offset + 1] = offsetX * c + offsetY * d + y;
    }
};
let $194dfe6c9cdc5a8c$export$d0fc51466fa6d530 = $194dfe6c9cdc5a8c$var$_RegionAttachment;
$194dfe6c9cdc5a8c$export$d0fc51466fa6d530.OX1 = 0;
$194dfe6c9cdc5a8c$export$d0fc51466fa6d530.OY1 = 1;
$194dfe6c9cdc5a8c$export$d0fc51466fa6d530.OX2 = 2;
$194dfe6c9cdc5a8c$export$d0fc51466fa6d530.OY2 = 3;
$194dfe6c9cdc5a8c$export$d0fc51466fa6d530.OX3 = 4;
$194dfe6c9cdc5a8c$export$d0fc51466fa6d530.OY3 = 5;
$194dfe6c9cdc5a8c$export$d0fc51466fa6d530.OX4 = 6;
$194dfe6c9cdc5a8c$export$d0fc51466fa6d530.OY4 = 7;
$194dfe6c9cdc5a8c$export$d0fc51466fa6d530.X1 = 0;
$194dfe6c9cdc5a8c$export$d0fc51466fa6d530.Y1 = 1;
$194dfe6c9cdc5a8c$export$d0fc51466fa6d530.C1R = 2;
$194dfe6c9cdc5a8c$export$d0fc51466fa6d530.C1G = 3;
$194dfe6c9cdc5a8c$export$d0fc51466fa6d530.C1B = 4;
$194dfe6c9cdc5a8c$export$d0fc51466fa6d530.C1A = 5;
$194dfe6c9cdc5a8c$export$d0fc51466fa6d530.U1 = 6;
$194dfe6c9cdc5a8c$export$d0fc51466fa6d530.V1 = 7;
$194dfe6c9cdc5a8c$export$d0fc51466fa6d530.X2 = 8;
$194dfe6c9cdc5a8c$export$d0fc51466fa6d530.Y2 = 9;
$194dfe6c9cdc5a8c$export$d0fc51466fa6d530.C2R = 10;
$194dfe6c9cdc5a8c$export$d0fc51466fa6d530.C2G = 11;
$194dfe6c9cdc5a8c$export$d0fc51466fa6d530.C2B = 12;
$194dfe6c9cdc5a8c$export$d0fc51466fa6d530.C2A = 13;
$194dfe6c9cdc5a8c$export$d0fc51466fa6d530.U2 = 14;
$194dfe6c9cdc5a8c$export$d0fc51466fa6d530.V2 = 15;
$194dfe6c9cdc5a8c$export$d0fc51466fa6d530.X3 = 16;
$194dfe6c9cdc5a8c$export$d0fc51466fa6d530.Y3 = 17;
$194dfe6c9cdc5a8c$export$d0fc51466fa6d530.C3R = 18;
$194dfe6c9cdc5a8c$export$d0fc51466fa6d530.C3G = 19;
$194dfe6c9cdc5a8c$export$d0fc51466fa6d530.C3B = 20;
$194dfe6c9cdc5a8c$export$d0fc51466fa6d530.C3A = 21;
$194dfe6c9cdc5a8c$export$d0fc51466fa6d530.U3 = 22;
$194dfe6c9cdc5a8c$export$d0fc51466fa6d530.V3 = 23;
$194dfe6c9cdc5a8c$export$d0fc51466fa6d530.X4 = 24;
$194dfe6c9cdc5a8c$export$d0fc51466fa6d530.Y4 = 25;
$194dfe6c9cdc5a8c$export$d0fc51466fa6d530.C4R = 26;
$194dfe6c9cdc5a8c$export$d0fc51466fa6d530.C4G = 27;
$194dfe6c9cdc5a8c$export$d0fc51466fa6d530.C4B = 28;
$194dfe6c9cdc5a8c$export$d0fc51466fa6d530.C4A = 29;
$194dfe6c9cdc5a8c$export$d0fc51466fa6d530.U4 = 30;
$194dfe6c9cdc5a8c$export$d0fc51466fa6d530.V4 = 31;



class $67c04dab902b471d$export$fcba7f85d07a2c99 {
    constructor(jitterX, jitterY){
        this.jitterX = 0;
        this.jitterY = 0;
        this.jitterX = jitterX;
        this.jitterY = jitterY;
    }
    begin(skeleton) {}
    transform(position, uv, light, dark) {
        position.x += (0, $8804784813ffae81$export$6a7ef315a0d1ef07).randomTriangular(-this.jitterX, this.jitterY);
        position.y += (0, $8804784813ffae81$export$6a7ef315a0d1ef07).randomTriangular(-this.jitterX, this.jitterY);
    }
    end() {}
}



const $37ada00811672ec8$var$_SwirlEffect = class {
    constructor(radius){
        this.centerX = 0;
        this.centerY = 0;
        this.radius = 0;
        this.angle = 0;
        this.worldX = 0;
        this.worldY = 0;
        this.radius = radius;
    }
    begin(skeleton) {
        this.worldX = skeleton.x + this.centerX;
        this.worldY = skeleton.y + this.centerY;
    }
    transform(position, uv, light, dark) {
        const radAngle = this.angle * (0, $8804784813ffae81$export$6a7ef315a0d1ef07).degreesToRadians;
        const x = position.x - this.worldX;
        const y = position.y - this.worldY;
        const dist = Math.sqrt(x * x + y * y);
        if (dist < this.radius) {
            const theta = $37ada00811672ec8$var$_SwirlEffect.interpolation.apply(0, radAngle, (this.radius - dist) / this.radius);
            const cos = Math.cos(theta);
            const sin = Math.sin(theta);
            position.x = cos * x - sin * y + this.worldX;
            position.y = sin * x + cos * y + this.worldY;
        }
    }
    end() {}
};
let $37ada00811672ec8$export$bf3ff70e38c4c145 = $37ada00811672ec8$var$_SwirlEffect;
$37ada00811672ec8$export$bf3ff70e38c4c145.interpolation = new (0, $8804784813ffae81$export$4834f341f53dca5c)(2);





class $5d5d4780b16fb6da$export$c35d437ae5945fcd {
    constructor(name, timelines, duration){
        if (name == null) throw new Error("name cannot be null.");
        if (timelines == null) throw new Error("timelines cannot be null.");
        this.name = name;
        this.timelines = timelines;
        this.duration = duration;
    }
    apply(skeleton, lastTime, time, loop, events, alpha, blend, direction) {
        if (skeleton == null) throw new Error("skeleton cannot be null.");
        if (loop && this.duration != 0) {
            time %= this.duration;
            if (lastTime > 0) lastTime %= this.duration;
        }
        const timelines = this.timelines;
        for(let i = 0, n = timelines.length; i < n; i++)timelines[i].apply(skeleton, lastTime, time, events, alpha, blend, direction);
    }
    static binarySearch(values, target, step = 1) {
        let low = 0;
        let high = values.length / step - 2;
        if (high == 0) return step;
        let current = high >>> 1;
        while(true){
            if (values[(current + 1) * step] <= target) low = current + 1;
            else high = current;
            if (low == high) return (low + 1) * step;
            current = low + high >>> 1;
        }
    }
    static linearSearch(values, target, step) {
        for(let i = 0, last = values.length - step; i <= last; i += step)if (values[i] > target) return i;
        return -1;
    }
}
var $5d5d4780b16fb6da$export$11f4f8480e4dd7d2 = /* @__PURE__ */ ((TimelineType2)=>{
    TimelineType2[TimelineType2["rotate"] = 0] = "rotate";
    TimelineType2[TimelineType2["translate"] = 1] = "translate";
    TimelineType2[TimelineType2["scale"] = 2] = "scale";
    TimelineType2[TimelineType2["shear"] = 3] = "shear";
    TimelineType2[TimelineType2["attachment"] = 4] = "attachment";
    TimelineType2[TimelineType2["color"] = 5] = "color";
    TimelineType2[TimelineType2["deform"] = 6] = "deform";
    TimelineType2[TimelineType2["event"] = 7] = "event";
    TimelineType2[TimelineType2["drawOrder"] = 8] = "drawOrder";
    TimelineType2[TimelineType2["ikConstraint"] = 9] = "ikConstraint";
    TimelineType2[TimelineType2["transformConstraint"] = 10] = "transformConstraint";
    TimelineType2[TimelineType2["pathConstraintPosition"] = 11] = "pathConstraintPosition";
    TimelineType2[TimelineType2["pathConstraintSpacing"] = 12] = "pathConstraintSpacing";
    TimelineType2[TimelineType2["pathConstraintMix"] = 13] = "pathConstraintMix";
    TimelineType2[TimelineType2["twoColor"] = 14] = "twoColor";
    return TimelineType2;
})($5d5d4780b16fb6da$export$11f4f8480e4dd7d2 || {});
const $5d5d4780b16fb6da$var$_CurveTimeline = class {
    constructor(frameCount){
        if (frameCount <= 0) throw new Error(`frameCount must be > 0: ${frameCount}`);
        this.curves = (0, $8804784813ffae81$export$d2ca453b913dcdea).newFloatArray((frameCount - 1) * $5d5d4780b16fb6da$var$_CurveTimeline.BEZIER_SIZE);
    }
    getFrameCount() {
        return this.curves.length / $5d5d4780b16fb6da$var$_CurveTimeline.BEZIER_SIZE + 1;
    }
    setLinear(frameIndex) {
        this.curves[frameIndex * $5d5d4780b16fb6da$var$_CurveTimeline.BEZIER_SIZE] = $5d5d4780b16fb6da$var$_CurveTimeline.LINEAR;
    }
    setStepped(frameIndex) {
        this.curves[frameIndex * $5d5d4780b16fb6da$var$_CurveTimeline.BEZIER_SIZE] = $5d5d4780b16fb6da$var$_CurveTimeline.STEPPED;
    }
    getCurveType(frameIndex) {
        const index = frameIndex * $5d5d4780b16fb6da$var$_CurveTimeline.BEZIER_SIZE;
        if (index == this.curves.length) return $5d5d4780b16fb6da$var$_CurveTimeline.LINEAR;
        const type = this.curves[index];
        if (type == $5d5d4780b16fb6da$var$_CurveTimeline.LINEAR) return $5d5d4780b16fb6da$var$_CurveTimeline.LINEAR;
        if (type == $5d5d4780b16fb6da$var$_CurveTimeline.STEPPED) return $5d5d4780b16fb6da$var$_CurveTimeline.STEPPED;
        return $5d5d4780b16fb6da$var$_CurveTimeline.BEZIER;
    }
    /** Sets the control handle positions for an interpolation bezier curve used to transition from this keyframe to the next.
   * cx1 and cx2 are from 0 to 1, representing the percent of time between the two keyframes. cy1 and cy2 are the percent of
   * the difference between the keyframe's values. */ setCurve(frameIndex, cx1, cy1, cx2, cy2) {
        const tmpx = (-cx1 * 2 + cx2) * 0.03;
        const tmpy = (-cy1 * 2 + cy2) * 0.03;
        const dddfx = ((cx1 - cx2) * 3 + 1) * 6e-3;
        const dddfy = ((cy1 - cy2) * 3 + 1) * 6e-3;
        let ddfx = tmpx * 2 + dddfx;
        let ddfy = tmpy * 2 + dddfy;
        let dfx = cx1 * 0.3 + tmpx + dddfx * 0.16666667;
        let dfy = cy1 * 0.3 + tmpy + dddfy * 0.16666667;
        let i = frameIndex * $5d5d4780b16fb6da$var$_CurveTimeline.BEZIER_SIZE;
        const curves = this.curves;
        curves[i++] = $5d5d4780b16fb6da$var$_CurveTimeline.BEZIER;
        let x = dfx;
        let y = dfy;
        for(let n = i + $5d5d4780b16fb6da$var$_CurveTimeline.BEZIER_SIZE - 1; i < n; i += 2){
            curves[i] = x;
            curves[i + 1] = y;
            dfx += ddfx;
            dfy += ddfy;
            ddfx += dddfx;
            ddfy += dddfy;
            x += dfx;
            y += dfy;
        }
    }
    getCurvePercent(frameIndex, percent) {
        percent = (0, $8804784813ffae81$export$6a7ef315a0d1ef07).clamp(percent, 0, 1);
        const curves = this.curves;
        let i = frameIndex * $5d5d4780b16fb6da$var$_CurveTimeline.BEZIER_SIZE;
        const type = curves[i];
        if (type == $5d5d4780b16fb6da$var$_CurveTimeline.LINEAR) return percent;
        if (type == $5d5d4780b16fb6da$var$_CurveTimeline.STEPPED) return 0;
        i++;
        let x = 0;
        for(let start = i, n = i + $5d5d4780b16fb6da$var$_CurveTimeline.BEZIER_SIZE - 1; i < n; i += 2){
            x = curves[i];
            if (x >= percent) {
                let prevX;
                let prevY;
                if (i == start) {
                    prevX = 0;
                    prevY = 0;
                } else {
                    prevX = curves[i - 2];
                    prevY = curves[i - 1];
                }
                return prevY + (curves[i + 1] - prevY) * (percent - prevX) / (x - prevX);
            }
        }
        const y = curves[i - 1];
        return y + (1 - y) * (percent - x) / (1 - x);
    }
};
let $5d5d4780b16fb6da$export$4094e7414845f78f = $5d5d4780b16fb6da$var$_CurveTimeline;
$5d5d4780b16fb6da$export$4094e7414845f78f.LINEAR = 0;
$5d5d4780b16fb6da$export$4094e7414845f78f.STEPPED = 1;
$5d5d4780b16fb6da$export$4094e7414845f78f.BEZIER = 2;
$5d5d4780b16fb6da$export$4094e7414845f78f.BEZIER_SIZE = 19;
const $5d5d4780b16fb6da$var$_RotateTimeline = class extends $5d5d4780b16fb6da$export$4094e7414845f78f {
    // time, degrees, ...
    constructor(frameCount){
        super(frameCount);
        this.frames = (0, $8804784813ffae81$export$d2ca453b913dcdea).newFloatArray(frameCount << 1);
    }
    getPropertyId() {
        return 0 + this.boneIndex;
    }
    /** Sets the time and angle of the specified keyframe. */ setFrame(frameIndex, time, degrees) {
        frameIndex <<= 1;
        this.frames[frameIndex] = time;
        this.frames[frameIndex + $5d5d4780b16fb6da$var$_RotateTimeline.ROTATION] = degrees;
    }
    apply(skeleton, lastTime, time, events, alpha, blend, direction) {
        const frames = this.frames;
        const bone = skeleton.bones[this.boneIndex];
        if (time < frames[0]) {
            switch(blend){
                case (0, $bbcccedbc883e405$export$ccab779a50275a35).setup:
                    bone.rotation = bone.data.rotation;
                    return;
                case (0, $bbcccedbc883e405$export$ccab779a50275a35).first:
                    const r2 = bone.data.rotation - bone.rotation;
                    bone.rotation += (r2 - (16384 - (16384.499999999996 - r2 / 360 | 0)) * 360) * alpha;
            }
            return;
        }
        if (time >= frames[frames.length - $5d5d4780b16fb6da$var$_RotateTimeline.ENTRIES]) {
            let r2 = frames[frames.length + $5d5d4780b16fb6da$var$_RotateTimeline.PREV_ROTATION];
            switch(blend){
                case (0, $bbcccedbc883e405$export$ccab779a50275a35).setup:
                    bone.rotation = bone.data.rotation + r2 * alpha;
                    break;
                case (0, $bbcccedbc883e405$export$ccab779a50275a35).first:
                case (0, $bbcccedbc883e405$export$ccab779a50275a35).replace:
                    r2 += bone.data.rotation - bone.rotation;
                    r2 -= (16384 - (16384.499999999996 - r2 / 360 | 0)) * 360;
                case (0, $bbcccedbc883e405$export$ccab779a50275a35).add:
                    bone.rotation += r2 * alpha;
            }
            return;
        }
        const frame = $5d5d4780b16fb6da$export$c35d437ae5945fcd.binarySearch(frames, time, $5d5d4780b16fb6da$var$_RotateTimeline.ENTRIES);
        const prevRotation = frames[frame + $5d5d4780b16fb6da$var$_RotateTimeline.PREV_ROTATION];
        const frameTime = frames[frame];
        const percent = this.getCurvePercent((frame >> 1) - 1, 1 - (time - frameTime) / (frames[frame + $5d5d4780b16fb6da$var$_RotateTimeline.PREV_TIME] - frameTime));
        let r = frames[frame + $5d5d4780b16fb6da$var$_RotateTimeline.ROTATION] - prevRotation;
        r = prevRotation + (r - (16384 - (16384.499999999996 - r / 360 | 0)) * 360) * percent;
        switch(blend){
            case (0, $bbcccedbc883e405$export$ccab779a50275a35).setup:
                bone.rotation = bone.data.rotation + (r - (16384 - (16384.499999999996 - r / 360 | 0)) * 360) * alpha;
                break;
            case (0, $bbcccedbc883e405$export$ccab779a50275a35).first:
            case (0, $bbcccedbc883e405$export$ccab779a50275a35).replace:
                r += bone.data.rotation - bone.rotation;
            case (0, $bbcccedbc883e405$export$ccab779a50275a35).add:
                bone.rotation += (r - (16384 - (16384.499999999996 - r / 360 | 0)) * 360) * alpha;
        }
    }
};
let $5d5d4780b16fb6da$export$b7ecb8f68b3e130b = $5d5d4780b16fb6da$var$_RotateTimeline;
$5d5d4780b16fb6da$export$b7ecb8f68b3e130b.ENTRIES = 2;
$5d5d4780b16fb6da$export$b7ecb8f68b3e130b.PREV_TIME = -2;
$5d5d4780b16fb6da$export$b7ecb8f68b3e130b.PREV_ROTATION = -1;
$5d5d4780b16fb6da$export$b7ecb8f68b3e130b.ROTATION = 1;
const $5d5d4780b16fb6da$var$_TranslateTimeline = class extends $5d5d4780b16fb6da$export$4094e7414845f78f {
    // time, x, y, ...
    constructor(frameCount){
        super(frameCount);
        this.frames = (0, $8804784813ffae81$export$d2ca453b913dcdea).newFloatArray(frameCount * $5d5d4780b16fb6da$var$_TranslateTimeline.ENTRIES);
    }
    getPropertyId() {
        return 16777216 + this.boneIndex;
    }
    /** Sets the time and value of the specified keyframe. */ setFrame(frameIndex, time, x, y) {
        frameIndex *= $5d5d4780b16fb6da$var$_TranslateTimeline.ENTRIES;
        this.frames[frameIndex] = time;
        this.frames[frameIndex + $5d5d4780b16fb6da$var$_TranslateTimeline.X] = x;
        this.frames[frameIndex + $5d5d4780b16fb6da$var$_TranslateTimeline.Y] = y;
    }
    apply(skeleton, lastTime, time, events, alpha, blend, direction) {
        const frames = this.frames;
        const bone = skeleton.bones[this.boneIndex];
        if (time < frames[0]) {
            switch(blend){
                case (0, $bbcccedbc883e405$export$ccab779a50275a35).setup:
                    bone.x = bone.data.x;
                    bone.y = bone.data.y;
                    return;
                case (0, $bbcccedbc883e405$export$ccab779a50275a35).first:
                    bone.x += (bone.data.x - bone.x) * alpha;
                    bone.y += (bone.data.y - bone.y) * alpha;
            }
            return;
        }
        let x = 0;
        let y = 0;
        if (time >= frames[frames.length - $5d5d4780b16fb6da$var$_TranslateTimeline.ENTRIES]) {
            x = frames[frames.length + $5d5d4780b16fb6da$var$_TranslateTimeline.PREV_X];
            y = frames[frames.length + $5d5d4780b16fb6da$var$_TranslateTimeline.PREV_Y];
        } else {
            const frame = $5d5d4780b16fb6da$export$c35d437ae5945fcd.binarySearch(frames, time, $5d5d4780b16fb6da$var$_TranslateTimeline.ENTRIES);
            x = frames[frame + $5d5d4780b16fb6da$var$_TranslateTimeline.PREV_X];
            y = frames[frame + $5d5d4780b16fb6da$var$_TranslateTimeline.PREV_Y];
            const frameTime = frames[frame];
            const percent = this.getCurvePercent(frame / $5d5d4780b16fb6da$var$_TranslateTimeline.ENTRIES - 1, 1 - (time - frameTime) / (frames[frame + $5d5d4780b16fb6da$var$_TranslateTimeline.PREV_TIME] - frameTime));
            x += (frames[frame + $5d5d4780b16fb6da$var$_TranslateTimeline.X] - x) * percent;
            y += (frames[frame + $5d5d4780b16fb6da$var$_TranslateTimeline.Y] - y) * percent;
        }
        switch(blend){
            case (0, $bbcccedbc883e405$export$ccab779a50275a35).setup:
                bone.x = bone.data.x + x * alpha;
                bone.y = bone.data.y + y * alpha;
                break;
            case (0, $bbcccedbc883e405$export$ccab779a50275a35).first:
            case (0, $bbcccedbc883e405$export$ccab779a50275a35).replace:
                bone.x += (bone.data.x + x - bone.x) * alpha;
                bone.y += (bone.data.y + y - bone.y) * alpha;
                break;
            case (0, $bbcccedbc883e405$export$ccab779a50275a35).add:
                bone.x += x * alpha;
                bone.y += y * alpha;
        }
    }
};
let $5d5d4780b16fb6da$export$eb93bf27829ae703 = $5d5d4780b16fb6da$var$_TranslateTimeline;
$5d5d4780b16fb6da$export$eb93bf27829ae703.ENTRIES = 3;
$5d5d4780b16fb6da$export$eb93bf27829ae703.PREV_TIME = -3;
$5d5d4780b16fb6da$export$eb93bf27829ae703.PREV_X = -2;
$5d5d4780b16fb6da$export$eb93bf27829ae703.PREV_Y = -1;
$5d5d4780b16fb6da$export$eb93bf27829ae703.X = 1;
$5d5d4780b16fb6da$export$eb93bf27829ae703.Y = 2;
class $5d5d4780b16fb6da$export$be544e22f6ad7737 extends $5d5d4780b16fb6da$export$eb93bf27829ae703 {
    constructor(frameCount){
        super(frameCount);
    }
    getPropertyId() {
        return 33554432 + this.boneIndex;
    }
    apply(skeleton, lastTime, time, events, alpha, blend, direction) {
        const frames = this.frames;
        const bone = skeleton.bones[this.boneIndex];
        if (time < frames[0]) {
            switch(blend){
                case (0, $bbcccedbc883e405$export$ccab779a50275a35).setup:
                    bone.scaleX = bone.data.scaleX;
                    bone.scaleY = bone.data.scaleY;
                    return;
                case (0, $bbcccedbc883e405$export$ccab779a50275a35).first:
                    bone.scaleX += (bone.data.scaleX - bone.scaleX) * alpha;
                    bone.scaleY += (bone.data.scaleY - bone.scaleY) * alpha;
            }
            return;
        }
        let x = 0;
        let y = 0;
        if (time >= frames[frames.length - $5d5d4780b16fb6da$export$be544e22f6ad7737.ENTRIES]) {
            x = frames[frames.length + $5d5d4780b16fb6da$export$be544e22f6ad7737.PREV_X] * bone.data.scaleX;
            y = frames[frames.length + $5d5d4780b16fb6da$export$be544e22f6ad7737.PREV_Y] * bone.data.scaleY;
        } else {
            const frame = $5d5d4780b16fb6da$export$c35d437ae5945fcd.binarySearch(frames, time, $5d5d4780b16fb6da$export$be544e22f6ad7737.ENTRIES);
            x = frames[frame + $5d5d4780b16fb6da$export$be544e22f6ad7737.PREV_X];
            y = frames[frame + $5d5d4780b16fb6da$export$be544e22f6ad7737.PREV_Y];
            const frameTime = frames[frame];
            const percent = this.getCurvePercent(frame / $5d5d4780b16fb6da$export$be544e22f6ad7737.ENTRIES - 1, 1 - (time - frameTime) / (frames[frame + $5d5d4780b16fb6da$export$be544e22f6ad7737.PREV_TIME] - frameTime));
            x = (x + (frames[frame + $5d5d4780b16fb6da$export$be544e22f6ad7737.X] - x) * percent) * bone.data.scaleX;
            y = (y + (frames[frame + $5d5d4780b16fb6da$export$be544e22f6ad7737.Y] - y) * percent) * bone.data.scaleY;
        }
        if (alpha == 1) {
            if (blend == (0, $bbcccedbc883e405$export$ccab779a50275a35).add) {
                bone.scaleX += x - bone.data.scaleX;
                bone.scaleY += y - bone.data.scaleY;
            } else {
                bone.scaleX = x;
                bone.scaleY = y;
            }
        } else {
            let bx = 0;
            let by = 0;
            if (direction == (0, $bbcccedbc883e405$export$52fc338c0bb328ba).mixOut) switch(blend){
                case (0, $bbcccedbc883e405$export$ccab779a50275a35).setup:
                    bx = bone.data.scaleX;
                    by = bone.data.scaleY;
                    bone.scaleX = bx + (Math.abs(x) * (0, $8804784813ffae81$export$6a7ef315a0d1ef07).signum(bx) - bx) * alpha;
                    bone.scaleY = by + (Math.abs(y) * (0, $8804784813ffae81$export$6a7ef315a0d1ef07).signum(by) - by) * alpha;
                    break;
                case (0, $bbcccedbc883e405$export$ccab779a50275a35).first:
                case (0, $bbcccedbc883e405$export$ccab779a50275a35).replace:
                    bx = bone.scaleX;
                    by = bone.scaleY;
                    bone.scaleX = bx + (Math.abs(x) * (0, $8804784813ffae81$export$6a7ef315a0d1ef07).signum(bx) - bx) * alpha;
                    bone.scaleY = by + (Math.abs(y) * (0, $8804784813ffae81$export$6a7ef315a0d1ef07).signum(by) - by) * alpha;
                    break;
                case (0, $bbcccedbc883e405$export$ccab779a50275a35).add:
                    bx = bone.scaleX;
                    by = bone.scaleY;
                    bone.scaleX = bx + (Math.abs(x) * (0, $8804784813ffae81$export$6a7ef315a0d1ef07).signum(bx) - bone.data.scaleX) * alpha;
                    bone.scaleY = by + (Math.abs(y) * (0, $8804784813ffae81$export$6a7ef315a0d1ef07).signum(by) - bone.data.scaleY) * alpha;
            }
            else switch(blend){
                case (0, $bbcccedbc883e405$export$ccab779a50275a35).setup:
                    bx = Math.abs(bone.data.scaleX) * (0, $8804784813ffae81$export$6a7ef315a0d1ef07).signum(x);
                    by = Math.abs(bone.data.scaleY) * (0, $8804784813ffae81$export$6a7ef315a0d1ef07).signum(y);
                    bone.scaleX = bx + (x - bx) * alpha;
                    bone.scaleY = by + (y - by) * alpha;
                    break;
                case (0, $bbcccedbc883e405$export$ccab779a50275a35).first:
                case (0, $bbcccedbc883e405$export$ccab779a50275a35).replace:
                    bx = Math.abs(bone.scaleX) * (0, $8804784813ffae81$export$6a7ef315a0d1ef07).signum(x);
                    by = Math.abs(bone.scaleY) * (0, $8804784813ffae81$export$6a7ef315a0d1ef07).signum(y);
                    bone.scaleX = bx + (x - bx) * alpha;
                    bone.scaleY = by + (y - by) * alpha;
                    break;
                case (0, $bbcccedbc883e405$export$ccab779a50275a35).add:
                    bx = (0, $8804784813ffae81$export$6a7ef315a0d1ef07).signum(x);
                    by = (0, $8804784813ffae81$export$6a7ef315a0d1ef07).signum(y);
                    bone.scaleX = Math.abs(bone.scaleX) * bx + (x - Math.abs(bone.data.scaleX) * bx) * alpha;
                    bone.scaleY = Math.abs(bone.scaleY) * by + (y - Math.abs(bone.data.scaleY) * by) * alpha;
            }
        }
    }
}
class $5d5d4780b16fb6da$export$4da82436a1a0d773 extends $5d5d4780b16fb6da$export$eb93bf27829ae703 {
    constructor(frameCount){
        super(frameCount);
    }
    getPropertyId() {
        return 50331648 + this.boneIndex;
    }
    apply(skeleton, lastTime, time, events, alpha, blend, direction) {
        const frames = this.frames;
        const bone = skeleton.bones[this.boneIndex];
        if (time < frames[0]) {
            switch(blend){
                case (0, $bbcccedbc883e405$export$ccab779a50275a35).setup:
                    bone.shearX = bone.data.shearX;
                    bone.shearY = bone.data.shearY;
                    return;
                case (0, $bbcccedbc883e405$export$ccab779a50275a35).first:
                    bone.shearX += (bone.data.shearX - bone.shearX) * alpha;
                    bone.shearY += (bone.data.shearY - bone.shearY) * alpha;
            }
            return;
        }
        let x = 0;
        let y = 0;
        if (time >= frames[frames.length - $5d5d4780b16fb6da$export$4da82436a1a0d773.ENTRIES]) {
            x = frames[frames.length + $5d5d4780b16fb6da$export$4da82436a1a0d773.PREV_X];
            y = frames[frames.length + $5d5d4780b16fb6da$export$4da82436a1a0d773.PREV_Y];
        } else {
            const frame = $5d5d4780b16fb6da$export$c35d437ae5945fcd.binarySearch(frames, time, $5d5d4780b16fb6da$export$4da82436a1a0d773.ENTRIES);
            x = frames[frame + $5d5d4780b16fb6da$export$4da82436a1a0d773.PREV_X];
            y = frames[frame + $5d5d4780b16fb6da$export$4da82436a1a0d773.PREV_Y];
            const frameTime = frames[frame];
            const percent = this.getCurvePercent(frame / $5d5d4780b16fb6da$export$4da82436a1a0d773.ENTRIES - 1, 1 - (time - frameTime) / (frames[frame + $5d5d4780b16fb6da$export$4da82436a1a0d773.PREV_TIME] - frameTime));
            x = x + (frames[frame + $5d5d4780b16fb6da$export$4da82436a1a0d773.X] - x) * percent;
            y = y + (frames[frame + $5d5d4780b16fb6da$export$4da82436a1a0d773.Y] - y) * percent;
        }
        switch(blend){
            case (0, $bbcccedbc883e405$export$ccab779a50275a35).setup:
                bone.shearX = bone.data.shearX + x * alpha;
                bone.shearY = bone.data.shearY + y * alpha;
                break;
            case (0, $bbcccedbc883e405$export$ccab779a50275a35).first:
            case (0, $bbcccedbc883e405$export$ccab779a50275a35).replace:
                bone.shearX += (bone.data.shearX + x - bone.shearX) * alpha;
                bone.shearY += (bone.data.shearY + y - bone.shearY) * alpha;
                break;
            case (0, $bbcccedbc883e405$export$ccab779a50275a35).add:
                bone.shearX += x * alpha;
                bone.shearY += y * alpha;
        }
    }
}
const $5d5d4780b16fb6da$var$_ColorTimeline = class extends $5d5d4780b16fb6da$export$4094e7414845f78f {
    // time, r, g, b, a, ...
    constructor(frameCount){
        super(frameCount);
        this.frames = (0, $8804784813ffae81$export$d2ca453b913dcdea).newFloatArray(frameCount * $5d5d4780b16fb6da$var$_ColorTimeline.ENTRIES);
    }
    getPropertyId() {
        return 83886080 + this.slotIndex;
    }
    /** Sets the time and value of the specified keyframe. */ setFrame(frameIndex, time, r, g, b, a) {
        frameIndex *= $5d5d4780b16fb6da$var$_ColorTimeline.ENTRIES;
        this.frames[frameIndex] = time;
        this.frames[frameIndex + $5d5d4780b16fb6da$var$_ColorTimeline.R] = r;
        this.frames[frameIndex + $5d5d4780b16fb6da$var$_ColorTimeline.G] = g;
        this.frames[frameIndex + $5d5d4780b16fb6da$var$_ColorTimeline.B] = b;
        this.frames[frameIndex + $5d5d4780b16fb6da$var$_ColorTimeline.A] = a;
    }
    apply(skeleton, lastTime, time, events, alpha, blend, direction) {
        const slot = skeleton.slots[this.slotIndex];
        const frames = this.frames;
        if (time < frames[0]) {
            switch(blend){
                case (0, $bbcccedbc883e405$export$ccab779a50275a35).setup:
                    slot.color.setFromColor(slot.data.color);
                    return;
                case (0, $bbcccedbc883e405$export$ccab779a50275a35).first:
                    const color = slot.color;
                    const setup = slot.data.color;
                    color.add((setup.r - color.r) * alpha, (setup.g - color.g) * alpha, (setup.b - color.b) * alpha, (setup.a - color.a) * alpha);
            }
            return;
        }
        let r = 0;
        let g = 0;
        let b = 0;
        let a = 0;
        if (time >= frames[frames.length - $5d5d4780b16fb6da$var$_ColorTimeline.ENTRIES]) {
            const i = frames.length;
            r = frames[i + $5d5d4780b16fb6da$var$_ColorTimeline.PREV_R];
            g = frames[i + $5d5d4780b16fb6da$var$_ColorTimeline.PREV_G];
            b = frames[i + $5d5d4780b16fb6da$var$_ColorTimeline.PREV_B];
            a = frames[i + $5d5d4780b16fb6da$var$_ColorTimeline.PREV_A];
        } else {
            const frame = $5d5d4780b16fb6da$export$c35d437ae5945fcd.binarySearch(frames, time, $5d5d4780b16fb6da$var$_ColorTimeline.ENTRIES);
            r = frames[frame + $5d5d4780b16fb6da$var$_ColorTimeline.PREV_R];
            g = frames[frame + $5d5d4780b16fb6da$var$_ColorTimeline.PREV_G];
            b = frames[frame + $5d5d4780b16fb6da$var$_ColorTimeline.PREV_B];
            a = frames[frame + $5d5d4780b16fb6da$var$_ColorTimeline.PREV_A];
            const frameTime = frames[frame];
            const percent = this.getCurvePercent(frame / $5d5d4780b16fb6da$var$_ColorTimeline.ENTRIES - 1, 1 - (time - frameTime) / (frames[frame + $5d5d4780b16fb6da$var$_ColorTimeline.PREV_TIME] - frameTime));
            r += (frames[frame + $5d5d4780b16fb6da$var$_ColorTimeline.R] - r) * percent;
            g += (frames[frame + $5d5d4780b16fb6da$var$_ColorTimeline.G] - g) * percent;
            b += (frames[frame + $5d5d4780b16fb6da$var$_ColorTimeline.B] - b) * percent;
            a += (frames[frame + $5d5d4780b16fb6da$var$_ColorTimeline.A] - a) * percent;
        }
        if (alpha == 1) slot.color.set(r, g, b, a);
        else {
            const color = slot.color;
            if (blend == (0, $bbcccedbc883e405$export$ccab779a50275a35).setup) color.setFromColor(slot.data.color);
            color.add((r - color.r) * alpha, (g - color.g) * alpha, (b - color.b) * alpha, (a - color.a) * alpha);
        }
    }
};
let $5d5d4780b16fb6da$export$565fcb3610070d7f = $5d5d4780b16fb6da$var$_ColorTimeline;
$5d5d4780b16fb6da$export$565fcb3610070d7f.ENTRIES = 5;
$5d5d4780b16fb6da$export$565fcb3610070d7f.PREV_TIME = -5;
$5d5d4780b16fb6da$export$565fcb3610070d7f.PREV_R = -4;
$5d5d4780b16fb6da$export$565fcb3610070d7f.PREV_G = -3;
$5d5d4780b16fb6da$export$565fcb3610070d7f.PREV_B = -2;
$5d5d4780b16fb6da$export$565fcb3610070d7f.PREV_A = -1;
$5d5d4780b16fb6da$export$565fcb3610070d7f.R = 1;
$5d5d4780b16fb6da$export$565fcb3610070d7f.G = 2;
$5d5d4780b16fb6da$export$565fcb3610070d7f.B = 3;
$5d5d4780b16fb6da$export$565fcb3610070d7f.A = 4;
const $5d5d4780b16fb6da$var$_TwoColorTimeline = class extends $5d5d4780b16fb6da$export$4094e7414845f78f {
    // time, r, g, b, a, r2, g2, b2, ...
    constructor(frameCount){
        super(frameCount);
        this.frames = (0, $8804784813ffae81$export$d2ca453b913dcdea).newFloatArray(frameCount * $5d5d4780b16fb6da$var$_TwoColorTimeline.ENTRIES);
    }
    getPropertyId() {
        return 234881024 + this.slotIndex;
    }
    /** Sets the time and value of the specified keyframe. */ setFrame(frameIndex, time, r, g, b, a, r2, g2, b2) {
        frameIndex *= $5d5d4780b16fb6da$var$_TwoColorTimeline.ENTRIES;
        this.frames[frameIndex] = time;
        this.frames[frameIndex + $5d5d4780b16fb6da$var$_TwoColorTimeline.R] = r;
        this.frames[frameIndex + $5d5d4780b16fb6da$var$_TwoColorTimeline.G] = g;
        this.frames[frameIndex + $5d5d4780b16fb6da$var$_TwoColorTimeline.B] = b;
        this.frames[frameIndex + $5d5d4780b16fb6da$var$_TwoColorTimeline.A] = a;
        this.frames[frameIndex + $5d5d4780b16fb6da$var$_TwoColorTimeline.R2] = r2;
        this.frames[frameIndex + $5d5d4780b16fb6da$var$_TwoColorTimeline.G2] = g2;
        this.frames[frameIndex + $5d5d4780b16fb6da$var$_TwoColorTimeline.B2] = b2;
    }
    apply(skeleton, lastTime, time, events, alpha, blend, direction) {
        const slot = skeleton.slots[this.slotIndex];
        const frames = this.frames;
        if (time < frames[0]) {
            switch(blend){
                case (0, $bbcccedbc883e405$export$ccab779a50275a35).setup:
                    slot.color.setFromColor(slot.data.color);
                    slot.darkColor.setFromColor(slot.data.darkColor);
                    return;
                case (0, $bbcccedbc883e405$export$ccab779a50275a35).first:
                    const light = slot.color;
                    const dark = slot.darkColor;
                    const setupLight = slot.data.color;
                    const setupDark = slot.data.darkColor;
                    light.add((setupLight.r - light.r) * alpha, (setupLight.g - light.g) * alpha, (setupLight.b - light.b) * alpha, (setupLight.a - light.a) * alpha);
                    dark.add((setupDark.r - dark.r) * alpha, (setupDark.g - dark.g) * alpha, (setupDark.b - dark.b) * alpha, 0);
            }
            return;
        }
        let r = 0;
        let g = 0;
        let b = 0;
        let a = 0;
        let r2 = 0;
        let g2 = 0;
        let b2 = 0;
        if (time >= frames[frames.length - $5d5d4780b16fb6da$var$_TwoColorTimeline.ENTRIES]) {
            const i = frames.length;
            r = frames[i + $5d5d4780b16fb6da$var$_TwoColorTimeline.PREV_R];
            g = frames[i + $5d5d4780b16fb6da$var$_TwoColorTimeline.PREV_G];
            b = frames[i + $5d5d4780b16fb6da$var$_TwoColorTimeline.PREV_B];
            a = frames[i + $5d5d4780b16fb6da$var$_TwoColorTimeline.PREV_A];
            r2 = frames[i + $5d5d4780b16fb6da$var$_TwoColorTimeline.PREV_R2];
            g2 = frames[i + $5d5d4780b16fb6da$var$_TwoColorTimeline.PREV_G2];
            b2 = frames[i + $5d5d4780b16fb6da$var$_TwoColorTimeline.PREV_B2];
        } else {
            const frame = $5d5d4780b16fb6da$export$c35d437ae5945fcd.binarySearch(frames, time, $5d5d4780b16fb6da$var$_TwoColorTimeline.ENTRIES);
            r = frames[frame + $5d5d4780b16fb6da$var$_TwoColorTimeline.PREV_R];
            g = frames[frame + $5d5d4780b16fb6da$var$_TwoColorTimeline.PREV_G];
            b = frames[frame + $5d5d4780b16fb6da$var$_TwoColorTimeline.PREV_B];
            a = frames[frame + $5d5d4780b16fb6da$var$_TwoColorTimeline.PREV_A];
            r2 = frames[frame + $5d5d4780b16fb6da$var$_TwoColorTimeline.PREV_R2];
            g2 = frames[frame + $5d5d4780b16fb6da$var$_TwoColorTimeline.PREV_G2];
            b2 = frames[frame + $5d5d4780b16fb6da$var$_TwoColorTimeline.PREV_B2];
            const frameTime = frames[frame];
            const percent = this.getCurvePercent(frame / $5d5d4780b16fb6da$var$_TwoColorTimeline.ENTRIES - 1, 1 - (time - frameTime) / (frames[frame + $5d5d4780b16fb6da$var$_TwoColorTimeline.PREV_TIME] - frameTime));
            r += (frames[frame + $5d5d4780b16fb6da$var$_TwoColorTimeline.R] - r) * percent;
            g += (frames[frame + $5d5d4780b16fb6da$var$_TwoColorTimeline.G] - g) * percent;
            b += (frames[frame + $5d5d4780b16fb6da$var$_TwoColorTimeline.B] - b) * percent;
            a += (frames[frame + $5d5d4780b16fb6da$var$_TwoColorTimeline.A] - a) * percent;
            r2 += (frames[frame + $5d5d4780b16fb6da$var$_TwoColorTimeline.R2] - r2) * percent;
            g2 += (frames[frame + $5d5d4780b16fb6da$var$_TwoColorTimeline.G2] - g2) * percent;
            b2 += (frames[frame + $5d5d4780b16fb6da$var$_TwoColorTimeline.B2] - b2) * percent;
        }
        if (alpha == 1) {
            slot.color.set(r, g, b, a);
            slot.darkColor.set(r2, g2, b2, 1);
        } else {
            const light = slot.color;
            const dark = slot.darkColor;
            if (blend == (0, $bbcccedbc883e405$export$ccab779a50275a35).setup) {
                light.setFromColor(slot.data.color);
                dark.setFromColor(slot.data.darkColor);
            }
            light.add((r - light.r) * alpha, (g - light.g) * alpha, (b - light.b) * alpha, (a - light.a) * alpha);
            dark.add((r2 - dark.r) * alpha, (g2 - dark.g) * alpha, (b2 - dark.b) * alpha, 0);
        }
    }
};
let $5d5d4780b16fb6da$export$938c1752e1b56539 = $5d5d4780b16fb6da$var$_TwoColorTimeline;
$5d5d4780b16fb6da$export$938c1752e1b56539.ENTRIES = 8;
$5d5d4780b16fb6da$export$938c1752e1b56539.PREV_TIME = -8;
$5d5d4780b16fb6da$export$938c1752e1b56539.PREV_R = -7;
$5d5d4780b16fb6da$export$938c1752e1b56539.PREV_G = -6;
$5d5d4780b16fb6da$export$938c1752e1b56539.PREV_B = -5;
$5d5d4780b16fb6da$export$938c1752e1b56539.PREV_A = -4;
$5d5d4780b16fb6da$export$938c1752e1b56539.PREV_R2 = -3;
$5d5d4780b16fb6da$export$938c1752e1b56539.PREV_G2 = -2;
$5d5d4780b16fb6da$export$938c1752e1b56539.PREV_B2 = -1;
$5d5d4780b16fb6da$export$938c1752e1b56539.R = 1;
$5d5d4780b16fb6da$export$938c1752e1b56539.G = 2;
$5d5d4780b16fb6da$export$938c1752e1b56539.B = 3;
$5d5d4780b16fb6da$export$938c1752e1b56539.A = 4;
$5d5d4780b16fb6da$export$938c1752e1b56539.R2 = 5;
$5d5d4780b16fb6da$export$938c1752e1b56539.G2 = 6;
$5d5d4780b16fb6da$export$938c1752e1b56539.B2 = 7;
class $5d5d4780b16fb6da$export$7f2bfc5bd27cb43d {
    constructor(frameCount){
        this.frames = (0, $8804784813ffae81$export$d2ca453b913dcdea).newFloatArray(frameCount);
        this.attachmentNames = new Array(frameCount);
    }
    getPropertyId() {
        return 67108864 + this.slotIndex;
    }
    getFrameCount() {
        return this.frames.length;
    }
    /** Sets the time and value of the specified keyframe. */ setFrame(frameIndex, time, attachmentName) {
        this.frames[frameIndex] = time;
        this.attachmentNames[frameIndex] = attachmentName;
    }
    apply(skeleton, lastTime, time, events, alpha, blend, direction) {
        const slot = skeleton.slots[this.slotIndex];
        if (direction == (0, $bbcccedbc883e405$export$52fc338c0bb328ba).mixOut && blend == (0, $bbcccedbc883e405$export$ccab779a50275a35).setup) {
            const attachmentName2 = slot.data.attachmentName;
            slot.setAttachment(attachmentName2 == null ? null : skeleton.getAttachment(this.slotIndex, attachmentName2));
            return;
        }
        const frames = this.frames;
        if (time < frames[0]) {
            if (blend == (0, $bbcccedbc883e405$export$ccab779a50275a35).setup || blend == (0, $bbcccedbc883e405$export$ccab779a50275a35).first) {
                const attachmentName2 = slot.data.attachmentName;
                slot.setAttachment(attachmentName2 == null ? null : skeleton.getAttachment(this.slotIndex, attachmentName2));
            }
            return;
        }
        let frameIndex = 0;
        if (time >= frames[frames.length - 1]) frameIndex = frames.length - 1;
        else frameIndex = $5d5d4780b16fb6da$export$c35d437ae5945fcd.binarySearch(frames, time, 1) - 1;
        const attachmentName = this.attachmentNames[frameIndex];
        skeleton.slots[this.slotIndex].setAttachment(attachmentName == null ? null : skeleton.getAttachment(this.slotIndex, attachmentName));
    }
}
let $5d5d4780b16fb6da$var$zeros = null;
class $5d5d4780b16fb6da$export$6968d40e5689ad6b extends $5d5d4780b16fb6da$export$4094e7414845f78f {
    constructor(frameCount){
        super(frameCount);
        this.frames = (0, $8804784813ffae81$export$d2ca453b913dcdea).newFloatArray(frameCount);
        this.frameVertices = new Array(frameCount);
        if ($5d5d4780b16fb6da$var$zeros == null) $5d5d4780b16fb6da$var$zeros = (0, $8804784813ffae81$export$d2ca453b913dcdea).newFloatArray(64);
    }
    getPropertyId() {
        return 805306368 + Number(this.attachment.id) + this.slotIndex;
    }
    /** Sets the time of the specified keyframe. */ setFrame(frameIndex, time, vertices) {
        this.frames[frameIndex] = time;
        this.frameVertices[frameIndex] = vertices;
    }
    apply(skeleton, lastTime, time, firedEvents, alpha, blend, direction) {
        const slot = skeleton.slots[this.slotIndex];
        const slotAttachment = slot.getAttachment();
        if (!(slotAttachment instanceof (0, $47016c9c5bcec983$export$66d3a0c3be55e044)) || !slotAttachment.applyDeform(this.attachment)) return;
        const verticesArray = slot.attachmentVertices;
        if (verticesArray.length == 0) blend = (0, $bbcccedbc883e405$export$ccab779a50275a35).setup;
        const frameVertices = this.frameVertices;
        const vertexCount = frameVertices[0].length;
        const frames = this.frames;
        if (time < frames[0]) {
            const vertexAttachment = slotAttachment;
            switch(blend){
                case (0, $bbcccedbc883e405$export$ccab779a50275a35).setup:
                    verticesArray.length = 0;
                    return;
                case (0, $bbcccedbc883e405$export$ccab779a50275a35).first:
                    if (alpha == 1) {
                        verticesArray.length = 0;
                        break;
                    }
                    const vertices2 = (0, $8804784813ffae81$export$d2ca453b913dcdea).setArraySize(verticesArray, vertexCount);
                    if (vertexAttachment.bones == null) {
                        const setupVertices = vertexAttachment.vertices;
                        for(let i = 0; i < vertexCount; i++)vertices2[i] += (setupVertices[i] - vertices2[i]) * alpha;
                    } else {
                        alpha = 1 - alpha;
                        for(let i = 0; i < vertexCount; i++)vertices2[i] *= alpha;
                    }
            }
            return;
        }
        const vertices = (0, $8804784813ffae81$export$d2ca453b913dcdea).setArraySize(verticesArray, vertexCount);
        if (time >= frames[frames.length - 1]) {
            const lastVertices = frameVertices[frames.length - 1];
            if (alpha == 1) {
                if (blend == (0, $bbcccedbc883e405$export$ccab779a50275a35).add) {
                    const vertexAttachment = slotAttachment;
                    if (vertexAttachment.bones == null) {
                        const setupVertices = vertexAttachment.vertices;
                        for(let i = 0; i < vertexCount; i++)vertices[i] += lastVertices[i] - setupVertices[i];
                    } else for(let i = 0; i < vertexCount; i++)vertices[i] += lastVertices[i];
                } else (0, $8804784813ffae81$export$d2ca453b913dcdea).arrayCopy(lastVertices, 0, vertices, 0, vertexCount);
            } else switch(blend){
                case (0, $bbcccedbc883e405$export$ccab779a50275a35).setup:
                    {
                        const vertexAttachment2 = slotAttachment;
                        if (vertexAttachment2.bones == null) {
                            const setupVertices = vertexAttachment2.vertices;
                            for(let i = 0; i < vertexCount; i++){
                                const setup = setupVertices[i];
                                vertices[i] = setup + (lastVertices[i] - setup) * alpha;
                            }
                        } else for(let i = 0; i < vertexCount; i++)vertices[i] = lastVertices[i] * alpha;
                        break;
                    }
                case (0, $bbcccedbc883e405$export$ccab779a50275a35).first:
                case (0, $bbcccedbc883e405$export$ccab779a50275a35).replace:
                    for(let i = 0; i < vertexCount; i++)vertices[i] += (lastVertices[i] - vertices[i]) * alpha;
                case (0, $bbcccedbc883e405$export$ccab779a50275a35).add:
                    const vertexAttachment = slotAttachment;
                    if (vertexAttachment.bones == null) {
                        const setupVertices = vertexAttachment.vertices;
                        for(let i = 0; i < vertexCount; i++)vertices[i] += (lastVertices[i] - setupVertices[i]) * alpha;
                    } else for(let i = 0; i < vertexCount; i++)vertices[i] += lastVertices[i] * alpha;
            }
            return;
        }
        const frame = $5d5d4780b16fb6da$export$c35d437ae5945fcd.binarySearch(frames, time);
        const prevVertices = frameVertices[frame - 1];
        const nextVertices = frameVertices[frame];
        const frameTime = frames[frame];
        const percent = this.getCurvePercent(frame - 1, 1 - (time - frameTime) / (frames[frame - 1] - frameTime));
        if (alpha == 1) {
            if (blend == (0, $bbcccedbc883e405$export$ccab779a50275a35).add) {
                const vertexAttachment = slotAttachment;
                if (vertexAttachment.bones == null) {
                    const setupVertices = vertexAttachment.vertices;
                    for(let i = 0; i < vertexCount; i++){
                        const prev = prevVertices[i];
                        vertices[i] += prev + (nextVertices[i] - prev) * percent - setupVertices[i];
                    }
                } else for(let i = 0; i < vertexCount; i++){
                    const prev = prevVertices[i];
                    vertices[i] += prev + (nextVertices[i] - prev) * percent;
                }
            } else for(let i = 0; i < vertexCount; i++){
                const prev = prevVertices[i];
                vertices[i] = prev + (nextVertices[i] - prev) * percent;
            }
        } else switch(blend){
            case (0, $bbcccedbc883e405$export$ccab779a50275a35).setup:
                {
                    const vertexAttachment2 = slotAttachment;
                    if (vertexAttachment2.bones == null) {
                        const setupVertices = vertexAttachment2.vertices;
                        for(let i = 0; i < vertexCount; i++){
                            const prev = prevVertices[i];
                            const setup = setupVertices[i];
                            vertices[i] = setup + (prev + (nextVertices[i] - prev) * percent - setup) * alpha;
                        }
                    } else for(let i = 0; i < vertexCount; i++){
                        const prev = prevVertices[i];
                        vertices[i] = (prev + (nextVertices[i] - prev) * percent) * alpha;
                    }
                    break;
                }
            case (0, $bbcccedbc883e405$export$ccab779a50275a35).first:
            case (0, $bbcccedbc883e405$export$ccab779a50275a35).replace:
                for(let i = 0; i < vertexCount; i++){
                    const prev = prevVertices[i];
                    vertices[i] += (prev + (nextVertices[i] - prev) * percent - vertices[i]) * alpha;
                }
                break;
            case (0, $bbcccedbc883e405$export$ccab779a50275a35).add:
                const vertexAttachment = slotAttachment;
                if (vertexAttachment.bones == null) {
                    const setupVertices = vertexAttachment.vertices;
                    for(let i = 0; i < vertexCount; i++){
                        const prev = prevVertices[i];
                        vertices[i] += (prev + (nextVertices[i] - prev) * percent - setupVertices[i]) * alpha;
                    }
                } else for(let i = 0; i < vertexCount; i++){
                    const prev = prevVertices[i];
                    vertices[i] += (prev + (nextVertices[i] - prev) * percent) * alpha;
                }
        }
    }
}
class $5d5d4780b16fb6da$export$4f4bca996c586084 {
    constructor(frameCount){
        this.frames = (0, $8804784813ffae81$export$d2ca453b913dcdea).newFloatArray(frameCount);
        this.events = new Array(frameCount);
    }
    getPropertyId() {
        return 117440512;
    }
    getFrameCount() {
        return this.frames.length;
    }
    /** Sets the time of the specified keyframe. */ setFrame(frameIndex, event) {
        this.frames[frameIndex] = event.time;
        this.events[frameIndex] = event;
    }
    /** Fires events for frames > lastTime and <= time. */ apply(skeleton, lastTime, time, firedEvents, alpha, blend, direction) {
        if (firedEvents == null) return;
        const frames = this.frames;
        const frameCount = this.frames.length;
        if (lastTime > time) {
            this.apply(skeleton, lastTime, Number.MAX_VALUE, firedEvents, alpha, blend, direction);
            lastTime = -1;
        } else if (lastTime >= frames[frameCount - 1]) return;
        if (time < frames[0]) return;
        let frame = 0;
        if (lastTime < frames[0]) frame = 0;
        else {
            frame = $5d5d4780b16fb6da$export$c35d437ae5945fcd.binarySearch(frames, lastTime);
            const frameTime = frames[frame];
            while(frame > 0){
                if (frames[frame - 1] != frameTime) break;
                frame--;
            }
        }
        for(; frame < frameCount && time >= frames[frame]; frame++)firedEvents.push(this.events[frame]);
    }
}
class $5d5d4780b16fb6da$export$ece1f7c41d051e83 {
    constructor(frameCount){
        this.frames = (0, $8804784813ffae81$export$d2ca453b913dcdea).newFloatArray(frameCount);
        this.drawOrders = new Array(frameCount);
    }
    getPropertyId() {
        return 134217728;
    }
    getFrameCount() {
        return this.frames.length;
    }
    /** Sets the time of the specified keyframe.
   * @param drawOrder May be null to use bind pose draw order. */ setFrame(frameIndex, time, drawOrder) {
        this.frames[frameIndex] = time;
        this.drawOrders[frameIndex] = drawOrder;
    }
    apply(skeleton, lastTime, time, firedEvents, alpha, blend, direction) {
        const drawOrder = skeleton.drawOrder;
        const slots = skeleton.slots;
        if (direction == (0, $bbcccedbc883e405$export$52fc338c0bb328ba).mixOut && blend == (0, $bbcccedbc883e405$export$ccab779a50275a35).setup) {
            (0, $8804784813ffae81$export$d2ca453b913dcdea).arrayCopy(skeleton.slots, 0, skeleton.drawOrder, 0, skeleton.slots.length);
            return;
        }
        const frames = this.frames;
        if (time < frames[0]) {
            if (blend == (0, $bbcccedbc883e405$export$ccab779a50275a35).setup || blend == (0, $bbcccedbc883e405$export$ccab779a50275a35).first) (0, $8804784813ffae81$export$d2ca453b913dcdea).arrayCopy(skeleton.slots, 0, skeleton.drawOrder, 0, skeleton.slots.length);
            return;
        }
        let frame = 0;
        if (time >= frames[frames.length - 1]) frame = frames.length - 1;
        else frame = $5d5d4780b16fb6da$export$c35d437ae5945fcd.binarySearch(frames, time) - 1;
        const drawOrderToSetupIndex = this.drawOrders[frame];
        if (drawOrderToSetupIndex == null) (0, $8804784813ffae81$export$d2ca453b913dcdea).arrayCopy(slots, 0, drawOrder, 0, slots.length);
        else for(let i = 0, n = drawOrderToSetupIndex.length; i < n; i++)drawOrder[i] = slots[drawOrderToSetupIndex[i]];
    }
}
const $5d5d4780b16fb6da$var$_IkConstraintTimeline = class extends $5d5d4780b16fb6da$export$4094e7414845f78f {
    // time, mix, bendDirection, compress, stretch, ...
    constructor(frameCount){
        super(frameCount);
        this.frames = (0, $8804784813ffae81$export$d2ca453b913dcdea).newFloatArray(frameCount * $5d5d4780b16fb6da$var$_IkConstraintTimeline.ENTRIES);
    }
    getPropertyId() {
        return 150994944 + this.ikConstraintIndex;
    }
    /** Sets the time, mix and bend direction of the specified keyframe. */ setFrame(frameIndex, time, mix, bendDirection, compress, stretch) {
        frameIndex *= $5d5d4780b16fb6da$var$_IkConstraintTimeline.ENTRIES;
        this.frames[frameIndex] = time;
        this.frames[frameIndex + $5d5d4780b16fb6da$var$_IkConstraintTimeline.MIX] = mix;
        this.frames[frameIndex + $5d5d4780b16fb6da$var$_IkConstraintTimeline.BEND_DIRECTION] = bendDirection;
        this.frames[frameIndex + $5d5d4780b16fb6da$var$_IkConstraintTimeline.COMPRESS] = compress ? 1 : 0;
        this.frames[frameIndex + $5d5d4780b16fb6da$var$_IkConstraintTimeline.STRETCH] = stretch ? 1 : 0;
    }
    apply(skeleton, lastTime, time, firedEvents, alpha, blend, direction) {
        const frames = this.frames;
        const constraint = skeleton.ikConstraints[this.ikConstraintIndex];
        if (time < frames[0]) {
            switch(blend){
                case (0, $bbcccedbc883e405$export$ccab779a50275a35).setup:
                    constraint.mix = constraint.data.mix;
                    constraint.bendDirection = constraint.data.bendDirection;
                    constraint.compress = constraint.data.compress;
                    constraint.stretch = constraint.data.stretch;
                    return;
                case (0, $bbcccedbc883e405$export$ccab779a50275a35).first:
                    constraint.mix += (constraint.data.mix - constraint.mix) * alpha;
                    constraint.bendDirection = constraint.data.bendDirection;
                    constraint.compress = constraint.data.compress;
                    constraint.stretch = constraint.data.stretch;
            }
            return;
        }
        if (time >= frames[frames.length - $5d5d4780b16fb6da$var$_IkConstraintTimeline.ENTRIES]) {
            if (blend == (0, $bbcccedbc883e405$export$ccab779a50275a35).setup) {
                constraint.mix = constraint.data.mix + (frames[frames.length + $5d5d4780b16fb6da$var$_IkConstraintTimeline.PREV_MIX] - constraint.data.mix) * alpha;
                if (direction == (0, $bbcccedbc883e405$export$52fc338c0bb328ba).mixOut) {
                    constraint.bendDirection = constraint.data.bendDirection;
                    constraint.compress = constraint.data.compress;
                    constraint.stretch = constraint.data.stretch;
                } else {
                    constraint.bendDirection = frames[frames.length + $5d5d4780b16fb6da$var$_IkConstraintTimeline.PREV_BEND_DIRECTION];
                    constraint.compress = frames[frames.length + $5d5d4780b16fb6da$var$_IkConstraintTimeline.PREV_COMPRESS] != 0;
                    constraint.stretch = frames[frames.length + $5d5d4780b16fb6da$var$_IkConstraintTimeline.PREV_STRETCH] != 0;
                }
            } else {
                constraint.mix += (frames[frames.length + $5d5d4780b16fb6da$var$_IkConstraintTimeline.PREV_MIX] - constraint.mix) * alpha;
                if (direction == (0, $bbcccedbc883e405$export$52fc338c0bb328ba).mixIn) {
                    constraint.bendDirection = frames[frames.length + $5d5d4780b16fb6da$var$_IkConstraintTimeline.PREV_BEND_DIRECTION];
                    constraint.compress = frames[frames.length + $5d5d4780b16fb6da$var$_IkConstraintTimeline.PREV_COMPRESS] != 0;
                    constraint.stretch = frames[frames.length + $5d5d4780b16fb6da$var$_IkConstraintTimeline.PREV_STRETCH] != 0;
                }
            }
            return;
        }
        const frame = $5d5d4780b16fb6da$export$c35d437ae5945fcd.binarySearch(frames, time, $5d5d4780b16fb6da$var$_IkConstraintTimeline.ENTRIES);
        const mix = frames[frame + $5d5d4780b16fb6da$var$_IkConstraintTimeline.PREV_MIX];
        const frameTime = frames[frame];
        const percent = this.getCurvePercent(frame / $5d5d4780b16fb6da$var$_IkConstraintTimeline.ENTRIES - 1, 1 - (time - frameTime) / (frames[frame + $5d5d4780b16fb6da$var$_IkConstraintTimeline.PREV_TIME] - frameTime));
        if (blend == (0, $bbcccedbc883e405$export$ccab779a50275a35).setup) {
            constraint.mix = constraint.data.mix + (mix + (frames[frame + $5d5d4780b16fb6da$var$_IkConstraintTimeline.MIX] - mix) * percent - constraint.data.mix) * alpha;
            if (direction == (0, $bbcccedbc883e405$export$52fc338c0bb328ba).mixOut) {
                constraint.bendDirection = constraint.data.bendDirection;
                constraint.compress = constraint.data.compress;
                constraint.stretch = constraint.data.stretch;
            } else {
                constraint.bendDirection = frames[frame + $5d5d4780b16fb6da$var$_IkConstraintTimeline.PREV_BEND_DIRECTION];
                constraint.compress = frames[frame + $5d5d4780b16fb6da$var$_IkConstraintTimeline.PREV_COMPRESS] != 0;
                constraint.stretch = frames[frame + $5d5d4780b16fb6da$var$_IkConstraintTimeline.PREV_STRETCH] != 0;
            }
        } else {
            constraint.mix += (mix + (frames[frame + $5d5d4780b16fb6da$var$_IkConstraintTimeline.MIX] - mix) * percent - constraint.mix) * alpha;
            if (direction == (0, $bbcccedbc883e405$export$52fc338c0bb328ba).mixIn) {
                constraint.bendDirection = frames[frame + $5d5d4780b16fb6da$var$_IkConstraintTimeline.PREV_BEND_DIRECTION];
                constraint.compress = frames[frame + $5d5d4780b16fb6da$var$_IkConstraintTimeline.PREV_COMPRESS] != 0;
                constraint.stretch = frames[frame + $5d5d4780b16fb6da$var$_IkConstraintTimeline.PREV_STRETCH] != 0;
            }
        }
    }
};
let $5d5d4780b16fb6da$export$73d125cd89dead44 = $5d5d4780b16fb6da$var$_IkConstraintTimeline;
$5d5d4780b16fb6da$export$73d125cd89dead44.ENTRIES = 5;
$5d5d4780b16fb6da$export$73d125cd89dead44.PREV_TIME = -5;
$5d5d4780b16fb6da$export$73d125cd89dead44.PREV_MIX = -4;
$5d5d4780b16fb6da$export$73d125cd89dead44.PREV_BEND_DIRECTION = -3;
$5d5d4780b16fb6da$export$73d125cd89dead44.PREV_COMPRESS = -2;
$5d5d4780b16fb6da$export$73d125cd89dead44.PREV_STRETCH = -1;
$5d5d4780b16fb6da$export$73d125cd89dead44.MIX = 1;
$5d5d4780b16fb6da$export$73d125cd89dead44.BEND_DIRECTION = 2;
$5d5d4780b16fb6da$export$73d125cd89dead44.COMPRESS = 3;
$5d5d4780b16fb6da$export$73d125cd89dead44.STRETCH = 4;
const $5d5d4780b16fb6da$var$_TransformConstraintTimeline = class extends $5d5d4780b16fb6da$export$4094e7414845f78f {
    // time, rotate mix, translate mix, scale mix, shear mix, ...
    constructor(frameCount){
        super(frameCount);
        this.frames = (0, $8804784813ffae81$export$d2ca453b913dcdea).newFloatArray(frameCount * $5d5d4780b16fb6da$var$_TransformConstraintTimeline.ENTRIES);
    }
    getPropertyId() {
        return 167772160 + this.transformConstraintIndex;
    }
    /** Sets the time and mixes of the specified keyframe. */ setFrame(frameIndex, time, rotateMix, translateMix, scaleMix, shearMix) {
        frameIndex *= $5d5d4780b16fb6da$var$_TransformConstraintTimeline.ENTRIES;
        this.frames[frameIndex] = time;
        this.frames[frameIndex + $5d5d4780b16fb6da$var$_TransformConstraintTimeline.ROTATE] = rotateMix;
        this.frames[frameIndex + $5d5d4780b16fb6da$var$_TransformConstraintTimeline.TRANSLATE] = translateMix;
        this.frames[frameIndex + $5d5d4780b16fb6da$var$_TransformConstraintTimeline.SCALE] = scaleMix;
        this.frames[frameIndex + $5d5d4780b16fb6da$var$_TransformConstraintTimeline.SHEAR] = shearMix;
    }
    apply(skeleton, lastTime, time, firedEvents, alpha, blend, direction) {
        const frames = this.frames;
        const constraint = skeleton.transformConstraints[this.transformConstraintIndex];
        if (time < frames[0]) {
            const data = constraint.data;
            switch(blend){
                case (0, $bbcccedbc883e405$export$ccab779a50275a35).setup:
                    constraint.rotateMix = data.rotateMix;
                    constraint.translateMix = data.translateMix;
                    constraint.scaleMix = data.scaleMix;
                    constraint.shearMix = data.shearMix;
                    return;
                case (0, $bbcccedbc883e405$export$ccab779a50275a35).first:
                    constraint.rotateMix += (data.rotateMix - constraint.rotateMix) * alpha;
                    constraint.translateMix += (data.translateMix - constraint.translateMix) * alpha;
                    constraint.scaleMix += (data.scaleMix - constraint.scaleMix) * alpha;
                    constraint.shearMix += (data.shearMix - constraint.shearMix) * alpha;
            }
            return;
        }
        let rotate = 0;
        let translate = 0;
        let scale = 0;
        let shear = 0;
        if (time >= frames[frames.length - $5d5d4780b16fb6da$var$_TransformConstraintTimeline.ENTRIES]) {
            const i = frames.length;
            rotate = frames[i + $5d5d4780b16fb6da$var$_TransformConstraintTimeline.PREV_ROTATE];
            translate = frames[i + $5d5d4780b16fb6da$var$_TransformConstraintTimeline.PREV_TRANSLATE];
            scale = frames[i + $5d5d4780b16fb6da$var$_TransformConstraintTimeline.PREV_SCALE];
            shear = frames[i + $5d5d4780b16fb6da$var$_TransformConstraintTimeline.PREV_SHEAR];
        } else {
            const frame = $5d5d4780b16fb6da$export$c35d437ae5945fcd.binarySearch(frames, time, $5d5d4780b16fb6da$var$_TransformConstraintTimeline.ENTRIES);
            rotate = frames[frame + $5d5d4780b16fb6da$var$_TransformConstraintTimeline.PREV_ROTATE];
            translate = frames[frame + $5d5d4780b16fb6da$var$_TransformConstraintTimeline.PREV_TRANSLATE];
            scale = frames[frame + $5d5d4780b16fb6da$var$_TransformConstraintTimeline.PREV_SCALE];
            shear = frames[frame + $5d5d4780b16fb6da$var$_TransformConstraintTimeline.PREV_SHEAR];
            const frameTime = frames[frame];
            const percent = this.getCurvePercent(frame / $5d5d4780b16fb6da$var$_TransformConstraintTimeline.ENTRIES - 1, 1 - (time - frameTime) / (frames[frame + $5d5d4780b16fb6da$var$_TransformConstraintTimeline.PREV_TIME] - frameTime));
            rotate += (frames[frame + $5d5d4780b16fb6da$var$_TransformConstraintTimeline.ROTATE] - rotate) * percent;
            translate += (frames[frame + $5d5d4780b16fb6da$var$_TransformConstraintTimeline.TRANSLATE] - translate) * percent;
            scale += (frames[frame + $5d5d4780b16fb6da$var$_TransformConstraintTimeline.SCALE] - scale) * percent;
            shear += (frames[frame + $5d5d4780b16fb6da$var$_TransformConstraintTimeline.SHEAR] - shear) * percent;
        }
        if (blend == (0, $bbcccedbc883e405$export$ccab779a50275a35).setup) {
            const data = constraint.data;
            constraint.rotateMix = data.rotateMix + (rotate - data.rotateMix) * alpha;
            constraint.translateMix = data.translateMix + (translate - data.translateMix) * alpha;
            constraint.scaleMix = data.scaleMix + (scale - data.scaleMix) * alpha;
            constraint.shearMix = data.shearMix + (shear - data.shearMix) * alpha;
        } else {
            constraint.rotateMix += (rotate - constraint.rotateMix) * alpha;
            constraint.translateMix += (translate - constraint.translateMix) * alpha;
            constraint.scaleMix += (scale - constraint.scaleMix) * alpha;
            constraint.shearMix += (shear - constraint.shearMix) * alpha;
        }
    }
};
let $5d5d4780b16fb6da$export$a7a393c2ad815ac7 = $5d5d4780b16fb6da$var$_TransformConstraintTimeline;
$5d5d4780b16fb6da$export$a7a393c2ad815ac7.ENTRIES = 5;
$5d5d4780b16fb6da$export$a7a393c2ad815ac7.PREV_TIME = -5;
$5d5d4780b16fb6da$export$a7a393c2ad815ac7.PREV_ROTATE = -4;
$5d5d4780b16fb6da$export$a7a393c2ad815ac7.PREV_TRANSLATE = -3;
$5d5d4780b16fb6da$export$a7a393c2ad815ac7.PREV_SCALE = -2;
$5d5d4780b16fb6da$export$a7a393c2ad815ac7.PREV_SHEAR = -1;
$5d5d4780b16fb6da$export$a7a393c2ad815ac7.ROTATE = 1;
$5d5d4780b16fb6da$export$a7a393c2ad815ac7.TRANSLATE = 2;
$5d5d4780b16fb6da$export$a7a393c2ad815ac7.SCALE = 3;
$5d5d4780b16fb6da$export$a7a393c2ad815ac7.SHEAR = 4;
const $5d5d4780b16fb6da$var$_PathConstraintPositionTimeline = class extends $5d5d4780b16fb6da$export$4094e7414845f78f {
    // time, position, ...
    constructor(frameCount){
        super(frameCount);
        this.frames = (0, $8804784813ffae81$export$d2ca453b913dcdea).newFloatArray(frameCount * $5d5d4780b16fb6da$var$_PathConstraintPositionTimeline.ENTRIES);
    }
    getPropertyId() {
        return 184549376 + this.pathConstraintIndex;
    }
    /** Sets the time and value of the specified keyframe. */ setFrame(frameIndex, time, value) {
        frameIndex *= $5d5d4780b16fb6da$var$_PathConstraintPositionTimeline.ENTRIES;
        this.frames[frameIndex] = time;
        this.frames[frameIndex + $5d5d4780b16fb6da$var$_PathConstraintPositionTimeline.VALUE] = value;
    }
    apply(skeleton, lastTime, time, firedEvents, alpha, blend, direction) {
        const frames = this.frames;
        const constraint = skeleton.pathConstraints[this.pathConstraintIndex];
        if (time < frames[0]) {
            switch(blend){
                case (0, $bbcccedbc883e405$export$ccab779a50275a35).setup:
                    constraint.position = constraint.data.position;
                    return;
                case (0, $bbcccedbc883e405$export$ccab779a50275a35).first:
                    constraint.position += (constraint.data.position - constraint.position) * alpha;
            }
            return;
        }
        let position = 0;
        if (time >= frames[frames.length - $5d5d4780b16fb6da$var$_PathConstraintPositionTimeline.ENTRIES]) position = frames[frames.length + $5d5d4780b16fb6da$var$_PathConstraintPositionTimeline.PREV_VALUE];
        else {
            const frame = $5d5d4780b16fb6da$export$c35d437ae5945fcd.binarySearch(frames, time, $5d5d4780b16fb6da$var$_PathConstraintPositionTimeline.ENTRIES);
            position = frames[frame + $5d5d4780b16fb6da$var$_PathConstraintPositionTimeline.PREV_VALUE];
            const frameTime = frames[frame];
            const percent = this.getCurvePercent(frame / $5d5d4780b16fb6da$var$_PathConstraintPositionTimeline.ENTRIES - 1, 1 - (time - frameTime) / (frames[frame + $5d5d4780b16fb6da$var$_PathConstraintPositionTimeline.PREV_TIME] - frameTime));
            position += (frames[frame + $5d5d4780b16fb6da$var$_PathConstraintPositionTimeline.VALUE] - position) * percent;
        }
        if (blend == (0, $bbcccedbc883e405$export$ccab779a50275a35).setup) constraint.position = constraint.data.position + (position - constraint.data.position) * alpha;
        else constraint.position += (position - constraint.position) * alpha;
    }
};
let $5d5d4780b16fb6da$export$7ce7e67fd9cc52ed = $5d5d4780b16fb6da$var$_PathConstraintPositionTimeline;
$5d5d4780b16fb6da$export$7ce7e67fd9cc52ed.ENTRIES = 2;
$5d5d4780b16fb6da$export$7ce7e67fd9cc52ed.PREV_TIME = -2;
$5d5d4780b16fb6da$export$7ce7e67fd9cc52ed.PREV_VALUE = -1;
$5d5d4780b16fb6da$export$7ce7e67fd9cc52ed.VALUE = 1;
class $5d5d4780b16fb6da$export$17ee50c08a07e62b extends $5d5d4780b16fb6da$export$7ce7e67fd9cc52ed {
    constructor(frameCount){
        super(frameCount);
    }
    getPropertyId() {
        return 201326592 + this.pathConstraintIndex;
    }
    apply(skeleton, lastTime, time, firedEvents, alpha, blend, direction) {
        const frames = this.frames;
        const constraint = skeleton.pathConstraints[this.pathConstraintIndex];
        if (time < frames[0]) {
            switch(blend){
                case (0, $bbcccedbc883e405$export$ccab779a50275a35).setup:
                    constraint.spacing = constraint.data.spacing;
                    return;
                case (0, $bbcccedbc883e405$export$ccab779a50275a35).first:
                    constraint.spacing += (constraint.data.spacing - constraint.spacing) * alpha;
            }
            return;
        }
        let spacing = 0;
        if (time >= frames[frames.length - $5d5d4780b16fb6da$export$17ee50c08a07e62b.ENTRIES]) spacing = frames[frames.length + $5d5d4780b16fb6da$export$17ee50c08a07e62b.PREV_VALUE];
        else {
            const frame = $5d5d4780b16fb6da$export$c35d437ae5945fcd.binarySearch(frames, time, $5d5d4780b16fb6da$export$17ee50c08a07e62b.ENTRIES);
            spacing = frames[frame + $5d5d4780b16fb6da$export$17ee50c08a07e62b.PREV_VALUE];
            const frameTime = frames[frame];
            const percent = this.getCurvePercent(frame / $5d5d4780b16fb6da$export$17ee50c08a07e62b.ENTRIES - 1, 1 - (time - frameTime) / (frames[frame + $5d5d4780b16fb6da$export$17ee50c08a07e62b.PREV_TIME] - frameTime));
            spacing += (frames[frame + $5d5d4780b16fb6da$export$17ee50c08a07e62b.VALUE] - spacing) * percent;
        }
        if (blend == (0, $bbcccedbc883e405$export$ccab779a50275a35).setup) constraint.spacing = constraint.data.spacing + (spacing - constraint.data.spacing) * alpha;
        else constraint.spacing += (spacing - constraint.spacing) * alpha;
    }
}
const $5d5d4780b16fb6da$var$_PathConstraintMixTimeline = class extends $5d5d4780b16fb6da$export$4094e7414845f78f {
    // time, rotate mix, translate mix, ...
    constructor(frameCount){
        super(frameCount);
        this.frames = (0, $8804784813ffae81$export$d2ca453b913dcdea).newFloatArray(frameCount * $5d5d4780b16fb6da$var$_PathConstraintMixTimeline.ENTRIES);
    }
    getPropertyId() {
        return 218103808 + this.pathConstraintIndex;
    }
    /** Sets the time and mixes of the specified keyframe. */ setFrame(frameIndex, time, rotateMix, translateMix) {
        frameIndex *= $5d5d4780b16fb6da$var$_PathConstraintMixTimeline.ENTRIES;
        this.frames[frameIndex] = time;
        this.frames[frameIndex + $5d5d4780b16fb6da$var$_PathConstraintMixTimeline.ROTATE] = rotateMix;
        this.frames[frameIndex + $5d5d4780b16fb6da$var$_PathConstraintMixTimeline.TRANSLATE] = translateMix;
    }
    apply(skeleton, lastTime, time, firedEvents, alpha, blend, direction) {
        const frames = this.frames;
        const constraint = skeleton.pathConstraints[this.pathConstraintIndex];
        if (time < frames[0]) {
            switch(blend){
                case (0, $bbcccedbc883e405$export$ccab779a50275a35).setup:
                    constraint.rotateMix = constraint.data.rotateMix;
                    constraint.translateMix = constraint.data.translateMix;
                    return;
                case (0, $bbcccedbc883e405$export$ccab779a50275a35).first:
                    constraint.rotateMix += (constraint.data.rotateMix - constraint.rotateMix) * alpha;
                    constraint.translateMix += (constraint.data.translateMix - constraint.translateMix) * alpha;
            }
            return;
        }
        let rotate = 0;
        let translate = 0;
        if (time >= frames[frames.length - $5d5d4780b16fb6da$var$_PathConstraintMixTimeline.ENTRIES]) {
            rotate = frames[frames.length + $5d5d4780b16fb6da$var$_PathConstraintMixTimeline.PREV_ROTATE];
            translate = frames[frames.length + $5d5d4780b16fb6da$var$_PathConstraintMixTimeline.PREV_TRANSLATE];
        } else {
            const frame = $5d5d4780b16fb6da$export$c35d437ae5945fcd.binarySearch(frames, time, $5d5d4780b16fb6da$var$_PathConstraintMixTimeline.ENTRIES);
            rotate = frames[frame + $5d5d4780b16fb6da$var$_PathConstraintMixTimeline.PREV_ROTATE];
            translate = frames[frame + $5d5d4780b16fb6da$var$_PathConstraintMixTimeline.PREV_TRANSLATE];
            const frameTime = frames[frame];
            const percent = this.getCurvePercent(frame / $5d5d4780b16fb6da$var$_PathConstraintMixTimeline.ENTRIES - 1, 1 - (time - frameTime) / (frames[frame + $5d5d4780b16fb6da$var$_PathConstraintMixTimeline.PREV_TIME] - frameTime));
            rotate += (frames[frame + $5d5d4780b16fb6da$var$_PathConstraintMixTimeline.ROTATE] - rotate) * percent;
            translate += (frames[frame + $5d5d4780b16fb6da$var$_PathConstraintMixTimeline.TRANSLATE] - translate) * percent;
        }
        if (blend == (0, $bbcccedbc883e405$export$ccab779a50275a35).setup) {
            constraint.rotateMix = constraint.data.rotateMix + (rotate - constraint.data.rotateMix) * alpha;
            constraint.translateMix = constraint.data.translateMix + (translate - constraint.data.translateMix) * alpha;
        } else {
            constraint.rotateMix += (rotate - constraint.rotateMix) * alpha;
            constraint.translateMix += (translate - constraint.translateMix) * alpha;
        }
    }
};
let $5d5d4780b16fb6da$export$ea67b41755485038 = $5d5d4780b16fb6da$var$_PathConstraintMixTimeline;
$5d5d4780b16fb6da$export$ea67b41755485038.ENTRIES = 3;
$5d5d4780b16fb6da$export$ea67b41755485038.PREV_TIME = -3;
$5d5d4780b16fb6da$export$ea67b41755485038.PREV_ROTATE = -2;
$5d5d4780b16fb6da$export$ea67b41755485038.PREV_TRANSLATE = -1;
$5d5d4780b16fb6da$export$ea67b41755485038.ROTATE = 1;
$5d5d4780b16fb6da$export$ea67b41755485038.TRANSLATE = 2;




const $aaa386b4abc834f7$var$_AnimationState = class {
    constructor(data){
        this.tracks = new Array();
        this.events = new Array();
        this.listeners = new Array();
        this.queue = new $aaa386b4abc834f7$export$2fc6338444a158e6(this);
        this.propertyIDs = new (0, $8804784813ffae81$export$270182061f11fa81)();
        this.animationsChanged = false;
        this.timeScale = 1;
        this.trackEntryPool = new (0, $8804784813ffae81$export$14963ee5c8637e11)(()=>new $aaa386b4abc834f7$export$6fd48f25bc0ee658());
        this.data = data;
    }
    update(delta) {
        delta *= this.timeScale;
        const tracks = this.tracks;
        for(let i = 0, n = tracks.length; i < n; i++){
            const current = tracks[i];
            if (current == null) continue;
            current.animationLast = current.nextAnimationLast;
            current.trackLast = current.nextTrackLast;
            let currentDelta = delta * current.timeScale;
            if (current.delay > 0) {
                current.delay -= currentDelta;
                if (current.delay > 0) continue;
                currentDelta = -current.delay;
                current.delay = 0;
            }
            let next = current.next;
            if (next != null) {
                const nextTime = current.trackLast - next.delay;
                if (nextTime >= 0) {
                    next.delay = 0;
                    next.trackTime = current.timeScale == 0 ? 0 : (nextTime / current.timeScale + delta) * next.timeScale;
                    current.trackTime += currentDelta;
                    this.setCurrent(i, next, true);
                    while(next.mixingFrom != null){
                        next.mixTime += delta;
                        next = next.mixingFrom;
                    }
                    continue;
                }
            } else if (current.trackLast >= current.trackEnd && current.mixingFrom == null) {
                tracks[i] = null;
                this.queue.end(current);
                this.disposeNext(current);
                continue;
            }
            if (current.mixingFrom != null && this.updateMixingFrom(current, delta)) {
                let from = current.mixingFrom;
                current.mixingFrom = null;
                if (from != null) from.mixingTo = null;
                while(from != null){
                    this.queue.end(from);
                    from = from.mixingFrom;
                }
            }
            current.trackTime += currentDelta;
        }
        this.queue.drain();
    }
    updateMixingFrom(to, delta) {
        const from = to.mixingFrom;
        if (from == null) return true;
        const finished = this.updateMixingFrom(from, delta);
        from.animationLast = from.nextAnimationLast;
        from.trackLast = from.nextTrackLast;
        if (to.mixTime > 0 && to.mixTime >= to.mixDuration) {
            if (from.totalAlpha == 0 || to.mixDuration == 0) {
                to.mixingFrom = from.mixingFrom;
                if (from.mixingFrom != null) from.mixingFrom.mixingTo = to;
                to.interruptAlpha = from.interruptAlpha;
                this.queue.end(from);
            }
            return finished;
        }
        from.trackTime += delta * from.timeScale;
        to.mixTime += delta;
        return false;
    }
    apply(skeleton) {
        if (skeleton == null) throw new Error("skeleton cannot be null.");
        if (this.animationsChanged) this._animationsChanged();
        const events = this.events;
        const tracks = this.tracks;
        let applied = false;
        for(let i = 0, n = tracks.length; i < n; i++){
            const current = tracks[i];
            if (current == null || current.delay > 0) continue;
            applied = true;
            const blend = i == 0 ? (0, $bbcccedbc883e405$export$ccab779a50275a35).first : current.mixBlend;
            let mix = current.alpha;
            if (current.mixingFrom != null) mix *= this.applyMixingFrom(current, skeleton, blend);
            else if (current.trackTime >= current.trackEnd && current.next == null) mix = 0;
            const animationLast = current.animationLast;
            const animationTime = current.getAnimationTime();
            const timelineCount = current.animation.timelines.length;
            const timelines = current.animation.timelines;
            if (i == 0 && mix == 1 || blend == (0, $bbcccedbc883e405$export$ccab779a50275a35).add) for(let ii = 0; ii < timelineCount; ii++){
                (0, $8804784813ffae81$export$d2ca453b913dcdea).webkit602BugfixHelper(mix, blend);
                timelines[ii].apply(skeleton, animationLast, animationTime, events, mix, blend, (0, $bbcccedbc883e405$export$52fc338c0bb328ba).mixIn);
            }
            else {
                const timelineMode = current.timelineMode;
                const firstFrame = current.timelinesRotation.length == 0;
                if (firstFrame) (0, $8804784813ffae81$export$d2ca453b913dcdea).setArraySize(current.timelinesRotation, timelineCount << 1, null);
                const timelinesRotation = current.timelinesRotation;
                for(let ii = 0; ii < timelineCount; ii++){
                    const timeline = timelines[ii];
                    const timelineBlend = timelineMode[ii] == $aaa386b4abc834f7$var$_AnimationState.SUBSEQUENT ? blend : (0, $bbcccedbc883e405$export$ccab779a50275a35).setup;
                    if (timeline instanceof (0, $5d5d4780b16fb6da$export$b7ecb8f68b3e130b)) this.applyRotateTimeline(timeline, skeleton, animationTime, mix, timelineBlend, timelinesRotation, ii << 1, firstFrame);
                    else {
                        (0, $8804784813ffae81$export$d2ca453b913dcdea).webkit602BugfixHelper(mix, blend);
                        timeline.apply(skeleton, animationLast, animationTime, events, mix, timelineBlend, (0, $bbcccedbc883e405$export$52fc338c0bb328ba).mixIn);
                    }
                }
            }
            this.queueEvents(current, animationTime);
            events.length = 0;
            current.nextAnimationLast = animationTime;
            current.nextTrackLast = current.trackTime;
        }
        this.queue.drain();
        return applied;
    }
    applyMixingFrom(to, skeleton, blend) {
        const from = to.mixingFrom;
        if (from.mixingFrom != null) this.applyMixingFrom(from, skeleton, blend);
        let mix = 0;
        if (to.mixDuration == 0) {
            mix = 1;
            if (blend == (0, $bbcccedbc883e405$export$ccab779a50275a35).first) blend = (0, $bbcccedbc883e405$export$ccab779a50275a35).setup;
        } else {
            mix = to.mixTime / to.mixDuration;
            if (mix > 1) mix = 1;
            if (blend != (0, $bbcccedbc883e405$export$ccab779a50275a35).first) blend = from.mixBlend;
        }
        const events = mix < from.eventThreshold ? this.events : null;
        const attachments = mix < from.attachmentThreshold;
        const drawOrder = mix < from.drawOrderThreshold;
        const animationLast = from.animationLast;
        const animationTime = from.getAnimationTime();
        const timelineCount = from.animation.timelines.length;
        const timelines = from.animation.timelines;
        const alphaHold = from.alpha * to.interruptAlpha;
        const alphaMix = alphaHold * (1 - mix);
        if (blend == (0, $bbcccedbc883e405$export$ccab779a50275a35).add) for(let i = 0; i < timelineCount; i++)timelines[i].apply(skeleton, animationLast, animationTime, events, alphaMix, blend, (0, $bbcccedbc883e405$export$52fc338c0bb328ba).mixOut);
        else {
            const timelineMode = from.timelineMode;
            const timelineHoldMix = from.timelineHoldMix;
            const firstFrame = from.timelinesRotation.length == 0;
            if (firstFrame) (0, $8804784813ffae81$export$d2ca453b913dcdea).setArraySize(from.timelinesRotation, timelineCount << 1, null);
            const timelinesRotation = from.timelinesRotation;
            from.totalAlpha = 0;
            for(let i = 0; i < timelineCount; i++){
                const timeline = timelines[i];
                let direction = (0, $bbcccedbc883e405$export$52fc338c0bb328ba).mixOut;
                let timelineBlend;
                let alpha = 0;
                switch(timelineMode[i]){
                    case $aaa386b4abc834f7$var$_AnimationState.SUBSEQUENT:
                        if (!attachments && timeline instanceof (0, $5d5d4780b16fb6da$export$7f2bfc5bd27cb43d)) continue;
                        if (!drawOrder && timeline instanceof (0, $5d5d4780b16fb6da$export$ece1f7c41d051e83)) continue;
                        timelineBlend = blend;
                        alpha = alphaMix;
                        break;
                    case $aaa386b4abc834f7$var$_AnimationState.FIRST:
                        timelineBlend = (0, $bbcccedbc883e405$export$ccab779a50275a35).setup;
                        alpha = alphaMix;
                        break;
                    case $aaa386b4abc834f7$var$_AnimationState.HOLD:
                        timelineBlend = (0, $bbcccedbc883e405$export$ccab779a50275a35).setup;
                        alpha = alphaHold;
                        break;
                    default:
                        timelineBlend = (0, $bbcccedbc883e405$export$ccab779a50275a35).setup;
                        const holdMix = timelineHoldMix[i];
                        alpha = alphaHold * Math.max(0, 1 - holdMix.mixTime / holdMix.mixDuration);
                        break;
                }
                from.totalAlpha += alpha;
                if (timeline instanceof (0, $5d5d4780b16fb6da$export$b7ecb8f68b3e130b)) this.applyRotateTimeline(timeline, skeleton, animationTime, alpha, timelineBlend, timelinesRotation, i << 1, firstFrame);
                else {
                    (0, $8804784813ffae81$export$d2ca453b913dcdea).webkit602BugfixHelper(alpha, blend);
                    if (timelineBlend == (0, $bbcccedbc883e405$export$ccab779a50275a35).setup) {
                        if (timeline instanceof (0, $5d5d4780b16fb6da$export$7f2bfc5bd27cb43d)) {
                            if (attachments) direction = (0, $bbcccedbc883e405$export$52fc338c0bb328ba).mixOut;
                        } else if (timeline instanceof (0, $5d5d4780b16fb6da$export$ece1f7c41d051e83)) {
                            if (drawOrder) direction = (0, $bbcccedbc883e405$export$52fc338c0bb328ba).mixOut;
                        }
                    }
                    timeline.apply(skeleton, animationLast, animationTime, events, alpha, timelineBlend, direction);
                }
            }
        }
        if (to.mixDuration > 0) this.queueEvents(from, animationTime);
        this.events.length = 0;
        from.nextAnimationLast = animationTime;
        from.nextTrackLast = from.trackTime;
        return mix;
    }
    applyRotateTimeline(timeline, skeleton, time, alpha, blend, timelinesRotation, i, firstFrame) {
        if (firstFrame) timelinesRotation[i] = 0;
        if (alpha == 1) {
            timeline.apply(skeleton, 0, time, null, 1, blend, (0, $bbcccedbc883e405$export$52fc338c0bb328ba).mixIn);
            return;
        }
        const rotateTimeline = timeline;
        const frames = rotateTimeline.frames;
        const bone = skeleton.bones[rotateTimeline.boneIndex];
        let r1 = 0;
        let r2 = 0;
        if (time < frames[0]) switch(blend){
            case (0, $bbcccedbc883e405$export$ccab779a50275a35).setup:
                bone.rotation = bone.data.rotation;
            default:
                return;
            case (0, $bbcccedbc883e405$export$ccab779a50275a35).first:
                r1 = bone.rotation;
                r2 = bone.data.rotation;
        }
        else {
            r1 = blend == (0, $bbcccedbc883e405$export$ccab779a50275a35).setup ? bone.data.rotation : bone.rotation;
            if (time >= frames[frames.length - (0, $5d5d4780b16fb6da$export$b7ecb8f68b3e130b).ENTRIES]) r2 = bone.data.rotation + frames[frames.length + (0, $5d5d4780b16fb6da$export$b7ecb8f68b3e130b).PREV_ROTATION];
            else {
                const frame = (0, $5d5d4780b16fb6da$export$c35d437ae5945fcd).binarySearch(frames, time, (0, $5d5d4780b16fb6da$export$b7ecb8f68b3e130b).ENTRIES);
                const prevRotation = frames[frame + (0, $5d5d4780b16fb6da$export$b7ecb8f68b3e130b).PREV_ROTATION];
                const frameTime = frames[frame];
                const percent = rotateTimeline.getCurvePercent((frame >> 1) - 1, 1 - (time - frameTime) / (frames[frame + (0, $5d5d4780b16fb6da$export$b7ecb8f68b3e130b).PREV_TIME] - frameTime));
                r2 = frames[frame + (0, $5d5d4780b16fb6da$export$b7ecb8f68b3e130b).ROTATION] - prevRotation;
                r2 -= (16384 - (16384.499999999996 - r2 / 360 | 0)) * 360;
                r2 = prevRotation + r2 * percent + bone.data.rotation;
                r2 -= (16384 - (16384.499999999996 - r2 / 360 | 0)) * 360;
            }
        }
        let total = 0;
        let diff = r2 - r1;
        diff -= (16384 - (16384.499999999996 - diff / 360 | 0)) * 360;
        if (diff == 0) total = timelinesRotation[i];
        else {
            let lastTotal = 0;
            let lastDiff = 0;
            if (firstFrame) {
                lastTotal = 0;
                lastDiff = diff;
            } else {
                lastTotal = timelinesRotation[i];
                lastDiff = timelinesRotation[i + 1];
            }
            const current = diff > 0;
            let dir = lastTotal >= 0;
            if ((0, $8804784813ffae81$export$6a7ef315a0d1ef07).signum(lastDiff) != (0, $8804784813ffae81$export$6a7ef315a0d1ef07).signum(diff) && Math.abs(lastDiff) <= 90) {
                if (Math.abs(lastTotal) > 180) lastTotal += 360 * (0, $8804784813ffae81$export$6a7ef315a0d1ef07).signum(lastTotal);
                dir = current;
            }
            total = diff + lastTotal - lastTotal % 360;
            if (dir != current) total += 360 * (0, $8804784813ffae81$export$6a7ef315a0d1ef07).signum(lastTotal);
            timelinesRotation[i] = total;
        }
        timelinesRotation[i + 1] = diff;
        r1 += total * alpha;
        bone.rotation = r1 - (16384 - (16384.499999999996 - r1 / 360 | 0)) * 360;
    }
    queueEvents(entry, animationTime) {
        const animationStart = entry.animationStart;
        const animationEnd = entry.animationEnd;
        const duration = animationEnd - animationStart;
        const trackLastWrapped = entry.trackLast % duration;
        const events = this.events;
        let i = 0;
        const n = events.length;
        for(; i < n; i++){
            const event = events[i];
            if (event.time < trackLastWrapped) break;
            if (event.time > animationEnd) continue;
            this.queue.event(entry, event);
        }
        let complete = false;
        if (entry.loop) complete = duration == 0 || trackLastWrapped > entry.trackTime % duration;
        else complete = animationTime >= animationEnd && entry.animationLast < animationEnd;
        if (complete) this.queue.complete(entry);
        for(; i < n; i++){
            const event = events[i];
            if (event.time < animationStart) continue;
            this.queue.event(entry, events[i]);
        }
    }
    clearTracks() {
        const oldDrainDisabled = this.queue.drainDisabled;
        this.queue.drainDisabled = true;
        for(let i = 0, n = this.tracks.length; i < n; i++)this.clearTrack(i);
        this.tracks.length = 0;
        this.queue.drainDisabled = oldDrainDisabled;
        this.queue.drain();
    }
    clearTrack(trackIndex) {
        if (trackIndex >= this.tracks.length) return;
        const current = this.tracks[trackIndex];
        if (current == null) return;
        this.queue.end(current);
        this.disposeNext(current);
        let entry = current;
        while(true){
            const from = entry.mixingFrom;
            if (from == null) break;
            this.queue.end(from);
            entry.mixingFrom = null;
            entry.mixingTo = null;
            entry = from;
        }
        this.tracks[current.trackIndex] = null;
        this.queue.drain();
    }
    setCurrent(index, current, interrupt) {
        const from = this.expandToIndex(index);
        this.tracks[index] = current;
        if (from != null) {
            if (interrupt) this.queue.interrupt(from);
            current.mixingFrom = from;
            from.mixingTo = current;
            current.mixTime = 0;
            if (from.mixingFrom != null && from.mixDuration > 0) current.interruptAlpha *= Math.min(1, from.mixTime / from.mixDuration);
            from.timelinesRotation.length = 0;
        }
        this.queue.start(current);
    }
    setAnimation(trackIndex, animationName, loop) {
        const animation = this.data.skeletonData.findAnimation(animationName);
        if (animation == null) throw new Error(`Animation not found: ${animationName}`);
        return this.setAnimationWith(trackIndex, animation, loop);
    }
    setAnimationWith(trackIndex, animation, loop) {
        if (animation == null) throw new Error("animation cannot be null.");
        let interrupt = true;
        let current = this.expandToIndex(trackIndex);
        if (current != null) {
            if (current.nextTrackLast == -1) {
                this.tracks[trackIndex] = current.mixingFrom;
                this.queue.interrupt(current);
                this.queue.end(current);
                this.disposeNext(current);
                current = current.mixingFrom;
                interrupt = false;
            } else this.disposeNext(current);
        }
        const entry = this.trackEntry(trackIndex, animation, loop, current);
        this.setCurrent(trackIndex, entry, interrupt);
        this.queue.drain();
        return entry;
    }
    addAnimation(trackIndex, animationName, loop, delay) {
        const animation = this.data.skeletonData.findAnimation(animationName);
        if (animation == null) throw new Error(`Animation not found: ${animationName}`);
        return this.addAnimationWith(trackIndex, animation, loop, delay);
    }
    addAnimationWith(trackIndex, animation, loop, delay) {
        if (animation == null) throw new Error("animation cannot be null.");
        let last = this.expandToIndex(trackIndex);
        if (last != null) while(last.next != null)last = last.next;
        const entry = this.trackEntry(trackIndex, animation, loop, last);
        if (last == null) {
            this.setCurrent(trackIndex, entry, true);
            this.queue.drain();
        } else {
            last.next = entry;
            if (delay <= 0) {
                const duration = last.animationEnd - last.animationStart;
                if (duration != 0) {
                    if (last.loop) delay += duration * (1 + (last.trackTime / duration | 0));
                    else delay += Math.max(duration, last.trackTime);
                    delay -= this.data.getMix(last.animation, animation);
                } else delay = last.trackTime;
            }
        }
        entry.delay = delay;
        return entry;
    }
    setEmptyAnimation(trackIndex, mixDuration) {
        const entry = this.setAnimationWith(trackIndex, $aaa386b4abc834f7$var$_AnimationState.emptyAnimation, false);
        entry.mixDuration = mixDuration;
        entry.trackEnd = mixDuration;
        return entry;
    }
    addEmptyAnimation(trackIndex, mixDuration, delay) {
        if (delay <= 0) delay -= mixDuration;
        const entry = this.addAnimationWith(trackIndex, $aaa386b4abc834f7$var$_AnimationState.emptyAnimation, false, delay);
        entry.mixDuration = mixDuration;
        entry.trackEnd = mixDuration;
        return entry;
    }
    setEmptyAnimations(mixDuration) {
        const oldDrainDisabled = this.queue.drainDisabled;
        this.queue.drainDisabled = true;
        for(let i = 0, n = this.tracks.length; i < n; i++){
            const current = this.tracks[i];
            if (current != null) this.setEmptyAnimation(current.trackIndex, mixDuration);
        }
        this.queue.drainDisabled = oldDrainDisabled;
        this.queue.drain();
    }
    expandToIndex(index) {
        if (index < this.tracks.length) return this.tracks[index];
        (0, $8804784813ffae81$export$d2ca453b913dcdea).ensureArrayCapacity(this.tracks, index - this.tracks.length + 1, null);
        this.tracks.length = index + 1;
        return null;
    }
    trackEntry(trackIndex, animation, loop, last) {
        const entry = this.trackEntryPool.obtain();
        entry.trackIndex = trackIndex;
        entry.animation = animation;
        entry.loop = loop;
        entry.holdPrevious = false;
        entry.eventThreshold = 0;
        entry.attachmentThreshold = 0;
        entry.drawOrderThreshold = 0;
        entry.animationStart = 0;
        entry.animationEnd = animation.duration;
        entry.animationLast = -1;
        entry.nextAnimationLast = -1;
        entry.delay = 0;
        entry.trackTime = 0;
        entry.trackLast = -1;
        entry.nextTrackLast = -1;
        entry.trackEnd = Number.MAX_VALUE;
        entry.timeScale = 1;
        entry.alpha = 1;
        entry.interruptAlpha = 1;
        entry.mixTime = 0;
        entry.mixDuration = last == null ? 0 : this.data.getMix(last.animation, animation);
        return entry;
    }
    disposeNext(entry) {
        let next = entry.next;
        while(next != null){
            this.queue.dispose(next);
            next = next.next;
        }
        entry.next = null;
    }
    _animationsChanged() {
        this.animationsChanged = false;
        this.propertyIDs.clear();
        for(let i = 0, n = this.tracks.length; i < n; i++){
            let entry = this.tracks[i];
            if (entry == null) continue;
            while(entry.mixingFrom != null)entry = entry.mixingFrom;
            do {
                if (entry.mixingFrom == null || entry.mixBlend != (0, $bbcccedbc883e405$export$ccab779a50275a35).add) this.setTimelineModes(entry);
                entry = entry.mixingTo;
            }while (entry != null);
        }
    }
    setTimelineModes(entry) {
        const to = entry.mixingTo;
        const timelines = entry.animation.timelines;
        const timelinesCount = entry.animation.timelines.length;
        const timelineMode = (0, $8804784813ffae81$export$d2ca453b913dcdea).setArraySize(entry.timelineMode, timelinesCount);
        entry.timelineHoldMix.length = 0;
        const timelineDipMix = (0, $8804784813ffae81$export$d2ca453b913dcdea).setArraySize(entry.timelineHoldMix, timelinesCount);
        const propertyIDs = this.propertyIDs;
        if (to != null && to.holdPrevious) {
            for(let i = 0; i < timelinesCount; i++){
                propertyIDs.add(timelines[i].getPropertyId());
                timelineMode[i] = $aaa386b4abc834f7$var$_AnimationState.HOLD;
            }
            return;
        }
        outer: for(let i = 0; i < timelinesCount; i++){
            const id = timelines[i].getPropertyId();
            if (!propertyIDs.add(id)) timelineMode[i] = $aaa386b4abc834f7$var$_AnimationState.SUBSEQUENT;
            else if (to == null || !this.hasTimeline(to, id)) timelineMode[i] = $aaa386b4abc834f7$var$_AnimationState.FIRST;
            else {
                for(let next = to.mixingTo; next != null; next = next.mixingTo){
                    if (this.hasTimeline(next, id)) continue;
                    if (entry.mixDuration > 0) {
                        timelineMode[i] = $aaa386b4abc834f7$var$_AnimationState.HOLD_MIX;
                        timelineDipMix[i] = next;
                        continue outer;
                    }
                    break;
                }
                timelineMode[i] = $aaa386b4abc834f7$var$_AnimationState.HOLD;
            }
        }
    }
    hasTimeline(entry, id) {
        const timelines = entry.animation.timelines;
        for(let i = 0, n = timelines.length; i < n; i++)if (timelines[i].getPropertyId() == id) return true;
        return false;
    }
    getCurrent(trackIndex) {
        if (trackIndex >= this.tracks.length) return null;
        return this.tracks[trackIndex];
    }
    addListener(listener) {
        if (listener == null) throw new Error("listener cannot be null.");
        this.listeners.push(listener);
    }
    /** Removes the listener added with {@link #addListener(AnimationStateListener)}. */ removeListener(listener) {
        const index = this.listeners.indexOf(listener);
        if (index >= 0) this.listeners.splice(index, 1);
    }
    clearListeners() {
        this.listeners.length = 0;
    }
    clearListenerNotifications() {
        this.queue.clear();
    }
    setAnimationByName(trackIndex, animationName, loop) {
        if (!$aaa386b4abc834f7$var$_AnimationState.deprecatedWarning1) {
            $aaa386b4abc834f7$var$_AnimationState.deprecatedWarning1 = true;
            console.warn("Spine Deprecation Warning: AnimationState.setAnimationByName is deprecated, please use setAnimation from now on.");
        }
        this.setAnimation(trackIndex, animationName, loop);
    }
    addAnimationByName(trackIndex, animationName, loop, delay) {
        if (!$aaa386b4abc834f7$var$_AnimationState.deprecatedWarning2) {
            $aaa386b4abc834f7$var$_AnimationState.deprecatedWarning2 = true;
            console.warn("Spine Deprecation Warning: AnimationState.addAnimationByName is deprecated, please use addAnimation from now on.");
        }
        this.addAnimation(trackIndex, animationName, loop, delay);
    }
    hasAnimation(animationName) {
        const animation = this.data.skeletonData.findAnimation(animationName);
        return animation !== null;
    }
    hasAnimationByName(animationName) {
        if (!$aaa386b4abc834f7$var$_AnimationState.deprecatedWarning3) {
            $aaa386b4abc834f7$var$_AnimationState.deprecatedWarning3 = true;
            console.warn("Spine Deprecation Warning: AnimationState.hasAnimationByName is deprecated, please use hasAnimation from now on.");
        }
        return this.hasAnimation(animationName);
    }
};
let $aaa386b4abc834f7$export$d0f7a26c90cc1562 = $aaa386b4abc834f7$var$_AnimationState;
$aaa386b4abc834f7$export$d0f7a26c90cc1562.emptyAnimation = new (0, $5d5d4780b16fb6da$export$c35d437ae5945fcd)("<empty>", [], 0);
$aaa386b4abc834f7$export$d0f7a26c90cc1562.SUBSEQUENT = 0;
$aaa386b4abc834f7$export$d0f7a26c90cc1562.FIRST = 1;
$aaa386b4abc834f7$export$d0f7a26c90cc1562.HOLD = 2;
$aaa386b4abc834f7$export$d0f7a26c90cc1562.HOLD_MIX = 3;
$aaa386b4abc834f7$export$d0f7a26c90cc1562.deprecatedWarning1 = false;
$aaa386b4abc834f7$export$d0f7a26c90cc1562.deprecatedWarning2 = false;
$aaa386b4abc834f7$export$d0f7a26c90cc1562.deprecatedWarning3 = false;
const $aaa386b4abc834f7$var$_TrackEntry = class {
    constructor(){
        this.mixBlend = (0, $bbcccedbc883e405$export$ccab779a50275a35).replace;
        this.timelineMode = new Array();
        this.timelineHoldMix = new Array();
        this.timelinesRotation = new Array();
    }
    reset() {
        this.next = null;
        this.mixingFrom = null;
        this.mixingTo = null;
        this.animation = null;
        this.listener = null;
        this.timelineMode.length = 0;
        this.timelineHoldMix.length = 0;
        this.timelinesRotation.length = 0;
    }
    getAnimationTime() {
        if (this.loop) {
            const duration = this.animationEnd - this.animationStart;
            if (duration == 0) return this.animationStart;
            return this.trackTime % duration + this.animationStart;
        }
        return Math.min(this.trackTime + this.animationStart, this.animationEnd);
    }
    setAnimationLast(animationLast) {
        this.animationLast = animationLast;
        this.nextAnimationLast = animationLast;
    }
    isComplete() {
        return this.trackTime >= this.animationEnd - this.animationStart;
    }
    resetRotationDirections() {
        this.timelinesRotation.length = 0;
    }
    get time() {
        if (!$aaa386b4abc834f7$var$_TrackEntry.deprecatedWarning1) {
            $aaa386b4abc834f7$var$_TrackEntry.deprecatedWarning1 = true;
            console.warn("Spine Deprecation Warning: TrackEntry.time is deprecated, please use trackTime from now on.");
        }
        return this.trackTime;
    }
    set time(value) {
        if (!$aaa386b4abc834f7$var$_TrackEntry.deprecatedWarning1) {
            $aaa386b4abc834f7$var$_TrackEntry.deprecatedWarning1 = true;
            console.warn("Spine Deprecation Warning: TrackEntry.time is deprecated, please use trackTime from now on.");
        }
        this.trackTime = value;
    }
    get endTime() {
        if (!$aaa386b4abc834f7$var$_TrackEntry.deprecatedWarning2) {
            $aaa386b4abc834f7$var$_TrackEntry.deprecatedWarning2 = true;
            console.warn("Spine Deprecation Warning: TrackEntry.endTime is deprecated, please use trackEnd from now on.");
        }
        return this.trackTime;
    }
    set endTime(value) {
        if (!$aaa386b4abc834f7$var$_TrackEntry.deprecatedWarning2) {
            $aaa386b4abc834f7$var$_TrackEntry.deprecatedWarning2 = true;
            console.warn("Spine Deprecation Warning: TrackEntry.endTime is deprecated, please use trackEnd from now on.");
        }
        this.trackTime = value;
    }
    loopsCount() {
        return Math.floor(this.trackTime / this.trackEnd);
    }
};
let $aaa386b4abc834f7$export$6fd48f25bc0ee658 = $aaa386b4abc834f7$var$_TrackEntry;
$aaa386b4abc834f7$export$6fd48f25bc0ee658.deprecatedWarning1 = false;
$aaa386b4abc834f7$export$6fd48f25bc0ee658.deprecatedWarning2 = false;
const $aaa386b4abc834f7$var$_EventQueue = class {
    constructor(animState){
        this.objects = [];
        this.drainDisabled = false;
        this.animState = animState;
    }
    start(entry) {
        this.objects.push($aaa386b4abc834f7$export$3d7865934588d77e.start);
        this.objects.push(entry);
        this.animState.animationsChanged = true;
    }
    interrupt(entry) {
        this.objects.push($aaa386b4abc834f7$export$3d7865934588d77e.interrupt);
        this.objects.push(entry);
    }
    end(entry) {
        this.objects.push($aaa386b4abc834f7$export$3d7865934588d77e.end);
        this.objects.push(entry);
        this.animState.animationsChanged = true;
    }
    dispose(entry) {
        this.objects.push($aaa386b4abc834f7$export$3d7865934588d77e.dispose);
        this.objects.push(entry);
    }
    complete(entry) {
        this.objects.push($aaa386b4abc834f7$export$3d7865934588d77e.complete);
        this.objects.push(entry);
    }
    event(entry, event) {
        this.objects.push($aaa386b4abc834f7$export$3d7865934588d77e.event);
        this.objects.push(entry);
        this.objects.push(event);
    }
    deprecateStuff() {
        if (!$aaa386b4abc834f7$var$_EventQueue.deprecatedWarning1) {
            $aaa386b4abc834f7$var$_EventQueue.deprecatedWarning1 = true;
            console.warn("Spine Deprecation Warning: onComplete, onStart, onEnd, onEvent art deprecated, please use listeners from now on. 'state.addListener({ complete: function(track, event) { } })'");
        }
        return true;
    }
    drain() {
        if (this.drainDisabled) return;
        this.drainDisabled = true;
        const objects = this.objects;
        const listeners = this.animState.listeners;
        for(let i = 0; i < objects.length; i += 2){
            const type = objects[i];
            const entry = objects[i + 1];
            switch(type){
                case $aaa386b4abc834f7$export$3d7865934588d77e.start:
                    if (entry.listener != null && entry.listener.start) entry.listener.start(entry);
                    for(let ii = 0; ii < listeners.length; ii++)if (listeners[ii].start) listeners[ii].start(entry);
                    entry.onStart && this.deprecateStuff() && entry.onStart(entry.trackIndex);
                    this.animState.onStart && this.deprecateStuff() && this.deprecateStuff && this.animState.onStart(entry.trackIndex);
                    break;
                case $aaa386b4abc834f7$export$3d7865934588d77e.interrupt:
                    if (entry.listener != null && entry.listener.interrupt) entry.listener.interrupt(entry);
                    for(let ii = 0; ii < listeners.length; ii++)if (listeners[ii].interrupt) listeners[ii].interrupt(entry);
                    break;
                case $aaa386b4abc834f7$export$3d7865934588d77e.end:
                    if (entry.listener != null && entry.listener.end) entry.listener.end(entry);
                    for(let ii = 0; ii < listeners.length; ii++)if (listeners[ii].end) listeners[ii].end(entry);
                    entry.onEnd && this.deprecateStuff() && entry.onEnd(entry.trackIndex);
                    this.animState.onEnd && this.deprecateStuff() && this.animState.onEnd(entry.trackIndex);
                case $aaa386b4abc834f7$export$3d7865934588d77e.dispose:
                    if (entry.listener != null && entry.listener.dispose) entry.listener.dispose(entry);
                    for(let ii = 0; ii < listeners.length; ii++)if (listeners[ii].dispose) listeners[ii].dispose(entry);
                    this.animState.trackEntryPool.free(entry);
                    break;
                case $aaa386b4abc834f7$export$3d7865934588d77e.complete:
                    if (entry.listener != null && entry.listener.complete) entry.listener.complete(entry);
                    for(let ii = 0; ii < listeners.length; ii++)if (listeners[ii].complete) listeners[ii].complete(entry);
                    const count = (0, $8804784813ffae81$export$6a7ef315a0d1ef07).toInt(entry.loopsCount());
                    entry.onComplete && this.deprecateStuff() && entry.onComplete(entry.trackIndex, count);
                    this.animState.onComplete && this.deprecateStuff() && this.animState.onComplete(entry.trackIndex, count);
                    break;
                case $aaa386b4abc834f7$export$3d7865934588d77e.event:
                    const event = objects[i++ + 2];
                    if (entry.listener != null && entry.listener.event) entry.listener.event(entry, event);
                    for(let ii = 0; ii < listeners.length; ii++)if (listeners[ii].event) listeners[ii].event(entry, event);
                    entry.onEvent && this.deprecateStuff() && entry.onEvent(entry.trackIndex, event);
                    this.animState.onEvent && this.deprecateStuff() && this.animState.onEvent(entry.trackIndex, event);
                    break;
            }
        }
        this.clear();
        this.drainDisabled = false;
    }
    clear() {
        this.objects.length = 0;
    }
};
let $aaa386b4abc834f7$export$2fc6338444a158e6 = $aaa386b4abc834f7$var$_EventQueue;
$aaa386b4abc834f7$export$2fc6338444a158e6.deprecatedWarning1 = false;
var $aaa386b4abc834f7$export$3d7865934588d77e = /* @__PURE__ */ ((EventType2)=>{
    EventType2[EventType2["start"] = 0] = "start";
    EventType2[EventType2["interrupt"] = 1] = "interrupt";
    EventType2[EventType2["end"] = 2] = "end";
    EventType2[EventType2["dispose"] = 3] = "dispose";
    EventType2[EventType2["complete"] = 4] = "complete";
    EventType2[EventType2["event"] = 5] = "event";
    return EventType2;
})($aaa386b4abc834f7$export$3d7865934588d77e || {});
class $aaa386b4abc834f7$export$3816040169c70f4f {
    start(entry) {}
    interrupt(entry) {}
    end(entry) {}
    dispose(entry) {}
    complete(entry) {}
    event(entry, event) {}
}


const $2694fad3c1cf0f47$var$_AnimationStateData = class {
    constructor(skeletonData){
        this.animationToMixTime = {};
        this.defaultMix = 0;
        if (skeletonData == null) throw new Error("skeletonData cannot be null.");
        this.skeletonData = skeletonData;
    }
    setMix(fromName, toName, duration) {
        const from = this.skeletonData.findAnimation(fromName);
        if (from == null) throw new Error(`Animation not found: ${fromName}`);
        const to = this.skeletonData.findAnimation(toName);
        if (to == null) throw new Error(`Animation not found: ${toName}`);
        this.setMixWith(from, to, duration);
    }
    setMixByName(fromName, toName, duration) {
        if (!$2694fad3c1cf0f47$var$_AnimationStateData.deprecatedWarning1) {
            $2694fad3c1cf0f47$var$_AnimationStateData.deprecatedWarning1 = true;
            console.warn("Deprecation Warning: AnimationStateData.setMixByName is deprecated, please use setMix from now on.");
        }
        this.setMix(fromName, toName, duration);
    }
    setMixWith(from, to, duration) {
        if (from == null) throw new Error("from cannot be null.");
        if (to == null) throw new Error("to cannot be null.");
        const key = `${from.name}.${to.name}`;
        this.animationToMixTime[key] = duration;
    }
    getMix(from, to) {
        const key = `${from.name}.${to.name}`;
        const value = this.animationToMixTime[key];
        return value === void 0 ? this.defaultMix : value;
    }
};
let $2694fad3c1cf0f47$export$90d7167cc0605975 = $2694fad3c1cf0f47$var$_AnimationStateData;
$2694fad3c1cf0f47$export$90d7167cc0605975.deprecatedWarning1 = false;









class $396085795b03eddd$export$2ff9add835475d95 {
    constructor(atlas){
        this.atlas = atlas;
    }
    /** @return May be null to not load an attachment. */ newRegionAttachment(skin, name, path) {
        const region = this.atlas.findRegion(path);
        if (region == null) throw new Error(`Region not found in atlas: ${path} (region attachment: ${name})`);
        const attachment = new (0, $194dfe6c9cdc5a8c$export$d0fc51466fa6d530)(name);
        attachment.region = region;
        return attachment;
    }
    /** @return May be null to not load an attachment. */ newMeshAttachment(skin, name, path) {
        const region = this.atlas.findRegion(path);
        if (region == null) throw new Error(`Region not found in atlas: ${path} (mesh attachment: ${name})`);
        const attachment = new (0, $768f0ee4496fce9b$export$3f1c1692adfcf3e2)(name);
        attachment.region = region;
        return attachment;
    }
    /** @return May be null to not load an attachment. */ newBoundingBoxAttachment(skin, name) {
        return new (0, $03ebceacc01e1eb0$export$9538c439c6b85ad2)(name);
    }
    /** @return May be null to not load an attachment */ newPathAttachment(skin, name) {
        return new (0, $193cdc10edd05e64$export$d285e3ec07b32800)(name);
    }
    newPointAttachment(skin, name) {
        return new (0, $1ce5a549b119c5f2$export$1b528cde44a6ab5)(name);
    }
    newClippingAttachment(skin, name) {
        return new (0, $80a02a4045299491$export$838805e22b9b55f1)(name);
    }
}




class $e2f8673bf53faa5e$export$b127726e56765aa4 {
    /** @param parent May be null. */ constructor(data, skeleton, parent){
        // be careful! Spine b,c is c,b in pixi matrix
        this.matrix = new (0, $d7da222aa639cde0$export$5b12bf1653c0dd85)();
        this.children = new Array();
        this.x = 0;
        this.y = 0;
        this.rotation = 0;
        this.scaleX = 0;
        this.scaleY = 0;
        this.shearX = 0;
        this.shearY = 0;
        this.ax = 0;
        this.ay = 0;
        this.arotation = 0;
        this.ascaleX = 0;
        this.ascaleY = 0;
        this.ashearX = 0;
        this.ashearY = 0;
        this.appliedValid = false;
        this.sorted = false;
        /** NOT USED IN 3.7. Needed for the debug graph code */ this.active = true;
        if (data == null) throw new Error("data cannot be null.");
        if (skeleton == null) throw new Error("skeleton cannot be null.");
        this.data = data;
        this.skeleton = skeleton;
        this.parent = parent;
        this.setToSetupPose();
    }
    get worldX() {
        return this.matrix.tx;
    }
    get worldY() {
        return this.matrix.ty;
    }
    /** Same as {@link #updateWorldTransform()}. This method exists for Bone to implement {@link Updatable}. */ update() {
        this.updateWorldTransformWith(this.x, this.y, this.rotation, this.scaleX, this.scaleY, this.shearX, this.shearY);
    }
    /** Computes the world transform using the parent bone and this bone's local transform. */ updateWorldTransform() {
        this.updateWorldTransformWith(this.x, this.y, this.rotation, this.scaleX, this.scaleY, this.shearX, this.shearY);
    }
    /** Computes the world transform using the parent bone and the specified local transform. */ updateWorldTransformWith(x, y, rotation, scaleX, scaleY, shearX, shearY) {
        this.ax = x;
        this.ay = y;
        this.arotation = rotation;
        this.ascaleX = scaleX;
        this.ascaleY = scaleY;
        this.ashearX = shearX;
        this.ashearY = shearY;
        this.appliedValid = true;
        const parent = this.parent;
        const m = this.matrix;
        const sx = this.skeleton.scaleX;
        const sy = (0, $1840f66876ded594$export$a5a6e0b888b2c992).yDown ? -this.skeleton.scaleY : this.skeleton.scaleY;
        if (parent == null) {
            const skeleton = this.skeleton;
            const rotationY = rotation + 90 + shearY;
            m.a = (0, $8804784813ffae81$export$6a7ef315a0d1ef07).cosDeg(rotation + shearX) * scaleX * sx;
            m.c = (0, $8804784813ffae81$export$6a7ef315a0d1ef07).cosDeg(rotationY) * scaleY * sx;
            m.b = (0, $8804784813ffae81$export$6a7ef315a0d1ef07).sinDeg(rotation + shearX) * scaleX * sy;
            m.d = (0, $8804784813ffae81$export$6a7ef315a0d1ef07).sinDeg(rotationY) * scaleY * sy;
            m.tx = x * sx + skeleton.x;
            m.ty = y * sy + skeleton.y;
            return;
        }
        let pa = parent.matrix.a;
        let pb = parent.matrix.c;
        let pc = parent.matrix.b;
        let pd = parent.matrix.d;
        m.tx = pa * x + pb * y + parent.matrix.tx;
        m.ty = pc * x + pd * y + parent.matrix.ty;
        switch(this.data.transformMode){
            case (0, $ccc5aebc60cbf024$export$4c408f82786a534d).Normal:
                {
                    const rotationY = rotation + 90 + shearY;
                    const la = (0, $8804784813ffae81$export$6a7ef315a0d1ef07).cosDeg(rotation + shearX) * scaleX;
                    const lb = (0, $8804784813ffae81$export$6a7ef315a0d1ef07).cosDeg(rotationY) * scaleY;
                    const lc = (0, $8804784813ffae81$export$6a7ef315a0d1ef07).sinDeg(rotation + shearX) * scaleX;
                    const ld = (0, $8804784813ffae81$export$6a7ef315a0d1ef07).sinDeg(rotationY) * scaleY;
                    m.a = pa * la + pb * lc;
                    m.c = pa * lb + pb * ld;
                    m.b = pc * la + pd * lc;
                    m.d = pc * lb + pd * ld;
                    return;
                }
            case (0, $ccc5aebc60cbf024$export$4c408f82786a534d).OnlyTranslation:
                {
                    const rotationY = rotation + 90 + shearY;
                    m.a = (0, $8804784813ffae81$export$6a7ef315a0d1ef07).cosDeg(rotation + shearX) * scaleX;
                    m.c = (0, $8804784813ffae81$export$6a7ef315a0d1ef07).cosDeg(rotationY) * scaleY;
                    m.b = (0, $8804784813ffae81$export$6a7ef315a0d1ef07).sinDeg(rotation + shearX) * scaleX;
                    m.d = (0, $8804784813ffae81$export$6a7ef315a0d1ef07).sinDeg(rotationY) * scaleY;
                    break;
                }
            case (0, $ccc5aebc60cbf024$export$4c408f82786a534d).NoRotationOrReflection:
                {
                    let s = pa * pa + pc * pc;
                    let prx = 0;
                    if (s > 1e-4) {
                        s = Math.abs(pa * pd - pb * pc) / s;
                        pb = pc * s;
                        pd = pa * s;
                        prx = Math.atan2(pc, pa) * (0, $8804784813ffae81$export$6a7ef315a0d1ef07).radDeg;
                    } else {
                        pa = 0;
                        pc = 0;
                        prx = 90 - Math.atan2(pd, pb) * (0, $8804784813ffae81$export$6a7ef315a0d1ef07).radDeg;
                    }
                    const rx = rotation + shearX - prx;
                    const ry = rotation + shearY - prx + 90;
                    const la = (0, $8804784813ffae81$export$6a7ef315a0d1ef07).cosDeg(rx) * scaleX;
                    const lb = (0, $8804784813ffae81$export$6a7ef315a0d1ef07).cosDeg(ry) * scaleY;
                    const lc = (0, $8804784813ffae81$export$6a7ef315a0d1ef07).sinDeg(rx) * scaleX;
                    const ld = (0, $8804784813ffae81$export$6a7ef315a0d1ef07).sinDeg(ry) * scaleY;
                    m.a = pa * la - pb * lc;
                    m.c = pa * lb - pb * ld;
                    m.b = pc * la + pd * lc;
                    m.d = pc * lb + pd * ld;
                    break;
                }
            case (0, $ccc5aebc60cbf024$export$4c408f82786a534d).NoScale:
            case (0, $ccc5aebc60cbf024$export$4c408f82786a534d).NoScaleOrReflection:
                {
                    const cos = (0, $8804784813ffae81$export$6a7ef315a0d1ef07).cosDeg(rotation);
                    const sin = (0, $8804784813ffae81$export$6a7ef315a0d1ef07).sinDeg(rotation);
                    let za = (pa * cos + pb * sin) / sx;
                    let zc = (pc * cos + pd * sin) / sy;
                    let s = Math.sqrt(za * za + zc * zc);
                    if (s > 1e-5) s = 1 / s;
                    za *= s;
                    zc *= s;
                    s = Math.sqrt(za * za + zc * zc);
                    if (this.data.transformMode == (0, $ccc5aebc60cbf024$export$4c408f82786a534d).NoScale && pa * pd - pb * pc < 0 != ((0, $1840f66876ded594$export$a5a6e0b888b2c992).yDown ? this.skeleton.scaleX < 0 != this.skeleton.scaleY > 0 : this.skeleton.scaleX < 0 != this.skeleton.scaleY < 0)) s = -s;
                    const r = Math.PI / 2 + Math.atan2(zc, za);
                    const zb = Math.cos(r) * s;
                    const zd = Math.sin(r) * s;
                    const la = (0, $8804784813ffae81$export$6a7ef315a0d1ef07).cosDeg(shearX) * scaleX;
                    const lb = (0, $8804784813ffae81$export$6a7ef315a0d1ef07).cosDeg(90 + shearY) * scaleY;
                    const lc = (0, $8804784813ffae81$export$6a7ef315a0d1ef07).sinDeg(shearX) * scaleX;
                    const ld = (0, $8804784813ffae81$export$6a7ef315a0d1ef07).sinDeg(90 + shearY) * scaleY;
                    m.a = za * la + zb * lc;
                    m.c = za * lb + zb * ld;
                    m.b = zc * la + zd * lc;
                    m.d = zc * lb + zd * ld;
                    break;
                }
        }
        m.a *= sx;
        m.c *= sx;
        m.b *= sy;
        m.d *= sy;
    }
    setToSetupPose() {
        const data = this.data;
        this.x = data.x;
        this.y = data.y;
        this.rotation = data.rotation;
        this.scaleX = data.scaleX;
        this.scaleY = data.scaleY;
        this.shearX = data.shearX;
        this.shearY = data.shearY;
    }
    getWorldRotationX() {
        return Math.atan2(this.matrix.b, this.matrix.a) * (0, $8804784813ffae81$export$6a7ef315a0d1ef07).radDeg;
    }
    getWorldRotationY() {
        return Math.atan2(this.matrix.d, this.matrix.c) * (0, $8804784813ffae81$export$6a7ef315a0d1ef07).radDeg;
    }
    getWorldScaleX() {
        const m = this.matrix;
        return Math.sqrt(m.a * m.a + m.c * m.c);
    }
    getWorldScaleY() {
        const m = this.matrix;
        return Math.sqrt(m.b * m.b + m.d * m.d);
    }
    /** Computes the individual applied transform values from the world transform. This can be useful to perform processing using
   * the applied transform after the world transform has been modified directly (eg, by a constraint).
   * <p>
   * Some information is ambiguous in the world transform, such as -1,-1 scale versus 180 rotation. */ updateAppliedTransform() {
        this.appliedValid = true;
        const parent = this.parent;
        const m = this.matrix;
        if (parent == null) {
            this.ax = m.tx;
            this.ay = m.ty;
            this.arotation = Math.atan2(m.b, m.a) * (0, $8804784813ffae81$export$6a7ef315a0d1ef07).radDeg;
            this.ascaleX = Math.sqrt(m.a * m.a + m.b * m.b);
            this.ascaleY = Math.sqrt(m.c * m.c + m.d * m.d);
            this.ashearX = 0;
            this.ashearY = Math.atan2(m.a * m.c + m.b * m.d, m.a * m.d - m.b * m.c) * (0, $8804784813ffae81$export$6a7ef315a0d1ef07).radDeg;
            return;
        }
        const pm = parent.matrix;
        const pid = 1 / (pm.a * pm.d - pm.b * pm.c);
        const dx = m.tx - pm.tx;
        const dy = m.ty - pm.ty;
        this.ax = dx * pm.d * pid - dy * pm.c * pid;
        this.ay = dy * pm.a * pid - dx * pm.b * pid;
        const ia = pid * pm.d;
        const id = pid * pm.a;
        const ib = pid * pm.c;
        const ic = pid * pm.b;
        const ra = ia * m.a - ib * m.b;
        const rb = ia * m.c - ib * m.d;
        const rc = id * m.b - ic * m.a;
        const rd = id * m.d - ic * m.c;
        this.ashearX = 0;
        this.ascaleX = Math.sqrt(ra * ra + rc * rc);
        if (this.ascaleX > 1e-4) {
            const det = ra * rd - rb * rc;
            this.ascaleY = det / this.ascaleX;
            this.ashearY = Math.atan2(ra * rb + rc * rd, det) * (0, $8804784813ffae81$export$6a7ef315a0d1ef07).radDeg;
            this.arotation = Math.atan2(rc, ra) * (0, $8804784813ffae81$export$6a7ef315a0d1ef07).radDeg;
        } else {
            this.ascaleX = 0;
            this.ascaleY = Math.sqrt(rb * rb + rd * rd);
            this.ashearY = 0;
            this.arotation = 90 - Math.atan2(rd, rb) * (0, $8804784813ffae81$export$6a7ef315a0d1ef07).radDeg;
        }
    }
    worldToLocal(world) {
        const m = this.matrix;
        const a = m.a;
        const b = m.c;
        const c = m.b;
        const d = m.d;
        const invDet = 1 / (a * d - b * c);
        const x = world.x - m.tx;
        const y = world.y - m.ty;
        world.x = x * d * invDet - y * b * invDet;
        world.y = y * a * invDet - x * c * invDet;
        return world;
    }
    localToWorld(local) {
        const m = this.matrix;
        const x = local.x;
        const y = local.y;
        local.x = x * m.a + y * m.c + m.tx;
        local.y = x * m.b + y * m.d + m.ty;
        return local;
    }
    worldToLocalRotation(worldRotation) {
        const sin = (0, $8804784813ffae81$export$6a7ef315a0d1ef07).sinDeg(worldRotation);
        const cos = (0, $8804784813ffae81$export$6a7ef315a0d1ef07).cosDeg(worldRotation);
        const mat = this.matrix;
        return Math.atan2(mat.a * sin - mat.b * cos, mat.d * cos - mat.c * sin) * (0, $8804784813ffae81$export$6a7ef315a0d1ef07).radDeg;
    }
    localToWorldRotation(localRotation) {
        const sin = (0, $8804784813ffae81$export$6a7ef315a0d1ef07).sinDeg(localRotation);
        const cos = (0, $8804784813ffae81$export$6a7ef315a0d1ef07).cosDeg(localRotation);
        const mat = this.matrix;
        return Math.atan2(cos * mat.b + sin * mat.d, cos * mat.a + sin * mat.c) * (0, $8804784813ffae81$export$6a7ef315a0d1ef07).radDeg;
    }
    rotateWorld(degrees) {
        const mat = this.matrix;
        const a = mat.a;
        const b = mat.c;
        const c = mat.b;
        const d = mat.d;
        const cos = (0, $8804784813ffae81$export$6a7ef315a0d1ef07).cosDeg(degrees);
        const sin = (0, $8804784813ffae81$export$6a7ef315a0d1ef07).sinDeg(degrees);
        mat.a = cos * a - sin * c;
        mat.c = cos * b - sin * d;
        mat.b = sin * a + cos * c;
        mat.d = sin * b + cos * d;
        this.appliedValid = false;
    }
}



class $a5b6524b51430054$export$7d85d96cf093e12f {
    constructor(index, name, parent){
        this.x = 0;
        this.y = 0;
        this.rotation = 0;
        this.scaleX = 1;
        this.scaleY = 1;
        this.shearX = 0;
        this.shearY = 0;
        this.transformMode = (0, $ccc5aebc60cbf024$export$4c408f82786a534d).Normal;
        if (index < 0) throw new Error("index must be >= 0.");
        if (name == null) throw new Error("name cannot be null.");
        this.index = index;
        this.name = name;
        this.parent = parent;
    }
}


class $c7ea2d215007ce13$export$d61e24a684f9e51 {
    constructor(time, data){
        if (data == null) throw new Error("data cannot be null.");
        this.time = time;
        this.data = data;
    }
}


class $a9b3b2867f4818f5$export$a5cf049e34c3d11e {
    constructor(name){
        this.name = name;
    }
}



class $15dc54730e7fffe4$export$3c158c80ff28c177 {
    constructor(data, skeleton){
        this.bendDirection = 0;
        this.compress = false;
        this.stretch = false;
        this.mix = 1;
        if (data == null) throw new Error("data cannot be null.");
        if (skeleton == null) throw new Error("skeleton cannot be null.");
        this.data = data;
        this.mix = data.mix;
        this.bendDirection = data.bendDirection;
        this.compress = data.compress;
        this.stretch = data.stretch;
        this.bones = new Array();
        for(let i = 0; i < data.bones.length; i++)this.bones.push(skeleton.findBone(data.bones[i].name));
        this.target = skeleton.findBone(data.target.name);
    }
    getOrder() {
        return this.data.order;
    }
    apply() {
        this.update();
    }
    update() {
        const target = this.target;
        const bones = this.bones;
        switch(bones.length){
            case 1:
                this.apply1(bones[0], target.worldX, target.worldY, this.compress, this.stretch, this.data.uniform, this.mix);
                break;
            case 2:
                this.apply2(bones[0], bones[1], target.worldX, target.worldY, this.bendDirection, this.stretch, this.mix);
                break;
        }
    }
    /** Adjusts the bone rotation so the tip is as close to the target position as possible. The target is specified in the world
   * coordinate system. */ apply1(bone, targetX, targetY, compress, stretch, uniform, alpha) {
        if (!bone.appliedValid) bone.updateAppliedTransform();
        const p = bone.parent.matrix;
        const id = 1 / (p.a * p.d - p.b * p.c);
        const x = targetX - p.tx;
        const y = targetY - p.ty;
        const tx = (x * p.d - y * p.c) * id - bone.ax;
        const ty = (y * p.a - x * p.b) * id - bone.ay;
        let rotationIK = Math.atan2(ty, tx) * (0, $8804784813ffae81$export$6a7ef315a0d1ef07).radDeg - bone.ashearX - bone.arotation;
        if (bone.ascaleX < 0) rotationIK += 180;
        if (rotationIK > 180) rotationIK -= 360;
        else if (rotationIK < -180) rotationIK += 360;
        let sx = bone.ascaleX;
        let sy = bone.ascaleY;
        if (compress || stretch) {
            const b = bone.data.length * sx;
            const dd = Math.sqrt(tx * tx + ty * ty);
            if (compress && dd < b || stretch && dd > b && b > 1e-4) {
                const s = (dd / b - 1) * alpha + 1;
                sx *= s;
                if (uniform) sy *= s;
            }
        }
        bone.updateWorldTransformWith(bone.ax, bone.ay, bone.arotation + rotationIK * alpha, sx, sy, bone.ashearX, bone.ashearY);
    }
    /** Adjusts the parent and child bone rotations so the tip of the child is as close to the target position as possible. The
   * target is specified in the world coordinate system.
   * @param child A direct descendant of the parent bone. */ apply2(parent, child, targetX, targetY, bendDir, stretch, alpha) {
        if (alpha == 0) {
            child.updateWorldTransform();
            return;
        }
        if (!parent.appliedValid) parent.updateAppliedTransform();
        if (!child.appliedValid) child.updateAppliedTransform();
        const px = parent.ax;
        const py = parent.ay;
        let psx = parent.ascaleX;
        let sx = psx;
        let psy = parent.ascaleY;
        let csx = child.ascaleX;
        const pmat = parent.matrix;
        let os1 = 0;
        let os2 = 0;
        let s2 = 0;
        if (psx < 0) {
            psx = -psx;
            os1 = 180;
            s2 = -1;
        } else {
            os1 = 0;
            s2 = 1;
        }
        if (psy < 0) {
            psy = -psy;
            s2 = -s2;
        }
        if (csx < 0) {
            csx = -csx;
            os2 = 180;
        } else os2 = 0;
        const cx = child.ax;
        let cy = 0;
        let cwx = 0;
        let cwy = 0;
        let a = pmat.a;
        let b = pmat.c;
        let c = pmat.b;
        let d = pmat.d;
        const u = Math.abs(psx - psy) <= 1e-4;
        if (!u) {
            cy = 0;
            cwx = a * cx + pmat.tx;
            cwy = c * cx + pmat.ty;
        } else {
            cy = child.ay;
            cwx = a * cx + b * cy + pmat.tx;
            cwy = c * cx + d * cy + pmat.ty;
        }
        const pp = parent.parent.matrix;
        a = pp.a;
        b = pp.c;
        c = pp.b;
        d = pp.d;
        const id = 1 / (a * d - b * c);
        let x = targetX - pp.tx;
        let y = targetY - pp.ty;
        const tx = (x * d - y * b) * id - px;
        const ty = (y * a - x * c) * id - py;
        const dd = tx * tx + ty * ty;
        x = cwx - pp.tx;
        y = cwy - pp.ty;
        const dx = (x * d - y * b) * id - px;
        const dy = (y * a - x * c) * id - py;
        const l1 = Math.sqrt(dx * dx + dy * dy);
        let l2 = child.data.length * csx;
        let a1 = 0;
        let a2 = 0;
        outer: if (u) {
            l2 *= psx;
            let cos = (dd - l1 * l1 - l2 * l2) / (2 * l1 * l2);
            if (cos < -1) cos = -1;
            else if (cos > 1) {
                cos = 1;
                if (stretch && l1 + l2 > 1e-4) sx *= (Math.sqrt(dd) / (l1 + l2) - 1) * alpha + 1;
            }
            a2 = Math.acos(cos) * bendDir;
            a = l1 + l2 * cos;
            b = l2 * Math.sin(a2);
            a1 = Math.atan2(ty * a - tx * b, tx * a + ty * b);
        } else {
            a = psx * l2;
            b = psy * l2;
            const aa = a * a;
            const bb = b * b;
            const ta = Math.atan2(ty, tx);
            c = bb * l1 * l1 + aa * dd - aa * bb;
            const c1 = -2 * bb * l1;
            const c2 = bb - aa;
            d = c1 * c1 - 4 * c2 * c;
            if (d >= 0) {
                let q = Math.sqrt(d);
                if (c1 < 0) q = -q;
                q = -(c1 + q) / 2;
                const r0 = q / c2;
                const r1 = c / q;
                const r = Math.abs(r0) < Math.abs(r1) ? r0 : r1;
                if (r * r <= dd) {
                    y = Math.sqrt(dd - r * r) * bendDir;
                    a1 = ta - Math.atan2(y, r);
                    a2 = Math.atan2(y / psy, (r - l1) / psx);
                    break outer;
                }
            }
            let minAngle = (0, $8804784813ffae81$export$6a7ef315a0d1ef07).PI;
            let minX = l1 - a;
            let minDist = minX * minX;
            let minY = 0;
            let maxAngle = 0;
            let maxX = l1 + a;
            let maxDist = maxX * maxX;
            let maxY = 0;
            c = -a * l1 / (aa - bb);
            if (c >= -1 && c <= 1) {
                c = Math.acos(c);
                x = a * Math.cos(c) + l1;
                y = b * Math.sin(c);
                d = x * x + y * y;
                if (d < minDist) {
                    minAngle = c;
                    minDist = d;
                    minX = x;
                    minY = y;
                }
                if (d > maxDist) {
                    maxAngle = c;
                    maxDist = d;
                    maxX = x;
                    maxY = y;
                }
            }
            if (dd <= (minDist + maxDist) / 2) {
                a1 = ta - Math.atan2(minY * bendDir, minX);
                a2 = minAngle * bendDir;
            } else {
                a1 = ta - Math.atan2(maxY * bendDir, maxX);
                a2 = maxAngle * bendDir;
            }
        }
        const os = Math.atan2(cy, cx) * s2;
        let rotation = parent.arotation;
        a1 = (a1 - os) * (0, $8804784813ffae81$export$6a7ef315a0d1ef07).radDeg + os1 - rotation;
        if (a1 > 180) a1 -= 360;
        else if (a1 < -180) a1 += 360;
        parent.updateWorldTransformWith(px, py, rotation + a1 * alpha, sx, parent.ascaleY, 0, 0);
        rotation = child.arotation;
        a2 = ((a2 + os) * (0, $8804784813ffae81$export$6a7ef315a0d1ef07).radDeg - child.ashearX) * s2 + os2 - rotation;
        if (a2 > 180) a2 -= 360;
        else if (a2 < -180) a2 += 360;
        child.updateWorldTransformWith(cx, cy, rotation + a2 * alpha, child.ascaleX, child.ascaleY, child.ashearX, child.ashearY);
    }
}


class $33de7df150c186a2$export$adcb08b651fc712e {
    constructor(name){
        this.order = 0;
        this.bones = new Array();
        this.bendDirection = 1;
        this.compress = false;
        this.stretch = false;
        this.uniform = false;
        this.mix = 1;
        this.name = name;
    }
}






class $6be2e6fd947029e3$export$d2629ab80d5dd5ba {
    constructor(name){
        this.order = 0;
        this.bones = new Array();
        this.name = name;
    }
}
var $6be2e6fd947029e3$export$34ce760ad2b0be4b = /* @__PURE__ */ ((SpacingMode2)=>{
    SpacingMode2[SpacingMode2["Length"] = 0] = "Length";
    SpacingMode2[SpacingMode2["Fixed"] = 1] = "Fixed";
    SpacingMode2[SpacingMode2["Percent"] = 2] = "Percent";
    return SpacingMode2;
})($6be2e6fd947029e3$export$34ce760ad2b0be4b || {});


const $84bfe255fc6dec07$var$_PathConstraint = class {
    constructor(data, skeleton){
        this.position = 0;
        this.spacing = 0;
        this.rotateMix = 0;
        this.translateMix = 0;
        this.spaces = new Array();
        this.positions = new Array();
        this.world = new Array();
        this.curves = new Array();
        this.lengths = new Array();
        this.segments = new Array();
        if (data == null) throw new Error("data cannot be null.");
        if (skeleton == null) throw new Error("skeleton cannot be null.");
        this.data = data;
        this.bones = new Array();
        for(let i = 0, n = data.bones.length; i < n; i++)this.bones.push(skeleton.findBone(data.bones[i].name));
        this.target = skeleton.findSlot(data.target.name);
        this.position = data.position;
        this.spacing = data.spacing;
        this.rotateMix = data.rotateMix;
        this.translateMix = data.translateMix;
    }
    apply() {
        this.update();
    }
    update() {
        const attachment = this.target.getAttachment();
        if (!(attachment instanceof (0, $193cdc10edd05e64$export$d285e3ec07b32800))) return;
        const rotateMix = this.rotateMix;
        const translateMix = this.translateMix;
        const translate = translateMix > 0;
        const rotate = rotateMix > 0;
        if (!translate && !rotate) return;
        const data = this.data;
        const spacingMode = data.spacingMode;
        const lengthSpacing = spacingMode == (0, $6be2e6fd947029e3$export$34ce760ad2b0be4b).Length;
        const rotateMode = data.rotateMode;
        const tangents = rotateMode == (0, $2c8db927dc4fcff5$export$a2a23846581ac82c).Tangent;
        const scale = rotateMode == (0, $2c8db927dc4fcff5$export$a2a23846581ac82c).ChainScale;
        const boneCount = this.bones.length;
        const spacesCount = tangents ? boneCount : boneCount + 1;
        const bones = this.bones;
        const spaces = (0, $8804784813ffae81$export$d2ca453b913dcdea).setArraySize(this.spaces, spacesCount);
        let lengths = null;
        const spacing = this.spacing;
        if (scale || lengthSpacing) {
            if (scale) lengths = (0, $8804784813ffae81$export$d2ca453b913dcdea).setArraySize(this.lengths, boneCount);
            for(let i = 0, n = spacesCount - 1; i < n;){
                const bone = bones[i];
                const setupLength = bone.data.length;
                if (setupLength < $84bfe255fc6dec07$var$_PathConstraint.epsilon) {
                    if (scale) lengths[i] = 0;
                    spaces[++i] = 0;
                } else {
                    const x = setupLength * bone.matrix.a;
                    const y = setupLength * bone.matrix.b;
                    const length = Math.sqrt(x * x + y * y);
                    if (scale) lengths[i] = length;
                    spaces[++i] = (lengthSpacing ? setupLength + spacing : spacing) * length / setupLength;
                }
            }
        } else for(let i = 1; i < spacesCount; i++)spaces[i] = spacing;
        const positions = this.computeWorldPositions(attachment, spacesCount, tangents, data.positionMode == (0, $2c8db927dc4fcff5$export$34d637c671e1e906).Percent, spacingMode == (0, $6be2e6fd947029e3$export$34ce760ad2b0be4b).Percent);
        let boneX = positions[0];
        let boneY = positions[1];
        let offsetRotation = data.offsetRotation;
        let tip = false;
        if (offsetRotation == 0) tip = rotateMode == (0, $2c8db927dc4fcff5$export$a2a23846581ac82c).Chain;
        else {
            tip = false;
            const p = this.target.bone.matrix;
            offsetRotation *= p.a * p.d - p.b * p.c > 0 ? (0, $8804784813ffae81$export$6a7ef315a0d1ef07).degRad : -(0, $8804784813ffae81$export$6a7ef315a0d1ef07).degRad;
        }
        for(let i = 0, p = 3; i < boneCount; i++, p += 3){
            const bone = bones[i];
            const mat = bone.matrix;
            mat.tx += (boneX - mat.tx) * translateMix;
            mat.ty += (boneY - mat.ty) * translateMix;
            const x = positions[p];
            const y = positions[p + 1];
            const dx = x - boneX;
            const dy = y - boneY;
            if (scale) {
                const length = lengths[i];
                if (length != 0) {
                    const s = (Math.sqrt(dx * dx + dy * dy) / length - 1) * rotateMix + 1;
                    mat.a *= s;
                    mat.b *= s;
                }
            }
            boneX = x;
            boneY = y;
            if (rotate) {
                const a = mat.a;
                const b = mat.c;
                const c = mat.b;
                const d = mat.d;
                let r = 0;
                let cos = 0;
                let sin = 0;
                if (tangents) {
                    if (tangents) r = positions[p - 1];
                    else if (spaces[i + 1] == 0) r = positions[p + 2];
                    else r = Math.atan2(dy, dx);
                }
                r -= Math.atan2(c, a);
                if (tip) {
                    cos = Math.cos(r);
                    sin = Math.sin(r);
                    const length = bone.data.length;
                    boneX += (length * (cos * a - sin * c) - dx) * rotateMix;
                    boneY += (length * (sin * a + cos * c) - dy) * rotateMix;
                } else r += offsetRotation;
                if (r > (0, $8804784813ffae81$export$6a7ef315a0d1ef07).PI) r -= (0, $8804784813ffae81$export$6a7ef315a0d1ef07).PI2;
                else if (r < -(0, $8804784813ffae81$export$6a7ef315a0d1ef07).PI) r += (0, $8804784813ffae81$export$6a7ef315a0d1ef07).PI2;
                r *= rotateMix;
                cos = Math.cos(r);
                sin = Math.sin(r);
                mat.a = cos * a - sin * c;
                mat.c = cos * b - sin * d;
                mat.b = sin * a + cos * c;
                mat.d = sin * b + cos * d;
            }
            bone.appliedValid = false;
        }
    }
    computeWorldPositions(path, spacesCount, tangents, percentPosition, percentSpacing) {
        const target = this.target;
        let position = this.position;
        const spaces = this.spaces;
        const out = (0, $8804784813ffae81$export$d2ca453b913dcdea).setArraySize(this.positions, spacesCount * 3 + 2);
        let world = null;
        const closed = path.closed;
        let verticesLength = path.worldVerticesLength;
        let curveCount = verticesLength / 6;
        let prevCurve = $84bfe255fc6dec07$var$_PathConstraint.NONE;
        if (!path.constantSpeed) {
            const lengths = path.lengths;
            curveCount -= closed ? 1 : 2;
            const pathLength2 = lengths[curveCount];
            if (percentPosition) position *= pathLength2;
            if (percentSpacing) for(let i = 0; i < spacesCount; i++)spaces[i] *= pathLength2;
            world = (0, $8804784813ffae81$export$d2ca453b913dcdea).setArraySize(this.world, 8);
            for(let i = 0, o = 0, curve = 0; i < spacesCount; i++, o += 3){
                const space = spaces[i];
                position += space;
                let p = position;
                if (closed) {
                    p %= pathLength2;
                    if (p < 0) p += pathLength2;
                    curve = 0;
                } else if (p < 0) {
                    if (prevCurve != $84bfe255fc6dec07$var$_PathConstraint.BEFORE) {
                        prevCurve = $84bfe255fc6dec07$var$_PathConstraint.BEFORE;
                        path.computeWorldVertices(target, 2, 4, world, 0, 2);
                    }
                    this.addBeforePosition(p, world, 0, out, o);
                    continue;
                } else if (p > pathLength2) {
                    if (prevCurve != $84bfe255fc6dec07$var$_PathConstraint.AFTER) {
                        prevCurve = $84bfe255fc6dec07$var$_PathConstraint.AFTER;
                        path.computeWorldVertices(target, verticesLength - 6, 4, world, 0, 2);
                    }
                    this.addAfterPosition(p - pathLength2, world, 0, out, o);
                    continue;
                }
                for(;; curve++){
                    const length = lengths[curve];
                    if (p > length) continue;
                    if (curve == 0) p /= length;
                    else {
                        const prev = lengths[curve - 1];
                        p = (p - prev) / (length - prev);
                    }
                    break;
                }
                if (curve != prevCurve) {
                    prevCurve = curve;
                    if (closed && curve == curveCount) {
                        path.computeWorldVertices(target, verticesLength - 4, 4, world, 0, 2);
                        path.computeWorldVertices(target, 0, 4, world, 4, 2);
                    } else path.computeWorldVertices(target, curve * 6 + 2, 8, world, 0, 2);
                }
                this.addCurvePosition(p, world[0], world[1], world[2], world[3], world[4], world[5], world[6], world[7], out, o, tangents || i > 0 && space == 0);
            }
            return out;
        }
        if (closed) {
            verticesLength += 2;
            world = (0, $8804784813ffae81$export$d2ca453b913dcdea).setArraySize(this.world, verticesLength);
            path.computeWorldVertices(target, 2, verticesLength - 4, world, 0, 2);
            path.computeWorldVertices(target, 0, 2, world, verticesLength - 4, 2);
            world[verticesLength - 2] = world[0];
            world[verticesLength - 1] = world[1];
        } else {
            curveCount--;
            verticesLength -= 4;
            world = (0, $8804784813ffae81$export$d2ca453b913dcdea).setArraySize(this.world, verticesLength);
            path.computeWorldVertices(target, 2, verticesLength, world, 0, 2);
        }
        const curves = (0, $8804784813ffae81$export$d2ca453b913dcdea).setArraySize(this.curves, curveCount);
        let pathLength = 0;
        let x1 = world[0];
        let y1 = world[1];
        let cx1 = 0;
        let cy1 = 0;
        let cx2 = 0;
        let cy2 = 0;
        let x2 = 0;
        let y2 = 0;
        let tmpx = 0;
        let tmpy = 0;
        let dddfx = 0;
        let dddfy = 0;
        let ddfx = 0;
        let ddfy = 0;
        let dfx = 0;
        let dfy = 0;
        for(let i = 0, w = 2; i < curveCount; i++, w += 6){
            cx1 = world[w];
            cy1 = world[w + 1];
            cx2 = world[w + 2];
            cy2 = world[w + 3];
            x2 = world[w + 4];
            y2 = world[w + 5];
            tmpx = (x1 - cx1 * 2 + cx2) * 0.1875;
            tmpy = (y1 - cy1 * 2 + cy2) * 0.1875;
            dddfx = ((cx1 - cx2) * 3 - x1 + x2) * 0.09375;
            dddfy = ((cy1 - cy2) * 3 - y1 + y2) * 0.09375;
            ddfx = tmpx * 2 + dddfx;
            ddfy = tmpy * 2 + dddfy;
            dfx = (cx1 - x1) * 0.75 + tmpx + dddfx * 0.16666667;
            dfy = (cy1 - y1) * 0.75 + tmpy + dddfy * 0.16666667;
            pathLength += Math.sqrt(dfx * dfx + dfy * dfy);
            dfx += ddfx;
            dfy += ddfy;
            ddfx += dddfx;
            ddfy += dddfy;
            pathLength += Math.sqrt(dfx * dfx + dfy * dfy);
            dfx += ddfx;
            dfy += ddfy;
            pathLength += Math.sqrt(dfx * dfx + dfy * dfy);
            dfx += ddfx + dddfx;
            dfy += ddfy + dddfy;
            pathLength += Math.sqrt(dfx * dfx + dfy * dfy);
            curves[i] = pathLength;
            x1 = x2;
            y1 = y2;
        }
        if (percentPosition) position *= pathLength;
        if (percentSpacing) for(let i = 0; i < spacesCount; i++)spaces[i] *= pathLength;
        const segments = this.segments;
        let curveLength = 0;
        for(let i = 0, o = 0, curve = 0, segment = 0; i < spacesCount; i++, o += 3){
            const space = spaces[i];
            position += space;
            let p = position;
            if (closed) {
                p %= pathLength;
                if (p < 0) p += pathLength;
                curve = 0;
            } else if (p < 0) {
                this.addBeforePosition(p, world, 0, out, o);
                continue;
            } else if (p > pathLength) {
                this.addAfterPosition(p - pathLength, world, verticesLength - 4, out, o);
                continue;
            }
            for(;; curve++){
                const length = curves[curve];
                if (p > length) continue;
                if (curve == 0) p /= length;
                else {
                    const prev = curves[curve - 1];
                    p = (p - prev) / (length - prev);
                }
                break;
            }
            if (curve != prevCurve) {
                prevCurve = curve;
                let ii = curve * 6;
                x1 = world[ii];
                y1 = world[ii + 1];
                cx1 = world[ii + 2];
                cy1 = world[ii + 3];
                cx2 = world[ii + 4];
                cy2 = world[ii + 5];
                x2 = world[ii + 6];
                y2 = world[ii + 7];
                tmpx = (x1 - cx1 * 2 + cx2) * 0.03;
                tmpy = (y1 - cy1 * 2 + cy2) * 0.03;
                dddfx = ((cx1 - cx2) * 3 - x1 + x2) * 6e-3;
                dddfy = ((cy1 - cy2) * 3 - y1 + y2) * 6e-3;
                ddfx = tmpx * 2 + dddfx;
                ddfy = tmpy * 2 + dddfy;
                dfx = (cx1 - x1) * 0.3 + tmpx + dddfx * 0.16666667;
                dfy = (cy1 - y1) * 0.3 + tmpy + dddfy * 0.16666667;
                curveLength = Math.sqrt(dfx * dfx + dfy * dfy);
                segments[0] = curveLength;
                for(ii = 1; ii < 8; ii++){
                    dfx += ddfx;
                    dfy += ddfy;
                    ddfx += dddfx;
                    ddfy += dddfy;
                    curveLength += Math.sqrt(dfx * dfx + dfy * dfy);
                    segments[ii] = curveLength;
                }
                dfx += ddfx;
                dfy += ddfy;
                curveLength += Math.sqrt(dfx * dfx + dfy * dfy);
                segments[8] = curveLength;
                dfx += ddfx + dddfx;
                dfy += ddfy + dddfy;
                curveLength += Math.sqrt(dfx * dfx + dfy * dfy);
                segments[9] = curveLength;
                segment = 0;
            }
            p *= curveLength;
            for(;; segment++){
                const length = segments[segment];
                if (p > length) continue;
                if (segment == 0) p /= length;
                else {
                    const prev = segments[segment - 1];
                    p = segment + (p - prev) / (length - prev);
                }
                break;
            }
            this.addCurvePosition(p * 0.1, x1, y1, cx1, cy1, cx2, cy2, x2, y2, out, o, tangents || i > 0 && space == 0);
        }
        return out;
    }
    addBeforePosition(p, temp, i, out, o) {
        const x1 = temp[i];
        const y1 = temp[i + 1];
        const dx = temp[i + 2] - x1;
        const dy = temp[i + 3] - y1;
        const r = Math.atan2(dy, dx);
        out[o] = x1 + p * Math.cos(r);
        out[o + 1] = y1 + p * Math.sin(r);
        out[o + 2] = r;
    }
    addAfterPosition(p, temp, i, out, o) {
        const x1 = temp[i + 2];
        const y1 = temp[i + 3];
        const dx = x1 - temp[i];
        const dy = y1 - temp[i + 1];
        const r = Math.atan2(dy, dx);
        out[o] = x1 + p * Math.cos(r);
        out[o + 1] = y1 + p * Math.sin(r);
        out[o + 2] = r;
    }
    addCurvePosition(p, x1, y1, cx1, cy1, cx2, cy2, x2, y2, out, o, tangents) {
        if (p == 0 || isNaN(p)) p = 1e-4;
        const tt = p * p;
        const ttt = tt * p;
        const u = 1 - p;
        const uu = u * u;
        const uuu = uu * u;
        const ut = u * p;
        const ut3 = ut * 3;
        const uut3 = u * ut3;
        const utt3 = ut3 * p;
        const x = x1 * uuu + cx1 * uut3 + cx2 * utt3 + x2 * ttt;
        const y = y1 * uuu + cy1 * uut3 + cy2 * utt3 + y2 * ttt;
        out[o] = x;
        out[o + 1] = y;
        if (tangents) out[o + 2] = Math.atan2(y - (y1 * uu + cy1 * ut * 2 + cy2 * tt), x - (x1 * uu + cx1 * ut * 2 + cx2 * tt));
    }
    getOrder() {
        return this.data.order;
    }
};
let $84bfe255fc6dec07$export$cb4f92fb0c018828 = $84bfe255fc6dec07$var$_PathConstraint;
$84bfe255fc6dec07$export$cb4f92fb0c018828.NONE = -1;
$84bfe255fc6dec07$export$cb4f92fb0c018828.BEFORE = -2;
$84bfe255fc6dec07$export$cb4f92fb0c018828.AFTER = -3;
$84bfe255fc6dec07$export$cb4f92fb0c018828.epsilon = 1e-5;












class $00508ebb97eb18da$export$a2d8268faabf5c52 {
    constructor(data, skeleton){
        this.rotateMix = 0;
        this.translateMix = 0;
        this.scaleMix = 0;
        this.shearMix = 0;
        this.temp = new (0, $8804784813ffae81$export$c977b3e384af9ae1)();
        if (data == null) throw new Error("data cannot be null.");
        if (skeleton == null) throw new Error("skeleton cannot be null.");
        this.data = data;
        this.rotateMix = data.rotateMix;
        this.translateMix = data.translateMix;
        this.scaleMix = data.scaleMix;
        this.shearMix = data.shearMix;
        this.bones = new Array();
        for(let i = 0; i < data.bones.length; i++)this.bones.push(skeleton.findBone(data.bones[i].name));
        this.target = skeleton.findBone(data.target.name);
    }
    apply() {
        this.update();
    }
    update() {
        if (this.data.local) {
            if (this.data.relative) this.applyRelativeLocal();
            else this.applyAbsoluteLocal();
        } else if (this.data.relative) this.applyRelativeWorld();
        else this.applyAbsoluteWorld();
    }
    applyAbsoluteWorld() {
        const rotateMix = this.rotateMix;
        const translateMix = this.translateMix;
        const scaleMix = this.scaleMix;
        const shearMix = this.shearMix;
        const target = this.target;
        const targetMat = target.matrix;
        const ta = targetMat.a;
        const tb = targetMat.c;
        const tc = targetMat.b;
        const td = targetMat.d;
        const degRadReflect = ta * td - tb * tc > 0 ? (0, $8804784813ffae81$export$6a7ef315a0d1ef07).degRad : -(0, $8804784813ffae81$export$6a7ef315a0d1ef07).degRad;
        const offsetRotation = this.data.offsetRotation * degRadReflect;
        const offsetShearY = this.data.offsetShearY * degRadReflect;
        const bones = this.bones;
        for(let i = 0, n = bones.length; i < n; i++){
            const bone = bones[i];
            let modified = false;
            const mat = bone.matrix;
            if (rotateMix != 0) {
                const a = mat.a;
                const b = mat.c;
                const c = mat.b;
                const d = mat.d;
                let r = Math.atan2(tc, ta) - Math.atan2(c, a) + offsetRotation;
                if (r > (0, $8804784813ffae81$export$6a7ef315a0d1ef07).PI) r -= (0, $8804784813ffae81$export$6a7ef315a0d1ef07).PI2;
                else if (r < -(0, $8804784813ffae81$export$6a7ef315a0d1ef07).PI) r += (0, $8804784813ffae81$export$6a7ef315a0d1ef07).PI2;
                r *= rotateMix;
                const cos = Math.cos(r);
                const sin = Math.sin(r);
                mat.a = cos * a - sin * c;
                mat.c = cos * b - sin * d;
                mat.b = sin * a + cos * c;
                mat.d = sin * b + cos * d;
                modified = true;
            }
            if (translateMix != 0) {
                const temp = this.temp;
                target.localToWorld(temp.set(this.data.offsetX, this.data.offsetY));
                mat.tx += (temp.x - mat.tx) * translateMix;
                mat.ty += (temp.y - mat.ty) * translateMix;
                modified = true;
            }
            if (scaleMix > 0) {
                let s = Math.sqrt(mat.a * mat.a + mat.b * mat.b);
                let ts = Math.sqrt(ta * ta + tc * tc);
                if (s > 1e-5) s = (s + (ts - s + this.data.offsetScaleX) * scaleMix) / s;
                mat.a *= s;
                mat.b *= s;
                s = Math.sqrt(mat.c * mat.c + mat.d * mat.d);
                ts = Math.sqrt(tb * tb + td * td);
                if (s > 1e-5) s = (s + (ts - s + this.data.offsetScaleY) * scaleMix) / s;
                mat.c *= s;
                mat.d *= s;
                modified = true;
            }
            if (shearMix > 0) {
                const b = mat.c;
                const d = mat.d;
                const by = Math.atan2(d, b);
                let r = Math.atan2(td, tb) - Math.atan2(tc, ta) - (by - Math.atan2(mat.b, mat.a));
                if (r > (0, $8804784813ffae81$export$6a7ef315a0d1ef07).PI) r -= (0, $8804784813ffae81$export$6a7ef315a0d1ef07).PI2;
                else if (r < -(0, $8804784813ffae81$export$6a7ef315a0d1ef07).PI) r += (0, $8804784813ffae81$export$6a7ef315a0d1ef07).PI2;
                r = by + (r + offsetShearY) * shearMix;
                const s = Math.sqrt(b * b + d * d);
                mat.c = Math.cos(r) * s;
                mat.d = Math.sin(r) * s;
                modified = true;
            }
            if (modified) bone.appliedValid = false;
        }
    }
    applyRelativeWorld() {
        const rotateMix = this.rotateMix;
        const translateMix = this.translateMix;
        const scaleMix = this.scaleMix;
        const shearMix = this.shearMix;
        const target = this.target;
        const targetMat = target.matrix;
        const ta = targetMat.a;
        const tb = targetMat.c;
        const tc = targetMat.b;
        const td = targetMat.d;
        const degRadReflect = ta * td - tb * tc > 0 ? (0, $8804784813ffae81$export$6a7ef315a0d1ef07).degRad : -(0, $8804784813ffae81$export$6a7ef315a0d1ef07).degRad;
        const offsetRotation = this.data.offsetRotation * degRadReflect;
        const offsetShearY = this.data.offsetShearY * degRadReflect;
        const bones = this.bones;
        for(let i = 0, n = bones.length; i < n; i++){
            const bone = bones[i];
            let modified = false;
            const mat = bone.matrix;
            if (rotateMix != 0) {
                const a = mat.a;
                const b = mat.c;
                const c = mat.b;
                const d = mat.d;
                let r = Math.atan2(tc, ta) + offsetRotation;
                if (r > (0, $8804784813ffae81$export$6a7ef315a0d1ef07).PI) r -= (0, $8804784813ffae81$export$6a7ef315a0d1ef07).PI2;
                else if (r < -(0, $8804784813ffae81$export$6a7ef315a0d1ef07).PI) r += (0, $8804784813ffae81$export$6a7ef315a0d1ef07).PI2;
                r *= rotateMix;
                const cos = Math.cos(r);
                const sin = Math.sin(r);
                mat.a = cos * a - sin * c;
                mat.c = cos * b - sin * d;
                mat.b = sin * a + cos * c;
                mat.d = sin * b + cos * d;
                modified = true;
            }
            if (translateMix != 0) {
                const temp = this.temp;
                target.localToWorld(temp.set(this.data.offsetX, this.data.offsetY));
                mat.tx += temp.x * translateMix;
                mat.ty += temp.y * translateMix;
                modified = true;
            }
            if (scaleMix > 0) {
                let s = (Math.sqrt(ta * ta + tc * tc) - 1 + this.data.offsetScaleX) * scaleMix + 1;
                mat.a *= s;
                mat.b *= s;
                s = (Math.sqrt(tb * tb + td * td) - 1 + this.data.offsetScaleY) * scaleMix + 1;
                mat.c *= s;
                mat.d *= s;
                modified = true;
            }
            if (shearMix > 0) {
                let r = Math.atan2(td, tb) - Math.atan2(tc, ta);
                if (r > (0, $8804784813ffae81$export$6a7ef315a0d1ef07).PI) r -= (0, $8804784813ffae81$export$6a7ef315a0d1ef07).PI2;
                else if (r < -(0, $8804784813ffae81$export$6a7ef315a0d1ef07).PI) r += (0, $8804784813ffae81$export$6a7ef315a0d1ef07).PI2;
                const b = mat.c;
                const d = mat.d;
                r = Math.atan2(d, b) + (r - (0, $8804784813ffae81$export$6a7ef315a0d1ef07).PI / 2 + offsetShearY) * shearMix;
                const s = Math.sqrt(b * b + d * d);
                mat.c = Math.cos(r) * s;
                mat.d = Math.sin(r) * s;
                modified = true;
            }
            if (modified) bone.appliedValid = false;
        }
    }
    applyAbsoluteLocal() {
        const rotateMix = this.rotateMix;
        const translateMix = this.translateMix;
        const scaleMix = this.scaleMix;
        const shearMix = this.shearMix;
        const target = this.target;
        if (!target.appliedValid) target.updateAppliedTransform();
        const bones = this.bones;
        for(let i = 0, n = bones.length; i < n; i++){
            const bone = bones[i];
            if (!bone.appliedValid) bone.updateAppliedTransform();
            let rotation = bone.arotation;
            if (rotateMix != 0) {
                let r = target.arotation - rotation + this.data.offsetRotation;
                r -= (16384 - (16384.499999999996 - r / 360 | 0)) * 360;
                rotation += r * rotateMix;
            }
            let x = bone.ax;
            let y = bone.ay;
            if (translateMix != 0) {
                x += (target.ax - x + this.data.offsetX) * translateMix;
                y += (target.ay - y + this.data.offsetY) * translateMix;
            }
            let scaleX = bone.ascaleX;
            let scaleY = bone.ascaleY;
            if (scaleMix > 0) {
                if (scaleX > 1e-5) scaleX = (scaleX + (target.ascaleX - scaleX + this.data.offsetScaleX) * scaleMix) / scaleX;
                if (scaleY > 1e-5) scaleY = (scaleY + (target.ascaleY - scaleY + this.data.offsetScaleY) * scaleMix) / scaleY;
            }
            const shearY = bone.ashearY;
            if (shearMix > 0) {
                let r = target.ashearY - shearY + this.data.offsetShearY;
                r -= (16384 - (16384.499999999996 - r / 360 | 0)) * 360;
                bone.shearY += r * shearMix;
            }
            bone.updateWorldTransformWith(x, y, rotation, scaleX, scaleY, bone.ashearX, shearY);
        }
    }
    applyRelativeLocal() {
        const rotateMix = this.rotateMix;
        const translateMix = this.translateMix;
        const scaleMix = this.scaleMix;
        const shearMix = this.shearMix;
        const target = this.target;
        if (!target.appliedValid) target.updateAppliedTransform();
        const bones = this.bones;
        for(let i = 0, n = bones.length; i < n; i++){
            const bone = bones[i];
            if (!bone.appliedValid) bone.updateAppliedTransform();
            let rotation = bone.arotation;
            if (rotateMix != 0) rotation += (target.arotation + this.data.offsetRotation) * rotateMix;
            let x = bone.ax;
            let y = bone.ay;
            if (translateMix != 0) {
                x += (target.ax + this.data.offsetX) * translateMix;
                y += (target.ay + this.data.offsetY) * translateMix;
            }
            let scaleX = bone.ascaleX;
            let scaleY = bone.ascaleY;
            if (scaleMix > 0) {
                if (scaleX > 1e-5) scaleX *= (target.ascaleX - 1 + this.data.offsetScaleX) * scaleMix + 1;
                if (scaleY > 1e-5) scaleY *= (target.ascaleY - 1 + this.data.offsetScaleY) * scaleMix + 1;
            }
            let shearY = bone.ashearY;
            if (shearMix > 0) shearY += (target.ashearY + this.data.offsetShearY) * shearMix;
            bone.updateWorldTransformWith(x, y, rotation, scaleX, scaleY, bone.ashearX, shearY);
        }
    }
    getOrder() {
        return this.data.order;
    }
}



const $6eee187fdca9d523$var$_Skeleton = class {
    constructor(data){
        this._updateCache = new Array();
        this.updateCacheReset = new Array();
        this.time = 0;
        this.scaleX = 1;
        this.scaleY = 1;
        this.x = 0;
        this.y = 0;
        if (data == null) throw new Error("data cannot be null.");
        this.data = data;
        this.bones = new Array();
        for(let i = 0; i < data.bones.length; i++){
            const boneData = data.bones[i];
            let bone;
            if (boneData.parent == null) bone = new (0, $e2f8673bf53faa5e$export$b127726e56765aa4)(boneData, this, null);
            else {
                const parent = this.bones[boneData.parent.index];
                bone = new (0, $e2f8673bf53faa5e$export$b127726e56765aa4)(boneData, this, parent);
                parent.children.push(bone);
            }
            this.bones.push(bone);
        }
        this.slots = new Array();
        this.drawOrder = new Array();
        for(let i = 0; i < data.slots.length; i++){
            const slotData = data.slots[i];
            const bone = this.bones[slotData.boneData.index];
            const slot = new (0, $2eeaf0a953c05635$export$8c6ed5c666ac1360)(slotData, bone);
            this.slots.push(slot);
            this.drawOrder.push(slot);
        }
        this.ikConstraints = new Array();
        for(let i = 0; i < data.ikConstraints.length; i++){
            const ikConstraintData = data.ikConstraints[i];
            this.ikConstraints.push(new (0, $15dc54730e7fffe4$export$3c158c80ff28c177)(ikConstraintData, this));
        }
        this.transformConstraints = new Array();
        for(let i = 0; i < data.transformConstraints.length; i++){
            const transformConstraintData = data.transformConstraints[i];
            this.transformConstraints.push(new (0, $00508ebb97eb18da$export$a2d8268faabf5c52)(transformConstraintData, this));
        }
        this.pathConstraints = new Array();
        for(let i = 0; i < data.pathConstraints.length; i++){
            const pathConstraintData = data.pathConstraints[i];
            this.pathConstraints.push(new (0, $84bfe255fc6dec07$export$cb4f92fb0c018828)(pathConstraintData, this));
        }
        this.color = new (0, $8804784813ffae81$export$892596cec99bc70e)(1, 1, 1, 1);
        this.updateCache();
    }
    updateCache() {
        const updateCache = this._updateCache;
        updateCache.length = 0;
        this.updateCacheReset.length = 0;
        const bones = this.bones;
        for(let i = 0, n = bones.length; i < n; i++)bones[i].sorted = false;
        const ikConstraints = this.ikConstraints;
        const transformConstraints = this.transformConstraints;
        const pathConstraints = this.pathConstraints;
        const ikCount = ikConstraints.length;
        const transformCount = transformConstraints.length;
        const pathCount = pathConstraints.length;
        const constraintCount = ikCount + transformCount + pathCount;
        outer: for(let i = 0; i < constraintCount; i++){
            for(let ii = 0; ii < ikCount; ii++){
                const constraint = ikConstraints[ii];
                if (constraint.data.order == i) {
                    this.sortIkConstraint(constraint);
                    continue outer;
                }
            }
            for(let ii = 0; ii < transformCount; ii++){
                const constraint = transformConstraints[ii];
                if (constraint.data.order == i) {
                    this.sortTransformConstraint(constraint);
                    continue outer;
                }
            }
            for(let ii = 0; ii < pathCount; ii++){
                const constraint = pathConstraints[ii];
                if (constraint.data.order == i) {
                    this.sortPathConstraint(constraint);
                    continue outer;
                }
            }
        }
        for(let i = 0, n = bones.length; i < n; i++)this.sortBone(bones[i]);
    }
    sortIkConstraint(constraint) {
        const target = constraint.target;
        this.sortBone(target);
        const constrained = constraint.bones;
        const parent = constrained[0];
        this.sortBone(parent);
        if (constrained.length > 1) {
            const child = constrained[constrained.length - 1];
            if (!(this._updateCache.indexOf(child) > -1)) this.updateCacheReset.push(child);
        }
        this._updateCache.push(constraint);
        this.sortReset(parent.children);
        constrained[constrained.length - 1].sorted = true;
    }
    sortPathConstraint(constraint) {
        const slot = constraint.target;
        const slotIndex = slot.data.index;
        const slotBone = slot.bone;
        if (this.skin != null) this.sortPathConstraintAttachment(this.skin, slotIndex, slotBone);
        if (this.data.defaultSkin != null && this.data.defaultSkin != this.skin) this.sortPathConstraintAttachment(this.data.defaultSkin, slotIndex, slotBone);
        for(let i = 0, n = this.data.skins.length; i < n; i++)this.sortPathConstraintAttachment(this.data.skins[i], slotIndex, slotBone);
        const attachment = slot.getAttachment();
        if (attachment instanceof (0, $193cdc10edd05e64$export$d285e3ec07b32800)) this.sortPathConstraintAttachmentWith(attachment, slotBone);
        const constrained = constraint.bones;
        const boneCount = constrained.length;
        for(let i = 0; i < boneCount; i++)this.sortBone(constrained[i]);
        this._updateCache.push(constraint);
        for(let i = 0; i < boneCount; i++)this.sortReset(constrained[i].children);
        for(let i = 0; i < boneCount; i++)constrained[i].sorted = true;
    }
    sortTransformConstraint(constraint) {
        this.sortBone(constraint.target);
        const constrained = constraint.bones;
        const boneCount = constrained.length;
        if (constraint.data.local) for(let i = 0; i < boneCount; i++){
            const child = constrained[i];
            this.sortBone(child.parent);
            if (!(this._updateCache.indexOf(child) > -1)) this.updateCacheReset.push(child);
        }
        else for(let i = 0; i < boneCount; i++)this.sortBone(constrained[i]);
        this._updateCache.push(constraint);
        for(let ii = 0; ii < boneCount; ii++)this.sortReset(constrained[ii].children);
        for(let ii = 0; ii < boneCount; ii++)constrained[ii].sorted = true;
    }
    sortPathConstraintAttachment(skin, slotIndex, slotBone) {
        const attachments = skin.attachments[slotIndex];
        if (!attachments) return;
        for(const key in attachments)this.sortPathConstraintAttachmentWith(attachments[key], slotBone);
    }
    sortPathConstraintAttachmentWith(attachment, slotBone) {
        if (!(attachment instanceof (0, $193cdc10edd05e64$export$d285e3ec07b32800))) return;
        const pathBones = attachment.bones;
        if (pathBones == null) this.sortBone(slotBone);
        else {
            const bones = this.bones;
            let i = 0;
            while(i < pathBones.length){
                const boneCount = pathBones[i++];
                for(let n = i + boneCount; i < n; i++){
                    const boneIndex = pathBones[i];
                    this.sortBone(bones[boneIndex]);
                }
            }
        }
    }
    sortBone(bone) {
        if (bone.sorted) return;
        const parent = bone.parent;
        if (parent != null) this.sortBone(parent);
        bone.sorted = true;
        this._updateCache.push(bone);
    }
    sortReset(bones) {
        for(let i = 0, n = bones.length; i < n; i++){
            const bone = bones[i];
            if (bone.sorted) this.sortReset(bone.children);
            bone.sorted = false;
        }
    }
    /** Updates the world transform for each bone and applies constraints. */ updateWorldTransform() {
        const updateCacheReset = this.updateCacheReset;
        for(let i = 0, n = updateCacheReset.length; i < n; i++){
            const bone = updateCacheReset[i];
            bone.ax = bone.x;
            bone.ay = bone.y;
            bone.arotation = bone.rotation;
            bone.ascaleX = bone.scaleX;
            bone.ascaleY = bone.scaleY;
            bone.ashearX = bone.shearX;
            bone.ashearY = bone.shearY;
            bone.appliedValid = true;
        }
        const updateCache = this._updateCache;
        for(let i = 0, n = updateCache.length; i < n; i++)updateCache[i].update();
    }
    /** Sets the bones, constraints, and slots to their setup pose values. */ setToSetupPose() {
        this.setBonesToSetupPose();
        this.setSlotsToSetupPose();
    }
    /** Sets the bones and constraints to their setup pose values. */ setBonesToSetupPose() {
        const bones = this.bones;
        for(let i = 0, n = bones.length; i < n; i++)bones[i].setToSetupPose();
        const ikConstraints = this.ikConstraints;
        for(let i = 0, n = ikConstraints.length; i < n; i++){
            const constraint = ikConstraints[i];
            constraint.bendDirection = constraint.data.bendDirection;
            constraint.mix = constraint.data.mix;
        }
        const transformConstraints = this.transformConstraints;
        for(let i = 0, n = transformConstraints.length; i < n; i++){
            const constraint = transformConstraints[i];
            const data = constraint.data;
            constraint.rotateMix = data.rotateMix;
            constraint.translateMix = data.translateMix;
            constraint.scaleMix = data.scaleMix;
            constraint.shearMix = data.shearMix;
        }
        const pathConstraints = this.pathConstraints;
        for(let i = 0, n = pathConstraints.length; i < n; i++){
            const constraint = pathConstraints[i];
            const data = constraint.data;
            constraint.position = data.position;
            constraint.spacing = data.spacing;
            constraint.rotateMix = data.rotateMix;
            constraint.translateMix = data.translateMix;
        }
    }
    setSlotsToSetupPose() {
        const slots = this.slots;
        (0, $8804784813ffae81$export$d2ca453b913dcdea).arrayCopy(slots, 0, this.drawOrder, 0, slots.length);
        for(let i = 0, n = slots.length; i < n; i++)slots[i].setToSetupPose();
    }
    /** @return May return null. */ getRootBone() {
        if (this.bones.length == 0) return null;
        return this.bones[0];
    }
    /** @return May be null. */ findBone(boneName) {
        if (boneName == null) throw new Error("boneName cannot be null.");
        const bones = this.bones;
        for(let i = 0, n = bones.length; i < n; i++){
            const bone = bones[i];
            if (bone.data.name == boneName) return bone;
        }
        return null;
    }
    /** @return -1 if the bone was not found. */ findBoneIndex(boneName) {
        if (boneName == null) throw new Error("boneName cannot be null.");
        const bones = this.bones;
        for(let i = 0, n = bones.length; i < n; i++)if (bones[i].data.name == boneName) return i;
        return -1;
    }
    /** @return May be null. */ findSlot(slotName) {
        if (slotName == null) throw new Error("slotName cannot be null.");
        const slots = this.slots;
        for(let i = 0, n = slots.length; i < n; i++){
            const slot = slots[i];
            if (slot.data.name == slotName) return slot;
        }
        return null;
    }
    /** @return -1 if the bone was not found. */ findSlotIndex(slotName) {
        if (slotName == null) throw new Error("slotName cannot be null.");
        const slots = this.slots;
        for(let i = 0, n = slots.length; i < n; i++)if (slots[i].data.name == slotName) return i;
        return -1;
    }
    /** Sets a skin by name.
   * @see #setSkin(Skin) */ setSkinByName(skinName) {
        const skin = this.data.findSkin(skinName);
        if (skin == null) throw new Error(`Skin not found: ${skinName}`);
        this.setSkin(skin);
    }
    /** Sets the skin used to look up attachments before looking in the {@link SkeletonData#getDefaultSkin() default skin}.
   * Attachments from the new skin are attached if the corresponding attachment from the old skin was attached. If there was no
   * old skin, each slot's setup mode attachment is attached from the new skin.
   * @param newSkin May be null. */ setSkin(newSkin) {
        if (newSkin != null) {
            if (this.skin != null) newSkin.attachAll(this, this.skin);
            else {
                const slots = this.slots;
                for(let i = 0, n = slots.length; i < n; i++){
                    const slot = slots[i];
                    const name = slot.data.attachmentName;
                    if (name != null) {
                        const attachment = newSkin.getAttachment(i, name);
                        if (attachment != null) slot.setAttachment(attachment);
                    }
                }
            }
        }
        this.skin = newSkin;
    }
    /** @return May be null. */ getAttachmentByName(slotName, attachmentName) {
        return this.getAttachment(this.data.findSlotIndex(slotName), attachmentName);
    }
    /** @return May be null. */ getAttachment(slotIndex, attachmentName) {
        if (attachmentName == null) throw new Error("attachmentName cannot be null.");
        if (this.skin != null) {
            const attachment = this.skin.getAttachment(slotIndex, attachmentName);
            if (attachment != null) return attachment;
        }
        if (this.data.defaultSkin != null) return this.data.defaultSkin.getAttachment(slotIndex, attachmentName);
        return null;
    }
    /** @param attachmentName May be null. */ setAttachment(slotName, attachmentName) {
        if (slotName == null) throw new Error("slotName cannot be null.");
        const slots = this.slots;
        for(let i = 0, n = slots.length; i < n; i++){
            const slot = slots[i];
            if (slot.data.name == slotName) {
                let attachment = null;
                if (attachmentName != null) {
                    attachment = this.getAttachment(i, attachmentName);
                    if (attachment == null) throw new Error(`Attachment not found: ${attachmentName}, for slot: ${slotName}`);
                }
                slot.setAttachment(attachment);
                return;
            }
        }
        throw new Error(`Slot not found: ${slotName}`);
    }
    /** @return May be null. */ findIkConstraint(constraintName) {
        if (constraintName == null) throw new Error("constraintName cannot be null.");
        const ikConstraints = this.ikConstraints;
        for(let i = 0, n = ikConstraints.length; i < n; i++){
            const ikConstraint = ikConstraints[i];
            if (ikConstraint.data.name == constraintName) return ikConstraint;
        }
        return null;
    }
    /** @return May be null. */ findTransformConstraint(constraintName) {
        if (constraintName == null) throw new Error("constraintName cannot be null.");
        const transformConstraints = this.transformConstraints;
        for(let i = 0, n = transformConstraints.length; i < n; i++){
            const constraint = transformConstraints[i];
            if (constraint.data.name == constraintName) return constraint;
        }
        return null;
    }
    /** @return May be null. */ findPathConstraint(constraintName) {
        if (constraintName == null) throw new Error("constraintName cannot be null.");
        const pathConstraints = this.pathConstraints;
        for(let i = 0, n = pathConstraints.length; i < n; i++){
            const constraint = pathConstraints[i];
            if (constraint.data.name == constraintName) return constraint;
        }
        return null;
    }
    /** Returns the axis aligned bounding box (AABB) of the region and mesh attachments for the current pose.
   * @param offset The distance from the skeleton origin to the bottom left corner of the AABB.
   * @param size The width and height of the AABB.
   * @param temp Working memory */ getBounds(offset, size, temp) {
        if (offset == null) throw new Error("offset cannot be null.");
        if (size == null) throw new Error("size cannot be null.");
        const drawOrder = this.drawOrder;
        let minX = Number.POSITIVE_INFINITY;
        let minY = Number.POSITIVE_INFINITY;
        let maxX = Number.NEGATIVE_INFINITY;
        let maxY = Number.NEGATIVE_INFINITY;
        for(let i = 0, n = drawOrder.length; i < n; i++){
            const slot = drawOrder[i];
            let verticesLength = 0;
            let vertices = null;
            const attachment = slot.getAttachment();
            if (attachment instanceof (0, $194dfe6c9cdc5a8c$export$d0fc51466fa6d530)) {
                verticesLength = 8;
                vertices = (0, $8804784813ffae81$export$d2ca453b913dcdea).setArraySize(temp, verticesLength, 0);
                attachment.computeWorldVertices(slot.bone, vertices, 0, 2);
            } else if (attachment instanceof (0, $768f0ee4496fce9b$export$3f1c1692adfcf3e2)) {
                const mesh = attachment;
                verticesLength = mesh.worldVerticesLength;
                vertices = (0, $8804784813ffae81$export$d2ca453b913dcdea).setArraySize(temp, verticesLength, 0);
                mesh.computeWorldVertices(slot, 0, verticesLength, vertices, 0, 2);
            }
            if (vertices != null) for(let ii = 0, nn = vertices.length; ii < nn; ii += 2){
                const x = vertices[ii];
                const y = vertices[ii + 1];
                minX = Math.min(minX, x);
                minY = Math.min(minY, y);
                maxX = Math.max(maxX, x);
                maxY = Math.max(maxY, y);
            }
        }
        offset.set(minX, minY);
        size.set(maxX - minX, maxY - minY);
    }
    update(delta) {
        this.time += delta;
    }
    get flipX() {
        return this.scaleX == -1;
    }
    set flipX(value) {
        if (!$6eee187fdca9d523$var$_Skeleton.deprecatedWarning1) {
            $6eee187fdca9d523$var$_Skeleton.deprecatedWarning1 = true;
            console.warn("Spine Deprecation Warning: `Skeleton.flipX/flipY` was deprecated, please use scaleX/scaleY");
        }
        this.scaleX = value ? 1 : -1;
    }
    get flipY() {
        return this.scaleY == -1;
    }
    set flipY(value) {
        if (!$6eee187fdca9d523$var$_Skeleton.deprecatedWarning1) {
            $6eee187fdca9d523$var$_Skeleton.deprecatedWarning1 = true;
            console.warn("Spine Deprecation Warning: `Skeleton.flipX/flipY` was deprecated, please use scaleX/scaleY");
        }
        this.scaleY = value ? 1 : -1;
    }
};
let $6eee187fdca9d523$export$8f31e4c4a37b8e9c = $6eee187fdca9d523$var$_Skeleton;
$6eee187fdca9d523$export$8f31e4c4a37b8e9c.deprecatedWarning1 = false;



class $f2afa1d5b3278a6e$export$119f1746fc062f5e extends (0, $f207f4fe652f3622$export$a40a4b6b6d62719b) {
}


class $05cacac1abb1a224$export$e8f362f163550575 {
    constructor(){
        this.bones = new Array();
        // Ordered parents first.
        this.slots = new Array();
        // Setup pose draw order.
        this.skins = new Array();
        this.events = new Array();
        this.animations = new Array();
        this.ikConstraints = new Array();
        this.transformConstraints = new Array();
        this.pathConstraints = new Array();
        // Nonessential
        this.fps = 0;
    }
    findBone(boneName) {
        if (boneName == null) throw new Error("boneName cannot be null.");
        const bones = this.bones;
        for(let i = 0, n = bones.length; i < n; i++){
            const bone = bones[i];
            if (bone.name == boneName) return bone;
        }
        return null;
    }
    findBoneIndex(boneName) {
        if (boneName == null) throw new Error("boneName cannot be null.");
        const bones = this.bones;
        for(let i = 0, n = bones.length; i < n; i++)if (bones[i].name == boneName) return i;
        return -1;
    }
    findSlot(slotName) {
        if (slotName == null) throw new Error("slotName cannot be null.");
        const slots = this.slots;
        for(let i = 0, n = slots.length; i < n; i++){
            const slot = slots[i];
            if (slot.name == slotName) return slot;
        }
        return null;
    }
    findSlotIndex(slotName) {
        if (slotName == null) throw new Error("slotName cannot be null.");
        const slots = this.slots;
        for(let i = 0, n = slots.length; i < n; i++)if (slots[i].name == slotName) return i;
        return -1;
    }
    findSkin(skinName) {
        if (skinName == null) throw new Error("skinName cannot be null.");
        const skins = this.skins;
        for(let i = 0, n = skins.length; i < n; i++){
            const skin = skins[i];
            if (skin.name == skinName) return skin;
        }
        return null;
    }
    findEvent(eventDataName) {
        if (eventDataName == null) throw new Error("eventDataName cannot be null.");
        const events = this.events;
        for(let i = 0, n = events.length; i < n; i++){
            const event = events[i];
            if (event.name == eventDataName) return event;
        }
        return null;
    }
    findAnimation(animationName) {
        if (animationName == null) throw new Error("animationName cannot be null.");
        const animations = this.animations;
        for(let i = 0, n = animations.length; i < n; i++){
            const animation = animations[i];
            if (animation.name == animationName) return animation;
        }
        return null;
    }
    findIkConstraint(constraintName) {
        if (constraintName == null) throw new Error("constraintName cannot be null.");
        const ikConstraints = this.ikConstraints;
        for(let i = 0, n = ikConstraints.length; i < n; i++){
            const constraint = ikConstraints[i];
            if (constraint.name == constraintName) return constraint;
        }
        return null;
    }
    findTransformConstraint(constraintName) {
        if (constraintName == null) throw new Error("constraintName cannot be null.");
        const transformConstraints = this.transformConstraints;
        for(let i = 0, n = transformConstraints.length; i < n; i++){
            const constraint = transformConstraints[i];
            if (constraint.name == constraintName) return constraint;
        }
        return null;
    }
    findPathConstraint(constraintName) {
        if (constraintName == null) throw new Error("constraintName cannot be null.");
        const pathConstraints = this.pathConstraints;
        for(let i = 0, n = pathConstraints.length; i < n; i++){
            const constraint = pathConstraints[i];
            if (constraint.name == constraintName) return constraint;
        }
        return null;
    }
    findPathConstraintIndex(pathConstraintName) {
        if (pathConstraintName == null) throw new Error("pathConstraintName cannot be null.");
        const pathConstraints = this.pathConstraints;
        for(let i = 0, n = pathConstraints.length; i < n; i++)if (pathConstraints[i].name == pathConstraintName) return i;
        return -1;
    }
}





class $5f798cbede6d2ed4$export$a4cce1bf50208679 {
    constructor(index, name, boneData){
        this.color = new (0, $8804784813ffae81$export$892596cec99bc70e)(1, 1, 1, 1);
        if (index < 0) throw new Error("index must be >= 0.");
        if (name == null) throw new Error("name cannot be null.");
        if (boneData == null) throw new Error("boneData cannot be null.");
        this.index = index;
        this.name = name;
        this.boneData = boneData;
    }
}




class $8d84975dd7f91171$export$823fbc29771afdb5 {
    constructor(name){
        this.order = 0;
        this.bones = new Array();
        this.rotateMix = 0;
        this.translateMix = 0;
        this.scaleMix = 0;
        this.shearMix = 0;
        this.offsetRotation = 0;
        this.offsetX = 0;
        this.offsetY = 0;
        this.offsetScaleX = 0;
        this.offsetScaleY = 0;
        this.offsetShearY = 0;
        this.relative = false;
        this.local = false;
        if (name == null) throw new Error("name cannot be null.");
        this.name = name;
    }
}



class $d75f12246b931247$export$b8e0f93a76772233 {
    constructor(name){
        this.attachments = new Array();
        if (name == null) throw new Error("name cannot be null.");
        this.name = name;
    }
    addAttachment(slotIndex, name, attachment) {
        if (attachment == null) throw new Error("attachment cannot be null.");
        const attachments = this.attachments;
        if (slotIndex >= attachments.length) attachments.length = slotIndex + 1;
        if (!attachments[slotIndex]) attachments[slotIndex] = {};
        attachments[slotIndex][name] = attachment;
    }
    /** @return May be null. */ getAttachment(slotIndex, name) {
        const dictionary = this.attachments[slotIndex];
        return dictionary ? dictionary[name] : null;
    }
    /** Attach each attachment in this skin if the corresponding attachment in the old skin is currently attached. */ attachAll(skeleton, oldSkin) {
        let slotIndex = 0;
        for(let i = 0; i < skeleton.slots.length; i++){
            const slot = skeleton.slots[i];
            const slotAttachment = slot.getAttachment();
            if (slotAttachment && slotIndex < oldSkin.attachments.length) {
                const dictionary = oldSkin.attachments[slotIndex];
                for(const key in dictionary){
                    const skinAttachment = dictionary[key];
                    if (slotAttachment == skinAttachment) {
                        const attachment = this.getAttachment(slotIndex, key);
                        if (attachment != null) slot.setAttachment(attachment);
                        break;
                    }
                }
            }
            slotIndex++;
        }
    }
}






class $60109c85cd5986cc$export$8913b5e618c6d2f3 {
    constructor(attachmentLoader){
        this.scale = 1;
        this.linkedMeshes = new Array();
        this.attachmentLoader = attachmentLoader;
    }
    readSkeletonData(json) {
        const scale = this.scale;
        const skeletonData = new (0, $05cacac1abb1a224$export$e8f362f163550575)();
        const root = typeof json === "string" ? JSON.parse(json) : json;
        const skeletonMap = root.skeleton;
        if (skeletonMap != null) {
            skeletonData.hash = skeletonMap.hash;
            skeletonData.version = skeletonMap.spine;
            skeletonData.width = skeletonMap.width;
            skeletonData.height = skeletonMap.height;
            skeletonData.fps = skeletonMap.fps;
            skeletonData.imagesPath = skeletonMap.images;
        }
        if (root.bones) for(let i = 0; i < root.bones.length; i++){
            const boneMap = root.bones[i];
            let parent = null;
            const parentName = this.getValue(boneMap, "parent", null);
            if (parentName != null) {
                parent = skeletonData.findBone(parentName);
                if (parent == null) throw new Error(`Parent bone not found: ${parentName}`);
            }
            const data = new (0, $a5b6524b51430054$export$7d85d96cf093e12f)(skeletonData.bones.length, boneMap.name, parent);
            data.length = this.getValue(boneMap, "length", 0) * scale;
            data.x = this.getValue(boneMap, "x", 0) * scale;
            data.y = this.getValue(boneMap, "y", 0) * scale;
            data.rotation = this.getValue(boneMap, "rotation", 0);
            data.scaleX = this.getValue(boneMap, "scaleX", 1);
            data.scaleY = this.getValue(boneMap, "scaleY", 1);
            data.shearX = this.getValue(boneMap, "shearX", 0);
            data.shearY = this.getValue(boneMap, "shearY", 0);
            data.transformMode = $60109c85cd5986cc$export$8913b5e618c6d2f3.transformModeFromString(this.getValue(boneMap, "transform", "normal"));
            skeletonData.bones.push(data);
        }
        if (root.slots) for(let i = 0; i < root.slots.length; i++){
            const slotMap = root.slots[i];
            const slotName = slotMap.name;
            const boneName = slotMap.bone;
            const boneData = skeletonData.findBone(boneName);
            if (boneData == null) throw new Error(`Slot bone not found: ${boneName}`);
            const data = new (0, $5f798cbede6d2ed4$export$a4cce1bf50208679)(skeletonData.slots.length, slotName, boneData);
            const color = this.getValue(slotMap, "color", null);
            if (color != null) data.color.setFromString(color);
            const dark = this.getValue(slotMap, "dark", null);
            if (dark != null) {
                data.darkColor = new (0, $8804784813ffae81$export$892596cec99bc70e)(1, 1, 1, 1);
                data.darkColor.setFromString(dark);
            }
            data.attachmentName = this.getValue(slotMap, "attachment", null);
            data.blendMode = $60109c85cd5986cc$export$8913b5e618c6d2f3.blendModeFromString(this.getValue(slotMap, "blend", "normal"));
            skeletonData.slots.push(data);
        }
        if (root.ik) for(let i = 0; i < root.ik.length; i++){
            const constraintMap = root.ik[i];
            const data = new (0, $33de7df150c186a2$export$adcb08b651fc712e)(constraintMap.name);
            data.order = this.getValue(constraintMap, "order", 0);
            for(let j = 0; j < constraintMap.bones.length; j++){
                const boneName = constraintMap.bones[j];
                const bone = skeletonData.findBone(boneName);
                if (bone == null) throw new Error(`IK bone not found: ${boneName}`);
                data.bones.push(bone);
            }
            const targetName = constraintMap.target;
            data.target = skeletonData.findBone(targetName);
            if (data.target == null) throw new Error(`IK target bone not found: ${targetName}`);
            data.bendDirection = this.getValue(constraintMap, "bendPositive", true) ? 1 : -1;
            data.mix = this.getValue(constraintMap, "mix", 1);
            skeletonData.ikConstraints.push(data);
        }
        if (root.transform) for(let i = 0; i < root.transform.length; i++){
            const constraintMap = root.transform[i];
            const data = new (0, $8d84975dd7f91171$export$823fbc29771afdb5)(constraintMap.name);
            data.order = this.getValue(constraintMap, "order", 0);
            for(let j = 0; j < constraintMap.bones.length; j++){
                const boneName = constraintMap.bones[j];
                const bone = skeletonData.findBone(boneName);
                if (bone == null) throw new Error(`Transform constraint bone not found: ${boneName}`);
                data.bones.push(bone);
            }
            const targetName = constraintMap.target;
            data.target = skeletonData.findBone(targetName);
            if (data.target == null) throw new Error(`Transform constraint target bone not found: ${targetName}`);
            data.local = this.getValue(constraintMap, "local", false);
            data.relative = this.getValue(constraintMap, "relative", false);
            data.offsetRotation = this.getValue(constraintMap, "rotation", 0);
            data.offsetX = this.getValue(constraintMap, "x", 0) * scale;
            data.offsetY = this.getValue(constraintMap, "y", 0) * scale;
            data.offsetScaleX = this.getValue(constraintMap, "scaleX", 0);
            data.offsetScaleY = this.getValue(constraintMap, "scaleY", 0);
            data.offsetShearY = this.getValue(constraintMap, "shearY", 0);
            data.rotateMix = this.getValue(constraintMap, "rotateMix", 1);
            data.translateMix = this.getValue(constraintMap, "translateMix", 1);
            data.scaleMix = this.getValue(constraintMap, "scaleMix", 1);
            data.shearMix = this.getValue(constraintMap, "shearMix", 1);
            skeletonData.transformConstraints.push(data);
        }
        if (root.path) for(let i = 0; i < root.path.length; i++){
            const constraintMap = root.path[i];
            const data = new (0, $6be2e6fd947029e3$export$d2629ab80d5dd5ba)(constraintMap.name);
            data.order = this.getValue(constraintMap, "order", 0);
            for(let j = 0; j < constraintMap.bones.length; j++){
                const boneName = constraintMap.bones[j];
                const bone = skeletonData.findBone(boneName);
                if (bone == null) throw new Error(`Transform constraint bone not found: ${boneName}`);
                data.bones.push(bone);
            }
            const targetName = constraintMap.target;
            data.target = skeletonData.findSlot(targetName);
            if (data.target == null) throw new Error(`Path target slot not found: ${targetName}`);
            data.positionMode = $60109c85cd5986cc$export$8913b5e618c6d2f3.positionModeFromString(this.getValue(constraintMap, "positionMode", "percent"));
            data.spacingMode = $60109c85cd5986cc$export$8913b5e618c6d2f3.spacingModeFromString(this.getValue(constraintMap, "spacingMode", "length"));
            data.rotateMode = $60109c85cd5986cc$export$8913b5e618c6d2f3.rotateModeFromString(this.getValue(constraintMap, "rotateMode", "tangent"));
            data.offsetRotation = this.getValue(constraintMap, "rotation", 0);
            data.position = this.getValue(constraintMap, "position", 0);
            if (data.positionMode == (0, $2c8db927dc4fcff5$export$34d637c671e1e906).Fixed) data.position *= scale;
            data.spacing = this.getValue(constraintMap, "spacing", 0);
            if (data.spacingMode == (0, $6be2e6fd947029e3$export$34ce760ad2b0be4b).Length || data.spacingMode == (0, $6be2e6fd947029e3$export$34ce760ad2b0be4b).Fixed) data.spacing *= scale;
            data.rotateMix = this.getValue(constraintMap, "rotateMix", 1);
            data.translateMix = this.getValue(constraintMap, "translateMix", 1);
            skeletonData.pathConstraints.push(data);
        }
        if (root.skins) for(const skinName in root.skins){
            const skinMap = root.skins[skinName];
            const skin = new (0, $d75f12246b931247$export$b8e0f93a76772233)(skinName);
            for(const slotName in skinMap){
                const slotIndex = skeletonData.findSlotIndex(slotName);
                if (slotIndex == -1) throw new Error(`Slot not found: ${slotName}`);
                const slotMap = skinMap[slotName];
                for(const entryName in slotMap){
                    const attachment = this.readAttachment(slotMap[entryName], skin, slotIndex, entryName, skeletonData);
                    if (attachment != null) skin.addAttachment(slotIndex, entryName, attachment);
                }
            }
            skeletonData.skins.push(skin);
            if (skin.name == "default") skeletonData.defaultSkin = skin;
        }
        for(let i = 0, n = this.linkedMeshes.length; i < n; i++){
            const linkedMesh = this.linkedMeshes[i];
            const skin = linkedMesh.skin == null ? skeletonData.defaultSkin : skeletonData.findSkin(linkedMesh.skin);
            if (skin == null) throw new Error(`Skin not found: ${linkedMesh.skin}`);
            const parent = skin.getAttachment(linkedMesh.slotIndex, linkedMesh.parent);
            if (parent == null) throw new Error(`Parent mesh not found: ${linkedMesh.parent}`);
            linkedMesh.mesh.setParentMesh(parent);
        }
        this.linkedMeshes.length = 0;
        if (root.events) for(const eventName in root.events){
            const eventMap = root.events[eventName];
            const data = new (0, $a9b3b2867f4818f5$export$a5cf049e34c3d11e)(eventName);
            data.intValue = this.getValue(eventMap, "int", 0);
            data.floatValue = this.getValue(eventMap, "float", 0);
            data.stringValue = this.getValue(eventMap, "string", "");
            data.audioPath = this.getValue(eventMap, "audio", null);
            if (data.audioPath != null) {
                data.volume = this.getValue(eventMap, "volume", 1);
                data.balance = this.getValue(eventMap, "balance", 0);
            }
            skeletonData.events.push(data);
        }
        if (root.animations) for(const animationName in root.animations){
            const animationMap = root.animations[animationName];
            this.readAnimation(animationMap, animationName, skeletonData);
        }
        return skeletonData;
    }
    readAttachment(map, skin, slotIndex, name, skeletonData) {
        const scale = this.scale;
        name = this.getValue(map, "name", name);
        const type = this.getValue(map, "type", "region");
        switch(type){
            case "region":
                {
                    const path = this.getValue(map, "path", name);
                    const region = this.attachmentLoader.newRegionAttachment(skin, name, path);
                    if (region == null) return null;
                    region.path = path;
                    region.x = this.getValue(map, "x", 0) * scale;
                    region.y = this.getValue(map, "y", 0) * scale;
                    region.scaleX = this.getValue(map, "scaleX", 1);
                    region.scaleY = this.getValue(map, "scaleY", 1);
                    region.rotation = this.getValue(map, "rotation", 0);
                    region.width = map.width * scale;
                    region.height = map.height * scale;
                    const color = this.getValue(map, "color", null);
                    if (color != null) region.color.setFromString(color);
                    return region;
                }
            case "boundingbox":
                {
                    const box = this.attachmentLoader.newBoundingBoxAttachment(skin, name);
                    if (box == null) return null;
                    this.readVertices(map, box, map.vertexCount << 1);
                    const color = this.getValue(map, "color", null);
                    if (color != null) box.color.setFromString(color);
                    return box;
                }
            case "mesh":
            case "linkedmesh":
                {
                    const path = this.getValue(map, "path", name);
                    const mesh = this.attachmentLoader.newMeshAttachment(skin, name, path);
                    if (mesh == null) return null;
                    mesh.path = path;
                    const color = this.getValue(map, "color", null);
                    if (color != null) mesh.color.setFromString(color);
                    const parent = this.getValue(map, "parent", null);
                    if (parent != null) {
                        mesh.inheritDeform = this.getValue(map, "deform", true);
                        this.linkedMeshes.push(new $60109c85cd5986cc$var$LinkedMesh(mesh, this.getValue(map, "skin", null), slotIndex, parent));
                        return mesh;
                    }
                    const uvs = map.uvs;
                    this.readVertices(map, mesh, uvs.length);
                    mesh.triangles = map.triangles;
                    mesh.regionUVs = new Float32Array(uvs);
                    mesh.hullLength = this.getValue(map, "hull", 0) * 2;
                    return mesh;
                }
            case "path":
                {
                    const path = this.attachmentLoader.newPathAttachment(skin, name);
                    if (path == null) return null;
                    path.closed = this.getValue(map, "closed", false);
                    path.constantSpeed = this.getValue(map, "constantSpeed", true);
                    const vertexCount = map.vertexCount;
                    this.readVertices(map, path, vertexCount << 1);
                    const lengths = (0, $8804784813ffae81$export$d2ca453b913dcdea).newArray(vertexCount / 3, 0);
                    for(let i = 0; i < map.lengths.length; i++)lengths[i] = map.lengths[i] * scale;
                    path.lengths = lengths;
                    const color = this.getValue(map, "color", null);
                    if (color != null) path.color.setFromString(color);
                    return path;
                }
            case "point":
                {
                    const point = this.attachmentLoader.newPointAttachment(skin, name);
                    if (point == null) return null;
                    point.x = this.getValue(map, "x", 0) * scale;
                    point.y = this.getValue(map, "y", 0) * scale;
                    point.rotation = this.getValue(map, "rotation", 0);
                    const color = this.getValue(map, "color", null);
                    if (color != null) point.color.setFromString(color);
                    return point;
                }
            case "clipping":
                {
                    const clip = this.attachmentLoader.newClippingAttachment(skin, name);
                    if (clip == null) return null;
                    const end = this.getValue(map, "end", null);
                    if (end != null) {
                        const slot = skeletonData.findSlot(end);
                        if (slot == null) throw new Error(`Clipping end slot not found: ${end}`);
                        clip.endSlot = slot;
                    }
                    const vertexCount = map.vertexCount;
                    this.readVertices(map, clip, vertexCount << 1);
                    const color = this.getValue(map, "color", null);
                    if (color != null) clip.color.setFromString(color);
                    return clip;
                }
        }
        return null;
    }
    readVertices(map, attachment, verticesLength) {
        const scale = this.scale;
        attachment.worldVerticesLength = verticesLength;
        const vertices = map.vertices;
        if (verticesLength == vertices.length) {
            const scaledVertices = (0, $8804784813ffae81$export$d2ca453b913dcdea).toFloatArray(vertices);
            if (scale != 1) for(let i = 0, n = vertices.length; i < n; i++)scaledVertices[i] *= scale;
            attachment.vertices = scaledVertices;
            return;
        }
        const weights = new Array();
        const bones = new Array();
        for(let i = 0, n = vertices.length; i < n;){
            const boneCount = vertices[i++];
            bones.push(boneCount);
            for(let nn = i + boneCount * 4; i < nn; i += 4){
                bones.push(vertices[i]);
                weights.push(vertices[i + 1] * scale);
                weights.push(vertices[i + 2] * scale);
                weights.push(vertices[i + 3]);
            }
        }
        attachment.bones = bones;
        attachment.vertices = (0, $8804784813ffae81$export$d2ca453b913dcdea).toFloatArray(weights);
    }
    readAnimation(map, name, skeletonData) {
        const scale = this.scale;
        const timelines = new Array();
        let duration = 0;
        if (map.slots) for(const slotName in map.slots){
            const slotMap = map.slots[slotName];
            const slotIndex = skeletonData.findSlotIndex(slotName);
            if (slotIndex == -1) throw new Error(`Slot not found: ${slotName}`);
            for(const timelineName in slotMap){
                const timelineMap = slotMap[timelineName];
                if (timelineName == "attachment") {
                    const timeline = new (0, $5d5d4780b16fb6da$export$7f2bfc5bd27cb43d)(timelineMap.length);
                    timeline.slotIndex = slotIndex;
                    let frameIndex = 0;
                    for(let i = 0; i < timelineMap.length; i++){
                        const valueMap = timelineMap[i];
                        timeline.setFrame(frameIndex++, valueMap.time, valueMap.name);
                    }
                    timelines.push(timeline);
                    duration = Math.max(duration, timeline.frames[timeline.getFrameCount() - 1]);
                } else if (timelineName == "color") {
                    const timeline = new (0, $5d5d4780b16fb6da$export$565fcb3610070d7f)(timelineMap.length);
                    timeline.slotIndex = slotIndex;
                    let frameIndex = 0;
                    for(let i = 0; i < timelineMap.length; i++){
                        const valueMap = timelineMap[i];
                        const color = new (0, $8804784813ffae81$export$892596cec99bc70e)();
                        color.setFromString(valueMap.color || "ffffffff");
                        timeline.setFrame(frameIndex, valueMap.time, color.r, color.g, color.b, color.a);
                        this.readCurve(valueMap, timeline, frameIndex);
                        frameIndex++;
                    }
                    timelines.push(timeline);
                    duration = Math.max(duration, timeline.frames[(timeline.getFrameCount() - 1) * (0, $5d5d4780b16fb6da$export$565fcb3610070d7f).ENTRIES]);
                } else if (timelineName == "twoColor") {
                    const timeline = new (0, $5d5d4780b16fb6da$export$938c1752e1b56539)(timelineMap.length);
                    timeline.slotIndex = slotIndex;
                    let frameIndex = 0;
                    for(let i = 0; i < timelineMap.length; i++){
                        const valueMap = timelineMap[i];
                        const light = new (0, $8804784813ffae81$export$892596cec99bc70e)();
                        const dark = new (0, $8804784813ffae81$export$892596cec99bc70e)();
                        light.setFromString(valueMap.light);
                        dark.setFromString(valueMap.dark);
                        timeline.setFrame(frameIndex, valueMap.time, light.r, light.g, light.b, light.a, dark.r, dark.g, dark.b);
                        this.readCurve(valueMap, timeline, frameIndex);
                        frameIndex++;
                    }
                    timelines.push(timeline);
                    duration = Math.max(duration, timeline.frames[(timeline.getFrameCount() - 1) * (0, $5d5d4780b16fb6da$export$938c1752e1b56539).ENTRIES]);
                } else throw new Error(`Invalid timeline type for a slot: ${timelineName} (${slotName})`);
            }
        }
        if (map.bones) for(const boneName in map.bones){
            const boneMap = map.bones[boneName];
            const boneIndex = skeletonData.findBoneIndex(boneName);
            if (boneIndex == -1) throw new Error(`Bone not found: ${boneName}`);
            for(const timelineName in boneMap){
                const timelineMap = boneMap[timelineName];
                if (timelineName === "rotate") {
                    const timeline = new (0, $5d5d4780b16fb6da$export$b7ecb8f68b3e130b)(timelineMap.length);
                    timeline.boneIndex = boneIndex;
                    let frameIndex = 0;
                    for(let i = 0; i < timelineMap.length; i++){
                        const valueMap = timelineMap[i];
                        timeline.setFrame(frameIndex, valueMap.time, valueMap.angle);
                        this.readCurve(valueMap, timeline, frameIndex);
                        frameIndex++;
                    }
                    timelines.push(timeline);
                    duration = Math.max(duration, timeline.frames[(timeline.getFrameCount() - 1) * (0, $5d5d4780b16fb6da$export$b7ecb8f68b3e130b).ENTRIES]);
                } else if (timelineName === "translate" || timelineName === "scale" || timelineName === "shear") {
                    let timeline = null;
                    let timelineScale = 1;
                    if (timelineName === "scale") timeline = new (0, $5d5d4780b16fb6da$export$be544e22f6ad7737)(timelineMap.length);
                    else if (timelineName === "shear") timeline = new (0, $5d5d4780b16fb6da$export$4da82436a1a0d773)(timelineMap.length);
                    else {
                        timeline = new (0, $5d5d4780b16fb6da$export$eb93bf27829ae703)(timelineMap.length);
                        timelineScale = scale;
                    }
                    timeline.boneIndex = boneIndex;
                    let frameIndex = 0;
                    for(let i = 0; i < timelineMap.length; i++){
                        const valueMap = timelineMap[i];
                        const x = this.getValue(valueMap, "x", 0);
                        const y = this.getValue(valueMap, "y", 0);
                        timeline.setFrame(frameIndex, valueMap.time, x * timelineScale, y * timelineScale);
                        this.readCurve(valueMap, timeline, frameIndex);
                        frameIndex++;
                    }
                    timelines.push(timeline);
                    duration = Math.max(duration, timeline.frames[(timeline.getFrameCount() - 1) * (0, $5d5d4780b16fb6da$export$eb93bf27829ae703).ENTRIES]);
                } else throw new Error(`Invalid timeline type for a bone: ${timelineName} (${boneName})`);
            }
        }
        if (map.ik) for(const constraintName in map.ik){
            const constraintMap = map.ik[constraintName];
            const constraint = skeletonData.findIkConstraint(constraintName);
            const timeline = new (0, $5d5d4780b16fb6da$export$73d125cd89dead44)(constraintMap.length);
            timeline.ikConstraintIndex = skeletonData.ikConstraints.indexOf(constraint);
            let frameIndex = 0;
            for(let i = 0; i < constraintMap.length; i++){
                const valueMap = constraintMap[i];
                timeline.setFrame(frameIndex, valueMap.time, this.getValue(valueMap, "mix", 1), this.getValue(valueMap, "bendPositive", true) ? 1 : -1, this.getValue(valueMap, "compress", false), this.getValue(valueMap, "stretch", false));
                this.readCurve(valueMap, timeline, frameIndex);
                frameIndex++;
            }
            timelines.push(timeline);
            duration = Math.max(duration, timeline.frames[(timeline.getFrameCount() - 1) * (0, $5d5d4780b16fb6da$export$73d125cd89dead44).ENTRIES]);
        }
        if (map.transform) for(const constraintName in map.transform){
            const constraintMap = map.transform[constraintName];
            const constraint = skeletonData.findTransformConstraint(constraintName);
            const timeline = new (0, $5d5d4780b16fb6da$export$a7a393c2ad815ac7)(constraintMap.length);
            timeline.transformConstraintIndex = skeletonData.transformConstraints.indexOf(constraint);
            let frameIndex = 0;
            for(let i = 0; i < constraintMap.length; i++){
                const valueMap = constraintMap[i];
                timeline.setFrame(frameIndex, valueMap.time, this.getValue(valueMap, "rotateMix", 1), this.getValue(valueMap, "translateMix", 1), this.getValue(valueMap, "scaleMix", 1), this.getValue(valueMap, "shearMix", 1));
                this.readCurve(valueMap, timeline, frameIndex);
                frameIndex++;
            }
            timelines.push(timeline);
            duration = Math.max(duration, timeline.frames[(timeline.getFrameCount() - 1) * (0, $5d5d4780b16fb6da$export$a7a393c2ad815ac7).ENTRIES]);
        }
        if (map.paths) for(const constraintName in map.paths){
            const constraintMap = map.paths[constraintName];
            const index = skeletonData.findPathConstraintIndex(constraintName);
            if (index == -1) throw new Error(`Path constraint not found: ${constraintName}`);
            const data = skeletonData.pathConstraints[index];
            for(const timelineName in constraintMap){
                const timelineMap = constraintMap[timelineName];
                if (timelineName === "position" || timelineName === "spacing") {
                    let timeline = null;
                    let timelineScale = 1;
                    if (timelineName === "spacing") {
                        timeline = new (0, $5d5d4780b16fb6da$export$17ee50c08a07e62b)(timelineMap.length);
                        if (data.spacingMode == (0, $6be2e6fd947029e3$export$34ce760ad2b0be4b).Length || data.spacingMode == (0, $6be2e6fd947029e3$export$34ce760ad2b0be4b).Fixed) timelineScale = scale;
                    } else {
                        timeline = new (0, $5d5d4780b16fb6da$export$7ce7e67fd9cc52ed)(timelineMap.length);
                        if (data.positionMode == (0, $2c8db927dc4fcff5$export$34d637c671e1e906).Fixed) timelineScale = scale;
                    }
                    timeline.pathConstraintIndex = index;
                    let frameIndex = 0;
                    for(let i = 0; i < timelineMap.length; i++){
                        const valueMap = timelineMap[i];
                        timeline.setFrame(frameIndex, valueMap.time, this.getValue(valueMap, timelineName, 0) * timelineScale);
                        this.readCurve(valueMap, timeline, frameIndex);
                        frameIndex++;
                    }
                    timelines.push(timeline);
                    duration = Math.max(duration, timeline.frames[(timeline.getFrameCount() - 1) * (0, $5d5d4780b16fb6da$export$7ce7e67fd9cc52ed).ENTRIES]);
                } else if (timelineName === "mix") {
                    const timeline = new (0, $5d5d4780b16fb6da$export$ea67b41755485038)(timelineMap.length);
                    timeline.pathConstraintIndex = index;
                    let frameIndex = 0;
                    for(let i = 0; i < timelineMap.length; i++){
                        const valueMap = timelineMap[i];
                        timeline.setFrame(frameIndex, valueMap.time, this.getValue(valueMap, "rotateMix", 1), this.getValue(valueMap, "translateMix", 1));
                        this.readCurve(valueMap, timeline, frameIndex);
                        frameIndex++;
                    }
                    timelines.push(timeline);
                    duration = Math.max(duration, timeline.frames[(timeline.getFrameCount() - 1) * (0, $5d5d4780b16fb6da$export$ea67b41755485038).ENTRIES]);
                }
            }
        }
        if (map.deform) for(const deformName in map.deform){
            const deformMap = map.deform[deformName];
            const skin = skeletonData.findSkin(deformName);
            if (skin == null) {
                if ((0, $1840f66876ded594$export$a5a6e0b888b2c992).FAIL_ON_NON_EXISTING_SKIN) throw new Error(`Skin not found: ${deformName}`);
                else continue;
            }
            for(const slotName in deformMap){
                const slotMap = deformMap[slotName];
                const slotIndex = skeletonData.findSlotIndex(slotName);
                if (slotIndex == -1) throw new Error(`Slot not found: ${slotMap.name}`);
                for(const timelineName in slotMap){
                    const timelineMap = slotMap[timelineName];
                    const attachment = skin.getAttachment(slotIndex, timelineName);
                    if (attachment == null) throw new Error(`Deform attachment not found: ${timelineMap.name}`);
                    const weighted = attachment.bones != null;
                    const vertices = attachment.vertices;
                    const deformLength = weighted ? vertices.length / 3 * 2 : vertices.length;
                    const timeline = new (0, $5d5d4780b16fb6da$export$6968d40e5689ad6b)(timelineMap.length);
                    timeline.slotIndex = slotIndex;
                    timeline.attachment = attachment;
                    let frameIndex = 0;
                    for(let j = 0; j < timelineMap.length; j++){
                        const valueMap = timelineMap[j];
                        let deform;
                        const verticesValue = this.getValue(valueMap, "vertices", null);
                        if (verticesValue == null) deform = weighted ? (0, $8804784813ffae81$export$d2ca453b913dcdea).newFloatArray(deformLength) : vertices;
                        else {
                            deform = (0, $8804784813ffae81$export$d2ca453b913dcdea).newFloatArray(deformLength);
                            const start = this.getValue(valueMap, "offset", 0);
                            (0, $8804784813ffae81$export$d2ca453b913dcdea).arrayCopy(verticesValue, 0, deform, start, verticesValue.length);
                            if (scale != 1) for(let i = start, n = i + verticesValue.length; i < n; i++)deform[i] *= scale;
                            if (!weighted) for(let i = 0; i < deformLength; i++)deform[i] += vertices[i];
                        }
                        timeline.setFrame(frameIndex, valueMap.time, deform);
                        this.readCurve(valueMap, timeline, frameIndex);
                        frameIndex++;
                    }
                    timelines.push(timeline);
                    duration = Math.max(duration, timeline.frames[timeline.getFrameCount() - 1]);
                }
            }
        }
        let drawOrderNode = map.drawOrder;
        if (drawOrderNode == null) drawOrderNode = map.draworder;
        if (drawOrderNode != null) {
            const timeline = new (0, $5d5d4780b16fb6da$export$ece1f7c41d051e83)(drawOrderNode.length);
            const slotCount = skeletonData.slots.length;
            let frameIndex = 0;
            for(let j = 0; j < drawOrderNode.length; j++){
                const drawOrderMap = drawOrderNode[j];
                let drawOrder = null;
                const offsets = this.getValue(drawOrderMap, "offsets", null);
                if (offsets != null) {
                    drawOrder = (0, $8804784813ffae81$export$d2ca453b913dcdea).newArray(slotCount, -1);
                    const unchanged = (0, $8804784813ffae81$export$d2ca453b913dcdea).newArray(slotCount - offsets.length, 0);
                    let originalIndex = 0;
                    let unchangedIndex = 0;
                    for(let i = 0; i < offsets.length; i++){
                        const offsetMap = offsets[i];
                        const slotIndex = skeletonData.findSlotIndex(offsetMap.slot);
                        if (slotIndex == -1) throw new Error(`Slot not found: ${offsetMap.slot}`);
                        while(originalIndex != slotIndex)unchanged[unchangedIndex++] = originalIndex++;
                        drawOrder[originalIndex + offsetMap.offset] = originalIndex++;
                    }
                    while(originalIndex < slotCount)unchanged[unchangedIndex++] = originalIndex++;
                    for(let i = slotCount - 1; i >= 0; i--)if (drawOrder[i] == -1) drawOrder[i] = unchanged[--unchangedIndex];
                }
                timeline.setFrame(frameIndex++, drawOrderMap.time, drawOrder);
            }
            timelines.push(timeline);
            duration = Math.max(duration, timeline.frames[timeline.getFrameCount() - 1]);
        }
        if (map.events) {
            const timeline = new (0, $5d5d4780b16fb6da$export$4f4bca996c586084)(map.events.length);
            let frameIndex = 0;
            for(let i = 0; i < map.events.length; i++){
                const eventMap = map.events[i];
                const eventData = skeletonData.findEvent(eventMap.name);
                if (eventData == null) throw new Error(`Event not found: ${eventMap.name}`);
                const event = new (0, $c7ea2d215007ce13$export$d61e24a684f9e51)((0, $8804784813ffae81$export$d2ca453b913dcdea).toSinglePrecision(eventMap.time), eventData);
                event.intValue = this.getValue(eventMap, "int", eventData.intValue);
                event.floatValue = this.getValue(eventMap, "float", eventData.floatValue);
                event.stringValue = this.getValue(eventMap, "string", eventData.stringValue);
                if (event.data.audioPath != null) {
                    event.volume = this.getValue(eventMap, "volume", 1);
                    event.balance = this.getValue(eventMap, "balance", 0);
                }
                timeline.setFrame(frameIndex++, event);
            }
            timelines.push(timeline);
            duration = Math.max(duration, timeline.frames[timeline.getFrameCount() - 1]);
        }
        if (isNaN(duration)) throw new Error("Error while parsing animation, duration is NaN");
        skeletonData.animations.push(new (0, $5d5d4780b16fb6da$export$c35d437ae5945fcd)(name, timelines, duration));
    }
    readCurve(map, timeline, frameIndex) {
        if (!map.curve) return;
        if (map.curve === "stepped") timeline.setStepped(frameIndex);
        else if (Object.prototype.toString.call(map.curve) === "[object Array]") {
            const curve = map.curve;
            timeline.setCurve(frameIndex, curve[0], curve[1], curve[2], curve[3]);
        }
    }
    getValue(map, prop, defaultValue) {
        return map[prop] !== void 0 ? map[prop] : defaultValue;
    }
    static blendModeFromString(str) {
        str = str.toLowerCase();
        if (str == "normal") return (0, $0fa4b07f86297abd$export$f821c68fe9beaecf).NORMAL;
        if (str == "additive") return (0, $0fa4b07f86297abd$export$f821c68fe9beaecf).ADD;
        if (str == "multiply") return (0, $0fa4b07f86297abd$export$f821c68fe9beaecf).MULTIPLY;
        if (str == "screen") return (0, $0fa4b07f86297abd$export$f821c68fe9beaecf).SCREEN;
        throw new Error(`Unknown blend mode: ${str}`);
    }
    static positionModeFromString(str) {
        str = str.toLowerCase();
        if (str == "fixed") return (0, $2c8db927dc4fcff5$export$34d637c671e1e906).Fixed;
        if (str == "percent") return (0, $2c8db927dc4fcff5$export$34d637c671e1e906).Percent;
        throw new Error(`Unknown position mode: ${str}`);
    }
    static spacingModeFromString(str) {
        str = str.toLowerCase();
        if (str == "length") return (0, $6be2e6fd947029e3$export$34ce760ad2b0be4b).Length;
        if (str == "fixed") return (0, $6be2e6fd947029e3$export$34ce760ad2b0be4b).Fixed;
        if (str == "percent") return (0, $6be2e6fd947029e3$export$34ce760ad2b0be4b).Percent;
        throw new Error(`Unknown position mode: ${str}`);
    }
    static rotateModeFromString(str) {
        str = str.toLowerCase();
        if (str == "tangent") return (0, $2c8db927dc4fcff5$export$a2a23846581ac82c).Tangent;
        if (str == "chain") return (0, $2c8db927dc4fcff5$export$a2a23846581ac82c).Chain;
        if (str == "chainscale") return (0, $2c8db927dc4fcff5$export$a2a23846581ac82c).ChainScale;
        throw new Error(`Unknown rotate mode: ${str}`);
    }
    static transformModeFromString(str) {
        str = str.toLowerCase();
        if (str == "normal") return (0, $ccc5aebc60cbf024$export$4c408f82786a534d).Normal;
        if (str == "onlytranslation") return (0, $ccc5aebc60cbf024$export$4c408f82786a534d).OnlyTranslation;
        if (str == "norotationorreflection") return (0, $ccc5aebc60cbf024$export$4c408f82786a534d).NoRotationOrReflection;
        if (str == "noscale") return (0, $ccc5aebc60cbf024$export$4c408f82786a534d).NoScale;
        if (str == "noscaleorreflection") return (0, $ccc5aebc60cbf024$export$4c408f82786a534d).NoScaleOrReflection;
        throw new Error(`Unknown transform mode: ${str}`);
    }
}
class $60109c85cd5986cc$var$LinkedMesh {
    constructor(mesh, skin, slotIndex, parent){
        this.mesh = mesh;
        this.skin = skin;
        this.slotIndex = slotIndex;
        this.parent = parent;
    }
}











class $e6d9166e037f46b1$export$ce0a100797286aea extends (0, $c67a865880ede3c3$export$4093f9922f3d2512) {
    createSkeleton(spineData) {
        this.skeleton = new (0, $6eee187fdca9d523$export$8f31e4c4a37b8e9c)(spineData);
        this.skeleton.updateWorldTransform();
        this.stateData = new (0, $2694fad3c1cf0f47$export$90d7167cc0605975)(spineData);
        this.state = new (0, $aaa386b4abc834f7$export$d0f7a26c90cc1562)(this.stateData);
    }
}





var $c36116a636cd0925$export$aa3a45d54d39384c = /* @__PURE__ */ ((SPINE_VERSION2)=>{
    SPINE_VERSION2[SPINE_VERSION2["UNKNOWN"] = 0] = "UNKNOWN";
    SPINE_VERSION2[SPINE_VERSION2["VER37"] = 37] = "VER37";
    SPINE_VERSION2[SPINE_VERSION2["VER38"] = 38] = "VER38";
    SPINE_VERSION2[SPINE_VERSION2["VER40"] = 40] = "VER40";
    SPINE_VERSION2[SPINE_VERSION2["VER41"] = 41] = "VER41";
    return SPINE_VERSION2;
})($c36116a636cd0925$export$aa3a45d54d39384c || {});
function $c36116a636cd0925$export$b5e17f9aea446f74(version) {
    const ver3 = version.substr(0, 3);
    const verNum = Math.floor(Number(ver3) * 10 + 1e-3);
    if (ver3 === "3.7") return 37 /* VER37 */ ;
    if (ver3 === "3.8") return 38 /* VER38 */ ;
    if (ver3 === "4.0") return 40 /* VER40 */ ;
    if (ver3 === "4.1") return 41 /* VER41 */ ;
    if (verNum < 37 /* VER37 */ ) return 37 /* VER37 */ ;
    return 0 /* UNKNOWN */ ;
}


class $ec209fb39e89cf8f$var$UniBinaryParser {
    constructor(){
        this.scale = 1;
    }
    readSkeletonData(atlas, dataToParse) {
        let parser = null;
        let version = this.readVersionOldFormat(dataToParse);
        let ver = (0, $c36116a636cd0925$export$b5e17f9aea446f74)(version);
        if (ver === (0, $c36116a636cd0925$export$aa3a45d54d39384c).VER38) parser = new $cd7869ac723b60bd$export$a7f7eaf4e9fce9ef(new $951b74e6d7b02e7a$export$2ff9add835475d95(atlas));
        version = this.readVersionNewFormat(dataToParse);
        ver = (0, $c36116a636cd0925$export$b5e17f9aea446f74)(version);
        if (ver === (0, $c36116a636cd0925$export$aa3a45d54d39384c).VER40 || ver === (0, $c36116a636cd0925$export$aa3a45d54d39384c).VER41) parser = new $64725297a8c20f8e$export$a7f7eaf4e9fce9ef(new $e1f9342c07c31bce$export$2ff9add835475d95(atlas));
        if (!parser) {
            const error = `Unsupported version of spine model ${version}, please update pixi-spine`;
            console.error(error);
        }
        parser.scale = this.scale;
        return parser.readSkeletonData(dataToParse);
    }
    readVersionOldFormat(dataToParse) {
        const input = new (0, $76f67eeea63ddac1$export$c8e921ea3330f774)(dataToParse);
        let version;
        try {
            input.readString();
            version = input.readString();
        } catch (e) {
            version = "";
        }
        return version || "";
    }
    readVersionNewFormat(dataToParse) {
        const input = new (0, $76f67eeea63ddac1$export$c8e921ea3330f774)(dataToParse);
        input.readInt32();
        input.readInt32();
        let version;
        try {
            version = input.readString();
        } catch (e) {
            version = "";
        }
        return version || "";
    }
}
class $ec209fb39e89cf8f$var$UniJsonParser {
    constructor(){
        this.scale = 1;
    }
    readSkeletonData(atlas, dataToParse) {
        const version = dataToParse.skeleton.spine;
        const ver = (0, $c36116a636cd0925$export$b5e17f9aea446f74)(version);
        let parser = null;
        if (ver === (0, $c36116a636cd0925$export$aa3a45d54d39384c).VER37) parser = new $60109c85cd5986cc$export$8913b5e618c6d2f3(new $396085795b03eddd$export$2ff9add835475d95(atlas));
        if (ver === (0, $c36116a636cd0925$export$aa3a45d54d39384c).VER38) parser = new $d82ca02a4894c3a8$export$8913b5e618c6d2f3(new $951b74e6d7b02e7a$export$2ff9add835475d95(atlas));
        if (ver === (0, $c36116a636cd0925$export$aa3a45d54d39384c).VER40 || ver === (0, $c36116a636cd0925$export$aa3a45d54d39384c).VER41) parser = new $3cdefcdf845023bf$export$8913b5e618c6d2f3(new $e1f9342c07c31bce$export$2ff9add835475d95(atlas));
        if (!parser) {
            const error = `Unsupported version of spine model ${version}, please update pixi-spine`;
            console.error(error);
        }
        parser.scale = this.scale;
        return parser.readSkeletonData(dataToParse);
    }
}
class $ec209fb39e89cf8f$export$48f69e82f36f1e74 extends (0, $eaeac13ae525399a$export$2a2aa2d35c27e626) {
    createBinaryParser() {
        return new $ec209fb39e89cf8f$var$UniBinaryParser();
    }
    createJsonParser() {
        return new $ec209fb39e89cf8f$var$UniJsonParser();
    }
    parseData(parser, atlas, dataToParse) {
        const parserCast = parser;
        return {
            spineData: parserCast.readSkeletonData(atlas, dataToParse),
            spineAtlas: atlas
        };
    }
}







class $9cd20aaea4b5b967$export$ce0a100797286aea extends (0, $c67a865880ede3c3$export$4093f9922f3d2512) {
    createSkeleton(spineData) {
        const ver = (0, $c36116a636cd0925$export$b5e17f9aea446f74)(spineData.version);
        let spine = null;
        if (ver === (0, $c36116a636cd0925$export$aa3a45d54d39384c).VER37) spine = $1c5acf04f9b75c28$exports;
        if (ver === (0, $c36116a636cd0925$export$aa3a45d54d39384c).VER38) spine = $2ae1fe659dc46dd2$exports;
        if (ver === (0, $c36116a636cd0925$export$aa3a45d54d39384c).VER40 || ver === (0, $c36116a636cd0925$export$aa3a45d54d39384c).VER41) spine = $d2df721d77c502e4$exports;
        if (!spine) {
            const error = `Cant detect version of spine model ${spineData.version}`;
            console.error(error);
        }
        this.skeleton = new spine.Skeleton(spineData);
        this.skeleton.updateWorldTransform();
        this.stateData = new spine.AnimationStateData(spineData);
        this.state = new spine.AnimationState(this.stateData);
    }
}



new (0, $ec209fb39e89cf8f$export$48f69e82f36f1e74)().installLoader();








const $5e6922f6744fcb9a$export$b8b10c7c42429e76 = async (canvas, config, onLoaderProgress)=>{
    if (!canvas) return;
    (0, $2ae84a41eb5f30ec$export$8e361a1ffbebf172).external = {
        ...config
    };
    (0, $2ae84a41eb5f30ec$export$8e361a1ffbebf172).exited = false;
    //PIXI.settings.SCALE_MODE = PIXI.SCALE_MODES.LINEAR
    $2808efac47e52be0$export$a5a6e0b888b2c992.PREFER_ENV = $0fa4b07f86297abd$export$83401e34d5e11bf4.WEBGL2;
    $48ce8a7de6645907$export$29d3e417456abdad.curves.maxLength = 3;
    const parent = canvas.parentElement;
    const app = new $f3c45d23c8a4ee00$export$16975c34e60e1e61({
        view: canvas,
        resolution: Math.max(2, window.devicePixelRatio),
        autoDensity: true,
        antialias: false,
        powerPreference: "high-performance",
        clearBeforeRender: false,
        resizeTo: parent,
        backgroundAlpha: 0
    });
    const defaultIcon = `url('${(0, $0426e2dd5e0de94d$export$24af3971dd36b33f)}/ui/cursor.png') 16 22, auto`;
    app.renderer.events.cursorStyles.default = defaultIcon;
    (0, $2ae84a41eb5f30ec$export$8e361a1ffbebf172).app = app;
    app.stage.eventMode = "static";
    app.ticker.stop();
    const loader = $f9c1af74ba91db41$export$c8eca95e306f7116;
    const gsapTicker = ()=>{
        if ((0, $2ae84a41eb5f30ec$export$8e361a1ffbebf172).exited) return;
        app.ticker.update();
    };
    // Now, we use 'tick' from gsap
    (0, $52be045d3cbb2b80$export$99ee26438460406a).ticker.add(gsapTicker);
    (0, $2ae84a41eb5f30ec$export$8e361a1ffbebf172).external.clearGame = async ()=>{
        console.log("CLEAR GAME");
        (0, $2ae84a41eb5f30ec$export$8e361a1ffbebf172).exited = true;
        (0, $52be045d3cbb2b80$export$99ee26438460406a).ticker.sleep();
        (0, $05e42dce750e973a$export$665e313beff80f41)();
        (0, $05e42dce750e973a$export$1197e9ca544859c8)();
        app.renderer.clear();
        app.stage.removeChildren();
        (0, $2ae84a41eb5f30ec$export$8e361a1ffbebf172).viewport?.destroy();
        (0, $52a374576fbfc221$export$eab32dcfc4ded11c).stopAll();
        if ((0, $2ae84a41eb5f30ec$export$8e361a1ffbebf172).room) await (0, $8b91dc769ad86d51$export$aba067a2a21e981e)();
        (0, $2ae84a41eb5f30ec$export$efbfeda1e6657cf0)();
        if (config.clearGame) config.clearGame();
    };
    const ceesHand = new (0, (/*@__PURE__*/$parcel$interopDefault($45b41de5de61a03d$exports)))("Cees Hand");
    const moreSugar = new (0, (/*@__PURE__*/$parcel$interopDefault($45b41de5de61a03d$exports)))("More Sugar");
    const supersonicRocketship = new (0, (/*@__PURE__*/$parcel$interopDefault($45b41de5de61a03d$exports)))("Supersonic Rocketship");
    loader.addBundle("oogy", {
        // GLOBAL
        logo: `${(0, $0426e2dd5e0de94d$export$24af3971dd36b33f)}/ui/logo.png`,
        // UI
        trophy: `${(0, $0426e2dd5e0de94d$export$24af3971dd36b33f)}/ui/trophy.png`,
        gem: `${(0, $0426e2dd5e0de94d$export$24af3971dd36b33f)}/ui/gem.png`,
        "white-oogy": `${(0, $0426e2dd5e0de94d$export$24af3971dd36b33f)}/ui/white-oogy.png`,
        "star-light": `${(0, $0426e2dd5e0de94d$export$24af3971dd36b33f)}/ui/star-light.png`,
        // LEVEL
        //'level-bg': `${OOGY_VISUAL_CDN_URL}/level/bg.png`,
        "level-bg-sand": `${(0, $0426e2dd5e0de94d$export$24af3971dd36b33f)}/level/bg/sand.jpg`,
        "level-bg-zombie": `${(0, $0426e2dd5e0de94d$export$24af3971dd36b33f)}/level/bg/zombie.jpg`,
        "level-bg-clay": `${(0, $0426e2dd5e0de94d$export$24af3971dd36b33f)}/level/bg/clay.jpg`,
        "level-bg-crop": `${(0, $0426e2dd5e0de94d$export$24af3971dd36b33f)}/level/bg/crop.jpg`,
        "level-bg-field": `${(0, $0426e2dd5e0de94d$export$24af3971dd36b33f)}/level/bg/field.jpg`,
        "level-bg-forest": `${(0, $0426e2dd5e0de94d$export$24af3971dd36b33f)}/level/bg/forest.jpg`,
        "level-bg-lava": `${(0, $0426e2dd5e0de94d$export$24af3971dd36b33f)}/level/bg/lava.jpg`,
        "level-bg-polar": `${(0, $0426e2dd5e0de94d$export$24af3971dd36b33f)}/level/bg/polar.jpg`,
        "level-bg-temple": `${(0, $0426e2dd5e0de94d$export$24af3971dd36b33f)}/level/bg/temple.jpg`,
        "level-bg-ore": `${(0, $0426e2dd5e0de94d$export$24af3971dd36b33f)}/level/bg/ore.jpg`,
        "level-bg-goo": `${(0, $0426e2dd5e0de94d$export$24af3971dd36b33f)}/level/bg/goo.jpg`,
        "level-bg-dirt": `${(0, $0426e2dd5e0de94d$export$24af3971dd36b33f)}/level/bg/dirt.jpg`,
        "level-bg-bricks": `${(0, $0426e2dd5e0de94d$export$24af3971dd36b33f)}/level/bg/bricks.jpg`,
        "level-bg-plates": `${(0, $0426e2dd5e0de94d$export$24af3971dd36b33f)}/level/bg/plates.jpg`,
        "level-bg-lab": `${(0, $0426e2dd5e0de94d$export$24af3971dd36b33f)}/level/bg/lab.jpg`,
        "level-bg-street": `${(0, $0426e2dd5e0de94d$export$24af3971dd36b33f)}/level/bg/street.jpg`,
        "level-bg-junkyard": `${(0, $0426e2dd5e0de94d$export$24af3971dd36b33f)}/level/bg/junkyard.jpg`,
        "level-bg-blocks": `${(0, $0426e2dd5e0de94d$export$24af3971dd36b33f)}/level/bg/blocks.jpg`,
        "level-bg-soil": `${(0, $0426e2dd5e0de94d$export$24af3971dd36b33f)}/level/bg/soil.jpg`,
        "level-bg-swamp": `${(0, $0426e2dd5e0de94d$export$24af3971dd36b33f)}/level/bg/swamp.jpg`,
        "level-bg-mars": `${(0, $0426e2dd5e0de94d$export$24af3971dd36b33f)}/level/bg/mars.jpg`,
        "level-bg-moon": `${(0, $0426e2dd5e0de94d$export$24af3971dd36b33f)}/level/bg/moon.jpg`,
        "level-bg-meltdown": `${(0, $0426e2dd5e0de94d$export$24af3971dd36b33f)}/level/bg/meltdown.jpg`,
        "level-bg-metal_floor": `${(0, $0426e2dd5e0de94d$export$24af3971dd36b33f)}/level/bg/metal_floor.jpg`,
        "level-bg-power_cell": `${(0, $0426e2dd5e0de94d$export$24af3971dd36b33f)}/level/bg/power_cell.jpg`,
        menu: `${(0, $0426e2dd5e0de94d$export$24af3971dd36b33f)}/level/menu-button.png`,
        skull: `${(0, $0426e2dd5e0de94d$export$24af3971dd36b33f)}/level/skull.png`,
        coin: `${(0, $0426e2dd5e0de94d$export$24af3971dd36b33f)}/level/coin.png`,
        clock: `${(0, $0426e2dd5e0de94d$export$24af3971dd36b33f)}/level/clock.png`,
        monster: `${(0, $0426e2dd5e0de94d$export$24af3971dd36b33f)}/level/monster.png`,
        icecube: `${(0, $0426e2dd5e0de94d$export$24af3971dd36b33f)}/level/icecube.png`,
        "clock-container": `${(0, $0426e2dd5e0de94d$export$24af3971dd36b33f)}/level/clock-container.png`,
        "score-container": `${(0, $0426e2dd5e0de94d$export$24af3971dd36b33f)}/level/score-container.png`,
        "level-progress": `${(0, $0426e2dd5e0de94d$export$24af3971dd36b33f)}/level/level-progress.png`,
        //'level-bars': `${OOGY_VISUAL_CDN_URL}/level/level-bars.png`,
        "level-bar-bg": `${(0, $0426e2dd5e0de94d$export$24af3971dd36b33f)}/level/level-bar-bg.jpg`,
        "level-flask": `${(0, $0426e2dd5e0de94d$export$24af3971dd36b33f)}/level/level-flask.png`,
        star: `${(0, $0426e2dd5e0de94d$export$24af3971dd36b33f)}/level/star.png`,
        "item-small-xp": `${(0, $0426e2dd5e0de94d$export$24af3971dd36b33f)}/level/small-xp.png`,
        "item-big-xp": `${(0, $0426e2dd5e0de94d$export$24af3971dd36b33f)}/level/big-xp.png`,
        "item-heal": `${(0, $0426e2dd5e0de94d$export$24af3971dd36b33f)}/level/heal.png`,
        "item-shield": `${(0, $0426e2dd5e0de94d$export$24af3971dd36b33f)}/level/shield.png`,
        "item-bomb": `${(0, $0426e2dd5e0de94d$export$24af3971dd36b33f)}/level/bomb.png`,
        "item-gem": `${(0, $0426e2dd5e0de94d$export$24af3971dd36b33f)}/ui/gem.png`,
        "blue-bullet": `${(0, $0426e2dd5e0de94d$export$24af3971dd36b33f)}/level/bullets/blue.png`,
        "yellow-bullet": `${(0, $0426e2dd5e0de94d$export$24af3971dd36b33f)}/level/bullets/yellow.png`,
        "pink-bullet": `${(0, $0426e2dd5e0de94d$export$24af3971dd36b33f)}/level/bullets/pink.png`,
        "red-bullet": `${(0, $0426e2dd5e0de94d$export$24af3971dd36b33f)}/level/bullets/red.png`,
        "card-bullet": `${(0, $0426e2dd5e0de94d$export$24af3971dd36b33f)}/level/bullets/card.png`,
        "slime-bullet": `${(0, $0426e2dd5e0de94d$export$24af3971dd36b33f)}/level/bullets/slime.png`,
        "xmas-bullet": `${(0, $0426e2dd5e0de94d$export$24af3971dd36b33f)}/level/bullets/xmas.png`,
        "carrot-bullet": `${(0, $0426e2dd5e0de94d$export$24af3971dd36b33f)}/level/bullets/carrot.png`,
        "riffle-bullet": `${(0, $0426e2dd5e0de94d$export$24af3971dd36b33f)}/level/bullets/riffle.png`,
        // SKILLS
        "skills-title": `${(0, $0426e2dd5e0de94d$export$24af3971dd36b33f)}/ui/skills/title.png`,
        "skills-star": `${(0, $0426e2dd5e0de94d$export$24af3971dd36b33f)}/ui/skills/star.png`,
        "skills-star-full": `${(0, $0426e2dd5e0de94d$export$24af3971dd36b33f)}/ui/skills/star-full.png`,
        "skills-star-empty": `${(0, $0426e2dd5e0de94d$export$24af3971dd36b33f)}/ui/skills/star-empty.png`,
        "skills-defensive": `${(0, $0426e2dd5e0de94d$export$24af3971dd36b33f)}/ui/skills/defensive.png`,
        "skills-healing-drone": `${(0, $0426e2dd5e0de94d$export$24af3971dd36b33f)}/ui/skills/healing-drone.png`,
        "skills-rocket-drone": `${(0, $0426e2dd5e0de94d$export$24af3971dd36b33f)}/ui/skills/rocket-drone.png`,
        "skills-lightning": `${(0, $0426e2dd5e0de94d$export$24af3971dd36b33f)}/ui/skills/lightning.png`,
        // SPINE
        player: `${(0, $0426e2dd5e0de94d$export$5e7589cedbd7a4e0)}/player/player.json`,
        gun: `${(0, $0426e2dd5e0de94d$export$5e7589cedbd7a4e0)}/player/gun.json`,
        bat: `${(0, $0426e2dd5e0de94d$export$5e7589cedbd7a4e0)}/monsters-static/bat.json`,
        flying_deer: `${(0, $0426e2dd5e0de94d$export$5e7589cedbd7a4e0)}/monsters-static/flying_deer.json`,
        ghost: `${(0, $0426e2dd5e0de94d$export$5e7589cedbd7a4e0)}/monsters-static/ghost.json`,
        ogre: `${(0, $0426e2dd5e0de94d$export$5e7589cedbd7a4e0)}/monsters-static/ogre.json`,
        rainbow: `${(0, $0426e2dd5e0de94d$export$5e7589cedbd7a4e0)}/monsters-static/rainbow.json`,
        spider: `${(0, $0426e2dd5e0de94d$export$5e7589cedbd7a4e0)}/monsters-static/spider.json`,
        blue_monster_1: `${(0, $0426e2dd5e0de94d$export$5e7589cedbd7a4e0)}/monsters-static/blue_monster_1.json`,
        blue_monster_2: `${(0, $0426e2dd5e0de94d$export$5e7589cedbd7a4e0)}/monsters-static/blue_monster_2.json`,
        blue_monster_3: `${(0, $0426e2dd5e0de94d$export$5e7589cedbd7a4e0)}/monsters-static/blue_monster_3.json`,
        pink_monster_1: `${(0, $0426e2dd5e0de94d$export$5e7589cedbd7a4e0)}/monsters-static/pink_monster_1.json`,
        pink_monster_2: `${(0, $0426e2dd5e0de94d$export$5e7589cedbd7a4e0)}/monsters-static/pink_monster_2.json`,
        pink_monster_3: `${(0, $0426e2dd5e0de94d$export$5e7589cedbd7a4e0)}/monsters-static/pink_monster_3.json`,
        red_monster_1: `${(0, $0426e2dd5e0de94d$export$5e7589cedbd7a4e0)}/monsters-static/red_monster_1.json`,
        red_monster_2: `${(0, $0426e2dd5e0de94d$export$5e7589cedbd7a4e0)}/monsters-static/red_monster_2.json`,
        crier: `${(0, $0426e2dd5e0de94d$export$5e7589cedbd7a4e0)}/monsters-static/crier.json`,
        klaus: `${(0, $0426e2dd5e0de94d$export$5e7589cedbd7a4e0)}/monsters-static/klaus.json`,
        "item-mystery-box": `${(0, $0426e2dd5e0de94d$export$5e7589cedbd7a4e0)}/chests/mystery-box.json`,
        "chests": `${(0, $0426e2dd5e0de94d$export$5e7589cedbd7a4e0)}/chests/chests.json`,
        "heal-aura": `${(0, $0426e2dd5e0de94d$export$5e7589cedbd7a4e0)}/auras/heal.json`,
        "power-aura": `${(0, $0426e2dd5e0de94d$export$5e7589cedbd7a4e0)}/auras/power.json`,
        "lightning-effect": `${(0, $0426e2dd5e0de94d$export$5e7589cedbd7a4e0)}/effects/lightning.json`,
        "rocket-drone": `${(0, $0426e2dd5e0de94d$export$5e7589cedbd7a4e0)}/drones/drone-blue.json`,
        "healing-drone": `${(0, $0426e2dd5e0de94d$export$5e7589cedbd7a4e0)}/drones/drone-red.json`,
        "rocket-bullet": `${(0, $0426e2dd5e0de94d$export$5e7589cedbd7a4e0)}/rocket/rocket.json`,
        "rocket-explosion": `${(0, $0426e2dd5e0de94d$export$5e7589cedbd7a4e0)}/rocket/rocket-explosion.json`,
        "electricity-aoe": `${(0, $0426e2dd5e0de94d$export$5e7589cedbd7a4e0)}/auras/defensive.json`,
        // Bosses
        "boss_1": `${(0, $0426e2dd5e0de94d$export$5e7589cedbd7a4e0)}/bosses/boss_1/boss_1.json`,
        "boss_1-bullet": `${(0, $0426e2dd5e0de94d$export$5e7589cedbd7a4e0)}/bosses/boss_1/boss_1_bullet.json`,
        "boss_1_lightning": `${(0, $0426e2dd5e0de94d$export$5e7589cedbd7a4e0)}/bosses/boss_1/boss_1_lightning.json`,
        "boss_2": `${(0, $0426e2dd5e0de94d$export$5e7589cedbd7a4e0)}/bosses/boss_2/boss_2.json`,
        "boss_2-bullet": `${(0, $0426e2dd5e0de94d$export$5e7589cedbd7a4e0)}/bosses/boss_2/boss_2_bullet.png`,
        "yeti": `${(0, $0426e2dd5e0de94d$export$5e7589cedbd7a4e0)}/bosses/yeti/YETI.json`,
        "yeti-bullet": `${(0, $0426e2dd5e0de94d$export$5e7589cedbd7a4e0)}/bosses/yeti/ICEBALL.png`,
        "yeti-spike": `${(0, $0426e2dd5e0de94d$export$5e7589cedbd7a4e0)}/bosses/yeti/SPIKES.json`,
        "yeti-icewave": `${(0, $0426e2dd5e0de94d$export$5e7589cedbd7a4e0)}/bosses/yeti/ICE_WAVE.json`,
        // Particles
        fireParticle: `${(0, $0426e2dd5e0de94d$export$24af3971dd36b33f)}/particles/fire.png`,
        circleParticle: `${(0, $0426e2dd5e0de94d$export$24af3971dd36b33f)}/particles/circle.png`
    });
    let resources;
    try {
        if (onLoaderProgress) {
            onLoaderProgress(0);
            let soundProgress = 0;
            let loaderProgress = 0;
            const updateProgress = (newSoundProgress, newLoaderProgress)=>{
                if (newSoundProgress !== undefined) soundProgress = newSoundProgress;
                if (newLoaderProgress !== undefined) loaderProgress = newLoaderProgress;
                onLoaderProgress(soundProgress * 0.5 + loaderProgress * 0.5, (0, $2ae84a41eb5f30ec$export$8e361a1ffbebf172).exited);
            };
            (0, $bf5e1bcc1f1c3d40$export$e7a4972e465134b1)((progress)=>{
                updateProgress(progress);
            }, ()=>{
                updateProgress(100);
            });
            resources = await loader.loadBundle("oogy", (progress)=>updateProgress(undefined, progress));
            updateProgress(undefined, 100);
        } else {
            (0, $bf5e1bcc1f1c3d40$export$e7a4972e465134b1)();
            resources = await loader.loadBundle("oogy");
        }
    } catch (err) {
        console.error(err);
        if (!(0, $2ae84a41eb5f30ec$export$8e361a1ffbebf172).exited) {
            (0, $2ae84a41eb5f30ec$export$8e361a1ffbebf172).exited = true;
            (0, $2ae84a41eb5f30ec$export$8e361a1ffbebf172).external.clearGame();
            (0, $2ae84a41eb5f30ec$export$8e361a1ffbebf172).external.showLoading(false);
            (0, $2ae84a41eb5f30ec$export$8e361a1ffbebf172).external.showModal({
                title: "Error",
                text: "Impossible to load the graphic resources, please check your internet connection and refresh the page"
            });
        }
        return;
    }
    (0, $2ae84a41eb5f30ec$export$8e361a1ffbebf172).resources = resources;
    Promise.all([
        ceesHand.load(),
        moreSugar.load(),
        supersonicRocketship.load()
    ]).then(()=>{
        if (onLoaderProgress) onLoaderProgress(100);
        app.resize();
        app.ticker.minFPS = 60;
        app.ticker.add((delta)=>{
            const roundedDelta = new (0, (/*@__PURE__*/$parcel$interopDefault($70e7e2b9a2a71832$exports)))(delta).mul(10).round().div(10).toNumber();
            $5e6922f6744fcb9a$var$update(roundedDelta);
        });
    }).catch((err)=>{
        console.error("loading failed", err);
    });
    return (0, $2ae84a41eb5f30ec$export$8e361a1ffbebf172).external.clearGame;
};
const $5e6922f6744fcb9a$export$e553497b10624e79 = (clamp, worldWidth, worldHeight)=>{
    if (!(0, $2ae84a41eb5f30ec$export$8e361a1ffbebf172).app || !(0, $2ae84a41eb5f30ec$export$8e361a1ffbebf172).resources) return;
    if ((0, $2ae84a41eb5f30ec$export$8e361a1ffbebf172).viewport) try {
        (0, $2ae84a41eb5f30ec$export$8e361a1ffbebf172).viewport.destroy();
    } catch (err) {
        console.error(err);
    }
    const viewport = new (0, $b4245adbfe6bbe42$export$d5c6c08dc2d3ca7)({
        screenWidth: (0, $08054706be28954e$export$e692ebd4cea17cf3)(),
        screenHeight: (0, $08054706be28954e$export$4e851fc33b36a5f0)(),
        worldWidth: worldWidth,
        worldHeight: worldHeight,
        events: (0, $2ae84a41eb5f30ec$export$8e361a1ffbebf172).app.renderer.events
    });
    if (clamp) viewport.clamp({
        direction: "all",
        underflow: "center"
    });
    (0, $2ae84a41eb5f30ec$export$8e361a1ffbebf172).app.renderer.on("resize", ()=>{
        //if (gameState.external.clearGame) {
        //  gameState.external.clearGame()
        //}
        (0, $2ae84a41eb5f30ec$export$8e361a1ffbebf172).external.showModal({
            title: "Do not change the size of the game",
            text: "Changing the size of the game can create visual bugs. Please, put the size back to previous one or refresh the page with the desired size."
        });
    //viewport.resize(getGameWidth(), getGameHeight())
    });
    viewport.sortableChildren = true;
    viewport.eventMode = "static";
    viewport.interactiveChildren = false;
    (0, $2ae84a41eb5f30ec$export$8e361a1ffbebf172).app.stage.addChild(viewport);
    (0, $2ae84a41eb5f30ec$export$8e361a1ffbebf172).viewport = viewport;
// addWaterEffect(state.app.stage, new Sprite(state.resources.waterDisplacement))
// addShockwaveEffect(viewport, new Point(getGameWidth() / 2, getGameHeight() / 2), undefined, {duration: 5})
};
/**
 * Update the state of the game
 * @param delta The delta (time passed since previous update)
 */ const $5e6922f6744fcb9a$var$update = (delta)=>{
    //if (gameState.level?.state.paused) return
    if (!(0, $2ae84a41eb5f30ec$export$8e361a1ffbebf172).level || (0, $2ae84a41eb5f30ec$export$8e361a1ffbebf172).level.state.ended) return;
    $5e6922f6744fcb9a$var$updateEmitters();
    (0, $09e18a5b5cfd97a5$export$c5d039b432737f65)(delta);
    (0, $44b699cfe818306c$export$c7d78f87941eb2fc)(delta);
    (0, $01e69bafe2fbba11$export$b92f1b9d5073a87b)(delta);
    (0, $306846f4386fc4d8$export$93438e5c7112cadf)(delta);
    (0, $1363c356f1a52b50$export$16bfbaf4ee7130aa)(delta);
    (0, $edd21dfd225447d1$export$a64e01919fe425f5)(delta);
    (0, $05e42dce750e973a$export$816913e06fd3bcf5)();
};
const $5e6922f6744fcb9a$var$updateEmitters = ()=>{
    for (const [clientId, value] of (0, $2ae84a41eb5f30ec$export$8e361a1ffbebf172).references.particles){
        const playerSpine = (0, $2ae84a41eb5f30ec$export$8e361a1ffbebf172).references.players.get(clientId);
        const gunSpine = (0, $2ae84a41eb5f30ec$export$8e361a1ffbebf172).references.guns.get(clientId);
        if (value.container && value.emitter && playerSpine && gunSpine) {
            value.container.x = playerSpine.element.x;
            value.container.y = playerSpine.element.y - 30;
        }
    }
};


var $8a56917682400e81$exports = {};
// colyseus.js@0.15.14 (@colyseus/schema 2.0.9)
(function(global1, factory) {
    factory($8a56917682400e81$exports);
})($8a56917682400e81$exports, function(exports1) {
    "use strict";
    function _mergeNamespaces(n, m) {
        m.forEach(function(e) {
            e && typeof e !== "string" && !Array.isArray(e) && Object.keys(e).forEach(function(k) {
                if (k !== "default" && !(k in n)) {
                    var d = Object.getOwnPropertyDescriptor(e, k);
                    Object.defineProperty(n, k, d.get ? d : {
                        enumerable: true,
                        get: function() {
                            return e[k];
                        }
                    });
                }
            });
        });
        return Object.freeze(n);
    }
    //
    // Polyfills for legacy environments
    //
    /*
     * Support Android 4.4.x
     */ if (!ArrayBuffer.isView) ArrayBuffer.isView = function(a) {
        return a !== null && typeof a === "object" && a.buffer instanceof ArrayBuffer;
    };
    // Define globalThis if not available.
    // https://github.com/colyseus/colyseus.js/issues/86
    if (typeof globalThis === "undefined" && typeof window !== "undefined") // @ts-ignore
    window["globalThis"] = window;
    /******************************************************************************
    Copyright (c) Microsoft Corporation.

    Permission to use, copy, modify, and/or distribute this software for any
    purpose with or without fee is hereby granted.

    THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
    REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
    AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
    INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
    LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
    OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
    PERFORMANCE OF THIS SOFTWARE.
    ***************************************************************************** */ /* global Reflect, Promise */ var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    function __extends(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    }
    function __awaiter(thisArg, _arguments, P, generator) {
        function adopt(value) {
            return value instanceof P ? value : new P(function(resolve) {
                resolve(value);
            });
        }
        return new (P || (P = Promise))(function(resolve, reject) {
            function fulfilled(value) {
                try {
                    step(generator.next(value));
                } catch (e) {
                    reject(e);
                }
            }
            function rejected(value) {
                try {
                    step(generator["throw"](value));
                } catch (e) {
                    reject(e);
                }
            }
            function step(result) {
                result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
            }
            step((generator = generator.apply(thisArg, _arguments || [])).next());
        });
    }
    function __generator(thisArg, body) {
        var _ = {
            label: 0,
            sent: function() {
                if (t[0] & 1) throw t[1];
                return t[1];
            },
            trys: [],
            ops: []
        }, f, y, t, g;
        return g = {
            next: verb(0),
            "throw": verb(1),
            "return": verb(2)
        }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
            return this;
        }), g;
        function verb(n) {
            return function(v) {
                return step([
                    n,
                    v
                ]);
            };
        }
        function step(op) {
            if (f) throw new TypeError("Generator is already executing.");
            while(g && (g = 0, op[0] && (_ = 0)), _)try {
                if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
                if (y = 0, t) op = [
                    op[0] & 2,
                    t.value
                ];
                switch(op[0]){
                    case 0:
                    case 1:
                        t = op;
                        break;
                    case 4:
                        _.label++;
                        return {
                            value: op[1],
                            done: false
                        };
                    case 5:
                        _.label++;
                        y = op[1];
                        op = [
                            0
                        ];
                        continue;
                    case 7:
                        op = _.ops.pop();
                        _.trys.pop();
                        continue;
                    default:
                        if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                            _ = 0;
                            continue;
                        }
                        if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                            _.label = op[1];
                            break;
                        }
                        if (op[0] === 6 && _.label < t[1]) {
                            _.label = t[1];
                            t = op;
                            break;
                        }
                        if (t && _.label < t[2]) {
                            _.label = t[2];
                            _.ops.push(op);
                            break;
                        }
                        if (t[2]) _.ops.pop();
                        _.trys.pop();
                        continue;
                }
                op = body.call(thisArg, _);
            } catch (e) {
                op = [
                    6,
                    e
                ];
                y = 0;
            } finally{
                f = t = 0;
            }
            if (op[0] & 5) throw op[1];
            return {
                value: op[0] ? op[1] : void 0,
                done: true
            };
        }
    }
    function apply(src, tar) {
        tar.statusMessage = src.statusText;
        tar.statusCode = src.status;
        tar.data = src.body;
    }
    function send(method, uri, opts) {
        opts = opts || {};
        var timer, ctrl, tmp = opts.body;
        opts.method = method;
        opts.headers = opts.headers || {};
        if (tmp instanceof FormData) ;
        else if (tmp && typeof tmp == "object") {
            opts.headers["content-type"] = "application/json";
            opts.body = JSON.stringify(tmp);
        }
        if (opts.withCredentials) opts.credentials = "include";
        if (opts.timeout) {
            ctrl = new AbortController;
            opts.signal = ctrl.signal;
            timer = setTimeout(ctrl.abort, opts.timeout);
        }
        return new Promise((res, rej)=>{
            fetch(uri, opts).then((rr, reply)=>{
                clearTimeout(timer);
                apply(rr, rr); //=> rr.headers
                reply = rr.status >= 400 ? rej : res;
                tmp = rr.headers.get("content-type");
                if (!tmp || !~tmp.indexOf("application/json")) reply(rr);
                else rr.text().then((str)=>{
                    try {
                        rr.data = JSON.parse(str, opts.reviver);
                        reply(rr);
                    } catch (err) {
                        err.headers = rr.headers;
                        apply(rr, err);
                        rej(err);
                    }
                });
            }).catch((err)=>{
                err.timeout = ctrl && ctrl.signal.aborted;
                rej(err);
            });
        });
    }
    var get = /*#__PURE__*/ send.bind(send, "GET");
    var post = /*#__PURE__*/ send.bind(send, "POST");
    var patch = /*#__PURE__*/ send.bind(send, "PATCH");
    var del = /*#__PURE__*/ send.bind(send, "DELETE");
    var put = /*#__PURE__*/ send.bind(send, "PUT");
    var del_1 = del;
    var get_1 = get;
    var patch_1 = patch;
    var post_1 = post;
    var put_1 = put;
    var send_1 = send;
    var fetch_1 = {
        del: del_1,
        get: get_1,
        patch: patch_1,
        post: post_1,
        put: put_1,
        send: send_1
    };
    var http = /*#__PURE__*/ _mergeNamespaces({
        __proto__: null,
        "default": fetch_1,
        del: del_1,
        get: get_1,
        patch: patch_1,
        post: post_1,
        put: put_1,
        send: send_1
    }, [
        fetch_1
    ]);
    var CloseCode;
    (function(CloseCode) {
        CloseCode[CloseCode["CONSENTED"] = 4000] = "CONSENTED";
        CloseCode[CloseCode["DEVMODE_RESTART"] = 4010] = "DEVMODE_RESTART";
    })(CloseCode || (CloseCode = {}));
    var ServerError = /** @class */ function(_super) {
        __extends(ServerError, _super);
        function ServerError(code, message) {
            var _this = _super.call(this, message) || this;
            _this.name = "ServerError";
            _this.code = code;
            return _this;
        }
        return ServerError;
    }(Error);
    /**
     * Copyright (c) 2014 Ion Drive Software Ltd.
     * https://github.com/darrachequesne/notepack/
     *
     * Permission is hereby granted, free of charge, to any person obtaining a copy
     * of this software and associated documentation files (the "Software"), to deal
     * in the Software without restriction, including without limitation the rights
     * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
     * copies of the Software, and to permit persons to whom the Software is
     * furnished to do so, subject to the following conditions:
     *
     * The above copyright notice and this permission notice shall be included in all
     * copies or substantial portions of the Software.
     *
     * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
     * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
     * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
     * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
     * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
     * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
     * SOFTWARE.
     */ /**
     * Patch for Colyseus:
     * -------------------
     * notepack.io@3.0.1
     *
     * added `offset` on Decoder constructor, for messages arriving with a code
     * before actual msgpack data
     */ //
    // DECODER
    //
    function Decoder(buffer, offset) {
        this._offset = offset;
        if (buffer instanceof ArrayBuffer) {
            this._buffer = buffer;
            this._view = new DataView(this._buffer);
        } else if (ArrayBuffer.isView(buffer)) {
            this._buffer = buffer.buffer;
            this._view = new DataView(this._buffer, buffer.byteOffset, buffer.byteLength);
        } else throw new Error("Invalid argument");
    }
    function utf8Read$1(view, offset, length) {
        var string = "", chr = 0;
        for(var i = offset, end = offset + length; i < end; i++){
            var byte = view.getUint8(i);
            if ((byte & 0x80) === 0x00) {
                string += String.fromCharCode(byte);
                continue;
            }
            if ((byte & 0xe0) === 0xc0) {
                string += String.fromCharCode((byte & 0x1f) << 6 | view.getUint8(++i) & 0x3f);
                continue;
            }
            if ((byte & 0xf0) === 0xe0) {
                string += String.fromCharCode((byte & 0x0f) << 12 | (view.getUint8(++i) & 0x3f) << 6 | (view.getUint8(++i) & 0x3f) << 0);
                continue;
            }
            if ((byte & 0xf8) === 0xf0) {
                chr = (byte & 0x07) << 18 | (view.getUint8(++i) & 0x3f) << 12 | (view.getUint8(++i) & 0x3f) << 6 | (view.getUint8(++i) & 0x3f) << 0;
                if (chr >= 0x010000) {
                    chr -= 0x010000;
                    string += String.fromCharCode((chr >>> 10) + 0xD800, (chr & 0x3FF) + 0xDC00);
                } else string += String.fromCharCode(chr);
                continue;
            }
            throw new Error("Invalid byte " + byte.toString(16));
        }
        return string;
    }
    Decoder.prototype._array = function(length) {
        var value = new Array(length);
        for(var i = 0; i < length; i++)value[i] = this._parse();
        return value;
    };
    Decoder.prototype._map = function(length) {
        var key = "", value = {};
        for(var i = 0; i < length; i++){
            key = this._parse();
            value[key] = this._parse();
        }
        return value;
    };
    Decoder.prototype._str = function(length) {
        var value = utf8Read$1(this._view, this._offset, length);
        this._offset += length;
        return value;
    };
    Decoder.prototype._bin = function(length) {
        var value = this._buffer.slice(this._offset, this._offset + length);
        this._offset += length;
        return value;
    };
    Decoder.prototype._parse = function() {
        var prefix = this._view.getUint8(this._offset++);
        var value, length = 0, type = 0, hi = 0, lo = 0;
        if (prefix < 0xc0) {
            // positive fixint
            if (prefix < 0x80) return prefix;
            // fixmap
            if (prefix < 0x90) return this._map(prefix & 0x0f);
            // fixarray
            if (prefix < 0xa0) return this._array(prefix & 0x0f);
            // fixstr
            return this._str(prefix & 0x1f);
        }
        // negative fixint
        if (prefix > 0xdf) return (0xff - prefix + 1) * -1;
        switch(prefix){
            // nil
            case 0xc0:
                return null;
            // false
            case 0xc2:
                return false;
            // true
            case 0xc3:
                return true;
            // bin
            case 0xc4:
                length = this._view.getUint8(this._offset);
                this._offset += 1;
                return this._bin(length);
            case 0xc5:
                length = this._view.getUint16(this._offset);
                this._offset += 2;
                return this._bin(length);
            case 0xc6:
                length = this._view.getUint32(this._offset);
                this._offset += 4;
                return this._bin(length);
            // ext
            case 0xc7:
                length = this._view.getUint8(this._offset);
                type = this._view.getInt8(this._offset + 1);
                this._offset += 2;
                if (type === -1) {
                    // timestamp 96
                    var ns = this._view.getUint32(this._offset);
                    hi = this._view.getInt32(this._offset + 4);
                    lo = this._view.getUint32(this._offset + 8);
                    this._offset += 12;
                    return new Date((hi * 0x100000000 + lo) * 1e3 + ns / 1e6);
                }
                return [
                    type,
                    this._bin(length)
                ];
            case 0xc8:
                length = this._view.getUint16(this._offset);
                type = this._view.getInt8(this._offset + 2);
                this._offset += 3;
                return [
                    type,
                    this._bin(length)
                ];
            case 0xc9:
                length = this._view.getUint32(this._offset);
                type = this._view.getInt8(this._offset + 4);
                this._offset += 5;
                return [
                    type,
                    this._bin(length)
                ];
            // float
            case 0xca:
                value = this._view.getFloat32(this._offset);
                this._offset += 4;
                return value;
            case 0xcb:
                value = this._view.getFloat64(this._offset);
                this._offset += 8;
                return value;
            // uint
            case 0xcc:
                value = this._view.getUint8(this._offset);
                this._offset += 1;
                return value;
            case 0xcd:
                value = this._view.getUint16(this._offset);
                this._offset += 2;
                return value;
            case 0xce:
                value = this._view.getUint32(this._offset);
                this._offset += 4;
                return value;
            case 0xcf:
                hi = this._view.getUint32(this._offset) * Math.pow(2, 32);
                lo = this._view.getUint32(this._offset + 4);
                this._offset += 8;
                return hi + lo;
            // int
            case 0xd0:
                value = this._view.getInt8(this._offset);
                this._offset += 1;
                return value;
            case 0xd1:
                value = this._view.getInt16(this._offset);
                this._offset += 2;
                return value;
            case 0xd2:
                value = this._view.getInt32(this._offset);
                this._offset += 4;
                return value;
            case 0xd3:
                hi = this._view.getInt32(this._offset) * Math.pow(2, 32);
                lo = this._view.getUint32(this._offset + 4);
                this._offset += 8;
                return hi + lo;
            // fixext
            case 0xd4:
                type = this._view.getInt8(this._offset);
                this._offset += 1;
                if (type === 0x00) {
                    // custom encoding for 'undefined' (kept for backward-compatibility)
                    this._offset += 1;
                    return void 0;
                }
                return [
                    type,
                    this._bin(1)
                ];
            case 0xd5:
                type = this._view.getInt8(this._offset);
                this._offset += 1;
                return [
                    type,
                    this._bin(2)
                ];
            case 0xd6:
                type = this._view.getInt8(this._offset);
                this._offset += 1;
                if (type === -1) {
                    // timestamp 32
                    value = this._view.getUint32(this._offset);
                    this._offset += 4;
                    return new Date(value * 1e3);
                }
                return [
                    type,
                    this._bin(4)
                ];
            case 0xd7:
                type = this._view.getInt8(this._offset);
                this._offset += 1;
                if (type === 0x00) {
                    // custom date encoding (kept for backward-compatibility)
                    hi = this._view.getInt32(this._offset) * Math.pow(2, 32);
                    lo = this._view.getUint32(this._offset + 4);
                    this._offset += 8;
                    return new Date(hi + lo);
                }
                if (type === -1) {
                    // timestamp 64
                    hi = this._view.getUint32(this._offset);
                    lo = this._view.getUint32(this._offset + 4);
                    this._offset += 8;
                    var s = (hi & 0x3) * 0x100000000 + lo;
                    return new Date(s * 1e3 + (hi >>> 2) / 1e6);
                }
                return [
                    type,
                    this._bin(8)
                ];
            case 0xd8:
                type = this._view.getInt8(this._offset);
                this._offset += 1;
                return [
                    type,
                    this._bin(16)
                ];
            // str
            case 0xd9:
                length = this._view.getUint8(this._offset);
                this._offset += 1;
                return this._str(length);
            case 0xda:
                length = this._view.getUint16(this._offset);
                this._offset += 2;
                return this._str(length);
            case 0xdb:
                length = this._view.getUint32(this._offset);
                this._offset += 4;
                return this._str(length);
            // array
            case 0xdc:
                length = this._view.getUint16(this._offset);
                this._offset += 2;
                return this._array(length);
            case 0xdd:
                length = this._view.getUint32(this._offset);
                this._offset += 4;
                return this._array(length);
            // map
            case 0xde:
                length = this._view.getUint16(this._offset);
                this._offset += 2;
                return this._map(length);
            case 0xdf:
                length = this._view.getUint32(this._offset);
                this._offset += 4;
                return this._map(length);
        }
        throw new Error("Could not parse");
    };
    function decode(buffer, offset) {
        if (offset === void 0) offset = 0;
        var decoder = new Decoder(buffer, offset);
        var value = decoder._parse();
        if (decoder._offset !== buffer.byteLength) throw new Error(buffer.byteLength - decoder._offset + " trailing bytes");
        return value;
    }
    //
    // ENCODER
    //
    var TIMESTAMP32_MAX_SEC = 4294967295; // 32-bit unsigned int
    var TIMESTAMP64_MAX_SEC = 17179869183; // 34-bit unsigned int
    function utf8Write(view, offset, str) {
        var c = 0;
        for(var i = 0, l = str.length; i < l; i++){
            c = str.charCodeAt(i);
            if (c < 0x80) view.setUint8(offset++, c);
            else if (c < 0x800) {
                view.setUint8(offset++, 0xc0 | c >> 6);
                view.setUint8(offset++, 0x80 | c & 0x3f);
            } else if (c < 0xd800 || c >= 0xe000) {
                view.setUint8(offset++, 0xe0 | c >> 12);
                view.setUint8(offset++, 0x80 | c >> 6 & 0x3f);
                view.setUint8(offset++, 0x80 | c & 0x3f);
            } else {
                i++;
                c = 0x10000 + ((c & 0x3ff) << 10 | str.charCodeAt(i) & 0x3ff);
                view.setUint8(offset++, 0xf0 | c >> 18);
                view.setUint8(offset++, 0x80 | c >> 12 & 0x3f);
                view.setUint8(offset++, 0x80 | c >> 6 & 0x3f);
                view.setUint8(offset++, 0x80 | c & 0x3f);
            }
        }
    }
    function utf8Length$1(str) {
        var c = 0, length = 0;
        for(var i = 0, l = str.length; i < l; i++){
            c = str.charCodeAt(i);
            if (c < 0x80) length += 1;
            else if (c < 0x800) length += 2;
            else if (c < 0xd800 || c >= 0xe000) length += 3;
            else {
                i++;
                length += 4;
            }
        }
        return length;
    }
    function _encode(bytes, defers, value) {
        var type = typeof value, i = 0, l = 0, hi = 0, lo = 0, length = 0, size = 0;
        if (type === "string") {
            length = utf8Length$1(value);
            // fixstr
            if (length < 0x20) {
                bytes.push(length | 0xa0);
                size = 1;
            } else if (length < 0x100) {
                bytes.push(0xd9, length);
                size = 2;
            } else if (length < 0x10000) {
                bytes.push(0xda, length >> 8, length);
                size = 3;
            } else if (length < 0x100000000) {
                bytes.push(0xdb, length >> 24, length >> 16, length >> 8, length);
                size = 5;
            } else throw new Error("String too long");
            defers.push({
                _str: value,
                _length: length,
                _offset: bytes.length
            });
            return size + length;
        }
        if (type === "number") {
            // TODO: encode to float 32?
            // float 64
            if (Math.floor(value) !== value || !isFinite(value)) {
                bytes.push(0xcb);
                defers.push({
                    _float: value,
                    _length: 8,
                    _offset: bytes.length
                });
                return 9;
            }
            if (value >= 0) {
                // positive fixnum
                if (value < 0x80) {
                    bytes.push(value);
                    return 1;
                }
                // uint 8
                if (value < 0x100) {
                    bytes.push(0xcc, value);
                    return 2;
                }
                // uint 16
                if (value < 0x10000) {
                    bytes.push(0xcd, value >> 8, value);
                    return 3;
                }
                // uint 32
                if (value < 0x100000000) {
                    bytes.push(0xce, value >> 24, value >> 16, value >> 8, value);
                    return 5;
                }
                // uint 64
                hi = value / Math.pow(2, 32) >> 0;
                lo = value >>> 0;
                bytes.push(0xcf, hi >> 24, hi >> 16, hi >> 8, hi, lo >> 24, lo >> 16, lo >> 8, lo);
                return 9;
            } else {
                // negative fixnum
                if (value >= -32) {
                    bytes.push(value);
                    return 1;
                }
                // int 8
                if (value >= -128) {
                    bytes.push(0xd0, value);
                    return 2;
                }
                // int 16
                if (value >= -32768) {
                    bytes.push(0xd1, value >> 8, value);
                    return 3;
                }
                // int 32
                if (value >= -2147483648) {
                    bytes.push(0xd2, value >> 24, value >> 16, value >> 8, value);
                    return 5;
                }
                // int 64
                hi = Math.floor(value / Math.pow(2, 32));
                lo = value >>> 0;
                bytes.push(0xd3, hi >> 24, hi >> 16, hi >> 8, hi, lo >> 24, lo >> 16, lo >> 8, lo);
                return 9;
            }
        }
        if (type === "object") {
            // nil
            if (value === null) {
                bytes.push(0xc0);
                return 1;
            }
            if (Array.isArray(value)) {
                length = value.length;
                // fixarray
                if (length < 0x10) {
                    bytes.push(length | 0x90);
                    size = 1;
                } else if (length < 0x10000) {
                    bytes.push(0xdc, length >> 8, length);
                    size = 3;
                } else if (length < 0x100000000) {
                    bytes.push(0xdd, length >> 24, length >> 16, length >> 8, length);
                    size = 5;
                } else throw new Error("Array too large");
                for(i = 0; i < length; i++)size += _encode(bytes, defers, value[i]);
                return size;
            }
            if (value instanceof Date) {
                var ms = value.getTime();
                var s = Math.floor(ms / 1e3);
                var ns = (ms - s * 1e3) * 1e6;
                if (s >= 0 && ns >= 0 && s <= TIMESTAMP64_MAX_SEC) {
                    if (ns === 0 && s <= TIMESTAMP32_MAX_SEC) {
                        // timestamp 32
                        bytes.push(0xd6, 0xff, s >> 24, s >> 16, s >> 8, s);
                        return 6;
                    } else {
                        // timestamp 64
                        hi = s / 0x100000000;
                        lo = s & 0xffffffff;
                        bytes.push(0xd7, 0xff, ns >> 22, ns >> 14, ns >> 6, hi, lo >> 24, lo >> 16, lo >> 8, lo);
                        return 10;
                    }
                } else {
                    // timestamp 96
                    hi = Math.floor(s / 0x100000000);
                    lo = s >>> 0;
                    bytes.push(0xc7, 0x0c, 0xff, ns >> 24, ns >> 16, ns >> 8, ns, hi >> 24, hi >> 16, hi >> 8, hi, lo >> 24, lo >> 16, lo >> 8, lo);
                    return 15;
                }
            }
            if (value instanceof ArrayBuffer) {
                length = value.byteLength;
                // bin 8
                if (length < 0x100) {
                    bytes.push(0xc4, length);
                    size = 2;
                } else // bin 16
                if (length < 0x10000) {
                    bytes.push(0xc5, length >> 8, length);
                    size = 3;
                } else // bin 32
                if (length < 0x100000000) {
                    bytes.push(0xc6, length >> 24, length >> 16, length >> 8, length);
                    size = 5;
                } else throw new Error("Buffer too large");
                defers.push({
                    _bin: value,
                    _length: length,
                    _offset: bytes.length
                });
                return size + length;
            }
            if (typeof value.toJSON === "function") return _encode(bytes, defers, value.toJSON());
            var keys = [], key = "";
            var allKeys = Object.keys(value);
            for(i = 0, l = allKeys.length; i < l; i++){
                key = allKeys[i];
                if (value[key] !== undefined && typeof value[key] !== "function") keys.push(key);
            }
            length = keys.length;
            // fixmap
            if (length < 0x10) {
                bytes.push(length | 0x80);
                size = 1;
            } else if (length < 0x10000) {
                bytes.push(0xde, length >> 8, length);
                size = 3;
            } else if (length < 0x100000000) {
                bytes.push(0xdf, length >> 24, length >> 16, length >> 8, length);
                size = 5;
            } else throw new Error("Object too large");
            for(i = 0; i < length; i++){
                key = keys[i];
                size += _encode(bytes, defers, key);
                size += _encode(bytes, defers, value[key]);
            }
            return size;
        }
        // false/true
        if (type === "boolean") {
            bytes.push(value ? 0xc3 : 0xc2);
            return 1;
        }
        if (type === "undefined") {
            bytes.push(0xc0);
            return 1;
        }
        // custom types like BigInt (typeof value === 'bigint')
        if (typeof value.toJSON === "function") return _encode(bytes, defers, value.toJSON());
        throw new Error("Could not encode");
    }
    function encode(value) {
        var bytes = [];
        var defers = [];
        var size = _encode(bytes, defers, value);
        var buf = new ArrayBuffer(size);
        var view = new DataView(buf);
        var deferIndex = 0;
        var deferWritten = 0;
        var nextOffset = -1;
        if (defers.length > 0) nextOffset = defers[0]._offset;
        var defer, deferLength = 0, offset = 0;
        for(var i = 0, l = bytes.length; i < l; i++){
            view.setUint8(deferWritten + i, bytes[i]);
            if (i + 1 !== nextOffset) continue;
            defer = defers[deferIndex];
            deferLength = defer._length;
            offset = deferWritten + nextOffset;
            if (defer._bin) {
                var bin = new Uint8Array(defer._bin);
                for(var j = 0; j < deferLength; j++)view.setUint8(offset + j, bin[j]);
            } else if (defer._str) utf8Write(view, offset, defer._str);
            else if (defer._float !== undefined) view.setFloat64(offset, defer._float);
            deferIndex++;
            deferWritten += deferLength;
            if (defers[deferIndex]) nextOffset = defers[deferIndex]._offset;
        }
        return buf;
    }
    var browser = function() {
        throw new Error("ws does not work in the browser. Browser clients must use the native WebSocket object");
    };
    var WebSocket = globalThis.WebSocket || browser;
    var WebSocketTransport = /** @class */ function() {
        function WebSocketTransport(events) {
            this.events = events;
        }
        WebSocketTransport.prototype.send = function(data) {
            if (data instanceof ArrayBuffer) this.ws.send(data);
            else if (Array.isArray(data)) this.ws.send(new Uint8Array(data).buffer);
        };
        WebSocketTransport.prototype.connect = function(url) {
            this.ws = new WebSocket(url, this.protocols);
            this.ws.binaryType = "arraybuffer";
            this.ws.onopen = this.events.onopen;
            this.ws.onmessage = this.events.onmessage;
            this.ws.onclose = this.events.onclose;
            this.ws.onerror = this.events.onerror;
        };
        WebSocketTransport.prototype.close = function(code, reason) {
            this.ws.close(code, reason);
        };
        Object.defineProperty(WebSocketTransport.prototype, "isOpen", {
            get: function() {
                return this.ws.readyState === WebSocket.OPEN;
            },
            enumerable: false,
            configurable: true
        });
        return WebSocketTransport;
    }();
    var Connection = /** @class */ function() {
        function Connection() {
            this.events = {};
            this.transport = new WebSocketTransport(this.events);
        }
        Connection.prototype.send = function(data) {
            this.transport.send(data);
        };
        Connection.prototype.connect = function(url) {
            this.transport.connect(url);
        };
        Connection.prototype.close = function(code, reason) {
            this.transport.close(code, reason);
        };
        Object.defineProperty(Connection.prototype, "isOpen", {
            get: function() {
                return this.transport.isOpen;
            },
            enumerable: false,
            configurable: true
        });
        return Connection;
    }();
    // Use codes between 0~127 for lesser throughput (1 byte)
    exports1.Protocol = void 0;
    (function(Protocol) {
        // Room-related (10~19)
        Protocol[Protocol["HANDSHAKE"] = 9] = "HANDSHAKE";
        Protocol[Protocol["JOIN_ROOM"] = 10] = "JOIN_ROOM";
        Protocol[Protocol["ERROR"] = 11] = "ERROR";
        Protocol[Protocol["LEAVE_ROOM"] = 12] = "LEAVE_ROOM";
        Protocol[Protocol["ROOM_DATA"] = 13] = "ROOM_DATA";
        Protocol[Protocol["ROOM_STATE"] = 14] = "ROOM_STATE";
        Protocol[Protocol["ROOM_STATE_PATCH"] = 15] = "ROOM_STATE_PATCH";
        Protocol[Protocol["ROOM_DATA_SCHEMA"] = 16] = "ROOM_DATA_SCHEMA";
        Protocol[Protocol["ROOM_DATA_BYTES"] = 17] = "ROOM_DATA_BYTES";
    })(exports1.Protocol || (exports1.Protocol = {}));
    exports1.ErrorCode = void 0;
    (function(ErrorCode) {
        ErrorCode[ErrorCode["MATCHMAKE_NO_HANDLER"] = 4210] = "MATCHMAKE_NO_HANDLER";
        ErrorCode[ErrorCode["MATCHMAKE_INVALID_CRITERIA"] = 4211] = "MATCHMAKE_INVALID_CRITERIA";
        ErrorCode[ErrorCode["MATCHMAKE_INVALID_ROOM_ID"] = 4212] = "MATCHMAKE_INVALID_ROOM_ID";
        ErrorCode[ErrorCode["MATCHMAKE_UNHANDLED"] = 4213] = "MATCHMAKE_UNHANDLED";
        ErrorCode[ErrorCode["MATCHMAKE_EXPIRED"] = 4214] = "MATCHMAKE_EXPIRED";
        ErrorCode[ErrorCode["AUTH_FAILED"] = 4215] = "AUTH_FAILED";
        ErrorCode[ErrorCode["APPLICATION_ERROR"] = 4216] = "APPLICATION_ERROR";
    })(exports1.ErrorCode || (exports1.ErrorCode = {}));
    function utf8Read(view, offset) {
        var length = view[offset++];
        var string = "", chr = 0;
        for(var i = offset, end = offset + length; i < end; i++){
            var byte = view[i];
            if ((byte & 0x80) === 0x00) {
                string += String.fromCharCode(byte);
                continue;
            }
            if ((byte & 0xe0) === 0xc0) {
                string += String.fromCharCode((byte & 0x1f) << 6 | view[++i] & 0x3f);
                continue;
            }
            if ((byte & 0xf0) === 0xe0) {
                string += String.fromCharCode((byte & 0x0f) << 12 | (view[++i] & 0x3f) << 6 | (view[++i] & 0x3f) << 0);
                continue;
            }
            if ((byte & 0xf8) === 0xf0) {
                chr = (byte & 0x07) << 18 | (view[++i] & 0x3f) << 12 | (view[++i] & 0x3f) << 6 | (view[++i] & 0x3f) << 0;
                if (chr >= 0x010000) {
                    chr -= 0x010000;
                    string += String.fromCharCode((chr >>> 10) + 0xD800, (chr & 0x3FF) + 0xDC00);
                } else string += String.fromCharCode(chr);
                continue;
            }
            throw new Error("Invalid byte " + byte.toString(16));
        }
        return string;
    }
    // Faster for short strings than Buffer.byteLength
    function utf8Length(str) {
        if (str === void 0) str = "";
        var c = 0;
        var length = 0;
        for(var i = 0, l = str.length; i < l; i++){
            c = str.charCodeAt(i);
            if (c < 0x80) length += 1;
            else if (c < 0x800) length += 2;
            else if (c < 0xd800 || c >= 0xe000) length += 3;
            else {
                i++;
                length += 4;
            }
        }
        return length + 1;
    }
    var serializers = {};
    function registerSerializer(id, serializer) {
        serializers[id] = serializer;
    }
    function getSerializer(id) {
        var serializer = serializers[id];
        if (!serializer) throw new Error("missing serializer: " + id);
        return serializer;
    }
    /**
     * The MIT License (MIT)
     *
     * Copyright 2016 Andrey Sitnik <andrey@sitnik.ru>
     *
     * Permission is hereby granted, free of charge, to any person obtaining a copy of
     * this software and associated documentation files (the "Software"), to deal in
     * the Software without restriction, including without limitation the rights to
     * use, copy, modify, merge, publish, distribute, sublicense, and/or sell copies of
     * the Software, and to permit persons to whom the Software is furnished to do so,
     * subject to the following conditions:
     *
     * The above copyright notice and this permission notice shall be included in all
     * copies or substantial portions of the Software.
     *
     * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
     * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY, FITNESS
     * FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR
     * COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER
     * IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN
     * CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.
     */ var createNanoEvents = function() {
        return {
            emit: function(event) {
                var args = [];
                for(var _i = 1; _i < arguments.length; _i++)args[_i - 1] = arguments[_i];
                var callbacks = this.events[event] || [];
                for(var i = 0, length_1 = callbacks.length; i < length_1; i++)callbacks[i].apply(callbacks, args);
            },
            events: {},
            on: function(event, cb) {
                var _this = this;
                var _a;
                ((_a = this.events[event]) === null || _a === void 0 ? void 0 : _a.push(cb)) || (this.events[event] = [
                    cb
                ]);
                return function() {
                    var _a;
                    _this.events[event] = (_a = _this.events[event]) === null || _a === void 0 ? void 0 : _a.filter(function(i) {
                        return cb !== i;
                    });
                };
            }
        };
    };
    var EventEmitter = /** @class */ function() {
        function EventEmitter() {
            this.handlers = [];
        }
        EventEmitter.prototype.register = function(cb, once) {
            this.handlers.push(cb);
            return this;
        };
        EventEmitter.prototype.invoke = function() {
            var _this = this;
            var args = [];
            for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
            this.handlers.forEach(function(handler) {
                return handler.apply(_this, args);
            });
        };
        EventEmitter.prototype.invokeAsync = function() {
            var _this = this;
            var args = [];
            for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
            return Promise.all(this.handlers.map(function(handler) {
                return handler.apply(_this, args);
            }));
        };
        EventEmitter.prototype.remove = function(cb) {
            var index = this.handlers.indexOf(cb);
            this.handlers[index] = this.handlers[this.handlers.length - 1];
            this.handlers.pop();
        };
        EventEmitter.prototype.clear = function() {
            this.handlers = [];
        };
        return EventEmitter;
    }();
    function createSignal() {
        var emitter = new EventEmitter();
        function register(cb) {
            return emitter.register(cb, this === null);
        }
        register.once = function(cb) {
            var callback = function() {
                var args = [];
                for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
                cb.apply(this, args);
                emitter.remove(callback);
            };
            emitter.register(callback);
        };
        register.remove = function(cb) {
            return emitter.remove(cb);
        };
        register.invoke = function() {
            var args = [];
            for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
            return emitter.invoke.apply(emitter, args);
        };
        register.invokeAsync = function() {
            var args = [];
            for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
            return emitter.invokeAsync.apply(emitter, args);
        };
        register.clear = function() {
            return emitter.clear();
        };
        return register;
    }
    var commonjsGlobal = typeof globalThis !== "undefined" ? globalThis : typeof window !== "undefined" ? window : typeof $parcel$global !== "undefined" ? $parcel$global : typeof self !== "undefined" ? self : {};
    function createCommonjsModule(fn) {
        var module = {
            exports: {}
        };
        return fn(module, module.exports), module.exports;
    }
    var umd = createCommonjsModule(function(module, exports1) {
        (function(global1, factory) {
            factory(exports1);
        })(commonjsGlobal, function(exports1) {
            /******************************************************************************
        Copyright (c) Microsoft Corporation.

        Permission to use, copy, modify, and/or distribute this software for any
        purpose with or without fee is hereby granted.

        THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
        REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
        AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
        INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
        LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
        OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
        PERFORMANCE OF THIS SOFTWARE.
        ***************************************************************************** */ /* global Reflect, Promise */ var extendStatics = function(d, b) {
                extendStatics = Object.setPrototypeOf || ({
                    __proto__: []
                }) instanceof Array && function(d, b) {
                    d.__proto__ = b;
                } || function(d, b) {
                    for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
                };
                return extendStatics(d, b);
            };
            function __extends(d, b) {
                if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
                extendStatics(d, b);
                function __() {
                    this.constructor = d;
                }
                d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
            }
            function __decorate(decorators, target, key, desc) {
                var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
                if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
                else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
                return c > 3 && r && Object.defineProperty(target, key, r), r;
            }
            function __spreadArray(to, from, pack) {
                if (pack || arguments.length === 2) {
                    for(var i = 0, l = from.length, ar; i < l; i++)if (ar || !(i in from)) {
                        if (!ar) ar = Array.prototype.slice.call(from, 0, i);
                        ar[i] = from[i];
                    }
                }
                return to.concat(ar || Array.prototype.slice.call(from));
            }
            // export const SWITCH_TO_STRUCTURE = 193; (easily collides with DELETE_AND_ADD + fieldIndex = 2)
            var SWITCH_TO_STRUCTURE = 255; // (decoding collides with DELETE_AND_ADD + fieldIndex = 63)
            var TYPE_ID = 213;
            /**
         * Encoding Schema field operations.
         */ exports1.OPERATION = void 0;
            (function(OPERATION) {
                // add new structure/primitive
                OPERATION[OPERATION["ADD"] = 128] = "ADD";
                // replace structure/primitive
                OPERATION[OPERATION["REPLACE"] = 0] = "REPLACE";
                // delete field
                OPERATION[OPERATION["DELETE"] = 64] = "DELETE";
                // DELETE field, followed by an ADD
                OPERATION[OPERATION["DELETE_AND_ADD"] = 192] = "DELETE_AND_ADD";
                // TOUCH is used to determine hierarchy of nested Schema structures during serialization.
                // touches are NOT encoded.
                OPERATION[OPERATION["TOUCH"] = 1] = "TOUCH";
                // MapSchema Operations
                OPERATION[OPERATION["CLEAR"] = 10] = "CLEAR";
            })(exports1.OPERATION || (exports1.OPERATION = {}));
            // export enum OPERATION {
            //     // add new structure/primitive
            //     // (128)
            //     ADD = 128, // 10000000,
            //     // replace structure/primitive
            //     REPLACE = 1,// 00000001
            //     // delete field
            //     DELETE = 192, // 11000000
            //     // DELETE field, followed by an ADD
            //     DELETE_AND_ADD = 224, // 11100000
            //     // TOUCH is used to determine hierarchy of nested Schema structures during serialization.
            //     // touches are NOT encoded.
            //     TOUCH = 0, // 00000000
            //     // MapSchema Operations
            //     CLEAR = 10,
            // }
            var ChangeTree = /** @class */ function() {
                function ChangeTree(ref, parent, root) {
                    this.changed = false;
                    this.changes = new Map();
                    this.allChanges = new Set();
                    // cached indexes for filtering
                    this.caches = {};
                    this.currentCustomOperation = 0;
                    this.ref = ref;
                    this.setParent(parent, root);
                }
                ChangeTree.prototype.setParent = function(parent, root, parentIndex) {
                    var _this = this;
                    if (!this.indexes) this.indexes = this.ref instanceof Schema ? this.ref["_definition"].indexes : {};
                    this.parent = parent;
                    this.parentIndex = parentIndex;
                    // avoid setting parents with empty `root`
                    if (!root) return;
                    this.root = root;
                    //
                    // assign same parent on child structures
                    //
                    if (this.ref instanceof Schema) {
                        var definition = this.ref["_definition"];
                        for(var field in definition.schema){
                            var value = this.ref[field];
                            if (value && value["$changes"]) {
                                var parentIndex_1 = definition.indexes[field];
                                value["$changes"].setParent(this.ref, root, parentIndex_1);
                            }
                        }
                    } else if (typeof this.ref === "object") this.ref.forEach(function(value, key) {
                        if (value instanceof Schema) {
                            var changeTreee = value["$changes"];
                            var parentIndex_2 = _this.ref["$changes"].indexes[key];
                            changeTreee.setParent(_this.ref, _this.root, parentIndex_2);
                        }
                    });
                };
                ChangeTree.prototype.operation = function(op) {
                    this.changes.set(--this.currentCustomOperation, op);
                };
                ChangeTree.prototype.change = function(fieldName, operation) {
                    if (operation === void 0) operation = exports1.OPERATION.ADD;
                    var index = typeof fieldName === "number" ? fieldName : this.indexes[fieldName];
                    this.assertValidIndex(index, fieldName);
                    var previousChange = this.changes.get(index);
                    if (!previousChange || previousChange.op === exports1.OPERATION.DELETE || previousChange.op === exports1.OPERATION.TOUCH // (mazmorra.io's BattleAction issue)
                    ) this.changes.set(index, {
                        op: !previousChange ? operation : previousChange.op === exports1.OPERATION.DELETE ? exports1.OPERATION.DELETE_AND_ADD : operation,
                        // : OPERATION.REPLACE,
                        index: index
                    });
                    this.allChanges.add(index);
                    this.changed = true;
                    this.touchParents();
                };
                ChangeTree.prototype.touch = function(fieldName) {
                    var index = typeof fieldName === "number" ? fieldName : this.indexes[fieldName];
                    this.assertValidIndex(index, fieldName);
                    if (!this.changes.has(index)) this.changes.set(index, {
                        op: exports1.OPERATION.TOUCH,
                        index: index
                    });
                    this.allChanges.add(index);
                    // ensure touch is placed until the $root is found.
                    this.touchParents();
                };
                ChangeTree.prototype.touchParents = function() {
                    if (this.parent) this.parent["$changes"].touch(this.parentIndex);
                };
                ChangeTree.prototype.getType = function(index) {
                    if (this.ref["_definition"]) {
                        var definition = this.ref["_definition"];
                        return definition.schema[definition.fieldsByIndex[index]];
                    } else {
                        var definition = this.parent["_definition"];
                        var parentType = definition.schema[definition.fieldsByIndex[this.parentIndex]];
                        //
                        // Get the child type from parent structure.
                        // - ["string"] => "string"
                        // - { map: "string" } => "string"
                        // - { set: "string" } => "string"
                        //
                        return Object.values(parentType)[0];
                    }
                };
                ChangeTree.prototype.getChildrenFilter = function() {
                    var childFilters = this.parent["_definition"].childFilters;
                    return childFilters && childFilters[this.parentIndex];
                };
                //
                // used during `.encode()`
                //
                ChangeTree.prototype.getValue = function(index) {
                    return this.ref["getByIndex"](index);
                };
                ChangeTree.prototype.delete = function(fieldName) {
                    var index = typeof fieldName === "number" ? fieldName : this.indexes[fieldName];
                    if (index === undefined) {
                        console.warn("@colyseus/schema ".concat(this.ref.constructor.name, ": trying to delete non-existing index: ").concat(fieldName, " (").concat(index, ")"));
                        return;
                    }
                    var previousValue = this.getValue(index);
                    // console.log("$changes.delete =>", { fieldName, index, previousValue });
                    this.changes.set(index, {
                        op: exports1.OPERATION.DELETE,
                        index: index
                    });
                    this.allChanges.delete(index);
                    // delete cache
                    delete this.caches[index];
                    // remove `root` reference
                    if (previousValue && previousValue["$changes"]) previousValue["$changes"].parent = undefined;
                    this.changed = true;
                    this.touchParents();
                };
                ChangeTree.prototype.discard = function(changed, discardAll) {
                    var _this = this;
                    if (changed === void 0) changed = false;
                    if (discardAll === void 0) discardAll = false;
                    //
                    // Map, Array, etc:
                    // Remove cached key to ensure ADD operations is unsed instead of
                    // REPLACE in case same key is used on next patches.
                    //
                    // TODO: refactor this. this is not relevant for Collection and Set.
                    //
                    if (!(this.ref instanceof Schema)) this.changes.forEach(function(change) {
                        if (change.op === exports1.OPERATION.DELETE) {
                            var index = _this.ref["getIndex"](change.index);
                            delete _this.indexes[index];
                        }
                    });
                    this.changes.clear();
                    this.changed = changed;
                    if (discardAll) this.allChanges.clear();
                    // re-set `currentCustomOperation`
                    this.currentCustomOperation = 0;
                };
                /**
             * Recursively discard all changes from this, and child structures.
             */ ChangeTree.prototype.discardAll = function() {
                    var _this = this;
                    this.changes.forEach(function(change) {
                        var value = _this.getValue(change.index);
                        if (value && value["$changes"]) value["$changes"].discardAll();
                    });
                    this.discard();
                };
                // cache(field: number, beginIndex: number, endIndex: number) {
                ChangeTree.prototype.cache = function(field, cachedBytes) {
                    this.caches[field] = cachedBytes;
                };
                ChangeTree.prototype.clone = function() {
                    return new ChangeTree(this.ref, this.parent, this.root);
                };
                ChangeTree.prototype.ensureRefId = function() {
                    // skip if refId is already set.
                    if (this.refId !== undefined) return;
                    this.refId = this.root.getNextUniqueId();
                };
                ChangeTree.prototype.assertValidIndex = function(index, fieldName) {
                    if (index === undefined) throw new Error('ChangeTree: missing index for field "'.concat(fieldName, '"'));
                };
                return ChangeTree;
            }();
            function addCallback($callbacks, op, callback, existing) {
                // initialize list of callbacks
                if (!$callbacks[op]) $callbacks[op] = [];
                $callbacks[op].push(callback);
                //
                // Trigger callback for existing elements
                // - OPERATION.ADD
                // - OPERATION.REPLACE
                //
                existing === null || existing === void 0 || existing.forEach(function(item, key) {
                    return callback(item, key);
                });
                return function() {
                    return spliceOne($callbacks[op], $callbacks[op].indexOf(callback));
                };
            }
            function removeChildRefs(changes) {
                var _this = this;
                var needRemoveRef = typeof this.$changes.getType() !== "string";
                this.$items.forEach(function(item, key) {
                    changes.push({
                        refId: _this.$changes.refId,
                        op: exports1.OPERATION.DELETE,
                        field: key,
                        value: undefined,
                        previousValue: item
                    });
                    if (needRemoveRef) _this.$changes.root.removeRef(item["$changes"].refId);
                });
            }
            function spliceOne(arr, index) {
                // manually splice an array
                if (index === -1 || index >= arr.length) return false;
                var len = arr.length - 1;
                for(var i = index; i < len; i++)arr[i] = arr[i + 1];
                arr.length = len;
                return true;
            }
            var DEFAULT_SORT = function(a, b) {
                var A = a.toString();
                var B = b.toString();
                if (A < B) return -1;
                else if (A > B) return 1;
                else return 0;
            };
            function getArrayProxy(value) {
                value["$proxy"] = true;
                //
                // compatibility with @colyseus/schema 0.5.x
                // - allow `map["key"]`
                // - allow `map["key"] = "xxx"`
                // - allow `delete map["key"]`
                //
                value = new Proxy(value, {
                    get: function(obj, prop) {
                        if (typeof prop !== "symbol" && !isNaN(prop) // https://stackoverflow.com/a/175787/892698
                        ) return obj.at(prop);
                        else return obj[prop];
                    },
                    set: function(obj, prop, setValue) {
                        if (typeof prop !== "symbol" && !isNaN(prop)) {
                            var indexes = Array.from(obj["$items"].keys());
                            var key = parseInt(indexes[prop] || prop);
                            if (setValue === undefined || setValue === null) obj.deleteAt(key);
                            else obj.setAt(key, setValue);
                        } else obj[prop] = setValue;
                        return true;
                    },
                    deleteProperty: function(obj, prop) {
                        if (typeof prop === "number") obj.deleteAt(prop);
                        else delete obj[prop];
                        return true;
                    }
                });
                return value;
            }
            var ArraySchema = /** @class */ function() {
                function ArraySchema() {
                    var items = [];
                    for(var _i = 0; _i < arguments.length; _i++)items[_i] = arguments[_i];
                    this.$changes = new ChangeTree(this);
                    this.$items = new Map();
                    this.$indexes = new Map();
                    this.$refId = 0;
                    this.push.apply(this, items);
                }
                ArraySchema.prototype.onAdd = function(callback, triggerAll) {
                    if (triggerAll === void 0) triggerAll = true;
                    return addCallback(this.$callbacks || (this.$callbacks = []), exports1.OPERATION.ADD, callback, triggerAll ? this.$items : undefined);
                };
                ArraySchema.prototype.onRemove = function(callback) {
                    return addCallback(this.$callbacks || (this.$callbacks = []), exports1.OPERATION.DELETE, callback);
                };
                ArraySchema.prototype.onChange = function(callback) {
                    return addCallback(this.$callbacks || (this.$callbacks = []), exports1.OPERATION.REPLACE, callback);
                };
                ArraySchema.is = function(type) {
                    return(// type format: ["string"]
                    Array.isArray(type) || // type format: { array: "string" }
                    type["array"] !== undefined);
                };
                Object.defineProperty(ArraySchema.prototype, "length", {
                    get: function() {
                        return this.$items.size;
                    },
                    set: function(value) {
                        if (value === 0) this.clear();
                        else this.splice(value, this.length - value);
                    },
                    enumerable: false,
                    configurable: true
                });
                ArraySchema.prototype.push = function() {
                    var _this = this;
                    var values = [];
                    for(var _i = 0; _i < arguments.length; _i++)values[_i] = arguments[_i];
                    var lastIndex;
                    values.forEach(function(value) {
                        // set "index" for reference.
                        lastIndex = _this.$refId++;
                        _this.setAt(lastIndex, value);
                    });
                    return lastIndex;
                };
                /**
             * Removes the last element from an array and returns it.
             */ ArraySchema.prototype.pop = function() {
                    var key = Array.from(this.$indexes.values()).pop();
                    if (key === undefined) return undefined;
                    this.$changes.delete(key);
                    this.$indexes.delete(key);
                    var value = this.$items.get(key);
                    this.$items.delete(key);
                    return value;
                };
                ArraySchema.prototype.at = function(index) {
                    //
                    // FIXME: this should be O(1)
                    //
                    var key = Array.from(this.$items.keys())[index];
                    return this.$items.get(key);
                };
                ArraySchema.prototype.setAt = function(index, value) {
                    var _a, _b;
                    if (value["$changes"] !== undefined) value["$changes"].setParent(this, this.$changes.root, index);
                    var operation = (_b = (_a = this.$changes.indexes[index]) === null || _a === void 0 ? void 0 : _a.op) !== null && _b !== void 0 ? _b : exports1.OPERATION.ADD;
                    this.$changes.indexes[index] = index;
                    this.$indexes.set(index, index);
                    this.$items.set(index, value);
                    this.$changes.change(index, operation);
                };
                ArraySchema.prototype.deleteAt = function(index) {
                    var key = Array.from(this.$items.keys())[index];
                    if (key === undefined) return false;
                    return this.$deleteAt(key);
                };
                ArraySchema.prototype.$deleteAt = function(index) {
                    // delete at internal index
                    this.$changes.delete(index);
                    this.$indexes.delete(index);
                    return this.$items.delete(index);
                };
                ArraySchema.prototype.clear = function(changes) {
                    // discard previous operations.
                    this.$changes.discard(true, true);
                    this.$changes.indexes = {};
                    // clear previous indexes
                    this.$indexes.clear();
                    //
                    // When decoding:
                    // - enqueue items for DELETE callback.
                    // - flag child items for garbage collection.
                    //
                    if (changes) removeChildRefs.call(this, changes);
                    // clear items
                    this.$items.clear();
                    this.$changes.operation({
                        index: 0,
                        op: exports1.OPERATION.CLEAR
                    });
                    // touch all structures until reach root
                    this.$changes.touchParents();
                };
                /**
             * Combines two or more arrays.
             * @param items Additional items to add to the end of array1.
             */ // @ts-ignore
                ArraySchema.prototype.concat = function() {
                    var _a;
                    var items = [];
                    for(var _i = 0; _i < arguments.length; _i++)items[_i] = arguments[_i];
                    return new (ArraySchema.bind.apply(ArraySchema, __spreadArray([
                        void 0
                    ], (_a = Array.from(this.$items.values())).concat.apply(_a, items), false)))();
                };
                /**
             * Adds all the elements of an array separated by the specified separator string.
             * @param separator A string used to separate one element of an array from the next in the resulting String. If omitted, the array elements are separated with a comma.
             */ ArraySchema.prototype.join = function(separator) {
                    return Array.from(this.$items.values()).join(separator);
                };
                /**
             * Reverses the elements in an Array.
             */ // @ts-ignore
                ArraySchema.prototype.reverse = function() {
                    var _this = this;
                    var indexes = Array.from(this.$items.keys());
                    var reversedItems = Array.from(this.$items.values()).reverse();
                    reversedItems.forEach(function(item, i) {
                        _this.setAt(indexes[i], item);
                    });
                    return this;
                };
                /**
             * Removes the first element from an array and returns it.
             */ ArraySchema.prototype.shift = function() {
                    var indexes = Array.from(this.$items.keys());
                    var shiftAt = indexes.shift();
                    if (shiftAt === undefined) return undefined;
                    var value = this.$items.get(shiftAt);
                    this.$deleteAt(shiftAt);
                    return value;
                };
                /**
             * Returns a section of an array.
             * @param start The beginning of the specified portion of the array.
             * @param end The end of the specified portion of the array. This is exclusive of the element at the index 'end'.
             */ ArraySchema.prototype.slice = function(start, end) {
                    var sliced = new ArraySchema();
                    sliced.push.apply(sliced, Array.from(this.$items.values()).slice(start, end));
                    return sliced;
                };
                /**
             * Sorts an array.
             * @param compareFn Function used to determine the order of the elements. It is expected to return
             * a negative value if first argument is less than second argument, zero if they're equal and a positive
             * value otherwise. If omitted, the elements are sorted in ascending, ASCII character order.
             * ```ts
             * [11,2,22,1].sort((a, b) => a - b)
             * ```
             */ ArraySchema.prototype.sort = function(compareFn) {
                    var _this = this;
                    if (compareFn === void 0) compareFn = DEFAULT_SORT;
                    var indexes = Array.from(this.$items.keys());
                    var sortedItems = Array.from(this.$items.values()).sort(compareFn);
                    sortedItems.forEach(function(item, i) {
                        _this.setAt(indexes[i], item);
                    });
                    return this;
                };
                /**
             * Removes elements from an array and, if necessary, inserts new elements in their place, returning the deleted elements.
             * @param start The zero-based location in the array from which to start removing elements.
             * @param deleteCount The number of elements to remove.
             * @param items Elements to insert into the array in place of the deleted elements.
             */ ArraySchema.prototype.splice = function(start, deleteCount) {
                    if (deleteCount === void 0) deleteCount = this.length - start;
                    var indexes = Array.from(this.$items.keys());
                    var removedItems = [];
                    for(var i = start; i < start + deleteCount; i++){
                        removedItems.push(this.$items.get(indexes[i]));
                        this.$deleteAt(indexes[i]);
                    }
                    return removedItems;
                };
                /**
             * Inserts new elements at the start of an array.
             * @param items  Elements to insert at the start of the Array.
             */ ArraySchema.prototype.unshift = function() {
                    var _this = this;
                    var items = [];
                    for(var _i = 0; _i < arguments.length; _i++)items[_i] = arguments[_i];
                    var length = this.length;
                    var addedLength = items.length;
                    // const indexes = Array.from(this.$items.keys());
                    var previousValues = Array.from(this.$items.values());
                    items.forEach(function(item, i) {
                        _this.setAt(i, item);
                    });
                    previousValues.forEach(function(previousValue, i) {
                        _this.setAt(addedLength + i, previousValue);
                    });
                    return length + addedLength;
                };
                /**
             * Returns the index of the first occurrence of a value in an array.
             * @param searchElement The value to locate in the array.
             * @param fromIndex The array index at which to begin the search. If fromIndex is omitted, the search starts at index 0.
             */ ArraySchema.prototype.indexOf = function(searchElement, fromIndex) {
                    return Array.from(this.$items.values()).indexOf(searchElement, fromIndex);
                };
                /**
             * Returns the index of the last occurrence of a specified value in an array.
             * @param searchElement The value to locate in the array.
             * @param fromIndex The array index at which to begin the search. If fromIndex is omitted, the search starts at the last index in the array.
             */ ArraySchema.prototype.lastIndexOf = function(searchElement, fromIndex) {
                    if (fromIndex === void 0) fromIndex = this.length - 1;
                    return Array.from(this.$items.values()).lastIndexOf(searchElement, fromIndex);
                };
                /**
             * Determines whether all the members of an array satisfy the specified test.
             * @param callbackfn A function that accepts up to three arguments. The every method calls
             * the callbackfn function for each element in the array until the callbackfn returns a value
             * which is coercible to the Boolean value false, or until the end of the array.
             * @param thisArg An object to which the this keyword can refer in the callbackfn function.
             * If thisArg is omitted, undefined is used as the this value.
             */ ArraySchema.prototype.every = function(callbackfn, thisArg) {
                    return Array.from(this.$items.values()).every(callbackfn, thisArg);
                };
                /**
             * Determines whether the specified callback function returns true for any element of an array.
             * @param callbackfn A function that accepts up to three arguments. The some method calls
             * the callbackfn function for each element in the array until the callbackfn returns a value
             * which is coercible to the Boolean value true, or until the end of the array.
             * @param thisArg An object to which the this keyword can refer in the callbackfn function.
             * If thisArg is omitted, undefined is used as the this value.
             */ ArraySchema.prototype.some = function(callbackfn, thisArg) {
                    return Array.from(this.$items.values()).some(callbackfn, thisArg);
                };
                /**
             * Performs the specified action for each element in an array.
             * @param callbackfn  A function that accepts up to three arguments. forEach calls the callbackfn function one time for each element in the array.
             * @param thisArg  An object to which the this keyword can refer in the callbackfn function. If thisArg is omitted, undefined is used as the this value.
             */ ArraySchema.prototype.forEach = function(callbackfn, thisArg) {
                    Array.from(this.$items.values()).forEach(callbackfn, thisArg);
                };
                /**
             * Calls a defined callback function on each element of an array, and returns an array that contains the results.
             * @param callbackfn A function that accepts up to three arguments. The map method calls the callbackfn function one time for each element in the array.
             * @param thisArg An object to which the this keyword can refer in the callbackfn function. If thisArg is omitted, undefined is used as the this value.
             */ ArraySchema.prototype.map = function(callbackfn, thisArg) {
                    return Array.from(this.$items.values()).map(callbackfn, thisArg);
                };
                ArraySchema.prototype.filter = function(callbackfn, thisArg) {
                    return Array.from(this.$items.values()).filter(callbackfn, thisArg);
                };
                /**
             * Calls the specified callback function for all the elements in an array. The return value of the callback function is the accumulated result, and is provided as an argument in the next call to the callback function.
             * @param callbackfn A function that accepts up to four arguments. The reduce method calls the callbackfn function one time for each element in the array.
             * @param initialValue If initialValue is specified, it is used as the initial value to start the accumulation. The first call to the callbackfn function provides this value as an argument instead of an array value.
             */ ArraySchema.prototype.reduce = function(callbackfn, initialValue) {
                    return Array.prototype.reduce.apply(Array.from(this.$items.values()), arguments);
                };
                /**
             * Calls the specified callback function for all the elements in an array, in descending order. The return value of the callback function is the accumulated result, and is provided as an argument in the next call to the callback function.
             * @param callbackfn A function that accepts up to four arguments. The reduceRight method calls the callbackfn function one time for each element in the array.
             * @param initialValue If initialValue is specified, it is used as the initial value to start the accumulation. The first call to the callbackfn function provides this value as an argument instead of an array value.
             */ ArraySchema.prototype.reduceRight = function(callbackfn, initialValue) {
                    return Array.prototype.reduceRight.apply(Array.from(this.$items.values()), arguments);
                };
                /**
             * Returns the value of the first element in the array where predicate is true, and undefined
             * otherwise.
             * @param predicate find calls predicate once for each element of the array, in ascending
             * order, until it finds one where predicate returns true. If such an element is found, find
             * immediately returns that element value. Otherwise, find returns undefined.
             * @param thisArg If provided, it will be used as the this value for each invocation of
             * predicate. If it is not provided, undefined is used instead.
             */ ArraySchema.prototype.find = function(predicate, thisArg) {
                    return Array.from(this.$items.values()).find(predicate, thisArg);
                };
                /**
             * Returns the index of the first element in the array where predicate is true, and -1
             * otherwise.
             * @param predicate find calls predicate once for each element of the array, in ascending
             * order, until it finds one where predicate returns true. If such an element is found,
             * findIndex immediately returns that element index. Otherwise, findIndex returns -1.
             * @param thisArg If provided, it will be used as the this value for each invocation of
             * predicate. If it is not provided, undefined is used instead.
             */ ArraySchema.prototype.findIndex = function(predicate, thisArg) {
                    return Array.from(this.$items.values()).findIndex(predicate, thisArg);
                };
                /**
             * Returns the this object after filling the section identified by start and end with value
             * @param value value to fill array section with
             * @param start index to start filling the array at. If start is negative, it is treated as
             * length+start where length is the length of the array.
             * @param end index to stop filling the array at. If end is negative, it is treated as
             * length+end.
             */ ArraySchema.prototype.fill = function(value, start, end) {
                    //
                    // TODO
                    //
                    throw new Error("ArraySchema#fill() not implemented");
                };
                /**
             * Returns the this object after copying a section of the array identified by start and end
             * to the same array starting at position target
             * @param target If target is negative, it is treated as length+target where length is the
             * length of the array.
             * @param start If start is negative, it is treated as length+start. If end is negative, it
             * is treated as length+end.
             * @param end If not specified, length of the this object is used as its default value.
             */ ArraySchema.prototype.copyWithin = function(target, start, end) {
                    //
                    // TODO
                    //
                    throw new Error("ArraySchema#copyWithin() not implemented");
                };
                /**
             * Returns a string representation of an array.
             */ ArraySchema.prototype.toString = function() {
                    return this.$items.toString();
                };
                /**
             * Returns a string representation of an array. The elements are converted to string using their toLocalString methods.
             */ ArraySchema.prototype.toLocaleString = function() {
                    return this.$items.toLocaleString();
                };
                /** Iterator */ ArraySchema.prototype[Symbol.iterator] = function() {
                    return Array.from(this.$items.values())[Symbol.iterator]();
                };
                /**
             * Returns an iterable of key, value pairs for every entry in the array
             */ ArraySchema.prototype.entries = function() {
                    return this.$items.entries();
                };
                /**
             * Returns an iterable of keys in the array
             */ ArraySchema.prototype.keys = function() {
                    return this.$items.keys();
                };
                /**
             * Returns an iterable of values in the array
             */ ArraySchema.prototype.values = function() {
                    return this.$items.values();
                };
                /**
             * Determines whether an array includes a certain element, returning true or false as appropriate.
             * @param searchElement The element to search for.
             * @param fromIndex The position in this array at which to begin searching for searchElement.
             */ ArraySchema.prototype.includes = function(searchElement, fromIndex) {
                    return Array.from(this.$items.values()).includes(searchElement, fromIndex);
                };
                /**
             * Calls a defined callback function on each element of an array. Then, flattens the result into
             * a new array.
             * This is identical to a map followed by flat with depth 1.
             *
             * @param callback A function that accepts up to three arguments. The flatMap method calls the
             * callback function one time for each element in the array.
             * @param thisArg An object to which the this keyword can refer in the callback function. If
             * thisArg is omitted, undefined is used as the this value.
             */ // @ts-ignore
                ArraySchema.prototype.flatMap = function(callback, thisArg) {
                    // @ts-ignore
                    throw new Error("ArraySchema#flatMap() is not supported.");
                };
                /**
             * Returns a new array with all sub-array elements concatenated into it recursively up to the
             * specified depth.
             *
             * @param depth The maximum recursion depth
             */ // @ts-ignore
                ArraySchema.prototype.flat = function(depth) {
                    throw new Error("ArraySchema#flat() is not supported.");
                };
                ArraySchema.prototype.findLast = function() {
                    var arr = Array.from(this.$items.values());
                    // @ts-ignore
                    return arr.findLast.apply(arr, arguments);
                };
                ArraySchema.prototype.findLastIndex = function() {
                    var arr = Array.from(this.$items.values());
                    // @ts-ignore
                    return arr.findLastIndex.apply(arr, arguments);
                };
                // get size () {
                //     return this.$items.size;
                // }
                ArraySchema.prototype.setIndex = function(index, key) {
                    this.$indexes.set(index, key);
                };
                ArraySchema.prototype.getIndex = function(index) {
                    return this.$indexes.get(index);
                };
                ArraySchema.prototype.getByIndex = function(index) {
                    return this.$items.get(this.$indexes.get(index));
                };
                ArraySchema.prototype.deleteByIndex = function(index) {
                    var key = this.$indexes.get(index);
                    this.$items.delete(key);
                    this.$indexes.delete(index);
                };
                ArraySchema.prototype.toArray = function() {
                    return Array.from(this.$items.values());
                };
                ArraySchema.prototype.toJSON = function() {
                    return this.toArray().map(function(value) {
                        return typeof value["toJSON"] === "function" ? value["toJSON"]() : value;
                    });
                };
                //
                // Decoding utilities
                //
                ArraySchema.prototype.clone = function(isDecoding) {
                    var cloned;
                    if (isDecoding) cloned = new (ArraySchema.bind.apply(ArraySchema, __spreadArray([
                        void 0
                    ], Array.from(this.$items.values()), false)))();
                    else cloned = new (ArraySchema.bind.apply(ArraySchema, __spreadArray([
                        void 0
                    ], this.map(function(item) {
                        return item["$changes"] ? item.clone() : item;
                    }), false)))();
                    return cloned;
                };
                return ArraySchema;
            }();
            function getMapProxy(value) {
                value["$proxy"] = true;
                value = new Proxy(value, {
                    get: function(obj, prop) {
                        if (typeof prop !== "symbol" && // accessing properties
                        typeof obj[prop] === "undefined") return obj.get(prop);
                        else return obj[prop];
                    },
                    set: function(obj, prop, setValue) {
                        if (typeof prop !== "symbol" && prop.indexOf("$") === -1 && prop !== "onAdd" && prop !== "onRemove" && prop !== "onChange") obj.set(prop, setValue);
                        else obj[prop] = setValue;
                        return true;
                    },
                    deleteProperty: function(obj, prop) {
                        obj.delete(prop);
                        return true;
                    }
                });
                return value;
            }
            var MapSchema = /** @class */ function() {
                function MapSchema(initialValues) {
                    var _this = this;
                    this.$changes = new ChangeTree(this);
                    this.$items = new Map();
                    this.$indexes = new Map();
                    this.$refId = 0;
                    if (initialValues) {
                        if (initialValues instanceof Map || initialValues instanceof MapSchema) initialValues.forEach(function(v, k) {
                            return _this.set(k, v);
                        });
                        else for(var k in initialValues)this.set(k, initialValues[k]);
                    }
                }
                MapSchema.prototype.onAdd = function(callback, triggerAll) {
                    if (triggerAll === void 0) triggerAll = true;
                    return addCallback(this.$callbacks || (this.$callbacks = []), exports1.OPERATION.ADD, callback, triggerAll ? this.$items : undefined);
                };
                MapSchema.prototype.onRemove = function(callback) {
                    return addCallback(this.$callbacks || (this.$callbacks = []), exports1.OPERATION.DELETE, callback);
                };
                MapSchema.prototype.onChange = function(callback) {
                    return addCallback(this.$callbacks || (this.$callbacks = []), exports1.OPERATION.REPLACE, callback);
                };
                MapSchema.is = function(type) {
                    return type["map"] !== undefined;
                };
                /** Iterator */ MapSchema.prototype[Symbol.iterator] = function() {
                    return this.$items[Symbol.iterator]();
                };
                Object.defineProperty(MapSchema.prototype, Symbol.toStringTag, {
                    get: function() {
                        return this.$items[Symbol.toStringTag];
                    },
                    enumerable: false,
                    configurable: true
                });
                MapSchema.prototype.set = function(key, value) {
                    if (value === undefined || value === null) throw new Error("MapSchema#set('".concat(key, "', ").concat(value, "): trying to set ").concat(value, " value on '").concat(key, "'."));
                    // get "index" for this value.
                    var hasIndex = typeof this.$changes.indexes[key] !== "undefined";
                    var index = hasIndex ? this.$changes.indexes[key] : this.$refId++;
                    var operation = hasIndex ? exports1.OPERATION.REPLACE : exports1.OPERATION.ADD;
                    var isRef = value["$changes"] !== undefined;
                    if (isRef) value["$changes"].setParent(this, this.$changes.root, index);
                    //
                    // (encoding)
                    // set a unique id to relate directly with this key/value.
                    //
                    if (!hasIndex) {
                        this.$changes.indexes[key] = index;
                        this.$indexes.set(index, key);
                    } else if (isRef && // if is schema, force ADD operation if value differ from previous one.
                    this.$items.get(key) !== value) operation = exports1.OPERATION.ADD;
                    this.$items.set(key, value);
                    this.$changes.change(key, operation);
                    return this;
                };
                MapSchema.prototype.get = function(key) {
                    return this.$items.get(key);
                };
                MapSchema.prototype.delete = function(key) {
                    //
                    // TODO: add a "purge" method after .encode() runs, to cleanup removed `$indexes`
                    //
                    // We don't remove $indexes to allow setting the same key in the same patch
                    // (See "should allow to remove and set an item in the same place" test)
                    //
                    // // const index = this.$changes.indexes[key];
                    // // this.$indexes.delete(index);
                    this.$changes.delete(key);
                    return this.$items.delete(key);
                };
                MapSchema.prototype.clear = function(changes) {
                    // discard previous operations.
                    this.$changes.discard(true, true);
                    this.$changes.indexes = {};
                    // clear previous indexes
                    this.$indexes.clear();
                    //
                    // When decoding:
                    // - enqueue items for DELETE callback.
                    // - flag child items for garbage collection.
                    //
                    if (changes) removeChildRefs.call(this, changes);
                    // clear items
                    this.$items.clear();
                    this.$changes.operation({
                        index: 0,
                        op: exports1.OPERATION.CLEAR
                    });
                    // touch all structures until reach root
                    this.$changes.touchParents();
                };
                MapSchema.prototype.has = function(key) {
                    return this.$items.has(key);
                };
                MapSchema.prototype.forEach = function(callbackfn) {
                    this.$items.forEach(callbackfn);
                };
                MapSchema.prototype.entries = function() {
                    return this.$items.entries();
                };
                MapSchema.prototype.keys = function() {
                    return this.$items.keys();
                };
                MapSchema.prototype.values = function() {
                    return this.$items.values();
                };
                Object.defineProperty(MapSchema.prototype, "size", {
                    get: function() {
                        return this.$items.size;
                    },
                    enumerable: false,
                    configurable: true
                });
                MapSchema.prototype.setIndex = function(index, key) {
                    this.$indexes.set(index, key);
                };
                MapSchema.prototype.getIndex = function(index) {
                    return this.$indexes.get(index);
                };
                MapSchema.prototype.getByIndex = function(index) {
                    return this.$items.get(this.$indexes.get(index));
                };
                MapSchema.prototype.deleteByIndex = function(index) {
                    var key = this.$indexes.get(index);
                    this.$items.delete(key);
                    this.$indexes.delete(index);
                };
                MapSchema.prototype.toJSON = function() {
                    var map = {};
                    this.forEach(function(value, key) {
                        map[key] = typeof value["toJSON"] === "function" ? value["toJSON"]() : value;
                    });
                    return map;
                };
                //
                // Decoding utilities
                //
                MapSchema.prototype.clone = function(isDecoding) {
                    var cloned;
                    if (isDecoding) // client-side
                    cloned = Object.assign(new MapSchema(), this);
                    else {
                        // server-side
                        cloned = new MapSchema();
                        this.forEach(function(value, key) {
                            if (value["$changes"]) cloned.set(key, value["clone"]());
                            else cloned.set(key, value);
                        });
                    }
                    return cloned;
                };
                return MapSchema;
            }();
            var registeredTypes = {};
            function registerType(identifier, definition) {
                registeredTypes[identifier] = definition;
            }
            function getType(identifier) {
                return registeredTypes[identifier];
            }
            var SchemaDefinition = /** @class */ function() {
                function SchemaDefinition() {
                    //
                    // TODO: use a "field" structure combining all these properties per-field.
                    //
                    this.indexes = {};
                    this.fieldsByIndex = {};
                    this.deprecated = {};
                    this.descriptors = {};
                }
                SchemaDefinition.create = function(parent) {
                    var definition = new SchemaDefinition();
                    // support inheritance
                    definition.schema = Object.assign({}, parent && parent.schema || {});
                    definition.indexes = Object.assign({}, parent && parent.indexes || {});
                    definition.fieldsByIndex = Object.assign({}, parent && parent.fieldsByIndex || {});
                    definition.descriptors = Object.assign({}, parent && parent.descriptors || {});
                    definition.deprecated = Object.assign({}, parent && parent.deprecated || {});
                    return definition;
                };
                SchemaDefinition.prototype.addField = function(field, type) {
                    var index = this.getNextFieldIndex();
                    this.fieldsByIndex[index] = field;
                    this.indexes[field] = index;
                    this.schema[field] = Array.isArray(type) ? {
                        array: type[0]
                    } : type;
                };
                SchemaDefinition.prototype.hasField = function(field) {
                    return this.indexes[field] !== undefined;
                };
                SchemaDefinition.prototype.addFilter = function(field, cb) {
                    if (!this.filters) {
                        this.filters = {};
                        this.indexesWithFilters = [];
                    }
                    this.filters[this.indexes[field]] = cb;
                    this.indexesWithFilters.push(this.indexes[field]);
                    return true;
                };
                SchemaDefinition.prototype.addChildrenFilter = function(field, cb) {
                    var index = this.indexes[field];
                    var type = this.schema[field];
                    if (getType(Object.keys(type)[0])) {
                        if (!this.childFilters) this.childFilters = {};
                        this.childFilters[index] = cb;
                        return true;
                    } else console.warn("@filterChildren: field '".concat(field, "' can't have children. Ignoring filter."));
                };
                SchemaDefinition.prototype.getChildrenFilter = function(field) {
                    return this.childFilters && this.childFilters[this.indexes[field]];
                };
                SchemaDefinition.prototype.getNextFieldIndex = function() {
                    return Object.keys(this.schema || {}).length;
                };
                return SchemaDefinition;
            }();
            function hasFilter(klass) {
                return klass._context && klass._context.useFilters;
            }
            var Context = /** @class */ function() {
                function Context() {
                    this.types = {};
                    this.schemas = new Map();
                    this.useFilters = false;
                }
                Context.prototype.has = function(schema) {
                    return this.schemas.has(schema);
                };
                Context.prototype.get = function(typeid) {
                    return this.types[typeid];
                };
                Context.prototype.add = function(schema, typeid) {
                    if (typeid === void 0) typeid = this.schemas.size;
                    // FIXME: move this to somewhere else?
                    // support inheritance
                    schema._definition = SchemaDefinition.create(schema._definition);
                    schema._typeid = typeid;
                    this.types[typeid] = schema;
                    this.schemas.set(schema, typeid);
                };
                Context.create = function(options) {
                    if (options === void 0) options = {};
                    return function(definition) {
                        if (!options.context) options.context = new Context();
                        return type(definition, options);
                    };
                };
                return Context;
            }();
            var globalContext = new Context();
            /**
         * [See documentation](https://docs.colyseus.io/state/schema/)
         *
         * Annotate a Schema property to be serializeable.
         * \@type()'d fields are automatically flagged as "dirty" for the next patch.
         *
         * @example Standard usage, with automatic change tracking.
         * ```
         * \@type("string") propertyName: string;
         * ```
         *
         * @example You can provide the "manual" option if you'd like to manually control your patches via .setDirty().
         * ```
         * \@type("string", { manual: true })
         * ```
         */ function type(type, options) {
                if (options === void 0) options = {};
                return function(target, field) {
                    var context = options.context || globalContext;
                    var constructor = target.constructor;
                    constructor._context = context;
                    if (!type) throw new Error("".concat(constructor.name, ': @type() reference provided for "').concat(field, "\" is undefined. Make sure you don't have any circular dependencies."));
                    /*
                 * static schema
                 */ if (!context.has(constructor)) context.add(constructor);
                    var definition = constructor._definition;
                    definition.addField(field, type);
                    /**
                 * skip if descriptor already exists for this field (`@deprecated()`)
                 */ if (definition.descriptors[field]) {
                        if (definition.deprecated[field]) // do not create accessors for deprecated properties.
                        return;
                        else // trying to define same property multiple times across inheritance.
                        // https://github.com/colyseus/colyseus-unity3d/issues/131#issuecomment-814308572
                        try {
                            throw new Error("@colyseus/schema: Duplicate '".concat(field, "' definition on '").concat(constructor.name, "'.\nCheck @type() annotation"));
                        } catch (e) {
                            var definitionAtLine = e.stack.split("\n")[4].trim();
                            throw new Error("".concat(e.message, " ").concat(definitionAtLine));
                        }
                    }
                    var isArray = ArraySchema.is(type);
                    var isMap = !isArray && MapSchema.is(type);
                    // TODO: refactor me.
                    // Allow abstract intermediary classes with no fields to be serialized
                    // (See "should support an inheritance with a Schema type without fields" test)
                    if (typeof type !== "string" && !Schema.is(type)) {
                        var childType = Object.values(type)[0];
                        if (typeof childType !== "string" && !context.has(childType)) context.add(childType);
                    }
                    if (options.manual) {
                        // do not declare getter/setter descriptor
                        definition.descriptors[field] = {
                            enumerable: true,
                            configurable: true,
                            writable: true
                        };
                        return;
                    }
                    var fieldCached = "_".concat(field);
                    definition.descriptors[fieldCached] = {
                        enumerable: false,
                        configurable: false,
                        writable: true
                    };
                    definition.descriptors[field] = {
                        get: function() {
                            return this[fieldCached];
                        },
                        set: function(value) {
                            /**
                         * Create Proxy for array or map items
                         */ // skip if value is the same as cached.
                            if (value === this[fieldCached]) return;
                            if (value !== undefined && value !== null) {
                                // automaticallty transform Array into ArraySchema
                                if (isArray && !(value instanceof ArraySchema)) value = new (ArraySchema.bind.apply(ArraySchema, __spreadArray([
                                    void 0
                                ], value, false)))();
                                // automaticallty transform Map into MapSchema
                                if (isMap && !(value instanceof MapSchema)) value = new MapSchema(value);
                                // try to turn provided structure into a Proxy
                                if (value["$proxy"] === undefined) {
                                    if (isMap) value = getMapProxy(value);
                                    else if (isArray) value = getArrayProxy(value);
                                }
                                // flag the change for encoding.
                                this.$changes.change(field);
                                //
                                // call setParent() recursively for this and its child
                                // structures.
                                //
                                if (value["$changes"]) value["$changes"].setParent(this, this.$changes.root, this._definition.indexes[field]);
                            } else if (this[fieldCached]) //
                            // Setting a field to `null` or `undefined` will delete it.
                            //
                            this.$changes.delete(field);
                            this[fieldCached] = value;
                        },
                        enumerable: true,
                        configurable: true
                    };
                };
            }
            /**
         * `@filter()` decorator for defining data filters per client
         */ function filter(cb) {
                return function(target, field) {
                    var constructor = target.constructor;
                    var definition = constructor._definition;
                    if (definition.addFilter(field, cb)) constructor._context.useFilters = true;
                };
            }
            function filterChildren(cb) {
                return function(target, field) {
                    var constructor = target.constructor;
                    var definition = constructor._definition;
                    if (definition.addChildrenFilter(field, cb)) constructor._context.useFilters = true;
                };
            }
            /**
         * `@deprecated()` flag a field as deprecated.
         * The previous `@type()` annotation should remain along with this one.
         */ function deprecated(throws) {
                if (throws === void 0) throws = true;
                return function(target, field) {
                    var constructor = target.constructor;
                    var definition = constructor._definition;
                    definition.deprecated[field] = true;
                    if (throws) definition.descriptors[field] = {
                        get: function() {
                            throw new Error("".concat(field, " is deprecated."));
                        },
                        set: function(value) {},
                        enumerable: false,
                        configurable: true
                    };
                };
            }
            function defineTypes(target, fields, options) {
                if (options === void 0) options = {};
                if (!options.context) options.context = target._context || options.context || globalContext;
                for(var field in fields)type(fields[field], options)(target.prototype, field);
                return target;
            }
            /**
         * Copyright (c) 2018 Endel Dreyer
         * Copyright (c) 2014 Ion Drive Software Ltd.
         *
         * Permission is hereby granted, free of charge, to any person obtaining a copy
         * of this software and associated documentation files (the "Software"), to deal
         * in the Software without restriction, including without limitation the rights
         * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
         * copies of the Software, and to permit persons to whom the Software is
         * furnished to do so, subject to the following conditions:
         *
         * The above copyright notice and this permission notice shall be included in all
         * copies or substantial portions of the Software.
         *
         * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
         * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
         * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
         * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
         * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
         * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
         * SOFTWARE
         */ /**
         * msgpack implementation highly based on notepack.io
         * https://github.com/darrachequesne/notepack
         */ function utf8Length(str) {
                var c = 0, length = 0;
                for(var i = 0, l = str.length; i < l; i++){
                    c = str.charCodeAt(i);
                    if (c < 0x80) length += 1;
                    else if (c < 0x800) length += 2;
                    else if (c < 0xd800 || c >= 0xe000) length += 3;
                    else {
                        i++;
                        length += 4;
                    }
                }
                return length;
            }
            function utf8Write(view, offset, str) {
                var c = 0;
                for(var i = 0, l = str.length; i < l; i++){
                    c = str.charCodeAt(i);
                    if (c < 0x80) view[offset++] = c;
                    else if (c < 0x800) {
                        view[offset++] = 0xc0 | c >> 6;
                        view[offset++] = 0x80 | c & 0x3f;
                    } else if (c < 0xd800 || c >= 0xe000) {
                        view[offset++] = 0xe0 | c >> 12;
                        view[offset++] = 0x80 | c >> 6 & 0x3f;
                        view[offset++] = 0x80 | c & 0x3f;
                    } else {
                        i++;
                        c = 0x10000 + ((c & 0x3ff) << 10 | str.charCodeAt(i) & 0x3ff);
                        view[offset++] = 0xf0 | c >> 18;
                        view[offset++] = 0x80 | c >> 12 & 0x3f;
                        view[offset++] = 0x80 | c >> 6 & 0x3f;
                        view[offset++] = 0x80 | c & 0x3f;
                    }
                }
            }
            function int8$1(bytes, value) {
                bytes.push(value & 255);
            }
            function uint8$1(bytes, value) {
                bytes.push(value & 255);
            }
            function int16$1(bytes, value) {
                bytes.push(value & 255);
                bytes.push(value >> 8 & 255);
            }
            function uint16$1(bytes, value) {
                bytes.push(value & 255);
                bytes.push(value >> 8 & 255);
            }
            function int32$1(bytes, value) {
                bytes.push(value & 255);
                bytes.push(value >> 8 & 255);
                bytes.push(value >> 16 & 255);
                bytes.push(value >> 24 & 255);
            }
            function uint32$1(bytes, value) {
                var b4 = value >> 24;
                var b3 = value >> 16;
                var b2 = value >> 8;
                var b1 = value;
                bytes.push(b1 & 255);
                bytes.push(b2 & 255);
                bytes.push(b3 & 255);
                bytes.push(b4 & 255);
            }
            function int64$1(bytes, value) {
                var high = Math.floor(value / Math.pow(2, 32));
                var low = value >>> 0;
                uint32$1(bytes, low);
                uint32$1(bytes, high);
            }
            function uint64$1(bytes, value) {
                var high = value / Math.pow(2, 32) >> 0;
                var low = value >>> 0;
                uint32$1(bytes, low);
                uint32$1(bytes, high);
            }
            function float32$1(bytes, value) {
                writeFloat32(bytes, value);
            }
            function float64$1(bytes, value) {
                writeFloat64(bytes, value);
            }
            var _int32$1 = new Int32Array(2);
            var _float32$1 = new Float32Array(_int32$1.buffer);
            var _float64$1 = new Float64Array(_int32$1.buffer);
            function writeFloat32(bytes, value) {
                _float32$1[0] = value;
                int32$1(bytes, _int32$1[0]);
            }
            function writeFloat64(bytes, value) {
                _float64$1[0] = value;
                int32$1(bytes, _int32$1[0]);
                int32$1(bytes, _int32$1[1]);
            }
            function boolean$1(bytes, value) {
                return uint8$1(bytes, value ? 1 : 0);
            }
            function string$1(bytes, value) {
                // encode `null` strings as empty.
                if (!value) value = "";
                var length = utf8Length(value);
                var size = 0;
                // fixstr
                if (length < 0x20) {
                    bytes.push(length | 0xa0);
                    size = 1;
                } else if (length < 0x100) {
                    bytes.push(0xd9);
                    uint8$1(bytes, length);
                    size = 2;
                } else if (length < 0x10000) {
                    bytes.push(0xda);
                    uint16$1(bytes, length);
                    size = 3;
                } else if (length < 0x100000000) {
                    bytes.push(0xdb);
                    uint32$1(bytes, length);
                    size = 5;
                } else throw new Error("String too long");
                utf8Write(bytes, bytes.length, value);
                return size + length;
            }
            function number$1(bytes, value) {
                if (isNaN(value)) return number$1(bytes, 0);
                else if (!isFinite(value)) return number$1(bytes, value > 0 ? Number.MAX_SAFE_INTEGER : -Number.MAX_SAFE_INTEGER);
                else if (value !== (value | 0)) {
                    bytes.push(0xcb);
                    writeFloat64(bytes, value);
                    return 9;
                // TODO: encode float 32?
                // is it possible to differentiate between float32 / float64 here?
                // // float 32
                // bytes.push(0xca);
                // writeFloat32(bytes, value);
                // return 5;
                }
                if (value >= 0) {
                    // positive fixnum
                    if (value < 0x80) {
                        uint8$1(bytes, value);
                        return 1;
                    }
                    // uint 8
                    if (value < 0x100) {
                        bytes.push(0xcc);
                        uint8$1(bytes, value);
                        return 2;
                    }
                    // uint 16
                    if (value < 0x10000) {
                        bytes.push(0xcd);
                        uint16$1(bytes, value);
                        return 3;
                    }
                    // uint 32
                    if (value < 0x100000000) {
                        bytes.push(0xce);
                        uint32$1(bytes, value);
                        return 5;
                    }
                    // uint 64
                    bytes.push(0xcf);
                    uint64$1(bytes, value);
                    return 9;
                } else {
                    // negative fixnum
                    if (value >= -32) {
                        bytes.push(0xe0 | value + 0x20);
                        return 1;
                    }
                    // int 8
                    if (value >= -128) {
                        bytes.push(0xd0);
                        int8$1(bytes, value);
                        return 2;
                    }
                    // int 16
                    if (value >= -32768) {
                        bytes.push(0xd1);
                        int16$1(bytes, value);
                        return 3;
                    }
                    // int 32
                    if (value >= -2147483648) {
                        bytes.push(0xd2);
                        int32$1(bytes, value);
                        return 5;
                    }
                    // int 64
                    bytes.push(0xd3);
                    int64$1(bytes, value);
                    return 9;
                }
            }
            var encode = /*#__PURE__*/ Object.freeze({
                __proto__: null,
                utf8Write: utf8Write,
                int8: int8$1,
                uint8: uint8$1,
                int16: int16$1,
                uint16: uint16$1,
                int32: int32$1,
                uint32: uint32$1,
                int64: int64$1,
                uint64: uint64$1,
                float32: float32$1,
                float64: float64$1,
                writeFloat32: writeFloat32,
                writeFloat64: writeFloat64,
                boolean: boolean$1,
                string: string$1,
                number: number$1
            });
            /**
         * Copyright (c) 2018 Endel Dreyer
         * Copyright (c) 2014 Ion Drive Software Ltd.
         *
         * Permission is hereby granted, free of charge, to any person obtaining a copy
         * of this software and associated documentation files (the "Software"), to deal
         * in the Software without restriction, including without limitation the rights
         * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
         * copies of the Software, and to permit persons to whom the Software is
         * furnished to do so, subject to the following conditions:
         *
         * The above copyright notice and this permission notice shall be included in all
         * copies or substantial portions of the Software.
         *
         * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
         * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
         * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
         * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
         * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
         * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
         * SOFTWARE
         */ function utf8Read(bytes, offset, length) {
                var string = "", chr = 0;
                for(var i = offset, end = offset + length; i < end; i++){
                    var byte = bytes[i];
                    if ((byte & 0x80) === 0x00) {
                        string += String.fromCharCode(byte);
                        continue;
                    }
                    if ((byte & 0xe0) === 0xc0) {
                        string += String.fromCharCode((byte & 0x1f) << 6 | bytes[++i] & 0x3f);
                        continue;
                    }
                    if ((byte & 0xf0) === 0xe0) {
                        string += String.fromCharCode((byte & 0x0f) << 12 | (bytes[++i] & 0x3f) << 6 | (bytes[++i] & 0x3f) << 0);
                        continue;
                    }
                    if ((byte & 0xf8) === 0xf0) {
                        chr = (byte & 0x07) << 18 | (bytes[++i] & 0x3f) << 12 | (bytes[++i] & 0x3f) << 6 | (bytes[++i] & 0x3f) << 0;
                        if (chr >= 0x010000) {
                            chr -= 0x010000;
                            string += String.fromCharCode((chr >>> 10) + 0xD800, (chr & 0x3FF) + 0xDC00);
                        } else string += String.fromCharCode(chr);
                        continue;
                    }
                    console.error("Invalid byte " + byte.toString(16));
                // (do not throw error to avoid server/client from crashing due to hack attemps)
                // throw new Error('Invalid byte ' + byte.toString(16));
                }
                return string;
            }
            function int8(bytes, it) {
                return uint8(bytes, it) << 24 >> 24;
            }
            function uint8(bytes, it) {
                return bytes[it.offset++];
            }
            function int16(bytes, it) {
                return uint16(bytes, it) << 16 >> 16;
            }
            function uint16(bytes, it) {
                return bytes[it.offset++] | bytes[it.offset++] << 8;
            }
            function int32(bytes, it) {
                return bytes[it.offset++] | bytes[it.offset++] << 8 | bytes[it.offset++] << 16 | bytes[it.offset++] << 24;
            }
            function uint32(bytes, it) {
                return int32(bytes, it) >>> 0;
            }
            function float32(bytes, it) {
                return readFloat32(bytes, it);
            }
            function float64(bytes, it) {
                return readFloat64(bytes, it);
            }
            function int64(bytes, it) {
                var low = uint32(bytes, it);
                var high = int32(bytes, it) * Math.pow(2, 32);
                return high + low;
            }
            function uint64(bytes, it) {
                var low = uint32(bytes, it);
                var high = uint32(bytes, it) * Math.pow(2, 32);
                return high + low;
            }
            var _int32 = new Int32Array(2);
            var _float32 = new Float32Array(_int32.buffer);
            var _float64 = new Float64Array(_int32.buffer);
            function readFloat32(bytes, it) {
                _int32[0] = int32(bytes, it);
                return _float32[0];
            }
            function readFloat64(bytes, it) {
                _int32[0] = int32(bytes, it);
                _int32[1] = int32(bytes, it);
                return _float64[0];
            }
            function boolean(bytes, it) {
                return uint8(bytes, it) > 0;
            }
            function string(bytes, it) {
                var prefix = bytes[it.offset++];
                var length;
                if (prefix < 0xc0) // fixstr
                length = prefix & 0x1f;
                else if (prefix === 0xd9) length = uint8(bytes, it);
                else if (prefix === 0xda) length = uint16(bytes, it);
                else if (prefix === 0xdb) length = uint32(bytes, it);
                var value = utf8Read(bytes, it.offset, length);
                it.offset += length;
                return value;
            }
            function stringCheck(bytes, it) {
                var prefix = bytes[it.offset];
                return(// fixstr
                prefix < 0xc0 && prefix > 0xa0 || // str 8
                prefix === 0xd9 || // str 16
                prefix === 0xda || // str 32
                prefix === 0xdb);
            }
            function number(bytes, it) {
                var prefix = bytes[it.offset++];
                if (prefix < 0x80) // positive fixint
                return prefix;
                else if (prefix === 0xca) // float 32
                return readFloat32(bytes, it);
                else if (prefix === 0xcb) // float 64
                return readFloat64(bytes, it);
                else if (prefix === 0xcc) // uint 8
                return uint8(bytes, it);
                else if (prefix === 0xcd) // uint 16
                return uint16(bytes, it);
                else if (prefix === 0xce) // uint 32
                return uint32(bytes, it);
                else if (prefix === 0xcf) // uint 64
                return uint64(bytes, it);
                else if (prefix === 0xd0) // int 8
                return int8(bytes, it);
                else if (prefix === 0xd1) // int 16
                return int16(bytes, it);
                else if (prefix === 0xd2) // int 32
                return int32(bytes, it);
                else if (prefix === 0xd3) // int 64
                return int64(bytes, it);
                else if (prefix > 0xdf) // negative fixint
                return (0xff - prefix + 1) * -1;
            }
            function numberCheck(bytes, it) {
                var prefix = bytes[it.offset];
                // positive fixint - 0x00 - 0x7f
                // float 32        - 0xca
                // float 64        - 0xcb
                // uint 8          - 0xcc
                // uint 16         - 0xcd
                // uint 32         - 0xce
                // uint 64         - 0xcf
                // int 8           - 0xd0
                // int 16          - 0xd1
                // int 32          - 0xd2
                // int 64          - 0xd3
                return prefix < 0x80 || prefix >= 0xca && prefix <= 0xd3;
            }
            function arrayCheck(bytes, it) {
                return bytes[it.offset] < 0xa0;
            // const prefix = bytes[it.offset] ;
            // if (prefix < 0xa0) {
            //   return prefix;
            // // array
            // } else if (prefix === 0xdc) {
            //   it.offset += 2;
            // } else if (0xdd) {
            //   it.offset += 4;
            // }
            // return prefix;
            }
            function switchStructureCheck(bytes, it) {
                return(// previous byte should be `SWITCH_TO_STRUCTURE`
                bytes[it.offset - 1] === SWITCH_TO_STRUCTURE && // next byte should be a number
                (bytes[it.offset] < 0x80 || bytes[it.offset] >= 0xca && bytes[it.offset] <= 0xd3));
            }
            var decode = /*#__PURE__*/ Object.freeze({
                __proto__: null,
                int8: int8,
                uint8: uint8,
                int16: int16,
                uint16: uint16,
                int32: int32,
                uint32: uint32,
                float32: float32,
                float64: float64,
                int64: int64,
                uint64: uint64,
                readFloat32: readFloat32,
                readFloat64: readFloat64,
                boolean: boolean,
                string: string,
                stringCheck: stringCheck,
                number: number,
                numberCheck: numberCheck,
                arrayCheck: arrayCheck,
                switchStructureCheck: switchStructureCheck
            });
            var CollectionSchema = /** @class */ function() {
                function CollectionSchema(initialValues) {
                    var _this = this;
                    this.$changes = new ChangeTree(this);
                    this.$items = new Map();
                    this.$indexes = new Map();
                    this.$refId = 0;
                    if (initialValues) initialValues.forEach(function(v) {
                        return _this.add(v);
                    });
                }
                CollectionSchema.prototype.onAdd = function(callback, triggerAll) {
                    if (triggerAll === void 0) triggerAll = true;
                    return addCallback(this.$callbacks || (this.$callbacks = []), exports1.OPERATION.ADD, callback, triggerAll ? this.$items : undefined);
                };
                CollectionSchema.prototype.onRemove = function(callback) {
                    return addCallback(this.$callbacks || (this.$callbacks = []), exports1.OPERATION.DELETE, callback);
                };
                CollectionSchema.prototype.onChange = function(callback) {
                    return addCallback(this.$callbacks || (this.$callbacks = []), exports1.OPERATION.REPLACE, callback);
                };
                CollectionSchema.is = function(type) {
                    return type["collection"] !== undefined;
                };
                CollectionSchema.prototype.add = function(value) {
                    // set "index" for reference.
                    var index = this.$refId++;
                    var isRef = value["$changes"] !== undefined;
                    if (isRef) value["$changes"].setParent(this, this.$changes.root, index);
                    this.$changes.indexes[index] = index;
                    this.$indexes.set(index, index);
                    this.$items.set(index, value);
                    this.$changes.change(index);
                    return index;
                };
                CollectionSchema.prototype.at = function(index) {
                    var key = Array.from(this.$items.keys())[index];
                    return this.$items.get(key);
                };
                CollectionSchema.prototype.entries = function() {
                    return this.$items.entries();
                };
                CollectionSchema.prototype.delete = function(item) {
                    var entries = this.$items.entries();
                    var index;
                    var entry;
                    while(entry = entries.next()){
                        if (entry.done) break;
                        if (item === entry.value[1]) {
                            index = entry.value[0];
                            break;
                        }
                    }
                    if (index === undefined) return false;
                    this.$changes.delete(index);
                    this.$indexes.delete(index);
                    return this.$items.delete(index);
                };
                CollectionSchema.prototype.clear = function(changes) {
                    // discard previous operations.
                    this.$changes.discard(true, true);
                    this.$changes.indexes = {};
                    // clear previous indexes
                    this.$indexes.clear();
                    //
                    // When decoding:
                    // - enqueue items for DELETE callback.
                    // - flag child items for garbage collection.
                    //
                    if (changes) removeChildRefs.call(this, changes);
                    // clear items
                    this.$items.clear();
                    this.$changes.operation({
                        index: 0,
                        op: exports1.OPERATION.CLEAR
                    });
                    // touch all structures until reach root
                    this.$changes.touchParents();
                };
                CollectionSchema.prototype.has = function(value) {
                    return Array.from(this.$items.values()).some(function(v) {
                        return v === value;
                    });
                };
                CollectionSchema.prototype.forEach = function(callbackfn) {
                    var _this = this;
                    this.$items.forEach(function(value, key, _) {
                        return callbackfn(value, key, _this);
                    });
                };
                CollectionSchema.prototype.values = function() {
                    return this.$items.values();
                };
                Object.defineProperty(CollectionSchema.prototype, "size", {
                    get: function() {
                        return this.$items.size;
                    },
                    enumerable: false,
                    configurable: true
                });
                CollectionSchema.prototype.setIndex = function(index, key) {
                    this.$indexes.set(index, key);
                };
                CollectionSchema.prototype.getIndex = function(index) {
                    return this.$indexes.get(index);
                };
                CollectionSchema.prototype.getByIndex = function(index) {
                    return this.$items.get(this.$indexes.get(index));
                };
                CollectionSchema.prototype.deleteByIndex = function(index) {
                    var key = this.$indexes.get(index);
                    this.$items.delete(key);
                    this.$indexes.delete(index);
                };
                CollectionSchema.prototype.toArray = function() {
                    return Array.from(this.$items.values());
                };
                CollectionSchema.prototype.toJSON = function() {
                    var values = [];
                    this.forEach(function(value, key) {
                        values.push(typeof value["toJSON"] === "function" ? value["toJSON"]() : value);
                    });
                    return values;
                };
                //
                // Decoding utilities
                //
                CollectionSchema.prototype.clone = function(isDecoding) {
                    var cloned;
                    if (isDecoding) // client-side
                    cloned = Object.assign(new CollectionSchema(), this);
                    else {
                        // server-side
                        cloned = new CollectionSchema();
                        this.forEach(function(value) {
                            if (value["$changes"]) cloned.add(value["clone"]());
                            else cloned.add(value);
                        });
                    }
                    return cloned;
                };
                return CollectionSchema;
            }();
            var SetSchema = /** @class */ function() {
                function SetSchema(initialValues) {
                    var _this = this;
                    this.$changes = new ChangeTree(this);
                    this.$items = new Map();
                    this.$indexes = new Map();
                    this.$refId = 0;
                    if (initialValues) initialValues.forEach(function(v) {
                        return _this.add(v);
                    });
                }
                SetSchema.prototype.onAdd = function(callback, triggerAll) {
                    if (triggerAll === void 0) triggerAll = true;
                    return addCallback(this.$callbacks || (this.$callbacks = []), exports1.OPERATION.ADD, callback, triggerAll ? this.$items : undefined);
                };
                SetSchema.prototype.onRemove = function(callback) {
                    return addCallback(this.$callbacks || (this.$callbacks = []), exports1.OPERATION.DELETE, callback);
                };
                SetSchema.prototype.onChange = function(callback) {
                    return addCallback(this.$callbacks || (this.$callbacks = []), exports1.OPERATION.REPLACE, callback);
                };
                SetSchema.is = function(type) {
                    return type["set"] !== undefined;
                };
                SetSchema.prototype.add = function(value) {
                    var _a, _b;
                    // immediatelly return false if value already added.
                    if (this.has(value)) return false;
                    // set "index" for reference.
                    var index = this.$refId++;
                    if (value["$changes"] !== undefined) value["$changes"].setParent(this, this.$changes.root, index);
                    var operation = (_b = (_a = this.$changes.indexes[index]) === null || _a === void 0 ? void 0 : _a.op) !== null && _b !== void 0 ? _b : exports1.OPERATION.ADD;
                    this.$changes.indexes[index] = index;
                    this.$indexes.set(index, index);
                    this.$items.set(index, value);
                    this.$changes.change(index, operation);
                    return index;
                };
                SetSchema.prototype.entries = function() {
                    return this.$items.entries();
                };
                SetSchema.prototype.delete = function(item) {
                    var entries = this.$items.entries();
                    var index;
                    var entry;
                    while(entry = entries.next()){
                        if (entry.done) break;
                        if (item === entry.value[1]) {
                            index = entry.value[0];
                            break;
                        }
                    }
                    if (index === undefined) return false;
                    this.$changes.delete(index);
                    this.$indexes.delete(index);
                    return this.$items.delete(index);
                };
                SetSchema.prototype.clear = function(changes) {
                    // discard previous operations.
                    this.$changes.discard(true, true);
                    this.$changes.indexes = {};
                    // clear previous indexes
                    this.$indexes.clear();
                    //
                    // When decoding:
                    // - enqueue items for DELETE callback.
                    // - flag child items for garbage collection.
                    //
                    if (changes) removeChildRefs.call(this, changes);
                    // clear items
                    this.$items.clear();
                    this.$changes.operation({
                        index: 0,
                        op: exports1.OPERATION.CLEAR
                    });
                    // touch all structures until reach root
                    this.$changes.touchParents();
                };
                SetSchema.prototype.has = function(value) {
                    var values = this.$items.values();
                    var has = false;
                    var entry;
                    while(entry = values.next()){
                        if (entry.done) break;
                        if (value === entry.value) {
                            has = true;
                            break;
                        }
                    }
                    return has;
                };
                SetSchema.prototype.forEach = function(callbackfn) {
                    var _this = this;
                    this.$items.forEach(function(value, key, _) {
                        return callbackfn(value, key, _this);
                    });
                };
                SetSchema.prototype.values = function() {
                    return this.$items.values();
                };
                Object.defineProperty(SetSchema.prototype, "size", {
                    get: function() {
                        return this.$items.size;
                    },
                    enumerable: false,
                    configurable: true
                });
                SetSchema.prototype.setIndex = function(index, key) {
                    this.$indexes.set(index, key);
                };
                SetSchema.prototype.getIndex = function(index) {
                    return this.$indexes.get(index);
                };
                SetSchema.prototype.getByIndex = function(index) {
                    return this.$items.get(this.$indexes.get(index));
                };
                SetSchema.prototype.deleteByIndex = function(index) {
                    var key = this.$indexes.get(index);
                    this.$items.delete(key);
                    this.$indexes.delete(index);
                };
                SetSchema.prototype.toArray = function() {
                    return Array.from(this.$items.values());
                };
                SetSchema.prototype.toJSON = function() {
                    var values = [];
                    this.forEach(function(value, key) {
                        values.push(typeof value["toJSON"] === "function" ? value["toJSON"]() : value);
                    });
                    return values;
                };
                //
                // Decoding utilities
                //
                SetSchema.prototype.clone = function(isDecoding) {
                    var cloned;
                    if (isDecoding) // client-side
                    cloned = Object.assign(new SetSchema(), this);
                    else {
                        // server-side
                        cloned = new SetSchema();
                        this.forEach(function(value) {
                            if (value["$changes"]) cloned.add(value["clone"]());
                            else cloned.add(value);
                        });
                    }
                    return cloned;
                };
                return SetSchema;
            }();
            var ClientState = /** @class */ function() {
                function ClientState() {
                    this.refIds = new WeakSet();
                    this.containerIndexes = new WeakMap();
                }
                // containerIndexes = new Map<ChangeTree, Set<number>>();
                ClientState.prototype.addRefId = function(changeTree) {
                    if (!this.refIds.has(changeTree)) {
                        this.refIds.add(changeTree);
                        this.containerIndexes.set(changeTree, new Set());
                    }
                };
                ClientState.get = function(client) {
                    if (client.$filterState === undefined) client.$filterState = new ClientState();
                    return client.$filterState;
                };
                return ClientState;
            }();
            var ReferenceTracker = /** @class */ function() {
                function ReferenceTracker() {
                    //
                    // Relation of refId => Schema structure
                    // For direct access of structures during decoding time.
                    //
                    this.refs = new Map();
                    this.refCounts = {};
                    this.deletedRefs = new Set();
                    this.nextUniqueId = 0;
                }
                ReferenceTracker.prototype.getNextUniqueId = function() {
                    return this.nextUniqueId++;
                };
                // for decoding
                ReferenceTracker.prototype.addRef = function(refId, ref, incrementCount) {
                    if (incrementCount === void 0) incrementCount = true;
                    this.refs.set(refId, ref);
                    if (incrementCount) this.refCounts[refId] = (this.refCounts[refId] || 0) + 1;
                };
                // for decoding
                ReferenceTracker.prototype.removeRef = function(refId) {
                    this.refCounts[refId] = this.refCounts[refId] - 1;
                    this.deletedRefs.add(refId);
                };
                ReferenceTracker.prototype.clearRefs = function() {
                    this.refs.clear();
                    this.deletedRefs.clear();
                    this.refCounts = {};
                };
                // for decoding
                ReferenceTracker.prototype.garbageCollectDeletedRefs = function() {
                    var _this = this;
                    this.deletedRefs.forEach(function(refId) {
                        //
                        // Skip active references.
                        //
                        if (_this.refCounts[refId] > 0) return;
                        var ref = _this.refs.get(refId);
                        //
                        // Ensure child schema instances have their references removed as well.
                        //
                        if (ref instanceof Schema) {
                            for(var fieldName in ref["_definition"].schema)if (typeof ref["_definition"].schema[fieldName] !== "string" && ref[fieldName] && ref[fieldName]["$changes"]) _this.removeRef(ref[fieldName]["$changes"].refId);
                        } else {
                            var definition = ref["$changes"].parent._definition;
                            var type = definition.schema[definition.fieldsByIndex[ref["$changes"].parentIndex]];
                            if (typeof Object.values(type)[0] === "function") Array.from(ref.values()).forEach(function(child) {
                                return _this.removeRef(child["$changes"].refId);
                            });
                        }
                        _this.refs.delete(refId);
                        delete _this.refCounts[refId];
                    });
                    // clear deleted refs.
                    this.deletedRefs.clear();
                };
                return ReferenceTracker;
            }();
            var EncodeSchemaError = /** @class */ function(_super) {
                __extends(EncodeSchemaError, _super);
                function EncodeSchemaError() {
                    return _super !== null && _super.apply(this, arguments) || this;
                }
                return EncodeSchemaError;
            }(Error);
            function assertType(value, type, klass, field) {
                var typeofTarget;
                var allowNull = false;
                switch(type){
                    case "number":
                    case "int8":
                    case "uint8":
                    case "int16":
                    case "uint16":
                    case "int32":
                    case "uint32":
                    case "int64":
                    case "uint64":
                    case "float32":
                    case "float64":
                        typeofTarget = "number";
                        if (isNaN(value)) console.log('trying to encode "NaN" in '.concat(klass.constructor.name, "#").concat(field));
                        break;
                    case "string":
                        typeofTarget = "string";
                        allowNull = true;
                        break;
                    case "boolean":
                        // boolean is always encoded as true/false based on truthiness
                        return;
                }
                if (typeof value !== typeofTarget && (!allowNull || allowNull && value !== null)) {
                    var foundValue = "'".concat(JSON.stringify(value), "'").concat(value && value.constructor && " (".concat(value.constructor.name, ")") || "");
                    throw new EncodeSchemaError("a '".concat(typeofTarget, "' was expected, but ").concat(foundValue, " was provided in ").concat(klass.constructor.name, "#").concat(field));
                }
            }
            function assertInstanceType(value, type, klass, field) {
                if (!(value instanceof type)) throw new EncodeSchemaError("a '".concat(type.name, "' was expected, but '").concat(value.constructor.name, "' was provided in ").concat(klass.constructor.name, "#").concat(field));
            }
            function encodePrimitiveType(type, bytes, value, klass, field) {
                assertType(value, type, klass, field);
                var encodeFunc = encode[type];
                if (encodeFunc) encodeFunc(bytes, value);
                else throw new EncodeSchemaError("a '".concat(type, "' was expected, but ").concat(value, " was provided in ").concat(klass.constructor.name, "#").concat(field));
            }
            function decodePrimitiveType(type, bytes, it) {
                return decode[type](bytes, it);
            }
            /**
         * Schema encoder / decoder
         */ var Schema = /** @class */ function() {
                // allow inherited classes to have a constructor
                function Schema() {
                    var args = [];
                    for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
                    // fix enumerability of fields for end-user
                    Object.defineProperties(this, {
                        $changes: {
                            value: new ChangeTree(this, undefined, new ReferenceTracker()),
                            enumerable: false,
                            writable: true
                        },
                        // $listeners: {
                        //     value: undefined,
                        //     enumerable: false,
                        //     writable: true
                        // },
                        $callbacks: {
                            value: undefined,
                            enumerable: false,
                            writable: true
                        }
                    });
                    var descriptors = this._definition.descriptors;
                    if (descriptors) Object.defineProperties(this, descriptors);
                    //
                    // Assign initial values
                    //
                    if (args[0]) this.assign(args[0]);
                }
                Schema.onError = function(e) {
                    console.error(e);
                };
                Schema.is = function(type) {
                    return type["_definition"] && type["_definition"].schema !== undefined;
                };
                Schema.prototype.onChange = function(callback) {
                    return addCallback(this.$callbacks || (this.$callbacks = []), exports1.OPERATION.REPLACE, callback);
                };
                Schema.prototype.onRemove = function(callback) {
                    return addCallback(this.$callbacks || (this.$callbacks = []), exports1.OPERATION.DELETE, callback);
                };
                Schema.prototype.assign = function(props) {
                    Object.assign(this, props);
                    return this;
                };
                Object.defineProperty(Schema.prototype, "_definition", {
                    get: function() {
                        return this.constructor._definition;
                    },
                    enumerable: false,
                    configurable: true
                });
                /**
             * (Server-side): Flag a property to be encoded for the next patch.
             * @param instance Schema instance
             * @param property string representing the property name, or number representing the index of the property.
             * @param operation OPERATION to perform (detected automatically)
             */ Schema.prototype.setDirty = function(property, operation) {
                    this.$changes.change(property, operation);
                };
                /**
             * Client-side: listen for changes on property.
             * @param prop the property name
             * @param callback callback to be triggered on property change
             * @param immediate trigger immediatelly if property has been already set.
             */ Schema.prototype.listen = function(prop, callback, immediate) {
                    var _this = this;
                    if (immediate === void 0) immediate = true;
                    if (!this.$callbacks) this.$callbacks = {};
                    if (!this.$callbacks[prop]) this.$callbacks[prop] = [];
                    this.$callbacks[prop].push(callback);
                    if (immediate && this[prop] !== undefined) callback(this[prop], undefined);
                    // return un-register callback.
                    return function() {
                        return spliceOne(_this.$callbacks[prop], _this.$callbacks[prop].indexOf(callback));
                    };
                };
                Schema.prototype.decode = function(bytes, it, ref) {
                    var _a;
                    if (it === void 0) it = {
                        offset: 0
                    };
                    if (ref === void 0) ref = this;
                    var allChanges = [];
                    var $root = this.$changes.root;
                    var totalBytes = bytes.length;
                    var refId = 0;
                    $root.refs.set(refId, this);
                    while(it.offset < totalBytes){
                        var byte = bytes[it.offset++];
                        if (byte == SWITCH_TO_STRUCTURE) {
                            refId = number(bytes, it);
                            var nextRef = $root.refs.get(refId);
                            //
                            // Trying to access a reference that haven't been decoded yet.
                            //
                            if (!nextRef) throw new Error('"refId" not found: '.concat(refId));
                            ref = nextRef;
                            continue;
                        }
                        var changeTree = ref["$changes"];
                        var isSchema = ref["_definition"] !== undefined;
                        var operation = isSchema ? byte >> 6 << 6 // "compressed" index + operation
                         : byte; // "uncompressed" index + operation (array/map items)
                        if (operation === exports1.OPERATION.CLEAR) {
                            //
                            // TODO: refactor me!
                            // The `.clear()` method is calling `$root.removeRef(refId)` for
                            // each item inside this collection
                            //
                            ref.clear(allChanges);
                            continue;
                        }
                        var fieldIndex = isSchema ? byte % (operation || 255 // if "REPLACE" operation (0), use 255
                        ) : number(bytes, it);
                        var fieldName = isSchema ? ref["_definition"].fieldsByIndex[fieldIndex] : "";
                        var type = changeTree.getType(fieldIndex);
                        var value = void 0;
                        var previousValue = void 0;
                        var dynamicIndex = void 0;
                        if (!isSchema) {
                            previousValue = ref["getByIndex"](fieldIndex);
                            if ((operation & exports1.OPERATION.ADD) === exports1.OPERATION.ADD) {
                                dynamicIndex = ref instanceof MapSchema ? string(bytes, it) : fieldIndex;
                                ref["setIndex"](fieldIndex, dynamicIndex);
                            } else // here
                            dynamicIndex = ref["getIndex"](fieldIndex);
                        } else previousValue = ref["_".concat(fieldName)];
                        //
                        // Delete operations
                        //
                        if ((operation & exports1.OPERATION.DELETE) === exports1.OPERATION.DELETE) {
                            if (operation !== exports1.OPERATION.DELETE_AND_ADD) ref["deleteByIndex"](fieldIndex);
                            // Flag `refId` for garbage collection.
                            if (previousValue && previousValue["$changes"]) $root.removeRef(previousValue["$changes"].refId);
                            value = null;
                        }
                        if (fieldName === undefined) {
                            console.warn("@colyseus/schema: definition mismatch");
                            //
                            // keep skipping next bytes until reaches a known structure
                            // by local decoder.
                            //
                            var nextIterator = {
                                offset: it.offset
                            };
                            while(it.offset < totalBytes){
                                if (switchStructureCheck(bytes, it)) {
                                    nextIterator.offset = it.offset + 1;
                                    if ($root.refs.has(number(bytes, nextIterator))) break;
                                }
                                it.offset++;
                            }
                            continue;
                        } else if (operation === exports1.OPERATION.DELETE) ;
                        else if (Schema.is(type)) {
                            var refId_1 = number(bytes, it);
                            value = $root.refs.get(refId_1);
                            if (operation !== exports1.OPERATION.REPLACE) {
                                var childType = this.getSchemaType(bytes, it, type);
                                if (!value) {
                                    value = this.createTypeInstance(childType);
                                    value.$changes.refId = refId_1;
                                    if (previousValue) {
                                        value.$callbacks = previousValue.$callbacks;
                                        // value.$listeners = previousValue.$listeners;
                                        if (previousValue["$changes"].refId && refId_1 !== previousValue["$changes"].refId) $root.removeRef(previousValue["$changes"].refId);
                                    }
                                }
                                $root.addRef(refId_1, value, value !== previousValue);
                            }
                        } else if (typeof type === "string") //
                        // primitive value (number, string, boolean, etc)
                        //
                        value = decodePrimitiveType(type, bytes, it);
                        else {
                            var typeDef = getType(Object.keys(type)[0]);
                            var refId_2 = number(bytes, it);
                            var valueRef = $root.refs.has(refId_2) ? previousValue || $root.refs.get(refId_2) : new typeDef.constructor();
                            value = valueRef.clone(true);
                            value.$changes.refId = refId_2;
                            // preserve schema callbacks
                            if (previousValue) {
                                value["$callbacks"] = previousValue["$callbacks"];
                                if (previousValue["$changes"].refId && refId_2 !== previousValue["$changes"].refId) {
                                    $root.removeRef(previousValue["$changes"].refId);
                                    //
                                    // Trigger onRemove if structure has been replaced.
                                    //
                                    var entries = previousValue.entries();
                                    var iter = void 0;
                                    while((iter = entries.next()) && !iter.done){
                                        var key = (_a = iter.value, _a[0]), value_1 = _a[1];
                                        allChanges.push({
                                            refId: refId_2,
                                            op: exports1.OPERATION.DELETE,
                                            field: key,
                                            value: undefined,
                                            previousValue: value_1
                                        });
                                    }
                                }
                            }
                            $root.addRef(refId_2, value, valueRef !== previousValue);
                        }
                        if (value !== null && value !== undefined) {
                            if (value["$changes"]) value["$changes"].setParent(changeTree.ref, changeTree.root, fieldIndex);
                            if (ref instanceof Schema) ref[fieldName] = value;
                            else if (ref instanceof MapSchema) {
                                // const key = ref['$indexes'].get(field);
                                var key = dynamicIndex;
                                // ref.set(key, value);
                                ref["$items"].set(key, value);
                                ref["$changes"].allChanges.add(fieldIndex);
                            } else if (ref instanceof ArraySchema) // const key = ref['$indexes'][field];
                            // console.log("SETTING FOR ArraySchema =>", { field, key, value });
                            // ref[key] = value;
                            ref.setAt(fieldIndex, value);
                            else if (ref instanceof CollectionSchema) {
                                var index = ref.add(value);
                                ref["setIndex"](fieldIndex, index);
                            } else if (ref instanceof SetSchema) {
                                var index = ref.add(value);
                                if (index !== false) ref["setIndex"](fieldIndex, index);
                            }
                        }
                        if (previousValue !== value) allChanges.push({
                            refId: refId,
                            op: operation,
                            field: fieldName,
                            dynamicIndex: dynamicIndex,
                            value: value,
                            previousValue: previousValue
                        });
                    }
                    this._triggerChanges(allChanges);
                    // drop references of unused schemas
                    $root.garbageCollectDeletedRefs();
                    return allChanges;
                };
                Schema.prototype.encode = function(encodeAll, bytes, useFilters) {
                    if (encodeAll === void 0) encodeAll = false;
                    if (bytes === void 0) bytes = [];
                    if (useFilters === void 0) useFilters = false;
                    var rootChangeTree = this.$changes;
                    var refIdsVisited = new WeakSet();
                    var changeTrees = [
                        rootChangeTree
                    ];
                    var numChangeTrees = 1;
                    for(var i = 0; i < numChangeTrees; i++){
                        var changeTree = changeTrees[i];
                        var ref = changeTree.ref;
                        var isSchema = ref instanceof Schema;
                        // Generate unique refId for the ChangeTree.
                        changeTree.ensureRefId();
                        // mark this ChangeTree as visited.
                        refIdsVisited.add(changeTree);
                        // root `refId` is skipped.
                        if (changeTree !== rootChangeTree && (changeTree.changed || encodeAll)) {
                            uint8$1(bytes, SWITCH_TO_STRUCTURE);
                            number$1(bytes, changeTree.refId);
                        }
                        var changes = encodeAll ? Array.from(changeTree.allChanges) : Array.from(changeTree.changes.values());
                        for(var j = 0, cl = changes.length; j < cl; j++){
                            var operation = encodeAll ? {
                                op: exports1.OPERATION.ADD,
                                index: changes[j]
                            } : changes[j];
                            var fieldIndex = operation.index;
                            var field = isSchema ? ref["_definition"].fieldsByIndex && ref["_definition"].fieldsByIndex[fieldIndex] : fieldIndex;
                            // cache begin index if `useFilters`
                            var beginIndex = bytes.length;
                            // encode field index + operation
                            if (operation.op !== exports1.OPERATION.TOUCH) {
                                if (isSchema) //
                                // Compress `fieldIndex` + `operation` into a single byte.
                                // This adds a limitaion of 64 fields per Schema structure
                                //
                                uint8$1(bytes, fieldIndex | operation.op);
                                else {
                                    uint8$1(bytes, operation.op);
                                    // custom operations
                                    if (operation.op === exports1.OPERATION.CLEAR) continue;
                                    // indexed operations
                                    number$1(bytes, fieldIndex);
                                }
                            }
                            //
                            // encode "alias" for dynamic fields (maps)
                            //
                            if (!isSchema && (operation.op & exports1.OPERATION.ADD) == exports1.OPERATION.ADD // ADD or DELETE_AND_ADD
                            ) {
                                if (ref instanceof MapSchema) {
                                    //
                                    // MapSchema dynamic key
                                    //
                                    var dynamicIndex = changeTree.ref["$indexes"].get(fieldIndex);
                                    string$1(bytes, dynamicIndex);
                                }
                            }
                            if (operation.op === exports1.OPERATION.DELETE) continue;
                            // const type = changeTree.childType || ref._schema[field];
                            var type = changeTree.getType(fieldIndex);
                            // const type = changeTree.getType(fieldIndex);
                            var value = changeTree.getValue(fieldIndex);
                            // Enqueue ChangeTree to be visited
                            if (value && value["$changes"] && !refIdsVisited.has(value["$changes"])) {
                                changeTrees.push(value["$changes"]);
                                value["$changes"].ensureRefId();
                                numChangeTrees++;
                            }
                            if (operation.op === exports1.OPERATION.TOUCH) continue;
                            if (Schema.is(type)) {
                                assertInstanceType(value, type, ref, field);
                                //
                                // Encode refId for this instance.
                                // The actual instance is going to be encoded on next `changeTree` iteration.
                                //
                                number$1(bytes, value.$changes.refId);
                                // Try to encode inherited TYPE_ID if it's an ADD operation.
                                if ((operation.op & exports1.OPERATION.ADD) === exports1.OPERATION.ADD) this.tryEncodeTypeId(bytes, type, value.constructor);
                            } else if (typeof type === "string") //
                            // Primitive values
                            //
                            encodePrimitiveType(type, bytes, value, ref, field);
                            else {
                                //
                                // Custom type (MapSchema, ArraySchema, etc)
                                //
                                var definition = getType(Object.keys(type)[0]);
                                //
                                // ensure a ArraySchema has been provided
                                //
                                assertInstanceType(ref["_".concat(field)], definition.constructor, ref, field);
                                //
                                // Encode refId for this instance.
                                // The actual instance is going to be encoded on next `changeTree` iteration.
                                //
                                number$1(bytes, value.$changes.refId);
                            }
                            if (useFilters) // cache begin / end index
                            changeTree.cache(fieldIndex, bytes.slice(beginIndex));
                        }
                        if (!encodeAll && !useFilters) changeTree.discard();
                    }
                    return bytes;
                };
                Schema.prototype.encodeAll = function(useFilters) {
                    return this.encode(true, [], useFilters);
                };
                Schema.prototype.applyFilters = function(client, encodeAll) {
                    var _a, _b;
                    if (encodeAll === void 0) encodeAll = false;
                    var root = this;
                    var refIdsDissallowed = new Set();
                    var $filterState = ClientState.get(client);
                    var changeTrees = [
                        this.$changes
                    ];
                    var numChangeTrees = 1;
                    var filteredBytes = [];
                    var _loop_1 = function(i) {
                        var changeTree = changeTrees[i];
                        if (refIdsDissallowed.has(changeTree.refId)) return "continue";
                        var ref = changeTree.ref;
                        var isSchema = ref instanceof Schema;
                        uint8$1(filteredBytes, SWITCH_TO_STRUCTURE);
                        number$1(filteredBytes, changeTree.refId);
                        var clientHasRefId = $filterState.refIds.has(changeTree);
                        var isEncodeAll = encodeAll || !clientHasRefId;
                        // console.log("REF:", ref.constructor.name);
                        // console.log("Encode all?", isEncodeAll);
                        //
                        // include `changeTree` on list of known refIds by this client.
                        //
                        $filterState.addRefId(changeTree);
                        var containerIndexes = $filterState.containerIndexes.get(changeTree);
                        var changes = isEncodeAll ? Array.from(changeTree.allChanges) : Array.from(changeTree.changes.values());
                        //
                        // WORKAROUND: tries to re-evaluate previously not included @filter() attributes
                        // - see "DELETE a field of Schema" test case.
                        //
                        if (!encodeAll && isSchema && ref._definition.indexesWithFilters) {
                            var indexesWithFilters = ref._definition.indexesWithFilters;
                            indexesWithFilters.forEach(function(indexWithFilter) {
                                if (!containerIndexes.has(indexWithFilter) && changeTree.allChanges.has(indexWithFilter)) {
                                    if (isEncodeAll) changes.push(indexWithFilter);
                                    else changes.push({
                                        op: exports1.OPERATION.ADD,
                                        index: indexWithFilter
                                    });
                                }
                            });
                        }
                        for(var j = 0, cl = changes.length; j < cl; j++){
                            var change = isEncodeAll ? {
                                op: exports1.OPERATION.ADD,
                                index: changes[j]
                            } : changes[j];
                            // custom operations
                            if (change.op === exports1.OPERATION.CLEAR) {
                                uint8$1(filteredBytes, change.op);
                                continue;
                            }
                            var fieldIndex = change.index;
                            //
                            // Deleting fields: encode the operation + field index
                            //
                            if (change.op === exports1.OPERATION.DELETE) {
                                //
                                // DELETE operations also need to go through filtering.
                                //
                                // TODO: cache the previous value so we can access the value (primitive or `refId`)
                                // (check against `$filterState.refIds`)
                                //
                                if (isSchema) uint8$1(filteredBytes, change.op | fieldIndex);
                                else {
                                    uint8$1(filteredBytes, change.op);
                                    number$1(filteredBytes, fieldIndex);
                                }
                                continue;
                            }
                            // indexed operation
                            var value = changeTree.getValue(fieldIndex);
                            var type = changeTree.getType(fieldIndex);
                            if (isSchema) {
                                // Is a Schema!
                                var filter = ref._definition.filters && ref._definition.filters[fieldIndex];
                                if (filter && !filter.call(ref, client, value, root)) {
                                    if (value && value["$changes"]) refIdsDissallowed.add(value["$changes"].refId);
                                    continue;
                                }
                            } else {
                                // Is a collection! (map, array, etc.)
                                var parent = changeTree.parent;
                                var filter = changeTree.getChildrenFilter();
                                if (filter && !filter.call(parent, client, ref["$indexes"].get(fieldIndex), value, root)) {
                                    if (value && value["$changes"]) refIdsDissallowed.add(value["$changes"].refId);
                                    continue;
                                }
                            }
                            // visit child ChangeTree on further iteration.
                            if (value["$changes"]) {
                                changeTrees.push(value["$changes"]);
                                numChangeTrees++;
                            }
                            //
                            // Copy cached bytes
                            //
                            if (change.op !== exports1.OPERATION.TOUCH) {
                                //
                                // TODO: refactor me!
                                //
                                if (change.op === exports1.OPERATION.ADD || isSchema) {
                                    //
                                    // use cached bytes directly if is from Schema type.
                                    //
                                    filteredBytes.push.apply(filteredBytes, (_a = changeTree.caches[fieldIndex]) !== null && _a !== void 0 ? _a : []);
                                    containerIndexes.add(fieldIndex);
                                } else if (containerIndexes.has(fieldIndex)) //
                                // use cached bytes if already has the field
                                //
                                filteredBytes.push.apply(filteredBytes, (_b = changeTree.caches[fieldIndex]) !== null && _b !== void 0 ? _b : []);
                                else {
                                    //
                                    // force ADD operation if field is not known by this client.
                                    //
                                    containerIndexes.add(fieldIndex);
                                    uint8$1(filteredBytes, exports1.OPERATION.ADD);
                                    number$1(filteredBytes, fieldIndex);
                                    if (ref instanceof MapSchema) {
                                        //
                                        // MapSchema dynamic key
                                        //
                                        var dynamicIndex = changeTree.ref["$indexes"].get(fieldIndex);
                                        string$1(filteredBytes, dynamicIndex);
                                    }
                                    if (value["$changes"]) number$1(filteredBytes, value["$changes"].refId);
                                    else // "encodePrimitiveType" without type checking.
                                    // the type checking has been done on the first .encode() call.
                                    encode[type](filteredBytes, value);
                                }
                            } else if (value["$changes"] && !isSchema) {
                                //
                                // TODO:
                                // - track ADD/REPLACE/DELETE instances on `$filterState`
                                // - do NOT always encode dynamicIndex for MapSchema.
                                //   (If client already has that key, only the first index is necessary.)
                                //
                                uint8$1(filteredBytes, exports1.OPERATION.ADD);
                                number$1(filteredBytes, fieldIndex);
                                if (ref instanceof MapSchema) {
                                    //
                                    // MapSchema dynamic key
                                    //
                                    var dynamicIndex = changeTree.ref["$indexes"].get(fieldIndex);
                                    string$1(filteredBytes, dynamicIndex);
                                }
                                number$1(filteredBytes, value["$changes"].refId);
                            }
                        }
                    };
                    for(var i = 0; i < numChangeTrees; i++)_loop_1(i);
                    return filteredBytes;
                };
                Schema.prototype.clone = function() {
                    var _a;
                    var cloned = new this.constructor;
                    var schema = this._definition.schema;
                    for(var field in schema)if (typeof this[field] === "object" && typeof ((_a = this[field]) === null || _a === void 0 ? void 0 : _a.clone) === "function") // deep clone
                    cloned[field] = this[field].clone();
                    else // primitive values
                    cloned[field] = this[field];
                    return cloned;
                };
                Schema.prototype.toJSON = function() {
                    var schema = this._definition.schema;
                    var deprecated = this._definition.deprecated;
                    var obj = {};
                    for(var field in schema)if (!deprecated[field] && this[field] !== null && typeof this[field] !== "undefined") obj[field] = typeof this[field]["toJSON"] === "function" ? this[field]["toJSON"]() : this["_".concat(field)];
                    return obj;
                };
                Schema.prototype.discardAllChanges = function() {
                    this.$changes.discardAll();
                };
                Schema.prototype.getByIndex = function(index) {
                    return this[this._definition.fieldsByIndex[index]];
                };
                Schema.prototype.deleteByIndex = function(index) {
                    this[this._definition.fieldsByIndex[index]] = undefined;
                };
                Schema.prototype.tryEncodeTypeId = function(bytes, type, targetType) {
                    if (type._typeid !== targetType._typeid) {
                        uint8$1(bytes, TYPE_ID);
                        number$1(bytes, targetType._typeid);
                    }
                };
                Schema.prototype.getSchemaType = function(bytes, it, defaultType) {
                    var type;
                    if (bytes[it.offset] === TYPE_ID) {
                        it.offset++;
                        type = this.constructor._context.get(number(bytes, it));
                    }
                    return type || defaultType;
                };
                Schema.prototype.createTypeInstance = function(type) {
                    var instance = new type();
                    // assign root on $changes
                    instance.$changes.root = this.$changes.root;
                    return instance;
                };
                Schema.prototype._triggerChanges = function(changes) {
                    var _a, _b, _c, _d, _e, _f, _g, _h, _j;
                    var uniqueRefIds = new Set();
                    var $refs = this.$changes.root.refs;
                    var _loop_2 = function(i) {
                        var change = changes[i];
                        var refId = change.refId;
                        var ref = $refs.get(refId);
                        var $callbacks = ref["$callbacks"];
                        //
                        // trigger onRemove on child structure.
                        //
                        if ((change.op & exports1.OPERATION.DELETE) === exports1.OPERATION.DELETE && change.previousValue instanceof Schema) (_b = (_a = change.previousValue["$callbacks"]) === null || _a === void 0 ? void 0 : _a[exports1.OPERATION.DELETE]) === null || _b === void 0 || _b.forEach(function(callback) {
                            return callback();
                        });
                        // no callbacks defined, skip this structure!
                        if (!$callbacks) return "continue";
                        if (ref instanceof Schema) {
                            if (!uniqueRefIds.has(refId)) try {
                                // trigger onChange
                                (_c = $callbacks === null || $callbacks === void 0 ? void 0 : $callbacks[exports1.OPERATION.REPLACE]) === null || _c === void 0 || _c.forEach(function(callback) {
                                    return callback(changes);
                                });
                            } catch (e) {
                                Schema.onError(e);
                            }
                            try {
                                if ($callbacks.hasOwnProperty(change.field)) (_d = $callbacks[change.field]) === null || _d === void 0 || _d.forEach(function(callback) {
                                    return callback(change.value, change.previousValue);
                                });
                            } catch (e) {
                                Schema.onError(e);
                            }
                        } else {
                            // is a collection of items
                            if (change.op === exports1.OPERATION.ADD && change.previousValue === undefined) // triger onAdd
                            (_e = $callbacks[exports1.OPERATION.ADD]) === null || _e === void 0 || _e.forEach(function(callback) {
                                var _a;
                                return callback(change.value, (_a = change.dynamicIndex) !== null && _a !== void 0 ? _a : change.field);
                            });
                            else if (change.op === exports1.OPERATION.DELETE) //
                            // FIXME: `previousValue` should always be available.
                            // ADD + DELETE operations are still encoding DELETE operation.
                            //
                            {
                                if (change.previousValue !== undefined) // triger onRemove
                                (_f = $callbacks[exports1.OPERATION.DELETE]) === null || _f === void 0 || _f.forEach(function(callback) {
                                    var _a;
                                    return callback(change.previousValue, (_a = change.dynamicIndex) !== null && _a !== void 0 ? _a : change.field);
                                });
                            } else if (change.op === exports1.OPERATION.DELETE_AND_ADD) {
                                // triger onRemove
                                if (change.previousValue !== undefined) (_g = $callbacks[exports1.OPERATION.DELETE]) === null || _g === void 0 || _g.forEach(function(callback) {
                                    var _a;
                                    return callback(change.previousValue, (_a = change.dynamicIndex) !== null && _a !== void 0 ? _a : change.field);
                                });
                                // triger onAdd
                                (_h = $callbacks[exports1.OPERATION.ADD]) === null || _h === void 0 || _h.forEach(function(callback) {
                                    var _a;
                                    return callback(change.value, (_a = change.dynamicIndex) !== null && _a !== void 0 ? _a : change.field);
                                });
                            }
                            // trigger onChange
                            if (change.value !== change.previousValue) (_j = $callbacks[exports1.OPERATION.REPLACE]) === null || _j === void 0 || _j.forEach(function(callback) {
                                var _a;
                                return callback(change.value, (_a = change.dynamicIndex) !== null && _a !== void 0 ? _a : change.field);
                            });
                        }
                        uniqueRefIds.add(refId);
                    };
                    for(var i = 0; i < changes.length; i++)_loop_2(i);
                };
                Schema._definition = SchemaDefinition.create();
                return Schema;
            }();
            function dumpChanges(schema) {
                var changeTrees = [
                    schema["$changes"]
                ];
                var numChangeTrees = 1;
                var dump = {};
                var currentStructure = dump;
                var _loop_1 = function(i) {
                    var changeTree = changeTrees[i];
                    changeTree.changes.forEach(function(change) {
                        var ref = changeTree.ref;
                        var fieldIndex = change.index;
                        var field = ref["_definition"] ? ref["_definition"].fieldsByIndex[fieldIndex] : ref["$indexes"].get(fieldIndex);
                        currentStructure[field] = changeTree.getValue(fieldIndex);
                    });
                };
                for(var i = 0; i < numChangeTrees; i++)_loop_1(i);
                return dump;
            }
            var reflectionContext = {
                context: new Context()
            };
            /**
         * Reflection
         */ var ReflectionField = /** @class */ function(_super) {
                __extends(ReflectionField, _super);
                function ReflectionField() {
                    return _super !== null && _super.apply(this, arguments) || this;
                }
                __decorate([
                    type("string", reflectionContext)
                ], ReflectionField.prototype, "name", void 0);
                __decorate([
                    type("string", reflectionContext)
                ], ReflectionField.prototype, "type", void 0);
                __decorate([
                    type("number", reflectionContext)
                ], ReflectionField.prototype, "referencedType", void 0);
                return ReflectionField;
            }(Schema);
            var ReflectionType = /** @class */ function(_super) {
                __extends(ReflectionType, _super);
                function ReflectionType() {
                    var _this = _super !== null && _super.apply(this, arguments) || this;
                    _this.fields = new ArraySchema();
                    return _this;
                }
                __decorate([
                    type("number", reflectionContext)
                ], ReflectionType.prototype, "id", void 0);
                __decorate([
                    type([
                        ReflectionField
                    ], reflectionContext)
                ], ReflectionType.prototype, "fields", void 0);
                return ReflectionType;
            }(Schema);
            var Reflection = /** @class */ function(_super) {
                __extends(Reflection, _super);
                function Reflection() {
                    var _this = _super !== null && _super.apply(this, arguments) || this;
                    _this.types = new ArraySchema();
                    return _this;
                }
                Reflection.encode = function(instance) {
                    var rootSchemaType = instance.constructor;
                    var reflection = new Reflection();
                    reflection.rootType = rootSchemaType._typeid;
                    var buildType = function(currentType, schema) {
                        for(var fieldName in schema){
                            var field = new ReflectionField();
                            field.name = fieldName;
                            var fieldType = void 0;
                            if (typeof schema[fieldName] === "string") fieldType = schema[fieldName];
                            else {
                                var type_1 = schema[fieldName];
                                var childTypeSchema = void 0;
                                //
                                // TODO: refactor below.
                                //
                                if (Schema.is(type_1)) {
                                    fieldType = "ref";
                                    childTypeSchema = schema[fieldName];
                                } else {
                                    fieldType = Object.keys(type_1)[0];
                                    if (typeof type_1[fieldType] === "string") fieldType += ":" + type_1[fieldType]; // array:string
                                    else childTypeSchema = type_1[fieldType];
                                }
                                field.referencedType = childTypeSchema ? childTypeSchema._typeid : -1;
                            }
                            field.type = fieldType;
                            currentType.fields.push(field);
                        }
                        reflection.types.push(currentType);
                    };
                    var types = rootSchemaType._context.types;
                    for(var typeid in types){
                        var type_2 = new ReflectionType();
                        type_2.id = Number(typeid);
                        buildType(type_2, types[typeid]._definition.schema);
                    }
                    return reflection.encodeAll();
                };
                Reflection.decode = function(bytes, it) {
                    var context = new Context();
                    var reflection = new Reflection();
                    reflection.decode(bytes, it);
                    var schemaTypes = reflection.types.reduce(function(types, reflectionType) {
                        var schema = /** @class */ function(_super) {
                            __extends(_, _super);
                            function _() {
                                return _super !== null && _super.apply(this, arguments) || this;
                            }
                            return _;
                        }(Schema);
                        var typeid = reflectionType.id;
                        types[typeid] = schema;
                        context.add(schema, typeid);
                        return types;
                    }, {});
                    reflection.types.forEach(function(reflectionType) {
                        var schemaType = schemaTypes[reflectionType.id];
                        reflectionType.fields.forEach(function(field) {
                            var _a;
                            if (field.referencedType !== undefined) {
                                var fieldType = field.type;
                                var refType = schemaTypes[field.referencedType];
                                // map or array of primitive type (-1)
                                if (!refType) {
                                    var typeInfo = field.type.split(":");
                                    fieldType = typeInfo[0];
                                    refType = typeInfo[1];
                                }
                                if (fieldType === "ref") type(refType, {
                                    context: context
                                })(schemaType.prototype, field.name);
                                else type((_a = {}, _a[fieldType] = refType, _a), {
                                    context: context
                                })(schemaType.prototype, field.name);
                            } else type(field.type, {
                                context: context
                            })(schemaType.prototype, field.name);
                        });
                    });
                    var rootType = schemaTypes[reflection.rootType];
                    var rootInstance = new rootType();
                    /**
                 * auto-initialize referenced types on root type
                 * to allow registering listeners immediatelly on client-side
                 */ for(var fieldName in rootType._definition.schema){
                        var fieldType = rootType._definition.schema[fieldName];
                        if (typeof fieldType !== "string") rootInstance[fieldName] = typeof fieldType === "function" ? new fieldType() // is a schema reference
                         : new (getType(Object.keys(fieldType)[0])).constructor(); // is a "collection"
                    }
                    return rootInstance;
                };
                __decorate([
                    type([
                        ReflectionType
                    ], reflectionContext)
                ], Reflection.prototype, "types", void 0);
                __decorate([
                    type("number", reflectionContext)
                ], Reflection.prototype, "rootType", void 0);
                return Reflection;
            }(Schema);
            registerType("map", {
                constructor: MapSchema
            });
            registerType("array", {
                constructor: ArraySchema
            });
            registerType("set", {
                constructor: SetSchema
            });
            registerType("collection", {
                constructor: CollectionSchema
            });
            exports1.ArraySchema = ArraySchema;
            exports1.CollectionSchema = CollectionSchema;
            exports1.Context = Context;
            exports1.MapSchema = MapSchema;
            exports1.Reflection = Reflection;
            exports1.ReflectionField = ReflectionField;
            exports1.ReflectionType = ReflectionType;
            exports1.Schema = Schema;
            exports1.SchemaDefinition = SchemaDefinition;
            exports1.SetSchema = SetSchema;
            exports1.decode = decode;
            exports1.defineTypes = defineTypes;
            exports1.deprecated = deprecated;
            exports1.dumpChanges = dumpChanges;
            exports1.encode = encode;
            exports1.filter = filter;
            exports1.filterChildren = filterChildren;
            exports1.hasFilter = hasFilter;
            exports1.registerType = registerType;
            exports1.type = type;
            Object.defineProperty(exports1, "__esModule", {
                value: true
            });
        });
    });
    var Room = /** @class */ function() {
        function Room(name, rootSchema) {
            var _this = this;
            // Public signals
            this.onStateChange = createSignal();
            this.onError = createSignal();
            this.onLeave = createSignal();
            this.onJoin = createSignal();
            this.hasJoined = false;
            this.onMessageHandlers = createNanoEvents();
            this.roomId = null;
            this.name = name;
            if (rootSchema) {
                this.serializer = new (getSerializer("schema"));
                this.rootSchema = rootSchema;
                this.serializer.state = new rootSchema();
            }
            this.onError(function(code, message) {
                var _a;
                return (_a = console.warn) === null || _a === void 0 ? void 0 : _a.call(console, "colyseus.js - onError => (".concat(code, ") ").concat(message));
            });
            this.onLeave(function() {
                return _this.removeAllListeners();
            });
        }
        Object.defineProperty(Room.prototype, "id", {
            // TODO: deprecate me on version 1.0
            get: function() {
                return this.roomId;
            },
            enumerable: false,
            configurable: true
        });
        Room.prototype.connect = function(endpoint, devModeCloseCallback, room // when reconnecting on devMode, re-use previous room intance for handling events.
        ) {
            if (room === void 0) room = this;
            var connection = new Connection();
            room.connection = connection;
            connection.events.onmessage = Room.prototype.onMessageCallback.bind(room);
            connection.events.onclose = function(e) {
                var _a;
                if (!room.hasJoined) {
                    (_a = console.warn) === null || _a === void 0 || _a.call(console, "Room connection was closed unexpectedly (".concat(e.code, "): ").concat(e.reason));
                    room.onError.invoke(e.code, e.reason);
                    return;
                }
                if (e.code === CloseCode.DEVMODE_RESTART && devModeCloseCallback) devModeCloseCallback();
                else {
                    room.onLeave.invoke(e.code);
                    room.destroy();
                }
            };
            connection.events.onerror = function(e) {
                var _a;
                (_a = console.warn) === null || _a === void 0 || _a.call(console, "Room, onError (".concat(e.code, "): ").concat(e.reason));
                room.onError.invoke(e.code, e.reason);
            };
            connection.connect(endpoint);
        };
        Room.prototype.leave = function(consented) {
            var _this = this;
            if (consented === void 0) consented = true;
            return new Promise(function(resolve) {
                _this.onLeave(function(code) {
                    return resolve(code);
                });
                if (_this.connection) {
                    if (consented) _this.connection.send([
                        exports1.Protocol.LEAVE_ROOM
                    ]);
                    else _this.connection.close();
                } else _this.onLeave.invoke(CloseCode.CONSENTED);
            });
        };
        Room.prototype.onMessage = function(type, callback) {
            return this.onMessageHandlers.on(this.getMessageHandlerKey(type), callback);
        };
        Room.prototype.send = function(type, message) {
            var initialBytes = [
                exports1.Protocol.ROOM_DATA
            ];
            if (typeof type === "string") umd.encode.string(initialBytes, type);
            else umd.encode.number(initialBytes, type);
            var arr;
            if (message !== undefined) {
                var encoded = encode(message);
                arr = new Uint8Array(initialBytes.length + encoded.byteLength);
                arr.set(new Uint8Array(initialBytes), 0);
                arr.set(new Uint8Array(encoded), initialBytes.length);
            } else arr = new Uint8Array(initialBytes);
            this.connection.send(arr.buffer);
        };
        Room.prototype.sendBytes = function(type, bytes) {
            var initialBytes = [
                exports1.Protocol.ROOM_DATA_BYTES
            ];
            if (typeof type === "string") umd.encode.string(initialBytes, type);
            else umd.encode.number(initialBytes, type);
            var arr;
            arr = new Uint8Array(initialBytes.length + (bytes.byteLength || bytes.length));
            arr.set(new Uint8Array(initialBytes), 0);
            arr.set(new Uint8Array(bytes), initialBytes.length);
            this.connection.send(arr.buffer);
        };
        Object.defineProperty(Room.prototype, "state", {
            get: function() {
                return this.serializer.getState();
            },
            enumerable: false,
            configurable: true
        });
        Room.prototype.removeAllListeners = function() {
            this.onJoin.clear();
            this.onStateChange.clear();
            this.onError.clear();
            this.onLeave.clear();
            this.onMessageHandlers.events = {};
        };
        Room.prototype.onMessageCallback = function(event) {
            var bytes = Array.from(new Uint8Array(event.data));
            var code = bytes[0];
            if (code === exports1.Protocol.JOIN_ROOM) {
                var offset = 1;
                var reconnectionToken = utf8Read(bytes, offset);
                offset += utf8Length(reconnectionToken);
                this.serializerId = utf8Read(bytes, offset);
                offset += utf8Length(this.serializerId);
                // Instantiate serializer if not locally available.
                if (!this.serializer) {
                    var serializer = getSerializer(this.serializerId);
                    this.serializer = new serializer();
                }
                if (bytes.length > offset && this.serializer.handshake) this.serializer.handshake(bytes, {
                    offset: offset
                });
                this.reconnectionToken = "".concat(this.roomId, ":").concat(reconnectionToken);
                this.hasJoined = true;
                this.onJoin.invoke();
                // acknowledge successfull JOIN_ROOM
                this.connection.send([
                    exports1.Protocol.JOIN_ROOM
                ]);
            } else if (code === exports1.Protocol.ERROR) {
                var it_1 = {
                    offset: 1
                };
                var code_1 = umd.decode.number(bytes, it_1);
                var message = umd.decode.string(bytes, it_1);
                this.onError.invoke(code_1, message);
            } else if (code === exports1.Protocol.LEAVE_ROOM) this.leave();
            else if (code === exports1.Protocol.ROOM_DATA_SCHEMA) {
                var it_2 = {
                    offset: 1
                };
                var context_1 = this.serializer.getState().constructor._context;
                var type = context_1.get(umd.decode.number(bytes, it_2));
                var message = new type();
                message.decode(bytes, it_2);
                this.dispatchMessage(type, message);
            } else if (code === exports1.Protocol.ROOM_STATE) {
                bytes.shift(); // drop `code` byte
                this.setState(bytes);
            } else if (code === exports1.Protocol.ROOM_STATE_PATCH) {
                bytes.shift(); // drop `code` byte
                this.patch(bytes);
            } else if (code === exports1.Protocol.ROOM_DATA) {
                var it_3 = {
                    offset: 1
                };
                var type = umd.decode.stringCheck(bytes, it_3) ? umd.decode.string(bytes, it_3) : umd.decode.number(bytes, it_3);
                var message = bytes.length > it_3.offset ? decode(event.data, it_3.offset) : undefined;
                this.dispatchMessage(type, message);
            } else if (code === exports1.Protocol.ROOM_DATA_BYTES) {
                var it_4 = {
                    offset: 1
                };
                var type = umd.decode.stringCheck(bytes, it_4) ? umd.decode.string(bytes, it_4) : umd.decode.number(bytes, it_4);
                this.dispatchMessage(type, new Uint8Array(bytes.slice(it_4.offset)));
            }
        };
        Room.prototype.setState = function(encodedState) {
            this.serializer.setState(encodedState);
            this.onStateChange.invoke(this.serializer.getState());
        };
        Room.prototype.patch = function(binaryPatch) {
            this.serializer.patch(binaryPatch);
            this.onStateChange.invoke(this.serializer.getState());
        };
        Room.prototype.dispatchMessage = function(type, message) {
            var _a;
            var messageType = this.getMessageHandlerKey(type);
            if (this.onMessageHandlers.events[messageType]) this.onMessageHandlers.emit(messageType, message);
            else if (this.onMessageHandlers.events["*"]) this.onMessageHandlers.emit("*", type, message);
            else (_a = console.warn) === null || _a === void 0 || _a.call(console, "colyseus.js: onMessage() not registered for type '".concat(type, "'."));
        };
        Room.prototype.destroy = function() {
            if (this.serializer) this.serializer.teardown();
        };
        Room.prototype.getMessageHandlerKey = function(type) {
            switch(typeof type){
                // typeof Schema
                case "function":
                    return "$".concat(type._typeid);
                // string
                case "string":
                    return type;
                // number
                case "number":
                    return "i".concat(type);
                default:
                    throw new Error("invalid message type.");
            }
        };
        return Room;
    }();
    var _a;
    var MatchMakeError = /** @class */ function(_super) {
        __extends(MatchMakeError, _super);
        function MatchMakeError(message, code) {
            var _this = _super.call(this, message) || this;
            _this.code = code;
            Object.setPrototypeOf(_this, MatchMakeError.prototype);
            return _this;
        }
        return MatchMakeError;
    }(Error);
    // - React Native does not provide `window.location`
    // - Cocos Creator (Native) does not provide `window.location.hostname`
    var DEFAULT_ENDPOINT = typeof window !== "undefined" && typeof ((_a = window === null || window === void 0 ? void 0 : window.location) === null || _a === void 0 ? void 0 : _a.hostname) !== "undefined" ? "".concat(window.location.protocol.replace("http", "ws"), "//").concat(window.location.hostname).concat(window.location.port && ":".concat(window.location.port)) : "ws://127.0.0.1:2567";
    var Client = /** @class */ function() {
        function Client(settings) {
            if (settings === void 0) settings = DEFAULT_ENDPOINT;
            if (typeof settings === "string") {
                //
                // endpoint by url
                //
                var url = new URL(settings);
                var secure = url.protocol === "https:" || url.protocol === "wss:";
                var port = Number(url.port || (secure ? 443 : 80));
                this.settings = {
                    hostname: url.hostname,
                    pathname: url.pathname !== "/" ? url.pathname : "",
                    port: port,
                    secure: secure
                };
            } else {
                //
                // endpoint by settings
                //
                if (settings.port === undefined) settings.port = settings.secure ? 443 : 80;
                if (settings.pathname === undefined) settings.pathname = "";
                this.settings = settings;
            }
        }
        Client.prototype.joinOrCreate = function(roomName, options, rootSchema) {
            if (options === void 0) options = {};
            return __awaiter(this, void 0, void 0, function() {
                return __generator(this, function(_a) {
                    switch(_a.label){
                        case 0:
                            return [
                                4 /*yield*/ ,
                                this.createMatchMakeRequest("joinOrCreate", roomName, options, rootSchema)
                            ];
                        case 1:
                            return [
                                2 /*return*/ ,
                                _a.sent()
                            ];
                    }
                });
            });
        };
        Client.prototype.create = function(roomName, options, rootSchema) {
            if (options === void 0) options = {};
            return __awaiter(this, void 0, void 0, function() {
                return __generator(this, function(_a) {
                    switch(_a.label){
                        case 0:
                            return [
                                4 /*yield*/ ,
                                this.createMatchMakeRequest("create", roomName, options, rootSchema)
                            ];
                        case 1:
                            return [
                                2 /*return*/ ,
                                _a.sent()
                            ];
                    }
                });
            });
        };
        Client.prototype.join = function(roomName, options, rootSchema) {
            if (options === void 0) options = {};
            return __awaiter(this, void 0, void 0, function() {
                return __generator(this, function(_a) {
                    switch(_a.label){
                        case 0:
                            return [
                                4 /*yield*/ ,
                                this.createMatchMakeRequest("join", roomName, options, rootSchema)
                            ];
                        case 1:
                            return [
                                2 /*return*/ ,
                                _a.sent()
                            ];
                    }
                });
            });
        };
        Client.prototype.joinById = function(roomId, options, rootSchema) {
            if (options === void 0) options = {};
            return __awaiter(this, void 0, void 0, function() {
                return __generator(this, function(_a) {
                    switch(_a.label){
                        case 0:
                            return [
                                4 /*yield*/ ,
                                this.createMatchMakeRequest("joinById", roomId, options, rootSchema)
                            ];
                        case 1:
                            return [
                                2 /*return*/ ,
                                _a.sent()
                            ];
                    }
                });
            });
        };
        /**
         * Re-establish connection with a room this client was previously connected to.
         *
         * @param reconnectionToken The `room.reconnectionToken` from previously connected room.
         * @param rootSchema (optional) Concrete root schema definition
         * @returns Promise<Room>
         */ Client.prototype.reconnect = function(reconnectionToken, rootSchema) {
            return __awaiter(this, void 0, void 0, function() {
                var _a, roomId, token;
                return __generator(this, function(_b) {
                    switch(_b.label){
                        case 0:
                            if (typeof reconnectionToken === "string" && typeof rootSchema === "string") throw new Error("DEPRECATED: .reconnect() now only accepts 'reconnectionToken' as argument.\nYou can get this token from previously connected `room.reconnectionToken`");
                            _a = reconnectionToken.split(":"), roomId = _a[0], token = _a[1];
                            return [
                                4 /*yield*/ ,
                                this.createMatchMakeRequest("reconnect", roomId, {
                                    reconnectionToken: token
                                }, rootSchema)
                            ];
                        case 1:
                            return [
                                2 /*return*/ ,
                                _b.sent()
                            ];
                    }
                });
            });
        };
        Client.prototype.getAvailableRooms = function(roomName) {
            if (roomName === void 0) roomName = "";
            return __awaiter(this, void 0, void 0, function() {
                return __generator(this, function(_a) {
                    switch(_a.label){
                        case 0:
                            return [
                                4 /*yield*/ ,
                                get_1(this.getHttpEndpoint("".concat(roomName)), {
                                    headers: {
                                        "Accept": "application/json"
                                    }
                                })
                            ];
                        case 1:
                            return [
                                2 /*return*/ ,
                                _a.sent().data
                            ];
                    }
                });
            });
        };
        Client.prototype.consumeSeatReservation = function(response, rootSchema, reuseRoomInstance // used in devMode
        ) {
            return __awaiter(this, void 0, void 0, function() {
                var room, options, targetRoom;
                var _this = this;
                return __generator(this, function(_a) {
                    room = this.createRoom(response.room.name, rootSchema);
                    room.roomId = response.room.roomId;
                    room.sessionId = response.sessionId;
                    options = {
                        sessionId: room.sessionId
                    };
                    // forward "reconnection token" in case of reconnection.
                    if (response.reconnectionToken) options.reconnectionToken = response.reconnectionToken;
                    targetRoom = reuseRoomInstance || room;
                    room.connect(this.buildEndpoint(response.room, options), response.devMode && function() {
                        return __awaiter(_this, void 0, void 0, function() {
                            var retryCount, retryMaxRetries, retryReconnection;
                            var _this = this;
                            return __generator(this, function(_a) {
                                console.info("[Colyseus devMode]: ".concat(String.fromCodePoint(0x1F504), " Re-establishing connection with room id '").concat(room.roomId, "'...")); // 🔄
                                retryCount = 0;
                                retryMaxRetries = 8;
                                retryReconnection = function() {
                                    return __awaiter(_this, void 0, void 0, function() {
                                        return __generator(this, function(_a) {
                                            switch(_a.label){
                                                case 0:
                                                    retryCount++;
                                                    _a.label = 1;
                                                case 1:
                                                    _a.trys.push([
                                                        1,
                                                        3,
                                                        ,
                                                        4
                                                    ]);
                                                    return [
                                                        4 /*yield*/ ,
                                                        this.consumeSeatReservation(response, rootSchema, targetRoom)
                                                    ];
                                                case 2:
                                                    _a.sent();
                                                    console.info("[Colyseus devMode]: ".concat(String.fromCodePoint(0x2705), " Successfully re-established connection with room '").concat(room.roomId, "'")); // ✅
                                                    return [
                                                        3 /*break*/ ,
                                                        4
                                                    ];
                                                case 3:
                                                    _a.sent();
                                                    if (retryCount < retryMaxRetries) {
                                                        console.info("[Colyseus devMode]: ".concat(String.fromCodePoint(0x1F504), " retrying... (").concat(retryCount, " out of ").concat(retryMaxRetries, ")")); // 🔄
                                                        setTimeout(retryReconnection, 2000);
                                                    } else console.info("[Colyseus devMode]: ".concat(String.fromCodePoint(0x274C), " Failed to reconnect. Is your server running? Please check server logs.")); // ❌
                                                    return [
                                                        3 /*break*/ ,
                                                        4
                                                    ];
                                                case 4:
                                                    return [
                                                        2 /*return*/ 
                                                    ];
                                            }
                                        });
                                    });
                                };
                                setTimeout(retryReconnection, 2000);
                                return [
                                    2 /*return*/ 
                                ];
                            });
                        });
                    }, targetRoom);
                    return [
                        2 /*return*/ ,
                        new Promise(function(resolve, reject) {
                            var onError = function(code, message) {
                                return reject(new ServerError(code, message));
                            };
                            targetRoom.onError.once(onError);
                            targetRoom["onJoin"].once(function() {
                                targetRoom.onError.remove(onError);
                                resolve(targetRoom);
                            });
                        })
                    ];
                });
            });
        };
        Client.prototype.createMatchMakeRequest = function(method, roomName, options, rootSchema, reuseRoomInstance) {
            if (options === void 0) options = {};
            return __awaiter(this, void 0, void 0, function() {
                var response;
                return __generator(this, function(_a) {
                    switch(_a.label){
                        case 0:
                            return [
                                4 /*yield*/ ,
                                post_1(this.getHttpEndpoint("".concat(method, "/").concat(roomName)), {
                                    headers: {
                                        "Accept": "application/json",
                                        "Content-Type": "application/json"
                                    },
                                    body: JSON.stringify(options)
                                })
                            ];
                        case 1:
                            response = _a.sent().data;
                            if (response.error) throw new MatchMakeError(response.error, response.code);
                            // forward reconnection token during "reconnect" methods.
                            if (method === "reconnect") response.reconnectionToken = options.reconnectionToken;
                            return [
                                4 /*yield*/ ,
                                this.consumeSeatReservation(response, rootSchema, reuseRoomInstance)
                            ];
                        case 2:
                            return [
                                2 /*return*/ ,
                                _a.sent()
                            ];
                    }
                });
            });
        };
        Client.prototype.createRoom = function(roomName, rootSchema) {
            return new Room(roomName, rootSchema);
        };
        Client.prototype.buildEndpoint = function(room, options) {
            if (options === void 0) options = {};
            var params = [];
            for(var name_1 in options){
                if (!options.hasOwnProperty(name_1)) continue;
                params.push("".concat(name_1, "=").concat(options[name_1]));
            }
            var endpoint = this.settings.secure ? "wss://" : "ws://";
            if (room.publicAddress) endpoint += "".concat(room.publicAddress);
            else endpoint += "".concat(this.settings.hostname).concat(this.getEndpointPort()).concat(this.settings.pathname);
            return "".concat(endpoint, "/").concat(room.processId, "/").concat(room.roomId, "?").concat(params.join("&"));
        };
        Client.prototype.getHttpEndpoint = function(segments) {
            if (segments === void 0) segments = "";
            return "".concat(this.settings.secure ? "https" : "http", "://").concat(this.settings.hostname).concat(this.getEndpointPort()).concat(this.settings.pathname, "/matchmake/").concat(segments);
        };
        Client.prototype.getEndpointPort = function() {
            return this.settings.port !== 80 && this.settings.port !== 443 ? ":".concat(this.settings.port) : "";
        };
        return Client;
    }();
    /// <reference path="../typings/cocos-creator.d.ts" />
    /**
     * We do not assign 'storage' to window.localStorage immediatelly for React
     * Native compatibility. window.localStorage is not present when this module is
     * loaded.
     */ var storage;
    function getStorage() {
        if (!storage) storage = typeof cc !== "undefined" && cc.sys && cc.sys.localStorage ? cc.sys.localStorage // compatibility with cocos creator
         : typeof window !== "undefined" && window.localStorage //RN does have window object at this point, but localStorage is not defined
         ? window.localStorage // regular browser environment
         : {
            cache: {},
            setItem: function(key, value) {
                this.cache[key] = value;
            },
            getItem: function(key) {
                this.cache[key];
            },
            removeItem: function(key) {
                delete this.cache[key];
            }
        };
        return storage;
    }
    function setItem(key, value) {
        getStorage().setItem(key, value);
    }
    function removeItem(key) {
        getStorage().removeItem(key);
    }
    function getItem(key, callback) {
        var value = getStorage().getItem(key);
        if (typeof Promise === "undefined" || // old browsers
        !(value instanceof Promise)) // browser has synchronous return
        callback(value);
        else // react-native is asynchronous
        value.then(function(id) {
            return callback(id);
        });
    }
    var TOKEN_STORAGE = "colyseus-auth-token";
    exports1.Platform = void 0;
    (function(Platform) {
        Platform["ios"] = "ios";
        Platform["android"] = "android";
    })(exports1.Platform || (exports1.Platform = {}));
    var Auth = /** @class */ function() {
        function Auth(endpoint) {
            var _this = this;
            this._id = undefined;
            this.username = undefined;
            this.displayName = undefined;
            this.avatarUrl = undefined;
            this.isAnonymous = undefined;
            this.email = undefined;
            this.lang = undefined;
            this.location = undefined;
            this.timezone = undefined;
            this.metadata = undefined;
            this.devices = undefined;
            this.facebookId = undefined;
            this.twitterId = undefined;
            this.googleId = undefined;
            this.gameCenterId = undefined;
            this.steamId = undefined;
            this.friendIds = undefined;
            this.blockedUserIds = undefined;
            this.createdAt = undefined;
            this.updatedAt = undefined;
            // auth token
            this.token = undefined;
            this.endpoint = endpoint.replace("ws", "http");
            getItem(TOKEN_STORAGE, function(token) {
                return _this.token = token;
            });
        }
        Object.defineProperty(Auth.prototype, "hasToken", {
            get: function() {
                return !!this.token;
            },
            enumerable: false,
            configurable: true
        });
        Auth.prototype.login = function(options) {
            if (options === void 0) options = {};
            return __awaiter(this, void 0, void 0, function() {
                var queryParams, data, attr;
                return __generator(this, function(_a) {
                    switch(_a.label){
                        case 0:
                            queryParams = Object.assign({}, options);
                            if (this.hasToken) queryParams.token = this.token;
                            return [
                                4 /*yield*/ ,
                                this.request("post", "/auth", queryParams)
                            ];
                        case 1:
                            data = _a.sent();
                            // set & cache token
                            this.token = data.token;
                            setItem(TOKEN_STORAGE, this.token);
                            for(attr in data)if (this.hasOwnProperty(attr)) this[attr] = data[attr];
                            this.registerPingService();
                            return [
                                2 /*return*/ ,
                                this
                            ];
                    }
                });
            });
        };
        Auth.prototype.save = function() {
            return __awaiter(this, void 0, void 0, function() {
                return __generator(this, function(_a) {
                    switch(_a.label){
                        case 0:
                            return [
                                4 /*yield*/ ,
                                this.request("put", "/auth", {}, {
                                    username: this.username,
                                    displayName: this.displayName,
                                    avatarUrl: this.avatarUrl,
                                    lang: this.lang,
                                    location: this.location,
                                    timezone: this.timezone
                                })
                            ];
                        case 1:
                            _a.sent();
                            return [
                                2 /*return*/ ,
                                this
                            ];
                    }
                });
            });
        };
        Auth.prototype.getFriends = function() {
            return __awaiter(this, void 0, void 0, function() {
                return __generator(this, function(_a) {
                    switch(_a.label){
                        case 0:
                            return [
                                4 /*yield*/ ,
                                this.request("get", "/friends/all")
                            ];
                        case 1:
                            return [
                                2 /*return*/ ,
                                _a.sent()
                            ];
                    }
                });
            });
        };
        Auth.prototype.getOnlineFriends = function() {
            return __awaiter(this, void 0, void 0, function() {
                return __generator(this, function(_a) {
                    switch(_a.label){
                        case 0:
                            return [
                                4 /*yield*/ ,
                                this.request("get", "/friends/online")
                            ];
                        case 1:
                            return [
                                2 /*return*/ ,
                                _a.sent()
                            ];
                    }
                });
            });
        };
        Auth.prototype.getFriendRequests = function() {
            return __awaiter(this, void 0, void 0, function() {
                return __generator(this, function(_a) {
                    switch(_a.label){
                        case 0:
                            return [
                                4 /*yield*/ ,
                                this.request("get", "/friends/requests")
                            ];
                        case 1:
                            return [
                                2 /*return*/ ,
                                _a.sent()
                            ];
                    }
                });
            });
        };
        Auth.prototype.sendFriendRequest = function(friendId) {
            return __awaiter(this, void 0, void 0, function() {
                return __generator(this, function(_a) {
                    switch(_a.label){
                        case 0:
                            return [
                                4 /*yield*/ ,
                                this.request("post", "/friends/requests", {
                                    userId: friendId
                                })
                            ];
                        case 1:
                            return [
                                2 /*return*/ ,
                                _a.sent()
                            ];
                    }
                });
            });
        };
        Auth.prototype.acceptFriendRequest = function(friendId) {
            return __awaiter(this, void 0, void 0, function() {
                return __generator(this, function(_a) {
                    switch(_a.label){
                        case 0:
                            return [
                                4 /*yield*/ ,
                                this.request("put", "/friends/requests", {
                                    userId: friendId
                                })
                            ];
                        case 1:
                            return [
                                2 /*return*/ ,
                                _a.sent()
                            ];
                    }
                });
            });
        };
        Auth.prototype.declineFriendRequest = function(friendId) {
            return __awaiter(this, void 0, void 0, function() {
                return __generator(this, function(_a) {
                    switch(_a.label){
                        case 0:
                            return [
                                4 /*yield*/ ,
                                this.request("del", "/friends/requests", {
                                    userId: friendId
                                })
                            ];
                        case 1:
                            return [
                                2 /*return*/ ,
                                _a.sent()
                            ];
                    }
                });
            });
        };
        Auth.prototype.blockUser = function(friendId) {
            return __awaiter(this, void 0, void 0, function() {
                return __generator(this, function(_a) {
                    switch(_a.label){
                        case 0:
                            return [
                                4 /*yield*/ ,
                                this.request("post", "/friends/block", {
                                    userId: friendId
                                })
                            ];
                        case 1:
                            return [
                                2 /*return*/ ,
                                _a.sent()
                            ];
                    }
                });
            });
        };
        Auth.prototype.unblockUser = function(friendId) {
            return __awaiter(this, void 0, void 0, function() {
                return __generator(this, function(_a) {
                    switch(_a.label){
                        case 0:
                            return [
                                4 /*yield*/ ,
                                this.request("put", "/friends/block", {
                                    userId: friendId
                                })
                            ];
                        case 1:
                            return [
                                2 /*return*/ ,
                                _a.sent()
                            ];
                    }
                });
            });
        };
        Auth.prototype.request = function(method, segments, query, body, headers) {
            if (query === void 0) query = {};
            if (headers === void 0) headers = {};
            return __awaiter(this, void 0, void 0, function() {
                var queryParams, name_1, queryString, opts;
                return __generator(this, function(_a) {
                    switch(_a.label){
                        case 0:
                            headers["Accept"] = "application/json";
                            if (this.hasToken) headers["Authorization"] = "Bearer " + this.token;
                            queryParams = [];
                            for(name_1 in query)queryParams.push("".concat(name_1, "=").concat(query[name_1]));
                            queryString = queryParams.length > 0 ? "?".concat(queryParams.join("&")) : "";
                            opts = {
                                headers: headers
                            };
                            if (body) opts.body = body;
                            return [
                                4 /*yield*/ ,
                                http[method]("".concat(this.endpoint).concat(segments).concat(queryString), opts)
                            ];
                        case 1:
                            return [
                                2 /*return*/ ,
                                _a.sent().data
                            ];
                    }
                });
            });
        };
        Auth.prototype.logout = function() {
            this.token = undefined;
            removeItem(TOKEN_STORAGE);
            this.unregisterPingService();
        };
        Auth.prototype.registerPingService = function(timeout) {
            var _this = this;
            if (timeout === void 0) timeout = 15000;
            this.unregisterPingService();
            this.keepOnlineInterval = setInterval(function() {
                return _this.request("get", "/auth");
            }, timeout);
        };
        Auth.prototype.unregisterPingService = function() {
            clearInterval(this.keepOnlineInterval);
        };
        return Auth;
    }();
    var SchemaSerializer = /** @class */ function() {
        function SchemaSerializer() {}
        SchemaSerializer.prototype.setState = function(rawState) {
            return this.state.decode(rawState);
        };
        SchemaSerializer.prototype.getState = function() {
            return this.state;
        };
        SchemaSerializer.prototype.patch = function(patches) {
            return this.state.decode(patches);
        };
        SchemaSerializer.prototype.teardown = function() {
            var _a, _b;
            (_b = (_a = this.state) === null || _a === void 0 ? void 0 : _a["$changes"]) === null || _b === void 0 || _b.root.clearRefs();
        };
        SchemaSerializer.prototype.handshake = function(bytes, it) {
            if (this.state) {
                // TODO: validate client/server definitinos
                var reflection = new umd.Reflection();
                reflection.decode(bytes, it);
            } else // initialize reflected state from server
            this.state = umd.Reflection.decode(bytes, it);
        };
        return SchemaSerializer;
    }();
    var NoneSerializer = /** @class */ function() {
        function NoneSerializer() {}
        NoneSerializer.prototype.setState = function(rawState) {};
        NoneSerializer.prototype.getState = function() {
            return null;
        };
        NoneSerializer.prototype.patch = function(patches) {};
        NoneSerializer.prototype.teardown = function() {};
        NoneSerializer.prototype.handshake = function(bytes) {};
        return NoneSerializer;
    }();
    registerSerializer("schema", SchemaSerializer);
    registerSerializer("none", NoneSerializer);
    exports1.Auth = Auth;
    exports1.Client = Client;
    exports1.Room = Room;
    exports1.SchemaSerializer = SchemaSerializer;
    exports1.registerSerializer = registerSerializer;
    Object.defineProperty(exports1, "__esModule", {
        value: true
    });
});








const $e23f740143f4ec63$export$69e3d9997822a61a = async (room)=>{
    (0, $05e42dce750e973a$export$1197e9ca544859c8)();
    (0, $52be045d3cbb2b80$export$99ee26438460406a).ticker.wake();
    (0, $2ae84a41eb5f30ec$export$8e361a1ffbebf172).external.showHomescreen(false);
    (0, $2ae84a41eb5f30ec$export$8e361a1ffbebf172).room = room;
    try {
        console.log(room.sessionId, " joined classic room ", room.name);
        room.onStateChange.once(async (state)=>{
            const player = state.players.get(room.sessionId);
            console.log("PLAY MUSIC", state.soundName);
            if (player) {
                (0, $bf5e1bcc1f1c3d40$export$a56500bd31d6d39d)(state.soundName ?? (0, $49736469f58fc92b$export$93445e7da77bf239).MainTheme);
                (0, $8b91dc769ad86d51$export$9e0aba4a2d0bac1d)(room, player);
            }
        });
        room.onLeave((code)=>{
            (0, $8b91dc769ad86d51$export$cb58a432bf104627)(code);
            if (code !== 4000) {
                (0, $2ae84a41eb5f30ec$export$8e361a1ffbebf172).external.showModal({
                    title: "Disconnected",
                    text: "You have been disconnected from the server, check your connection"
                });
                (0, $2ae84a41eb5f30ec$export$8e361a1ffbebf172).external.clearGame();
                (0, $2ae84a41eb5f30ec$export$8e361a1ffbebf172).external.showHomescreen(true);
            }
            console.log("leave", code);
        });
        room.onError((code, message)=>{
            console.log("ERROR: ", code, " [", message, "]");
        });
        room.onMessage("leaderboard", async (leaderboard)=>{
            if (!leaderboard || !room) return;
            const rank = leaderboard.findIndex((leader)=>leader.clientId === room.sessionId) + 1;
            const strRank = rank === 1 ? "1st" : rank === 2 ? "2nd" : rank === 3 ? "3rd" : `${rank}th`;
            //setRank(strRank)
            console.log("rank", strRank);
        });
        return room;
    } catch (err) {
        (0, $8b91dc769ad86d51$export$1c91c4b074f3fd21)(err);
    }
};
const $e23f740143f4ec63$export$bab581b2088445c9 = async ({ options: options, onConnect: onConnect, onLeave: onLeave, onJoinError: onJoinError })=>{
    try {
        const colyseusClientURL = "ws://localhost:3000";
        const colyseusClient = new (0, $8a56917682400e81$exports.Client)(colyseusClientURL);
        const room = await colyseusClient.joinOrCreate("classic", {
            ...options,
            roomInfo: {
                name: "testtest",
                maxPlayers: 1,
                mode: options.mode ?? "score"
            }
        });
        (0, $2ae84a41eb5f30ec$export$8e361a1ffbebf172).room = room;
        console.log(room.sessionId, " joined classic room ", room.name);
        if (options.mode === "clash") (0, $bf5e1bcc1f1c3d40$export$a56500bd31d6d39d)((0, $49736469f58fc92b$export$93445e7da77bf239).MainTheme2);
        else (0, $bf5e1bcc1f1c3d40$export$a56500bd31d6d39d)((0, $49736469f58fc92b$export$93445e7da77bf239).MainTheme);
        room.onStateChange.once(async (state)=>{
            const player = state.players.get(room.sessionId);
            if (player) //sound.find(SoundName.selectLevel).play()
            onConnect(room, player);
        });
        room.onLeave((code)=>{
            onLeave(code);
            if (code !== 4000) (0, $2ae84a41eb5f30ec$export$8e361a1ffbebf172).external.showModal({
                title: "Disconnected",
                text: "You have been disconnected from the server, check your connection"
            });
            (0, $2ae84a41eb5f30ec$export$8e361a1ffbebf172).external.clearGame();
            (0, $2ae84a41eb5f30ec$export$8e361a1ffbebf172).external.showHomescreen(true);
            console.log("leave", code);
        });
        room.onError((code, message)=>{
            console.log("ERROR: ", code, " [", message, "]");
        });
        room.onMessage("leaderboard", async (leaderboard)=>{
            if (!leaderboard || !room) return;
            const rank = leaderboard.findIndex((leader)=>leader.clientId === room.sessionId) + 1;
            const strRank = rank === 1 ? "1st" : rank === 2 ? "2nd" : rank === 3 ? "3rd" : `${rank}th`;
            //setRank(strRank)
            console.log("rank", strRank);
        });
        return room;
    } catch (err) {
        onJoinError(err);
    }
} //setTimeout(async () => {
 //  createSoloLevelRoom({
 //    options: {
 //      clientWidth: window.innerWidth,
 //      clientHeight: window.innerHeight,
 //      mode: 'score'
 //    },
 //    onConnect,
 //    onLeave,
 //    onJoinError
 //  })
 //}, 3000)
;


// 
// THIS FILE HAS BEEN GENERATED AUTOMATICALLY
// DO NOT CHANGE IT MANUALLY UNLESS YOU KNOW WHAT YOU'RE DOING
// 
// GENERATED USING @colyseus/schema 2.0.19
// 
/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ /* global Reflect, Promise, SuppressedError, Symbol */ var $5c96a02c592fcff1$var$extendStatics = function(d, b) {
    $5c96a02c592fcff1$var$extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
    };
    return $5c96a02c592fcff1$var$extendStatics(d, b);
};
function $5c96a02c592fcff1$export$a8ba968b8961cb8a(d, b) {
    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
    $5c96a02c592fcff1$var$extendStatics(d, b);
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var $5c96a02c592fcff1$export$18ce0697a983be9b = function() {
    $5c96a02c592fcff1$export$18ce0697a983be9b = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $5c96a02c592fcff1$export$18ce0697a983be9b.apply(this, arguments);
};
function $5c96a02c592fcff1$export$3c9a16f847548506(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
function $5c96a02c592fcff1$export$29e00dfd3077644b(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function $5c96a02c592fcff1$export$d5ad3fd78186038f(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
}
function $5c96a02c592fcff1$export$3a84e1ae4e97e9b0(ctor, descriptorIn, decorators, contextIn, initializers, extraInitializers) {
    function accept(f) {
        if (f !== void 0 && typeof f !== "function") throw new TypeError("Function expected");
        return f;
    }
    var kind = contextIn.kind, key = kind === "getter" ? "get" : kind === "setter" ? "set" : "value";
    var target = !descriptorIn && ctor ? contextIn["static"] ? ctor : ctor.prototype : null;
    var descriptor = descriptorIn || (target ? Object.getOwnPropertyDescriptor(target, contextIn.name) : {});
    var _, done = false;
    for(var i = decorators.length - 1; i >= 0; i--){
        var context = {};
        for(var p in contextIn)context[p] = p === "access" ? {} : contextIn[p];
        for(var p in contextIn.access)context.access[p] = contextIn.access[p];
        context.addInitializer = function(f) {
            if (done) throw new TypeError("Cannot add initializers after decoration has completed");
            extraInitializers.push(accept(f || null));
        };
        var result = (0, decorators[i])(kind === "accessor" ? {
            get: descriptor.get,
            set: descriptor.set
        } : descriptor[key], context);
        if (kind === "accessor") {
            if (result === void 0) continue;
            if (result === null || typeof result !== "object") throw new TypeError("Object expected");
            if (_ = accept(result.get)) descriptor.get = _;
            if (_ = accept(result.set)) descriptor.set = _;
            if (_ = accept(result.init)) initializers.unshift(_);
        } else if (_ = accept(result)) {
            if (kind === "field") initializers.unshift(_);
            else descriptor[key] = _;
        }
    }
    if (target) Object.defineProperty(target, contextIn.name, descriptor);
    done = true;
}
function $5c96a02c592fcff1$export$d831c04e792af3d(thisArg, initializers, value) {
    var useValue = arguments.length > 2;
    for(var i = 0; i < initializers.length; i++)value = useValue ? initializers[i].call(thisArg, value) : initializers[i].call(thisArg);
    return useValue ? value : void 0;
}
function $5c96a02c592fcff1$export$6a2a36740a146cb8(x) {
    return typeof x === "symbol" ? x : "".concat(x);
}
function $5c96a02c592fcff1$export$d1a06452d3489bc7(f, name, prefix) {
    if (typeof name === "symbol") name = name.description ? "[".concat(name.description, "]") : "";
    return Object.defineProperty(f, "name", {
        configurable: true,
        value: prefix ? "".concat(prefix, " ", name) : name
    });
}
function $5c96a02c592fcff1$export$f1db080c865becb9(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}
function $5c96a02c592fcff1$export$1050f835b63b671e(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}
function $5c96a02c592fcff1$export$67ebef60e6f28a6(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
var $5c96a02c592fcff1$export$45d3717a4c69092e = Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
};
function $5c96a02c592fcff1$export$f33643c0debef087(m, o) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(o, p)) $5c96a02c592fcff1$export$45d3717a4c69092e(o, m, p);
}
function $5c96a02c592fcff1$export$19a8beecd37a4c45(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function $5c96a02c592fcff1$export$8d051b38c9118094(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
}
function $5c96a02c592fcff1$export$afc72e2116322959() {
    for(var ar = [], i = 0; i < arguments.length; i++)ar = ar.concat($5c96a02c592fcff1$export$8d051b38c9118094(arguments[i]));
    return ar;
}
function $5c96a02c592fcff1$export$6388937ca91ccae8() {
    for(var s = 0, i = 0, il = arguments.length; i < il; i++)s += arguments[i].length;
    for(var r = Array(s), k = 0, i = 0; i < il; i++)for(var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)r[k] = a[j];
    return r;
}
function $5c96a02c592fcff1$export$1216008129fb82ed(to, from, pack) {
    if (pack || arguments.length === 2) {
        for(var i = 0, l = from.length, ar; i < l; i++)if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
}
function $5c96a02c592fcff1$export$10c90e4f7922046c(v) {
    return this instanceof $5c96a02c592fcff1$export$10c90e4f7922046c ? (this.v = v, this) : new $5c96a02c592fcff1$export$10c90e4f7922046c(v);
}
function $5c96a02c592fcff1$export$e427f37a30a4de9b(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i;
    function verb(n) {
        if (g[n]) i[n] = function(v) {
            return new Promise(function(a, b) {
                q.push([
                    n,
                    v,
                    a,
                    b
                ]) > 1 || resume(n, v);
            });
        };
    }
    function resume(n, v) {
        try {
            step(g[n](v));
        } catch (e) {
            settle(q[0][3], e);
        }
    }
    function step(r) {
        r.value instanceof $5c96a02c592fcff1$export$10c90e4f7922046c ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);
    }
    function fulfill(value) {
        resume("next", value);
    }
    function reject(value) {
        resume("throw", value);
    }
    function settle(f, v) {
        if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]);
    }
}
function $5c96a02c592fcff1$export$bbd80228419bb833(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function(e) {
        throw e;
    }), verb("return"), i[Symbol.iterator] = function() {
        return this;
    }, i;
    function verb(n, f) {
        i[n] = o[n] ? function(v) {
            return (p = !p) ? {
                value: $5c96a02c592fcff1$export$10c90e4f7922046c(o[n](v)),
                done: false
            } : f ? f(v) : v;
        } : f;
    }
}
function $5c96a02c592fcff1$export$e3b29a3d6162315f(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof $5c96a02c592fcff1$export$19a8beecd37a4c45 === "function" ? $5c96a02c592fcff1$export$19a8beecd37a4c45(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i);
    function verb(n) {
        i[n] = o[n] && function(v) {
            return new Promise(function(resolve, reject) {
                v = o[n](v), settle(resolve, reject, v.done, v.value);
            });
        };
    }
    function settle(resolve, reject, d, v) {
        Promise.resolve(v).then(function(v) {
            resolve({
                value: v,
                done: d
            });
        }, reject);
    }
}
function $5c96a02c592fcff1$export$4fb47efe1390b86f(cooked, raw) {
    if (Object.defineProperty) Object.defineProperty(cooked, "raw", {
        value: raw
    });
    else cooked.raw = raw;
    return cooked;
}
var $5c96a02c592fcff1$var$__setModuleDefault = Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
};
function $5c96a02c592fcff1$export$c21735bcef00d192(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) $5c96a02c592fcff1$export$45d3717a4c69092e(result, mod, k);
    }
    $5c96a02c592fcff1$var$__setModuleDefault(result, mod);
    return result;
}
function $5c96a02c592fcff1$export$da59b14a69baef04(mod) {
    return mod && mod.__esModule ? mod : {
        default: mod
    };
}
function $5c96a02c592fcff1$export$d5dcaf168c640c35(receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
}
function $5c96a02c592fcff1$export$d40a35129aaff81f(receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value), value;
}
function $5c96a02c592fcff1$export$81fdc39f203e4e04(state, receiver) {
    if (receiver === null || typeof receiver !== "object" && typeof receiver !== "function") throw new TypeError("Cannot use 'in' operator on non-object");
    return typeof state === "function" ? receiver === state : state.has(receiver);
}
function $5c96a02c592fcff1$export$88ac25d8e944e405(env, value, async) {
    if (value !== null && value !== void 0) {
        if (typeof value !== "object" && typeof value !== "function") throw new TypeError("Object expected.");
        var dispose;
        if (async) {
            if (!Symbol.asyncDispose) throw new TypeError("Symbol.asyncDispose is not defined.");
            dispose = value[Symbol.asyncDispose];
        }
        if (dispose === void 0) {
            if (!Symbol.dispose) throw new TypeError("Symbol.dispose is not defined.");
            dispose = value[Symbol.dispose];
        }
        if (typeof dispose !== "function") throw new TypeError("Object not disposable.");
        env.stack.push({
            value: value,
            dispose: dispose,
            async: async
        });
    } else if (async) env.stack.push({
        async: true
    });
    return value;
}
var $5c96a02c592fcff1$var$_SuppressedError = typeof SuppressedError === "function" ? SuppressedError : function(error, suppressed, message) {
    var e = new Error(message);
    return e.name = "SuppressedError", e.error = error, e.suppressed = suppressed, e;
};
function $5c96a02c592fcff1$export$8f076105dc360e92(env) {
    function fail(e) {
        env.error = env.hasError ? new $5c96a02c592fcff1$var$_SuppressedError(e, env.error, "An error was suppressed during disposal.") : e;
        env.hasError = true;
    }
    function next() {
        while(env.stack.length){
            var rec = env.stack.pop();
            try {
                var result = rec.dispose && rec.dispose.call(rec.value);
                if (rec.async) return Promise.resolve(result).then(next, function(e) {
                    fail(e);
                    return next();
                });
            } catch (e) {
                fail(e);
            }
        }
        if (env.hasError) throw env.error;
    }
    return next();
}
var $5c96a02c592fcff1$export$2e2bcd8739ae039 = {
    __extends: $5c96a02c592fcff1$export$a8ba968b8961cb8a,
    __assign: $5c96a02c592fcff1$export$18ce0697a983be9b,
    __rest: $5c96a02c592fcff1$export$3c9a16f847548506,
    __decorate: $5c96a02c592fcff1$export$29e00dfd3077644b,
    __param: $5c96a02c592fcff1$export$d5ad3fd78186038f,
    __metadata: $5c96a02c592fcff1$export$f1db080c865becb9,
    __awaiter: $5c96a02c592fcff1$export$1050f835b63b671e,
    __generator: $5c96a02c592fcff1$export$67ebef60e6f28a6,
    __createBinding: $5c96a02c592fcff1$export$45d3717a4c69092e,
    __exportStar: $5c96a02c592fcff1$export$f33643c0debef087,
    __values: $5c96a02c592fcff1$export$19a8beecd37a4c45,
    __read: $5c96a02c592fcff1$export$8d051b38c9118094,
    __spread: $5c96a02c592fcff1$export$afc72e2116322959,
    __spreadArrays: $5c96a02c592fcff1$export$6388937ca91ccae8,
    __spreadArray: $5c96a02c592fcff1$export$1216008129fb82ed,
    __await: $5c96a02c592fcff1$export$10c90e4f7922046c,
    __asyncGenerator: $5c96a02c592fcff1$export$e427f37a30a4de9b,
    __asyncDelegator: $5c96a02c592fcff1$export$bbd80228419bb833,
    __asyncValues: $5c96a02c592fcff1$export$e3b29a3d6162315f,
    __makeTemplateObject: $5c96a02c592fcff1$export$4fb47efe1390b86f,
    __importStar: $5c96a02c592fcff1$export$c21735bcef00d192,
    __importDefault: $5c96a02c592fcff1$export$da59b14a69baef04,
    __classPrivateFieldGet: $5c96a02c592fcff1$export$d5dcaf168c640c35,
    __classPrivateFieldSet: $5c96a02c592fcff1$export$d40a35129aaff81f,
    __classPrivateFieldIn: $5c96a02c592fcff1$export$81fdc39f203e4e04,
    __addDisposableResource: $5c96a02c592fcff1$export$88ac25d8e944e405,
    __disposeResources: $5c96a02c592fcff1$export$8f076105dc360e92
};


var $13e0994b5a5d999e$exports = {};
(function(global, factory) {
    factory($13e0994b5a5d999e$exports);
})($13e0994b5a5d999e$exports, function(exports1) {
    "use strict";
    /******************************************************************************
    Copyright (c) Microsoft Corporation.

    Permission to use, copy, modify, and/or distribute this software for any
    purpose with or without fee is hereby granted.

    THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
    REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
    AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
    INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
    LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
    OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
    PERFORMANCE OF THIS SOFTWARE.
    ***************************************************************************** */ /* global Reflect, Promise, SuppressedError, Symbol */ var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    function __extends(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    }
    function __decorate(decorators, target, key, desc) {
        var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
        if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
        else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
        return c > 3 && r && Object.defineProperty(target, key, r), r;
    }
    function __spreadArray(to, from, pack) {
        if (pack || arguments.length === 2) {
            for(var i = 0, l = from.length, ar; i < l; i++)if (ar || !(i in from)) {
                if (!ar) ar = Array.prototype.slice.call(from, 0, i);
                ar[i] = from[i];
            }
        }
        return to.concat(ar || Array.prototype.slice.call(from));
    }
    typeof SuppressedError === "function" && SuppressedError;
    // export const SWITCH_TO_STRUCTURE = 193; (easily collides with DELETE_AND_ADD + fieldIndex = 2)
    var SWITCH_TO_STRUCTURE = 255; // (decoding collides with DELETE_AND_ADD + fieldIndex = 63)
    var TYPE_ID = 213;
    /**
     * Encoding Schema field operations.
     */ exports1.OPERATION = void 0;
    (function(OPERATION) {
        // add new structure/primitive
        OPERATION[OPERATION["ADD"] = 128] = "ADD";
        // replace structure/primitive
        OPERATION[OPERATION["REPLACE"] = 0] = "REPLACE";
        // delete field
        OPERATION[OPERATION["DELETE"] = 64] = "DELETE";
        // DELETE field, followed by an ADD
        OPERATION[OPERATION["DELETE_AND_ADD"] = 192] = "DELETE_AND_ADD";
        // TOUCH is used to determine hierarchy of nested Schema structures during serialization.
        // touches are NOT encoded.
        OPERATION[OPERATION["TOUCH"] = 1] = "TOUCH";
        // MapSchema Operations
        OPERATION[OPERATION["CLEAR"] = 10] = "CLEAR";
    })(exports1.OPERATION || (exports1.OPERATION = {}));
    // export enum OPERATION {
    //     // add new structure/primitive
    //     // (128)
    //     ADD = 128, // 10000000,
    //     // replace structure/primitive
    //     REPLACE = 1,// 00000001
    //     // delete field
    //     DELETE = 192, // 11000000
    //     // DELETE field, followed by an ADD
    //     DELETE_AND_ADD = 224, // 11100000
    //     // TOUCH is used to determine hierarchy of nested Schema structures during serialization.
    //     // touches are NOT encoded.
    //     TOUCH = 0, // 00000000
    //     // MapSchema Operations
    //     CLEAR = 10,
    // }
    var ChangeTree = /** @class */ function() {
        function ChangeTree(ref, parent, root) {
            this.changed = false;
            this.changes = new Map();
            this.allChanges = new Set();
            // cached indexes for filtering
            this.caches = {};
            this.currentCustomOperation = 0;
            this.ref = ref;
            this.setParent(parent, root);
        }
        ChangeTree.prototype.setParent = function(parent, root, parentIndex) {
            var _this = this;
            if (!this.indexes) this.indexes = this.ref instanceof Schema ? this.ref["_definition"].indexes : {};
            this.parent = parent;
            this.parentIndex = parentIndex;
            // avoid setting parents with empty `root`
            if (!root) return;
            this.root = root;
            //
            // assign same parent on child structures
            //
            if (this.ref instanceof Schema) {
                var definition = this.ref["_definition"];
                for(var field in definition.schema){
                    var value = this.ref[field];
                    if (value && value["$changes"]) {
                        var parentIndex_1 = definition.indexes[field];
                        value["$changes"].setParent(this.ref, root, parentIndex_1);
                    }
                }
            } else if (typeof this.ref === "object") this.ref.forEach(function(value, key) {
                if (value instanceof Schema) {
                    var changeTreee = value["$changes"];
                    var parentIndex_2 = _this.ref["$changes"].indexes[key];
                    changeTreee.setParent(_this.ref, _this.root, parentIndex_2);
                }
            });
        };
        ChangeTree.prototype.operation = function(op) {
            this.changes.set(--this.currentCustomOperation, op);
        };
        ChangeTree.prototype.change = function(fieldName, operation) {
            if (operation === void 0) operation = exports1.OPERATION.ADD;
            var index = typeof fieldName === "number" ? fieldName : this.indexes[fieldName];
            this.assertValidIndex(index, fieldName);
            var previousChange = this.changes.get(index);
            if (!previousChange || previousChange.op === exports1.OPERATION.DELETE || previousChange.op === exports1.OPERATION.TOUCH // (mazmorra.io's BattleAction issue)
            ) this.changes.set(index, {
                op: !previousChange ? operation : previousChange.op === exports1.OPERATION.DELETE ? exports1.OPERATION.DELETE_AND_ADD : operation,
                // : OPERATION.REPLACE,
                index: index
            });
            this.allChanges.add(index);
            this.changed = true;
            this.touchParents();
        };
        ChangeTree.prototype.touch = function(fieldName) {
            var index = typeof fieldName === "number" ? fieldName : this.indexes[fieldName];
            this.assertValidIndex(index, fieldName);
            if (!this.changes.has(index)) this.changes.set(index, {
                op: exports1.OPERATION.TOUCH,
                index: index
            });
            this.allChanges.add(index);
            // ensure touch is placed until the $root is found.
            this.touchParents();
        };
        ChangeTree.prototype.touchParents = function() {
            if (this.parent) this.parent["$changes"].touch(this.parentIndex);
        };
        ChangeTree.prototype.getType = function(index) {
            if (this.ref["_definition"]) {
                var definition = this.ref["_definition"];
                return definition.schema[definition.fieldsByIndex[index]];
            } else {
                var definition = this.parent["_definition"];
                var parentType = definition.schema[definition.fieldsByIndex[this.parentIndex]];
                //
                // Get the child type from parent structure.
                // - ["string"] => "string"
                // - { map: "string" } => "string"
                // - { set: "string" } => "string"
                //
                return Object.values(parentType)[0];
            }
        };
        ChangeTree.prototype.getChildrenFilter = function() {
            var childFilters = this.parent["_definition"].childFilters;
            return childFilters && childFilters[this.parentIndex];
        };
        //
        // used during `.encode()`
        //
        ChangeTree.prototype.getValue = function(index) {
            return this.ref["getByIndex"](index);
        };
        ChangeTree.prototype.delete = function(fieldName) {
            var index = typeof fieldName === "number" ? fieldName : this.indexes[fieldName];
            if (index === undefined) {
                console.warn("@colyseus/schema ".concat(this.ref.constructor.name, ": trying to delete non-existing index: ").concat(fieldName, " (").concat(index, ")"));
                return;
            }
            var previousValue = this.getValue(index);
            // console.log("$changes.delete =>", { fieldName, index, previousValue });
            this.changes.set(index, {
                op: exports1.OPERATION.DELETE,
                index: index
            });
            this.allChanges.delete(index);
            // delete cache
            delete this.caches[index];
            // remove `root` reference
            if (previousValue && previousValue["$changes"]) previousValue["$changes"].parent = undefined;
            this.changed = true;
            this.touchParents();
        };
        ChangeTree.prototype.discard = function(changed, discardAll) {
            var _this = this;
            if (changed === void 0) changed = false;
            if (discardAll === void 0) discardAll = false;
            //
            // Map, Array, etc:
            // Remove cached key to ensure ADD operations is unsed instead of
            // REPLACE in case same key is used on next patches.
            //
            // TODO: refactor this. this is not relevant for Collection and Set.
            //
            if (!(this.ref instanceof Schema)) this.changes.forEach(function(change) {
                if (change.op === exports1.OPERATION.DELETE) {
                    var index = _this.ref["getIndex"](change.index);
                    delete _this.indexes[index];
                }
            });
            this.changes.clear();
            this.changed = changed;
            if (discardAll) this.allChanges.clear();
            // re-set `currentCustomOperation`
            this.currentCustomOperation = 0;
        };
        /**
         * Recursively discard all changes from this, and child structures.
         */ ChangeTree.prototype.discardAll = function() {
            var _this = this;
            this.changes.forEach(function(change) {
                var value = _this.getValue(change.index);
                if (value && value["$changes"]) value["$changes"].discardAll();
            });
            this.discard();
        };
        // cache(field: number, beginIndex: number, endIndex: number) {
        ChangeTree.prototype.cache = function(field, cachedBytes) {
            this.caches[field] = cachedBytes;
        };
        ChangeTree.prototype.clone = function() {
            return new ChangeTree(this.ref, this.parent, this.root);
        };
        ChangeTree.prototype.ensureRefId = function() {
            // skip if refId is already set.
            if (this.refId !== undefined) return;
            this.refId = this.root.getNextUniqueId();
        };
        ChangeTree.prototype.assertValidIndex = function(index, fieldName) {
            if (index === undefined) throw new Error('ChangeTree: missing index for field "'.concat(fieldName, '"'));
        };
        return ChangeTree;
    }();
    function addCallback($callbacks, op, callback, existing) {
        // initialize list of callbacks
        if (!$callbacks[op]) $callbacks[op] = [];
        $callbacks[op].push(callback);
        //
        // Trigger callback for existing elements
        // - OPERATION.ADD
        // - OPERATION.REPLACE
        //
        existing === null || existing === void 0 || existing.forEach(function(item, key) {
            return callback(item, key);
        });
        return function() {
            return spliceOne($callbacks[op], $callbacks[op].indexOf(callback));
        };
    }
    function removeChildRefs(changes) {
        var _this = this;
        var needRemoveRef = typeof this.$changes.getType() !== "string";
        this.$items.forEach(function(item, key) {
            changes.push({
                refId: _this.$changes.refId,
                op: exports1.OPERATION.DELETE,
                field: key,
                value: undefined,
                previousValue: item
            });
            if (needRemoveRef) _this.$changes.root.removeRef(item["$changes"].refId);
        });
    }
    function spliceOne(arr, index) {
        // manually splice an array
        if (index === -1 || index >= arr.length) return false;
        var len = arr.length - 1;
        for(var i = index; i < len; i++)arr[i] = arr[i + 1];
        arr.length = len;
        return true;
    }
    var DEFAULT_SORT = function(a, b) {
        var A = a.toString();
        var B = b.toString();
        if (A < B) return -1;
        else if (A > B) return 1;
        else return 0;
    };
    function getArrayProxy(value) {
        value["$proxy"] = true;
        //
        // compatibility with @colyseus/schema 0.5.x
        // - allow `map["key"]`
        // - allow `map["key"] = "xxx"`
        // - allow `delete map["key"]`
        //
        value = new Proxy(value, {
            get: function(obj, prop) {
                if (typeof prop !== "symbol" && !isNaN(prop) // https://stackoverflow.com/a/175787/892698
                ) return obj.at(prop);
                else return obj[prop];
            },
            set: function(obj, prop, setValue) {
                if (typeof prop !== "symbol" && !isNaN(prop)) {
                    var indexes = Array.from(obj["$items"].keys());
                    var key = parseInt(indexes[prop] || prop);
                    if (setValue === undefined || setValue === null) obj.deleteAt(key);
                    else obj.setAt(key, setValue);
                } else obj[prop] = setValue;
                return true;
            },
            deleteProperty: function(obj, prop) {
                if (typeof prop === "number") obj.deleteAt(prop);
                else delete obj[prop];
                return true;
            },
            has: function(obj, key) {
                if (typeof key !== "symbol" && !isNaN(Number(key))) return obj["$items"].has(Number(key));
                return Reflect.has(obj, key);
            }
        });
        return value;
    }
    var ArraySchema = /** @class */ function() {
        function ArraySchema() {
            var items = [];
            for(var _i = 0; _i < arguments.length; _i++)items[_i] = arguments[_i];
            this.$changes = new ChangeTree(this);
            this.$items = new Map();
            this.$indexes = new Map();
            this.$refId = 0;
            this.push.apply(this, items);
        }
        ArraySchema.prototype.onAdd = function(callback, triggerAll) {
            if (triggerAll === void 0) triggerAll = true;
            return addCallback(this.$callbacks || (this.$callbacks = {}), exports1.OPERATION.ADD, callback, triggerAll ? this.$items : undefined);
        };
        ArraySchema.prototype.onRemove = function(callback) {
            return addCallback(this.$callbacks || (this.$callbacks = {}), exports1.OPERATION.DELETE, callback);
        };
        ArraySchema.prototype.onChange = function(callback) {
            return addCallback(this.$callbacks || (this.$callbacks = {}), exports1.OPERATION.REPLACE, callback);
        };
        ArraySchema.is = function(type) {
            return(// type format: ["string"]
            Array.isArray(type) || // type format: { array: "string" }
            type["array"] !== undefined);
        };
        Object.defineProperty(ArraySchema.prototype, "length", {
            get: function() {
                return this.$items.size;
            },
            set: function(value) {
                if (value === 0) this.clear();
                else this.splice(value, this.length - value);
            },
            enumerable: false,
            configurable: true
        });
        ArraySchema.prototype.push = function() {
            var _this = this;
            var values = [];
            for(var _i = 0; _i < arguments.length; _i++)values[_i] = arguments[_i];
            var lastIndex;
            values.forEach(function(value) {
                // set "index" for reference.
                lastIndex = _this.$refId++;
                _this.setAt(lastIndex, value);
            });
            return lastIndex;
        };
        /**
         * Removes the last element from an array and returns it.
         */ ArraySchema.prototype.pop = function() {
            var key = Array.from(this.$indexes.values()).pop();
            if (key === undefined) return undefined;
            this.$changes.delete(key);
            this.$indexes.delete(key);
            var value = this.$items.get(key);
            this.$items.delete(key);
            return value;
        };
        ArraySchema.prototype.at = function(index) {
            //
            // FIXME: this should be O(1)
            //
            var key = Array.from(this.$items.keys())[index];
            return this.$items.get(key);
        };
        ArraySchema.prototype.setAt = function(index, value) {
            var _a, _b;
            if (value === undefined || value === null) {
                console.error("ArraySchema items cannot be null nor undefined; Use `deleteAt(index)` instead.");
                return;
            }
            // skip if the value is the same as cached.
            if (this.$items.get(index) === value) return;
            if (value["$changes"] !== undefined) value["$changes"].setParent(this, this.$changes.root, index);
            var operation = (_b = (_a = this.$changes.indexes[index]) === null || _a === void 0 ? void 0 : _a.op) !== null && _b !== void 0 ? _b : exports1.OPERATION.ADD;
            this.$changes.indexes[index] = index;
            this.$indexes.set(index, index);
            this.$items.set(index, value);
            this.$changes.change(index, operation);
        };
        ArraySchema.prototype.deleteAt = function(index) {
            var key = Array.from(this.$items.keys())[index];
            if (key === undefined) return false;
            return this.$deleteAt(key);
        };
        ArraySchema.prototype.$deleteAt = function(index) {
            // delete at internal index
            this.$changes.delete(index);
            this.$indexes.delete(index);
            return this.$items.delete(index);
        };
        ArraySchema.prototype.clear = function(changes) {
            // discard previous operations.
            this.$changes.discard(true, true);
            this.$changes.indexes = {};
            // clear previous indexes
            this.$indexes.clear();
            //
            // When decoding:
            // - enqueue items for DELETE callback.
            // - flag child items for garbage collection.
            //
            if (changes) removeChildRefs.call(this, changes);
            // clear items
            this.$items.clear();
            this.$changes.operation({
                index: 0,
                op: exports1.OPERATION.CLEAR
            });
            // touch all structures until reach root
            this.$changes.touchParents();
        };
        /**
         * Combines two or more arrays.
         * @param items Additional items to add to the end of array1.
         */ // @ts-ignore
        ArraySchema.prototype.concat = function() {
            var _a;
            var items = [];
            for(var _i = 0; _i < arguments.length; _i++)items[_i] = arguments[_i];
            return new (ArraySchema.bind.apply(ArraySchema, __spreadArray([
                void 0
            ], (_a = Array.from(this.$items.values())).concat.apply(_a, items), false)))();
        };
        /**
         * Adds all the elements of an array separated by the specified separator string.
         * @param separator A string used to separate one element of an array from the next in the resulting String. If omitted, the array elements are separated with a comma.
         */ ArraySchema.prototype.join = function(separator) {
            return Array.from(this.$items.values()).join(separator);
        };
        /**
         * Reverses the elements in an Array.
         */ // @ts-ignore
        ArraySchema.prototype.reverse = function() {
            var _this = this;
            var indexes = Array.from(this.$items.keys());
            var reversedItems = Array.from(this.$items.values()).reverse();
            reversedItems.forEach(function(item, i) {
                _this.setAt(indexes[i], item);
            });
            return this;
        };
        /**
         * Removes the first element from an array and returns it.
         */ ArraySchema.prototype.shift = function() {
            var indexes = Array.from(this.$items.keys());
            var shiftAt = indexes.shift();
            if (shiftAt === undefined) return undefined;
            var value = this.$items.get(shiftAt);
            this.$deleteAt(shiftAt);
            return value;
        };
        /**
         * Returns a section of an array.
         * @param start The beginning of the specified portion of the array.
         * @param end The end of the specified portion of the array. This is exclusive of the element at the index 'end'.
         */ ArraySchema.prototype.slice = function(start, end) {
            var sliced = new ArraySchema();
            sliced.push.apply(sliced, Array.from(this.$items.values()).slice(start, end));
            return sliced;
        };
        /**
         * Sorts an array.
         * @param compareFn Function used to determine the order of the elements. It is expected to return
         * a negative value if first argument is less than second argument, zero if they're equal and a positive
         * value otherwise. If omitted, the elements are sorted in ascending, ASCII character order.
         * ```ts
         * [11,2,22,1].sort((a, b) => a - b)
         * ```
         */ ArraySchema.prototype.sort = function(compareFn) {
            var _this = this;
            if (compareFn === void 0) compareFn = DEFAULT_SORT;
            var indexes = Array.from(this.$items.keys());
            var sortedItems = Array.from(this.$items.values()).sort(compareFn);
            sortedItems.forEach(function(item, i) {
                _this.setAt(indexes[i], item);
            });
            return this;
        };
        /**
         * Removes elements from an array and, if necessary, inserts new elements in their place, returning the deleted elements.
         * @param start The zero-based location in the array from which to start removing elements.
         * @param deleteCount The number of elements to remove.
         * @param items Elements to insert into the array in place of the deleted elements.
         */ ArraySchema.prototype.splice = function(start, deleteCount) {
            if (deleteCount === void 0) deleteCount = this.length - start;
            var indexes = Array.from(this.$items.keys());
            var removedItems = [];
            for(var i = start; i < start + deleteCount; i++){
                removedItems.push(this.$items.get(indexes[i]));
                this.$deleteAt(indexes[i]);
            }
            return removedItems;
        };
        /**
         * Inserts new elements at the start of an array.
         * @param items  Elements to insert at the start of the Array.
         */ ArraySchema.prototype.unshift = function() {
            var _this = this;
            var items = [];
            for(var _i = 0; _i < arguments.length; _i++)items[_i] = arguments[_i];
            var length = this.length;
            var addedLength = items.length;
            // const indexes = Array.from(this.$items.keys());
            var previousValues = Array.from(this.$items.values());
            items.forEach(function(item, i) {
                _this.setAt(i, item);
            });
            previousValues.forEach(function(previousValue, i) {
                _this.setAt(addedLength + i, previousValue);
            });
            return length + addedLength;
        };
        /**
         * Returns the index of the first occurrence of a value in an array.
         * @param searchElement The value to locate in the array.
         * @param fromIndex The array index at which to begin the search. If fromIndex is omitted, the search starts at index 0.
         */ ArraySchema.prototype.indexOf = function(searchElement, fromIndex) {
            return Array.from(this.$items.values()).indexOf(searchElement, fromIndex);
        };
        /**
         * Returns the index of the last occurrence of a specified value in an array.
         * @param searchElement The value to locate in the array.
         * @param fromIndex The array index at which to begin the search. If fromIndex is omitted, the search starts at the last index in the array.
         */ ArraySchema.prototype.lastIndexOf = function(searchElement, fromIndex) {
            if (fromIndex === void 0) fromIndex = this.length - 1;
            return Array.from(this.$items.values()).lastIndexOf(searchElement, fromIndex);
        };
        /**
         * Determines whether all the members of an array satisfy the specified test.
         * @param callbackfn A function that accepts up to three arguments. The every method calls
         * the callbackfn function for each element in the array until the callbackfn returns a value
         * which is coercible to the Boolean value false, or until the end of the array.
         * @param thisArg An object to which the this keyword can refer in the callbackfn function.
         * If thisArg is omitted, undefined is used as the this value.
         */ ArraySchema.prototype.every = function(callbackfn, thisArg) {
            return Array.from(this.$items.values()).every(callbackfn, thisArg);
        };
        /**
         * Determines whether the specified callback function returns true for any element of an array.
         * @param callbackfn A function that accepts up to three arguments. The some method calls
         * the callbackfn function for each element in the array until the callbackfn returns a value
         * which is coercible to the Boolean value true, or until the end of the array.
         * @param thisArg An object to which the this keyword can refer in the callbackfn function.
         * If thisArg is omitted, undefined is used as the this value.
         */ ArraySchema.prototype.some = function(callbackfn, thisArg) {
            return Array.from(this.$items.values()).some(callbackfn, thisArg);
        };
        /**
         * Performs the specified action for each element in an array.
         * @param callbackfn  A function that accepts up to three arguments. forEach calls the callbackfn function one time for each element in the array.
         * @param thisArg  An object to which the this keyword can refer in the callbackfn function. If thisArg is omitted, undefined is used as the this value.
         */ ArraySchema.prototype.forEach = function(callbackfn, thisArg) {
            Array.from(this.$items.values()).forEach(callbackfn, thisArg);
        };
        /**
         * Calls a defined callback function on each element of an array, and returns an array that contains the results.
         * @param callbackfn A function that accepts up to three arguments. The map method calls the callbackfn function one time for each element in the array.
         * @param thisArg An object to which the this keyword can refer in the callbackfn function. If thisArg is omitted, undefined is used as the this value.
         */ ArraySchema.prototype.map = function(callbackfn, thisArg) {
            return Array.from(this.$items.values()).map(callbackfn, thisArg);
        };
        ArraySchema.prototype.filter = function(callbackfn, thisArg) {
            return Array.from(this.$items.values()).filter(callbackfn, thisArg);
        };
        /**
         * Calls the specified callback function for all the elements in an array. The return value of the callback function is the accumulated result, and is provided as an argument in the next call to the callback function.
         * @param callbackfn A function that accepts up to four arguments. The reduce method calls the callbackfn function one time for each element in the array.
         * @param initialValue If initialValue is specified, it is used as the initial value to start the accumulation. The first call to the callbackfn function provides this value as an argument instead of an array value.
         */ ArraySchema.prototype.reduce = function(callbackfn, initialValue) {
            return Array.prototype.reduce.apply(Array.from(this.$items.values()), arguments);
        };
        /**
         * Calls the specified callback function for all the elements in an array, in descending order. The return value of the callback function is the accumulated result, and is provided as an argument in the next call to the callback function.
         * @param callbackfn A function that accepts up to four arguments. The reduceRight method calls the callbackfn function one time for each element in the array.
         * @param initialValue If initialValue is specified, it is used as the initial value to start the accumulation. The first call to the callbackfn function provides this value as an argument instead of an array value.
         */ ArraySchema.prototype.reduceRight = function(callbackfn, initialValue) {
            return Array.prototype.reduceRight.apply(Array.from(this.$items.values()), arguments);
        };
        /**
         * Returns the value of the first element in the array where predicate is true, and undefined
         * otherwise.
         * @param predicate find calls predicate once for each element of the array, in ascending
         * order, until it finds one where predicate returns true. If such an element is found, find
         * immediately returns that element value. Otherwise, find returns undefined.
         * @param thisArg If provided, it will be used as the this value for each invocation of
         * predicate. If it is not provided, undefined is used instead.
         */ ArraySchema.prototype.find = function(predicate, thisArg) {
            return Array.from(this.$items.values()).find(predicate, thisArg);
        };
        /**
         * Returns the index of the first element in the array where predicate is true, and -1
         * otherwise.
         * @param predicate find calls predicate once for each element of the array, in ascending
         * order, until it finds one where predicate returns true. If such an element is found,
         * findIndex immediately returns that element index. Otherwise, findIndex returns -1.
         * @param thisArg If provided, it will be used as the this value for each invocation of
         * predicate. If it is not provided, undefined is used instead.
         */ ArraySchema.prototype.findIndex = function(predicate, thisArg) {
            return Array.from(this.$items.values()).findIndex(predicate, thisArg);
        };
        /**
         * Returns the this object after filling the section identified by start and end with value
         * @param value value to fill array section with
         * @param start index to start filling the array at. If start is negative, it is treated as
         * length+start where length is the length of the array.
         * @param end index to stop filling the array at. If end is negative, it is treated as
         * length+end.
         */ ArraySchema.prototype.fill = function(value, start, end) {
            //
            // TODO
            //
            throw new Error("ArraySchema#fill() not implemented");
        };
        /**
         * Returns the this object after copying a section of the array identified by start and end
         * to the same array starting at position target
         * @param target If target is negative, it is treated as length+target where length is the
         * length of the array.
         * @param start If start is negative, it is treated as length+start. If end is negative, it
         * is treated as length+end.
         * @param end If not specified, length of the this object is used as its default value.
         */ ArraySchema.prototype.copyWithin = function(target, start, end) {
            //
            // TODO
            //
            throw new Error("ArraySchema#copyWithin() not implemented");
        };
        /**
         * Returns a string representation of an array.
         */ ArraySchema.prototype.toString = function() {
            return this.$items.toString();
        };
        /**
         * Returns a string representation of an array. The elements are converted to string using their toLocalString methods.
         */ ArraySchema.prototype.toLocaleString = function() {
            return this.$items.toLocaleString();
        };
        /** Iterator */ ArraySchema.prototype[Symbol.iterator] = function() {
            return Array.from(this.$items.values())[Symbol.iterator]();
        };
        Object.defineProperty(ArraySchema, Symbol.species, {
            get: function() {
                return ArraySchema;
            },
            enumerable: false,
            configurable: true
        });
        /**
         * Returns an iterable of key, value pairs for every entry in the array
         */ ArraySchema.prototype.entries = function() {
            return this.$items.entries();
        };
        /**
         * Returns an iterable of keys in the array
         */ ArraySchema.prototype.keys = function() {
            return this.$items.keys();
        };
        /**
         * Returns an iterable of values in the array
         */ ArraySchema.prototype.values = function() {
            return this.$items.values();
        };
        /**
         * Determines whether an array includes a certain element, returning true or false as appropriate.
         * @param searchElement The element to search for.
         * @param fromIndex The position in this array at which to begin searching for searchElement.
         */ ArraySchema.prototype.includes = function(searchElement, fromIndex) {
            return Array.from(this.$items.values()).includes(searchElement, fromIndex);
        };
        /**
         * Calls a defined callback function on each element of an array. Then, flattens the result into
         * a new array.
         * This is identical to a map followed by flat with depth 1.
         *
         * @param callback A function that accepts up to three arguments. The flatMap method calls the
         * callback function one time for each element in the array.
         * @param thisArg An object to which the this keyword can refer in the callback function. If
         * thisArg is omitted, undefined is used as the this value.
         */ // @ts-ignore
        ArraySchema.prototype.flatMap = function(callback, thisArg) {
            // @ts-ignore
            throw new Error("ArraySchema#flatMap() is not supported.");
        };
        /**
         * Returns a new array with all sub-array elements concatenated into it recursively up to the
         * specified depth.
         *
         * @param depth The maximum recursion depth
         */ // @ts-ignore
        ArraySchema.prototype.flat = function(depth) {
            throw new Error("ArraySchema#flat() is not supported.");
        };
        ArraySchema.prototype.findLast = function() {
            var arr = Array.from(this.$items.values());
            // @ts-ignore
            return arr.findLast.apply(arr, arguments);
        };
        ArraySchema.prototype.findLastIndex = function() {
            var arr = Array.from(this.$items.values());
            // @ts-ignore
            return arr.findLastIndex.apply(arr, arguments);
        };
        // get size () {
        //     return this.$items.size;
        // }
        ArraySchema.prototype.setIndex = function(index, key) {
            this.$indexes.set(index, key);
        };
        ArraySchema.prototype.getIndex = function(index) {
            return this.$indexes.get(index);
        };
        ArraySchema.prototype.getByIndex = function(index) {
            return this.$items.get(this.$indexes.get(index));
        };
        ArraySchema.prototype.deleteByIndex = function(index) {
            var key = this.$indexes.get(index);
            this.$items.delete(key);
            this.$indexes.delete(index);
        };
        ArraySchema.prototype.toArray = function() {
            return Array.from(this.$items.values());
        };
        ArraySchema.prototype.toJSON = function() {
            return this.toArray().map(function(value) {
                return typeof value["toJSON"] === "function" ? value["toJSON"]() : value;
            });
        };
        //
        // Decoding utilities
        //
        ArraySchema.prototype.clone = function(isDecoding) {
            var cloned;
            if (isDecoding) cloned = new (ArraySchema.bind.apply(ArraySchema, __spreadArray([
                void 0
            ], Array.from(this.$items.values()), false)))();
            else cloned = new (ArraySchema.bind.apply(ArraySchema, __spreadArray([
                void 0
            ], this.map(function(item) {
                return item["$changes"] ? item.clone() : item;
            }), false)))();
            return cloned;
        };
        return ArraySchema;
    }();
    function getMapProxy(value) {
        value["$proxy"] = true;
        value = new Proxy(value, {
            get: function(obj, prop) {
                if (typeof prop !== "symbol" && // accessing properties
                typeof obj[prop] === "undefined") return obj.get(prop);
                else return obj[prop];
            },
            set: function(obj, prop, setValue) {
                if (typeof prop !== "symbol" && prop.indexOf("$") === -1 && prop !== "onAdd" && prop !== "onRemove" && prop !== "onChange") obj.set(prop, setValue);
                else obj[prop] = setValue;
                return true;
            },
            deleteProperty: function(obj, prop) {
                obj.delete(prop);
                return true;
            }
        });
        return value;
    }
    var MapSchema = /** @class */ function() {
        function MapSchema(initialValues) {
            var _this = this;
            this.$changes = new ChangeTree(this);
            this.$items = new Map();
            this.$indexes = new Map();
            this.$refId = 0;
            if (initialValues) {
                if (initialValues instanceof Map || initialValues instanceof MapSchema) initialValues.forEach(function(v, k) {
                    return _this.set(k, v);
                });
                else for(var k in initialValues)this.set(k, initialValues[k]);
            }
        }
        MapSchema.prototype.onAdd = function(callback, triggerAll) {
            if (triggerAll === void 0) triggerAll = true;
            return addCallback(this.$callbacks || (this.$callbacks = {}), exports1.OPERATION.ADD, callback, triggerAll ? this.$items : undefined);
        };
        MapSchema.prototype.onRemove = function(callback) {
            return addCallback(this.$callbacks || (this.$callbacks = {}), exports1.OPERATION.DELETE, callback);
        };
        MapSchema.prototype.onChange = function(callback) {
            return addCallback(this.$callbacks || (this.$callbacks = {}), exports1.OPERATION.REPLACE, callback);
        };
        MapSchema.is = function(type) {
            return type["map"] !== undefined;
        };
        /** Iterator */ MapSchema.prototype[Symbol.iterator] = function() {
            return this.$items[Symbol.iterator]();
        };
        Object.defineProperty(MapSchema.prototype, Symbol.toStringTag, {
            get: function() {
                return this.$items[Symbol.toStringTag];
            },
            enumerable: false,
            configurable: true
        });
        Object.defineProperty(MapSchema, Symbol.species, {
            get: function() {
                return MapSchema;
            },
            enumerable: false,
            configurable: true
        });
        MapSchema.prototype.set = function(key, value) {
            if (value === undefined || value === null) throw new Error("MapSchema#set('".concat(key, "', ").concat(value, "): trying to set ").concat(value, " value on '").concat(key, "'."));
            // Force "key" as string
            // See: https://github.com/colyseus/colyseus/issues/561#issuecomment-1646733468
            key = key.toString();
            // get "index" for this value.
            var hasIndex = typeof this.$changes.indexes[key] !== "undefined";
            var index = hasIndex ? this.$changes.indexes[key] : this.$refId++;
            var operation = hasIndex ? exports1.OPERATION.REPLACE : exports1.OPERATION.ADD;
            var isRef = value["$changes"] !== undefined;
            if (isRef) value["$changes"].setParent(this, this.$changes.root, index);
            //
            // (encoding)
            // set a unique id to relate directly with this key/value.
            //
            if (!hasIndex) {
                this.$changes.indexes[key] = index;
                this.$indexes.set(index, key);
            } else if (!isRef && this.$items.get(key) === value) // if value is the same, avoid re-encoding it.
            return;
            else if (isRef && // if is schema, force ADD operation if value differ from previous one.
            this.$items.get(key) !== value) operation = exports1.OPERATION.ADD;
            this.$items.set(key, value);
            this.$changes.change(key, operation);
            return this;
        };
        MapSchema.prototype.get = function(key) {
            return this.$items.get(key);
        };
        MapSchema.prototype.delete = function(key) {
            //
            // TODO: add a "purge" method after .encode() runs, to cleanup removed `$indexes`
            //
            // We don't remove $indexes to allow setting the same key in the same patch
            // (See "should allow to remove and set an item in the same place" test)
            //
            // // const index = this.$changes.indexes[key];
            // // this.$indexes.delete(index);
            this.$changes.delete(key);
            return this.$items.delete(key);
        };
        MapSchema.prototype.clear = function(changes) {
            // discard previous operations.
            this.$changes.discard(true, true);
            this.$changes.indexes = {};
            // clear previous indexes
            this.$indexes.clear();
            //
            // When decoding:
            // - enqueue items for DELETE callback.
            // - flag child items for garbage collection.
            //
            if (changes) removeChildRefs.call(this, changes);
            // clear items
            this.$items.clear();
            this.$changes.operation({
                index: 0,
                op: exports1.OPERATION.CLEAR
            });
            // touch all structures until reach root
            this.$changes.touchParents();
        };
        MapSchema.prototype.has = function(key) {
            return this.$items.has(key);
        };
        MapSchema.prototype.forEach = function(callbackfn) {
            this.$items.forEach(callbackfn);
        };
        MapSchema.prototype.entries = function() {
            return this.$items.entries();
        };
        MapSchema.prototype.keys = function() {
            return this.$items.keys();
        };
        MapSchema.prototype.values = function() {
            return this.$items.values();
        };
        Object.defineProperty(MapSchema.prototype, "size", {
            get: function() {
                return this.$items.size;
            },
            enumerable: false,
            configurable: true
        });
        MapSchema.prototype.setIndex = function(index, key) {
            this.$indexes.set(index, key);
        };
        MapSchema.prototype.getIndex = function(index) {
            return this.$indexes.get(index);
        };
        MapSchema.prototype.getByIndex = function(index) {
            return this.$items.get(this.$indexes.get(index));
        };
        MapSchema.prototype.deleteByIndex = function(index) {
            var key = this.$indexes.get(index);
            this.$items.delete(key);
            this.$indexes.delete(index);
        };
        MapSchema.prototype.toJSON = function() {
            var map = {};
            this.forEach(function(value, key) {
                map[key] = typeof value["toJSON"] === "function" ? value["toJSON"]() : value;
            });
            return map;
        };
        //
        // Decoding utilities
        //
        MapSchema.prototype.clone = function(isDecoding) {
            var cloned;
            if (isDecoding) // client-side
            cloned = Object.assign(new MapSchema(), this);
            else {
                // server-side
                cloned = new MapSchema();
                this.forEach(function(value, key) {
                    if (value["$changes"]) cloned.set(key, value["clone"]());
                    else cloned.set(key, value);
                });
            }
            return cloned;
        };
        return MapSchema;
    }();
    var registeredTypes = {};
    function registerType(identifier, definition) {
        registeredTypes[identifier] = definition;
    }
    function getType(identifier) {
        return registeredTypes[identifier];
    }
    var SchemaDefinition = /** @class */ function() {
        function SchemaDefinition() {
            //
            // TODO: use a "field" structure combining all these properties per-field.
            //
            this.indexes = {};
            this.fieldsByIndex = {};
            this.deprecated = {};
            this.descriptors = {};
        }
        SchemaDefinition.create = function(parent) {
            var definition = new SchemaDefinition();
            // support inheritance
            definition.schema = Object.assign({}, parent && parent.schema || {});
            definition.indexes = Object.assign({}, parent && parent.indexes || {});
            definition.fieldsByIndex = Object.assign({}, parent && parent.fieldsByIndex || {});
            definition.descriptors = Object.assign({}, parent && parent.descriptors || {});
            definition.deprecated = Object.assign({}, parent && parent.deprecated || {});
            return definition;
        };
        SchemaDefinition.prototype.addField = function(field, type) {
            var index = this.getNextFieldIndex();
            this.fieldsByIndex[index] = field;
            this.indexes[field] = index;
            this.schema[field] = Array.isArray(type) ? {
                array: type[0]
            } : type;
        };
        SchemaDefinition.prototype.hasField = function(field) {
            return this.indexes[field] !== undefined;
        };
        SchemaDefinition.prototype.addFilter = function(field, cb) {
            if (!this.filters) {
                this.filters = {};
                this.indexesWithFilters = [];
            }
            this.filters[this.indexes[field]] = cb;
            this.indexesWithFilters.push(this.indexes[field]);
            return true;
        };
        SchemaDefinition.prototype.addChildrenFilter = function(field, cb) {
            var index = this.indexes[field];
            var type = this.schema[field];
            if (getType(Object.keys(type)[0])) {
                if (!this.childFilters) this.childFilters = {};
                this.childFilters[index] = cb;
                return true;
            } else console.warn("@filterChildren: field '".concat(field, "' can't have children. Ignoring filter."));
        };
        SchemaDefinition.prototype.getChildrenFilter = function(field) {
            return this.childFilters && this.childFilters[this.indexes[field]];
        };
        SchemaDefinition.prototype.getNextFieldIndex = function() {
            return Object.keys(this.schema || {}).length;
        };
        return SchemaDefinition;
    }();
    function hasFilter(klass) {
        return klass._context && klass._context.useFilters;
    }
    var Context = /** @class */ function() {
        function Context() {
            this.types = {};
            this.schemas = new Map();
            this.useFilters = false;
        }
        Context.prototype.has = function(schema) {
            return this.schemas.has(schema);
        };
        Context.prototype.get = function(typeid) {
            return this.types[typeid];
        };
        Context.prototype.add = function(schema, typeid) {
            if (typeid === void 0) typeid = this.schemas.size;
            // FIXME: move this to somewhere else?
            // support inheritance
            schema._definition = SchemaDefinition.create(schema._definition);
            schema._typeid = typeid;
            this.types[typeid] = schema;
            this.schemas.set(schema, typeid);
        };
        Context.create = function(options) {
            if (options === void 0) options = {};
            return function(definition) {
                if (!options.context) options.context = new Context();
                return type(definition, options);
            };
        };
        return Context;
    }();
    var globalContext = new Context();
    /**
     * [See documentation](https://docs.colyseus.io/state/schema/)
     *
     * Annotate a Schema property to be serializeable.
     * \@type()'d fields are automatically flagged as "dirty" for the next patch.
     *
     * @example Standard usage, with automatic change tracking.
     * ```
     * \@type("string") propertyName: string;
     * ```
     *
     * @example You can provide the "manual" option if you'd like to manually control your patches via .setDirty().
     * ```
     * \@type("string", { manual: true })
     * ```
     */ function type(type, options) {
        if (options === void 0) options = {};
        return function(target, field) {
            var context = options.context || globalContext;
            var constructor = target.constructor;
            constructor._context = context;
            if (!type) throw new Error("".concat(constructor.name, ': @type() reference provided for "').concat(field, "\" is undefined. Make sure you don't have any circular dependencies."));
            /*
             * static schema
             */ if (!context.has(constructor)) context.add(constructor);
            var definition = constructor._definition;
            definition.addField(field, type);
            /**
             * skip if descriptor already exists for this field (`@deprecated()`)
             */ if (definition.descriptors[field]) {
                if (definition.deprecated[field]) // do not create accessors for deprecated properties.
                return;
                else // trying to define same property multiple times across inheritance.
                // https://github.com/colyseus/colyseus-unity3d/issues/131#issuecomment-814308572
                try {
                    throw new Error("@colyseus/schema: Duplicate '".concat(field, "' definition on '").concat(constructor.name, "'.\nCheck @type() annotation"));
                } catch (e) {
                    var definitionAtLine = e.stack.split("\n")[4].trim();
                    throw new Error("".concat(e.message, " ").concat(definitionAtLine));
                }
            }
            var isArray = ArraySchema.is(type);
            var isMap = !isArray && MapSchema.is(type);
            // TODO: refactor me.
            // Allow abstract intermediary classes with no fields to be serialized
            // (See "should support an inheritance with a Schema type without fields" test)
            if (typeof type !== "string" && !Schema.is(type)) {
                var childType = Object.values(type)[0];
                if (typeof childType !== "string" && !context.has(childType)) context.add(childType);
            }
            if (options.manual) {
                // do not declare getter/setter descriptor
                definition.descriptors[field] = {
                    enumerable: true,
                    configurable: true,
                    writable: true
                };
                return;
            }
            var fieldCached = "_".concat(field);
            definition.descriptors[fieldCached] = {
                enumerable: false,
                configurable: false,
                writable: true
            };
            definition.descriptors[field] = {
                get: function() {
                    return this[fieldCached];
                },
                set: function(value) {
                    /**
                     * Create Proxy for array or map items
                     */ // skip if value is the same as cached.
                    if (value === this[fieldCached]) return;
                    if (value !== undefined && value !== null) {
                        // automaticallty transform Array into ArraySchema
                        if (isArray && !(value instanceof ArraySchema)) value = new (ArraySchema.bind.apply(ArraySchema, __spreadArray([
                            void 0
                        ], value, false)))();
                        // automaticallty transform Map into MapSchema
                        if (isMap && !(value instanceof MapSchema)) value = new MapSchema(value);
                        // try to turn provided structure into a Proxy
                        if (value["$proxy"] === undefined) {
                            if (isMap) value = getMapProxy(value);
                            else if (isArray) value = getArrayProxy(value);
                        }
                        // flag the change for encoding.
                        this.$changes.change(field);
                        //
                        // call setParent() recursively for this and its child
                        // structures.
                        //
                        if (value["$changes"]) value["$changes"].setParent(this, this.$changes.root, this._definition.indexes[field]);
                    } else if (this[fieldCached]) //
                    // Setting a field to `null` or `undefined` will delete it.
                    //
                    this.$changes.delete(field);
                    this[fieldCached] = value;
                },
                enumerable: true,
                configurable: true
            };
        };
    }
    /**
     * `@filter()` decorator for defining data filters per client
     */ function filter(cb) {
        return function(target, field) {
            var constructor = target.constructor;
            var definition = constructor._definition;
            if (definition.addFilter(field, cb)) constructor._context.useFilters = true;
        };
    }
    function filterChildren(cb) {
        return function(target, field) {
            var constructor = target.constructor;
            var definition = constructor._definition;
            if (definition.addChildrenFilter(field, cb)) constructor._context.useFilters = true;
        };
    }
    /**
     * `@deprecated()` flag a field as deprecated.
     * The previous `@type()` annotation should remain along with this one.
     */ function deprecated(throws) {
        if (throws === void 0) throws = true;
        return function(target, field) {
            var constructor = target.constructor;
            var definition = constructor._definition;
            definition.deprecated[field] = true;
            if (throws) definition.descriptors[field] = {
                get: function() {
                    throw new Error("".concat(field, " is deprecated."));
                },
                set: function(value) {},
                enumerable: false,
                configurable: true
            };
        };
    }
    function defineTypes(target, fields, options) {
        if (options === void 0) options = {};
        if (!options.context) options.context = target._context || options.context || globalContext;
        for(var field in fields)type(fields[field], options)(target.prototype, field);
        return target;
    }
    /**
     * Copyright (c) 2018 Endel Dreyer
     * Copyright (c) 2014 Ion Drive Software Ltd.
     *
     * Permission is hereby granted, free of charge, to any person obtaining a copy
     * of this software and associated documentation files (the "Software"), to deal
     * in the Software without restriction, including without limitation the rights
     * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
     * copies of the Software, and to permit persons to whom the Software is
     * furnished to do so, subject to the following conditions:
     *
     * The above copyright notice and this permission notice shall be included in all
     * copies or substantial portions of the Software.
     *
     * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
     * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
     * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
     * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
     * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
     * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
     * SOFTWARE
     */ /**
     * msgpack implementation highly based on notepack.io
     * https://github.com/darrachequesne/notepack
     */ function utf8Length(str) {
        var c = 0, length = 0;
        for(var i = 0, l = str.length; i < l; i++){
            c = str.charCodeAt(i);
            if (c < 0x80) length += 1;
            else if (c < 0x800) length += 2;
            else if (c < 0xd800 || c >= 0xe000) length += 3;
            else {
                i++;
                length += 4;
            }
        }
        return length;
    }
    function utf8Write(view, offset, str) {
        var c = 0;
        for(var i = 0, l = str.length; i < l; i++){
            c = str.charCodeAt(i);
            if (c < 0x80) view[offset++] = c;
            else if (c < 0x800) {
                view[offset++] = 0xc0 | c >> 6;
                view[offset++] = 0x80 | c & 0x3f;
            } else if (c < 0xd800 || c >= 0xe000) {
                view[offset++] = 0xe0 | c >> 12;
                view[offset++] = 0x80 | c >> 6 & 0x3f;
                view[offset++] = 0x80 | c & 0x3f;
            } else {
                i++;
                c = 0x10000 + ((c & 0x3ff) << 10 | str.charCodeAt(i) & 0x3ff);
                view[offset++] = 0xf0 | c >> 18;
                view[offset++] = 0x80 | c >> 12 & 0x3f;
                view[offset++] = 0x80 | c >> 6 & 0x3f;
                view[offset++] = 0x80 | c & 0x3f;
            }
        }
    }
    function int8$1(bytes, value) {
        bytes.push(value & 255);
    }
    function uint8$1(bytes, value) {
        bytes.push(value & 255);
    }
    function int16$1(bytes, value) {
        bytes.push(value & 255);
        bytes.push(value >> 8 & 255);
    }
    function uint16$1(bytes, value) {
        bytes.push(value & 255);
        bytes.push(value >> 8 & 255);
    }
    function int32$1(bytes, value) {
        bytes.push(value & 255);
        bytes.push(value >> 8 & 255);
        bytes.push(value >> 16 & 255);
        bytes.push(value >> 24 & 255);
    }
    function uint32$1(bytes, value) {
        var b4 = value >> 24;
        var b3 = value >> 16;
        var b2 = value >> 8;
        var b1 = value;
        bytes.push(b1 & 255);
        bytes.push(b2 & 255);
        bytes.push(b3 & 255);
        bytes.push(b4 & 255);
    }
    function int64$1(bytes, value) {
        var high = Math.floor(value / Math.pow(2, 32));
        var low = value >>> 0;
        uint32$1(bytes, low);
        uint32$1(bytes, high);
    }
    function uint64$1(bytes, value) {
        var high = value / Math.pow(2, 32) >> 0;
        var low = value >>> 0;
        uint32$1(bytes, low);
        uint32$1(bytes, high);
    }
    function float32$1(bytes, value) {
        writeFloat32(bytes, value);
    }
    function float64$1(bytes, value) {
        writeFloat64(bytes, value);
    }
    var _int32$1 = new Int32Array(2);
    var _float32$1 = new Float32Array(_int32$1.buffer);
    var _float64$1 = new Float64Array(_int32$1.buffer);
    function writeFloat32(bytes, value) {
        _float32$1[0] = value;
        int32$1(bytes, _int32$1[0]);
    }
    function writeFloat64(bytes, value) {
        _float64$1[0] = value;
        int32$1(bytes, _int32$1[0]);
        int32$1(bytes, _int32$1[1]);
    }
    function boolean$1(bytes, value) {
        return uint8$1(bytes, value ? 1 : 0);
    }
    function string$1(bytes, value) {
        // encode `null` strings as empty.
        if (!value) value = "";
        var length = utf8Length(value);
        var size = 0;
        // fixstr
        if (length < 0x20) {
            bytes.push(length | 0xa0);
            size = 1;
        } else if (length < 0x100) {
            bytes.push(0xd9);
            uint8$1(bytes, length);
            size = 2;
        } else if (length < 0x10000) {
            bytes.push(0xda);
            uint16$1(bytes, length);
            size = 3;
        } else if (length < 0x100000000) {
            bytes.push(0xdb);
            uint32$1(bytes, length);
            size = 5;
        } else throw new Error("String too long");
        utf8Write(bytes, bytes.length, value);
        return size + length;
    }
    function number$1(bytes, value) {
        if (isNaN(value)) return number$1(bytes, 0);
        else if (!isFinite(value)) return number$1(bytes, value > 0 ? Number.MAX_SAFE_INTEGER : -Number.MAX_SAFE_INTEGER);
        else if (value !== (value | 0)) {
            bytes.push(0xcb);
            writeFloat64(bytes, value);
            return 9;
        // TODO: encode float 32?
        // is it possible to differentiate between float32 / float64 here?
        // // float 32
        // bytes.push(0xca);
        // writeFloat32(bytes, value);
        // return 5;
        }
        if (value >= 0) {
            // positive fixnum
            if (value < 0x80) {
                uint8$1(bytes, value);
                return 1;
            }
            // uint 8
            if (value < 0x100) {
                bytes.push(0xcc);
                uint8$1(bytes, value);
                return 2;
            }
            // uint 16
            if (value < 0x10000) {
                bytes.push(0xcd);
                uint16$1(bytes, value);
                return 3;
            }
            // uint 32
            if (value < 0x100000000) {
                bytes.push(0xce);
                uint32$1(bytes, value);
                return 5;
            }
            // uint 64
            bytes.push(0xcf);
            uint64$1(bytes, value);
            return 9;
        } else {
            // negative fixnum
            if (value >= -32) {
                bytes.push(0xe0 | value + 0x20);
                return 1;
            }
            // int 8
            if (value >= -128) {
                bytes.push(0xd0);
                int8$1(bytes, value);
                return 2;
            }
            // int 16
            if (value >= -32768) {
                bytes.push(0xd1);
                int16$1(bytes, value);
                return 3;
            }
            // int 32
            if (value >= -2147483648) {
                bytes.push(0xd2);
                int32$1(bytes, value);
                return 5;
            }
            // int 64
            bytes.push(0xd3);
            int64$1(bytes, value);
            return 9;
        }
    }
    var encode = /*#__PURE__*/ Object.freeze({
        __proto__: null,
        utf8Write: utf8Write,
        int8: int8$1,
        uint8: uint8$1,
        int16: int16$1,
        uint16: uint16$1,
        int32: int32$1,
        uint32: uint32$1,
        int64: int64$1,
        uint64: uint64$1,
        float32: float32$1,
        float64: float64$1,
        writeFloat32: writeFloat32,
        writeFloat64: writeFloat64,
        boolean: boolean$1,
        string: string$1,
        number: number$1
    });
    /**
     * Copyright (c) 2018 Endel Dreyer
     * Copyright (c) 2014 Ion Drive Software Ltd.
     *
     * Permission is hereby granted, free of charge, to any person obtaining a copy
     * of this software and associated documentation files (the "Software"), to deal
     * in the Software without restriction, including without limitation the rights
     * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
     * copies of the Software, and to permit persons to whom the Software is
     * furnished to do so, subject to the following conditions:
     *
     * The above copyright notice and this permission notice shall be included in all
     * copies or substantial portions of the Software.
     *
     * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
     * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
     * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
     * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
     * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
     * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
     * SOFTWARE
     */ function utf8Read(bytes, offset, length) {
        var string = "", chr = 0;
        for(var i = offset, end = offset + length; i < end; i++){
            var byte = bytes[i];
            if ((byte & 0x80) === 0x00) {
                string += String.fromCharCode(byte);
                continue;
            }
            if ((byte & 0xe0) === 0xc0) {
                string += String.fromCharCode((byte & 0x1f) << 6 | bytes[++i] & 0x3f);
                continue;
            }
            if ((byte & 0xf0) === 0xe0) {
                string += String.fromCharCode((byte & 0x0f) << 12 | (bytes[++i] & 0x3f) << 6 | (bytes[++i] & 0x3f) << 0);
                continue;
            }
            if ((byte & 0xf8) === 0xf0) {
                chr = (byte & 0x07) << 18 | (bytes[++i] & 0x3f) << 12 | (bytes[++i] & 0x3f) << 6 | (bytes[++i] & 0x3f) << 0;
                if (chr >= 0x010000) {
                    chr -= 0x010000;
                    string += String.fromCharCode((chr >>> 10) + 0xD800, (chr & 0x3FF) + 0xDC00);
                } else string += String.fromCharCode(chr);
                continue;
            }
            console.error("Invalid byte " + byte.toString(16));
        // (do not throw error to avoid server/client from crashing due to hack attemps)
        // throw new Error('Invalid byte ' + byte.toString(16));
        }
        return string;
    }
    function int8(bytes, it) {
        return uint8(bytes, it) << 24 >> 24;
    }
    function uint8(bytes, it) {
        return bytes[it.offset++];
    }
    function int16(bytes, it) {
        return uint16(bytes, it) << 16 >> 16;
    }
    function uint16(bytes, it) {
        return bytes[it.offset++] | bytes[it.offset++] << 8;
    }
    function int32(bytes, it) {
        return bytes[it.offset++] | bytes[it.offset++] << 8 | bytes[it.offset++] << 16 | bytes[it.offset++] << 24;
    }
    function uint32(bytes, it) {
        return int32(bytes, it) >>> 0;
    }
    function float32(bytes, it) {
        return readFloat32(bytes, it);
    }
    function float64(bytes, it) {
        return readFloat64(bytes, it);
    }
    function int64(bytes, it) {
        var low = uint32(bytes, it);
        var high = int32(bytes, it) * Math.pow(2, 32);
        return high + low;
    }
    function uint64(bytes, it) {
        var low = uint32(bytes, it);
        var high = uint32(bytes, it) * Math.pow(2, 32);
        return high + low;
    }
    var _int32 = new Int32Array(2);
    var _float32 = new Float32Array(_int32.buffer);
    var _float64 = new Float64Array(_int32.buffer);
    function readFloat32(bytes, it) {
        _int32[0] = int32(bytes, it);
        return _float32[0];
    }
    function readFloat64(bytes, it) {
        _int32[0] = int32(bytes, it);
        _int32[1] = int32(bytes, it);
        return _float64[0];
    }
    function boolean(bytes, it) {
        return uint8(bytes, it) > 0;
    }
    function string(bytes, it) {
        var prefix = bytes[it.offset++];
        var length;
        if (prefix < 0xc0) // fixstr
        length = prefix & 0x1f;
        else if (prefix === 0xd9) length = uint8(bytes, it);
        else if (prefix === 0xda) length = uint16(bytes, it);
        else if (prefix === 0xdb) length = uint32(bytes, it);
        var value = utf8Read(bytes, it.offset, length);
        it.offset += length;
        return value;
    }
    function stringCheck(bytes, it) {
        var prefix = bytes[it.offset];
        return(// fixstr
        prefix < 0xc0 && prefix > 0xa0 || // str 8
        prefix === 0xd9 || // str 16
        prefix === 0xda || // str 32
        prefix === 0xdb);
    }
    function number(bytes, it) {
        var prefix = bytes[it.offset++];
        if (prefix < 0x80) // positive fixint
        return prefix;
        else if (prefix === 0xca) // float 32
        return readFloat32(bytes, it);
        else if (prefix === 0xcb) // float 64
        return readFloat64(bytes, it);
        else if (prefix === 0xcc) // uint 8
        return uint8(bytes, it);
        else if (prefix === 0xcd) // uint 16
        return uint16(bytes, it);
        else if (prefix === 0xce) // uint 32
        return uint32(bytes, it);
        else if (prefix === 0xcf) // uint 64
        return uint64(bytes, it);
        else if (prefix === 0xd0) // int 8
        return int8(bytes, it);
        else if (prefix === 0xd1) // int 16
        return int16(bytes, it);
        else if (prefix === 0xd2) // int 32
        return int32(bytes, it);
        else if (prefix === 0xd3) // int 64
        return int64(bytes, it);
        else if (prefix > 0xdf) // negative fixint
        return (0xff - prefix + 1) * -1;
    }
    function numberCheck(bytes, it) {
        var prefix = bytes[it.offset];
        // positive fixint - 0x00 - 0x7f
        // float 32        - 0xca
        // float 64        - 0xcb
        // uint 8          - 0xcc
        // uint 16         - 0xcd
        // uint 32         - 0xce
        // uint 64         - 0xcf
        // int 8           - 0xd0
        // int 16          - 0xd1
        // int 32          - 0xd2
        // int 64          - 0xd3
        return prefix < 0x80 || prefix >= 0xca && prefix <= 0xd3;
    }
    function arrayCheck(bytes, it) {
        return bytes[it.offset] < 0xa0;
    // const prefix = bytes[it.offset] ;
    // if (prefix < 0xa0) {
    //   return prefix;
    // // array
    // } else if (prefix === 0xdc) {
    //   it.offset += 2;
    // } else if (0xdd) {
    //   it.offset += 4;
    // }
    // return prefix;
    }
    function switchStructureCheck(bytes, it) {
        return(// previous byte should be `SWITCH_TO_STRUCTURE`
        bytes[it.offset - 1] === SWITCH_TO_STRUCTURE && // next byte should be a number
        (bytes[it.offset] < 0x80 || bytes[it.offset] >= 0xca && bytes[it.offset] <= 0xd3));
    }
    var decode = /*#__PURE__*/ Object.freeze({
        __proto__: null,
        int8: int8,
        uint8: uint8,
        int16: int16,
        uint16: uint16,
        int32: int32,
        uint32: uint32,
        float32: float32,
        float64: float64,
        int64: int64,
        uint64: uint64,
        readFloat32: readFloat32,
        readFloat64: readFloat64,
        boolean: boolean,
        string: string,
        stringCheck: stringCheck,
        number: number,
        numberCheck: numberCheck,
        arrayCheck: arrayCheck,
        switchStructureCheck: switchStructureCheck
    });
    var CollectionSchema = /** @class */ function() {
        function CollectionSchema(initialValues) {
            var _this = this;
            this.$changes = new ChangeTree(this);
            this.$items = new Map();
            this.$indexes = new Map();
            this.$refId = 0;
            if (initialValues) initialValues.forEach(function(v) {
                return _this.add(v);
            });
        }
        CollectionSchema.prototype.onAdd = function(callback, triggerAll) {
            if (triggerAll === void 0) triggerAll = true;
            return addCallback(this.$callbacks || (this.$callbacks = []), exports1.OPERATION.ADD, callback, triggerAll ? this.$items : undefined);
        };
        CollectionSchema.prototype.onRemove = function(callback) {
            return addCallback(this.$callbacks || (this.$callbacks = []), exports1.OPERATION.DELETE, callback);
        };
        CollectionSchema.prototype.onChange = function(callback) {
            return addCallback(this.$callbacks || (this.$callbacks = []), exports1.OPERATION.REPLACE, callback);
        };
        CollectionSchema.is = function(type) {
            return type["collection"] !== undefined;
        };
        CollectionSchema.prototype.add = function(value) {
            // set "index" for reference.
            var index = this.$refId++;
            var isRef = value["$changes"] !== undefined;
            if (isRef) value["$changes"].setParent(this, this.$changes.root, index);
            this.$changes.indexes[index] = index;
            this.$indexes.set(index, index);
            this.$items.set(index, value);
            this.$changes.change(index);
            return index;
        };
        CollectionSchema.prototype.at = function(index) {
            var key = Array.from(this.$items.keys())[index];
            return this.$items.get(key);
        };
        CollectionSchema.prototype.entries = function() {
            return this.$items.entries();
        };
        CollectionSchema.prototype.delete = function(item) {
            var entries = this.$items.entries();
            var index;
            var entry;
            while(entry = entries.next()){
                if (entry.done) break;
                if (item === entry.value[1]) {
                    index = entry.value[0];
                    break;
                }
            }
            if (index === undefined) return false;
            this.$changes.delete(index);
            this.$indexes.delete(index);
            return this.$items.delete(index);
        };
        CollectionSchema.prototype.clear = function(changes) {
            // discard previous operations.
            this.$changes.discard(true, true);
            this.$changes.indexes = {};
            // clear previous indexes
            this.$indexes.clear();
            //
            // When decoding:
            // - enqueue items for DELETE callback.
            // - flag child items for garbage collection.
            //
            if (changes) removeChildRefs.call(this, changes);
            // clear items
            this.$items.clear();
            this.$changes.operation({
                index: 0,
                op: exports1.OPERATION.CLEAR
            });
            // touch all structures until reach root
            this.$changes.touchParents();
        };
        CollectionSchema.prototype.has = function(value) {
            return Array.from(this.$items.values()).some(function(v) {
                return v === value;
            });
        };
        CollectionSchema.prototype.forEach = function(callbackfn) {
            var _this = this;
            this.$items.forEach(function(value, key, _) {
                return callbackfn(value, key, _this);
            });
        };
        CollectionSchema.prototype.values = function() {
            return this.$items.values();
        };
        Object.defineProperty(CollectionSchema.prototype, "size", {
            get: function() {
                return this.$items.size;
            },
            enumerable: false,
            configurable: true
        });
        CollectionSchema.prototype.setIndex = function(index, key) {
            this.$indexes.set(index, key);
        };
        CollectionSchema.prototype.getIndex = function(index) {
            return this.$indexes.get(index);
        };
        CollectionSchema.prototype.getByIndex = function(index) {
            return this.$items.get(this.$indexes.get(index));
        };
        CollectionSchema.prototype.deleteByIndex = function(index) {
            var key = this.$indexes.get(index);
            this.$items.delete(key);
            this.$indexes.delete(index);
        };
        CollectionSchema.prototype.toArray = function() {
            return Array.from(this.$items.values());
        };
        CollectionSchema.prototype.toJSON = function() {
            var values = [];
            this.forEach(function(value, key) {
                values.push(typeof value["toJSON"] === "function" ? value["toJSON"]() : value);
            });
            return values;
        };
        //
        // Decoding utilities
        //
        CollectionSchema.prototype.clone = function(isDecoding) {
            var cloned;
            if (isDecoding) // client-side
            cloned = Object.assign(new CollectionSchema(), this);
            else {
                // server-side
                cloned = new CollectionSchema();
                this.forEach(function(value) {
                    if (value["$changes"]) cloned.add(value["clone"]());
                    else cloned.add(value);
                });
            }
            return cloned;
        };
        return CollectionSchema;
    }();
    var SetSchema = /** @class */ function() {
        function SetSchema(initialValues) {
            var _this = this;
            this.$changes = new ChangeTree(this);
            this.$items = new Map();
            this.$indexes = new Map();
            this.$refId = 0;
            if (initialValues) initialValues.forEach(function(v) {
                return _this.add(v);
            });
        }
        SetSchema.prototype.onAdd = function(callback, triggerAll) {
            if (triggerAll === void 0) triggerAll = true;
            return addCallback(this.$callbacks || (this.$callbacks = []), exports1.OPERATION.ADD, callback, triggerAll ? this.$items : undefined);
        };
        SetSchema.prototype.onRemove = function(callback) {
            return addCallback(this.$callbacks || (this.$callbacks = []), exports1.OPERATION.DELETE, callback);
        };
        SetSchema.prototype.onChange = function(callback) {
            return addCallback(this.$callbacks || (this.$callbacks = []), exports1.OPERATION.REPLACE, callback);
        };
        SetSchema.is = function(type) {
            return type["set"] !== undefined;
        };
        SetSchema.prototype.add = function(value) {
            var _a, _b;
            // immediatelly return false if value already added.
            if (this.has(value)) return false;
            // set "index" for reference.
            var index = this.$refId++;
            if (value["$changes"] !== undefined) value["$changes"].setParent(this, this.$changes.root, index);
            var operation = (_b = (_a = this.$changes.indexes[index]) === null || _a === void 0 ? void 0 : _a.op) !== null && _b !== void 0 ? _b : exports1.OPERATION.ADD;
            this.$changes.indexes[index] = index;
            this.$indexes.set(index, index);
            this.$items.set(index, value);
            this.$changes.change(index, operation);
            return index;
        };
        SetSchema.prototype.entries = function() {
            return this.$items.entries();
        };
        SetSchema.prototype.delete = function(item) {
            var entries = this.$items.entries();
            var index;
            var entry;
            while(entry = entries.next()){
                if (entry.done) break;
                if (item === entry.value[1]) {
                    index = entry.value[0];
                    break;
                }
            }
            if (index === undefined) return false;
            this.$changes.delete(index);
            this.$indexes.delete(index);
            return this.$items.delete(index);
        };
        SetSchema.prototype.clear = function(changes) {
            // discard previous operations.
            this.$changes.discard(true, true);
            this.$changes.indexes = {};
            // clear previous indexes
            this.$indexes.clear();
            //
            // When decoding:
            // - enqueue items for DELETE callback.
            // - flag child items for garbage collection.
            //
            if (changes) removeChildRefs.call(this, changes);
            // clear items
            this.$items.clear();
            this.$changes.operation({
                index: 0,
                op: exports1.OPERATION.CLEAR
            });
            // touch all structures until reach root
            this.$changes.touchParents();
        };
        SetSchema.prototype.has = function(value) {
            var values = this.$items.values();
            var has = false;
            var entry;
            while(entry = values.next()){
                if (entry.done) break;
                if (value === entry.value) {
                    has = true;
                    break;
                }
            }
            return has;
        };
        SetSchema.prototype.forEach = function(callbackfn) {
            var _this = this;
            this.$items.forEach(function(value, key, _) {
                return callbackfn(value, key, _this);
            });
        };
        SetSchema.prototype.values = function() {
            return this.$items.values();
        };
        Object.defineProperty(SetSchema.prototype, "size", {
            get: function() {
                return this.$items.size;
            },
            enumerable: false,
            configurable: true
        });
        SetSchema.prototype.setIndex = function(index, key) {
            this.$indexes.set(index, key);
        };
        SetSchema.prototype.getIndex = function(index) {
            return this.$indexes.get(index);
        };
        SetSchema.prototype.getByIndex = function(index) {
            return this.$items.get(this.$indexes.get(index));
        };
        SetSchema.prototype.deleteByIndex = function(index) {
            var key = this.$indexes.get(index);
            this.$items.delete(key);
            this.$indexes.delete(index);
        };
        SetSchema.prototype.toArray = function() {
            return Array.from(this.$items.values());
        };
        SetSchema.prototype.toJSON = function() {
            var values = [];
            this.forEach(function(value, key) {
                values.push(typeof value["toJSON"] === "function" ? value["toJSON"]() : value);
            });
            return values;
        };
        //
        // Decoding utilities
        //
        SetSchema.prototype.clone = function(isDecoding) {
            var cloned;
            if (isDecoding) // client-side
            cloned = Object.assign(new SetSchema(), this);
            else {
                // server-side
                cloned = new SetSchema();
                this.forEach(function(value) {
                    if (value["$changes"]) cloned.add(value["clone"]());
                    else cloned.add(value);
                });
            }
            return cloned;
        };
        return SetSchema;
    }();
    var ClientState = /** @class */ function() {
        function ClientState() {
            this.refIds = new WeakSet();
            this.containerIndexes = new WeakMap();
        }
        // containerIndexes = new Map<ChangeTree, Set<number>>();
        ClientState.prototype.addRefId = function(changeTree) {
            if (!this.refIds.has(changeTree)) {
                this.refIds.add(changeTree);
                this.containerIndexes.set(changeTree, new Set());
            }
        };
        ClientState.get = function(client) {
            if (client.$filterState === undefined) client.$filterState = new ClientState();
            return client.$filterState;
        };
        return ClientState;
    }();
    var ReferenceTracker = /** @class */ function() {
        function ReferenceTracker() {
            //
            // Relation of refId => Schema structure
            // For direct access of structures during decoding time.
            //
            this.refs = new Map();
            this.refCounts = {};
            this.deletedRefs = new Set();
            this.nextUniqueId = 0;
        }
        ReferenceTracker.prototype.getNextUniqueId = function() {
            return this.nextUniqueId++;
        };
        // for decoding
        ReferenceTracker.prototype.addRef = function(refId, ref, incrementCount) {
            if (incrementCount === void 0) incrementCount = true;
            this.refs.set(refId, ref);
            if (incrementCount) this.refCounts[refId] = (this.refCounts[refId] || 0) + 1;
        };
        // for decoding
        ReferenceTracker.prototype.removeRef = function(refId) {
            this.refCounts[refId] = this.refCounts[refId] - 1;
            this.deletedRefs.add(refId);
        };
        ReferenceTracker.prototype.clearRefs = function() {
            this.refs.clear();
            this.deletedRefs.clear();
            this.refCounts = {};
        };
        // for decoding
        ReferenceTracker.prototype.garbageCollectDeletedRefs = function() {
            var _this = this;
            this.deletedRefs.forEach(function(refId) {
                //
                // Skip active references.
                //
                if (_this.refCounts[refId] > 0) return;
                var ref = _this.refs.get(refId);
                //
                // Ensure child schema instances have their references removed as well.
                //
                if (ref instanceof Schema) {
                    for(var fieldName in ref["_definition"].schema)if (typeof ref["_definition"].schema[fieldName] !== "string" && ref[fieldName] && ref[fieldName]["$changes"]) _this.removeRef(ref[fieldName]["$changes"].refId);
                } else {
                    var definition = ref["$changes"].parent._definition;
                    var type = definition.schema[definition.fieldsByIndex[ref["$changes"].parentIndex]];
                    if (typeof Object.values(type)[0] === "function") Array.from(ref.values()).forEach(function(child) {
                        return _this.removeRef(child["$changes"].refId);
                    });
                }
                _this.refs.delete(refId);
                delete _this.refCounts[refId];
            });
            // clear deleted refs.
            this.deletedRefs.clear();
        };
        return ReferenceTracker;
    }();
    var EncodeSchemaError = /** @class */ function(_super) {
        __extends(EncodeSchemaError, _super);
        function EncodeSchemaError() {
            return _super !== null && _super.apply(this, arguments) || this;
        }
        return EncodeSchemaError;
    }(Error);
    function assertType(value, type, klass, field) {
        var typeofTarget;
        var allowNull = false;
        switch(type){
            case "number":
            case "int8":
            case "uint8":
            case "int16":
            case "uint16":
            case "int32":
            case "uint32":
            case "int64":
            case "uint64":
            case "float32":
            case "float64":
                typeofTarget = "number";
                if (isNaN(value)) console.log('trying to encode "NaN" in '.concat(klass.constructor.name, "#").concat(field));
                break;
            case "string":
                typeofTarget = "string";
                allowNull = true;
                break;
            case "boolean":
                // boolean is always encoded as true/false based on truthiness
                return;
        }
        if (typeof value !== typeofTarget && (!allowNull || allowNull && value !== null)) {
            var foundValue = "'".concat(JSON.stringify(value), "'").concat(value && value.constructor && " (".concat(value.constructor.name, ")") || "");
            throw new EncodeSchemaError("a '".concat(typeofTarget, "' was expected, but ").concat(foundValue, " was provided in ").concat(klass.constructor.name, "#").concat(field));
        }
    }
    function assertInstanceType(value, type, klass, field) {
        if (!(value instanceof type)) throw new EncodeSchemaError("a '".concat(type.name, "' was expected, but '").concat(value.constructor.name, "' was provided in ").concat(klass.constructor.name, "#").concat(field));
    }
    function encodePrimitiveType(type, bytes, value, klass, field) {
        assertType(value, type, klass, field);
        var encodeFunc = encode[type];
        if (encodeFunc) encodeFunc(bytes, value);
        else throw new EncodeSchemaError("a '".concat(type, "' was expected, but ").concat(value, " was provided in ").concat(klass.constructor.name, "#").concat(field));
    }
    function decodePrimitiveType(type, bytes, it) {
        return decode[type](bytes, it);
    }
    /**
     * Schema encoder / decoder
     */ var Schema = /** @class */ function() {
        // allow inherited classes to have a constructor
        function Schema() {
            var args = [];
            for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
            // fix enumerability of fields for end-user
            Object.defineProperties(this, {
                $changes: {
                    value: new ChangeTree(this, undefined, new ReferenceTracker()),
                    enumerable: false,
                    writable: true
                },
                // $listeners: {
                //     value: undefined,
                //     enumerable: false,
                //     writable: true
                // },
                $callbacks: {
                    value: undefined,
                    enumerable: false,
                    writable: true
                }
            });
            var descriptors = this._definition.descriptors;
            if (descriptors) Object.defineProperties(this, descriptors);
            //
            // Assign initial values
            //
            if (args[0]) this.assign(args[0]);
        }
        Schema.onError = function(e) {
            console.error(e);
        };
        Schema.is = function(type) {
            return type["_definition"] && type["_definition"].schema !== undefined;
        };
        Schema.prototype.onChange = function(callback) {
            return addCallback(this.$callbacks || (this.$callbacks = {}), exports1.OPERATION.REPLACE, callback);
        };
        Schema.prototype.onRemove = function(callback) {
            return addCallback(this.$callbacks || (this.$callbacks = {}), exports1.OPERATION.DELETE, callback);
        };
        Schema.prototype.assign = function(props) {
            Object.assign(this, props);
            return this;
        };
        Object.defineProperty(Schema.prototype, "_definition", {
            get: function() {
                return this.constructor._definition;
            },
            enumerable: false,
            configurable: true
        });
        /**
         * (Server-side): Flag a property to be encoded for the next patch.
         * @param instance Schema instance
         * @param property string representing the property name, or number representing the index of the property.
         * @param operation OPERATION to perform (detected automatically)
         */ Schema.prototype.setDirty = function(property, operation) {
            this.$changes.change(property, operation);
        };
        /**
         * Client-side: listen for changes on property.
         * @param prop the property name
         * @param callback callback to be triggered on property change
         * @param immediate trigger immediatelly if property has been already set.
         */ Schema.prototype.listen = function(prop, callback, immediate) {
            var _this = this;
            if (immediate === void 0) immediate = true;
            if (!this.$callbacks) this.$callbacks = {};
            if (!this.$callbacks[prop]) this.$callbacks[prop] = [];
            this.$callbacks[prop].push(callback);
            if (immediate && this[prop] !== undefined) callback(this[prop], undefined);
            // return un-register callback.
            return function() {
                return spliceOne(_this.$callbacks[prop], _this.$callbacks[prop].indexOf(callback));
            };
        };
        Schema.prototype.decode = function(bytes, it, ref) {
            if (it === void 0) it = {
                offset: 0
            };
            if (ref === void 0) ref = this;
            var allChanges = [];
            var $root = this.$changes.root;
            var totalBytes = bytes.length;
            var refId = 0;
            $root.refs.set(refId, this);
            while(it.offset < totalBytes){
                var byte = bytes[it.offset++];
                if (byte == SWITCH_TO_STRUCTURE) {
                    refId = number(bytes, it);
                    var nextRef = $root.refs.get(refId);
                    //
                    // Trying to access a reference that haven't been decoded yet.
                    //
                    if (!nextRef) throw new Error('"refId" not found: '.concat(refId));
                    ref = nextRef;
                    continue;
                }
                var changeTree = ref["$changes"];
                var isSchema = ref["_definition"] !== undefined;
                var operation = isSchema ? byte >> 6 << 6 // "compressed" index + operation
                 : byte; // "uncompressed" index + operation (array/map items)
                if (operation === exports1.OPERATION.CLEAR) {
                    //
                    // TODO: refactor me!
                    // The `.clear()` method is calling `$root.removeRef(refId)` for
                    // each item inside this collection
                    //
                    ref.clear(allChanges);
                    continue;
                }
                var fieldIndex = isSchema ? byte % (operation || 255 // if "REPLACE" operation (0), use 255
                ) : number(bytes, it);
                var fieldName = isSchema ? ref["_definition"].fieldsByIndex[fieldIndex] : "";
                var type = changeTree.getType(fieldIndex);
                var value = void 0;
                var previousValue = void 0;
                var dynamicIndex = void 0;
                if (!isSchema) {
                    previousValue = ref["getByIndex"](fieldIndex);
                    if ((operation & exports1.OPERATION.ADD) === exports1.OPERATION.ADD) {
                        dynamicIndex = ref instanceof MapSchema ? string(bytes, it) : fieldIndex;
                        ref["setIndex"](fieldIndex, dynamicIndex);
                    } else // here
                    dynamicIndex = ref["getIndex"](fieldIndex);
                } else previousValue = ref["_".concat(fieldName)];
                //
                // Delete operations
                //
                if ((operation & exports1.OPERATION.DELETE) === exports1.OPERATION.DELETE) {
                    if (operation !== exports1.OPERATION.DELETE_AND_ADD) ref["deleteByIndex"](fieldIndex);
                    // Flag `refId` for garbage collection.
                    if (previousValue && previousValue["$changes"]) $root.removeRef(previousValue["$changes"].refId);
                    value = null;
                }
                if (fieldName === undefined) {
                    console.warn("@colyseus/schema: definition mismatch");
                    //
                    // keep skipping next bytes until reaches a known structure
                    // by local decoder.
                    //
                    var nextIterator = {
                        offset: it.offset
                    };
                    while(it.offset < totalBytes){
                        if (switchStructureCheck(bytes, it)) {
                            nextIterator.offset = it.offset + 1;
                            if ($root.refs.has(number(bytes, nextIterator))) break;
                        }
                        it.offset++;
                    }
                    continue;
                } else if (operation === exports1.OPERATION.DELETE) ;
                else if (Schema.is(type)) {
                    var refId_1 = number(bytes, it);
                    value = $root.refs.get(refId_1);
                    if (operation !== exports1.OPERATION.REPLACE) {
                        var childType = this.getSchemaType(bytes, it, type);
                        if (!value) {
                            value = this.createTypeInstance(childType);
                            value.$changes.refId = refId_1;
                            if (previousValue) {
                                value.$callbacks = previousValue.$callbacks;
                                // value.$listeners = previousValue.$listeners;
                                if (previousValue["$changes"].refId && refId_1 !== previousValue["$changes"].refId) $root.removeRef(previousValue["$changes"].refId);
                            }
                        }
                        $root.addRef(refId_1, value, value !== previousValue);
                    }
                } else if (typeof type === "string") //
                // primitive value (number, string, boolean, etc)
                //
                value = decodePrimitiveType(type, bytes, it);
                else {
                    var typeDef = getType(Object.keys(type)[0]);
                    var refId_2 = number(bytes, it);
                    var valueRef = $root.refs.has(refId_2) ? previousValue || $root.refs.get(refId_2) : new typeDef.constructor();
                    value = valueRef.clone(true);
                    value.$changes.refId = refId_2;
                    // preserve schema callbacks
                    if (previousValue) {
                        value["$callbacks"] = previousValue["$callbacks"];
                        if (previousValue["$changes"].refId && refId_2 !== previousValue["$changes"].refId) {
                            $root.removeRef(previousValue["$changes"].refId);
                            //
                            // Trigger onRemove if structure has been replaced.
                            //
                            var entries = previousValue.entries();
                            var iter = void 0;
                            while((iter = entries.next()) && !iter.done){
                                var _a = iter.value, key = _a[0], value_1 = _a[1];
                                allChanges.push({
                                    refId: refId_2,
                                    op: exports1.OPERATION.DELETE,
                                    field: key,
                                    value: undefined,
                                    previousValue: value_1
                                });
                            }
                        }
                    }
                    $root.addRef(refId_2, value, valueRef !== previousValue);
                }
                if (value !== null && value !== undefined) {
                    if (value["$changes"]) value["$changes"].setParent(changeTree.ref, changeTree.root, fieldIndex);
                    if (ref instanceof Schema) ref[fieldName] = value;
                    else if (ref instanceof MapSchema) {
                        // const key = ref['$indexes'].get(field);
                        var key = dynamicIndex;
                        // ref.set(key, value);
                        ref["$items"].set(key, value);
                        ref["$changes"].allChanges.add(fieldIndex);
                    } else if (ref instanceof ArraySchema) // const key = ref['$indexes'][field];
                    // console.log("SETTING FOR ArraySchema =>", { field, key, value });
                    // ref[key] = value;
                    ref.setAt(fieldIndex, value);
                    else if (ref instanceof CollectionSchema) {
                        var index = ref.add(value);
                        ref["setIndex"](fieldIndex, index);
                    } else if (ref instanceof SetSchema) {
                        var index = ref.add(value);
                        if (index !== false) ref["setIndex"](fieldIndex, index);
                    }
                }
                if (previousValue !== value) allChanges.push({
                    refId: refId,
                    op: operation,
                    field: fieldName,
                    dynamicIndex: dynamicIndex,
                    value: value,
                    previousValue: previousValue
                });
            }
            this._triggerChanges(allChanges);
            // drop references of unused schemas
            $root.garbageCollectDeletedRefs();
            return allChanges;
        };
        Schema.prototype.encode = function(encodeAll, bytes, useFilters) {
            if (encodeAll === void 0) encodeAll = false;
            if (bytes === void 0) bytes = [];
            if (useFilters === void 0) useFilters = false;
            var rootChangeTree = this.$changes;
            var refIdsVisited = new WeakSet();
            var changeTrees = [
                rootChangeTree
            ];
            var numChangeTrees = 1;
            for(var i = 0; i < numChangeTrees; i++){
                var changeTree = changeTrees[i];
                var ref = changeTree.ref;
                var isSchema = ref instanceof Schema;
                // Generate unique refId for the ChangeTree.
                changeTree.ensureRefId();
                // mark this ChangeTree as visited.
                refIdsVisited.add(changeTree);
                // root `refId` is skipped.
                if (changeTree !== rootChangeTree && (changeTree.changed || encodeAll)) {
                    uint8$1(bytes, SWITCH_TO_STRUCTURE);
                    number$1(bytes, changeTree.refId);
                }
                var changes = encodeAll ? Array.from(changeTree.allChanges) : Array.from(changeTree.changes.values());
                for(var j = 0, cl = changes.length; j < cl; j++){
                    var operation = encodeAll ? {
                        op: exports1.OPERATION.ADD,
                        index: changes[j]
                    } : changes[j];
                    var fieldIndex = operation.index;
                    var field = isSchema ? ref["_definition"].fieldsByIndex && ref["_definition"].fieldsByIndex[fieldIndex] : fieldIndex;
                    // cache begin index if `useFilters`
                    var beginIndex = bytes.length;
                    // encode field index + operation
                    if (operation.op !== exports1.OPERATION.TOUCH) {
                        if (isSchema) //
                        // Compress `fieldIndex` + `operation` into a single byte.
                        // This adds a limitaion of 64 fields per Schema structure
                        //
                        uint8$1(bytes, fieldIndex | operation.op);
                        else {
                            uint8$1(bytes, operation.op);
                            // custom operations
                            if (operation.op === exports1.OPERATION.CLEAR) continue;
                            // indexed operations
                            number$1(bytes, fieldIndex);
                        }
                    }
                    //
                    // encode "alias" for dynamic fields (maps)
                    //
                    if (!isSchema && (operation.op & exports1.OPERATION.ADD) == exports1.OPERATION.ADD // ADD or DELETE_AND_ADD
                    ) {
                        if (ref instanceof MapSchema) {
                            //
                            // MapSchema dynamic key
                            //
                            var dynamicIndex = changeTree.ref["$indexes"].get(fieldIndex);
                            string$1(bytes, dynamicIndex);
                        }
                    }
                    if (operation.op === exports1.OPERATION.DELETE) continue;
                    // const type = changeTree.childType || ref._schema[field];
                    var type = changeTree.getType(fieldIndex);
                    // const type = changeTree.getType(fieldIndex);
                    var value = changeTree.getValue(fieldIndex);
                    // Enqueue ChangeTree to be visited
                    if (value && value["$changes"] && !refIdsVisited.has(value["$changes"])) {
                        changeTrees.push(value["$changes"]);
                        value["$changes"].ensureRefId();
                        numChangeTrees++;
                    }
                    if (operation.op === exports1.OPERATION.TOUCH) continue;
                    if (Schema.is(type)) {
                        assertInstanceType(value, type, ref, field);
                        //
                        // Encode refId for this instance.
                        // The actual instance is going to be encoded on next `changeTree` iteration.
                        //
                        number$1(bytes, value.$changes.refId);
                        // Try to encode inherited TYPE_ID if it's an ADD operation.
                        if ((operation.op & exports1.OPERATION.ADD) === exports1.OPERATION.ADD) this.tryEncodeTypeId(bytes, type, value.constructor);
                    } else if (typeof type === "string") //
                    // Primitive values
                    //
                    encodePrimitiveType(type, bytes, value, ref, field);
                    else {
                        //
                        // Custom type (MapSchema, ArraySchema, etc)
                        //
                        var definition = getType(Object.keys(type)[0]);
                        //
                        // ensure a ArraySchema has been provided
                        //
                        assertInstanceType(ref["_".concat(field)], definition.constructor, ref, field);
                        //
                        // Encode refId for this instance.
                        // The actual instance is going to be encoded on next `changeTree` iteration.
                        //
                        number$1(bytes, value.$changes.refId);
                    }
                    if (useFilters) // cache begin / end index
                    changeTree.cache(fieldIndex, bytes.slice(beginIndex));
                }
                if (!encodeAll && !useFilters) changeTree.discard();
            }
            return bytes;
        };
        Schema.prototype.encodeAll = function(useFilters) {
            return this.encode(true, [], useFilters);
        };
        Schema.prototype.applyFilters = function(client, encodeAll) {
            var _a, _b;
            if (encodeAll === void 0) encodeAll = false;
            var root = this;
            var refIdsDissallowed = new Set();
            var $filterState = ClientState.get(client);
            var changeTrees = [
                this.$changes
            ];
            var numChangeTrees = 1;
            var filteredBytes = [];
            var _loop_1 = function(i) {
                var changeTree = changeTrees[i];
                if (refIdsDissallowed.has(changeTree.refId)) return "continue";
                var ref = changeTree.ref;
                var isSchema = ref instanceof Schema;
                uint8$1(filteredBytes, SWITCH_TO_STRUCTURE);
                number$1(filteredBytes, changeTree.refId);
                var clientHasRefId = $filterState.refIds.has(changeTree);
                var isEncodeAll = encodeAll || !clientHasRefId;
                // console.log("REF:", ref.constructor.name);
                // console.log("Encode all?", isEncodeAll);
                //
                // include `changeTree` on list of known refIds by this client.
                //
                $filterState.addRefId(changeTree);
                var containerIndexes = $filterState.containerIndexes.get(changeTree);
                var changes = isEncodeAll ? Array.from(changeTree.allChanges) : Array.from(changeTree.changes.values());
                //
                // WORKAROUND: tries to re-evaluate previously not included @filter() attributes
                // - see "DELETE a field of Schema" test case.
                //
                if (!encodeAll && isSchema && ref._definition.indexesWithFilters) {
                    var indexesWithFilters = ref._definition.indexesWithFilters;
                    indexesWithFilters.forEach(function(indexWithFilter) {
                        if (!containerIndexes.has(indexWithFilter) && changeTree.allChanges.has(indexWithFilter)) {
                            if (isEncodeAll) changes.push(indexWithFilter);
                            else changes.push({
                                op: exports1.OPERATION.ADD,
                                index: indexWithFilter
                            });
                        }
                    });
                }
                for(var j = 0, cl = changes.length; j < cl; j++){
                    var change = isEncodeAll ? {
                        op: exports1.OPERATION.ADD,
                        index: changes[j]
                    } : changes[j];
                    // custom operations
                    if (change.op === exports1.OPERATION.CLEAR) {
                        uint8$1(filteredBytes, change.op);
                        continue;
                    }
                    var fieldIndex = change.index;
                    //
                    // Deleting fields: encode the operation + field index
                    //
                    if (change.op === exports1.OPERATION.DELETE) {
                        //
                        // DELETE operations also need to go through filtering.
                        //
                        // TODO: cache the previous value so we can access the value (primitive or `refId`)
                        // (check against `$filterState.refIds`)
                        //
                        if (isSchema) uint8$1(filteredBytes, change.op | fieldIndex);
                        else {
                            uint8$1(filteredBytes, change.op);
                            number$1(filteredBytes, fieldIndex);
                        }
                        continue;
                    }
                    // indexed operation
                    var value = changeTree.getValue(fieldIndex);
                    var type = changeTree.getType(fieldIndex);
                    if (isSchema) {
                        // Is a Schema!
                        var filter = ref._definition.filters && ref._definition.filters[fieldIndex];
                        if (filter && !filter.call(ref, client, value, root)) {
                            if (value && value["$changes"]) refIdsDissallowed.add(value["$changes"].refId);
                            continue;
                        }
                    } else {
                        // Is a collection! (map, array, etc.)
                        var parent = changeTree.parent;
                        var filter = changeTree.getChildrenFilter();
                        if (filter && !filter.call(parent, client, ref["$indexes"].get(fieldIndex), value, root)) {
                            if (value && value["$changes"]) refIdsDissallowed.add(value["$changes"].refId);
                            continue;
                        }
                    }
                    // visit child ChangeTree on further iteration.
                    if (value["$changes"]) {
                        changeTrees.push(value["$changes"]);
                        numChangeTrees++;
                    }
                    //
                    // Copy cached bytes
                    //
                    if (change.op !== exports1.OPERATION.TOUCH) {
                        //
                        // TODO: refactor me!
                        //
                        if (change.op === exports1.OPERATION.ADD || isSchema) {
                            //
                            // use cached bytes directly if is from Schema type.
                            //
                            filteredBytes.push.apply(filteredBytes, (_a = changeTree.caches[fieldIndex]) !== null && _a !== void 0 ? _a : []);
                            containerIndexes.add(fieldIndex);
                        } else if (containerIndexes.has(fieldIndex)) //
                        // use cached bytes if already has the field
                        //
                        filteredBytes.push.apply(filteredBytes, (_b = changeTree.caches[fieldIndex]) !== null && _b !== void 0 ? _b : []);
                        else {
                            //
                            // force ADD operation if field is not known by this client.
                            //
                            containerIndexes.add(fieldIndex);
                            uint8$1(filteredBytes, exports1.OPERATION.ADD);
                            number$1(filteredBytes, fieldIndex);
                            if (ref instanceof MapSchema) {
                                //
                                // MapSchema dynamic key
                                //
                                var dynamicIndex = changeTree.ref["$indexes"].get(fieldIndex);
                                string$1(filteredBytes, dynamicIndex);
                            }
                            if (value["$changes"]) number$1(filteredBytes, value["$changes"].refId);
                            else // "encodePrimitiveType" without type checking.
                            // the type checking has been done on the first .encode() call.
                            encode[type](filteredBytes, value);
                        }
                    } else if (value["$changes"] && !isSchema) {
                        //
                        // TODO:
                        // - track ADD/REPLACE/DELETE instances on `$filterState`
                        // - do NOT always encode dynamicIndex for MapSchema.
                        //   (If client already has that key, only the first index is necessary.)
                        //
                        uint8$1(filteredBytes, exports1.OPERATION.ADD);
                        number$1(filteredBytes, fieldIndex);
                        if (ref instanceof MapSchema) {
                            //
                            // MapSchema dynamic key
                            //
                            var dynamicIndex = changeTree.ref["$indexes"].get(fieldIndex);
                            string$1(filteredBytes, dynamicIndex);
                        }
                        number$1(filteredBytes, value["$changes"].refId);
                    }
                }
            };
            for(var i = 0; i < numChangeTrees; i++)_loop_1(i);
            return filteredBytes;
        };
        Schema.prototype.clone = function() {
            var _a;
            var cloned = new this.constructor;
            var schema = this._definition.schema;
            for(var field in schema)if (typeof this[field] === "object" && typeof ((_a = this[field]) === null || _a === void 0 ? void 0 : _a.clone) === "function") // deep clone
            cloned[field] = this[field].clone();
            else // primitive values
            cloned[field] = this[field];
            return cloned;
        };
        Schema.prototype.toJSON = function() {
            var schema = this._definition.schema;
            var deprecated = this._definition.deprecated;
            var obj = {};
            for(var field in schema)if (!deprecated[field] && this[field] !== null && typeof this[field] !== "undefined") obj[field] = typeof this[field]["toJSON"] === "function" ? this[field]["toJSON"]() : this["_".concat(field)];
            return obj;
        };
        Schema.prototype.discardAllChanges = function() {
            this.$changes.discardAll();
        };
        Schema.prototype.getByIndex = function(index) {
            return this[this._definition.fieldsByIndex[index]];
        };
        Schema.prototype.deleteByIndex = function(index) {
            this[this._definition.fieldsByIndex[index]] = undefined;
        };
        Schema.prototype.tryEncodeTypeId = function(bytes, type, targetType) {
            if (type._typeid !== targetType._typeid) {
                uint8$1(bytes, TYPE_ID);
                number$1(bytes, targetType._typeid);
            }
        };
        Schema.prototype.getSchemaType = function(bytes, it, defaultType) {
            var type;
            if (bytes[it.offset] === TYPE_ID) {
                it.offset++;
                type = this.constructor._context.get(number(bytes, it));
            }
            return type || defaultType;
        };
        Schema.prototype.createTypeInstance = function(type) {
            var instance = new type();
            // assign root on $changes
            instance.$changes.root = this.$changes.root;
            return instance;
        };
        Schema.prototype._triggerChanges = function(changes) {
            var _a, _b, _c, _d, _e, _f, _g, _h, _j;
            var uniqueRefIds = new Set();
            var $refs = this.$changes.root.refs;
            var _loop_2 = function(i) {
                var change = changes[i];
                var refId = change.refId;
                var ref = $refs.get(refId);
                var $callbacks = ref["$callbacks"];
                //
                // trigger onRemove on child structure.
                //
                if ((change.op & exports1.OPERATION.DELETE) === exports1.OPERATION.DELETE && change.previousValue instanceof Schema) (_b = (_a = change.previousValue["$callbacks"]) === null || _a === void 0 ? void 0 : _a[exports1.OPERATION.DELETE]) === null || _b === void 0 || _b.forEach(function(callback) {
                    return callback();
                });
                // no callbacks defined, skip this structure!
                if (!$callbacks) return "continue";
                if (ref instanceof Schema) {
                    if (!uniqueRefIds.has(refId)) try {
                        // trigger onChange
                        (_c = $callbacks === null || $callbacks === void 0 ? void 0 : $callbacks[exports1.OPERATION.REPLACE]) === null || _c === void 0 || _c.forEach(function(callback) {
                            return callback();
                        });
                    } catch (e) {
                        Schema.onError(e);
                    }
                    try {
                        if ($callbacks.hasOwnProperty(change.field)) (_d = $callbacks[change.field]) === null || _d === void 0 || _d.forEach(function(callback) {
                            return callback(change.value, change.previousValue);
                        });
                    } catch (e) {
                        Schema.onError(e);
                    }
                } else {
                    // is a collection of items
                    if (change.op === exports1.OPERATION.ADD && change.previousValue === undefined) // triger onAdd
                    (_e = $callbacks[exports1.OPERATION.ADD]) === null || _e === void 0 || _e.forEach(function(callback) {
                        var _a;
                        return callback(change.value, (_a = change.dynamicIndex) !== null && _a !== void 0 ? _a : change.field);
                    });
                    else if (change.op === exports1.OPERATION.DELETE) //
                    // FIXME: `previousValue` should always be available.
                    // ADD + DELETE operations are still encoding DELETE operation.
                    //
                    {
                        if (change.previousValue !== undefined) // triger onRemove
                        (_f = $callbacks[exports1.OPERATION.DELETE]) === null || _f === void 0 || _f.forEach(function(callback) {
                            var _a;
                            return callback(change.previousValue, (_a = change.dynamicIndex) !== null && _a !== void 0 ? _a : change.field);
                        });
                    } else if (change.op === exports1.OPERATION.DELETE_AND_ADD) {
                        // triger onRemove
                        if (change.previousValue !== undefined) (_g = $callbacks[exports1.OPERATION.DELETE]) === null || _g === void 0 || _g.forEach(function(callback) {
                            var _a;
                            return callback(change.previousValue, (_a = change.dynamicIndex) !== null && _a !== void 0 ? _a : change.field);
                        });
                        // triger onAdd
                        (_h = $callbacks[exports1.OPERATION.ADD]) === null || _h === void 0 || _h.forEach(function(callback) {
                            var _a;
                            return callback(change.value, (_a = change.dynamicIndex) !== null && _a !== void 0 ? _a : change.field);
                        });
                    }
                    // trigger onChange
                    if (change.value !== change.previousValue) (_j = $callbacks[exports1.OPERATION.REPLACE]) === null || _j === void 0 || _j.forEach(function(callback) {
                        var _a;
                        return callback(change.value, (_a = change.dynamicIndex) !== null && _a !== void 0 ? _a : change.field);
                    });
                }
                uniqueRefIds.add(refId);
            };
            for(var i = 0; i < changes.length; i++)_loop_2(i);
        };
        Schema._definition = SchemaDefinition.create();
        return Schema;
    }();
    function dumpChanges(schema) {
        var changeTrees = [
            schema["$changes"]
        ];
        var numChangeTrees = 1;
        var dump = {};
        var currentStructure = dump;
        var _loop_1 = function(i) {
            var changeTree = changeTrees[i];
            changeTree.changes.forEach(function(change) {
                var ref = changeTree.ref;
                var fieldIndex = change.index;
                var field = ref["_definition"] ? ref["_definition"].fieldsByIndex[fieldIndex] : ref["$indexes"].get(fieldIndex);
                currentStructure[field] = changeTree.getValue(fieldIndex);
            });
        };
        for(var i = 0; i < numChangeTrees; i++)_loop_1(i);
        return dump;
    }
    var reflectionContext = {
        context: new Context()
    };
    /**
     * Reflection
     */ var ReflectionField = /** @class */ function(_super) {
        __extends(ReflectionField, _super);
        function ReflectionField() {
            return _super !== null && _super.apply(this, arguments) || this;
        }
        __decorate([
            type("string", reflectionContext)
        ], ReflectionField.prototype, "name", void 0);
        __decorate([
            type("string", reflectionContext)
        ], ReflectionField.prototype, "type", void 0);
        __decorate([
            type("number", reflectionContext)
        ], ReflectionField.prototype, "referencedType", void 0);
        return ReflectionField;
    }(Schema);
    var ReflectionType = /** @class */ function(_super) {
        __extends(ReflectionType, _super);
        function ReflectionType() {
            var _this = _super !== null && _super.apply(this, arguments) || this;
            _this.fields = new ArraySchema();
            return _this;
        }
        __decorate([
            type("number", reflectionContext)
        ], ReflectionType.prototype, "id", void 0);
        __decorate([
            type([
                ReflectionField
            ], reflectionContext)
        ], ReflectionType.prototype, "fields", void 0);
        return ReflectionType;
    }(Schema);
    var Reflection = /** @class */ function(_super) {
        __extends(Reflection, _super);
        function Reflection() {
            var _this = _super !== null && _super.apply(this, arguments) || this;
            _this.types = new ArraySchema();
            return _this;
        }
        Reflection.encode = function(instance) {
            var rootSchemaType = instance.constructor;
            var reflection = new Reflection();
            reflection.rootType = rootSchemaType._typeid;
            var buildType = function(currentType, schema) {
                for(var fieldName in schema){
                    var field = new ReflectionField();
                    field.name = fieldName;
                    var fieldType = void 0;
                    if (typeof schema[fieldName] === "string") fieldType = schema[fieldName];
                    else {
                        var type_1 = schema[fieldName];
                        var childTypeSchema = void 0;
                        //
                        // TODO: refactor below.
                        //
                        if (Schema.is(type_1)) {
                            fieldType = "ref";
                            childTypeSchema = schema[fieldName];
                        } else {
                            fieldType = Object.keys(type_1)[0];
                            if (typeof type_1[fieldType] === "string") fieldType += ":" + type_1[fieldType]; // array:string
                            else childTypeSchema = type_1[fieldType];
                        }
                        field.referencedType = childTypeSchema ? childTypeSchema._typeid : -1;
                    }
                    field.type = fieldType;
                    currentType.fields.push(field);
                }
                reflection.types.push(currentType);
            };
            var types = rootSchemaType._context.types;
            for(var typeid in types){
                var type_2 = new ReflectionType();
                type_2.id = Number(typeid);
                buildType(type_2, types[typeid]._definition.schema);
            }
            return reflection.encodeAll();
        };
        Reflection.decode = function(bytes, it) {
            var context = new Context();
            var reflection = new Reflection();
            reflection.decode(bytes, it);
            var schemaTypes = reflection.types.reduce(function(types, reflectionType) {
                var schema = /** @class */ function(_super) {
                    __extends(_, _super);
                    function _() {
                        return _super !== null && _super.apply(this, arguments) || this;
                    }
                    return _;
                }(Schema);
                var typeid = reflectionType.id;
                types[typeid] = schema;
                context.add(schema, typeid);
                return types;
            }, {});
            reflection.types.forEach(function(reflectionType) {
                var schemaType = schemaTypes[reflectionType.id];
                reflectionType.fields.forEach(function(field) {
                    var _a;
                    if (field.referencedType !== undefined) {
                        var fieldType = field.type;
                        var refType = schemaTypes[field.referencedType];
                        // map or array of primitive type (-1)
                        if (!refType) {
                            var typeInfo = field.type.split(":");
                            fieldType = typeInfo[0];
                            refType = typeInfo[1];
                        }
                        if (fieldType === "ref") type(refType, {
                            context: context
                        })(schemaType.prototype, field.name);
                        else type((_a = {}, _a[fieldType] = refType, _a), {
                            context: context
                        })(schemaType.prototype, field.name);
                    } else type(field.type, {
                        context: context
                    })(schemaType.prototype, field.name);
                });
            });
            var rootType = schemaTypes[reflection.rootType];
            var rootInstance = new rootType();
            /**
             * auto-initialize referenced types on root type
             * to allow registering listeners immediatelly on client-side
             */ for(var fieldName in rootType._definition.schema){
                var fieldType = rootType._definition.schema[fieldName];
                if (typeof fieldType !== "string") rootInstance[fieldName] = typeof fieldType === "function" ? new fieldType() // is a schema reference
                 : new (getType(Object.keys(fieldType)[0])).constructor(); // is a "collection"
            }
            return rootInstance;
        };
        __decorate([
            type([
                ReflectionType
            ], reflectionContext)
        ], Reflection.prototype, "types", void 0);
        __decorate([
            type("number", reflectionContext)
        ], Reflection.prototype, "rootType", void 0);
        return Reflection;
    }(Schema);
    registerType("map", {
        constructor: MapSchema
    });
    registerType("array", {
        constructor: ArraySchema
    });
    registerType("set", {
        constructor: SetSchema
    });
    registerType("collection", {
        constructor: CollectionSchema
    });
    exports1.ArraySchema = ArraySchema;
    exports1.CollectionSchema = CollectionSchema;
    exports1.Context = Context;
    exports1.MapSchema = MapSchema;
    exports1.Reflection = Reflection;
    exports1.ReflectionField = ReflectionField;
    exports1.ReflectionType = ReflectionType;
    exports1.Schema = Schema;
    exports1.SchemaDefinition = SchemaDefinition;
    exports1.SetSchema = SetSchema;
    exports1.decode = decode;
    exports1.defineTypes = defineTypes;
    exports1.deprecated = deprecated;
    exports1.dumpChanges = dumpChanges;
    exports1.encode = encode;
    exports1.filter = filter;
    exports1.filterChildren = filterChildren;
    exports1.hasFilter = hasFilter;
    exports1.registerType = registerType;
    exports1.type = type;
    Object.defineProperty(exports1, "__esModule", {
        value: true
    });
});


// 
// THIS FILE HAS BEEN GENERATED AUTOMATICALLY
// DO NOT CHANGE IT MANUALLY UNLESS YOU KNOW WHAT YOU'RE DOING
// 
// GENERATED USING @colyseus/schema 2.0.19
// 


// 
// THIS FILE HAS BEEN GENERATED AUTOMATICALLY
// DO NOT CHANGE IT MANUALLY UNLESS YOU KNOW WHAT YOU'RE DOING
// 
// GENERATED USING @colyseus/schema 2.0.19
// 


class $c0f4c58287bd5e83$export$8ef94d40d2a0bc9e extends (0, $13e0994b5a5d999e$exports.Schema) {
}
(0, $5c96a02c592fcff1$export$29e00dfd3077644b)([
    (0, $13e0994b5a5d999e$exports.type)("number")
], $c0f4c58287bd5e83$export$8ef94d40d2a0bc9e.prototype, "x", void 0);
(0, $5c96a02c592fcff1$export$29e00dfd3077644b)([
    (0, $13e0994b5a5d999e$exports.type)("number")
], $c0f4c58287bd5e83$export$8ef94d40d2a0bc9e.prototype, "y", void 0);
(0, $5c96a02c592fcff1$export$29e00dfd3077644b)([
    (0, $13e0994b5a5d999e$exports.type)("number")
], $c0f4c58287bd5e83$export$8ef94d40d2a0bc9e.prototype, "width", void 0);
(0, $5c96a02c592fcff1$export$29e00dfd3077644b)([
    (0, $13e0994b5a5d999e$exports.type)("number")
], $c0f4c58287bd5e83$export$8ef94d40d2a0bc9e.prototype, "height", void 0);


class $4a77ed809e0e4791$export$c45a5b7b29ed29eb extends (0, $c0f4c58287bd5e83$export$8ef94d40d2a0bc9e) {
}
(0, $5c96a02c592fcff1$export$29e00dfd3077644b)([
    (0, $13e0994b5a5d999e$exports.type)("number")
], $4a77ed809e0e4791$export$c45a5b7b29ed29eb.prototype, "dx", void 0);
(0, $5c96a02c592fcff1$export$29e00dfd3077644b)([
    (0, $13e0994b5a5d999e$exports.type)("number")
], $4a77ed809e0e4791$export$c45a5b7b29ed29eb.prototype, "dy", void 0);
(0, $5c96a02c592fcff1$export$29e00dfd3077644b)([
    (0, $13e0994b5a5d999e$exports.type)("number")
], $4a77ed809e0e4791$export$c45a5b7b29ed29eb.prototype, "speed", void 0);
(0, $5c96a02c592fcff1$export$29e00dfd3077644b)([
    (0, $13e0994b5a5d999e$exports.type)("number")
], $4a77ed809e0e4791$export$c45a5b7b29ed29eb.prototype, "maxSpeed", void 0);
(0, $5c96a02c592fcff1$export$29e00dfd3077644b)([
    (0, $13e0994b5a5d999e$exports.type)("number")
], $4a77ed809e0e4791$export$c45a5b7b29ed29eb.prototype, "boundingX", void 0);
(0, $5c96a02c592fcff1$export$29e00dfd3077644b)([
    (0, $13e0994b5a5d999e$exports.type)("number")
], $4a77ed809e0e4791$export$c45a5b7b29ed29eb.prototype, "boundingY", void 0);
(0, $5c96a02c592fcff1$export$29e00dfd3077644b)([
    (0, $13e0994b5a5d999e$exports.type)("number")
], $4a77ed809e0e4791$export$c45a5b7b29ed29eb.prototype, "boundingWidth", void 0);
(0, $5c96a02c592fcff1$export$29e00dfd3077644b)([
    (0, $13e0994b5a5d999e$exports.type)("number")
], $4a77ed809e0e4791$export$c45a5b7b29ed29eb.prototype, "boundingHeight", void 0);
(0, $5c96a02c592fcff1$export$29e00dfd3077644b)([
    (0, $13e0994b5a5d999e$exports.type)("string")
], $4a77ed809e0e4791$export$c45a5b7b29ed29eb.prototype, "orientation", void 0);


class $7d2bffd74934cb86$export$f41e045a2ffd16fc extends (0, $4a77ed809e0e4791$export$c45a5b7b29ed29eb) {
}
(0, $5c96a02c592fcff1$export$29e00dfd3077644b)([
    (0, $13e0994b5a5d999e$exports.type)("string")
], $7d2bffd74934cb86$export$f41e045a2ffd16fc.prototype, "uid", void 0);
(0, $5c96a02c592fcff1$export$29e00dfd3077644b)([
    (0, $13e0994b5a5d999e$exports.type)("string")
], $7d2bffd74934cb86$export$f41e045a2ffd16fc.prototype, "type", void 0);
(0, $5c96a02c592fcff1$export$29e00dfd3077644b)([
    (0, $13e0994b5a5d999e$exports.type)("number")
], $7d2bffd74934cb86$export$f41e045a2ffd16fc.prototype, "maxWaves", void 0);
(0, $5c96a02c592fcff1$export$29e00dfd3077644b)([
    (0, $13e0994b5a5d999e$exports.type)("number")
], $7d2bffd74934cb86$export$f41e045a2ffd16fc.prototype, "waveCooldown", void 0);
(0, $5c96a02c592fcff1$export$29e00dfd3077644b)([
    (0, $13e0994b5a5d999e$exports.type)("number")
], $7d2bffd74934cb86$export$f41e045a2ffd16fc.prototype, "damages", void 0);
(0, $5c96a02c592fcff1$export$29e00dfd3077644b)([
    (0, $13e0994b5a5d999e$exports.type)("string")
], $7d2bffd74934cb86$export$f41e045a2ffd16fc.prototype, "fromPlayerId", void 0);
(0, $5c96a02c592fcff1$export$29e00dfd3077644b)([
    (0, $13e0994b5a5d999e$exports.type)("number")
], $7d2bffd74934cb86$export$f41e045a2ffd16fc.prototype, "waveCount", void 0);


// 
// THIS FILE HAS BEEN GENERATED AUTOMATICALLY
// DO NOT CHANGE IT MANUALLY UNLESS YOU KNOW WHAT YOU'RE DOING
// 
// GENERATED USING @colyseus/schema 2.0.19
// 


class $9eaefd8c2eae9266$export$8504d03717147918 extends (0, $13e0994b5a5d999e$exports.Schema) {
}
(0, $5c96a02c592fcff1$export$29e00dfd3077644b)([
    (0, $13e0994b5a5d999e$exports.type)("number")
], $9eaefd8c2eae9266$export$8504d03717147918.prototype, "endingAt", void 0);


// 
// THIS FILE HAS BEEN GENERATED AUTOMATICALLY
// DO NOT CHANGE IT MANUALLY UNLESS YOU KNOW WHAT YOU'RE DOING
// 
// GENERATED USING @colyseus/schema 2.0.19
// 



class $511ae202db6a2396$export$dd435bce62c7b354 extends (0, $4a77ed809e0e4791$export$c45a5b7b29ed29eb) {
}
(0, $5c96a02c592fcff1$export$29e00dfd3077644b)([
    (0, $13e0994b5a5d999e$exports.type)("string")
], $511ae202db6a2396$export$dd435bce62c7b354.prototype, "uid", void 0);
(0, $5c96a02c592fcff1$export$29e00dfd3077644b)([
    (0, $13e0994b5a5d999e$exports.type)("number")
], $511ae202db6a2396$export$dd435bce62c7b354.prototype, "ttl", void 0);
(0, $5c96a02c592fcff1$export$29e00dfd3077644b)([
    (0, $13e0994b5a5d999e$exports.type)("string")
], $511ae202db6a2396$export$dd435bce62c7b354.prototype, "type", void 0);
(0, $5c96a02c592fcff1$export$29e00dfd3077644b)([
    (0, $13e0994b5a5d999e$exports.type)("number")
], $511ae202db6a2396$export$dd435bce62c7b354.prototype, "damages", void 0);
(0, $5c96a02c592fcff1$export$29e00dfd3077644b)([
    (0, $13e0994b5a5d999e$exports.type)("string")
], $511ae202db6a2396$export$dd435bce62c7b354.prototype, "fromPlayerId", void 0);
(0, $5c96a02c592fcff1$export$29e00dfd3077644b)([
    (0, $13e0994b5a5d999e$exports.type)("boolean")
], $511ae202db6a2396$export$dd435bce62c7b354.prototype, "ellipticMovement", void 0);


// 
// THIS FILE HAS BEEN GENERATED AUTOMATICALLY
// DO NOT CHANGE IT MANUALLY UNLESS YOU KNOW WHAT YOU'RE DOING
// 
// GENERATED USING @colyseus/schema 2.0.19
// 


// 
// THIS FILE HAS BEEN GENERATED AUTOMATICALLY
// DO NOT CHANGE IT MANUALLY UNLESS YOU KNOW WHAT YOU'RE DOING
// 
// GENERATED USING @colyseus/schema 2.0.19
// 




// 
// THIS FILE HAS BEEN GENERATED AUTOMATICALLY
// DO NOT CHANGE IT MANUALLY UNLESS YOU KNOW WHAT YOU'RE DOING
// 
// GENERATED USING @colyseus/schema 2.0.19
// 



class $89173f80491cfbc3$export$6bc78928f83db8f6 extends (0, $4a77ed809e0e4791$export$c45a5b7b29ed29eb) {
}
(0, $5c96a02c592fcff1$export$29e00dfd3077644b)([
    (0, $13e0994b5a5d999e$exports.type)("string")
], $89173f80491cfbc3$export$6bc78928f83db8f6.prototype, "uid", void 0);
(0, $5c96a02c592fcff1$export$29e00dfd3077644b)([
    (0, $13e0994b5a5d999e$exports.type)("string")
], $89173f80491cfbc3$export$6bc78928f83db8f6.prototype, "type", void 0);
(0, $5c96a02c592fcff1$export$29e00dfd3077644b)([
    (0, $13e0994b5a5d999e$exports.type)("string")
], $89173f80491cfbc3$export$6bc78928f83db8f6.prototype, "visibleForClientId", void 0);


// 
// THIS FILE HAS BEEN GENERATED AUTOMATICALLY
// DO NOT CHANGE IT MANUALLY UNLESS YOU KNOW WHAT YOU'RE DOING
// 
// GENERATED USING @colyseus/schema 2.0.19
// 


// 
// THIS FILE HAS BEEN GENERATED AUTOMATICALLY
// DO NOT CHANGE IT MANUALLY UNLESS YOU KNOW WHAT YOU'RE DOING
// 
// GENERATED USING @colyseus/schema 2.0.19
// 



class $f85dbbe1f389643e$export$7e4fc67cbd2e1f45 extends (0, $4a77ed809e0e4791$export$c45a5b7b29ed29eb) {
}
(0, $5c96a02c592fcff1$export$29e00dfd3077644b)([
    (0, $13e0994b5a5d999e$exports.type)("number")
], $f85dbbe1f389643e$export$7e4fc67cbd2e1f45.prototype, "life", void 0);
(0, $5c96a02c592fcff1$export$29e00dfd3077644b)([
    (0, $13e0994b5a5d999e$exports.type)("number")
], $f85dbbe1f389643e$export$7e4fc67cbd2e1f45.prototype, "maxLife", void 0);


class $3d929d8eb842425e$export$c22bc1fa4d3382fb extends (0, $f85dbbe1f389643e$export$7e4fc67cbd2e1f45) {
}
(0, $5c96a02c592fcff1$export$29e00dfd3077644b)([
    (0, $13e0994b5a5d999e$exports.type)("string")
], $3d929d8eb842425e$export$c22bc1fa4d3382fb.prototype, "uid", void 0);
(0, $5c96a02c592fcff1$export$29e00dfd3077644b)([
    (0, $13e0994b5a5d999e$exports.type)("string")
], $3d929d8eb842425e$export$c22bc1fa4d3382fb.prototype, "type", void 0);
(0, $5c96a02c592fcff1$export$29e00dfd3077644b)([
    (0, $13e0994b5a5d999e$exports.type)("boolean")
], $3d929d8eb842425e$export$c22bc1fa4d3382fb.prototype, "isElite", void 0);
(0, $5c96a02c592fcff1$export$29e00dfd3077644b)([
    (0, $13e0994b5a5d999e$exports.type)("boolean")
], $3d929d8eb842425e$export$c22bc1fa4d3382fb.prototype, "isBoss", void 0);


class $9712dadca0a2c97a$export$cb22b56f9c9add70 extends (0, $13e0994b5a5d999e$exports.Schema) {
    constructor(...args){
        super(...args);
        this.items = new (0, $13e0994b5a5d999e$exports.MapSchema)();
        this.bullets = new (0, $13e0994b5a5d999e$exports.MapSchema)();
        this.monsters = new (0, $13e0994b5a5d999e$exports.MapSchema)();
        this.aoe = new (0, $13e0994b5a5d999e$exports.MapSchema)();
    }
}
(0, $5c96a02c592fcff1$export$29e00dfd3077644b)([
    (0, $13e0994b5a5d999e$exports.type)({
        map: (0, $89173f80491cfbc3$export$6bc78928f83db8f6)
    })
], $9712dadca0a2c97a$export$cb22b56f9c9add70.prototype, "items", void 0);
(0, $5c96a02c592fcff1$export$29e00dfd3077644b)([
    (0, $13e0994b5a5d999e$exports.type)({
        map: (0, $511ae202db6a2396$export$dd435bce62c7b354)
    })
], $9712dadca0a2c97a$export$cb22b56f9c9add70.prototype, "bullets", void 0);
(0, $5c96a02c592fcff1$export$29e00dfd3077644b)([
    (0, $13e0994b5a5d999e$exports.type)({
        map: (0, $3d929d8eb842425e$export$c22bc1fa4d3382fb)
    })
], $9712dadca0a2c97a$export$cb22b56f9c9add70.prototype, "monsters", void 0);
(0, $5c96a02c592fcff1$export$29e00dfd3077644b)([
    (0, $13e0994b5a5d999e$exports.type)({
        map: (0, $7d2bffd74934cb86$export$f41e045a2ffd16fc)
    })
], $9712dadca0a2c97a$export$cb22b56f9c9add70.prototype, "aoe", void 0);
(0, $5c96a02c592fcff1$export$29e00dfd3077644b)([
    (0, $13e0994b5a5d999e$exports.type)("boolean")
], $9712dadca0a2c97a$export$cb22b56f9c9add70.prototype, "canMove", void 0);
(0, $5c96a02c592fcff1$export$29e00dfd3077644b)([
    (0, $13e0994b5a5d999e$exports.type)("number")
], $9712dadca0a2c97a$export$cb22b56f9c9add70.prototype, "worldSize", void 0);
(0, $5c96a02c592fcff1$export$29e00dfd3077644b)([
    (0, $13e0994b5a5d999e$exports.type)("string")
], $9712dadca0a2c97a$export$cb22b56f9c9add70.prototype, "background", void 0);


// 
// THIS FILE HAS BEEN GENERATED AUTOMATICALLY
// DO NOT CHANGE IT MANUALLY UNLESS YOU KNOW WHAT YOU'RE DOING
// 
// GENERATED USING @colyseus/schema 2.0.19
// 



// 
// THIS FILE HAS BEEN GENERATED AUTOMATICALLY
// DO NOT CHANGE IT MANUALLY UNLESS YOU KNOW WHAT YOU'RE DOING
// 
// GENERATED USING @colyseus/schema 2.0.19
// 


class $c0450198aeb483d6$export$d2250882ce2076b2 extends (0, $13e0994b5a5d999e$exports.Schema) {
}
(0, $5c96a02c592fcff1$export$29e00dfd3077644b)([
    (0, $13e0994b5a5d999e$exports.type)("string")
], $c0450198aeb483d6$export$d2250882ce2076b2.prototype, "eyes", void 0);
(0, $5c96a02c592fcff1$export$29e00dfd3077644b)([
    (0, $13e0994b5a5d999e$exports.type)("string")
], $c0450198aeb483d6$export$d2250882ce2076b2.prototype, "fur", void 0);
(0, $5c96a02c592fcff1$export$29e00dfd3077644b)([
    (0, $13e0994b5a5d999e$exports.type)("string")
], $c0450198aeb483d6$export$d2250882ce2076b2.prototype, "head", void 0);
(0, $5c96a02c592fcff1$export$29e00dfd3077644b)([
    (0, $13e0994b5a5d999e$exports.type)("string")
], $c0450198aeb483d6$export$d2250882ce2076b2.prototype, "top", void 0);
(0, $5c96a02c592fcff1$export$29e00dfd3077644b)([
    (0, $13e0994b5a5d999e$exports.type)("string")
], $c0450198aeb483d6$export$d2250882ce2076b2.prototype, "mouth", void 0);
(0, $5c96a02c592fcff1$export$29e00dfd3077644b)([
    (0, $13e0994b5a5d999e$exports.type)("string")
], $c0450198aeb483d6$export$d2250882ce2076b2.prototype, "outfits", void 0);



// 
// THIS FILE HAS BEEN GENERATED AUTOMATICALLY
// DO NOT CHANGE IT MANUALLY UNLESS YOU KNOW WHAT YOU'RE DOING
// 
// GENERATED USING @colyseus/schema 2.0.19
// 



class $19ddb5c8fb6828f4$export$7d0e45375cbc5649 extends (0, $4a77ed809e0e4791$export$c45a5b7b29ed29eb) {
}
(0, $5c96a02c592fcff1$export$29e00dfd3077644b)([
    (0, $13e0994b5a5d999e$exports.type)("number")
], $19ddb5c8fb6828f4$export$7d0e45375cbc5649.prototype, "level", void 0);


// 
// THIS FILE HAS BEEN GENERATED AUTOMATICALLY
// DO NOT CHANGE IT MANUALLY UNLESS YOU KNOW WHAT YOU'RE DOING
// 
// GENERATED USING @colyseus/schema 2.0.19
// 


class $11eec046138a1763$export$b93e99e706aeadf extends (0, $13e0994b5a5d999e$exports.Schema) {
}
(0, $5c96a02c592fcff1$export$29e00dfd3077644b)([
    (0, $13e0994b5a5d999e$exports.type)("number")
], $11eec046138a1763$export$b93e99e706aeadf.prototype, "damagePerBullet", void 0);
(0, $5c96a02c592fcff1$export$29e00dfd3077644b)([
    (0, $13e0994b5a5d999e$exports.type)("number")
], $11eec046138a1763$export$b93e99e706aeadf.prototype, "bulletLifetime", void 0);
(0, $5c96a02c592fcff1$export$29e00dfd3077644b)([
    (0, $13e0994b5a5d999e$exports.type)("number")
], $11eec046138a1763$export$b93e99e706aeadf.prototype, "bulletSpeed", void 0);
(0, $5c96a02c592fcff1$export$29e00dfd3077644b)([
    (0, $13e0994b5a5d999e$exports.type)("number")
], $11eec046138a1763$export$b93e99e706aeadf.prototype, "shootingCooldown", void 0);
(0, $5c96a02c592fcff1$export$29e00dfd3077644b)([
    (0, $13e0994b5a5d999e$exports.type)("number")
], $11eec046138a1763$export$b93e99e706aeadf.prototype, "cooldown", void 0);
(0, $5c96a02c592fcff1$export$29e00dfd3077644b)([
    (0, $13e0994b5a5d999e$exports.type)("number")
], $11eec046138a1763$export$b93e99e706aeadf.prototype, "bullets", void 0);
(0, $5c96a02c592fcff1$export$29e00dfd3077644b)([
    (0, $13e0994b5a5d999e$exports.type)("string")
], $11eec046138a1763$export$b93e99e706aeadf.prototype, "type", void 0);
(0, $5c96a02c592fcff1$export$29e00dfd3077644b)([
    (0, $13e0994b5a5d999e$exports.type)("string")
], $11eec046138a1763$export$b93e99e706aeadf.prototype, "bulletType", void 0);


class $df137488315af06b$export$c1cd02abf10182fa extends (0, $f85dbbe1f389643e$export$7e4fc67cbd2e1f45) {
    constructor(...args){
        super(...args);
        this.chests = new (0, $13e0994b5a5d999e$exports.ArraySchema)();
        this.cosmetics = new (0, $c0450198aeb483d6$export$d2250882ce2076b2)();
        this.weapon = new (0, $11eec046138a1763$export$b93e99e706aeadf)();
        this.auras = new (0, $13e0994b5a5d999e$exports.MapSchema)();
        this.skills = new (0, $13e0994b5a5d999e$exports.MapSchema)();
    }
}
(0, $5c96a02c592fcff1$export$29e00dfd3077644b)([
    (0, $13e0994b5a5d999e$exports.type)("boolean")
], $df137488315af06b$export$c1cd02abf10182fa.prototype, "moving", void 0);
(0, $5c96a02c592fcff1$export$29e00dfd3077644b)([
    (0, $13e0994b5a5d999e$exports.type)("boolean")
], $df137488315af06b$export$c1cd02abf10182fa.prototype, "movingWithRotation", void 0);
(0, $5c96a02c592fcff1$export$29e00dfd3077644b)([
    (0, $13e0994b5a5d999e$exports.type)("number")
], $df137488315af06b$export$c1cd02abf10182fa.prototype, "shootingAngle", void 0);
(0, $5c96a02c592fcff1$export$29e00dfd3077644b)([
    (0, $13e0994b5a5d999e$exports.type)("number")
], $df137488315af06b$export$c1cd02abf10182fa.prototype, "score", void 0);
(0, $5c96a02c592fcff1$export$29e00dfd3077644b)([
    (0, $13e0994b5a5d999e$exports.type)("number")
], $df137488315af06b$export$c1cd02abf10182fa.prototype, "monstersKilled", void 0);
(0, $5c96a02c592fcff1$export$29e00dfd3077644b)([
    (0, $13e0994b5a5d999e$exports.type)("number")
], $df137488315af06b$export$c1cd02abf10182fa.prototype, "gems", void 0);
(0, $5c96a02c592fcff1$export$29e00dfd3077644b)([
    (0, $13e0994b5a5d999e$exports.type)([
        "string"
    ])
], $df137488315af06b$export$c1cd02abf10182fa.prototype, "chests", void 0);
(0, $5c96a02c592fcff1$export$29e00dfd3077644b)([
    (0, $13e0994b5a5d999e$exports.type)("number")
], $df137488315af06b$export$c1cd02abf10182fa.prototype, "usedLives", void 0);
(0, $5c96a02c592fcff1$export$29e00dfd3077644b)([
    (0, $13e0994b5a5d999e$exports.type)("number")
], $df137488315af06b$export$c1cd02abf10182fa.prototype, "attractingRadius", void 0);
(0, $5c96a02c592fcff1$export$29e00dfd3077644b)([
    (0, $13e0994b5a5d999e$exports.type)("number")
], $df137488315af06b$export$c1cd02abf10182fa.prototype, "experience", void 0);
(0, $5c96a02c592fcff1$export$29e00dfd3077644b)([
    (0, $13e0994b5a5d999e$exports.type)("number")
], $df137488315af06b$export$c1cd02abf10182fa.prototype, "nextLevelExperience", void 0);
(0, $5c96a02c592fcff1$export$29e00dfd3077644b)([
    (0, $13e0994b5a5d999e$exports.type)("number")
], $df137488315af06b$export$c1cd02abf10182fa.prototype, "level", void 0);
(0, $5c96a02c592fcff1$export$29e00dfd3077644b)([
    (0, $13e0994b5a5d999e$exports.type)("number")
], $df137488315af06b$export$c1cd02abf10182fa.prototype, "revivedCount", void 0);
(0, $5c96a02c592fcff1$export$29e00dfd3077644b)([
    (0, $13e0994b5a5d999e$exports.type)("boolean")
], $df137488315af06b$export$c1cd02abf10182fa.prototype, "dead", void 0);
(0, $5c96a02c592fcff1$export$29e00dfd3077644b)([
    (0, $13e0994b5a5d999e$exports.type)("boolean")
], $df137488315af06b$export$c1cd02abf10182fa.prototype, "waitingSkillUnlock", void 0);
(0, $5c96a02c592fcff1$export$29e00dfd3077644b)([
    (0, $13e0994b5a5d999e$exports.type)("string")
], $df137488315af06b$export$c1cd02abf10182fa.prototype, "color", void 0);
(0, $5c96a02c592fcff1$export$29e00dfd3077644b)([
    (0, $13e0994b5a5d999e$exports.type)("string")
], $df137488315af06b$export$c1cd02abf10182fa.prototype, "name", void 0);
(0, $5c96a02c592fcff1$export$29e00dfd3077644b)([
    (0, $13e0994b5a5d999e$exports.type)("string")
], $df137488315af06b$export$c1cd02abf10182fa.prototype, "clientId", void 0);
(0, $5c96a02c592fcff1$export$29e00dfd3077644b)([
    (0, $13e0994b5a5d999e$exports.type)("boolean")
], $df137488315af06b$export$c1cd02abf10182fa.prototype, "ready", void 0);
(0, $5c96a02c592fcff1$export$29e00dfd3077644b)([
    (0, $13e0994b5a5d999e$exports.type)("boolean")
], $df137488315af06b$export$c1cd02abf10182fa.prototype, "frozen", void 0);
(0, $5c96a02c592fcff1$export$29e00dfd3077644b)([
    (0, $13e0994b5a5d999e$exports.type)("boolean")
], $df137488315af06b$export$c1cd02abf10182fa.prototype, "connected", void 0);
(0, $5c96a02c592fcff1$export$29e00dfd3077644b)([
    (0, $13e0994b5a5d999e$exports.type)("boolean")
], $df137488315af06b$export$c1cd02abf10182fa.prototype, "host", void 0);
(0, $5c96a02c592fcff1$export$29e00dfd3077644b)([
    (0, $13e0994b5a5d999e$exports.type)((0, $c0450198aeb483d6$export$d2250882ce2076b2))
], $df137488315af06b$export$c1cd02abf10182fa.prototype, "cosmetics", void 0);
(0, $5c96a02c592fcff1$export$29e00dfd3077644b)([
    (0, $13e0994b5a5d999e$exports.type)((0, $11eec046138a1763$export$b93e99e706aeadf))
], $df137488315af06b$export$c1cd02abf10182fa.prototype, "weapon", void 0);
(0, $5c96a02c592fcff1$export$29e00dfd3077644b)([
    (0, $13e0994b5a5d999e$exports.type)({
        map: (0, $9eaefd8c2eae9266$export$8504d03717147918)
    })
], $df137488315af06b$export$c1cd02abf10182fa.prototype, "auras", void 0);
(0, $5c96a02c592fcff1$export$29e00dfd3077644b)([
    (0, $13e0994b5a5d999e$exports.type)({
        map: (0, $19ddb5c8fb6828f4$export$7d0e45375cbc5649)
    })
], $df137488315af06b$export$c1cd02abf10182fa.prototype, "skills", void 0);


class $ba46ecaa51dd6ec0$export$6d8e639cdcf2b060 extends (0, $13e0994b5a5d999e$exports.Schema) {
    constructor(...args){
        super(...args);
        this.level = new (0, $9712dadca0a2c97a$export$cb22b56f9c9add70)();
        this.players = new (0, $13e0994b5a5d999e$exports.MapSchema)();
    }
}
(0, $5c96a02c592fcff1$export$29e00dfd3077644b)([
    (0, $13e0994b5a5d999e$exports.type)((0, $9712dadca0a2c97a$export$cb22b56f9c9add70))
], $ba46ecaa51dd6ec0$export$6d8e639cdcf2b060.prototype, "level", void 0);
(0, $5c96a02c592fcff1$export$29e00dfd3077644b)([
    (0, $13e0994b5a5d999e$exports.type)({
        map: (0, $df137488315af06b$export$c1cd02abf10182fa)
    })
], $ba46ecaa51dd6ec0$export$6d8e639cdcf2b060.prototype, "players", void 0);
(0, $5c96a02c592fcff1$export$29e00dfd3077644b)([
    (0, $13e0994b5a5d999e$exports.type)("boolean")
], $ba46ecaa51dd6ec0$export$6d8e639cdcf2b060.prototype, "started", void 0);
(0, $5c96a02c592fcff1$export$29e00dfd3077644b)([
    (0, $13e0994b5a5d999e$exports.type)("boolean")
], $ba46ecaa51dd6ec0$export$6d8e639cdcf2b060.prototype, "ended", void 0);
(0, $5c96a02c592fcff1$export$29e00dfd3077644b)([
    (0, $13e0994b5a5d999e$exports.type)("boolean")
], $ba46ecaa51dd6ec0$export$6d8e639cdcf2b060.prototype, "won", void 0);
(0, $5c96a02c592fcff1$export$29e00dfd3077644b)([
    (0, $13e0994b5a5d999e$exports.type)("number")
], $ba46ecaa51dd6ec0$export$6d8e639cdcf2b060.prototype, "wave", void 0);
(0, $5c96a02c592fcff1$export$29e00dfd3077644b)([
    (0, $13e0994b5a5d999e$exports.type)("number")
], $ba46ecaa51dd6ec0$export$6d8e639cdcf2b060.prototype, "waveTimeLeft", void 0);
(0, $5c96a02c592fcff1$export$29e00dfd3077644b)([
    (0, $13e0994b5a5d999e$exports.type)("number")
], $ba46ecaa51dd6ec0$export$6d8e639cdcf2b060.prototype, "remainingMonsters", void 0);
(0, $5c96a02c592fcff1$export$29e00dfd3077644b)([
    (0, $13e0994b5a5d999e$exports.type)("string")
], $ba46ecaa51dd6ec0$export$6d8e639cdcf2b060.prototype, "soundName", void 0);


// 
// THIS FILE HAS BEEN GENERATED AUTOMATICALLY
// DO NOT CHANGE IT MANUALLY UNLESS YOU KNOW WHAT YOU'RE DOING
// 
// GENERATED USING @colyseus/schema 2.0.19
// 

class $c71480b6e46c2d1d$export$5e41c3feb65c62e8 extends (0, $11eec046138a1763$export$b93e99e706aeadf) {
}




// 
// THIS FILE HAS BEEN GENERATED AUTOMATICALLY
// DO NOT CHANGE IT MANUALLY UNLESS YOU KNOW WHAT YOU'RE DOING
// 
// GENERATED USING @colyseus/schema 2.0.19
// 

class $8fd031dfce5c1dab$export$503c8549a245a4c6 extends (0, $11eec046138a1763$export$b93e99e706aeadf) {
}




// 
// THIS FILE HAS BEEN GENERATED AUTOMATICALLY
// DO NOT CHANGE IT MANUALLY UNLESS YOU KNOW WHAT YOU'RE DOING
// 
// GENERATED USING @colyseus/schema 2.0.19
// 

class $93cc1ed54bb8e5cd$export$fddcd788888bd801 extends (0, $11eec046138a1763$export$b93e99e706aeadf) {
}




// 
// THIS FILE HAS BEEN GENERATED AUTOMATICALLY
// DO NOT CHANGE IT MANUALLY UNLESS YOU KNOW WHAT YOU'RE DOING
// 
// GENERATED USING @colyseus/schema 2.0.19
// 

class $65bb587f3531e736$export$c3ddae4f70ad4da2 extends (0, $11eec046138a1763$export$b93e99e706aeadf) {
}







const $ea8994d2415eb9a4$export$6f673644cb3171 = [
    "score"
];
const $ea8994d2415eb9a4$export$cbcca23355808db8 = [
    1,
    2,
    3,
    4
];











var $acw62 = parcelRequire("acw62");

var $6ab139e79a761c06$exports = {};
$parcel$export($6ab139e79a761c06$exports, "SpinePlayer", () => $781d0b326a8f1540$export$a928bbadb775ec2a);
$parcel$export($6ab139e79a761c06$exports, "Skin", () => $73641f3ef2c01e99$export$b8e0f93a76772233);
$parcel$export($6ab139e79a761c06$exports, "Skin", () => $73641f3ef2c01e99$export$b8e0f93a76772233);
/******************************************************************************
 * Spine Runtimes License Agreement
 * Last updated July 28, 2023. Replaces all prior versions.
 *
 * Copyright (c) 2013-2023, Esoteric Software LLC
 *
 * Integration of the Spine Runtimes into software or otherwise creating
 * derivative works of the Spine Runtimes is permitted under the terms and
 * conditions of Section 2 of the Spine Editor License Agreement:
 * http://esotericsoftware.com/spine-editor-license
 *
 * Otherwise, it is permitted to integrate the Spine Runtimes into software or
 * otherwise create derivative works of the Spine Runtimes (collectively,
 * "Products"), provided that each user of the Products must obtain their own
 * Spine Editor license and redistribution of the Products in any form must
 * include this license and copyright notice.
 *
 * THE SPINE RUNTIMES ARE PROVIDED BY ESOTERIC SOFTWARE LLC "AS IS" AND ANY
 * EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
 * WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE
 * DISCLAIMED. IN NO EVENT SHALL ESOTERIC SOFTWARE LLC BE LIABLE FOR ANY
 * DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES
 * (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES,
 * BUSINESS INTERRUPTION, OR LOSS OF USE, DATA, OR PROFITS) HOWEVER CAUSED AND
 * ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT
 * (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THE
 * SPINE RUNTIMES, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
 *****************************************************************************/ /******************************************************************************
 * Spine Runtimes License Agreement
 * Last updated July 28, 2023. Replaces all prior versions.
 *
 * Copyright (c) 2013-2023, Esoteric Software LLC
 *
 * Integration of the Spine Runtimes into software or otherwise creating
 * derivative works of the Spine Runtimes is permitted under the terms and
 * conditions of Section 2 of the Spine Editor License Agreement:
 * http://esotericsoftware.com/spine-editor-license
 *
 * Otherwise, it is permitted to integrate the Spine Runtimes into software or
 * otherwise create derivative works of the Spine Runtimes (collectively,
 * "Products"), provided that each user of the Products must obtain their own
 * Spine Editor license and redistribution of the Products in any form must
 * include this license and copyright notice.
 *
 * THE SPINE RUNTIMES ARE PROVIDED BY ESOTERIC SOFTWARE LLC "AS IS" AND ANY
 * EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
 * WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE
 * DISCLAIMED. IN NO EVENT SHALL ESOTERIC SOFTWARE LLC BE LIABLE FOR ANY
 * DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES
 * (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES,
 * BUSINESS INTERRUPTION, OR LOSS OF USE, DATA, OR PROFITS) HOWEVER CAUSED AND
 * ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT
 * (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THE
 * SPINE RUNTIMES, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
 *****************************************************************************/ /******************************************************************************
 * Spine Runtimes License Agreement
 * Last updated July 28, 2023. Replaces all prior versions.
 *
 * Copyright (c) 2013-2023, Esoteric Software LLC
 *
 * Integration of the Spine Runtimes into software or otherwise creating
 * derivative works of the Spine Runtimes is permitted under the terms and
 * conditions of Section 2 of the Spine Editor License Agreement:
 * http://esotericsoftware.com/spine-editor-license
 *
 * Otherwise, it is permitted to integrate the Spine Runtimes into software or
 * otherwise create derivative works of the Spine Runtimes (collectively,
 * "Products"), provided that each user of the Products must obtain their own
 * Spine Editor license and redistribution of the Products in any form must
 * include this license and copyright notice.
 *
 * THE SPINE RUNTIMES ARE PROVIDED BY ESOTERIC SOFTWARE LLC "AS IS" AND ANY
 * EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
 * WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE
 * DISCLAIMED. IN NO EVENT SHALL ESOTERIC SOFTWARE LLC BE LIABLE FOR ANY
 * DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES
 * (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES,
 * BUSINESS INTERRUPTION, OR LOSS OF USE, DATA, OR PROFITS) HOWEVER CAUSED AND
 * ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT
 * (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THE
 * SPINE RUNTIMES, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
 *****************************************************************************/ /******************************************************************************
 * Spine Runtimes License Agreement
 * Last updated July 28, 2023. Replaces all prior versions.
 *
 * Copyright (c) 2013-2023, Esoteric Software LLC
 *
 * Integration of the Spine Runtimes into software or otherwise creating
 * derivative works of the Spine Runtimes is permitted under the terms and
 * conditions of Section 2 of the Spine Editor License Agreement:
 * http://esotericsoftware.com/spine-editor-license
 *
 * Otherwise, it is permitted to integrate the Spine Runtimes into software or
 * otherwise create derivative works of the Spine Runtimes (collectively,
 * "Products"), provided that each user of the Products must obtain their own
 * Spine Editor license and redistribution of the Products in any form must
 * include this license and copyright notice.
 *
 * THE SPINE RUNTIMES ARE PROVIDED BY ESOTERIC SOFTWARE LLC "AS IS" AND ANY
 * EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
 * WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE
 * DISCLAIMED. IN NO EVENT SHALL ESOTERIC SOFTWARE LLC BE LIABLE FOR ANY
 * DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES
 * (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES,
 * BUSINESS INTERRUPTION, OR LOSS OF USE, DATA, OR PROFITS) HOWEVER CAUSED AND
 * ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT
 * (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THE
 * SPINE RUNTIMES, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
 *****************************************************************************/ class $1702fa998ec22e58$export$270182061f11fa81 {
    array = new Array();
    add(value) {
        let contains = this.contains(value);
        this.array[value | 0] = value | 0;
        return !contains;
    }
    contains(value) {
        return this.array[value | 0] != undefined;
    }
    remove(value) {
        this.array[value | 0] = undefined;
    }
    clear() {
        this.array.length = 0;
    }
}
class $1702fa998ec22e58$export$1a41fd2ab8394c46 {
    entries = {};
    size = 0;
    add(value) {
        let contains = this.entries[value];
        this.entries[value] = true;
        if (!contains) {
            this.size++;
            return true;
        }
        return false;
    }
    addAll(values) {
        let oldSize = this.size;
        for(var i = 0, n = values.length; i < n; i++)this.add(values[i]);
        return oldSize != this.size;
    }
    contains(value) {
        return this.entries[value];
    }
    clear() {
        this.entries = {};
        this.size = 0;
    }
}
class $1702fa998ec22e58$export$892596cec99bc70e {
    r;
    g;
    b;
    a;
    static WHITE = new $1702fa998ec22e58$export$892596cec99bc70e(1, 1, 1, 1);
    static RED = new $1702fa998ec22e58$export$892596cec99bc70e(1, 0, 0, 1);
    static GREEN = new $1702fa998ec22e58$export$892596cec99bc70e(0, 1, 0, 1);
    static BLUE = new $1702fa998ec22e58$export$892596cec99bc70e(0, 0, 1, 1);
    static MAGENTA = new $1702fa998ec22e58$export$892596cec99bc70e(1, 0, 1, 1);
    constructor(r = 0, g = 0, b = 0, a = 0){
        this.r = r;
        this.g = g;
        this.b = b;
        this.a = a;
    }
    set(r, g, b, a) {
        this.r = r;
        this.g = g;
        this.b = b;
        this.a = a;
        return this.clamp();
    }
    setFromColor(c) {
        this.r = c.r;
        this.g = c.g;
        this.b = c.b;
        this.a = c.a;
        return this;
    }
    setFromString(hex) {
        hex = hex.charAt(0) == "#" ? hex.substr(1) : hex;
        this.r = parseInt(hex.substr(0, 2), 16) / 255;
        this.g = parseInt(hex.substr(2, 2), 16) / 255;
        this.b = parseInt(hex.substr(4, 2), 16) / 255;
        this.a = hex.length != 8 ? 1 : parseInt(hex.substr(6, 2), 16) / 255;
        return this;
    }
    add(r, g, b, a) {
        this.r += r;
        this.g += g;
        this.b += b;
        this.a += a;
        return this.clamp();
    }
    clamp() {
        if (this.r < 0) this.r = 0;
        else if (this.r > 1) this.r = 1;
        if (this.g < 0) this.g = 0;
        else if (this.g > 1) this.g = 1;
        if (this.b < 0) this.b = 0;
        else if (this.b > 1) this.b = 1;
        if (this.a < 0) this.a = 0;
        else if (this.a > 1) this.a = 1;
        return this;
    }
    static rgba8888ToColor(color, value) {
        color.r = ((value & 0xff000000) >>> 24) / 255;
        color.g = ((value & 0x00ff0000) >>> 16) / 255;
        color.b = ((value & 0x0000ff00) >>> 8) / 255;
        color.a = (value & 0x000000ff) / 255;
    }
    static rgb888ToColor(color, value) {
        color.r = ((value & 0x00ff0000) >>> 16) / 255;
        color.g = ((value & 0x0000ff00) >>> 8) / 255;
        color.b = (value & 0x000000ff) / 255;
    }
    static fromString(hex) {
        return new $1702fa998ec22e58$export$892596cec99bc70e().setFromString(hex);
    }
}
class $1702fa998ec22e58$export$6a7ef315a0d1ef07 {
    static PI = 3.1415927;
    static PI2 = $1702fa998ec22e58$export$6a7ef315a0d1ef07.PI * 2;
    static radiansToDegrees = 180 / $1702fa998ec22e58$export$6a7ef315a0d1ef07.PI;
    static radDeg = $1702fa998ec22e58$export$6a7ef315a0d1ef07.radiansToDegrees;
    static degreesToRadians = $1702fa998ec22e58$export$6a7ef315a0d1ef07.PI / 180;
    static degRad = $1702fa998ec22e58$export$6a7ef315a0d1ef07.degreesToRadians;
    static clamp(value, min, max) {
        if (value < min) return min;
        if (value > max) return max;
        return value;
    }
    static cosDeg(degrees) {
        return Math.cos(degrees * $1702fa998ec22e58$export$6a7ef315a0d1ef07.degRad);
    }
    static sinDeg(degrees) {
        return Math.sin(degrees * $1702fa998ec22e58$export$6a7ef315a0d1ef07.degRad);
    }
    static signum(value) {
        return value > 0 ? 1 : value < 0 ? -1 : 0;
    }
    static toInt(x) {
        return x > 0 ? Math.floor(x) : Math.ceil(x);
    }
    static cbrt(x) {
        let y = Math.pow(Math.abs(x), 1 / 3);
        return x < 0 ? -y : y;
    }
    static randomTriangular(min, max) {
        return $1702fa998ec22e58$export$6a7ef315a0d1ef07.randomTriangularWith(min, max, (min + max) * 0.5);
    }
    static randomTriangularWith(min, max, mode) {
        let u = Math.random();
        let d = max - min;
        if (u <= (mode - min) / d) return min + Math.sqrt(u * d * (mode - min));
        return max - Math.sqrt((1 - u) * d * (max - mode));
    }
    static isPowerOfTwo(value) {
        return value && (value & value - 1) === 0;
    }
}
class $1702fa998ec22e58$export$b0cc4f9860136880 {
    apply(start, end, a) {
        return start + (end - start) * this.applyInternal(a);
    }
}
class $1702fa998ec22e58$export$ce28d653ec559ee extends $1702fa998ec22e58$export$b0cc4f9860136880 {
    power = 2;
    constructor(power){
        super();
        this.power = power;
    }
    applyInternal(a) {
        if (a <= 0.5) return Math.pow(a * 2, this.power) / 2;
        return Math.pow((a - 1) * 2, this.power) / (this.power % 2 == 0 ? -2 : 2) + 1;
    }
}
class $1702fa998ec22e58$export$4834f341f53dca5c extends $1702fa998ec22e58$export$ce28d653ec559ee {
    constructor(power){
        super(power);
    }
    applyInternal(a) {
        return Math.pow(a - 1, this.power) * (this.power % 2 == 0 ? -1 : 1) + 1;
    }
}
class $1702fa998ec22e58$export$d2ca453b913dcdea {
    static SUPPORTS_TYPED_ARRAYS = typeof Float32Array !== "undefined";
    static arrayCopy(source, sourceStart, dest, destStart, numElements) {
        for(let i = sourceStart, j = destStart; i < sourceStart + numElements; i++, j++)dest[j] = source[i];
    }
    static arrayFill(array, fromIndex, toIndex, value) {
        for(let i = fromIndex; i < toIndex; i++)array[i] = value;
    }
    static setArraySize(array, size, value = 0) {
        let oldSize = array.length;
        if (oldSize == size) return array;
        array.length = size;
        if (oldSize < size) for(let i = oldSize; i < size; i++)array[i] = value;
        return array;
    }
    static ensureArrayCapacity(array, size, value = 0) {
        if (array.length >= size) return array;
        return $1702fa998ec22e58$export$d2ca453b913dcdea.setArraySize(array, size, value);
    }
    static newArray(size, defaultValue) {
        let array = new Array(size);
        for(let i = 0; i < size; i++)array[i] = defaultValue;
        return array;
    }
    static newFloatArray(size) {
        if ($1702fa998ec22e58$export$d2ca453b913dcdea.SUPPORTS_TYPED_ARRAYS) return new Float32Array(size);
        else {
            let array = new Array(size);
            for(let i = 0; i < array.length; i++)array[i] = 0;
            return array;
        }
    }
    static newShortArray(size) {
        if ($1702fa998ec22e58$export$d2ca453b913dcdea.SUPPORTS_TYPED_ARRAYS) return new Int16Array(size);
        else {
            let array = new Array(size);
            for(let i = 0; i < array.length; i++)array[i] = 0;
            return array;
        }
    }
    static toFloatArray(array) {
        return $1702fa998ec22e58$export$d2ca453b913dcdea.SUPPORTS_TYPED_ARRAYS ? new Float32Array(array) : array;
    }
    static toSinglePrecision(value) {
        return $1702fa998ec22e58$export$d2ca453b913dcdea.SUPPORTS_TYPED_ARRAYS ? Math.fround(value) : value;
    }
    // This function is used to fix WebKit 602 specific issue described at http://esotericsoftware.com/forum/iOS-10-disappearing-graphics-10109
    static webkit602BugfixHelper(alpha, blend) {}
    static contains(array, element, identity = true) {
        for(var i = 0; i < array.length; i++)if (array[i] == element) return true;
        return false;
    }
    static enumValue(type, name) {
        return type[name[0].toUpperCase() + name.slice(1)];
    }
}
class $1702fa998ec22e58$export$d19db7c5e7bdee05 {
    static logBones(skeleton) {
        for(let i = 0; i < skeleton.bones.length; i++){
            let bone = skeleton.bones[i];
            console.log(bone.data.name + ", " + bone.a + ", " + bone.b + ", " + bone.c + ", " + bone.d + ", " + bone.worldX + ", " + bone.worldY);
        }
    }
}
class $1702fa998ec22e58$export$14963ee5c8637e11 {
    items = new Array();
    instantiator;
    constructor(instantiator){
        this.instantiator = instantiator;
    }
    obtain() {
        return this.items.length > 0 ? this.items.pop() : this.instantiator();
    }
    free(item) {
        if (item.reset) item.reset();
        this.items.push(item);
    }
    freeAll(items) {
        for(let i = 0; i < items.length; i++)this.free(items[i]);
    }
    clear() {
        this.items.length = 0;
    }
}
class $1702fa998ec22e58$export$c977b3e384af9ae1 {
    x;
    y;
    constructor(x = 0, y = 0){
        this.x = x;
        this.y = y;
    }
    set(x, y) {
        this.x = x;
        this.y = y;
        return this;
    }
    length() {
        let x = this.x;
        let y = this.y;
        return Math.sqrt(x * x + y * y);
    }
    normalize() {
        let len = this.length();
        if (len != 0) {
            this.x /= len;
            this.y /= len;
        }
        return this;
    }
}
class $1702fa998ec22e58$export$ab19517904b64359 {
    maxDelta = 0.064;
    framesPerSecond = 0;
    delta = 0;
    totalTime = 0;
    lastTime = Date.now() / 1000;
    frameCount = 0;
    frameTime = 0;
    update() {
        let now = Date.now() / 1000;
        this.delta = now - this.lastTime;
        this.frameTime += this.delta;
        this.totalTime += this.delta;
        if (this.delta > this.maxDelta) this.delta = this.maxDelta;
        this.lastTime = now;
        this.frameCount++;
        if (this.frameTime > 1) {
            this.framesPerSecond = this.frameCount / this.frameTime;
            this.frameTime = 0;
            this.frameCount = 0;
        }
    }
}
class $1702fa998ec22e58$export$a88e0a4e9fe51345 {
    values;
    addedValues = 0;
    lastValue = 0;
    mean = 0;
    dirty = true;
    constructor(windowSize = 32){
        this.values = new Array(windowSize);
    }
    hasEnoughData() {
        return this.addedValues >= this.values.length;
    }
    addValue(value) {
        if (this.addedValues < this.values.length) this.addedValues++;
        this.values[this.lastValue++] = value;
        if (this.lastValue > this.values.length - 1) this.lastValue = 0;
        this.dirty = true;
    }
    getMean() {
        if (this.hasEnoughData()) {
            if (this.dirty) {
                let mean = 0;
                for(let i = 0; i < this.values.length; i++)mean += this.values[i];
                this.mean = mean / this.values.length;
                this.dirty = false;
            }
            return this.mean;
        }
        return 0;
    }
}


class $3c213aed73167a71$export$71e4db985cfcf9e3 {
    name;
    constructor(name){
        if (!name) throw new Error("name cannot be null.");
        this.name = name;
    }
}
class $3c213aed73167a71$export$66d3a0c3be55e044 extends $3c213aed73167a71$export$71e4db985cfcf9e3 {
    static nextID = 0;
    /** The unique ID for this attachment. */ id = $3c213aed73167a71$export$66d3a0c3be55e044.nextID++;
    /** The bones which affect the {@link #getVertices()}. The array entries are, for each vertex, the number of bones affecting
     * the vertex followed by that many bone indices, which is the index of the bone in {@link Skeleton#bones}. Will be null
     * if this attachment has no weights. */ bones = null;
    /** The vertex positions in the bone's coordinate system. For a non-weighted attachment, the values are `x,y`
     * entries for each vertex. For a weighted attachment, the values are `x,y,weight` entries for each bone affecting
     * each vertex. */ vertices = [];
    /** The maximum number of world vertex values that can be output by
     * {@link #computeWorldVertices()} using the `count` parameter. */ worldVerticesLength = 0;
    /** Timelines for the timeline attachment are also applied to this attachment.
     * May be null if no attachment-specific timelines should be applied. */ timelineAttachment = this;
    constructor(name){
        super(name);
    }
    /** Transforms the attachment's local {@link #vertices} to world coordinates. If the slot's {@link Slot#deform} is
     * not empty, it is used to deform the vertices.
     *
     * See [World transforms](http://esotericsoftware.com/spine-runtime-skeletons#World-transforms) in the Spine
     * Runtimes Guide.
     * @param start The index of the first {@link #vertices} value to transform. Each vertex has 2 values, x and y.
     * @param count The number of world vertex values to output. Must be <= {@link #worldVerticesLength} - `start`.
     * @param worldVertices The output world vertices. Must have a length >= `offset` + `count` *
     *           `stride` / 2.
     * @param offset The `worldVertices` index to begin writing values.
     * @param stride The number of `worldVertices` entries between the value pairs written. */ computeWorldVertices(slot, start, count, worldVertices, offset, stride) {
        count = offset + (count >> 1) * stride;
        let skeleton = slot.bone.skeleton;
        let deformArray = slot.deform;
        let vertices = this.vertices;
        let bones = this.bones;
        if (!bones) {
            if (deformArray.length > 0) vertices = deformArray;
            let bone = slot.bone;
            let x = bone.worldX;
            let y = bone.worldY;
            let a = bone.a, b = bone.b, c = bone.c, d = bone.d;
            for(let v = start, w = offset; w < count; v += 2, w += stride){
                let vx = vertices[v], vy = vertices[v + 1];
                worldVertices[w] = vx * a + vy * b + x;
                worldVertices[w + 1] = vx * c + vy * d + y;
            }
            return;
        }
        let v = 0, skip = 0;
        for(let i = 0; i < start; i += 2){
            let n = bones[v];
            v += n + 1;
            skip += n;
        }
        let skeletonBones = skeleton.bones;
        if (deformArray.length == 0) for(let w = offset, b = skip * 3; w < count; w += stride){
            let wx = 0, wy = 0;
            let n = bones[v++];
            n += v;
            for(; v < n; v++, b += 3){
                let bone = skeletonBones[bones[v]];
                let vx = vertices[b], vy = vertices[b + 1], weight = vertices[b + 2];
                wx += (vx * bone.a + vy * bone.b + bone.worldX) * weight;
                wy += (vx * bone.c + vy * bone.d + bone.worldY) * weight;
            }
            worldVertices[w] = wx;
            worldVertices[w + 1] = wy;
        }
        else {
            let deform = deformArray;
            for(let w = offset, b = skip * 3, f = skip << 1; w < count; w += stride){
                let wx = 0, wy = 0;
                let n = bones[v++];
                n += v;
                for(; v < n; v++, b += 3, f += 2){
                    let bone = skeletonBones[bones[v]];
                    let vx = vertices[b] + deform[f], vy = vertices[b + 1] + deform[f + 1], weight = vertices[b + 2];
                    wx += (vx * bone.a + vy * bone.b + bone.worldX) * weight;
                    wy += (vx * bone.c + vy * bone.d + bone.worldY) * weight;
                }
                worldVertices[w] = wx;
                worldVertices[w + 1] = wy;
            }
        }
    }
    /** Does not copy id (generated) or name (set on construction). **/ copyTo(attachment) {
        if (this.bones) {
            attachment.bones = new Array(this.bones.length);
            (0, $1702fa998ec22e58$export$d2ca453b913dcdea).arrayCopy(this.bones, 0, attachment.bones, 0, this.bones.length);
        } else attachment.bones = null;
        if (this.vertices) {
            attachment.vertices = (0, $1702fa998ec22e58$export$d2ca453b913dcdea).newFloatArray(this.vertices.length);
            (0, $1702fa998ec22e58$export$d2ca453b913dcdea).arrayCopy(this.vertices, 0, attachment.vertices, 0, this.vertices.length);
        }
        attachment.worldVerticesLength = this.worldVerticesLength;
        attachment.timelineAttachment = this.timelineAttachment;
    }
}



/******************************************************************************
 * Spine Runtimes License Agreement
 * Last updated July 28, 2023. Replaces all prior versions.
 *
 * Copyright (c) 2013-2023, Esoteric Software LLC
 *
 * Integration of the Spine Runtimes into software or otherwise creating
 * derivative works of the Spine Runtimes is permitted under the terms and
 * conditions of Section 2 of the Spine Editor License Agreement:
 * http://esotericsoftware.com/spine-editor-license
 *
 * Otherwise, it is permitted to integrate the Spine Runtimes into software or
 * otherwise create derivative works of the Spine Runtimes (collectively,
 * "Products"), provided that each user of the Products must obtain their own
 * Spine Editor license and redistribution of the Products in any form must
 * include this license and copyright notice.
 *
 * THE SPINE RUNTIMES ARE PROVIDED BY ESOTERIC SOFTWARE LLC "AS IS" AND ANY
 * EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
 * WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE
 * DISCLAIMED. IN NO EVENT SHALL ESOTERIC SOFTWARE LLC BE LIABLE FOR ANY
 * DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES
 * (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES,
 * BUSINESS INTERRUPTION, OR LOSS OF USE, DATA, OR PROFITS) HOWEVER CAUSED AND
 * ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT
 * (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THE
 * SPINE RUNTIMES, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
 *****************************************************************************/ 
class $1bc73da5d49cda90$export$edde1bcb1b2b310e {
    static _nextID = 0;
    id = $1bc73da5d49cda90$export$edde1bcb1b2b310e.nextID();
    regions;
    start = 0;
    digits = 0;
    /** The index of the region to show for the setup pose. */ setupIndex = 0;
    constructor(count){
        this.regions = new Array(count);
    }
    copy() {
        let copy = new $1bc73da5d49cda90$export$edde1bcb1b2b310e(this.regions.length);
        (0, $1702fa998ec22e58$export$d2ca453b913dcdea).arrayCopy(this.regions, 0, copy.regions, 0, this.regions.length);
        copy.start = this.start;
        copy.digits = this.digits;
        copy.setupIndex = this.setupIndex;
        return copy;
    }
    apply(slot, attachment) {
        let index = slot.sequenceIndex;
        if (index == -1) index = this.setupIndex;
        if (index >= this.regions.length) index = this.regions.length - 1;
        let region = this.regions[index];
        if (attachment.region != region) {
            attachment.region = region;
            attachment.updateRegion();
        }
    }
    getPath(basePath, index) {
        let result = basePath;
        let frame = (this.start + index).toString();
        for(let i = this.digits - frame.length; i > 0; i--)result += "0";
        result += frame;
        return result;
    }
    static nextID() {
        return $1bc73da5d49cda90$export$edde1bcb1b2b310e._nextID++;
    }
}
var $1bc73da5d49cda90$export$2d839466c6120eb9;
(function(SequenceMode) {
    SequenceMode[SequenceMode["hold"] = 0] = "hold";
    SequenceMode[SequenceMode["once"] = 1] = "once";
    SequenceMode[SequenceMode["loop"] = 2] = "loop";
    SequenceMode[SequenceMode["pingpong"] = 3] = "pingpong";
    SequenceMode[SequenceMode["onceReverse"] = 4] = "onceReverse";
    SequenceMode[SequenceMode["loopReverse"] = 5] = "loopReverse";
    SequenceMode[SequenceMode["pingpongReverse"] = 6] = "pingpongReverse";
})($1bc73da5d49cda90$export$2d839466c6120eb9 || ($1bc73da5d49cda90$export$2d839466c6120eb9 = {}));
const $1bc73da5d49cda90$export$3d518da8d966a9f5 = [
    $1bc73da5d49cda90$export$2d839466c6120eb9.hold,
    $1bc73da5d49cda90$export$2d839466c6120eb9.once,
    $1bc73da5d49cda90$export$2d839466c6120eb9.loop,
    $1bc73da5d49cda90$export$2d839466c6120eb9.pingpong,
    $1bc73da5d49cda90$export$2d839466c6120eb9.onceReverse,
    $1bc73da5d49cda90$export$2d839466c6120eb9.loopReverse,
    $1bc73da5d49cda90$export$2d839466c6120eb9.pingpongReverse
];


class $c8bc0977b55afb3a$export$c35d437ae5945fcd {
    /** The animation's name, which is unique across all animations in the skeleton. */ name;
    timelines = [];
    timelineIds = new (0, $1702fa998ec22e58$export$1a41fd2ab8394c46)();
    /** The duration of the animation in seconds, which is the highest time of all keys in the timeline. */ duration;
    constructor(name, timelines, duration){
        if (!name) throw new Error("name cannot be null.");
        this.name = name;
        this.setTimelines(timelines);
        this.duration = duration;
    }
    setTimelines(timelines) {
        if (!timelines) throw new Error("timelines cannot be null.");
        this.timelines = timelines;
        this.timelineIds.clear();
        for(var i = 0; i < timelines.length; i++)this.timelineIds.addAll(timelines[i].getPropertyIds());
    }
    hasTimeline(ids) {
        for(let i = 0; i < ids.length; i++)if (this.timelineIds.contains(ids[i])) return true;
        return false;
    }
    /** Applies all the animation's timelines to the specified skeleton.
     *
     * See Timeline {@link Timeline#apply(Skeleton, float, float, Array, float, MixBlend, MixDirection)}.
     * @param loop If true, the animation repeats after {@link #getDuration()}.
     * @param events May be null to ignore fired events. */ apply(skeleton, lastTime, time, loop, events, alpha, blend, direction) {
        if (!skeleton) throw new Error("skeleton cannot be null.");
        if (loop && this.duration != 0) {
            time %= this.duration;
            if (lastTime > 0) lastTime %= this.duration;
        }
        let timelines = this.timelines;
        for(let i = 0, n = timelines.length; i < n; i++)timelines[i].apply(skeleton, lastTime, time, events, alpha, blend, direction);
    }
}
var $c8bc0977b55afb3a$export$ccab779a50275a35;
(function(MixBlend) {
    /** Transitions from the setup value to the timeline value (the current value is not used). Before the first key, the setup
     * value is set. */ MixBlend[MixBlend["setup"] = 0] = "setup";
    /** Transitions from the current value to the timeline value. Before the first key, transitions from the current value to
     * the setup value. Timelines which perform instant transitions, such as {@link DrawOrderTimeline} or
     * {@link AttachmentTimeline}, use the setup value before the first key.
     *
     * `first` is intended for the first animations applied, not for animations layered on top of those. */ MixBlend[MixBlend["first"] = 1] = "first";
    /** Transitions from the current value to the timeline value. No change is made before the first key (the current value is
     * kept until the first key).
     *
     * `replace` is intended for animations layered on top of others, not for the first animations applied. */ MixBlend[MixBlend["replace"] = 2] = "replace";
    /** Transitions from the current value to the current value plus the timeline value. No change is made before the first key
     * (the current value is kept until the first key).
     *
     * `add` is intended for animations layered on top of others, not for the first animations applied. Properties
     * keyed by additive animations must be set manually or by another animation before applying the additive animations, else
     * the property values will increase continually. */ MixBlend[MixBlend["add"] = 3] = "add";
})($c8bc0977b55afb3a$export$ccab779a50275a35 || ($c8bc0977b55afb3a$export$ccab779a50275a35 = {}));
var $c8bc0977b55afb3a$export$52fc338c0bb328ba;
(function(MixDirection) {
    MixDirection[MixDirection["mixIn"] = 0] = "mixIn";
    MixDirection[MixDirection["mixOut"] = 1] = "mixOut";
})($c8bc0977b55afb3a$export$52fc338c0bb328ba || ($c8bc0977b55afb3a$export$52fc338c0bb328ba = {}));
const $c8bc0977b55afb3a$var$Property = {
    rotate: 0,
    x: 1,
    y: 2,
    scaleX: 3,
    scaleY: 4,
    shearX: 5,
    shearY: 6,
    rgb: 7,
    alpha: 8,
    rgb2: 9,
    attachment: 10,
    deform: 11,
    event: 12,
    drawOrder: 13,
    ikConstraint: 14,
    transformConstraint: 15,
    pathConstraintPosition: 16,
    pathConstraintSpacing: 17,
    pathConstraintMix: 18,
    sequence: 19
};
class $c8bc0977b55afb3a$export$e6a97ba2cae5bb94 {
    propertyIds;
    frames;
    constructor(frameCount, propertyIds){
        this.propertyIds = propertyIds;
        this.frames = (0, $1702fa998ec22e58$export$d2ca453b913dcdea).newFloatArray(frameCount * this.getFrameEntries());
    }
    getPropertyIds() {
        return this.propertyIds;
    }
    getFrameEntries() {
        return 1;
    }
    getFrameCount() {
        return this.frames.length / this.getFrameEntries();
    }
    getDuration() {
        return this.frames[this.frames.length - this.getFrameEntries()];
    }
    static search1(frames, time) {
        let n = frames.length;
        for(let i = 1; i < n; i++)if (frames[i] > time) return i - 1;
        return n - 1;
    }
    static search(frames, time, step) {
        let n = frames.length;
        for(let i = step; i < n; i += step)if (frames[i] > time) return i - step;
        return n - step;
    }
}
class $c8bc0977b55afb3a$export$4094e7414845f78f extends $c8bc0977b55afb3a$export$e6a97ba2cae5bb94 {
    curves;
    constructor(frameCount, bezierCount, propertyIds){
        super(frameCount, propertyIds);
        this.curves = (0, $1702fa998ec22e58$export$d2ca453b913dcdea).newFloatArray(frameCount + bezierCount * 18 /*BEZIER_SIZE*/ );
        this.curves[frameCount - 1] = 1 /*STEPPED*/ ;
    }
    /** Sets the specified key frame to linear interpolation. */ setLinear(frame) {
        this.curves[frame] = 0 /*LINEAR*/ ;
    }
    /** Sets the specified key frame to stepped interpolation. */ setStepped(frame) {
        this.curves[frame] = 1 /*STEPPED*/ ;
    }
    /** Shrinks the storage for Bezier curves, for use when <code>bezierCount</code> (specified in the constructor) was larger
     * than the actual number of Bezier curves. */ shrink(bezierCount) {
        let size = this.getFrameCount() + bezierCount * 18 /*BEZIER_SIZE*/ ;
        if (this.curves.length > size) {
            let newCurves = (0, $1702fa998ec22e58$export$d2ca453b913dcdea).newFloatArray(size);
            (0, $1702fa998ec22e58$export$d2ca453b913dcdea).arrayCopy(this.curves, 0, newCurves, 0, size);
            this.curves = newCurves;
        }
    }
    /** Stores the segments for the specified Bezier curve. For timelines that modify multiple values, there may be more than
     * one curve per frame.
     * @param bezier The ordinal of this Bezier curve for this timeline, between 0 and <code>bezierCount - 1</code> (specified
     *           in the constructor), inclusive.
     * @param frame Between 0 and <code>frameCount - 1</code>, inclusive.
     * @param value The index of the value for this frame that this curve is used for.
     * @param time1 The time for the first key.
     * @param value1 The value for the first key.
     * @param cx1 The time for the first Bezier handle.
     * @param cy1 The value for the first Bezier handle.
     * @param cx2 The time of the second Bezier handle.
     * @param cy2 The value for the second Bezier handle.
     * @param time2 The time for the second key.
     * @param value2 The value for the second key. */ setBezier(bezier, frame, value, time1, value1, cx1, cy1, cx2, cy2, time2, value2) {
        let curves = this.curves;
        let i = this.getFrameCount() + bezier * 18 /*BEZIER_SIZE*/ ;
        if (value == 0) curves[frame] = 2 /*BEZIER*/  + i;
        let tmpx = (time1 - cx1 * 2 + cx2) * 0.03, tmpy = (value1 - cy1 * 2 + cy2) * 0.03;
        let dddx = ((cx1 - cx2) * 3 - time1 + time2) * 0.006, dddy = ((cy1 - cy2) * 3 - value1 + value2) * 0.006;
        let ddx = tmpx * 2 + dddx, ddy = tmpy * 2 + dddy;
        let dx = (cx1 - time1) * 0.3 + tmpx + dddx * 0.16666667, dy = (cy1 - value1) * 0.3 + tmpy + dddy * 0.16666667;
        let x = time1 + dx, y = value1 + dy;
        for(let n = i + 18 /*BEZIER_SIZE*/ ; i < n; i += 2){
            curves[i] = x;
            curves[i + 1] = y;
            dx += ddx;
            dy += ddy;
            ddx += dddx;
            ddy += dddy;
            x += dx;
            y += dy;
        }
    }
    /** Returns the Bezier interpolated value for the specified time.
     * @param frameIndex The index into {@link #getFrames()} for the values of the frame before <code>time</code>.
     * @param valueOffset The offset from <code>frameIndex</code> to the value this curve is used for.
     * @param i The index of the Bezier segments. See {@link #getCurveType(int)}. */ getBezierValue(time, frameIndex, valueOffset, i) {
        let curves = this.curves;
        if (curves[i] > time) {
            let x = this.frames[frameIndex], y = this.frames[frameIndex + valueOffset];
            return y + (time - x) / (curves[i] - x) * (curves[i + 1] - y);
        }
        let n = i + 18 /*BEZIER_SIZE*/ ;
        for(i += 2; i < n; i += 2)if (curves[i] >= time) {
            let x = curves[i - 2], y = curves[i - 1];
            return y + (time - x) / (curves[i] - x) * (curves[i + 1] - y);
        }
        frameIndex += this.getFrameEntries();
        let x = curves[n - 2], y = curves[n - 1];
        return y + (time - x) / (this.frames[frameIndex] - x) * (this.frames[frameIndex + valueOffset] - y);
    }
}
class $c8bc0977b55afb3a$export$ea4b0b6c1bc191c5 extends $c8bc0977b55afb3a$export$4094e7414845f78f {
    constructor(frameCount, bezierCount, propertyId){
        super(frameCount, bezierCount, [
            propertyId
        ]);
    }
    getFrameEntries() {
        return 2 /*ENTRIES*/ ;
    }
    /** Sets the time and value for the specified frame.
     * @param frame Between 0 and <code>frameCount</code>, inclusive.
     * @param time The frame time in seconds. */ setFrame(frame, time, value) {
        frame <<= 1;
        this.frames[frame] = time;
        this.frames[frame + 1 /*VALUE*/ ] = value;
    }
    /** Returns the interpolated value for the specified time. */ getCurveValue(time) {
        let frames = this.frames;
        let i = frames.length - 2;
        for(let ii = 2; ii <= i; ii += 2)if (frames[ii] > time) {
            i = ii - 2;
            break;
        }
        let curveType = this.curves[i >> 1];
        switch(curveType){
            case 0 /*LINEAR*/ :
                let before = frames[i], value = frames[i + 1 /*VALUE*/ ];
                return value + (time - before) / (frames[i + 2 /*ENTRIES*/ ] - before) * (frames[i + 2 /*ENTRIES*/  + 1 /*VALUE*/ ] - value);
            case 1 /*STEPPED*/ :
                return frames[i + 1 /*VALUE*/ ];
        }
        return this.getBezierValue(time, i, 1 /*VALUE*/ , curveType - 2 /*BEZIER*/ );
    }
}
class $c8bc0977b55afb3a$export$d380b930c0f765ae extends $c8bc0977b55afb3a$export$4094e7414845f78f {
    /** @param bezierCount The maximum number of Bezier curves. See {@link #shrink(int)}.
     * @param propertyIds Unique identifiers for the properties the timeline modifies. */ constructor(frameCount, bezierCount, propertyId1, propertyId2){
        super(frameCount, bezierCount, [
            propertyId1,
            propertyId2
        ]);
    }
    getFrameEntries() {
        return 3 /*ENTRIES*/ ;
    }
    /** Sets the time and values for the specified frame.
     * @param frame Between 0 and <code>frameCount</code>, inclusive.
     * @param time The frame time in seconds. */ setFrame(frame, time, value1, value2) {
        frame *= 3 /*ENTRIES*/ ;
        this.frames[frame] = time;
        this.frames[frame + 1 /*VALUE1*/ ] = value1;
        this.frames[frame + 2 /*VALUE2*/ ] = value2;
    }
}
class $c8bc0977b55afb3a$export$b7ecb8f68b3e130b extends $c8bc0977b55afb3a$export$ea4b0b6c1bc191c5 {
    boneIndex = 0;
    constructor(frameCount, bezierCount, boneIndex){
        super(frameCount, bezierCount, $c8bc0977b55afb3a$var$Property.rotate + "|" + boneIndex);
        this.boneIndex = boneIndex;
    }
    apply(skeleton, lastTime, time, events, alpha, blend, direction) {
        let bone = skeleton.bones[this.boneIndex];
        if (!bone.active) return;
        let frames = this.frames;
        if (time < frames[0]) {
            switch(blend){
                case $c8bc0977b55afb3a$export$ccab779a50275a35.setup:
                    bone.rotation = bone.data.rotation;
                    return;
                case $c8bc0977b55afb3a$export$ccab779a50275a35.first:
                    bone.rotation += (bone.data.rotation - bone.rotation) * alpha;
            }
            return;
        }
        let r = this.getCurveValue(time);
        switch(blend){
            case $c8bc0977b55afb3a$export$ccab779a50275a35.setup:
                bone.rotation = bone.data.rotation + r * alpha;
                break;
            case $c8bc0977b55afb3a$export$ccab779a50275a35.first:
            case $c8bc0977b55afb3a$export$ccab779a50275a35.replace:
                r += bone.data.rotation - bone.rotation;
            case $c8bc0977b55afb3a$export$ccab779a50275a35.add:
                bone.rotation += r * alpha;
        }
    }
}
class $c8bc0977b55afb3a$export$eb93bf27829ae703 extends $c8bc0977b55afb3a$export$d380b930c0f765ae {
    boneIndex = 0;
    constructor(frameCount, bezierCount, boneIndex){
        super(frameCount, bezierCount, $c8bc0977b55afb3a$var$Property.x + "|" + boneIndex, $c8bc0977b55afb3a$var$Property.y + "|" + boneIndex);
        this.boneIndex = boneIndex;
    }
    apply(skeleton, lastTime, time, events, alpha, blend, direction) {
        let bone = skeleton.bones[this.boneIndex];
        if (!bone.active) return;
        let frames = this.frames;
        if (time < frames[0]) {
            switch(blend){
                case $c8bc0977b55afb3a$export$ccab779a50275a35.setup:
                    bone.x = bone.data.x;
                    bone.y = bone.data.y;
                    return;
                case $c8bc0977b55afb3a$export$ccab779a50275a35.first:
                    bone.x += (bone.data.x - bone.x) * alpha;
                    bone.y += (bone.data.y - bone.y) * alpha;
            }
            return;
        }
        let x = 0, y = 0;
        let i = $c8bc0977b55afb3a$export$e6a97ba2cae5bb94.search(frames, time, 3 /*ENTRIES*/ );
        let curveType = this.curves[i / 3 /*ENTRIES*/ ];
        switch(curveType){
            case 0 /*LINEAR*/ :
                let before = frames[i];
                x = frames[i + 1 /*VALUE1*/ ];
                y = frames[i + 2 /*VALUE2*/ ];
                let t = (time - before) / (frames[i + 3 /*ENTRIES*/ ] - before);
                x += (frames[i + 3 /*ENTRIES*/  + 1 /*VALUE1*/ ] - x) * t;
                y += (frames[i + 3 /*ENTRIES*/  + 2 /*VALUE2*/ ] - y) * t;
                break;
            case 1 /*STEPPED*/ :
                x = frames[i + 1 /*VALUE1*/ ];
                y = frames[i + 2 /*VALUE2*/ ];
                break;
            default:
                x = this.getBezierValue(time, i, 1 /*VALUE1*/ , curveType - 2 /*BEZIER*/ );
                y = this.getBezierValue(time, i, 2 /*VALUE2*/ , curveType + 18 /*BEZIER_SIZE*/  - 2 /*BEZIER*/ );
        }
        switch(blend){
            case $c8bc0977b55afb3a$export$ccab779a50275a35.setup:
                bone.x = bone.data.x + x * alpha;
                bone.y = bone.data.y + y * alpha;
                break;
            case $c8bc0977b55afb3a$export$ccab779a50275a35.first:
            case $c8bc0977b55afb3a$export$ccab779a50275a35.replace:
                bone.x += (bone.data.x + x - bone.x) * alpha;
                bone.y += (bone.data.y + y - bone.y) * alpha;
                break;
            case $c8bc0977b55afb3a$export$ccab779a50275a35.add:
                bone.x += x * alpha;
                bone.y += y * alpha;
        }
    }
}
class $c8bc0977b55afb3a$export$cf49491eb4394eca extends $c8bc0977b55afb3a$export$ea4b0b6c1bc191c5 {
    boneIndex = 0;
    constructor(frameCount, bezierCount, boneIndex){
        super(frameCount, bezierCount, $c8bc0977b55afb3a$var$Property.x + "|" + boneIndex);
        this.boneIndex = boneIndex;
    }
    apply(skeleton, lastTime, time, events, alpha, blend, direction) {
        let bone = skeleton.bones[this.boneIndex];
        if (!bone.active) return;
        let frames = this.frames;
        if (time < frames[0]) {
            switch(blend){
                case $c8bc0977b55afb3a$export$ccab779a50275a35.setup:
                    bone.x = bone.data.x;
                    return;
                case $c8bc0977b55afb3a$export$ccab779a50275a35.first:
                    bone.x += (bone.data.x - bone.x) * alpha;
            }
            return;
        }
        let x = this.getCurveValue(time);
        switch(blend){
            case $c8bc0977b55afb3a$export$ccab779a50275a35.setup:
                bone.x = bone.data.x + x * alpha;
                break;
            case $c8bc0977b55afb3a$export$ccab779a50275a35.first:
            case $c8bc0977b55afb3a$export$ccab779a50275a35.replace:
                bone.x += (bone.data.x + x - bone.x) * alpha;
                break;
            case $c8bc0977b55afb3a$export$ccab779a50275a35.add:
                bone.x += x * alpha;
        }
    }
}
class $c8bc0977b55afb3a$export$6540b7ba297d3e41 extends $c8bc0977b55afb3a$export$ea4b0b6c1bc191c5 {
    boneIndex = 0;
    constructor(frameCount, bezierCount, boneIndex){
        super(frameCount, bezierCount, $c8bc0977b55afb3a$var$Property.y + "|" + boneIndex);
        this.boneIndex = boneIndex;
    }
    apply(skeleton, lastTime, time, events, alpha, blend, direction) {
        let bone = skeleton.bones[this.boneIndex];
        if (!bone.active) return;
        let frames = this.frames;
        if (time < frames[0]) {
            switch(blend){
                case $c8bc0977b55afb3a$export$ccab779a50275a35.setup:
                    bone.y = bone.data.y;
                    return;
                case $c8bc0977b55afb3a$export$ccab779a50275a35.first:
                    bone.y += (bone.data.y - bone.y) * alpha;
            }
            return;
        }
        let y = this.getCurveValue(time);
        switch(blend){
            case $c8bc0977b55afb3a$export$ccab779a50275a35.setup:
                bone.y = bone.data.y + y * alpha;
                break;
            case $c8bc0977b55afb3a$export$ccab779a50275a35.first:
            case $c8bc0977b55afb3a$export$ccab779a50275a35.replace:
                bone.y += (bone.data.y + y - bone.y) * alpha;
                break;
            case $c8bc0977b55afb3a$export$ccab779a50275a35.add:
                bone.y += y * alpha;
        }
    }
}
class $c8bc0977b55afb3a$export$be544e22f6ad7737 extends $c8bc0977b55afb3a$export$d380b930c0f765ae {
    boneIndex = 0;
    constructor(frameCount, bezierCount, boneIndex){
        super(frameCount, bezierCount, $c8bc0977b55afb3a$var$Property.scaleX + "|" + boneIndex, $c8bc0977b55afb3a$var$Property.scaleY + "|" + boneIndex);
        this.boneIndex = boneIndex;
    }
    apply(skeleton, lastTime, time, events, alpha, blend, direction) {
        let bone = skeleton.bones[this.boneIndex];
        if (!bone.active) return;
        let frames = this.frames;
        if (time < frames[0]) {
            switch(blend){
                case $c8bc0977b55afb3a$export$ccab779a50275a35.setup:
                    bone.scaleX = bone.data.scaleX;
                    bone.scaleY = bone.data.scaleY;
                    return;
                case $c8bc0977b55afb3a$export$ccab779a50275a35.first:
                    bone.scaleX += (bone.data.scaleX - bone.scaleX) * alpha;
                    bone.scaleY += (bone.data.scaleY - bone.scaleY) * alpha;
            }
            return;
        }
        let x, y;
        let i = $c8bc0977b55afb3a$export$e6a97ba2cae5bb94.search(frames, time, 3 /*ENTRIES*/ );
        let curveType = this.curves[i / 3 /*ENTRIES*/ ];
        switch(curveType){
            case 0 /*LINEAR*/ :
                let before = frames[i];
                x = frames[i + 1 /*VALUE1*/ ];
                y = frames[i + 2 /*VALUE2*/ ];
                let t = (time - before) / (frames[i + 3 /*ENTRIES*/ ] - before);
                x += (frames[i + 3 /*ENTRIES*/  + 1 /*VALUE1*/ ] - x) * t;
                y += (frames[i + 3 /*ENTRIES*/  + 2 /*VALUE2*/ ] - y) * t;
                break;
            case 1 /*STEPPED*/ :
                x = frames[i + 1 /*VALUE1*/ ];
                y = frames[i + 2 /*VALUE2*/ ];
                break;
            default:
                x = this.getBezierValue(time, i, 1 /*VALUE1*/ , curveType - 2 /*BEZIER*/ );
                y = this.getBezierValue(time, i, 2 /*VALUE2*/ , curveType + 18 /*BEZIER_SIZE*/  - 2 /*BEZIER*/ );
        }
        x *= bone.data.scaleX;
        y *= bone.data.scaleY;
        if (alpha == 1) {
            if (blend == $c8bc0977b55afb3a$export$ccab779a50275a35.add) {
                bone.scaleX += x - bone.data.scaleX;
                bone.scaleY += y - bone.data.scaleY;
            } else {
                bone.scaleX = x;
                bone.scaleY = y;
            }
        } else {
            let bx = 0, by = 0;
            if (direction == $c8bc0977b55afb3a$export$52fc338c0bb328ba.mixOut) switch(blend){
                case $c8bc0977b55afb3a$export$ccab779a50275a35.setup:
                    bx = bone.data.scaleX;
                    by = bone.data.scaleY;
                    bone.scaleX = bx + (Math.abs(x) * (0, $1702fa998ec22e58$export$6a7ef315a0d1ef07).signum(bx) - bx) * alpha;
                    bone.scaleY = by + (Math.abs(y) * (0, $1702fa998ec22e58$export$6a7ef315a0d1ef07).signum(by) - by) * alpha;
                    break;
                case $c8bc0977b55afb3a$export$ccab779a50275a35.first:
                case $c8bc0977b55afb3a$export$ccab779a50275a35.replace:
                    bx = bone.scaleX;
                    by = bone.scaleY;
                    bone.scaleX = bx + (Math.abs(x) * (0, $1702fa998ec22e58$export$6a7ef315a0d1ef07).signum(bx) - bx) * alpha;
                    bone.scaleY = by + (Math.abs(y) * (0, $1702fa998ec22e58$export$6a7ef315a0d1ef07).signum(by) - by) * alpha;
                    break;
                case $c8bc0977b55afb3a$export$ccab779a50275a35.add:
                    bone.scaleX += (x - bone.data.scaleX) * alpha;
                    bone.scaleY += (y - bone.data.scaleY) * alpha;
            }
            else switch(blend){
                case $c8bc0977b55afb3a$export$ccab779a50275a35.setup:
                    bx = Math.abs(bone.data.scaleX) * (0, $1702fa998ec22e58$export$6a7ef315a0d1ef07).signum(x);
                    by = Math.abs(bone.data.scaleY) * (0, $1702fa998ec22e58$export$6a7ef315a0d1ef07).signum(y);
                    bone.scaleX = bx + (x - bx) * alpha;
                    bone.scaleY = by + (y - by) * alpha;
                    break;
                case $c8bc0977b55afb3a$export$ccab779a50275a35.first:
                case $c8bc0977b55afb3a$export$ccab779a50275a35.replace:
                    bx = Math.abs(bone.scaleX) * (0, $1702fa998ec22e58$export$6a7ef315a0d1ef07).signum(x);
                    by = Math.abs(bone.scaleY) * (0, $1702fa998ec22e58$export$6a7ef315a0d1ef07).signum(y);
                    bone.scaleX = bx + (x - bx) * alpha;
                    bone.scaleY = by + (y - by) * alpha;
                    break;
                case $c8bc0977b55afb3a$export$ccab779a50275a35.add:
                    bone.scaleX += (x - bone.data.scaleX) * alpha;
                    bone.scaleY += (y - bone.data.scaleY) * alpha;
            }
        }
    }
}
class $c8bc0977b55afb3a$export$407a9cf4df59ebda extends $c8bc0977b55afb3a$export$ea4b0b6c1bc191c5 {
    boneIndex = 0;
    constructor(frameCount, bezierCount, boneIndex){
        super(frameCount, bezierCount, $c8bc0977b55afb3a$var$Property.scaleX + "|" + boneIndex);
        this.boneIndex = boneIndex;
    }
    apply(skeleton, lastTime, time, events, alpha, blend, direction) {
        let bone = skeleton.bones[this.boneIndex];
        if (!bone.active) return;
        let frames = this.frames;
        if (time < frames[0]) {
            switch(blend){
                case $c8bc0977b55afb3a$export$ccab779a50275a35.setup:
                    bone.scaleX = bone.data.scaleX;
                    return;
                case $c8bc0977b55afb3a$export$ccab779a50275a35.first:
                    bone.scaleX += (bone.data.scaleX - bone.scaleX) * alpha;
            }
            return;
        }
        let x = this.getCurveValue(time) * bone.data.scaleX;
        if (alpha == 1) {
            if (blend == $c8bc0977b55afb3a$export$ccab779a50275a35.add) bone.scaleX += x - bone.data.scaleX;
            else bone.scaleX = x;
        } else {
            // Mixing out uses sign of setup or current pose, else use sign of key.
            let bx = 0;
            if (direction == $c8bc0977b55afb3a$export$52fc338c0bb328ba.mixOut) switch(blend){
                case $c8bc0977b55afb3a$export$ccab779a50275a35.setup:
                    bx = bone.data.scaleX;
                    bone.scaleX = bx + (Math.abs(x) * (0, $1702fa998ec22e58$export$6a7ef315a0d1ef07).signum(bx) - bx) * alpha;
                    break;
                case $c8bc0977b55afb3a$export$ccab779a50275a35.first:
                case $c8bc0977b55afb3a$export$ccab779a50275a35.replace:
                    bx = bone.scaleX;
                    bone.scaleX = bx + (Math.abs(x) * (0, $1702fa998ec22e58$export$6a7ef315a0d1ef07).signum(bx) - bx) * alpha;
                    break;
                case $c8bc0977b55afb3a$export$ccab779a50275a35.add:
                    bone.scaleX += (x - bone.data.scaleX) * alpha;
            }
            else switch(blend){
                case $c8bc0977b55afb3a$export$ccab779a50275a35.setup:
                    bx = Math.abs(bone.data.scaleX) * (0, $1702fa998ec22e58$export$6a7ef315a0d1ef07).signum(x);
                    bone.scaleX = bx + (x - bx) * alpha;
                    break;
                case $c8bc0977b55afb3a$export$ccab779a50275a35.first:
                case $c8bc0977b55afb3a$export$ccab779a50275a35.replace:
                    bx = Math.abs(bone.scaleX) * (0, $1702fa998ec22e58$export$6a7ef315a0d1ef07).signum(x);
                    bone.scaleX = bx + (x - bx) * alpha;
                    break;
                case $c8bc0977b55afb3a$export$ccab779a50275a35.add:
                    bone.scaleX += (x - bone.data.scaleX) * alpha;
            }
        }
    }
}
class $c8bc0977b55afb3a$export$cc13ceba88ef3794 extends $c8bc0977b55afb3a$export$ea4b0b6c1bc191c5 {
    boneIndex = 0;
    constructor(frameCount, bezierCount, boneIndex){
        super(frameCount, bezierCount, $c8bc0977b55afb3a$var$Property.scaleY + "|" + boneIndex);
        this.boneIndex = boneIndex;
    }
    apply(skeleton, lastTime, time, events, alpha, blend, direction) {
        let bone = skeleton.bones[this.boneIndex];
        if (!bone.active) return;
        let frames = this.frames;
        if (time < frames[0]) {
            switch(blend){
                case $c8bc0977b55afb3a$export$ccab779a50275a35.setup:
                    bone.scaleY = bone.data.scaleY;
                    return;
                case $c8bc0977b55afb3a$export$ccab779a50275a35.first:
                    bone.scaleY += (bone.data.scaleY - bone.scaleY) * alpha;
            }
            return;
        }
        let y = this.getCurveValue(time) * bone.data.scaleY;
        if (alpha == 1) {
            if (blend == $c8bc0977b55afb3a$export$ccab779a50275a35.add) bone.scaleY += y - bone.data.scaleY;
            else bone.scaleY = y;
        } else {
            // Mixing out uses sign of setup or current pose, else use sign of key.
            let by = 0;
            if (direction == $c8bc0977b55afb3a$export$52fc338c0bb328ba.mixOut) switch(blend){
                case $c8bc0977b55afb3a$export$ccab779a50275a35.setup:
                    by = bone.data.scaleY;
                    bone.scaleY = by + (Math.abs(y) * (0, $1702fa998ec22e58$export$6a7ef315a0d1ef07).signum(by) - by) * alpha;
                    break;
                case $c8bc0977b55afb3a$export$ccab779a50275a35.first:
                case $c8bc0977b55afb3a$export$ccab779a50275a35.replace:
                    by = bone.scaleY;
                    bone.scaleY = by + (Math.abs(y) * (0, $1702fa998ec22e58$export$6a7ef315a0d1ef07).signum(by) - by) * alpha;
                    break;
                case $c8bc0977b55afb3a$export$ccab779a50275a35.add:
                    bone.scaleY += (y - bone.data.scaleY) * alpha;
            }
            else switch(blend){
                case $c8bc0977b55afb3a$export$ccab779a50275a35.setup:
                    by = Math.abs(bone.data.scaleY) * (0, $1702fa998ec22e58$export$6a7ef315a0d1ef07).signum(y);
                    bone.scaleY = by + (y - by) * alpha;
                    break;
                case $c8bc0977b55afb3a$export$ccab779a50275a35.first:
                case $c8bc0977b55afb3a$export$ccab779a50275a35.replace:
                    by = Math.abs(bone.scaleY) * (0, $1702fa998ec22e58$export$6a7ef315a0d1ef07).signum(y);
                    bone.scaleY = by + (y - by) * alpha;
                    break;
                case $c8bc0977b55afb3a$export$ccab779a50275a35.add:
                    bone.scaleY += (y - bone.data.scaleY) * alpha;
            }
        }
    }
}
class $c8bc0977b55afb3a$export$4da82436a1a0d773 extends $c8bc0977b55afb3a$export$d380b930c0f765ae {
    boneIndex = 0;
    constructor(frameCount, bezierCount, boneIndex){
        super(frameCount, bezierCount, $c8bc0977b55afb3a$var$Property.shearX + "|" + boneIndex, $c8bc0977b55afb3a$var$Property.shearY + "|" + boneIndex);
        this.boneIndex = boneIndex;
    }
    apply(skeleton, lastTime, time, events, alpha, blend, direction) {
        let bone = skeleton.bones[this.boneIndex];
        if (!bone.active) return;
        let frames = this.frames;
        if (time < frames[0]) {
            switch(blend){
                case $c8bc0977b55afb3a$export$ccab779a50275a35.setup:
                    bone.shearX = bone.data.shearX;
                    bone.shearY = bone.data.shearY;
                    return;
                case $c8bc0977b55afb3a$export$ccab779a50275a35.first:
                    bone.shearX += (bone.data.shearX - bone.shearX) * alpha;
                    bone.shearY += (bone.data.shearY - bone.shearY) * alpha;
            }
            return;
        }
        let x = 0, y = 0;
        let i = $c8bc0977b55afb3a$export$e6a97ba2cae5bb94.search(frames, time, 3 /*ENTRIES*/ );
        let curveType = this.curves[i / 3 /*ENTRIES*/ ];
        switch(curveType){
            case 0 /*LINEAR*/ :
                let before = frames[i];
                x = frames[i + 1 /*VALUE1*/ ];
                y = frames[i + 2 /*VALUE2*/ ];
                let t = (time - before) / (frames[i + 3 /*ENTRIES*/ ] - before);
                x += (frames[i + 3 /*ENTRIES*/  + 1 /*VALUE1*/ ] - x) * t;
                y += (frames[i + 3 /*ENTRIES*/  + 2 /*VALUE2*/ ] - y) * t;
                break;
            case 1 /*STEPPED*/ :
                x = frames[i + 1 /*VALUE1*/ ];
                y = frames[i + 2 /*VALUE2*/ ];
                break;
            default:
                x = this.getBezierValue(time, i, 1 /*VALUE1*/ , curveType - 2 /*BEZIER*/ );
                y = this.getBezierValue(time, i, 2 /*VALUE2*/ , curveType + 18 /*BEZIER_SIZE*/  - 2 /*BEZIER*/ );
        }
        switch(blend){
            case $c8bc0977b55afb3a$export$ccab779a50275a35.setup:
                bone.shearX = bone.data.shearX + x * alpha;
                bone.shearY = bone.data.shearY + y * alpha;
                break;
            case $c8bc0977b55afb3a$export$ccab779a50275a35.first:
            case $c8bc0977b55afb3a$export$ccab779a50275a35.replace:
                bone.shearX += (bone.data.shearX + x - bone.shearX) * alpha;
                bone.shearY += (bone.data.shearY + y - bone.shearY) * alpha;
                break;
            case $c8bc0977b55afb3a$export$ccab779a50275a35.add:
                bone.shearX += x * alpha;
                bone.shearY += y * alpha;
        }
    }
}
class $c8bc0977b55afb3a$export$2392b1c4c21acaf8 extends $c8bc0977b55afb3a$export$ea4b0b6c1bc191c5 {
    boneIndex = 0;
    constructor(frameCount, bezierCount, boneIndex){
        super(frameCount, bezierCount, $c8bc0977b55afb3a$var$Property.shearX + "|" + boneIndex);
        this.boneIndex = boneIndex;
    }
    apply(skeleton, lastTime, time, events, alpha, blend, direction) {
        let bone = skeleton.bones[this.boneIndex];
        if (!bone.active) return;
        let frames = this.frames;
        if (time < frames[0]) {
            switch(blend){
                case $c8bc0977b55afb3a$export$ccab779a50275a35.setup:
                    bone.shearX = bone.data.shearX;
                    return;
                case $c8bc0977b55afb3a$export$ccab779a50275a35.first:
                    bone.shearX += (bone.data.shearX - bone.shearX) * alpha;
            }
            return;
        }
        let x = this.getCurveValue(time);
        switch(blend){
            case $c8bc0977b55afb3a$export$ccab779a50275a35.setup:
                bone.shearX = bone.data.shearX + x * alpha;
                break;
            case $c8bc0977b55afb3a$export$ccab779a50275a35.first:
            case $c8bc0977b55afb3a$export$ccab779a50275a35.replace:
                bone.shearX += (bone.data.shearX + x - bone.shearX) * alpha;
                break;
            case $c8bc0977b55afb3a$export$ccab779a50275a35.add:
                bone.shearX += x * alpha;
        }
    }
}
class $c8bc0977b55afb3a$export$f65148e1d95352fd extends $c8bc0977b55afb3a$export$ea4b0b6c1bc191c5 {
    boneIndex = 0;
    constructor(frameCount, bezierCount, boneIndex){
        super(frameCount, bezierCount, $c8bc0977b55afb3a$var$Property.shearY + "|" + boneIndex);
        this.boneIndex = boneIndex;
    }
    apply(skeleton, lastTime, time, events, alpha, blend, direction) {
        let bone = skeleton.bones[this.boneIndex];
        if (!bone.active) return;
        let frames = this.frames;
        if (time < frames[0]) {
            switch(blend){
                case $c8bc0977b55afb3a$export$ccab779a50275a35.setup:
                    bone.shearY = bone.data.shearY;
                    return;
                case $c8bc0977b55afb3a$export$ccab779a50275a35.first:
                    bone.shearY += (bone.data.shearY - bone.shearY) * alpha;
            }
            return;
        }
        let y = this.getCurveValue(time);
        switch(blend){
            case $c8bc0977b55afb3a$export$ccab779a50275a35.setup:
                bone.shearY = bone.data.shearY + y * alpha;
                break;
            case $c8bc0977b55afb3a$export$ccab779a50275a35.first:
            case $c8bc0977b55afb3a$export$ccab779a50275a35.replace:
                bone.shearY += (bone.data.shearY + y - bone.shearY) * alpha;
                break;
            case $c8bc0977b55afb3a$export$ccab779a50275a35.add:
                bone.shearY += y * alpha;
        }
    }
}
class $c8bc0977b55afb3a$export$84cf3a3e225bcbdc extends $c8bc0977b55afb3a$export$4094e7414845f78f {
    slotIndex = 0;
    constructor(frameCount, bezierCount, slotIndex){
        super(frameCount, bezierCount, [
            $c8bc0977b55afb3a$var$Property.rgb + "|" + slotIndex,
            $c8bc0977b55afb3a$var$Property.alpha + "|" + slotIndex
        ]);
        this.slotIndex = slotIndex;
    }
    getFrameEntries() {
        return 5 /*ENTRIES*/ ;
    }
    /** Sets the time in seconds, red, green, blue, and alpha for the specified key frame. */ setFrame(frame, time, r, g, b, a) {
        frame *= 5 /*ENTRIES*/ ;
        this.frames[frame] = time;
        this.frames[frame + 1 /*R*/ ] = r;
        this.frames[frame + 2 /*G*/ ] = g;
        this.frames[frame + 3 /*B*/ ] = b;
        this.frames[frame + 4 /*A*/ ] = a;
    }
    apply(skeleton, lastTime, time, events, alpha, blend, direction) {
        let slot = skeleton.slots[this.slotIndex];
        if (!slot.bone.active) return;
        let frames = this.frames;
        let color = slot.color;
        if (time < frames[0]) {
            let setup = slot.data.color;
            switch(blend){
                case $c8bc0977b55afb3a$export$ccab779a50275a35.setup:
                    color.setFromColor(setup);
                    return;
                case $c8bc0977b55afb3a$export$ccab779a50275a35.first:
                    color.add((setup.r - color.r) * alpha, (setup.g - color.g) * alpha, (setup.b - color.b) * alpha, (setup.a - color.a) * alpha);
            }
            return;
        }
        let r = 0, g = 0, b = 0, a = 0;
        let i = $c8bc0977b55afb3a$export$e6a97ba2cae5bb94.search(frames, time, 5 /*ENTRIES*/ );
        let curveType = this.curves[i / 5 /*ENTRIES*/ ];
        switch(curveType){
            case 0 /*LINEAR*/ :
                let before = frames[i];
                r = frames[i + 1 /*R*/ ];
                g = frames[i + 2 /*G*/ ];
                b = frames[i + 3 /*B*/ ];
                a = frames[i + 4 /*A*/ ];
                let t = (time - before) / (frames[i + 5 /*ENTRIES*/ ] - before);
                r += (frames[i + 5 /*ENTRIES*/  + 1 /*R*/ ] - r) * t;
                g += (frames[i + 5 /*ENTRIES*/  + 2 /*G*/ ] - g) * t;
                b += (frames[i + 5 /*ENTRIES*/  + 3 /*B*/ ] - b) * t;
                a += (frames[i + 5 /*ENTRIES*/  + 4 /*A*/ ] - a) * t;
                break;
            case 1 /*STEPPED*/ :
                r = frames[i + 1 /*R*/ ];
                g = frames[i + 2 /*G*/ ];
                b = frames[i + 3 /*B*/ ];
                a = frames[i + 4 /*A*/ ];
                break;
            default:
                r = this.getBezierValue(time, i, 1 /*R*/ , curveType - 2 /*BEZIER*/ );
                g = this.getBezierValue(time, i, 2 /*G*/ , curveType + 18 /*BEZIER_SIZE*/  - 2 /*BEZIER*/ );
                b = this.getBezierValue(time, i, 3 /*B*/ , curveType + 36 - 2 /*BEZIER*/ );
                a = this.getBezierValue(time, i, 4 /*A*/ , curveType + 54 - 2 /*BEZIER*/ );
        }
        if (alpha == 1) color.set(r, g, b, a);
        else {
            if (blend == $c8bc0977b55afb3a$export$ccab779a50275a35.setup) color.setFromColor(slot.data.color);
            color.add((r - color.r) * alpha, (g - color.g) * alpha, (b - color.b) * alpha, (a - color.a) * alpha);
        }
    }
}
class $c8bc0977b55afb3a$export$e179fb669ddccfa9 extends $c8bc0977b55afb3a$export$4094e7414845f78f {
    slotIndex = 0;
    constructor(frameCount, bezierCount, slotIndex){
        super(frameCount, bezierCount, [
            $c8bc0977b55afb3a$var$Property.rgb + "|" + slotIndex
        ]);
        this.slotIndex = slotIndex;
    }
    getFrameEntries() {
        return 4 /*ENTRIES*/ ;
    }
    /** Sets the time in seconds, red, green, blue, and alpha for the specified key frame. */ setFrame(frame, time, r, g, b) {
        frame <<= 2;
        this.frames[frame] = time;
        this.frames[frame + 1 /*R*/ ] = r;
        this.frames[frame + 2 /*G*/ ] = g;
        this.frames[frame + 3 /*B*/ ] = b;
    }
    apply(skeleton, lastTime, time, events, alpha, blend, direction) {
        let slot = skeleton.slots[this.slotIndex];
        if (!slot.bone.active) return;
        let frames = this.frames;
        let color = slot.color;
        if (time < frames[0]) {
            let setup = slot.data.color;
            switch(blend){
                case $c8bc0977b55afb3a$export$ccab779a50275a35.setup:
                    color.r = setup.r;
                    color.g = setup.g;
                    color.b = setup.b;
                    return;
                case $c8bc0977b55afb3a$export$ccab779a50275a35.first:
                    color.r += (setup.r - color.r) * alpha;
                    color.g += (setup.g - color.g) * alpha;
                    color.b += (setup.b - color.b) * alpha;
            }
            return;
        }
        let r = 0, g = 0, b = 0;
        let i = $c8bc0977b55afb3a$export$e6a97ba2cae5bb94.search(frames, time, 4 /*ENTRIES*/ );
        let curveType = this.curves[i >> 2];
        switch(curveType){
            case 0 /*LINEAR*/ :
                let before = frames[i];
                r = frames[i + 1 /*R*/ ];
                g = frames[i + 2 /*G*/ ];
                b = frames[i + 3 /*B*/ ];
                let t = (time - before) / (frames[i + 4 /*ENTRIES*/ ] - before);
                r += (frames[i + 4 /*ENTRIES*/  + 1 /*R*/ ] - r) * t;
                g += (frames[i + 4 /*ENTRIES*/  + 2 /*G*/ ] - g) * t;
                b += (frames[i + 4 /*ENTRIES*/  + 3 /*B*/ ] - b) * t;
                break;
            case 1 /*STEPPED*/ :
                r = frames[i + 1 /*R*/ ];
                g = frames[i + 2 /*G*/ ];
                b = frames[i + 3 /*B*/ ];
                break;
            default:
                r = this.getBezierValue(time, i, 1 /*R*/ , curveType - 2 /*BEZIER*/ );
                g = this.getBezierValue(time, i, 2 /*G*/ , curveType + 18 /*BEZIER_SIZE*/  - 2 /*BEZIER*/ );
                b = this.getBezierValue(time, i, 3 /*B*/ , curveType + 36 - 2 /*BEZIER*/ );
        }
        if (alpha == 1) {
            color.r = r;
            color.g = g;
            color.b = b;
        } else {
            if (blend == $c8bc0977b55afb3a$export$ccab779a50275a35.setup) {
                let setup = slot.data.color;
                color.r = setup.r;
                color.g = setup.g;
                color.b = setup.b;
            }
            color.r += (r - color.r) * alpha;
            color.g += (g - color.g) * alpha;
            color.b += (b - color.b) * alpha;
        }
    }
}
class $c8bc0977b55afb3a$export$2211be7c5ccde97b extends $c8bc0977b55afb3a$export$ea4b0b6c1bc191c5 {
    slotIndex = 0;
    constructor(frameCount, bezierCount, slotIndex){
        super(frameCount, bezierCount, $c8bc0977b55afb3a$var$Property.alpha + "|" + slotIndex);
        this.slotIndex = slotIndex;
    }
    apply(skeleton, lastTime, time, events, alpha, blend, direction) {
        let slot = skeleton.slots[this.slotIndex];
        if (!slot.bone.active) return;
        let color = slot.color;
        if (time < this.frames[0]) {
            let setup = slot.data.color;
            switch(blend){
                case $c8bc0977b55afb3a$export$ccab779a50275a35.setup:
                    color.a = setup.a;
                    return;
                case $c8bc0977b55afb3a$export$ccab779a50275a35.first:
                    color.a += (setup.a - color.a) * alpha;
            }
            return;
        }
        let a = this.getCurveValue(time);
        if (alpha == 1) color.a = a;
        else {
            if (blend == $c8bc0977b55afb3a$export$ccab779a50275a35.setup) color.a = slot.data.color.a;
            color.a += (a - color.a) * alpha;
        }
    }
}
class $c8bc0977b55afb3a$export$6fc6620d97c53689 extends $c8bc0977b55afb3a$export$4094e7414845f78f {
    slotIndex = 0;
    constructor(frameCount, bezierCount, slotIndex){
        super(frameCount, bezierCount, [
            $c8bc0977b55afb3a$var$Property.rgb + "|" + slotIndex,
            $c8bc0977b55afb3a$var$Property.alpha + "|" + slotIndex,
            $c8bc0977b55afb3a$var$Property.rgb2 + "|" + slotIndex
        ]);
        this.slotIndex = slotIndex;
    }
    getFrameEntries() {
        return 8 /*ENTRIES*/ ;
    }
    /** Sets the time in seconds, light, and dark colors for the specified key frame. */ setFrame(frame, time, r, g, b, a, r2, g2, b2) {
        frame <<= 3;
        this.frames[frame] = time;
        this.frames[frame + 1 /*R*/ ] = r;
        this.frames[frame + 2 /*G*/ ] = g;
        this.frames[frame + 3 /*B*/ ] = b;
        this.frames[frame + 4 /*A*/ ] = a;
        this.frames[frame + 5 /*R2*/ ] = r2;
        this.frames[frame + 6 /*G2*/ ] = g2;
        this.frames[frame + 7 /*B2*/ ] = b2;
    }
    apply(skeleton, lastTime, time, events, alpha, blend, direction) {
        let slot = skeleton.slots[this.slotIndex];
        if (!slot.bone.active) return;
        let frames = this.frames;
        let light = slot.color, dark = slot.darkColor;
        if (time < frames[0]) {
            let setupLight = slot.data.color, setupDark = slot.data.darkColor;
            switch(blend){
                case $c8bc0977b55afb3a$export$ccab779a50275a35.setup:
                    light.setFromColor(setupLight);
                    dark.r = setupDark.r;
                    dark.g = setupDark.g;
                    dark.b = setupDark.b;
                    return;
                case $c8bc0977b55afb3a$export$ccab779a50275a35.first:
                    light.add((setupLight.r - light.r) * alpha, (setupLight.g - light.g) * alpha, (setupLight.b - light.b) * alpha, (setupLight.a - light.a) * alpha);
                    dark.r += (setupDark.r - dark.r) * alpha;
                    dark.g += (setupDark.g - dark.g) * alpha;
                    dark.b += (setupDark.b - dark.b) * alpha;
            }
            return;
        }
        let r = 0, g = 0, b = 0, a = 0, r2 = 0, g2 = 0, b2 = 0;
        let i = $c8bc0977b55afb3a$export$e6a97ba2cae5bb94.search(frames, time, 8 /*ENTRIES*/ );
        let curveType = this.curves[i >> 3];
        switch(curveType){
            case 0 /*LINEAR*/ :
                let before = frames[i];
                r = frames[i + 1 /*R*/ ];
                g = frames[i + 2 /*G*/ ];
                b = frames[i + 3 /*B*/ ];
                a = frames[i + 4 /*A*/ ];
                r2 = frames[i + 5 /*R2*/ ];
                g2 = frames[i + 6 /*G2*/ ];
                b2 = frames[i + 7 /*B2*/ ];
                let t = (time - before) / (frames[i + 8 /*ENTRIES*/ ] - before);
                r += (frames[i + 8 /*ENTRIES*/  + 1 /*R*/ ] - r) * t;
                g += (frames[i + 8 /*ENTRIES*/  + 2 /*G*/ ] - g) * t;
                b += (frames[i + 8 /*ENTRIES*/  + 3 /*B*/ ] - b) * t;
                a += (frames[i + 8 /*ENTRIES*/  + 4 /*A*/ ] - a) * t;
                r2 += (frames[i + 8 /*ENTRIES*/  + 5 /*R2*/ ] - r2) * t;
                g2 += (frames[i + 8 /*ENTRIES*/  + 6 /*G2*/ ] - g2) * t;
                b2 += (frames[i + 8 /*ENTRIES*/  + 7 /*B2*/ ] - b2) * t;
                break;
            case 1 /*STEPPED*/ :
                r = frames[i + 1 /*R*/ ];
                g = frames[i + 2 /*G*/ ];
                b = frames[i + 3 /*B*/ ];
                a = frames[i + 4 /*A*/ ];
                r2 = frames[i + 5 /*R2*/ ];
                g2 = frames[i + 6 /*G2*/ ];
                b2 = frames[i + 7 /*B2*/ ];
                break;
            default:
                r = this.getBezierValue(time, i, 1 /*R*/ , curveType - 2 /*BEZIER*/ );
                g = this.getBezierValue(time, i, 2 /*G*/ , curveType + 18 /*BEZIER_SIZE*/  - 2 /*BEZIER*/ );
                b = this.getBezierValue(time, i, 3 /*B*/ , curveType + 36 - 2 /*BEZIER*/ );
                a = this.getBezierValue(time, i, 4 /*A*/ , curveType + 54 - 2 /*BEZIER*/ );
                r2 = this.getBezierValue(time, i, 5 /*R2*/ , curveType + 72 - 2 /*BEZIER*/ );
                g2 = this.getBezierValue(time, i, 6 /*G2*/ , curveType + 90 - 2 /*BEZIER*/ );
                b2 = this.getBezierValue(time, i, 7 /*B2*/ , curveType + 108 - 2 /*BEZIER*/ );
        }
        if (alpha == 1) {
            light.set(r, g, b, a);
            dark.r = r2;
            dark.g = g2;
            dark.b = b2;
        } else {
            if (blend == $c8bc0977b55afb3a$export$ccab779a50275a35.setup) {
                light.setFromColor(slot.data.color);
                let setupDark = slot.data.darkColor;
                dark.r = setupDark.r;
                dark.g = setupDark.g;
                dark.b = setupDark.b;
            }
            light.add((r - light.r) * alpha, (g - light.g) * alpha, (b - light.b) * alpha, (a - light.a) * alpha);
            dark.r += (r2 - dark.r) * alpha;
            dark.g += (g2 - dark.g) * alpha;
            dark.b += (b2 - dark.b) * alpha;
        }
    }
}
class $c8bc0977b55afb3a$export$a12960afd309a230 extends $c8bc0977b55afb3a$export$4094e7414845f78f {
    slotIndex = 0;
    constructor(frameCount, bezierCount, slotIndex){
        super(frameCount, bezierCount, [
            $c8bc0977b55afb3a$var$Property.rgb + "|" + slotIndex,
            $c8bc0977b55afb3a$var$Property.rgb2 + "|" + slotIndex
        ]);
        this.slotIndex = slotIndex;
    }
    getFrameEntries() {
        return 7 /*ENTRIES*/ ;
    }
    /** Sets the time in seconds, light, and dark colors for the specified key frame. */ setFrame(frame, time, r, g, b, r2, g2, b2) {
        frame *= 7 /*ENTRIES*/ ;
        this.frames[frame] = time;
        this.frames[frame + 1 /*R*/ ] = r;
        this.frames[frame + 2 /*G*/ ] = g;
        this.frames[frame + 3 /*B*/ ] = b;
        this.frames[frame + 4 /*R2*/ ] = r2;
        this.frames[frame + 5 /*G2*/ ] = g2;
        this.frames[frame + 6 /*B2*/ ] = b2;
    }
    apply(skeleton, lastTime, time, events, alpha, blend, direction) {
        let slot = skeleton.slots[this.slotIndex];
        if (!slot.bone.active) return;
        let frames = this.frames;
        let light = slot.color, dark = slot.darkColor;
        if (time < frames[0]) {
            let setupLight = slot.data.color, setupDark = slot.data.darkColor;
            switch(blend){
                case $c8bc0977b55afb3a$export$ccab779a50275a35.setup:
                    light.r = setupLight.r;
                    light.g = setupLight.g;
                    light.b = setupLight.b;
                    dark.r = setupDark.r;
                    dark.g = setupDark.g;
                    dark.b = setupDark.b;
                    return;
                case $c8bc0977b55afb3a$export$ccab779a50275a35.first:
                    light.r += (setupLight.r - light.r) * alpha;
                    light.g += (setupLight.g - light.g) * alpha;
                    light.b += (setupLight.b - light.b) * alpha;
                    dark.r += (setupDark.r - dark.r) * alpha;
                    dark.g += (setupDark.g - dark.g) * alpha;
                    dark.b += (setupDark.b - dark.b) * alpha;
            }
            return;
        }
        let r = 0, g = 0, b = 0, a = 0, r2 = 0, g2 = 0, b2 = 0;
        let i = $c8bc0977b55afb3a$export$e6a97ba2cae5bb94.search(frames, time, 7 /*ENTRIES*/ );
        let curveType = this.curves[i / 7 /*ENTRIES*/ ];
        switch(curveType){
            case 0 /*LINEAR*/ :
                let before = frames[i];
                r = frames[i + 1 /*R*/ ];
                g = frames[i + 2 /*G*/ ];
                b = frames[i + 3 /*B*/ ];
                r2 = frames[i + 4 /*R2*/ ];
                g2 = frames[i + 5 /*G2*/ ];
                b2 = frames[i + 6 /*B2*/ ];
                let t = (time - before) / (frames[i + 7 /*ENTRIES*/ ] - before);
                r += (frames[i + 7 /*ENTRIES*/  + 1 /*R*/ ] - r) * t;
                g += (frames[i + 7 /*ENTRIES*/  + 2 /*G*/ ] - g) * t;
                b += (frames[i + 7 /*ENTRIES*/  + 3 /*B*/ ] - b) * t;
                r2 += (frames[i + 7 /*ENTRIES*/  + 4 /*R2*/ ] - r2) * t;
                g2 += (frames[i + 7 /*ENTRIES*/  + 5 /*G2*/ ] - g2) * t;
                b2 += (frames[i + 7 /*ENTRIES*/  + 6 /*B2*/ ] - b2) * t;
                break;
            case 1 /*STEPPED*/ :
                r = frames[i + 1 /*R*/ ];
                g = frames[i + 2 /*G*/ ];
                b = frames[i + 3 /*B*/ ];
                r2 = frames[i + 4 /*R2*/ ];
                g2 = frames[i + 5 /*G2*/ ];
                b2 = frames[i + 6 /*B2*/ ];
                break;
            default:
                r = this.getBezierValue(time, i, 1 /*R*/ , curveType - 2 /*BEZIER*/ );
                g = this.getBezierValue(time, i, 2 /*G*/ , curveType + 18 /*BEZIER_SIZE*/  - 2 /*BEZIER*/ );
                b = this.getBezierValue(time, i, 3 /*B*/ , curveType + 36 - 2 /*BEZIER*/ );
                r2 = this.getBezierValue(time, i, 4 /*R2*/ , curveType + 54 - 2 /*BEZIER*/ );
                g2 = this.getBezierValue(time, i, 5 /*G2*/ , curveType + 72 - 2 /*BEZIER*/ );
                b2 = this.getBezierValue(time, i, 6 /*B2*/ , curveType + 90 - 2 /*BEZIER*/ );
        }
        if (alpha == 1) {
            light.r = r;
            light.g = g;
            light.b = b;
            dark.r = r2;
            dark.g = g2;
            dark.b = b2;
        } else {
            if (blend == $c8bc0977b55afb3a$export$ccab779a50275a35.setup) {
                let setupLight = slot.data.color, setupDark = slot.data.darkColor;
                light.r = setupLight.r;
                light.g = setupLight.g;
                light.b = setupLight.b;
                dark.r = setupDark.r;
                dark.g = setupDark.g;
                dark.b = setupDark.b;
            }
            light.r += (r - light.r) * alpha;
            light.g += (g - light.g) * alpha;
            light.b += (b - light.b) * alpha;
            dark.r += (r2 - dark.r) * alpha;
            dark.g += (g2 - dark.g) * alpha;
            dark.b += (b2 - dark.b) * alpha;
        }
    }
}
class $c8bc0977b55afb3a$export$7f2bfc5bd27cb43d extends $c8bc0977b55afb3a$export$e6a97ba2cae5bb94 {
    slotIndex = 0;
    /** The attachment name for each key frame. May contain null values to clear the attachment. */ attachmentNames;
    constructor(frameCount, slotIndex){
        super(frameCount, [
            $c8bc0977b55afb3a$var$Property.attachment + "|" + slotIndex
        ]);
        this.slotIndex = slotIndex;
        this.attachmentNames = new Array(frameCount);
    }
    getFrameCount() {
        return this.frames.length;
    }
    /** Sets the time in seconds and the attachment name for the specified key frame. */ setFrame(frame, time, attachmentName) {
        this.frames[frame] = time;
        this.attachmentNames[frame] = attachmentName;
    }
    apply(skeleton, lastTime, time, events, alpha, blend, direction) {
        let slot = skeleton.slots[this.slotIndex];
        if (!slot.bone.active) return;
        if (direction == $c8bc0977b55afb3a$export$52fc338c0bb328ba.mixOut) {
            if (blend == $c8bc0977b55afb3a$export$ccab779a50275a35.setup) this.setAttachment(skeleton, slot, slot.data.attachmentName);
            return;
        }
        if (time < this.frames[0]) {
            if (blend == $c8bc0977b55afb3a$export$ccab779a50275a35.setup || blend == $c8bc0977b55afb3a$export$ccab779a50275a35.first) this.setAttachment(skeleton, slot, slot.data.attachmentName);
            return;
        }
        this.setAttachment(skeleton, slot, this.attachmentNames[$c8bc0977b55afb3a$export$e6a97ba2cae5bb94.search1(this.frames, time)]);
    }
    setAttachment(skeleton, slot, attachmentName) {
        slot.setAttachment(!attachmentName ? null : skeleton.getAttachment(this.slotIndex, attachmentName));
    }
}
class $c8bc0977b55afb3a$export$6968d40e5689ad6b extends $c8bc0977b55afb3a$export$4094e7414845f78f {
    slotIndex = 0;
    /** The attachment that will be deformed. */ attachment;
    /** The vertices for each key frame. */ vertices;
    constructor(frameCount, bezierCount, slotIndex, attachment){
        super(frameCount, bezierCount, [
            $c8bc0977b55afb3a$var$Property.deform + "|" + slotIndex + "|" + attachment.id
        ]);
        this.slotIndex = slotIndex;
        this.attachment = attachment;
        this.vertices = new Array(frameCount);
    }
    getFrameCount() {
        return this.frames.length;
    }
    /** Sets the time in seconds and the vertices for the specified key frame.
     * @param vertices Vertex positions for an unweighted VertexAttachment, or deform offsets if it has weights. */ setFrame(frame, time, vertices) {
        this.frames[frame] = time;
        this.vertices[frame] = vertices;
    }
    /** @param value1 Ignored (0 is used for a deform timeline).
     * @param value2 Ignored (1 is used for a deform timeline). */ setBezier(bezier, frame, value, time1, value1, cx1, cy1, cx2, cy2, time2, value2) {
        let curves = this.curves;
        let i = this.getFrameCount() + bezier * 18 /*BEZIER_SIZE*/ ;
        if (value == 0) curves[frame] = 2 /*BEZIER*/  + i;
        let tmpx = (time1 - cx1 * 2 + cx2) * 0.03, tmpy = cy2 * 0.03 - cy1 * 0.06;
        let dddx = ((cx1 - cx2) * 3 - time1 + time2) * 0.006, dddy = (cy1 - cy2 + 0.33333333) * 0.018;
        let ddx = tmpx * 2 + dddx, ddy = tmpy * 2 + dddy;
        let dx = (cx1 - time1) * 0.3 + tmpx + dddx * 0.16666667, dy = cy1 * 0.3 + tmpy + dddy * 0.16666667;
        let x = time1 + dx, y = dy;
        for(let n = i + 18 /*BEZIER_SIZE*/ ; i < n; i += 2){
            curves[i] = x;
            curves[i + 1] = y;
            dx += ddx;
            dy += ddy;
            ddx += dddx;
            ddy += dddy;
            x += dx;
            y += dy;
        }
    }
    getCurvePercent(time, frame) {
        let curves = this.curves;
        let i = curves[frame];
        switch(i){
            case 0 /*LINEAR*/ :
                let x = this.frames[frame];
                return (time - x) / (this.frames[frame + this.getFrameEntries()] - x);
            case 1 /*STEPPED*/ :
                return 0;
        }
        i -= 2 /*BEZIER*/ ;
        if (curves[i] > time) {
            let x = this.frames[frame];
            return curves[i + 1] * (time - x) / (curves[i] - x);
        }
        let n = i + 18 /*BEZIER_SIZE*/ ;
        for(i += 2; i < n; i += 2)if (curves[i] >= time) {
            let x = curves[i - 2], y = curves[i - 1];
            return y + (time - x) / (curves[i] - x) * (curves[i + 1] - y);
        }
        let x1 = curves[n - 2], y = curves[n - 1];
        return y + (1 - y) * (time - x1) / (this.frames[frame + this.getFrameEntries()] - x1);
    }
    apply(skeleton, lastTime, time, firedEvents, alpha, blend, direction) {
        let slot = skeleton.slots[this.slotIndex];
        if (!slot.bone.active) return;
        let slotAttachment = slot.getAttachment();
        if (!slotAttachment) return;
        if (!(slotAttachment instanceof (0, $3c213aed73167a71$export$66d3a0c3be55e044)) || slotAttachment.timelineAttachment != this.attachment) return;
        let deform = slot.deform;
        if (deform.length == 0) blend = $c8bc0977b55afb3a$export$ccab779a50275a35.setup;
        let vertices = this.vertices;
        let vertexCount = vertices[0].length;
        let frames = this.frames;
        if (time < frames[0]) {
            switch(blend){
                case $c8bc0977b55afb3a$export$ccab779a50275a35.setup:
                    deform.length = 0;
                    return;
                case $c8bc0977b55afb3a$export$ccab779a50275a35.first:
                    if (alpha == 1) {
                        deform.length = 0;
                        return;
                    }
                    deform.length = vertexCount;
                    let vertexAttachment = slotAttachment;
                    if (!vertexAttachment.bones) {
                        // Unweighted vertex positions.
                        let setupVertices = vertexAttachment.vertices;
                        for(var i = 0; i < vertexCount; i++)deform[i] += (setupVertices[i] - deform[i]) * alpha;
                    } else {
                        // Weighted deform offsets.
                        alpha = 1 - alpha;
                        for(var i = 0; i < vertexCount; i++)deform[i] *= alpha;
                    }
            }
            return;
        }
        deform.length = vertexCount;
        if (time >= frames[frames.length - 1]) {
            let lastVertices = vertices[frames.length - 1];
            if (alpha == 1) {
                if (blend == $c8bc0977b55afb3a$export$ccab779a50275a35.add) {
                    let vertexAttachment = slotAttachment;
                    if (!vertexAttachment.bones) {
                        // Unweighted vertex positions, with alpha.
                        let setupVertices = vertexAttachment.vertices;
                        for(let i = 0; i < vertexCount; i++)deform[i] += lastVertices[i] - setupVertices[i];
                    } else // Weighted deform offsets, with alpha.
                    for(let i = 0; i < vertexCount; i++)deform[i] += lastVertices[i];
                } else (0, $1702fa998ec22e58$export$d2ca453b913dcdea).arrayCopy(lastVertices, 0, deform, 0, vertexCount);
            } else switch(blend){
                case $c8bc0977b55afb3a$export$ccab779a50275a35.setup:
                    {
                        let vertexAttachment = slotAttachment;
                        if (!vertexAttachment.bones) {
                            // Unweighted vertex positions, with alpha.
                            let setupVertices = vertexAttachment.vertices;
                            for(let i = 0; i < vertexCount; i++){
                                let setup = setupVertices[i];
                                deform[i] = setup + (lastVertices[i] - setup) * alpha;
                            }
                        } else // Weighted deform offsets, with alpha.
                        for(let i = 0; i < vertexCount; i++)deform[i] = lastVertices[i] * alpha;
                        break;
                    }
                case $c8bc0977b55afb3a$export$ccab779a50275a35.first:
                case $c8bc0977b55afb3a$export$ccab779a50275a35.replace:
                    for(let i = 0; i < vertexCount; i++)deform[i] += (lastVertices[i] - deform[i]) * alpha;
                    break;
                case $c8bc0977b55afb3a$export$ccab779a50275a35.add:
                    let vertexAttachment = slotAttachment;
                    if (!vertexAttachment.bones) {
                        // Unweighted vertex positions, with alpha.
                        let setupVertices = vertexAttachment.vertices;
                        for(let i = 0; i < vertexCount; i++)deform[i] += (lastVertices[i] - setupVertices[i]) * alpha;
                    } else // Weighted deform offsets, with alpha.
                    for(let i = 0; i < vertexCount; i++)deform[i] += lastVertices[i] * alpha;
            }
            return;
        }
        // Interpolate between the previous frame and the current frame.
        let frame = $c8bc0977b55afb3a$export$e6a97ba2cae5bb94.search1(frames, time);
        let percent = this.getCurvePercent(time, frame);
        let prevVertices = vertices[frame];
        let nextVertices = vertices[frame + 1];
        if (alpha == 1) {
            if (blend == $c8bc0977b55afb3a$export$ccab779a50275a35.add) {
                let vertexAttachment = slotAttachment;
                if (!vertexAttachment.bones) {
                    // Unweighted vertex positions, with alpha.
                    let setupVertices = vertexAttachment.vertices;
                    for(let i = 0; i < vertexCount; i++){
                        let prev = prevVertices[i];
                        deform[i] += prev + (nextVertices[i] - prev) * percent - setupVertices[i];
                    }
                } else // Weighted deform offsets, with alpha.
                for(let i = 0; i < vertexCount; i++){
                    let prev = prevVertices[i];
                    deform[i] += prev + (nextVertices[i] - prev) * percent;
                }
            } else for(let i = 0; i < vertexCount; i++){
                let prev = prevVertices[i];
                deform[i] = prev + (nextVertices[i] - prev) * percent;
            }
        } else switch(blend){
            case $c8bc0977b55afb3a$export$ccab779a50275a35.setup:
                {
                    let vertexAttachment = slotAttachment;
                    if (!vertexAttachment.bones) {
                        // Unweighted vertex positions, with alpha.
                        let setupVertices = vertexAttachment.vertices;
                        for(let i = 0; i < vertexCount; i++){
                            let prev = prevVertices[i], setup = setupVertices[i];
                            deform[i] = setup + (prev + (nextVertices[i] - prev) * percent - setup) * alpha;
                        }
                    } else // Weighted deform offsets, with alpha.
                    for(let i = 0; i < vertexCount; i++){
                        let prev = prevVertices[i];
                        deform[i] = (prev + (nextVertices[i] - prev) * percent) * alpha;
                    }
                    break;
                }
            case $c8bc0977b55afb3a$export$ccab779a50275a35.first:
            case $c8bc0977b55afb3a$export$ccab779a50275a35.replace:
                for(let i = 0; i < vertexCount; i++){
                    let prev = prevVertices[i];
                    deform[i] += (prev + (nextVertices[i] - prev) * percent - deform[i]) * alpha;
                }
                break;
            case $c8bc0977b55afb3a$export$ccab779a50275a35.add:
                let vertexAttachment = slotAttachment;
                if (!vertexAttachment.bones) {
                    // Unweighted vertex positions, with alpha.
                    let setupVertices = vertexAttachment.vertices;
                    for(let i = 0; i < vertexCount; i++){
                        let prev = prevVertices[i];
                        deform[i] += (prev + (nextVertices[i] - prev) * percent - setupVertices[i]) * alpha;
                    }
                } else // Weighted deform offsets, with alpha.
                for(let i = 0; i < vertexCount; i++){
                    let prev = prevVertices[i];
                    deform[i] += (prev + (nextVertices[i] - prev) * percent) * alpha;
                }
        }
    }
}
class $c8bc0977b55afb3a$export$4f4bca996c586084 extends $c8bc0977b55afb3a$export$e6a97ba2cae5bb94 {
    static propertyIds = [
        "" + $c8bc0977b55afb3a$var$Property.event
    ];
    /** The event for each key frame. */ events;
    constructor(frameCount){
        super(frameCount, $c8bc0977b55afb3a$export$4f4bca996c586084.propertyIds);
        this.events = new Array(frameCount);
    }
    getFrameCount() {
        return this.frames.length;
    }
    /** Sets the time in seconds and the event for the specified key frame. */ setFrame(frame, event) {
        this.frames[frame] = event.time;
        this.events[frame] = event;
    }
    /** Fires events for frames > `lastTime` and <= `time`. */ apply(skeleton, lastTime, time, firedEvents, alpha, blend, direction) {
        if (!firedEvents) return;
        let frames = this.frames;
        let frameCount = this.frames.length;
        if (lastTime > time) {
            this.apply(skeleton, lastTime, Number.MAX_VALUE, firedEvents, alpha, blend, direction);
            lastTime = -1;
        } else if (lastTime >= frames[frameCount - 1]) return;
        if (time < frames[0]) return; // Time is before first frame.
        let i = 0;
        if (lastTime < frames[0]) i = 0;
        else {
            i = $c8bc0977b55afb3a$export$e6a97ba2cae5bb94.search1(frames, lastTime) + 1;
            let frameTime = frames[i];
            while(i > 0){
                if (frames[i - 1] != frameTime) break;
                i--;
            }
        }
        for(; i < frameCount && time >= frames[i]; i++)firedEvents.push(this.events[i]);
    }
}
class $c8bc0977b55afb3a$export$ece1f7c41d051e83 extends $c8bc0977b55afb3a$export$e6a97ba2cae5bb94 {
    static propertyIds = [
        "" + $c8bc0977b55afb3a$var$Property.drawOrder
    ];
    /** The draw order for each key frame. See {@link #setFrame(int, float, int[])}. */ drawOrders;
    constructor(frameCount){
        super(frameCount, $c8bc0977b55afb3a$export$ece1f7c41d051e83.propertyIds);
        this.drawOrders = new Array(frameCount);
    }
    getFrameCount() {
        return this.frames.length;
    }
    /** Sets the time in seconds and the draw order for the specified key frame.
     * @param drawOrder For each slot in {@link Skeleton#slots}, the index of the new draw order. May be null to use setup pose
     *           draw order. */ setFrame(frame, time, drawOrder) {
        this.frames[frame] = time;
        this.drawOrders[frame] = drawOrder;
    }
    apply(skeleton, lastTime, time, firedEvents, alpha, blend, direction) {
        if (direction == $c8bc0977b55afb3a$export$52fc338c0bb328ba.mixOut) {
            if (blend == $c8bc0977b55afb3a$export$ccab779a50275a35.setup) (0, $1702fa998ec22e58$export$d2ca453b913dcdea).arrayCopy(skeleton.slots, 0, skeleton.drawOrder, 0, skeleton.slots.length);
            return;
        }
        if (time < this.frames[0]) {
            if (blend == $c8bc0977b55afb3a$export$ccab779a50275a35.setup || blend == $c8bc0977b55afb3a$export$ccab779a50275a35.first) (0, $1702fa998ec22e58$export$d2ca453b913dcdea).arrayCopy(skeleton.slots, 0, skeleton.drawOrder, 0, skeleton.slots.length);
            return;
        }
        let idx = $c8bc0977b55afb3a$export$e6a97ba2cae5bb94.search1(this.frames, time);
        let drawOrderToSetupIndex = this.drawOrders[idx];
        if (!drawOrderToSetupIndex) (0, $1702fa998ec22e58$export$d2ca453b913dcdea).arrayCopy(skeleton.slots, 0, skeleton.drawOrder, 0, skeleton.slots.length);
        else {
            let drawOrder = skeleton.drawOrder;
            let slots = skeleton.slots;
            for(let i = 0, n = drawOrderToSetupIndex.length; i < n; i++)drawOrder[i] = slots[drawOrderToSetupIndex[i]];
        }
    }
}
class $c8bc0977b55afb3a$export$73d125cd89dead44 extends $c8bc0977b55afb3a$export$4094e7414845f78f {
    /** The index of the IK constraint slot in {@link Skeleton#ikConstraints} that will be changed. */ ikConstraintIndex = 0;
    constructor(frameCount, bezierCount, ikConstraintIndex){
        super(frameCount, bezierCount, [
            $c8bc0977b55afb3a$var$Property.ikConstraint + "|" + ikConstraintIndex
        ]);
        this.ikConstraintIndex = ikConstraintIndex;
    }
    getFrameEntries() {
        return 6 /*ENTRIES*/ ;
    }
    /** Sets the time in seconds, mix, softness, bend direction, compress, and stretch for the specified key frame. */ setFrame(frame, time, mix, softness, bendDirection, compress, stretch) {
        frame *= 6 /*ENTRIES*/ ;
        this.frames[frame] = time;
        this.frames[frame + 1 /*MIX*/ ] = mix;
        this.frames[frame + 2 /*SOFTNESS*/ ] = softness;
        this.frames[frame + 3 /*BEND_DIRECTION*/ ] = bendDirection;
        this.frames[frame + 4 /*COMPRESS*/ ] = compress ? 1 : 0;
        this.frames[frame + 5 /*STRETCH*/ ] = stretch ? 1 : 0;
    }
    apply(skeleton, lastTime, time, firedEvents, alpha, blend, direction) {
        let constraint = skeleton.ikConstraints[this.ikConstraintIndex];
        if (!constraint.active) return;
        let frames = this.frames;
        if (time < frames[0]) {
            switch(blend){
                case $c8bc0977b55afb3a$export$ccab779a50275a35.setup:
                    constraint.mix = constraint.data.mix;
                    constraint.softness = constraint.data.softness;
                    constraint.bendDirection = constraint.data.bendDirection;
                    constraint.compress = constraint.data.compress;
                    constraint.stretch = constraint.data.stretch;
                    return;
                case $c8bc0977b55afb3a$export$ccab779a50275a35.first:
                    constraint.mix += (constraint.data.mix - constraint.mix) * alpha;
                    constraint.softness += (constraint.data.softness - constraint.softness) * alpha;
                    constraint.bendDirection = constraint.data.bendDirection;
                    constraint.compress = constraint.data.compress;
                    constraint.stretch = constraint.data.stretch;
            }
            return;
        }
        let mix = 0, softness = 0;
        let i = $c8bc0977b55afb3a$export$e6a97ba2cae5bb94.search(frames, time, 6 /*ENTRIES*/ );
        let curveType = this.curves[i / 6 /*ENTRIES*/ ];
        switch(curveType){
            case 0 /*LINEAR*/ :
                let before = frames[i];
                mix = frames[i + 1 /*MIX*/ ];
                softness = frames[i + 2 /*SOFTNESS*/ ];
                let t = (time - before) / (frames[i + 6 /*ENTRIES*/ ] - before);
                mix += (frames[i + 6 /*ENTRIES*/  + 1 /*MIX*/ ] - mix) * t;
                softness += (frames[i + 6 /*ENTRIES*/  + 2 /*SOFTNESS*/ ] - softness) * t;
                break;
            case 1 /*STEPPED*/ :
                mix = frames[i + 1 /*MIX*/ ];
                softness = frames[i + 2 /*SOFTNESS*/ ];
                break;
            default:
                mix = this.getBezierValue(time, i, 1 /*MIX*/ , curveType - 2 /*BEZIER*/ );
                softness = this.getBezierValue(time, i, 2 /*SOFTNESS*/ , curveType + 18 /*BEZIER_SIZE*/  - 2 /*BEZIER*/ );
        }
        if (blend == $c8bc0977b55afb3a$export$ccab779a50275a35.setup) {
            constraint.mix = constraint.data.mix + (mix - constraint.data.mix) * alpha;
            constraint.softness = constraint.data.softness + (softness - constraint.data.softness) * alpha;
            if (direction == $c8bc0977b55afb3a$export$52fc338c0bb328ba.mixOut) {
                constraint.bendDirection = constraint.data.bendDirection;
                constraint.compress = constraint.data.compress;
                constraint.stretch = constraint.data.stretch;
            } else {
                constraint.bendDirection = frames[i + 3 /*BEND_DIRECTION*/ ];
                constraint.compress = frames[i + 4 /*COMPRESS*/ ] != 0;
                constraint.stretch = frames[i + 5 /*STRETCH*/ ] != 0;
            }
        } else {
            constraint.mix += (mix - constraint.mix) * alpha;
            constraint.softness += (softness - constraint.softness) * alpha;
            if (direction == $c8bc0977b55afb3a$export$52fc338c0bb328ba.mixIn) {
                constraint.bendDirection = frames[i + 3 /*BEND_DIRECTION*/ ];
                constraint.compress = frames[i + 4 /*COMPRESS*/ ] != 0;
                constraint.stretch = frames[i + 5 /*STRETCH*/ ] != 0;
            }
        }
    }
}
class $c8bc0977b55afb3a$export$a7a393c2ad815ac7 extends $c8bc0977b55afb3a$export$4094e7414845f78f {
    /** The index of the transform constraint slot in {@link Skeleton#transformConstraints} that will be changed. */ transformConstraintIndex = 0;
    constructor(frameCount, bezierCount, transformConstraintIndex){
        super(frameCount, bezierCount, [
            $c8bc0977b55afb3a$var$Property.transformConstraint + "|" + transformConstraintIndex
        ]);
        this.transformConstraintIndex = transformConstraintIndex;
    }
    getFrameEntries() {
        return 7 /*ENTRIES*/ ;
    }
    /** The time in seconds, rotate mix, translate mix, scale mix, and shear mix for the specified key frame. */ setFrame(frame, time, mixRotate, mixX, mixY, mixScaleX, mixScaleY, mixShearY) {
        let frames = this.frames;
        frame *= 7 /*ENTRIES*/ ;
        frames[frame] = time;
        frames[frame + 1 /*ROTATE*/ ] = mixRotate;
        frames[frame + 2 /*X*/ ] = mixX;
        frames[frame + 3 /*Y*/ ] = mixY;
        frames[frame + 4 /*SCALEX*/ ] = mixScaleX;
        frames[frame + 5 /*SCALEY*/ ] = mixScaleY;
        frames[frame + 6 /*SHEARY*/ ] = mixShearY;
    }
    apply(skeleton, lastTime, time, firedEvents, alpha, blend, direction) {
        let constraint = skeleton.transformConstraints[this.transformConstraintIndex];
        if (!constraint.active) return;
        let frames = this.frames;
        if (time < frames[0]) {
            let data = constraint.data;
            switch(blend){
                case $c8bc0977b55afb3a$export$ccab779a50275a35.setup:
                    constraint.mixRotate = data.mixRotate;
                    constraint.mixX = data.mixX;
                    constraint.mixY = data.mixY;
                    constraint.mixScaleX = data.mixScaleX;
                    constraint.mixScaleY = data.mixScaleY;
                    constraint.mixShearY = data.mixShearY;
                    return;
                case $c8bc0977b55afb3a$export$ccab779a50275a35.first:
                    constraint.mixRotate += (data.mixRotate - constraint.mixRotate) * alpha;
                    constraint.mixX += (data.mixX - constraint.mixX) * alpha;
                    constraint.mixY += (data.mixY - constraint.mixY) * alpha;
                    constraint.mixScaleX += (data.mixScaleX - constraint.mixScaleX) * alpha;
                    constraint.mixScaleY += (data.mixScaleY - constraint.mixScaleY) * alpha;
                    constraint.mixShearY += (data.mixShearY - constraint.mixShearY) * alpha;
            }
            return;
        }
        let rotate, x, y, scaleX, scaleY, shearY;
        let i = $c8bc0977b55afb3a$export$e6a97ba2cae5bb94.search(frames, time, 7 /*ENTRIES*/ );
        let curveType = this.curves[i / 7 /*ENTRIES*/ ];
        switch(curveType){
            case 0 /*LINEAR*/ :
                let before = frames[i];
                rotate = frames[i + 1 /*ROTATE*/ ];
                x = frames[i + 2 /*X*/ ];
                y = frames[i + 3 /*Y*/ ];
                scaleX = frames[i + 4 /*SCALEX*/ ];
                scaleY = frames[i + 5 /*SCALEY*/ ];
                shearY = frames[i + 6 /*SHEARY*/ ];
                let t = (time - before) / (frames[i + 7 /*ENTRIES*/ ] - before);
                rotate += (frames[i + 7 /*ENTRIES*/  + 1 /*ROTATE*/ ] - rotate) * t;
                x += (frames[i + 7 /*ENTRIES*/  + 2 /*X*/ ] - x) * t;
                y += (frames[i + 7 /*ENTRIES*/  + 3 /*Y*/ ] - y) * t;
                scaleX += (frames[i + 7 /*ENTRIES*/  + 4 /*SCALEX*/ ] - scaleX) * t;
                scaleY += (frames[i + 7 /*ENTRIES*/  + 5 /*SCALEY*/ ] - scaleY) * t;
                shearY += (frames[i + 7 /*ENTRIES*/  + 6 /*SHEARY*/ ] - shearY) * t;
                break;
            case 1 /*STEPPED*/ :
                rotate = frames[i + 1 /*ROTATE*/ ];
                x = frames[i + 2 /*X*/ ];
                y = frames[i + 3 /*Y*/ ];
                scaleX = frames[i + 4 /*SCALEX*/ ];
                scaleY = frames[i + 5 /*SCALEY*/ ];
                shearY = frames[i + 6 /*SHEARY*/ ];
                break;
            default:
                rotate = this.getBezierValue(time, i, 1 /*ROTATE*/ , curveType - 2 /*BEZIER*/ );
                x = this.getBezierValue(time, i, 2 /*X*/ , curveType + 18 /*BEZIER_SIZE*/  - 2 /*BEZIER*/ );
                y = this.getBezierValue(time, i, 3 /*Y*/ , curveType + 36 - 2 /*BEZIER*/ );
                scaleX = this.getBezierValue(time, i, 4 /*SCALEX*/ , curveType + 54 - 2 /*BEZIER*/ );
                scaleY = this.getBezierValue(time, i, 5 /*SCALEY*/ , curveType + 72 - 2 /*BEZIER*/ );
                shearY = this.getBezierValue(time, i, 6 /*SHEARY*/ , curveType + 90 - 2 /*BEZIER*/ );
        }
        if (blend == $c8bc0977b55afb3a$export$ccab779a50275a35.setup) {
            let data = constraint.data;
            constraint.mixRotate = data.mixRotate + (rotate - data.mixRotate) * alpha;
            constraint.mixX = data.mixX + (x - data.mixX) * alpha;
            constraint.mixY = data.mixY + (y - data.mixY) * alpha;
            constraint.mixScaleX = data.mixScaleX + (scaleX - data.mixScaleX) * alpha;
            constraint.mixScaleY = data.mixScaleY + (scaleY - data.mixScaleY) * alpha;
            constraint.mixShearY = data.mixShearY + (shearY - data.mixShearY) * alpha;
        } else {
            constraint.mixRotate += (rotate - constraint.mixRotate) * alpha;
            constraint.mixX += (x - constraint.mixX) * alpha;
            constraint.mixY += (y - constraint.mixY) * alpha;
            constraint.mixScaleX += (scaleX - constraint.mixScaleX) * alpha;
            constraint.mixScaleY += (scaleY - constraint.mixScaleY) * alpha;
            constraint.mixShearY += (shearY - constraint.mixShearY) * alpha;
        }
    }
}
class $c8bc0977b55afb3a$export$7ce7e67fd9cc52ed extends $c8bc0977b55afb3a$export$ea4b0b6c1bc191c5 {
    /** The index of the path constraint slot in {@link Skeleton#pathConstraints} that will be changed. */ pathConstraintIndex = 0;
    constructor(frameCount, bezierCount, pathConstraintIndex){
        super(frameCount, bezierCount, $c8bc0977b55afb3a$var$Property.pathConstraintPosition + "|" + pathConstraintIndex);
        this.pathConstraintIndex = pathConstraintIndex;
    }
    apply(skeleton, lastTime, time, firedEvents, alpha, blend, direction) {
        let constraint = skeleton.pathConstraints[this.pathConstraintIndex];
        if (!constraint.active) return;
        let frames = this.frames;
        if (time < frames[0]) {
            switch(blend){
                case $c8bc0977b55afb3a$export$ccab779a50275a35.setup:
                    constraint.position = constraint.data.position;
                    return;
                case $c8bc0977b55afb3a$export$ccab779a50275a35.first:
                    constraint.position += (constraint.data.position - constraint.position) * alpha;
            }
            return;
        }
        let position = this.getCurveValue(time);
        if (blend == $c8bc0977b55afb3a$export$ccab779a50275a35.setup) constraint.position = constraint.data.position + (position - constraint.data.position) * alpha;
        else constraint.position += (position - constraint.position) * alpha;
    }
}
class $c8bc0977b55afb3a$export$17ee50c08a07e62b extends $c8bc0977b55afb3a$export$ea4b0b6c1bc191c5 {
    /** The index of the path constraint slot in {@link Skeleton#getPathConstraints()} that will be changed. */ pathConstraintIndex = 0;
    constructor(frameCount, bezierCount, pathConstraintIndex){
        super(frameCount, bezierCount, $c8bc0977b55afb3a$var$Property.pathConstraintSpacing + "|" + pathConstraintIndex);
        this.pathConstraintIndex = pathConstraintIndex;
    }
    apply(skeleton, lastTime, time, firedEvents, alpha, blend, direction) {
        let constraint = skeleton.pathConstraints[this.pathConstraintIndex];
        if (!constraint.active) return;
        let frames = this.frames;
        if (time < frames[0]) {
            switch(blend){
                case $c8bc0977b55afb3a$export$ccab779a50275a35.setup:
                    constraint.spacing = constraint.data.spacing;
                    return;
                case $c8bc0977b55afb3a$export$ccab779a50275a35.first:
                    constraint.spacing += (constraint.data.spacing - constraint.spacing) * alpha;
            }
            return;
        }
        let spacing = this.getCurveValue(time);
        if (blend == $c8bc0977b55afb3a$export$ccab779a50275a35.setup) constraint.spacing = constraint.data.spacing + (spacing - constraint.data.spacing) * alpha;
        else constraint.spacing += (spacing - constraint.spacing) * alpha;
    }
}
class $c8bc0977b55afb3a$export$ea67b41755485038 extends $c8bc0977b55afb3a$export$4094e7414845f78f {
    /** The index of the path constraint slot in {@link Skeleton#getPathConstraints()} that will be changed. */ pathConstraintIndex = 0;
    constructor(frameCount, bezierCount, pathConstraintIndex){
        super(frameCount, bezierCount, [
            $c8bc0977b55afb3a$var$Property.pathConstraintMix + "|" + pathConstraintIndex
        ]);
        this.pathConstraintIndex = pathConstraintIndex;
    }
    getFrameEntries() {
        return 4 /*ENTRIES*/ ;
    }
    setFrame(frame, time, mixRotate, mixX, mixY) {
        let frames = this.frames;
        frame <<= 2;
        frames[frame] = time;
        frames[frame + 1 /*ROTATE*/ ] = mixRotate;
        frames[frame + 2 /*X*/ ] = mixX;
        frames[frame + 3 /*Y*/ ] = mixY;
    }
    apply(skeleton, lastTime, time, firedEvents, alpha, blend, direction) {
        let constraint = skeleton.pathConstraints[this.pathConstraintIndex];
        if (!constraint.active) return;
        let frames = this.frames;
        if (time < frames[0]) {
            switch(blend){
                case $c8bc0977b55afb3a$export$ccab779a50275a35.setup:
                    constraint.mixRotate = constraint.data.mixRotate;
                    constraint.mixX = constraint.data.mixX;
                    constraint.mixY = constraint.data.mixY;
                    return;
                case $c8bc0977b55afb3a$export$ccab779a50275a35.first:
                    constraint.mixRotate += (constraint.data.mixRotate - constraint.mixRotate) * alpha;
                    constraint.mixX += (constraint.data.mixX - constraint.mixX) * alpha;
                    constraint.mixY += (constraint.data.mixY - constraint.mixY) * alpha;
            }
            return;
        }
        let rotate, x, y;
        let i = $c8bc0977b55afb3a$export$e6a97ba2cae5bb94.search(frames, time, 4 /*ENTRIES*/ );
        let curveType = this.curves[i >> 2];
        switch(curveType){
            case 0 /*LINEAR*/ :
                let before = frames[i];
                rotate = frames[i + 1 /*ROTATE*/ ];
                x = frames[i + 2 /*X*/ ];
                y = frames[i + 3 /*Y*/ ];
                let t = (time - before) / (frames[i + 4 /*ENTRIES*/ ] - before);
                rotate += (frames[i + 4 /*ENTRIES*/  + 1 /*ROTATE*/ ] - rotate) * t;
                x += (frames[i + 4 /*ENTRIES*/  + 2 /*X*/ ] - x) * t;
                y += (frames[i + 4 /*ENTRIES*/  + 3 /*Y*/ ] - y) * t;
                break;
            case 1 /*STEPPED*/ :
                rotate = frames[i + 1 /*ROTATE*/ ];
                x = frames[i + 2 /*X*/ ];
                y = frames[i + 3 /*Y*/ ];
                break;
            default:
                rotate = this.getBezierValue(time, i, 1 /*ROTATE*/ , curveType - 2 /*BEZIER*/ );
                x = this.getBezierValue(time, i, 2 /*X*/ , curveType + 18 /*BEZIER_SIZE*/  - 2 /*BEZIER*/ );
                y = this.getBezierValue(time, i, 3 /*Y*/ , curveType + 36 - 2 /*BEZIER*/ );
        }
        if (blend == $c8bc0977b55afb3a$export$ccab779a50275a35.setup) {
            let data = constraint.data;
            constraint.mixRotate = data.mixRotate + (rotate - data.mixRotate) * alpha;
            constraint.mixX = data.mixX + (x - data.mixX) * alpha;
            constraint.mixY = data.mixY + (y - data.mixY) * alpha;
        } else {
            constraint.mixRotate += (rotate - constraint.mixRotate) * alpha;
            constraint.mixX += (x - constraint.mixX) * alpha;
            constraint.mixY += (y - constraint.mixY) * alpha;
        }
    }
}
class $c8bc0977b55afb3a$export$2687f324e8496672 extends $c8bc0977b55afb3a$export$e6a97ba2cae5bb94 {
    static ENTRIES = 3;
    static MODE = 1;
    static DELAY = 2;
    slotIndex;
    attachment;
    constructor(frameCount, slotIndex, attachment){
        super(frameCount, [
            $c8bc0977b55afb3a$var$Property.sequence + "|" + slotIndex + "|" + attachment.sequence.id
        ]);
        this.slotIndex = slotIndex;
        this.attachment = attachment;
    }
    getFrameEntries() {
        return $c8bc0977b55afb3a$export$2687f324e8496672.ENTRIES;
    }
    getSlotIndex() {
        return this.slotIndex;
    }
    getAttachment() {
        return this.attachment;
    }
    /** Sets the time, mode, index, and frame time for the specified frame.
     * @param frame Between 0 and <code>frameCount</code>, inclusive.
     * @param time Seconds between frames. */ setFrame(frame, time, mode, index, delay) {
        let frames = this.frames;
        frame *= $c8bc0977b55afb3a$export$2687f324e8496672.ENTRIES;
        frames[frame] = time;
        frames[frame + $c8bc0977b55afb3a$export$2687f324e8496672.MODE] = mode | index << 4;
        frames[frame + $c8bc0977b55afb3a$export$2687f324e8496672.DELAY] = delay;
    }
    apply(skeleton, lastTime, time, events, alpha, blend, direction) {
        let slot = skeleton.slots[this.slotIndex];
        if (!slot.bone.active) return;
        let slotAttachment = slot.attachment;
        let attachment = this.attachment;
        if (slotAttachment != attachment) {
            if (!(slotAttachment instanceof (0, $3c213aed73167a71$export$66d3a0c3be55e044)) || slotAttachment.timelineAttachment != attachment) return;
        }
        let frames = this.frames;
        if (time < frames[0]) {
            if (blend == $c8bc0977b55afb3a$export$ccab779a50275a35.setup || blend == $c8bc0977b55afb3a$export$ccab779a50275a35.first) slot.sequenceIndex = -1;
            return;
        }
        let i = $c8bc0977b55afb3a$export$e6a97ba2cae5bb94.search(frames, time, $c8bc0977b55afb3a$export$2687f324e8496672.ENTRIES);
        let before = frames[i];
        let modeAndIndex = frames[i + $c8bc0977b55afb3a$export$2687f324e8496672.MODE];
        let delay = frames[i + $c8bc0977b55afb3a$export$2687f324e8496672.DELAY];
        if (!this.attachment.sequence) return;
        let index = modeAndIndex >> 4, count = this.attachment.sequence.regions.length;
        let mode = (0, $1bc73da5d49cda90$export$3d518da8d966a9f5)[modeAndIndex & 0xf];
        if (mode != (0, $1bc73da5d49cda90$export$2d839466c6120eb9).hold) {
            index += (time - before) / delay + 0.00001 | 0;
            switch(mode){
                case (0, $1bc73da5d49cda90$export$2d839466c6120eb9).once:
                    index = Math.min(count - 1, index);
                    break;
                case (0, $1bc73da5d49cda90$export$2d839466c6120eb9).loop:
                    index %= count;
                    break;
                case (0, $1bc73da5d49cda90$export$2d839466c6120eb9).pingpong:
                    {
                        let n = (count << 1) - 2;
                        index = n == 0 ? 0 : index % n;
                        if (index >= count) index = n - index;
                        break;
                    }
                case (0, $1bc73da5d49cda90$export$2d839466c6120eb9).onceReverse:
                    index = Math.max(count - 1 - index, 0);
                    break;
                case (0, $1bc73da5d49cda90$export$2d839466c6120eb9).loopReverse:
                    index = count - 1 - index % count;
                    break;
                case (0, $1bc73da5d49cda90$export$2d839466c6120eb9).pingpongReverse:
                    {
                        let n = (count << 1) - 2;
                        index = n == 0 ? 0 : (index + count - 1) % n;
                        if (index >= count) index = n - index;
                    }
            }
        }
        slot.sequenceIndex = index;
    }
}


/******************************************************************************
 * Spine Runtimes License Agreement
 * Last updated July 28, 2023. Replaces all prior versions.
 *
 * Copyright (c) 2013-2023, Esoteric Software LLC
 *
 * Integration of the Spine Runtimes into software or otherwise creating
 * derivative works of the Spine Runtimes is permitted under the terms and
 * conditions of Section 2 of the Spine Editor License Agreement:
 * http://esotericsoftware.com/spine-editor-license
 *
 * Otherwise, it is permitted to integrate the Spine Runtimes into software or
 * otherwise create derivative works of the Spine Runtimes (collectively,
 * "Products"), provided that each user of the Products must obtain their own
 * Spine Editor license and redistribution of the Products in any form must
 * include this license and copyright notice.
 *
 * THE SPINE RUNTIMES ARE PROVIDED BY ESOTERIC SOFTWARE LLC "AS IS" AND ANY
 * EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
 * WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE
 * DISCLAIMED. IN NO EVENT SHALL ESOTERIC SOFTWARE LLC BE LIABLE FOR ANY
 * DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES
 * (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES,
 * BUSINESS INTERRUPTION, OR LOSS OF USE, DATA, OR PROFITS) HOWEVER CAUSED AND
 * ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT
 * (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THE
 * SPINE RUNTIMES, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
 *****************************************************************************/ 

class $15bd7a75a398401c$export$d0f7a26c90cc1562 {
    static _emptyAnimation = new (0, $c8bc0977b55afb3a$export$c35d437ae5945fcd)("<empty>", [], 0);
    static emptyAnimation() {
        return $15bd7a75a398401c$export$d0f7a26c90cc1562._emptyAnimation;
    }
    /** The AnimationStateData to look up mix durations. */ data;
    /** The list of tracks that currently have animations, which may contain null entries. */ tracks = new Array();
    /** Multiplier for the delta time when the animation state is updated, causing time for all animations and mixes to play slower
     * or faster. Defaults to 1.
     *
     * See TrackEntry {@link TrackEntry#timeScale} for affecting a single animation. */ timeScale = 1;
    unkeyedState = 0;
    events = new Array();
    listeners = new Array();
    queue = new $15bd7a75a398401c$export$2fc6338444a158e6(this);
    propertyIDs = new (0, $1702fa998ec22e58$export$1a41fd2ab8394c46)();
    animationsChanged = false;
    trackEntryPool = new (0, $1702fa998ec22e58$export$14963ee5c8637e11)(()=>new $15bd7a75a398401c$export$6fd48f25bc0ee658());
    constructor(data){
        this.data = data;
    }
    /** Increments each track entry {@link TrackEntry#trackTime()}, setting queued animations as current if needed. */ update(delta) {
        delta *= this.timeScale;
        let tracks = this.tracks;
        for(let i = 0, n = tracks.length; i < n; i++){
            let current = tracks[i];
            if (!current) continue;
            current.animationLast = current.nextAnimationLast;
            current.trackLast = current.nextTrackLast;
            let currentDelta = delta * current.timeScale;
            if (current.delay > 0) {
                current.delay -= currentDelta;
                if (current.delay > 0) continue;
                currentDelta = -current.delay;
                current.delay = 0;
            }
            let next = current.next;
            if (next) {
                // When the next entry's delay is passed, change to the next entry, preserving leftover time.
                let nextTime = current.trackLast - next.delay;
                if (nextTime >= 0) {
                    next.delay = 0;
                    next.trackTime += current.timeScale == 0 ? 0 : (nextTime / current.timeScale + delta) * next.timeScale;
                    current.trackTime += currentDelta;
                    this.setCurrent(i, next, true);
                    while(next.mixingFrom){
                        next.mixTime += delta;
                        next = next.mixingFrom;
                    }
                    continue;
                }
            } else if (current.trackLast >= current.trackEnd && !current.mixingFrom) {
                tracks[i] = null;
                this.queue.end(current);
                this.clearNext(current);
                continue;
            }
            if (current.mixingFrom && this.updateMixingFrom(current, delta)) {
                // End mixing from entries once all have completed.
                let from = current.mixingFrom;
                current.mixingFrom = null;
                if (from) from.mixingTo = null;
                while(from){
                    this.queue.end(from);
                    from = from.mixingFrom;
                }
            }
            current.trackTime += currentDelta;
        }
        this.queue.drain();
    }
    /** Returns true when all mixing from entries are complete. */ updateMixingFrom(to, delta) {
        let from = to.mixingFrom;
        if (!from) return true;
        let finished = this.updateMixingFrom(from, delta);
        from.animationLast = from.nextAnimationLast;
        from.trackLast = from.nextTrackLast;
        // Require mixTime > 0 to ensure the mixing from entry was applied at least once.
        if (to.mixTime > 0 && to.mixTime >= to.mixDuration) {
            // Require totalAlpha == 0 to ensure mixing is complete, unless mixDuration == 0 (the transition is a single frame).
            if (from.totalAlpha == 0 || to.mixDuration == 0) {
                to.mixingFrom = from.mixingFrom;
                if (from.mixingFrom) from.mixingFrom.mixingTo = to;
                to.interruptAlpha = from.interruptAlpha;
                this.queue.end(from);
            }
            return finished;
        }
        from.trackTime += delta * from.timeScale;
        to.mixTime += delta;
        return false;
    }
    /** Poses the skeleton using the track entry animations. There are no side effects other than invoking listeners, so the
     * animation state can be applied to multiple skeletons to pose them identically.
     * @returns True if any animations were applied. */ apply(skeleton) {
        if (!skeleton) throw new Error("skeleton cannot be null.");
        if (this.animationsChanged) this._animationsChanged();
        let events = this.events;
        let tracks = this.tracks;
        let applied = false;
        for(let i = 0, n = tracks.length; i < n; i++){
            let current = tracks[i];
            if (!current || current.delay > 0) continue;
            applied = true;
            let blend = i == 0 ? (0, $c8bc0977b55afb3a$export$ccab779a50275a35).first : current.mixBlend;
            // Apply mixing from entries first.
            let mix = current.alpha;
            if (current.mixingFrom) mix *= this.applyMixingFrom(current, skeleton, blend);
            else if (current.trackTime >= current.trackEnd && !current.next) mix = 0;
            // Apply current entry.
            let animationLast = current.animationLast, animationTime = current.getAnimationTime(), applyTime = animationTime;
            let applyEvents = events;
            if (current.reverse) {
                applyTime = current.animation.duration - applyTime;
                applyEvents = null;
            }
            let timelines = current.animation.timelines;
            let timelineCount = timelines.length;
            if (i == 0 && mix == 1 || blend == (0, $c8bc0977b55afb3a$export$ccab779a50275a35).add) for(let ii = 0; ii < timelineCount; ii++){
                // Fixes issue #302 on IOS9 where mix, blend sometimes became undefined and caused assets
                // to sometimes stop rendering when using color correction, as their RGBA values become NaN.
                // (https://github.com/pixijs/pixi-spine/issues/302)
                (0, $1702fa998ec22e58$export$d2ca453b913dcdea).webkit602BugfixHelper(mix, blend);
                var timeline = timelines[ii];
                if (timeline instanceof (0, $c8bc0977b55afb3a$export$7f2bfc5bd27cb43d)) this.applyAttachmentTimeline(timeline, skeleton, applyTime, blend, true);
                else timeline.apply(skeleton, animationLast, applyTime, applyEvents, mix, blend, (0, $c8bc0977b55afb3a$export$52fc338c0bb328ba).mixIn);
            }
            else {
                let timelineMode = current.timelineMode;
                let shortestRotation = current.shortestRotation;
                let firstFrame = !shortestRotation && current.timelinesRotation.length != timelineCount << 1;
                if (firstFrame) current.timelinesRotation.length = timelineCount << 1;
                for(let ii = 0; ii < timelineCount; ii++){
                    let timeline = timelines[ii];
                    let timelineBlend = timelineMode[ii] == $15bd7a75a398401c$export$89027c4cc247cc19 ? blend : (0, $c8bc0977b55afb3a$export$ccab779a50275a35).setup;
                    if (!shortestRotation && timeline instanceof (0, $c8bc0977b55afb3a$export$b7ecb8f68b3e130b)) this.applyRotateTimeline(timeline, skeleton, applyTime, mix, timelineBlend, current.timelinesRotation, ii << 1, firstFrame);
                    else if (timeline instanceof (0, $c8bc0977b55afb3a$export$7f2bfc5bd27cb43d)) this.applyAttachmentTimeline(timeline, skeleton, applyTime, blend, true);
                    else {
                        // This fixes the WebKit 602 specific issue described at http://esotericsoftware.com/forum/iOS-10-disappearing-graphics-10109
                        (0, $1702fa998ec22e58$export$d2ca453b913dcdea).webkit602BugfixHelper(mix, blend);
                        timeline.apply(skeleton, animationLast, applyTime, applyEvents, mix, timelineBlend, (0, $c8bc0977b55afb3a$export$52fc338c0bb328ba).mixIn);
                    }
                }
            }
            this.queueEvents(current, animationTime);
            events.length = 0;
            current.nextAnimationLast = animationTime;
            current.nextTrackLast = current.trackTime;
        }
        // Set slots attachments to the setup pose, if needed. This occurs if an animation that is mixing out sets attachments so
        // subsequent timelines see any deform, but the subsequent timelines don't set an attachment (eg they are also mixing out or
        // the time is before the first key).
        var setupState = this.unkeyedState + $15bd7a75a398401c$export$be88f4235204622a;
        var slots = skeleton.slots;
        for(var i = 0, n = skeleton.slots.length; i < n; i++){
            var slot = slots[i];
            if (slot.attachmentState == setupState) {
                var attachmentName = slot.data.attachmentName;
                slot.setAttachment(!attachmentName ? null : skeleton.getAttachment(slot.data.index, attachmentName));
            }
        }
        this.unkeyedState += 2; // Increasing after each use avoids the need to reset attachmentState for every slot.
        this.queue.drain();
        return applied;
    }
    applyMixingFrom(to, skeleton, blend) {
        let from = to.mixingFrom;
        if (from.mixingFrom) this.applyMixingFrom(from, skeleton, blend);
        let mix = 0;
        if (to.mixDuration == 0) {
            mix = 1;
            if (blend == (0, $c8bc0977b55afb3a$export$ccab779a50275a35).first) blend = (0, $c8bc0977b55afb3a$export$ccab779a50275a35).setup;
        } else {
            mix = to.mixTime / to.mixDuration;
            if (mix > 1) mix = 1;
            if (blend != (0, $c8bc0977b55afb3a$export$ccab779a50275a35).first) blend = from.mixBlend;
        }
        let attachments = mix < from.attachmentThreshold, drawOrder = mix < from.drawOrderThreshold;
        let timelines = from.animation.timelines;
        let timelineCount = timelines.length;
        let alphaHold = from.alpha * to.interruptAlpha, alphaMix = alphaHold * (1 - mix);
        let animationLast = from.animationLast, animationTime = from.getAnimationTime(), applyTime = animationTime;
        let events = null;
        if (from.reverse) applyTime = from.animation.duration - applyTime;
        else if (mix < from.eventThreshold) events = this.events;
        if (blend == (0, $c8bc0977b55afb3a$export$ccab779a50275a35).add) for(let i = 0; i < timelineCount; i++)timelines[i].apply(skeleton, animationLast, applyTime, events, alphaMix, blend, (0, $c8bc0977b55afb3a$export$52fc338c0bb328ba).mixOut);
        else {
            let timelineMode = from.timelineMode;
            let timelineHoldMix = from.timelineHoldMix;
            let shortestRotation = from.shortestRotation;
            let firstFrame = !shortestRotation && from.timelinesRotation.length != timelineCount << 1;
            if (firstFrame) from.timelinesRotation.length = timelineCount << 1;
            from.totalAlpha = 0;
            for(let i = 0; i < timelineCount; i++){
                let timeline = timelines[i];
                let direction = (0, $c8bc0977b55afb3a$export$52fc338c0bb328ba).mixOut;
                let timelineBlend;
                let alpha = 0;
                switch(timelineMode[i]){
                    case $15bd7a75a398401c$export$89027c4cc247cc19:
                        if (!drawOrder && timeline instanceof (0, $c8bc0977b55afb3a$export$ece1f7c41d051e83)) continue;
                        timelineBlend = blend;
                        alpha = alphaMix;
                        break;
                    case $15bd7a75a398401c$export$9f55c59c79ce7630:
                        timelineBlend = (0, $c8bc0977b55afb3a$export$ccab779a50275a35).setup;
                        alpha = alphaMix;
                        break;
                    case $15bd7a75a398401c$export$61db7ea55ff2bc4f:
                        timelineBlend = blend;
                        alpha = alphaHold;
                        break;
                    case $15bd7a75a398401c$export$83263fba6795a4f7:
                        timelineBlend = (0, $c8bc0977b55afb3a$export$ccab779a50275a35).setup;
                        alpha = alphaHold;
                        break;
                    default:
                        timelineBlend = (0, $c8bc0977b55afb3a$export$ccab779a50275a35).setup;
                        let holdMix = timelineHoldMix[i];
                        alpha = alphaHold * Math.max(0, 1 - holdMix.mixTime / holdMix.mixDuration);
                        break;
                }
                from.totalAlpha += alpha;
                if (!shortestRotation && timeline instanceof (0, $c8bc0977b55afb3a$export$b7ecb8f68b3e130b)) this.applyRotateTimeline(timeline, skeleton, applyTime, alpha, timelineBlend, from.timelinesRotation, i << 1, firstFrame);
                else if (timeline instanceof (0, $c8bc0977b55afb3a$export$7f2bfc5bd27cb43d)) this.applyAttachmentTimeline(timeline, skeleton, applyTime, timelineBlend, attachments);
                else {
                    // This fixes the WebKit 602 specific issue described at http://esotericsoftware.com/forum/iOS-10-disappearing-graphics-10109
                    (0, $1702fa998ec22e58$export$d2ca453b913dcdea).webkit602BugfixHelper(alpha, blend);
                    if (drawOrder && timeline instanceof (0, $c8bc0977b55afb3a$export$ece1f7c41d051e83) && timelineBlend == (0, $c8bc0977b55afb3a$export$ccab779a50275a35).setup) direction = (0, $c8bc0977b55afb3a$export$52fc338c0bb328ba).mixIn;
                    timeline.apply(skeleton, animationLast, applyTime, events, alpha, timelineBlend, direction);
                }
            }
        }
        if (to.mixDuration > 0) this.queueEvents(from, animationTime);
        this.events.length = 0;
        from.nextAnimationLast = animationTime;
        from.nextTrackLast = from.trackTime;
        return mix;
    }
    applyAttachmentTimeline(timeline, skeleton, time, blend, attachments) {
        var slot = skeleton.slots[timeline.slotIndex];
        if (!slot.bone.active) return;
        if (time < timeline.frames[0]) {
            if (blend == (0, $c8bc0977b55afb3a$export$ccab779a50275a35).setup || blend == (0, $c8bc0977b55afb3a$export$ccab779a50275a35).first) this.setAttachment(skeleton, slot, slot.data.attachmentName, attachments);
        } else this.setAttachment(skeleton, slot, timeline.attachmentNames[(0, $c8bc0977b55afb3a$export$e6a97ba2cae5bb94).search1(timeline.frames, time)], attachments);
        // If an attachment wasn't set (ie before the first frame or attachments is false), set the setup attachment later.
        if (slot.attachmentState <= this.unkeyedState) slot.attachmentState = this.unkeyedState + $15bd7a75a398401c$export$be88f4235204622a;
    }
    setAttachment(skeleton, slot, attachmentName, attachments) {
        slot.setAttachment(!attachmentName ? null : skeleton.getAttachment(slot.data.index, attachmentName));
        if (attachments) slot.attachmentState = this.unkeyedState + $15bd7a75a398401c$export$eed19b551669af14;
    }
    applyRotateTimeline(timeline, skeleton, time, alpha, blend, timelinesRotation, i, firstFrame) {
        if (firstFrame) timelinesRotation[i] = 0;
        if (alpha == 1) {
            timeline.apply(skeleton, 0, time, null, 1, blend, (0, $c8bc0977b55afb3a$export$52fc338c0bb328ba).mixIn);
            return;
        }
        let bone = skeleton.bones[timeline.boneIndex];
        if (!bone.active) return;
        let frames = timeline.frames;
        let r1 = 0, r2 = 0;
        if (time < frames[0]) switch(blend){
            case (0, $c8bc0977b55afb3a$export$ccab779a50275a35).setup:
                bone.rotation = bone.data.rotation;
            default:
                return;
            case (0, $c8bc0977b55afb3a$export$ccab779a50275a35).first:
                r1 = bone.rotation;
                r2 = bone.data.rotation;
        }
        else {
            r1 = blend == (0, $c8bc0977b55afb3a$export$ccab779a50275a35).setup ? bone.data.rotation : bone.rotation;
            r2 = bone.data.rotation + timeline.getCurveValue(time);
        }
        // Mix between rotations using the direction of the shortest route on the first frame while detecting crosses.
        let total = 0, diff = r2 - r1;
        diff -= (16384 - (16384.499999999996 - diff / 360 | 0)) * 360;
        if (diff == 0) total = timelinesRotation[i];
        else {
            let lastTotal = 0, lastDiff = 0;
            if (firstFrame) {
                lastTotal = 0;
                lastDiff = diff;
            } else {
                lastTotal = timelinesRotation[i];
                lastDiff = timelinesRotation[i + 1];
            }
            let loops = lastTotal - lastTotal % 360;
            total = diff + loops;
            let current = diff >= 0, dir = lastTotal >= 0;
            if (Math.abs(lastDiff) <= 90 && (0, $1702fa998ec22e58$export$6a7ef315a0d1ef07).signum(lastDiff) != (0, $1702fa998ec22e58$export$6a7ef315a0d1ef07).signum(diff)) {
                if (Math.abs(lastTotal - loops) > 180) {
                    total += 360 * (0, $1702fa998ec22e58$export$6a7ef315a0d1ef07).signum(lastTotal);
                    dir = current;
                } else if (loops != 0) total -= 360 * (0, $1702fa998ec22e58$export$6a7ef315a0d1ef07).signum(lastTotal);
                else dir = current;
            }
            if (dir != current) total += 360 * (0, $1702fa998ec22e58$export$6a7ef315a0d1ef07).signum(lastTotal);
            timelinesRotation[i] = total;
        }
        timelinesRotation[i + 1] = diff;
        bone.rotation = r1 + total * alpha;
    }
    queueEvents(entry, animationTime) {
        let animationStart = entry.animationStart, animationEnd = entry.animationEnd;
        let duration = animationEnd - animationStart;
        let trackLastWrapped = entry.trackLast % duration;
        // Queue events before complete.
        let events = this.events;
        let i = 0, n = events.length;
        for(; i < n; i++){
            let event = events[i];
            if (event.time < trackLastWrapped) break;
            if (event.time > animationEnd) continue; // Discard events outside animation start/end.
            this.queue.event(entry, event);
        }
        // Queue complete if completed a loop iteration or the animation.
        let complete = false;
        if (entry.loop) complete = duration == 0 || trackLastWrapped > entry.trackTime % duration;
        else complete = animationTime >= animationEnd && entry.animationLast < animationEnd;
        if (complete) this.queue.complete(entry);
        // Queue events after complete.
        for(; i < n; i++){
            let event = events[i];
            if (event.time < animationStart) continue; // Discard events outside animation start/end.
            this.queue.event(entry, event);
        }
    }
    /** Removes all animations from all tracks, leaving skeletons in their current pose.
     *
     * It may be desired to use {@link AnimationState#setEmptyAnimation()} to mix the skeletons back to the setup pose,
     * rather than leaving them in their current pose. */ clearTracks() {
        let oldDrainDisabled = this.queue.drainDisabled;
        this.queue.drainDisabled = true;
        for(let i = 0, n = this.tracks.length; i < n; i++)this.clearTrack(i);
        this.tracks.length = 0;
        this.queue.drainDisabled = oldDrainDisabled;
        this.queue.drain();
    }
    /** Removes all animations from the track, leaving skeletons in their current pose.
     *
     * It may be desired to use {@link AnimationState#setEmptyAnimation()} to mix the skeletons back to the setup pose,
     * rather than leaving them in their current pose. */ clearTrack(trackIndex) {
        if (trackIndex >= this.tracks.length) return;
        let current = this.tracks[trackIndex];
        if (!current) return;
        this.queue.end(current);
        this.clearNext(current);
        let entry = current;
        while(true){
            let from = entry.mixingFrom;
            if (!from) break;
            this.queue.end(from);
            entry.mixingFrom = null;
            entry.mixingTo = null;
            entry = from;
        }
        this.tracks[current.trackIndex] = null;
        this.queue.drain();
    }
    setCurrent(index, current, interrupt) {
        let from = this.expandToIndex(index);
        this.tracks[index] = current;
        current.previous = null;
        if (from) {
            if (interrupt) this.queue.interrupt(from);
            current.mixingFrom = from;
            from.mixingTo = current;
            current.mixTime = 0;
            // Store the interrupted mix percentage.
            if (from.mixingFrom && from.mixDuration > 0) current.interruptAlpha *= Math.min(1, from.mixTime / from.mixDuration);
            from.timelinesRotation.length = 0; // Reset rotation for mixing out, in case entry was mixed in.
        }
        this.queue.start(current);
    }
    /** Sets an animation by name.
      *
      * See {@link #setAnimationWith()}. */ setAnimation(trackIndex, animationName, loop = false) {
        let animation = this.data.skeletonData.findAnimation(animationName);
        if (!animation) throw new Error("Animation not found: " + animationName);
        return this.setAnimationWith(trackIndex, animation, loop);
    }
    /** Sets the current animation for a track, discarding any queued animations. If the formerly current track entry was never
     * applied to a skeleton, it is replaced (not mixed from).
     * @param loop If true, the animation will repeat. If false it will not, instead its last frame is applied if played beyond its
     *           duration. In either case {@link TrackEntry#trackEnd} determines when the track is cleared.
     * @returns A track entry to allow further customization of animation playback. References to the track entry must not be kept
     *         after the {@link AnimationStateListener#dispose()} event occurs. */ setAnimationWith(trackIndex, animation, loop = false) {
        if (!animation) throw new Error("animation cannot be null.");
        let interrupt = true;
        let current = this.expandToIndex(trackIndex);
        if (current) {
            if (current.nextTrackLast == -1) {
                // Don't mix from an entry that was never applied.
                this.tracks[trackIndex] = current.mixingFrom;
                this.queue.interrupt(current);
                this.queue.end(current);
                this.clearNext(current);
                current = current.mixingFrom;
                interrupt = false;
            } else this.clearNext(current);
        }
        let entry = this.trackEntry(trackIndex, animation, loop, current);
        this.setCurrent(trackIndex, entry, interrupt);
        this.queue.drain();
        return entry;
    }
    /** Queues an animation by name.
     *
     * See {@link #addAnimationWith()}. */ addAnimation(trackIndex, animationName, loop = false, delay = 0) {
        let animation = this.data.skeletonData.findAnimation(animationName);
        if (!animation) throw new Error("Animation not found: " + animationName);
        return this.addAnimationWith(trackIndex, animation, loop, delay);
    }
    /** Adds an animation to be played after the current or last queued animation for a track. If the track is empty, it is
     * equivalent to calling {@link #setAnimationWith()}.
     * @param delay If > 0, sets {@link TrackEntry#delay}. If <= 0, the delay set is the duration of the previous track entry
     *           minus any mix duration (from the {@link AnimationStateData}) plus the specified `delay` (ie the mix
     *           ends at (`delay` = 0) or before (`delay` < 0) the previous track entry duration). If the
     *           previous entry is looping, its next loop completion is used instead of its duration.
     * @returns A track entry to allow further customization of animation playback. References to the track entry must not be kept
     *         after the {@link AnimationStateListener#dispose()} event occurs. */ addAnimationWith(trackIndex, animation, loop = false, delay = 0) {
        if (!animation) throw new Error("animation cannot be null.");
        let last = this.expandToIndex(trackIndex);
        if (last) while(last.next)last = last.next;
        let entry = this.trackEntry(trackIndex, animation, loop, last);
        if (!last) {
            this.setCurrent(trackIndex, entry, true);
            this.queue.drain();
        } else {
            last.next = entry;
            entry.previous = last;
            if (delay <= 0) delay += last.getTrackComplete() - entry.mixDuration;
        }
        entry.delay = delay;
        return entry;
    }
    /** Sets an empty animation for a track, discarding any queued animations, and sets the track entry's
     * {@link TrackEntry#mixduration}. An empty animation has no timelines and serves as a placeholder for mixing in or out.
     *
     * Mixing out is done by setting an empty animation with a mix duration using either {@link #setEmptyAnimation()},
     * {@link #setEmptyAnimations()}, or {@link #addEmptyAnimation()}. Mixing to an empty animation causes
     * the previous animation to be applied less and less over the mix duration. Properties keyed in the previous animation
     * transition to the value from lower tracks or to the setup pose value if no lower tracks key the property. A mix duration of
     * 0 still mixes out over one frame.
     *
     * Mixing in is done by first setting an empty animation, then adding an animation using
     * {@link #addAnimation()} and on the returned track entry, set the
     * {@link TrackEntry#setMixDuration()}. Mixing from an empty animation causes the new animation to be applied more and
     * more over the mix duration. Properties keyed in the new animation transition from the value from lower tracks or from the
     * setup pose value if no lower tracks key the property to the value keyed in the new animation. */ setEmptyAnimation(trackIndex, mixDuration = 0) {
        let entry = this.setAnimationWith(trackIndex, $15bd7a75a398401c$export$d0f7a26c90cc1562.emptyAnimation(), false);
        entry.mixDuration = mixDuration;
        entry.trackEnd = mixDuration;
        return entry;
    }
    /** Adds an empty animation to be played after the current or last queued animation for a track, and sets the track entry's
     * {@link TrackEntry#mixDuration}. If the track is empty, it is equivalent to calling
     * {@link #setEmptyAnimation()}.
     *
     * See {@link #setEmptyAnimation()}.
     * @param delay If > 0, sets {@link TrackEntry#delay}. If <= 0, the delay set is the duration of the previous track entry
     *           minus any mix duration plus the specified `delay` (ie the mix ends at (`delay` = 0) or
     *           before (`delay` < 0) the previous track entry duration). If the previous entry is looping, its next
     *           loop completion is used instead of its duration.
     * @return A track entry to allow further customization of animation playback. References to the track entry must not be kept
     *         after the {@link AnimationStateListener#dispose()} event occurs. */ addEmptyAnimation(trackIndex, mixDuration = 0, delay = 0) {
        let entry = this.addAnimationWith(trackIndex, $15bd7a75a398401c$export$d0f7a26c90cc1562.emptyAnimation(), false, delay);
        if (delay <= 0) entry.delay += entry.mixDuration - mixDuration;
        entry.mixDuration = mixDuration;
        entry.trackEnd = mixDuration;
        return entry;
    }
    /** Sets an empty animation for every track, discarding any queued animations, and mixes to it over the specified mix
      * duration. */ setEmptyAnimations(mixDuration = 0) {
        let oldDrainDisabled = this.queue.drainDisabled;
        this.queue.drainDisabled = true;
        for(let i = 0, n = this.tracks.length; i < n; i++){
            let current = this.tracks[i];
            if (current) this.setEmptyAnimation(current.trackIndex, mixDuration);
        }
        this.queue.drainDisabled = oldDrainDisabled;
        this.queue.drain();
    }
    expandToIndex(index) {
        if (index < this.tracks.length) return this.tracks[index];
        (0, $1702fa998ec22e58$export$d2ca453b913dcdea).ensureArrayCapacity(this.tracks, index + 1, null);
        this.tracks.length = index + 1;
        return null;
    }
    /** @param last May be null. */ trackEntry(trackIndex, animation, loop, last) {
        let entry = this.trackEntryPool.obtain();
        entry.reset();
        entry.trackIndex = trackIndex;
        entry.animation = animation;
        entry.loop = loop;
        entry.holdPrevious = false;
        entry.reverse = false;
        entry.shortestRotation = false;
        entry.eventThreshold = 0;
        entry.attachmentThreshold = 0;
        entry.drawOrderThreshold = 0;
        entry.animationStart = 0;
        entry.animationEnd = animation.duration;
        entry.animationLast = -1;
        entry.nextAnimationLast = -1;
        entry.delay = 0;
        entry.trackTime = 0;
        entry.trackLast = -1;
        entry.nextTrackLast = -1;
        entry.trackEnd = Number.MAX_VALUE;
        entry.timeScale = 1;
        entry.alpha = 1;
        entry.mixTime = 0;
        entry.mixDuration = !last ? 0 : this.data.getMix(last.animation, animation);
        entry.interruptAlpha = 1;
        entry.totalAlpha = 0;
        entry.mixBlend = (0, $c8bc0977b55afb3a$export$ccab779a50275a35).replace;
        return entry;
    }
    /** Removes the {@link TrackEntry#getNext() next entry} and all entries after it for the specified entry. */ clearNext(entry) {
        let next = entry.next;
        while(next){
            this.queue.dispose(next);
            next = next.next;
        }
        entry.next = null;
    }
    _animationsChanged() {
        this.animationsChanged = false;
        this.propertyIDs.clear();
        let tracks = this.tracks;
        for(let i = 0, n = tracks.length; i < n; i++){
            let entry = tracks[i];
            if (!entry) continue;
            while(entry.mixingFrom)entry = entry.mixingFrom;
            do {
                if (!entry.mixingTo || entry.mixBlend != (0, $c8bc0977b55afb3a$export$ccab779a50275a35).add) this.computeHold(entry);
                entry = entry.mixingTo;
            }while (entry);
        }
    }
    computeHold(entry) {
        let to = entry.mixingTo;
        let timelines = entry.animation.timelines;
        let timelinesCount = entry.animation.timelines.length;
        let timelineMode = entry.timelineMode;
        timelineMode.length = timelinesCount;
        let timelineHoldMix = entry.timelineHoldMix;
        timelineHoldMix.length = 0;
        let propertyIDs = this.propertyIDs;
        if (to && to.holdPrevious) {
            for(let i = 0; i < timelinesCount; i++)timelineMode[i] = propertyIDs.addAll(timelines[i].getPropertyIds()) ? $15bd7a75a398401c$export$83263fba6795a4f7 : $15bd7a75a398401c$export$61db7ea55ff2bc4f;
            return;
        }
        outer: for(let i = 0; i < timelinesCount; i++){
            let timeline = timelines[i];
            let ids = timeline.getPropertyIds();
            if (!propertyIDs.addAll(ids)) timelineMode[i] = $15bd7a75a398401c$export$89027c4cc247cc19;
            else if (!to || timeline instanceof (0, $c8bc0977b55afb3a$export$7f2bfc5bd27cb43d) || timeline instanceof (0, $c8bc0977b55afb3a$export$ece1f7c41d051e83) || timeline instanceof (0, $c8bc0977b55afb3a$export$4f4bca996c586084) || !to.animation.hasTimeline(ids)) timelineMode[i] = $15bd7a75a398401c$export$9f55c59c79ce7630;
            else {
                for(let next = to.mixingTo; next; next = next.mixingTo){
                    if (next.animation.hasTimeline(ids)) continue;
                    if (entry.mixDuration > 0) {
                        timelineMode[i] = $15bd7a75a398401c$export$68479a2ca54edfe5;
                        timelineHoldMix[i] = next;
                        continue outer;
                    }
                    break;
                }
                timelineMode[i] = $15bd7a75a398401c$export$83263fba6795a4f7;
            }
        }
    }
    /** Returns the track entry for the animation currently playing on the track, or null if no animation is currently playing. */ getCurrent(trackIndex) {
        if (trackIndex >= this.tracks.length) return null;
        return this.tracks[trackIndex];
    }
    /** Adds a listener to receive events for all track entries. */ addListener(listener) {
        if (!listener) throw new Error("listener cannot be null.");
        this.listeners.push(listener);
    }
    /** Removes the listener added with {@link #addListener()}. */ removeListener(listener) {
        let index = this.listeners.indexOf(listener);
        if (index >= 0) this.listeners.splice(index, 1);
    }
    /** Removes all listeners added with {@link #addListener()}. */ clearListeners() {
        this.listeners.length = 0;
    }
    /** Discards all listener notifications that have not yet been delivered. This can be useful to call from an
     * {@link AnimationStateListener} when it is known that further notifications that may have been already queued for delivery
     * are not wanted because new animations are being set. */ clearListenerNotifications() {
        this.queue.clear();
    }
}
class $15bd7a75a398401c$export$6fd48f25bc0ee658 {
    /** The animation to apply for this track entry. */ animation = null;
    previous = null;
    /** The animation queued to start after this animation, or null. `next` makes up a linked list. */ next = null;
    /** The track entry for the previous animation when mixing from the previous animation to this animation, or null if no
     * mixing is currently occuring. When mixing from multiple animations, `mixingFrom` makes up a linked list. */ mixingFrom = null;
    /** The track entry for the next animation when mixing from this animation to the next animation, or null if no mixing is
     * currently occuring. When mixing to multiple animations, `mixingTo` makes up a linked list. */ mixingTo = null;
    /** The listener for events generated by this track entry, or null.
     *
     * A track entry returned from {@link AnimationState#setAnimation()} is already the current animation
     * for the track, so the track entry listener {@link AnimationStateListener#start()} will not be called. */ listener = null;
    /** The index of the track where this track entry is either current or queued.
     *
     * See {@link AnimationState#getCurrent()}. */ trackIndex = 0;
    /** If true, the animation will repeat. If false it will not, instead its last frame is applied if played beyond its
     * duration. */ loop = false;
    /** If true, when mixing from the previous animation to this animation, the previous animation is applied as normal instead
     * of being mixed out.
     *
     * When mixing between animations that key the same property, if a lower track also keys that property then the value will
     * briefly dip toward the lower track value during the mix. This happens because the first animation mixes from 100% to 0%
     * while the second animation mixes from 0% to 100%. Setting `holdPrevious` to true applies the first animation
     * at 100% during the mix so the lower track value is overwritten. Such dipping does not occur on the lowest track which
     * keys the property, only when a higher track also keys the property.
     *
     * Snapping will occur if `holdPrevious` is true and this animation does not key all the same properties as the
     * previous animation. */ holdPrevious = false;
    reverse = false;
    shortestRotation = false;
    /** When the mix percentage ({@link #mixTime} / {@link #mixDuration}) is less than the
     * `eventThreshold`, event timelines are applied while this animation is being mixed out. Defaults to 0, so event
     * timelines are not applied while this animation is being mixed out. */ eventThreshold = 0;
    /** When the mix percentage ({@link #mixtime} / {@link #mixDuration}) is less than the
     * `attachmentThreshold`, attachment timelines are applied while this animation is being mixed out. Defaults to
     * 0, so attachment timelines are not applied while this animation is being mixed out. */ attachmentThreshold = 0;
    /** When the mix percentage ({@link #mixTime} / {@link #mixDuration}) is less than the
     * `drawOrderThreshold`, draw order timelines are applied while this animation is being mixed out. Defaults to 0,
     * so draw order timelines are not applied while this animation is being mixed out. */ drawOrderThreshold = 0;
    /** Seconds when this animation starts, both initially and after looping. Defaults to 0.
     *
     * When changing the `animationStart` time, it often makes sense to set {@link #animationLast} to the same
     * value to prevent timeline keys before the start time from triggering. */ animationStart = 0;
    /** Seconds for the last frame of this animation. Non-looping animations won't play past this time. Looping animations will
     * loop back to {@link #animationStart} at this time. Defaults to the animation {@link Animation#duration}. */ animationEnd = 0;
    /** The time in seconds this animation was last applied. Some timelines use this for one-time triggers. Eg, when this
     * animation is applied, event timelines will fire all events between the `animationLast` time (exclusive) and
     * `animationTime` (inclusive). Defaults to -1 to ensure triggers on frame 0 happen the first time this animation
     * is applied. */ animationLast = 0;
    nextAnimationLast = 0;
    /** Seconds to postpone playing the animation. When this track entry is the current track entry, `delay`
     * postpones incrementing the {@link #trackTime}. When this track entry is queued, `delay` is the time from
     * the start of the previous animation to when this track entry will become the current track entry (ie when the previous
     * track entry {@link TrackEntry#trackTime} >= this track entry's `delay`).
     *
     * {@link #timeScale} affects the delay. */ delay = 0;
    /** Current time in seconds this track entry has been the current track entry. The track time determines
     * {@link #animationTime}. The track time can be set to start the animation at a time other than 0, without affecting
     * looping. */ trackTime = 0;
    trackLast = 0;
    nextTrackLast = 0;
    /** The track time in seconds when this animation will be removed from the track. Defaults to the highest possible float
     * value, meaning the animation will be applied until a new animation is set or the track is cleared. If the track end time
     * is reached, no other animations are queued for playback, and mixing from any previous animations is complete, then the
     * properties keyed by the animation are set to the setup pose and the track is cleared.
     *
     * It may be desired to use {@link AnimationState#addEmptyAnimation()} rather than have the animation
     * abruptly cease being applied. */ trackEnd = 0;
    /** Multiplier for the delta time when this track entry is updated, causing time for this animation to pass slower or
     * faster. Defaults to 1.
     *
     * {@link #mixTime} is not affected by track entry time scale, so {@link #mixDuration} may need to be adjusted to
     * match the animation speed.
     *
     * When using {@link AnimationState#addAnimation()} with a `delay` <= 0, note the
     * {@link #delay} is set using the mix duration from the {@link AnimationStateData}, assuming time scale to be 1. If
     * the time scale is not 1, the delay may need to be adjusted.
     *
     * See AnimationState {@link AnimationState#timeScale} for affecting all animations. */ timeScale = 0;
    /** Values < 1 mix this animation with the skeleton's current pose (usually the pose resulting from lower tracks). Defaults
     * to 1, which overwrites the skeleton's current pose with this animation.
     *
     * Typically track 0 is used to completely pose the skeleton, then alpha is used on higher tracks. It doesn't make sense to
     * use alpha on track 0 if the skeleton pose is from the last frame render. */ alpha = 0;
    /** Seconds from 0 to the {@link #getMixDuration()} when mixing from the previous animation to this animation. May be
     * slightly more than `mixDuration` when the mix is complete. */ mixTime = 0;
    /** Seconds for mixing from the previous animation to this animation. Defaults to the value provided by AnimationStateData
     * {@link AnimationStateData#getMix()} based on the animation before this animation (if any).
     *
     * A mix duration of 0 still mixes out over one frame to provide the track entry being mixed out a chance to revert the
     * properties it was animating.
     *
     * The `mixDuration` can be set manually rather than use the value from
     * {@link AnimationStateData#getMix()}. In that case, the `mixDuration` can be set for a new
     * track entry only before {@link AnimationState#update(float)} is first called.
     *
     * When using {@link AnimationState#addAnimation()} with a `delay` <= 0, note the
     * {@link #delay} is set using the mix duration from the {@link AnimationStateData}, not a mix duration set
     * afterward. */ mixDuration = 0;
    interruptAlpha = 0;
    totalAlpha = 0;
    /** Controls how properties keyed in the animation are mixed with lower tracks. Defaults to {@link MixBlend#replace}, which
     * replaces the values from the lower tracks with the animation values. {@link MixBlend#add} adds the animation values to
     * the values from the lower tracks.
     *
     * The `mixBlend` can be set for a new track entry only before {@link AnimationState#apply()} is first
     * called. */ mixBlend = (0, $c8bc0977b55afb3a$export$ccab779a50275a35).replace;
    timelineMode = new Array();
    timelineHoldMix = new Array();
    timelinesRotation = new Array();
    reset() {
        this.next = null;
        this.previous = null;
        this.mixingFrom = null;
        this.mixingTo = null;
        this.animation = null;
        this.listener = null;
        this.timelineMode.length = 0;
        this.timelineHoldMix.length = 0;
        this.timelinesRotation.length = 0;
    }
    /** Uses {@link #trackTime} to compute the `animationTime`, which is between {@link #animationStart}
     * and {@link #animationEnd}. When the `trackTime` is 0, the `animationTime` is equal to the
     * `animationStart` time. */ getAnimationTime() {
        if (this.loop) {
            let duration = this.animationEnd - this.animationStart;
            if (duration == 0) return this.animationStart;
            return this.trackTime % duration + this.animationStart;
        }
        return Math.min(this.trackTime + this.animationStart, this.animationEnd);
    }
    setAnimationLast(animationLast) {
        this.animationLast = animationLast;
        this.nextAnimationLast = animationLast;
    }
    /** Returns true if at least one loop has been completed.
     *
     * See {@link AnimationStateListener#complete()}. */ isComplete() {
        return this.trackTime >= this.animationEnd - this.animationStart;
    }
    /** Resets the rotation directions for mixing this entry's rotate timelines. This can be useful to avoid bones rotating the
     * long way around when using {@link #alpha} and starting animations on other tracks.
     *
     * Mixing with {@link MixBlend#replace} involves finding a rotation between two others, which has two possible solutions:
     * the short way or the long way around. The two rotations likely change over time, so which direction is the short or long
     * way also changes. If the short way was always chosen, bones would flip to the other side when that direction became the
     * long way. TrackEntry chooses the short way the first time it is applied and remembers that direction. */ resetRotationDirections() {
        this.timelinesRotation.length = 0;
    }
    getTrackComplete() {
        let duration = this.animationEnd - this.animationStart;
        if (duration != 0) {
            if (this.loop) return duration * (1 + (this.trackTime / duration | 0)); // Completion of next loop.
            if (this.trackTime < duration) return duration; // Before duration.
        }
        return this.trackTime; // Next update.
    }
}
class $15bd7a75a398401c$export$2fc6338444a158e6 {
    objects = [];
    drainDisabled = false;
    animState;
    constructor(animState){
        this.animState = animState;
    }
    start(entry) {
        this.objects.push($15bd7a75a398401c$export$3d7865934588d77e.start);
        this.objects.push(entry);
        this.animState.animationsChanged = true;
    }
    interrupt(entry) {
        this.objects.push($15bd7a75a398401c$export$3d7865934588d77e.interrupt);
        this.objects.push(entry);
    }
    end(entry) {
        this.objects.push($15bd7a75a398401c$export$3d7865934588d77e.end);
        this.objects.push(entry);
        this.animState.animationsChanged = true;
    }
    dispose(entry) {
        this.objects.push($15bd7a75a398401c$export$3d7865934588d77e.dispose);
        this.objects.push(entry);
    }
    complete(entry) {
        this.objects.push($15bd7a75a398401c$export$3d7865934588d77e.complete);
        this.objects.push(entry);
    }
    event(entry, event) {
        this.objects.push($15bd7a75a398401c$export$3d7865934588d77e.event);
        this.objects.push(entry);
        this.objects.push(event);
    }
    drain() {
        if (this.drainDisabled) return;
        this.drainDisabled = true;
        let objects = this.objects;
        let listeners = this.animState.listeners;
        for(let i = 0; i < objects.length; i += 2){
            let type = objects[i];
            let entry = objects[i + 1];
            switch(type){
                case $15bd7a75a398401c$export$3d7865934588d77e.start:
                    if (entry.listener && entry.listener.start) entry.listener.start(entry);
                    for(let ii = 0; ii < listeners.length; ii++){
                        let listener = listeners[ii];
                        if (listener.start) listener.start(entry);
                    }
                    break;
                case $15bd7a75a398401c$export$3d7865934588d77e.interrupt:
                    if (entry.listener && entry.listener.interrupt) entry.listener.interrupt(entry);
                    for(let ii = 0; ii < listeners.length; ii++){
                        let listener = listeners[ii];
                        if (listener.interrupt) listener.interrupt(entry);
                    }
                    break;
                case $15bd7a75a398401c$export$3d7865934588d77e.end:
                    if (entry.listener && entry.listener.end) entry.listener.end(entry);
                    for(let ii = 0; ii < listeners.length; ii++){
                        let listener = listeners[ii];
                        if (listener.end) listener.end(entry);
                    }
                // Fall through.
                case $15bd7a75a398401c$export$3d7865934588d77e.dispose:
                    if (entry.listener && entry.listener.dispose) entry.listener.dispose(entry);
                    for(let ii = 0; ii < listeners.length; ii++){
                        let listener = listeners[ii];
                        if (listener.dispose) listener.dispose(entry);
                    }
                    this.animState.trackEntryPool.free(entry);
                    break;
                case $15bd7a75a398401c$export$3d7865934588d77e.complete:
                    if (entry.listener && entry.listener.complete) entry.listener.complete(entry);
                    for(let ii = 0; ii < listeners.length; ii++){
                        let listener = listeners[ii];
                        if (listener.complete) listener.complete(entry);
                    }
                    break;
                case $15bd7a75a398401c$export$3d7865934588d77e.event:
                    let event = objects[i++ + 2];
                    if (entry.listener && entry.listener.event) entry.listener.event(entry, event);
                    for(let ii = 0; ii < listeners.length; ii++){
                        let listener = listeners[ii];
                        if (listener.event) listener.event(entry, event);
                    }
                    break;
            }
        }
        this.clear();
        this.drainDisabled = false;
    }
    clear() {
        this.objects.length = 0;
    }
}
var $15bd7a75a398401c$export$3d7865934588d77e;
(function(EventType) {
    EventType[EventType["start"] = 0] = "start";
    EventType[EventType["interrupt"] = 1] = "interrupt";
    EventType[EventType["end"] = 2] = "end";
    EventType[EventType["dispose"] = 3] = "dispose";
    EventType[EventType["complete"] = 4] = "complete";
    EventType[EventType["event"] = 5] = "event";
})($15bd7a75a398401c$export$3d7865934588d77e || ($15bd7a75a398401c$export$3d7865934588d77e = {}));
class $15bd7a75a398401c$export$31af0cf42be5a74d {
    start(entry) {}
    interrupt(entry) {}
    end(entry) {}
    dispose(entry) {}
    complete(entry) {}
    event(entry, event) {}
}
const $15bd7a75a398401c$export$89027c4cc247cc19 = 0;
const $15bd7a75a398401c$export$9f55c59c79ce7630 = 1;
const $15bd7a75a398401c$export$61db7ea55ff2bc4f = 2;
const $15bd7a75a398401c$export$83263fba6795a4f7 = 3;
const $15bd7a75a398401c$export$68479a2ca54edfe5 = 4;
const $15bd7a75a398401c$export$be88f4235204622a = 1;
const $15bd7a75a398401c$export$eed19b551669af14 = 2;


/******************************************************************************
 * Spine Runtimes License Agreement
 * Last updated July 28, 2023. Replaces all prior versions.
 *
 * Copyright (c) 2013-2023, Esoteric Software LLC
 *
 * Integration of the Spine Runtimes into software or otherwise creating
 * derivative works of the Spine Runtimes is permitted under the terms and
 * conditions of Section 2 of the Spine Editor License Agreement:
 * http://esotericsoftware.com/spine-editor-license
 *
 * Otherwise, it is permitted to integrate the Spine Runtimes into software or
 * otherwise create derivative works of the Spine Runtimes (collectively,
 * "Products"), provided that each user of the Products must obtain their own
 * Spine Editor license and redistribution of the Products in any form must
 * include this license and copyright notice.
 *
 * THE SPINE RUNTIMES ARE PROVIDED BY ESOTERIC SOFTWARE LLC "AS IS" AND ANY
 * EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
 * WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE
 * DISCLAIMED. IN NO EVENT SHALL ESOTERIC SOFTWARE LLC BE LIABLE FOR ANY
 * DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES
 * (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES,
 * BUSINESS INTERRUPTION, OR LOSS OF USE, DATA, OR PROFITS) HOWEVER CAUSED AND
 * ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT
 * (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THE
 * SPINE RUNTIMES, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
 *****************************************************************************/ /** Stores mix (crossfade) durations to be applied when {@link AnimationState} animations are changed. */ class $14a949d916e0f278$export$90d7167cc0605975 {
    /** The SkeletonData to look up animations when they are specified by name. */ skeletonData;
    animationToMixTime = {};
    /** The mix duration to use when no mix duration has been defined between two animations. */ defaultMix = 0;
    constructor(skeletonData){
        if (!skeletonData) throw new Error("skeletonData cannot be null.");
        this.skeletonData = skeletonData;
    }
    /** Sets a mix duration by animation name.
     *
     * See {@link #setMixWith()}. */ setMix(fromName, toName, duration) {
        let from = this.skeletonData.findAnimation(fromName);
        if (!from) throw new Error("Animation not found: " + fromName);
        let to = this.skeletonData.findAnimation(toName);
        if (!to) throw new Error("Animation not found: " + toName);
        this.setMixWith(from, to, duration);
    }
    /** Sets the mix duration when changing from the specified animation to the other.
     *
     * See {@link TrackEntry#mixDuration}. */ setMixWith(from, to, duration) {
        if (!from) throw new Error("from cannot be null.");
        if (!to) throw new Error("to cannot be null.");
        let key = from.name + "." + to.name;
        this.animationToMixTime[key] = duration;
    }
    /** Returns the mix duration to use when changing from the specified animation to the other, or the {@link #defaultMix} if
      * no mix duration has been set. */ getMix(from, to) {
        let key = from.name + "." + to.name;
        let value = this.animationToMixTime[key];
        return value === undefined ? this.defaultMix : value;
    }
}


/******************************************************************************
 * Spine Runtimes License Agreement
 * Last updated July 28, 2023. Replaces all prior versions.
 *
 * Copyright (c) 2013-2023, Esoteric Software LLC
 *
 * Integration of the Spine Runtimes into software or otherwise creating
 * derivative works of the Spine Runtimes is permitted under the terms and
 * conditions of Section 2 of the Spine Editor License Agreement:
 * http://esotericsoftware.com/spine-editor-license
 *
 * Otherwise, it is permitted to integrate the Spine Runtimes into software or
 * otherwise create derivative works of the Spine Runtimes (collectively,
 * "Products"), provided that each user of the Products must obtain their own
 * Spine Editor license and redistribution of the Products in any form must
 * include this license and copyright notice.
 *
 * THE SPINE RUNTIMES ARE PROVIDED BY ESOTERIC SOFTWARE LLC "AS IS" AND ANY
 * EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
 * WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE
 * DISCLAIMED. IN NO EVENT SHALL ESOTERIC SOFTWARE LLC BE LIABLE FOR ANY
 * DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES
 * (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES,
 * BUSINESS INTERRUPTION, OR LOSS OF USE, DATA, OR PROFITS) HOWEVER CAUSED AND
 * ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT
 * (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THE
 * SPINE RUNTIMES, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
 *****************************************************************************/ /******************************************************************************
 * Spine Runtimes License Agreement
 * Last updated July 28, 2023. Replaces all prior versions.
 *
 * Copyright (c) 2013-2023, Esoteric Software LLC
 *
 * Integration of the Spine Runtimes into software or otherwise creating
 * derivative works of the Spine Runtimes is permitted under the terms and
 * conditions of Section 2 of the Spine Editor License Agreement:
 * http://esotericsoftware.com/spine-editor-license
 *
 * Otherwise, it is permitted to integrate the Spine Runtimes into software or
 * otherwise create derivative works of the Spine Runtimes (collectively,
 * "Products"), provided that each user of the Products must obtain their own
 * Spine Editor license and redistribution of the Products in any form must
 * include this license and copyright notice.
 *
 * THE SPINE RUNTIMES ARE PROVIDED BY ESOTERIC SOFTWARE LLC "AS IS" AND ANY
 * EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
 * WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE
 * DISCLAIMED. IN NO EVENT SHALL ESOTERIC SOFTWARE LLC BE LIABLE FOR ANY
 * DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES
 * (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES,
 * BUSINESS INTERRUPTION, OR LOSS OF USE, DATA, OR PROFITS) HOWEVER CAUSED AND
 * ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT
 * (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THE
 * SPINE RUNTIMES, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
 *****************************************************************************/ 

class $4ed11088ab57e209$export$9538c439c6b85ad2 extends (0, $3c213aed73167a71$export$66d3a0c3be55e044) {
    color = new (0, $1702fa998ec22e58$export$892596cec99bc70e)(1, 1, 1, 1);
    constructor(name){
        super(name);
    }
    copy() {
        let copy = new $4ed11088ab57e209$export$9538c439c6b85ad2(this.name);
        this.copyTo(copy);
        copy.color.setFromColor(this.color);
        return copy;
    }
}


/******************************************************************************
 * Spine Runtimes License Agreement
 * Last updated July 28, 2023. Replaces all prior versions.
 *
 * Copyright (c) 2013-2023, Esoteric Software LLC
 *
 * Integration of the Spine Runtimes into software or otherwise creating
 * derivative works of the Spine Runtimes is permitted under the terms and
 * conditions of Section 2 of the Spine Editor License Agreement:
 * http://esotericsoftware.com/spine-editor-license
 *
 * Otherwise, it is permitted to integrate the Spine Runtimes into software or
 * otherwise create derivative works of the Spine Runtimes (collectively,
 * "Products"), provided that each user of the Products must obtain their own
 * Spine Editor license and redistribution of the Products in any form must
 * include this license and copyright notice.
 *
 * THE SPINE RUNTIMES ARE PROVIDED BY ESOTERIC SOFTWARE LLC "AS IS" AND ANY
 * EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
 * WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE
 * DISCLAIMED. IN NO EVENT SHALL ESOTERIC SOFTWARE LLC BE LIABLE FOR ANY
 * DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES
 * (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES,
 * BUSINESS INTERRUPTION, OR LOSS OF USE, DATA, OR PROFITS) HOWEVER CAUSED AND
 * ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT
 * (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THE
 * SPINE RUNTIMES, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
 *****************************************************************************/ 

class $c8cbdfdbe3e3034c$export$838805e22b9b55f1 extends (0, $3c213aed73167a71$export$66d3a0c3be55e044) {
    /** Clipping is performed between the clipping polygon's slot and the end slot. Returns null if clipping is done until the end of
     * the skeleton's rendering. */ endSlot = null;
    // Nonessential.
    /** The color of the clipping polygon as it was in Spine. Available only when nonessential data was exported. Clipping polygons
     * are not usually rendered at runtime. */ color = new (0, $1702fa998ec22e58$export$892596cec99bc70e)(0.2275, 0.2275, 0.8078, 1);
    constructor(name){
        super(name);
    }
    copy() {
        let copy = new $c8cbdfdbe3e3034c$export$838805e22b9b55f1(this.name);
        this.copyTo(copy);
        copy.endSlot = this.endSlot;
        copy.color.setFromColor(this.color);
        return copy;
    }
}


/******************************************************************************
 * Spine Runtimes License Agreement
 * Last updated July 28, 2023. Replaces all prior versions.
 *
 * Copyright (c) 2013-2023, Esoteric Software LLC
 *
 * Integration of the Spine Runtimes into software or otherwise creating
 * derivative works of the Spine Runtimes is permitted under the terms and
 * conditions of Section 2 of the Spine Editor License Agreement:
 * http://esotericsoftware.com/spine-editor-license
 *
 * Otherwise, it is permitted to integrate the Spine Runtimes into software or
 * otherwise create derivative works of the Spine Runtimes (collectively,
 * "Products"), provided that each user of the Products must obtain their own
 * Spine Editor license and redistribution of the Products in any form must
 * include this license and copyright notice.
 *
 * THE SPINE RUNTIMES ARE PROVIDED BY ESOTERIC SOFTWARE LLC "AS IS" AND ANY
 * EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
 * WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE
 * DISCLAIMED. IN NO EVENT SHALL ESOTERIC SOFTWARE LLC BE LIABLE FOR ANY
 * DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES
 * (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES,
 * BUSINESS INTERRUPTION, OR LOSS OF USE, DATA, OR PROFITS) HOWEVER CAUSED AND
 * ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT
 * (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THE
 * SPINE RUNTIMES, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
 *****************************************************************************/ /******************************************************************************
 * Spine Runtimes License Agreement
 * Last updated July 28, 2023. Replaces all prior versions.
 *
 * Copyright (c) 2013-2023, Esoteric Software LLC
 *
 * Integration of the Spine Runtimes into software or otherwise creating
 * derivative works of the Spine Runtimes is permitted under the terms and
 * conditions of Section 2 of the Spine Editor License Agreement:
 * http://esotericsoftware.com/spine-editor-license
 *
 * Otherwise, it is permitted to integrate the Spine Runtimes into software or
 * otherwise create derivative works of the Spine Runtimes (collectively,
 * "Products"), provided that each user of the Products must obtain their own
 * Spine Editor license and redistribution of the Products in any form must
 * include this license and copyright notice.
 *
 * THE SPINE RUNTIMES ARE PROVIDED BY ESOTERIC SOFTWARE LLC "AS IS" AND ANY
 * EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
 * WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE
 * DISCLAIMED. IN NO EVENT SHALL ESOTERIC SOFTWARE LLC BE LIABLE FOR ANY
 * DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES
 * (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES,
 * BUSINESS INTERRUPTION, OR LOSS OF USE, DATA, OR PROFITS) HOWEVER CAUSED AND
 * ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT
 * (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THE
 * SPINE RUNTIMES, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
 *****************************************************************************/ /******************************************************************************
 * Spine Runtimes License Agreement
 * Last updated July 28, 2023. Replaces all prior versions.
 *
 * Copyright (c) 2013-2023, Esoteric Software LLC
 *
 * Integration of the Spine Runtimes into software or otherwise creating
 * derivative works of the Spine Runtimes is permitted under the terms and
 * conditions of Section 2 of the Spine Editor License Agreement:
 * http://esotericsoftware.com/spine-editor-license
 *
 * Otherwise, it is permitted to integrate the Spine Runtimes into software or
 * otherwise create derivative works of the Spine Runtimes (collectively,
 * "Products"), provided that each user of the Products must obtain their own
 * Spine Editor license and redistribution of the Products in any form must
 * include this license and copyright notice.
 *
 * THE SPINE RUNTIMES ARE PROVIDED BY ESOTERIC SOFTWARE LLC "AS IS" AND ANY
 * EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
 * WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE
 * DISCLAIMED. IN NO EVENT SHALL ESOTERIC SOFTWARE LLC BE LIABLE FOR ANY
 * DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES
 * (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES,
 * BUSINESS INTERRUPTION, OR LOSS OF USE, DATA, OR PROFITS) HOWEVER CAUSED AND
 * ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT
 * (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THE
 * SPINE RUNTIMES, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
 *****************************************************************************/ class $471b0ca0afe71980$export$5431306cf43de24a {
    _image;
    constructor(image){
        this._image = image;
    }
    getImage() {
        return this._image;
    }
}
var $471b0ca0afe71980$export$f389c48fc54053be;
(function(TextureFilter) {
    TextureFilter[TextureFilter["Nearest"] = 9728] = "Nearest";
    TextureFilter[TextureFilter["Linear"] = 9729] = "Linear";
    TextureFilter[TextureFilter["MipMap"] = 9987] = "MipMap";
    TextureFilter[TextureFilter["MipMapNearestNearest"] = 9984] = "MipMapNearestNearest";
    TextureFilter[TextureFilter["MipMapLinearNearest"] = 9985] = "MipMapLinearNearest";
    TextureFilter[TextureFilter["MipMapNearestLinear"] = 9986] = "MipMapNearestLinear";
    TextureFilter[TextureFilter["MipMapLinearLinear"] = 9987] = "MipMapLinearLinear"; // WebGLRenderingContext.LINEAR_MIPMAP_LINEAR
})($471b0ca0afe71980$export$f389c48fc54053be || ($471b0ca0afe71980$export$f389c48fc54053be = {}));
var $471b0ca0afe71980$export$522a1d31bfb74ba3;
(function(TextureWrap) {
    TextureWrap[TextureWrap["MirroredRepeat"] = 33648] = "MirroredRepeat";
    TextureWrap[TextureWrap["ClampToEdge"] = 33071] = "ClampToEdge";
    TextureWrap[TextureWrap["Repeat"] = 10497] = "Repeat"; // WebGLRenderingContext.REPEAT
})($471b0ca0afe71980$export$522a1d31bfb74ba3 || ($471b0ca0afe71980$export$522a1d31bfb74ba3 = {}));
class $471b0ca0afe71980$export$e7d46317c6b644d1 {
    texture;
    u = 0;
    v = 0;
    u2 = 0;
    v2 = 0;
    width = 0;
    height = 0;
    degrees = 0;
    offsetX = 0;
    offsetY = 0;
    originalWidth = 0;
    originalHeight = 0;
}
class $471b0ca0afe71980$export$b3652565e6818133 extends $471b0ca0afe71980$export$5431306cf43de24a {
    setFilters(minFilter, magFilter) {}
    setWraps(uWrap, vWrap) {}
    dispose() {}
}



class $959dc053f9cefaa3$export$1ffc3159823e6649 {
    pages = new Array();
    regions = new Array();
    constructor(atlasText){
        let reader = new $959dc053f9cefaa3$var$TextureAtlasReader(atlasText);
        let entry = new Array(4);
        let pageFields = {};
        pageFields["size"] = (page)=>{
            page.width = parseInt(entry[1]);
            page.height = parseInt(entry[2]);
        };
        pageFields["format"] = ()=>{
        // page.format = Format[tuple[0]]; we don't need format in WebGL
        };
        pageFields["filter"] = (page)=>{
            page.minFilter = (0, $1702fa998ec22e58$export$d2ca453b913dcdea).enumValue((0, $471b0ca0afe71980$export$f389c48fc54053be), entry[1]);
            page.magFilter = (0, $1702fa998ec22e58$export$d2ca453b913dcdea).enumValue((0, $471b0ca0afe71980$export$f389c48fc54053be), entry[2]);
        };
        pageFields["repeat"] = (page)=>{
            if (entry[1].indexOf("x") != -1) page.uWrap = (0, $471b0ca0afe71980$export$522a1d31bfb74ba3).Repeat;
            if (entry[1].indexOf("y") != -1) page.vWrap = (0, $471b0ca0afe71980$export$522a1d31bfb74ba3).Repeat;
        };
        pageFields["pma"] = (page)=>{
            page.pma = entry[1] == "true";
        };
        var regionFields = {};
        regionFields["xy"] = (region)=>{
            region.x = parseInt(entry[1]);
            region.y = parseInt(entry[2]);
        };
        regionFields["size"] = (region)=>{
            region.width = parseInt(entry[1]);
            region.height = parseInt(entry[2]);
        };
        regionFields["bounds"] = (region)=>{
            region.x = parseInt(entry[1]);
            region.y = parseInt(entry[2]);
            region.width = parseInt(entry[3]);
            region.height = parseInt(entry[4]);
        };
        regionFields["offset"] = (region)=>{
            region.offsetX = parseInt(entry[1]);
            region.offsetY = parseInt(entry[2]);
        };
        regionFields["orig"] = (region)=>{
            region.originalWidth = parseInt(entry[1]);
            region.originalHeight = parseInt(entry[2]);
        };
        regionFields["offsets"] = (region)=>{
            region.offsetX = parseInt(entry[1]);
            region.offsetY = parseInt(entry[2]);
            region.originalWidth = parseInt(entry[3]);
            region.originalHeight = parseInt(entry[4]);
        };
        regionFields["rotate"] = (region)=>{
            let value = entry[1];
            if (value == "true") region.degrees = 90;
            else if (value != "false") region.degrees = parseInt(value);
        };
        regionFields["index"] = (region)=>{
            region.index = parseInt(entry[1]);
        };
        let line = reader.readLine();
        // Ignore empty lines before first entry.
        while(line && line.trim().length == 0)line = reader.readLine();
        // Header entries.
        while(true){
            if (!line || line.trim().length == 0) break;
            if (reader.readEntry(entry, line) == 0) break; // Silently ignore all header fields.
            line = reader.readLine();
        }
        // Page and region entries.
        let page = null;
        let names = null;
        let values = null;
        while(true){
            if (line === null) break;
            if (line.trim().length == 0) {
                page = null;
                line = reader.readLine();
            } else if (!page) {
                page = new $959dc053f9cefaa3$export$1a5db136de4137c2(line.trim());
                while(true){
                    if (reader.readEntry(entry, line = reader.readLine()) == 0) break;
                    let field = pageFields[entry[0]];
                    if (field) field(page);
                }
                this.pages.push(page);
            } else {
                let region = new $959dc053f9cefaa3$export$6c0770e21c633916(page, line);
                while(true){
                    let count = reader.readEntry(entry, line = reader.readLine());
                    if (count == 0) break;
                    let field = regionFields[entry[0]];
                    if (field) field(region);
                    else {
                        if (!names) names = [];
                        if (!values) values = [];
                        names.push(entry[0]);
                        let entryValues = [];
                        for(let i = 0; i < count; i++)entryValues.push(parseInt(entry[i + 1]));
                        values.push(entryValues);
                    }
                }
                if (region.originalWidth == 0 && region.originalHeight == 0) {
                    region.originalWidth = region.width;
                    region.originalHeight = region.height;
                }
                if (names && names.length > 0 && values && values.length > 0) {
                    region.names = names;
                    region.values = values;
                    names = null;
                    values = null;
                }
                region.u = region.x / page.width;
                region.v = region.y / page.height;
                if (region.degrees == 90) {
                    region.u2 = (region.x + region.height) / page.width;
                    region.v2 = (region.y + region.width) / page.height;
                } else {
                    region.u2 = (region.x + region.width) / page.width;
                    region.v2 = (region.y + region.height) / page.height;
                }
                this.regions.push(region);
            }
        }
    }
    findRegion(name) {
        for(let i = 0; i < this.regions.length; i++){
            if (this.regions[i].name == name) return this.regions[i];
        }
        return null;
    }
    setTextures(assetManager, pathPrefix = "") {
        for (let page of this.pages)page.setTexture(assetManager.get(pathPrefix + page.name));
    }
    dispose() {
        for(let i = 0; i < this.pages.length; i++)this.pages[i].texture?.dispose();
    }
}
class $959dc053f9cefaa3$var$TextureAtlasReader {
    lines;
    index = 0;
    constructor(text){
        this.lines = text.split(/\r\n|\r|\n/);
    }
    readLine() {
        if (this.index >= this.lines.length) return null;
        return this.lines[this.index++];
    }
    readEntry(entry, line) {
        if (!line) return 0;
        line = line.trim();
        if (line.length == 0) return 0;
        let colon = line.indexOf(":");
        if (colon == -1) return 0;
        entry[0] = line.substr(0, colon).trim();
        for(let i = 1, lastMatch = colon + 1;; i++){
            let comma = line.indexOf(",", lastMatch);
            if (comma == -1) {
                entry[i] = line.substr(lastMatch).trim();
                return i;
            }
            entry[i] = line.substr(lastMatch, comma - lastMatch).trim();
            lastMatch = comma + 1;
            if (i == 4) return 4;
        }
    }
}
class $959dc053f9cefaa3$export$1a5db136de4137c2 {
    name;
    minFilter = (0, $471b0ca0afe71980$export$f389c48fc54053be).Nearest;
    magFilter = (0, $471b0ca0afe71980$export$f389c48fc54053be).Nearest;
    uWrap = (0, $471b0ca0afe71980$export$522a1d31bfb74ba3).ClampToEdge;
    vWrap = (0, $471b0ca0afe71980$export$522a1d31bfb74ba3).ClampToEdge;
    texture = null;
    width = 0;
    height = 0;
    pma = false;
    regions = new Array();
    constructor(name){
        this.name = name;
    }
    setTexture(texture) {
        this.texture = texture;
        texture.setFilters(this.minFilter, this.magFilter);
        texture.setWraps(this.uWrap, this.vWrap);
        for (let region of this.regions)region.texture = texture;
    }
}
class $959dc053f9cefaa3$export$6c0770e21c633916 extends (0, $471b0ca0afe71980$export$e7d46317c6b644d1) {
    page;
    name;
    x = 0;
    y = 0;
    offsetX = 0;
    offsetY = 0;
    originalWidth = 0;
    originalHeight = 0;
    index = 0;
    degrees = 0;
    names = null;
    values = null;
    constructor(page, name){
        super();
        this.page = page;
        this.name = name;
        page.regions.push(this);
    }
}




class $3ed5c5afaf00d170$export$3f1c1692adfcf3e2 extends (0, $3c213aed73167a71$export$66d3a0c3be55e044) {
    region = null;
    /** The name of the texture region for this attachment. */ path;
    /** The UV pair for each vertex, normalized within the texture region. */ regionUVs = [];
    /** The UV pair for each vertex, normalized within the entire texture.
     *
     * See {@link #updateUVs}. */ uvs = [];
    /** Triplets of vertex indices which describe the mesh's triangulation. */ triangles = [];
    /** The color to tint the mesh. */ color = new (0, $1702fa998ec22e58$export$892596cec99bc70e)(1, 1, 1, 1);
    /** The width of the mesh's image. Available only when nonessential data was exported. */ width = 0;
    /** The height of the mesh's image. Available only when nonessential data was exported. */ height = 0;
    /** The number of entries at the beginning of {@link #vertices} that make up the mesh hull. */ hullLength = 0;
    /** Vertex index pairs describing edges for controling triangulation. Mesh triangles will never cross edges. Only available if
     * nonessential data was exported. Triangulation is not performed at runtime. */ edges = [];
    parentMesh = null;
    sequence = null;
    tempColor = new (0, $1702fa998ec22e58$export$892596cec99bc70e)(0, 0, 0, 0);
    constructor(name, path){
        super(name);
        this.path = path;
    }
    /** Calculates {@link #uvs} using the {@link #regionUVs} and region. Must be called if the region, the region's properties, or
     * the {@link #regionUVs} are changed. */ updateRegion() {
        if (!this.region) throw new Error("Region not set.");
        let regionUVs = this.regionUVs;
        if (!this.uvs || this.uvs.length != regionUVs.length) this.uvs = (0, $1702fa998ec22e58$export$d2ca453b913dcdea).newFloatArray(regionUVs.length);
        let uvs = this.uvs;
        let n = this.uvs.length;
        let u = this.region.u, v = this.region.v, width = 0, height = 0;
        if (this.region instanceof (0, $959dc053f9cefaa3$export$6c0770e21c633916)) {
            let region = this.region, page = region.page;
            let textureWidth = page.width, textureHeight = page.height;
            switch(region.degrees){
                case 90:
                    u -= (region.originalHeight - region.offsetY - region.height) / textureWidth;
                    v -= (region.originalWidth - region.offsetX - region.width) / textureHeight;
                    width = region.originalHeight / textureWidth;
                    height = region.originalWidth / textureHeight;
                    for(let i = 0; i < n; i += 2){
                        uvs[i] = u + regionUVs[i + 1] * width;
                        uvs[i + 1] = v + (1 - regionUVs[i]) * height;
                    }
                    return;
                case 180:
                    u -= (region.originalWidth - region.offsetX - region.width) / textureWidth;
                    v -= region.offsetY / textureHeight;
                    width = region.originalWidth / textureWidth;
                    height = region.originalHeight / textureHeight;
                    for(let i = 0; i < n; i += 2){
                        uvs[i] = u + (1 - regionUVs[i]) * width;
                        uvs[i + 1] = v + (1 - regionUVs[i + 1]) * height;
                    }
                    return;
                case 270:
                    u -= region.offsetY / textureWidth;
                    v -= region.offsetX / textureHeight;
                    width = region.originalHeight / textureWidth;
                    height = region.originalWidth / textureHeight;
                    for(let i = 0; i < n; i += 2){
                        uvs[i] = u + (1 - regionUVs[i + 1]) * width;
                        uvs[i + 1] = v + regionUVs[i] * height;
                    }
                    return;
            }
            u -= region.offsetX / textureWidth;
            v -= (region.originalHeight - region.offsetY - region.height) / textureHeight;
            width = region.originalWidth / textureWidth;
            height = region.originalHeight / textureHeight;
        } else if (!this.region) {
            u = v = 0;
            width = height = 1;
        } else {
            width = this.region.u2 - u;
            height = this.region.v2 - v;
        }
        for(let i = 0; i < n; i += 2){
            uvs[i] = u + regionUVs[i] * width;
            uvs[i + 1] = v + regionUVs[i + 1] * height;
        }
    }
    /** The parent mesh if this is a linked mesh, else null. A linked mesh shares the {@link #bones}, {@link #vertices},
     * {@link #regionUVs}, {@link #triangles}, {@link #hullLength}, {@link #edges}, {@link #width}, and {@link #height} with the
     * parent mesh, but may have a different {@link #name} or {@link #path} (and therefore a different texture). */ getParentMesh() {
        return this.parentMesh;
    }
    /** @param parentMesh May be null. */ setParentMesh(parentMesh) {
        this.parentMesh = parentMesh;
        if (parentMesh) {
            this.bones = parentMesh.bones;
            this.vertices = parentMesh.vertices;
            this.worldVerticesLength = parentMesh.worldVerticesLength;
            this.regionUVs = parentMesh.regionUVs;
            this.triangles = parentMesh.triangles;
            this.hullLength = parentMesh.hullLength;
            this.worldVerticesLength = parentMesh.worldVerticesLength;
        }
    }
    copy() {
        if (this.parentMesh) return this.newLinkedMesh();
        let copy = new $3ed5c5afaf00d170$export$3f1c1692adfcf3e2(this.name, this.path);
        copy.region = this.region;
        copy.color.setFromColor(this.color);
        this.copyTo(copy);
        copy.regionUVs = new Array(this.regionUVs.length);
        (0, $1702fa998ec22e58$export$d2ca453b913dcdea).arrayCopy(this.regionUVs, 0, copy.regionUVs, 0, this.regionUVs.length);
        copy.uvs = new Array(this.uvs.length);
        (0, $1702fa998ec22e58$export$d2ca453b913dcdea).arrayCopy(this.uvs, 0, copy.uvs, 0, this.uvs.length);
        copy.triangles = new Array(this.triangles.length);
        (0, $1702fa998ec22e58$export$d2ca453b913dcdea).arrayCopy(this.triangles, 0, copy.triangles, 0, this.triangles.length);
        copy.hullLength = this.hullLength;
        copy.sequence = this.sequence != null ? this.sequence.copy() : null;
        // Nonessential.
        if (this.edges) {
            copy.edges = new Array(this.edges.length);
            (0, $1702fa998ec22e58$export$d2ca453b913dcdea).arrayCopy(this.edges, 0, copy.edges, 0, this.edges.length);
        }
        copy.width = this.width;
        copy.height = this.height;
        return copy;
    }
    computeWorldVertices(slot, start, count, worldVertices, offset, stride) {
        if (this.sequence != null) this.sequence.apply(slot, this);
        super.computeWorldVertices(slot, start, count, worldVertices, offset, stride);
    }
    /** Returns a new mesh with the {@link #parentMesh} set to this mesh's parent mesh, if any, else to this mesh. **/ newLinkedMesh() {
        let copy = new $3ed5c5afaf00d170$export$3f1c1692adfcf3e2(this.name, this.path);
        copy.region = this.region;
        copy.color.setFromColor(this.color);
        copy.timelineAttachment = this.timelineAttachment;
        copy.setParentMesh(this.parentMesh ? this.parentMesh : this);
        if (copy.region != null) copy.updateRegion();
        return copy;
    }
}


/******************************************************************************
 * Spine Runtimes License Agreement
 * Last updated July 28, 2023. Replaces all prior versions.
 *
 * Copyright (c) 2013-2023, Esoteric Software LLC
 *
 * Integration of the Spine Runtimes into software or otherwise creating
 * derivative works of the Spine Runtimes is permitted under the terms and
 * conditions of Section 2 of the Spine Editor License Agreement:
 * http://esotericsoftware.com/spine-editor-license
 *
 * Otherwise, it is permitted to integrate the Spine Runtimes into software or
 * otherwise create derivative works of the Spine Runtimes (collectively,
 * "Products"), provided that each user of the Products must obtain their own
 * Spine Editor license and redistribution of the Products in any form must
 * include this license and copyright notice.
 *
 * THE SPINE RUNTIMES ARE PROVIDED BY ESOTERIC SOFTWARE LLC "AS IS" AND ANY
 * EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
 * WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE
 * DISCLAIMED. IN NO EVENT SHALL ESOTERIC SOFTWARE LLC BE LIABLE FOR ANY
 * DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES
 * (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES,
 * BUSINESS INTERRUPTION, OR LOSS OF USE, DATA, OR PROFITS) HOWEVER CAUSED AND
 * ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT
 * (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THE
 * SPINE RUNTIMES, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
 *****************************************************************************/ 

class $2fcc86453abe2c1c$export$d285e3ec07b32800 extends (0, $3c213aed73167a71$export$66d3a0c3be55e044) {
    /** The lengths along the path in the setup pose from the start of the path to the end of each Bezier curve. */ lengths = [];
    /** If true, the start and end knots are connected. */ closed = false;
    /** If true, additional calculations are performed to make calculating positions along the path more accurate. If false, fewer
     * calculations are performed but calculating positions along the path is less accurate. */ constantSpeed = false;
    /** The color of the path as it was in Spine. Available only when nonessential data was exported. Paths are not usually
     * rendered at runtime. */ color = new (0, $1702fa998ec22e58$export$892596cec99bc70e)(1, 1, 1, 1);
    constructor(name){
        super(name);
    }
    copy() {
        let copy = new $2fcc86453abe2c1c$export$d285e3ec07b32800(this.name);
        this.copyTo(copy);
        copy.lengths = new Array(this.lengths.length);
        (0, $1702fa998ec22e58$export$d2ca453b913dcdea).arrayCopy(this.lengths, 0, copy.lengths, 0, this.lengths.length);
        copy.closed = closed;
        copy.constantSpeed = this.constantSpeed;
        copy.color.setFromColor(this.color);
        return copy;
    }
}


/******************************************************************************
 * Spine Runtimes License Agreement
 * Last updated July 28, 2023. Replaces all prior versions.
 *
 * Copyright (c) 2013-2023, Esoteric Software LLC
 *
 * Integration of the Spine Runtimes into software or otherwise creating
 * derivative works of the Spine Runtimes is permitted under the terms and
 * conditions of Section 2 of the Spine Editor License Agreement:
 * http://esotericsoftware.com/spine-editor-license
 *
 * Otherwise, it is permitted to integrate the Spine Runtimes into software or
 * otherwise create derivative works of the Spine Runtimes (collectively,
 * "Products"), provided that each user of the Products must obtain their own
 * Spine Editor license and redistribution of the Products in any form must
 * include this license and copyright notice.
 *
 * THE SPINE RUNTIMES ARE PROVIDED BY ESOTERIC SOFTWARE LLC "AS IS" AND ANY
 * EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
 * WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE
 * DISCLAIMED. IN NO EVENT SHALL ESOTERIC SOFTWARE LLC BE LIABLE FOR ANY
 * DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES
 * (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES,
 * BUSINESS INTERRUPTION, OR LOSS OF USE, DATA, OR PROFITS) HOWEVER CAUSED AND
 * ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT
 * (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THE
 * SPINE RUNTIMES, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
 *****************************************************************************/ 

class $cc4a762d2c6d2eb6$export$1b528cde44a6ab5 extends (0, $3c213aed73167a71$export$66d3a0c3be55e044) {
    x = 0;
    y = 0;
    rotation = 0;
    /** The color of the point attachment as it was in Spine. Available only when nonessential data was exported. Point attachments
     * are not usually rendered at runtime. */ color = new (0, $1702fa998ec22e58$export$892596cec99bc70e)(0.38, 0.94, 0, 1);
    constructor(name){
        super(name);
    }
    computeWorldPosition(bone, point) {
        point.x = this.x * bone.a + this.y * bone.b + bone.worldX;
        point.y = this.x * bone.c + this.y * bone.d + bone.worldY;
        return point;
    }
    computeWorldRotation(bone) {
        let cos = (0, $1702fa998ec22e58$export$6a7ef315a0d1ef07).cosDeg(this.rotation), sin = (0, $1702fa998ec22e58$export$6a7ef315a0d1ef07).sinDeg(this.rotation);
        let x = cos * bone.a + sin * bone.b;
        let y = cos * bone.c + sin * bone.d;
        return Math.atan2(y, x) * (0, $1702fa998ec22e58$export$6a7ef315a0d1ef07).radDeg;
    }
    copy() {
        let copy = new $cc4a762d2c6d2eb6$export$1b528cde44a6ab5(this.name);
        copy.x = this.x;
        copy.y = this.y;
        copy.rotation = this.rotation;
        copy.color.setFromColor(this.color);
        return copy;
    }
}


/******************************************************************************
 * Spine Runtimes License Agreement
 * Last updated July 28, 2023. Replaces all prior versions.
 *
 * Copyright (c) 2013-2023, Esoteric Software LLC
 *
 * Integration of the Spine Runtimes into software or otherwise creating
 * derivative works of the Spine Runtimes is permitted under the terms and
 * conditions of Section 2 of the Spine Editor License Agreement:
 * http://esotericsoftware.com/spine-editor-license
 *
 * Otherwise, it is permitted to integrate the Spine Runtimes into software or
 * otherwise create derivative works of the Spine Runtimes (collectively,
 * "Products"), provided that each user of the Products must obtain their own
 * Spine Editor license and redistribution of the Products in any form must
 * include this license and copyright notice.
 *
 * THE SPINE RUNTIMES ARE PROVIDED BY ESOTERIC SOFTWARE LLC "AS IS" AND ANY
 * EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
 * WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE
 * DISCLAIMED. IN NO EVENT SHALL ESOTERIC SOFTWARE LLC BE LIABLE FOR ANY
 * DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES
 * (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES,
 * BUSINESS INTERRUPTION, OR LOSS OF USE, DATA, OR PROFITS) HOWEVER CAUSED AND
 * ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT
 * (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THE
 * SPINE RUNTIMES, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
 *****************************************************************************/ 

class $6355869a5ef59f02$export$d0fc51466fa6d530 extends (0, $3c213aed73167a71$export$71e4db985cfcf9e3) {
    /** The local x translation. */ x = 0;
    /** The local y translation. */ y = 0;
    /** The local scaleX. */ scaleX = 1;
    /** The local scaleY. */ scaleY = 1;
    /** The local rotation. */ rotation = 0;
    /** The width of the region attachment in Spine. */ width = 0;
    /** The height of the region attachment in Spine. */ height = 0;
    /** The color to tint the region attachment. */ color = new (0, $1702fa998ec22e58$export$892596cec99bc70e)(1, 1, 1, 1);
    /** The name of the texture region for this attachment. */ path;
    region = null;
    sequence = null;
    /** For each of the 4 vertices, a pair of <code>x,y</code> values that is the local position of the vertex.
     *
     * See {@link #updateOffset()}. */ offset = (0, $1702fa998ec22e58$export$d2ca453b913dcdea).newFloatArray(8);
    uvs = (0, $1702fa998ec22e58$export$d2ca453b913dcdea).newFloatArray(8);
    tempColor = new (0, $1702fa998ec22e58$export$892596cec99bc70e)(1, 1, 1, 1);
    constructor(name, path){
        super(name);
        this.path = path;
    }
    /** Calculates the {@link #offset} using the region settings. Must be called after changing region settings. */ updateRegion() {
        if (!this.region) throw new Error("Region not set.");
        let region = this.region;
        let uvs = this.uvs;
        if (region == null) {
            uvs[0] = 0;
            uvs[1] = 0;
            uvs[2] = 0;
            uvs[3] = 1;
            uvs[4] = 1;
            uvs[5] = 1;
            uvs[6] = 1;
            uvs[7] = 0;
            return;
        }
        let regionScaleX = this.width / this.region.originalWidth * this.scaleX;
        let regionScaleY = this.height / this.region.originalHeight * this.scaleY;
        let localX = -this.width / 2 * this.scaleX + this.region.offsetX * regionScaleX;
        let localY = -this.height / 2 * this.scaleY + this.region.offsetY * regionScaleY;
        let localX2 = localX + this.region.width * regionScaleX;
        let localY2 = localY + this.region.height * regionScaleY;
        let radians = this.rotation * Math.PI / 180;
        let cos = Math.cos(radians);
        let sin = Math.sin(radians);
        let x = this.x, y = this.y;
        let localXCos = localX * cos + x;
        let localXSin = localX * sin;
        let localYCos = localY * cos + y;
        let localYSin = localY * sin;
        let localX2Cos = localX2 * cos + x;
        let localX2Sin = localX2 * sin;
        let localY2Cos = localY2 * cos + y;
        let localY2Sin = localY2 * sin;
        let offset = this.offset;
        offset[0] = localXCos - localYSin;
        offset[1] = localYCos + localXSin;
        offset[2] = localXCos - localY2Sin;
        offset[3] = localY2Cos + localXSin;
        offset[4] = localX2Cos - localY2Sin;
        offset[5] = localY2Cos + localX2Sin;
        offset[6] = localX2Cos - localYSin;
        offset[7] = localYCos + localX2Sin;
        if (region.degrees == 90) {
            uvs[0] = region.u2;
            uvs[1] = region.v2;
            uvs[2] = region.u;
            uvs[3] = region.v2;
            uvs[4] = region.u;
            uvs[5] = region.v;
            uvs[6] = region.u2;
            uvs[7] = region.v;
        } else {
            uvs[0] = region.u;
            uvs[1] = region.v2;
            uvs[2] = region.u;
            uvs[3] = region.v;
            uvs[4] = region.u2;
            uvs[5] = region.v;
            uvs[6] = region.u2;
            uvs[7] = region.v2;
        }
    }
    /** Transforms the attachment's four vertices to world coordinates. If the attachment has a {@link #sequence}, the region may
     * be changed.
     * <p>
     * See <a href="http://esotericsoftware.com/spine-runtime-skeletons#World-transforms">World transforms</a> in the Spine
     * Runtimes Guide.
     * @param worldVertices The output world vertices. Must have a length >= <code>offset</code> + 8.
     * @param offset The <code>worldVertices</code> index to begin writing values.
     * @param stride The number of <code>worldVertices</code> entries between the value pairs written. */ computeWorldVertices(slot, worldVertices, offset, stride) {
        if (this.sequence != null) this.sequence.apply(slot, this);
        let bone = slot.bone;
        let vertexOffset = this.offset;
        let x = bone.worldX, y = bone.worldY;
        let a = bone.a, b = bone.b, c = bone.c, d = bone.d;
        let offsetX = 0, offsetY = 0;
        offsetX = vertexOffset[0];
        offsetY = vertexOffset[1];
        worldVertices[offset] = offsetX * a + offsetY * b + x; // br
        worldVertices[offset + 1] = offsetX * c + offsetY * d + y;
        offset += stride;
        offsetX = vertexOffset[2];
        offsetY = vertexOffset[3];
        worldVertices[offset] = offsetX * a + offsetY * b + x; // bl
        worldVertices[offset + 1] = offsetX * c + offsetY * d + y;
        offset += stride;
        offsetX = vertexOffset[4];
        offsetY = vertexOffset[5];
        worldVertices[offset] = offsetX * a + offsetY * b + x; // ul
        worldVertices[offset + 1] = offsetX * c + offsetY * d + y;
        offset += stride;
        offsetX = vertexOffset[6];
        offsetY = vertexOffset[7];
        worldVertices[offset] = offsetX * a + offsetY * b + x; // ur
        worldVertices[offset + 1] = offsetX * c + offsetY * d + y;
    }
    copy() {
        let copy = new $6355869a5ef59f02$export$d0fc51466fa6d530(this.name, this.path);
        copy.region = this.region;
        copy.x = this.x;
        copy.y = this.y;
        copy.scaleX = this.scaleX;
        copy.scaleY = this.scaleY;
        copy.rotation = this.rotation;
        copy.width = this.width;
        copy.height = this.height;
        (0, $1702fa998ec22e58$export$d2ca453b913dcdea).arrayCopy(this.uvs, 0, copy.uvs, 0, 8);
        (0, $1702fa998ec22e58$export$d2ca453b913dcdea).arrayCopy(this.offset, 0, copy.offset, 0, 8);
        copy.color.setFromColor(this.color);
        copy.sequence = this.sequence != null ? this.sequence.copy() : null;
        return copy;
    }
    static X1 = 0;
    static Y1 = 1;
    static C1R = 2;
    static C1G = 3;
    static C1B = 4;
    static C1A = 5;
    static U1 = 6;
    static V1 = 7;
    static X2 = 8;
    static Y2 = 9;
    static C2R = 10;
    static C2G = 11;
    static C2B = 12;
    static C2A = 13;
    static U2 = 14;
    static V2 = 15;
    static X3 = 16;
    static Y3 = 17;
    static C3R = 18;
    static C3G = 19;
    static C3B = 20;
    static C3A = 21;
    static U3 = 22;
    static V3 = 23;
    static X4 = 24;
    static Y4 = 25;
    static C4R = 26;
    static C4G = 27;
    static C4B = 28;
    static C4A = 29;
    static U4 = 30;
    static V4 = 31;
}


class $1b8eecdee9c89b5e$export$2ff9add835475d95 {
    atlas;
    constructor(atlas){
        this.atlas = atlas;
    }
    loadSequence(name, basePath, sequence) {
        let regions = sequence.regions;
        for(let i = 0, n = regions.length; i < n; i++){
            let path = sequence.getPath(basePath, i);
            let region = this.atlas.findRegion(path);
            if (region == null) throw new Error("Region not found in atlas: " + path + " (sequence: " + name + ")");
            regions[i] = region;
        }
    }
    newRegionAttachment(skin, name, path, sequence) {
        let attachment = new (0, $6355869a5ef59f02$export$d0fc51466fa6d530)(name, path);
        if (sequence != null) this.loadSequence(name, path, sequence);
        else {
            let region = this.atlas.findRegion(path);
            if (!region) throw new Error("Region not found in atlas: " + path + " (region attachment: " + name + ")");
            attachment.region = region;
        }
        return attachment;
    }
    newMeshAttachment(skin, name, path, sequence) {
        let attachment = new (0, $3ed5c5afaf00d170$export$3f1c1692adfcf3e2)(name, path);
        if (sequence != null) this.loadSequence(name, path, sequence);
        else {
            let region = this.atlas.findRegion(path);
            if (!region) throw new Error("Region not found in atlas: " + path + " (mesh attachment: " + name + ")");
            attachment.region = region;
        }
        return attachment;
    }
    newBoundingBoxAttachment(skin, name) {
        return new (0, $4ed11088ab57e209$export$9538c439c6b85ad2)(name);
    }
    newPathAttachment(skin, name) {
        return new (0, $2fcc86453abe2c1c$export$d285e3ec07b32800)(name);
    }
    newPointAttachment(skin, name) {
        return new (0, $cc4a762d2c6d2eb6$export$1b528cde44a6ab5)(name);
    }
    newClippingAttachment(skin, name) {
        return new (0, $c8cbdfdbe3e3034c$export$838805e22b9b55f1)(name);
    }
}


/******************************************************************************
 * Spine Runtimes License Agreement
 * Last updated July 28, 2023. Replaces all prior versions.
 *
 * Copyright (c) 2013-2023, Esoteric Software LLC
 *
 * Integration of the Spine Runtimes into software or otherwise creating
 * derivative works of the Spine Runtimes is permitted under the terms and
 * conditions of Section 2 of the Spine Editor License Agreement:
 * http://esotericsoftware.com/spine-editor-license
 *
 * Otherwise, it is permitted to integrate the Spine Runtimes into software or
 * otherwise create derivative works of the Spine Runtimes (collectively,
 * "Products"), provided that each user of the Products must obtain their own
 * Spine Editor license and redistribution of the Products in any form must
 * include this license and copyright notice.
 *
 * THE SPINE RUNTIMES ARE PROVIDED BY ESOTERIC SOFTWARE LLC "AS IS" AND ANY
 * EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
 * WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE
 * DISCLAIMED. IN NO EVENT SHALL ESOTERIC SOFTWARE LLC BE LIABLE FOR ANY
 * DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES
 * (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES,
 * BUSINESS INTERRUPTION, OR LOSS OF USE, DATA, OR PROFITS) HOWEVER CAUSED AND
 * ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT
 * (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THE
 * SPINE RUNTIMES, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
 *****************************************************************************/ /******************************************************************************
 * Spine Runtimes License Agreement
 * Last updated July 28, 2023. Replaces all prior versions.
 *
 * Copyright (c) 2013-2023, Esoteric Software LLC
 *
 * Integration of the Spine Runtimes into software or otherwise creating
 * derivative works of the Spine Runtimes is permitted under the terms and
 * conditions of Section 2 of the Spine Editor License Agreement:
 * http://esotericsoftware.com/spine-editor-license
 *
 * Otherwise, it is permitted to integrate the Spine Runtimes into software or
 * otherwise create derivative works of the Spine Runtimes (collectively,
 * "Products"), provided that each user of the Products must obtain their own
 * Spine Editor license and redistribution of the Products in any form must
 * include this license and copyright notice.
 *
 * THE SPINE RUNTIMES ARE PROVIDED BY ESOTERIC SOFTWARE LLC "AS IS" AND ANY
 * EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
 * WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE
 * DISCLAIMED. IN NO EVENT SHALL ESOTERIC SOFTWARE LLC BE LIABLE FOR ANY
 * DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES
 * (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES,
 * BUSINESS INTERRUPTION, OR LOSS OF USE, DATA, OR PROFITS) HOWEVER CAUSED AND
 * ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT
 * (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THE
 * SPINE RUNTIMES, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
 *****************************************************************************/ 
class $15d066d20c83b36f$export$7d85d96cf093e12f {
    /** The index of the bone in {@link Skeleton#getBones()}. */ index = 0;
    /** The name of the bone, which is unique across all bones in the skeleton. */ name;
    /** @returns May be null. */ parent = null;
    /** The bone's length. */ length = 0;
    /** The local x translation. */ x = 0;
    /** The local y translation. */ y = 0;
    /** The local rotation. */ rotation = 0;
    /** The local scaleX. */ scaleX = 1;
    /** The local scaleY. */ scaleY = 1;
    /** The local shearX. */ shearX = 0;
    /** The local shearX. */ shearY = 0;
    /** The transform mode for how parent world transforms affect this bone. */ transformMode = $15d066d20c83b36f$export$4c408f82786a534d.Normal;
    /** When true, {@link Skeleton#updateWorldTransform()} only updates this bone if the {@link Skeleton#skin} contains this
      * bone.
      * @see Skin#bones */ skinRequired = false;
    /** The color of the bone as it was in Spine. Available only when nonessential data was exported. Bones are not usually
     * rendered at runtime. */ color = new (0, $1702fa998ec22e58$export$892596cec99bc70e)();
    constructor(index, name, parent){
        if (index < 0) throw new Error("index must be >= 0.");
        if (!name) throw new Error("name cannot be null.");
        this.index = index;
        this.name = name;
        this.parent = parent;
    }
}
var $15d066d20c83b36f$export$4c408f82786a534d;
(function(TransformMode) {
    TransformMode[TransformMode["Normal"] = 0] = "Normal";
    TransformMode[TransformMode["OnlyTranslation"] = 1] = "OnlyTranslation";
    TransformMode[TransformMode["NoRotationOrReflection"] = 2] = "NoRotationOrReflection";
    TransformMode[TransformMode["NoScale"] = 3] = "NoScale";
    TransformMode[TransformMode["NoScaleOrReflection"] = 4] = "NoScaleOrReflection";
})($15d066d20c83b36f$export$4c408f82786a534d || ($15d066d20c83b36f$export$4c408f82786a534d = {}));



class $40c15a4a15521c66$export$b127726e56765aa4 {
    /** The bone's setup pose data. */ data;
    /** The skeleton this bone belongs to. */ skeleton;
    /** The parent bone, or null if this is the root bone. */ parent = null;
    /** The immediate children of this bone. */ children = new Array();
    /** The local x translation. */ x = 0;
    /** The local y translation. */ y = 0;
    /** The local rotation in degrees, counter clockwise. */ rotation = 0;
    /** The local scaleX. */ scaleX = 0;
    /** The local scaleY. */ scaleY = 0;
    /** The local shearX. */ shearX = 0;
    /** The local shearY. */ shearY = 0;
    /** The applied local x translation. */ ax = 0;
    /** The applied local y translation. */ ay = 0;
    /** The applied local rotation in degrees, counter clockwise. */ arotation = 0;
    /** The applied local scaleX. */ ascaleX = 0;
    /** The applied local scaleY. */ ascaleY = 0;
    /** The applied local shearX. */ ashearX = 0;
    /** The applied local shearY. */ ashearY = 0;
    /** Part of the world transform matrix for the X axis. If changed, {@link #updateAppliedTransform()} should be called. */ a = 0;
    /** Part of the world transform matrix for the Y axis. If changed, {@link #updateAppliedTransform()} should be called. */ b = 0;
    /** Part of the world transform matrix for the X axis. If changed, {@link #updateAppliedTransform()} should be called. */ c = 0;
    /** Part of the world transform matrix for the Y axis. If changed, {@link #updateAppliedTransform()} should be called. */ d = 0;
    /** The world X position. If changed, {@link #updateAppliedTransform()} should be called. */ worldY = 0;
    /** The world Y position. If changed, {@link #updateAppliedTransform()} should be called. */ worldX = 0;
    sorted = false;
    active = false;
    /** @param parent May be null. */ constructor(data, skeleton, parent){
        if (!data) throw new Error("data cannot be null.");
        if (!skeleton) throw new Error("skeleton cannot be null.");
        this.data = data;
        this.skeleton = skeleton;
        this.parent = parent;
        this.setToSetupPose();
    }
    /** Returns false when the bone has not been computed because {@link BoneData#skinRequired} is true and the
      * {@link Skeleton#skin active skin} does not {@link Skin#bones contain} this bone. */ isActive() {
        return this.active;
    }
    /** Computes the world transform using the parent bone and this bone's local applied transform. */ update() {
        this.updateWorldTransformWith(this.ax, this.ay, this.arotation, this.ascaleX, this.ascaleY, this.ashearX, this.ashearY);
    }
    /** Computes the world transform using the parent bone and this bone's local transform.
     *
     * See {@link #updateWorldTransformWith()}. */ updateWorldTransform() {
        this.updateWorldTransformWith(this.x, this.y, this.rotation, this.scaleX, this.scaleY, this.shearX, this.shearY);
    }
    /** Computes the world transform using the parent bone and the specified local transform. The applied transform is set to the
     * specified local transform. Child bones are not updated.
     *
     * See [World transforms](http://esotericsoftware.com/spine-runtime-skeletons#World-transforms) in the Spine
     * Runtimes Guide. */ updateWorldTransformWith(x, y, rotation, scaleX, scaleY, shearX, shearY) {
        this.ax = x;
        this.ay = y;
        this.arotation = rotation;
        this.ascaleX = scaleX;
        this.ascaleY = scaleY;
        this.ashearX = shearX;
        this.ashearY = shearY;
        let parent = this.parent;
        if (!parent) {
            let skeleton = this.skeleton;
            let rotationY = rotation + 90 + shearY;
            let sx = skeleton.scaleX;
            let sy = skeleton.scaleY;
            this.a = (0, $1702fa998ec22e58$export$6a7ef315a0d1ef07).cosDeg(rotation + shearX) * scaleX * sx;
            this.b = (0, $1702fa998ec22e58$export$6a7ef315a0d1ef07).cosDeg(rotationY) * scaleY * sx;
            this.c = (0, $1702fa998ec22e58$export$6a7ef315a0d1ef07).sinDeg(rotation + shearX) * scaleX * sy;
            this.d = (0, $1702fa998ec22e58$export$6a7ef315a0d1ef07).sinDeg(rotationY) * scaleY * sy;
            this.worldX = x * sx + skeleton.x;
            this.worldY = y * sy + skeleton.y;
            return;
        }
        let pa = parent.a, pb = parent.b, pc = parent.c, pd = parent.d;
        this.worldX = pa * x + pb * y + parent.worldX;
        this.worldY = pc * x + pd * y + parent.worldY;
        switch(this.data.transformMode){
            case (0, $15d066d20c83b36f$export$4c408f82786a534d).Normal:
                {
                    let rotationY = rotation + 90 + shearY;
                    let la = (0, $1702fa998ec22e58$export$6a7ef315a0d1ef07).cosDeg(rotation + shearX) * scaleX;
                    let lb = (0, $1702fa998ec22e58$export$6a7ef315a0d1ef07).cosDeg(rotationY) * scaleY;
                    let lc = (0, $1702fa998ec22e58$export$6a7ef315a0d1ef07).sinDeg(rotation + shearX) * scaleX;
                    let ld = (0, $1702fa998ec22e58$export$6a7ef315a0d1ef07).sinDeg(rotationY) * scaleY;
                    this.a = pa * la + pb * lc;
                    this.b = pa * lb + pb * ld;
                    this.c = pc * la + pd * lc;
                    this.d = pc * lb + pd * ld;
                    return;
                }
            case (0, $15d066d20c83b36f$export$4c408f82786a534d).OnlyTranslation:
                {
                    let rotationY = rotation + 90 + shearY;
                    this.a = (0, $1702fa998ec22e58$export$6a7ef315a0d1ef07).cosDeg(rotation + shearX) * scaleX;
                    this.b = (0, $1702fa998ec22e58$export$6a7ef315a0d1ef07).cosDeg(rotationY) * scaleY;
                    this.c = (0, $1702fa998ec22e58$export$6a7ef315a0d1ef07).sinDeg(rotation + shearX) * scaleX;
                    this.d = (0, $1702fa998ec22e58$export$6a7ef315a0d1ef07).sinDeg(rotationY) * scaleY;
                    break;
                }
            case (0, $15d066d20c83b36f$export$4c408f82786a534d).NoRotationOrReflection:
                {
                    let s = pa * pa + pc * pc;
                    let prx = 0;
                    if (s > 0.0001) {
                        s = Math.abs(pa * pd - pb * pc) / s;
                        pa /= this.skeleton.scaleX;
                        pc /= this.skeleton.scaleY;
                        pb = pc * s;
                        pd = pa * s;
                        prx = Math.atan2(pc, pa) * (0, $1702fa998ec22e58$export$6a7ef315a0d1ef07).radDeg;
                    } else {
                        pa = 0;
                        pc = 0;
                        prx = 90 - Math.atan2(pd, pb) * (0, $1702fa998ec22e58$export$6a7ef315a0d1ef07).radDeg;
                    }
                    let rx = rotation + shearX - prx;
                    let ry = rotation + shearY - prx + 90;
                    let la = (0, $1702fa998ec22e58$export$6a7ef315a0d1ef07).cosDeg(rx) * scaleX;
                    let lb = (0, $1702fa998ec22e58$export$6a7ef315a0d1ef07).cosDeg(ry) * scaleY;
                    let lc = (0, $1702fa998ec22e58$export$6a7ef315a0d1ef07).sinDeg(rx) * scaleX;
                    let ld = (0, $1702fa998ec22e58$export$6a7ef315a0d1ef07).sinDeg(ry) * scaleY;
                    this.a = pa * la - pb * lc;
                    this.b = pa * lb - pb * ld;
                    this.c = pc * la + pd * lc;
                    this.d = pc * lb + pd * ld;
                    break;
                }
            case (0, $15d066d20c83b36f$export$4c408f82786a534d).NoScale:
            case (0, $15d066d20c83b36f$export$4c408f82786a534d).NoScaleOrReflection:
                {
                    let cos = (0, $1702fa998ec22e58$export$6a7ef315a0d1ef07).cosDeg(rotation);
                    let sin = (0, $1702fa998ec22e58$export$6a7ef315a0d1ef07).sinDeg(rotation);
                    let za = (pa * cos + pb * sin) / this.skeleton.scaleX;
                    let zc = (pc * cos + pd * sin) / this.skeleton.scaleY;
                    let s = Math.sqrt(za * za + zc * zc);
                    if (s > 0.00001) s = 1 / s;
                    za *= s;
                    zc *= s;
                    s = Math.sqrt(za * za + zc * zc);
                    if (this.data.transformMode == (0, $15d066d20c83b36f$export$4c408f82786a534d).NoScale && pa * pd - pb * pc < 0 != (this.skeleton.scaleX < 0 != this.skeleton.scaleY < 0)) s = -s;
                    let r = Math.PI / 2 + Math.atan2(zc, za);
                    let zb = Math.cos(r) * s;
                    let zd = Math.sin(r) * s;
                    let la = (0, $1702fa998ec22e58$export$6a7ef315a0d1ef07).cosDeg(shearX) * scaleX;
                    let lb = (0, $1702fa998ec22e58$export$6a7ef315a0d1ef07).cosDeg(90 + shearY) * scaleY;
                    let lc = (0, $1702fa998ec22e58$export$6a7ef315a0d1ef07).sinDeg(shearX) * scaleX;
                    let ld = (0, $1702fa998ec22e58$export$6a7ef315a0d1ef07).sinDeg(90 + shearY) * scaleY;
                    this.a = za * la + zb * lc;
                    this.b = za * lb + zb * ld;
                    this.c = zc * la + zd * lc;
                    this.d = zc * lb + zd * ld;
                    break;
                }
        }
        this.a *= this.skeleton.scaleX;
        this.b *= this.skeleton.scaleX;
        this.c *= this.skeleton.scaleY;
        this.d *= this.skeleton.scaleY;
    }
    /** Sets this bone's local transform to the setup pose. */ setToSetupPose() {
        let data = this.data;
        this.x = data.x;
        this.y = data.y;
        this.rotation = data.rotation;
        this.scaleX = data.scaleX;
        this.scaleY = data.scaleY;
        this.shearX = data.shearX;
        this.shearY = data.shearY;
    }
    /** The world rotation for the X axis, calculated using {@link #a} and {@link #c}. */ getWorldRotationX() {
        return Math.atan2(this.c, this.a) * (0, $1702fa998ec22e58$export$6a7ef315a0d1ef07).radDeg;
    }
    /** The world rotation for the Y axis, calculated using {@link #b} and {@link #d}. */ getWorldRotationY() {
        return Math.atan2(this.d, this.b) * (0, $1702fa998ec22e58$export$6a7ef315a0d1ef07).radDeg;
    }
    /** The magnitude (always positive) of the world scale X, calculated using {@link #a} and {@link #c}. */ getWorldScaleX() {
        return Math.sqrt(this.a * this.a + this.c * this.c);
    }
    /** The magnitude (always positive) of the world scale Y, calculated using {@link #b} and {@link #d}. */ getWorldScaleY() {
        return Math.sqrt(this.b * this.b + this.d * this.d);
    }
    /** Computes the applied transform values from the world transform.
     *
     * If the world transform is modified (by a constraint, {@link #rotateWorld(float)}, etc) then this method should be called so
     * the applied transform matches the world transform. The applied transform may be needed by other code (eg to apply other
     * constraints).
     *
     * Some information is ambiguous in the world transform, such as -1,-1 scale versus 180 rotation. The applied transform after
     * calling this method is equivalent to the local transform used to compute the world transform, but may not be identical. */ updateAppliedTransform() {
        let parent = this.parent;
        if (!parent) {
            this.ax = this.worldX - this.skeleton.x;
            this.ay = this.worldY - this.skeleton.y;
            this.arotation = Math.atan2(this.c, this.a) * (0, $1702fa998ec22e58$export$6a7ef315a0d1ef07).radDeg;
            this.ascaleX = Math.sqrt(this.a * this.a + this.c * this.c);
            this.ascaleY = Math.sqrt(this.b * this.b + this.d * this.d);
            this.ashearX = 0;
            this.ashearY = Math.atan2(this.a * this.b + this.c * this.d, this.a * this.d - this.b * this.c) * (0, $1702fa998ec22e58$export$6a7ef315a0d1ef07).radDeg;
            return;
        }
        let pa = parent.a, pb = parent.b, pc = parent.c, pd = parent.d;
        let pid = 1 / (pa * pd - pb * pc);
        let ia = pd * pid, ib = pb * pid, ic = pc * pid, id = pa * pid;
        let dx = this.worldX - parent.worldX, dy = this.worldY - parent.worldY;
        this.ax = dx * ia - dy * ib;
        this.ay = dy * id - dx * ic;
        let ra, rb, rc, rd;
        if (this.data.transformMode == (0, $15d066d20c83b36f$export$4c408f82786a534d).OnlyTranslation) {
            ra = this.a;
            rb = this.b;
            rc = this.c;
            rd = this.d;
        } else {
            switch(this.data.transformMode){
                case (0, $15d066d20c83b36f$export$4c408f82786a534d).NoRotationOrReflection:
                    {
                        let s = Math.abs(pa * pd - pb * pc) / (pa * pa + pc * pc);
                        let sa = pa / this.skeleton.scaleX;
                        let sc = pc / this.skeleton.scaleY;
                        pb = -sc * s * this.skeleton.scaleX;
                        pd = sa * s * this.skeleton.scaleY;
                        pid = 1 / (pa * pd - pb * pc);
                        ia = pd * pid;
                        ib = pb * pid;
                        break;
                    }
                case (0, $15d066d20c83b36f$export$4c408f82786a534d).NoScale:
                case (0, $15d066d20c83b36f$export$4c408f82786a534d).NoScaleOrReflection:
                    let cos = (0, $1702fa998ec22e58$export$6a7ef315a0d1ef07).cosDeg(this.rotation), sin = (0, $1702fa998ec22e58$export$6a7ef315a0d1ef07).sinDeg(this.rotation);
                    pa = (pa * cos + pb * sin) / this.skeleton.scaleX;
                    pc = (pc * cos + pd * sin) / this.skeleton.scaleY;
                    let s = Math.sqrt(pa * pa + pc * pc);
                    if (s > 0.00001) s = 1 / s;
                    pa *= s;
                    pc *= s;
                    s = Math.sqrt(pa * pa + pc * pc);
                    if (this.data.transformMode == (0, $15d066d20c83b36f$export$4c408f82786a534d).NoScale && pid < 0 != (this.skeleton.scaleX < 0 != this.skeleton.scaleY < 0)) s = -s;
                    let r = (0, $1702fa998ec22e58$export$6a7ef315a0d1ef07).PI / 2 + Math.atan2(pc, pa);
                    pb = Math.cos(r) * s;
                    pd = Math.sin(r) * s;
                    pid = 1 / (pa * pd - pb * pc);
                    ia = pd * pid;
                    ib = pb * pid;
                    ic = pc * pid;
                    id = pa * pid;
            }
            ra = ia * this.a - ib * this.c;
            rb = ia * this.b - ib * this.d;
            rc = id * this.c - ic * this.a;
            rd = id * this.d - ic * this.b;
        }
        this.ashearX = 0;
        this.ascaleX = Math.sqrt(ra * ra + rc * rc);
        if (this.ascaleX > 0.0001) {
            let det = ra * rd - rb * rc;
            this.ascaleY = det / this.ascaleX;
            this.ashearY = -Math.atan2(ra * rb + rc * rd, det) * (0, $1702fa998ec22e58$export$6a7ef315a0d1ef07).radDeg;
            this.arotation = Math.atan2(rc, ra) * (0, $1702fa998ec22e58$export$6a7ef315a0d1ef07).radDeg;
        } else {
            this.ascaleX = 0;
            this.ascaleY = Math.sqrt(rb * rb + rd * rd);
            this.ashearY = 0;
            this.arotation = 90 - Math.atan2(rd, rb) * (0, $1702fa998ec22e58$export$6a7ef315a0d1ef07).radDeg;
        }
    }
    /** Transforms a point from world coordinates to the bone's local coordinates. */ worldToLocal(world) {
        let invDet = 1 / (this.a * this.d - this.b * this.c);
        let x = world.x - this.worldX, y = world.y - this.worldY;
        world.x = x * this.d * invDet - y * this.b * invDet;
        world.y = y * this.a * invDet - x * this.c * invDet;
        return world;
    }
    /** Transforms a point from the bone's local coordinates to world coordinates. */ localToWorld(local) {
        let x = local.x, y = local.y;
        local.x = x * this.a + y * this.b + this.worldX;
        local.y = x * this.c + y * this.d + this.worldY;
        return local;
    }
    /** Transforms a world rotation to a local rotation. */ worldToLocalRotation(worldRotation) {
        let sin = (0, $1702fa998ec22e58$export$6a7ef315a0d1ef07).sinDeg(worldRotation), cos = (0, $1702fa998ec22e58$export$6a7ef315a0d1ef07).cosDeg(worldRotation);
        return Math.atan2(this.a * sin - this.c * cos, this.d * cos - this.b * sin) * (0, $1702fa998ec22e58$export$6a7ef315a0d1ef07).radDeg + this.rotation - this.shearX;
    }
    /** Transforms a local rotation to a world rotation. */ localToWorldRotation(localRotation) {
        localRotation -= this.rotation - this.shearX;
        let sin = (0, $1702fa998ec22e58$export$6a7ef315a0d1ef07).sinDeg(localRotation), cos = (0, $1702fa998ec22e58$export$6a7ef315a0d1ef07).cosDeg(localRotation);
        return Math.atan2(cos * this.c + sin * this.d, cos * this.a + sin * this.b) * (0, $1702fa998ec22e58$export$6a7ef315a0d1ef07).radDeg;
    }
    /** Rotates the world transform the specified amount.
     * <p>
     * After changes are made to the world transform, {@link #updateAppliedTransform()} should be called and {@link #update()} will
     * need to be called on any child bones, recursively. */ rotateWorld(degrees) {
        let a = this.a, b = this.b, c = this.c, d = this.d;
        let cos = (0, $1702fa998ec22e58$export$6a7ef315a0d1ef07).cosDeg(degrees), sin = (0, $1702fa998ec22e58$export$6a7ef315a0d1ef07).sinDeg(degrees);
        this.a = cos * a - sin * c;
        this.b = cos * b - sin * d;
        this.c = sin * a + cos * c;
        this.d = sin * b + cos * d;
    }
}



/******************************************************************************
 * Spine Runtimes License Agreement
 * Last updated July 28, 2023. Replaces all prior versions.
 *
 * Copyright (c) 2013-2023, Esoteric Software LLC
 *
 * Integration of the Spine Runtimes into software or otherwise creating
 * derivative works of the Spine Runtimes is permitted under the terms and
 * conditions of Section 2 of the Spine Editor License Agreement:
 * http://esotericsoftware.com/spine-editor-license
 *
 * Otherwise, it is permitted to integrate the Spine Runtimes into software or
 * otherwise create derivative works of the Spine Runtimes (collectively,
 * "Products"), provided that each user of the Products must obtain their own
 * Spine Editor license and redistribution of the Products in any form must
 * include this license and copyright notice.
 *
 * THE SPINE RUNTIMES ARE PROVIDED BY ESOTERIC SOFTWARE LLC "AS IS" AND ANY
 * EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
 * WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE
 * DISCLAIMED. IN NO EVENT SHALL ESOTERIC SOFTWARE LLC BE LIABLE FOR ANY
 * DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES
 * (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES,
 * BUSINESS INTERRUPTION, OR LOSS OF USE, DATA, OR PROFITS) HOWEVER CAUSED AND
 * ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT
 * (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THE
 * SPINE RUNTIMES, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
 *****************************************************************************/ /** The base class for all constraint datas. */ class $a1d4de5372395191$export$b826e1ab3af63566 {
    name;
    order;
    skinRequired;
    constructor(name, order, skinRequired){
        this.name = name;
        this.order = order;
        this.skinRequired = skinRequired;
    }
}


/******************************************************************************
 * Spine Runtimes License Agreement
 * Last updated July 28, 2023. Replaces all prior versions.
 *
 * Copyright (c) 2013-2023, Esoteric Software LLC
 *
 * Integration of the Spine Runtimes into software or otherwise creating
 * derivative works of the Spine Runtimes is permitted under the terms and
 * conditions of Section 2 of the Spine Editor License Agreement:
 * http://esotericsoftware.com/spine-editor-license
 *
 * Otherwise, it is permitted to integrate the Spine Runtimes into software or
 * otherwise create derivative works of the Spine Runtimes (collectively,
 * "Products"), provided that each user of the Products must obtain their own
 * Spine Editor license and redistribution of the Products in any form must
 * include this license and copyright notice.
 *
 * THE SPINE RUNTIMES ARE PROVIDED BY ESOTERIC SOFTWARE LLC "AS IS" AND ANY
 * EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
 * WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE
 * DISCLAIMED. IN NO EVENT SHALL ESOTERIC SOFTWARE LLC BE LIABLE FOR ANY
 * DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES
 * (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES,
 * BUSINESS INTERRUPTION, OR LOSS OF USE, DATA, OR PROFITS) HOWEVER CAUSED AND
 * ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT
 * (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THE
 * SPINE RUNTIMES, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
 *****************************************************************************/ 
class $f2a2fac98ed0510e$export$d187693bfb349728 {
    pathPrefix = "";
    textureLoader;
    downloader;
    assets = {};
    errors = {};
    toLoad = 0;
    loaded = 0;
    constructor(textureLoader, pathPrefix = "", downloader = new $f2a2fac98ed0510e$export$ef06e7620d37c296()){
        this.textureLoader = textureLoader;
        this.pathPrefix = pathPrefix;
        this.downloader = downloader;
    }
    start(path) {
        this.toLoad++;
        return this.pathPrefix + path;
    }
    success(callback, path, asset) {
        this.toLoad--;
        this.loaded++;
        this.assets[path] = asset;
        if (callback) callback(path, asset);
    }
    error(callback, path, message) {
        this.toLoad--;
        this.loaded++;
        this.errors[path] = message;
        if (callback) callback(path, message);
    }
    loadAll() {
        let promise = new Promise((resolve, reject)=>{
            let check = ()=>{
                if (this.isLoadingComplete()) {
                    if (this.hasErrors()) reject(this.errors);
                    else resolve(this);
                    return;
                }
                requestAnimationFrame(check);
            };
            requestAnimationFrame(check);
        });
        return promise;
    }
    setRawDataURI(path, data) {
        this.downloader.rawDataUris[this.pathPrefix + path] = data;
    }
    loadBinary(path, success = ()=>{}, error = ()=>{}) {
        path = this.start(path);
        this.downloader.downloadBinary(path, (data)=>{
            this.success(success, path, data);
        }, (status, responseText)=>{
            this.error(error, path, `Couldn't load binary ${path}: status ${status}, ${responseText}`);
        });
    }
    loadText(path, success = ()=>{}, error = ()=>{}) {
        path = this.start(path);
        this.downloader.downloadText(path, (data)=>{
            this.success(success, path, data);
        }, (status, responseText)=>{
            this.error(error, path, `Couldn't load text ${path}: status ${status}, ${responseText}`);
        });
    }
    loadJson(path, success = ()=>{}, error = ()=>{}) {
        path = this.start(path);
        this.downloader.downloadJson(path, (data)=>{
            this.success(success, path, data);
        }, (status, responseText)=>{
            this.error(error, path, `Couldn't load JSON ${path}: status ${status}, ${responseText}`);
        });
    }
    loadTexture(path, success = ()=>{}, error = ()=>{}) {
        path = this.start(path);
        let isBrowser = !!(typeof window !== "undefined" && typeof navigator !== "undefined" && window.document);
        let isWebWorker = !isBrowser; // && typeof importScripts !== 'undefined';
        if (isWebWorker) fetch(path, {
            mode: "cors"
        }).then((response)=>{
            if (response.ok) return response.blob();
            this.error(error, path, `Couldn't load image: ${path}`);
            return null;
        }).then((blob)=>{
            return blob ? createImageBitmap(blob, {
                premultiplyAlpha: "none",
                colorSpaceConversion: "none"
            }) : null;
        }).then((bitmap)=>{
            if (bitmap) this.success(success, path, this.textureLoader(bitmap));
        });
        else {
            let image = new Image();
            image.crossOrigin = "anonymous";
            image.onload = ()=>{
                this.success(success, path, this.textureLoader(image));
            };
            image.onerror = ()=>{
                this.error(error, path, `Couldn't load image: ${path}`);
            };
            if (this.downloader.rawDataUris[path]) path = this.downloader.rawDataUris[path];
            image.src = path;
        }
    }
    loadTextureAtlas(path, success = ()=>{}, error = ()=>{}, fileAlias) {
        let index = path.lastIndexOf("/");
        let parent = index >= 0 ? path.substring(0, index + 1) : "";
        path = this.start(path);
        this.downloader.downloadText(path, (atlasText)=>{
            try {
                let atlas = new (0, $959dc053f9cefaa3$export$1ffc3159823e6649)(atlasText);
                let toLoad = atlas.pages.length, abort = false;
                for (let page of atlas.pages)this.loadTexture(!fileAlias ? parent + page.name : fileAlias[page.name], (imagePath, texture)=>{
                    if (!abort) {
                        page.setTexture(texture);
                        if (--toLoad == 0) this.success(success, path, atlas);
                    }
                }, (imagePath, message)=>{
                    if (!abort) this.error(error, path, `Couldn't load texture atlas ${path} page image: ${imagePath}`);
                    abort = true;
                });
            } catch (e) {
                this.error(error, path, `Couldn't parse texture atlas ${path}: ${e.message}`);
            }
        }, (status, responseText)=>{
            this.error(error, path, `Couldn't load texture atlas ${path}: status ${status}, ${responseText}`);
        });
    }
    get(path) {
        return this.assets[this.pathPrefix + path];
    }
    require(path) {
        path = this.pathPrefix + path;
        let asset = this.assets[path];
        if (asset) return asset;
        let error = this.errors[path];
        throw Error("Asset not found: " + path + (error ? "\n" + error : ""));
    }
    remove(path) {
        path = this.pathPrefix + path;
        let asset = this.assets[path];
        if (asset.dispose) asset.dispose();
        delete this.assets[path];
        return asset;
    }
    removeAll() {
        for(let key in this.assets){
            let asset = this.assets[key];
            if (asset.dispose) asset.dispose();
        }
        this.assets = {};
    }
    isLoadingComplete() {
        return this.toLoad == 0;
    }
    getToLoad() {
        return this.toLoad;
    }
    getLoaded() {
        return this.loaded;
    }
    dispose() {
        this.removeAll();
    }
    hasErrors() {
        return Object.keys(this.errors).length > 0;
    }
    getErrors() {
        return this.errors;
    }
}
class $f2a2fac98ed0510e$export$ef06e7620d37c296 {
    callbacks = {};
    rawDataUris = {};
    dataUriToString(dataUri) {
        if (!dataUri.startsWith("data:")) throw new Error("Not a data URI.");
        let base64Idx = dataUri.indexOf("base64,");
        if (base64Idx != -1) {
            base64Idx += 7;
            return atob(dataUri.substr(base64Idx));
        } else return dataUri.substr(dataUri.indexOf(",") + 1);
    }
    base64ToUint8Array(base64) {
        var binary_string = window.atob(base64);
        var len = binary_string.length;
        var bytes = new Uint8Array(len);
        for(var i = 0; i < len; i++)bytes[i] = binary_string.charCodeAt(i);
        return bytes;
    }
    dataUriToUint8Array(dataUri) {
        if (!dataUri.startsWith("data:")) throw new Error("Not a data URI.");
        let base64Idx = dataUri.indexOf("base64,");
        if (base64Idx == -1) throw new Error("Not a binary data URI.");
        base64Idx += 7;
        return this.base64ToUint8Array(dataUri.substr(base64Idx));
    }
    downloadText(url, success, error) {
        if (this.start(url, success, error)) return;
        if (this.rawDataUris[url]) {
            try {
                let dataUri = this.rawDataUris[url];
                this.finish(url, 200, this.dataUriToString(dataUri));
            } catch (e) {
                this.finish(url, 400, JSON.stringify(e));
            }
            return;
        }
        let request = new XMLHttpRequest();
        request.overrideMimeType("text/html");
        request.open("GET", url, true);
        let done = ()=>{
            this.finish(url, request.status, request.responseText);
        };
        request.onload = done;
        request.onerror = done;
        request.send();
    }
    downloadJson(url, success, error) {
        this.downloadText(url, (data)=>{
            success(JSON.parse(data));
        }, error);
    }
    downloadBinary(url, success, error) {
        if (this.start(url, success, error)) return;
        if (this.rawDataUris[url]) {
            try {
                let dataUri = this.rawDataUris[url];
                this.finish(url, 200, this.dataUriToUint8Array(dataUri));
            } catch (e) {
                this.finish(url, 400, JSON.stringify(e));
            }
            return;
        }
        let request = new XMLHttpRequest();
        request.open("GET", url, true);
        request.responseType = "arraybuffer";
        let onerror = ()=>{
            this.finish(url, request.status, request.response);
        };
        request.onload = ()=>{
            if (request.status == 200 || request.status == 0) this.finish(url, 200, new Uint8Array(request.response));
            else onerror();
        };
        request.onerror = onerror;
        request.send();
    }
    start(url, success, error) {
        let callbacks = this.callbacks[url];
        try {
            if (callbacks) return true;
            this.callbacks[url] = callbacks = [];
        } finally{
            callbacks.push(success, error);
        }
    }
    finish(url, status, data) {
        let callbacks = this.callbacks[url];
        delete this.callbacks[url];
        let args = status == 200 || status == 0 ? [
            data
        ] : [
            status,
            data
        ];
        for(let i = args.length - 1, n = callbacks.length; i < n; i += 2)callbacks[i].apply(null, args);
    }
}


/******************************************************************************
 * Spine Runtimes License Agreement
 * Last updated July 28, 2023. Replaces all prior versions.
 *
 * Copyright (c) 2013-2023, Esoteric Software LLC
 *
 * Integration of the Spine Runtimes into software or otherwise creating
 * derivative works of the Spine Runtimes is permitted under the terms and
 * conditions of Section 2 of the Spine Editor License Agreement:
 * http://esotericsoftware.com/spine-editor-license
 *
 * Otherwise, it is permitted to integrate the Spine Runtimes into software or
 * otherwise create derivative works of the Spine Runtimes (collectively,
 * "Products"), provided that each user of the Products must obtain their own
 * Spine Editor license and redistribution of the Products in any form must
 * include this license and copyright notice.
 *
 * THE SPINE RUNTIMES ARE PROVIDED BY ESOTERIC SOFTWARE LLC "AS IS" AND ANY
 * EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
 * WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE
 * DISCLAIMED. IN NO EVENT SHALL ESOTERIC SOFTWARE LLC BE LIABLE FOR ANY
 * DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES
 * (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES,
 * BUSINESS INTERRUPTION, OR LOSS OF USE, DATA, OR PROFITS) HOWEVER CAUSED AND
 * ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT
 * (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THE
 * SPINE RUNTIMES, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
 *****************************************************************************/ /** Stores the current pose values for an {@link Event}.
 *
 * See Timeline {@link Timeline#apply()},
 * AnimationStateListener {@link AnimationStateListener#event()}, and
 * [Events](http://esotericsoftware.com/spine-events) in the Spine User Guide. */ class $1b0b163278ab2291$export$d61e24a684f9e51 {
    data;
    intValue = 0;
    floatValue = 0;
    stringValue = null;
    time = 0;
    volume = 0;
    balance = 0;
    constructor(time, data){
        if (!data) throw new Error("data cannot be null.");
        this.time = time;
        this.data = data;
    }
}


/******************************************************************************
 * Spine Runtimes License Agreement
 * Last updated July 28, 2023. Replaces all prior versions.
 *
 * Copyright (c) 2013-2023, Esoteric Software LLC
 *
 * Integration of the Spine Runtimes into software or otherwise creating
 * derivative works of the Spine Runtimes is permitted under the terms and
 * conditions of Section 2 of the Spine Editor License Agreement:
 * http://esotericsoftware.com/spine-editor-license
 *
 * Otherwise, it is permitted to integrate the Spine Runtimes into software or
 * otherwise create derivative works of the Spine Runtimes (collectively,
 * "Products"), provided that each user of the Products must obtain their own
 * Spine Editor license and redistribution of the Products in any form must
 * include this license and copyright notice.
 *
 * THE SPINE RUNTIMES ARE PROVIDED BY ESOTERIC SOFTWARE LLC "AS IS" AND ANY
 * EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
 * WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE
 * DISCLAIMED. IN NO EVENT SHALL ESOTERIC SOFTWARE LLC BE LIABLE FOR ANY
 * DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES
 * (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES,
 * BUSINESS INTERRUPTION, OR LOSS OF USE, DATA, OR PROFITS) HOWEVER CAUSED AND
 * ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT
 * (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THE
 * SPINE RUNTIMES, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
 *****************************************************************************/ /** Stores the setup pose values for an {@link Event}.
 *
 * See [Events](http://esotericsoftware.com/spine-events) in the Spine User Guide. */ class $bd4901ace6c255ad$export$a5cf049e34c3d11e {
    name;
    intValue = 0;
    floatValue = 0;
    stringValue = null;
    audioPath = null;
    volume = 0;
    balance = 0;
    constructor(name){
        this.name = name;
    }
}


/******************************************************************************
 * Spine Runtimes License Agreement
 * Last updated July 28, 2023. Replaces all prior versions.
 *
 * Copyright (c) 2013-2023, Esoteric Software LLC
 *
 * Integration of the Spine Runtimes into software or otherwise creating
 * derivative works of the Spine Runtimes is permitted under the terms and
 * conditions of Section 2 of the Spine Editor License Agreement:
 * http://esotericsoftware.com/spine-editor-license
 *
 * Otherwise, it is permitted to integrate the Spine Runtimes into software or
 * otherwise create derivative works of the Spine Runtimes (collectively,
 * "Products"), provided that each user of the Products must obtain their own
 * Spine Editor license and redistribution of the Products in any form must
 * include this license and copyright notice.
 *
 * THE SPINE RUNTIMES ARE PROVIDED BY ESOTERIC SOFTWARE LLC "AS IS" AND ANY
 * EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
 * WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE
 * DISCLAIMED. IN NO EVENT SHALL ESOTERIC SOFTWARE LLC BE LIABLE FOR ANY
 * DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES
 * (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES,
 * BUSINESS INTERRUPTION, OR LOSS OF USE, DATA, OR PROFITS) HOWEVER CAUSED AND
 * ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT
 * (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THE
 * SPINE RUNTIMES, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
 *****************************************************************************/ 

class $f465f1df39d40cbb$export$3c158c80ff28c177 {
    /** The IK constraint's setup pose data. */ data;
    /** The bones that will be modified by this IK constraint. */ bones;
    /** The bone that is the IK target. */ target;
    /** Controls the bend direction of the IK bones, either 1 or -1. */ bendDirection = 0;
    /** When true and only a single bone is being constrained, if the target is too close, the bone is scaled to reach it. */ compress = false;
    /** When true, if the target is out of range, the parent bone is scaled to reach it. If more than one bone is being constrained
     * and the parent bone has local nonuniform scale, stretch is not applied. */ stretch = false;
    /** A percentage (0-1) that controls the mix between the constrained and unconstrained rotations. */ mix = 1;
    /** For two bone IK, the distance from the maximum reach of the bones that rotation will slow. */ softness = 0;
    active = false;
    constructor(data, skeleton){
        if (!data) throw new Error("data cannot be null.");
        if (!skeleton) throw new Error("skeleton cannot be null.");
        this.data = data;
        this.mix = data.mix;
        this.softness = data.softness;
        this.bendDirection = data.bendDirection;
        this.compress = data.compress;
        this.stretch = data.stretch;
        this.bones = new Array();
        for(let i = 0; i < data.bones.length; i++){
            let bone = skeleton.findBone(data.bones[i].name);
            if (!bone) throw new Error(`Couldn't find bone ${data.bones[i].name}`);
            this.bones.push(bone);
        }
        let target = skeleton.findBone(data.target.name);
        if (!target) throw new Error(`Couldn't find bone ${data.target.name}`);
        this.target = target;
    }
    isActive() {
        return this.active;
    }
    update() {
        if (this.mix == 0) return;
        let target = this.target;
        let bones = this.bones;
        switch(bones.length){
            case 1:
                this.apply1(bones[0], target.worldX, target.worldY, this.compress, this.stretch, this.data.uniform, this.mix);
                break;
            case 2:
                this.apply2(bones[0], bones[1], target.worldX, target.worldY, this.bendDirection, this.stretch, this.data.uniform, this.softness, this.mix);
                break;
        }
    }
    /** Applies 1 bone IK. The target is specified in the world coordinate system. */ apply1(bone, targetX, targetY, compress, stretch, uniform, alpha) {
        let p = bone.parent;
        if (!p) throw new Error("IK bone must have parent.");
        let pa = p.a, pb = p.b, pc = p.c, pd = p.d;
        let rotationIK = -bone.ashearX - bone.arotation, tx = 0, ty = 0;
        switch(bone.data.transformMode){
            case (0, $15d066d20c83b36f$export$4c408f82786a534d).OnlyTranslation:
                tx = targetX - bone.worldX;
                ty = targetY - bone.worldY;
                break;
            case (0, $15d066d20c83b36f$export$4c408f82786a534d).NoRotationOrReflection:
                let s = Math.abs(pa * pd - pb * pc) / Math.max(0.0001, pa * pa + pc * pc);
                let sa = pa / bone.skeleton.scaleX;
                let sc = pc / bone.skeleton.scaleY;
                pb = -sc * s * bone.skeleton.scaleX;
                pd = sa * s * bone.skeleton.scaleY;
                rotationIK += Math.atan2(sc, sa) * (0, $1702fa998ec22e58$export$6a7ef315a0d1ef07).radDeg;
            // Fall through
            default:
                let x = targetX - p.worldX, y = targetY - p.worldY;
                let d = pa * pd - pb * pc;
                if (Math.abs(d) <= 0.0001) {
                    tx = 0;
                    ty = 0;
                } else {
                    tx = (x * pd - y * pb) / d - bone.ax;
                    ty = (y * pa - x * pc) / d - bone.ay;
                }
        }
        rotationIK += Math.atan2(ty, tx) * (0, $1702fa998ec22e58$export$6a7ef315a0d1ef07).radDeg;
        if (bone.ascaleX < 0) rotationIK += 180;
        if (rotationIK > 180) rotationIK -= 360;
        else if (rotationIK < -180) rotationIK += 360;
        let sx = bone.ascaleX, sy = bone.ascaleY;
        if (compress || stretch) {
            switch(bone.data.transformMode){
                case (0, $15d066d20c83b36f$export$4c408f82786a534d).NoScale:
                case (0, $15d066d20c83b36f$export$4c408f82786a534d).NoScaleOrReflection:
                    tx = targetX - bone.worldX;
                    ty = targetY - bone.worldY;
            }
            let b = bone.data.length * sx, dd = Math.sqrt(tx * tx + ty * ty);
            if (compress && dd < b || stretch && dd > b && b > 0.0001) {
                let s = (dd / b - 1) * alpha + 1;
                sx *= s;
                if (uniform) sy *= s;
            }
        }
        bone.updateWorldTransformWith(bone.ax, bone.ay, bone.arotation + rotationIK * alpha, sx, sy, bone.ashearX, bone.ashearY);
    }
    /** Applies 2 bone IK. The target is specified in the world coordinate system.
     * @param child A direct descendant of the parent bone. */ apply2(parent, child, targetX, targetY, bendDir, stretch, uniform, softness, alpha) {
        let px = parent.ax, py = parent.ay, psx = parent.ascaleX, psy = parent.ascaleY, sx = psx, sy = psy, csx = child.ascaleX;
        let os1 = 0, os2 = 0, s2 = 0;
        if (psx < 0) {
            psx = -psx;
            os1 = 180;
            s2 = -1;
        } else {
            os1 = 0;
            s2 = 1;
        }
        if (psy < 0) {
            psy = -psy;
            s2 = -s2;
        }
        if (csx < 0) {
            csx = -csx;
            os2 = 180;
        } else os2 = 0;
        let cx = child.ax, cy = 0, cwx = 0, cwy = 0, a = parent.a, b = parent.b, c = parent.c, d = parent.d;
        let u = Math.abs(psx - psy) <= 0.0001;
        if (!u || stretch) {
            cy = 0;
            cwx = a * cx + parent.worldX;
            cwy = c * cx + parent.worldY;
        } else {
            cy = child.ay;
            cwx = a * cx + b * cy + parent.worldX;
            cwy = c * cx + d * cy + parent.worldY;
        }
        let pp = parent.parent;
        if (!pp) throw new Error("IK parent must itself have a parent.");
        a = pp.a;
        b = pp.b;
        c = pp.c;
        d = pp.d;
        let id = a * d - b * c, x = cwx - pp.worldX, y = cwy - pp.worldY;
        id = Math.abs(id) <= 0.0001 ? 0 : 1 / id;
        let dx = (x * d - y * b) * id - px, dy = (y * a - x * c) * id - py;
        let l1 = Math.sqrt(dx * dx + dy * dy), l2 = child.data.length * csx, a1, a2;
        if (l1 < 0.0001) {
            this.apply1(parent, targetX, targetY, false, stretch, false, alpha);
            child.updateWorldTransformWith(cx, cy, 0, child.ascaleX, child.ascaleY, child.ashearX, child.ashearY);
            return;
        }
        x = targetX - pp.worldX;
        y = targetY - pp.worldY;
        let tx = (x * d - y * b) * id - px, ty = (y * a - x * c) * id - py;
        let dd = tx * tx + ty * ty;
        if (softness != 0) {
            softness *= psx * (csx + 1) * 0.5;
            let td = Math.sqrt(dd), sd = td - l1 - l2 * psx + softness;
            if (sd > 0) {
                let p = Math.min(1, sd / (softness * 2)) - 1;
                p = (sd - softness * (1 - p * p)) / td;
                tx -= p * tx;
                ty -= p * ty;
                dd = tx * tx + ty * ty;
            }
        }
        outer: if (u) {
            l2 *= psx;
            let cos = (dd - l1 * l1 - l2 * l2) / (2 * l1 * l2);
            if (cos < -1) {
                cos = -1;
                a2 = Math.PI * bendDir;
            } else if (cos > 1) {
                cos = 1;
                a2 = 0;
                if (stretch) {
                    a = (Math.sqrt(dd) / (l1 + l2) - 1) * alpha + 1;
                    sx *= a;
                    if (uniform) sy *= a;
                }
            } else a2 = Math.acos(cos) * bendDir;
            a = l1 + l2 * cos;
            b = l2 * Math.sin(a2);
            a1 = Math.atan2(ty * a - tx * b, tx * a + ty * b);
        } else {
            a = psx * l2;
            b = psy * l2;
            let aa = a * a, bb = b * b, ta = Math.atan2(ty, tx);
            c = bb * l1 * l1 + aa * dd - aa * bb;
            let c1 = -2 * bb * l1, c2 = bb - aa;
            d = c1 * c1 - 4 * c2 * c;
            if (d >= 0) {
                let q = Math.sqrt(d);
                if (c1 < 0) q = -q;
                q = -(c1 + q) * 0.5;
                let r0 = q / c2, r1 = c / q;
                let r = Math.abs(r0) < Math.abs(r1) ? r0 : r1;
                if (r * r <= dd) {
                    y = Math.sqrt(dd - r * r) * bendDir;
                    a1 = ta - Math.atan2(y, r);
                    a2 = Math.atan2(y / psy, (r - l1) / psx);
                    break outer;
                }
            }
            let minAngle = (0, $1702fa998ec22e58$export$6a7ef315a0d1ef07).PI, minX = l1 - a, minDist = minX * minX, minY = 0;
            let maxAngle = 0, maxX = l1 + a, maxDist = maxX * maxX, maxY = 0;
            c = -a * l1 / (aa - bb);
            if (c >= -1 && c <= 1) {
                c = Math.acos(c);
                x = a * Math.cos(c) + l1;
                y = b * Math.sin(c);
                d = x * x + y * y;
                if (d < minDist) {
                    minAngle = c;
                    minDist = d;
                    minX = x;
                    minY = y;
                }
                if (d > maxDist) {
                    maxAngle = c;
                    maxDist = d;
                    maxX = x;
                    maxY = y;
                }
            }
            if (dd <= (minDist + maxDist) * 0.5) {
                a1 = ta - Math.atan2(minY * bendDir, minX);
                a2 = minAngle * bendDir;
            } else {
                a1 = ta - Math.atan2(maxY * bendDir, maxX);
                a2 = maxAngle * bendDir;
            }
        }
        let os = Math.atan2(cy, cx) * s2;
        let rotation = parent.arotation;
        a1 = (a1 - os) * (0, $1702fa998ec22e58$export$6a7ef315a0d1ef07).radDeg + os1 - rotation;
        if (a1 > 180) a1 -= 360;
        else if (a1 < -180) a1 += 360;
        parent.updateWorldTransformWith(px, py, rotation + a1 * alpha, sx, sy, 0, 0);
        rotation = child.arotation;
        a2 = ((a2 + os) * (0, $1702fa998ec22e58$export$6a7ef315a0d1ef07).radDeg - child.ashearX) * s2 + os2 - rotation;
        if (a2 > 180) a2 -= 360;
        else if (a2 < -180) a2 += 360;
        child.updateWorldTransformWith(cx, cy, rotation + a2 * alpha, child.ascaleX, child.ascaleY, child.ashearX, child.ashearY);
    }
}


/******************************************************************************
 * Spine Runtimes License Agreement
 * Last updated July 28, 2023. Replaces all prior versions.
 *
 * Copyright (c) 2013-2023, Esoteric Software LLC
 *
 * Integration of the Spine Runtimes into software or otherwise creating
 * derivative works of the Spine Runtimes is permitted under the terms and
 * conditions of Section 2 of the Spine Editor License Agreement:
 * http://esotericsoftware.com/spine-editor-license
 *
 * Otherwise, it is permitted to integrate the Spine Runtimes into software or
 * otherwise create derivative works of the Spine Runtimes (collectively,
 * "Products"), provided that each user of the Products must obtain their own
 * Spine Editor license and redistribution of the Products in any form must
 * include this license and copyright notice.
 *
 * THE SPINE RUNTIMES ARE PROVIDED BY ESOTERIC SOFTWARE LLC "AS IS" AND ANY
 * EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
 * WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE
 * DISCLAIMED. IN NO EVENT SHALL ESOTERIC SOFTWARE LLC BE LIABLE FOR ANY
 * DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES
 * (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES,
 * BUSINESS INTERRUPTION, OR LOSS OF USE, DATA, OR PROFITS) HOWEVER CAUSED AND
 * ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT
 * (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THE
 * SPINE RUNTIMES, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
 *****************************************************************************/ 
class $1a17aaf311b9f6a0$export$adcb08b651fc712e extends (0, $a1d4de5372395191$export$b826e1ab3af63566) {
    /** The bones that are constrained by this IK constraint. */ bones = new Array();
    /** The bone that is the IK target. */ _target = null;
    set target(boneData) {
        this._target = boneData;
    }
    get target() {
        if (!this._target) throw new Error("BoneData not set.");
        else return this._target;
    }
    /** Controls the bend direction of the IK bones, either 1 or -1. */ bendDirection = 1;
    /** When true and only a single bone is being constrained, if the target is too close, the bone is scaled to reach it. */ compress = false;
    /** When true, if the target is out of range, the parent bone is scaled to reach it. If more than one bone is being constrained
     * and the parent bone has local nonuniform scale, stretch is not applied. */ stretch = false;
    /** When true, only a single bone is being constrained, and {@link #getCompress()} or {@link #getStretch()} is used, the bone
     * is scaled on both the X and Y axes. */ uniform = false;
    /** A percentage (0-1) that controls the mix between the constrained and unconstrained rotations. */ mix = 1;
    /** For two bone IK, the distance from the maximum reach of the bones that rotation will slow. */ softness = 0;
    constructor(name){
        super(name, 0, false);
    }
}


/******************************************************************************
 * Spine Runtimes License Agreement
 * Last updated July 28, 2023. Replaces all prior versions.
 *
 * Copyright (c) 2013-2023, Esoteric Software LLC
 *
 * Integration of the Spine Runtimes into software or otherwise creating
 * derivative works of the Spine Runtimes is permitted under the terms and
 * conditions of Section 2 of the Spine Editor License Agreement:
 * http://esotericsoftware.com/spine-editor-license
 *
 * Otherwise, it is permitted to integrate the Spine Runtimes into software or
 * otherwise create derivative works of the Spine Runtimes (collectively,
 * "Products"), provided that each user of the Products must obtain their own
 * Spine Editor license and redistribution of the Products in any form must
 * include this license and copyright notice.
 *
 * THE SPINE RUNTIMES ARE PROVIDED BY ESOTERIC SOFTWARE LLC "AS IS" AND ANY
 * EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
 * WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE
 * DISCLAIMED. IN NO EVENT SHALL ESOTERIC SOFTWARE LLC BE LIABLE FOR ANY
 * DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES
 * (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES,
 * BUSINESS INTERRUPTION, OR LOSS OF USE, DATA, OR PROFITS) HOWEVER CAUSED AND
 * ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT
 * (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THE
 * SPINE RUNTIMES, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
 *****************************************************************************/ 
/******************************************************************************
 * Spine Runtimes License Agreement
 * Last updated July 28, 2023. Replaces all prior versions.
 *
 * Copyright (c) 2013-2023, Esoteric Software LLC
 *
 * Integration of the Spine Runtimes into software or otherwise creating
 * derivative works of the Spine Runtimes is permitted under the terms and
 * conditions of Section 2 of the Spine Editor License Agreement:
 * http://esotericsoftware.com/spine-editor-license
 *
 * Otherwise, it is permitted to integrate the Spine Runtimes into software or
 * otherwise create derivative works of the Spine Runtimes (collectively,
 * "Products"), provided that each user of the Products must obtain their own
 * Spine Editor license and redistribution of the Products in any form must
 * include this license and copyright notice.
 *
 * THE SPINE RUNTIMES ARE PROVIDED BY ESOTERIC SOFTWARE LLC "AS IS" AND ANY
 * EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
 * WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE
 * DISCLAIMED. IN NO EVENT SHALL ESOTERIC SOFTWARE LLC BE LIABLE FOR ANY
 * DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES
 * (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES,
 * BUSINESS INTERRUPTION, OR LOSS OF USE, DATA, OR PROFITS) HOWEVER CAUSED AND
 * ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT
 * (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THE
 * SPINE RUNTIMES, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
 *****************************************************************************/ 
class $16a395dfc145fe87$export$d2629ab80d5dd5ba extends (0, $a1d4de5372395191$export$b826e1ab3af63566) {
    /** The bones that will be modified by this path constraint. */ bones = new Array();
    /** The slot whose path attachment will be used to constrained the bones. */ _target = null;
    set target(slotData) {
        this._target = slotData;
    }
    get target() {
        if (!this._target) throw new Error("SlotData not set.");
        else return this._target;
    }
    /** The mode for positioning the first bone on the path. */ positionMode = $16a395dfc145fe87$export$34d637c671e1e906.Fixed;
    /** The mode for positioning the bones after the first bone on the path. */ spacingMode = $16a395dfc145fe87$export$34ce760ad2b0be4b.Fixed;
    /** The mode for adjusting the rotation of the bones. */ rotateMode = $16a395dfc145fe87$export$a2a23846581ac82c.Chain;
    /** An offset added to the constrained bone rotation. */ offsetRotation = 0;
    /** The position along the path. */ position = 0;
    /** The spacing between bones. */ spacing = 0;
    mixRotate = 0;
    mixX = 0;
    mixY = 0;
    constructor(name){
        super(name, 0, false);
    }
}
var $16a395dfc145fe87$export$34d637c671e1e906;
(function(PositionMode) {
    PositionMode[PositionMode["Fixed"] = 0] = "Fixed";
    PositionMode[PositionMode["Percent"] = 1] = "Percent";
})($16a395dfc145fe87$export$34d637c671e1e906 || ($16a395dfc145fe87$export$34d637c671e1e906 = {}));
var $16a395dfc145fe87$export$34ce760ad2b0be4b;
(function(SpacingMode) {
    SpacingMode[SpacingMode["Length"] = 0] = "Length";
    SpacingMode[SpacingMode["Fixed"] = 1] = "Fixed";
    SpacingMode[SpacingMode["Percent"] = 2] = "Percent";
    SpacingMode[SpacingMode["Proportional"] = 3] = "Proportional";
})($16a395dfc145fe87$export$34ce760ad2b0be4b || ($16a395dfc145fe87$export$34ce760ad2b0be4b = {}));
var $16a395dfc145fe87$export$a2a23846581ac82c;
(function(RotateMode) {
    RotateMode[RotateMode["Tangent"] = 0] = "Tangent";
    RotateMode[RotateMode["Chain"] = 1] = "Chain";
    RotateMode[RotateMode["ChainScale"] = 2] = "ChainScale";
})($16a395dfc145fe87$export$a2a23846581ac82c || ($16a395dfc145fe87$export$a2a23846581ac82c = {}));



class $a130814e4f9c40a2$export$cb4f92fb0c018828 {
    static NONE = -1;
    static BEFORE = -2;
    static AFTER = -3;
    static epsilon = 0.00001;
    /** The path constraint's setup pose data. */ data;
    /** The bones that will be modified by this path constraint. */ bones;
    /** The slot whose path attachment will be used to constrained the bones. */ target;
    /** The position along the path. */ position = 0;
    /** The spacing between bones. */ spacing = 0;
    mixRotate = 0;
    mixX = 0;
    mixY = 0;
    spaces = new Array();
    positions = new Array();
    world = new Array();
    curves = new Array();
    lengths = new Array();
    segments = new Array();
    active = false;
    constructor(data, skeleton){
        if (!data) throw new Error("data cannot be null.");
        if (!skeleton) throw new Error("skeleton cannot be null.");
        this.data = data;
        this.bones = new Array();
        for(let i = 0, n = data.bones.length; i < n; i++){
            let bone = skeleton.findBone(data.bones[i].name);
            if (!bone) throw new Error(`Couldn't find bone ${data.bones[i].name}.`);
            this.bones.push(bone);
        }
        let target = skeleton.findSlot(data.target.name);
        if (!target) throw new Error(`Couldn't find target bone ${data.target.name}`);
        this.target = target;
        this.position = data.position;
        this.spacing = data.spacing;
        this.mixRotate = data.mixRotate;
        this.mixX = data.mixX;
        this.mixY = data.mixY;
    }
    isActive() {
        return this.active;
    }
    update() {
        let attachment = this.target.getAttachment();
        if (!(attachment instanceof (0, $2fcc86453abe2c1c$export$d285e3ec07b32800))) return;
        let mixRotate = this.mixRotate, mixX = this.mixX, mixY = this.mixY;
        if (mixRotate == 0 && mixX == 0 && mixY == 0) return;
        let data = this.data;
        let tangents = data.rotateMode == (0, $16a395dfc145fe87$export$a2a23846581ac82c).Tangent, scale = data.rotateMode == (0, $16a395dfc145fe87$export$a2a23846581ac82c).ChainScale;
        let bones = this.bones;
        let boneCount = bones.length, spacesCount = tangents ? boneCount : boneCount + 1;
        let spaces = (0, $1702fa998ec22e58$export$d2ca453b913dcdea).setArraySize(this.spaces, spacesCount), lengths = scale ? this.lengths = (0, $1702fa998ec22e58$export$d2ca453b913dcdea).setArraySize(this.lengths, boneCount) : [];
        let spacing = this.spacing;
        switch(data.spacingMode){
            case (0, $16a395dfc145fe87$export$34ce760ad2b0be4b).Percent:
                if (scale) for(let i = 0, n = spacesCount - 1; i < n; i++){
                    let bone = bones[i];
                    let setupLength = bone.data.length;
                    if (setupLength < $a130814e4f9c40a2$export$cb4f92fb0c018828.epsilon) lengths[i] = 0;
                    else {
                        let x = setupLength * bone.a, y = setupLength * bone.c;
                        lengths[i] = Math.sqrt(x * x + y * y);
                    }
                }
                (0, $1702fa998ec22e58$export$d2ca453b913dcdea).arrayFill(spaces, 1, spacesCount, spacing);
                break;
            case (0, $16a395dfc145fe87$export$34ce760ad2b0be4b).Proportional:
                let sum = 0;
                for(let i = 0, n = spacesCount - 1; i < n;){
                    let bone = bones[i];
                    let setupLength = bone.data.length;
                    if (setupLength < $a130814e4f9c40a2$export$cb4f92fb0c018828.epsilon) {
                        if (scale) lengths[i] = 0;
                        spaces[++i] = spacing;
                    } else {
                        let x = setupLength * bone.a, y = setupLength * bone.c;
                        let length = Math.sqrt(x * x + y * y);
                        if (scale) lengths[i] = length;
                        spaces[++i] = length;
                        sum += length;
                    }
                }
                if (sum > 0) {
                    sum = spacesCount / sum * spacing;
                    for(let i = 1; i < spacesCount; i++)spaces[i] *= sum;
                }
                break;
            default:
                let lengthSpacing = data.spacingMode == (0, $16a395dfc145fe87$export$34ce760ad2b0be4b).Length;
                for(let i = 0, n = spacesCount - 1; i < n;){
                    let bone = bones[i];
                    let setupLength = bone.data.length;
                    if (setupLength < $a130814e4f9c40a2$export$cb4f92fb0c018828.epsilon) {
                        if (scale) lengths[i] = 0;
                        spaces[++i] = spacing;
                    } else {
                        let x = setupLength * bone.a, y = setupLength * bone.c;
                        let length = Math.sqrt(x * x + y * y);
                        if (scale) lengths[i] = length;
                        spaces[++i] = (lengthSpacing ? setupLength + spacing : spacing) * length / setupLength;
                    }
                }
        }
        let positions = this.computeWorldPositions(attachment, spacesCount, tangents);
        let boneX = positions[0], boneY = positions[1], offsetRotation = data.offsetRotation;
        let tip = false;
        if (offsetRotation == 0) tip = data.rotateMode == (0, $16a395dfc145fe87$export$a2a23846581ac82c).Chain;
        else {
            tip = false;
            let p = this.target.bone;
            offsetRotation *= p.a * p.d - p.b * p.c > 0 ? (0, $1702fa998ec22e58$export$6a7ef315a0d1ef07).degRad : -(0, $1702fa998ec22e58$export$6a7ef315a0d1ef07).degRad;
        }
        for(let i = 0, p = 3; i < boneCount; i++, p += 3){
            let bone = bones[i];
            bone.worldX += (boneX - bone.worldX) * mixX;
            bone.worldY += (boneY - bone.worldY) * mixY;
            let x = positions[p], y = positions[p + 1], dx = x - boneX, dy = y - boneY;
            if (scale) {
                let length = lengths[i];
                if (length != 0) {
                    let s = (Math.sqrt(dx * dx + dy * dy) / length - 1) * mixRotate + 1;
                    bone.a *= s;
                    bone.c *= s;
                }
            }
            boneX = x;
            boneY = y;
            if (mixRotate > 0) {
                let a = bone.a, b = bone.b, c = bone.c, d = bone.d, r = 0, cos = 0, sin = 0;
                if (tangents) r = positions[p - 1];
                else if (spaces[i + 1] == 0) r = positions[p + 2];
                else r = Math.atan2(dy, dx);
                r -= Math.atan2(c, a);
                if (tip) {
                    cos = Math.cos(r);
                    sin = Math.sin(r);
                    let length = bone.data.length;
                    boneX += (length * (cos * a - sin * c) - dx) * mixRotate;
                    boneY += (length * (sin * a + cos * c) - dy) * mixRotate;
                } else r += offsetRotation;
                if (r > (0, $1702fa998ec22e58$export$6a7ef315a0d1ef07).PI) r -= (0, $1702fa998ec22e58$export$6a7ef315a0d1ef07).PI2;
                else if (r < -(0, $1702fa998ec22e58$export$6a7ef315a0d1ef07).PI) r += (0, $1702fa998ec22e58$export$6a7ef315a0d1ef07).PI2;
                r *= mixRotate;
                cos = Math.cos(r);
                sin = Math.sin(r);
                bone.a = cos * a - sin * c;
                bone.b = cos * b - sin * d;
                bone.c = sin * a + cos * c;
                bone.d = sin * b + cos * d;
            }
            bone.updateAppliedTransform();
        }
    }
    computeWorldPositions(path, spacesCount, tangents) {
        let target = this.target;
        let position = this.position;
        let spaces = this.spaces, out = (0, $1702fa998ec22e58$export$d2ca453b913dcdea).setArraySize(this.positions, spacesCount * 3 + 2), world = this.world;
        let closed = path.closed;
        let verticesLength = path.worldVerticesLength, curveCount = verticesLength / 6, prevCurve = $a130814e4f9c40a2$export$cb4f92fb0c018828.NONE;
        if (!path.constantSpeed) {
            let lengths = path.lengths;
            curveCount -= closed ? 1 : 2;
            let pathLength = lengths[curveCount];
            if (this.data.positionMode == (0, $16a395dfc145fe87$export$34d637c671e1e906).Percent) position *= pathLength;
            let multiplier;
            switch(this.data.spacingMode){
                case (0, $16a395dfc145fe87$export$34ce760ad2b0be4b).Percent:
                    multiplier = pathLength;
                    break;
                case (0, $16a395dfc145fe87$export$34ce760ad2b0be4b).Proportional:
                    multiplier = pathLength / spacesCount;
                    break;
                default:
                    multiplier = 1;
            }
            world = (0, $1702fa998ec22e58$export$d2ca453b913dcdea).setArraySize(this.world, 8);
            for(let i = 0, o = 0, curve = 0; i < spacesCount; i++, o += 3){
                let space = spaces[i] * multiplier;
                position += space;
                let p = position;
                if (closed) {
                    p %= pathLength;
                    if (p < 0) p += pathLength;
                    curve = 0;
                } else if (p < 0) {
                    if (prevCurve != $a130814e4f9c40a2$export$cb4f92fb0c018828.BEFORE) {
                        prevCurve = $a130814e4f9c40a2$export$cb4f92fb0c018828.BEFORE;
                        path.computeWorldVertices(target, 2, 4, world, 0, 2);
                    }
                    this.addBeforePosition(p, world, 0, out, o);
                    continue;
                } else if (p > pathLength) {
                    if (prevCurve != $a130814e4f9c40a2$export$cb4f92fb0c018828.AFTER) {
                        prevCurve = $a130814e4f9c40a2$export$cb4f92fb0c018828.AFTER;
                        path.computeWorldVertices(target, verticesLength - 6, 4, world, 0, 2);
                    }
                    this.addAfterPosition(p - pathLength, world, 0, out, o);
                    continue;
                }
                // Determine curve containing position.
                for(;; curve++){
                    let length = lengths[curve];
                    if (p > length) continue;
                    if (curve == 0) p /= length;
                    else {
                        let prev = lengths[curve - 1];
                        p = (p - prev) / (length - prev);
                    }
                    break;
                }
                if (curve != prevCurve) {
                    prevCurve = curve;
                    if (closed && curve == curveCount) {
                        path.computeWorldVertices(target, verticesLength - 4, 4, world, 0, 2);
                        path.computeWorldVertices(target, 0, 4, world, 4, 2);
                    } else path.computeWorldVertices(target, curve * 6 + 2, 8, world, 0, 2);
                }
                this.addCurvePosition(p, world[0], world[1], world[2], world[3], world[4], world[5], world[6], world[7], out, o, tangents || i > 0 && space == 0);
            }
            return out;
        }
        // World vertices.
        if (closed) {
            verticesLength += 2;
            world = (0, $1702fa998ec22e58$export$d2ca453b913dcdea).setArraySize(this.world, verticesLength);
            path.computeWorldVertices(target, 2, verticesLength - 4, world, 0, 2);
            path.computeWorldVertices(target, 0, 2, world, verticesLength - 4, 2);
            world[verticesLength - 2] = world[0];
            world[verticesLength - 1] = world[1];
        } else {
            curveCount--;
            verticesLength -= 4;
            world = (0, $1702fa998ec22e58$export$d2ca453b913dcdea).setArraySize(this.world, verticesLength);
            path.computeWorldVertices(target, 2, verticesLength, world, 0, 2);
        }
        // Curve lengths.
        let curves = (0, $1702fa998ec22e58$export$d2ca453b913dcdea).setArraySize(this.curves, curveCount);
        let pathLength = 0;
        let x1 = world[0], y1 = world[1], cx1 = 0, cy1 = 0, cx2 = 0, cy2 = 0, x2 = 0, y2 = 0;
        let tmpx = 0, tmpy = 0, dddfx = 0, dddfy = 0, ddfx = 0, ddfy = 0, dfx = 0, dfy = 0;
        for(let i = 0, w = 2; i < curveCount; i++, w += 6){
            cx1 = world[w];
            cy1 = world[w + 1];
            cx2 = world[w + 2];
            cy2 = world[w + 3];
            x2 = world[w + 4];
            y2 = world[w + 5];
            tmpx = (x1 - cx1 * 2 + cx2) * 0.1875;
            tmpy = (y1 - cy1 * 2 + cy2) * 0.1875;
            dddfx = ((cx1 - cx2) * 3 - x1 + x2) * 0.09375;
            dddfy = ((cy1 - cy2) * 3 - y1 + y2) * 0.09375;
            ddfx = tmpx * 2 + dddfx;
            ddfy = tmpy * 2 + dddfy;
            dfx = (cx1 - x1) * 0.75 + tmpx + dddfx * 0.16666667;
            dfy = (cy1 - y1) * 0.75 + tmpy + dddfy * 0.16666667;
            pathLength += Math.sqrt(dfx * dfx + dfy * dfy);
            dfx += ddfx;
            dfy += ddfy;
            ddfx += dddfx;
            ddfy += dddfy;
            pathLength += Math.sqrt(dfx * dfx + dfy * dfy);
            dfx += ddfx;
            dfy += ddfy;
            pathLength += Math.sqrt(dfx * dfx + dfy * dfy);
            dfx += ddfx + dddfx;
            dfy += ddfy + dddfy;
            pathLength += Math.sqrt(dfx * dfx + dfy * dfy);
            curves[i] = pathLength;
            x1 = x2;
            y1 = y2;
        }
        if (this.data.positionMode == (0, $16a395dfc145fe87$export$34d637c671e1e906).Percent) position *= pathLength;
        let multiplier;
        switch(this.data.spacingMode){
            case (0, $16a395dfc145fe87$export$34ce760ad2b0be4b).Percent:
                multiplier = pathLength;
                break;
            case (0, $16a395dfc145fe87$export$34ce760ad2b0be4b).Proportional:
                multiplier = pathLength / spacesCount;
                break;
            default:
                multiplier = 1;
        }
        let segments = this.segments;
        let curveLength = 0;
        for(let i = 0, o = 0, curve = 0, segment = 0; i < spacesCount; i++, o += 3){
            let space = spaces[i] * multiplier;
            position += space;
            let p = position;
            if (closed) {
                p %= pathLength;
                if (p < 0) p += pathLength;
                curve = 0;
            } else if (p < 0) {
                this.addBeforePosition(p, world, 0, out, o);
                continue;
            } else if (p > pathLength) {
                this.addAfterPosition(p - pathLength, world, verticesLength - 4, out, o);
                continue;
            }
            // Determine curve containing position.
            for(;; curve++){
                let length = curves[curve];
                if (p > length) continue;
                if (curve == 0) p /= length;
                else {
                    let prev = curves[curve - 1];
                    p = (p - prev) / (length - prev);
                }
                break;
            }
            // Curve segment lengths.
            if (curve != prevCurve) {
                prevCurve = curve;
                let ii = curve * 6;
                x1 = world[ii];
                y1 = world[ii + 1];
                cx1 = world[ii + 2];
                cy1 = world[ii + 3];
                cx2 = world[ii + 4];
                cy2 = world[ii + 5];
                x2 = world[ii + 6];
                y2 = world[ii + 7];
                tmpx = (x1 - cx1 * 2 + cx2) * 0.03;
                tmpy = (y1 - cy1 * 2 + cy2) * 0.03;
                dddfx = ((cx1 - cx2) * 3 - x1 + x2) * 0.006;
                dddfy = ((cy1 - cy2) * 3 - y1 + y2) * 0.006;
                ddfx = tmpx * 2 + dddfx;
                ddfy = tmpy * 2 + dddfy;
                dfx = (cx1 - x1) * 0.3 + tmpx + dddfx * 0.16666667;
                dfy = (cy1 - y1) * 0.3 + tmpy + dddfy * 0.16666667;
                curveLength = Math.sqrt(dfx * dfx + dfy * dfy);
                segments[0] = curveLength;
                for(ii = 1; ii < 8; ii++){
                    dfx += ddfx;
                    dfy += ddfy;
                    ddfx += dddfx;
                    ddfy += dddfy;
                    curveLength += Math.sqrt(dfx * dfx + dfy * dfy);
                    segments[ii] = curveLength;
                }
                dfx += ddfx;
                dfy += ddfy;
                curveLength += Math.sqrt(dfx * dfx + dfy * dfy);
                segments[8] = curveLength;
                dfx += ddfx + dddfx;
                dfy += ddfy + dddfy;
                curveLength += Math.sqrt(dfx * dfx + dfy * dfy);
                segments[9] = curveLength;
                segment = 0;
            }
            // Weight by segment length.
            p *= curveLength;
            for(;; segment++){
                let length = segments[segment];
                if (p > length) continue;
                if (segment == 0) p /= length;
                else {
                    let prev = segments[segment - 1];
                    p = segment + (p - prev) / (length - prev);
                }
                break;
            }
            this.addCurvePosition(p * 0.1, x1, y1, cx1, cy1, cx2, cy2, x2, y2, out, o, tangents || i > 0 && space == 0);
        }
        return out;
    }
    addBeforePosition(p, temp, i, out, o) {
        let x1 = temp[i], y1 = temp[i + 1], dx = temp[i + 2] - x1, dy = temp[i + 3] - y1, r = Math.atan2(dy, dx);
        out[o] = x1 + p * Math.cos(r);
        out[o + 1] = y1 + p * Math.sin(r);
        out[o + 2] = r;
    }
    addAfterPosition(p, temp, i, out, o) {
        let x1 = temp[i + 2], y1 = temp[i + 3], dx = x1 - temp[i], dy = y1 - temp[i + 1], r = Math.atan2(dy, dx);
        out[o] = x1 + p * Math.cos(r);
        out[o + 1] = y1 + p * Math.sin(r);
        out[o + 2] = r;
    }
    addCurvePosition(p, x1, y1, cx1, cy1, cx2, cy2, x2, y2, out, o, tangents) {
        if (p == 0 || isNaN(p)) {
            out[o] = x1;
            out[o + 1] = y1;
            out[o + 2] = Math.atan2(cy1 - y1, cx1 - x1);
            return;
        }
        let tt = p * p, ttt = tt * p, u = 1 - p, uu = u * u, uuu = uu * u;
        let ut = u * p, ut3 = ut * 3, uut3 = u * ut3, utt3 = ut3 * p;
        let x = x1 * uuu + cx1 * uut3 + cx2 * utt3 + x2 * ttt, y = y1 * uuu + cy1 * uut3 + cy2 * utt3 + y2 * ttt;
        out[o] = x;
        out[o + 1] = y;
        if (tangents) {
            if (p < 0.001) out[o + 2] = Math.atan2(cy1 - y1, cx1 - x1);
            else out[o + 2] = Math.atan2(y - (y1 * uu + cy1 * ut * 2 + cy2 * tt), x - (x1 * uu + cx1 * ut * 2 + cx2 * tt));
        }
    }
}



/******************************************************************************
 * Spine Runtimes License Agreement
 * Last updated July 28, 2023. Replaces all prior versions.
 *
 * Copyright (c) 2013-2023, Esoteric Software LLC
 *
 * Integration of the Spine Runtimes into software or otherwise creating
 * derivative works of the Spine Runtimes is permitted under the terms and
 * conditions of Section 2 of the Spine Editor License Agreement:
 * http://esotericsoftware.com/spine-editor-license
 *
 * Otherwise, it is permitted to integrate the Spine Runtimes into software or
 * otherwise create derivative works of the Spine Runtimes (collectively,
 * "Products"), provided that each user of the Products must obtain their own
 * Spine Editor license and redistribution of the Products in any form must
 * include this license and copyright notice.
 *
 * THE SPINE RUNTIMES ARE PROVIDED BY ESOTERIC SOFTWARE LLC "AS IS" AND ANY
 * EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
 * WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE
 * DISCLAIMED. IN NO EVENT SHALL ESOTERIC SOFTWARE LLC BE LIABLE FOR ANY
 * DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES
 * (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES,
 * BUSINESS INTERRUPTION, OR LOSS OF USE, DATA, OR PROFITS) HOWEVER CAUSED AND
 * ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT
 * (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THE
 * SPINE RUNTIMES, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
 *****************************************************************************/ 





/******************************************************************************
 * Spine Runtimes License Agreement
 * Last updated July 28, 2023. Replaces all prior versions.
 *
 * Copyright (c) 2013-2023, Esoteric Software LLC
 *
 * Integration of the Spine Runtimes into software or otherwise creating
 * derivative works of the Spine Runtimes is permitted under the terms and
 * conditions of Section 2 of the Spine Editor License Agreement:
 * http://esotericsoftware.com/spine-editor-license
 *
 * Otherwise, it is permitted to integrate the Spine Runtimes into software or
 * otherwise create derivative works of the Spine Runtimes (collectively,
 * "Products"), provided that each user of the Products must obtain their own
 * Spine Editor license and redistribution of the Products in any form must
 * include this license and copyright notice.
 *
 * THE SPINE RUNTIMES ARE PROVIDED BY ESOTERIC SOFTWARE LLC "AS IS" AND ANY
 * EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
 * WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE
 * DISCLAIMED. IN NO EVENT SHALL ESOTERIC SOFTWARE LLC BE LIABLE FOR ANY
 * DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES
 * (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES,
 * BUSINESS INTERRUPTION, OR LOSS OF USE, DATA, OR PROFITS) HOWEVER CAUSED AND
 * ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT
 * (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THE
 * SPINE RUNTIMES, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
 *****************************************************************************/ 

class $20da912a1ef4fb98$export$8c6ed5c666ac1360 {
    /** The slot's setup pose data. */ data;
    /** The bone this slot belongs to. */ bone;
    /** The color used to tint the slot's attachment. If {@link #getDarkColor()} is set, this is used as the light color for two
     * color tinting. */ color;
    /** The dark color used to tint the slot's attachment for two color tinting, or null if two color tinting is not used. The dark
     * color's alpha is not used. */ darkColor = null;
    attachment = null;
    attachmentState = 0;
    /** The index of the texture region to display when the slot's attachment has a {@link Sequence}. -1 represents the
     * {@link Sequence#getSetupIndex()}. */ sequenceIndex = -1;
    /** Values to deform the slot's attachment. For an unweighted mesh, the entries are local positions for each vertex. For a
     * weighted mesh, the entries are an offset for each vertex which will be added to the mesh's local vertex positions.
     *
     * See {@link VertexAttachment#computeWorldVertices()} and {@link DeformTimeline}. */ deform = new Array();
    constructor(data, bone){
        if (!data) throw new Error("data cannot be null.");
        if (!bone) throw new Error("bone cannot be null.");
        this.data = data;
        this.bone = bone;
        this.color = new (0, $1702fa998ec22e58$export$892596cec99bc70e)();
        this.darkColor = !data.darkColor ? null : new (0, $1702fa998ec22e58$export$892596cec99bc70e)();
        this.setToSetupPose();
    }
    /** The skeleton this slot belongs to. */ getSkeleton() {
        return this.bone.skeleton;
    }
    /** The current attachment for the slot, or null if the slot has no attachment. */ getAttachment() {
        return this.attachment;
    }
    /** Sets the slot's attachment and, if the attachment changed, resets {@link #sequenceIndex} and clears the {@link #deform}.
     * The deform is not cleared if the old attachment has the same {@link VertexAttachment#getTimelineAttachment()} as the
     * specified attachment. */ setAttachment(attachment) {
        if (this.attachment == attachment) return;
        if (!(attachment instanceof (0, $3c213aed73167a71$export$66d3a0c3be55e044)) || !(this.attachment instanceof (0, $3c213aed73167a71$export$66d3a0c3be55e044)) || attachment.timelineAttachment != this.attachment.timelineAttachment) this.deform.length = 0;
        this.attachment = attachment;
        this.sequenceIndex = -1;
    }
    /** Sets this slot to the setup pose. */ setToSetupPose() {
        this.color.setFromColor(this.data.color);
        if (this.darkColor) this.darkColor.setFromColor(this.data.darkColor);
        if (!this.data.attachmentName) this.attachment = null;
        else {
            this.attachment = null;
            this.setAttachment(this.bone.skeleton.getAttachment(this.data.index, this.data.attachmentName));
        }
    }
}


/******************************************************************************
 * Spine Runtimes License Agreement
 * Last updated July 28, 2023. Replaces all prior versions.
 *
 * Copyright (c) 2013-2023, Esoteric Software LLC
 *
 * Integration of the Spine Runtimes into software or otherwise creating
 * derivative works of the Spine Runtimes is permitted under the terms and
 * conditions of Section 2 of the Spine Editor License Agreement:
 * http://esotericsoftware.com/spine-editor-license
 *
 * Otherwise, it is permitted to integrate the Spine Runtimes into software or
 * otherwise create derivative works of the Spine Runtimes (collectively,
 * "Products"), provided that each user of the Products must obtain their own
 * Spine Editor license and redistribution of the Products in any form must
 * include this license and copyright notice.
 *
 * THE SPINE RUNTIMES ARE PROVIDED BY ESOTERIC SOFTWARE LLC "AS IS" AND ANY
 * EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
 * WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE
 * DISCLAIMED. IN NO EVENT SHALL ESOTERIC SOFTWARE LLC BE LIABLE FOR ANY
 * DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES
 * (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES,
 * BUSINESS INTERRUPTION, OR LOSS OF USE, DATA, OR PROFITS) HOWEVER CAUSED AND
 * ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT
 * (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THE
 * SPINE RUNTIMES, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
 *****************************************************************************/ 
class $cacedf5f4217ea0c$export$a2d8268faabf5c52 {
    /** The transform constraint's setup pose data. */ data;
    /** The bones that will be modified by this transform constraint. */ bones;
    /** The target bone whose world transform will be copied to the constrained bones. */ target;
    mixRotate = 0;
    mixX = 0;
    mixY = 0;
    mixScaleX = 0;
    mixScaleY = 0;
    mixShearY = 0;
    temp = new (0, $1702fa998ec22e58$export$c977b3e384af9ae1)();
    active = false;
    constructor(data, skeleton){
        if (!data) throw new Error("data cannot be null.");
        if (!skeleton) throw new Error("skeleton cannot be null.");
        this.data = data;
        this.mixRotate = data.mixRotate;
        this.mixX = data.mixX;
        this.mixY = data.mixY;
        this.mixScaleX = data.mixScaleX;
        this.mixScaleY = data.mixScaleY;
        this.mixShearY = data.mixShearY;
        this.bones = new Array();
        for(let i = 0; i < data.bones.length; i++){
            let bone = skeleton.findBone(data.bones[i].name);
            if (!bone) throw new Error(`Couldn't find bone ${data.bones[i].name}.`);
            this.bones.push(bone);
        }
        let target = skeleton.findBone(data.target.name);
        if (!target) throw new Error(`Couldn't find target bone ${data.target.name}.`);
        this.target = target;
    }
    isActive() {
        return this.active;
    }
    update() {
        if (this.mixRotate == 0 && this.mixX == 0 && this.mixY == 0 && this.mixScaleX == 0 && this.mixScaleY == 0 && this.mixShearY == 0) return;
        if (this.data.local) {
            if (this.data.relative) this.applyRelativeLocal();
            else this.applyAbsoluteLocal();
        } else if (this.data.relative) this.applyRelativeWorld();
        else this.applyAbsoluteWorld();
    }
    applyAbsoluteWorld() {
        let mixRotate = this.mixRotate, mixX = this.mixX, mixY = this.mixY, mixScaleX = this.mixScaleX, mixScaleY = this.mixScaleY, mixShearY = this.mixShearY;
        let translate = mixX != 0 || mixY != 0;
        let target = this.target;
        let ta = target.a, tb = target.b, tc = target.c, td = target.d;
        let degRadReflect = ta * td - tb * tc > 0 ? (0, $1702fa998ec22e58$export$6a7ef315a0d1ef07).degRad : -(0, $1702fa998ec22e58$export$6a7ef315a0d1ef07).degRad;
        let offsetRotation = this.data.offsetRotation * degRadReflect;
        let offsetShearY = this.data.offsetShearY * degRadReflect;
        let bones = this.bones;
        for(let i = 0, n = bones.length; i < n; i++){
            let bone = bones[i];
            if (mixRotate != 0) {
                let a = bone.a, b = bone.b, c = bone.c, d = bone.d;
                let r = Math.atan2(tc, ta) - Math.atan2(c, a) + offsetRotation;
                if (r > (0, $1702fa998ec22e58$export$6a7ef315a0d1ef07).PI) r -= (0, $1702fa998ec22e58$export$6a7ef315a0d1ef07).PI2;
                else if (r < -(0, $1702fa998ec22e58$export$6a7ef315a0d1ef07).PI) r += (0, $1702fa998ec22e58$export$6a7ef315a0d1ef07).PI2;
                r *= mixRotate;
                let cos = Math.cos(r), sin = Math.sin(r);
                bone.a = cos * a - sin * c;
                bone.b = cos * b - sin * d;
                bone.c = sin * a + cos * c;
                bone.d = sin * b + cos * d;
            }
            if (translate) {
                let temp = this.temp;
                target.localToWorld(temp.set(this.data.offsetX, this.data.offsetY));
                bone.worldX += (temp.x - bone.worldX) * mixX;
                bone.worldY += (temp.y - bone.worldY) * mixY;
            }
            if (mixScaleX != 0) {
                let s = Math.sqrt(bone.a * bone.a + bone.c * bone.c);
                if (s != 0) s = (s + (Math.sqrt(ta * ta + tc * tc) - s + this.data.offsetScaleX) * mixScaleX) / s;
                bone.a *= s;
                bone.c *= s;
            }
            if (mixScaleY != 0) {
                let s = Math.sqrt(bone.b * bone.b + bone.d * bone.d);
                if (s != 0) s = (s + (Math.sqrt(tb * tb + td * td) - s + this.data.offsetScaleY) * mixScaleY) / s;
                bone.b *= s;
                bone.d *= s;
            }
            if (mixShearY > 0) {
                let b = bone.b, d = bone.d;
                let by = Math.atan2(d, b);
                let r = Math.atan2(td, tb) - Math.atan2(tc, ta) - (by - Math.atan2(bone.c, bone.a));
                if (r > (0, $1702fa998ec22e58$export$6a7ef315a0d1ef07).PI) r -= (0, $1702fa998ec22e58$export$6a7ef315a0d1ef07).PI2;
                else if (r < -(0, $1702fa998ec22e58$export$6a7ef315a0d1ef07).PI) r += (0, $1702fa998ec22e58$export$6a7ef315a0d1ef07).PI2;
                r = by + (r + offsetShearY) * mixShearY;
                let s = Math.sqrt(b * b + d * d);
                bone.b = Math.cos(r) * s;
                bone.d = Math.sin(r) * s;
            }
            bone.updateAppliedTransform();
        }
    }
    applyRelativeWorld() {
        let mixRotate = this.mixRotate, mixX = this.mixX, mixY = this.mixY, mixScaleX = this.mixScaleX, mixScaleY = this.mixScaleY, mixShearY = this.mixShearY;
        let translate = mixX != 0 || mixY != 0;
        let target = this.target;
        let ta = target.a, tb = target.b, tc = target.c, td = target.d;
        let degRadReflect = ta * td - tb * tc > 0 ? (0, $1702fa998ec22e58$export$6a7ef315a0d1ef07).degRad : -(0, $1702fa998ec22e58$export$6a7ef315a0d1ef07).degRad;
        let offsetRotation = this.data.offsetRotation * degRadReflect, offsetShearY = this.data.offsetShearY * degRadReflect;
        let bones = this.bones;
        for(let i = 0, n = bones.length; i < n; i++){
            let bone = bones[i];
            if (mixRotate != 0) {
                let a = bone.a, b = bone.b, c = bone.c, d = bone.d;
                let r = Math.atan2(tc, ta) + offsetRotation;
                if (r > (0, $1702fa998ec22e58$export$6a7ef315a0d1ef07).PI) r -= (0, $1702fa998ec22e58$export$6a7ef315a0d1ef07).PI2;
                else if (r < -(0, $1702fa998ec22e58$export$6a7ef315a0d1ef07).PI) r += (0, $1702fa998ec22e58$export$6a7ef315a0d1ef07).PI2;
                r *= mixRotate;
                let cos = Math.cos(r), sin = Math.sin(r);
                bone.a = cos * a - sin * c;
                bone.b = cos * b - sin * d;
                bone.c = sin * a + cos * c;
                bone.d = sin * b + cos * d;
            }
            if (translate) {
                let temp = this.temp;
                target.localToWorld(temp.set(this.data.offsetX, this.data.offsetY));
                bone.worldX += temp.x * mixX;
                bone.worldY += temp.y * mixY;
            }
            if (mixScaleX != 0) {
                let s = (Math.sqrt(ta * ta + tc * tc) - 1 + this.data.offsetScaleX) * mixScaleX + 1;
                bone.a *= s;
                bone.c *= s;
            }
            if (mixScaleY != 0) {
                let s = (Math.sqrt(tb * tb + td * td) - 1 + this.data.offsetScaleY) * mixScaleY + 1;
                bone.b *= s;
                bone.d *= s;
            }
            if (mixShearY > 0) {
                let r = Math.atan2(td, tb) - Math.atan2(tc, ta);
                if (r > (0, $1702fa998ec22e58$export$6a7ef315a0d1ef07).PI) r -= (0, $1702fa998ec22e58$export$6a7ef315a0d1ef07).PI2;
                else if (r < -(0, $1702fa998ec22e58$export$6a7ef315a0d1ef07).PI) r += (0, $1702fa998ec22e58$export$6a7ef315a0d1ef07).PI2;
                let b = bone.b, d = bone.d;
                r = Math.atan2(d, b) + (r - (0, $1702fa998ec22e58$export$6a7ef315a0d1ef07).PI / 2 + offsetShearY) * mixShearY;
                let s = Math.sqrt(b * b + d * d);
                bone.b = Math.cos(r) * s;
                bone.d = Math.sin(r) * s;
            }
            bone.updateAppliedTransform();
        }
    }
    applyAbsoluteLocal() {
        let mixRotate = this.mixRotate, mixX = this.mixX, mixY = this.mixY, mixScaleX = this.mixScaleX, mixScaleY = this.mixScaleY, mixShearY = this.mixShearY;
        let target = this.target;
        let bones = this.bones;
        for(let i = 0, n = bones.length; i < n; i++){
            let bone = bones[i];
            let rotation = bone.arotation;
            if (mixRotate != 0) {
                let r = target.arotation - rotation + this.data.offsetRotation;
                r -= (16384 - (16384.499999999996 - r / 360 | 0)) * 360;
                rotation += r * mixRotate;
            }
            let x = bone.ax, y = bone.ay;
            x += (target.ax - x + this.data.offsetX) * mixX;
            y += (target.ay - y + this.data.offsetY) * mixY;
            let scaleX = bone.ascaleX, scaleY = bone.ascaleY;
            if (mixScaleX != 0 && scaleX != 0) scaleX = (scaleX + (target.ascaleX - scaleX + this.data.offsetScaleX) * mixScaleX) / scaleX;
            if (mixScaleY != 0 && scaleY != 0) scaleY = (scaleY + (target.ascaleY - scaleY + this.data.offsetScaleY) * mixScaleY) / scaleY;
            let shearY = bone.ashearY;
            if (mixShearY != 0) {
                let r = target.ashearY - shearY + this.data.offsetShearY;
                r -= (16384 - (16384.499999999996 - r / 360 | 0)) * 360;
                shearY += r * mixShearY;
            }
            bone.updateWorldTransformWith(x, y, rotation, scaleX, scaleY, bone.ashearX, shearY);
        }
    }
    applyRelativeLocal() {
        let mixRotate = this.mixRotate, mixX = this.mixX, mixY = this.mixY, mixScaleX = this.mixScaleX, mixScaleY = this.mixScaleY, mixShearY = this.mixShearY;
        let target = this.target;
        let bones = this.bones;
        for(let i = 0, n = bones.length; i < n; i++){
            let bone = bones[i];
            let rotation = bone.arotation + (target.arotation + this.data.offsetRotation) * mixRotate;
            let x = bone.ax + (target.ax + this.data.offsetX) * mixX;
            let y = bone.ay + (target.ay + this.data.offsetY) * mixY;
            let scaleX = bone.ascaleX * ((target.ascaleX - 1 + this.data.offsetScaleX) * mixScaleX + 1);
            let scaleY = bone.ascaleY * ((target.ascaleY - 1 + this.data.offsetScaleY) * mixScaleY + 1);
            let shearY = bone.ashearY + (target.ashearY + this.data.offsetShearY) * mixShearY;
            bone.updateWorldTransformWith(x, y, rotation, scaleX, scaleY, bone.ashearX, shearY);
        }
    }
}



class $3dc39cfdbd0ba43d$export$8f31e4c4a37b8e9c {
    static yDown = false;
    /** The skeleton's setup pose data. */ data;
    /** The skeleton's bones, sorted parent first. The root bone is always the first bone. */ bones;
    /** The skeleton's slots. */ slots;
    /** The skeleton's slots in the order they should be drawn. The returned array may be modified to change the draw order. */ drawOrder;
    /** The skeleton's IK constraints. */ ikConstraints;
    /** The skeleton's transform constraints. */ transformConstraints;
    /** The skeleton's path constraints. */ pathConstraints;
    /** The list of bones and constraints, sorted in the order they should be updated, as computed by {@link #updateCache()}. */ _updateCache = new Array();
    /** The skeleton's current skin. May be null. */ skin = null;
    /** The color to tint all the skeleton's attachments. */ color;
    /** Scales the entire skeleton on the X axis. This affects all bones, even if the bone's transform mode disallows scale
      * inheritance. */ scaleX = 1;
    /** Scales the entire skeleton on the Y axis. This affects all bones, even if the bone's transform mode disallows scale
      * inheritance. */ _scaleY = 1;
    get scaleY() {
        return $3dc39cfdbd0ba43d$export$8f31e4c4a37b8e9c.yDown ? -this._scaleY : this._scaleY;
    }
    set scaleY(scaleY) {
        this._scaleY = scaleY;
    }
    /** Sets the skeleton X position, which is added to the root bone worldX position. */ x = 0;
    /** Sets the skeleton Y position, which is added to the root bone worldY position. */ y = 0;
    constructor(data){
        if (!data) throw new Error("data cannot be null.");
        this.data = data;
        this.bones = new Array();
        for(let i = 0; i < data.bones.length; i++){
            let boneData = data.bones[i];
            let bone;
            if (!boneData.parent) bone = new (0, $40c15a4a15521c66$export$b127726e56765aa4)(boneData, this, null);
            else {
                let parent = this.bones[boneData.parent.index];
                bone = new (0, $40c15a4a15521c66$export$b127726e56765aa4)(boneData, this, parent);
                parent.children.push(bone);
            }
            this.bones.push(bone);
        }
        this.slots = new Array();
        this.drawOrder = new Array();
        for(let i = 0; i < data.slots.length; i++){
            let slotData = data.slots[i];
            let bone = this.bones[slotData.boneData.index];
            let slot = new (0, $20da912a1ef4fb98$export$8c6ed5c666ac1360)(slotData, bone);
            this.slots.push(slot);
            this.drawOrder.push(slot);
        }
        this.ikConstraints = new Array();
        for(let i = 0; i < data.ikConstraints.length; i++){
            let ikConstraintData = data.ikConstraints[i];
            this.ikConstraints.push(new (0, $f465f1df39d40cbb$export$3c158c80ff28c177)(ikConstraintData, this));
        }
        this.transformConstraints = new Array();
        for(let i = 0; i < data.transformConstraints.length; i++){
            let transformConstraintData = data.transformConstraints[i];
            this.transformConstraints.push(new (0, $cacedf5f4217ea0c$export$a2d8268faabf5c52)(transformConstraintData, this));
        }
        this.pathConstraints = new Array();
        for(let i = 0; i < data.pathConstraints.length; i++){
            let pathConstraintData = data.pathConstraints[i];
            this.pathConstraints.push(new (0, $a130814e4f9c40a2$export$cb4f92fb0c018828)(pathConstraintData, this));
        }
        this.color = new (0, $1702fa998ec22e58$export$892596cec99bc70e)(1, 1, 1, 1);
        this.updateCache();
    }
    /** Caches information about bones and constraints. Must be called if the {@link #getSkin()} is modified or if bones,
     * constraints, or weighted path attachments are added or removed. */ updateCache() {
        let updateCache = this._updateCache;
        updateCache.length = 0;
        let bones = this.bones;
        for(let i = 0, n = bones.length; i < n; i++){
            let bone = bones[i];
            bone.sorted = bone.data.skinRequired;
            bone.active = !bone.sorted;
        }
        if (this.skin) {
            let skinBones = this.skin.bones;
            for(let i = 0, n = this.skin.bones.length; i < n; i++){
                let bone = this.bones[skinBones[i].index];
                do {
                    bone.sorted = false;
                    bone.active = true;
                    bone = bone.parent;
                }while (bone);
            }
        }
        // IK first, lowest hierarchy depth first.
        let ikConstraints = this.ikConstraints;
        let transformConstraints = this.transformConstraints;
        let pathConstraints = this.pathConstraints;
        let ikCount = ikConstraints.length, transformCount = transformConstraints.length, pathCount = pathConstraints.length;
        let constraintCount = ikCount + transformCount + pathCount;
        outer: for(let i = 0; i < constraintCount; i++){
            for(let ii = 0; ii < ikCount; ii++){
                let constraint = ikConstraints[ii];
                if (constraint.data.order == i) {
                    this.sortIkConstraint(constraint);
                    continue outer;
                }
            }
            for(let ii = 0; ii < transformCount; ii++){
                let constraint = transformConstraints[ii];
                if (constraint.data.order == i) {
                    this.sortTransformConstraint(constraint);
                    continue outer;
                }
            }
            for(let ii = 0; ii < pathCount; ii++){
                let constraint = pathConstraints[ii];
                if (constraint.data.order == i) {
                    this.sortPathConstraint(constraint);
                    continue outer;
                }
            }
        }
        for(let i = 0, n = bones.length; i < n; i++)this.sortBone(bones[i]);
    }
    sortIkConstraint(constraint) {
        constraint.active = constraint.target.isActive() && (!constraint.data.skinRequired || this.skin && (0, $1702fa998ec22e58$export$d2ca453b913dcdea).contains(this.skin.constraints, constraint.data, true));
        if (!constraint.active) return;
        let target = constraint.target;
        this.sortBone(target);
        let constrained = constraint.bones;
        let parent = constrained[0];
        this.sortBone(parent);
        if (constrained.length == 1) {
            this._updateCache.push(constraint);
            this.sortReset(parent.children);
        } else {
            let child = constrained[constrained.length - 1];
            this.sortBone(child);
            this._updateCache.push(constraint);
            this.sortReset(parent.children);
            child.sorted = true;
        }
    }
    sortPathConstraint(constraint) {
        constraint.active = constraint.target.bone.isActive() && (!constraint.data.skinRequired || this.skin && (0, $1702fa998ec22e58$export$d2ca453b913dcdea).contains(this.skin.constraints, constraint.data, true));
        if (!constraint.active) return;
        let slot = constraint.target;
        let slotIndex = slot.data.index;
        let slotBone = slot.bone;
        if (this.skin) this.sortPathConstraintAttachment(this.skin, slotIndex, slotBone);
        if (this.data.defaultSkin && this.data.defaultSkin != this.skin) this.sortPathConstraintAttachment(this.data.defaultSkin, slotIndex, slotBone);
        for(let i = 0, n = this.data.skins.length; i < n; i++)this.sortPathConstraintAttachment(this.data.skins[i], slotIndex, slotBone);
        let attachment = slot.getAttachment();
        if (attachment instanceof (0, $2fcc86453abe2c1c$export$d285e3ec07b32800)) this.sortPathConstraintAttachmentWith(attachment, slotBone);
        let constrained = constraint.bones;
        let boneCount = constrained.length;
        for(let i = 0; i < boneCount; i++)this.sortBone(constrained[i]);
        this._updateCache.push(constraint);
        for(let i = 0; i < boneCount; i++)this.sortReset(constrained[i].children);
        for(let i = 0; i < boneCount; i++)constrained[i].sorted = true;
    }
    sortTransformConstraint(constraint) {
        constraint.active = constraint.target.isActive() && (!constraint.data.skinRequired || this.skin && (0, $1702fa998ec22e58$export$d2ca453b913dcdea).contains(this.skin.constraints, constraint.data, true));
        if (!constraint.active) return;
        this.sortBone(constraint.target);
        let constrained = constraint.bones;
        let boneCount = constrained.length;
        if (constraint.data.local) for(let i = 0; i < boneCount; i++){
            let child = constrained[i];
            this.sortBone(child.parent);
            this.sortBone(child);
        }
        else for(let i = 0; i < boneCount; i++)this.sortBone(constrained[i]);
        this._updateCache.push(constraint);
        for(let i = 0; i < boneCount; i++)this.sortReset(constrained[i].children);
        for(let i = 0; i < boneCount; i++)constrained[i].sorted = true;
    }
    sortPathConstraintAttachment(skin, slotIndex, slotBone) {
        let attachments = skin.attachments[slotIndex];
        if (!attachments) return;
        for(let key in attachments)this.sortPathConstraintAttachmentWith(attachments[key], slotBone);
    }
    sortPathConstraintAttachmentWith(attachment, slotBone) {
        if (!(attachment instanceof (0, $2fcc86453abe2c1c$export$d285e3ec07b32800))) return;
        let pathBones = attachment.bones;
        if (!pathBones) this.sortBone(slotBone);
        else {
            let bones = this.bones;
            for(let i = 0, n = pathBones.length; i < n;){
                let nn = pathBones[i++];
                nn += i;
                while(i < nn)this.sortBone(bones[pathBones[i++]]);
            }
        }
    }
    sortBone(bone) {
        if (!bone) return;
        if (bone.sorted) return;
        let parent = bone.parent;
        if (parent) this.sortBone(parent);
        bone.sorted = true;
        this._updateCache.push(bone);
    }
    sortReset(bones) {
        for(let i = 0, n = bones.length; i < n; i++){
            let bone = bones[i];
            if (!bone.active) continue;
            if (bone.sorted) this.sortReset(bone.children);
            bone.sorted = false;
        }
    }
    /** Updates the world transform for each bone and applies all constraints.
     *
     * See [World transforms](http://esotericsoftware.com/spine-runtime-skeletons#World-transforms) in the Spine
     * Runtimes Guide. */ updateWorldTransform() {
        let bones = this.bones;
        for(let i = 0, n = bones.length; i < n; i++){
            let bone = bones[i];
            bone.ax = bone.x;
            bone.ay = bone.y;
            bone.arotation = bone.rotation;
            bone.ascaleX = bone.scaleX;
            bone.ascaleY = bone.scaleY;
            bone.ashearX = bone.shearX;
            bone.ashearY = bone.shearY;
        }
        let updateCache = this._updateCache;
        for(let i = 0, n = updateCache.length; i < n; i++)updateCache[i].update();
    }
    updateWorldTransformWith(parent) {
        // Apply the parent bone transform to the root bone. The root bone always inherits scale, rotation and reflection.
        let rootBone = this.getRootBone();
        if (!rootBone) throw new Error("Root bone must not be null.");
        let pa = parent.a, pb = parent.b, pc = parent.c, pd = parent.d;
        rootBone.worldX = pa * this.x + pb * this.y + parent.worldX;
        rootBone.worldY = pc * this.x + pd * this.y + parent.worldY;
        let rotationY = rootBone.rotation + 90 + rootBone.shearY;
        let la = (0, $1702fa998ec22e58$export$6a7ef315a0d1ef07).cosDeg(rootBone.rotation + rootBone.shearX) * rootBone.scaleX;
        let lb = (0, $1702fa998ec22e58$export$6a7ef315a0d1ef07).cosDeg(rotationY) * rootBone.scaleY;
        let lc = (0, $1702fa998ec22e58$export$6a7ef315a0d1ef07).sinDeg(rootBone.rotation + rootBone.shearX) * rootBone.scaleX;
        let ld = (0, $1702fa998ec22e58$export$6a7ef315a0d1ef07).sinDeg(rotationY) * rootBone.scaleY;
        rootBone.a = (pa * la + pb * lc) * this.scaleX;
        rootBone.b = (pa * lb + pb * ld) * this.scaleX;
        rootBone.c = (pc * la + pd * lc) * this.scaleY;
        rootBone.d = (pc * lb + pd * ld) * this.scaleY;
        // Update everything except root bone.
        let updateCache = this._updateCache;
        for(let i = 0, n = updateCache.length; i < n; i++){
            let updatable = updateCache[i];
            if (updatable != rootBone) updatable.update();
        }
    }
    /** Sets the bones, constraints, and slots to their setup pose values. */ setToSetupPose() {
        this.setBonesToSetupPose();
        this.setSlotsToSetupPose();
    }
    /** Sets the bones and constraints to their setup pose values. */ setBonesToSetupPose() {
        let bones = this.bones;
        for(let i = 0, n = bones.length; i < n; i++)bones[i].setToSetupPose();
        let ikConstraints = this.ikConstraints;
        for(let i = 0, n = ikConstraints.length; i < n; i++){
            let constraint = ikConstraints[i];
            constraint.mix = constraint.data.mix;
            constraint.softness = constraint.data.softness;
            constraint.bendDirection = constraint.data.bendDirection;
            constraint.compress = constraint.data.compress;
            constraint.stretch = constraint.data.stretch;
        }
        let transformConstraints = this.transformConstraints;
        for(let i = 0, n = transformConstraints.length; i < n; i++){
            let constraint = transformConstraints[i];
            let data = constraint.data;
            constraint.mixRotate = data.mixRotate;
            constraint.mixX = data.mixX;
            constraint.mixY = data.mixY;
            constraint.mixScaleX = data.mixScaleX;
            constraint.mixScaleY = data.mixScaleY;
            constraint.mixShearY = data.mixShearY;
        }
        let pathConstraints = this.pathConstraints;
        for(let i = 0, n = pathConstraints.length; i < n; i++){
            let constraint = pathConstraints[i];
            let data = constraint.data;
            constraint.position = data.position;
            constraint.spacing = data.spacing;
            constraint.mixRotate = data.mixRotate;
            constraint.mixX = data.mixX;
            constraint.mixY = data.mixY;
        }
    }
    /** Sets the slots and draw order to their setup pose values. */ setSlotsToSetupPose() {
        let slots = this.slots;
        (0, $1702fa998ec22e58$export$d2ca453b913dcdea).arrayCopy(slots, 0, this.drawOrder, 0, slots.length);
        for(let i = 0, n = slots.length; i < n; i++)slots[i].setToSetupPose();
    }
    /** @returns May return null. */ getRootBone() {
        if (this.bones.length == 0) return null;
        return this.bones[0];
    }
    /** @returns May be null. */ findBone(boneName) {
        if (!boneName) throw new Error("boneName cannot be null.");
        let bones = this.bones;
        for(let i = 0, n = bones.length; i < n; i++){
            let bone = bones[i];
            if (bone.data.name == boneName) return bone;
        }
        return null;
    }
    /** Finds a slot by comparing each slot's name. It is more efficient to cache the results of this method than to call it
     * repeatedly.
     * @returns May be null. */ findSlot(slotName) {
        if (!slotName) throw new Error("slotName cannot be null.");
        let slots = this.slots;
        for(let i = 0, n = slots.length; i < n; i++){
            let slot = slots[i];
            if (slot.data.name == slotName) return slot;
        }
        return null;
    }
    /** Sets a skin by name.
     *
     * See {@link #setSkin()}. */ setSkinByName(skinName) {
        let skin = this.data.findSkin(skinName);
        if (!skin) throw new Error("Skin not found: " + skinName);
        this.setSkin(skin);
    }
    /** Sets the skin used to look up attachments before looking in the {@link SkeletonData#defaultSkin default skin}. If the
     * skin is changed, {@link #updateCache()} is called.
     *
     * Attachments from the new skin are attached if the corresponding attachment from the old skin was attached. If there was no
     * old skin, each slot's setup mode attachment is attached from the new skin.
     *
     * After changing the skin, the visible attachments can be reset to those attached in the setup pose by calling
     * {@link #setSlotsToSetupPose()}. Also, often {@link AnimationState#apply()} is called before the next time the
     * skeleton is rendered to allow any attachment keys in the current animation(s) to hide or show attachments from the new skin.
     * @param newSkin May be null. */ setSkin(newSkin) {
        if (newSkin == this.skin) return;
        if (newSkin) {
            if (this.skin) newSkin.attachAll(this, this.skin);
            else {
                let slots = this.slots;
                for(let i = 0, n = slots.length; i < n; i++){
                    let slot = slots[i];
                    let name = slot.data.attachmentName;
                    if (name) {
                        let attachment = newSkin.getAttachment(i, name);
                        if (attachment) slot.setAttachment(attachment);
                    }
                }
            }
        }
        this.skin = newSkin;
        this.updateCache();
    }
    /** Finds an attachment by looking in the {@link #skin} and {@link SkeletonData#defaultSkin} using the slot name and attachment
     * name.
     *
     * See {@link #getAttachment()}.
     * @returns May be null. */ getAttachmentByName(slotName, attachmentName) {
        let slot = this.data.findSlot(slotName);
        if (!slot) throw new Error(`Can't find slot with name ${slotName}`);
        return this.getAttachment(slot.index, attachmentName);
    }
    /** Finds an attachment by looking in the {@link #skin} and {@link SkeletonData#defaultSkin} using the slot index and
     * attachment name. First the skin is checked and if the attachment was not found, the default skin is checked.
     *
     * See [Runtime skins](http://esotericsoftware.com/spine-runtime-skins) in the Spine Runtimes Guide.
     * @returns May be null. */ getAttachment(slotIndex, attachmentName) {
        if (!attachmentName) throw new Error("attachmentName cannot be null.");
        if (this.skin) {
            let attachment = this.skin.getAttachment(slotIndex, attachmentName);
            if (attachment) return attachment;
        }
        if (this.data.defaultSkin) return this.data.defaultSkin.getAttachment(slotIndex, attachmentName);
        return null;
    }
    /** A convenience method to set an attachment by finding the slot with {@link #findSlot()}, finding the attachment with
     * {@link #getAttachment()}, then setting the slot's {@link Slot#attachment}.
     * @param attachmentName May be null to clear the slot's attachment. */ setAttachment(slotName, attachmentName) {
        if (!slotName) throw new Error("slotName cannot be null.");
        let slots = this.slots;
        for(let i = 0, n = slots.length; i < n; i++){
            let slot = slots[i];
            if (slot.data.name == slotName) {
                let attachment = null;
                if (attachmentName) {
                    attachment = this.getAttachment(i, attachmentName);
                    if (!attachment) throw new Error("Attachment not found: " + attachmentName + ", for slot: " + slotName);
                }
                slot.setAttachment(attachment);
                return;
            }
        }
        throw new Error("Slot not found: " + slotName);
    }
    /** Finds an IK constraint by comparing each IK constraint's name. It is more efficient to cache the results of this method
     * than to call it repeatedly.
     * @return May be null. */ findIkConstraint(constraintName) {
        if (!constraintName) throw new Error("constraintName cannot be null.");
        let ikConstraints = this.ikConstraints;
        for(let i = 0, n = ikConstraints.length; i < n; i++){
            let ikConstraint = ikConstraints[i];
            if (ikConstraint.data.name == constraintName) return ikConstraint;
        }
        return null;
    }
    /** Finds a transform constraint by comparing each transform constraint's name. It is more efficient to cache the results of
     * this method than to call it repeatedly.
     * @return May be null. */ findTransformConstraint(constraintName) {
        if (!constraintName) throw new Error("constraintName cannot be null.");
        let transformConstraints = this.transformConstraints;
        for(let i = 0, n = transformConstraints.length; i < n; i++){
            let constraint = transformConstraints[i];
            if (constraint.data.name == constraintName) return constraint;
        }
        return null;
    }
    /** Finds a path constraint by comparing each path constraint's name. It is more efficient to cache the results of this method
     * than to call it repeatedly.
     * @return May be null. */ findPathConstraint(constraintName) {
        if (!constraintName) throw new Error("constraintName cannot be null.");
        let pathConstraints = this.pathConstraints;
        for(let i = 0, n = pathConstraints.length; i < n; i++){
            let constraint = pathConstraints[i];
            if (constraint.data.name == constraintName) return constraint;
        }
        return null;
    }
    /** Returns the axis aligned bounding box (AABB) of the region and mesh attachments for the current pose as `{ x: number, y: number, width: number, height: number }`.
     * Note that this method will create temporary objects which can add to garbage collection pressure. Use `getBounds()` if garbage collection is a concern. */ getBoundsRect() {
        let offset = new (0, $1702fa998ec22e58$export$c977b3e384af9ae1)();
        let size = new (0, $1702fa998ec22e58$export$c977b3e384af9ae1)();
        this.getBounds(offset, size);
        return {
            x: offset.x,
            y: offset.y,
            width: size.x,
            height: size.y
        };
    }
    /** Returns the axis aligned bounding box (AABB) of the region and mesh attachments for the current pose.
     * @param offset An output value, the distance from the skeleton origin to the bottom left corner of the AABB.
     * @param size An output value, the width and height of the AABB.
     * @param temp Working memory to temporarily store attachments' computed world vertices. */ getBounds(offset, size, temp = new Array(2)) {
        if (!offset) throw new Error("offset cannot be null.");
        if (!size) throw new Error("size cannot be null.");
        let drawOrder = this.drawOrder;
        let minX = Number.POSITIVE_INFINITY, minY = Number.POSITIVE_INFINITY, maxX = Number.NEGATIVE_INFINITY, maxY = Number.NEGATIVE_INFINITY;
        for(let i = 0, n = drawOrder.length; i < n; i++){
            let slot = drawOrder[i];
            if (!slot.bone.active) continue;
            let verticesLength = 0;
            let vertices = null;
            let attachment = slot.getAttachment();
            if (attachment instanceof (0, $6355869a5ef59f02$export$d0fc51466fa6d530)) {
                verticesLength = 8;
                vertices = (0, $1702fa998ec22e58$export$d2ca453b913dcdea).setArraySize(temp, verticesLength, 0);
                attachment.computeWorldVertices(slot, vertices, 0, 2);
            } else if (attachment instanceof (0, $3ed5c5afaf00d170$export$3f1c1692adfcf3e2)) {
                let mesh = attachment;
                verticesLength = mesh.worldVerticesLength;
                vertices = (0, $1702fa998ec22e58$export$d2ca453b913dcdea).setArraySize(temp, verticesLength, 0);
                mesh.computeWorldVertices(slot, 0, verticesLength, vertices, 0, 2);
            }
            if (vertices) for(let ii = 0, nn = vertices.length; ii < nn; ii += 2){
                let x = vertices[ii], y = vertices[ii + 1];
                minX = Math.min(minX, x);
                minY = Math.min(minY, y);
                maxX = Math.max(maxX, x);
                maxY = Math.max(maxY, y);
            }
        }
        offset.set(minX, minY);
        size.set(maxX - minX, maxY - minY);
    }
}


/******************************************************************************
 * Spine Runtimes License Agreement
 * Last updated July 28, 2023. Replaces all prior versions.
 *
 * Copyright (c) 2013-2023, Esoteric Software LLC
 *
 * Integration of the Spine Runtimes into software or otherwise creating
 * derivative works of the Spine Runtimes is permitted under the terms and
 * conditions of Section 2 of the Spine Editor License Agreement:
 * http://esotericsoftware.com/spine-editor-license
 *
 * Otherwise, it is permitted to integrate the Spine Runtimes into software or
 * otherwise create derivative works of the Spine Runtimes (collectively,
 * "Products"), provided that each user of the Products must obtain their own
 * Spine Editor license and redistribution of the Products in any form must
 * include this license and copyright notice.
 *
 * THE SPINE RUNTIMES ARE PROVIDED BY ESOTERIC SOFTWARE LLC "AS IS" AND ANY
 * EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
 * WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE
 * DISCLAIMED. IN NO EVENT SHALL ESOTERIC SOFTWARE LLC BE LIABLE FOR ANY
 * DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES
 * (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES,
 * BUSINESS INTERRUPTION, OR LOSS OF USE, DATA, OR PROFITS) HOWEVER CAUSED AND
 * ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT
 * (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THE
 * SPINE RUNTIMES, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
 *****************************************************************************/ 






/******************************************************************************
 * Spine Runtimes License Agreement
 * Last updated July 28, 2023. Replaces all prior versions.
 *
 * Copyright (c) 2013-2023, Esoteric Software LLC
 *
 * Integration of the Spine Runtimes into software or otherwise creating
 * derivative works of the Spine Runtimes is permitted under the terms and
 * conditions of Section 2 of the Spine Editor License Agreement:
 * http://esotericsoftware.com/spine-editor-license
 *
 * Otherwise, it is permitted to integrate the Spine Runtimes into software or
 * otherwise create derivative works of the Spine Runtimes (collectively,
 * "Products"), provided that each user of the Products must obtain their own
 * Spine Editor license and redistribution of the Products in any form must
 * include this license and copyright notice.
 *
 * THE SPINE RUNTIMES ARE PROVIDED BY ESOTERIC SOFTWARE LLC "AS IS" AND ANY
 * EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
 * WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE
 * DISCLAIMED. IN NO EVENT SHALL ESOTERIC SOFTWARE LLC BE LIABLE FOR ANY
 * DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES
 * (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES,
 * BUSINESS INTERRUPTION, OR LOSS OF USE, DATA, OR PROFITS) HOWEVER CAUSED AND
 * ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT
 * (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THE
 * SPINE RUNTIMES, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
 *****************************************************************************/ /** Stores the setup pose and all of the stateless data for a skeleton.
 *
 * See [Data objects](http://esotericsoftware.com/spine-runtime-architecture#Data-objects) in the Spine Runtimes
 * Guide. */ class $9859a8a0f6d556f1$export$e8f362f163550575 {
    /** The skeleton's name, which by default is the name of the skeleton data file, if possible. May be null. */ name = null;
    /** The skeleton's bones, sorted parent first. The root bone is always the first bone. */ bones = new Array();
    /** The skeleton's slots. */ slots = new Array();
    skins = new Array();
    /** The skeleton's default skin. By default this skin contains all attachments that were not in a skin in Spine.
     *
     * See {@link Skeleton#getAttachmentByName()}.
     * May be null. */ defaultSkin = null;
    /** The skeleton's events. */ events = new Array();
    /** The skeleton's animations. */ animations = new Array();
    /** The skeleton's IK constraints. */ ikConstraints = new Array();
    /** The skeleton's transform constraints. */ transformConstraints = new Array();
    /** The skeleton's path constraints. */ pathConstraints = new Array();
    /** The X coordinate of the skeleton's axis aligned bounding box in the setup pose. */ x = 0;
    /** The Y coordinate of the skeleton's axis aligned bounding box in the setup pose. */ y = 0;
    /** The width of the skeleton's axis aligned bounding box in the setup pose. */ width = 0;
    /** The height of the skeleton's axis aligned bounding box in the setup pose. */ height = 0;
    /** The Spine version used to export the skeleton data, or null. */ version = null;
    /** The skeleton data hash. This value will change if any of the skeleton data has changed. May be null. */ hash = null;
    // Nonessential
    /** The dopesheet FPS in Spine. Available only when nonessential data was exported. */ fps = 0;
    /** The path to the images directory as defined in Spine. Available only when nonessential data was exported. May be null. */ imagesPath = null;
    /** The path to the audio directory as defined in Spine. Available only when nonessential data was exported. May be null. */ audioPath = null;
    /** Finds a bone by comparing each bone's name. It is more efficient to cache the results of this method than to call it
     * multiple times.
     * @returns May be null. */ findBone(boneName) {
        if (!boneName) throw new Error("boneName cannot be null.");
        let bones = this.bones;
        for(let i = 0, n = bones.length; i < n; i++){
            let bone = bones[i];
            if (bone.name == boneName) return bone;
        }
        return null;
    }
    /** Finds a slot by comparing each slot's name. It is more efficient to cache the results of this method than to call it
     * multiple times.
     * @returns May be null. */ findSlot(slotName) {
        if (!slotName) throw new Error("slotName cannot be null.");
        let slots = this.slots;
        for(let i = 0, n = slots.length; i < n; i++){
            let slot = slots[i];
            if (slot.name == slotName) return slot;
        }
        return null;
    }
    /** Finds a skin by comparing each skin's name. It is more efficient to cache the results of this method than to call it
     * multiple times.
     * @returns May be null. */ findSkin(skinName) {
        if (!skinName) throw new Error("skinName cannot be null.");
        let skins = this.skins;
        for(let i = 0, n = skins.length; i < n; i++){
            let skin = skins[i];
            if (skin.name == skinName) return skin;
        }
        return null;
    }
    /** Finds an event by comparing each events's name. It is more efficient to cache the results of this method than to call it
     * multiple times.
     * @returns May be null. */ findEvent(eventDataName) {
        if (!eventDataName) throw new Error("eventDataName cannot be null.");
        let events = this.events;
        for(let i = 0, n = events.length; i < n; i++){
            let event = events[i];
            if (event.name == eventDataName) return event;
        }
        return null;
    }
    /** Finds an animation by comparing each animation's name. It is more efficient to cache the results of this method than to
     * call it multiple times.
     * @returns May be null. */ findAnimation(animationName) {
        if (!animationName) throw new Error("animationName cannot be null.");
        let animations = this.animations;
        for(let i = 0, n = animations.length; i < n; i++){
            let animation = animations[i];
            if (animation.name == animationName) return animation;
        }
        return null;
    }
    /** Finds an IK constraint by comparing each IK constraint's name. It is more efficient to cache the results of this method
     * than to call it multiple times.
     * @return May be null. */ findIkConstraint(constraintName) {
        if (!constraintName) throw new Error("constraintName cannot be null.");
        let ikConstraints = this.ikConstraints;
        for(let i = 0, n = ikConstraints.length; i < n; i++){
            let constraint = ikConstraints[i];
            if (constraint.name == constraintName) return constraint;
        }
        return null;
    }
    /** Finds a transform constraint by comparing each transform constraint's name. It is more efficient to cache the results of
     * this method than to call it multiple times.
     * @return May be null. */ findTransformConstraint(constraintName) {
        if (!constraintName) throw new Error("constraintName cannot be null.");
        let transformConstraints = this.transformConstraints;
        for(let i = 0, n = transformConstraints.length; i < n; i++){
            let constraint = transformConstraints[i];
            if (constraint.name == constraintName) return constraint;
        }
        return null;
    }
    /** Finds a path constraint by comparing each path constraint's name. It is more efficient to cache the results of this method
     * than to call it multiple times.
     * @return May be null. */ findPathConstraint(constraintName) {
        if (!constraintName) throw new Error("constraintName cannot be null.");
        let pathConstraints = this.pathConstraints;
        for(let i = 0, n = pathConstraints.length; i < n; i++){
            let constraint = pathConstraints[i];
            if (constraint.name == constraintName) return constraint;
        }
        return null;
    }
}


/******************************************************************************
 * Spine Runtimes License Agreement
 * Last updated July 28, 2023. Replaces all prior versions.
 *
 * Copyright (c) 2013-2023, Esoteric Software LLC
 *
 * Integration of the Spine Runtimes into software or otherwise creating
 * derivative works of the Spine Runtimes is permitted under the terms and
 * conditions of Section 2 of the Spine Editor License Agreement:
 * http://esotericsoftware.com/spine-editor-license
 *
 * Otherwise, it is permitted to integrate the Spine Runtimes into software or
 * otherwise create derivative works of the Spine Runtimes (collectively,
 * "Products"), provided that each user of the Products must obtain their own
 * Spine Editor license and redistribution of the Products in any form must
 * include this license and copyright notice.
 *
 * THE SPINE RUNTIMES ARE PROVIDED BY ESOTERIC SOFTWARE LLC "AS IS" AND ANY
 * EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
 * WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE
 * DISCLAIMED. IN NO EVENT SHALL ESOTERIC SOFTWARE LLC BE LIABLE FOR ANY
 * DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES
 * (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES,
 * BUSINESS INTERRUPTION, OR LOSS OF USE, DATA, OR PROFITS) HOWEVER CAUSED AND
 * ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT
 * (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THE
 * SPINE RUNTIMES, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
 *****************************************************************************/ 
class $73641f3ef2c01e99$export$18ca51770a196b7d {
    slotIndex;
    name;
    attachment;
    constructor(slotIndex = 0, name, attachment){
        this.slotIndex = slotIndex;
        this.name = name;
        this.attachment = attachment;
    }
}
class $73641f3ef2c01e99$export$b8e0f93a76772233 {
    /** The skin's name, which is unique across all skins in the skeleton. */ name;
    attachments = new Array();
    bones = Array();
    constraints = new Array();
    constructor(name){
        if (!name) throw new Error("name cannot be null.");
        this.name = name;
    }
    /** Adds an attachment to the skin for the specified slot index and name. */ setAttachment(slotIndex, name, attachment) {
        if (!attachment) throw new Error("attachment cannot be null.");
        let attachments = this.attachments;
        if (slotIndex >= attachments.length) attachments.length = slotIndex + 1;
        if (!attachments[slotIndex]) attachments[slotIndex] = {};
        attachments[slotIndex][name] = attachment;
    }
    /** Adds all attachments, bones, and constraints from the specified skin to this skin. */ addSkin(skin) {
        for(let i = 0; i < skin.bones.length; i++){
            let bone = skin.bones[i];
            let contained = false;
            for(let ii = 0; ii < this.bones.length; ii++)if (this.bones[ii] == bone) {
                contained = true;
                break;
            }
            if (!contained) this.bones.push(bone);
        }
        for(let i = 0; i < skin.constraints.length; i++){
            let constraint = skin.constraints[i];
            let contained = false;
            for(let ii = 0; ii < this.constraints.length; ii++)if (this.constraints[ii] == constraint) {
                contained = true;
                break;
            }
            if (!contained) this.constraints.push(constraint);
        }
        let attachments = skin.getAttachments();
        for(let i = 0; i < attachments.length; i++){
            var attachment = attachments[i];
            this.setAttachment(attachment.slotIndex, attachment.name, attachment.attachment);
        }
    }
    /** Adds all bones and constraints and copies of all attachments from the specified skin to this skin. Mesh attachments are not
     * copied, instead a new linked mesh is created. The attachment copies can be modified without affecting the originals. */ copySkin(skin) {
        for(let i = 0; i < skin.bones.length; i++){
            let bone = skin.bones[i];
            let contained = false;
            for(let ii = 0; ii < this.bones.length; ii++)if (this.bones[ii] == bone) {
                contained = true;
                break;
            }
            if (!contained) this.bones.push(bone);
        }
        for(let i = 0; i < skin.constraints.length; i++){
            let constraint = skin.constraints[i];
            let contained = false;
            for(let ii = 0; ii < this.constraints.length; ii++)if (this.constraints[ii] == constraint) {
                contained = true;
                break;
            }
            if (!contained) this.constraints.push(constraint);
        }
        let attachments = skin.getAttachments();
        for(let i = 0; i < attachments.length; i++){
            var attachment = attachments[i];
            if (!attachment.attachment) continue;
            if (attachment.attachment instanceof (0, $3ed5c5afaf00d170$export$3f1c1692adfcf3e2)) {
                attachment.attachment = attachment.attachment.newLinkedMesh();
                this.setAttachment(attachment.slotIndex, attachment.name, attachment.attachment);
            } else {
                attachment.attachment = attachment.attachment.copy();
                this.setAttachment(attachment.slotIndex, attachment.name, attachment.attachment);
            }
        }
    }
    /** Returns the attachment for the specified slot index and name, or null. */ getAttachment(slotIndex, name) {
        let dictionary = this.attachments[slotIndex];
        return dictionary ? dictionary[name] : null;
    }
    /** Removes the attachment in the skin for the specified slot index and name, if any. */ removeAttachment(slotIndex, name) {
        let dictionary = this.attachments[slotIndex];
        if (dictionary) delete dictionary[name];
    }
    /** Returns all attachments in this skin. */ getAttachments() {
        let entries = new Array();
        for(var i = 0; i < this.attachments.length; i++){
            let slotAttachments = this.attachments[i];
            if (slotAttachments) for(let name in slotAttachments){
                let attachment = slotAttachments[name];
                if (attachment) entries.push(new $73641f3ef2c01e99$export$18ca51770a196b7d(i, name, attachment));
            }
        }
        return entries;
    }
    /** Returns all attachments in this skin for the specified slot index. */ getAttachmentsForSlot(slotIndex, attachments) {
        let slotAttachments = this.attachments[slotIndex];
        if (slotAttachments) for(let name in slotAttachments){
            let attachment = slotAttachments[name];
            if (attachment) attachments.push(new $73641f3ef2c01e99$export$18ca51770a196b7d(slotIndex, name, attachment));
        }
    }
    /** Clears all attachments, bones, and constraints. */ clear() {
        this.attachments.length = 0;
        this.bones.length = 0;
        this.constraints.length = 0;
    }
    /** Attach each attachment in this skin if the corresponding attachment in the old skin is currently attached. */ attachAll(skeleton, oldSkin) {
        let slotIndex = 0;
        for(let i = 0; i < skeleton.slots.length; i++){
            let slot = skeleton.slots[i];
            let slotAttachment = slot.getAttachment();
            if (slotAttachment && slotIndex < oldSkin.attachments.length) {
                let dictionary = oldSkin.attachments[slotIndex];
                for(let key in dictionary){
                    let skinAttachment = dictionary[key];
                    if (slotAttachment == skinAttachment) {
                        let attachment = this.getAttachment(slotIndex, key);
                        if (attachment) slot.setAttachment(attachment);
                        break;
                    }
                }
            }
            slotIndex++;
        }
    }
}


/******************************************************************************
 * Spine Runtimes License Agreement
 * Last updated July 28, 2023. Replaces all prior versions.
 *
 * Copyright (c) 2013-2023, Esoteric Software LLC
 *
 * Integration of the Spine Runtimes into software or otherwise creating
 * derivative works of the Spine Runtimes is permitted under the terms and
 * conditions of Section 2 of the Spine Editor License Agreement:
 * http://esotericsoftware.com/spine-editor-license
 *
 * Otherwise, it is permitted to integrate the Spine Runtimes into software or
 * otherwise create derivative works of the Spine Runtimes (collectively,
 * "Products"), provided that each user of the Products must obtain their own
 * Spine Editor license and redistribution of the Products in any form must
 * include this license and copyright notice.
 *
 * THE SPINE RUNTIMES ARE PROVIDED BY ESOTERIC SOFTWARE LLC "AS IS" AND ANY
 * EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
 * WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE
 * DISCLAIMED. IN NO EVENT SHALL ESOTERIC SOFTWARE LLC BE LIABLE FOR ANY
 * DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES
 * (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES,
 * BUSINESS INTERRUPTION, OR LOSS OF USE, DATA, OR PROFITS) HOWEVER CAUSED AND
 * ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT
 * (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THE
 * SPINE RUNTIMES, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
 *****************************************************************************/ 
class $64f50722bcc00a44$export$a4cce1bf50208679 {
    /** The index of the slot in {@link Skeleton#getSlots()}. */ index = 0;
    /** The name of the slot, which is unique across all slots in the skeleton. */ name;
    /** The bone this slot belongs to. */ boneData;
    /** The color used to tint the slot's attachment. If {@link #getDarkColor()} is set, this is used as the light color for two
     * color tinting. */ color = new (0, $1702fa998ec22e58$export$892596cec99bc70e)(1, 1, 1, 1);
    /** The dark color used to tint the slot's attachment for two color tinting, or null if two color tinting is not used. The dark
     * color's alpha is not used. */ darkColor = null;
    /** The name of the attachment that is visible for this slot in the setup pose, or null if no attachment is visible. */ attachmentName = null;
    /** The blend mode for drawing the slot's attachment. */ blendMode = $64f50722bcc00a44$export$c9b8fe72ac71821.Normal;
    constructor(index, name, boneData){
        if (index < 0) throw new Error("index must be >= 0.");
        if (!name) throw new Error("name cannot be null.");
        if (!boneData) throw new Error("boneData cannot be null.");
        this.index = index;
        this.name = name;
        this.boneData = boneData;
    }
}
var $64f50722bcc00a44$export$c9b8fe72ac71821;
(function(BlendMode) {
    BlendMode[BlendMode["Normal"] = 0] = "Normal";
    BlendMode[BlendMode["Additive"] = 1] = "Additive";
    BlendMode[BlendMode["Multiply"] = 2] = "Multiply";
    BlendMode[BlendMode["Screen"] = 3] = "Screen";
})($64f50722bcc00a44$export$c9b8fe72ac71821 || ($64f50722bcc00a44$export$c9b8fe72ac71821 = {}));


/******************************************************************************
 * Spine Runtimes License Agreement
 * Last updated July 28, 2023. Replaces all prior versions.
 *
 * Copyright (c) 2013-2023, Esoteric Software LLC
 *
 * Integration of the Spine Runtimes into software or otherwise creating
 * derivative works of the Spine Runtimes is permitted under the terms and
 * conditions of Section 2 of the Spine Editor License Agreement:
 * http://esotericsoftware.com/spine-editor-license
 *
 * Otherwise, it is permitted to integrate the Spine Runtimes into software or
 * otherwise create derivative works of the Spine Runtimes (collectively,
 * "Products"), provided that each user of the Products must obtain their own
 * Spine Editor license and redistribution of the Products in any form must
 * include this license and copyright notice.
 *
 * THE SPINE RUNTIMES ARE PROVIDED BY ESOTERIC SOFTWARE LLC "AS IS" AND ANY
 * EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
 * WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE
 * DISCLAIMED. IN NO EVENT SHALL ESOTERIC SOFTWARE LLC BE LIABLE FOR ANY
 * DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES
 * (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES,
 * BUSINESS INTERRUPTION, OR LOSS OF USE, DATA, OR PROFITS) HOWEVER CAUSED AND
 * ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT
 * (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THE
 * SPINE RUNTIMES, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
 *****************************************************************************/ 
class $2699ed07640898d3$export$823fbc29771afdb5 extends (0, $a1d4de5372395191$export$b826e1ab3af63566) {
    /** The bones that will be modified by this transform constraint. */ bones = new Array();
    /** The target bone whose world transform will be copied to the constrained bones. */ _target = null;
    set target(boneData) {
        this._target = boneData;
    }
    get target() {
        if (!this._target) throw new Error("BoneData not set.");
        else return this._target;
    }
    mixRotate = 0;
    mixX = 0;
    mixY = 0;
    mixScaleX = 0;
    mixScaleY = 0;
    mixShearY = 0;
    /** An offset added to the constrained bone rotation. */ offsetRotation = 0;
    /** An offset added to the constrained bone X translation. */ offsetX = 0;
    /** An offset added to the constrained bone Y translation. */ offsetY = 0;
    /** An offset added to the constrained bone scaleX. */ offsetScaleX = 0;
    /** An offset added to the constrained bone scaleY. */ offsetScaleY = 0;
    /** An offset added to the constrained bone shearY. */ offsetShearY = 0;
    relative = false;
    local = false;
    constructor(name){
        super(name, 0, false);
    }
}



class $97fef4e9c50039b0$export$a7f7eaf4e9fce9ef {
    /** Scales bone positions, image sizes, and translations as they are loaded. This allows different size images to be used at
     * runtime than were used in Spine.
     *
     * See [Scaling](http://esotericsoftware.com/spine-loading-skeleton-data#Scaling) in the Spine Runtimes Guide. */ scale = 1;
    attachmentLoader;
    linkedMeshes = new Array();
    constructor(attachmentLoader){
        this.attachmentLoader = attachmentLoader;
    }
    readSkeletonData(binary) {
        let scale = this.scale;
        let skeletonData = new (0, $9859a8a0f6d556f1$export$e8f362f163550575)();
        skeletonData.name = ""; // BOZO
        let input = new $97fef4e9c50039b0$export$c8e921ea3330f774(binary);
        let lowHash = input.readInt32();
        let highHash = input.readInt32();
        skeletonData.hash = highHash == 0 && lowHash == 0 ? null : highHash.toString(16) + lowHash.toString(16);
        skeletonData.version = input.readString();
        skeletonData.x = input.readFloat();
        skeletonData.y = input.readFloat();
        skeletonData.width = input.readFloat();
        skeletonData.height = input.readFloat();
        let nonessential = input.readBoolean();
        if (nonessential) {
            skeletonData.fps = input.readFloat();
            skeletonData.imagesPath = input.readString();
            skeletonData.audioPath = input.readString();
        }
        let n = 0;
        // Strings.
        n = input.readInt(true);
        for(let i = 0; i < n; i++){
            let str = input.readString();
            if (!str) throw new Error("String in string table must not be null.");
            input.strings.push(str);
        }
        // Bones.
        n = input.readInt(true);
        for(let i = 0; i < n; i++){
            let name = input.readString();
            if (!name) throw new Error("Bone name must not be null.");
            let parent = i == 0 ? null : skeletonData.bones[input.readInt(true)];
            let data = new (0, $15d066d20c83b36f$export$7d85d96cf093e12f)(i, name, parent);
            data.rotation = input.readFloat();
            data.x = input.readFloat() * scale;
            data.y = input.readFloat() * scale;
            data.scaleX = input.readFloat();
            data.scaleY = input.readFloat();
            data.shearX = input.readFloat();
            data.shearY = input.readFloat();
            data.length = input.readFloat() * scale;
            data.transformMode = input.readInt(true);
            data.skinRequired = input.readBoolean();
            if (nonessential) (0, $1702fa998ec22e58$export$892596cec99bc70e).rgba8888ToColor(data.color, input.readInt32());
            skeletonData.bones.push(data);
        }
        // Slots.
        n = input.readInt(true);
        for(let i = 0; i < n; i++){
            let slotName = input.readString();
            if (!slotName) throw new Error("Slot name must not be null.");
            let boneData = skeletonData.bones[input.readInt(true)];
            let data = new (0, $64f50722bcc00a44$export$a4cce1bf50208679)(i, slotName, boneData);
            (0, $1702fa998ec22e58$export$892596cec99bc70e).rgba8888ToColor(data.color, input.readInt32());
            let darkColor = input.readInt32();
            if (darkColor != -1) (0, $1702fa998ec22e58$export$892596cec99bc70e).rgb888ToColor(data.darkColor = new (0, $1702fa998ec22e58$export$892596cec99bc70e)(), darkColor);
            data.attachmentName = input.readStringRef();
            data.blendMode = input.readInt(true);
            skeletonData.slots.push(data);
        }
        // IK constraints.
        n = input.readInt(true);
        for(let i = 0, nn; i < n; i++){
            let name = input.readString();
            if (!name) throw new Error("IK constraint data name must not be null.");
            let data = new (0, $1a17aaf311b9f6a0$export$adcb08b651fc712e)(name);
            data.order = input.readInt(true);
            data.skinRequired = input.readBoolean();
            nn = input.readInt(true);
            for(let ii = 0; ii < nn; ii++)data.bones.push(skeletonData.bones[input.readInt(true)]);
            data.target = skeletonData.bones[input.readInt(true)];
            data.mix = input.readFloat();
            data.softness = input.readFloat() * scale;
            data.bendDirection = input.readByte();
            data.compress = input.readBoolean();
            data.stretch = input.readBoolean();
            data.uniform = input.readBoolean();
            skeletonData.ikConstraints.push(data);
        }
        // Transform constraints.
        n = input.readInt(true);
        for(let i = 0, nn; i < n; i++){
            let name = input.readString();
            if (!name) throw new Error("Transform constraint data name must not be null.");
            let data = new (0, $2699ed07640898d3$export$823fbc29771afdb5)(name);
            data.order = input.readInt(true);
            data.skinRequired = input.readBoolean();
            nn = input.readInt(true);
            for(let ii = 0; ii < nn; ii++)data.bones.push(skeletonData.bones[input.readInt(true)]);
            data.target = skeletonData.bones[input.readInt(true)];
            data.local = input.readBoolean();
            data.relative = input.readBoolean();
            data.offsetRotation = input.readFloat();
            data.offsetX = input.readFloat() * scale;
            data.offsetY = input.readFloat() * scale;
            data.offsetScaleX = input.readFloat();
            data.offsetScaleY = input.readFloat();
            data.offsetShearY = input.readFloat();
            data.mixRotate = input.readFloat();
            data.mixX = input.readFloat();
            data.mixY = input.readFloat();
            data.mixScaleX = input.readFloat();
            data.mixScaleY = input.readFloat();
            data.mixShearY = input.readFloat();
            skeletonData.transformConstraints.push(data);
        }
        // Path constraints.
        n = input.readInt(true);
        for(let i = 0, nn; i < n; i++){
            let name = input.readString();
            if (!name) throw new Error("Path constraint data name must not be null.");
            let data = new (0, $16a395dfc145fe87$export$d2629ab80d5dd5ba)(name);
            data.order = input.readInt(true);
            data.skinRequired = input.readBoolean();
            nn = input.readInt(true);
            for(let ii = 0; ii < nn; ii++)data.bones.push(skeletonData.bones[input.readInt(true)]);
            data.target = skeletonData.slots[input.readInt(true)];
            data.positionMode = input.readInt(true);
            data.spacingMode = input.readInt(true);
            data.rotateMode = input.readInt(true);
            data.offsetRotation = input.readFloat();
            data.position = input.readFloat();
            if (data.positionMode == (0, $16a395dfc145fe87$export$34d637c671e1e906).Fixed) data.position *= scale;
            data.spacing = input.readFloat();
            if (data.spacingMode == (0, $16a395dfc145fe87$export$34ce760ad2b0be4b).Length || data.spacingMode == (0, $16a395dfc145fe87$export$34ce760ad2b0be4b).Fixed) data.spacing *= scale;
            data.mixRotate = input.readFloat();
            data.mixX = input.readFloat();
            data.mixY = input.readFloat();
            skeletonData.pathConstraints.push(data);
        }
        // Default skin.
        let defaultSkin = this.readSkin(input, skeletonData, true, nonessential);
        if (defaultSkin) {
            skeletonData.defaultSkin = defaultSkin;
            skeletonData.skins.push(defaultSkin);
        }
        // Skins.
        {
            let i = skeletonData.skins.length;
            (0, $1702fa998ec22e58$export$d2ca453b913dcdea).setArraySize(skeletonData.skins, n = i + input.readInt(true));
            for(; i < n; i++){
                let skin = this.readSkin(input, skeletonData, false, nonessential);
                if (!skin) throw new Error("readSkin() should not have returned null.");
                skeletonData.skins[i] = skin;
            }
        }
        // Linked meshes.
        n = this.linkedMeshes.length;
        for(let i = 0; i < n; i++){
            let linkedMesh = this.linkedMeshes[i];
            let skin = !linkedMesh.skin ? skeletonData.defaultSkin : skeletonData.findSkin(linkedMesh.skin);
            if (!skin) throw new Error("Not skin found for linked mesh.");
            if (!linkedMesh.parent) throw new Error("Linked mesh parent must not be null");
            let parent = skin.getAttachment(linkedMesh.slotIndex, linkedMesh.parent);
            if (!parent) throw new Error(`Parent mesh not found: ${linkedMesh.parent}`);
            linkedMesh.mesh.timelineAttachment = linkedMesh.inheritTimeline ? parent : linkedMesh.mesh;
            linkedMesh.mesh.setParentMesh(parent);
            if (linkedMesh.mesh.region != null) linkedMesh.mesh.updateRegion();
        }
        this.linkedMeshes.length = 0;
        // Events.
        n = input.readInt(true);
        for(let i = 0; i < n; i++){
            let eventName = input.readStringRef();
            if (!eventName) throw new Error;
            let data = new (0, $bd4901ace6c255ad$export$a5cf049e34c3d11e)(eventName);
            data.intValue = input.readInt(false);
            data.floatValue = input.readFloat();
            data.stringValue = input.readString();
            data.audioPath = input.readString();
            if (data.audioPath) {
                data.volume = input.readFloat();
                data.balance = input.readFloat();
            }
            skeletonData.events.push(data);
        }
        // Animations.
        n = input.readInt(true);
        for(let i = 0; i < n; i++){
            let animationName = input.readString();
            if (!animationName) throw new Error("Animatio name must not be null.");
            skeletonData.animations.push(this.readAnimation(input, animationName, skeletonData));
        }
        return skeletonData;
    }
    readSkin(input, skeletonData, defaultSkin, nonessential) {
        let skin = null;
        let slotCount = 0;
        if (defaultSkin) {
            slotCount = input.readInt(true);
            if (slotCount == 0) return null;
            skin = new (0, $73641f3ef2c01e99$export$b8e0f93a76772233)("default");
        } else {
            let skinName = input.readStringRef();
            if (!skinName) throw new Error("Skin name must not be null.");
            skin = new (0, $73641f3ef2c01e99$export$b8e0f93a76772233)(skinName);
            skin.bones.length = input.readInt(true);
            for(let i = 0, n = skin.bones.length; i < n; i++)skin.bones[i] = skeletonData.bones[input.readInt(true)];
            for(let i = 0, n = input.readInt(true); i < n; i++)skin.constraints.push(skeletonData.ikConstraints[input.readInt(true)]);
            for(let i = 0, n = input.readInt(true); i < n; i++)skin.constraints.push(skeletonData.transformConstraints[input.readInt(true)]);
            for(let i = 0, n = input.readInt(true); i < n; i++)skin.constraints.push(skeletonData.pathConstraints[input.readInt(true)]);
            slotCount = input.readInt(true);
        }
        for(let i = 0; i < slotCount; i++){
            let slotIndex = input.readInt(true);
            for(let ii = 0, nn = input.readInt(true); ii < nn; ii++){
                let name = input.readStringRef();
                if (!name) throw new Error("Attachment name must not be null");
                let attachment = this.readAttachment(input, skeletonData, skin, slotIndex, name, nonessential);
                if (attachment) skin.setAttachment(slotIndex, name, attachment);
            }
        }
        return skin;
    }
    readAttachment(input, skeletonData, skin, slotIndex, attachmentName, nonessential) {
        let scale = this.scale;
        let name = input.readStringRef();
        if (!name) name = attachmentName;
        switch(input.readByte()){
            case $97fef4e9c50039b0$var$AttachmentType.Region:
                {
                    let path = input.readStringRef();
                    let rotation = input.readFloat();
                    let x = input.readFloat();
                    let y = input.readFloat();
                    let scaleX = input.readFloat();
                    let scaleY = input.readFloat();
                    let width = input.readFloat();
                    let height = input.readFloat();
                    let color = input.readInt32();
                    let sequence = this.readSequence(input);
                    if (!path) path = name;
                    let region = this.attachmentLoader.newRegionAttachment(skin, name, path, sequence);
                    if (!region) return null;
                    region.path = path;
                    region.x = x * scale;
                    region.y = y * scale;
                    region.scaleX = scaleX;
                    region.scaleY = scaleY;
                    region.rotation = rotation;
                    region.width = width * scale;
                    region.height = height * scale;
                    (0, $1702fa998ec22e58$export$892596cec99bc70e).rgba8888ToColor(region.color, color);
                    region.sequence = sequence;
                    if (sequence == null) region.updateRegion();
                    return region;
                }
            case $97fef4e9c50039b0$var$AttachmentType.BoundingBox:
                {
                    let vertexCount = input.readInt(true);
                    let vertices = this.readVertices(input, vertexCount);
                    let color = nonessential ? input.readInt32() : 0;
                    let box = this.attachmentLoader.newBoundingBoxAttachment(skin, name);
                    if (!box) return null;
                    box.worldVerticesLength = vertexCount << 1;
                    box.vertices = vertices.vertices;
                    box.bones = vertices.bones;
                    if (nonessential) (0, $1702fa998ec22e58$export$892596cec99bc70e).rgba8888ToColor(box.color, color);
                    return box;
                }
            case $97fef4e9c50039b0$var$AttachmentType.Mesh:
                {
                    let path = input.readStringRef();
                    let color = input.readInt32();
                    let vertexCount = input.readInt(true);
                    let uvs = this.readFloatArray(input, vertexCount << 1, 1);
                    let triangles = this.readShortArray(input);
                    let vertices = this.readVertices(input, vertexCount);
                    let hullLength = input.readInt(true);
                    let sequence = this.readSequence(input);
                    let edges = [];
                    let width = 0, height = 0;
                    if (nonessential) {
                        edges = this.readShortArray(input);
                        width = input.readFloat();
                        height = input.readFloat();
                    }
                    if (!path) path = name;
                    let mesh = this.attachmentLoader.newMeshAttachment(skin, name, path, sequence);
                    if (!mesh) return null;
                    mesh.path = path;
                    (0, $1702fa998ec22e58$export$892596cec99bc70e).rgba8888ToColor(mesh.color, color);
                    mesh.bones = vertices.bones;
                    mesh.vertices = vertices.vertices;
                    mesh.worldVerticesLength = vertexCount << 1;
                    mesh.triangles = triangles;
                    mesh.regionUVs = uvs;
                    if (sequence == null) mesh.updateRegion();
                    mesh.hullLength = hullLength << 1;
                    mesh.sequence = sequence;
                    if (nonessential) {
                        mesh.edges = edges;
                        mesh.width = width * scale;
                        mesh.height = height * scale;
                    }
                    return mesh;
                }
            case $97fef4e9c50039b0$var$AttachmentType.LinkedMesh:
                {
                    let path = input.readStringRef();
                    let color = input.readInt32();
                    let skinName = input.readStringRef();
                    let parent = input.readStringRef();
                    let inheritTimelines = input.readBoolean();
                    let sequence = this.readSequence(input);
                    let width = 0, height = 0;
                    if (nonessential) {
                        width = input.readFloat();
                        height = input.readFloat();
                    }
                    if (!path) path = name;
                    let mesh = this.attachmentLoader.newMeshAttachment(skin, name, path, sequence);
                    if (!mesh) return null;
                    mesh.path = path;
                    (0, $1702fa998ec22e58$export$892596cec99bc70e).rgba8888ToColor(mesh.color, color);
                    mesh.sequence = sequence;
                    if (nonessential) {
                        mesh.width = width * scale;
                        mesh.height = height * scale;
                    }
                    this.linkedMeshes.push(new $97fef4e9c50039b0$var$LinkedMesh(mesh, skinName, slotIndex, parent, inheritTimelines));
                    return mesh;
                }
            case $97fef4e9c50039b0$var$AttachmentType.Path:
                {
                    let closed = input.readBoolean();
                    let constantSpeed = input.readBoolean();
                    let vertexCount = input.readInt(true);
                    let vertices = this.readVertices(input, vertexCount);
                    let lengths = (0, $1702fa998ec22e58$export$d2ca453b913dcdea).newArray(vertexCount / 3, 0);
                    for(let i = 0, n = lengths.length; i < n; i++)lengths[i] = input.readFloat() * scale;
                    let color = nonessential ? input.readInt32() : 0;
                    let path = this.attachmentLoader.newPathAttachment(skin, name);
                    if (!path) return null;
                    path.closed = closed;
                    path.constantSpeed = constantSpeed;
                    path.worldVerticesLength = vertexCount << 1;
                    path.vertices = vertices.vertices;
                    path.bones = vertices.bones;
                    path.lengths = lengths;
                    if (nonessential) (0, $1702fa998ec22e58$export$892596cec99bc70e).rgba8888ToColor(path.color, color);
                    return path;
                }
            case $97fef4e9c50039b0$var$AttachmentType.Point:
                {
                    let rotation = input.readFloat();
                    let x = input.readFloat();
                    let y = input.readFloat();
                    let color = nonessential ? input.readInt32() : 0;
                    let point = this.attachmentLoader.newPointAttachment(skin, name);
                    if (!point) return null;
                    point.x = x * scale;
                    point.y = y * scale;
                    point.rotation = rotation;
                    if (nonessential) (0, $1702fa998ec22e58$export$892596cec99bc70e).rgba8888ToColor(point.color, color);
                    return point;
                }
            case $97fef4e9c50039b0$var$AttachmentType.Clipping:
                {
                    let endSlotIndex = input.readInt(true);
                    let vertexCount = input.readInt(true);
                    let vertices = this.readVertices(input, vertexCount);
                    let color = nonessential ? input.readInt32() : 0;
                    let clip = this.attachmentLoader.newClippingAttachment(skin, name);
                    if (!clip) return null;
                    clip.endSlot = skeletonData.slots[endSlotIndex];
                    clip.worldVerticesLength = vertexCount << 1;
                    clip.vertices = vertices.vertices;
                    clip.bones = vertices.bones;
                    if (nonessential) (0, $1702fa998ec22e58$export$892596cec99bc70e).rgba8888ToColor(clip.color, color);
                    return clip;
                }
        }
        return null;
    }
    readSequence(input) {
        if (!input.readBoolean()) return null;
        let sequence = new (0, $1bc73da5d49cda90$export$edde1bcb1b2b310e)(input.readInt(true));
        sequence.start = input.readInt(true);
        sequence.digits = input.readInt(true);
        sequence.setupIndex = input.readInt(true);
        return sequence;
    }
    readVertices(input, vertexCount) {
        let scale = this.scale;
        let verticesLength = vertexCount << 1;
        let vertices = new $97fef4e9c50039b0$var$Vertices();
        if (!input.readBoolean()) {
            vertices.vertices = this.readFloatArray(input, verticesLength, scale);
            return vertices;
        }
        let weights = new Array();
        let bonesArray = new Array();
        for(let i = 0; i < vertexCount; i++){
            let boneCount = input.readInt(true);
            bonesArray.push(boneCount);
            for(let ii = 0; ii < boneCount; ii++){
                bonesArray.push(input.readInt(true));
                weights.push(input.readFloat() * scale);
                weights.push(input.readFloat() * scale);
                weights.push(input.readFloat());
            }
        }
        vertices.vertices = (0, $1702fa998ec22e58$export$d2ca453b913dcdea).toFloatArray(weights);
        vertices.bones = bonesArray;
        return vertices;
    }
    readFloatArray(input, n, scale) {
        let array = new Array(n);
        if (scale == 1) for(let i = 0; i < n; i++)array[i] = input.readFloat();
        else for(let i = 0; i < n; i++)array[i] = input.readFloat() * scale;
        return array;
    }
    readShortArray(input) {
        let n = input.readInt(true);
        let array = new Array(n);
        for(let i = 0; i < n; i++)array[i] = input.readShort();
        return array;
    }
    readAnimation(input, name, skeletonData) {
        input.readInt(true); // Number of timelines.
        let timelines = new Array();
        let scale = this.scale;
        let tempColor1 = new (0, $1702fa998ec22e58$export$892596cec99bc70e)();
        let tempColor2 = new (0, $1702fa998ec22e58$export$892596cec99bc70e)();
        // Slot timelines.
        for(let i = 0, n = input.readInt(true); i < n; i++){
            let slotIndex = input.readInt(true);
            for(let ii = 0, nn = input.readInt(true); ii < nn; ii++){
                let timelineType = input.readByte();
                let frameCount = input.readInt(true);
                let frameLast = frameCount - 1;
                switch(timelineType){
                    case $97fef4e9c50039b0$var$SLOT_ATTACHMENT:
                        {
                            let timeline = new (0, $c8bc0977b55afb3a$export$7f2bfc5bd27cb43d)(frameCount, slotIndex);
                            for(let frame = 0; frame < frameCount; frame++)timeline.setFrame(frame, input.readFloat(), input.readStringRef());
                            timelines.push(timeline);
                            break;
                        }
                    case $97fef4e9c50039b0$var$SLOT_RGBA:
                        {
                            let bezierCount = input.readInt(true);
                            let timeline = new (0, $c8bc0977b55afb3a$export$84cf3a3e225bcbdc)(frameCount, bezierCount, slotIndex);
                            let time = input.readFloat();
                            let r = input.readUnsignedByte() / 255.0;
                            let g = input.readUnsignedByte() / 255.0;
                            let b = input.readUnsignedByte() / 255.0;
                            let a = input.readUnsignedByte() / 255.0;
                            for(let frame = 0, bezier = 0;; frame++){
                                timeline.setFrame(frame, time, r, g, b, a);
                                if (frame == frameLast) break;
                                let time2 = input.readFloat();
                                let r2 = input.readUnsignedByte() / 255.0;
                                let g2 = input.readUnsignedByte() / 255.0;
                                let b2 = input.readUnsignedByte() / 255.0;
                                let a2 = input.readUnsignedByte() / 255.0;
                                switch(input.readByte()){
                                    case $97fef4e9c50039b0$var$CURVE_STEPPED:
                                        timeline.setStepped(frame);
                                        break;
                                    case $97fef4e9c50039b0$var$CURVE_BEZIER:
                                        $97fef4e9c50039b0$var$setBezier(input, timeline, bezier++, frame, 0, time, time2, r, r2, 1);
                                        $97fef4e9c50039b0$var$setBezier(input, timeline, bezier++, frame, 1, time, time2, g, g2, 1);
                                        $97fef4e9c50039b0$var$setBezier(input, timeline, bezier++, frame, 2, time, time2, b, b2, 1);
                                        $97fef4e9c50039b0$var$setBezier(input, timeline, bezier++, frame, 3, time, time2, a, a2, 1);
                                }
                                time = time2;
                                r = r2;
                                g = g2;
                                b = b2;
                                a = a2;
                            }
                            timelines.push(timeline);
                            break;
                        }
                    case $97fef4e9c50039b0$var$SLOT_RGB:
                        {
                            let bezierCount = input.readInt(true);
                            let timeline = new (0, $c8bc0977b55afb3a$export$e179fb669ddccfa9)(frameCount, bezierCount, slotIndex);
                            let time = input.readFloat();
                            let r = input.readUnsignedByte() / 255.0;
                            let g = input.readUnsignedByte() / 255.0;
                            let b = input.readUnsignedByte() / 255.0;
                            for(let frame = 0, bezier = 0;; frame++){
                                timeline.setFrame(frame, time, r, g, b);
                                if (frame == frameLast) break;
                                let time2 = input.readFloat();
                                let r2 = input.readUnsignedByte() / 255.0;
                                let g2 = input.readUnsignedByte() / 255.0;
                                let b2 = input.readUnsignedByte() / 255.0;
                                switch(input.readByte()){
                                    case $97fef4e9c50039b0$var$CURVE_STEPPED:
                                        timeline.setStepped(frame);
                                        break;
                                    case $97fef4e9c50039b0$var$CURVE_BEZIER:
                                        $97fef4e9c50039b0$var$setBezier(input, timeline, bezier++, frame, 0, time, time2, r, r2, 1);
                                        $97fef4e9c50039b0$var$setBezier(input, timeline, bezier++, frame, 1, time, time2, g, g2, 1);
                                        $97fef4e9c50039b0$var$setBezier(input, timeline, bezier++, frame, 2, time, time2, b, b2, 1);
                                }
                                time = time2;
                                r = r2;
                                g = g2;
                                b = b2;
                            }
                            timelines.push(timeline);
                            break;
                        }
                    case $97fef4e9c50039b0$var$SLOT_RGBA2:
                        {
                            let bezierCount = input.readInt(true);
                            let timeline = new (0, $c8bc0977b55afb3a$export$6fc6620d97c53689)(frameCount, bezierCount, slotIndex);
                            let time = input.readFloat();
                            let r = input.readUnsignedByte() / 255.0;
                            let g = input.readUnsignedByte() / 255.0;
                            let b = input.readUnsignedByte() / 255.0;
                            let a = input.readUnsignedByte() / 255.0;
                            let r2 = input.readUnsignedByte() / 255.0;
                            let g2 = input.readUnsignedByte() / 255.0;
                            let b2 = input.readUnsignedByte() / 255.0;
                            for(let frame = 0, bezier = 0;; frame++){
                                timeline.setFrame(frame, time, r, g, b, a, r2, g2, b2);
                                if (frame == frameLast) break;
                                let time2 = input.readFloat();
                                let nr = input.readUnsignedByte() / 255.0;
                                let ng = input.readUnsignedByte() / 255.0;
                                let nb = input.readUnsignedByte() / 255.0;
                                let na = input.readUnsignedByte() / 255.0;
                                let nr2 = input.readUnsignedByte() / 255.0;
                                let ng2 = input.readUnsignedByte() / 255.0;
                                let nb2 = input.readUnsignedByte() / 255.0;
                                switch(input.readByte()){
                                    case $97fef4e9c50039b0$var$CURVE_STEPPED:
                                        timeline.setStepped(frame);
                                        break;
                                    case $97fef4e9c50039b0$var$CURVE_BEZIER:
                                        $97fef4e9c50039b0$var$setBezier(input, timeline, bezier++, frame, 0, time, time2, r, nr, 1);
                                        $97fef4e9c50039b0$var$setBezier(input, timeline, bezier++, frame, 1, time, time2, g, ng, 1);
                                        $97fef4e9c50039b0$var$setBezier(input, timeline, bezier++, frame, 2, time, time2, b, nb, 1);
                                        $97fef4e9c50039b0$var$setBezier(input, timeline, bezier++, frame, 3, time, time2, a, na, 1);
                                        $97fef4e9c50039b0$var$setBezier(input, timeline, bezier++, frame, 4, time, time2, r2, nr2, 1);
                                        $97fef4e9c50039b0$var$setBezier(input, timeline, bezier++, frame, 5, time, time2, g2, ng2, 1);
                                        $97fef4e9c50039b0$var$setBezier(input, timeline, bezier++, frame, 6, time, time2, b2, nb2, 1);
                                }
                                time = time2;
                                r = nr;
                                g = ng;
                                b = nb;
                                a = na;
                                r2 = nr2;
                                g2 = ng2;
                                b2 = nb2;
                            }
                            timelines.push(timeline);
                            break;
                        }
                    case $97fef4e9c50039b0$var$SLOT_RGB2:
                        {
                            let bezierCount = input.readInt(true);
                            let timeline = new (0, $c8bc0977b55afb3a$export$a12960afd309a230)(frameCount, bezierCount, slotIndex);
                            let time = input.readFloat();
                            let r = input.readUnsignedByte() / 255.0;
                            let g = input.readUnsignedByte() / 255.0;
                            let b = input.readUnsignedByte() / 255.0;
                            let r2 = input.readUnsignedByte() / 255.0;
                            let g2 = input.readUnsignedByte() / 255.0;
                            let b2 = input.readUnsignedByte() / 255.0;
                            for(let frame = 0, bezier = 0;; frame++){
                                timeline.setFrame(frame, time, r, g, b, r2, g2, b2);
                                if (frame == frameLast) break;
                                let time2 = input.readFloat();
                                let nr = input.readUnsignedByte() / 255.0;
                                let ng = input.readUnsignedByte() / 255.0;
                                let nb = input.readUnsignedByte() / 255.0;
                                let nr2 = input.readUnsignedByte() / 255.0;
                                let ng2 = input.readUnsignedByte() / 255.0;
                                let nb2 = input.readUnsignedByte() / 255.0;
                                switch(input.readByte()){
                                    case $97fef4e9c50039b0$var$CURVE_STEPPED:
                                        timeline.setStepped(frame);
                                        break;
                                    case $97fef4e9c50039b0$var$CURVE_BEZIER:
                                        $97fef4e9c50039b0$var$setBezier(input, timeline, bezier++, frame, 0, time, time2, r, nr, 1);
                                        $97fef4e9c50039b0$var$setBezier(input, timeline, bezier++, frame, 1, time, time2, g, ng, 1);
                                        $97fef4e9c50039b0$var$setBezier(input, timeline, bezier++, frame, 2, time, time2, b, nb, 1);
                                        $97fef4e9c50039b0$var$setBezier(input, timeline, bezier++, frame, 3, time, time2, r2, nr2, 1);
                                        $97fef4e9c50039b0$var$setBezier(input, timeline, bezier++, frame, 4, time, time2, g2, ng2, 1);
                                        $97fef4e9c50039b0$var$setBezier(input, timeline, bezier++, frame, 5, time, time2, b2, nb2, 1);
                                }
                                time = time2;
                                r = nr;
                                g = ng;
                                b = nb;
                                r2 = nr2;
                                g2 = ng2;
                                b2 = nb2;
                            }
                            timelines.push(timeline);
                            break;
                        }
                    case $97fef4e9c50039b0$var$SLOT_ALPHA:
                        {
                            let timeline = new (0, $c8bc0977b55afb3a$export$2211be7c5ccde97b)(frameCount, input.readInt(true), slotIndex);
                            let time = input.readFloat(), a = input.readUnsignedByte() / 255;
                            for(let frame = 0, bezier = 0;; frame++){
                                timeline.setFrame(frame, time, a);
                                if (frame == frameLast) break;
                                let time2 = input.readFloat();
                                let a2 = input.readUnsignedByte() / 255;
                                switch(input.readByte()){
                                    case $97fef4e9c50039b0$var$CURVE_STEPPED:
                                        timeline.setStepped(frame);
                                        break;
                                    case $97fef4e9c50039b0$var$CURVE_BEZIER:
                                        $97fef4e9c50039b0$var$setBezier(input, timeline, bezier++, frame, 0, time, time2, a, a2, 1);
                                }
                                time = time2;
                                a = a2;
                            }
                            timelines.push(timeline);
                        }
                }
            }
        }
        // Bone timelines.
        for(let i = 0, n = input.readInt(true); i < n; i++){
            let boneIndex = input.readInt(true);
            for(let ii = 0, nn = input.readInt(true); ii < nn; ii++){
                let type = input.readByte(), frameCount = input.readInt(true), bezierCount = input.readInt(true);
                switch(type){
                    case $97fef4e9c50039b0$var$BONE_ROTATE:
                        timelines.push($97fef4e9c50039b0$var$readTimeline1(input, new (0, $c8bc0977b55afb3a$export$b7ecb8f68b3e130b)(frameCount, bezierCount, boneIndex), 1));
                        break;
                    case $97fef4e9c50039b0$var$BONE_TRANSLATE:
                        timelines.push($97fef4e9c50039b0$var$readTimeline2(input, new (0, $c8bc0977b55afb3a$export$eb93bf27829ae703)(frameCount, bezierCount, boneIndex), scale));
                        break;
                    case $97fef4e9c50039b0$var$BONE_TRANSLATEX:
                        timelines.push($97fef4e9c50039b0$var$readTimeline1(input, new (0, $c8bc0977b55afb3a$export$cf49491eb4394eca)(frameCount, bezierCount, boneIndex), scale));
                        break;
                    case $97fef4e9c50039b0$var$BONE_TRANSLATEY:
                        timelines.push($97fef4e9c50039b0$var$readTimeline1(input, new (0, $c8bc0977b55afb3a$export$6540b7ba297d3e41)(frameCount, bezierCount, boneIndex), scale));
                        break;
                    case $97fef4e9c50039b0$var$BONE_SCALE:
                        timelines.push($97fef4e9c50039b0$var$readTimeline2(input, new (0, $c8bc0977b55afb3a$export$be544e22f6ad7737)(frameCount, bezierCount, boneIndex), 1));
                        break;
                    case $97fef4e9c50039b0$var$BONE_SCALEX:
                        timelines.push($97fef4e9c50039b0$var$readTimeline1(input, new (0, $c8bc0977b55afb3a$export$407a9cf4df59ebda)(frameCount, bezierCount, boneIndex), 1));
                        break;
                    case $97fef4e9c50039b0$var$BONE_SCALEY:
                        timelines.push($97fef4e9c50039b0$var$readTimeline1(input, new (0, $c8bc0977b55afb3a$export$cc13ceba88ef3794)(frameCount, bezierCount, boneIndex), 1));
                        break;
                    case $97fef4e9c50039b0$var$BONE_SHEAR:
                        timelines.push($97fef4e9c50039b0$var$readTimeline2(input, new (0, $c8bc0977b55afb3a$export$4da82436a1a0d773)(frameCount, bezierCount, boneIndex), 1));
                        break;
                    case $97fef4e9c50039b0$var$BONE_SHEARX:
                        timelines.push($97fef4e9c50039b0$var$readTimeline1(input, new (0, $c8bc0977b55afb3a$export$2392b1c4c21acaf8)(frameCount, bezierCount, boneIndex), 1));
                        break;
                    case $97fef4e9c50039b0$var$BONE_SHEARY:
                        timelines.push($97fef4e9c50039b0$var$readTimeline1(input, new (0, $c8bc0977b55afb3a$export$f65148e1d95352fd)(frameCount, bezierCount, boneIndex), 1));
                }
            }
        }
        // IK constraint timelines.
        for(let i = 0, n = input.readInt(true); i < n; i++){
            let index = input.readInt(true), frameCount = input.readInt(true), frameLast = frameCount - 1;
            let timeline = new (0, $c8bc0977b55afb3a$export$73d125cd89dead44)(frameCount, input.readInt(true), index);
            let time = input.readFloat(), mix = input.readFloat(), softness = input.readFloat() * scale;
            for(let frame = 0, bezier = 0;; frame++){
                timeline.setFrame(frame, time, mix, softness, input.readByte(), input.readBoolean(), input.readBoolean());
                if (frame == frameLast) break;
                let time2 = input.readFloat(), mix2 = input.readFloat(), softness2 = input.readFloat() * scale;
                switch(input.readByte()){
                    case $97fef4e9c50039b0$var$CURVE_STEPPED:
                        timeline.setStepped(frame);
                        break;
                    case $97fef4e9c50039b0$var$CURVE_BEZIER:
                        $97fef4e9c50039b0$var$setBezier(input, timeline, bezier++, frame, 0, time, time2, mix, mix2, 1);
                        $97fef4e9c50039b0$var$setBezier(input, timeline, bezier++, frame, 1, time, time2, softness, softness2, scale);
                }
                time = time2;
                mix = mix2;
                softness = softness2;
            }
            timelines.push(timeline);
        }
        // Transform constraint timelines.
        for(let i = 0, n = input.readInt(true); i < n; i++){
            let index = input.readInt(true), frameCount = input.readInt(true), frameLast = frameCount - 1;
            let timeline = new (0, $c8bc0977b55afb3a$export$a7a393c2ad815ac7)(frameCount, input.readInt(true), index);
            let time = input.readFloat(), mixRotate = input.readFloat(), mixX = input.readFloat(), mixY = input.readFloat(), mixScaleX = input.readFloat(), mixScaleY = input.readFloat(), mixShearY = input.readFloat();
            for(let frame = 0, bezier = 0;; frame++){
                timeline.setFrame(frame, time, mixRotate, mixX, mixY, mixScaleX, mixScaleY, mixShearY);
                if (frame == frameLast) break;
                let time2 = input.readFloat(), mixRotate2 = input.readFloat(), mixX2 = input.readFloat(), mixY2 = input.readFloat(), mixScaleX2 = input.readFloat(), mixScaleY2 = input.readFloat(), mixShearY2 = input.readFloat();
                switch(input.readByte()){
                    case $97fef4e9c50039b0$var$CURVE_STEPPED:
                        timeline.setStepped(frame);
                        break;
                    case $97fef4e9c50039b0$var$CURVE_BEZIER:
                        $97fef4e9c50039b0$var$setBezier(input, timeline, bezier++, frame, 0, time, time2, mixRotate, mixRotate2, 1);
                        $97fef4e9c50039b0$var$setBezier(input, timeline, bezier++, frame, 1, time, time2, mixX, mixX2, 1);
                        $97fef4e9c50039b0$var$setBezier(input, timeline, bezier++, frame, 2, time, time2, mixY, mixY2, 1);
                        $97fef4e9c50039b0$var$setBezier(input, timeline, bezier++, frame, 3, time, time2, mixScaleX, mixScaleX2, 1);
                        $97fef4e9c50039b0$var$setBezier(input, timeline, bezier++, frame, 4, time, time2, mixScaleY, mixScaleY2, 1);
                        $97fef4e9c50039b0$var$setBezier(input, timeline, bezier++, frame, 5, time, time2, mixShearY, mixShearY2, 1);
                }
                time = time2;
                mixRotate = mixRotate2;
                mixX = mixX2;
                mixY = mixY2;
                mixScaleX = mixScaleX2;
                mixScaleY = mixScaleY2;
                mixShearY = mixShearY2;
            }
            timelines.push(timeline);
        }
        // Path constraint timelines.
        for(let i = 0, n = input.readInt(true); i < n; i++){
            let index = input.readInt(true);
            let data = skeletonData.pathConstraints[index];
            for(let ii = 0, nn = input.readInt(true); ii < nn; ii++)switch(input.readByte()){
                case $97fef4e9c50039b0$var$PATH_POSITION:
                    timelines.push($97fef4e9c50039b0$var$readTimeline1(input, new (0, $c8bc0977b55afb3a$export$7ce7e67fd9cc52ed)(input.readInt(true), input.readInt(true), index), data.positionMode == (0, $16a395dfc145fe87$export$34d637c671e1e906).Fixed ? scale : 1));
                    break;
                case $97fef4e9c50039b0$var$PATH_SPACING:
                    timelines.push($97fef4e9c50039b0$var$readTimeline1(input, new (0, $c8bc0977b55afb3a$export$17ee50c08a07e62b)(input.readInt(true), input.readInt(true), index), data.spacingMode == (0, $16a395dfc145fe87$export$34ce760ad2b0be4b).Length || data.spacingMode == (0, $16a395dfc145fe87$export$34ce760ad2b0be4b).Fixed ? scale : 1));
                    break;
                case $97fef4e9c50039b0$var$PATH_MIX:
                    let timeline = new (0, $c8bc0977b55afb3a$export$ea67b41755485038)(input.readInt(true), input.readInt(true), index);
                    let time = input.readFloat(), mixRotate = input.readFloat(), mixX = input.readFloat(), mixY = input.readFloat();
                    for(let frame = 0, bezier = 0, frameLast = timeline.getFrameCount() - 1;; frame++){
                        timeline.setFrame(frame, time, mixRotate, mixX, mixY);
                        if (frame == frameLast) break;
                        let time2 = input.readFloat(), mixRotate2 = input.readFloat(), mixX2 = input.readFloat(), mixY2 = input.readFloat();
                        switch(input.readByte()){
                            case $97fef4e9c50039b0$var$CURVE_STEPPED:
                                timeline.setStepped(frame);
                                break;
                            case $97fef4e9c50039b0$var$CURVE_BEZIER:
                                $97fef4e9c50039b0$var$setBezier(input, timeline, bezier++, frame, 0, time, time2, mixRotate, mixRotate2, 1);
                                $97fef4e9c50039b0$var$setBezier(input, timeline, bezier++, frame, 1, time, time2, mixX, mixX2, 1);
                                $97fef4e9c50039b0$var$setBezier(input, timeline, bezier++, frame, 2, time, time2, mixY, mixY2, 1);
                        }
                        time = time2;
                        mixRotate = mixRotate2;
                        mixX = mixX2;
                        mixY = mixY2;
                    }
                    timelines.push(timeline);
            }
        }
        // Deform timelines.
        for(let i = 0, n = input.readInt(true); i < n; i++){
            let skin = skeletonData.skins[input.readInt(true)];
            for(let ii = 0, nn = input.readInt(true); ii < nn; ii++){
                let slotIndex = input.readInt(true);
                for(let iii = 0, nnn = input.readInt(true); iii < nnn; iii++){
                    let attachmentName = input.readStringRef();
                    if (!attachmentName) throw new Error("attachmentName must not be null.");
                    let attachment = skin.getAttachment(slotIndex, attachmentName);
                    let timelineType = input.readByte();
                    let frameCount = input.readInt(true);
                    let frameLast = frameCount - 1;
                    switch(timelineType){
                        case $97fef4e9c50039b0$var$ATTACHMENT_DEFORM:
                            {
                                let vertexAttachment = attachment;
                                let weighted = vertexAttachment.bones;
                                let vertices = vertexAttachment.vertices;
                                let deformLength = weighted ? vertices.length / 3 * 2 : vertices.length;
                                let bezierCount = input.readInt(true);
                                let timeline = new (0, $c8bc0977b55afb3a$export$6968d40e5689ad6b)(frameCount, bezierCount, slotIndex, vertexAttachment);
                                let time = input.readFloat();
                                for(let frame = 0, bezier = 0;; frame++){
                                    let deform;
                                    let end = input.readInt(true);
                                    if (end == 0) deform = weighted ? (0, $1702fa998ec22e58$export$d2ca453b913dcdea).newFloatArray(deformLength) : vertices;
                                    else {
                                        deform = (0, $1702fa998ec22e58$export$d2ca453b913dcdea).newFloatArray(deformLength);
                                        let start = input.readInt(true);
                                        end += start;
                                        if (scale == 1) for(let v = start; v < end; v++)deform[v] = input.readFloat();
                                        else for(let v = start; v < end; v++)deform[v] = input.readFloat() * scale;
                                        if (!weighted) for(let v = 0, vn = deform.length; v < vn; v++)deform[v] += vertices[v];
                                    }
                                    timeline.setFrame(frame, time, deform);
                                    if (frame == frameLast) break;
                                    let time2 = input.readFloat();
                                    switch(input.readByte()){
                                        case $97fef4e9c50039b0$var$CURVE_STEPPED:
                                            timeline.setStepped(frame);
                                            break;
                                        case $97fef4e9c50039b0$var$CURVE_BEZIER:
                                            $97fef4e9c50039b0$var$setBezier(input, timeline, bezier++, frame, 0, time, time2, 0, 1, 1);
                                    }
                                    time = time2;
                                }
                                timelines.push(timeline);
                                break;
                            }
                        case $97fef4e9c50039b0$var$ATTACHMENT_SEQUENCE:
                            {
                                let timeline = new (0, $c8bc0977b55afb3a$export$2687f324e8496672)(frameCount, slotIndex, attachment);
                                for(let frame = 0; frame < frameCount; frame++){
                                    let time = input.readFloat();
                                    let modeAndIndex = input.readInt32();
                                    timeline.setFrame(frame, time, (0, $1bc73da5d49cda90$export$3d518da8d966a9f5)[modeAndIndex & 0xf], modeAndIndex >> 4, input.readFloat());
                                }
                                timelines.push(timeline);
                                break;
                            }
                    }
                }
            }
        }
        // Draw order timeline.
        let drawOrderCount = input.readInt(true);
        if (drawOrderCount > 0) {
            let timeline = new (0, $c8bc0977b55afb3a$export$ece1f7c41d051e83)(drawOrderCount);
            let slotCount = skeletonData.slots.length;
            for(let i = 0; i < drawOrderCount; i++){
                let time = input.readFloat();
                let offsetCount = input.readInt(true);
                let drawOrder = (0, $1702fa998ec22e58$export$d2ca453b913dcdea).newArray(slotCount, 0);
                for(let ii = slotCount - 1; ii >= 0; ii--)drawOrder[ii] = -1;
                let unchanged = (0, $1702fa998ec22e58$export$d2ca453b913dcdea).newArray(slotCount - offsetCount, 0);
                let originalIndex = 0, unchangedIndex = 0;
                for(let ii = 0; ii < offsetCount; ii++){
                    let slotIndex = input.readInt(true);
                    // Collect unchanged items.
                    while(originalIndex != slotIndex)unchanged[unchangedIndex++] = originalIndex++;
                    // Set changed items.
                    drawOrder[originalIndex + input.readInt(true)] = originalIndex++;
                }
                // Collect remaining unchanged items.
                while(originalIndex < slotCount)unchanged[unchangedIndex++] = originalIndex++;
                // Fill in unchanged items.
                for(let ii = slotCount - 1; ii >= 0; ii--)if (drawOrder[ii] == -1) drawOrder[ii] = unchanged[--unchangedIndex];
                timeline.setFrame(i, time, drawOrder);
            }
            timelines.push(timeline);
        }
        // Event timeline.
        let eventCount = input.readInt(true);
        if (eventCount > 0) {
            let timeline = new (0, $c8bc0977b55afb3a$export$4f4bca996c586084)(eventCount);
            for(let i = 0; i < eventCount; i++){
                let time = input.readFloat();
                let eventData = skeletonData.events[input.readInt(true)];
                let event = new (0, $1b0b163278ab2291$export$d61e24a684f9e51)(time, eventData);
                event.intValue = input.readInt(false);
                event.floatValue = input.readFloat();
                event.stringValue = input.readBoolean() ? input.readString() : eventData.stringValue;
                if (event.data.audioPath) {
                    event.volume = input.readFloat();
                    event.balance = input.readFloat();
                }
                timeline.setFrame(i, event);
            }
            timelines.push(timeline);
        }
        let duration = 0;
        for(let i = 0, n = timelines.length; i < n; i++)duration = Math.max(duration, timelines[i].getDuration());
        return new (0, $c8bc0977b55afb3a$export$c35d437ae5945fcd)(name, timelines, duration);
    }
}
class $97fef4e9c50039b0$export$c8e921ea3330f774 {
    strings;
    index;
    buffer;
    constructor(data, strings = new Array(), index = 0, buffer = new DataView(data.buffer)){
        this.strings = strings;
        this.index = index;
        this.buffer = buffer;
    }
    readByte() {
        return this.buffer.getInt8(this.index++);
    }
    readUnsignedByte() {
        return this.buffer.getUint8(this.index++);
    }
    readShort() {
        let value = this.buffer.getInt16(this.index);
        this.index += 2;
        return value;
    }
    readInt32() {
        let value = this.buffer.getInt32(this.index);
        this.index += 4;
        return value;
    }
    readInt(optimizePositive) {
        let b = this.readByte();
        let result = b & 0x7F;
        if ((b & 0x80) != 0) {
            b = this.readByte();
            result |= (b & 0x7F) << 7;
            if ((b & 0x80) != 0) {
                b = this.readByte();
                result |= (b & 0x7F) << 14;
                if ((b & 0x80) != 0) {
                    b = this.readByte();
                    result |= (b & 0x7F) << 21;
                    if ((b & 0x80) != 0) {
                        b = this.readByte();
                        result |= (b & 0x7F) << 28;
                    }
                }
            }
        }
        return optimizePositive ? result : result >>> 1 ^ -(result & 1);
    }
    readStringRef() {
        let index = this.readInt(true);
        return index == 0 ? null : this.strings[index - 1];
    }
    readString() {
        let byteCount = this.readInt(true);
        switch(byteCount){
            case 0:
                return null;
            case 1:
                return "";
        }
        byteCount--;
        let chars = "";
        let charCount = 0;
        for(let i = 0; i < byteCount;){
            let b = this.readUnsignedByte();
            switch(b >> 4){
                case 12:
                case 13:
                    chars += String.fromCharCode((b & 0x1F) << 6 | this.readByte() & 0x3F);
                    i += 2;
                    break;
                case 14:
                    chars += String.fromCharCode((b & 0x0F) << 12 | (this.readByte() & 0x3F) << 6 | this.readByte() & 0x3F);
                    i += 3;
                    break;
                default:
                    chars += String.fromCharCode(b);
                    i++;
            }
        }
        return chars;
    }
    readFloat() {
        let value = this.buffer.getFloat32(this.index);
        this.index += 4;
        return value;
    }
    readBoolean() {
        return this.readByte() != 0;
    }
}
class $97fef4e9c50039b0$var$LinkedMesh {
    parent;
    skin;
    slotIndex;
    mesh;
    inheritTimeline;
    constructor(mesh, skin, slotIndex, parent, inheritDeform){
        this.mesh = mesh;
        this.skin = skin;
        this.slotIndex = slotIndex;
        this.parent = parent;
        this.inheritTimeline = inheritDeform;
    }
}
class $97fef4e9c50039b0$var$Vertices {
    bones;
    vertices;
    constructor(bones = null, vertices = null){
        this.bones = bones;
        this.vertices = vertices;
    }
}
var $97fef4e9c50039b0$var$AttachmentType;
(function(AttachmentType) {
    AttachmentType[AttachmentType["Region"] = 0] = "Region";
    AttachmentType[AttachmentType["BoundingBox"] = 1] = "BoundingBox";
    AttachmentType[AttachmentType["Mesh"] = 2] = "Mesh";
    AttachmentType[AttachmentType["LinkedMesh"] = 3] = "LinkedMesh";
    AttachmentType[AttachmentType["Path"] = 4] = "Path";
    AttachmentType[AttachmentType["Point"] = 5] = "Point";
    AttachmentType[AttachmentType["Clipping"] = 6] = "Clipping";
})($97fef4e9c50039b0$var$AttachmentType || ($97fef4e9c50039b0$var$AttachmentType = {}));
function $97fef4e9c50039b0$var$readTimeline1(input, timeline, scale) {
    let time = input.readFloat(), value = input.readFloat() * scale;
    for(let frame = 0, bezier = 0, frameLast = timeline.getFrameCount() - 1;; frame++){
        timeline.setFrame(frame, time, value);
        if (frame == frameLast) break;
        let time2 = input.readFloat(), value2 = input.readFloat() * scale;
        switch(input.readByte()){
            case $97fef4e9c50039b0$var$CURVE_STEPPED:
                timeline.setStepped(frame);
                break;
            case $97fef4e9c50039b0$var$CURVE_BEZIER:
                $97fef4e9c50039b0$var$setBezier(input, timeline, bezier++, frame, 0, time, time2, value, value2, scale);
        }
        time = time2;
        value = value2;
    }
    return timeline;
}
function $97fef4e9c50039b0$var$readTimeline2(input, timeline, scale) {
    let time = input.readFloat(), value1 = input.readFloat() * scale, value2 = input.readFloat() * scale;
    for(let frame = 0, bezier = 0, frameLast = timeline.getFrameCount() - 1;; frame++){
        timeline.setFrame(frame, time, value1, value2);
        if (frame == frameLast) break;
        let time2 = input.readFloat(), nvalue1 = input.readFloat() * scale, nvalue2 = input.readFloat() * scale;
        switch(input.readByte()){
            case $97fef4e9c50039b0$var$CURVE_STEPPED:
                timeline.setStepped(frame);
                break;
            case $97fef4e9c50039b0$var$CURVE_BEZIER:
                $97fef4e9c50039b0$var$setBezier(input, timeline, bezier++, frame, 0, time, time2, value1, nvalue1, scale);
                $97fef4e9c50039b0$var$setBezier(input, timeline, bezier++, frame, 1, time, time2, value2, nvalue2, scale);
        }
        time = time2;
        value1 = nvalue1;
        value2 = nvalue2;
    }
    return timeline;
}
function $97fef4e9c50039b0$var$setBezier(input, timeline, bezier, frame, value, time1, time2, value1, value2, scale) {
    timeline.setBezier(bezier, frame, value, time1, value1, input.readFloat(), input.readFloat() * scale, input.readFloat(), input.readFloat() * scale, time2, value2);
}
const $97fef4e9c50039b0$var$BONE_ROTATE = 0;
const $97fef4e9c50039b0$var$BONE_TRANSLATE = 1;
const $97fef4e9c50039b0$var$BONE_TRANSLATEX = 2;
const $97fef4e9c50039b0$var$BONE_TRANSLATEY = 3;
const $97fef4e9c50039b0$var$BONE_SCALE = 4;
const $97fef4e9c50039b0$var$BONE_SCALEX = 5;
const $97fef4e9c50039b0$var$BONE_SCALEY = 6;
const $97fef4e9c50039b0$var$BONE_SHEAR = 7;
const $97fef4e9c50039b0$var$BONE_SHEARX = 8;
const $97fef4e9c50039b0$var$BONE_SHEARY = 9;
const $97fef4e9c50039b0$var$SLOT_ATTACHMENT = 0;
const $97fef4e9c50039b0$var$SLOT_RGBA = 1;
const $97fef4e9c50039b0$var$SLOT_RGB = 2;
const $97fef4e9c50039b0$var$SLOT_RGBA2 = 3;
const $97fef4e9c50039b0$var$SLOT_RGB2 = 4;
const $97fef4e9c50039b0$var$SLOT_ALPHA = 5;
const $97fef4e9c50039b0$var$ATTACHMENT_DEFORM = 0;
const $97fef4e9c50039b0$var$ATTACHMENT_SEQUENCE = 1;
const $97fef4e9c50039b0$var$PATH_POSITION = 0;
const $97fef4e9c50039b0$var$PATH_SPACING = 1;
const $97fef4e9c50039b0$var$PATH_MIX = 2;
const $97fef4e9c50039b0$var$CURVE_LINEAR = 0;
const $97fef4e9c50039b0$var$CURVE_STEPPED = 1;
const $97fef4e9c50039b0$var$CURVE_BEZIER = 2;


/******************************************************************************
 * Spine Runtimes License Agreement
 * Last updated July 28, 2023. Replaces all prior versions.
 *
 * Copyright (c) 2013-2023, Esoteric Software LLC
 *
 * Integration of the Spine Runtimes into software or otherwise creating
 * derivative works of the Spine Runtimes is permitted under the terms and
 * conditions of Section 2 of the Spine Editor License Agreement:
 * http://esotericsoftware.com/spine-editor-license
 *
 * Otherwise, it is permitted to integrate the Spine Runtimes into software or
 * otherwise create derivative works of the Spine Runtimes (collectively,
 * "Products"), provided that each user of the Products must obtain their own
 * Spine Editor license and redistribution of the Products in any form must
 * include this license and copyright notice.
 *
 * THE SPINE RUNTIMES ARE PROVIDED BY ESOTERIC SOFTWARE LLC "AS IS" AND ANY
 * EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
 * WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE
 * DISCLAIMED. IN NO EVENT SHALL ESOTERIC SOFTWARE LLC BE LIABLE FOR ANY
 * DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES
 * (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES,
 * BUSINESS INTERRUPTION, OR LOSS OF USE, DATA, OR PROFITS) HOWEVER CAUSED AND
 * ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT
 * (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THE
 * SPINE RUNTIMES, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
 *****************************************************************************/ 

class $06824dc31dec3458$export$119f1746fc062f5e {
    /** The left edge of the axis aligned bounding box. */ minX = 0;
    /** The bottom edge of the axis aligned bounding box. */ minY = 0;
    /** The right edge of the axis aligned bounding box. */ maxX = 0;
    /** The top edge of the axis aligned bounding box. */ maxY = 0;
    /** The visible bounding boxes. */ boundingBoxes = new Array();
    /** The world vertices for the bounding box polygons. */ polygons = new Array();
    polygonPool = new (0, $1702fa998ec22e58$export$14963ee5c8637e11)(()=>{
        return (0, $1702fa998ec22e58$export$d2ca453b913dcdea).newFloatArray(16);
    });
    /** Clears any previous polygons, finds all visible bounding box attachments, and computes the world vertices for each bounding
     * box's polygon.
     * @param updateAabb If true, the axis aligned bounding box containing all the polygons is computed. If false, the
     *           SkeletonBounds AABB methods will always return true. */ update(skeleton, updateAabb) {
        if (!skeleton) throw new Error("skeleton cannot be null.");
        let boundingBoxes = this.boundingBoxes;
        let polygons = this.polygons;
        let polygonPool = this.polygonPool;
        let slots = skeleton.slots;
        let slotCount = slots.length;
        boundingBoxes.length = 0;
        polygonPool.freeAll(polygons);
        polygons.length = 0;
        for(let i = 0; i < slotCount; i++){
            let slot = slots[i];
            if (!slot.bone.active) continue;
            let attachment = slot.getAttachment();
            if (attachment instanceof (0, $4ed11088ab57e209$export$9538c439c6b85ad2)) {
                let boundingBox = attachment;
                boundingBoxes.push(boundingBox);
                let polygon = polygonPool.obtain();
                if (polygon.length != boundingBox.worldVerticesLength) polygon = (0, $1702fa998ec22e58$export$d2ca453b913dcdea).newFloatArray(boundingBox.worldVerticesLength);
                polygons.push(polygon);
                boundingBox.computeWorldVertices(slot, 0, boundingBox.worldVerticesLength, polygon, 0, 2);
            }
        }
        if (updateAabb) this.aabbCompute();
        else {
            this.minX = Number.POSITIVE_INFINITY;
            this.minY = Number.POSITIVE_INFINITY;
            this.maxX = Number.NEGATIVE_INFINITY;
            this.maxY = Number.NEGATIVE_INFINITY;
        }
    }
    aabbCompute() {
        let minX = Number.POSITIVE_INFINITY, minY = Number.POSITIVE_INFINITY, maxX = Number.NEGATIVE_INFINITY, maxY = Number.NEGATIVE_INFINITY;
        let polygons = this.polygons;
        for(let i = 0, n = polygons.length; i < n; i++){
            let polygon = polygons[i];
            let vertices = polygon;
            for(let ii = 0, nn = polygon.length; ii < nn; ii += 2){
                let x = vertices[ii];
                let y = vertices[ii + 1];
                minX = Math.min(minX, x);
                minY = Math.min(minY, y);
                maxX = Math.max(maxX, x);
                maxY = Math.max(maxY, y);
            }
        }
        this.minX = minX;
        this.minY = minY;
        this.maxX = maxX;
        this.maxY = maxY;
    }
    /** Returns true if the axis aligned bounding box contains the point. */ aabbContainsPoint(x, y) {
        return x >= this.minX && x <= this.maxX && y >= this.minY && y <= this.maxY;
    }
    /** Returns true if the axis aligned bounding box intersects the line segment. */ aabbIntersectsSegment(x1, y1, x2, y2) {
        let minX = this.minX;
        let minY = this.minY;
        let maxX = this.maxX;
        let maxY = this.maxY;
        if (x1 <= minX && x2 <= minX || y1 <= minY && y2 <= minY || x1 >= maxX && x2 >= maxX || y1 >= maxY && y2 >= maxY) return false;
        let m = (y2 - y1) / (x2 - x1);
        let y = m * (minX - x1) + y1;
        if (y > minY && y < maxY) return true;
        y = m * (maxX - x1) + y1;
        if (y > minY && y < maxY) return true;
        let x = (minY - y1) / m + x1;
        if (x > minX && x < maxX) return true;
        x = (maxY - y1) / m + x1;
        if (x > minX && x < maxX) return true;
        return false;
    }
    /** Returns true if the axis aligned bounding box intersects the axis aligned bounding box of the specified bounds. */ aabbIntersectsSkeleton(bounds) {
        return this.minX < bounds.maxX && this.maxX > bounds.minX && this.minY < bounds.maxY && this.maxY > bounds.minY;
    }
    /** Returns the first bounding box attachment that contains the point, or null. When doing many checks, it is usually more
     * efficient to only call this method if {@link #aabbContainsPoint(float, float)} returns true. */ containsPoint(x, y) {
        let polygons = this.polygons;
        for(let i = 0, n = polygons.length; i < n; i++)if (this.containsPointPolygon(polygons[i], x, y)) return this.boundingBoxes[i];
        return null;
    }
    /** Returns true if the polygon contains the point. */ containsPointPolygon(polygon, x, y) {
        let vertices = polygon;
        let nn = polygon.length;
        let prevIndex = nn - 2;
        let inside = false;
        for(let ii = 0; ii < nn; ii += 2){
            let vertexY = vertices[ii + 1];
            let prevY = vertices[prevIndex + 1];
            if (vertexY < y && prevY >= y || prevY < y && vertexY >= y) {
                let vertexX = vertices[ii];
                if (vertexX + (y - vertexY) / (prevY - vertexY) * (vertices[prevIndex] - vertexX) < x) inside = !inside;
            }
            prevIndex = ii;
        }
        return inside;
    }
    /** Returns the first bounding box attachment that contains any part of the line segment, or null. When doing many checks, it
     * is usually more efficient to only call this method if {@link #aabbIntersectsSegment()} returns
     * true. */ intersectsSegment(x1, y1, x2, y2) {
        let polygons = this.polygons;
        for(let i = 0, n = polygons.length; i < n; i++)if (this.intersectsSegmentPolygon(polygons[i], x1, y1, x2, y2)) return this.boundingBoxes[i];
        return null;
    }
    /** Returns true if the polygon contains any part of the line segment. */ intersectsSegmentPolygon(polygon, x1, y1, x2, y2) {
        let vertices = polygon;
        let nn = polygon.length;
        let width12 = x1 - x2, height12 = y1 - y2;
        let det1 = x1 * y2 - y1 * x2;
        let x3 = vertices[nn - 2], y3 = vertices[nn - 1];
        for(let ii = 0; ii < nn; ii += 2){
            let x4 = vertices[ii], y4 = vertices[ii + 1];
            let det2 = x3 * y4 - y3 * x4;
            let width34 = x3 - x4, height34 = y3 - y4;
            let det3 = width12 * height34 - height12 * width34;
            let x = (det1 * width34 - width12 * det2) / det3;
            if ((x >= x3 && x <= x4 || x >= x4 && x <= x3) && (x >= x1 && x <= x2 || x >= x2 && x <= x1)) {
                let y = (det1 * height34 - height12 * det2) / det3;
                if ((y >= y3 && y <= y4 || y >= y4 && y <= y3) && (y >= y1 && y <= y2 || y >= y2 && y <= y1)) return true;
            }
            x3 = x4;
            y3 = y4;
        }
        return false;
    }
    /** Returns the polygon for the specified bounding box, or null. */ getPolygon(boundingBox) {
        if (!boundingBox) throw new Error("boundingBox cannot be null.");
        let index = this.boundingBoxes.indexOf(boundingBox);
        return index == -1 ? null : this.polygons[index];
    }
    /** The width of the axis aligned bounding box. */ getWidth() {
        return this.maxX - this.minX;
    }
    /** The height of the axis aligned bounding box. */ getHeight() {
        return this.maxY - this.minY;
    }
}


/******************************************************************************
 * Spine Runtimes License Agreement
 * Last updated July 28, 2023. Replaces all prior versions.
 *
 * Copyright (c) 2013-2023, Esoteric Software LLC
 *
 * Integration of the Spine Runtimes into software or otherwise creating
 * derivative works of the Spine Runtimes is permitted under the terms and
 * conditions of Section 2 of the Spine Editor License Agreement:
 * http://esotericsoftware.com/spine-editor-license
 *
 * Otherwise, it is permitted to integrate the Spine Runtimes into software or
 * otherwise create derivative works of the Spine Runtimes (collectively,
 * "Products"), provided that each user of the Products must obtain their own
 * Spine Editor license and redistribution of the Products in any form must
 * include this license and copyright notice.
 *
 * THE SPINE RUNTIMES ARE PROVIDED BY ESOTERIC SOFTWARE LLC "AS IS" AND ANY
 * EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
 * WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE
 * DISCLAIMED. IN NO EVENT SHALL ESOTERIC SOFTWARE LLC BE LIABLE FOR ANY
 * DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES
 * (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES,
 * BUSINESS INTERRUPTION, OR LOSS OF USE, DATA, OR PROFITS) HOWEVER CAUSED AND
 * ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT
 * (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THE
 * SPINE RUNTIMES, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
 *****************************************************************************/ /******************************************************************************
 * Spine Runtimes License Agreement
 * Last updated July 28, 2023. Replaces all prior versions.
 *
 * Copyright (c) 2013-2023, Esoteric Software LLC
 *
 * Integration of the Spine Runtimes into software or otherwise creating
 * derivative works of the Spine Runtimes is permitted under the terms and
 * conditions of Section 2 of the Spine Editor License Agreement:
 * http://esotericsoftware.com/spine-editor-license
 *
 * Otherwise, it is permitted to integrate the Spine Runtimes into software or
 * otherwise create derivative works of the Spine Runtimes (collectively,
 * "Products"), provided that each user of the Products must obtain their own
 * Spine Editor license and redistribution of the Products in any form must
 * include this license and copyright notice.
 *
 * THE SPINE RUNTIMES ARE PROVIDED BY ESOTERIC SOFTWARE LLC "AS IS" AND ANY
 * EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
 * WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE
 * DISCLAIMED. IN NO EVENT SHALL ESOTERIC SOFTWARE LLC BE LIABLE FOR ANY
 * DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES
 * (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES,
 * BUSINESS INTERRUPTION, OR LOSS OF USE, DATA, OR PROFITS) HOWEVER CAUSED AND
 * ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT
 * (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THE
 * SPINE RUNTIMES, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
 *****************************************************************************/ 
class $7685f4a504844bde$export$2af2b14d1e1cb475 {
    convexPolygons = new Array();
    convexPolygonsIndices = new Array();
    indicesArray = new Array();
    isConcaveArray = new Array();
    triangles = new Array();
    polygonPool = new (0, $1702fa998ec22e58$export$14963ee5c8637e11)(()=>{
        return new Array();
    });
    polygonIndicesPool = new (0, $1702fa998ec22e58$export$14963ee5c8637e11)(()=>{
        return new Array();
    });
    triangulate(verticesArray) {
        let vertices = verticesArray;
        let vertexCount = verticesArray.length >> 1;
        let indices = this.indicesArray;
        indices.length = 0;
        for(let i = 0; i < vertexCount; i++)indices[i] = i;
        let isConcave = this.isConcaveArray;
        isConcave.length = 0;
        for(let i = 0, n = vertexCount; i < n; ++i)isConcave[i] = $7685f4a504844bde$export$2af2b14d1e1cb475.isConcave(i, vertexCount, vertices, indices);
        let triangles = this.triangles;
        triangles.length = 0;
        while(vertexCount > 3){
            // Find ear tip.
            let previous = vertexCount - 1, i = 0, next = 1;
            while(true){
                outer: if (!isConcave[i]) {
                    let p1 = indices[previous] << 1, p2 = indices[i] << 1, p3 = indices[next] << 1;
                    let p1x = vertices[p1], p1y = vertices[p1 + 1];
                    let p2x = vertices[p2], p2y = vertices[p2 + 1];
                    let p3x = vertices[p3], p3y = vertices[p3 + 1];
                    for(let ii = (next + 1) % vertexCount; ii != previous; ii = (ii + 1) % vertexCount){
                        if (!isConcave[ii]) continue;
                        let v = indices[ii] << 1;
                        let vx = vertices[v], vy = vertices[v + 1];
                        if ($7685f4a504844bde$export$2af2b14d1e1cb475.positiveArea(p3x, p3y, p1x, p1y, vx, vy)) {
                            if ($7685f4a504844bde$export$2af2b14d1e1cb475.positiveArea(p1x, p1y, p2x, p2y, vx, vy)) {
                                if ($7685f4a504844bde$export$2af2b14d1e1cb475.positiveArea(p2x, p2y, p3x, p3y, vx, vy)) break outer;
                            }
                        }
                    }
                    break;
                }
                if (next == 0) {
                    do {
                        if (!isConcave[i]) break;
                        i--;
                    }while (i > 0);
                    break;
                }
                previous = i;
                i = next;
                next = (next + 1) % vertexCount;
            }
            // Cut ear tip.
            triangles.push(indices[(vertexCount + i - 1) % vertexCount]);
            triangles.push(indices[i]);
            triangles.push(indices[(i + 1) % vertexCount]);
            indices.splice(i, 1);
            isConcave.splice(i, 1);
            vertexCount--;
            let previousIndex = (vertexCount + i - 1) % vertexCount;
            let nextIndex = i == vertexCount ? 0 : i;
            isConcave[previousIndex] = $7685f4a504844bde$export$2af2b14d1e1cb475.isConcave(previousIndex, vertexCount, vertices, indices);
            isConcave[nextIndex] = $7685f4a504844bde$export$2af2b14d1e1cb475.isConcave(nextIndex, vertexCount, vertices, indices);
        }
        if (vertexCount == 3) {
            triangles.push(indices[2]);
            triangles.push(indices[0]);
            triangles.push(indices[1]);
        }
        return triangles;
    }
    decompose(verticesArray, triangles) {
        let vertices = verticesArray;
        let convexPolygons = this.convexPolygons;
        this.polygonPool.freeAll(convexPolygons);
        convexPolygons.length = 0;
        let convexPolygonsIndices = this.convexPolygonsIndices;
        this.polygonIndicesPool.freeAll(convexPolygonsIndices);
        convexPolygonsIndices.length = 0;
        let polygonIndices = this.polygonIndicesPool.obtain();
        polygonIndices.length = 0;
        let polygon = this.polygonPool.obtain();
        polygon.length = 0;
        // Merge subsequent triangles if they form a triangle fan.
        let fanBaseIndex = -1, lastWinding = 0;
        for(let i = 0, n = triangles.length; i < n; i += 3){
            let t1 = triangles[i] << 1, t2 = triangles[i + 1] << 1, t3 = triangles[i + 2] << 1;
            let x1 = vertices[t1], y1 = vertices[t1 + 1];
            let x2 = vertices[t2], y2 = vertices[t2 + 1];
            let x3 = vertices[t3], y3 = vertices[t3 + 1];
            // If the base of the last triangle is the same as this triangle, check if they form a convex polygon (triangle fan).
            let merged = false;
            if (fanBaseIndex == t1) {
                let o = polygon.length - 4;
                let winding1 = $7685f4a504844bde$export$2af2b14d1e1cb475.winding(polygon[o], polygon[o + 1], polygon[o + 2], polygon[o + 3], x3, y3);
                let winding2 = $7685f4a504844bde$export$2af2b14d1e1cb475.winding(x3, y3, polygon[0], polygon[1], polygon[2], polygon[3]);
                if (winding1 == lastWinding && winding2 == lastWinding) {
                    polygon.push(x3);
                    polygon.push(y3);
                    polygonIndices.push(t3);
                    merged = true;
                }
            }
            // Otherwise make this triangle the new base.
            if (!merged) {
                if (polygon.length > 0) {
                    convexPolygons.push(polygon);
                    convexPolygonsIndices.push(polygonIndices);
                } else {
                    this.polygonPool.free(polygon);
                    this.polygonIndicesPool.free(polygonIndices);
                }
                polygon = this.polygonPool.obtain();
                polygon.length = 0;
                polygon.push(x1);
                polygon.push(y1);
                polygon.push(x2);
                polygon.push(y2);
                polygon.push(x3);
                polygon.push(y3);
                polygonIndices = this.polygonIndicesPool.obtain();
                polygonIndices.length = 0;
                polygonIndices.push(t1);
                polygonIndices.push(t2);
                polygonIndices.push(t3);
                lastWinding = $7685f4a504844bde$export$2af2b14d1e1cb475.winding(x1, y1, x2, y2, x3, y3);
                fanBaseIndex = t1;
            }
        }
        if (polygon.length > 0) {
            convexPolygons.push(polygon);
            convexPolygonsIndices.push(polygonIndices);
        }
        // Go through the list of polygons and try to merge the remaining triangles with the found triangle fans.
        for(let i = 0, n = convexPolygons.length; i < n; i++){
            polygonIndices = convexPolygonsIndices[i];
            if (polygonIndices.length == 0) continue;
            let firstIndex = polygonIndices[0];
            let lastIndex = polygonIndices[polygonIndices.length - 1];
            polygon = convexPolygons[i];
            let o = polygon.length - 4;
            let prevPrevX = polygon[o], prevPrevY = polygon[o + 1];
            let prevX = polygon[o + 2], prevY = polygon[o + 3];
            let firstX = polygon[0], firstY = polygon[1];
            let secondX = polygon[2], secondY = polygon[3];
            let winding = $7685f4a504844bde$export$2af2b14d1e1cb475.winding(prevPrevX, prevPrevY, prevX, prevY, firstX, firstY);
            for(let ii = 0; ii < n; ii++){
                if (ii == i) continue;
                let otherIndices = convexPolygonsIndices[ii];
                if (otherIndices.length != 3) continue;
                let otherFirstIndex = otherIndices[0];
                let otherSecondIndex = otherIndices[1];
                let otherLastIndex = otherIndices[2];
                let otherPoly = convexPolygons[ii];
                let x3 = otherPoly[otherPoly.length - 2], y3 = otherPoly[otherPoly.length - 1];
                if (otherFirstIndex != firstIndex || otherSecondIndex != lastIndex) continue;
                let winding1 = $7685f4a504844bde$export$2af2b14d1e1cb475.winding(prevPrevX, prevPrevY, prevX, prevY, x3, y3);
                let winding2 = $7685f4a504844bde$export$2af2b14d1e1cb475.winding(x3, y3, firstX, firstY, secondX, secondY);
                if (winding1 == winding && winding2 == winding) {
                    otherPoly.length = 0;
                    otherIndices.length = 0;
                    polygon.push(x3);
                    polygon.push(y3);
                    polygonIndices.push(otherLastIndex);
                    prevPrevX = prevX;
                    prevPrevY = prevY;
                    prevX = x3;
                    prevY = y3;
                    ii = 0;
                }
            }
        }
        // Remove empty polygons that resulted from the merge step above.
        for(let i = convexPolygons.length - 1; i >= 0; i--){
            polygon = convexPolygons[i];
            if (polygon.length == 0) {
                convexPolygons.splice(i, 1);
                this.polygonPool.free(polygon);
                polygonIndices = convexPolygonsIndices[i];
                convexPolygonsIndices.splice(i, 1);
                this.polygonIndicesPool.free(polygonIndices);
            }
        }
        return convexPolygons;
    }
    static isConcave(index, vertexCount, vertices, indices) {
        let previous = indices[(vertexCount + index - 1) % vertexCount] << 1;
        let current = indices[index] << 1;
        let next = indices[(index + 1) % vertexCount] << 1;
        return !this.positiveArea(vertices[previous], vertices[previous + 1], vertices[current], vertices[current + 1], vertices[next], vertices[next + 1]);
    }
    static positiveArea(p1x, p1y, p2x, p2y, p3x, p3y) {
        return p1x * (p3y - p2y) + p2x * (p1y - p3y) + p3x * (p2y - p1y) >= 0;
    }
    static winding(p1x, p1y, p2x, p2y, p3x, p3y) {
        let px = p2x - p1x, py = p2y - p1y;
        return p3x * py - p3y * px + px * p1y - p1x * py >= 0 ? 1 : -1;
    }
}



class $eeeb8de69d7449cf$export$40b4063afbb1b315 {
    triangulator = new (0, $7685f4a504844bde$export$2af2b14d1e1cb475)();
    clippingPolygon = new Array();
    clipOutput = new Array();
    clippedVertices = new Array();
    clippedTriangles = new Array();
    scratch = new Array();
    clipAttachment = null;
    clippingPolygons = null;
    clipStart(slot, clip) {
        if (this.clipAttachment) return 0;
        this.clipAttachment = clip;
        let n = clip.worldVerticesLength;
        let vertices = (0, $1702fa998ec22e58$export$d2ca453b913dcdea).setArraySize(this.clippingPolygon, n);
        clip.computeWorldVertices(slot, 0, n, vertices, 0, 2);
        let clippingPolygon = this.clippingPolygon;
        $eeeb8de69d7449cf$export$40b4063afbb1b315.makeClockwise(clippingPolygon);
        let clippingPolygons = this.clippingPolygons = this.triangulator.decompose(clippingPolygon, this.triangulator.triangulate(clippingPolygon));
        for(let i = 0, n = clippingPolygons.length; i < n; i++){
            let polygon = clippingPolygons[i];
            $eeeb8de69d7449cf$export$40b4063afbb1b315.makeClockwise(polygon);
            polygon.push(polygon[0]);
            polygon.push(polygon[1]);
        }
        return clippingPolygons.length;
    }
    clipEndWithSlot(slot) {
        if (this.clipAttachment && this.clipAttachment.endSlot == slot.data) this.clipEnd();
    }
    clipEnd() {
        if (!this.clipAttachment) return;
        this.clipAttachment = null;
        this.clippingPolygons = null;
        this.clippedVertices.length = 0;
        this.clippedTriangles.length = 0;
        this.clippingPolygon.length = 0;
    }
    isClipping() {
        return this.clipAttachment != null;
    }
    clipTriangles(vertices, verticesLength, triangles, trianglesLength, uvs, light, dark, twoColor) {
        let clipOutput = this.clipOutput, clippedVertices = this.clippedVertices;
        let clippedTriangles = this.clippedTriangles;
        let polygons = this.clippingPolygons;
        let polygonsCount = polygons.length;
        let vertexSize = twoColor ? 12 : 8;
        let index = 0;
        clippedVertices.length = 0;
        clippedTriangles.length = 0;
        outer: for(let i = 0; i < trianglesLength; i += 3){
            let vertexOffset = triangles[i] << 1;
            let x1 = vertices[vertexOffset], y1 = vertices[vertexOffset + 1];
            let u1 = uvs[vertexOffset], v1 = uvs[vertexOffset + 1];
            vertexOffset = triangles[i + 1] << 1;
            let x2 = vertices[vertexOffset], y2 = vertices[vertexOffset + 1];
            let u2 = uvs[vertexOffset], v2 = uvs[vertexOffset + 1];
            vertexOffset = triangles[i + 2] << 1;
            let x3 = vertices[vertexOffset], y3 = vertices[vertexOffset + 1];
            let u3 = uvs[vertexOffset], v3 = uvs[vertexOffset + 1];
            for(let p = 0; p < polygonsCount; p++){
                let s = clippedVertices.length;
                if (this.clip(x1, y1, x2, y2, x3, y3, polygons[p], clipOutput)) {
                    let clipOutputLength = clipOutput.length;
                    if (clipOutputLength == 0) continue;
                    let d0 = y2 - y3, d1 = x3 - x2, d2 = x1 - x3, d4 = y3 - y1;
                    let d = 1 / (d0 * d2 + d1 * (y1 - y3));
                    let clipOutputCount = clipOutputLength >> 1;
                    let clipOutputItems = this.clipOutput;
                    let clippedVerticesItems = (0, $1702fa998ec22e58$export$d2ca453b913dcdea).setArraySize(clippedVertices, s + clipOutputCount * vertexSize);
                    for(let ii = 0; ii < clipOutputLength; ii += 2){
                        let x = clipOutputItems[ii], y = clipOutputItems[ii + 1];
                        clippedVerticesItems[s] = x;
                        clippedVerticesItems[s + 1] = y;
                        clippedVerticesItems[s + 2] = light.r;
                        clippedVerticesItems[s + 3] = light.g;
                        clippedVerticesItems[s + 4] = light.b;
                        clippedVerticesItems[s + 5] = light.a;
                        let c0 = x - x3, c1 = y - y3;
                        let a = (d0 * c0 + d1 * c1) * d;
                        let b = (d4 * c0 + d2 * c1) * d;
                        let c = 1 - a - b;
                        clippedVerticesItems[s + 6] = u1 * a + u2 * b + u3 * c;
                        clippedVerticesItems[s + 7] = v1 * a + v2 * b + v3 * c;
                        if (twoColor) {
                            clippedVerticesItems[s + 8] = dark.r;
                            clippedVerticesItems[s + 9] = dark.g;
                            clippedVerticesItems[s + 10] = dark.b;
                            clippedVerticesItems[s + 11] = dark.a;
                        }
                        s += vertexSize;
                    }
                    s = clippedTriangles.length;
                    let clippedTrianglesItems = (0, $1702fa998ec22e58$export$d2ca453b913dcdea).setArraySize(clippedTriangles, s + 3 * (clipOutputCount - 2));
                    clipOutputCount--;
                    for(let ii = 1; ii < clipOutputCount; ii++){
                        clippedTrianglesItems[s] = index;
                        clippedTrianglesItems[s + 1] = index + ii;
                        clippedTrianglesItems[s + 2] = index + ii + 1;
                        s += 3;
                    }
                    index += clipOutputCount + 1;
                } else {
                    let clippedVerticesItems = (0, $1702fa998ec22e58$export$d2ca453b913dcdea).setArraySize(clippedVertices, s + 3 * vertexSize);
                    clippedVerticesItems[s] = x1;
                    clippedVerticesItems[s + 1] = y1;
                    clippedVerticesItems[s + 2] = light.r;
                    clippedVerticesItems[s + 3] = light.g;
                    clippedVerticesItems[s + 4] = light.b;
                    clippedVerticesItems[s + 5] = light.a;
                    if (!twoColor) {
                        clippedVerticesItems[s + 6] = u1;
                        clippedVerticesItems[s + 7] = v1;
                        clippedVerticesItems[s + 8] = x2;
                        clippedVerticesItems[s + 9] = y2;
                        clippedVerticesItems[s + 10] = light.r;
                        clippedVerticesItems[s + 11] = light.g;
                        clippedVerticesItems[s + 12] = light.b;
                        clippedVerticesItems[s + 13] = light.a;
                        clippedVerticesItems[s + 14] = u2;
                        clippedVerticesItems[s + 15] = v2;
                        clippedVerticesItems[s + 16] = x3;
                        clippedVerticesItems[s + 17] = y3;
                        clippedVerticesItems[s + 18] = light.r;
                        clippedVerticesItems[s + 19] = light.g;
                        clippedVerticesItems[s + 20] = light.b;
                        clippedVerticesItems[s + 21] = light.a;
                        clippedVerticesItems[s + 22] = u3;
                        clippedVerticesItems[s + 23] = v3;
                    } else {
                        clippedVerticesItems[s + 6] = u1;
                        clippedVerticesItems[s + 7] = v1;
                        clippedVerticesItems[s + 8] = dark.r;
                        clippedVerticesItems[s + 9] = dark.g;
                        clippedVerticesItems[s + 10] = dark.b;
                        clippedVerticesItems[s + 11] = dark.a;
                        clippedVerticesItems[s + 12] = x2;
                        clippedVerticesItems[s + 13] = y2;
                        clippedVerticesItems[s + 14] = light.r;
                        clippedVerticesItems[s + 15] = light.g;
                        clippedVerticesItems[s + 16] = light.b;
                        clippedVerticesItems[s + 17] = light.a;
                        clippedVerticesItems[s + 18] = u2;
                        clippedVerticesItems[s + 19] = v2;
                        clippedVerticesItems[s + 20] = dark.r;
                        clippedVerticesItems[s + 21] = dark.g;
                        clippedVerticesItems[s + 22] = dark.b;
                        clippedVerticesItems[s + 23] = dark.a;
                        clippedVerticesItems[s + 24] = x3;
                        clippedVerticesItems[s + 25] = y3;
                        clippedVerticesItems[s + 26] = light.r;
                        clippedVerticesItems[s + 27] = light.g;
                        clippedVerticesItems[s + 28] = light.b;
                        clippedVerticesItems[s + 29] = light.a;
                        clippedVerticesItems[s + 30] = u3;
                        clippedVerticesItems[s + 31] = v3;
                        clippedVerticesItems[s + 32] = dark.r;
                        clippedVerticesItems[s + 33] = dark.g;
                        clippedVerticesItems[s + 34] = dark.b;
                        clippedVerticesItems[s + 35] = dark.a;
                    }
                    s = clippedTriangles.length;
                    let clippedTrianglesItems = (0, $1702fa998ec22e58$export$d2ca453b913dcdea).setArraySize(clippedTriangles, s + 3);
                    clippedTrianglesItems[s] = index;
                    clippedTrianglesItems[s + 1] = index + 1;
                    clippedTrianglesItems[s + 2] = index + 2;
                    index += 3;
                    continue outer;
                }
            }
        }
    }
    /** Clips the input triangle against the convex, clockwise clipping area. If the triangle lies entirely within the clipping
     * area, false is returned. The clipping area must duplicate the first vertex at the end of the vertices list. */ clip(x1, y1, x2, y2, x3, y3, clippingArea, output) {
        let originalOutput = output;
        let clipped = false;
        // Avoid copy at the end.
        let input;
        if (clippingArea.length % 4 >= 2) {
            input = output;
            output = this.scratch;
        } else input = this.scratch;
        input.length = 0;
        input.push(x1);
        input.push(y1);
        input.push(x2);
        input.push(y2);
        input.push(x3);
        input.push(y3);
        input.push(x1);
        input.push(y1);
        output.length = 0;
        let clippingVertices = clippingArea;
        let clippingVerticesLast = clippingArea.length - 4;
        for(let i = 0;; i += 2){
            let edgeX = clippingVertices[i], edgeY = clippingVertices[i + 1];
            let edgeX2 = clippingVertices[i + 2], edgeY2 = clippingVertices[i + 3];
            let deltaX = edgeX - edgeX2, deltaY = edgeY - edgeY2;
            let inputVertices = input;
            let inputVerticesLength = input.length - 2, outputStart = output.length;
            for(let ii = 0; ii < inputVerticesLength; ii += 2){
                let inputX = inputVertices[ii], inputY = inputVertices[ii + 1];
                let inputX2 = inputVertices[ii + 2], inputY2 = inputVertices[ii + 3];
                let side2 = deltaX * (inputY2 - edgeY2) - deltaY * (inputX2 - edgeX2) > 0;
                if (deltaX * (inputY - edgeY2) - deltaY * (inputX - edgeX2) > 0) {
                    if (side2) {
                        output.push(inputX2);
                        output.push(inputY2);
                        continue;
                    }
                    // v1 inside, v2 outside
                    let c0 = inputY2 - inputY, c2 = inputX2 - inputX;
                    let s = c0 * (edgeX2 - edgeX) - c2 * (edgeY2 - edgeY);
                    if (Math.abs(s) > 0.000001) {
                        let ua = (c2 * (edgeY - inputY) - c0 * (edgeX - inputX)) / s;
                        output.push(edgeX + (edgeX2 - edgeX) * ua);
                        output.push(edgeY + (edgeY2 - edgeY) * ua);
                    } else {
                        output.push(edgeX);
                        output.push(edgeY);
                    }
                } else if (side2) {
                    let c0 = inputY2 - inputY, c2 = inputX2 - inputX;
                    let s = c0 * (edgeX2 - edgeX) - c2 * (edgeY2 - edgeY);
                    if (Math.abs(s) > 0.000001) {
                        let ua = (c2 * (edgeY - inputY) - c0 * (edgeX - inputX)) / s;
                        output.push(edgeX + (edgeX2 - edgeX) * ua);
                        output.push(edgeY + (edgeY2 - edgeY) * ua);
                    } else {
                        output.push(edgeX);
                        output.push(edgeY);
                    }
                    output.push(inputX2);
                    output.push(inputY2);
                }
                clipped = true;
            }
            if (outputStart == output.length) {
                originalOutput.length = 0;
                return true;
            }
            output.push(output[0]);
            output.push(output[1]);
            if (i == clippingVerticesLast) break;
            let temp = output;
            output = input;
            output.length = 0;
            input = temp;
        }
        if (originalOutput != output) {
            originalOutput.length = 0;
            for(let i = 0, n = output.length - 2; i < n; i++)originalOutput[i] = output[i];
        } else originalOutput.length = originalOutput.length - 2;
        return clipped;
    }
    static makeClockwise(polygon) {
        let vertices = polygon;
        let verticeslength = polygon.length;
        let area = vertices[verticeslength - 2] * vertices[1] - vertices[0] * vertices[verticeslength - 1], p1x = 0, p1y = 0, p2x = 0, p2y = 0;
        for(let i = 0, n = verticeslength - 3; i < n; i += 2){
            p1x = vertices[i];
            p1y = vertices[i + 1];
            p2x = vertices[i + 2];
            p2y = vertices[i + 3];
            area += p1x * p2y - p2x * p1y;
        }
        if (area < 0) return;
        for(let i = 0, lastX = verticeslength - 2, n = verticeslength >> 1; i < n; i += 2){
            let x = vertices[i], y = vertices[i + 1];
            let other = lastX - i;
            vertices[i] = vertices[other];
            vertices[i + 1] = vertices[other + 1];
            vertices[other] = x;
            vertices[other + 1] = y;
        }
    }
}



/******************************************************************************
 * Spine Runtimes License Agreement
 * Last updated July 28, 2023. Replaces all prior versions.
 *
 * Copyright (c) 2013-2023, Esoteric Software LLC
 *
 * Integration of the Spine Runtimes into software or otherwise creating
 * derivative works of the Spine Runtimes is permitted under the terms and
 * conditions of Section 2 of the Spine Editor License Agreement:
 * http://esotericsoftware.com/spine-editor-license
 *
 * Otherwise, it is permitted to integrate the Spine Runtimes into software or
 * otherwise create derivative works of the Spine Runtimes (collectively,
 * "Products"), provided that each user of the Products must obtain their own
 * Spine Editor license and redistribution of the Products in any form must
 * include this license and copyright notice.
 *
 * THE SPINE RUNTIMES ARE PROVIDED BY ESOTERIC SOFTWARE LLC "AS IS" AND ANY
 * EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
 * WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE
 * DISCLAIMED. IN NO EVENT SHALL ESOTERIC SOFTWARE LLC BE LIABLE FOR ANY
 * DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES
 * (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES,
 * BUSINESS INTERRUPTION, OR LOSS OF USE, DATA, OR PROFITS) HOWEVER CAUSED AND
 * ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT
 * (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THE
 * SPINE RUNTIMES, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
 *****************************************************************************/ 











class $acc7b1056b491f28$export$8913b5e618c6d2f3 {
    attachmentLoader;
    /** Scales bone positions, image sizes, and translations as they are loaded. This allows different size images to be used at
     * runtime than were used in Spine.
     *
     * See [Scaling](http://esotericsoftware.com/spine-loading-skeleton-data#Scaling) in the Spine Runtimes Guide. */ scale = 1;
    linkedMeshes = new Array();
    constructor(attachmentLoader){
        this.attachmentLoader = attachmentLoader;
    }
    readSkeletonData(json) {
        let scale = this.scale;
        let skeletonData = new (0, $9859a8a0f6d556f1$export$e8f362f163550575)();
        let root = typeof json === "string" ? JSON.parse(json) : json;
        // Skeleton
        let skeletonMap = root.skeleton;
        if (skeletonMap) {
            skeletonData.hash = skeletonMap.hash;
            skeletonData.version = skeletonMap.spine;
            skeletonData.x = skeletonMap.x;
            skeletonData.y = skeletonMap.y;
            skeletonData.width = skeletonMap.width;
            skeletonData.height = skeletonMap.height;
            skeletonData.fps = skeletonMap.fps;
            skeletonData.imagesPath = skeletonMap.images;
        }
        // Bones
        if (root.bones) for(let i = 0; i < root.bones.length; i++){
            let boneMap = root.bones[i];
            let parent = null;
            let parentName = $acc7b1056b491f28$var$getValue(boneMap, "parent", null);
            if (parentName) parent = skeletonData.findBone(parentName);
            let data = new (0, $15d066d20c83b36f$export$7d85d96cf093e12f)(skeletonData.bones.length, boneMap.name, parent);
            data.length = $acc7b1056b491f28$var$getValue(boneMap, "length", 0) * scale;
            data.x = $acc7b1056b491f28$var$getValue(boneMap, "x", 0) * scale;
            data.y = $acc7b1056b491f28$var$getValue(boneMap, "y", 0) * scale;
            data.rotation = $acc7b1056b491f28$var$getValue(boneMap, "rotation", 0);
            data.scaleX = $acc7b1056b491f28$var$getValue(boneMap, "scaleX", 1);
            data.scaleY = $acc7b1056b491f28$var$getValue(boneMap, "scaleY", 1);
            data.shearX = $acc7b1056b491f28$var$getValue(boneMap, "shearX", 0);
            data.shearY = $acc7b1056b491f28$var$getValue(boneMap, "shearY", 0);
            data.transformMode = (0, $1702fa998ec22e58$export$d2ca453b913dcdea).enumValue((0, $15d066d20c83b36f$export$4c408f82786a534d), $acc7b1056b491f28$var$getValue(boneMap, "transform", "Normal"));
            data.skinRequired = $acc7b1056b491f28$var$getValue(boneMap, "skin", false);
            let color = $acc7b1056b491f28$var$getValue(boneMap, "color", null);
            if (color) data.color.setFromString(color);
            skeletonData.bones.push(data);
        }
        // Slots.
        if (root.slots) for(let i = 0; i < root.slots.length; i++){
            let slotMap = root.slots[i];
            let boneData = skeletonData.findBone(slotMap.bone);
            if (!boneData) throw new Error(`Couldn't find bone ${slotMap.bone} for slot ${slotMap.name}`);
            let data = new (0, $64f50722bcc00a44$export$a4cce1bf50208679)(skeletonData.slots.length, slotMap.name, boneData);
            let color = $acc7b1056b491f28$var$getValue(slotMap, "color", null);
            if (color) data.color.setFromString(color);
            let dark = $acc7b1056b491f28$var$getValue(slotMap, "dark", null);
            if (dark) data.darkColor = (0, $1702fa998ec22e58$export$892596cec99bc70e).fromString(dark);
            data.attachmentName = $acc7b1056b491f28$var$getValue(slotMap, "attachment", null);
            data.blendMode = (0, $1702fa998ec22e58$export$d2ca453b913dcdea).enumValue((0, $64f50722bcc00a44$export$c9b8fe72ac71821), $acc7b1056b491f28$var$getValue(slotMap, "blend", "normal"));
            skeletonData.slots.push(data);
        }
        // IK constraints
        if (root.ik) for(let i = 0; i < root.ik.length; i++){
            let constraintMap = root.ik[i];
            let data = new (0, $1a17aaf311b9f6a0$export$adcb08b651fc712e)(constraintMap.name);
            data.order = $acc7b1056b491f28$var$getValue(constraintMap, "order", 0);
            data.skinRequired = $acc7b1056b491f28$var$getValue(constraintMap, "skin", false);
            for(let ii = 0; ii < constraintMap.bones.length; ii++){
                let bone = skeletonData.findBone(constraintMap.bones[ii]);
                if (!bone) throw new Error(`Couldn't find bone ${constraintMap.bones[ii]} for IK constraint ${constraintMap.name}.`);
                data.bones.push(bone);
            }
            let target = skeletonData.findBone(constraintMap.target);
            if (!target) throw new Error(`Couldn't find target bone ${constraintMap.target} for IK constraint ${constraintMap.name}.`);
            data.target = target;
            data.mix = $acc7b1056b491f28$var$getValue(constraintMap, "mix", 1);
            data.softness = $acc7b1056b491f28$var$getValue(constraintMap, "softness", 0) * scale;
            data.bendDirection = $acc7b1056b491f28$var$getValue(constraintMap, "bendPositive", true) ? 1 : -1;
            data.compress = $acc7b1056b491f28$var$getValue(constraintMap, "compress", false);
            data.stretch = $acc7b1056b491f28$var$getValue(constraintMap, "stretch", false);
            data.uniform = $acc7b1056b491f28$var$getValue(constraintMap, "uniform", false);
            skeletonData.ikConstraints.push(data);
        }
        // Transform constraints.
        if (root.transform) for(let i = 0; i < root.transform.length; i++){
            let constraintMap = root.transform[i];
            let data = new (0, $2699ed07640898d3$export$823fbc29771afdb5)(constraintMap.name);
            data.order = $acc7b1056b491f28$var$getValue(constraintMap, "order", 0);
            data.skinRequired = $acc7b1056b491f28$var$getValue(constraintMap, "skin", false);
            for(let ii = 0; ii < constraintMap.bones.length; ii++){
                let boneName = constraintMap.bones[ii];
                let bone = skeletonData.findBone(boneName);
                if (!bone) throw new Error(`Couldn't find bone ${boneName} for transform constraint ${constraintMap.name}.`);
                data.bones.push(bone);
            }
            let targetName = constraintMap.target;
            let target = skeletonData.findBone(targetName);
            if (!target) throw new Error(`Couldn't find target bone ${targetName} for transform constraint ${constraintMap.name}.`);
            data.target = target;
            data.local = $acc7b1056b491f28$var$getValue(constraintMap, "local", false);
            data.relative = $acc7b1056b491f28$var$getValue(constraintMap, "relative", false);
            data.offsetRotation = $acc7b1056b491f28$var$getValue(constraintMap, "rotation", 0);
            data.offsetX = $acc7b1056b491f28$var$getValue(constraintMap, "x", 0) * scale;
            data.offsetY = $acc7b1056b491f28$var$getValue(constraintMap, "y", 0) * scale;
            data.offsetScaleX = $acc7b1056b491f28$var$getValue(constraintMap, "scaleX", 0);
            data.offsetScaleY = $acc7b1056b491f28$var$getValue(constraintMap, "scaleY", 0);
            data.offsetShearY = $acc7b1056b491f28$var$getValue(constraintMap, "shearY", 0);
            data.mixRotate = $acc7b1056b491f28$var$getValue(constraintMap, "mixRotate", 1);
            data.mixX = $acc7b1056b491f28$var$getValue(constraintMap, "mixX", 1);
            data.mixY = $acc7b1056b491f28$var$getValue(constraintMap, "mixY", data.mixX);
            data.mixScaleX = $acc7b1056b491f28$var$getValue(constraintMap, "mixScaleX", 1);
            data.mixScaleY = $acc7b1056b491f28$var$getValue(constraintMap, "mixScaleY", data.mixScaleX);
            data.mixShearY = $acc7b1056b491f28$var$getValue(constraintMap, "mixShearY", 1);
            skeletonData.transformConstraints.push(data);
        }
        // Path constraints.
        if (root.path) for(let i = 0; i < root.path.length; i++){
            let constraintMap = root.path[i];
            let data = new (0, $16a395dfc145fe87$export$d2629ab80d5dd5ba)(constraintMap.name);
            data.order = $acc7b1056b491f28$var$getValue(constraintMap, "order", 0);
            data.skinRequired = $acc7b1056b491f28$var$getValue(constraintMap, "skin", false);
            for(let ii = 0; ii < constraintMap.bones.length; ii++){
                let boneName = constraintMap.bones[ii];
                let bone = skeletonData.findBone(boneName);
                if (!bone) throw new Error(`Couldn't find bone ${boneName} for path constraint ${constraintMap.name}.`);
                data.bones.push(bone);
            }
            let targetName = constraintMap.target;
            let target = skeletonData.findSlot(targetName);
            if (!target) throw new Error(`Couldn't find target slot ${targetName} for path constraint ${constraintMap.name}.`);
            data.target = target;
            data.positionMode = (0, $1702fa998ec22e58$export$d2ca453b913dcdea).enumValue((0, $16a395dfc145fe87$export$34d637c671e1e906), $acc7b1056b491f28$var$getValue(constraintMap, "positionMode", "Percent"));
            data.spacingMode = (0, $1702fa998ec22e58$export$d2ca453b913dcdea).enumValue((0, $16a395dfc145fe87$export$34ce760ad2b0be4b), $acc7b1056b491f28$var$getValue(constraintMap, "spacingMode", "Length"));
            data.rotateMode = (0, $1702fa998ec22e58$export$d2ca453b913dcdea).enumValue((0, $16a395dfc145fe87$export$a2a23846581ac82c), $acc7b1056b491f28$var$getValue(constraintMap, "rotateMode", "Tangent"));
            data.offsetRotation = $acc7b1056b491f28$var$getValue(constraintMap, "rotation", 0);
            data.position = $acc7b1056b491f28$var$getValue(constraintMap, "position", 0);
            if (data.positionMode == (0, $16a395dfc145fe87$export$34d637c671e1e906).Fixed) data.position *= scale;
            data.spacing = $acc7b1056b491f28$var$getValue(constraintMap, "spacing", 0);
            if (data.spacingMode == (0, $16a395dfc145fe87$export$34ce760ad2b0be4b).Length || data.spacingMode == (0, $16a395dfc145fe87$export$34ce760ad2b0be4b).Fixed) data.spacing *= scale;
            data.mixRotate = $acc7b1056b491f28$var$getValue(constraintMap, "mixRotate", 1);
            data.mixX = $acc7b1056b491f28$var$getValue(constraintMap, "mixX", 1);
            data.mixY = $acc7b1056b491f28$var$getValue(constraintMap, "mixY", data.mixX);
            skeletonData.pathConstraints.push(data);
        }
        // Skins.
        if (root.skins) for(let i = 0; i < root.skins.length; i++){
            let skinMap = root.skins[i];
            let skin = new (0, $73641f3ef2c01e99$export$b8e0f93a76772233)(skinMap.name);
            if (skinMap.bones) for(let ii = 0; ii < skinMap.bones.length; ii++){
                let boneName = skinMap.bones[ii];
                let bone = skeletonData.findBone(boneName);
                if (!bone) throw new Error(`Couldn't find bone ${boneName} for skin ${skinMap.name}.`);
                skin.bones.push(bone);
            }
            if (skinMap.ik) for(let ii = 0; ii < skinMap.ik.length; ii++){
                let constraintName = skinMap.ik[ii];
                let constraint = skeletonData.findIkConstraint(constraintName);
                if (!constraint) throw new Error(`Couldn't find IK constraint ${constraintName} for skin ${skinMap.name}.`);
                skin.constraints.push(constraint);
            }
            if (skinMap.transform) for(let ii = 0; ii < skinMap.transform.length; ii++){
                let constraintName = skinMap.transform[ii];
                let constraint = skeletonData.findTransformConstraint(constraintName);
                if (!constraint) throw new Error(`Couldn't find transform constraint ${constraintName} for skin ${skinMap.name}.`);
                skin.constraints.push(constraint);
            }
            if (skinMap.path) for(let ii = 0; ii < skinMap.path.length; ii++){
                let constraintName = skinMap.path[ii];
                let constraint = skeletonData.findPathConstraint(constraintName);
                if (!constraint) throw new Error(`Couldn't find path constraint ${constraintName} for skin ${skinMap.name}.`);
                skin.constraints.push(constraint);
            }
            for(let slotName in skinMap.attachments){
                let slot = skeletonData.findSlot(slotName);
                if (!slot) throw new Error(`Couldn't find slot ${slotName} for skin ${skinMap.name}.`);
                let slotMap = skinMap.attachments[slotName];
                for(let entryName in slotMap){
                    let attachment = this.readAttachment(slotMap[entryName], skin, slot.index, entryName, skeletonData);
                    if (attachment) skin.setAttachment(slot.index, entryName, attachment);
                }
            }
            skeletonData.skins.push(skin);
            if (skin.name == "default") skeletonData.defaultSkin = skin;
        }
        // Linked meshes.
        for(let i = 0, n = this.linkedMeshes.length; i < n; i++){
            let linkedMesh = this.linkedMeshes[i];
            let skin = !linkedMesh.skin ? skeletonData.defaultSkin : skeletonData.findSkin(linkedMesh.skin);
            if (!skin) throw new Error(`Skin not found: ${linkedMesh.skin}`);
            let parent = skin.getAttachment(linkedMesh.slotIndex, linkedMesh.parent);
            if (!parent) throw new Error(`Parent mesh not found: ${linkedMesh.parent}`);
            linkedMesh.mesh.timelineAttachment = linkedMesh.inheritTimeline ? parent : linkedMesh.mesh;
            linkedMesh.mesh.setParentMesh(parent);
            if (linkedMesh.mesh.region != null) linkedMesh.mesh.updateRegion();
        }
        this.linkedMeshes.length = 0;
        // Events.
        if (root.events) for(let eventName in root.events){
            let eventMap = root.events[eventName];
            let data = new (0, $bd4901ace6c255ad$export$a5cf049e34c3d11e)(eventName);
            data.intValue = $acc7b1056b491f28$var$getValue(eventMap, "int", 0);
            data.floatValue = $acc7b1056b491f28$var$getValue(eventMap, "float", 0);
            data.stringValue = $acc7b1056b491f28$var$getValue(eventMap, "string", "");
            data.audioPath = $acc7b1056b491f28$var$getValue(eventMap, "audio", null);
            if (data.audioPath) {
                data.volume = $acc7b1056b491f28$var$getValue(eventMap, "volume", 1);
                data.balance = $acc7b1056b491f28$var$getValue(eventMap, "balance", 0);
            }
            skeletonData.events.push(data);
        }
        // Animations.
        if (root.animations) for(let animationName in root.animations){
            let animationMap = root.animations[animationName];
            this.readAnimation(animationMap, animationName, skeletonData);
        }
        return skeletonData;
    }
    readAttachment(map, skin, slotIndex, name, skeletonData) {
        let scale = this.scale;
        name = $acc7b1056b491f28$var$getValue(map, "name", name);
        switch($acc7b1056b491f28$var$getValue(map, "type", "region")){
            case "region":
                {
                    let path = $acc7b1056b491f28$var$getValue(map, "path", name);
                    let sequence = this.readSequence($acc7b1056b491f28$var$getValue(map, "sequence", null));
                    let region = this.attachmentLoader.newRegionAttachment(skin, name, path, sequence);
                    if (!region) return null;
                    region.path = path;
                    region.x = $acc7b1056b491f28$var$getValue(map, "x", 0) * scale;
                    region.y = $acc7b1056b491f28$var$getValue(map, "y", 0) * scale;
                    region.scaleX = $acc7b1056b491f28$var$getValue(map, "scaleX", 1);
                    region.scaleY = $acc7b1056b491f28$var$getValue(map, "scaleY", 1);
                    region.rotation = $acc7b1056b491f28$var$getValue(map, "rotation", 0);
                    region.width = map.width * scale;
                    region.height = map.height * scale;
                    region.sequence = sequence;
                    let color = $acc7b1056b491f28$var$getValue(map, "color", null);
                    if (color) region.color.setFromString(color);
                    if (region.region != null) region.updateRegion();
                    return region;
                }
            case "boundingbox":
                {
                    let box = this.attachmentLoader.newBoundingBoxAttachment(skin, name);
                    if (!box) return null;
                    this.readVertices(map, box, map.vertexCount << 1);
                    let color = $acc7b1056b491f28$var$getValue(map, "color", null);
                    if (color) box.color.setFromString(color);
                    return box;
                }
            case "mesh":
            case "linkedmesh":
                {
                    let path = $acc7b1056b491f28$var$getValue(map, "path", name);
                    let sequence = this.readSequence($acc7b1056b491f28$var$getValue(map, "sequence", null));
                    let mesh = this.attachmentLoader.newMeshAttachment(skin, name, path, sequence);
                    if (!mesh) return null;
                    mesh.path = path;
                    let color = $acc7b1056b491f28$var$getValue(map, "color", null);
                    if (color) mesh.color.setFromString(color);
                    mesh.width = $acc7b1056b491f28$var$getValue(map, "width", 0) * scale;
                    mesh.height = $acc7b1056b491f28$var$getValue(map, "height", 0) * scale;
                    mesh.sequence = sequence;
                    let parent = $acc7b1056b491f28$var$getValue(map, "parent", null);
                    if (parent) {
                        this.linkedMeshes.push(new $acc7b1056b491f28$var$LinkedMesh(mesh, $acc7b1056b491f28$var$getValue(map, "skin", null), slotIndex, parent, $acc7b1056b491f28$var$getValue(map, "timelines", true)));
                        return mesh;
                    }
                    let uvs = map.uvs;
                    this.readVertices(map, mesh, uvs.length);
                    mesh.triangles = map.triangles;
                    mesh.regionUVs = uvs;
                    if (mesh.region != null) mesh.updateRegion();
                    mesh.edges = $acc7b1056b491f28$var$getValue(map, "edges", null);
                    mesh.hullLength = $acc7b1056b491f28$var$getValue(map, "hull", 0) * 2;
                    return mesh;
                }
            case "path":
                {
                    let path = this.attachmentLoader.newPathAttachment(skin, name);
                    if (!path) return null;
                    path.closed = $acc7b1056b491f28$var$getValue(map, "closed", false);
                    path.constantSpeed = $acc7b1056b491f28$var$getValue(map, "constantSpeed", true);
                    let vertexCount = map.vertexCount;
                    this.readVertices(map, path, vertexCount << 1);
                    let lengths = (0, $1702fa998ec22e58$export$d2ca453b913dcdea).newArray(vertexCount / 3, 0);
                    for(let i = 0; i < map.lengths.length; i++)lengths[i] = map.lengths[i] * scale;
                    path.lengths = lengths;
                    let color = $acc7b1056b491f28$var$getValue(map, "color", null);
                    if (color) path.color.setFromString(color);
                    return path;
                }
            case "point":
                {
                    let point = this.attachmentLoader.newPointAttachment(skin, name);
                    if (!point) return null;
                    point.x = $acc7b1056b491f28$var$getValue(map, "x", 0) * scale;
                    point.y = $acc7b1056b491f28$var$getValue(map, "y", 0) * scale;
                    point.rotation = $acc7b1056b491f28$var$getValue(map, "rotation", 0);
                    let color = $acc7b1056b491f28$var$getValue(map, "color", null);
                    if (color) point.color.setFromString(color);
                    return point;
                }
            case "clipping":
                {
                    let clip = this.attachmentLoader.newClippingAttachment(skin, name);
                    if (!clip) return null;
                    let end = $acc7b1056b491f28$var$getValue(map, "end", null);
                    if (end) clip.endSlot = skeletonData.findSlot(end);
                    let vertexCount = map.vertexCount;
                    this.readVertices(map, clip, vertexCount << 1);
                    let color = $acc7b1056b491f28$var$getValue(map, "color", null);
                    if (color) clip.color.setFromString(color);
                    return clip;
                }
        }
        return null;
    }
    readSequence(map) {
        if (map == null) return null;
        let sequence = new (0, $1bc73da5d49cda90$export$edde1bcb1b2b310e)($acc7b1056b491f28$var$getValue(map, "count", 0));
        sequence.start = $acc7b1056b491f28$var$getValue(map, "start", 1);
        sequence.digits = $acc7b1056b491f28$var$getValue(map, "digits", 0);
        sequence.setupIndex = $acc7b1056b491f28$var$getValue(map, "setup", 0);
        return sequence;
    }
    readVertices(map, attachment, verticesLength) {
        let scale = this.scale;
        attachment.worldVerticesLength = verticesLength;
        let vertices = map.vertices;
        if (verticesLength == vertices.length) {
            let scaledVertices = (0, $1702fa998ec22e58$export$d2ca453b913dcdea).toFloatArray(vertices);
            if (scale != 1) for(let i = 0, n = vertices.length; i < n; i++)scaledVertices[i] *= scale;
            attachment.vertices = scaledVertices;
            return;
        }
        let weights = new Array();
        let bones = new Array();
        for(let i = 0, n = vertices.length; i < n;){
            let boneCount = vertices[i++];
            bones.push(boneCount);
            for(let nn = i + boneCount * 4; i < nn; i += 4){
                bones.push(vertices[i]);
                weights.push(vertices[i + 1] * scale);
                weights.push(vertices[i + 2] * scale);
                weights.push(vertices[i + 3]);
            }
        }
        attachment.bones = bones;
        attachment.vertices = (0, $1702fa998ec22e58$export$d2ca453b913dcdea).toFloatArray(weights);
    }
    readAnimation(map, name, skeletonData) {
        let scale = this.scale;
        let timelines = new Array();
        // Slot timelines.
        if (map.slots) for(let slotName in map.slots){
            let slotMap = map.slots[slotName];
            let slot = skeletonData.findSlot(slotName);
            if (!slot) throw new Error("Slot not found: " + slotName);
            let slotIndex = slot.index;
            for(let timelineName in slotMap){
                let timelineMap = slotMap[timelineName];
                if (!timelineMap) continue;
                let frames = timelineMap.length;
                if (timelineName == "attachment") {
                    let timeline = new (0, $c8bc0977b55afb3a$export$7f2bfc5bd27cb43d)(frames, slotIndex);
                    for(let frame = 0; frame < frames; frame++){
                        let keyMap = timelineMap[frame];
                        timeline.setFrame(frame, $acc7b1056b491f28$var$getValue(keyMap, "time", 0), $acc7b1056b491f28$var$getValue(keyMap, "name", null));
                    }
                    timelines.push(timeline);
                } else if (timelineName == "rgba") {
                    let timeline = new (0, $c8bc0977b55afb3a$export$84cf3a3e225bcbdc)(frames, frames << 2, slotIndex);
                    let keyMap = timelineMap[0];
                    let time = $acc7b1056b491f28$var$getValue(keyMap, "time", 0);
                    let color = (0, $1702fa998ec22e58$export$892596cec99bc70e).fromString(keyMap.color);
                    for(let frame = 0, bezier = 0;; frame++){
                        timeline.setFrame(frame, time, color.r, color.g, color.b, color.a);
                        let nextMap = timelineMap[frame + 1];
                        if (!nextMap) {
                            timeline.shrink(bezier);
                            break;
                        }
                        let time2 = $acc7b1056b491f28$var$getValue(nextMap, "time", 0);
                        let newColor = (0, $1702fa998ec22e58$export$892596cec99bc70e).fromString(nextMap.color);
                        let curve = keyMap.curve;
                        if (curve) {
                            bezier = $acc7b1056b491f28$var$readCurve(curve, timeline, bezier, frame, 0, time, time2, color.r, newColor.r, 1);
                            bezier = $acc7b1056b491f28$var$readCurve(curve, timeline, bezier, frame, 1, time, time2, color.g, newColor.g, 1);
                            bezier = $acc7b1056b491f28$var$readCurve(curve, timeline, bezier, frame, 2, time, time2, color.b, newColor.b, 1);
                            bezier = $acc7b1056b491f28$var$readCurve(curve, timeline, bezier, frame, 3, time, time2, color.a, newColor.a, 1);
                        }
                        time = time2;
                        color = newColor;
                        keyMap = nextMap;
                    }
                    timelines.push(timeline);
                } else if (timelineName == "rgb") {
                    let timeline = new (0, $c8bc0977b55afb3a$export$e179fb669ddccfa9)(frames, frames * 3, slotIndex);
                    let keyMap = timelineMap[0];
                    let time = $acc7b1056b491f28$var$getValue(keyMap, "time", 0);
                    let color = (0, $1702fa998ec22e58$export$892596cec99bc70e).fromString(keyMap.color);
                    for(let frame = 0, bezier = 0;; frame++){
                        timeline.setFrame(frame, time, color.r, color.g, color.b);
                        let nextMap = timelineMap[frame + 1];
                        if (!nextMap) {
                            timeline.shrink(bezier);
                            break;
                        }
                        let time2 = $acc7b1056b491f28$var$getValue(nextMap, "time", 0);
                        let newColor = (0, $1702fa998ec22e58$export$892596cec99bc70e).fromString(nextMap.color);
                        let curve = keyMap.curve;
                        if (curve) {
                            bezier = $acc7b1056b491f28$var$readCurve(curve, timeline, bezier, frame, 0, time, time2, color.r, newColor.r, 1);
                            bezier = $acc7b1056b491f28$var$readCurve(curve, timeline, bezier, frame, 1, time, time2, color.g, newColor.g, 1);
                            bezier = $acc7b1056b491f28$var$readCurve(curve, timeline, bezier, frame, 2, time, time2, color.b, newColor.b, 1);
                        }
                        time = time2;
                        color = newColor;
                        keyMap = nextMap;
                    }
                    timelines.push(timeline);
                } else if (timelineName == "alpha") timelines.push($acc7b1056b491f28$var$readTimeline1(timelineMap, new (0, $c8bc0977b55afb3a$export$2211be7c5ccde97b)(frames, frames, slotIndex), 0, 1));
                else if (timelineName == "rgba2") {
                    let timeline = new (0, $c8bc0977b55afb3a$export$6fc6620d97c53689)(frames, frames * 7, slotIndex);
                    let keyMap = timelineMap[0];
                    let time = $acc7b1056b491f28$var$getValue(keyMap, "time", 0);
                    let color = (0, $1702fa998ec22e58$export$892596cec99bc70e).fromString(keyMap.light);
                    let color2 = (0, $1702fa998ec22e58$export$892596cec99bc70e).fromString(keyMap.dark);
                    for(let frame = 0, bezier = 0;; frame++){
                        timeline.setFrame(frame, time, color.r, color.g, color.b, color.a, color2.r, color2.g, color2.b);
                        let nextMap = timelineMap[frame + 1];
                        if (!nextMap) {
                            timeline.shrink(bezier);
                            break;
                        }
                        let time2 = $acc7b1056b491f28$var$getValue(nextMap, "time", 0);
                        let newColor = (0, $1702fa998ec22e58$export$892596cec99bc70e).fromString(nextMap.light);
                        let newColor2 = (0, $1702fa998ec22e58$export$892596cec99bc70e).fromString(nextMap.dark);
                        let curve = keyMap.curve;
                        if (curve) {
                            bezier = $acc7b1056b491f28$var$readCurve(curve, timeline, bezier, frame, 0, time, time2, color.r, newColor.r, 1);
                            bezier = $acc7b1056b491f28$var$readCurve(curve, timeline, bezier, frame, 1, time, time2, color.g, newColor.g, 1);
                            bezier = $acc7b1056b491f28$var$readCurve(curve, timeline, bezier, frame, 2, time, time2, color.b, newColor.b, 1);
                            bezier = $acc7b1056b491f28$var$readCurve(curve, timeline, bezier, frame, 3, time, time2, color.a, newColor.a, 1);
                            bezier = $acc7b1056b491f28$var$readCurve(curve, timeline, bezier, frame, 4, time, time2, color2.r, newColor2.r, 1);
                            bezier = $acc7b1056b491f28$var$readCurve(curve, timeline, bezier, frame, 5, time, time2, color2.g, newColor2.g, 1);
                            bezier = $acc7b1056b491f28$var$readCurve(curve, timeline, bezier, frame, 6, time, time2, color2.b, newColor2.b, 1);
                        }
                        time = time2;
                        color = newColor;
                        color2 = newColor2;
                        keyMap = nextMap;
                    }
                    timelines.push(timeline);
                } else if (timelineName == "rgb2") {
                    let timeline = new (0, $c8bc0977b55afb3a$export$a12960afd309a230)(frames, frames * 6, slotIndex);
                    let keyMap = timelineMap[0];
                    let time = $acc7b1056b491f28$var$getValue(keyMap, "time", 0);
                    let color = (0, $1702fa998ec22e58$export$892596cec99bc70e).fromString(keyMap.light);
                    let color2 = (0, $1702fa998ec22e58$export$892596cec99bc70e).fromString(keyMap.dark);
                    for(let frame = 0, bezier = 0;; frame++){
                        timeline.setFrame(frame, time, color.r, color.g, color.b, color2.r, color2.g, color2.b);
                        let nextMap = timelineMap[frame + 1];
                        if (!nextMap) {
                            timeline.shrink(bezier);
                            break;
                        }
                        let time2 = $acc7b1056b491f28$var$getValue(nextMap, "time", 0);
                        let newColor = (0, $1702fa998ec22e58$export$892596cec99bc70e).fromString(nextMap.light);
                        let newColor2 = (0, $1702fa998ec22e58$export$892596cec99bc70e).fromString(nextMap.dark);
                        let curve = keyMap.curve;
                        if (curve) {
                            bezier = $acc7b1056b491f28$var$readCurve(curve, timeline, bezier, frame, 0, time, time2, color.r, newColor.r, 1);
                            bezier = $acc7b1056b491f28$var$readCurve(curve, timeline, bezier, frame, 1, time, time2, color.g, newColor.g, 1);
                            bezier = $acc7b1056b491f28$var$readCurve(curve, timeline, bezier, frame, 2, time, time2, color.b, newColor.b, 1);
                            bezier = $acc7b1056b491f28$var$readCurve(curve, timeline, bezier, frame, 3, time, time2, color2.r, newColor2.r, 1);
                            bezier = $acc7b1056b491f28$var$readCurve(curve, timeline, bezier, frame, 4, time, time2, color2.g, newColor2.g, 1);
                            bezier = $acc7b1056b491f28$var$readCurve(curve, timeline, bezier, frame, 5, time, time2, color2.b, newColor2.b, 1);
                        }
                        time = time2;
                        color = newColor;
                        color2 = newColor2;
                        keyMap = nextMap;
                    }
                    timelines.push(timeline);
                }
            }
        }
        // Bone timelines.
        if (map.bones) for(let boneName in map.bones){
            let boneMap = map.bones[boneName];
            let bone = skeletonData.findBone(boneName);
            if (!bone) throw new Error("Bone not found: " + boneName);
            let boneIndex = bone.index;
            for(let timelineName in boneMap){
                let timelineMap = boneMap[timelineName];
                let frames = timelineMap.length;
                if (frames == 0) continue;
                if (timelineName === "rotate") timelines.push($acc7b1056b491f28$var$readTimeline1(timelineMap, new (0, $c8bc0977b55afb3a$export$b7ecb8f68b3e130b)(frames, frames, boneIndex), 0, 1));
                else if (timelineName === "translate") {
                    let timeline = new (0, $c8bc0977b55afb3a$export$eb93bf27829ae703)(frames, frames << 1, boneIndex);
                    timelines.push($acc7b1056b491f28$var$readTimeline2(timelineMap, timeline, "x", "y", 0, scale));
                } else if (timelineName === "translatex") {
                    let timeline = new (0, $c8bc0977b55afb3a$export$cf49491eb4394eca)(frames, frames, boneIndex);
                    timelines.push($acc7b1056b491f28$var$readTimeline1(timelineMap, timeline, 0, scale));
                } else if (timelineName === "translatey") {
                    let timeline = new (0, $c8bc0977b55afb3a$export$6540b7ba297d3e41)(frames, frames, boneIndex);
                    timelines.push($acc7b1056b491f28$var$readTimeline1(timelineMap, timeline, 0, scale));
                } else if (timelineName === "scale") {
                    let timeline = new (0, $c8bc0977b55afb3a$export$be544e22f6ad7737)(frames, frames << 1, boneIndex);
                    timelines.push($acc7b1056b491f28$var$readTimeline2(timelineMap, timeline, "x", "y", 1, 1));
                } else if (timelineName === "scalex") {
                    let timeline = new (0, $c8bc0977b55afb3a$export$407a9cf4df59ebda)(frames, frames, boneIndex);
                    timelines.push($acc7b1056b491f28$var$readTimeline1(timelineMap, timeline, 1, 1));
                } else if (timelineName === "scaley") {
                    let timeline = new (0, $c8bc0977b55afb3a$export$cc13ceba88ef3794)(frames, frames, boneIndex);
                    timelines.push($acc7b1056b491f28$var$readTimeline1(timelineMap, timeline, 1, 1));
                } else if (timelineName === "shear") {
                    let timeline = new (0, $c8bc0977b55afb3a$export$4da82436a1a0d773)(frames, frames << 1, boneIndex);
                    timelines.push($acc7b1056b491f28$var$readTimeline2(timelineMap, timeline, "x", "y", 0, 1));
                } else if (timelineName === "shearx") {
                    let timeline = new (0, $c8bc0977b55afb3a$export$2392b1c4c21acaf8)(frames, frames, boneIndex);
                    timelines.push($acc7b1056b491f28$var$readTimeline1(timelineMap, timeline, 0, 1));
                } else if (timelineName === "sheary") {
                    let timeline = new (0, $c8bc0977b55afb3a$export$f65148e1d95352fd)(frames, frames, boneIndex);
                    timelines.push($acc7b1056b491f28$var$readTimeline1(timelineMap, timeline, 0, 1));
                }
            }
        }
        // IK constraint timelines.
        if (map.ik) for(let constraintName in map.ik){
            let constraintMap = map.ik[constraintName];
            let keyMap = constraintMap[0];
            if (!keyMap) continue;
            let constraint = skeletonData.findIkConstraint(constraintName);
            if (!constraint) throw new Error("IK Constraint not found: " + constraintName);
            let constraintIndex = skeletonData.ikConstraints.indexOf(constraint);
            let timeline = new (0, $c8bc0977b55afb3a$export$73d125cd89dead44)(constraintMap.length, constraintMap.length << 1, constraintIndex);
            let time = $acc7b1056b491f28$var$getValue(keyMap, "time", 0);
            let mix = $acc7b1056b491f28$var$getValue(keyMap, "mix", 1);
            let softness = $acc7b1056b491f28$var$getValue(keyMap, "softness", 0) * scale;
            for(let frame = 0, bezier = 0;; frame++){
                timeline.setFrame(frame, time, mix, softness, $acc7b1056b491f28$var$getValue(keyMap, "bendPositive", true) ? 1 : -1, $acc7b1056b491f28$var$getValue(keyMap, "compress", false), $acc7b1056b491f28$var$getValue(keyMap, "stretch", false));
                let nextMap = constraintMap[frame + 1];
                if (!nextMap) {
                    timeline.shrink(bezier);
                    break;
                }
                let time2 = $acc7b1056b491f28$var$getValue(nextMap, "time", 0);
                let mix2 = $acc7b1056b491f28$var$getValue(nextMap, "mix", 1);
                let softness2 = $acc7b1056b491f28$var$getValue(nextMap, "softness", 0) * scale;
                let curve = keyMap.curve;
                if (curve) {
                    bezier = $acc7b1056b491f28$var$readCurve(curve, timeline, bezier, frame, 0, time, time2, mix, mix2, 1);
                    bezier = $acc7b1056b491f28$var$readCurve(curve, timeline, bezier, frame, 1, time, time2, softness, softness2, scale);
                }
                time = time2;
                mix = mix2;
                softness = softness2;
                keyMap = nextMap;
            }
            timelines.push(timeline);
        }
        // Transform constraint timelines.
        if (map.transform) for(let constraintName in map.transform){
            let timelineMap = map.transform[constraintName];
            let keyMap = timelineMap[0];
            if (!keyMap) continue;
            let constraint = skeletonData.findTransformConstraint(constraintName);
            if (!constraint) throw new Error("Transform constraint not found: " + constraintName);
            let constraintIndex = skeletonData.transformConstraints.indexOf(constraint);
            let timeline = new (0, $c8bc0977b55afb3a$export$a7a393c2ad815ac7)(timelineMap.length, timelineMap.length * 6, constraintIndex);
            let time = $acc7b1056b491f28$var$getValue(keyMap, "time", 0);
            let mixRotate = $acc7b1056b491f28$var$getValue(keyMap, "mixRotate", 1);
            let mixX = $acc7b1056b491f28$var$getValue(keyMap, "mixX", 1);
            let mixY = $acc7b1056b491f28$var$getValue(keyMap, "mixY", mixX);
            let mixScaleX = $acc7b1056b491f28$var$getValue(keyMap, "mixScaleX", 1);
            let mixScaleY = $acc7b1056b491f28$var$getValue(keyMap, "mixScaleY", mixScaleX);
            let mixShearY = $acc7b1056b491f28$var$getValue(keyMap, "mixShearY", 1);
            for(let frame = 0, bezier = 0;; frame++){
                timeline.setFrame(frame, time, mixRotate, mixX, mixY, mixScaleX, mixScaleY, mixShearY);
                let nextMap = timelineMap[frame + 1];
                if (!nextMap) {
                    timeline.shrink(bezier);
                    break;
                }
                let time2 = $acc7b1056b491f28$var$getValue(nextMap, "time", 0);
                let mixRotate2 = $acc7b1056b491f28$var$getValue(nextMap, "mixRotate", 1);
                let mixX2 = $acc7b1056b491f28$var$getValue(nextMap, "mixX", 1);
                let mixY2 = $acc7b1056b491f28$var$getValue(nextMap, "mixY", mixX2);
                let mixScaleX2 = $acc7b1056b491f28$var$getValue(nextMap, "mixScaleX", 1);
                let mixScaleY2 = $acc7b1056b491f28$var$getValue(nextMap, "mixScaleY", mixScaleX2);
                let mixShearY2 = $acc7b1056b491f28$var$getValue(nextMap, "mixShearY", 1);
                let curve = keyMap.curve;
                if (curve) {
                    bezier = $acc7b1056b491f28$var$readCurve(curve, timeline, bezier, frame, 0, time, time2, mixRotate, mixRotate2, 1);
                    bezier = $acc7b1056b491f28$var$readCurve(curve, timeline, bezier, frame, 1, time, time2, mixX, mixX2, 1);
                    bezier = $acc7b1056b491f28$var$readCurve(curve, timeline, bezier, frame, 2, time, time2, mixY, mixY2, 1);
                    bezier = $acc7b1056b491f28$var$readCurve(curve, timeline, bezier, frame, 3, time, time2, mixScaleX, mixScaleX2, 1);
                    bezier = $acc7b1056b491f28$var$readCurve(curve, timeline, bezier, frame, 4, time, time2, mixScaleY, mixScaleY2, 1);
                    bezier = $acc7b1056b491f28$var$readCurve(curve, timeline, bezier, frame, 5, time, time2, mixShearY, mixShearY2, 1);
                }
                time = time2;
                mixRotate = mixRotate2;
                mixX = mixX2;
                mixY = mixY2;
                mixScaleX = mixScaleX2;
                mixScaleY = mixScaleY2;
                mixScaleX = mixScaleX2;
                keyMap = nextMap;
            }
            timelines.push(timeline);
        }
        // Path constraint timelines.
        if (map.path) for(let constraintName in map.path){
            let constraintMap = map.path[constraintName];
            let constraint = skeletonData.findPathConstraint(constraintName);
            if (!constraint) throw new Error("Path constraint not found: " + constraintName);
            let constraintIndex = skeletonData.pathConstraints.indexOf(constraint);
            for(let timelineName in constraintMap){
                let timelineMap = constraintMap[timelineName];
                let keyMap = timelineMap[0];
                if (!keyMap) continue;
                let frames = timelineMap.length;
                if (timelineName === "position") {
                    let timeline = new (0, $c8bc0977b55afb3a$export$7ce7e67fd9cc52ed)(frames, frames, constraintIndex);
                    timelines.push($acc7b1056b491f28$var$readTimeline1(timelineMap, timeline, 0, constraint.positionMode == (0, $16a395dfc145fe87$export$34d637c671e1e906).Fixed ? scale : 1));
                } else if (timelineName === "spacing") {
                    let timeline = new (0, $c8bc0977b55afb3a$export$17ee50c08a07e62b)(frames, frames, constraintIndex);
                    timelines.push($acc7b1056b491f28$var$readTimeline1(timelineMap, timeline, 0, constraint.spacingMode == (0, $16a395dfc145fe87$export$34ce760ad2b0be4b).Length || constraint.spacingMode == (0, $16a395dfc145fe87$export$34ce760ad2b0be4b).Fixed ? scale : 1));
                } else if (timelineName === "mix") {
                    let timeline = new (0, $c8bc0977b55afb3a$export$ea67b41755485038)(frames, frames * 3, constraintIndex);
                    let time = $acc7b1056b491f28$var$getValue(keyMap, "time", 0);
                    let mixRotate = $acc7b1056b491f28$var$getValue(keyMap, "mixRotate", 1);
                    let mixX = $acc7b1056b491f28$var$getValue(keyMap, "mixX", 1);
                    let mixY = $acc7b1056b491f28$var$getValue(keyMap, "mixY", mixX);
                    for(let frame = 0, bezier = 0;; frame++){
                        timeline.setFrame(frame, time, mixRotate, mixX, mixY);
                        let nextMap = timelineMap[frame + 1];
                        if (!nextMap) {
                            timeline.shrink(bezier);
                            break;
                        }
                        let time2 = $acc7b1056b491f28$var$getValue(nextMap, "time", 0);
                        let mixRotate2 = $acc7b1056b491f28$var$getValue(nextMap, "mixRotate", 1);
                        let mixX2 = $acc7b1056b491f28$var$getValue(nextMap, "mixX", 1);
                        let mixY2 = $acc7b1056b491f28$var$getValue(nextMap, "mixY", mixX2);
                        let curve = keyMap.curve;
                        if (curve) {
                            bezier = $acc7b1056b491f28$var$readCurve(curve, timeline, bezier, frame, 0, time, time2, mixRotate, mixRotate2, 1);
                            bezier = $acc7b1056b491f28$var$readCurve(curve, timeline, bezier, frame, 1, time, time2, mixX, mixX2, 1);
                            bezier = $acc7b1056b491f28$var$readCurve(curve, timeline, bezier, frame, 2, time, time2, mixY, mixY2, 1);
                        }
                        time = time2;
                        mixRotate = mixRotate2;
                        mixX = mixX2;
                        mixY = mixY2;
                        keyMap = nextMap;
                    }
                    timelines.push(timeline);
                }
            }
        }
        // Attachment timelines.
        if (map.attachments) for(let attachmentsName in map.attachments){
            let attachmentsMap = map.attachments[attachmentsName];
            let skin = skeletonData.findSkin(attachmentsName);
            if (!skin) throw new Error("Skin not found: " + attachmentsName);
            for(let slotMapName in attachmentsMap){
                let slotMap = attachmentsMap[slotMapName];
                let slot = skeletonData.findSlot(slotMapName);
                if (!slot) throw new Error("Slot not found: " + slotMapName);
                let slotIndex = slot.index;
                for(let attachmentMapName in slotMap){
                    let attachmentMap = slotMap[attachmentMapName];
                    let attachment = skin.getAttachment(slotIndex, attachmentMapName);
                    for(let timelineMapName in attachmentMap){
                        let timelineMap = attachmentMap[timelineMapName];
                        let keyMap = timelineMap[0];
                        if (!keyMap) continue;
                        if (timelineMapName == "deform") {
                            let weighted = attachment.bones;
                            let vertices = attachment.vertices;
                            let deformLength = weighted ? vertices.length / 3 * 2 : vertices.length;
                            let timeline = new (0, $c8bc0977b55afb3a$export$6968d40e5689ad6b)(timelineMap.length, timelineMap.length, slotIndex, attachment);
                            let time = $acc7b1056b491f28$var$getValue(keyMap, "time", 0);
                            for(let frame = 0, bezier = 0;; frame++){
                                let deform;
                                let verticesValue = $acc7b1056b491f28$var$getValue(keyMap, "vertices", null);
                                if (!verticesValue) deform = weighted ? (0, $1702fa998ec22e58$export$d2ca453b913dcdea).newFloatArray(deformLength) : vertices;
                                else {
                                    deform = (0, $1702fa998ec22e58$export$d2ca453b913dcdea).newFloatArray(deformLength);
                                    let start = $acc7b1056b491f28$var$getValue(keyMap, "offset", 0);
                                    (0, $1702fa998ec22e58$export$d2ca453b913dcdea).arrayCopy(verticesValue, 0, deform, start, verticesValue.length);
                                    if (scale != 1) for(let i = start, n = i + verticesValue.length; i < n; i++)deform[i] *= scale;
                                    if (!weighted) for(let i = 0; i < deformLength; i++)deform[i] += vertices[i];
                                }
                                timeline.setFrame(frame, time, deform);
                                let nextMap = timelineMap[frame + 1];
                                if (!nextMap) {
                                    timeline.shrink(bezier);
                                    break;
                                }
                                let time2 = $acc7b1056b491f28$var$getValue(nextMap, "time", 0);
                                let curve = keyMap.curve;
                                if (curve) bezier = $acc7b1056b491f28$var$readCurve(curve, timeline, bezier, frame, 0, time, time2, 0, 1, 1);
                                time = time2;
                                keyMap = nextMap;
                            }
                            timelines.push(timeline);
                        } else if (timelineMapName == "sequence") {
                            let timeline = new (0, $c8bc0977b55afb3a$export$2687f324e8496672)(timelineMap.length, slotIndex, attachment);
                            let lastDelay = 0;
                            for(let frame = 0; frame < timelineMap.length; frame++){
                                let delay = $acc7b1056b491f28$var$getValue(keyMap, "delay", lastDelay);
                                let time = $acc7b1056b491f28$var$getValue(keyMap, "time", 0);
                                let mode = (0, $1bc73da5d49cda90$export$2d839466c6120eb9)[$acc7b1056b491f28$var$getValue(keyMap, "mode", "hold")];
                                let index = $acc7b1056b491f28$var$getValue(keyMap, "index", 0);
                                timeline.setFrame(frame, time, mode, index, delay);
                                lastDelay = delay;
                                keyMap = timelineMap[frame + 1];
                            }
                            timelines.push(timeline);
                        }
                    }
                }
            }
        }
        // Draw order timelines.
        if (map.drawOrder) {
            let timeline = new (0, $c8bc0977b55afb3a$export$ece1f7c41d051e83)(map.drawOrder.length);
            let slotCount = skeletonData.slots.length;
            let frame = 0;
            for(let i = 0; i < map.drawOrder.length; i++, frame++){
                let drawOrderMap = map.drawOrder[i];
                let drawOrder = null;
                let offsets = $acc7b1056b491f28$var$getValue(drawOrderMap, "offsets", null);
                if (offsets) {
                    drawOrder = (0, $1702fa998ec22e58$export$d2ca453b913dcdea).newArray(slotCount, -1);
                    let unchanged = (0, $1702fa998ec22e58$export$d2ca453b913dcdea).newArray(slotCount - offsets.length, 0);
                    let originalIndex = 0, unchangedIndex = 0;
                    for(let ii = 0; ii < offsets.length; ii++){
                        let offsetMap = offsets[ii];
                        let slot = skeletonData.findSlot(offsetMap.slot);
                        if (!slot) throw new Error("Slot not found: " + slot);
                        let slotIndex = slot.index;
                        // Collect unchanged items.
                        while(originalIndex != slotIndex)unchanged[unchangedIndex++] = originalIndex++;
                        // Set changed items.
                        drawOrder[originalIndex + offsetMap.offset] = originalIndex++;
                    }
                    // Collect remaining unchanged items.
                    while(originalIndex < slotCount)unchanged[unchangedIndex++] = originalIndex++;
                    // Fill in unchanged items.
                    for(let ii = slotCount - 1; ii >= 0; ii--)if (drawOrder[ii] == -1) drawOrder[ii] = unchanged[--unchangedIndex];
                }
                timeline.setFrame(frame, $acc7b1056b491f28$var$getValue(drawOrderMap, "time", 0), drawOrder);
            }
            timelines.push(timeline);
        }
        // Event timelines.
        if (map.events) {
            let timeline = new (0, $c8bc0977b55afb3a$export$4f4bca996c586084)(map.events.length);
            let frame = 0;
            for(let i = 0; i < map.events.length; i++, frame++){
                let eventMap = map.events[i];
                let eventData = skeletonData.findEvent(eventMap.name);
                if (!eventData) throw new Error("Event not found: " + eventMap.name);
                let event = new (0, $1b0b163278ab2291$export$d61e24a684f9e51)((0, $1702fa998ec22e58$export$d2ca453b913dcdea).toSinglePrecision($acc7b1056b491f28$var$getValue(eventMap, "time", 0)), eventData);
                event.intValue = $acc7b1056b491f28$var$getValue(eventMap, "int", eventData.intValue);
                event.floatValue = $acc7b1056b491f28$var$getValue(eventMap, "float", eventData.floatValue);
                event.stringValue = $acc7b1056b491f28$var$getValue(eventMap, "string", eventData.stringValue);
                if (event.data.audioPath) {
                    event.volume = $acc7b1056b491f28$var$getValue(eventMap, "volume", 1);
                    event.balance = $acc7b1056b491f28$var$getValue(eventMap, "balance", 0);
                }
                timeline.setFrame(frame, event);
            }
            timelines.push(timeline);
        }
        let duration = 0;
        for(let i = 0, n = timelines.length; i < n; i++)duration = Math.max(duration, timelines[i].getDuration());
        skeletonData.animations.push(new (0, $c8bc0977b55afb3a$export$c35d437ae5945fcd)(name, timelines, duration));
    }
}
class $acc7b1056b491f28$var$LinkedMesh {
    parent;
    skin;
    slotIndex;
    mesh;
    inheritTimeline;
    constructor(mesh, skin, slotIndex, parent, inheritDeform){
        this.mesh = mesh;
        this.skin = skin;
        this.slotIndex = slotIndex;
        this.parent = parent;
        this.inheritTimeline = inheritDeform;
    }
}
function $acc7b1056b491f28$var$readTimeline1(keys, timeline, defaultValue, scale) {
    let keyMap = keys[0];
    let time = $acc7b1056b491f28$var$getValue(keyMap, "time", 0);
    let value = $acc7b1056b491f28$var$getValue(keyMap, "value", defaultValue) * scale;
    let bezier = 0;
    for(let frame = 0;; frame++){
        timeline.setFrame(frame, time, value);
        let nextMap = keys[frame + 1];
        if (!nextMap) {
            timeline.shrink(bezier);
            return timeline;
        }
        let time2 = $acc7b1056b491f28$var$getValue(nextMap, "time", 0);
        let value2 = $acc7b1056b491f28$var$getValue(nextMap, "value", defaultValue) * scale;
        if (keyMap.curve) bezier = $acc7b1056b491f28$var$readCurve(keyMap.curve, timeline, bezier, frame, 0, time, time2, value, value2, scale);
        time = time2;
        value = value2;
        keyMap = nextMap;
    }
}
function $acc7b1056b491f28$var$readTimeline2(keys, timeline, name1, name2, defaultValue, scale) {
    let keyMap = keys[0];
    let time = $acc7b1056b491f28$var$getValue(keyMap, "time", 0);
    let value1 = $acc7b1056b491f28$var$getValue(keyMap, name1, defaultValue) * scale;
    let value2 = $acc7b1056b491f28$var$getValue(keyMap, name2, defaultValue) * scale;
    let bezier = 0;
    for(let frame = 0;; frame++){
        timeline.setFrame(frame, time, value1, value2);
        let nextMap = keys[frame + 1];
        if (!nextMap) {
            timeline.shrink(bezier);
            return timeline;
        }
        let time2 = $acc7b1056b491f28$var$getValue(nextMap, "time", 0);
        let nvalue1 = $acc7b1056b491f28$var$getValue(nextMap, name1, defaultValue) * scale;
        let nvalue2 = $acc7b1056b491f28$var$getValue(nextMap, name2, defaultValue) * scale;
        let curve = keyMap.curve;
        if (curve) {
            bezier = $acc7b1056b491f28$var$readCurve(curve, timeline, bezier, frame, 0, time, time2, value1, nvalue1, scale);
            bezier = $acc7b1056b491f28$var$readCurve(curve, timeline, bezier, frame, 1, time, time2, value2, nvalue2, scale);
        }
        time = time2;
        value1 = nvalue1;
        value2 = nvalue2;
        keyMap = nextMap;
    }
}
function $acc7b1056b491f28$var$readCurve(curve, timeline, bezier, frame, value, time1, time2, value1, value2, scale) {
    if (curve == "stepped") {
        timeline.setStepped(frame);
        return bezier;
    }
    let i = value << 2;
    let cx1 = curve[i];
    let cy1 = curve[i + 1] * scale;
    let cx2 = curve[i + 2];
    let cy2 = curve[i + 3] * scale;
    timeline.setBezier(bezier, frame, value, time1, value1, cx1, cy1, cx2, cy2, time2, value2);
    return bezier + 1;
}
function $acc7b1056b491f28$var$getValue(map, property, defaultValue) {
    return map[property] !== undefined ? map[property] : defaultValue;
}










/******************************************************************************
 * Spine Runtimes License Agreement
 * Last updated July 28, 2023. Replaces all prior versions.
 *
 * Copyright (c) 2013-2023, Esoteric Software LLC
 *
 * Integration of the Spine Runtimes into software or otherwise creating
 * derivative works of the Spine Runtimes is permitted under the terms and
 * conditions of Section 2 of the Spine Editor License Agreement:
 * http://esotericsoftware.com/spine-editor-license
 *
 * Otherwise, it is permitted to integrate the Spine Runtimes into software or
 * otherwise create derivative works of the Spine Runtimes (collectively,
 * "Products"), provided that each user of the Products must obtain their own
 * Spine Editor license and redistribution of the Products in any form must
 * include this license and copyright notice.
 *
 * THE SPINE RUNTIMES ARE PROVIDED BY ESOTERIC SOFTWARE LLC "AS IS" AND ANY
 * EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
 * WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE
 * DISCLAIMED. IN NO EVENT SHALL ESOTERIC SOFTWARE LLC BE LIABLE FOR ANY
 * DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES
 * (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES,
 * BUSINESS INTERRUPTION, OR LOSS OF USE, DATA, OR PROFITS) HOWEVER CAUSED AND
 * ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT
 * (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THE
 * SPINE RUNTIMES, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
 *****************************************************************************/ 


/******************************************************************************
 * Spine Runtimes License Agreement
 * Last updated July 28, 2023. Replaces all prior versions.
 *
 * Copyright (c) 2013-2023, Esoteric Software LLC
 *
 * Integration of the Spine Runtimes into software or otherwise creating
 * derivative works of the Spine Runtimes is permitted under the terms and
 * conditions of Section 2 of the Spine Editor License Agreement:
 * http://esotericsoftware.com/spine-editor-license
 *
 * Otherwise, it is permitted to integrate the Spine Runtimes into software or
 * otherwise create derivative works of the Spine Runtimes (collectively,
 * "Products"), provided that each user of the Products must obtain their own
 * Spine Editor license and redistribution of the Products in any form must
 * include this license and copyright notice.
 *
 * THE SPINE RUNTIMES ARE PROVIDED BY ESOTERIC SOFTWARE LLC "AS IS" AND ANY
 * EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
 * WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE
 * DISCLAIMED. IN NO EVENT SHALL ESOTERIC SOFTWARE LLC BE LIABLE FOR ANY
 * DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES
 * (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES,
 * BUSINESS INTERRUPTION, OR LOSS OF USE, DATA, OR PROFITS) HOWEVER CAUSED AND
 * ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT
 * (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THE
 * SPINE RUNTIMES, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
 *****************************************************************************/ (()=>{
    if (typeof Math.fround === "undefined") Math.fround = function(array) {
        return function(x) {
            return array[0] = x, array[0];
        };
    }(new Float32Array(1));
})();



/******************************************************************************
 * Spine Runtimes License Agreement
 * Last updated July 28, 2023. Replaces all prior versions.
 *
 * Copyright (c) 2013-2023, Esoteric Software LLC
 *
 * Integration of the Spine Runtimes into software or otherwise creating
 * derivative works of the Spine Runtimes is permitted under the terms and
 * conditions of Section 2 of the Spine Editor License Agreement:
 * http://esotericsoftware.com/spine-editor-license
 *
 * Otherwise, it is permitted to integrate the Spine Runtimes into software or
 * otherwise create derivative works of the Spine Runtimes (collectively,
 * "Products"), provided that each user of the Products must obtain their own
 * Spine Editor license and redistribution of the Products in any form must
 * include this license and copyright notice.
 *
 * THE SPINE RUNTIMES ARE PROVIDED BY ESOTERIC SOFTWARE LLC "AS IS" AND ANY
 * EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
 * WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE
 * DISCLAIMED. IN NO EVENT SHALL ESOTERIC SOFTWARE LLC BE LIABLE FOR ANY
 * DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES
 * (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES,
 * BUSINESS INTERRUPTION, OR LOSS OF USE, DATA, OR PROFITS) HOWEVER CAUSED AND
 * ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT
 * (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THE
 * SPINE RUNTIMES, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
 *****************************************************************************/ 









/******************************************************************************
 * Spine Runtimes License Agreement
 * Last updated July 28, 2023. Replaces all prior versions.
 *
 * Copyright (c) 2013-2023, Esoteric Software LLC
 *
 * Integration of the Spine Runtimes into software or otherwise creating
 * derivative works of the Spine Runtimes is permitted under the terms and
 * conditions of Section 2 of the Spine Editor License Agreement:
 * http://esotericsoftware.com/spine-editor-license
 *
 * Otherwise, it is permitted to integrate the Spine Runtimes into software or
 * otherwise create derivative works of the Spine Runtimes (collectively,
 * "Products"), provided that each user of the Products must obtain their own
 * Spine Editor license and redistribution of the Products in any form must
 * include this license and copyright notice.
 *
 * THE SPINE RUNTIMES ARE PROVIDED BY ESOTERIC SOFTWARE LLC "AS IS" AND ANY
 * EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
 * WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE
 * DISCLAIMED. IN NO EVENT SHALL ESOTERIC SOFTWARE LLC BE LIABLE FOR ANY
 * DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES
 * (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES,
 * BUSINESS INTERRUPTION, OR LOSS OF USE, DATA, OR PROFITS) HOWEVER CAUSED AND
 * ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT
 * (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THE
 * SPINE RUNTIMES, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
 *****************************************************************************/ 
/******************************************************************************
 * Spine Runtimes License Agreement
 * Last updated July 28, 2023. Replaces all prior versions.
 *
 * Copyright (c) 2013-2023, Esoteric Software LLC
 *
 * Integration of the Spine Runtimes into software or otherwise creating
 * derivative works of the Spine Runtimes is permitted under the terms and
 * conditions of Section 2 of the Spine Editor License Agreement:
 * http://esotericsoftware.com/spine-editor-license
 *
 * Otherwise, it is permitted to integrate the Spine Runtimes into software or
 * otherwise create derivative works of the Spine Runtimes (collectively,
 * "Products"), provided that each user of the Products must obtain their own
 * Spine Editor license and redistribution of the Products in any form must
 * include this license and copyright notice.
 *
 * THE SPINE RUNTIMES ARE PROVIDED BY ESOTERIC SOFTWARE LLC "AS IS" AND ANY
 * EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
 * WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE
 * DISCLAIMED. IN NO EVENT SHALL ESOTERIC SOFTWARE LLC BE LIABLE FOR ANY
 * DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES
 * (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES,
 * BUSINESS INTERRUPTION, OR LOSS OF USE, DATA, OR PROFITS) HOWEVER CAUSED AND
 * ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT
 * (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THE
 * SPINE RUNTIMES, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
 *****************************************************************************/ 
/******************************************************************************
 * Spine Runtimes License Agreement
 * Last updated July 28, 2023. Replaces all prior versions.
 *
 * Copyright (c) 2013-2023, Esoteric Software LLC
 *
 * Integration of the Spine Runtimes into software or otherwise creating
 * derivative works of the Spine Runtimes is permitted under the terms and
 * conditions of Section 2 of the Spine Editor License Agreement:
 * http://esotericsoftware.com/spine-editor-license
 *
 * Otherwise, it is permitted to integrate the Spine Runtimes into software or
 * otherwise create derivative works of the Spine Runtimes (collectively,
 * "Products"), provided that each user of the Products must obtain their own
 * Spine Editor license and redistribution of the Products in any form must
 * include this license and copyright notice.
 *
 * THE SPINE RUNTIMES ARE PROVIDED BY ESOTERIC SOFTWARE LLC "AS IS" AND ANY
 * EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
 * WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE
 * DISCLAIMED. IN NO EVENT SHALL ESOTERIC SOFTWARE LLC BE LIABLE FOR ANY
 * DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES
 * (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES,
 * BUSINESS INTERRUPTION, OR LOSS OF USE, DATA, OR PROFITS) HOWEVER CAUSED AND
 * ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT
 * (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THE
 * SPINE RUNTIMES, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
 *****************************************************************************/ class $d702f730bad78eda$export$a4d6d43057cae2ac {
    canvas;
    gl;
    restorables = new Array();
    constructor(canvasOrContext, contextConfig = {
        alpha: "true"
    }){
        if (!(canvasOrContext instanceof WebGLRenderingContext || typeof WebGL2RenderingContext !== "undefined" && canvasOrContext instanceof WebGL2RenderingContext)) {
            let canvas = canvasOrContext;
            this.gl = canvas.getContext("webgl2", contextConfig) || canvas.getContext("webgl", contextConfig);
            this.canvas = canvas;
            canvas.addEventListener("webglcontextlost", (e)=>{
                let event = e;
                if (e) e.preventDefault();
            });
            canvas.addEventListener("webglcontextrestored", (e)=>{
                for(let i = 0, n = this.restorables.length; i < n; i++)this.restorables[i].restore();
            });
        } else {
            this.gl = canvasOrContext;
            this.canvas = this.gl.canvas;
        }
    }
    addRestorable(restorable) {
        this.restorables.push(restorable);
    }
    removeRestorable(restorable) {
        let index = this.restorables.indexOf(restorable);
        if (index > -1) this.restorables.splice(index, 1);
    }
}


class $d0ec9bcdfbe617c0$export$6c73c2a4561c07a2 extends (0, $471b0ca0afe71980$export$5431306cf43de24a) {
    context;
    texture = null;
    boundUnit = 0;
    useMipMaps = false;
    static DISABLE_UNPACK_PREMULTIPLIED_ALPHA_WEBGL = false;
    constructor(context, image, useMipMaps = false){
        super(image);
        this.context = context instanceof (0, $d702f730bad78eda$export$a4d6d43057cae2ac) ? context : new (0, $d702f730bad78eda$export$a4d6d43057cae2ac)(context);
        this.useMipMaps = useMipMaps;
        this.restore();
        this.context.addRestorable(this);
    }
    setFilters(minFilter, magFilter) {
        let gl = this.context.gl;
        this.bind();
        gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_MIN_FILTER, minFilter);
        gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_MAG_FILTER, $d0ec9bcdfbe617c0$export$6c73c2a4561c07a2.validateMagFilter(magFilter));
        this.useMipMaps = $d0ec9bcdfbe617c0$export$6c73c2a4561c07a2.usesMipMaps(minFilter);
        if (this.useMipMaps) gl.generateMipmap(gl.TEXTURE_2D);
    }
    static validateMagFilter(magFilter) {
        switch(magFilter){
            case (0, $471b0ca0afe71980$export$f389c48fc54053be).MipMapLinearLinear:
            case (0, $471b0ca0afe71980$export$f389c48fc54053be).MipMapLinearNearest:
            case (0, $471b0ca0afe71980$export$f389c48fc54053be).MipMapNearestLinear:
            case (0, $471b0ca0afe71980$export$f389c48fc54053be).MipMapNearestNearest:
                return (0, $471b0ca0afe71980$export$f389c48fc54053be).Linear;
            default:
                return magFilter;
        }
    }
    static usesMipMaps(filter) {
        switch(filter){
            case (0, $471b0ca0afe71980$export$f389c48fc54053be).MipMapLinearLinear:
            case (0, $471b0ca0afe71980$export$f389c48fc54053be).MipMapLinearNearest:
            case (0, $471b0ca0afe71980$export$f389c48fc54053be).MipMapNearestLinear:
            case (0, $471b0ca0afe71980$export$f389c48fc54053be).MipMapNearestNearest:
                return true;
            default:
                return false;
        }
    }
    setWraps(uWrap, vWrap) {
        let gl = this.context.gl;
        this.bind();
        gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_WRAP_S, uWrap);
        gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_WRAP_T, vWrap);
    }
    update(useMipMaps) {
        let gl = this.context.gl;
        if (!this.texture) this.texture = this.context.gl.createTexture();
        this.bind();
        if ($d0ec9bcdfbe617c0$export$6c73c2a4561c07a2.DISABLE_UNPACK_PREMULTIPLIED_ALPHA_WEBGL) gl.pixelStorei(gl.UNPACK_PREMULTIPLY_ALPHA_WEBGL, false);
        gl.texImage2D(gl.TEXTURE_2D, 0, gl.RGBA, gl.RGBA, gl.UNSIGNED_BYTE, this._image);
        gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_MAG_FILTER, gl.LINEAR);
        gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_MIN_FILTER, useMipMaps ? gl.LINEAR_MIPMAP_LINEAR : gl.LINEAR);
        gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_WRAP_S, gl.CLAMP_TO_EDGE);
        gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_WRAP_T, gl.CLAMP_TO_EDGE);
        if (useMipMaps) gl.generateMipmap(gl.TEXTURE_2D);
    }
    restore() {
        this.texture = null;
        this.update(this.useMipMaps);
    }
    bind(unit = 0) {
        let gl = this.context.gl;
        this.boundUnit = unit;
        gl.activeTexture(gl.TEXTURE0 + unit);
        gl.bindTexture(gl.TEXTURE_2D, this.texture);
    }
    unbind() {
        let gl = this.context.gl;
        gl.activeTexture(gl.TEXTURE0 + this.boundUnit);
        gl.bindTexture(gl.TEXTURE_2D, null);
    }
    dispose() {
        this.context.removeRestorable(this);
        let gl = this.context.gl;
        gl.deleteTexture(this.texture);
    }
}


class $abea8e8cabf3badd$export$85f9686224250ac3 extends (0, $f2a2fac98ed0510e$export$d187693bfb349728) {
    constructor(context, pathPrefix = "", downloader = new (0, $f2a2fac98ed0510e$export$ef06e7620d37c296)()){
        super((image)=>{
            return new (0, $d0ec9bcdfbe617c0$export$6c73c2a4561c07a2)(context, image);
        }, pathPrefix, downloader);
    }
}


/******************************************************************************
 * Spine Runtimes License Agreement
 * Last updated July 28, 2023. Replaces all prior versions.
 *
 * Copyright (c) 2013-2023, Esoteric Software LLC
 *
 * Integration of the Spine Runtimes into software or otherwise creating
 * derivative works of the Spine Runtimes is permitted under the terms and
 * conditions of Section 2 of the Spine Editor License Agreement:
 * http://esotericsoftware.com/spine-editor-license
 *
 * Otherwise, it is permitted to integrate the Spine Runtimes into software or
 * otherwise create derivative works of the Spine Runtimes (collectively,
 * "Products"), provided that each user of the Products must obtain their own
 * Spine Editor license and redistribution of the Products in any form must
 * include this license and copyright notice.
 *
 * THE SPINE RUNTIMES ARE PROVIDED BY ESOTERIC SOFTWARE LLC "AS IS" AND ANY
 * EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
 * WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE
 * DISCLAIMED. IN NO EVENT SHALL ESOTERIC SOFTWARE LLC BE LIABLE FOR ANY
 * DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES
 * (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES,
 * BUSINESS INTERRUPTION, OR LOSS OF USE, DATA, OR PROFITS) HOWEVER CAUSED AND
 * ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT
 * (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THE
 * SPINE RUNTIMES, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
 *****************************************************************************/ /******************************************************************************
 * Spine Runtimes License Agreement
 * Last updated July 28, 2023. Replaces all prior versions.
 *
 * Copyright (c) 2013-2023, Esoteric Software LLC
 *
 * Integration of the Spine Runtimes into software or otherwise creating
 * derivative works of the Spine Runtimes is permitted under the terms and
 * conditions of Section 2 of the Spine Editor License Agreement:
 * http://esotericsoftware.com/spine-editor-license
 *
 * Otherwise, it is permitted to integrate the Spine Runtimes into software or
 * otherwise create derivative works of the Spine Runtimes (collectively,
 * "Products"), provided that each user of the Products must obtain their own
 * Spine Editor license and redistribution of the Products in any form must
 * include this license and copyright notice.
 *
 * THE SPINE RUNTIMES ARE PROVIDED BY ESOTERIC SOFTWARE LLC "AS IS" AND ANY
 * EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
 * WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE
 * DISCLAIMED. IN NO EVENT SHALL ESOTERIC SOFTWARE LLC BE LIABLE FOR ANY
 * DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES
 * (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES,
 * BUSINESS INTERRUPTION, OR LOSS OF USE, DATA, OR PROFITS) HOWEVER CAUSED AND
 * ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT
 * (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THE
 * SPINE RUNTIMES, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
 *****************************************************************************/ /******************************************************************************
 * Spine Runtimes License Agreement
 * Last updated July 28, 2023. Replaces all prior versions.
 *
 * Copyright (c) 2013-2023, Esoteric Software LLC
 *
 * Integration of the Spine Runtimes into software or otherwise creating
 * derivative works of the Spine Runtimes is permitted under the terms and
 * conditions of Section 2 of the Spine Editor License Agreement:
 * http://esotericsoftware.com/spine-editor-license
 *
 * Otherwise, it is permitted to integrate the Spine Runtimes into software or
 * otherwise create derivative works of the Spine Runtimes (collectively,
 * "Products"), provided that each user of the Products must obtain their own
 * Spine Editor license and redistribution of the Products in any form must
 * include this license and copyright notice.
 *
 * THE SPINE RUNTIMES ARE PROVIDED BY ESOTERIC SOFTWARE LLC "AS IS" AND ANY
 * EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
 * WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE
 * DISCLAIMED. IN NO EVENT SHALL ESOTERIC SOFTWARE LLC BE LIABLE FOR ANY
 * DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES
 * (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES,
 * BUSINESS INTERRUPTION, OR LOSS OF USE, DATA, OR PROFITS) HOWEVER CAUSED AND
 * ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT
 * (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THE
 * SPINE RUNTIMES, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
 *****************************************************************************/ 
class $75a60b996df58eed$export$64b5c384219d3699 {
    x = 0;
    y = 0;
    z = 0;
    constructor(x = 0, y = 0, z = 0){
        this.x = x;
        this.y = y;
        this.z = z;
    }
    setFrom(v) {
        this.x = v.x;
        this.y = v.y;
        this.z = v.z;
        return this;
    }
    set(x, y, z) {
        this.x = x;
        this.y = y;
        this.z = z;
        return this;
    }
    add(v) {
        this.x += v.x;
        this.y += v.y;
        this.z += v.z;
        return this;
    }
    sub(v) {
        this.x -= v.x;
        this.y -= v.y;
        this.z -= v.z;
        return this;
    }
    scale(s) {
        this.x *= s;
        this.y *= s;
        this.z *= s;
        return this;
    }
    normalize() {
        let len = this.length();
        if (len == 0) return this;
        len = 1 / len;
        this.x *= len;
        this.y *= len;
        this.z *= len;
        return this;
    }
    cross(v) {
        return this.set(this.y * v.z - this.z * v.y, this.z * v.x - this.x * v.z, this.x * v.y - this.y * v.x);
    }
    multiply(matrix) {
        let l_mat = matrix.values;
        return this.set(this.x * l_mat[0, $ab3ad4186e4caed0$export$b06a2a6195c06efc] + this.y * l_mat[0, $ab3ad4186e4caed0$export$5ae52f682687d620] + this.z * l_mat[0, $ab3ad4186e4caed0$export$91e90b05312755fb] + l_mat[0, $ab3ad4186e4caed0$export$99d2679d75e60dc2], this.x * l_mat[0, $ab3ad4186e4caed0$export$585a161a9f77f349] + this.y * l_mat[0, $ab3ad4186e4caed0$export$f2a5a7bac7258e1] + this.z * l_mat[0, $ab3ad4186e4caed0$export$b9223c25c7ef9657] + l_mat[0, $ab3ad4186e4caed0$export$92c05cfba9c4af26], this.x * l_mat[0, $ab3ad4186e4caed0$export$f962d36842749298] + this.y * l_mat[0, $ab3ad4186e4caed0$export$82895316122b6751] + this.z * l_mat[0, $ab3ad4186e4caed0$export$4bbf13e387a5a72d] + l_mat[0, $ab3ad4186e4caed0$export$5ef568f270a37e28]);
    }
    project(matrix) {
        let l_mat = matrix.values;
        let l_w = 1 / (this.x * l_mat[0, $ab3ad4186e4caed0$export$bc0cebc6a0427364] + this.y * l_mat[0, $ab3ad4186e4caed0$export$dc2c5fe5c845d994] + this.z * l_mat[0, $ab3ad4186e4caed0$export$f6ad99760c0e8d51] + l_mat[0, $ab3ad4186e4caed0$export$ab9ff870dfff35f]);
        return this.set((this.x * l_mat[0, $ab3ad4186e4caed0$export$b06a2a6195c06efc] + this.y * l_mat[0, $ab3ad4186e4caed0$export$5ae52f682687d620] + this.z * l_mat[0, $ab3ad4186e4caed0$export$91e90b05312755fb] + l_mat[0, $ab3ad4186e4caed0$export$99d2679d75e60dc2]) * l_w, (this.x * l_mat[0, $ab3ad4186e4caed0$export$585a161a9f77f349] + this.y * l_mat[0, $ab3ad4186e4caed0$export$f2a5a7bac7258e1] + this.z * l_mat[0, $ab3ad4186e4caed0$export$b9223c25c7ef9657] + l_mat[0, $ab3ad4186e4caed0$export$92c05cfba9c4af26]) * l_w, (this.x * l_mat[0, $ab3ad4186e4caed0$export$f962d36842749298] + this.y * l_mat[0, $ab3ad4186e4caed0$export$82895316122b6751] + this.z * l_mat[0, $ab3ad4186e4caed0$export$4bbf13e387a5a72d] + l_mat[0, $ab3ad4186e4caed0$export$5ef568f270a37e28]) * l_w);
    }
    dot(v) {
        return this.x * v.x + this.y * v.y + this.z * v.z;
    }
    length() {
        return Math.sqrt(this.x * this.x + this.y * this.y + this.z * this.z);
    }
    distance(v) {
        let a = v.x - this.x;
        let b = v.y - this.y;
        let c = v.z - this.z;
        return Math.sqrt(a * a + b * b + c * c);
    }
}


const $ab3ad4186e4caed0$export$b06a2a6195c06efc = 0;
const $ab3ad4186e4caed0$export$5ae52f682687d620 = 4;
const $ab3ad4186e4caed0$export$91e90b05312755fb = 8;
const $ab3ad4186e4caed0$export$99d2679d75e60dc2 = 12;
const $ab3ad4186e4caed0$export$585a161a9f77f349 = 1;
const $ab3ad4186e4caed0$export$f2a5a7bac7258e1 = 5;
const $ab3ad4186e4caed0$export$b9223c25c7ef9657 = 9;
const $ab3ad4186e4caed0$export$92c05cfba9c4af26 = 13;
const $ab3ad4186e4caed0$export$f962d36842749298 = 2;
const $ab3ad4186e4caed0$export$82895316122b6751 = 6;
const $ab3ad4186e4caed0$export$4bbf13e387a5a72d = 10;
const $ab3ad4186e4caed0$export$5ef568f270a37e28 = 14;
const $ab3ad4186e4caed0$export$bc0cebc6a0427364 = 3;
const $ab3ad4186e4caed0$export$dc2c5fe5c845d994 = 7;
const $ab3ad4186e4caed0$export$f6ad99760c0e8d51 = 11;
const $ab3ad4186e4caed0$export$ab9ff870dfff35f = 15;
class $ab3ad4186e4caed0$export$2ae72fc923e5eb5 {
    temp = new Float32Array(16);
    values = new Float32Array(16);
    static xAxis = new (0, $75a60b996df58eed$export$64b5c384219d3699)();
    static yAxis = new (0, $75a60b996df58eed$export$64b5c384219d3699)();
    static zAxis = new (0, $75a60b996df58eed$export$64b5c384219d3699)();
    static tmpMatrix = new $ab3ad4186e4caed0$export$2ae72fc923e5eb5();
    constructor(){
        let v = this.values;
        v[$ab3ad4186e4caed0$export$b06a2a6195c06efc] = 1;
        v[$ab3ad4186e4caed0$export$f2a5a7bac7258e1] = 1;
        v[$ab3ad4186e4caed0$export$4bbf13e387a5a72d] = 1;
        v[$ab3ad4186e4caed0$export$ab9ff870dfff35f] = 1;
    }
    set(values) {
        this.values.set(values);
        return this;
    }
    transpose() {
        let t = this.temp;
        let v = this.values;
        t[$ab3ad4186e4caed0$export$b06a2a6195c06efc] = v[$ab3ad4186e4caed0$export$b06a2a6195c06efc];
        t[$ab3ad4186e4caed0$export$5ae52f682687d620] = v[$ab3ad4186e4caed0$export$585a161a9f77f349];
        t[$ab3ad4186e4caed0$export$91e90b05312755fb] = v[$ab3ad4186e4caed0$export$f962d36842749298];
        t[$ab3ad4186e4caed0$export$99d2679d75e60dc2] = v[$ab3ad4186e4caed0$export$bc0cebc6a0427364];
        t[$ab3ad4186e4caed0$export$585a161a9f77f349] = v[$ab3ad4186e4caed0$export$5ae52f682687d620];
        t[$ab3ad4186e4caed0$export$f2a5a7bac7258e1] = v[$ab3ad4186e4caed0$export$f2a5a7bac7258e1];
        t[$ab3ad4186e4caed0$export$b9223c25c7ef9657] = v[$ab3ad4186e4caed0$export$82895316122b6751];
        t[$ab3ad4186e4caed0$export$92c05cfba9c4af26] = v[$ab3ad4186e4caed0$export$dc2c5fe5c845d994];
        t[$ab3ad4186e4caed0$export$f962d36842749298] = v[$ab3ad4186e4caed0$export$91e90b05312755fb];
        t[$ab3ad4186e4caed0$export$82895316122b6751] = v[$ab3ad4186e4caed0$export$b9223c25c7ef9657];
        t[$ab3ad4186e4caed0$export$4bbf13e387a5a72d] = v[$ab3ad4186e4caed0$export$4bbf13e387a5a72d];
        t[$ab3ad4186e4caed0$export$5ef568f270a37e28] = v[$ab3ad4186e4caed0$export$f6ad99760c0e8d51];
        t[$ab3ad4186e4caed0$export$bc0cebc6a0427364] = v[$ab3ad4186e4caed0$export$99d2679d75e60dc2];
        t[$ab3ad4186e4caed0$export$dc2c5fe5c845d994] = v[$ab3ad4186e4caed0$export$92c05cfba9c4af26];
        t[$ab3ad4186e4caed0$export$f6ad99760c0e8d51] = v[$ab3ad4186e4caed0$export$5ef568f270a37e28];
        t[$ab3ad4186e4caed0$export$ab9ff870dfff35f] = v[$ab3ad4186e4caed0$export$ab9ff870dfff35f];
        return this.set(t);
    }
    identity() {
        let v = this.values;
        v[$ab3ad4186e4caed0$export$b06a2a6195c06efc] = 1;
        v[$ab3ad4186e4caed0$export$5ae52f682687d620] = 0;
        v[$ab3ad4186e4caed0$export$91e90b05312755fb] = 0;
        v[$ab3ad4186e4caed0$export$99d2679d75e60dc2] = 0;
        v[$ab3ad4186e4caed0$export$585a161a9f77f349] = 0;
        v[$ab3ad4186e4caed0$export$f2a5a7bac7258e1] = 1;
        v[$ab3ad4186e4caed0$export$b9223c25c7ef9657] = 0;
        v[$ab3ad4186e4caed0$export$92c05cfba9c4af26] = 0;
        v[$ab3ad4186e4caed0$export$f962d36842749298] = 0;
        v[$ab3ad4186e4caed0$export$82895316122b6751] = 0;
        v[$ab3ad4186e4caed0$export$4bbf13e387a5a72d] = 1;
        v[$ab3ad4186e4caed0$export$5ef568f270a37e28] = 0;
        v[$ab3ad4186e4caed0$export$bc0cebc6a0427364] = 0;
        v[$ab3ad4186e4caed0$export$dc2c5fe5c845d994] = 0;
        v[$ab3ad4186e4caed0$export$f6ad99760c0e8d51] = 0;
        v[$ab3ad4186e4caed0$export$ab9ff870dfff35f] = 1;
        return this;
    }
    invert() {
        let v = this.values;
        let t = this.temp;
        let l_det = v[$ab3ad4186e4caed0$export$bc0cebc6a0427364] * v[$ab3ad4186e4caed0$export$82895316122b6751] * v[$ab3ad4186e4caed0$export$b9223c25c7ef9657] * v[$ab3ad4186e4caed0$export$99d2679d75e60dc2] - v[$ab3ad4186e4caed0$export$f962d36842749298] * v[$ab3ad4186e4caed0$export$dc2c5fe5c845d994] * v[$ab3ad4186e4caed0$export$b9223c25c7ef9657] * v[$ab3ad4186e4caed0$export$99d2679d75e60dc2] - v[$ab3ad4186e4caed0$export$bc0cebc6a0427364] * v[$ab3ad4186e4caed0$export$f2a5a7bac7258e1] * v[$ab3ad4186e4caed0$export$4bbf13e387a5a72d] * v[$ab3ad4186e4caed0$export$99d2679d75e60dc2] + v[$ab3ad4186e4caed0$export$585a161a9f77f349] * v[$ab3ad4186e4caed0$export$dc2c5fe5c845d994] * v[$ab3ad4186e4caed0$export$4bbf13e387a5a72d] * v[$ab3ad4186e4caed0$export$99d2679d75e60dc2] + v[$ab3ad4186e4caed0$export$f962d36842749298] * v[$ab3ad4186e4caed0$export$f2a5a7bac7258e1] * v[$ab3ad4186e4caed0$export$f6ad99760c0e8d51] * v[$ab3ad4186e4caed0$export$99d2679d75e60dc2] - v[$ab3ad4186e4caed0$export$585a161a9f77f349] * v[$ab3ad4186e4caed0$export$82895316122b6751] * v[$ab3ad4186e4caed0$export$f6ad99760c0e8d51] * v[$ab3ad4186e4caed0$export$99d2679d75e60dc2] - v[$ab3ad4186e4caed0$export$bc0cebc6a0427364] * v[$ab3ad4186e4caed0$export$82895316122b6751] * v[$ab3ad4186e4caed0$export$91e90b05312755fb] * v[$ab3ad4186e4caed0$export$92c05cfba9c4af26] + v[$ab3ad4186e4caed0$export$f962d36842749298] * v[$ab3ad4186e4caed0$export$dc2c5fe5c845d994] * v[$ab3ad4186e4caed0$export$91e90b05312755fb] * v[$ab3ad4186e4caed0$export$92c05cfba9c4af26] + v[$ab3ad4186e4caed0$export$bc0cebc6a0427364] * v[$ab3ad4186e4caed0$export$5ae52f682687d620] * v[$ab3ad4186e4caed0$export$4bbf13e387a5a72d] * v[$ab3ad4186e4caed0$export$92c05cfba9c4af26] - v[$ab3ad4186e4caed0$export$b06a2a6195c06efc] * v[$ab3ad4186e4caed0$export$dc2c5fe5c845d994] * v[$ab3ad4186e4caed0$export$4bbf13e387a5a72d] * v[$ab3ad4186e4caed0$export$92c05cfba9c4af26] - v[$ab3ad4186e4caed0$export$f962d36842749298] * v[$ab3ad4186e4caed0$export$5ae52f682687d620] * v[$ab3ad4186e4caed0$export$f6ad99760c0e8d51] * v[$ab3ad4186e4caed0$export$92c05cfba9c4af26] + v[$ab3ad4186e4caed0$export$b06a2a6195c06efc] * v[$ab3ad4186e4caed0$export$82895316122b6751] * v[$ab3ad4186e4caed0$export$f6ad99760c0e8d51] * v[$ab3ad4186e4caed0$export$92c05cfba9c4af26] + v[$ab3ad4186e4caed0$export$bc0cebc6a0427364] * v[$ab3ad4186e4caed0$export$f2a5a7bac7258e1] * v[$ab3ad4186e4caed0$export$91e90b05312755fb] * v[$ab3ad4186e4caed0$export$5ef568f270a37e28] - v[$ab3ad4186e4caed0$export$585a161a9f77f349] * v[$ab3ad4186e4caed0$export$dc2c5fe5c845d994] * v[$ab3ad4186e4caed0$export$91e90b05312755fb] * v[$ab3ad4186e4caed0$export$5ef568f270a37e28] - v[$ab3ad4186e4caed0$export$bc0cebc6a0427364] * v[$ab3ad4186e4caed0$export$5ae52f682687d620] * v[$ab3ad4186e4caed0$export$b9223c25c7ef9657] * v[$ab3ad4186e4caed0$export$5ef568f270a37e28] + v[$ab3ad4186e4caed0$export$b06a2a6195c06efc] * v[$ab3ad4186e4caed0$export$dc2c5fe5c845d994] * v[$ab3ad4186e4caed0$export$b9223c25c7ef9657] * v[$ab3ad4186e4caed0$export$5ef568f270a37e28] + v[$ab3ad4186e4caed0$export$585a161a9f77f349] * v[$ab3ad4186e4caed0$export$5ae52f682687d620] * v[$ab3ad4186e4caed0$export$f6ad99760c0e8d51] * v[$ab3ad4186e4caed0$export$5ef568f270a37e28] - v[$ab3ad4186e4caed0$export$b06a2a6195c06efc] * v[$ab3ad4186e4caed0$export$f2a5a7bac7258e1] * v[$ab3ad4186e4caed0$export$f6ad99760c0e8d51] * v[$ab3ad4186e4caed0$export$5ef568f270a37e28] - v[$ab3ad4186e4caed0$export$f962d36842749298] * v[$ab3ad4186e4caed0$export$f2a5a7bac7258e1] * v[$ab3ad4186e4caed0$export$91e90b05312755fb] * v[$ab3ad4186e4caed0$export$ab9ff870dfff35f] + v[$ab3ad4186e4caed0$export$585a161a9f77f349] * v[$ab3ad4186e4caed0$export$82895316122b6751] * v[$ab3ad4186e4caed0$export$91e90b05312755fb] * v[$ab3ad4186e4caed0$export$ab9ff870dfff35f] + v[$ab3ad4186e4caed0$export$f962d36842749298] * v[$ab3ad4186e4caed0$export$5ae52f682687d620] * v[$ab3ad4186e4caed0$export$b9223c25c7ef9657] * v[$ab3ad4186e4caed0$export$ab9ff870dfff35f] - v[$ab3ad4186e4caed0$export$b06a2a6195c06efc] * v[$ab3ad4186e4caed0$export$82895316122b6751] * v[$ab3ad4186e4caed0$export$b9223c25c7ef9657] * v[$ab3ad4186e4caed0$export$ab9ff870dfff35f] - v[$ab3ad4186e4caed0$export$585a161a9f77f349] * v[$ab3ad4186e4caed0$export$5ae52f682687d620] * v[$ab3ad4186e4caed0$export$4bbf13e387a5a72d] * v[$ab3ad4186e4caed0$export$ab9ff870dfff35f] + v[$ab3ad4186e4caed0$export$b06a2a6195c06efc] * v[$ab3ad4186e4caed0$export$f2a5a7bac7258e1] * v[$ab3ad4186e4caed0$export$4bbf13e387a5a72d] * v[$ab3ad4186e4caed0$export$ab9ff870dfff35f];
        if (l_det == 0) throw new Error("non-invertible matrix");
        let inv_det = 1.0 / l_det;
        t[$ab3ad4186e4caed0$export$b06a2a6195c06efc] = v[$ab3ad4186e4caed0$export$b9223c25c7ef9657] * v[$ab3ad4186e4caed0$export$5ef568f270a37e28] * v[$ab3ad4186e4caed0$export$dc2c5fe5c845d994] - v[$ab3ad4186e4caed0$export$92c05cfba9c4af26] * v[$ab3ad4186e4caed0$export$4bbf13e387a5a72d] * v[$ab3ad4186e4caed0$export$dc2c5fe5c845d994] + v[$ab3ad4186e4caed0$export$92c05cfba9c4af26] * v[$ab3ad4186e4caed0$export$82895316122b6751] * v[$ab3ad4186e4caed0$export$f6ad99760c0e8d51] - v[$ab3ad4186e4caed0$export$f2a5a7bac7258e1] * v[$ab3ad4186e4caed0$export$5ef568f270a37e28] * v[$ab3ad4186e4caed0$export$f6ad99760c0e8d51] - v[$ab3ad4186e4caed0$export$b9223c25c7ef9657] * v[$ab3ad4186e4caed0$export$82895316122b6751] * v[$ab3ad4186e4caed0$export$ab9ff870dfff35f] + v[$ab3ad4186e4caed0$export$f2a5a7bac7258e1] * v[$ab3ad4186e4caed0$export$4bbf13e387a5a72d] * v[$ab3ad4186e4caed0$export$ab9ff870dfff35f];
        t[$ab3ad4186e4caed0$export$5ae52f682687d620] = v[$ab3ad4186e4caed0$export$99d2679d75e60dc2] * v[$ab3ad4186e4caed0$export$4bbf13e387a5a72d] * v[$ab3ad4186e4caed0$export$dc2c5fe5c845d994] - v[$ab3ad4186e4caed0$export$91e90b05312755fb] * v[$ab3ad4186e4caed0$export$5ef568f270a37e28] * v[$ab3ad4186e4caed0$export$dc2c5fe5c845d994] - v[$ab3ad4186e4caed0$export$99d2679d75e60dc2] * v[$ab3ad4186e4caed0$export$82895316122b6751] * v[$ab3ad4186e4caed0$export$f6ad99760c0e8d51] + v[$ab3ad4186e4caed0$export$5ae52f682687d620] * v[$ab3ad4186e4caed0$export$5ef568f270a37e28] * v[$ab3ad4186e4caed0$export$f6ad99760c0e8d51] + v[$ab3ad4186e4caed0$export$91e90b05312755fb] * v[$ab3ad4186e4caed0$export$82895316122b6751] * v[$ab3ad4186e4caed0$export$ab9ff870dfff35f] - v[$ab3ad4186e4caed0$export$5ae52f682687d620] * v[$ab3ad4186e4caed0$export$4bbf13e387a5a72d] * v[$ab3ad4186e4caed0$export$ab9ff870dfff35f];
        t[$ab3ad4186e4caed0$export$91e90b05312755fb] = v[$ab3ad4186e4caed0$export$91e90b05312755fb] * v[$ab3ad4186e4caed0$export$92c05cfba9c4af26] * v[$ab3ad4186e4caed0$export$dc2c5fe5c845d994] - v[$ab3ad4186e4caed0$export$99d2679d75e60dc2] * v[$ab3ad4186e4caed0$export$b9223c25c7ef9657] * v[$ab3ad4186e4caed0$export$dc2c5fe5c845d994] + v[$ab3ad4186e4caed0$export$99d2679d75e60dc2] * v[$ab3ad4186e4caed0$export$f2a5a7bac7258e1] * v[$ab3ad4186e4caed0$export$f6ad99760c0e8d51] - v[$ab3ad4186e4caed0$export$5ae52f682687d620] * v[$ab3ad4186e4caed0$export$92c05cfba9c4af26] * v[$ab3ad4186e4caed0$export$f6ad99760c0e8d51] - v[$ab3ad4186e4caed0$export$91e90b05312755fb] * v[$ab3ad4186e4caed0$export$f2a5a7bac7258e1] * v[$ab3ad4186e4caed0$export$ab9ff870dfff35f] + v[$ab3ad4186e4caed0$export$5ae52f682687d620] * v[$ab3ad4186e4caed0$export$b9223c25c7ef9657] * v[$ab3ad4186e4caed0$export$ab9ff870dfff35f];
        t[$ab3ad4186e4caed0$export$99d2679d75e60dc2] = v[$ab3ad4186e4caed0$export$99d2679d75e60dc2] * v[$ab3ad4186e4caed0$export$b9223c25c7ef9657] * v[$ab3ad4186e4caed0$export$82895316122b6751] - v[$ab3ad4186e4caed0$export$91e90b05312755fb] * v[$ab3ad4186e4caed0$export$92c05cfba9c4af26] * v[$ab3ad4186e4caed0$export$82895316122b6751] - v[$ab3ad4186e4caed0$export$99d2679d75e60dc2] * v[$ab3ad4186e4caed0$export$f2a5a7bac7258e1] * v[$ab3ad4186e4caed0$export$4bbf13e387a5a72d] + v[$ab3ad4186e4caed0$export$5ae52f682687d620] * v[$ab3ad4186e4caed0$export$92c05cfba9c4af26] * v[$ab3ad4186e4caed0$export$4bbf13e387a5a72d] + v[$ab3ad4186e4caed0$export$91e90b05312755fb] * v[$ab3ad4186e4caed0$export$f2a5a7bac7258e1] * v[$ab3ad4186e4caed0$export$5ef568f270a37e28] - v[$ab3ad4186e4caed0$export$5ae52f682687d620] * v[$ab3ad4186e4caed0$export$b9223c25c7ef9657] * v[$ab3ad4186e4caed0$export$5ef568f270a37e28];
        t[$ab3ad4186e4caed0$export$585a161a9f77f349] = v[$ab3ad4186e4caed0$export$92c05cfba9c4af26] * v[$ab3ad4186e4caed0$export$4bbf13e387a5a72d] * v[$ab3ad4186e4caed0$export$bc0cebc6a0427364] - v[$ab3ad4186e4caed0$export$b9223c25c7ef9657] * v[$ab3ad4186e4caed0$export$5ef568f270a37e28] * v[$ab3ad4186e4caed0$export$bc0cebc6a0427364] - v[$ab3ad4186e4caed0$export$92c05cfba9c4af26] * v[$ab3ad4186e4caed0$export$f962d36842749298] * v[$ab3ad4186e4caed0$export$f6ad99760c0e8d51] + v[$ab3ad4186e4caed0$export$585a161a9f77f349] * v[$ab3ad4186e4caed0$export$5ef568f270a37e28] * v[$ab3ad4186e4caed0$export$f6ad99760c0e8d51] + v[$ab3ad4186e4caed0$export$b9223c25c7ef9657] * v[$ab3ad4186e4caed0$export$f962d36842749298] * v[$ab3ad4186e4caed0$export$ab9ff870dfff35f] - v[$ab3ad4186e4caed0$export$585a161a9f77f349] * v[$ab3ad4186e4caed0$export$4bbf13e387a5a72d] * v[$ab3ad4186e4caed0$export$ab9ff870dfff35f];
        t[$ab3ad4186e4caed0$export$f2a5a7bac7258e1] = v[$ab3ad4186e4caed0$export$91e90b05312755fb] * v[$ab3ad4186e4caed0$export$5ef568f270a37e28] * v[$ab3ad4186e4caed0$export$bc0cebc6a0427364] - v[$ab3ad4186e4caed0$export$99d2679d75e60dc2] * v[$ab3ad4186e4caed0$export$4bbf13e387a5a72d] * v[$ab3ad4186e4caed0$export$bc0cebc6a0427364] + v[$ab3ad4186e4caed0$export$99d2679d75e60dc2] * v[$ab3ad4186e4caed0$export$f962d36842749298] * v[$ab3ad4186e4caed0$export$f6ad99760c0e8d51] - v[$ab3ad4186e4caed0$export$b06a2a6195c06efc] * v[$ab3ad4186e4caed0$export$5ef568f270a37e28] * v[$ab3ad4186e4caed0$export$f6ad99760c0e8d51] - v[$ab3ad4186e4caed0$export$91e90b05312755fb] * v[$ab3ad4186e4caed0$export$f962d36842749298] * v[$ab3ad4186e4caed0$export$ab9ff870dfff35f] + v[$ab3ad4186e4caed0$export$b06a2a6195c06efc] * v[$ab3ad4186e4caed0$export$4bbf13e387a5a72d] * v[$ab3ad4186e4caed0$export$ab9ff870dfff35f];
        t[$ab3ad4186e4caed0$export$b9223c25c7ef9657] = v[$ab3ad4186e4caed0$export$99d2679d75e60dc2] * v[$ab3ad4186e4caed0$export$b9223c25c7ef9657] * v[$ab3ad4186e4caed0$export$bc0cebc6a0427364] - v[$ab3ad4186e4caed0$export$91e90b05312755fb] * v[$ab3ad4186e4caed0$export$92c05cfba9c4af26] * v[$ab3ad4186e4caed0$export$bc0cebc6a0427364] - v[$ab3ad4186e4caed0$export$99d2679d75e60dc2] * v[$ab3ad4186e4caed0$export$585a161a9f77f349] * v[$ab3ad4186e4caed0$export$f6ad99760c0e8d51] + v[$ab3ad4186e4caed0$export$b06a2a6195c06efc] * v[$ab3ad4186e4caed0$export$92c05cfba9c4af26] * v[$ab3ad4186e4caed0$export$f6ad99760c0e8d51] + v[$ab3ad4186e4caed0$export$91e90b05312755fb] * v[$ab3ad4186e4caed0$export$585a161a9f77f349] * v[$ab3ad4186e4caed0$export$ab9ff870dfff35f] - v[$ab3ad4186e4caed0$export$b06a2a6195c06efc] * v[$ab3ad4186e4caed0$export$b9223c25c7ef9657] * v[$ab3ad4186e4caed0$export$ab9ff870dfff35f];
        t[$ab3ad4186e4caed0$export$92c05cfba9c4af26] = v[$ab3ad4186e4caed0$export$91e90b05312755fb] * v[$ab3ad4186e4caed0$export$92c05cfba9c4af26] * v[$ab3ad4186e4caed0$export$f962d36842749298] - v[$ab3ad4186e4caed0$export$99d2679d75e60dc2] * v[$ab3ad4186e4caed0$export$b9223c25c7ef9657] * v[$ab3ad4186e4caed0$export$f962d36842749298] + v[$ab3ad4186e4caed0$export$99d2679d75e60dc2] * v[$ab3ad4186e4caed0$export$585a161a9f77f349] * v[$ab3ad4186e4caed0$export$4bbf13e387a5a72d] - v[$ab3ad4186e4caed0$export$b06a2a6195c06efc] * v[$ab3ad4186e4caed0$export$92c05cfba9c4af26] * v[$ab3ad4186e4caed0$export$4bbf13e387a5a72d] - v[$ab3ad4186e4caed0$export$91e90b05312755fb] * v[$ab3ad4186e4caed0$export$585a161a9f77f349] * v[$ab3ad4186e4caed0$export$5ef568f270a37e28] + v[$ab3ad4186e4caed0$export$b06a2a6195c06efc] * v[$ab3ad4186e4caed0$export$b9223c25c7ef9657] * v[$ab3ad4186e4caed0$export$5ef568f270a37e28];
        t[$ab3ad4186e4caed0$export$f962d36842749298] = v[$ab3ad4186e4caed0$export$f2a5a7bac7258e1] * v[$ab3ad4186e4caed0$export$5ef568f270a37e28] * v[$ab3ad4186e4caed0$export$bc0cebc6a0427364] - v[$ab3ad4186e4caed0$export$92c05cfba9c4af26] * v[$ab3ad4186e4caed0$export$82895316122b6751] * v[$ab3ad4186e4caed0$export$bc0cebc6a0427364] + v[$ab3ad4186e4caed0$export$92c05cfba9c4af26] * v[$ab3ad4186e4caed0$export$f962d36842749298] * v[$ab3ad4186e4caed0$export$dc2c5fe5c845d994] - v[$ab3ad4186e4caed0$export$585a161a9f77f349] * v[$ab3ad4186e4caed0$export$5ef568f270a37e28] * v[$ab3ad4186e4caed0$export$dc2c5fe5c845d994] - v[$ab3ad4186e4caed0$export$f2a5a7bac7258e1] * v[$ab3ad4186e4caed0$export$f962d36842749298] * v[$ab3ad4186e4caed0$export$ab9ff870dfff35f] + v[$ab3ad4186e4caed0$export$585a161a9f77f349] * v[$ab3ad4186e4caed0$export$82895316122b6751] * v[$ab3ad4186e4caed0$export$ab9ff870dfff35f];
        t[$ab3ad4186e4caed0$export$82895316122b6751] = v[$ab3ad4186e4caed0$export$99d2679d75e60dc2] * v[$ab3ad4186e4caed0$export$82895316122b6751] * v[$ab3ad4186e4caed0$export$bc0cebc6a0427364] - v[$ab3ad4186e4caed0$export$5ae52f682687d620] * v[$ab3ad4186e4caed0$export$5ef568f270a37e28] * v[$ab3ad4186e4caed0$export$bc0cebc6a0427364] - v[$ab3ad4186e4caed0$export$99d2679d75e60dc2] * v[$ab3ad4186e4caed0$export$f962d36842749298] * v[$ab3ad4186e4caed0$export$dc2c5fe5c845d994] + v[$ab3ad4186e4caed0$export$b06a2a6195c06efc] * v[$ab3ad4186e4caed0$export$5ef568f270a37e28] * v[$ab3ad4186e4caed0$export$dc2c5fe5c845d994] + v[$ab3ad4186e4caed0$export$5ae52f682687d620] * v[$ab3ad4186e4caed0$export$f962d36842749298] * v[$ab3ad4186e4caed0$export$ab9ff870dfff35f] - v[$ab3ad4186e4caed0$export$b06a2a6195c06efc] * v[$ab3ad4186e4caed0$export$82895316122b6751] * v[$ab3ad4186e4caed0$export$ab9ff870dfff35f];
        t[$ab3ad4186e4caed0$export$4bbf13e387a5a72d] = v[$ab3ad4186e4caed0$export$5ae52f682687d620] * v[$ab3ad4186e4caed0$export$92c05cfba9c4af26] * v[$ab3ad4186e4caed0$export$bc0cebc6a0427364] - v[$ab3ad4186e4caed0$export$99d2679d75e60dc2] * v[$ab3ad4186e4caed0$export$f2a5a7bac7258e1] * v[$ab3ad4186e4caed0$export$bc0cebc6a0427364] + v[$ab3ad4186e4caed0$export$99d2679d75e60dc2] * v[$ab3ad4186e4caed0$export$585a161a9f77f349] * v[$ab3ad4186e4caed0$export$dc2c5fe5c845d994] - v[$ab3ad4186e4caed0$export$b06a2a6195c06efc] * v[$ab3ad4186e4caed0$export$92c05cfba9c4af26] * v[$ab3ad4186e4caed0$export$dc2c5fe5c845d994] - v[$ab3ad4186e4caed0$export$5ae52f682687d620] * v[$ab3ad4186e4caed0$export$585a161a9f77f349] * v[$ab3ad4186e4caed0$export$ab9ff870dfff35f] + v[$ab3ad4186e4caed0$export$b06a2a6195c06efc] * v[$ab3ad4186e4caed0$export$f2a5a7bac7258e1] * v[$ab3ad4186e4caed0$export$ab9ff870dfff35f];
        t[$ab3ad4186e4caed0$export$5ef568f270a37e28] = v[$ab3ad4186e4caed0$export$99d2679d75e60dc2] * v[$ab3ad4186e4caed0$export$f2a5a7bac7258e1] * v[$ab3ad4186e4caed0$export$f962d36842749298] - v[$ab3ad4186e4caed0$export$5ae52f682687d620] * v[$ab3ad4186e4caed0$export$92c05cfba9c4af26] * v[$ab3ad4186e4caed0$export$f962d36842749298] - v[$ab3ad4186e4caed0$export$99d2679d75e60dc2] * v[$ab3ad4186e4caed0$export$585a161a9f77f349] * v[$ab3ad4186e4caed0$export$82895316122b6751] + v[$ab3ad4186e4caed0$export$b06a2a6195c06efc] * v[$ab3ad4186e4caed0$export$92c05cfba9c4af26] * v[$ab3ad4186e4caed0$export$82895316122b6751] + v[$ab3ad4186e4caed0$export$5ae52f682687d620] * v[$ab3ad4186e4caed0$export$585a161a9f77f349] * v[$ab3ad4186e4caed0$export$5ef568f270a37e28] - v[$ab3ad4186e4caed0$export$b06a2a6195c06efc] * v[$ab3ad4186e4caed0$export$f2a5a7bac7258e1] * v[$ab3ad4186e4caed0$export$5ef568f270a37e28];
        t[$ab3ad4186e4caed0$export$bc0cebc6a0427364] = v[$ab3ad4186e4caed0$export$b9223c25c7ef9657] * v[$ab3ad4186e4caed0$export$82895316122b6751] * v[$ab3ad4186e4caed0$export$bc0cebc6a0427364] - v[$ab3ad4186e4caed0$export$f2a5a7bac7258e1] * v[$ab3ad4186e4caed0$export$4bbf13e387a5a72d] * v[$ab3ad4186e4caed0$export$bc0cebc6a0427364] - v[$ab3ad4186e4caed0$export$b9223c25c7ef9657] * v[$ab3ad4186e4caed0$export$f962d36842749298] * v[$ab3ad4186e4caed0$export$dc2c5fe5c845d994] + v[$ab3ad4186e4caed0$export$585a161a9f77f349] * v[$ab3ad4186e4caed0$export$4bbf13e387a5a72d] * v[$ab3ad4186e4caed0$export$dc2c5fe5c845d994] + v[$ab3ad4186e4caed0$export$f2a5a7bac7258e1] * v[$ab3ad4186e4caed0$export$f962d36842749298] * v[$ab3ad4186e4caed0$export$f6ad99760c0e8d51] - v[$ab3ad4186e4caed0$export$585a161a9f77f349] * v[$ab3ad4186e4caed0$export$82895316122b6751] * v[$ab3ad4186e4caed0$export$f6ad99760c0e8d51];
        t[$ab3ad4186e4caed0$export$dc2c5fe5c845d994] = v[$ab3ad4186e4caed0$export$5ae52f682687d620] * v[$ab3ad4186e4caed0$export$4bbf13e387a5a72d] * v[$ab3ad4186e4caed0$export$bc0cebc6a0427364] - v[$ab3ad4186e4caed0$export$91e90b05312755fb] * v[$ab3ad4186e4caed0$export$82895316122b6751] * v[$ab3ad4186e4caed0$export$bc0cebc6a0427364] + v[$ab3ad4186e4caed0$export$91e90b05312755fb] * v[$ab3ad4186e4caed0$export$f962d36842749298] * v[$ab3ad4186e4caed0$export$dc2c5fe5c845d994] - v[$ab3ad4186e4caed0$export$b06a2a6195c06efc] * v[$ab3ad4186e4caed0$export$4bbf13e387a5a72d] * v[$ab3ad4186e4caed0$export$dc2c5fe5c845d994] - v[$ab3ad4186e4caed0$export$5ae52f682687d620] * v[$ab3ad4186e4caed0$export$f962d36842749298] * v[$ab3ad4186e4caed0$export$f6ad99760c0e8d51] + v[$ab3ad4186e4caed0$export$b06a2a6195c06efc] * v[$ab3ad4186e4caed0$export$82895316122b6751] * v[$ab3ad4186e4caed0$export$f6ad99760c0e8d51];
        t[$ab3ad4186e4caed0$export$f6ad99760c0e8d51] = v[$ab3ad4186e4caed0$export$91e90b05312755fb] * v[$ab3ad4186e4caed0$export$f2a5a7bac7258e1] * v[$ab3ad4186e4caed0$export$bc0cebc6a0427364] - v[$ab3ad4186e4caed0$export$5ae52f682687d620] * v[$ab3ad4186e4caed0$export$b9223c25c7ef9657] * v[$ab3ad4186e4caed0$export$bc0cebc6a0427364] - v[$ab3ad4186e4caed0$export$91e90b05312755fb] * v[$ab3ad4186e4caed0$export$585a161a9f77f349] * v[$ab3ad4186e4caed0$export$dc2c5fe5c845d994] + v[$ab3ad4186e4caed0$export$b06a2a6195c06efc] * v[$ab3ad4186e4caed0$export$b9223c25c7ef9657] * v[$ab3ad4186e4caed0$export$dc2c5fe5c845d994] + v[$ab3ad4186e4caed0$export$5ae52f682687d620] * v[$ab3ad4186e4caed0$export$585a161a9f77f349] * v[$ab3ad4186e4caed0$export$f6ad99760c0e8d51] - v[$ab3ad4186e4caed0$export$b06a2a6195c06efc] * v[$ab3ad4186e4caed0$export$f2a5a7bac7258e1] * v[$ab3ad4186e4caed0$export$f6ad99760c0e8d51];
        t[$ab3ad4186e4caed0$export$ab9ff870dfff35f] = v[$ab3ad4186e4caed0$export$5ae52f682687d620] * v[$ab3ad4186e4caed0$export$b9223c25c7ef9657] * v[$ab3ad4186e4caed0$export$f962d36842749298] - v[$ab3ad4186e4caed0$export$91e90b05312755fb] * v[$ab3ad4186e4caed0$export$f2a5a7bac7258e1] * v[$ab3ad4186e4caed0$export$f962d36842749298] + v[$ab3ad4186e4caed0$export$91e90b05312755fb] * v[$ab3ad4186e4caed0$export$585a161a9f77f349] * v[$ab3ad4186e4caed0$export$82895316122b6751] - v[$ab3ad4186e4caed0$export$b06a2a6195c06efc] * v[$ab3ad4186e4caed0$export$b9223c25c7ef9657] * v[$ab3ad4186e4caed0$export$82895316122b6751] - v[$ab3ad4186e4caed0$export$5ae52f682687d620] * v[$ab3ad4186e4caed0$export$585a161a9f77f349] * v[$ab3ad4186e4caed0$export$4bbf13e387a5a72d] + v[$ab3ad4186e4caed0$export$b06a2a6195c06efc] * v[$ab3ad4186e4caed0$export$f2a5a7bac7258e1] * v[$ab3ad4186e4caed0$export$4bbf13e387a5a72d];
        v[$ab3ad4186e4caed0$export$b06a2a6195c06efc] = t[$ab3ad4186e4caed0$export$b06a2a6195c06efc] * inv_det;
        v[$ab3ad4186e4caed0$export$5ae52f682687d620] = t[$ab3ad4186e4caed0$export$5ae52f682687d620] * inv_det;
        v[$ab3ad4186e4caed0$export$91e90b05312755fb] = t[$ab3ad4186e4caed0$export$91e90b05312755fb] * inv_det;
        v[$ab3ad4186e4caed0$export$99d2679d75e60dc2] = t[$ab3ad4186e4caed0$export$99d2679d75e60dc2] * inv_det;
        v[$ab3ad4186e4caed0$export$585a161a9f77f349] = t[$ab3ad4186e4caed0$export$585a161a9f77f349] * inv_det;
        v[$ab3ad4186e4caed0$export$f2a5a7bac7258e1] = t[$ab3ad4186e4caed0$export$f2a5a7bac7258e1] * inv_det;
        v[$ab3ad4186e4caed0$export$b9223c25c7ef9657] = t[$ab3ad4186e4caed0$export$b9223c25c7ef9657] * inv_det;
        v[$ab3ad4186e4caed0$export$92c05cfba9c4af26] = t[$ab3ad4186e4caed0$export$92c05cfba9c4af26] * inv_det;
        v[$ab3ad4186e4caed0$export$f962d36842749298] = t[$ab3ad4186e4caed0$export$f962d36842749298] * inv_det;
        v[$ab3ad4186e4caed0$export$82895316122b6751] = t[$ab3ad4186e4caed0$export$82895316122b6751] * inv_det;
        v[$ab3ad4186e4caed0$export$4bbf13e387a5a72d] = t[$ab3ad4186e4caed0$export$4bbf13e387a5a72d] * inv_det;
        v[$ab3ad4186e4caed0$export$5ef568f270a37e28] = t[$ab3ad4186e4caed0$export$5ef568f270a37e28] * inv_det;
        v[$ab3ad4186e4caed0$export$bc0cebc6a0427364] = t[$ab3ad4186e4caed0$export$bc0cebc6a0427364] * inv_det;
        v[$ab3ad4186e4caed0$export$dc2c5fe5c845d994] = t[$ab3ad4186e4caed0$export$dc2c5fe5c845d994] * inv_det;
        v[$ab3ad4186e4caed0$export$f6ad99760c0e8d51] = t[$ab3ad4186e4caed0$export$f6ad99760c0e8d51] * inv_det;
        v[$ab3ad4186e4caed0$export$ab9ff870dfff35f] = t[$ab3ad4186e4caed0$export$ab9ff870dfff35f] * inv_det;
        return this;
    }
    determinant() {
        let v = this.values;
        return v[$ab3ad4186e4caed0$export$bc0cebc6a0427364] * v[$ab3ad4186e4caed0$export$82895316122b6751] * v[$ab3ad4186e4caed0$export$b9223c25c7ef9657] * v[$ab3ad4186e4caed0$export$99d2679d75e60dc2] - v[$ab3ad4186e4caed0$export$f962d36842749298] * v[$ab3ad4186e4caed0$export$dc2c5fe5c845d994] * v[$ab3ad4186e4caed0$export$b9223c25c7ef9657] * v[$ab3ad4186e4caed0$export$99d2679d75e60dc2] - v[$ab3ad4186e4caed0$export$bc0cebc6a0427364] * v[$ab3ad4186e4caed0$export$f2a5a7bac7258e1] * v[$ab3ad4186e4caed0$export$4bbf13e387a5a72d] * v[$ab3ad4186e4caed0$export$99d2679d75e60dc2] + v[$ab3ad4186e4caed0$export$585a161a9f77f349] * v[$ab3ad4186e4caed0$export$dc2c5fe5c845d994] * v[$ab3ad4186e4caed0$export$4bbf13e387a5a72d] * v[$ab3ad4186e4caed0$export$99d2679d75e60dc2] + v[$ab3ad4186e4caed0$export$f962d36842749298] * v[$ab3ad4186e4caed0$export$f2a5a7bac7258e1] * v[$ab3ad4186e4caed0$export$f6ad99760c0e8d51] * v[$ab3ad4186e4caed0$export$99d2679d75e60dc2] - v[$ab3ad4186e4caed0$export$585a161a9f77f349] * v[$ab3ad4186e4caed0$export$82895316122b6751] * v[$ab3ad4186e4caed0$export$f6ad99760c0e8d51] * v[$ab3ad4186e4caed0$export$99d2679d75e60dc2] - v[$ab3ad4186e4caed0$export$bc0cebc6a0427364] * v[$ab3ad4186e4caed0$export$82895316122b6751] * v[$ab3ad4186e4caed0$export$91e90b05312755fb] * v[$ab3ad4186e4caed0$export$92c05cfba9c4af26] + v[$ab3ad4186e4caed0$export$f962d36842749298] * v[$ab3ad4186e4caed0$export$dc2c5fe5c845d994] * v[$ab3ad4186e4caed0$export$91e90b05312755fb] * v[$ab3ad4186e4caed0$export$92c05cfba9c4af26] + v[$ab3ad4186e4caed0$export$bc0cebc6a0427364] * v[$ab3ad4186e4caed0$export$5ae52f682687d620] * v[$ab3ad4186e4caed0$export$4bbf13e387a5a72d] * v[$ab3ad4186e4caed0$export$92c05cfba9c4af26] - v[$ab3ad4186e4caed0$export$b06a2a6195c06efc] * v[$ab3ad4186e4caed0$export$dc2c5fe5c845d994] * v[$ab3ad4186e4caed0$export$4bbf13e387a5a72d] * v[$ab3ad4186e4caed0$export$92c05cfba9c4af26] - v[$ab3ad4186e4caed0$export$f962d36842749298] * v[$ab3ad4186e4caed0$export$5ae52f682687d620] * v[$ab3ad4186e4caed0$export$f6ad99760c0e8d51] * v[$ab3ad4186e4caed0$export$92c05cfba9c4af26] + v[$ab3ad4186e4caed0$export$b06a2a6195c06efc] * v[$ab3ad4186e4caed0$export$82895316122b6751] * v[$ab3ad4186e4caed0$export$f6ad99760c0e8d51] * v[$ab3ad4186e4caed0$export$92c05cfba9c4af26] + v[$ab3ad4186e4caed0$export$bc0cebc6a0427364] * v[$ab3ad4186e4caed0$export$f2a5a7bac7258e1] * v[$ab3ad4186e4caed0$export$91e90b05312755fb] * v[$ab3ad4186e4caed0$export$5ef568f270a37e28] - v[$ab3ad4186e4caed0$export$585a161a9f77f349] * v[$ab3ad4186e4caed0$export$dc2c5fe5c845d994] * v[$ab3ad4186e4caed0$export$91e90b05312755fb] * v[$ab3ad4186e4caed0$export$5ef568f270a37e28] - v[$ab3ad4186e4caed0$export$bc0cebc6a0427364] * v[$ab3ad4186e4caed0$export$5ae52f682687d620] * v[$ab3ad4186e4caed0$export$b9223c25c7ef9657] * v[$ab3ad4186e4caed0$export$5ef568f270a37e28] + v[$ab3ad4186e4caed0$export$b06a2a6195c06efc] * v[$ab3ad4186e4caed0$export$dc2c5fe5c845d994] * v[$ab3ad4186e4caed0$export$b9223c25c7ef9657] * v[$ab3ad4186e4caed0$export$5ef568f270a37e28] + v[$ab3ad4186e4caed0$export$585a161a9f77f349] * v[$ab3ad4186e4caed0$export$5ae52f682687d620] * v[$ab3ad4186e4caed0$export$f6ad99760c0e8d51] * v[$ab3ad4186e4caed0$export$5ef568f270a37e28] - v[$ab3ad4186e4caed0$export$b06a2a6195c06efc] * v[$ab3ad4186e4caed0$export$f2a5a7bac7258e1] * v[$ab3ad4186e4caed0$export$f6ad99760c0e8d51] * v[$ab3ad4186e4caed0$export$5ef568f270a37e28] - v[$ab3ad4186e4caed0$export$f962d36842749298] * v[$ab3ad4186e4caed0$export$f2a5a7bac7258e1] * v[$ab3ad4186e4caed0$export$91e90b05312755fb] * v[$ab3ad4186e4caed0$export$ab9ff870dfff35f] + v[$ab3ad4186e4caed0$export$585a161a9f77f349] * v[$ab3ad4186e4caed0$export$82895316122b6751] * v[$ab3ad4186e4caed0$export$91e90b05312755fb] * v[$ab3ad4186e4caed0$export$ab9ff870dfff35f] + v[$ab3ad4186e4caed0$export$f962d36842749298] * v[$ab3ad4186e4caed0$export$5ae52f682687d620] * v[$ab3ad4186e4caed0$export$b9223c25c7ef9657] * v[$ab3ad4186e4caed0$export$ab9ff870dfff35f] - v[$ab3ad4186e4caed0$export$b06a2a6195c06efc] * v[$ab3ad4186e4caed0$export$82895316122b6751] * v[$ab3ad4186e4caed0$export$b9223c25c7ef9657] * v[$ab3ad4186e4caed0$export$ab9ff870dfff35f] - v[$ab3ad4186e4caed0$export$585a161a9f77f349] * v[$ab3ad4186e4caed0$export$5ae52f682687d620] * v[$ab3ad4186e4caed0$export$4bbf13e387a5a72d] * v[$ab3ad4186e4caed0$export$ab9ff870dfff35f] + v[$ab3ad4186e4caed0$export$b06a2a6195c06efc] * v[$ab3ad4186e4caed0$export$f2a5a7bac7258e1] * v[$ab3ad4186e4caed0$export$4bbf13e387a5a72d] * v[$ab3ad4186e4caed0$export$ab9ff870dfff35f];
    }
    translate(x, y, z) {
        let v = this.values;
        v[$ab3ad4186e4caed0$export$99d2679d75e60dc2] += x;
        v[$ab3ad4186e4caed0$export$92c05cfba9c4af26] += y;
        v[$ab3ad4186e4caed0$export$5ef568f270a37e28] += z;
        return this;
    }
    copy() {
        return new $ab3ad4186e4caed0$export$2ae72fc923e5eb5().set(this.values);
    }
    projection(near, far, fovy, aspectRatio) {
        this.identity();
        let l_fd = 1.0 / Math.tan(fovy * (Math.PI / 180) / 2.0);
        let l_a1 = (far + near) / (near - far);
        let l_a2 = 2 * far * near / (near - far);
        let v = this.values;
        v[$ab3ad4186e4caed0$export$b06a2a6195c06efc] = l_fd / aspectRatio;
        v[$ab3ad4186e4caed0$export$585a161a9f77f349] = 0;
        v[$ab3ad4186e4caed0$export$f962d36842749298] = 0;
        v[$ab3ad4186e4caed0$export$bc0cebc6a0427364] = 0;
        v[$ab3ad4186e4caed0$export$5ae52f682687d620] = 0;
        v[$ab3ad4186e4caed0$export$f2a5a7bac7258e1] = l_fd;
        v[$ab3ad4186e4caed0$export$82895316122b6751] = 0;
        v[$ab3ad4186e4caed0$export$dc2c5fe5c845d994] = 0;
        v[$ab3ad4186e4caed0$export$91e90b05312755fb] = 0;
        v[$ab3ad4186e4caed0$export$b9223c25c7ef9657] = 0;
        v[$ab3ad4186e4caed0$export$4bbf13e387a5a72d] = l_a1;
        v[$ab3ad4186e4caed0$export$f6ad99760c0e8d51] = -1;
        v[$ab3ad4186e4caed0$export$99d2679d75e60dc2] = 0;
        v[$ab3ad4186e4caed0$export$92c05cfba9c4af26] = 0;
        v[$ab3ad4186e4caed0$export$5ef568f270a37e28] = l_a2;
        v[$ab3ad4186e4caed0$export$ab9ff870dfff35f] = 0;
        return this;
    }
    ortho2d(x, y, width, height) {
        return this.ortho(x, x + width, y, y + height, 0, 1);
    }
    ortho(left, right, bottom, top, near, far) {
        this.identity();
        let x_orth = 2 / (right - left);
        let y_orth = 2 / (top - bottom);
        let z_orth = -2 / (far - near);
        let tx = -(right + left) / (right - left);
        let ty = -(top + bottom) / (top - bottom);
        let tz = -(far + near) / (far - near);
        let v = this.values;
        v[$ab3ad4186e4caed0$export$b06a2a6195c06efc] = x_orth;
        v[$ab3ad4186e4caed0$export$585a161a9f77f349] = 0;
        v[$ab3ad4186e4caed0$export$f962d36842749298] = 0;
        v[$ab3ad4186e4caed0$export$bc0cebc6a0427364] = 0;
        v[$ab3ad4186e4caed0$export$5ae52f682687d620] = 0;
        v[$ab3ad4186e4caed0$export$f2a5a7bac7258e1] = y_orth;
        v[$ab3ad4186e4caed0$export$82895316122b6751] = 0;
        v[$ab3ad4186e4caed0$export$dc2c5fe5c845d994] = 0;
        v[$ab3ad4186e4caed0$export$91e90b05312755fb] = 0;
        v[$ab3ad4186e4caed0$export$b9223c25c7ef9657] = 0;
        v[$ab3ad4186e4caed0$export$4bbf13e387a5a72d] = z_orth;
        v[$ab3ad4186e4caed0$export$f6ad99760c0e8d51] = 0;
        v[$ab3ad4186e4caed0$export$99d2679d75e60dc2] = tx;
        v[$ab3ad4186e4caed0$export$92c05cfba9c4af26] = ty;
        v[$ab3ad4186e4caed0$export$5ef568f270a37e28] = tz;
        v[$ab3ad4186e4caed0$export$ab9ff870dfff35f] = 1;
        return this;
    }
    multiply(matrix) {
        let t = this.temp;
        let v = this.values;
        let m = matrix.values;
        t[$ab3ad4186e4caed0$export$b06a2a6195c06efc] = v[$ab3ad4186e4caed0$export$b06a2a6195c06efc] * m[$ab3ad4186e4caed0$export$b06a2a6195c06efc] + v[$ab3ad4186e4caed0$export$5ae52f682687d620] * m[$ab3ad4186e4caed0$export$585a161a9f77f349] + v[$ab3ad4186e4caed0$export$91e90b05312755fb] * m[$ab3ad4186e4caed0$export$f962d36842749298] + v[$ab3ad4186e4caed0$export$99d2679d75e60dc2] * m[$ab3ad4186e4caed0$export$bc0cebc6a0427364];
        t[$ab3ad4186e4caed0$export$5ae52f682687d620] = v[$ab3ad4186e4caed0$export$b06a2a6195c06efc] * m[$ab3ad4186e4caed0$export$5ae52f682687d620] + v[$ab3ad4186e4caed0$export$5ae52f682687d620] * m[$ab3ad4186e4caed0$export$f2a5a7bac7258e1] + v[$ab3ad4186e4caed0$export$91e90b05312755fb] * m[$ab3ad4186e4caed0$export$82895316122b6751] + v[$ab3ad4186e4caed0$export$99d2679d75e60dc2] * m[$ab3ad4186e4caed0$export$dc2c5fe5c845d994];
        t[$ab3ad4186e4caed0$export$91e90b05312755fb] = v[$ab3ad4186e4caed0$export$b06a2a6195c06efc] * m[$ab3ad4186e4caed0$export$91e90b05312755fb] + v[$ab3ad4186e4caed0$export$5ae52f682687d620] * m[$ab3ad4186e4caed0$export$b9223c25c7ef9657] + v[$ab3ad4186e4caed0$export$91e90b05312755fb] * m[$ab3ad4186e4caed0$export$4bbf13e387a5a72d] + v[$ab3ad4186e4caed0$export$99d2679d75e60dc2] * m[$ab3ad4186e4caed0$export$f6ad99760c0e8d51];
        t[$ab3ad4186e4caed0$export$99d2679d75e60dc2] = v[$ab3ad4186e4caed0$export$b06a2a6195c06efc] * m[$ab3ad4186e4caed0$export$99d2679d75e60dc2] + v[$ab3ad4186e4caed0$export$5ae52f682687d620] * m[$ab3ad4186e4caed0$export$92c05cfba9c4af26] + v[$ab3ad4186e4caed0$export$91e90b05312755fb] * m[$ab3ad4186e4caed0$export$5ef568f270a37e28] + v[$ab3ad4186e4caed0$export$99d2679d75e60dc2] * m[$ab3ad4186e4caed0$export$ab9ff870dfff35f];
        t[$ab3ad4186e4caed0$export$585a161a9f77f349] = v[$ab3ad4186e4caed0$export$585a161a9f77f349] * m[$ab3ad4186e4caed0$export$b06a2a6195c06efc] + v[$ab3ad4186e4caed0$export$f2a5a7bac7258e1] * m[$ab3ad4186e4caed0$export$585a161a9f77f349] + v[$ab3ad4186e4caed0$export$b9223c25c7ef9657] * m[$ab3ad4186e4caed0$export$f962d36842749298] + v[$ab3ad4186e4caed0$export$92c05cfba9c4af26] * m[$ab3ad4186e4caed0$export$bc0cebc6a0427364];
        t[$ab3ad4186e4caed0$export$f2a5a7bac7258e1] = v[$ab3ad4186e4caed0$export$585a161a9f77f349] * m[$ab3ad4186e4caed0$export$5ae52f682687d620] + v[$ab3ad4186e4caed0$export$f2a5a7bac7258e1] * m[$ab3ad4186e4caed0$export$f2a5a7bac7258e1] + v[$ab3ad4186e4caed0$export$b9223c25c7ef9657] * m[$ab3ad4186e4caed0$export$82895316122b6751] + v[$ab3ad4186e4caed0$export$92c05cfba9c4af26] * m[$ab3ad4186e4caed0$export$dc2c5fe5c845d994];
        t[$ab3ad4186e4caed0$export$b9223c25c7ef9657] = v[$ab3ad4186e4caed0$export$585a161a9f77f349] * m[$ab3ad4186e4caed0$export$91e90b05312755fb] + v[$ab3ad4186e4caed0$export$f2a5a7bac7258e1] * m[$ab3ad4186e4caed0$export$b9223c25c7ef9657] + v[$ab3ad4186e4caed0$export$b9223c25c7ef9657] * m[$ab3ad4186e4caed0$export$4bbf13e387a5a72d] + v[$ab3ad4186e4caed0$export$92c05cfba9c4af26] * m[$ab3ad4186e4caed0$export$f6ad99760c0e8d51];
        t[$ab3ad4186e4caed0$export$92c05cfba9c4af26] = v[$ab3ad4186e4caed0$export$585a161a9f77f349] * m[$ab3ad4186e4caed0$export$99d2679d75e60dc2] + v[$ab3ad4186e4caed0$export$f2a5a7bac7258e1] * m[$ab3ad4186e4caed0$export$92c05cfba9c4af26] + v[$ab3ad4186e4caed0$export$b9223c25c7ef9657] * m[$ab3ad4186e4caed0$export$5ef568f270a37e28] + v[$ab3ad4186e4caed0$export$92c05cfba9c4af26] * m[$ab3ad4186e4caed0$export$ab9ff870dfff35f];
        t[$ab3ad4186e4caed0$export$f962d36842749298] = v[$ab3ad4186e4caed0$export$f962d36842749298] * m[$ab3ad4186e4caed0$export$b06a2a6195c06efc] + v[$ab3ad4186e4caed0$export$82895316122b6751] * m[$ab3ad4186e4caed0$export$585a161a9f77f349] + v[$ab3ad4186e4caed0$export$4bbf13e387a5a72d] * m[$ab3ad4186e4caed0$export$f962d36842749298] + v[$ab3ad4186e4caed0$export$5ef568f270a37e28] * m[$ab3ad4186e4caed0$export$bc0cebc6a0427364];
        t[$ab3ad4186e4caed0$export$82895316122b6751] = v[$ab3ad4186e4caed0$export$f962d36842749298] * m[$ab3ad4186e4caed0$export$5ae52f682687d620] + v[$ab3ad4186e4caed0$export$82895316122b6751] * m[$ab3ad4186e4caed0$export$f2a5a7bac7258e1] + v[$ab3ad4186e4caed0$export$4bbf13e387a5a72d] * m[$ab3ad4186e4caed0$export$82895316122b6751] + v[$ab3ad4186e4caed0$export$5ef568f270a37e28] * m[$ab3ad4186e4caed0$export$dc2c5fe5c845d994];
        t[$ab3ad4186e4caed0$export$4bbf13e387a5a72d] = v[$ab3ad4186e4caed0$export$f962d36842749298] * m[$ab3ad4186e4caed0$export$91e90b05312755fb] + v[$ab3ad4186e4caed0$export$82895316122b6751] * m[$ab3ad4186e4caed0$export$b9223c25c7ef9657] + v[$ab3ad4186e4caed0$export$4bbf13e387a5a72d] * m[$ab3ad4186e4caed0$export$4bbf13e387a5a72d] + v[$ab3ad4186e4caed0$export$5ef568f270a37e28] * m[$ab3ad4186e4caed0$export$f6ad99760c0e8d51];
        t[$ab3ad4186e4caed0$export$5ef568f270a37e28] = v[$ab3ad4186e4caed0$export$f962d36842749298] * m[$ab3ad4186e4caed0$export$99d2679d75e60dc2] + v[$ab3ad4186e4caed0$export$82895316122b6751] * m[$ab3ad4186e4caed0$export$92c05cfba9c4af26] + v[$ab3ad4186e4caed0$export$4bbf13e387a5a72d] * m[$ab3ad4186e4caed0$export$5ef568f270a37e28] + v[$ab3ad4186e4caed0$export$5ef568f270a37e28] * m[$ab3ad4186e4caed0$export$ab9ff870dfff35f];
        t[$ab3ad4186e4caed0$export$bc0cebc6a0427364] = v[$ab3ad4186e4caed0$export$bc0cebc6a0427364] * m[$ab3ad4186e4caed0$export$b06a2a6195c06efc] + v[$ab3ad4186e4caed0$export$dc2c5fe5c845d994] * m[$ab3ad4186e4caed0$export$585a161a9f77f349] + v[$ab3ad4186e4caed0$export$f6ad99760c0e8d51] * m[$ab3ad4186e4caed0$export$f962d36842749298] + v[$ab3ad4186e4caed0$export$ab9ff870dfff35f] * m[$ab3ad4186e4caed0$export$bc0cebc6a0427364];
        t[$ab3ad4186e4caed0$export$dc2c5fe5c845d994] = v[$ab3ad4186e4caed0$export$bc0cebc6a0427364] * m[$ab3ad4186e4caed0$export$5ae52f682687d620] + v[$ab3ad4186e4caed0$export$dc2c5fe5c845d994] * m[$ab3ad4186e4caed0$export$f2a5a7bac7258e1] + v[$ab3ad4186e4caed0$export$f6ad99760c0e8d51] * m[$ab3ad4186e4caed0$export$82895316122b6751] + v[$ab3ad4186e4caed0$export$ab9ff870dfff35f] * m[$ab3ad4186e4caed0$export$dc2c5fe5c845d994];
        t[$ab3ad4186e4caed0$export$f6ad99760c0e8d51] = v[$ab3ad4186e4caed0$export$bc0cebc6a0427364] * m[$ab3ad4186e4caed0$export$91e90b05312755fb] + v[$ab3ad4186e4caed0$export$dc2c5fe5c845d994] * m[$ab3ad4186e4caed0$export$b9223c25c7ef9657] + v[$ab3ad4186e4caed0$export$f6ad99760c0e8d51] * m[$ab3ad4186e4caed0$export$4bbf13e387a5a72d] + v[$ab3ad4186e4caed0$export$ab9ff870dfff35f] * m[$ab3ad4186e4caed0$export$f6ad99760c0e8d51];
        t[$ab3ad4186e4caed0$export$ab9ff870dfff35f] = v[$ab3ad4186e4caed0$export$bc0cebc6a0427364] * m[$ab3ad4186e4caed0$export$99d2679d75e60dc2] + v[$ab3ad4186e4caed0$export$dc2c5fe5c845d994] * m[$ab3ad4186e4caed0$export$92c05cfba9c4af26] + v[$ab3ad4186e4caed0$export$f6ad99760c0e8d51] * m[$ab3ad4186e4caed0$export$5ef568f270a37e28] + v[$ab3ad4186e4caed0$export$ab9ff870dfff35f] * m[$ab3ad4186e4caed0$export$ab9ff870dfff35f];
        return this.set(this.temp);
    }
    multiplyLeft(matrix) {
        let t = this.temp;
        let v = this.values;
        let m = matrix.values;
        t[$ab3ad4186e4caed0$export$b06a2a6195c06efc] = m[$ab3ad4186e4caed0$export$b06a2a6195c06efc] * v[$ab3ad4186e4caed0$export$b06a2a6195c06efc] + m[$ab3ad4186e4caed0$export$5ae52f682687d620] * v[$ab3ad4186e4caed0$export$585a161a9f77f349] + m[$ab3ad4186e4caed0$export$91e90b05312755fb] * v[$ab3ad4186e4caed0$export$f962d36842749298] + m[$ab3ad4186e4caed0$export$99d2679d75e60dc2] * v[$ab3ad4186e4caed0$export$bc0cebc6a0427364];
        t[$ab3ad4186e4caed0$export$5ae52f682687d620] = m[$ab3ad4186e4caed0$export$b06a2a6195c06efc] * v[$ab3ad4186e4caed0$export$5ae52f682687d620] + m[$ab3ad4186e4caed0$export$5ae52f682687d620] * v[$ab3ad4186e4caed0$export$f2a5a7bac7258e1] + m[$ab3ad4186e4caed0$export$91e90b05312755fb] * v[$ab3ad4186e4caed0$export$82895316122b6751] + m[$ab3ad4186e4caed0$export$99d2679d75e60dc2] * v[$ab3ad4186e4caed0$export$dc2c5fe5c845d994];
        t[$ab3ad4186e4caed0$export$91e90b05312755fb] = m[$ab3ad4186e4caed0$export$b06a2a6195c06efc] * v[$ab3ad4186e4caed0$export$91e90b05312755fb] + m[$ab3ad4186e4caed0$export$5ae52f682687d620] * v[$ab3ad4186e4caed0$export$b9223c25c7ef9657] + m[$ab3ad4186e4caed0$export$91e90b05312755fb] * v[$ab3ad4186e4caed0$export$4bbf13e387a5a72d] + m[$ab3ad4186e4caed0$export$99d2679d75e60dc2] * v[$ab3ad4186e4caed0$export$f6ad99760c0e8d51];
        t[$ab3ad4186e4caed0$export$99d2679d75e60dc2] = m[$ab3ad4186e4caed0$export$b06a2a6195c06efc] * v[$ab3ad4186e4caed0$export$99d2679d75e60dc2] + m[$ab3ad4186e4caed0$export$5ae52f682687d620] * v[$ab3ad4186e4caed0$export$92c05cfba9c4af26] + m[$ab3ad4186e4caed0$export$91e90b05312755fb] * v[$ab3ad4186e4caed0$export$5ef568f270a37e28] + m[$ab3ad4186e4caed0$export$99d2679d75e60dc2] * v[$ab3ad4186e4caed0$export$ab9ff870dfff35f];
        t[$ab3ad4186e4caed0$export$585a161a9f77f349] = m[$ab3ad4186e4caed0$export$585a161a9f77f349] * v[$ab3ad4186e4caed0$export$b06a2a6195c06efc] + m[$ab3ad4186e4caed0$export$f2a5a7bac7258e1] * v[$ab3ad4186e4caed0$export$585a161a9f77f349] + m[$ab3ad4186e4caed0$export$b9223c25c7ef9657] * v[$ab3ad4186e4caed0$export$f962d36842749298] + m[$ab3ad4186e4caed0$export$92c05cfba9c4af26] * v[$ab3ad4186e4caed0$export$bc0cebc6a0427364];
        t[$ab3ad4186e4caed0$export$f2a5a7bac7258e1] = m[$ab3ad4186e4caed0$export$585a161a9f77f349] * v[$ab3ad4186e4caed0$export$5ae52f682687d620] + m[$ab3ad4186e4caed0$export$f2a5a7bac7258e1] * v[$ab3ad4186e4caed0$export$f2a5a7bac7258e1] + m[$ab3ad4186e4caed0$export$b9223c25c7ef9657] * v[$ab3ad4186e4caed0$export$82895316122b6751] + m[$ab3ad4186e4caed0$export$92c05cfba9c4af26] * v[$ab3ad4186e4caed0$export$dc2c5fe5c845d994];
        t[$ab3ad4186e4caed0$export$b9223c25c7ef9657] = m[$ab3ad4186e4caed0$export$585a161a9f77f349] * v[$ab3ad4186e4caed0$export$91e90b05312755fb] + m[$ab3ad4186e4caed0$export$f2a5a7bac7258e1] * v[$ab3ad4186e4caed0$export$b9223c25c7ef9657] + m[$ab3ad4186e4caed0$export$b9223c25c7ef9657] * v[$ab3ad4186e4caed0$export$4bbf13e387a5a72d] + m[$ab3ad4186e4caed0$export$92c05cfba9c4af26] * v[$ab3ad4186e4caed0$export$f6ad99760c0e8d51];
        t[$ab3ad4186e4caed0$export$92c05cfba9c4af26] = m[$ab3ad4186e4caed0$export$585a161a9f77f349] * v[$ab3ad4186e4caed0$export$99d2679d75e60dc2] + m[$ab3ad4186e4caed0$export$f2a5a7bac7258e1] * v[$ab3ad4186e4caed0$export$92c05cfba9c4af26] + m[$ab3ad4186e4caed0$export$b9223c25c7ef9657] * v[$ab3ad4186e4caed0$export$5ef568f270a37e28] + m[$ab3ad4186e4caed0$export$92c05cfba9c4af26] * v[$ab3ad4186e4caed0$export$ab9ff870dfff35f];
        t[$ab3ad4186e4caed0$export$f962d36842749298] = m[$ab3ad4186e4caed0$export$f962d36842749298] * v[$ab3ad4186e4caed0$export$b06a2a6195c06efc] + m[$ab3ad4186e4caed0$export$82895316122b6751] * v[$ab3ad4186e4caed0$export$585a161a9f77f349] + m[$ab3ad4186e4caed0$export$4bbf13e387a5a72d] * v[$ab3ad4186e4caed0$export$f962d36842749298] + m[$ab3ad4186e4caed0$export$5ef568f270a37e28] * v[$ab3ad4186e4caed0$export$bc0cebc6a0427364];
        t[$ab3ad4186e4caed0$export$82895316122b6751] = m[$ab3ad4186e4caed0$export$f962d36842749298] * v[$ab3ad4186e4caed0$export$5ae52f682687d620] + m[$ab3ad4186e4caed0$export$82895316122b6751] * v[$ab3ad4186e4caed0$export$f2a5a7bac7258e1] + m[$ab3ad4186e4caed0$export$4bbf13e387a5a72d] * v[$ab3ad4186e4caed0$export$82895316122b6751] + m[$ab3ad4186e4caed0$export$5ef568f270a37e28] * v[$ab3ad4186e4caed0$export$dc2c5fe5c845d994];
        t[$ab3ad4186e4caed0$export$4bbf13e387a5a72d] = m[$ab3ad4186e4caed0$export$f962d36842749298] * v[$ab3ad4186e4caed0$export$91e90b05312755fb] + m[$ab3ad4186e4caed0$export$82895316122b6751] * v[$ab3ad4186e4caed0$export$b9223c25c7ef9657] + m[$ab3ad4186e4caed0$export$4bbf13e387a5a72d] * v[$ab3ad4186e4caed0$export$4bbf13e387a5a72d] + m[$ab3ad4186e4caed0$export$5ef568f270a37e28] * v[$ab3ad4186e4caed0$export$f6ad99760c0e8d51];
        t[$ab3ad4186e4caed0$export$5ef568f270a37e28] = m[$ab3ad4186e4caed0$export$f962d36842749298] * v[$ab3ad4186e4caed0$export$99d2679d75e60dc2] + m[$ab3ad4186e4caed0$export$82895316122b6751] * v[$ab3ad4186e4caed0$export$92c05cfba9c4af26] + m[$ab3ad4186e4caed0$export$4bbf13e387a5a72d] * v[$ab3ad4186e4caed0$export$5ef568f270a37e28] + m[$ab3ad4186e4caed0$export$5ef568f270a37e28] * v[$ab3ad4186e4caed0$export$ab9ff870dfff35f];
        t[$ab3ad4186e4caed0$export$bc0cebc6a0427364] = m[$ab3ad4186e4caed0$export$bc0cebc6a0427364] * v[$ab3ad4186e4caed0$export$b06a2a6195c06efc] + m[$ab3ad4186e4caed0$export$dc2c5fe5c845d994] * v[$ab3ad4186e4caed0$export$585a161a9f77f349] + m[$ab3ad4186e4caed0$export$f6ad99760c0e8d51] * v[$ab3ad4186e4caed0$export$f962d36842749298] + m[$ab3ad4186e4caed0$export$ab9ff870dfff35f] * v[$ab3ad4186e4caed0$export$bc0cebc6a0427364];
        t[$ab3ad4186e4caed0$export$dc2c5fe5c845d994] = m[$ab3ad4186e4caed0$export$bc0cebc6a0427364] * v[$ab3ad4186e4caed0$export$5ae52f682687d620] + m[$ab3ad4186e4caed0$export$dc2c5fe5c845d994] * v[$ab3ad4186e4caed0$export$f2a5a7bac7258e1] + m[$ab3ad4186e4caed0$export$f6ad99760c0e8d51] * v[$ab3ad4186e4caed0$export$82895316122b6751] + m[$ab3ad4186e4caed0$export$ab9ff870dfff35f] * v[$ab3ad4186e4caed0$export$dc2c5fe5c845d994];
        t[$ab3ad4186e4caed0$export$f6ad99760c0e8d51] = m[$ab3ad4186e4caed0$export$bc0cebc6a0427364] * v[$ab3ad4186e4caed0$export$91e90b05312755fb] + m[$ab3ad4186e4caed0$export$dc2c5fe5c845d994] * v[$ab3ad4186e4caed0$export$b9223c25c7ef9657] + m[$ab3ad4186e4caed0$export$f6ad99760c0e8d51] * v[$ab3ad4186e4caed0$export$4bbf13e387a5a72d] + m[$ab3ad4186e4caed0$export$ab9ff870dfff35f] * v[$ab3ad4186e4caed0$export$f6ad99760c0e8d51];
        t[$ab3ad4186e4caed0$export$ab9ff870dfff35f] = m[$ab3ad4186e4caed0$export$bc0cebc6a0427364] * v[$ab3ad4186e4caed0$export$99d2679d75e60dc2] + m[$ab3ad4186e4caed0$export$dc2c5fe5c845d994] * v[$ab3ad4186e4caed0$export$92c05cfba9c4af26] + m[$ab3ad4186e4caed0$export$f6ad99760c0e8d51] * v[$ab3ad4186e4caed0$export$5ef568f270a37e28] + m[$ab3ad4186e4caed0$export$ab9ff870dfff35f] * v[$ab3ad4186e4caed0$export$ab9ff870dfff35f];
        return this.set(this.temp);
    }
    lookAt(position, direction, up) {
        let xAxis = $ab3ad4186e4caed0$export$2ae72fc923e5eb5.xAxis, yAxis = $ab3ad4186e4caed0$export$2ae72fc923e5eb5.yAxis, zAxis = $ab3ad4186e4caed0$export$2ae72fc923e5eb5.zAxis;
        zAxis.setFrom(direction).normalize();
        xAxis.setFrom(direction).normalize();
        xAxis.cross(up).normalize();
        yAxis.setFrom(xAxis).cross(zAxis).normalize();
        this.identity();
        let val = this.values;
        val[$ab3ad4186e4caed0$export$b06a2a6195c06efc] = xAxis.x;
        val[$ab3ad4186e4caed0$export$5ae52f682687d620] = xAxis.y;
        val[$ab3ad4186e4caed0$export$91e90b05312755fb] = xAxis.z;
        val[$ab3ad4186e4caed0$export$585a161a9f77f349] = yAxis.x;
        val[$ab3ad4186e4caed0$export$f2a5a7bac7258e1] = yAxis.y;
        val[$ab3ad4186e4caed0$export$b9223c25c7ef9657] = yAxis.z;
        val[$ab3ad4186e4caed0$export$f962d36842749298] = -zAxis.x;
        val[$ab3ad4186e4caed0$export$82895316122b6751] = -zAxis.y;
        val[$ab3ad4186e4caed0$export$4bbf13e387a5a72d] = -zAxis.z;
        $ab3ad4186e4caed0$export$2ae72fc923e5eb5.tmpMatrix.identity();
        $ab3ad4186e4caed0$export$2ae72fc923e5eb5.tmpMatrix.values[$ab3ad4186e4caed0$export$99d2679d75e60dc2] = -position.x;
        $ab3ad4186e4caed0$export$2ae72fc923e5eb5.tmpMatrix.values[$ab3ad4186e4caed0$export$92c05cfba9c4af26] = -position.y;
        $ab3ad4186e4caed0$export$2ae72fc923e5eb5.tmpMatrix.values[$ab3ad4186e4caed0$export$5ef568f270a37e28] = -position.z;
        this.multiply($ab3ad4186e4caed0$export$2ae72fc923e5eb5.tmpMatrix);
        return this;
    }
}



class $39edd788f496d3c6$export$b58af824322cf043 {
    position = new (0, $75a60b996df58eed$export$64b5c384219d3699)(0, 0, 0);
    direction = new (0, $75a60b996df58eed$export$64b5c384219d3699)(0, 0, -1);
    up = new (0, $75a60b996df58eed$export$64b5c384219d3699)(0, 1, 0);
    near = 0;
    far = 100;
    zoom = 1;
    viewportWidth = 0;
    viewportHeight = 0;
    projectionView = new (0, $ab3ad4186e4caed0$export$2ae72fc923e5eb5)();
    inverseProjectionView = new (0, $ab3ad4186e4caed0$export$2ae72fc923e5eb5)();
    projection = new (0, $ab3ad4186e4caed0$export$2ae72fc923e5eb5)();
    view = new (0, $ab3ad4186e4caed0$export$2ae72fc923e5eb5)();
    constructor(viewportWidth, viewportHeight){
        this.viewportWidth = viewportWidth;
        this.viewportHeight = viewportHeight;
        this.update();
    }
    update() {
        let projection = this.projection;
        let view = this.view;
        let projectionView = this.projectionView;
        let inverseProjectionView = this.inverseProjectionView;
        let zoom = this.zoom, viewportWidth = this.viewportWidth, viewportHeight = this.viewportHeight;
        projection.ortho(zoom * (-viewportWidth / 2), zoom * (viewportWidth / 2), zoom * (-viewportHeight / 2), zoom * (viewportHeight / 2), this.near, this.far);
        view.lookAt(this.position, this.direction, this.up);
        projectionView.set(projection.values);
        projectionView.multiply(view);
        inverseProjectionView.set(projectionView.values).invert();
    }
    screenToWorld(screenCoords, screenWidth, screenHeight) {
        let x = screenCoords.x, y = screenHeight - screenCoords.y - 1;
        screenCoords.x = 2 * x / screenWidth - 1;
        screenCoords.y = 2 * y / screenHeight - 1;
        screenCoords.z = 2 * screenCoords.z - 1;
        screenCoords.project(this.inverseProjectionView);
        return screenCoords;
    }
    worldToScreen(worldCoords, screenWidth, screenHeight) {
        worldCoords.project(this.projectionView);
        worldCoords.x = screenWidth * (worldCoords.x + 1) / 2;
        worldCoords.y = screenHeight * (worldCoords.y + 1) / 2;
        worldCoords.z = (worldCoords.z + 1) / 2;
        return worldCoords;
    }
    setViewport(viewportWidth, viewportHeight) {
        this.viewportWidth = viewportWidth;
        this.viewportHeight = viewportHeight;
    }
}


/******************************************************************************
 * Spine Runtimes License Agreement
 * Last updated July 28, 2023. Replaces all prior versions.
 *
 * Copyright (c) 2013-2023, Esoteric Software LLC
 *
 * Integration of the Spine Runtimes into software or otherwise creating
 * derivative works of the Spine Runtimes is permitted under the terms and
 * conditions of Section 2 of the Spine Editor License Agreement:
 * http://esotericsoftware.com/spine-editor-license
 *
 * Otherwise, it is permitted to integrate the Spine Runtimes into software or
 * otherwise create derivative works of the Spine Runtimes (collectively,
 * "Products"), provided that each user of the Products must obtain their own
 * Spine Editor license and redistribution of the Products in any form must
 * include this license and copyright notice.
 *
 * THE SPINE RUNTIMES ARE PROVIDED BY ESOTERIC SOFTWARE LLC "AS IS" AND ANY
 * EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
 * WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE
 * DISCLAIMED. IN NO EVENT SHALL ESOTERIC SOFTWARE LLC BE LIABLE FOR ANY
 * DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES
 * (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES,
 * BUSINESS INTERRUPTION, OR LOSS OF USE, DATA, OR PROFITS) HOWEVER CAUSED AND
 * ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT
 * (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THE
 * SPINE RUNTIMES, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
 *****************************************************************************/ /******************************************************************************
 * Spine Runtimes License Agreement
 * Last updated July 28, 2023. Replaces all prior versions.
 *
 * Copyright (c) 2013-2023, Esoteric Software LLC
 *
 * Integration of the Spine Runtimes into software or otherwise creating
 * derivative works of the Spine Runtimes is permitted under the terms and
 * conditions of Section 2 of the Spine Editor License Agreement:
 * http://esotericsoftware.com/spine-editor-license
 *
 * Otherwise, it is permitted to integrate the Spine Runtimes into software or
 * otherwise create derivative works of the Spine Runtimes (collectively,
 * "Products"), provided that each user of the Products must obtain their own
 * Spine Editor license and redistribution of the Products in any form must
 * include this license and copyright notice.
 *
 * THE SPINE RUNTIMES ARE PROVIDED BY ESOTERIC SOFTWARE LLC "AS IS" AND ANY
 * EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
 * WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE
 * DISCLAIMED. IN NO EVENT SHALL ESOTERIC SOFTWARE LLC BE LIABLE FOR ANY
 * DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES
 * (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES,
 * BUSINESS INTERRUPTION, OR LOSS OF USE, DATA, OR PROFITS) HOWEVER CAUSED AND
 * ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT
 * (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THE
 * SPINE RUNTIMES, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
 *****************************************************************************/ class $f2aa140968060cbb$export$f5b8910cec6cf069 {
    element;
    mouseX = 0;
    mouseY = 0;
    buttonDown = false;
    touch0 = null;
    touch1 = null;
    initialPinchDistance = 0;
    listeners = new Array();
    eventListeners = [];
    constructor(element){
        this.element = element;
        this.setupCallbacks(element);
    }
    setupCallbacks(element) {
        let mouseDown = (ev)=>{
            if (ev instanceof MouseEvent) {
                let rect = element.getBoundingClientRect();
                this.mouseX = ev.clientX - rect.left;
                this.mouseY = ev.clientY - rect.top;
                this.buttonDown = true;
                this.listeners.map((listener)=>{
                    if (listener.down) listener.down(this.mouseX, this.mouseY);
                });
                document.addEventListener("mousemove", mouseMove);
                document.addEventListener("mouseup", mouseUp);
            }
        };
        let mouseMove = (ev)=>{
            if (ev instanceof MouseEvent) {
                let rect = element.getBoundingClientRect();
                this.mouseX = ev.clientX - rect.left;
                this.mouseY = ev.clientY - rect.top;
                this.listeners.map((listener)=>{
                    if (this.buttonDown) {
                        if (listener.dragged) listener.dragged(this.mouseX, this.mouseY);
                    } else if (listener.moved) listener.moved(this.mouseX, this.mouseY);
                });
            }
        };
        let mouseUp = (ev)=>{
            if (ev instanceof MouseEvent) {
                let rect = element.getBoundingClientRect();
                this.mouseX = ev.clientX - rect.left;
                this.mouseY = ev.clientY - rect.top;
                this.buttonDown = false;
                this.listeners.map((listener)=>{
                    if (listener.up) listener.up(this.mouseX, this.mouseY);
                });
                document.removeEventListener("mousemove", mouseMove);
                document.removeEventListener("mouseup", mouseUp);
            }
        };
        let mouseWheel = (e)=>{
            e.preventDefault();
            let deltaY = e.deltaY;
            if (e.deltaMode == WheelEvent.DOM_DELTA_LINE) deltaY *= 8;
            if (e.deltaMode == WheelEvent.DOM_DELTA_PAGE) deltaY *= 24;
            this.listeners.map((listener)=>{
                if (listener.wheel) listener.wheel(e.deltaY);
            });
        };
        element.addEventListener("mousedown", mouseDown, true);
        element.addEventListener("mousemove", mouseMove, true);
        element.addEventListener("mouseup", mouseUp, true);
        element.addEventListener("wheel", mouseWheel, true);
        element.addEventListener("touchstart", (ev)=>{
            if (!this.touch0 || !this.touch1) {
                var touches = ev.changedTouches;
                let nativeTouch = touches.item(0);
                if (!nativeTouch) return;
                let rect = element.getBoundingClientRect();
                let x = nativeTouch.clientX - rect.left;
                let y = nativeTouch.clientY - rect.top;
                let touch = new $f2aa140968060cbb$export$746b04bbf92762fd(nativeTouch.identifier, x, y);
                this.mouseX = x;
                this.mouseY = y;
                this.buttonDown = true;
                if (!this.touch0) {
                    this.touch0 = touch;
                    this.listeners.map((listener)=>{
                        if (listener.down) listener.down(touch.x, touch.y);
                    });
                } else if (!this.touch1) {
                    this.touch1 = touch;
                    let dx = this.touch1.x - this.touch0.x;
                    let dy = this.touch1.x - this.touch0.x;
                    this.initialPinchDistance = Math.sqrt(dx * dx + dy * dy);
                    this.listeners.map((listener)=>{
                        if (listener.zoom) listener.zoom(this.initialPinchDistance, this.initialPinchDistance);
                    });
                }
            }
            ev.preventDefault();
        }, false);
        element.addEventListener("touchmove", (ev)=>{
            if (this.touch0) {
                var touches = ev.changedTouches;
                let rect = element.getBoundingClientRect();
                for(var i = 0; i < touches.length; i++){
                    var nativeTouch = touches[i];
                    let x = nativeTouch.clientX - rect.left;
                    let y = nativeTouch.clientY - rect.top;
                    if (this.touch0.identifier === nativeTouch.identifier) {
                        this.touch0.x = this.mouseX = x;
                        this.touch0.y = this.mouseY = y;
                        this.listeners.map((listener)=>{
                            if (listener.dragged) listener.dragged(x, y);
                        });
                    }
                    if (this.touch1 && this.touch1.identifier === nativeTouch.identifier) {
                        this.touch1.x = this.mouseX = x;
                        this.touch1.y = this.mouseY = y;
                    }
                }
                if (this.touch0 && this.touch1) {
                    let dx = this.touch1.x - this.touch0.x;
                    let dy = this.touch1.x - this.touch0.x;
                    let distance = Math.sqrt(dx * dx + dy * dy);
                    this.listeners.map((listener)=>{
                        if (listener.zoom) listener.zoom(this.initialPinchDistance, distance);
                    });
                }
            }
            ev.preventDefault();
        }, false);
        let touchEnd = (ev)=>{
            if (this.touch0) {
                var touches = ev.changedTouches;
                let rect = element.getBoundingClientRect();
                for(var i = 0; i < touches.length; i++){
                    var nativeTouch = touches[i];
                    let x = nativeTouch.clientX - rect.left;
                    let y = nativeTouch.clientY - rect.top;
                    if (this.touch0.identifier === nativeTouch.identifier) {
                        this.touch0 = null;
                        this.mouseX = x;
                        this.mouseY = y;
                        this.listeners.map((listener)=>{
                            if (listener.up) listener.up(x, y);
                        });
                        if (!this.touch1) {
                            this.buttonDown = false;
                            break;
                        } else {
                            this.touch0 = this.touch1;
                            this.touch1 = null;
                            this.mouseX = this.touch0.x;
                            this.mouseX = this.touch0.x;
                            this.buttonDown = true;
                            this.listeners.map((listener)=>{
                                if (listener.down) listener.down(this.touch0.x, this.touch0.y);
                            });
                        }
                    }
                    if (this.touch1 && this.touch1.identifier) this.touch1 = null;
                }
            }
            ev.preventDefault();
        };
        element.addEventListener("touchend", touchEnd, false);
        element.addEventListener("touchcancel", touchEnd);
    }
    addListener(listener) {
        this.listeners.push(listener);
    }
    removeListener(listener) {
        let idx = this.listeners.indexOf(listener);
        if (idx > -1) this.listeners.splice(idx, 1);
    }
}
class $f2aa140968060cbb$export$746b04bbf92762fd {
    identifier;
    x;
    y;
    constructor(identifier, x, y){
        this.identifier = identifier;
        this.x = x;
        this.y = y;
    }
}



class $0441b5cb11fba1f0$export$d53514a691eb5346 {
    canvas;
    camera;
    constructor(canvas, camera){
        this.canvas = canvas;
        this.camera = camera;
        let cameraX = 0, cameraY = 0, cameraZoom = 0;
        let mouseX = 0, mouseY = 0;
        let lastX = 0, lastY = 0;
        let initialZoom = 0;
        new (0, $f2aa140968060cbb$export$f5b8910cec6cf069)(canvas).addListener({
            down: (x, y)=>{
                cameraX = camera.position.x;
                cameraY = camera.position.y;
                mouseX = lastX = x;
                mouseY = lastY = y;
                initialZoom = camera.zoom;
            },
            dragged: (x, y)=>{
                let deltaX = x - mouseX;
                let deltaY = y - mouseY;
                let originWorld = camera.screenToWorld(new (0, $75a60b996df58eed$export$64b5c384219d3699)(0, 0), canvas.clientWidth, canvas.clientHeight);
                let deltaWorld = camera.screenToWorld(new (0, $75a60b996df58eed$export$64b5c384219d3699)(deltaX, deltaY), canvas.clientWidth, canvas.clientHeight).sub(originWorld);
                camera.position.set(cameraX - deltaWorld.x, cameraY - deltaWorld.y, 0);
                camera.update();
                lastX = x;
                lastY = y;
            },
            wheel: (delta)=>{
                let zoomAmount = delta / 200 * camera.zoom;
                let newZoom = camera.zoom + zoomAmount;
                if (newZoom > 0) {
                    let x = 0, y = 0;
                    if (delta < 0) {
                        x = lastX;
                        y = lastY;
                    } else {
                        let viewCenter = new (0, $75a60b996df58eed$export$64b5c384219d3699)(canvas.clientWidth / 2 + 15, canvas.clientHeight / 2);
                        let mouseToCenterX = lastX - viewCenter.x;
                        let mouseToCenterY = canvas.clientHeight - 1 - lastY - viewCenter.y;
                        x = viewCenter.x - mouseToCenterX;
                        y = canvas.clientHeight - 1 - viewCenter.y + mouseToCenterY;
                    }
                    let oldDistance = camera.screenToWorld(new (0, $75a60b996df58eed$export$64b5c384219d3699)(x, y), canvas.clientWidth, canvas.clientHeight);
                    camera.zoom = newZoom;
                    camera.update();
                    let newDistance = camera.screenToWorld(new (0, $75a60b996df58eed$export$64b5c384219d3699)(x, y), canvas.clientWidth, canvas.clientHeight);
                    camera.position.add(oldDistance.sub(newDistance));
                    camera.update();
                }
            },
            zoom: (initialDistance, distance)=>{
                let newZoom = initialDistance / distance;
                camera.zoom = initialZoom * newZoom;
            },
            up: (x, y)=>{
                lastX = x;
                lastY = y;
            },
            moved: (x, y)=>{
                lastX = x;
                lastY = y;
            }
        });
    }
}




/******************************************************************************
 * Spine Runtimes License Agreement
 * Last updated July 28, 2023. Replaces all prior versions.
 *
 * Copyright (c) 2013-2023, Esoteric Software LLC
 *
 * Integration of the Spine Runtimes into software or otherwise creating
 * derivative works of the Spine Runtimes is permitted under the terms and
 * conditions of Section 2 of the Spine Editor License Agreement:
 * http://esotericsoftware.com/spine-editor-license
 *
 * Otherwise, it is permitted to integrate the Spine Runtimes into software or
 * otherwise create derivative works of the Spine Runtimes (collectively,
 * "Products"), provided that each user of the Products must obtain their own
 * Spine Editor license and redistribution of the Products in any form must
 * include this license and copyright notice.
 *
 * THE SPINE RUNTIMES ARE PROVIDED BY ESOTERIC SOFTWARE LLC "AS IS" AND ANY
 * EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
 * WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE
 * DISCLAIMED. IN NO EVENT SHALL ESOTERIC SOFTWARE LLC BE LIABLE FOR ANY
 * DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES
 * (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES,
 * BUSINESS INTERRUPTION, OR LOSS OF USE, DATA, OR PROFITS) HOWEVER CAUSED AND
 * ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT
 * (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THE
 * SPINE RUNTIMES, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
 *****************************************************************************/ 

/******************************************************************************
 * Spine Runtimes License Agreement
 * Last updated July 28, 2023. Replaces all prior versions.
 *
 * Copyright (c) 2013-2023, Esoteric Software LLC
 *
 * Integration of the Spine Runtimes into software or otherwise creating
 * derivative works of the Spine Runtimes is permitted under the terms and
 * conditions of Section 2 of the Spine Editor License Agreement:
 * http://esotericsoftware.com/spine-editor-license
 *
 * Otherwise, it is permitted to integrate the Spine Runtimes into software or
 * otherwise create derivative works of the Spine Runtimes (collectively,
 * "Products"), provided that each user of the Products must obtain their own
 * Spine Editor license and redistribution of the Products in any form must
 * include this license and copyright notice.
 *
 * THE SPINE RUNTIMES ARE PROVIDED BY ESOTERIC SOFTWARE LLC "AS IS" AND ANY
 * EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
 * WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE
 * DISCLAIMED. IN NO EVENT SHALL ESOTERIC SOFTWARE LLC BE LIABLE FOR ANY
 * DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES
 * (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES,
 * BUSINESS INTERRUPTION, OR LOSS OF USE, DATA, OR PROFITS) HOWEVER CAUSED AND
 * ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT
 * (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THE
 * SPINE RUNTIMES, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
 *****************************************************************************/ 

/******************************************************************************
 * Spine Runtimes License Agreement
 * Last updated July 28, 2023. Replaces all prior versions.
 *
 * Copyright (c) 2013-2023, Esoteric Software LLC
 *
 * Integration of the Spine Runtimes into software or otherwise creating
 * derivative works of the Spine Runtimes is permitted under the terms and
 * conditions of Section 2 of the Spine Editor License Agreement:
 * http://esotericsoftware.com/spine-editor-license
 *
 * Otherwise, it is permitted to integrate the Spine Runtimes into software or
 * otherwise create derivative works of the Spine Runtimes (collectively,
 * "Products"), provided that each user of the Products must obtain their own
 * Spine Editor license and redistribution of the Products in any form must
 * include this license and copyright notice.
 *
 * THE SPINE RUNTIMES ARE PROVIDED BY ESOTERIC SOFTWARE LLC "AS IS" AND ANY
 * EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
 * WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE
 * DISCLAIMED. IN NO EVENT SHALL ESOTERIC SOFTWARE LLC BE LIABLE FOR ANY
 * DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES
 * (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES,
 * BUSINESS INTERRUPTION, OR LOSS OF USE, DATA, OR PROFITS) HOWEVER CAUSED AND
 * ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT
 * (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THE
 * SPINE RUNTIMES, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
 *****************************************************************************/ /******************************************************************************
 * Spine Runtimes License Agreement
 * Last updated July 28, 2023. Replaces all prior versions.
 *
 * Copyright (c) 2013-2023, Esoteric Software LLC
 *
 * Integration of the Spine Runtimes into software or otherwise creating
 * derivative works of the Spine Runtimes is permitted under the terms and
 * conditions of Section 2 of the Spine Editor License Agreement:
 * http://esotericsoftware.com/spine-editor-license
 *
 * Otherwise, it is permitted to integrate the Spine Runtimes into software or
 * otherwise create derivative works of the Spine Runtimes (collectively,
 * "Products"), provided that each user of the Products must obtain their own
 * Spine Editor license and redistribution of the Products in any form must
 * include this license and copyright notice.
 *
 * THE SPINE RUNTIMES ARE PROVIDED BY ESOTERIC SOFTWARE LLC "AS IS" AND ANY
 * EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
 * WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE
 * DISCLAIMED. IN NO EVENT SHALL ESOTERIC SOFTWARE LLC BE LIABLE FOR ANY
 * DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES
 * (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES,
 * BUSINESS INTERRUPTION, OR LOSS OF USE, DATA, OR PROFITS) HOWEVER CAUSED AND
 * ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT
 * (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THE
 * SPINE RUNTIMES, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
 *****************************************************************************/ /******************************************************************************
 * Spine Runtimes License Agreement
 * Last updated July 28, 2023. Replaces all prior versions.
 *
 * Copyright (c) 2013-2023, Esoteric Software LLC
 *
 * Integration of the Spine Runtimes into software or otherwise creating
 * derivative works of the Spine Runtimes is permitted under the terms and
 * conditions of Section 2 of the Spine Editor License Agreement:
 * http://esotericsoftware.com/spine-editor-license
 *
 * Otherwise, it is permitted to integrate the Spine Runtimes into software or
 * otherwise create derivative works of the Spine Runtimes (collectively,
 * "Products"), provided that each user of the Products must obtain their own
 * Spine Editor license and redistribution of the Products in any form must
 * include this license and copyright notice.
 *
 * THE SPINE RUNTIMES ARE PROVIDED BY ESOTERIC SOFTWARE LLC "AS IS" AND ANY
 * EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
 * WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE
 * DISCLAIMED. IN NO EVENT SHALL ESOTERIC SOFTWARE LLC BE LIABLE FOR ANY
 * DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES
 * (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES,
 * BUSINESS INTERRUPTION, OR LOSS OF USE, DATA, OR PROFITS) HOWEVER CAUSED AND
 * ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT
 * (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THE
 * SPINE RUNTIMES, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
 *****************************************************************************/ 
class $8a8ff7c90fa2f6c9$export$462bb059fed9d9e5 {
    vertexShader;
    fragmentShader;
    static MVP_MATRIX = "u_projTrans";
    static POSITION = "a_position";
    static COLOR = "a_color";
    static COLOR2 = "a_color2";
    static TEXCOORDS = "a_texCoords";
    static SAMPLER = "u_texture";
    context;
    vs = null;
    vsSource;
    fs = null;
    fsSource;
    program = null;
    tmp2x2 = new Float32Array(4);
    tmp3x3 = new Float32Array(9);
    tmp4x4 = new Float32Array(16);
    getProgram() {
        return this.program;
    }
    getVertexShader() {
        return this.vertexShader;
    }
    getFragmentShader() {
        return this.fragmentShader;
    }
    getVertexShaderSource() {
        return this.vsSource;
    }
    getFragmentSource() {
        return this.fsSource;
    }
    constructor(context, vertexShader, fragmentShader){
        this.vertexShader = vertexShader;
        this.fragmentShader = fragmentShader;
        this.vsSource = vertexShader;
        this.fsSource = fragmentShader;
        this.context = context instanceof (0, $d702f730bad78eda$export$a4d6d43057cae2ac) ? context : new (0, $d702f730bad78eda$export$a4d6d43057cae2ac)(context);
        this.context.addRestorable(this);
        this.compile();
    }
    compile() {
        let gl = this.context.gl;
        try {
            this.vs = this.compileShader(gl.VERTEX_SHADER, this.vertexShader);
            if (!this.vs) throw new Error("Couldn't compile vertex shader.");
            this.fs = this.compileShader(gl.FRAGMENT_SHADER, this.fragmentShader);
            if (!this.fs) throw new Error("Couldn#t compile fragment shader.");
            this.program = this.compileProgram(this.vs, this.fs);
        } catch (e) {
            this.dispose();
            throw e;
        }
    }
    compileShader(type, source) {
        let gl = this.context.gl;
        let shader = gl.createShader(type);
        if (!shader) throw new Error("Couldn't create shader.");
        gl.shaderSource(shader, source);
        gl.compileShader(shader);
        if (!gl.getShaderParameter(shader, gl.COMPILE_STATUS)) {
            let error = "Couldn't compile shader: " + gl.getShaderInfoLog(shader);
            gl.deleteShader(shader);
            if (!gl.isContextLost()) throw new Error(error);
        }
        return shader;
    }
    compileProgram(vs, fs) {
        let gl = this.context.gl;
        let program = gl.createProgram();
        if (!program) throw new Error("Couldn't compile program.");
        gl.attachShader(program, vs);
        gl.attachShader(program, fs);
        gl.linkProgram(program);
        if (!gl.getProgramParameter(program, gl.LINK_STATUS)) {
            let error = "Couldn't compile shader program: " + gl.getProgramInfoLog(program);
            gl.deleteProgram(program);
            if (!gl.isContextLost()) throw new Error(error);
        }
        return program;
    }
    restore() {
        this.compile();
    }
    bind() {
        this.context.gl.useProgram(this.program);
    }
    unbind() {
        this.context.gl.useProgram(null);
    }
    setUniformi(uniform, value) {
        this.context.gl.uniform1i(this.getUniformLocation(uniform), value);
    }
    setUniformf(uniform, value) {
        this.context.gl.uniform1f(this.getUniformLocation(uniform), value);
    }
    setUniform2f(uniform, value, value2) {
        this.context.gl.uniform2f(this.getUniformLocation(uniform), value, value2);
    }
    setUniform3f(uniform, value, value2, value3) {
        this.context.gl.uniform3f(this.getUniformLocation(uniform), value, value2, value3);
    }
    setUniform4f(uniform, value, value2, value3, value4) {
        this.context.gl.uniform4f(this.getUniformLocation(uniform), value, value2, value3, value4);
    }
    setUniform2x2f(uniform, value) {
        let gl = this.context.gl;
        this.tmp2x2.set(value);
        gl.uniformMatrix2fv(this.getUniformLocation(uniform), false, this.tmp2x2);
    }
    setUniform3x3f(uniform, value) {
        let gl = this.context.gl;
        this.tmp3x3.set(value);
        gl.uniformMatrix3fv(this.getUniformLocation(uniform), false, this.tmp3x3);
    }
    setUniform4x4f(uniform, value) {
        let gl = this.context.gl;
        this.tmp4x4.set(value);
        gl.uniformMatrix4fv(this.getUniformLocation(uniform), false, this.tmp4x4);
    }
    getUniformLocation(uniform) {
        let gl = this.context.gl;
        if (!this.program) throw new Error("Shader not compiled.");
        let location = gl.getUniformLocation(this.program, uniform);
        if (!location && !gl.isContextLost()) throw new Error(`Couldn't find location for uniform ${uniform}`);
        return location;
    }
    getAttributeLocation(attribute) {
        let gl = this.context.gl;
        if (!this.program) throw new Error("Shader not compiled.");
        let location = gl.getAttribLocation(this.program, attribute);
        if (location == -1 && !gl.isContextLost()) throw new Error(`Couldn't find location for attribute ${attribute}`);
        return location;
    }
    dispose() {
        this.context.removeRestorable(this);
        let gl = this.context.gl;
        if (this.vs) {
            gl.deleteShader(this.vs);
            this.vs = null;
        }
        if (this.fs) {
            gl.deleteShader(this.fs);
            this.fs = null;
        }
        if (this.program) {
            gl.deleteProgram(this.program);
            this.program = null;
        }
    }
    static newColoredTextured(context) {
        let vs = `
attribute vec4 ${$8a8ff7c90fa2f6c9$export$462bb059fed9d9e5.POSITION};
attribute vec4 ${$8a8ff7c90fa2f6c9$export$462bb059fed9d9e5.COLOR};
attribute vec2 ${$8a8ff7c90fa2f6c9$export$462bb059fed9d9e5.TEXCOORDS};
uniform mat4 ${$8a8ff7c90fa2f6c9$export$462bb059fed9d9e5.MVP_MATRIX};
varying vec4 v_color;
varying vec2 v_texCoords;

void main () {
	v_color = ${$8a8ff7c90fa2f6c9$export$462bb059fed9d9e5.COLOR};
	v_texCoords = ${$8a8ff7c90fa2f6c9$export$462bb059fed9d9e5.TEXCOORDS};
	gl_Position = ${$8a8ff7c90fa2f6c9$export$462bb059fed9d9e5.MVP_MATRIX} * ${$8a8ff7c90fa2f6c9$export$462bb059fed9d9e5.POSITION};
}
`;
        let fs = `
#ifdef GL_ES
	#define LOWP lowp
	precision mediump float;
#else
	#define LOWP
#endif
varying LOWP vec4 v_color;
varying vec2 v_texCoords;
uniform sampler2D u_texture;

void main () {
	gl_FragColor = v_color * texture2D(u_texture, v_texCoords);
}
`;
        return new $8a8ff7c90fa2f6c9$export$462bb059fed9d9e5(context, vs, fs);
    }
    static newTwoColoredTextured(context) {
        let vs = `
attribute vec4 ${$8a8ff7c90fa2f6c9$export$462bb059fed9d9e5.POSITION};
attribute vec4 ${$8a8ff7c90fa2f6c9$export$462bb059fed9d9e5.COLOR};
attribute vec4 ${$8a8ff7c90fa2f6c9$export$462bb059fed9d9e5.COLOR2};
attribute vec2 ${$8a8ff7c90fa2f6c9$export$462bb059fed9d9e5.TEXCOORDS};
uniform mat4 ${$8a8ff7c90fa2f6c9$export$462bb059fed9d9e5.MVP_MATRIX};
varying vec4 v_light;
varying vec4 v_dark;
varying vec2 v_texCoords;

void main () {
	v_light = ${$8a8ff7c90fa2f6c9$export$462bb059fed9d9e5.COLOR};
	v_dark = ${$8a8ff7c90fa2f6c9$export$462bb059fed9d9e5.COLOR2};
	v_texCoords = ${$8a8ff7c90fa2f6c9$export$462bb059fed9d9e5.TEXCOORDS};
	gl_Position = ${$8a8ff7c90fa2f6c9$export$462bb059fed9d9e5.MVP_MATRIX} * ${$8a8ff7c90fa2f6c9$export$462bb059fed9d9e5.POSITION};
}
`;
        let fs = `
#ifdef GL_ES
	#define LOWP lowp
	precision mediump float;
#else
	#define LOWP
#endif
varying LOWP vec4 v_light;
varying LOWP vec4 v_dark;
varying vec2 v_texCoords;
uniform sampler2D u_texture;

void main () {
	vec4 texColor = texture2D(u_texture, v_texCoords);
	gl_FragColor.a = texColor.a * v_light.a;
	gl_FragColor.rgb = ((texColor.a - 1.0) * v_dark.a + 1.0 - texColor.rgb) * v_dark.rgb + texColor.rgb * v_light.rgb;
}
`;
        return new $8a8ff7c90fa2f6c9$export$462bb059fed9d9e5(context, vs, fs);
    }
    static newColored(context) {
        let vs = `
attribute vec4 ${$8a8ff7c90fa2f6c9$export$462bb059fed9d9e5.POSITION};
attribute vec4 ${$8a8ff7c90fa2f6c9$export$462bb059fed9d9e5.COLOR};
uniform mat4 ${$8a8ff7c90fa2f6c9$export$462bb059fed9d9e5.MVP_MATRIX};
varying vec4 v_color;

void main () {
	v_color = ${$8a8ff7c90fa2f6c9$export$462bb059fed9d9e5.COLOR};
	gl_Position = ${$8a8ff7c90fa2f6c9$export$462bb059fed9d9e5.MVP_MATRIX} * ${$8a8ff7c90fa2f6c9$export$462bb059fed9d9e5.POSITION};
}
`;
        let fs = `
#ifdef GL_ES
	#define LOWP lowp
	precision mediump float;
#else
	#define LOWP
#endif
varying LOWP vec4 v_color;

void main () {
	gl_FragColor = v_color;
}
`;
        return new $8a8ff7c90fa2f6c9$export$462bb059fed9d9e5(context, vs, fs);
    }
}



class $db0c869546d28139$export$e176487c05830cc5 {
    attributes;
    context;
    vertices;
    verticesBuffer = null;
    verticesLength = 0;
    dirtyVertices = false;
    indices;
    indicesBuffer = null;
    indicesLength = 0;
    dirtyIndices = false;
    elementsPerVertex = 0;
    getAttributes() {
        return this.attributes;
    }
    maxVertices() {
        return this.vertices.length / this.elementsPerVertex;
    }
    numVertices() {
        return this.verticesLength / this.elementsPerVertex;
    }
    setVerticesLength(length) {
        this.dirtyVertices = true;
        this.verticesLength = length;
    }
    getVertices() {
        return this.vertices;
    }
    maxIndices() {
        return this.indices.length;
    }
    numIndices() {
        return this.indicesLength;
    }
    setIndicesLength(length) {
        this.dirtyIndices = true;
        this.indicesLength = length;
    }
    getIndices() {
        return this.indices;
    }
    getVertexSizeInFloats() {
        let size = 0;
        for(var i = 0; i < this.attributes.length; i++){
            let attribute = this.attributes[i];
            size += attribute.numElements;
        }
        return size;
    }
    constructor(context, attributes, maxVertices, maxIndices){
        this.attributes = attributes;
        this.context = context instanceof (0, $d702f730bad78eda$export$a4d6d43057cae2ac) ? context : new (0, $d702f730bad78eda$export$a4d6d43057cae2ac)(context);
        this.elementsPerVertex = 0;
        for(let i = 0; i < attributes.length; i++)this.elementsPerVertex += attributes[i].numElements;
        this.vertices = new Float32Array(maxVertices * this.elementsPerVertex);
        this.indices = new Uint16Array(maxIndices);
        this.context.addRestorable(this);
    }
    setVertices(vertices) {
        this.dirtyVertices = true;
        if (vertices.length > this.vertices.length) throw Error("Mesh can't store more than " + this.maxVertices() + " vertices");
        this.vertices.set(vertices, 0);
        this.verticesLength = vertices.length;
    }
    setIndices(indices) {
        this.dirtyIndices = true;
        if (indices.length > this.indices.length) throw Error("Mesh can't store more than " + this.maxIndices() + " indices");
        this.indices.set(indices, 0);
        this.indicesLength = indices.length;
    }
    draw(shader, primitiveType) {
        this.drawWithOffset(shader, primitiveType, 0, this.indicesLength > 0 ? this.indicesLength : this.verticesLength / this.elementsPerVertex);
    }
    drawWithOffset(shader, primitiveType, offset, count) {
        let gl = this.context.gl;
        if (this.dirtyVertices || this.dirtyIndices) this.update();
        this.bind(shader);
        if (this.indicesLength > 0) gl.drawElements(primitiveType, count, gl.UNSIGNED_SHORT, offset * 2);
        else gl.drawArrays(primitiveType, offset, count);
        this.unbind(shader);
    }
    bind(shader) {
        let gl = this.context.gl;
        gl.bindBuffer(gl.ARRAY_BUFFER, this.verticesBuffer);
        let offset = 0;
        for(let i = 0; i < this.attributes.length; i++){
            let attrib = this.attributes[i];
            let location = shader.getAttributeLocation(attrib.name);
            gl.enableVertexAttribArray(location);
            gl.vertexAttribPointer(location, attrib.numElements, gl.FLOAT, false, this.elementsPerVertex * 4, offset * 4);
            offset += attrib.numElements;
        }
        if (this.indicesLength > 0) gl.bindBuffer(gl.ELEMENT_ARRAY_BUFFER, this.indicesBuffer);
    }
    unbind(shader) {
        let gl = this.context.gl;
        for(let i = 0; i < this.attributes.length; i++){
            let attrib = this.attributes[i];
            let location = shader.getAttributeLocation(attrib.name);
            gl.disableVertexAttribArray(location);
        }
        gl.bindBuffer(gl.ARRAY_BUFFER, null);
        if (this.indicesLength > 0) gl.bindBuffer(gl.ELEMENT_ARRAY_BUFFER, null);
    }
    update() {
        let gl = this.context.gl;
        if (this.dirtyVertices) {
            if (!this.verticesBuffer) this.verticesBuffer = gl.createBuffer();
            gl.bindBuffer(gl.ARRAY_BUFFER, this.verticesBuffer);
            gl.bufferData(gl.ARRAY_BUFFER, this.vertices.subarray(0, this.verticesLength), gl.DYNAMIC_DRAW);
            this.dirtyVertices = false;
        }
        if (this.dirtyIndices) {
            if (!this.indicesBuffer) this.indicesBuffer = gl.createBuffer();
            gl.bindBuffer(gl.ELEMENT_ARRAY_BUFFER, this.indicesBuffer);
            gl.bufferData(gl.ELEMENT_ARRAY_BUFFER, this.indices.subarray(0, this.indicesLength), gl.DYNAMIC_DRAW);
            this.dirtyIndices = false;
        }
    }
    restore() {
        this.verticesBuffer = null;
        this.indicesBuffer = null;
        this.update();
    }
    dispose() {
        this.context.removeRestorable(this);
        let gl = this.context.gl;
        gl.deleteBuffer(this.verticesBuffer);
        gl.deleteBuffer(this.indicesBuffer);
    }
}
class $db0c869546d28139$export$142149153d9e5406 {
    name;
    type;
    numElements;
    constructor(name, type, numElements){
        this.name = name;
        this.type = type;
        this.numElements = numElements;
    }
}
class $db0c869546d28139$export$6b406d6c1228e26d extends $db0c869546d28139$export$142149153d9e5406 {
    constructor(){
        super((0, $8a8ff7c90fa2f6c9$export$462bb059fed9d9e5).POSITION, $db0c869546d28139$export$29e4de6ed653892c.Float, 2);
    }
}
class $db0c869546d28139$export$440ae2b34cdfe21 extends $db0c869546d28139$export$142149153d9e5406 {
    constructor(){
        super((0, $8a8ff7c90fa2f6c9$export$462bb059fed9d9e5).POSITION, $db0c869546d28139$export$29e4de6ed653892c.Float, 3);
    }
}
class $db0c869546d28139$export$6c4bbe20c7b280cf extends $db0c869546d28139$export$142149153d9e5406 {
    constructor(unit = 0){
        super((0, $8a8ff7c90fa2f6c9$export$462bb059fed9d9e5).TEXCOORDS + (unit == 0 ? "" : unit), $db0c869546d28139$export$29e4de6ed653892c.Float, 2);
    }
}
class $db0c869546d28139$export$47e44c5f8d8a60a1 extends $db0c869546d28139$export$142149153d9e5406 {
    constructor(){
        super((0, $8a8ff7c90fa2f6c9$export$462bb059fed9d9e5).COLOR, $db0c869546d28139$export$29e4de6ed653892c.Float, 4);
    }
}
class $db0c869546d28139$export$78d25687df716e3e extends $db0c869546d28139$export$142149153d9e5406 {
    constructor(){
        super((0, $8a8ff7c90fa2f6c9$export$462bb059fed9d9e5).COLOR2, $db0c869546d28139$export$29e4de6ed653892c.Float, 4);
    }
}
var $db0c869546d28139$export$29e4de6ed653892c;
(function(VertexAttributeType) {
    VertexAttributeType[VertexAttributeType["Float"] = 0] = "Float";
})($db0c869546d28139$export$29e4de6ed653892c || ($db0c869546d28139$export$29e4de6ed653892c = {}));



const $8f51e6f694760411$var$GL_ONE = 1;
const $8f51e6f694760411$var$GL_ONE_MINUS_SRC_COLOR = 0x0301;
const $8f51e6f694760411$var$GL_SRC_ALPHA = 0x0302;
const $8f51e6f694760411$var$GL_ONE_MINUS_SRC_ALPHA = 0x0303;
const $8f51e6f694760411$var$GL_ONE_MINUS_DST_ALPHA = 0x0305;
const $8f51e6f694760411$var$GL_DST_COLOR = 0x0306;
class $8f51e6f694760411$export$d398217aafc5a694 {
    static disableCulling = false;
    context;
    drawCalls = 0;
    static globalDrawCalls = 0;
    isDrawing = false;
    mesh;
    shader = null;
    lastTexture = null;
    verticesLength = 0;
    indicesLength = 0;
    srcColorBlend;
    srcAlphaBlend;
    dstBlend;
    cullWasEnabled = false;
    constructor(context, twoColorTint = true, maxVertices = 10920){
        if (maxVertices > 10920) throw new Error("Can't have more than 10920 triangles per batch: " + maxVertices);
        this.context = context instanceof (0, $d702f730bad78eda$export$a4d6d43057cae2ac) ? context : new (0, $d702f730bad78eda$export$a4d6d43057cae2ac)(context);
        let attributes = twoColorTint ? [
            new (0, $db0c869546d28139$export$6b406d6c1228e26d)(),
            new (0, $db0c869546d28139$export$47e44c5f8d8a60a1)(),
            new (0, $db0c869546d28139$export$6c4bbe20c7b280cf)(),
            new (0, $db0c869546d28139$export$78d25687df716e3e)()
        ] : [
            new (0, $db0c869546d28139$export$6b406d6c1228e26d)(),
            new (0, $db0c869546d28139$export$47e44c5f8d8a60a1)(),
            new (0, $db0c869546d28139$export$6c4bbe20c7b280cf)()
        ];
        this.mesh = new (0, $db0c869546d28139$export$e176487c05830cc5)(context, attributes, maxVertices, maxVertices * 3);
        let gl = this.context.gl;
        this.srcColorBlend = gl.SRC_ALPHA;
        this.srcAlphaBlend = gl.ONE;
        this.dstBlend = gl.ONE_MINUS_SRC_ALPHA;
    }
    begin(shader) {
        if (this.isDrawing) throw new Error("PolygonBatch is already drawing. Call PolygonBatch.end() before calling PolygonBatch.begin()");
        this.drawCalls = 0;
        this.shader = shader;
        this.lastTexture = null;
        this.isDrawing = true;
        let gl = this.context.gl;
        gl.enable(gl.BLEND);
        gl.blendFuncSeparate(this.srcColorBlend, this.dstBlend, this.srcAlphaBlend, this.dstBlend);
        if ($8f51e6f694760411$export$d398217aafc5a694.disableCulling) {
            this.cullWasEnabled = gl.isEnabled(gl.CULL_FACE);
            if (this.cullWasEnabled) gl.disable(gl.CULL_FACE);
        }
    }
    static blendModesGL = [
        {
            srcRgb: $8f51e6f694760411$var$GL_SRC_ALPHA,
            srcRgbPma: $8f51e6f694760411$var$GL_ONE,
            dstRgb: $8f51e6f694760411$var$GL_ONE_MINUS_SRC_ALPHA,
            srcAlpha: $8f51e6f694760411$var$GL_ONE
        },
        {
            srcRgb: $8f51e6f694760411$var$GL_SRC_ALPHA,
            srcRgbPma: $8f51e6f694760411$var$GL_ONE,
            dstRgb: $8f51e6f694760411$var$GL_ONE,
            srcAlpha: $8f51e6f694760411$var$GL_ONE
        },
        {
            srcRgb: $8f51e6f694760411$var$GL_DST_COLOR,
            srcRgbPma: $8f51e6f694760411$var$GL_DST_COLOR,
            dstRgb: $8f51e6f694760411$var$GL_ONE_MINUS_SRC_ALPHA,
            srcAlpha: $8f51e6f694760411$var$GL_ONE
        },
        {
            srcRgb: $8f51e6f694760411$var$GL_ONE,
            srcRgbPma: $8f51e6f694760411$var$GL_ONE,
            dstRgb: $8f51e6f694760411$var$GL_ONE_MINUS_SRC_COLOR,
            srcAlpha: $8f51e6f694760411$var$GL_ONE
        }
    ];
    setBlendMode(blendMode, premultipliedAlpha) {
        const blendModeGL = $8f51e6f694760411$export$d398217aafc5a694.blendModesGL[blendMode];
        const srcColorBlend = premultipliedAlpha ? blendModeGL.srcRgbPma : blendModeGL.srcRgb;
        const srcAlphaBlend = blendModeGL.srcAlpha;
        const dstBlend = blendModeGL.dstRgb;
        if (this.srcColorBlend == srcColorBlend && this.srcAlphaBlend == srcAlphaBlend && this.dstBlend == dstBlend) return;
        this.srcColorBlend = srcColorBlend;
        this.srcAlphaBlend = srcAlphaBlend;
        this.dstBlend = dstBlend;
        if (this.isDrawing) this.flush();
        let gl = this.context.gl;
        gl.blendFuncSeparate(srcColorBlend, dstBlend, srcAlphaBlend, dstBlend);
    }
    draw(texture, vertices, indices) {
        if (texture != this.lastTexture) {
            this.flush();
            this.lastTexture = texture;
        } else if (this.verticesLength + vertices.length > this.mesh.getVertices().length || this.indicesLength + indices.length > this.mesh.getIndices().length) this.flush();
        let indexStart = this.mesh.numVertices();
        this.mesh.getVertices().set(vertices, this.verticesLength);
        this.verticesLength += vertices.length;
        this.mesh.setVerticesLength(this.verticesLength);
        let indicesArray = this.mesh.getIndices();
        for(let i = this.indicesLength, j = 0; j < indices.length; i++, j++)indicesArray[i] = indices[j] + indexStart;
        this.indicesLength += indices.length;
        this.mesh.setIndicesLength(this.indicesLength);
    }
    flush() {
        if (this.verticesLength == 0) return;
        if (!this.lastTexture) throw new Error("No texture set.");
        if (!this.shader) throw new Error("No shader set.");
        this.lastTexture.bind();
        this.mesh.draw(this.shader, this.context.gl.TRIANGLES);
        this.verticesLength = 0;
        this.indicesLength = 0;
        this.mesh.setVerticesLength(0);
        this.mesh.setIndicesLength(0);
        this.drawCalls++;
        $8f51e6f694760411$export$d398217aafc5a694.globalDrawCalls++;
    }
    end() {
        if (!this.isDrawing) throw new Error("PolygonBatch is not drawing. Call PolygonBatch.begin() before calling PolygonBatch.end()");
        if (this.verticesLength > 0 || this.indicesLength > 0) this.flush();
        this.shader = null;
        this.lastTexture = null;
        this.isDrawing = false;
        let gl = this.context.gl;
        gl.disable(gl.BLEND);
        if ($8f51e6f694760411$export$d398217aafc5a694.disableCulling) {
            if (this.cullWasEnabled) gl.enable(gl.CULL_FACE);
        }
    }
    getDrawCalls() {
        return this.drawCalls;
    }
    static getAndResetGlobalDrawCalls() {
        let result = $8f51e6f694760411$export$d398217aafc5a694.globalDrawCalls;
        $8f51e6f694760411$export$d398217aafc5a694.globalDrawCalls = 0;
        return result;
    }
    dispose() {
        this.mesh.dispose();
    }
}



/******************************************************************************
 * Spine Runtimes License Agreement
 * Last updated July 28, 2023. Replaces all prior versions.
 *
 * Copyright (c) 2013-2023, Esoteric Software LLC
 *
 * Integration of the Spine Runtimes into software or otherwise creating
 * derivative works of the Spine Runtimes is permitted under the terms and
 * conditions of Section 2 of the Spine Editor License Agreement:
 * http://esotericsoftware.com/spine-editor-license
 *
 * Otherwise, it is permitted to integrate the Spine Runtimes into software or
 * otherwise create derivative works of the Spine Runtimes (collectively,
 * "Products"), provided that each user of the Products must obtain their own
 * Spine Editor license and redistribution of the Products in any form must
 * include this license and copyright notice.
 *
 * THE SPINE RUNTIMES ARE PROVIDED BY ESOTERIC SOFTWARE LLC "AS IS" AND ANY
 * EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
 * WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE
 * DISCLAIMED. IN NO EVENT SHALL ESOTERIC SOFTWARE LLC BE LIABLE FOR ANY
 * DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES
 * (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES,
 * BUSINESS INTERRUPTION, OR LOSS OF USE, DATA, OR PROFITS) HOWEVER CAUSED AND
 * ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT
 * (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THE
 * SPINE RUNTIMES, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
 *****************************************************************************/ 


class $11e63f9c55d0b5c0$export$8304e6ea0c546270 {
    context;
    isDrawing = false;
    mesh;
    shapeType = $11e63f9c55d0b5c0$export$fc850f719b5599d5.Filled;
    color = new (0, $1702fa998ec22e58$export$892596cec99bc70e)(1, 1, 1, 1);
    shader = null;
    vertexIndex = 0;
    tmp = new (0, $1702fa998ec22e58$export$c977b3e384af9ae1)();
    srcColorBlend;
    srcAlphaBlend;
    dstBlend;
    constructor(context, maxVertices = 10920){
        if (maxVertices > 10920) throw new Error("Can't have more than 10920 triangles per batch: " + maxVertices);
        this.context = context instanceof (0, $d702f730bad78eda$export$a4d6d43057cae2ac) ? context : new (0, $d702f730bad78eda$export$a4d6d43057cae2ac)(context);
        this.mesh = new (0, $db0c869546d28139$export$e176487c05830cc5)(context, [
            new (0, $db0c869546d28139$export$6b406d6c1228e26d)(),
            new (0, $db0c869546d28139$export$47e44c5f8d8a60a1)()
        ], maxVertices, 0);
        let gl = this.context.gl;
        this.srcColorBlend = gl.SRC_ALPHA;
        this.srcAlphaBlend = gl.ONE;
        this.dstBlend = gl.ONE_MINUS_SRC_ALPHA;
    }
    begin(shader) {
        if (this.isDrawing) throw new Error("ShapeRenderer.begin() has already been called");
        this.shader = shader;
        this.vertexIndex = 0;
        this.isDrawing = true;
        let gl = this.context.gl;
        gl.enable(gl.BLEND);
        gl.blendFuncSeparate(this.srcColorBlend, this.dstBlend, this.srcAlphaBlend, this.dstBlend);
    }
    setBlendMode(srcColorBlend, srcAlphaBlend, dstBlend) {
        this.srcColorBlend = srcColorBlend;
        this.srcAlphaBlend = srcAlphaBlend;
        this.dstBlend = dstBlend;
        if (this.isDrawing) {
            this.flush();
            let gl = this.context.gl;
            gl.blendFuncSeparate(srcColorBlend, dstBlend, srcAlphaBlend, dstBlend);
        }
    }
    setColor(color) {
        this.color.setFromColor(color);
    }
    setColorWith(r, g, b, a) {
        this.color.set(r, g, b, a);
    }
    point(x, y, color) {
        this.check($11e63f9c55d0b5c0$export$fc850f719b5599d5.Point, 1);
        if (!color) color = this.color;
        this.vertex(x, y, color);
    }
    line(x, y, x2, y2, color) {
        this.check($11e63f9c55d0b5c0$export$fc850f719b5599d5.Line, 2);
        let vertices = this.mesh.getVertices();
        let idx = this.vertexIndex;
        if (!color) color = this.color;
        this.vertex(x, y, color);
        this.vertex(x2, y2, color);
    }
    triangle(filled, x, y, x2, y2, x3, y3, color, color2, color3) {
        this.check(filled ? $11e63f9c55d0b5c0$export$fc850f719b5599d5.Filled : $11e63f9c55d0b5c0$export$fc850f719b5599d5.Line, 3);
        let vertices = this.mesh.getVertices();
        let idx = this.vertexIndex;
        if (!color) color = this.color;
        if (!color2) color2 = this.color;
        if (!color3) color3 = this.color;
        if (filled) {
            this.vertex(x, y, color);
            this.vertex(x2, y2, color2);
            this.vertex(x3, y3, color3);
        } else {
            this.vertex(x, y, color);
            this.vertex(x2, y2, color2);
            this.vertex(x2, y2, color);
            this.vertex(x3, y3, color2);
            this.vertex(x3, y3, color);
            this.vertex(x, y, color2);
        }
    }
    quad(filled, x, y, x2, y2, x3, y3, x4, y4, color, color2, color3, color4) {
        this.check(filled ? $11e63f9c55d0b5c0$export$fc850f719b5599d5.Filled : $11e63f9c55d0b5c0$export$fc850f719b5599d5.Line, 3);
        let vertices = this.mesh.getVertices();
        let idx = this.vertexIndex;
        if (!color) color = this.color;
        if (!color2) color2 = this.color;
        if (!color3) color3 = this.color;
        if (!color4) color4 = this.color;
        if (filled) {
            this.vertex(x, y, color);
            this.vertex(x2, y2, color2);
            this.vertex(x3, y3, color3);
            this.vertex(x3, y3, color3);
            this.vertex(x4, y4, color4);
            this.vertex(x, y, color);
        } else {
            this.vertex(x, y, color);
            this.vertex(x2, y2, color2);
            this.vertex(x2, y2, color2);
            this.vertex(x3, y3, color3);
            this.vertex(x3, y3, color3);
            this.vertex(x4, y4, color4);
            this.vertex(x4, y4, color4);
            this.vertex(x, y, color);
        }
    }
    rect(filled, x, y, width, height, color) {
        this.quad(filled, x, y, x + width, y, x + width, y + height, x, y + height, color, color, color, color);
    }
    rectLine(filled, x1, y1, x2, y2, width, color) {
        this.check(filled ? $11e63f9c55d0b5c0$export$fc850f719b5599d5.Filled : $11e63f9c55d0b5c0$export$fc850f719b5599d5.Line, 8);
        if (!color) color = this.color;
        let t = this.tmp.set(y2 - y1, x1 - x2);
        t.normalize();
        width *= 0.5;
        let tx = t.x * width;
        let ty = t.y * width;
        if (!filled) {
            this.vertex(x1 + tx, y1 + ty, color);
            this.vertex(x1 - tx, y1 - ty, color);
            this.vertex(x2 + tx, y2 + ty, color);
            this.vertex(x2 - tx, y2 - ty, color);
            this.vertex(x2 + tx, y2 + ty, color);
            this.vertex(x1 + tx, y1 + ty, color);
            this.vertex(x2 - tx, y2 - ty, color);
            this.vertex(x1 - tx, y1 - ty, color);
        } else {
            this.vertex(x1 + tx, y1 + ty, color);
            this.vertex(x1 - tx, y1 - ty, color);
            this.vertex(x2 + tx, y2 + ty, color);
            this.vertex(x2 - tx, y2 - ty, color);
            this.vertex(x2 + tx, y2 + ty, color);
            this.vertex(x1 - tx, y1 - ty, color);
        }
    }
    x(x, y, size) {
        this.line(x - size, y - size, x + size, y + size);
        this.line(x - size, y + size, x + size, y - size);
    }
    polygon(polygonVertices, offset, count, color) {
        if (count < 3) throw new Error("Polygon must contain at least 3 vertices");
        this.check($11e63f9c55d0b5c0$export$fc850f719b5599d5.Line, count * 2);
        if (!color) color = this.color;
        let vertices = this.mesh.getVertices();
        let idx = this.vertexIndex;
        offset <<= 1;
        count <<= 1;
        let firstX = polygonVertices[offset];
        let firstY = polygonVertices[offset + 1];
        let last = offset + count;
        for(let i = offset, n = offset + count - 2; i < n; i += 2){
            let x1 = polygonVertices[i];
            let y1 = polygonVertices[i + 1];
            let x2 = 0;
            let y2 = 0;
            if (i + 2 >= last) {
                x2 = firstX;
                y2 = firstY;
            } else {
                x2 = polygonVertices[i + 2];
                y2 = polygonVertices[i + 3];
            }
            this.vertex(x1, y1, color);
            this.vertex(x2, y2, color);
        }
    }
    circle(filled, x, y, radius, color, segments = 0) {
        if (segments == 0) segments = Math.max(1, 6 * (0, $1702fa998ec22e58$export$6a7ef315a0d1ef07).cbrt(radius) | 0);
        if (segments <= 0) throw new Error("segments must be > 0.");
        if (!color) color = this.color;
        let angle = 2 * (0, $1702fa998ec22e58$export$6a7ef315a0d1ef07).PI / segments;
        let cos = Math.cos(angle);
        let sin = Math.sin(angle);
        let cx = radius, cy = 0;
        if (!filled) {
            this.check($11e63f9c55d0b5c0$export$fc850f719b5599d5.Line, segments * 2 + 2);
            for(let i = 0; i < segments; i++){
                this.vertex(x + cx, y + cy, color);
                let temp = cx;
                cx = cos * cx - sin * cy;
                cy = sin * temp + cos * cy;
                this.vertex(x + cx, y + cy, color);
            }
            // Ensure the last segment is identical to the first.
            this.vertex(x + cx, y + cy, color);
        } else {
            this.check($11e63f9c55d0b5c0$export$fc850f719b5599d5.Filled, segments * 3 + 3);
            segments--;
            for(let i = 0; i < segments; i++){
                this.vertex(x, y, color);
                this.vertex(x + cx, y + cy, color);
                let temp = cx;
                cx = cos * cx - sin * cy;
                cy = sin * temp + cos * cy;
                this.vertex(x + cx, y + cy, color);
            }
            // Ensure the last segment is identical to the first.
            this.vertex(x, y, color);
            this.vertex(x + cx, y + cy, color);
        }
        let temp = cx;
        cx = radius;
        cy = 0;
        this.vertex(x + cx, y + cy, color);
    }
    curve(x1, y1, cx1, cy1, cx2, cy2, x2, y2, segments, color) {
        this.check($11e63f9c55d0b5c0$export$fc850f719b5599d5.Line, segments * 2 + 2);
        if (!color) color = this.color;
        // Algorithm from: http://www.antigrain.com/research/bezier_interpolation/index.html#PAGE_BEZIER_INTERPOLATION
        let subdiv_step = 1 / segments;
        let subdiv_step2 = subdiv_step * subdiv_step;
        let subdiv_step3 = subdiv_step * subdiv_step * subdiv_step;
        let pre1 = 3 * subdiv_step;
        let pre2 = 3 * subdiv_step2;
        let pre4 = 6 * subdiv_step2;
        let pre5 = 6 * subdiv_step3;
        let tmp1x = x1 - cx1 * 2 + cx2;
        let tmp1y = y1 - cy1 * 2 + cy2;
        let tmp2x = (cx1 - cx2) * 3 - x1 + x2;
        let tmp2y = (cy1 - cy2) * 3 - y1 + y2;
        let fx = x1;
        let fy = y1;
        let dfx = (cx1 - x1) * pre1 + tmp1x * pre2 + tmp2x * subdiv_step3;
        let dfy = (cy1 - y1) * pre1 + tmp1y * pre2 + tmp2y * subdiv_step3;
        let ddfx = tmp1x * pre4 + tmp2x * pre5;
        let ddfy = tmp1y * pre4 + tmp2y * pre5;
        let dddfx = tmp2x * pre5;
        let dddfy = tmp2y * pre5;
        while(segments-- > 0){
            this.vertex(fx, fy, color);
            fx += dfx;
            fy += dfy;
            dfx += ddfx;
            dfy += ddfy;
            ddfx += dddfx;
            ddfy += dddfy;
            this.vertex(fx, fy, color);
        }
        this.vertex(fx, fy, color);
        this.vertex(x2, y2, color);
    }
    vertex(x, y, color) {
        let idx = this.vertexIndex;
        let vertices = this.mesh.getVertices();
        vertices[idx++] = x;
        vertices[idx++] = y;
        vertices[idx++] = color.r;
        vertices[idx++] = color.g;
        vertices[idx++] = color.b;
        vertices[idx++] = color.a;
        this.vertexIndex = idx;
    }
    end() {
        if (!this.isDrawing) throw new Error("ShapeRenderer.begin() has not been called");
        this.flush();
        let gl = this.context.gl;
        gl.disable(gl.BLEND);
        this.isDrawing = false;
    }
    flush() {
        if (this.vertexIndex == 0) return;
        if (!this.shader) throw new Error("No shader set.");
        this.mesh.setVerticesLength(this.vertexIndex);
        this.mesh.draw(this.shader, this.shapeType);
        this.vertexIndex = 0;
    }
    check(shapeType, numVertices) {
        if (!this.isDrawing) throw new Error("ShapeRenderer.begin() has not been called");
        if (this.shapeType == shapeType) {
            if (this.mesh.maxVertices() - this.mesh.numVertices() < numVertices) this.flush();
            else return;
        } else {
            this.flush();
            this.shapeType = shapeType;
        }
    }
    dispose() {
        this.mesh.dispose();
    }
}
var $11e63f9c55d0b5c0$export$fc850f719b5599d5;
(function(ShapeType) {
    ShapeType[ShapeType["Point"] = 0] = "Point";
    ShapeType[ShapeType["Line"] = 1] = "Line";
    ShapeType[ShapeType["Filled"] = 4] = "Filled";
})($11e63f9c55d0b5c0$export$fc850f719b5599d5 || ($11e63f9c55d0b5c0$export$fc850f719b5599d5 = {}));


/******************************************************************************
 * Spine Runtimes License Agreement
 * Last updated July 28, 2023. Replaces all prior versions.
 *
 * Copyright (c) 2013-2023, Esoteric Software LLC
 *
 * Integration of the Spine Runtimes into software or otherwise creating
 * derivative works of the Spine Runtimes is permitted under the terms and
 * conditions of Section 2 of the Spine Editor License Agreement:
 * http://esotericsoftware.com/spine-editor-license
 *
 * Otherwise, it is permitted to integrate the Spine Runtimes into software or
 * otherwise create derivative works of the Spine Runtimes (collectively,
 * "Products"), provided that each user of the Products must obtain their own
 * Spine Editor license and redistribution of the Products in any form must
 * include this license and copyright notice.
 *
 * THE SPINE RUNTIMES ARE PROVIDED BY ESOTERIC SOFTWARE LLC "AS IS" AND ANY
 * EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
 * WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE
 * DISCLAIMED. IN NO EVENT SHALL ESOTERIC SOFTWARE LLC BE LIABLE FOR ANY
 * DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES
 * (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES,
 * BUSINESS INTERRUPTION, OR LOSS OF USE, DATA, OR PROFITS) HOWEVER CAUSED AND
 * ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT
 * (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THE
 * SPINE RUNTIMES, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
 *****************************************************************************/ 

class $ca5c822b035b6df0$export$ce694abc08778c7a {
    boneLineColor = new (0, $1702fa998ec22e58$export$892596cec99bc70e)(1, 0, 0, 1);
    boneOriginColor = new (0, $1702fa998ec22e58$export$892596cec99bc70e)(0, 1, 0, 1);
    attachmentLineColor = new (0, $1702fa998ec22e58$export$892596cec99bc70e)(0, 0, 1, 0.5);
    triangleLineColor = new (0, $1702fa998ec22e58$export$892596cec99bc70e)(1, 0.64, 0, 0.5);
    pathColor = new (0, $1702fa998ec22e58$export$892596cec99bc70e)().setFromString("FF7F00");
    clipColor = new (0, $1702fa998ec22e58$export$892596cec99bc70e)(0.8, 0, 0, 2);
    aabbColor = new (0, $1702fa998ec22e58$export$892596cec99bc70e)(0, 1, 0, 0.5);
    drawBones = true;
    drawRegionAttachments = true;
    drawBoundingBoxes = true;
    drawMeshHull = true;
    drawMeshTriangles = true;
    drawPaths = true;
    drawSkeletonXY = false;
    drawClipping = true;
    premultipliedAlpha = false;
    scale = 1;
    boneWidth = 2;
    context;
    bounds = new (0, $06824dc31dec3458$export$119f1746fc062f5e)();
    temp = new Array();
    vertices = (0, $1702fa998ec22e58$export$d2ca453b913dcdea).newFloatArray(2048);
    static LIGHT_GRAY = new (0, $1702fa998ec22e58$export$892596cec99bc70e)(192 / 255, 192 / 255, 192 / 255, 1);
    static GREEN = new (0, $1702fa998ec22e58$export$892596cec99bc70e)(0, 1, 0, 1);
    constructor(context){
        this.context = context instanceof (0, $d702f730bad78eda$export$a4d6d43057cae2ac) ? context : new (0, $d702f730bad78eda$export$a4d6d43057cae2ac)(context);
    }
    draw(shapes, skeleton, ignoredBones) {
        let skeletonX = skeleton.x;
        let skeletonY = skeleton.y;
        let gl = this.context.gl;
        let srcFunc = this.premultipliedAlpha ? gl.ONE : gl.SRC_ALPHA;
        shapes.setBlendMode(srcFunc, gl.ONE, gl.ONE_MINUS_SRC_ALPHA);
        let bones = skeleton.bones;
        if (this.drawBones) {
            shapes.setColor(this.boneLineColor);
            for(let i = 0, n = bones.length; i < n; i++){
                let bone = bones[i];
                if (ignoredBones && ignoredBones.indexOf(bone.data.name) > -1) continue;
                if (!bone.parent) continue;
                let x = bone.data.length * bone.a + bone.worldX;
                let y = bone.data.length * bone.c + bone.worldY;
                shapes.rectLine(true, bone.worldX, bone.worldY, x, y, this.boneWidth * this.scale);
            }
            if (this.drawSkeletonXY) shapes.x(skeletonX, skeletonY, 4 * this.scale);
        }
        if (this.drawRegionAttachments) {
            shapes.setColor(this.attachmentLineColor);
            let slots = skeleton.slots;
            for(let i = 0, n = slots.length; i < n; i++){
                let slot = slots[i];
                let attachment = slot.getAttachment();
                if (attachment instanceof (0, $6355869a5ef59f02$export$d0fc51466fa6d530)) {
                    let regionAttachment = attachment;
                    let vertices = this.vertices;
                    regionAttachment.computeWorldVertices(slot, vertices, 0, 2);
                    shapes.line(vertices[0], vertices[1], vertices[2], vertices[3]);
                    shapes.line(vertices[2], vertices[3], vertices[4], vertices[5]);
                    shapes.line(vertices[4], vertices[5], vertices[6], vertices[7]);
                    shapes.line(vertices[6], vertices[7], vertices[0], vertices[1]);
                }
            }
        }
        if (this.drawMeshHull || this.drawMeshTriangles) {
            let slots = skeleton.slots;
            for(let i = 0, n = slots.length; i < n; i++){
                let slot = slots[i];
                if (!slot.bone.active) continue;
                let attachment = slot.getAttachment();
                if (!(attachment instanceof (0, $3ed5c5afaf00d170$export$3f1c1692adfcf3e2))) continue;
                let mesh = attachment;
                let vertices = this.vertices;
                mesh.computeWorldVertices(slot, 0, mesh.worldVerticesLength, vertices, 0, 2);
                let triangles = mesh.triangles;
                let hullLength = mesh.hullLength;
                if (this.drawMeshTriangles) {
                    shapes.setColor(this.triangleLineColor);
                    for(let ii = 0, nn = triangles.length; ii < nn; ii += 3){
                        let v1 = triangles[ii] * 2, v2 = triangles[ii + 1] * 2, v3 = triangles[ii + 2] * 2;
                        shapes.triangle(false, vertices[v1], vertices[v1 + 1], vertices[v2], vertices[v2 + 1], vertices[v3], vertices[v3 + 1] //
                        );
                    }
                }
                if (this.drawMeshHull && hullLength > 0) {
                    shapes.setColor(this.attachmentLineColor);
                    hullLength = (hullLength >> 1) * 2;
                    let lastX = vertices[hullLength - 2], lastY = vertices[hullLength - 1];
                    for(let ii = 0, nn = hullLength; ii < nn; ii += 2){
                        let x = vertices[ii], y = vertices[ii + 1];
                        shapes.line(x, y, lastX, lastY);
                        lastX = x;
                        lastY = y;
                    }
                }
            }
        }
        if (this.drawBoundingBoxes) {
            let bounds = this.bounds;
            bounds.update(skeleton, true);
            shapes.setColor(this.aabbColor);
            shapes.rect(false, bounds.minX, bounds.minY, bounds.getWidth(), bounds.getHeight());
            let polygons = bounds.polygons;
            let boxes = bounds.boundingBoxes;
            for(let i = 0, n = polygons.length; i < n; i++){
                let polygon = polygons[i];
                shapes.setColor(boxes[i].color);
                shapes.polygon(polygon, 0, polygon.length);
            }
        }
        if (this.drawPaths) {
            let slots = skeleton.slots;
            for(let i = 0, n = slots.length; i < n; i++){
                let slot = slots[i];
                if (!slot.bone.active) continue;
                let attachment = slot.getAttachment();
                if (!(attachment instanceof (0, $2fcc86453abe2c1c$export$d285e3ec07b32800))) continue;
                let path = attachment;
                let nn = path.worldVerticesLength;
                let world = this.temp = (0, $1702fa998ec22e58$export$d2ca453b913dcdea).setArraySize(this.temp, nn, 0);
                path.computeWorldVertices(slot, 0, nn, world, 0, 2);
                let color = this.pathColor;
                let x1 = world[2], y1 = world[3], x2 = 0, y2 = 0;
                if (path.closed) {
                    shapes.setColor(color);
                    let cx1 = world[0], cy1 = world[1], cx2 = world[nn - 2], cy2 = world[nn - 1];
                    x2 = world[nn - 4];
                    y2 = world[nn - 3];
                    shapes.curve(x1, y1, cx1, cy1, cx2, cy2, x2, y2, 32);
                    shapes.setColor($ca5c822b035b6df0$export$ce694abc08778c7a.LIGHT_GRAY);
                    shapes.line(x1, y1, cx1, cy1);
                    shapes.line(x2, y2, cx2, cy2);
                }
                nn -= 4;
                for(let ii = 4; ii < nn; ii += 6){
                    let cx1 = world[ii], cy1 = world[ii + 1], cx2 = world[ii + 2], cy2 = world[ii + 3];
                    x2 = world[ii + 4];
                    y2 = world[ii + 5];
                    shapes.setColor(color);
                    shapes.curve(x1, y1, cx1, cy1, cx2, cy2, x2, y2, 32);
                    shapes.setColor($ca5c822b035b6df0$export$ce694abc08778c7a.LIGHT_GRAY);
                    shapes.line(x1, y1, cx1, cy1);
                    shapes.line(x2, y2, cx2, cy2);
                    x1 = x2;
                    y1 = y2;
                }
            }
        }
        if (this.drawBones) {
            shapes.setColor(this.boneOriginColor);
            for(let i = 0, n = bones.length; i < n; i++){
                let bone = bones[i];
                if (ignoredBones && ignoredBones.indexOf(bone.data.name) > -1) continue;
                shapes.circle(true, bone.worldX, bone.worldY, 3 * this.scale, this.boneOriginColor, 8);
            }
        }
        if (this.drawClipping) {
            let slots = skeleton.slots;
            shapes.setColor(this.clipColor);
            for(let i = 0, n = slots.length; i < n; i++){
                let slot = slots[i];
                if (!slot.bone.active) continue;
                let attachment = slot.getAttachment();
                if (!(attachment instanceof (0, $c8cbdfdbe3e3034c$export$838805e22b9b55f1))) continue;
                let clip = attachment;
                let nn = clip.worldVerticesLength;
                let world = this.temp = (0, $1702fa998ec22e58$export$d2ca453b913dcdea).setArraySize(this.temp, nn, 0);
                clip.computeWorldVertices(slot, 0, nn, world, 0, 2);
                for(let i = 0, n = world.length; i < n; i += 2){
                    let x = world[i];
                    let y = world[i + 1];
                    let x2 = world[(i + 2) % world.length];
                    let y2 = world[(i + 3) % world.length];
                    shapes.line(x, y, x2, y2);
                }
            }
        }
    }
    dispose() {}
}


/******************************************************************************
 * Spine Runtimes License Agreement
 * Last updated July 28, 2023. Replaces all prior versions.
 *
 * Copyright (c) 2013-2023, Esoteric Software LLC
 *
 * Integration of the Spine Runtimes into software or otherwise creating
 * derivative works of the Spine Runtimes is permitted under the terms and
 * conditions of Section 2 of the Spine Editor License Agreement:
 * http://esotericsoftware.com/spine-editor-license
 *
 * Otherwise, it is permitted to integrate the Spine Runtimes into software or
 * otherwise create derivative works of the Spine Runtimes (collectively,
 * "Products"), provided that each user of the Products must obtain their own
 * Spine Editor license and redistribution of the Products in any form must
 * include this license and copyright notice.
 *
 * THE SPINE RUNTIMES ARE PROVIDED BY ESOTERIC SOFTWARE LLC "AS IS" AND ANY
 * EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
 * WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE
 * DISCLAIMED. IN NO EVENT SHALL ESOTERIC SOFTWARE LLC BE LIABLE FOR ANY
 * DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES
 * (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES,
 * BUSINESS INTERRUPTION, OR LOSS OF USE, DATA, OR PROFITS) HOWEVER CAUSED AND
 * ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT
 * (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THE
 * SPINE RUNTIMES, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
 *****************************************************************************/ 
class $4ef4615f5ebdea54$var$Renderable {
    vertices;
    numVertices;
    numFloats;
    constructor(vertices, numVertices, numFloats){
        this.vertices = vertices;
        this.numVertices = numVertices;
        this.numFloats = numFloats;
    }
}
class $4ef4615f5ebdea54$export$383ab220c2c9987a {
    static QUAD_TRIANGLES = [
        0,
        1,
        2,
        2,
        3,
        0
    ];
    premultipliedAlpha = false;
    tempColor = new (0, $1702fa998ec22e58$export$892596cec99bc70e)();
    tempColor2 = new (0, $1702fa998ec22e58$export$892596cec99bc70e)();
    vertices;
    vertexSize = 8;
    twoColorTint = false;
    renderable = new $4ef4615f5ebdea54$var$Renderable([], 0, 0);
    clipper = new (0, $eeeb8de69d7449cf$export$40b4063afbb1b315)();
    temp = new (0, $1702fa998ec22e58$export$c977b3e384af9ae1)();
    temp2 = new (0, $1702fa998ec22e58$export$c977b3e384af9ae1)();
    temp3 = new (0, $1702fa998ec22e58$export$892596cec99bc70e)();
    temp4 = new (0, $1702fa998ec22e58$export$892596cec99bc70e)();
    constructor(context, twoColorTint = true){
        this.twoColorTint = twoColorTint;
        if (twoColorTint) this.vertexSize += 4;
        this.vertices = (0, $1702fa998ec22e58$export$d2ca453b913dcdea).newFloatArray(this.vertexSize * 1024);
    }
    draw(batcher, skeleton, slotRangeStart = -1, slotRangeEnd = -1, transformer = null) {
        let clipper = this.clipper;
        let premultipliedAlpha = this.premultipliedAlpha;
        let twoColorTint = this.twoColorTint;
        let blendMode = null;
        let renderable = this.renderable;
        let uvs;
        let triangles;
        let drawOrder = skeleton.drawOrder;
        let attachmentColor;
        let skeletonColor = skeleton.color;
        let vertexSize = twoColorTint ? 12 : 8;
        let inRange = false;
        if (slotRangeStart == -1) inRange = true;
        for(let i = 0, n = drawOrder.length; i < n; i++){
            let clippedVertexSize = clipper.isClipping() ? 2 : vertexSize;
            let slot = drawOrder[i];
            if (!slot.bone.active) {
                clipper.clipEndWithSlot(slot);
                continue;
            }
            if (slotRangeStart >= 0 && slotRangeStart == slot.data.index) inRange = true;
            if (!inRange) {
                clipper.clipEndWithSlot(slot);
                continue;
            }
            if (slotRangeEnd >= 0 && slotRangeEnd == slot.data.index) inRange = false;
            let attachment = slot.getAttachment();
            let texture;
            if (attachment instanceof (0, $6355869a5ef59f02$export$d0fc51466fa6d530)) {
                let region = attachment;
                renderable.vertices = this.vertices;
                renderable.numVertices = 4;
                renderable.numFloats = clippedVertexSize << 2;
                region.computeWorldVertices(slot, renderable.vertices, 0, clippedVertexSize);
                triangles = $4ef4615f5ebdea54$export$383ab220c2c9987a.QUAD_TRIANGLES;
                uvs = region.uvs;
                texture = region.region.texture;
                attachmentColor = region.color;
            } else if (attachment instanceof (0, $3ed5c5afaf00d170$export$3f1c1692adfcf3e2)) {
                let mesh = attachment;
                renderable.vertices = this.vertices;
                renderable.numVertices = mesh.worldVerticesLength >> 1;
                renderable.numFloats = renderable.numVertices * clippedVertexSize;
                if (renderable.numFloats > renderable.vertices.length) renderable.vertices = this.vertices = (0, $1702fa998ec22e58$export$d2ca453b913dcdea).newFloatArray(renderable.numFloats);
                mesh.computeWorldVertices(slot, 0, mesh.worldVerticesLength, renderable.vertices, 0, clippedVertexSize);
                triangles = mesh.triangles;
                texture = mesh.region.texture;
                uvs = mesh.uvs;
                attachmentColor = mesh.color;
            } else if (attachment instanceof (0, $c8cbdfdbe3e3034c$export$838805e22b9b55f1)) {
                let clip = attachment;
                clipper.clipStart(slot, clip);
                continue;
            } else {
                clipper.clipEndWithSlot(slot);
                continue;
            }
            if (texture) {
                let slotColor = slot.color;
                let finalColor = this.tempColor;
                finalColor.r = skeletonColor.r * slotColor.r * attachmentColor.r;
                finalColor.g = skeletonColor.g * slotColor.g * attachmentColor.g;
                finalColor.b = skeletonColor.b * slotColor.b * attachmentColor.b;
                finalColor.a = skeletonColor.a * slotColor.a * attachmentColor.a;
                if (premultipliedAlpha) {
                    finalColor.r *= finalColor.a;
                    finalColor.g *= finalColor.a;
                    finalColor.b *= finalColor.a;
                }
                let darkColor = this.tempColor2;
                if (!slot.darkColor) darkColor.set(0, 0, 0, 1.0);
                else {
                    if (premultipliedAlpha) {
                        darkColor.r = slot.darkColor.r * finalColor.a;
                        darkColor.g = slot.darkColor.g * finalColor.a;
                        darkColor.b = slot.darkColor.b * finalColor.a;
                    } else darkColor.setFromColor(slot.darkColor);
                    darkColor.a = premultipliedAlpha ? 1.0 : 0.0;
                }
                let slotBlendMode = slot.data.blendMode;
                if (slotBlendMode != blendMode) {
                    blendMode = slotBlendMode;
                    batcher.setBlendMode(blendMode, premultipliedAlpha);
                }
                if (clipper.isClipping()) {
                    clipper.clipTriangles(renderable.vertices, renderable.numFloats, triangles, triangles.length, uvs, finalColor, darkColor, twoColorTint);
                    let clippedVertices = new Float32Array(clipper.clippedVertices);
                    let clippedTriangles = clipper.clippedTriangles;
                    if (transformer) transformer(clippedVertices, clippedVertices.length, vertexSize);
                    batcher.draw(texture, clippedVertices, clippedTriangles);
                } else {
                    let verts = renderable.vertices;
                    if (!twoColorTint) for(let v = 2, u = 0, n = renderable.numFloats; v < n; v += vertexSize, u += 2){
                        verts[v] = finalColor.r;
                        verts[v + 1] = finalColor.g;
                        verts[v + 2] = finalColor.b;
                        verts[v + 3] = finalColor.a;
                        verts[v + 4] = uvs[u];
                        verts[v + 5] = uvs[u + 1];
                    }
                    else for(let v = 2, u = 0, n = renderable.numFloats; v < n; v += vertexSize, u += 2){
                        verts[v] = finalColor.r;
                        verts[v + 1] = finalColor.g;
                        verts[v + 2] = finalColor.b;
                        verts[v + 3] = finalColor.a;
                        verts[v + 4] = uvs[u];
                        verts[v + 5] = uvs[u + 1];
                        verts[v + 6] = darkColor.r;
                        verts[v + 7] = darkColor.g;
                        verts[v + 8] = darkColor.b;
                        verts[v + 9] = darkColor.a;
                    }
                    let view = renderable.vertices.subarray(0, renderable.numFloats);
                    if (transformer) transformer(renderable.vertices, renderable.numFloats, vertexSize);
                    batcher.draw(texture, view, triangles);
                }
            }
            clipper.clipEndWithSlot(slot);
        }
        clipper.clipEnd();
    }
}



const $e8e79f3c1b8010ec$var$quad = [
    0,
    0,
    1,
    1,
    1,
    1,
    0,
    0,
    0,
    0,
    1,
    1,
    1,
    1,
    0,
    0,
    0,
    0,
    1,
    1,
    1,
    1,
    0,
    0,
    0,
    0,
    1,
    1,
    1,
    1,
    0,
    0
];
const $e8e79f3c1b8010ec$var$QUAD_TRIANGLES = [
    0,
    1,
    2,
    2,
    3,
    0
];
const $e8e79f3c1b8010ec$var$WHITE = new (0, $1702fa998ec22e58$export$892596cec99bc70e)(1, 1, 1, 1);
class $e8e79f3c1b8010ec$export$d172b6b77f76007c {
    context;
    canvas;
    camera;
    batcher;
    twoColorTint = false;
    batcherShader;
    shapes;
    shapesShader;
    activeRenderer = null;
    skeletonRenderer;
    skeletonDebugRenderer;
    constructor(canvas, context, twoColorTint = true){
        this.canvas = canvas;
        this.context = context instanceof (0, $d702f730bad78eda$export$a4d6d43057cae2ac) ? context : new (0, $d702f730bad78eda$export$a4d6d43057cae2ac)(context);
        this.twoColorTint = twoColorTint;
        this.camera = new (0, $39edd788f496d3c6$export$b58af824322cf043)(canvas.width, canvas.height);
        this.batcherShader = twoColorTint ? (0, $8a8ff7c90fa2f6c9$export$462bb059fed9d9e5).newTwoColoredTextured(this.context) : (0, $8a8ff7c90fa2f6c9$export$462bb059fed9d9e5).newColoredTextured(this.context);
        this.batcher = new (0, $8f51e6f694760411$export$d398217aafc5a694)(this.context, twoColorTint);
        this.shapesShader = (0, $8a8ff7c90fa2f6c9$export$462bb059fed9d9e5).newColored(this.context);
        this.shapes = new (0, $11e63f9c55d0b5c0$export$8304e6ea0c546270)(this.context);
        this.skeletonRenderer = new (0, $4ef4615f5ebdea54$export$383ab220c2c9987a)(this.context, twoColorTint);
        this.skeletonDebugRenderer = new (0, $ca5c822b035b6df0$export$ce694abc08778c7a)(this.context);
    }
    dispose() {
        this.batcher.dispose();
        this.batcherShader.dispose();
        this.shapes.dispose();
        this.shapesShader.dispose();
        this.skeletonDebugRenderer.dispose();
    }
    begin() {
        this.camera.update();
        this.enableRenderer(this.batcher);
    }
    drawSkeleton(skeleton, premultipliedAlpha = false, slotRangeStart = -1, slotRangeEnd = -1, transform = null) {
        this.enableRenderer(this.batcher);
        this.skeletonRenderer.premultipliedAlpha = premultipliedAlpha;
        this.skeletonRenderer.draw(this.batcher, skeleton, slotRangeStart, slotRangeEnd, transform);
    }
    drawSkeletonDebug(skeleton, premultipliedAlpha = false, ignoredBones) {
        this.enableRenderer(this.shapes);
        this.skeletonDebugRenderer.premultipliedAlpha = premultipliedAlpha;
        this.skeletonDebugRenderer.draw(this.shapes, skeleton, ignoredBones);
    }
    drawTexture(texture, x, y, width, height, color) {
        this.enableRenderer(this.batcher);
        if (!color) color = $e8e79f3c1b8010ec$var$WHITE;
        var i = 0;
        $e8e79f3c1b8010ec$var$quad[i++] = x;
        $e8e79f3c1b8010ec$var$quad[i++] = y;
        $e8e79f3c1b8010ec$var$quad[i++] = color.r;
        $e8e79f3c1b8010ec$var$quad[i++] = color.g;
        $e8e79f3c1b8010ec$var$quad[i++] = color.b;
        $e8e79f3c1b8010ec$var$quad[i++] = color.a;
        $e8e79f3c1b8010ec$var$quad[i++] = 0;
        $e8e79f3c1b8010ec$var$quad[i++] = 1;
        if (this.twoColorTint) {
            $e8e79f3c1b8010ec$var$quad[i++] = 0;
            $e8e79f3c1b8010ec$var$quad[i++] = 0;
            $e8e79f3c1b8010ec$var$quad[i++] = 0;
            $e8e79f3c1b8010ec$var$quad[i++] = 0;
        }
        $e8e79f3c1b8010ec$var$quad[i++] = x + width;
        $e8e79f3c1b8010ec$var$quad[i++] = y;
        $e8e79f3c1b8010ec$var$quad[i++] = color.r;
        $e8e79f3c1b8010ec$var$quad[i++] = color.g;
        $e8e79f3c1b8010ec$var$quad[i++] = color.b;
        $e8e79f3c1b8010ec$var$quad[i++] = color.a;
        $e8e79f3c1b8010ec$var$quad[i++] = 1;
        $e8e79f3c1b8010ec$var$quad[i++] = 1;
        if (this.twoColorTint) {
            $e8e79f3c1b8010ec$var$quad[i++] = 0;
            $e8e79f3c1b8010ec$var$quad[i++] = 0;
            $e8e79f3c1b8010ec$var$quad[i++] = 0;
            $e8e79f3c1b8010ec$var$quad[i++] = 0;
        }
        $e8e79f3c1b8010ec$var$quad[i++] = x + width;
        $e8e79f3c1b8010ec$var$quad[i++] = y + height;
        $e8e79f3c1b8010ec$var$quad[i++] = color.r;
        $e8e79f3c1b8010ec$var$quad[i++] = color.g;
        $e8e79f3c1b8010ec$var$quad[i++] = color.b;
        $e8e79f3c1b8010ec$var$quad[i++] = color.a;
        $e8e79f3c1b8010ec$var$quad[i++] = 1;
        $e8e79f3c1b8010ec$var$quad[i++] = 0;
        if (this.twoColorTint) {
            $e8e79f3c1b8010ec$var$quad[i++] = 0;
            $e8e79f3c1b8010ec$var$quad[i++] = 0;
            $e8e79f3c1b8010ec$var$quad[i++] = 0;
            $e8e79f3c1b8010ec$var$quad[i++] = 0;
        }
        $e8e79f3c1b8010ec$var$quad[i++] = x;
        $e8e79f3c1b8010ec$var$quad[i++] = y + height;
        $e8e79f3c1b8010ec$var$quad[i++] = color.r;
        $e8e79f3c1b8010ec$var$quad[i++] = color.g;
        $e8e79f3c1b8010ec$var$quad[i++] = color.b;
        $e8e79f3c1b8010ec$var$quad[i++] = color.a;
        $e8e79f3c1b8010ec$var$quad[i++] = 0;
        $e8e79f3c1b8010ec$var$quad[i++] = 0;
        if (this.twoColorTint) {
            $e8e79f3c1b8010ec$var$quad[i++] = 0;
            $e8e79f3c1b8010ec$var$quad[i++] = 0;
            $e8e79f3c1b8010ec$var$quad[i++] = 0;
            $e8e79f3c1b8010ec$var$quad[i] = 0;
        }
        this.batcher.draw(texture, $e8e79f3c1b8010ec$var$quad, $e8e79f3c1b8010ec$var$QUAD_TRIANGLES);
    }
    drawTextureUV(texture, x, y, width, height, u, v, u2, v2, color) {
        this.enableRenderer(this.batcher);
        if (!color) color = $e8e79f3c1b8010ec$var$WHITE;
        var i = 0;
        $e8e79f3c1b8010ec$var$quad[i++] = x;
        $e8e79f3c1b8010ec$var$quad[i++] = y;
        $e8e79f3c1b8010ec$var$quad[i++] = color.r;
        $e8e79f3c1b8010ec$var$quad[i++] = color.g;
        $e8e79f3c1b8010ec$var$quad[i++] = color.b;
        $e8e79f3c1b8010ec$var$quad[i++] = color.a;
        $e8e79f3c1b8010ec$var$quad[i++] = u;
        $e8e79f3c1b8010ec$var$quad[i++] = v;
        if (this.twoColorTint) {
            $e8e79f3c1b8010ec$var$quad[i++] = 0;
            $e8e79f3c1b8010ec$var$quad[i++] = 0;
            $e8e79f3c1b8010ec$var$quad[i++] = 0;
            $e8e79f3c1b8010ec$var$quad[i++] = 0;
        }
        $e8e79f3c1b8010ec$var$quad[i++] = x + width;
        $e8e79f3c1b8010ec$var$quad[i++] = y;
        $e8e79f3c1b8010ec$var$quad[i++] = color.r;
        $e8e79f3c1b8010ec$var$quad[i++] = color.g;
        $e8e79f3c1b8010ec$var$quad[i++] = color.b;
        $e8e79f3c1b8010ec$var$quad[i++] = color.a;
        $e8e79f3c1b8010ec$var$quad[i++] = u2;
        $e8e79f3c1b8010ec$var$quad[i++] = v;
        if (this.twoColorTint) {
            $e8e79f3c1b8010ec$var$quad[i++] = 0;
            $e8e79f3c1b8010ec$var$quad[i++] = 0;
            $e8e79f3c1b8010ec$var$quad[i++] = 0;
            $e8e79f3c1b8010ec$var$quad[i++] = 0;
        }
        $e8e79f3c1b8010ec$var$quad[i++] = x + width;
        $e8e79f3c1b8010ec$var$quad[i++] = y + height;
        $e8e79f3c1b8010ec$var$quad[i++] = color.r;
        $e8e79f3c1b8010ec$var$quad[i++] = color.g;
        $e8e79f3c1b8010ec$var$quad[i++] = color.b;
        $e8e79f3c1b8010ec$var$quad[i++] = color.a;
        $e8e79f3c1b8010ec$var$quad[i++] = u2;
        $e8e79f3c1b8010ec$var$quad[i++] = v2;
        if (this.twoColorTint) {
            $e8e79f3c1b8010ec$var$quad[i++] = 0;
            $e8e79f3c1b8010ec$var$quad[i++] = 0;
            $e8e79f3c1b8010ec$var$quad[i++] = 0;
            $e8e79f3c1b8010ec$var$quad[i++] = 0;
        }
        $e8e79f3c1b8010ec$var$quad[i++] = x;
        $e8e79f3c1b8010ec$var$quad[i++] = y + height;
        $e8e79f3c1b8010ec$var$quad[i++] = color.r;
        $e8e79f3c1b8010ec$var$quad[i++] = color.g;
        $e8e79f3c1b8010ec$var$quad[i++] = color.b;
        $e8e79f3c1b8010ec$var$quad[i++] = color.a;
        $e8e79f3c1b8010ec$var$quad[i++] = u;
        $e8e79f3c1b8010ec$var$quad[i++] = v2;
        if (this.twoColorTint) {
            $e8e79f3c1b8010ec$var$quad[i++] = 0;
            $e8e79f3c1b8010ec$var$quad[i++] = 0;
            $e8e79f3c1b8010ec$var$quad[i++] = 0;
            $e8e79f3c1b8010ec$var$quad[i] = 0;
        }
        this.batcher.draw(texture, $e8e79f3c1b8010ec$var$quad, $e8e79f3c1b8010ec$var$QUAD_TRIANGLES);
    }
    drawTextureRotated(texture, x, y, width, height, pivotX, pivotY, angle, color) {
        this.enableRenderer(this.batcher);
        if (!color) color = $e8e79f3c1b8010ec$var$WHITE;
        // bottom left and top right corner points relative to origin
        let worldOriginX = x + pivotX;
        let worldOriginY = y + pivotY;
        let fx = -pivotX;
        let fy = -pivotY;
        let fx2 = width - pivotX;
        let fy2 = height - pivotY;
        // construct corner points, start from top left and go counter clockwise
        let p1x = fx;
        let p1y = fy;
        let p2x = fx;
        let p2y = fy2;
        let p3x = fx2;
        let p3y = fy2;
        let p4x = fx2;
        let p4y = fy;
        let x1 = 0;
        let y1 = 0;
        let x2 = 0;
        let y2 = 0;
        let x3 = 0;
        let y3 = 0;
        let x4 = 0;
        let y4 = 0;
        // rotate
        if (angle != 0) {
            let cos = (0, $1702fa998ec22e58$export$6a7ef315a0d1ef07).cosDeg(angle);
            let sin = (0, $1702fa998ec22e58$export$6a7ef315a0d1ef07).sinDeg(angle);
            x1 = cos * p1x - sin * p1y;
            y1 = sin * p1x + cos * p1y;
            x4 = cos * p2x - sin * p2y;
            y4 = sin * p2x + cos * p2y;
            x3 = cos * p3x - sin * p3y;
            y3 = sin * p3x + cos * p3y;
            x2 = x3 + (x1 - x4);
            y2 = y3 + (y1 - y4);
        } else {
            x1 = p1x;
            y1 = p1y;
            x4 = p2x;
            y4 = p2y;
            x3 = p3x;
            y3 = p3y;
            x2 = p4x;
            y2 = p4y;
        }
        x1 += worldOriginX;
        y1 += worldOriginY;
        x2 += worldOriginX;
        y2 += worldOriginY;
        x3 += worldOriginX;
        y3 += worldOriginY;
        x4 += worldOriginX;
        y4 += worldOriginY;
        var i = 0;
        $e8e79f3c1b8010ec$var$quad[i++] = x1;
        $e8e79f3c1b8010ec$var$quad[i++] = y1;
        $e8e79f3c1b8010ec$var$quad[i++] = color.r;
        $e8e79f3c1b8010ec$var$quad[i++] = color.g;
        $e8e79f3c1b8010ec$var$quad[i++] = color.b;
        $e8e79f3c1b8010ec$var$quad[i++] = color.a;
        $e8e79f3c1b8010ec$var$quad[i++] = 0;
        $e8e79f3c1b8010ec$var$quad[i++] = 1;
        if (this.twoColorTint) {
            $e8e79f3c1b8010ec$var$quad[i++] = 0;
            $e8e79f3c1b8010ec$var$quad[i++] = 0;
            $e8e79f3c1b8010ec$var$quad[i++] = 0;
            $e8e79f3c1b8010ec$var$quad[i++] = 0;
        }
        $e8e79f3c1b8010ec$var$quad[i++] = x2;
        $e8e79f3c1b8010ec$var$quad[i++] = y2;
        $e8e79f3c1b8010ec$var$quad[i++] = color.r;
        $e8e79f3c1b8010ec$var$quad[i++] = color.g;
        $e8e79f3c1b8010ec$var$quad[i++] = color.b;
        $e8e79f3c1b8010ec$var$quad[i++] = color.a;
        $e8e79f3c1b8010ec$var$quad[i++] = 1;
        $e8e79f3c1b8010ec$var$quad[i++] = 1;
        if (this.twoColorTint) {
            $e8e79f3c1b8010ec$var$quad[i++] = 0;
            $e8e79f3c1b8010ec$var$quad[i++] = 0;
            $e8e79f3c1b8010ec$var$quad[i++] = 0;
            $e8e79f3c1b8010ec$var$quad[i++] = 0;
        }
        $e8e79f3c1b8010ec$var$quad[i++] = x3;
        $e8e79f3c1b8010ec$var$quad[i++] = y3;
        $e8e79f3c1b8010ec$var$quad[i++] = color.r;
        $e8e79f3c1b8010ec$var$quad[i++] = color.g;
        $e8e79f3c1b8010ec$var$quad[i++] = color.b;
        $e8e79f3c1b8010ec$var$quad[i++] = color.a;
        $e8e79f3c1b8010ec$var$quad[i++] = 1;
        $e8e79f3c1b8010ec$var$quad[i++] = 0;
        if (this.twoColorTint) {
            $e8e79f3c1b8010ec$var$quad[i++] = 0;
            $e8e79f3c1b8010ec$var$quad[i++] = 0;
            $e8e79f3c1b8010ec$var$quad[i++] = 0;
            $e8e79f3c1b8010ec$var$quad[i++] = 0;
        }
        $e8e79f3c1b8010ec$var$quad[i++] = x4;
        $e8e79f3c1b8010ec$var$quad[i++] = y4;
        $e8e79f3c1b8010ec$var$quad[i++] = color.r;
        $e8e79f3c1b8010ec$var$quad[i++] = color.g;
        $e8e79f3c1b8010ec$var$quad[i++] = color.b;
        $e8e79f3c1b8010ec$var$quad[i++] = color.a;
        $e8e79f3c1b8010ec$var$quad[i++] = 0;
        $e8e79f3c1b8010ec$var$quad[i++] = 0;
        if (this.twoColorTint) {
            $e8e79f3c1b8010ec$var$quad[i++] = 0;
            $e8e79f3c1b8010ec$var$quad[i++] = 0;
            $e8e79f3c1b8010ec$var$quad[i++] = 0;
            $e8e79f3c1b8010ec$var$quad[i] = 0;
        }
        this.batcher.draw(texture, $e8e79f3c1b8010ec$var$quad, $e8e79f3c1b8010ec$var$QUAD_TRIANGLES);
    }
    drawRegion(region, x, y, width, height, color) {
        this.enableRenderer(this.batcher);
        if (!color) color = $e8e79f3c1b8010ec$var$WHITE;
        var i = 0;
        $e8e79f3c1b8010ec$var$quad[i++] = x;
        $e8e79f3c1b8010ec$var$quad[i++] = y;
        $e8e79f3c1b8010ec$var$quad[i++] = color.r;
        $e8e79f3c1b8010ec$var$quad[i++] = color.g;
        $e8e79f3c1b8010ec$var$quad[i++] = color.b;
        $e8e79f3c1b8010ec$var$quad[i++] = color.a;
        $e8e79f3c1b8010ec$var$quad[i++] = region.u;
        $e8e79f3c1b8010ec$var$quad[i++] = region.v2;
        if (this.twoColorTint) {
            $e8e79f3c1b8010ec$var$quad[i++] = 0;
            $e8e79f3c1b8010ec$var$quad[i++] = 0;
            $e8e79f3c1b8010ec$var$quad[i++] = 0;
            $e8e79f3c1b8010ec$var$quad[i++] = 0;
        }
        $e8e79f3c1b8010ec$var$quad[i++] = x + width;
        $e8e79f3c1b8010ec$var$quad[i++] = y;
        $e8e79f3c1b8010ec$var$quad[i++] = color.r;
        $e8e79f3c1b8010ec$var$quad[i++] = color.g;
        $e8e79f3c1b8010ec$var$quad[i++] = color.b;
        $e8e79f3c1b8010ec$var$quad[i++] = color.a;
        $e8e79f3c1b8010ec$var$quad[i++] = region.u2;
        $e8e79f3c1b8010ec$var$quad[i++] = region.v2;
        if (this.twoColorTint) {
            $e8e79f3c1b8010ec$var$quad[i++] = 0;
            $e8e79f3c1b8010ec$var$quad[i++] = 0;
            $e8e79f3c1b8010ec$var$quad[i++] = 0;
            $e8e79f3c1b8010ec$var$quad[i++] = 0;
        }
        $e8e79f3c1b8010ec$var$quad[i++] = x + width;
        $e8e79f3c1b8010ec$var$quad[i++] = y + height;
        $e8e79f3c1b8010ec$var$quad[i++] = color.r;
        $e8e79f3c1b8010ec$var$quad[i++] = color.g;
        $e8e79f3c1b8010ec$var$quad[i++] = color.b;
        $e8e79f3c1b8010ec$var$quad[i++] = color.a;
        $e8e79f3c1b8010ec$var$quad[i++] = region.u2;
        $e8e79f3c1b8010ec$var$quad[i++] = region.v;
        if (this.twoColorTint) {
            $e8e79f3c1b8010ec$var$quad[i++] = 0;
            $e8e79f3c1b8010ec$var$quad[i++] = 0;
            $e8e79f3c1b8010ec$var$quad[i++] = 0;
            $e8e79f3c1b8010ec$var$quad[i++] = 0;
        }
        $e8e79f3c1b8010ec$var$quad[i++] = x;
        $e8e79f3c1b8010ec$var$quad[i++] = y + height;
        $e8e79f3c1b8010ec$var$quad[i++] = color.r;
        $e8e79f3c1b8010ec$var$quad[i++] = color.g;
        $e8e79f3c1b8010ec$var$quad[i++] = color.b;
        $e8e79f3c1b8010ec$var$quad[i++] = color.a;
        $e8e79f3c1b8010ec$var$quad[i++] = region.u;
        $e8e79f3c1b8010ec$var$quad[i++] = region.v;
        if (this.twoColorTint) {
            $e8e79f3c1b8010ec$var$quad[i++] = 0;
            $e8e79f3c1b8010ec$var$quad[i++] = 0;
            $e8e79f3c1b8010ec$var$quad[i++] = 0;
            $e8e79f3c1b8010ec$var$quad[i] = 0;
        }
        this.batcher.draw(region.page.texture, $e8e79f3c1b8010ec$var$quad, $e8e79f3c1b8010ec$var$QUAD_TRIANGLES);
    }
    line(x, y, x2, y2, color, color2) {
        this.enableRenderer(this.shapes);
        this.shapes.line(x, y, x2, y2, color);
    }
    triangle(filled, x, y, x2, y2, x3, y3, color, color2, color3) {
        this.enableRenderer(this.shapes);
        this.shapes.triangle(filled, x, y, x2, y2, x3, y3, color, color2, color3);
    }
    quad(filled, x, y, x2, y2, x3, y3, x4, y4, color, color2, color3, color4) {
        this.enableRenderer(this.shapes);
        this.shapes.quad(filled, x, y, x2, y2, x3, y3, x4, y4, color, color2, color3, color4);
    }
    rect(filled, x, y, width, height, color) {
        this.enableRenderer(this.shapes);
        this.shapes.rect(filled, x, y, width, height, color);
    }
    rectLine(filled, x1, y1, x2, y2, width, color) {
        this.enableRenderer(this.shapes);
        this.shapes.rectLine(filled, x1, y1, x2, y2, width, color);
    }
    polygon(polygonVertices, offset, count, color) {
        this.enableRenderer(this.shapes);
        this.shapes.polygon(polygonVertices, offset, count, color);
    }
    circle(filled, x, y, radius, color, segments = 0) {
        this.enableRenderer(this.shapes);
        this.shapes.circle(filled, x, y, radius, color, segments);
    }
    curve(x1, y1, cx1, cy1, cx2, cy2, x2, y2, segments, color) {
        this.enableRenderer(this.shapes);
        this.shapes.curve(x1, y1, cx1, cy1, cx2, cy2, x2, y2, segments, color);
    }
    end() {
        if (this.activeRenderer === this.batcher) this.batcher.end();
        else if (this.activeRenderer === this.shapes) this.shapes.end();
        this.activeRenderer = null;
    }
    resize(resizeMode) {
        let canvas = this.canvas;
        var dpr = window.devicePixelRatio || 1;
        var w = Math.round(canvas.clientWidth * dpr);
        var h = Math.round(canvas.clientHeight * dpr);
        if (canvas.width != w || canvas.height != h) {
            canvas.width = w;
            canvas.height = h;
        }
        this.context.gl.viewport(0, 0, canvas.width, canvas.height);
        // Nothing to do for stretch, we simply apply the viewport size of the camera.
        if (resizeMode === $e8e79f3c1b8010ec$export$5d6d136f0a4d9153.Expand) this.camera.setViewport(w, h);
        else if (resizeMode === $e8e79f3c1b8010ec$export$5d6d136f0a4d9153.Fit) {
            let sourceWidth = canvas.width, sourceHeight = canvas.height;
            let targetWidth = this.camera.viewportWidth, targetHeight = this.camera.viewportHeight;
            let targetRatio = targetHeight / targetWidth;
            let sourceRatio = sourceHeight / sourceWidth;
            let scale = targetRatio < sourceRatio ? targetWidth / sourceWidth : targetHeight / sourceHeight;
            this.camera.setViewport(sourceWidth * scale, sourceHeight * scale);
        }
        this.camera.update();
    }
    enableRenderer(renderer) {
        if (this.activeRenderer === renderer) return;
        this.end();
        if (renderer instanceof (0, $8f51e6f694760411$export$d398217aafc5a694)) {
            this.batcherShader.bind();
            this.batcherShader.setUniform4x4f((0, $8a8ff7c90fa2f6c9$export$462bb059fed9d9e5).MVP_MATRIX, this.camera.projectionView.values);
            this.batcherShader.setUniformi("u_texture", 0);
            this.batcher.begin(this.batcherShader);
            this.activeRenderer = this.batcher;
        } else if (renderer instanceof (0, $11e63f9c55d0b5c0$export$8304e6ea0c546270)) {
            this.shapesShader.bind();
            this.shapesShader.setUniform4x4f((0, $8a8ff7c90fa2f6c9$export$462bb059fed9d9e5).MVP_MATRIX, this.camera.projectionView.values);
            this.shapes.begin(this.shapesShader);
            this.activeRenderer = this.shapes;
        } else this.activeRenderer = this.skeletonDebugRenderer;
    }
}
var $e8e79f3c1b8010ec$export$5d6d136f0a4d9153;
(function(ResizeMode) {
    ResizeMode[ResizeMode["Stretch"] = 0] = "Stretch";
    ResizeMode[ResizeMode["Expand"] = 1] = "Expand";
    ResizeMode[ResizeMode["Fit"] = 2] = "Fit";
})($e8e79f3c1b8010ec$export$5d6d136f0a4d9153 || ($e8e79f3c1b8010ec$export$5d6d136f0a4d9153 = {}));


let $ec27ae8f38585a40$var$spinnerImage;
let $ec27ae8f38585a40$var$logoImage;
let $ec27ae8f38585a40$var$loaded = 0;
const $ec27ae8f38585a40$var$FADE_IN = 1, $ec27ae8f38585a40$var$FADE_OUT = 1;
const $ec27ae8f38585a40$var$logoWidth = 165, $ec27ae8f38585a40$var$logoHeight = 108, $ec27ae8f38585a40$var$spinnerSize = 163;
class $ec27ae8f38585a40$export$e2b0760399e6dece {
    renderer;
    logo = null;
    spinner = null;
    angle = 0;
    fadeOut = 0;
    fadeIn = 0;
    timeKeeper = new (0, $1702fa998ec22e58$export$ab19517904b64359)();
    backgroundColor = new (0, $1702fa998ec22e58$export$892596cec99bc70e)(0.135, 0.135, 0.135, 1);
    tempColor = new (0, $1702fa998ec22e58$export$892596cec99bc70e)();
    constructor(renderer){
        this.renderer = renderer;
        this.timeKeeper.maxDelta = 9;
        if (!$ec27ae8f38585a40$var$logoImage) {
            let isSafari = navigator.userAgent.indexOf("Safari") > -1; // Thank you Apple Inc.
            let onload = ()=>$ec27ae8f38585a40$var$loaded++;
            $ec27ae8f38585a40$var$logoImage = new Image();
            $ec27ae8f38585a40$var$logoImage.src = $ec27ae8f38585a40$var$SPINE_LOGO_DATA;
            if (!isSafari) $ec27ae8f38585a40$var$logoImage.crossOrigin = "anonymous";
            $ec27ae8f38585a40$var$logoImage.onload = onload;
            $ec27ae8f38585a40$var$spinnerImage = new Image();
            $ec27ae8f38585a40$var$spinnerImage.src = $ec27ae8f38585a40$var$SPINNER_DATA;
            if (!isSafari) $ec27ae8f38585a40$var$spinnerImage.crossOrigin = "anonymous";
            $ec27ae8f38585a40$var$spinnerImage.onload = onload;
        }
    }
    dispose() {
        this.logo?.dispose();
        this.spinner?.dispose();
    }
    draw(complete = false) {
        if ($ec27ae8f38585a40$var$loaded < 2 || complete && this.fadeOut > $ec27ae8f38585a40$var$FADE_OUT) return;
        this.timeKeeper.update();
        let a = Math.abs(Math.sin(this.timeKeeper.totalTime + 0.25));
        this.angle -= this.timeKeeper.delta * 200 * (1 + 1.5 * Math.pow(a, 5));
        let tempColor = this.tempColor;
        let renderer = this.renderer;
        let canvas = renderer.canvas;
        let gl = renderer.context.gl;
        renderer.resize((0, $e8e79f3c1b8010ec$export$5d6d136f0a4d9153).Expand);
        renderer.camera.position.set(canvas.width / 2, canvas.height / 2, 0);
        renderer.batcher.setBlendMode((0, $64f50722bcc00a44$export$c9b8fe72ac71821).Normal, true);
        if (complete) {
            this.fadeOut += this.timeKeeper.delta * (this.timeKeeper.totalTime < 1 ? 2 : 1);
            if (this.fadeOut > $ec27ae8f38585a40$var$FADE_OUT) return;
            tempColor.setFromColor(this.backgroundColor);
            a = 1 - this.fadeOut / $ec27ae8f38585a40$var$FADE_OUT;
            a = 1 - (a - 1) * (a - 1);
            tempColor.a *= a;
            if (tempColor.a > 0) {
                renderer.camera.zoom = 1;
                renderer.begin();
                renderer.quad(true, 0, 0, canvas.width, 0, canvas.width, canvas.height, 0, canvas.height, tempColor, tempColor, tempColor, tempColor);
                renderer.end();
            }
        } else {
            this.fadeIn += this.timeKeeper.delta;
            if (this.backgroundColor.a > 0) {
                gl.clearColor(this.backgroundColor.r, this.backgroundColor.g, this.backgroundColor.b, this.backgroundColor.a);
                gl.clear(gl.COLOR_BUFFER_BIT);
            }
            a = 1;
        }
        a *= Math.min(this.fadeIn / $ec27ae8f38585a40$var$FADE_IN, 1);
        tempColor.set(a, a, a, a);
        if (!this.logo) {
            this.logo = new (0, $d0ec9bcdfbe617c0$export$6c73c2a4561c07a2)(renderer.context, $ec27ae8f38585a40$var$logoImage);
            this.spinner = new (0, $d0ec9bcdfbe617c0$export$6c73c2a4561c07a2)(renderer.context, $ec27ae8f38585a40$var$spinnerImage);
        }
        renderer.camera.zoom = Math.max(1, $ec27ae8f38585a40$var$spinnerSize / canvas.height);
        renderer.begin();
        renderer.drawTexture(this.logo, (canvas.width - $ec27ae8f38585a40$var$logoWidth) / 2, (canvas.height - $ec27ae8f38585a40$var$logoHeight) / 2, $ec27ae8f38585a40$var$logoWidth, $ec27ae8f38585a40$var$logoHeight, tempColor);
        if (this.spinner) renderer.drawTextureRotated(this.spinner, (canvas.width - $ec27ae8f38585a40$var$spinnerSize) / 2, (canvas.height - $ec27ae8f38585a40$var$spinnerSize) / 2, $ec27ae8f38585a40$var$spinnerSize, $ec27ae8f38585a40$var$spinnerSize, $ec27ae8f38585a40$var$spinnerSize / 2, $ec27ae8f38585a40$var$spinnerSize / 2, this.angle, tempColor);
        renderer.end();
    }
}
let $ec27ae8f38585a40$var$SPINNER_DATA = "data:image/png;base64,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";
let $ec27ae8f38585a40$var$SPINE_LOGO_DATA = "data:image/png;base64,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";










/******************************************************************************
 * Spine Runtimes License Agreement
 * Last updated July 28, 2023. Replaces all prior versions.
 *
 * Copyright (c) 2013-2023, Esoteric Software LLC
 *
 * Integration of the Spine Runtimes into software or otherwise creating
 * derivative works of the Spine Runtimes is permitted under the terms and
 * conditions of Section 2 of the Spine Editor License Agreement:
 * http://esotericsoftware.com/spine-editor-license
 *
 * Otherwise, it is permitted to integrate the Spine Runtimes into software or
 * otherwise create derivative works of the Spine Runtimes (collectively,
 * "Products"), provided that each user of the Products must obtain their own
 * Spine Editor license and redistribution of the Products in any form must
 * include this license and copyright notice.
 *
 * THE SPINE RUNTIMES ARE PROVIDED BY ESOTERIC SOFTWARE LLC "AS IS" AND ANY
 * EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
 * WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE
 * DISCLAIMED. IN NO EVENT SHALL ESOTERIC SOFTWARE LLC BE LIABLE FOR ANY
 * DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES
 * (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES,
 * BUSINESS INTERRUPTION, OR LOSS OF USE, DATA, OR PROFITS) HOWEVER CAUSED AND
 * ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT
 * (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THE
 * SPINE RUNTIMES, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
 *****************************************************************************/ 
class $1515af16ab92d264$export$2985f0cbdc74acab {
    config;
    context;
    /** Tracks the current time, delta, and other time related statistics. */ time = new (0, $1702fa998ec22e58$export$ab19517904b64359)();
    /** The HTML canvas to render to. */ htmlCanvas;
    /** The WebGL rendering context. */ gl;
    /** The scene renderer for easy drawing of skeletons, shapes, and images. */ renderer;
    /** The asset manager to load assets with. */ assetManager;
    /** The input processor used to listen to mouse, touch, and keyboard events. */ input;
    disposed = false;
    /** Constructs a new spine canvas, rendering to the provided HTML canvas. */ constructor(canvas, config){
        this.config = config;
        if (!config.pathPrefix) config.pathPrefix = "";
        if (!config.app) config.app = {
            loadAssets: ()=>{},
            initialize: ()=>{},
            update: ()=>{},
            render: ()=>{},
            error: ()=>{},
            dispose: ()=>{}
        };
        if (!config.webglConfig) config.webglConfig = {
            alpha: true
        };
        this.htmlCanvas = canvas;
        this.context = new (0, $d702f730bad78eda$export$a4d6d43057cae2ac)(canvas, config.webglConfig);
        this.renderer = new (0, $e8e79f3c1b8010ec$export$d172b6b77f76007c)(canvas, this.context);
        this.gl = this.context.gl;
        this.assetManager = new (0, $abea8e8cabf3badd$export$85f9686224250ac3)(this.context, config.pathPrefix);
        this.input = new (0, $f2aa140968060cbb$export$f5b8910cec6cf069)(canvas);
        if (config.app.loadAssets) config.app.loadAssets(this);
        let loop = ()=>{
            if (this.disposed) return;
            requestAnimationFrame(loop);
            this.time.update();
            if (config.app.update) config.app.update(this, this.time.delta);
            if (config.app.render) config.app.render(this);
        };
        let waitForAssets = ()=>{
            if (this.disposed) return;
            if (this.assetManager.isLoadingComplete()) {
                if (this.assetManager.hasErrors()) {
                    if (config.app.error) config.app.error(this, this.assetManager.getErrors());
                } else {
                    if (config.app.initialize) config.app.initialize(this);
                    loop();
                }
                return;
            }
            requestAnimationFrame(waitForAssets);
        };
        requestAnimationFrame(waitForAssets);
    }
    /** Clears the canvas with the given color. The color values are given in the range [0,1]. */ clear(r, g, b, a) {
        this.gl.clearColor(r, g, b, a);
        this.gl.clear(this.gl.COLOR_BUFFER_BIT);
    }
    /** Disposes the app, so the update() and render() functions are no longer called. Calls the dispose() callback.*/ dispose() {
        if (this.config.app.dispose) this.config.app.dispose(this);
        this.disposed = true;
    }
}







class $781d0b326a8f1540$export$a928bbadb775ec2a {
    config;
    parent;
    dom;
    canvas = null;
    context = null;
    sceneRenderer = null;
    loadingScreen = null;
    assetManager = null;
    bg = new (0, $1702fa998ec22e58$export$892596cec99bc70e)();
    bgFullscreen = new (0, $1702fa998ec22e58$export$892596cec99bc70e)();
    playerControls = null;
    timelineSlider = null;
    playButton = null;
    skinButton = null;
    animationButton = null;
    playTime = 0;
    selectedBones = [];
    cancelId = 0;
    popup = null;
    /* True if the player is unable to load or render the skeleton. */ error = false;
    /* The player's skeleton. Null until loading is complete (access after config.success). */ skeleton = null;
    /* The animation state controlling the skeleton. Null until loading is complete (access after config.success). */ animationState = null;
    paused = true;
    speed = 1;
    time = new (0, $1702fa998ec22e58$export$ab19517904b64359)();
    stopRequestAnimationFrame = false;
    disposed = false;
    viewport = {};
    currentViewport = {};
    previousViewport = {};
    viewportTransitionStart = 0;
    eventListeners = [];
    constructor(parent, config){
        this.config = config;
        let parentDom = typeof parent === "string" ? document.getElementById(parent) : parent;
        if (parentDom == null) throw new Error("SpinePlayer parent not found: " + parent);
        this.parent = parentDom;
        if (config.showControls === void 0) config.showControls = true;
        let controls = config.showControls ? /*html*/ `
<div class="spine-player-controls spine-player-popup-parent spine-player-controls-hidden">
<div class="spine-player-timeline"></div>
<div class="spine-player-buttons">
<button class="spine-player-button spine-player-button-icon-pause"></button>
<div class="spine-player-button-spacer"></div>
<button class="spine-player-button spine-player-button-icon-speed"></button>
<button class="spine-player-button spine-player-button-icon-animations"></button>
<button class="spine-player-button spine-player-button-icon-skins"></button>
<button class="spine-player-button spine-player-button-icon-settings"></button>
<button class="spine-player-button spine-player-button-icon-fullscreen"></button>
<img class="spine-player-button-icon-spine-logo" src="data:image/svg+xml,%3Csvg%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20viewBox%3D%220%200%20104%2031.16%22%3E%3Cpath%20d%3D%22M104%2012.68a1.31%201.31%200%200%201-.37%201%201.28%201.28%200%200%201-.85.31H91.57a10.51%2010.51%200%200%200%20.29%202.55%204.92%204.92%200%200%200%201%202%204.27%204.27%200%200%200%201.64%201.26%206.89%206.89%200%200%200%202.6.44%2010.66%2010.66%200%200%200%202.17-.2%2012.81%2012.81%200%200%200%201.64-.44q.69-.25%201.14-.44a1.87%201.87%200%200%201%20.68-.2.44.44%200%200%201%20.27.04.43.43%200%200%201%20.16.2%201.38%201.38%200%200%201%20.09.37%204.89%204.89%200%200%201%200%20.58%204.14%204.14%200%200%201%200%20.43v.32a.83.83%200%200%201-.09.26%201.1%201.1%200%200%201-.17.22%202.77%202.77%200%200%201-.61.34%208.94%208.94%200%200%201-1.32.46%2018.54%2018.54%200%200%201-1.88.41%2013.78%2013.78%200%200%201-2.28.18%2010.55%2010.55%200%200%201-3.68-.59%206.82%206.82%200%200%201-2.66-1.74%207.44%207.44%200%200%201-1.63-2.89%2013.48%2013.48%200%200%201-.55-4%2012.76%2012.76%200%200%201%20.57-3.94%208.35%208.35%200%200%201%201.64-3%207.15%207.15%200%200%201%202.58-1.87%208.47%208.47%200%200%201%203.39-.65%208.19%208.19%200%200%201%203.41.64%206.46%206.46%200%200%201%202.32%201.73%207%207%200%200%201%201.3%202.54%2011.17%2011.17%200%200%201%20.43%203.13zm-3.14-.93a5.69%205.69%200%200%200-1.09-3.86%204.17%204.17%200%200%200-3.42-1.4%204.52%204.52%200%200%200-2%20.44%204.41%204.41%200%200%200-1.47%201.15A5.29%205.29%200%200%200%2092%209.75a7%207%200%200%200-.36%202zM80.68%2021.94a.42.42%200%200%201-.08.26.59.59%200%200%201-.25.18%201.74%201.74%200%200%201-.47.11%206.31%206.31%200%200%201-.76%200%206.5%206.5%200%200%201-.78%200%201.74%201.74%200%200%201-.47-.11.59.59%200%200%201-.25-.18.42.42%200%200%201-.08-.26V12a9.8%209.8%200%200%200-.23-2.35%204.86%204.86%200%200%200-.66-1.53%202.88%202.88%200%200%200-1.13-1%203.57%203.57%200%200%200-1.6-.34%204%204%200%200%200-2.35.83A12.71%2012.71%200%200%200%2069.11%2010v11.9a.42.42%200%200%201-.08.26.59.59%200%200%201-.25.18%201.74%201.74%200%200%201-.47.11%206.51%206.51%200%200%201-.78%200%206.31%206.31%200%200%201-.76%200%201.88%201.88%200%200%201-.48-.11.52.52%200%200%201-.25-.18.46.46%200%200%201-.07-.26v-17a.53.53%200%200%201%20.03-.21.5.5%200%200%201%20.23-.19%201.28%201.28%200%200%201%20.44-.11%208.53%208.53%200%200%201%201.39%200%201.12%201.12%200%200%201%20.43.11.6.6%200%200%201%20.22.19.47.47%200%200%201%20.07.26V7.2a10.46%2010.46%200%200%201%202.87-2.36%206.17%206.17%200%200%201%202.88-.75%206.41%206.41%200%200%201%202.87.58%205.16%205.16%200%200%201%201.88%201.54%206.15%206.15%200%200%201%201%202.26%2013.46%2013.46%200%200%201%20.31%203.11z%22%20fill%3D%22%23fff%22%2F%3E%3Cpath%20d%3D%22M43.35%202.86c.09%202.6%201.89%204%205.48%204.61%203%20.48%205.79.24%206.69-2.37%201.75-5.09-2.4-3.82-6-4.39s-6.31-2.03-6.17%202.15zm1.08%2010.69c.33%201.94%202.14%203.06%204.91%203s4.84-1.16%205.13-3.25c.53-3.88-2.53-2.38-5.3-2.3s-5.4-1.26-4.74%202.55zM48%2022.44c.55%201.45%202.06%202.06%204.1%201.63s3.45-1.11%203.33-2.76c-.21-3.06-2.22-2.1-4.26-1.66S47%2019.6%2048%2022.44zm1.78%206.78c.16%201.22%201.22%202%202.88%201.93s2.92-.67%203.13-2c.4-2.43-1.46-1.53-3.12-1.51s-3.17-.82-2.89%201.58z%22%20fill%3D%22%23ff4000%22%2F%3E%3Cpath%20d%3D%22M35.28%2013.16a15.33%2015.33%200%200%201-.48%204%208.75%208.75%200%200%201-1.42%203%206.35%206.35%200%200%201-2.32%201.91%207.14%207.14%200%200%201-3.16.67%206.1%206.1%200%200%201-1.4-.15%205.34%205.34%200%200%201-1.26-.47%207.29%207.29%200%200%201-1.24-.81q-.61-.49-1.29-1.15v8.51a.47.47%200%200%201-.08.26.56.56%200%200%201-.25.19%201.74%201.74%200%200%201-.47.11%206.47%206.47%200%200%201-.78%200%206.26%206.26%200%200%201-.76%200%201.89%201.89%200%200%201-.48-.11.49.49%200%200%201-.25-.19.51.51%200%200%201-.07-.26V4.91a.57.57%200%200%201%20.06-.27.46.46%200%200%201%20.23-.18%201.47%201.47%200%200%201%20.44-.1%207.41%207.41%200%200%201%201.3%200%201.45%201.45%200%200%201%20.43.1.52.52%200%200%201%20.24.18.51.51%200%200%201%20.07.27V7.2a18.06%2018.06%200%200%201%201.49-1.38%209%209%200%200%201%201.45-1%206.82%206.82%200%200%201%201.49-.59%207.09%207.09%200%200%201%204.78.52%206%206%200%200%201%202.13%202%208.79%208.79%200%200%201%201.2%202.9%2015.72%2015.72%200%200%201%20.4%203.51zm-3.28.36a15.64%2015.64%200%200%200-.2-2.53%207.32%207.32%200%200%200-.69-2.17%204.06%204.06%200%200%200-1.3-1.51%203.49%203.49%200%200%200-2-.57%204.1%204.1%200%200%200-1.2.18%204.92%204.92%200%200%200-1.2.57%208.54%208.54%200%200%200-1.28%201A15.77%2015.77%200%200%200%2022.76%2010v6.77a13.53%2013.53%200%200%200%202.46%202.4%204.12%204.12%200%200%200%202.44.83%203.56%203.56%200%200%200%202-.57A4.28%204.28%200%200%200%2031%2018a7.58%207.58%200%200%200%20.77-2.12%2011.43%2011.43%200%200%200%20.23-2.36zM12%2017.3a5.39%205.39%200%200%201-.48%202.33%204.73%204.73%200%200%201-1.37%201.72%206.19%206.19%200%200%201-2.12%201.06%209.62%209.62%200%200%201-2.71.36%2010.38%2010.38%200%200%201-3.21-.5A7.63%207.63%200%200%201%201%2021.82a3.25%203.25%200%200%201-.66-.43%201.09%201.09%200%200%201-.3-.53%203.59%203.59%200%200%201-.04-.93%204.06%204.06%200%200%201%200-.61%202%202%200%200%201%20.09-.4.42.42%200%200%201%20.16-.22.43.43%200%200%201%20.24-.07%201.35%201.35%200%200%201%20.61.26q.41.26%201%20.56a9.22%209.22%200%200%200%201.41.55%206.25%206.25%200%200%200%201.87.26%205.62%205.62%200%200%200%201.44-.17%203.48%203.48%200%200%200%201.12-.5%202.23%202.23%200%200%200%20.73-.84%202.68%202.68%200%200%200%20.26-1.21%202%202%200%200%200-.37-1.21%203.55%203.55%200%200%200-1-.87%208.09%208.09%200%200%200-1.36-.66l-1.56-.61a16%2016%200%200%201-1.57-.73%206%206%200%200%201-1.37-1%204.52%204.52%200%200%201-1-1.4%204.69%204.69%200%200%201-.37-2%204.88%204.88%200%200%201%20.39-1.87%204.46%204.46%200%200%201%201.16-1.61%205.83%205.83%200%200%201%201.94-1.11A8.06%208.06%200%200%201%206.53%204a8.28%208.28%200%200%201%201.36.11%209.36%209.36%200%200%201%201.23.28%205.92%205.92%200%200%201%20.94.37%204.09%204.09%200%200%201%20.59.35%201%201%200%200%201%20.26.26.83.83%200%200%201%20.09.26%201.32%201.32%200%200%200%20.06.35%203.87%203.87%200%200%201%200%20.51%204.76%204.76%200%200%201%200%20.56%201.39%201.39%200%200%201-.09.39.5.5%200%200%201-.16.22.35.35%200%200%201-.21.07%201%201%200%200%201-.49-.21%207%207%200%200%200-.83-.44%209.26%209.26%200%200%200-1.2-.44%205.49%205.49%200%200%200-1.58-.16%204.93%204.93%200%200%200-1.4.18%202.69%202.69%200%200%200-1%20.51%202.16%202.16%200%200%200-.59.83%202.43%202.43%200%200%200-.2%201%202%202%200%200%200%20.38%201.24%203.6%203.6%200%200%200%201%20.88%208.25%208.25%200%200%200%201.38.68l1.58.62q.8.32%201.59.72a6%206%200%200%201%201.39%201%204.37%204.37%200%200%201%201%201.36%204.46%204.46%200%200%201%20.37%201.8z%22%20fill%3D%22%23fff%22%2F%3E%3C%2Fsvg%3E">
</div></div>` : "";
        this.parent.appendChild(this.dom = $781d0b326a8f1540$var$createElement(/*html*/ `<div class="spine-player" style="position:relative;height:100%"><canvas class="spine-player-canvas" style="display:block;width:100%;height:100%"></canvas>${controls}</div>`));
        try {
            this.validateConfig(config);
        } catch (e) {
            this.showError(e.message, e);
        }
        this.initialize();
        // Register a global resize handler to redraw, avoiding flicker.
        this.addEventListener(window, "resize", ()=>this.drawFrame(false));
        // Start the rendering loop.
        requestAnimationFrame(()=>this.drawFrame());
    }
    dispose() {
        this.sceneRenderer?.dispose();
        this.loadingScreen?.dispose();
        this.assetManager?.dispose();
        for(var i = 0; i < this.eventListeners.length; i++){
            var eventListener = this.eventListeners[i];
            eventListener.target.removeEventListener(eventListener.event, eventListener.func);
        }
        this.parent.removeChild(this.dom);
        this.disposed = true;
    }
    addEventListener(target, event, func) {
        this.eventListeners.push({
            target: target,
            event: event,
            func: func
        });
        target.addEventListener(event, func);
    }
    validateConfig(config) {
        if (!config) throw new Error("A configuration object must be passed to to new SpinePlayer().");
        if (config.skelUrl) config.binaryUrl = config.skelUrl;
        if (!config.jsonUrl && !config.binaryUrl) throw new Error("A URL must be specified for the skeleton JSON or binary file.");
        if (!config.atlasUrl) throw new Error("A URL must be specified for the atlas file.");
        if (!config.backgroundColor) config.backgroundColor = config.alpha ? "00000000" : "000000";
        if (!config.fullScreenBackgroundColor) config.fullScreenBackgroundColor = config.backgroundColor;
        if (config.backgroundImage && !config.backgroundImage.url) config.backgroundImage = undefined;
        if (config.premultipliedAlpha === void 0) config.premultipliedAlpha = true;
        if (config.preserveDrawingBuffer === void 0) config.preserveDrawingBuffer = false;
        if (config.mipmaps === void 0) config.mipmaps = true;
        if (!config.debug) config.debug = {
            bones: false,
            clipping: false,
            bounds: false,
            hulls: false,
            meshes: false,
            paths: false,
            points: false,
            regions: false
        };
        if (config.animations && config.animation && config.animations.indexOf(config.animation) < 0) throw new Error("Animation '" + config.animation + "' is not in the config animation list: " + $781d0b326a8f1540$var$toString(config.animations));
        if (config.skins && config.skin && config.skins.indexOf(config.skin) < 0) throw new Error("Default skin '" + config.skin + "' is not in the config skins list: " + $781d0b326a8f1540$var$toString(config.skins));
        if (!config.viewport) config.viewport = {};
        if (!config.viewport.animations) config.viewport.animations = {};
        if (config.viewport.debugRender === void 0) config.viewport.debugRender = false;
        if (config.viewport.transitionTime === void 0) config.viewport.transitionTime = 0.25;
        if (!config.controlBones) config.controlBones = [];
        if (config.showLoading === void 0) config.showLoading = true;
        if (config.defaultMix === void 0) config.defaultMix = 0.25;
    }
    initialize() {
        let config = this.config;
        let dom = this.dom;
        if (!config.alpha) {
            let hex = config.backgroundColor;
            this.dom.style.backgroundColor = (hex.charAt(0) == "#" ? hex : "#" + hex).substr(0, 7);
        }
        try {
            // Setup the OpenGL context.
            this.canvas = $781d0b326a8f1540$var$findWithClass(dom, "spine-player-canvas");
            this.context = new (0, $d702f730bad78eda$export$a4d6d43057cae2ac)(this.canvas, {
                alpha: config.alpha,
                preserveDrawingBuffer: config.preserveDrawingBuffer
            });
            // Setup the scene renderer and loading screen.
            this.sceneRenderer = new (0, $e8e79f3c1b8010ec$export$d172b6b77f76007c)(this.canvas, this.context, true);
            if (config.showLoading) this.loadingScreen = new (0, $ec27ae8f38585a40$export$e2b0760399e6dece)(this.sceneRenderer);
        } catch (e) {
            this.showError("Sorry, your browser does not support \nPlease use the latest version of Firefox, Chrome, Edge, or Safari.", e);
            return null;
        }
        // Load the assets.
        this.assetManager = new (0, $abea8e8cabf3badd$export$85f9686224250ac3)(this.context, "", config.downloader);
        if (config.rawDataURIs) for(let path in config.rawDataURIs)this.assetManager.setRawDataURI(path, config.rawDataURIs[path]);
        if (config.jsonUrl) this.assetManager.loadJson(config.jsonUrl);
        else this.assetManager.loadBinary(config.binaryUrl);
        this.assetManager.loadTextureAtlas(config.atlasUrl);
        if (config.backgroundImage) this.assetManager.loadTexture(config.backgroundImage.url);
        // Setup the UI elements.
        this.bg.setFromString(config.backgroundColor);
        this.bgFullscreen.setFromString(config.fullScreenBackgroundColor);
        if (config.showControls) {
            this.playerControls = dom.children[1];
            let controls = this.playerControls.children;
            let timeline = controls[0];
            let buttons = controls[1].children;
            this.playButton = buttons[0];
            let speedButton = buttons[2];
            this.animationButton = buttons[3];
            this.skinButton = buttons[4];
            let settingsButton = buttons[5];
            let fullscreenButton = buttons[6];
            let logoButton = buttons[7];
            this.timelineSlider = new $781d0b326a8f1540$var$Slider();
            timeline.appendChild(this.timelineSlider.create());
            this.timelineSlider.change = (percentage)=>{
                this.pause();
                let animationDuration = this.animationState.getCurrent(0).animation.duration;
                let time = animationDuration * percentage;
                this.animationState.update(time - this.playTime);
                this.animationState.apply(this.skeleton);
                this.skeleton.updateWorldTransform();
                this.playTime = time;
            };
            this.playButton.onclick = ()=>this.paused ? this.play() : this.pause();
            speedButton.onclick = ()=>this.showSpeedDialog(speedButton);
            this.animationButton.onclick = ()=>this.showAnimationsDialog(this.animationButton);
            this.skinButton.onclick = ()=>this.showSkinsDialog(this.skinButton);
            settingsButton.onclick = ()=>this.showSettingsDialog(settingsButton);
            let oldWidth = this.canvas.clientWidth, oldHeight = this.canvas.clientHeight;
            let oldStyleWidth = this.canvas.style.width, oldStyleHeight = this.canvas.style.height;
            let isFullscreen = false;
            fullscreenButton.onclick = ()=>{
                let fullscreenChanged = ()=>{
                    isFullscreen = !isFullscreen;
                    if (!isFullscreen) {
                        this.canvas.style.width = oldWidth + "px";
                        this.canvas.style.height = oldHeight + "px";
                        this.drawFrame(false);
                        // Got to reset the style to whatever the user set after the next layouting.
                        requestAnimationFrame(()=>{
                            this.canvas.style.width = oldStyleWidth;
                            this.canvas.style.height = oldStyleHeight;
                        });
                    }
                };
                let player = dom;
                player.onfullscreenchange = fullscreenChanged;
                player.onwebkitfullscreenchange = fullscreenChanged;
                let doc = document;
                if (doc.fullscreenElement || doc.webkitFullscreenElement || doc.mozFullScreenElement || doc.msFullscreenElement) {
                    if (doc.exitFullscreen) doc.exitFullscreen();
                    else if (doc.mozCancelFullScreen) doc.mozCancelFullScreen();
                    else if (doc.webkitExitFullscreen) doc.webkitExitFullscreen();
                    else if (doc.msExitFullscreen) doc.msExitFullscreen();
                } else {
                    oldWidth = this.canvas.clientWidth;
                    oldHeight = this.canvas.clientHeight;
                    oldStyleWidth = this.canvas.style.width;
                    oldStyleHeight = this.canvas.style.height;
                    if (player.requestFullscreen) player.requestFullscreen();
                    else if (player.webkitRequestFullScreen) player.webkitRequestFullScreen();
                    else if (player.mozRequestFullScreen) player.mozRequestFullScreen();
                    else if (player.msRequestFullscreen) player.msRequestFullscreen();
                }
            };
            logoButton.onclick = ()=>window.open("http://esotericsoftware.com");
        }
        return dom;
    }
    loadSkeleton() {
        if (this.error) return;
        if (this.assetManager.hasErrors()) this.showError("Error: Assets could not be loaded.\n" + $781d0b326a8f1540$var$toString(this.assetManager.getErrors()));
        let config = this.config;
        // Configure filtering, don't use mipmaps in WebGL1 if the atlas page is non-POT
        let atlas = this.assetManager.require(config.atlasUrl);
        let gl = this.context.gl, anisotropic = gl.getExtension("EXT_texture_filter_anisotropic");
        let isWebGL1 = gl.getParameter(gl.VERSION).indexOf("WebGL 1.0") != -1;
        for (let page of atlas.pages){
            let minFilter = page.minFilter;
            var useMipMaps = config.mipmaps;
            var isPOT = (0, $1702fa998ec22e58$export$6a7ef315a0d1ef07).isPowerOfTwo(page.width) && (0, $1702fa998ec22e58$export$6a7ef315a0d1ef07).isPowerOfTwo(page.height);
            if (isWebGL1 && !isPOT) useMipMaps = false;
            if (useMipMaps) {
                if (anisotropic) {
                    gl.texParameterf(gl.TEXTURE_2D, anisotropic.TEXTURE_MAX_ANISOTROPY_EXT, 8);
                    minFilter = (0, $471b0ca0afe71980$export$f389c48fc54053be).MipMapLinearLinear;
                } else minFilter = (0, $471b0ca0afe71980$export$f389c48fc54053be).Linear; // Don't use mipmaps without anisotropic.
                page.texture.setFilters(minFilter, (0, $471b0ca0afe71980$export$f389c48fc54053be).Nearest);
            }
            if (minFilter != (0, $471b0ca0afe71980$export$f389c48fc54053be).Nearest && minFilter != (0, $471b0ca0afe71980$export$f389c48fc54053be).Linear) page.texture.update(true);
        }
        // Load skeleton data.
        let skeletonData;
        if (config.jsonUrl) try {
            let jsonData = this.assetManager.remove(config.jsonUrl);
            if (!jsonData) throw new Error("Empty JSON data.");
            if (config.jsonField) {
                jsonData = jsonData[config.jsonField];
                if (!jsonData) throw new Error("JSON field does not exist: " + config.jsonField);
            }
            let json = new (0, $acc7b1056b491f28$export$8913b5e618c6d2f3)(new (0, $1b8eecdee9c89b5e$export$2ff9add835475d95)(atlas));
            skeletonData = json.readSkeletonData(jsonData);
        } catch (e) {
            this.showError(`Error: Could not load skeleton JSON.\n${e.message}`, e);
            return;
        }
        else {
            let binaryData = this.assetManager.remove(config.binaryUrl);
            let binary = new (0, $97fef4e9c50039b0$export$a7f7eaf4e9fce9ef)(new (0, $1b8eecdee9c89b5e$export$2ff9add835475d95)(atlas));
            try {
                skeletonData = binary.readSkeletonData(binaryData);
            } catch (e) {
                this.showError(`Error: Could not load skeleton binary.\n${e.message}`, e);
                return;
            }
        }
        this.skeleton = new (0, $3dc39cfdbd0ba43d$export$8f31e4c4a37b8e9c)(skeletonData);
        let stateData = new (0, $14a949d916e0f278$export$90d7167cc0605975)(skeletonData);
        stateData.defaultMix = config.defaultMix;
        this.animationState = new (0, $15bd7a75a398401c$export$d0f7a26c90cc1562)(stateData);
        // Check if all control bones are in the skeleton
        config.controlBones.forEach((bone)=>{
            if (!skeletonData.findBone(bone)) this.showError(`Error: Control bone does not exist in skeleton: ${bone}`);
        });
        // Setup skin.
        if (!config.skin && skeletonData.skins.length) config.skin = skeletonData.skins[0].name;
        if (config.skins && config.skin.length) config.skins.forEach((skin)=>{
            if (!this.skeleton.data.findSkin(skin)) this.showError(`Error: Skin in config list does not exist in skeleton: ${skin}`);
        });
        if (config.skin) {
            if (!this.skeleton.data.findSkin(config.skin)) this.showError(`Error: Skin does not exist in skeleton: ${config.skin}`);
            this.skeleton.setSkinByName(config.skin);
            this.skeleton.setSlotsToSetupPose();
        }
        // Check if all animations given a viewport exist.
        Object.getOwnPropertyNames(config.viewport.animations).forEach((animation)=>{
            if (!skeletonData.findAnimation(animation)) this.showError(`Error: Animation for which a viewport was specified does not exist in skeleton: ${animation}`);
        });
        // Setup the animations after the viewport, so default bounds don't get messed up.
        if (config.animations && config.animations.length) {
            config.animations.forEach((animation)=>{
                if (!this.skeleton.data.findAnimation(animation)) this.showError(`Error: Animation in config list does not exist in skeleton: ${animation}`);
            });
            if (!config.animation) config.animation = config.animations[0];
        }
        if (config.animation && !skeletonData.findAnimation(config.animation)) this.showError(`Error: Animation does not exist in skeleton: ${config.animation}`);
        // Setup input processing and control bones.
        this.setupInput();
        if (config.showControls) {
            // Hide skin and animation if there's only the default skin / no animation
            if (skeletonData.skins.length == 1 || config.skins && config.skins.length == 1) this.skinButton.classList.add("spine-player-hidden");
            if (skeletonData.animations.length == 1 || config.animations && config.animations.length == 1) this.animationButton.classList.add("spine-player-hidden");
        }
        if (config.success) config.success(this);
        let entry = this.animationState.getCurrent(0);
        if (!entry) {
            if (config.animation) {
                entry = this.setAnimation(config.animation);
                this.play();
            } else {
                entry = this.animationState.setEmptyAnimation(0);
                entry.trackEnd = 100000000;
                this.skeleton.updateWorldTransform();
                this.setViewport(entry.animation);
                this.pause();
            }
        } else if (!this.currentViewport) {
            this.setViewport(entry.animation);
            this.play();
        }
    }
    setupInput() {
        let config = this.config;
        let controlBones = config.controlBones;
        if (!controlBones.length && !config.showControls) return;
        let selectedBones = this.selectedBones = new Array(controlBones.length);
        let canvas = this.canvas;
        let target = null;
        let offset = new (0, $1702fa998ec22e58$export$c977b3e384af9ae1)();
        let coords = new (0, $75a60b996df58eed$export$64b5c384219d3699)();
        let mouse = new (0, $75a60b996df58eed$export$64b5c384219d3699)();
        let position = new (0, $1702fa998ec22e58$export$c977b3e384af9ae1)();
        let skeleton = this.skeleton;
        let renderer = this.sceneRenderer;
        let closest = function(x, y) {
            mouse.set(x, canvas.clientHeight - y, 0);
            offset.x = offset.y = 0;
            let bestDistance = 24, index = 0;
            let best = null;
            for(let i = 0; i < controlBones.length; i++){
                selectedBones[i] = null;
                let bone = skeleton.findBone(controlBones[i]);
                if (!bone) continue;
                let distance = renderer.camera.worldToScreen(coords.set(bone.worldX, bone.worldY, 0), canvas.clientWidth, canvas.clientHeight).distance(mouse);
                if (distance < bestDistance) {
                    bestDistance = distance;
                    best = bone;
                    index = i;
                    offset.x = coords.x - mouse.x;
                    offset.y = coords.y - mouse.y;
                }
            }
            if (best) selectedBones[index] = best;
            return best;
        };
        new (0, $f2aa140968060cbb$export$f5b8910cec6cf069)(canvas).addListener({
            down: (x, y)=>{
                target = closest(x, y);
            },
            up: ()=>{
                if (target) target = null;
                else if (config.showControls) this.paused ? this.play() : this.pause();
            },
            dragged: (x, y)=>{
                if (target) {
                    x = (0, $1702fa998ec22e58$export$6a7ef315a0d1ef07).clamp(x + offset.x, 0, canvas.clientWidth);
                    y = (0, $1702fa998ec22e58$export$6a7ef315a0d1ef07).clamp(y - offset.y, 0, canvas.clientHeight);
                    renderer.camera.screenToWorld(coords.set(x, y, 0), canvas.clientWidth, canvas.clientHeight);
                    if (target.parent) {
                        target.parent.worldToLocal(position.set(coords.x - skeleton.x, coords.y - skeleton.y));
                        target.x = position.x;
                        target.y = position.y;
                    } else {
                        target.x = coords.x - skeleton.x;
                        target.y = coords.y - skeleton.y;
                    }
                }
            },
            moved: (x, y)=>closest(x, y)
        });
        if (config.showControls) {
            // For manual hover to work, we need to disable hidding controls if the mouse/touch entered the clickable area of a child of the controls.
            // For this we need to register a mouse handler on the document and see if we are within the canvas area.
            this.addEventListener(document, "mousemove", (ev)=>{
                if (ev instanceof MouseEvent) handleHover(ev.clientX, ev.clientY);
            });
            this.addEventListener(document, "touchmove", (ev)=>{
                if (ev instanceof TouchEvent) {
                    let touches = ev.changedTouches;
                    if (touches.length) {
                        let touch = touches[0];
                        handleHover(touch.clientX, touch.clientY);
                    }
                }
            });
            let overlap = (mouseX, mouseY, rect)=>{
                let x = mouseX - rect.left, y = mouseY - rect.top;
                return x >= 0 && x <= rect.width && y >= 0 && y <= rect.height;
            };
            let mouseOverControls = true, mouseOverCanvas = false;
            let handleHover = (mouseX, mouseY)=>{
                let popup = $781d0b326a8f1540$var$findWithClass(this.dom, "spine-player-popup");
                mouseOverControls = overlap(mouseX, mouseY, this.playerControls.getBoundingClientRect());
                mouseOverCanvas = overlap(mouseX, mouseY, canvas.getBoundingClientRect());
                clearTimeout(this.cancelId);
                let hide = !popup && !mouseOverControls && !mouseOverCanvas && !this.paused;
                if (hide) this.playerControls.classList.add("spine-player-controls-hidden");
                else this.playerControls.classList.remove("spine-player-controls-hidden");
                if (!mouseOverControls && !popup && !this.paused) this.cancelId = setTimeout(()=>{
                    if (!this.paused) this.playerControls.classList.add("spine-player-controls-hidden");
                }, 1000);
            };
        }
    }
    play() {
        this.paused = false;
        let config = this.config;
        if (config.showControls) {
            this.cancelId = setTimeout(()=>{
                if (!this.paused) this.playerControls.classList.add("spine-player-controls-hidden");
            }, 1000);
            this.playButton.classList.remove("spine-player-button-icon-play");
            this.playButton.classList.add("spine-player-button-icon-pause");
            // If no config animation, set one when first clicked.
            if (!config.animation) {
                if (config.animations && config.animations.length) config.animation = config.animations[0];
                else if (this.skeleton.data.animations.length) config.animation = this.skeleton.data.animations[0].name;
                if (config.animation) this.setAnimation(config.animation);
            }
        }
    }
    pause() {
        this.paused = true;
        if (this.config.showControls) {
            this.playerControls.classList.remove("spine-player-controls-hidden");
            clearTimeout(this.cancelId);
            this.playButton.classList.remove("spine-player-button-icon-pause");
            this.playButton.classList.add("spine-player-button-icon-play");
        }
    }
    /* Sets a new animation and viewport on track 0. */ setAnimation(animation, loop = true) {
        animation = this.setViewport(animation);
        return this.animationState.setAnimationWith(0, animation, loop);
    }
    /* Adds a new animation and viewport on track 0. */ addAnimation(animation, loop = true, delay = 0) {
        animation = this.setViewport(animation);
        return this.animationState.addAnimationWith(0, animation, loop, delay);
    }
    /* Sets the viewport for the specified animation. */ setViewport(animation) {
        if (typeof animation == "string") {
            let foundAnimation = this.skeleton.data.findAnimation(animation);
            if (!foundAnimation) throw new Error("Animation not found: " + animation);
            animation = foundAnimation;
        }
        this.previousViewport = this.currentViewport;
        // Determine the base viewport.
        let globalViewport = this.config.viewport;
        let viewport = this.currentViewport = {
            padLeft: globalViewport.padLeft !== void 0 ? globalViewport.padLeft : "10%",
            padRight: globalViewport.padRight !== void 0 ? globalViewport.padRight : "10%",
            padTop: globalViewport.padTop !== void 0 ? globalViewport.padTop : "10%",
            padBottom: globalViewport.padBottom !== void 0 ? globalViewport.padBottom : "10%"
        };
        if (globalViewport.x !== void 0 && globalViewport.y !== void 0 && globalViewport.width && globalViewport.height) {
            viewport.x = globalViewport.x;
            viewport.y = globalViewport.y;
            viewport.width = globalViewport.width;
            viewport.height = globalViewport.height;
        } else this.calculateAnimationViewport(animation, viewport);
        // Override with the animation specific viewport for the final result.
        let userAnimViewport = this.config.viewport.animations[animation.name];
        if (userAnimViewport) {
            if (userAnimViewport.x !== void 0 && userAnimViewport.y !== void 0 && userAnimViewport.width && userAnimViewport.height) {
                viewport.x = userAnimViewport.x;
                viewport.y = userAnimViewport.y;
                viewport.width = userAnimViewport.width;
                viewport.height = userAnimViewport.height;
            }
            if (userAnimViewport.padLeft !== void 0) viewport.padLeft = userAnimViewport.padLeft;
            if (userAnimViewport.padRight !== void 0) viewport.padRight = userAnimViewport.padRight;
            if (userAnimViewport.padTop !== void 0) viewport.padTop = userAnimViewport.padTop;
            if (userAnimViewport.padBottom !== void 0) viewport.padBottom = userAnimViewport.padBottom;
        }
        // Translate percentage padding to world units.
        viewport.padLeft = this.percentageToWorldUnit(viewport.width, viewport.padLeft);
        viewport.padRight = this.percentageToWorldUnit(viewport.width, viewport.padRight);
        viewport.padBottom = this.percentageToWorldUnit(viewport.height, viewport.padBottom);
        viewport.padTop = this.percentageToWorldUnit(viewport.height, viewport.padTop);
        this.viewportTransitionStart = performance.now();
        return animation;
    }
    percentageToWorldUnit(size, percentageOrAbsolute) {
        if (typeof percentageOrAbsolute === "string") return size * parseFloat(percentageOrAbsolute.substr(0, percentageOrAbsolute.length - 1)) / 100;
        return percentageOrAbsolute;
    }
    calculateAnimationViewport(animation, viewport) {
        this.skeleton.setToSetupPose();
        let steps = 100, stepTime = animation.duration ? animation.duration / steps : 0, time = 0;
        let minX = 100000000, maxX = -100000000, minY = 100000000, maxY = -100000000;
        let offset = new (0, $1702fa998ec22e58$export$c977b3e384af9ae1)(), size = new (0, $1702fa998ec22e58$export$c977b3e384af9ae1)();
        for(let i = 0; i < steps; i++, time += stepTime){
            animation.apply(this.skeleton, time, time, false, [], 1, (0, $c8bc0977b55afb3a$export$ccab779a50275a35).setup, (0, $c8bc0977b55afb3a$export$52fc338c0bb328ba).mixIn);
            this.skeleton.updateWorldTransform();
            this.skeleton.getBounds(offset, size);
            if (!isNaN(offset.x) && !isNaN(offset.y) && !isNaN(size.x) && !isNaN(size.y)) {
                minX = Math.min(offset.x, minX);
                maxX = Math.max(offset.x + size.x, maxX);
                minY = Math.min(offset.y, minY);
                maxY = Math.max(offset.y + size.y, maxY);
            } else this.showError("Animation bounds are invalid: " + animation.name);
        }
        viewport.x = minX;
        viewport.y = minY;
        viewport.width = maxX - minX;
        viewport.height = maxY - minY;
    }
    drawFrame(requestNextFrame = true) {
        try {
            if (this.error) return;
            if (this.disposed) return;
            if (requestNextFrame && !this.stopRequestAnimationFrame) requestAnimationFrame(()=>this.drawFrame());
            let doc = document;
            let isFullscreen = doc.fullscreenElement || doc.webkitFullscreenElement || doc.mozFullScreenElement || doc.msFullscreenElement;
            let bg = isFullscreen ? this.bgFullscreen : this.bg;
            this.time.update();
            let delta = this.time.delta;
            // Load the skeleton if the assets are ready.
            let loading = this.assetManager.isLoadingComplete();
            if (!this.skeleton && loading) this.loadSkeleton();
            let skeleton = this.skeleton;
            let config = this.config;
            if (skeleton) {
                // Resize the canvas.
                let renderer = this.sceneRenderer;
                renderer.resize((0, $e8e79f3c1b8010ec$export$5d6d136f0a4d9153).Expand);
                let playDelta = this.paused ? 0 : delta * this.speed;
                if (config.frame) config.frame(this, playDelta);
                // Update animation time and pose the skeleton.
                if (!this.paused) {
                    this.animationState.update(playDelta);
                    this.animationState.apply(skeleton);
                    skeleton.updateWorldTransform();
                    if (config.showControls) {
                        this.playTime += playDelta;
                        let entry = this.animationState.getCurrent(0);
                        if (entry) {
                            let duration = entry.animation.duration;
                            while(this.playTime >= duration && duration != 0)this.playTime -= duration;
                            this.playTime = Math.max(0, Math.min(this.playTime, duration));
                            this.timelineSlider.setValue(this.playTime / duration);
                        }
                    }
                }
                // Determine the viewport.
                let viewport = this.viewport;
                viewport.x = this.currentViewport.x - this.currentViewport.padLeft;
                viewport.y = this.currentViewport.y - this.currentViewport.padBottom;
                viewport.width = this.currentViewport.width + this.currentViewport.padLeft + this.currentViewport.padRight;
                viewport.height = this.currentViewport.height + this.currentViewport.padBottom + this.currentViewport.padTop;
                if (this.previousViewport) {
                    let transitionAlpha = (performance.now() - this.viewportTransitionStart) / 1000 / config.viewport.transitionTime;
                    if (transitionAlpha < 1) {
                        let x = this.previousViewport.x - this.previousViewport.padLeft;
                        let y = this.previousViewport.y - this.previousViewport.padBottom;
                        let width = this.previousViewport.width + this.previousViewport.padLeft + this.previousViewport.padRight;
                        let height = this.previousViewport.height + this.previousViewport.padBottom + this.previousViewport.padTop;
                        viewport.x = x + (viewport.x - x) * transitionAlpha;
                        viewport.y = y + (viewport.y - y) * transitionAlpha;
                        viewport.width = width + (viewport.width - width) * transitionAlpha;
                        viewport.height = height + (viewport.height - height) * transitionAlpha;
                    }
                }
                renderer.camera.zoom = this.canvas.height / this.canvas.width > viewport.height / viewport.width ? viewport.width / this.canvas.width : viewport.height / this.canvas.height;
                renderer.camera.position.x = viewport.x + viewport.width / 2;
                renderer.camera.position.y = viewport.y + viewport.height / 2;
                // Clear the screen.
                let gl = this.context.gl;
                gl.clearColor(bg.r, bg.g, bg.b, bg.a);
                gl.clear(gl.COLOR_BUFFER_BIT);
                if (config.update) config.update(this, playDelta);
                renderer.begin();
                // Draw the background image.
                let bgImage = config.backgroundImage;
                if (bgImage) {
                    let texture = this.assetManager.require(bgImage.url);
                    if (bgImage.x !== void 0 && bgImage.y !== void 0 && bgImage.width && bgImage.height) renderer.drawTexture(texture, bgImage.x, bgImage.y, bgImage.width, bgImage.height);
                    else renderer.drawTexture(texture, viewport.x, viewport.y, viewport.width, viewport.height);
                }
                // Draw the skeleton and debug output.
                renderer.drawSkeleton(skeleton, config.premultipliedAlpha);
                if (Number(renderer.skeletonDebugRenderer.drawBones = config.debug.bones ?? false) + Number(renderer.skeletonDebugRenderer.drawBoundingBoxes = config.debug.bounds ?? false) + Number(renderer.skeletonDebugRenderer.drawClipping = config.debug.clipping ?? false) + Number(renderer.skeletonDebugRenderer.drawMeshHull = config.debug.hulls ?? false) + Number(renderer.skeletonDebugRenderer.drawPaths = config.debug.paths ?? false) + Number(renderer.skeletonDebugRenderer.drawRegionAttachments = config.debug.regions ?? false) + Number(renderer.skeletonDebugRenderer.drawMeshTriangles = config.debug.meshes ?? false) > 0) renderer.drawSkeletonDebug(skeleton, config.premultipliedAlpha);
                // Draw the control bones.
                let controlBones = config.controlBones;
                if (controlBones.length) {
                    let selectedBones = this.selectedBones;
                    gl.lineWidth(2);
                    for(let i = 0; i < controlBones.length; i++){
                        let bone = skeleton.findBone(controlBones[i]);
                        if (!bone) continue;
                        let colorInner = selectedBones[i] ? $781d0b326a8f1540$var$BONE_INNER_OVER : $781d0b326a8f1540$var$BONE_INNER;
                        let colorOuter = selectedBones[i] ? $781d0b326a8f1540$var$BONE_OUTER_OVER : $781d0b326a8f1540$var$BONE_OUTER;
                        renderer.circle(true, skeleton.x + bone.worldX, skeleton.y + bone.worldY, 20, colorInner);
                        renderer.circle(false, skeleton.x + bone.worldX, skeleton.y + bone.worldY, 20, colorOuter);
                    }
                }
                // Draw the viewport bounds.
                if (config.viewport.debugRender) {
                    gl.lineWidth(1);
                    renderer.rect(false, this.currentViewport.x, this.currentViewport.y, this.currentViewport.width, this.currentViewport.height, (0, $1702fa998ec22e58$export$892596cec99bc70e).GREEN);
                    renderer.rect(false, viewport.x, viewport.y, viewport.width, viewport.height, (0, $1702fa998ec22e58$export$892596cec99bc70e).RED);
                }
                renderer.end();
                if (config.draw) config.draw(this, playDelta);
            }
            // Draw the loading screen.
            if (config.showLoading) {
                this.loadingScreen.backgroundColor.setFromColor(bg);
                this.loadingScreen.draw(loading);
            }
            if (loading && config.loading) config.loading(this, delta);
        } catch (e) {
            this.showError(`Error: Unable to render skeleton.\n${e.message}`, e);
        }
    }
    stopRendering() {
        this.stopRequestAnimationFrame = true;
    }
    hidePopup(id) {
        return this.popup != null && this.popup.hide(id);
    }
    showSpeedDialog(speedButton) {
        let id = "speed";
        if (this.hidePopup(id)) return;
        let popup = new $781d0b326a8f1540$var$Popup(id, speedButton, this, this.playerControls, /*html*/ `
<div class="spine-player-popup-title">Speed</div>
<hr>
<div class="spine-player-row" style="align-items:center;padding:8px">
<div class="spine-player-column">
	<div class="spine-player-speed-slider" style="margin-bottom:4px"></div>
	<div class="spine-player-row" style="justify-content:space-between"><div>0.1x</div><div>1x</div><div>2x</div></div>
</div>
</div>`);
        let slider = new $781d0b326a8f1540$var$Slider(2, 0.1, true);
        $781d0b326a8f1540$var$findWithClass(popup.dom, "spine-player-speed-slider").appendChild(slider.create());
        slider.setValue(this.speed / 2);
        slider.change = (percentage)=>this.speed = percentage * 2;
        popup.show();
    }
    showAnimationsDialog(animationsButton) {
        let id = "animations";
        if (this.hidePopup(id)) return;
        if (!this.skeleton || !this.skeleton.data.animations.length) return;
        let popup = new $781d0b326a8f1540$var$Popup(id, animationsButton, this, this.playerControls, /*html*/ `<div class="spine-player-popup-title">Animations</div><hr><ul class="spine-player-list"></ul>`);
        let rows = $781d0b326a8f1540$var$findWithClass(popup.dom, "spine-player-list");
        this.skeleton.data.animations.forEach((animation)=>{
            // Skip animations not whitelisted if a whitelist was given.
            if (this.config.animations && this.config.animations.indexOf(animation.name) < 0) return;
            let row = $781d0b326a8f1540$var$createElement(/*html*/ `<li class="spine-player-list-item selectable"><div class="selectable-circle"></div><div class="selectable-text"></div></li>`);
            if (animation.name == this.config.animation) row.classList.add("selected");
            $781d0b326a8f1540$var$findWithClass(row, "selectable-text").innerText = animation.name;
            rows.appendChild(row);
            row.onclick = ()=>{
                $781d0b326a8f1540$var$removeClass(rows.children, "selected");
                row.classList.add("selected");
                this.config.animation = animation.name;
                this.playTime = 0;
                this.setAnimation(animation.name);
                this.play();
            };
        });
        popup.show();
    }
    showSkinsDialog(skinButton) {
        let id = "skins";
        if (this.hidePopup(id)) return;
        if (!this.skeleton || !this.skeleton.data.animations.length) return;
        let popup = new $781d0b326a8f1540$var$Popup(id, skinButton, this, this.playerControls, /*html*/ `<div class="spine-player-popup-title">Skins</div><hr><ul class="spine-player-list"></ul>`);
        let rows = $781d0b326a8f1540$var$findWithClass(popup.dom, "spine-player-list");
        this.skeleton.data.skins.forEach((skin)=>{
            // Skip skins not whitelisted if a whitelist was given.
            if (this.config.skins && this.config.skins.indexOf(skin.name) < 0) return;
            let row = $781d0b326a8f1540$var$createElement(/*html*/ `<li class="spine-player-list-item selectable"><div class="selectable-circle"></div><div class="selectable-text"></div></li>`);
            if (skin.name == this.config.skin) row.classList.add("selected");
            $781d0b326a8f1540$var$findWithClass(row, "selectable-text").innerText = skin.name;
            rows.appendChild(row);
            row.onclick = ()=>{
                $781d0b326a8f1540$var$removeClass(rows.children, "selected");
                row.classList.add("selected");
                this.config.skin = skin.name;
                this.skeleton.setSkinByName(this.config.skin);
                this.skeleton.setSlotsToSetupPose();
            };
        });
        popup.show();
    }
    showSettingsDialog(settingsButton) {
        let id = "settings";
        if (this.hidePopup(id)) return;
        if (!this.skeleton || !this.skeleton.data.animations.length) return;
        let popup = new $781d0b326a8f1540$var$Popup(id, settingsButton, this, this.playerControls, /*html*/ `<div class="spine-player-popup-title">Debug</div><hr><ul class="spine-player-list"></li>`);
        let rows = $781d0b326a8f1540$var$findWithClass(popup.dom, "spine-player-list");
        let makeItem = (label, name)=>{
            let row = $781d0b326a8f1540$var$createElement(/*html*/ `<li class="spine-player-list-item"></li>`);
            let s = new $781d0b326a8f1540$var$Switch(label);
            row.appendChild(s.create());
            let debug = this.config.debug;
            s.setEnabled(debug[name]);
            s.change = (value)=>debug[name] = value;
            rows.appendChild(row);
        };
        makeItem("Bones", "bones");
        makeItem("Regions", "regions");
        makeItem("Meshes", "meshes");
        makeItem("Bounds", "bounds");
        makeItem("Paths", "paths");
        makeItem("Clipping", "clipping");
        makeItem("Points", "points");
        makeItem("Hulls", "hulls");
        popup.show();
    }
    showError(message, error) {
        if (this.error) {
            if (error) throw error; // Don't lose error if showError throws, is caught, and showError is called again.
        } else {
            this.error = true;
            this.dom.appendChild($781d0b326a8f1540$var$createElement(/*html*/ `<div class="spine-player-error" style="background:#000;color:#fff;position:absolute;top:0;width:100%;height:100%;display:flex;justify-content:center;align-items:center;overflow:auto;z-index:999">` + message.replace("\n", "<br><br>") + `</div>`));
            if (this.config.error) this.config.error(this, message);
            throw error ? error : new Error(message);
        }
    }
}
class $781d0b326a8f1540$var$Popup {
    id;
    button;
    player;
    dom;
    className;
    windowClickListener;
    constructor(id, button, player, parent, htmlContent){
        this.id = id;
        this.button = button;
        this.player = player;
        this.dom = $781d0b326a8f1540$var$createElement(/*html*/ `<div class="spine-player-popup spine-player-hidden"></div>`);
        this.dom.innerHTML = htmlContent;
        parent.appendChild(this.dom);
        this.className = "spine-player-button-icon-" + id + "-selected";
    }
    dispose() {}
    hide(id) {
        this.dom.remove();
        this.button.classList.remove(this.className);
        if (this.id == id) {
            this.player.popup = null;
            return true;
        }
        return false;
    }
    show() {
        this.player.popup = this;
        this.button.classList.add(this.className);
        this.dom.classList.remove("spine-player-hidden");
        // Make sure the popup isn't bigger than the player.
        let dismissed = false;
        let resize = ()=>{
            if (!dismissed) requestAnimationFrame(resize);
            let playerDom = this.player.dom;
            let bottomOffset = Math.abs(playerDom.getBoundingClientRect().bottom - playerDom.getBoundingClientRect().bottom);
            let rightOffset = Math.abs(playerDom.getBoundingClientRect().right - playerDom.getBoundingClientRect().right);
            this.dom.style.maxHeight = playerDom.clientHeight - bottomOffset - rightOffset + "px";
        };
        requestAnimationFrame(resize);
        // Dismiss when clicking somewhere outside the popup.
        let justClicked = true;
        let windowClickListener = (event)=>{
            if (justClicked || this.player.popup != this) {
                justClicked = false;
                return;
            }
            if (!this.dom.contains(event.target)) {
                this.dom.remove();
                window.removeEventListener("click", windowClickListener);
                this.button.classList.remove(this.className);
                this.player.popup = null;
                dismissed = true;
            }
        };
        this.player.addEventListener(window, "click", windowClickListener);
    }
}
class $781d0b326a8f1540$var$Switch {
    text;
    switch = null;
    enabled = false;
    change = ()=>{};
    constructor(text){
        this.text = text;
    }
    create() {
        this.switch = $781d0b326a8f1540$var$createElement(/*html*/ `
<div class="spine-player-switch">
	<span class="spine-player-switch-text">${this.text}</span>
	<div class="spine-player-switch-knob-area">
		<div class="spine-player-switch-knob"></div>
	</div>
</div>`);
        this.switch.addEventListener("click", ()=>{
            this.setEnabled(!this.enabled);
            if (this.change) this.change(this.enabled);
        });
        return this.switch;
    }
    setEnabled(enabled) {
        if (enabled) this.switch?.classList.add("active");
        else this.switch?.classList.remove("active");
        this.enabled = enabled;
    }
    isEnabled() {
        return this.enabled;
    }
}
class $781d0b326a8f1540$var$Slider {
    snaps;
    snapPercentage;
    big;
    slider = null;
    value = null;
    knob = null;
    change = ()=>{};
    constructor(snaps = 0, snapPercentage = 0.1, big = false){
        this.snaps = snaps;
        this.snapPercentage = snapPercentage;
        this.big = big;
    }
    create() {
        this.slider = $781d0b326a8f1540$var$createElement(/*html*/ `
<div class="spine-player-slider ${this.big ? "big" : ""}">
	<div class="spine-player-slider-value"></div>
	<!--<div class="spine-player-slider-knob"></div>-->
</div>`);
        this.value = $781d0b326a8f1540$var$findWithClass(this.slider, "spine-player-slider-value");
        // this.knob = findWithClass(this.slider, "spine-player-slider-knob");
        this.setValue(0);
        let dragging = false;
        new (0, $f2aa140968060cbb$export$f5b8910cec6cf069)(this.slider).addListener({
            down: (x, y)=>{
                dragging = true;
                this.value?.classList.add("hovering");
            },
            up: (x, y)=>{
                dragging = false;
                if (this.change) this.change(this.setValue(x / this.slider.clientWidth));
                this.value?.classList.remove("hovering");
            },
            moved: (x, y)=>{
                if (dragging && this.change) this.change(this.setValue(x / this.slider.clientWidth));
            },
            dragged: (x, y)=>{
                if (this.change) this.change(this.setValue(x / this.slider.clientWidth));
            }
        });
        return this.slider;
    }
    setValue(percentage) {
        percentage = Math.max(0, Math.min(1, percentage));
        if (this.snaps) {
            let snap = 1 / this.snaps;
            let modulo = percentage % snap;
            // floor
            if (modulo < snap * this.snapPercentage) percentage = percentage - modulo;
            else if (modulo > snap - snap * this.snapPercentage) percentage = percentage - modulo + snap;
            percentage = Math.max(0, Math.min(1, percentage));
        }
        this.value.style.width = "" + percentage * 100 + "%";
        // this.knob.style.left = "" + (-8 + percentage * this.slider.clientWidth) + "px";
        return percentage;
    }
}
function $781d0b326a8f1540$var$findWithClass(element, className) {
    return element.getElementsByClassName(className)[0];
}
function $781d0b326a8f1540$var$createElement(html) {
    let div = document.createElement("div");
    div.innerHTML = html;
    return div.children[0];
}
function $781d0b326a8f1540$var$removeClass(elements, clazz) {
    for(let i = 0; i < elements.length; i++)elements[i].classList.remove(clazz);
}
function $781d0b326a8f1540$var$toString(object) {
    return JSON.stringify(object).replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;").replace(/"/g, "&#34;").replace(/'/g, "&#39;");
}
const $781d0b326a8f1540$var$BONE_INNER_OVER = new (0, $1702fa998ec22e58$export$892596cec99bc70e)(0.478, 0, 0, 0.25);
const $781d0b326a8f1540$var$BONE_OUTER_OVER = new (0, $1702fa998ec22e58$export$892596cec99bc70e)(1, 1, 1, 1);
const $781d0b326a8f1540$var$BONE_INNER = new (0, $1702fa998ec22e58$export$892596cec99bc70e)(0.478, 0, 0, 0.5);
const $781d0b326a8f1540$var$BONE_OUTER = new (0, $1702fa998ec22e58$export$892596cec99bc70e)(1, 0, 0, 0.8);









const $e16030e48e62d804$var$container = document.createElement("div");
$e16030e48e62d804$var$container.style.display = "none";
$e16030e48e62d804$var$container.id = "spine-cache";
document.body.appendChild($e16030e48e62d804$var$container);
// CHARACTER
const $e16030e48e62d804$var$generateSpineCharacter = async (containerId)=>new Promise((resolve, reject)=>{
        new (0, $781d0b326a8f1540$export$a928bbadb775ec2a)(containerId, {
            jsonUrl: `${(0, $0426e2dd5e0de94d$export$5e7589cedbd7a4e0)}/player/player.json`,
            atlasUrl: `${(0, $0426e2dd5e0de94d$export$5e7589cedbd7a4e0)}/player/player.atlas`,
            preserveDrawingBuffer: true,
            animation: "IDLE",
            premultipliedAlpha: false,
            showControls: false,
            showLoading: false,
            alpha: true,
            success (spine) {
                if (!spine.skeleton) {
                    reject();
                    return;
                }
                const skin = new (0, $73641f3ef2c01e99$export$b8e0f93a76772233)("combined");
                const fur = spine.skeleton.data.skins.filter((skin)=>skin.name.startsWith("FUR/ORANGE"));
                skin.addSkin(fur[Math.floor(Math.random() * fur.length)]);
                spine.skeleton.setSkin(skin);
                resolve(spine);
            }
        });
    });
const $e16030e48e62d804$var$CHARACTER_CACHE_SIZE = 1;
const $e16030e48e62d804$var$CHARACTER_CACHE = [];
Array.from({
    length: $e16030e48e62d804$var$CHARACTER_CACHE_SIZE
}, async ()=>$e16030e48e62d804$var$CHARACTER_CACHE.push(await $e16030e48e62d804$var$generateSpineCharacter($e16030e48e62d804$var$container.id)));
const $e16030e48e62d804$export$ce8e199cc2716d76 = async (index, containerId, skin)=>{
    const parent = document.getElementById(containerId);
    let spine;
    let i = 0;
    do {
        spine = $e16030e48e62d804$var$CHARACTER_CACHE[index];
        await (0, $9805619f03ed02ef$export$e772c8ff12451969)(50 * (i + 1));
    }while (!spine?.skeleton && ++i < 10);
    if (!parent || !spine.skeleton) return;
    if (skin) {
        const skinCombined = new (0, $73641f3ef2c01e99$export$b8e0f93a76772233)("combined");
        if (skin.FUR) {
            const eyes = spine.skeleton.data.findSkin(`FUR/${skin.FUR ?? "ORANGE"}`);
            if (eyes) skinCombined.addSkin(eyes);
        }
        if (skin.EYES) {
            const fur = spine.skeleton.data.findSkin(`EYES/${skin.EYES}`);
            if (fur) skinCombined.addSkin(fur);
        }
        if (skin.HEAD) {
            const head = spine.skeleton.data.findSkin(`HEAD/${skin.HEAD}`);
            if (head) skinCombined.addSkin(head);
        }
        if (skin.TOP) {
            const top = spine.skeleton.data.findSkin(`TOP/${skin.TOP}`);
            if (top) skinCombined.addSkin(top);
        }
        if (skin.MOUTH) {
            const mouth = spine.skeleton.data.findSkin(`MOUTH/${skin.MOUTH}`);
            if (mouth) skinCombined.addSkin(mouth);
        }
        spine.skeleton.setSkin(skinCombined);
    } else {
        const skinCombined = new (0, $73641f3ef2c01e99$export$b8e0f93a76772233)("combined");
        const eyes = spine.skeleton.data.skins.filter((skin)=>skin.name.startsWith("EYES/"));
        const fur = spine.skeleton.data.skins.filter((skin)=>skin.name.startsWith("FUR/"));
        const head = spine.skeleton.data.skins.filter((skin)=>skin.name.startsWith("HEAD/"));
        const top = spine.skeleton.data.skins.filter((skin)=>skin.name.startsWith("TOP/"));
        const mouth = spine.skeleton.data.skins.filter((skin)=>skin.name.startsWith("MOUTH/"));
        skinCombined.addSkin(eyes[Math.floor(Math.random() * eyes.length)]);
        skinCombined.addSkin(fur[Math.floor(Math.random() * fur.length)]);
        skinCombined.addSkin(head[Math.floor(Math.random() * head.length)]);
        skinCombined.addSkin(top[Math.floor(Math.random() * top.length)]);
        skinCombined.addSkin(mouth[Math.floor(Math.random() * mouth.length)]);
        spine.skeleton.setSkin(skinCombined);
    }
    spine.skeleton.setSlotsToSetupPose();
    spine.speed = 1;
    parent.appendChild(spine.dom);
    return spine;
};
const $e16030e48e62d804$export$3bd44b7bc70cd0eb = (spine, skin)=>{
    if (!spine.skeleton) return;
    if (skin) {
        const skinCombined = new (0, $73641f3ef2c01e99$export$b8e0f93a76772233)("combined");
        if (skin.FUR) {
            const fur = spine.skeleton.data.findSkin(`FUR/${skin.FUR ?? "ORANGE"}`);
            if (fur) skinCombined.addSkin(fur);
        }
        if (skin.EYES) {
            const eyes = spine.skeleton.data.findSkin(`EYES/${skin.EYES}`);
            if (eyes) skinCombined.addSkin(eyes);
        }
        if (skin.HEAD) {
            const head = spine.skeleton.data.findSkin(`HEAD/${skin.HEAD}`);
            if (head) skinCombined.addSkin(head);
        }
        if (skin.TOP) {
            const top = spine.skeleton.data.findSkin(`TOP/${skin.TOP}`);
            if (top) skinCombined.addSkin(top);
        }
        if (skin.MOUTH) {
            const mouth = spine.skeleton.data.findSkin(`MOUTH/${skin.MOUTH}`);
            if (mouth) skinCombined.addSkin(mouth);
        }
        spine.skeleton.setSkin(skinCombined);
    }
    spine.skeleton.setSlotsToSetupPose();
};
// CHEST
const $e16030e48e62d804$var$generateSpineChest = (containerId)=>new Promise((resolve)=>{
        new (0, $781d0b326a8f1540$export$a928bbadb775ec2a)(containerId, {
            jsonUrl: `${(0, $0426e2dd5e0de94d$export$5e7589cedbd7a4e0)}/chests/chests.json`,
            atlasUrl: `${(0, $0426e2dd5e0de94d$export$5e7589cedbd7a4e0)}/chests/chests.atlas`,
            preserveDrawingBuffer: true,
            animation: "IDLE",
            premultipliedAlpha: false,
            showControls: false,
            showLoading: false,
            alpha: true,
            skin: `CHEST/${(0, $49736469f58fc92b$export$f33286854e75f828).Common.toUpperCase()}`,
            viewport: {
                transitionTime: 0,
                animations: {
                    IDLE: {
                        x: -253.27773267418507,
                        y: -268.3782219427256,
                        width: 512.2129358966614,
                        height: 542.082570296565,
                        padBottom: 0,
                        padTop: 0,
                        padLeft: 0,
                        padRight: 0
                    },
                    OPEN: {
                        x: -253.27773267418507,
                        y: -268.3782219427256,
                        width: 512.2129358966614,
                        height: 542.082570296565,
                        padBottom: 0,
                        padTop: 0,
                        padLeft: 0,
                        padRight: 0
                    }
                }
            },
            success (spine) {
                resolve(spine);
            }
        });
    });
const $e16030e48e62d804$var$CHEST_CACHE_SIZE = 1;
const $e16030e48e62d804$var$CHEST_CACHE = [];
Array.from({
    length: $e16030e48e62d804$var$CHEST_CACHE_SIZE
}, async ()=>$e16030e48e62d804$var$CHEST_CACHE.push(await $e16030e48e62d804$var$generateSpineChest($e16030e48e62d804$var$container.id)));
const $e16030e48e62d804$export$9ae88a47cefbffb9 = async (index, containerId, chestType)=>{
    const parent = document.getElementById(containerId);
    let spine;
    let i = 0;
    do {
        spine = $e16030e48e62d804$var$CHEST_CACHE[index];
        await (0, $9805619f03ed02ef$export$e772c8ff12451969)(50 * (i + 1));
    }while (!spine?.skeleton && ++i < 10);
    if (!parent || !spine.skeleton) return;
    spine.skeleton?.setSkinByName(`CHEST/${chestType.toUpperCase()}`);
    spine.animationState?.setAnimation(0, "IDLE", true);
    parent.appendChild(spine.dom);
    return spine;
};
const $e16030e48e62d804$export$ed8fc336fedfaf4e = ()=>{
    $e16030e48e62d804$var$CHEST_CACHE.forEach((spine)=>{
        spine.setViewport("IDLE");
        spine.animationState?.setAnimation(0, "IDLE", true);
    });
};
// Monster
const $e16030e48e62d804$var$generateSpineMonster = (containerId)=>new Promise((resolve)=>{
        new (0, $781d0b326a8f1540$export$a928bbadb775ec2a)(containerId, {
            preserveDrawingBuffer: true,
            premultipliedAlpha: false,
            showControls: false,
            showLoading: false,
            alpha: true,
            jsonUrl: `${(0, $0426e2dd5e0de94d$export$5e7589cedbd7a4e0)}/main-screen/monster.json`,
            atlasUrl: `${(0, $0426e2dd5e0de94d$export$5e7589cedbd7a4e0)}/main-screen/monster.atlas`,
            animation: "animation",
            success (spine) {
                resolve(spine);
            }
        });
    });
const $e16030e48e62d804$var$MONSTER_CACHE_SIZE = 1;
const $e16030e48e62d804$var$MONSTER_CACHE = [];
Array.from({
    length: $e16030e48e62d804$var$MONSTER_CACHE_SIZE
}, async ()=>$e16030e48e62d804$var$MONSTER_CACHE.push(await $e16030e48e62d804$var$generateSpineMonster($e16030e48e62d804$var$container.id)));
const $e16030e48e62d804$export$3f9fa6d3e8ec4bff = async (index, containerId)=>{
    const parent = document.getElementById(containerId);
    let spine;
    let i = 0;
    do {
        spine = $e16030e48e62d804$var$MONSTER_CACHE[index];
        await (0, $9805619f03ed02ef$export$e772c8ff12451969)(50 * (i + 1));
    }while (!spine?.skeleton && ++i < 10);
    if (!parent || !spine.skeleton) return;
    parent.appendChild(spine.dom);
    return spine;
};






let $c7501b837bedbe83$var$CACHE;
let $c7501b837bedbe83$var$CACHE_TIME = 0;
const $c7501b837bedbe83$export$f9bf007567f0252a = async ()=>{
    if ($c7501b837bedbe83$var$CACHE_TIME < Date.now() - 600000) {
        if ($c7501b837bedbe83$var$CACHE) $c7501b837bedbe83$var$CACHE_TIME = Date.now();
        const response = await (0, $57966c7e0affc4cb$export$2e2bcd8739ae039).get(`${(0, $0426e2dd5e0de94d$export$41baa606ecc5bb4f)}/character/character.json`);
        if (response.status === 200) {
            $c7501b837bedbe83$var$CACHE_TIME = Date.now();
            $c7501b837bedbe83$var$CACHE = response.data;
        }
    }
    return $c7501b837bedbe83$var$CACHE;
};



var $89eabbf3af7bf2fc$exports = {};

$parcel$export($89eabbf3af7bf2fc$exports, "content", () => $89eabbf3af7bf2fc$export$a7db06668cad9adb, (v) => $89eabbf3af7bf2fc$export$a7db06668cad9adb = v);
$parcel$export($89eabbf3af7bf2fc$exports, "continue-menu", () => $89eabbf3af7bf2fc$export$b214608bbf199086, (v) => $89eabbf3af7bf2fc$export$b214608bbf199086 = v);
$parcel$export($89eabbf3af7bf2fc$exports, "error", () => $89eabbf3af7bf2fc$export$a3bc9b8ed74fc, (v) => $89eabbf3af7bf2fc$export$a3bc9b8ed74fc = v);
$parcel$export($89eabbf3af7bf2fc$exports, "gems", () => $89eabbf3af7bf2fc$export$b7dcc03c39461775, (v) => $89eabbf3af7bf2fc$export$b7dcc03c39461775 = v);
$parcel$export($89eabbf3af7bf2fc$exports, "player", () => $89eabbf3af7bf2fc$export$615455393ee443ca, (v) => $89eabbf3af7bf2fc$export$615455393ee443ca = v);
$parcel$export($89eabbf3af7bf2fc$exports, "shadow", () => $89eabbf3af7bf2fc$export$b8972b998723d602, (v) => $89eabbf3af7bf2fc$export$b8972b998723d602 = v);
$parcel$export($89eabbf3af7bf2fc$exports, "title", () => $89eabbf3af7bf2fc$export$fb184b623420d9be, (v) => $89eabbf3af7bf2fc$export$fb184b623420d9be = v);
var $89eabbf3af7bf2fc$export$a7db06668cad9adb;
var $89eabbf3af7bf2fc$export$b214608bbf199086;
var $89eabbf3af7bf2fc$export$a3bc9b8ed74fc;
var $89eabbf3af7bf2fc$export$b7dcc03c39461775;
var $89eabbf3af7bf2fc$export$615455393ee443ca;
var $89eabbf3af7bf2fc$export$b8972b998723d602;
var $89eabbf3af7bf2fc$export$fb184b623420d9be;
$89eabbf3af7bf2fc$export$a7db06668cad9adb = `nVyzUq_content`;
$89eabbf3af7bf2fc$export$b214608bbf199086 = `nVyzUq_continue-menu`;
$89eabbf3af7bf2fc$export$a3bc9b8ed74fc = `nVyzUq_error`;
$89eabbf3af7bf2fc$export$b7dcc03c39461775 = `nVyzUq_gems`;
$89eabbf3af7bf2fc$export$615455393ee443ca = `nVyzUq_player`;
$89eabbf3af7bf2fc$export$b8972b998723d602 = `nVyzUq_shadow`;
$89eabbf3af7bf2fc$export$fb184b623420d9be = `nVyzUq_title`;


const $03301896a15ad73a$var$Content = ({ onClose: onClose })=>{
    const { state: { accountInfo: accountInfo } } = (0, $c25623cc446ec3c6$export$ac8576a9912be18c)();
    const [data, setData] = (0, $acw62.useState)();
    (0, $acw62.useEffect)(()=>{
        (0, $c7501b837bedbe83$export$f9bf007567f0252a)().then(setData);
    }, []);
    (0, $acw62.useEffect)(()=>{
        (0, $e16030e48e62d804$export$ce8e199cc2716d76)(0, "continue_player-container", {
            FUR: accountInfo?.character.cosmetics.FUR.equiped,
            EYES: accountInfo?.character.cosmetics.EYES.equiped,
            HEAD: accountInfo?.character.cosmetics.HEAD.equiped,
            TOP: accountInfo?.character.cosmetics.TOP.equiped,
            MOUTH: accountInfo?.character.cosmetics.MOUTH.equiped
        }).then((spine)=>{
            if (!spine?.skeleton) return;
            spine.speed = 0;
        });
    }, [
        accountInfo
    ]);
    const notEnoughGems = data !== undefined && accountInfo?.gems !== undefined && (data.reviveCost.gems ?? 0) > accountInfo.gems;
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: (0, $9805619f03ed02ef$export$91884aa883243770)((0, (/*@__PURE__*/$parcel$interopDefault($89eabbf3af7bf2fc$exports))), "content"),
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: (0, $9805619f03ed02ef$export$91884aa883243770)((0, (/*@__PURE__*/$parcel$interopDefault($89eabbf3af7bf2fc$exports))), "player"),
                id: "continue_player-container"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: (0, $9805619f03ed02ef$export$91884aa883243770)((0, (/*@__PURE__*/$parcel$interopDefault($89eabbf3af7bf2fc$exports))), "shadow")
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $6725244138e0595f$export$353f5b6fc5456de1), {
                className: (0, $9805619f03ed02ef$export$91884aa883243770)((0, (/*@__PURE__*/$parcel$interopDefault($89eabbf3af7bf2fc$exports))), `small gems ${notEnoughGems ? "gray" : "blue"}`),
                onClick: ()=>onClose(true),
                disabled: notEnoughGems,
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                        src: `${(0, $0426e2dd5e0de94d$export$24af3971dd36b33f)}/ui/gem.png`,
                        alt: "gems"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: (0, $9805619f03ed02ef$export$91884aa883243770)((0, (/*@__PURE__*/$parcel$interopDefault($89eabbf3af7bf2fc$exports))), `${notEnoughGems ? "error" : ""}`),
                        children: [
                            data?.reviveCost.gems ?? "...",
                            " GEMS"
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $6725244138e0595f$export$353f5b6fc5456de1), {
                className: (0, $9805619f03ed02ef$export$91884aa883243770)((0, (/*@__PURE__*/$parcel$interopDefault($89eabbf3af7bf2fc$exports))), "gray small"),
                onClick: ()=>onClose(false),
                children: "SKIP"
            })
        ]
    });
};
const $03301896a15ad73a$var$Title = ({ onClose: onClose })=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: (0, $9805619f03ed02ef$export$91884aa883243770)((0, (/*@__PURE__*/$parcel$interopDefault($89eabbf3af7bf2fc$exports))), "title"),
        children: [
            "Continue?",
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                src: `${(0, $0426e2dd5e0de94d$export$24af3971dd36b33f)}/ui/cross.png`,
                alt: "cross",
                onClick: ()=>onClose(false)
            })
        ]
    });
const $03301896a15ad73a$export$90a4e1a8bda2b731 = ({ className: className, onClose: onClose, ...props })=>{
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $207d23274fe2be11$export$6e63c1000ecf9db8), {
        className: (0, $9805619f03ed02ef$export$91884aa883243770)((0, (/*@__PURE__*/$parcel$interopDefault($89eabbf3af7bf2fc$exports))), `continue-menu ${className}`),
        title: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($03301896a15ad73a$var$Title, {
            onClose: onClose
        }),
        content: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($03301896a15ad73a$var$Content, {
            onClose: onClose
        }),
        onClickBackground: ()=>onClose(false),
        ...props
    });
};



parcelRequire("acw62");





var $acw62 = parcelRequire("acw62");

var $ftY1i = parcelRequire("ftY1i");

const $e97e44cd4550f081$export$a20373bb0df6efdd = (d = new Date)=>{
    const next = new Date(d);
    next.setUTCDate(next.getUTCDate() + (7 - (next.getUTCDay() + 6)) % 7);
    next.setUTCHours(0, 0, 0, 0);
    if (next <= d) next.setUTCDate(next.getUTCDate() + 7);
    return next;
};



var $243a0fb2392e59c4$exports = {};
// colyseus.js@0.15.14 (@colyseus/schema 2.0.9)
(function(global1, factory) {
    factory($243a0fb2392e59c4$exports);
})($243a0fb2392e59c4$exports, function(exports1) {
    "use strict";
    function _mergeNamespaces(n, m) {
        m.forEach(function(e) {
            e && typeof e !== "string" && !Array.isArray(e) && Object.keys(e).forEach(function(k) {
                if (k !== "default" && !(k in n)) {
                    var d = Object.getOwnPropertyDescriptor(e, k);
                    Object.defineProperty(n, k, d.get ? d : {
                        enumerable: true,
                        get: function() {
                            return e[k];
                        }
                    });
                }
            });
        });
        return Object.freeze(n);
    }
    //
    // Polyfills for legacy environments
    //
    /*
     * Support Android 4.4.x
     */ if (!ArrayBuffer.isView) ArrayBuffer.isView = function(a) {
        return a !== null && typeof a === "object" && a.buffer instanceof ArrayBuffer;
    };
    // Define globalThis if not available.
    // https://github.com/colyseus/colyseus.js/issues/86
    if (typeof globalThis === "undefined" && typeof window !== "undefined") // @ts-ignore
    window["globalThis"] = window;
    /******************************************************************************
    Copyright (c) Microsoft Corporation.

    Permission to use, copy, modify, and/or distribute this software for any
    purpose with or without fee is hereby granted.

    THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
    REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
    AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
    INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
    LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
    OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
    PERFORMANCE OF THIS SOFTWARE.
    ***************************************************************************** */ /* global Reflect, Promise */ var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    function __extends(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    }
    function __awaiter(thisArg, _arguments, P, generator) {
        function adopt(value) {
            return value instanceof P ? value : new P(function(resolve) {
                resolve(value);
            });
        }
        return new (P || (P = Promise))(function(resolve, reject) {
            function fulfilled(value) {
                try {
                    step(generator.next(value));
                } catch (e) {
                    reject(e);
                }
            }
            function rejected(value) {
                try {
                    step(generator["throw"](value));
                } catch (e) {
                    reject(e);
                }
            }
            function step(result) {
                result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
            }
            step((generator = generator.apply(thisArg, _arguments || [])).next());
        });
    }
    function __generator(thisArg, body) {
        var _ = {
            label: 0,
            sent: function() {
                if (t[0] & 1) throw t[1];
                return t[1];
            },
            trys: [],
            ops: []
        }, f, y, t, g;
        return g = {
            next: verb(0),
            "throw": verb(1),
            "return": verb(2)
        }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
            return this;
        }), g;
        function verb(n) {
            return function(v) {
                return step([
                    n,
                    v
                ]);
            };
        }
        function step(op) {
            if (f) throw new TypeError("Generator is already executing.");
            while(g && (g = 0, op[0] && (_ = 0)), _)try {
                if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
                if (y = 0, t) op = [
                    op[0] & 2,
                    t.value
                ];
                switch(op[0]){
                    case 0:
                    case 1:
                        t = op;
                        break;
                    case 4:
                        _.label++;
                        return {
                            value: op[1],
                            done: false
                        };
                    case 5:
                        _.label++;
                        y = op[1];
                        op = [
                            0
                        ];
                        continue;
                    case 7:
                        op = _.ops.pop();
                        _.trys.pop();
                        continue;
                    default:
                        if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                            _ = 0;
                            continue;
                        }
                        if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                            _.label = op[1];
                            break;
                        }
                        if (op[0] === 6 && _.label < t[1]) {
                            _.label = t[1];
                            t = op;
                            break;
                        }
                        if (t && _.label < t[2]) {
                            _.label = t[2];
                            _.ops.push(op);
                            break;
                        }
                        if (t[2]) _.ops.pop();
                        _.trys.pop();
                        continue;
                }
                op = body.call(thisArg, _);
            } catch (e) {
                op = [
                    6,
                    e
                ];
                y = 0;
            } finally{
                f = t = 0;
            }
            if (op[0] & 5) throw op[1];
            return {
                value: op[0] ? op[1] : void 0,
                done: true
            };
        }
    }
    function apply(src, tar) {
        tar.statusMessage = src.statusText;
        tar.statusCode = src.status;
        tar.data = src.body;
    }
    function send(method, uri, opts) {
        opts = opts || {};
        var timer, ctrl, tmp = opts.body;
        opts.method = method;
        opts.headers = opts.headers || {};
        if (tmp instanceof FormData) ;
        else if (tmp && typeof tmp == "object") {
            opts.headers["content-type"] = "application/json";
            opts.body = JSON.stringify(tmp);
        }
        if (opts.withCredentials) opts.credentials = "include";
        if (opts.timeout) {
            ctrl = new AbortController;
            opts.signal = ctrl.signal;
            timer = setTimeout(ctrl.abort, opts.timeout);
        }
        return new Promise((res, rej)=>{
            fetch(uri, opts).then((rr, reply)=>{
                clearTimeout(timer);
                apply(rr, rr); //=> rr.headers
                reply = rr.status >= 400 ? rej : res;
                tmp = rr.headers.get("content-type");
                if (!tmp || !~tmp.indexOf("application/json")) reply(rr);
                else rr.text().then((str)=>{
                    try {
                        rr.data = JSON.parse(str, opts.reviver);
                        reply(rr);
                    } catch (err) {
                        err.headers = rr.headers;
                        apply(rr, err);
                        rej(err);
                    }
                });
            }).catch((err)=>{
                err.timeout = ctrl && ctrl.signal.aborted;
                rej(err);
            });
        });
    }
    var get = /*#__PURE__*/ send.bind(send, "GET");
    var post = /*#__PURE__*/ send.bind(send, "POST");
    var patch = /*#__PURE__*/ send.bind(send, "PATCH");
    var del = /*#__PURE__*/ send.bind(send, "DELETE");
    var put = /*#__PURE__*/ send.bind(send, "PUT");
    var del_1 = del;
    var get_1 = get;
    var patch_1 = patch;
    var post_1 = post;
    var put_1 = put;
    var send_1 = send;
    var fetch_1 = {
        del: del_1,
        get: get_1,
        patch: patch_1,
        post: post_1,
        put: put_1,
        send: send_1
    };
    var http = /*#__PURE__*/ _mergeNamespaces({
        __proto__: null,
        "default": fetch_1,
        del: del_1,
        get: get_1,
        patch: patch_1,
        post: post_1,
        put: put_1,
        send: send_1
    }, [
        fetch_1
    ]);
    var CloseCode;
    (function(CloseCode) {
        CloseCode[CloseCode["CONSENTED"] = 4000] = "CONSENTED";
        CloseCode[CloseCode["DEVMODE_RESTART"] = 4010] = "DEVMODE_RESTART";
    })(CloseCode || (CloseCode = {}));
    var ServerError = /** @class */ function(_super) {
        __extends(ServerError, _super);
        function ServerError(code, message) {
            var _this = _super.call(this, message) || this;
            _this.name = "ServerError";
            _this.code = code;
            return _this;
        }
        return ServerError;
    }(Error);
    /**
     * Copyright (c) 2014 Ion Drive Software Ltd.
     * https://github.com/darrachequesne/notepack/
     *
     * Permission is hereby granted, free of charge, to any person obtaining a copy
     * of this software and associated documentation files (the "Software"), to deal
     * in the Software without restriction, including without limitation the rights
     * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
     * copies of the Software, and to permit persons to whom the Software is
     * furnished to do so, subject to the following conditions:
     *
     * The above copyright notice and this permission notice shall be included in all
     * copies or substantial portions of the Software.
     *
     * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
     * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
     * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
     * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
     * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
     * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
     * SOFTWARE.
     */ /**
     * Patch for Colyseus:
     * -------------------
     * notepack.io@3.0.1
     *
     * added `offset` on Decoder constructor, for messages arriving with a code
     * before actual msgpack data
     */ //
    // DECODER
    //
    function Decoder(buffer, offset) {
        this._offset = offset;
        if (buffer instanceof ArrayBuffer) {
            this._buffer = buffer;
            this._view = new DataView(this._buffer);
        } else if (ArrayBuffer.isView(buffer)) {
            this._buffer = buffer.buffer;
            this._view = new DataView(this._buffer, buffer.byteOffset, buffer.byteLength);
        } else throw new Error("Invalid argument");
    }
    function utf8Read$1(view, offset, length) {
        var string = "", chr = 0;
        for(var i = offset, end = offset + length; i < end; i++){
            var byte = view.getUint8(i);
            if ((byte & 0x80) === 0x00) {
                string += String.fromCharCode(byte);
                continue;
            }
            if ((byte & 0xe0) === 0xc0) {
                string += String.fromCharCode((byte & 0x1f) << 6 | view.getUint8(++i) & 0x3f);
                continue;
            }
            if ((byte & 0xf0) === 0xe0) {
                string += String.fromCharCode((byte & 0x0f) << 12 | (view.getUint8(++i) & 0x3f) << 6 | (view.getUint8(++i) & 0x3f) << 0);
                continue;
            }
            if ((byte & 0xf8) === 0xf0) {
                chr = (byte & 0x07) << 18 | (view.getUint8(++i) & 0x3f) << 12 | (view.getUint8(++i) & 0x3f) << 6 | (view.getUint8(++i) & 0x3f) << 0;
                if (chr >= 0x010000) {
                    chr -= 0x010000;
                    string += String.fromCharCode((chr >>> 10) + 0xD800, (chr & 0x3FF) + 0xDC00);
                } else string += String.fromCharCode(chr);
                continue;
            }
            throw new Error("Invalid byte " + byte.toString(16));
        }
        return string;
    }
    Decoder.prototype._array = function(length) {
        var value = new Array(length);
        for(var i = 0; i < length; i++)value[i] = this._parse();
        return value;
    };
    Decoder.prototype._map = function(length) {
        var key = "", value = {};
        for(var i = 0; i < length; i++){
            key = this._parse();
            value[key] = this._parse();
        }
        return value;
    };
    Decoder.prototype._str = function(length) {
        var value = utf8Read$1(this._view, this._offset, length);
        this._offset += length;
        return value;
    };
    Decoder.prototype._bin = function(length) {
        var value = this._buffer.slice(this._offset, this._offset + length);
        this._offset += length;
        return value;
    };
    Decoder.prototype._parse = function() {
        var prefix = this._view.getUint8(this._offset++);
        var value, length = 0, type = 0, hi = 0, lo = 0;
        if (prefix < 0xc0) {
            // positive fixint
            if (prefix < 0x80) return prefix;
            // fixmap
            if (prefix < 0x90) return this._map(prefix & 0x0f);
            // fixarray
            if (prefix < 0xa0) return this._array(prefix & 0x0f);
            // fixstr
            return this._str(prefix & 0x1f);
        }
        // negative fixint
        if (prefix > 0xdf) return (0xff - prefix + 1) * -1;
        switch(prefix){
            // nil
            case 0xc0:
                return null;
            // false
            case 0xc2:
                return false;
            // true
            case 0xc3:
                return true;
            // bin
            case 0xc4:
                length = this._view.getUint8(this._offset);
                this._offset += 1;
                return this._bin(length);
            case 0xc5:
                length = this._view.getUint16(this._offset);
                this._offset += 2;
                return this._bin(length);
            case 0xc6:
                length = this._view.getUint32(this._offset);
                this._offset += 4;
                return this._bin(length);
            // ext
            case 0xc7:
                length = this._view.getUint8(this._offset);
                type = this._view.getInt8(this._offset + 1);
                this._offset += 2;
                if (type === -1) {
                    // timestamp 96
                    var ns = this._view.getUint32(this._offset);
                    hi = this._view.getInt32(this._offset + 4);
                    lo = this._view.getUint32(this._offset + 8);
                    this._offset += 12;
                    return new Date((hi * 0x100000000 + lo) * 1e3 + ns / 1e6);
                }
                return [
                    type,
                    this._bin(length)
                ];
            case 0xc8:
                length = this._view.getUint16(this._offset);
                type = this._view.getInt8(this._offset + 2);
                this._offset += 3;
                return [
                    type,
                    this._bin(length)
                ];
            case 0xc9:
                length = this._view.getUint32(this._offset);
                type = this._view.getInt8(this._offset + 4);
                this._offset += 5;
                return [
                    type,
                    this._bin(length)
                ];
            // float
            case 0xca:
                value = this._view.getFloat32(this._offset);
                this._offset += 4;
                return value;
            case 0xcb:
                value = this._view.getFloat64(this._offset);
                this._offset += 8;
                return value;
            // uint
            case 0xcc:
                value = this._view.getUint8(this._offset);
                this._offset += 1;
                return value;
            case 0xcd:
                value = this._view.getUint16(this._offset);
                this._offset += 2;
                return value;
            case 0xce:
                value = this._view.getUint32(this._offset);
                this._offset += 4;
                return value;
            case 0xcf:
                hi = this._view.getUint32(this._offset) * Math.pow(2, 32);
                lo = this._view.getUint32(this._offset + 4);
                this._offset += 8;
                return hi + lo;
            // int
            case 0xd0:
                value = this._view.getInt8(this._offset);
                this._offset += 1;
                return value;
            case 0xd1:
                value = this._view.getInt16(this._offset);
                this._offset += 2;
                return value;
            case 0xd2:
                value = this._view.getInt32(this._offset);
                this._offset += 4;
                return value;
            case 0xd3:
                hi = this._view.getInt32(this._offset) * Math.pow(2, 32);
                lo = this._view.getUint32(this._offset + 4);
                this._offset += 8;
                return hi + lo;
            // fixext
            case 0xd4:
                type = this._view.getInt8(this._offset);
                this._offset += 1;
                if (type === 0x00) {
                    // custom encoding for 'undefined' (kept for backward-compatibility)
                    this._offset += 1;
                    return void 0;
                }
                return [
                    type,
                    this._bin(1)
                ];
            case 0xd5:
                type = this._view.getInt8(this._offset);
                this._offset += 1;
                return [
                    type,
                    this._bin(2)
                ];
            case 0xd6:
                type = this._view.getInt8(this._offset);
                this._offset += 1;
                if (type === -1) {
                    // timestamp 32
                    value = this._view.getUint32(this._offset);
                    this._offset += 4;
                    return new Date(value * 1e3);
                }
                return [
                    type,
                    this._bin(4)
                ];
            case 0xd7:
                type = this._view.getInt8(this._offset);
                this._offset += 1;
                if (type === 0x00) {
                    // custom date encoding (kept for backward-compatibility)
                    hi = this._view.getInt32(this._offset) * Math.pow(2, 32);
                    lo = this._view.getUint32(this._offset + 4);
                    this._offset += 8;
                    return new Date(hi + lo);
                }
                if (type === -1) {
                    // timestamp 64
                    hi = this._view.getUint32(this._offset);
                    lo = this._view.getUint32(this._offset + 4);
                    this._offset += 8;
                    var s = (hi & 0x3) * 0x100000000 + lo;
                    return new Date(s * 1e3 + (hi >>> 2) / 1e6);
                }
                return [
                    type,
                    this._bin(8)
                ];
            case 0xd8:
                type = this._view.getInt8(this._offset);
                this._offset += 1;
                return [
                    type,
                    this._bin(16)
                ];
            // str
            case 0xd9:
                length = this._view.getUint8(this._offset);
                this._offset += 1;
                return this._str(length);
            case 0xda:
                length = this._view.getUint16(this._offset);
                this._offset += 2;
                return this._str(length);
            case 0xdb:
                length = this._view.getUint32(this._offset);
                this._offset += 4;
                return this._str(length);
            // array
            case 0xdc:
                length = this._view.getUint16(this._offset);
                this._offset += 2;
                return this._array(length);
            case 0xdd:
                length = this._view.getUint32(this._offset);
                this._offset += 4;
                return this._array(length);
            // map
            case 0xde:
                length = this._view.getUint16(this._offset);
                this._offset += 2;
                return this._map(length);
            case 0xdf:
                length = this._view.getUint32(this._offset);
                this._offset += 4;
                return this._map(length);
        }
        throw new Error("Could not parse");
    };
    function decode(buffer, offset) {
        if (offset === void 0) offset = 0;
        var decoder = new Decoder(buffer, offset);
        var value = decoder._parse();
        if (decoder._offset !== buffer.byteLength) throw new Error(buffer.byteLength - decoder._offset + " trailing bytes");
        return value;
    }
    //
    // ENCODER
    //
    var TIMESTAMP32_MAX_SEC = 4294967295; // 32-bit unsigned int
    var TIMESTAMP64_MAX_SEC = 17179869183; // 34-bit unsigned int
    function utf8Write(view, offset, str) {
        var c = 0;
        for(var i = 0, l = str.length; i < l; i++){
            c = str.charCodeAt(i);
            if (c < 0x80) view.setUint8(offset++, c);
            else if (c < 0x800) {
                view.setUint8(offset++, 0xc0 | c >> 6);
                view.setUint8(offset++, 0x80 | c & 0x3f);
            } else if (c < 0xd800 || c >= 0xe000) {
                view.setUint8(offset++, 0xe0 | c >> 12);
                view.setUint8(offset++, 0x80 | c >> 6 & 0x3f);
                view.setUint8(offset++, 0x80 | c & 0x3f);
            } else {
                i++;
                c = 0x10000 + ((c & 0x3ff) << 10 | str.charCodeAt(i) & 0x3ff);
                view.setUint8(offset++, 0xf0 | c >> 18);
                view.setUint8(offset++, 0x80 | c >> 12 & 0x3f);
                view.setUint8(offset++, 0x80 | c >> 6 & 0x3f);
                view.setUint8(offset++, 0x80 | c & 0x3f);
            }
        }
    }
    function utf8Length$1(str) {
        var c = 0, length = 0;
        for(var i = 0, l = str.length; i < l; i++){
            c = str.charCodeAt(i);
            if (c < 0x80) length += 1;
            else if (c < 0x800) length += 2;
            else if (c < 0xd800 || c >= 0xe000) length += 3;
            else {
                i++;
                length += 4;
            }
        }
        return length;
    }
    function _encode(bytes, defers, value) {
        var type = typeof value, i = 0, l = 0, hi = 0, lo = 0, length = 0, size = 0;
        if (type === "string") {
            length = utf8Length$1(value);
            // fixstr
            if (length < 0x20) {
                bytes.push(length | 0xa0);
                size = 1;
            } else if (length < 0x100) {
                bytes.push(0xd9, length);
                size = 2;
            } else if (length < 0x10000) {
                bytes.push(0xda, length >> 8, length);
                size = 3;
            } else if (length < 0x100000000) {
                bytes.push(0xdb, length >> 24, length >> 16, length >> 8, length);
                size = 5;
            } else throw new Error("String too long");
            defers.push({
                _str: value,
                _length: length,
                _offset: bytes.length
            });
            return size + length;
        }
        if (type === "number") {
            // TODO: encode to float 32?
            // float 64
            if (Math.floor(value) !== value || !isFinite(value)) {
                bytes.push(0xcb);
                defers.push({
                    _float: value,
                    _length: 8,
                    _offset: bytes.length
                });
                return 9;
            }
            if (value >= 0) {
                // positive fixnum
                if (value < 0x80) {
                    bytes.push(value);
                    return 1;
                }
                // uint 8
                if (value < 0x100) {
                    bytes.push(0xcc, value);
                    return 2;
                }
                // uint 16
                if (value < 0x10000) {
                    bytes.push(0xcd, value >> 8, value);
                    return 3;
                }
                // uint 32
                if (value < 0x100000000) {
                    bytes.push(0xce, value >> 24, value >> 16, value >> 8, value);
                    return 5;
                }
                // uint 64
                hi = value / Math.pow(2, 32) >> 0;
                lo = value >>> 0;
                bytes.push(0xcf, hi >> 24, hi >> 16, hi >> 8, hi, lo >> 24, lo >> 16, lo >> 8, lo);
                return 9;
            } else {
                // negative fixnum
                if (value >= -32) {
                    bytes.push(value);
                    return 1;
                }
                // int 8
                if (value >= -128) {
                    bytes.push(0xd0, value);
                    return 2;
                }
                // int 16
                if (value >= -32768) {
                    bytes.push(0xd1, value >> 8, value);
                    return 3;
                }
                // int 32
                if (value >= -2147483648) {
                    bytes.push(0xd2, value >> 24, value >> 16, value >> 8, value);
                    return 5;
                }
                // int 64
                hi = Math.floor(value / Math.pow(2, 32));
                lo = value >>> 0;
                bytes.push(0xd3, hi >> 24, hi >> 16, hi >> 8, hi, lo >> 24, lo >> 16, lo >> 8, lo);
                return 9;
            }
        }
        if (type === "object") {
            // nil
            if (value === null) {
                bytes.push(0xc0);
                return 1;
            }
            if (Array.isArray(value)) {
                length = value.length;
                // fixarray
                if (length < 0x10) {
                    bytes.push(length | 0x90);
                    size = 1;
                } else if (length < 0x10000) {
                    bytes.push(0xdc, length >> 8, length);
                    size = 3;
                } else if (length < 0x100000000) {
                    bytes.push(0xdd, length >> 24, length >> 16, length >> 8, length);
                    size = 5;
                } else throw new Error("Array too large");
                for(i = 0; i < length; i++)size += _encode(bytes, defers, value[i]);
                return size;
            }
            if (value instanceof Date) {
                var ms = value.getTime();
                var s = Math.floor(ms / 1e3);
                var ns = (ms - s * 1e3) * 1e6;
                if (s >= 0 && ns >= 0 && s <= TIMESTAMP64_MAX_SEC) {
                    if (ns === 0 && s <= TIMESTAMP32_MAX_SEC) {
                        // timestamp 32
                        bytes.push(0xd6, 0xff, s >> 24, s >> 16, s >> 8, s);
                        return 6;
                    } else {
                        // timestamp 64
                        hi = s / 0x100000000;
                        lo = s & 0xffffffff;
                        bytes.push(0xd7, 0xff, ns >> 22, ns >> 14, ns >> 6, hi, lo >> 24, lo >> 16, lo >> 8, lo);
                        return 10;
                    }
                } else {
                    // timestamp 96
                    hi = Math.floor(s / 0x100000000);
                    lo = s >>> 0;
                    bytes.push(0xc7, 0x0c, 0xff, ns >> 24, ns >> 16, ns >> 8, ns, hi >> 24, hi >> 16, hi >> 8, hi, lo >> 24, lo >> 16, lo >> 8, lo);
                    return 15;
                }
            }
            if (value instanceof ArrayBuffer) {
                length = value.byteLength;
                // bin 8
                if (length < 0x100) {
                    bytes.push(0xc4, length);
                    size = 2;
                } else // bin 16
                if (length < 0x10000) {
                    bytes.push(0xc5, length >> 8, length);
                    size = 3;
                } else // bin 32
                if (length < 0x100000000) {
                    bytes.push(0xc6, length >> 24, length >> 16, length >> 8, length);
                    size = 5;
                } else throw new Error("Buffer too large");
                defers.push({
                    _bin: value,
                    _length: length,
                    _offset: bytes.length
                });
                return size + length;
            }
            if (typeof value.toJSON === "function") return _encode(bytes, defers, value.toJSON());
            var keys = [], key = "";
            var allKeys = Object.keys(value);
            for(i = 0, l = allKeys.length; i < l; i++){
                key = allKeys[i];
                if (value[key] !== undefined && typeof value[key] !== "function") keys.push(key);
            }
            length = keys.length;
            // fixmap
            if (length < 0x10) {
                bytes.push(length | 0x80);
                size = 1;
            } else if (length < 0x10000) {
                bytes.push(0xde, length >> 8, length);
                size = 3;
            } else if (length < 0x100000000) {
                bytes.push(0xdf, length >> 24, length >> 16, length >> 8, length);
                size = 5;
            } else throw new Error("Object too large");
            for(i = 0; i < length; i++){
                key = keys[i];
                size += _encode(bytes, defers, key);
                size += _encode(bytes, defers, value[key]);
            }
            return size;
        }
        // false/true
        if (type === "boolean") {
            bytes.push(value ? 0xc3 : 0xc2);
            return 1;
        }
        if (type === "undefined") {
            bytes.push(0xc0);
            return 1;
        }
        // custom types like BigInt (typeof value === 'bigint')
        if (typeof value.toJSON === "function") return _encode(bytes, defers, value.toJSON());
        throw new Error("Could not encode");
    }
    function encode(value) {
        var bytes = [];
        var defers = [];
        var size = _encode(bytes, defers, value);
        var buf = new ArrayBuffer(size);
        var view = new DataView(buf);
        var deferIndex = 0;
        var deferWritten = 0;
        var nextOffset = -1;
        if (defers.length > 0) nextOffset = defers[0]._offset;
        var defer, deferLength = 0, offset = 0;
        for(var i = 0, l = bytes.length; i < l; i++){
            view.setUint8(deferWritten + i, bytes[i]);
            if (i + 1 !== nextOffset) continue;
            defer = defers[deferIndex];
            deferLength = defer._length;
            offset = deferWritten + nextOffset;
            if (defer._bin) {
                var bin = new Uint8Array(defer._bin);
                for(var j = 0; j < deferLength; j++)view.setUint8(offset + j, bin[j]);
            } else if (defer._str) utf8Write(view, offset, defer._str);
            else if (defer._float !== undefined) view.setFloat64(offset, defer._float);
            deferIndex++;
            deferWritten += deferLength;
            if (defers[deferIndex]) nextOffset = defers[deferIndex]._offset;
        }
        return buf;
    }
    var browser = function() {
        throw new Error("ws does not work in the browser. Browser clients must use the native WebSocket object");
    };
    var WebSocket = globalThis.WebSocket || browser;
    var WebSocketTransport = /** @class */ function() {
        function WebSocketTransport(events) {
            this.events = events;
        }
        WebSocketTransport.prototype.send = function(data) {
            if (data instanceof ArrayBuffer) this.ws.send(data);
            else if (Array.isArray(data)) this.ws.send(new Uint8Array(data).buffer);
        };
        WebSocketTransport.prototype.connect = function(url) {
            this.ws = new WebSocket(url, this.protocols);
            this.ws.binaryType = "arraybuffer";
            this.ws.onopen = this.events.onopen;
            this.ws.onmessage = this.events.onmessage;
            this.ws.onclose = this.events.onclose;
            this.ws.onerror = this.events.onerror;
        };
        WebSocketTransport.prototype.close = function(code, reason) {
            this.ws.close(code, reason);
        };
        Object.defineProperty(WebSocketTransport.prototype, "isOpen", {
            get: function() {
                return this.ws.readyState === WebSocket.OPEN;
            },
            enumerable: false,
            configurable: true
        });
        return WebSocketTransport;
    }();
    var Connection = /** @class */ function() {
        function Connection() {
            this.events = {};
            this.transport = new WebSocketTransport(this.events);
        }
        Connection.prototype.send = function(data) {
            this.transport.send(data);
        };
        Connection.prototype.connect = function(url) {
            this.transport.connect(url);
        };
        Connection.prototype.close = function(code, reason) {
            this.transport.close(code, reason);
        };
        Object.defineProperty(Connection.prototype, "isOpen", {
            get: function() {
                return this.transport.isOpen;
            },
            enumerable: false,
            configurable: true
        });
        return Connection;
    }();
    // Use codes between 0~127 for lesser throughput (1 byte)
    exports1.Protocol = void 0;
    (function(Protocol) {
        // Room-related (10~19)
        Protocol[Protocol["HANDSHAKE"] = 9] = "HANDSHAKE";
        Protocol[Protocol["JOIN_ROOM"] = 10] = "JOIN_ROOM";
        Protocol[Protocol["ERROR"] = 11] = "ERROR";
        Protocol[Protocol["LEAVE_ROOM"] = 12] = "LEAVE_ROOM";
        Protocol[Protocol["ROOM_DATA"] = 13] = "ROOM_DATA";
        Protocol[Protocol["ROOM_STATE"] = 14] = "ROOM_STATE";
        Protocol[Protocol["ROOM_STATE_PATCH"] = 15] = "ROOM_STATE_PATCH";
        Protocol[Protocol["ROOM_DATA_SCHEMA"] = 16] = "ROOM_DATA_SCHEMA";
        Protocol[Protocol["ROOM_DATA_BYTES"] = 17] = "ROOM_DATA_BYTES";
    })(exports1.Protocol || (exports1.Protocol = {}));
    exports1.ErrorCode = void 0;
    (function(ErrorCode) {
        ErrorCode[ErrorCode["MATCHMAKE_NO_HANDLER"] = 4210] = "MATCHMAKE_NO_HANDLER";
        ErrorCode[ErrorCode["MATCHMAKE_INVALID_CRITERIA"] = 4211] = "MATCHMAKE_INVALID_CRITERIA";
        ErrorCode[ErrorCode["MATCHMAKE_INVALID_ROOM_ID"] = 4212] = "MATCHMAKE_INVALID_ROOM_ID";
        ErrorCode[ErrorCode["MATCHMAKE_UNHANDLED"] = 4213] = "MATCHMAKE_UNHANDLED";
        ErrorCode[ErrorCode["MATCHMAKE_EXPIRED"] = 4214] = "MATCHMAKE_EXPIRED";
        ErrorCode[ErrorCode["AUTH_FAILED"] = 4215] = "AUTH_FAILED";
        ErrorCode[ErrorCode["APPLICATION_ERROR"] = 4216] = "APPLICATION_ERROR";
    })(exports1.ErrorCode || (exports1.ErrorCode = {}));
    function utf8Read(view, offset) {
        var length = view[offset++];
        var string = "", chr = 0;
        for(var i = offset, end = offset + length; i < end; i++){
            var byte = view[i];
            if ((byte & 0x80) === 0x00) {
                string += String.fromCharCode(byte);
                continue;
            }
            if ((byte & 0xe0) === 0xc0) {
                string += String.fromCharCode((byte & 0x1f) << 6 | view[++i] & 0x3f);
                continue;
            }
            if ((byte & 0xf0) === 0xe0) {
                string += String.fromCharCode((byte & 0x0f) << 12 | (view[++i] & 0x3f) << 6 | (view[++i] & 0x3f) << 0);
                continue;
            }
            if ((byte & 0xf8) === 0xf0) {
                chr = (byte & 0x07) << 18 | (view[++i] & 0x3f) << 12 | (view[++i] & 0x3f) << 6 | (view[++i] & 0x3f) << 0;
                if (chr >= 0x010000) {
                    chr -= 0x010000;
                    string += String.fromCharCode((chr >>> 10) + 0xD800, (chr & 0x3FF) + 0xDC00);
                } else string += String.fromCharCode(chr);
                continue;
            }
            throw new Error("Invalid byte " + byte.toString(16));
        }
        return string;
    }
    // Faster for short strings than Buffer.byteLength
    function utf8Length(str) {
        if (str === void 0) str = "";
        var c = 0;
        var length = 0;
        for(var i = 0, l = str.length; i < l; i++){
            c = str.charCodeAt(i);
            if (c < 0x80) length += 1;
            else if (c < 0x800) length += 2;
            else if (c < 0xd800 || c >= 0xe000) length += 3;
            else {
                i++;
                length += 4;
            }
        }
        return length + 1;
    }
    var serializers = {};
    function registerSerializer(id, serializer) {
        serializers[id] = serializer;
    }
    function getSerializer(id) {
        var serializer = serializers[id];
        if (!serializer) throw new Error("missing serializer: " + id);
        return serializer;
    }
    /**
     * The MIT License (MIT)
     *
     * Copyright 2016 Andrey Sitnik <andrey@sitnik.ru>
     *
     * Permission is hereby granted, free of charge, to any person obtaining a copy of
     * this software and associated documentation files (the "Software"), to deal in
     * the Software without restriction, including without limitation the rights to
     * use, copy, modify, merge, publish, distribute, sublicense, and/or sell copies of
     * the Software, and to permit persons to whom the Software is furnished to do so,
     * subject to the following conditions:
     *
     * The above copyright notice and this permission notice shall be included in all
     * copies or substantial portions of the Software.
     *
     * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
     * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY, FITNESS
     * FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR
     * COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER
     * IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN
     * CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.
     */ var createNanoEvents = function() {
        return {
            emit: function(event) {
                var args = [];
                for(var _i = 1; _i < arguments.length; _i++)args[_i - 1] = arguments[_i];
                var callbacks = this.events[event] || [];
                for(var i = 0, length_1 = callbacks.length; i < length_1; i++)callbacks[i].apply(callbacks, args);
            },
            events: {},
            on: function(event, cb) {
                var _this = this;
                var _a;
                ((_a = this.events[event]) === null || _a === void 0 ? void 0 : _a.push(cb)) || (this.events[event] = [
                    cb
                ]);
                return function() {
                    var _a;
                    _this.events[event] = (_a = _this.events[event]) === null || _a === void 0 ? void 0 : _a.filter(function(i) {
                        return cb !== i;
                    });
                };
            }
        };
    };
    var EventEmitter = /** @class */ function() {
        function EventEmitter() {
            this.handlers = [];
        }
        EventEmitter.prototype.register = function(cb, once) {
            this.handlers.push(cb);
            return this;
        };
        EventEmitter.prototype.invoke = function() {
            var _this = this;
            var args = [];
            for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
            this.handlers.forEach(function(handler) {
                return handler.apply(_this, args);
            });
        };
        EventEmitter.prototype.invokeAsync = function() {
            var _this = this;
            var args = [];
            for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
            return Promise.all(this.handlers.map(function(handler) {
                return handler.apply(_this, args);
            }));
        };
        EventEmitter.prototype.remove = function(cb) {
            var index = this.handlers.indexOf(cb);
            this.handlers[index] = this.handlers[this.handlers.length - 1];
            this.handlers.pop();
        };
        EventEmitter.prototype.clear = function() {
            this.handlers = [];
        };
        return EventEmitter;
    }();
    function createSignal() {
        var emitter = new EventEmitter();
        function register(cb) {
            return emitter.register(cb, this === null);
        }
        register.once = function(cb) {
            var callback = function() {
                var args = [];
                for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
                cb.apply(this, args);
                emitter.remove(callback);
            };
            emitter.register(callback);
        };
        register.remove = function(cb) {
            return emitter.remove(cb);
        };
        register.invoke = function() {
            var args = [];
            for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
            return emitter.invoke.apply(emitter, args);
        };
        register.invokeAsync = function() {
            var args = [];
            for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
            return emitter.invokeAsync.apply(emitter, args);
        };
        register.clear = function() {
            return emitter.clear();
        };
        return register;
    }
    var commonjsGlobal = typeof globalThis !== "undefined" ? globalThis : typeof window !== "undefined" ? window : typeof $parcel$global !== "undefined" ? $parcel$global : typeof self !== "undefined" ? self : {};
    function createCommonjsModule(fn) {
        var module = {
            exports: {}
        };
        return fn(module, module.exports), module.exports;
    }
    var umd = createCommonjsModule(function(module, exports1) {
        (function(global1, factory) {
            factory(exports1);
        })(commonjsGlobal, function(exports1) {
            /******************************************************************************
        Copyright (c) Microsoft Corporation.

        Permission to use, copy, modify, and/or distribute this software for any
        purpose with or without fee is hereby granted.

        THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
        REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
        AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
        INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
        LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
        OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
        PERFORMANCE OF THIS SOFTWARE.
        ***************************************************************************** */ /* global Reflect, Promise */ var extendStatics = function(d, b) {
                extendStatics = Object.setPrototypeOf || ({
                    __proto__: []
                }) instanceof Array && function(d, b) {
                    d.__proto__ = b;
                } || function(d, b) {
                    for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
                };
                return extendStatics(d, b);
            };
            function __extends(d, b) {
                if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
                extendStatics(d, b);
                function __() {
                    this.constructor = d;
                }
                d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
            }
            function __decorate(decorators, target, key, desc) {
                var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
                if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
                else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
                return c > 3 && r && Object.defineProperty(target, key, r), r;
            }
            function __spreadArray(to, from, pack) {
                if (pack || arguments.length === 2) {
                    for(var i = 0, l = from.length, ar; i < l; i++)if (ar || !(i in from)) {
                        if (!ar) ar = Array.prototype.slice.call(from, 0, i);
                        ar[i] = from[i];
                    }
                }
                return to.concat(ar || Array.prototype.slice.call(from));
            }
            // export const SWITCH_TO_STRUCTURE = 193; (easily collides with DELETE_AND_ADD + fieldIndex = 2)
            var SWITCH_TO_STRUCTURE = 255; // (decoding collides with DELETE_AND_ADD + fieldIndex = 63)
            var TYPE_ID = 213;
            /**
         * Encoding Schema field operations.
         */ exports1.OPERATION = void 0;
            (function(OPERATION) {
                // add new structure/primitive
                OPERATION[OPERATION["ADD"] = 128] = "ADD";
                // replace structure/primitive
                OPERATION[OPERATION["REPLACE"] = 0] = "REPLACE";
                // delete field
                OPERATION[OPERATION["DELETE"] = 64] = "DELETE";
                // DELETE field, followed by an ADD
                OPERATION[OPERATION["DELETE_AND_ADD"] = 192] = "DELETE_AND_ADD";
                // TOUCH is used to determine hierarchy of nested Schema structures during serialization.
                // touches are NOT encoded.
                OPERATION[OPERATION["TOUCH"] = 1] = "TOUCH";
                // MapSchema Operations
                OPERATION[OPERATION["CLEAR"] = 10] = "CLEAR";
            })(exports1.OPERATION || (exports1.OPERATION = {}));
            // export enum OPERATION {
            //     // add new structure/primitive
            //     // (128)
            //     ADD = 128, // 10000000,
            //     // replace structure/primitive
            //     REPLACE = 1,// 00000001
            //     // delete field
            //     DELETE = 192, // 11000000
            //     // DELETE field, followed by an ADD
            //     DELETE_AND_ADD = 224, // 11100000
            //     // TOUCH is used to determine hierarchy of nested Schema structures during serialization.
            //     // touches are NOT encoded.
            //     TOUCH = 0, // 00000000
            //     // MapSchema Operations
            //     CLEAR = 10,
            // }
            var ChangeTree = /** @class */ function() {
                function ChangeTree(ref, parent, root) {
                    this.changed = false;
                    this.changes = new Map();
                    this.allChanges = new Set();
                    // cached indexes for filtering
                    this.caches = {};
                    this.currentCustomOperation = 0;
                    this.ref = ref;
                    this.setParent(parent, root);
                }
                ChangeTree.prototype.setParent = function(parent, root, parentIndex) {
                    var _this = this;
                    if (!this.indexes) this.indexes = this.ref instanceof Schema ? this.ref["_definition"].indexes : {};
                    this.parent = parent;
                    this.parentIndex = parentIndex;
                    // avoid setting parents with empty `root`
                    if (!root) return;
                    this.root = root;
                    //
                    // assign same parent on child structures
                    //
                    if (this.ref instanceof Schema) {
                        var definition = this.ref["_definition"];
                        for(var field in definition.schema){
                            var value = this.ref[field];
                            if (value && value["$changes"]) {
                                var parentIndex_1 = definition.indexes[field];
                                value["$changes"].setParent(this.ref, root, parentIndex_1);
                            }
                        }
                    } else if (typeof this.ref === "object") this.ref.forEach(function(value, key) {
                        if (value instanceof Schema) {
                            var changeTreee = value["$changes"];
                            var parentIndex_2 = _this.ref["$changes"].indexes[key];
                            changeTreee.setParent(_this.ref, _this.root, parentIndex_2);
                        }
                    });
                };
                ChangeTree.prototype.operation = function(op) {
                    this.changes.set(--this.currentCustomOperation, op);
                };
                ChangeTree.prototype.change = function(fieldName, operation) {
                    if (operation === void 0) operation = exports1.OPERATION.ADD;
                    var index = typeof fieldName === "number" ? fieldName : this.indexes[fieldName];
                    this.assertValidIndex(index, fieldName);
                    var previousChange = this.changes.get(index);
                    if (!previousChange || previousChange.op === exports1.OPERATION.DELETE || previousChange.op === exports1.OPERATION.TOUCH // (mazmorra.io's BattleAction issue)
                    ) this.changes.set(index, {
                        op: !previousChange ? operation : previousChange.op === exports1.OPERATION.DELETE ? exports1.OPERATION.DELETE_AND_ADD : operation,
                        // : OPERATION.REPLACE,
                        index: index
                    });
                    this.allChanges.add(index);
                    this.changed = true;
                    this.touchParents();
                };
                ChangeTree.prototype.touch = function(fieldName) {
                    var index = typeof fieldName === "number" ? fieldName : this.indexes[fieldName];
                    this.assertValidIndex(index, fieldName);
                    if (!this.changes.has(index)) this.changes.set(index, {
                        op: exports1.OPERATION.TOUCH,
                        index: index
                    });
                    this.allChanges.add(index);
                    // ensure touch is placed until the $root is found.
                    this.touchParents();
                };
                ChangeTree.prototype.touchParents = function() {
                    if (this.parent) this.parent["$changes"].touch(this.parentIndex);
                };
                ChangeTree.prototype.getType = function(index) {
                    if (this.ref["_definition"]) {
                        var definition = this.ref["_definition"];
                        return definition.schema[definition.fieldsByIndex[index]];
                    } else {
                        var definition = this.parent["_definition"];
                        var parentType = definition.schema[definition.fieldsByIndex[this.parentIndex]];
                        //
                        // Get the child type from parent structure.
                        // - ["string"] => "string"
                        // - { map: "string" } => "string"
                        // - { set: "string" } => "string"
                        //
                        return Object.values(parentType)[0];
                    }
                };
                ChangeTree.prototype.getChildrenFilter = function() {
                    var childFilters = this.parent["_definition"].childFilters;
                    return childFilters && childFilters[this.parentIndex];
                };
                //
                // used during `.encode()`
                //
                ChangeTree.prototype.getValue = function(index) {
                    return this.ref["getByIndex"](index);
                };
                ChangeTree.prototype.delete = function(fieldName) {
                    var index = typeof fieldName === "number" ? fieldName : this.indexes[fieldName];
                    if (index === undefined) {
                        console.warn("@colyseus/schema ".concat(this.ref.constructor.name, ": trying to delete non-existing index: ").concat(fieldName, " (").concat(index, ")"));
                        return;
                    }
                    var previousValue = this.getValue(index);
                    // console.log("$changes.delete =>", { fieldName, index, previousValue });
                    this.changes.set(index, {
                        op: exports1.OPERATION.DELETE,
                        index: index
                    });
                    this.allChanges.delete(index);
                    // delete cache
                    delete this.caches[index];
                    // remove `root` reference
                    if (previousValue && previousValue["$changes"]) previousValue["$changes"].parent = undefined;
                    this.changed = true;
                    this.touchParents();
                };
                ChangeTree.prototype.discard = function(changed, discardAll) {
                    var _this = this;
                    if (changed === void 0) changed = false;
                    if (discardAll === void 0) discardAll = false;
                    //
                    // Map, Array, etc:
                    // Remove cached key to ensure ADD operations is unsed instead of
                    // REPLACE in case same key is used on next patches.
                    //
                    // TODO: refactor this. this is not relevant for Collection and Set.
                    //
                    if (!(this.ref instanceof Schema)) this.changes.forEach(function(change) {
                        if (change.op === exports1.OPERATION.DELETE) {
                            var index = _this.ref["getIndex"](change.index);
                            delete _this.indexes[index];
                        }
                    });
                    this.changes.clear();
                    this.changed = changed;
                    if (discardAll) this.allChanges.clear();
                    // re-set `currentCustomOperation`
                    this.currentCustomOperation = 0;
                };
                /**
             * Recursively discard all changes from this, and child structures.
             */ ChangeTree.prototype.discardAll = function() {
                    var _this = this;
                    this.changes.forEach(function(change) {
                        var value = _this.getValue(change.index);
                        if (value && value["$changes"]) value["$changes"].discardAll();
                    });
                    this.discard();
                };
                // cache(field: number, beginIndex: number, endIndex: number) {
                ChangeTree.prototype.cache = function(field, cachedBytes) {
                    this.caches[field] = cachedBytes;
                };
                ChangeTree.prototype.clone = function() {
                    return new ChangeTree(this.ref, this.parent, this.root);
                };
                ChangeTree.prototype.ensureRefId = function() {
                    // skip if refId is already set.
                    if (this.refId !== undefined) return;
                    this.refId = this.root.getNextUniqueId();
                };
                ChangeTree.prototype.assertValidIndex = function(index, fieldName) {
                    if (index === undefined) throw new Error('ChangeTree: missing index for field "'.concat(fieldName, '"'));
                };
                return ChangeTree;
            }();
            function addCallback($callbacks, op, callback, existing) {
                // initialize list of callbacks
                if (!$callbacks[op]) $callbacks[op] = [];
                $callbacks[op].push(callback);
                //
                // Trigger callback for existing elements
                // - OPERATION.ADD
                // - OPERATION.REPLACE
                //
                existing === null || existing === void 0 || existing.forEach(function(item, key) {
                    return callback(item, key);
                });
                return function() {
                    return spliceOne($callbacks[op], $callbacks[op].indexOf(callback));
                };
            }
            function removeChildRefs(changes) {
                var _this = this;
                var needRemoveRef = typeof this.$changes.getType() !== "string";
                this.$items.forEach(function(item, key) {
                    changes.push({
                        refId: _this.$changes.refId,
                        op: exports1.OPERATION.DELETE,
                        field: key,
                        value: undefined,
                        previousValue: item
                    });
                    if (needRemoveRef) _this.$changes.root.removeRef(item["$changes"].refId);
                });
            }
            function spliceOne(arr, index) {
                // manually splice an array
                if (index === -1 || index >= arr.length) return false;
                var len = arr.length - 1;
                for(var i = index; i < len; i++)arr[i] = arr[i + 1];
                arr.length = len;
                return true;
            }
            var DEFAULT_SORT = function(a, b) {
                var A = a.toString();
                var B = b.toString();
                if (A < B) return -1;
                else if (A > B) return 1;
                else return 0;
            };
            function getArrayProxy(value) {
                value["$proxy"] = true;
                //
                // compatibility with @colyseus/schema 0.5.x
                // - allow `map["key"]`
                // - allow `map["key"] = "xxx"`
                // - allow `delete map["key"]`
                //
                value = new Proxy(value, {
                    get: function(obj, prop) {
                        if (typeof prop !== "symbol" && !isNaN(prop) // https://stackoverflow.com/a/175787/892698
                        ) return obj.at(prop);
                        else return obj[prop];
                    },
                    set: function(obj, prop, setValue) {
                        if (typeof prop !== "symbol" && !isNaN(prop)) {
                            var indexes = Array.from(obj["$items"].keys());
                            var key = parseInt(indexes[prop] || prop);
                            if (setValue === undefined || setValue === null) obj.deleteAt(key);
                            else obj.setAt(key, setValue);
                        } else obj[prop] = setValue;
                        return true;
                    },
                    deleteProperty: function(obj, prop) {
                        if (typeof prop === "number") obj.deleteAt(prop);
                        else delete obj[prop];
                        return true;
                    }
                });
                return value;
            }
            var ArraySchema = /** @class */ function() {
                function ArraySchema() {
                    var items = [];
                    for(var _i = 0; _i < arguments.length; _i++)items[_i] = arguments[_i];
                    this.$changes = new ChangeTree(this);
                    this.$items = new Map();
                    this.$indexes = new Map();
                    this.$refId = 0;
                    this.push.apply(this, items);
                }
                ArraySchema.prototype.onAdd = function(callback, triggerAll) {
                    if (triggerAll === void 0) triggerAll = true;
                    return addCallback(this.$callbacks || (this.$callbacks = []), exports1.OPERATION.ADD, callback, triggerAll ? this.$items : undefined);
                };
                ArraySchema.prototype.onRemove = function(callback) {
                    return addCallback(this.$callbacks || (this.$callbacks = []), exports1.OPERATION.DELETE, callback);
                };
                ArraySchema.prototype.onChange = function(callback) {
                    return addCallback(this.$callbacks || (this.$callbacks = []), exports1.OPERATION.REPLACE, callback);
                };
                ArraySchema.is = function(type) {
                    return(// type format: ["string"]
                    Array.isArray(type) || // type format: { array: "string" }
                    type["array"] !== undefined);
                };
                Object.defineProperty(ArraySchema.prototype, "length", {
                    get: function() {
                        return this.$items.size;
                    },
                    set: function(value) {
                        if (value === 0) this.clear();
                        else this.splice(value, this.length - value);
                    },
                    enumerable: false,
                    configurable: true
                });
                ArraySchema.prototype.push = function() {
                    var _this = this;
                    var values = [];
                    for(var _i = 0; _i < arguments.length; _i++)values[_i] = arguments[_i];
                    var lastIndex;
                    values.forEach(function(value) {
                        // set "index" for reference.
                        lastIndex = _this.$refId++;
                        _this.setAt(lastIndex, value);
                    });
                    return lastIndex;
                };
                /**
             * Removes the last element from an array and returns it.
             */ ArraySchema.prototype.pop = function() {
                    var key = Array.from(this.$indexes.values()).pop();
                    if (key === undefined) return undefined;
                    this.$changes.delete(key);
                    this.$indexes.delete(key);
                    var value = this.$items.get(key);
                    this.$items.delete(key);
                    return value;
                };
                ArraySchema.prototype.at = function(index) {
                    //
                    // FIXME: this should be O(1)
                    //
                    var key = Array.from(this.$items.keys())[index];
                    return this.$items.get(key);
                };
                ArraySchema.prototype.setAt = function(index, value) {
                    var _a, _b;
                    if (value["$changes"] !== undefined) value["$changes"].setParent(this, this.$changes.root, index);
                    var operation = (_b = (_a = this.$changes.indexes[index]) === null || _a === void 0 ? void 0 : _a.op) !== null && _b !== void 0 ? _b : exports1.OPERATION.ADD;
                    this.$changes.indexes[index] = index;
                    this.$indexes.set(index, index);
                    this.$items.set(index, value);
                    this.$changes.change(index, operation);
                };
                ArraySchema.prototype.deleteAt = function(index) {
                    var key = Array.from(this.$items.keys())[index];
                    if (key === undefined) return false;
                    return this.$deleteAt(key);
                };
                ArraySchema.prototype.$deleteAt = function(index) {
                    // delete at internal index
                    this.$changes.delete(index);
                    this.$indexes.delete(index);
                    return this.$items.delete(index);
                };
                ArraySchema.prototype.clear = function(changes) {
                    // discard previous operations.
                    this.$changes.discard(true, true);
                    this.$changes.indexes = {};
                    // clear previous indexes
                    this.$indexes.clear();
                    //
                    // When decoding:
                    // - enqueue items for DELETE callback.
                    // - flag child items for garbage collection.
                    //
                    if (changes) removeChildRefs.call(this, changes);
                    // clear items
                    this.$items.clear();
                    this.$changes.operation({
                        index: 0,
                        op: exports1.OPERATION.CLEAR
                    });
                    // touch all structures until reach root
                    this.$changes.touchParents();
                };
                /**
             * Combines two or more arrays.
             * @param items Additional items to add to the end of array1.
             */ // @ts-ignore
                ArraySchema.prototype.concat = function() {
                    var _a;
                    var items = [];
                    for(var _i = 0; _i < arguments.length; _i++)items[_i] = arguments[_i];
                    return new (ArraySchema.bind.apply(ArraySchema, __spreadArray([
                        void 0
                    ], (_a = Array.from(this.$items.values())).concat.apply(_a, items), false)))();
                };
                /**
             * Adds all the elements of an array separated by the specified separator string.
             * @param separator A string used to separate one element of an array from the next in the resulting String. If omitted, the array elements are separated with a comma.
             */ ArraySchema.prototype.join = function(separator) {
                    return Array.from(this.$items.values()).join(separator);
                };
                /**
             * Reverses the elements in an Array.
             */ // @ts-ignore
                ArraySchema.prototype.reverse = function() {
                    var _this = this;
                    var indexes = Array.from(this.$items.keys());
                    var reversedItems = Array.from(this.$items.values()).reverse();
                    reversedItems.forEach(function(item, i) {
                        _this.setAt(indexes[i], item);
                    });
                    return this;
                };
                /**
             * Removes the first element from an array and returns it.
             */ ArraySchema.prototype.shift = function() {
                    var indexes = Array.from(this.$items.keys());
                    var shiftAt = indexes.shift();
                    if (shiftAt === undefined) return undefined;
                    var value = this.$items.get(shiftAt);
                    this.$deleteAt(shiftAt);
                    return value;
                };
                /**
             * Returns a section of an array.
             * @param start The beginning of the specified portion of the array.
             * @param end The end of the specified portion of the array. This is exclusive of the element at the index 'end'.
             */ ArraySchema.prototype.slice = function(start, end) {
                    var sliced = new ArraySchema();
                    sliced.push.apply(sliced, Array.from(this.$items.values()).slice(start, end));
                    return sliced;
                };
                /**
             * Sorts an array.
             * @param compareFn Function used to determine the order of the elements. It is expected to return
             * a negative value if first argument is less than second argument, zero if they're equal and a positive
             * value otherwise. If omitted, the elements are sorted in ascending, ASCII character order.
             * ```ts
             * [11,2,22,1].sort((a, b) => a - b)
             * ```
             */ ArraySchema.prototype.sort = function(compareFn) {
                    var _this = this;
                    if (compareFn === void 0) compareFn = DEFAULT_SORT;
                    var indexes = Array.from(this.$items.keys());
                    var sortedItems = Array.from(this.$items.values()).sort(compareFn);
                    sortedItems.forEach(function(item, i) {
                        _this.setAt(indexes[i], item);
                    });
                    return this;
                };
                /**
             * Removes elements from an array and, if necessary, inserts new elements in their place, returning the deleted elements.
             * @param start The zero-based location in the array from which to start removing elements.
             * @param deleteCount The number of elements to remove.
             * @param items Elements to insert into the array in place of the deleted elements.
             */ ArraySchema.prototype.splice = function(start, deleteCount) {
                    if (deleteCount === void 0) deleteCount = this.length - start;
                    var indexes = Array.from(this.$items.keys());
                    var removedItems = [];
                    for(var i = start; i < start + deleteCount; i++){
                        removedItems.push(this.$items.get(indexes[i]));
                        this.$deleteAt(indexes[i]);
                    }
                    return removedItems;
                };
                /**
             * Inserts new elements at the start of an array.
             * @param items  Elements to insert at the start of the Array.
             */ ArraySchema.prototype.unshift = function() {
                    var _this = this;
                    var items = [];
                    for(var _i = 0; _i < arguments.length; _i++)items[_i] = arguments[_i];
                    var length = this.length;
                    var addedLength = items.length;
                    // const indexes = Array.from(this.$items.keys());
                    var previousValues = Array.from(this.$items.values());
                    items.forEach(function(item, i) {
                        _this.setAt(i, item);
                    });
                    previousValues.forEach(function(previousValue, i) {
                        _this.setAt(addedLength + i, previousValue);
                    });
                    return length + addedLength;
                };
                /**
             * Returns the index of the first occurrence of a value in an array.
             * @param searchElement The value to locate in the array.
             * @param fromIndex The array index at which to begin the search. If fromIndex is omitted, the search starts at index 0.
             */ ArraySchema.prototype.indexOf = function(searchElement, fromIndex) {
                    return Array.from(this.$items.values()).indexOf(searchElement, fromIndex);
                };
                /**
             * Returns the index of the last occurrence of a specified value in an array.
             * @param searchElement The value to locate in the array.
             * @param fromIndex The array index at which to begin the search. If fromIndex is omitted, the search starts at the last index in the array.
             */ ArraySchema.prototype.lastIndexOf = function(searchElement, fromIndex) {
                    if (fromIndex === void 0) fromIndex = this.length - 1;
                    return Array.from(this.$items.values()).lastIndexOf(searchElement, fromIndex);
                };
                /**
             * Determines whether all the members of an array satisfy the specified test.
             * @param callbackfn A function that accepts up to three arguments. The every method calls
             * the callbackfn function for each element in the array until the callbackfn returns a value
             * which is coercible to the Boolean value false, or until the end of the array.
             * @param thisArg An object to which the this keyword can refer in the callbackfn function.
             * If thisArg is omitted, undefined is used as the this value.
             */ ArraySchema.prototype.every = function(callbackfn, thisArg) {
                    return Array.from(this.$items.values()).every(callbackfn, thisArg);
                };
                /**
             * Determines whether the specified callback function returns true for any element of an array.
             * @param callbackfn A function that accepts up to three arguments. The some method calls
             * the callbackfn function for each element in the array until the callbackfn returns a value
             * which is coercible to the Boolean value true, or until the end of the array.
             * @param thisArg An object to which the this keyword can refer in the callbackfn function.
             * If thisArg is omitted, undefined is used as the this value.
             */ ArraySchema.prototype.some = function(callbackfn, thisArg) {
                    return Array.from(this.$items.values()).some(callbackfn, thisArg);
                };
                /**
             * Performs the specified action for each element in an array.
             * @param callbackfn  A function that accepts up to three arguments. forEach calls the callbackfn function one time for each element in the array.
             * @param thisArg  An object to which the this keyword can refer in the callbackfn function. If thisArg is omitted, undefined is used as the this value.
             */ ArraySchema.prototype.forEach = function(callbackfn, thisArg) {
                    Array.from(this.$items.values()).forEach(callbackfn, thisArg);
                };
                /**
             * Calls a defined callback function on each element of an array, and returns an array that contains the results.
             * @param callbackfn A function that accepts up to three arguments. The map method calls the callbackfn function one time for each element in the array.
             * @param thisArg An object to which the this keyword can refer in the callbackfn function. If thisArg is omitted, undefined is used as the this value.
             */ ArraySchema.prototype.map = function(callbackfn, thisArg) {
                    return Array.from(this.$items.values()).map(callbackfn, thisArg);
                };
                ArraySchema.prototype.filter = function(callbackfn, thisArg) {
                    return Array.from(this.$items.values()).filter(callbackfn, thisArg);
                };
                /**
             * Calls the specified callback function for all the elements in an array. The return value of the callback function is the accumulated result, and is provided as an argument in the next call to the callback function.
             * @param callbackfn A function that accepts up to four arguments. The reduce method calls the callbackfn function one time for each element in the array.
             * @param initialValue If initialValue is specified, it is used as the initial value to start the accumulation. The first call to the callbackfn function provides this value as an argument instead of an array value.
             */ ArraySchema.prototype.reduce = function(callbackfn, initialValue) {
                    return Array.prototype.reduce.apply(Array.from(this.$items.values()), arguments);
                };
                /**
             * Calls the specified callback function for all the elements in an array, in descending order. The return value of the callback function is the accumulated result, and is provided as an argument in the next call to the callback function.
             * @param callbackfn A function that accepts up to four arguments. The reduceRight method calls the callbackfn function one time for each element in the array.
             * @param initialValue If initialValue is specified, it is used as the initial value to start the accumulation. The first call to the callbackfn function provides this value as an argument instead of an array value.
             */ ArraySchema.prototype.reduceRight = function(callbackfn, initialValue) {
                    return Array.prototype.reduceRight.apply(Array.from(this.$items.values()), arguments);
                };
                /**
             * Returns the value of the first element in the array where predicate is true, and undefined
             * otherwise.
             * @param predicate find calls predicate once for each element of the array, in ascending
             * order, until it finds one where predicate returns true. If such an element is found, find
             * immediately returns that element value. Otherwise, find returns undefined.
             * @param thisArg If provided, it will be used as the this value for each invocation of
             * predicate. If it is not provided, undefined is used instead.
             */ ArraySchema.prototype.find = function(predicate, thisArg) {
                    return Array.from(this.$items.values()).find(predicate, thisArg);
                };
                /**
             * Returns the index of the first element in the array where predicate is true, and -1
             * otherwise.
             * @param predicate find calls predicate once for each element of the array, in ascending
             * order, until it finds one where predicate returns true. If such an element is found,
             * findIndex immediately returns that element index. Otherwise, findIndex returns -1.
             * @param thisArg If provided, it will be used as the this value for each invocation of
             * predicate. If it is not provided, undefined is used instead.
             */ ArraySchema.prototype.findIndex = function(predicate, thisArg) {
                    return Array.from(this.$items.values()).findIndex(predicate, thisArg);
                };
                /**
             * Returns the this object after filling the section identified by start and end with value
             * @param value value to fill array section with
             * @param start index to start filling the array at. If start is negative, it is treated as
             * length+start where length is the length of the array.
             * @param end index to stop filling the array at. If end is negative, it is treated as
             * length+end.
             */ ArraySchema.prototype.fill = function(value, start, end) {
                    //
                    // TODO
                    //
                    throw new Error("ArraySchema#fill() not implemented");
                };
                /**
             * Returns the this object after copying a section of the array identified by start and end
             * to the same array starting at position target
             * @param target If target is negative, it is treated as length+target where length is the
             * length of the array.
             * @param start If start is negative, it is treated as length+start. If end is negative, it
             * is treated as length+end.
             * @param end If not specified, length of the this object is used as its default value.
             */ ArraySchema.prototype.copyWithin = function(target, start, end) {
                    //
                    // TODO
                    //
                    throw new Error("ArraySchema#copyWithin() not implemented");
                };
                /**
             * Returns a string representation of an array.
             */ ArraySchema.prototype.toString = function() {
                    return this.$items.toString();
                };
                /**
             * Returns a string representation of an array. The elements are converted to string using their toLocalString methods.
             */ ArraySchema.prototype.toLocaleString = function() {
                    return this.$items.toLocaleString();
                };
                /** Iterator */ ArraySchema.prototype[Symbol.iterator] = function() {
                    return Array.from(this.$items.values())[Symbol.iterator]();
                };
                /**
             * Returns an iterable of key, value pairs for every entry in the array
             */ ArraySchema.prototype.entries = function() {
                    return this.$items.entries();
                };
                /**
             * Returns an iterable of keys in the array
             */ ArraySchema.prototype.keys = function() {
                    return this.$items.keys();
                };
                /**
             * Returns an iterable of values in the array
             */ ArraySchema.prototype.values = function() {
                    return this.$items.values();
                };
                /**
             * Determines whether an array includes a certain element, returning true or false as appropriate.
             * @param searchElement The element to search for.
             * @param fromIndex The position in this array at which to begin searching for searchElement.
             */ ArraySchema.prototype.includes = function(searchElement, fromIndex) {
                    return Array.from(this.$items.values()).includes(searchElement, fromIndex);
                };
                /**
             * Calls a defined callback function on each element of an array. Then, flattens the result into
             * a new array.
             * This is identical to a map followed by flat with depth 1.
             *
             * @param callback A function that accepts up to three arguments. The flatMap method calls the
             * callback function one time for each element in the array.
             * @param thisArg An object to which the this keyword can refer in the callback function. If
             * thisArg is omitted, undefined is used as the this value.
             */ // @ts-ignore
                ArraySchema.prototype.flatMap = function(callback, thisArg) {
                    // @ts-ignore
                    throw new Error("ArraySchema#flatMap() is not supported.");
                };
                /**
             * Returns a new array with all sub-array elements concatenated into it recursively up to the
             * specified depth.
             *
             * @param depth The maximum recursion depth
             */ // @ts-ignore
                ArraySchema.prototype.flat = function(depth) {
                    throw new Error("ArraySchema#flat() is not supported.");
                };
                ArraySchema.prototype.findLast = function() {
                    var arr = Array.from(this.$items.values());
                    // @ts-ignore
                    return arr.findLast.apply(arr, arguments);
                };
                ArraySchema.prototype.findLastIndex = function() {
                    var arr = Array.from(this.$items.values());
                    // @ts-ignore
                    return arr.findLastIndex.apply(arr, arguments);
                };
                // get size () {
                //     return this.$items.size;
                // }
                ArraySchema.prototype.setIndex = function(index, key) {
                    this.$indexes.set(index, key);
                };
                ArraySchema.prototype.getIndex = function(index) {
                    return this.$indexes.get(index);
                };
                ArraySchema.prototype.getByIndex = function(index) {
                    return this.$items.get(this.$indexes.get(index));
                };
                ArraySchema.prototype.deleteByIndex = function(index) {
                    var key = this.$indexes.get(index);
                    this.$items.delete(key);
                    this.$indexes.delete(index);
                };
                ArraySchema.prototype.toArray = function() {
                    return Array.from(this.$items.values());
                };
                ArraySchema.prototype.toJSON = function() {
                    return this.toArray().map(function(value) {
                        return typeof value["toJSON"] === "function" ? value["toJSON"]() : value;
                    });
                };
                //
                // Decoding utilities
                //
                ArraySchema.prototype.clone = function(isDecoding) {
                    var cloned;
                    if (isDecoding) cloned = new (ArraySchema.bind.apply(ArraySchema, __spreadArray([
                        void 0
                    ], Array.from(this.$items.values()), false)))();
                    else cloned = new (ArraySchema.bind.apply(ArraySchema, __spreadArray([
                        void 0
                    ], this.map(function(item) {
                        return item["$changes"] ? item.clone() : item;
                    }), false)))();
                    return cloned;
                };
                return ArraySchema;
            }();
            function getMapProxy(value) {
                value["$proxy"] = true;
                value = new Proxy(value, {
                    get: function(obj, prop) {
                        if (typeof prop !== "symbol" && // accessing properties
                        typeof obj[prop] === "undefined") return obj.get(prop);
                        else return obj[prop];
                    },
                    set: function(obj, prop, setValue) {
                        if (typeof prop !== "symbol" && prop.indexOf("$") === -1 && prop !== "onAdd" && prop !== "onRemove" && prop !== "onChange") obj.set(prop, setValue);
                        else obj[prop] = setValue;
                        return true;
                    },
                    deleteProperty: function(obj, prop) {
                        obj.delete(prop);
                        return true;
                    }
                });
                return value;
            }
            var MapSchema = /** @class */ function() {
                function MapSchema(initialValues) {
                    var _this = this;
                    this.$changes = new ChangeTree(this);
                    this.$items = new Map();
                    this.$indexes = new Map();
                    this.$refId = 0;
                    if (initialValues) {
                        if (initialValues instanceof Map || initialValues instanceof MapSchema) initialValues.forEach(function(v, k) {
                            return _this.set(k, v);
                        });
                        else for(var k in initialValues)this.set(k, initialValues[k]);
                    }
                }
                MapSchema.prototype.onAdd = function(callback, triggerAll) {
                    if (triggerAll === void 0) triggerAll = true;
                    return addCallback(this.$callbacks || (this.$callbacks = []), exports1.OPERATION.ADD, callback, triggerAll ? this.$items : undefined);
                };
                MapSchema.prototype.onRemove = function(callback) {
                    return addCallback(this.$callbacks || (this.$callbacks = []), exports1.OPERATION.DELETE, callback);
                };
                MapSchema.prototype.onChange = function(callback) {
                    return addCallback(this.$callbacks || (this.$callbacks = []), exports1.OPERATION.REPLACE, callback);
                };
                MapSchema.is = function(type) {
                    return type["map"] !== undefined;
                };
                /** Iterator */ MapSchema.prototype[Symbol.iterator] = function() {
                    return this.$items[Symbol.iterator]();
                };
                Object.defineProperty(MapSchema.prototype, Symbol.toStringTag, {
                    get: function() {
                        return this.$items[Symbol.toStringTag];
                    },
                    enumerable: false,
                    configurable: true
                });
                MapSchema.prototype.set = function(key, value) {
                    if (value === undefined || value === null) throw new Error("MapSchema#set('".concat(key, "', ").concat(value, "): trying to set ").concat(value, " value on '").concat(key, "'."));
                    // get "index" for this value.
                    var hasIndex = typeof this.$changes.indexes[key] !== "undefined";
                    var index = hasIndex ? this.$changes.indexes[key] : this.$refId++;
                    var operation = hasIndex ? exports1.OPERATION.REPLACE : exports1.OPERATION.ADD;
                    var isRef = value["$changes"] !== undefined;
                    if (isRef) value["$changes"].setParent(this, this.$changes.root, index);
                    //
                    // (encoding)
                    // set a unique id to relate directly with this key/value.
                    //
                    if (!hasIndex) {
                        this.$changes.indexes[key] = index;
                        this.$indexes.set(index, key);
                    } else if (isRef && // if is schema, force ADD operation if value differ from previous one.
                    this.$items.get(key) !== value) operation = exports1.OPERATION.ADD;
                    this.$items.set(key, value);
                    this.$changes.change(key, operation);
                    return this;
                };
                MapSchema.prototype.get = function(key) {
                    return this.$items.get(key);
                };
                MapSchema.prototype.delete = function(key) {
                    //
                    // TODO: add a "purge" method after .encode() runs, to cleanup removed `$indexes`
                    //
                    // We don't remove $indexes to allow setting the same key in the same patch
                    // (See "should allow to remove and set an item in the same place" test)
                    //
                    // // const index = this.$changes.indexes[key];
                    // // this.$indexes.delete(index);
                    this.$changes.delete(key);
                    return this.$items.delete(key);
                };
                MapSchema.prototype.clear = function(changes) {
                    // discard previous operations.
                    this.$changes.discard(true, true);
                    this.$changes.indexes = {};
                    // clear previous indexes
                    this.$indexes.clear();
                    //
                    // When decoding:
                    // - enqueue items for DELETE callback.
                    // - flag child items for garbage collection.
                    //
                    if (changes) removeChildRefs.call(this, changes);
                    // clear items
                    this.$items.clear();
                    this.$changes.operation({
                        index: 0,
                        op: exports1.OPERATION.CLEAR
                    });
                    // touch all structures until reach root
                    this.$changes.touchParents();
                };
                MapSchema.prototype.has = function(key) {
                    return this.$items.has(key);
                };
                MapSchema.prototype.forEach = function(callbackfn) {
                    this.$items.forEach(callbackfn);
                };
                MapSchema.prototype.entries = function() {
                    return this.$items.entries();
                };
                MapSchema.prototype.keys = function() {
                    return this.$items.keys();
                };
                MapSchema.prototype.values = function() {
                    return this.$items.values();
                };
                Object.defineProperty(MapSchema.prototype, "size", {
                    get: function() {
                        return this.$items.size;
                    },
                    enumerable: false,
                    configurable: true
                });
                MapSchema.prototype.setIndex = function(index, key) {
                    this.$indexes.set(index, key);
                };
                MapSchema.prototype.getIndex = function(index) {
                    return this.$indexes.get(index);
                };
                MapSchema.prototype.getByIndex = function(index) {
                    return this.$items.get(this.$indexes.get(index));
                };
                MapSchema.prototype.deleteByIndex = function(index) {
                    var key = this.$indexes.get(index);
                    this.$items.delete(key);
                    this.$indexes.delete(index);
                };
                MapSchema.prototype.toJSON = function() {
                    var map = {};
                    this.forEach(function(value, key) {
                        map[key] = typeof value["toJSON"] === "function" ? value["toJSON"]() : value;
                    });
                    return map;
                };
                //
                // Decoding utilities
                //
                MapSchema.prototype.clone = function(isDecoding) {
                    var cloned;
                    if (isDecoding) // client-side
                    cloned = Object.assign(new MapSchema(), this);
                    else {
                        // server-side
                        cloned = new MapSchema();
                        this.forEach(function(value, key) {
                            if (value["$changes"]) cloned.set(key, value["clone"]());
                            else cloned.set(key, value);
                        });
                    }
                    return cloned;
                };
                return MapSchema;
            }();
            var registeredTypes = {};
            function registerType(identifier, definition) {
                registeredTypes[identifier] = definition;
            }
            function getType(identifier) {
                return registeredTypes[identifier];
            }
            var SchemaDefinition = /** @class */ function() {
                function SchemaDefinition() {
                    //
                    // TODO: use a "field" structure combining all these properties per-field.
                    //
                    this.indexes = {};
                    this.fieldsByIndex = {};
                    this.deprecated = {};
                    this.descriptors = {};
                }
                SchemaDefinition.create = function(parent) {
                    var definition = new SchemaDefinition();
                    // support inheritance
                    definition.schema = Object.assign({}, parent && parent.schema || {});
                    definition.indexes = Object.assign({}, parent && parent.indexes || {});
                    definition.fieldsByIndex = Object.assign({}, parent && parent.fieldsByIndex || {});
                    definition.descriptors = Object.assign({}, parent && parent.descriptors || {});
                    definition.deprecated = Object.assign({}, parent && parent.deprecated || {});
                    return definition;
                };
                SchemaDefinition.prototype.addField = function(field, type) {
                    var index = this.getNextFieldIndex();
                    this.fieldsByIndex[index] = field;
                    this.indexes[field] = index;
                    this.schema[field] = Array.isArray(type) ? {
                        array: type[0]
                    } : type;
                };
                SchemaDefinition.prototype.hasField = function(field) {
                    return this.indexes[field] !== undefined;
                };
                SchemaDefinition.prototype.addFilter = function(field, cb) {
                    if (!this.filters) {
                        this.filters = {};
                        this.indexesWithFilters = [];
                    }
                    this.filters[this.indexes[field]] = cb;
                    this.indexesWithFilters.push(this.indexes[field]);
                    return true;
                };
                SchemaDefinition.prototype.addChildrenFilter = function(field, cb) {
                    var index = this.indexes[field];
                    var type = this.schema[field];
                    if (getType(Object.keys(type)[0])) {
                        if (!this.childFilters) this.childFilters = {};
                        this.childFilters[index] = cb;
                        return true;
                    } else console.warn("@filterChildren: field '".concat(field, "' can't have children. Ignoring filter."));
                };
                SchemaDefinition.prototype.getChildrenFilter = function(field) {
                    return this.childFilters && this.childFilters[this.indexes[field]];
                };
                SchemaDefinition.prototype.getNextFieldIndex = function() {
                    return Object.keys(this.schema || {}).length;
                };
                return SchemaDefinition;
            }();
            function hasFilter(klass) {
                return klass._context && klass._context.useFilters;
            }
            var Context = /** @class */ function() {
                function Context() {
                    this.types = {};
                    this.schemas = new Map();
                    this.useFilters = false;
                }
                Context.prototype.has = function(schema) {
                    return this.schemas.has(schema);
                };
                Context.prototype.get = function(typeid) {
                    return this.types[typeid];
                };
                Context.prototype.add = function(schema, typeid) {
                    if (typeid === void 0) typeid = this.schemas.size;
                    // FIXME: move this to somewhere else?
                    // support inheritance
                    schema._definition = SchemaDefinition.create(schema._definition);
                    schema._typeid = typeid;
                    this.types[typeid] = schema;
                    this.schemas.set(schema, typeid);
                };
                Context.create = function(options) {
                    if (options === void 0) options = {};
                    return function(definition) {
                        if (!options.context) options.context = new Context();
                        return type(definition, options);
                    };
                };
                return Context;
            }();
            var globalContext = new Context();
            /**
         * [See documentation](https://docs.colyseus.io/state/schema/)
         *
         * Annotate a Schema property to be serializeable.
         * \@type()'d fields are automatically flagged as "dirty" for the next patch.
         *
         * @example Standard usage, with automatic change tracking.
         * ```
         * \@type("string") propertyName: string;
         * ```
         *
         * @example You can provide the "manual" option if you'd like to manually control your patches via .setDirty().
         * ```
         * \@type("string", { manual: true })
         * ```
         */ function type(type, options) {
                if (options === void 0) options = {};
                return function(target, field) {
                    var context = options.context || globalContext;
                    var constructor = target.constructor;
                    constructor._context = context;
                    if (!type) throw new Error("".concat(constructor.name, ': @type() reference provided for "').concat(field, "\" is undefined. Make sure you don't have any circular dependencies."));
                    /*
                 * static schema
                 */ if (!context.has(constructor)) context.add(constructor);
                    var definition = constructor._definition;
                    definition.addField(field, type);
                    /**
                 * skip if descriptor already exists for this field (`@deprecated()`)
                 */ if (definition.descriptors[field]) {
                        if (definition.deprecated[field]) // do not create accessors for deprecated properties.
                        return;
                        else // trying to define same property multiple times across inheritance.
                        // https://github.com/colyseus/colyseus-unity3d/issues/131#issuecomment-814308572
                        try {
                            throw new Error("@colyseus/schema: Duplicate '".concat(field, "' definition on '").concat(constructor.name, "'.\nCheck @type() annotation"));
                        } catch (e) {
                            var definitionAtLine = e.stack.split("\n")[4].trim();
                            throw new Error("".concat(e.message, " ").concat(definitionAtLine));
                        }
                    }
                    var isArray = ArraySchema.is(type);
                    var isMap = !isArray && MapSchema.is(type);
                    // TODO: refactor me.
                    // Allow abstract intermediary classes with no fields to be serialized
                    // (See "should support an inheritance with a Schema type without fields" test)
                    if (typeof type !== "string" && !Schema.is(type)) {
                        var childType = Object.values(type)[0];
                        if (typeof childType !== "string" && !context.has(childType)) context.add(childType);
                    }
                    if (options.manual) {
                        // do not declare getter/setter descriptor
                        definition.descriptors[field] = {
                            enumerable: true,
                            configurable: true,
                            writable: true
                        };
                        return;
                    }
                    var fieldCached = "_".concat(field);
                    definition.descriptors[fieldCached] = {
                        enumerable: false,
                        configurable: false,
                        writable: true
                    };
                    definition.descriptors[field] = {
                        get: function() {
                            return this[fieldCached];
                        },
                        set: function(value) {
                            /**
                         * Create Proxy for array or map items
                         */ // skip if value is the same as cached.
                            if (value === this[fieldCached]) return;
                            if (value !== undefined && value !== null) {
                                // automaticallty transform Array into ArraySchema
                                if (isArray && !(value instanceof ArraySchema)) value = new (ArraySchema.bind.apply(ArraySchema, __spreadArray([
                                    void 0
                                ], value, false)))();
                                // automaticallty transform Map into MapSchema
                                if (isMap && !(value instanceof MapSchema)) value = new MapSchema(value);
                                // try to turn provided structure into a Proxy
                                if (value["$proxy"] === undefined) {
                                    if (isMap) value = getMapProxy(value);
                                    else if (isArray) value = getArrayProxy(value);
                                }
                                // flag the change for encoding.
                                this.$changes.change(field);
                                //
                                // call setParent() recursively for this and its child
                                // structures.
                                //
                                if (value["$changes"]) value["$changes"].setParent(this, this.$changes.root, this._definition.indexes[field]);
                            } else if (this[fieldCached]) //
                            // Setting a field to `null` or `undefined` will delete it.
                            //
                            this.$changes.delete(field);
                            this[fieldCached] = value;
                        },
                        enumerable: true,
                        configurable: true
                    };
                };
            }
            /**
         * `@filter()` decorator for defining data filters per client
         */ function filter(cb) {
                return function(target, field) {
                    var constructor = target.constructor;
                    var definition = constructor._definition;
                    if (definition.addFilter(field, cb)) constructor._context.useFilters = true;
                };
            }
            function filterChildren(cb) {
                return function(target, field) {
                    var constructor = target.constructor;
                    var definition = constructor._definition;
                    if (definition.addChildrenFilter(field, cb)) constructor._context.useFilters = true;
                };
            }
            /**
         * `@deprecated()` flag a field as deprecated.
         * The previous `@type()` annotation should remain along with this one.
         */ function deprecated(throws) {
                if (throws === void 0) throws = true;
                return function(target, field) {
                    var constructor = target.constructor;
                    var definition = constructor._definition;
                    definition.deprecated[field] = true;
                    if (throws) definition.descriptors[field] = {
                        get: function() {
                            throw new Error("".concat(field, " is deprecated."));
                        },
                        set: function(value) {},
                        enumerable: false,
                        configurable: true
                    };
                };
            }
            function defineTypes(target, fields, options) {
                if (options === void 0) options = {};
                if (!options.context) options.context = target._context || options.context || globalContext;
                for(var field in fields)type(fields[field], options)(target.prototype, field);
                return target;
            }
            /**
         * Copyright (c) 2018 Endel Dreyer
         * Copyright (c) 2014 Ion Drive Software Ltd.
         *
         * Permission is hereby granted, free of charge, to any person obtaining a copy
         * of this software and associated documentation files (the "Software"), to deal
         * in the Software without restriction, including without limitation the rights
         * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
         * copies of the Software, and to permit persons to whom the Software is
         * furnished to do so, subject to the following conditions:
         *
         * The above copyright notice and this permission notice shall be included in all
         * copies or substantial portions of the Software.
         *
         * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
         * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
         * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
         * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
         * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
         * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
         * SOFTWARE
         */ /**
         * msgpack implementation highly based on notepack.io
         * https://github.com/darrachequesne/notepack
         */ function utf8Length(str) {
                var c = 0, length = 0;
                for(var i = 0, l = str.length; i < l; i++){
                    c = str.charCodeAt(i);
                    if (c < 0x80) length += 1;
                    else if (c < 0x800) length += 2;
                    else if (c < 0xd800 || c >= 0xe000) length += 3;
                    else {
                        i++;
                        length += 4;
                    }
                }
                return length;
            }
            function utf8Write(view, offset, str) {
                var c = 0;
                for(var i = 0, l = str.length; i < l; i++){
                    c = str.charCodeAt(i);
                    if (c < 0x80) view[offset++] = c;
                    else if (c < 0x800) {
                        view[offset++] = 0xc0 | c >> 6;
                        view[offset++] = 0x80 | c & 0x3f;
                    } else if (c < 0xd800 || c >= 0xe000) {
                        view[offset++] = 0xe0 | c >> 12;
                        view[offset++] = 0x80 | c >> 6 & 0x3f;
                        view[offset++] = 0x80 | c & 0x3f;
                    } else {
                        i++;
                        c = 0x10000 + ((c & 0x3ff) << 10 | str.charCodeAt(i) & 0x3ff);
                        view[offset++] = 0xf0 | c >> 18;
                        view[offset++] = 0x80 | c >> 12 & 0x3f;
                        view[offset++] = 0x80 | c >> 6 & 0x3f;
                        view[offset++] = 0x80 | c & 0x3f;
                    }
                }
            }
            function int8$1(bytes, value) {
                bytes.push(value & 255);
            }
            function uint8$1(bytes, value) {
                bytes.push(value & 255);
            }
            function int16$1(bytes, value) {
                bytes.push(value & 255);
                bytes.push(value >> 8 & 255);
            }
            function uint16$1(bytes, value) {
                bytes.push(value & 255);
                bytes.push(value >> 8 & 255);
            }
            function int32$1(bytes, value) {
                bytes.push(value & 255);
                bytes.push(value >> 8 & 255);
                bytes.push(value >> 16 & 255);
                bytes.push(value >> 24 & 255);
            }
            function uint32$1(bytes, value) {
                var b4 = value >> 24;
                var b3 = value >> 16;
                var b2 = value >> 8;
                var b1 = value;
                bytes.push(b1 & 255);
                bytes.push(b2 & 255);
                bytes.push(b3 & 255);
                bytes.push(b4 & 255);
            }
            function int64$1(bytes, value) {
                var high = Math.floor(value / Math.pow(2, 32));
                var low = value >>> 0;
                uint32$1(bytes, low);
                uint32$1(bytes, high);
            }
            function uint64$1(bytes, value) {
                var high = value / Math.pow(2, 32) >> 0;
                var low = value >>> 0;
                uint32$1(bytes, low);
                uint32$1(bytes, high);
            }
            function float32$1(bytes, value) {
                writeFloat32(bytes, value);
            }
            function float64$1(bytes, value) {
                writeFloat64(bytes, value);
            }
            var _int32$1 = new Int32Array(2);
            var _float32$1 = new Float32Array(_int32$1.buffer);
            var _float64$1 = new Float64Array(_int32$1.buffer);
            function writeFloat32(bytes, value) {
                _float32$1[0] = value;
                int32$1(bytes, _int32$1[0]);
            }
            function writeFloat64(bytes, value) {
                _float64$1[0] = value;
                int32$1(bytes, _int32$1[0]);
                int32$1(bytes, _int32$1[1]);
            }
            function boolean$1(bytes, value) {
                return uint8$1(bytes, value ? 1 : 0);
            }
            function string$1(bytes, value) {
                // encode `null` strings as empty.
                if (!value) value = "";
                var length = utf8Length(value);
                var size = 0;
                // fixstr
                if (length < 0x20) {
                    bytes.push(length | 0xa0);
                    size = 1;
                } else if (length < 0x100) {
                    bytes.push(0xd9);
                    uint8$1(bytes, length);
                    size = 2;
                } else if (length < 0x10000) {
                    bytes.push(0xda);
                    uint16$1(bytes, length);
                    size = 3;
                } else if (length < 0x100000000) {
                    bytes.push(0xdb);
                    uint32$1(bytes, length);
                    size = 5;
                } else throw new Error("String too long");
                utf8Write(bytes, bytes.length, value);
                return size + length;
            }
            function number$1(bytes, value) {
                if (isNaN(value)) return number$1(bytes, 0);
                else if (!isFinite(value)) return number$1(bytes, value > 0 ? Number.MAX_SAFE_INTEGER : -Number.MAX_SAFE_INTEGER);
                else if (value !== (value | 0)) {
                    bytes.push(0xcb);
                    writeFloat64(bytes, value);
                    return 9;
                // TODO: encode float 32?
                // is it possible to differentiate between float32 / float64 here?
                // // float 32
                // bytes.push(0xca);
                // writeFloat32(bytes, value);
                // return 5;
                }
                if (value >= 0) {
                    // positive fixnum
                    if (value < 0x80) {
                        uint8$1(bytes, value);
                        return 1;
                    }
                    // uint 8
                    if (value < 0x100) {
                        bytes.push(0xcc);
                        uint8$1(bytes, value);
                        return 2;
                    }
                    // uint 16
                    if (value < 0x10000) {
                        bytes.push(0xcd);
                        uint16$1(bytes, value);
                        return 3;
                    }
                    // uint 32
                    if (value < 0x100000000) {
                        bytes.push(0xce);
                        uint32$1(bytes, value);
                        return 5;
                    }
                    // uint 64
                    bytes.push(0xcf);
                    uint64$1(bytes, value);
                    return 9;
                } else {
                    // negative fixnum
                    if (value >= -32) {
                        bytes.push(0xe0 | value + 0x20);
                        return 1;
                    }
                    // int 8
                    if (value >= -128) {
                        bytes.push(0xd0);
                        int8$1(bytes, value);
                        return 2;
                    }
                    // int 16
                    if (value >= -32768) {
                        bytes.push(0xd1);
                        int16$1(bytes, value);
                        return 3;
                    }
                    // int 32
                    if (value >= -2147483648) {
                        bytes.push(0xd2);
                        int32$1(bytes, value);
                        return 5;
                    }
                    // int 64
                    bytes.push(0xd3);
                    int64$1(bytes, value);
                    return 9;
                }
            }
            var encode = /*#__PURE__*/ Object.freeze({
                __proto__: null,
                utf8Write: utf8Write,
                int8: int8$1,
                uint8: uint8$1,
                int16: int16$1,
                uint16: uint16$1,
                int32: int32$1,
                uint32: uint32$1,
                int64: int64$1,
                uint64: uint64$1,
                float32: float32$1,
                float64: float64$1,
                writeFloat32: writeFloat32,
                writeFloat64: writeFloat64,
                boolean: boolean$1,
                string: string$1,
                number: number$1
            });
            /**
         * Copyright (c) 2018 Endel Dreyer
         * Copyright (c) 2014 Ion Drive Software Ltd.
         *
         * Permission is hereby granted, free of charge, to any person obtaining a copy
         * of this software and associated documentation files (the "Software"), to deal
         * in the Software without restriction, including without limitation the rights
         * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
         * copies of the Software, and to permit persons to whom the Software is
         * furnished to do so, subject to the following conditions:
         *
         * The above copyright notice and this permission notice shall be included in all
         * copies or substantial portions of the Software.
         *
         * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
         * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
         * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
         * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
         * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
         * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
         * SOFTWARE
         */ function utf8Read(bytes, offset, length) {
                var string = "", chr = 0;
                for(var i = offset, end = offset + length; i < end; i++){
                    var byte = bytes[i];
                    if ((byte & 0x80) === 0x00) {
                        string += String.fromCharCode(byte);
                        continue;
                    }
                    if ((byte & 0xe0) === 0xc0) {
                        string += String.fromCharCode((byte & 0x1f) << 6 | bytes[++i] & 0x3f);
                        continue;
                    }
                    if ((byte & 0xf0) === 0xe0) {
                        string += String.fromCharCode((byte & 0x0f) << 12 | (bytes[++i] & 0x3f) << 6 | (bytes[++i] & 0x3f) << 0);
                        continue;
                    }
                    if ((byte & 0xf8) === 0xf0) {
                        chr = (byte & 0x07) << 18 | (bytes[++i] & 0x3f) << 12 | (bytes[++i] & 0x3f) << 6 | (bytes[++i] & 0x3f) << 0;
                        if (chr >= 0x010000) {
                            chr -= 0x010000;
                            string += String.fromCharCode((chr >>> 10) + 0xD800, (chr & 0x3FF) + 0xDC00);
                        } else string += String.fromCharCode(chr);
                        continue;
                    }
                    console.error("Invalid byte " + byte.toString(16));
                // (do not throw error to avoid server/client from crashing due to hack attemps)
                // throw new Error('Invalid byte ' + byte.toString(16));
                }
                return string;
            }
            function int8(bytes, it) {
                return uint8(bytes, it) << 24 >> 24;
            }
            function uint8(bytes, it) {
                return bytes[it.offset++];
            }
            function int16(bytes, it) {
                return uint16(bytes, it) << 16 >> 16;
            }
            function uint16(bytes, it) {
                return bytes[it.offset++] | bytes[it.offset++] << 8;
            }
            function int32(bytes, it) {
                return bytes[it.offset++] | bytes[it.offset++] << 8 | bytes[it.offset++] << 16 | bytes[it.offset++] << 24;
            }
            function uint32(bytes, it) {
                return int32(bytes, it) >>> 0;
            }
            function float32(bytes, it) {
                return readFloat32(bytes, it);
            }
            function float64(bytes, it) {
                return readFloat64(bytes, it);
            }
            function int64(bytes, it) {
                var low = uint32(bytes, it);
                var high = int32(bytes, it) * Math.pow(2, 32);
                return high + low;
            }
            function uint64(bytes, it) {
                var low = uint32(bytes, it);
                var high = uint32(bytes, it) * Math.pow(2, 32);
                return high + low;
            }
            var _int32 = new Int32Array(2);
            var _float32 = new Float32Array(_int32.buffer);
            var _float64 = new Float64Array(_int32.buffer);
            function readFloat32(bytes, it) {
                _int32[0] = int32(bytes, it);
                return _float32[0];
            }
            function readFloat64(bytes, it) {
                _int32[0] = int32(bytes, it);
                _int32[1] = int32(bytes, it);
                return _float64[0];
            }
            function boolean(bytes, it) {
                return uint8(bytes, it) > 0;
            }
            function string(bytes, it) {
                var prefix = bytes[it.offset++];
                var length;
                if (prefix < 0xc0) // fixstr
                length = prefix & 0x1f;
                else if (prefix === 0xd9) length = uint8(bytes, it);
                else if (prefix === 0xda) length = uint16(bytes, it);
                else if (prefix === 0xdb) length = uint32(bytes, it);
                var value = utf8Read(bytes, it.offset, length);
                it.offset += length;
                return value;
            }
            function stringCheck(bytes, it) {
                var prefix = bytes[it.offset];
                return(// fixstr
                prefix < 0xc0 && prefix > 0xa0 || // str 8
                prefix === 0xd9 || // str 16
                prefix === 0xda || // str 32
                prefix === 0xdb);
            }
            function number(bytes, it) {
                var prefix = bytes[it.offset++];
                if (prefix < 0x80) // positive fixint
                return prefix;
                else if (prefix === 0xca) // float 32
                return readFloat32(bytes, it);
                else if (prefix === 0xcb) // float 64
                return readFloat64(bytes, it);
                else if (prefix === 0xcc) // uint 8
                return uint8(bytes, it);
                else if (prefix === 0xcd) // uint 16
                return uint16(bytes, it);
                else if (prefix === 0xce) // uint 32
                return uint32(bytes, it);
                else if (prefix === 0xcf) // uint 64
                return uint64(bytes, it);
                else if (prefix === 0xd0) // int 8
                return int8(bytes, it);
                else if (prefix === 0xd1) // int 16
                return int16(bytes, it);
                else if (prefix === 0xd2) // int 32
                return int32(bytes, it);
                else if (prefix === 0xd3) // int 64
                return int64(bytes, it);
                else if (prefix > 0xdf) // negative fixint
                return (0xff - prefix + 1) * -1;
            }
            function numberCheck(bytes, it) {
                var prefix = bytes[it.offset];
                // positive fixint - 0x00 - 0x7f
                // float 32        - 0xca
                // float 64        - 0xcb
                // uint 8          - 0xcc
                // uint 16         - 0xcd
                // uint 32         - 0xce
                // uint 64         - 0xcf
                // int 8           - 0xd0
                // int 16          - 0xd1
                // int 32          - 0xd2
                // int 64          - 0xd3
                return prefix < 0x80 || prefix >= 0xca && prefix <= 0xd3;
            }
            function arrayCheck(bytes, it) {
                return bytes[it.offset] < 0xa0;
            // const prefix = bytes[it.offset] ;
            // if (prefix < 0xa0) {
            //   return prefix;
            // // array
            // } else if (prefix === 0xdc) {
            //   it.offset += 2;
            // } else if (0xdd) {
            //   it.offset += 4;
            // }
            // return prefix;
            }
            function switchStructureCheck(bytes, it) {
                return(// previous byte should be `SWITCH_TO_STRUCTURE`
                bytes[it.offset - 1] === SWITCH_TO_STRUCTURE && // next byte should be a number
                (bytes[it.offset] < 0x80 || bytes[it.offset] >= 0xca && bytes[it.offset] <= 0xd3));
            }
            var decode = /*#__PURE__*/ Object.freeze({
                __proto__: null,
                int8: int8,
                uint8: uint8,
                int16: int16,
                uint16: uint16,
                int32: int32,
                uint32: uint32,
                float32: float32,
                float64: float64,
                int64: int64,
                uint64: uint64,
                readFloat32: readFloat32,
                readFloat64: readFloat64,
                boolean: boolean,
                string: string,
                stringCheck: stringCheck,
                number: number,
                numberCheck: numberCheck,
                arrayCheck: arrayCheck,
                switchStructureCheck: switchStructureCheck
            });
            var CollectionSchema = /** @class */ function() {
                function CollectionSchema(initialValues) {
                    var _this = this;
                    this.$changes = new ChangeTree(this);
                    this.$items = new Map();
                    this.$indexes = new Map();
                    this.$refId = 0;
                    if (initialValues) initialValues.forEach(function(v) {
                        return _this.add(v);
                    });
                }
                CollectionSchema.prototype.onAdd = function(callback, triggerAll) {
                    if (triggerAll === void 0) triggerAll = true;
                    return addCallback(this.$callbacks || (this.$callbacks = []), exports1.OPERATION.ADD, callback, triggerAll ? this.$items : undefined);
                };
                CollectionSchema.prototype.onRemove = function(callback) {
                    return addCallback(this.$callbacks || (this.$callbacks = []), exports1.OPERATION.DELETE, callback);
                };
                CollectionSchema.prototype.onChange = function(callback) {
                    return addCallback(this.$callbacks || (this.$callbacks = []), exports1.OPERATION.REPLACE, callback);
                };
                CollectionSchema.is = function(type) {
                    return type["collection"] !== undefined;
                };
                CollectionSchema.prototype.add = function(value) {
                    // set "index" for reference.
                    var index = this.$refId++;
                    var isRef = value["$changes"] !== undefined;
                    if (isRef) value["$changes"].setParent(this, this.$changes.root, index);
                    this.$changes.indexes[index] = index;
                    this.$indexes.set(index, index);
                    this.$items.set(index, value);
                    this.$changes.change(index);
                    return index;
                };
                CollectionSchema.prototype.at = function(index) {
                    var key = Array.from(this.$items.keys())[index];
                    return this.$items.get(key);
                };
                CollectionSchema.prototype.entries = function() {
                    return this.$items.entries();
                };
                CollectionSchema.prototype.delete = function(item) {
                    var entries = this.$items.entries();
                    var index;
                    var entry;
                    while(entry = entries.next()){
                        if (entry.done) break;
                        if (item === entry.value[1]) {
                            index = entry.value[0];
                            break;
                        }
                    }
                    if (index === undefined) return false;
                    this.$changes.delete(index);
                    this.$indexes.delete(index);
                    return this.$items.delete(index);
                };
                CollectionSchema.prototype.clear = function(changes) {
                    // discard previous operations.
                    this.$changes.discard(true, true);
                    this.$changes.indexes = {};
                    // clear previous indexes
                    this.$indexes.clear();
                    //
                    // When decoding:
                    // - enqueue items for DELETE callback.
                    // - flag child items for garbage collection.
                    //
                    if (changes) removeChildRefs.call(this, changes);
                    // clear items
                    this.$items.clear();
                    this.$changes.operation({
                        index: 0,
                        op: exports1.OPERATION.CLEAR
                    });
                    // touch all structures until reach root
                    this.$changes.touchParents();
                };
                CollectionSchema.prototype.has = function(value) {
                    return Array.from(this.$items.values()).some(function(v) {
                        return v === value;
                    });
                };
                CollectionSchema.prototype.forEach = function(callbackfn) {
                    var _this = this;
                    this.$items.forEach(function(value, key, _) {
                        return callbackfn(value, key, _this);
                    });
                };
                CollectionSchema.prototype.values = function() {
                    return this.$items.values();
                };
                Object.defineProperty(CollectionSchema.prototype, "size", {
                    get: function() {
                        return this.$items.size;
                    },
                    enumerable: false,
                    configurable: true
                });
                CollectionSchema.prototype.setIndex = function(index, key) {
                    this.$indexes.set(index, key);
                };
                CollectionSchema.prototype.getIndex = function(index) {
                    return this.$indexes.get(index);
                };
                CollectionSchema.prototype.getByIndex = function(index) {
                    return this.$items.get(this.$indexes.get(index));
                };
                CollectionSchema.prototype.deleteByIndex = function(index) {
                    var key = this.$indexes.get(index);
                    this.$items.delete(key);
                    this.$indexes.delete(index);
                };
                CollectionSchema.prototype.toArray = function() {
                    return Array.from(this.$items.values());
                };
                CollectionSchema.prototype.toJSON = function() {
                    var values = [];
                    this.forEach(function(value, key) {
                        values.push(typeof value["toJSON"] === "function" ? value["toJSON"]() : value);
                    });
                    return values;
                };
                //
                // Decoding utilities
                //
                CollectionSchema.prototype.clone = function(isDecoding) {
                    var cloned;
                    if (isDecoding) // client-side
                    cloned = Object.assign(new CollectionSchema(), this);
                    else {
                        // server-side
                        cloned = new CollectionSchema();
                        this.forEach(function(value) {
                            if (value["$changes"]) cloned.add(value["clone"]());
                            else cloned.add(value);
                        });
                    }
                    return cloned;
                };
                return CollectionSchema;
            }();
            var SetSchema = /** @class */ function() {
                function SetSchema(initialValues) {
                    var _this = this;
                    this.$changes = new ChangeTree(this);
                    this.$items = new Map();
                    this.$indexes = new Map();
                    this.$refId = 0;
                    if (initialValues) initialValues.forEach(function(v) {
                        return _this.add(v);
                    });
                }
                SetSchema.prototype.onAdd = function(callback, triggerAll) {
                    if (triggerAll === void 0) triggerAll = true;
                    return addCallback(this.$callbacks || (this.$callbacks = []), exports1.OPERATION.ADD, callback, triggerAll ? this.$items : undefined);
                };
                SetSchema.prototype.onRemove = function(callback) {
                    return addCallback(this.$callbacks || (this.$callbacks = []), exports1.OPERATION.DELETE, callback);
                };
                SetSchema.prototype.onChange = function(callback) {
                    return addCallback(this.$callbacks || (this.$callbacks = []), exports1.OPERATION.REPLACE, callback);
                };
                SetSchema.is = function(type) {
                    return type["set"] !== undefined;
                };
                SetSchema.prototype.add = function(value) {
                    var _a, _b;
                    // immediatelly return false if value already added.
                    if (this.has(value)) return false;
                    // set "index" for reference.
                    var index = this.$refId++;
                    if (value["$changes"] !== undefined) value["$changes"].setParent(this, this.$changes.root, index);
                    var operation = (_b = (_a = this.$changes.indexes[index]) === null || _a === void 0 ? void 0 : _a.op) !== null && _b !== void 0 ? _b : exports1.OPERATION.ADD;
                    this.$changes.indexes[index] = index;
                    this.$indexes.set(index, index);
                    this.$items.set(index, value);
                    this.$changes.change(index, operation);
                    return index;
                };
                SetSchema.prototype.entries = function() {
                    return this.$items.entries();
                };
                SetSchema.prototype.delete = function(item) {
                    var entries = this.$items.entries();
                    var index;
                    var entry;
                    while(entry = entries.next()){
                        if (entry.done) break;
                        if (item === entry.value[1]) {
                            index = entry.value[0];
                            break;
                        }
                    }
                    if (index === undefined) return false;
                    this.$changes.delete(index);
                    this.$indexes.delete(index);
                    return this.$items.delete(index);
                };
                SetSchema.prototype.clear = function(changes) {
                    // discard previous operations.
                    this.$changes.discard(true, true);
                    this.$changes.indexes = {};
                    // clear previous indexes
                    this.$indexes.clear();
                    //
                    // When decoding:
                    // - enqueue items for DELETE callback.
                    // - flag child items for garbage collection.
                    //
                    if (changes) removeChildRefs.call(this, changes);
                    // clear items
                    this.$items.clear();
                    this.$changes.operation({
                        index: 0,
                        op: exports1.OPERATION.CLEAR
                    });
                    // touch all structures until reach root
                    this.$changes.touchParents();
                };
                SetSchema.prototype.has = function(value) {
                    var values = this.$items.values();
                    var has = false;
                    var entry;
                    while(entry = values.next()){
                        if (entry.done) break;
                        if (value === entry.value) {
                            has = true;
                            break;
                        }
                    }
                    return has;
                };
                SetSchema.prototype.forEach = function(callbackfn) {
                    var _this = this;
                    this.$items.forEach(function(value, key, _) {
                        return callbackfn(value, key, _this);
                    });
                };
                SetSchema.prototype.values = function() {
                    return this.$items.values();
                };
                Object.defineProperty(SetSchema.prototype, "size", {
                    get: function() {
                        return this.$items.size;
                    },
                    enumerable: false,
                    configurable: true
                });
                SetSchema.prototype.setIndex = function(index, key) {
                    this.$indexes.set(index, key);
                };
                SetSchema.prototype.getIndex = function(index) {
                    return this.$indexes.get(index);
                };
                SetSchema.prototype.getByIndex = function(index) {
                    return this.$items.get(this.$indexes.get(index));
                };
                SetSchema.prototype.deleteByIndex = function(index) {
                    var key = this.$indexes.get(index);
                    this.$items.delete(key);
                    this.$indexes.delete(index);
                };
                SetSchema.prototype.toArray = function() {
                    return Array.from(this.$items.values());
                };
                SetSchema.prototype.toJSON = function() {
                    var values = [];
                    this.forEach(function(value, key) {
                        values.push(typeof value["toJSON"] === "function" ? value["toJSON"]() : value);
                    });
                    return values;
                };
                //
                // Decoding utilities
                //
                SetSchema.prototype.clone = function(isDecoding) {
                    var cloned;
                    if (isDecoding) // client-side
                    cloned = Object.assign(new SetSchema(), this);
                    else {
                        // server-side
                        cloned = new SetSchema();
                        this.forEach(function(value) {
                            if (value["$changes"]) cloned.add(value["clone"]());
                            else cloned.add(value);
                        });
                    }
                    return cloned;
                };
                return SetSchema;
            }();
            var ClientState = /** @class */ function() {
                function ClientState() {
                    this.refIds = new WeakSet();
                    this.containerIndexes = new WeakMap();
                }
                // containerIndexes = new Map<ChangeTree, Set<number>>();
                ClientState.prototype.addRefId = function(changeTree) {
                    if (!this.refIds.has(changeTree)) {
                        this.refIds.add(changeTree);
                        this.containerIndexes.set(changeTree, new Set());
                    }
                };
                ClientState.get = function(client) {
                    if (client.$filterState === undefined) client.$filterState = new ClientState();
                    return client.$filterState;
                };
                return ClientState;
            }();
            var ReferenceTracker = /** @class */ function() {
                function ReferenceTracker() {
                    //
                    // Relation of refId => Schema structure
                    // For direct access of structures during decoding time.
                    //
                    this.refs = new Map();
                    this.refCounts = {};
                    this.deletedRefs = new Set();
                    this.nextUniqueId = 0;
                }
                ReferenceTracker.prototype.getNextUniqueId = function() {
                    return this.nextUniqueId++;
                };
                // for decoding
                ReferenceTracker.prototype.addRef = function(refId, ref, incrementCount) {
                    if (incrementCount === void 0) incrementCount = true;
                    this.refs.set(refId, ref);
                    if (incrementCount) this.refCounts[refId] = (this.refCounts[refId] || 0) + 1;
                };
                // for decoding
                ReferenceTracker.prototype.removeRef = function(refId) {
                    this.refCounts[refId] = this.refCounts[refId] - 1;
                    this.deletedRefs.add(refId);
                };
                ReferenceTracker.prototype.clearRefs = function() {
                    this.refs.clear();
                    this.deletedRefs.clear();
                    this.refCounts = {};
                };
                // for decoding
                ReferenceTracker.prototype.garbageCollectDeletedRefs = function() {
                    var _this = this;
                    this.deletedRefs.forEach(function(refId) {
                        //
                        // Skip active references.
                        //
                        if (_this.refCounts[refId] > 0) return;
                        var ref = _this.refs.get(refId);
                        //
                        // Ensure child schema instances have their references removed as well.
                        //
                        if (ref instanceof Schema) {
                            for(var fieldName in ref["_definition"].schema)if (typeof ref["_definition"].schema[fieldName] !== "string" && ref[fieldName] && ref[fieldName]["$changes"]) _this.removeRef(ref[fieldName]["$changes"].refId);
                        } else {
                            var definition = ref["$changes"].parent._definition;
                            var type = definition.schema[definition.fieldsByIndex[ref["$changes"].parentIndex]];
                            if (typeof Object.values(type)[0] === "function") Array.from(ref.values()).forEach(function(child) {
                                return _this.removeRef(child["$changes"].refId);
                            });
                        }
                        _this.refs.delete(refId);
                        delete _this.refCounts[refId];
                    });
                    // clear deleted refs.
                    this.deletedRefs.clear();
                };
                return ReferenceTracker;
            }();
            var EncodeSchemaError = /** @class */ function(_super) {
                __extends(EncodeSchemaError, _super);
                function EncodeSchemaError() {
                    return _super !== null && _super.apply(this, arguments) || this;
                }
                return EncodeSchemaError;
            }(Error);
            function assertType(value, type, klass, field) {
                var typeofTarget;
                var allowNull = false;
                switch(type){
                    case "number":
                    case "int8":
                    case "uint8":
                    case "int16":
                    case "uint16":
                    case "int32":
                    case "uint32":
                    case "int64":
                    case "uint64":
                    case "float32":
                    case "float64":
                        typeofTarget = "number";
                        if (isNaN(value)) console.log('trying to encode "NaN" in '.concat(klass.constructor.name, "#").concat(field));
                        break;
                    case "string":
                        typeofTarget = "string";
                        allowNull = true;
                        break;
                    case "boolean":
                        // boolean is always encoded as true/false based on truthiness
                        return;
                }
                if (typeof value !== typeofTarget && (!allowNull || allowNull && value !== null)) {
                    var foundValue = "'".concat(JSON.stringify(value), "'").concat(value && value.constructor && " (".concat(value.constructor.name, ")") || "");
                    throw new EncodeSchemaError("a '".concat(typeofTarget, "' was expected, but ").concat(foundValue, " was provided in ").concat(klass.constructor.name, "#").concat(field));
                }
            }
            function assertInstanceType(value, type, klass, field) {
                if (!(value instanceof type)) throw new EncodeSchemaError("a '".concat(type.name, "' was expected, but '").concat(value.constructor.name, "' was provided in ").concat(klass.constructor.name, "#").concat(field));
            }
            function encodePrimitiveType(type, bytes, value, klass, field) {
                assertType(value, type, klass, field);
                var encodeFunc = encode[type];
                if (encodeFunc) encodeFunc(bytes, value);
                else throw new EncodeSchemaError("a '".concat(type, "' was expected, but ").concat(value, " was provided in ").concat(klass.constructor.name, "#").concat(field));
            }
            function decodePrimitiveType(type, bytes, it) {
                return decode[type](bytes, it);
            }
            /**
         * Schema encoder / decoder
         */ var Schema = /** @class */ function() {
                // allow inherited classes to have a constructor
                function Schema() {
                    var args = [];
                    for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
                    // fix enumerability of fields for end-user
                    Object.defineProperties(this, {
                        $changes: {
                            value: new ChangeTree(this, undefined, new ReferenceTracker()),
                            enumerable: false,
                            writable: true
                        },
                        // $listeners: {
                        //     value: undefined,
                        //     enumerable: false,
                        //     writable: true
                        // },
                        $callbacks: {
                            value: undefined,
                            enumerable: false,
                            writable: true
                        }
                    });
                    var descriptors = this._definition.descriptors;
                    if (descriptors) Object.defineProperties(this, descriptors);
                    //
                    // Assign initial values
                    //
                    if (args[0]) this.assign(args[0]);
                }
                Schema.onError = function(e) {
                    console.error(e);
                };
                Schema.is = function(type) {
                    return type["_definition"] && type["_definition"].schema !== undefined;
                };
                Schema.prototype.onChange = function(callback) {
                    return addCallback(this.$callbacks || (this.$callbacks = []), exports1.OPERATION.REPLACE, callback);
                };
                Schema.prototype.onRemove = function(callback) {
                    return addCallback(this.$callbacks || (this.$callbacks = []), exports1.OPERATION.DELETE, callback);
                };
                Schema.prototype.assign = function(props) {
                    Object.assign(this, props);
                    return this;
                };
                Object.defineProperty(Schema.prototype, "_definition", {
                    get: function() {
                        return this.constructor._definition;
                    },
                    enumerable: false,
                    configurable: true
                });
                /**
             * (Server-side): Flag a property to be encoded for the next patch.
             * @param instance Schema instance
             * @param property string representing the property name, or number representing the index of the property.
             * @param operation OPERATION to perform (detected automatically)
             */ Schema.prototype.setDirty = function(property, operation) {
                    this.$changes.change(property, operation);
                };
                /**
             * Client-side: listen for changes on property.
             * @param prop the property name
             * @param callback callback to be triggered on property change
             * @param immediate trigger immediatelly if property has been already set.
             */ Schema.prototype.listen = function(prop, callback, immediate) {
                    var _this = this;
                    if (immediate === void 0) immediate = true;
                    if (!this.$callbacks) this.$callbacks = {};
                    if (!this.$callbacks[prop]) this.$callbacks[prop] = [];
                    this.$callbacks[prop].push(callback);
                    if (immediate && this[prop] !== undefined) callback(this[prop], undefined);
                    // return un-register callback.
                    return function() {
                        return spliceOne(_this.$callbacks[prop], _this.$callbacks[prop].indexOf(callback));
                    };
                };
                Schema.prototype.decode = function(bytes, it, ref) {
                    var _a;
                    if (it === void 0) it = {
                        offset: 0
                    };
                    if (ref === void 0) ref = this;
                    var allChanges = [];
                    var $root = this.$changes.root;
                    var totalBytes = bytes.length;
                    var refId = 0;
                    $root.refs.set(refId, this);
                    while(it.offset < totalBytes){
                        var byte = bytes[it.offset++];
                        if (byte == SWITCH_TO_STRUCTURE) {
                            refId = number(bytes, it);
                            var nextRef = $root.refs.get(refId);
                            //
                            // Trying to access a reference that haven't been decoded yet.
                            //
                            if (!nextRef) throw new Error('"refId" not found: '.concat(refId));
                            ref = nextRef;
                            continue;
                        }
                        var changeTree = ref["$changes"];
                        var isSchema = ref["_definition"] !== undefined;
                        var operation = isSchema ? byte >> 6 << 6 // "compressed" index + operation
                         : byte; // "uncompressed" index + operation (array/map items)
                        if (operation === exports1.OPERATION.CLEAR) {
                            //
                            // TODO: refactor me!
                            // The `.clear()` method is calling `$root.removeRef(refId)` for
                            // each item inside this collection
                            //
                            ref.clear(allChanges);
                            continue;
                        }
                        var fieldIndex = isSchema ? byte % (operation || 255 // if "REPLACE" operation (0), use 255
                        ) : number(bytes, it);
                        var fieldName = isSchema ? ref["_definition"].fieldsByIndex[fieldIndex] : "";
                        var type = changeTree.getType(fieldIndex);
                        var value = void 0;
                        var previousValue = void 0;
                        var dynamicIndex = void 0;
                        if (!isSchema) {
                            previousValue = ref["getByIndex"](fieldIndex);
                            if ((operation & exports1.OPERATION.ADD) === exports1.OPERATION.ADD) {
                                dynamicIndex = ref instanceof MapSchema ? string(bytes, it) : fieldIndex;
                                ref["setIndex"](fieldIndex, dynamicIndex);
                            } else // here
                            dynamicIndex = ref["getIndex"](fieldIndex);
                        } else previousValue = ref["_".concat(fieldName)];
                        //
                        // Delete operations
                        //
                        if ((operation & exports1.OPERATION.DELETE) === exports1.OPERATION.DELETE) {
                            if (operation !== exports1.OPERATION.DELETE_AND_ADD) ref["deleteByIndex"](fieldIndex);
                            // Flag `refId` for garbage collection.
                            if (previousValue && previousValue["$changes"]) $root.removeRef(previousValue["$changes"].refId);
                            value = null;
                        }
                        if (fieldName === undefined) {
                            console.warn("@colyseus/schema: definition mismatch");
                            //
                            // keep skipping next bytes until reaches a known structure
                            // by local decoder.
                            //
                            var nextIterator = {
                                offset: it.offset
                            };
                            while(it.offset < totalBytes){
                                if (switchStructureCheck(bytes, it)) {
                                    nextIterator.offset = it.offset + 1;
                                    if ($root.refs.has(number(bytes, nextIterator))) break;
                                }
                                it.offset++;
                            }
                            continue;
                        } else if (operation === exports1.OPERATION.DELETE) ;
                        else if (Schema.is(type)) {
                            var refId_1 = number(bytes, it);
                            value = $root.refs.get(refId_1);
                            if (operation !== exports1.OPERATION.REPLACE) {
                                var childType = this.getSchemaType(bytes, it, type);
                                if (!value) {
                                    value = this.createTypeInstance(childType);
                                    value.$changes.refId = refId_1;
                                    if (previousValue) {
                                        value.$callbacks = previousValue.$callbacks;
                                        // value.$listeners = previousValue.$listeners;
                                        if (previousValue["$changes"].refId && refId_1 !== previousValue["$changes"].refId) $root.removeRef(previousValue["$changes"].refId);
                                    }
                                }
                                $root.addRef(refId_1, value, value !== previousValue);
                            }
                        } else if (typeof type === "string") //
                        // primitive value (number, string, boolean, etc)
                        //
                        value = decodePrimitiveType(type, bytes, it);
                        else {
                            var typeDef = getType(Object.keys(type)[0]);
                            var refId_2 = number(bytes, it);
                            var valueRef = $root.refs.has(refId_2) ? previousValue || $root.refs.get(refId_2) : new typeDef.constructor();
                            value = valueRef.clone(true);
                            value.$changes.refId = refId_2;
                            // preserve schema callbacks
                            if (previousValue) {
                                value["$callbacks"] = previousValue["$callbacks"];
                                if (previousValue["$changes"].refId && refId_2 !== previousValue["$changes"].refId) {
                                    $root.removeRef(previousValue["$changes"].refId);
                                    //
                                    // Trigger onRemove if structure has been replaced.
                                    //
                                    var entries = previousValue.entries();
                                    var iter = void 0;
                                    while((iter = entries.next()) && !iter.done){
                                        var key = (_a = iter.value, _a[0]), value_1 = _a[1];
                                        allChanges.push({
                                            refId: refId_2,
                                            op: exports1.OPERATION.DELETE,
                                            field: key,
                                            value: undefined,
                                            previousValue: value_1
                                        });
                                    }
                                }
                            }
                            $root.addRef(refId_2, value, valueRef !== previousValue);
                        }
                        if (value !== null && value !== undefined) {
                            if (value["$changes"]) value["$changes"].setParent(changeTree.ref, changeTree.root, fieldIndex);
                            if (ref instanceof Schema) ref[fieldName] = value;
                            else if (ref instanceof MapSchema) {
                                // const key = ref['$indexes'].get(field);
                                var key = dynamicIndex;
                                // ref.set(key, value);
                                ref["$items"].set(key, value);
                                ref["$changes"].allChanges.add(fieldIndex);
                            } else if (ref instanceof ArraySchema) // const key = ref['$indexes'][field];
                            // console.log("SETTING FOR ArraySchema =>", { field, key, value });
                            // ref[key] = value;
                            ref.setAt(fieldIndex, value);
                            else if (ref instanceof CollectionSchema) {
                                var index = ref.add(value);
                                ref["setIndex"](fieldIndex, index);
                            } else if (ref instanceof SetSchema) {
                                var index = ref.add(value);
                                if (index !== false) ref["setIndex"](fieldIndex, index);
                            }
                        }
                        if (previousValue !== value) allChanges.push({
                            refId: refId,
                            op: operation,
                            field: fieldName,
                            dynamicIndex: dynamicIndex,
                            value: value,
                            previousValue: previousValue
                        });
                    }
                    this._triggerChanges(allChanges);
                    // drop references of unused schemas
                    $root.garbageCollectDeletedRefs();
                    return allChanges;
                };
                Schema.prototype.encode = function(encodeAll, bytes, useFilters) {
                    if (encodeAll === void 0) encodeAll = false;
                    if (bytes === void 0) bytes = [];
                    if (useFilters === void 0) useFilters = false;
                    var rootChangeTree = this.$changes;
                    var refIdsVisited = new WeakSet();
                    var changeTrees = [
                        rootChangeTree
                    ];
                    var numChangeTrees = 1;
                    for(var i = 0; i < numChangeTrees; i++){
                        var changeTree = changeTrees[i];
                        var ref = changeTree.ref;
                        var isSchema = ref instanceof Schema;
                        // Generate unique refId for the ChangeTree.
                        changeTree.ensureRefId();
                        // mark this ChangeTree as visited.
                        refIdsVisited.add(changeTree);
                        // root `refId` is skipped.
                        if (changeTree !== rootChangeTree && (changeTree.changed || encodeAll)) {
                            uint8$1(bytes, SWITCH_TO_STRUCTURE);
                            number$1(bytes, changeTree.refId);
                        }
                        var changes = encodeAll ? Array.from(changeTree.allChanges) : Array.from(changeTree.changes.values());
                        for(var j = 0, cl = changes.length; j < cl; j++){
                            var operation = encodeAll ? {
                                op: exports1.OPERATION.ADD,
                                index: changes[j]
                            } : changes[j];
                            var fieldIndex = operation.index;
                            var field = isSchema ? ref["_definition"].fieldsByIndex && ref["_definition"].fieldsByIndex[fieldIndex] : fieldIndex;
                            // cache begin index if `useFilters`
                            var beginIndex = bytes.length;
                            // encode field index + operation
                            if (operation.op !== exports1.OPERATION.TOUCH) {
                                if (isSchema) //
                                // Compress `fieldIndex` + `operation` into a single byte.
                                // This adds a limitaion of 64 fields per Schema structure
                                //
                                uint8$1(bytes, fieldIndex | operation.op);
                                else {
                                    uint8$1(bytes, operation.op);
                                    // custom operations
                                    if (operation.op === exports1.OPERATION.CLEAR) continue;
                                    // indexed operations
                                    number$1(bytes, fieldIndex);
                                }
                            }
                            //
                            // encode "alias" for dynamic fields (maps)
                            //
                            if (!isSchema && (operation.op & exports1.OPERATION.ADD) == exports1.OPERATION.ADD // ADD or DELETE_AND_ADD
                            ) {
                                if (ref instanceof MapSchema) {
                                    //
                                    // MapSchema dynamic key
                                    //
                                    var dynamicIndex = changeTree.ref["$indexes"].get(fieldIndex);
                                    string$1(bytes, dynamicIndex);
                                }
                            }
                            if (operation.op === exports1.OPERATION.DELETE) continue;
                            // const type = changeTree.childType || ref._schema[field];
                            var type = changeTree.getType(fieldIndex);
                            // const type = changeTree.getType(fieldIndex);
                            var value = changeTree.getValue(fieldIndex);
                            // Enqueue ChangeTree to be visited
                            if (value && value["$changes"] && !refIdsVisited.has(value["$changes"])) {
                                changeTrees.push(value["$changes"]);
                                value["$changes"].ensureRefId();
                                numChangeTrees++;
                            }
                            if (operation.op === exports1.OPERATION.TOUCH) continue;
                            if (Schema.is(type)) {
                                assertInstanceType(value, type, ref, field);
                                //
                                // Encode refId for this instance.
                                // The actual instance is going to be encoded on next `changeTree` iteration.
                                //
                                number$1(bytes, value.$changes.refId);
                                // Try to encode inherited TYPE_ID if it's an ADD operation.
                                if ((operation.op & exports1.OPERATION.ADD) === exports1.OPERATION.ADD) this.tryEncodeTypeId(bytes, type, value.constructor);
                            } else if (typeof type === "string") //
                            // Primitive values
                            //
                            encodePrimitiveType(type, bytes, value, ref, field);
                            else {
                                //
                                // Custom type (MapSchema, ArraySchema, etc)
                                //
                                var definition = getType(Object.keys(type)[0]);
                                //
                                // ensure a ArraySchema has been provided
                                //
                                assertInstanceType(ref["_".concat(field)], definition.constructor, ref, field);
                                //
                                // Encode refId for this instance.
                                // The actual instance is going to be encoded on next `changeTree` iteration.
                                //
                                number$1(bytes, value.$changes.refId);
                            }
                            if (useFilters) // cache begin / end index
                            changeTree.cache(fieldIndex, bytes.slice(beginIndex));
                        }
                        if (!encodeAll && !useFilters) changeTree.discard();
                    }
                    return bytes;
                };
                Schema.prototype.encodeAll = function(useFilters) {
                    return this.encode(true, [], useFilters);
                };
                Schema.prototype.applyFilters = function(client, encodeAll) {
                    var _a, _b;
                    if (encodeAll === void 0) encodeAll = false;
                    var root = this;
                    var refIdsDissallowed = new Set();
                    var $filterState = ClientState.get(client);
                    var changeTrees = [
                        this.$changes
                    ];
                    var numChangeTrees = 1;
                    var filteredBytes = [];
                    var _loop_1 = function(i) {
                        var changeTree = changeTrees[i];
                        if (refIdsDissallowed.has(changeTree.refId)) return "continue";
                        var ref = changeTree.ref;
                        var isSchema = ref instanceof Schema;
                        uint8$1(filteredBytes, SWITCH_TO_STRUCTURE);
                        number$1(filteredBytes, changeTree.refId);
                        var clientHasRefId = $filterState.refIds.has(changeTree);
                        var isEncodeAll = encodeAll || !clientHasRefId;
                        // console.log("REF:", ref.constructor.name);
                        // console.log("Encode all?", isEncodeAll);
                        //
                        // include `changeTree` on list of known refIds by this client.
                        //
                        $filterState.addRefId(changeTree);
                        var containerIndexes = $filterState.containerIndexes.get(changeTree);
                        var changes = isEncodeAll ? Array.from(changeTree.allChanges) : Array.from(changeTree.changes.values());
                        //
                        // WORKAROUND: tries to re-evaluate previously not included @filter() attributes
                        // - see "DELETE a field of Schema" test case.
                        //
                        if (!encodeAll && isSchema && ref._definition.indexesWithFilters) {
                            var indexesWithFilters = ref._definition.indexesWithFilters;
                            indexesWithFilters.forEach(function(indexWithFilter) {
                                if (!containerIndexes.has(indexWithFilter) && changeTree.allChanges.has(indexWithFilter)) {
                                    if (isEncodeAll) changes.push(indexWithFilter);
                                    else changes.push({
                                        op: exports1.OPERATION.ADD,
                                        index: indexWithFilter
                                    });
                                }
                            });
                        }
                        for(var j = 0, cl = changes.length; j < cl; j++){
                            var change = isEncodeAll ? {
                                op: exports1.OPERATION.ADD,
                                index: changes[j]
                            } : changes[j];
                            // custom operations
                            if (change.op === exports1.OPERATION.CLEAR) {
                                uint8$1(filteredBytes, change.op);
                                continue;
                            }
                            var fieldIndex = change.index;
                            //
                            // Deleting fields: encode the operation + field index
                            //
                            if (change.op === exports1.OPERATION.DELETE) {
                                //
                                // DELETE operations also need to go through filtering.
                                //
                                // TODO: cache the previous value so we can access the value (primitive or `refId`)
                                // (check against `$filterState.refIds`)
                                //
                                if (isSchema) uint8$1(filteredBytes, change.op | fieldIndex);
                                else {
                                    uint8$1(filteredBytes, change.op);
                                    number$1(filteredBytes, fieldIndex);
                                }
                                continue;
                            }
                            // indexed operation
                            var value = changeTree.getValue(fieldIndex);
                            var type = changeTree.getType(fieldIndex);
                            if (isSchema) {
                                // Is a Schema!
                                var filter = ref._definition.filters && ref._definition.filters[fieldIndex];
                                if (filter && !filter.call(ref, client, value, root)) {
                                    if (value && value["$changes"]) refIdsDissallowed.add(value["$changes"].refId);
                                    continue;
                                }
                            } else {
                                // Is a collection! (map, array, etc.)
                                var parent = changeTree.parent;
                                var filter = changeTree.getChildrenFilter();
                                if (filter && !filter.call(parent, client, ref["$indexes"].get(fieldIndex), value, root)) {
                                    if (value && value["$changes"]) refIdsDissallowed.add(value["$changes"].refId);
                                    continue;
                                }
                            }
                            // visit child ChangeTree on further iteration.
                            if (value["$changes"]) {
                                changeTrees.push(value["$changes"]);
                                numChangeTrees++;
                            }
                            //
                            // Copy cached bytes
                            //
                            if (change.op !== exports1.OPERATION.TOUCH) {
                                //
                                // TODO: refactor me!
                                //
                                if (change.op === exports1.OPERATION.ADD || isSchema) {
                                    //
                                    // use cached bytes directly if is from Schema type.
                                    //
                                    filteredBytes.push.apply(filteredBytes, (_a = changeTree.caches[fieldIndex]) !== null && _a !== void 0 ? _a : []);
                                    containerIndexes.add(fieldIndex);
                                } else if (containerIndexes.has(fieldIndex)) //
                                // use cached bytes if already has the field
                                //
                                filteredBytes.push.apply(filteredBytes, (_b = changeTree.caches[fieldIndex]) !== null && _b !== void 0 ? _b : []);
                                else {
                                    //
                                    // force ADD operation if field is not known by this client.
                                    //
                                    containerIndexes.add(fieldIndex);
                                    uint8$1(filteredBytes, exports1.OPERATION.ADD);
                                    number$1(filteredBytes, fieldIndex);
                                    if (ref instanceof MapSchema) {
                                        //
                                        // MapSchema dynamic key
                                        //
                                        var dynamicIndex = changeTree.ref["$indexes"].get(fieldIndex);
                                        string$1(filteredBytes, dynamicIndex);
                                    }
                                    if (value["$changes"]) number$1(filteredBytes, value["$changes"].refId);
                                    else // "encodePrimitiveType" without type checking.
                                    // the type checking has been done on the first .encode() call.
                                    encode[type](filteredBytes, value);
                                }
                            } else if (value["$changes"] && !isSchema) {
                                //
                                // TODO:
                                // - track ADD/REPLACE/DELETE instances on `$filterState`
                                // - do NOT always encode dynamicIndex for MapSchema.
                                //   (If client already has that key, only the first index is necessary.)
                                //
                                uint8$1(filteredBytes, exports1.OPERATION.ADD);
                                number$1(filteredBytes, fieldIndex);
                                if (ref instanceof MapSchema) {
                                    //
                                    // MapSchema dynamic key
                                    //
                                    var dynamicIndex = changeTree.ref["$indexes"].get(fieldIndex);
                                    string$1(filteredBytes, dynamicIndex);
                                }
                                number$1(filteredBytes, value["$changes"].refId);
                            }
                        }
                    };
                    for(var i = 0; i < numChangeTrees; i++)_loop_1(i);
                    return filteredBytes;
                };
                Schema.prototype.clone = function() {
                    var _a;
                    var cloned = new this.constructor;
                    var schema = this._definition.schema;
                    for(var field in schema)if (typeof this[field] === "object" && typeof ((_a = this[field]) === null || _a === void 0 ? void 0 : _a.clone) === "function") // deep clone
                    cloned[field] = this[field].clone();
                    else // primitive values
                    cloned[field] = this[field];
                    return cloned;
                };
                Schema.prototype.toJSON = function() {
                    var schema = this._definition.schema;
                    var deprecated = this._definition.deprecated;
                    var obj = {};
                    for(var field in schema)if (!deprecated[field] && this[field] !== null && typeof this[field] !== "undefined") obj[field] = typeof this[field]["toJSON"] === "function" ? this[field]["toJSON"]() : this["_".concat(field)];
                    return obj;
                };
                Schema.prototype.discardAllChanges = function() {
                    this.$changes.discardAll();
                };
                Schema.prototype.getByIndex = function(index) {
                    return this[this._definition.fieldsByIndex[index]];
                };
                Schema.prototype.deleteByIndex = function(index) {
                    this[this._definition.fieldsByIndex[index]] = undefined;
                };
                Schema.prototype.tryEncodeTypeId = function(bytes, type, targetType) {
                    if (type._typeid !== targetType._typeid) {
                        uint8$1(bytes, TYPE_ID);
                        number$1(bytes, targetType._typeid);
                    }
                };
                Schema.prototype.getSchemaType = function(bytes, it, defaultType) {
                    var type;
                    if (bytes[it.offset] === TYPE_ID) {
                        it.offset++;
                        type = this.constructor._context.get(number(bytes, it));
                    }
                    return type || defaultType;
                };
                Schema.prototype.createTypeInstance = function(type) {
                    var instance = new type();
                    // assign root on $changes
                    instance.$changes.root = this.$changes.root;
                    return instance;
                };
                Schema.prototype._triggerChanges = function(changes) {
                    var _a, _b, _c, _d, _e, _f, _g, _h, _j;
                    var uniqueRefIds = new Set();
                    var $refs = this.$changes.root.refs;
                    var _loop_2 = function(i) {
                        var change = changes[i];
                        var refId = change.refId;
                        var ref = $refs.get(refId);
                        var $callbacks = ref["$callbacks"];
                        //
                        // trigger onRemove on child structure.
                        //
                        if ((change.op & exports1.OPERATION.DELETE) === exports1.OPERATION.DELETE && change.previousValue instanceof Schema) (_b = (_a = change.previousValue["$callbacks"]) === null || _a === void 0 ? void 0 : _a[exports1.OPERATION.DELETE]) === null || _b === void 0 || _b.forEach(function(callback) {
                            return callback();
                        });
                        // no callbacks defined, skip this structure!
                        if (!$callbacks) return "continue";
                        if (ref instanceof Schema) {
                            if (!uniqueRefIds.has(refId)) try {
                                // trigger onChange
                                (_c = $callbacks === null || $callbacks === void 0 ? void 0 : $callbacks[exports1.OPERATION.REPLACE]) === null || _c === void 0 || _c.forEach(function(callback) {
                                    return callback(changes);
                                });
                            } catch (e) {
                                Schema.onError(e);
                            }
                            try {
                                if ($callbacks.hasOwnProperty(change.field)) (_d = $callbacks[change.field]) === null || _d === void 0 || _d.forEach(function(callback) {
                                    return callback(change.value, change.previousValue);
                                });
                            } catch (e) {
                                Schema.onError(e);
                            }
                        } else {
                            // is a collection of items
                            if (change.op === exports1.OPERATION.ADD && change.previousValue === undefined) // triger onAdd
                            (_e = $callbacks[exports1.OPERATION.ADD]) === null || _e === void 0 || _e.forEach(function(callback) {
                                var _a;
                                return callback(change.value, (_a = change.dynamicIndex) !== null && _a !== void 0 ? _a : change.field);
                            });
                            else if (change.op === exports1.OPERATION.DELETE) //
                            // FIXME: `previousValue` should always be available.
                            // ADD + DELETE operations are still encoding DELETE operation.
                            //
                            {
                                if (change.previousValue !== undefined) // triger onRemove
                                (_f = $callbacks[exports1.OPERATION.DELETE]) === null || _f === void 0 || _f.forEach(function(callback) {
                                    var _a;
                                    return callback(change.previousValue, (_a = change.dynamicIndex) !== null && _a !== void 0 ? _a : change.field);
                                });
                            } else if (change.op === exports1.OPERATION.DELETE_AND_ADD) {
                                // triger onRemove
                                if (change.previousValue !== undefined) (_g = $callbacks[exports1.OPERATION.DELETE]) === null || _g === void 0 || _g.forEach(function(callback) {
                                    var _a;
                                    return callback(change.previousValue, (_a = change.dynamicIndex) !== null && _a !== void 0 ? _a : change.field);
                                });
                                // triger onAdd
                                (_h = $callbacks[exports1.OPERATION.ADD]) === null || _h === void 0 || _h.forEach(function(callback) {
                                    var _a;
                                    return callback(change.value, (_a = change.dynamicIndex) !== null && _a !== void 0 ? _a : change.field);
                                });
                            }
                            // trigger onChange
                            if (change.value !== change.previousValue) (_j = $callbacks[exports1.OPERATION.REPLACE]) === null || _j === void 0 || _j.forEach(function(callback) {
                                var _a;
                                return callback(change.value, (_a = change.dynamicIndex) !== null && _a !== void 0 ? _a : change.field);
                            });
                        }
                        uniqueRefIds.add(refId);
                    };
                    for(var i = 0; i < changes.length; i++)_loop_2(i);
                };
                Schema._definition = SchemaDefinition.create();
                return Schema;
            }();
            function dumpChanges(schema) {
                var changeTrees = [
                    schema["$changes"]
                ];
                var numChangeTrees = 1;
                var dump = {};
                var currentStructure = dump;
                var _loop_1 = function(i) {
                    var changeTree = changeTrees[i];
                    changeTree.changes.forEach(function(change) {
                        var ref = changeTree.ref;
                        var fieldIndex = change.index;
                        var field = ref["_definition"] ? ref["_definition"].fieldsByIndex[fieldIndex] : ref["$indexes"].get(fieldIndex);
                        currentStructure[field] = changeTree.getValue(fieldIndex);
                    });
                };
                for(var i = 0; i < numChangeTrees; i++)_loop_1(i);
                return dump;
            }
            var reflectionContext = {
                context: new Context()
            };
            /**
         * Reflection
         */ var ReflectionField = /** @class */ function(_super) {
                __extends(ReflectionField, _super);
                function ReflectionField() {
                    return _super !== null && _super.apply(this, arguments) || this;
                }
                __decorate([
                    type("string", reflectionContext)
                ], ReflectionField.prototype, "name", void 0);
                __decorate([
                    type("string", reflectionContext)
                ], ReflectionField.prototype, "type", void 0);
                __decorate([
                    type("number", reflectionContext)
                ], ReflectionField.prototype, "referencedType", void 0);
                return ReflectionField;
            }(Schema);
            var ReflectionType = /** @class */ function(_super) {
                __extends(ReflectionType, _super);
                function ReflectionType() {
                    var _this = _super !== null && _super.apply(this, arguments) || this;
                    _this.fields = new ArraySchema();
                    return _this;
                }
                __decorate([
                    type("number", reflectionContext)
                ], ReflectionType.prototype, "id", void 0);
                __decorate([
                    type([
                        ReflectionField
                    ], reflectionContext)
                ], ReflectionType.prototype, "fields", void 0);
                return ReflectionType;
            }(Schema);
            var Reflection = /** @class */ function(_super) {
                __extends(Reflection, _super);
                function Reflection() {
                    var _this = _super !== null && _super.apply(this, arguments) || this;
                    _this.types = new ArraySchema();
                    return _this;
                }
                Reflection.encode = function(instance) {
                    var rootSchemaType = instance.constructor;
                    var reflection = new Reflection();
                    reflection.rootType = rootSchemaType._typeid;
                    var buildType = function(currentType, schema) {
                        for(var fieldName in schema){
                            var field = new ReflectionField();
                            field.name = fieldName;
                            var fieldType = void 0;
                            if (typeof schema[fieldName] === "string") fieldType = schema[fieldName];
                            else {
                                var type_1 = schema[fieldName];
                                var childTypeSchema = void 0;
                                //
                                // TODO: refactor below.
                                //
                                if (Schema.is(type_1)) {
                                    fieldType = "ref";
                                    childTypeSchema = schema[fieldName];
                                } else {
                                    fieldType = Object.keys(type_1)[0];
                                    if (typeof type_1[fieldType] === "string") fieldType += ":" + type_1[fieldType]; // array:string
                                    else childTypeSchema = type_1[fieldType];
                                }
                                field.referencedType = childTypeSchema ? childTypeSchema._typeid : -1;
                            }
                            field.type = fieldType;
                            currentType.fields.push(field);
                        }
                        reflection.types.push(currentType);
                    };
                    var types = rootSchemaType._context.types;
                    for(var typeid in types){
                        var type_2 = new ReflectionType();
                        type_2.id = Number(typeid);
                        buildType(type_2, types[typeid]._definition.schema);
                    }
                    return reflection.encodeAll();
                };
                Reflection.decode = function(bytes, it) {
                    var context = new Context();
                    var reflection = new Reflection();
                    reflection.decode(bytes, it);
                    var schemaTypes = reflection.types.reduce(function(types, reflectionType) {
                        var schema = /** @class */ function(_super) {
                            __extends(_, _super);
                            function _() {
                                return _super !== null && _super.apply(this, arguments) || this;
                            }
                            return _;
                        }(Schema);
                        var typeid = reflectionType.id;
                        types[typeid] = schema;
                        context.add(schema, typeid);
                        return types;
                    }, {});
                    reflection.types.forEach(function(reflectionType) {
                        var schemaType = schemaTypes[reflectionType.id];
                        reflectionType.fields.forEach(function(field) {
                            var _a;
                            if (field.referencedType !== undefined) {
                                var fieldType = field.type;
                                var refType = schemaTypes[field.referencedType];
                                // map or array of primitive type (-1)
                                if (!refType) {
                                    var typeInfo = field.type.split(":");
                                    fieldType = typeInfo[0];
                                    refType = typeInfo[1];
                                }
                                if (fieldType === "ref") type(refType, {
                                    context: context
                                })(schemaType.prototype, field.name);
                                else type((_a = {}, _a[fieldType] = refType, _a), {
                                    context: context
                                })(schemaType.prototype, field.name);
                            } else type(field.type, {
                                context: context
                            })(schemaType.prototype, field.name);
                        });
                    });
                    var rootType = schemaTypes[reflection.rootType];
                    var rootInstance = new rootType();
                    /**
                 * auto-initialize referenced types on root type
                 * to allow registering listeners immediatelly on client-side
                 */ for(var fieldName in rootType._definition.schema){
                        var fieldType = rootType._definition.schema[fieldName];
                        if (typeof fieldType !== "string") rootInstance[fieldName] = typeof fieldType === "function" ? new fieldType() // is a schema reference
                         : new (getType(Object.keys(fieldType)[0])).constructor(); // is a "collection"
                    }
                    return rootInstance;
                };
                __decorate([
                    type([
                        ReflectionType
                    ], reflectionContext)
                ], Reflection.prototype, "types", void 0);
                __decorate([
                    type("number", reflectionContext)
                ], Reflection.prototype, "rootType", void 0);
                return Reflection;
            }(Schema);
            registerType("map", {
                constructor: MapSchema
            });
            registerType("array", {
                constructor: ArraySchema
            });
            registerType("set", {
                constructor: SetSchema
            });
            registerType("collection", {
                constructor: CollectionSchema
            });
            exports1.ArraySchema = ArraySchema;
            exports1.CollectionSchema = CollectionSchema;
            exports1.Context = Context;
            exports1.MapSchema = MapSchema;
            exports1.Reflection = Reflection;
            exports1.ReflectionField = ReflectionField;
            exports1.ReflectionType = ReflectionType;
            exports1.Schema = Schema;
            exports1.SchemaDefinition = SchemaDefinition;
            exports1.SetSchema = SetSchema;
            exports1.decode = decode;
            exports1.defineTypes = defineTypes;
            exports1.deprecated = deprecated;
            exports1.dumpChanges = dumpChanges;
            exports1.encode = encode;
            exports1.filter = filter;
            exports1.filterChildren = filterChildren;
            exports1.hasFilter = hasFilter;
            exports1.registerType = registerType;
            exports1.type = type;
            Object.defineProperty(exports1, "__esModule", {
                value: true
            });
        });
    });
    var Room = /** @class */ function() {
        function Room(name, rootSchema) {
            var _this = this;
            // Public signals
            this.onStateChange = createSignal();
            this.onError = createSignal();
            this.onLeave = createSignal();
            this.onJoin = createSignal();
            this.hasJoined = false;
            this.onMessageHandlers = createNanoEvents();
            this.roomId = null;
            this.name = name;
            if (rootSchema) {
                this.serializer = new (getSerializer("schema"));
                this.rootSchema = rootSchema;
                this.serializer.state = new rootSchema();
            }
            this.onError(function(code, message) {
                var _a;
                return (_a = console.warn) === null || _a === void 0 ? void 0 : _a.call(console, "colyseus.js - onError => (".concat(code, ") ").concat(message));
            });
            this.onLeave(function() {
                return _this.removeAllListeners();
            });
        }
        Object.defineProperty(Room.prototype, "id", {
            // TODO: deprecate me on version 1.0
            get: function() {
                return this.roomId;
            },
            enumerable: false,
            configurable: true
        });
        Room.prototype.connect = function(endpoint, devModeCloseCallback, room // when reconnecting on devMode, re-use previous room intance for handling events.
        ) {
            if (room === void 0) room = this;
            var connection = new Connection();
            room.connection = connection;
            connection.events.onmessage = Room.prototype.onMessageCallback.bind(room);
            connection.events.onclose = function(e) {
                var _a;
                if (!room.hasJoined) {
                    (_a = console.warn) === null || _a === void 0 || _a.call(console, "Room connection was closed unexpectedly (".concat(e.code, "): ").concat(e.reason));
                    room.onError.invoke(e.code, e.reason);
                    return;
                }
                if (e.code === CloseCode.DEVMODE_RESTART && devModeCloseCallback) devModeCloseCallback();
                else {
                    room.onLeave.invoke(e.code);
                    room.destroy();
                }
            };
            connection.events.onerror = function(e) {
                var _a;
                (_a = console.warn) === null || _a === void 0 || _a.call(console, "Room, onError (".concat(e.code, "): ").concat(e.reason));
                room.onError.invoke(e.code, e.reason);
            };
            connection.connect(endpoint);
        };
        Room.prototype.leave = function(consented) {
            var _this = this;
            if (consented === void 0) consented = true;
            return new Promise(function(resolve) {
                _this.onLeave(function(code) {
                    return resolve(code);
                });
                if (_this.connection) {
                    if (consented) _this.connection.send([
                        exports1.Protocol.LEAVE_ROOM
                    ]);
                    else _this.connection.close();
                } else _this.onLeave.invoke(CloseCode.CONSENTED);
            });
        };
        Room.prototype.onMessage = function(type, callback) {
            return this.onMessageHandlers.on(this.getMessageHandlerKey(type), callback);
        };
        Room.prototype.send = function(type, message) {
            var initialBytes = [
                exports1.Protocol.ROOM_DATA
            ];
            if (typeof type === "string") umd.encode.string(initialBytes, type);
            else umd.encode.number(initialBytes, type);
            var arr;
            if (message !== undefined) {
                var encoded = encode(message);
                arr = new Uint8Array(initialBytes.length + encoded.byteLength);
                arr.set(new Uint8Array(initialBytes), 0);
                arr.set(new Uint8Array(encoded), initialBytes.length);
            } else arr = new Uint8Array(initialBytes);
            this.connection.send(arr.buffer);
        };
        Room.prototype.sendBytes = function(type, bytes) {
            var initialBytes = [
                exports1.Protocol.ROOM_DATA_BYTES
            ];
            if (typeof type === "string") umd.encode.string(initialBytes, type);
            else umd.encode.number(initialBytes, type);
            var arr;
            arr = new Uint8Array(initialBytes.length + (bytes.byteLength || bytes.length));
            arr.set(new Uint8Array(initialBytes), 0);
            arr.set(new Uint8Array(bytes), initialBytes.length);
            this.connection.send(arr.buffer);
        };
        Object.defineProperty(Room.prototype, "state", {
            get: function() {
                return this.serializer.getState();
            },
            enumerable: false,
            configurable: true
        });
        Room.prototype.removeAllListeners = function() {
            this.onJoin.clear();
            this.onStateChange.clear();
            this.onError.clear();
            this.onLeave.clear();
            this.onMessageHandlers.events = {};
        };
        Room.prototype.onMessageCallback = function(event) {
            var bytes = Array.from(new Uint8Array(event.data));
            var code = bytes[0];
            if (code === exports1.Protocol.JOIN_ROOM) {
                var offset = 1;
                var reconnectionToken = utf8Read(bytes, offset);
                offset += utf8Length(reconnectionToken);
                this.serializerId = utf8Read(bytes, offset);
                offset += utf8Length(this.serializerId);
                // Instantiate serializer if not locally available.
                if (!this.serializer) {
                    var serializer = getSerializer(this.serializerId);
                    this.serializer = new serializer();
                }
                if (bytes.length > offset && this.serializer.handshake) this.serializer.handshake(bytes, {
                    offset: offset
                });
                this.reconnectionToken = "".concat(this.roomId, ":").concat(reconnectionToken);
                this.hasJoined = true;
                this.onJoin.invoke();
                // acknowledge successfull JOIN_ROOM
                this.connection.send([
                    exports1.Protocol.JOIN_ROOM
                ]);
            } else if (code === exports1.Protocol.ERROR) {
                var it_1 = {
                    offset: 1
                };
                var code_1 = umd.decode.number(bytes, it_1);
                var message = umd.decode.string(bytes, it_1);
                this.onError.invoke(code_1, message);
            } else if (code === exports1.Protocol.LEAVE_ROOM) this.leave();
            else if (code === exports1.Protocol.ROOM_DATA_SCHEMA) {
                var it_2 = {
                    offset: 1
                };
                var context_1 = this.serializer.getState().constructor._context;
                var type = context_1.get(umd.decode.number(bytes, it_2));
                var message = new type();
                message.decode(bytes, it_2);
                this.dispatchMessage(type, message);
            } else if (code === exports1.Protocol.ROOM_STATE) {
                bytes.shift(); // drop `code` byte
                this.setState(bytes);
            } else if (code === exports1.Protocol.ROOM_STATE_PATCH) {
                bytes.shift(); // drop `code` byte
                this.patch(bytes);
            } else if (code === exports1.Protocol.ROOM_DATA) {
                var it_3 = {
                    offset: 1
                };
                var type = umd.decode.stringCheck(bytes, it_3) ? umd.decode.string(bytes, it_3) : umd.decode.number(bytes, it_3);
                var message = bytes.length > it_3.offset ? decode(event.data, it_3.offset) : undefined;
                this.dispatchMessage(type, message);
            } else if (code === exports1.Protocol.ROOM_DATA_BYTES) {
                var it_4 = {
                    offset: 1
                };
                var type = umd.decode.stringCheck(bytes, it_4) ? umd.decode.string(bytes, it_4) : umd.decode.number(bytes, it_4);
                this.dispatchMessage(type, new Uint8Array(bytes.slice(it_4.offset)));
            }
        };
        Room.prototype.setState = function(encodedState) {
            this.serializer.setState(encodedState);
            this.onStateChange.invoke(this.serializer.getState());
        };
        Room.prototype.patch = function(binaryPatch) {
            this.serializer.patch(binaryPatch);
            this.onStateChange.invoke(this.serializer.getState());
        };
        Room.prototype.dispatchMessage = function(type, message) {
            var _a;
            var messageType = this.getMessageHandlerKey(type);
            if (this.onMessageHandlers.events[messageType]) this.onMessageHandlers.emit(messageType, message);
            else if (this.onMessageHandlers.events["*"]) this.onMessageHandlers.emit("*", type, message);
            else (_a = console.warn) === null || _a === void 0 || _a.call(console, "colyseus.js: onMessage() not registered for type '".concat(type, "'."));
        };
        Room.prototype.destroy = function() {
            if (this.serializer) this.serializer.teardown();
        };
        Room.prototype.getMessageHandlerKey = function(type) {
            switch(typeof type){
                // typeof Schema
                case "function":
                    return "$".concat(type._typeid);
                // string
                case "string":
                    return type;
                // number
                case "number":
                    return "i".concat(type);
                default:
                    throw new Error("invalid message type.");
            }
        };
        return Room;
    }();
    var _a;
    var MatchMakeError = /** @class */ function(_super) {
        __extends(MatchMakeError, _super);
        function MatchMakeError(message, code) {
            var _this = _super.call(this, message) || this;
            _this.code = code;
            Object.setPrototypeOf(_this, MatchMakeError.prototype);
            return _this;
        }
        return MatchMakeError;
    }(Error);
    // - React Native does not provide `window.location`
    // - Cocos Creator (Native) does not provide `window.location.hostname`
    var DEFAULT_ENDPOINT = typeof window !== "undefined" && typeof ((_a = window === null || window === void 0 ? void 0 : window.location) === null || _a === void 0 ? void 0 : _a.hostname) !== "undefined" ? "".concat(window.location.protocol.replace("http", "ws"), "//").concat(window.location.hostname).concat(window.location.port && ":".concat(window.location.port)) : "ws://127.0.0.1:2567";
    var Client = /** @class */ function() {
        function Client(settings) {
            if (settings === void 0) settings = DEFAULT_ENDPOINT;
            if (typeof settings === "string") {
                //
                // endpoint by url
                //
                var url = new URL(settings);
                var secure = url.protocol === "https:" || url.protocol === "wss:";
                var port = Number(url.port || (secure ? 443 : 80));
                this.settings = {
                    hostname: url.hostname,
                    pathname: url.pathname !== "/" ? url.pathname : "",
                    port: port,
                    secure: secure
                };
            } else {
                //
                // endpoint by settings
                //
                if (settings.port === undefined) settings.port = settings.secure ? 443 : 80;
                if (settings.pathname === undefined) settings.pathname = "";
                this.settings = settings;
            }
        }
        Client.prototype.joinOrCreate = function(roomName, options, rootSchema) {
            if (options === void 0) options = {};
            return __awaiter(this, void 0, void 0, function() {
                return __generator(this, function(_a) {
                    switch(_a.label){
                        case 0:
                            return [
                                4 /*yield*/ ,
                                this.createMatchMakeRequest("joinOrCreate", roomName, options, rootSchema)
                            ];
                        case 1:
                            return [
                                2 /*return*/ ,
                                _a.sent()
                            ];
                    }
                });
            });
        };
        Client.prototype.create = function(roomName, options, rootSchema) {
            if (options === void 0) options = {};
            return __awaiter(this, void 0, void 0, function() {
                return __generator(this, function(_a) {
                    switch(_a.label){
                        case 0:
                            return [
                                4 /*yield*/ ,
                                this.createMatchMakeRequest("create", roomName, options, rootSchema)
                            ];
                        case 1:
                            return [
                                2 /*return*/ ,
                                _a.sent()
                            ];
                    }
                });
            });
        };
        Client.prototype.join = function(roomName, options, rootSchema) {
            if (options === void 0) options = {};
            return __awaiter(this, void 0, void 0, function() {
                return __generator(this, function(_a) {
                    switch(_a.label){
                        case 0:
                            return [
                                4 /*yield*/ ,
                                this.createMatchMakeRequest("join", roomName, options, rootSchema)
                            ];
                        case 1:
                            return [
                                2 /*return*/ ,
                                _a.sent()
                            ];
                    }
                });
            });
        };
        Client.prototype.joinById = function(roomId, options, rootSchema) {
            if (options === void 0) options = {};
            return __awaiter(this, void 0, void 0, function() {
                return __generator(this, function(_a) {
                    switch(_a.label){
                        case 0:
                            return [
                                4 /*yield*/ ,
                                this.createMatchMakeRequest("joinById", roomId, options, rootSchema)
                            ];
                        case 1:
                            return [
                                2 /*return*/ ,
                                _a.sent()
                            ];
                    }
                });
            });
        };
        /**
         * Re-establish connection with a room this client was previously connected to.
         *
         * @param reconnectionToken The `room.reconnectionToken` from previously connected room.
         * @param rootSchema (optional) Concrete root schema definition
         * @returns Promise<Room>
         */ Client.prototype.reconnect = function(reconnectionToken, rootSchema) {
            return __awaiter(this, void 0, void 0, function() {
                var _a, roomId, token;
                return __generator(this, function(_b) {
                    switch(_b.label){
                        case 0:
                            if (typeof reconnectionToken === "string" && typeof rootSchema === "string") throw new Error("DEPRECATED: .reconnect() now only accepts 'reconnectionToken' as argument.\nYou can get this token from previously connected `room.reconnectionToken`");
                            _a = reconnectionToken.split(":"), roomId = _a[0], token = _a[1];
                            return [
                                4 /*yield*/ ,
                                this.createMatchMakeRequest("reconnect", roomId, {
                                    reconnectionToken: token
                                }, rootSchema)
                            ];
                        case 1:
                            return [
                                2 /*return*/ ,
                                _b.sent()
                            ];
                    }
                });
            });
        };
        Client.prototype.getAvailableRooms = function(roomName) {
            if (roomName === void 0) roomName = "";
            return __awaiter(this, void 0, void 0, function() {
                return __generator(this, function(_a) {
                    switch(_a.label){
                        case 0:
                            return [
                                4 /*yield*/ ,
                                get_1(this.getHttpEndpoint("".concat(roomName)), {
                                    headers: {
                                        "Accept": "application/json"
                                    }
                                })
                            ];
                        case 1:
                            return [
                                2 /*return*/ ,
                                _a.sent().data
                            ];
                    }
                });
            });
        };
        Client.prototype.consumeSeatReservation = function(response, rootSchema, reuseRoomInstance // used in devMode
        ) {
            return __awaiter(this, void 0, void 0, function() {
                var room, options, targetRoom;
                var _this = this;
                return __generator(this, function(_a) {
                    room = this.createRoom(response.room.name, rootSchema);
                    room.roomId = response.room.roomId;
                    room.sessionId = response.sessionId;
                    options = {
                        sessionId: room.sessionId
                    };
                    // forward "reconnection token" in case of reconnection.
                    if (response.reconnectionToken) options.reconnectionToken = response.reconnectionToken;
                    targetRoom = reuseRoomInstance || room;
                    room.connect(this.buildEndpoint(response.room, options), response.devMode && function() {
                        return __awaiter(_this, void 0, void 0, function() {
                            var retryCount, retryMaxRetries, retryReconnection;
                            var _this = this;
                            return __generator(this, function(_a) {
                                console.info("[Colyseus devMode]: ".concat(String.fromCodePoint(0x1F504), " Re-establishing connection with room id '").concat(room.roomId, "'...")); // 🔄
                                retryCount = 0;
                                retryMaxRetries = 8;
                                retryReconnection = function() {
                                    return __awaiter(_this, void 0, void 0, function() {
                                        return __generator(this, function(_a) {
                                            switch(_a.label){
                                                case 0:
                                                    retryCount++;
                                                    _a.label = 1;
                                                case 1:
                                                    _a.trys.push([
                                                        1,
                                                        3,
                                                        ,
                                                        4
                                                    ]);
                                                    return [
                                                        4 /*yield*/ ,
                                                        this.consumeSeatReservation(response, rootSchema, targetRoom)
                                                    ];
                                                case 2:
                                                    _a.sent();
                                                    console.info("[Colyseus devMode]: ".concat(String.fromCodePoint(0x2705), " Successfully re-established connection with room '").concat(room.roomId, "'")); // ✅
                                                    return [
                                                        3 /*break*/ ,
                                                        4
                                                    ];
                                                case 3:
                                                    _a.sent();
                                                    if (retryCount < retryMaxRetries) {
                                                        console.info("[Colyseus devMode]: ".concat(String.fromCodePoint(0x1F504), " retrying... (").concat(retryCount, " out of ").concat(retryMaxRetries, ")")); // 🔄
                                                        setTimeout(retryReconnection, 2000);
                                                    } else console.info("[Colyseus devMode]: ".concat(String.fromCodePoint(0x274C), " Failed to reconnect. Is your server running? Please check server logs.")); // ❌
                                                    return [
                                                        3 /*break*/ ,
                                                        4
                                                    ];
                                                case 4:
                                                    return [
                                                        2 /*return*/ 
                                                    ];
                                            }
                                        });
                                    });
                                };
                                setTimeout(retryReconnection, 2000);
                                return [
                                    2 /*return*/ 
                                ];
                            });
                        });
                    }, targetRoom);
                    return [
                        2 /*return*/ ,
                        new Promise(function(resolve, reject) {
                            var onError = function(code, message) {
                                return reject(new ServerError(code, message));
                            };
                            targetRoom.onError.once(onError);
                            targetRoom["onJoin"].once(function() {
                                targetRoom.onError.remove(onError);
                                resolve(targetRoom);
                            });
                        })
                    ];
                });
            });
        };
        Client.prototype.createMatchMakeRequest = function(method, roomName, options, rootSchema, reuseRoomInstance) {
            if (options === void 0) options = {};
            return __awaiter(this, void 0, void 0, function() {
                var response;
                return __generator(this, function(_a) {
                    switch(_a.label){
                        case 0:
                            return [
                                4 /*yield*/ ,
                                post_1(this.getHttpEndpoint("".concat(method, "/").concat(roomName)), {
                                    headers: {
                                        "Accept": "application/json",
                                        "Content-Type": "application/json"
                                    },
                                    body: JSON.stringify(options)
                                })
                            ];
                        case 1:
                            response = _a.sent().data;
                            if (response.error) throw new MatchMakeError(response.error, response.code);
                            // forward reconnection token during "reconnect" methods.
                            if (method === "reconnect") response.reconnectionToken = options.reconnectionToken;
                            return [
                                4 /*yield*/ ,
                                this.consumeSeatReservation(response, rootSchema, reuseRoomInstance)
                            ];
                        case 2:
                            return [
                                2 /*return*/ ,
                                _a.sent()
                            ];
                    }
                });
            });
        };
        Client.prototype.createRoom = function(roomName, rootSchema) {
            return new Room(roomName, rootSchema);
        };
        Client.prototype.buildEndpoint = function(room, options) {
            if (options === void 0) options = {};
            var params = [];
            for(var name_1 in options){
                if (!options.hasOwnProperty(name_1)) continue;
                params.push("".concat(name_1, "=").concat(options[name_1]));
            }
            var endpoint = this.settings.secure ? "wss://" : "ws://";
            if (room.publicAddress) endpoint += "".concat(room.publicAddress);
            else endpoint += "".concat(this.settings.hostname).concat(this.getEndpointPort()).concat(this.settings.pathname);
            return "".concat(endpoint, "/").concat(room.processId, "/").concat(room.roomId, "?").concat(params.join("&"));
        };
        Client.prototype.getHttpEndpoint = function(segments) {
            if (segments === void 0) segments = "";
            return "".concat(this.settings.secure ? "https" : "http", "://").concat(this.settings.hostname).concat(this.getEndpointPort()).concat(this.settings.pathname, "/matchmake/").concat(segments);
        };
        Client.prototype.getEndpointPort = function() {
            return this.settings.port !== 80 && this.settings.port !== 443 ? ":".concat(this.settings.port) : "";
        };
        return Client;
    }();
    /// <reference path="../typings/cocos-creator.d.ts" />
    /**
     * We do not assign 'storage' to window.localStorage immediatelly for React
     * Native compatibility. window.localStorage is not present when this module is
     * loaded.
     */ var storage;
    function getStorage() {
        if (!storage) storage = typeof cc !== "undefined" && cc.sys && cc.sys.localStorage ? cc.sys.localStorage // compatibility with cocos creator
         : typeof window !== "undefined" && window.localStorage //RN does have window object at this point, but localStorage is not defined
         ? window.localStorage // regular browser environment
         : {
            cache: {},
            setItem: function(key, value) {
                this.cache[key] = value;
            },
            getItem: function(key) {
                this.cache[key];
            },
            removeItem: function(key) {
                delete this.cache[key];
            }
        };
        return storage;
    }
    function setItem(key, value) {
        getStorage().setItem(key, value);
    }
    function removeItem(key) {
        getStorage().removeItem(key);
    }
    function getItem(key, callback) {
        var value = getStorage().getItem(key);
        if (typeof Promise === "undefined" || // old browsers
        !(value instanceof Promise)) // browser has synchronous return
        callback(value);
        else // react-native is asynchronous
        value.then(function(id) {
            return callback(id);
        });
    }
    var TOKEN_STORAGE = "colyseus-auth-token";
    exports1.Platform = void 0;
    (function(Platform) {
        Platform["ios"] = "ios";
        Platform["android"] = "android";
    })(exports1.Platform || (exports1.Platform = {}));
    var Auth = /** @class */ function() {
        function Auth(endpoint) {
            var _this = this;
            this._id = undefined;
            this.username = undefined;
            this.displayName = undefined;
            this.avatarUrl = undefined;
            this.isAnonymous = undefined;
            this.email = undefined;
            this.lang = undefined;
            this.location = undefined;
            this.timezone = undefined;
            this.metadata = undefined;
            this.devices = undefined;
            this.facebookId = undefined;
            this.twitterId = undefined;
            this.googleId = undefined;
            this.gameCenterId = undefined;
            this.steamId = undefined;
            this.friendIds = undefined;
            this.blockedUserIds = undefined;
            this.createdAt = undefined;
            this.updatedAt = undefined;
            // auth token
            this.token = undefined;
            this.endpoint = endpoint.replace("ws", "http");
            getItem(TOKEN_STORAGE, function(token) {
                return _this.token = token;
            });
        }
        Object.defineProperty(Auth.prototype, "hasToken", {
            get: function() {
                return !!this.token;
            },
            enumerable: false,
            configurable: true
        });
        Auth.prototype.login = function(options) {
            if (options === void 0) options = {};
            return __awaiter(this, void 0, void 0, function() {
                var queryParams, data, attr;
                return __generator(this, function(_a) {
                    switch(_a.label){
                        case 0:
                            queryParams = Object.assign({}, options);
                            if (this.hasToken) queryParams.token = this.token;
                            return [
                                4 /*yield*/ ,
                                this.request("post", "/auth", queryParams)
                            ];
                        case 1:
                            data = _a.sent();
                            // set & cache token
                            this.token = data.token;
                            setItem(TOKEN_STORAGE, this.token);
                            for(attr in data)if (this.hasOwnProperty(attr)) this[attr] = data[attr];
                            this.registerPingService();
                            return [
                                2 /*return*/ ,
                                this
                            ];
                    }
                });
            });
        };
        Auth.prototype.save = function() {
            return __awaiter(this, void 0, void 0, function() {
                return __generator(this, function(_a) {
                    switch(_a.label){
                        case 0:
                            return [
                                4 /*yield*/ ,
                                this.request("put", "/auth", {}, {
                                    username: this.username,
                                    displayName: this.displayName,
                                    avatarUrl: this.avatarUrl,
                                    lang: this.lang,
                                    location: this.location,
                                    timezone: this.timezone
                                })
                            ];
                        case 1:
                            _a.sent();
                            return [
                                2 /*return*/ ,
                                this
                            ];
                    }
                });
            });
        };
        Auth.prototype.getFriends = function() {
            return __awaiter(this, void 0, void 0, function() {
                return __generator(this, function(_a) {
                    switch(_a.label){
                        case 0:
                            return [
                                4 /*yield*/ ,
                                this.request("get", "/friends/all")
                            ];
                        case 1:
                            return [
                                2 /*return*/ ,
                                _a.sent()
                            ];
                    }
                });
            });
        };
        Auth.prototype.getOnlineFriends = function() {
            return __awaiter(this, void 0, void 0, function() {
                return __generator(this, function(_a) {
                    switch(_a.label){
                        case 0:
                            return [
                                4 /*yield*/ ,
                                this.request("get", "/friends/online")
                            ];
                        case 1:
                            return [
                                2 /*return*/ ,
                                _a.sent()
                            ];
                    }
                });
            });
        };
        Auth.prototype.getFriendRequests = function() {
            return __awaiter(this, void 0, void 0, function() {
                return __generator(this, function(_a) {
                    switch(_a.label){
                        case 0:
                            return [
                                4 /*yield*/ ,
                                this.request("get", "/friends/requests")
                            ];
                        case 1:
                            return [
                                2 /*return*/ ,
                                _a.sent()
                            ];
                    }
                });
            });
        };
        Auth.prototype.sendFriendRequest = function(friendId) {
            return __awaiter(this, void 0, void 0, function() {
                return __generator(this, function(_a) {
                    switch(_a.label){
                        case 0:
                            return [
                                4 /*yield*/ ,
                                this.request("post", "/friends/requests", {
                                    userId: friendId
                                })
                            ];
                        case 1:
                            return [
                                2 /*return*/ ,
                                _a.sent()
                            ];
                    }
                });
            });
        };
        Auth.prototype.acceptFriendRequest = function(friendId) {
            return __awaiter(this, void 0, void 0, function() {
                return __generator(this, function(_a) {
                    switch(_a.label){
                        case 0:
                            return [
                                4 /*yield*/ ,
                                this.request("put", "/friends/requests", {
                                    userId: friendId
                                })
                            ];
                        case 1:
                            return [
                                2 /*return*/ ,
                                _a.sent()
                            ];
                    }
                });
            });
        };
        Auth.prototype.declineFriendRequest = function(friendId) {
            return __awaiter(this, void 0, void 0, function() {
                return __generator(this, function(_a) {
                    switch(_a.label){
                        case 0:
                            return [
                                4 /*yield*/ ,
                                this.request("del", "/friends/requests", {
                                    userId: friendId
                                })
                            ];
                        case 1:
                            return [
                                2 /*return*/ ,
                                _a.sent()
                            ];
                    }
                });
            });
        };
        Auth.prototype.blockUser = function(friendId) {
            return __awaiter(this, void 0, void 0, function() {
                return __generator(this, function(_a) {
                    switch(_a.label){
                        case 0:
                            return [
                                4 /*yield*/ ,
                                this.request("post", "/friends/block", {
                                    userId: friendId
                                })
                            ];
                        case 1:
                            return [
                                2 /*return*/ ,
                                _a.sent()
                            ];
                    }
                });
            });
        };
        Auth.prototype.unblockUser = function(friendId) {
            return __awaiter(this, void 0, void 0, function() {
                return __generator(this, function(_a) {
                    switch(_a.label){
                        case 0:
                            return [
                                4 /*yield*/ ,
                                this.request("put", "/friends/block", {
                                    userId: friendId
                                })
                            ];
                        case 1:
                            return [
                                2 /*return*/ ,
                                _a.sent()
                            ];
                    }
                });
            });
        };
        Auth.prototype.request = function(method, segments, query, body, headers) {
            if (query === void 0) query = {};
            if (headers === void 0) headers = {};
            return __awaiter(this, void 0, void 0, function() {
                var queryParams, name_1, queryString, opts;
                return __generator(this, function(_a) {
                    switch(_a.label){
                        case 0:
                            headers["Accept"] = "application/json";
                            if (this.hasToken) headers["Authorization"] = "Bearer " + this.token;
                            queryParams = [];
                            for(name_1 in query)queryParams.push("".concat(name_1, "=").concat(query[name_1]));
                            queryString = queryParams.length > 0 ? "?".concat(queryParams.join("&")) : "";
                            opts = {
                                headers: headers
                            };
                            if (body) opts.body = body;
                            return [
                                4 /*yield*/ ,
                                http[method]("".concat(this.endpoint).concat(segments).concat(queryString), opts)
                            ];
                        case 1:
                            return [
                                2 /*return*/ ,
                                _a.sent().data
                            ];
                    }
                });
            });
        };
        Auth.prototype.logout = function() {
            this.token = undefined;
            removeItem(TOKEN_STORAGE);
            this.unregisterPingService();
        };
        Auth.prototype.registerPingService = function(timeout) {
            var _this = this;
            if (timeout === void 0) timeout = 15000;
            this.unregisterPingService();
            this.keepOnlineInterval = setInterval(function() {
                return _this.request("get", "/auth");
            }, timeout);
        };
        Auth.prototype.unregisterPingService = function() {
            clearInterval(this.keepOnlineInterval);
        };
        return Auth;
    }();
    var SchemaSerializer = /** @class */ function() {
        function SchemaSerializer() {}
        SchemaSerializer.prototype.setState = function(rawState) {
            return this.state.decode(rawState);
        };
        SchemaSerializer.prototype.getState = function() {
            return this.state;
        };
        SchemaSerializer.prototype.patch = function(patches) {
            return this.state.decode(patches);
        };
        SchemaSerializer.prototype.teardown = function() {
            var _a, _b;
            (_b = (_a = this.state) === null || _a === void 0 ? void 0 : _a["$changes"]) === null || _b === void 0 || _b.root.clearRefs();
        };
        SchemaSerializer.prototype.handshake = function(bytes, it) {
            if (this.state) {
                // TODO: validate client/server definitinos
                var reflection = new umd.Reflection();
                reflection.decode(bytes, it);
            } else // initialize reflected state from server
            this.state = umd.Reflection.decode(bytes, it);
        };
        return SchemaSerializer;
    }();
    var NoneSerializer = /** @class */ function() {
        function NoneSerializer() {}
        NoneSerializer.prototype.setState = function(rawState) {};
        NoneSerializer.prototype.getState = function() {
            return null;
        };
        NoneSerializer.prototype.patch = function(patches) {};
        NoneSerializer.prototype.teardown = function() {};
        NoneSerializer.prototype.handshake = function(bytes) {};
        return NoneSerializer;
    }();
    registerSerializer("schema", SchemaSerializer);
    registerSerializer("none", NoneSerializer);
    exports1.Auth = Auth;
    exports1.Client = Client;
    exports1.Room = Room;
    exports1.SchemaSerializer = SchemaSerializer;
    exports1.registerSerializer = registerSerializer;
    Object.defineProperty(exports1, "__esModule", {
        value: true
    });
});






const $28f5873a05064284$export$f34e1364531bbc4f = async ()=>{
    if (window.location.hostname.includes("dev-")) return "wss://dev-i0-blast.oogy.io";
    const response = await (0, $35a528e84618b070$export$df25f2f949bacaf7)();
    if (response?.status !== 200) {
        (0, $ad26fe773541dcd3$export$b410431fab84fa58).error("Impossible to retrieve the servers info");
        return;
    }
    const servers = response.data;
    if (servers["local"]) return "ws://localhost:3000";
    const availableServers = new Set(Object.keys(servers).map((serverName)=>serverName.split("-")[0]));
    const availableServersWithPing = [];
    await Promise.all(Array.from(availableServers.values()).map(async (availableServer)=>{
        const ping = await (0, $35a528e84618b070$export$c0f0d0ce4283a937)(availableServer);
        if (ping) availableServersWithPing.push({
            serverName: availableServer,
            ping: ping
        });
    }));
    const bestServer = availableServersWithPing.sort((a, b)=>a.ping - b.ping).shift();
    if (!bestServer) {
        (0, $ad26fe773541dcd3$export$b410431fab84fa58).error("Impossible to find the optimal server, please try again later");
        return;
    }
    return `wss://${bestServer.serverName}-i0-blast.oogy.io`;
};




const $631a100c3bfebc62$export$cabce3055a2aa92d = async (roomAvailable, dispatch, sessionToken, serverURL, roomSession, password, loadout)=>{
    if (!roomSession && !password && roomAvailable?.metadata?.private && (0, $b3b1baf40467424d$export$745043c7dc65e495).showInputModal) {
        (0, $b3b1baf40467424d$export$745043c7dc65e495).showInputModal({
            title: "Enter the room password",
            inputProps: {
                type: "password",
                maxLength: 32,
                placeholder: "password..."
            },
            async onAccept (password) {
                await $631a100c3bfebc62$export$cabce3055a2aa92d(roomAvailable, dispatch, sessionToken, serverURL, roomSession, password, loadout);
            }
        });
        return;
    }
    try {
        const client = new (0, $243a0fb2392e59c4$exports.Client)(serverURL);
        let room;
        if (roomSession) {
            room = await client.reconnect(roomSession.reconnectionToken);
            await (0, $e23f740143f4ec63$export$69e3d9997822a61a)(room);
            dispatch({
                type: "SET_ROOM_SESSION",
                roomSession: {
                    roomId: room.id,
                    sessionId: room.sessionId,
                    roomAvailable: roomAvailable,
                    reconnectionToken: room.reconnectionToken
                }
            });
            return;
        } else {
            room = await client.joinById(roomAvailable.roomId, {
                clientWidth: window.innerWidth,
                clientHeight: window.innerHeight,
                password: password,
                sessionToken: sessionToken,
                clubClash: roomAvailable.metadata.mode === "clash",
                clubClashLoadout: loadout
            });
            room.onMessage("start-game", async ()=>{
                await (0, $e23f740143f4ec63$export$69e3d9997822a61a)(room);
                Howler.stop();
            });
        }
        dispatch({
            type: "SET_ROOM",
            room: room
        });
        dispatch({
            type: "SET_ROOM_METADATA",
            roomMetadata: roomAvailable.metadata
        });
        dispatch({
            type: "SET_ROOM_SESSION",
            roomSession: {
                roomId: room.id,
                sessionId: room.sessionId,
                roomAvailable: roomAvailable,
                reconnectionToken: room.reconnectionToken
            }
        });
    } catch (err) {
        if ((0, $b3b1baf40467424d$export$745043c7dc65e495).showModal) (0, $b3b1baf40467424d$export$745043c7dc65e495).showModal({
            title: "Error",
            text: `${err}`
        });
        console.error(err);
    }
};
const $631a100c3bfebc62$export$e5629f326cfe53f6 = async (sessionToken, mode, dispatch, loadout)=>{
    return await $631a100c3bfebc62$export$fe853b5841b12ace({
        mode: mode,
        name: (0, $9805619f03ed02ef$export$ecfa8810709ab489)(32),
        maxPlayers: 1
    }, sessionToken, dispatch, undefined, undefined, loadout);
};
const $631a100c3bfebc62$export$fe853b5841b12ace = async (roomInfo, sessionToken, dispatch, password, serverURL, loadout)=>{
    try {
        const url = serverURL ? serverURL : await (0, $28f5873a05064284$export$f34e1364531bbc4f)();
        const client = new (0, $243a0fb2392e59c4$exports.Client)(url);
        if (!client) {
            (0, $ad26fe773541dcd3$export$b410431fab84fa58).error("Impossible to create a client, verify your internet connection or contact the support team");
            return;
        }
        const room = await client.create("classic", {
            clientWidth: window.innerWidth,
            clientHeight: window.innerHeight,
            roomInfo: roomInfo,
            password: password,
            sessionToken: sessionToken,
            clubClash: roomInfo.mode === "clash",
            clubClashLoadout: loadout
        });
        let started = false;
        room.onMessage("start-game", async ()=>{
            if (started) return;
            started = true;
            await (0, $e23f740143f4ec63$export$69e3d9997822a61a)(room);
            Howler.stop();
        });
        const roomAvailable = (await client.getAvailableRooms()).find((roomAvailable)=>roomAvailable.roomId === room.id);
        dispatch({
            type: "SET_ROOM",
            room: room
        });
        dispatch({
            type: "SET_ROOM_METADATA",
            roomMetadata: roomAvailable?.metadata
        });
        dispatch({
            type: "SET_ROOM_SESSION",
            roomSession: {
                roomId: room.id,
                sessionId: room.sessionId,
                roomAvailable: roomAvailable,
                reconnectionToken: room.reconnectionToken
            }
        });
        setTimeout(()=>{
            if (!started) room.send("is-game-started");
        }, 500);
        return url;
    } catch (err) {
        if ((0, $b3b1baf40467424d$export$745043c7dc65e495).showModal) (0, $b3b1baf40467424d$export$745043c7dc65e495).showModal({
            title: "Error",
            text: `${err}`
        });
        console.error(err);
    }
};






let $294c300caaab742a$var$CACHE;
let $294c300caaab742a$var$CACHE_TIME = 0;
const $294c300caaab742a$export$9a11c4d521627ff7 = async ()=>{
    if ($294c300caaab742a$var$CACHE_TIME < Date.now() - 600000) {
        if ($294c300caaab742a$var$CACHE) $294c300caaab742a$var$CACHE_TIME = Date.now();
        const response = await (0, $57966c7e0affc4cb$export$2e2bcd8739ae039).get(`${(0, $0426e2dd5e0de94d$export$41baa606ecc5bb4f)}/daily-rewards/daily-rewards.json`);
        if (response.status === 200) {
            $294c300caaab742a$var$CACHE_TIME = Date.now();
            $294c300caaab742a$var$CACHE = response.data;
        }
    }
    return $294c300caaab742a$var$CACHE;
};








var $acw62 = parcelRequire("acw62");

var $ftY1i = parcelRequire("ftY1i");



parcelRequire("acw62");

var $19cfdf7e8092b9b1$exports = {};

$parcel$export($19cfdf7e8092b9b1$exports, "badge", () => $19cfdf7e8092b9b1$export$4aebd143f31d0c0d, (v) => $19cfdf7e8092b9b1$export$4aebd143f31d0c0d = v);
$parcel$export($19cfdf7e8092b9b1$exports, "green", () => $19cfdf7e8092b9b1$export$955a2ebd2fb142ae, (v) => $19cfdf7e8092b9b1$export$955a2ebd2fb142ae = v);
$parcel$export($19cfdf7e8092b9b1$exports, "pink", () => $19cfdf7e8092b9b1$export$47853bc718611763, (v) => $19cfdf7e8092b9b1$export$47853bc718611763 = v);
$parcel$export($19cfdf7e8092b9b1$exports, "violet", () => $19cfdf7e8092b9b1$export$8241b7126941c403, (v) => $19cfdf7e8092b9b1$export$8241b7126941c403 = v);
var $19cfdf7e8092b9b1$export$4aebd143f31d0c0d;
var $19cfdf7e8092b9b1$export$955a2ebd2fb142ae;
var $19cfdf7e8092b9b1$export$47853bc718611763;
var $19cfdf7e8092b9b1$export$8241b7126941c403;
$19cfdf7e8092b9b1$export$4aebd143f31d0c0d = `wlS_9a_badge`;
$19cfdf7e8092b9b1$export$955a2ebd2fb142ae = `wlS_9a_green`;
$19cfdf7e8092b9b1$export$47853bc718611763 = `wlS_9a_pink`;
$19cfdf7e8092b9b1$export$8241b7126941c403 = `wlS_9a_violet`;


const $e2407f67ab2c799c$export$37acb3580601e69a = ({ className: className, children: children, ...props })=>{
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
        className: (0, $9805619f03ed02ef$export$91884aa883243770)((0, (/*@__PURE__*/$parcel$interopDefault($19cfdf7e8092b9b1$exports))), `badge ${className ?? ""}`),
        ...props,
        children: children
    });
};






var $acw62 = parcelRequire("acw62");






let $57b51d0a48cdc17b$var$CACHE;
let $57b51d0a48cdc17b$var$CACHE_TIME = 0;
const $57b51d0a48cdc17b$export$b48eee938ff0c204 = async ()=>{
    if ($57b51d0a48cdc17b$var$CACHE_TIME < Date.now() - 600000) {
        if ($57b51d0a48cdc17b$var$CACHE) $57b51d0a48cdc17b$var$CACHE_TIME = Date.now();
        const response = await (0, $57966c7e0affc4cb$export$2e2bcd8739ae039).get(`${(0, $0426e2dd5e0de94d$export$41baa606ecc5bb4f)}/chests/chests.json`);
        if (response.status === 200) {
            $57b51d0a48cdc17b$var$CACHE_TIME = Date.now();
            $57b51d0a48cdc17b$var$CACHE = response.data;
        }
    }
    return $57b51d0a48cdc17b$var$CACHE;
};




var $5ddaff220e612f23$exports = {};

$parcel$export($5ddaff220e612f23$exports, "buy-chest", () => $5ddaff220e612f23$export$24513d3efd249bf6, (v) => $5ddaff220e612f23$export$24513d3efd249bf6 = v);
$parcel$export($5ddaff220e612f23$exports, "content", () => $5ddaff220e612f23$export$a7db06668cad9adb, (v) => $5ddaff220e612f23$export$a7db06668cad9adb = v);
$parcel$export($5ddaff220e612f23$exports, "description", () => $5ddaff220e612f23$export$6d59db4903f20f7d, (v) => $5ddaff220e612f23$export$6d59db4903f20f7d = v);
$parcel$export($5ddaff220e612f23$exports, "error", () => $5ddaff220e612f23$export$a3bc9b8ed74fc, (v) => $5ddaff220e612f23$export$a3bc9b8ed74fc = v);
$parcel$export($5ddaff220e612f23$exports, "gems", () => $5ddaff220e612f23$export$b7dcc03c39461775, (v) => $5ddaff220e612f23$export$b7dcc03c39461775 = v);
$parcel$export($5ddaff220e612f23$exports, "tile", () => $5ddaff220e612f23$export$3c17558da18e4d75, (v) => $5ddaff220e612f23$export$3c17558da18e4d75 = v);
$parcel$export($5ddaff220e612f23$exports, "title", () => $5ddaff220e612f23$export$fb184b623420d9be, (v) => $5ddaff220e612f23$export$fb184b623420d9be = v);
var $5ddaff220e612f23$export$24513d3efd249bf6;
var $5ddaff220e612f23$export$a7db06668cad9adb;
var $5ddaff220e612f23$export$6d59db4903f20f7d;
var $5ddaff220e612f23$export$a3bc9b8ed74fc;
var $5ddaff220e612f23$export$b7dcc03c39461775;
var $5ddaff220e612f23$export$3c17558da18e4d75;
var $5ddaff220e612f23$export$fb184b623420d9be;
$5ddaff220e612f23$export$24513d3efd249bf6 = `C7mfTG_buy-chest`;
$5ddaff220e612f23$export$a7db06668cad9adb = `C7mfTG_content`;
$5ddaff220e612f23$export$6d59db4903f20f7d = `C7mfTG_description`;
$5ddaff220e612f23$export$a3bc9b8ed74fc = `C7mfTG_error`;
$5ddaff220e612f23$export$b7dcc03c39461775 = `C7mfTG_gems`;
$5ddaff220e612f23$export$3c17558da18e4d75 = `C7mfTG_tile`;
$5ddaff220e612f23$export$fb184b623420d9be = `C7mfTG_title`;


const $7443e6aa543aa526$export$cf8bd5e2833e0c24 = ({ className: className, onClose: onClose, chestSlotId: chestSlotId, ...props })=>{
    const { state: { accountInfo: accountInfo } } = (0, $c25623cc446ec3c6$export$ac8576a9912be18c)();
    const [buying, setBuying] = (0, $acw62.useState)(false);
    const [data, setData] = (0, $acw62.useState)();
    (0, $acw62.useEffect)(()=>{
        (0, $57b51d0a48cdc17b$export$b48eee938ff0c204)().then(setData);
    }, []);
    const title = /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: (0, $9805619f03ed02ef$export$91884aa883243770)((0, (/*@__PURE__*/$parcel$interopDefault($5ddaff220e612f23$exports))), "title"),
        children: [
            "Open new chest slot",
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                src: `${(0, $0426e2dd5e0de94d$export$24af3971dd36b33f)}/ui/cross.png`,
                alt: "cross",
                onClick: onClose
            })
        ]
    });
    const openSlot = async ()=>{
        if (!chestSlotId) return;
        setBuying(true);
        const result = await (0, $35a528e84618b070$export$82c8231841dac5b7)(chestSlotId);
        if (result?.data && (0, $b3b1baf40467424d$export$745043c7dc65e495).refreshAccountInfo) (0, $b3b1baf40467424d$export$745043c7dc65e495).refreshAccountInfo();
        setBuying(false);
        onClose();
    };
    const notEnoughGems = data !== undefined && accountInfo?.gems !== undefined && data.openSlotPrice.gems > accountInfo.gems;
    const content = /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: (0, $9805619f03ed02ef$export$91884aa883243770)((0, (/*@__PURE__*/$parcel$interopDefault($5ddaff220e612f23$exports))), "content"),
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: (0, $9805619f03ed02ef$export$91884aa883243770)((0, (/*@__PURE__*/$parcel$interopDefault($5ddaff220e612f23$exports))), "tile"),
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                    src: `${(0, $0426e2dd5e0de94d$export$24af3971dd36b33f)}/ui/empty-chest.png`,
                    alt: "empty-chest"
                })
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: (0, $9805619f03ed02ef$export$91884aa883243770)((0, (/*@__PURE__*/$parcel$interopDefault($5ddaff220e612f23$exports))), "description"),
                children: "this is a one time purchase that permanently unlocks an additional chest slot"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $6725244138e0595f$export$353f5b6fc5456de1), {
                className: (0, $9805619f03ed02ef$export$91884aa883243770)((0, (/*@__PURE__*/$parcel$interopDefault($5ddaff220e612f23$exports))), `gems ${notEnoughGems ? "gray" : "blue"}`),
                onClick: openSlot,
                loading: buying || !data,
                disabled: notEnoughGems,
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                        src: `${(0, $0426e2dd5e0de94d$export$24af3971dd36b33f)}/ui/gem.png`,
                        alt: "gems"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: (0, $9805619f03ed02ef$export$91884aa883243770)((0, (/*@__PURE__*/$parcel$interopDefault($5ddaff220e612f23$exports))), `${notEnoughGems ? "error" : ""}`),
                        children: [
                            data?.openSlotPrice.gems ?? "...",
                            " GEMS"
                        ]
                    })
                ]
            }),
            notEnoughGems && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: (0, $9805619f03ed02ef$export$91884aa883243770)((0, (/*@__PURE__*/$parcel$interopDefault($5ddaff220e612f23$exports))), "not-enough-gems"),
                children: "not enough gems"
            })
        ]
    });
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $207d23274fe2be11$export$6e63c1000ecf9db8), {
        className: (0, $9805619f03ed02ef$export$91884aa883243770)((0, (/*@__PURE__*/$parcel$interopDefault($5ddaff220e612f23$exports))), `buy-chest ${className}`),
        title: title,
        content: content,
        onClickBackground: onClose,
        ...props
    });
};






var $acw62 = parcelRequire("acw62");

var $ftY1i = parcelRequire("ftY1i");









let $cf016c70669323e2$var$CACHE;
let $cf016c70669323e2$var$CACHE_TIME = 0;
const $cf016c70669323e2$export$a993cc2444c7b2a = async ()=>{
    if ($cf016c70669323e2$var$CACHE_TIME < Date.now() - 600000) {
        if ($cf016c70669323e2$var$CACHE) $cf016c70669323e2$var$CACHE_TIME = Date.now();
        const response = await (0, $57966c7e0affc4cb$export$2e2bcd8739ae039).get(`${(0, $0426e2dd5e0de94d$export$41baa606ecc5bb4f)}/cosmetics/cosmetics.json`);
        if (response.status === 200) {
            $cf016c70669323e2$var$CACHE_TIME = Date.now();
            $cf016c70669323e2$var$CACHE = response.data;
        }
    }
    return $cf016c70669323e2$var$CACHE;
};




let $8e7f75257467a1e7$var$CACHE;
let $8e7f75257467a1e7$var$CACHE_TIME = 0;
const $8e7f75257467a1e7$export$efa13fcf93ec313a = async ()=>{
    if ($8e7f75257467a1e7$var$CACHE_TIME < Date.now() - 600000) {
        if ($8e7f75257467a1e7$var$CACHE) $8e7f75257467a1e7$var$CACHE_TIME = Date.now();
        const response = await (0, $57966c7e0affc4cb$export$2e2bcd8739ae039).get(`${(0, $0426e2dd5e0de94d$export$41baa606ecc5bb4f)}/weapons/weapons.json`);
        if (response.status === 200) {
            $8e7f75257467a1e7$var$CACHE_TIME = Date.now();
            $8e7f75257467a1e7$var$CACHE = response.data;
        }
    }
    return $8e7f75257467a1e7$var$CACHE;
};








parcelRequire("acw62");






var $acw62 = parcelRequire("acw62");


var $caaa8d26bf77619d$exports = {};

$parcel$export($caaa8d26bf77619d$exports, "absolute", () => $caaa8d26bf77619d$export$d31af2dc8039efd3, (v) => $caaa8d26bf77619d$export$d31af2dc8039efd3 = v);
$parcel$export($caaa8d26bf77619d$exports, "back", () => $caaa8d26bf77619d$export$7c341cb16fc91138, (v) => $caaa8d26bf77619d$export$7c341cb16fc91138 = v);
$parcel$export($caaa8d26bf77619d$exports, "big", () => $caaa8d26bf77619d$export$cc81a5c85b55e12c, (v) => $caaa8d26bf77619d$export$cc81a5c85b55e12c = v);
$parcel$export($caaa8d26bf77619d$exports, "common", () => $caaa8d26bf77619d$export$919daad019702595, (v) => $caaa8d26bf77619d$export$919daad019702595 = v);
$parcel$export($caaa8d26bf77619d$exports, "fabled", () => $caaa8d26bf77619d$export$b72fd0ee24dc1bcb, (v) => $caaa8d26bf77619d$export$b72fd0ee24dc1bcb = v);
$parcel$export($caaa8d26bf77619d$exports, "front", () => $caaa8d26bf77619d$export$b2764264c46c14df, (v) => $caaa8d26bf77619d$export$b2764264c46c14df = v);
$parcel$export($caaa8d26bf77619d$exports, "generic", () => $caaa8d26bf77619d$export$bcb4acd77ce96da3, (v) => $caaa8d26bf77619d$export$bcb4acd77ce96da3 = v);
$parcel$export($caaa8d26bf77619d$exports, "image", () => $caaa8d26bf77619d$export$5c452ff88e35e47d, (v) => $caaa8d26bf77619d$export$5c452ff88e35e47d = v);
$parcel$export($caaa8d26bf77619d$exports, "image-container", () => $caaa8d26bf77619d$export$bc3ecac96a6a5fd4, (v) => $caaa8d26bf77619d$export$bc3ecac96a6a5fd4 = v);
$parcel$export($caaa8d26bf77619d$exports, "rare", () => $caaa8d26bf77619d$export$b2e68d2f08b863d2, (v) => $caaa8d26bf77619d$export$b2e68d2f08b863d2 = v);
$parcel$export($caaa8d26bf77619d$exports, "rate", () => $caaa8d26bf77619d$export$e8435ed7e8ba58fa, (v) => $caaa8d26bf77619d$export$e8435ed7e8ba58fa = v);
$parcel$export($caaa8d26bf77619d$exports, "reward", () => $caaa8d26bf77619d$export$7abfebf4aa86b126, (v) => $caaa8d26bf77619d$export$7abfebf4aa86b126 = v);
$parcel$export($caaa8d26bf77619d$exports, "rewards", () => $caaa8d26bf77619d$export$4b2cb815b21f438d, (v) => $caaa8d26bf77619d$export$4b2cb815b21f438d = v);
$parcel$export($caaa8d26bf77619d$exports, "show", () => $caaa8d26bf77619d$export$57bf213be019eeb0, (v) => $caaa8d26bf77619d$export$57bf213be019eeb0 = v);
$parcel$export($caaa8d26bf77619d$exports, "special", () => $caaa8d26bf77619d$export$83aa05add7fe0e17, (v) => $caaa8d26bf77619d$export$83aa05add7fe0e17 = v);
$parcel$export($caaa8d26bf77619d$exports, "text", () => $caaa8d26bf77619d$export$6f093cfa640b7166, (v) => $caaa8d26bf77619d$export$6f093cfa640b7166 = v);
$parcel$export($caaa8d26bf77619d$exports, "tokens", () => $caaa8d26bf77619d$export$6ad93df59e712c43, (v) => $caaa8d26bf77619d$export$6ad93df59e712c43 = v);
$parcel$export($caaa8d26bf77619d$exports, "weapon", () => $caaa8d26bf77619d$export$49f053317aaa2405, (v) => $caaa8d26bf77619d$export$49f053317aaa2405 = v);
var $caaa8d26bf77619d$export$d31af2dc8039efd3;
var $caaa8d26bf77619d$export$7c341cb16fc91138;
var $caaa8d26bf77619d$export$cc81a5c85b55e12c;
var $caaa8d26bf77619d$export$919daad019702595;
var $caaa8d26bf77619d$export$b72fd0ee24dc1bcb;
var $caaa8d26bf77619d$export$b2764264c46c14df;
var $caaa8d26bf77619d$export$bcb4acd77ce96da3;
var $caaa8d26bf77619d$export$5c452ff88e35e47d;
var $caaa8d26bf77619d$export$bc3ecac96a6a5fd4;
var $caaa8d26bf77619d$export$b2e68d2f08b863d2;
var $caaa8d26bf77619d$export$e8435ed7e8ba58fa;
var $caaa8d26bf77619d$export$7abfebf4aa86b126;
var $caaa8d26bf77619d$export$4b2cb815b21f438d;
var $caaa8d26bf77619d$export$57bf213be019eeb0;
var $caaa8d26bf77619d$export$83aa05add7fe0e17;
var $caaa8d26bf77619d$export$6f093cfa640b7166;
var $caaa8d26bf77619d$export$6ad93df59e712c43;
var $caaa8d26bf77619d$export$49f053317aaa2405;
$caaa8d26bf77619d$export$d31af2dc8039efd3 = `Adk8EW_absolute`;
$caaa8d26bf77619d$export$7c341cb16fc91138 = `Adk8EW_back`;
$caaa8d26bf77619d$export$cc81a5c85b55e12c = `Adk8EW_big`;
$caaa8d26bf77619d$export$919daad019702595 = `Adk8EW_common`;
$caaa8d26bf77619d$export$b72fd0ee24dc1bcb = `Adk8EW_fabled`;
$caaa8d26bf77619d$export$b2764264c46c14df = `Adk8EW_front`;
$caaa8d26bf77619d$export$bcb4acd77ce96da3 = `Adk8EW_generic`;
$caaa8d26bf77619d$export$5c452ff88e35e47d = `Adk8EW_image`;
$caaa8d26bf77619d$export$bc3ecac96a6a5fd4 = `Adk8EW_image-container`;
$caaa8d26bf77619d$export$b2e68d2f08b863d2 = `Adk8EW_rare`;
$caaa8d26bf77619d$export$e8435ed7e8ba58fa = `Adk8EW_rate`;
$caaa8d26bf77619d$export$7abfebf4aa86b126 = `Adk8EW_reward`;
$caaa8d26bf77619d$export$4b2cb815b21f438d = `Adk8EW_rewards`;
$caaa8d26bf77619d$export$57bf213be019eeb0 = `Adk8EW_show`;
$caaa8d26bf77619d$export$83aa05add7fe0e17 = `Adk8EW_special`;
$caaa8d26bf77619d$export$6f093cfa640b7166 = `Adk8EW_text`;
$caaa8d26bf77619d$export$6ad93df59e712c43 = `Adk8EW_tokens`;
$caaa8d26bf77619d$export$49f053317aaa2405 = `Adk8EW_weapon`;


const $917136c90b9e1944$export$b58f7d8ba025fac7 = ({ className: className, rewards: rewards, flipped: flipped, ...props })=>{
    const [show, setShow] = (0, $acw62.useState)(Array.from({
        length: rewards.length
    }, ()=>flipped));
    (0, $acw62.useEffect)(()=>{
        if (flipped) {
            setShow(Array.from({
                length: rewards.length
            }, ()=>flipped));
            return;
        }
        const timeouts = rewards.map((reward, index)=>setTimeout(()=>{
                show[index] = true;
                setShow([
                    ...show
                ]);
                (0, $0c69c9c512bb7a3f$export$d5dc2923b9ea91d1).play();
            }, 500 + index * 500));
        return ()=>{
            timeouts.map(clearTimeout);
        };
    }, [
        flipped,
        rewards
    ]);
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
        className: (0, $9805619f03ed02ef$export$91884aa883243770)((0, (/*@__PURE__*/$parcel$interopDefault($caaa8d26bf77619d$exports))), `rewards ${className}`),
        ...props,
        children: rewards.map((reward, index)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: (0, $9805619f03ed02ef$export$91884aa883243770)((0, (/*@__PURE__*/$parcel$interopDefault($caaa8d26bf77619d$exports))), `reward ${show[index] ? "show" : ""}`),
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        className: (0, $9805619f03ed02ef$export$91884aa883243770)((0, (/*@__PURE__*/$parcel$interopDefault($caaa8d26bf77619d$exports))), `front ${reward.rarity === "special" ? "special" : ""}`)
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: (0, $9805619f03ed02ef$export$91884aa883243770)((0, (/*@__PURE__*/$parcel$interopDefault($caaa8d26bf77619d$exports))), `back ${reward.rarity === "special" ? "special" : ""} ${reward.type === "weapon" || reward.type === "tokens" ? reward.type : reward.type === "cosmetic" ? reward.rarity : ""}`),
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: (0, $9805619f03ed02ef$export$91884aa883243770)((0, (/*@__PURE__*/$parcel$interopDefault($caaa8d26bf77619d$exports))), "image-container"),
                                children: [
                                    reward.type === "gems" && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                                        className: (0, $9805619f03ed02ef$export$91884aa883243770)((0, (/*@__PURE__*/$parcel$interopDefault($caaa8d26bf77619d$exports))), "image"),
                                        src: `${(0, $0426e2dd5e0de94d$export$24af3971dd36b33f)}/ui/gem.png`,
                                        alt: "gem"
                                    }),
                                    reward.type === "tokens" && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                                        className: (0, $9805619f03ed02ef$export$91884aa883243770)((0, (/*@__PURE__*/$parcel$interopDefault($caaa8d26bf77619d$exports))), "image"),
                                        src: `${(0, $0426e2dd5e0de94d$export$24af3971dd36b33f)}/ui/token.png`,
                                        alt: "token"
                                    }),
                                    reward.type === "cosmetic" && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                                        className: (0, $9805619f03ed02ef$export$91884aa883243770)((0, (/*@__PURE__*/$parcel$interopDefault($caaa8d26bf77619d$exports))), "image cosmetic"),
                                        src: `${(0, $0426e2dd5e0de94d$export$24af3971dd36b33f)}/ui/cosmetics/${reward.category?.toLowerCase()}/${reward.name?.toLowerCase()}.png`,
                                        alt: reward.name
                                    }),
                                    reward.type === "weapon" && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                                        className: (0, $9805619f03ed02ef$export$91884aa883243770)((0, (/*@__PURE__*/$parcel$interopDefault($caaa8d26bf77619d$exports))), "image weapon"),
                                        src: `${(0, $0426e2dd5e0de94d$export$24af3971dd36b33f)}/ui/weapons/${reward.name?.toLowerCase()}.png`,
                                        alt: reward.name
                                    }),
                                    reward.type === "generic" && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                                        className: (0, $9805619f03ed02ef$export$91884aa883243770)((0, (/*@__PURE__*/$parcel$interopDefault($caaa8d26bf77619d$exports))), "image generic"),
                                        src: reward.imageURL,
                                        alt: reward.name
                                    })
                                ]
                            }),
                            (reward.type === "gems" || reward.type === "tokens") && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: (0, $9805619f03ed02ef$export$91884aa883243770)((0, (/*@__PURE__*/$parcel$interopDefault($caaa8d26bf77619d$exports))), "text"),
                                children: [
                                    reward.quantity,
                                    reward.type === "gems" ? " GEM" : " TOKEN",
                                    reward.quantity > 1 && "S"
                                ]
                            }),
                            reward.type === "generic" && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                className: (0, $9805619f03ed02ef$export$91884aa883243770)((0, (/*@__PURE__*/$parcel$interopDefault($caaa8d26bf77619d$exports))), "text"),
                                children: reward.name
                            }),
                            reward.rate !== undefined && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: (0, $9805619f03ed02ef$export$91884aa883243770)((0, (/*@__PURE__*/$parcel$interopDefault($caaa8d26bf77619d$exports))), "rate"),
                                children: [
                                    reward.rate,
                                    "%"
                                ]
                            })
                        ]
                    })
                ]
            }, `reward-${index}`))
    });
};


var $2ff76ca457602110$exports = {};

$parcel$export($2ff76ca457602110$exports, "description", () => $2ff76ca457602110$export$6d59db4903f20f7d, (v) => $2ff76ca457602110$export$6d59db4903f20f7d = v);
$parcel$export($2ff76ca457602110$exports, "drop-table", () => $2ff76ca457602110$export$7a87da42b2b4af85, (v) => $2ff76ca457602110$export$7a87da42b2b4af85 = v);
$parcel$export($2ff76ca457602110$exports, "rewards", () => $2ff76ca457602110$export$4b2cb815b21f438d, (v) => $2ff76ca457602110$export$4b2cb815b21f438d = v);
$parcel$export($2ff76ca457602110$exports, "title", () => $2ff76ca457602110$export$fb184b623420d9be, (v) => $2ff76ca457602110$export$fb184b623420d9be = v);
var $2ff76ca457602110$export$6d59db4903f20f7d;
var $2ff76ca457602110$export$7a87da42b2b4af85;
var $2ff76ca457602110$export$4b2cb815b21f438d;
var $2ff76ca457602110$export$fb184b623420d9be;
$2ff76ca457602110$export$6d59db4903f20f7d = `hulZaG_description`;
$2ff76ca457602110$export$7a87da42b2b4af85 = `hulZaG_drop-table`;
$2ff76ca457602110$export$4b2cb815b21f438d = `hulZaG_rewards`;
$2ff76ca457602110$export$fb184b623420d9be = `hulZaG_title`;


const $e7944c7df4b6c497$export$4f0abbd4b5b22d8a = ({ className: className, drops: rewards, onClose: onClose, ...props })=>{
    const title = /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: (0, $9805619f03ed02ef$export$91884aa883243770)((0, (/*@__PURE__*/$parcel$interopDefault($2ff76ca457602110$exports))), "title"),
        children: [
            "Drop Table",
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                src: `${(0, $0426e2dd5e0de94d$export$24af3971dd36b33f)}/ui/cross.png`,
                alt: "cross",
                onClick: onClose
            })
        ]
    });
    const content = /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: (0, $9805619f03ed02ef$export$91884aa883243770)((0, (/*@__PURE__*/$parcel$interopDefault($2ff76ca457602110$exports))), "description"),
                children: [
                    "Chest rewards are a random roll across several drop tables. The rarer the chest, the better your odds.You will be guaranteed ",
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                        children: "at least one"
                    }),
                    " prize from below."
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $917136c90b9e1944$export$b58f7d8ba025fac7), {
                className: (0, $9805619f03ed02ef$export$91884aa883243770)((0, (/*@__PURE__*/$parcel$interopDefault($2ff76ca457602110$exports))), "rewards"),
                rewards: rewards,
                flipped: true
            })
        ]
    });
    const footer = /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7b02d682eb115277$exports.Fragment), {
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $6725244138e0595f$export$353f5b6fc5456de1), {
            className: (0, $9805619f03ed02ef$export$91884aa883243770)((0, (/*@__PURE__*/$parcel$interopDefault($2ff76ca457602110$exports))), "small"),
            onClick: onClose,
            children: "GOT IT"
        })
    });
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $207d23274fe2be11$export$6e63c1000ecf9db8), {
        className: (0, $9805619f03ed02ef$export$91884aa883243770)((0, (/*@__PURE__*/$parcel$interopDefault($2ff76ca457602110$exports))), `drop-table ${className}`),
        title: title,
        content: content,
        footer: footer,
        ...props
    });
};



var $c21fd1e0330b1ec5$exports = {};

$parcel$export($c21fd1e0330b1ec5$exports, "appear", () => $c21fd1e0330b1ec5$export$fb1b4b0e602f43f1, (v) => $c21fd1e0330b1ec5$export$fb1b4b0e602f43f1 = v);
$parcel$export($c21fd1e0330b1ec5$exports, "back", () => $c21fd1e0330b1ec5$export$7c341cb16fc91138, (v) => $c21fd1e0330b1ec5$export$7c341cb16fc91138 = v);
$parcel$export($c21fd1e0330b1ec5$exports, "badge", () => $c21fd1e0330b1ec5$export$4aebd143f31d0c0d, (v) => $c21fd1e0330b1ec5$export$4aebd143f31d0c0d = v);
$parcel$export($c21fd1e0330b1ec5$exports, "bottom", () => $c21fd1e0330b1ec5$export$40e543e69a8b3fbb, (v) => $c21fd1e0330b1ec5$export$40e543e69a8b3fbb = v);
$parcel$export($c21fd1e0330b1ec5$exports, "chest", () => $c21fd1e0330b1ec5$export$11c092ac8d4e295c, (v) => $c21fd1e0330b1ec5$export$11c092ac8d4e295c = v);
$parcel$export($c21fd1e0330b1ec5$exports, "chest-container", () => $c21fd1e0330b1ec5$export$ad06d95ce12214f1, (v) => $c21fd1e0330b1ec5$export$ad06d95ce12214f1 = v);
$parcel$export($c21fd1e0330b1ec5$exports, "container", () => $c21fd1e0330b1ec5$export$34e0f9847d4c02dd, (v) => $c21fd1e0330b1ec5$export$34e0f9847d4c02dd = v);
$parcel$export($c21fd1e0330b1ec5$exports, "countdown", () => $c21fd1e0330b1ec5$export$f52e29715bba3529, (v) => $c21fd1e0330b1ec5$export$f52e29715bba3529 = v);
$parcel$export($c21fd1e0330b1ec5$exports, "drop-table", () => $c21fd1e0330b1ec5$export$7a87da42b2b4af85, (v) => $c21fd1e0330b1ec5$export$7a87da42b2b4af85 = v);
$parcel$export($c21fd1e0330b1ec5$exports, "hide", () => $c21fd1e0330b1ec5$export$fe8985bb6374093c, (v) => $c21fd1e0330b1ec5$export$fe8985bb6374093c = v);
$parcel$export($c21fd1e0330b1ec5$exports, "hover", () => $c21fd1e0330b1ec5$export$3f60957f5dbf3876, (v) => $c21fd1e0330b1ec5$export$3f60957f5dbf3876 = v);
$parcel$export($c21fd1e0330b1ec5$exports, "image", () => $c21fd1e0330b1ec5$export$5c452ff88e35e47d, (v) => $c21fd1e0330b1ec5$export$5c452ff88e35e47d = v);
$parcel$export($c21fd1e0330b1ec5$exports, "light", () => $c21fd1e0330b1ec5$export$a43af521ac8c3202, (v) => $c21fd1e0330b1ec5$export$a43af521ac8c3202 = v);
$parcel$export($c21fd1e0330b1ec5$exports, "middle", () => $c21fd1e0330b1ec5$export$848500358616d9e6, (v) => $c21fd1e0330b1ec5$export$848500358616d9e6 = v);
$parcel$export($c21fd1e0330b1ec5$exports, "price", () => $c21fd1e0330b1ec5$export$321c0b1a406de31f, (v) => $c21fd1e0330b1ec5$export$321c0b1a406de31f = v);
$parcel$export($c21fd1e0330b1ec5$exports, "price-container", () => $c21fd1e0330b1ec5$export$657c5a8a5f1e78b, (v) => $c21fd1e0330b1ec5$export$657c5a8a5f1e78b = v);
$parcel$export($c21fd1e0330b1ec5$exports, "price-text", () => $c21fd1e0330b1ec5$export$d965235ad6c8f2d1, (v) => $c21fd1e0330b1ec5$export$d965235ad6c8f2d1 = v);
$parcel$export($c21fd1e0330b1ec5$exports, "rewards", () => $c21fd1e0330b1ec5$export$4b2cb815b21f438d, (v) => $c21fd1e0330b1ec5$export$4b2cb815b21f438d = v);
$parcel$export($c21fd1e0330b1ec5$exports, "rewards-container", () => $c21fd1e0330b1ec5$export$758192ef72bae219, (v) => $c21fd1e0330b1ec5$export$758192ef72bae219 = v);
$parcel$export($c21fd1e0330b1ec5$exports, "rotating", () => $c21fd1e0330b1ec5$export$bfd64c937657f93a, (v) => $c21fd1e0330b1ec5$export$bfd64c937657f93a = v);
$parcel$export($c21fd1e0330b1ec5$exports, "timer", () => $c21fd1e0330b1ec5$export$9dc4ecf953986f04, (v) => $c21fd1e0330b1ec5$export$9dc4ecf953986f04 = v);
var $c21fd1e0330b1ec5$export$fb1b4b0e602f43f1;
var $c21fd1e0330b1ec5$export$7c341cb16fc91138;
var $c21fd1e0330b1ec5$export$4aebd143f31d0c0d;
var $c21fd1e0330b1ec5$export$40e543e69a8b3fbb;
var $c21fd1e0330b1ec5$export$11c092ac8d4e295c;
var $c21fd1e0330b1ec5$export$ad06d95ce12214f1;
var $c21fd1e0330b1ec5$export$34e0f9847d4c02dd;
var $c21fd1e0330b1ec5$export$f52e29715bba3529;
var $c21fd1e0330b1ec5$export$7a87da42b2b4af85;
var $c21fd1e0330b1ec5$export$fe8985bb6374093c;
var $c21fd1e0330b1ec5$export$3f60957f5dbf3876;
var $c21fd1e0330b1ec5$export$5c452ff88e35e47d;
var $c21fd1e0330b1ec5$export$a43af521ac8c3202;
var $c21fd1e0330b1ec5$export$848500358616d9e6;
var $c21fd1e0330b1ec5$export$321c0b1a406de31f;
var $c21fd1e0330b1ec5$export$657c5a8a5f1e78b;
var $c21fd1e0330b1ec5$export$d965235ad6c8f2d1;
var $c21fd1e0330b1ec5$export$4b2cb815b21f438d;
var $c21fd1e0330b1ec5$export$758192ef72bae219;
var $c21fd1e0330b1ec5$export$bfd64c937657f93a;
var $c21fd1e0330b1ec5$export$9dc4ecf953986f04;
$c21fd1e0330b1ec5$export$fb1b4b0e602f43f1 = `IhgY5q_appear`;
$c21fd1e0330b1ec5$export$fb1b4b0e602f43f1;
$c21fd1e0330b1ec5$export$7c341cb16fc91138 = `IhgY5q_back`;
$c21fd1e0330b1ec5$export$4aebd143f31d0c0d = `IhgY5q_badge`;
$c21fd1e0330b1ec5$export$40e543e69a8b3fbb = `IhgY5q_bottom`;
$c21fd1e0330b1ec5$export$11c092ac8d4e295c = `IhgY5q_chest`;
$c21fd1e0330b1ec5$export$ad06d95ce12214f1 = `IhgY5q_chest-container`;
$c21fd1e0330b1ec5$export$34e0f9847d4c02dd = `IhgY5q_container`;
$c21fd1e0330b1ec5$export$f52e29715bba3529 = `IhgY5q_countdown`;
$c21fd1e0330b1ec5$export$7a87da42b2b4af85 = `IhgY5q_drop-table`;
$c21fd1e0330b1ec5$export$fe8985bb6374093c = `IhgY5q_hide`;
$c21fd1e0330b1ec5$export$3f60957f5dbf3876 = `IhgY5q_hover`;
$c21fd1e0330b1ec5$export$5c452ff88e35e47d = `IhgY5q_image`;
$c21fd1e0330b1ec5$export$a43af521ac8c3202 = `IhgY5q_light`;
$c21fd1e0330b1ec5$export$848500358616d9e6 = `IhgY5q_middle`;
$c21fd1e0330b1ec5$export$321c0b1a406de31f = `IhgY5q_price`;
$c21fd1e0330b1ec5$export$657c5a8a5f1e78b = `IhgY5q_price-container`;
$c21fd1e0330b1ec5$export$d965235ad6c8f2d1 = `IhgY5q_price-text`;
$c21fd1e0330b1ec5$export$4b2cb815b21f438d = `IhgY5q_rewards`;
$c21fd1e0330b1ec5$export$758192ef72bae219 = `IhgY5q_rewards-container`;
$c21fd1e0330b1ec5$export$bfd64c937657f93a = `IhgY5q_rotating`;
$c21fd1e0330b1ec5$export$bfd64c937657f93a;
$c21fd1e0330b1ec5$export$9dc4ecf953986f04 = `IhgY5q_timer`;


const $dbf74f74fe2c2ca0$var$addZeroToNumber = (number)=>number < 10 ? `0${number}` : number;
const $dbf74f74fe2c2ca0$var$renderer = ({ days: days, hours: hours, minutes: minutes })=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
        children: [
            $dbf74f74fe2c2ca0$var$addZeroToNumber(hours + days * 24),
            "H",
            $dbf74f74fe2c2ca0$var$addZeroToNumber(minutes),
            "M"
        ]
    });
const $dbf74f74fe2c2ca0$export$d2000f524695a9a0 = ({ className: className, chest: chest, index: index, onHide: onHide, ...props })=>{
    const { state: { accountInfo: accountInfo } } = (0, $c25623cc446ec3c6$export$ac8576a9912be18c)();
    const [openingChest, setOpeningChest] = (0, $acw62.useState)(false);
    //const [burningChest, setBurningChest] = useState(false)
    const [showDropTable, setShowDropTable] = (0, $acw62.useState)(false);
    const [chestOpened, setChestOpened] = (0, $acw62.useState)(false);
    const [chestSpine, setChestSpine] = (0, $acw62.useState)();
    const [rewards, setRewards] = (0, $acw62.useState)([]);
    const [drops, setDrops] = (0, $acw62.useState)([]);
    (0, $acw62.useEffect)(()=>{
        if (!chest.type) return;
        (0, $e16030e48e62d804$export$9ae88a47cefbffb9)(0, "chest_chest-container", chest.type).then(setChestSpine);
        return ()=>{
            (0, $e16030e48e62d804$export$ed8fc336fedfaf4e)();
        };
    }, [
        chest
    ]);
    (0, $acw62.useEffect)(()=>{
        // Drops
        (async ()=>{
            if (!chest.type || !accountInfo) return;
            const drops = [
                ...Object.entries(await (0, $cf016c70669323e2$export$a993cc2444c7b2a)()).map(([category, data])=>Object.entries(data).map(([, entry])=>{
                        if (!chest.type || !entry.chestDropRates?.[chest.type]) return;
                        return {
                            type: "cosmetic",
                            category: category,
                            name: entry.name,
                            rarity: entry.rarity,
                            quantity: 1,
                            rate: entry.chestDropRates[chest.type]
                        };
                    }).filter((entry)=>!!entry && !accountInfo.character.cosmetics[category].unlocked.includes(entry.name))).flat(),
                ...Object.entries(await (0, $8e7f75257467a1e7$export$efa13fcf93ec313a)()).map(([name, entry])=>{
                    if (!chest.type || !entry.chestDropRates?.[chest.type]) return;
                    return {
                        type: "weapon",
                        name: name,
                        quantity: 1,
                        rarity: entry.rarity,
                        rate: entry.chestDropRates[chest.type]
                    };
                }).filter((entry)=>!!entry && accountInfo.character.weapons.unlocked[entry.name] === undefined),
                ...(await (0, $57b51d0a48cdc17b$export$b48eee938ff0c204)()).chests[chest.type].gemsDrop?.map((gemDrop)=>({
                        type: "gems",
                        ...gemDrop
                    })) ?? []
            ];
            setDrops([
                ...drops.filter((drop)=>drop.type === "gems").sort((a, b)=>(b.rate ?? 0) - (a.rate ?? 0)),
                ...drops.filter((drop)=>drop.type === "cosmetic").sort((a, b)=>(b.rate ?? 0) - (a.rate ?? 0)),
                ...drops.filter((drop)=>drop.type === "weapon").sort((a, b)=>(b.rate ?? 0) - (a.rate ?? 0))
            ]);
        })();
    }, [
        chest,
        accountInfo
    ]);
    const openChest = async ()=>{
        if (!chest.type) return;
        const fct = async ()=>{
            if (!chest.type || !chestSpine?.animationState) return;
            setOpeningChest(true);
            (0, $0c69c9c512bb7a3f$export$c8dc8223fac2849e).play("open");
            chestSpine.animationState.addListener({
                complete (entry) {
                    if (entry.animation?.name === "OPEN") {
                        setChestOpened(true);
                        setTimeout((0, $e16030e48e62d804$export$ed8fc336fedfaf4e), 100);
                    }
                }
            });
            chestSpine.setAnimation("OPEN", false);
            const response = await (0, $35a528e84618b070$export$59cbea4635bedba3)(index);
            if (response?.status === 200) {
                setRewards([
                    ...response.data.filter((reward)=>reward.type === "gems"),
                    ...response.data.filter((reward)=>reward.rarity === "common" && reward.type !== "gems"),
                    ...response.data.filter((reward)=>reward.rarity === "rare" && reward.type !== "gems"),
                    ...response.data.filter((reward)=>reward.rarity === "fabled" && reward.type !== "gems")
                ]);
                if ((0, $b3b1baf40467424d$export$745043c7dc65e495).refreshAccountInfo) (0, $b3b1baf40467424d$export$745043c7dc65e495).refreshAccountInfo();
            }
        };
        if (chest.timer !== undefined && chest.timer > Date.now() - 86400000) {
            if ((0, $b3b1baf40467424d$export$745043c7dc65e495).showConfirm) {
                const speedUpPrice = (await (0, $57b51d0a48cdc17b$export$b48eee938ff0c204)()).speedUpPrice[chest.type];
                (0, $b3b1baf40467424d$export$745043c7dc65e495).showConfirm({
                    title: "Opening cost",
                    text: `Opening this chest without waiting 24h costs ${speedUpPrice} gems`,
                    acceptText: "open",
                    refuseText: "cancel",
                    onAccept: fct
                });
            }
        } else fct();
    };
    //const burnChest = async () => {
    //  if (!chest.type || !chestSpine?.animationState) return
    //  if (hubState.showConfirm) {
    //    hubState.showConfirm({
    //      title: `Burning the "${chest.type}" chest`,
    //      text: `Are you sure you want to burn the "${chest.type}" chest?`,
    //      acceptText: 'burn',
    //      refuseText: 'cancel',
    //      onAccept: async () => {
    //        setBurningChest(true)
    //        await burnChestRequest(index)
    //        setBurningChest(false)
    //        if (hubState.refreshAccountInfo) hubState.refreshAccountInfo()
    //        onHide()
    //      }
    //    })
    //  }
    //}
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: (0, $9805619f03ed02ef$export$91884aa883243770)((0, (/*@__PURE__*/$parcel$interopDefault($c21fd1e0330b1ec5$exports))), `chest ${className}`),
        ...props,
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $d476126f9afdc959$export$668799e4797757a8), {}),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $e7944c7df4b6c497$export$4f0abbd4b5b22d8a), {
                show: showDropTable,
                drops: drops,
                onClickBackground: ()=>setShowDropTable(false),
                onClose: ()=>setShowDropTable(false)
            }),
            chestOpened && rewards && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: (0, $9805619f03ed02ef$export$91884aa883243770)((0, (/*@__PURE__*/$parcel$interopDefault($c21fd1e0330b1ec5$exports))), "rewards-container"),
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $917136c90b9e1944$export$b58f7d8ba025fac7), {
                    className: (0, $9805619f03ed02ef$export$91884aa883243770)((0, (/*@__PURE__*/$parcel$interopDefault($c21fd1e0330b1ec5$exports))), "rewards"),
                    rewards: rewards
                })
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: (0, $9805619f03ed02ef$export$91884aa883243770)((0, (/*@__PURE__*/$parcel$interopDefault($c21fd1e0330b1ec5$exports))), "container"),
                children: [
                    !chestOpened && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        id: "chest_chest-container",
                        className: (0, $9805619f03ed02ef$export$91884aa883243770)((0, (/*@__PURE__*/$parcel$interopDefault($c21fd1e0330b1ec5$exports))), "image")
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: (0, $9805619f03ed02ef$export$91884aa883243770)((0, (/*@__PURE__*/$parcel$interopDefault($c21fd1e0330b1ec5$exports))), "back hover"),
                        onClick: onHide,
                        children: [
                            "back ",
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                                src: `${(0, $0426e2dd5e0de94d$export$24af3971dd36b33f)}/ui/back.png`,
                                alt: "arrow"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: (0, $9805619f03ed02ef$export$91884aa883243770)((0, (/*@__PURE__*/$parcel$interopDefault($c21fd1e0330b1ec5$exports))), "middle"),
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: (0, $9805619f03ed02ef$export$91884aa883243770)((0, (/*@__PURE__*/$parcel$interopDefault($c21fd1e0330b1ec5$exports))), `price-container ${openingChest ? "hide" : ""}`),
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                        className: (0, $9805619f03ed02ef$export$91884aa883243770)((0, (/*@__PURE__*/$parcel$interopDefault($c21fd1e0330b1ec5$exports))), "price-text"),
                                        children: "Cost to open"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                        className: (0, $9805619f03ed02ef$export$91884aa883243770)((0, (/*@__PURE__*/$parcel$interopDefault($c21fd1e0330b1ec5$exports))), "price"),
                                        children: [
                                            chest.cost?.gems !== undefined && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                                                children: [
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                                                        src: `${(0, $0426e2dd5e0de94d$export$24af3971dd36b33f)}/ui/gem.png`,
                                                        alt: "gem"
                                                    }),
                                                    chest.cost.gems
                                                ]
                                            }),
                                            chest.cost?.gems !== undefined && chest.cost.sol !== undefined && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                children: "+"
                                            }),
                                            chest.cost?.sol !== undefined && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                                                children: [
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                                                        src: `${(0, $0426e2dd5e0de94d$export$24af3971dd36b33f)}/ui/sol.png`,
                                                        alt: "sol"
                                                    }),
                                                    chest.cost.sol
                                                ]
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: (0, $9805619f03ed02ef$export$91884aa883243770)((0, (/*@__PURE__*/$parcel$interopDefault($c21fd1e0330b1ec5$exports))), "chest-container"),
                                children: [
                                    chest.timer !== undefined && chest.timer > Date.now() - 86400000 && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                        className: (0, $9805619f03ed02ef$export$91884aa883243770)((0, (/*@__PURE__*/$parcel$interopDefault($c21fd1e0330b1ec5$exports))), `timer ${openingChest ? "hide" : ""}`),
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                                                className: (0, $9805619f03ed02ef$export$91884aa883243770)((0, (/*@__PURE__*/$parcel$interopDefault($c21fd1e0330b1ec5$exports))), "lock"),
                                                src: `${(0, $0426e2dd5e0de94d$export$24af3971dd36b33f)}/ui/lock.png`,
                                                alt: "lock"
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                className: (0, $9805619f03ed02ef$export$91884aa883243770)((0, (/*@__PURE__*/$parcel$interopDefault($c21fd1e0330b1ec5$exports))), "countdown"),
                                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $ftY1i.default), {
                                                    date: chest.timer + 86400000,
                                                    renderer: $dbf74f74fe2c2ca0$var$renderer
                                                })
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $e2407f67ab2c799c$export$37acb3580601e69a), {
                                        className: `${(0, $b66fc98e4eed8243$export$64b16c65d143d94d)[chest.type ?? (0, $49736469f58fc92b$export$f33286854e75f828).Common]} ${(0, $9805619f03ed02ef$export$91884aa883243770)((0, (/*@__PURE__*/$parcel$interopDefault($c21fd1e0330b1ec5$exports))), `badge ${openingChest ? "hide" : ""}`)}`,
                                        children: chest.type
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        className: (0, $9805619f03ed02ef$export$91884aa883243770)((0, (/*@__PURE__*/$parcel$interopDefault($c21fd1e0330b1ec5$exports))), "bottom"),
                        children: openingChest ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $6725244138e0595f$export$353f5b6fc5456de1), {
                            onClick: onHide,
                            children: "CONTINUE"
                        }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                    className: (0, $9805619f03ed02ef$export$91884aa883243770)((0, (/*@__PURE__*/$parcel$interopDefault($c21fd1e0330b1ec5$exports))), "drop-table hover"),
                                    onClick: ()=>setShowDropTable(true),
                                    children: [
                                        "See drop table ",
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                                            src: `${(0, $0426e2dd5e0de94d$export$24af3971dd36b33f)}/ui/open-arrow.png`,
                                            alt: "arrow"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $6725244138e0595f$export$353f5b6fc5456de1), {
                                    onClick: openChest,
                                    children: "OPEN"
                                })
                            ]
                        })
                    })
                ]
            })
        ]
    });
};


var $9b17f3fb339abf2a$exports = {};

$parcel$export($9b17f3fb339abf2a$exports, "badge", () => $9b17f3fb339abf2a$export$4aebd143f31d0c0d, (v) => $9b17f3fb339abf2a$export$4aebd143f31d0c0d = v);
$parcel$export($9b17f3fb339abf2a$exports, "chest", () => $9b17f3fb339abf2a$export$11c092ac8d4e295c, (v) => $9b17f3fb339abf2a$export$11c092ac8d4e295c = v);
$parcel$export($9b17f3fb339abf2a$exports, "chest-container", () => $9b17f3fb339abf2a$export$ad06d95ce12214f1, (v) => $9b17f3fb339abf2a$export$ad06d95ce12214f1 = v);
$parcel$export($9b17f3fb339abf2a$exports, "chests", () => $9b17f3fb339abf2a$export$ff298d49dd5478e3, (v) => $9b17f3fb339abf2a$export$ff298d49dd5478e3 = v);
$parcel$export($9b17f3fb339abf2a$exports, "countdown", () => $9b17f3fb339abf2a$export$f52e29715bba3529, (v) => $9b17f3fb339abf2a$export$f52e29715bba3529 = v);
$parcel$export($9b17f3fb339abf2a$exports, "empty", () => $9b17f3fb339abf2a$export$6e22c362a0406a2c, (v) => $9b17f3fb339abf2a$export$6e22c362a0406a2c = v);
$parcel$export($9b17f3fb339abf2a$exports, "green", () => $9b17f3fb339abf2a$export$955a2ebd2fb142ae, (v) => $9b17f3fb339abf2a$export$955a2ebd2fb142ae = v);
$parcel$export($9b17f3fb339abf2a$exports, "hover", () => $9b17f3fb339abf2a$export$3f60957f5dbf3876, (v) => $9b17f3fb339abf2a$export$3f60957f5dbf3876 = v);
$parcel$export($9b17f3fb339abf2a$exports, "image", () => $9b17f3fb339abf2a$export$5c452ff88e35e47d, (v) => $9b17f3fb339abf2a$export$5c452ff88e35e47d = v);
$parcel$export($9b17f3fb339abf2a$exports, "light", () => $9b17f3fb339abf2a$export$a43af521ac8c3202, (v) => $9b17f3fb339abf2a$export$a43af521ac8c3202 = v);
$parcel$export($9b17f3fb339abf2a$exports, "open-now", () => $9b17f3fb339abf2a$export$1917ec3a354d62d9, (v) => $9b17f3fb339abf2a$export$1917ec3a354d62d9 = v);
$parcel$export($9b17f3fb339abf2a$exports, "open-slot", () => $9b17f3fb339abf2a$export$8a6574a0e88d5342, (v) => $9b17f3fb339abf2a$export$8a6574a0e88d5342 = v);
$parcel$export($9b17f3fb339abf2a$exports, "pink", () => $9b17f3fb339abf2a$export$47853bc718611763, (v) => $9b17f3fb339abf2a$export$47853bc718611763 = v);
$parcel$export($9b17f3fb339abf2a$exports, "price", () => $9b17f3fb339abf2a$export$321c0b1a406de31f, (v) => $9b17f3fb339abf2a$export$321c0b1a406de31f = v);
$parcel$export($9b17f3fb339abf2a$exports, "rotating", () => $9b17f3fb339abf2a$export$bfd64c937657f93a, (v) => $9b17f3fb339abf2a$export$bfd64c937657f93a = v);
$parcel$export($9b17f3fb339abf2a$exports, "selected-chest", () => $9b17f3fb339abf2a$export$56cb094bda6bc914, (v) => $9b17f3fb339abf2a$export$56cb094bda6bc914 = v);
$parcel$export($9b17f3fb339abf2a$exports, "timer", () => $9b17f3fb339abf2a$export$9dc4ecf953986f04, (v) => $9b17f3fb339abf2a$export$9dc4ecf953986f04 = v);
$parcel$export($9b17f3fb339abf2a$exports, "violet", () => $9b17f3fb339abf2a$export$8241b7126941c403, (v) => $9b17f3fb339abf2a$export$8241b7126941c403 = v);
$parcel$export($9b17f3fb339abf2a$exports, "yellow", () => $9b17f3fb339abf2a$export$594c5a8758200c32, (v) => $9b17f3fb339abf2a$export$594c5a8758200c32 = v);
var $9b17f3fb339abf2a$export$4aebd143f31d0c0d;
var $9b17f3fb339abf2a$export$11c092ac8d4e295c;
var $9b17f3fb339abf2a$export$ad06d95ce12214f1;
var $9b17f3fb339abf2a$export$ff298d49dd5478e3;
var $9b17f3fb339abf2a$export$f52e29715bba3529;
var $9b17f3fb339abf2a$export$6e22c362a0406a2c;
var $9b17f3fb339abf2a$export$955a2ebd2fb142ae;
var $9b17f3fb339abf2a$export$3f60957f5dbf3876;
var $9b17f3fb339abf2a$export$5c452ff88e35e47d;
var $9b17f3fb339abf2a$export$a43af521ac8c3202;
var $9b17f3fb339abf2a$export$1917ec3a354d62d9;
var $9b17f3fb339abf2a$export$8a6574a0e88d5342;
var $9b17f3fb339abf2a$export$47853bc718611763;
var $9b17f3fb339abf2a$export$321c0b1a406de31f;
var $9b17f3fb339abf2a$export$bfd64c937657f93a;
var $9b17f3fb339abf2a$export$56cb094bda6bc914;
var $9b17f3fb339abf2a$export$9dc4ecf953986f04;
var $9b17f3fb339abf2a$export$8241b7126941c403;
var $9b17f3fb339abf2a$export$594c5a8758200c32;
$9b17f3fb339abf2a$export$4aebd143f31d0c0d = `jbNodq_badge`;
$9b17f3fb339abf2a$export$11c092ac8d4e295c = `jbNodq_chest`;
$9b17f3fb339abf2a$export$ad06d95ce12214f1 = `jbNodq_chest-container`;
$9b17f3fb339abf2a$export$ff298d49dd5478e3 = `jbNodq_chests`;
$9b17f3fb339abf2a$export$f52e29715bba3529 = `jbNodq_countdown`;
$9b17f3fb339abf2a$export$6e22c362a0406a2c = `jbNodq_empty`;
$9b17f3fb339abf2a$export$955a2ebd2fb142ae = `jbNodq_green`;
$9b17f3fb339abf2a$export$3f60957f5dbf3876 = `jbNodq_hover`;
$9b17f3fb339abf2a$export$5c452ff88e35e47d = `jbNodq_image`;
$9b17f3fb339abf2a$export$a43af521ac8c3202 = `jbNodq_light`;
$9b17f3fb339abf2a$export$1917ec3a354d62d9 = `jbNodq_open-now`;
$9b17f3fb339abf2a$export$8a6574a0e88d5342 = `jbNodq_open-slot`;
$9b17f3fb339abf2a$export$47853bc718611763 = `jbNodq_pink`;
$9b17f3fb339abf2a$export$321c0b1a406de31f = `jbNodq_price`;
$9b17f3fb339abf2a$export$bfd64c937657f93a = `jbNodq_rotating`;
$9b17f3fb339abf2a$export$bfd64c937657f93a;
$9b17f3fb339abf2a$export$56cb094bda6bc914 = `jbNodq_selected-chest`;
$9b17f3fb339abf2a$export$9dc4ecf953986f04 = `jbNodq_timer`;
$9b17f3fb339abf2a$export$8241b7126941c403 = `jbNodq_violet`;
$9b17f3fb339abf2a$export$594c5a8758200c32 = `jbNodq_yellow`;


const $b66fc98e4eed8243$var$addZeroToNumber = (number)=>number < 10 ? `0${number}` : number;
const $b66fc98e4eed8243$var$renderer = ({ days: days, hours: hours, minutes: minutes })=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
        children: [
            $b66fc98e4eed8243$var$addZeroToNumber(hours + days * 24),
            "H",
            $b66fc98e4eed8243$var$addZeroToNumber(minutes),
            "M"
        ]
    });
const $b66fc98e4eed8243$var$emptyChests = {
    0: {
        unlocked: false,
        cost: {
            gems: 250
        }
    },
    1: {
        unlocked: false,
        cost: {
            gems: 250
        }
    },
    2: {
        unlocked: false,
        cost: {
            gems: 250
        }
    },
    3: {
        unlocked: false,
        cost: {
            gems: 250
        }
    }
};
const $b66fc98e4eed8243$export$64b16c65d143d94d = {
    [(0, $49736469f58fc92b$export$f33286854e75f828).Common]: "yellow",
    [(0, $49736469f58fc92b$export$f33286854e75f828).Rare]: "pink",
    [(0, $49736469f58fc92b$export$f33286854e75f828).Fabled]: "violet",
    [(0, $49736469f58fc92b$export$f33286854e75f828).Zombie]: "green"
};
const $b66fc98e4eed8243$export$ca8dc42bbb6f2e22 = ({ className: className, onPointerOver: onPointerOver, onPointerUp: onPointerUp, ...props })=>{
    const { state: { accountInfo: accountInfo } } = (0, $c25623cc446ec3c6$export$ac8576a9912be18c)();
    const [selectedChestIndex, setSelectedChestIndex] = (0, $acw62.useState)(0);
    const [selectedChest, setSelectedChest] = (0, $acw62.useState)();
    const [showBuyChest, setShowBuyChest] = (0, $acw62.useState)(false);
    const [selectedSlotId, setSelectedSlotId] = (0, $acw62.useState)();
    const chests = accountInfo?.chests ?? $b66fc98e4eed8243$var$emptyChests;
    const onPointerOverPrepared = (event)=>{
        if (onPointerOver) onPointerOver(event);
        (0, $0c69c9c512bb7a3f$export$2b20361d967f09eb).play();
    };
    const onPointerUpPrepared = (event, chest, index)=>{
        if (onPointerUp) onPointerUp(event);
        if (chest.type) {
            setSelectedChestIndex(index);
            setSelectedChest(chest);
            (0, $0c69c9c512bb7a3f$export$4db563113ca18f41).play();
        } else if (!chest.unlocked) {
            setSelectedSlotId(index);
            setShowBuyChest(true);
            (0, $0c69c9c512bb7a3f$export$4db563113ca18f41).play();
        } else (0, $0c69c9c512bb7a3f$export$cf053497c941917c).play();
    };
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
        children: [
            selectedChest && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $dbf74f74fe2c2ca0$export$d2000f524695a9a0), {
                onHide: ()=>setSelectedChest(undefined),
                index: selectedChestIndex,
                chest: selectedChest,
                className: (0, $9805619f03ed02ef$export$91884aa883243770)((0, (/*@__PURE__*/$parcel$interopDefault($9b17f3fb339abf2a$exports))), "selected-chest")
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7443e6aa543aa526$export$cf8bd5e2833e0c24), {
                show: showBuyChest,
                chestSlotId: selectedSlotId,
                onClose: ()=>setShowBuyChest(false)
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: (0, $9805619f03ed02ef$export$91884aa883243770)((0, (/*@__PURE__*/$parcel$interopDefault($9b17f3fb339abf2a$exports))), `chests ${className}`),
                ...props,
                children: Object.values(chests).map((chest, index)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: (0, $9805619f03ed02ef$export$91884aa883243770)((0, (/*@__PURE__*/$parcel$interopDefault($9b17f3fb339abf2a$exports))), `chest ${chest?.type ? $b66fc98e4eed8243$export$64b16c65d143d94d[chest.type] : "empty"}`),
                        onPointerUp: (event)=>onPointerUpPrepared(event, chest, index),
                        onPointerOver: onPointerOverPrepared,
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                className: (0, $9805619f03ed02ef$export$91884aa883243770)((0, (/*@__PURE__*/$parcel$interopDefault($9b17f3fb339abf2a$exports))), "chest-container"),
                                children: chest?.unlocked ? chest.type ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $acw62.Fragment), {
                                    children: [
                                        chest.timer !== undefined && chest.timer > Date.now() - 86400000 && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                            className: (0, $9805619f03ed02ef$export$91884aa883243770)((0, (/*@__PURE__*/$parcel$interopDefault($9b17f3fb339abf2a$exports))), "timer"),
                                            children: [
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                                                    className: (0, $9805619f03ed02ef$export$91884aa883243770)((0, (/*@__PURE__*/$parcel$interopDefault($9b17f3fb339abf2a$exports))), "lock"),
                                                    src: `${(0, $0426e2dd5e0de94d$export$24af3971dd36b33f)}/ui/lock.png`,
                                                    alt: "lock"
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                    className: (0, $9805619f03ed02ef$export$91884aa883243770)((0, (/*@__PURE__*/$parcel$interopDefault($9b17f3fb339abf2a$exports))), "countdown"),
                                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $ftY1i.default), {
                                                        date: chest.timer + 86400000,
                                                        renderer: $b66fc98e4eed8243$var$renderer
                                                    })
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $e2407f67ab2c799c$export$37acb3580601e69a), {
                                            className: `${$b66fc98e4eed8243$export$64b16c65d143d94d[chest.type]} ${(0, $9805619f03ed02ef$export$91884aa883243770)((0, (/*@__PURE__*/$parcel$interopDefault($9b17f3fb339abf2a$exports))), "badge")}`,
                                            children: chest.type
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                                            className: (0, $9805619f03ed02ef$export$91884aa883243770)((0, (/*@__PURE__*/$parcel$interopDefault($9b17f3fb339abf2a$exports))), "light"),
                                            src: `${(0, $0426e2dd5e0de94d$export$24af3971dd36b33f)}/ui/star-light.png`,
                                            alt: "light"
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                                            className: (0, $9805619f03ed02ef$export$91884aa883243770)((0, (/*@__PURE__*/$parcel$interopDefault($9b17f3fb339abf2a$exports))), "image"),
                                            src: `${(0, $0426e2dd5e0de94d$export$24af3971dd36b33f)}/ui/chests/${chest.type}-chest.png`,
                                            alt: `${chest.type}-chest`
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                            className: (0, $9805619f03ed02ef$export$91884aa883243770)((0, (/*@__PURE__*/$parcel$interopDefault($9b17f3fb339abf2a$exports))), "open-now"),
                                            children: "OPEN NOW"
                                        })
                                    ]
                                }, `chest-container-${index}`) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $acw62.Fragment), {
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                                            className: (0, $9805619f03ed02ef$export$91884aa883243770)((0, (/*@__PURE__*/$parcel$interopDefault($9b17f3fb339abf2a$exports))), "image"),
                                            src: `${(0, $0426e2dd5e0de94d$export$24af3971dd36b33f)}/ui/empty-chest.png`,
                                            alt: "empty-chest"
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                            className: (0, $9805619f03ed02ef$export$91884aa883243770)((0, (/*@__PURE__*/$parcel$interopDefault($9b17f3fb339abf2a$exports))), "open-slot"),
                                            children: "EMPTY"
                                        })
                                    ]
                                }, `chest-${index}`) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $acw62.Fragment), {
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                                            className: (0, $9805619f03ed02ef$export$91884aa883243770)((0, (/*@__PURE__*/$parcel$interopDefault($9b17f3fb339abf2a$exports))), "image"),
                                            src: `${(0, $0426e2dd5e0de94d$export$24af3971dd36b33f)}/ui/empty-chest.png`,
                                            alt: "empty-chest"
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                            className: (0, $9805619f03ed02ef$export$91884aa883243770)((0, (/*@__PURE__*/$parcel$interopDefault($9b17f3fb339abf2a$exports))), "open-slot"),
                                            children: "OPEN NEW CHEST SLOT"
                                        })
                                    ]
                                }, `chest-${index}`)
                            }),
                            chest.cost && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: (0, $9805619f03ed02ef$export$91884aa883243770)((0, (/*@__PURE__*/$parcel$interopDefault($9b17f3fb339abf2a$exports))), "price"),
                                children: [
                                    chest.cost?.gems !== undefined && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                                                src: `${(0, $0426e2dd5e0de94d$export$24af3971dd36b33f)}/ui/gem.png`,
                                                alt: "gem"
                                            }),
                                            chest.cost.gems
                                        ]
                                    }),
                                    chest.cost?.gems !== undefined && chest.cost.sol !== undefined && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                        children: "+"
                                    }),
                                    chest.cost?.sol !== undefined && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                                                src: `${(0, $0426e2dd5e0de94d$export$24af3971dd36b33f)}/ui/sol.png`,
                                                alt: "sol"
                                            }),
                                            chest.cost.sol
                                        ]
                                    })
                                ]
                            })
                        ]
                    }, `chest-${index}`))
            })
        ]
    });
};




parcelRequire("acw62");



var $e0e4e4ddabb34d0f$exports = {};

$parcel$export($e0e4e4ddabb34d0f$exports, "button-container", () => $e0e4e4ddabb34d0f$export$4f7a98834621a1a, (v) => $e0e4e4ddabb34d0f$export$4f7a98834621a1a = v);
$parcel$export($e0e4e4ddabb34d0f$exports, "buy", () => $e0e4e4ddabb34d0f$export$7f8e2b98eca5a7f0, (v) => $e0e4e4ddabb34d0f$export$7f8e2b98eca5a7f0 = v);
$parcel$export($e0e4e4ddabb34d0f$exports, "content", () => $e0e4e4ddabb34d0f$export$a7db06668cad9adb, (v) => $e0e4e4ddabb34d0f$export$a7db06668cad9adb = v);
$parcel$export($e0e4e4ddabb34d0f$exports, "holder", () => $e0e4e4ddabb34d0f$export$f57c6e831b0d072a, (v) => $e0e4e4ddabb34d0f$export$f57c6e831b0d072a = v);
$parcel$export($e0e4e4ddabb34d0f$exports, "image", () => $e0e4e4ddabb34d0f$export$5c452ff88e35e47d, (v) => $e0e4e4ddabb34d0f$export$5c452ff88e35e47d = v);
$parcel$export($e0e4e4ddabb34d0f$exports, "public", () => $e0e4e4ddabb34d0f$export$a786b833ca8bc8ec, (v) => $e0e4e4ddabb34d0f$export$a786b833ca8bc8ec = v);
$parcel$export($e0e4e4ddabb34d0f$exports, "title", () => $e0e4e4ddabb34d0f$export$fb184b623420d9be, (v) => $e0e4e4ddabb34d0f$export$fb184b623420d9be = v);
$parcel$export($e0e4e4ddabb34d0f$exports, "weekly-prize-menu", () => $e0e4e4ddabb34d0f$export$45fee011cc8bf235, (v) => $e0e4e4ddabb34d0f$export$45fee011cc8bf235 = v);
var $e0e4e4ddabb34d0f$export$4f7a98834621a1a;
var $e0e4e4ddabb34d0f$export$7f8e2b98eca5a7f0;
var $e0e4e4ddabb34d0f$export$a7db06668cad9adb;
var $e0e4e4ddabb34d0f$export$f57c6e831b0d072a;
var $e0e4e4ddabb34d0f$export$5c452ff88e35e47d;
var $e0e4e4ddabb34d0f$export$a786b833ca8bc8ec;
var $e0e4e4ddabb34d0f$export$fb184b623420d9be;
var $e0e4e4ddabb34d0f$export$45fee011cc8bf235;
$e0e4e4ddabb34d0f$export$4f7a98834621a1a = `chAQta_button-container`;
$e0e4e4ddabb34d0f$export$7f8e2b98eca5a7f0 = `chAQta_buy`;
$e0e4e4ddabb34d0f$export$a7db06668cad9adb = `chAQta_content`;
$e0e4e4ddabb34d0f$export$f57c6e831b0d072a = `chAQta_holder`;
$e0e4e4ddabb34d0f$export$5c452ff88e35e47d = `chAQta_image`;
$e0e4e4ddabb34d0f$export$a786b833ca8bc8ec = `chAQta_public`;
$e0e4e4ddabb34d0f$export$fb184b623420d9be = `chAQta_title`;
$e0e4e4ddabb34d0f$export$45fee011cc8bf235 = `chAQta_weekly-prize-menu`;


const $4dcf018e9a053e67$var$Content = ({ openPublic: openPublic, openHolder: openHolder, onClose: onClose })=>{
    const launchPublic = async ()=>{
        openPublic();
        onClose();
    };
    const launchHolder = ()=>{
        openHolder();
        onClose();
    };
    const tensor = ()=>{
        const params = [
            "height=" + screen.height,
            "width=" + screen.width,
            "fullscreen=yes"
        ].join(",");
        window.open("https://www.tensor.trade/trade/oogy", undefined, params);
    };
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: (0, $9805619f03ed02ef$export$91884aa883243770)((0, (/*@__PURE__*/$parcel$interopDefault($e0e4e4ddabb34d0f$exports))), "content"),
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: (0, $9805619f03ed02ef$export$91884aa883243770)((0, (/*@__PURE__*/$parcel$interopDefault($e0e4e4ddabb34d0f$exports))), "holder"),
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        className: (0, $9805619f03ed02ef$export$91884aa883243770)((0, (/*@__PURE__*/$parcel$interopDefault($e0e4e4ddabb34d0f$exports))), "image"),
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                            src: `${(0, $0426e2dd5e0de94d$export$24af3971dd36b33f)}/ui/multi-mode.png`,
                            alt: "holder"
                        })
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        className: (0, $9805619f03ed02ef$export$91884aa883243770)((0, (/*@__PURE__*/$parcel$interopDefault($e0e4e4ddabb34d0f$exports))), "button-container"),
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $6725244138e0595f$export$353f5b6fc5456de1), {
                            onClick: launchHolder,
                            children: "holder"
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: (0, $9805619f03ed02ef$export$91884aa883243770)((0, (/*@__PURE__*/$parcel$interopDefault($e0e4e4ddabb34d0f$exports))), "public"),
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        className: (0, $9805619f03ed02ef$export$91884aa883243770)((0, (/*@__PURE__*/$parcel$interopDefault($e0e4e4ddabb34d0f$exports))), "image"),
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                            src: `${(0, $0426e2dd5e0de94d$export$24af3971dd36b33f)}/ui/weekly-prize-public.png`,
                            alt: "public"
                        })
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        className: (0, $9805619f03ed02ef$export$91884aa883243770)((0, (/*@__PURE__*/$parcel$interopDefault($e0e4e4ddabb34d0f$exports))), "button-container"),
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $6725244138e0595f$export$353f5b6fc5456de1), {
                            className: "violet",
                            onClick: launchPublic,
                            children: "public"
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $6725244138e0595f$export$353f5b6fc5456de1), {
                className: (0, $9805619f03ed02ef$export$91884aa883243770)((0, (/*@__PURE__*/$parcel$interopDefault($e0e4e4ddabb34d0f$exports))), "violet buy"),
                onClick: tensor,
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                        src: `${(0, $0426e2dd5e0de94d$export$24af3971dd36b33f)}/ui/tensor.png`,
                        alt: "tensor"
                    }),
                    " BUY OOGY"
                ]
            })
        ]
    });
};
const $4dcf018e9a053e67$var$Title = ({ onClose: onClose })=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: (0, $9805619f03ed02ef$export$91884aa883243770)((0, (/*@__PURE__*/$parcel$interopDefault($e0e4e4ddabb34d0f$exports))), "title"),
        children: [
            "Weekly Prizes",
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                src: `${(0, $0426e2dd5e0de94d$export$24af3971dd36b33f)}/ui/cross.png`,
                alt: "cross",
                onClick: onClose
            })
        ]
    });
const $4dcf018e9a053e67$export$ffcb39df7ef525c5 = ({ className: className, onClose: onClose, openPublic: openPublic, openHolder: openHolder, show: show, ...props })=>{
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $207d23274fe2be11$export$6e63c1000ecf9db8), {
        className: (0, $9805619f03ed02ef$export$91884aa883243770)((0, (/*@__PURE__*/$parcel$interopDefault($e0e4e4ddabb34d0f$exports))), `weekly-prize-menu ${className}`),
        title: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($4dcf018e9a053e67$var$Title, {
            onClose: onClose
        }),
        content: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($4dcf018e9a053e67$var$Content, {
            openPublic: openPublic,
            openHolder: openHolder,
            onClose: onClose
        }),
        onClickBackground: onClose,
        show: show,
        ...props
    });
};


var $b1c12edd46ef2e0d$exports = {};

$parcel$export($b1c12edd46ef2e0d$exports, "battle", () => $b1c12edd46ef2e0d$export$aa87b6293616fca4, (v) => $b1c12edd46ef2e0d$export$aa87b6293616fca4 = v);
$parcel$export($b1c12edd46ef2e0d$exports, "battle-tab", () => $b1c12edd46ef2e0d$export$7512727a18faa47c, (v) => $b1c12edd46ef2e0d$export$7512727a18faa47c = v);
$parcel$export($b1c12edd46ef2e0d$exports, "bounce", () => $b1c12edd46ef2e0d$export$e3ce947fb98643bf, (v) => $b1c12edd46ef2e0d$export$e3ce947fb98643bf = v);
$parcel$export($b1c12edd46ef2e0d$exports, "bounceIn", () => $b1c12edd46ef2e0d$export$fccebd7948554554, (v) => $b1c12edd46ef2e0d$export$fccebd7948554554 = v);
$parcel$export($b1c12edd46ef2e0d$exports, "chests", () => $b1c12edd46ef2e0d$export$ff298d49dd5478e3, (v) => $b1c12edd46ef2e0d$export$ff298d49dd5478e3 = v);
$parcel$export($b1c12edd46ef2e0d$exports, "content", () => $b1c12edd46ef2e0d$export$a7db06668cad9adb, (v) => $b1c12edd46ef2e0d$export$a7db06668cad9adb = v);
$parcel$export($b1c12edd46ef2e0d$exports, "daily-rewards-modal", () => $b1c12edd46ef2e0d$export$6c44c86c3f21c8a7, (v) => $b1c12edd46ef2e0d$export$6c44c86c3f21c8a7 = v);
$parcel$export($b1c12edd46ef2e0d$exports, "description", () => $b1c12edd46ef2e0d$export$6d59db4903f20f7d, (v) => $b1c12edd46ef2e0d$export$6d59db4903f20f7d = v);
$parcel$export($b1c12edd46ef2e0d$exports, "icon", () => $b1c12edd46ef2e0d$export$1ca1ec8b29a4ce27, (v) => $b1c12edd46ef2e0d$export$1ca1ec8b29a4ce27 = v);
$parcel$export($b1c12edd46ef2e0d$exports, "monster", () => $b1c12edd46ef2e0d$export$17a41932ecd798ec, (v) => $b1c12edd46ef2e0d$export$17a41932ecd798ec = v);
$parcel$export($b1c12edd46ef2e0d$exports, "particles", () => $b1c12edd46ef2e0d$export$2096b54ada1e6fa4, (v) => $b1c12edd46ef2e0d$export$2096b54ada1e6fa4 = v);
$parcel$export($b1c12edd46ef2e0d$exports, "player", () => $b1c12edd46ef2e0d$export$615455393ee443ca, (v) => $b1c12edd46ef2e0d$export$615455393ee443ca = v);
$parcel$export($b1c12edd46ef2e0d$exports, "pulse", () => $b1c12edd46ef2e0d$export$f3aaf94dc96a60de, (v) => $b1c12edd46ef2e0d$export$f3aaf94dc96a60de = v);
$parcel$export($b1c12edd46ef2e0d$exports, "pulseButton", () => $b1c12edd46ef2e0d$export$daa0506c82a4914d, (v) => $b1c12edd46ef2e0d$export$daa0506c82a4914d = v);
$parcel$export($b1c12edd46ef2e0d$exports, "rewards", () => $b1c12edd46ef2e0d$export$4b2cb815b21f438d, (v) => $b1c12edd46ef2e0d$export$4b2cb815b21f438d = v);
$parcel$export($b1c12edd46ef2e0d$exports, "tile", () => $b1c12edd46ef2e0d$export$3c17558da18e4d75, (v) => $b1c12edd46ef2e0d$export$3c17558da18e4d75 = v);
$parcel$export($b1c12edd46ef2e0d$exports, "title", () => $b1c12edd46ef2e0d$export$fb184b623420d9be, (v) => $b1c12edd46ef2e0d$export$fb184b623420d9be = v);
$parcel$export($b1c12edd46ef2e0d$exports, "top-line", () => $b1c12edd46ef2e0d$export$63fd42f86387895b, (v) => $b1c12edd46ef2e0d$export$63fd42f86387895b = v);
var $b1c12edd46ef2e0d$export$aa87b6293616fca4;
var $b1c12edd46ef2e0d$export$7512727a18faa47c;
var $b1c12edd46ef2e0d$export$e3ce947fb98643bf;
var $b1c12edd46ef2e0d$export$fccebd7948554554;
var $b1c12edd46ef2e0d$export$ff298d49dd5478e3;
var $b1c12edd46ef2e0d$export$a7db06668cad9adb;
var $b1c12edd46ef2e0d$export$6c44c86c3f21c8a7;
var $b1c12edd46ef2e0d$export$6d59db4903f20f7d;
var $b1c12edd46ef2e0d$export$1ca1ec8b29a4ce27;
var $b1c12edd46ef2e0d$export$17a41932ecd798ec;
var $b1c12edd46ef2e0d$export$2096b54ada1e6fa4;
var $b1c12edd46ef2e0d$export$615455393ee443ca;
var $b1c12edd46ef2e0d$export$f3aaf94dc96a60de;
var $b1c12edd46ef2e0d$export$daa0506c82a4914d;
var $b1c12edd46ef2e0d$export$4b2cb815b21f438d;
var $b1c12edd46ef2e0d$export$3c17558da18e4d75;
var $b1c12edd46ef2e0d$export$fb184b623420d9be;
var $b1c12edd46ef2e0d$export$63fd42f86387895b;
$b1c12edd46ef2e0d$export$aa87b6293616fca4 = `Z5WCxW_battle`;
$b1c12edd46ef2e0d$export$7512727a18faa47c = `Z5WCxW_battle-tab`;
$b1c12edd46ef2e0d$export$e3ce947fb98643bf = `Z5WCxW_bounce`;
$b1c12edd46ef2e0d$export$fccebd7948554554 = `Z5WCxW_bounceIn`;
$b1c12edd46ef2e0d$export$fccebd7948554554;
$b1c12edd46ef2e0d$export$ff298d49dd5478e3 = `Z5WCxW_chests`;
$b1c12edd46ef2e0d$export$a7db06668cad9adb = `Z5WCxW_content`;
$b1c12edd46ef2e0d$export$6c44c86c3f21c8a7 = `Z5WCxW_daily-rewards-modal`;
$b1c12edd46ef2e0d$export$6d59db4903f20f7d = `Z5WCxW_description`;
$b1c12edd46ef2e0d$export$1ca1ec8b29a4ce27 = `Z5WCxW_icon`;
$b1c12edd46ef2e0d$export$17a41932ecd798ec = `Z5WCxW_monster`;
$b1c12edd46ef2e0d$export$2096b54ada1e6fa4 = `Z5WCxW_particles`;
$b1c12edd46ef2e0d$export$615455393ee443ca = `Z5WCxW_player`;
$b1c12edd46ef2e0d$export$f3aaf94dc96a60de = `Z5WCxW_pulse`;
$b1c12edd46ef2e0d$export$daa0506c82a4914d = `Z5WCxW_pulseButton`;
$b1c12edd46ef2e0d$export$daa0506c82a4914d;
$b1c12edd46ef2e0d$export$4b2cb815b21f438d = `Z5WCxW_rewards`;
$b1c12edd46ef2e0d$export$3c17558da18e4d75 = `Z5WCxW_tile`;
$b1c12edd46ef2e0d$export$fb184b623420d9be = `Z5WCxW_title`;
$b1c12edd46ef2e0d$export$63fd42f86387895b = `Z5WCxW_top-line`;





var $acw62 = parcelRequire("acw62");




var $d9f2f4006bcf92f5$exports = {};

$parcel$export($d9f2f4006bcf92f5$exports, "active", () => $d9f2f4006bcf92f5$export$89da14300d534261, (v) => $d9f2f4006bcf92f5$export$89da14300d534261 = v);
$parcel$export($d9f2f4006bcf92f5$exports, "calendar", () => $d9f2f4006bcf92f5$export$56bbcdb8aca31149, (v) => $d9f2f4006bcf92f5$export$56bbcdb8aca31149 = v);
$parcel$export($d9f2f4006bcf92f5$exports, "circle", () => $d9f2f4006bcf92f5$export$e1d786d2f707b414, (v) => $d9f2f4006bcf92f5$export$e1d786d2f707b414 = v);
$parcel$export($d9f2f4006bcf92f5$exports, "content", () => $d9f2f4006bcf92f5$export$a7db06668cad9adb, (v) => $d9f2f4006bcf92f5$export$a7db06668cad9adb = v);
$parcel$export($d9f2f4006bcf92f5$exports, "daily-rewards", () => $d9f2f4006bcf92f5$export$f1b9a94af9ce1a7d, (v) => $d9f2f4006bcf92f5$export$f1b9a94af9ce1a7d = v);
$parcel$export($d9f2f4006bcf92f5$exports, "day", () => $d9f2f4006bcf92f5$export$d2d39d1adcc883a2, (v) => $d9f2f4006bcf92f5$export$d2d39d1adcc883a2 = v);
$parcel$export($d9f2f4006bcf92f5$exports, "end", () => $d9f2f4006bcf92f5$export$bd5df0f255a350f8, (v) => $d9f2f4006bcf92f5$export$bd5df0f255a350f8 = v);
$parcel$export($d9f2f4006bcf92f5$exports, "gems", () => $d9f2f4006bcf92f5$export$b7dcc03c39461775, (v) => $d9f2f4006bcf92f5$export$b7dcc03c39461775 = v);
$parcel$export($d9f2f4006bcf92f5$exports, "hidden", () => $d9f2f4006bcf92f5$export$73920f18ca706874, (v) => $d9f2f4006bcf92f5$export$73920f18ca706874 = v);
$parcel$export($d9f2f4006bcf92f5$exports, "label", () => $d9f2f4006bcf92f5$export$1237798dc640739a, (v) => $d9f2f4006bcf92f5$export$1237798dc640739a = v);
$parcel$export($d9f2f4006bcf92f5$exports, "line", () => $d9f2f4006bcf92f5$export$53f1d5ea8de3d7c, (v) => $d9f2f4006bcf92f5$export$53f1d5ea8de3d7c = v);
$parcel$export($d9f2f4006bcf92f5$exports, "separator-h", () => $d9f2f4006bcf92f5$export$e2f8ba4fc8c00a88, (v) => $d9f2f4006bcf92f5$export$e2f8ba4fc8c00a88 = v);
$parcel$export($d9f2f4006bcf92f5$exports, "separator-v", () => $d9f2f4006bcf92f5$export$aee5f53dd4cc63f0, (v) => $d9f2f4006bcf92f5$export$aee5f53dd4cc63f0 = v);
$parcel$export($d9f2f4006bcf92f5$exports, "shinny", () => $d9f2f4006bcf92f5$export$1ba166ff5709f80d, (v) => $d9f2f4006bcf92f5$export$1ba166ff5709f80d = v);
$parcel$export($d9f2f4006bcf92f5$exports, "title", () => $d9f2f4006bcf92f5$export$fb184b623420d9be, (v) => $d9f2f4006bcf92f5$export$fb184b623420d9be = v);
var $d9f2f4006bcf92f5$export$89da14300d534261;
var $d9f2f4006bcf92f5$export$56bbcdb8aca31149;
var $d9f2f4006bcf92f5$export$e1d786d2f707b414;
var $d9f2f4006bcf92f5$export$a7db06668cad9adb;
var $d9f2f4006bcf92f5$export$f1b9a94af9ce1a7d;
var $d9f2f4006bcf92f5$export$d2d39d1adcc883a2;
var $d9f2f4006bcf92f5$export$bd5df0f255a350f8;
var $d9f2f4006bcf92f5$export$b7dcc03c39461775;
var $d9f2f4006bcf92f5$export$73920f18ca706874;
var $d9f2f4006bcf92f5$export$1237798dc640739a;
var $d9f2f4006bcf92f5$export$53f1d5ea8de3d7c;
var $d9f2f4006bcf92f5$export$e2f8ba4fc8c00a88;
var $d9f2f4006bcf92f5$export$aee5f53dd4cc63f0;
var $d9f2f4006bcf92f5$export$1ba166ff5709f80d;
var $d9f2f4006bcf92f5$export$fb184b623420d9be;
$d9f2f4006bcf92f5$export$89da14300d534261 = `STK3LW_active`;
$d9f2f4006bcf92f5$export$56bbcdb8aca31149 = `STK3LW_calendar`;
$d9f2f4006bcf92f5$export$e1d786d2f707b414 = `STK3LW_circle`;
$d9f2f4006bcf92f5$export$a7db06668cad9adb = `STK3LW_content`;
$d9f2f4006bcf92f5$export$f1b9a94af9ce1a7d = `STK3LW_daily-rewards`;
$d9f2f4006bcf92f5$export$d2d39d1adcc883a2 = `STK3LW_day`;
$d9f2f4006bcf92f5$export$bd5df0f255a350f8 = `STK3LW_end`;
$d9f2f4006bcf92f5$export$b7dcc03c39461775 = `STK3LW_gems`;
$d9f2f4006bcf92f5$export$73920f18ca706874 = `STK3LW_hidden`;
$d9f2f4006bcf92f5$export$1237798dc640739a = `STK3LW_label`;
$d9f2f4006bcf92f5$export$53f1d5ea8de3d7c = `STK3LW_line`;
$d9f2f4006bcf92f5$export$e2f8ba4fc8c00a88 = `STK3LW_separator-h`;
$d9f2f4006bcf92f5$export$aee5f53dd4cc63f0 = `STK3LW_separator-v`;
$d9f2f4006bcf92f5$export$1ba166ff5709f80d = `STK3LW_shinny`;
$d9f2f4006bcf92f5$export$fb184b623420d9be = `STK3LW_title`;


const $c7c68647d2f2d9c7$var$SVG = ()=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "17",
        height: "13",
        viewBox: "0 0 17 13",
        fill: "none",
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M6.11022 12.531C5.77364 12.531 5.45389 12.3964 5.21828 12.1608L0.455633 7.39815C-0.0324116 6.9101 -0.0324116 6.1023 0.455633 5.61426C0.943678 5.12621 1.75148 5.12621 2.23952 5.61426L6.11022 9.48496L14.7604 0.834784C15.2484 0.346739 16.0562 0.346739 16.5443 0.834784C17.0323 1.32283 17.0323 2.13063 16.5443 2.61867L7.00217 12.1608C6.76656 12.3964 6.44681 12.531 6.11022 12.531Z",
            fill: "white"
        })
    });
const $c7c68647d2f2d9c7$var$Content = ()=>{
    const { state: { accountInfo: accountInfo } } = (0, $c25623cc446ec3c6$export$ac8576a9912be18c)();
    const [data, setData] = (0, $acw62.useState)();
    (0, $acw62.useEffect)(()=>{
        (async ()=>{
            setData(await (0, $294c300caaab742a$export$9a11c4d521627ff7)());
        })();
    }, []);
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: (0, $9805619f03ed02ef$export$91884aa883243770)((0, (/*@__PURE__*/$parcel$interopDefault($d9f2f4006bcf92f5$exports))), "content"),
        children: [
            "earn extra gems by blasting everyday",
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: (0, $9805619f03ed02ef$export$91884aa883243770)((0, (/*@__PURE__*/$parcel$interopDefault($d9f2f4006bcf92f5$exports))), "calendar"),
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: (0, $9805619f03ed02ef$export$91884aa883243770)((0, (/*@__PURE__*/$parcel$interopDefault($d9f2f4006bcf92f5$exports))), "line"),
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                className: (0, $9805619f03ed02ef$export$91884aa883243770)((0, (/*@__PURE__*/$parcel$interopDefault($d9f2f4006bcf92f5$exports))), "day"),
                                children: "DAY 1"
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                className: (0, $9805619f03ed02ef$export$91884aa883243770)((0, (/*@__PURE__*/$parcel$interopDefault($d9f2f4006bcf92f5$exports))), "separator-h hidden")
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                className: (0, $9805619f03ed02ef$export$91884aa883243770)((0, (/*@__PURE__*/$parcel$interopDefault($d9f2f4006bcf92f5$exports))), "day"),
                                children: "DAY 2"
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                className: (0, $9805619f03ed02ef$export$91884aa883243770)((0, (/*@__PURE__*/$parcel$interopDefault($d9f2f4006bcf92f5$exports))), "separator-h hidden")
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                className: (0, $9805619f03ed02ef$export$91884aa883243770)((0, (/*@__PURE__*/$parcel$interopDefault($d9f2f4006bcf92f5$exports))), "day"),
                                children: "DAY 3"
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                className: (0, $9805619f03ed02ef$export$91884aa883243770)((0, (/*@__PURE__*/$parcel$interopDefault($d9f2f4006bcf92f5$exports))), "separator-h hidden")
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                className: (0, $9805619f03ed02ef$export$91884aa883243770)((0, (/*@__PURE__*/$parcel$interopDefault($d9f2f4006bcf92f5$exports))), "day"),
                                children: "DAY 4"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: (0, $9805619f03ed02ef$export$91884aa883243770)((0, (/*@__PURE__*/$parcel$interopDefault($d9f2f4006bcf92f5$exports))), "line"),
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: (0, $9805619f03ed02ef$export$91884aa883243770)((0, (/*@__PURE__*/$parcel$interopDefault($d9f2f4006bcf92f5$exports))), `circle ${(accountInfo?.dailyRewards.score ?? 0) >= 0 ? "active" : ""}`),
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                                        className: (0, $9805619f03ed02ef$export$91884aa883243770)((0, (/*@__PURE__*/$parcel$interopDefault($d9f2f4006bcf92f5$exports))), "gems"),
                                        src: `${(0, $0426e2dd5e0de94d$export$24af3971dd36b33f)}/ui/daily-rewards-pew.png`,
                                        alt: "daily-rewards-pew"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                        className: (0, $9805619f03ed02ef$export$91884aa883243770)((0, (/*@__PURE__*/$parcel$interopDefault($d9f2f4006bcf92f5$exports))), "label"),
                                        children: (accountInfo?.dailyRewards.score ?? 0) >= 0 ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($c7c68647d2f2d9c7$var$SVG, {}) : data ? `+${data?.rewards[0]}` : "..."
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                className: (0, $9805619f03ed02ef$export$91884aa883243770)((0, (/*@__PURE__*/$parcel$interopDefault($d9f2f4006bcf92f5$exports))), `separator-h ${(accountInfo?.dailyRewards.score ?? 0) >= 1 ? "active" : ""}`)
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: (0, $9805619f03ed02ef$export$91884aa883243770)((0, (/*@__PURE__*/$parcel$interopDefault($d9f2f4006bcf92f5$exports))), `circle ${(accountInfo?.dailyRewards.score ?? 0) >= 1 ? "active" : ""}`),
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                                        src: `${(0, $0426e2dd5e0de94d$export$24af3971dd36b33f)}/ui/gem.png`,
                                        alt: "gem"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                        className: (0, $9805619f03ed02ef$export$91884aa883243770)((0, (/*@__PURE__*/$parcel$interopDefault($d9f2f4006bcf92f5$exports))), "label"),
                                        children: (accountInfo?.dailyRewards.score ?? 0) >= 1 ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($c7c68647d2f2d9c7$var$SVG, {}) : data ? `+${data?.rewards[1]}` : "..."
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                className: (0, $9805619f03ed02ef$export$91884aa883243770)((0, (/*@__PURE__*/$parcel$interopDefault($d9f2f4006bcf92f5$exports))), `separator-h ${(accountInfo?.dailyRewards.score ?? 0) >= 2 ? "active" : ""}`)
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: (0, $9805619f03ed02ef$export$91884aa883243770)((0, (/*@__PURE__*/$parcel$interopDefault($d9f2f4006bcf92f5$exports))), `circle ${(accountInfo?.dailyRewards.score ?? 0) >= 2 ? "active" : ""}`),
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                                        src: `${(0, $0426e2dd5e0de94d$export$24af3971dd36b33f)}/ui/gem.png`,
                                        alt: "gem"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                        className: (0, $9805619f03ed02ef$export$91884aa883243770)((0, (/*@__PURE__*/$parcel$interopDefault($d9f2f4006bcf92f5$exports))), "label"),
                                        children: (accountInfo?.dailyRewards.score ?? 0) >= 2 ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($c7c68647d2f2d9c7$var$SVG, {}) : data ? `+${data?.rewards[2]}` : "..."
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                className: (0, $9805619f03ed02ef$export$91884aa883243770)((0, (/*@__PURE__*/$parcel$interopDefault($d9f2f4006bcf92f5$exports))), `separator-h ${(accountInfo?.dailyRewards.score ?? 0) >= 3 ? "active" : ""}`)
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: (0, $9805619f03ed02ef$export$91884aa883243770)((0, (/*@__PURE__*/$parcel$interopDefault($d9f2f4006bcf92f5$exports))), `circle ${(accountInfo?.dailyRewards.score ?? 0) >= 3 ? "active" : ""}`),
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                                        src: `${(0, $0426e2dd5e0de94d$export$24af3971dd36b33f)}/ui/gem.png`,
                                        alt: "gem"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                        className: (0, $9805619f03ed02ef$export$91884aa883243770)((0, (/*@__PURE__*/$parcel$interopDefault($d9f2f4006bcf92f5$exports))), "label"),
                                        children: (accountInfo?.dailyRewards.score ?? 0) >= 3 ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($c7c68647d2f2d9c7$var$SVG, {}) : data ? `+${data?.rewards[3]}` : "..."
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        className: (0, $9805619f03ed02ef$export$91884aa883243770)((0, (/*@__PURE__*/$parcel$interopDefault($d9f2f4006bcf92f5$exports))), "line end"),
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                            className: (0, $9805619f03ed02ef$export$91884aa883243770)((0, (/*@__PURE__*/$parcel$interopDefault($d9f2f4006bcf92f5$exports))), `separator-v ${(accountInfo?.dailyRewards.score ?? 0) >= 4 ? "active" : ""}`)
                        })
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: (0, $9805619f03ed02ef$export$91884aa883243770)((0, (/*@__PURE__*/$parcel$interopDefault($d9f2f4006bcf92f5$exports))), "line"),
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                className: (0, $9805619f03ed02ef$export$91884aa883243770)((0, (/*@__PURE__*/$parcel$interopDefault($d9f2f4006bcf92f5$exports))), "day"),
                                children: "DAY 8+"
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                className: (0, $9805619f03ed02ef$export$91884aa883243770)((0, (/*@__PURE__*/$parcel$interopDefault($d9f2f4006bcf92f5$exports))), "separator-h hidden")
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                className: (0, $9805619f03ed02ef$export$91884aa883243770)((0, (/*@__PURE__*/$parcel$interopDefault($d9f2f4006bcf92f5$exports))), "day"),
                                children: "DAY 7"
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                className: (0, $9805619f03ed02ef$export$91884aa883243770)((0, (/*@__PURE__*/$parcel$interopDefault($d9f2f4006bcf92f5$exports))), "separator-h hidden")
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                className: (0, $9805619f03ed02ef$export$91884aa883243770)((0, (/*@__PURE__*/$parcel$interopDefault($d9f2f4006bcf92f5$exports))), "day"),
                                children: "DAY 6"
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                className: (0, $9805619f03ed02ef$export$91884aa883243770)((0, (/*@__PURE__*/$parcel$interopDefault($d9f2f4006bcf92f5$exports))), "separator-h hidden")
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                className: (0, $9805619f03ed02ef$export$91884aa883243770)((0, (/*@__PURE__*/$parcel$interopDefault($d9f2f4006bcf92f5$exports))), "day"),
                                children: "DAY 5"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: (0, $9805619f03ed02ef$export$91884aa883243770)((0, (/*@__PURE__*/$parcel$interopDefault($d9f2f4006bcf92f5$exports))), "line"),
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: (0, $9805619f03ed02ef$export$91884aa883243770)((0, (/*@__PURE__*/$parcel$interopDefault($d9f2f4006bcf92f5$exports))), `circle ${(accountInfo?.dailyRewards.score ?? 0) >= 7 ? "active" : ""}`),
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                                        className: (0, $9805619f03ed02ef$export$91884aa883243770)((0, (/*@__PURE__*/$parcel$interopDefault($d9f2f4006bcf92f5$exports))), "shinny"),
                                        src: `${(0, $0426e2dd5e0de94d$export$24af3971dd36b33f)}/ui/daily-rewards-shinny.png`,
                                        alt: "shinny"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                                        className: (0, $9805619f03ed02ef$export$91884aa883243770)((0, (/*@__PURE__*/$parcel$interopDefault($d9f2f4006bcf92f5$exports))), "gems"),
                                        src: `${(0, $0426e2dd5e0de94d$export$24af3971dd36b33f)}/ui/gems.png`,
                                        alt: "gems"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                        className: (0, $9805619f03ed02ef$export$91884aa883243770)((0, (/*@__PURE__*/$parcel$interopDefault($d9f2f4006bcf92f5$exports))), "label"),
                                        children: (accountInfo?.dailyRewards.score ?? 0) >= 7 ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($c7c68647d2f2d9c7$var$SVG, {}) : data ? `+${data?.rewards[7]}` : "..."
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                className: (0, $9805619f03ed02ef$export$91884aa883243770)((0, (/*@__PURE__*/$parcel$interopDefault($d9f2f4006bcf92f5$exports))), `separator-h ${(accountInfo?.dailyRewards.score ?? 0) >= 7 ? "active" : ""}`)
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: (0, $9805619f03ed02ef$export$91884aa883243770)((0, (/*@__PURE__*/$parcel$interopDefault($d9f2f4006bcf92f5$exports))), `circle ${(accountInfo?.dailyRewards.score ?? 0) >= 6 ? "active" : ""}`),
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                                        className: (0, $9805619f03ed02ef$export$91884aa883243770)((0, (/*@__PURE__*/$parcel$interopDefault($d9f2f4006bcf92f5$exports))), "shinny"),
                                        src: `${(0, $0426e2dd5e0de94d$export$24af3971dd36b33f)}/ui/daily-rewards-shinny.png`,
                                        alt: "shinny"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                                        className: (0, $9805619f03ed02ef$export$91884aa883243770)((0, (/*@__PURE__*/$parcel$interopDefault($d9f2f4006bcf92f5$exports))), "gems"),
                                        src: `${(0, $0426e2dd5e0de94d$export$24af3971dd36b33f)}/ui/gems.png`,
                                        alt: "gems"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                        className: (0, $9805619f03ed02ef$export$91884aa883243770)((0, (/*@__PURE__*/$parcel$interopDefault($d9f2f4006bcf92f5$exports))), "label"),
                                        children: (accountInfo?.dailyRewards.score ?? 0) >= 6 ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($c7c68647d2f2d9c7$var$SVG, {}) : data ? `+${data?.rewards[6]}` : "..."
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                className: (0, $9805619f03ed02ef$export$91884aa883243770)((0, (/*@__PURE__*/$parcel$interopDefault($d9f2f4006bcf92f5$exports))), `separator-h ${(accountInfo?.dailyRewards.score ?? 0) >= 6 ? "active" : ""}`)
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: (0, $9805619f03ed02ef$export$91884aa883243770)((0, (/*@__PURE__*/$parcel$interopDefault($d9f2f4006bcf92f5$exports))), `circle ${(accountInfo?.dailyRewards.score ?? 0) >= 5 ? "active" : ""}`),
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                                        src: `${(0, $0426e2dd5e0de94d$export$24af3971dd36b33f)}/ui/gem.png`,
                                        alt: "gem"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                        className: (0, $9805619f03ed02ef$export$91884aa883243770)((0, (/*@__PURE__*/$parcel$interopDefault($d9f2f4006bcf92f5$exports))), "label"),
                                        children: (accountInfo?.dailyRewards.score ?? 0) >= 5 ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($c7c68647d2f2d9c7$var$SVG, {}) : data ? `+${data?.rewards[5]}` : "..."
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                className: (0, $9805619f03ed02ef$export$91884aa883243770)((0, (/*@__PURE__*/$parcel$interopDefault($d9f2f4006bcf92f5$exports))), `separator-h ${(accountInfo?.dailyRewards.score ?? 0) >= 5 ? "active" : ""}`)
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: (0, $9805619f03ed02ef$export$91884aa883243770)((0, (/*@__PURE__*/$parcel$interopDefault($d9f2f4006bcf92f5$exports))), `circle ${(accountInfo?.dailyRewards.score ?? 0) >= 4 ? "active" : ""}`),
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                                        src: `${(0, $0426e2dd5e0de94d$export$24af3971dd36b33f)}/ui/gem.png`,
                                        alt: "gem"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                        className: (0, $9805619f03ed02ef$export$91884aa883243770)((0, (/*@__PURE__*/$parcel$interopDefault($d9f2f4006bcf92f5$exports))), "label"),
                                        children: (accountInfo?.dailyRewards.score ?? 0) >= 4 ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($c7c68647d2f2d9c7$var$SVG, {}) : data ? `+${data?.rewards[4]}` : "..."
                                    })
                                ]
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
const $c7c68647d2f2d9c7$var$Title = ({ onClose: onClose })=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: (0, $9805619f03ed02ef$export$91884aa883243770)((0, (/*@__PURE__*/$parcel$interopDefault($d9f2f4006bcf92f5$exports))), "title"),
        children: [
            "Daily Rewards",
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                src: `${(0, $0426e2dd5e0de94d$export$24af3971dd36b33f)}/ui/cross.png`,
                alt: "cross",
                onClick: onClose
            })
        ]
    });
const $c7c68647d2f2d9c7$export$eed488b0019288d = ({ className: className, onClose: onClose, show: show, ...props })=>{
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $207d23274fe2be11$export$6e63c1000ecf9db8), {
        className: (0, $9805619f03ed02ef$export$91884aa883243770)((0, (/*@__PURE__*/$parcel$interopDefault($d9f2f4006bcf92f5$exports))), `daily-rewards ${className}`),
        title: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($c7c68647d2f2d9c7$var$Title, {
            onClose: onClose
        }),
        content: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($c7c68647d2f2d9c7$var$Content, {}),
        onClickBackground: onClose,
        show: show,
        ...props
    });
};





var $acw62 = parcelRequire("acw62");










parcelRequire("acw62");



var $ce5da1ed8357609e$exports = {};

$parcel$export($ce5da1ed8357609e$exports, "container", () => $ce5da1ed8357609e$export$34e0f9847d4c02dd, (v) => $ce5da1ed8357609e$export$34e0f9847d4c02dd = v);
$parcel$export($ce5da1ed8357609e$exports, "content", () => $ce5da1ed8357609e$export$a7db06668cad9adb, (v) => $ce5da1ed8357609e$export$a7db06668cad9adb = v);
$parcel$export($ce5da1ed8357609e$exports, "how-to-play", () => $ce5da1ed8357609e$export$f4e32dd80996c074, (v) => $ce5da1ed8357609e$export$f4e32dd80996c074 = v);
$parcel$export($ce5da1ed8357609e$exports, "subtitle", () => $ce5da1ed8357609e$export$c96745152eb2740f, (v) => $ce5da1ed8357609e$export$c96745152eb2740f = v);
$parcel$export($ce5da1ed8357609e$exports, "text", () => $ce5da1ed8357609e$export$6f093cfa640b7166, (v) => $ce5da1ed8357609e$export$6f093cfa640b7166 = v);
$parcel$export($ce5da1ed8357609e$exports, "title", () => $ce5da1ed8357609e$export$fb184b623420d9be, (v) => $ce5da1ed8357609e$export$fb184b623420d9be = v);
$parcel$export($ce5da1ed8357609e$exports, "tuto", () => $ce5da1ed8357609e$export$f80f432191b84d7f, (v) => $ce5da1ed8357609e$export$f80f432191b84d7f = v);
var $ce5da1ed8357609e$export$34e0f9847d4c02dd;
var $ce5da1ed8357609e$export$a7db06668cad9adb;
var $ce5da1ed8357609e$export$f4e32dd80996c074;
var $ce5da1ed8357609e$export$c96745152eb2740f;
var $ce5da1ed8357609e$export$6f093cfa640b7166;
var $ce5da1ed8357609e$export$fb184b623420d9be;
var $ce5da1ed8357609e$export$f80f432191b84d7f;
$ce5da1ed8357609e$export$34e0f9847d4c02dd = `BhWfQW_container`;
$ce5da1ed8357609e$export$a7db06668cad9adb = `BhWfQW_content`;
$ce5da1ed8357609e$export$f4e32dd80996c074 = `BhWfQW_how-to-play`;
$ce5da1ed8357609e$export$c96745152eb2740f = `BhWfQW_subtitle`;
$ce5da1ed8357609e$export$6f093cfa640b7166 = `BhWfQW_text`;
$ce5da1ed8357609e$export$fb184b623420d9be = `BhWfQW_title`;
$ce5da1ed8357609e$export$f80f432191b84d7f = `BhWfQW_tuto`;


const $389920e14c601f6f$var$Content = ({ onClose: onClose })=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: (0, $9805619f03ed02ef$export$91884aa883243770)((0, (/*@__PURE__*/$parcel$interopDefault($ce5da1ed8357609e$exports))), "content"),
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: (0, $9805619f03ed02ef$export$91884aa883243770)((0, (/*@__PURE__*/$parcel$interopDefault($ce5da1ed8357609e$exports))), "subtitle"),
                children: "Desktop"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: (0, $9805619f03ed02ef$export$91884aa883243770)((0, (/*@__PURE__*/$parcel$interopDefault($ce5da1ed8357609e$exports))), "tuto"),
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: (0, $9805619f03ed02ef$export$91884aa883243770)((0, (/*@__PURE__*/$parcel$interopDefault($ce5da1ed8357609e$exports))), "container"),
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                className: (0, $9805619f03ed02ef$export$91884aa883243770)((0, (/*@__PURE__*/$parcel$interopDefault($ce5da1ed8357609e$exports))), "text"),
                                children: "Use arrow keys to move"
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                                src: `${(0, $0426e2dd5e0de94d$export$24af3971dd36b33f)}/ui/keyboard-arrows.png`,
                                alt: "keyboard mouse"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: (0, $9805619f03ed02ef$export$91884aa883243770)((0, (/*@__PURE__*/$parcel$interopDefault($ce5da1ed8357609e$exports))), "container"),
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                className: (0, $9805619f03ed02ef$export$91884aa883243770)((0, (/*@__PURE__*/$parcel$interopDefault($ce5da1ed8357609e$exports))), "text"),
                                children: "Use mouse to aim"
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                                src: `${(0, $0426e2dd5e0de94d$export$24af3971dd36b33f)}/ui/mouse.png`,
                                alt: "mouse"
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: (0, $9805619f03ed02ef$export$91884aa883243770)((0, (/*@__PURE__*/$parcel$interopDefault($ce5da1ed8357609e$exports))), "subtitle"),
                children: "Mobile"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: (0, $9805619f03ed02ef$export$91884aa883243770)((0, (/*@__PURE__*/$parcel$interopDefault($ce5da1ed8357609e$exports))), "tuto"),
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: (0, $9805619f03ed02ef$export$91884aa883243770)((0, (/*@__PURE__*/$parcel$interopDefault($ce5da1ed8357609e$exports))), "container"),
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                className: (0, $9805619f03ed02ef$export$91884aa883243770)((0, (/*@__PURE__*/$parcel$interopDefault($ce5da1ed8357609e$exports))), "text"),
                                children: "Move with"
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                                src: `${(0, $0426e2dd5e0de94d$export$24af3971dd36b33f)}/ui/pink-stick.png`,
                                alt: "pink stick"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: (0, $9805619f03ed02ef$export$91884aa883243770)((0, (/*@__PURE__*/$parcel$interopDefault($ce5da1ed8357609e$exports))), "container"),
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                className: (0, $9805619f03ed02ef$export$91884aa883243770)((0, (/*@__PURE__*/$parcel$interopDefault($ce5da1ed8357609e$exports))), "text"),
                                children: "Aim with"
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                                src: `${(0, $0426e2dd5e0de94d$export$24af3971dd36b33f)}/ui/blue-stick.png`,
                                alt: "blue stick"
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $6725244138e0595f$export$353f5b6fc5456de1), {
                className: (0, $9805619f03ed02ef$export$91884aa883243770)((0, (/*@__PURE__*/$parcel$interopDefault($ce5da1ed8357609e$exports))), "small gray"),
                onClick: onClose,
                children: "GOT IT"
            })
        ]
    });
const $389920e14c601f6f$var$Title = ({ onClose: onClose })=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: (0, $9805619f03ed02ef$export$91884aa883243770)((0, (/*@__PURE__*/$parcel$interopDefault($ce5da1ed8357609e$exports))), "title"),
        children: [
            "How to play",
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                src: `${(0, $0426e2dd5e0de94d$export$24af3971dd36b33f)}/ui/cross.png`,
                alt: "cross",
                onClick: onClose
            })
        ]
    });
const $389920e14c601f6f$export$45c4ca16caeed66b = ({ className: className, onClose: onClose, ...props })=>{
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $207d23274fe2be11$export$6e63c1000ecf9db8), {
        className: (0, $9805619f03ed02ef$export$91884aa883243770)((0, (/*@__PURE__*/$parcel$interopDefault($ce5da1ed8357609e$exports))), `how-to-play ${className}`),
        title: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($389920e14c601f6f$var$Title, {
            onClose: onClose
        }),
        content: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($389920e14c601f6f$var$Content, {
            onClose: onClose
        }),
        onClickBackground: onClose,
        ...props
    });
};




parcelRequire("acw62");

var $ftY1i = parcelRequire("ftY1i");




var $54a2fade5b0de8b9$exports = {};

$parcel$export($54a2fade5b0de8b9$exports, "balance", () => $54a2fade5b0de8b9$export$13efda6d80c8a88, (v) => $54a2fade5b0de8b9$export$13efda6d80c8a88 = v);
$parcel$export($54a2fade5b0de8b9$exports, "balance-entries", () => $54a2fade5b0de8b9$export$685cb18947f85f26, (v) => $54a2fade5b0de8b9$export$685cb18947f85f26 = v);
$parcel$export($54a2fade5b0de8b9$exports, "balance-entry", () => $54a2fade5b0de8b9$export$b5329f9a568adea0, (v) => $54a2fade5b0de8b9$export$b5329f9a568adea0 = v);
$parcel$export($54a2fade5b0de8b9$exports, "buttons", () => $54a2fade5b0de8b9$export$bbea856fdb3e3c5f, (v) => $54a2fade5b0de8b9$export$bbea856fdb3e3c5f = v);
$parcel$export($54a2fade5b0de8b9$exports, "confirm-clash", () => $54a2fade5b0de8b9$export$4ec1b751405ae542, (v) => $54a2fade5b0de8b9$export$4ec1b751405ae542 = v);
$parcel$export($54a2fade5b0de8b9$exports, "content", () => $54a2fade5b0de8b9$export$a7db06668cad9adb, (v) => $54a2fade5b0de8b9$export$a7db06668cad9adb = v);
$parcel$export($54a2fade5b0de8b9$exports, "cost", () => $54a2fade5b0de8b9$export$1f08406bd75c466e, (v) => $54a2fade5b0de8b9$export$1f08406bd75c466e = v);
$parcel$export($54a2fade5b0de8b9$exports, "description", () => $54a2fade5b0de8b9$export$6d59db4903f20f7d, (v) => $54a2fade5b0de8b9$export$6d59db4903f20f7d = v);
$parcel$export($54a2fade5b0de8b9$exports, "error", () => $54a2fade5b0de8b9$export$a3bc9b8ed74fc, (v) => $54a2fade5b0de8b9$export$a3bc9b8ed74fc = v);
$parcel$export($54a2fade5b0de8b9$exports, "free", () => $54a2fade5b0de8b9$export$13e2de3c33d99539, (v) => $54a2fade5b0de8b9$export$13e2de3c33d99539 = v);
$parcel$export($54a2fade5b0de8b9$exports, "gems", () => $54a2fade5b0de8b9$export$b7dcc03c39461775, (v) => $54a2fade5b0de8b9$export$b7dcc03c39461775 = v);
$parcel$export($54a2fade5b0de8b9$exports, "title", () => $54a2fade5b0de8b9$export$fb184b623420d9be, (v) => $54a2fade5b0de8b9$export$fb184b623420d9be = v);
var $54a2fade5b0de8b9$export$13efda6d80c8a88;
var $54a2fade5b0de8b9$export$685cb18947f85f26;
var $54a2fade5b0de8b9$export$b5329f9a568adea0;
var $54a2fade5b0de8b9$export$bbea856fdb3e3c5f;
var $54a2fade5b0de8b9$export$4ec1b751405ae542;
var $54a2fade5b0de8b9$export$a7db06668cad9adb;
var $54a2fade5b0de8b9$export$1f08406bd75c466e;
var $54a2fade5b0de8b9$export$6d59db4903f20f7d;
var $54a2fade5b0de8b9$export$a3bc9b8ed74fc;
var $54a2fade5b0de8b9$export$13e2de3c33d99539;
var $54a2fade5b0de8b9$export$b7dcc03c39461775;
var $54a2fade5b0de8b9$export$fb184b623420d9be;
$54a2fade5b0de8b9$export$13efda6d80c8a88 = `kOiuDa_balance`;
$54a2fade5b0de8b9$export$685cb18947f85f26 = `kOiuDa_balance-entries`;
$54a2fade5b0de8b9$export$b5329f9a568adea0 = `kOiuDa_balance-entry`;
$54a2fade5b0de8b9$export$bbea856fdb3e3c5f = `kOiuDa_buttons`;
$54a2fade5b0de8b9$export$4ec1b751405ae542 = `kOiuDa_confirm-clash`;
$54a2fade5b0de8b9$export$a7db06668cad9adb = `kOiuDa_content`;
$54a2fade5b0de8b9$export$1f08406bd75c466e = `kOiuDa_cost`;
$54a2fade5b0de8b9$export$6d59db4903f20f7d = `kOiuDa_description`;
$54a2fade5b0de8b9$export$a3bc9b8ed74fc = `kOiuDa_error`;
$54a2fade5b0de8b9$export$13e2de3c33d99539 = `kOiuDa_free`;
$54a2fade5b0de8b9$export$b7dcc03c39461775 = `kOiuDa_gems`;
$54a2fade5b0de8b9$export$fb184b623420d9be = `kOiuDa_title`;


const $a576f75f1a522661$var$addZeroToNumber = (number)=>number < 10 ? `0${number}` : number;
const $a576f75f1a522661$var$renderer = ({ days: days, hours: hours, minutes: minutes, seconds: seconds })=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
        children: days === 0 && hours === 0 && minutes === 0 && seconds === 0 ? "available" : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
            children: [
                $a576f75f1a522661$var$addZeroToNumber(hours + days * 24),
                "H",
                $a576f75f1a522661$var$addZeroToNumber(minutes),
                "M"
            ]
        })
    });
const $a576f75f1a522661$var$Content = ({ callback: callback })=>{
    const { state: { accountInfo: accountInfo } } = (0, $c25623cc446ec3c6$export$ac8576a9912be18c)();
    const play = ()=>{
        if (callback) callback(true, "clash");
    };
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: (0, $9805619f03ed02ef$export$91884aa883243770)((0, (/*@__PURE__*/$parcel$interopDefault($54a2fade5b0de8b9$exports))), "content"),
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: (0, $9805619f03ed02ef$export$91884aa883243770)((0, (/*@__PURE__*/$parcel$interopDefault($54a2fade5b0de8b9$exports))), "balance"),
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                        src: `${(0, $0426e2dd5e0de94d$export$24af3971dd36b33f)}/ui/tab-clash.png`,
                        alt: "skull"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: (0, $9805619f03ed02ef$export$91884aa883243770)((0, (/*@__PURE__*/$parcel$interopDefault($54a2fade5b0de8b9$exports))), "description"),
                        children: [
                            "You have",
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                children: [
                                    accountInfo?.clash.quantity ?? "...",
                                    "/1 FREE TRY"
                                ]
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                                children: [
                                    "+1 try in ",
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $ftY1i.default), {
                                        date: (accountInfo?.clash.lastUpdate ?? Date.now()) + 86400000,
                                        renderer: $a576f75f1a522661$var$renderer
                                    })
                                ]
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: (0, $9805619f03ed02ef$export$91884aa883243770)((0, (/*@__PURE__*/$parcel$interopDefault($54a2fade5b0de8b9$exports))), "cost"),
                children: [
                    "Cost to play",
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        className: (0, $9805619f03ed02ef$export$91884aa883243770)((0, (/*@__PURE__*/$parcel$interopDefault($54a2fade5b0de8b9$exports))), "balance-entries"),
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                            className: (0, $9805619f03ed02ef$export$91884aa883243770)((0, (/*@__PURE__*/$parcel$interopDefault($54a2fade5b0de8b9$exports))), "balance-entry"),
                            children: "1 TRY"
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: (0, $9805619f03ed02ef$export$91884aa883243770)((0, (/*@__PURE__*/$parcel$interopDefault($54a2fade5b0de8b9$exports))), "buttons"),
                children: (accountInfo?.clash.quantity ?? 0) === 0 ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $6725244138e0595f$export$353f5b6fc5456de1), {
                    className: (0, $9805619f03ed02ef$export$91884aa883243770)((0, (/*@__PURE__*/$parcel$interopDefault($54a2fade5b0de8b9$exports))), "gems blue"),
                    onClick: play,
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                            src: `${(0, $0426e2dd5e0de94d$export$24af3971dd36b33f)}/ui/gem.png`,
                            alt: "gems"
                        }),
                        "PLAY FOR 100 GEMS"
                    ]
                }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $6725244138e0595f$export$353f5b6fc5456de1), {
                    className: "small",
                    onClick: play,
                    disabled: (accountInfo?.clash.quantity ?? 0) < 1,
                    children: "PLAY FOR FREE"
                })
            })
        ]
    });
};
const $a576f75f1a522661$var$Title = ({ onClose: onClose })=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: (0, $9805619f03ed02ef$export$91884aa883243770)((0, (/*@__PURE__*/$parcel$interopDefault($54a2fade5b0de8b9$exports))), "title"),
        children: [
            "Confirm Clash",
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                src: `${(0, $0426e2dd5e0de94d$export$24af3971dd36b33f)}/ui/cross.png`,
                alt: "cross",
                onClick: onClose
            })
        ]
    });
const $a576f75f1a522661$export$3719b54e275aa330 = ({ className: className, onClose: onClose, callback: callback, ...props })=>{
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $207d23274fe2be11$export$6e63c1000ecf9db8), {
        className: (0, $9805619f03ed02ef$export$91884aa883243770)((0, (/*@__PURE__*/$parcel$interopDefault($54a2fade5b0de8b9$exports))), `confirm-clash ${className}`),
        title: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($a576f75f1a522661$var$Title, {
            onClose: onClose
        }),
        content: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($a576f75f1a522661$var$Content, {
            callback: callback
        }),
        onClickBackground: onClose,
        ...props
    });
};





var $acw62 = parcelRequire("acw62");

var $ftY1i = parcelRequire("ftY1i");










var $acw62 = parcelRequire("acw62");

var $ftY1i = parcelRequire("ftY1i");






var $6c6701e29b107e05$exports = {};

$parcel$export($6c6701e29b107e05$exports, "buy-energy", () => $6c6701e29b107e05$export$e0dde8ca94e2a15, (v) => $6c6701e29b107e05$export$e0dde8ca94e2a15 = v);
$parcel$export($6c6701e29b107e05$exports, "content", () => $6c6701e29b107e05$export$a7db06668cad9adb, (v) => $6c6701e29b107e05$export$a7db06668cad9adb = v);
$parcel$export($6c6701e29b107e05$exports, "description", () => $6c6701e29b107e05$export$6d59db4903f20f7d, (v) => $6c6701e29b107e05$export$6d59db4903f20f7d = v);
$parcel$export($6c6701e29b107e05$exports, "energy", () => $6c6701e29b107e05$export$cf5fa39c68f77634, (v) => $6c6701e29b107e05$export$cf5fa39c68f77634 = v);
$parcel$export($6c6701e29b107e05$exports, "gems", () => $6c6701e29b107e05$export$b7dcc03c39461775, (v) => $6c6701e29b107e05$export$b7dcc03c39461775 = v);
$parcel$export($6c6701e29b107e05$exports, "title", () => $6c6701e29b107e05$export$fb184b623420d9be, (v) => $6c6701e29b107e05$export$fb184b623420d9be = v);
$parcel$export($6c6701e29b107e05$exports, "vessel", () => $6c6701e29b107e05$export$5f63db1d988def4d, (v) => $6c6701e29b107e05$export$5f63db1d988def4d = v);
var $6c6701e29b107e05$export$e0dde8ca94e2a15;
var $6c6701e29b107e05$export$a7db06668cad9adb;
var $6c6701e29b107e05$export$6d59db4903f20f7d;
var $6c6701e29b107e05$export$cf5fa39c68f77634;
var $6c6701e29b107e05$export$b7dcc03c39461775;
var $6c6701e29b107e05$export$fb184b623420d9be;
var $6c6701e29b107e05$export$5f63db1d988def4d;
$6c6701e29b107e05$export$e0dde8ca94e2a15 = `Gccroq_buy-energy`;
$6c6701e29b107e05$export$a7db06668cad9adb = `Gccroq_content`;
$6c6701e29b107e05$export$6d59db4903f20f7d = `Gccroq_description`;
$6c6701e29b107e05$export$cf5fa39c68f77634 = `Gccroq_energy`;
$6c6701e29b107e05$export$b7dcc03c39461775 = `Gccroq_gems`;
$6c6701e29b107e05$export$fb184b623420d9be = `Gccroq_title`;
$6c6701e29b107e05$export$5f63db1d988def4d = `Gccroq_vessel`;


const $54ca9f6efc2d9cab$var$addZeroToNumber = (number)=>number < 10 ? `0${number}` : number;
const $54ca9f6efc2d9cab$var$renderer = ({ hours: hours, minutes: minutes, seconds: seconds, total: total, api: api })=>{
    if (total > 0) api.start();
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
        children: [
            $54ca9f6efc2d9cab$var$addZeroToNumber(minutes + hours * 60),
            "M",
            $54ca9f6efc2d9cab$var$addZeroToNumber(seconds),
            "S"
        ]
    });
};
const $54ca9f6efc2d9cab$var$Content = ()=>{
    const { state: { accountInfo: accountInfo } } = (0, $c25623cc446ec3c6$export$ac8576a9912be18c)();
    const [loading, setLoading] = (0, $acw62.useState)();
    const buyEnergy = async (mode)=>{
        setLoading(mode);
        const result = await (0, $35a528e84618b070$export$d13a04717b4c27fa)(mode);
        if (result?.data && (0, $b3b1baf40467424d$export$745043c7dc65e495).refreshAccountInfo) (0, $b3b1baf40467424d$export$745043c7dc65e495).refreshAccountInfo();
        setLoading(undefined);
    };
    const refreshEnergy = ()=>{
        setTimeout(()=>{
            if ((0, $b3b1baf40467424d$export$745043c7dc65e495).refreshAccountInfo) (0, $b3b1baf40467424d$export$745043c7dc65e495).refreshAccountInfo();
        }, 2000);
    };
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: (0, $9805619f03ed02ef$export$91884aa883243770)((0, (/*@__PURE__*/$parcel$interopDefault($6c6701e29b107e05$exports))), "content"),
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: (0, $9805619f03ed02ef$export$91884aa883243770)((0, (/*@__PURE__*/$parcel$interopDefault($6c6701e29b107e05$exports))), "energy"),
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                        src: `${(0, $0426e2dd5e0de94d$export$24af3971dd36b33f)}/ui/energy.png`,
                        alt: "energy"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: (0, $9805619f03ed02ef$export$91884aa883243770)((0, (/*@__PURE__*/$parcel$interopDefault($6c6701e29b107e05$exports))), "description"),
                        children: [
                            "You have",
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                children: [
                                    accountInfo?.energy.quantity ?? "...",
                                    "/12"
                                ]
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                                children: [
                                    "+1 in ",
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $ftY1i.default), {
                                        date: (accountInfo?.energy.lastUpdate ?? Date.now()) + 7200000,
                                        renderer: $54ca9f6efc2d9cab$var$renderer,
                                        onComplete: refreshEnergy
                                    })
                                ]
                            })
                        ]
                    })
                ]
            }),
            "buy 3 energy for",
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $6725244138e0595f$export$353f5b6fc5456de1), {
                className: (0, $9805619f03ed02ef$export$91884aa883243770)((0, (/*@__PURE__*/$parcel$interopDefault($6c6701e29b107e05$exports))), "vessel yellow"),
                disabled: (accountInfo?.vessels ?? 0) < 5 || accountInfo?.energy.quantity === 12,
                onClick: ()=>buyEnergy("vessels"),
                loading: loading === "vessels",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                        src: `${(0, $0426e2dd5e0de94d$export$24af3971dd36b33f)}/ui/vessel.png`,
                        alt: "vessel"
                    }),
                    "5 VESSELS"
                ]
            }),
            "or",
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $6725244138e0595f$export$353f5b6fc5456de1), {
                className: (0, $9805619f03ed02ef$export$91884aa883243770)((0, (/*@__PURE__*/$parcel$interopDefault($6c6701e29b107e05$exports))), "gems blue"),
                disabled: (accountInfo?.gems ?? 0) < 50 || accountInfo?.energy.quantity === 12,
                onClick: ()=>buyEnergy("gems"),
                loading: loading === "gems",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                        src: `${(0, $0426e2dd5e0de94d$export$24af3971dd36b33f)}/ui/gem.png`,
                        alt: "gems"
                    }),
                    "50 GEMS"
                ]
            })
        ]
    });
};
const $54ca9f6efc2d9cab$var$Title = ({ onClose: onClose })=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: (0, $9805619f03ed02ef$export$91884aa883243770)((0, (/*@__PURE__*/$parcel$interopDefault($6c6701e29b107e05$exports))), "title"),
        children: [
            "Buy energy",
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                src: `${(0, $0426e2dd5e0de94d$export$24af3971dd36b33f)}/ui/cross.png`,
                alt: "cross",
                onClick: onClose
            })
        ]
    });
const $54ca9f6efc2d9cab$export$35af786d5efcb0fc = ({ className: className, onClose: onClose, ...props })=>{
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $207d23274fe2be11$export$6e63c1000ecf9db8), {
        className: (0, $9805619f03ed02ef$export$91884aa883243770)((0, (/*@__PURE__*/$parcel$interopDefault($6c6701e29b107e05$exports))), `buy-energy ${className}`),
        title: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($54ca9f6efc2d9cab$var$Title, {
            onClose: onClose
        }),
        content: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($54ca9f6efc2d9cab$var$Content, {}),
        onClickBackground: onClose,
        ...props
    });
};


var $6c757fd998739277$exports = {};

$parcel$export($6c757fd998739277$exports, "balance", () => $6c757fd998739277$export$13efda6d80c8a88, (v) => $6c757fd998739277$export$13efda6d80c8a88 = v);
$parcel$export($6c757fd998739277$exports, "balance-buttons", () => $6c757fd998739277$export$d22a33f777b61d23, (v) => $6c757fd998739277$export$d22a33f777b61d23 = v);
$parcel$export($6c757fd998739277$exports, "balance-entries", () => $6c757fd998739277$export$685cb18947f85f26, (v) => $6c757fd998739277$export$685cb18947f85f26 = v);
$parcel$export($6c757fd998739277$exports, "balance-entry", () => $6c757fd998739277$export$b5329f9a568adea0, (v) => $6c757fd998739277$export$b5329f9a568adea0 = v);
$parcel$export($6c757fd998739277$exports, "buttons", () => $6c757fd998739277$export$bbea856fdb3e3c5f, (v) => $6c757fd998739277$export$bbea856fdb3e3c5f = v);
$parcel$export($6c757fd998739277$exports, "confirm-game", () => $6c757fd998739277$export$b7089bba1bed824c, (v) => $6c757fd998739277$export$b7089bba1bed824c = v);
$parcel$export($6c757fd998739277$exports, "content", () => $6c757fd998739277$export$a7db06668cad9adb, (v) => $6c757fd998739277$export$a7db06668cad9adb = v);
$parcel$export($6c757fd998739277$exports, "cost", () => $6c757fd998739277$export$1f08406bd75c466e, (v) => $6c757fd998739277$export$1f08406bd75c466e = v);
$parcel$export($6c757fd998739277$exports, "free", () => $6c757fd998739277$export$13e2de3c33d99539, (v) => $6c757fd998739277$export$13e2de3c33d99539 = v);
$parcel$export($6c757fd998739277$exports, "title", () => $6c757fd998739277$export$fb184b623420d9be, (v) => $6c757fd998739277$export$fb184b623420d9be = v);
var $6c757fd998739277$export$13efda6d80c8a88;
var $6c757fd998739277$export$d22a33f777b61d23;
var $6c757fd998739277$export$685cb18947f85f26;
var $6c757fd998739277$export$b5329f9a568adea0;
var $6c757fd998739277$export$bbea856fdb3e3c5f;
var $6c757fd998739277$export$b7089bba1bed824c;
var $6c757fd998739277$export$a7db06668cad9adb;
var $6c757fd998739277$export$1f08406bd75c466e;
var $6c757fd998739277$export$13e2de3c33d99539;
var $6c757fd998739277$export$fb184b623420d9be;
$6c757fd998739277$export$13efda6d80c8a88 = `ibB7Uq_balance`;
$6c757fd998739277$export$d22a33f777b61d23 = `ibB7Uq_balance-buttons`;
$6c757fd998739277$export$685cb18947f85f26 = `ibB7Uq_balance-entries`;
$6c757fd998739277$export$b5329f9a568adea0 = `ibB7Uq_balance-entry`;
$6c757fd998739277$export$bbea856fdb3e3c5f = `ibB7Uq_buttons`;
$6c757fd998739277$export$b7089bba1bed824c = `ibB7Uq_confirm-game`;
$6c757fd998739277$export$a7db06668cad9adb = `ibB7Uq_content`;
$6c757fd998739277$export$1f08406bd75c466e = `ibB7Uq_cost`;
$6c757fd998739277$export$13e2de3c33d99539 = `ibB7Uq_free`;
$6c757fd998739277$export$fb184b623420d9be = `ibB7Uq_title`;


const $4eb8d2f3208bede8$var$addZeroToNumber = (number)=>number < 10 ? `0${number}` : number;
const $4eb8d2f3208bede8$var$renderer = ({ days: days, hours: hours, minutes: minutes, seconds: seconds })=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
        children: days === 0 && hours === 0 && minutes === 0 && seconds === 0 ? "available" : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
            children: [
                $4eb8d2f3208bede8$var$addZeroToNumber(hours + days * 24),
                "H",
                $4eb8d2f3208bede8$var$addZeroToNumber(minutes),
                "M"
            ]
        })
    });
const $4eb8d2f3208bede8$var$Content = ({ setShowBuyEnergy: setShowBuyEnergy, callback: callback })=>{
    const { state: { accountInfo: accountInfo } } = (0, $c25623cc446ec3c6$export$ac8576a9912be18c)();
    const [loading, setLoading] = (0, $acw62.useState)();
    const freeGameAvailable = accountInfo && accountInfo.freeGameLastUsage + 86400000 < Date.now();
    const play = async (mode)=>{
        if (mode === "free" && !freeGameAvailable) {
            if (!accountInfo?.freeGames) {
                (0, $ad26fe773541dcd3$export$b410431fab84fa58).error("No free game detected");
                return;
            } else if (accountInfo.freeGames > 0) {
                if (callback) callback(true);
                return;
            }
        }
        setLoading(mode);
        const result = await (0, $35a528e84618b070$export$37992403e144a117)(mode);
        if (result?.status === 200 && result?.data && (0, $b3b1baf40467424d$export$745043c7dc65e495).refreshAccountInfo) {
            if (mode === "free" && result.data.freeGames === 0) (0, $ad26fe773541dcd3$export$b410431fab84fa58).info("You don't have any Oogy on this wallet");
            else if (mode === "paid" && result.data.paidGames === 0) (0, $ad26fe773541dcd3$export$b410431fab84fa58).info("You don't have any paid games, please contact the support team");
            else {
                (0, $b3b1baf40467424d$export$745043c7dc65e495).refreshAccountInfo();
                if (callback) callback(true);
            }
        }
        setLoading(undefined);
    };
    //const tensor = () => {
    //  window.open('https://www.tensor.trade/trade/spicevessels', undefined, 'popup')
    //}
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: (0, $9805619f03ed02ef$export$91884aa883243770)((0, (/*@__PURE__*/$parcel$interopDefault($6c757fd998739277$exports))), "content"),
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: (0, $9805619f03ed02ef$export$91884aa883243770)((0, (/*@__PURE__*/$parcel$interopDefault($6c757fd998739277$exports))), "balance"),
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        children: "Your balance"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        className: (0, $9805619f03ed02ef$export$91884aa883243770)((0, (/*@__PURE__*/$parcel$interopDefault($6c757fd998739277$exports))), "balance-entries"),
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                            className: (0, $9805619f03ed02ef$export$91884aa883243770)((0, (/*@__PURE__*/$parcel$interopDefault($6c757fd998739277$exports))), "balance-entry"),
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                                    src: `${(0, $0426e2dd5e0de94d$export$24af3971dd36b33f)}/ui/energy.png`,
                                    alt: "energy"
                                }),
                                accountInfo?.energy.quantity ?? "..."
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        className: (0, $9805619f03ed02ef$export$91884aa883243770)((0, (/*@__PURE__*/$parcel$interopDefault($6c757fd998739277$exports))), "balance-buttons"),
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $6725244138e0595f$export$353f5b6fc5456de1), {
                            className: "xsmall",
                            onClick: ()=>setShowBuyEnergy(true),
                            children: "BUY ENERGY"
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: (0, $9805619f03ed02ef$export$91884aa883243770)((0, (/*@__PURE__*/$parcel$interopDefault($6c757fd998739277$exports))), "cost"),
                children: [
                    "Cost to play",
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        className: (0, $9805619f03ed02ef$export$91884aa883243770)((0, (/*@__PURE__*/$parcel$interopDefault($6c757fd998739277$exports))), "balance-entries"),
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                            className: (0, $9805619f03ed02ef$export$91884aa883243770)((0, (/*@__PURE__*/$parcel$interopDefault($6c757fd998739277$exports))), "balance-entry"),
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                                    src: `${(0, $0426e2dd5e0de94d$export$24af3971dd36b33f)}/ui/energy.png`,
                                    alt: "energy"
                                }),
                                (accountInfo?.paidGames ?? 0) > 0 ? 0 : "-3"
                            ]
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: (0, $9805619f03ed02ef$export$91884aa883243770)((0, (/*@__PURE__*/$parcel$interopDefault($6c757fd998739277$exports))), "buttons"),
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $6725244138e0595f$export$353f5b6fc5456de1), {
                        className: "small",
                        onClick: ()=>play("paid"),
                        loading: loading === "paid",
                        disabled: (accountInfo?.energy.quantity ?? 0) < 3 && (accountInfo?.paidGames ?? 0) === 0 && (accountInfo?.freeGames ?? 0) === 0,
                        children: (accountInfo?.paidGames ?? 0) > 0 ? "PLAY FOR FREE" : "PLAY"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $6725244138e0595f$export$353f5b6fc5456de1), {
                        className: (0, $9805619f03ed02ef$export$91884aa883243770)((0, (/*@__PURE__*/$parcel$interopDefault($6c757fd998739277$exports))), "free pink"),
                        onClick: ()=>play("free"),
                        loading: loading === "free",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                                src: `${(0, $0426e2dd5e0de94d$export$24af3971dd36b33f)}/ui/oogy-logo.png`,
                                alt: "oogy-logo"
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                        children: "FREE TO PLAY"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                        children: accountInfo?.freeGames !== undefined && accountInfo.freeGames > 0 ? `${accountInfo.freeGames} games left` : accountInfo?.freeGameLastUsage !== undefined ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $ftY1i.default), {
                                            date: accountInfo.freeGameLastUsage + 86400000,
                                            onComplete: ()=>{},
                                            renderer: $4eb8d2f3208bede8$var$renderer
                                        }) : "..."
                                    })
                                ]
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
const $4eb8d2f3208bede8$var$Title = ({ onClose: onClose })=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: (0, $9805619f03ed02ef$export$91884aa883243770)((0, (/*@__PURE__*/$parcel$interopDefault($6c757fd998739277$exports))), "title"),
        children: [
            "Confirm game",
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                src: `${(0, $0426e2dd5e0de94d$export$24af3971dd36b33f)}/ui/cross.png`,
                alt: "cross",
                onClick: onClose
            })
        ]
    });
const $4eb8d2f3208bede8$export$809c58c36f4d69bd = ({ className: className, onClose: onClose, callback: callback, ...props })=>{
    const [showBuyEnergy, setShowBuyEnergy] = (0, $acw62.useState)(false);
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $207d23274fe2be11$export$6e63c1000ecf9db8), {
                className: (0, $9805619f03ed02ef$export$91884aa883243770)((0, (/*@__PURE__*/$parcel$interopDefault($6c757fd998739277$exports))), `confirm-game ${className}`),
                title: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($4eb8d2f3208bede8$var$Title, {
                    onClose: onClose
                }),
                content: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($4eb8d2f3208bede8$var$Content, {
                    callback: callback,
                    setShowBuyEnergy: setShowBuyEnergy
                }),
                onClickBackground: onClose,
                ...props
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $54ca9f6efc2d9cab$export$35af786d5efcb0fc), {
                show: showBuyEnergy,
                onClose: ()=>setShowBuyEnergy(false)
            })
        ]
    });
};





var $acw62 = parcelRequire("acw62");





var $2ca173282d183f41$exports = {};

$parcel$export($2ca173282d183f41$exports, "button-container", () => $2ca173282d183f41$export$4f7a98834621a1a, (v) => $2ca173282d183f41$export$4f7a98834621a1a = v);
$parcel$export($2ca173282d183f41$exports, "clash", () => $2ca173282d183f41$export$bf443b6d1a33b62f, (v) => $2ca173282d183f41$export$bf443b6d1a33b62f = v);
$parcel$export($2ca173282d183f41$exports, "content", () => $2ca173282d183f41$export$a7db06668cad9adb, (v) => $2ca173282d183f41$export$a7db06668cad9adb = v);
$parcel$export($2ca173282d183f41$exports, "game-type", () => $2ca173282d183f41$export$6f42e049908729c7, (v) => $2ca173282d183f41$export$6f42e049908729c7 = v);
$parcel$export($2ca173282d183f41$exports, "gems", () => $2ca173282d183f41$export$b7dcc03c39461775, (v) => $2ca173282d183f41$export$b7dcc03c39461775 = v);
$parcel$export($2ca173282d183f41$exports, "image", () => $2ca173282d183f41$export$5c452ff88e35e47d, (v) => $2ca173282d183f41$export$5c452ff88e35e47d = v);
$parcel$export($2ca173282d183f41$exports, "single", () => $2ca173282d183f41$export$863d7ca51b416cee, (v) => $2ca173282d183f41$export$863d7ca51b416cee = v);
$parcel$export($2ca173282d183f41$exports, "title", () => $2ca173282d183f41$export$fb184b623420d9be, (v) => $2ca173282d183f41$export$fb184b623420d9be = v);
var $2ca173282d183f41$export$4f7a98834621a1a;
var $2ca173282d183f41$export$bf443b6d1a33b62f;
var $2ca173282d183f41$export$a7db06668cad9adb;
var $2ca173282d183f41$export$6f42e049908729c7;
var $2ca173282d183f41$export$b7dcc03c39461775;
var $2ca173282d183f41$export$5c452ff88e35e47d;
var $2ca173282d183f41$export$863d7ca51b416cee;
var $2ca173282d183f41$export$fb184b623420d9be;
$2ca173282d183f41$export$4f7a98834621a1a = `bjfiZG_button-container`;
$2ca173282d183f41$export$bf443b6d1a33b62f = `bjfiZG_clash`;
$2ca173282d183f41$export$a7db06668cad9adb = `bjfiZG_content`;
$2ca173282d183f41$export$6f42e049908729c7 = `bjfiZG_game-type`;
$2ca173282d183f41$export$b7dcc03c39461775 = `bjfiZG_gems`;
$2ca173282d183f41$export$5c452ff88e35e47d = `bjfiZG_image`;
$2ca173282d183f41$export$863d7ca51b416cee = `bjfiZG_single`;
$2ca173282d183f41$export$fb184b623420d9be = `bjfiZG_title`;


const $565e58bc0a4c0b2b$var$Content = ({ onSelect: onSelect, onClose: onClose })=>{
    const { state: { accountInfo: accountInfo }, dispatch: dispatch } = (0, $c25623cc446ec3c6$export$ac8576a9912be18c)();
    const [loading, setLoading] = (0, $acw62.useState)(false);
    const [clubClashData, setClubClashData] = (0, $acw62.useState)();
    (0, $acw62.useEffect)(()=>{
        setLoading(true);
        (0, $35a528e84618b070$export$1b2baf0c7c665732)(()=>console.info).then((response)=>{
            setLoading(false);
            if (response?.status !== 200) return;
            setClubClashData(response.data);
        }).catch(()=>{
            setLoading(false);
        });
    }, []);
    const launchNormal = async ()=>{
        onSelect("score");
    };
    const launchClash = ()=>{
        onSelect("clash");
    };
    const joinAClub = ()=>{
        dispatch({
            type: "SET_NAVIGATION",
            tab: "clash"
        });
        onClose();
    };
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: (0, $9805619f03ed02ef$export$91884aa883243770)((0, (/*@__PURE__*/$parcel$interopDefault($2ca173282d183f41$exports))), "content"),
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: (0, $9805619f03ed02ef$export$91884aa883243770)((0, (/*@__PURE__*/$parcel$interopDefault($2ca173282d183f41$exports))), "single"),
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        className: (0, $9805619f03ed02ef$export$91884aa883243770)((0, (/*@__PURE__*/$parcel$interopDefault($2ca173282d183f41$exports))), "image"),
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                            src: `${(0, $0426e2dd5e0de94d$export$24af3971dd36b33f)}/ui/single-mode.png`,
                            alt: "multi"
                        })
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: (0, $9805619f03ed02ef$export$91884aa883243770)((0, (/*@__PURE__*/$parcel$interopDefault($2ca173282d183f41$exports))), "button-container"),
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                children: "CLASSIC"
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $6725244138e0595f$export$353f5b6fc5456de1), {
                                onClick: launchNormal,
                                children: "PLAY"
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: (0, $9805619f03ed02ef$export$91884aa883243770)((0, (/*@__PURE__*/$parcel$interopDefault($2ca173282d183f41$exports))), "clash"),
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        className: (0, $9805619f03ed02ef$export$91884aa883243770)((0, (/*@__PURE__*/$parcel$interopDefault($2ca173282d183f41$exports))), "image"),
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                            src: `${(0, $0426e2dd5e0de94d$export$24af3971dd36b33f)}/ui/clash-mode.png`,
                            alt: "clash"
                        })
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: (0, $9805619f03ed02ef$export$91884aa883243770)((0, (/*@__PURE__*/$parcel$interopDefault($2ca173282d183f41$exports))), "button-container"),
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                children: "CLUB CLASH"
                            }),
                            accountInfo?.clubId ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $6725244138e0595f$export$353f5b6fc5456de1), {
                                onClick: launchClash,
                                disabled: (clubClashData?.startingAt ?? 0) > Date.now() || (clubClashData?.endingAt ?? 0) < Date.now(),
                                children: (clubClashData?.startingAt ?? 0) > Date.now() ? "NOT STARTED" : (clubClashData?.endingAt ?? 0) < Date.now() ? "ENDED" : "PLAY"
                            }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $6725244138e0595f$export$353f5b6fc5456de1), {
                                className: (0, $9805619f03ed02ef$export$91884aa883243770)((0, (/*@__PURE__*/$parcel$interopDefault($2ca173282d183f41$exports))), "gray"),
                                onClick: joinAClub,
                                loading: loading,
                                disabled: !loading && !clubClashData || clubClashData && (clubClashData.startingAt > Date.now() || clubClashData.endingAt < Date.now()),
                                children: clubClashData ? "JOIN A CLUB" : "NO CLUB CLASH"
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
const $565e58bc0a4c0b2b$var$Title = ({ onClose: onClose })=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: (0, $9805619f03ed02ef$export$91884aa883243770)((0, (/*@__PURE__*/$parcel$interopDefault($2ca173282d183f41$exports))), "title"),
        children: [
            "Type of room",
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                src: `${(0, $0426e2dd5e0de94d$export$24af3971dd36b33f)}/ui/cross.png`,
                alt: "cross",
                onClick: onClose
            })
        ]
    });
const $565e58bc0a4c0b2b$export$e7a4d22d9ec76989 = ({ className: className, onClose: onClose, onSelect: onSelect, show: show, ...props })=>{
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $207d23274fe2be11$export$6e63c1000ecf9db8), {
        className: (0, $9805619f03ed02ef$export$91884aa883243770)((0, (/*@__PURE__*/$parcel$interopDefault($2ca173282d183f41$exports))), `game-type ${className}`),
        title: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($565e58bc0a4c0b2b$var$Title, {
            onClose: onClose
        }),
        content: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($565e58bc0a4c0b2b$var$Content, {
            onSelect: onSelect,
            onClose: onClose
        }),
        onClickBackground: onClose,
        show: show,
        ...props
    });
};



var $46d5a9f991de27f2$exports = {};
"use strict";
Object.defineProperty($46d5a9f991de27f2$exports, "__esModule", {
    value: true
});
var $e65e75cd5d3cab3e$exports = {};
"use strict";
var $e65e75cd5d3cab3e$var$__importDefault = $e65e75cd5d3cab3e$exports && $e65e75cd5d3cab3e$exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty($e65e75cd5d3cab3e$exports, "__esModule", {
    value: true
});
$e65e75cd5d3cab3e$exports.ColorToFilter = void 0;

var $1V2eF = parcelRequire("1V2eF");
var $f7c1f69687298974$exports = {};
"use strict";
Object.defineProperty($f7c1f69687298974$exports, "__esModule", {
    value: true
});
$f7c1f69687298974$exports.SheenUtil = void 0;
class $f7c1f69687298974$var$SheenUtil {
    static parseSheenFromOptions(options) {
        if (options) {
            if (typeof options.sheen === "boolean") return options.sheen;
        }
        return true;
    }
}
$f7c1f69687298974$exports.SheenUtil = $f7c1f69687298974$var$SheenUtil;
$f7c1f69687298974$var$SheenUtil.SHEEN_FILTER_PREFIX = "brightness(0) saturate(100%)";



var $f4ycg = parcelRequire("f4ycg");
var $62b19baf7b5b315c$exports = {};
"use strict";
Object.defineProperty($62b19baf7b5b315c$exports, "__esModule", {
    value: true
});
$62b19baf7b5b315c$exports.RgbToFilter = void 0;

var $1V2eF = parcelRequire("1V2eF");

var $i2izK = parcelRequire("i2izK");
var $2c21de465de77b15$exports = {};
"use strict";
// the code used within this class has been taken and modified from the following codepen owned by Barrett Sonntag:
// https://codepen.io/sosuke/pen/Pjoqqp
Object.defineProperty($2c21de465de77b15$exports, "__esModule", {
    value: true
});
$2c21de465de77b15$exports.RgbToFilterWorker = void 0;

var $31c73a59efd49b38$exports = {};
"use strict";
Object.defineProperty($31c73a59efd49b38$exports, "__esModule", {
    value: true
});
$31c73a59efd49b38$exports.RgbColor = void 0;
class $31c73a59efd49b38$var$RgbColor {
    constructor(rgb = [
        0,
        0,
        0
    ]){
        this.r = this.clamp(rgb[0]);
        this.g = this.clamp(rgb[1]);
        this.b = this.clamp(rgb[2]);
    }
    clamp(value) {
        if (value > 255) value = 255;
        else if (value < 0) value = 0;
        return value;
    }
    setRgb(r, g, b) {
        this.r = this.clamp(r);
        this.g = this.clamp(g);
        this.b = this.clamp(b);
    }
    multiply(matrix) {
        const newR = this.clamp(this.r * matrix[0] + this.g * matrix[1] + this.b * matrix[2]);
        const newG = this.clamp(this.r * matrix[3] + this.g * matrix[4] + this.b * matrix[5]);
        const newB = this.clamp(this.r * matrix[6] + this.g * matrix[7] + this.b * matrix[8]);
        this.r = newR;
        this.g = newG;
        this.b = newB;
    }
    hueRotate(angle = 0) {
        angle = angle / 180 * Math.PI;
        const sin = Math.sin(angle);
        const cos = Math.cos(angle);
        this.multiply([
            0.213 + cos * 0.787 - sin * 0.213,
            0.715 - cos * 0.715 - sin * 0.715,
            0.072 - cos * 0.072 + sin * 0.928,
            0.213 - cos * 0.213 + sin * 0.143,
            0.715 + cos * 0.285 + sin * 0.14,
            0.072 - cos * 0.072 - sin * 0.283,
            0.213 - cos * 0.213 - sin * 0.787,
            0.715 - cos * 0.715 + sin * 0.715,
            0.072 + cos * 0.928 + sin * 0.072
        ]);
    }
    sepia(value = 1) {
        this.multiply([
            0.393 + 0.607 * (1 - value),
            0.769 - 0.769 * (1 - value),
            0.189 - 0.189 * (1 - value),
            0.349 - 0.349 * (1 - value),
            0.686 + 0.314 * (1 - value),
            0.168 - 0.168 * (1 - value),
            0.272 - 0.272 * (1 - value),
            0.534 - 0.534 * (1 - value),
            0.131 + 0.869 * (1 - value)
        ]);
    }
    saturate(value = 1) {
        this.multiply([
            0.213 + 0.787 * value,
            0.715 - 0.715 * value,
            0.072 - 0.072 * value,
            0.213 - 0.213 * value,
            0.715 + 0.285 * value,
            0.072 - 0.072 * value,
            0.213 - 0.213 * value,
            0.715 - 0.715 * value,
            0.072 + 0.928 * value
        ]);
    }
    linear(slope = 1, intercept = 0) {
        this.r = this.clamp(this.r * slope + intercept * 255);
        this.g = this.clamp(this.g * slope + intercept * 255);
        this.b = this.clamp(this.b * slope + intercept * 255);
    }
    brightness(value = 1) {
        this.linear(value);
    }
    contrast(value = 1) {
        this.linear(value, -(0.5 * value) + 0.5);
    }
    invert(value = 1) {
        this.r = this.clamp((value + this.r / 255 * (1 - 2 * value)) * 255);
        this.g = this.clamp((value + this.g / 255 * (1 - 2 * value)) * 255);
        this.b = this.clamp((value + this.b / 255 * (1 - 2 * value)) * 255);
    }
}
$31c73a59efd49b38$exports.RgbColor = $31c73a59efd49b38$var$RgbColor;


class $2c21de465de77b15$var$RgbToFilterWorker {
    constructor(targetRgbColor, addSheen){
        this.targetRgbColor = targetRgbColor;
        this.reusedRgbColor = new $31c73a59efd49b38$exports.RgbColor();
        this.addSheen = addSheen;
    }
    static fmt(filters, idx, multiplier = 1) {
        return Math.round(filters[idx] * multiplier);
    }
    generateCss(filters) {
        const prefix = this.addSheen ? `${$f7c1f69687298974$exports.SheenUtil.SHEEN_FILTER_PREFIX} ` : "";
        // prettier-ignore
        // eslint-disable-next-line max-len
        return `${prefix}invert(${$2c21de465de77b15$var$RgbToFilterWorker.fmt(filters, 0)}%) sepia(${$2c21de465de77b15$var$RgbToFilterWorker.fmt(filters, 1)}%) saturate(${$2c21de465de77b15$var$RgbToFilterWorker.fmt(filters, 2)}%) hue-rotate(${$2c21de465de77b15$var$RgbToFilterWorker.fmt(filters, 3, 3.6)}deg) brightness(${$2c21de465de77b15$var$RgbToFilterWorker.fmt(filters, 4)}%) contrast(${$2c21de465de77b15$var$RgbToFilterWorker.fmt(filters, 5)}%)`;
    }
    loss(filters) {
        this.reusedRgbColor.setRgb(0, 0, 0);
        this.reusedRgbColor.invert(filters[0] / 100);
        this.reusedRgbColor.sepia(filters[1] / 100);
        this.reusedRgbColor.saturate(filters[2] / 100);
        this.reusedRgbColor.hueRotate(filters[3] * 3.6);
        this.reusedRgbColor.brightness(filters[4] / 100);
        this.reusedRgbColor.contrast(filters[5] / 100);
        return Math.abs(this.reusedRgbColor.r - this.targetRgbColor.r) + Math.abs(this.reusedRgbColor.g - this.targetRgbColor.g) + Math.abs(this.reusedRgbColor.b - this.targetRgbColor.b);
    }
    static fixSpsa(value, idx) {
        let max = 100;
        if (idx === 2 /* saturate */ ) max = 7500;
        else if (idx === 4 /* brightness */  || idx === 5 /* contrast */ ) max = 200;
        if (idx === 3 /* hue-rotate */ ) {
            if (value > max) value %= max;
            else if (value < 0) value = max + value % max;
        } else if (value < 0) value = 0;
        else if (value > max) value = max;
        return value;
    }
    spsa(A, a, c, values, iters) {
        const alpha = 1;
        const gamma = 0.16666666666666666;
        let best = [];
        let bestLoss = Infinity;
        const deltas = new Array(6);
        const highArgs = new Array(6);
        const lowArgs = new Array(6);
        for(let k = 0; k < iters; k += 1){
            const ck = c / Math.pow(k + 1, gamma);
            for(let i = 0; i < 6; i += 1){
                deltas[i] = Math.random() > 0.5 ? 1 : -1;
                highArgs[i] = values[i] + ck * deltas[i];
                lowArgs[i] = values[i] - ck * deltas[i];
            }
            const lossDiff = this.loss(highArgs) - this.loss(lowArgs);
            for(let i = 0; i < 6; i += 1){
                const g = lossDiff / (2 * ck) * deltas[i];
                const ak = a[i] / Math.pow(A + k + 1, alpha);
                values[i] = $2c21de465de77b15$var$RgbToFilterWorker.fixSpsa(values[i] - ak * g, i);
            }
            const loss = this.loss(values);
            if (loss < bestLoss) {
                best = values.slice(0);
                bestLoss = loss;
            }
        }
        return {
            values: best,
            loss: bestLoss
        };
    }
    solveNarrow(wide) {
        const A = wide.loss;
        const c = 2;
        const A1 = A + 1;
        const a = [
            0.25 * A1,
            0.25 * A1,
            A1,
            0.25 * A1,
            0.2 * A1,
            0.2 * A1
        ];
        return this.spsa(A, a, c, wide.values, 500);
    }
    solveWide() {
        const A = 5;
        const c = 15;
        const a = [
            60,
            180,
            18000,
            600,
            1.2,
            1.2
        ];
        let best = {
            values: [],
            loss: Infinity
        };
        for(let i = 0; best.loss > 25 && i < 3; i += 1){
            const initial = [
                50,
                20,
                3750,
                50,
                100,
                100
            ];
            const result = this.spsa(A, a, c, initial, 1000);
            if (result.loss < best.loss) best = result;
        }
        return best;
    }
    convert() {
        const result = this.solveNarrow(this.solveWide());
        return {
            loss: result.loss,
            color: this.generateCss(result.values)
        };
    }
}
$2c21de465de77b15$exports.RgbToFilterWorker = $2c21de465de77b15$var$RgbToFilterWorker;



class $62b19baf7b5b315c$var$RgbToFilter {
    static generateConversionError(conversionErrorMessage) {
        const errorMessage = conversionErrorMessage || $i2izK.DEFAULT_CONVERSION_ERROR_MESSAGE;
        return $1V2eF.ErrorHandling.generateErrorResult(errorMessage);
    }
    static generateValidateAndParseError(errorMessage) {
        return $1V2eF.ErrorHandling.generateErrorResult(errorMessage);
    }
    static execute(rgb, addSheen) {
        const rgbColor = new $31c73a59efd49b38$exports.RgbColor(rgb);
        const rgbToFilter = new $2c21de465de77b15$exports.RgbToFilterWorker(rgbColor, addSheen);
        return rgbToFilter.convert();
    }
    static convertToRGB(parseResultColor, convertToRgb) {
        if (parseResultColor && convertToRgb) return convertToRgb(parseResultColor);
        return null;
    }
    static convert(conversionProps) {
        try {
            const { colorString: colorString, validateAndParse: validateAndParse, convertToRgb: convertToRgb, conversionErrorMessage: conversionErrorMessage, addSheen: addSheen } = conversionProps;
            const trimmedString = colorString.trim().toLocaleLowerCase();
            const parseResult = (validateAndParse === null || validateAndParse === void 0 ? void 0 : validateAndParse(trimmedString)) || {
                color: trimmedString
            };
            if ($1V2eF.ErrorHandling.hasError(parseResult)) return $62b19baf7b5b315c$var$RgbToFilter.generateValidateAndParseError(parseResult.errorMessage);
            const rgbColor = $62b19baf7b5b315c$var$RgbToFilter.convertToRGB(parseResult.color, convertToRgb) || parseResult.color;
            if (!rgbColor) return $62b19baf7b5b315c$var$RgbToFilter.generateConversionError(conversionErrorMessage);
            return $62b19baf7b5b315c$var$RgbToFilter.execute(rgbColor, addSheen);
        } catch (error) {
            return $1V2eF.ErrorHandling.generateUnexpectedError(error);
        }
    }
}
$62b19baf7b5b315c$exports.RgbToFilter = $62b19baf7b5b315c$var$RgbToFilter;


var $c3de6fb9444b0e4c$exports = {};
"use strict";
var $c3de6fb9444b0e4c$var$__importDefault = $c3de6fb9444b0e4c$exports && $c3de6fb9444b0e4c$exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty($c3de6fb9444b0e4c$exports, "__esModule", {
    value: true
});
$c3de6fb9444b0e4c$exports.ColorParser = void 0;
var $c2b8275b6ad654a0$exports = {};
"use strict";
Object.defineProperty($c2b8275b6ad654a0$exports, "__esModule", {
    value: true
});
$c2b8275b6ad654a0$exports.MATCH_HEXADECIMAL = $c2b8275b6ad654a0$exports.MATCH_INTEGER_AND_FLOAT_NUMBERS = void 0;
$c2b8275b6ad654a0$exports.MATCH_INTEGER_AND_FLOAT_NUMBERS = /(-?\d+(?:\.\d+)?)/g;
$c2b8275b6ad654a0$exports.MATCH_HEXADECIMAL = /^#[0-9a-f]{3}([0-9a-f]{3})?$/i;



var $1V2eF = parcelRequire("1V2eF");
var $aa79424c46e71ace$exports = {};
"use strict";
Object.defineProperty($aa79424c46e71ace$exports, "__esModule", {
    value: true
});
$aa79424c46e71ace$exports.MAX_COLOR_INPUT_STRING_LENGTH = void 0;
// this is used to prevent regex matcher from evaluating a long string that can be assumed to be incorrect
// currently not applied to filter
$aa79424c46e71ace$exports.MAX_COLOR_INPUT_STRING_LENGTH = 25;



var $j1wjX = parcelRequire("j1wjX");

var $f4ycg = parcelRequire("f4ycg");

// eslint-disable-next-line import/no-extraneous-dependencies
const $c3de6fb9444b0e4c$var$color_name_1 = $c3de6fb9444b0e4c$var$__importDefault((parcelRequire("kUVKl")));
class $c3de6fb9444b0e4c$var$ColorParser {
    static validateAndParseHex(hexString) {
        if (hexString.length < $aa79424c46e71ace$exports.MAX_COLOR_INPUT_STRING_LENGTH) {
            const isValid = hexString.match($c2b8275b6ad654a0$exports.MATCH_HEXADECIMAL);
            if (isValid) return {
                color: hexString
            };
        }
        return {
            errorMessage: $1V2eF.ErrorHandling.generateInputErrorMessage($f4ycg.ColorTypes.HEX, hexString, $j1wjX.ColorFormats.HEX)
        };
    }
    // the reason why this is simply parsing the first three digits instead of the tailored format is because the number
    // of variations of different inputs is very high. E.g. these are valid RGB values:
    // rgb(1,2,3)
    // rgb(1%,2%,3%)
    // rgb(1,2,3,0.5)
    // rgb(1 2 3 / 0.5)
    // rgb(1 2 3 / 50%)
    // Hence because the first three values are always consistent integers and the fourth is irrelevant, it is simpler to
    // parse the first three integers and use them accordingly
    static parseFirstThreeIntegersFromString(color) {
        if (color.length < $aa79424c46e71ace$exports.MAX_COLOR_INPUT_STRING_LENGTH) {
            const regexResult = color.match($c2b8275b6ad654a0$exports.MATCH_INTEGER_AND_FLOAT_NUMBERS);
            $c2b8275b6ad654a0$exports.MATCH_INTEGER_AND_FLOAT_NUMBERS.lastIndex = 0;
            if (regexResult && regexResult.length >= 3) return regexResult.slice(0, 3).map((numberString)=>Number.parseInt(numberString));
        }
        return null;
    }
    static validateAndParseRgb(rgbString) {
        const rgb = $c3de6fb9444b0e4c$var$ColorParser.parseFirstThreeIntegersFromString(rgbString);
        if (rgb && rgb[0] >= 0 && rgb[0] <= 255 && rgb[1] >= 0 && rgb[1] <= 255 && rgb[2] >= 0 && rgb[2] <= 255) return {
            color: rgb
        };
        return {
            errorMessage: $1V2eF.ErrorHandling.generateInputErrorMessage($f4ycg.ColorTypes.RGB, rgbString, $j1wjX.ColorFormats.RGB)
        };
    }
    static validateAndParseHsl(hslString) {
        const hsl = $c3de6fb9444b0e4c$var$ColorParser.parseFirstThreeIntegersFromString(hslString);
        if (hsl && hsl[0] >= 0 && hsl[0] <= 360 && hsl[1] >= 0 && hsl[1] <= 100 && hsl[2] >= 0 && hsl[2] <= 100) return {
            color: hsl
        };
        return {
            errorMessage: $1V2eF.ErrorHandling.generateInputErrorMessage($f4ycg.ColorTypes.HSL, hslString, $j1wjX.ColorFormats.HSL)
        };
    }
    static validateAndParseKeyword(keyword) {
        if (keyword.length < $aa79424c46e71ace$exports.MAX_COLOR_INPUT_STRING_LENGTH) {
            const isValid = $c3de6fb9444b0e4c$var$color_name_1.default[keyword];
            if (isValid) return {
                color: keyword
            };
        }
        return {
            errorMessage: $1V2eF.ErrorHandling.generateInputErrorMessage($f4ycg.ColorTypes.KEYWORD, keyword, $j1wjX.ColorFormats.KEYWORD)
        };
    }
}
$c3de6fb9444b0e4c$exports.ColorParser = $c3de6fb9444b0e4c$var$ColorParser; // There is a unique opportunity to validate the color input when this library operates in the browser
 // by creating a new element on the dom and adding the color to it to see if it is valid.
 // However it was decided not to use this approach as formats like hsl(1,2,3) are invalid in html elements.
 // Additionally, it can also be time consuming to create/find an element, adding color to it and validating
 // that color.



const $e65e75cd5d3cab3e$var$color_convert_1 = $e65e75cd5d3cab3e$var$__importDefault((parcelRequire("dO2Xp")));
class $e65e75cd5d3cab3e$var$ColorToFilter {
    static rgbToFilter(rgbString, options) {
        return $62b19baf7b5b315c$exports.RgbToFilter.convert({
            colorString: rgbString,
            validateAndParse: $c3de6fb9444b0e4c$exports.ColorParser.validateAndParseRgb,
            addSheen: $f7c1f69687298974$exports.SheenUtil.parseSheenFromOptions(options)
        });
    }
    static hexToFilter(hexString, options) {
        return $62b19baf7b5b315c$exports.RgbToFilter.convert({
            colorString: hexString,
            validateAndParse: $c3de6fb9444b0e4c$exports.ColorParser.validateAndParseHex,
            convertToRgb: $e65e75cd5d3cab3e$var$color_convert_1.default.hex.rgb,
            addSheen: $f7c1f69687298974$exports.SheenUtil.parseSheenFromOptions(options)
        });
    }
    static hslToFilter(hslString, options) {
        return $62b19baf7b5b315c$exports.RgbToFilter.convert({
            colorString: hslString,
            validateAndParse: $c3de6fb9444b0e4c$exports.ColorParser.validateAndParseHsl,
            convertToRgb: $e65e75cd5d3cab3e$var$color_convert_1.default.hsl.rgb,
            addSheen: $f7c1f69687298974$exports.SheenUtil.parseSheenFromOptions(options)
        });
    }
    static keywordToFilter(keyword, options) {
        return $62b19baf7b5b315c$exports.RgbToFilter.convert({
            colorString: keyword,
            validateAndParse: $c3de6fb9444b0e4c$exports.ColorParser.validateAndParseKeyword,
            convertToRgb: $e65e75cd5d3cab3e$var$color_convert_1.default.keyword.rgb,
            conversionErrorMessage: $1V2eF.ErrorHandling.generateInputErrorMessage($f4ycg.ColorTypes.KEYWORD, keyword),
            addSheen: $f7c1f69687298974$exports.SheenUtil.parseSheenFromOptions(options)
        });
    }
}
$e65e75cd5d3cab3e$exports.ColorToFilter = $e65e75cd5d3cab3e$var$ColorToFilter;


var $cb215e0e5ce3feab$exports = {};
"use strict";
Object.defineProperty($cb215e0e5ce3feab$exports, "__esModule", {
    value: true
});
$cb215e0e5ce3feab$exports.FilterToColor = void 0;
var $3f291c39be12d003$exports = {};
"use strict";
var $3f291c39be12d003$var$__createBinding = $3f291c39be12d003$exports && $3f291c39be12d003$exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, {
        enumerable: true,
        get: function() {
            return m[k];
        }
    });
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $3f291c39be12d003$var$__setModuleDefault = $3f291c39be12d003$exports && $3f291c39be12d003$exports.__setModuleDefault || (Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
});
var $3f291c39be12d003$var$__importStar = $3f291c39be12d003$exports && $3f291c39be12d003$exports.__importStar || function(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) $3f291c39be12d003$var$__createBinding(result, mod, k);
    }
    $3f291c39be12d003$var$__setModuleDefault(result, mod);
    return result;
};
Object.defineProperty($3f291c39be12d003$exports, "__esModule", {
    value: true
});
$3f291c39be12d003$exports.FilterToHex = void 0;

var $1V2eF = parcelRequire("1V2eF");
var $37f182ccd50dd4ca$exports = {};
"use strict";
var $37f182ccd50dd4ca$var$__createBinding = $37f182ccd50dd4ca$exports && $37f182ccd50dd4ca$exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, {
        enumerable: true,
        get: function() {
            return m[k];
        }
    });
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $37f182ccd50dd4ca$var$__setModuleDefault = $37f182ccd50dd4ca$exports && $37f182ccd50dd4ca$exports.__setModuleDefault || (Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
});
var $37f182ccd50dd4ca$var$__importStar = $37f182ccd50dd4ca$exports && $37f182ccd50dd4ca$exports.__importStar || function(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) $37f182ccd50dd4ca$var$__createBinding(result, mod, k);
    }
    $37f182ccd50dd4ca$var$__setModuleDefault(result, mod);
    return result;
};
Object.defineProperty($37f182ccd50dd4ca$exports, "__esModule", {
    value: true
});
$37f182ccd50dd4ca$exports.FilterToHexBrowser = void 0;

var $1V2eF = parcelRequire("1V2eF");

var $gDx9E = parcelRequire("gDx9E");

class $37f182ccd50dd4ca$var$FilterToHexBrowser extends $gDx9E.FilterToHexShared {
    static cleanup(svgContainerElement) {
        svgContainerElement.remove();
    }
    static returnInputError(filterString, svgContainerElement) {
        const errorMessage = $gDx9E.FilterToHexShared.generateInputErrorMessage(filterString);
        const errorResult = $1V2eF.ErrorHandling.generateErrorResult(errorMessage);
        $37f182ccd50dd4ca$var$FilterToHexBrowser.cleanup(svgContainerElement);
        return errorResult;
    }
    static async getImageBase64ViaSVG(svgContainerElement) {
        const domToImage = await Promise.resolve().then(function() {
            return (parcelRequire("h0THN"));
        }).then((res)=>$37f182ccd50dd4ca$var$__importStar(res));
        return domToImage.toPng(svgContainerElement);
    }
    static async convert(filterString) {
        const { errorMessage: errorMessage, svgContainerElement: svgContainerElement } = $gDx9E.FilterToHexShared.addSVGElementsToDOMAndValidateFilter(filterString);
        if (errorMessage) return $37f182ccd50dd4ca$var$FilterToHexBrowser.returnInputError(filterString, svgContainerElement);
        const base64EncodedDataURL = await $37f182ccd50dd4ca$var$FilterToHexBrowser.getImageBase64ViaSVG(svgContainerElement);
        const hexColor = await $gDx9E.FilterToHexShared.getColorViaImageDataURL(base64EncodedDataURL);
        $37f182ccd50dd4ca$var$FilterToHexBrowser.cleanup(svgContainerElement);
        return {
            color: hexColor
        };
    }
}
$37f182ccd50dd4ca$exports.FilterToHexBrowser = $37f182ccd50dd4ca$var$FilterToHexBrowser;



class $3f291c39be12d003$var$FilterToHex {
    static async convert(filterString, convertFromHex, options) {
        try {
            let result;
            if (typeof window === "undefined") {
                const { FilterToHexNode: FilterToHexNode } = await Promise.resolve().then(function() {
                    return (parcelRequire("gLWJ8"));
                }).then((res)=>$3f291c39be12d003$var$__importStar(res));
                result = await FilterToHexNode.convert(filterString);
            } else result = await $37f182ccd50dd4ca$exports.FilterToHexBrowser.convert(filterString);
            if (result.color && convertFromHex && typeof result.color === "string") result.color = convertFromHex(result.color, options);
            return result;
        } catch (error) {
            return $1V2eF.ErrorHandling.generateUnexpectedError(error);
        }
    }
}
$3f291c39be12d003$exports.FilterToHex = $3f291c39be12d003$var$FilterToHex;


var $a6a1a51680100389$exports = {};
"use strict";
var $a6a1a51680100389$var$__importDefault = $a6a1a51680100389$exports && $a6a1a51680100389$exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty($a6a1a51680100389$exports, "__esModule", {
    value: true
});
$a6a1a51680100389$exports.HexToColor = void 0;
var $615c777754041951$exports = {};
"use strict";
Object.defineProperty($615c777754041951$exports, "__esModule", {
    value: true
});
$615c777754041951$exports.ColorFormatter = void 0;
class $615c777754041951$var$ColorFormatter {
    static arrayToRgbString(rgbArray) {
        return `rgb(${rgbArray[0]}, ${rgbArray[1]}, ${rgbArray[2]})`;
    }
    static arrayToHslString(hslArray) {
        return `hsl(${hslArray[0]}deg, ${hslArray[1]}%, ${hslArray[2]}%)`;
    }
}
$615c777754041951$exports.ColorFormatter = $615c777754041951$var$ColorFormatter;



const $a6a1a51680100389$var$color_convert_1 = $a6a1a51680100389$var$__importDefault((parcelRequire("dO2Xp")));
class $a6a1a51680100389$var$HexToColor {
    static convertToRgb(color, options) {
        const result = $a6a1a51680100389$var$color_convert_1.default.hex.rgb(color);
        return (options === null || options === void 0 ? void 0 : options.resultType) === "string" ? $615c777754041951$exports.ColorFormatter.arrayToRgbString(result) : result;
    }
    static convertToHsl(color, options) {
        const result = $a6a1a51680100389$var$color_convert_1.default.hex.hsl(color);
        return (options === null || options === void 0 ? void 0 : options.resultType) === "string" ? $615c777754041951$exports.ColorFormatter.arrayToHslString(result) : result;
    }
}
$a6a1a51680100389$exports.HexToColor = $a6a1a51680100389$var$HexToColor;


class $cb215e0e5ce3feab$var$FilterToColor {
    static async filterToHex(filterString) {
        const result = await $3f291c39be12d003$exports.FilterToHex.convert(filterString);
        if (result.color) result.color = result.color.toUpperCase();
        return result;
    }
    static async filterToRgb(filterString, options) {
        return $3f291c39be12d003$exports.FilterToHex.convert(filterString, $a6a1a51680100389$exports.HexToColor.convertToRgb, options);
    }
    static async filterToHsl(filterString, options) {
        return $3f291c39be12d003$exports.FilterToHex.convert(filterString, $a6a1a51680100389$exports.HexToColor.convertToHsl, options);
    }
}
$cb215e0e5ce3feab$exports.FilterToColor = $cb215e0e5ce3feab$var$FilterToColor;


class $46d5a9f991de27f2$var$CssFilterConverter {
    static rgbToFilter(rgbString, options) {
        return $e65e75cd5d3cab3e$exports.ColorToFilter.rgbToFilter(rgbString, options);
    }
    static hexToFilter(hexString, options) {
        return $e65e75cd5d3cab3e$exports.ColorToFilter.hexToFilter(hexString, options);
    }
    static hslToFilter(hslString, options) {
        return $e65e75cd5d3cab3e$exports.ColorToFilter.hslToFilter(hslString, options);
    }
    static keywordToFilter(keyword, options) {
        return $e65e75cd5d3cab3e$exports.ColorToFilter.keywordToFilter(keyword, options);
    }
    static async filterToHex(filterString) {
        return $cb215e0e5ce3feab$exports.FilterToColor.filterToHex(filterString);
    }
    static async filterToRgb(filterString, options) {
        return $cb215e0e5ce3feab$exports.FilterToColor.filterToRgb(filterString, options);
    }
    static async filterToHsl(filterString, options) {
        return $cb215e0e5ce3feab$exports.FilterToColor.filterToHsl(filterString, options);
    }
}
$46d5a9f991de27f2$exports.default = $46d5a9f991de27f2$var$CssFilterConverter;
$46d5a9f991de27f2$exports = $46d5a9f991de27f2$var$CssFilterConverter;





var $acw62 = parcelRequire("acw62");







var $7cbbe62f175567fd$exports = {};

$parcel$export($7cbbe62f175567fd$exports, "bg", () => $7cbbe62f175567fd$export$136fd86de524d3c2, (v) => $7cbbe62f175567fd$export$136fd86de524d3c2 = v);
$parcel$export($7cbbe62f175567fd$exports, "buy", () => $7cbbe62f175567fd$export$7f8e2b98eca5a7f0, (v) => $7cbbe62f175567fd$export$7f8e2b98eca5a7f0 = v);
$parcel$export($7cbbe62f175567fd$exports, "content", () => $7cbbe62f175567fd$export$a7db06668cad9adb, (v) => $7cbbe62f175567fd$export$a7db06668cad9adb = v);
$parcel$export($7cbbe62f175567fd$exports, "details", () => $7cbbe62f175567fd$export$41ee12f6f6f05843, (v) => $7cbbe62f175567fd$export$41ee12f6f6f05843 = v);
$parcel$export($7cbbe62f175567fd$exports, "image", () => $7cbbe62f175567fd$export$5c452ff88e35e47d, (v) => $7cbbe62f175567fd$export$5c452ff88e35e47d = v);
$parcel$export($7cbbe62f175567fd$exports, "info", () => $7cbbe62f175567fd$export$a80b3bd66acc52ff, (v) => $7cbbe62f175567fd$export$a80b3bd66acc52ff = v);
$parcel$export($7cbbe62f175567fd$exports, "list", () => $7cbbe62f175567fd$export$8837f4fc672e936d, (v) => $7cbbe62f175567fd$export$8837f4fc672e936d = v);
$parcel$export($7cbbe62f175567fd$exports, "loadout", () => $7cbbe62f175567fd$export$9e5fff2546eb9e1a, (v) => $7cbbe62f175567fd$export$9e5fff2546eb9e1a = v);
$parcel$export($7cbbe62f175567fd$exports, "locked", () => $7cbbe62f175567fd$export$b5cac684278fae13, (v) => $7cbbe62f175567fd$export$b5cac684278fae13 = v);
$parcel$export($7cbbe62f175567fd$exports, "tile", () => $7cbbe62f175567fd$export$3c17558da18e4d75, (v) => $7cbbe62f175567fd$export$3c17558da18e4d75 = v);
$parcel$export($7cbbe62f175567fd$exports, "title", () => $7cbbe62f175567fd$export$fb184b623420d9be, (v) => $7cbbe62f175567fd$export$fb184b623420d9be = v);
var $7cbbe62f175567fd$export$136fd86de524d3c2;
var $7cbbe62f175567fd$export$7f8e2b98eca5a7f0;
var $7cbbe62f175567fd$export$a7db06668cad9adb;
var $7cbbe62f175567fd$export$41ee12f6f6f05843;
var $7cbbe62f175567fd$export$5c452ff88e35e47d;
var $7cbbe62f175567fd$export$a80b3bd66acc52ff;
var $7cbbe62f175567fd$export$8837f4fc672e936d;
var $7cbbe62f175567fd$export$9e5fff2546eb9e1a;
var $7cbbe62f175567fd$export$b5cac684278fae13;
var $7cbbe62f175567fd$export$3c17558da18e4d75;
var $7cbbe62f175567fd$export$fb184b623420d9be;
$7cbbe62f175567fd$export$136fd86de524d3c2 = `fGF89a_bg`;
$7cbbe62f175567fd$export$7f8e2b98eca5a7f0 = `fGF89a_buy`;
$7cbbe62f175567fd$export$a7db06668cad9adb = `fGF89a_content`;
$7cbbe62f175567fd$export$41ee12f6f6f05843 = `fGF89a_details`;
$7cbbe62f175567fd$export$5c452ff88e35e47d = `fGF89a_image`;
$7cbbe62f175567fd$export$a80b3bd66acc52ff = `fGF89a_info`;
$7cbbe62f175567fd$export$8837f4fc672e936d = `fGF89a_list`;
$7cbbe62f175567fd$export$9e5fff2546eb9e1a = `fGF89a_loadout`;
$7cbbe62f175567fd$export$b5cac684278fae13 = `fGF89a_locked`;
$7cbbe62f175567fd$export$3c17558da18e4d75 = `fGF89a_tile`;
$7cbbe62f175567fd$export$fb184b623420d9be = `fGF89a_title`;


const $56f58a7885f727b0$var$Content = ({ onSelect: onSelectCallback })=>{
    const { state: { accountInfo: accountInfo } } = (0, $c25623cc446ec3c6$export$ac8576a9912be18c)();
    const [loading, setLoading] = (0, $acw62.useState)();
    const onBuy = async (weaponName)=>{
        const data = await (0, $8e7f75257467a1e7$export$efa13fcf93ec313a)();
        const entry = data[weaponName];
        if ((0, $b3b1baf40467424d$export$745043c7dc65e495).showConfirm) (0, $b3b1baf40467424d$export$745043c7dc65e495).showConfirm({
            title: "Buy weapon",
            text: `Do you really want to buy the weapon for ${entry.levels[0].priceToUnlock.gems} gems?`,
            acceptText: "Yes",
            refuseText: "No",
            async onAccept () {
                setLoading(weaponName);
                const result = await (0, $35a528e84618b070$export$5c66de07daf88ef5)(weaponName);
                if (result?.data && (0, $b3b1baf40467424d$export$745043c7dc65e495).refreshAccountInfo) (0, $b3b1baf40467424d$export$745043c7dc65e495).refreshAccountInfo();
                setLoading(undefined);
            }
        });
    };
    const onSelect = (loadout)=>{
        let weapon = (0, $49736469f58fc92b$export$a0b1da4b3d9a7c29).CommonBlaster;
        switch(loadout){
            case 0:
                weapon = (0, $49736469f58fc92b$export$a0b1da4b3d9a7c29).CommonBlaster;
                break;
            case 1:
                weapon = (0, $49736469f58fc92b$export$a0b1da4b3d9a7c29).MachineGun;
                break;
            case 2:
                weapon = (0, $49736469f58fc92b$export$a0b1da4b3d9a7c29).GanAutoRifle;
                break;
        }
        if (accountInfo?.character.weapons.unlocked[weapon] === undefined) onBuy(weapon);
        else onSelectCallback(loadout);
    };
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: (0, $9805619f03ed02ef$export$91884aa883243770)((0, (/*@__PURE__*/$parcel$interopDefault($7cbbe62f175567fd$exports))), "content"),
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: (0, $9805619f03ed02ef$export$91884aa883243770)((0, (/*@__PURE__*/$parcel$interopDefault($7cbbe62f175567fd$exports))), "list"),
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: (0, $9805619f03ed02ef$export$91884aa883243770)((0, (/*@__PURE__*/$parcel$interopDefault($7cbbe62f175567fd$exports))), "tile"),
                        onClick: ()=>onSelect(0),
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                className: (0, $9805619f03ed02ef$export$91884aa883243770)((0, (/*@__PURE__*/$parcel$interopDefault($7cbbe62f175567fd$exports))), "bg"),
                                style: {
                                    filter: `brightness(0) saturate(100%) ${(0, (/*@__PURE__*/$parcel$interopDefault($46d5a9f991de27f2$exports))).hexToFilter("#FFAC9E").color}` ?? "none"
                                }
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                className: (0, $9805619f03ed02ef$export$91884aa883243770)((0, (/*@__PURE__*/$parcel$interopDefault($7cbbe62f175567fd$exports))), "image"),
                                style: {
                                    backgroundImage: `url('${(0, $0426e2dd5e0de94d$export$24af3971dd36b33f)}/ui/weapons/common_blaster.png')`
                                }
                            }),
                            accountInfo?.character.weapons.unlocked["COMMON_BLASTER"] === undefined && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                className: (0, $9805619f03ed02ef$export$91884aa883243770)((0, (/*@__PURE__*/$parcel$interopDefault($7cbbe62f175567fd$exports))), "buy"),
                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $6725244138e0595f$export$353f5b6fc5456de1), {
                                    onClick: ()=>onBuy((0, $49736469f58fc92b$export$a0b1da4b3d9a7c29).CommonBlaster),
                                    loading: loading === (0, $49736469f58fc92b$export$a0b1da4b3d9a7c29).CommonBlaster,
                                    children: "Buy"
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: (0, $9805619f03ed02ef$export$91884aa883243770)((0, (/*@__PURE__*/$parcel$interopDefault($7cbbe62f175567fd$exports))), "tile"),
                        onClick: ()=>onSelect(1),
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                className: (0, $9805619f03ed02ef$export$91884aa883243770)((0, (/*@__PURE__*/$parcel$interopDefault($7cbbe62f175567fd$exports))), "bg"),
                                style: {
                                    filter: `brightness(0) saturate(100%) ${(0, (/*@__PURE__*/$parcel$interopDefault($46d5a9f991de27f2$exports))).hexToFilter("#83FBFF").color}` ?? "none"
                                }
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                className: (0, $9805619f03ed02ef$export$91884aa883243770)((0, (/*@__PURE__*/$parcel$interopDefault($7cbbe62f175567fd$exports))), "image"),
                                style: {
                                    backgroundImage: `url('${(0, $0426e2dd5e0de94d$export$24af3971dd36b33f)}/ui/weapons/machine_gun.png')`
                                }
                            }),
                            accountInfo?.character.weapons.unlocked["MACHINE_GUN"] === undefined && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                className: (0, $9805619f03ed02ef$export$91884aa883243770)((0, (/*@__PURE__*/$parcel$interopDefault($7cbbe62f175567fd$exports))), "buy"),
                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $6725244138e0595f$export$353f5b6fc5456de1), {
                                    onClick: ()=>onBuy((0, $49736469f58fc92b$export$a0b1da4b3d9a7c29).MachineGun),
                                    loading: loading === (0, $49736469f58fc92b$export$a0b1da4b3d9a7c29).MachineGun,
                                    children: "Buy"
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: (0, $9805619f03ed02ef$export$91884aa883243770)((0, (/*@__PURE__*/$parcel$interopDefault($7cbbe62f175567fd$exports))), "tile"),
                        onClick: ()=>onSelect(2),
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                className: (0, $9805619f03ed02ef$export$91884aa883243770)((0, (/*@__PURE__*/$parcel$interopDefault($7cbbe62f175567fd$exports))), "bg"),
                                style: {
                                    filter: `brightness(0) saturate(100%) ${(0, (/*@__PURE__*/$parcel$interopDefault($46d5a9f991de27f2$exports))).hexToFilter("#ffe374").color}` ?? "none"
                                }
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                className: (0, $9805619f03ed02ef$export$91884aa883243770)((0, (/*@__PURE__*/$parcel$interopDefault($7cbbe62f175567fd$exports))), "image"),
                                style: {
                                    backgroundImage: `url('${(0, $0426e2dd5e0de94d$export$24af3971dd36b33f)}/ui/weapons/gan_auto_rifle.png')`
                                }
                            }),
                            accountInfo?.character.weapons.unlocked["GAN_AUTO_RIFLE"] === undefined && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                className: (0, $9805619f03ed02ef$export$91884aa883243770)((0, (/*@__PURE__*/$parcel$interopDefault($7cbbe62f175567fd$exports))), "buy"),
                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $6725244138e0595f$export$353f5b6fc5456de1), {
                                    onClick: ()=>onBuy((0, $49736469f58fc92b$export$a0b1da4b3d9a7c29).GanAutoRifle),
                                    loading: loading === (0, $49736469f58fc92b$export$a0b1da4b3d9a7c29).GanAutoRifle,
                                    children: "Buy"
                                })
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: (0, $9805619f03ed02ef$export$91884aa883243770)((0, (/*@__PURE__*/$parcel$interopDefault($7cbbe62f175567fd$exports))), "list info"),
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        children: "Blaster"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        children: "Machine Gun"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        children: "Gan Auto Rifle"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: (0, $9805619f03ed02ef$export$91884aa883243770)((0, (/*@__PURE__*/$parcel$interopDefault($7cbbe62f175567fd$exports))), "list details"),
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                children: "- Slow fire"
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                children: "- Mid range"
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                children: "- Low damages"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                children: "- Rapid fire"
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                children: "- Short range"
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                children: "- Low damages"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                children: "- Rapid fire"
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                children: "- Long range"
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                children: "- High damages"
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
const $56f58a7885f727b0$var$Title = ({ onClose: onClose })=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: (0, $9805619f03ed02ef$export$91884aa883243770)((0, (/*@__PURE__*/$parcel$interopDefault($7cbbe62f175567fd$exports))), "title"),
        children: [
            "Select your loadout",
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                src: `${(0, $0426e2dd5e0de94d$export$24af3971dd36b33f)}/ui/cross.png`,
                alt: "cross",
                onClick: onClose
            })
        ]
    });
const $56f58a7885f727b0$export$f1c1812ed2ac1602 = ({ className: className, onClose: onClose, onSelect: onSelect, show: show, ...props })=>{
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $207d23274fe2be11$export$6e63c1000ecf9db8), {
        className: (0, $9805619f03ed02ef$export$91884aa883243770)((0, (/*@__PURE__*/$parcel$interopDefault($7cbbe62f175567fd$exports))), `loadout ${className}`),
        title: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($56f58a7885f727b0$var$Title, {
            onClose: onClose
        }),
        content: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($56f58a7885f727b0$var$Content, {
            onSelect: onSelect
        }),
        onClickBackground: onClose,
        show: show,
        ...props
    });
};


var $8235497fcd77437e$exports = {};

$parcel$export($8235497fcd77437e$exports, "button-container", () => $8235497fcd77437e$export$4f7a98834621a1a, (v) => $8235497fcd77437e$export$4f7a98834621a1a = v);
$parcel$export($8235497fcd77437e$exports, "content", () => $8235497fcd77437e$export$a7db06668cad9adb, (v) => $8235497fcd77437e$export$a7db06668cad9adb = v);
$parcel$export($8235497fcd77437e$exports, "game-mode", () => $8235497fcd77437e$export$d212ab138ee3751c, (v) => $8235497fcd77437e$export$d212ab138ee3751c = v);
$parcel$export($8235497fcd77437e$exports, "gems", () => $8235497fcd77437e$export$b7dcc03c39461775, (v) => $8235497fcd77437e$export$b7dcc03c39461775 = v);
$parcel$export($8235497fcd77437e$exports, "image", () => $8235497fcd77437e$export$5c452ff88e35e47d, (v) => $8235497fcd77437e$export$5c452ff88e35e47d = v);
$parcel$export($8235497fcd77437e$exports, "multi", () => $8235497fcd77437e$export$13e2537ceeaf8a3a, (v) => $8235497fcd77437e$export$13e2537ceeaf8a3a = v);
$parcel$export($8235497fcd77437e$exports, "single", () => $8235497fcd77437e$export$863d7ca51b416cee, (v) => $8235497fcd77437e$export$863d7ca51b416cee = v);
$parcel$export($8235497fcd77437e$exports, "title", () => $8235497fcd77437e$export$fb184b623420d9be, (v) => $8235497fcd77437e$export$fb184b623420d9be = v);
var $8235497fcd77437e$export$4f7a98834621a1a;
var $8235497fcd77437e$export$a7db06668cad9adb;
var $8235497fcd77437e$export$d212ab138ee3751c;
var $8235497fcd77437e$export$b7dcc03c39461775;
var $8235497fcd77437e$export$5c452ff88e35e47d;
var $8235497fcd77437e$export$13e2537ceeaf8a3a;
var $8235497fcd77437e$export$863d7ca51b416cee;
var $8235497fcd77437e$export$fb184b623420d9be;
$8235497fcd77437e$export$4f7a98834621a1a = `eKIoIq_button-container`;
$8235497fcd77437e$export$a7db06668cad9adb = `eKIoIq_content`;
$8235497fcd77437e$export$d212ab138ee3751c = `eKIoIq_game-mode`;
$8235497fcd77437e$export$b7dcc03c39461775 = `eKIoIq_gems`;
$8235497fcd77437e$export$5c452ff88e35e47d = `eKIoIq_image`;
$8235497fcd77437e$export$13e2537ceeaf8a3a = `eKIoIq_multi`;
$8235497fcd77437e$export$863d7ca51b416cee = `eKIoIq_single`;
$8235497fcd77437e$export$fb184b623420d9be = `eKIoIq_title`;


const $0a84c922bdcca86d$var$Content = ({ mode: mode, loadout: loadout, openConfirmGame: openConfirmGame, openLobby: openLobby, onClose: onClose })=>{
    const { state: { sessionToken: sessionToken, accountInfo: accountInfo }, dispatch: dispatch } = (0, $c25623cc446ec3c6$export$ac8576a9912be18c)();
    const launchSolo = async ()=>{
        if (!sessionToken) return;
        openConfirmGame(async (confirmed)=>{
            if (confirmed && (0, $b3b1baf40467424d$export$745043c7dc65e495).showLoading) {
                (0, $b3b1baf40467424d$export$745043c7dc65e495).showLoading(true);
                try {
                    const serverURL = await (0, $631a100c3bfebc62$export$e5629f326cfe53f6)(sessionToken, mode, dispatch, loadout);
                    dispatch({
                        type: "SET_LAST_SERVER_URL",
                        lastServerURL: serverURL
                    });
                } catch (err) {
                    (0, $ad26fe773541dcd3$export$b410431fab84fa58).error("Impossible to create the room, please try again later or contact the support team");
                }
                if ((0, $b3b1baf40467424d$export$745043c7dc65e495).showLoading) (0, $b3b1baf40467424d$export$745043c7dc65e495).showLoading(false);
            } else onClose();
        });
    };
    const launchMulti = ()=>{
        openConfirmGame((confirmed)=>{
            if (confirmed) openLobby(mode, loadout);
            else onClose();
        });
    };
    const [loading, setLoading] = (0, $acw62.useState)(false);
    const unlockMultiplayer = async ()=>{
        if ((0, $b3b1baf40467424d$export$745043c7dc65e495).showConfirm) (0, $b3b1baf40467424d$export$745043c7dc65e495).showConfirm({
            title: "Unlock multiplayer",
            text: "Are you sure you want to pay 50 gems to unlock the multiplayer?",
            acceptText: "yes",
            refuseText: "no",
            async onAccept () {
                setLoading(true);
                const result = await (0, $35a528e84618b070$export$c6443615f35b2a2c)();
                if (result?.data && (0, $b3b1baf40467424d$export$745043c7dc65e495).refreshAccountInfo) (0, $b3b1baf40467424d$export$745043c7dc65e495).refreshAccountInfo();
                setLoading(false);
            }
        });
    };
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: (0, $9805619f03ed02ef$export$91884aa883243770)((0, (/*@__PURE__*/$parcel$interopDefault($8235497fcd77437e$exports))), "content"),
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: (0, $9805619f03ed02ef$export$91884aa883243770)((0, (/*@__PURE__*/$parcel$interopDefault($8235497fcd77437e$exports))), "single"),
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        className: (0, $9805619f03ed02ef$export$91884aa883243770)((0, (/*@__PURE__*/$parcel$interopDefault($8235497fcd77437e$exports))), "image"),
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                            src: `${(0, $0426e2dd5e0de94d$export$24af3971dd36b33f)}/ui/single-mode.png`,
                            alt: "multi"
                        })
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: (0, $9805619f03ed02ef$export$91884aa883243770)((0, (/*@__PURE__*/$parcel$interopDefault($8235497fcd77437e$exports))), "button-container"),
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                children: "Single player"
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $6725244138e0595f$export$353f5b6fc5456de1), {
                                onClick: launchSolo,
                                children: "single"
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: (0, $9805619f03ed02ef$export$91884aa883243770)((0, (/*@__PURE__*/$parcel$interopDefault($8235497fcd77437e$exports))), "multi"),
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        className: (0, $9805619f03ed02ef$export$91884aa883243770)((0, (/*@__PURE__*/$parcel$interopDefault($8235497fcd77437e$exports))), "image"),
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                            src: `${(0, $0426e2dd5e0de94d$export$24af3971dd36b33f)}/ui/multi-mode.png`,
                            alt: "multi"
                        })
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: (0, $9805619f03ed02ef$export$91884aa883243770)((0, (/*@__PURE__*/$parcel$interopDefault($8235497fcd77437e$exports))), "button-container"),
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                children: "Multi player"
                            }),
                            accountInfo?.unlockedMultiplayer || mode === "clash" ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $6725244138e0595f$export$353f5b6fc5456de1), {
                                onClick: launchMulti,
                                children: "multi"
                            }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $6725244138e0595f$export$353f5b6fc5456de1), {
                                className: (0, $9805619f03ed02ef$export$91884aa883243770)((0, (/*@__PURE__*/$parcel$interopDefault($8235497fcd77437e$exports))), "gems gray"),
                                onClick: unlockMultiplayer,
                                loading: loading,
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                        children: "UNLOCK FOR"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                                                src: `${(0, $0426e2dd5e0de94d$export$24af3971dd36b33f)}/ui/gem.png`,
                                                alt: "gems"
                                            }),
                                            "50"
                                        ]
                                    })
                                ]
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
const $0a84c922bdcca86d$var$Title = ({ onClose: onClose })=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: (0, $9805619f03ed02ef$export$91884aa883243770)((0, (/*@__PURE__*/$parcel$interopDefault($8235497fcd77437e$exports))), "title"),
        children: [
            "Select a mode",
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                src: `${(0, $0426e2dd5e0de94d$export$24af3971dd36b33f)}/ui/cross.png`,
                alt: "cross",
                onClick: onClose
            })
        ]
    });
const $0a84c922bdcca86d$export$7cd7a93136e7148a = ({ className: className, onClose: onClose, openLobby: openLobby, show: show, ...props })=>{
    const [showConfirmGame, setShowConfirmGame] = (0, $acw62.useState)(false);
    const [showGameType, setShowGameType] = (0, $acw62.useState)(false);
    const [showLoadout, setShowLoadout] = (0, $acw62.useState)(false);
    const [gameType, setGameType] = (0, $acw62.useState)();
    const [loadout, setLoadout] = (0, $acw62.useState)();
    const [showTuto, setShowTuto] = (0, $acw62.useState)(true);
    const [confirmGameCallback, setConfirmGameCallback] = (0, $acw62.useState)();
    (0, $acw62.useEffect)(()=>{
        if (show) {
            setGameType(undefined);
            setShowGameType(true);
            setLoadout(undefined);
        }
    }, [
        show
    ]);
    const openConfirmGame = (callback)=>{
        setConfirmGameCallback(()=>callback);
        setShowConfirmGame(true);
    };
    const onOpenLobby = (mode, loadout)=>{
        setShowConfirmGame(false);
        openLobby(mode, loadout);
    };
    const selectGameType = (type)=>{
        setGameType(type);
        setShowGameType(false);
        if (type === "clash") setShowLoadout(true);
    };
    const selectLoadout = (loadout)=>{
        setLoadout(loadout);
        setShowLoadout(false);
    };
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $207d23274fe2be11$export$6e63c1000ecf9db8), {
                className: (0, $9805619f03ed02ef$export$91884aa883243770)((0, (/*@__PURE__*/$parcel$interopDefault($8235497fcd77437e$exports))), `game-mode ${className}`),
                title: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($0a84c922bdcca86d$var$Title, {
                    onClose: onClose
                }),
                content: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($0a84c922bdcca86d$var$Content, {
                    mode: gameType ?? "score",
                    loadout: loadout,
                    openConfirmGame: openConfirmGame,
                    openLobby: onOpenLobby,
                    onClose: onClose
                }),
                onClickBackground: onClose,
                show: show,
                ...props
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $389920e14c601f6f$export$45c4ca16caeed66b), {
                show: show && !localStorage.getItem("tuto") && showTuto,
                onClose: ()=>{
                    localStorage.setItem("tuto", "done");
                    setShowTuto(false);
                }
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $565e58bc0a4c0b2b$export$e7a4d22d9ec76989), {
                show: showGameType,
                onClose: ()=>{
                    setShowGameType(false);
                    if (!gameType) onClose();
                },
                onSelect: selectGameType
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $56f58a7885f727b0$export$f1c1812ed2ac1602), {
                show: showLoadout,
                onClose: ()=>{
                    setShowLoadout(false);
                    if (loadout !== undefined) onClose();
                },
                onSelect: selectLoadout
            }),
            gameType && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7b02d682eb115277$exports.Fragment), {
                children: gameType === "score" ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $4eb8d2f3208bede8$export$809c58c36f4d69bd), {
                    show: showConfirmGame,
                    onClose: ()=>setShowConfirmGame(false),
                    callback: confirmGameCallback
                }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $a576f75f1a522661$export$3719b54e275aa330), {
                    show: showConfirmGame,
                    onClose: ()=>setShowConfirmGame(false),
                    callback: confirmGameCallback
                })
            })
        ]
    });
};






var $acw62 = parcelRequire("acw62");












var $acw62 = parcelRequire("acw62");






var $f7cdbb07f7053351$exports = {};

$parcel$export($f7cdbb07f7053351$exports, "bg", () => $f7cdbb07f7053351$export$136fd86de524d3c2, (v) => $f7cdbb07f7053351$export$136fd86de524d3c2 = v);
$parcel$export($f7cdbb07f7053351$exports, "content", () => $f7cdbb07f7053351$export$a7db06668cad9adb, (v) => $f7cdbb07f7053351$export$a7db06668cad9adb = v);
$parcel$export($f7cdbb07f7053351$exports, "create-room-button", () => $f7cdbb07f7053351$export$78ff9e2da5fea638, (v) => $f7cdbb07f7053351$export$78ff9e2da5fea638 = v);
$parcel$export($f7cdbb07f7053351$exports, "create-room-modal", () => $f7cdbb07f7053351$export$eab198e0dad6d8b0, (v) => $f7cdbb07f7053351$export$eab198e0dad6d8b0 = v);
$parcel$export($f7cdbb07f7053351$exports, "entry", () => $f7cdbb07f7053351$export$c407db72103fecfa, (v) => $f7cdbb07f7053351$export$c407db72103fecfa = v);
$parcel$export($f7cdbb07f7053351$exports, "form", () => $f7cdbb07f7053351$export$6210fa4921d2a466, (v) => $f7cdbb07f7053351$export$6210fa4921d2a466 = v);
$parcel$export($f7cdbb07f7053351$exports, "multi-button", () => $f7cdbb07f7053351$export$1fbfc406395df0a, (v) => $f7cdbb07f7053351$export$1fbfc406395df0a = v);
$parcel$export($f7cdbb07f7053351$exports, "selected", () => $f7cdbb07f7053351$export$d90250155de6d7e7, (v) => $f7cdbb07f7053351$export$d90250155de6d7e7 = v);
$parcel$export($f7cdbb07f7053351$exports, "text", () => $f7cdbb07f7053351$export$6f093cfa640b7166, (v) => $f7cdbb07f7053351$export$6f093cfa640b7166 = v);
$parcel$export($f7cdbb07f7053351$exports, "title", () => $f7cdbb07f7053351$export$fb184b623420d9be, (v) => $f7cdbb07f7053351$export$fb184b623420d9be = v);
var $f7cdbb07f7053351$export$136fd86de524d3c2;
var $f7cdbb07f7053351$export$a7db06668cad9adb;
var $f7cdbb07f7053351$export$78ff9e2da5fea638;
var $f7cdbb07f7053351$export$eab198e0dad6d8b0;
var $f7cdbb07f7053351$export$c407db72103fecfa;
var $f7cdbb07f7053351$export$6210fa4921d2a466;
var $f7cdbb07f7053351$export$1fbfc406395df0a;
var $f7cdbb07f7053351$export$d90250155de6d7e7;
var $f7cdbb07f7053351$export$6f093cfa640b7166;
var $f7cdbb07f7053351$export$fb184b623420d9be;
$f7cdbb07f7053351$export$136fd86de524d3c2 = `lnvG6q_bg`;
$f7cdbb07f7053351$export$a7db06668cad9adb = `lnvG6q_content`;
$f7cdbb07f7053351$export$78ff9e2da5fea638 = `lnvG6q_create-room-button`;
$f7cdbb07f7053351$export$eab198e0dad6d8b0 = `lnvG6q_create-room-modal`;
$f7cdbb07f7053351$export$c407db72103fecfa = `lnvG6q_entry`;
$f7cdbb07f7053351$export$6210fa4921d2a466 = `lnvG6q_form`;
$f7cdbb07f7053351$export$1fbfc406395df0a = `lnvG6q_multi-button`;
$f7cdbb07f7053351$export$d90250155de6d7e7 = `lnvG6q_selected`;
$f7cdbb07f7053351$export$6f093cfa640b7166 = `lnvG6q_text`;
$f7cdbb07f7053351$export$fb184b623420d9be = `lnvG6q_title`;


const $cffed08bb11701f2$var$Content = ({ onCreate: onCreate })=>{
    const [name, setName] = (0, $acw62.useState)("");
    const [password, setPassword] = (0, $acw62.useState)("");
    const [maxPlayers, setMaxPlayers] = (0, $acw62.useState)(2);
    const [creating, setCreating] = (0, $acw62.useState)(false);
    const createRoom = async ()=>{
        if (creating) return;
        if (name.length < 7) {
            (0, $ad26fe773541dcd3$export$b410431fab84fa58).error("Room name too short, min 6 characters");
            return;
        }
        setCreating(true);
        if ((0, $b3b1baf40467424d$export$745043c7dc65e495).showLoading) (0, $b3b1baf40467424d$export$745043c7dc65e495).showLoading(true);
        const roomInfo = {
            name: name,
            mode: "score",
            maxPlayers: maxPlayers
        };
        try {
            await onCreate(roomInfo, password);
        } catch (err) {
            (0, $ad26fe773541dcd3$export$b410431fab84fa58).error("Impossible to create the room, please try again later or contact the support team");
        } finally{
            if ((0, $b3b1baf40467424d$export$745043c7dc65e495).showLoading) (0, $b3b1baf40467424d$export$745043c7dc65e495).showLoading(false);
        }
        setCreating(false);
    };
    const nameChange = (event)=>{
        setName(event.target.value);
    };
    const passwordChange = (event)=>{
        setPassword(event.target.value);
    };
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: (0, $9805619f03ed02ef$export$91884aa883243770)((0, (/*@__PURE__*/$parcel$interopDefault($f7cdbb07f7053351$exports))), "content"),
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: (0, $9805619f03ed02ef$export$91884aa883243770)((0, (/*@__PURE__*/$parcel$interopDefault($f7cdbb07f7053351$exports))), "form"),
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: (0, $9805619f03ed02ef$export$91884aa883243770)((0, (/*@__PURE__*/$parcel$interopDefault($f7cdbb07f7053351$exports))), "entry"),
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                className: (0, $9805619f03ed02ef$export$91884aa883243770)((0, (/*@__PURE__*/$parcel$interopDefault($f7cdbb07f7053351$exports))), "title"),
                                children: "Room name*"
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $863b21ed6a3b3d61$export$f5b8910cec6cf069), {
                                type: "text",
                                maxLength: 32,
                                placeholder: "Room name (min 6 chars)",
                                value: name,
                                onChange: nameChange,
                                autoFocus: true
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: (0, $9805619f03ed02ef$export$91884aa883243770)((0, (/*@__PURE__*/$parcel$interopDefault($f7cdbb07f7053351$exports))), "entry"),
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                className: (0, $9805619f03ed02ef$export$91884aa883243770)((0, (/*@__PURE__*/$parcel$interopDefault($f7cdbb07f7053351$exports))), "title"),
                                children: "Password"
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $863b21ed6a3b3d61$export$f5b8910cec6cf069), {
                                type: "password",
                                maxLength: 32,
                                placeholder: "Leave empty for a public room",
                                value: password,
                                onChange: passwordChange
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: (0, $9805619f03ed02ef$export$91884aa883243770)((0, (/*@__PURE__*/$parcel$interopDefault($f7cdbb07f7053351$exports))), "entry"),
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                className: (0, $9805619f03ed02ef$export$91884aa883243770)((0, (/*@__PURE__*/$parcel$interopDefault($f7cdbb07f7053351$exports))), "title"),
                                children: "Number of players*"
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: (0, $9805619f03ed02ef$export$91884aa883243770)((0, (/*@__PURE__*/$parcel$interopDefault($f7cdbb07f7053351$exports))), "multi-button"),
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                        className: (0, $9805619f03ed02ef$export$91884aa883243770)((0, (/*@__PURE__*/$parcel$interopDefault($f7cdbb07f7053351$exports))), `${maxPlayers === 2 && "selected"}`),
                                        onClick: ()=>setMaxPlayers(2),
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                className: (0, $9805619f03ed02ef$export$91884aa883243770)((0, (/*@__PURE__*/$parcel$interopDefault($f7cdbb07f7053351$exports))), "bg")
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                className: (0, $9805619f03ed02ef$export$91884aa883243770)((0, (/*@__PURE__*/$parcel$interopDefault($f7cdbb07f7053351$exports))), "text"),
                                                children: "2"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                        className: (0, $9805619f03ed02ef$export$91884aa883243770)((0, (/*@__PURE__*/$parcel$interopDefault($f7cdbb07f7053351$exports))), `${maxPlayers === 3 && "selected"}`),
                                        onClick: ()=>setMaxPlayers(3),
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                className: (0, $9805619f03ed02ef$export$91884aa883243770)((0, (/*@__PURE__*/$parcel$interopDefault($f7cdbb07f7053351$exports))), "bg")
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                className: (0, $9805619f03ed02ef$export$91884aa883243770)((0, (/*@__PURE__*/$parcel$interopDefault($f7cdbb07f7053351$exports))), "text"),
                                                children: "3"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                        className: (0, $9805619f03ed02ef$export$91884aa883243770)((0, (/*@__PURE__*/$parcel$interopDefault($f7cdbb07f7053351$exports))), `${maxPlayers === 4 && "selected"}`),
                                        onClick: ()=>setMaxPlayers(4),
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                className: (0, $9805619f03ed02ef$export$91884aa883243770)((0, (/*@__PURE__*/$parcel$interopDefault($f7cdbb07f7053351$exports))), "bg")
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                className: (0, $9805619f03ed02ef$export$91884aa883243770)((0, (/*@__PURE__*/$parcel$interopDefault($f7cdbb07f7053351$exports))), "text"),
                                                children: "4"
                                            })
                                        ]
                                    })
                                ]
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $6725244138e0595f$export$e1c22a2ee2645e36), {
                className: (0, $9805619f03ed02ef$export$91884aa883243770)((0, (/*@__PURE__*/$parcel$interopDefault($f7cdbb07f7053351$exports))), "create-room-button"),
                icon: "circle-plus",
                onClick: createRoom,
                disabled: creating,
                children: "create"
            })
        ]
    });
};
const $cffed08bb11701f2$var$Title = ({ onClose: onClose })=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: (0, $9805619f03ed02ef$export$91884aa883243770)((0, (/*@__PURE__*/$parcel$interopDefault($f7cdbb07f7053351$exports))), "title"),
        children: [
            "Create your room",
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                src: `${(0, $0426e2dd5e0de94d$export$24af3971dd36b33f)}/ui/cross.png`,
                alt: "cross",
                onClick: onClose
            })
        ]
    });
const $cffed08bb11701f2$export$843bb69f42d9dd52 = ({ onCreate: onCreate, onClose: onClose, className: className, ...props })=>{
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $207d23274fe2be11$export$6e63c1000ecf9db8), {
        className: (0, $9805619f03ed02ef$export$91884aa883243770)((0, (/*@__PURE__*/$parcel$interopDefault($f7cdbb07f7053351$exports))), `create-room-modal ${className}`),
        title: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($cffed08bb11701f2$var$Title, {
            onClose: onClose
        }),
        content: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($cffed08bb11701f2$var$Content, {
            onCreate: onCreate
        }),
        ...props
    });
};


var $7e51696272f0b48e$exports = {};

$parcel$export($7e51696272f0b48e$exports, "actions", () => $7e51696272f0b48e$export$e324594224ef24da, (v) => $7e51696272f0b48e$export$e324594224ef24da = v);
$parcel$export($7e51696272f0b48e$exports, "content", () => $7e51696272f0b48e$export$a7db06668cad9adb, (v) => $7e51696272f0b48e$export$a7db06668cad9adb = v);
$parcel$export($7e51696272f0b48e$exports, "create-room-button", () => $7e51696272f0b48e$export$78ff9e2da5fea638, (v) => $7e51696272f0b48e$export$78ff9e2da5fea638 = v);
$parcel$export($7e51696272f0b48e$exports, "exit-button", () => $7e51696272f0b48e$export$94d9bff3e086c301, (v) => $7e51696272f0b48e$export$94d9bff3e086c301 = v);
$parcel$export($7e51696272f0b48e$exports, "header-empty", () => $7e51696272f0b48e$export$3bb948e76cc954d0, (v) => $7e51696272f0b48e$export$3bb948e76cc954d0 = v);
$parcel$export($7e51696272f0b48e$exports, "header-name", () => $7e51696272f0b48e$export$df0a88867bd969fb, (v) => $7e51696272f0b48e$export$df0a88867bd969fb = v);
$parcel$export($7e51696272f0b48e$exports, "header-ping", () => $7e51696272f0b48e$export$a46d18586c55a50d, (v) => $7e51696272f0b48e$export$a46d18586c55a50d = v);
$parcel$export($7e51696272f0b48e$exports, "header-players", () => $7e51696272f0b48e$export$345ed2920cad39db, (v) => $7e51696272f0b48e$export$345ed2920cad39db = v);
$parcel$export($7e51696272f0b48e$exports, "headers", () => $7e51696272f0b48e$export$838e2a576d4d6ff6, (v) => $7e51696272f0b48e$export$838e2a576d4d6ff6 = v);
$parcel$export($7e51696272f0b48e$exports, "lobby", () => $7e51696272f0b48e$export$cea5b5500b00007f, (v) => $7e51696272f0b48e$export$cea5b5500b00007f = v);
$parcel$export($7e51696272f0b48e$exports, "room", () => $7e51696272f0b48e$export$f9d3fff8c23da278, (v) => $7e51696272f0b48e$export$f9d3fff8c23da278 = v);
$parcel$export($7e51696272f0b48e$exports, "room-button", () => $7e51696272f0b48e$export$3e7351bed85e58c4, (v) => $7e51696272f0b48e$export$3e7351bed85e58c4 = v);
$parcel$export($7e51696272f0b48e$exports, "room-list", () => $7e51696272f0b48e$export$1de06561f3705f0e, (v) => $7e51696272f0b48e$export$1de06561f3705f0e = v);
$parcel$export($7e51696272f0b48e$exports, "room-name", () => $7e51696272f0b48e$export$c7846c30b8af84d7, (v) => $7e51696272f0b48e$export$c7846c30b8af84d7 = v);
$parcel$export($7e51696272f0b48e$exports, "room-ping", () => $7e51696272f0b48e$export$fb4d240659cbab91, (v) => $7e51696272f0b48e$export$fb4d240659cbab91 = v);
$parcel$export($7e51696272f0b48e$exports, "room-players", () => $7e51696272f0b48e$export$b5e6b2694471b960, (v) => $7e51696272f0b48e$export$b5e6b2694471b960 = v);
$parcel$export($7e51696272f0b48e$exports, "rooms", () => $7e51696272f0b48e$export$fe8ca8b645b7788d, (v) => $7e51696272f0b48e$export$fe8ca8b645b7788d = v);
$parcel$export($7e51696272f0b48e$exports, "selected", () => $7e51696272f0b48e$export$d90250155de6d7e7, (v) => $7e51696272f0b48e$export$d90250155de6d7e7 = v);
$parcel$export($7e51696272f0b48e$exports, "status", () => $7e51696272f0b48e$export$471f7ae5c4103ae1, (v) => $7e51696272f0b48e$export$471f7ae5c4103ae1 = v);
$parcel$export($7e51696272f0b48e$exports, "title", () => $7e51696272f0b48e$export$fb184b623420d9be, (v) => $7e51696272f0b48e$export$fb184b623420d9be = v);
var $7e51696272f0b48e$export$e324594224ef24da;
var $7e51696272f0b48e$export$a7db06668cad9adb;
var $7e51696272f0b48e$export$78ff9e2da5fea638;
var $7e51696272f0b48e$export$94d9bff3e086c301;
var $7e51696272f0b48e$export$3bb948e76cc954d0;
var $7e51696272f0b48e$export$df0a88867bd969fb;
var $7e51696272f0b48e$export$a46d18586c55a50d;
var $7e51696272f0b48e$export$345ed2920cad39db;
var $7e51696272f0b48e$export$838e2a576d4d6ff6;
var $7e51696272f0b48e$export$cea5b5500b00007f;
var $7e51696272f0b48e$export$f9d3fff8c23da278;
var $7e51696272f0b48e$export$3e7351bed85e58c4;
var $7e51696272f0b48e$export$1de06561f3705f0e;
var $7e51696272f0b48e$export$c7846c30b8af84d7;
var $7e51696272f0b48e$export$fb4d240659cbab91;
var $7e51696272f0b48e$export$b5e6b2694471b960;
var $7e51696272f0b48e$export$fe8ca8b645b7788d;
var $7e51696272f0b48e$export$d90250155de6d7e7;
var $7e51696272f0b48e$export$471f7ae5c4103ae1;
var $7e51696272f0b48e$export$fb184b623420d9be;
$7e51696272f0b48e$export$e324594224ef24da = `wVM9MW_actions`;
$7e51696272f0b48e$export$a7db06668cad9adb = `wVM9MW_content`;
$7e51696272f0b48e$export$78ff9e2da5fea638 = `wVM9MW_create-room-button`;
$7e51696272f0b48e$export$94d9bff3e086c301 = `wVM9MW_exit-button`;
$7e51696272f0b48e$export$3bb948e76cc954d0 = `wVM9MW_header-empty`;
$7e51696272f0b48e$export$df0a88867bd969fb = `wVM9MW_header-name`;
$7e51696272f0b48e$export$a46d18586c55a50d = `wVM9MW_header-ping`;
$7e51696272f0b48e$export$345ed2920cad39db = `wVM9MW_header-players`;
$7e51696272f0b48e$export$838e2a576d4d6ff6 = `wVM9MW_headers`;
$7e51696272f0b48e$export$cea5b5500b00007f = `wVM9MW_lobby`;
$7e51696272f0b48e$export$f9d3fff8c23da278 = `wVM9MW_room`;
$7e51696272f0b48e$export$3e7351bed85e58c4 = `wVM9MW_room-button`;
$7e51696272f0b48e$export$1de06561f3705f0e = `wVM9MW_room-list`;
$7e51696272f0b48e$export$c7846c30b8af84d7 = `wVM9MW_room-name`;
$7e51696272f0b48e$export$fb4d240659cbab91 = `wVM9MW_room-ping`;
$7e51696272f0b48e$export$b5e6b2694471b960 = `wVM9MW_room-players`;
$7e51696272f0b48e$export$fe8ca8b645b7788d = `wVM9MW_rooms`;
$7e51696272f0b48e$export$d90250155de6d7e7 = `wVM9MW_selected`;
$7e51696272f0b48e$export$471f7ae5c4103ae1 = `wVM9MW_status`;
$7e51696272f0b48e$export$fb184b623420d9be = `wVM9MW_title`;



var $5f34832a90ff6389$exports = {};
(function(global, factory) {
    factory($5f34832a90ff6389$exports);
})($5f34832a90ff6389$exports, function(exports1) {
    "use strict";
    /******************************************************************************
    Copyright (c) Microsoft Corporation.

    Permission to use, copy, modify, and/or distribute this software for any
    purpose with or without fee is hereby granted.

    THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
    REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
    AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
    INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
    LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
    OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
    PERFORMANCE OF THIS SOFTWARE.
    ***************************************************************************** */ /* global Reflect, Promise, SuppressedError, Symbol */ var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    function __extends(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    }
    function __decorate(decorators, target, key, desc) {
        var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
        if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
        else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
        return c > 3 && r && Object.defineProperty(target, key, r), r;
    }
    function __spreadArray(to, from, pack) {
        if (pack || arguments.length === 2) {
            for(var i = 0, l = from.length, ar; i < l; i++)if (ar || !(i in from)) {
                if (!ar) ar = Array.prototype.slice.call(from, 0, i);
                ar[i] = from[i];
            }
        }
        return to.concat(ar || Array.prototype.slice.call(from));
    }
    typeof SuppressedError === "function" && SuppressedError;
    // export const SWITCH_TO_STRUCTURE = 193; (easily collides with DELETE_AND_ADD + fieldIndex = 2)
    var SWITCH_TO_STRUCTURE = 255; // (decoding collides with DELETE_AND_ADD + fieldIndex = 63)
    var TYPE_ID = 213;
    /**
     * Encoding Schema field operations.
     */ exports1.OPERATION = void 0;
    (function(OPERATION) {
        // add new structure/primitive
        OPERATION[OPERATION["ADD"] = 128] = "ADD";
        // replace structure/primitive
        OPERATION[OPERATION["REPLACE"] = 0] = "REPLACE";
        // delete field
        OPERATION[OPERATION["DELETE"] = 64] = "DELETE";
        // DELETE field, followed by an ADD
        OPERATION[OPERATION["DELETE_AND_ADD"] = 192] = "DELETE_AND_ADD";
        // TOUCH is used to determine hierarchy of nested Schema structures during serialization.
        // touches are NOT encoded.
        OPERATION[OPERATION["TOUCH"] = 1] = "TOUCH";
        // MapSchema Operations
        OPERATION[OPERATION["CLEAR"] = 10] = "CLEAR";
    })(exports1.OPERATION || (exports1.OPERATION = {}));
    // export enum OPERATION {
    //     // add new structure/primitive
    //     // (128)
    //     ADD = 128, // 10000000,
    //     // replace structure/primitive
    //     REPLACE = 1,// 00000001
    //     // delete field
    //     DELETE = 192, // 11000000
    //     // DELETE field, followed by an ADD
    //     DELETE_AND_ADD = 224, // 11100000
    //     // TOUCH is used to determine hierarchy of nested Schema structures during serialization.
    //     // touches are NOT encoded.
    //     TOUCH = 0, // 00000000
    //     // MapSchema Operations
    //     CLEAR = 10,
    // }
    var ChangeTree = /** @class */ function() {
        function ChangeTree(ref, parent, root) {
            this.changed = false;
            this.changes = new Map();
            this.allChanges = new Set();
            // cached indexes for filtering
            this.caches = {};
            this.currentCustomOperation = 0;
            this.ref = ref;
            this.setParent(parent, root);
        }
        ChangeTree.prototype.setParent = function(parent, root, parentIndex) {
            var _this = this;
            if (!this.indexes) this.indexes = this.ref instanceof Schema ? this.ref["_definition"].indexes : {};
            this.parent = parent;
            this.parentIndex = parentIndex;
            // avoid setting parents with empty `root`
            if (!root) return;
            this.root = root;
            //
            // assign same parent on child structures
            //
            if (this.ref instanceof Schema) {
                var definition = this.ref["_definition"];
                for(var field in definition.schema){
                    var value = this.ref[field];
                    if (value && value["$changes"]) {
                        var parentIndex_1 = definition.indexes[field];
                        value["$changes"].setParent(this.ref, root, parentIndex_1);
                    }
                }
            } else if (typeof this.ref === "object") this.ref.forEach(function(value, key) {
                if (value instanceof Schema) {
                    var changeTreee = value["$changes"];
                    var parentIndex_2 = _this.ref["$changes"].indexes[key];
                    changeTreee.setParent(_this.ref, _this.root, parentIndex_2);
                }
            });
        };
        ChangeTree.prototype.operation = function(op) {
            this.changes.set(--this.currentCustomOperation, op);
        };
        ChangeTree.prototype.change = function(fieldName, operation) {
            if (operation === void 0) operation = exports1.OPERATION.ADD;
            var index = typeof fieldName === "number" ? fieldName : this.indexes[fieldName];
            this.assertValidIndex(index, fieldName);
            var previousChange = this.changes.get(index);
            if (!previousChange || previousChange.op === exports1.OPERATION.DELETE || previousChange.op === exports1.OPERATION.TOUCH // (mazmorra.io's BattleAction issue)
            ) this.changes.set(index, {
                op: !previousChange ? operation : previousChange.op === exports1.OPERATION.DELETE ? exports1.OPERATION.DELETE_AND_ADD : operation,
                // : OPERATION.REPLACE,
                index: index
            });
            this.allChanges.add(index);
            this.changed = true;
            this.touchParents();
        };
        ChangeTree.prototype.touch = function(fieldName) {
            var index = typeof fieldName === "number" ? fieldName : this.indexes[fieldName];
            this.assertValidIndex(index, fieldName);
            if (!this.changes.has(index)) this.changes.set(index, {
                op: exports1.OPERATION.TOUCH,
                index: index
            });
            this.allChanges.add(index);
            // ensure touch is placed until the $root is found.
            this.touchParents();
        };
        ChangeTree.prototype.touchParents = function() {
            if (this.parent) this.parent["$changes"].touch(this.parentIndex);
        };
        ChangeTree.prototype.getType = function(index) {
            if (this.ref["_definition"]) {
                var definition = this.ref["_definition"];
                return definition.schema[definition.fieldsByIndex[index]];
            } else {
                var definition = this.parent["_definition"];
                var parentType = definition.schema[definition.fieldsByIndex[this.parentIndex]];
                //
                // Get the child type from parent structure.
                // - ["string"] => "string"
                // - { map: "string" } => "string"
                // - { set: "string" } => "string"
                //
                return Object.values(parentType)[0];
            }
        };
        ChangeTree.prototype.getChildrenFilter = function() {
            var childFilters = this.parent["_definition"].childFilters;
            return childFilters && childFilters[this.parentIndex];
        };
        //
        // used during `.encode()`
        //
        ChangeTree.prototype.getValue = function(index) {
            return this.ref["getByIndex"](index);
        };
        ChangeTree.prototype.delete = function(fieldName) {
            var index = typeof fieldName === "number" ? fieldName : this.indexes[fieldName];
            if (index === undefined) {
                console.warn("@colyseus/schema ".concat(this.ref.constructor.name, ": trying to delete non-existing index: ").concat(fieldName, " (").concat(index, ")"));
                return;
            }
            var previousValue = this.getValue(index);
            // console.log("$changes.delete =>", { fieldName, index, previousValue });
            this.changes.set(index, {
                op: exports1.OPERATION.DELETE,
                index: index
            });
            this.allChanges.delete(index);
            // delete cache
            delete this.caches[index];
            // remove `root` reference
            if (previousValue && previousValue["$changes"]) previousValue["$changes"].parent = undefined;
            this.changed = true;
            this.touchParents();
        };
        ChangeTree.prototype.discard = function(changed, discardAll) {
            var _this = this;
            if (changed === void 0) changed = false;
            if (discardAll === void 0) discardAll = false;
            //
            // Map, Array, etc:
            // Remove cached key to ensure ADD operations is unsed instead of
            // REPLACE in case same key is used on next patches.
            //
            // TODO: refactor this. this is not relevant for Collection and Set.
            //
            if (!(this.ref instanceof Schema)) this.changes.forEach(function(change) {
                if (change.op === exports1.OPERATION.DELETE) {
                    var index = _this.ref["getIndex"](change.index);
                    delete _this.indexes[index];
                }
            });
            this.changes.clear();
            this.changed = changed;
            if (discardAll) this.allChanges.clear();
            // re-set `currentCustomOperation`
            this.currentCustomOperation = 0;
        };
        /**
         * Recursively discard all changes from this, and child structures.
         */ ChangeTree.prototype.discardAll = function() {
            var _this = this;
            this.changes.forEach(function(change) {
                var value = _this.getValue(change.index);
                if (value && value["$changes"]) value["$changes"].discardAll();
            });
            this.discard();
        };
        // cache(field: number, beginIndex: number, endIndex: number) {
        ChangeTree.prototype.cache = function(field, cachedBytes) {
            this.caches[field] = cachedBytes;
        };
        ChangeTree.prototype.clone = function() {
            return new ChangeTree(this.ref, this.parent, this.root);
        };
        ChangeTree.prototype.ensureRefId = function() {
            // skip if refId is already set.
            if (this.refId !== undefined) return;
            this.refId = this.root.getNextUniqueId();
        };
        ChangeTree.prototype.assertValidIndex = function(index, fieldName) {
            if (index === undefined) throw new Error('ChangeTree: missing index for field "'.concat(fieldName, '"'));
        };
        return ChangeTree;
    }();
    function addCallback($callbacks, op, callback, existing) {
        // initialize list of callbacks
        if (!$callbacks[op]) $callbacks[op] = [];
        $callbacks[op].push(callback);
        //
        // Trigger callback for existing elements
        // - OPERATION.ADD
        // - OPERATION.REPLACE
        //
        existing === null || existing === void 0 || existing.forEach(function(item, key) {
            return callback(item, key);
        });
        return function() {
            return spliceOne($callbacks[op], $callbacks[op].indexOf(callback));
        };
    }
    function removeChildRefs(changes) {
        var _this = this;
        var needRemoveRef = typeof this.$changes.getType() !== "string";
        this.$items.forEach(function(item, key) {
            changes.push({
                refId: _this.$changes.refId,
                op: exports1.OPERATION.DELETE,
                field: key,
                value: undefined,
                previousValue: item
            });
            if (needRemoveRef) _this.$changes.root.removeRef(item["$changes"].refId);
        });
    }
    function spliceOne(arr, index) {
        // manually splice an array
        if (index === -1 || index >= arr.length) return false;
        var len = arr.length - 1;
        for(var i = index; i < len; i++)arr[i] = arr[i + 1];
        arr.length = len;
        return true;
    }
    var DEFAULT_SORT = function(a, b) {
        var A = a.toString();
        var B = b.toString();
        if (A < B) return -1;
        else if (A > B) return 1;
        else return 0;
    };
    function getArrayProxy(value) {
        value["$proxy"] = true;
        //
        // compatibility with @colyseus/schema 0.5.x
        // - allow `map["key"]`
        // - allow `map["key"] = "xxx"`
        // - allow `delete map["key"]`
        //
        value = new Proxy(value, {
            get: function(obj, prop) {
                if (typeof prop !== "symbol" && !isNaN(prop) // https://stackoverflow.com/a/175787/892698
                ) return obj.at(prop);
                else return obj[prop];
            },
            set: function(obj, prop, setValue) {
                if (typeof prop !== "symbol" && !isNaN(prop)) {
                    var indexes = Array.from(obj["$items"].keys());
                    var key = parseInt(indexes[prop] || prop);
                    if (setValue === undefined || setValue === null) obj.deleteAt(key);
                    else obj.setAt(key, setValue);
                } else obj[prop] = setValue;
                return true;
            },
            deleteProperty: function(obj, prop) {
                if (typeof prop === "number") obj.deleteAt(prop);
                else delete obj[prop];
                return true;
            },
            has: function(obj, key) {
                if (typeof key !== "symbol" && !isNaN(Number(key))) return obj["$items"].has(Number(key));
                return Reflect.has(obj, key);
            }
        });
        return value;
    }
    var ArraySchema = /** @class */ function() {
        function ArraySchema() {
            var items = [];
            for(var _i = 0; _i < arguments.length; _i++)items[_i] = arguments[_i];
            this.$changes = new ChangeTree(this);
            this.$items = new Map();
            this.$indexes = new Map();
            this.$refId = 0;
            this.push.apply(this, items);
        }
        ArraySchema.prototype.onAdd = function(callback, triggerAll) {
            if (triggerAll === void 0) triggerAll = true;
            return addCallback(this.$callbacks || (this.$callbacks = {}), exports1.OPERATION.ADD, callback, triggerAll ? this.$items : undefined);
        };
        ArraySchema.prototype.onRemove = function(callback) {
            return addCallback(this.$callbacks || (this.$callbacks = {}), exports1.OPERATION.DELETE, callback);
        };
        ArraySchema.prototype.onChange = function(callback) {
            return addCallback(this.$callbacks || (this.$callbacks = {}), exports1.OPERATION.REPLACE, callback);
        };
        ArraySchema.is = function(type) {
            return(// type format: ["string"]
            Array.isArray(type) || // type format: { array: "string" }
            type["array"] !== undefined);
        };
        Object.defineProperty(ArraySchema.prototype, "length", {
            get: function() {
                return this.$items.size;
            },
            set: function(value) {
                if (value === 0) this.clear();
                else this.splice(value, this.length - value);
            },
            enumerable: false,
            configurable: true
        });
        ArraySchema.prototype.push = function() {
            var _this = this;
            var values = [];
            for(var _i = 0; _i < arguments.length; _i++)values[_i] = arguments[_i];
            var lastIndex;
            values.forEach(function(value) {
                // set "index" for reference.
                lastIndex = _this.$refId++;
                _this.setAt(lastIndex, value);
            });
            return lastIndex;
        };
        /**
         * Removes the last element from an array and returns it.
         */ ArraySchema.prototype.pop = function() {
            var key = Array.from(this.$indexes.values()).pop();
            if (key === undefined) return undefined;
            this.$changes.delete(key);
            this.$indexes.delete(key);
            var value = this.$items.get(key);
            this.$items.delete(key);
            return value;
        };
        ArraySchema.prototype.at = function(index) {
            //
            // FIXME: this should be O(1)
            //
            var key = Array.from(this.$items.keys())[index];
            return this.$items.get(key);
        };
        ArraySchema.prototype.setAt = function(index, value) {
            var _a, _b;
            if (value === undefined || value === null) {
                console.error("ArraySchema items cannot be null nor undefined; Use `deleteAt(index)` instead.");
                return;
            }
            // skip if the value is the same as cached.
            if (this.$items.get(index) === value) return;
            if (value["$changes"] !== undefined) value["$changes"].setParent(this, this.$changes.root, index);
            var operation = (_b = (_a = this.$changes.indexes[index]) === null || _a === void 0 ? void 0 : _a.op) !== null && _b !== void 0 ? _b : exports1.OPERATION.ADD;
            this.$changes.indexes[index] = index;
            this.$indexes.set(index, index);
            this.$items.set(index, value);
            this.$changes.change(index, operation);
        };
        ArraySchema.prototype.deleteAt = function(index) {
            var key = Array.from(this.$items.keys())[index];
            if (key === undefined) return false;
            return this.$deleteAt(key);
        };
        ArraySchema.prototype.$deleteAt = function(index) {
            // delete at internal index
            this.$changes.delete(index);
            this.$indexes.delete(index);
            return this.$items.delete(index);
        };
        ArraySchema.prototype.clear = function(changes) {
            // discard previous operations.
            this.$changes.discard(true, true);
            this.$changes.indexes = {};
            // clear previous indexes
            this.$indexes.clear();
            //
            // When decoding:
            // - enqueue items for DELETE callback.
            // - flag child items for garbage collection.
            //
            if (changes) removeChildRefs.call(this, changes);
            // clear items
            this.$items.clear();
            this.$changes.operation({
                index: 0,
                op: exports1.OPERATION.CLEAR
            });
            // touch all structures until reach root
            this.$changes.touchParents();
        };
        /**
         * Combines two or more arrays.
         * @param items Additional items to add to the end of array1.
         */ // @ts-ignore
        ArraySchema.prototype.concat = function() {
            var _a;
            var items = [];
            for(var _i = 0; _i < arguments.length; _i++)items[_i] = arguments[_i];
            return new (ArraySchema.bind.apply(ArraySchema, __spreadArray([
                void 0
            ], (_a = Array.from(this.$items.values())).concat.apply(_a, items), false)))();
        };
        /**
         * Adds all the elements of an array separated by the specified separator string.
         * @param separator A string used to separate one element of an array from the next in the resulting String. If omitted, the array elements are separated with a comma.
         */ ArraySchema.prototype.join = function(separator) {
            return Array.from(this.$items.values()).join(separator);
        };
        /**
         * Reverses the elements in an Array.
         */ // @ts-ignore
        ArraySchema.prototype.reverse = function() {
            var _this = this;
            var indexes = Array.from(this.$items.keys());
            var reversedItems = Array.from(this.$items.values()).reverse();
            reversedItems.forEach(function(item, i) {
                _this.setAt(indexes[i], item);
            });
            return this;
        };
        /**
         * Removes the first element from an array and returns it.
         */ ArraySchema.prototype.shift = function() {
            var indexes = Array.from(this.$items.keys());
            var shiftAt = indexes.shift();
            if (shiftAt === undefined) return undefined;
            var value = this.$items.get(shiftAt);
            this.$deleteAt(shiftAt);
            return value;
        };
        /**
         * Returns a section of an array.
         * @param start The beginning of the specified portion of the array.
         * @param end The end of the specified portion of the array. This is exclusive of the element at the index 'end'.
         */ ArraySchema.prototype.slice = function(start, end) {
            var sliced = new ArraySchema();
            sliced.push.apply(sliced, Array.from(this.$items.values()).slice(start, end));
            return sliced;
        };
        /**
         * Sorts an array.
         * @param compareFn Function used to determine the order of the elements. It is expected to return
         * a negative value if first argument is less than second argument, zero if they're equal and a positive
         * value otherwise. If omitted, the elements are sorted in ascending, ASCII character order.
         * ```ts
         * [11,2,22,1].sort((a, b) => a - b)
         * ```
         */ ArraySchema.prototype.sort = function(compareFn) {
            var _this = this;
            if (compareFn === void 0) compareFn = DEFAULT_SORT;
            var indexes = Array.from(this.$items.keys());
            var sortedItems = Array.from(this.$items.values()).sort(compareFn);
            sortedItems.forEach(function(item, i) {
                _this.setAt(indexes[i], item);
            });
            return this;
        };
        /**
         * Removes elements from an array and, if necessary, inserts new elements in their place, returning the deleted elements.
         * @param start The zero-based location in the array from which to start removing elements.
         * @param deleteCount The number of elements to remove.
         * @param items Elements to insert into the array in place of the deleted elements.
         */ ArraySchema.prototype.splice = function(start, deleteCount) {
            if (deleteCount === void 0) deleteCount = this.length - start;
            var items = [];
            for(var _i = 2; _i < arguments.length; _i++)items[_i - 2] = arguments[_i];
            var indexes = Array.from(this.$items.keys());
            var removedItems = [];
            for(var i = start; i < start + deleteCount; i++){
                removedItems.push(this.$items.get(indexes[i]));
                this.$deleteAt(indexes[i]);
            }
            for(var i = 0; i < items.length; i++)this.setAt(start + i, items[i]);
            return removedItems;
        };
        /**
         * Inserts new elements at the start of an array.
         * @param items  Elements to insert at the start of the Array.
         */ ArraySchema.prototype.unshift = function() {
            var _this = this;
            var items = [];
            for(var _i = 0; _i < arguments.length; _i++)items[_i] = arguments[_i];
            var length = this.length;
            var addedLength = items.length;
            // const indexes = Array.from(this.$items.keys());
            var previousValues = Array.from(this.$items.values());
            items.forEach(function(item, i) {
                _this.setAt(i, item);
            });
            previousValues.forEach(function(previousValue, i) {
                _this.setAt(addedLength + i, previousValue);
            });
            return length + addedLength;
        };
        /**
         * Returns the index of the first occurrence of a value in an array.
         * @param searchElement The value to locate in the array.
         * @param fromIndex The array index at which to begin the search. If fromIndex is omitted, the search starts at index 0.
         */ ArraySchema.prototype.indexOf = function(searchElement, fromIndex) {
            return Array.from(this.$items.values()).indexOf(searchElement, fromIndex);
        };
        /**
         * Returns the index of the last occurrence of a specified value in an array.
         * @param searchElement The value to locate in the array.
         * @param fromIndex The array index at which to begin the search. If fromIndex is omitted, the search starts at the last index in the array.
         */ ArraySchema.prototype.lastIndexOf = function(searchElement, fromIndex) {
            if (fromIndex === void 0) fromIndex = this.length - 1;
            return Array.from(this.$items.values()).lastIndexOf(searchElement, fromIndex);
        };
        /**
         * Determines whether all the members of an array satisfy the specified test.
         * @param callbackfn A function that accepts up to three arguments. The every method calls
         * the callbackfn function for each element in the array until the callbackfn returns a value
         * which is coercible to the Boolean value false, or until the end of the array.
         * @param thisArg An object to which the this keyword can refer in the callbackfn function.
         * If thisArg is omitted, undefined is used as the this value.
         */ ArraySchema.prototype.every = function(callbackfn, thisArg) {
            return Array.from(this.$items.values()).every(callbackfn, thisArg);
        };
        /**
         * Determines whether the specified callback function returns true for any element of an array.
         * @param callbackfn A function that accepts up to three arguments. The some method calls
         * the callbackfn function for each element in the array until the callbackfn returns a value
         * which is coercible to the Boolean value true, or until the end of the array.
         * @param thisArg An object to which the this keyword can refer in the callbackfn function.
         * If thisArg is omitted, undefined is used as the this value.
         */ ArraySchema.prototype.some = function(callbackfn, thisArg) {
            return Array.from(this.$items.values()).some(callbackfn, thisArg);
        };
        /**
         * Performs the specified action for each element in an array.
         * @param callbackfn  A function that accepts up to three arguments. forEach calls the callbackfn function one time for each element in the array.
         * @param thisArg  An object to which the this keyword can refer in the callbackfn function. If thisArg is omitted, undefined is used as the this value.
         */ ArraySchema.prototype.forEach = function(callbackfn, thisArg) {
            Array.from(this.$items.values()).forEach(callbackfn, thisArg);
        };
        /**
         * Calls a defined callback function on each element of an array, and returns an array that contains the results.
         * @param callbackfn A function that accepts up to three arguments. The map method calls the callbackfn function one time for each element in the array.
         * @param thisArg An object to which the this keyword can refer in the callbackfn function. If thisArg is omitted, undefined is used as the this value.
         */ ArraySchema.prototype.map = function(callbackfn, thisArg) {
            return Array.from(this.$items.values()).map(callbackfn, thisArg);
        };
        ArraySchema.prototype.filter = function(callbackfn, thisArg) {
            return Array.from(this.$items.values()).filter(callbackfn, thisArg);
        };
        /**
         * Calls the specified callback function for all the elements in an array. The return value of the callback function is the accumulated result, and is provided as an argument in the next call to the callback function.
         * @param callbackfn A function that accepts up to four arguments. The reduce method calls the callbackfn function one time for each element in the array.
         * @param initialValue If initialValue is specified, it is used as the initial value to start the accumulation. The first call to the callbackfn function provides this value as an argument instead of an array value.
         */ ArraySchema.prototype.reduce = function(callbackfn, initialValue) {
            return Array.prototype.reduce.apply(Array.from(this.$items.values()), arguments);
        };
        /**
         * Calls the specified callback function for all the elements in an array, in descending order. The return value of the callback function is the accumulated result, and is provided as an argument in the next call to the callback function.
         * @param callbackfn A function that accepts up to four arguments. The reduceRight method calls the callbackfn function one time for each element in the array.
         * @param initialValue If initialValue is specified, it is used as the initial value to start the accumulation. The first call to the callbackfn function provides this value as an argument instead of an array value.
         */ ArraySchema.prototype.reduceRight = function(callbackfn, initialValue) {
            return Array.prototype.reduceRight.apply(Array.from(this.$items.values()), arguments);
        };
        /**
         * Returns the value of the first element in the array where predicate is true, and undefined
         * otherwise.
         * @param predicate find calls predicate once for each element of the array, in ascending
         * order, until it finds one where predicate returns true. If such an element is found, find
         * immediately returns that element value. Otherwise, find returns undefined.
         * @param thisArg If provided, it will be used as the this value for each invocation of
         * predicate. If it is not provided, undefined is used instead.
         */ ArraySchema.prototype.find = function(predicate, thisArg) {
            return Array.from(this.$items.values()).find(predicate, thisArg);
        };
        /**
         * Returns the index of the first element in the array where predicate is true, and -1
         * otherwise.
         * @param predicate find calls predicate once for each element of the array, in ascending
         * order, until it finds one where predicate returns true. If such an element is found,
         * findIndex immediately returns that element index. Otherwise, findIndex returns -1.
         * @param thisArg If provided, it will be used as the this value for each invocation of
         * predicate. If it is not provided, undefined is used instead.
         */ ArraySchema.prototype.findIndex = function(predicate, thisArg) {
            return Array.from(this.$items.values()).findIndex(predicate, thisArg);
        };
        /**
         * Returns the this object after filling the section identified by start and end with value
         * @param value value to fill array section with
         * @param start index to start filling the array at. If start is negative, it is treated as
         * length+start where length is the length of the array.
         * @param end index to stop filling the array at. If end is negative, it is treated as
         * length+end.
         */ ArraySchema.prototype.fill = function(value, start, end) {
            //
            // TODO
            //
            throw new Error("ArraySchema#fill() not implemented");
        };
        /**
         * Returns the this object after copying a section of the array identified by start and end
         * to the same array starting at position target
         * @param target If target is negative, it is treated as length+target where length is the
         * length of the array.
         * @param start If start is negative, it is treated as length+start. If end is negative, it
         * is treated as length+end.
         * @param end If not specified, length of the this object is used as its default value.
         */ ArraySchema.prototype.copyWithin = function(target, start, end) {
            //
            // TODO
            //
            throw new Error("ArraySchema#copyWithin() not implemented");
        };
        /**
         * Returns a string representation of an array.
         */ ArraySchema.prototype.toString = function() {
            return this.$items.toString();
        };
        /**
         * Returns a string representation of an array. The elements are converted to string using their toLocalString methods.
         */ ArraySchema.prototype.toLocaleString = function() {
            return this.$items.toLocaleString();
        };
        /** Iterator */ ArraySchema.prototype[Symbol.iterator] = function() {
            return Array.from(this.$items.values())[Symbol.iterator]();
        };
        Object.defineProperty(ArraySchema, Symbol.species, {
            get: function() {
                return ArraySchema;
            },
            enumerable: false,
            configurable: true
        });
        /**
         * Returns an iterable of key, value pairs for every entry in the array
         */ ArraySchema.prototype.entries = function() {
            return this.$items.entries();
        };
        /**
         * Returns an iterable of keys in the array
         */ ArraySchema.prototype.keys = function() {
            return this.$items.keys();
        };
        /**
         * Returns an iterable of values in the array
         */ ArraySchema.prototype.values = function() {
            return this.$items.values();
        };
        /**
         * Determines whether an array includes a certain element, returning true or false as appropriate.
         * @param searchElement The element to search for.
         * @param fromIndex The position in this array at which to begin searching for searchElement.
         */ ArraySchema.prototype.includes = function(searchElement, fromIndex) {
            return Array.from(this.$items.values()).includes(searchElement, fromIndex);
        };
        //
        // ES2022
        //
        /**
         * Calls a defined callback function on each element of an array. Then, flattens the result into
         * a new array.
         * This is identical to a map followed by flat with depth 1.
         *
         * @param callback A function that accepts up to three arguments. The flatMap method calls the
         * callback function one time for each element in the array.
         * @param thisArg An object to which the this keyword can refer in the callback function. If
         * thisArg is omitted, undefined is used as the this value.
         */ // @ts-ignore
        ArraySchema.prototype.flatMap = function(callback, thisArg) {
            // @ts-ignore
            throw new Error("ArraySchema#flatMap() is not supported.");
        };
        /**
         * Returns a new array with all sub-array elements concatenated into it recursively up to the
         * specified depth.
         *
         * @param depth The maximum recursion depth
         */ // @ts-ignore
        ArraySchema.prototype.flat = function(depth) {
            throw new Error("ArraySchema#flat() is not supported.");
        };
        ArraySchema.prototype.findLast = function() {
            var arr = Array.from(this.$items.values());
            // @ts-ignore
            return arr.findLast.apply(arr, arguments);
        };
        ArraySchema.prototype.findLastIndex = function() {
            var arr = Array.from(this.$items.values());
            // @ts-ignore
            return arr.findLastIndex.apply(arr, arguments);
        };
        //
        // ES2023
        //
        ArraySchema.prototype.with = function(index, value) {
            var copy = Array.from(this.$items.values());
            copy[index] = value;
            return new (ArraySchema.bind.apply(ArraySchema, __spreadArray([
                void 0
            ], copy, false)))();
        };
        ArraySchema.prototype.toReversed = function() {
            return Array.from(this.$items.values()).reverse();
        };
        ArraySchema.prototype.toSorted = function(compareFn) {
            return Array.from(this.$items.values()).sort(compareFn);
        };
        // @ts-ignore
        ArraySchema.prototype.toSpliced = function(start, deleteCount) {
            var copy = Array.from(this.$items.values());
            // @ts-ignore
            return copy.toSpliced.apply(copy, arguments);
        };
        ArraySchema.prototype.setIndex = function(index, key) {
            this.$indexes.set(index, key);
        };
        ArraySchema.prototype.getIndex = function(index) {
            return this.$indexes.get(index);
        };
        ArraySchema.prototype.getByIndex = function(index) {
            return this.$items.get(this.$indexes.get(index));
        };
        ArraySchema.prototype.deleteByIndex = function(index) {
            var key = this.$indexes.get(index);
            this.$items.delete(key);
            this.$indexes.delete(index);
        };
        ArraySchema.prototype.toArray = function() {
            return Array.from(this.$items.values());
        };
        ArraySchema.prototype.toJSON = function() {
            return this.toArray().map(function(value) {
                return typeof value["toJSON"] === "function" ? value["toJSON"]() : value;
            });
        };
        //
        // Decoding utilities
        //
        ArraySchema.prototype.clone = function(isDecoding) {
            var cloned;
            if (isDecoding) cloned = new (ArraySchema.bind.apply(ArraySchema, __spreadArray([
                void 0
            ], Array.from(this.$items.values()), false)))();
            else cloned = new (ArraySchema.bind.apply(ArraySchema, __spreadArray([
                void 0
            ], this.map(function(item) {
                return item["$changes"] ? item.clone() : item;
            }), false)))();
            return cloned;
        };
        return ArraySchema;
    }();
    function getMapProxy(value) {
        value["$proxy"] = true;
        value = new Proxy(value, {
            get: function(obj, prop) {
                if (typeof prop !== "symbol" && // accessing properties
                typeof obj[prop] === "undefined") return obj.get(prop);
                else return obj[prop];
            },
            set: function(obj, prop, setValue) {
                if (typeof prop !== "symbol" && prop.indexOf("$") === -1 && prop !== "onAdd" && prop !== "onRemove" && prop !== "onChange") obj.set(prop, setValue);
                else obj[prop] = setValue;
                return true;
            },
            deleteProperty: function(obj, prop) {
                obj.delete(prop);
                return true;
            }
        });
        return value;
    }
    var MapSchema = /** @class */ function() {
        function MapSchema(initialValues) {
            var _this = this;
            this.$changes = new ChangeTree(this);
            this.$items = new Map();
            this.$indexes = new Map();
            this.$refId = 0;
            if (initialValues) {
                if (initialValues instanceof Map || initialValues instanceof MapSchema) initialValues.forEach(function(v, k) {
                    return _this.set(k, v);
                });
                else for(var k in initialValues)this.set(k, initialValues[k]);
            }
        }
        MapSchema.prototype.onAdd = function(callback, triggerAll) {
            if (triggerAll === void 0) triggerAll = true;
            return addCallback(this.$callbacks || (this.$callbacks = {}), exports1.OPERATION.ADD, callback, triggerAll ? this.$items : undefined);
        };
        MapSchema.prototype.onRemove = function(callback) {
            return addCallback(this.$callbacks || (this.$callbacks = {}), exports1.OPERATION.DELETE, callback);
        };
        MapSchema.prototype.onChange = function(callback) {
            return addCallback(this.$callbacks || (this.$callbacks = {}), exports1.OPERATION.REPLACE, callback);
        };
        MapSchema.is = function(type) {
            return type["map"] !== undefined;
        };
        /** Iterator */ MapSchema.prototype[Symbol.iterator] = function() {
            return this.$items[Symbol.iterator]();
        };
        Object.defineProperty(MapSchema.prototype, Symbol.toStringTag, {
            get: function() {
                return this.$items[Symbol.toStringTag];
            },
            enumerable: false,
            configurable: true
        });
        Object.defineProperty(MapSchema, Symbol.species, {
            get: function() {
                return MapSchema;
            },
            enumerable: false,
            configurable: true
        });
        MapSchema.prototype.set = function(key, value) {
            if (value === undefined || value === null) throw new Error("MapSchema#set('".concat(key, "', ").concat(value, "): trying to set ").concat(value, " value on '").concat(key, "'."));
            // Force "key" as string
            // See: https://github.com/colyseus/colyseus/issues/561#issuecomment-1646733468
            key = key.toString();
            // get "index" for this value.
            var hasIndex = typeof this.$changes.indexes[key] !== "undefined";
            var index = hasIndex ? this.$changes.indexes[key] : this.$refId++;
            var operation = hasIndex ? exports1.OPERATION.REPLACE : exports1.OPERATION.ADD;
            var isRef = value["$changes"] !== undefined;
            if (isRef) value["$changes"].setParent(this, this.$changes.root, index);
            //
            // (encoding)
            // set a unique id to relate directly with this key/value.
            //
            if (!hasIndex) {
                this.$changes.indexes[key] = index;
                this.$indexes.set(index, key);
            } else if (!isRef && this.$items.get(key) === value) // if value is the same, avoid re-encoding it.
            return;
            else if (isRef && // if is schema, force ADD operation if value differ from previous one.
            this.$items.get(key) !== value) operation = exports1.OPERATION.ADD;
            this.$items.set(key, value);
            this.$changes.change(key, operation);
            return this;
        };
        MapSchema.prototype.get = function(key) {
            return this.$items.get(key);
        };
        MapSchema.prototype.delete = function(key) {
            //
            // TODO: add a "purge" method after .encode() runs, to cleanup removed `$indexes`
            //
            // We don't remove $indexes to allow setting the same key in the same patch
            // (See "should allow to remove and set an item in the same place" test)
            //
            // // const index = this.$changes.indexes[key];
            // // this.$indexes.delete(index);
            this.$changes.delete(key);
            return this.$items.delete(key);
        };
        MapSchema.prototype.clear = function(changes) {
            // discard previous operations.
            this.$changes.discard(true, true);
            this.$changes.indexes = {};
            // clear previous indexes
            this.$indexes.clear();
            //
            // When decoding:
            // - enqueue items for DELETE callback.
            // - flag child items for garbage collection.
            //
            if (changes) removeChildRefs.call(this, changes);
            // clear items
            this.$items.clear();
            this.$changes.operation({
                index: 0,
                op: exports1.OPERATION.CLEAR
            });
            // touch all structures until reach root
            this.$changes.touchParents();
        };
        MapSchema.prototype.has = function(key) {
            return this.$items.has(key);
        };
        MapSchema.prototype.forEach = function(callbackfn) {
            this.$items.forEach(callbackfn);
        };
        MapSchema.prototype.entries = function() {
            return this.$items.entries();
        };
        MapSchema.prototype.keys = function() {
            return this.$items.keys();
        };
        MapSchema.prototype.values = function() {
            return this.$items.values();
        };
        Object.defineProperty(MapSchema.prototype, "size", {
            get: function() {
                return this.$items.size;
            },
            enumerable: false,
            configurable: true
        });
        MapSchema.prototype.setIndex = function(index, key) {
            this.$indexes.set(index, key);
        };
        MapSchema.prototype.getIndex = function(index) {
            return this.$indexes.get(index);
        };
        MapSchema.prototype.getByIndex = function(index) {
            return this.$items.get(this.$indexes.get(index));
        };
        MapSchema.prototype.deleteByIndex = function(index) {
            var key = this.$indexes.get(index);
            this.$items.delete(key);
            this.$indexes.delete(index);
        };
        MapSchema.prototype.toJSON = function() {
            var map = {};
            this.forEach(function(value, key) {
                map[key] = typeof value["toJSON"] === "function" ? value["toJSON"]() : value;
            });
            return map;
        };
        //
        // Decoding utilities
        //
        MapSchema.prototype.clone = function(isDecoding) {
            var cloned;
            if (isDecoding) // client-side
            cloned = Object.assign(new MapSchema(), this);
            else {
                // server-side
                cloned = new MapSchema();
                this.forEach(function(value, key) {
                    if (value["$changes"]) cloned.set(key, value["clone"]());
                    else cloned.set(key, value);
                });
            }
            return cloned;
        };
        return MapSchema;
    }();
    var registeredTypes = {};
    function registerType(identifier, definition) {
        registeredTypes[identifier] = definition;
    }
    function getType(identifier) {
        return registeredTypes[identifier];
    }
    var SchemaDefinition = /** @class */ function() {
        function SchemaDefinition() {
            //
            // TODO: use a "field" structure combining all these properties per-field.
            //
            this.indexes = {};
            this.fieldsByIndex = {};
            this.deprecated = {};
            this.descriptors = {};
        }
        SchemaDefinition.create = function(parent) {
            var definition = new SchemaDefinition();
            // support inheritance
            definition.schema = Object.assign({}, parent && parent.schema || {});
            definition.indexes = Object.assign({}, parent && parent.indexes || {});
            definition.fieldsByIndex = Object.assign({}, parent && parent.fieldsByIndex || {});
            definition.descriptors = Object.assign({}, parent && parent.descriptors || {});
            definition.deprecated = Object.assign({}, parent && parent.deprecated || {});
            return definition;
        };
        SchemaDefinition.prototype.addField = function(field, type) {
            var index = this.getNextFieldIndex();
            this.fieldsByIndex[index] = field;
            this.indexes[field] = index;
            this.schema[field] = Array.isArray(type) ? {
                array: type[0]
            } : type;
        };
        SchemaDefinition.prototype.hasField = function(field) {
            return this.indexes[field] !== undefined;
        };
        SchemaDefinition.prototype.addFilter = function(field, cb) {
            if (!this.filters) {
                this.filters = {};
                this.indexesWithFilters = [];
            }
            this.filters[this.indexes[field]] = cb;
            this.indexesWithFilters.push(this.indexes[field]);
            return true;
        };
        SchemaDefinition.prototype.addChildrenFilter = function(field, cb) {
            var index = this.indexes[field];
            var type = this.schema[field];
            if (getType(Object.keys(type)[0])) {
                if (!this.childFilters) this.childFilters = {};
                this.childFilters[index] = cb;
                return true;
            } else console.warn("@filterChildren: field '".concat(field, "' can't have children. Ignoring filter."));
        };
        SchemaDefinition.prototype.getChildrenFilter = function(field) {
            return this.childFilters && this.childFilters[this.indexes[field]];
        };
        SchemaDefinition.prototype.getNextFieldIndex = function() {
            return Object.keys(this.schema || {}).length;
        };
        return SchemaDefinition;
    }();
    function hasFilter(klass) {
        return klass._context && klass._context.useFilters;
    }
    var Context = /** @class */ function() {
        function Context() {
            this.types = {};
            this.schemas = new Map();
            this.useFilters = false;
        }
        Context.prototype.has = function(schema) {
            return this.schemas.has(schema);
        };
        Context.prototype.get = function(typeid) {
            return this.types[typeid];
        };
        Context.prototype.add = function(schema, typeid) {
            if (typeid === void 0) typeid = this.schemas.size;
            // FIXME: move this to somewhere else?
            // support inheritance
            schema._definition = SchemaDefinition.create(schema._definition);
            schema._typeid = typeid;
            this.types[typeid] = schema;
            this.schemas.set(schema, typeid);
        };
        Context.create = function(options) {
            if (options === void 0) options = {};
            return function(definition) {
                if (!options.context) options.context = new Context();
                return type(definition, options);
            };
        };
        return Context;
    }();
    var globalContext = new Context();
    /**
     * [See documentation](https://docs.colyseus.io/state/schema/)
     *
     * Annotate a Schema property to be serializeable.
     * \@type()'d fields are automatically flagged as "dirty" for the next patch.
     *
     * @example Standard usage, with automatic change tracking.
     * ```
     * \@type("string") propertyName: string;
     * ```
     *
     * @example You can provide the "manual" option if you'd like to manually control your patches via .setDirty().
     * ```
     * \@type("string", { manual: true })
     * ```
     */ function type(type, options) {
        if (options === void 0) options = {};
        return function(target, field) {
            var context = options.context || globalContext;
            var constructor = target.constructor;
            constructor._context = context;
            if (!type) throw new Error("".concat(constructor.name, ': @type() reference provided for "').concat(field, "\" is undefined. Make sure you don't have any circular dependencies."));
            /*
             * static schema
             */ if (!context.has(constructor)) context.add(constructor);
            var definition = constructor._definition;
            definition.addField(field, type);
            /**
             * skip if descriptor already exists for this field (`@deprecated()`)
             */ if (definition.descriptors[field]) {
                if (definition.deprecated[field]) // do not create accessors for deprecated properties.
                return;
                else // trying to define same property multiple times across inheritance.
                // https://github.com/colyseus/colyseus-unity3d/issues/131#issuecomment-814308572
                try {
                    throw new Error("@colyseus/schema: Duplicate '".concat(field, "' definition on '").concat(constructor.name, "'.\nCheck @type() annotation"));
                } catch (e) {
                    var definitionAtLine = e.stack.split("\n")[4].trim();
                    throw new Error("".concat(e.message, " ").concat(definitionAtLine));
                }
            }
            var isArray = ArraySchema.is(type);
            var isMap = !isArray && MapSchema.is(type);
            // TODO: refactor me.
            // Allow abstract intermediary classes with no fields to be serialized
            // (See "should support an inheritance with a Schema type without fields" test)
            if (typeof type !== "string" && !Schema.is(type)) {
                var childType = Object.values(type)[0];
                if (typeof childType !== "string" && !context.has(childType)) context.add(childType);
            }
            if (options.manual) {
                // do not declare getter/setter descriptor
                definition.descriptors[field] = {
                    enumerable: true,
                    configurable: true,
                    writable: true
                };
                return;
            }
            var fieldCached = "_".concat(field);
            definition.descriptors[fieldCached] = {
                enumerable: false,
                configurable: false,
                writable: true
            };
            definition.descriptors[field] = {
                get: function() {
                    return this[fieldCached];
                },
                set: function(value) {
                    /**
                     * Create Proxy for array or map items
                     */ // skip if value is the same as cached.
                    if (value === this[fieldCached]) return;
                    if (value !== undefined && value !== null) {
                        // automaticallty transform Array into ArraySchema
                        if (isArray && !(value instanceof ArraySchema)) value = new (ArraySchema.bind.apply(ArraySchema, __spreadArray([
                            void 0
                        ], value, false)))();
                        // automaticallty transform Map into MapSchema
                        if (isMap && !(value instanceof MapSchema)) value = new MapSchema(value);
                        // try to turn provided structure into a Proxy
                        if (value["$proxy"] === undefined) {
                            if (isMap) value = getMapProxy(value);
                            else if (isArray) value = getArrayProxy(value);
                        }
                        // flag the change for encoding.
                        this.$changes.change(field);
                        //
                        // call setParent() recursively for this and its child
                        // structures.
                        //
                        if (value["$changes"]) value["$changes"].setParent(this, this.$changes.root, this._definition.indexes[field]);
                    } else if (this[fieldCached]) //
                    // Setting a field to `null` or `undefined` will delete it.
                    //
                    this.$changes.delete(field);
                    this[fieldCached] = value;
                },
                enumerable: true,
                configurable: true
            };
        };
    }
    /**
     * `@filter()` decorator for defining data filters per client
     */ function filter(cb) {
        return function(target, field) {
            var constructor = target.constructor;
            var definition = constructor._definition;
            if (definition.addFilter(field, cb)) constructor._context.useFilters = true;
        };
    }
    function filterChildren(cb) {
        return function(target, field) {
            var constructor = target.constructor;
            var definition = constructor._definition;
            if (definition.addChildrenFilter(field, cb)) constructor._context.useFilters = true;
        };
    }
    /**
     * `@deprecated()` flag a field as deprecated.
     * The previous `@type()` annotation should remain along with this one.
     */ function deprecated(throws) {
        if (throws === void 0) throws = true;
        return function(target, field) {
            var constructor = target.constructor;
            var definition = constructor._definition;
            definition.deprecated[field] = true;
            if (throws) definition.descriptors[field] = {
                get: function() {
                    throw new Error("".concat(field, " is deprecated."));
                },
                set: function(value) {},
                enumerable: false,
                configurable: true
            };
        };
    }
    function defineTypes(target, fields, options) {
        if (options === void 0) options = {};
        if (!options.context) options.context = target._context || options.context || globalContext;
        for(var field in fields)type(fields[field], options)(target.prototype, field);
        return target;
    }
    /**
     * Copyright (c) 2018 Endel Dreyer
     * Copyright (c) 2014 Ion Drive Software Ltd.
     *
     * Permission is hereby granted, free of charge, to any person obtaining a copy
     * of this software and associated documentation files (the "Software"), to deal
     * in the Software without restriction, including without limitation the rights
     * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
     * copies of the Software, and to permit persons to whom the Software is
     * furnished to do so, subject to the following conditions:
     *
     * The above copyright notice and this permission notice shall be included in all
     * copies or substantial portions of the Software.
     *
     * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
     * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
     * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
     * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
     * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
     * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
     * SOFTWARE
     */ /**
     * msgpack implementation highly based on notepack.io
     * https://github.com/darrachequesne/notepack
     */ function utf8Length(str) {
        var c = 0, length = 0;
        for(var i = 0, l = str.length; i < l; i++){
            c = str.charCodeAt(i);
            if (c < 0x80) length += 1;
            else if (c < 0x800) length += 2;
            else if (c < 0xd800 || c >= 0xe000) length += 3;
            else {
                i++;
                length += 4;
            }
        }
        return length;
    }
    function utf8Write(view, offset, str) {
        var c = 0;
        for(var i = 0, l = str.length; i < l; i++){
            c = str.charCodeAt(i);
            if (c < 0x80) view[offset++] = c;
            else if (c < 0x800) {
                view[offset++] = 0xc0 | c >> 6;
                view[offset++] = 0x80 | c & 0x3f;
            } else if (c < 0xd800 || c >= 0xe000) {
                view[offset++] = 0xe0 | c >> 12;
                view[offset++] = 0x80 | c >> 6 & 0x3f;
                view[offset++] = 0x80 | c & 0x3f;
            } else {
                i++;
                c = 0x10000 + ((c & 0x3ff) << 10 | str.charCodeAt(i) & 0x3ff);
                view[offset++] = 0xf0 | c >> 18;
                view[offset++] = 0x80 | c >> 12 & 0x3f;
                view[offset++] = 0x80 | c >> 6 & 0x3f;
                view[offset++] = 0x80 | c & 0x3f;
            }
        }
    }
    function int8$1(bytes, value) {
        bytes.push(value & 255);
    }
    function uint8$1(bytes, value) {
        bytes.push(value & 255);
    }
    function int16$1(bytes, value) {
        bytes.push(value & 255);
        bytes.push(value >> 8 & 255);
    }
    function uint16$1(bytes, value) {
        bytes.push(value & 255);
        bytes.push(value >> 8 & 255);
    }
    function int32$1(bytes, value) {
        bytes.push(value & 255);
        bytes.push(value >> 8 & 255);
        bytes.push(value >> 16 & 255);
        bytes.push(value >> 24 & 255);
    }
    function uint32$1(bytes, value) {
        var b4 = value >> 24;
        var b3 = value >> 16;
        var b2 = value >> 8;
        var b1 = value;
        bytes.push(b1 & 255);
        bytes.push(b2 & 255);
        bytes.push(b3 & 255);
        bytes.push(b4 & 255);
    }
    function int64$1(bytes, value) {
        var high = Math.floor(value / Math.pow(2, 32));
        var low = value >>> 0;
        uint32$1(bytes, low);
        uint32$1(bytes, high);
    }
    function uint64$1(bytes, value) {
        var high = value / Math.pow(2, 32) >> 0;
        var low = value >>> 0;
        uint32$1(bytes, low);
        uint32$1(bytes, high);
    }
    function float32$1(bytes, value) {
        writeFloat32(bytes, value);
    }
    function float64$1(bytes, value) {
        writeFloat64(bytes, value);
    }
    var _int32$1 = new Int32Array(2);
    var _float32$1 = new Float32Array(_int32$1.buffer);
    var _float64$1 = new Float64Array(_int32$1.buffer);
    function writeFloat32(bytes, value) {
        _float32$1[0] = value;
        int32$1(bytes, _int32$1[0]);
    }
    function writeFloat64(bytes, value) {
        _float64$1[0] = value;
        int32$1(bytes, _int32$1[0]);
        int32$1(bytes, _int32$1[1]);
    }
    function boolean$1(bytes, value) {
        return uint8$1(bytes, value ? 1 : 0);
    }
    function string$1(bytes, value) {
        // encode `null` strings as empty.
        if (!value) value = "";
        var length = utf8Length(value);
        var size = 0;
        // fixstr
        if (length < 0x20) {
            bytes.push(length | 0xa0);
            size = 1;
        } else if (length < 0x100) {
            bytes.push(0xd9);
            uint8$1(bytes, length);
            size = 2;
        } else if (length < 0x10000) {
            bytes.push(0xda);
            uint16$1(bytes, length);
            size = 3;
        } else if (length < 0x100000000) {
            bytes.push(0xdb);
            uint32$1(bytes, length);
            size = 5;
        } else throw new Error("String too long");
        utf8Write(bytes, bytes.length, value);
        return size + length;
    }
    function number$1(bytes, value) {
        if (isNaN(value)) return number$1(bytes, 0);
        else if (!isFinite(value)) return number$1(bytes, value > 0 ? Number.MAX_SAFE_INTEGER : -Number.MAX_SAFE_INTEGER);
        else if (value !== (value | 0)) {
            bytes.push(0xcb);
            writeFloat64(bytes, value);
            return 9;
        // TODO: encode float 32?
        // is it possible to differentiate between float32 / float64 here?
        // // float 32
        // bytes.push(0xca);
        // writeFloat32(bytes, value);
        // return 5;
        }
        if (value >= 0) {
            // positive fixnum
            if (value < 0x80) {
                uint8$1(bytes, value);
                return 1;
            }
            // uint 8
            if (value < 0x100) {
                bytes.push(0xcc);
                uint8$1(bytes, value);
                return 2;
            }
            // uint 16
            if (value < 0x10000) {
                bytes.push(0xcd);
                uint16$1(bytes, value);
                return 3;
            }
            // uint 32
            if (value < 0x100000000) {
                bytes.push(0xce);
                uint32$1(bytes, value);
                return 5;
            }
            // uint 64
            bytes.push(0xcf);
            uint64$1(bytes, value);
            return 9;
        } else {
            // negative fixnum
            if (value >= -32) {
                bytes.push(0xe0 | value + 0x20);
                return 1;
            }
            // int 8
            if (value >= -128) {
                bytes.push(0xd0);
                int8$1(bytes, value);
                return 2;
            }
            // int 16
            if (value >= -32768) {
                bytes.push(0xd1);
                int16$1(bytes, value);
                return 3;
            }
            // int 32
            if (value >= -2147483648) {
                bytes.push(0xd2);
                int32$1(bytes, value);
                return 5;
            }
            // int 64
            bytes.push(0xd3);
            int64$1(bytes, value);
            return 9;
        }
    }
    var encode = /*#__PURE__*/ Object.freeze({
        __proto__: null,
        utf8Write: utf8Write,
        int8: int8$1,
        uint8: uint8$1,
        int16: int16$1,
        uint16: uint16$1,
        int32: int32$1,
        uint32: uint32$1,
        int64: int64$1,
        uint64: uint64$1,
        float32: float32$1,
        float64: float64$1,
        writeFloat32: writeFloat32,
        writeFloat64: writeFloat64,
        boolean: boolean$1,
        string: string$1,
        number: number$1
    });
    /**
     * Copyright (c) 2018 Endel Dreyer
     * Copyright (c) 2014 Ion Drive Software Ltd.
     *
     * Permission is hereby granted, free of charge, to any person obtaining a copy
     * of this software and associated documentation files (the "Software"), to deal
     * in the Software without restriction, including without limitation the rights
     * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
     * copies of the Software, and to permit persons to whom the Software is
     * furnished to do so, subject to the following conditions:
     *
     * The above copyright notice and this permission notice shall be included in all
     * copies or substantial portions of the Software.
     *
     * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
     * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
     * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
     * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
     * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
     * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
     * SOFTWARE
     */ function utf8Read(bytes, offset, length) {
        var string = "", chr = 0;
        for(var i = offset, end = offset + length; i < end; i++){
            var byte = bytes[i];
            if ((byte & 0x80) === 0x00) {
                string += String.fromCharCode(byte);
                continue;
            }
            if ((byte & 0xe0) === 0xc0) {
                string += String.fromCharCode((byte & 0x1f) << 6 | bytes[++i] & 0x3f);
                continue;
            }
            if ((byte & 0xf0) === 0xe0) {
                string += String.fromCharCode((byte & 0x0f) << 12 | (bytes[++i] & 0x3f) << 6 | (bytes[++i] & 0x3f) << 0);
                continue;
            }
            if ((byte & 0xf8) === 0xf0) {
                chr = (byte & 0x07) << 18 | (bytes[++i] & 0x3f) << 12 | (bytes[++i] & 0x3f) << 6 | (bytes[++i] & 0x3f) << 0;
                if (chr >= 0x010000) {
                    chr -= 0x010000;
                    string += String.fromCharCode((chr >>> 10) + 0xD800, (chr & 0x3FF) + 0xDC00);
                } else string += String.fromCharCode(chr);
                continue;
            }
            console.error("Invalid byte " + byte.toString(16));
        // (do not throw error to avoid server/client from crashing due to hack attemps)
        // throw new Error('Invalid byte ' + byte.toString(16));
        }
        return string;
    }
    function int8(bytes, it) {
        return uint8(bytes, it) << 24 >> 24;
    }
    function uint8(bytes, it) {
        return bytes[it.offset++];
    }
    function int16(bytes, it) {
        return uint16(bytes, it) << 16 >> 16;
    }
    function uint16(bytes, it) {
        return bytes[it.offset++] | bytes[it.offset++] << 8;
    }
    function int32(bytes, it) {
        return bytes[it.offset++] | bytes[it.offset++] << 8 | bytes[it.offset++] << 16 | bytes[it.offset++] << 24;
    }
    function uint32(bytes, it) {
        return int32(bytes, it) >>> 0;
    }
    function float32(bytes, it) {
        return readFloat32(bytes, it);
    }
    function float64(bytes, it) {
        return readFloat64(bytes, it);
    }
    function int64(bytes, it) {
        var low = uint32(bytes, it);
        var high = int32(bytes, it) * Math.pow(2, 32);
        return high + low;
    }
    function uint64(bytes, it) {
        var low = uint32(bytes, it);
        var high = uint32(bytes, it) * Math.pow(2, 32);
        return high + low;
    }
    var _int32 = new Int32Array(2);
    var _float32 = new Float32Array(_int32.buffer);
    var _float64 = new Float64Array(_int32.buffer);
    function readFloat32(bytes, it) {
        _int32[0] = int32(bytes, it);
        return _float32[0];
    }
    function readFloat64(bytes, it) {
        _int32[0] = int32(bytes, it);
        _int32[1] = int32(bytes, it);
        return _float64[0];
    }
    function boolean(bytes, it) {
        return uint8(bytes, it) > 0;
    }
    function string(bytes, it) {
        var prefix = bytes[it.offset++];
        var length;
        if (prefix < 0xc0) // fixstr
        length = prefix & 0x1f;
        else if (prefix === 0xd9) length = uint8(bytes, it);
        else if (prefix === 0xda) length = uint16(bytes, it);
        else if (prefix === 0xdb) length = uint32(bytes, it);
        var value = utf8Read(bytes, it.offset, length);
        it.offset += length;
        return value;
    }
    function stringCheck(bytes, it) {
        var prefix = bytes[it.offset];
        return(// fixstr
        prefix < 0xc0 && prefix > 0xa0 || // str 8
        prefix === 0xd9 || // str 16
        prefix === 0xda || // str 32
        prefix === 0xdb);
    }
    function number(bytes, it) {
        var prefix = bytes[it.offset++];
        if (prefix < 0x80) // positive fixint
        return prefix;
        else if (prefix === 0xca) // float 32
        return readFloat32(bytes, it);
        else if (prefix === 0xcb) // float 64
        return readFloat64(bytes, it);
        else if (prefix === 0xcc) // uint 8
        return uint8(bytes, it);
        else if (prefix === 0xcd) // uint 16
        return uint16(bytes, it);
        else if (prefix === 0xce) // uint 32
        return uint32(bytes, it);
        else if (prefix === 0xcf) // uint 64
        return uint64(bytes, it);
        else if (prefix === 0xd0) // int 8
        return int8(bytes, it);
        else if (prefix === 0xd1) // int 16
        return int16(bytes, it);
        else if (prefix === 0xd2) // int 32
        return int32(bytes, it);
        else if (prefix === 0xd3) // int 64
        return int64(bytes, it);
        else if (prefix > 0xdf) // negative fixint
        return (0xff - prefix + 1) * -1;
    }
    function numberCheck(bytes, it) {
        var prefix = bytes[it.offset];
        // positive fixint - 0x00 - 0x7f
        // float 32        - 0xca
        // float 64        - 0xcb
        // uint 8          - 0xcc
        // uint 16         - 0xcd
        // uint 32         - 0xce
        // uint 64         - 0xcf
        // int 8           - 0xd0
        // int 16          - 0xd1
        // int 32          - 0xd2
        // int 64          - 0xd3
        return prefix < 0x80 || prefix >= 0xca && prefix <= 0xd3;
    }
    function arrayCheck(bytes, it) {
        return bytes[it.offset] < 0xa0;
    // const prefix = bytes[it.offset] ;
    // if (prefix < 0xa0) {
    //   return prefix;
    // // array
    // } else if (prefix === 0xdc) {
    //   it.offset += 2;
    // } else if (0xdd) {
    //   it.offset += 4;
    // }
    // return prefix;
    }
    function switchStructureCheck(bytes, it) {
        return(// previous byte should be `SWITCH_TO_STRUCTURE`
        bytes[it.offset - 1] === SWITCH_TO_STRUCTURE && // next byte should be a number
        (bytes[it.offset] < 0x80 || bytes[it.offset] >= 0xca && bytes[it.offset] <= 0xd3));
    }
    var decode = /*#__PURE__*/ Object.freeze({
        __proto__: null,
        int8: int8,
        uint8: uint8,
        int16: int16,
        uint16: uint16,
        int32: int32,
        uint32: uint32,
        float32: float32,
        float64: float64,
        int64: int64,
        uint64: uint64,
        readFloat32: readFloat32,
        readFloat64: readFloat64,
        boolean: boolean,
        string: string,
        stringCheck: stringCheck,
        number: number,
        numberCheck: numberCheck,
        arrayCheck: arrayCheck,
        switchStructureCheck: switchStructureCheck
    });
    var CollectionSchema = /** @class */ function() {
        function CollectionSchema(initialValues) {
            var _this = this;
            this.$changes = new ChangeTree(this);
            this.$items = new Map();
            this.$indexes = new Map();
            this.$refId = 0;
            if (initialValues) initialValues.forEach(function(v) {
                return _this.add(v);
            });
        }
        CollectionSchema.prototype.onAdd = function(callback, triggerAll) {
            if (triggerAll === void 0) triggerAll = true;
            return addCallback(this.$callbacks || (this.$callbacks = []), exports1.OPERATION.ADD, callback, triggerAll ? this.$items : undefined);
        };
        CollectionSchema.prototype.onRemove = function(callback) {
            return addCallback(this.$callbacks || (this.$callbacks = []), exports1.OPERATION.DELETE, callback);
        };
        CollectionSchema.prototype.onChange = function(callback) {
            return addCallback(this.$callbacks || (this.$callbacks = []), exports1.OPERATION.REPLACE, callback);
        };
        CollectionSchema.is = function(type) {
            return type["collection"] !== undefined;
        };
        CollectionSchema.prototype.add = function(value) {
            // set "index" for reference.
            var index = this.$refId++;
            var isRef = value["$changes"] !== undefined;
            if (isRef) value["$changes"].setParent(this, this.$changes.root, index);
            this.$changes.indexes[index] = index;
            this.$indexes.set(index, index);
            this.$items.set(index, value);
            this.$changes.change(index);
            return index;
        };
        CollectionSchema.prototype.at = function(index) {
            var key = Array.from(this.$items.keys())[index];
            return this.$items.get(key);
        };
        CollectionSchema.prototype.entries = function() {
            return this.$items.entries();
        };
        CollectionSchema.prototype.delete = function(item) {
            var entries = this.$items.entries();
            var index;
            var entry;
            while(entry = entries.next()){
                if (entry.done) break;
                if (item === entry.value[1]) {
                    index = entry.value[0];
                    break;
                }
            }
            if (index === undefined) return false;
            this.$changes.delete(index);
            this.$indexes.delete(index);
            return this.$items.delete(index);
        };
        CollectionSchema.prototype.clear = function(changes) {
            // discard previous operations.
            this.$changes.discard(true, true);
            this.$changes.indexes = {};
            // clear previous indexes
            this.$indexes.clear();
            //
            // When decoding:
            // - enqueue items for DELETE callback.
            // - flag child items for garbage collection.
            //
            if (changes) removeChildRefs.call(this, changes);
            // clear items
            this.$items.clear();
            this.$changes.operation({
                index: 0,
                op: exports1.OPERATION.CLEAR
            });
            // touch all structures until reach root
            this.$changes.touchParents();
        };
        CollectionSchema.prototype.has = function(value) {
            return Array.from(this.$items.values()).some(function(v) {
                return v === value;
            });
        };
        CollectionSchema.prototype.forEach = function(callbackfn) {
            var _this = this;
            this.$items.forEach(function(value, key, _) {
                return callbackfn(value, key, _this);
            });
        };
        CollectionSchema.prototype.values = function() {
            return this.$items.values();
        };
        Object.defineProperty(CollectionSchema.prototype, "size", {
            get: function() {
                return this.$items.size;
            },
            enumerable: false,
            configurable: true
        });
        CollectionSchema.prototype.setIndex = function(index, key) {
            this.$indexes.set(index, key);
        };
        CollectionSchema.prototype.getIndex = function(index) {
            return this.$indexes.get(index);
        };
        CollectionSchema.prototype.getByIndex = function(index) {
            return this.$items.get(this.$indexes.get(index));
        };
        CollectionSchema.prototype.deleteByIndex = function(index) {
            var key = this.$indexes.get(index);
            this.$items.delete(key);
            this.$indexes.delete(index);
        };
        CollectionSchema.prototype.toArray = function() {
            return Array.from(this.$items.values());
        };
        CollectionSchema.prototype.toJSON = function() {
            var values = [];
            this.forEach(function(value, key) {
                values.push(typeof value["toJSON"] === "function" ? value["toJSON"]() : value);
            });
            return values;
        };
        //
        // Decoding utilities
        //
        CollectionSchema.prototype.clone = function(isDecoding) {
            var cloned;
            if (isDecoding) // client-side
            cloned = Object.assign(new CollectionSchema(), this);
            else {
                // server-side
                cloned = new CollectionSchema();
                this.forEach(function(value) {
                    if (value["$changes"]) cloned.add(value["clone"]());
                    else cloned.add(value);
                });
            }
            return cloned;
        };
        return CollectionSchema;
    }();
    var SetSchema = /** @class */ function() {
        function SetSchema(initialValues) {
            var _this = this;
            this.$changes = new ChangeTree(this);
            this.$items = new Map();
            this.$indexes = new Map();
            this.$refId = 0;
            if (initialValues) initialValues.forEach(function(v) {
                return _this.add(v);
            });
        }
        SetSchema.prototype.onAdd = function(callback, triggerAll) {
            if (triggerAll === void 0) triggerAll = true;
            return addCallback(this.$callbacks || (this.$callbacks = []), exports1.OPERATION.ADD, callback, triggerAll ? this.$items : undefined);
        };
        SetSchema.prototype.onRemove = function(callback) {
            return addCallback(this.$callbacks || (this.$callbacks = []), exports1.OPERATION.DELETE, callback);
        };
        SetSchema.prototype.onChange = function(callback) {
            return addCallback(this.$callbacks || (this.$callbacks = []), exports1.OPERATION.REPLACE, callback);
        };
        SetSchema.is = function(type) {
            return type["set"] !== undefined;
        };
        SetSchema.prototype.add = function(value) {
            var _a, _b;
            // immediatelly return false if value already added.
            if (this.has(value)) return false;
            // set "index" for reference.
            var index = this.$refId++;
            if (value["$changes"] !== undefined) value["$changes"].setParent(this, this.$changes.root, index);
            var operation = (_b = (_a = this.$changes.indexes[index]) === null || _a === void 0 ? void 0 : _a.op) !== null && _b !== void 0 ? _b : exports1.OPERATION.ADD;
            this.$changes.indexes[index] = index;
            this.$indexes.set(index, index);
            this.$items.set(index, value);
            this.$changes.change(index, operation);
            return index;
        };
        SetSchema.prototype.entries = function() {
            return this.$items.entries();
        };
        SetSchema.prototype.delete = function(item) {
            var entries = this.$items.entries();
            var index;
            var entry;
            while(entry = entries.next()){
                if (entry.done) break;
                if (item === entry.value[1]) {
                    index = entry.value[0];
                    break;
                }
            }
            if (index === undefined) return false;
            this.$changes.delete(index);
            this.$indexes.delete(index);
            return this.$items.delete(index);
        };
        SetSchema.prototype.clear = function(changes) {
            // discard previous operations.
            this.$changes.discard(true, true);
            this.$changes.indexes = {};
            // clear previous indexes
            this.$indexes.clear();
            //
            // When decoding:
            // - enqueue items for DELETE callback.
            // - flag child items for garbage collection.
            //
            if (changes) removeChildRefs.call(this, changes);
            // clear items
            this.$items.clear();
            this.$changes.operation({
                index: 0,
                op: exports1.OPERATION.CLEAR
            });
            // touch all structures until reach root
            this.$changes.touchParents();
        };
        SetSchema.prototype.has = function(value) {
            var values = this.$items.values();
            var has = false;
            var entry;
            while(entry = values.next()){
                if (entry.done) break;
                if (value === entry.value) {
                    has = true;
                    break;
                }
            }
            return has;
        };
        SetSchema.prototype.forEach = function(callbackfn) {
            var _this = this;
            this.$items.forEach(function(value, key, _) {
                return callbackfn(value, key, _this);
            });
        };
        SetSchema.prototype.values = function() {
            return this.$items.values();
        };
        Object.defineProperty(SetSchema.prototype, "size", {
            get: function() {
                return this.$items.size;
            },
            enumerable: false,
            configurable: true
        });
        SetSchema.prototype.setIndex = function(index, key) {
            this.$indexes.set(index, key);
        };
        SetSchema.prototype.getIndex = function(index) {
            return this.$indexes.get(index);
        };
        SetSchema.prototype.getByIndex = function(index) {
            return this.$items.get(this.$indexes.get(index));
        };
        SetSchema.prototype.deleteByIndex = function(index) {
            var key = this.$indexes.get(index);
            this.$items.delete(key);
            this.$indexes.delete(index);
        };
        SetSchema.prototype.toArray = function() {
            return Array.from(this.$items.values());
        };
        SetSchema.prototype.toJSON = function() {
            var values = [];
            this.forEach(function(value, key) {
                values.push(typeof value["toJSON"] === "function" ? value["toJSON"]() : value);
            });
            return values;
        };
        //
        // Decoding utilities
        //
        SetSchema.prototype.clone = function(isDecoding) {
            var cloned;
            if (isDecoding) // client-side
            cloned = Object.assign(new SetSchema(), this);
            else {
                // server-side
                cloned = new SetSchema();
                this.forEach(function(value) {
                    if (value["$changes"]) cloned.add(value["clone"]());
                    else cloned.add(value);
                });
            }
            return cloned;
        };
        return SetSchema;
    }();
    var ClientState = /** @class */ function() {
        function ClientState() {
            this.refIds = new WeakSet();
            this.containerIndexes = new WeakMap();
        }
        // containerIndexes = new Map<ChangeTree, Set<number>>();
        ClientState.prototype.addRefId = function(changeTree) {
            if (!this.refIds.has(changeTree)) {
                this.refIds.add(changeTree);
                this.containerIndexes.set(changeTree, new Set());
            }
        };
        ClientState.get = function(client) {
            if (client.$filterState === undefined) client.$filterState = new ClientState();
            return client.$filterState;
        };
        return ClientState;
    }();
    var ReferenceTracker = /** @class */ function() {
        function ReferenceTracker() {
            //
            // Relation of refId => Schema structure
            // For direct access of structures during decoding time.
            //
            this.refs = new Map();
            this.refCounts = {};
            this.deletedRefs = new Set();
            this.nextUniqueId = 0;
        }
        ReferenceTracker.prototype.getNextUniqueId = function() {
            return this.nextUniqueId++;
        };
        // for decoding
        ReferenceTracker.prototype.addRef = function(refId, ref, incrementCount) {
            if (incrementCount === void 0) incrementCount = true;
            this.refs.set(refId, ref);
            if (incrementCount) this.refCounts[refId] = (this.refCounts[refId] || 0) + 1;
        };
        // for decoding
        ReferenceTracker.prototype.removeRef = function(refId) {
            var refCount = this.refCounts[refId];
            if (refCount === undefined) {
                console.warn("trying to remove reference ".concat(refId, " that doesn't exist"));
                return;
            }
            if (refCount === 0) {
                console.warn("trying to remove reference ".concat(refId, " with 0 refCount"));
                return;
            }
            this.refCounts[refId] = refCount - 1;
            this.deletedRefs.add(refId);
        };
        ReferenceTracker.prototype.clearRefs = function() {
            this.refs.clear();
            this.deletedRefs.clear();
            this.refCounts = {};
        };
        // for decoding
        ReferenceTracker.prototype.garbageCollectDeletedRefs = function() {
            var _this = this;
            this.deletedRefs.forEach(function(refId) {
                //
                // Skip active references.
                //
                if (_this.refCounts[refId] > 0) return;
                var ref = _this.refs.get(refId);
                //
                // Ensure child schema instances have their references removed as well.
                //
                if (ref instanceof Schema) {
                    for(var fieldName in ref["_definition"].schema)if (typeof ref["_definition"].schema[fieldName] !== "string" && ref[fieldName] && ref[fieldName]["$changes"]) _this.removeRef(ref[fieldName]["$changes"].refId);
                } else {
                    var definition = ref["$changes"].parent._definition;
                    var type = definition.schema[definition.fieldsByIndex[ref["$changes"].parentIndex]];
                    if (typeof Object.values(type)[0] === "function") Array.from(ref.values()).forEach(function(child) {
                        return _this.removeRef(child["$changes"].refId);
                    });
                }
                _this.refs.delete(refId);
                delete _this.refCounts[refId];
            });
            // clear deleted refs.
            this.deletedRefs.clear();
        };
        return ReferenceTracker;
    }();
    var EncodeSchemaError = /** @class */ function(_super) {
        __extends(EncodeSchemaError, _super);
        function EncodeSchemaError() {
            return _super !== null && _super.apply(this, arguments) || this;
        }
        return EncodeSchemaError;
    }(Error);
    function assertType(value, type, klass, field) {
        var typeofTarget;
        var allowNull = false;
        switch(type){
            case "number":
            case "int8":
            case "uint8":
            case "int16":
            case "uint16":
            case "int32":
            case "uint32":
            case "int64":
            case "uint64":
            case "float32":
            case "float64":
                typeofTarget = "number";
                if (isNaN(value)) console.log('trying to encode "NaN" in '.concat(klass.constructor.name, "#").concat(field));
                break;
            case "string":
                typeofTarget = "string";
                allowNull = true;
                break;
            case "boolean":
                // boolean is always encoded as true/false based on truthiness
                return;
        }
        if (typeof value !== typeofTarget && (!allowNull || allowNull && value !== null)) {
            var foundValue = "'".concat(JSON.stringify(value), "'").concat(value && value.constructor && " (".concat(value.constructor.name, ")") || "");
            throw new EncodeSchemaError("a '".concat(typeofTarget, "' was expected, but ").concat(foundValue, " was provided in ").concat(klass.constructor.name, "#").concat(field));
        }
    }
    function assertInstanceType(value, type, klass, field) {
        if (!(value instanceof type)) throw new EncodeSchemaError("a '".concat(type.name, "' was expected, but '").concat(value.constructor.name, "' was provided in ").concat(klass.constructor.name, "#").concat(field));
    }
    function encodePrimitiveType(type, bytes, value, klass, field) {
        assertType(value, type, klass, field);
        var encodeFunc = encode[type];
        if (encodeFunc) encodeFunc(bytes, value);
        else throw new EncodeSchemaError("a '".concat(type, "' was expected, but ").concat(value, " was provided in ").concat(klass.constructor.name, "#").concat(field));
    }
    function decodePrimitiveType(type, bytes, it) {
        return decode[type](bytes, it);
    }
    /**
     * Schema encoder / decoder
     */ var Schema = /** @class */ function() {
        // allow inherited classes to have a constructor
        function Schema() {
            var args = [];
            for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
            // fix enumerability of fields for end-user
            Object.defineProperties(this, {
                $changes: {
                    value: new ChangeTree(this, undefined, new ReferenceTracker()),
                    enumerable: false,
                    writable: true
                },
                // $listeners: {
                //     value: undefined,
                //     enumerable: false,
                //     writable: true
                // },
                $callbacks: {
                    value: undefined,
                    enumerable: false,
                    writable: true
                }
            });
            var descriptors = this._definition.descriptors;
            if (descriptors) Object.defineProperties(this, descriptors);
            //
            // Assign initial values
            //
            if (args[0]) this.assign(args[0]);
        }
        Schema.onError = function(e) {
            console.error(e);
        };
        Schema.is = function(type) {
            return type["_definition"] && type["_definition"].schema !== undefined;
        };
        Schema.prototype.onChange = function(callback) {
            return addCallback(this.$callbacks || (this.$callbacks = {}), exports1.OPERATION.REPLACE, callback);
        };
        Schema.prototype.onRemove = function(callback) {
            return addCallback(this.$callbacks || (this.$callbacks = {}), exports1.OPERATION.DELETE, callback);
        };
        Schema.prototype.assign = function(props) {
            Object.assign(this, props);
            return this;
        };
        Object.defineProperty(Schema.prototype, "_definition", {
            get: function() {
                return this.constructor._definition;
            },
            enumerable: false,
            configurable: true
        });
        /**
         * (Server-side): Flag a property to be encoded for the next patch.
         * @param instance Schema instance
         * @param property string representing the property name, or number representing the index of the property.
         * @param operation OPERATION to perform (detected automatically)
         */ Schema.prototype.setDirty = function(property, operation) {
            this.$changes.change(property, operation);
        };
        /**
         * Client-side: listen for changes on property.
         * @param prop the property name
         * @param callback callback to be triggered on property change
         * @param immediate trigger immediatelly if property has been already set.
         */ Schema.prototype.listen = function(prop, callback, immediate) {
            var _this = this;
            if (immediate === void 0) immediate = true;
            if (!this.$callbacks) this.$callbacks = {};
            if (!this.$callbacks[prop]) this.$callbacks[prop] = [];
            this.$callbacks[prop].push(callback);
            if (immediate && this[prop] !== undefined) callback(this[prop], undefined);
            // return un-register callback.
            return function() {
                return spliceOne(_this.$callbacks[prop], _this.$callbacks[prop].indexOf(callback));
            };
        };
        Schema.prototype.decode = function(bytes, it, ref) {
            if (it === void 0) it = {
                offset: 0
            };
            if (ref === void 0) ref = this;
            var allChanges = [];
            var $root = this.$changes.root;
            var totalBytes = bytes.length;
            var refId = 0;
            $root.refs.set(refId, this);
            while(it.offset < totalBytes){
                var byte = bytes[it.offset++];
                if (byte == SWITCH_TO_STRUCTURE) {
                    refId = number(bytes, it);
                    var nextRef = $root.refs.get(refId);
                    //
                    // Trying to access a reference that haven't been decoded yet.
                    //
                    if (!nextRef) throw new Error('"refId" not found: '.concat(refId));
                    ref = nextRef;
                    continue;
                }
                var changeTree = ref["$changes"];
                var isSchema = ref["_definition"] !== undefined;
                var operation = isSchema ? byte >> 6 << 6 // "compressed" index + operation
                 : byte; // "uncompressed" index + operation (array/map items)
                if (operation === exports1.OPERATION.CLEAR) {
                    //
                    // TODO: refactor me!
                    // The `.clear()` method is calling `$root.removeRef(refId)` for
                    // each item inside this collection
                    //
                    ref.clear(allChanges);
                    continue;
                }
                var fieldIndex = isSchema ? byte % (operation || 255 // if "REPLACE" operation (0), use 255
                ) : number(bytes, it);
                var fieldName = isSchema ? ref["_definition"].fieldsByIndex[fieldIndex] : "";
                var type = changeTree.getType(fieldIndex);
                var value = void 0;
                var previousValue = void 0;
                var dynamicIndex = void 0;
                if (!isSchema) {
                    previousValue = ref["getByIndex"](fieldIndex);
                    if ((operation & exports1.OPERATION.ADD) === exports1.OPERATION.ADD) {
                        dynamicIndex = ref instanceof MapSchema ? string(bytes, it) : fieldIndex;
                        ref["setIndex"](fieldIndex, dynamicIndex);
                    } else // here
                    dynamicIndex = ref["getIndex"](fieldIndex);
                } else previousValue = ref["_".concat(fieldName)];
                //
                // Delete operations
                //
                if ((operation & exports1.OPERATION.DELETE) === exports1.OPERATION.DELETE) {
                    if (operation !== exports1.OPERATION.DELETE_AND_ADD) ref["deleteByIndex"](fieldIndex);
                    // Flag `refId` for garbage collection.
                    if (previousValue && previousValue["$changes"]) $root.removeRef(previousValue["$changes"].refId);
                    value = null;
                }
                if (fieldName === undefined) {
                    console.warn("@colyseus/schema: definition mismatch");
                    //
                    // keep skipping next bytes until reaches a known structure
                    // by local decoder.
                    //
                    var nextIterator = {
                        offset: it.offset
                    };
                    while(it.offset < totalBytes){
                        if (switchStructureCheck(bytes, it)) {
                            nextIterator.offset = it.offset + 1;
                            if ($root.refs.has(number(bytes, nextIterator))) break;
                        }
                        it.offset++;
                    }
                    continue;
                } else if (operation === exports1.OPERATION.DELETE) ;
                else if (Schema.is(type)) {
                    var refId_1 = number(bytes, it);
                    value = $root.refs.get(refId_1);
                    if (operation !== exports1.OPERATION.REPLACE) {
                        var childType = this.getSchemaType(bytes, it, type);
                        if (!value) {
                            value = this.createTypeInstance(childType);
                            value.$changes.refId = refId_1;
                            if (previousValue) {
                                value.$callbacks = previousValue.$callbacks;
                                // value.$listeners = previousValue.$listeners;
                                if (previousValue["$changes"].refId && refId_1 !== previousValue["$changes"].refId) $root.removeRef(previousValue["$changes"].refId);
                            }
                        }
                        $root.addRef(refId_1, value, value !== previousValue);
                    }
                } else if (typeof type === "string") //
                // primitive value (number, string, boolean, etc)
                //
                value = decodePrimitiveType(type, bytes, it);
                else {
                    var typeDef = getType(Object.keys(type)[0]);
                    var refId_2 = number(bytes, it);
                    var valueRef = $root.refs.has(refId_2) ? previousValue || $root.refs.get(refId_2) : new typeDef.constructor();
                    value = valueRef.clone(true);
                    value.$changes.refId = refId_2;
                    // preserve schema callbacks
                    if (previousValue) {
                        value["$callbacks"] = previousValue["$callbacks"];
                        if (previousValue["$changes"].refId && refId_2 !== previousValue["$changes"].refId) {
                            $root.removeRef(previousValue["$changes"].refId);
                            //
                            // Trigger onRemove if structure has been replaced.
                            //
                            var entries = previousValue.entries();
                            var iter = void 0;
                            while((iter = entries.next()) && !iter.done){
                                var _a = iter.value, key = _a[0], value_1 = _a[1];
                                allChanges.push({
                                    refId: refId_2,
                                    op: exports1.OPERATION.DELETE,
                                    field: key,
                                    value: undefined,
                                    previousValue: value_1
                                });
                            }
                        }
                    }
                    $root.addRef(refId_2, value, valueRef !== previousValue);
                }
                if (value !== null && value !== undefined) {
                    if (value["$changes"]) value["$changes"].setParent(changeTree.ref, changeTree.root, fieldIndex);
                    if (ref instanceof Schema) ref[fieldName] = value;
                    else if (ref instanceof MapSchema) {
                        // const key = ref['$indexes'].get(field);
                        var key = dynamicIndex;
                        // ref.set(key, value);
                        ref["$items"].set(key, value);
                        ref["$changes"].allChanges.add(fieldIndex);
                    } else if (ref instanceof ArraySchema) // const key = ref['$indexes'][field];
                    // console.log("SETTING FOR ArraySchema =>", { field, key, value });
                    // ref[key] = value;
                    ref.setAt(fieldIndex, value);
                    else if (ref instanceof CollectionSchema) {
                        var index = ref.add(value);
                        ref["setIndex"](fieldIndex, index);
                    } else if (ref instanceof SetSchema) {
                        var index = ref.add(value);
                        if (index !== false) ref["setIndex"](fieldIndex, index);
                    }
                }
                if (previousValue !== value) allChanges.push({
                    refId: refId,
                    op: operation,
                    field: fieldName,
                    dynamicIndex: dynamicIndex,
                    value: value,
                    previousValue: previousValue
                });
            }
            this._triggerChanges(allChanges);
            // drop references of unused schemas
            $root.garbageCollectDeletedRefs();
            return allChanges;
        };
        Schema.prototype.encode = function(encodeAll, bytes, useFilters) {
            if (encodeAll === void 0) encodeAll = false;
            if (bytes === void 0) bytes = [];
            if (useFilters === void 0) useFilters = false;
            var rootChangeTree = this.$changes;
            var refIdsVisited = new WeakSet();
            var changeTrees = [
                rootChangeTree
            ];
            var numChangeTrees = 1;
            for(var i = 0; i < numChangeTrees; i++){
                var changeTree = changeTrees[i];
                var ref = changeTree.ref;
                var isSchema = ref instanceof Schema;
                // Generate unique refId for the ChangeTree.
                changeTree.ensureRefId();
                // mark this ChangeTree as visited.
                refIdsVisited.add(changeTree);
                // root `refId` is skipped.
                if (changeTree !== rootChangeTree && (changeTree.changed || encodeAll)) {
                    uint8$1(bytes, SWITCH_TO_STRUCTURE);
                    number$1(bytes, changeTree.refId);
                }
                var changes = encodeAll ? Array.from(changeTree.allChanges) : Array.from(changeTree.changes.values());
                for(var j = 0, cl = changes.length; j < cl; j++){
                    var operation = encodeAll ? {
                        op: exports1.OPERATION.ADD,
                        index: changes[j]
                    } : changes[j];
                    var fieldIndex = operation.index;
                    var field = isSchema ? ref["_definition"].fieldsByIndex && ref["_definition"].fieldsByIndex[fieldIndex] : fieldIndex;
                    // cache begin index if `useFilters`
                    var beginIndex = bytes.length;
                    // encode field index + operation
                    if (operation.op !== exports1.OPERATION.TOUCH) {
                        if (isSchema) //
                        // Compress `fieldIndex` + `operation` into a single byte.
                        // This adds a limitaion of 64 fields per Schema structure
                        //
                        uint8$1(bytes, fieldIndex | operation.op);
                        else {
                            uint8$1(bytes, operation.op);
                            // custom operations
                            if (operation.op === exports1.OPERATION.CLEAR) continue;
                            // indexed operations
                            number$1(bytes, fieldIndex);
                        }
                    }
                    //
                    // encode "alias" for dynamic fields (maps)
                    //
                    if (!isSchema && (operation.op & exports1.OPERATION.ADD) == exports1.OPERATION.ADD // ADD or DELETE_AND_ADD
                    ) {
                        if (ref instanceof MapSchema) {
                            //
                            // MapSchema dynamic key
                            //
                            var dynamicIndex = changeTree.ref["$indexes"].get(fieldIndex);
                            string$1(bytes, dynamicIndex);
                        }
                    }
                    if (operation.op === exports1.OPERATION.DELETE) continue;
                    // const type = changeTree.childType || ref._schema[field];
                    var type = changeTree.getType(fieldIndex);
                    // const type = changeTree.getType(fieldIndex);
                    var value = changeTree.getValue(fieldIndex);
                    // Enqueue ChangeTree to be visited
                    if (value && value["$changes"] && !refIdsVisited.has(value["$changes"])) {
                        changeTrees.push(value["$changes"]);
                        value["$changes"].ensureRefId();
                        numChangeTrees++;
                    }
                    if (operation.op === exports1.OPERATION.TOUCH) continue;
                    if (Schema.is(type)) {
                        assertInstanceType(value, type, ref, field);
                        //
                        // Encode refId for this instance.
                        // The actual instance is going to be encoded on next `changeTree` iteration.
                        //
                        number$1(bytes, value.$changes.refId);
                        // Try to encode inherited TYPE_ID if it's an ADD operation.
                        if ((operation.op & exports1.OPERATION.ADD) === exports1.OPERATION.ADD) this.tryEncodeTypeId(bytes, type, value.constructor);
                    } else if (typeof type === "string") //
                    // Primitive values
                    //
                    encodePrimitiveType(type, bytes, value, ref, field);
                    else {
                        //
                        // Custom type (MapSchema, ArraySchema, etc)
                        //
                        var definition = getType(Object.keys(type)[0]);
                        //
                        // ensure a ArraySchema has been provided
                        //
                        assertInstanceType(ref["_".concat(field)], definition.constructor, ref, field);
                        //
                        // Encode refId for this instance.
                        // The actual instance is going to be encoded on next `changeTree` iteration.
                        //
                        number$1(bytes, value.$changes.refId);
                    }
                    if (useFilters) // cache begin / end index
                    changeTree.cache(fieldIndex, bytes.slice(beginIndex));
                }
                if (!encodeAll && !useFilters) changeTree.discard();
            }
            return bytes;
        };
        Schema.prototype.encodeAll = function(useFilters) {
            return this.encode(true, [], useFilters);
        };
        Schema.prototype.applyFilters = function(client, encodeAll) {
            var _a, _b;
            if (encodeAll === void 0) encodeAll = false;
            var root = this;
            var refIdsDissallowed = new Set();
            var $filterState = ClientState.get(client);
            var changeTrees = [
                this.$changes
            ];
            var numChangeTrees = 1;
            var filteredBytes = [];
            var _loop_1 = function(i) {
                var changeTree = changeTrees[i];
                if (refIdsDissallowed.has(changeTree.refId)) return "continue";
                var ref = changeTree.ref;
                var isSchema = ref instanceof Schema;
                uint8$1(filteredBytes, SWITCH_TO_STRUCTURE);
                number$1(filteredBytes, changeTree.refId);
                var clientHasRefId = $filterState.refIds.has(changeTree);
                var isEncodeAll = encodeAll || !clientHasRefId;
                // console.log("REF:", ref.constructor.name);
                // console.log("Encode all?", isEncodeAll);
                //
                // include `changeTree` on list of known refIds by this client.
                //
                $filterState.addRefId(changeTree);
                var containerIndexes = $filterState.containerIndexes.get(changeTree);
                var changes = isEncodeAll ? Array.from(changeTree.allChanges) : Array.from(changeTree.changes.values());
                //
                // WORKAROUND: tries to re-evaluate previously not included @filter() attributes
                // - see "DELETE a field of Schema" test case.
                //
                if (!encodeAll && isSchema && ref._definition.indexesWithFilters) {
                    var indexesWithFilters = ref._definition.indexesWithFilters;
                    indexesWithFilters.forEach(function(indexWithFilter) {
                        if (!containerIndexes.has(indexWithFilter) && changeTree.allChanges.has(indexWithFilter)) {
                            if (isEncodeAll) changes.push(indexWithFilter);
                            else changes.push({
                                op: exports1.OPERATION.ADD,
                                index: indexWithFilter
                            });
                        }
                    });
                }
                for(var j = 0, cl = changes.length; j < cl; j++){
                    var change = isEncodeAll ? {
                        op: exports1.OPERATION.ADD,
                        index: changes[j]
                    } : changes[j];
                    // custom operations
                    if (change.op === exports1.OPERATION.CLEAR) {
                        uint8$1(filteredBytes, change.op);
                        continue;
                    }
                    var fieldIndex = change.index;
                    //
                    // Deleting fields: encode the operation + field index
                    //
                    if (change.op === exports1.OPERATION.DELETE) {
                        //
                        // DELETE operations also need to go through filtering.
                        //
                        // TODO: cache the previous value so we can access the value (primitive or `refId`)
                        // (check against `$filterState.refIds`)
                        //
                        if (isSchema) uint8$1(filteredBytes, change.op | fieldIndex);
                        else {
                            uint8$1(filteredBytes, change.op);
                            number$1(filteredBytes, fieldIndex);
                        }
                        continue;
                    }
                    // indexed operation
                    var value = changeTree.getValue(fieldIndex);
                    var type = changeTree.getType(fieldIndex);
                    if (isSchema) {
                        // Is a Schema!
                        var filter = ref._definition.filters && ref._definition.filters[fieldIndex];
                        if (filter && !filter.call(ref, client, value, root)) {
                            if (value && value["$changes"]) refIdsDissallowed.add(value["$changes"].refId);
                            continue;
                        }
                    } else {
                        // Is a collection! (map, array, etc.)
                        var parent = changeTree.parent;
                        var filter = changeTree.getChildrenFilter();
                        if (filter && !filter.call(parent, client, ref["$indexes"].get(fieldIndex), value, root)) {
                            if (value && value["$changes"]) refIdsDissallowed.add(value["$changes"].refId);
                            continue;
                        }
                    }
                    // visit child ChangeTree on further iteration.
                    if (value["$changes"]) {
                        changeTrees.push(value["$changes"]);
                        numChangeTrees++;
                    }
                    //
                    // Copy cached bytes
                    //
                    if (change.op !== exports1.OPERATION.TOUCH) {
                        //
                        // TODO: refactor me!
                        //
                        if (change.op === exports1.OPERATION.ADD || isSchema) {
                            //
                            // use cached bytes directly if is from Schema type.
                            //
                            filteredBytes.push.apply(filteredBytes, (_a = changeTree.caches[fieldIndex]) !== null && _a !== void 0 ? _a : []);
                            containerIndexes.add(fieldIndex);
                        } else if (containerIndexes.has(fieldIndex)) //
                        // use cached bytes if already has the field
                        //
                        filteredBytes.push.apply(filteredBytes, (_b = changeTree.caches[fieldIndex]) !== null && _b !== void 0 ? _b : []);
                        else {
                            //
                            // force ADD operation if field is not known by this client.
                            //
                            containerIndexes.add(fieldIndex);
                            uint8$1(filteredBytes, exports1.OPERATION.ADD);
                            number$1(filteredBytes, fieldIndex);
                            if (ref instanceof MapSchema) {
                                //
                                // MapSchema dynamic key
                                //
                                var dynamicIndex = changeTree.ref["$indexes"].get(fieldIndex);
                                string$1(filteredBytes, dynamicIndex);
                            }
                            if (value["$changes"]) number$1(filteredBytes, value["$changes"].refId);
                            else // "encodePrimitiveType" without type checking.
                            // the type checking has been done on the first .encode() call.
                            encode[type](filteredBytes, value);
                        }
                    } else if (value["$changes"] && !isSchema) {
                        //
                        // TODO:
                        // - track ADD/REPLACE/DELETE instances on `$filterState`
                        // - do NOT always encode dynamicIndex for MapSchema.
                        //   (If client already has that key, only the first index is necessary.)
                        //
                        uint8$1(filteredBytes, exports1.OPERATION.ADD);
                        number$1(filteredBytes, fieldIndex);
                        if (ref instanceof MapSchema) {
                            //
                            // MapSchema dynamic key
                            //
                            var dynamicIndex = changeTree.ref["$indexes"].get(fieldIndex);
                            string$1(filteredBytes, dynamicIndex);
                        }
                        number$1(filteredBytes, value["$changes"].refId);
                    }
                }
            };
            for(var i = 0; i < numChangeTrees; i++)_loop_1(i);
            return filteredBytes;
        };
        Schema.prototype.clone = function() {
            var _a;
            var cloned = new this.constructor;
            var schema = this._definition.schema;
            for(var field in schema)if (typeof this[field] === "object" && typeof ((_a = this[field]) === null || _a === void 0 ? void 0 : _a.clone) === "function") // deep clone
            cloned[field] = this[field].clone();
            else // primitive values
            cloned[field] = this[field];
            return cloned;
        };
        Schema.prototype.toJSON = function() {
            var schema = this._definition.schema;
            var deprecated = this._definition.deprecated;
            var obj = {};
            for(var field in schema)if (!deprecated[field] && this[field] !== null && typeof this[field] !== "undefined") obj[field] = typeof this[field]["toJSON"] === "function" ? this[field]["toJSON"]() : this["_".concat(field)];
            return obj;
        };
        Schema.prototype.discardAllChanges = function() {
            this.$changes.discardAll();
        };
        Schema.prototype.getByIndex = function(index) {
            return this[this._definition.fieldsByIndex[index]];
        };
        Schema.prototype.deleteByIndex = function(index) {
            this[this._definition.fieldsByIndex[index]] = undefined;
        };
        Schema.prototype.tryEncodeTypeId = function(bytes, type, targetType) {
            if (type._typeid !== targetType._typeid) {
                uint8$1(bytes, TYPE_ID);
                number$1(bytes, targetType._typeid);
            }
        };
        Schema.prototype.getSchemaType = function(bytes, it, defaultType) {
            var type;
            if (bytes[it.offset] === TYPE_ID) {
                it.offset++;
                type = this.constructor._context.get(number(bytes, it));
            }
            return type || defaultType;
        };
        Schema.prototype.createTypeInstance = function(type) {
            var instance = new type();
            // assign root on $changes
            instance.$changes.root = this.$changes.root;
            return instance;
        };
        Schema.prototype._triggerChanges = function(changes) {
            var _a, _b, _c, _d, _e, _f, _g, _h, _j;
            var uniqueRefIds = new Set();
            var $refs = this.$changes.root.refs;
            var _loop_2 = function(i) {
                var change = changes[i];
                var refId = change.refId;
                var ref = $refs.get(refId);
                var $callbacks = ref["$callbacks"];
                //
                // trigger onRemove on child structure.
                //
                if ((change.op & exports1.OPERATION.DELETE) === exports1.OPERATION.DELETE && change.previousValue instanceof Schema) (_b = (_a = change.previousValue["$callbacks"]) === null || _a === void 0 ? void 0 : _a[exports1.OPERATION.DELETE]) === null || _b === void 0 || _b.forEach(function(callback) {
                    return callback();
                });
                // no callbacks defined, skip this structure!
                if (!$callbacks) return "continue";
                if (ref instanceof Schema) {
                    if (!uniqueRefIds.has(refId)) try {
                        // trigger onChange
                        (_c = $callbacks === null || $callbacks === void 0 ? void 0 : $callbacks[exports1.OPERATION.REPLACE]) === null || _c === void 0 || _c.forEach(function(callback) {
                            return callback();
                        });
                    } catch (e) {
                        Schema.onError(e);
                    }
                    try {
                        if ($callbacks.hasOwnProperty(change.field)) (_d = $callbacks[change.field]) === null || _d === void 0 || _d.forEach(function(callback) {
                            return callback(change.value, change.previousValue);
                        });
                    } catch (e) {
                        Schema.onError(e);
                    }
                } else {
                    // is a collection of items
                    if (change.op === exports1.OPERATION.ADD && change.previousValue === undefined) // triger onAdd
                    (_e = $callbacks[exports1.OPERATION.ADD]) === null || _e === void 0 || _e.forEach(function(callback) {
                        var _a;
                        return callback(change.value, (_a = change.dynamicIndex) !== null && _a !== void 0 ? _a : change.field);
                    });
                    else if (change.op === exports1.OPERATION.DELETE) //
                    // FIXME: `previousValue` should always be available.
                    // ADD + DELETE operations are still encoding DELETE operation.
                    //
                    {
                        if (change.previousValue !== undefined) // triger onRemove
                        (_f = $callbacks[exports1.OPERATION.DELETE]) === null || _f === void 0 || _f.forEach(function(callback) {
                            var _a;
                            return callback(change.previousValue, (_a = change.dynamicIndex) !== null && _a !== void 0 ? _a : change.field);
                        });
                    } else if (change.op === exports1.OPERATION.DELETE_AND_ADD) {
                        // triger onRemove
                        if (change.previousValue !== undefined) (_g = $callbacks[exports1.OPERATION.DELETE]) === null || _g === void 0 || _g.forEach(function(callback) {
                            var _a;
                            return callback(change.previousValue, (_a = change.dynamicIndex) !== null && _a !== void 0 ? _a : change.field);
                        });
                        // triger onAdd
                        (_h = $callbacks[exports1.OPERATION.ADD]) === null || _h === void 0 || _h.forEach(function(callback) {
                            var _a;
                            return callback(change.value, (_a = change.dynamicIndex) !== null && _a !== void 0 ? _a : change.field);
                        });
                    }
                    // trigger onChange
                    if (change.value !== change.previousValue) (_j = $callbacks[exports1.OPERATION.REPLACE]) === null || _j === void 0 || _j.forEach(function(callback) {
                        var _a;
                        return callback(change.value, (_a = change.dynamicIndex) !== null && _a !== void 0 ? _a : change.field);
                    });
                }
                uniqueRefIds.add(refId);
            };
            for(var i = 0; i < changes.length; i++)_loop_2(i);
        };
        Schema._definition = SchemaDefinition.create();
        return Schema;
    }();
    function dumpChanges(schema) {
        var changeTrees = [
            schema["$changes"]
        ];
        var numChangeTrees = 1;
        var dump = {};
        var currentStructure = dump;
        var _loop_1 = function(i) {
            var changeTree = changeTrees[i];
            changeTree.changes.forEach(function(change) {
                var ref = changeTree.ref;
                var fieldIndex = change.index;
                var field = ref["_definition"] ? ref["_definition"].fieldsByIndex[fieldIndex] : ref["$indexes"].get(fieldIndex);
                currentStructure[field] = changeTree.getValue(fieldIndex);
            });
        };
        for(var i = 0; i < numChangeTrees; i++)_loop_1(i);
        return dump;
    }
    var reflectionContext = {
        context: new Context()
    };
    /**
     * Reflection
     */ var ReflectionField = /** @class */ function(_super) {
        __extends(ReflectionField, _super);
        function ReflectionField() {
            return _super !== null && _super.apply(this, arguments) || this;
        }
        __decorate([
            type("string", reflectionContext)
        ], ReflectionField.prototype, "name", void 0);
        __decorate([
            type("string", reflectionContext)
        ], ReflectionField.prototype, "type", void 0);
        __decorate([
            type("number", reflectionContext)
        ], ReflectionField.prototype, "referencedType", void 0);
        return ReflectionField;
    }(Schema);
    var ReflectionType = /** @class */ function(_super) {
        __extends(ReflectionType, _super);
        function ReflectionType() {
            var _this = _super !== null && _super.apply(this, arguments) || this;
            _this.fields = new ArraySchema();
            return _this;
        }
        __decorate([
            type("number", reflectionContext)
        ], ReflectionType.prototype, "id", void 0);
        __decorate([
            type([
                ReflectionField
            ], reflectionContext)
        ], ReflectionType.prototype, "fields", void 0);
        return ReflectionType;
    }(Schema);
    var Reflection = /** @class */ function(_super) {
        __extends(Reflection, _super);
        function Reflection() {
            var _this = _super !== null && _super.apply(this, arguments) || this;
            _this.types = new ArraySchema();
            return _this;
        }
        Reflection.encode = function(instance) {
            var rootSchemaType = instance.constructor;
            var reflection = new Reflection();
            reflection.rootType = rootSchemaType._typeid;
            var buildType = function(currentType, schema) {
                for(var fieldName in schema){
                    var field = new ReflectionField();
                    field.name = fieldName;
                    var fieldType = void 0;
                    if (typeof schema[fieldName] === "string") fieldType = schema[fieldName];
                    else {
                        var type_1 = schema[fieldName];
                        var childTypeSchema = void 0;
                        //
                        // TODO: refactor below.
                        //
                        if (Schema.is(type_1)) {
                            fieldType = "ref";
                            childTypeSchema = schema[fieldName];
                        } else {
                            fieldType = Object.keys(type_1)[0];
                            if (typeof type_1[fieldType] === "string") fieldType += ":" + type_1[fieldType]; // array:string
                            else childTypeSchema = type_1[fieldType];
                        }
                        field.referencedType = childTypeSchema ? childTypeSchema._typeid : -1;
                    }
                    field.type = fieldType;
                    currentType.fields.push(field);
                }
                reflection.types.push(currentType);
            };
            var types = rootSchemaType._context.types;
            for(var typeid in types){
                var type_2 = new ReflectionType();
                type_2.id = Number(typeid);
                buildType(type_2, types[typeid]._definition.schema);
            }
            return reflection.encodeAll();
        };
        Reflection.decode = function(bytes, it) {
            var context = new Context();
            var reflection = new Reflection();
            reflection.decode(bytes, it);
            var schemaTypes = reflection.types.reduce(function(types, reflectionType) {
                var schema = /** @class */ function(_super) {
                    __extends(_, _super);
                    function _() {
                        return _super !== null && _super.apply(this, arguments) || this;
                    }
                    return _;
                }(Schema);
                var typeid = reflectionType.id;
                types[typeid] = schema;
                context.add(schema, typeid);
                return types;
            }, {});
            reflection.types.forEach(function(reflectionType) {
                var schemaType = schemaTypes[reflectionType.id];
                reflectionType.fields.forEach(function(field) {
                    var _a;
                    if (field.referencedType !== undefined) {
                        var fieldType = field.type;
                        var refType = schemaTypes[field.referencedType];
                        // map or array of primitive type (-1)
                        if (!refType) {
                            var typeInfo = field.type.split(":");
                            fieldType = typeInfo[0];
                            refType = typeInfo[1];
                        }
                        if (fieldType === "ref") type(refType, {
                            context: context
                        })(schemaType.prototype, field.name);
                        else type((_a = {}, _a[fieldType] = refType, _a), {
                            context: context
                        })(schemaType.prototype, field.name);
                    } else type(field.type, {
                        context: context
                    })(schemaType.prototype, field.name);
                });
            });
            var rootType = schemaTypes[reflection.rootType];
            var rootInstance = new rootType();
            /**
             * auto-initialize referenced types on root type
             * to allow registering listeners immediatelly on client-side
             */ for(var fieldName in rootType._definition.schema){
                var fieldType = rootType._definition.schema[fieldName];
                if (typeof fieldType !== "string") rootInstance[fieldName] = typeof fieldType === "function" ? new fieldType() // is a schema reference
                 : new (getType(Object.keys(fieldType)[0])).constructor(); // is a "collection"
            }
            return rootInstance;
        };
        __decorate([
            type([
                ReflectionType
            ], reflectionContext)
        ], Reflection.prototype, "types", void 0);
        __decorate([
            type("number", reflectionContext)
        ], Reflection.prototype, "rootType", void 0);
        return Reflection;
    }(Schema);
    registerType("map", {
        constructor: MapSchema
    });
    registerType("array", {
        constructor: ArraySchema
    });
    registerType("set", {
        constructor: SetSchema
    });
    registerType("collection", {
        constructor: CollectionSchema
    });
    exports1.ArraySchema = ArraySchema;
    exports1.CollectionSchema = CollectionSchema;
    exports1.Context = Context;
    exports1.MapSchema = MapSchema;
    exports1.Reflection = Reflection;
    exports1.ReflectionField = ReflectionField;
    exports1.ReflectionType = ReflectionType;
    exports1.Schema = Schema;
    exports1.SchemaDefinition = SchemaDefinition;
    exports1.SetSchema = SetSchema;
    exports1.decode = decode;
    exports1.defineTypes = defineTypes;
    exports1.deprecated = deprecated;
    exports1.dumpChanges = dumpChanges;
    exports1.encode = encode;
    exports1.filter = filter;
    exports1.filterChildren = filterChildren;
    exports1.hasFilter = hasFilter;
    exports1.registerType = registerType;
    exports1.type = type;
    Object.defineProperty(exports1, "__esModule", {
        value: true
    });
});



var $acw62 = parcelRequire("acw62");

var $ftY1i = parcelRequire("ftY1i");




var $67593c33c5144796$exports = {};

$parcel$export($67593c33c5144796$exports, "actions", () => $67593c33c5144796$export$e324594224ef24da, (v) => $67593c33c5144796$export$e324594224ef24da = v);
$parcel$export($67593c33c5144796$exports, "exit-button", () => $67593c33c5144796$export$94d9bff3e086c301, (v) => $67593c33c5144796$export$94d9bff3e086c301 = v);
$parcel$export($67593c33c5144796$exports, "player", () => $67593c33c5144796$export$615455393ee443ca, (v) => $67593c33c5144796$export$615455393ee443ca = v);
$parcel$export($67593c33c5144796$exports, "player-name", () => $67593c33c5144796$export$8c3add25137b3bbd, (v) => $67593c33c5144796$export$8c3add25137b3bbd = v);
$parcel$export($67593c33c5144796$exports, "player-ready", () => $67593c33c5144796$export$e4511a4b7f41e840, (v) => $67593c33c5144796$export$e4511a4b7f41e840 = v);
$parcel$export($67593c33c5144796$exports, "players", () => $67593c33c5144796$export$2b8dccb26e41f6c2, (v) => $67593c33c5144796$export$2b8dccb26e41f6c2 = v);
$parcel$export($67593c33c5144796$exports, "ready", () => $67593c33c5144796$export$28ee1007e174a2a6, (v) => $67593c33c5144796$export$28ee1007e174a2a6 = v);
$parcel$export($67593c33c5144796$exports, "ready-button", () => $67593c33c5144796$export$357df5234b872d8b, (v) => $67593c33c5144796$export$357df5234b872d8b = v);
$parcel$export($67593c33c5144796$exports, "room-details", () => $67593c33c5144796$export$7ed0d19455f62066, (v) => $67593c33c5144796$export$7ed0d19455f62066 = v);
$parcel$export($67593c33c5144796$exports, "room-info", () => $67593c33c5144796$export$3abba7b7cf60b30f, (v) => $67593c33c5144796$export$3abba7b7cf60b30f = v);
$parcel$export($67593c33c5144796$exports, "selected", () => $67593c33c5144796$export$d90250155de6d7e7, (v) => $67593c33c5144796$export$d90250155de6d7e7 = v);
$parcel$export($67593c33c5144796$exports, "timer", () => $67593c33c5144796$export$9dc4ecf953986f04, (v) => $67593c33c5144796$export$9dc4ecf953986f04 = v);
var $67593c33c5144796$export$e324594224ef24da;
var $67593c33c5144796$export$94d9bff3e086c301;
var $67593c33c5144796$export$615455393ee443ca;
var $67593c33c5144796$export$8c3add25137b3bbd;
var $67593c33c5144796$export$e4511a4b7f41e840;
var $67593c33c5144796$export$2b8dccb26e41f6c2;
var $67593c33c5144796$export$28ee1007e174a2a6;
var $67593c33c5144796$export$357df5234b872d8b;
var $67593c33c5144796$export$7ed0d19455f62066;
var $67593c33c5144796$export$3abba7b7cf60b30f;
var $67593c33c5144796$export$d90250155de6d7e7;
var $67593c33c5144796$export$9dc4ecf953986f04;
$67593c33c5144796$export$e324594224ef24da = `brmfia_actions`;
$67593c33c5144796$export$94d9bff3e086c301 = `brmfia_exit-button`;
$67593c33c5144796$export$615455393ee443ca = `brmfia_player`;
$67593c33c5144796$export$8c3add25137b3bbd = `brmfia_player-name`;
$67593c33c5144796$export$e4511a4b7f41e840 = `brmfia_player-ready`;
$67593c33c5144796$export$2b8dccb26e41f6c2 = `brmfia_players`;
$67593c33c5144796$export$28ee1007e174a2a6 = `brmfia_ready`;
$67593c33c5144796$export$357df5234b872d8b = `brmfia_ready-button`;
$67593c33c5144796$export$7ed0d19455f62066 = `brmfia_room-details`;
$67593c33c5144796$export$3abba7b7cf60b30f = `brmfia_room-info`;
$67593c33c5144796$export$d90250155de6d7e7 = `brmfia_selected`;
$67593c33c5144796$export$9dc4ecf953986f04 = `brmfia_timer`;


const $01857c97d917504b$var$addZeroToNumber = (number)=>number < 10 ? `0${number}` : number;
const $01857c97d917504b$var$renderer = ({ days: days, hours: hours, minutes: minutes, seconds: seconds })=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
        children: [
            $01857c97d917504b$var$addZeroToNumber(hours + days * 24),
            ":",
            $01857c97d917504b$var$addZeroToNumber(minutes),
            ":",
            $01857c97d917504b$var$addZeroToNumber(seconds)
        ]
    });
const $01857c97d917504b$export$e8121f7c2d172894 = ({ roomAvailable: roomAvailable, className: className, ...props })=>{
    const { state: { room: room, roomMetadata: roomMetadata }, dispatch: dispatch } = (0, $c25623cc446ec3c6$export$ac8576a9912be18c)();
    const [ready, setReady] = (0, $acw62.useState)(false);
    const [players, setPlayers] = (0, $acw62.useState)([]);
    const [showTimer, setShowTimer] = (0, $acw62.useState)(false);
    const [endDate, setEndDate] = (0, $acw62.useState)();
    const [host, setHost] = (0, $acw62.useState)(false);
    (0, $acw62.useEffect)(()=>{
        if (!room) return;
        room.onError((code, message)=>{
            if ((0, $b3b1baf40467424d$export$745043c7dc65e495).showModal) (0, $b3b1baf40467424d$export$745043c7dc65e495).showModal({
                title: "Error",
                text: `Message: ${message}, Code: ${code}`
            });
        });
        room.onLeave((code)=>{
            if (code === 1000) return;
            if ((0, $b3b1baf40467424d$export$745043c7dc65e495).showModal) (0, $b3b1baf40467424d$export$745043c7dc65e495).showModal({
                title: "Disconnected",
                text: "You have been disconnected from the room"
            });
            if ((0, $b3b1baf40467424d$export$745043c7dc65e495).clearGame) (0, $b3b1baf40467424d$export$745043c7dc65e495).clearGame();
            dispatch({
                type: "SET_ROOM"
            });
            dispatch({
                type: "SET_ROOM_METADATA"
            });
            dispatch({
                type: "SET_ROOM_SESSION"
            });
        });
        room.onMessage("players", async (message)=>{
            const players = new (0, $5f34832a90ff6389$exports.MapSchema)(message);
            const array = [];
            players.forEach((player)=>array.push(player));
            const host = Array.from(players.values()).find((player)=>player.host);
            if (host) setHost(host.clientId === room.sessionId);
            setPlayers(array);
        });
        room.onMessage("timer-started", async ({ endDate: endDate })=>{
            setShowTimer(true);
            setEndDate(endDate);
        });
        room.onMessage("timer-stopped", async ()=>{
            setShowTimer(false);
        });
        room.send("players");
        if ((0, $b3b1baf40467424d$export$745043c7dc65e495).refreshAccountInfo) (0, $b3b1baf40467424d$export$745043c7dc65e495).refreshAccountInfo();
        setReady(false);
    }, [
        room
    ]);
    const sendReadyMessage = ()=>{
        if (!room) return;
        room.send("ready", !ready);
        setReady(!ready);
    };
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7b02d682eb115277$exports.Fragment), {
        children: room && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
            className: (0, $9805619f03ed02ef$export$91884aa883243770)((0, (/*@__PURE__*/$parcel$interopDefault($67593c33c5144796$exports))), `room-details ${className}`),
            ...props,
            children: [
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                    className: (0, $9805619f03ed02ef$export$91884aa883243770)((0, (/*@__PURE__*/$parcel$interopDefault($67593c33c5144796$exports))), "room-info"),
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                    children: "room name"
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                    children: roomMetadata?.roomName
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                    children: "players"
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                    children: [
                                        players.length,
                                        "/",
                                        roomAvailable.maxClients
                                    ]
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                    className: (0, $9805619f03ed02ef$export$91884aa883243770)((0, (/*@__PURE__*/$parcel$interopDefault($67593c33c5144796$exports))), "players"),
                    children: players.map((player, index)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                            className: (0, $9805619f03ed02ef$export$91884aa883243770)((0, (/*@__PURE__*/$parcel$interopDefault($67593c33c5144796$exports))), "player"),
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                    className: (0, $9805619f03ed02ef$export$91884aa883243770)((0, (/*@__PURE__*/$parcel$interopDefault($67593c33c5144796$exports))), "player-name"),
                                    children: player.name
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                    className: (0, $9805619f03ed02ef$export$91884aa883243770)((0, (/*@__PURE__*/$parcel$interopDefault($67593c33c5144796$exports))), `player-ready ${player.ready ? "ready" : ""}`),
                                    children: player.ready ? "ready" : "not ready"
                                })
                            ]
                        }, `player-${index}`))
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                    className: (0, $9805619f03ed02ef$export$91884aa883243770)((0, (/*@__PURE__*/$parcel$interopDefault($67593c33c5144796$exports))), "timer"),
                    children: showTimer ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7b02d682eb115277$exports.Fragment), {
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                            children: [
                                "starting in ",
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $ftY1i.default), {
                                    date: endDate,
                                    renderer: $01857c97d917504b$var$renderer
                                })
                            ]
                        })
                    }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7b02d682eb115277$exports.Fragment), {
                        children: players.length === roomAvailable.maxClients ? "waiting for players to be ready" : "waiting for other players to join"
                    })
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                    className: (0, $9805619f03ed02ef$export$91884aa883243770)((0, (/*@__PURE__*/$parcel$interopDefault($67593c33c5144796$exports))), "actions"),
                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $6725244138e0595f$export$353f5b6fc5456de1), {
                        className: (0, $9805619f03ed02ef$export$91884aa883243770)((0, (/*@__PURE__*/$parcel$interopDefault($67593c33c5144796$exports))), `ready-button ${ready ? "gray" : ""}`),
                        onClick: sendReadyMessage,
                        children: host ? ready ? "STOP" : "START GAME" : ready ? "NOT READY" : "READY"
                    })
                })
            ]
        })
    });
};


const $56386a68ac3eb975$var$Content = ({ mode: mode, loadout: loadout, onClose: onClose, setShowCreateRoom: setShowCreateRoom })=>{
    const { state: { sessionToken: sessionToken, room: room }, dispatch: dispatch } = (0, $c25623cc446ec3c6$export$ac8576a9912be18c)();
    const [loadingRooms, setLoadingRooms] = (0, $acw62.useState)(true);
    const [roomsAvailable, setRoomsAvailable] = (0, $acw62.useState)([]);
    const [name, setName] = (0, $acw62.useState)("");
    const [connected, setConnected] = (0, $acw62.useState)(false);
    const [ping, setPing] = (0, $acw62.useState)({});
    const [joining, setJoining] = (0, $acw62.useState)(false);
    const onJoinOrReconnect = async (room, roomSession, password)=>{
        if (joining || !sessionToken) return;
        setJoining(true);
        if ((0, $b3b1baf40467424d$export$745043c7dc65e495).showLoading) (0, $b3b1baf40467424d$export$745043c7dc65e495).showLoading(true);
        try {
            const address = room.publicAddress.includes("localhost") ? `ws://${room.publicAddress}` : `wss://${room.publicAddress}`;
            await (0, $631a100c3bfebc62$export$cabce3055a2aa92d)(room, dispatch, sessionToken, address, roomSession, password, loadout);
            dispatch({
                type: "SET_LAST_SERVER_URL",
                lastServerURL: address
            });
        } catch (err) {
            (0, $ad26fe773541dcd3$export$b410431fab84fa58).error("Impossible to join the room, please try again later or contact the support team");
        } finally{
            if ((0, $b3b1baf40467424d$export$745043c7dc65e495).showLoading) (0, $b3b1baf40467424d$export$745043c7dc65e495).showLoading(false);
        }
        setJoining(false);
    };
    (0, $acw62.useEffect)(()=>{
        if (connected) return;
        setConnected(true);
        (async ()=>{
            const response = await (0, $35a528e84618b070$export$df25f2f949bacaf7)();
            if (response?.status !== 200) {
                (0, $ad26fe773541dcd3$export$b410431fab84fa58).error("Impossible to retrieve the servers info");
                return;
            }
            const servers = response.data;
            const availableServers = new Set(Object.keys(servers).map((serverName)=>serverName.split("-")[0]));
            let allRooms = [];
            const pingList = {};
            await Promise.all(Array.from(availableServers).map(async (server)=>{
                const serverURL = server === "local" ? "ws://localhost:3000" : `${server}-i0-blast.oogy.io`;
                if (!pingList[server]) {
                    pingList[server.split("-")[0]] = await (0, $35a528e84618b070$export$c0f0d0ce4283a937)(server) ?? Number.MAX_SAFE_INTEGER;
                    setPing(pingList);
                }
                try {
                    const client = new (0, $243a0fb2392e59c4$exports.Client)(server === "local" ? serverURL : `wss://${serverURL}`);
                    if (!client) {
                        (0, $ad26fe773541dcd3$export$b410431fab84fa58).error("Impossible to create a client, verify your internet connection or contact the support team");
                        return;
                    }
                    const lobby = await client.joinOrCreate("lobby");
                    lobby.onMessage("rooms", (rooms)=>{
                        allRooms.push(...rooms);
                        setRoomsAvailable([
                            ...allRooms
                        ]);
                        setLoadingRooms(false);
                    });
                    lobby.onMessage("+", ([roomId, room])=>{
                        const roomIndex = allRooms.findIndex((room)=>room.roomId === roomId);
                        if (roomIndex !== -1) allRooms[roomIndex] = room;
                        else allRooms.push(room);
                        setRoomsAvailable([
                            ...allRooms
                        ]);
                    });
                    lobby.onMessage("-", (roomId)=>{
                        allRooms = allRooms.filter((room)=>room.roomId !== roomId);
                        setRoomsAvailable([
                            ...allRooms
                        ]);
                    });
                    lobby.onLeave((code)=>{
                        if (code === 1000) return;
                        if ((0, $b3b1baf40467424d$export$745043c7dc65e495).showModal) (0, $b3b1baf40467424d$export$745043c7dc65e495).showModal({
                            title: "Disconnected",
                            text: "You have been disconnected from the lobby"
                        });
                        onClose();
                    });
                } catch (err) {
                    console.info("Problem to sync lobby with server ", serverURL);
                }
            }));
        })();
    }, [
        onClose,
        connected
    ]);
    (0, $acw62.useEffect)(()=>{
        dispatch({
            type: "SET_ROOM"
        });
        dispatch({
            type: "SET_ROOM_METADATA"
        });
    }, []);
    const nameChange = (event)=>{
        setName(event.target.value);
    };
    const selectedRoom = roomsAvailable.find((roomAvailable)=>roomAvailable.roomId === room?.id);
    const roomsOpened = roomsAvailable.filter((roomAvailable)=>roomAvailable.clients < roomAvailable.maxClients && !roomAvailable.metadata.started);
    console.log(roomsOpened);
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
        className: (0, $9805619f03ed02ef$export$91884aa883243770)((0, (/*@__PURE__*/$parcel$interopDefault($7e51696272f0b48e$exports))), "content"),
        children: room && selectedRoom ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $01857c97d917504b$export$e8121f7c2d172894), {
            roomAvailable: selectedRoom
        }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
            className: (0, $9805619f03ed02ef$export$91884aa883243770)((0, (/*@__PURE__*/$parcel$interopDefault($7e51696272f0b48e$exports))), "room-list"),
            children: [
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $863b21ed6a3b3d61$export$f5b8910cec6cf069), {
                    type: "text",
                    maxLength: 32,
                    placeholder: "Search by room's name...",
                    value: name,
                    onChange: nameChange
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                    className: (0, $9805619f03ed02ef$export$91884aa883243770)((0, (/*@__PURE__*/$parcel$interopDefault($7e51696272f0b48e$exports))), "rooms"),
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                            className: (0, $9805619f03ed02ef$export$91884aa883243770)((0, (/*@__PURE__*/$parcel$interopDefault($7e51696272f0b48e$exports))), "headers"),
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                    className: (0, $9805619f03ed02ef$export$91884aa883243770)((0, (/*@__PURE__*/$parcel$interopDefault($7e51696272f0b48e$exports))), "header-name"),
                                    children: "Name"
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                    className: (0, $9805619f03ed02ef$export$91884aa883243770)((0, (/*@__PURE__*/$parcel$interopDefault($7e51696272f0b48e$exports))), "header-players"),
                                    children: "Players"
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                    className: (0, $9805619f03ed02ef$export$91884aa883243770)((0, (/*@__PURE__*/$parcel$interopDefault($7e51696272f0b48e$exports))), "header-ping"),
                                    children: "Ping"
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                    className: (0, $9805619f03ed02ef$export$91884aa883243770)((0, (/*@__PURE__*/$parcel$interopDefault($7e51696272f0b48e$exports))), "header-empty")
                                })
                            ]
                        }),
                        roomsOpened.length > 0 && roomsOpened.filter((room)=>room.metadata.roomName.includes(name) && room.metadata.mode === mode).map((room, index)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: (0, $9805619f03ed02ef$export$91884aa883243770)((0, (/*@__PURE__*/$parcel$interopDefault($7e51696272f0b48e$exports))), "room"),
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                        className: (0, $9805619f03ed02ef$export$91884aa883243770)((0, (/*@__PURE__*/$parcel$interopDefault($7e51696272f0b48e$exports))), "room-name"),
                                        children: room.metadata.roomName
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                        className: (0, $9805619f03ed02ef$export$91884aa883243770)((0, (/*@__PURE__*/$parcel$interopDefault($7e51696272f0b48e$exports))), "room-players"),
                                        children: [
                                            room.clients,
                                            "/",
                                            room.maxClients
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                        className: (0, $9805619f03ed02ef$export$91884aa883243770)((0, (/*@__PURE__*/$parcel$interopDefault($7e51696272f0b48e$exports))), "room-ping"),
                                        children: ping[room.publicAddress.split("-")[0]] ?? "-"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                        className: (0, $9805619f03ed02ef$export$91884aa883243770)((0, (/*@__PURE__*/$parcel$interopDefault($7e51696272f0b48e$exports))), "room-button"),
                                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $6725244138e0595f$export$353f5b6fc5456de1), {
                                            className: "xsmall",
                                            disabled: room.clients === room.maxClients || room.metadata.started || joining,
                                            onClick: ()=>onJoinOrReconnect(room),
                                            children: "join"
                                        })
                                    })
                                ]
                            }, `room-${index}`)),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                            className: (0, $9805619f03ed02ef$export$91884aa883243770)((0, (/*@__PURE__*/$parcel$interopDefault($7e51696272f0b48e$exports))), "status"),
                            children: loadingRooms ? "Loading rooms..." : roomsOpened.length === 0 && "No rooms available, create one!"
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                    className: (0, $9805619f03ed02ef$export$91884aa883243770)((0, (/*@__PURE__*/$parcel$interopDefault($7e51696272f0b48e$exports))), "actions"),
                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $6725244138e0595f$export$e1c22a2ee2645e36), {
                        icon: "circle-plus",
                        className: (0, $9805619f03ed02ef$export$91884aa883243770)((0, (/*@__PURE__*/$parcel$interopDefault($7e51696272f0b48e$exports))), "create-room-button"),
                        onClick: ()=>setShowCreateRoom(true),
                        children: "Create a room"
                    })
                })
            ]
        })
    });
};
const $56386a68ac3eb975$var$Title = ({ onClose: onClose })=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: (0, $9805619f03ed02ef$export$91884aa883243770)((0, (/*@__PURE__*/$parcel$interopDefault($7e51696272f0b48e$exports))), "title"),
        children: [
            "Rooms",
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                src: `${(0, $0426e2dd5e0de94d$export$24af3971dd36b33f)}/ui/cross.png`,
                alt: "cross",
                onClick: onClose
            })
        ]
    });
const $56386a68ac3eb975$export$7ddda366b148a43a = ({ className: className, onClose: onCloseRaw, mode: mode, loadout: loadout, ...props })=>{
    const { state: { sessionToken: sessionToken, room: room }, dispatch: dispatch } = (0, $c25623cc446ec3c6$export$ac8576a9912be18c)();
    const [showCreateRoom, setShowCreateRoom] = (0, $acw62.useState)(false);
    const onCreateClassicRoom = async (roomInfo, password)=>{
        if (!sessionToken) return;
        await (0, $631a100c3bfebc62$export$fe853b5841b12ace)({
            ...roomInfo,
            mode: mode
        }, sessionToken, dispatch, password, undefined, loadout);
        setShowCreateRoom(false);
    };
    const onClose = async ()=>{
        if (room) {
            if ((0, $b3b1baf40467424d$export$745043c7dc65e495).showConfirm) (0, $b3b1baf40467424d$export$745043c7dc65e495).showConfirm({
                title: "Exit room?",
                text: "Do you really want to exit the room?",
                async onAccept () {
                    await room.leave(true);
                    dispatch({
                        type: "SET_ROOM"
                    });
                    dispatch({
                        type: "SET_ROOM_METADATA"
                    });
                    dispatch({
                        type: "SET_ROOM_SESSION"
                    });
                    onCloseRaw();
                },
                acceptText: "Exit",
                refuseText: "Stay"
            });
        } else onCloseRaw();
    };
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $207d23274fe2be11$export$6e63c1000ecf9db8), {
                className: (0, $9805619f03ed02ef$export$91884aa883243770)((0, (/*@__PURE__*/$parcel$interopDefault($7e51696272f0b48e$exports))), `lobby ${className}`),
                title: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($56386a68ac3eb975$var$Title, {
                    onClose: onClose
                }),
                content: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($56386a68ac3eb975$var$Content, {
                    onClose: onClose,
                    mode: mode,
                    loadout: loadout,
                    setShowCreateRoom: setShowCreateRoom
                }),
                ...props
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $cffed08bb11701f2$export$843bb69f42d9dd52), {
                show: showCreateRoom,
                onClose: ()=>setShowCreateRoom(false),
                onCreate: onCreateClassicRoom
            })
        ]
    });
};


const $0b78b7046d0dbf1e$var$addZeroToNumber = (number)=>number < 10 ? `0${number}` : number;
const $0b78b7046d0dbf1e$var$renderer = ({ days: days, hours: hours, minutes: minutes })=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
        children: [
            $0b78b7046d0dbf1e$var$addZeroToNumber(days),
            "D ",
            $0b78b7046d0dbf1e$var$addZeroToNumber(hours),
            "H ",
            $0b78b7046d0dbf1e$var$addZeroToNumber(minutes),
            "M"
        ]
    });
const $0b78b7046d0dbf1e$export$1fafd7585827ebd1 = ({ className: className, onPointerOver: onPointerOver, onPointerUp: onPointerUp, ...props })=>{
    const { state: { accountInfo: accountInfo, roomSession: roomSession, sessionToken: sessionToken, lastServerURL: lastServerURL }, dispatch: dispatch } = (0, $c25623cc446ec3c6$export$ac8576a9912be18c)();
    const [showGameMode, setShowGameMode] = (0, $acw62.useState)(false);
    const [showLobby, setShowLobby] = (0, $acw62.useState)(false);
    const [showWeeklyPrizeMenu, setShowWeeklyPrizeMenu] = (0, $acw62.useState)(false);
    const [initialized, setInitialized] = (0, $acw62.useState)(false);
    const [spine, setSpine] = (0, $acw62.useState)();
    const battleNowRef = (0, $acw62.useRef)(null);
    const [animationEnded, setAnimationEnded] = (0, $acw62.useState)(false);
    const [showDailyRewards, setShowDailyRewards] = (0, $acw62.useState)(false);
    const [showUnlockedDailyReward, setShowUnlockedDailyReward] = (0, $acw62.useState)(false);
    const [dailyRewards, setDailyRewards] = (0, $acw62.useState)(0);
    const [gameMode, setGameMode] = (0, $acw62.useState)();
    const [loadout, setLoadout] = (0, $acw62.useState)();
    const onPointerOverPrepared = (event)=>{
        if (onPointerOver) onPointerOver(event);
        (0, $0c69c9c512bb7a3f$export$2b20361d967f09eb).play();
    };
    const onPointerUpPrepared = (event)=>{
        if (onPointerUp) onPointerUp(event);
        (0, $0c69c9c512bb7a3f$export$4db563113ca18f41).play();
        setShowGameMode(true);
    };
    (0, $acw62.useEffect)(()=>{
        (0, $0c69c9c512bb7a3f$export$31feb4e10852ccbd)();
        (0, $e16030e48e62d804$export$ce8e199cc2716d76)(0, "battle_player-container").then(setSpine);
        (0, $e16030e48e62d804$export$3f9fa6d3e8ec4bff)(0, "battle_monster-container");
    }, []);
    (0, $acw62.useEffect)(()=>{
        if (!accountInfo) return;
        if (window.localStorage.getItem("daily-rewards-score") && Number(window.localStorage.getItem("daily-rewards-score")) < accountInfo.dailyRewards.score) (async ()=>{
            const data = await (0, $294c300caaab742a$export$9a11c4d521627ff7)();
            setDailyRewards(data.rewards[Math.min(data.rewards.length - 1, accountInfo.dailyRewards.score)]);
            setShowUnlockedDailyReward(true);
        })();
        window.localStorage.setItem("daily-rewards-score", String(accountInfo.dailyRewards.score));
    }, [
        accountInfo
    ]);
    (0, $acw62.useEffect)(()=>{
        if (!spine || !accountInfo) return;
        (0, $e16030e48e62d804$export$3bd44b7bc70cd0eb)(spine, {
            FUR: accountInfo.character.cosmetics.FUR.equiped,
            EYES: accountInfo.character.cosmetics.EYES.equiped,
            HEAD: accountInfo.character.cosmetics.HEAD.equiped,
            TOP: accountInfo.character.cosmetics.TOP.equiped,
            MOUTH: accountInfo.character.cosmetics.MOUTH.equiped
        });
    }, [
        accountInfo,
        spine
    ]);
    (0, $acw62.useEffect)(()=>{
        setInitialized(true);
        if (!initialized && roomSession && sessionToken && lastServerURL && (0, $b3b1baf40467424d$export$745043c7dc65e495).showConfirm) (0, $b3b1baf40467424d$export$745043c7dc65e495).showConfirm({
            title: "Reconnect to the game",
            text: "We detected a running game. Do you want to reconnect to it?",
            onAccept: ()=>(0, $631a100c3bfebc62$export$cabce3055a2aa92d)(roomSession.roomAvailable, dispatch, sessionToken, lastServerURL, roomSession, lastServerURL),
            onRefuse: ()=>dispatch({
                    type: "SET_ROOM_SESSION"
                }),
            refuseText: "leave"
        });
    }, [
        roomSession,
        sessionToken,
        initialized
    ]);
    (0, $acw62.useEffect)(()=>{
        if (battleNowRef.current) battleNowRef.current.onanimationend = ()=>{
            setAnimationEnded(true);
        };
    }, [
        battleNowRef
    ]);
    const openPublic = ()=>{
        dispatch({
            type: "SET_NAVIGATION",
            tab: "weekly-prize"
        });
    };
    const openHolder = ()=>{
        dispatch({
            type: "SET_NAVIGATION",
            tab: "holder-weekly-prize"
        });
    };
    const endOfWeeklyPrize = (0, $e97e44cd4550f081$export$a20373bb0df6efdd)();
    // endOfWeeklyPrize = addMinutes(endOfWeeklyPrize, endOfWeeklyPrize.getTimezoneOffset())
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: (0, $9805619f03ed02ef$export$91884aa883243770)((0, (/*@__PURE__*/$parcel$interopDefault($b1c12edd46ef2e0d$exports))), `battle-tab reveal-element ${className}`),
        ...props,
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $0a84c922bdcca86d$export$7cd7a93136e7148a), {
                show: showGameMode,
                onClose: ()=>setShowGameMode(false),
                openLobby: (mode, loadout)=>{
                    setShowGameMode(false);
                    setGameMode(mode);
                    setLoadout(loadout);
                    setShowLobby(true);
                }
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $56386a68ac3eb975$export$7ddda366b148a43a), {
                show: showLobby,
                onClose: ()=>setShowLobby(false),
                mode: gameMode ?? "score",
                loadout: loadout
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $c7c68647d2f2d9c7$export$eed488b0019288d), {
                show: showDailyRewards,
                onClose: ()=>setShowDailyRewards(false)
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $4dcf018e9a053e67$export$ffcb39df7ef525c5), {
                show: showWeeklyPrizeMenu,
                onClose: ()=>setShowWeeklyPrizeMenu(false),
                openPublic: openPublic,
                openHolder: openHolder
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $207d23274fe2be11$export$a118d25f3bd40bb8), {
                show: showUnlockedDailyReward,
                onClickBackground: ()=>setShowUnlockedDailyReward(false),
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                    className: (0, $9805619f03ed02ef$export$91884aa883243770)((0, (/*@__PURE__*/$parcel$interopDefault($b1c12edd46ef2e0d$exports))), "daily-rewards-modal"),
                    style: {
                        backgroundImage: `url('${(0, $0426e2dd5e0de94d$export$24af3971dd36b33f)}/ui/daily-rewards-modal.png')`
                    },
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                            className: (0, $9805619f03ed02ef$export$91884aa883243770)((0, (/*@__PURE__*/$parcel$interopDefault($b1c12edd46ef2e0d$exports))), "icon"),
                            src: `${(0, $0426e2dd5e0de94d$export$24af3971dd36b33f)}/ui/daily-rewards-icon.png`,
                            alt: "daily-rewards-icon"
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                            className: (0, $9805619f03ed02ef$export$91884aa883243770)((0, (/*@__PURE__*/$parcel$interopDefault($b1c12edd46ef2e0d$exports))), "title"),
                            children: "DAILY REWARD EARNED"
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                            className: (0, $9805619f03ed02ef$export$91884aa883243770)((0, (/*@__PURE__*/$parcel$interopDefault($b1c12edd46ef2e0d$exports))), "description"),
                            children: [
                                (accountInfo?.dailyRewards.score ?? 0) + 1,
                                " days in a row!"
                            ]
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                            className: (0, $9805619f03ed02ef$export$91884aa883243770)((0, (/*@__PURE__*/$parcel$interopDefault($b1c12edd46ef2e0d$exports))), "rewards"),
                            children: [
                                "+",
                                dailyRewards,
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                                    src: `${(0, $0426e2dd5e0de94d$export$24af3971dd36b33f)}/ui/gem.png`,
                                    alt: "gem"
                                })
                            ]
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: (0, $9805619f03ed02ef$export$91884aa883243770)((0, (/*@__PURE__*/$parcel$interopDefault($b1c12edd46ef2e0d$exports))), "player"),
                id: "battle_player-container"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: (0, $9805619f03ed02ef$export$91884aa883243770)((0, (/*@__PURE__*/$parcel$interopDefault($b1c12edd46ef2e0d$exports))), "monster"),
                id: "battle_monster-container"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: (0, $9805619f03ed02ef$export$91884aa883243770)((0, (/*@__PURE__*/$parcel$interopDefault($b1c12edd46ef2e0d$exports))), "top-line"),
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: (0, $9805619f03ed02ef$export$91884aa883243770)((0, (/*@__PURE__*/$parcel$interopDefault($b1c12edd46ef2e0d$exports))), "tile"),
                        style: {
                            backgroundImage: `url('${(0, $0426e2dd5e0de94d$export$24af3971dd36b33f)}/ui/daily-rewards-bg.png')`
                        },
                        onPointerUp: ()=>setShowDailyRewards(true),
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                className: (0, $9805619f03ed02ef$export$91884aa883243770)((0, (/*@__PURE__*/$parcel$interopDefault($b1c12edd46ef2e0d$exports))), "icon"),
                                style: {
                                    backgroundImage: `url('${(0, $0426e2dd5e0de94d$export$24af3971dd36b33f)}/ui/daily-rewards-icon.png')`
                                }
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: (0, $9805619f03ed02ef$export$91884aa883243770)((0, (/*@__PURE__*/$parcel$interopDefault($b1c12edd46ef2e0d$exports))), "content"),
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                        className: (0, $9805619f03ed02ef$export$91884aa883243770)((0, (/*@__PURE__*/$parcel$interopDefault($b1c12edd46ef2e0d$exports))), "title"),
                                        children: "DAILY REWARDS"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                        className: (0, $9805619f03ed02ef$export$91884aa883243770)((0, (/*@__PURE__*/$parcel$interopDefault($b1c12edd46ef2e0d$exports))), "description"),
                                        children: [
                                            "earn bonus ",
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                                                src: `${(0, $0426e2dd5e0de94d$export$24af3971dd36b33f)}/ui/gem.png`,
                                                alt: "gem"
                                            })
                                        ]
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: (0, $9805619f03ed02ef$export$91884aa883243770)((0, (/*@__PURE__*/$parcel$interopDefault($b1c12edd46ef2e0d$exports))), "tile"),
                        style: {
                            backgroundImage: `url('${(0, $0426e2dd5e0de94d$export$24af3971dd36b33f)}/ui/weekly-price-bg.png')`
                        },
                        onPointerUp: ()=>setShowWeeklyPrizeMenu(true),
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                className: (0, $9805619f03ed02ef$export$91884aa883243770)((0, (/*@__PURE__*/$parcel$interopDefault($b1c12edd46ef2e0d$exports))), "icon"),
                                style: {
                                    backgroundImage: `url('${(0, $0426e2dd5e0de94d$export$24af3971dd36b33f)}/ui/weekly-prize.png')`
                                }
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: (0, $9805619f03ed02ef$export$91884aa883243770)((0, (/*@__PURE__*/$parcel$interopDefault($b1c12edd46ef2e0d$exports))), "content"),
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                        className: (0, $9805619f03ed02ef$export$91884aa883243770)((0, (/*@__PURE__*/$parcel$interopDefault($b1c12edd46ef2e0d$exports))), "title"),
                                        children: "WEEKLY PRIZES"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                        className: (0, $9805619f03ed02ef$export$91884aa883243770)((0, (/*@__PURE__*/$parcel$interopDefault($b1c12edd46ef2e0d$exports))), "description"),
                                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $ftY1i.default), {
                                            date: endOfWeeklyPrize,
                                            renderer: $0b78b7046d0dbf1e$var$renderer
                                        })
                                    })
                                ]
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $b66fc98e4eed8243$export$ca8dc42bbb6f2e22), {
                className: (0, $9805619f03ed02ef$export$91884aa883243770)((0, (/*@__PURE__*/$parcel$interopDefault($b1c12edd46ef2e0d$exports))), "chests")
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                ref: battleNowRef,
                className: (0, $9805619f03ed02ef$export$91884aa883243770)((0, (/*@__PURE__*/$parcel$interopDefault($b1c12edd46ef2e0d$exports))), `battle ${animationEnded ? "pulse" : "bounce"}`),
                src: `${(0, $0426e2dd5e0de94d$export$24af3971dd36b33f)}/ui/battle-now.png`,
                alt: "battle-now",
                onPointerOver: onPointerOverPrepared,
                onPointerUp: onPointerUpPrepared
            })
        ]
    });
};




var $acw62 = parcelRequire("acw62");






var $bb489d0c93d49add$exports = {};

$parcel$export($bb489d0c93d49add$exports, "character", () => $bb489d0c93d49add$export$c0306caf338ac095, (v) => $bb489d0c93d49add$export$c0306caf338ac095 = v);
$parcel$export($bb489d0c93d49add$exports, "character-tab", () => $bb489d0c93d49add$export$7d67a756dcf82a1f, (v) => $bb489d0c93d49add$export$7d67a756dcf82a1f = v);
$parcel$export($bb489d0c93d49add$exports, "container", () => $bb489d0c93d49add$export$34e0f9847d4c02dd, (v) => $bb489d0c93d49add$export$34e0f9847d4c02dd = v);
$parcel$export($bb489d0c93d49add$exports, "player", () => $bb489d0c93d49add$export$615455393ee443ca, (v) => $bb489d0c93d49add$export$615455393ee443ca = v);
$parcel$export($bb489d0c93d49add$exports, "tab", () => $bb489d0c93d49add$export$62d58b1c91e8e902, (v) => $bb489d0c93d49add$export$62d58b1c91e8e902 = v);
$parcel$export($bb489d0c93d49add$exports, "tabs", () => $bb489d0c93d49add$export$39f5674517ec0000, (v) => $bb489d0c93d49add$export$39f5674517ec0000 = v);
$parcel$export($bb489d0c93d49add$exports, "title", () => $bb489d0c93d49add$export$fb184b623420d9be, (v) => $bb489d0c93d49add$export$fb184b623420d9be = v);
var $bb489d0c93d49add$export$c0306caf338ac095;
var $bb489d0c93d49add$export$7d67a756dcf82a1f;
var $bb489d0c93d49add$export$34e0f9847d4c02dd;
var $bb489d0c93d49add$export$615455393ee443ca;
var $bb489d0c93d49add$export$62d58b1c91e8e902;
var $bb489d0c93d49add$export$39f5674517ec0000;
var $bb489d0c93d49add$export$fb184b623420d9be;
$bb489d0c93d49add$export$c0306caf338ac095 = `_1QQwwG_character`;
$bb489d0c93d49add$export$7d67a756dcf82a1f = `_1QQwwG_character-tab`;
$bb489d0c93d49add$export$34e0f9847d4c02dd = `_1QQwwG_container`;
$bb489d0c93d49add$export$615455393ee443ca = `_1QQwwG_player`;
$bb489d0c93d49add$export$62d58b1c91e8e902 = `_1QQwwG_tab`;
$bb489d0c93d49add$export$39f5674517ec0000 = `_1QQwwG_tabs`;
$bb489d0c93d49add$export$fb184b623420d9be = `_1QQwwG_title`;






var $acw62 = parcelRequire("acw62");







var $201cf689de7b4198$exports = {};

$parcel$export($201cf689de7b4198$exports, "bg", () => $201cf689de7b4198$export$136fd86de524d3c2, (v) => $201cf689de7b4198$export$136fd86de524d3c2 = v);
$parcel$export($201cf689de7b4198$exports, "cosmetics-tab", () => $201cf689de7b4198$export$2c18395c98366dff, (v) => $201cf689de7b4198$export$2c18395c98366dff = v);
$parcel$export($201cf689de7b4198$exports, "image", () => $201cf689de7b4198$export$5c452ff88e35e47d, (v) => $201cf689de7b4198$export$5c452ff88e35e47d = v);
$parcel$export($201cf689de7b4198$exports, "info", () => $201cf689de7b4198$export$a80b3bd66acc52ff, (v) => $201cf689de7b4198$export$a80b3bd66acc52ff = v);
$parcel$export($201cf689de7b4198$exports, "list", () => $201cf689de7b4198$export$8837f4fc672e936d, (v) => $201cf689de7b4198$export$8837f4fc672e936d = v);
$parcel$export($201cf689de7b4198$exports, "multi-button", () => $201cf689de7b4198$export$1fbfc406395df0a, (v) => $201cf689de7b4198$export$1fbfc406395df0a = v);
$parcel$export($201cf689de7b4198$exports, "selected", () => $201cf689de7b4198$export$d90250155de6d7e7, (v) => $201cf689de7b4198$export$d90250155de6d7e7 = v);
$parcel$export($201cf689de7b4198$exports, "text", () => $201cf689de7b4198$export$6f093cfa640b7166, (v) => $201cf689de7b4198$export$6f093cfa640b7166 = v);
$parcel$export($201cf689de7b4198$exports, "tile", () => $201cf689de7b4198$export$3c17558da18e4d75, (v) => $201cf689de7b4198$export$3c17558da18e4d75 = v);
var $201cf689de7b4198$export$136fd86de524d3c2;
var $201cf689de7b4198$export$2c18395c98366dff;
var $201cf689de7b4198$export$5c452ff88e35e47d;
var $201cf689de7b4198$export$a80b3bd66acc52ff;
var $201cf689de7b4198$export$8837f4fc672e936d;
var $201cf689de7b4198$export$1fbfc406395df0a;
var $201cf689de7b4198$export$d90250155de6d7e7;
var $201cf689de7b4198$export$6f093cfa640b7166;
var $201cf689de7b4198$export$3c17558da18e4d75;
$201cf689de7b4198$export$136fd86de524d3c2 = `_9fmJSG_bg`;
$201cf689de7b4198$export$2c18395c98366dff = `_9fmJSG_cosmetics-tab`;
$201cf689de7b4198$export$5c452ff88e35e47d = `_9fmJSG_image`;
$201cf689de7b4198$export$a80b3bd66acc52ff = `_9fmJSG_info`;
$201cf689de7b4198$export$8837f4fc672e936d = `_9fmJSG_list`;
$201cf689de7b4198$export$1fbfc406395df0a = `_9fmJSG_multi-button`;
$201cf689de7b4198$export$d90250155de6d7e7 = `_9fmJSG_selected`;
$201cf689de7b4198$export$6f093cfa640b7166 = `_9fmJSG_text`;
$201cf689de7b4198$export$3c17558da18e4d75 = `_9fmJSG_tile`;


const $ea5def17c57022f1$var$COLOR_CACHE = {};
const $ea5def17c57022f1$export$6abe2cec88142692 = ({ className: className, spinePlayer: spinePlayer, ...props })=>{
    const { state: { accountInfo: accountInfo }, dispatch: dispatch } = (0, $c25623cc446ec3c6$export$ac8576a9912be18c)();
    const [buying, setBuying] = (0, $acw62.useState)(false);
    const [equipying, setEquipying] = (0, $acw62.useState)(false);
    const [data, setData] = (0, $acw62.useState)();
    const [selectedName, setSelectedName] = (0, $acw62.useState)();
    const [type, setType] = (0, $acw62.useState)("FUR");
    (0, $acw62.useEffect)(()=>{
        (0, $cf016c70669323e2$export$a993cc2444c7b2a)().then(setData);
    }, []);
    (0, $acw62.useEffect)(()=>{
        setSelectedName(undefined);
        if (spinePlayer) (0, $e16030e48e62d804$export$3bd44b7bc70cd0eb)(spinePlayer, {
            FUR: accountInfo?.character.cosmetics.FUR.equiped,
            EYES: accountInfo?.character.cosmetics.EYES.equiped,
            HEAD: accountInfo?.character.cosmetics.HEAD.equiped,
            TOP: accountInfo?.character.cosmetics.TOP.equiped,
            MOUTH: accountInfo?.character.cosmetics.MOUTH.equiped
        });
    }, [
        type
    ]);
    const onTileClick = (entry)=>{
        setSelectedName(entry.name);
        if (spinePlayer) {
            const skin = {
                FUR: accountInfo?.character.cosmetics.FUR.equiped,
                EYES: accountInfo?.character.cosmetics.EYES.equiped,
                HEAD: accountInfo?.character.cosmetics.HEAD.equiped,
                TOP: accountInfo?.character.cosmetics.TOP.equiped,
                MOUTH: accountInfo?.character.cosmetics.MOUTH.equiped
            };
            skin[type] = entry.name;
            (0, $e16030e48e62d804$export$3bd44b7bc70cd0eb)(spinePlayer, skin);
        }
    };
    const onBuy = (entry)=>{
        if ((0, $b3b1baf40467424d$export$745043c7dc65e495).showConfirm) (0, $b3b1baf40467424d$export$745043c7dc65e495).showConfirm({
            title: "Buy cosmetic",
            text: `Do you really want to buy the cosmetic for ${entry.priceToUnlock.gems} gems?`,
            acceptText: "Yes",
            refuseText: "No",
            async onAccept () {
                setBuying(true);
                const result = await (0, $35a528e84618b070$export$ad4eacef1e38433)(type, entry.name);
                if (result?.data && (0, $b3b1baf40467424d$export$745043c7dc65e495).refreshAccountInfo) (0, $b3b1baf40467424d$export$745043c7dc65e495).refreshAccountInfo();
                setBuying(false);
            }
        });
    };
    const onEquip = async (entry)=>{
        setEquipying(true);
        const result = await (0, $35a528e84618b070$export$571699c739686853)(type, entry?.name);
        if (result?.data) {
            const copy = JSON.parse(JSON.stringify(accountInfo));
            copy.character.cosmetics[type].equiped = entry?.name;
            dispatch({
                type: "SET_ACCOUNT_INFO",
                accountInfo: copy
            });
        }
        //setSelectedName(undefined)
        setEquipying(false);
    };
    const colorToFilter = (color)=>{
        if (!$ea5def17c57022f1$var$COLOR_CACHE[color]) $ea5def17c57022f1$var$COLOR_CACHE[color] = (0, (/*@__PURE__*/$parcel$interopDefault($46d5a9f991de27f2$exports))).hexToFilter(color).color ?? "none";
        return $ea5def17c57022f1$var$COLOR_CACHE[color];
    };
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: (0, $9805619f03ed02ef$export$91884aa883243770)((0, (/*@__PURE__*/$parcel$interopDefault($201cf689de7b4198$exports))), `cosmetics-tab reveal-element ${className}`),
        ...props,
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: (0, $9805619f03ed02ef$export$91884aa883243770)((0, (/*@__PURE__*/$parcel$interopDefault($201cf689de7b4198$exports))), "multi-button"),
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: (0, $9805619f03ed02ef$export$91884aa883243770)((0, (/*@__PURE__*/$parcel$interopDefault($201cf689de7b4198$exports))), `${type === "FUR" && "selected"}`),
                        onClick: ()=>setType("FUR"),
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                className: (0, $9805619f03ed02ef$export$91884aa883243770)((0, (/*@__PURE__*/$parcel$interopDefault($201cf689de7b4198$exports))), "bg")
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                className: (0, $9805619f03ed02ef$export$91884aa883243770)((0, (/*@__PURE__*/$parcel$interopDefault($201cf689de7b4198$exports))), "text"),
                                children: "FUR"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: (0, $9805619f03ed02ef$export$91884aa883243770)((0, (/*@__PURE__*/$parcel$interopDefault($201cf689de7b4198$exports))), `${type === "TOP" && "selected"}`),
                        onClick: ()=>setType("TOP"),
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                className: (0, $9805619f03ed02ef$export$91884aa883243770)((0, (/*@__PURE__*/$parcel$interopDefault($201cf689de7b4198$exports))), "bg")
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                className: (0, $9805619f03ed02ef$export$91884aa883243770)((0, (/*@__PURE__*/$parcel$interopDefault($201cf689de7b4198$exports))), "text"),
                                children: "TOP"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: (0, $9805619f03ed02ef$export$91884aa883243770)((0, (/*@__PURE__*/$parcel$interopDefault($201cf689de7b4198$exports))), `${type === "HEAD" && "selected"}`),
                        onClick: ()=>setType("HEAD"),
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                className: (0, $9805619f03ed02ef$export$91884aa883243770)((0, (/*@__PURE__*/$parcel$interopDefault($201cf689de7b4198$exports))), "bg")
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                className: (0, $9805619f03ed02ef$export$91884aa883243770)((0, (/*@__PURE__*/$parcel$interopDefault($201cf689de7b4198$exports))), "text"),
                                children: "HEAD"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: (0, $9805619f03ed02ef$export$91884aa883243770)((0, (/*@__PURE__*/$parcel$interopDefault($201cf689de7b4198$exports))), `${type === "EYES" && "selected"}`),
                        onClick: ()=>setType("EYES"),
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                className: (0, $9805619f03ed02ef$export$91884aa883243770)((0, (/*@__PURE__*/$parcel$interopDefault($201cf689de7b4198$exports))), "bg")
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                className: (0, $9805619f03ed02ef$export$91884aa883243770)((0, (/*@__PURE__*/$parcel$interopDefault($201cf689de7b4198$exports))), "text"),
                                children: "EYES"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: (0, $9805619f03ed02ef$export$91884aa883243770)((0, (/*@__PURE__*/$parcel$interopDefault($201cf689de7b4198$exports))), `${type === "MOUTH" && "selected"}`),
                        onClick: ()=>setType("MOUTH"),
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                className: (0, $9805619f03ed02ef$export$91884aa883243770)((0, (/*@__PURE__*/$parcel$interopDefault($201cf689de7b4198$exports))), "bg")
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                className: (0, $9805619f03ed02ef$export$91884aa883243770)((0, (/*@__PURE__*/$parcel$interopDefault($201cf689de7b4198$exports))), "text"),
                                children: "MOUTH"
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: (0, $9805619f03ed02ef$export$91884aa883243770)((0, (/*@__PURE__*/$parcel$interopDefault($201cf689de7b4198$exports))), "list"),
                children: data?.[type].sort((a, b)=>a.priceToUnlock.gems - b.priceToUnlock.gems).filter((entry)=>!entry.availableFrom || accountInfo?.character.cosmetics[type].unlocked.includes(entry.name) || Date.now() >= entry.availableFrom && Date.now() <= (entry.availableTo ?? 0)).map((entry)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: (0, $9805619f03ed02ef$export$91884aa883243770)((0, (/*@__PURE__*/$parcel$interopDefault($201cf689de7b4198$exports))), "tile reveal-element"),
                        onClick: ()=>onTileClick(entry),
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                className: (0, $9805619f03ed02ef$export$91884aa883243770)((0, (/*@__PURE__*/$parcel$interopDefault($201cf689de7b4198$exports))), "bg"),
                                style: {
                                    filter: `brightness(0) saturate(100%) ${colorToFilter(entry.backgroundColor)}` ?? "none"
                                }
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                className: (0, $9805619f03ed02ef$export$91884aa883243770)((0, (/*@__PURE__*/$parcel$interopDefault($201cf689de7b4198$exports))), "image"),
                                style: {
                                    backgroundImage: `url('${(0, $0426e2dd5e0de94d$export$24af3971dd36b33f)}/ui/cosmetics/${type.toLowerCase()}/${entry.name.toLowerCase()}.png')`
                                }
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                className: (0, $9805619f03ed02ef$export$91884aa883243770)((0, (/*@__PURE__*/$parcel$interopDefault($201cf689de7b4198$exports))), "info"),
                                children: !accountInfo?.character.cosmetics[type].unlocked.includes(entry.name) ? selectedName === entry.name ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $6725244138e0595f$export$353f5b6fc5456de1), {
                                    className: "xxsmall blue",
                                    onClick: ()=>onBuy(entry),
                                    loading: buying,
                                    children: "buy"
                                }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                                            src: `${(0, $0426e2dd5e0de94d$export$24af3971dd36b33f)}/ui/gem.png`,
                                            alt: "gem"
                                        }),
                                        entry.priceToUnlock.gems
                                    ]
                                }) : accountInfo?.character.cosmetics[type].equiped === entry.name ? type === "FUR" ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                                    src: `${(0, $0426e2dd5e0de94d$export$24af3971dd36b33f)}/ui/check.png`,
                                    alt: "check"
                                }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $6725244138e0595f$export$353f5b6fc5456de1), {
                                    className: "xxsmall",
                                    onClick: ()=>onEquip(),
                                    loading: equipying,
                                    children: "unequip"
                                }) : selectedName === entry.name && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $6725244138e0595f$export$353f5b6fc5456de1), {
                                    className: "xxsmall",
                                    onClick: ()=>onEquip(entry),
                                    loading: equipying,
                                    children: "equip"
                                })
                            })
                        ]
                    }, entry.name))
            })
        ]
    });
};





var $acw62 = parcelRequire("acw62");




var $5bd3bef98b39f73a$exports = {};

$parcel$export($5bd3bef98b39f73a$exports, "bg", () => $5bd3bef98b39f73a$export$136fd86de524d3c2, (v) => $5bd3bef98b39f73a$export$136fd86de524d3c2 = v);
$parcel$export($5bd3bef98b39f73a$exports, "container", () => $5bd3bef98b39f73a$export$34e0f9847d4c02dd, (v) => $5bd3bef98b39f73a$export$34e0f9847d4c02dd = v);
$parcel$export($5bd3bef98b39f73a$exports, "icon", () => $5bd3bef98b39f73a$export$1ca1ec8b29a4ce27, (v) => $5bd3bef98b39f73a$export$1ca1ec8b29a4ce27 = v);
$parcel$export($5bd3bef98b39f73a$exports, "info", () => $5bd3bef98b39f73a$export$a80b3bd66acc52ff, (v) => $5bd3bef98b39f73a$export$a80b3bd66acc52ff = v);
$parcel$export($5bd3bef98b39f73a$exports, "level", () => $5bd3bef98b39f73a$export$617f828bbf323ba2, (v) => $5bd3bef98b39f73a$export$617f828bbf323ba2 = v);
$parcel$export($5bd3bef98b39f73a$exports, "name", () => $5bd3bef98b39f73a$export$a8ff84c12d48cfa6, (v) => $5bd3bef98b39f73a$export$a8ff84c12d48cfa6 = v);
$parcel$export($5bd3bef98b39f73a$exports, "statistics-tab", () => $5bd3bef98b39f73a$export$95c98301756edbec, (v) => $5bd3bef98b39f73a$export$95c98301756edbec = v);
$parcel$export($5bd3bef98b39f73a$exports, "tile", () => $5bd3bef98b39f73a$export$3c17558da18e4d75, (v) => $5bd3bef98b39f73a$export$3c17558da18e4d75 = v);
$parcel$export($5bd3bef98b39f73a$exports, "value", () => $5bd3bef98b39f73a$export$2ab9a8f9f1186f14, (v) => $5bd3bef98b39f73a$export$2ab9a8f9f1186f14 = v);
var $5bd3bef98b39f73a$export$136fd86de524d3c2;
var $5bd3bef98b39f73a$export$34e0f9847d4c02dd;
var $5bd3bef98b39f73a$export$1ca1ec8b29a4ce27;
var $5bd3bef98b39f73a$export$a80b3bd66acc52ff;
var $5bd3bef98b39f73a$export$617f828bbf323ba2;
var $5bd3bef98b39f73a$export$a8ff84c12d48cfa6;
var $5bd3bef98b39f73a$export$95c98301756edbec;
var $5bd3bef98b39f73a$export$3c17558da18e4d75;
var $5bd3bef98b39f73a$export$2ab9a8f9f1186f14;
$5bd3bef98b39f73a$export$136fd86de524d3c2 = `_8dyASa_bg`;
$5bd3bef98b39f73a$export$34e0f9847d4c02dd = `_8dyASa_container`;
$5bd3bef98b39f73a$export$1ca1ec8b29a4ce27 = `_8dyASa_icon`;
$5bd3bef98b39f73a$export$a80b3bd66acc52ff = `_8dyASa_info`;
$5bd3bef98b39f73a$export$617f828bbf323ba2 = `_8dyASa_level`;
$5bd3bef98b39f73a$export$a8ff84c12d48cfa6 = `_8dyASa_name`;
$5bd3bef98b39f73a$export$95c98301756edbec = `_8dyASa_statistics-tab`;
$5bd3bef98b39f73a$export$3c17558da18e4d75 = `_8dyASa_tile`;
$5bd3bef98b39f73a$export$2ab9a8f9f1186f14 = `_8dyASa_value`;





var $acw62 = parcelRequire("acw62");






var $970ba3fd3bded05f$exports = {};

$parcel$export($970ba3fd3bded05f$exports, "arrow-down", () => $970ba3fd3bded05f$export$cb6045cf6e2f5220, (v) => $970ba3fd3bded05f$export$cb6045cf6e2f5220 = v);
$parcel$export($970ba3fd3bded05f$exports, "bg", () => $970ba3fd3bded05f$export$136fd86de524d3c2, (v) => $970ba3fd3bded05f$export$136fd86de524d3c2 = v);
$parcel$export($970ba3fd3bded05f$exports, "container", () => $970ba3fd3bded05f$export$34e0f9847d4c02dd, (v) => $970ba3fd3bded05f$export$34e0f9847d4c02dd = v);
$parcel$export($970ba3fd3bded05f$exports, "content", () => $970ba3fd3bded05f$export$a7db06668cad9adb, (v) => $970ba3fd3bded05f$export$a7db06668cad9adb = v);
$parcel$export($970ba3fd3bded05f$exports, "error", () => $970ba3fd3bded05f$export$a3bc9b8ed74fc, (v) => $970ba3fd3bded05f$export$a3bc9b8ed74fc = v);
$parcel$export($970ba3fd3bded05f$exports, "gems", () => $970ba3fd3bded05f$export$b7dcc03c39461775, (v) => $970ba3fd3bded05f$export$b7dcc03c39461775 = v);
$parcel$export($970ba3fd3bded05f$exports, "icon", () => $970ba3fd3bded05f$export$1ca1ec8b29a4ce27, (v) => $970ba3fd3bded05f$export$1ca1ec8b29a4ce27 = v);
$parcel$export($970ba3fd3bded05f$exports, "info", () => $970ba3fd3bded05f$export$a80b3bd66acc52ff, (v) => $970ba3fd3bded05f$export$a80b3bd66acc52ff = v);
$parcel$export($970ba3fd3bded05f$exports, "level", () => $970ba3fd3bded05f$export$617f828bbf323ba2, (v) => $970ba3fd3bded05f$export$617f828bbf323ba2 = v);
$parcel$export($970ba3fd3bded05f$exports, "name", () => $970ba3fd3bded05f$export$a8ff84c12d48cfa6, (v) => $970ba3fd3bded05f$export$a8ff84c12d48cfa6 = v);
$parcel$export($970ba3fd3bded05f$exports, "not-enough-gems", () => $970ba3fd3bded05f$export$faafa7f90d2dd0bb, (v) => $970ba3fd3bded05f$export$faafa7f90d2dd0bb = v);
$parcel$export($970ba3fd3bded05f$exports, "tile", () => $970ba3fd3bded05f$export$3c17558da18e4d75, (v) => $970ba3fd3bded05f$export$3c17558da18e4d75 = v);
$parcel$export($970ba3fd3bded05f$exports, "title", () => $970ba3fd3bded05f$export$fb184b623420d9be, (v) => $970ba3fd3bded05f$export$fb184b623420d9be = v);
$parcel$export($970ba3fd3bded05f$exports, "upgrade", () => $970ba3fd3bded05f$export$ba387509dbaf942e, (v) => $970ba3fd3bded05f$export$ba387509dbaf942e = v);
$parcel$export($970ba3fd3bded05f$exports, "value", () => $970ba3fd3bded05f$export$2ab9a8f9f1186f14, (v) => $970ba3fd3bded05f$export$2ab9a8f9f1186f14 = v);
var $970ba3fd3bded05f$export$cb6045cf6e2f5220;
var $970ba3fd3bded05f$export$136fd86de524d3c2;
var $970ba3fd3bded05f$export$34e0f9847d4c02dd;
var $970ba3fd3bded05f$export$a7db06668cad9adb;
var $970ba3fd3bded05f$export$a3bc9b8ed74fc;
var $970ba3fd3bded05f$export$b7dcc03c39461775;
var $970ba3fd3bded05f$export$1ca1ec8b29a4ce27;
var $970ba3fd3bded05f$export$a80b3bd66acc52ff;
var $970ba3fd3bded05f$export$617f828bbf323ba2;
var $970ba3fd3bded05f$export$a8ff84c12d48cfa6;
var $970ba3fd3bded05f$export$faafa7f90d2dd0bb;
var $970ba3fd3bded05f$export$3c17558da18e4d75;
var $970ba3fd3bded05f$export$fb184b623420d9be;
var $970ba3fd3bded05f$export$ba387509dbaf942e;
var $970ba3fd3bded05f$export$2ab9a8f9f1186f14;
$970ba3fd3bded05f$export$cb6045cf6e2f5220 = `TYRSWa_arrow-down`;
$970ba3fd3bded05f$export$136fd86de524d3c2 = `TYRSWa_bg`;
$970ba3fd3bded05f$export$34e0f9847d4c02dd = `TYRSWa_container`;
$970ba3fd3bded05f$export$a7db06668cad9adb = `TYRSWa_content`;
$970ba3fd3bded05f$export$a3bc9b8ed74fc = `TYRSWa_error`;
$970ba3fd3bded05f$export$b7dcc03c39461775 = `TYRSWa_gems`;
$970ba3fd3bded05f$export$1ca1ec8b29a4ce27 = `TYRSWa_icon`;
$970ba3fd3bded05f$export$a80b3bd66acc52ff = `TYRSWa_info`;
$970ba3fd3bded05f$export$617f828bbf323ba2 = `TYRSWa_level`;
$970ba3fd3bded05f$export$a8ff84c12d48cfa6 = `TYRSWa_name`;
$970ba3fd3bded05f$export$faafa7f90d2dd0bb = `TYRSWa_not-enough-gems`;
$970ba3fd3bded05f$export$3c17558da18e4d75 = `TYRSWa_tile`;
$970ba3fd3bded05f$export$fb184b623420d9be = `TYRSWa_title`;
$970ba3fd3bded05f$export$ba387509dbaf942e = `TYRSWa_upgrade`;
$970ba3fd3bded05f$export$2ab9a8f9f1186f14 = `TYRSWa_value`;


const $b46a364e7e2cb030$export$cf79c8aca48b2651 = ({ className: className, onClose: onClose, data: data, name: name, level: level, ...props })=>{
    const { state: { accountInfo: accountInfo } } = (0, $c25623cc446ec3c6$export$ac8576a9912be18c)();
    const [upgrading, setUpgrading] = (0, $acw62.useState)(false);
    const title = /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: (0, $9805619f03ed02ef$export$91884aa883243770)((0, (/*@__PURE__*/$parcel$interopDefault($970ba3fd3bded05f$exports))), "title"),
        children: [
            "Upgrade ",
            (0, $9805619f03ed02ef$export$1ae03cd54bd9de7a)(name ?? "", " "),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                src: `${(0, $0426e2dd5e0de94d$export$24af3971dd36b33f)}/ui/cross.png`,
                alt: "cross",
                onClick: onClose
            })
        ]
    });
    const entry = name ? data?.stats?.[name] : undefined;
    const actualLevel = entry?.levels[(level ?? 1) - 1];
    const newLevel = entry?.levels[level ?? 0];
    const neededGems = entry?.levels[level ?? 0]?.priceToUnlock.gems;
    const notEnoughGems = neededGems !== undefined && accountInfo?.gems !== undefined && neededGems > accountInfo.gems;
    const maxLevelReached = level !== undefined && entry?.levels[level] === undefined;
    const upgrade = async ()=>{
        if (notEnoughGems || maxLevelReached || !name || !entry) return;
        if ((0, $b3b1baf40467424d$export$745043c7dc65e495).showConfirm) (0, $b3b1baf40467424d$export$745043c7dc65e495).showConfirm({
            title: `Upgrade ${name}`,
            text: `Do you really want to upgrade ${name} for ${entry.levels[level ?? 0].priceToUnlock.gems} gems?`,
            acceptText: "Yes",
            refuseText: "No",
            async onAccept () {
                setUpgrading(true);
                const result = await (0, $35a528e84618b070$export$f1209970daa254db)(name);
                if (result?.data && (0, $b3b1baf40467424d$export$745043c7dc65e495).refreshAccountInfo) (0, $b3b1baf40467424d$export$745043c7dc65e495).refreshAccountInfo();
                setUpgrading(false);
                onClose();
            }
        });
    };
    const content = /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: (0, $9805619f03ed02ef$export$91884aa883243770)((0, (/*@__PURE__*/$parcel$interopDefault($970ba3fd3bded05f$exports))), "content"),
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: (0, $9805619f03ed02ef$export$91884aa883243770)((0, (/*@__PURE__*/$parcel$interopDefault($970ba3fd3bded05f$exports))), "tile"),
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        className: (0, $9805619f03ed02ef$export$91884aa883243770)((0, (/*@__PURE__*/$parcel$interopDefault($970ba3fd3bded05f$exports))), "bg")
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: (0, $9805619f03ed02ef$export$91884aa883243770)((0, (/*@__PURE__*/$parcel$interopDefault($970ba3fd3bded05f$exports))), "container"),
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: (0, $9805619f03ed02ef$export$91884aa883243770)((0, (/*@__PURE__*/$parcel$interopDefault($970ba3fd3bded05f$exports))), "icon"),
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                                        src: `${(0, $0426e2dd5e0de94d$export$24af3971dd36b33f)}/ui/character/${name}.png`,
                                        alt: `${name}`
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                        className: (0, $9805619f03ed02ef$export$91884aa883243770)((0, (/*@__PURE__*/$parcel$interopDefault($970ba3fd3bded05f$exports))), "level"),
                                        children: level ?? 1
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: (0, $9805619f03ed02ef$export$91884aa883243770)((0, (/*@__PURE__*/$parcel$interopDefault($970ba3fd3bded05f$exports))), "info"),
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                        className: (0, $9805619f03ed02ef$export$91884aa883243770)((0, (/*@__PURE__*/$parcel$interopDefault($970ba3fd3bded05f$exports))), "name"),
                                        children: (0, $9805619f03ed02ef$export$1ae03cd54bd9de7a)(name ?? "", " ")
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                        className: (0, $9805619f03ed02ef$export$91884aa883243770)((0, (/*@__PURE__*/$parcel$interopDefault($970ba3fd3bded05f$exports))), "value"),
                                        children: actualLevel?.value ?? "..."
                                    })
                                ]
                            })
                        ]
                    })
                ]
            }),
            !maxLevelReached && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                        className: (0, $9805619f03ed02ef$export$91884aa883243770)((0, (/*@__PURE__*/$parcel$interopDefault($970ba3fd3bded05f$exports))), "arrow-down"),
                        src: `${(0, $0426e2dd5e0de94d$export$24af3971dd36b33f)}/ui/arrow-down.png`,
                        alt: "arrow-down"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: (0, $9805619f03ed02ef$export$91884aa883243770)((0, (/*@__PURE__*/$parcel$interopDefault($970ba3fd3bded05f$exports))), "tile"),
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                className: (0, $9805619f03ed02ef$export$91884aa883243770)((0, (/*@__PURE__*/$parcel$interopDefault($970ba3fd3bded05f$exports))), "bg")
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: (0, $9805619f03ed02ef$export$91884aa883243770)((0, (/*@__PURE__*/$parcel$interopDefault($970ba3fd3bded05f$exports))), "container"),
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                        className: (0, $9805619f03ed02ef$export$91884aa883243770)((0, (/*@__PURE__*/$parcel$interopDefault($970ba3fd3bded05f$exports))), "icon"),
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                                                src: `${(0, $0426e2dd5e0de94d$export$24af3971dd36b33f)}/ui/character/${name}.png`,
                                                alt: `${name}`
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                className: (0, $9805619f03ed02ef$export$91884aa883243770)((0, (/*@__PURE__*/$parcel$interopDefault($970ba3fd3bded05f$exports))), "level"),
                                                children: (level ?? 0) + 1
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                        className: (0, $9805619f03ed02ef$export$91884aa883243770)((0, (/*@__PURE__*/$parcel$interopDefault($970ba3fd3bded05f$exports))), "info"),
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                className: (0, $9805619f03ed02ef$export$91884aa883243770)((0, (/*@__PURE__*/$parcel$interopDefault($970ba3fd3bded05f$exports))), "name"),
                                                children: (0, $9805619f03ed02ef$export$1ae03cd54bd9de7a)(name ?? "", " ")
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                className: (0, $9805619f03ed02ef$export$91884aa883243770)((0, (/*@__PURE__*/$parcel$interopDefault($970ba3fd3bded05f$exports))), "value"),
                                                children: newLevel?.value ?? "..."
                                            })
                                        ]
                                    })
                                ]
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $6725244138e0595f$export$353f5b6fc5456de1), {
                className: (0, $9805619f03ed02ef$export$91884aa883243770)((0, (/*@__PURE__*/$parcel$interopDefault($970ba3fd3bded05f$exports))), `gems ${maxLevelReached || notEnoughGems ? "gray" : "blue"}`),
                disabled: maxLevelReached || notEnoughGems,
                loading: upgrading,
                onClick: upgrade,
                children: [
                    !maxLevelReached && !notEnoughGems && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                        src: `${(0, $0426e2dd5e0de94d$export$24af3971dd36b33f)}/ui/gem.png`,
                        alt: "gem"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        children: maxLevelReached ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                    children: "MAX LEVEL"
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                    children: "REACHED"
                                })
                            ]
                        }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                    children: "UPGRADE FOR"
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                    className: (0, $9805619f03ed02ef$export$91884aa883243770)((0, (/*@__PURE__*/$parcel$interopDefault($970ba3fd3bded05f$exports))), `${notEnoughGems ? "error" : ""}`),
                                    children: [
                                        entry?.levels[level ?? 0].priceToUnlock.gems ?? "...",
                                        " GEMS"
                                    ]
                                })
                            ]
                        })
                    }),
                    !maxLevelReached && !notEnoughGems && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                        src: `${(0, $0426e2dd5e0de94d$export$24af3971dd36b33f)}/ui/gem.png`,
                        alt: "gem"
                    })
                ]
            }),
            notEnoughGems && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: (0, $9805619f03ed02ef$export$91884aa883243770)((0, (/*@__PURE__*/$parcel$interopDefault($970ba3fd3bded05f$exports))), "not-enough-gems"),
                children: "not enough gems"
            })
        ]
    });
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $207d23274fe2be11$export$6e63c1000ecf9db8), {
        className: (0, $9805619f03ed02ef$export$91884aa883243770)((0, (/*@__PURE__*/$parcel$interopDefault($970ba3fd3bded05f$exports))), `upgrade ${className}`),
        title: title,
        content: content,
        onClickBackground: onClose,
        ...props
    });
};


const $2172b79dca601800$export$6e7ed12337047155 = ({ className: className, ...props })=>{
    const { state: { accountInfo: accountInfo } } = (0, $c25623cc446ec3c6$export$ac8576a9912be18c)();
    const [data, setData] = (0, $acw62.useState)();
    const [showUpgrade, setShowUpgrade] = (0, $acw62.useState)(false);
    const [selectedName, setSelectedName] = (0, $acw62.useState)();
    const [selectedLevel, setSelectedLevel] = (0, $acw62.useState)();
    (0, $acw62.useEffect)(()=>{
        (0, $c7501b837bedbe83$export$f9bf007567f0252a)().then(setData);
    }, []);
    const levelUp = (name, level)=>{
        if (level === undefined) {
            (0, $ad26fe773541dcd3$export$b410431fab84fa58).error("Impossible to upgrade this trait");
            return;
        }
        setSelectedName(name);
        setSelectedLevel(level + 1);
        setShowUpgrade(true);
    };
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: (0, $9805619f03ed02ef$export$91884aa883243770)((0, (/*@__PURE__*/$parcel$interopDefault($5bd3bef98b39f73a$exports))), `statistics-tab reveal-element ${className}`),
                ...props,
                children: Object.entries(data?.stats ?? {}).map(([name])=>{
                    const level = accountInfo?.character.stats[name];
                    const entry = data?.stats?.[name];
                    const actualLevel = entry?.levels[level ?? 0];
                    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: (0, $9805619f03ed02ef$export$91884aa883243770)((0, (/*@__PURE__*/$parcel$interopDefault($5bd3bef98b39f73a$exports))), "tile"),
                        onClick: ()=>levelUp(name, level),
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                className: (0, $9805619f03ed02ef$export$91884aa883243770)((0, (/*@__PURE__*/$parcel$interopDefault($5bd3bef98b39f73a$exports))), "bg")
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: (0, $9805619f03ed02ef$export$91884aa883243770)((0, (/*@__PURE__*/$parcel$interopDefault($5bd3bef98b39f73a$exports))), "container"),
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                        className: (0, $9805619f03ed02ef$export$91884aa883243770)((0, (/*@__PURE__*/$parcel$interopDefault($5bd3bef98b39f73a$exports))), "icon"),
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                                                src: `${(0, $0426e2dd5e0de94d$export$24af3971dd36b33f)}/ui/character/${name}.png`,
                                                alt: `${name}`
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                className: (0, $9805619f03ed02ef$export$91884aa883243770)((0, (/*@__PURE__*/$parcel$interopDefault($5bd3bef98b39f73a$exports))), "level"),
                                                children: (level ?? 0) + 1
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                        className: (0, $9805619f03ed02ef$export$91884aa883243770)((0, (/*@__PURE__*/$parcel$interopDefault($5bd3bef98b39f73a$exports))), "info"),
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                className: (0, $9805619f03ed02ef$export$91884aa883243770)((0, (/*@__PURE__*/$parcel$interopDefault($5bd3bef98b39f73a$exports))), "name"),
                                                children: (0, $9805619f03ed02ef$export$1ae03cd54bd9de7a)(name, " ")
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                className: (0, $9805619f03ed02ef$export$91884aa883243770)((0, (/*@__PURE__*/$parcel$interopDefault($5bd3bef98b39f73a$exports))), "value"),
                                                children: actualLevel?.value ?? "..."
                                            })
                                        ]
                                    })
                                ]
                            })
                        ]
                    }, `info-${name}`);
                })
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $b46a364e7e2cb030$export$cf79c8aca48b2651), {
                show: showUpgrade,
                onExited: ()=>{
                    setSelectedName(undefined);
                    setSelectedLevel(undefined);
                },
                onClose: ()=>setShowUpgrade(false),
                name: selectedName,
                level: selectedLevel,
                data: data
            })
        ]
    });
};






var $acw62 = parcelRequire("acw62");







var $acw62 = parcelRequire("acw62");






var $6b0b4ade5fc37a94$exports = {};

$parcel$export($6b0b4ade5fc37a94$exports, "arrow-down", () => $6b0b4ade5fc37a94$export$cb6045cf6e2f5220, (v) => $6b0b4ade5fc37a94$export$cb6045cf6e2f5220 = v);
$parcel$export($6b0b4ade5fc37a94$exports, "bg", () => $6b0b4ade5fc37a94$export$136fd86de524d3c2, (v) => $6b0b4ade5fc37a94$export$136fd86de524d3c2 = v);
$parcel$export($6b0b4ade5fc37a94$exports, "buy-or-upgrade", () => $6b0b4ade5fc37a94$export$7675a010d623d517, (v) => $6b0b4ade5fc37a94$export$7675a010d623d517 = v);
$parcel$export($6b0b4ade5fc37a94$exports, "container", () => $6b0b4ade5fc37a94$export$34e0f9847d4c02dd, (v) => $6b0b4ade5fc37a94$export$34e0f9847d4c02dd = v);
$parcel$export($6b0b4ade5fc37a94$exports, "content", () => $6b0b4ade5fc37a94$export$a7db06668cad9adb, (v) => $6b0b4ade5fc37a94$export$a7db06668cad9adb = v);
$parcel$export($6b0b4ade5fc37a94$exports, "error", () => $6b0b4ade5fc37a94$export$a3bc9b8ed74fc, (v) => $6b0b4ade5fc37a94$export$a3bc9b8ed74fc = v);
$parcel$export($6b0b4ade5fc37a94$exports, "gems", () => $6b0b4ade5fc37a94$export$b7dcc03c39461775, (v) => $6b0b4ade5fc37a94$export$b7dcc03c39461775 = v);
$parcel$export($6b0b4ade5fc37a94$exports, "grid", () => $6b0b4ade5fc37a94$export$85fc379452d91af0, (v) => $6b0b4ade5fc37a94$export$85fc379452d91af0 = v);
$parcel$export($6b0b4ade5fc37a94$exports, "icon", () => $6b0b4ade5fc37a94$export$1ca1ec8b29a4ce27, (v) => $6b0b4ade5fc37a94$export$1ca1ec8b29a4ce27 = v);
$parcel$export($6b0b4ade5fc37a94$exports, "info", () => $6b0b4ade5fc37a94$export$a80b3bd66acc52ff, (v) => $6b0b4ade5fc37a94$export$a80b3bd66acc52ff = v);
$parcel$export($6b0b4ade5fc37a94$exports, "name", () => $6b0b4ade5fc37a94$export$a8ff84c12d48cfa6, (v) => $6b0b4ade5fc37a94$export$a8ff84c12d48cfa6 = v);
$parcel$export($6b0b4ade5fc37a94$exports, "not-enough-gems", () => $6b0b4ade5fc37a94$export$faafa7f90d2dd0bb, (v) => $6b0b4ade5fc37a94$export$faafa7f90d2dd0bb = v);
$parcel$export($6b0b4ade5fc37a94$exports, "pew-pew-1", () => $6b0b4ade5fc37a94$export$f813f11131542305, (v) => $6b0b4ade5fc37a94$export$f813f11131542305 = v);
$parcel$export($6b0b4ade5fc37a94$exports, "pew-pew-2", () => $6b0b4ade5fc37a94$export$dee2eb7bb5b7b2fa, (v) => $6b0b4ade5fc37a94$export$dee2eb7bb5b7b2fa = v);
$parcel$export($6b0b4ade5fc37a94$exports, "pew-pew-3", () => $6b0b4ade5fc37a94$export$bbc3aa3bad100f67, (v) => $6b0b4ade5fc37a94$export$bbc3aa3bad100f67 = v);
$parcel$export($6b0b4ade5fc37a94$exports, "pew-pew-4", () => $6b0b4ade5fc37a94$export$1c83a85e536aa172, (v) => $6b0b4ade5fc37a94$export$1c83a85e536aa172 = v);
$parcel$export($6b0b4ade5fc37a94$exports, "shadow", () => $6b0b4ade5fc37a94$export$b8972b998723d602, (v) => $6b0b4ade5fc37a94$export$b8972b998723d602 = v);
$parcel$export($6b0b4ade5fc37a94$exports, "stats", () => $6b0b4ade5fc37a94$export$7804429c45dff272, (v) => $6b0b4ade5fc37a94$export$7804429c45dff272 = v);
$parcel$export($6b0b4ade5fc37a94$exports, "tile", () => $6b0b4ade5fc37a94$export$3c17558da18e4d75, (v) => $6b0b4ade5fc37a94$export$3c17558da18e4d75 = v);
$parcel$export($6b0b4ade5fc37a94$exports, "title", () => $6b0b4ade5fc37a94$export$fb184b623420d9be, (v) => $6b0b4ade5fc37a94$export$fb184b623420d9be = v);
$parcel$export($6b0b4ade5fc37a94$exports, "value", () => $6b0b4ade5fc37a94$export$2ab9a8f9f1186f14, (v) => $6b0b4ade5fc37a94$export$2ab9a8f9f1186f14 = v);
$parcel$export($6b0b4ade5fc37a94$exports, "weapon", () => $6b0b4ade5fc37a94$export$49f053317aaa2405, (v) => $6b0b4ade5fc37a94$export$49f053317aaa2405 = v);
var $6b0b4ade5fc37a94$export$cb6045cf6e2f5220;
var $6b0b4ade5fc37a94$export$136fd86de524d3c2;
var $6b0b4ade5fc37a94$export$7675a010d623d517;
var $6b0b4ade5fc37a94$export$34e0f9847d4c02dd;
var $6b0b4ade5fc37a94$export$a7db06668cad9adb;
var $6b0b4ade5fc37a94$export$a3bc9b8ed74fc;
var $6b0b4ade5fc37a94$export$b7dcc03c39461775;
var $6b0b4ade5fc37a94$export$85fc379452d91af0;
var $6b0b4ade5fc37a94$export$1ca1ec8b29a4ce27;
var $6b0b4ade5fc37a94$export$a80b3bd66acc52ff;
var $6b0b4ade5fc37a94$export$a8ff84c12d48cfa6;
var $6b0b4ade5fc37a94$export$faafa7f90d2dd0bb;
var $6b0b4ade5fc37a94$export$f813f11131542305;
var $6b0b4ade5fc37a94$export$dee2eb7bb5b7b2fa;
var $6b0b4ade5fc37a94$export$bbc3aa3bad100f67;
var $6b0b4ade5fc37a94$export$1c83a85e536aa172;
var $6b0b4ade5fc37a94$export$b8972b998723d602;
var $6b0b4ade5fc37a94$export$7804429c45dff272;
var $6b0b4ade5fc37a94$export$3c17558da18e4d75;
var $6b0b4ade5fc37a94$export$fb184b623420d9be;
var $6b0b4ade5fc37a94$export$2ab9a8f9f1186f14;
var $6b0b4ade5fc37a94$export$49f053317aaa2405;
$6b0b4ade5fc37a94$export$cb6045cf6e2f5220 = `_8cr78a_arrow-down`;
$6b0b4ade5fc37a94$export$136fd86de524d3c2 = `_8cr78a_bg`;
$6b0b4ade5fc37a94$export$7675a010d623d517 = `_8cr78a_buy-or-upgrade`;
$6b0b4ade5fc37a94$export$34e0f9847d4c02dd = `_8cr78a_container`;
$6b0b4ade5fc37a94$export$a7db06668cad9adb = `_8cr78a_content`;
$6b0b4ade5fc37a94$export$a3bc9b8ed74fc = `_8cr78a_error`;
$6b0b4ade5fc37a94$export$b7dcc03c39461775 = `_8cr78a_gems`;
$6b0b4ade5fc37a94$export$85fc379452d91af0 = `_8cr78a_grid`;
$6b0b4ade5fc37a94$export$1ca1ec8b29a4ce27 = `_8cr78a_icon`;
$6b0b4ade5fc37a94$export$a80b3bd66acc52ff = `_8cr78a_info`;
$6b0b4ade5fc37a94$export$a8ff84c12d48cfa6 = `_8cr78a_name`;
$6b0b4ade5fc37a94$export$faafa7f90d2dd0bb = `_8cr78a_not-enough-gems`;
$6b0b4ade5fc37a94$export$f813f11131542305 = `_8cr78a_pew-pew-1`;
$6b0b4ade5fc37a94$export$dee2eb7bb5b7b2fa = `_8cr78a_pew-pew-2`;
$6b0b4ade5fc37a94$export$bbc3aa3bad100f67 = `_8cr78a_pew-pew-3`;
$6b0b4ade5fc37a94$export$1c83a85e536aa172 = `_8cr78a_pew-pew-4`;
$6b0b4ade5fc37a94$export$b8972b998723d602 = `_8cr78a_shadow`;
$6b0b4ade5fc37a94$export$7804429c45dff272 = `_8cr78a_stats`;
$6b0b4ade5fc37a94$export$3c17558da18e4d75 = `_8cr78a_tile`;
$6b0b4ade5fc37a94$export$fb184b623420d9be = `_8cr78a_title`;
$6b0b4ade5fc37a94$export$2ab9a8f9f1186f14 = `_8cr78a_value`;
$6b0b4ade5fc37a94$export$49f053317aaa2405 = `_8cr78a_weapon`;


const $91ad28735b1958ee$export$848c2f7384932dba = ({ className: className, onClose: onClose, data: data, name: name, ...props })=>{
    const { state: { accountInfo: accountInfo }, dispatch: dispatch } = (0, $c25623cc446ec3c6$export$ac8576a9912be18c)();
    const [loading, setLoading] = (0, $acw62.useState)(false);
    const [equipying, setEquipying] = (0, $acw62.useState)(false);
    const entry = name ? data?.[name] : undefined;
    const unlocked = accountInfo?.character.weapons.unlocked[name ?? (0, $49736469f58fc92b$export$a0b1da4b3d9a7c29).CommonBlaster] !== undefined;
    const equiped = accountInfo?.character.weapons.equiped === name;
    const actualLevelIndex = accountInfo?.character.weapons.unlocked[name ?? (0, $49736469f58fc92b$export$a0b1da4b3d9a7c29).CommonBlaster] ?? 0;
    const actualLevel = entry?.levels[actualLevelIndex];
    const nextLevel = entry?.levels[actualLevelIndex + 1];
    const maxLevelReached = actualLevelIndex !== undefined && nextLevel === undefined;
    const neededGems = unlocked ? maxLevelReached ? 0 : nextLevel?.priceToUnlock.gems : entry?.levels[0].priceToUnlock.gems;
    const notEnoughGems = neededGems !== undefined && accountInfo?.gems !== undefined && neededGems > accountInfo.gems;
    const title = /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: (0, $9805619f03ed02ef$export$91884aa883243770)((0, (/*@__PURE__*/$parcel$interopDefault($6b0b4ade5fc37a94$exports))), "title"),
        children: [
            name?.replaceAll("_", " ").toLowerCase(),
            " (level ",
            actualLevelIndex + 1,
            ")",
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                src: `${(0, $0426e2dd5e0de94d$export$24af3971dd36b33f)}/ui/cross.png`,
                alt: "cross",
                onClick: onClose
            })
        ]
    });
    const onUpgrade = async ()=>{
        if (notEnoughGems || maxLevelReached || !name || !nextLevel) return;
        if ((0, $b3b1baf40467424d$export$745043c7dc65e495).showConfirm) (0, $b3b1baf40467424d$export$745043c7dc65e495).showConfirm({
            title: "Upgrade weapon",
            text: `Do you really want to upgrade the weapon for ${nextLevel.priceToUnlock.gems} gems?`,
            acceptText: "Yes",
            refuseText: "No",
            async onAccept () {
                setLoading(true);
                const result = await (0, $35a528e84618b070$export$705f2068f3c1014b)(name);
                if (result?.data && (0, $b3b1baf40467424d$export$745043c7dc65e495).refreshAccountInfo) (0, $b3b1baf40467424d$export$745043c7dc65e495).refreshAccountInfo();
                setLoading(false);
            }
        });
    };
    const onBuy = ()=>{
        if (!name || !entry) return;
        if ((0, $b3b1baf40467424d$export$745043c7dc65e495).showConfirm) (0, $b3b1baf40467424d$export$745043c7dc65e495).showConfirm({
            title: "Buy weapon",
            text: `Do you really want to buy the weapon for ${entry.levels[0].priceToUnlock.gems} gems?`,
            acceptText: "Yes",
            refuseText: "No",
            async onAccept () {
                setLoading(true);
                const result = await (0, $35a528e84618b070$export$5c66de07daf88ef5)(name);
                if (result?.data && (0, $b3b1baf40467424d$export$745043c7dc65e495).refreshAccountInfo) (0, $b3b1baf40467424d$export$745043c7dc65e495).refreshAccountInfo();
                setLoading(false);
            }
        });
    };
    const onEquip = async ()=>{
        if (!name) return;
        setEquipying(true);
        const result = await (0, $35a528e84618b070$export$5abf33b3a23c0859)(name);
        if (result?.data) {
            const copy = JSON.parse(JSON.stringify(accountInfo));
            copy.character.weapons.equiped = name;
            dispatch({
                type: "SET_ACCOUNT_INFO",
                accountInfo: copy
            });
        }
        setEquipying(false);
    };
    const content = /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: (0, $9805619f03ed02ef$export$91884aa883243770)((0, (/*@__PURE__*/$parcel$interopDefault($6b0b4ade5fc37a94$exports))), "content"),
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: (0, $9805619f03ed02ef$export$91884aa883243770)((0, (/*@__PURE__*/$parcel$interopDefault($6b0b4ade5fc37a94$exports))), "weapon"),
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        className: (0, $9805619f03ed02ef$export$91884aa883243770)((0, (/*@__PURE__*/$parcel$interopDefault($6b0b4ade5fc37a94$exports))), "pew-pew-1"),
                        children: "pew pew"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        className: (0, $9805619f03ed02ef$export$91884aa883243770)((0, (/*@__PURE__*/$parcel$interopDefault($6b0b4ade5fc37a94$exports))), "pew-pew-2"),
                        children: "pew pew"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        className: (0, $9805619f03ed02ef$export$91884aa883243770)((0, (/*@__PURE__*/$parcel$interopDefault($6b0b4ade5fc37a94$exports))), "pew-pew-3"),
                        children: "pew pew"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        className: (0, $9805619f03ed02ef$export$91884aa883243770)((0, (/*@__PURE__*/$parcel$interopDefault($6b0b4ade5fc37a94$exports))), "pew-pew-4"),
                        children: "pew pew"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                        src: `${(0, $0426e2dd5e0de94d$export$24af3971dd36b33f)}/ui/weapons/${(name ?? "").toLowerCase()}.png`
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        className: (0, $9805619f03ed02ef$export$91884aa883243770)((0, (/*@__PURE__*/$parcel$interopDefault($6b0b4ade5fc37a94$exports))), "shadow")
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: (0, $9805619f03ed02ef$export$91884aa883243770)((0, (/*@__PURE__*/$parcel$interopDefault($6b0b4ade5fc37a94$exports))), "stats"),
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: (0, $9805619f03ed02ef$export$91884aa883243770)((0, (/*@__PURE__*/$parcel$interopDefault($6b0b4ade5fc37a94$exports))), "title"),
                        children: [
                            unlocked && "upgrade ",
                            "weapon stats"
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        className: (0, $9805619f03ed02ef$export$91884aa883243770)((0, (/*@__PURE__*/$parcel$interopDefault($6b0b4ade5fc37a94$exports))), "grid"),
                        children: Object.entries(actualLevel?.characteristics ?? {}).map(([name, value])=>{
                            if (name === "lifetime") return;
                            const difference = (nextLevel?.characteristics[name] ?? 0) - value;
                            return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: (0, $9805619f03ed02ef$export$91884aa883243770)((0, (/*@__PURE__*/$parcel$interopDefault($6b0b4ade5fc37a94$exports))), "tile"),
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                        className: (0, $9805619f03ed02ef$export$91884aa883243770)((0, (/*@__PURE__*/$parcel$interopDefault($6b0b4ade5fc37a94$exports))), "bg")
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                        className: (0, $9805619f03ed02ef$export$91884aa883243770)((0, (/*@__PURE__*/$parcel$interopDefault($6b0b4ade5fc37a94$exports))), "container"),
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                className: (0, $9805619f03ed02ef$export$91884aa883243770)((0, (/*@__PURE__*/$parcel$interopDefault($6b0b4ade5fc37a94$exports))), "icon"),
                                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                                                    src: `${(0, $0426e2dd5e0de94d$export$24af3971dd36b33f)}/ui/weapons/characteristics/${name}.png`,
                                                    alt: `${name}`
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                className: (0, $9805619f03ed02ef$export$91884aa883243770)((0, (/*@__PURE__*/$parcel$interopDefault($6b0b4ade5fc37a94$exports))), "info"),
                                                children: [
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                        className: (0, $9805619f03ed02ef$export$91884aa883243770)((0, (/*@__PURE__*/$parcel$interopDefault($6b0b4ade5fc37a94$exports))), "name"),
                                                        children: (0, $9805619f03ed02ef$export$1ae03cd54bd9de7a)(name, " ")
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                        className: (0, $9805619f03ed02ef$export$91884aa883243770)((0, (/*@__PURE__*/$parcel$interopDefault($6b0b4ade5fc37a94$exports))), "value"),
                                                        children: [
                                                            value,
                                                            unlocked && !maxLevelReached && Math.abs(difference) > 0 && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                                                                children: [
                                                                    " ",
                                                                    difference < 0 ? "-" : "+",
                                                                    " ",
                                                                    Math.abs(difference)
                                                                ]
                                                            })
                                                        ]
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                ]
                            }, `stats-${name}`);
                        })
                    })
                ]
            }),
            unlocked ? maxLevelReached ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $6725244138e0595f$export$353f5b6fc5456de1), {
                className: (0, $9805619f03ed02ef$export$91884aa883243770)((0, (/*@__PURE__*/$parcel$interopDefault($6b0b4ade5fc37a94$exports))), "gray gems small"),
                disabled: true,
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                            children: "MAX LEVEL"
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                            children: "REACHED"
                        })
                    ]
                })
            }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $6725244138e0595f$export$353f5b6fc5456de1), {
                className: (0, $9805619f03ed02ef$export$91884aa883243770)((0, (/*@__PURE__*/$parcel$interopDefault($6b0b4ade5fc37a94$exports))), `${notEnoughGems ? "gray" : "blue"} gems small`),
                onClick: onUpgrade,
                loading: loading,
                disabled: notEnoughGems,
                children: [
                    !notEnoughGems && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                        src: `${(0, $0426e2dd5e0de94d$export$24af3971dd36b33f)}/ui/gem.png`,
                        alt: "gem"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                children: "UPGRADE FOR"
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: (0, $9805619f03ed02ef$export$91884aa883243770)((0, (/*@__PURE__*/$parcel$interopDefault($6b0b4ade5fc37a94$exports))), `${notEnoughGems ? "error" : ""}`),
                                children: [
                                    nextLevel?.priceToUnlock.gems ?? "...",
                                    " GEMS"
                                ]
                            })
                        ]
                    }),
                    !notEnoughGems && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                        src: `${(0, $0426e2dd5e0de94d$export$24af3971dd36b33f)}/ui/gem.png`,
                        alt: "gem"
                    })
                ]
            }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $6725244138e0595f$export$353f5b6fc5456de1), {
                className: (0, $9805619f03ed02ef$export$91884aa883243770)((0, (/*@__PURE__*/$parcel$interopDefault($6b0b4ade5fc37a94$exports))), `${notEnoughGems ? "gray" : "blue"} gems small`),
                onClick: onBuy,
                loading: loading,
                disabled: notEnoughGems,
                children: [
                    !notEnoughGems && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                        src: `${(0, $0426e2dd5e0de94d$export$24af3971dd36b33f)}/ui/gem.png`,
                        alt: "gem"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                children: "UNLOCK FOR"
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: (0, $9805619f03ed02ef$export$91884aa883243770)((0, (/*@__PURE__*/$parcel$interopDefault($6b0b4ade5fc37a94$exports))), `${notEnoughGems ? "error" : ""}`),
                                children: [
                                    entry?.levels[0].priceToUnlock.gems ?? "...",
                                    " GEMS"
                                ]
                            })
                        ]
                    }),
                    !notEnoughGems && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                        src: `${(0, $0426e2dd5e0de94d$export$24af3971dd36b33f)}/ui/gem.png`,
                        alt: "gem"
                    })
                ]
            }),
            !equiped && unlocked && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $6725244138e0595f$export$353f5b6fc5456de1), {
                className: "small",
                onClick: onEquip,
                loading: equipying,
                children: "EQUIP"
            })
        ]
    });
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $207d23274fe2be11$export$6e63c1000ecf9db8), {
        className: (0, $9805619f03ed02ef$export$91884aa883243770)((0, (/*@__PURE__*/$parcel$interopDefault($6b0b4ade5fc37a94$exports))), `buy-or-upgrade ${className}`),
        title: title,
        content: content,
        onClickBackground: onClose,
        ...props
    });
};


var $a0b3c3363ace277a$exports = {};

$parcel$export($a0b3c3363ace277a$exports, "bg", () => $a0b3c3363ace277a$export$136fd86de524d3c2, (v) => $a0b3c3363ace277a$export$136fd86de524d3c2 = v);
$parcel$export($a0b3c3363ace277a$exports, "image", () => $a0b3c3363ace277a$export$5c452ff88e35e47d, (v) => $a0b3c3363ace277a$export$5c452ff88e35e47d = v);
$parcel$export($a0b3c3363ace277a$exports, "info", () => $a0b3c3363ace277a$export$a80b3bd66acc52ff, (v) => $a0b3c3363ace277a$export$a80b3bd66acc52ff = v);
$parcel$export($a0b3c3363ace277a$exports, "list", () => $a0b3c3363ace277a$export$8837f4fc672e936d, (v) => $a0b3c3363ace277a$export$8837f4fc672e936d = v);
$parcel$export($a0b3c3363ace277a$exports, "locked", () => $a0b3c3363ace277a$export$b5cac684278fae13, (v) => $a0b3c3363ace277a$export$b5cac684278fae13 = v);
$parcel$export($a0b3c3363ace277a$exports, "multi-button", () => $a0b3c3363ace277a$export$1fbfc406395df0a, (v) => $a0b3c3363ace277a$export$1fbfc406395df0a = v);
$parcel$export($a0b3c3363ace277a$exports, "selected", () => $a0b3c3363ace277a$export$d90250155de6d7e7, (v) => $a0b3c3363ace277a$export$d90250155de6d7e7 = v);
$parcel$export($a0b3c3363ace277a$exports, "text", () => $a0b3c3363ace277a$export$6f093cfa640b7166, (v) => $a0b3c3363ace277a$export$6f093cfa640b7166 = v);
$parcel$export($a0b3c3363ace277a$exports, "tile", () => $a0b3c3363ace277a$export$3c17558da18e4d75, (v) => $a0b3c3363ace277a$export$3c17558da18e4d75 = v);
$parcel$export($a0b3c3363ace277a$exports, "weapons-tab", () => $a0b3c3363ace277a$export$143c4ee2dac37eb5, (v) => $a0b3c3363ace277a$export$143c4ee2dac37eb5 = v);
var $a0b3c3363ace277a$export$136fd86de524d3c2;
var $a0b3c3363ace277a$export$5c452ff88e35e47d;
var $a0b3c3363ace277a$export$a80b3bd66acc52ff;
var $a0b3c3363ace277a$export$8837f4fc672e936d;
var $a0b3c3363ace277a$export$b5cac684278fae13;
var $a0b3c3363ace277a$export$1fbfc406395df0a;
var $a0b3c3363ace277a$export$d90250155de6d7e7;
var $a0b3c3363ace277a$export$6f093cfa640b7166;
var $a0b3c3363ace277a$export$3c17558da18e4d75;
var $a0b3c3363ace277a$export$143c4ee2dac37eb5;
$a0b3c3363ace277a$export$136fd86de524d3c2 = `Soz96q_bg`;
$a0b3c3363ace277a$export$5c452ff88e35e47d = `Soz96q_image`;
$a0b3c3363ace277a$export$a80b3bd66acc52ff = `Soz96q_info`;
$a0b3c3363ace277a$export$8837f4fc672e936d = `Soz96q_list`;
$a0b3c3363ace277a$export$b5cac684278fae13 = `Soz96q_locked`;
$a0b3c3363ace277a$export$1fbfc406395df0a = `Soz96q_multi-button`;
$a0b3c3363ace277a$export$d90250155de6d7e7 = `Soz96q_selected`;
$a0b3c3363ace277a$export$6f093cfa640b7166 = `Soz96q_text`;
$a0b3c3363ace277a$export$3c17558da18e4d75 = `Soz96q_tile`;
$a0b3c3363ace277a$export$143c4ee2dac37eb5 = `Soz96q_weapons-tab`;


const $c02e0df7b74ab84e$var$COLOR_CACHE = {};
const $c02e0df7b74ab84e$export$81df28fe2aa19ff1 = ({ className: className, ...props })=>{
    const { state: { accountInfo: accountInfo } } = (0, $c25623cc446ec3c6$export$ac8576a9912be18c)();
    const [showBuyOrUpgrade, setShowBuyOrUpgrade] = (0, $acw62.useState)(false);
    const [data, setData] = (0, $acw62.useState)();
    const [selectedName, setSelectedName] = (0, $acw62.useState)();
    (0, $acw62.useEffect)(()=>{
        (0, $8e7f75257467a1e7$export$efa13fcf93ec313a)().then(setData);
    }, []);
    const onTileClick = (name)=>{
        setSelectedName(name);
        setShowBuyOrUpgrade(true);
    };
    const colorToFilter = (color)=>{
        if (!$c02e0df7b74ab84e$var$COLOR_CACHE[color]) $c02e0df7b74ab84e$var$COLOR_CACHE[color] = (0, (/*@__PURE__*/$parcel$interopDefault($46d5a9f991de27f2$exports))).hexToFilter(color).color ?? "none";
        return $c02e0df7b74ab84e$var$COLOR_CACHE[color];
    };
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: (0, $9805619f03ed02ef$export$91884aa883243770)((0, (/*@__PURE__*/$parcel$interopDefault($a0b3c3363ace277a$exports))), `weapons-tab reveal-element ${className}`),
                ...props,
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                    className: (0, $9805619f03ed02ef$export$91884aa883243770)((0, (/*@__PURE__*/$parcel$interopDefault($a0b3c3363ace277a$exports))), "list"),
                    children: Object.entries(data ?? {}).sort(([, a], [, b])=>a.order - b.order)//.sort(([, a], [, b]) => a.levels[0].priceToUnlock.gems - b.levels[0].priceToUnlock.gems)
                    .filter(([name, entry])=>!entry.availableFrom || accountInfo?.character.weapons.unlocked[name] !== undefined || !entry.hiddenInShop && Date.now() >= entry.availableFrom && Date.now() <= (entry.availableTo ?? 0)).map(([name, weapon])=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                            className: (0, $9805619f03ed02ef$export$91884aa883243770)((0, (/*@__PURE__*/$parcel$interopDefault($a0b3c3363ace277a$exports))), "tile"),
                            onClick: ()=>onTileClick(name),
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                    className: (0, $9805619f03ed02ef$export$91884aa883243770)((0, (/*@__PURE__*/$parcel$interopDefault($a0b3c3363ace277a$exports))), "bg"),
                                    style: {
                                        filter: `brightness(0) saturate(100%) ${colorToFilter(weapon.backgroundColor)}` ?? "none"
                                    }
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                    className: (0, $9805619f03ed02ef$export$91884aa883243770)((0, (/*@__PURE__*/$parcel$interopDefault($a0b3c3363ace277a$exports))), "image"),
                                    style: {
                                        backgroundImage: `url('${(0, $0426e2dd5e0de94d$export$24af3971dd36b33f)}/ui/weapons/${name.toLowerCase()}.png')`
                                    }
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                    className: (0, $9805619f03ed02ef$export$91884aa883243770)((0, (/*@__PURE__*/$parcel$interopDefault($a0b3c3363ace277a$exports))), "info"),
                                    children: accountInfo?.character.weapons.unlocked[name] === undefined ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                                                src: `${(0, $0426e2dd5e0de94d$export$24af3971dd36b33f)}/ui/gem.png`,
                                                alt: "gem"
                                            }),
                                            weapon.levels[0].priceToUnlock.gems
                                        ]
                                    }) : accountInfo?.character.weapons.equiped === name && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                                        src: `${(0, $0426e2dd5e0de94d$export$24af3971dd36b33f)}/ui/check.png`,
                                        alt: "check"
                                    })
                                })
                            ]
                        }, name))
                })
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $91ad28735b1958ee$export$848c2f7384932dba), {
                show: showBuyOrUpgrade,
                onExited: ()=>{
                    setSelectedName(undefined);
                },
                onClose: ()=>setShowBuyOrUpgrade(false),
                name: selectedName,
                data: data
            })
        ]
    });
};


const $eb5fda4e7ad93e80$export$150cf13f95deb6c = ({ className: className, ...props })=>{
    const [tab, setTab] = (0, $acw62.useState)("stats");
    const { state: { accountInfo: accountInfo } } = (0, $c25623cc446ec3c6$export$ac8576a9912be18c)();
    //const [loading, setLoading] = useState(false)
    const [spinePlayer, setSpinePlayer] = (0, $acw62.useState)();
    (0, $acw62.useEffect)(()=>{
        if (!spinePlayer) (0, $e16030e48e62d804$export$ce8e199cc2716d76)(0, "character_player-container", {
            FUR: accountInfo?.character.cosmetics.FUR.equiped,
            EYES: accountInfo?.character.cosmetics.EYES.equiped,
            HEAD: accountInfo?.character.cosmetics.HEAD.equiped,
            TOP: accountInfo?.character.cosmetics.TOP.equiped,
            MOUTH: accountInfo?.character.cosmetics.MOUTH.equiped
        }).then(setSpinePlayer);
        else (0, $e16030e48e62d804$export$3bd44b7bc70cd0eb)(spinePlayer, {
            FUR: accountInfo?.character.cosmetics.FUR.equiped,
            EYES: accountInfo?.character.cosmetics.EYES.equiped,
            HEAD: accountInfo?.character.cosmetics.HEAD.equiped,
            TOP: accountInfo?.character.cosmetics.TOP.equiped,
            MOUTH: accountInfo?.character.cosmetics.MOUTH.equiped
        });
    }, [
        accountInfo,
        spinePlayer,
        tab
    ]);
    (0, $acw62.useEffect)(()=>{
        if ((0, $b3b1baf40467424d$export$745043c7dc65e495).refreshAccountInfo) (0, $b3b1baf40467424d$export$745043c7dc65e495).refreshAccountInfo();
    }, []);
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: (0, $9805619f03ed02ef$export$91884aa883243770)((0, (/*@__PURE__*/$parcel$interopDefault($bb489d0c93d49add$exports))), `character-tab ${className}`),
        ...props,
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $d476126f9afdc959$export$668799e4797757a8), {
                className: "high"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: (0, $9805619f03ed02ef$export$91884aa883243770)((0, (/*@__PURE__*/$parcel$interopDefault($bb489d0c93d49add$exports))), "character"),
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        className: (0, $9805619f03ed02ef$export$91884aa883243770)((0, (/*@__PURE__*/$parcel$interopDefault($bb489d0c93d49add$exports))), "title"),
                        children: "Character"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: (0, $9805619f03ed02ef$export$91884aa883243770)((0, (/*@__PURE__*/$parcel$interopDefault($bb489d0c93d49add$exports))), "container"),
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: (0, $9805619f03ed02ef$export$91884aa883243770)((0, (/*@__PURE__*/$parcel$interopDefault($bb489d0c93d49add$exports))), "tabs"),
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                        className: (0, $9805619f03ed02ef$export$91884aa883243770)((0, (/*@__PURE__*/$parcel$interopDefault($bb489d0c93d49add$exports))), "tab"),
                                        onClick: ()=>{
                                            setTab("stats");
                                        },
                                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $6725244138e0595f$export$353f5b6fc5456de1), {
                                            className: (0, $9805619f03ed02ef$export$91884aa883243770)((0, (/*@__PURE__*/$parcel$interopDefault($bb489d0c93d49add$exports))), `xsmall ${tab === "stats" ? "" : "gray"}`),
                                            children: "STATS"
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                        className: (0, $9805619f03ed02ef$export$91884aa883243770)((0, (/*@__PURE__*/$parcel$interopDefault($bb489d0c93d49add$exports))), "tab"),
                                        onClick: ()=>{
                                            setTab("cosmetics");
                                        },
                                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $6725244138e0595f$export$353f5b6fc5456de1), {
                                            className: (0, $9805619f03ed02ef$export$91884aa883243770)((0, (/*@__PURE__*/$parcel$interopDefault($bb489d0c93d49add$exports))), `xsmall ${tab === "cosmetics" ? "" : "gray"}`),
                                            children: "COSMETICS"
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                        className: (0, $9805619f03ed02ef$export$91884aa883243770)((0, (/*@__PURE__*/$parcel$interopDefault($bb489d0c93d49add$exports))), "tab"),
                                        onClick: ()=>{
                                            setTab("weapons");
                                        },
                                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $6725244138e0595f$export$353f5b6fc5456de1), {
                                            className: (0, $9805619f03ed02ef$export$91884aa883243770)((0, (/*@__PURE__*/$parcel$interopDefault($bb489d0c93d49add$exports))), `xsmall ${tab === "weapons" ? "" : "gray"}`),
                                            children: "WEAPONS"
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                className: (0, $9805619f03ed02ef$export$91884aa883243770)((0, (/*@__PURE__*/$parcel$interopDefault($bb489d0c93d49add$exports))), "player"),
                                id: "character_player-container"
                            }),
                            tab === "stats" && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $2172b79dca601800$export$6e7ed12337047155), {}),
                            tab === "cosmetics" && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $ea5def17c57022f1$export$6abe2cec88142692), {
                                spinePlayer: spinePlayer
                            }),
                            tab === "weapons" && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $c02e0df7b74ab84e$export$81df28fe2aa19ff1), {})
                        ]
                    })
                ]
            })
        ]
    });
};





var $acw62 = parcelRequire("acw62");

var $ftY1i = parcelRequire("ftY1i");







var $7ca4f3c5cadce429$exports = {};

$parcel$export($7ca4f3c5cadce429$exports, "clash", () => $7ca4f3c5cadce429$export$bf443b6d1a33b62f, (v) => $7ca4f3c5cadce429$export$bf443b6d1a33b62f = v);
$parcel$export($7ca4f3c5cadce429$exports, "clash-tab", () => $7ca4f3c5cadce429$export$b4bd47c6fd067dfa, (v) => $7ca4f3c5cadce429$export$b4bd47c6fd067dfa = v);
$parcel$export($7ca4f3c5cadce429$exports, "clubs", () => $7ca4f3c5cadce429$export$5cab4cd5716b83f4, (v) => $7ca4f3c5cadce429$export$5cab4cd5716b83f4 = v);
$parcel$export($7ca4f3c5cadce429$exports, "clubs-top", () => $7ca4f3c5cadce429$export$3eb7ad5778409588, (v) => $7ca4f3c5cadce429$export$3eb7ad5778409588 = v);
$parcel$export($7ca4f3c5cadce429$exports, "container", () => $7ca4f3c5cadce429$export$34e0f9847d4c02dd, (v) => $7ca4f3c5cadce429$export$34e0f9847d4c02dd = v);
$parcel$export($7ca4f3c5cadce429$exports, "countdown", () => $7ca4f3c5cadce429$export$f52e29715bba3529, (v) => $7ca4f3c5cadce429$export$f52e29715bba3529 = v);
$parcel$export($7ca4f3c5cadce429$exports, "countdown-container", () => $7ca4f3c5cadce429$export$1ccce14e4eff5b22, (v) => $7ca4f3c5cadce429$export$1ccce14e4eff5b22 = v);
$parcel$export($7ca4f3c5cadce429$exports, "daily-rewards-modal", () => $7ca4f3c5cadce429$export$6c44c86c3f21c8a7, (v) => $7ca4f3c5cadce429$export$6c44c86c3f21c8a7 = v);
$parcel$export($7ca4f3c5cadce429$exports, "first", () => $7ca4f3c5cadce429$export$43128fadae87b74a, (v) => $7ca4f3c5cadce429$export$43128fadae87b74a = v);
$parcel$export($7ca4f3c5cadce429$exports, "icon", () => $7ca4f3c5cadce429$export$1ca1ec8b29a4ce27, (v) => $7ca4f3c5cadce429$export$1ca1ec8b29a4ce27 = v);
$parcel$export($7ca4f3c5cadce429$exports, "image", () => $7ca4f3c5cadce429$export$5c452ff88e35e47d, (v) => $7ca4f3c5cadce429$export$5c452ff88e35e47d = v);
$parcel$export($7ca4f3c5cadce429$exports, "name", () => $7ca4f3c5cadce429$export$a8ff84c12d48cfa6, (v) => $7ca4f3c5cadce429$export$a8ff84c12d48cfa6 = v);
$parcel$export($7ca4f3c5cadce429$exports, "no-clash", () => $7ca4f3c5cadce429$export$1483bfcd739de95b, (v) => $7ca4f3c5cadce429$export$1483bfcd739de95b = v);
$parcel$export($7ca4f3c5cadce429$exports, "overlay-button", () => $7ca4f3c5cadce429$export$75ebd1fc3d1477a8, (v) => $7ca4f3c5cadce429$export$75ebd1fc3d1477a8 = v);
$parcel$export($7ca4f3c5cadce429$exports, "player", () => $7ca4f3c5cadce429$export$615455393ee443ca, (v) => $7ca4f3c5cadce429$export$615455393ee443ca = v);
$parcel$export($7ca4f3c5cadce429$exports, "rewards", () => $7ca4f3c5cadce429$export$4b2cb815b21f438d, (v) => $7ca4f3c5cadce429$export$4b2cb815b21f438d = v);
$parcel$export($7ca4f3c5cadce429$exports, "score", () => $7ca4f3c5cadce429$export$e55b6242cf16bbb8, (v) => $7ca4f3c5cadce429$export$e55b6242cf16bbb8 = v);
$parcel$export($7ca4f3c5cadce429$exports, "second", () => $7ca4f3c5cadce429$export$3d3c77ce7df7d30d, (v) => $7ca4f3c5cadce429$export$3d3c77ce7df7d30d = v);
$parcel$export($7ca4f3c5cadce429$exports, "show-all", () => $7ca4f3c5cadce429$export$d0c61ea8e6818370, (v) => $7ca4f3c5cadce429$export$d0c61ea8e6818370 = v);
$parcel$export($7ca4f3c5cadce429$exports, "sub-title", () => $7ca4f3c5cadce429$export$b77c95dbff56e254, (v) => $7ca4f3c5cadce429$export$b77c95dbff56e254 = v);
$parcel$export($7ca4f3c5cadce429$exports, "tab", () => $7ca4f3c5cadce429$export$62d58b1c91e8e902, (v) => $7ca4f3c5cadce429$export$62d58b1c91e8e902 = v);
$parcel$export($7ca4f3c5cadce429$exports, "tabs", () => $7ca4f3c5cadce429$export$39f5674517ec0000, (v) => $7ca4f3c5cadce429$export$39f5674517ec0000 = v);
$parcel$export($7ca4f3c5cadce429$exports, "third", () => $7ca4f3c5cadce429$export$1fa4a8860392dfdb, (v) => $7ca4f3c5cadce429$export$1fa4a8860392dfdb = v);
$parcel$export($7ca4f3c5cadce429$exports, "title", () => $7ca4f3c5cadce429$export$fb184b623420d9be, (v) => $7ca4f3c5cadce429$export$fb184b623420d9be = v);
$parcel$export($7ca4f3c5cadce429$exports, "up", () => $7ca4f3c5cadce429$export$e1f445cd6eeea85e, (v) => $7ca4f3c5cadce429$export$e1f445cd6eeea85e = v);
var $7ca4f3c5cadce429$export$bf443b6d1a33b62f;
var $7ca4f3c5cadce429$export$b4bd47c6fd067dfa;
var $7ca4f3c5cadce429$export$5cab4cd5716b83f4;
var $7ca4f3c5cadce429$export$3eb7ad5778409588;
var $7ca4f3c5cadce429$export$34e0f9847d4c02dd;
var $7ca4f3c5cadce429$export$f52e29715bba3529;
var $7ca4f3c5cadce429$export$1ccce14e4eff5b22;
var $7ca4f3c5cadce429$export$6c44c86c3f21c8a7;
var $7ca4f3c5cadce429$export$43128fadae87b74a;
var $7ca4f3c5cadce429$export$1ca1ec8b29a4ce27;
var $7ca4f3c5cadce429$export$5c452ff88e35e47d;
var $7ca4f3c5cadce429$export$a8ff84c12d48cfa6;
var $7ca4f3c5cadce429$export$1483bfcd739de95b;
var $7ca4f3c5cadce429$export$75ebd1fc3d1477a8;
var $7ca4f3c5cadce429$export$615455393ee443ca;
var $7ca4f3c5cadce429$export$4b2cb815b21f438d;
var $7ca4f3c5cadce429$export$e55b6242cf16bbb8;
var $7ca4f3c5cadce429$export$3d3c77ce7df7d30d;
var $7ca4f3c5cadce429$export$d0c61ea8e6818370;
var $7ca4f3c5cadce429$export$b77c95dbff56e254;
var $7ca4f3c5cadce429$export$62d58b1c91e8e902;
var $7ca4f3c5cadce429$export$39f5674517ec0000;
var $7ca4f3c5cadce429$export$1fa4a8860392dfdb;
var $7ca4f3c5cadce429$export$fb184b623420d9be;
var $7ca4f3c5cadce429$export$e1f445cd6eeea85e;
$7ca4f3c5cadce429$export$bf443b6d1a33b62f = `tH0mnG_clash`;
$7ca4f3c5cadce429$export$b4bd47c6fd067dfa = `tH0mnG_clash-tab`;
$7ca4f3c5cadce429$export$5cab4cd5716b83f4 = `tH0mnG_clubs`;
$7ca4f3c5cadce429$export$3eb7ad5778409588 = `tH0mnG_clubs-top`;
$7ca4f3c5cadce429$export$34e0f9847d4c02dd = `tH0mnG_container`;
$7ca4f3c5cadce429$export$f52e29715bba3529 = `tH0mnG_countdown`;
$7ca4f3c5cadce429$export$1ccce14e4eff5b22 = `tH0mnG_countdown-container`;
$7ca4f3c5cadce429$export$6c44c86c3f21c8a7 = `tH0mnG_daily-rewards-modal`;
$7ca4f3c5cadce429$export$43128fadae87b74a = `tH0mnG_first`;
$7ca4f3c5cadce429$export$1ca1ec8b29a4ce27 = `tH0mnG_icon`;
$7ca4f3c5cadce429$export$5c452ff88e35e47d = `tH0mnG_image`;
$7ca4f3c5cadce429$export$a8ff84c12d48cfa6 = `tH0mnG_name`;
$7ca4f3c5cadce429$export$1483bfcd739de95b = `tH0mnG_no-clash`;
$7ca4f3c5cadce429$export$75ebd1fc3d1477a8 = `tH0mnG_overlay-button`;
$7ca4f3c5cadce429$export$615455393ee443ca = `tH0mnG_player`;
$7ca4f3c5cadce429$export$4b2cb815b21f438d = `tH0mnG_rewards`;
$7ca4f3c5cadce429$export$e55b6242cf16bbb8 = `tH0mnG_score`;
$7ca4f3c5cadce429$export$3d3c77ce7df7d30d = `tH0mnG_second`;
$7ca4f3c5cadce429$export$d0c61ea8e6818370 = `tH0mnG_show-all`;
$7ca4f3c5cadce429$export$b77c95dbff56e254 = `tH0mnG_sub-title`;
$7ca4f3c5cadce429$export$62d58b1c91e8e902 = `tH0mnG_tab`;
$7ca4f3c5cadce429$export$39f5674517ec0000 = `tH0mnG_tabs`;
$7ca4f3c5cadce429$export$1fa4a8860392dfdb = `tH0mnG_third`;
$7ca4f3c5cadce429$export$fb184b623420d9be = `tH0mnG_title`;
$7ca4f3c5cadce429$export$e1f445cd6eeea85e = `tH0mnG_up`;



parcelRequire("acw62");

var $a370fc64f7fe72da$exports = {};

$parcel$export($a370fc64f7fe72da$exports, "club-entry", () => $a370fc64f7fe72da$export$73dd20a715c0acd6, (v) => $a370fc64f7fe72da$export$73dd20a715c0acd6 = v);
$parcel$export($a370fc64f7fe72da$exports, "details", () => $a370fc64f7fe72da$export$41ee12f6f6f05843, (v) => $a370fc64f7fe72da$export$41ee12f6f6f05843 = v);
$parcel$export($a370fc64f7fe72da$exports, "disabled", () => $a370fc64f7fe72da$export$683472f6198a076e, (v) => $a370fc64f7fe72da$export$683472f6198a076e = v);
$parcel$export($a370fc64f7fe72da$exports, "members", () => $a370fc64f7fe72da$export$100ad4af8c8d544f, (v) => $a370fc64f7fe72da$export$100ad4af8c8d544f = v);
$parcel$export($a370fc64f7fe72da$exports, "name", () => $a370fc64f7fe72da$export$a8ff84c12d48cfa6, (v) => $a370fc64f7fe72da$export$a8ff84c12d48cfa6 = v);
$parcel$export($a370fc64f7fe72da$exports, "selected", () => $a370fc64f7fe72da$export$d90250155de6d7e7, (v) => $a370fc64f7fe72da$export$d90250155de6d7e7 = v);
$parcel$export($a370fc64f7fe72da$exports, "transparent", () => $a370fc64f7fe72da$export$f4d082c200a4b4b8, (v) => $a370fc64f7fe72da$export$f4d082c200a4b4b8 = v);
var $a370fc64f7fe72da$export$73dd20a715c0acd6;
var $a370fc64f7fe72da$export$41ee12f6f6f05843;
var $a370fc64f7fe72da$export$683472f6198a076e;
var $a370fc64f7fe72da$export$100ad4af8c8d544f;
var $a370fc64f7fe72da$export$a8ff84c12d48cfa6;
var $a370fc64f7fe72da$export$d90250155de6d7e7;
var $a370fc64f7fe72da$export$f4d082c200a4b4b8;
$a370fc64f7fe72da$export$73dd20a715c0acd6 = `GmjSwW_club-entry`;
$a370fc64f7fe72da$export$41ee12f6f6f05843 = `GmjSwW_details`;
$a370fc64f7fe72da$export$683472f6198a076e = `GmjSwW_disabled`;
$a370fc64f7fe72da$export$100ad4af8c8d544f = `GmjSwW_members`;
$a370fc64f7fe72da$export$a8ff84c12d48cfa6 = `GmjSwW_name`;
$a370fc64f7fe72da$export$d90250155de6d7e7 = `GmjSwW_selected`;
$a370fc64f7fe72da$export$f4d082c200a4b4b8 = `GmjSwW_transparent`;


const $cf57aac21455785a$export$b5c66cbe436b19d9 = ({ className: className, club: club, clubId: clubId, score: score, onSelectClub: onSelectClub, ...props })=>{
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
        ...props,
        className: (0, $9805619f03ed02ef$export$91884aa883243770)((0, (/*@__PURE__*/$parcel$interopDefault($a370fc64f7fe72da$exports))), `club-entry ${className}`),
        onClick: ()=>onSelectClub && onSelectClub(club, clubId),
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
            className: (0, $9805619f03ed02ef$export$91884aa883243770)((0, (/*@__PURE__*/$parcel$interopDefault($a370fc64f7fe72da$exports))), "details"),
            children: [
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                    src: club.imageURL,
                    alt: club.name
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                    className: (0, $9805619f03ed02ef$export$91884aa883243770)((0, (/*@__PURE__*/$parcel$interopDefault($a370fc64f7fe72da$exports))), "name"),
                    children: club.name
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                    className: (0, $9805619f03ed02ef$export$91884aa883243770)((0, (/*@__PURE__*/$parcel$interopDefault($a370fc64f7fe72da$exports))), "members"),
                    children: [
                        club.members,
                        " members",
                        score !== undefined && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                            children: [
                                " / ",
                                score,
                                " points"
                            ]
                        })
                    ]
                })
            ]
        })
    });
};





var $acw62 = parcelRequire("acw62");





var $f1e26fea7abd1bae$exports = {};

$parcel$export($f1e26fea7abd1bae$exports, "club", () => $f1e26fea7abd1bae$export$4015171ff2082aa2, (v) => $f1e26fea7abd1bae$export$4015171ff2082aa2 = v);
$parcel$export($f1e26fea7abd1bae$exports, "confirm-club", () => $f1e26fea7abd1bae$export$7c50a8c01775315, (v) => $f1e26fea7abd1bae$export$7c50a8c01775315 = v);
$parcel$export($f1e26fea7abd1bae$exports, "content", () => $f1e26fea7abd1bae$export$a7db06668cad9adb, (v) => $f1e26fea7abd1bae$export$a7db06668cad9adb = v);
$parcel$export($f1e26fea7abd1bae$exports, "gems", () => $f1e26fea7abd1bae$export$b7dcc03c39461775, (v) => $f1e26fea7abd1bae$export$b7dcc03c39461775 = v);
$parcel$export($f1e26fea7abd1bae$exports, "text", () => $f1e26fea7abd1bae$export$6f093cfa640b7166, (v) => $f1e26fea7abd1bae$export$6f093cfa640b7166 = v);
$parcel$export($f1e26fea7abd1bae$exports, "title", () => $f1e26fea7abd1bae$export$fb184b623420d9be, (v) => $f1e26fea7abd1bae$export$fb184b623420d9be = v);
var $f1e26fea7abd1bae$export$4015171ff2082aa2;
var $f1e26fea7abd1bae$export$7c50a8c01775315;
var $f1e26fea7abd1bae$export$a7db06668cad9adb;
var $f1e26fea7abd1bae$export$b7dcc03c39461775;
var $f1e26fea7abd1bae$export$6f093cfa640b7166;
var $f1e26fea7abd1bae$export$fb184b623420d9be;
$f1e26fea7abd1bae$export$4015171ff2082aa2 = `_3efy1G_club`;
$f1e26fea7abd1bae$export$7c50a8c01775315 = `_3efy1G_confirm-club`;
$f1e26fea7abd1bae$export$a7db06668cad9adb = `_3efy1G_content`;
$f1e26fea7abd1bae$export$b7dcc03c39461775 = `_3efy1G_gems`;
$f1e26fea7abd1bae$export$6f093cfa640b7166 = `_3efy1G_text`;
$f1e26fea7abd1bae$export$fb184b623420d9be = `_3efy1G_title`;


const $4150806023a08153$var$Content = ({ onClose: onClose })=>{
    const [loading, setLoading] = (0, $acw62.useState)(false);
    const confirmClub = async ()=>{
        setLoading(true);
        const result = await (0, $35a528e84618b070$export$d26d4d6ef5001f3a)();
        if (result?.status === 200 && (0, $b3b1baf40467424d$export$745043c7dc65e495).refreshAccountInfo) (0, $b3b1baf40467424d$export$745043c7dc65e495).refreshAccountInfo();
        onClose();
        setLoading(false);
    };
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
        className: (0, $9805619f03ed02ef$export$91884aa883243770)((0, (/*@__PURE__*/$parcel$interopDefault($f1e26fea7abd1bae$exports))), "content"),
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $6725244138e0595f$export$353f5b6fc5456de1), {
            className: (0, $9805619f03ed02ef$export$91884aa883243770)((0, (/*@__PURE__*/$parcel$interopDefault($f1e26fea7abd1bae$exports))), "blue"),
            onClick: confirmClub,
            loading: loading,
            children: "Sign Up"
        })
    });
};
const $4150806023a08153$var$Title = ({ onClose: onClose })=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: (0, $9805619f03ed02ef$export$91884aa883243770)((0, (/*@__PURE__*/$parcel$interopDefault($f1e26fea7abd1bae$exports))), "title"),
        children: [
            "Participate in Atlas Clash",
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                src: `${(0, $0426e2dd5e0de94d$export$24af3971dd36b33f)}/ui/cross.png`,
                alt: "cross",
                onClick: onClose
            })
        ]
    });
const $4150806023a08153$export$ef429fde88b17151 = ({ className: className, onClose: onClose, show: show, ...props })=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $207d23274fe2be11$export$6e63c1000ecf9db8), {
        className: (0, $9805619f03ed02ef$export$91884aa883243770)((0, (/*@__PURE__*/$parcel$interopDefault($f1e26fea7abd1bae$exports))), `confirm-club ${className}`),
        title: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($4150806023a08153$var$Title, {
            onClose: onClose
        }),
        content: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($4150806023a08153$var$Content, {
            onClose: onClose
        }),
        onClickBackground: onClose,
        show: show,
        ...props
    });




parcelRequire("acw62");



var $0176aa4989915d7e$exports = {};

$parcel$export($0176aa4989915d7e$exports, "about-tab", () => $0176aa4989915d7e$export$faa5899c61437a1a, (v) => $0176aa4989915d7e$export$faa5899c61437a1a = v);
$parcel$export($0176aa4989915d7e$exports, "prizes", () => $0176aa4989915d7e$export$3558f0d45079635e, (v) => $0176aa4989915d7e$export$3558f0d45079635e = v);
$parcel$export($0176aa4989915d7e$exports, "prizes-title", () => $0176aa4989915d7e$export$e5a15510c3f672b7, (v) => $0176aa4989915d7e$export$e5a15510c3f672b7 = v);
$parcel$export($0176aa4989915d7e$exports, "tba", () => $0176aa4989915d7e$export$1542772de6bcce3a, (v) => $0176aa4989915d7e$export$1542772de6bcce3a = v);
var $0176aa4989915d7e$export$faa5899c61437a1a;
var $0176aa4989915d7e$export$3558f0d45079635e;
var $0176aa4989915d7e$export$e5a15510c3f672b7;
var $0176aa4989915d7e$export$1542772de6bcce3a;
$0176aa4989915d7e$export$faa5899c61437a1a = `Fl4RFq_about-tab`;
$0176aa4989915d7e$export$3558f0d45079635e = `Fl4RFq_prizes`;
$0176aa4989915d7e$export$e5a15510c3f672b7 = `Fl4RFq_prizes-title`;
$0176aa4989915d7e$export$1542772de6bcce3a = `Fl4RFq_tba`;


const $43ae8e3303d8e0e7$export$eaffb7469d102331 = ({ className: className, rewards: rewards, ...props })=>{
    const openPrizeDistribution = ()=>{
        if ((0, $b3b1baf40467424d$export$745043c7dc65e495).showModal) (0, $b3b1baf40467424d$export$745043c7dc65e495).showModal({
            title: "Prize distribution",
            text: "Prizes below will be distributed randomly to the top 50% of performers on the winning Club. All winning Club members will receive the Star Atlas Gun."
        });
    };
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: (0, $9805619f03ed02ef$export$91884aa883243770)((0, (/*@__PURE__*/$parcel$interopDefault($0176aa4989915d7e$exports))), `about-tab reveal-element ${className}`),
        ...props,
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: (0, $9805619f03ed02ef$export$91884aa883243770)((0, (/*@__PURE__*/$parcel$interopDefault($0176aa4989915d7e$exports))), "prizes-title"),
                children: [
                    "Prizes ",
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $e4ec753f5c716375$export$2b9260d4a45c8710), {
                        icon: "circle-question",
                        onClick: openPrizeDistribution
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $917136c90b9e1944$export$b58f7d8ba025fac7), {
                flipped: true,
                className: (0, $9805619f03ed02ef$export$91884aa883243770)((0, (/*@__PURE__*/$parcel$interopDefault($0176aa4989915d7e$exports))), "big prizes absolute"),
                rewards: rewards
            })
        ]
    });
};



parcelRequire("acw62");

const $96fee590aab2642b$export$18ad4f09da04481c = (num, digits)=>{
    const lookup = [
        {
            value: 1,
            symbol: ""
        },
        {
            value: 1e3,
            symbol: "k"
        },
        {
            value: 1e6,
            symbol: "M"
        },
        {
            value: 1e9,
            symbol: "G"
        },
        {
            value: 1e12,
            symbol: "T"
        },
        {
            value: 1e15,
            symbol: "P"
        },
        {
            value: 1e18,
            symbol: "E"
        }
    ];
    const regexp = /\.0+$|(?<=\.[0-9]*[1-9])0+$/;
    const item = lookup.findLast((item)=>num >= item.value);
    return item ? (num / item.value).toFixed(digits).replace(regexp, "").concat(item.symbol) : "0";
};



var $3d15eb5ccbc6516a$exports = {};

$parcel$export($3d15eb5ccbc6516a$exports, "bg", () => $3d15eb5ccbc6516a$export$136fd86de524d3c2, (v) => $3d15eb5ccbc6516a$export$136fd86de524d3c2 = v);
$parcel$export($3d15eb5ccbc6516a$exports, "club", () => $3d15eb5ccbc6516a$export$4015171ff2082aa2, (v) => $3d15eb5ccbc6516a$export$4015171ff2082aa2 = v);
$parcel$export($3d15eb5ccbc6516a$exports, "entry", () => $3d15eb5ccbc6516a$export$c407db72103fecfa, (v) => $3d15eb5ccbc6516a$export$c407db72103fecfa = v);
$parcel$export($3d15eb5ccbc6516a$exports, "first", () => $3d15eb5ccbc6516a$export$43128fadae87b74a, (v) => $3d15eb5ccbc6516a$export$43128fadae87b74a = v);
$parcel$export($3d15eb5ccbc6516a$exports, "info", () => $3d15eb5ccbc6516a$export$a80b3bd66acc52ff, (v) => $3d15eb5ccbc6516a$export$a80b3bd66acc52ff = v);
$parcel$export($3d15eb5ccbc6516a$exports, "key", () => $3d15eb5ccbc6516a$export$df61b30b684217c0, (v) => $3d15eb5ccbc6516a$export$df61b30b684217c0 = v);
$parcel$export($3d15eb5ccbc6516a$exports, "leaderboard-tab", () => $3d15eb5ccbc6516a$export$bbb4cc57afa5c50f, (v) => $3d15eb5ccbc6516a$export$bbb4cc57afa5c50f = v);
$parcel$export($3d15eb5ccbc6516a$exports, "list", () => $3d15eb5ccbc6516a$export$8837f4fc672e936d, (v) => $3d15eb5ccbc6516a$export$8837f4fc672e936d = v);
$parcel$export($3d15eb5ccbc6516a$exports, "list-container", () => $3d15eb5ccbc6516a$export$9b732d716e8660cd, (v) => $3d15eb5ccbc6516a$export$9b732d716e8660cd = v);
$parcel$export($3d15eb5ccbc6516a$exports, "loader", () => $3d15eb5ccbc6516a$export$f4c5de44377d2946, (v) => $3d15eb5ccbc6516a$export$f4c5de44377d2946 = v);
$parcel$export($3d15eb5ccbc6516a$exports, "my", () => $3d15eb5ccbc6516a$export$94fa0a6beb22f989, (v) => $3d15eb5ccbc6516a$export$94fa0a6beb22f989 = v);
$parcel$export($3d15eb5ccbc6516a$exports, "rank", () => $3d15eb5ccbc6516a$export$fbc8bcd33b574fbc, (v) => $3d15eb5ccbc6516a$export$fbc8bcd33b574fbc = v);
$parcel$export($3d15eb5ccbc6516a$exports, "second", () => $3d15eb5ccbc6516a$export$3d3c77ce7df7d30d, (v) => $3d15eb5ccbc6516a$export$3d3c77ce7df7d30d = v);
$parcel$export($3d15eb5ccbc6516a$exports, "third", () => $3d15eb5ccbc6516a$export$1fa4a8860392dfdb, (v) => $3d15eb5ccbc6516a$export$1fa4a8860392dfdb = v);
$parcel$export($3d15eb5ccbc6516a$exports, "violet", () => $3d15eb5ccbc6516a$export$8241b7126941c403, (v) => $3d15eb5ccbc6516a$export$8241b7126941c403 = v);
var $3d15eb5ccbc6516a$export$136fd86de524d3c2;
var $3d15eb5ccbc6516a$export$4015171ff2082aa2;
var $3d15eb5ccbc6516a$export$c407db72103fecfa;
var $3d15eb5ccbc6516a$export$43128fadae87b74a;
var $3d15eb5ccbc6516a$export$a80b3bd66acc52ff;
var $3d15eb5ccbc6516a$export$df61b30b684217c0;
var $3d15eb5ccbc6516a$export$bbb4cc57afa5c50f;
var $3d15eb5ccbc6516a$export$8837f4fc672e936d;
var $3d15eb5ccbc6516a$export$9b732d716e8660cd;
var $3d15eb5ccbc6516a$export$f4c5de44377d2946;
var $3d15eb5ccbc6516a$export$94fa0a6beb22f989;
var $3d15eb5ccbc6516a$export$fbc8bcd33b574fbc;
var $3d15eb5ccbc6516a$export$3d3c77ce7df7d30d;
var $3d15eb5ccbc6516a$export$1fa4a8860392dfdb;
var $3d15eb5ccbc6516a$export$8241b7126941c403;
$3d15eb5ccbc6516a$export$136fd86de524d3c2 = `EE-BVa_bg`;
$3d15eb5ccbc6516a$export$4015171ff2082aa2 = `EE-BVa_club`;
$3d15eb5ccbc6516a$export$c407db72103fecfa = `EE-BVa_entry`;
$3d15eb5ccbc6516a$export$43128fadae87b74a = `EE-BVa_first`;
$3d15eb5ccbc6516a$export$a80b3bd66acc52ff = `EE-BVa_info`;
$3d15eb5ccbc6516a$export$df61b30b684217c0 = `EE-BVa_key`;
$3d15eb5ccbc6516a$export$bbb4cc57afa5c50f = `EE-BVa_leaderboard-tab`;
$3d15eb5ccbc6516a$export$8837f4fc672e936d = `EE-BVa_list`;
$3d15eb5ccbc6516a$export$9b732d716e8660cd = `EE-BVa_list-container`;
$3d15eb5ccbc6516a$export$f4c5de44377d2946 = `EE-BVa_loader`;
$3d15eb5ccbc6516a$export$94fa0a6beb22f989 = `EE-BVa_my`;
$3d15eb5ccbc6516a$export$fbc8bcd33b574fbc = `EE-BVa_rank`;
$3d15eb5ccbc6516a$export$3d3c77ce7df7d30d = `EE-BVa_second`;
$3d15eb5ccbc6516a$export$1fa4a8860392dfdb = `EE-BVa_third`;
$3d15eb5ccbc6516a$export$8241b7126941c403 = `EE-BVa_violet`;


const $9f22486bd66a45a1$export$f3fb70d565ab13b3 = ({ className: className, clubClash: clubClash, stats: stats, ...props })=>{
    const { state: { accountInfo: accountInfo } } = (0, $c25623cc446ec3c6$export$ac8576a9912be18c)();
    const formatRank = (rank)=>{
        if (rank === 1) return "first";
        else if (rank === 2) return "second";
        else if (rank === 3) return "third";
    };
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: (0, $9805619f03ed02ef$export$91884aa883243770)((0, (/*@__PURE__*/$parcel$interopDefault($3d15eb5ccbc6516a$exports))), `leaderboard-tab reveal-element ${className}`),
        ...props,
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: (0, $9805619f03ed02ef$export$91884aa883243770)((0, (/*@__PURE__*/$parcel$interopDefault($3d15eb5ccbc6516a$exports))), "entry my"),
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        className: (0, $9805619f03ed02ef$export$91884aa883243770)((0, (/*@__PURE__*/$parcel$interopDefault($3d15eb5ccbc6516a$exports))), "bg")
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        className: (0, $9805619f03ed02ef$export$91884aa883243770)((0, (/*@__PURE__*/$parcel$interopDefault($3d15eb5ccbc6516a$exports))), `rank ${formatRank(stats?.data?.rank)}`),
                        children: stats?.data?.rank === 0 ? "-" : stats?.data?.rank
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        className: (0, $9805619f03ed02ef$export$91884aa883243770)((0, (/*@__PURE__*/$parcel$interopDefault($3d15eb5ccbc6516a$exports))), "key"),
                        children: "You"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        children: stats?.data?.highestScore === 0 ? "no score" : (0, $96fee590aab2642b$export$18ad4f09da04481c)(stats?.data?.highestScore ?? 0, 2)
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        className: (0, $9805619f03ed02ef$export$91884aa883243770)((0, (/*@__PURE__*/$parcel$interopDefault($3d15eb5ccbc6516a$exports))), "club"),
                        children: accountInfo && accountInfo.clubId !== undefined && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                            src: clubClash.clubs[accountInfo.clubId].imageURL,
                            alt: accountInfo.clubId
                        })
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        className: (0, $9805619f03ed02ef$export$91884aa883243770)((0, (/*@__PURE__*/$parcel$interopDefault($3d15eb5ccbc6516a$exports))), "violet"),
                        children: stats?.data?.highestScore === 0 ? "no score" : (0, $96fee590aab2642b$export$18ad4f09da04481c)(stats?.data?.score ?? 0, 2)
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: (0, $9805619f03ed02ef$export$91884aa883243770)((0, (/*@__PURE__*/$parcel$interopDefault($3d15eb5ccbc6516a$exports))), "list-container"),
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                    className: (0, $9805619f03ed02ef$export$91884aa883243770)((0, (/*@__PURE__*/$parcel$interopDefault($3d15eb5ccbc6516a$exports))), "list"),
                    children: stats ? (stats.data?.top ?? []).map((entry, index)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                            className: (0, $9805619f03ed02ef$export$91884aa883243770)((0, (/*@__PURE__*/$parcel$interopDefault($3d15eb5ccbc6516a$exports))), "entry"),
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                    className: (0, $9805619f03ed02ef$export$91884aa883243770)((0, (/*@__PURE__*/$parcel$interopDefault($3d15eb5ccbc6516a$exports))), "bg")
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                    className: (0, $9805619f03ed02ef$export$91884aa883243770)((0, (/*@__PURE__*/$parcel$interopDefault($3d15eb5ccbc6516a$exports))), `rank ${formatRank(index + 1)}`),
                                    children: index + 1
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                    className: (0, $9805619f03ed02ef$export$91884aa883243770)((0, (/*@__PURE__*/$parcel$interopDefault($3d15eb5ccbc6516a$exports))), "key"),
                                    children: entry.username
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                    children: (0, $96fee590aab2642b$export$18ad4f09da04481c)(entry.highestScore, 2)
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                    className: (0, $9805619f03ed02ef$export$91884aa883243770)((0, (/*@__PURE__*/$parcel$interopDefault($3d15eb5ccbc6516a$exports))), "club"),
                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                                        src: clubClash.clubs[entry.clubId].imageURL,
                                        alt: entry.clubId
                                    })
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                    className: (0, $9805619f03ed02ef$export$91884aa883243770)((0, (/*@__PURE__*/$parcel$interopDefault($3d15eb5ccbc6516a$exports))), "violet"),
                                    children: (0, $96fee590aab2642b$export$18ad4f09da04481c)(entry.score, 2)
                                })
                            ]
                        }, entry.publicKey)) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        className: (0, $9805619f03ed02ef$export$91884aa883243770)((0, (/*@__PURE__*/$parcel$interopDefault($3d15eb5ccbc6516a$exports))), "loader"),
                        children: "Loading..."
                    })
                })
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: (0, $9805619f03ed02ef$export$91884aa883243770)((0, (/*@__PURE__*/$parcel$interopDefault($3d15eb5ccbc6516a$exports))), "info"),
                children: "the leaderboard is computed each minute"
            })
        ]
    });
};


const $698ad062f1347ee3$var$addZeroToNumber = (number)=>number < 10 ? `0${number}` : number;
const $698ad062f1347ee3$var$renderer = ({ days: days, hours: hours, minutes: minutes })=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
        children: [
            $698ad062f1347ee3$var$addZeroToNumber(days),
            "D ",
            $698ad062f1347ee3$var$addZeroToNumber(hours),
            "H ",
            $698ad062f1347ee3$var$addZeroToNumber(minutes),
            "M"
        ]
    });
const $698ad062f1347ee3$export$1ec4af8dfddbc212 = ({ className: className, ...props })=>{
    const { state: { accountInfo: accountInfo, publicKey: publicKey } } = (0, $c25623cc446ec3c6$export$ac8576a9912be18c)();
    const [tab, setTab] = (0, $acw62.useState)("about");
    const [showConfirm, setShowConfirm] = (0, $acw62.useState)(false);
    const [showFullClubList, setShowFullClubList] = (0, $acw62.useState)(false);
    const [showGemsReward, setShowGemsReward] = (0, $acw62.useState)(false);
    const [gemsWon, setGemsWon] = (0, $acw62.useState)(0);
    const [clubClash, setClubClash] = (0, $acw62.useState)();
    const [clubTop, setClubTop] = (0, $acw62.useState)();
    const [rewards, setRewards] = (0, $acw62.useState)([]);
    const [loading, setLoading] = (0, $acw62.useState)(false);
    const [stats, setStats] = (0, $acw62.useState)();
    const refreshClubClash = ()=>{
        setLoading(true);
        (0, $35a528e84618b070$export$1b2baf0c7c665732)().then((response)=>{
            if (response?.status === 200) {
                setClubClash(response.data);
                setRewards([
                    // {
                    //   name: `${(response.data.gems ?? 0)} GEMS`,
                    //   imageURL: 'https://cdn.piratesquadnft.com/clients/oogy-blast/game/visual/ui/gem.png',
                    //   quantity: 1,
                    //   rarity: 'special',
                    //   type: 'generic'
                    // },
                    ...response.data.rewards.map((reward)=>({
                            ...reward,
                            quantity: 1,
                            rarity: "special",
                            type: "generic"
                        }))
                ]);
            }
        }).catch(()=>{
            (0, $ad26fe773541dcd3$export$b410431fab84fa58).error("Impossible to retrieve the club clash info");
        }).finally(()=>{
            setLoading(false);
        });
    };
    (0, $acw62.useEffect)(()=>{
        refreshClubClash();
    }, []);
    (0, $acw62.useEffect)(()=>{
        if (!clubClash) return;
        (0, $35a528e84618b070$export$98b77fd74ac44d44)().then((res)=>{
            setStats(res);
            if (!res) return;
            const clubTop = Object.entries(clubClash.clubs).map(([clubId, data])=>{
                const entries = res.data.top.filter((entry)=>entry.clubId === clubId).sort((a, b)=>b.score - a.score).slice(0, 20);
                return {
                    ...data,
                    clubId: clubId,
                    score: entries.length === 0 ? 0 : entries.reduce((previousValue, entry)=>previousValue + entry.score, 0)
                };
            }).sort((a, b)=>b.score - a.score);
            setClubTop(clubTop);
        }).catch(console.error);
    }, [
        clubClash
    ]);
    (0, $acw62.useEffect)(()=>{
        if (!clubClash || !clubClash.ended || !clubClash.winners) return;
        const found = clubClash.winners.find((winner)=>winner.publicKey === publicKey);
        if (!found) return;
        setGemsWon(found.gems);
        setShowGemsReward(true);
    }, [
        clubClash,
        publicKey
    ]);
    const onParticipate = ()=>{
        if (!accountInfo?.clubId) setShowConfirm(true);
    };
    const clubClashStarted = !!clubClash && clubClash.startingAt < Date.now();
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $d476126f9afdc959$export$668799e4797757a8), {
                className: "high"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: (0, $9805619f03ed02ef$export$91884aa883243770)((0, (/*@__PURE__*/$parcel$interopDefault($7ca4f3c5cadce429$exports))), `clash-tab ${className}`),
                ...props,
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                    className: (0, $9805619f03ed02ef$export$91884aa883243770)((0, (/*@__PURE__*/$parcel$interopDefault($7ca4f3c5cadce429$exports))), "clash"),
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                            className: (0, $9805619f03ed02ef$export$91884aa883243770)((0, (/*@__PURE__*/$parcel$interopDefault($7ca4f3c5cadce429$exports))), "title"),
                            children: [
                                "Club Clash",
                                clubClash && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                    className: (0, $9805619f03ed02ef$export$91884aa883243770)((0, (/*@__PURE__*/$parcel$interopDefault($7ca4f3c5cadce429$exports))), "countdown-container"),
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                                            src: `${(0, $0426e2dd5e0de94d$export$24af3971dd36b33f)}/ui/clock.png`,
                                            alt: "clock"
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                            className: (0, $9805619f03ed02ef$export$91884aa883243770)((0, (/*@__PURE__*/$parcel$interopDefault($7ca4f3c5cadce429$exports))), "countdown"),
                                            children: [
                                                (clubClash.startingAt ?? 0) > Date.now() ? "Starting in" : (clubClash.endingAt ?? 0) > Date.now() ? "Ending in" : "Ended",
                                                !loading && clubClash.endingAt > Date.now() && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $ftY1i.default), {
                                                    date: (clubClash.startingAt ?? 0) > Date.now() ? clubClash.startingAt : clubClash.endingAt,
                                                    renderer: $698ad062f1347ee3$var$renderer,
                                                    onComplete: refreshClubClash
                                                })
                                            ]
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                            className: (0, $9805619f03ed02ef$export$91884aa883243770)((0, (/*@__PURE__*/$parcel$interopDefault($7ca4f3c5cadce429$exports))), "container"),
                            children: clubClash ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                                children: [
                                    !clubClashStarted && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                        className: (0, $9805619f03ed02ef$export$91884aa883243770)((0, (/*@__PURE__*/$parcel$interopDefault($7ca4f3c5cadce429$exports))), "sub-title"),
                                        children: "Club list"
                                    }),
                                    clubClashStarted && !showFullClubList && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                        className: (0, $9805619f03ed02ef$export$91884aa883243770)((0, (/*@__PURE__*/$parcel$interopDefault($7ca4f3c5cadce429$exports))), "clubs-top"),
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                className: (0, $9805619f03ed02ef$export$91884aa883243770)((0, (/*@__PURE__*/$parcel$interopDefault($7ca4f3c5cadce429$exports))), "second"),
                                                children: clubTop?.[1] && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                                                    children: [
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                            className: (0, $9805619f03ed02ef$export$91884aa883243770)((0, (/*@__PURE__*/$parcel$interopDefault($7ca4f3c5cadce429$exports))), "image"),
                                                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                                                                src: clubTop[1].imageURL,
                                                                alt: clubTop[1].name
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                            className: (0, $9805619f03ed02ef$export$91884aa883243770)((0, (/*@__PURE__*/$parcel$interopDefault($7ca4f3c5cadce429$exports))), "name"),
                                                            children: clubTop[1].name
                                                        }),
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                            className: (0, $9805619f03ed02ef$export$91884aa883243770)((0, (/*@__PURE__*/$parcel$interopDefault($7ca4f3c5cadce429$exports))), "score"),
                                                            children: clubTop[1].score
                                                        })
                                                    ]
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                className: (0, $9805619f03ed02ef$export$91884aa883243770)((0, (/*@__PURE__*/$parcel$interopDefault($7ca4f3c5cadce429$exports))), "first"),
                                                children: clubTop?.[0] && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                                                    children: [
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                            className: (0, $9805619f03ed02ef$export$91884aa883243770)((0, (/*@__PURE__*/$parcel$interopDefault($7ca4f3c5cadce429$exports))), "image"),
                                                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                                                                src: clubTop[0].imageURL,
                                                                alt: clubTop[0].name
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                            className: (0, $9805619f03ed02ef$export$91884aa883243770)((0, (/*@__PURE__*/$parcel$interopDefault($7ca4f3c5cadce429$exports))), "name"),
                                                            children: clubTop[0].name
                                                        }),
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                            className: (0, $9805619f03ed02ef$export$91884aa883243770)((0, (/*@__PURE__*/$parcel$interopDefault($7ca4f3c5cadce429$exports))), "score"),
                                                            children: clubTop[0].score
                                                        })
                                                    ]
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                className: (0, $9805619f03ed02ef$export$91884aa883243770)((0, (/*@__PURE__*/$parcel$interopDefault($7ca4f3c5cadce429$exports))), "third"),
                                                children: clubTop?.[2] && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                                                    children: [
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                            className: (0, $9805619f03ed02ef$export$91884aa883243770)((0, (/*@__PURE__*/$parcel$interopDefault($7ca4f3c5cadce429$exports))), "image"),
                                                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                                                                src: clubTop[2].imageURL,
                                                                alt: clubTop[2].name
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                            className: (0, $9805619f03ed02ef$export$91884aa883243770)((0, (/*@__PURE__*/$parcel$interopDefault($7ca4f3c5cadce429$exports))), "name"),
                                                            children: clubTop[2].name
                                                        }),
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                            className: (0, $9805619f03ed02ef$export$91884aa883243770)((0, (/*@__PURE__*/$parcel$interopDefault($7ca4f3c5cadce429$exports))), "score"),
                                                            children: clubTop[2].score
                                                        })
                                                    ]
                                                })
                                            })
                                        ]
                                    }),
                                    (!clubClashStarted || showFullClubList) && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                        className: (0, $9805619f03ed02ef$export$91884aa883243770)((0, (/*@__PURE__*/$parcel$interopDefault($7ca4f3c5cadce429$exports))), "clubs"),
                                        children: [
                                            accountInfo?.clubId === undefined && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                className: (0, $9805619f03ed02ef$export$91884aa883243770)((0, (/*@__PURE__*/$parcel$interopDefault($7ca4f3c5cadce429$exports))), "overlay-button"),
                                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $6725244138e0595f$export$353f5b6fc5456de1), {
                                                    onClick: onParticipate,
                                                    children: "Join Atlas Clash"
                                                })
                                            }),
                                            (clubClash ? Object.entries(clubClash.clubs) : []).sort(([, a], [, b])=>b.members - a.members).map(([id, club])=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $cf57aac21455785a$export$b5c66cbe436b19d9), {
                                                    className: `${accountInfo?.clubId === id ? "selected" : ""} ${accountInfo?.clubId ? "disabled" : ""} ${accountInfo?.clubId === undefined ? "transparent" : ""}`,
                                                    clubId: id,
                                                    club: club,
                                                    score: clubTop?.find((club)=>club.clubId === id)?.score ?? 0
                                                }, id))
                                        ]
                                    }),
                                    clubClashStarted && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                        className: (0, $9805619f03ed02ef$export$91884aa883243770)((0, (/*@__PURE__*/$parcel$interopDefault($7ca4f3c5cadce429$exports))), "show-all"),
                                        onClick: ()=>setShowFullClubList(!showFullClubList),
                                        children: [
                                            showFullClubList ? "hide" : "show",
                                            " all",
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                                                className: (0, $9805619f03ed02ef$export$91884aa883243770)((0, (/*@__PURE__*/$parcel$interopDefault($7ca4f3c5cadce429$exports))), showFullClubList ? "up" : ""),
                                                src: `${(0, $0426e2dd5e0de94d$export$24af3971dd36b33f)}/ui/open-arrow.png`,
                                                alt: "arrow"
                                            })
                                        ]
                                    }),
                                    clubClashStarted && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                        className: (0, $9805619f03ed02ef$export$91884aa883243770)((0, (/*@__PURE__*/$parcel$interopDefault($7ca4f3c5cadce429$exports))), "tabs"),
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                className: (0, $9805619f03ed02ef$export$91884aa883243770)((0, (/*@__PURE__*/$parcel$interopDefault($7ca4f3c5cadce429$exports))), "tab"),
                                                onClick: ()=>{
                                                    setTab("about");
                                                },
                                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $6725244138e0595f$export$353f5b6fc5456de1), {
                                                    className: (0, $9805619f03ed02ef$export$91884aa883243770)((0, (/*@__PURE__*/$parcel$interopDefault($7ca4f3c5cadce429$exports))), `xsmall ${tab === "about" ? "" : "gray"}`),
                                                    children: "ABOUT"
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                className: (0, $9805619f03ed02ef$export$91884aa883243770)((0, (/*@__PURE__*/$parcel$interopDefault($7ca4f3c5cadce429$exports))), "tab"),
                                                onClick: ()=>{
                                                    setTab("leaderboard");
                                                },
                                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $6725244138e0595f$export$353f5b6fc5456de1), {
                                                    className: (0, $9805619f03ed02ef$export$91884aa883243770)((0, (/*@__PURE__*/$parcel$interopDefault($7ca4f3c5cadce429$exports))), `xsmall ${tab === "leaderboard" ? "" : "gray"}`),
                                                    children: "LEADERBOARD"
                                                })
                                            })
                                        ]
                                    }),
                                    tab === "about" && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $43ae8e3303d8e0e7$export$eaffb7469d102331), {
                                        rewards: rewards
                                    }),
                                    tab === "leaderboard" && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $9f22486bd66a45a1$export$f3fb70d565ab13b3), {
                                        clubClash: clubClash,
                                        stats: stats
                                    })
                                ]
                            }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                className: (0, $9805619f03ed02ef$export$91884aa883243770)((0, (/*@__PURE__*/$parcel$interopDefault($7ca4f3c5cadce429$exports))), "no-clash"),
                                children: loading ? "loading..." : "No upcoming club clash"
                            })
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $4150806023a08153$export$ef429fde88b17151), {
                show: showConfirm,
                onClose: ()=>{
                    setShowConfirm(false);
                    refreshClubClash();
                }
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $207d23274fe2be11$export$a118d25f3bd40bb8), {
                show: showGemsReward,
                onClickBackground: ()=>setShowGemsReward(false),
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                    className: (0, $9805619f03ed02ef$export$91884aa883243770)((0, (/*@__PURE__*/$parcel$interopDefault($7ca4f3c5cadce429$exports))), "daily-rewards-modal"),
                    style: {
                        backgroundImage: `url('${(0, $0426e2dd5e0de94d$export$24af3971dd36b33f)}/ui/daily-rewards-modal.png')`
                    },
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                            className: (0, $9805619f03ed02ef$export$91884aa883243770)((0, (/*@__PURE__*/$parcel$interopDefault($7ca4f3c5cadce429$exports))), "icon"),
                            src: `${(0, $0426e2dd5e0de94d$export$24af3971dd36b33f)}/ui/daily-rewards-icon.png`,
                            alt: "daily-rewards-icon"
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                            className: (0, $9805619f03ed02ef$export$91884aa883243770)((0, (/*@__PURE__*/$parcel$interopDefault($7ca4f3c5cadce429$exports))), "title"),
                            children: "GEMS EARNED"
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                            className: (0, $9805619f03ed02ef$export$91884aa883243770)((0, (/*@__PURE__*/$parcel$interopDefault($7ca4f3c5cadce429$exports))), "rewards"),
                            children: [
                                "+",
                                gemsWon,
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                                    src: `${(0, $0426e2dd5e0de94d$export$24af3971dd36b33f)}/ui/gem.png`,
                                    alt: "gem"
                                })
                            ]
                        })
                    ]
                })
            })
        ]
    });
};





var $acw62 = parcelRequire("acw62");


var $43b504c32acaa1b9$exports = {};

$parcel$export($43b504c32acaa1b9$exports, "bg", () => $43b504c32acaa1b9$export$136fd86de524d3c2, (v) => $43b504c32acaa1b9$export$136fd86de524d3c2 = v);
$parcel$export($43b504c32acaa1b9$exports, "container", () => $43b504c32acaa1b9$export$34e0f9847d4c02dd, (v) => $43b504c32acaa1b9$export$34e0f9847d4c02dd = v);
$parcel$export($43b504c32acaa1b9$exports, "entry", () => $43b504c32acaa1b9$export$c407db72103fecfa, (v) => $43b504c32acaa1b9$export$c407db72103fecfa = v);
$parcel$export($43b504c32acaa1b9$exports, "first", () => $43b504c32acaa1b9$export$43128fadae87b74a, (v) => $43b504c32acaa1b9$export$43128fadae87b74a = v);
$parcel$export($43b504c32acaa1b9$exports, "info", () => $43b504c32acaa1b9$export$a80b3bd66acc52ff, (v) => $43b504c32acaa1b9$export$a80b3bd66acc52ff = v);
$parcel$export($43b504c32acaa1b9$exports, "key", () => $43b504c32acaa1b9$export$df61b30b684217c0, (v) => $43b504c32acaa1b9$export$df61b30b684217c0 = v);
$parcel$export($43b504c32acaa1b9$exports, "leaderboard", () => $43b504c32acaa1b9$export$71dbdde416a3cc7, (v) => $43b504c32acaa1b9$export$71dbdde416a3cc7 = v);
$parcel$export($43b504c32acaa1b9$exports, "leaderboard-tab", () => $43b504c32acaa1b9$export$bbb4cc57afa5c50f, (v) => $43b504c32acaa1b9$export$bbb4cc57afa5c50f = v);
$parcel$export($43b504c32acaa1b9$exports, "list", () => $43b504c32acaa1b9$export$8837f4fc672e936d, (v) => $43b504c32acaa1b9$export$8837f4fc672e936d = v);
$parcel$export($43b504c32acaa1b9$exports, "list-container", () => $43b504c32acaa1b9$export$9b732d716e8660cd, (v) => $43b504c32acaa1b9$export$9b732d716e8660cd = v);
$parcel$export($43b504c32acaa1b9$exports, "loader", () => $43b504c32acaa1b9$export$f4c5de44377d2946, (v) => $43b504c32acaa1b9$export$f4c5de44377d2946 = v);
$parcel$export($43b504c32acaa1b9$exports, "my", () => $43b504c32acaa1b9$export$94fa0a6beb22f989, (v) => $43b504c32acaa1b9$export$94fa0a6beb22f989 = v);
$parcel$export($43b504c32acaa1b9$exports, "my-rank", () => $43b504c32acaa1b9$export$f91e403202a62ce, (v) => $43b504c32acaa1b9$export$f91e403202a62ce = v);
$parcel$export($43b504c32acaa1b9$exports, "my-score", () => $43b504c32acaa1b9$export$329d02f9fe7e2b22, (v) => $43b504c32acaa1b9$export$329d02f9fe7e2b22 = v);
$parcel$export($43b504c32acaa1b9$exports, "my-stats", () => $43b504c32acaa1b9$export$7575acec9a159f5a, (v) => $43b504c32acaa1b9$export$7575acec9a159f5a = v);
$parcel$export($43b504c32acaa1b9$exports, "rank", () => $43b504c32acaa1b9$export$fbc8bcd33b574fbc, (v) => $43b504c32acaa1b9$export$fbc8bcd33b574fbc = v);
$parcel$export($43b504c32acaa1b9$exports, "second", () => $43b504c32acaa1b9$export$3d3c77ce7df7d30d, (v) => $43b504c32acaa1b9$export$3d3c77ce7df7d30d = v);
$parcel$export($43b504c32acaa1b9$exports, "tab", () => $43b504c32acaa1b9$export$62d58b1c91e8e902, (v) => $43b504c32acaa1b9$export$62d58b1c91e8e902 = v);
$parcel$export($43b504c32acaa1b9$exports, "tabs", () => $43b504c32acaa1b9$export$39f5674517ec0000, (v) => $43b504c32acaa1b9$export$39f5674517ec0000 = v);
$parcel$export($43b504c32acaa1b9$exports, "third", () => $43b504c32acaa1b9$export$1fa4a8860392dfdb, (v) => $43b504c32acaa1b9$export$1fa4a8860392dfdb = v);
$parcel$export($43b504c32acaa1b9$exports, "title", () => $43b504c32acaa1b9$export$fb184b623420d9be, (v) => $43b504c32acaa1b9$export$fb184b623420d9be = v);
var $43b504c32acaa1b9$export$136fd86de524d3c2;
var $43b504c32acaa1b9$export$34e0f9847d4c02dd;
var $43b504c32acaa1b9$export$c407db72103fecfa;
var $43b504c32acaa1b9$export$43128fadae87b74a;
var $43b504c32acaa1b9$export$a80b3bd66acc52ff;
var $43b504c32acaa1b9$export$df61b30b684217c0;
var $43b504c32acaa1b9$export$71dbdde416a3cc7;
var $43b504c32acaa1b9$export$bbb4cc57afa5c50f;
var $43b504c32acaa1b9$export$8837f4fc672e936d;
var $43b504c32acaa1b9$export$9b732d716e8660cd;
var $43b504c32acaa1b9$export$f4c5de44377d2946;
var $43b504c32acaa1b9$export$94fa0a6beb22f989;
var $43b504c32acaa1b9$export$f91e403202a62ce;
var $43b504c32acaa1b9$export$329d02f9fe7e2b22;
var $43b504c32acaa1b9$export$7575acec9a159f5a;
var $43b504c32acaa1b9$export$fbc8bcd33b574fbc;
var $43b504c32acaa1b9$export$3d3c77ce7df7d30d;
var $43b504c32acaa1b9$export$62d58b1c91e8e902;
var $43b504c32acaa1b9$export$39f5674517ec0000;
var $43b504c32acaa1b9$export$1fa4a8860392dfdb;
var $43b504c32acaa1b9$export$fb184b623420d9be;
$43b504c32acaa1b9$export$136fd86de524d3c2 = `_9LFFya_bg`;
$43b504c32acaa1b9$export$34e0f9847d4c02dd = `_9LFFya_container`;
$43b504c32acaa1b9$export$c407db72103fecfa = `_9LFFya_entry`;
$43b504c32acaa1b9$export$43128fadae87b74a = `_9LFFya_first`;
$43b504c32acaa1b9$export$a80b3bd66acc52ff = `_9LFFya_info`;
$43b504c32acaa1b9$export$df61b30b684217c0 = `_9LFFya_key`;
$43b504c32acaa1b9$export$71dbdde416a3cc7 = `_9LFFya_leaderboard`;
$43b504c32acaa1b9$export$bbb4cc57afa5c50f = `_9LFFya_leaderboard-tab`;
$43b504c32acaa1b9$export$8837f4fc672e936d = `_9LFFya_list`;
$43b504c32acaa1b9$export$9b732d716e8660cd = `_9LFFya_list-container`;
$43b504c32acaa1b9$export$f4c5de44377d2946 = `_9LFFya_loader`;
$43b504c32acaa1b9$export$94fa0a6beb22f989 = `_9LFFya_my`;
$43b504c32acaa1b9$export$f91e403202a62ce = `_9LFFya_my-rank`;
$43b504c32acaa1b9$export$329d02f9fe7e2b22 = `_9LFFya_my-score`;
$43b504c32acaa1b9$export$7575acec9a159f5a = `_9LFFya_my-stats`;
$43b504c32acaa1b9$export$fbc8bcd33b574fbc = `_9LFFya_rank`;
$43b504c32acaa1b9$export$3d3c77ce7df7d30d = `_9LFFya_second`;
$43b504c32acaa1b9$export$62d58b1c91e8e902 = `_9LFFya_tab`;
$43b504c32acaa1b9$export$39f5674517ec0000 = `_9LFFya_tabs`;
$43b504c32acaa1b9$export$1fa4a8860392dfdb = `_9LFFya_third`;
$43b504c32acaa1b9$export$fb184b623420d9be = `_9LFFya_title`;


const $3529734a17fc27ef$export$f3fb70d565ab13b3 = ({ className: className, ...props })=>{
    const [leaderboard, setLeaderboard] = (0, $acw62.useState)("global");
    const [stats, setStats] = (0, $acw62.useState)();
    const [loading, setLoading] = (0, $acw62.useState)(false);
    (0, $acw62.useEffect)(()=>{
        setLoading(true);
        if (leaderboard === "global") (0, $35a528e84618b070$export$36e89c7c246b7b1b)().then((res)=>{
            setStats(res);
            setLoading(false);
        }).catch(console.error);
    // else if (leaderboard === 'weekly') {
    //  getWeeklyLeaderboard().then((res) => {
    //    setStats(res)
    //    setLoading(false)
    //  }).catch(console.error)
    //}
    }, [
        leaderboard
    ]);
    const formatRank = (rank)=>{
        if (rank === 1) return "first";
        else if (rank === 2) return "second";
        else if (rank === 3) return "third";
    };
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
        className: (0, $9805619f03ed02ef$export$91884aa883243770)((0, (/*@__PURE__*/$parcel$interopDefault($43b504c32acaa1b9$exports))), `leaderboard-tab reveal-element ${className}`),
        ...props,
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
            className: (0, $9805619f03ed02ef$export$91884aa883243770)((0, (/*@__PURE__*/$parcel$interopDefault($43b504c32acaa1b9$exports))), "leaderboard"),
            children: [
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                    className: (0, $9805619f03ed02ef$export$91884aa883243770)((0, (/*@__PURE__*/$parcel$interopDefault($43b504c32acaa1b9$exports))), "title"),
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                            src: `${(0, $0426e2dd5e0de94d$export$24af3971dd36b33f)}/ui/tab-ranking.png`,
                            alt: "ranking"
                        }),
                        "Leaderboard"
                    ]
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                    className: (0, $9805619f03ed02ef$export$91884aa883243770)((0, (/*@__PURE__*/$parcel$interopDefault($43b504c32acaa1b9$exports))), "container"),
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                            className: (0, $9805619f03ed02ef$export$91884aa883243770)((0, (/*@__PURE__*/$parcel$interopDefault($43b504c32acaa1b9$exports))), "entry my"),
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                    className: (0, $9805619f03ed02ef$export$91884aa883243770)((0, (/*@__PURE__*/$parcel$interopDefault($43b504c32acaa1b9$exports))), "bg")
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                    className: (0, $9805619f03ed02ef$export$91884aa883243770)((0, (/*@__PURE__*/$parcel$interopDefault($43b504c32acaa1b9$exports))), `rank ${formatRank(stats?.data?.rank)}`),
                                    children: stats?.data?.rank === 0 ? "-" : stats?.data?.rank
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                    className: (0, $9805619f03ed02ef$export$91884aa883243770)((0, (/*@__PURE__*/$parcel$interopDefault($43b504c32acaa1b9$exports))), "key"),
                                    children: "You"
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                    className: (0, $9805619f03ed02ef$export$91884aa883243770)((0, (/*@__PURE__*/$parcel$interopDefault($43b504c32acaa1b9$exports))), "score"),
                                    children: stats?.data?.score === 0 ? "no score" : stats?.data?.score.toLocaleString()
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                            className: (0, $9805619f03ed02ef$export$91884aa883243770)((0, (/*@__PURE__*/$parcel$interopDefault($43b504c32acaa1b9$exports))), "list-container"),
                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                className: (0, $9805619f03ed02ef$export$91884aa883243770)((0, (/*@__PURE__*/$parcel$interopDefault($43b504c32acaa1b9$exports))), "list"),
                                children: !loading && stats ? (stats.data?.top250 ?? []).map((entry, index)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                        className: (0, $9805619f03ed02ef$export$91884aa883243770)((0, (/*@__PURE__*/$parcel$interopDefault($43b504c32acaa1b9$exports))), "entry"),
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                className: (0, $9805619f03ed02ef$export$91884aa883243770)((0, (/*@__PURE__*/$parcel$interopDefault($43b504c32acaa1b9$exports))), "bg")
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                className: (0, $9805619f03ed02ef$export$91884aa883243770)((0, (/*@__PURE__*/$parcel$interopDefault($43b504c32acaa1b9$exports))), `rank ${formatRank(index + 1)}`),
                                                children: index + 1
                                            }, `${entry.publicKey}-rank`),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                className: (0, $9805619f03ed02ef$export$91884aa883243770)((0, (/*@__PURE__*/$parcel$interopDefault($43b504c32acaa1b9$exports))), "key"),
                                                children: entry.username
                                            }, `${entry.publicKey}-key`),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                className: (0, $9805619f03ed02ef$export$91884aa883243770)((0, (/*@__PURE__*/$parcel$interopDefault($43b504c32acaa1b9$exports))), "score"),
                                                children: entry.score.toLocaleString()
                                            }, `${entry.publicKey}-score`)
                                        ]
                                    }, entry.publicKey)) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                    className: (0, $9805619f03ed02ef$export$91884aa883243770)((0, (/*@__PURE__*/$parcel$interopDefault($43b504c32acaa1b9$exports))), "loader"),
                                    children: "Loading..."
                                })
                            })
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                            className: (0, $9805619f03ed02ef$export$91884aa883243770)((0, (/*@__PURE__*/$parcel$interopDefault($43b504c32acaa1b9$exports))), "info"),
                            children: "the leaderboard is computed each minute"
                        })
                    ]
                })
            ]
        })
    });
};




var $acw62 = parcelRequire("acw62");

var $ftY1i = parcelRequire("ftY1i");








var $acw62 = parcelRequire("acw62");



var $74e1835149fe15c3$exports = {};

$parcel$export($74e1835149fe15c3$exports, "image", () => $74e1835149fe15c3$export$5c452ff88e35e47d, (v) => $74e1835149fe15c3$export$5c452ff88e35e47d = v);
$parcel$export($74e1835149fe15c3$exports, "no-prizes", () => $74e1835149fe15c3$export$888b206f6660f35, (v) => $74e1835149fe15c3$export$888b206f6660f35 = v);
$parcel$export($74e1835149fe15c3$exports, "previous-week-tab", () => $74e1835149fe15c3$export$172222d81e964bbb, (v) => $74e1835149fe15c3$export$172222d81e964bbb = v);
$parcel$export($74e1835149fe15c3$exports, "reward", () => $74e1835149fe15c3$export$7abfebf4aa86b126, (v) => $74e1835149fe15c3$export$7abfebf4aa86b126 = v);
$parcel$export($74e1835149fe15c3$exports, "rewards", () => $74e1835149fe15c3$export$4b2cb815b21f438d, (v) => $74e1835149fe15c3$export$4b2cb815b21f438d = v);
var $74e1835149fe15c3$export$5c452ff88e35e47d;
var $74e1835149fe15c3$export$888b206f6660f35;
var $74e1835149fe15c3$export$172222d81e964bbb;
var $74e1835149fe15c3$export$7abfebf4aa86b126;
var $74e1835149fe15c3$export$4b2cb815b21f438d;
$74e1835149fe15c3$export$5c452ff88e35e47d = `n7DsxG_image`;
$74e1835149fe15c3$export$888b206f6660f35 = `n7DsxG_no-prizes`;
$74e1835149fe15c3$export$172222d81e964bbb = `n7DsxG_previous-week-tab`;
$74e1835149fe15c3$export$7abfebf4aa86b126 = `n7DsxG_reward`;
$74e1835149fe15c3$export$4b2cb815b21f438d = `n7DsxG_rewards`;


const $e534c71e74232c68$export$7bb0470b5b9ad3fc = ({ className: className, holder: holder, ...props })=>{
    const { state: { accountInfo: accountInfo, publicKey: publicKey } } = (0, $c25623cc446ec3c6$export$ac8576a9912be18c)();
    const [data, setData] = (0, $acw62.useState)();
    (0, $acw62.useEffect)(()=>{
        (0, $35a528e84618b070$export$680d5e90d764a0e1)(holder, console.error).then((response)=>setData(response?.data));
    }, [
        accountInfo
    ]);
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
        className: (0, $9805619f03ed02ef$export$91884aa883243770)((0, (/*@__PURE__*/$parcel$interopDefault($74e1835149fe15c3$exports))), `previous-week-tab reveal-element ${className}`),
        ...props,
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
            className: (0, $9805619f03ed02ef$export$91884aa883243770)((0, (/*@__PURE__*/$parcel$interopDefault($74e1835149fe15c3$exports))), "rewards"),
            children: [
                data?.rewards?.map((reward, index)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        style: {
                            backgroundImage: `url('${(0, $0426e2dd5e0de94d$export$24af3971dd36b33f)}/ui/${!holder ? "violet-" : ""}weekly-price-bg.png')`
                        },
                        className: (0, $9805619f03ed02ef$export$91884aa883243770)((0, (/*@__PURE__*/$parcel$interopDefault($74e1835149fe15c3$exports))), "reward"),
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                className: (0, $9805619f03ed02ef$export$91884aa883243770)((0, (/*@__PURE__*/$parcel$interopDefault($74e1835149fe15c3$exports))), "image"),
                                style: {
                                    backgroundImage: `url('${reward.imageURL}')`
                                }
                            }),
                            reward.name,
                            " (",
                            data.winners?.[index]?.username ? publicKey === data.winners[index].publicKey ? "YOU WON!" : data.winners[index].username : "no winner",
                            ")"
                        ]
                    }, index)),
                !data && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                    className: (0, $9805619f03ed02ef$export$91884aa883243770)((0, (/*@__PURE__*/$parcel$interopDefault($74e1835149fe15c3$exports))), "no-prizes"),
                    children: "No prizes won last week"
                })
            ]
        })
    });
};





var $acw62 = parcelRequire("acw62");



var $daee57187a4f9813$exports = {};

$parcel$export($daee57187a4f9813$exports, "entry", () => $daee57187a4f9813$export$c407db72103fecfa, (v) => $daee57187a4f9813$export$c407db72103fecfa = v);
$parcel$export($daee57187a4f9813$exports, "image", () => $daee57187a4f9813$export$5c452ff88e35e47d, (v) => $daee57187a4f9813$export$5c452ff88e35e47d = v);
$parcel$export($daee57187a4f9813$exports, "line", () => $daee57187a4f9813$export$53f1d5ea8de3d7c, (v) => $daee57187a4f9813$export$53f1d5ea8de3d7c = v);
$parcel$export($daee57187a4f9813$exports, "no-prizes", () => $daee57187a4f9813$export$888b206f6660f35, (v) => $daee57187a4f9813$export$888b206f6660f35 = v);
$parcel$export($daee57187a4f9813$exports, "reward", () => $daee57187a4f9813$export$7abfebf4aa86b126, (v) => $daee57187a4f9813$export$7abfebf4aa86b126 = v);
$parcel$export($daee57187a4f9813$exports, "rewards", () => $daee57187a4f9813$export$4b2cb815b21f438d, (v) => $daee57187a4f9813$export$4b2cb815b21f438d = v);
$parcel$export($daee57187a4f9813$exports, "your-entry-tab", () => $daee57187a4f9813$export$2184e4552051773f, (v) => $daee57187a4f9813$export$2184e4552051773f = v);
var $daee57187a4f9813$export$c407db72103fecfa;
var $daee57187a4f9813$export$5c452ff88e35e47d;
var $daee57187a4f9813$export$53f1d5ea8de3d7c;
var $daee57187a4f9813$export$888b206f6660f35;
var $daee57187a4f9813$export$7abfebf4aa86b126;
var $daee57187a4f9813$export$4b2cb815b21f438d;
var $daee57187a4f9813$export$2184e4552051773f;
$daee57187a4f9813$export$c407db72103fecfa = `Z8UAsG_entry`;
$daee57187a4f9813$export$5c452ff88e35e47d = `Z8UAsG_image`;
$daee57187a4f9813$export$53f1d5ea8de3d7c = `Z8UAsG_line`;
$daee57187a4f9813$export$888b206f6660f35 = `Z8UAsG_no-prizes`;
$daee57187a4f9813$export$7abfebf4aa86b126 = `Z8UAsG_reward`;
$daee57187a4f9813$export$4b2cb815b21f438d = `Z8UAsG_rewards`;
$daee57187a4f9813$export$2184e4552051773f = `Z8UAsG_your-entry-tab`;


const $0d13bbe2fd26c409$export$900b86a34a63e149 = ({ className: className, holder: holder, ...props })=>{
    const { state: { accountInfo: accountInfo } } = (0, $c25623cc446ec3c6$export$ac8576a9912be18c)();
    const [data, setData] = (0, $acw62.useState)();
    const [holdedNFTs, setHoldedNFTs] = (0, $acw62.useState)();
    (0, $acw62.useEffect)(()=>{
        (0, $35a528e84618b070$export$ea0cf17b3b0cadbf)(holder, console.error).then((response)=>setData(response?.data));
    }, [
        holder
    ]);
    (0, $acw62.useEffect)(()=>{
        (0, $35a528e84618b070$export$aa6ba60d2e4d6066)(console.error).then((response)=>setHoldedNFTs(response?.data));
    }, []);
    const weekString = accountInfo?.actualWeek ?? "";
    const percentage = data?.totalTokens !== undefined ? Math.floor((accountInfo?.tokens[weekString] ?? 0) / data.totalTokens * 10000) / 100 : 0;
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: (0, $9805619f03ed02ef$export$91884aa883243770)((0, (/*@__PURE__*/$parcel$interopDefault($daee57187a4f9813$exports))), `your-entry-tab reveal-element ${className}`),
        ...props,
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: (0, $9805619f03ed02ef$export$91884aa883243770)((0, (/*@__PURE__*/$parcel$interopDefault($daee57187a4f9813$exports))), "line"),
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: (0, $9805619f03ed02ef$export$91884aa883243770)((0, (/*@__PURE__*/$parcel$interopDefault($daee57187a4f9813$exports))), "entry"),
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                                src: `${(0, $0426e2dd5e0de94d$export$24af3971dd36b33f)}/ui/token.png`,
                                alt: "token"
                            }),
                            accountInfo ? holder && (holdedNFTs ?? 0) > 0 || !holder ? accountInfo.tokens[weekString] ?? 0 : 0 : "...",
                            " ENTRIES"
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: (0, $9805619f03ed02ef$export$91884aa883243770)((0, (/*@__PURE__*/$parcel$interopDefault($daee57187a4f9813$exports))), "entry"),
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                                src: `${(0, $0426e2dd5e0de94d$export$24af3971dd36b33f)}/ui/trophy.png`,
                                alt: "trophy"
                            }),
                            holder ? (holdedNFTs ?? 0) > 0 ? percentage : 0 : percentage,
                            "% WIN CHANCE"
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: (0, $9805619f03ed02ef$export$91884aa883243770)((0, (/*@__PURE__*/$parcel$interopDefault($daee57187a4f9813$exports))), "rewards"),
                children: [
                    data?.rewards?.map((reward, index)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                            style: {
                                backgroundImage: `url('${(0, $0426e2dd5e0de94d$export$24af3971dd36b33f)}/ui/${!holder ? "violet-" : ""}weekly-price-bg.png')`
                            },
                            className: (0, $9805619f03ed02ef$export$91884aa883243770)((0, (/*@__PURE__*/$parcel$interopDefault($daee57187a4f9813$exports))), "reward"),
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                    className: (0, $9805619f03ed02ef$export$91884aa883243770)((0, (/*@__PURE__*/$parcel$interopDefault($daee57187a4f9813$exports))), "image"),
                                    style: {
                                        backgroundImage: `url('${reward.imageURL}')`
                                    }
                                }),
                                reward.name
                            ]
                        }, index)),
                    (!data || !data.rewards) && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        className: (0, $9805619f03ed02ef$export$91884aa883243770)((0, (/*@__PURE__*/$parcel$interopDefault($daee57187a4f9813$exports))), "no-prizes"),
                        children: "No prizes for this week"
                    })
                ]
            })
        ]
    });
};


var $d6d5c59b03efc8ff$exports = {};

$parcel$export($d6d5c59b03efc8ff$exports, "container", () => $d6d5c59b03efc8ff$export$34e0f9847d4c02dd, (v) => $d6d5c59b03efc8ff$export$34e0f9847d4c02dd = v);
$parcel$export($d6d5c59b03efc8ff$exports, "countdown", () => $d6d5c59b03efc8ff$export$f52e29715bba3529, (v) => $d6d5c59b03efc8ff$export$f52e29715bba3529 = v);
$parcel$export($d6d5c59b03efc8ff$exports, "player", () => $d6d5c59b03efc8ff$export$615455393ee443ca, (v) => $d6d5c59b03efc8ff$export$615455393ee443ca = v);
$parcel$export($d6d5c59b03efc8ff$exports, "tab", () => $d6d5c59b03efc8ff$export$62d58b1c91e8e902, (v) => $d6d5c59b03efc8ff$export$62d58b1c91e8e902 = v);
$parcel$export($d6d5c59b03efc8ff$exports, "tabs", () => $d6d5c59b03efc8ff$export$39f5674517ec0000, (v) => $d6d5c59b03efc8ff$export$39f5674517ec0000 = v);
$parcel$export($d6d5c59b03efc8ff$exports, "title", () => $d6d5c59b03efc8ff$export$fb184b623420d9be, (v) => $d6d5c59b03efc8ff$export$fb184b623420d9be = v);
$parcel$export($d6d5c59b03efc8ff$exports, "violet-image", () => $d6d5c59b03efc8ff$export$ed8559cf66e4926a, (v) => $d6d5c59b03efc8ff$export$ed8559cf66e4926a = v);
$parcel$export($d6d5c59b03efc8ff$exports, "weekly-prize", () => $d6d5c59b03efc8ff$export$eba8f373b286f071, (v) => $d6d5c59b03efc8ff$export$eba8f373b286f071 = v);
$parcel$export($d6d5c59b03efc8ff$exports, "weekly-prize-tab", () => $d6d5c59b03efc8ff$export$416c55e422e7932c, (v) => $d6d5c59b03efc8ff$export$416c55e422e7932c = v);
var $d6d5c59b03efc8ff$export$34e0f9847d4c02dd;
var $d6d5c59b03efc8ff$export$f52e29715bba3529;
var $d6d5c59b03efc8ff$export$615455393ee443ca;
var $d6d5c59b03efc8ff$export$62d58b1c91e8e902;
var $d6d5c59b03efc8ff$export$39f5674517ec0000;
var $d6d5c59b03efc8ff$export$fb184b623420d9be;
var $d6d5c59b03efc8ff$export$ed8559cf66e4926a;
var $d6d5c59b03efc8ff$export$eba8f373b286f071;
var $d6d5c59b03efc8ff$export$416c55e422e7932c;
$d6d5c59b03efc8ff$export$34e0f9847d4c02dd = `js0gna_container`;
$d6d5c59b03efc8ff$export$f52e29715bba3529 = `js0gna_countdown`;
$d6d5c59b03efc8ff$export$615455393ee443ca = `js0gna_player`;
$d6d5c59b03efc8ff$export$62d58b1c91e8e902 = `js0gna_tab`;
$d6d5c59b03efc8ff$export$39f5674517ec0000 = `js0gna_tabs`;
$d6d5c59b03efc8ff$export$fb184b623420d9be = `js0gna_title`;
$d6d5c59b03efc8ff$export$ed8559cf66e4926a = `js0gna_violet-image`;
$d6d5c59b03efc8ff$export$eba8f373b286f071 = `js0gna_weekly-prize`;
$d6d5c59b03efc8ff$export$416c55e422e7932c = `js0gna_weekly-prize-tab`;


const $0ed5cab2aa982e2e$var$addZeroToNumber = (number)=>number < 10 ? `0${number}` : number;
const $0ed5cab2aa982e2e$var$renderer = ({ days: days, hours: hours, minutes: minutes })=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
        children: [
            $0ed5cab2aa982e2e$var$addZeroToNumber(days),
            "D ",
            $0ed5cab2aa982e2e$var$addZeroToNumber(hours),
            "H ",
            $0ed5cab2aa982e2e$var$addZeroToNumber(minutes),
            "M"
        ]
    });
const $0ed5cab2aa982e2e$export$6672f2bb1ff038b2 = ({ className: className, holder: holder, ...props })=>{
    const [tab, setTab] = (0, $acw62.useState)("your-entry");
    (0, $acw62.useEffect)(()=>{
        if ((0, $b3b1baf40467424d$export$745043c7dc65e495).refreshAccountInfo) (0, $b3b1baf40467424d$export$745043c7dc65e495).refreshAccountInfo();
    }, []);
    const endOfWeeklyPrize = (0, $e97e44cd4550f081$export$a20373bb0df6efdd)();
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: (0, $9805619f03ed02ef$export$91884aa883243770)((0, (/*@__PURE__*/$parcel$interopDefault($d6d5c59b03efc8ff$exports))), `weekly-prize-tab ${className}`),
        ...props,
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $d476126f9afdc959$export$668799e4797757a8), {
                className: "high"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: (0, $9805619f03ed02ef$export$91884aa883243770)((0, (/*@__PURE__*/$parcel$interopDefault($d6d5c59b03efc8ff$exports))), "weekly-prize"),
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: (0, $9805619f03ed02ef$export$91884aa883243770)((0, (/*@__PURE__*/$parcel$interopDefault($d6d5c59b03efc8ff$exports))), `title ${!holder ? "violet-image" : ""}`),
                        children: [
                            holder ? "Holder " : "Public ",
                            "Weekly Prize ",
                            tab === "your-entry" && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                className: (0, $9805619f03ed02ef$export$91884aa883243770)((0, (/*@__PURE__*/$parcel$interopDefault($d6d5c59b03efc8ff$exports))), "countdown"),
                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $ftY1i.default), {
                                    date: endOfWeeklyPrize,
                                    renderer: $0ed5cab2aa982e2e$var$renderer
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: (0, $9805619f03ed02ef$export$91884aa883243770)((0, (/*@__PURE__*/$parcel$interopDefault($d6d5c59b03efc8ff$exports))), "container"),
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: (0, $9805619f03ed02ef$export$91884aa883243770)((0, (/*@__PURE__*/$parcel$interopDefault($d6d5c59b03efc8ff$exports))), "tabs"),
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                        className: (0, $9805619f03ed02ef$export$91884aa883243770)((0, (/*@__PURE__*/$parcel$interopDefault($d6d5c59b03efc8ff$exports))), "tab"),
                                        onClick: ()=>{
                                            setTab("your-entry");
                                        },
                                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $6725244138e0595f$export$353f5b6fc5456de1), {
                                            className: (0, $9805619f03ed02ef$export$91884aa883243770)((0, (/*@__PURE__*/$parcel$interopDefault($d6d5c59b03efc8ff$exports))), `xsmall ${tab === "your-entry" ? !holder ? "violet" : "" : "gray"}`),
                                            children: "YOUR ENTRY"
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                        className: (0, $9805619f03ed02ef$export$91884aa883243770)((0, (/*@__PURE__*/$parcel$interopDefault($d6d5c59b03efc8ff$exports))), "tab"),
                                        onClick: ()=>{
                                            setTab("previous-week");
                                        },
                                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $6725244138e0595f$export$353f5b6fc5456de1), {
                                            className: (0, $9805619f03ed02ef$export$91884aa883243770)((0, (/*@__PURE__*/$parcel$interopDefault($d6d5c59b03efc8ff$exports))), `xsmall ${tab === "previous-week" ? !holder ? "violet" : "" : "gray"}`),
                                            children: "PREVIOUS WEEK"
                                        })
                                    })
                                ]
                            }),
                            tab === "your-entry" && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $0d13bbe2fd26c409$export$900b86a34a63e149), {
                                holder: holder
                            }),
                            tab === "previous-week" && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $e534c71e74232c68$export$7bb0470b5b9ad3fc), {
                                holder: holder
                            })
                        ]
                    })
                ]
            })
        ]
    });
};


var $a696b5b7f0d47a50$exports = {};

$parcel$export($a696b5b7f0d47a50$exports, "bg-bottom", () => $a696b5b7f0d47a50$export$ea448b8ccea09295, (v) => $a696b5b7f0d47a50$export$ea448b8ccea09295 = v);
$parcel$export($a696b5b7f0d47a50$exports, "bg-middle", () => $a696b5b7f0d47a50$export$ce8ba153cd42f7bc, (v) => $a696b5b7f0d47a50$export$ce8ba153cd42f7bc = v);
$parcel$export($a696b5b7f0d47a50$exports, "bg-top", () => $a696b5b7f0d47a50$export$11da0b5e0781449c, (v) => $a696b5b7f0d47a50$export$11da0b5e0781449c = v);
$parcel$export($a696b5b7f0d47a50$exports, "homescreen", () => $a696b5b7f0d47a50$export$bc297d030cd7c667, (v) => $a696b5b7f0d47a50$export$bc297d030cd7c667 = v);
$parcel$export($a696b5b7f0d47a50$exports, "tab", () => $a696b5b7f0d47a50$export$62d58b1c91e8e902, (v) => $a696b5b7f0d47a50$export$62d58b1c91e8e902 = v);
var $a696b5b7f0d47a50$export$ea448b8ccea09295;
var $a696b5b7f0d47a50$export$ce8ba153cd42f7bc;
var $a696b5b7f0d47a50$export$11da0b5e0781449c;
var $a696b5b7f0d47a50$export$bc297d030cd7c667;
var $a696b5b7f0d47a50$export$62d58b1c91e8e902;
$a696b5b7f0d47a50$export$ea448b8ccea09295 = `qQfzxq_bg-bottom`;
$a696b5b7f0d47a50$export$ce8ba153cd42f7bc = `qQfzxq_bg-middle`;
$a696b5b7f0d47a50$export$11da0b5e0781449c = `qQfzxq_bg-top`;
$a696b5b7f0d47a50$export$bc297d030cd7c667 = `qQfzxq_homescreen`;
$a696b5b7f0d47a50$export$62d58b1c91e8e902 = `qQfzxq_tab`;


const $f980f5f69bb36415$export$f2ca285b456891c7 = ({ className: className, ...props })=>{
    const { state: { tab: tab } } = (0, $c25623cc446ec3c6$export$ac8576a9912be18c)();
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7b02d682eb115277$exports.Fragment), {
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
            className: (0, $9805619f03ed02ef$export$91884aa883243770)((0, (/*@__PURE__*/$parcel$interopDefault($a696b5b7f0d47a50$exports))), `homescreen ${className}`),
            ...props,
            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: (0, $9805619f03ed02ef$export$91884aa883243770)((0, (/*@__PURE__*/$parcel$interopDefault($a696b5b7f0d47a50$exports))), "tab"),
                children: [
                    tab === "leaderboard" && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $3529734a17fc27ef$export$f3fb70d565ab13b3), {}),
                    tab === "clash" && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $698ad062f1347ee3$export$1ec4af8dfddbc212), {}),
                    tab === "battle" && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $0b78b7046d0dbf1e$export$1fafd7585827ebd1), {}),
                    tab === "character" && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $eb5fda4e7ad93e80$export$150cf13f95deb6c), {}),
                    tab === "weekly-prize" && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $0ed5cab2aa982e2e$export$6672f2bb1ff038b2), {}),
                    tab === "holder-weekly-prize" && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $0ed5cab2aa982e2e$export$6672f2bb1ff038b2), {
                        holder: true
                    })
                ]
            })
        })
    });
};




parcelRequire("acw62");



var $3b34c50aa8abf48b$exports = {};

$parcel$export($3b34c50aa8abf48b$exports, "active", () => $3b34c50aa8abf48b$export$89da14300d534261, (v) => $3b34c50aa8abf48b$export$89da14300d534261 = v);
$parcel$export($3b34c50aa8abf48b$exports, "active-bg", () => $3b34c50aa8abf48b$export$c510e94e50478715, (v) => $3b34c50aa8abf48b$export$c510e94e50478715 = v);
$parcel$export($3b34c50aa8abf48b$exports, "arrow-left", () => $3b34c50aa8abf48b$export$19c6dffef469df6c, (v) => $3b34c50aa8abf48b$export$19c6dffef469df6c = v);
$parcel$export($3b34c50aa8abf48b$exports, "arrow-right", () => $3b34c50aa8abf48b$export$7fe96d2c800fc553, (v) => $3b34c50aa8abf48b$export$7fe96d2c800fc553 = v);
$parcel$export($3b34c50aa8abf48b$exports, "battle", () => $3b34c50aa8abf48b$export$aa87b6293616fca4, (v) => $3b34c50aa8abf48b$export$aa87b6293616fca4 = v);
$parcel$export($3b34c50aa8abf48b$exports, "bg", () => $3b34c50aa8abf48b$export$136fd86de524d3c2, (v) => $3b34c50aa8abf48b$export$136fd86de524d3c2 = v);
$parcel$export($3b34c50aa8abf48b$exports, "character", () => $3b34c50aa8abf48b$export$c0306caf338ac095, (v) => $3b34c50aa8abf48b$export$c0306caf338ac095 = v);
$parcel$export($3b34c50aa8abf48b$exports, "hover", () => $3b34c50aa8abf48b$export$3f60957f5dbf3876, (v) => $3b34c50aa8abf48b$export$3f60957f5dbf3876 = v);
$parcel$export($3b34c50aa8abf48b$exports, "icon", () => $3b34c50aa8abf48b$export$1ca1ec8b29a4ce27, (v) => $3b34c50aa8abf48b$export$1ca1ec8b29a4ce27 = v);
$parcel$export($3b34c50aa8abf48b$exports, "navigation", () => $3b34c50aa8abf48b$export$428e7c787d57587d, (v) => $3b34c50aa8abf48b$export$428e7c787d57587d = v);
$parcel$export($3b34c50aa8abf48b$exports, "tab", () => $3b34c50aa8abf48b$export$62d58b1c91e8e902, (v) => $3b34c50aa8abf48b$export$62d58b1c91e8e902 = v);
$parcel$export($3b34c50aa8abf48b$exports, "tabs", () => $3b34c50aa8abf48b$export$39f5674517ec0000, (v) => $3b34c50aa8abf48b$export$39f5674517ec0000 = v);
$parcel$export($3b34c50aa8abf48b$exports, "title", () => $3b34c50aa8abf48b$export$fb184b623420d9be, (v) => $3b34c50aa8abf48b$export$fb184b623420d9be = v);
var $3b34c50aa8abf48b$export$89da14300d534261;
var $3b34c50aa8abf48b$export$c510e94e50478715;
var $3b34c50aa8abf48b$export$19c6dffef469df6c;
var $3b34c50aa8abf48b$export$7fe96d2c800fc553;
var $3b34c50aa8abf48b$export$aa87b6293616fca4;
var $3b34c50aa8abf48b$export$136fd86de524d3c2;
var $3b34c50aa8abf48b$export$c0306caf338ac095;
var $3b34c50aa8abf48b$export$3f60957f5dbf3876;
var $3b34c50aa8abf48b$export$1ca1ec8b29a4ce27;
var $3b34c50aa8abf48b$export$428e7c787d57587d;
var $3b34c50aa8abf48b$export$62d58b1c91e8e902;
var $3b34c50aa8abf48b$export$39f5674517ec0000;
var $3b34c50aa8abf48b$export$fb184b623420d9be;
$3b34c50aa8abf48b$export$89da14300d534261 = `_70Me4q_active`;
$3b34c50aa8abf48b$export$c510e94e50478715 = `_70Me4q_active-bg`;
$3b34c50aa8abf48b$export$19c6dffef469df6c = `_70Me4q_arrow-left`;
$3b34c50aa8abf48b$export$7fe96d2c800fc553 = `_70Me4q_arrow-right`;
$3b34c50aa8abf48b$export$aa87b6293616fca4 = `_70Me4q_battle`;
$3b34c50aa8abf48b$export$136fd86de524d3c2 = `_70Me4q_bg`;
$3b34c50aa8abf48b$export$c0306caf338ac095 = `_70Me4q_character`;
$3b34c50aa8abf48b$export$3f60957f5dbf3876 = `_70Me4q_hover`;
$3b34c50aa8abf48b$export$1ca1ec8b29a4ce27 = `_70Me4q_icon`;
$3b34c50aa8abf48b$export$428e7c787d57587d = `_70Me4q_navigation`;
$3b34c50aa8abf48b$export$62d58b1c91e8e902 = `_70Me4q_tab`;
$3b34c50aa8abf48b$export$39f5674517ec0000 = `_70Me4q_tabs`;
$3b34c50aa8abf48b$export$fb184b623420d9be = `_70Me4q_title`;


const $4a67a16e8064c76c$export$b8a61e5c71402559 = ({ className: className, ...props })=>{
    const { dispatch: dispatch, state: { tab: tab } } = (0, $c25623cc446ec3c6$export$ac8576a9912be18c)();
    const backgroundImage = tab === "leaderboard" ? `url('${0, $0426e2dd5e0de94d$export$24af3971dd36b33f}/ui/nav-1.png')` : tab === "clash" ? `url('${0, $0426e2dd5e0de94d$export$24af3971dd36b33f}/ui/nav-2.png')` : tab === "battle" ? `url('${0, $0426e2dd5e0de94d$export$24af3971dd36b33f}/ui/nav-3.png')` : `url('${0, $0426e2dd5e0de94d$export$24af3971dd36b33f}/ui/nav-4.png')`;
    const navigate = (tab)=>{
        dispatch({
            type: "SET_NAVIGATION",
            tab: tab
        });
    };
    const onPointerUp = (tab)=>{
        (0, $0c69c9c512bb7a3f$export$4db563113ca18f41).play();
        navigate(tab);
    };
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: (0, $9805619f03ed02ef$export$91884aa883243770)((0, (/*@__PURE__*/$parcel$interopDefault($3b34c50aa8abf48b$exports))), `navigation ${className}`),
        ...props,
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: (0, $9805619f03ed02ef$export$91884aa883243770)((0, (/*@__PURE__*/$parcel$interopDefault($3b34c50aa8abf48b$exports))), "bg"),
                style: {
                    backgroundImage: `url('${(0, $0426e2dd5e0de94d$export$24af3971dd36b33f)}/ui/nav-bg.svg')`
                }
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: (0, $9805619f03ed02ef$export$91884aa883243770)((0, (/*@__PURE__*/$parcel$interopDefault($3b34c50aa8abf48b$exports))), "active-bg"),
                style: {
                    backgroundImage: backgroundImage
                }
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: (0, $9805619f03ed02ef$export$91884aa883243770)((0, (/*@__PURE__*/$parcel$interopDefault($3b34c50aa8abf48b$exports))), "tabs"),
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: (0, $9805619f03ed02ef$export$91884aa883243770)((0, (/*@__PURE__*/$parcel$interopDefault($3b34c50aa8abf48b$exports))), `tab ranking hover ${tab === "leaderboard" ? "active" : ""}`),
                        onPointerUp: ()=>onPointerUp("leaderboard"),
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                                className: (0, $9805619f03ed02ef$export$91884aa883243770)((0, (/*@__PURE__*/$parcel$interopDefault($3b34c50aa8abf48b$exports))), "icon"),
                                src: `${(0, $0426e2dd5e0de94d$export$24af3971dd36b33f)}/ui/tab-ranking.png`,
                                alt: "tab-ranking"
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                                className: (0, $9805619f03ed02ef$export$91884aa883243770)((0, (/*@__PURE__*/$parcel$interopDefault($3b34c50aa8abf48b$exports))), "arrow-right"),
                                src: `${(0, $0426e2dd5e0de94d$export$24af3971dd36b33f)}/ui/nav-arrow.png`,
                                alt: "nav-arrow-right"
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                className: (0, $9805619f03ed02ef$export$91884aa883243770)((0, (/*@__PURE__*/$parcel$interopDefault($3b34c50aa8abf48b$exports))), "title"),
                                children: "RANKING"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: (0, $9805619f03ed02ef$export$91884aa883243770)((0, (/*@__PURE__*/$parcel$interopDefault($3b34c50aa8abf48b$exports))), `tab clash hover ${tab === "clash" ? "active" : ""}`),
                        onPointerUp: ()=>onPointerUp("clash"),
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                                className: (0, $9805619f03ed02ef$export$91884aa883243770)((0, (/*@__PURE__*/$parcel$interopDefault($3b34c50aa8abf48b$exports))), "arrow-left"),
                                src: `${(0, $0426e2dd5e0de94d$export$24af3971dd36b33f)}/ui/nav-arrow.png`,
                                alt: "nav-arrow-left"
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                                className: (0, $9805619f03ed02ef$export$91884aa883243770)((0, (/*@__PURE__*/$parcel$interopDefault($3b34c50aa8abf48b$exports))), "icon"),
                                src: `${(0, $0426e2dd5e0de94d$export$24af3971dd36b33f)}/ui/tab-clash.png`,
                                alt: "tab-clash"
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                                className: (0, $9805619f03ed02ef$export$91884aa883243770)((0, (/*@__PURE__*/$parcel$interopDefault($3b34c50aa8abf48b$exports))), "arrow-right"),
                                src: `${(0, $0426e2dd5e0de94d$export$24af3971dd36b33f)}/ui/nav-arrow.png`,
                                alt: "nav-arrow-right"
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                className: (0, $9805619f03ed02ef$export$91884aa883243770)((0, (/*@__PURE__*/$parcel$interopDefault($3b34c50aa8abf48b$exports))), "title"),
                                children: "CLASH"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: (0, $9805619f03ed02ef$export$91884aa883243770)((0, (/*@__PURE__*/$parcel$interopDefault($3b34c50aa8abf48b$exports))), `tab battle hover ${tab === "battle" ? "active" : ""}`),
                        onPointerUp: ()=>onPointerUp("battle"),
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                                className: (0, $9805619f03ed02ef$export$91884aa883243770)((0, (/*@__PURE__*/$parcel$interopDefault($3b34c50aa8abf48b$exports))), "arrow-left"),
                                src: `${(0, $0426e2dd5e0de94d$export$24af3971dd36b33f)}/ui/nav-arrow.png`,
                                alt: "nav-arrow-left"
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                                className: (0, $9805619f03ed02ef$export$91884aa883243770)((0, (/*@__PURE__*/$parcel$interopDefault($3b34c50aa8abf48b$exports))), "icon"),
                                src: `${(0, $0426e2dd5e0de94d$export$24af3971dd36b33f)}/ui/tab-battle.png`,
                                alt: "tab-battle"
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                                className: (0, $9805619f03ed02ef$export$91884aa883243770)((0, (/*@__PURE__*/$parcel$interopDefault($3b34c50aa8abf48b$exports))), "arrow-right"),
                                src: `${(0, $0426e2dd5e0de94d$export$24af3971dd36b33f)}/ui/nav-arrow.png`,
                                alt: "nav-arrow-right"
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                className: (0, $9805619f03ed02ef$export$91884aa883243770)((0, (/*@__PURE__*/$parcel$interopDefault($3b34c50aa8abf48b$exports))), "title"),
                                children: "BATTLE"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: (0, $9805619f03ed02ef$export$91884aa883243770)((0, (/*@__PURE__*/$parcel$interopDefault($3b34c50aa8abf48b$exports))), `tab character hover ${tab === "character" ? "active" : ""}`),
                        onPointerUp: ()=>onPointerUp("character"),
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                                className: (0, $9805619f03ed02ef$export$91884aa883243770)((0, (/*@__PURE__*/$parcel$interopDefault($3b34c50aa8abf48b$exports))), "arrow-left"),
                                src: `${(0, $0426e2dd5e0de94d$export$24af3971dd36b33f)}/ui/nav-arrow.png`,
                                alt: "nav-arrow-left"
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                                className: (0, $9805619f03ed02ef$export$91884aa883243770)((0, (/*@__PURE__*/$parcel$interopDefault($3b34c50aa8abf48b$exports))), "icon"),
                                src: `${(0, $0426e2dd5e0de94d$export$24af3971dd36b33f)}/ui/tab-character.png`,
                                alt: "tab-character"
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                className: (0, $9805619f03ed02ef$export$91884aa883243770)((0, (/*@__PURE__*/$parcel$interopDefault($3b34c50aa8abf48b$exports))), "title"),
                                children: "CHARACTER"
                            })
                        ]
                    })
                ]
            })
        ]
    });
};






var $acw62 = parcelRequire("acw62");






var $414885eadc41ac2a$exports = {};

$parcel$export($414885eadc41ac2a$exports, "content", () => $414885eadc41ac2a$export$a7db06668cad9adb, (v) => $414885eadc41ac2a$export$a7db06668cad9adb = v);
$parcel$export($414885eadc41ac2a$exports, "enabled", () => $414885eadc41ac2a$export$25eaa035e2e3a214, (v) => $414885eadc41ac2a$export$25eaa035e2e3a214 = v);
$parcel$export($414885eadc41ac2a$exports, "pause-menu", () => $414885eadc41ac2a$export$881e48a3dd2e86b8, (v) => $414885eadc41ac2a$export$881e48a3dd2e86b8 = v);
$parcel$export($414885eadc41ac2a$exports, "player", () => $414885eadc41ac2a$export$615455393ee443ca, (v) => $414885eadc41ac2a$export$615455393ee443ca = v);
$parcel$export($414885eadc41ac2a$exports, "sound", () => $414885eadc41ac2a$export$eab32dcfc4ded11c, (v) => $414885eadc41ac2a$export$eab32dcfc4ded11c = v);
$parcel$export($414885eadc41ac2a$exports, "title", () => $414885eadc41ac2a$export$fb184b623420d9be, (v) => $414885eadc41ac2a$export$fb184b623420d9be = v);
var $414885eadc41ac2a$export$a7db06668cad9adb;
var $414885eadc41ac2a$export$25eaa035e2e3a214;
var $414885eadc41ac2a$export$881e48a3dd2e86b8;
var $414885eadc41ac2a$export$615455393ee443ca;
var $414885eadc41ac2a$export$eab32dcfc4ded11c;
var $414885eadc41ac2a$export$fb184b623420d9be;
$414885eadc41ac2a$export$a7db06668cad9adb = `sQTtSa_content`;
$414885eadc41ac2a$export$25eaa035e2e3a214 = `sQTtSa_enabled`;
$414885eadc41ac2a$export$881e48a3dd2e86b8 = `sQTtSa_pause-menu`;
$414885eadc41ac2a$export$615455393ee443ca = `sQTtSa_player`;
$414885eadc41ac2a$export$eab32dcfc4ded11c = `sQTtSa_sound`;
$414885eadc41ac2a$export$fb184b623420d9be = `sQTtSa_title`;


const $55ab31902ab8db2b$var$Content = ({ onClose: onClose, onQuit: onQuit, muteCallback: muteCallback })=>{
    const { state: { accountInfo: accountInfo }, dispatch: dispatch } = (0, $c25623cc446ec3c6$export$ac8576a9912be18c)();
    const [soundMuted, setSoundMuted] = (0, $acw62.useState)(window.localStorage.getItem("music-muted") === "true");
    const toggleSound = ()=>{
        Howler.mute(!soundMuted);
        if (muteCallback) muteCallback(!soundMuted);
        window.localStorage.setItem("music-muted", String(!soundMuted));
        setSoundMuted(!soundMuted);
    };
    (0, $acw62.useEffect)(()=>{
        (0, $e16030e48e62d804$export$ce8e199cc2716d76)(0, "pause_player-container", {
            FUR: accountInfo?.character.cosmetics.FUR.equiped,
            EYES: accountInfo?.character.cosmetics.EYES.equiped,
            HEAD: accountInfo?.character.cosmetics.HEAD.equiped,
            TOP: accountInfo?.character.cosmetics.TOP.equiped,
            MOUTH: accountInfo?.character.cosmetics.MOUTH.equiped
        });
    }, [
        accountInfo
    ]);
    const onQuitPrepared = ()=>{
        if ((0, $b3b1baf40467424d$export$745043c7dc65e495).showConfirm) (0, $b3b1baf40467424d$export$745043c7dc65e495).showConfirm({
            title: "Quit game?",
            text: "Are you sure you want to leave the game?",
            acceptText: "quit",
            refuseText: "stay",
            onAccept () {
                if ((0, $b3b1baf40467424d$export$745043c7dc65e495).clearGame) (0, $b3b1baf40467424d$export$745043c7dc65e495).clearGame();
                dispatch({
                    type: "SET_ROOM"
                });
                dispatch({
                    type: "SET_ROOM_METADATA"
                });
                dispatch({
                    type: "SET_ROOM_SESSION"
                });
                onClose();
                onQuit();
            }
        });
    };
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: (0, $9805619f03ed02ef$export$91884aa883243770)((0, (/*@__PURE__*/$parcel$interopDefault($414885eadc41ac2a$exports))), "content"),
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: (0, $9805619f03ed02ef$export$91884aa883243770)((0, (/*@__PURE__*/$parcel$interopDefault($414885eadc41ac2a$exports))), "sound"),
                onClick: toggleSound,
                children: [
                    "Sound",
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $e4ec753f5c716375$export$2b9260d4a45c8710), {
                        className: (0, $9805619f03ed02ef$export$91884aa883243770)((0, (/*@__PURE__*/$parcel$interopDefault($414885eadc41ac2a$exports))), soundMuted ? "" : "enabled"),
                        icon: soundMuted ? "volume-xmark" : "volume-low"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: (0, $9805619f03ed02ef$export$91884aa883243770)((0, (/*@__PURE__*/$parcel$interopDefault($414885eadc41ac2a$exports))), "player"),
                id: "pause_player-container"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $6725244138e0595f$export$353f5b6fc5456de1), {
                className: (0, $9805619f03ed02ef$export$91884aa883243770)((0, (/*@__PURE__*/$parcel$interopDefault($414885eadc41ac2a$exports))), "small"),
                onClick: onQuitPrepared,
                children: "QUIT GAME"
            })
        ]
    });
};
const $55ab31902ab8db2b$var$Title = ({ onClose: onClose })=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: (0, $9805619f03ed02ef$export$91884aa883243770)((0, (/*@__PURE__*/$parcel$interopDefault($414885eadc41ac2a$exports))), "title"),
        children: [
            "Menu",
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                src: `${(0, $0426e2dd5e0de94d$export$24af3971dd36b33f)}/ui/cross.png`,
                alt: "cross",
                onClick: onClose
            })
        ]
    });
const $55ab31902ab8db2b$export$66bb9231a6614ad8 = ({ className: className, onClose: onClose, onQuit: onQuit, muteCallback: muteCallback, ...props })=>{
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $207d23274fe2be11$export$6e63c1000ecf9db8), {
        className: (0, $9805619f03ed02ef$export$91884aa883243770)((0, (/*@__PURE__*/$parcel$interopDefault($414885eadc41ac2a$exports))), `pause-menu ${className}`),
        title: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($55ab31902ab8db2b$var$Title, {
            onClose: onClose
        }),
        content: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($55ab31902ab8db2b$var$Content, {
            onClose: onClose,
            onQuit: onQuit,
            muteCallback: muteCallback
        }),
        onClickBackground: onClose,
        ...props
    });
};





var $acw62 = parcelRequire("acw62");






parcelRequire("acw62");



var $6bb86a74a2986669$exports = {};

$parcel$export($6bb86a74a2986669$exports, "twitter-intent-button", () => $6bb86a74a2986669$export$40e2db0381abb50f, (v) => $6bb86a74a2986669$export$40e2db0381abb50f = v);
var $6bb86a74a2986669$export$40e2db0381abb50f;
$6bb86a74a2986669$export$40e2db0381abb50f = `B1l-rG_twitter-intent-button`;


const $fd78273f4a6fadcf$var$TwitterIntentButton = ({ className: className, intentProperty: intentProperty, intentValue: intentValue, icon: icon, intent: intent, text: text, url: url, hashtags: hashtags, related: related, onClick: onClick, ...props })=>{
    const openWindow = async ()=>{
        const openedWindow = window.open(encodeURI(`https://twitter.com/intent/${intent}?original_referer=${window.location}&ref_src=twsrc^tfw|twcamp^buttonembed|twterm^share|twgr^url=/${intentProperty ? `&${intentProperty}=${intentValue}` : ""}${text ? `&text=${text}` : ""}${url ? `&url=${url}` : ""}${hashtags ? `&hashtags=${hashtags}` : ""}${related ? `&related=${related}` : ""}`), "Oogy Blast - X", "toolbar=1,scrollbars=1,location=0,statusbar=0,menubar=1,resizable=1,width=800,height=600,left=240,top=212");
        if (openedWindow === null) (0, $ad26fe773541dcd3$export$b410431fab84fa58).info("Please disable your adblock to open the X pages");
    };
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $6725244138e0595f$export$e1c22a2ee2645e36), {
        icon: icon,
        className: (0, $9805619f03ed02ef$export$91884aa883243770)((0, (/*@__PURE__*/$parcel$interopDefault($6bb86a74a2986669$exports))), `twitter-intent-button no-color ${className}`),
        onClick: (event)=>{
            if (onClick) onClick(event);
            openWindow();
        },
        ...props
    });
};
const $fd78273f4a6fadcf$export$77aa7f3517b928f6 = ({ className: className, tweetId: tweetId, ...props })=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($fd78273f4a6fadcf$var$TwitterIntentButton, {
        title: "like",
        icon: "heart",
        intent: "like",
        intentProperty: "tweet_id",
        intentValue: tweetId,
        className: (0, $9805619f03ed02ef$export$91884aa883243770)((0, (/*@__PURE__*/$parcel$interopDefault($6bb86a74a2986669$exports))), `like ${className}`),
        ...props
    });
const $fd78273f4a6fadcf$export$e59f168f8b7c3819 = ({ className: className, tweetId: tweetId, ...props })=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($fd78273f4a6fadcf$var$TwitterIntentButton, {
        title: "retweet",
        icon: "retweet",
        intent: "retweet",
        intentProperty: "tweet_id",
        intentValue: tweetId,
        className: (0, $9805619f03ed02ef$export$91884aa883243770)((0, (/*@__PURE__*/$parcel$interopDefault($6bb86a74a2986669$exports))), `retweet ${className}`),
        ...props
    });
const $fd78273f4a6fadcf$export$197ce84a6edb77d7 = ({ className: className, targetScreenName: targetScreenName, ...props })=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($fd78273f4a6fadcf$var$TwitterIntentButton, {
        title: "follow",
        icon: "user-plus",
        intent: "follow",
        intentProperty: "screen_name",
        intentValue: targetScreenName,
        className: (0, $9805619f03ed02ef$export$91884aa883243770)((0, (/*@__PURE__*/$parcel$interopDefault($6bb86a74a2986669$exports))), `follow ${className}`),
        ...props
    });
const $fd78273f4a6fadcf$export$cac1f7de16bcf89 = ({ className: className, text: text, url: url, hashtags: hashtags, related: related, ...props })=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($fd78273f4a6fadcf$var$TwitterIntentButton, {
        title: "tweet",
        icon: [
            "fab",
            "x-twitter"
        ],
        intent: "tweet",
        text: text,
        url: url,
        hashtags: hashtags,
        related: related,
        className: (0, $9805619f03ed02ef$export$91884aa883243770)((0, (/*@__PURE__*/$parcel$interopDefault($6bb86a74a2986669$exports))), `tweet ${className}`),
        ...props
    });






var $c5f232bb6dc595bb$exports = {};

$parcel$export($c5f232bb6dc595bb$exports, "badge", () => $c5f232bb6dc595bb$export$4aebd143f31d0c0d, (v) => $c5f232bb6dc595bb$export$4aebd143f31d0c0d = v);
$parcel$export($c5f232bb6dc595bb$exports, "bounceIn", () => $c5f232bb6dc595bb$export$fccebd7948554554, (v) => $c5f232bb6dc595bb$export$fccebd7948554554 = v);
$parcel$export($c5f232bb6dc595bb$exports, "chest", () => $c5f232bb6dc595bb$export$11c092ac8d4e295c, (v) => $c5f232bb6dc595bb$export$11c092ac8d4e295c = v);
$parcel$export($c5f232bb6dc595bb$exports, "chest-container", () => $c5f232bb6dc595bb$export$ad06d95ce12214f1, (v) => $c5f232bb6dc595bb$export$ad06d95ce12214f1 = v);
$parcel$export($c5f232bb6dc595bb$exports, "chests", () => $c5f232bb6dc595bb$export$ff298d49dd5478e3, (v) => $c5f232bb6dc595bb$export$ff298d49dd5478e3 = v);
$parcel$export($c5f232bb6dc595bb$exports, "container", () => $c5f232bb6dc595bb$export$34e0f9847d4c02dd, (v) => $c5f232bb6dc595bb$export$34e0f9847d4c02dd = v);
$parcel$export($c5f232bb6dc595bb$exports, "gems", () => $c5f232bb6dc595bb$export$b7dcc03c39461775, (v) => $c5f232bb6dc595bb$export$b7dcc03c39461775 = v);
$parcel$export($c5f232bb6dc595bb$exports, "image", () => $c5f232bb6dc595bb$export$5c452ff88e35e47d, (v) => $c5f232bb6dc595bb$export$5c452ff88e35e47d = v);
$parcel$export($c5f232bb6dc595bb$exports, "light", () => $c5f232bb6dc595bb$export$a43af521ac8c3202, (v) => $c5f232bb6dc595bb$export$a43af521ac8c3202 = v);
$parcel$export($c5f232bb6dc595bb$exports, "middle-line", () => $c5f232bb6dc595bb$export$a8f14f946401df1d, (v) => $c5f232bb6dc595bb$export$a8f14f946401df1d = v);
$parcel$export($c5f232bb6dc595bb$exports, "no-chest", () => $c5f232bb6dc595bb$export$7fa6949537173b11, (v) => $c5f232bb6dc595bb$export$7fa6949537173b11 = v);
$parcel$export($c5f232bb6dc595bb$exports, "player", () => $c5f232bb6dc595bb$export$615455393ee443ca, (v) => $c5f232bb6dc595bb$export$615455393ee443ca = v);
$parcel$export($c5f232bb6dc595bb$exports, "rewards", () => $c5f232bb6dc595bb$export$4b2cb815b21f438d, (v) => $c5f232bb6dc595bb$export$4b2cb815b21f438d = v);
$parcel$export($c5f232bb6dc595bb$exports, "rotating", () => $c5f232bb6dc595bb$export$bfd64c937657f93a, (v) => $c5f232bb6dc595bb$export$bfd64c937657f93a = v);
$parcel$export($c5f232bb6dc595bb$exports, "score", () => $c5f232bb6dc595bb$export$e55b6242cf16bbb8, (v) => $c5f232bb6dc595bb$export$e55b6242cf16bbb8 = v);
$parcel$export($c5f232bb6dc595bb$exports, "score-container", () => $c5f232bb6dc595bb$export$30371f4d0a86b4a4, (v) => $c5f232bb6dc595bb$export$30371f4d0a86b4a4 = v);
$parcel$export($c5f232bb6dc595bb$exports, "shadow", () => $c5f232bb6dc595bb$export$b8972b998723d602, (v) => $c5f232bb6dc595bb$export$b8972b998723d602 = v);
$parcel$export($c5f232bb6dc595bb$exports, "skip", () => $c5f232bb6dc595bb$export$955fc4a6c4be454d, (v) => $c5f232bb6dc595bb$export$955fc4a6c4be454d = v);
$parcel$export($c5f232bb6dc595bb$exports, "title", () => $c5f232bb6dc595bb$export$fb184b623420d9be, (v) => $c5f232bb6dc595bb$export$fb184b623420d9be = v);
$parcel$export($c5f232bb6dc595bb$exports, "top-line", () => $c5f232bb6dc595bb$export$63fd42f86387895b, (v) => $c5f232bb6dc595bb$export$63fd42f86387895b = v);
var $c5f232bb6dc595bb$export$4aebd143f31d0c0d;
var $c5f232bb6dc595bb$export$fccebd7948554554;
var $c5f232bb6dc595bb$export$11c092ac8d4e295c;
var $c5f232bb6dc595bb$export$ad06d95ce12214f1;
var $c5f232bb6dc595bb$export$ff298d49dd5478e3;
var $c5f232bb6dc595bb$export$34e0f9847d4c02dd;
var $c5f232bb6dc595bb$export$b7dcc03c39461775;
var $c5f232bb6dc595bb$export$5c452ff88e35e47d;
var $c5f232bb6dc595bb$export$a43af521ac8c3202;
var $c5f232bb6dc595bb$export$a8f14f946401df1d;
var $c5f232bb6dc595bb$export$7fa6949537173b11;
var $c5f232bb6dc595bb$export$615455393ee443ca;
var $c5f232bb6dc595bb$export$4b2cb815b21f438d;
var $c5f232bb6dc595bb$export$bfd64c937657f93a;
var $c5f232bb6dc595bb$export$e55b6242cf16bbb8;
var $c5f232bb6dc595bb$export$30371f4d0a86b4a4;
var $c5f232bb6dc595bb$export$b8972b998723d602;
var $c5f232bb6dc595bb$export$955fc4a6c4be454d;
var $c5f232bb6dc595bb$export$fb184b623420d9be;
var $c5f232bb6dc595bb$export$63fd42f86387895b;
$c5f232bb6dc595bb$export$4aebd143f31d0c0d = `fnlHsq_badge`;
$c5f232bb6dc595bb$export$fccebd7948554554 = `fnlHsq_bounceIn`;
$c5f232bb6dc595bb$export$fccebd7948554554;
$c5f232bb6dc595bb$export$11c092ac8d4e295c = `fnlHsq_chest`;
$c5f232bb6dc595bb$export$ad06d95ce12214f1 = `fnlHsq_chest-container`;
$c5f232bb6dc595bb$export$ff298d49dd5478e3 = `fnlHsq_chests`;
$c5f232bb6dc595bb$export$34e0f9847d4c02dd = `fnlHsq_container`;
$c5f232bb6dc595bb$export$b7dcc03c39461775 = `fnlHsq_gems`;
$c5f232bb6dc595bb$export$5c452ff88e35e47d = `fnlHsq_image`;
$c5f232bb6dc595bb$export$a43af521ac8c3202 = `fnlHsq_light`;
$c5f232bb6dc595bb$export$a8f14f946401df1d = `fnlHsq_middle-line`;
$c5f232bb6dc595bb$export$7fa6949537173b11 = `fnlHsq_no-chest`;
$c5f232bb6dc595bb$export$615455393ee443ca = `fnlHsq_player`;
$c5f232bb6dc595bb$export$4b2cb815b21f438d = `fnlHsq_rewards`;
$c5f232bb6dc595bb$export$bfd64c937657f93a = `fnlHsq_rotating`;
$c5f232bb6dc595bb$export$bfd64c937657f93a;
$c5f232bb6dc595bb$export$e55b6242cf16bbb8 = `fnlHsq_score`;
$c5f232bb6dc595bb$export$30371f4d0a86b4a4 = `fnlHsq_score-container`;
$c5f232bb6dc595bb$export$b8972b998723d602 = `fnlHsq_shadow`;
$c5f232bb6dc595bb$export$955fc4a6c4be454d = `fnlHsq_skip`;
$c5f232bb6dc595bb$export$fb184b623420d9be = `fnlHsq_title`;
$c5f232bb6dc595bb$export$63fd42f86387895b = `fnlHsq_top-line`;


const $4a03d27093a4ff46$export$6735cf84ecd2736 = ({ className: className, score: score, gems: gems, onClose: onClose, ...props })=>{
    const { state: { accountInfo: accountInfo } } = (0, $c25623cc446ec3c6$export$ac8576a9912be18c)();
    const [loading, setLoading] = (0, $acw62.useState)(false);
    const selectChest = async (index, type)=>{
        if (!accountInfo) return;
        const freeSlot = Object.entries(accountInfo.chests).find(([, entry])=>entry.unlocked && !entry.type);
        if (!freeSlot) {
            if ((0, $b3b1baf40467424d$export$745043c7dc65e495).showModal) (0, $b3b1baf40467424d$export$745043c7dc65e495).showModal({
                title: "No empty slot",
                text: "Open, burn or buy a new chest slot (if available) to keep an additional chest"
            });
            return;
        }
        if ((0, $b3b1baf40467424d$export$745043c7dc65e495).showConfirm) (0, $b3b1baf40467424d$export$745043c7dc65e495).showConfirm({
            title: `Keep the "${type.toUpperCase()}" chest?`,
            acceptText: "yes",
            refuseText: "no",
            onAccept: async ()=>{
                setLoading(true);
                const result = await (0, $35a528e84618b070$export$f9acc3183a46a920)(index);
                if (result?.data && (0, $b3b1baf40467424d$export$745043c7dc65e495).refreshAccountInfo) (0, $b3b1baf40467424d$export$745043c7dc65e495).refreshAccountInfo();
                setLoading(false);
            }
        });
    };
    const onClosePrepared = ()=>{
        if (Object.values(accountInfo?.wonChests ?? {}).length > 0 && (0, $b3b1baf40467424d$export$745043c7dc65e495).showConfirm) (0, $b3b1baf40467424d$export$745043c7dc65e495).showConfirm({
            title: "Are you sure?",
            text: "If you skip, you will lose all the remaining chests earned this round",
            acceptText: "yes",
            refuseText: "no",
            onAccept: ()=>{
                (0, $35a528e84618b070$export$8a18bf6ea8cb2bd9)().then(()=>{
                    if ((0, $b3b1baf40467424d$export$745043c7dc65e495).refreshAccountInfo) (0, $b3b1baf40467424d$export$745043c7dc65e495).refreshAccountInfo();
                });
                (0, $0c69c9c512bb7a3f$export$31feb4e10852ccbd)();
                onClose();
            }
        });
        else {
            (0, $0c69c9c512bb7a3f$export$31feb4e10852ccbd)();
            onClose();
        }
    };
    (0, $acw62.useEffect)(()=>{
        (0, $0c69c9c512bb7a3f$export$31feb4e10852ccbd)();
    }, []);
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: (0, $9805619f03ed02ef$export$91884aa883243770)((0, (/*@__PURE__*/$parcel$interopDefault($c5f232bb6dc595bb$exports))), `score reveal-element ${className}`),
        ...props,
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $d476126f9afdc959$export$668799e4797757a8), {
                className: "high"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: (0, $9805619f03ed02ef$export$91884aa883243770)((0, (/*@__PURE__*/$parcel$interopDefault($c5f232bb6dc595bb$exports))), "score-container"),
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        className: (0, $9805619f03ed02ef$export$91884aa883243770)((0, (/*@__PURE__*/$parcel$interopDefault($c5f232bb6dc595bb$exports))), "title"),
                        children: "Game Over"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: (0, $9805619f03ed02ef$export$91884aa883243770)((0, (/*@__PURE__*/$parcel$interopDefault($c5f232bb6dc595bb$exports))), "container"),
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: (0, $9805619f03ed02ef$export$91884aa883243770)((0, (/*@__PURE__*/$parcel$interopDefault($c5f232bb6dc595bb$exports))), "top-line"),
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                                        src: `${(0, $0426e2dd5e0de94d$export$24af3971dd36b33f)}/ui/trophy.png`,
                                        alt: "trophy"
                                    }),
                                    " ",
                                    (0, $9805619f03ed02ef$export$2e1efffb4405e7a8)(score),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $fd78273f4a6fadcf$export$cac1f7de16bcf89), {
                                        className: "small",
                                        text: "Had a blast playing Oogy Blast! @oogyNFT",
                                        related: "oogyNFT",
                                        hashtags: "oogyNFT"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                className: (0, $9805619f03ed02ef$export$91884aa883243770)((0, (/*@__PURE__*/$parcel$interopDefault($c5f232bb6dc595bb$exports))), "middle-line"),
                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                    className: (0, $9805619f03ed02ef$export$91884aa883243770)((0, (/*@__PURE__*/$parcel$interopDefault($c5f232bb6dc595bb$exports))), "rewards"),
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                            className: (0, $9805619f03ed02ef$export$91884aa883243770)((0, (/*@__PURE__*/$parcel$interopDefault($c5f232bb6dc595bb$exports))), "gems"),
                                            children: [
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                                                    src: `${(0, $0426e2dd5e0de94d$export$24af3971dd36b33f)}/ui/gem.png`,
                                                    alt: "gem"
                                                }),
                                                gems,
                                                " EARNED"
                                            ]
                                        }),
                                        Object.entries(accountInfo?.wonChests ?? {}).length > 0 ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                                            children: [
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                    className: (0, $9805619f03ed02ef$export$91884aa883243770)((0, (/*@__PURE__*/$parcel$interopDefault($c5f232bb6dc595bb$exports))), "chests"),
                                                    children: Object.entries(accountInfo?.wonChests ?? {}).map(([index, type])=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                            className: (0, $9805619f03ed02ef$export$91884aa883243770)((0, (/*@__PURE__*/$parcel$interopDefault($c5f232bb6dc595bb$exports))), `chest ${(0, $b66fc98e4eed8243$export$64b16c65d143d94d)[type]}`),
                                                            onClick: ()=>selectChest(Number(index), type),
                                                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                                className: (0, $9805619f03ed02ef$export$91884aa883243770)((0, (/*@__PURE__*/$parcel$interopDefault($c5f232bb6dc595bb$exports))), "chest-container"),
                                                                children: [
                                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $e2407f67ab2c799c$export$37acb3580601e69a), {
                                                                        className: `${(0, $b66fc98e4eed8243$export$64b16c65d143d94d)[type]} ${(0, $9805619f03ed02ef$export$91884aa883243770)((0, (/*@__PURE__*/$parcel$interopDefault($c5f232bb6dc595bb$exports))), "badge")}`,
                                                                        children: type
                                                                    }),
                                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                                                                        className: (0, $9805619f03ed02ef$export$91884aa883243770)((0, (/*@__PURE__*/$parcel$interopDefault($c5f232bb6dc595bb$exports))), "light"),
                                                                        src: `${(0, $0426e2dd5e0de94d$export$24af3971dd36b33f)}/ui/star-light.png`,
                                                                        alt: "light"
                                                                    }),
                                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                                                                        className: (0, $9805619f03ed02ef$export$91884aa883243770)((0, (/*@__PURE__*/$parcel$interopDefault($c5f232bb6dc595bb$exports))), "image"),
                                                                        src: `${(0, $0426e2dd5e0de94d$export$24af3971dd36b33f)}/ui/chests/${type}-chest.png`,
                                                                        alt: `${type}-chest`
                                                                    })
                                                                ]
                                                            }, `chest-container-${index}`)
                                                        }, `chest-${index}`))
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                    children: "Select chests to keep"
                                                })
                                            ]
                                        }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                            className: (0, $9805619f03ed02ef$export$91884aa883243770)((0, (/*@__PURE__*/$parcel$interopDefault($c5f232bb6dc595bb$exports))), "no-chest"),
                                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                children: [
                                                    "no chests earned.",
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("br", {}),
                                                    "better luck next time!"
                                                ]
                                            })
                                        })
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $b66fc98e4eed8243$export$ca8dc42bbb6f2e22), {
                                className: (0, $9805619f03ed02ef$export$91884aa883243770)((0, (/*@__PURE__*/$parcel$interopDefault($c5f232bb6dc595bb$exports))), "chests")
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $6725244138e0595f$export$353f5b6fc5456de1), {
                                className: (0, $9805619f03ed02ef$export$91884aa883243770)((0, (/*@__PURE__*/$parcel$interopDefault($c5f232bb6dc595bb$exports))), "skip"),
                                onClick: onClosePrepared,
                                loading: loading,
                                children: "SKIP"
                            })
                        ]
                    })
                ]
            })
        ]
    });
};






var $acw62 = parcelRequire("acw62");







var $gNDby = parcelRequire("gNDby");


var $acw62 = parcelRequire("acw62");






var $ff0b0ecebe8a93fa$exports = {};

$parcel$export($ff0b0ecebe8a93fa$exports, "buy-gems", () => $ff0b0ecebe8a93fa$export$1a2fa2ea438b3652, (v) => $ff0b0ecebe8a93fa$export$1a2fa2ea438b3652 = v);
$parcel$export($ff0b0ecebe8a93fa$exports, "content", () => $ff0b0ecebe8a93fa$export$a7db06668cad9adb, (v) => $ff0b0ecebe8a93fa$export$a7db06668cad9adb = v);
$parcel$export($ff0b0ecebe8a93fa$exports, "details", () => $ff0b0ecebe8a93fa$export$41ee12f6f6f05843, (v) => $ff0b0ecebe8a93fa$export$41ee12f6f6f05843 = v);
$parcel$export($ff0b0ecebe8a93fa$exports, "discount", () => $ff0b0ecebe8a93fa$export$c6275193bf7056d3, (v) => $ff0b0ecebe8a93fa$export$c6275193bf7056d3 = v);
$parcel$export($ff0b0ecebe8a93fa$exports, "gems", () => $ff0b0ecebe8a93fa$export$b7dcc03c39461775, (v) => $ff0b0ecebe8a93fa$export$b7dcc03c39461775 = v);
$parcel$export($ff0b0ecebe8a93fa$exports, "gems-1", () => $ff0b0ecebe8a93fa$export$df1d71fb016cc765, (v) => $ff0b0ecebe8a93fa$export$df1d71fb016cc765 = v);
$parcel$export($ff0b0ecebe8a93fa$exports, "gems-2", () => $ff0b0ecebe8a93fa$export$f7a29243b5a26e24, (v) => $ff0b0ecebe8a93fa$export$f7a29243b5a26e24 = v);
$parcel$export($ff0b0ecebe8a93fa$exports, "gems-3", () => $ff0b0ecebe8a93fa$export$48a949a20a21c309, (v) => $ff0b0ecebe8a93fa$export$48a949a20a21c309 = v);
$parcel$export($ff0b0ecebe8a93fa$exports, "price", () => $ff0b0ecebe8a93fa$export$321c0b1a406de31f, (v) => $ff0b0ecebe8a93fa$export$321c0b1a406de31f = v);
$parcel$export($ff0b0ecebe8a93fa$exports, "tile", () => $ff0b0ecebe8a93fa$export$3c17558da18e4d75, (v) => $ff0b0ecebe8a93fa$export$3c17558da18e4d75 = v);
$parcel$export($ff0b0ecebe8a93fa$exports, "title", () => $ff0b0ecebe8a93fa$export$fb184b623420d9be, (v) => $ff0b0ecebe8a93fa$export$fb184b623420d9be = v);
var $ff0b0ecebe8a93fa$export$1a2fa2ea438b3652;
var $ff0b0ecebe8a93fa$export$a7db06668cad9adb;
var $ff0b0ecebe8a93fa$export$41ee12f6f6f05843;
var $ff0b0ecebe8a93fa$export$c6275193bf7056d3;
var $ff0b0ecebe8a93fa$export$b7dcc03c39461775;
var $ff0b0ecebe8a93fa$export$df1d71fb016cc765;
var $ff0b0ecebe8a93fa$export$f7a29243b5a26e24;
var $ff0b0ecebe8a93fa$export$48a949a20a21c309;
var $ff0b0ecebe8a93fa$export$321c0b1a406de31f;
var $ff0b0ecebe8a93fa$export$3c17558da18e4d75;
var $ff0b0ecebe8a93fa$export$fb184b623420d9be;
$ff0b0ecebe8a93fa$export$1a2fa2ea438b3652 = `_0QTAvq_buy-gems`;
$ff0b0ecebe8a93fa$export$a7db06668cad9adb = `_0QTAvq_content`;
$ff0b0ecebe8a93fa$export$41ee12f6f6f05843 = `_0QTAvq_details`;
$ff0b0ecebe8a93fa$export$c6275193bf7056d3 = `_0QTAvq_discount`;
$ff0b0ecebe8a93fa$export$b7dcc03c39461775 = `_0QTAvq_gems`;
$ff0b0ecebe8a93fa$export$df1d71fb016cc765 = `_0QTAvq_gems-1`;
$ff0b0ecebe8a93fa$export$f7a29243b5a26e24 = `_0QTAvq_gems-2`;
$ff0b0ecebe8a93fa$export$48a949a20a21c309 = `_0QTAvq_gems-3`;
$ff0b0ecebe8a93fa$export$321c0b1a406de31f = `_0QTAvq_price`;
$ff0b0ecebe8a93fa$export$3c17558da18e4d75 = `_0QTAvq_tile`;
$ff0b0ecebe8a93fa$export$fb184b623420d9be = `_0QTAvq_title`;



var $6ZWSX = parcelRequire("6ZWSX");
var $352d1692cbb387fd$require$Buffer = $6ZWSX.Buffer;
const $352d1692cbb387fd$var$Content = ()=>{
    const { state: { publicKey: publicKey } } = (0, $c25623cc446ec3c6$export$ac8576a9912be18c)();
    const { connection: connection } = (0, $86c338e4d5b0d511$export$985e8768c0e91dbc)();
    const [loading, setLoading] = (0, $acw62.useState)(false);
    const buyGems = async (quantity, sol)=>{
        if (loading) return;
        if ((0, $b3b1baf40467424d$export$745043c7dc65e495).showConfirm) (0, $b3b1baf40467424d$export$745043c7dc65e495).showConfirm({
            title: `Buy ${quantity} gems`,
            text: `Are you sure you want to buy ${quantity} gems for ${sol} SOL?`,
            acceptText: "buy",
            refuseText: "cancel",
            onAccept: async ()=>{
                if (!publicKey || !(0, $b3b1baf40467424d$export$745043c7dc65e495).sendTransaction || !(0, $b3b1baf40467424d$export$745043c7dc65e495).showLoading) return;
                setLoading(true);
                try {
                    const invoiceResponse = await (0, $35a528e84618b070$export$ad9fce45729b6a0e)(quantity);
                    if (!invoiceResponse || invoiceResponse.status !== 200) {
                        (0, $ad26fe773541dcd3$export$b410431fab84fa58).error("Impossible to generate an invoice id");
                        return;
                    }
                    const invoiceData = invoiceResponse.data;
                    const blockhashInfo = await connection.getLatestBlockhashAndContext();
                    const transferTransaction = new (0, $gNDby.Transaction)().add((0, $gNDby.SystemProgram).transfer({
                        fromPubkey: new (0, $gNDby.PublicKey)(publicKey),
                        toPubkey: new (0, $gNDby.PublicKey)(invoiceData.receiverPublicKey),
                        lamports: (0, $gNDby.LAMPORTS_PER_SOL) * invoiceData.price
                    }));
                    transferTransaction.add(new (0, $gNDby.TransactionInstruction)({
                        keys: [
                            {
                                pubkey: new (0, $gNDby.PublicKey)(publicKey),
                                isSigner: true,
                                isWritable: true
                            }
                        ],
                        data: $352d1692cbb387fd$require$Buffer.from(invoiceData.invoiceId, "utf-8"),
                        programId: new (0, $gNDby.PublicKey)("MemoSq4gqABAXKb96qnH8TysNcWxMyWCqXgDLGmfcHr")
                    }));
                    transferTransaction.minNonceContextSlot = blockhashInfo.context.slot;
                    transferTransaction.recentBlockhash = blockhashInfo.value.blockhash;
                    transferTransaction.lastValidBlockHeight = blockhashInfo.value.lastValidBlockHeight;
                    (0, $b3b1baf40467424d$export$745043c7dc65e495).showLoading(true, undefined, "Buying gems...");
                    const signature = await (0, $b3b1baf40467424d$export$745043c7dc65e495).sendTransaction(transferTransaction, connection, {
                        minContextSlot: blockhashInfo.context.slot
                    });
                    const checkResponse = await (0, $35a528e84618b070$export$cad5256e969c1910)(invoiceData.invoiceId, signature);
                    if (!checkResponse || checkResponse.status !== 200) (0, $ad26fe773541dcd3$export$b410431fab84fa58).error("Impossible to validate the invoice, please contact the support team");
                    else {
                        if ((0, $b3b1baf40467424d$export$745043c7dc65e495).refreshAccountInfo) (0, $b3b1baf40467424d$export$745043c7dc65e495).refreshAccountInfo();
                        (0, $ad26fe773541dcd3$export$b410431fab84fa58).success(`You successfully bought ${quantity} gems!`);
                    }
                } catch (err) {
                    console.dir(err);
                    if (err instanceof (0, $3c176f8d57de1623$export$3f5ccdf96415785c)) (0, $ad26fe773541dcd3$export$b410431fab84fa58).error("Wallet not connected, please try to disconnect and reconnect");
                    if (typeof err === "string") (0, $ad26fe773541dcd3$export$b410431fab84fa58).error(err);
                }
                (0, $b3b1baf40467424d$export$745043c7dc65e495).showLoading(false);
                setLoading(false);
            }
        });
    };
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: (0, $9805619f03ed02ef$export$91884aa883243770)((0, (/*@__PURE__*/$parcel$interopDefault($ff0b0ecebe8a93fa$exports))), "content"),
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: (0, $9805619f03ed02ef$export$91884aa883243770)((0, (/*@__PURE__*/$parcel$interopDefault($ff0b0ecebe8a93fa$exports))), "tile"),
                onClick: ()=>buyGems(100, 0.05),
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: (0, $9805619f03ed02ef$export$91884aa883243770)((0, (/*@__PURE__*/$parcel$interopDefault($ff0b0ecebe8a93fa$exports))), "details"),
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                className: (0, $9805619f03ed02ef$export$91884aa883243770)((0, (/*@__PURE__*/$parcel$interopDefault($ff0b0ecebe8a93fa$exports))), "gems gems-1"),
                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                                    src: `${(0, $0426e2dd5e0de94d$export$24af3971dd36b33f)}/ui/gem.png`,
                                    alt: "gem"
                                })
                            }),
                            "100 GEMS"
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: (0, $9805619f03ed02ef$export$91884aa883243770)((0, (/*@__PURE__*/$parcel$interopDefault($ff0b0ecebe8a93fa$exports))), "price"),
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                                src: `${(0, $0426e2dd5e0de94d$export$24af3971dd36b33f)}/ui/sol.png`,
                                alt: "sol"
                            }),
                            "0.05"
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: (0, $9805619f03ed02ef$export$91884aa883243770)((0, (/*@__PURE__*/$parcel$interopDefault($ff0b0ecebe8a93fa$exports))), "tile"),
                onClick: ()=>buyGems(500, 0.2),
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: (0, $9805619f03ed02ef$export$91884aa883243770)((0, (/*@__PURE__*/$parcel$interopDefault($ff0b0ecebe8a93fa$exports))), "details"),
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: (0, $9805619f03ed02ef$export$91884aa883243770)((0, (/*@__PURE__*/$parcel$interopDefault($ff0b0ecebe8a93fa$exports))), "gems gems-2"),
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                                        src: `${(0, $0426e2dd5e0de94d$export$24af3971dd36b33f)}/ui/gem.png`,
                                        alt: "gem"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                                        src: `${(0, $0426e2dd5e0de94d$export$24af3971dd36b33f)}/ui/gem.png`,
                                        alt: "gem"
                                    })
                                ]
                            }),
                            "500 GEMS"
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: (0, $9805619f03ed02ef$export$91884aa883243770)((0, (/*@__PURE__*/$parcel$interopDefault($ff0b0ecebe8a93fa$exports))), "price"),
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                className: (0, $9805619f03ed02ef$export$91884aa883243770)((0, (/*@__PURE__*/$parcel$interopDefault($ff0b0ecebe8a93fa$exports))), "discount"),
                                children: "-20%"
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                                src: `${(0, $0426e2dd5e0de94d$export$24af3971dd36b33f)}/ui/sol.png`,
                                alt: "sol"
                            }),
                            "0.2"
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: (0, $9805619f03ed02ef$export$91884aa883243770)((0, (/*@__PURE__*/$parcel$interopDefault($ff0b0ecebe8a93fa$exports))), "tile"),
                onClick: ()=>buyGems(2000, 0.5),
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: (0, $9805619f03ed02ef$export$91884aa883243770)((0, (/*@__PURE__*/$parcel$interopDefault($ff0b0ecebe8a93fa$exports))), "details"),
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: (0, $9805619f03ed02ef$export$91884aa883243770)((0, (/*@__PURE__*/$parcel$interopDefault($ff0b0ecebe8a93fa$exports))), "gems gems-3"),
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                                        src: `${(0, $0426e2dd5e0de94d$export$24af3971dd36b33f)}/ui/gem.png`,
                                        alt: "gem"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                                        src: `${(0, $0426e2dd5e0de94d$export$24af3971dd36b33f)}/ui/gem.png`,
                                        alt: "gem"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                                        src: `${(0, $0426e2dd5e0de94d$export$24af3971dd36b33f)}/ui/gem.png`,
                                        alt: "gem"
                                    })
                                ]
                            }),
                            "2000 GEMS"
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: (0, $9805619f03ed02ef$export$91884aa883243770)((0, (/*@__PURE__*/$parcel$interopDefault($ff0b0ecebe8a93fa$exports))), "price"),
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                className: (0, $9805619f03ed02ef$export$91884aa883243770)((0, (/*@__PURE__*/$parcel$interopDefault($ff0b0ecebe8a93fa$exports))), "discount"),
                                children: "-50%"
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                                src: `${(0, $0426e2dd5e0de94d$export$24af3971dd36b33f)}/ui/sol.png`,
                                alt: "sol"
                            }),
                            "0.5"
                        ]
                    })
                ]
            })
        ]
    });
};
const $352d1692cbb387fd$var$Title = ({ onClose: onClose })=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: (0, $9805619f03ed02ef$export$91884aa883243770)((0, (/*@__PURE__*/$parcel$interopDefault($ff0b0ecebe8a93fa$exports))), "title"),
        children: [
            "Buy gems",
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                src: `${(0, $0426e2dd5e0de94d$export$24af3971dd36b33f)}/ui/cross.png`,
                alt: "cross",
                onClick: onClose
            })
        ]
    });
const $352d1692cbb387fd$export$ba9d9247397e31aa = ({ className: className, onClose: onClose, ...props })=>{
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $207d23274fe2be11$export$6e63c1000ecf9db8), {
        className: (0, $9805619f03ed02ef$export$91884aa883243770)((0, (/*@__PURE__*/$parcel$interopDefault($ff0b0ecebe8a93fa$exports))), `buy-gems ${className}`),
        title: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($352d1692cbb387fd$var$Title, {
            onClose: onClose
        }),
        content: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($352d1692cbb387fd$var$Content, {}),
        onClickBackground: onClose,
        ...props
    });
};






var $acw62 = parcelRequire("acw62");



const $995765860f493c1e$export$d77c50dae9576df5 = async (ownerAddress, collection)=>{
    const res = await (0, $57966c7e0affc4cb$export$2e2bcd8739ae039).post("https://rpc.hellomoon.io/9ebf282c-577a-45d4-bf84-6a597eda3091", {
        jsonrpc: "2.0",
        id: "get-compressed-nfts",
        method: "searchAssets",
        params: {
            ownerAddress: ownerAddress,
            page: 1,
            limit: 1000,
            compressed: true,
            grouping: [
                "collection",
                collection
            ]
        }
    }, {
        headers: {
            "Content-Type": "application/json"
        }
    });
    const { result: result } = await res.data;
    const nfts = result?.items ?? [];
    return nfts;
};







var $639441d8fdf4cf0e$exports = {};
"use strict";
var $639441d8fdf4cf0e$var$__createBinding = $639441d8fdf4cf0e$exports && $639441d8fdf4cf0e$exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $639441d8fdf4cf0e$var$__exportStar = $639441d8fdf4cf0e$exports && $639441d8fdf4cf0e$exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $639441d8fdf4cf0e$var$__createBinding(exports1, m, p);
};
Object.defineProperty($639441d8fdf4cf0e$exports, "__esModule", {
    value: true
});

$639441d8fdf4cf0e$var$__exportStar((parcelRequire("5dlKa")), $639441d8fdf4cf0e$exports);

$639441d8fdf4cf0e$var$__exportStar((parcelRequire("l0Lrl")), $639441d8fdf4cf0e$exports);

$639441d8fdf4cf0e$var$__exportStar((parcelRequire("3JSSJ")), $639441d8fdf4cf0e$exports);



var $gNDby = parcelRequire("gNDby");


const $03d845dbbcbc291b$export$fa1b8796aaeb6718 = async (numberOfVessels, connection, publicKey, signAllTransactions, callback)=>{
    if (!signAllTransactions) return;
    (0, $ad26fe773541dcd3$export$b410431fab84fa58).info("Creating the transaction...");
    const result = await (0, $35a528e84618b070$export$ddd1b76aad54589d)(numberOfVessels);
    const data = result?.data;
    if (data) {
        const transactions = [];
        const { context: { slot: minContextSlot }, value: { blockhash: blockhash, lastValidBlockHeight: lastValidBlockHeight } } = await connection.getLatestBlockhashAndContext();
        data.forEach(({ assetId: assetId, transactionData: transactionData })=>{
            const transaction = new (0, $gNDby.Transaction)();
            transaction.recentBlockhash = blockhash;
            transaction.lastValidBlockHeight = lastValidBlockHeight;
            transaction.minNonceContextSlot = minContextSlot;
            transaction.feePayer = new (0, $gNDby.PublicKey)(publicKey);
            const prepareData = {
                accounts: {
                    merkleTree: new (0, $gNDby.PublicKey)(transactionData.accounts.merkleTree),
                    treeAuthority: new (0, $gNDby.PublicKey)(transactionData.accounts.treeAuthority),
                    leafOwner: new (0, $gNDby.PublicKey)(transactionData.accounts.leafOwner),
                    leafDelegate: new (0, $gNDby.PublicKey)(transactionData.accounts.leafDelegate),
                    newLeafOwner: new (0, $gNDby.PublicKey)(transactionData.accounts.newLeafOwner),
                    logWrapper: new (0, $gNDby.PublicKey)(transactionData.accounts.logWrapper),
                    compressionProgram: new (0, $gNDby.PublicKey)(transactionData.accounts.compressionProgram),
                    anchorRemainingAccounts: transactionData.accounts.anchorRemainingAccounts.map((entry)=>({
                            ...entry,
                            pubkey: new (0, $gNDby.PublicKey)(entry.pubkey)
                        }))
                },
                args: transactionData.args,
                programId: new (0, $gNDby.PublicKey)(transactionData.programId)
            };
            const transferTx = (0, $639441d8fdf4cf0e$exports.createTransferInstruction)(prepareData.accounts, prepareData.args, prepareData.programId);
            transaction.add(transferTx);
            transactions.push({
                assetId: assetId,
                transaction: transaction,
                status: "waiting"
            });
        });
        const signedTransactions = await signAllTransactions(transactions.map((entry)=>entry.transaction));
        await Promise.all(signedTransactions.map(async (transaction, index)=>{
            const signature = await connection.sendRawTransaction(transaction.serialize(), {
                minContextSlot: minContextSlot
            });
            transactions[index].signature = signature;
        }));
        callback(true, transactions.filter((entry)=>entry.status === "waiting").length, transactions.filter((entry)=>entry.status === "validated").length, transactions.filter((entry)=>entry.status === "failed").length);
        let verifyCount = 0;
        do {
            await Promise.all(transactions.filter((entry)=>entry.status === "waiting").map(async (transaction)=>{
                if (!transaction.signature) return;
                const verifyResponse = await (0, $35a528e84618b070$export$783917a48fbd6b16)(transaction.assetId, transaction.signature);
                if (verifyResponse?.status === 200) transaction.status = "validated";
                callback(true, transactions.filter((entry)=>entry.status === "waiting").length, transactions.filter((entry)=>entry.status === "validated").length, transactions.filter((entry)=>entry.status === "failed").length);
            }));
            if (verifyCount++ >= 0) transactions.forEach((entry)=>{
                if (entry.status === "waiting") entry.status = "failed";
            });
            callback(true, transactions.filter((entry)=>entry.status === "waiting").length, transactions.filter((entry)=>entry.status === "validated").length, transactions.filter((entry)=>entry.status === "failed").length);
        }while (transactions.find((entry)=>entry.status === "waiting"));
    }
};


var $1418f64bf1ea1583$exports = {};

$parcel$export($1418f64bf1ea1583$exports, "amount", () => $1418f64bf1ea1583$export$802cfe72001a1ee, (v) => $1418f64bf1ea1583$export$802cfe72001a1ee = v);
$parcel$export($1418f64bf1ea1583$exports, "balance", () => $1418f64bf1ea1583$export$13efda6d80c8a88, (v) => $1418f64bf1ea1583$export$13efda6d80c8a88 = v);
$parcel$export($1418f64bf1ea1583$exports, "content", () => $1418f64bf1ea1583$export$a7db06668cad9adb, (v) => $1418f64bf1ea1583$export$a7db06668cad9adb = v);
$parcel$export($1418f64bf1ea1583$exports, "deposit-vessels", () => $1418f64bf1ea1583$export$c7d5e207ac813a94, (v) => $1418f64bf1ea1583$export$c7d5e207ac813a94 = v);
$parcel$export($1418f64bf1ea1583$exports, "description", () => $1418f64bf1ea1583$export$6d59db4903f20f7d, (v) => $1418f64bf1ea1583$export$6d59db4903f20f7d = v);
$parcel$export($1418f64bf1ea1583$exports, "error", () => $1418f64bf1ea1583$export$a3bc9b8ed74fc, (v) => $1418f64bf1ea1583$export$a3bc9b8ed74fc = v);
$parcel$export($1418f64bf1ea1583$exports, "input", () => $1418f64bf1ea1583$export$b7e3ae3d7c15e42e, (v) => $1418f64bf1ea1583$export$b7e3ae3d7c15e42e = v);
$parcel$export($1418f64bf1ea1583$exports, "subtitle", () => $1418f64bf1ea1583$export$c96745152eb2740f, (v) => $1418f64bf1ea1583$export$c96745152eb2740f = v);
$parcel$export($1418f64bf1ea1583$exports, "title", () => $1418f64bf1ea1583$export$fb184b623420d9be, (v) => $1418f64bf1ea1583$export$fb184b623420d9be = v);
$parcel$export($1418f64bf1ea1583$exports, "vessel", () => $1418f64bf1ea1583$export$5f63db1d988def4d, (v) => $1418f64bf1ea1583$export$5f63db1d988def4d = v);
$parcel$export($1418f64bf1ea1583$exports, "vessels", () => $1418f64bf1ea1583$export$14fb490a0ca021ea, (v) => $1418f64bf1ea1583$export$14fb490a0ca021ea = v);
var $1418f64bf1ea1583$export$802cfe72001a1ee;
var $1418f64bf1ea1583$export$13efda6d80c8a88;
var $1418f64bf1ea1583$export$a7db06668cad9adb;
var $1418f64bf1ea1583$export$c7d5e207ac813a94;
var $1418f64bf1ea1583$export$6d59db4903f20f7d;
var $1418f64bf1ea1583$export$a3bc9b8ed74fc;
var $1418f64bf1ea1583$export$b7e3ae3d7c15e42e;
var $1418f64bf1ea1583$export$c96745152eb2740f;
var $1418f64bf1ea1583$export$fb184b623420d9be;
var $1418f64bf1ea1583$export$5f63db1d988def4d;
var $1418f64bf1ea1583$export$14fb490a0ca021ea;
$1418f64bf1ea1583$export$802cfe72001a1ee = `ZV7H9G_amount`;
$1418f64bf1ea1583$export$13efda6d80c8a88 = `ZV7H9G_balance`;
$1418f64bf1ea1583$export$a7db06668cad9adb = `ZV7H9G_content`;
$1418f64bf1ea1583$export$c7d5e207ac813a94 = `ZV7H9G_deposit-vessels`;
$1418f64bf1ea1583$export$6d59db4903f20f7d = `ZV7H9G_description`;
$1418f64bf1ea1583$export$a3bc9b8ed74fc = `ZV7H9G_error`;
$1418f64bf1ea1583$export$b7e3ae3d7c15e42e = `ZV7H9G_input`;
$1418f64bf1ea1583$export$c96745152eb2740f = `ZV7H9G_subtitle`;
$1418f64bf1ea1583$export$fb184b623420d9be = `ZV7H9G_title`;
$1418f64bf1ea1583$export$5f63db1d988def4d = `ZV7H9G_vessel`;
$1418f64bf1ea1583$export$14fb490a0ca021ea = `ZV7H9G_vessels`;




parcelRequire("acw62");



var $e546e7a9cde224c3$exports = {};

$parcel$export($e546e7a9cde224c3$exports, "content", () => $e546e7a9cde224c3$export$a7db06668cad9adb, (v) => $e546e7a9cde224c3$export$a7db06668cad9adb = v);
$parcel$export($e546e7a9cde224c3$exports, "count", () => $e546e7a9cde224c3$export$85b9a36db797e02b, (v) => $e546e7a9cde224c3$export$85b9a36db797e02b = v);
$parcel$export($e546e7a9cde224c3$exports, "depositing-vessels", () => $e546e7a9cde224c3$export$4f2d8f74cccc843, (v) => $e546e7a9cde224c3$export$4f2d8f74cccc843 = v);
$parcel$export($e546e7a9cde224c3$exports, "done", () => $e546e7a9cde224c3$export$3df11c9c20e7b288, (v) => $e546e7a9cde224c3$export$3df11c9c20e7b288 = v);
$parcel$export($e546e7a9cde224c3$exports, "label", () => $e546e7a9cde224c3$export$1237798dc640739a, (v) => $e546e7a9cde224c3$export$1237798dc640739a = v);
$parcel$export($e546e7a9cde224c3$exports, "title", () => $e546e7a9cde224c3$export$fb184b623420d9be, (v) => $e546e7a9cde224c3$export$fb184b623420d9be = v);
$parcel$export($e546e7a9cde224c3$exports, "total", () => $e546e7a9cde224c3$export$9086bb9c16b2b5b, (v) => $e546e7a9cde224c3$export$9086bb9c16b2b5b = v);
var $e546e7a9cde224c3$export$a7db06668cad9adb;
var $e546e7a9cde224c3$export$85b9a36db797e02b;
var $e546e7a9cde224c3$export$4f2d8f74cccc843;
var $e546e7a9cde224c3$export$3df11c9c20e7b288;
var $e546e7a9cde224c3$export$1237798dc640739a;
var $e546e7a9cde224c3$export$fb184b623420d9be;
var $e546e7a9cde224c3$export$9086bb9c16b2b5b;
$e546e7a9cde224c3$export$a7db06668cad9adb = `N3kflW_content`;
$e546e7a9cde224c3$export$85b9a36db797e02b = `N3kflW_count`;
$e546e7a9cde224c3$export$4f2d8f74cccc843 = `N3kflW_depositing-vessels`;
$e546e7a9cde224c3$export$3df11c9c20e7b288 = `N3kflW_done`;
$e546e7a9cde224c3$export$1237798dc640739a = `N3kflW_label`;
$e546e7a9cde224c3$export$fb184b623420d9be = `N3kflW_title`;
$e546e7a9cde224c3$export$9086bb9c16b2b5b = `N3kflW_total`;


const $aa5ae2ce9006643d$var$Content = ({ nbWaiting: nbWaiting, nbValidated: nbValidated, nbFailed: nbFailed, onClose: onClose })=>{
    const total = nbWaiting + nbValidated + nbFailed;
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: (0, $9805619f03ed02ef$export$91884aa883243770)((0, (/*@__PURE__*/$parcel$interopDefault($e546e7a9cde224c3$exports))), "content"),
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: (0, $9805619f03ed02ef$export$91884aa883243770)((0, (/*@__PURE__*/$parcel$interopDefault($e546e7a9cde224c3$exports))), "total"),
                children: [
                    "depositing",
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                        src: `${(0, $0426e2dd5e0de94d$export$24af3971dd36b33f)}/ui/vessel.png`,
                        alt: "vessel"
                    }),
                    total
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: (0, $9805619f03ed02ef$export$91884aa883243770)((0, (/*@__PURE__*/$parcel$interopDefault($e546e7a9cde224c3$exports))), "count"),
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: (0, $9805619f03ed02ef$export$91884aa883243770)((0, (/*@__PURE__*/$parcel$interopDefault($e546e7a9cde224c3$exports))), "label"),
                        children: [
                            nbValidated,
                            " V"
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: (0, $9805619f03ed02ef$export$91884aa883243770)((0, (/*@__PURE__*/$parcel$interopDefault($e546e7a9cde224c3$exports))), "label"),
                        children: [
                            nbFailed,
                            " X"
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $6725244138e0595f$export$353f5b6fc5456de1), {
                className: (0, $9805619f03ed02ef$export$91884aa883243770)((0, (/*@__PURE__*/$parcel$interopDefault($e546e7a9cde224c3$exports))), "done"),
                loading: nbWaiting !== 0,
                disabled: nbWaiting !== 0,
                onClick: onClose,
                children: "DONE"
            })
        ]
    });
};
const $aa5ae2ce9006643d$var$Title = ()=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
        className: (0, $9805619f03ed02ef$export$91884aa883243770)((0, (/*@__PURE__*/$parcel$interopDefault($e546e7a9cde224c3$exports))), "title"),
        children: "Depositing vessels..."
    });
const $aa5ae2ce9006643d$export$d77b8bce6af93ac4 = ({ className: className, onClose: onClose, nbWaiting: nbWaiting, nbValidated: nbValidated, nbFailed: nbFailed, ...props })=>{
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7b02d682eb115277$exports.Fragment), {
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $207d23274fe2be11$export$6e63c1000ecf9db8), {
            className: (0, $9805619f03ed02ef$export$91884aa883243770)((0, (/*@__PURE__*/$parcel$interopDefault($e546e7a9cde224c3$exports))), `depositing-vessels ${className}`),
            title: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($aa5ae2ce9006643d$var$Title, {}),
            content: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($aa5ae2ce9006643d$var$Content, {
                onClose: onClose,
                nbWaiting: nbWaiting,
                nbValidated: nbValidated,
                nbFailed: nbFailed
            }),
            ...props
        })
    });
};


const $7146d5d93ec55a32$var$Content = ({ callback: callback })=>{
    const { state: { accountInfo: accountInfo, publicKey: publicKey } } = (0, $c25623cc446ec3c6$export$ac8576a9912be18c)();
    const { connection: connection } = (0, $86c338e4d5b0d511$export$985e8768c0e91dbc)();
    const [depositing, setDepositing] = (0, $acw62.useState)(false);
    const [vessels, setVessels] = (0, $acw62.useState)();
    const [availableVessels, setAvailableVessels] = (0, $acw62.useState)();
    (0, $acw62.useEffect)(()=>{
        if (!publicKey) return;
        (0, $995765860f493c1e$export$d77c50dae9576df5)(publicKey, "3njr1Xyu4qY2Vg31YUECh9LiHw9etS5g6CdmwYaFXfx4").then((res)=>setAvailableVessels(res.length));
    }, [
        publicKey
    ]);
    const deposit = async ()=>{
        if (isNaN(Number(vessels)) || Number(vessels) <= 0 || !publicKey || !(0, $b3b1baf40467424d$export$745043c7dc65e495).showConfirm) return;
        if (Number(vessels) > 10) {
            (0, $ad26fe773541dcd3$export$b410431fab84fa58).info("You can only deposit 10 vessels in one time");
            return;
        }
        if (Number(vessels) <= 0) {
            (0, $ad26fe773541dcd3$export$b410431fab84fa58).info("You need to deposit at least 1 vessel");
            return;
        }
        setDepositing(true);
        (0, $b3b1baf40467424d$export$745043c7dc65e495).showConfirm({
            title: "Vessels deposit",
            text: `Are you sure you want to deposit ${vessels} vessels?`,
            async onAccept () {
                if (!(0, $b3b1baf40467424d$export$745043c7dc65e495).signAllTransactions) return;
                await (0, $03d845dbbcbc291b$export$fa1b8796aaeb6718)(Number(vessels), connection, publicKey, (0, $b3b1baf40467424d$export$745043c7dc65e495).signAllTransactions, callback);
                if ((0, $b3b1baf40467424d$export$745043c7dc65e495).refreshAccountInfo) (0, $b3b1baf40467424d$export$745043c7dc65e495).refreshAccountInfo();
                setAvailableVessels((await (0, $995765860f493c1e$export$d77c50dae9576df5)(publicKey, "3njr1Xyu4qY2Vg31YUECh9LiHw9etS5g6CdmwYaFXfx4")).length);
                setDepositing(false);
            },
            onRefuse () {
                setDepositing(false);
            },
            acceptText: "deposit",
            refuseText: "cancel"
        });
    };
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: (0, $9805619f03ed02ef$export$91884aa883243770)((0, (/*@__PURE__*/$parcel$interopDefault($1418f64bf1ea1583$exports))), "content"),
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: (0, $9805619f03ed02ef$export$91884aa883243770)((0, (/*@__PURE__*/$parcel$interopDefault($1418f64bf1ea1583$exports))), "balance"),
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        children: "Balance"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: (0, $9805619f03ed02ef$export$91884aa883243770)((0, (/*@__PURE__*/$parcel$interopDefault($1418f64bf1ea1583$exports))), "vessels"),
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                                src: `${(0, $0426e2dd5e0de94d$export$24af3971dd36b33f)}/ui/vessel.png`,
                                alt: "vessel"
                            }),
                            accountInfo?.vessels ?? "..."
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: (0, $9805619f03ed02ef$export$91884aa883243770)((0, (/*@__PURE__*/$parcel$interopDefault($1418f64bf1ea1583$exports))), "input"),
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        className: (0, $9805619f03ed02ef$export$91884aa883243770)((0, (/*@__PURE__*/$parcel$interopDefault($1418f64bf1ea1583$exports))), "subtitle"),
                        children: "Deposit amount (max 10)"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $863b21ed6a3b3d61$export$f5b8910cec6cf069), {
                        className: (0, $9805619f03ed02ef$export$91884aa883243770)((0, (/*@__PURE__*/$parcel$interopDefault($1418f64bf1ea1583$exports))), "amount"),
                        max: availableVessels !== undefined ? Math.min(10, availableVessels) : 10,
                        value: vessels,
                        onChange: (e)=>setVessels(e.target.value),
                        placeholder: availableVessels === undefined ? "Checking your actual number of vessels..." : `You have ${availableVessels} vessels available`,
                        disabled: availableVessels === undefined
                    }),
                    availableVessels !== undefined && !isNaN(Number(vessels)) && (availableVessels < Number(vessels) ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: (0, $9805619f03ed02ef$export$91884aa883243770)((0, (/*@__PURE__*/$parcel$interopDefault($1418f64bf1ea1583$exports))), "error"),
                        children: [
                            "you don't have enough vessels (",
                            availableVessels,
                            " available)"
                        ]
                    }) : Number(vessels) > 10) && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        className: (0, $9805619f03ed02ef$export$91884aa883243770)((0, (/*@__PURE__*/$parcel$interopDefault($1418f64bf1ea1583$exports))), "error"),
                        children: "you can only deposit 10 vessels in one time"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: (0, $9805619f03ed02ef$export$91884aa883243770)((0, (/*@__PURE__*/$parcel$interopDefault($1418f64bf1ea1583$exports))), "description"),
                children: [
                    "please note: once you have deposited vessels into oogy blast, they will be burned and ",
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                        children: "you cannot withdraw"
                    }),
                    " them."
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $6725244138e0595f$export$353f5b6fc5456de1), {
                className: (0, $9805619f03ed02ef$export$91884aa883243770)((0, (/*@__PURE__*/$parcel$interopDefault($1418f64bf1ea1583$exports))), "vessel yellow"),
                onClick: deposit,
                loading: depositing,
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                        src: `${(0, $0426e2dd5e0de94d$export$24af3971dd36b33f)}/ui/vessel.png`,
                        alt: "vessel"
                    }),
                    "MAKE DEPOSIT"
                ]
            })
        ]
    });
};
const $7146d5d93ec55a32$var$Title = ({ onClose: onClose })=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: (0, $9805619f03ed02ef$export$91884aa883243770)((0, (/*@__PURE__*/$parcel$interopDefault($1418f64bf1ea1583$exports))), "title"),
        children: [
            "Deposit vessels",
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                src: `${(0, $0426e2dd5e0de94d$export$24af3971dd36b33f)}/ui/cross.png`,
                alt: "cross",
                onClick: onClose
            })
        ]
    });
const $7146d5d93ec55a32$export$33070c964c92079 = ({ className: className, onClose: onClose, ...props })=>{
    const [showDepositing, setShowDepositing] = (0, $acw62.useState)(false);
    const [nbWaiting, setNbWaiting] = (0, $acw62.useState)(0);
    const [nbValidated, setNbValidated] = (0, $acw62.useState)(0);
    const [nbFailed, setNbFailed] = (0, $acw62.useState)(0);
    const callback = (show, nbWaiting, nbValidated, nbFailed)=>{
        setShowDepositing(show);
        setNbWaiting(nbWaiting);
        setNbValidated(nbValidated);
        setNbFailed(nbFailed);
    };
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $207d23274fe2be11$export$6e63c1000ecf9db8), {
                className: (0, $9805619f03ed02ef$export$91884aa883243770)((0, (/*@__PURE__*/$parcel$interopDefault($1418f64bf1ea1583$exports))), `deposit-vessels ${className}`),
                title: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($7146d5d93ec55a32$var$Title, {
                    onClose: onClose
                }),
                content: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($7146d5d93ec55a32$var$Content, {
                    callback: callback
                }),
                onClickBackground: onClose,
                ...props
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $aa5ae2ce9006643d$export$d77b8bce6af93ac4), {
                show: showDepositing,
                nbWaiting: nbWaiting,
                nbValidated: nbValidated,
                nbFailed: nbFailed,
                onClose: ()=>setShowDepositing(false),
                className: "no-blur"
            })
        ]
    });
};






var $acw62 = parcelRequire("acw62");








var $acw62 = parcelRequire("acw62");




const $ad346ab53b5cc334$export$587e3b6843f18f08 = async ()=>{
    const result = await (0, $35a528e84618b070$export$3394aac6a0917ca2)({
        method: "GET",
        url: "/api/v1/twitter/me"
    });
    if (!result || result.status !== 200) //toast.error('Please verify that you have a Twitter account linked to your Pirate Squad account')
    return;
    return result.data;
};
const $ad346ab53b5cc334$export$a693c9e33e65782f = async ()=>{
    const result = await (0, $35a528e84618b070$export$3394aac6a0917ca2)({
        method: "GET",
        url: "/api/v1/twitter/pkce"
    });
    if (!result || result.status !== 200) return;
    return result.data;
};
const $ad346ab53b5cc334$export$ae5329353d60f51a = async (onError)=>{
    const result = await (0, $35a528e84618b070$export$3394aac6a0917ca2)({
        url: "/api/v1/twitter/unlink",
        method: "POST"
    }, onError);
    return result;
};





var $173b862de23cbc08$exports = {};

$parcel$export($173b862de23cbc08$exports, "twitter-link-button", () => $173b862de23cbc08$export$18b78f7e4298ded5, (v) => $173b862de23cbc08$export$18b78f7e4298ded5 = v);
var $173b862de23cbc08$export$18b78f7e4298ded5;
$173b862de23cbc08$export$18b78f7e4298ded5 = `ym65UW_twitter-link-button`;


const $2420362d91d8d22d$var$TWITTER_CLIENT_ID = "bjhHTDZ0U0F4RmhjMWlnekNqNjY6MTpjaQ";
const $2420362d91d8d22d$var$getTwitterOauthUrl = async ()=>{
    const result = await (0, $ad346ab53b5cc334$export$a693c9e33e65782f)();
    if (!result) {
        (0, $ad26fe773541dcd3$export$b410431fab84fa58).error("Impossible to connect with X, please try again later or contact the support team");
        return;
    }
    const { state: state, codeChallenge: codeChallenge } = result;
    const rootUrl = "https://twitter.com/i/oauth2/authorize";
    const options = {
        redirect_uri: `${window.location.origin}/api/v1/twitter/oauth`,
        //redirect_uri: 'http://localhost:5001/meegos-689d1/us-central1/twitter/api/v1/twitter/oauth',
        client_id: $2420362d91d8d22d$var$TWITTER_CLIENT_ID,
        state: state,
        response_type: "code",
        code_challenge: codeChallenge,
        code_challenge_method: "S256",
        scope: [
            "users.read",
            "tweet.read",
            "follows.read"
        ].join(" ") // , 'offline.access'
    };
    const qs = new URLSearchParams(options).toString();
    return `${rootUrl}?${qs}`;
};
const $2420362d91d8d22d$var$MAX_TRIES = 5;
let $2420362d91d8d22d$var$tries = 1;
let $2420362d91d8d22d$var$interval;
const $2420362d91d8d22d$export$794bc7620c244678 = ({ className: className, value: value, ...props })=>{
    const { dispatch: dispatch, state: { twitterUsername: twitterUsername } } = (0, $c25623cc446ec3c6$export$ac8576a9912be18c)();
    const [linking, setLinking] = (0, $acw62.useState)(false);
    const [cacheHref, setCacheHref] = (0, $acw62.useState)();
    const [numberOfTries, setNumberOfTries] = (0, $acw62.useState)(1);
    const syncUsername = async ()=>{
        const data = await (0, $ad346ab53b5cc334$export$587e3b6843f18f08)();
        if (data?.twitterUsername) {
            setLinking(false);
            dispatch({
                type: "SET_TWITTER_USERNAME",
                twitterUsername: data.twitterUsername
            });
            return data.twitterUsername;
        }
        return;
    };
    const openWindow = async ()=>{
        setLinking(true);
        dispatch({
            type: "SET_TWITTER_USERNAME",
            twitterUsername: undefined
        });
        setNumberOfTries(1);
        $2420362d91d8d22d$var$tries = 1;
        if (((0, $76c62964b0a424ce$exports.isIOS) || (0, $76c62964b0a424ce$exports.isAndroid)) && (0, $9805619f03ed02ef$export$7f84b2f452f9a348) && (0, $b3b1baf40467424d$export$745043c7dc65e495).showLoading) (0, $b3b1baf40467424d$export$745043c7dc65e495).showLoading(true);
        let href;
        if (cacheHref) href = cacheHref;
        else {
            href = await $2420362d91d8d22d$var$getTwitterOauthUrl();
            if (!href) {
                setLinking(false);
                return;
            }
        }
        if (((0, $76c62964b0a424ce$exports.isIOS) || (0, $76c62964b0a424ce$exports.isAndroid)) && (0, $9805619f03ed02ef$export$7f84b2f452f9a348)) {
            window.location.replace(href);
            return;
        }
        const openedWindow = window.open(href, "Oogy Blast - X Link", "toolbar=1,scrollbars=1,location=0,statusbar=0,menubar=1,resizable=1,width=800,height=600,left=240,top=212");
        if (openedWindow === null) {
            setLinking(false);
            if (!cacheHref) (0, $ad26fe773541dcd3$export$b410431fab84fa58).info("Please click again on the X button (normal process if you have an adblock \uD83D\uDE09)");
            setCacheHref(href);
        } else {
            if ((0, $b3b1baf40467424d$export$745043c7dc65e495).showLoading) (0, $b3b1baf40467424d$export$745043c7dc65e495).showLoading(true, undefined, "Linking X, please wait...");
            setCacheHref(undefined);
            $2420362d91d8d22d$var$interval = setInterval(async ()=>{
                ++$2420362d91d8d22d$var$tries;
                setNumberOfTries($2420362d91d8d22d$var$tries);
                if ($2420362d91d8d22d$var$tries >= $2420362d91d8d22d$var$MAX_TRIES) {
                    setLinking(false);
                    clearInterval($2420362d91d8d22d$var$interval);
                    if ((0, $b3b1baf40467424d$export$745043c7dc65e495).showLoading) (0, $b3b1baf40467424d$export$745043c7dc65e495).showLoading(false);
                    (0, $ad26fe773541dcd3$export$b410431fab84fa58).error("Impossible to refresh the X user, if you successfully authorized the connection, please refresh this page and reconnect");
                } else try {
                    const twitterUsername = await syncUsername();
                    if (twitterUsername) {
                        clearInterval($2420362d91d8d22d$var$interval);
                        if ((0, $b3b1baf40467424d$export$745043c7dc65e495).showLoading) (0, $b3b1baf40467424d$export$745043c7dc65e495).showLoading(false);
                        (0, $ad26fe773541dcd3$export$b410431fab84fa58).success("X successfully connected to your account");
                    }
                } catch (err) {
                    console.error(err);
                    setLinking(false);
                    clearInterval($2420362d91d8d22d$var$interval);
                    if ((0, $b3b1baf40467424d$export$745043c7dc65e495).showLoading) (0, $b3b1baf40467424d$export$745043c7dc65e495).showLoading(false);
                    (0, $ad26fe773541dcd3$export$b410431fab84fa58).error("Impossible to refresh the X user, if you successfully authorized the connection, please refresh this page and reconnect");
                }
            }, 10000);
        }
    };
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7b02d682eb115277$exports.Fragment), {
        children: twitterUsername ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $6725244138e0595f$export$e1c22a2ee2645e36), {
            icon: [
                "fab",
                "x-twitter"
            ],
            className: (0, $9805619f03ed02ef$export$91884aa883243770)((0, (/*@__PURE__*/$parcel$interopDefault($173b862de23cbc08$exports))), `twitter-link-button ${className}`),
            disabled: linking,
            ...props,
            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                children: value ?? twitterUsername
            })
        }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $6725244138e0595f$export$e1c22a2ee2645e36), {
            icon: [
                "fab",
                "x-twitter"
            ],
            className: (0, $9805619f03ed02ef$export$91884aa883243770)((0, (/*@__PURE__*/$parcel$interopDefault($173b862de23cbc08$exports))), `twitter-link-button ${className}`),
            onClick: openWindow,
            disabled: linking,
            ...props,
            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                children: linking ? `Please wait... (${numberOfTries}/${$2420362d91d8d22d$var$MAX_TRIES})` : value ?? "Link"
            })
        })
    });
};



var $047793aeec26e39c$exports = {};

$parcel$export($047793aeec26e39c$exports, "code", () => $047793aeec26e39c$export$6565f9f03506010b, (v) => $047793aeec26e39c$export$6565f9f03506010b = v);
$parcel$export($047793aeec26e39c$exports, "content", () => $047793aeec26e39c$export$a7db06668cad9adb, (v) => $047793aeec26e39c$export$a7db06668cad9adb = v);
$parcel$export($047793aeec26e39c$exports, "enabled", () => $047793aeec26e39c$export$25eaa035e2e3a214, (v) => $047793aeec26e39c$export$25eaa035e2e3a214 = v);
$parcel$export($047793aeec26e39c$exports, "settings", () => $047793aeec26e39c$export$a5a6e0b888b2c992, (v) => $047793aeec26e39c$export$a5a6e0b888b2c992 = v);
$parcel$export($047793aeec26e39c$exports, "sound", () => $047793aeec26e39c$export$eab32dcfc4ded11c, (v) => $047793aeec26e39c$export$eab32dcfc4ded11c = v);
$parcel$export($047793aeec26e39c$exports, "submit", () => $047793aeec26e39c$export$853c27de4ce0f746, (v) => $047793aeec26e39c$export$853c27de4ce0f746 = v);
$parcel$export($047793aeec26e39c$exports, "subtitle", () => $047793aeec26e39c$export$c96745152eb2740f, (v) => $047793aeec26e39c$export$c96745152eb2740f = v);
$parcel$export($047793aeec26e39c$exports, "title", () => $047793aeec26e39c$export$fb184b623420d9be, (v) => $047793aeec26e39c$export$fb184b623420d9be = v);
$parcel$export($047793aeec26e39c$exports, "twitter", () => $047793aeec26e39c$export$87453108c2dd3831, (v) => $047793aeec26e39c$export$87453108c2dd3831 = v);
var $047793aeec26e39c$export$6565f9f03506010b;
var $047793aeec26e39c$export$a7db06668cad9adb;
var $047793aeec26e39c$export$25eaa035e2e3a214;
var $047793aeec26e39c$export$a5a6e0b888b2c992;
var $047793aeec26e39c$export$eab32dcfc4ded11c;
var $047793aeec26e39c$export$853c27de4ce0f746;
var $047793aeec26e39c$export$c96745152eb2740f;
var $047793aeec26e39c$export$fb184b623420d9be;
var $047793aeec26e39c$export$87453108c2dd3831;
$047793aeec26e39c$export$6565f9f03506010b = `Nc_WTq_code`;
$047793aeec26e39c$export$a7db06668cad9adb = `Nc_WTq_content`;
$047793aeec26e39c$export$25eaa035e2e3a214 = `Nc_WTq_enabled`;
$047793aeec26e39c$export$a5a6e0b888b2c992 = `Nc_WTq_settings`;
$047793aeec26e39c$export$eab32dcfc4ded11c = `Nc_WTq_sound`;
$047793aeec26e39c$export$853c27de4ce0f746 = `Nc_WTq_submit`;
$047793aeec26e39c$export$c96745152eb2740f = `Nc_WTq_subtitle`;
$047793aeec26e39c$export$fb184b623420d9be = `Nc_WTq_title`;
$047793aeec26e39c$export$87453108c2dd3831 = `Nc_WTq_twitter`;


const $67530843f1a1c751$var$Content = ()=>{
    const [soundMuted, setSoundMuted] = (0, $acw62.useState)(window.localStorage.getItem("music-muted") === "true");
    const [code, setCode] = (0, $acw62.useState)();
    const [loading, setLoading] = (0, $acw62.useState)(false);
    const toggleSound = ()=>{
        Howler.mute(!soundMuted);
        window.localStorage.setItem("music-muted", String(!soundMuted));
        setSoundMuted(!soundMuted);
    };
    const submitCode = async ()=>{
        if (loading || !code) return;
        setLoading(true);
        const response = await (0, $35a528e84618b070$export$ae43f0e5ee21df6f)(code);
        if (response?.status === 200 && (0, $b3b1baf40467424d$export$745043c7dc65e495).refreshAccountInfo) {
            (0, $b3b1baf40467424d$export$745043c7dc65e495).refreshAccountInfo();
            (0, $ad26fe773541dcd3$export$b410431fab84fa58).success("Code used!");
        }
        setLoading(false);
    };
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: (0, $9805619f03ed02ef$export$91884aa883243770)((0, (/*@__PURE__*/$parcel$interopDefault($047793aeec26e39c$exports))), "content"),
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: (0, $9805619f03ed02ef$export$91884aa883243770)((0, (/*@__PURE__*/$parcel$interopDefault($047793aeec26e39c$exports))), "sound"),
                onClick: toggleSound,
                children: [
                    "Sound",
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $e4ec753f5c716375$export$2b9260d4a45c8710), {
                        className: (0, $9805619f03ed02ef$export$91884aa883243770)((0, (/*@__PURE__*/$parcel$interopDefault($047793aeec26e39c$exports))), soundMuted ? "" : "enabled"),
                        icon: soundMuted ? "volume-xmark" : "volume-low"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        className: (0, $9805619f03ed02ef$export$91884aa883243770)((0, (/*@__PURE__*/$parcel$interopDefault($047793aeec26e39c$exports))), "subtitle"),
                        children: "Promo code"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: (0, $9805619f03ed02ef$export$91884aa883243770)((0, (/*@__PURE__*/$parcel$interopDefault($047793aeec26e39c$exports))), "code"),
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $863b21ed6a3b3d61$export$f5b8910cec6cf069), {
                                className: (0, $9805619f03ed02ef$export$91884aa883243770)((0, (/*@__PURE__*/$parcel$interopDefault($047793aeec26e39c$exports))), "amount"),
                                maxLength: 32,
                                value: code,
                                onChange: (e)=>setCode(e.target.value),
                                placeholder: "Enter a promo code...",
                                disabled: loading
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $6725244138e0595f$export$353f5b6fc5456de1), {
                                className: (0, $9805619f03ed02ef$export$91884aa883243770)((0, (/*@__PURE__*/$parcel$interopDefault($047793aeec26e39c$exports))), "submit xsmall"),
                                loading: loading,
                                onClick: submitCode,
                                children: "SUBMIT"
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $2420362d91d8d22d$export$794bc7620c244678), {
                className: (0, $9805619f03ed02ef$export$91884aa883243770)((0, (/*@__PURE__*/$parcel$interopDefault($047793aeec26e39c$exports))), "twitter small")
            })
        ]
    });
};
const $67530843f1a1c751$var$Title = ({ onClose: onClose })=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: (0, $9805619f03ed02ef$export$91884aa883243770)((0, (/*@__PURE__*/$parcel$interopDefault($047793aeec26e39c$exports))), "title"),
        children: [
            "Settings",
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                src: `${(0, $0426e2dd5e0de94d$export$24af3971dd36b33f)}/ui/cross.png`,
                alt: "cross",
                onClick: onClose
            })
        ]
    });
const $67530843f1a1c751$export$c72f6eaae7b9adff = ({ className: className, onClose: onClose, ...props })=>{
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $207d23274fe2be11$export$6e63c1000ecf9db8), {
        className: (0, $9805619f03ed02ef$export$91884aa883243770)((0, (/*@__PURE__*/$parcel$interopDefault($047793aeec26e39c$exports))), `settings ${className}`),
        title: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($67530843f1a1c751$var$Title, {
            onClose: onClose
        }),
        content: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($67530843f1a1c751$var$Content, {}),
        onClickBackground: onClose,
        ...props
    });
};


var $c80287bfd0c91e93$exports = {};

$parcel$export($c80287bfd0c91e93$exports, "bag", () => $c80287bfd0c91e93$export$35e48f1ff4f2bc86, (v) => $c80287bfd0c91e93$export$35e48f1ff4f2bc86 = v);
$parcel$export($c80287bfd0c91e93$exports, "buy", () => $c80287bfd0c91e93$export$7f8e2b98eca5a7f0, (v) => $c80287bfd0c91e93$export$7f8e2b98eca5a7f0 = v);
$parcel$export($c80287bfd0c91e93$exports, "element", () => $c80287bfd0c91e93$export$8454457683f90105, (v) => $c80287bfd0c91e93$export$8454457683f90105 = v);
$parcel$export($c80287bfd0c91e93$exports, "element-left", () => $c80287bfd0c91e93$export$6e8e69912b7015bc, (v) => $c80287bfd0c91e93$export$6e8e69912b7015bc = v);
$parcel$export($c80287bfd0c91e93$exports, "element-right", () => $c80287bfd0c91e93$export$6ac5cb52538c8989, (v) => $c80287bfd0c91e93$export$6ac5cb52538c8989 = v);
$parcel$export($c80287bfd0c91e93$exports, "hover", () => $c80287bfd0c91e93$export$3f60957f5dbf3876, (v) => $c80287bfd0c91e93$export$3f60957f5dbf3876 = v);
$parcel$export($c80287bfd0c91e93$exports, "icon", () => $c80287bfd0c91e93$export$1ca1ec8b29a4ce27, (v) => $c80287bfd0c91e93$export$1ca1ec8b29a4ce27 = v);
$parcel$export($c80287bfd0c91e93$exports, "quantity", () => $c80287bfd0c91e93$export$82dd68b83a44b253, (v) => $c80287bfd0c91e93$export$82dd68b83a44b253 = v);
$parcel$export($c80287bfd0c91e93$exports, "settings", () => $c80287bfd0c91e93$export$a5a6e0b888b2c992, (v) => $c80287bfd0c91e93$export$a5a6e0b888b2c992 = v);
$parcel$export($c80287bfd0c91e93$exports, "top-bar", () => $c80287bfd0c91e93$export$e6bd3ce1c3980ae2, (v) => $c80287bfd0c91e93$export$e6bd3ce1c3980ae2 = v);
var $c80287bfd0c91e93$export$35e48f1ff4f2bc86;
var $c80287bfd0c91e93$export$7f8e2b98eca5a7f0;
var $c80287bfd0c91e93$export$8454457683f90105;
var $c80287bfd0c91e93$export$6e8e69912b7015bc;
var $c80287bfd0c91e93$export$6ac5cb52538c8989;
var $c80287bfd0c91e93$export$3f60957f5dbf3876;
var $c80287bfd0c91e93$export$1ca1ec8b29a4ce27;
var $c80287bfd0c91e93$export$82dd68b83a44b253;
var $c80287bfd0c91e93$export$a5a6e0b888b2c992;
var $c80287bfd0c91e93$export$e6bd3ce1c3980ae2;
$c80287bfd0c91e93$export$35e48f1ff4f2bc86 = `QaHdgW_bag`;
$c80287bfd0c91e93$export$7f8e2b98eca5a7f0 = `QaHdgW_buy`;
$c80287bfd0c91e93$export$8454457683f90105 = `QaHdgW_element`;
$c80287bfd0c91e93$export$6e8e69912b7015bc = `QaHdgW_element-left`;
$c80287bfd0c91e93$export$6ac5cb52538c8989 = `QaHdgW_element-right`;
$c80287bfd0c91e93$export$3f60957f5dbf3876 = `QaHdgW_hover`;
$c80287bfd0c91e93$export$1ca1ec8b29a4ce27 = `QaHdgW_icon`;
$c80287bfd0c91e93$export$82dd68b83a44b253 = `QaHdgW_quantity`;
$c80287bfd0c91e93$export$a5a6e0b888b2c992 = `QaHdgW_settings`;
$c80287bfd0c91e93$export$e6bd3ce1c3980ae2 = `QaHdgW_top-bar`;




parcelRequire("acw62");






var $19e9575d251afe2f$exports = {};

$parcel$export($19e9575d251afe2f$exports, "content", () => $19e9575d251afe2f$export$a7db06668cad9adb, (v) => $19e9575d251afe2f$export$a7db06668cad9adb = v);
$parcel$export($19e9575d251afe2f$exports, "title", () => $19e9575d251afe2f$export$fb184b623420d9be, (v) => $19e9575d251afe2f$export$fb184b623420d9be = v);
$parcel$export($19e9575d251afe2f$exports, "vessel", () => $19e9575d251afe2f$export$5f63db1d988def4d, (v) => $19e9575d251afe2f$export$5f63db1d988def4d = v);
$parcel$export($19e9575d251afe2f$exports, "wallet", () => $19e9575d251afe2f$export$4b6dd4ac026934d2, (v) => $19e9575d251afe2f$export$4b6dd4ac026934d2 = v);
var $19e9575d251afe2f$export$a7db06668cad9adb;
var $19e9575d251afe2f$export$fb184b623420d9be;
var $19e9575d251afe2f$export$5f63db1d988def4d;
var $19e9575d251afe2f$export$4b6dd4ac026934d2;
$19e9575d251afe2f$export$a7db06668cad9adb = `QsW5AW_content`;
$19e9575d251afe2f$export$fb184b623420d9be = `QsW5AW_title`;
$19e9575d251afe2f$export$5f63db1d988def4d = `QsW5AW_vessel`;
$19e9575d251afe2f$export$4b6dd4ac026934d2 = `QsW5AW_wallet`;


const $a37643b089255ceb$var$Content = ({ openDepositVessels: openDepositVessels })=>{
    const { disconnect: disconnect } = (0, $4ea79fe64cc4ba62$export$50927ef1fb3dba34)();
    const { state: { publicKey: publicKey, accountInfo: accountInfo } } = (0, $c25623cc446ec3c6$export$ac8576a9912be18c)();
    const onDisconnect = ()=>{
        if ((0, $b3b1baf40467424d$export$745043c7dc65e495).showConfirm) (0, $b3b1baf40467424d$export$745043c7dc65e495).showConfirm({
            title: "Disconnect",
            text: "Do you really want to disconnect your wallet?",
            acceptText: "Yes",
            refuseText: "No",
            onAccept: disconnect
        });
    };
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: (0, $9805619f03ed02ef$export$91884aa883243770)((0, (/*@__PURE__*/$parcel$interopDefault($19e9575d251afe2f$exports))), "content"),
        children: [
            `${publicKey?.slice(0, 4)} . . . ${publicKey?.slice(-4)}`,
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $6725244138e0595f$export$353f5b6fc5456de1), {
                className: (0, $9805619f03ed02ef$export$91884aa883243770)((0, (/*@__PURE__*/$parcel$interopDefault($19e9575d251afe2f$exports))), "vessel yellow"),
                children: [
                    "You have ",
                    accountInfo?.vessels ?? 0,
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                        src: `${(0, $0426e2dd5e0de94d$export$24af3971dd36b33f)}/ui/vessel.png`,
                        alt: "vessel"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $6725244138e0595f$export$353f5b6fc5456de1), {
                className: (0, $9805619f03ed02ef$export$91884aa883243770)((0, (/*@__PURE__*/$parcel$interopDefault($19e9575d251afe2f$exports))), "disconnect small gray"),
                onClick: onDisconnect,
                children: "DISCONNECT WALLET"
            })
        ]
    });
};
const $a37643b089255ceb$var$Title = ({ onClose: onClose })=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: (0, $9805619f03ed02ef$export$91884aa883243770)((0, (/*@__PURE__*/$parcel$interopDefault($19e9575d251afe2f$exports))), "title"),
        children: [
            "Wallet",
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                src: `${(0, $0426e2dd5e0de94d$export$24af3971dd36b33f)}/ui/cross.png`,
                alt: "cross",
                onClick: onClose
            })
        ]
    });
const $a37643b089255ceb$export$bcca3ea514774656 = ({ className: className, onClose: onClose, openDepositVessels: openDepositVessels, ...props })=>{
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $207d23274fe2be11$export$6e63c1000ecf9db8), {
        className: (0, $9805619f03ed02ef$export$91884aa883243770)((0, (/*@__PURE__*/$parcel$interopDefault($19e9575d251afe2f$exports))), `wallet ${className}`),
        title: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($a37643b089255ceb$var$Title, {
            onClose: onClose
        }),
        content: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($a37643b089255ceb$var$Content, {
            openDepositVessels: openDepositVessels
        }),
        onClickBackground: onClose,
        ...props
    });
};


const $affb1ceff24a3e39$var$SVG = ()=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "78",
        height: "23",
        viewBox: "0 0 78 23",
        fill: "none",
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M0.349121 18.4032V4.14896C0.349121 2.0803 2.02611 0.40332 4.09477 0.40332H20.8564C21.7985 0.40332 22.7059 0.758293 23.3979 1.39749L26.3159 4.0928C27.0079 4.732 27.9153 5.08697 28.8574 5.08697H73.6844C76.4365 5.08697 78.2489 7.95562 77.0671 10.4411L72.5162 20.0117C71.8955 21.3171 70.579 22.1488 69.1335 22.1488H4.09476C2.0261 22.1488 0.349121 20.4719 0.349121 18.4032Z",
            fill: "#7E64A4",
            fillOpacity: "0.4"
        })
    });
const $affb1ceff24a3e39$export$c4e96258f3b6511 = ({ className: className, ...props })=>{
    const { state: { accountInfo: accountInfo } } = (0, $c25623cc446ec3c6$export$ac8576a9912be18c)();
    const [showSettings, setShowSettings] = (0, $acw62.useState)(false);
    const [showWallet, setShowWallet] = (0, $acw62.useState)(false);
    const [showDepositVessels, setShowDepositVessels] = (0, $acw62.useState)(false);
    const [showBuyEnergy, setShowBuyEnergy] = (0, $acw62.useState)(false);
    const [showBuyGems, setShowBuyGems] = (0, $acw62.useState)(false);
    const openDepositVessels = ()=>{
        setShowWallet(false);
        setShowDepositVessels(true);
    };
    const onPointerOver = ()=>{
        (0, $0c69c9c512bb7a3f$export$2b20361d967f09eb).play();
    };
    const onPointerUp = (callback)=>{
        callback();
        (0, $0c69c9c512bb7a3f$export$4db563113ca18f41).play();
    };
    const weekString = accountInfo?.actualWeek ?? "";
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $67530843f1a1c751$export$c72f6eaae7b9adff), {
                show: showSettings,
                onClose: ()=>setShowSettings(false)
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $a37643b089255ceb$export$bcca3ea514774656), {
                show: showWallet,
                onClose: ()=>setShowWallet(false),
                openDepositVessels: openDepositVessels
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7146d5d93ec55a32$export$33070c964c92079), {
                show: showDepositVessels,
                onClose: ()=>setShowDepositVessels(false)
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $54ca9f6efc2d9cab$export$35af786d5efcb0fc), {
                show: showBuyEnergy,
                onClose: ()=>setShowBuyEnergy(false)
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $352d1692cbb387fd$export$ba9d9247397e31aa), {
                show: showBuyGems,
                onClose: ()=>setShowBuyGems(false)
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: (0, $9805619f03ed02ef$export$91884aa883243770)((0, (/*@__PURE__*/$parcel$interopDefault($c80287bfd0c91e93$exports))), `top-bar ${className}`),
                ...props,
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: (0, $9805619f03ed02ef$export$91884aa883243770)((0, (/*@__PURE__*/$parcel$interopDefault($c80287bfd0c91e93$exports))), "element-left"),
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: (0, $9805619f03ed02ef$export$91884aa883243770)((0, (/*@__PURE__*/$parcel$interopDefault($c80287bfd0c91e93$exports))), "element hover"),
                                onPointerUp: ()=>onPointerUp(()=>setShowBuyGems(true)),
                                onPointerOver: onPointerOver,
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                        className: (0, $9805619f03ed02ef$export$91884aa883243770)((0, (/*@__PURE__*/$parcel$interopDefault($c80287bfd0c91e93$exports))), "icon"),
                                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                                            src: `${(0, $0426e2dd5e0de94d$export$24af3971dd36b33f)}/ui/gem.png`,
                                            alt: "gems"
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                        className: (0, $9805619f03ed02ef$export$91884aa883243770)((0, (/*@__PURE__*/$parcel$interopDefault($c80287bfd0c91e93$exports))), "quantity"),
                                        children: accountInfo?.gems !== undefined ? (0, $9805619f03ed02ef$export$2e1efffb4405e7a8)(accountInfo.gems) : "..."
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                        className: (0, $9805619f03ed02ef$export$91884aa883243770)((0, (/*@__PURE__*/$parcel$interopDefault($c80287bfd0c91e93$exports))), "buy"),
                                        children: "+"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($affb1ceff24a3e39$var$SVG, {})
                                ]
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: (0, $9805619f03ed02ef$export$91884aa883243770)((0, (/*@__PURE__*/$parcel$interopDefault($c80287bfd0c91e93$exports))), "element hover"),
                                onPointerUp: ()=>onPointerUp(()=>setShowBuyEnergy(true)),
                                onPointerOver: onPointerOver,
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                        className: (0, $9805619f03ed02ef$export$91884aa883243770)((0, (/*@__PURE__*/$parcel$interopDefault($c80287bfd0c91e93$exports))), "icon"),
                                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                                            src: `${(0, $0426e2dd5e0de94d$export$24af3971dd36b33f)}/ui/energy.png`,
                                            alt: "energy"
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                        className: (0, $9805619f03ed02ef$export$91884aa883243770)((0, (/*@__PURE__*/$parcel$interopDefault($c80287bfd0c91e93$exports))), "quantity"),
                                        children: [
                                            accountInfo?.energy.quantity !== undefined ? accountInfo?.energy.quantity : "...",
                                            "/12"
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                        className: (0, $9805619f03ed02ef$export$91884aa883243770)((0, (/*@__PURE__*/$parcel$interopDefault($c80287bfd0c91e93$exports))), "buy"),
                                        children: "+"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($affb1ceff24a3e39$var$SVG, {})
                                ]
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: (0, $9805619f03ed02ef$export$91884aa883243770)((0, (/*@__PURE__*/$parcel$interopDefault($c80287bfd0c91e93$exports))), "element"),
                                onPointerOver: onPointerOver,
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                        className: (0, $9805619f03ed02ef$export$91884aa883243770)((0, (/*@__PURE__*/$parcel$interopDefault($c80287bfd0c91e93$exports))), "icon"),
                                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                                            src: `${(0, $0426e2dd5e0de94d$export$24af3971dd36b33f)}/ui/token.png`,
                                            alt: "token"
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                        className: (0, $9805619f03ed02ef$export$91884aa883243770)((0, (/*@__PURE__*/$parcel$interopDefault($c80287bfd0c91e93$exports))), "quantity"),
                                        children: accountInfo?.tokens[weekString] ?? 0
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($affb1ceff24a3e39$var$SVG, {})
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: (0, $9805619f03ed02ef$export$91884aa883243770)((0, (/*@__PURE__*/$parcel$interopDefault($c80287bfd0c91e93$exports))), "element-right"),
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                className: (0, $9805619f03ed02ef$export$91884aa883243770)((0, (/*@__PURE__*/$parcel$interopDefault($c80287bfd0c91e93$exports))), "bag hover"),
                                onPointerUp: ()=>onPointerUp(()=>setShowWallet(true)),
                                onPointerOver: onPointerOver,
                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                                    src: `${(0, $0426e2dd5e0de94d$export$24af3971dd36b33f)}/ui/bag.png`,
                                    alt: "bag"
                                })
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                className: (0, $9805619f03ed02ef$export$91884aa883243770)((0, (/*@__PURE__*/$parcel$interopDefault($c80287bfd0c91e93$exports))), "settings hover"),
                                onPointerUp: ()=>onPointerUp(()=>setShowSettings(true)),
                                onPointerOver: onPointerOver,
                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                                    src: `${(0, $0426e2dd5e0de94d$export$24af3971dd36b33f)}/ui/settings.png`,
                                    alt: "settings"
                                })
                            })
                        ]
                    })
                ]
            })
        ]
    });
};


const $17460f31ac2fcb23$export$2616165974278734 = ({ className: className, ...props })=>{
    const { game: game } = (0, $7939e29d663dd3ed$export$99eaa27ddbbb95ef)();
    const { dispatch: dispatch } = (0, $c25623cc446ec3c6$export$ac8576a9912be18c)();
    const gameRef = (0, $acw62.useRef)(null);
    const gameContainerRef = (0, $acw62.useRef)(null);
    const [showBackground, setShowBackground] = (0, $acw62.useState)(true);
    const [showTopBar, setShowTopBar] = (0, $acw62.useState)(true);
    const [showNavigation, setShowNavigation] = (0, $acw62.useState)(true);
    const [showHomescreen, setShowHomescreen] = (0, $acw62.useState)(true);
    const [showPauseMenu, setShowPauseMenu] = (0, $acw62.useState)(false);
    const [showContinueMenu, setShowContinueMenu] = (0, $acw62.useState)(false);
    const [showLobby, setShowLobby] = (0, $acw62.useState)(false);
    const [showScore, setShowScore] = (0, $acw62.useState)(false);
    const [gameScore, setGameScore] = (0, $acw62.useState)(0);
    const [gameGems, setGameGems] = (0, $acw62.useState)(0);
    const [muteCallback, setMuteCallback] = (0, $acw62.useState)();
    const [onRevive, setOnRevive] = (0, $acw62.useState)();
    const [showScreenSize, setShowScreenSize] = (0, $acw62.useState)(false);
    const [showScreenOrientation, setShowScreenOrientation] = (0, $acw62.useState)(false);
    const [ready, setReady] = (0, $acw62.useState)(false);
    const [loading, setLoading] = (0, $acw62.useState)(true);
    const [inGame, setInGame] = (0, $acw62.useState)(false);
    const [gameLaunched, setGameLaunched] = (0, $acw62.useState)(false);
    //const getNumberOfAvailableNFT = async () => {
    //  if (!publicKey) return
    //  const nfts = (await getCompressedAssets(publicKey, 'HPyb9JaYa6xHK28pgxek7cad9i1GwUK7JaFgRqGBa1HG')) ?? []
    //  return nfts.length
    //}
    const checkScreenSize = ()=>{
        if (!gameContainerRef.current) return;
        setShowScreenOrientation(gameContainerRef.current.offsetWidth > gameContainerRef.current.offsetHeight && (0, $76c62964b0a424ce$exports.isMobile));
        setShowScreenSize(gameContainerRef.current.offsetWidth < 200 || gameContainerRef.current.offsetHeight < 350 || gameContainerRef.current.offsetWidth > 10000 || gameContainerRef.current.offsetHeight > 10000);
        setReady(true);
    };
    const showHomescreenPrepared = (show)=>{
        setInGame(!show);
        setShowHomescreen(show);
        setShowTopBar(show);
        setShowNavigation(show);
        setShowBackground(show);
        setShowLobby(false);
        setShowScore(false);
    };
    const showScoreMenuPrepared = (score, gems)=>{
        if ((0, $b3b1baf40467424d$export$745043c7dc65e495).refreshAccountInfo) (0, $b3b1baf40467424d$export$745043c7dc65e495).refreshAccountInfo();
        dispatch({
            type: "SET_ROOM"
        });
        dispatch({
            type: "SET_ROOM_METADATA"
        });
        dispatch({
            type: "SET_ROOM_SESSION"
        });
        setGameScore(score);
        setGameGems(gems);
        setShowTopBar(true);
        setShowScore(true);
        setInGame(false);
        setShowHomescreen(false);
        setShowNavigation(false);
        setShowBackground(false);
        setShowLobby(false);
    };
    (0, $acw62.useEffect)(()=>{
        //if (hubState.clearGame) hubState.clearGame()
        window.addEventListener("resize", checkScreenSize);
        checkScreenSize();
        (0, $0c69c9c512bb7a3f$export$31feb4e10852ccbd)();
        return ()=>{
            window.removeEventListener("resize", checkScreenSize);
        };
    }, []);
    (0, $acw62.useEffect)(()=>{
        if (!gameRef.current || !ready || showScreenOrientation || showScreenSize || gameLaunched || !(0, $b3b1baf40467424d$export$745043c7dc65e495).showLoading || !(0, $b3b1baf40467424d$export$745043c7dc65e495).showModal) return;
        (0, $b3b1baf40467424d$export$745043c7dc65e495).showLoading(true);
        (0, $5e6922f6744fcb9a$export$b8b10c7c42429e76)(gameRef.current, {
            tryOrReconnect: $35a528e84618b070$export$3394aac6a0917ca2,
            clearGame: ()=>{
                dispatch({
                    type: "SET_ROOM"
                });
                dispatch({
                    type: "SET_ROOM_METADATA"
                });
                dispatch({
                    type: "SET_ROOM_SESSION"
                });
                if ((0, $b3b1baf40467424d$export$745043c7dc65e495).refreshAccountInfo) (0, $b3b1baf40467424d$export$745043c7dc65e495).refreshAccountInfo();
            },
            // GETTERS
            getSessionToken: ()=>(0, $b3b1baf40467424d$export$745043c7dc65e495).sessionToken,
            getCreditsRequest: $35a528e84618b070$export$92508f27abff77c2,
            getAccountInfo: (0, $35a528e84618b070$export$ed6a7eb10310bf8),
            // UI 
            showLoading: (0, $b3b1baf40467424d$export$745043c7dc65e495).showLoading,
            showModal: (0, $b3b1baf40467424d$export$745043c7dc65e495).showModal,
            showHomescreen: showHomescreenPrepared,
            showPauseMenu (show, muteCallback) {
                setMuteCallback(()=>muteCallback);
                setShowPauseMenu(show);
            },
            showContinueMenu (show, onRevive) {
                setOnRevive(()=>onRevive);
                setShowContinueMenu(show);
            },
            showScoreMenu: showScoreMenuPrepared
        }, (progress, exited)=>{
            if ((0, $b3b1baf40467424d$export$745043c7dc65e495).showLoading && !exited) {
                if (progress === 100) {
                    (0, $b3b1baf40467424d$export$745043c7dc65e495).showLoading(false);
                    setLoading(false);
                } else (0, $b3b1baf40467424d$export$745043c7dc65e495).showLoading(true, Math.floor(progress));
            }
        }).then((clearGame)=>{
            (0, $b3b1baf40467424d$export$745043c7dc65e495).clearGame = clearGame;
        }).catch((err)=>{
            (0, $ad26fe773541dcd3$export$b410431fab84fa58).error("Error while retreiving the game state, please try again later or contact the support team");
            console.error(err);
        });
        setGameLaunched(true);
    }, [
        gameRef,
        game,
        showScreenOrientation,
        showScreenSize,
        ready,
        gameLaunched
    ]);
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: (0, $9805619f03ed02ef$export$91884aa883243770)((0, (/*@__PURE__*/$parcel$interopDefault($8ea82a4cc4d506e8$exports))), `player ${className}`),
        ...props,
        onContextMenu: (event)=>{
            event.preventDefault();
        },
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $207d23274fe2be11$export$a118d25f3bd40bb8), {
                show: showScreenOrientation,
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                    className: (0, $9805619f03ed02ef$export$91884aa883243770)((0, (/*@__PURE__*/$parcel$interopDefault($8ea82a4cc4d506e8$exports))), "screen-size"),
                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                        children: "Please use your mobile in portrait orientation to play the game"
                    })
                })
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $207d23274fe2be11$export$a118d25f3bd40bb8), {
                show: showScreenSize && !showScreenOrientation,
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                    className: (0, $9805619f03ed02ef$export$91884aa883243770)((0, (/*@__PURE__*/$parcel$interopDefault($8ea82a4cc4d506e8$exports))), "screen-size"),
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                            children: "You screen is too small (width < 200px or height < 350px) or too big (width > 10000px, height > 10000px)."
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                            children: "To play the game, please modify the size of your window (desktop) or connect with a compatible device."
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: (0, $9805619f03ed02ef$export$91884aa883243770)((0, (/*@__PURE__*/$parcel$interopDefault($8ea82a4cc4d506e8$exports))), "ui-container"),
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: (0, $9805619f03ed02ef$export$91884aa883243770)((0, (/*@__PURE__*/$parcel$interopDefault($8ea82a4cc4d506e8$exports))), `main-ui ${!loading && !inGame ? "fade-in" : ""}`),
                        children: [
                            showBackground && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $d476126f9afdc959$export$668799e4797757a8), {}),
                            showTopBar && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $affb1ceff24a3e39$export$c4e96258f3b6511), {
                                className: (0, $9805619f03ed02ef$export$91884aa883243770)((0, (/*@__PURE__*/$parcel$interopDefault($8ea82a4cc4d506e8$exports))), "top-bar")
                            }),
                            showHomescreen && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $f980f5f69bb36415$export$f2ca285b456891c7), {}),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $56386a68ac3eb975$export$7ddda366b148a43a), {
                                show: showLobby,
                                clientInfo: {
                                    clientWidth: window.innerWidth,
                                    clientHeight: window.innerHeight
                                },
                                onClose: ()=>setShowLobby(false)
                            }),
                            showScore && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $4a03d27093a4ff46$export$6735cf84ecd2736), {
                                score: gameScore,
                                gems: gameGems,
                                onClose: ()=>{
                                    showHomescreenPrepared(true);
                                }
                            }),
                            showNavigation && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $4a67a16e8064c76c$export$b8a61e5c71402559), {
                                className: (0, $9805619f03ed02ef$export$91884aa883243770)((0, (/*@__PURE__*/$parcel$interopDefault($8ea82a4cc4d506e8$exports))), "navigation")
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $55ab31902ab8db2b$export$66bb9231a6614ad8), {
                        className: (0, $9805619f03ed02ef$export$91884aa883243770)((0, (/*@__PURE__*/$parcel$interopDefault($8ea82a4cc4d506e8$exports))), "pause-menu"),
                        show: showPauseMenu,
                        onClose: ()=>setShowPauseMenu(false),
                        onQuit: ()=>showHomescreenPrepared(true),
                        muteCallback: muteCallback
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $03301896a15ad73a$export$90a4e1a8bda2b731), {
                        className: (0, $9805619f03ed02ef$export$91884aa883243770)((0, (/*@__PURE__*/$parcel$interopDefault($8ea82a4cc4d506e8$exports))), "continue-menu"),
                        show: showContinueMenu,
                        onClose: (accepted)=>{
                            setShowContinueMenu(false);
                            if (onRevive) onRevive(accepted);
                        }
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                ref: gameContainerRef,
                className: (0, $9805619f03ed02ef$export$91884aa883243770)((0, (/*@__PURE__*/$parcel$interopDefault($8ea82a4cc4d506e8$exports))), `game ${showScreenSize ? "hidden" : ""}`),
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("canvas", {
                    ref: gameRef
                })
            })
        ]
    });
};



const $6a807f7e8fbb49cb$export$8c41bb232f1008b1 = ()=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $c25623cc446ec3c6$export$63beeacfc264bbcb), {
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $040dbb9c344a508d$export$9ba4e89fdfa1fc54), {
            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7939e29d663dd3ed$export$3565eb3d00ca5a74), {
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7939e29d663dd3ed$export$e7b0ac011bb776c6), {
                    element: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $b5ff9c7262ea50db$export$97f984197eab5d2f), {}),
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7939e29d663dd3ed$export$e7b0ac011bb776c6), {
                            element: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $d3a99b82c5bf971f$export$f8d21f2bc604f7bf), {}),
                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7939e29d663dd3ed$export$e7b0ac011bb776c6), {
                                path: "dashboard",
                                element: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $d3ab93f8f48fad14$export$fedd53519a0e2bce), {}),
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7939e29d663dd3ed$export$e7b0ac011bb776c6), {
                                        path: "game",
                                        element: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $17460f31ac2fcb23$export$2616165974278734), {})
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7939e29d663dd3ed$export$e7b0ac011bb776c6), {
                                        path: "*",
                                        element: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7939e29d663dd3ed$export$444b3ab0cb9aec40), {
                                            to: "game",
                                            replace: true
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7939e29d663dd3ed$export$e7b0ac011bb776c6), {
                                        index: true,
                                        element: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7939e29d663dd3ed$export$444b3ab0cb9aec40), {
                                            to: "game",
                                            replace: true
                                        })
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7939e29d663dd3ed$export$e7b0ac011bb776c6), {
                            path: "*",
                            element: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7939e29d663dd3ed$export$444b3ab0cb9aec40), {
                                to: "dashboard"
                            })
                        })
                    ]
                })
            })
        })
    });



var $ef0249c5e48bf4e3$export$82e9f45cca5ba907 = "fab";
var $ef0249c5e48bf4e3$export$155bdf1ceac204e7 = {
    prefix: "fab",
    iconName: "monero",
    icon: [
        496,
        512,
        [],
        "f3d0",
        "M352 384h108.4C417 455.9 338.1 504 248 504S79 455.9 35.6 384H144V256.2L248 361l104-105v128zM88 336V128l159.4 159.4L408 128v208h74.8c8.5-25.1 13.2-52 13.2-80C496 119 385 8 248 8S0 119 0 256c0 28 4.6 54.9 13.2 80H88z"
    ]
};
var $ef0249c5e48bf4e3$export$3a040ca24382cf1c = {
    prefix: "fab",
    iconName: "hooli",
    icon: [
        640,
        512,
        [],
        "f427",
        "M144.5 352l38.3.8c-13.2-4.6-26-10.2-38.3-16.8zm57.7-5.3v5.3l-19.4.8c36.5 12.5 69.9 14.2 94.7 7.2-19.9.2-45.8-2.6-75.3-13.3zm408.9-115.2c15.9 0 28.9-12.9 28.9-28.9s-12.9-24.5-28.9-24.5c-15.9 0-28.9 8.6-28.9 24.5s12.9 28.9 28.9 28.9zm-29 120.5H640V241.5h-57.9zm-73.7 0h57.9V156.7L508.4 184zm-31-119.4c-18.2-18.2-50.4-17.1-50.4-17.1s-32.3-1.1-50.4 17.1c-18.2 18.2-16.8 33.9-16.8 52.6s-1.4 34.3 16.8 52.5 50.4 17.1 50.4 17.1 32.3 1.1 50.4-17.1c18.2-18.2 16.8-33.8 16.8-52.5-.1-18.8 1.3-34.5-16.8-52.6zm-39.8 71.9c0 3.6-1.8 12.5-10.7 12.5s-10.7-8.9-10.7-12.5v-40.4c0-8.7 7.3-10.9 10.7-10.9s10.7 2.1 10.7 10.9zm-106.2-71.9c-18.2-18.2-50.4-17.1-50.4-17.1s-32.2-1.1-50.4 17.1c-1.9 1.9-3.7 3.9-5.3 6-38.2-29.6-72.5-46.5-102.1-61.1v-20.7l-22.5 10.6c-54.4-22.1-89-18.2-97.3.1 0 0-24.9 32.8 61.8 110.8V352h57.9v-28.6c-6.5-4.2-13-8.7-19.4-13.6-14.8-11.2-27.4-21.6-38.4-31.4v-31c13.1 14.7 30.5 31.4 53.4 50.3l4.5 3.6v-29.8c0-6.9 1.7-18.2 10.8-18.2s10.6 6.9 10.6 15V317c18 12.2 37.3 22.1 57.7 29.6v-93.9c0-18.7-13.4-37.4-40.6-37.4-15.8-.1-30.5 8.2-38.5 21.9v-54.3c41.9 20.9 83.9 46.5 99.9 58.3-10.2 14.6-9.3 28.1-9.3 43.7 0 18.7-1.4 34.3 16.8 52.5s50.4 17.1 50.4 17.1 32.3 1.1 50.4-17.1c18.2-18.2 16.7-33.8 16.7-52.5 0-18.5 1.5-34.2-16.7-52.3zM65.2 184v63.3c-48.7-54.5-38.9-76-35.2-79.1 13.5-11.4 37.5-8 64.4 2.1zm226.5 120.5c0 3.6-1.8 12.5-10.7 12.5s-10.7-8.9-10.7-12.5v-40.4c0-8.7 7.3-10.9 10.7-10.9s10.7 2.1 10.7 10.9z"
    ]
};
var $ef0249c5e48bf4e3$export$2de47f03337052b6 = {
    prefix: "fab",
    iconName: "yelp",
    icon: [
        384,
        512,
        [],
        "f1e9",
        "M42.9 240.32l99.62 48.61c19.2 9.4 16.2 37.51-4.5 42.71L30.5 358.45a22.79 22.79 0 0 1-28.21-19.6 197.16 197.16 0 0 1 9-85.32 22.8 22.8 0 0 1 31.61-13.21zm44 239.25a199.45 199.45 0 0 0 79.42 32.11A22.78 22.78 0 0 0 192.94 490l3.9-110.82c.7-21.3-25.5-31.91-39.81-16.1l-74.21 82.4a22.82 22.82 0 0 0 4.09 34.09zm145.34-109.92l58.81 94a22.93 22.93 0 0 0 34 5.5 198.36 198.36 0 0 0 52.71-67.61A23 23 0 0 0 364.17 370l-105.42-34.26c-20.31-6.5-37.81 15.8-26.51 33.91zm148.33-132.23a197.44 197.44 0 0 0-50.41-69.31 22.85 22.85 0 0 0-34 4.4l-62 91.92c-11.9 17.7 4.7 40.61 25.2 34.71L366 268.63a23 23 0 0 0 14.61-31.21zM62.11 30.18a22.86 22.86 0 0 0-9.9 32l104.12 180.44c11.7 20.2 42.61 11.9 42.61-11.4V22.88a22.67 22.67 0 0 0-24.5-22.8 320.37 320.37 0 0 0-112.33 30.1z"
    ]
};
var $ef0249c5e48bf4e3$export$acc882c0b0e9e801 = {
    prefix: "fab",
    iconName: "cc-visa",
    icon: [
        576,
        512,
        [],
        "f1f0",
        "M470.1 231.3s7.6 37.2 9.3 45H446c3.3-8.9 16-43.5 16-43.5-.2.3 3.3-9.1 5.3-14.9l2.8 13.4zM576 80v352c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V80c0-26.5 21.5-48 48-48h480c26.5 0 48 21.5 48 48zM152.5 331.2L215.7 176h-42.5l-39.3 106-4.3-21.5-14-71.4c-2.3-9.9-9.4-12.7-18.2-13.1H32.7l-.7 3.1c15.8 4 29.9 9.8 42.2 17.1l35.8 135h42.5zm94.4.2L272.1 176h-40.2l-25.1 155.4h40.1zm139.9-50.8c.2-17.7-10.6-31.2-33.7-42.3-14.1-7.1-22.7-11.9-22.7-19.2.2-6.6 7.3-13.4 23.1-13.4 13.1-.3 22.7 2.8 29.9 5.9l3.6 1.7 5.5-33.6c-7.9-3.1-20.5-6.6-36-6.6-39.7 0-67.6 21.2-67.8 51.4-.3 22.3 20 34.7 35.2 42.2 15.5 7.6 20.8 12.6 20.8 19.3-.2 10.4-12.6 15.2-24.1 15.2-16 0-24.6-2.5-37.7-8.3l-5.3-2.5-5.6 34.9c9.4 4.3 26.8 8.1 44.8 8.3 42.2.1 69.7-20.8 70-53zM528 331.4L495.6 176h-31.1c-9.6 0-16.9 2.8-21 12.9l-59.7 142.5H426s6.9-19.2 8.4-23.3H486c1.2 5.5 4.8 23.3 4.8 23.3H528z"
    ]
};
var $ef0249c5e48bf4e3$export$8226e5267dd86de3 = {
    prefix: "fab",
    iconName: "lastfm",
    icon: [
        512,
        512,
        [],
        "f202",
        "M225.8 367.1l-18.8-51s-30.5 34-76.2 34c-40.5 0-69.2-35.2-69.2-91.5 0-72.1 36.4-97.9 72.1-97.9 66.5 0 74.8 53.3 100.9 134.9 18.8 56.9 54 102.6 155.4 102.6 72.7 0 122-22.3 122-80.9 0-72.9-62.7-80.6-115-92.1-25.8-5.9-33.4-16.4-33.4-34 0-19.9 15.8-31.7 41.6-31.7 28.2 0 43.4 10.6 45.7 35.8l58.6-7c-4.7-52.8-41.1-74.5-100.9-74.5-52.8 0-104.4 19.9-104.4 83.9 0 39.9 19.4 65.1 68 76.8 44.9 10.6 79.8 13.8 79.8 45.7 0 21.7-21.1 30.5-61 30.5-59.2 0-83.9-31.1-97.9-73.9-32-96.8-43.6-163-161.3-163C45.7 113.8 0 168.3 0 261c0 89.1 45.7 137.2 127.9 137.2 66.2 0 97.9-31.1 97.9-31.1z"
    ]
};
var $ef0249c5e48bf4e3$export$c0b2d6cff425a846 = {
    prefix: "fab",
    iconName: "shopware",
    icon: [
        512,
        512,
        [],
        "f5b5",
        "M403.5 455.41A246.17 246.17 0 0 1 256 504C118.81 504 8 393 8 256 8 118.81 119 8 256 8a247.39 247.39 0 0 1 165.7 63.5 3.57 3.57 0 0 1-2.86 6.18A418.62 418.62 0 0 0 362.13 74c-129.36 0-222.4 53.47-222.4 155.35 0 109 92.13 145.88 176.83 178.73 33.64 13 65.4 25.36 87 41.59a3.58 3.58 0 0 1 0 5.72zM503 233.09a3.64 3.64 0 0 0-1.27-2.44c-51.76-43-93.62-60.48-144.48-60.48-84.13 0-80.25 52.17-80.25 53.63 0 42.6 52.06 62 112.34 84.49 31.07 11.59 63.19 23.57 92.68 39.93a3.57 3.57 0 0 0 5-1.82A249 249 0 0 0 503 233.09z"
    ]
};
var $ef0249c5e48bf4e3$export$e36098165f3fc869 = {
    prefix: "fab",
    iconName: "creative-commons-nc",
    icon: [
        496,
        512,
        [],
        "f4e8",
        "M247.6 8C387.4 8 496 115.9 496 256c0 147.2-118.5 248-248.4 248C113.1 504 0 393.2 0 256 0 123.1 104.7 8 247.6 8zM55.8 189.1c-7.4 20.4-11.1 42.7-11.1 66.9 0 110.9 92.1 202.4 203.7 202.4 122.4 0 177.2-101.8 178.5-104.1l-93.4-41.6c-7.7 37.1-41.2 53-68.2 55.4v38.1h-28.8V368c-27.5-.3-52.6-10.2-75.3-29.7l34.1-34.5c31.7 29.4 86.4 31.8 86.4-2.2 0-6.2-2.2-11.2-6.6-15.1-14.2-6-1.8-.1-219.3-97.4zM248.4 52.3c-38.4 0-112.4 8.7-170.5 93l94.8 42.5c10-31.3 40.4-42.9 63.8-44.3v-38.1h28.8v38.1c22.7 1.2 43.4 8.9 62 23L295 199.7c-42.7-29.9-83.5-8-70 11.1 53.4 24.1 43.8 19.8 93 41.6l127.1 56.7c4.1-17.4 6.2-35.1 6.2-53.1 0-57-19.8-105-59.3-143.9-39.3-39.9-87.2-59.8-143.6-59.8z"
    ]
};
var $ef0249c5e48bf4e3$export$a4ddb2c7f767be70 = {
    prefix: "fab",
    iconName: "aws",
    icon: [
        640,
        512,
        [],
        "f375",
        "M180.41 203.01c-.72 22.65 10.6 32.68 10.88 39.05a8.164 8.164 0 0 1-4.1 6.27l-12.8 8.96a10.66 10.66 0 0 1-5.63 1.92c-.43-.02-8.19 1.83-20.48-25.61a78.608 78.608 0 0 1-62.61 29.45c-16.28.89-60.4-9.24-58.13-56.21-1.59-38.28 34.06-62.06 70.93-60.05 7.1.02 21.6.37 46.99 6.27v-15.62c2.69-26.46-14.7-46.99-44.81-43.91-2.4.01-19.4-.5-45.84 10.11-7.36 3.38-8.3 2.82-10.75 2.82-7.41 0-4.36-21.48-2.94-24.2 5.21-6.4 35.86-18.35 65.94-18.18a76.857 76.857 0 0 1 55.69 17.28 70.285 70.285 0 0 1 17.67 52.36l-.01 69.29zM93.99 235.4c32.43-.47 46.16-19.97 49.29-30.47 2.46-10.05 2.05-16.41 2.05-27.4-9.67-2.32-23.59-4.85-39.56-4.87-15.15-1.14-42.82 5.63-41.74 32.26-1.24 16.79 11.12 31.4 29.96 30.48zm170.92 23.05c-7.86.72-11.52-4.86-12.68-10.37l-49.8-164.65c-.97-2.78-1.61-5.65-1.92-8.58a4.61 4.61 0 0 1 3.86-5.25c.24-.04-2.13 0 22.25 0 8.78-.88 11.64 6.03 12.55 10.37l35.72 140.83 33.16-140.83c.53-3.22 2.94-11.07 12.8-10.24h17.16c2.17-.18 11.11-.5 12.68 10.37l33.42 142.63L420.98 80.1c.48-2.18 2.72-11.37 12.68-10.37h19.72c.85-.13 6.15-.81 5.25 8.58-.43 1.85 3.41-10.66-52.75 169.9-1.15 5.51-4.82 11.09-12.68 10.37h-18.69c-10.94 1.15-12.51-9.66-12.68-10.75L328.67 110.7l-32.78 136.99c-.16 1.09-1.73 11.9-12.68 10.75h-18.3zm273.48 5.63c-5.88.01-33.92-.3-57.36-12.29a12.802 12.802 0 0 1-7.81-11.91v-10.75c0-8.45 6.2-6.9 8.83-5.89 10.04 4.06 16.48 7.14 28.81 9.6 36.65 7.53 52.77-2.3 56.72-4.48 13.15-7.81 14.19-25.68 5.25-34.95-10.48-8.79-15.48-9.12-53.13-21-4.64-1.29-43.7-13.61-43.79-52.36-.61-28.24 25.05-56.18 69.52-55.95 12.67-.01 46.43 4.13 55.57 15.62 1.35 2.09 2.02 4.55 1.92 7.04v10.11c0 4.44-1.62 6.66-4.87 6.66-7.71-.86-21.39-11.17-49.16-10.75-6.89-.36-39.89.91-38.41 24.97-.43 18.96 26.61 26.07 29.7 26.89 36.46 10.97 48.65 12.79 63.12 29.58 17.14 22.25 7.9 48.3 4.35 55.44-19.08 37.49-68.42 34.44-69.26 34.42zm40.2 104.86c-70.03 51.72-171.69 79.25-258.49 79.25A469.127 469.127 0 0 1 2.83 327.46c-6.53-5.89-.77-13.96 7.17-9.47a637.37 637.37 0 0 0 316.88 84.12 630.22 630.22 0 0 0 241.59-49.55c11.78-5 21.77 7.8 10.12 16.38zm29.19-33.29c-8.96-11.52-59.28-5.38-81.81-2.69-6.79.77-7.94-5.12-1.79-9.47 40.07-28.17 105.88-20.1 113.44-10.63 7.55 9.47-2.05 75.41-39.56 106.91-5.76 4.87-11.27 2.3-8.71-4.1 8.44-21.25 27.39-68.49 18.43-80.02z"
    ]
};
var $ef0249c5e48bf4e3$export$d65557a7abc2c5dc = {
    prefix: "fab",
    iconName: "redhat",
    icon: [
        512,
        512,
        [],
        "f7bc",
        "M341.52 285.56c33.65 0 82.34-6.94 82.34-47 .22-6.74.86-1.82-20.88-96.24-4.62-19.15-8.68-27.84-42.31-44.65-26.09-13.34-82.92-35.37-99.73-35.37-15.66 0-20.2 20.17-38.87 20.17-18 0-31.31-15.06-48.12-15.06-16.14 0-26.66 11-34.78 33.62-27.5 77.55-26.28 74.27-26.12 78.27 0 24.8 97.64 106.11 228.47 106.11M429 254.84c4.65 22 4.65 24.35 4.65 27.25 0 37.66-42.33 58.56-98 58.56-125.74.08-235.91-73.65-235.91-122.33a49.55 49.55 0 0 1 4.06-19.72C58.56 200.86 0 208.93 0 260.63c0 84.67 200.63 189 359.49 189 121.79 0 152.51-55.08 152.51-98.58 0-34.21-29.59-73.05-82.93-96.24"
    ]
};
var $ef0249c5e48bf4e3$export$73b6ef60226f6801 = {
    prefix: "fab",
    iconName: "yoast",
    icon: [
        448,
        512,
        [],
        "f2b1",
        "M91.3 76h186l-7 18.9h-179c-39.7 0-71.9 31.6-71.9 70.3v205.4c0 35.4 24.9 70.3 84 70.3V460H91.3C41.2 460 0 419.8 0 370.5V165.2C0 115.9 40.7 76 91.3 76zm229.1-56h66.5C243.1 398.1 241.2 418.9 202.2 459.3c-20.8 21.6-49.3 31.7-78.3 32.7v-51.1c49.2-7.7 64.6-49.9 64.6-75.3 0-20.1.6-12.6-82.1-223.2h61.4L218.2 299 320.4 20zM448 161.5V460H234c6.6-9.6 10.7-16.3 12.1-19.4h182.5V161.5c0-32.5-17.1-51.9-48.2-62.9l6.7-17.6c41.7 13.6 60.9 43.1 60.9 80.5z"
    ]
};
var $ef0249c5e48bf4e3$export$7a31e37b2189232c = {
    prefix: "fab",
    iconName: "cloudflare",
    icon: [
        640,
        512,
        [],
        "e07d",
        "M407.906,319.913l-230.8-2.928a4.58,4.58,0,0,1-3.632-1.926,4.648,4.648,0,0,1-.494-4.147,6.143,6.143,0,0,1,5.361-4.076L411.281,303.9c27.631-1.26,57.546-23.574,68.022-50.784l13.286-34.542a7.944,7.944,0,0,0,.524-2.936,7.735,7.735,0,0,0-.164-1.631A151.91,151.91,0,0,0,201.257,198.4,68.12,68.12,0,0,0,94.2,269.59C41.924,271.106,0,313.728,0,366.12a96.054,96.054,0,0,0,1.029,13.958,4.508,4.508,0,0,0,4.445,3.871l426.1.051c.043,0,.08-.019.122-.02a5.606,5.606,0,0,0,5.271-4l3.273-11.265c3.9-13.4,2.448-25.8-4.1-34.9C430.124,325.423,420.09,320.487,407.906,319.913ZM513.856,221.1c-2.141,0-4.271.062-6.391.164a3.771,3.771,0,0,0-3.324,2.653l-9.077,31.193c-3.9,13.4-2.449,25.786,4.1,34.89,6.02,8.4,16.054,13.323,28.238,13.9l49.2,2.939a4.491,4.491,0,0,1,3.51,1.894,4.64,4.64,0,0,1,.514,4.169,6.153,6.153,0,0,1-5.351,4.075l-51.125,2.939c-27.754,1.27-57.669,23.574-68.145,50.784l-3.695,9.606a2.716,2.716,0,0,0,2.427,3.68c.046,0,.088.017.136.017h175.91a4.69,4.69,0,0,0,4.539-3.37,124.807,124.807,0,0,0,4.682-34C640,277.3,583.524,221.1,513.856,221.1Z"
    ]
};
var $ef0249c5e48bf4e3$export$c6f6a1beb6102ac = {
    prefix: "fab",
    iconName: "ups",
    icon: [
        384,
        512,
        [],
        "f7e0",
        "M103.2 303c-5.2 3.6-32.6 13.1-32.6-19V180H37.9v102.6c0 74.9 80.2 51.1 97.9 39V180h-32.6zM4 74.82v220.9c0 103.7 74.9 135.2 187.7 184.1 112.4-48.9 187.7-80.2 187.7-184.1V74.82c-116.3-61.6-281.8-49.6-375.4 0zm358.1 220.9c0 86.6-53.2 113.6-170.4 165.3-117.5-51.8-170.5-78.7-170.5-165.3v-126.4c102.3-93.8 231.6-100 340.9-89.8zm-209.6-107.4v212.8h32.7v-68.7c24.4 7.3 71.7-2.6 71.7-78.5 0-97.4-80.7-80.92-104.4-65.6zm32.7 117.3v-100.3c8.4-4.2 38.4-12.7 38.4 49.3 0 67.9-36.4 51.8-38.4 51zm79.1-86.4c.1 47.3 51.6 42.5 52.2 70.4.6 23.5-30.4 23-50.8 4.9v30.1c36.2 21.5 81.9 8.1 83.2-33.5 1.7-51.5-54.1-46.6-53.4-73.2.6-20.3 30.6-20.5 48.5-2.2v-28.4c-28.5-22-79.9-9.2-79.7 31.9z"
    ]
};
var $ef0249c5e48bf4e3$export$9ab35a48e8f904bf = {
    prefix: "fab",
    iconName: "wpexplorer",
    icon: [
        512,
        512,
        [],
        "f2de",
        "M512 256c0 141.2-114.7 256-256 256C114.8 512 0 397.3 0 256S114.7 0 256 0s256 114.7 256 256zm-32 0c0-123.2-100.3-224-224-224C132.5 32 32 132.5 32 256s100.5 224 224 224 224-100.5 224-224zM160.9 124.6l86.9 37.1-37.1 86.9-86.9-37.1 37.1-86.9zm110 169.1l46.6 94h-14.6l-50-100-48.9 100h-14l51.1-106.9-22.3-9.4 6-14 68.6 29.1-6 14.3-16.5-7.1zm-11.8-116.3l68.6 29.4-29.4 68.3L230 246l29.1-68.6zm80.3 42.9l54.6 23.1-23.4 54.3-54.3-23.1 23.1-54.3z"
    ]
};
var $ef0249c5e48bf4e3$export$1661cbacae81932b = {
    prefix: "fab",
    iconName: "dyalog",
    icon: [
        416,
        512,
        [],
        "f399",
        "M0 32v119.2h64V96h107.2C284.6 96 352 176.2 352 255.9 352 332 293.4 416 171.2 416H0v64h171.2C331.9 480 416 367.3 416 255.9c0-58.7-22.1-113.4-62.3-154.3C308.9 56 245.7 32 171.2 32H0z"
    ]
};
var $ef0249c5e48bf4e3$export$76a6a7e968d921fe = {
    prefix: "fab",
    iconName: "bity",
    icon: [
        496,
        512,
        [],
        "f37a",
        "M78.4 67.2C173.8-22 324.5-24 421.5 71c14.3 14.1-6.4 37.1-22.4 21.5-84.8-82.4-215.8-80.3-298.9-3.2-16.3 15.1-36.5-8.3-21.8-22.1zm98.9 418.6c19.3 5.7 29.3-23.6 7.9-30C73 421.9 9.4 306.1 37.7 194.8c5-19.6-24.9-28.1-30.2-7.1-32.1 127.4 41.1 259.8 169.8 298.1zm148.1-2c121.9-40.2 192.9-166.9 164.4-291-4.5-19.7-34.9-13.8-30 7.9 24.2 107.7-37.1 217.9-143.2 253.4-21.2 7-10.4 36 8.8 29.7zm-62.9-79l.2-71.8c0-8.2-6.6-14.8-14.8-14.8-8.2 0-14.8 6.7-14.8 14.8l-.2 71.8c0 8.2 6.6 14.8 14.8 14.8s14.8-6.6 14.8-14.8zm71-269c2.1 90.9 4.7 131.9-85.5 132.5-92.5-.7-86.9-44.3-85.5-132.5 0-21.8-32.5-19.6-32.5 0v71.6c0 69.3 60.7 90.9 118 90.1 57.3.8 118-20.8 118-90.1v-71.6c0-19.6-32.5-21.8-32.5 0z"
    ]
};
var $ef0249c5e48bf4e3$export$a14b012b76f98910 = {
    prefix: "fab",
    iconName: "stackpath",
    icon: [
        448,
        512,
        [],
        "f842",
        "M244.6 232.4c0 8.5-4.26 20.49-21.34 20.49h-19.61v-41.47h19.61c17.13 0 21.34 12.36 21.34 20.98zM448 32v448H0V32zM151.3 287.84c0-21.24-12.12-34.54-46.72-44.85-20.57-7.41-26-10.91-26-18.63s7-14.61 20.41-14.61c14.09 0 20.79 8.45 20.79 18.35h30.7l.19-.57c.5-19.57-15.06-41.65-51.12-41.65-23.37 0-52.55 10.75-52.55 38.29 0 19.4 9.25 31.29 50.74 44.37 17.26 6.15 21.91 10.4 21.91 19.48 0 15.2-19.13 14.23-19.47 14.23-20.4 0-25.65-9.1-25.65-21.9h-30.8l-.18.56c-.68 31.32 28.38 45.22 56.63 45.22 29.98 0 51.12-13.55 51.12-38.29zm125.38-55.63c0-25.3-18.43-45.46-53.42-45.46h-51.78v138.18h32.17v-47.36h19.61c30.25 0 53.42-15.95 53.42-45.36zM297.94 325L347 186.78h-31.09L268 325zm106.52-138.22h-31.09L325.46 325h29.94z"
    ]
};
var $ef0249c5e48bf4e3$export$6c0bc096306cebf8 = {
    prefix: "fab",
    iconName: "buysellads",
    icon: [
        448,
        512,
        [],
        "f20d",
        "M224 150.7l42.9 160.7h-85.8L224 150.7zM448 80v352c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V80c0-26.5 21.5-48 48-48h352c26.5 0 48 21.5 48 48zm-65.3 325.3l-94.5-298.7H159.8L65.3 405.3H156l111.7-91.6 24.2 91.6h90.8z"
    ]
};
var $ef0249c5e48bf4e3$export$e0a21844bf49ca8e = {
    prefix: "fab",
    iconName: "first-order",
    icon: [
        448,
        512,
        [],
        "f2b0",
        "M12.9 229.2c.1-.1.2-.3.3-.4 0 .1 0 .3-.1.4h-.2zM224 96.6c-7.1 0-14.6.6-21.4 1.7l3.7 67.4-22-64c-14.3 3.7-27.7 9.4-40 16.6l29.4 61.4-45.1-50.9c-11.4 8.9-21.7 19.1-30.6 30.9l50.6 45.4-61.1-29.7c-7.1 12.3-12.9 25.7-16.6 40l64.3 22.6-68-4c-.9 7.1-1.4 14.6-1.4 22s.6 14.6 1.4 21.7l67.7-4-64 22.6c3.7 14.3 9.4 27.7 16.6 40.3l61.1-29.7L97.7 352c8.9 11.7 19.1 22.3 30.9 30.9l44.9-50.9-29.5 61.4c12.3 7.4 25.7 13.1 40 16.9l22.3-64.6-4 68c7.1 1.1 14.6 1.7 21.7 1.7 7.4 0 14.6-.6 21.7-1.7l-4-68.6 22.6 65.1c14.3-4 27.7-9.4 40-16.9L274.9 332l44.9 50.9c11.7-8.9 22-19.1 30.6-30.9l-50.6-45.1 61.1 29.4c7.1-12.3 12.9-25.7 16.6-40.3l-64-22.3 67.4 4c1.1-7.1 1.4-14.3 1.4-21.7s-.3-14.9-1.4-22l-67.7 4 64-22.3c-3.7-14.3-9.1-28-16.6-40.3l-60.9 29.7 50.6-45.4c-8.9-11.7-19.1-22-30.6-30.9l-45.1 50.9 29.4-61.1c-12.3-7.4-25.7-13.1-40-16.9L241.7 166l4-67.7c-7.1-1.2-14.3-1.7-21.7-1.7zM443.4 128v256L224 512 4.6 384V128L224 0l219.4 128zm-17.1 10.3L224 20.9 21.7 138.3v235.1L224 491.1l202.3-117.7V138.3zM224 37.1l187.7 109.4v218.9L224 474.9 36.3 365.4V146.6L224 37.1zm0 50.9c-92.3 0-166.9 75.1-166.9 168 0 92.6 74.6 167.7 166.9 167.7 92 0 166.9-75.1 166.9-167.7 0-92.9-74.9-168-166.9-168z"
    ]
};
var $ef0249c5e48bf4e3$export$fb06254b4488a5b6 = {
    prefix: "fab",
    iconName: "modx",
    icon: [
        448,
        512,
        [],
        "f285",
        "M356 241.8l36.7 23.7V480l-133-83.8L356 241.8zM440 75H226.3l-23 37.8 153.5 96.5L440 75zm-89 142.8L55.2 32v214.5l46 29L351 217.8zM97 294.2L8 437h213.7l125-200.5L97 294.2z"
    ]
};
var $ef0249c5e48bf4e3$export$b6ff6f33a85ee805 = {
    prefix: "fab",
    iconName: "guilded",
    icon: [
        448,
        512,
        [],
        "e07e",
        "M443.427,64H4.571c0,103.26,22.192,180.06,43.418,222.358C112.046,414.135,224,448,225.256,448a312.824,312.824,0,0,0,140.55-103.477c25.907-33.923,53.1-87.19,65.916-145.761H171.833c4.14,36.429,22.177,67.946,45.1,86.944h88.589c-17.012,28.213-48.186,54.4-80.456,69.482-31.232-13.259-69.09-46.544-96.548-98.362-26.726-53.833-27.092-105.883-27.092-105.883H437.573A625.91,625.91,0,0,0,443.427,64Z"
    ]
};
var $ef0249c5e48bf4e3$export$13bd8782a2ce17e7 = {
    prefix: "fab",
    iconName: "vnv",
    icon: [
        640,
        512,
        [],
        "f40b",
        "M104.9 352c-34.1 0-46.4-30.4-46.4-30.4L2.6 210.1S-7.8 192 13 192h32.8c10.4 0 13.2 8.7 18.8 18.1l36.7 74.5s5.2 13.1 21.1 13.1 21.1-13.1 21.1-13.1l36.7-74.5c5.6-9.5 8.4-18.1 18.8-18.1h32.8c20.8 0 10.4 18.1 10.4 18.1l-55.8 111.5S174.2 352 140 352h-35.1zm395 0c-34.1 0-46.4-30.4-46.4-30.4l-55.9-111.5S387.2 192 408 192h32.8c10.4 0 13.2 8.7 18.8 18.1l36.7 74.5s5.2 13.1 21.1 13.1 21.1-13.1 21.1-13.1l36.8-74.5c5.6-9.5 8.4-18.1 18.8-18.1H627c20.8 0 10.4 18.1 10.4 18.1l-55.9 111.5S569.3 352 535.1 352h-35.2zM337.6 192c34.1 0 46.4 30.4 46.4 30.4l55.9 111.5s10.4 18.1-10.4 18.1h-32.8c-10.4 0-13.2-8.7-18.8-18.1l-36.7-74.5s-5.2-13.1-21.1-13.1c-15.9 0-21.1 13.1-21.1 13.1l-36.7 74.5c-5.6 9.4-8.4 18.1-18.8 18.1h-32.9c-20.8 0-10.4-18.1-10.4-18.1l55.9-111.5s12.2-30.4 46.4-30.4h35.1z"
    ]
};
var $ef0249c5e48bf4e3$export$c989752ecb8b3fae = {
    prefix: "fab",
    iconName: "square-js",
    icon: [
        448,
        512,
        [
            "js-square"
        ],
        "f3b9",
        "M400 32H48C21.5 32 0 53.5 0 80v352c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48V80c0-26.5-21.5-48-48-48zM243.8 381.4c0 43.6-25.6 63.5-62.9 63.5-33.7 0-53.2-17.4-63.2-38.5l34.3-20.7c6.6 11.7 12.6 21.6 27.1 21.6 13.8 0 22.6-5.4 22.6-26.5V237.7h42.1v143.7zm99.6 63.5c-39.1 0-64.4-18.6-76.7-43l34.3-19.8c9 14.7 20.8 25.6 41.5 25.6 17.4 0 28.6-8.7 28.6-20.8 0-14.4-11.4-19.5-30.7-28l-10.5-4.5c-30.4-12.9-50.5-29.2-50.5-63.5 0-31.6 24.1-55.6 61.6-55.6 26.8 0 46 9.3 59.8 33.7L368 290c-7.2-12.9-15-18-27.1-18-12.3 0-20.1 7.8-20.1 18 0 12.6 7.8 17.7 25.9 25.6l10.5 4.5c35.8 15.3 55.9 31 55.9 66.2 0 37.8-29.8 58.6-69.7 58.6z"
    ]
};
var $ef0249c5e48bf4e3$export$d9bf3211f885d573 = $ef0249c5e48bf4e3$export$c989752ecb8b3fae;
var $ef0249c5e48bf4e3$export$b3b8195c77f1f877 = {
    prefix: "fab",
    iconName: "microsoft",
    icon: [
        448,
        512,
        [],
        "f3ca",
        "M0 32h214.6v214.6H0V32zm233.4 0H448v214.6H233.4V32zM0 265.4h214.6V480H0V265.4zm233.4 0H448V480H233.4V265.4z"
    ]
};
var $ef0249c5e48bf4e3$export$39d59e523abf051d = {
    prefix: "fab",
    iconName: "qq",
    icon: [
        448,
        512,
        [],
        "f1d6",
        "M433.754 420.445c-11.526 1.393-44.86-52.741-44.86-52.741 0 31.345-16.136 72.247-51.051 101.786 16.842 5.192 54.843 19.167 45.803 34.421-7.316 12.343-125.51 7.881-159.632 4.037-34.122 3.844-152.316 8.306-159.632-4.037-9.045-15.25 28.918-29.214 45.783-34.415-34.92-29.539-51.059-70.445-51.059-101.792 0 0-33.334 54.134-44.859 52.741-5.37-.65-12.424-29.644 9.347-99.704 10.261-33.024 21.995-60.478 40.144-105.779C60.683 98.063 108.982.006 224 0c113.737.006 163.156 96.133 160.264 214.963 18.118 45.223 29.912 72.85 40.144 105.778 21.768 70.06 14.716 99.053 9.346 99.704z"
    ]
};
var $ef0249c5e48bf4e3$export$9bf8457cc97dd02e = {
    prefix: "fab",
    iconName: "orcid",
    icon: [
        512,
        512,
        [],
        "f8d2",
        "M294.75 188.19h-45.92V342h47.47c67.62 0 83.12-51.34 83.12-76.91 0-41.64-26.54-76.9-84.67-76.9zM256 8C119 8 8 119 8 256s111 248 248 248 248-111 248-248S393 8 256 8zm-80.79 360.76h-29.84v-207.5h29.84zm-14.92-231.14a19.57 19.57 0 1 1 19.57-19.57 19.64 19.64 0 0 1-19.57 19.57zM300 369h-81V161.26h80.6c76.73 0 110.44 54.83 110.44 103.85C410 318.39 368.38 369 300 369z"
    ]
};
var $ef0249c5e48bf4e3$export$25a84a6ff654acd1 = {
    prefix: "fab",
    iconName: "java",
    icon: [
        384,
        512,
        [],
        "f4e4",
        "M277.74 312.9c9.8-6.7 23.4-12.5 23.4-12.5s-38.7 7-77.2 10.2c-47.1 3.9-97.7 4.7-123.1 1.3-60.1-8 33-30.1 33-30.1s-36.1-2.4-80.6 19c-52.5 25.4 130 37 224.5 12.1zm-85.4-32.1c-19-42.7-83.1-80.2 0-145.8C296 53.2 242.84 0 242.84 0c21.5 84.5-75.6 110.1-110.7 162.6-23.9 35.9 11.7 74.4 60.2 118.2zm114.6-176.2c.1 0-175.2 43.8-91.5 140.2 24.7 28.4-6.5 54-6.5 54s62.7-32.4 33.9-72.9c-26.9-37.8-47.5-56.6 64.1-121.3zm-6.1 270.5a12.19 12.19 0 0 1-2 2.6c128.3-33.7 81.1-118.9 19.8-97.3a17.33 17.33 0 0 0-8.2 6.3 70.45 70.45 0 0 1 11-3c31-6.5 75.5 41.5-20.6 91.4zM348 437.4s14.5 11.9-15.9 21.2c-57.9 17.5-240.8 22.8-291.6.7-18.3-7.9 16-19 26.8-21.3 11.2-2.4 17.7-2 17.7-2-20.3-14.3-131.3 28.1-56.4 40.2C232.84 509.4 401 461.3 348 437.4zM124.44 396c-78.7 22 47.9 67.4 148.1 24.5a185.89 185.89 0 0 1-28.2-13.8c-44.7 8.5-65.4 9.1-106 4.5-33.5-3.8-13.9-15.2-13.9-15.2zm179.8 97.2c-78.7 14.8-175.8 13.1-233.3 3.6 0-.1 11.8 9.7 72.4 13.6 92.2 5.9 233.8-3.3 237.1-46.9 0 0-6.4 16.5-76.2 29.7zM260.64 353c-59.2 11.4-93.5 11.1-136.8 6.6-33.5-3.5-11.6-19.7-11.6-19.7-86.8 28.8 48.2 61.4 169.5 25.9a60.37 60.37 0 0 1-21.1-12.8z"
    ]
};
var $ef0249c5e48bf4e3$export$6e249797a4721568 = {
    prefix: "fab",
    iconName: "invision",
    icon: [
        448,
        512,
        [],
        "f7b0",
        "M407.4 32H40.6C18.2 32 0 50.2 0 72.6v366.8C0 461.8 18.2 480 40.6 480h366.8c22.4 0 40.6-18.2 40.6-40.6V72.6c0-22.4-18.2-40.6-40.6-40.6zM176.1 145.6c.4 23.4-22.4 27.3-26.6 27.4-14.9 0-27.1-12-27.1-27 .1-35.2 53.1-35.5 53.7-.4zM332.8 377c-65.6 0-34.1-74-25-106.6 14.1-46.4-45.2-59-59.9.7l-25.8 103.3H177l8.1-32.5c-31.5 51.8-94.6 44.4-94.6-4.3.1-14.3.9-14 23-104.1H81.7l9.7-35.6h76.4c-33.6 133.7-32.6 126.9-32.9 138.2 0 20.9 40.9 13.5 57.4-23.2l19.8-79.4h-32.3l9.7-35.6h68.8l-8.9 40.5c40.5-75.5 127.9-47.8 101.8 38-14.2 51.1-14.6 50.7-14.9 58.8 0 15.5 17.5 22.6 31.8-16.9L386 325c-10.5 36.7-29.4 52-53.2 52z"
    ]
};
var $ef0249c5e48bf4e3$export$d93ab92a56e88ce6 = {
    prefix: "fab",
    iconName: "creative-commons-pd-alt",
    icon: [
        496,
        512,
        [],
        "f4ed",
        "M247.6 8C104.7 8 0 123.1 0 256c0 138.5 113.6 248 247.6 248C377.5 504 496 403.1 496 256 496 118.1 389.4 8 247.6 8zm.8 450.8c-112.5 0-203.7-93-203.7-202.8 0-105.4 85.5-203.3 203.7-203.3 112.6 0 202.9 89.5 202.8 203.3 0 121.7-99.6 202.8-202.8 202.8zM316.7 186h-53.2v137.2h53.2c21.4 0 70-5.1 70-68.6 0-63.4-48.6-68.6-70-68.6zm.8 108.5h-19.9v-79.7l19.4-.1c3.8 0 35-2.1 35 39.9 0 24.6-10.5 39.9-34.5 39.9zM203.7 186h-68.2v137.3h34.6V279h27c54.1 0 57.1-37.5 57.1-46.5 0-31-16.8-46.5-50.5-46.5zm-4.9 67.3h-29.2v-41.6h28.3c30.9 0 28.8 41.6.9 41.6z"
    ]
};
var $ef0249c5e48bf4e3$export$961762d5b3aedd8d = {
    prefix: "fab",
    iconName: "centercode",
    icon: [
        512,
        512,
        [],
        "f380",
        "M329.2 268.6c-3.8 35.2-35.4 60.6-70.6 56.8-35.2-3.8-60.6-35.4-56.8-70.6 3.8-35.2 35.4-60.6 70.6-56.8 35.1 3.8 60.6 35.4 56.8 70.6zm-85.8 235.1C96.7 496-8.2 365.5 10.1 224.3c11.2-86.6 65.8-156.9 139.1-192 161-77.1 349.7 37.4 354.7 216.6 4.1 147-118.4 262.2-260.5 254.8zm179.9-180c27.9-118-160.5-205.9-237.2-234.2-57.5 56.3-69.1 188.6-33.8 344.4 68.8 15.8 169.1-26.4 271-110.2z"
    ]
};
var $ef0249c5e48bf4e3$export$91d5526742c32d42 = {
    prefix: "fab",
    iconName: "glide-g",
    icon: [
        448,
        512,
        [],
        "f2a6",
        "M407.1 211.2c-3.5-1.4-11.6-3.8-15.4-3.8-37.1 0-62.2 16.8-93.5 34.5l-.9-.9c7-47.3 23.5-91.9 23.5-140.4C320.8 29.1 282.6 0 212.4 0 97.3 0 39 113.7 39 198.4 39 286.3 90.3 335 177.6 335c12 0 11-1 11 3.8-16.9 128.9-90.8 133.1-90.8 94.6 0-39.2 45-58.6 45.5-61-.3-12.2-47-27.6-58.9-27.6-33.9.1-52.4 51.2-52.4 79.3C32 476 64.8 512 117.5 512c77.4 0 134-77.8 151.4-145.4 15.1-60.5 11.2-63.3 19.7-67.6 32.2-16.2 57.5-27 93.8-27 17.8 0 30.5 3.7 58.9 8.4 2.9 0 6.7-2.9 6.7-5.8 0-8-33.4-60.5-40.9-63.4zm-175.3-84.4c-9.3 44.7-18.6 89.6-27.8 134.3-2.3 10.2-13.3 7.8-22 7.8-38.3 0-49-41.8-49-73.1 0-47 18-109.3 61.8-133.4 7-4.1 14.8-6.7 22.6-6.7 18.6 0 20 13.3 20 28.7-.1 14.3-2.7 28.5-5.6 42.4z"
    ]
};
var $ef0249c5e48bf4e3$export$51e679e8d2e3f8c1 = {
    prefix: "fab",
    iconName: "drupal",
    icon: [
        448,
        512,
        [],
        "f1a9",
        "M303.973,108.136C268.2,72.459,234.187,38.35,224.047,0c-9.957,38.35-44.25,72.459-80.019,108.136C90.467,161.7,29.716,222.356,29.716,313.436c-2.337,107.3,82.752,196.18,190.053,198.517S415.948,429.2,418.285,321.9q.091-4.231,0-8.464C418.285,222.356,357.534,161.7,303.973,108.136Zm-174.326,223a130.282,130.282,0,0,0-15.211,24.153,4.978,4.978,0,0,1-3.319,2.766h-1.659c-4.333,0-9.219-8.481-9.219-8.481h0c-1.29-2.028-2.489-4.149-3.687-6.361l-.83-1.752c-11.247-25.72-1.475-62.318-1.475-62.318h0a160.585,160.585,0,0,1,23.231-49.873A290.8,290.8,0,0,1,138.5,201.613l9.219,9.219,43.512,44.434a4.979,4.979,0,0,1,0,6.638L145.78,312.33h0Zm96.612,127.311a67.2,67.2,0,0,1-49.781-111.915c14.2-16.871,31.528-33.464,50.334-55.313,22.309,23.785,36.875,40.1,51.164,57.986a28.413,28.413,0,0,1,2.95,4.425,65.905,65.905,0,0,1,11.984,37.981,66.651,66.651,0,0,1-66.466,66.836ZM352.371,351.6h0a7.743,7.743,0,0,1-6.176,5.347H344.9a11.249,11.249,0,0,1-6.269-5.07h0a348.21,348.21,0,0,0-39.456-48.952L281.387,284.49,222.3,223.185a497.888,497.888,0,0,1-35.4-36.322,12.033,12.033,0,0,0-.922-1.382,35.4,35.4,0,0,1-4.7-9.219V174.51a31.346,31.346,0,0,1,9.218-27.656c11.432-11.431,22.955-22.954,33.833-34.939,11.984,13.275,24.8,26,37.428,38.627h0a530.991,530.991,0,0,1,69.6,79.1,147.494,147.494,0,0,1,27.011,83.8A134.109,134.109,0,0,1,352.371,351.6Z"
    ]
};
var $ef0249c5e48bf4e3$export$66507f26cc60b31e = {
    prefix: "fab",
    iconName: "hire-a-helper",
    icon: [
        512,
        512,
        [],
        "f3b0",
        "M443.1 0H71.9C67.9 37.3 37.4 67.8 0 71.7v371.5c37.4 4.9 66 32.4 71.9 68.8h372.2c3-36.4 32.5-65.8 67.9-69.8V71.7c-36.4-5.9-65-35.3-68.9-71.7zm-37 404.9c-36.3 0-18.8-2-55.1-2-35.8 0-21 2-56.1 2-5.9 0-4.9-8.2 0-9.8 22.8-7.6 22.9-10.2 24.6-12.8 10.4-15.6 5.9-83 5.9-113 0-5.3-6.4-12.8-13.8-12.8H200.4c-7.4 0-13.8 7.5-13.8 12.8 0 30-4.5 97.4 5.9 113 1.7 2.5 1.8 5.2 24.6 12.8 4.9 1.6 6 9.8 0 9.8-35.1 0-20.3-2-56.1-2-36.3 0-18.8 2-55.1 2-7.9 0-5.8-10.8 0-10.8 10.2-3.4 13.5-3.5 21.7-13.8 7.7-12.9 7.9-44.4 7.9-127.8V151.3c0-22.2-12.2-28.3-28.6-32.4-8.8-2.2-4-11.8 1-11.8 36.5 0 20.6 2 57.1 2 32.7 0 16.5-2 49.2-2 3.3 0 8.5 8.3 1 10.8-4.9 1.6-27.6 3.7-27.6 39.3 0 45.6-.2 55.8 1 68.8 0 1.3 2.3 12.8 12.8 12.8h109.2c10.5 0 12.8-11.5 12.8-12.8 1.2-13 1-23.2 1-68.8 0-35.6-22.7-37.7-27.6-39.3-7.5-2.5-2.3-10.8 1-10.8 32.7 0 16.5 2 49.2 2 36.5 0 20.6-2 57.1-2 4.9 0 9.9 9.6 1 11.8-16.4 4.1-28.6 10.3-28.6 32.4v101.2c0 83.4.1 114.9 7.9 127.8 8.2 10.2 11.4 10.4 21.7 13.8 5.8 0 7.8 10.8 0 10.8z"
    ]
};
var $ef0249c5e48bf4e3$export$5040b13190e5beb7 = {
    prefix: "fab",
    iconName: "creative-commons-by",
    icon: [
        496,
        512,
        [],
        "f4e7",
        "M314.9 194.4v101.4h-28.3v120.5h-77.1V295.9h-28.3V194.4c0-4.4 1.6-8.2 4.6-11.3 3.1-3.1 6.9-4.7 11.3-4.7H299c4.1 0 7.8 1.6 11.1 4.7 3.1 3.2 4.8 6.9 4.8 11.3zm-101.5-63.7c0-23.3 11.5-35 34.5-35s34.5 11.7 34.5 35c0 23-11.5 34.5-34.5 34.5s-34.5-11.5-34.5-34.5zM247.6 8C389.4 8 496 118.1 496 256c0 147.1-118.5 248-248.4 248C113.6 504 0 394.5 0 256 0 123.1 104.7 8 247.6 8zm.8 44.7C130.2 52.7 44.7 150.6 44.7 256c0 109.8 91.2 202.8 203.7 202.8 103.2 0 202.8-81.1 202.8-202.8.1-113.8-90.2-203.3-202.8-203.3z"
    ]
};
var $ef0249c5e48bf4e3$export$72fd5838af249737 = {
    prefix: "fab",
    iconName: "unity",
    icon: [
        448,
        512,
        [],
        "e049",
        "M243.583 91.6027L323.695 138.384C326.575 140.026 326.68 144.583 323.695 146.225L228.503 201.854C225.623 203.55 222.22 203.444 219.549 201.854L124.357 146.225C121.425 144.636 121.373 139.973 124.357 138.384L204.417 91.6027V0L0 119.417V358.252L78.3843 312.477V218.914C78.3319 215.576 82.2066 213.192 85.0865 214.993L180.279 270.622C183.159 272.318 184.782 275.338 184.782 278.464V389.669C184.834 393.007 180.959 395.391 178.079 393.589L97.9673 346.808L19.583 392.583L224 512L428.417 392.583L350.033 346.808L269.921 393.589C267.093 395.338 263.114 393.06 263.218 389.669V278.464C263.218 275.126 265.051 272.159 267.721 270.622L362.914 214.993C365.741 213.245 369.72 215.47 369.616 218.914V312.477L448 358.252V119.417L243.583 0V91.6027Z"
    ]
};
var $ef0249c5e48bf4e3$export$4d4f65ec2f52482 = {
    prefix: "fab",
    iconName: "whmcs",
    icon: [
        448,
        512,
        [],
        "f40d",
        "M448 161v-21.3l-28.5-8.8-2.2-10.4 20.1-20.7L427 80.4l-29 7.5-7.2-7.5 7.5-28.2-19.1-11.6-21.3 21-10.7-3.2-7-26.4h-22.6l-6.2 26.4-12.1 3.2-19.7-21-19.4 11 8.1 27.7-8.1 8.4-28.5-7.5-11 19.1 20.7 21-2.9 10.4-28.5 7.8-.3 21.7 28.8 7.5 2.4 12.1-20.1 19.9 10.4 18.5 29.6-7.5 7.2 8.6-8.1 26.9 19.9 11.6 19.4-20.4 11.6 2.9 6.7 28.5 22.6.3 6.7-28.8 11.6-3.5 20.7 21.6 20.4-12.1-8.8-28 7.8-8.1 28.8 8.8 10.3-20.1-20.9-18.8 2.2-12.1 29.1-7zm-119.2 45.2c-31.3 0-56.8-25.4-56.8-56.8s25.4-56.8 56.8-56.8 56.8 25.4 56.8 56.8c0 31.5-25.4 56.8-56.8 56.8zm72.3 16.4l46.9 14.5V277l-55.1 13.4-4.1 22.7 38.9 35.3-19.2 37.9-54-16.7-14.6 15.2 16.7 52.5-38.3 22.7-38.9-40.5-21.7 6.6-12.6 54-42.4-.5-12.6-53.6-21.7-5.6-36.4 38.4-37.4-21.7 15.2-50.5-13.7-16.1-55.5 14.1-19.7-34.8 37.9-37.4-4.8-22.8-54-14.1.5-40.9L54 219.9l5.7-19.7-38.9-39.4L41.5 125l53.6 14.1 15.2-15.7-15.2-52 36.4-20.7 36.8 39.4L191 84l11.6-52H245l11.6 45.9L234 72l-6.3-1.7-3.3 5.7-11 19.1-3.3 5.6 4.6 4.6 17.2 17.4-.3 1-23.8 6.5-6.2 1.7-.1 6.4-.2 12.9C153.8 161.6 118 204 118 254.7c0 58.3 47.3 105.7 105.7 105.7 50.5 0 92.7-35.4 103.2-82.8l13.2.2 6.9.1 1.6-6.7 5.6-24 1.9-.6 17.1 17.8 4.7 4.9 5.8-3.4 20.4-12.1 5.8-3.5-2-6.5-6.8-21.2z"
    ]
};
var $ef0249c5e48bf4e3$export$193ac2f517f63e63 = {
    prefix: "fab",
    iconName: "rocketchat",
    icon: [
        576,
        512,
        [],
        "f3e8",
        "M284.046,224.8a34.114,34.114,0,1,0,34.317,34.113A34.217,34.217,0,0,0,284.046,224.8Zm-110.45,0a34.114,34.114,0,1,0,34.317,34.113A34.217,34.217,0,0,0,173.6,224.8Zm220.923,0a34.114,34.114,0,1,0,34.317,34.113A34.215,34.215,0,0,0,394.519,224.8Zm153.807-55.319c-15.535-24.172-37.31-45.57-64.681-63.618-52.886-34.817-122.374-54-195.666-54a405.975,405.975,0,0,0-72.032,6.357,238.524,238.524,0,0,0-49.51-36.588C99.684-11.7,40.859.711,11.135,11.421A14.291,14.291,0,0,0,5.58,34.782C26.542,56.458,61.222,99.3,52.7,138.252c-33.142,33.9-51.112,74.776-51.112,117.337,0,43.372,17.97,84.248,51.112,118.148,8.526,38.956-26.154,81.816-47.116,103.491a14.284,14.284,0,0,0,5.555,23.34c29.724,10.709,88.549,23.147,155.324-10.2a238.679,238.679,0,0,0,49.51-36.589A405.972,405.972,0,0,0,288,460.14c73.313,0,142.8-19.159,195.667-53.975,27.371-18.049,49.145-39.426,64.679-63.619,17.309-26.923,26.07-55.916,26.07-86.125C574.394,225.4,565.634,196.43,548.326,169.485ZM284.987,409.9a345.65,345.65,0,0,1-89.446-11.5l-20.129,19.393a184.366,184.366,0,0,1-37.138,27.585,145.767,145.767,0,0,1-52.522,14.87c.983-1.771,1.881-3.563,2.842-5.356q30.258-55.68,16.325-100.078c-32.992-25.962-52.778-59.2-52.778-95.4,0-83.1,104.254-150.469,232.846-150.469s232.867,67.373,232.867,150.469C517.854,342.525,413.6,409.9,284.987,409.9Z"
    ]
};
var $ef0249c5e48bf4e3$export$a6bf4d62e541f988 = {
    prefix: "fab",
    iconName: "vk",
    icon: [
        448,
        512,
        [],
        "f189",
        "M31.4907 63.4907C0 94.9813 0 145.671 0 247.04V264.96C0 366.329 0 417.019 31.4907 448.509C62.9813 480 113.671 480 215.04 480H232.96C334.329 480 385.019 480 416.509 448.509C448 417.019 448 366.329 448 264.96V247.04C448 145.671 448 94.9813 416.509 63.4907C385.019 32 334.329 32 232.96 32H215.04C113.671 32 62.9813 32 31.4907 63.4907ZM75.6 168.267H126.747C128.427 253.76 166.133 289.973 196 297.44V168.267H244.16V242C273.653 238.827 304.64 205.227 315.093 168.267H363.253C359.313 187.435 351.46 205.583 340.186 221.579C328.913 237.574 314.461 251.071 297.733 261.227C316.41 270.499 332.907 283.63 346.132 299.751C359.357 315.873 369.01 334.618 374.453 354.747H321.44C316.555 337.262 306.614 321.61 292.865 309.754C279.117 297.899 262.173 290.368 244.16 288.107V354.747H238.373C136.267 354.747 78.0267 284.747 75.6 168.267Z"
    ]
};
var $ef0249c5e48bf4e3$export$f1679625ed434576 = {
    prefix: "fab",
    iconName: "untappd",
    icon: [
        640,
        512,
        [],
        "f405",
        "M401.3 49.9c-79.8 160.1-84.6 152.5-87.9 173.2l-5.2 32.8c-1.9 12-6.6 23.5-13.7 33.4L145.6 497.1c-7.6 10.6-20.4 16.2-33.4 14.6-40.3-5-77.8-32.2-95.3-68.5-5.7-11.8-4.5-25.8 3.1-36.4l148.9-207.9c7.1-9.9 16.4-18 27.2-23.7l29.3-15.5c18.5-9.8 9.7-11.9 135.6-138.9 1-4.8 1-7.3 3.6-8 3-.7 6.6-1 6.3-4.6l-.4-4.6c-.2-1.9 1.3-3.6 3.2-3.6 4.5-.1 13.2 1.2 25.6 10 12.3 8.9 16.4 16.8 17.7 21.1.6 1.8-.6 3.7-2.4 4.2l-4.5 1.1c-3.4.9-2.5 4.4-2.3 7.4.1 2.8-2.3 3.6-6.5 6.1zM230.1 36.4c3.4.9 2.5 4.4 2.3 7.4-.2 2.7 2.1 3.5 6.4 6 7.9 15.9 15.3 30.5 22.2 44 .7 1.3 2.3 1.5 3.3.5 11.2-12 24.6-26.2 40.5-42.6 1.3-1.4 1.4-3.5.1-4.9-8-8.2-16.5-16.9-25.6-26.1-1-4.7-1-7.3-3.6-8-3-.8-6.6-1-6.3-4.6.3-3.3 1.4-8.1-2.8-8.2-4.5-.1-13.2 1.1-25.6 10-12.3 8.9-16.4 16.8-17.7 21.1-1.4 4.2 3.6 4.6 6.8 5.4zM620 406.7L471.2 198.8c-13.2-18.5-26.6-23.4-56.4-39.1-11.2-5.9-14.2-10.9-30.5-28.9-1-1.1-2.9-.9-3.6.5-46.3 88.8-47.1 82.8-49 94.8-1.7 10.7-1.3 20 .3 29.8 1.9 12 6.6 23.5 13.7 33.4l148.9 207.9c7.6 10.6 20.2 16.2 33.1 14.7 40.3-4.9 78-32 95.7-68.6 5.4-11.9 4.3-25.9-3.4-36.6z"
    ]
};
var $ef0249c5e48bf4e3$export$da9f5a873e107292 = {
    prefix: "fab",
    iconName: "mailchimp",
    icon: [
        448,
        512,
        [],
        "f59e",
        "M330.61 243.52a36.15 36.15 0 0 1 9.3 0c1.66-3.83 1.95-10.43.45-17.61-2.23-10.67-5.25-17.14-11.48-16.13s-6.47 8.74-4.24 19.42c1.26 6 3.49 11.14 6 14.32zM277.05 252c4.47 2 7.2 3.26 8.28 2.13 1.89-1.94-3.48-9.39-12.12-13.09a31.44 31.44 0 0 0-30.61 3.68c-3 2.18-5.81 5.22-5.41 7.06.85 3.74 10-2.71 22.6-3.48 7-.44 12.8 1.75 17.26 3.71zm-9 5.13c-9.07 1.42-15 6.53-13.47 10.1.9.34 1.17.81 5.21-.81a37 37 0 0 1 18.72-1.95c2.92.34 4.31.52 4.94-.49 1.46-2.22-5.71-8-15.39-6.85zm54.17 17.1c3.38-6.87-10.9-13.93-14.3-7s10.92 13.88 14.32 6.97zm15.66-20.47c-7.66-.13-7.95 15.8-.26 15.93s7.98-15.81.28-15.96zm-218.79 78.9c-1.32.31-6 1.45-8.47-2.35-5.2-8 11.11-20.38 3-35.77-9.1-17.47-27.82-13.54-35.05-5.54-8.71 9.6-8.72 23.54-5 24.08 4.27.57 4.08-6.47 7.38-11.63a12.83 12.83 0 0 1 17.85-3.72c11.59 7.59 1.37 17.76 2.28 28.62 1.39 16.68 18.42 16.37 21.58 9a2.08 2.08 0 0 0-.2-2.33c.03.89.68-1.3-3.35-.39zm299.72-17.07c-3.35-11.73-2.57-9.22-6.78-20.52 2.45-3.67 15.29-24-3.07-43.25-10.4-10.92-33.9-16.54-41.1-18.54-1.5-11.39 4.65-58.7-21.52-83 20.79-21.55 33.76-45.29 33.73-65.65-.06-39.16-48.15-51-107.42-26.47l-12.55 5.33c-.06-.05-22.71-22.27-23.05-22.57C169.5-18-41.77 216.81 25.78 273.85l14.76 12.51a72.49 72.49 0 0 0-4.1 33.5c3.36 33.4 36 60.42 67.53 60.38 57.73 133.06 267.9 133.28 322.29 3 1.74-4.47 9.11-24.61 9.11-42.38s-10.09-25.27-16.53-25.27zm-316 48.16c-22.82-.61-47.46-21.15-49.91-45.51-6.17-61.31 74.26-75.27 84-12.33 4.54 29.64-4.67 58.49-34.12 57.81zM84.3 249.55C69.14 252.5 55.78 261.09 47.6 273c-4.88-4.07-14-12-15.59-15-13.01-24.85 14.24-73 33.3-100.21C112.42 90.56 186.19 39.68 220.36 48.91c5.55 1.57 23.94 22.89 23.94 22.89s-34.15 18.94-65.8 45.35c-42.66 32.85-74.89 80.59-94.2 132.4zM323.18 350.7s-35.74 5.3-69.51-7.07c6.21-20.16 27 6.1 96.4-13.81 15.29-4.38 35.37-13 51-25.35a102.85 102.85 0 0 1 7.12 24.28c3.66-.66 14.25-.52 11.44 18.1-3.29 19.87-11.73 36-25.93 50.84A106.86 106.86 0 0 1 362.55 421a132.45 132.45 0 0 1-20.34 8.58c-53.51 17.48-108.3-1.74-126-43a66.33 66.33 0 0 1-3.55-9.74c-7.53-27.2-1.14-59.83 18.84-80.37 1.23-1.31 2.48-2.85 2.48-4.79a8.45 8.45 0 0 0-1.92-4.54c-7-10.13-31.19-27.4-26.33-60.83 3.5-24 24.49-40.91 44.07-39.91l5 .29c8.48.5 15.89 1.59 22.88 1.88 11.69.5 22.2-1.19 34.64-11.56 4.2-3.5 7.57-6.54 13.26-7.51a17.45 17.45 0 0 1 13.6 2.24c10 6.64 11.4 22.73 11.92 34.49.29 6.72 1.1 23 1.38 27.63.63 10.67 3.43 12.17 9.11 14 3.19 1.05 6.15 1.83 10.51 3.06 13.21 3.71 21 7.48 26 12.31a16.38 16.38 0 0 1 4.74 9.29c1.56 11.37-8.82 25.4-36.31 38.16-46.71 21.68-93.68 14.45-100.48 13.68-20.15-2.71-31.63 23.32-19.55 41.15 22.64 33.41 122.4 20 151.37-21.35.69-1 .12-1.59-.73-1-41.77 28.58-97.06 38.21-128.46 26-4.77-1.85-14.73-6.44-15.94-16.67 43.6 13.49 71 .74 71 .74s2.03-2.79-.56-2.53zm-68.47-5.7zm-83.4-187.5c16.74-19.35 37.36-36.18 55.83-45.63a.73.73 0 0 1 1 1c-1.46 2.66-4.29 8.34-5.19 12.65a.75.75 0 0 0 1.16.79c11.49-7.83 31.48-16.22 49-17.3a.77.77 0 0 1 .52 1.38 41.86 41.86 0 0 0-7.71 7.74.75.75 0 0 0 .59 1.19c12.31.09 29.66 4.4 41 10.74.76.43.22 1.91-.64 1.72-69.55-15.94-123.08 18.53-134.5 26.83a.76.76 0 0 1-1-1.12z"
    ]
};
var $ef0249c5e48bf4e3$export$928cd5ee6ccd55c0 = {
    prefix: "fab",
    iconName: "css3-alt",
    icon: [
        384,
        512,
        [],
        "f38b",
        "M0 32l34.9 395.8L192 480l157.1-52.2L384 32H0zm313.1 80l-4.8 47.3L193 208.6l-.3.1h111.5l-12.8 146.6-98.2 28.7-98.8-29.2-6.4-73.9h48.9l3.2 38.3 52.6 13.3 54.7-15.4 3.7-61.6-166.3-.5v-.1l-.2.1-3.6-46.3L193.1 162l6.5-2.7H76.7L70.9 112h242.2z"
    ]
};
var $ef0249c5e48bf4e3$export$307bcbd032fbb8d3 = {
    prefix: "fab",
    iconName: "square-reddit",
    icon: [
        448,
        512,
        [
            "reddit-square"
        ],
        "f1a2",
        "M283.2 345.5c2.7 2.7 2.7 6.8 0 9.2-24.5 24.5-93.8 24.6-118.4 0-2.7-2.4-2.7-6.5 0-9.2 2.4-2.4 6.5-2.4 8.9 0 18.7 19.2 81 19.6 100.5 0 2.4-2.3 6.6-2.3 9 0zm-91.3-53.8c0-14.9-11.9-26.8-26.5-26.8-14.9 0-26.8 11.9-26.8 26.8 0 14.6 11.9 26.5 26.8 26.5 14.6 0 26.5-11.9 26.5-26.5zm90.7-26.8c-14.6 0-26.5 11.9-26.5 26.8 0 14.6 11.9 26.5 26.5 26.5 14.9 0 26.8-11.9 26.8-26.5 0-14.9-11.9-26.8-26.8-26.8zM448 80v352c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V80c0-26.5 21.5-48 48-48h352c26.5 0 48 21.5 48 48zm-99.7 140.6c-10.1 0-19 4.2-25.6 10.7-24.1-16.7-56.5-27.4-92.5-28.6l18.7-84.2 59.5 13.4c0 14.6 11.9 26.5 26.5 26.5 14.9 0 26.8-12.2 26.8-26.8 0-14.6-11.9-26.8-26.8-26.8-10.4 0-19.3 6.2-23.8 14.9l-65.7-14.6c-3.3-.9-6.5 1.5-7.4 4.8l-20.5 92.8c-35.7 1.5-67.8 12.2-91.9 28.9-6.5-6.8-15.8-11-25.9-11-37.5 0-49.8 50.4-15.5 67.5-1.2 5.4-1.8 11-1.8 16.7 0 56.5 63.7 102.3 141.9 102.3 78.5 0 142.2-45.8 142.2-102.3 0-5.7-.6-11.6-2.1-17 33.6-17.2 21.2-67.2-16.1-67.2z"
    ]
};
var $ef0249c5e48bf4e3$export$f8480c75bb6acc77 = $ef0249c5e48bf4e3$export$307bcbd032fbb8d3;
var $ef0249c5e48bf4e3$export$2ea137a3f22bc61 = {
    prefix: "fab",
    iconName: "vimeo-v",
    icon: [
        448,
        512,
        [],
        "f27d",
        "M447.8 153.6c-2 43.6-32.4 103.3-91.4 179.1-60.9 79.2-112.4 118.8-154.6 118.8-26.1 0-48.2-24.1-66.3-72.3C100.3 250 85.3 174.3 56.2 174.3c-3.4 0-15.1 7.1-35.2 21.1L0 168.2c51.6-45.3 100.9-95.7 131.8-98.5 34.9-3.4 56.3 20.5 64.4 71.5 28.7 181.5 41.4 208.9 93.6 126.7 18.7-29.6 28.8-52.1 30.2-67.6 4.8-45.9-35.8-42.8-63.3-31 22-72.1 64.1-107.1 126.2-105.1 45.8 1.2 67.5 31.1 64.9 89.4z"
    ]
};
var $ef0249c5e48bf4e3$export$d023cd407bbc3cab = {
    prefix: "fab",
    iconName: "contao",
    icon: [
        512,
        512,
        [],
        "f26d",
        "M45.4 305c14.4 67.1 26.4 129 68.2 175H34c-18.7 0-34-15.2-34-34V66c0-18.7 15.2-34 34-34h57.7C77.9 44.6 65.6 59.2 54.8 75.6c-45.4 70-27 146.8-9.4 229.4zM478 32h-90.2c21.4 21.4 39.2 49.5 52.7 84.1l-137.1 29.3c-14.9-29-37.8-53.3-82.6-43.9-24.6 5.3-41 19.3-48.3 34.6-8.8 18.7-13.2 39.8 8.2 140.3 21.1 100.2 33.7 117.7 49.5 131.2 12.9 11.1 33.4 17 58.3 11.7 44.5-9.4 55.7-40.7 57.4-73.2l137.4-29.6c3.2 71.5-18.7 125.2-57.4 163.6H478c18.7 0 34-15.2 34-34V66c0-18.8-15.2-34-34-34z"
    ]
};
var $ef0249c5e48bf4e3$export$128da80f2cbe244a = {
    prefix: "fab",
    iconName: "square-font-awesome",
    icon: [
        448,
        512,
        [],
        "e5ad",
        "M384.5,32.5h-320c-35.3,0-64,28.7-64,64v320c0,35.3,28.7,64,64,64h320c35.3,0,64-28.7,64-64v-320 C448.5,61.2,419.8,32.5,384.5,32.5z M336.5,312.5c-31.6,11.2-41.2,16-59.8,16c-31.4,0-43.2-16-74.6-16c-10.2,0-18.2,1.6-25.6,4v-32 c7.4-2.2,15.4-4,25.6-4c31.2,0,43.2,16,74.6,16c10.2,0,17.8-1.4,27.8-4.6v-96c-10,3.2-17.6,4.6-27.8,4.6c-31.4,0-43.2-16-74.6-16 c-25.4,0-37.4,10.4-57.6,14.4v153.6c0,8.8-7.2,16-16,16c-8.8,0-16-7.2-16-16v-192c0-8.8,7.2-16,16-16c8.8,0,16,7.2,16,16v6.4 c20.2-4,32.2-14.4,57.6-14.4c31.2,0,43.2,16,74.6,16c18.6,0,28.2-4.8,59.8-16V312.5z"
    ]
};
var $ef0249c5e48bf4e3$export$9005bf63ad3e3083 = {
    prefix: "fab",
    iconName: "deskpro",
    icon: [
        480,
        512,
        [],
        "f38f",
        "M205.9 512l31.1-38.4c12.3-.2 25.6-1.4 36.5-6.6 38.9-18.6 38.4-61.9 38.3-63.8-.1-5-.8-4.4-28.9-37.4H362c-.2 50.1-7.3 68.5-10.2 75.7-9.4 23.7-43.9 62.8-95.2 69.4-8.7 1.1-32.8 1.2-50.7 1.1zm200.4-167.7c38.6 0 58.5-13.6 73.7-30.9l-175.5-.3-17.4 31.3 119.2-.1zm-43.6-223.9v168.3h-73.5l-32.7 55.5H250c-52.3 0-58.1-56.5-58.3-58.9-1.2-13.2-21.3-11.6-20.1 1.8 1.4 15.8 8.8 40 26.4 57.1h-91c-25.5 0-110.8-26.8-107-114V16.9C0 .9 9.7.3 15 .1h82c.2 0 .3.1.5.1 4.3-.4 50.1-2.1 50.1 43.7 0 13.3 20.2 13.4 20.2 0 0-18.2-5.5-32.8-15.8-43.7h84.2c108.7-.4 126.5 79.4 126.5 120.2zm-132.5 56l64 29.3c13.3-45.5-42.2-71.7-64-29.3z"
    ]
};
var $ef0249c5e48bf4e3$export$36ca6be2e064d2cd = {
    prefix: "fab",
    iconName: "sistrix",
    icon: [
        448,
        512,
        [],
        "f3ee",
        "M448 449L301.2 300.2c20-27.9 31.9-62.2 31.9-99.2 0-93.1-74.7-168.9-166.5-168.9C74.7 32 0 107.8 0 200.9s74.7 168.9 166.5 168.9c39.8 0 76.3-14.2 105-37.9l146 148.1 30.5-31zM166.5 330.8c-70.6 0-128.1-58.3-128.1-129.9S95.9 71 166.5 71s128.1 58.3 128.1 129.9-57.4 129.9-128.1 129.9z"
    ]
};
var $ef0249c5e48bf4e3$export$526087fb4de86dae = {
    prefix: "fab",
    iconName: "square-instagram",
    icon: [
        448,
        512,
        [
            "instagram-square"
        ],
        "e055",
        "M224,202.66A53.34,53.34,0,1,0,277.36,256,53.38,53.38,0,0,0,224,202.66Zm124.71-41a54,54,0,0,0-30.41-30.41c-21-8.29-71-6.43-94.3-6.43s-73.25-1.93-94.31,6.43a54,54,0,0,0-30.41,30.41c-8.28,21-6.43,71.05-6.43,94.33S91,329.26,99.32,350.33a54,54,0,0,0,30.41,30.41c21,8.29,71,6.43,94.31,6.43s73.24,1.93,94.3-6.43a54,54,0,0,0,30.41-30.41c8.35-21,6.43-71.05,6.43-94.33S357.1,182.74,348.75,161.67ZM224,338a82,82,0,1,1,82-82A81.9,81.9,0,0,1,224,338Zm85.38-148.3a19.14,19.14,0,1,1,19.13-19.14A19.1,19.1,0,0,1,309.42,189.74ZM400,32H48A48,48,0,0,0,0,80V432a48,48,0,0,0,48,48H400a48,48,0,0,0,48-48V80A48,48,0,0,0,400,32ZM382.88,322c-1.29,25.63-7.14,48.34-25.85,67s-41.4,24.63-67,25.85c-26.41,1.49-105.59,1.49-132,0-25.63-1.29-48.26-7.15-67-25.85s-24.63-41.42-25.85-67c-1.49-26.42-1.49-105.61,0-132,1.29-25.63,7.07-48.34,25.85-67s41.47-24.56,67-25.78c26.41-1.49,105.59-1.49,132,0,25.63,1.29,48.33,7.15,67,25.85s24.63,41.42,25.85,67.05C384.37,216.44,384.37,295.56,382.88,322Z"
    ]
};
var $ef0249c5e48bf4e3$export$ccb1f25058292a04 = $ef0249c5e48bf4e3$export$526087fb4de86dae;
var $ef0249c5e48bf4e3$export$fb3fd8e112e1fa28 = {
    prefix: "fab",
    iconName: "battle-net",
    icon: [
        512,
        512,
        [],
        "f835",
        "M448.61 225.62c26.87.18 35.57-7.43 38.92-12.37 12.47-16.32-7.06-47.6-52.85-71.33 17.76-33.58 30.11-63.68 36.34-85.3 3.38-11.83 1.09-19 .45-20.25-1.72 10.52-15.85 48.46-48.2 100.05-25-11.22-56.52-20.1-93.77-23.8-8.94-16.94-34.88-63.86-60.48-88.93C252.18 7.14 238.7 1.07 228.18.22h-.05c-13.83-1.55-22.67 5.85-27.4 11-17.2 18.53-24.33 48.87-25 84.07-7.24-12.35-17.17-24.63-28.5-25.93h-.18c-20.66-3.48-38.39 29.22-36 81.29-38.36 1.38-71 5.75-93 11.23-9.9 2.45-16.22 7.27-17.76 9.72 1-.38 22.4-9.22 111.56-9.22 5.22 53 29.75 101.82 26 93.19-9.73 15.4-38.24 62.36-47.31 97.7-5.87 22.88-4.37 37.61.15 47.14 5.57 12.75 16.41 16.72 23.2 18.26 25 5.71 55.38-3.63 86.7-21.14-7.53 12.84-13.9 28.51-9.06 39.34 7.31 19.65 44.49 18.66 88.44-9.45 20.18 32.18 40.07 57.94 55.7 74.12a39.79 39.79 0 0 0 8.75 7.09c5.14 3.21 8.58 3.37 8.58 3.37-8.24-6.75-34-38-62.54-91.78 22.22-16 45.65-38.87 67.47-69.27 122.82 4.6 143.29-24.76 148-31.64 14.67-19.88 3.43-57.44-57.32-93.69zm-77.85 106.22c23.81-37.71 30.34-67.77 29.45-92.33 27.86 17.57 47.18 37.58 49.06 58.83 1.14 12.93-8.1 29.12-78.51 33.5zM216.9 387.69c9.76-6.23 19.53-13.12 29.2-20.49 6.68 13.33 13.6 26.1 20.6 38.19-40.6 21.86-68.84 12.76-49.8-17.7zm215-171.35c-10.29-5.34-21.16-10.34-32.38-15.05a722.459 722.459 0 0 0 22.74-36.9c39.06 24.1 45.9 53.18 9.64 51.95zM279.18 398c-5.51-11.35-11-23.5-16.5-36.44 43.25 1.27 62.42-18.73 63.28-20.41 0 .07-25 15.64-62.53 12.25a718.78 718.78 0 0 0 85.06-84q13.06-15.31 24.93-31.11c-.36-.29-1.54-3-16.51-12-51.7 60.27-102.34 98-132.75 115.92-20.59-11.18-40.84-31.78-55.71-61.49-20-39.92-30-82.39-31.57-116.07 12.3.91 25.27 2.17 38.85 3.88-22.29 36.8-14.39 63-13.47 64.23 0-.07-.95-29.17 20.14-59.57a695.23 695.23 0 0 0 44.67 152.84c.93-.38 1.84.88 18.67-8.25-26.33-74.47-33.76-138.17-34-173.43 20-12.42 48.18-19.8 81.63-17.81 44.57 2.67 86.36 15.25 116.32 30.71q-10.69 15.66-23.33 32.47C365.63 152 339.1 145.84 337.5 146c.11 0 25.9 14.07 41.52 47.22a717.63 717.63 0 0 0-115.34-31.71 646.608 646.608 0 0 0-39.39-6.05c-.07.45-1.81 1.85-2.16 20.33C300 190.28 358.78 215.68 389.36 233c.74 23.55-6.95 51.61-25.41 79.57-24.6 37.31-56.39 67.23-84.77 85.43zm27.4-287c-44.56-1.66-73.58 7.43-94.69 20.67 2-52.3 21.31-76.38 38.21-75.28C267 52.15 305 108.55 306.58 111zm-130.65 3.1c.48 12.11 1.59 24.62 3.21 37.28-14.55-.85-28.74-1.25-42.4-1.26-.08 3.24-.12-51 24.67-49.59h.09c5.76 1.09 10.63 6.88 14.43 13.57zm-28.06 162c20.76 39.7 43.3 60.57 65.25 72.31-46.79 24.76-77.53 20-84.92 4.51-.2-.21-11.13-15.3 19.67-76.81zm210.06 74.8"
    ]
};
var $ef0249c5e48bf4e3$export$daa019c708da49e9 = {
    prefix: "fab",
    iconName: "the-red-yeti",
    icon: [
        512,
        512,
        [],
        "f69d",
        "M488.23 241.7l20.7 7.1c-9.6-23.9-23.9-37-31.7-44.8l7.1-18.2c.2 0 12.3-27.8-2.5-30.7-.6-11.3-6.6-27-18.4-27-7.6-10.6-17.7-12.3-30.7-5.9a122.2 122.2 0 0 0-25.3 16.5c-5.3-6.4-3 .4-3-29.8-37.1-24.3-45.4-11.7-74.8 3l.5.5a239.36 239.36 0 0 0-68.4-13.3c-5.5-8.7-18.6-19.1-25.1-25.1l24.8 7.1c-5.5-5.5-26.8-12.9-34.2-15.2 18.2-4.1 29.8-20.8 42.5-33-34.9-10.1-67.9-5.9-97.9 11.8l12-44.2L182 0c-31.6 24.2-33 41.9-33.7 45.5-.9-2.4-6.3-19.6-15.2-27a35.12 35.12 0 0 0-.5 25.3c3 8.4 5.9 14.8 8.4 18.9-16-3.3-28.3-4.9-49.2 0h-3.7l33 14.3a194.26 194.26 0 0 0-46.7 67.4l-1.7 8.4 1.7 1.7 7.6-4.7c-3.3 11.6-5.3 19.4-6.6 25.8a200.18 200.18 0 0 0-27.8 40.3c-15 1-31.8 10.8-40.3 14.3l3 3.4 28.8 1c-.5 1-.7 2.2-1.2 3.2-7.3 6.4-39.8 37.7-33 80.7l20.2-22.4c.5 1.7.7 3.4 1.2 5.2 0 25.5.4 89.6 64.9 150.5 43.6 40 96 60.2 157.5 60.2 121.7 0 223-87.3 223-211.5 6.8-9.7-1.2 3 16.7-25.1l13 14.3 2.5-.5A181.84 181.84 0 0 0 495 255a44.74 44.74 0 0 0-6.8-13.3zM398 111.2l-.5 21.9c5.5 18.1 16.9 17.2 22.4 17.2l-3.4-4.7 22.4-5.4a242.44 242.44 0 0 1-27 0c12.8-2.1 33.3-29 43-11.3 3.4 7.6 6.4 17.2 9.3 27.8l1.7-5.9a56.38 56.38 0 0 1-1.7-15.2c5.4.5 8.8 3.4 9.3 10.1.5 6.4 1.7 14.8 3.4 25.3l4.7-11.3c4.6 0 4.5-3.6-2.5 20.7-20.9-8.7-35.1-8.4-46.5-8.4l18.2-16c-25.3 8.2-33 10.8-54.8 20.9-1.1-5.4-5-13.5-16-19.9-3.2 3.8-2.8.9-.7 14.8h-2.5a62.32 62.32 0 0 0-8.4-23.1l4.2-3.4c8.4-7.1 11.8-14.3 10.6-21.9-.5-6.4-5.4-13.5-13.5-20.7 5.6-3.4 15.2-.4 28.3 8.5zm-39.6-10.1c2.7 1.9 11.4 5.4 18.9 17.2 4.2 8.4 4 9.8 3.4 11.1-.5 2.4-.5 4.3-3 7.1-1.7 2.5-5.4 4.7-11.8 7.6-7.6-13-16.5-23.6-27.8-31.2zM91 143.1l1.2-1.7c1.2-2.9 4.2-7.6 9.3-15.2l2.5-3.4-13 12.3 5.4-4.7-10.1 9.3-4.2 1.2c12.3-24.1 23.1-41.3 32.5-50.2 9.3-9.3 16-16 20.2-19.4l-6.4 1.2c-11.3-4.2-19.4-7.1-24.8-8.4 2.5-.5 3.7-.5 3.2-.5 10.3 0 17.5.5 20.9 1.2a52.35 52.35 0 0 0 16 2.5l.5-1.7-8.4-35.8 13.5 29a42.89 42.89 0 0 0 5.9-14.3c1.7-6.4 5.4-13 10.1-19.4s7.6-10.6 9.3-11.3a234.68 234.68 0 0 0-6.4 25.3l-1.7 7.1-.5 4.7 2.5 2.5C190.4 39.9 214 34 239.8 34.5l21.1.5c-11.8 13.5-27.8 21.9-48.5 24.8a201.26 201.26 0 0 1-23.4 2.9l-.2-.5-2.5-1.2a20.75 20.75 0 0 0-14 2c-2.5-.2-4.9-.5-7.1-.7l-2.5 1.7.5 1.2c2 .2 3.9.5 6.2.7l-2 3.4 3.4-.5-10.6 11.3c-4.2 3-5.4 6.4-4.2 9.3l5.4-3.4h1.2a39.4 39.4 0 0 1 25.3-15.2v-3c6.4.5 13 1 19.4 1.2 6.4 0 8.4.5 5.4 1.2a189.6 189.6 0 0 1 20.7 13.5c13.5 10.1 23.6 21.9 30 35.4 8.8 18.2 13.5 37.1 13.5 56.6a141.13 141.13 0 0 1-3 28.3 209.91 209.91 0 0 1-16 46l2.5.5c18.2-19.7 41.9-16 49.2-16l-6.4 5.9 22.4 17.7-1.7 30.7c-5.4-12.3-16.5-21.1-33-27.8 16.5 14.8 23.6 21.1 21.9 20.2-4.8-2.8-3.5-1.9-10.8-3.7 4.1 4.1 17.5 18.8 18.2 20.7l.2.2-.2.2c0 1.8 1.6-1.2-14 22.9-75.2-15.3-106.27-42.7-141.2-63.2l11.8 1.2c-11.8-18.5-15.6-17.7-38.4-26.1L149 225c-8.8-3-18.2-3-28.3.5l7.6-10.6-1.2-1.7c-14.9 4.3-19.8 9.2-22.6 11.3-1.1-5.5-2.8-12.4-12.3-28.8l-1.2 27-13.2-5c1.5-25.2 5.4-50.5 13.2-74.6zm276.5 330c-49.9 25-56.1 22.4-59 23.9-29.8-11.8-50.9-31.7-63.5-58.8l30 16.5c-9.8-9.3-18.3-16.5-38.4-44.3l11.8 23.1-17.7-7.6c14.2 21.1 23.5 51.7 66.6 73.5-120.8 24.2-199-72.1-200.9-74.3a262.57 262.57 0 0 0 35.4 24.8c3.4 1.7 7.1 2.5 10.1 1.2l-16-20.7c9.2 4.2 9.5 4.5 69.1 29-42.5-20.7-73.8-40.8-93.2-60.2-.5 6.4-1.2 10.1-1.2 10.1a80.25 80.25 0 0 1 20.7 26.6c-39-18.9-57.6-47.6-71.3-82.6 49.9 55.1 118.9 37.5 120.5 37.1 34.8 16.4 69.9 23.6 113.9 10.6 3.3 0 20.3 17 25.3 39.1l4.2-3-2.5-23.6c9 9 24.9 22.6 34.4 13-15.6-5.3-23.5-9.5-29.5-31.7 4.6 4.2 7.6 9 27.8 15l1.2-1.2-10.5-14.2c11.7-4.8-3.5 1 32-10.8 4.3 34.3 9 49.2.7 89.5zm115.3-214.4l-2.5.5 3 9.3c-3.5 5.9-23.7 44.3-71.6 79.7-39.5 29.8-76.6 39.1-80.9 40.3l-7.6-7.1-1.2 3 14.3 16-7.1-4.7 3.4 4.2h-1.2l-21.9-13.5 9.3 26.6-19-27.9-1.2 2.5 7.6 29c-6.1-8.2-21-32.6-56.8-39.6l32.5 21.2a214.82 214.82 0 0 1-93.2-6.4c-4.2-1.2-8.9-2.5-13.5-4.2l1.2-3-44.8-22.4 26.1 22.4c-57.7 9.1-113-25.4-126.4-83.4l-2.5-16.4-22.27 22.3c19.5-57.5 25.6-57.9 51.4-70.1-9.1-5.3-1.6-3.3-38.4-9.3 15.8-5.8 33-15.4 73 5.2a18.5 18.5 0 0 1 3.7-1.7c.6-3.2.4-.8 1-11.8 3.9 10 3.6 8.7 3 9.3l1.7.5c12.7-6.5 8.9-4.5 17-8.9l-5.4 13.5 22.3-5.8-8.4 8.4 2.5 2.5c4.5-1.8 30.3 3.4 40.8 16l-23.6-2.5c39.4 23 51.5 54 55.8 69.6l1.7-1.2c-2.8-22.3-12.4-33.9-16-40.1 4.2 5 39.2 34.6 110.4 46-11.3-.5-23.1 5.4-34.9 18.9l46.7-20.2-9.3 21.9c7.6-10.1 14.8-23.6 21.2-39.6v-.5l1.2-3-1.2 16c13.5-41.8 25.3-78.5 35.4-109.7l13.5-27.8v-2l-5.4-4.2h10.1l5.9 4.2 2.5-1.2-3.4-16 12.3 18.9 41.8-20.2-14.8 13 .5 2.9 17.7-.5a184 184 0 0 1 33 4.2l-23.6 2.5-1.2 3 26.6 23.1a254.21 254.21 0 0 1 27 32c-11.2-3.3-10.3-3.4-21.2-3.4l12.3 32.5zm-6.1-71.3l-3.9 13-14.3-11.8zm-254.8 7.1c1.7 10.6 4.7 17.7 8.8 21.9-9.3 6.6-27.5 13.9-46.5 16l.5 1.2a50.22 50.22 0 0 0 24.8-2.5l-7.1 13c4.2-1.7 10.1-7.1 17.7-14.8 11.9-5.5 12.7-5.1 20.2-16-12.7-6.4-15.7-13.7-18.4-18.8zm3.7-102.3c-6.4-3.4-10.6 3-12.3 18.9s2.5 29.5 11.8 39.6 18.2 10.6 26.1 3 3.4-23.6-11.3-47.7a39.57 39.57 0 0 0-14.27-13.8zm-4.7 46.3c5.4 2.2 10.5 1.9 12.3-10.6v-4.7l-1.2.5c-4.3-3.1-2.5-4.5-1.7-6.2l.5-.5c-.9-1.2-5-8.1-12.5 4.7-.5-13.5.5-21.9 3-24.8 1.2-2.5 4.7-1.2 11.3 4.2 6.4 5.4 11.3 16 15.2 32.5 6.5 28-19.8 26.2-26.9 4.9zm-45-5.5c1.6.3 9.3-1.1 9.3-14.8h-.5c-5.4-1.1-2.2-5.5-.7-5.9-1.7-3-3.4-4.2-5.4-4.7-8.1 0-11.6 12.7-8.1 21.2a7.51 7.51 0 0 0 5.43 4.2zM216 82.9l-2.5.5.5 3a48.94 48.94 0 0 1 26.1 5.9c-2.5-5.5-10-14.3-28.3-14.3l.5 2.5zm-71.8 49.4c21.7 16.8 16.5 21.4 46.5 23.6l-2.9-4.7a42.67 42.67 0 0 0 14.8-28.3c1.7-16-1.2-29.5-8.8-41.3l13-7.6a2.26 2.26 0 0 0-.5-1.7 14.21 14.21 0 0 0-13.5 1.7c-12.7 6.7-28 20.9-29 22.4-1.7 1.7-3.4 5.9-5.4 13.5a99.61 99.61 0 0 0-2.9 23.6c-4.7-8-10.5-6.4-19.9-5.9l7.1 7.6c-16.5 0-23.3 15.4-23.6 16 6.8 0 4.6-7.6 30-12.3-4.3-6.3-3.3-5-4.9-6.6zm18.7-18.7c1.2-7.6 3.4-13 6.4-17.2 5.4-6.4 10.6-10.1 16-11.8 4.2-1.7 7.1 1.2 10.1 9.3a72.14 72.14 0 0 1 3 25.3c-.5 9.3-3.4 17.2-8.4 23.1-2.9 3.4-5.4 5.9-6.4 7.6a39.21 39.21 0 0 1-11.3-.5l-7.1-3.4-5.4-6.4c.8-10 1.3-18.8 3.1-26zm42 56.1c-34.8 14.4-34.7 14-36.1 14.3-20.8 4.7-19-24.4-18.9-24.8l5.9-1.2-.5-2.5c-20.2-2.6-31 4.2-32.5 4.9.5.5 3 3.4 5.9 9.3 4.2-6.4 8.8-10.1 15.2-10.6a83.47 83.47 0 0 0 1.7 33.7c.1.5 2.6 17.4 27.5 24.1 11.3 3 27 1.2 48.9-5.4l-9.2.5c-4.2-14.8-6.4-24.8-5.9-29.5 11.3-8.8 21.9-11.3 30.7-7.6h2.5l-11.8-7.6-7.1.5c-5.9 1.2-12.3 4.2-19.4 8.4z"
    ]
};
var $ef0249c5e48bf4e3$export$ca115ee475bced67 = {
    prefix: "fab",
    iconName: "square-hacker-news",
    icon: [
        448,
        512,
        [
            "hacker-news-square"
        ],
        "f3af",
        "M400 32H48C21.5 32 0 53.5 0 80v352c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48V80c0-26.5-21.5-48-48-48zM21.2 229.2H21c.1-.1.2-.3.3-.4 0 .1 0 .3-.1.4zm218 53.9V384h-31.4V281.3L128 128h37.3c52.5 98.3 49.2 101.2 59.3 125.6 12.3-27 5.8-24.4 60.6-125.6H320l-80.8 155.1z"
    ]
};
var $ef0249c5e48bf4e3$export$310b7424f1f97fc = $ef0249c5e48bf4e3$export$ca115ee475bced67;
var $ef0249c5e48bf4e3$export$9c65bd68cbc68ec9 = {
    prefix: "fab",
    iconName: "edge",
    icon: [
        512,
        512,
        [],
        "f282",
        "M120.1 37.44C161.1 12.23 207.7-.7753 255 .0016C423 .0016 512 123.8 512 219.5C511.9 252.2 499 283.4 476.1 306.7C453.2 329.9 422.1 343.2 389.4 343.7C314.2 343.7 297.9 320.6 297.9 311.7C297.9 307.9 299.1 305.5 302.7 302.3L303.7 301.1L304.1 299.5C314.6 288 320 273.3 320 257.9C320 179.2 237.8 115.2 136 115.2C98.46 114.9 61.46 124.1 28.48 142.1C55.48 84.58 111.2 44.5 119.8 38.28C120.6 37.73 120.1 37.44 120.1 37.44V37.44zM135.7 355.5C134.3 385.5 140.3 415.5 152.1 442.7C165.7 469.1 184.8 493.7 208.6 512C149.1 500.5 97.11 468.1 59.2 422.7C21.12 376.3 0 318.4 0 257.9C0 206.7 62.4 163.5 136 163.5C172.6 162.9 208.4 174.4 237.8 196.2L234.2 197.4C182.7 215 135.7 288.1 135.7 355.5V355.5zM469.8 400L469.1 400.1C457.3 418.9 443.2 435.2 426.9 449.6C396.1 477.6 358.8 495.1 318.1 499.5C299.5 499.8 281.3 496.3 264.3 488.1C238.7 477.8 217.2 458.1 202.7 435.1C188.3 411.2 181.6 383.4 183.7 355.5C183.1 335.4 189.1 315.2 198.7 297.3C212.6 330.4 236.2 358.6 266.3 378.1C296.4 397.6 331.8 407.6 367.7 406.7C398.7 407 429.8 400 457.9 386.2L459.8 385.3C463.7 383 467.5 381.4 471.4 385.3C475.9 390.2 473.2 394.5 470.2 399.3C470 399.5 469.9 399.8 469.8 400V400z"
    ]
};
var $ef0249c5e48bf4e3$export$2a1c6a809b4fdc7f = {
    prefix: "fab",
    iconName: "threads",
    icon: [
        448,
        512,
        [],
        "e618",
        "M331.5 235.7c2.2 .9 4.2 1.9 6.3 2.8c29.2 14.1 50.6 35.2 61.8 61.4c15.7 36.5 17.2 95.8-30.3 143.2c-36.2 36.2-80.3 52.5-142.6 53h-.3c-70.2-.5-124.1-24.1-160.4-70.2c-32.3-41-48.9-98.1-49.5-169.6V256v-.2C17 184.3 33.6 127.2 65.9 86.2C102.2 40.1 156.2 16.5 226.4 16h.3c70.3 .5 124.9 24 162.3 69.9c18.4 22.7 32 50 40.6 81.7l-40.4 10.8c-7.1-25.8-17.8-47.8-32.2-65.4c-29.2-35.8-73-54.2-130.5-54.6c-57 .5-100.1 18.8-128.2 54.4C72.1 146.1 58.5 194.3 58 256c.5 61.7 14.1 109.9 40.3 143.3c28 35.6 71.2 53.9 128.2 54.4c51.4-.4 85.4-12.6 113.7-40.9c32.3-32.2 31.7-71.8 21.4-95.9c-6.1-14.2-17.1-26-31.9-34.9c-3.7 26.9-11.8 48.3-24.7 64.8c-17.1 21.8-41.4 33.6-72.7 35.3c-23.6 1.3-46.3-4.4-63.9-16c-20.8-13.8-33-34.8-34.3-59.3c-2.5-48.3 35.7-83 95.2-86.4c21.1-1.2 40.9-.3 59.2 2.8c-2.4-14.8-7.3-26.6-14.6-35.2c-10-11.7-25.6-17.7-46.2-17.8H227c-16.6 0-39 4.6-53.3 26.3l-34.4-23.6c19.2-29.1 50.3-45.1 87.8-45.1h.8c62.6 .4 99.9 39.5 103.7 107.7l-.2 .2zm-156 68.8c1.3 25.1 28.4 36.8 54.6 35.3c25.6-1.4 54.6-11.4 59.5-73.2c-13.2-2.9-27.8-4.4-43.4-4.4c-4.8 0-9.6 .1-14.4 .4c-42.9 2.4-57.2 23.2-56.2 41.8l-.1 .1z"
    ]
};
var $ef0249c5e48bf4e3$export$29d678db44edc00 = {
    prefix: "fab",
    iconName: "napster",
    icon: [
        496,
        512,
        [],
        "f3d2",
        "M298.3 373.6c-14.2 13.6-31.3 24.1-50.4 30.5-19-6.4-36.2-16.9-50.3-30.5h100.7zm44-199.6c20-16.9 43.6-29.2 69.6-36.2V299c0 219.4-328 217.6-328 .3V137.7c25.9 6.9 49.6 19.6 69.5 36.4 56.8-40 132.5-39.9 188.9-.1zm-208.8-58.5c64.4-60 164.3-60.1 228.9-.2-7.1 3.5-13.9 7.3-20.6 11.5-58.7-30.5-129.2-30.4-187.9.1-6.3-4-13.9-8.2-20.4-11.4zM43.8 93.2v69.3c-58.4 36.5-58.4 121.1.1 158.3 26.4 245.1 381.7 240.3 407.6 1.5l.3-1.7c58.7-36.3 58.9-121.7.2-158.2V93.2c-17.3.5-34 3-50.1 7.4-82-91.5-225.5-91.5-307.5.1-16.3-4.4-33.1-7-50.6-7.5zM259.2 352s36-.3 61.3-1.5c10.2-.5 21.1-4 25.5-6.5 26.3-15.1 25.4-39.2 26.2-47.4-79.5-.6-99.9-3.9-113 55.4zm-135.5-55.3c.8 8.2-.1 32.3 26.2 47.4 4.4 2.5 15.2 6 25.5 6.5 25.3 1.1 61.3 1.5 61.3 1.5-13.2-59.4-33.7-56.1-113-55.4zm169.1 123.4c-3.2-5.3-6.9-7.3-6.9-7.3-24.8 7.3-52.2 6.9-75.9 0 0 0-2.9 1.5-6.4 6.6-2.8 4.1-3.7 9.6-3.7 9.6 29.1 17.6 67.1 17.6 96.2 0-.1-.1-.3-4-3.3-8.9z"
    ]
};
var $ef0249c5e48bf4e3$export$8176f1a0ece4380c = {
    prefix: "fab",
    iconName: "square-snapchat",
    icon: [
        448,
        512,
        [
            "snapchat-square"
        ],
        "f2ad",
        "M384,32H64A64,64,0,0,0,0,96V416a64,64,0,0,0,64,64H384a64,64,0,0,0,64-64V96A64,64,0,0,0,384,32Zm-3.907,319.309-.083.1a32.364,32.364,0,0,1-8.717,6.823,90.26,90.26,0,0,1-20.586,8.2,12.694,12.694,0,0,0-3.852,1.76c-2.158,1.909-2.1,4.64-4.4,8.55a23.137,23.137,0,0,1-6.84,7.471c-6.707,4.632-14.244,4.923-22.23,5.23-7.214.274-15.39.581-24.729,3.669-3.761,1.245-7.753,3.694-12.377,6.533-11.265,6.9-26.68,16.353-52.3,16.353s-40.925-9.4-52.106-16.279c-4.657-2.888-8.675-5.362-12.543-6.64-9.339-3.08-17.516-3.4-24.729-3.67-7.986-.307-15.523-.6-22.231-5.229a23.085,23.085,0,0,1-6.01-6.11c-3.2-4.632-2.855-7.8-5.254-9.895a13.428,13.428,0,0,0-4.1-1.834,89.986,89.986,0,0,1-20.313-8.127,32.905,32.905,0,0,1-8.3-6.284c-6.583-6.757-8.276-14.776-5.686-21.824,3.436-9.338,11.571-12.111,19.4-16.262,14.776-8.027,26.348-18.055,34.433-29.884a68.236,68.236,0,0,0,5.985-10.567c.789-2.158.772-3.329.241-4.416a7.386,7.386,0,0,0-2.208-2.217c-2.532-1.676-5.113-3.353-6.882-4.5-3.27-2.141-5.868-3.818-7.529-4.98-6.267-4.383-10.65-9.04-13.4-14.245a28.4,28.4,0,0,1-1.369-23.584c4.134-10.924,14.469-17.706,26.978-17.706a37.141,37.141,0,0,1,7.845.83c.689.15,1.37.307,2.042.482-.108-7.43.058-15.357.722-23.119,2.358-27.261,11.912-41.589,21.874-52.994a86.836,86.836,0,0,1,22.28-17.931C188.254,100.383,205.312,96,224,96s35.828,4.383,50.944,13.016a87.169,87.169,0,0,1,22.239,17.9c9.961,11.406,19.516,25.709,21.874,52.995a231.194,231.194,0,0,1,.713,23.118c.673-.174,1.362-.332,2.051-.481a37.131,37.131,0,0,1,7.844-.83c12.5,0,22.82,6.782,26.971,17.706a28.37,28.37,0,0,1-1.4,23.559c-2.74,5.2-7.123,9.861-13.39,14.244-1.668,1.187-4.258,2.864-7.529,4.981-1.835,1.187-4.541,2.947-7.164,4.682a6.856,6.856,0,0,0-1.951,2.034c-.506,1.046-.539,2.191.166,4.208a69.015,69.015,0,0,0,6.085,10.792c8.268,12.1,20.188,22.313,35.454,30.407,1.486.772,2.98,1.5,4.441,2.258.722.332,1.569.763,2.491,1.3,4.9,2.723,9.2,6.01,11.455,12.153C387.821,336.915,386.269,344.7,380.093,351.309Zm-16.719-18.461c-50.313-24.314-58.332-61.918-58.689-64.749-.431-3.379-.921-6.035,2.806-9.472,3.594-3.328,19.541-13.19,23.965-16.278,7.33-5.114,10.534-10.219,8.16-16.495-1.66-4.316-5.686-5.976-9.961-5.976a18.5,18.5,0,0,0-3.993.448c-8.035,1.743-15.838,5.769-20.354,6.857a7.1,7.1,0,0,1-1.66.224c-2.408,0-3.279-1.071-3.088-3.968.564-8.783,1.759-25.925.373-41.937-1.884-22.032-8.99-32.948-17.432-42.6-4.051-4.624-23.135-24.654-59.536-24.654S168.53,134.359,164.479,139c-8.434,9.654-15.531,20.57-17.432,42.6-1.386,16.013-.141,33.147.373,41.937.166,2.756-.68,3.968-3.088,3.968a7.1,7.1,0,0,1-1.66-.224c-4.507-1.087-12.31-5.113-20.346-6.856a18.494,18.494,0,0,0-3.993-.449c-4.25,0-8.3,1.636-9.961,5.977-2.374,6.276.847,11.381,8.168,16.494,4.425,3.088,20.371,12.958,23.966,16.279,3.719,3.437,3.237,6.093,2.805,9.471-.356,2.79-8.384,40.394-58.689,64.749-2.946,1.428-7.96,4.45.88,9.331,13.88,7.628,23.111,6.807,30.3,11.43,6.093,3.927,2.5,12.394,6.923,15.449,5.454,3.76,21.583-.266,42.335,6.6,17.433,5.744,28.116,22.015,58.963,22.015s41.788-16.3,58.938-21.973c20.795-6.865,36.89-2.839,42.336-6.6,4.433-3.055.822-11.522,6.923-15.448,7.181-4.624,16.411-3.8,30.3-11.472C371.36,337.355,366.346,334.333,363.374,332.848Z"
    ]
};
var $ef0249c5e48bf4e3$export$20f908cf15afb04b = $ef0249c5e48bf4e3$export$8176f1a0ece4380c;
var $ef0249c5e48bf4e3$export$74ebd8f5ac37d070 = {
    prefix: "fab",
    iconName: "google-plus-g",
    icon: [
        640,
        512,
        [],
        "f0d5",
        "M386.061 228.496c1.834 9.692 3.143 19.384 3.143 31.956C389.204 370.205 315.599 448 204.8 448c-106.084 0-192-85.915-192-192s85.916-192 192-192c51.864 0 95.083 18.859 128.611 50.292l-52.126 50.03c-14.145-13.621-39.028-29.599-76.485-29.599-65.484 0-118.92 54.221-118.92 121.277 0 67.056 53.436 121.277 118.92 121.277 75.961 0 104.513-54.745 108.965-82.773H204.8v-66.009h181.261zm185.406 6.437V179.2h-56.001v55.733h-55.733v56.001h55.733v55.733h56.001v-55.733H627.2v-56.001h-55.733z"
    ]
};
var $ef0249c5e48bf4e3$export$4fb55b03537dc8e3 = {
    prefix: "fab",
    iconName: "artstation",
    icon: [
        512,
        512,
        [],
        "f77a",
        "M2 377.4l43 74.3A51.35 51.35 0 0 0 90.9 480h285.4l-59.2-102.6zM501.8 350L335.6 59.3A51.38 51.38 0 0 0 290.2 32h-88.4l257.3 447.6 40.7-70.5c1.9-3.2 21-29.7 2-59.1zM275 304.5l-115.5-200L44 304.5z"
    ]
};
var $ef0249c5e48bf4e3$export$4401a9960e402a1c = {
    prefix: "fab",
    iconName: "markdown",
    icon: [
        640,
        512,
        [],
        "f60f",
        "M593.8 59.1H46.2C20.7 59.1 0 79.8 0 105.2v301.5c0 25.5 20.7 46.2 46.2 46.2h547.7c25.5 0 46.2-20.7 46.1-46.1V105.2c0-25.4-20.7-46.1-46.2-46.1zM338.5 360.6H277v-120l-61.5 76.9-61.5-76.9v120H92.3V151.4h61.5l61.5 76.9 61.5-76.9h61.5v209.2zm135.3 3.1L381.5 256H443V151.4h61.5V256H566z"
    ]
};
var $ef0249c5e48bf4e3$export$fd6b8582f52b208a = {
    prefix: "fab",
    iconName: "sourcetree",
    icon: [
        448,
        512,
        [],
        "f7d3",
        "M427.2 203c0-112.1-90.9-203-203-203C112.1-.2 21.2 90.6 21 202.6A202.86 202.86 0 0 0 161.5 396v101.7a14.3 14.3 0 0 0 14.3 14.3h96.4a14.3 14.3 0 0 0 14.3-14.3V396.1A203.18 203.18 0 0 0 427.2 203zm-271.6 0c0-90.8 137.3-90.8 137.3 0-.1 89.9-137.3 91-137.3 0z"
    ]
};
var $ef0249c5e48bf4e3$export$384e1aaf24320a2d = {
    prefix: "fab",
    iconName: "google-plus",
    icon: [
        512,
        512,
        [],
        "f2b3",
        "M256,8C119.1,8,8,119.1,8,256S119.1,504,256,504,504,392.9,504,256,392.9,8,256,8ZM185.3,380a124,124,0,0,1,0-248c31.3,0,60.1,11,83,32.3l-33.6,32.6c-13.2-12.9-31.3-19.1-49.4-19.1-42.9,0-77.2,35.5-77.2,78.1S142.3,334,185.3,334c32.6,0,64.9-19.1,70.1-53.3H185.3V238.1H302.2a109.2,109.2,0,0,1,1.9,20.7c0,70.8-47.5,121.2-118.8,121.2ZM415.5,273.8v35.5H380V273.8H344.5V238.3H380V202.8h35.5v35.5h35.2v35.5Z"
    ]
};
var $ef0249c5e48bf4e3$export$f59fd74fa97e6ae5 = {
    prefix: "fab",
    iconName: "diaspora",
    icon: [
        512,
        512,
        [],
        "f791",
        "M251.64 354.55c-1.4 0-88 119.9-88.7 119.9S76.34 414 76 413.25s86.6-125.7 86.6-127.4c0-2.2-129.6-44-137.6-47.1-1.3-.5 31.4-101.8 31.7-102.1.6-.7 144.4 47 145.5 47 .4 0 .9-.6 1-1.3.4-2 1-148.6 1.7-149.6.8-1.2 104.5-.7 105.1-.3 1.5 1 3.5 156.1 6.1 156.1 1.4 0 138.7-47 139.3-46.3.8.9 31.9 102.2 31.5 102.6-.9.9-140.2 47.1-140.6 48.8-.3 1.4 82.8 122.1 82.5 122.9s-85.5 63.5-86.3 63.5c-1-.2-89-125.5-90.9-125.5z"
    ]
};
var $ef0249c5e48bf4e3$export$b14039dbb12386bc = {
    prefix: "fab",
    iconName: "foursquare",
    icon: [
        368,
        512,
        [],
        "f180",
        "M323.1 3H49.9C12.4 3 0 31.3 0 49.1v433.8c0 20.3 12.1 27.7 18.2 30.1 6.2 2.5 22.8 4.6 32.9-7.1C180 356.5 182.2 354 182.2 354c3.1-3.4 3.4-3.1 6.8-3.1h83.4c35.1 0 40.6-25.2 44.3-39.7l48.6-243C373.8 25.8 363.1 3 323.1 3zm-16.3 73.8l-11.4 59.7c-1.2 6.5-9.5 13.2-16.9 13.2H172.1c-12 0-20.6 8.3-20.6 20.3v13c0 12 8.6 20.6 20.6 20.6h90.4c8.3 0 16.6 9.2 14.8 18.2-1.8 8.9-10.5 53.8-11.4 58.8-.9 4.9-6.8 13.5-16.9 13.5h-73.5c-13.5 0-17.2 1.8-26.5 12.6 0 0-8.9 11.4-89.5 108.3-.9.9-1.8.6-1.8-.3V75.9c0-7.7 6.8-16.6 16.6-16.6h219c8.2 0 15.6 7.7 13.5 17.5z"
    ]
};
var $ef0249c5e48bf4e3$export$2c0cf6f85294daec = {
    prefix: "fab",
    iconName: "stack-overflow",
    icon: [
        384,
        512,
        [],
        "f16c",
        "M290.7 311L95 269.7 86.8 309l195.7 41zm51-87L188.2 95.7l-25.5 30.8 153.5 128.3zm-31.2 39.7L129.2 179l-16.7 36.5L293.7 300zM262 32l-32 24 119.3 160.3 32-24zm20.5 328h-200v39.7h200zm39.7 80H42.7V320h-40v160h359.5V320h-40z"
    ]
};
var $ef0249c5e48bf4e3$export$edfa6885dbf62839 = {
    prefix: "fab",
    iconName: "github-alt",
    icon: [
        480,
        512,
        [],
        "f113",
        "M186.1 328.7c0 20.9-10.9 55.1-36.7 55.1s-36.7-34.2-36.7-55.1 10.9-55.1 36.7-55.1 36.7 34.2 36.7 55.1zM480 278.2c0 31.9-3.2 65.7-17.5 95-37.9 76.6-142.1 74.8-216.7 74.8-75.8 0-186.2 2.7-225.6-74.8-14.6-29-20.2-63.1-20.2-95 0-41.9 13.9-81.5 41.5-113.6-5.2-15.8-7.7-32.4-7.7-48.8 0-21.5 4.9-32.3 14.6-51.8 45.3 0 74.3 9 108.8 36 29-6.9 58.8-10 88.7-10 27 0 54.2 2.9 80.4 9.2 34-26.7 63-35.2 107.8-35.2 9.8 19.5 14.6 30.3 14.6 51.8 0 16.4-2.6 32.7-7.7 48.2 27.5 32.4 39 72.3 39 114.2zm-64.3 50.5c0-43.9-26.7-82.6-73.5-82.6-18.9 0-37 3.4-56 6-14.9 2.3-29.8 3.2-45.1 3.2-15.2 0-30.1-.9-45.1-3.2-18.7-2.6-37-6-56-6-46.8 0-73.5 38.7-73.5 82.6 0 87.8 80.4 101.3 150.4 101.3h48.2c70.3 0 150.6-13.4 150.6-101.3zm-82.6-55.1c-25.8 0-36.7 34.2-36.7 55.1s10.9 55.1 36.7 55.1 36.7-34.2 36.7-55.1-10.9-55.1-36.7-55.1z"
    ]
};
var $ef0249c5e48bf4e3$export$699e806dfe31d90b = {
    prefix: "fab",
    iconName: "phoenix-squadron",
    icon: [
        512,
        512,
        [],
        "f511",
        "M96 63.38C142.49 27.25 201.55 7.31 260.51 8.81c29.58-.38 59.11 5.37 86.91 15.33-24.13-4.63-49-6.34-73.38-2.45C231.17 27 191 48.84 162.21 80.87c5.67-1 10.78-3.67 16-5.86 18.14-7.87 37.49-13.26 57.23-14.83 19.74-2.13 39.64-.43 59.28 1.92-14.42 2.79-29.12 4.57-43 9.59-34.43 11.07-65.27 33.16-86.3 62.63-13.8 19.71-23.63 42.86-24.67 67.13-.35 16.49 5.22 34.81 19.83 44a53.27 53.27 0 0 0 37.52 6.74c15.45-2.46 30.07-8.64 43.6-16.33 11.52-6.82 22.67-14.55 32-24.25 3.79-3.22 2.53-8.45 2.62-12.79-2.12-.34-4.38-1.11-6.3.3a203 203 0 0 1-35.82 15.37c-20 6.17-42.16 8.46-62.1.78 12.79 1.73 26.06.31 37.74-5.44 20.23-9.72 36.81-25.2 54.44-38.77a526.57 526.57 0 0 1 88.9-55.31c25.71-12 52.94-22.78 81.57-24.12-15.63 13.72-32.15 26.52-46.78 41.38-14.51 14-27.46 29.5-40.11 45.18-3.52 4.6-8.95 6.94-13.58 10.16a150.7 150.7 0 0 0-51.89 60.1c-9.33 19.68-14.5 41.85-11.77 63.65 1.94 13.69 8.71 27.59 20.9 34.91 12.9 8 29.05 8.07 43.48 5.1 32.8-7.45 61.43-28.89 81-55.84 20.44-27.52 30.52-62.2 29.16-96.35-.52-7.5-1.57-15-1.66-22.49 8 19.48 14.82 39.71 16.65 60.83 2 14.28.75 28.76-1.62 42.9-1.91 11-5.67 21.51-7.78 32.43a165 165 0 0 0 39.34-81.07 183.64 183.64 0 0 0-14.21-104.64c20.78 32 32.34 69.58 35.71 107.48.49 12.73.49 25.51 0 38.23A243.21 243.21 0 0 1 482 371.34c-26.12 47.34-68 85.63-117.19 108-78.29 36.23-174.68 31.32-248-14.68A248.34 248.34 0 0 1 25.36 366 238.34 238.34 0 0 1 0 273.08v-31.34C3.93 172 40.87 105.82 96 63.38m222 80.33a79.13 79.13 0 0 0 16-4.48c5-1.77 9.24-5.94 10.32-11.22-8.96 4.99-17.98 9.92-26.32 15.7z"
    ]
};
var $ef0249c5e48bf4e3$export$e4b095fb96bd3e1 = {
    prefix: "fab",
    iconName: "pagelines",
    icon: [
        384,
        512,
        [],
        "f18c",
        "M384 312.7c-55.1 136.7-187.1 54-187.1 54-40.5 81.8-107.4 134.4-184.6 134.7-16.1 0-16.6-24.4 0-24.4 64.4-.3 120.5-42.7 157.2-110.1-41.1 15.9-118.6 27.9-161.6-82.2 109-44.9 159.1 11.2 178.3 45.5 9.9-24.4 17-50.9 21.6-79.7 0 0-139.7 21.9-149.5-98.1 119.1-47.9 152.6 76.7 152.6 76.7 1.6-16.7 3.3-52.6 3.3-53.4 0 0-106.3-73.7-38.1-165.2 124.6 43 61.4 162.4 61.4 162.4.5 1.6.5 23.8 0 33.4 0 0 45.2-89 136.4-57.5-4.2 134-141.9 106.4-141.9 106.4-4.4 27.4-11.2 53.4-20 77.5 0 0 83-91.8 172-20z"
    ]
};
var $ef0249c5e48bf4e3$export$8819d592a12ec37e = {
    prefix: "fab",
    iconName: "algolia",
    icon: [
        512,
        512,
        [],
        "f36c",
        "M256 0C116.1 0 2 112.7 0 252.1C-2 393.6 112.9 510.8 254.5 511.6c43.7 .3 85.9-10.4 123.3-30.7c3.6-2 4.2-7 1.1-9.7l-24-21.2c-4.9-4.3-11.8-5.5-17.8-3c-26.1 11.1-54.5 16.8-83.7 16.4C139 461.9 46.5 366.8 48.3 252.4C50.1 139.5 142.6 48.2 256 48.2H463.7V417.2L345.9 312.5c-3.8-3.4-9.7-2.7-12.7 1.3c-18.9 25-49.7 40.6-83.9 38.2c-47.5-3.3-85.9-41.5-89.5-88.9c-4.2-56.6 40.6-103.9 96.3-103.9c50.4 0 91.9 38.8 96.2 88c.4 4.4 2.4 8.5 5.7 11.4l30.7 27.2c3.5 3.1 9 1.2 9.9-3.4c2.2-11.8 3-24.2 2.1-36.8c-4.9-72-63.3-130-135.4-134.4c-82.7-5.1-151.8 59.5-154 140.6c-2.1 78.9 62.6 147 141.6 148.7c33 .7 63.6-9.6 88.3-27.6L495 509.4c6.6 5.8 17 1.2 17-7.7V9.7c0-5.4-4.4-9.7-9.7-9.7H256z"
    ]
};
var $ef0249c5e48bf4e3$export$1052bcfc0bf56d5d = {
    prefix: "fab",
    iconName: "red-river",
    icon: [
        448,
        512,
        [],
        "f3e3",
        "M353.2 32H94.8C42.4 32 0 74.4 0 126.8v258.4C0 437.6 42.4 480 94.8 480h258.4c52.4 0 94.8-42.4 94.8-94.8V126.8c0-52.4-42.4-94.8-94.8-94.8zM144.9 200.9v56.3c0 27-21.9 48.9-48.9 48.9V151.9c0-13.2 10.7-23.9 23.9-23.9h154.2c0 27-21.9 48.9-48.9 48.9h-56.3c-12.3-.6-24.6 11.6-24 24zm176.3 72h-56.3c-12.3-.6-24.6 11.6-24 24v56.3c0 27-21.9 48.9-48.9 48.9V247.9c0-13.2 10.7-23.9 23.9-23.9h154.2c0 27-21.9 48.9-48.9 48.9z"
    ]
};
var $ef0249c5e48bf4e3$export$976ebfab93ea9362 = {
    prefix: "fab",
    iconName: "creative-commons-sa",
    icon: [
        496,
        512,
        [],
        "f4ef",
        "M247.6 8C389.4 8 496 118.1 496 256c0 147.1-118.5 248-248.4 248C113.6 504 0 394.5 0 256 0 123.1 104.7 8 247.6 8zm.8 44.7C130.2 52.7 44.7 150.6 44.7 256c0 109.8 91.2 202.8 203.7 202.8 103.2 0 202.8-81.1 202.8-202.8.1-113.8-90.2-203.3-202.8-203.3zM137.7 221c13-83.9 80.5-95.7 108.9-95.7 99.8 0 127.5 82.5 127.5 134.2 0 63.6-41 132.9-128.9 132.9-38.9 0-99.1-20-109.4-97h62.5c1.5 30.1 19.6 45.2 54.5 45.2 23.3 0 58-18.2 58-82.8 0-82.5-49.1-80.6-56.7-80.6-33.1 0-51.7 14.6-55.8 43.8h18.2l-49.2 49.2-49-49.2h19.4z"
    ]
};
var $ef0249c5e48bf4e3$export$3fbc2591308fa490 = {
    prefix: "fab",
    iconName: "safari",
    icon: [
        512,
        512,
        [],
        "f267",
        "M274.69,274.69l-37.38-37.38L166,346ZM256,8C119,8,8,119,8,256S119,504,256,504,504,393,504,256,393,8,256,8ZM411.85,182.79l14.78-6.13A8,8,0,0,1,437.08,181h0a8,8,0,0,1-4.33,10.46L418,197.57a8,8,0,0,1-10.45-4.33h0A8,8,0,0,1,411.85,182.79ZM314.43,94l6.12-14.78A8,8,0,0,1,331,74.92h0a8,8,0,0,1,4.33,10.45l-6.13,14.78a8,8,0,0,1-10.45,4.33h0A8,8,0,0,1,314.43,94ZM256,60h0a8,8,0,0,1,8,8V84a8,8,0,0,1-8,8h0a8,8,0,0,1-8-8V68A8,8,0,0,1,256,60ZM181,74.92a8,8,0,0,1,10.46,4.33L197.57,94a8,8,0,1,1-14.78,6.12l-6.13-14.78A8,8,0,0,1,181,74.92Zm-63.58,42.49h0a8,8,0,0,1,11.31,0L140,128.72A8,8,0,0,1,140,140h0a8,8,0,0,1-11.31,0l-11.31-11.31A8,8,0,0,1,117.41,117.41ZM60,256h0a8,8,0,0,1,8-8H84a8,8,0,0,1,8,8h0a8,8,0,0,1-8,8H68A8,8,0,0,1,60,256Zm40.15,73.21-14.78,6.13A8,8,0,0,1,74.92,331h0a8,8,0,0,1,4.33-10.46L94,314.43a8,8,0,0,1,10.45,4.33h0A8,8,0,0,1,100.15,329.21Zm4.33-136h0A8,8,0,0,1,94,197.57l-14.78-6.12A8,8,0,0,1,74.92,181h0a8,8,0,0,1,10.45-4.33l14.78,6.13A8,8,0,0,1,104.48,193.24ZM197.57,418l-6.12,14.78a8,8,0,0,1-14.79-6.12l6.13-14.78A8,8,0,1,1,197.57,418ZM264,444a8,8,0,0,1-8,8h0a8,8,0,0,1-8-8V428a8,8,0,0,1,8-8h0a8,8,0,0,1,8,8Zm67-6.92h0a8,8,0,0,1-10.46-4.33L314.43,418a8,8,0,0,1,4.33-10.45h0a8,8,0,0,1,10.45,4.33l6.13,14.78A8,8,0,0,1,331,437.08Zm63.58-42.49h0a8,8,0,0,1-11.31,0L372,383.28A8,8,0,0,1,372,372h0a8,8,0,0,1,11.31,0l11.31,11.31A8,8,0,0,1,394.59,394.59ZM286.25,286.25,110.34,401.66,225.75,225.75,401.66,110.34ZM437.08,331h0a8,8,0,0,1-10.45,4.33l-14.78-6.13a8,8,0,0,1-4.33-10.45h0A8,8,0,0,1,418,314.43l14.78,6.12A8,8,0,0,1,437.08,331ZM444,264H428a8,8,0,0,1-8-8h0a8,8,0,0,1,8-8h16a8,8,0,0,1,8,8h0A8,8,0,0,1,444,264Z"
    ]
};
var $ef0249c5e48bf4e3$export$4675affbae76524d = {
    prefix: "fab",
    iconName: "google",
    icon: [
        488,
        512,
        [],
        "f1a0",
        "M488 261.8C488 403.3 391.1 504 248 504 110.8 504 0 393.2 0 256S110.8 8 248 8c66.8 0 123 24.5 166.3 64.9l-67.5 64.9C258.5 52.6 94.3 116.6 94.3 256c0 86.5 69.1 156.6 153.7 156.6 98.2 0 135-70.4 140.8-106.9H248v-85.3h236.1c2.3 12.7 3.9 24.9 3.9 41.4z"
    ]
};
var $ef0249c5e48bf4e3$export$dda4448112663ba = {
    prefix: "fab",
    iconName: "square-font-awesome-stroke",
    icon: [
        448,
        512,
        [
            "font-awesome-alt"
        ],
        "f35c",
        "M201.6,152c-25.4,0-37.4,10.4-57.6,14.4V160c0-8.8-7.2-16-16-16s-16,7.2-16,16v192c0,0.8,0.1,1.6,0.2,2.4 c0.1,0.4,0.1,0.8,0.2,1.2c1.6,7.1,8,12.4,15.6,12.4s14-5.3,15.6-12.4c0.1-0.4,0.2-0.8,0.2-1.2c0.1-0.8,0.2-1.6,0.2-2.4V198.4 c4-0.8,7.7-1.8,11.2-3c14.3-4.7,26-11.4,46.4-11.4c31.4,0,43.2,16,74.6,16c8.9,0,15.9-1.1,24.2-3.5c1.2-0.3,2.4-0.7,3.6-1.1v96 c-10,3.2-17.6,4.6-27.8,4.6c-31.4,0-43.4-16-74.6-16c-10.2,0-18.2,1.8-25.6,4v32c7.4-2.4,15.4-4,25.6-4c31.4,0,43.2,16,74.6,16 c18.6,0,28.2-4.8,59.8-16V152c-31.6,11.2-41.2,16-59.8,16C244.8,168,232.8,152,201.6,152z M384,32H64C28.7,32,0,60.7,0,96v320 c0,35.3,28.7,64,64,64h320c35.3,0,64-28.7,64-64V96C448,60.7,419.3,32,384,32z M416,416c0,17.6-14.4,32-32,32H64 c-17.6,0-32-14.4-32-32V96c0-17.6,14.4-32,32-32h320c17.6,0,32,14.4,32,32V416z"
    ]
};
var $ef0249c5e48bf4e3$export$85f790d14ecf253e = $ef0249c5e48bf4e3$export$dda4448112663ba;
var $ef0249c5e48bf4e3$export$f200be919c1eaf0d = {
    prefix: "fab",
    iconName: "atlassian",
    icon: [
        512,
        512,
        [],
        "f77b",
        "M152.2 236.4c-7.7-8.2-19.7-7.7-24.8 2.8L1.6 490.2c-5 10 2.4 21.7 13.4 21.7h175c5.8.1 11-3.2 13.4-8.4 37.9-77.8 15.1-196.3-51.2-267.1zM244.4 8.1c-122.3 193.4-8.5 348.6 65 495.5 2.5 5.1 7.7 8.4 13.4 8.4H497c11.2 0 18.4-11.8 13.4-21.7 0 0-234.5-470.6-240.4-482.3-5.3-10.6-18.8-10.8-25.6.1z"
    ]
};
var $ef0249c5e48bf4e3$export$ed0a679f653cc1ec = {
    prefix: "fab",
    iconName: "linkedin-in",
    icon: [
        448,
        512,
        [],
        "f0e1",
        "M100.28 448H7.4V148.9h92.88zM53.79 108.1C24.09 108.1 0 83.5 0 53.8a53.79 53.79 0 0 1 107.58 0c0 29.7-24.1 54.3-53.79 54.3zM447.9 448h-92.68V302.4c0-34.7-.7-79.2-48.29-79.2-48.29 0-55.69 37.7-55.69 76.7V448h-92.78V148.9h89.08v40.8h1.3c12.4-23.5 42.69-48.3 87.88-48.3 94 0 111.28 61.9 111.28 142.3V448z"
    ]
};
var $ef0249c5e48bf4e3$export$c5c4219467aa9953 = {
    prefix: "fab",
    iconName: "digital-ocean",
    icon: [
        512,
        512,
        [],
        "f391",
        "M87 481.8h73.7v-73.6H87zM25.4 346.6v61.6H87v-61.6zm466.2-169.7c-23-74.2-82.4-133.3-156.6-156.6C164.9-32.8 8 93.7 8 255.9h95.8c0-101.8 101-180.5 208.1-141.7 39.7 14.3 71.5 46.1 85.8 85.7 39.1 107-39.7 207.8-141.4 208v.3h-.3V504c162.6 0 288.8-156.8 235.6-327.1zm-235.3 231v-95.3h-95.6v95.6H256v-.3z"
    ]
};
var $ef0249c5e48bf4e3$export$3f240983de3f5d10 = {
    prefix: "fab",
    iconName: "nimblr",
    icon: [
        384,
        512,
        [],
        "f5a8",
        "M246.6 299.29c15.57 0 27.15 11.46 27.15 27s-11.62 27-27.15 27c-15.7 0-27.15-11.57-27.15-27s11.55-27 27.15-27zM113 326.25c0-15.61 11.68-27 27.15-27s27.15 11.46 27.15 27-11.47 27-27.15 27c-15.44 0-27.15-11.31-27.15-27M191.76 159C157 159 89.45 178.77 59.25 227L14 0v335.48C14 433.13 93.61 512 191.76 512s177.76-78.95 177.76-176.52S290.13 159 191.76 159zm0 308.12c-73.27 0-132.51-58.9-132.51-131.59s59.24-131.59 132.51-131.59 132.51 58.86 132.51 131.54S265 467.07 191.76 467.07z"
    ]
};
var $ef0249c5e48bf4e3$export$8d89e361d79b386e = {
    prefix: "fab",
    iconName: "chromecast",
    icon: [
        512,
        512,
        [],
        "f838",
        "M447.8,64H64c-23.6,0-42.7,19.1-42.7,42.7v63.9H64v-63.9h383.8v298.6H298.6V448H448c23.6,0,42.7-19.1,42.7-42.7V106.7 C490.7,83.1,471.4,64,447.8,64z M21.3,383.6L21.3,383.6l0,63.9h63.9C85.2,412.2,56.6,383.6,21.3,383.6L21.3,383.6z M21.3,298.6V341 c58.9,0,106.6,48.1,106.6,107h42.7C170.7,365.6,103.7,298.7,21.3,298.6z M213.4,448h42.7c-0.5-129.5-105.3-234.3-234.8-234.6l0,42.4 C127.3,255.6,213.3,342,213.4,448z"
    ]
};
var $ef0249c5e48bf4e3$export$acd6dee6975fc503 = {
    prefix: "fab",
    iconName: "evernote",
    icon: [
        384,
        512,
        [],
        "f839",
        "M120.82 132.21c1.6 22.31-17.55 21.59-21.61 21.59-68.93 0-73.64-1-83.58 3.34-.56.22-.74 0-.37-.37L123.79 46.45c.38-.37.6-.22.38.37-4.35 9.99-3.35 15.09-3.35 85.39zm79 308c-14.68-37.08 13-76.93 52.52-76.62 17.49 0 22.6 23.21 7.95 31.42-6.19 3.3-24.95 1.74-25.14 19.2-.05 17.09 19.67 25 31.2 24.89A45.64 45.64 0 0 0 312 393.45v-.08c0-11.63-7.79-47.22-47.54-55.34-7.72-1.54-65-6.35-68.35-50.52-3.74 16.93-17.4 63.49-43.11 69.09-8.74 1.94-69.68 7.64-112.92-36.77 0 0-18.57-15.23-28.23-57.95-3.38-15.75-9.28-39.7-11.14-62 0-18 11.14-30.45 25.07-32.2 81 0 90 2.32 101-7.8 9.82-9.24 7.8-15.5 7.8-102.78 1-8.3 7.79-30.81 53.41-24.14 6 .86 31.91 4.18 37.48 30.64l64.26 11.15c20.43 3.71 70.94 7 80.6 57.94 22.66 121.09 8.91 238.46 7.8 238.46C362.15 485.53 267.06 480 267.06 480c-18.95-.23-54.25-9.4-67.27-39.83zm80.94-204.84c-1 1.92-2.2 6 .85 7 14.09 4.93 39.75 6.84 45.88 5.53 3.11-.25 3.05-4.43 2.48-6.65-3.53-21.85-40.83-26.5-49.24-5.92z"
    ]
};
var $ef0249c5e48bf4e3$export$5d439911ece032d6 = {
    prefix: "fab",
    iconName: "hacker-news",
    icon: [
        448,
        512,
        [],
        "f1d4",
        "M0 32v448h448V32H0zm21.2 197.2H21c.1-.1.2-.3.3-.4 0 .1 0 .3-.1.4zm218 53.9V384h-31.4V281.3L128 128h37.3c52.5 98.3 49.2 101.2 59.3 125.6 12.3-27 5.8-24.4 60.6-125.6H320l-80.8 155.1z"
    ]
};
var $ef0249c5e48bf4e3$export$e443cc965f82dd02 = {
    prefix: "fab",
    iconName: "creative-commons-sampling",
    icon: [
        496,
        512,
        [],
        "f4f0",
        "M247.6 8C389.4 8 496 118.1 496 256c0 147.1-118.5 248-248.4 248C113.6 504 0 394.5 0 256 0 123.1 104.7 8 247.6 8zm.8 44.7C130.2 52.7 44.7 150.6 44.7 256c0 109.8 91.2 202.8 203.7 202.8 103.2 0 202.8-81.1 202.8-202.8.1-113.8-90.2-203.3-202.8-203.3zm3.6 53.2c2.8-.3 11.5 1 11.5 11.5l6.6 107.2 4.9-59.3c0-6 4.7-10.6 10.6-10.6 5.9 0 10.6 4.7 10.6 10.6 0 2.5-.5-5.7 5.7 81.5l5.8-64.2c.3-2.9 2.9-9.3 10.2-9.3 3.8 0 9.9 2.3 10.6 8.9l11.5 96.5 5.3-12.8c1.8-4.4 5.2-6.6 10.2-6.6h58v21.3h-50.9l-18.2 44.3c-3.9 9.9-19.5 9.1-20.8-3.1l-4-31.9-7.5 92.6c-.3 3-3 9.3-10.2 9.3-3 0-9.8-2.1-10.6-9.3 0-1.9.6 5.8-6.2-77.9l-5.3 72.2c-1.1 4.8-4.8 9.3-10.6 9.3-2.9 0-9.8-2-10.6-9.3 0-1.9.5 6.7-5.8-87.7l-5.8 94.8c0 6.3-3.6 12.4-10.6 12.4-5.2 0-10.6-4.1-10.6-12l-5.8-87.7c-5.8 92.5-5.3 84-5.3 85.9-1.1 4.8-4.8 9.3-10.6 9.3-3 0-9.8-2.1-10.6-9.3 0-.7-.4-1.1-.4-2.6l-6.2-88.6L182 348c-.7 6.5-6.7 9.3-10.6 9.3-5.8 0-9.6-4.1-10.6-8.9L149.7 272c-2 4-3.5 8.4-11.1 8.4H87.2v-21.3H132l13.7-27.9c4.4-9.9 18.2-7.2 19.9 2.7l3.1 20.4 8.4-97.9c0-6 4.8-10.6 10.6-10.6.5 0 10.6-.2 10.6 12.4l4.9 69.1 6.6-92.6c0-10.1 9.5-10.6 10.2-10.6.6 0 10.6.7 10.6 10.6l5.3 80.6 6.2-97.9c.1-1.1-.6-10.3 9.9-11.5z"
    ]
};
var $ef0249c5e48bf4e3$export$1a30438e2bd95428 = {
    prefix: "fab",
    iconName: "adversal",
    icon: [
        512,
        512,
        [],
        "f36a",
        "M482.1 32H28.7C5.8 32 0 37.9 0 60.9v390.2C0 474.4 5.8 480 28.7 480h453.4c24.4 0 29.9-5.2 29.9-29.7V62.2c0-24.6-5.4-30.2-29.9-30.2zM178.4 220.3c-27.5-20.2-72.1-8.7-84.2 23.4-4.3 11.1-9.3 9.5-17.5 8.3-9.7-1.5-17.2-3.2-22.5-5.5-28.8-11.4 8.6-55.3 24.9-64.3 41.1-21.4 83.4-22.2 125.3-4.8 40.9 16.8 34.5 59.2 34.5 128.5 2.7 25.8-4.3 58.3 9.3 88.8 1.9 4.4.4 7.9-2.7 10.7-8.4 6.7-39.3 2.2-46.6-7.4-1.9-2.2-1.8-3.6-3.9-6.2-3.6-3.9-7.3-2.2-11.9 1-57.4 36.4-140.3 21.4-147-43.3-3.1-29.3 12.4-57.1 39.6-71 38.2-19.5 112.2-11.8 114-30.9 1.1-10.2-1.9-20.1-11.3-27.3zm286.7 222c0 15.1-11.1 9.9-17.8 9.9H52.4c-7.4 0-18.2 4.8-17.8-10.7.4-13.9 10.5-9.1 17.1-9.1 132.3-.4 264.5-.4 396.8 0 6.8 0 16.6-4.4 16.6 9.9zm3.8-340.5v291c0 5.7-.7 13.9-8.1 13.9-12.4-.4-27.5 7.1-36.1-5.6-5.8-8.7-7.8-4-12.4-1.2-53.4 29.7-128.1 7.1-144.4-85.2-6.1-33.4-.7-67.1 15.7-100 11.8-23.9 56.9-76.1 136.1-30.5v-71c0-26.2-.1-26.2 26-26.2 3.1 0 6.6.4 9.7 0 10.1-.8 13.6 4.4 13.6 14.3-.1.2-.1.3-.1.5zm-51.5 232.3c-19.5 47.6-72.9 43.3-90 5.2-15.1-33.3-15.5-68.2.4-101.5 16.3-34.1 59.7-35.7 81.5-4.8 20.6 28.8 14.9 84.6 8.1 101.1zm-294.8 35.3c-7.5-1.3-33-3.3-33.7-27.8-.4-13.9 7.8-23 19.8-25.8 24.4-5.9 49.3-9.9 73.7-14.7 8.9-2 7.4 4.4 7.8 9.5 1.4 33-26.1 59.2-67.6 58.8z"
    ]
};
var $ef0249c5e48bf4e3$export$cf9c9b2132d3672c = {
    prefix: "fab",
    iconName: "creative-commons",
    icon: [
        496,
        512,
        [],
        "f25e",
        "M245.83 214.87l-33.22 17.28c-9.43-19.58-25.24-19.93-27.46-19.93-22.13 0-33.22 14.61-33.22 43.84 0 23.57 9.21 43.84 33.22 43.84 14.47 0 24.65-7.09 30.57-21.26l30.55 15.5c-6.17 11.51-25.69 38.98-65.1 38.98-22.6 0-73.96-10.32-73.96-77.05 0-58.69 43-77.06 72.63-77.06 30.72-.01 52.7 11.95 65.99 35.86zm143.05 0l-32.78 17.28c-9.5-19.77-25.72-19.93-27.9-19.93-22.14 0-33.22 14.61-33.22 43.84 0 23.55 9.23 43.84 33.22 43.84 14.45 0 24.65-7.09 30.54-21.26l31 15.5c-2.1 3.75-21.39 38.98-65.09 38.98-22.69 0-73.96-9.87-73.96-77.05 0-58.67 42.97-77.06 72.63-77.06 30.71-.01 52.58 11.95 65.56 35.86zM247.56 8.05C104.74 8.05 0 123.11 0 256.05c0 138.49 113.6 248 247.56 248 129.93 0 248.44-100.87 248.44-248 0-137.87-106.62-248-248.44-248zm.87 450.81c-112.54 0-203.7-93.04-203.7-202.81 0-105.42 85.43-203.27 203.72-203.27 112.53 0 202.82 89.46 202.82 203.26-.01 121.69-99.68 202.82-202.84 202.82z"
    ]
};
var $ef0249c5e48bf4e3$export$17b7e34aba803644 = {
    prefix: "fab",
    iconName: "watchman-monitoring",
    icon: [
        512,
        512,
        [],
        "e087",
        "M256,16C123.452,16,16,123.452,16,256S123.452,496,256,496,496,388.548,496,256,388.548,16,256,16ZM121.69,429.122C70.056,388.972,36.741,326.322,36.741,256a218.519,218.519,0,0,1,9.587-64.122l102.9-17.895-.121,10.967-13.943,2.013s-.144,12.5-.144,19.549a12.778,12.778,0,0,0,4.887,10.349l9.468,7.4Zm105.692-283.27,8.48-7.618s6.934-5.38-.143-9.344c-7.188-4.024-39.53-34.5-39.53-34.5-5.348-5.477-8.257-7.347-15.46,0,0,0-32.342,30.474-39.529,34.5-7.078,3.964-.144,9.344-.144,9.344l8.481,7.618-.048,4.369L75.982,131.045c39.644-56.938,105.532-94.3,180.018-94.3A218.754,218.754,0,0,1,420.934,111.77l-193.512,37.7Zm34.063,329.269-33.9-250.857,9.467-7.4a12.778,12.778,0,0,0,4.888-10.349c0-7.044-.144-19.549-.144-19.549l-13.943-2.013-.116-10.474,241.711,31.391A218.872,218.872,0,0,1,475.259,256C475.259,375.074,379.831,472.212,261.445,475.121Z"
    ]
};
var $ef0249c5e48bf4e3$export$324e0175b7ef27f7 = {
    prefix: "fab",
    iconName: "fonticons",
    icon: [
        448,
        512,
        [],
        "f280",
        "M0 32v448h448V32zm187 140.9c-18.4 0-19 9.9-19 27.4v23.3c0 2.4-3.5 4.4-.6 4.4h67.4l-11.1 37.3H168v112.9c0 5.8-2 6.7 3.2 7.3l43.5 4.1v25.1H84V389l21.3-2c5.2-.6 6.7-2.3 6.7-7.9V267.7c0-2.3-2.9-2.3-5.8-2.3H84V228h28v-21c0-49.6 26.5-70 77.3-70 34.1 0 64.7 8.2 64.7 52.8l-50.7 6.1c.3-18.7-4.4-23-16.3-23zm74.3 241.8v-25.1l20.4-2.6c5.2-.6 7.6-1.7 7.6-7.3V271.8c0-4.1-2.9-6.7-6.7-7.9l-24.2-6.4 6.7-29.5h80.2v151.7c0 5.8-2.6 6.4 2.9 7.3l15.7 2.6v25.1zm80.8-255.5l9 33.2-7.3 7.3-31.2-16.6-31.2 16.6-7.3-7.3 9-33.2-21.8-24.2 3.5-9.6h27.7l15.5-28h9.3l15.5 28h27.7l3.5 9.6z"
    ]
};
var $ef0249c5e48bf4e3$export$5c0c3408fef47d33 = {
    prefix: "fab",
    iconName: "weixin",
    icon: [
        576,
        512,
        [],
        "f1d7",
        "M385.2 167.6c6.4 0 12.6.3 18.8 1.1C387.4 90.3 303.3 32 207.7 32 100.5 32 13 104.8 13 197.4c0 53.4 29.3 97.5 77.9 131.6l-19.3 58.6 68-34.1c24.4 4.8 43.8 9.7 68.2 9.7 6.2 0 12.1-.3 18.3-.8-4-12.9-6.2-26.6-6.2-40.8-.1-84.9 72.9-154 165.3-154zm-104.5-52.9c14.5 0 24.2 9.7 24.2 24.4 0 14.5-9.7 24.2-24.2 24.2-14.8 0-29.3-9.7-29.3-24.2.1-14.7 14.6-24.4 29.3-24.4zm-136.4 48.6c-14.5 0-29.3-9.7-29.3-24.2 0-14.8 14.8-24.4 29.3-24.4 14.8 0 24.4 9.7 24.4 24.4 0 14.6-9.6 24.2-24.4 24.2zM563 319.4c0-77.9-77.9-141.3-165.4-141.3-92.7 0-165.4 63.4-165.4 141.3S305 460.7 397.6 460.7c19.3 0 38.9-5.1 58.6-9.9l53.4 29.3-14.8-48.6C534 402.1 563 363.2 563 319.4zm-219.1-24.5c-9.7 0-19.3-9.7-19.3-19.6 0-9.7 9.7-19.3 19.3-19.3 14.8 0 24.4 9.7 24.4 19.3 0 10-9.7 19.6-24.4 19.6zm107.1 0c-9.7 0-19.3-9.7-19.3-19.6 0-9.7 9.7-19.3 19.3-19.3 14.5 0 24.4 9.7 24.4 19.3.1 10-9.9 19.6-24.4 19.6z"
    ]
};
var $ef0249c5e48bf4e3$export$621d1ced1e254c1c = {
    prefix: "fab",
    iconName: "shirtsinbulk",
    icon: [
        448,
        512,
        [],
        "f214",
        "M100 410.3l30.6 13.4 4.4-9.9-30.6-13.4zm39.4 17.5l30.6 13.4 4.4-9.9-30.6-13.4zm172.1-14l4.4 9.9 30.6-13.4-4.4-9.9zM179.1 445l30.3 13.7 4.4-9.9-30.3-13.4zM60.4 392.8L91 406.2l4.4-9.6-30.6-13.7zm211.4 38.5l4.4 9.9 30.6-13.4-4.4-9.9zm-39.3 17.5l4.4 9.9 30.6-13.7-4.4-9.6zm118.4-52.2l4.4 9.6 30.6-13.4-4.4-9.9zM170 46.6h-33.5v10.5H170zm-47.2 0H89.2v10.5h33.5zm-47.3 0H42.3v10.5h33.3zm141.5 0h-33.2v10.5H217zm94.5 0H278v10.5h33.5zm47.3 0h-33.5v10.5h33.5zm-94.6 0H231v10.5h33.2zm141.5 0h-33.3v10.5h33.3zM52.8 351.1H42v33.5h10.8zm70-215.9H89.2v10.5h33.5zm-70 10.6h22.8v-10.5H42v33.5h10.8zm168.9 228.6c50.5 0 91.3-40.8 91.3-91.3 0-50.2-40.8-91.3-91.3-91.3-50.2 0-91.3 41.1-91.3 91.3 0 50.5 41.1 91.3 91.3 91.3zm-48.2-111.1c0-25.4 29.5-31.8 49.6-31.8 16.9 0 29.2 5.8 44.3 12l-8.8 16.9h-.9c-6.4-9.9-24.8-13.1-35.6-13.1-9 0-29.8 1.8-29.8 14.9 0 21.6 78.5-10.2 78.5 37.9 0 25.4-31.5 31.2-51 31.2-18.1 0-32.4-2.9-47.2-12.2l9-18.4h.9c6.1 12.2 23.6 14.9 35.9 14.9 8.7 0 32.7-1.2 32.7-14.3 0-26.1-77.6 6.3-77.6-38zM52.8 178.4H42V212h10.8zm342.4 206.2H406v-33.5h-10.8zM52.8 307.9H42v33.5h10.8zM0 3.7v406l221.7 98.6L448 409.7V3.7zm418.8 387.1L222 476.5 29.2 390.8V120.7h389.7v270.1zm0-299.3H29.2V32.9h389.7v58.6zm-366 130.1H42v33.5h10.8zm0 43.2H42v33.5h10.8zM170 135.2h-33.5v10.5H170zm225.2 163.1H406v-33.5h-10.8zm0-43.2H406v-33.5h-10.8zM217 135.2h-33.2v10.5H217zM395.2 212H406v-33.5h-10.8zm0 129.5H406V308h-10.8zm-131-206.3H231v10.5h33.2zm47.3 0H278v10.5h33.5zm83.7 33.6H406v-33.5h-33.5v10.5h22.8zm-36.4-33.6h-33.5v10.5h33.5z"
    ]
};
var $ef0249c5e48bf4e3$export$f02422936d21d2f4 = {
    prefix: "fab",
    iconName: "codepen",
    icon: [
        512,
        512,
        [],
        "f1cb",
        "M502.285 159.704l-234-156c-7.987-4.915-16.511-4.96-24.571 0l-234 156C3.714 163.703 0 170.847 0 177.989v155.999c0 7.143 3.714 14.286 9.715 18.286l234 156.022c7.987 4.915 16.511 4.96 24.571 0l234-156.022c6-3.999 9.715-11.143 9.715-18.286V177.989c-.001-7.142-3.715-14.286-9.716-18.285zM278 63.131l172.286 114.858-76.857 51.429L278 165.703V63.131zm-44 0v102.572l-95.429 63.715-76.857-51.429L234 63.131zM44 219.132l55.143 36.857L44 292.846v-73.714zm190 229.715L61.714 333.989l76.857-51.429L234 346.275v102.572zm22-140.858l-77.715-52 77.715-52 77.715 52-77.715 52zm22 140.858V346.275l95.429-63.715 76.857 51.429L278 448.847zm190-156.001l-55.143-36.857L468 219.132v73.714z"
    ]
};
var $ef0249c5e48bf4e3$export$9ce7fda0737f89e7 = {
    prefix: "fab",
    iconName: "git-alt",
    icon: [
        448,
        512,
        [],
        "f841",
        "M439.55 236.05L244 40.45a28.87 28.87 0 0 0-40.81 0l-40.66 40.63 51.52 51.52c27.06-9.14 52.68 16.77 43.39 43.68l49.66 49.66c34.23-11.8 61.18 31 35.47 56.69-26.49 26.49-70.21-2.87-56-37.34L240.22 199v121.85c25.3 12.54 22.26 41.85 9.08 55a34.34 34.34 0 0 1-48.55 0c-17.57-17.6-11.07-46.91 11.25-56v-123c-20.8-8.51-24.6-30.74-18.64-45L142.57 101 8.45 235.14a28.86 28.86 0 0 0 0 40.81l195.61 195.6a28.86 28.86 0 0 0 40.8 0l194.69-194.69a28.86 28.86 0 0 0 0-40.81z"
    ]
};
var $ef0249c5e48bf4e3$export$c2221e2ed2fea622 = {
    prefix: "fab",
    iconName: "lyft",
    icon: [
        512,
        512,
        [],
        "f3c3",
        "M0 81.1h77.8v208.7c0 33.1 15 52.8 27.2 61-12.7 11.1-51.2 20.9-80.2-2.8C7.8 334 0 310.7 0 289V81.1zm485.9 173.5v-22h23.8v-76.8h-26.1c-10.1-46.3-51.2-80.7-100.3-80.7-56.6 0-102.7 46-102.7 102.7V357c16 2.3 35.4-.3 51.7-14 17.1-14 24.8-37.2 24.8-59v-6.7h38.8v-76.8h-38.8v-23.3c0-34.6 52.2-34.6 52.2 0v77.1c0 56.6 46 102.7 102.7 102.7v-76.5c-14.5 0-26.1-11.7-26.1-25.9zm-294.3-99v113c0 15.4-23.8 15.4-23.8 0v-113H91v132.7c0 23.8 8 54 45 63.9 37 9.8 58.2-10.6 58.2-10.6-2.1 13.4-14.5 23.3-34.9 25.3-15.5 1.6-35.2-3.6-45-7.8v70.3c25.1 7.5 51.5 9.8 77.6 4.7 47.1-9.1 76.8-48.4 76.8-100.8V155.1h-77.1v.5z"
    ]
};
var $ef0249c5e48bf4e3$export$344ccb7aebcc7cfa = {
    prefix: "fab",
    iconName: "rev",
    icon: [
        448,
        512,
        [],
        "f5b2",
        "M289.67 274.89a65.57 65.57 0 1 1-65.56-65.56 65.64 65.64 0 0 1 65.56 65.56zm139.55-5.05h-.13a204.69 204.69 0 0 0-74.32-153l-45.38 26.2a157.07 157.07 0 0 1 71.81 131.84C381.2 361.5 310.73 432 224.11 432S67 361.5 67 274.88c0-81.88 63-149.27 143-156.43v39.12l108.77-62.79L210 32v38.32c-106.7 7.25-191 96-191 204.57 0 111.59 89.12 202.29 200.06 205v.11h210.16V269.84z"
    ]
};
var $ef0249c5e48bf4e3$export$b138356c7d4344fd = {
    prefix: "fab",
    iconName: "windows",
    icon: [
        448,
        512,
        [],
        "f17a",
        "M0 93.7l183.6-25.3v177.4H0V93.7zm0 324.6l183.6 25.3V268.4H0v149.9zm203.8 28L448 480V268.4H203.8v177.9zm0-380.6v180.1H448V32L203.8 65.7z"
    ]
};
var $ef0249c5e48bf4e3$export$2c1079aeb76cd815 = {
    prefix: "fab",
    iconName: "wizards-of-the-coast",
    icon: [
        640,
        512,
        [],
        "f730",
        "M219.19 345.69c-1.9 1.38-11.07 8.44-.26 23.57 4.64 6.42 14.11 12.79 21.73 6.55 6.5-4.88 7.35-12.92.26-23.04-5.47-7.76-14.28-12.88-21.73-7.08zm336.75 75.94c-.34 1.7-.55 1.67.79 0 2.09-4.19 4.19-10.21 4.98-19.9 3.14-38.49-40.33-71.49-101.34-78.03-54.73-6.02-124.38 9.17-188.8 60.49l-.26 1.57c2.62 4.98 4.98 10.74 3.4 21.21l.79.26c63.89-58.4 131.19-77.25 184.35-73.85 58.4 3.67 100.03 34.04 100.03 68.08-.01 9.96-2.63 15.72-3.94 20.17zM392.28 240.42c.79 7.07 4.19 10.21 9.17 10.47 5.5.26 9.43-2.62 10.47-6.55.79-3.4 2.09-29.85 2.09-29.85s-11.26 6.55-14.93 10.47c-3.66 3.68-7.33 8.39-6.8 15.46zm-50.02-151.1C137.75 89.32 13.1 226.8.79 241.2c-1.05.52-1.31.79.79 1.31 60.49 16.5 155.81 81.18 196.13 202.16l1.05.26c55.25-69.92 140.88-128.05 236.99-128.05 80.92 0 130.15 42.16 130.15 80.39 0 18.33-6.55 33.52-22.26 46.35 0 .96-.2.79.79.79 14.66-10.74 27.5-28.8 27.5-48.18 0-22.78-12.05-38.23-12.05-38.23 7.07 7.07 10.74 16.24 10.74 16.24 5.76-40.85 26.97-62.32 26.97-62.32-2.36-9.69-6.81-17.81-6.81-17.81 7.59 8.12 14.4 27.5 14.4 41.37 0 10.47-3.4 22.78-12.57 31.95l.26.52c8.12-4.98 16.5-16.76 16.5-37.97 0-15.71-4.71-25.92-4.71-25.92 5.76-5.24 11.26-9.17 15.97-11.78.79 3.4 2.09 9.69 2.36 14.93 0 1.05.79 1.83 1.05 0 .79-5.76-.26-16.24-.26-16.5 6.02-3.14 9.69-4.45 9.69-4.45C617.74 176 489.43 89.32 342.26 89.32zm-99.24 289.62c-11.06 8.99-24.2 4.08-30.64-4.19-7.45-9.58-6.76-24.09 4.19-32.47 14.85-11.35 27.08-.49 31.16 5.5.28.39 12.13 16.57-4.71 31.16zm2.09-136.43l9.43-17.81 11.78 70.96-12.57 6.02-24.62-28.8 14.14-26.71 3.67 4.45-1.83-8.11zm18.59 117.58l-.26-.26c2.05-4.1-2.5-6.61-17.54-31.69-1.31-2.36-3.14-2.88-4.45-2.62l-.26-.52c7.86-5.76 15.45-10.21 25.4-15.71l.52.26c1.31 1.83 2.09 2.88 3.4 4.71l-.26.52c-1.05-.26-2.36-.79-5.24.26-2.09.79-7.86 3.67-12.31 7.59v1.31c1.57 2.36 3.93 6.55 5.76 9.69h.26c10.05-6.28 7.56-4.55 11.52-7.86h.26c.52 1.83.52 1.83 1.83 5.5l-.26.26c-3.06.61-4.65.34-11.52 5.5v.26c9.46 17.02 11.01 16.75 12.57 15.97l.26.26c-2.34 1.59-6.27 4.21-9.68 6.57zm55.26-32.47c-3.14 1.57-6.02 2.88-9.95 4.98l-.26-.26c1.29-2.59 1.16-2.71-11.78-32.47l-.26-.26c-.15 0-8.9 3.65-9.95 7.33h-.52l-1.05-5.76.26-.52c7.29-4.56 25.53-11.64 27.76-12.57l.52.26 3.14 4.98-.26.52c-3.53-1.76-7.35.76-12.31 2.62v.26c12.31 32.01 12.67 30.64 14.66 30.64v.25zm44.77-16.5c-4.19 1.05-5.24 1.31-9.69 2.88l-.26-.26.52-4.45c-1.05-3.4-3.14-11.52-3.67-13.62l-.26-.26c-3.4.79-8.9 2.62-12.83 3.93l-.26.26c.79 2.62 3.14 9.95 4.19 13.88.79 2.36 1.83 2.88 2.88 3.14v.52c-3.67 1.05-7.07 2.62-10.21 3.93l-.26-.26c1.05-1.31 1.05-2.88.26-4.98-1.05-3.14-8.12-23.83-9.17-27.23-.52-1.83-1.57-3.14-2.62-3.14v-.52c3.14-1.05 6.02-2.09 10.74-3.4l.26.26-.26 4.71c1.31 3.93 2.36 7.59 3.14 9.69h.26c3.93-1.31 9.43-2.88 12.83-3.93l.26-.26-2.62-9.43c-.52-1.83-1.05-3.4-2.62-3.93v-.26c4.45-1.05 7.33-1.83 10.74-2.36l.26.26c-1.05 1.31-1.05 2.88-.52 4.45 1.57 6.28 4.71 20.43 6.28 26.45.54 2.62 1.85 3.41 2.63 3.93zm32.21-6.81l-.26.26c-4.71.52-14.14 2.36-22.52 4.19l-.26-.26.79-4.19c-1.57-7.86-3.4-18.59-4.98-26.19-.26-1.83-.79-2.88-2.62-3.67l.79-.52c9.17-1.57 20.16-2.36 24.88-2.62l.26.26c.52 2.36.79 3.14 1.57 5.5l-.26.26c-1.14-1.14-3.34-3.2-16.24-.79l-.26.26c.26 1.57 1.05 6.55 1.57 9.95l.26.26c9.52-1.68 4.76-.06 10.74-2.36h.26c0 1.57-.26 1.83-.26 5.24h-.26c-4.81-1.03-2.15-.9-10.21 0l-.26.26c.26 2.09 1.57 9.43 2.09 12.57l.26.26c1.15.38 14.21-.65 16.24-4.71h.26c-.53 2.38-1.05 4.21-1.58 6.04zm10.74-44.51c-4.45 2.36-8.12 2.88-11 2.88-.25.02-11.41 1.09-17.54-9.95-6.74-10.79-.98-25.2 5.5-31.69 8.8-8.12 23.35-10.1 28.54-17.02 8.03-10.33-13.04-22.31-29.59-5.76l-2.62-2.88 5.24-16.24c25.59-1.57 45.2-3.04 50.02 16.24.79 3.14 0 9.43-.26 12.05 0 2.62-1.83 18.85-2.09 23.04-.52 4.19-.79 18.33-.79 20.69.26 2.36.52 4.19 1.57 5.5 1.57 1.83 5.76 1.83 5.76 1.83l-.79 4.71c-11.82-1.07-10.28-.59-20.43-1.05-3.22-5.15-2.23-3.28-4.19-7.86 0 .01-4.19 3.94-7.33 5.51zm37.18 21.21c-6.35-10.58-19.82-7.16-21.73 5.5-2.63 17.08 14.3 19.79 20.69 10.21l.26.26c-.52 1.83-1.83 6.02-1.83 6.28l-.52.52c-10.3 6.87-28.5-2.5-25.66-18.59 1.94-10.87 14.44-18.93 28.8-9.95l.26.52c0 1.06-.27 3.41-.27 5.25zm5.77-87.73v-6.55c.69 0 19.65 3.28 27.76 7.33l-1.57 17.54s10.21-9.43 15.45-10.74c5.24-1.57 14.93 7.33 14.93 7.33l-11.26 11.26c-12.07-6.35-19.59-.08-20.69.79-5.29 38.72-8.6 42.17 4.45 46.09l-.52 4.71c-17.55-4.29-18.53-4.5-36.92-7.33l.79-4.71c7.25 0 7.48-5.32 7.59-6.81 0 0 4.98-53.16 4.98-55.25-.02-2.87-4.99-3.66-4.99-3.66zm10.99 114.44c-8.12-2.09-14.14-11-10.74-20.69 3.14-9.43 12.31-12.31 18.85-10.21 9.17 2.62 12.83 11.78 10.74 19.38-2.61 8.9-9.42 13.87-18.85 11.52zm42.16 9.69c-2.36-.52-7.07-2.36-8.64-2.88v-.26l1.57-1.83c.59-8.24.59-7.27.26-7.59-4.82-1.81-6.66-2.36-7.07-2.36-1.31 1.83-2.88 4.45-3.67 5.5l-.79 3.4v.26c-1.31-.26-3.93-1.31-6.02-1.57v-.26l2.62-1.83c3.4-4.71 9.95-14.14 13.88-20.16v-2.09l.52-.26c2.09.79 5.5 2.09 7.59 2.88.48.48.18-1.87-1.05 25.14-.24 1.81.02 2.6.8 3.91zm-4.71-89.82c11.25-18.27 30.76-16.19 34.04-3.4L539.7 198c2.34-6.25-2.82-9.9-4.45-11.26l1.83-3.67c12.22 10.37 16.38 13.97 22.52 20.43-25.91 73.07-30.76 80.81-24.62 84.32l-1.83 4.45c-6.37-3.35-8.9-4.42-17.81-8.64l2.09-6.81c-.26-.26-3.93 3.93-9.69 3.67-19.06-1.3-22.89-31.75-9.67-52.9zm29.33 79.34c0-5.71-6.34-7.89-7.86-5.24-1.31 2.09 1.05 4.98 2.88 8.38 1.57 2.62 2.62 6.28 1.05 9.43-2.64 6.34-12.4 5.31-15.45-.79 0-.7-.27.09 1.83-4.71l.79-.26c-.57 5.66 6.06 9.61 8.38 4.98 1.05-2.09-.52-5.5-2.09-8.38-1.57-2.62-3.67-6.28-1.83-9.69 2.72-5.06 11.25-4.47 14.66 2.36v.52l-2.36 3.4zm21.21 13.36c-1.96-3.27-.91-2.14-4.45-4.71h-.26c-2.36 4.19-5.76 10.47-8.64 16.24-1.31 2.36-1.05 3.4-.79 3.93l-.26.26-5.76-4.45.26-.26 2.09-1.31c3.14-5.76 6.55-12.05 9.17-17.02v-.26c-2.64-1.98-1.22-1.51-6.02-1.83v-.26l3.14-3.4h.26c3.67 2.36 9.95 6.81 12.31 8.9l.26.26-1.31 3.91zm27.23-44.26l-2.88-2.88c.79-2.36 1.83-4.98 2.09-7.59.75-9.74-11.52-11.84-11.52-4.98 0 4.98 7.86 19.38 7.86 27.76 0 10.21-5.76 15.71-13.88 16.5-8.38.79-20.16-10.47-20.16-10.47l4.98-14.4 2.88 2.09c-2.97 17.8 17.68 20.37 13.35 5.24-1.06-4.02-18.75-34.2 2.09-38.23 13.62-2.36 23.04 16.5 23.04 16.5l-7.85 10.46zm35.62-10.21c-11-30.38-60.49-127.53-191.95-129.62-53.42-1.05-94.27 15.45-132.76 37.97l85.63-9.17-91.39 20.69 25.14 19.64-3.93-16.5c7.5-1.71 39.15-8.45 66.77-8.9l-22.26 80.39c13.61-.7 18.97-8.98 19.64-22.78l4.98-1.05.26 26.71c-22.46 3.21-37.3 6.69-49.49 9.95l13.09-43.21-61.54-36.66 2.36 8.12 10.21 4.98c6.28 18.59 19.38 56.56 20.43 58.66 1.95 4.28 3.16 5.78 12.05 4.45l1.05 4.98c-16.08 4.86-23.66 7.61-39.02 14.4l-2.36-4.71c4.4-2.94 8.73-3.94 5.5-12.83-23.7-62.5-21.48-58.14-22.78-59.44l2.36-4.45 33.52 67.3c-3.84-11.87 1.68 1.69-32.99-78.82l-41.9 88.51 4.71-13.88-35.88-42.16 27.76 93.48-11.78 8.38C95 228.58 101.05 231.87 93.23 231.52c-5.5-.26-13.62 5.5-13.62 5.5L74.63 231c30.56-23.53 31.62-24.33 58.4-42.68l4.19 7.07s-5.76 4.19-7.86 7.07c-5.9 9.28 1.67 13.28 61.8 75.68l-18.85-58.92 39.8-10.21 25.66 30.64 4.45-12.31-4.98-24.62 13.09-3.4.52 3.14 3.67-10.47-94.27 29.33 11.26-4.98-13.62-42.42 17.28-9.17 30.11 36.14 28.54-13.09c-1.41-7.47-2.47-14.5-4.71-19.64l17.28 13.88 4.71-2.09-59.18-42.68 23.08 11.5c18.98-6.07 25.23-7.47 32.21-9.69l2.62 11c-12.55 12.55 1.43 16.82 6.55 19.38l-13.62-61.01 12.05 28.28c4.19-1.31 7.33-2.09 7.33-2.09l2.62 8.64s-3.14 1.05-6.28 2.09l8.9 20.95 33.78-65.73-20.69 61.01c42.42-24.09 81.44-36.66 131.98-35.88 67.04 1.05 167.33 40.85 199.8 139.83.78 2.1-.01 2.63-.79.27zM203.48 152.43s1.83-.52 4.19-1.31l9.43 7.59c-.4 0-3.44-.25-11.26 2.36l-2.36-8.64zm143.76 38.5c-1.57-.6-26.46-4.81-33.26 20.69l21.73 17.02 11.53-37.71zM318.43 67.07c-58.4 0-106.05 12.05-114.96 14.4v.79c8.38 2.09 14.4 4.19 21.21 11.78l1.57.26c6.55-1.83 48.97-13.88 110.24-13.88 180.16 0 301.67 116.79 301.67 223.37v9.95c0 1.31.79 2.62 1.05.52.52-2.09.79-8.64.79-19.64.26-83.79-96.63-227.55-321.57-227.55zm211.06 169.68c1.31-5.76 0-12.31-7.33-13.09-9.62-1.13-16.14 23.79-17.02 33.52-.79 5.5-1.31 14.93 6.02 14.93 4.68-.01 9.72-.91 18.33-35.36zm-61.53 42.95c-2.62-.79-9.43-.79-12.57 10.47-1.83 6.81.52 13.35 6.02 14.66 3.67 1.05 8.9.52 11.78-10.74 2.62-9.94-1.83-13.61-5.23-14.39zM491 300.65c1.83.52 3.14 1.05 5.76 1.83 0-1.83.52-8.38.79-12.05-1.05 1.31-5.5 8.12-6.55 9.95v.27z"
    ]
};
var $ef0249c5e48bf4e3$export$d20d4c95d5790834 = {
    prefix: "fab",
    iconName: "square-viadeo",
    icon: [
        448,
        512,
        [
            "viadeo-square"
        ],
        "f2aa",
        "M400 32H48C21.5 32 0 53.5 0 80v352c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48V80c0-26.5-21.5-48-48-48zM280.7 381.2c-42.4 46.2-120 46.6-162.4 0-68-73.6-19.8-196.1 81.2-196.1 13.3 0 26.6 2.1 39.1 6.7-4.3 8.4-7.3 17.6-8.4 27.1-9.7-4.1-20.2-6-30.7-6-48.8 0-84.6 41.7-84.6 88.9 0 43 28.5 78.7 69.5 85.9 61.5-24 72.9-117.6 72.9-175 0-7.3 0-14.8-.6-22.1-11.2-32.9-26.6-64.6-44.2-94.5 27.1 18.3 41.9 62.5 44.2 94.1v.4c7.7 22.5 11.8 46.2 11.8 70 0 54.1-21.9 99-68.3 128.2l-2.4.2c50 1 86.2-38.6 86.2-87.2 0-12.2-2.1-24.3-6.9-35.7 9.5-1.9 18.5-5.6 26.4-10.5 15.3 36.6 12.6 87.3-22.8 125.6zM309 233.7c-13.3 0-25.1-7.1-34.4-16.1 21.9-12 49.6-30.7 62.3-53 1.5-3 4.1-8.6 4.5-12-12.5 27.9-44.2 49.8-73.9 56.7-4.7-7.3-7.5-15.5-7.5-24.3 0-10.3 5.2-24.1 12.9-31.6 21.6-20.5 53-8.5 72.4-50 32.5 46.2 13.1 130.3-36.3 130.3z"
    ]
};
var $ef0249c5e48bf4e3$export$46c94e3313db0253 = $ef0249c5e48bf4e3$export$d20d4c95d5790834;
var $ef0249c5e48bf4e3$export$61e6f6fcefd81d6e = {
    prefix: "fab",
    iconName: "meetup",
    icon: [
        512,
        512,
        [],
        "f2e0",
        "M99 414.3c1.1 5.7-2.3 11.1-8 12.3-5.4 1.1-10.9-2.3-12-8-1.1-5.4 2.3-11.1 7.7-12.3 5.4-1.2 11.1 2.3 12.3 8zm143.1 71.4c-6.3 4.6-8 13.4-3.7 20 4.6 6.6 13.4 8.3 20 3.7 6.3-4.6 8-13.4 3.4-20-4.2-6.5-13.1-8.3-19.7-3.7zm-86-462.3c6.3-1.4 10.3-7.7 8.9-14-1.1-6.6-7.4-10.6-13.7-9.1-6.3 1.4-10.3 7.7-9.1 14 1.4 6.6 7.6 10.6 13.9 9.1zM34.4 226.3c-10-6.9-23.7-4.3-30.6 6-6.9 10-4.3 24 5.7 30.9 10 7.1 23.7 4.6 30.6-5.7 6.9-10.4 4.3-24.1-5.7-31.2zm272-170.9c10.6-6.3 13.7-20 7.7-30.3-6.3-10.6-19.7-14-30-7.7s-13.7 20-7.4 30.6c6 10.3 19.4 13.7 29.7 7.4zm-191.1 58c7.7-5.4 9.4-16 4.3-23.7s-15.7-9.4-23.1-4.3c-7.7 5.4-9.4 16-4.3 23.7 5.1 7.8 15.6 9.5 23.1 4.3zm372.3 156c-7.4 1.7-12.3 9.1-10.6 16.9 1.4 7.4 8.9 12.3 16.3 10.6 7.4-1.4 12.3-8.9 10.6-16.6-1.5-7.4-8.9-12.3-16.3-10.9zm39.7-56.8c-1.1-5.7-6.6-9.1-12-8-5.7 1.1-9.1 6.9-8 12.6 1.1 5.4 6.6 9.1 12.3 8 5.4-1.5 9.1-6.9 7.7-12.6zM447 138.9c-8.6 6-10.6 17.7-4.9 26.3 5.7 8.6 17.4 10.6 26 4.9 8.3-6 10.3-17.7 4.6-26.3-5.7-8.7-17.4-10.9-25.7-4.9zm-6.3 139.4c26.3 43.1 15.1 100-26.3 129.1-17.4 12.3-37.1 17.7-56.9 17.1-12 47.1-69.4 64.6-105.1 32.6-1.1.9-2.6 1.7-3.7 2.9-39.1 27.1-92.3 17.4-119.4-22.3-9.7-14.3-14.6-30.6-15.1-46.9-65.4-10.9-90-94-41.1-139.7-28.3-46.9.6-107.4 53.4-114.9C151.6 70 234.1 38.6 290.1 82c67.4-22.3 136.3 29.4 130.9 101.1 41.1 12.6 52.8 66.9 19.7 95.2zm-70 74.3c-3.1-20.6-40.9-4.6-43.1-27.1-3.1-32 43.7-101.1 40-128-3.4-24-19.4-29.1-33.4-29.4-13.4-.3-16.9 2-21.4 4.6-2.9 1.7-6.6 4.9-11.7-.3-6.3-6-11.1-11.7-19.4-12.9-12.3-2-17.7 2-26.6 9.7-3.4 2.9-12 12.9-20 9.1-3.4-1.7-15.4-7.7-24-11.4-16.3-7.1-40 4.6-48.6 20-12.9 22.9-38 113.1-41.7 125.1-8.6 26.6 10.9 48.6 36.9 47.1 11.1-.6 18.3-4.6 25.4-17.4 4-7.4 41.7-107.7 44.6-112.6 2-3.4 8.9-8 14.6-5.1 5.7 3.1 6.9 9.4 6 15.1-1.1 9.7-28 70.9-28.9 77.7-3.4 22.9 26.9 26.6 38.6 4 3.7-7.1 45.7-92.6 49.4-98.3 4.3-6.3 7.4-8.3 11.7-8 3.1 0 8.3.9 7.1 10.9-1.4 9.4-35.1 72.3-38.9 87.7-4.6 20.6 6.6 41.4 24.9 50.6 11.4 5.7 62.5 15.7 58.5-11.1zm5.7 92.3c-10.3 7.4-12.9 22-5.7 32.6 7.1 10.6 21.4 13.1 32 6 10.6-7.4 13.1-22 6-32.6-7.4-10.6-21.7-13.5-32.3-6z"
    ]
};
var $ef0249c5e48bf4e3$export$47b9420154e916ca = {
    prefix: "fab",
    iconName: "centos",
    icon: [
        448,
        512,
        [],
        "f789",
        "M289.6 97.5l31.6 31.7-76.3 76.5V97.5zm-162.4 31.7l76.3 76.5V97.5h-44.7zm41.5-41.6h44.7v127.9l10.8 10.8 10.8-10.8V87.6h44.7L224.2 32zm26.2 168.1l-10.8-10.8H55.5v-44.8L0 255.7l55.5 55.6v-44.8h128.6l10.8-10.8zm79.3-20.7h107.9v-44.8l-31.6-31.7zm173.3 20.7L392 200.1v44.8H264.3l-10.8 10.8 10.8 10.8H392v44.8l55.5-55.6zM65.4 176.2l32.5-31.7 90.3 90.5h15.3v-15.3l-90.3-90.5 31.6-31.7H65.4zm316.7-78.7h-78.5l31.6 31.7-90.3 90.5V235h15.3l90.3-90.5 31.6 31.7zM203.5 413.9V305.8l-76.3 76.5 31.6 31.7h44.7zM65.4 235h108.8l-76.3-76.5-32.5 31.7zm316.7 100.2l-31.6 31.7-90.3-90.5h-15.3v15.3l90.3 90.5-31.6 31.7h78.5zm0-58.8H274.2l76.3 76.5 31.6-31.7zm-60.9 105.8l-76.3-76.5v108.1h44.7zM97.9 352.9l76.3-76.5H65.4v44.8zm181.8 70.9H235V295.9l-10.8-10.8-10.8 10.8v127.9h-44.7l55.5 55.6zm-166.5-41.6l90.3-90.5v-15.3h-15.3l-90.3 90.5-32.5-31.7v78.7h79.4z"
    ]
};
var $ef0249c5e48bf4e3$export$64d8cc39326ee7a8 = {
    prefix: "fab",
    iconName: "adn",
    icon: [
        496,
        512,
        [],
        "f170",
        "M248 167.5l64.9 98.8H183.1l64.9-98.8zM496 256c0 136.9-111.1 248-248 248S0 392.9 0 256 111.1 8 248 8s248 111.1 248 248zm-99.8 82.7L248 115.5 99.8 338.7h30.4l33.6-51.7h168.6l33.6 51.7h30.2z"
    ]
};
var $ef0249c5e48bf4e3$export$616a6b084ab35801 = {
    prefix: "fab",
    iconName: "cloudsmith",
    icon: [
        512,
        512,
        [],
        "f384",
        "M512 227.6v56.9L284.4 512H227.6L0 284.4V227.6L227.6 0h56.9L512 227.6zm-256 162a133.6 133.6 0 1 0 0-267.1 133.6 133.6 0 1 0 0 267.1z"
    ]
};
var $ef0249c5e48bf4e3$export$ef7de58d3fe843ba = {
    prefix: "fab",
    iconName: "pied-piper-alt",
    icon: [
        576,
        512,
        [],
        "f1a8",
        "M244 246c-3.2-2-6.3-2.9-10.1-2.9-6.6 0-12.6 3.2-19.3 3.7l1.7 4.9zm135.9 197.9c-19 0-64.1 9.5-79.9 19.8l6.9 45.1c35.7 6.1 70.1 3.6 106-9.8-4.8-10-23.5-55.1-33-55.1zM340.8 177c6.6 2.8 11.5 9.2 22.7 22.1 2-1.4 7.5-5.2 7.5-8.6 0-4.9-11.8-13.2-13.2-23 11.2-5.7 25.2-6 37.6-8.9 68.1-16.4 116.3-52.9 146.8-116.7C548.3 29.3 554 16.1 554.6 2l-2 2.6c-28.4 50-33 63.2-81.3 100-31.9 24.4-69.2 40.2-106.6 54.6l-6.3-.3v-21.8c-19.6 1.6-19.7-14.6-31.6-23-18.7 20.6-31.6 40.8-58.9 51.1-12.7 4.8-19.6 10-25.9 21.8 34.9-16.4 91.2-13.5 98.8-10zM555.5 0l-.6 1.1-.3.9.6-.6zm-59.2 382.1c-33.9-56.9-75.3-118.4-150-115.5l-.3-6c-1.1-13.5 32.8 3.2 35.1-31l-14.4 7.2c-19.8-45.7-8.6-54.3-65.5-54.3-14.7 0-26.7 1.7-41.4 4.6 2.9 18.6 2.2 36.7-10.9 50.3l19.5 5.5c-1.7 3.2-2.9 6.3-2.9 9.8 0 21 42.8 2.9 42.8 33.6 0 18.4-36.8 60.1-54.9 60.1-8 0-53.7-50-53.4-60.1l.3-4.6 52.3-11.5c13-2.6 12.3-22.7-2.9-22.7-3.7 0-43.1 9.2-49.4 10.6-2-5.2-7.5-14.1-13.8-14.1-3.2 0-6.3 3.2-9.5 4-9.2 2.6-31 2.9-21.5 20.1L15.9 298.5c-5.5 1.1-8.9 6.3-8.9 11.8 0 6 5.5 10.9 11.5 10.9 8 0 131.3-28.4 147.4-32.2 2.6 3.2 4.6 6.3 7.8 8.6 20.1 14.4 59.8 85.9 76.4 85.9 24.1 0 58-22.4 71.3-41.9 3.2-4.3 6.9-7.5 12.4-6.9.6 13.8-31.6 34.2-33 43.7-1.4 10.2-1 35.2-.3 41.1 26.7 8.1 52-3.6 77.9-2.9 4.3-21 10.6-41.9 9.8-63.5l-.3-9.5c-1.4-34.2-10.9-38.5-34.8-58.6-1.1-1.1-2.6-2.6-3.7-4 2.2-1.4 1.1-1 4.6-1.7 88.5 0 56.3 183.6 111.5 229.9 33.1-15 72.5-27.9 103.5-47.2-29-25.6-52.6-45.7-72.7-79.9zm-196.2 46.1v27.2l11.8-3.4-2.9-23.8zm-68.7-150.4l24.1 61.2 21-13.8-31.3-50.9zm84.4 154.9l2 12.4c9-1.5 58.4-6.6 58.4-14.1 0-1.4-.6-3.2-.9-4.6-26.8 0-36.9 3.8-59.5 6.3z"
    ]
};
var $ef0249c5e48bf4e3$export$fc95d67ac3aa8c53 = {
    prefix: "fab",
    iconName: "square-dribbble",
    icon: [
        448,
        512,
        [
            "dribbble-square"
        ],
        "f397",
        "M90.2 228.2c8.9-42.4 37.4-77.7 75.7-95.7 3.6 4.9 28 38.8 50.7 79-64 17-120.3 16.8-126.4 16.7zM314.6 154c-33.6-29.8-79.3-41.1-122.6-30.6 3.8 5.1 28.6 38.9 51 80 48.6-18.3 69.1-45.9 71.6-49.4zM140.1 364c40.5 31.6 93.3 36.7 137.3 18-2-12-10-53.8-29.2-103.6-55.1 18.8-93.8 56.4-108.1 85.6zm98.8-108.2c-3.4-7.8-7.2-15.5-11.1-23.2C159.6 253 93.4 252.2 87.4 252c0 1.4-.1 2.8-.1 4.2 0 35.1 13.3 67.1 35.1 91.4 22.2-37.9 67.1-77.9 116.5-91.8zm34.9 16.3c17.9 49.1 25.1 89.1 26.5 97.4 30.7-20.7 52.5-53.6 58.6-91.6-4.6-1.5-42.3-12.7-85.1-5.8zm-20.3-48.4c4.8 9.8 8.3 17.8 12 26.8 45.5-5.7 90.7 3.4 95.2 4.4-.3-32.3-11.8-61.9-30.9-85.1-2.9 3.9-25.8 33.2-76.3 53.9zM448 80v352c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V80c0-26.5 21.5-48 48-48h352c26.5 0 48 21.5 48 48zm-64 176c0-88.2-71.8-160-160-160S64 167.8 64 256s71.8 160 160 160 160-71.8 160-160z"
    ]
};
var $ef0249c5e48bf4e3$export$ff55221913bb3cd0 = $ef0249c5e48bf4e3$export$fc95d67ac3aa8c53;
var $ef0249c5e48bf4e3$export$248fddd2c856e8cc = {
    prefix: "fab",
    iconName: "codiepie",
    icon: [
        472,
        512,
        [],
        "f284",
        "M422.5 202.9c30.7 0 33.5 53.1-.3 53.1h-10.8v44.3h-26.6v-97.4h37.7zM472 352.6C429.9 444.5 350.4 504 248 504 111 504 0 393 0 256S111 8 248 8c97.4 0 172.8 53.7 218.2 138.4l-186 108.8L472 352.6zm-38.5 12.5l-60.3-30.7c-27.1 44.3-70.4 71.4-122.4 71.4-82.5 0-149.2-66.7-149.2-148.9 0-82.5 66.7-149.2 149.2-149.2 48.4 0 88.9 23.5 116.9 63.4l59.5-34.6c-40.7-62.6-104.7-100-179.2-100-121.2 0-219.5 98.3-219.5 219.5S126.8 475.5 248 475.5c78.6 0 146.5-42.1 185.5-110.4z"
    ]
};
var $ef0249c5e48bf4e3$export$4c16416edc1f091a = {
    prefix: "fab",
    iconName: "node",
    icon: [
        640,
        512,
        [],
        "f419",
        "M316.3 452c-2.1 0-4.2-.6-6.1-1.6L291 439c-2.9-1.6-1.5-2.2-.5-2.5 3.8-1.3 4.6-1.6 8.7-4 .4-.2 1-.1 1.4.1l14.8 8.8c.5.3 1.3.3 1.8 0L375 408c.5-.3.9-.9.9-1.6v-66.7c0-.7-.3-1.3-.9-1.6l-57.8-33.3c-.5-.3-1.2-.3-1.8 0l-57.8 33.3c-.6.3-.9 1-.9 1.6v66.7c0 .6.4 1.2.9 1.5l15.8 9.1c8.6 4.3 13.9-.8 13.9-5.8v-65.9c0-.9.7-1.7 1.7-1.7h7.3c.9 0 1.7.7 1.7 1.7v65.9c0 11.5-6.2 18-17.1 18-3.3 0-6 0-13.3-3.6l-15.2-8.7c-3.7-2.2-6.1-6.2-6.1-10.5v-66.7c0-4.3 2.3-8.4 6.1-10.5l57.8-33.4c3.7-2.1 8.5-2.1 12.1 0l57.8 33.4c3.7 2.2 6.1 6.2 6.1 10.5v66.7c0 4.3-2.3 8.4-6.1 10.5l-57.8 33.4c-1.7 1.1-3.8 1.7-6 1.7zm46.7-65.8c0-12.5-8.4-15.8-26.2-18.2-18-2.4-19.8-3.6-19.8-7.8 0-3.5 1.5-8.1 14.8-8.1 11.9 0 16.3 2.6 18.1 10.6.2.8.8 1.3 1.6 1.3h7.5c.5 0 .9-.2 1.2-.5.3-.4.5-.8.4-1.3-1.2-13.8-10.3-20.2-28.8-20.2-16.5 0-26.3 7-26.3 18.6 0 12.7 9.8 16.1 25.6 17.7 18.9 1.9 20.4 4.6 20.4 8.3 0 6.5-5.2 9.2-17.4 9.2-15.3 0-18.7-3.8-19.8-11.4-.1-.8-.8-1.4-1.7-1.4h-7.5c-.9 0-1.7.7-1.7 1.7 0 9.7 5.3 21.3 30.6 21.3 18.5 0 29-7.2 29-19.8zm54.5-50.1c0 6.1-5 11.1-11.1 11.1s-11.1-5-11.1-11.1c0-6.3 5.2-11.1 11.1-11.1 6-.1 11.1 4.8 11.1 11.1zm-1.8 0c0-5.2-4.2-9.3-9.4-9.3-5.1 0-9.3 4.1-9.3 9.3 0 5.2 4.2 9.4 9.3 9.4 5.2-.1 9.4-4.3 9.4-9.4zm-4.5 6.2h-2.6c-.1-.6-.5-3.8-.5-3.9-.2-.7-.4-1.1-1.3-1.1h-2.2v5h-2.4v-12.5h4.3c1.5 0 4.4 0 4.4 3.3 0 2.3-1.5 2.8-2.4 3.1 1.7.1 1.8 1.2 2.1 2.8.1 1 .3 2.7.6 3.3zm-2.8-8.8c0-1.7-1.2-1.7-1.8-1.7h-2v3.5h1.9c1.6 0 1.9-1.1 1.9-1.8zM137.3 191c0-2.7-1.4-5.1-3.7-6.4l-61.3-35.3c-1-.6-2.2-.9-3.4-1h-.6c-1.2 0-2.3.4-3.4 1L3.7 184.6C1.4 185.9 0 188.4 0 191l.1 95c0 1.3.7 2.5 1.8 3.2 1.1.7 2.5.7 3.7 0L42 268.3c2.3-1.4 3.7-3.8 3.7-6.4v-44.4c0-2.6 1.4-5.1 3.7-6.4l15.5-8.9c1.2-.7 2.4-1 3.7-1 1.3 0 2.6.3 3.7 1l15.5 8.9c2.3 1.3 3.7 3.8 3.7 6.4v44.4c0 2.6 1.4 5.1 3.7 6.4l36.4 20.9c1.1.7 2.6.7 3.7 0 1.1-.6 1.8-1.9 1.8-3.2l.2-95zM472.5 87.3v176.4c0 2.6-1.4 5.1-3.7 6.4l-61.3 35.4c-2.3 1.3-5.1 1.3-7.4 0l-61.3-35.4c-2.3-1.3-3.7-3.8-3.7-6.4v-70.8c0-2.6 1.4-5.1 3.7-6.4l61.3-35.4c2.3-1.3 5.1-1.3 7.4 0l15.3 8.8c1.7 1 3.9-.3 3.9-2.2v-94c0-2.8 3-4.6 5.5-3.2l36.5 20.4c2.3 1.2 3.8 3.7 3.8 6.4zm-46 128.9c0-.7-.4-1.3-.9-1.6l-21-12.2c-.6-.3-1.3-.3-1.9 0l-21 12.2c-.6.3-.9.9-.9 1.6v24.3c0 .7.4 1.3.9 1.6l21 12.1c.6.3 1.3.3 1.8 0l21-12.1c.6-.3.9-.9.9-1.6v-24.3zm209.8-.7c2.3-1.3 3.7-3.8 3.7-6.4V192c0-2.6-1.4-5.1-3.7-6.4l-60.9-35.4c-2.3-1.3-5.1-1.3-7.4 0l-61.3 35.4c-2.3 1.3-3.7 3.8-3.7 6.4v70.8c0 2.7 1.4 5.1 3.7 6.4l60.9 34.7c2.2 1.3 5 1.3 7.3 0l36.8-20.5c2.5-1.4 2.5-5 0-6.4L550 241.6c-1.2-.7-1.9-1.9-1.9-3.2v-22.2c0-1.3.7-2.5 1.9-3.2l19.2-11.1c1.1-.7 2.6-.7 3.7 0l19.2 11.1c1.1.7 1.9 1.9 1.9 3.2v17.4c0 2.8 3.1 4.6 5.6 3.2l36.7-21.3zM559 219c-.4.3-.7.7-.7 1.2v13.6c0 .5.3 1 .7 1.2l11.8 6.8c.4.3 1 .3 1.4 0L584 235c.4-.3.7-.7.7-1.2v-13.6c0-.5-.3-1-.7-1.2l-11.8-6.8c-.4-.3-1-.3-1.4 0L559 219zm-254.2 43.5v-70.4c0-2.6-1.6-5.1-3.9-6.4l-61.1-35.2c-2.1-1.2-5-1.4-7.4 0l-61.1 35.2c-2.3 1.3-3.9 3.7-3.9 6.4v70.4c0 2.8 1.9 5.2 4 6.4l61.2 35.2c2.4 1.4 5.2 1.3 7.4 0l61-35.2c1.8-1 3.1-2.7 3.6-4.7.1-.5.2-1.1.2-1.7zm-74.3-124.9l-.8.5h1.1l-.3-.5zm76.2 130.2l-.4-.7v.9l.4-.2z"
    ]
};
var $ef0249c5e48bf4e3$export$4176cb98e090fc09 = {
    prefix: "fab",
    iconName: "mix",
    icon: [
        448,
        512,
        [],
        "f3cb",
        "M0 64v348.9c0 56.2 88 58.1 88 0V174.3c7.9-52.9 88-50.4 88 6.5v175.3c0 57.9 96 58 96 0V240c5.3-54.7 88-52.5 88 4.3v23.8c0 59.9 88 56.6 88 0V64H0z"
    ]
};
var $ef0249c5e48bf4e3$export$7c80ad2689275b29 = {
    prefix: "fab",
    iconName: "steam",
    icon: [
        496,
        512,
        [],
        "f1b6",
        "M496 256c0 137-111.2 248-248.4 248-113.8 0-209.6-76.3-239-180.4l95.2 39.3c6.4 32.1 34.9 56.4 68.9 56.4 39.2 0 71.9-32.4 70.2-73.5l84.5-60.2c52.1 1.3 95.8-40.9 95.8-93.5 0-51.6-42-93.5-93.7-93.5s-93.7 42-93.7 93.5v1.2L176.6 279c-15.5-.9-30.7 3.4-43.5 12.1L0 236.1C10.2 108.4 117.1 8 247.6 8 384.8 8 496 119 496 256zM155.7 384.3l-30.5-12.6a52.79 52.79 0 0 0 27.2 25.8c26.9 11.2 57.8-1.6 69-28.4 5.4-13 5.5-27.3.1-40.3-5.4-13-15.5-23.2-28.5-28.6-12.9-5.4-26.7-5.2-38.9-.6l31.5 13c19.8 8.2 29.2 30.9 20.9 50.7-8.3 19.9-31 29.2-50.8 21zm173.8-129.9c-34.4 0-62.4-28-62.4-62.3s28-62.3 62.4-62.3 62.4 28 62.4 62.3-27.9 62.3-62.4 62.3zm.1-15.6c25.9 0 46.9-21 46.9-46.8 0-25.9-21-46.8-46.9-46.8s-46.9 21-46.9 46.8c.1 25.8 21.1 46.8 46.9 46.8z"
    ]
};
var $ef0249c5e48bf4e3$export$37af1170a8e0c21b = {
    prefix: "fab",
    iconName: "cc-apple-pay",
    icon: [
        576,
        512,
        [],
        "f416",
        "M302.2 218.4c0 17.2-10.5 27.1-29 27.1h-24.3v-54.2h24.4c18.4 0 28.9 9.8 28.9 27.1zm47.5 62.6c0 8.3 7.2 13.7 18.5 13.7 14.4 0 25.2-9.1 25.2-21.9v-7.7l-23.5 1.5c-13.3.9-20.2 5.8-20.2 14.4zM576 79v352c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V79c0-26.5 21.5-48 48-48h480c26.5 0 48 21.5 48 48zM127.8 197.2c8.4.7 16.8-4.2 22.1-10.4 5.2-6.4 8.6-15 7.7-23.7-7.4.3-16.6 4.9-21.9 11.3-4.8 5.5-8.9 14.4-7.9 22.8zm60.6 74.5c-.2-.2-19.6-7.6-19.8-30-.2-18.7 15.3-27.7 16-28.2-8.8-13-22.4-14.4-27.1-14.7-12.2-.7-22.6 6.9-28.4 6.9-5.9 0-14.7-6.6-24.3-6.4-12.5.2-24.2 7.3-30.5 18.6-13.1 22.6-3.4 56 9.3 74.4 6.2 9.1 13.7 19.1 23.5 18.7 9.3-.4 13-6 24.2-6 11.3 0 14.5 6 24.3 5.9 10.2-.2 16.5-9.1 22.8-18.2 6.9-10.4 9.8-20.4 10-21zm135.4-53.4c0-26.6-18.5-44.8-44.9-44.8h-51.2v136.4h21.2v-46.6h29.3c26.8 0 45.6-18.4 45.6-45zm90 23.7c0-19.7-15.8-32.4-40-32.4-22.5 0-39.1 12.9-39.7 30.5h19.1c1.6-8.4 9.4-13.9 20-13.9 13 0 20.2 6 20.2 17.2v7.5l-26.4 1.6c-24.6 1.5-37.9 11.6-37.9 29.1 0 17.7 13.7 29.4 33.4 29.4 13.3 0 25.6-6.7 31.2-17.4h.4V310h19.6v-68zM516 210.9h-21.5l-24.9 80.6h-.4l-24.9-80.6H422l35.9 99.3-1.9 6c-3.2 10.2-8.5 14.2-17.9 14.2-1.7 0-4.9-.2-6.2-.3v16.4c1.2.4 6.5.5 8.1.5 20.7 0 30.4-7.9 38.9-31.8L516 210.9z"
    ]
};
var $ef0249c5e48bf4e3$export$d271dfaa2c63aec5 = {
    prefix: "fab",
    iconName: "scribd",
    icon: [
        384,
        512,
        [],
        "f28a",
        "M42.3 252.7c-16.1-19-24.7-45.9-24.8-79.9 0-100.4 75.2-153.1 167.2-153.1 98.6-1.6 156.8 49 184.3 70.6l-50.5 72.1-37.3-24.6 26.9-38.6c-36.5-24-79.4-36.5-123-35.8-50.7-.8-111.7 27.2-111.7 76.2 0 18.7 11.2 20.7 28.6 15.6 23.3-5.3 41.9.6 55.8 14 26.4 24.3 23.2 67.6-.7 91.9-29.2 29.5-85.2 27.3-114.8-8.4zm317.7 5.9c-15.5-18.8-38.9-29.4-63.2-28.6-38.1-2-71.1 28-70.5 67.2-.7 16.8 6 33 18.4 44.3 14.1 13.9 33 19.7 56.3 14.4 17.4-5.1 28.6-3.1 28.6 15.6 0 4.3-.5 8.5-1.4 12.7-16.7 40.9-59.5 64.4-121.4 64.4-51.9.2-102.4-16.4-144.1-47.3l33.7-39.4-35.6-27.4L0 406.3l15.4 13.8c52.5 46.8 120.4 72.5 190.7 72.2 51.4 0 94.4-10.5 133.6-44.1 57.1-51.4 54.2-149.2 20.3-189.6z"
    ]
};
var $ef0249c5e48bf4e3$export$b30079bac9ebcf2a = {
    prefix: "fab",
    iconName: "debian",
    icon: [
        448,
        512,
        [],
        "e60b",
        "M248.2 .9c-4 .2-8.1 .4-11.4 1.6l-3.4-.5c5.4-.7 10.9-1.1 16.4-1.5c2.4-.2 4.8-.4 7.2-.6c-2.7 .6-5.7 .8-8.8 .9zm132 244.7c3-7.6 5.5-14 5.2-24.4l-4.3 9c4.4-13.2 4-27.1 3.6-40.4c-.2-6-.3-11.8 0-17.4l-1.8-.5c-1.5-45.2-40.6-93.1-75.3-109.4c-30-13.8-76.1-16.2-97.3-5.8c1.3-1.1 4.2-2 6.8-2.7c3.4-1 6.3-1.8 4.3-3c-19.2 1.9-24.9 5.5-31.1 9.4c-4.6 2.9-9.5 6-20.3 8.7c-3.5 3.4 1.7 2 5.8 .9c4.1-1.1 7.2-1.9-.1 2.4c-3.6 1-6.7 1.3-9.7 1.6c-8.3 .8-15.8 1.6-30.7 17c.8 1.3 3.5-.3 5.4-1.4c2.3-1.4 3.4-2-1.7 4.4c-19.1-2.4-60.3 43.7-69.1 59l4.6 .8c-3.2 8-6.8 14.8-10 20.8c-4.3 8.1-7.9 14.9-8.7 21.3c-.4 5.9-1.2 12.9-2 20.3c-3 27.4-6.8 61.3 3.8 73.6l-1.3 13c.6 1.2 1.1 2.3 1.6 3.5c1.2 2.5 2.3 5 3.9 7.4l-3 .2c7 22.2 10.8 22.5 15.1 22.9c4.4 .4 9.3 .9 18.7 24.2c-2.7-.9-5.5-1.9-9.4-7.2c-.5 4.1 5.8 16.3 13.1 25.8l-3.1 3.6c3.2 5.8 6.1 8.1 8.6 10l0 0c.8 .6 1.5 1.1 2.1 1.7c-11.9-6.5 3.2 13.7 11.9 25.2c2.5 3.4 4.5 6 5.1 7l2.4-4.2c-.3 6.1 4.3 13.9 13.1 24.7l7.3-.3c3 6 14 16.7 20.7 17.2l-4.4 5.8c8.1 2.6 10.3 4.3 12.7 6.2c2.6 2.1 5.4 4.3 16.1 8.1l-4.2-7.4c3.5 3 6.2 5.9 8.8 8.7c5.2 5.6 9.9 10.7 19.8 15.4c11.2 3.9 17.1 4.8 23.6 5.9c5.4 .8 11.2 1.8 20.8 4.5c-2.2-.1-4.4-.1-6.7-.2l0 0h0c-16.3-.4-34-.8-46.4-5.2C107.8 480.5 19.5 367.2 26 250.6c-.6-9.9-.3-20.9 0-30.7c.4-13.5 .7-24.8-1.6-28.3l1-3.1c5.3-17.4 11.7-38.2 23.8-62.8l-.1-.2 0-.1 0 0 0 0c.4 .4 3.4 3.4 8.8-5.8c1.3-2.9 2.5-5.8 3.8-8.8l0 0c2.5-6.1 5.1-12.3 8.4-17.9l2.6-.6c1.7-10.1 17-23.8 29.8-35.2l0 0c6.1-5.5 11.6-10.4 14.7-14.1l.7 4.4c17.1-16 45-27.7 66.1-36.6c4.8-2 9.3-3.9 13.3-5.7c-3.4 3.8 2.2 2.7 10 1c4.8-1 10.4-2.1 15.3-2.4c-1.3 .7-2.6 1.4-3.9 2.1l0 0 0 0c-2.7 1.4-5.4 2.8-8 4.6c8.3-2 11.9-1.4 16-.8c3.5 .6 7.3 1.2 14.6 .2c-5.6 .8-12.3 3-11.2 3.8c7.9 .9 12.8-.1 17.2-1c5.6-1.1 10.4-2.1 19.5 .9l-1-4.8c7.5 2.7 13.1 4.4 18 5.9c10 3 17.6 5.3 34.2 14.1c3.2 .2 5.3-.5 7.4-1.2c3.6-1.1 7-2.2 15.3 1.2c.5 .8 .7 1.5 1 2.1c1 2.6 1.7 4.6 14.6 12.2c1.8-.7-3.1-5.1-7-8.7l-.2-.1c32.3 17.3 67.5 54.1 78.2 93.6c-6-11.1-5.2-5.5-4.3 .5c.6 4 1.2 8.1-.2 7.5c4.5 12.1 8.1 24.5 10.4 37.4l-.8-2.9c-3.3-11.8-9.6-34.5-20-49.6c-.4 4.4-2.9 3.9-5.3 3.5c-3.3-.6-6.3-1.2-1.9 12.6c2.6 3.8 3.1 2.4 3.5 1.1c.5-1.5 .9-2.8 4.7 5.2c.1 4.3 1.1 8.5 2.2 13.3l0 0 0 0 0 0 0 0 0 0 0 0c.7 3 1.5 6.2 2.1 9.8c-1.1-.2-2.3-2.2-3.4-4.2l0 0 0 0c-1.4-2.4-2.8-4.7-3.7-3.2c2.4 11.5 6.5 17.4 8 18.3c-.3 .6-.6 .7-1.1 .7c-.8 0-1.8 .1-1.9 5.3c.7 13.7 3.3 12.5 5.3 11.6c.6-.3 1.2-.6 1.7-.4c-.6 2.5-1.6 5.1-2.7 7.9l0 0c-2.8 7.1-6 15.4-3.4 26.1c-.8-3.1-2.1-6.3-3.3-9.3l0 0 0 0c-.5-1.3-1.1-2.6-1.5-3.8c-.6 4.8-.3 8.2-.1 11.3c.4 5.3 .7 10-3 19.9c4.3-14.2 3.8-26.9-.2-20.8c1 11-3.8 20.5-8.1 29.1c-3.6 7.1-6.8 13.5-5.9 19.3l-5.2-7.1c-7.6 11-7 13.3-6.5 15.6c.5 1.9 1 3.8-3.4 10.8c1.7-2.9 1.3-3.6 1-4.2c-.4-.8-.7-1.5 1.7-5.1c-1.6 .1-5.5 3.9-10.1 8.5l0 0c-3.9 3.9-8.5 8.4-12.8 11.8c-37.5 30.1-82.3 34-125.6 17.8l0 0c.2-1-.2-2.1-3.1-4.1c-36.8-28.2-58.5-52.1-50.9-107.5c2.2-1.7 3.7-6.2 5.6-11.6c2.9-8.4 6.5-18.9 14.3-23.9c7.8-17.3 31.3-33.3 56.4-33.7c25.6-1.4 47.2 13.7 58.1 27.9c-19.8-18.4-52.1-24-79.7-10.4c-28.2 12.7-45 43.8-42.5 74.7c.3-.5 .7-.7 1-.9c.6-.5 1.2-.9 1.5-3.4c-.9 60.2 64.8 104.3 112.1 82l.6 1.3c12.7-3.5 15.9-6.5 20.3-10.7c2.2-2.1 4.7-4.5 9-7.4c-.3 .7-1.3 1.7-2.4 2.7c-2.2 2.1-4.6 4.5-1.6 4.6c5.3-1.4 20.1-14.8 30.2-23.8l0 0 0 0c1.6-1.4 3-2.7 4.3-3.9c2-4.3 1.6-5.7 1.3-7.1c-.4-1.6-.8-3.3 2.4-9.6l7.3-3.7c1-2.8 2-5.4 2.9-7.8l0 0zM233.1 321.9a.9 .9 0 1 0 -1.7 0 .9 .9 0 1 0 1.7 0zm-.2 .5l-.2 .4c-.3 .7-.6 1.4-.3 2.4c-12.2-5.7-23.4-14.3-32.6-24.9c4.9 7.1 10.1 14.1 17 19.5c-6.9-2.3-15.2-11.9-21.7-19.4l0 0 0 0c-4.3-5-7.9-9.1-9.7-9.5c19.8 35.5 80.5 62.3 112.3 49c-14.7 .5-33.4 .3-49.9-5.8c-6.3-3.2-14.6-9.6-14.9-11.8zM237.5 7c3.8 .6 7.3 1.2 6.7 2.1c5-1.1 6.1-2.1-9-2.5c.8 .1 1.6 .3 2.4 .4zm92.2 208.4c-1 3.9-1.8 1.4-2.7-1.2c-.5-1.5-1.1-3.1-1.7-3.4c1.4-5.8 5.4-10.7 4.4 4.6zm-6.8 21.2c-1.3 7.9-5 15.5-10.1 22.5c.2-2-1.2-2.4-2.6-2.8c-2.9-.8-5.9-1.6 5.6-16.1c-.5 2-2.3 4.9-4 7.7l0 0c-3.6 5.9-6.7 11 4 4.3l1-1.8c2.6-4.5 5-8.8 6-13.8zM280 276.6c-11.1-1.7-21.2-6-12.7-6.1c7.1 .6 14.1 .6 21-1.1c-2.5 2.4-5.2 4.8-8.3 7.2zM244.2 9.1l-.2 .4-3 .3 3.2-.7zm-69.5 273c3.7 7.2 6.5 11.7 9.1 15.9c2.3 3.7 4.4 7.1 6.8 11.7c-5.2-4.3-8.9-9.8-12.8-15.5c-1.4-2.1-2.8-4.2-4.4-6.2l1.2-5.9zm7.3-10c1.7 3.4 3.3 6.7 5.9 9.5l2.6 7.7-1.3-2.1c-3.2-5.3-6.3-10.6-8-16.7l.8 1.6zm239.1-41.2c-2.3 17.4-7.7 34.6-16 50.3c7.6-14.9 12.5-30.9 14.8-47.2l1.2-3.1zM35.4 109.6c0 .3 0 .5 .1 .7c0-.2 0-.5-.1-.7zm.1 .7c.3 1.2 1.4 .9 2.4 .6c1.9-.5 3.6-.9-.1 7.6c-2.4 1.7-3.8 2.8-4.6 3.4c-.6 .4-.8 .6-.8 .6c0 0 .1-.2 .3-.5c.8-1.4 3.4-5.5 2.9-11.7zm-10.2 42c-.7 3.7-1.5 7.9-3.4 13.9c.2-1.9 0-3.5-.2-4.9c-.4-3.4-.8-6.3 4.3-12.9c-.3 1.2-.5 2.5-.7 3.8z"
    ]
};
var $ef0249c5e48bf4e3$export$b2dcd141e150a391 = {
    prefix: "fab",
    iconName: "openid",
    icon: [
        448,
        512,
        [],
        "f19b",
        "M271.5 432l-68 32C88.5 453.7 0 392.5 0 318.2c0-71.5 82.5-131 191.7-144.3v43c-71.5 12.5-124 53-124 101.3 0 51 58.5 93.3 135.7 103v-340l68-33.2v384zM448 291l-131.3-28.5 36.8-20.7c-19.5-11.5-43.5-20-70-24.8v-43c46.2 5.5 87.7 19.5 120.3 39.3l35-19.8L448 291z"
    ]
};
var $ef0249c5e48bf4e3$export$792bea9ca32c60da = {
    prefix: "fab",
    iconName: "instalod",
    icon: [
        512,
        512,
        [],
        "e081",
        "M153.384,480H387.113L502.554,275.765,204.229,333.211ZM504.726,240.078,387.113,32H155.669L360.23,267.9ZM124.386,48.809,7.274,256,123.236,461.154,225.627,165.561Z"
    ]
};
var $ef0249c5e48bf4e3$export$fe553f3645c5aefa = {
    prefix: "fab",
    iconName: "expeditedssl",
    icon: [
        496,
        512,
        [],
        "f23e",
        "M248 43.4C130.6 43.4 35.4 138.6 35.4 256S130.6 468.6 248 468.6 460.6 373.4 460.6 256 365.4 43.4 248 43.4zm-97.4 132.9c0-53.7 43.7-97.4 97.4-97.4s97.4 43.7 97.4 97.4v26.6c0 5-3.9 8.9-8.9 8.9h-17.7c-5 0-8.9-3.9-8.9-8.9v-26.6c0-82.1-124-82.1-124 0v26.6c0 5-3.9 8.9-8.9 8.9h-17.7c-5 0-8.9-3.9-8.9-8.9v-26.6zM389.7 380c0 9.7-8 17.7-17.7 17.7H124c-9.7 0-17.7-8-17.7-17.7V238.3c0-9.7 8-17.7 17.7-17.7h248c9.7 0 17.7 8 17.7 17.7V380zm-248-137.3v132.9c0 2.5-1.9 4.4-4.4 4.4h-8.9c-2.5 0-4.4-1.9-4.4-4.4V242.7c0-2.5 1.9-4.4 4.4-4.4h8.9c2.5 0 4.4 1.9 4.4 4.4zm141.7 48.7c0 13-7.2 24.4-17.7 30.4v31.6c0 5-3.9 8.9-8.9 8.9h-17.7c-5 0-8.9-3.9-8.9-8.9v-31.6c-10.5-6.1-17.7-17.4-17.7-30.4 0-19.7 15.8-35.4 35.4-35.4s35.5 15.8 35.5 35.4zM248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zm0 478.3C121 486.3 17.7 383 17.7 256S121 25.7 248 25.7 478.3 129 478.3 256 375 486.3 248 486.3z"
    ]
};
var $ef0249c5e48bf4e3$export$23a4f18e8bd9f913 = {
    prefix: "fab",
    iconName: "sellcast",
    icon: [
        448,
        512,
        [],
        "f2da",
        "M353.4 32H94.7C42.6 32 0 74.6 0 126.6v258.7C0 437.4 42.6 480 94.7 480h258.7c52.1 0 94.7-42.6 94.7-94.6V126.6c0-52-42.6-94.6-94.7-94.6zm-50 316.4c-27.9 48.2-89.9 64.9-138.2 37.2-22.9 39.8-54.9 8.6-42.3-13.2l15.7-27.2c5.9-10.3 19.2-13.9 29.5-7.9 18.6 10.8-.1-.1 18.5 10.7 27.6 15.9 63.4 6.3 79.4-21.3 15.9-27.6 6.3-63.4-21.3-79.4-17.8-10.2-.6-.4-18.6-10.6-24.6-14.2-3.4-51.9 21.6-37.5 18.6 10.8-.1-.1 18.5 10.7 48.4 28 65.1 90.3 37.2 138.5zm21.8-208.8c-17 29.5-16.3 28.8-19 31.5-6.5 6.5-16.3 8.7-26.5 3.6-18.6-10.8.1.1-18.5-10.7-27.6-15.9-63.4-6.3-79.4 21.3s-6.3 63.4 21.3 79.4c0 0 18.5 10.6 18.6 10.6 24.6 14.2 3.4 51.9-21.6 37.5-18.6-10.8.1.1-18.5-10.7-48.2-27.8-64.9-90.1-37.1-138.4 27.9-48.2 89.9-64.9 138.2-37.2l4.8-8.4c14.3-24.9 52-3.3 37.7 21.5z"
    ]
};
var $ef0249c5e48bf4e3$export$58fc652e3c488143 = {
    prefix: "fab",
    iconName: "square-twitter",
    icon: [
        448,
        512,
        [
            "twitter-square"
        ],
        "f081",
        "M64 32C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64zM351.3 199.3v0c0 86.7-66 186.6-186.6 186.6c-37.2 0-71.7-10.8-100.7-29.4c5.3 .6 10.4 .8 15.8 .8c30.7 0 58.9-10.4 81.4-28c-28.8-.6-53-19.5-61.3-45.5c10.1 1.5 19.2 1.5 29.6-1.2c-30-6.1-52.5-32.5-52.5-64.4v-.8c8.7 4.9 18.9 7.9 29.6 8.3c-9-6-16.4-14.1-21.5-23.6s-7.8-20.2-7.7-31c0-12.2 3.2-23.4 8.9-33.1c32.3 39.8 80.8 65.8 135.2 68.6c-9.3-44.5 24-80.6 64-80.6c18.9 0 35.9 7.9 47.9 20.7c14.8-2.8 29-8.3 41.6-15.8c-4.9 15.2-15.2 28-28.8 36.1c13.2-1.4 26-5.1 37.8-10.2c-8.9 13.1-20.1 24.7-32.9 34c.2 2.8 .2 5.7 .2 8.5z"
    ]
};
var $ef0249c5e48bf4e3$export$270370f3feaf6b90 = $ef0249c5e48bf4e3$export$58fc652e3c488143;
var $ef0249c5e48bf4e3$export$f9a04980ef22b6b0 = {
    prefix: "fab",
    iconName: "r-project",
    icon: [
        581,
        512,
        [],
        "f4f7",
        "M581 226.6C581 119.1 450.9 32 290.5 32S0 119.1 0 226.6C0 322.4 103.3 402 239.4 418.1V480h99.1v-61.5c24.3-2.7 47.6-7.4 69.4-13.9L448 480h112l-67.4-113.7c54.5-35.4 88.4-84.9 88.4-139.7zm-466.8 14.5c0-73.5 98.9-133 220.8-133s211.9 40.7 211.9 133c0 50.1-26.5 85-70.3 106.4-2.4-1.6-4.7-2.9-6.4-3.7-10.2-5.2-27.8-10.5-27.8-10.5s86.6-6.4 86.6-92.7-90.6-87.9-90.6-87.9h-199V361c-74.1-21.5-125.2-67.1-125.2-119.9zm225.1 38.3v-55.6c57.8 0 87.8-6.8 87.8 27.3 0 36.5-38.2 28.3-87.8 28.3zm-.9 72.5H365c10.8 0 18.9 11.7 24 19.2-16.1 1.9-33 2.8-50.6 2.9v-22.1z"
    ]
};
var $ef0249c5e48bf4e3$export$fc15ee5b2eab0af4 = {
    prefix: "fab",
    iconName: "delicious",
    icon: [
        448,
        512,
        [],
        "f1a5",
        "M446.5 68c-.4-1.5-.9-3-1.4-4.5-.9-2.5-2-4.8-3.3-7.1-1.4-2.4-3-4.8-4.7-6.9-2.1-2.5-4.4-4.8-6.9-6.8-1.1-.9-2.2-1.7-3.3-2.5-1.3-.9-2.6-1.7-4-2.4-1.8-1-3.6-1.8-5.5-2.5-1.7-.7-3.5-1.3-5.4-1.7-3.8-1-7.9-1.5-12-1.5H48C21.5 32 0 53.5 0 80v352c0 4.1.5 8.2 1.5 12 2 7.7 5.8 14.6 11 20.3 1 1.1 2.1 2.2 3.3 3.3 5.7 5.2 12.6 9 20.3 11 3.8 1 7.9 1.5 12 1.5h352c26.5 0 48-21.5 48-48V80c-.1-4.1-.6-8.2-1.6-12zM416 432c0 8.8-7.2 16-16 16H224V256H32V80c0-8.8 7.2-16 16-16h176v192h192z"
    ]
};
var $ef0249c5e48bf4e3$export$1fa830857b3a4dc7 = {
    prefix: "fab",
    iconName: "freebsd",
    icon: [
        448,
        512,
        [],
        "f3a4",
        "M303.7 96.2c11.1-11.1 115.5-77 139.2-53.2 23.7 23.7-42.1 128.1-53.2 139.2-11.1 11.1-39.4.9-63.1-22.9-23.8-23.7-34.1-52-22.9-63.1zM109.9 68.1C73.6 47.5 22 24.6 5.6 41.1c-16.6 16.6 7.1 69.4 27.9 105.7 18.5-32.2 44.8-59.3 76.4-78.7zM406.7 174c3.3 11.3 2.7 20.7-2.7 26.1-20.3 20.3-87.5-27-109.3-70.1-18-32.3-11.1-53.4 14.9-48.7 5.7-3.6 12.3-7.6 19.6-11.6-29.8-15.5-63.6-24.3-99.5-24.3-119.1 0-215.6 96.5-215.6 215.6 0 119 96.5 215.6 215.6 215.6S445.3 380.1 445.3 261c0-38.4-10.1-74.5-27.7-105.8-3.9 7-7.6 13.3-10.9 18.8z"
    ]
};
var $ef0249c5e48bf4e3$export$3e0cc9b4555f8145 = {
    prefix: "fab",
    iconName: "vuejs",
    icon: [
        448,
        512,
        [],
        "f41f",
        "M356.9 64.3H280l-56 88.6-48-88.6H0L224 448 448 64.3h-91.1zm-301.2 32h53.8L224 294.5 338.4 96.3h53.8L224 384.5 55.7 96.3z"
    ]
};
var $ef0249c5e48bf4e3$export$233214294e90ff53 = {
    prefix: "fab",
    iconName: "accusoft",
    icon: [
        640,
        512,
        [],
        "f369",
        "M322.1 252v-1l-51.2-65.8s-12 1.6-25 15.1c-9 9.3-242.1 239.1-243.4 240.9-7 10 1.6 6.8 15.7 1.7.8 0 114.5-36.6 114.5-36.6.5-.6-.1-.1.6-.6-.4-5.1-.8-26.2-1-27.7-.6-5.2 2.2-6.9 7-8.9l92.6-33.8c.6-.8 88.5-81.7 90.2-83.3zm160.1 120.1c13.3 16.1 20.7 13.3 30.8 9.3 3.2-1.2 115.4-47.6 117.8-48.9 8-4.3-1.7-16.7-7.2-23.4-2.1-2.5-205.1-245.6-207.2-248.3-9.7-12.2-14.3-12.9-38.4-12.8-10.2 0-106.8.5-116.5.6-19.2.1-32.9-.3-19.2 16.9C250 75 476.5 365.2 482.2 372.1zm152.7 1.6c-2.3-.3-24.6-4.7-38-7.2 0 0-115 50.4-117.5 51.6-16 7.3-26.9-3.2-36.7-14.6l-57.1-74c-5.4-.9-60.4-9.6-65.3-9.3-3.1.2-9.6.8-14.4 2.9-4.9 2.1-145.2 52.8-150.2 54.7-5.1 2-11.4 3.6-11.1 7.6.2 2.5 2 2.6 4.6 3.5 2.7.8 300.9 67.6 308 69.1 15.6 3.3 38.5 10.5 53.6 1.7 2.1-1.2 123.8-76.4 125.8-77.8 5.4-4 4.3-6.8-1.7-8.2z"
    ]
};
var $ef0249c5e48bf4e3$export$d11e9e62a1442448 = {
    prefix: "fab",
    iconName: "ioxhost",
    icon: [
        640,
        512,
        [],
        "f208",
        "M616 160h-67.3C511.2 70.7 422.9 8 320 8 183 8 72 119 72 256c0 16.4 1.6 32.5 4.7 48H24c-13.3 0-24 10.8-24 24 0 13.3 10.7 24 24 24h67.3c37.5 89.3 125.8 152 228.7 152 137 0 248-111 248-248 0-16.4-1.6-32.5-4.7-48H616c13.3 0 24-10.8 24-24 0-13.3-10.7-24-24-24zm-96 96c0 110.5-89.5 200-200 200-75.7 0-141.6-42-175.5-104H424c13.3 0 24-10.8 24-24 0-13.3-10.7-24-24-24H125.8c-3.8-15.4-5.8-31.4-5.8-48 0-110.5 89.5-200 200-200 75.7 0 141.6 42 175.5 104H216c-13.3 0-24 10.8-24 24 0 13.3 10.7 24 24 24h298.2c3.8 15.4 5.8 31.4 5.8 48zm-304-24h208c13.3 0 24 10.7 24 24 0 13.2-10.7 24-24 24H216c-13.3 0-24-10.7-24-24 0-13.2 10.7-24 24-24z"
    ]
};
var $ef0249c5e48bf4e3$export$e6a0ac478bf76bf2 = {
    prefix: "fab",
    iconName: "fonticons-fi",
    icon: [
        384,
        512,
        [],
        "f3a2",
        "M114.4 224h92.4l-15.2 51.2h-76.4V433c0 8-2.8 9.2 4.4 10l59.6 5.6V483H0v-35.2l29.2-2.8c7.2-.8 9.2-3.2 9.2-10.8V278.4c0-3.2-4-3.2-8-3.2H0V224h38.4v-28.8c0-68 36.4-96 106-96 46.8 0 88.8 11.2 88.8 72.4l-69.6 8.4c.4-25.6-6-31.6-22.4-31.6-25.2 0-26 13.6-26 37.6v32c0 3.2-4.8 6-.8 6zM384 483H243.2v-34.4l28-3.6c7.2-.8 10.4-2.4 10.4-10V287c0-5.6-4-9.2-9.2-10.8l-33.2-8.8 9.2-40.4h110v208c0 8-3.6 8.8 4 10l21.6 3.6V483zm-30-347.2l12.4 45.6-10 10-42.8-22.8-42.8 22.8-10-10 12.4-45.6-30-36.4 4.8-10h38L307.2 51H320l21.2 38.4h38l4.8 13.2-30 33.2z"
    ]
};
var $ef0249c5e48bf4e3$export$500760921a1e1f4e = {
    prefix: "fab",
    iconName: "app-store",
    icon: [
        512,
        512,
        [],
        "f36f",
        "M255.9 120.9l9.1-15.7c5.6-9.8 18.1-13.1 27.9-7.5 9.8 5.6 13.1 18.1 7.5 27.9l-87.5 151.5h63.3c20.5 0 32 24.1 23.1 40.8H113.8c-11.3 0-20.4-9.1-20.4-20.4 0-11.3 9.1-20.4 20.4-20.4h52l66.6-115.4-20.8-36.1c-5.6-9.8-2.3-22.2 7.5-27.9 9.8-5.6 22.2-2.3 27.9 7.5l8.9 15.7zm-78.7 218l-19.6 34c-5.6 9.8-18.1 13.1-27.9 7.5-9.8-5.6-13.1-18.1-7.5-27.9l14.6-25.2c16.4-5.1 29.8-1.2 40.4 11.6zm168.9-61.7h53.1c11.3 0 20.4 9.1 20.4 20.4 0 11.3-9.1 20.4-20.4 20.4h-29.5l19.9 34.5c5.6 9.8 2.3 22.2-7.5 27.9-9.8 5.6-22.2 2.3-27.9-7.5-33.5-58.1-58.7-101.6-75.4-130.6-17.1-29.5-4.9-59.1 7.2-69.1 13.4 23 33.4 57.7 60.1 104zM256 8C119 8 8 119 8 256s111 248 248 248 248-111 248-248S393 8 256 8zm216 248c0 118.7-96.1 216-216 216-118.7 0-216-96.1-216-216 0-118.7 96.1-216 216-216 118.7 0 216 96.1 216 216z"
    ]
};
var $ef0249c5e48bf4e3$export$dd0d0d0b3b519db5 = {
    prefix: "fab",
    iconName: "cc-mastercard",
    icon: [
        576,
        512,
        [],
        "f1f1",
        "M482.9 410.3c0 6.8-4.6 11.7-11.2 11.7-6.8 0-11.2-5.2-11.2-11.7 0-6.5 4.4-11.7 11.2-11.7 6.6 0 11.2 5.2 11.2 11.7zm-310.8-11.7c-7.1 0-11.2 5.2-11.2 11.7 0 6.5 4.1 11.7 11.2 11.7 6.5 0 10.9-4.9 10.9-11.7-.1-6.5-4.4-11.7-10.9-11.7zm117.5-.3c-5.4 0-8.7 3.5-9.5 8.7h19.1c-.9-5.7-4.4-8.7-9.6-8.7zm107.8.3c-6.8 0-10.9 5.2-10.9 11.7 0 6.5 4.1 11.7 10.9 11.7 6.8 0 11.2-4.9 11.2-11.7 0-6.5-4.4-11.7-11.2-11.7zm105.9 26.1c0 .3.3.5.3 1.1 0 .3-.3.5-.3 1.1-.3.3-.3.5-.5.8-.3.3-.5.5-1.1.5-.3.3-.5.3-1.1.3-.3 0-.5 0-1.1-.3-.3 0-.5-.3-.8-.5-.3-.3-.5-.5-.5-.8-.3-.5-.3-.8-.3-1.1 0-.5 0-.8.3-1.1 0-.5.3-.8.5-1.1.3-.3.5-.3.8-.5.5-.3.8-.3 1.1-.3.5 0 .8 0 1.1.3.5.3.8.3 1.1.5s.2.6.5 1.1zm-2.2 1.4c.5 0 .5-.3.8-.3.3-.3.3-.5.3-.8 0-.3 0-.5-.3-.8-.3 0-.5-.3-1.1-.3h-1.6v3.5h.8V426h.3l1.1 1.4h.8l-1.1-1.3zM576 81v352c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V81c0-26.5 21.5-48 48-48h480c26.5 0 48 21.5 48 48zM64 220.6c0 76.5 62.1 138.5 138.5 138.5 27.2 0 53.9-8.2 76.5-23.1-72.9-59.3-72.4-171.2 0-230.5-22.6-15-49.3-23.1-76.5-23.1-76.4-.1-138.5 62-138.5 138.2zm224 108.8c70.5-55 70.2-162.2 0-217.5-70.2 55.3-70.5 162.6 0 217.5zm-142.3 76.3c0-8.7-5.7-14.4-14.7-14.7-4.6 0-9.5 1.4-12.8 6.5-2.4-4.1-6.5-6.5-12.2-6.5-3.8 0-7.6 1.4-10.6 5.4V392h-8.2v36.7h8.2c0-18.9-2.5-30.2 9-30.2 10.2 0 8.2 10.2 8.2 30.2h7.9c0-18.3-2.5-30.2 9-30.2 10.2 0 8.2 10 8.2 30.2h8.2v-23zm44.9-13.7h-7.9v4.4c-2.7-3.3-6.5-5.4-11.7-5.4-10.3 0-18.2 8.2-18.2 19.3 0 11.2 7.9 19.3 18.2 19.3 5.2 0 9-1.9 11.7-5.4v4.6h7.9V392zm40.5 25.6c0-15-22.9-8.2-22.9-15.2 0-5.7 11.9-4.8 18.5-1.1l3.3-6.5c-9.4-6.1-30.2-6-30.2 8.2 0 14.3 22.9 8.3 22.9 15 0 6.3-13.5 5.8-20.7.8l-3.5 6.3c11.2 7.6 32.6 6 32.6-7.5zm35.4 9.3l-2.2-6.8c-3.8 2.1-12.2 4.4-12.2-4.1v-16.6h13.1V392h-13.1v-11.2h-8.2V392h-7.6v7.3h7.6V416c0 17.6 17.3 14.4 22.6 10.9zm13.3-13.4h27.5c0-16.2-7.4-22.6-17.4-22.6-10.6 0-18.2 7.9-18.2 19.3 0 20.5 22.6 23.9 33.8 14.2l-3.8-6c-7.8 6.4-19.6 5.8-21.9-4.9zm59.1-21.5c-4.6-2-11.6-1.8-15.2 4.4V392h-8.2v36.7h8.2V408c0-11.6 9.5-10.1 12.8-8.4l2.4-7.6zm10.6 18.3c0-11.4 11.6-15.1 20.7-8.4l3.8-6.5c-11.6-9.1-32.7-4.1-32.7 15 0 19.8 22.4 23.8 32.7 15l-3.8-6.5c-9.2 6.5-20.7 2.6-20.7-8.6zm66.7-18.3H408v4.4c-8.3-11-29.9-4.8-29.9 13.9 0 19.2 22.4 24.7 29.9 13.9v4.6h8.2V392zm33.7 0c-2.4-1.2-11-2.9-15.2 4.4V392h-7.9v36.7h7.9V408c0-11 9-10.3 12.8-8.4l2.4-7.6zm40.3-14.9h-7.9v19.3c-8.2-10.9-29.9-5.1-29.9 13.9 0 19.4 22.5 24.6 29.9 13.9v4.6h7.9v-51.7zm7.6-75.1v4.6h.8V302h1.9v-.8h-4.6v.8h1.9zm6.6 123.8c0-.5 0-1.1-.3-1.6-.3-.3-.5-.8-.8-1.1-.3-.3-.8-.5-1.1-.8-.5 0-1.1-.3-1.6-.3-.3 0-.8.3-1.4.3-.5.3-.8.5-1.1.8-.5.3-.8.8-.8 1.1-.3.5-.3 1.1-.3 1.6 0 .3 0 .8.3 1.4 0 .3.3.8.8 1.1.3.3.5.5 1.1.8.5.3 1.1.3 1.4.3.5 0 1.1 0 1.6-.3.3-.3.8-.5 1.1-.8.3-.3.5-.8.8-1.1.3-.6.3-1.1.3-1.4zm3.2-124.7h-1.4l-1.6 3.5-1.6-3.5h-1.4v5.4h.8v-4.1l1.6 3.5h1.1l1.4-3.5v4.1h1.1v-5.4zm4.4-80.5c0-76.2-62.1-138.3-138.5-138.3-27.2 0-53.9 8.2-76.5 23.1 72.1 59.3 73.2 171.5 0 230.5 22.6 15 49.5 23.1 76.5 23.1 76.4.1 138.5-61.9 138.5-138.4z"
    ]
};
var $ef0249c5e48bf4e3$export$a0c8448ba3e387bc = {
    prefix: "fab",
    iconName: "itunes-note",
    icon: [
        384,
        512,
        [],
        "f3b5",
        "M381.9 388.2c-6.4 27.4-27.2 42.8-55.1 48-24.5 4.5-44.9 5.6-64.5-10.2-23.9-20.1-24.2-53.4-2.7-74.4 17-16.2 40.9-19.5 76.8-25.8 6-1.1 11.2-2.5 15.6-7.4 6.4-7.2 4.4-4.1 4.4-163.2 0-11.2-5.5-14.3-17-12.3-8.2 1.4-185.7 34.6-185.7 34.6-10.2 2.2-13.4 5.2-13.4 16.7 0 234.7 1.1 223.9-2.5 239.5-4.2 18.2-15.4 31.9-30.2 39.5-16.8 9.3-47.2 13.4-63.4 10.4-43.2-8.1-58.4-58-29.1-86.6 17-16.2 40.9-19.5 76.8-25.8 6-1.1 11.2-2.5 15.6-7.4 10.1-11.5 1.8-256.6 5.2-270.2.8-5.2 3-9.6 7.1-12.9 4.2-3.5 11.8-5.5 13.4-5.5 204-38.2 228.9-43.1 232.4-43.1 11.5-.8 18.1 6 18.1 17.6.2 344.5 1.1 326-1.8 338.5z"
    ]
};
var $ef0249c5e48bf4e3$export$36cd41563937ec03 = {
    prefix: "fab",
    iconName: "golang",
    icon: [
        640,
        512,
        [],
        "e40f",
        "M400.1 194.8C389.2 197.6 380.2 199.1 371 202.4C363.7 204.3 356.3 206.3 347.8 208.5L347.2 208.6C343 209.8 342.6 209.9 338.7 205.4C334 200.1 330.6 196.7 324.1 193.5C304.4 183.9 285.4 186.7 267.7 198.2C246.5 211.9 235.6 232.2 235.9 257.4C236.2 282.4 253.3 302.9 277.1 306.3C299.1 309.1 316.9 301.7 330.9 285.8C333 283.2 334.9 280.5 337 277.5V277.5L337 277.5C337.8 276.5 338.5 275.4 339.3 274.2H279.2C272.7 274.2 271.1 270.2 273.3 264.9C277.3 255.2 284.8 239 289.2 230.9C290.1 229.1 292.3 225.1 296.1 225.1H397.2C401.7 211.7 409 198.2 418.8 185.4C441.5 155.5 468.1 139.9 506 133.4C537.8 127.8 567.7 130.9 594.9 149.3C619.5 166.1 634.7 188.9 638.8 218.8C644.1 260.9 631.9 295.1 602.1 324.4C582.4 345.3 557.2 358.4 528.2 364.3C522.6 365.3 517.1 365.8 511.7 366.3C508.8 366.5 506 366.8 503.2 367.1C474.9 366.5 449 358.4 427.2 339.7C411.9 326.4 401.3 310.1 396.1 291.2C392.4 298.5 388.1 305.6 382.1 312.3C360.5 341.9 331.2 360.3 294.2 365.2C263.6 369.3 235.3 363.4 210.3 344.7C187.3 327.2 174.2 304.2 170.8 275.5C166.7 241.5 176.7 210.1 197.2 184.2C219.4 155.2 248.7 136.8 284.5 130.3C313.8 124.1 341.8 128.4 367.1 145.6C383.6 156.5 395.4 171.4 403.2 189.5C405.1 192.3 403.8 193.9 400.1 194.8zM48.3 200.4C47.05 200.4 46.74 199.8 47.36 198.8L53.91 190.4C54.53 189.5 56.09 188.9 57.34 188.9H168.6C169.8 188.9 170.1 189.8 169.5 190.7L164.2 198.8C163.6 199.8 162 200.7 161.1 200.7L48.3 200.4zM1.246 229.1C0 229.1-.3116 228.4 .3116 227.5L6.855 219.1C7.479 218.2 9.037 217.5 10.28 217.5H152.4C153.6 217.5 154.2 218.5 153.9 219.4L151.4 226.9C151.1 228.1 149.9 228.8 148.6 228.8L1.246 229.1zM75.72 255.9C75.1 256.8 75.41 257.7 76.65 257.7L144.6 258C145.5 258 146.8 257.1 146.8 255.9L147.4 248.4C147.4 247.1 146.8 246.2 145.5 246.2H83.2C81.95 246.2 80.71 247.1 80.08 248.1L75.72 255.9zM577.2 237.9C577 235.3 576.9 233.1 576.5 230.9C570.9 200.1 542.5 182.6 512.9 189.5C483.9 196 465.2 214.4 458.4 243.7C452.8 268 464.6 292.6 487 302.6C504.2 310.1 521.3 309.2 537.8 300.7C562.4 287.1 575.8 268 577.4 241.2C577.3 240 577.3 238.9 577.2 237.9z"
    ]
};
var $ef0249c5e48bf4e3$export$f06b8625c0ebb13a = {
    prefix: "fab",
    iconName: "kickstarter",
    icon: [
        448,
        512,
        [],
        "f3bb",
        "M400 480H48c-26.4 0-48-21.6-48-48V80c0-26.4 21.6-48 48-48h352c26.4 0 48 21.6 48 48v352c0 26.4-21.6 48-48 48zM199.6 178.5c0-30.7-17.6-45.1-39.7-45.1-25.8 0-40 19.8-40 44.5v154.8c0 25.8 13.7 45.6 40.5 45.6 21.5 0 39.2-14 39.2-45.6v-41.8l60.6 75.7c12.3 14.9 39 16.8 55.8 0 14.6-15.1 14.8-36.8 4-50.4l-49.1-62.8 40.5-58.7c9.4-13.5 9.5-34.5-5.6-49.1-16.4-15.9-44.6-17.3-61.4 7l-44.8 64.7v-38.8z"
    ]
};
var $ef0249c5e48bf4e3$export$fdcdacf548a335ed = {
    prefix: "fab",
    iconName: "grav",
    icon: [
        512,
        512,
        [],
        "f2d6",
        "M301.1 212c4.4 4.4 4.4 11.9 0 16.3l-9.7 9.7c-4.4 4.7-11.9 4.7-16.6 0l-10.5-10.5c-4.4-4.7-4.4-11.9 0-16.6l9.7-9.7c4.4-4.4 11.9-4.4 16.6 0l10.5 10.8zm-30.2-19.7c3-3 3-7.8 0-10.5-2.8-3-7.5-3-10.5 0-2.8 2.8-2.8 7.5 0 10.5 3.1 2.8 7.8 2.8 10.5 0zm-26 5.3c-3 2.8-3 7.5 0 10.2 2.8 3 7.5 3 10.5 0 2.8-2.8 2.8-7.5 0-10.2-3-3-7.7-3-10.5 0zm72.5-13.3c-19.9-14.4-33.8-43.2-11.9-68.1 21.6-24.9 40.7-17.2 59.8.8 11.9 11.3 29.3 24.9 17.2 48.2-12.5 23.5-45.1 33.2-65.1 19.1zm47.7-44.5c-8.9-10-23.3 6.9-15.5 16.1 7.4 9 32.1 2.4 15.5-16.1zM504 256c0 137-111 248-248 248S8 393 8 256 119 8 256 8s248 111 248 248zm-66.2 42.6c2.5-16.1-20.2-16.6-25.2-25.7-13.6-24.1-27.7-36.8-54.5-30.4 11.6-8 23.5-6.1 23.5-6.1.3-6.4 0-13-9.4-24.9 3.9-12.5.3-22.4.3-22.4 15.5-8.6 26.8-24.4 29.1-43.2 3.6-31-18.8-59.2-49.8-62.8-22.1-2.5-43.7 7.7-54.3 25.7-23.2 40.1 1.4 70.9 22.4 81.4-14.4-1.4-34.3-11.9-40.1-34.3-6.6-25.7 2.8-49.8 8.9-61.4 0 0-4.4-5.8-8-8.9 0 0-13.8 0-24.6 5.3 11.9-15.2 25.2-14.4 25.2-14.4 0-6.4-.6-14.9-3.6-21.6-5.4-11-23.8-12.9-31.7 2.8.1-.2.3-.4.4-.5-5 11.9-1.1 55.9 16.9 87.2-2.5 1.4-9.1 6.1-13 10-21.6 9.7-56.2 60.3-56.2 60.3-28.2 10.8-77.2 50.9-70.6 79.7.3 3 1.4 5.5 3 7.5-2.8 2.2-5.5 5-8.3 8.3-11.9 13.8-5.3 35.2 17.7 24.4 15.8-7.2 29.6-20.2 36.3-30.4 0 0-5.5-5-16.3-4.4 27.7-6.6 34.3-9.4 46.2-9.1 8 3.9 8-34.3 8-34.3 0-14.7-2.2-31-11.1-41.5 12.5 12.2 29.1 32.7 28 60.6-.8 18.3-15.2 23-15.2 23-9.1 16.6-43.2 65.9-30.4 106 0 0-9.7-14.9-10.2-22.1-17.4 19.4-46.5 52.3-24.6 64.5 26.6 14.7 108.8-88.6 126.2-142.3 34.6-20.8 55.4-47.3 63.9-65 22 43.5 95.3 94.5 101.1 59z"
    ]
};
var $ef0249c5e48bf4e3$export$75bd846ccb390b1e = {
    prefix: "fab",
    iconName: "weibo",
    icon: [
        512,
        512,
        [],
        "f18a",
        "M407 177.6c7.6-24-13.4-46.8-37.4-41.7-22 4.8-28.8-28.1-7.1-32.8 50.1-10.9 92.3 37.1 76.5 84.8-6.8 21.2-38.8 10.8-32-10.3zM214.8 446.7C108.5 446.7 0 395.3 0 310.4c0-44.3 28-95.4 76.3-143.7C176 67 279.5 65.8 249.9 161c-4 13.1 12.3 5.7 12.3 6 79.5-33.6 140.5-16.8 114 51.4-3.7 9.4 1.1 10.9 8.3 13.1 135.7 42.3 34.8 215.2-169.7 215.2zm143.7-146.3c-5.4-55.7-78.5-94-163.4-85.7-84.8 8.6-148.8 60.3-143.4 116s78.5 94 163.4 85.7c84.8-8.6 148.8-60.3 143.4-116zM347.9 35.1c-25.9 5.6-16.8 43.7 8.3 38.3 72.3-15.2 134.8 52.8 111.7 124-7.4 24.2 29.1 37 37.4 12 31.9-99.8-55.1-195.9-157.4-174.3zm-78.5 311c-17.1 38.8-66.8 60-109.1 46.3-40.8-13.1-58-53.4-40.3-89.7 17.7-35.4 63.1-55.4 103.4-45.1 42 10.8 63.1 50.2 46 88.5zm-86.3-30c-12.9-5.4-30 .3-38 12.9-8.3 12.9-4.3 28 8.6 34 13.1 6 30.8.3 39.1-12.9 8-13.1 3.7-28.3-9.7-34zm32.6-13.4c-5.1-1.7-11.4.6-14.3 5.4-2.9 5.1-1.4 10.6 3.7 12.9 5.1 2 11.7-.3 14.6-5.4 2.8-5.2 1.1-10.9-4-12.9z"
    ]
};
var $ef0249c5e48bf4e3$export$e1cced2e7ea20eff = {
    prefix: "fab",
    iconName: "uncharted",
    icon: [
        448,
        512,
        [],
        "e084",
        "M171.73,232.813A5.381,5.381,0,0,0,176.7,229.5,48.081,48.081,0,0,1,191.6,204.244c1.243-.828,1.657-2.484,1.657-4.141a4.22,4.22,0,0,0-2.071-3.312L74.429,128.473,148.958,85a9.941,9.941,0,0,0,4.968-8.281,9.108,9.108,0,0,0-4.968-8.281L126.6,55.6a9.748,9.748,0,0,0-9.523,0l-100.2,57.966a9.943,9.943,0,0,0-4.969,8.281V236.954a9.109,9.109,0,0,0,4.969,8.281L39.235,258.07a8.829,8.829,0,0,0,4.968,1.242,9.4,9.4,0,0,0,6.625-2.484,10.8,10.8,0,0,0,2.9-7.039V164.5L169.66,232.4A4.5,4.5,0,0,0,171.73,232.813ZM323.272,377.73a12.478,12.478,0,0,0-4.969,1.242l-74.528,43.062V287.882c0-2.9-2.9-5.8-6.211-4.555a53.036,53.036,0,0,1-28.984.414,4.86,4.86,0,0,0-6.21,4.555V421.619l-74.529-43.061a8.83,8.83,0,0,0-4.969-1.242,9.631,9.631,0,0,0-9.523,9.523v26.085a9.107,9.107,0,0,0,4.969,8.281l100.2,57.553A8.829,8.829,0,0,0,223.486,480a11.027,11.027,0,0,0,4.969-1.242l100.2-57.553a9.941,9.941,0,0,0,4.968-8.281V386.839C332.8,382.285,328.24,377.73,323.272,377.73ZM286.007,78a23,23,0,1,0-23-23A23,23,0,0,0,286.007,78Zm63.627-10.086a23,23,0,1,0,23,23A23,23,0,0,0,349.634,67.914ZM412.816,151.6a23,23,0,1,0-23-23A23,23,0,0,0,412.816,151.6Zm-63.182-9.2a23,23,0,1,0,23,23A23,23,0,0,0,349.634,142.4Zm-63.627,83.244a23,23,0,1,0-23-23A23,23,0,0,0,286.007,225.648Zm-62.074,36.358a23,23,0,1,0-23-23A23,23,0,0,0,223.933,262.006Zm188.883-82.358a23,23,0,1,0,23,23A23,23,0,0,0,412.816,179.648Zm0,72.272a23,23,0,1,0,23,23A23,23,0,0,0,412.816,251.92Z"
    ]
};
var $ef0249c5e48bf4e3$export$44a54556e145bddf = {
    prefix: "fab",
    iconName: "firstdraft",
    icon: [
        384,
        512,
        [],
        "f3a1",
        "M384 192h-64v128H192v128H0v-25.6h166.4v-128h128v-128H384V192zm-25.6 38.4v128h-128v128H64V512h192V384h128V230.4h-25.6zm25.6 192h-89.6V512H320v-64h64v-25.6zM0 0v384h128V256h128V128h128V0H0z"
    ]
};
var $ef0249c5e48bf4e3$export$1082b39fc1076b43 = {
    prefix: "fab",
    iconName: "square-youtube",
    icon: [
        448,
        512,
        [
            61798,
            "youtube-square"
        ],
        "f431",
        "M186.8 202.1l95.2 54.1-95.2 54.1V202.1zM448 80v352c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V80c0-26.5 21.5-48 48-48h352c26.5 0 48 21.5 48 48zm-42 176.3s0-59.6-7.6-88.2c-4.2-15.8-16.5-28.2-32.2-32.4C337.9 128 224 128 224 128s-113.9 0-142.2 7.7c-15.7 4.2-28 16.6-32.2 32.4-7.6 28.5-7.6 88.2-7.6 88.2s0 59.6 7.6 88.2c4.2 15.8 16.5 27.7 32.2 31.9C110.1 384 224 384 224 384s113.9 0 142.2-7.7c15.7-4.2 28-16.1 32.2-31.9 7.6-28.5 7.6-88.1 7.6-88.1z"
    ]
};
var $ef0249c5e48bf4e3$export$8992da42b645c563 = $ef0249c5e48bf4e3$export$1082b39fc1076b43;
var $ef0249c5e48bf4e3$export$6657c749288c4042 = {
    prefix: "fab",
    iconName: "wikipedia-w",
    icon: [
        640,
        512,
        [],
        "f266",
        "M640 51.2l-.3 12.2c-28.1.8-45 15.8-55.8 40.3-25 57.8-103.3 240-155.3 358.6H415l-81.9-193.1c-32.5 63.6-68.3 130-99.2 193.1-.3.3-15 0-15-.3C172 352.3 122.8 243.4 75.8 133.4 64.4 106.7 26.4 63.4.2 63.7c0-3.1-.3-10-.3-14.2h161.9v13.9c-19.2 1.1-52.8 13.3-43.3 34.2 21.9 49.7 103.6 240.3 125.6 288.6 15-29.7 57.8-109.2 75.3-142.8-13.9-28.3-58.6-133.9-72.8-160-9.7-17.8-36.1-19.4-55.8-19.7V49.8l142.5.3v13.1c-19.4.6-38.1 7.8-29.4 26.1 18.9 40 30.6 68.1 48.1 104.7 5.6-10.8 34.7-69.4 48.1-100.8 8.9-20.6-3.9-28.6-38.6-29.4.3-3.6 0-10.3.3-13.6 44.4-.3 111.1-.3 123.1-.6v13.6c-22.5.8-45.8 12.8-58.1 31.7l-59.2 122.8c6.4 16.1 63.3 142.8 69.2 156.7L559.2 91.8c-8.6-23.1-36.4-28.1-47.2-28.3V49.6l127.8 1.1.2.5z"
    ]
};
var $ef0249c5e48bf4e3$export$66f88c21efa6f12d = {
    prefix: "fab",
    iconName: "wpressr",
    icon: [
        496,
        512,
        [
            "rendact"
        ],
        "f3e4",
        "M248 8C111.03 8 0 119.03 0 256s111.03 248 248 248 248-111.03 248-248S384.97 8 248 8zm171.33 158.6c-15.18 34.51-30.37 69.02-45.63 103.5-2.44 5.51-6.89 8.24-12.97 8.24-23.02-.01-46.03.06-69.05-.05-5.12-.03-8.25 1.89-10.34 6.72-10.19 23.56-20.63 47-30.95 70.5-1.54 3.51-4.06 5.29-7.92 5.29-45.94-.01-91.87-.02-137.81 0-3.13 0-5.63-1.15-7.72-3.45-11.21-12.33-22.46-24.63-33.68-36.94-2.69-2.95-2.79-6.18-1.21-9.73 8.66-19.54 17.27-39.1 25.89-58.66 12.93-29.35 25.89-58.69 38.75-88.08 1.7-3.88 4.28-5.68 8.54-5.65 14.24.1 28.48.02 42.72.05 6.24.01 9.2 4.84 6.66 10.59-13.6 30.77-27.17 61.55-40.74 92.33-5.72 12.99-11.42 25.99-17.09 39-3.91 8.95 7.08 11.97 10.95 5.6.23-.37-1.42 4.18 30.01-67.69 1.36-3.1 3.41-4.4 6.77-4.39 15.21.08 30.43.02 45.64.04 5.56.01 7.91 3.64 5.66 8.75-8.33 18.96-16.71 37.9-24.98 56.89-4.98 11.43 8.08 12.49 11.28 5.33.04-.08 27.89-63.33 32.19-73.16 2.02-4.61 5.44-6.51 10.35-6.5 26.43.05 52.86 0 79.29.05 12.44.02 13.93-13.65 3.9-13.64-25.26.03-50.52.02-75.78.02-6.27 0-7.84-2.47-5.27-8.27 5.78-13.06 11.59-26.11 17.3-39.21 1.73-3.96 4.52-5.79 8.84-5.78 23.09.06 25.98.02 130.78.03 6.08-.01 8.03 2.79 5.62 8.27z"
    ]
};
var $ef0249c5e48bf4e3$export$d06b08e37a8aaaec = $ef0249c5e48bf4e3$export$66f88c21efa6f12d;
var $ef0249c5e48bf4e3$export$65f66dc47afb97bd = {
    prefix: "fab",
    iconName: "angellist",
    icon: [
        448,
        512,
        [],
        "f209",
        "M347.1 215.4c11.7-32.6 45.4-126.9 45.4-157.1 0-26.6-15.7-48.9-43.7-48.9-44.6 0-84.6 131.7-97.1 163.1C242 144 196.6 0 156.6 0c-31.1 0-45.7 22.9-45.7 51.7 0 35.3 34.2 126.8 46.6 162-6.3-2.3-13.1-4.3-20-4.3-23.4 0-48.3 29.1-48.3 52.6 0 8.9 4.9 21.4 8 29.7-36.9 10-51.1 34.6-51.1 71.7C46 435.6 114.4 512 210.6 512c118 0 191.4-88.6 191.4-202.9 0-43.1-6.9-82-54.9-93.7zM311.7 108c4-12.3 21.1-64.3 37.1-64.3 8.6 0 10.9 8.9 10.9 16 0 19.1-38.6 124.6-47.1 148l-34-6 33.1-93.7zM142.3 48.3c0-11.9 14.5-45.7 46.3 47.1l34.6 100.3c-15.6-1.3-27.7-3-35.4 1.4-10.9-28.8-45.5-119.7-45.5-148.8zM140 244c29.3 0 67.1 94.6 67.1 107.4 0 5.1-4.9 11.4-10.6 11.4-20.9 0-76.9-76.9-76.9-97.7.1-7.7 12.7-21.1 20.4-21.1zm184.3 186.3c-29.1 32-66.3 48.6-109.7 48.6-59.4 0-106.3-32.6-128.9-88.3-17.1-43.4 3.8-68.3 20.6-68.3 11.4 0 54.3 60.3 54.3 73.1 0 4.9-7.7 8.3-11.7 8.3-16.1 0-22.4-15.5-51.1-51.4-29.7 29.7 20.5 86.9 58.3 86.9 26.1 0 43.1-24.2 38-42 3.7 0 8.3.3 11.7-.6 1.1 27.1 9.1 59.4 41.7 61.7 0-.9 2-7.1 2-7.4 0-17.4-10.6-32.6-10.6-50.3 0-28.3 21.7-55.7 43.7-71.7 8-6 17.7-9.7 27.1-13.1 9.7-3.7 20-8 27.4-15.4-1.1-11.2-5.7-21.1-16.9-21.1-27.7 0-120.6 4-120.6-39.7 0-6.7.1-13.1 17.4-13.1 32.3 0 114.3 8 138.3 29.1 18.1 16.1 24.3 113.2-31 174.7zm-98.6-126c9.7 3.1 19.7 4 29.7 6-7.4 5.4-14 12-20.3 19.1-2.8-8.5-6.2-16.8-9.4-25.1z"
    ]
};
var $ef0249c5e48bf4e3$export$ba5a2dfe23db8bb6 = {
    prefix: "fab",
    iconName: "galactic-republic",
    icon: [
        496,
        512,
        [],
        "f50c",
        "M248 504C111.25 504 0 392.75 0 256S111.25 8 248 8s248 111.25 248 248-111.25 248-248 248zm0-479.47C120.37 24.53 16.53 128.37 16.53 256S120.37 487.47 248 487.47 479.47 383.63 479.47 256 375.63 24.53 248 24.53zm27.62 21.81v24.62a185.933 185.933 0 0 1 83.57 34.54l17.39-17.36c-28.75-22.06-63.3-36.89-100.96-41.8zm-55.37.07c-37.64 4.94-72.16 19.8-100.88 41.85l17.28 17.36h.08c24.07-17.84 52.55-30.06 83.52-34.67V46.41zm12.25 50.17v82.87c-10.04 2.03-19.42 5.94-27.67 11.42l-58.62-58.59-21.93 21.93 58.67 58.67c-5.47 8.23-9.45 17.59-11.47 27.62h-82.9v31h82.9c2.02 10.02 6.01 19.31 11.47 27.54l-58.67 58.69 21.93 21.93 58.62-58.62a77.873 77.873 0 0 0 27.67 11.47v82.9h31v-82.9c10.05-2.03 19.37-6.06 27.62-11.55l58.67 58.69 21.93-21.93-58.67-58.69c5.46-8.23 9.47-17.52 11.5-27.54h82.87v-31h-82.87c-2.02-10.02-6.03-19.38-11.5-27.62l58.67-58.67-21.93-21.93-58.67 58.67c-8.25-5.49-17.57-9.47-27.62-11.5V96.58h-31zm183.24 30.72l-17.36 17.36a186.337 186.337 0 0 1 34.67 83.67h24.62c-4.95-37.69-19.83-72.29-41.93-101.03zm-335.55.13c-22.06 28.72-36.91 63.26-41.85 100.91h24.65c4.6-30.96 16.76-59.45 34.59-83.52l-17.39-17.39zM38.34 283.67c4.92 37.64 19.75 72.18 41.8 100.9l17.36-17.39c-17.81-24.07-29.92-52.57-34.51-83.52H38.34zm394.7 0c-4.61 30.99-16.8 59.5-34.67 83.6l17.36 17.36c22.08-28.74 36.98-63.29 41.93-100.96h-24.62zM136.66 406.38l-17.36 17.36c28.73 22.09 63.3 36.98 100.96 41.93v-24.64c-30.99-4.63-59.53-16.79-83.6-34.65zm222.53.05c-24.09 17.84-52.58 30.08-83.57 34.67v24.57c37.67-4.92 72.21-19.79 100.96-41.85l-17.31-17.39h-.08z"
    ]
};
var $ef0249c5e48bf4e3$export$d637dd7b404459cf = {
    prefix: "fab",
    iconName: "nfc-directional",
    icon: [
        512,
        512,
        [],
        "e530",
        "M211.8 488.6C213.4 491.1 213.9 494.2 213.2 497.1C212.6 500 210.8 502.6 208.3 504.2C205.7 505.8 202.7 506.3 199.7 505.7C138.3 491.8 84.1 455.8 47.53 404.5C10.97 353.2-5.395 290.3 1.57 227.7C8.536 165 38.34 107.2 85.29 65.21C132.2 23.2 193-.0131 256 0C257.5 0 258.1 .2931 260.3 .8627C261.7 1.432 262.1 2.267 264 3.319C265.1 4.371 265.9 5.619 266.5 6.993C267 8.367 267.3 9.839 267.3 11.32V112.3L291.8 86.39C292.8 85.31 294 84.44 295.4 83.84C296.7 83.23 298.2 82.9 299.7 82.86C301.2 82.81 302.6 83.06 304 83.59C305.4 84.12 306.7 84.92 307.8 85.94C308.8 86.96 309.7 88.18 310.3 89.54C310.9 90.89 311.3 92.35 311.3 93.84C311.3 95.32 311.1 96.8 310.6 98.18C310 99.57 309.2 100.8 308.2 101.9L264.2 148.5C263.1 149.6 261.9 150.5 260.5 151.1C259 151.7 257.5 152 255.1 152C254.5 152 252.9 151.7 251.5 151.1C250.1 150.5 248.8 149.6 247.8 148.5L203.7 101.9C201.7 99.74 200.6 96.83 200.7 93.84C200.7 90.84 202 87.1 204.2 85.94C206.4 83.88 209.3 82.77 212.3 82.86C215.3 82.94 218.1 84.21 220.2 86.39L244.7 112.4V22.89C188.3 25.64 134.9 48.73 94.23 87.87C53.58 127 28.49 179.6 23.61 235.8C18.73 292 34.38 348.1 67.68 393.7C100.1 439.2 149.7 471.2 204.7 483.6C207.6 484.3 210.2 486.1 211.8 488.6L211.8 488.6zM171.4 126.1C170.6 127.4 169.5 128.5 168.3 129.3C147.8 143.2 131.1 161.9 119.5 183.8C107.9 205.7 101.8 230.1 101.8 254.9C101.8 279.7 107.9 304.1 119.5 325.1C131.1 347.9 147.8 366.6 168.3 380.5C170.8 382.2 172.5 384.8 173 387.8C173.6 390.7 172.1 393.8 171.3 396.2C169.6 398.7 166.1 400.4 164 400.1C161.1 401.5 158 400.9 155.6 399.2C132 383.2 112.8 361.7 99.46 336.5C86.15 311.4 79.19 283.4 79.19 254.9C79.19 226.5 86.15 198.4 99.46 173.3C112.8 148.1 132 126.6 155.6 110.6C156.8 109.8 158.2 109.2 159.6 108.8C161.1 108.5 162.6 108.5 164.1 108.8C165.5 109 166.9 109.6 168.2 110.4C169.5 111.2 170.5 112.3 171.4 113.5C172.2 114.7 172.8 116.1 173.1 117.6C173.4 119.1 173.4 120.6 173.1 122C172.8 123.5 172.3 124.9 171.4 126.1H171.4zM340.9 383.5C341.7 382.3 342.8 381.2 343.1 380.4V380.3C364.4 366.3 381.1 347.6 392.7 325.7C404.2 303.9 410.2 279.5 410.2 254.8C410.2 230.1 404.2 205.7 392.7 183.8C381.1 161.1 364.4 143.3 343.1 129.3C342.8 128.5 341.7 127.4 340.9 126.2C340.1 124.9 339.5 123.5 339.3 122.1C338.1 120.6 339 119.1 339.3 117.7C339.6 116.2 340.2 114.8 341 113.6C341.9 112.4 342.1 111.3 344.2 110.5C345.4 109.7 346.8 109.2 348.3 108.9C349.8 108.6 351.2 108.6 352.7 108.9C354.2 109.2 355.5 109.8 356.8 110.7C380.2 126.7 399.5 148.2 412.7 173.3C426 198.4 432.1 226.4 432.1 254.8C432.1 283.3 426 311.3 412.7 336.4C399.5 361.5 380.2 383 356.8 399C355.5 399.9 354.2 400.5 352.7 400.8C351.2 401.1 349.8 401.1 348.3 400.8C346.8 400.5 345.4 399.1 344.2 399.2C342.1 398.4 341.9 397.3 341 396.1C340.2 394.9 339.6 393.5 339.3 392C339 390.6 338.1 389.1 339.3 387.6C339.5 386.2 340.1 384.8 340.9 383.5V383.5zM312.3 6.307C368.5 19.04 418.7 50.28 455 95.01C485.4 132.6 504.6 178 510.3 226C515.9 274 507.9 322.7 487.1 366.3C466.2 409.9 433.5 446.8 392.6 472.6C351.7 498.3 304.4 512 256 512C254.5 512 253.1 511.7 251.7 511.1C250.3 510.6 249.1 509.7 248 508.7C246.1 507.6 246.1 506.4 245.6 505C245 503.6 244.7 502.2 244.7 500.7V401.5L220.2 427.5C218.1 429.7 215.3 430.1 212.3 431.1C209.3 431.2 206.4 430 204.2 427.1C202 425.9 200.7 423.1 200.7 420.1C200.6 417.1 201.7 414.2 203.7 412L247.8 365.4C249.1 363.2 252.9 362 255.1 362C259.1 362 262 363.2 264.2 365.4L308.2 412C310.3 414.2 311.4 417.1 311.3 420.1C311.2 423.1 309.9 425.9 307.8 427.1C305.6 430 302.7 431.2 299.7 431.1C296.7 430.1 293.8 429.7 291.8 427.5L267.3 401.6V489.1C323.7 486.3 377.1 463.3 417.8 424.1C458.5 384.1 483.6 332.4 488.5 276.2C493.3 219.1 477.7 163.9 444.4 118.3C411.1 72.75 362.4 40.79 307.4 28.36C305.9 28.03 304.6 27.42 303.3 26.57C302.1 25.71 301.1 24.63 300.3 23.37C299.5 22.12 298.1 20.72 298.7 19.26C298.5 17.8 298.5 16.3 298.8 14.85C299.2 13.41 299.8 12.04 300.6 10.82C301.5 9.61 302.6 8.577 303.8 7.784C305.1 6.99 306.5 6.451 307.9 6.198C309.4 5.945 310.9 5.982 312.3 6.307L312.3 6.307zM353.1 256.1C353.1 287.5 335.6 317.2 303.8 339.6C301.7 341.1 299 341.9 296.4 341.6C293.7 341.4 291.2 340.3 289.4 338.4L219.3 268.6C217.1 266.5 215.1 263.6 215.9 260.6C215.9 257.6 217.1 254.7 219.2 252.6C221.4 250.5 224.2 249.3 227.2 249.3C230.2 249.3 233.1 250.5 235.2 252.6L298.3 315.4C319.1 298.3 330.5 277.5 330.5 256.1C330.5 232.2 316.4 209.1 290.8 191C288.3 189.3 286.7 186.7 286.2 183.7C285.7 180.8 286.3 177.7 288.1 175.3C289.8 172.8 292.4 171.2 295.4 170.7C298.3 170.2 301.4 170.8 303.8 172.6C335.6 195 353.1 224.7 353.1 256.1V256.1zM216.7 341.5C213.7 342 210.7 341.3 208.2 339.6C176.5 317.2 158.1 287.5 158.1 256.1C158.1 224.7 176.5 195 208.2 172.6C210.4 171 213.1 170.3 215.7 170.5C218.4 170.8 220.8 171.9 222.7 173.8L292.8 243.6C294.9 245.7 296.1 248.6 296.1 251.6C296.1 254.6 294.1 257.4 292.8 259.6C290.7 261.7 287.8 262.9 284.9 262.9C281.9 262.9 278.1 261.7 276.9 259.6L213.8 196.7C192.9 214 181.6 234.7 181.6 256.1C181.6 279.1 195.7 303.1 221.3 321.1C223.7 322.9 225.4 325.5 225.9 328.5C226.4 331.4 225.7 334.4 224 336.9C222.3 339.3 219.6 341 216.7 341.5L216.7 341.5z"
    ]
};
var $ef0249c5e48bf4e3$export$78370b1b91348c9e = {
    prefix: "fab",
    iconName: "skype",
    icon: [
        448,
        512,
        [],
        "f17e",
        "M424.7 299.8c2.9-14 4.7-28.9 4.7-43.8 0-113.5-91.9-205.3-205.3-205.3-14.9 0-29.7 1.7-43.8 4.7C161.3 40.7 137.7 32 112 32 50.2 32 0 82.2 0 144c0 25.7 8.7 49.3 23.3 68.2-2.9 14-4.7 28.9-4.7 43.8 0 113.5 91.9 205.3 205.3 205.3 14.9 0 29.7-1.7 43.8-4.7 19 14.6 42.6 23.3 68.2 23.3 61.8 0 112-50.2 112-112 .1-25.6-8.6-49.2-23.2-68.1zm-194.6 91.5c-65.6 0-120.5-29.2-120.5-65 0-16 9-30.6 29.5-30.6 31.2 0 34.1 44.9 88.1 44.9 25.7 0 42.3-11.4 42.3-26.3 0-18.7-16-21.6-42-28-62.5-15.4-117.8-22-117.8-87.2 0-59.2 58.6-81.1 109.1-81.1 55.1 0 110.8 21.9 110.8 55.4 0 16.9-11.4 31.8-30.3 31.8-28.3 0-29.2-33.5-75-33.5-25.7 0-42 7-42 22.5 0 19.8 20.8 21.8 69.1 33 41.4 9.3 90.7 26.8 90.7 77.6 0 59.1-57.1 86.5-112 86.5z"
    ]
};
var $ef0249c5e48bf4e3$export$ae307621d0877ba2 = {
    prefix: "fab",
    iconName: "joget",
    icon: [
        496,
        512,
        [],
        "f3b7",
        "M378.1 45C337.6 19.9 292.6 8 248.2 8 165 8 83.8 49.9 36.9 125.9c-71.9 116.6-35.6 269.3 81 341.2s269.3 35.6 341.2-80.9c71.9-116.6 35.6-269.4-81-341.2zm51.8 323.2c-40.4 65.5-110.4 101.5-182 101.5-6.8 0-13.6-.4-20.4-1-9-13.6-19.9-33.3-23.7-42.4-5.7-13.7-27.2-45.6 31.2-67.1 51.7-19.1 176.7-16.5 208.8-17.6-4 9-8.6 17.9-13.9 26.6zm-200.8-86.3c-55.5-1.4-81.7-20.8-58.5-48.2s51.1-40.7 68.9-51.2c17.9-10.5 27.3-33.7-23.6-29.7C87.3 161.5 48.6 252.1 37.6 293c-8.8-49.7-.1-102.7 28.5-149.1C128 43.4 259.6 12.2 360.1 74.1c74.8 46.1 111.2 130.9 99.3 212.7-24.9-.5-179.3-3.6-230.3-4.9zm183.8-54.8c-22.7-6-57 11.3-86.7 27.2-29.7 15.8-31.1 8.2-31.1 8.2s40.2-28.1 50.7-34.5 31.9-14 13.4-24.6c-3.2-1.8-6.7-2.7-10.4-2.7-17.8 0-41.5 18.7-67.5 35.6-31.5 20.5-65.3 31.3-65.3 31.3l169.5-1.6 46.5-23.4s3.6-9.5-19.1-15.5z"
    ]
};
var $ef0249c5e48bf4e3$export$8cf9f3ca16e668b0 = {
    prefix: "fab",
    iconName: "fedora",
    icon: [
        448,
        512,
        [],
        "f798",
        "M.0413 255.8C.1219 132.2 100.3 32 224 32C347.7 32 448 132.3 448 256C448 379.7 347.8 479.9 224.1 480H50.93C22.84 480 .0832 457.3 .0416 429.2H0V255.8H.0413zM342.6 192.7C342.6 153 307 124.2 269.4 124.2C234.5 124.2 203.6 150.5 199.3 184.1C199.1 187.9 198.9 189.1 198.9 192.6C198.8 213.7 198.9 235.4 198.1 257C199 283.1 199.1 309.1 198.1 333.6C198.1 360.7 178.7 379.1 153.4 379.1C128.1 379.1 107.6 358.9 107.6 333.6C108.1 305.9 130.2 288.3 156.1 287.5H156.3L182.6 287.3V250L156.3 250.2C109.2 249.8 71.72 286.7 70.36 333.6C70.36 379.2 107.9 416.5 153.4 416.5C196.4 416.5 232.1 382.9 236 340.9L236.2 287.4L268.8 287.1C294.1 287.3 293.8 249.3 268.6 249.8L236.2 250.1C236.2 243.7 236.3 237.3 236.3 230.9C236.4 218.2 236.4 205.5 236.2 192.7C236.3 176.2 252 161.5 269.4 161.5C286.9 161.5 305.3 170.2 305.3 192.7C305.3 195.9 305.2 197.8 305 199C303.1 209.5 310.2 219.4 320.7 220.9C331.3 222.4 340.9 214.8 341.9 204.3C342.5 200.1 342.6 196.4 342.6 192.7H342.6z"
    ]
};
var $ef0249c5e48bf4e3$export$4823078d958b443a = {
    prefix: "fab",
    iconName: "stripe-s",
    icon: [
        384,
        512,
        [],
        "f42a",
        "M155.3 154.6c0-22.3 18.6-30.9 48.4-30.9 43.4 0 98.5 13.3 141.9 36.7V26.1C298.3 7.2 251.1 0 203.8 0 88.1 0 11 60.4 11 161.4c0 157.9 216.8 132.3 216.8 200.4 0 26.4-22.9 34.9-54.7 34.9-47.2 0-108.2-19.5-156.1-45.5v128.5a396.09 396.09 0 0 0 156 32.4c118.6 0 200.3-51 200.3-153.6 0-170.2-218-139.7-218-203.9z"
    ]
};
var $ef0249c5e48bf4e3$export$75b94550e27ccec5 = {
    prefix: "fab",
    iconName: "meta",
    icon: [
        640,
        512,
        [],
        "e49b",
        "M640 317.9C640 409.2 600.6 466.4 529.7 466.4C467.1 466.4 433.9 431.8 372.8 329.8L341.4 277.2C333.1 264.7 326.9 253 320.2 242.2C300.1 276 273.1 325.2 273.1 325.2C206.1 441.8 168.5 466.4 116.2 466.4C43.42 466.4 0 409.1 0 320.5C0 177.5 79.78 42.4 183.9 42.4C234.1 42.4 277.7 67.08 328.7 131.9C365.8 81.8 406.8 42.4 459.3 42.4C558.4 42.4 640 168.1 640 317.9H640zM287.4 192.2C244.5 130.1 216.5 111.7 183 111.7C121.1 111.7 69.22 217.8 69.22 321.7C69.22 370.2 87.7 397.4 118.8 397.4C149 397.4 167.8 378.4 222 293.6C222 293.6 246.7 254.5 287.4 192.2V192.2zM531.2 397.4C563.4 397.4 578.1 369.9 578.1 322.5C578.1 198.3 523.8 97.08 454.9 97.08C421.7 97.08 393.8 123 360 175.1C369.4 188.9 379.1 204.1 389.3 220.5L426.8 282.9C485.5 377 500.3 397.4 531.2 397.4L531.2 397.4z"
    ]
};
var $ef0249c5e48bf4e3$export$bfe42001388ccf42 = {
    prefix: "fab",
    iconName: "laravel",
    icon: [
        512,
        512,
        [],
        "f3bd",
        "M504.4,115.83a5.72,5.72,0,0,0-.28-.68,8.52,8.52,0,0,0-.53-1.25,6,6,0,0,0-.54-.71,9.36,9.36,0,0,0-.72-.94c-.23-.22-.52-.4-.77-.6a8.84,8.84,0,0,0-.9-.68L404.4,55.55a8,8,0,0,0-8,0L300.12,111h0a8.07,8.07,0,0,0-.88.69,7.68,7.68,0,0,0-.78.6,8.23,8.23,0,0,0-.72.93c-.17.24-.39.45-.54.71a9.7,9.7,0,0,0-.52,1.25c-.08.23-.21.44-.28.68a8.08,8.08,0,0,0-.28,2.08V223.18l-80.22,46.19V63.44a7.8,7.8,0,0,0-.28-2.09c-.06-.24-.2-.45-.28-.68a8.35,8.35,0,0,0-.52-1.24c-.14-.26-.37-.47-.54-.72a9.36,9.36,0,0,0-.72-.94,9.46,9.46,0,0,0-.78-.6,9.8,9.8,0,0,0-.88-.68h0L115.61,1.07a8,8,0,0,0-8,0L11.34,56.49h0a6.52,6.52,0,0,0-.88.69,7.81,7.81,0,0,0-.79.6,8.15,8.15,0,0,0-.71.93c-.18.25-.4.46-.55.72a7.88,7.88,0,0,0-.51,1.24,6.46,6.46,0,0,0-.29.67,8.18,8.18,0,0,0-.28,2.1v329.7a8,8,0,0,0,4,6.95l192.5,110.84a8.83,8.83,0,0,0,1.33.54c.21.08.41.2.63.26a7.92,7.92,0,0,0,4.1,0c.2-.05.37-.16.55-.22a8.6,8.6,0,0,0,1.4-.58L404.4,400.09a8,8,0,0,0,4-6.95V287.88l92.24-53.11a8,8,0,0,0,4-7V117.92A8.63,8.63,0,0,0,504.4,115.83ZM111.6,17.28h0l80.19,46.15-80.2,46.18L31.41,63.44Zm88.25,60V278.6l-46.53,26.79-33.69,19.4V123.5l46.53-26.79Zm0,412.78L23.37,388.5V77.32L57.06,96.7l46.52,26.8V338.68a6.94,6.94,0,0,0,.12.9,8,8,0,0,0,.16,1.18h0a5.92,5.92,0,0,0,.38.9,6.38,6.38,0,0,0,.42,1v0a8.54,8.54,0,0,0,.6.78,7.62,7.62,0,0,0,.66.84l0,0c.23.22.52.38.77.58a8.93,8.93,0,0,0,.86.66l0,0,0,0,92.19,52.18Zm8-106.17-80.06-45.32,84.09-48.41,92.26-53.11,80.13,46.13-58.8,33.56Zm184.52,4.57L215.88,490.11V397.8L346.6,323.2l45.77-26.15Zm0-119.13L358.68,250l-46.53-26.79V131.79l33.69,19.4L392.37,178Zm8-105.28-80.2-46.17,80.2-46.16,80.18,46.15Zm8,105.28V178L455,151.19l33.68-19.4v91.39h0Z"
    ]
};
var $ef0249c5e48bf4e3$export$d309e8b75a17a518 = {
    prefix: "fab",
    iconName: "hotjar",
    icon: [
        512,
        512,
        [],
        "f3b1",
        "M361.5 0c0 131.6-80.7 176.8-140.2 209.4c-.6 .3-1.1 .6-1.6 .9c-53.8 30.2-88.7 49.8-89.6 122H32C32 200.8 112.7 155.6 172.2 123C227 93.2 262.5 73 262.5 0h98.9zM301 302.6c54.8-29.8 90.3-50 90.3-123h98c0 131.6-80.7 176.7-140.2 209.4c-54.8 29.8-90.3 50-90.3 123h-98c0-131.6 80.7-176.8 140.2-209.4z"
    ]
};
var $ef0249c5e48bf4e3$export$ad4174fe3fc4abe2 = {
    prefix: "fab",
    iconName: "bluetooth-b",
    icon: [
        320,
        512,
        [],
        "f294",
        "M196.48 260.023l92.626-103.333L143.125 0v206.33l-86.111-86.111-31.406 31.405 108.061 108.399L25.608 368.422l31.406 31.405 86.111-86.111L145.84 512l148.552-148.644-97.912-103.333zm40.86-102.996l-49.977 49.978-.338-100.295 50.315 50.317zM187.363 313.04l49.977 49.978-50.315 50.316.338-100.294z"
    ]
};
var $ef0249c5e48bf4e3$export$439612f87b462a40 = {
    prefix: "fab",
    iconName: "sticker-mule",
    icon: [
        576,
        512,
        [],
        "f3f7",
        "M561.7 199.6c-1.3.3.3 0 0 0zm-6.2-77.4c-7.7-22.3-5.1-7.2-13.4-36.9-1.6-6.5-3.6-14.5-6.2-20-4.4-8.7-4.6-7.5-4.6-9.5 0-5.3 30.7-45.3 19-46.9-5.7-.6-12.2 11.6-20.6 17-8.6 4.2-8 5-10.3 5-2.6 0-5.7-3-6.2-5-2-5.7 1.9-25.9-3.6-25.9-3.6 0-12.3 24.8-17 25.8-5.2 1.3-27.9-11.4-75.1 18-25.3 13.2-86.9 65.2-87 65.3-6.7 4.7-20 4.7-35.5 16-44.4 30.1-109.6 9.4-110.7 9-110.6-26.8-128-15.2-159 11.5-20.8 17.9-23.7 36.5-24.2 38.9-4.2 20.4 5.2 48.3 6.7 64.3 1.8 19.3-2.7 17.7 7.7 98.3.5 1 4.1 0 5.1 1.5 0 8.4-3.8 12.1-4.1 13-1.5 4.5-1.5 10.5 0 16 2.3 8.2 8.2 37.2 8.2 46.9 0 41.8.4 44 2.6 49.4 3.9 10 12.5 9.1 17 12 3.1 3.5-.5 8.5 1 12.5.5 2 3.6 4 6.2 5 9.2 3.6 27 .3 29.9-2.5 1.6-1.5.5-4.5 3.1-5 5.1 0 10.8-.5 14.4-2.5 5.1-2.5 4.1-6 1.5-10.5-.4-.8-7-13.3-9.8-16-2.1-2-5.1-3-7.2-4.5-5.8-4.9-10.3-19.4-10.3-19.5-4.6-19.4-10.3-46.3-4.1-66.8 4.6-17.2 39.5-87.7 39.6-87.8 4.1-6.5 17-11.5 27.3-7 6 1.9 19.3 22 65.4 30.9 47.9 8.7 97.4-2 112.2-2 2.8 2-1.9 13-.5 38.9 0 26.4-.4 13.7-4.1 29.9-2.2 9.7 3.4 23.2-1.5 46.9-1.4 9.8-9.9 32.7-8.2 43.4.5 1 1 2 1.5 3.5.5 4.5 1.5 8.5 4.6 10 7.3 3.6 12-3.5 9.8 11.5-.7 3.1-2.6 12 1.5 15 4.4 3.7 30.6 3.4 36.5.5 2.6-1.5 1.6-4.5 6.4-7.4 1.9-.9 11.3-.4 11.3-6.5.3-1.8-9.2-19.9-9.3-20-2.6-3.5-9.2-4.5-11.3-8-6.9-10.1-1.7-52.6.5-59.4 3-11 5.6-22.4 8.7-32.4 11-42.5 10.3-50.6 16.5-68.3.8-1.8 6.4-23.1 10.3-29.9 9.3-17 21.7-32.4 33.5-47.4 18-22.9 34-46.9 52-69.8 6.1-7 8.2-13.7 18-8 10.8 5.7 21.6 7 31.9 17 14.6 12.8 10.2 18.2 11.8 22.9 1.5 5 7.7 10.5 14.9 9.5 10.4-2 13-2.5 13.4-2.5 2.6-.5 5.7-5 7.2-8 3.1-5.5 7.2-9 7.2-16.5 0-7.7-.4-2.8-20.6-52.9z"
    ]
};
var $ef0249c5e48bf4e3$export$72df0aea6a5da9de = {
    prefix: "fab",
    iconName: "creative-commons-zero",
    icon: [
        496,
        512,
        [],
        "f4f3",
        "M247.6 8C389.4 8 496 118.1 496 256c0 147.1-118.5 248-248.4 248C113.6 504 0 394.5 0 256 0 123.1 104.7 8 247.6 8zm.8 44.7C130.2 52.7 44.7 150.6 44.7 256c0 109.8 91.2 202.8 203.7 202.8 103.2 0 202.8-81.1 202.8-202.8.1-113.8-90.2-203.3-202.8-203.3zm-.4 60.5c-81.9 0-102.5 77.3-102.5 142.8 0 65.5 20.6 142.8 102.5 142.8S350.5 321.5 350.5 256c0-65.5-20.6-142.8-102.5-142.8zm0 53.9c3.3 0 6.4.5 9.2 1.2 5.9 5.1 8.8 12.1 3.1 21.9l-54.5 100.2c-1.7-12.7-1.9-25.1-1.9-34.4 0-28.8 2-88.9 44.1-88.9zm40.8 46.2c2.9 15.4 3.3 31.4 3.3 42.7 0 28.9-2 88.9-44.1 88.9-13.5 0-32.6-7.7-20.1-26.4l60.9-105.2z"
    ]
};
var $ef0249c5e48bf4e3$export$51de6451f4c7b107 = {
    prefix: "fab",
    iconName: "hips",
    icon: [
        640,
        512,
        [],
        "f452",
        "M251.6 157.6c0-1.9-.9-2.8-2.8-2.8h-40.9c-1.6 0-2.7 1.4-2.7 2.8v201.8c0 1.4 1.1 2.8 2.7 2.8h40.9c1.9 0 2.8-.9 2.8-2.8zM156.5 168c-16.1-11.8-36.3-17.9-60.3-18-18.1-.1-34.6 3.7-49.8 11.4V80.2c0-1.8-.9-2.7-2.8-2.7H2.7c-1.8 0-2.7.9-2.7 2.7v279.2c0 1.9.9 2.8 2.7 2.8h41c1.9 0 2.8-.9 2.8-2.8V223.3c0-.8-2.8-27 45.8-27 48.5 0 45.8 26.1 45.8 27v122.6c0 9 7.3 16.3 16.4 16.3h27.3c1.8 0 2.7-.9 2.7-2.8V223.3c0-23.4-9.3-41.8-28-55.3zm478.4 110.1c-6.8-15.7-18.4-27-34.9-34.1l-57.6-25.3c-8.6-3.6-9.2-11.2-2.6-16.1 7.4-5.5 44.3-13.9 84 6.8 1.7 1 4-.3 4-2.4v-44.7c0-1.3-.6-2.1-1.9-2.6-17.7-6.6-36.1-9.9-55.1-9.9-26.5 0-45.3 5.8-58.5 15.4-.5.4-28.4 20-22.7 53.7 3.4 19.6 15.8 34.2 37.2 43.6l53.6 23.5c11.6 5.1 15.2 13.3 12.2 21.2-3.7 9.1-13.2 13.6-36.5 13.6-24.3 0-44.7-8.9-58.4-19.1-2.1-1.4-4.4.2-4.4 2.3v34.4c0 10.4 4.9 17.3 14.6 20.7 15.6 5.5 31.6 8.2 48.2 8.2 12.7 0 25.8-1.2 36.3-4.3.7-.3 36-8.9 45.6-45.8 3.5-13.5 2.4-26.5-3.1-39.1zM376.2 149.8c-31.7 0-104.2 20.1-104.2 103.5v183.5c0 .8.6 2.7 2.7 2.7h40.9c1.9 0 2.8-.9 2.8-2.7V348c16.5 12.7 35.8 19.1 57.7 19.1 60.5 0 108.7-48.5 108.7-108.7.1-60.3-48.2-108.6-108.6-108.6zm0 170.9c-17.2 0-31.9-6.1-44-18.2-12.2-12.2-18.2-26.8-18.2-44 0-34.5 27.6-62.2 62.2-62.2 34.5 0 62.2 27.6 62.2 62.2.1 34.3-27.3 62.2-62.2 62.2zM228.3 72.5c-15.9 0-28.8 12.9-28.9 28.9 0 15.6 12.7 28.9 28.9 28.9s28.9-13.1 28.9-28.9c0-16.2-13-28.9-28.9-28.9z"
    ]
};
var $ef0249c5e48bf4e3$export$907c17a7f1d6a0d3 = {
    prefix: "fab",
    iconName: "behance",
    icon: [
        576,
        512,
        [],
        "f1b4",
        "M232 237.2c31.8-15.2 48.4-38.2 48.4-74 0-70.6-52.6-87.8-113.3-87.8H0v354.4h171.8c64.4 0 124.9-30.9 124.9-102.9 0-44.5-21.1-77.4-64.7-89.7zM77.9 135.9H151c28.1 0 53.4 7.9 53.4 40.5 0 30.1-19.7 42.2-47.5 42.2h-79v-82.7zm83.3 233.7H77.9V272h84.9c34.3 0 56 14.3 56 50.6 0 35.8-25.9 47-57.6 47zm358.5-240.7H376V94h143.7v34.9zM576 305.2c0-75.9-44.4-139.2-124.9-139.2-78.2 0-131.3 58.8-131.3 135.8 0 79.9 50.3 134.7 131.3 134.7 61.3 0 101-27.6 120.1-86.3H509c-6.7 21.9-34.3 33.5-55.7 33.5-41.3 0-63-24.2-63-65.3h185.1c.3-4.2.6-8.7.6-13.2zM390.4 274c2.3-33.7 24.7-54.8 58.5-54.8 35.4 0 53.2 20.8 56.2 54.8H390.4z"
    ]
};
var $ef0249c5e48bf4e3$export$97dd0b04d798af1a = {
    prefix: "fab",
    iconName: "reddit",
    icon: [
        512,
        512,
        [],
        "f1a1",
        "M201.5 305.5c-13.8 0-24.9-11.1-24.9-24.6 0-13.8 11.1-24.9 24.9-24.9 13.6 0 24.6 11.1 24.6 24.9 0 13.6-11.1 24.6-24.6 24.6zM504 256c0 137-111 248-248 248S8 393 8 256 119 8 256 8s248 111 248 248zm-132.3-41.2c-9.4 0-17.7 3.9-23.8 10-22.4-15.5-52.6-25.5-86.1-26.6l17.4-78.3 55.4 12.5c0 13.6 11.1 24.6 24.6 24.6 13.8 0 24.9-11.3 24.9-24.9s-11.1-24.9-24.9-24.9c-9.7 0-18 5.8-22.1 13.8l-61.2-13.6c-3-.8-6.1 1.4-6.9 4.4l-19.1 86.4c-33.2 1.4-63.1 11.3-85.5 26.8-6.1-6.4-14.7-10.2-24.1-10.2-34.9 0-46.3 46.9-14.4 62.8-1.1 5-1.7 10.2-1.7 15.5 0 52.6 59.2 95.2 132 95.2 73.1 0 132.3-42.6 132.3-95.2 0-5.3-.6-10.8-1.9-15.8 31.3-16 19.8-62.5-14.9-62.5zM302.8 331c-18.2 18.2-76.1 17.9-93.6 0-2.2-2.2-6.1-2.2-8.3 0-2.5 2.5-2.5 6.4 0 8.6 22.8 22.8 87.3 22.8 110.2 0 2.5-2.2 2.5-6.1 0-8.6-2.2-2.2-6.1-2.2-8.3 0zm7.7-75c-13.6 0-24.6 11.1-24.6 24.9 0 13.6 11.1 24.6 24.6 24.6 13.8 0 24.9-11.1 24.9-24.6 0-13.8-11-24.9-24.9-24.9z"
    ]
};
var $ef0249c5e48bf4e3$export$c8d4525a5e9ad3ad = {
    prefix: "fab",
    iconName: "discord",
    icon: [
        640,
        512,
        [],
        "f392",
        "M524.531,69.836a1.5,1.5,0,0,0-.764-.7A485.065,485.065,0,0,0,404.081,32.03a1.816,1.816,0,0,0-1.923.91,337.461,337.461,0,0,0-14.9,30.6,447.848,447.848,0,0,0-134.426,0,309.541,309.541,0,0,0-15.135-30.6,1.89,1.89,0,0,0-1.924-.91A483.689,483.689,0,0,0,116.085,69.137a1.712,1.712,0,0,0-.788.676C39.068,183.651,18.186,294.69,28.43,404.354a2.016,2.016,0,0,0,.765,1.375A487.666,487.666,0,0,0,176.02,479.918a1.9,1.9,0,0,0,2.063-.676A348.2,348.2,0,0,0,208.12,430.4a1.86,1.86,0,0,0-1.019-2.588,321.173,321.173,0,0,1-45.868-21.853,1.885,1.885,0,0,1-.185-3.126c3.082-2.309,6.166-4.711,9.109-7.137a1.819,1.819,0,0,1,1.9-.256c96.229,43.917,200.41,43.917,295.5,0a1.812,1.812,0,0,1,1.924.233c2.944,2.426,6.027,4.851,9.132,7.16a1.884,1.884,0,0,1-.162,3.126,301.407,301.407,0,0,1-45.89,21.83,1.875,1.875,0,0,0-1,2.611,391.055,391.055,0,0,0,30.014,48.815,1.864,1.864,0,0,0,2.063.7A486.048,486.048,0,0,0,610.7,405.729a1.882,1.882,0,0,0,.765-1.352C623.729,277.594,590.933,167.465,524.531,69.836ZM222.491,337.58c-28.972,0-52.844-26.587-52.844-59.239S193.056,219.1,222.491,219.1c29.665,0,53.306,26.82,52.843,59.239C275.334,310.993,251.924,337.58,222.491,337.58Zm195.38,0c-28.971,0-52.843-26.587-52.843-59.239S388.437,219.1,417.871,219.1c29.667,0,53.307,26.82,52.844,59.239C470.715,310.993,447.538,337.58,417.871,337.58Z"
    ]
};
var $ef0249c5e48bf4e3$export$430df45ec2fae593 = {
    prefix: "fab",
    iconName: "chrome",
    icon: [
        512,
        512,
        [],
        "f268",
        "M0 256C0 209.4 12.47 165.6 34.27 127.1L144.1 318.3C166 357.5 207.9 384 256 384C270.3 384 283.1 381.7 296.8 377.4L220.5 509.6C95.9 492.3 0 385.3 0 256zM365.1 321.6C377.4 302.4 384 279.1 384 256C384 217.8 367.2 183.5 340.7 160H493.4C505.4 189.6 512 222.1 512 256C512 397.4 397.4 511.1 256 512L365.1 321.6zM477.8 128H256C193.1 128 142.3 172.1 130.5 230.7L54.19 98.47C101 38.53 174 0 256 0C350.8 0 433.5 51.48 477.8 128V128zM168 256C168 207.4 207.4 168 256 168C304.6 168 344 207.4 344 256C344 304.6 304.6 344 256 344C207.4 344 168 304.6 168 256z"
    ]
};
var $ef0249c5e48bf4e3$export$e36cec8e481a3a4b = {
    prefix: "fab",
    iconName: "app-store-ios",
    icon: [
        448,
        512,
        [],
        "f370",
        "M400 32H48C21.5 32 0 53.5 0 80v352c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48V80c0-26.5-21.5-48-48-48zM127 384.5c-5.5 9.6-17.8 12.8-27.3 7.3-9.6-5.5-12.8-17.8-7.3-27.3l14.3-24.7c16.1-4.9 29.3-1.1 39.6 11.4L127 384.5zm138.9-53.9H84c-11 0-20-9-20-20s9-20 20-20h51l65.4-113.2-20.5-35.4c-5.5-9.6-2.2-21.8 7.3-27.3 9.6-5.5 21.8-2.2 27.3 7.3l8.9 15.4 8.9-15.4c5.5-9.6 17.8-12.8 27.3-7.3 9.6 5.5 12.8 17.8 7.3 27.3l-85.8 148.6h62.1c20.2 0 31.5 23.7 22.7 40zm98.1 0h-29l19.6 33.9c5.5 9.6 2.2 21.8-7.3 27.3-9.6 5.5-21.8 2.2-27.3-7.3-32.9-56.9-57.5-99.7-74-128.1-16.7-29-4.8-58 7.1-67.8 13.1 22.7 32.7 56.7 58.9 102h52c11 0 20 9 20 20 0 11.1-9 20-20 20z"
    ]
};
var $ef0249c5e48bf4e3$export$4a929e0a1abf7e41 = {
    prefix: "fab",
    iconName: "cc-discover",
    icon: [
        576,
        512,
        [],
        "f1f2",
        "M520.4 196.1c0-7.9-5.5-12.1-15.6-12.1h-4.9v24.9h4.7c10.3 0 15.8-4.4 15.8-12.8zM528 32H48C21.5 32 0 53.5 0 80v352c0 26.5 21.5 48 48 48h480c26.5 0 48-21.5 48-48V80c0-26.5-21.5-48-48-48zm-44.1 138.9c22.6 0 52.9-4.1 52.9 24.4 0 12.6-6.6 20.7-18.7 23.2l25.8 34.4h-19.6l-22.2-32.8h-2.2v32.8h-16zm-55.9.1h45.3v14H444v18.2h28.3V217H444v22.2h29.3V253H428zm-68.7 0l21.9 55.2 22.2-55.2h17.5l-35.5 84.2h-8.6l-35-84.2zm-55.9-3c24.7 0 44.6 20 44.6 44.6 0 24.7-20 44.6-44.6 44.6-24.7 0-44.6-20-44.6-44.6 0-24.7 20-44.6 44.6-44.6zm-49.3 6.1v19c-20.1-20.1-46.8-4.7-46.8 19 0 25 27.5 38.5 46.8 19.2v19c-29.7 14.3-63.3-5.7-63.3-38.2 0-31.2 33.1-53 63.3-38zm-97.2 66.3c11.4 0 22.4-15.3-3.3-24.4-15-5.5-20.2-11.4-20.2-22.7 0-23.2 30.6-31.4 49.7-14.3l-8.4 10.8c-10.4-11.6-24.9-6.2-24.9 2.5 0 4.4 2.7 6.9 12.3 10.3 18.2 6.6 23.6 12.5 23.6 25.6 0 29.5-38.8 37.4-56.6 11.3l10.3-9.9c3.7 7.1 9.9 10.8 17.5 10.8zM55.4 253H32v-82h23.4c26.1 0 44.1 17 44.1 41.1 0 18.5-13.2 40.9-44.1 40.9zm67.5 0h-16v-82h16zM544 433c0 8.2-6.8 15-15 15H128c189.6-35.6 382.7-139.2 416-160zM74.1 191.6c-5.2-4.9-11.6-6.6-21.9-6.6H48v54.2h4.2c10.3 0 17-2 21.9-6.4 5.7-5.2 8.9-12.8 8.9-20.7s-3.2-15.5-8.9-20.5z"
    ]
};
var $ef0249c5e48bf4e3$export$a24323c111493948 = {
    prefix: "fab",
    iconName: "wpbeginner",
    icon: [
        512,
        512,
        [],
        "f297",
        "M462.799 322.374C519.01 386.682 466.961 480 370.944 480c-39.602 0-78.824-17.687-100.142-50.04-6.887.356-22.702.356-29.59 0C219.848 462.381 180.588 480 141.069 480c-95.49 0-148.348-92.996-91.855-157.626C-29.925 190.523 80.479 32 256.006 32c175.632 0 285.87 158.626 206.793 290.374zm-339.647-82.972h41.529v-58.075h-41.529v58.075zm217.18 86.072v-23.839c-60.506 20.915-132.355 9.198-187.589-33.971l.246 24.897c51.101 46.367 131.746 57.875 187.343 32.913zm-150.753-86.072h166.058v-58.075H189.579v58.075z"
    ]
};
var $ef0249c5e48bf4e3$export$259f76b402dd445f = {
    prefix: "fab",
    iconName: "confluence",
    icon: [
        512,
        512,
        [],
        "f78d",
        "M2.3 412.2c-4.5 7.6-2.1 17.5 5.5 22.2l105.9 65.2c7.7 4.7 17.7 2.4 22.4-5.3 0-.1.1-.2.1-.2 67.1-112.2 80.5-95.9 280.9-.7 8.1 3.9 17.8.4 21.7-7.7.1-.1.1-.3.2-.4l50.4-114.1c3.6-8.1-.1-17.6-8.1-21.3-22.2-10.4-66.2-31.2-105.9-50.3C127.5 179 44.6 345.3 2.3 412.2zm507.4-312.1c4.5-7.6 2.1-17.5-5.5-22.2L398.4 12.8c-7.5-5-17.6-3.1-22.6 4.4-.2.3-.4.6-.6 1-67.3 112.6-81.1 95.6-280.6.9-8.1-3.9-17.8-.4-21.7 7.7-.1.1-.1.3-.2.4L22.2 141.3c-3.6 8.1.1 17.6 8.1 21.3 22.2 10.4 66.3 31.2 106 50.4 248 120 330.8-45.4 373.4-112.9z"
    ]
};
var $ef0249c5e48bf4e3$export$7add95166ef0248a = {
    prefix: "fab",
    iconName: "mdb",
    icon: [
        576,
        512,
        [],
        "f8ca",
        "M17.37 160.41L7 352h43.91l5.59-79.83L84.43 352h44.71l25.54-77.43 4.79 77.43H205l-12.79-191.59H146.7L106 277.74 63.67 160.41zm281 0h-47.9V352h47.9s95 .8 94.2-95.79c-.78-94.21-94.18-95.78-94.18-95.78zm-1.2 146.46V204.78s46 4.27 46.8 50.57-46.78 51.54-46.78 51.54zm238.29-74.24a56.16 56.16 0 0 0 8-38.31c-5.34-35.76-55.08-34.32-55.08-34.32h-51.9v191.58H482s87 4.79 87-63.85c0-43.14-33.52-55.08-33.52-55.08zm-51.9-31.94s13.57-1.59 16 9.59c1.43 6.66-4 12-4 12h-12v-21.57zm-.1 109.46l.1-24.92V267h.08s41.58-4.73 41.19 22.43c-.33 25.65-41.35 20.74-41.35 20.74z"
    ]
};
var $ef0249c5e48bf4e3$export$81d728fa770edbe1 = {
    prefix: "fab",
    iconName: "dochub",
    icon: [
        416,
        512,
        [],
        "f394",
        "M397.9 160H256V19.6L397.9 160zM304 192v130c0 66.8-36.5 100.1-113.3 100.1H96V84.8h94.7c12 0 23.1.8 33.1 2.5v-84C212.9 1.1 201.4 0 189.2 0H0v512h189.2C329.7 512 400 447.4 400 318.1V192h-96z"
    ]
};
var $ef0249c5e48bf4e3$export$3c152d640f62968e = {
    prefix: "fab",
    iconName: "accessible-icon",
    icon: [
        448,
        512,
        [
            62107
        ],
        "f368",
        "M423.9 255.8L411 413.1c-3.3 40.7-63.9 35.1-60.6-4.9l10-122.5-41.1 2.3c10.1 20.7 15.8 43.9 15.8 68.5 0 41.2-16.1 78.7-42.3 106.5l-39.3-39.3c57.9-63.7 13.1-167.2-74-167.2-25.9 0-49.5 9.9-67.2 26L73 243.2c22-20.7 50.1-35.1 81.4-40.2l75.3-85.7-42.6-24.8-51.6 46c-30 26.8-70.6-18.5-40.5-45.4l68-60.7c9.8-8.8 24.1-10.2 35.5-3.6 0 0 139.3 80.9 139.5 81.1 16.2 10.1 20.7 36 6.1 52.6L285.7 229l106.1-5.9c18.5-1.1 33.6 14.4 32.1 32.7zm-64.9-154c28.1 0 50.9-22.8 50.9-50.9C409.9 22.8 387.1 0 359 0c-28.1 0-50.9 22.8-50.9 50.9 0 28.1 22.8 50.9 50.9 50.9zM179.6 456.5c-80.6 0-127.4-90.6-82.7-156.1l-39.7-39.7C36.4 287 24 320.3 24 356.4c0 130.7 150.7 201.4 251.4 122.5l-39.7-39.7c-16 10.9-35.3 17.3-56.1 17.3z"
    ]
};
var $ef0249c5e48bf4e3$export$ddb611ff59fc9802 = {
    prefix: "fab",
    iconName: "ebay",
    icon: [
        640,
        512,
        [],
        "f4f4",
        "M606 189.5l-54.8 109.9-54.9-109.9h-37.5l10.9 20.6c-11.5-19-35.9-26-63.3-26-31.8 0-67.9 8.7-71.5 43.1h33.7c1.4-13.8 15.7-21.8 35-21.8 26 0 41 9.6 41 33v3.4c-12.7 0-28 .1-41.7.4-42.4.9-69.6 10-76.7 34.4 1-5.2 1.5-10.6 1.5-16.2 0-52.1-39.7-76.2-75.4-76.2-21.3 0-43 5.5-58.7 24.2v-80.6h-32.1v169.5c0 10.3-.6 22.9-1.1 33.1h31.5c.7-6.3 1.1-12.9 1.1-19.5 13.6 16.6 35.4 24.9 58.7 24.9 36.9 0 64.9-21.9 73.3-54.2-.5 2.8-.7 5.8-.7 9 0 24.1 21.1 45 60.6 45 26.6 0 45.8-5.7 61.9-25.5 0 6.6.3 13.3 1.1 20.2h29.8c-.7-8.2-1-17.5-1-26.8v-65.6c0-9.3-1.7-17.2-4.8-23.8l61.5 116.1-28.5 54.1h35.9L640 189.5zM243.7 313.8c-29.6 0-50.2-21.5-50.2-53.8 0-32.4 20.6-53.8 50.2-53.8 29.8 0 50.2 21.4 50.2 53.8 0 32.3-20.4 53.8-50.2 53.8zm200.9-47.3c0 30-17.9 48.4-51.6 48.4-25.1 0-35-13.4-35-25.8 0-19.1 18.1-24.4 47.2-25.3 13.1-.5 27.6-.6 39.4-.6zm-411.9 1.6h128.8v-8.5c0-51.7-33.1-75.4-78.4-75.4-56.8 0-83 30.8-83 77.6 0 42.5 25.3 74 82.5 74 31.4 0 68-11.7 74.4-46.1h-33.1c-12 35.8-87.7 36.7-91.2-21.6zm95-21.4H33.3c6.9-56.6 92.1-54.7 94.4 0z"
    ]
};
var $ef0249c5e48bf4e3$export$ebc1e565fd80a447 = {
    prefix: "fab",
    iconName: "amazon",
    icon: [
        448,
        512,
        [],
        "f270",
        "M257.2 162.7c-48.7 1.8-169.5 15.5-169.5 117.5 0 109.5 138.3 114 183.5 43.2 6.5 10.2 35.4 37.5 45.3 46.8l56.8-56S341 288.9 341 261.4V114.3C341 89 316.5 32 228.7 32 140.7 32 94 87 94 136.3l73.5 6.8c16.3-49.5 54.2-49.5 54.2-49.5 40.7-.1 35.5 29.8 35.5 69.1zm0 86.8c0 80-84.2 68-84.2 17.2 0-47.2 50.5-56.7 84.2-57.8v40.6zm136 163.5c-7.7 10-70 67-174.5 67S34.2 408.5 9.7 379c-6.8-7.7 1-11.3 5.5-8.3C88.5 415.2 203 488.5 387.7 401c7.5-3.7 13.3 2 5.5 12zm39.8 2.2c-6.5 15.8-16 26.8-21.2 31-5.5 4.5-9.5 2.7-6.5-3.8s19.3-46.5 12.7-55c-6.5-8.3-37-4.3-48-3.2-10.8 1-13 2-14-.3-2.3-5.7 21.7-15.5 37.5-17.5 15.7-1.8 41-.8 46 5.7 3.7 5.1 0 27.1-6.5 43.1z"
    ]
};
var $ef0249c5e48bf4e3$export$3997191a5880488f = {
    prefix: "fab",
    iconName: "unsplash",
    icon: [
        448,
        512,
        [],
        "e07c",
        "M448,230.17V480H0V230.17H141.13V355.09H306.87V230.17ZM306.87,32H141.13V156.91H306.87Z"
    ]
};
var $ef0249c5e48bf4e3$export$a67629e1d516967d = {
    prefix: "fab",
    iconName: "yarn",
    icon: [
        496,
        512,
        [],
        "f7e3",
        "M393.9 345.2c-39 9.3-48.4 32.1-104 47.4 0 0-2.7 4-10.4 5.8-13.4 3.3-63.9 6-68.5 6.1-12.4.1-19.9-3.2-22-8.2-6.4-15.3 9.2-22 9.2-22-8.1-5-9-9.9-9.8-8.1-2.4 5.8-3.6 20.1-10.1 26.5-8.8 8.9-25.5 5.9-35.3.8-10.8-5.7.8-19.2.8-19.2s-5.8 3.4-10.5-3.6c-6-9.3-17.1-37.3 11.5-62-1.3-10.1-4.6-53.7 40.6-85.6 0 0-20.6-22.8-12.9-43.3 5-13.4 7-13.3 8.6-13.9 5.7-2.2 11.3-4.6 15.4-9.1 20.6-22.2 46.8-18 46.8-18s12.4-37.8 23.9-30.4c3.5 2.3 16.3 30.6 16.3 30.6s13.6-7.9 15.1-5c8.2 16 9.2 46.5 5.6 65.1-6.1 30.6-21.4 47.1-27.6 57.5-1.4 2.4 16.5 10 27.8 41.3 10.4 28.6 1.1 52.7 2.8 55.3.8 1.4 13.7.8 36.4-13.2 12.8-7.9 28.1-16.9 45.4-17 16.7-.5 17.6 19.2 4.9 22.2zM496 256c0 136.9-111.1 248-248 248S0 392.9 0 256 111.1 8 248 8s248 111.1 248 248zm-79.3 75.2c-1.7-13.6-13.2-23-28-22.8-22 .3-40.5 11.7-52.8 19.2-4.8 3-8.9 5.2-12.4 6.8 3.1-44.5-22.5-73.1-28.7-79.4 7.8-11.3 18.4-27.8 23.4-53.2 4.3-21.7 3-55.5-6.9-74.5-1.6-3.1-7.4-11.2-21-7.4-9.7-20-13-22.1-15.6-23.8-1.1-.7-23.6-16.4-41.4 28-12.2.9-31.3 5.3-47.5 22.8-2 2.2-5.9 3.8-10.1 5.4h.1c-8.4 3-12.3 9.9-16.9 22.3-6.5 17.4.2 34.6 6.8 45.7-17.8 15.9-37 39.8-35.7 82.5-34 36-11.8 73-5.6 79.6-1.6 11.1 3.7 19.4 12 23.8 12.6 6.7 30.3 9.6 43.9 2.8 4.9 5.2 13.8 10.1 30 10.1 6.8 0 58-2.9 72.6-6.5 6.8-1.6 11.5-4.5 14.6-7.1 9.8-3.1 36.8-12.3 62.2-28.7 18-11.7 24.2-14.2 37.6-17.4 12.9-3.2 21-15.1 19.4-28.2z"
    ]
};
var $ef0249c5e48bf4e3$export$c334a5e9c1f73381 = {
    prefix: "fab",
    iconName: "square-steam",
    icon: [
        448,
        512,
        [
            "steam-square"
        ],
        "f1b7",
        "M185.2 356.5c7.7-18.5-1-39.7-19.6-47.4l-29.5-12.2c11.4-4.3 24.3-4.5 36.4.5 12.2 5.1 21.6 14.6 26.7 26.7 5 12.2 5 25.6-.1 37.7-10.5 25.1-39.4 37-64.6 26.5-11.6-4.8-20.4-13.6-25.4-24.2l28.5 11.8c18.6 7.8 39.9-.9 47.6-19.4zM400 32H48C21.5 32 0 53.5 0 80v160.7l116.6 48.1c12-8.2 26.2-12.1 40.7-11.3l55.4-80.2v-1.1c0-48.2 39.3-87.5 87.6-87.5s87.6 39.3 87.6 87.5c0 49.2-40.9 88.7-89.6 87.5l-79 56.3c1.6 38.5-29.1 68.8-65.7 68.8-31.8 0-58.5-22.7-64.5-52.7L0 319.2V432c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48V80c0-26.5-21.5-48-48-48zm-99.7 222.5c-32.2 0-58.4-26.1-58.4-58.3s26.2-58.3 58.4-58.3 58.4 26.2 58.4 58.3-26.2 58.3-58.4 58.3zm.1-14.6c24.2 0 43.9-19.6 43.9-43.8 0-24.2-19.6-43.8-43.9-43.8-24.2 0-43.9 19.6-43.9 43.8 0 24.2 19.7 43.8 43.9 43.8z"
    ]
};
var $ef0249c5e48bf4e3$export$b0e9b012d636da0a = $ef0249c5e48bf4e3$export$c334a5e9c1f73381;
var $ef0249c5e48bf4e3$export$4adb509bb23593b0 = {
    prefix: "fab",
    iconName: "500px",
    icon: [
        448,
        512,
        [],
        "f26e",
        "M103.3 344.3c-6.5-14.2-6.9-18.3 7.4-23.1 25.6-8 8 9.2 43.2 49.2h.3v-93.9c1.2-50.2 44-92.2 97.7-92.2 53.9 0 97.7 43.5 97.7 96.8 0 63.4-60.8 113.2-128.5 93.3-10.5-4.2-2.1-31.7 8.5-28.6 53 0 89.4-10.1 89.4-64.4 0-61-77.1-89.6-116.9-44.6-23.5 26.4-17.6 42.1-17.6 157.6 50.7 31 118.3 22 160.4-20.1 24.8-24.8 38.5-58 38.5-93 0-35.2-13.8-68.2-38.8-93.3-24.8-24.8-57.8-38.5-93.3-38.5s-68.8 13.8-93.5 38.5c-.3.3-16 16.5-21.2 23.9l-.5.6c-3.3 4.7-6.3 9.1-20.1 6.1-6.9-1.7-14.3-5.8-14.3-11.8V20c0-5 3.9-10.5 10.5-10.5h241.3c8.3 0 8.3 11.6 8.3 15.1 0 3.9 0 15.1-8.3 15.1H130.3v132.9h.3c104.2-109.8 282.8-36 282.8 108.9 0 178.1-244.8 220.3-310.1 62.8zm63.3-260.8c-.5 4.2 4.6 24.5 14.6 20.6C306 56.6 384 144.5 390.6 144.5c4.8 0 22.8-15.3 14.3-22.8-93.2-89-234.5-57-238.3-38.2zM393 414.7C283 524.6 94 475.5 61 310.5c0-12.2-30.4-7.4-28.9 3.3 24 173.4 246 256.9 381.6 121.3 6.9-7.8-12.6-28.4-20.7-20.4zM213.6 306.6c0 4 4.3 7.3 5.5 8.5 3 3 6.1 4.4 8.5 4.4 3.8 0 2.6.2 22.3-19.5 19.6 19.3 19.1 19.5 22.3 19.5 5.4 0 18.5-10.4 10.7-18.2L265.6 284l18.2-18.2c6.3-6.8-10.1-21.8-16.2-15.7L249.7 268c-18.6-18.8-18.4-19.5-21.5-19.5-5 0-18 11.7-12.4 17.3L234 284c-18.1 17.9-20.4 19.2-20.4 22.6z"
    ]
};
var $ef0249c5e48bf4e3$export$8974793285f35ac8 = {
    prefix: "fab",
    iconName: "square-vimeo",
    icon: [
        448,
        512,
        [
            "vimeo-square"
        ],
        "f194",
        "M400 32H48C21.5 32 0 53.5 0 80v352c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48V80c0-26.5-21.5-48-48-48zm-16.2 149.6c-1.4 31.1-23.2 73.8-65.3 127.9-43.5 56.5-80.3 84.8-110.4 84.8-18.7 0-34.4-17.2-47.3-51.6-25.2-92.3-35.9-146.4-56.7-146.4-2.4 0-10.8 5-25.1 15.1L64 192c36.9-32.4 72.1-68.4 94.1-70.4 24.9-2.4 40.2 14.6 46 51.1 20.5 129.6 29.6 149.2 66.8 90.5 13.4-21.2 20.6-37.2 21.5-48.3 3.4-32.8-25.6-30.6-45.2-22.2 15.7-51.5 45.8-76.5 90.1-75.1 32.9 1 48.4 22.4 46.5 64z"
    ]
};
var $ef0249c5e48bf4e3$export$78628c2da1e685b5 = $ef0249c5e48bf4e3$export$8974793285f35ac8;
var $ef0249c5e48bf4e3$export$50ef858a08ddd1e5 = {
    prefix: "fab",
    iconName: "asymmetrik",
    icon: [
        576,
        512,
        [],
        "f372",
        "M517.5 309.2c38.8-40 58.1-80 58.5-116.1.8-65.5-59.4-118.2-169.4-135C277.9 38.4 118.1 73.6 0 140.5 52 114 110.6 92.3 170.7 82.3c74.5-20.5 153-25.4 221.3-14.8C544.5 91.3 588.8 195 490.8 299.2c-10.2 10.8-22 21.1-35 30.6L304.9 103.4 114.7 388.9c-65.6-29.4-76.5-90.2-19.1-151.2 20.8-22.2 48.3-41.9 79.5-58.1 20-12.2 39.7-22.6 62-30.7-65.1 20.3-122.7 52.9-161.6 92.9-27.7 28.6-41.4 57.1-41.7 82.9-.5 35.1 23.4 65.1 68.4 83l-34.5 51.7h101.6l22-34.4c22.2 1 45.3 0 68.6-2.7l-22.8 37.1h135.5L340 406.3c18.6-5.3 36.9-11.5 54.5-18.7l45.9 71.8H542L468.6 349c18.5-12.1 35-25.5 48.9-39.8zm-187.6 80.5l-25-40.6-32.7 53.3c-23.4 3.5-46.7 5.1-69.2 4.4l101.9-159.3 78.7 123c-17.2 7.4-35.3 13.9-53.7 19.2z"
    ]
};
var $ef0249c5e48bf4e3$export$aa4baaed1c60f58d = {
    prefix: "fab",
    iconName: "font-awesome",
    icon: [
        448,
        512,
        [
            62501,
            62694,
            "font-awesome-flag",
            "font-awesome-logo-full"
        ],
        "f2b4",
        "M448 48V384C385 407 366 416 329 416C266 416 242 384 179 384C159 384 143 388 128 392V328C143 324 159 320 179 320C242 320 266 352 329 352C349 352 364 349 384 343V135C364 141 349 144 329 144C266 144 242 112 179 112C128 112 104 133 64 141V448C64 466 50 480 32 480S0 466 0 448V64C0 46 14 32 32 32S64 46 64 64V77C104 69 128 48 179 48C242 48 266 80 329 80C366 80 385 71 448 48Z"
    ]
};
var $ef0249c5e48bf4e3$export$102c25fde54d4843 = $ef0249c5e48bf4e3$export$aa4baaed1c60f58d;
var $ef0249c5e48bf4e3$export$6e20d421a2e0f320 = $ef0249c5e48bf4e3$export$aa4baaed1c60f58d;
var $ef0249c5e48bf4e3$export$cf1aa567b9609235 = {
    prefix: "fab",
    iconName: "gratipay",
    icon: [
        496,
        512,
        [],
        "f184",
        "M248 8C111.1 8 0 119.1 0 256s111.1 248 248 248 248-111.1 248-248S384.9 8 248 8zm114.6 226.4l-113 152.7-112.7-152.7c-8.7-11.9-19.1-50.4 13.6-72 28.1-18.1 54.6-4.2 68.5 11.9 15.9 17.9 46.6 16.9 61.7 0 13.9-16.1 40.4-30 68.1-11.9 32.9 21.6 22.6 60 13.8 72z"
    ]
};
var $ef0249c5e48bf4e3$export$a649d390c50fd6df = {
    prefix: "fab",
    iconName: "apple",
    icon: [
        384,
        512,
        [],
        "f179",
        "M318.7 268.7c-.2-36.7 16.4-64.4 50-84.8-18.8-26.9-47.2-41.7-84.7-44.6-35.5-2.8-74.3 20.7-88.5 20.7-15 0-49.4-19.7-76.4-19.7C63.3 141.2 4 184.8 4 273.5q0 39.3 14.4 81.2c12.8 36.7 59 126.7 107.2 125.2 25.2-.6 43-17.9 75.8-17.9 31.8 0 48.3 17.9 76.4 17.9 48.6-.7 90.4-82.5 102.6-119.3-65.2-30.7-61.7-90-61.7-91.9zm-56.6-164.2c27.3-32.4 24.8-61.9 24-72.5-24.1 1.4-52 16.4-67.9 34.9-17.5 19.8-27.8 44.3-25.6 71.9 26.1 2 49.9-11.4 69.5-34.3z"
    ]
};
var $ef0249c5e48bf4e3$export$f5cdac644000a430 = {
    prefix: "fab",
    iconName: "hive",
    icon: [
        512,
        512,
        [],
        "e07f",
        "M260.353,254.878,131.538,33.1a2.208,2.208,0,0,0-3.829.009L.3,254.887A2.234,2.234,0,0,0,.3,257.122L129.116,478.9a2.208,2.208,0,0,0,3.83-.009L260.358,257.113A2.239,2.239,0,0,0,260.353,254.878Zm39.078-25.713a2.19,2.19,0,0,0,1.9,1.111h66.509a2.226,2.226,0,0,0,1.9-3.341L259.115,33.111a2.187,2.187,0,0,0-1.9-1.111H190.707a2.226,2.226,0,0,0-1.9,3.341ZM511.7,254.886,384.9,33.112A2.2,2.2,0,0,0,382.99,32h-66.6a2.226,2.226,0,0,0-1.906,3.34L440.652,256,314.481,476.66a2.226,2.226,0,0,0,1.906,3.34h66.6a2.2,2.2,0,0,0,1.906-1.112L511.7,257.114A2.243,2.243,0,0,0,511.7,254.886ZM366.016,284.917H299.508a2.187,2.187,0,0,0-1.9,1.111l-108.8,190.631a2.226,2.226,0,0,0,1.9,3.341h66.509a2.187,2.187,0,0,0,1.9-1.111l108.8-190.631A2.226,2.226,0,0,0,366.016,284.917Z"
    ]
};
var $ef0249c5e48bf4e3$export$cd2223c7b77bd41c = {
    prefix: "fab",
    iconName: "gitkraken",
    icon: [
        592,
        512,
        [],
        "f3a6",
        "M565.7 118.1c-2.3-6.1-9.3-9.2-15.3-6.6-5.7 2.4-8.5 8.9-6.3 14.6 10.9 29 16.9 60.5 16.9 93.3 0 134.6-100.3 245.7-230.2 262.7V358.4c7.9-1.5 15.5-3.6 23-6.2v104c106.7-25.9 185.9-122.1 185.9-236.8 0-91.8-50.8-171.8-125.8-213.3-5.7-3.2-13-.9-15.9 5-2.7 5.5-.6 12.2 4.7 15.1 67.9 37.6 113.9 110 113.9 193.2 0 93.3-57.9 173.1-139.8 205.4v-92.2c14.2-4.5 24.9-17.7 24.9-33.5 0-13.1-6.8-24.4-17.3-30.5 8.3-79.5 44.5-58.6 44.5-83.9V170c0-38-87.9-161.8-129-164.7-2.5-.2-5-.2-7.6 0C251.1 8.3 163.2 132 163.2 170v14.8c0 25.3 36.3 4.3 44.5 83.9-10.6 6.1-17.3 17.4-17.3 30.5 0 15.8 10.6 29 24.8 33.5v92.2c-81.9-32.2-139.8-112-139.8-205.4 0-83.1 46-155.5 113.9-193.2 5.4-3 7.4-9.6 4.7-15.1-2.9-5.9-10.1-8.2-15.9-5-75 41.5-125.8 121.5-125.8 213.3 0 114.7 79.2 210.8 185.9 236.8v-104c7.6 2.5 15.1 4.6 23 6.2v123.7C131.4 465.2 31 354.1 31 219.5c0-32.8 6-64.3 16.9-93.3 2.2-5.8-.6-12.2-6.3-14.6-6-2.6-13 .4-15.3 6.6C14.5 149.7 8 183.8 8 219.5c0 155.1 122.6 281.6 276.3 287.8V361.4c6.8.4 15 .5 23.4 0v145.8C461.4 501.1 584 374.6 584 219.5c0-35.7-6.5-69.8-18.3-101.4zM365.9 275.5c13 0 23.7 10.5 23.7 23.7 0 13.1-10.6 23.7-23.7 23.7-13 0-23.7-10.5-23.7-23.7 0-13.1 10.6-23.7 23.7-23.7zm-139.8 47.3c-13.2 0-23.7-10.7-23.7-23.7s10.5-23.7 23.7-23.7c13.1 0 23.7 10.6 23.7 23.7 0 13-10.5 23.7-23.7 23.7z"
    ]
};
var $ef0249c5e48bf4e3$export$c80d8749c6106849 = {
    prefix: "fab",
    iconName: "keybase",
    icon: [
        448,
        512,
        [],
        "f4f5",
        "M286.17 419a18 18 0 1 0 18 18 18 18 0 0 0-18-18zm111.92-147.6c-9.5-14.62-39.37-52.45-87.26-73.71q-9.1-4.06-18.38-7.27a78.43 78.43 0 0 0-47.88-104.13c-12.41-4.1-23.33-6-32.41-5.77-.6-2-1.89-11 9.4-35L198.66 32l-5.48 7.56c-8.69 12.06-16.92 23.55-24.34 34.89a51 51 0 0 0-8.29-1.25c-41.53-2.45-39-2.33-41.06-2.33-50.61 0-50.75 52.12-50.75 45.88l-2.36 36.68c-1.61 27 19.75 50.21 47.63 51.85l8.93.54a214 214 0 0 0-46.29 35.54C14 304.66 14 374 14 429.77v33.64l23.32-29.8a148.6 148.6 0 0 0 14.56 37.56c5.78 10.13 14.87 9.45 19.64 7.33 4.21-1.87 10-6.92 3.75-20.11a178.29 178.29 0 0 1-15.76-53.13l46.82-59.83-24.66 74.11c58.23-42.4 157.38-61.76 236.25-38.59 34.2 10.05 67.45.69 84.74-23.84.72-1 1.2-2.16 1.85-3.22a156.09 156.09 0 0 1 2.8 28.43c0 23.3-3.69 52.93-14.88 81.64-2.52 6.46 1.76 14.5 8.6 15.74 7.42 1.57 15.33-3.1 18.37-11.15C429 443 434 414 434 382.32c0-38.58-13-77.46-35.91-110.92zM142.37 128.58l-15.7-.93-1.39 21.79 13.13.78a93 93 0 0 0 .32 19.57l-22.38-1.34a12.28 12.28 0 0 1-11.76-12.79L107 119c1-12.17 13.87-11.27 13.26-11.32l29.11 1.73a144.35 144.35 0 0 0-7 19.17zm148.42 172.18a10.51 10.51 0 0 1-14.35-1.39l-9.68-11.49-34.42 27a8.09 8.09 0 0 1-11.13-1.08l-15.78-18.64a7.38 7.38 0 0 1 1.34-10.34l34.57-27.18-14.14-16.74-17.09 13.45a7.75 7.75 0 0 1-10.59-1s-3.72-4.42-3.8-4.53a7.38 7.38 0 0 1 1.37-10.34L214 225.19s-18.51-22-18.6-22.14a9.56 9.56 0 0 1 1.74-13.42 10.38 10.38 0 0 1 14.3 1.37l81.09 96.32a9.58 9.58 0 0 1-1.74 13.44zM187.44 419a18 18 0 1 0 18 18 18 18 0 0 0-18-18z"
    ]
};
var $ef0249c5e48bf4e3$export$fbfbf4eeb373a6ab = {
    prefix: "fab",
    iconName: "apple-pay",
    icon: [
        640,
        512,
        [],
        "f415",
        "M116.9 158.5c-7.5 8.9-19.5 15.9-31.5 14.9-1.5-12 4.4-24.8 11.3-32.6 7.5-9.1 20.6-15.6 31.3-16.1 1.2 12.4-3.7 24.7-11.1 33.8m10.9 17.2c-17.4-1-32.3 9.9-40.5 9.9-8.4 0-21-9.4-34.8-9.1-17.9.3-34.5 10.4-43.6 26.5-18.8 32.3-4.9 80 13.3 106.3 8.9 13 19.5 27.3 33.5 26.8 13.3-.5 18.5-8.6 34.5-8.6 16.1 0 20.8 8.6 34.8 8.4 14.5-.3 23.6-13 32.5-26 10.1-14.8 14.3-29.1 14.5-29.9-.3-.3-28-10.9-28.3-42.9-.3-26.8 21.9-39.5 22.9-40.3-12.5-18.6-32-20.6-38.8-21.1m100.4-36.2v194.9h30.3v-66.6h41.9c38.3 0 65.1-26.3 65.1-64.3s-26.4-64-64.1-64h-73.2zm30.3 25.5h34.9c26.3 0 41.3 14 41.3 38.6s-15 38.8-41.4 38.8h-34.8V165zm162.2 170.9c19 0 36.6-9.6 44.6-24.9h.6v23.4h28v-97c0-28.1-22.5-46.3-57.1-46.3-32.1 0-55.9 18.4-56.8 43.6h27.3c2.3-12 13.4-19.9 28.6-19.9 18.5 0 28.9 8.6 28.9 24.5v10.8l-37.8 2.3c-35.1 2.1-54.1 16.5-54.1 41.5.1 25.2 19.7 42 47.8 42zm8.2-23.1c-16.1 0-26.4-7.8-26.4-19.6 0-12.3 9.9-19.4 28.8-20.5l33.6-2.1v11c0 18.2-15.5 31.2-36 31.2zm102.5 74.6c29.5 0 43.4-11.3 55.5-45.4L640 193h-30.8l-35.6 115.1h-.6L537.4 193h-31.6L557 334.9l-2.8 8.6c-4.6 14.6-12.1 20.3-25.5 20.3-2.4 0-7-.3-8.9-.5v23.4c1.8.4 9.3.7 11.6.7z"
    ]
};
var $ef0249c5e48bf4e3$export$369427eba18eb826 = {
    prefix: "fab",
    iconName: "padlet",
    icon: [
        640,
        512,
        [],
        "e4a0",
        "M297.9 0L298 .001C305.6 .1078 312.4 4.72 315.5 11.78L447.5 320.3L447.8 320.2L448 320.6L445.2 330.6L402.3 488.6C398.6 504.8 382.6 514.9 366.5 511.2L298.1 495.6L229.6 511.2C213.5 514.9 197.5 504.8 193.8 488.6L150.9 330.6L148.2 320.6L148.3 320.2L280.4 11.78C283.4 4.797 290.3 .1837 297.9 .0006L297.9 0zM160.1 322.1L291.1 361.2L298 483.7L305.9 362.2L436.5 322.9L436.7 322.8L305.7 347.9L297.1 27.72L291.9 347.9L160.1 322.1zM426 222.6L520.4 181.6H594.2L437.2 429.2L468.8 320.2L426 222.6zM597.5 181.4L638.9 257.6C642.9 265.1 635 273.5 627.3 269.8L579.7 247.1L597.5 181.4zM127.3 318.5L158.7 430L1.61 154.5C-4.292 144.1 7.128 132.5 17.55 138.3L169.4 222.5L127.3 318.5z"
    ]
};
var $ef0249c5e48bf4e3$export$448eb0f9d8323c85 = {
    prefix: "fab",
    iconName: "amazon-pay",
    icon: [
        640,
        512,
        [],
        "f42c",
        "M14 325.3c2.3-4.2 5.2-4.9 9.7-2.5 10.4 5.6 20.6 11.4 31.2 16.7a595.88 595.88 0 0 0 127.4 46.3 616.61 616.61 0 0 0 63.2 11.8 603.33 603.33 0 0 0 95 5.2c17.4-.4 34.8-1.8 52.1-3.8a603.66 603.66 0 0 0 163.3-42.8c2.9-1.2 5.9-2 9.1-1.2 6.7 1.8 9 9 4.1 13.9a70 70 0 0 1-9.6 7.4c-30.7 21.1-64.2 36.4-99.6 47.9a473.31 473.31 0 0 1-75.1 17.6 431 431 0 0 1-53.2 4.8 21.3 21.3 0 0 0-2.5.3H308a21.3 21.3 0 0 0-2.5-.3c-3.6-.2-7.2-.3-10.7-.4a426.3 426.3 0 0 1-50.4-5.3A448.4 448.4 0 0 1 164 420a443.33 443.33 0 0 1-145.6-87c-1.8-1.6-3-3.8-4.4-5.7zM172 65.1l-4.3.6a80.92 80.92 0 0 0-38 15.1c-2.4 1.7-4.6 3.5-7.1 5.4a4.29 4.29 0 0 1-.4-1.4c-.4-2.7-.8-5.5-1.3-8.2-.7-4.6-3-6.6-7.6-6.6h-11.5c-6.9 0-8.2 1.3-8.2 8.2v209.3c0 1 0 2 .1 3 .2 3 2 4.9 4.9 5 7 .1 14.1.1 21.1 0 2.9 0 4.7-2 5-5 .1-1 .1-2 .1-3v-72.4c1.1.9 1.7 1.4 2.2 1.9 17.9 14.9 38.5 19.8 61 15.4 20.4-4 34.6-16.5 43.8-34.9 7-13.9 9.9-28.7 10.3-44.1.5-17.1-1.2-33.9-8.1-49.8-8.5-19.6-22.6-32.5-43.9-36.9-3.2-.7-6.5-1-9.8-1.5-2.8-.1-5.5-.1-8.3-.1zM124.6 107a3.48 3.48 0 0 1 1.7-3.3c13.7-9.5 28.8-14.5 45.6-13.2 14.9 1.1 27.1 8.4 33.5 25.9 3.9 10.7 4.9 21.8 4.9 33 0 10.4-.8 20.6-4 30.6-6.8 21.3-22.4 29.4-42.6 28.5-14-.6-26.2-6-37.4-13.9a3.57 3.57 0 0 1-1.7-3.3c.1-14.1 0-28.1 0-42.2s.1-28 0-42.1zm205.7-41.9c-1 .1-2 .3-2.9.4a148 148 0 0 0-28.9 4.1c-6.1 1.6-12 3.8-17.9 5.8-3.6 1.2-5.4 3.8-5.3 7.7.1 3.3-.1 6.6 0 9.9.1 4.8 2.1 6.1 6.8 4.9 7.8-2 15.6-4.2 23.5-5.7 12.3-2.3 24.7-3.3 37.2-1.4 6.5 1 12.6 2.9 16.8 8.4 3.7 4.8 5.1 10.5 5.3 16.4.3 8.3.2 16.6.3 24.9a7.84 7.84 0 0 1-.2 1.4c-.5-.1-.9 0-1.3-.1a180.56 180.56 0 0 0-32-4.9c-11.3-.6-22.5.1-33.3 3.9-12.9 4.5-23.3 12.3-29.4 24.9-4.7 9.8-5.4 20.2-3.9 30.7 2 14 9 24.8 21.4 31.7 11.9 6.6 24.8 7.4 37.9 5.4 15.1-2.3 28.5-8.7 40.3-18.4a7.36 7.36 0 0 1 1.6-1.1c.6 3.8 1.1 7.4 1.8 11 .6 3.1 2.5 5.1 5.4 5.2 5.4.1 10.9.1 16.3 0a4.84 4.84 0 0 0 4.8-4.7 26.2 26.2 0 0 0 .1-2.8v-106a80 80 0 0 0-.9-12.9c-1.9-12.9-7.4-23.5-19-30.4-6.7-4-14.1-6-21.8-7.1-3.6-.5-7.2-.8-10.8-1.3-3.9.1-7.9.1-11.9.1zm35 127.7a3.33 3.33 0 0 1-1.5 3c-11.2 8.1-23.5 13.5-37.4 14.9-5.7.6-11.4.4-16.8-1.8a20.08 20.08 0 0 1-12.4-13.3 32.9 32.9 0 0 1-.1-19.4c2.5-8.3 8.4-13 16.4-15.6a61.33 61.33 0 0 1 24.8-2.2c8.4.7 16.6 2.3 25 3.4 1.6.2 2.1 1 2.1 2.6-.1 4.8 0 9.5 0 14.3s-.2 9.4-.1 14.1zm259.9 129.4c-1-5-4.8-6.9-9.1-8.3a88.42 88.42 0 0 0-21-3.9 147.32 147.32 0 0 0-39.2 1.9c-14.3 2.7-27.9 7.3-40 15.6a13.75 13.75 0 0 0-3.7 3.5 5.11 5.11 0 0 0-.5 4c.4 1.5 2.1 1.9 3.6 1.8a16.2 16.2 0 0 0 2.2-.1c7.8-.8 15.5-1.7 23.3-2.5 11.4-1.1 22.9-1.8 34.3-.9a71.64 71.64 0 0 1 14.4 2.7c5.1 1.4 7.4 5.2 7.6 10.4.4 8-1.4 15.7-3.5 23.3-4.1 15.4-10 30.3-15.8 45.1a17.6 17.6 0 0 0-1 3c-.5 2.9 1.2 4.8 4.1 4.1a10.56 10.56 0 0 0 4.8-2.5 145.91 145.91 0 0 0 12.7-13.4c12.8-16.4 20.3-35.3 24.7-55.6.8-3.6 1.4-7.3 2.1-10.9v-17.3zM493.1 199q-19.35-53.55-38.7-107.2c-2-5.7-4.2-11.3-6.3-16.9-1.1-2.9-3.2-4.8-6.4-4.8-7.6-.1-15.2-.2-22.9-.1-2.5 0-3.7 2-3.2 4.5a43.1 43.1 0 0 0 1.9 6.1q29.4 72.75 59.1 145.5c1.7 4.1 2.1 7.6.2 11.8-3.3 7.3-5.9 15-9.3 22.3-3 6.5-8 11.4-15.2 13.3a42.13 42.13 0 0 1-15.4 1.1c-2.5-.2-5-.8-7.5-1-3.4-.2-5.1 1.3-5.2 4.8q-.15 5 0 9.9c.1 5.5 2 8 7.4 8.9a108.18 108.18 0 0 0 16.9 2c17.1.4 30.7-6.5 39.5-21.4a131.63 131.63 0 0 0 9.2-18.4q35.55-89.7 70.6-179.6a26.62 26.62 0 0 0 1.6-5.5c.4-2.8-.9-4.4-3.7-4.4-6.6-.1-13.3 0-19.9 0a7.54 7.54 0 0 0-7.7 5.2c-.5 1.4-1.1 2.7-1.6 4.1l-34.8 100c-2.5 7.2-5.1 14.5-7.7 22.2-.4-1.1-.6-1.7-.9-2.4z"
    ]
};
var $ef0249c5e48bf4e3$export$be5db653ba5b5871 = {
    prefix: "fab",
    iconName: "square-github",
    icon: [
        448,
        512,
        [
            "github-square"
        ],
        "f092",
        "M400 32H48C21.5 32 0 53.5 0 80v352c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48V80c0-26.5-21.5-48-48-48zM277.3 415.7c-8.4 1.5-11.5-3.7-11.5-8 0-5.4.2-33 .2-55.3 0-15.6-5.2-25.5-11.3-30.7 37-4.1 76-9.2 76-73.1 0-18.2-6.5-27.3-17.1-39 1.7-4.3 7.4-22-1.7-45-13.9-4.3-45.7 17.9-45.7 17.9-13.2-3.7-27.5-5.6-41.6-5.6-14.1 0-28.4 1.9-41.6 5.6 0 0-31.8-22.2-45.7-17.9-9.1 22.9-3.5 40.6-1.7 45-10.6 11.7-15.6 20.8-15.6 39 0 63.6 37.3 69 74.3 73.1-4.8 4.3-9.1 11.7-10.6 22.3-9.5 4.3-33.8 11.7-48.3-13.9-9.1-15.8-25.5-17.1-25.5-17.1-16.2-.2-1.1 10.2-1.1 10.2 10.8 5 18.4 24.2 18.4 24.2 9.7 29.7 56.1 19.7 56.1 19.7 0 13.9.2 36.5.2 40.6 0 4.3-3 9.5-11.5 8-66-22.1-112.2-84.9-112.2-158.3 0-91.8 70.2-161.5 162-161.5S388 165.6 388 257.4c.1 73.4-44.7 136.3-110.7 158.3zm-98.1-61.1c-1.9.4-3.7-.4-3.9-1.7-.2-1.5 1.1-2.8 3-3.2 1.9-.2 3.7.6 3.9 1.9.3 1.3-1 2.6-3 3zm-9.5-.9c0 1.3-1.5 2.4-3.5 2.4-2.2.2-3.7-.9-3.7-2.4 0-1.3 1.5-2.4 3.5-2.4 1.9-.2 3.7.9 3.7 2.4zm-13.7-1.1c-.4 1.3-2.4 1.9-4.1 1.3-1.9-.4-3.2-1.9-2.8-3.2.4-1.3 2.4-1.9 4.1-1.5 2 .6 3.3 2.1 2.8 3.4zm-12.3-5.4c-.9 1.1-2.8.9-4.3-.6-1.5-1.3-1.9-3.2-.9-4.1.9-1.1 2.8-.9 4.3.6 1.3 1.3 1.8 3.3.9 4.1zm-9.1-9.1c-.9.6-2.6 0-3.7-1.5s-1.1-3.2 0-3.9c1.1-.9 2.8-.2 3.7 1.3 1.1 1.5 1.1 3.3 0 4.1zm-6.5-9.7c-.9.9-2.4.4-3.5-.6-1.1-1.3-1.3-2.8-.4-3.5.9-.9 2.4-.4 3.5.6 1.1 1.3 1.3 2.8.4 3.5zm-6.7-7.4c-.4.9-1.7 1.1-2.8.4-1.3-.6-1.9-1.7-1.5-2.6.4-.6 1.5-.9 2.8-.4 1.3.7 1.9 1.8 1.5 2.6z"
    ]
};
var $ef0249c5e48bf4e3$export$5fe0a956971aa3c2 = $ef0249c5e48bf4e3$export$be5db653ba5b5871;
var $ef0249c5e48bf4e3$export$7872bf6ac6945976 = {
    prefix: "fab",
    iconName: "stumbleupon",
    icon: [
        512,
        512,
        [],
        "f1a4",
        "M502.9 266v69.7c0 62.1-50.3 112.4-112.4 112.4-61.8 0-112.4-49.8-112.4-111.3v-70.2l34.3 16 51.1-15.2V338c0 14.7 12 26.5 26.7 26.5S417 352.7 417 338v-72h85.9zm-224.7-58.2l34.3 16 51.1-15.2V173c0-60.5-51.1-109-112.1-109-60.8 0-112.1 48.2-112.1 108.2v162.4c0 14.9-12 26.7-26.7 26.7S86 349.5 86 334.6V266H0v69.7C0 397.7 50.3 448 112.4 448c61.6 0 112.4-49.5 112.4-110.8V176.9c0-14.7 12-26.7 26.7-26.7s26.7 12 26.7 26.7v30.9z"
    ]
};
var $ef0249c5e48bf4e3$export$c9127779112e2ff8 = {
    prefix: "fab",
    iconName: "fedex",
    icon: [
        640,
        512,
        [],
        "f797",
        "M586 284.5l53.3-59.9h-62.4l-21.7 24.8-22.5-24.8H414v-16h56.1v-48.1H318.9V236h-.5c-9.6-11-21.5-14.8-35.4-14.8-28.4 0-49.8 19.4-57.3 44.9-18-59.4-97.4-57.6-121.9-14v-24.2H49v-26.2h60v-41.1H0V345h49v-77.5h48.9c-1.5 5.7-2.3 11.8-2.3 18.2 0 73.1 102.6 91.4 130.2 23.7h-42c-14.7 20.9-45.8 8.9-45.8-14.6h85.5c3.7 30.5 27.4 56.9 60.1 56.9 14.1 0 27-6.9 34.9-18.6h.5V345h212.2l22.1-25 22.3 25H640l-54-60.5zm-446.7-16.6c6.1-26.3 41.7-25.6 46.5 0h-46.5zm153.4 48.9c-34.6 0-34-62.8 0-62.8 32.6 0 34.5 62.8 0 62.8zm167.8 19.1h-94.4V169.4h95v30.2H405v33.9h55.5v28.1h-56.1v44.7h56.1v29.6zm-45.9-39.8v-24.4h56.1v-44l50.7 57-50.7 57v-45.6h-56.1zm138.6 10.3l-26.1 29.5H489l45.6-51.2-45.6-51.2h39.7l26.6 29.3 25.6-29.3h38.5l-45.4 51 46 51.4h-40.5l-26.3-29.5z"
    ]
};
var $ef0249c5e48bf4e3$export$3d9357caf53f9b59 = {
    prefix: "fab",
    iconName: "phoenix-framework",
    icon: [
        640,
        512,
        [],
        "f3dc",
        "M212.9 344.3c3.8-.1 22.8-1.4 25.6-2.2-2.4-2.6-43.6-1-68-49.6-4.3-8.6-7.5-17.6-6.4-27.6 2.9-25.5 32.9-30 52-18.5 36 21.6 63.3 91.3 113.7 97.5 37 4.5 84.6-17 108.2-45.4-.6-.1-.8-.2-1-.1-.4.1-.8.2-1.1.3-33.3 12.1-94.3 9.7-134.7-14.8-37.6-22.8-53.1-58.7-51.8-74.6 1.8-21.3 22.9-23.2 35.9-19.6 14.4 3.9 24.4 17.6 38.9 27.4 15.6 10.4 32.9 13.7 51.3 10.3 14.9-2.7 34.4-12.3 36.5-14.5-1.1-.1-1.8-.1-2.5-.2-6.2-.6-12.4-.8-18.5-1.7C279.8 194.5 262.1 47.4 138.5 37.9 94.2 34.5 39.1 46 2.2 72.9c-.8.6-1.5 1.2-2.2 1.8.1.2.1.3.2.5.8 0 1.6-.1 2.4-.2 6.3-1 12.5-.8 18.7.3 23.8 4.3 47.7 23.1 55.9 76.5 5.3 34.3-.7 50.8 8 86.1 19 77.1 91 107.6 127.7 106.4zM75.3 64.9c-.9-1-.9-1.2-1.3-2 12.1-2.6 24.2-4.1 36.6-4.8-1.1 14.7-22.2 21.3-35.3 6.8zm196.9 350.5c-42.8 1.2-92-26.7-123.5-61.4-4.6-5-16.8-20.2-18.6-23.4l.4-.4c6.6 4.1 25.7 18.6 54.8 27 24.2 7 48.1 6.3 71.6-3.3 22.7-9.3 41-.5 43.1 2.9-18.5 3.8-20.1 4.4-24 7.9-5.1 4.4-4.6 11.7 7 17.2 26.2 12.4 63-2.8 97.2 25.4 2.4 2 8.1 7.8 10.1 10.7-.1.2-.3.3-.4.5-4.8-1.5-16.4-7.5-40.2-9.3-24.7-2-46.3 5.3-77.5 6.2zm174.8-252c16.4-5.2 41.3-13.4 66.5-3.3 16.1 6.5 26.2 18.7 32.1 34.6 3.5 9.4 5.1 19.7 5.1 28.7-.2 0-.4 0-.6.1-.2-.4-.4-.9-.5-1.3-5-22-29.9-43.8-67.6-29.9-50.2 18.6-130.4 9.7-176.9-48-.7-.9-2.4-1.7-1.3-3.2.1-.2 2.1.6 3 1.3 18.1 13.4 38.3 21.9 60.3 26.2 30.5 6.1 54.6 2.9 79.9-5.2zm102.7 117.5c-32.4.2-33.8 50.1-103.6 64.4-18.2 3.7-38.7 4.6-44.9 4.2v-.4c2.8-1.5 14.7-2.6 29.7-16.6 7.9-7.3 15.3-15.1 22.8-22.9 19.5-20.2 41.4-42.2 81.9-39 23.1 1.8 29.3 8.2 36.1 12.7.3.2.4.5.7.9-.5 0-.7.1-.9 0-7-2.7-14.3-3.3-21.8-3.3zm-12.3-24.1c-.1.2-.1.4-.2.6-28.9-4.4-48-7.9-68.5 4-17 9.9-31.4 20.5-62 24.4-27.1 3.4-45.1 2.4-66.1-8-.3-.2-.6-.4-1-.6 0-.2.1-.3.1-.5 24.9 3.8 36.4 5.1 55.5-5.8 22.3-12.9 40.1-26.6 71.3-31 29.6-4.1 51.3 2.5 70.9 16.9zM268.6 97.3c-.6-.6-1.1-1.2-2.1-2.3 7.6 0 29.7-1.2 53.4 8.4 19.7 8 32.2 21 50.2 32.9 11.1 7.3 23.4 9.3 36.4 8.1 4.3-.4 8.5-1.2 12.8-1.7.4-.1.9 0 1.5.3-.6.4-1.2.9-1.8 1.2-8.1 4-16.7 6.3-25.6 7.1-26.1 2.6-50.3-3.7-73.4-15.4-19.3-9.9-36.4-22.9-51.4-38.6zM640 335.7c-3.5 3.1-22.7 11.6-42.7 5.3-12.3-3.9-19.5-14.9-31.6-24.1-10-7.6-20.9-7.9-28.1-8.4.6-.8.9-1.2 1.2-1.4 14.8-9.2 30.5-12.2 47.3-6.5 12.5 4.2 19.2 13.5 30.4 24.2 10.8 10.4 21 9.9 23.1 10.5.1-.1.2 0 .4.4zm-212.5 137c2.2 1.2 1.6 1.5 1.5 2-18.5-1.4-33.9-7.6-46.8-22.2-21.8-24.7-41.7-27.9-48.6-29.7.5-.2.8-.4 1.1-.4 13.1.1 26.1.7 38.9 3.9 25.3 6.4 35 25.4 41.6 35.3 3.2 4.8 7.3 8.3 12.3 11.1z"
    ]
};
var $ef0249c5e48bf4e3$export$c18d8940c93637ce = {
    prefix: "fab",
    iconName: "shopify",
    icon: [
        448,
        512,
        [],
        "e057",
        "M388.32,104.1a4.66,4.66,0,0,0-4.4-4c-2,0-37.23-.8-37.23-.8s-21.61-20.82-29.62-28.83V503.2L442.76,472S388.72,106.5,388.32,104.1ZM288.65,70.47a116.67,116.67,0,0,0-7.21-17.61C271,32.85,255.42,22,237,22a15,15,0,0,0-4,.4c-.4-.8-1.2-1.2-1.6-2C223.4,11.63,213,7.63,200.58,8c-24,.8-48,18-67.25,48.83-13.61,21.62-24,48.84-26.82,70.06-27.62,8.4-46.83,14.41-47.23,14.81-14,4.4-14.41,4.8-16,18-1.2,10-38,291.82-38,291.82L307.86,504V65.67a41.66,41.66,0,0,0-4.4.4S297.86,67.67,288.65,70.47ZM233.41,87.69c-16,4.8-33.63,10.4-50.84,15.61,4.8-18.82,14.41-37.63,25.62-50,4.4-4.4,10.41-9.61,17.21-12.81C232.21,54.86,233.81,74.48,233.41,87.69ZM200.58,24.44A27.49,27.49,0,0,1,215,28c-6.4,3.2-12.81,8.41-18.81,14.41-15.21,16.42-26.82,42-31.62,66.45-14.42,4.41-28.83,8.81-42,12.81C131.33,83.28,163.75,25.24,200.58,24.44ZM154.15,244.61c1.6,25.61,69.25,31.22,73.25,91.66,2.8,47.64-25.22,80.06-65.65,82.47-48.83,3.2-75.65-25.62-75.65-25.62l10.4-44s26.82,20.42,48.44,18.82c14-.8,19.22-12.41,18.81-20.42-2-33.62-57.24-31.62-60.84-86.86-3.2-46.44,27.22-93.27,94.47-97.68,26-1.6,39.23,4.81,39.23,4.81L221.4,225.39s-17.21-8-37.63-6.4C154.15,221,153.75,239.8,154.15,244.61ZM249.42,82.88c0-12-1.6-29.22-7.21-43.63,18.42,3.6,27.22,24,31.23,36.43Q262.63,78.68,249.42,82.88Z"
    ]
};
var $ef0249c5e48bf4e3$export$a38c2efcceaf5a01 = {
    prefix: "fab",
    iconName: "neos",
    icon: [
        512,
        512,
        [],
        "f612",
        "M415.44 512h-95.11L212.12 357.46v91.1L125.69 512H28V29.82L68.47 0h108.05l123.74 176.13V63.45L386.69 0h97.69v461.5zM38.77 35.27V496l72-52.88V194l215.5 307.64h84.79l52.35-38.17h-78.27L69 13zm82.54 466.61l80-58.78v-101l-79.76-114.4v220.94L49 501.89h72.34zM80.63 10.77l310.6 442.57h82.37V10.77h-79.75v317.56L170.91 10.77zM311 191.65l72 102.81V15.93l-72 53v122.72z"
    ]
};
var $ef0249c5e48bf4e3$export$75f15eb229650b3a = {
    prefix: "fab",
    iconName: "square-threads",
    icon: [
        448,
        512,
        [],
        "e619",
        "M64 32C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64zM294.2 244.3c19.5 9.3 33.7 23.5 41.2 40.9c10.4 24.3 11.4 63.9-20.2 95.4c-24.2 24.1-53.5 35-95.1 35.3h-.2c-46.8-.3-82.8-16.1-106.9-46.8C91.5 341.8 80.4 303.7 80 256v-.1-.1c.4-47.7 11.5-85.7 33-113.1c24.2-30.7 60.2-46.5 106.9-46.8h.2c46.9 .3 83.3 16 108.2 46.6c12.3 15.1 21.3 33.3 27 54.4l-26.9 7.2c-4.7-17.2-11.9-31.9-21.4-43.6c-19.4-23.9-48.7-36.1-87-36.4c-38 .3-66.8 12.5-85.5 36.2c-17.5 22.3-26.6 54.4-26.9 95.5c.3 41.1 9.4 73.3 26.9 95.5c18.7 23.8 47.4 36 85.5 36.2c34.3-.3 56.9-8.4 75.8-27.3c21.5-21.5 21.1-47.9 14.2-64c-4-9.4-11.4-17.3-21.3-23.3c-2.4 18-7.9 32.2-16.5 43.2c-11.4 14.5-27.7 22.4-48.4 23.5c-15.7 .9-30.8-2.9-42.6-10.7c-13.9-9.2-22-23.2-22.9-39.5c-1.7-32.2 23.8-55.3 63.5-57.6c14.1-.8 27.3-.2 39.5 1.9c-1.6-9.9-4.9-17.7-9.8-23.4c-6.7-7.8-17.1-11.8-30.8-11.9h-.4c-11 0-26 3.1-35.6 17.6l-23-15.8c12.8-19.4 33.6-30.1 58.5-30.1h.6c41.8 .3 66.6 26.3 69.1 71.8c1.4 .6 2.8 1.2 4.2 1.9l.1 .5zm-71.8 67.5c17-.9 36.4-7.6 39.7-48.8c-8.8-1.9-18.6-2.9-29-2.9c-3.2 0-6.4 .1-9.6 .3c-28.6 1.6-38.1 15.5-37.4 27.9c.9 16.7 19 24.5 36.4 23.6l-.1-.1z"
    ]
};
var $ef0249c5e48bf4e3$export$5fb7eeed7d5e4dea = {
    prefix: "fab",
    iconName: "hackerrank",
    icon: [
        512,
        512,
        [],
        "f5f7",
        "M477.5 128C463 103.05 285.13 0 256.16 0S49.25 102.79 34.84 128s-14.49 230.8 0 256 192.38 128 221.32 128S463 409.08 477.49 384s14.51-231 .01-256zM316.13 414.22c-4 0-40.91-35.77-38-38.69.87-.87 6.26-1.48 17.55-1.83 0-26.23.59-68.59.94-86.32 0-2-.44-3.43-.44-5.85h-79.93c0 7.1-.46 36.2 1.37 72.88.23 4.54-1.58 6-5.74 5.94-10.13 0-20.27-.11-30.41-.08-4.1 0-5.87-1.53-5.74-6.11.92-33.44 3-84-.15-212.67v-3.17c-9.67-.35-16.38-1-17.26-1.84-2.92-2.92 34.54-38.69 38.49-38.69s41.17 35.78 38.27 38.69c-.87.87-7.9 1.49-16.77 1.84v3.16c-2.42 25.75-2 79.59-2.63 105.39h80.26c0-4.55.39-34.74-1.2-83.64-.1-3.39.95-5.17 4.21-5.2 11.07-.08 22.15-.13 33.23-.06 3.46 0 4.57 1.72 4.5 5.38C333 354.64 336 341.29 336 373.69c8.87.35 16.82 1 17.69 1.84 2.88 2.91-33.62 38.69-37.58 38.69z"
    ]
};
var $ef0249c5e48bf4e3$export$5c5693a4f82cd9eb = {
    prefix: "fab",
    iconName: "researchgate",
    icon: [
        448,
        512,
        [],
        "f4f8",
        "M0 32v448h448V32H0zm262.2 334.4c-6.6 3-33.2 6-50-14.2-9.2-10.6-25.3-33.3-42.2-63.6-8.9 0-14.7 0-21.4-.6v46.4c0 23.5 6 21.2 25.8 23.9v8.1c-6.9-.3-23.1-.8-35.6-.8-13.1 0-26.1.6-33.6.8v-8.1c15.5-2.9 22-1.3 22-23.9V225c0-22.6-6.4-21-22-23.9V193c25.8 1 53.1-.6 70.9-.6 31.7 0 55.9 14.4 55.9 45.6 0 21.1-16.7 42.2-39.2 47.5 13.6 24.2 30 45.6 42.2 58.9 7.2 7.8 17.2 14.7 27.2 14.7v7.3zm22.9-135c-23.3 0-32.2-15.7-32.2-32.2V167c0-12.2 8.8-30.4 34-30.4s30.4 17.9 30.4 17.9l-10.7 7.2s-5.5-12.5-19.7-12.5c-7.9 0-19.7 7.3-19.7 19.7v26.8c0 13.4 6.6 23.3 17.9 23.3 14.1 0 21.5-10.9 21.5-26.8h-17.9v-10.7h30.4c0 20.5 4.7 49.9-34 49.9zm-116.5 44.7c-9.4 0-13.6-.3-20-.8v-69.7c6.4-.6 15-.6 22.5-.6 23.3 0 37.2 12.2 37.2 34.5 0 21.9-15 36.6-39.7 36.6z"
    ]
};
var $ef0249c5e48bf4e3$export$dcdf312747bb3471 = {
    prefix: "fab",
    iconName: "swift",
    icon: [
        448,
        512,
        [],
        "f8e1",
        "M448 156.09c0-4.51-.08-9-.2-13.52a196.31 196.31 0 0 0-2.58-29.42 99.62 99.62 0 0 0-9.22-28A94.08 94.08 0 0 0 394.84 44a99.17 99.17 0 0 0-28-9.22 195 195 0 0 0-29.43-2.59c-4.51-.12-9-.17-13.52-.2H124.14c-4.51 0-9 .08-13.52.2-2.45.07-4.91.15-7.37.27a171.68 171.68 0 0 0-22.06 2.32 103.06 103.06 0 0 0-21.21 6.1q-3.46 1.45-6.81 3.12a94.66 94.66 0 0 0-18.39 12.32c-1.88 1.61-3.69 3.28-5.43 5A93.86 93.86 0 0 0 12 85.17a99.45 99.45 0 0 0-9.22 28 196.31 196.31 0 0 0-2.54 29.4c-.13 4.51-.18 9-.21 13.52v199.83c0 4.51.08 9 .21 13.51a196.08 196.08 0 0 0 2.58 29.42 99.3 99.3 0 0 0 9.22 28A94.31 94.31 0 0 0 53.17 468a99.47 99.47 0 0 0 28 9.21 195 195 0 0 0 29.43 2.59c4.5.12 9 .17 13.52.2H323.91c4.51 0 9-.08 13.52-.2a196.59 196.59 0 0 0 29.44-2.59 99.57 99.57 0 0 0 28-9.21A94.22 94.22 0 0 0 436 426.84a99.3 99.3 0 0 0 9.22-28 194.79 194.79 0 0 0 2.59-29.42c.12-4.5.17-9 .2-13.51V172.14c-.01-5.35-.01-10.7-.01-16.05zm-69.88 241c-20-38.93-57.23-29.27-76.31-19.47-1.72 1-3.48 2-5.25 3l-.42.25c-39.5 21-92.53 22.54-145.85-.38A234.64 234.64 0 0 1 45 290.12a230.63 230.63 0 0 0 39.17 23.37c56.36 26.4 113 24.49 153 0-57-43.85-104.6-101-141.09-147.22a197.09 197.09 0 0 1-18.78-25.9c43.7 40 112.7 90.22 137.48 104.12-52.57-55.49-98.89-123.94-96.72-121.74 82.79 83.42 159.18 130.59 159.18 130.59 2.88 1.58 5 2.85 6.73 4a127.44 127.44 0 0 0 4.16-12.47c13.22-48.33-1.66-103.58-35.31-149.2C329.61 141.75 375 229.34 356.4 303.42c-.44 1.73-.95 3.4-1.44 5.09 38.52 47.4 28.04 98.17 23.13 88.59z"
    ]
};
var $ef0249c5e48bf4e3$export$9df3e2a7a3f59b3b = {
    prefix: "fab",
    iconName: "angular",
    icon: [
        448,
        512,
        [],
        "f420",
        "M185.7 268.1h76.2l-38.1-91.6-38.1 91.6zM223.8 32L16 106.4l31.8 275.7 176 97.9 176-97.9 31.8-275.7zM354 373.8h-48.6l-26.2-65.4H168.6l-26.2 65.4H93.7L223.8 81.5z"
    ]
};
var $ef0249c5e48bf4e3$export$90ae1a3824ece6f2 = {
    prefix: "fab",
    iconName: "speakap",
    icon: [
        448,
        512,
        [],
        "f3f3",
        "M64 391.78C-15.41 303.59-8 167.42 80.64 87.64s224.8-73 304.21 15.24 72 224.36-16.64 304.14c-18.74 16.87 64 43.09 42 52.26-82.06 34.21-253.91 35-346.23-67.5zm213.31-211.6l38.5-40.86c-9.61-8.89-32-26.83-76.17-27.6-52.33-.91-95.86 28.3-96.77 80-.2 11.33.29 36.72 29.42 54.83 34.46 21.42 86.52 21.51 86 52.26-.37 21.28-26.42 25.81-38.59 25.6-3-.05-30.23-.46-47.61-24.62l-40 42.61c28.16 27 59 32.62 83.49 33.05 10.23.18 96.42.33 97.84-81 .28-15.81-2.07-39.72-28.86-56.59-34.36-21.64-85-19.45-84.43-49.75.41-23.25 31-25.37 37.53-25.26.43 0 26.62.26 39.62 17.37z"
    ]
};
var $ef0249c5e48bf4e3$export$a9e7bf021125ee89 = {
    prefix: "fab",
    iconName: "angrycreative",
    icon: [
        640,
        512,
        [],
        "f36e",
        "M640 238.2l-3.2 28.2-34.5 2.3-2 18.1 34.5-2.3-3.2 28.2-34.4 2.2-2.3 20.1 34.4-2.2-3 26.1-64.7 4.1 12.7-113.2L527 365.2l-31.9 2-23.8-117.8 30.3-2 13.6 79.4 31.7-82.4 93.1-6.2zM426.8 371.5l28.3-1.8L468 249.6l-28.4 1.9-12.8 120zM162 388.1l-19.4-36-3.5 37.4-28.2 1.7 2.7-29.1c-11 18-32 34.3-56.9 35.8C23.9 399.9-3 377 .3 339.7c2.6-29.3 26.7-62.8 67.5-65.4 37.7-2.4 47.6 23.2 51.3 28.8l2.8-30.8 38.9-2.5c20.1-1.3 38.7 3.7 42.5 23.7l2.6-26.6 64.8-4.2-2.7 27.9-36.4 2.4-1.7 17.9 36.4-2.3-2.7 27.9-36.4 2.3-1.9 19.9 36.3-2.3-2.1 20.8 55-117.2 23.8-1.6L370.4 369l8.9-85.6-22.3 1.4 2.9-27.9 75-4.9-3 28-24.3 1.6-9.7 91.9-58 3.7-4.3-15.6-39.4 2.5-8 16.3-126.2 7.7zm-44.3-70.2l-26.4 1.7C84.6 307.2 76.9 303 65 303.8c-19 1.2-33.3 17.5-34.6 33.3-1.4 16 7.3 32.5 28.7 31.2 12.8-.8 21.3-8.6 28.9-18.9l27-1.7 2.7-29.8zm56.1-7.7c1.2-12.9-7.6-13.6-26.1-12.4l-2.7 28.5c14.2-.9 27.5-2.1 28.8-16.1zm21.1 70.8l5.8-60c-5 13.5-14.7 21.1-27.9 26.6l22.1 33.4zm135.4-45l-7.9-37.8-15.8 39.3 23.7-1.5zm-170.1-74.6l-4.3-17.5-39.6 2.6-8.1 18.2-31.9 2.1 57-121.9 23.9-1.6 30.7 102 9.9-104.7 27-1.8 37.8 63.6 6.5-66.6 28.5-1.9-4 41.2c7.4-13.5 22.9-44.7 63.6-47.5 40.5-2.8 52.4 29.3 53.4 30.3l3.3-32 39.3-2.7c12.7-.9 27.8.3 36.3 9.7l-4.4-11.9 32.2-2.2 12.9 43.2 23-45.7 31-2.2-43.6 78.4-4.8 44.3-28.4 1.9 4.8-44.3-15.8-43c1 22.3-9.2 40.1-32 49.6l25.2 38.8-36.4 2.4-19.2-36.8-4 38.3-28.4 1.9 3.3-31.5c-6.7 9.3-19.7 35.4-59.6 38-26.2 1.7-45.6-10.3-55.4-39.2l-4 40.3-25 1.6-37.6-63.3-6.3 66.2-56.8 3.7zm276.6-82.1c10.2-.7 17.5-2.1 21.6-4.3 4.5-2.4 7-6.4 7.6-12.1.6-5.3-.6-8.8-3.4-10.4-3.6-2.1-10.6-2.8-22.9-2l-2.9 28.8zM327.7 214c5.6 5.9 12.7 8.5 21.3 7.9 4.7-.3 9.1-1.8 13.3-4.1 5.5-3 10.6-8 15.1-14.3l-34.2 2.3 2.4-23.9 63.1-4.3 1.2-12-31.2 2.1c-4.1-3.7-7.8-6.6-11.1-8.1-4-1.7-8.1-2.8-12.2-2.5-8 .5-15.3 3.6-22 9.2-7.7 6.4-12 14.5-12.9 24.4-1.1 9.6 1.4 17.3 7.2 23.3zm-201.3 8.2l23.8-1.6-8.3-37.6-15.5 39.2z"
    ]
};
var $ef0249c5e48bf4e3$export$9ee2f35ed1fe0fd4 = {
    prefix: "fab",
    iconName: "y-combinator",
    icon: [
        448,
        512,
        [],
        "f23b",
        "M448 32v448H0V32h448zM236 287.5L313.5 142h-32.7L235 233c-4.7 9.3-9 18.3-12.8 26.8L210 233l-45.2-91h-35l76.7 143.8v94.5H236v-92.8z"
    ]
};
var $ef0249c5e48bf4e3$export$c966a5d80266ef06 = {
    prefix: "fab",
    iconName: "empire",
    icon: [
        496,
        512,
        [],
        "f1d1",
        "M287.6 54.2c-10.8-2.2-22.1-3.3-33.5-3.6V32.4c78.1 2.2 146.1 44 184.6 106.6l-15.8 9.1c-6.1-9.7-12.7-18.8-20.2-27.1l-18 15.5c-26-29.6-61.4-50.7-101.9-58.4l4.8-23.9zM53.4 322.4l23-7.7c-6.4-18.3-10-38.2-10-58.7s3.3-40.4 9.7-58.7l-22.7-7.7c3.6-10.8 8.3-21.3 13.6-31l-15.8-9.1C34 181 24.1 217.5 24.1 256s10 75 27.1 106.6l15.8-9.1c-5.3-10-9.7-20.3-13.6-31.1zM213.1 434c-40.4-8-75.8-29.1-101.9-58.7l-18 15.8c-7.5-8.6-14.4-17.7-20.2-27.4l-16 9.4c38.5 62.3 106.8 104.3 184.9 106.6v-18.3c-11.3-.3-22.7-1.7-33.5-3.6l4.7-23.8zM93.3 120.9l18 15.5c26-29.6 61.4-50.7 101.9-58.4l-4.7-23.8c10.8-2.2 22.1-3.3 33.5-3.6V32.4C163.9 34.6 95.9 76.4 57.4 139l15.8 9.1c6-9.7 12.6-18.9 20.1-27.2zm309.4 270.2l-18-15.8c-26 29.6-61.4 50.7-101.9 58.7l4.7 23.8c-10.8 1.9-22.1 3.3-33.5 3.6v18.3c78.1-2.2 146.4-44.3 184.9-106.6l-16.1-9.4c-5.7 9.7-12.6 18.8-20.1 27.4zM496 256c0 137-111 248-248 248S0 393 0 256 111 8 248 8s248 111 248 248zm-12.2 0c0-130.1-105.7-235.8-235.8-235.8S12.2 125.9 12.2 256 117.9 491.8 248 491.8 483.8 386.1 483.8 256zm-39-106.6l-15.8 9.1c5.3 9.7 10 20.2 13.6 31l-22.7 7.7c6.4 18.3 9.7 38.2 9.7 58.7s-3.6 40.4-10 58.7l23 7.7c-3.9 10.8-8.3 21-13.6 31l15.8 9.1C462 331 471.9 294.5 471.9 256s-9.9-75-27.1-106.6zm-183 177.7c16.3-3.3 30.4-11.6 40.7-23.5l51.2 44.8c11.9-13.6 21.3-29.3 27.1-46.8l-64.2-22.1c2.5-7.5 3.9-15.2 3.9-23.5s-1.4-16.1-3.9-23.5l64.5-22.1c-6.1-17.4-15.5-33.2-27.4-46.8l-51.2 44.8c-10.2-11.9-24.4-20.5-40.7-23.8l13.3-66.4c-8.6-1.9-17.7-2.8-27.1-2.8-9.4 0-18.5.8-27.1 2.8l13.3 66.4c-16.3 3.3-30.4 11.9-40.7 23.8l-51.2-44.8c-11.9 13.6-21.3 29.3-27.4 46.8l64.5 22.1c-2.5 7.5-3.9 15.2-3.9 23.5s1.4 16.1 3.9 23.5l-64.2 22.1c5.8 17.4 15.2 33.2 27.1 46.8l51.2-44.8c10.2 11.9 24.4 20.2 40.7 23.5l-13.3 66.7c8.6 1.7 17.7 2.8 27.1 2.8 9.4 0 18.5-1.1 27.1-2.8l-13.3-66.7z"
    ]
};
var $ef0249c5e48bf4e3$export$9e2c7c55d2fddd0 = {
    prefix: "fab",
    iconName: "envira",
    icon: [
        448,
        512,
        [],
        "f299",
        "M0 32c477.6 0 366.6 317.3 367.1 366.3L448 480h-26l-70.4-71.2c-39 4.2-124.4 34.5-214.4-37C47 300.3 52 214.7 0 32zm79.7 46c-49.7-23.5-5.2 9.2-5.2 9.2 45.2 31.2 66 73.7 90.2 119.9 31.5 60.2 79 139.7 144.2 167.7 65 28 34.2 12.5 6-8.5-28.2-21.2-68.2-87-91-130.2-31.7-60-61-118.6-144.2-158.1z"
    ]
};
var $ef0249c5e48bf4e3$export$1c14974e1904bc76 = {
    prefix: "fab",
    iconName: "square-gitlab",
    icon: [
        448,
        512,
        [
            "gitlab-square"
        ],
        "e5ae",
        "M48 32H400C426.5 32 448 53.5 448 80V432C448 458.5 426.5 480 400 480H48C21.5 480 0 458.5 0 432V80C0 53.5 21.5 32 48 32zM382.1 224.9L337.5 108.5C336.6 106.2 334.9 104.2 332.9 102.9C331.3 101.9 329.5 101.3 327.7 101.1C325.9 100.9 324 101.2 322.3 101.8C320.6 102.5 319 103.5 317.8 104.9C316.6 106.3 315.7 107.9 315.2 109.7L285 201.9H162.1L132.9 109.7C132.4 107.9 131.4 106.3 130.2 104.9C128.1 103.6 127.4 102.5 125.7 101.9C123.1 101.2 122.1 100.1 120.3 101.1C118.5 101.3 116.7 101.9 115.1 102.9C113.1 104.2 111.5 106.2 110.6 108.5L65.94 224.9L65.47 226.1C59.05 242.9 58.26 261.3 63.22 278.6C68.18 295.9 78.62 311.1 92.97 321.9L93.14 322L93.52 322.3L161.4 373.2L215.6 414.1C217.1 415.1 220.9 416.9 223.9 416.9C226.9 416.9 229.9 415.1 232.3 414.1L286.4 373.2L354.8 322L355 321.9C369.4 311 379.8 295.8 384.8 278.6C389.7 261.3 388.1 242.9 382.5 226.1L382.1 224.9z"
    ]
};
var $ef0249c5e48bf4e3$export$4459a47a802afa29 = $ef0249c5e48bf4e3$export$1c14974e1904bc76;
var $ef0249c5e48bf4e3$export$9d71d8f56add75cb = {
    prefix: "fab",
    iconName: "studiovinari",
    icon: [
        512,
        512,
        [],
        "f3f8",
        "M480.3 187.7l4.2 28v28l-25.1 44.1-39.8 78.4-56.1 67.5-79.1 37.8-17.7 24.5-7.7 12-9.6 4s17.3-63.6 19.4-63.6c2.1 0 20.3.7 20.3.7l66.7-38.6-92.5 26.1-55.9 36.8-22.8 28-6.6 1.4 20.8-73.6 6.9-5.5 20.7 12.9 88.3-45.2 56.8-51.5 14.8-68.4-125.4 23.3 15.2-18.2-173.4-53.3 81.9-10.5-166-122.9L133.5 108 32.2 0l252.9 126.6-31.5-38L378 163 234.7 64l18.7 38.4-49.6-18.1L158.3 0l194.6 122L310 66.2l108 96.4 12-8.9-21-16.4 4.2-37.8L451 89.1l29.2 24.7 11.5 4.2-7 6.2 8.5 12-13.1 7.4-10.3 20.2 10.5 23.9z"
    ]
};
var $ef0249c5e48bf4e3$export$13581f4cc240d7d9 = {
    prefix: "fab",
    iconName: "pied-piper",
    icon: [
        480,
        512,
        [],
        "f2ae",
        "M455.93,23.2C429.23,30,387.79,51.69,341.35,90.66A206,206,0,0,0,240,64C125.13,64,32,157.12,32,272s93.13,208,208,208,208-93.13,208-208a207.25,207.25,0,0,0-58.75-144.81,155.35,155.35,0,0,0-17,27.4A176.16,176.16,0,0,1,417.1,272c0,97.66-79.44,177.11-177.09,177.11a175.81,175.81,0,0,1-87.63-23.4c82.94-107.33,150.79-37.77,184.31-226.65,5.79-32.62,28-94.26,126.23-160.18C471,33.45,465.35,20.8,455.93,23.2ZM125,406.4A176.66,176.66,0,0,1,62.9,272C62.9,174.34,142.35,94.9,240,94.9a174,174,0,0,1,76.63,17.75C250.64,174.76,189.77,265.52,125,406.4Z"
    ]
};
var $ef0249c5e48bf4e3$export$8898e76262ada01d = {
    prefix: "fab",
    iconName: "wordpress",
    icon: [
        512,
        512,
        [],
        "f19a",
        "M61.7 169.4l101.5 278C92.2 413 43.3 340.2 43.3 256c0-30.9 6.6-60.1 18.4-86.6zm337.9 75.9c0-26.3-9.4-44.5-17.5-58.7-10.8-17.5-20.9-32.4-20.9-49.9 0-19.6 14.8-37.8 35.7-37.8.9 0 1.8.1 2.8.2-37.9-34.7-88.3-55.9-143.7-55.9-74.3 0-139.7 38.1-177.8 95.9 5 .2 9.7.3 13.7.3 22.2 0 56.7-2.7 56.7-2.7 11.5-.7 12.8 16.2 1.4 17.5 0 0-11.5 1.3-24.3 2l77.5 230.4L249.8 247l-33.1-90.8c-11.5-.7-22.3-2-22.3-2-11.5-.7-10.1-18.2 1.3-17.5 0 0 35.1 2.7 56 2.7 22.2 0 56.7-2.7 56.7-2.7 11.5-.7 12.8 16.2 1.4 17.5 0 0-11.5 1.3-24.3 2l76.9 228.7 21.2-70.9c9-29.4 16-50.5 16-68.7zm-139.9 29.3l-63.8 185.5c19.1 5.6 39.2 8.7 60.1 8.7 24.8 0 48.5-4.3 70.6-12.1-.6-.9-1.1-1.9-1.5-2.9l-65.4-179.2zm183-120.7c.9 6.8 1.4 14 1.4 21.9 0 21.6-4 45.8-16.2 76.2l-65 187.9C426.2 403 468.7 334.5 468.7 256c0-37-9.4-71.8-26-102.1zM504 256c0 136.8-111.3 248-248 248C119.2 504 8 392.7 8 256 8 119.2 119.2 8 256 8c136.7 0 248 111.2 248 248zm-11.4 0c0-130.5-106.2-236.6-236.6-236.6C125.5 19.4 19.4 125.5 19.4 256S125.6 492.6 256 492.6c130.5 0 236.6-106.1 236.6-236.6z"
    ]
};
var $ef0249c5e48bf4e3$export$91dcff48b72c75ce = {
    prefix: "fab",
    iconName: "product-hunt",
    icon: [
        512,
        512,
        [],
        "f288",
        "M326.3 218.8c0 20.5-16.7 37.2-37.2 37.2h-70.3v-74.4h70.3c20.5 0 37.2 16.7 37.2 37.2zM504 256c0 137-111 248-248 248S8 393 8 256 119 8 256 8s248 111 248 248zm-128.1-37.2c0-47.9-38.9-86.8-86.8-86.8H169.2v248h49.6v-74.4h70.3c47.9 0 86.8-38.9 86.8-86.8z"
    ]
};
var $ef0249c5e48bf4e3$export$53a067e7149deea9 = {
    prefix: "fab",
    iconName: "firefox",
    icon: [
        512,
        512,
        [],
        "f269",
        "M503.52,241.48c-.12-1.56-.24-3.12-.24-4.68v-.12l-.36-4.68v-.12a245.86,245.86,0,0,0-7.32-41.15c0-.12,0-.12-.12-.24l-1.08-4c-.12-.24-.12-.48-.24-.6-.36-1.2-.72-2.52-1.08-3.72-.12-.24-.12-.6-.24-.84-.36-1.2-.72-2.4-1.08-3.48-.12-.36-.24-.6-.36-1-.36-1.2-.72-2.28-1.2-3.48l-.36-1.08c-.36-1.08-.84-2.28-1.2-3.36a8.27,8.27,0,0,0-.36-1c-.48-1.08-.84-2.28-1.32-3.36-.12-.24-.24-.6-.36-.84-.48-1.2-1-2.28-1.44-3.48,0-.12-.12-.24-.12-.36-1.56-3.84-3.24-7.68-5-11.4l-.36-.72c-.48-1-.84-1.8-1.32-2.64-.24-.48-.48-1.08-.72-1.56-.36-.84-.84-1.56-1.2-2.4-.36-.6-.6-1.2-1-1.8s-.84-1.44-1.2-2.28c-.36-.6-.72-1.32-1.08-1.92s-.84-1.44-1.2-2.16a18.07,18.07,0,0,0-1.2-2c-.36-.72-.84-1.32-1.2-2s-.84-1.32-1.2-2-.84-1.32-1.2-1.92-.84-1.44-1.32-2.16a15.63,15.63,0,0,0-1.2-1.8L463.2,119a15.63,15.63,0,0,0-1.2-1.8c-.48-.72-1.08-1.56-1.56-2.28-.36-.48-.72-1.08-1.08-1.56l-1.8-2.52c-.36-.48-.6-.84-1-1.32-1-1.32-1.8-2.52-2.76-3.72a248.76,248.76,0,0,0-23.51-26.64A186.82,186.82,0,0,0,412,62.46c-4-3.48-8.16-6.72-12.48-9.84a162.49,162.49,0,0,0-24.6-15.12c-2.4-1.32-4.8-2.52-7.2-3.72a254,254,0,0,0-55.43-19.56c-1.92-.36-3.84-.84-5.64-1.2h-.12c-1-.12-1.8-.36-2.76-.48a236.35,236.35,0,0,0-38-4H255.14a234.62,234.62,0,0,0-45.48,5c-33.59,7.08-63.23,21.24-82.91,39-1.08,1-1.92,1.68-2.4,2.16l-.48.48H124l-.12.12.12-.12a.12.12,0,0,0,.12-.12l-.12.12a.42.42,0,0,1,.24-.12c14.64-8.76,34.92-16,49.44-19.56l5.88-1.44c.36-.12.84-.12,1.2-.24,1.68-.36,3.36-.72,5.16-1.08.24,0,.6-.12.84-.12C250.94,20.94,319.34,40.14,367,85.61a171.49,171.49,0,0,1,26.88,32.76c30.36,49.2,27.48,111.11,3.84,147.59-34.44,53-111.35,71.27-159,24.84a84.19,84.19,0,0,1-25.56-59,74.05,74.05,0,0,1,6.24-31c1.68-3.84,13.08-25.67,18.24-24.59-13.08-2.76-37.55,2.64-54.71,28.19-15.36,22.92-14.52,58.2-5,83.28a132.85,132.85,0,0,1-12.12-39.24c-12.24-82.55,43.31-153,94.31-170.51-27.48-24-96.47-22.31-147.71,15.36-29.88,22-51.23,53.16-62.51,90.36,1.68-20.88,9.6-52.08,25.8-83.88-17.16,8.88-39,37-49.8,62.88-15.6,37.43-21,82.19-16.08,124.79.36,3.24.72,6.36,1.08,9.6,19.92,117.11,122,206.38,244.78,206.38C392.77,503.42,504,392.19,504,255,503.88,250.48,503.76,245.92,503.52,241.48Z"
    ]
};
var $ef0249c5e48bf4e3$export$fcbc58842fe8e217 = {
    prefix: "fab",
    iconName: "linode",
    icon: [
        448,
        512,
        [],
        "f2b8",
        "M366.036,186.867l-59.5,36.871-.838,36.871-29.329-19.273-39.384,24.3c2.238,55.211,2.483,59.271,2.51,59.5l-97.2,65.359L127.214,285.748l108.1-62.01L195.09,197.761l-75.417,38.547L98.723,93.015,227.771,43.574,136.432,0,10.737,39.385,38.39,174.3l41.9,32.681L48.445,222.062,69.394,323.457,98.723,351.11,77.774,363.679l16.76,78.769L160.733,512c-10.8-74.842-11.658-78.641-11.725-78.773l77.925-55.3c16.759-12.57,15.083-10.894,15.083-10.894l.838,24.3,33.519,28.491-.838-77.093,46.927-33.519,26.815-18.435-2.514,36.033,25.139,17.6,6.7-74.579,58.657-43.575Z"
    ]
};
var $ef0249c5e48bf4e3$export$cc058e4fd428aead = {
    prefix: "fab",
    iconName: "goodreads",
    icon: [
        448,
        512,
        [],
        "f3a8",
        "M299.9 191.2c5.1 37.3-4.7 79-35.9 100.7-22.3 15.5-52.8 14.1-70.8 5.7-37.1-17.3-49.5-58.6-46.8-97.2 4.3-60.9 40.9-87.9 75.3-87.5 46.9-.2 71.8 31.8 78.2 78.3zM448 88v336c0 30.9-25.1 56-56 56H56c-30.9 0-56-25.1-56-56V88c0-30.9 25.1-56 56-56h336c30.9 0 56 25.1 56 56zM330 313.2s-.1-34-.1-217.3h-29v40.3c-.8.3-1.2-.5-1.6-1.2-9.6-20.7-35.9-46.3-76-46-51.9.4-87.2 31.2-100.6 77.8-4.3 14.9-5.8 30.1-5.5 45.6 1.7 77.9 45.1 117.8 112.4 115.2 28.9-1.1 54.5-17 69-45.2.5-1 1.1-1.9 1.7-2.9.2.1.4.1.6.2.3 3.8.2 30.7.1 34.5-.2 14.8-2 29.5-7.2 43.5-7.8 21-22.3 34.7-44.5 39.5-17.8 3.9-35.6 3.8-53.2-1.2-21.5-6.1-36.5-19-41.1-41.8-.3-1.6-1.3-1.3-2.3-1.3h-26.8c.8 10.6 3.2 20.3 8.5 29.2 24.2 40.5 82.7 48.5 128.2 37.4 49.9-12.3 67.3-54.9 67.4-106.3z"
    ]
};
var $ef0249c5e48bf4e3$export$df58e66e423b11a0 = {
    prefix: "fab",
    iconName: "square-odnoklassniki",
    icon: [
        448,
        512,
        [
            "odnoklassniki-square"
        ],
        "f264",
        "M184.2 177.1c0-22.1 17.9-40 39.8-40s39.8 17.9 39.8 40c0 22-17.9 39.8-39.8 39.8s-39.8-17.9-39.8-39.8zM448 80v352c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V80c0-26.5 21.5-48 48-48h352c26.5 0 48 21.5 48 48zm-305.1 97.1c0 44.6 36.4 80.9 81.1 80.9s81.1-36.2 81.1-80.9c0-44.8-36.4-81.1-81.1-81.1s-81.1 36.2-81.1 81.1zm174.5 90.7c-4.6-9.1-17.3-16.8-34.1-3.6 0 0-22.7 18-59.3 18s-59.3-18-59.3-18c-16.8-13.2-29.5-5.5-34.1 3.6-7.9 16.1 1.1 23.7 21.4 37 17.3 11.1 41.2 15.2 56.6 16.8l-12.9 12.9c-18.2 18-35.5 35.5-47.7 47.7-17.6 17.6 10.7 45.8 28.4 28.6l47.7-47.9c18.2 18.2 35.7 35.7 47.7 47.9 17.6 17.2 46-10.7 28.6-28.6l-47.7-47.7-13-12.9c15.5-1.6 39.1-5.9 56.2-16.8 20.4-13.3 29.3-21 21.5-37z"
    ]
};
var $ef0249c5e48bf4e3$export$8bab3f1c73ff1d0 = $ef0249c5e48bf4e3$export$df58e66e423b11a0;
var $ef0249c5e48bf4e3$export$49c67105b922997 = {
    prefix: "fab",
    iconName: "jsfiddle",
    icon: [
        576,
        512,
        [],
        "f1cc",
        "M510.634 237.462c-4.727-2.621-5.664-5.748-6.381-10.776-2.352-16.488-3.539-33.619-9.097-49.095-35.895-99.957-153.99-143.386-246.849-91.646-27.37 15.25-48.971 36.369-65.493 63.903-3.184-1.508-5.458-2.71-7.824-3.686-30.102-12.421-59.049-10.121-85.331 9.167-25.531 18.737-36.422 44.548-32.676 76.408.355 3.025-1.967 7.621-4.514 9.545-39.712 29.992-56.031 78.065-41.902 124.615 13.831 45.569 57.514 79.796 105.608 81.433 30.291 1.031 60.637.546 90.959.539 84.041-.021 168.09.531 252.12-.48 52.664-.634 96.108-36.873 108.212-87.293 11.54-48.074-11.144-97.3-56.832-122.634zm21.107 156.88c-18.23 22.432-42.343 35.253-71.28 35.65-56.874.781-113.767.23-170.652.23 0 .7-163.028.159-163.728.154-43.861-.332-76.739-19.766-95.175-59.995-18.902-41.245-4.004-90.848 34.186-116.106 9.182-6.073 12.505-11.566 10.096-23.136-5.49-26.361 4.453-47.956 26.42-62.981 22.987-15.723 47.422-16.146 72.034-3.083 10.269 5.45 14.607 11.564 22.198-2.527 14.222-26.399 34.557-46.727 60.671-61.294 97.46-54.366 228.37 7.568 230.24 132.697.122 8.15 2.412 12.428 9.848 15.894 57.56 26.829 74.456 96.122 35.142 144.497zm-87.789-80.499c-5.848 31.157-34.622 55.096-66.666 55.095-16.953-.001-32.058-6.545-44.079-17.705-27.697-25.713-71.141-74.98-95.937-93.387-20.056-14.888-41.99-12.333-60.272 3.782-49.996 44.071 15.859 121.775 67.063 77.188 4.548-3.96 7.84-9.543 12.744-12.844 8.184-5.509 20.766-.884 13.168 10.622-17.358 26.284-49.33 38.197-78.863 29.301-28.897-8.704-48.84-35.968-48.626-70.179 1.225-22.485 12.364-43.06 35.414-55.965 22.575-12.638 46.369-13.146 66.991 2.474C295.68 280.7 320.467 323.97 352.185 343.47c24.558 15.099 54.254 7.363 68.823-17.506 28.83-49.209-34.592-105.016-78.868-63.46-3.989 3.744-6.917 8.932-11.41 11.72-10.975 6.811-17.333-4.113-12.809-10.353 20.703-28.554 50.464-40.44 83.271-28.214 31.429 11.714 49.108 44.366 42.76 78.186z"
    ]
};
var $ef0249c5e48bf4e3$export$6b9a61f04a3c9eb4 = {
    prefix: "fab",
    iconName: "sith",
    icon: [
        448,
        512,
        [],
        "f512",
        "M0 32l69.71 118.75-58.86-11.52 69.84 91.03a146.741 146.741 0 0 0 0 51.45l-69.84 91.03 58.86-11.52L0 480l118.75-69.71-11.52 58.86 91.03-69.84c17.02 3.04 34.47 3.04 51.48 0l91.03 69.84-11.52-58.86L448 480l-69.71-118.78 58.86 11.52-69.84-91.03c3.03-17.01 3.04-34.44 0-51.45l69.84-91.03-58.86 11.52L448 32l-118.75 69.71 11.52-58.9-91.06 69.87c-8.5-1.52-17.1-2.29-25.71-2.29s-17.21.78-25.71 2.29l-91.06-69.87 11.52 58.9L0 32zm224 99.78c31.8 0 63.6 12.12 87.85 36.37 48.5 48.5 48.49 127.21 0 175.7s-127.2 48.46-175.7-.03c-48.5-48.5-48.49-127.21 0-175.7 24.24-24.25 56.05-36.34 87.85-36.34zm0 36.66c-22.42 0-44.83 8.52-61.92 25.61-34.18 34.18-34.19 89.68 0 123.87s89.65 34.18 123.84 0c34.18-34.18 34.19-89.68 0-123.87-17.09-17.09-39.5-25.61-61.92-25.61z"
    ]
};
var $ef0249c5e48bf4e3$export$9ce81750a9f73ac4 = {
    prefix: "fab",
    iconName: "themeisle",
    icon: [
        512,
        512,
        [],
        "f2b2",
        "M208 88.286c0-10 6.286-21.714 17.715-21.714 11.142 0 17.714 11.714 17.714 21.714 0 10.285-6.572 21.714-17.714 21.714C214.286 110 208 98.571 208 88.286zm304 160c0 36.001-11.429 102.286-36.286 129.714-22.858 24.858-87.428 61.143-120.857 70.572l-1.143.286v32.571c0 16.286-12.572 30.571-29.143 30.571-10 0-19.429-5.714-24.572-14.286-5.427 8.572-14.856 14.286-24.856 14.286-10 0-19.429-5.714-24.858-14.286-5.142 8.572-14.571 14.286-24.57 14.286-10.286 0-19.429-5.714-24.858-14.286-5.143 8.572-14.571 14.286-24.571 14.286-18.857 0-29.429-15.714-29.429-32.857-16.286 12.285-35.715 19.428-56.571 19.428-22 0-43.429-8.285-60.286-22.857 10.285-.286 20.571-2.286 30.285-5.714-20.857-5.714-39.428-18.857-52-36.286 21.37 4.645 46.209 1.673 67.143-11.143-22-22-56.571-58.857-68.572-87.428C1.143 321.714 0 303.714 0 289.429c0-49.714 20.286-160 86.286-160 10.571 0 18.857 4.858 23.143 14.857a158.792 158.792 0 0 1 12-15.428c2-2.572 5.714-5.429 7.143-8.286 7.999-12.571 11.714-21.142 21.714-34C182.571 45.428 232 17.143 285.143 17.143c6 0 12 .285 17.714 1.143C313.714 6.571 328.857 0 344.572 0c14.571 0 29.714 6 40 16.286.857.858 1.428 2.286 1.428 3.428 0 3.714-10.285 13.429-12.857 16.286 4.286 1.429 15.714 6.858 15.714 12 0 2.857-2.857 5.143-4.571 7.143 31.429 27.714 49.429 67.143 56.286 108 4.286-5.143 10.285-8.572 17.143-8.572 10.571 0 20.857 7.144 28.571 14.001C507.143 187.143 512 221.714 512 248.286zM188 89.428c0 18.286 12.571 37.143 32.286 37.143 19.714 0 32.285-18.857 32.285-37.143 0-18-12.571-36.857-32.285-36.857-19.715 0-32.286 18.858-32.286 36.857zM237.714 194c0-19.714 3.714-39.143 8.571-58.286-52.039 79.534-13.531 184.571 68.858 184.571 21.428 0 42.571-7.714 60-20 2-7.429 3.714-14.857 3.714-22.572 0-14.286-6.286-21.428-20.572-21.428-4.571 0-9.143.857-13.429 1.714-63.343 12.668-107.142 3.669-107.142-63.999zm-41.142 254.858c0-11.143-8.858-20.857-20.286-20.857-11.429 0-20 9.715-20 20.857v32.571c0 11.143 8.571 21.142 20 21.142 11.428 0 20.286-9.715 20.286-21.142v-32.571zm49.143 0c0-11.143-8.572-20.857-20-20.857-11.429 0-20.286 9.715-20.286 20.857v32.571c0 11.143 8.857 21.142 20.286 21.142 11.428 0 20-10 20-21.142v-32.571zm49.713 0c0-11.143-8.857-20.857-20.285-20.857-11.429 0-20.286 9.715-20.286 20.857v32.571c0 11.143 8.857 21.142 20.286 21.142 11.428 0 20.285-9.715 20.285-21.142v-32.571zm49.715 0c0-11.143-8.857-20.857-20.286-20.857-11.428 0-20.286 9.715-20.286 20.857v32.571c0 11.143 8.858 21.142 20.286 21.142 11.429 0 20.286-10 20.286-21.142v-32.571zM421.714 286c-30.857 59.142-90.285 102.572-158.571 102.572-96.571 0-160.571-84.572-160.571-176.572 0-16.857 2-33.429 6-49.714-20 33.715-29.714 72.572-29.714 111.429 0 60.286 24.857 121.715 71.429 160.857 5.143-9.714 14.857-16.286 26-16.286 10 0 19.428 5.714 24.571 14.286 5.429-8.571 14.571-14.286 24.858-14.286 10 0 19.428 5.714 24.571 14.286 5.429-8.571 14.857-14.286 24.858-14.286 10 0 19.428 5.714 24.857 14.286 5.143-8.571 14.571-14.286 24.572-14.286 10.857 0 20.857 6.572 25.714 16 43.427-36.286 68.569-92 71.426-148.286zm10.572-99.714c0-53.714-34.571-105.714-92.572-105.714-30.285 0-58.571 15.143-78.857 36.857C240.862 183.812 233.41 254 302.286 254c28.805 0 97.357-28.538 84.286 36.857 28.857-26 45.714-65.714 45.714-104.571z"
    ]
};
var $ef0249c5e48bf4e3$export$e504e93b36693690 = {
    prefix: "fab",
    iconName: "page4",
    icon: [
        496,
        512,
        [],
        "f3d7",
        "M248 504C111 504 0 393 0 256S111 8 248 8c20.9 0 41.3 2.6 60.7 7.5L42.3 392H248v112zm0-143.6V146.8L98.6 360.4H248zm96 31.6v92.7c45.7-19.2 84.5-51.7 111.4-92.7H344zm57.4-138.2l-21.2 8.4 21.2 8.3v-16.7zm-20.3 54.5c-6.7 0-8 6.3-8 12.9v7.7h16.2v-10c0-5.9-2.3-10.6-8.2-10.6zM496 256c0 37.3-8.2 72.7-23 104.4H344V27.3C433.3 64.8 496 153.1 496 256zM360.4 143.6h68.2V96h-13.9v32.6h-13.9V99h-13.9v29.6h-12.7V96h-13.9v47.6zm68.1 185.3H402v-11c0-15.4-5.6-25.2-20.9-25.2-15.4 0-20.7 10.6-20.7 25.9v25.3h68.2v-15zm0-103l-68.2 29.7V268l68.2 29.5v-16.6l-14.4-5.7v-26.5l14.4-5.9v-16.9zm-4.8-68.5h-35.6V184H402v-12.2h11c8.6 15.8 1.3 35.3-18.6 35.3-22.5 0-28.3-25.3-15.5-37.7l-11.6-10.6c-16.2 17.5-12.2 63.9 27.1 63.9 34 0 44.7-35.9 29.3-65.3z"
    ]
};
var $ef0249c5e48bf4e3$export$459e822cce028974 = {
    prefix: "fab",
    iconName: "hashnode",
    icon: [
        512,
        512,
        [],
        "e499",
        "M35.19 171.1C-11.72 217.1-11.72 294 35.19 340.9L171.1 476.8C217.1 523.7 294 523.7 340.9 476.8L476.8 340.9C523.7 294 523.7 217.1 476.8 171.1L340.9 35.19C294-11.72 217.1-11.72 171.1 35.19L35.19 171.1zM315.5 315.5C282.6 348.3 229.4 348.3 196.6 315.5C163.7 282.6 163.7 229.4 196.6 196.6C229.4 163.7 282.6 163.7 315.5 196.6C348.3 229.4 348.3 282.6 315.5 315.5z"
    ]
};
var $ef0249c5e48bf4e3$export$e62f4d94322d112c = {
    prefix: "fab",
    iconName: "react",
    icon: [
        512,
        512,
        [],
        "f41b",
        "M418.2 177.2c-5.4-1.8-10.8-3.5-16.2-5.1.9-3.7 1.7-7.4 2.5-11.1 12.3-59.6 4.2-107.5-23.1-123.3-26.3-15.1-69.2.6-112.6 38.4-4.3 3.7-8.5 7.6-12.5 11.5-2.7-2.6-5.5-5.2-8.3-7.7-45.5-40.4-91.1-57.4-118.4-41.5-26.2 15.2-34 60.3-23 116.7 1.1 5.6 2.3 11.1 3.7 16.7-6.4 1.8-12.7 3.8-18.6 5.9C38.3 196.2 0 225.4 0 255.6c0 31.2 40.8 62.5 96.3 81.5 4.5 1.5 9 3 13.6 4.3-1.5 6-2.8 11.9-4 18-10.5 55.5-2.3 99.5 23.9 114.6 27 15.6 72.4-.4 116.6-39.1 3.5-3.1 7-6.3 10.5-9.7 4.4 4.3 9 8.4 13.6 12.4 42.8 36.8 85.1 51.7 111.2 36.6 27-15.6 35.8-62.9 24.4-120.5-.9-4.4-1.9-8.9-3-13.5 3.2-.9 6.3-1.9 9.4-2.9 57.7-19.1 99.5-50 99.5-81.7 0-30.3-39.4-59.7-93.8-78.4zM282.9 92.3c37.2-32.4 71.9-45.1 87.7-36 16.9 9.7 23.4 48.9 12.8 100.4-.7 3.4-1.4 6.7-2.3 10-22.2-5-44.7-8.6-67.3-10.6-13-18.6-27.2-36.4-42.6-53.1 3.9-3.7 7.7-7.2 11.7-10.7zM167.2 307.5c5.1 8.7 10.3 17.4 15.8 25.9-15.6-1.7-31.1-4.2-46.4-7.5 4.4-14.4 9.9-29.3 16.3-44.5 4.6 8.8 9.3 17.5 14.3 26.1zm-30.3-120.3c14.4-3.2 29.7-5.8 45.6-7.8-5.3 8.3-10.5 16.8-15.4 25.4-4.9 8.5-9.7 17.2-14.2 26-6.3-14.9-11.6-29.5-16-43.6zm27.4 68.9c6.6-13.8 13.8-27.3 21.4-40.6s15.8-26.2 24.4-38.9c15-1.1 30.3-1.7 45.9-1.7s31 .6 45.9 1.7c8.5 12.6 16.6 25.5 24.3 38.7s14.9 26.7 21.7 40.4c-6.7 13.8-13.9 27.4-21.6 40.8-7.6 13.3-15.7 26.2-24.2 39-14.9 1.1-30.4 1.6-46.1 1.6s-30.9-.5-45.6-1.4c-8.7-12.7-16.9-25.7-24.6-39s-14.8-26.8-21.5-40.6zm180.6 51.2c5.1-8.8 9.9-17.7 14.6-26.7 6.4 14.5 12 29.2 16.9 44.3-15.5 3.5-31.2 6.2-47 8 5.4-8.4 10.5-17 15.5-25.6zm14.4-76.5c-4.7-8.8-9.5-17.6-14.5-26.2-4.9-8.5-10-16.9-15.3-25.2 16.1 2 31.5 4.7 45.9 8-4.6 14.8-10 29.2-16.1 43.4zM256.2 118.3c10.5 11.4 20.4 23.4 29.6 35.8-19.8-.9-39.7-.9-59.5 0 9.8-12.9 19.9-24.9 29.9-35.8zM140.2 57c16.8-9.8 54.1 4.2 93.4 39 2.5 2.2 5 4.6 7.6 7-15.5 16.7-29.8 34.5-42.9 53.1-22.6 2-45 5.5-67.2 10.4-1.3-5.1-2.4-10.3-3.5-15.5-9.4-48.4-3.2-84.9 12.6-94zm-24.5 263.6c-4.2-1.2-8.3-2.5-12.4-3.9-21.3-6.7-45.5-17.3-63-31.2-10.1-7-16.9-17.8-18.8-29.9 0-18.3 31.6-41.7 77.2-57.6 5.7-2 11.5-3.8 17.3-5.5 6.8 21.7 15 43 24.5 63.6-9.6 20.9-17.9 42.5-24.8 64.5zm116.6 98c-16.5 15.1-35.6 27.1-56.4 35.3-11.1 5.3-23.9 5.8-35.3 1.3-15.9-9.2-22.5-44.5-13.5-92 1.1-5.6 2.3-11.2 3.7-16.7 22.4 4.8 45 8.1 67.9 9.8 13.2 18.7 27.7 36.6 43.2 53.4-3.2 3.1-6.4 6.1-9.6 8.9zm24.5-24.3c-10.2-11-20.4-23.2-30.3-36.3 9.6.4 19.5.6 29.5.6 10.3 0 20.4-.2 30.4-.7-9.2 12.7-19.1 24.8-29.6 36.4zm130.7 30c-.9 12.2-6.9 23.6-16.5 31.3-15.9 9.2-49.8-2.8-86.4-34.2-4.2-3.6-8.4-7.5-12.7-11.5 15.3-16.9 29.4-34.8 42.2-53.6 22.9-1.9 45.7-5.4 68.2-10.5 1 4.1 1.9 8.2 2.7 12.2 4.9 21.6 5.7 44.1 2.5 66.3zm18.2-107.5c-2.8.9-5.6 1.8-8.5 2.6-7-21.8-15.6-43.1-25.5-63.8 9.6-20.4 17.7-41.4 24.5-62.9 5.2 1.5 10.2 3.1 15 4.7 46.6 16 79.3 39.8 79.3 58 0 19.6-34.9 44.9-84.8 61.4zm-149.7-15c25.3 0 45.8-20.5 45.8-45.8s-20.5-45.8-45.8-45.8c-25.3 0-45.8 20.5-45.8 45.8s20.5 45.8 45.8 45.8z"
    ]
};
var $ef0249c5e48bf4e3$export$c4a0e7e817efc4de = {
    prefix: "fab",
    iconName: "cc-paypal",
    icon: [
        576,
        512,
        [],
        "f1f4",
        "M186.3 258.2c0 12.2-9.7 21.5-22 21.5-9.2 0-16-5.2-16-15 0-12.2 9.5-22 21.7-22 9.3 0 16.3 5.7 16.3 15.5zM80.5 209.7h-4.7c-1.5 0-3 1-3.2 2.7l-4.3 26.7 8.2-.3c11 0 19.5-1.5 21.5-14.2 2.3-13.4-6.2-14.9-17.5-14.9zm284 0H360c-1.8 0-3 1-3.2 2.7l-4.2 26.7 8-.3c13 0 22-3 22-18-.1-10.6-9.6-11.1-18.1-11.1zM576 80v352c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V80c0-26.5 21.5-48 48-48h480c26.5 0 48 21.5 48 48zM128.3 215.4c0-21-16.2-28-34.7-28h-40c-2.5 0-5 2-5.2 4.7L32 294.2c-.3 2 1.2 4 3.2 4h19c2.7 0 5.2-2.9 5.5-5.7l4.5-26.6c1-7.2 13.2-4.7 18-4.7 28.6 0 46.1-17 46.1-45.8zm84.2 8.8h-19c-3.8 0-4 5.5-4.2 8.2-5.8-8.5-14.2-10-23.7-10-24.5 0-43.2 21.5-43.2 45.2 0 19.5 12.2 32.2 31.7 32.2 9 0 20.2-4.9 26.5-11.9-.5 1.5-1 4.7-1 6.2 0 2.3 1 4 3.2 4H200c2.7 0 5-2.9 5.5-5.7l10.2-64.3c.3-1.9-1.2-3.9-3.2-3.9zm40.5 97.9l63.7-92.6c.5-.5.5-1 .5-1.7 0-1.7-1.5-3.5-3.2-3.5h-19.2c-1.7 0-3.5 1-4.5 2.5l-26.5 39-11-37.5c-.8-2.2-3-4-5.5-4h-18.7c-1.7 0-3.2 1.8-3.2 3.5 0 1.2 19.5 56.8 21.2 62.1-2.7 3.8-20.5 28.6-20.5 31.6 0 1.8 1.5 3.2 3.2 3.2h19.2c1.8-.1 3.5-1.1 4.5-2.6zm159.3-106.7c0-21-16.2-28-34.7-28h-39.7c-2.7 0-5.2 2-5.5 4.7l-16.2 102c-.2 2 1.3 4 3.2 4h20.5c2 0 3.5-1.5 4-3.2l4.5-29c1-7.2 13.2-4.7 18-4.7 28.4 0 45.9-17 45.9-45.8zm84.2 8.8h-19c-3.8 0-4 5.5-4.3 8.2-5.5-8.5-14-10-23.7-10-24.5 0-43.2 21.5-43.2 45.2 0 19.5 12.2 32.2 31.7 32.2 9.3 0 20.5-4.9 26.5-11.9-.3 1.5-1 4.7-1 6.2 0 2.3 1 4 3.2 4H484c2.7 0 5-2.9 5.5-5.7l10.2-64.3c.3-1.9-1.2-3.9-3.2-3.9zm47.5-33.3c0-2-1.5-3.5-3.2-3.5h-18.5c-1.5 0-3 1.2-3.2 2.7l-16.2 104-.3.5c0 1.8 1.5 3.5 3.5 3.5h16.5c2.5 0 5-2.9 5.2-5.7L544 191.2v-.3zm-90 51.8c-12.2 0-21.7 9.7-21.7 22 0 9.7 7 15 16.2 15 12 0 21.7-9.2 21.7-21.5.1-9.8-6.9-15.5-16.2-15.5z"
    ]
};
var $ef0249c5e48bf4e3$export$c1ba640907c93eb6 = {
    prefix: "fab",
    iconName: "squarespace",
    icon: [
        512,
        512,
        [],
        "f5be",
        "M186.12 343.34c-9.65 9.65-9.65 25.29 0 34.94 9.65 9.65 25.29 9.65 34.94 0L378.24 221.1c19.29-19.29 50.57-19.29 69.86 0s19.29 50.57 0 69.86L293.95 445.1c19.27 19.29 50.53 19.31 69.82.04l.04-.04 119.25-119.24c38.59-38.59 38.59-101.14 0-139.72-38.59-38.59-101.15-38.59-139.72 0l-157.22 157.2zm244.53-104.8c-9.65-9.65-25.29-9.65-34.93 0l-157.2 157.18c-19.27 19.29-50.53 19.31-69.82.05l-.05-.05c-9.64-9.64-25.27-9.65-34.92-.01l-.01.01c-9.65 9.64-9.66 25.28-.02 34.93l.02.02c38.58 38.57 101.14 38.57 139.72 0l157.2-157.2c9.65-9.65 9.65-25.29.01-34.93zm-261.99 87.33l157.18-157.18c9.64-9.65 9.64-25.29 0-34.94-9.64-9.64-25.27-9.64-34.91 0L133.72 290.93c-19.28 19.29-50.56 19.3-69.85.01l-.01-.01c-19.29-19.28-19.31-50.54-.03-69.84l.03-.03L218.03 66.89c-19.28-19.29-50.55-19.3-69.85-.02l-.02.02L28.93 186.14c-38.58 38.59-38.58 101.14 0 139.72 38.6 38.59 101.13 38.59 139.73.01zm-87.33-52.4c9.64 9.64 25.27 9.64 34.91 0l157.21-157.19c19.28-19.29 50.55-19.3 69.84-.02l.02.02c9.65 9.65 25.29 9.65 34.93 0 9.65-9.65 9.65-25.29 0-34.93-38.59-38.59-101.13-38.59-139.72 0L81.33 238.54c-9.65 9.64-9.65 25.28-.01 34.93h.01z"
    ]
};
var $ef0249c5e48bf4e3$export$235ca29d6ed8f50f = {
    prefix: "fab",
    iconName: "cc-stripe",
    icon: [
        576,
        512,
        [],
        "f1f5",
        "M492.4 220.8c-8.9 0-18.7 6.7-18.7 22.7h36.7c0-16-9.3-22.7-18-22.7zM375 223.4c-8.2 0-13.3 2.9-17 7l.2 52.8c3.5 3.7 8.5 6.7 16.8 6.7 13.1 0 21.9-14.3 21.9-33.4 0-18.6-9-33.2-21.9-33.1zM528 32H48C21.5 32 0 53.5 0 80v352c0 26.5 21.5 48 48 48h480c26.5 0 48-21.5 48-48V80c0-26.5-21.5-48-48-48zM122.2 281.1c0 25.6-20.3 40.1-49.9 40.3-12.2 0-25.6-2.4-38.8-8.1v-33.9c12 6.4 27.1 11.3 38.9 11.3 7.9 0 13.6-2.1 13.6-8.7 0-17-54-10.6-54-49.9 0-25.2 19.2-40.2 48-40.2 11.8 0 23.5 1.8 35.3 6.5v33.4c-10.8-5.8-24.5-9.1-35.3-9.1-7.5 0-12.1 2.2-12.1 7.7 0 16 54.3 8.4 54.3 50.7zm68.8-56.6h-27V275c0 20.9 22.5 14.4 27 12.6v28.9c-4.7 2.6-13.3 4.7-24.9 4.7-21.1 0-36.9-15.5-36.9-36.5l.2-113.9 34.7-7.4v30.8H191zm74 2.4c-4.5-1.5-18.7-3.6-27.1 7.4v84.4h-35.5V194.2h30.7l2.2 10.5c8.3-15.3 24.9-12.2 29.6-10.5h.1zm44.1 91.8h-35.7V194.2h35.7zm0-142.9l-35.7 7.6v-28.9l35.7-7.6zm74.1 145.5c-12.4 0-20-5.3-25.1-9l-.1 40.2-35.5 7.5V194.2h31.3l1.8 8.8c4.9-4.5 13.9-11.1 27.8-11.1 24.9 0 48.4 22.5 48.4 63.8 0 45.1-23.2 65.5-48.6 65.6zm160.4-51.5h-69.5c1.6 16.6 13.8 21.5 27.6 21.5 14.1 0 25.2-3 34.9-7.9V312c-9.7 5.3-22.4 9.2-39.4 9.2-34.6 0-58.8-21.7-58.8-64.5 0-36.2 20.5-64.9 54.3-64.9 33.7 0 51.3 28.7 51.3 65.1 0 3.5-.3 10.9-.4 12.9z"
    ]
};
var $ef0249c5e48bf4e3$export$82bc9680d7d55560 = {
    prefix: "fab",
    iconName: "creative-commons-share",
    icon: [
        496,
        512,
        [],
        "f4f2",
        "M247.6 8C389.4 8 496 118.1 496 256c0 147.1-118.5 248-248.4 248C113.6 504 0 394.5 0 256 0 123.1 104.7 8 247.6 8zm.8 44.7C130.2 52.7 44.7 150.6 44.7 256c0 109.8 91.2 202.8 203.7 202.8 103.2 0 202.8-81.1 202.8-202.8.1-113.8-90.2-203.3-202.8-203.3zm101 132.4c7.8 0 13.7 6.1 13.7 13.7v182.5c0 7.7-6.1 13.7-13.7 13.7H214.3c-7.7 0-13.7-6-13.7-13.7v-54h-54c-7.8 0-13.7-6-13.7-13.7V131.1c0-8.2 6.6-12.7 12.4-13.7h136.4c7.7 0 13.7 6 13.7 13.7v54h54zM159.9 300.3h40.7V198.9c0-7.4 5.8-12.6 12-13.7h55.8v-40.3H159.9v155.4zm176.2-88.1H227.6v155.4h108.5V212.2z"
    ]
};
var $ef0249c5e48bf4e3$export$7bb8936d912f16ef = {
    prefix: "fab",
    iconName: "bitcoin",
    icon: [
        512,
        512,
        [],
        "f379",
        "M504 256c0 136.967-111.033 248-248 248S8 392.967 8 256 119.033 8 256 8s248 111.033 248 248zm-141.651-35.33c4.937-32.999-20.191-50.739-54.55-62.573l11.146-44.702-27.213-6.781-10.851 43.524c-7.154-1.783-14.502-3.464-21.803-5.13l10.929-43.81-27.198-6.781-11.153 44.686c-5.922-1.349-11.735-2.682-17.377-4.084l.031-.14-37.53-9.37-7.239 29.062s20.191 4.627 19.765 4.913c11.022 2.751 13.014 10.044 12.68 15.825l-12.696 50.925c.76.194 1.744.473 2.829.907-.907-.225-1.876-.473-2.876-.713l-17.796 71.338c-1.349 3.348-4.767 8.37-12.471 6.464.271.395-19.78-4.937-19.78-4.937l-13.51 31.147 35.414 8.827c6.588 1.651 13.045 3.379 19.4 5.006l-11.262 45.213 27.182 6.781 11.153-44.733a1038.209 1038.209 0 0 0 21.687 5.627l-11.115 44.523 27.213 6.781 11.262-45.128c46.404 8.781 81.299 5.239 95.986-36.727 11.836-33.79-.589-53.281-25.004-65.991 17.78-4.098 31.174-15.792 34.747-39.949zm-62.177 87.179c-8.41 33.79-65.308 15.523-83.755 10.943l14.944-59.899c18.446 4.603 77.6 13.717 68.811 48.956zm8.417-87.667c-7.673 30.736-55.031 15.12-70.393 11.292l13.548-54.327c15.363 3.828 64.836 10.973 56.845 43.035z"
    ]
};
var $ef0249c5e48bf4e3$export$644ebffaf375bd06 = {
    prefix: "fab",
    iconName: "keycdn",
    icon: [
        512,
        512,
        [],
        "f3ba",
        "M63.8 409.3l60.5-59c32.1 42.8 71.1 66 126.6 67.4 30.5.7 60.3-7 86.4-22.4 5.1 5.3 18.5 19.5 20.9 22-32.2 20.7-69.6 31.1-108.1 30.2-43.3-1.1-84.6-16.7-117.7-44.4.3-.6-38.2 37.5-38.6 37.9 9.5 29.8-13.1 62.4-46.3 62.4C20.7 503.3 0 481.7 0 454.9c0-34.3 33.1-56.6 63.8-45.6zm354.9-252.4c19.1 31.3 29.6 67.4 28.7 104-1.1 44.8-19 87.5-48.6 121 .3.3 23.8 25.2 24.1 25.5 9.6-1.3 19.2 2 25.9 9.1 11.3 12 10.9 30.9-1.1 42.4-12 11.3-30.9 10.9-42.4-1.1-6.7-7-9.4-16.8-7.6-26.3-24.9-26.6-44.4-47.2-44.4-47.2 42.7-34.1 63.3-79.6 64.4-124.2.7-28.9-7.2-57.2-21.1-82.2l22.1-21zM104 53.1c6.7 7 9.4 16.8 7.6 26.3l45.9 48.1c-4.7 3.8-13.3 10.4-22.8 21.3-25.4 28.5-39.6 64.8-40.7 102.9-.7 28.9 6.1 57.2 20 82.4l-22 21.5C72.7 324 63.1 287.9 64.2 250.9c1-44.6 18.3-87.6 47.5-121.1l-25.3-26.4c-9.6 1.3-19.2-2-25.9-9.1-11.3-12-10.9-30.9 1.1-42.4C73.5 40.7 92.2 41 104 53.1zM464.9 8c26 0 47.1 22.4 47.1 48.3S490.9 104 464.9 104c-6.3.1-14-1.1-15.9-1.8l-62.9 59.7c-32.7-43.6-76.7-65.9-126.9-67.2-30.5-.7-60.3 6.8-86.2 22.4l-21.1-22C184.1 74.3 221.5 64 260 64.9c43.3 1.1 84.6 16.7 117.7 44.6l41.1-38.6c-1.5-4.7-2.2-9.6-2.2-14.5C416.5 29.7 438.9 8 464.9 8zM256.7 113.4c5.5 0 10.9.4 16.4 1.1 78.1 9.8 133.4 81.1 123.8 159.1-9.8 78.1-81.1 133.4-159.1 123.8-78.1-9.8-133.4-81.1-123.8-159.2 9.3-72.4 70.1-124.6 142.7-124.8zm-59 119.4c.6 22.7 12.2 41.8 32.4 52.2l-11 51.7h73.7l-11-51.7c20.1-10.9 32.1-29 32.4-52.2-.4-32.8-25.8-57.5-58.3-58.3-32.1.8-57.3 24.8-58.2 58.3zM256 160"
    ]
};
var $ef0249c5e48bf4e3$export$76e4000ae88923a5 = {
    prefix: "fab",
    iconName: "opera",
    icon: [
        496,
        512,
        [],
        "f26a",
        "M313.9 32.7c-170.2 0-252.6 223.8-147.5 355.1 36.5 45.4 88.6 75.6 147.5 75.6 36.3 0 70.3-11.1 99.4-30.4-43.8 39.2-101.9 63-165.3 63-3.9 0-8 0-11.9-.3C104.6 489.6 0 381.1 0 248 0 111 111 0 248 0h.8c63.1.3 120.7 24.1 164.4 63.1-29-19.4-63.1-30.4-99.3-30.4zm101.8 397.7c-40.9 24.7-90.7 23.6-132-5.8 56.2-20.5 97.7-91.6 97.7-176.6 0-84.7-41.2-155.8-97.4-176.6 41.8-29.2 91.2-30.3 132.9-5 105.9 98.7 105.5 265.7-1.2 364z"
    ]
};
var $ef0249c5e48bf4e3$export$4ec4278290df08a8 = {
    prefix: "fab",
    iconName: "itch-io",
    icon: [
        512,
        512,
        [],
        "f83a",
        "M71.92 34.77C50.2 47.67 7.4 96.84 7 109.73v21.34c0 27.06 25.29 50.84 48.25 50.84 27.57 0 50.54-22.85 50.54-50 0 27.12 22.18 50 49.76 50s49-22.85 49-50c0 27.12 23.59 50 51.16 50h.5c27.57 0 51.16-22.85 51.16-50 0 27.12 21.47 50 49 50s49.76-22.85 49.76-50c0 27.12 23 50 50.54 50 23 0 48.25-23.78 48.25-50.84v-21.34c-.4-12.9-43.2-62.07-64.92-75C372.56 32.4 325.76 32 256 32S91.14 33.1 71.92 34.77zm132.32 134.39c-22 38.4-77.9 38.71-99.85.25-13.17 23.14-43.17 32.07-56 27.66-3.87 40.15-13.67 237.13 17.73 269.15 80 18.67 302.08 18.12 379.76 0 31.65-32.27 21.32-232 17.75-269.15-12.92 4.44-42.88-4.6-56-27.66-22 38.52-77.85 38.1-99.85-.24-7.1 12.49-23.05 28.94-51.76 28.94a57.54 57.54 0 0 1-51.75-28.94zm-41.58 53.77c16.47 0 31.09 0 49.22 19.78a436.91 436.91 0 0 1 88.18 0C318.22 223 332.85 223 349.31 223c52.33 0 65.22 77.53 83.87 144.45 17.26 62.15-5.52 63.67-33.95 63.73-42.15-1.57-65.49-32.18-65.49-62.79-39.25 6.43-101.93 8.79-155.55 0 0 30.61-23.34 61.22-65.49 62.79-28.42-.06-51.2-1.58-33.94-63.73 18.67-67 31.56-144.45 83.88-144.45zM256 270.79s-44.38 40.77-52.35 55.21l29-1.17v25.32c0 1.55 21.34.16 23.33.16 11.65.54 23.31 1 23.31-.16v-25.28l29 1.17c-8-14.48-52.35-55.24-52.35-55.24z"
    ]
};
var $ef0249c5e48bf4e3$export$b92d594113fd14c4 = {
    prefix: "fab",
    iconName: "umbraco",
    icon: [
        510,
        512,
        [],
        "f8e8",
        "M255.35 8C118.36 7.83 7.14 118.72 7 255.68c-.07 137 111 248.2 248 248.27 136.85 0 247.82-110.7 248-247.67S392.34 8.17 255.35 8zm145 266q-1.14 40.68-14 65t-43.51 35q-30.61 10.7-85.45 10.47h-4.6q-54.78.22-85.44-10.47t-43.52-35q-12.85-24.36-14-65a224.81 224.81 0 0 1 0-30.71 418.37 418.37 0 0 1 3.6-43.88c1.88-13.39 3.57-22.58 5.4-32 1-4.88 1.28-6.42 1.82-8.45a5.09 5.09 0 0 1 4.9-3.89h.69l32 5a5.07 5.07 0 0 1 4.16 5 5 5 0 0 1 0 .77l-1.7 8.78q-2.41 13.25-4.84 33.68a380.62 380.62 0 0 0-2.64 42.15q-.28 40.43 8.13 59.83a43.87 43.87 0 0 0 31.31 25.18A243 243 0 0 0 250 340.6h10.25a242.64 242.64 0 0 0 57.27-5.16 43.86 43.86 0 0 0 31.15-25.23q8.53-19.42 8.13-59.78a388 388 0 0 0-2.6-42.15q-2.48-20.38-4.89-33.68l-1.69-8.78a5 5 0 0 1 0-.77 5 5 0 0 1 4.2-5l32-5h.82a5 5 0 0 1 4.9 3.89c.55 2.05.81 3.57 1.83 8.45 1.82 9.62 3.52 18.78 5.39 32a415.71 415.71 0 0 1 3.61 43.88 228.06 228.06 0 0 1-.04 30.73z"
    ]
};
var $ef0249c5e48bf4e3$export$85ca259eee71d856 = {
    prefix: "fab",
    iconName: "galactic-senate",
    icon: [
        512,
        512,
        [],
        "f50d",
        "M249.86 33.48v26.07C236.28 80.17 226 168.14 225.39 274.9c11.74-15.62 19.13-33.33 19.13-48.24v-16.88c-.03-5.32.75-10.53 2.19-15.65.65-2.14 1.39-4.08 2.62-5.82 1.23-1.75 3.43-3.79 6.68-3.79 3.24 0 5.45 2.05 6.68 3.79 1.23 1.75 1.97 3.68 2.62 5.82 1.44 5.12 2.22 10.33 2.19 15.65v16.88c0 14.91 7.39 32.62 19.13 48.24-.63-106.76-10.91-194.73-24.49-215.35V33.48h-12.28zm-26.34 147.77c-9.52 2.15-18.7 5.19-27.46 9.08 8.9 16.12 9.76 32.64 1.71 37.29-8 4.62-21.85-4.23-31.36-19.82-11.58 8.79-21.88 19.32-30.56 31.09 14.73 9.62 22.89 22.92 18.32 30.66-4.54 7.7-20.03 7.14-35.47-.96-5.78 13.25-9.75 27.51-11.65 42.42 9.68.18 18.67 2.38 26.18 6.04 17.78-.3 32.77-1.96 40.49-4.22 5.55-26.35 23.02-48.23 46.32-59.51.73-25.55 1.88-49.67 3.48-72.07zm64.96 0c1.59 22.4 2.75 46.52 3.47 72.07 23.29 11.28 40.77 33.16 46.32 59.51 7.72 2.26 22.71 3.92 40.49 4.22 7.51-3.66 16.5-5.85 26.18-6.04-1.9-14.91-5.86-29.17-11.65-42.42-15.44 8.1-30.93 8.66-35.47.96-4.57-7.74 3.6-21.05 18.32-30.66-8.68-11.77-18.98-22.3-30.56-31.09-9.51 15.59-23.36 24.44-31.36 19.82-8.05-4.65-7.19-21.16 1.71-37.29a147.49 147.49 0 0 0-27.45-9.08zm-32.48 8.6c-3.23 0-5.86 8.81-6.09 19.93h-.05v16.88c0 41.42-49.01 95.04-93.49 95.04-52 0-122.75-1.45-156.37 29.17v2.51c9.42 17.12 20.58 33.17 33.18 47.97C45.7 380.26 84.77 360.4 141.2 360c45.68 1.02 79.03 20.33 90.76 40.87.01.01-.01.04 0 .05 7.67 2.14 15.85 3.23 24.04 3.21 8.19.02 16.37-1.07 24.04-3.21.01-.01-.01-.04 0-.05 11.74-20.54 45.08-39.85 90.76-40.87 56.43.39 95.49 20.26 108.02 41.35 12.6-14.8 23.76-30.86 33.18-47.97v-2.51c-33.61-30.62-104.37-29.17-156.37-29.17-44.48 0-93.49-53.62-93.49-95.04v-16.88h-.05c-.23-11.12-2.86-19.93-6.09-19.93zm0 96.59c22.42 0 40.6 18.18 40.6 40.6s-18.18 40.65-40.6 40.65-40.6-18.23-40.6-40.65c0-22.42 18.18-40.6 40.6-40.6zm0 7.64c-18.19 0-32.96 14.77-32.96 32.96S237.81 360 256 360s32.96-14.77 32.96-32.96-14.77-32.96-32.96-32.96zm0 6.14c14.81 0 26.82 12.01 26.82 26.82s-12.01 26.82-26.82 26.82-26.82-12.01-26.82-26.82 12.01-26.82 26.82-26.82zm-114.8 66.67c-10.19.07-21.6.36-30.5 1.66.43 4.42 1.51 18.63 7.11 29.76 9.11-2.56 18.36-3.9 27.62-3.9 41.28.94 71.48 34.35 78.26 74.47l.11 4.7c10.4 1.91 21.19 2.94 32.21 2.94 11.03 0 21.81-1.02 32.21-2.94l.11-4.7c6.78-40.12 36.98-73.53 78.26-74.47 9.26 0 18.51 1.34 27.62 3.9 5.6-11.13 6.68-25.34 7.11-29.76-8.9-1.3-20.32-1.58-30.5-1.66-18.76.42-35.19 4.17-48.61 9.67-12.54 16.03-29.16 30.03-49.58 33.07-.09.02-.17.04-.27.05-.05.01-.11.04-.16.05-5.24 1.07-10.63 1.6-16.19 1.6-5.55 0-10.95-.53-16.19-1.6-.05-.01-.11-.04-.16-.05-.1-.02-.17-.04-.27-.05-20.42-3.03-37.03-17.04-49.58-33.07-13.42-5.49-29.86-9.25-48.61-9.67z"
    ]
};
var $ef0249c5e48bf4e3$export$188bec0355fe7cb3 = {
    prefix: "fab",
    iconName: "ubuntu",
    icon: [
        496,
        512,
        [],
        "f7df",
        "M248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zm52.7 93c8.8-15.2 28.3-20.5 43.5-11.7 15.3 8.8 20.5 28.3 11.7 43.6-8.8 15.2-28.3 20.5-43.5 11.7-15.3-8.9-20.5-28.4-11.7-43.6zM87.4 287.9c-17.6 0-31.9-14.3-31.9-31.9 0-17.6 14.3-31.9 31.9-31.9 17.6 0 31.9 14.3 31.9 31.9 0 17.6-14.3 31.9-31.9 31.9zm28.1 3.1c22.3-17.9 22.4-51.9 0-69.9 8.6-32.8 29.1-60.7 56.5-79.1l23.7 39.6c-51.5 36.3-51.5 112.5 0 148.8L172 370c-27.4-18.3-47.8-46.3-56.5-79zm228.7 131.7c-15.3 8.8-34.7 3.6-43.5-11.7-8.8-15.3-3.6-34.8 11.7-43.6 15.2-8.8 34.7-3.6 43.5 11.7 8.8 15.3 3.6 34.8-11.7 43.6zm.3-69.5c-26.7-10.3-56.1 6.6-60.5 35-5.2 1.4-48.9 14.3-96.7-9.4l22.5-40.3c57 26.5 123.4-11.7 128.9-74.4l46.1.7c-2.3 34.5-17.3 65.5-40.3 88.4zm-5.9-105.3c-5.4-62-71.3-101.2-128.9-74.4l-22.5-40.3c47.9-23.7 91.5-10.8 96.7-9.4 4.4 28.3 33.8 45.3 60.5 35 23.1 22.9 38 53.9 40.2 88.5l-46 .6z"
    ]
};
var $ef0249c5e48bf4e3$export$89aeef49dacedf59 = {
    prefix: "fab",
    iconName: "draft2digital",
    icon: [
        480,
        512,
        [],
        "f396",
        "M480 398.1l-144-82.2v64.7h-91.3c30.8-35 81.8-95.9 111.8-149.3 35.2-62.6 16.1-123.4-12.8-153.3-4.4-4.6-62.2-62.9-166-41.2-59.1 12.4-89.4 43.4-104.3 67.3-13.1 20.9-17 39.8-18.2 47.7-5.5 33 19.4 67.1 56.7 67.1 31.7 0 57.3-25.7 57.3-57.4 0-27.1-19.7-52.1-48-56.8 1.8-7.3 17.7-21.1 26.3-24.7 41.1-17.3 78 5.2 83.3 33.5 8.3 44.3-37.1 90.4-69.7 127.6C84.5 328.1 18.3 396.8 0 415.9l336-.1V480zM369.9 371l47.1 27.2-47.1 27.2zM134.2 161.4c0 12.4-10 22.4-22.4 22.4s-22.4-10-22.4-22.4 10-22.4 22.4-22.4 22.4 10.1 22.4 22.4zM82.5 380.5c25.6-27.4 97.7-104.7 150.8-169.9 35.1-43.1 40.3-82.4 28.4-112.7-7.4-18.8-17.5-30.2-24.3-35.7 45.3 2.1 68 23.4 82.2 38.3 0 0 42.4 48.2 5.8 113.3-37 65.9-110.9 147.5-128.5 166.7z"
    ]
};
var $ef0249c5e48bf4e3$export$4124a45a674b7b36 = {
    prefix: "fab",
    iconName: "stripe",
    icon: [
        640,
        512,
        [],
        "f429",
        "M165 144.7l-43.3 9.2-.2 142.4c0 26.3 19.8 43.3 46.1 43.3 14.6 0 25.3-2.7 31.2-5.9v-33.8c-5.7 2.3-33.7 10.5-33.7-15.7V221h33.7v-37.8h-33.7zm89.1 51.6l-2.7-13.1H213v153.2h44.3V233.3c10.5-13.8 28.2-11.1 33.9-9.3v-40.8c-6-2.1-26.7-6-37.1 13.1zm92.3-72.3l-44.6 9.5v36.2l44.6-9.5zM44.9 228.3c0-6.9 5.8-9.6 15.1-9.7 13.5 0 30.7 4.1 44.2 11.4v-41.8c-14.7-5.8-29.4-8.1-44.1-8.1-36 0-60 18.8-60 50.2 0 49.2 67.5 41.2 67.5 62.4 0 8.2-7.1 10.9-17 10.9-14.7 0-33.7-6.1-48.6-14.2v40c16.5 7.1 33.2 10.1 48.5 10.1 36.9 0 62.3-15.8 62.3-47.8 0-52.9-67.9-43.4-67.9-63.4zM640 261.6c0-45.5-22-81.4-64.2-81.4s-67.9 35.9-67.9 81.1c0 53.5 30.3 78.2 73.5 78.2 21.2 0 37.1-4.8 49.2-11.5v-33.4c-12.1 6.1-26 9.8-43.6 9.8-17.3 0-32.5-6.1-34.5-26.9h86.9c.2-2.3.6-11.6.6-15.9zm-87.9-16.8c0-20 12.3-28.4 23.4-28.4 10.9 0 22.5 8.4 22.5 28.4zm-112.9-64.6c-17.4 0-28.6 8.2-34.8 13.9l-2.3-11H363v204.8l44.4-9.4.1-50.2c6.4 4.7 15.9 11.2 31.4 11.2 31.8 0 60.8-23.2 60.8-79.6.1-51.6-29.3-79.7-60.5-79.7zm-10.6 122.5c-10.4 0-16.6-3.8-20.9-8.4l-.3-66c4.6-5.1 11-8.8 21.2-8.8 16.2 0 27.4 18.2 27.4 41.4.1 23.9-10.9 41.8-27.4 41.8zm-126.7 33.7h44.6V183.2h-44.6z"
    ]
};
var $ef0249c5e48bf4e3$export$f5c2efa520323804 = {
    prefix: "fab",
    iconName: "houzz",
    icon: [
        448,
        512,
        [],
        "f27c",
        "M275.9 330.7H171.3V480H17V32h109.5v104.5l305.1 85.6V480H275.9z"
    ]
};
var $ef0249c5e48bf4e3$export$5b7cd580ca5d0c32 = {
    prefix: "fab",
    iconName: "gg",
    icon: [
        512,
        512,
        [],
        "f260",
        "M179.2 230.4l102.4 102.4-102.4 102.4L0 256 179.2 76.8l44.8 44.8-25.6 25.6-19.2-19.2-128 128 128 128 51.5-51.5-77.1-76.5 25.6-25.6zM332.8 76.8L230.4 179.2l102.4 102.4 25.6-25.6-77.1-76.5 51.5-51.5 128 128-128 128-19.2-19.2-25.6 25.6 44.8 44.8L512 256 332.8 76.8z"
    ]
};
var $ef0249c5e48bf4e3$export$f3f333bdcc61afcd = {
    prefix: "fab",
    iconName: "dhl",
    icon: [
        640,
        512,
        [],
        "f790",
        "M238 301.2h58.7L319 271h-58.7L238 301.2zM0 282.9v6.4h81.8l4.7-6.4H0zM172.9 271c-8.7 0-6-3.6-4.6-5.5 2.8-3.8 7.6-10.4 10.4-14.1 2.8-3.7 2.8-5.9-2.8-5.9h-51l-41.1 55.8h100.1c33.1 0 51.5-22.5 57.2-30.3h-68.2zm317.5-6.9l39.3-53.4h-62.2l-39.3 53.4h62.2zM95.3 271H0v6.4h90.6l4.7-6.4zm111-26.6c-2.8 3.8-7.5 10.4-10.3 14.2-1.4 2-4.1 5.5 4.6 5.5h45.6s7.3-10 13.5-18.4c8.4-11.4.7-35-29.2-35H112.6l-20.4 27.8h111.4c5.6 0 5.5 2.2 2.7 5.9zM0 301.2h73.1l4.7-6.4H0v6.4zm323 0h58.7L404 271h-58.7c-.1 0-22.3 30.2-22.3 30.2zm222 .1h95v-6.4h-90.3l-4.7 6.4zm22.3-30.3l-4.7 6.4H640V271h-72.7zm-13.5 18.3H640v-6.4h-81.5l-4.7 6.4zm-164.2-78.6l-22.5 30.6h-26.2l22.5-30.6h-58.7l-39.3 53.4H409l39.3-53.4h-58.7zm33.5 60.3s-4.3 5.9-6.4 8.7c-7.4 10-.9 21.6 23.2 21.6h94.3l22.3-30.3H423.1z"
    ]
};
var $ef0249c5e48bf4e3$export$bfa4536fab29fa25 = {
    prefix: "fab",
    iconName: "square-pinterest",
    icon: [
        448,
        512,
        [
            "pinterest-square"
        ],
        "f0d3",
        "M448 80v352c0 26.5-21.5 48-48 48H154.4c9.8-16.4 22.4-40 27.4-59.3 3-11.5 15.3-58.4 15.3-58.4 8 15.3 31.4 28.2 56.3 28.2 74.1 0 127.4-68.1 127.4-152.7 0-81.1-66.2-141.8-151.4-141.8-106 0-162.2 71.1-162.2 148.6 0 36 19.2 80.8 49.8 95.1 4.7 2.2 7.1 1.2 8.2-3.3.8-3.4 5-20.1 6.8-27.8.6-2.5.3-4.6-1.7-7-10.1-12.3-18.3-34.9-18.3-56 0-54.2 41-106.6 110.9-106.6 60.3 0 102.6 41.1 102.6 99.9 0 66.4-33.5 112.4-77.2 112.4-24.1 0-42.1-19.9-36.4-44.4 6.9-29.2 20.3-60.7 20.3-81.8 0-53-75.5-45.7-75.5 25 0 21.7 7.3 36.5 7.3 36.5-31.4 132.8-36.1 134.5-29.6 192.6l2.2.8H48c-26.5 0-48-21.5-48-48V80c0-26.5 21.5-48 48-48h352c26.5 0 48 21.5 48 48z"
    ]
};
var $ef0249c5e48bf4e3$export$67aa35027cc046c7 = $ef0249c5e48bf4e3$export$bfa4536fab29fa25;
var $ef0249c5e48bf4e3$export$28ff226a626fb008 = {
    prefix: "fab",
    iconName: "xing",
    icon: [
        384,
        512,
        [],
        "f168",
        "M162.7 210c-1.8 3.3-25.2 44.4-70.1 123.5-4.9 8.3-10.8 12.5-17.7 12.5H9.8c-7.7 0-12.1-7.5-8.5-14.4l69-121.3c.2 0 .2-.1 0-.3l-43.9-75.6c-4.3-7.8.3-14.1 8.5-14.1H100c7.3 0 13.3 4.1 18 12.2l44.7 77.5zM382.6 46.1l-144 253v.3L330.2 466c3.9 7.1.2 14.1-8.5 14.1h-65.2c-7.6 0-13.6-4-18-12.2l-92.4-168.5c3.3-5.8 51.5-90.8 144.8-255.2 4.6-8.1 10.4-12.2 17.5-12.2h65.7c8 0 12.3 6.7 8.5 14.1z"
    ]
};
var $ef0249c5e48bf4e3$export$11c2ed8ca6d46555 = {
    prefix: "fab",
    iconName: "blackberry",
    icon: [
        512,
        512,
        [],
        "f37b",
        "M166 116.9c0 23.4-16.4 49.1-72.5 49.1H23.4l21-88.8h67.8c42.1 0 53.8 23.3 53.8 39.7zm126.2-39.7h-67.8L205.7 166h70.1c53.8 0 70.1-25.7 70.1-49.1.1-16.4-11.6-39.7-53.7-39.7zM88.8 208.1H21L0 296.9h70.1c56.1 0 72.5-23.4 72.5-49.1 0-16.3-11.7-39.7-53.8-39.7zm180.1 0h-67.8l-18.7 88.8h70.1c53.8 0 70.1-23.4 70.1-49.1 0-16.3-11.7-39.7-53.7-39.7zm189.3-53.8h-67.8l-18.7 88.8h70.1c53.8 0 70.1-23.4 70.1-49.1.1-16.3-11.6-39.7-53.7-39.7zm-28 137.9h-67.8L343.7 381h70.1c56.1 0 70.1-23.4 70.1-49.1 0-16.3-11.6-39.7-53.7-39.7zM240.8 346H173l-18.7 88.8h70.1c56.1 0 70.1-25.7 70.1-49.1.1-16.3-11.6-39.7-53.7-39.7z"
    ]
};
var $ef0249c5e48bf4e3$export$10c9e6deac1c2eeb = {
    prefix: "fab",
    iconName: "creative-commons-pd",
    icon: [
        496,
        512,
        [],
        "f4ec",
        "M248 8C111 8 0 119.1 0 256c0 137 111 248 248 248s248-111 248-248C496 119.1 385 8 248 8zm0 449.5c-139.2 0-235.8-138-190.2-267.9l78.8 35.1c-2.1 10.5-3.3 21.5-3.3 32.9 0 99 73.9 126.9 120.4 126.9 22.9 0 53.5-6.7 79.4-29.5L297 311.1c-5.5 6.3-17.6 16.7-36.3 16.7-37.8 0-53.7-39.9-53.9-71.9 230.4 102.6 216.5 96.5 217.9 96.8-34.3 62.4-100.6 104.8-176.7 104.8zm194.2-150l-224-100c18.8-34 54.9-30.7 74.7-11l40.4-41.6c-27.1-23.3-58-27.5-78.1-27.5-47.4 0-80.9 20.5-100.7 51.6l-74.9-33.4c36.1-54.9 98.1-91.2 168.5-91.2 111.1 0 201.5 90.4 201.5 201.5 0 18-2.4 35.4-6.8 52-.3-.1-.4-.2-.6-.4z"
    ]
};
var $ef0249c5e48bf4e3$export$6fcce83c026197c = {
    prefix: "fab",
    iconName: "playstation",
    icon: [
        576,
        512,
        [],
        "f3df",
        "M570.9 372.3c-11.3 14.2-38.8 24.3-38.8 24.3L327 470.2v-54.3l150.9-53.8c17.1-6.1 19.8-14.8 5.8-19.4-13.9-4.6-39.1-3.3-56.2 2.9L327 381.1v-56.4c23.2-7.8 47.1-13.6 75.7-16.8 40.9-4.5 90.9.6 130.2 15.5 44.2 14 49.2 34.7 38 48.9zm-224.4-92.5v-139c0-16.3-3-31.3-18.3-35.6-11.7-3.8-19 7.1-19 23.4v347.9l-93.8-29.8V32c39.9 7.4 98 24.9 129.2 35.4C424.1 94.7 451 128.7 451 205.2c0 74.5-46 102.8-104.5 74.6zM43.2 410.2c-45.4-12.8-53-39.5-32.3-54.8 19.1-14.2 51.7-24.9 51.7-24.9l134.5-47.8v54.5l-96.8 34.6c-17.1 6.1-19.7 14.8-5.8 19.4 13.9 4.6 39.1 3.3 56.2-2.9l46.4-16.9v48.8c-51.6 9.3-101.4 7.3-153.9-10z"
    ]
};
var $ef0249c5e48bf4e3$export$1079c541f45f51d0 = {
    prefix: "fab",
    iconName: "quinscape",
    icon: [
        512,
        512,
        [],
        "f459",
        "M313.6 474.6h-1a158.1 158.1 0 0 1 0-316.2c94.9 0 168.2 83.1 157 176.6 4 5.1 8.2 9.6 11.2 15.3 13.4-30.3 20.3-62.4 20.3-97.7C501.1 117.5 391.6 8 256.5 8S12 117.5 12 252.6s109.5 244.6 244.5 244.6a237.36 237.36 0 0 0 70.4-10.1c-5.2-3.5-8.9-8.1-13.3-12.5zm-.1-.1l.4.1zm78.4-168.9a99.2 99.2 0 1 0 99.2 99.2 99.18 99.18 0 0 0-99.2-99.2z"
    ]
};
var $ef0249c5e48bf4e3$export$df0a28abd4a08bff = {
    prefix: "fab",
    iconName: "less",
    icon: [
        640,
        512,
        [],
        "f41d",
        "M612.7 219c0-20.5 3.2-32.6 3.2-54.6 0-34.2-12.6-45.2-40.5-45.2h-20.5v24.2h6.3c14.2 0 17.3 4.7 17.3 22.1 0 16.3-1.6 32.6-1.6 51.5 0 24.2 7.9 33.6 23.6 37.3v1.6c-15.8 3.7-23.6 13.1-23.6 37.3 0 18.9 1.6 34.2 1.6 51.5 0 17.9-3.7 22.6-17.3 22.6v.5h-6.3V393h20.5c27.8 0 40.5-11 40.5-45.2 0-22.6-3.2-34.2-3.2-54.6 0-11 6.8-22.6 27.3-23.6v-27.3c-20.5-.7-27.3-12.3-27.3-23.3zm-105.6 32c-15.8-6.3-30.5-10-30.5-20.5 0-7.9 6.3-12.6 17.9-12.6s22.1 4.7 33.6 13.1l21-27.8c-13.1-10-31-20.5-55.2-20.5-35.7 0-59.9 20.5-59.9 49.4 0 25.7 22.6 38.9 41.5 46.2 16.3 6.3 32.1 11.6 32.1 22.1 0 7.9-6.3 13.1-20.5 13.1-13.1 0-26.3-5.3-40.5-16.3l-21 30.5c15.8 13.1 39.9 22.1 59.9 22.1 42 0 64.6-22.1 64.6-51s-22.5-41-43-47.8zm-358.9 59.4c-3.7 0-8.4-3.2-8.4-13.1V119.1H65.2c-28.4 0-41 11-41 45.2 0 22.6 3.2 35.2 3.2 54.6 0 11-6.8 22.6-27.3 23.6v27.3c20.5.5 27.3 12.1 27.3 23.1 0 19.4-3.2 31-3.2 53.6 0 34.2 12.6 45.2 40.5 45.2h20.5v-24.2h-6.3c-13.1 0-17.3-5.3-17.3-22.6s1.6-32.1 1.6-51.5c0-24.2-7.9-33.6-23.6-37.3v-1.6c15.8-3.7 23.6-13.1 23.6-37.3 0-18.9-1.6-34.2-1.6-51.5s3.7-22.1 17.3-22.1H93v150.8c0 32.1 11 53.1 43.1 53.1 10 0 17.9-1.6 23.6-3.7l-5.3-34.2c-3.1.8-4.6.8-6.2.8zM379.9 251c-16.3-6.3-31-10-31-20.5 0-7.9 6.3-12.6 17.9-12.6 11.6 0 22.1 4.7 33.6 13.1l21-27.8c-13.1-10-31-20.5-55.2-20.5-35.7 0-59.9 20.5-59.9 49.4 0 25.7 22.6 38.9 41.5 46.2 16.3 6.3 32.1 11.6 32.1 22.1 0 7.9-6.3 13.1-20.5 13.1-13.1 0-26.3-5.3-40.5-16.3l-20.5 30.5c15.8 13.1 39.9 22.1 59.9 22.1 42 0 64.6-22.1 64.6-51 .1-28.9-22.5-41-43-47.8zm-155-68.8c-38.4 0-75.1 32.1-74.1 82.5 0 52 34.2 82.5 79.3 82.5 18.9 0 39.9-6.8 56.2-17.9l-15.8-27.8c-11.6 6.8-22.6 10-34.2 10-21 0-37.3-10-41.5-34.2H290c.5-3.7 1.6-11 1.6-19.4.6-42.6-22.6-75.7-66.7-75.7zm-30 66.2c3.2-21 15.8-31 30.5-31 18.9 0 26.3 13.1 26.3 31h-56.8z"
    ]
};
var $ef0249c5e48bf4e3$export$fb78f7bb43feec45 = {
    prefix: "fab",
    iconName: "blogger-b",
    icon: [
        448,
        512,
        [],
        "f37d",
        "M446.6 222.7c-1.8-8-6.8-15.4-12.5-18.5-1.8-1-13-2.2-25-2.7-20.1-.9-22.3-1.3-28.7-5-10.1-5.9-12.8-12.3-12.9-29.5-.1-33-13.8-63.7-40.9-91.3-19.3-19.7-40.9-33-65.5-40.5-5.9-1.8-19.1-2.4-63.3-2.9-69.4-.8-84.8.6-108.4 10C45.9 59.5 14.7 96.1 3.3 142.9 1.2 151.7.7 165.8.2 246.8c-.6 101.5.1 116.4 6.4 136.5 15.6 49.6 59.9 86.3 104.4 94.3 14.8 2.7 197.3 3.3 216 .8 32.5-4.4 58-17.5 81.9-41.9 17.3-17.7 28.1-36.8 35.2-62.1 4.9-17.6 4.5-142.8 2.5-151.7zm-322.1-63.6c7.8-7.9 10-8.2 58.8-8.2 43.9 0 45.4.1 51.8 3.4 9.3 4.7 13.4 11.3 13.4 21.9 0 9.5-3.8 16.2-12.3 21.6-4.6 2.9-7.3 3.1-50.3 3.3-26.5.2-47.7-.4-50.8-1.2-16.6-4.7-22.8-28.5-10.6-40.8zm191.8 199.8l-14.9 2.4-77.5.9c-68.1.8-87.3-.4-90.9-2-7.1-3.1-13.8-11.7-14.9-19.4-1.1-7.3 2.6-17.3 8.2-22.4 7.1-6.4 10.2-6.6 97.3-6.7 89.6-.1 89.1-.1 97.6 7.8 12.1 11.3 9.5 31.2-4.9 39.4z"
    ]
};
var $ef0249c5e48bf4e3$export$b1b65e1549fc9915 = {
    prefix: "fab",
    iconName: "opencart",
    icon: [
        640,
        512,
        [],
        "f23d",
        "M423.3 440.7c0 25.3-20.3 45.6-45.6 45.6s-45.8-20.3-45.8-45.6 20.6-45.8 45.8-45.8c25.4 0 45.6 20.5 45.6 45.8zm-253.9-45.8c-25.3 0-45.6 20.6-45.6 45.8s20.3 45.6 45.6 45.6 45.8-20.3 45.8-45.6-20.5-45.8-45.8-45.8zm291.7-270C158.9 124.9 81.9 112.1 0 25.7c34.4 51.7 53.3 148.9 373.1 144.2 333.3-5 130 86.1 70.8 188.9 186.7-166.7 319.4-233.9 17.2-233.9z"
    ]
};
var $ef0249c5e48bf4e3$export$ff24f295c905f144 = {
    prefix: "fab",
    iconName: "vine",
    icon: [
        384,
        512,
        [],
        "f1ca",
        "M384 254.7v52.1c-18.4 4.2-36.9 6.1-52.1 6.1-36.9 77.4-103 143.8-125.1 156.2-14 7.9-27.1 8.4-42.7-.8C137 452 34.2 367.7 0 102.7h74.5C93.2 261.8 139 343.4 189.3 404.5c27.9-27.9 54.8-65.1 75.6-106.9-49.8-25.3-80.1-80.9-80.1-145.6 0-65.6 37.7-115.1 102.2-115.1 114.9 0 106.2 127.9 81.6 181.5 0 0-46.4 9.2-63.5-20.5 3.4-11.3 8.2-30.8 8.2-48.5 0-31.3-11.3-46.6-28.4-46.6-18.2 0-30.8 17.1-30.8 50 .1 79.2 59.4 118.7 129.9 101.9z"
    ]
};
var $ef0249c5e48bf4e3$export$1aaa7b292157aaf7 = {
    prefix: "fab",
    iconName: "paypal",
    icon: [
        384,
        512,
        [],
        "f1ed",
        "M111.4 295.9c-3.5 19.2-17.4 108.7-21.5 134-.3 1.8-1 2.5-3 2.5H12.3c-7.6 0-13.1-6.6-12.1-13.9L58.8 46.6c1.5-9.6 10.1-16.9 20-16.9 152.3 0 165.1-3.7 204 11.4 60.1 23.3 65.6 79.5 44 140.3-21.5 62.6-72.5 89.5-140.1 90.3-43.4.7-69.5-7-75.3 24.2zM357.1 152c-1.8-1.3-2.5-1.8-3 1.3-2 11.4-5.1 22.5-8.8 33.6-39.9 113.8-150.5 103.9-204.5 103.9-6.1 0-10.1 3.3-10.9 9.4-22.6 140.4-27.1 169.7-27.1 169.7-1 7.1 3.5 12.9 10.6 12.9h63.5c8.6 0 15.7-6.3 17.4-14.9.7-5.4-1.1 6.1 14.4-91.3 4.6-22 14.3-19.7 29.3-19.7 71 0 126.4-28.8 142.9-112.3 6.5-34.8 4.6-71.4-23.8-92.6z"
    ]
};
var $ef0249c5e48bf4e3$export$bc1566dfb0a3651b = {
    prefix: "fab",
    iconName: "gitlab",
    icon: [
        512,
        512,
        [],
        "f296",
        "M503.5 204.6L502.8 202.8L433.1 21.02C431.7 17.45 429.2 14.43 425.9 12.38C423.5 10.83 420.8 9.865 417.9 9.57C415 9.275 412.2 9.653 409.5 10.68C406.8 11.7 404.4 13.34 402.4 15.46C400.5 17.58 399.1 20.13 398.3 22.9L351.3 166.9H160.8L113.7 22.9C112.9 20.13 111.5 17.59 109.6 15.47C107.6 13.35 105.2 11.72 102.5 10.7C99.86 9.675 96.98 9.295 94.12 9.587C91.26 9.878 88.51 10.83 86.08 12.38C82.84 14.43 80.33 17.45 78.92 21.02L9.267 202.8L8.543 204.6C-1.484 230.8-2.72 259.6 5.023 286.6C12.77 313.5 29.07 337.3 51.47 354.2L51.74 354.4L52.33 354.8L158.3 434.3L210.9 474L242.9 498.2C246.6 500.1 251.2 502.5 255.9 502.5C260.6 502.5 265.2 500.1 268.9 498.2L300.9 474L353.5 434.3L460.2 354.4L460.5 354.1C482.9 337.2 499.2 313.5 506.1 286.6C514.7 259.6 513.5 230.8 503.5 204.6z"
    ]
};
var $ef0249c5e48bf4e3$export$26fe3ad1dc9d4c5b = {
    prefix: "fab",
    iconName: "typo3",
    icon: [
        448,
        512,
        [],
        "f42b",
        "M178.7 78.4c0-24.7 5.4-32.4 13.9-39.4-69.5 8.5-149.3 34-176.3 66.4-5.4 7.7-9.3 20.8-9.3 37.1C7 246 113.8 480 191.1 480c36.3 0 97.3-59.5 146.7-139-7 2.3-11.6 2.3-18.5 2.3-57.2 0-140.6-198.5-140.6-264.9zM301.5 32c-30.1 0-41.7 5.4-41.7 36.3 0 66.4 53.8 198.5 101.7 198.5 26.3 0 78.8-99.7 78.8-182.3 0-40.9-67-52.5-138.8-52.5z"
    ]
};
var $ef0249c5e48bf4e3$export$9fbf70587b6b0dcc = {
    prefix: "fab",
    iconName: "reddit-alien",
    icon: [
        512,
        512,
        [],
        "f281",
        "M440.3 203.5c-15 0-28.2 6.2-37.9 15.9-35.7-24.7-83.8-40.6-137.1-42.3L293 52.3l88.2 19.8c0 21.6 17.6 39.2 39.2 39.2 22 0 39.7-18.1 39.7-39.7s-17.6-39.7-39.7-39.7c-15.4 0-28.7 9.3-35.3 22l-97.4-21.6c-4.9-1.3-9.7 2.2-11 7.1L246.3 177c-52.9 2.2-100.5 18.1-136.3 42.8-9.7-10.1-23.4-16.3-38.4-16.3-55.6 0-73.8 74.6-22.9 100.1-1.8 7.9-2.6 16.3-2.6 24.7 0 83.8 94.4 151.7 210.3 151.7 116.4 0 210.8-67.9 210.8-151.7 0-8.4-.9-17.2-3.1-25.1 49.9-25.6 31.5-99.7-23.8-99.7zM129.4 308.9c0-22 17.6-39.7 39.7-39.7 21.6 0 39.2 17.6 39.2 39.7 0 21.6-17.6 39.2-39.2 39.2-22 .1-39.7-17.6-39.7-39.2zm214.3 93.5c-36.4 36.4-139.1 36.4-175.5 0-4-3.5-4-9.7 0-13.7 3.5-3.5 9.7-3.5 13.2 0 27.8 28.5 120 29 149 0 3.5-3.5 9.7-3.5 13.2 0 4.1 4 4.1 10.2.1 13.7zm-.8-54.2c-21.6 0-39.2-17.6-39.2-39.2 0-22 17.6-39.7 39.2-39.7 22 0 39.7 17.6 39.7 39.7-.1 21.5-17.7 39.2-39.7 39.2z"
    ]
};
var $ef0249c5e48bf4e3$export$d0632e92ebe1197f = {
    prefix: "fab",
    iconName: "yahoo",
    icon: [
        512,
        512,
        [],
        "f19e",
        "M223.69,141.06,167,284.23,111,141.06H14.93L120.76,390.19,82.19,480h94.17L317.27,141.06Zm105.4,135.79a58.22,58.22,0,1,0,58.22,58.22A58.22,58.22,0,0,0,329.09,276.85ZM394.65,32l-93,223.47H406.44L499.07,32Z"
    ]
};
var $ef0249c5e48bf4e3$export$9743e7788f64058a = {
    prefix: "fab",
    iconName: "dailymotion",
    icon: [
        448,
        512,
        [],
        "e052",
        "M298.93,267a48.4,48.4,0,0,0-24.36-6.21q-19.83,0-33.44,13.27t-13.61,33.42q0,21.16,13.28,34.6t33.43,13.44q20.5,0,34.11-13.78T322,307.47A47.13,47.13,0,0,0,315.9,284,44.13,44.13,0,0,0,298.93,267ZM0,32V480H448V32ZM374.71,405.26h-53.1V381.37h-.67q-15.79,26.2-55.78,26.2-27.56,0-48.89-13.1a88.29,88.29,0,0,1-32.94-35.77q-11.6-22.68-11.59-50.89,0-27.56,11.76-50.22a89.9,89.9,0,0,1,32.93-35.78q21.18-13.09,47.72-13.1a80.87,80.87,0,0,1,29.74,5.21q13.28,5.21,25,17V153l55.79-12.09Z"
    ]
};
var $ef0249c5e48bf4e3$export$c40f060084205fb6 = {
    prefix: "fab",
    iconName: "affiliatetheme",
    icon: [
        512,
        512,
        [],
        "f36b",
        "M159.7 237.4C108.4 308.3 43.1 348.2 14 326.6-15.2 304.9 2.8 230 54.2 159.1c51.3-70.9 116.6-110.8 145.7-89.2 29.1 21.6 11.1 96.6-40.2 167.5zm351.2-57.3C437.1 303.5 319 367.8 246.4 323.7c-25-15.2-41.3-41.2-49-73.8-33.6 64.8-92.8 113.8-164.1 133.2 49.8 59.3 124.1 96.9 207 96.9 150 0 271.6-123.1 271.6-274.9.1-8.5-.3-16.8-1-25z"
    ]
};
var $ef0249c5e48bf4e3$export$96d17626187f6e34 = {
    prefix: "fab",
    iconName: "pied-piper-pp",
    icon: [
        448,
        512,
        [],
        "f1a7",
        "M205.3 174.6c0 21.1-14.2 38.1-31.7 38.1-7.1 0-12.8-1.2-17.2-3.7v-68c4.4-2.7 10.1-4.2 17.2-4.2 17.5 0 31.7 16.9 31.7 37.8zm52.6 67c-7.1 0-12.8 1.5-17.2 4.2v68c4.4 2.5 10.1 3.7 17.2 3.7 17.4 0 31.7-16.9 31.7-37.8 0-21.1-14.3-38.1-31.7-38.1zM448 80v352c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V80c0-26.5 21.5-48 48-48h352c26.5 0 48 21.5 48 48zM185 255.1c41 0 74.2-35.6 74.2-79.6 0-44-33.2-79.6-74.2-79.6-12 0-24.1 3.2-34.6 8.8h-45.7V311l51.8-10.1v-50.6c8.6 3.1 18.1 4.8 28.5 4.8zm158.4 25.3c0-44-33.2-79.6-73.9-79.6-3.2 0-6.4.2-9.6.7-3.7 12.5-10.1 23.8-19.2 33.4-13.8 15-32.2 23.8-51.8 24.8V416l51.8-10.1v-50.6c8.6 3.2 18.2 4.7 28.7 4.7 40.8 0 74-35.6 74-79.6z"
    ]
};
var $ef0249c5e48bf4e3$export$3de8f256f5aadacf = {
    prefix: "fab",
    iconName: "bootstrap",
    icon: [
        576,
        512,
        [],
        "f836",
        "M333.5,201.4c0-22.1-15.6-34.3-43-34.3h-50.4v71.2h42.5C315.4,238.2,333.5,225,333.5,201.4z M517,188.6 c-9.5-30.9-10.9-68.8-9.8-98.1c1.1-30.5-22.7-58.5-54.7-58.5H123.7c-32.1,0-55.8,28.1-54.7,58.5c1,29.3-0.3,67.2-9.8,98.1 c-9.6,31-25.7,50.6-52.2,53.1v28.5c26.4,2.5,42.6,22.1,52.2,53.1c9.5,30.9,10.9,68.8,9.8,98.1c-1.1,30.5,22.7,58.5,54.7,58.5h328.7 c32.1,0,55.8-28.1,54.7-58.5c-1-29.3,0.3-67.2,9.8-98.1c9.6-31,25.7-50.6,52.1-53.1v-28.5C542.7,239.2,526.5,219.6,517,188.6z M300.2,375.1h-97.9V136.8h97.4c43.3,0,71.7,23.4,71.7,59.4c0,25.3-19.1,47.9-43.5,51.8v1.3c33.2,3.6,55.5,26.6,55.5,58.3 C383.4,349.7,352.1,375.1,300.2,375.1z M290.2,266.4h-50.1v78.4h52.3c34.2,0,52.3-13.7,52.3-39.5 C344.7,279.6,326.1,266.4,290.2,266.4z"
    ]
};
var $ef0249c5e48bf4e3$export$f31d1294fef45f = {
    prefix: "fab",
    iconName: "odnoklassniki",
    icon: [
        320,
        512,
        [],
        "f263",
        "M275.1 334c-27.4 17.4-65.1 24.3-90 26.9l20.9 20.6 76.3 76.3c27.9 28.6-17.5 73.3-45.7 45.7-19.1-19.4-47.1-47.4-76.3-76.6L84 503.4c-28.2 27.5-73.6-17.6-45.4-45.7 19.4-19.4 47.1-47.4 76.3-76.3l20.6-20.6c-24.6-2.6-62.9-9.1-90.6-26.9-32.6-21-46.9-33.3-34.3-59 7.4-14.6 27.7-26.9 54.6-5.7 0 0 36.3 28.9 94.9 28.9s94.9-28.9 94.9-28.9c26.9-21.1 47.1-8.9 54.6 5.7 12.4 25.7-1.9 38-34.5 59.1zM30.3 129.7C30.3 58 88.6 0 160 0s129.7 58 129.7 129.7c0 71.4-58.3 129.4-129.7 129.4s-129.7-58-129.7-129.4zm66 0c0 35.1 28.6 63.7 63.7 63.7s63.7-28.6 63.7-63.7c0-35.4-28.6-64-63.7-64s-63.7 28.6-63.7 64z"
    ]
};
var $ef0249c5e48bf4e3$export$a64aa05b0287bdaf = {
    prefix: "fab",
    iconName: "nfc-symbol",
    icon: [
        576,
        512,
        [],
        "e531",
        "M392.9 32.43C400.6 31.1 408.6 32.89 414.1 37.41C498.2 96.14 544 173.7 544 255.1C544 338.2 498.2 415.9 414.1 474.6C409.3 478.6 402.4 480.5 395.5 479.9C388.5 479.3 382 476.3 377.1 471.4L193.7 288.7C188.1 283.2 185 275.7 184.1 267.8C184.1 260 188.1 252.5 193.6 246.9C199.2 241.4 206.7 238.2 214.5 238.2C222.4 238.2 229.9 241.3 235.4 246.8L400.5 411.2C455.1 366.5 484.8 312 484.8 255.1C484.8 193.5 447.9 132.9 380.9 85.76C374.5 81.24 370.1 74.35 368.8 66.62C367.4 58.89 369.2 50.94 373.8 44.53C378.3 38.12 385.2 33.77 392.9 32.43V32.43zM186.9 479.6C179.2 480.9 171.3 479.1 164.8 474.6C81.67 415.9 35.84 338.2 35.84 255.1C35.84 173.7 81.67 96.14 164.8 37.41C170.5 33.4 177.4 31.53 184.4 32.12C191.3 32.71 197.8 35.72 202.7 40.63L386.1 223.3C391.7 228.8 394.8 236.3 394.8 244.2C394.9 251.1 391.8 259.5 386.2 265.1C380.7 270.6 373.2 273.8 365.3 273.8C357.5 273.8 349.1 270.7 344.4 265.2L179.3 100.7C124.7 145.9 95.03 199.9 95.03 255.1C95.03 318.5 131.9 379.1 198.1 426.2C205.4 430.8 209.7 437.6 211.1 445.4C212.4 453.1 210.6 461.1 206.1 467.5C201.6 473.9 194.7 478.2 186.9 479.6V479.6z"
    ]
};
var $ef0249c5e48bf4e3$export$b5ebb163fdb5edfd = {
    prefix: "fab",
    iconName: "ethereum",
    icon: [
        320,
        512,
        [],
        "f42e",
        "M311.9 260.8L160 353.6 8 260.8 160 0l151.9 260.8zM160 383.4L8 290.6 160 512l152-221.4-152 92.8z"
    ]
};
var $ef0249c5e48bf4e3$export$7c461c4ee7c07c19 = {
    prefix: "fab",
    iconName: "speaker-deck",
    icon: [
        512,
        512,
        [],
        "f83c",
        "M213.86 296H100a100 100 0 0 1 0-200h132.84a40 40 0 0 1 0 80H98c-26.47 0-26.45 40 0 40h113.82a100 100 0 0 1 0 200H40a40 40 0 0 1 0-80h173.86c26.48 0 26.46-40 0-40zM298 416a120.21 120.21 0 0 0 51.11-80h64.55a19.83 19.83 0 0 0 19.66-20V196a19.83 19.83 0 0 0-19.66-20H296.42a60.77 60.77 0 0 0 0-80h136.93c43.44 0 78.65 35.82 78.65 80v160c0 44.18-35.21 80-78.65 80z"
    ]
};
var $ef0249c5e48bf4e3$export$bcf1858bdc40caa3 = {
    prefix: "fab",
    iconName: "creative-commons-nc-eu",
    icon: [
        496,
        512,
        [],
        "f4e9",
        "M247.7 8C103.6 8 0 124.8 0 256c0 136.3 111.7 248 247.7 248C377.9 504 496 403.1 496 256 496 117 388.4 8 247.7 8zm.6 450.7c-112 0-203.6-92.5-203.6-202.7 0-23.2 3.7-45.2 10.9-66l65.7 29.1h-4.7v29.5h23.3c0 6.2-.4 3.2-.4 19.5h-22.8v29.5h27c11.4 67 67.2 101.3 124.6 101.3 26.6 0 50.6-7.9 64.8-15.8l-10-46.1c-8.7 4.6-28.2 10.8-47.3 10.8-28.2 0-58.1-10.9-67.3-50.2h90.3l128.3 56.8c-1.5 2.1-56.2 104.3-178.8 104.3zm-16.7-190.6l-.5-.4.9.4h-.4zm77.2-19.5h3.7v-29.5h-70.3l-28.6-12.6c2.5-5.5 5.4-10.5 8.8-14.3 12.9-15.8 31.1-22.4 51.1-22.4 18.3 0 35.3 5.4 46.1 10l11.6-47.3c-15-6.6-37-12.4-62.3-12.4-39 0-72.2 15.8-95.9 42.3-5.3 6.1-9.8 12.9-13.9 20.1l-81.6-36.1c64.6-96.8 157.7-93.6 170.7-93.6 113 0 203 90.2 203 203.4 0 18.7-2.1 36.3-6.3 52.9l-136.1-60.5z"
    ]
};
var $ef0249c5e48bf4e3$export$a4dfebb823a477ff = {
    prefix: "fab",
    iconName: "patreon",
    icon: [
        512,
        512,
        [],
        "f3d9",
        "M512 194.8c0 101.3-82.4 183.8-183.8 183.8-101.7 0-184.4-82.4-184.4-183.8 0-101.6 82.7-184.3 184.4-184.3C429.6 10.5 512 93.2 512 194.8zM0 501.5h90v-491H0v491z"
    ]
};
var $ef0249c5e48bf4e3$export$862396e708985a99 = {
    prefix: "fab",
    iconName: "avianex",
    icon: [
        512,
        512,
        [],
        "f374",
        "M453.1 32h-312c-38.9 0-76.2 31.2-83.3 69.7L1.2 410.3C-5.9 448.8 19.9 480 58.9 480h312c38.9 0 76.2-31.2 83.3-69.7l56.7-308.5c7-38.6-18.8-69.8-57.8-69.8zm-58.2 347.3l-32 13.5-115.4-110c-14.7 10-29.2 19.5-41.7 27.1l22.1 64.2-17.9 12.7-40.6-61-52.4-48.1 15.7-15.4 58 31.1c9.3-10.5 20.8-22.6 32.8-34.9L203 228.9l-68.8-99.8 18.8-28.9 8.9-4.8L265 207.8l4.9 4.5c19.4-18.8 33.8-32.4 33.8-32.4 7.7-6.5 21.5-2.9 30.7 7.9 9 10.5 10.6 24.7 2.7 31.3-1.8 1.3-15.5 11.4-35.3 25.6l4.5 7.3 94.9 119.4-6.3 7.9z"
    ]
};
var $ef0249c5e48bf4e3$export$e644e4a8cae83fb3 = {
    prefix: "fab",
    iconName: "ello",
    icon: [
        496,
        512,
        [],
        "f5f1",
        "M248 8C111.03 8 0 119.03 0 256s111.03 248 248 248 248-111.03 248-248S384.97 8 248 8zm143.84 285.2C375.31 358.51 315.79 404.8 248 404.8s-127.31-46.29-143.84-111.6c-1.65-7.44 2.48-15.71 9.92-17.36 7.44-1.65 15.71 2.48 17.36 9.92 14.05 52.91 62 90.11 116.56 90.11s102.51-37.2 116.56-90.11c1.65-7.44 9.92-12.4 17.36-9.92 7.44 1.65 12.4 9.92 9.92 17.36z"
    ]
};
var $ef0249c5e48bf4e3$export$380164e9d6cdbec2 = {
    prefix: "fab",
    iconName: "gofore",
    icon: [
        400,
        512,
        [],
        "f3a7",
        "M324 319.8h-13.2v34.7c-24.5 23.1-56.3 35.8-89.9 35.8-73.2 0-132.4-60.2-132.4-134.4 0-74.1 59.2-134.4 132.4-134.4 35.3 0 68.6 14 93.6 39.4l62.3-63.3C335 55.3 279.7 32 220.7 32 98 32 0 132.6 0 256c0 122.5 97 224 220.7 224 63.2 0 124.5-26.2 171-82.5-2-27.6-13.4-77.7-67.7-77.7zm-12.1-112.5H205.6v89H324c33.5 0 60.5 15.1 76 41.8v-30.6c0-65.2-40.4-100.2-88.1-100.2z"
    ]
};
var $ef0249c5e48bf4e3$export$a219f36955efe01a = {
    prefix: "fab",
    iconName: "bimobject",
    icon: [
        448,
        512,
        [],
        "f378",
        "M416 32H32C14.4 32 0 46.4 0 64v384c0 17.6 14.4 32 32 32h384c17.6 0 32-14.4 32-32V64c0-17.6-14.4-32-32-32zm-64 257.4c0 49.4-11.4 82.6-103.8 82.6h-16.9c-44.1 0-62.4-14.9-70.4-38.8h-.9V368H96V136h64v74.7h1.1c4.6-30.5 39.7-38.8 69.7-38.8h17.3c92.4 0 103.8 33.1 103.8 82.5v35zm-64-28.9v22.9c0 21.7-3.4 33.8-38.4 33.8h-45.3c-28.9 0-44.1-6.5-44.1-35.7v-19c0-29.3 15.2-35.7 44.1-35.7h45.3c35-.2 38.4 12 38.4 33.7z"
    ]
};
var $ef0249c5e48bf4e3$export$890714bb00316cc = {
    prefix: "fab",
    iconName: "facebook-f",
    icon: [
        320,
        512,
        [],
        "f39e",
        "M279.14 288l14.22-92.66h-88.91v-60.13c0-25.35 12.42-50.06 52.24-50.06h40.42V6.26S260.43 0 225.36 0c-73.22 0-121.08 44.38-121.08 124.72v70.62H22.89V288h81.39v224h100.17V288z"
    ]
};
var $ef0249c5e48bf4e3$export$e94511deb1df63ce = {
    prefix: "fab",
    iconName: "square-google-plus",
    icon: [
        448,
        512,
        [
            "google-plus-square"
        ],
        "f0d4",
        "M400 32H48C21.5 32 0 53.5 0 80v352c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48V80c0-26.5-21.5-48-48-48zM164 356c-55.3 0-100-44.7-100-100s44.7-100 100-100c27 0 49.5 9.8 67 26.2l-27.1 26.1c-7.4-7.1-20.3-15.4-39.8-15.4-34.1 0-61.9 28.2-61.9 63.2 0 34.9 27.8 63.2 61.9 63.2 39.6 0 54.4-28.5 56.8-43.1H164v-34.4h94.4c1 5 1.6 10.1 1.6 16.6 0 57.1-38.3 97.6-96 97.6zm220-81.8h-29v29h-29.2v-29h-29V245h29v-29H355v29h29v29.2z"
    ]
};
var $ef0249c5e48bf4e3$export$d546947149d9505a = $ef0249c5e48bf4e3$export$e94511deb1df63ce;
var $ef0249c5e48bf4e3$export$2a745e3ef2838c53 = {
    prefix: "fab",
    iconName: "mandalorian",
    icon: [
        448,
        512,
        [],
        "f50f",
        "M232.27 511.89c-1-3.26-1.69-15.83-1.39-24.58.55-15.89 1-24.72 1.4-28.76.64-6.2 2.87-20.72 3.28-21.38.6-1 .4-27.87-.24-33.13-.31-2.58-.63-11.9-.69-20.73-.13-16.47-.53-20.12-2.73-24.76-1.1-2.32-1.23-3.84-1-11.43a92.38 92.38 0 0 0-.34-12.71c-2-13-3.46-27.7-3.25-33.9s.43-7.15 2.06-9.67c3.05-4.71 6.51-14 8.62-23.27 2.26-9.86 3.88-17.18 4.59-20.74a109.54 109.54 0 0 1 4.42-15.05c2.27-6.25 2.49-15.39.37-15.39-.3 0-1.38 1.22-2.41 2.71s-4.76 4.8-8.29 7.36c-8.37 6.08-11.7 9.39-12.66 12.58s-1 7.23-.16 7.76c.34.21 1.29 2.4 2.11 4.88a28.83 28.83 0 0 1 .72 15.36c-.39 1.77-1 5.47-1.46 8.23s-1 6.46-1.25 8.22a9.85 9.85 0 0 1-1.55 4.26c-1 1-1.14.91-2.05-.53a14.87 14.87 0 0 1-1.44-4.75c-.25-1.74-1.63-7.11-3.08-11.93-3.28-10.9-3.52-16.15-1-21a14.24 14.24 0 0 0 1.67-4.61c0-2.39-2.2-5.32-7.41-9.89-7-6.18-8.63-7.92-10.23-11.3-1.71-3.6-3.06-4.06-4.54-1.54-1.78 3-2.6 9.11-3 22l-.34 12.19 2 2.25c3.21 3.7 12.07 16.45 13.78 19.83 3.41 6.74 4.34 11.69 4.41 23.56s.95 22.75 2 24.71c.36.66.51 1.35.34 1.52s.41 2.09 1.29 4.27a38.14 38.14 0 0 1 2.06 9 91 91 0 0 0 1.71 10.37c2.23 9.56 2.77 14.08 2.39 20.14-.2 3.27-.53 11.07-.73 17.32-1.31 41.76-1.85 58-2 61.21-.12 2-.39 11.51-.6 21.07-.36 16.3-1.3 27.37-2.42 28.65-.64.73-8.07-4.91-12.52-9.49-3.75-3.87-4-4.79-2.83-9.95.7-3 2.26-18.29 3.33-32.62.36-4.78.81-10.5 1-12.71.83-9.37 1.66-20.35 2.61-34.78.56-8.46 1.33-16.44 1.72-17.73s.89-9.89 1.13-19.11l.43-16.77-2.26-4.3c-1.72-3.28-4.87-6.94-13.22-15.34-6-6.07-11.84-12.3-12.91-13.85l-1.95-2.81.75-10.9c1.09-15.71 1.1-48.57 0-59.06l-.89-8.7-3.28-4.52c-5.86-8.08-5.8-7.75-6.22-33.27-.1-6.07-.38-11.5-.63-12.06-.83-1.87-3.05-2.66-8.54-3.05-8.86-.62-11-1.9-23.85-14.55-6.15-6-12.34-12-13.75-13.19-2.81-2.42-2.79-2-.56-9.63l1.35-4.65-1.69-3a32.22 32.22 0 0 0-2.59-4.07c-1.33-1.51-5.5-10.89-6-13.49a4.24 4.24 0 0 1 .87-3.9c2.23-2.86 3.4-5.68 4.45-10.73 2.33-11.19 7.74-26.09 10.6-29.22 3.18-3.47 7.7-1 9.41 5 1.34 4.79 1.37 9.79.1 18.55a101.2 101.2 0 0 0-1 11.11c0 4 .19 4.69 2.25 7.39 3.33 4.37 7.73 7.41 15.2 10.52a18.67 18.67 0 0 1 4.72 2.85c11.17 10.72 18.62 16.18 22.95 16.85 5.18.8 8 4.54 10 13.39 1.31 5.65 4 11.14 5.46 11.14a9.38 9.38 0 0 0 3.33-1.39c2-1.22 2.25-1.73 2.25-4.18a132.88 132.88 0 0 0-2-17.84c-.37-1.66-.78-4.06-.93-5.35s-.61-3.85-1-5.69c-2.55-11.16-3.65-15.46-4.1-16-1.55-2-4.08-10.2-4.93-15.92-1.64-11.11-4-14.23-12.91-17.39A43.15 43.15 0 0 1 165.24 78c-1.15-1-4-3.22-6.35-5.06s-4.41-3.53-4.6-3.76a22.7 22.7 0 0 0-2.69-2c-6.24-4.22-8.84-7-11.26-12l-2.44-5-.22-13-.22-13 6.91-6.55c3.95-3.75 8.48-7.35 10.59-8.43 3.31-1.69 4.45-1.89 11.37-2 8.53-.19 10.12 0 11.66 1.56s1.36 6.4-.29 8.5a6.66 6.66 0 0 0-1.34 2.32c0 .58-2.61 4.91-5.42 9a30.39 30.39 0 0 0-2.37 6.82c20.44 13.39 21.55 3.77 14.07 29L194 66.92c3.11-8.66 6.47-17.26 8.61-26.22.29-7.63-12-4.19-15.4-8.68-2.33-5.93 3.13-14.18 6.06-19.2 1.6-2.34 6.62-4.7 8.82-4.15.88.22 4.16-.35 7.37-1.28a45.3 45.3 0 0 1 7.55-1.68 29.57 29.57 0 0 0 6-1.29c3.65-1.11 4.5-1.17 6.35-.4a29.54 29.54 0 0 0 5.82 1.36 18.18 18.18 0 0 1 6 1.91 22.67 22.67 0 0 0 5 2.17c2.51.68 3 .57 7.05-1.67l4.35-2.4L268.32 5c10.44-.4 10.81-.47 15.26-2.68L288.16 0l2.46 1.43c1.76 1 3.14 2.73 4.85 6 2.36 4.51 2.38 4.58 1.37 7.37-.88 2.44-.89 3.3-.1 6.39a35.76 35.76 0 0 0 2.1 5.91 13.55 13.55 0 0 1 1.31 4c.31 4.33 0 5.3-2.41 6.92-2.17 1.47-7 7.91-7 9.34a14.77 14.77 0 0 1-1.07 3c-5 11.51-6.76 13.56-14.26 17-9.2 4.2-12.3 5.19-16.21 5.19-3.1 0-4 .25-4.54 1.26a18.33 18.33 0 0 1-4.09 3.71 13.62 13.62 0 0 0-4.38 4.78 5.89 5.89 0 0 1-2.49 2.91 6.88 6.88 0 0 0-2.45 1.71 67.62 67.62 0 0 1-7 5.38c-3.33 2.34-6.87 5-7.87 6A7.27 7.27 0 0 1 224 100a5.76 5.76 0 0 0-2.13 1.65c-1.31 1.39-1.49 2.11-1.14 4.6a36.45 36.45 0 0 0 1.42 5.88c1.32 3.8 1.31 7.86 0 10.57s-.89 6.65 1.35 9.59c2 2.63 2.16 4.56.71 8.84a33.45 33.45 0 0 0-1.06 8.91c0 4.88.22 6.28 1.46 8.38s1.82 2.48 3.24 2.32c2-.23 2.3-1.05 4.71-12.12 2.18-10 3.71-11.92 13.76-17.08 2.94-1.51 7.46-4 10-5.44s6.79-3.69 9.37-4.91a40.09 40.09 0 0 0 15.22-11.67c7.11-8.79 10-16.22 12.85-33.3a18.37 18.37 0 0 1 2.86-7.73 20.39 20.39 0 0 0 2.89-7.31c1-5.3 2.85-9.08 5.58-11.51 4.7-4.18 6-1.09 4.59 10.87-.46 3.86-1.1 10.33-1.44 14.38l-.61 7.36 4.45 4.09 4.45 4.09.11 8.42c.06 4.63.47 9.53.92 10.89l.82 2.47-6.43 6.28c-8.54 8.33-12.88 13.93-16.76 21.61-1.77 3.49-3.74 7.11-4.38 8-2.18 3.11-6.46 13-8.76 20.26l-2.29 7.22-7 6.49c-3.83 3.57-8 7.25-9.17 8.17-3.05 2.32-4.26 5.15-4.26 10a14.62 14.62 0 0 0 1.59 7.26 42 42 0 0 1 2.09 4.83 9.28 9.28 0 0 0 1.57 2.89c1.4 1.59 1.92 16.12.83 23.22-.68 4.48-3.63 12-4.7 12-1.79 0-4.06 9.27-5.07 20.74-.18 2-.62 5.94-1 8.7s-1 10-1.35 16.05c-.77 12.22-.19 18.77 2 23.15 3.41 6.69.52 12.69-11 22.84l-4 3.49.07 5.19a40.81 40.81 0 0 0 1.14 8.87c4.61 16 4.73 16.92 4.38 37.13-.46 26.4-.26 40.27.63 44.15a61.31 61.31 0 0 1 1.08 7c.17 2 .66 5.33 1.08 7.36.47 2.26.78 11 .79 22.74v19.06l-1.81 2.63c-2.71 3.91-15.11 13.54-15.49 12.29zm29.53-45.11c-.18-.3-.33-6.87-.33-14.59 0-14.06-.89-27.54-2.26-34.45-.4-2-.81-9.7-.9-17.06-.15-11.93-1.4-24.37-2.64-26.38-.66-1.07-3-17.66-3-21.3 0-4.23 1-6 5.28-9.13s4.86-3.14 5.48-.72c.28 1.1 1.45 5.62 2.6 10 3.93 15.12 4.14 16.27 4.05 21.74-.1 5.78-.13 6.13-1.74 17.73-1 7.07-1.17 12.39-1 28.43.17 19.4-.64 35.73-2 41.27-.71 2.78-2.8 5.48-3.43 4.43zm-71-37.58a101 101 0 0 1-1.73-10.79 100.5 100.5 0 0 0-1.73-10.79 37.53 37.53 0 0 1-1-6.49c-.31-3.19-.91-7.46-1.33-9.48-1-4.79-3.35-19.35-3.42-21.07 0-.74-.34-4.05-.7-7.36-.67-6.21-.84-27.67-.22-28.29 1-1 6.63 2.76 11.33 7.43l5.28 5.25-.45 6.47c-.25 3.56-.6 10.23-.78 14.83s-.49 9.87-.67 11.71-.61 9.36-.94 16.72c-.79 17.41-1.94 31.29-2.65 32a.62.62 0 0 1-1-.14zm-87.18-266.59c21.07 12.79 17.84 14.15 28.49 17.66 13 4.29 18.87 7.13 23.15 16.87C111.6 233.28 86.25 255 78.55 268c-31 52-6 101.59 62.75 87.21-14.18 29.23-78 28.63-98.68-4.9-24.68-39.95-22.09-118.3 61-187.66zm210.79 179c56.66 6.88 82.32-37.74 46.54-89.23 0 0-26.87-29.34-64.28-68 3-15.45 9.49-32.12 30.57-53.82 89.2 63.51 92 141.61 92.46 149.36 4.3 70.64-78.7 91.18-105.29 61.71z"
    ]
};
var $ef0249c5e48bf4e3$export$ea0bc2cd8d60b806 = {
    prefix: "fab",
    iconName: "first-order-alt",
    icon: [
        496,
        512,
        [],
        "f50a",
        "M248 8C111.03 8 0 119.03 0 256s111.03 248 248 248 248-111.03 248-248S384.97 8 248 8zm0 488.21C115.34 496.21 7.79 388.66 7.79 256S115.34 15.79 248 15.79 488.21 123.34 488.21 256 380.66 496.21 248 496.21zm0-459.92C126.66 36.29 28.29 134.66 28.29 256S126.66 475.71 248 475.71 467.71 377.34 467.71 256 369.34 36.29 248 36.29zm0 431.22c-116.81 0-211.51-94.69-211.51-211.51S131.19 44.49 248 44.49 459.51 139.19 459.51 256 364.81 467.51 248 467.51zm186.23-162.98a191.613 191.613 0 0 1-20.13 48.69l-74.13-35.88 61.48 54.82a193.515 193.515 0 0 1-37.2 37.29l-54.8-61.57 35.88 74.27a190.944 190.944 0 0 1-48.63 20.23l-27.29-78.47 4.79 82.93c-8.61 1.18-17.4 1.8-26.33 1.8s-17.72-.62-26.33-1.8l4.76-82.46-27.15 78.03a191.365 191.365 0 0 1-48.65-20.2l35.93-74.34-54.87 61.64a193.85 193.85 0 0 1-37.22-37.28l61.59-54.9-74.26 35.93a191.638 191.638 0 0 1-20.14-48.69l77.84-27.11-82.23 4.76c-1.16-8.57-1.78-17.32-1.78-26.21 0-9 .63-17.84 1.82-26.51l82.38 4.77-77.94-27.16a191.726 191.726 0 0 1 20.23-48.67l74.22 35.92-61.52-54.86a193.85 193.85 0 0 1 37.28-37.22l54.76 61.53-35.83-74.17a191.49 191.49 0 0 1 48.65-20.13l26.87 77.25-4.71-81.61c8.61-1.18 17.39-1.8 26.32-1.8s17.71.62 26.32 1.8l-4.74 82.16 27.05-77.76c17.27 4.5 33.6 11.35 48.63 20.17l-35.82 74.12 54.72-61.47a193.13 193.13 0 0 1 37.24 37.23l-61.45 54.77 74.12-35.86a191.515 191.515 0 0 1 20.2 48.65l-77.81 27.1 82.24-4.75c1.19 8.66 1.82 17.5 1.82 26.49 0 8.88-.61 17.63-1.78 26.19l-82.12-4.75 77.72 27.09z"
    ]
};
var $ef0249c5e48bf4e3$export$89cf1df24c6f1e2 = {
    prefix: "fab",
    iconName: "osi",
    icon: [
        512,
        512,
        [],
        "f41a",
        "M8 266.44C10.3 130.64 105.4 34 221.8 18.34c138.8-18.6 255.6 75.8 278 201.1 21.3 118.8-44 230-151.6 274-9.3 3.8-14.4 1.7-18-7.7q-26.7-69.45-53.4-139c-3.1-8.1-1-13.2 7-16.8 24.2-11 39.3-29.4 43.3-55.8a71.47 71.47 0 0 0-64.5-82.2c-39-3.4-71.8 23.7-77.5 59.7-5.2 33 11.1 63.7 41.9 77.7 9.6 4.4 11.5 8.6 7.8 18.4q-26.85 69.9-53.7 139.9c-2.6 6.9-8.3 9.3-15.5 6.5-52.6-20.3-101.4-61-130.8-119-24.9-49.2-25.2-87.7-26.8-108.7zm20.9-1.9c.4 6.6.6 14.3 1.3 22.1 6.3 71.9 49.6 143.5 131 183.1 3.2 1.5 4.4.8 5.6-2.3q22.35-58.65 45-117.3c1.3-3.3.6-4.8-2.4-6.7-31.6-19.9-47.3-48.5-45.6-86 1-21.6 9.3-40.5 23.8-56.3 30-32.7 77-39.8 115.5-17.6a91.64 91.64 0 0 1 45.2 90.4c-3.6 30.6-19.3 53.9-45.7 69.8-2.7 1.6-3.5 2.9-2.3 6q22.8 58.8 45.2 117.7c1.2 3.1 2.4 3.8 5.6 2.3 35.5-16.6 65.2-40.3 88.1-72 34.8-48.2 49.1-101.9 42.3-161-13.7-117.5-119.4-214.8-255.5-198-106.1 13-195.3 102.5-197.1 225.8z"
    ]
};
var $ef0249c5e48bf4e3$export$6fd7b581d1a20a14 = {
    prefix: "fab",
    iconName: "google-wallet",
    icon: [
        448,
        512,
        [],
        "f1ee",
        "M156.8 126.8c37.6 60.6 64.2 113.1 84.3 162.5-8.3 33.8-18.8 66.5-31.3 98.3-13.2-52.3-26.5-101.3-56-148.5 6.5-36.4 2.3-73.6 3-112.3zM109.3 200H16.1c-6.5 0-10.5 7.5-6.5 12.7C51.8 267 81.3 330.5 101.3 400h103.5c-16.2-69.7-38.7-133.7-82.5-193.5-3-4-8-6.5-13-6.5zm47.8-88c68.5 108 130 234.5 138.2 368H409c-12-138-68.4-265-143.2-368H157.1zm251.8-68.5c-1.8-6.8-8.2-11.5-15.2-11.5h-88.3c-5.3 0-9 5-7.8 10.3 13.2 46.5 22.3 95.5 26.5 146 48.2 86.2 79.7 178.3 90.6 270.8 15.8-60.5 25.3-133.5 25.3-203 0-73.6-12.1-145.1-31.1-212.6z"
    ]
};
var $ef0249c5e48bf4e3$export$8ffeba28c1feff0d = {
    prefix: "fab",
    iconName: "d-and-d-beyond",
    icon: [
        640,
        512,
        [],
        "f6ca",
        "M313.8 241.5c13.8 0 21-10.1 24.8-17.9-1-1.1-5-4.2-7.4-6.6-2.4 4.3-8.2 10.7-13.9 10.7-10.2 0-15.4-14.7-3.2-26.6-.5-.2-4.3-1.8-8 2.4 0-3 1-5.1 2.1-6.6-3.5 1.3-9.8 5.6-11.4 7.9.2-5.8 1.6-7.5.6-9l-.2-.2s-8.5 5.6-9.3 14.7c0 0 1.1-1.6 2.1-1.9.6-.3 1.3 0 .6 1.9-.2.6-5.8 15.7 5.1 26-.6-1.6-1.9-7.6 2.4-1.9-.3.1 5.8 7.1 15.7 7.1zm52.4-21.1c0-4-4.9-4.4-5.6-4.5 2 3.9.9 7.5.2 9 2.5-.4 5.4-1.6 5.4-4.5zm10.3 5.2c0-6.4-6.2-11.4-13.5-10.7 8 1.3 5.6 13.8-5 11.4 3.7-2.6 3.2-9.9-1.3-12.5 1.4 4.2-3 8.2-7.4 4.6-2.4-1.9-8-6.6-10.6-8.6-2.4-2.1-5.5-1-6.6-1.8-1.3-1.1-.5-3.8-2.2-5-1.6-.8-3-.3-4.8-1-1.6-.6-2.7-1.9-2.6-3.5-2.5 4.4 3.4 6.3 4.5 8.5 1 1.9-.8 4.8 4 8.5 14.8 11.6 9.1 8 10.4 18.1.6 4.3 4.2 6.7 6.4 7.4-2.1-1.9-2.9-6.4 0-9.3 0 13.9 19.2 13.3 23.1 6.4-2.4 1.1-7-.2-9-1.9 7.7 1 14.2-4.1 14.6-10.6zm-39.4-18.4c2 .8 1.6.7 6.4 4.5 10.2-24.5 21.7-15.7 22-15.5 2.2-1.9 9.8-3.8 13.8-2.7-2.4-2.7-7.5-6.2-13.3-6.2-4.7 0-7.4 2.2-8 1.3-.8-1.4 3.2-3.4 3.2-3.4-5.4.2-9.6 6.7-11.2 5.9-1.1-.5 1.4-3.7 1.4-3.7-5.1 2.9-9.3 9.1-10.2 13 4.6-5.8 13.8-9.8 19.7-9-10.5.5-19.5 9.7-23.8 15.8zm242.5 51.9c-20.7 0-40 1.3-50.3 2.1l7.4 8.2v77.2l-7.4 8.2c10.4.8 30.9 2.1 51.6 2.1 42.1 0 59.1-20.7 59.1-48.9 0-29.3-23.2-48.9-60.4-48.9zm-15.1 75.6v-53.3c30.1-3.3 46.8 3.8 46.8 26.3 0 25.6-21.4 30.2-46.8 27zM301.6 181c-1-3.4-.2-6.9 1.1-9.4 1 3 2.6 6.4 7.5 9-.5-2.4-.2-5.6.5-8-1.4-5.4 2.1-9.9 6.4-9.9 6.9 0 8.5 8.8 4.7 14.4 2.1 3.2 5.5 5.6 7.7 7.8 3.2-3.7 5.5-9.5 5.5-13.8 0-8.2-5.5-15.9-16.7-16.5-20-.9-20.2 16.6-20 18.9.5 5.2 3.4 7.8 3.3 7.5zm-.4 6c-.5 1.8-7 3.7-10.2 6.9 4.8-1 7-.2 7.8 1.8.5 1.4-.2 3.4-.5 5.6 1.6-1.8 7-5.5 11-6.2-1-.3-3.4-.8-4.3-.8 2.9-3.4 9.3-4.5 12.8-3.7-2.2-.2-6.7 1.1-8.5 2.6 1.6.3 3 .6 4.3 1.1-2.1.8-4.8 3.4-5.8 6.1 7-5 13.1 5.2 7 8.2.8.2 2.7 0 3.5-.5-.3 1.1-1.9 3-3 3.4 2.9 0 7-1.9 8.2-4.6 0 0-1.8.6-2.6-.2s.3-4.3.3-4.3c-2.3 2.9-3.4-1.3-1.3-4.2-1-.3-3.5-.6-4.6-.5 3.2-1.1 10.4-1.8 11.2-.3.6 1.1-1 3.4-1 3.4 4-.5 8.3 1.1 6.7 5.1 2.9-1.4 5.5-5.9 4.8-10.4-.3 1-1.6 2.4-2.9 2.7.2-1.4-1-2.2-1.9-2.6 1.7-9.6-14.6-14.2-14.1-23.9-1 1.3-1.8 5-.8 7.1 2.7 3.2 8.7 6.7 10.1 12.2-2.6-6.4-15.1-11.4-14.6-20.2-1.6 1.6-2.6 7.8-1.3 11 2.4 1.4 4.5 3.8 4.8 6.1-2.2-5.1-11.4-6.1-13.9-12.2-.6 2.2-.3 5 1 6.7 0 0-2.2-.8-7-.6 1.7.6 5.1 3.5 4.8 5.2zm25.9 7.4c-2.7 0-3.5-2.1-4.2-4.3 3.3 1.3 4.2 4.3 4.2 4.3zm38.9 3.7l-1-.6c-1.1-1-2.9-1.4-4.7-1.4-2.9 0-5.8 1.3-7.5 3.4-.8.8-1.4 1.8-2.1 2.6v15.7c3.5 2.6 7.1-2.9 3-7.2 1.5.3 4.6 2.7 5.1 3.2 0 0 2.6-.5 5-.5 2.1 0 3.9.3 5.6 1.1V196c-1.1.5-2.2 1-2.7 1.4zM79.9 305.9c17.2-4.6 16.2-18 16.2-19.9 0-20.6-24.1-25-37-25H3l8.3 8.6v29.5H0l11.4 14.6V346L3 354.6c61.7 0 73.8 1.5 86.4-5.9 6.7-4 9.9-9.8 9.9-17.6 0-5.1 2.6-18.8-19.4-25.2zm-41.3-27.5c20 0 29.6-.8 29.6 9.1v3c0 12.1-19 8.8-29.6 8.8zm0 59.2V315c12.2 0 32.7-2.3 32.7 8.8v4.5h.2c0 11.2-12.5 9.3-32.9 9.3zm101.2-19.3l23.1.2v-.2l14.1-21.2h-37.2v-14.9h52.4l-14.1-21v-.2l-73.5.2 7.4 8.2v77.1l-7.4 8.2h81.2l14.1-21.2-60.1.2zm214.7-60.1c-73.9 0-77.5 99.3-.3 99.3 77.9 0 74.1-99.3.3-99.3zm-.3 77.5c-37.4 0-36.9-55.3.2-55.3 36.8.1 38.8 55.3-.2 55.3zm-91.3-8.3l44.1-66.2h-41.7l6.1 7.2-20.5 37.2h-.3l-21-37.2 6.4-7.2h-44.9l44.1 65.8.2 19.4-7.7 8.2h42.6l-7.2-8.2zm-28.4-151.3c1.6 1.3 2.9 2.4 2.9 6.6v38.8c0 4.2-.8 5.3-2.7 6.4-.1.1-7.5 4.5-7.9 4.6h35.1c10 0 17.4-1.5 26-8.6-.6-5 .2-9.5.8-12 0-.2-1.8 1.4-2.7 3.5 0-5.7 1.6-15.4 9.6-20.5-.1 0-3.7-.8-9 1.1 2-3.1 10-7.9 10.4-7.9-8.2-26-38-22.9-32.2-22.9-30.9 0-32.6.3-39.9-4 .1.8.5 8.2 9.6 14.9zm21.5 5.5c4.6 0 23.1-3.3 23.1 17.3 0 20.7-18.4 17.3-23.1 17.3zm228.9 79.6l7 8.3V312h-.3c-5.4-14.4-42.3-41.5-45.2-50.9h-31.6l7.4 8.5v76.9l-7.2 8.3h39l-7.4-8.2v-47.4h.3c3.7 10.6 44.5 42.9 48.5 55.6h21.3v-85.2l7.4-8.3zm-106.7-96.1c-32.2 0-32.8.2-39.9-4 .1.7.5 8.3 9.6 14.9 3.1 2 2.9 4.3 2.9 9.5 1.8-1.1 3.8-2.2 6.1-3-1.1 1.1-2.7 2.7-3.5 4.5 1-1.1 7.5-5.1 14.6-3.5-1.6.3-4 1.1-6.1 2.9.1 0 2.1-1.1 7.5-.3v-4.3c4.7 0 23.1-3.4 23.1 17.3 0 20.5-18.5 17.3-19.7 17.3 5.7 4.4 5.8 12 2.2 16.3h.3c33.4 0 36.7-27.3 36.7-34 0-3.8-1.1-32-33.8-33.6z"
    ]
};
var $ef0249c5e48bf4e3$export$10deb29d7dbf2418 = {
    prefix: "fab",
    iconName: "periscope",
    icon: [
        448,
        512,
        [],
        "f3da",
        "M370 63.6C331.4 22.6 280.5 0 226.6 0 111.9 0 18.5 96.2 18.5 214.4c0 75.1 57.8 159.8 82.7 192.7C137.8 455.5 192.6 512 226.6 512c41.6 0 112.9-94.2 120.9-105 24.6-33.1 82-118.3 82-192.6 0-56.5-21.1-110.1-59.5-150.8zM226.6 493.9c-42.5 0-190-167.3-190-279.4 0-107.4 83.9-196.3 190-196.3 100.8 0 184.7 89 184.7 196.3.1 112.1-147.4 279.4-184.7 279.4zM338 206.8c0 59.1-51.1 109.7-110.8 109.7-100.6 0-150.7-108.2-92.9-181.8v.4c0 24.5 20.1 44.4 44.8 44.4 24.7 0 44.8-19.9 44.8-44.4 0-18.2-11.1-33.8-26.9-40.7 76.6-19.2 141 39.3 141 112.4z"
    ]
};
var $ef0249c5e48bf4e3$export$beb89eeaf726c65a = {
    prefix: "fab",
    iconName: "fulcrum",
    icon: [
        320,
        512,
        [],
        "f50b",
        "M95.75 164.14l-35.38 43.55L25 164.14l35.38-43.55zM144.23 0l-20.54 198.18L72.72 256l51 57.82L144.23 512V300.89L103.15 256l41.08-44.89zm79.67 164.14l35.38 43.55 35.38-43.55-35.38-43.55zm-48.48 47L216.5 256l-41.08 44.89V512L196 313.82 247 256l-51-57.82L175.42 0z"
    ]
};
var $ef0249c5e48bf4e3$export$fdf6053d73314ca6 = {
    prefix: "fab",
    iconName: "cloudscale",
    icon: [
        448,
        512,
        [],
        "f383",
        "M318.1 154l-9.4 7.6c-22.5-19.3-51.5-33.6-83.3-33.6C153.8 128 96 188.8 96 260.3c0 6.6.4 13.1 1.4 19.4-2-56 41.8-97.4 92.6-97.4 24.2 0 46.2 9.4 62.6 24.7l-25.2 20.4c-8.3-.9-16.8 1.8-23.1 8.1-11.1 11-11.1 28.9 0 40 11.1 11 28.9 11 40 0 6.3-6.3 9-14.9 8.1-23.1l75.2-88.8c6.3-6.5-3.3-15.9-9.5-9.6zm-83.8 111.5c-5.6 5.5-14.6 5.5-20.2 0-5.6-5.6-5.6-14.6 0-20.2s14.6-5.6 20.2 0 5.6 14.7 0 20.2zM224 32C100.5 32 0 132.5 0 256s100.5 224 224 224 224-100.5 224-224S347.5 32 224 32zm0 384c-88.2 0-160-71.8-160-160S135.8 96 224 96s160 71.8 160 160-71.8 160-160 160z"
    ]
};
var $ef0249c5e48bf4e3$export$e4fb88a0423b6fee = {
    prefix: "fab",
    iconName: "forumbee",
    icon: [
        448,
        512,
        [],
        "f211",
        "M5.8 309.7C2 292.7 0 275.5 0 258.3 0 135 99.8 35 223.1 35c16.6 0 33.3 2 49.3 5.5C149 87.5 51.9 186 5.8 309.7zm392.9-189.2C385 103 369 87.8 350.9 75.2c-149.6 44.3-266.3 162.1-309.7 312 12.5 18.1 28 35.6 45.2 49 43.1-151.3 161.2-271.7 312.3-315.7zm15.8 252.7c15.2-25.1 25.4-53.7 29.5-82.8-79.4 42.9-145 110.6-187.6 190.3 30-4.4 58.9-15.3 84.6-31.3 35 13.1 70.9 24.3 107 33.6-9.3-36.5-20.4-74.5-33.5-109.8zm29.7-145.5c-2.6-19.5-7.9-38.7-15.8-56.8C290.5 216.7 182 327.5 137.1 466c18.1 7.6 37 12.5 56.6 15.2C240 367.1 330.5 274.4 444.2 227.7z"
    ]
};
var $ef0249c5e48bf4e3$export$e6a3c752190fa3cb = {
    prefix: "fab",
    iconName: "mizuni",
    icon: [
        496,
        512,
        [],
        "f3cc",
        "M248 8C111 8 0 119.1 0 256c0 137 111 248 248 248s248-111 248-248C496 119.1 385 8 248 8zm-80 351.9c-31.4 10.6-58.8 27.3-80 48.2V136c0-22.1 17.9-40 40-40s40 17.9 40 40v223.9zm120-9.9c-12.9-2-26.2-3.1-39.8-3.1-13.8 0-27.2 1.1-40.2 3.1V136c0-22.1 17.9-40 40-40s40 17.9 40 40v214zm120 57.7c-21.2-20.8-48.6-37.4-80-48V136c0-22.1 17.9-40 40-40s40 17.9 40 40v271.7z"
    ]
};
var $ef0249c5e48bf4e3$export$3f1891b85805675f = {
    prefix: "fab",
    iconName: "schlix",
    icon: [
        448,
        512,
        [],
        "f3ea",
        "M350.5 157.7l-54.2-46.1 73.4-39 78.3 44.2-97.5 40.9zM192 122.1l45.7-28.2 34.7 34.6-55.4 29-25-35.4zm-65.1 6.6l31.9-22.1L176 135l-36.7 22.5-12.4-28.8zm-23.3 88.2l-8.8-34.8 29.6-18.3 13.1 35.3-33.9 17.8zm-21.2-83.7l23.9-18.1 8.9 24-26.7 18.3-6.1-24.2zM59 206.5l-3.6-28.4 22.3-15.5 6.1 28.7L59 206.5zm-30.6 16.6l20.8-12.8 3.3 33.4-22.9 12-1.2-32.6zM1.4 268l19.2-10.2.4 38.2-21 8.8L1.4 268zm59.1 59.3l-28.3 8.3-1.6-46.8 25.1-10.7 4.8 49.2zM99 263.2l-31.1 13-5.2-40.8L90.1 221l8.9 42.2zM123.2 377l-41.6 5.9-8.1-63.5 35.2-10.8 14.5 68.4zm28.5-139.9l21.2 57.1-46.2 13.6-13.7-54.1 38.7-16.6zm85.7 230.5l-70.9-3.3-24.3-95.8 55.2-8.6 40 107.7zm-84.9-279.7l42.2-22.4 28 45.9-50.8 21.3-19.4-44.8zm41 94.9l61.3-18.7 52.8 86.6-79.8 11.3-34.3-79.2zm51.4-85.6l67.3-28.8 65.5 65.4-88.6 26.2-44.2-62.8z"
    ]
};
var $ef0249c5e48bf4e3$export$ca49464b0602c8ef = {
    prefix: "fab",
    iconName: "square-xing",
    icon: [
        448,
        512,
        [
            "xing-square"
        ],
        "f169",
        "M400 32H48C21.5 32 0 53.5 0 80v352c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48V80c0-26.5-21.5-48-48-48zM140.4 320.2H93.8c-5.5 0-8.7-5.3-6-10.3l49.3-86.7c.1 0 .1-.1 0-.2l-31.4-54c-3-5.6.2-10.1 6-10.1h46.6c5.2 0 9.5 2.9 12.9 8.7l31.9 55.3c-1.3 2.3-18 31.7-50.1 88.2-3.5 6.2-7.7 9.1-12.6 9.1zm219.7-214.1L257.3 286.8v.2l65.5 119c2.8 5.1.1 10.1-6 10.1h-46.6c-5.5 0-9.7-2.9-12.9-8.7l-66-120.3c2.3-4.1 36.8-64.9 103.4-182.3 3.3-5.8 7.4-8.7 12.5-8.7h46.9c5.7-.1 8.8 4.7 6 10z"
    ]
};
var $ef0249c5e48bf4e3$export$3f616d72d818a1a6 = $ef0249c5e48bf4e3$export$ca49464b0602c8ef;
var $ef0249c5e48bf4e3$export$cf8fa465ef81d073 = {
    prefix: "fab",
    iconName: "bandcamp",
    icon: [
        512,
        512,
        [],
        "f2d5",
        "M256,8C119,8,8,119,8,256S119,504,256,504,504,393,504,256,393,8,256,8Zm48.2,326.1h-181L207.9,178h181Z"
    ]
};
var $ef0249c5e48bf4e3$export$f70eba4216b4419a = {
    prefix: "fab",
    iconName: "wpforms",
    icon: [
        448,
        512,
        [],
        "f298",
        "M448 75.2v361.7c0 24.3-19 43.2-43.2 43.2H43.2C19.3 480 0 461.4 0 436.8V75.2C0 51.1 18.8 32 43.2 32h361.7c24 0 43.1 18.8 43.1 43.2zm-37.3 361.6V75.2c0-3-2.6-5.8-5.8-5.8h-9.3L285.3 144 224 94.1 162.8 144 52.5 69.3h-9.3c-3.2 0-5.8 2.8-5.8 5.8v361.7c0 3 2.6 5.8 5.8 5.8h361.7c3.2.1 5.8-2.7 5.8-5.8zM150.2 186v37H76.7v-37h73.5zm0 74.4v37.3H76.7v-37.3h73.5zm11.1-147.3l54-43.7H96.8l64.5 43.7zm210 72.9v37h-196v-37h196zm0 74.4v37.3h-196v-37.3h196zm-84.6-147.3l64.5-43.7H232.8l53.9 43.7zM371.3 335v37.3h-99.4V335h99.4z"
    ]
};
var $ef0249c5e48bf4e3$export$623057fac7dabd52 = {
    prefix: "fab",
    iconName: "cloudversify",
    icon: [
        616,
        512,
        [],
        "f385",
        "M148.6 304c8.2 68.5 67.4 115.5 146 111.3 51.2 43.3 136.8 45.8 186.4-5.6 69.2 1.1 118.5-44.6 131.5-99.5 14.8-62.5-18.2-132.5-92.1-155.1-33-88.1-131.4-101.5-186.5-85-57.3 17.3-84.3 53.2-99.3 109.7-7.8 2.7-26.5 8.9-45 24.1 11.7 0 15.2 8.9 15.2 19.5v20.4c0 10.7-8.7 19.5-19.5 19.5h-20.2c-10.7 0-19.5-6-19.5-16.7V240H98.8C95 240 88 244.3 88 251.9v40.4c0 6.4 5.3 11.8 11.7 11.8h48.9zm227.4 8c-10.7 46.3 21.7 72.4 55.3 86.8C324.1 432.6 259.7 348 296 288c-33.2 21.6-33.7 71.2-29.2 92.9-17.9-12.4-53.8-32.4-57.4-79.8-3-39.9 21.5-75.7 57-93.9C297 191.4 369.9 198.7 400 248c-14.1-48-53.8-70.1-101.8-74.8 30.9-30.7 64.4-50.3 114.2-43.7 69.8 9.3 133.2 82.8 67.7 150.5 35-16.3 48.7-54.4 47.5-76.9l10.5 19.6c11.8 22 15.2 47.6 9.4 72-9.2 39-40.6 68.8-79.7 76.5-32.1 6.3-83.1-5.1-91.8-59.2zM128 208H88.2c-8.9 0-16.2-7.3-16.2-16.2v-39.6c0-8.9 7.3-16.2 16.2-16.2H128c8.9 0 16.2 7.3 16.2 16.2v39.6c0 8.9-7.3 16.2-16.2 16.2zM10.1 168C4.5 168 0 163.5 0 157.9v-27.8c0-5.6 4.5-10.1 10.1-10.1h27.7c5.5 0 10.1 4.5 10.1 10.1v27.8c0 5.6-4.5 10.1-10.1 10.1H10.1zM168 142.7v-21.4c0-5.1 4.2-9.3 9.3-9.3h21.4c5.1 0 9.3 4.2 9.3 9.3v21.4c0 5.1-4.2 9.3-9.3 9.3h-21.4c-5.1 0-9.3-4.2-9.3-9.3zM56 235.5v25c0 6.3-5.1 11.5-11.4 11.5H19.4C13.1 272 8 266.8 8 260.5v-25c0-6.3 5.1-11.5 11.4-11.5h25.1c6.4 0 11.5 5.2 11.5 11.5z"
    ]
};
var $ef0249c5e48bf4e3$export$216644b0c66e66a5 = {
    prefix: "fab",
    iconName: "usps",
    icon: [
        576,
        512,
        [],
        "f7e1",
        "M460.3 241.7c25.8-41.3 15.2-48.8-11.7-48.8h-27c-.1 0-1.5-1.4-10.9 8-11.2 5.6-37.9 6.3-37.9 8.7 0 4.5 70.3-3.1 88.1 0 9.5 1.5-1.5 20.4-4.4 32-.5 4.5 2.4 2.3 3.8.1zm-112.1 22.6c64-21.3 97.3-23.9 102-26.2 4.4-2.9-4.4-6.6-26.2-5.8-51.7 2.2-137.6 37.1-172.6 53.9l-30.7-93.3h196.6c-2.7-28.2-152.9-22.6-337.9-22.6L27 415.8c196.4-97.3 258.9-130.3 321.2-151.5zM94.7 96c253.3 53.7 330 65.7 332.1 85.2 36.4 0 45.9 0 52.4 6.6 21.1 19.7-14.6 67.7-14.6 67.7-4.4 2.9-406.4 160.2-406.4 160.2h423.1L549 96z"
    ]
};
var $ef0249c5e48bf4e3$export$e7e4dbda4df6110f = {
    prefix: "fab",
    iconName: "megaport",
    icon: [
        496,
        512,
        [],
        "f5a3",
        "M214.5 209.6v66.2l33.5 33.5 33.3-33.3v-66.4l-33.4-33.4zM248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zm145.1 414.4L367 441.6l-26-19.2v-65.5l-33.4-33.4-33.4 33.4v65.5L248 441.6l-26.1-19.2v-65.5l-33.4-33.4-33.5 33.4v65.5l-26.1 19.2-26.1-19.2v-87l59.5-59.5V188l59.5-59.5V52.9l26.1-19.2L274 52.9v75.6l59.5 59.5v87.6l59.7 59.7v87.1z"
    ]
};
var $ef0249c5e48bf4e3$export$9b8374b50472190d = {
    prefix: "fab",
    iconName: "magento",
    icon: [
        448,
        512,
        [],
        "f3c4",
        "M445.7 127.9V384l-63.4 36.5V164.7L223.8 73.1 65.2 164.7l.4 255.9L2.3 384V128.1L224.2 0l221.5 127.9zM255.6 420.5L224 438.9l-31.8-18.2v-256l-63.3 36.6.1 255.9 94.9 54.9 95.1-54.9v-256l-63.4-36.6v255.9z"
    ]
};
var $ef0249c5e48bf4e3$export$8218f3fbb2f89724 = {
    prefix: "fab",
    iconName: "spotify",
    icon: [
        496,
        512,
        [],
        "f1bc",
        "M248 8C111.1 8 0 119.1 0 256s111.1 248 248 248 248-111.1 248-248S384.9 8 248 8zm100.7 364.9c-4.2 0-6.8-1.3-10.7-3.6-62.4-37.6-135-39.2-206.7-24.5-3.9 1-9 2.6-11.9 2.6-9.7 0-15.8-7.7-15.8-15.8 0-10.3 6.1-15.2 13.6-16.8 81.9-18.1 165.6-16.5 237 26.2 6.1 3.9 9.7 7.4 9.7 16.5s-7.1 15.4-15.2 15.4zm26.9-65.6c-5.2 0-8.7-2.3-12.3-4.2-62.5-37-155.7-51.9-238.6-29.4-4.8 1.3-7.4 2.6-11.9 2.6-10.7 0-19.4-8.7-19.4-19.4s5.2-17.8 15.5-20.7c27.8-7.8 56.2-13.6 97.8-13.6 64.9 0 127.6 16.1 177 45.5 8.1 4.8 11.3 11 11.3 19.7-.1 10.8-8.5 19.5-19.4 19.5zm31-76.2c-5.2 0-8.4-1.3-12.9-3.9-71.2-42.5-198.5-52.7-280.9-29.7-3.6 1-8.1 2.6-12.9 2.6-13.2 0-23.3-10.3-23.3-23.6 0-13.6 8.4-21.3 17.4-23.9 35.2-10.3 74.6-15.2 117.5-15.2 73 0 149.5 15.2 205.4 47.8 7.8 4.5 12.9 10.7 12.9 22.6 0 13.6-11 23.3-23.2 23.3z"
    ]
};
var $ef0249c5e48bf4e3$export$5247a00f0c0b93a3 = {
    prefix: "fab",
    iconName: "optin-monster",
    icon: [
        576,
        512,
        [],
        "f23c",
        "M572.6 421.4c5.6-9.5 4.7-15.2-5.4-11.6-3-4.9-7-9.5-11.1-13.8 2.9-9.7-.7-14.2-10.8-9.2-4.6-3.2-10.3-6.5-15.9-9.2 0-15.1-11.6-11.6-17.6-5.7-10.4-1.5-18.7-.3-26.8 5.7.3-6.5.3-13 .3-19.7 12.6 0 40.2-11 45.9-36.2 1.4-6.8 1.6-13.8-.3-21.9-3-13.5-14.3-21.3-25.1-25.7-.8-5.9-7.6-14.3-14.9-15.9s-12.4 4.9-14.1 10.3c-8.5 0-19.2 2.8-21.1 8.4-5.4-.5-11.1-1.4-16.8-1.9 2.7-1.9 5.4-3.5 8.4-4.6 5.4-9.2 14.6-11.4 25.7-11.6V256c19.5-.5 43-5.9 53.8-18.1 12.7-13.8 14.6-37.3 12.4-55.1-2.4-17.3-9.7-37.6-24.6-48.1-8.4-5.9-21.6-.8-22.7 9.5-2.2 19.6 1.2 30-38.6 25.1-10.3-23.8-24.6-44.6-42.7-60C341 49.6 242.9 55.5 166.4 71.7c19.7 4.6 41.1 8.6 59.7 16.5-26.2 2.4-52.7 11.3-76.2 23.2-32.8 17-44 29.9-56.7 42.4 14.9-2.2 28.9-5.1 43.8-3.8-9.7 5.4-18.4 12.2-26.5 20-25.8.9-23.8-5.3-26.2-25.9-1.1-10.5-14.3-15.4-22.7-9.7-28.1 19.9-33.5 79.9-12.2 103.5 10.8 12.2 35.1 17.3 54.9 17.8-.3 1.1-.3 1.9-.3 2.7 10.8.5 19.5 2.7 24.6 11.6 3 1.1 5.7 2.7 8.1 4.6-5.4.5-11.1 1.4-16.5 1.9-3.3-6.6-13.7-8.1-21.1-8.1-1.6-5.7-6.5-12.2-14.1-10.3-6.8 1.9-14.1 10-14.9 15.9-22.5 9.5-30.1 26.8-25.1 47.6 5.3 24.8 33 36.2 45.9 36.2v19.7c-6.6-5-14.3-7.5-26.8-5.7-5.5-5.5-17.3-10.1-17.3 5.7-5.9 2.7-11.4 5.9-15.9 9.2-9.8-4.9-13.6-1.7-11.1 9.2-4.1 4.3-7.8 8.6-11.1 13.8-10.2-3.7-11 2.2-5.4 11.6-1.1 3.5-1.6 7-1.9 10.8-.5 31.6 44.6 64 73.5 65.1 17.3.5 34.6-8.4 43-23.5 113.2 4.9 226.7 4.1 340.2 0 8.1 15.1 25.4 24.3 42.7 23.5 29.2-1.1 74.3-33.5 73.5-65.1.2-3.7-.7-7.2-1.7-10.7zm-73.8-254c1.1-3 2.4-8.4 2.4-14.6 0-5.9 6.8-8.1 14.1-.8 11.1 11.6 14.9 40.5 13.8 51.1-4.1-13.6-13-29-30.3-35.7zm-4.6 6.7c19.5 6.2 28.6 27.6 29.7 48.9-1.1 2.7-3 5.4-4.9 7.6-5.7 5.9-15.4 10-26.2 12.2 4.3-21.3.3-47.3-12.7-63 4.9-.8 10.9-2.4 14.1-5.7zm-24.1 6.8c13.8 11.9 20 39.2 14.1 63.5-4.1.5-8.1.8-11.6.8-1.9-21.9-6.8-44-14.3-64.6 3.7.3 8.1.3 11.8.3zM47.5 203c-1.1-10.5 2.4-39.5 13.8-51.1 7-7.3 14.1-5.1 14.1.8 0 6.2 1.4 11.6 2.4 14.6-17.3 6.8-26.2 22.2-30.3 35.7zm9.7 27.6c-1.9-2.2-3.5-4.9-4.9-7.6 1.4-21.3 10.3-42.7 29.7-48.9 3.2 3.2 9.2 4.9 14.1 5.7-13 15.7-17 41.6-12.7 63-10.8-2.2-20.5-6-26.2-12.2zm47.9 14.6c-4.1 0-8.1-.3-12.7-.8-4.6-18.6-1.9-38.9 5.4-53v.3l12.2-5.1c4.9-1.9 9.7-3.8 14.9-4.9-10.7 19.7-17.4 41.3-19.8 63.5zm184-162.7c41.9 0 76.2 34 76.2 75.9 0 42.2-34.3 76.2-76.2 76.2s-76.2-34-76.2-76.2c0-41.8 34.3-75.9 76.2-75.9zm115.6 174.3c-.3 17.8-7 48.9-23 57-13.2 6.6-6.5-7.5-16.5-58.1 13.3.3 26.6.3 39.5 1.1zm-54-1.6c.8 4.9 3.8 40.3-1.6 41.9-11.6 3.5-40 4.3-51.1-1.1-4.1-3-4.6-35.9-4.3-41.1v.3c18.9-.3 38.1-.3 57 0zM278.3 309c-13 3.5-41.6 4.1-54.6-1.6-6.5-2.7-3.8-42.4-1.9-51.6 19.2-.5 38.4-.5 57.8-.8v.3c1.1 8.3 3.3 51.2-1.3 53.7zm-106.5-51.1c12.2-.8 24.6-1.4 36.8-1.6-2.4 15.4-3 43.5-4.9 52.2-1.1 6.8-4.3 6.8-9.7 4.3-21.9-9.8-27.6-35.2-22.2-54.9zm-35.4 31.3c7.8-1.1 15.7-1.9 23.5-2.7 1.6 6.2 3.8 11.9 7 17.6 10 17 44 35.7 45.1 7 6.2 14.9 40.8 12.2 54.9 10.8 15.7-1.4 23.8-1.4 26.8-14.3 12.4 4.3 30.8 4.1 44 3 11.3-.8 20.8-.5 24.6-8.9 1.1 5.1 1.9 11.6 4.6 16.8 10.8 21.3 37.3 1.4 46.8-31.6 8.6.8 17.6 1.9 26.5 2.7-.4 1.3-3.8 7.3 7.3 11.6-47.6 47-95.7 87.8-163.2 107-63.2-20.8-112.1-59.5-155.9-106.5 9.6-3.4 10.4-8.8 8-12.5zm-21.6 172.5c-3.8 17.8-21.9 29.7-39.7 28.9-19.2-.8-46.5-17-59.2-36.5-2.7-31.1 43.8-61.3 66.2-54.6 14.9 4.3 27.8 30.8 33.5 54 0 3-.3 5.7-.8 8.2zm-8.7-66c-.5-13.5-.5-27-.3-40.5h.3c2.7-1.6 5.7-3.8 7.8-6.5 6.5-1.6 13-5.1 15.1-9.2 3.3-7.1-7-7.5-5.4-12.4 2.7-1.1 5.7-2.2 7.8-3.5 29.2 29.2 58.6 56.5 97.3 77-36.8 11.3-72.4 27.6-105.9 47-1.2-18.6-7.7-35.9-16.7-51.9zm337.6 64.6c-103 3.5-206.2 4.1-309.4 0 0 .3 0 .3-.3.3v-.3h.3c35.1-21.6 72.2-39.2 112.4-50.8 11.6 5.1 23 9.5 34.9 13.2 2.2.8 2.2.8 4.3 0 14.3-4.1 28.4-9.2 42.2-15.4 41.5 11.7 78.8 31.7 115.6 53zm10.5-12.4c-35.9-19.5-73-35.9-111.9-47.6 38.1-20 71.9-47.3 103.5-76.7 2.2 1.4 4.6 2.4 7.6 3.2 0 .8.3 1.9.5 2.4-4.6 2.7-7.8 6.2-5.9 10.3 2.2 3.8 8.6 7.6 15.1 8.9 2.4 2.7 5.1 5.1 8.1 6.8 0 13.8-.3 27.6-.8 41.3l.3-.3c-9.3 15.9-15.5 37-16.5 51.7zm105.9 6.2c-12.7 19.5-40 35.7-59.2 36.5-19.3.9-40.5-13.2-40.5-37 5.7-23.2 18.9-49.7 33.5-54 22.7-6.9 69.2 23.4 66.2 54.5zM372.9 75.2c-3.8-72.1-100.8-79.7-126-23.5 44.6-24.3 90.3-15.7 126 23.5zM74.8 407.1c-15.7 1.6-49.5 25.4-49.5 43.2 0 11.6 15.7 19.5 32.2 14.9 12.2-3.2 31.1-17.6 35.9-27.3 6-11.6-3.7-32.7-18.6-30.8zm215.9-176.2c28.6 0 51.9-21.6 51.9-48.4 0-36.1-40.5-58.1-72.2-44.3 9.5 3 16.5 11.6 16.5 21.6 0 23.3-33.3 32-46.5 11.3-7.3 34.1 19.4 59.8 50.3 59.8zM68 474.1c.5 6.5 12.2 12.7 21.6 9.5 6.8-2.7 14.6-10.5 17.3-16.2 3-7-1.1-20-9.7-18.4-8.9 1.6-29.7 16.7-29.2 25.1zm433.2-67c-14.9-1.9-24.6 19.2-18.9 30.8 4.9 9.7 24.1 24.1 36.2 27.3 16.5 4.6 32.2-3.2 32.2-14.9 0-17.8-33.8-41.6-49.5-43.2zM478.8 449c-8.4-1.6-12.4 11.3-9.5 18.4 2.4 5.7 10.3 13.5 17.3 16.2 9.2 3.2 21.1-3 21.3-9.5.9-8.4-20.2-23.5-29.1-25.1z"
    ]
};
var $ef0249c5e48bf4e3$export$cfbbba1261e4e2d2 = {
    prefix: "fab",
    iconName: "fly",
    icon: [
        384,
        512,
        [],
        "f417",
        "M197.8 427.8c12.9 11.7 33.7 33.3 33.2 50.7 0 .8-.1 1.6-.1 2.5-1.8 19.8-18.8 31.1-39.1 31-25-.1-39.9-16.8-38.7-35.8 1-16.2 20.5-36.7 32.4-47.6 2.3-2.1 2.7-2.7 5.6-3.6 3.4 0 3.9.3 6.7 2.8zM331.9 67.3c-16.3-25.7-38.6-40.6-63.3-52.1C243.1 4.5 214-.2 192 0c-44.1 0-71.2 13.2-81.1 17.3C57.3 45.2 26.5 87.2 28 158.6c7.1 82.2 97 176 155.8 233.8 1.7 1.6 4.5 4.5 6.2 5.1l3.3.1c2.1-.7 1.8-.5 3.5-2.1 52.3-49.2 140.7-145.8 155.9-215.7 7-39.2 3.1-72.5-20.8-112.5zM186.8 351.9c-28-51.1-65.2-130.7-69.3-189-3.4-47.5 11.4-131.2 69.3-136.7v325.7zM328.7 180c-16.4 56.8-77.3 128-118.9 170.3C237.6 298.4 275 217 277 158.4c1.6-45.9-9.8-105.8-48-131.4 88.8 18.3 115.5 98.1 99.7 153z"
    ]
};
var $ef0249c5e48bf4e3$export$f731696770842fd2 = {
    prefix: "fab",
    iconName: "aviato",
    icon: [
        640,
        512,
        [],
        "f421",
        "M107.2 283.5l-19-41.8H36.1l-19 41.8H0l62.2-131.4 62.2 131.4h-17.2zm-45-98.1l-19.6 42.5h39.2l-19.6-42.5zm112.7 102.4l-62.2-131.4h17.1l45.1 96 45.1-96h17l-62.1 131.4zm80.6-4.3V156.4H271v127.1h-15.5zm209.1-115.6v115.6h-17.3V167.9h-41.2v-11.5h99.6v11.5h-41.1zM640 218.8c0 9.2-1.7 17.8-5.1 25.8-3.4 8-8.2 15.1-14.2 21.1-6 6-13.1 10.8-21.1 14.2-8 3.4-16.6 5.1-25.8 5.1s-17.8-1.7-25.8-5.1c-8-3.4-15.1-8.2-21.1-14.2-6-6-10.8-13-14.2-21.1-3.4-8-5.1-16.6-5.1-25.8s1.7-17.8 5.1-25.8c3.4-8 8.2-15.1 14.2-21.1 6-6 13-8.4 21.1-11.9 8-3.4 16.6-5.1 25.8-5.1s17.8 1.7 25.8 5.1c8 3.4 15.1 5.8 21.1 11.9 6 6 10.7 13.1 14.2 21.1 3.4 8 5.1 16.6 5.1 25.8zm-15.5 0c0-7.3-1.3-14-3.9-20.3-2.6-6.3-6.2-11.7-10.8-16.3-4.6-4.6-10-8.2-16.2-10.9-6.2-2.7-12.8-4-19.8-4s-13.6 1.3-19.8 4c-6.2 2.7-11.6 6.3-16.2 10.9-4.6 4.6-8.2 10-10.8 16.3-2.6 6.3-3.9 13.1-3.9 20.3 0 7.3 1.3 14 3.9 20.3 2.6 6.3 6.2 11.7 10.8 16.3 4.6 4.6 10 8.2 16.2 10.9 6.2 2.7 12.8 4 19.8 4s13.6-1.3 19.8-4c6.2-2.7 11.6-6.3 16.2-10.9 4.6-4.6 8.2-10 10.8-16.3 2.6-6.3 3.9-13.1 3.9-20.3zm-94.8 96.7v-6.3l88.9-10-242.9 13.4c.6-2.2 1.1-4.6 1.4-7.2.3-2 .5-4.2.6-6.5l64.8-8.1-64.9 1.9c0-.4-.1-.7-.1-1.1-2.8-17.2-25.5-23.7-25.5-23.7l-1.1-26.3h23.8l19 41.8h17.1L348.6 152l-62.2 131.4h17.1l19-41.8h23.6L345 268s-22.7 6.5-25.5 23.7c-.1.3-.1.7-.1 1.1l-64.9-1.9 64.8 8.1c.1 2.3.3 4.4.6 6.5.3 2.6.8 5 1.4 7.2L78.4 299.2l88.9 10v6.3c-5.9.9-10.5 6-10.5 12.2 0 6.8 5.6 12.4 12.4 12.4 6.8 0 12.4-5.6 12.4-12.4 0-6.2-4.6-11.3-10.5-12.2v-5.8l80.3 9v5.4c-5.7 1.1-9.9 6.2-9.9 12.1 0 6.8 5.6 10.2 12.4 10.2 6.8 0 12.4-3.4 12.4-10.2 0-6-4.3-11-9.9-12.1v-4.9l28.4 3.2v23.7h-5.9V360h5.9v-6.6h5v6.6h5.9v-13.8h-5.9V323l38.3 4.3c8.1 11.4 19 13.6 19 13.6l-.1 6.7-5.1.2-.1 12.1h4.1l.1-5h5.2l.1 5h4.1l-.1-12.1-5.1-.2-.1-6.7s10.9-2.1 19-13.6l38.3-4.3v23.2h-5.9V360h5.9v-6.6h5v6.6h5.9v-13.8h-5.9v-23.7l28.4-3.2v4.9c-5.7 1.1-9.9 6.2-9.9 12.1 0 6.8 5.6 10.2 12.4 10.2 6.8 0 12.4-3.4 12.4-10.2 0-6-4.3-11-9.9-12.1v-5.4l80.3-9v5.8c-5.9.9-10.5 6-10.5 12.2 0 6.8 5.6 12.4 12.4 12.4 6.8 0 12.4-5.6 12.4-12.4-.2-6.3-4.7-11.4-10.7-12.3zm-200.8-87.6l19.6-42.5 19.6 42.5h-17.9l-1.7-40.3-1.7 40.3h-17.9z"
    ]
};
var $ef0249c5e48bf4e3$export$5f69a5b38e12c984 = {
    prefix: "fab",
    iconName: "itunes",
    icon: [
        448,
        512,
        [],
        "f3b4",
        "M223.6 80.3C129 80.3 52.5 157 52.5 251.5S129 422.8 223.6 422.8s171.2-76.7 171.2-171.2c0-94.6-76.7-171.3-171.2-171.3zm79.4 240c-3.2 13.6-13.5 21.2-27.3 23.8-12.1 2.2-22.2 2.8-31.9-5-11.8-10-12-26.4-1.4-36.8 8.4-8 20.3-9.6 38-12.8 3-.5 5.6-1.2 7.7-3.7 3.2-3.6 2.2-2 2.2-80.8 0-5.6-2.7-7.1-8.4-6.1-4 .7-91.9 17.1-91.9 17.1-5 1.1-6.7 2.6-6.7 8.3 0 116.1.5 110.8-1.2 118.5-2.1 9-7.6 15.8-14.9 19.6-8.3 4.6-23.4 6.6-31.4 5.2-21.4-4-28.9-28.7-14.4-42.9 8.4-8 20.3-9.6 38-12.8 3-.5 5.6-1.2 7.7-3.7 5-5.7.9-127 2.6-133.7.4-2.6 1.5-4.8 3.5-6.4 2.1-1.7 5.8-2.7 6.7-2.7 101-19 113.3-21.4 115.1-21.4 5.7-.4 9 3 9 8.7-.1 170.6.4 161.4-1 167.6zM345.2 32H102.8C45.9 32 0 77.9 0 134.8v242.4C0 434.1 45.9 480 102.8 480h242.4c57 0 102.8-45.9 102.8-102.8V134.8C448 77.9 402.1 32 345.2 32zM223.6 444c-106.3 0-192.5-86.2-192.5-192.5S117.3 59 223.6 59s192.5 86.2 192.5 192.5S329.9 444 223.6 444z"
    ]
};
var $ef0249c5e48bf4e3$export$883d4844d275b117 = {
    prefix: "fab",
    iconName: "cuttlefish",
    icon: [
        440,
        512,
        [],
        "f38c",
        "M344 305.5c-17.5 31.6-57.4 54.5-96 54.5-56.6 0-104-47.4-104-104s47.4-104 104-104c38.6 0 78.5 22.9 96 54.5 13.7-50.9 41.7-93.3 87-117.8C385.7 39.1 320.5 8 248 8 111 8 0 119 0 256s111 248 248 248c72.5 0 137.7-31.1 183-80.7-45.3-24.5-73.3-66.9-87-117.8z"
    ]
};
var $ef0249c5e48bf4e3$export$eba2747efc67a397 = {
    prefix: "fab",
    iconName: "blogger",
    icon: [
        448,
        512,
        [],
        "f37c",
        "M162.4 196c4.8-4.9 6.2-5.1 36.4-5.1 27.2 0 28.1.1 32.1 2.1 5.8 2.9 8.3 7 8.3 13.6 0 5.9-2.4 10-7.6 13.4-2.8 1.8-4.5 1.9-31.1 2.1-16.4.1-29.5-.2-31.5-.8-10.3-2.9-14.1-17.7-6.6-25.3zm61.4 94.5c-53.9 0-55.8.2-60.2 4.1-3.5 3.1-5.7 9.4-5.1 13.9.7 4.7 4.8 10.1 9.2 12 2.2 1 14.1 1.7 56.3 1.2l47.9-.6 9.2-1.5c9-5.1 10.5-17.4 3.1-24.4-5.3-4.7-5-4.7-60.4-4.7zm223.4 130.1c-3.5 28.4-23 50.4-51.1 57.5-7.2 1.8-9.7 1.9-172.9 1.8-157.8 0-165.9-.1-172-1.8-8.4-2.2-15.6-5.5-22.3-10-5.6-3.8-13.9-11.8-17-16.4-3.8-5.6-8.2-15.3-10-22C.1 423 0 420.3 0 256.3 0 93.2 0 89.7 1.8 82.6 8.1 57.9 27.7 39 53 33.4c7.3-1.6 332.1-1.9 340-.3 21.2 4.3 37.9 17.1 47.6 36.4 7.7 15.3 7-1.5 7.3 180.6.2 115.8 0 164.5-.7 170.5zm-85.4-185.2c-1.1-5-4.2-9.6-7.7-11.5-1.1-.6-8-1.3-15.5-1.7-12.4-.6-13.8-.8-17.8-3.1-6.2-3.6-7.9-7.6-8-18.3 0-20.4-8.5-39.4-25.3-56.5-12-12.2-25.3-20.5-40.6-25.1-3.6-1.1-11.8-1.5-39.2-1.8-42.9-.5-52.5.4-67.1 6.2-27 10.7-46.3 33.4-53.4 62.4-1.3 5.4-1.6 14.2-1.9 64.3-.4 62.8 0 72.1 4 84.5 9.7 30.7 37.1 53.4 64.6 58.4 9.2 1.7 122.2 2.1 133.7.5 20.1-2.7 35.9-10.8 50.7-25.9 10.7-10.9 17.4-22.8 21.8-38.5 3.2-10.9 2.9-88.4 1.7-93.9z"
    ]
};
var $ef0249c5e48bf4e3$export$4fc2e88e3ac2b091 = {
    prefix: "fab",
    iconName: "flickr",
    icon: [
        448,
        512,
        [],
        "f16e",
        "M400 32H48C21.5 32 0 53.5 0 80v352c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48V80c0-26.5-21.5-48-48-48zM144.5 319c-35.1 0-63.5-28.4-63.5-63.5s28.4-63.5 63.5-63.5 63.5 28.4 63.5 63.5-28.4 63.5-63.5 63.5zm159 0c-35.1 0-63.5-28.4-63.5-63.5s28.4-63.5 63.5-63.5 63.5 28.4 63.5 63.5-28.4 63.5-63.5 63.5z"
    ]
};
var $ef0249c5e48bf4e3$export$c16cb0c14aa5beed = {
    prefix: "fab",
    iconName: "viber",
    icon: [
        512,
        512,
        [],
        "f409",
        "M444 49.9C431.3 38.2 379.9.9 265.3.4c0 0-135.1-8.1-200.9 52.3C27.8 89.3 14.9 143 13.5 209.5c-1.4 66.5-3.1 191.1 117 224.9h.1l-.1 51.6s-.8 20.9 13 25.1c16.6 5.2 26.4-10.7 42.3-27.8 8.7-9.4 20.7-23.2 29.8-33.7 82.2 6.9 145.3-8.9 152.5-11.2 16.6-5.4 110.5-17.4 125.7-142 15.8-128.6-7.6-209.8-49.8-246.5zM457.9 287c-12.9 104-89 110.6-103 115.1-6 1.9-61.5 15.7-131.2 11.2 0 0-52 62.7-68.2 79-5.3 5.3-11.1 4.8-11-5.7 0-6.9.4-85.7.4-85.7-.1 0-.1 0 0 0-101.8-28.2-95.8-134.3-94.7-189.8 1.1-55.5 11.6-101 42.6-131.6 55.7-50.5 170.4-43 170.4-43 96.9.4 143.3 29.6 154.1 39.4 35.7 30.6 53.9 103.8 40.6 211.1zm-139-80.8c.4 8.6-12.5 9.2-12.9.6-1.1-22-11.4-32.7-32.6-33.9-8.6-.5-7.8-13.4.7-12.9 27.9 1.5 43.4 17.5 44.8 46.2zm20.3 11.3c1-42.4-25.5-75.6-75.8-79.3-8.5-.6-7.6-13.5.9-12.9 58 4.2 88.9 44.1 87.8 92.5-.1 8.6-13.1 8.2-12.9-.3zm47 13.4c.1 8.6-12.9 8.7-12.9.1-.6-81.5-54.9-125.9-120.8-126.4-8.5-.1-8.5-12.9 0-12.9 73.7.5 133 51.4 133.7 139.2zM374.9 329v.2c-10.8 19-31 40-51.8 33.3l-.2-.3c-21.1-5.9-70.8-31.5-102.2-56.5-16.2-12.8-31-27.9-42.4-42.4-10.3-12.9-20.7-28.2-30.8-46.6-21.3-38.5-26-55.7-26-55.7-6.7-20.8 14.2-41 33.3-51.8h.2c9.2-4.8 18-3.2 23.9 3.9 0 0 12.4 14.8 17.7 22.1 5 6.8 11.7 17.7 15.2 23.8 6.1 10.9 2.3 22-3.7 26.6l-12 9.6c-6.1 4.9-5.3 14-5.3 14s17.8 67.3 84.3 84.3c0 0 9.1.8 14-5.3l9.6-12c4.6-6 15.7-9.8 26.6-3.7 14.7 8.3 33.4 21.2 45.8 32.9 7 5.7 8.6 14.4 3.8 23.6z"
    ]
};
var $ef0249c5e48bf4e3$export$5803ef8c86f9786d = {
    prefix: "fab",
    iconName: "soundcloud",
    icon: [
        640,
        512,
        [],
        "f1be",
        "M111.4 256.3l5.8 65-5.8 68.3c-.3 2.5-2.2 4.4-4.4 4.4s-4.2-1.9-4.2-4.4l-5.6-68.3 5.6-65c0-2.2 1.9-4.2 4.2-4.2 2.2 0 4.1 2 4.4 4.2zm21.4-45.6c-2.8 0-4.7 2.2-5 5l-5 105.6 5 68.3c.3 2.8 2.2 5 5 5 2.5 0 4.7-2.2 4.7-5l5.8-68.3-5.8-105.6c0-2.8-2.2-5-4.7-5zm25.5-24.1c-3.1 0-5.3 2.2-5.6 5.3l-4.4 130 4.4 67.8c.3 3.1 2.5 5.3 5.6 5.3 2.8 0 5.3-2.2 5.3-5.3l5.3-67.8-5.3-130c0-3.1-2.5-5.3-5.3-5.3zM7.2 283.2c-1.4 0-2.2 1.1-2.5 2.5L0 321.3l4.7 35c.3 1.4 1.1 2.5 2.5 2.5s2.2-1.1 2.5-2.5l5.6-35-5.6-35.6c-.3-1.4-1.1-2.5-2.5-2.5zm23.6-21.9c-1.4 0-2.5 1.1-2.5 2.5l-6.4 57.5 6.4 56.1c0 1.7 1.1 2.8 2.5 2.8s2.5-1.1 2.8-2.5l7.2-56.4-7.2-57.5c-.3-1.4-1.4-2.5-2.8-2.5zm25.3-11.4c-1.7 0-3.1 1.4-3.3 3.3L47 321.3l5.8 65.8c.3 1.7 1.7 3.1 3.3 3.1 1.7 0 3.1-1.4 3.1-3.1l6.9-65.8-6.9-68.1c0-1.9-1.4-3.3-3.1-3.3zm25.3-2.2c-1.9 0-3.6 1.4-3.6 3.6l-5.8 70 5.8 67.8c0 2.2 1.7 3.6 3.6 3.6s3.6-1.4 3.9-3.6l6.4-67.8-6.4-70c-.3-2.2-2-3.6-3.9-3.6zm241.4-110.9c-1.1-.8-2.8-1.4-4.2-1.4-2.2 0-4.2.8-5.6 1.9-1.9 1.7-3.1 4.2-3.3 6.7v.8l-3.3 176.7 1.7 32.5 1.7 31.7c.3 4.7 4.2 8.6 8.9 8.6s8.6-3.9 8.6-8.6l3.9-64.2-3.9-177.5c-.4-3-2-5.8-4.5-7.2zm-26.7 15.3c-1.4-.8-2.8-1.4-4.4-1.4s-3.1.6-4.4 1.4c-2.2 1.4-3.6 3.9-3.6 6.7l-.3 1.7-2.8 160.8s0 .3 3.1 65.6v.3c0 1.7.6 3.3 1.7 4.7 1.7 1.9 3.9 3.1 6.4 3.1 2.2 0 4.2-1.1 5.6-2.5 1.7-1.4 2.5-3.3 2.5-5.6l.3-6.7 3.1-58.6-3.3-162.8c-.3-2.8-1.7-5.3-3.9-6.7zm-111.4 22.5c-3.1 0-5.8 2.8-5.8 6.1l-4.4 140.6 4.4 67.2c.3 3.3 2.8 5.8 5.8 5.8 3.3 0 5.8-2.5 6.1-5.8l5-67.2-5-140.6c-.2-3.3-2.7-6.1-6.1-6.1zm376.7 62.8c-10.8 0-21.1 2.2-30.6 6.1-6.4-70.8-65.8-126.4-138.3-126.4-17.8 0-35 3.3-50.3 9.4-6.1 2.2-7.8 4.4-7.8 9.2v249.7c0 5 3.9 8.6 8.6 9.2h218.3c43.3 0 78.6-35 78.6-78.3.1-43.6-35.2-78.9-78.5-78.9zm-296.7-60.3c-4.2 0-7.5 3.3-7.8 7.8l-3.3 136.7 3.3 65.6c.3 4.2 3.6 7.5 7.8 7.5 4.2 0 7.5-3.3 7.5-7.5l3.9-65.6-3.9-136.7c-.3-4.5-3.3-7.8-7.5-7.8zm-53.6-7.8c-3.3 0-6.4 3.1-6.4 6.7l-3.9 145.3 3.9 66.9c.3 3.6 3.1 6.4 6.4 6.4 3.6 0 6.4-2.8 6.7-6.4l4.4-66.9-4.4-145.3c-.3-3.6-3.1-6.7-6.7-6.7zm26.7 3.4c-3.9 0-6.9 3.1-6.9 6.9L227 321.3l3.9 66.4c.3 3.9 3.1 6.9 6.9 6.9s6.9-3.1 6.9-6.9l4.2-66.4-4.2-141.7c0-3.9-3-6.9-6.9-6.9z"
    ]
};
var $ef0249c5e48bf4e3$export$1902312a1701467c = {
    prefix: "fab",
    iconName: "digg",
    icon: [
        512,
        512,
        [],
        "f1a6",
        "M81.7 172.3H0v174.4h132.7V96h-51v76.3zm0 133.4H50.9v-92.3h30.8v92.3zm297.2-133.4v174.4h81.8v28.5h-81.8V416H512V172.3H378.9zm81.8 133.4h-30.8v-92.3h30.8v92.3zm-235.6 41h82.1v28.5h-82.1V416h133.3V172.3H225.1v174.4zm51.2-133.3h30.8v92.3h-30.8v-92.3zM153.3 96h51.3v51h-51.3V96zm0 76.3h51.3v174.4h-51.3V172.3z"
    ]
};
var $ef0249c5e48bf4e3$export$9ea61fa1ff3225c6 = {
    prefix: "fab",
    iconName: "tencent-weibo",
    icon: [
        384,
        512,
        [],
        "f1d5",
        "M72.3 495.8c1.4 19.9-27.6 22.2-29.7 2.9C31 368.8 73.7 259.2 144 185.5c-15.6-34 9.2-77.1 50.6-77.1 30.3 0 55.1 24.6 55.1 55.1 0 44-49.5 70.8-86.9 45.1-65.7 71.3-101.4 169.8-90.5 287.2zM192 .1C66.1.1-12.3 134.3 43.7 242.4 52.4 259.8 79 246.9 70 229 23.7 136.4 91 29.8 192 29.8c75.4 0 136.9 61.4 136.9 136.9 0 90.8-86.9 153.9-167.7 133.1-19.1-4.1-25.6 24.4-6.6 29.1 110.7 23.2 204-60 204-162.3C358.6 74.7 284 .1 192 .1z"
    ]
};
var $ef0249c5e48bf4e3$export$5420457350c35845 = {
    prefix: "fab",
    iconName: "symfony",
    icon: [
        512,
        512,
        [],
        "f83d",
        "M256 8C119 8 8 119 8 256s111 248 248 248 248-111 248-248S393 8 256 8zm133.74 143.54c-11.47.41-19.4-6.45-19.77-16.87-.27-9.18 6.68-13.44 6.53-18.85-.23-6.55-10.16-6.82-12.87-6.67-39.78 1.29-48.59 57-58.89 113.85 21.43 3.15 36.65-.72 45.14-6.22 12-7.75-3.34-15.72-1.42-24.56 4-18.16 32.55-19 32 5.3-.36 17.86-25.92 41.81-77.6 35.7-10.76 59.52-18.35 115-58.2 161.72-29 34.46-58.4 39.82-71.58 40.26-24.65.85-41-12.31-41.58-29.84-.56-17 14.45-26.26 24.31-26.59 21.89-.75 30.12 25.67 14.88 34-12.09 9.71.11 12.61 2.05 12.55 10.42-.36 17.34-5.51 22.18-9 24-20 33.24-54.86 45.35-118.35 8.19-49.66 17-78 18.23-82-16.93-12.75-27.08-28.55-49.85-34.72-15.61-4.23-25.12-.63-31.81 7.83-7.92 10-5.29 23 2.37 30.7l12.63 14c15.51 17.93 24 31.87 20.8 50.62-5.06 29.93-40.72 52.9-82.88 39.94-36-11.11-42.7-36.56-38.38-50.62 7.51-24.15 42.36-11.72 34.62 13.6-2.79 8.6-4.92 8.68-6.28 13.07-4.56 14.77 41.85 28.4 51-1.39 4.47-14.52-5.3-21.71-22.25-39.85-28.47-31.75-16-65.49 2.95-79.67C204.23 140.13 251.94 197 262 205.29c37.17-109 100.53-105.46 102.43-105.53 25.16-.81 44.19 10.59 44.83 28.65.25 7.69-4.17 22.59-19.52 23.13z"
    ]
};
var $ef0249c5e48bf4e3$export$a33f03bc723e6603 = {
    prefix: "fab",
    iconName: "maxcdn",
    icon: [
        512,
        512,
        [],
        "f136",
        "M461.1 442.7h-97.4L415.6 200c2.3-10.2.9-19.5-4.4-25.7-5-6.1-13.7-9.6-24.2-9.6h-49.3l-59.5 278h-97.4l59.5-278h-83.4l-59.5 278H0l59.5-278-44.6-95.4H387c39.4 0 75.3 16.3 98.3 44.9 23.3 28.6 31.8 67.4 23.6 105.9l-47.8 222.6z"
    ]
};
var $ef0249c5e48bf4e3$export$c7956780474e39de = {
    prefix: "fab",
    iconName: "etsy",
    icon: [
        384,
        512,
        [],
        "f2d7",
        "M384 348c-1.75 10.75-13.75 110-15.5 132-117.879-4.299-219.895-4.743-368.5 0v-25.5c45.457-8.948 60.627-8.019 61-35.25 1.793-72.322 3.524-244.143 0-322-1.029-28.46-12.13-26.765-61-36v-25.5c73.886 2.358 255.933 8.551 362.999-3.75-3.5 38.25-7.75 126.5-7.75 126.5H332C320.947 115.665 313.241 68 277.25 68h-137c-10.25 0-10.75 3.5-10.75 9.75V241.5c58 .5 88.5-2.5 88.5-2.5 29.77-.951 27.56-8.502 40.75-65.251h25.75c-4.407 101.351-3.91 61.829-1.75 160.25H257c-9.155-40.086-9.065-61.045-39.501-61.5 0 0-21.5-2-88-2v139c0 26 14.25 38.25 44.25 38.25H263c63.636 0 66.564-24.996 98.751-99.75H384z"
    ]
};
var $ef0249c5e48bf4e3$export$6c28dada3398f534 = {
    prefix: "fab",
    iconName: "facebook-messenger",
    icon: [
        512,
        512,
        [],
        "f39f",
        "M256.55 8C116.52 8 8 110.34 8 248.57c0 72.3 29.71 134.78 78.07 177.94 8.35 7.51 6.63 11.86 8.05 58.23A19.92 19.92 0 0 0 122 502.31c52.91-23.3 53.59-25.14 62.56-22.7C337.85 521.8 504 423.7 504 248.57 504 110.34 396.59 8 256.55 8zm149.24 185.13l-73 115.57a37.37 37.37 0 0 1-53.91 9.93l-58.08-43.47a15 15 0 0 0-18 0l-78.37 59.44c-10.46 7.93-24.16-4.6-17.11-15.67l73-115.57a37.36 37.36 0 0 1 53.91-9.93l58.06 43.46a15 15 0 0 0 18 0l78.41-59.38c10.44-7.98 24.14 4.54 17.09 15.62z"
    ]
};
var $ef0249c5e48bf4e3$export$83a2d14204e40d9a = {
    prefix: "fab",
    iconName: "audible",
    icon: [
        640,
        512,
        [],
        "f373",
        "M640 199.9v54l-320 200L0 254v-54l320 200 320-200.1zm-194.5 72l47.1-29.4c-37.2-55.8-100.7-92.6-172.7-92.6-72 0-135.5 36.7-172.6 92.4h.3c2.5-2.3 5.1-4.5 7.7-6.7 89.7-74.4 219.4-58.1 290.2 36.3zm-220.1 18.8c16.9-11.9 36.5-18.7 57.4-18.7 34.4 0 65.2 18.4 86.4 47.6l45.4-28.4c-20.9-29.9-55.6-49.5-94.8-49.5-38.9 0-73.4 19.4-94.4 49zM103.6 161.1c131.8-104.3 318.2-76.4 417.5 62.1l.7 1 48.8-30.4C517.1 112.1 424.8 58.1 319.9 58.1c-103.5 0-196.6 53.5-250.5 135.6 9.9-10.5 22.7-23.5 34.2-32.6zm467 32.7z"
    ]
};
var $ef0249c5e48bf4e3$export$4c12ad86c5e9c2a9 = {
    prefix: "fab",
    iconName: "think-peaks",
    icon: [
        576,
        512,
        [],
        "f731",
        "M465.4 409.4l87.1-150.2-32-.3-55.1 95L259.2 0 23 407.4l32 .3L259.2 55.6zm-355.3-44.1h32.1l117.4-202.5L463 511.9l32.5.1-235.8-404.6z"
    ]
};
var $ef0249c5e48bf4e3$export$34797550194301d4 = {
    prefix: "fab",
    iconName: "bilibili",
    icon: [
        512,
        512,
        [],
        "e3d9",
        "M488.6 104.1C505.3 122.2 513 143.8 511.9 169.8V372.2C511.5 398.6 502.7 420.3 485.4 437.3C468.2 454.3 446.3 463.2 419.9 464H92.02C65.57 463.2 43.81 454.2 26.74 436.8C9.682 419.4 .7667 396.5 0 368.2V169.8C.7667 143.8 9.682 122.2 26.74 104.1C43.81 87.75 65.57 78.77 92.02 78H121.4L96.05 52.19C90.3 46.46 87.42 39.19 87.42 30.4C87.42 21.6 90.3 14.34 96.05 8.603C101.8 2.868 109.1 0 117.9 0C126.7 0 134 2.868 139.8 8.603L213.1 78H301.1L375.6 8.603C381.7 2.868 389.2 0 398 0C406.8 0 414.1 2.868 419.9 8.603C425.6 14.34 428.5 21.6 428.5 30.4C428.5 39.19 425.6 46.46 419.9 52.19L394.6 78L423.9 78C450.3 78.77 471.9 87.75 488.6 104.1H488.6zM449.8 173.8C449.4 164.2 446.1 156.4 439.1 150.3C433.9 144.2 425.1 140.9 416.4 140.5H96.05C86.46 140.9 78.6 144.2 72.47 150.3C66.33 156.4 63.07 164.2 62.69 173.8V368.2C62.69 377.4 65.95 385.2 72.47 391.7C78.99 398.2 86.85 401.5 96.05 401.5H416.4C425.6 401.5 433.4 398.2 439.7 391.7C446 385.2 449.4 377.4 449.8 368.2L449.8 173.8zM185.5 216.5C191.8 222.8 195.2 230.6 195.6 239.7V273C195.2 282.2 191.9 289.9 185.8 296.2C179.6 302.5 171.8 305.7 162.2 305.7C152.6 305.7 144.7 302.5 138.6 296.2C132.5 289.9 129.2 282.2 128.8 273V239.7C129.2 230.6 132.6 222.8 138.9 216.5C145.2 210.2 152.1 206.9 162.2 206.5C171.4 206.9 179.2 210.2 185.5 216.5H185.5zM377 216.5C383.3 222.8 386.7 230.6 387.1 239.7V273C386.7 282.2 383.4 289.9 377.3 296.2C371.2 302.5 363.3 305.7 353.7 305.7C344.1 305.7 336.3 302.5 330.1 296.2C323.1 289.9 320.7 282.2 320.4 273V239.7C320.7 230.6 324.1 222.8 330.4 216.5C336.7 210.2 344.5 206.9 353.7 206.5C362.9 206.9 370.7 210.2 377 216.5H377z"
    ]
};
var $ef0249c5e48bf4e3$export$c6087bbc62da6f90 = {
    prefix: "fab",
    iconName: "erlang",
    icon: [
        640,
        512,
        [],
        "f39d",
        "M87.2 53.5H0v405h100.4c-49.7-52.6-78.8-125.3-78.7-212.1-.1-76.7 24-142.7 65.5-192.9zm238.2 9.7c-45.9.1-85.1 33.5-89.2 83.2h169.9c-1.1-49.7-34.5-83.1-80.7-83.2zm230.7-9.6h.3l-.1-.1zm.3 0c31.4 42.7 48.7 97.5 46.2 162.7.5 6 .5 11.7 0 24.1H230.2c-.2 109.7 38.9 194.9 138.6 195.3 68.5-.3 118-51 151.9-106.1l96.4 48.2c-17.4 30.9-36.5 57.8-57.9 80.8H640v-405z"
    ]
};
var $ef0249c5e48bf4e3$export$fd0513a3aa908a67 = {
    prefix: "fab",
    iconName: "x-twitter",
    icon: [
        512,
        512,
        [],
        "e61b",
        "M389.2 48h70.6L305.6 224.2 487 464H345L233.7 318.6 106.5 464H35.8L200.7 275.5 26.8 48H172.4L272.9 180.9 389.2 48zM364.4 421.8h39.1L151.1 88h-42L364.4 421.8z"
    ]
};
var $ef0249c5e48bf4e3$export$8fc0685430a4202e = {
    prefix: "fab",
    iconName: "cotton-bureau",
    icon: [
        512,
        512,
        [],
        "f89e",
        "M474.31 330.41c-23.66 91.85-94.23 144.59-201.9 148.35V429.6c0-48 26.41-74.39 74.39-74.39 62 0 99.2-37.2 99.2-99.21 0-61.37-36.53-98.28-97.38-99.06-33-69.32-146.5-64.65-177.24 0C110.52 157.72 74 194.63 74 256c0 62.13 37.27 99.41 99.4 99.41 48 0 74.55 26.23 74.55 74.39V479c-134.43-5-211.1-85.07-211.1-223 0-141.82 81.35-223.2 223.2-223.2 114.77 0 189.84 53.2 214.69 148.81H500C473.88 71.51 388.22 8 259.82 8 105 8 12 101.19 12 255.82 12 411.14 105.19 504.34 259.82 504c128.27 0 213.87-63.81 239.67-173.59zM357 182.33c41.37 3.45 64.2 29 64.2 73.67 0 48-26.43 74.41-74.4 74.41-28.61 0-49.33-9.59-61.59-27.33 83.06-16.55 75.59-99.67 71.79-120.75zm-81.68 97.36c-2.46-10.34-16.33-87 56.23-97 2.27 10.09 16.52 87.11-56.26 97zM260 132c28.61 0 49 9.67 61.44 27.61-28.36 5.48-49.36 20.59-61.59 43.45-12.23-22.86-33.23-38-61.6-43.45 12.41-17.69 33.27-27.35 61.57-27.35zm-71.52 50.72c73.17 10.57 58.91 86.81 56.49 97-72.41-9.84-59-86.95-56.25-97zM173.2 330.41c-48 0-74.4-26.4-74.4-74.41 0-44.36 22.86-70 64.22-73.67-6.75 37.2-1.38 106.53 71.65 120.75-12.14 17.63-32.84 27.3-61.14 27.3zm53.21 12.39A80.8 80.8 0 0 0 260 309.25c7.77 14.49 19.33 25.54 33.82 33.55a80.28 80.28 0 0 0-33.58 33.83c-8-14.5-19.07-26.23-33.56-33.83z"
    ]
};
var $ef0249c5e48bf4e3$export$fc2c1db4698b6c91 = {
    prefix: "fab",
    iconName: "dashcube",
    icon: [
        448,
        512,
        [],
        "f210",
        "M326.6 104H110.4c-51.1 0-91.2 43.3-91.2 93.5V427c0 50.5 40.1 85 91.2 85h227.2c51.1 0 91.2-34.5 91.2-85V0L326.6 104zM153.9 416.5c-17.7 0-32.4-15.1-32.4-32.8V240.8c0-17.7 14.7-32.5 32.4-32.5h140.7c17.7 0 32 14.8 32 32.5v123.5l51.1 52.3H153.9z"
    ]
};
var $ef0249c5e48bf4e3$export$a02285afcee8b3ba = {
    prefix: "fab",
    iconName: "42-group",
    icon: [
        640,
        512,
        [
            "innosoft"
        ],
        "e080",
        "M320 96V416C341.011 416 361.818 411.861 381.23 403.821C400.641 395.78 418.28 383.995 433.138 369.138C447.995 354.28 459.78 336.641 467.821 317.23C475.861 297.818 480 277.011 480 256C480 234.989 475.861 214.182 467.821 194.771C459.78 175.359 447.995 157.72 433.138 142.863C418.28 128.005 400.641 116.22 381.23 108.179C361.818 100.139 341.011 96 320 96ZM0 256L160.002 416L320.003 256L160.002 96L0 256ZM480 256C480 277.011 484.138 297.818 492.179 317.23C500.219 336.643 512.005 354.28 526.862 369.138C541.72 383.995 559.357 395.781 578.77 403.821C598.182 411.862 618.989 416 640 416V96C597.565 96 556.869 112.858 526.862 142.863C496.857 172.869 480 213.565 480 256Z"
    ]
};
var $ef0249c5e48bf4e3$export$da8db9965333c744 = $ef0249c5e48bf4e3$export$a02285afcee8b3ba;
var $ef0249c5e48bf4e3$export$d511b4edf7fbac5a = {
    prefix: "fab",
    iconName: "stack-exchange",
    icon: [
        448,
        512,
        [],
        "f18d",
        "M17.7 332.3h412.7v22c0 37.7-29.3 68-65.3 68h-19L259.3 512v-89.7H83c-36 0-65.3-30.3-65.3-68v-22zm0-23.6h412.7v-85H17.7v85zm0-109.4h412.7v-85H17.7v85zM365 0H83C47 0 17.7 30.3 17.7 67.7V90h412.7V67.7C430.3 30.3 401 0 365 0z"
    ]
};
var $ef0249c5e48bf4e3$export$66726053c0c0ec32 = {
    prefix: "fab",
    iconName: "elementor",
    icon: [
        512,
        512,
        [],
        "f430",
        "M.361 256C.361 397 114 511 255 511C397 511 511 397 511 256C511 116 397 2.05 255 2.05C114 2.05 .361 116 .361 256zM192 150V363H149V150H192zM234 150H362V193H234V150zM362 235V278H234V235H362zM234 320H362V363H234V320z"
    ]
};
var $ef0249c5e48bf4e3$export$9d16a5780aab9cd3 = {
    prefix: "fab",
    iconName: "square-pied-piper",
    icon: [
        448,
        512,
        [
            "pied-piper-square"
        ],
        "e01e",
        "M32 419L0 479.2l.8-328C.8 85.3 54 32 120 32h327.2c-93 28.9-189.9 94.2-253.9 168.6C122.7 282 82.6 338 32 419M448 32S305.2 98.8 261.6 199.1c-23.2 53.6-28.9 118.1-71 158.6-28.9 27.8-69.8 38.2-105.3 56.3-23.2 12-66.4 40.5-84.9 66h328.4c66 0 119.3-53.3 119.3-119.2-.1 0-.1-328.8-.1-328.8z"
    ]
};
var $ef0249c5e48bf4e3$export$95ddae6b65597c6e = $ef0249c5e48bf4e3$export$9d16a5780aab9cd3;
var $ef0249c5e48bf4e3$export$157e4276d9138bda = {
    prefix: "fab",
    iconName: "creative-commons-nd",
    icon: [
        496,
        512,
        [],
        "f4eb",
        "M247.6 8C389.4 8 496 118.1 496 256c0 147.1-118.5 248-248.4 248C113.6 504 0 394.5 0 256 0 123.1 104.7 8 247.6 8zm.8 44.7C130.2 52.7 44.7 150.6 44.7 256c0 109.8 91.2 202.8 203.7 202.8 103.2 0 202.8-81.1 202.8-202.8.1-113.8-90.2-203.3-202.8-203.3zm94 144.3v42.5H162.1V197h180.3zm0 79.8v42.5H162.1v-42.5h180.3z"
    ]
};
var $ef0249c5e48bf4e3$export$a226dd96512e144 = {
    prefix: "fab",
    iconName: "palfed",
    icon: [
        576,
        512,
        [],
        "f3d8",
        "M384.9 193.9c0-47.4-55.2-44.2-95.4-29.8-1.3 39.4-2.5 80.7-3 119.8.7 2.8 2.6 6.2 15.1 6.2 36.8 0 83.4-42.8 83.3-96.2zm-194.5 72.2c.2 0 6.5-2.7 11.2-2.7 26.6 0 20.7 44.1-14.4 44.1-21.5 0-37.1-18.1-37.1-43 0-42 42.9-95.6 100.7-126.5 1-12.4 3-22 10.5-28.2 11.2-9 26.6-3.5 29.5 11.1 72.2-22.2 135.2 1 135.2 72 0 77.9-79.3 152.6-140.1 138.2-.1 39.4.9 74.4 2.7 100v.2c.2 3.4.6 12.5-5.3 19.1-9.6 10.6-33.4 10-36.4-22.3-4.1-44.4.2-206.1 1.4-242.5-21.5 15-58.5 50.3-58.5 75.9.2 2.5.4 4 .6 4.6zM8 181.1s-.1 37.4 38.4 37.4h30l22.4 217.2s0 44.3 44.7 44.3h288.9s44.7-.4 44.7-44.3l22.4-217.2h30s38.4 1.2 38.4-37.4c0 0 .1-37.4-38.4-37.4h-30.1c-7.3-25.6-30.2-74.3-119.4-74.3h-28V50.3s-2.7-18.4-21.1-18.4h-85.8s-21.1 0-21.1 18.4v19.1h-28.1s-105 4.2-120.5 74.3h-29S8 142.5 8 181.1z"
    ]
};
var $ef0249c5e48bf4e3$export$349f4fc9997a1bf0 = {
    prefix: "fab",
    iconName: "superpowers",
    icon: [
        448,
        512,
        [],
        "f2dd",
        "M448 32c-83.3 11-166.8 22-250 33-92 12.5-163.3 86.7-169 180-3.3 55.5 18 109.5 57.8 148.2L0 480c83.3-11 166.5-22 249.8-33 91.8-12.5 163.3-86.8 168.7-179.8 3.5-55.5-18-109.5-57.7-148.2L448 32zm-79.7 232.3c-4.2 79.5-74 139.2-152.8 134.5-79.5-4.7-140.7-71-136.3-151 4.5-79.2 74.3-139.3 153-134.5 79.3 4.7 140.5 71 136.1 151z"
    ]
};
var $ef0249c5e48bf4e3$export$e73a6c635a57ef10 = {
    prefix: "fab",
    iconName: "resolving",
    icon: [
        496,
        512,
        [],
        "f3e7",
        "M281.2 278.2c46-13.3 49.6-23.5 44-43.4L314 195.5c-6.1-20.9-18.4-28.1-71.1-12.8L54.7 236.8l28.6 98.6 197.9-57.2zM248.5 8C131.4 8 33.2 88.7 7.2 197.5l221.9-63.9c34.8-10.2 54.2-11.7 79.3-8.2 36.3 6.1 52.7 25 61.4 55.2l10.7 37.8c8.2 28.1 1 50.6-23.5 73.6-19.4 17.4-31.2 24.5-61.4 33.2L203 351.8l220.4 27.1 9.7 34.2-48.1 13.3-286.8-37.3 23 80.2c36.8 22 80.3 34.7 126.3 34.7 137 0 248.5-111.4 248.5-248.3C497 119.4 385.5 8 248.5 8zM38.3 388.6L0 256.8c0 48.5 14.3 93.4 38.3 131.8z"
    ]
};
var $ef0249c5e48bf4e3$export$2c743c09f4269e9c = {
    prefix: "fab",
    iconName: "xbox",
    icon: [
        512,
        512,
        [],
        "f412",
        "M369.9 318.2c44.3 54.3 64.7 98.8 54.4 118.7-7.9 15.1-56.7 44.6-92.6 55.9-29.6 9.3-68.4 13.3-100.4 10.2-38.2-3.7-76.9-17.4-110.1-39C93.3 445.8 87 438.3 87 423.4c0-29.9 32.9-82.3 89.2-142.1 32-33.9 76.5-73.7 81.4-72.6 9.4 2.1 84.3 75.1 112.3 109.5zM188.6 143.8c-29.7-26.9-58.1-53.9-86.4-63.4-15.2-5.1-16.3-4.8-28.7 8.1-29.2 30.4-53.5 79.7-60.3 122.4-5.4 34.2-6.1 43.8-4.2 60.5 5.6 50.5 17.3 85.4 40.5 120.9 9.5 14.6 12.1 17.3 9.3 9.9-4.2-11-.3-37.5 9.5-64 14.3-39 53.9-112.9 120.3-194.4zm311.6 63.5C483.3 127.3 432.7 77 425.6 77c-7.3 0-24.2 6.5-36 13.9-23.3 14.5-41 31.4-64.3 52.8C367.7 197 427.5 283.1 448.2 346c6.8 20.7 9.7 41.1 7.4 52.3-1.7 8.5-1.7 8.5 1.4 4.6 6.1-7.7 19.9-31.3 25.4-43.5 7.4-16.2 15-40.2 18.6-58.7 4.3-22.5 3.9-70.8-.8-93.4zM141.3 43C189 40.5 251 77.5 255.6 78.4c.7.1 10.4-4.2 21.6-9.7 63.9-31.1 94-25.8 107.4-25.2-63.9-39.3-152.7-50-233.9-11.7-23.4 11.1-24 11.9-9.4 11.2z"
    ]
};
var $ef0249c5e48bf4e3$export$e72de9688042e327 = {
    prefix: "fab",
    iconName: "searchengin",
    icon: [
        460,
        512,
        [],
        "f3eb",
        "M220.6 130.3l-67.2 28.2V43.2L98.7 233.5l54.7-24.2v130.3l67.2-209.3zm-83.2-96.7l-1.3 4.7-15.2 52.9C80.6 106.7 52 145.8 52 191.5c0 52.3 34.3 95.9 83.4 105.5v53.6C57.5 340.1 0 272.4 0 191.6c0-80.5 59.8-147.2 137.4-158zm311.4 447.2c-11.2 11.2-23.1 12.3-28.6 10.5-5.4-1.8-27.1-19.9-60.4-44.4-33.3-24.6-33.6-35.7-43-56.7-9.4-20.9-30.4-42.6-57.5-52.4l-9.7-14.7c-24.7 16.9-53 26.9-81.3 28.7l2.1-6.6 15.9-49.5c46.5-11.9 80.9-54 80.9-104.2 0-54.5-38.4-102.1-96-107.1V32.3C254.4 37.4 320 106.8 320 191.6c0 33.6-11.2 64.7-29 90.4l14.6 9.6c9.8 27.1 31.5 48 52.4 57.4s32.2 9.7 56.8 43c24.6 33.2 42.7 54.9 44.5 60.3s.7 17.3-10.5 28.5zm-9.9-17.9c0-4.4-3.6-8-8-8s-8 3.6-8 8 3.6 8 8 8 8-3.6 8-8z"
    ]
};
var $ef0249c5e48bf4e3$export$f310e79ae35a251f = {
    prefix: "fab",
    iconName: "tiktok",
    icon: [
        448,
        512,
        [],
        "e07b",
        "M448,209.91a210.06,210.06,0,0,1-122.77-39.25V349.38A162.55,162.55,0,1,1,185,188.31V278.2a74.62,74.62,0,1,0,52.23,71.18V0l88,0a121.18,121.18,0,0,0,1.86,22.17h0A122.18,122.18,0,0,0,381,102.39a121.43,121.43,0,0,0,67,20.14Z"
    ]
};
var $ef0249c5e48bf4e3$export$8545d76ecd01ec19 = {
    prefix: "fab",
    iconName: "square-facebook",
    icon: [
        448,
        512,
        [
            "facebook-square"
        ],
        "f082",
        "M400 32H48A48 48 0 0 0 0 80v352a48 48 0 0 0 48 48h137.25V327.69h-63V256h63v-54.64c0-62.15 37-96.48 93.67-96.48 27.14 0 55.52 4.84 55.52 4.84v61h-31.27c-30.81 0-40.42 19.12-40.42 38.73V256h68.78l-11 71.69h-57.78V480H400a48 48 0 0 0 48-48V80a48 48 0 0 0-48-48z"
    ]
};
var $ef0249c5e48bf4e3$export$cd6ab8ed6a9ec7a4 = $ef0249c5e48bf4e3$export$8545d76ecd01ec19;
var $ef0249c5e48bf4e3$export$36a9439e8de2df70 = {
    prefix: "fab",
    iconName: "renren",
    icon: [
        512,
        512,
        [],
        "f18b",
        "M214 169.1c0 110.4-61 205.4-147.6 247.4C30 373.2 8 317.7 8 256.6 8 133.9 97.1 32.2 214 12.5v156.6zM255 504c-42.9 0-83.3-11-118.5-30.4C193.7 437.5 239.9 382.9 255 319c15.5 63.9 61.7 118.5 118.8 154.7C338.7 493 298.3 504 255 504zm190.6-87.5C359 374.5 298 279.6 298 169.1V12.5c116.9 19.7 206 121.4 206 244.1 0 61.1-22 116.6-58.4 159.9z"
    ]
};
var $ef0249c5e48bf4e3$export$5cb68a24a0b7bdf6 = {
    prefix: "fab",
    iconName: "linux",
    icon: [
        448,
        512,
        [],
        "f17c",
        "M220.8 123.3c1 .5 1.8 1.7 3 1.7 1.1 0 2.8-.4 2.9-1.5.2-1.4-1.9-2.3-3.2-2.9-1.7-.7-3.9-1-5.5-.1-.4.2-.8.7-.6 1.1.3 1.3 2.3 1.1 3.4 1.7zm-21.9 1.7c1.2 0 2-1.2 3-1.7 1.1-.6 3.1-.4 3.5-1.6.2-.4-.2-.9-.6-1.1-1.6-.9-3.8-.6-5.5.1-1.3.6-3.4 1.5-3.2 2.9.1 1 1.8 1.5 2.8 1.4zM420 403.8c-3.6-4-5.3-11.6-7.2-19.7-1.8-8.1-3.9-16.8-10.5-22.4-1.3-1.1-2.6-2.1-4-2.9-1.3-.8-2.7-1.5-4.1-2 9.2-27.3 5.6-54.5-3.7-79.1-11.4-30.1-31.3-56.4-46.5-74.4-17.1-21.5-33.7-41.9-33.4-72C311.1 85.4 315.7.1 234.8 0 132.4-.2 158 103.4 156.9 135.2c-1.7 23.4-6.4 41.8-22.5 64.7-18.9 22.5-45.5 58.8-58.1 96.7-6 17.9-8.8 36.1-6.2 53.3-6.5 5.8-11.4 14.7-16.6 20.2-4.2 4.3-10.3 5.9-17 8.3s-14 6-18.5 14.5c-2.1 3.9-2.8 8.1-2.8 12.4 0 3.9.6 7.9 1.2 11.8 1.2 8.1 2.5 15.7.8 20.8-5.2 14.4-5.9 24.4-2.2 31.7 3.8 7.3 11.4 10.5 20.1 12.3 17.3 3.6 40.8 2.7 59.3 12.5 19.8 10.4 39.9 14.1 55.9 10.4 11.6-2.6 21.1-9.6 25.9-20.2 12.5-.1 26.3-5.4 48.3-6.6 14.9-1.2 33.6 5.3 55.1 4.1.6 2.3 1.4 4.6 2.5 6.7v.1c8.3 16.7 23.8 24.3 40.3 23 16.6-1.3 34.1-11 48.3-27.9 13.6-16.4 36-23.2 50.9-32.2 7.4-4.5 13.4-10.1 13.9-18.3.4-8.2-4.4-17.3-15.5-29.7zM223.7 87.3c9.8-22.2 34.2-21.8 44-.4 6.5 14.2 3.6 30.9-4.3 40.4-1.6-.8-5.9-2.6-12.6-4.9 1.1-1.2 3.1-2.7 3.9-4.6 4.8-11.8-.2-27-9.1-27.3-7.3-.5-13.9 10.8-11.8 23-4.1-2-9.4-3.5-13-4.4-1-6.9-.3-14.6 2.9-21.8zM183 75.8c10.1 0 20.8 14.2 19.1 33.5-3.5 1-7.1 2.5-10.2 4.6 1.2-8.9-3.3-20.1-9.6-19.6-8.4.7-9.8 21.2-1.8 28.1 1 .8 1.9-.2-5.9 5.5-15.6-14.6-10.5-52.1 8.4-52.1zm-13.6 60.7c6.2-4.6 13.6-10 14.1-10.5 4.7-4.4 13.5-14.2 27.9-14.2 7.1 0 15.6 2.3 25.9 8.9 6.3 4.1 11.3 4.4 22.6 9.3 8.4 3.5 13.7 9.7 10.5 18.2-2.6 7.1-11 14.4-22.7 18.1-11.1 3.6-19.8 16-38.2 14.9-3.9-.2-7-1-9.6-2.1-8-3.5-12.2-10.4-20-15-8.6-4.8-13.2-10.4-14.7-15.3-1.4-4.9 0-9 4.2-12.3zm3.3 334c-2.7 35.1-43.9 34.4-75.3 18-29.9-15.8-68.6-6.5-76.5-21.9-2.4-4.7-2.4-12.7 2.6-26.4v-.2c2.4-7.6.6-16-.6-23.9-1.2-7.8-1.8-15 .9-20 3.5-6.7 8.5-9.1 14.8-11.3 10.3-3.7 11.8-3.4 19.6-9.9 5.5-5.7 9.5-12.9 14.3-18 5.1-5.5 10-8.1 17.7-6.9 8.1 1.2 15.1 6.8 21.9 16l19.6 35.6c9.5 19.9 43.1 48.4 41 68.9zm-1.4-25.9c-4.1-6.6-9.6-13.6-14.4-19.6 7.1 0 14.2-2.2 16.7-8.9 2.3-6.2 0-14.9-7.4-24.9-13.5-18.2-38.3-32.5-38.3-32.5-13.5-8.4-21.1-18.7-24.6-29.9s-3-23.3-.3-35.2c5.2-22.9 18.6-45.2 27.2-59.2 2.3-1.7.8 3.2-8.7 20.8-8.5 16.1-24.4 53.3-2.6 82.4.6-20.7 5.5-41.8 13.8-61.5 12-27.4 37.3-74.9 39.3-112.7 1.1.8 4.6 3.2 6.2 4.1 4.6 2.7 8.1 6.7 12.6 10.3 12.4 10 28.5 9.2 42.4 1.2 6.2-3.5 11.2-7.5 15.9-9 9.9-3.1 17.8-8.6 22.3-15 7.7 30.4 25.7 74.3 37.2 95.7 6.1 11.4 18.3 35.5 23.6 64.6 3.3-.1 7 .4 10.9 1.4 13.8-35.7-11.7-74.2-23.3-84.9-4.7-4.6-4.9-6.6-2.6-6.5 12.6 11.2 29.2 33.7 35.2 59 2.8 11.6 3.3 23.7.4 35.7 16.4 6.8 35.9 17.9 30.7 34.8-2.2-.1-3.2 0-4.2 0 3.2-10.1-3.9-17.6-22.8-26.1-19.6-8.6-36-8.6-38.3 12.5-12.1 4.2-18.3 14.7-21.4 27.3-2.8 11.2-3.6 24.7-4.4 39.9-.5 7.7-3.6 18-6.8 29-32.1 22.9-76.7 32.9-114.3 7.2zm257.4-11.5c-.9 16.8-41.2 19.9-63.2 46.5-13.2 15.7-29.4 24.4-43.6 25.5s-26.5-4.8-33.7-19.3c-4.7-11.1-2.4-23.1 1.1-36.3 3.7-14.2 9.2-28.8 9.9-40.6.8-15.2 1.7-28.5 4.2-38.7 2.6-10.3 6.6-17.2 13.7-21.1.3-.2.7-.3 1-.5.8 13.2 7.3 26.6 18.8 29.5 12.6 3.3 30.7-7.5 38.4-16.3 9-.3 15.7-.9 22.6 5.1 9.9 8.5 7.1 30.3 17.1 41.6 10.6 11.6 14 19.5 13.7 24.6zM173.3 148.7c2 1.9 4.7 4.5 8 7.1 6.6 5.2 15.8 10.6 27.3 10.6 11.6 0 22.5-5.9 31.8-10.8 4.9-2.6 10.9-7 14.8-10.4s5.9-6.3 3.1-6.6-2.6 2.6-6 5.1c-4.4 3.2-9.7 7.4-13.9 9.8-7.4 4.2-19.5 10.2-29.9 10.2s-18.7-4.8-24.9-9.7c-3.1-2.5-5.7-5-7.7-6.9-1.5-1.4-1.9-4.6-4.3-4.9-1.4-.1-1.8 3.7 1.7 6.5z"
    ]
};
var $ef0249c5e48bf4e3$export$c4c84939b8784e10 = {
    prefix: "fab",
    iconName: "glide",
    icon: [
        448,
        512,
        [],
        "f2a5",
        "M252.8 148.6c0 8.8-1.6 17.7-3.4 26.4-5.8 27.8-11.6 55.8-17.3 83.6-1.4 6.3-8.3 4.9-13.7 4.9-23.8 0-30.5-26-30.5-45.5 0-29.3 11.2-68.1 38.5-83.1 4.3-2.5 9.2-4.2 14.1-4.2 11.4 0 12.3 8.3 12.3 17.9zM448 80v352c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V80c0-26.5 21.5-48 48-48h352c26.5 0 48 21.5 48 48zm-64 187c0-5.1-20.8-37.7-25.5-39.5-2.2-.9-7.2-2.3-9.6-2.3-23.1 0-38.7 10.5-58.2 21.5l-.5-.5c4.3-29.4 14.6-57.2 14.6-87.4 0-44.6-23.8-62.7-67.5-62.7-71.7 0-108 70.8-108 123.5 0 54.7 32 85 86.3 85 7.5 0 6.9-.6 6.9 2.3-10.5 80.3-56.5 82.9-56.5 58.9 0-24.4 28-36.5 28.3-38-.2-7.6-29.3-17.2-36.7-17.2-21.1 0-32.7 33-32.7 50.6 0 32.3 20.4 54.7 53.3 54.7 48.2 0 83.4-49.7 94.3-91.7 9.4-37.7 7-39.4 12.3-42.1 20-10.1 35.8-16.8 58.4-16.8 11.1 0 19 2.3 36.7 5.2 1.8.1 4.1-1.7 4.1-3.5z"
    ]
};
var $ef0249c5e48bf4e3$export$b38fbe0cd1e4c67d = {
    prefix: "fab",
    iconName: "linkedin",
    icon: [
        448,
        512,
        [],
        "f08c",
        "M416 32H31.9C14.3 32 0 46.5 0 64.3v383.4C0 465.5 14.3 480 31.9 480H416c17.6 0 32-14.5 32-32.3V64.3c0-17.8-14.4-32.3-32-32.3zM135.4 416H69V202.2h66.5V416zm-33.2-243c-21.3 0-38.5-17.3-38.5-38.5S80.9 96 102.2 96c21.2 0 38.5 17.3 38.5 38.5 0 21.3-17.2 38.5-38.5 38.5zm282.1 243h-66.4V312c0-24.8-.5-56.7-34.5-56.7-34.6 0-39.9 27-39.9 54.9V416h-66.4V202.2h63.7v29.2h.9c8.9-16.8 30.6-34.5 62.9-34.5 67.2 0 79.7 44.3 79.7 101.9V416z"
    ]
};
var $ef0249c5e48bf4e3$export$418b99079caf9b9b = {
    prefix: "fab",
    iconName: "hubspot",
    icon: [
        512,
        512,
        [],
        "f3b2",
        "M267.4 211.6c-25.1 23.7-40.8 57.3-40.8 94.6 0 29.3 9.7 56.3 26 78L203.1 434c-4.4-1.6-9.1-2.5-14-2.5-10.8 0-20.9 4.2-28.5 11.8-7.6 7.6-11.8 17.8-11.8 28.6s4.2 20.9 11.8 28.5c7.6 7.6 17.8 11.6 28.5 11.6 10.8 0 20.9-3.9 28.6-11.6 7.6-7.6 11.8-17.8 11.8-28.5 0-4.2-.6-8.2-1.9-12.1l50-50.2c22 16.9 49.4 26.9 79.3 26.9 71.9 0 130-58.3 130-130.2 0-65.2-47.7-119.2-110.2-128.7V116c17.5-7.4 28.2-23.8 28.2-42.9 0-26.1-20.9-47.9-47-47.9S311.2 47 311.2 73.1c0 19.1 10.7 35.5 28.2 42.9v61.2c-15.2 2.1-29.6 6.7-42.7 13.6-27.6-20.9-117.5-85.7-168.9-124.8 1.2-4.4 2-9 2-13.8C129.8 23.4 106.3 0 77.4 0 48.6 0 25.2 23.4 25.2 52.2c0 28.9 23.4 52.3 52.2 52.3 9.8 0 18.9-2.9 26.8-7.6l163.2 114.7zm89.5 163.6c-38.1 0-69-30.9-69-69s30.9-69 69-69 69 30.9 69 69-30.9 69-69 69z"
    ]
};
var $ef0249c5e48bf4e3$export$bd9dbf3c3b0bdc5e = {
    prefix: "fab",
    iconName: "deploydog",
    icon: [
        512,
        512,
        [],
        "f38e",
        "M382.2 136h51.7v239.6h-51.7v-20.7c-19.8 24.8-52.8 24.1-73.8 14.7-26.2-11.7-44.3-38.1-44.3-71.8 0-29.8 14.8-57.9 43.3-70.8 20.2-9.1 52.7-10.6 74.8 12.9V136zm-64.7 161.8c0 18.2 13.6 33.5 33.2 33.5 19.8 0 33.2-16.4 33.2-32.9 0-17.1-13.7-33.2-33.2-33.2-19.6 0-33.2 16.4-33.2 32.6zM188.5 136h51.7v239.6h-51.7v-20.7c-19.8 24.8-52.8 24.1-73.8 14.7-26.2-11.7-44.3-38.1-44.3-71.8 0-29.8 14.8-57.9 43.3-70.8 20.2-9.1 52.7-10.6 74.8 12.9V136zm-64.7 161.8c0 18.2 13.6 33.5 33.2 33.5 19.8 0 33.2-16.4 33.2-32.9 0-17.1-13.7-33.2-33.2-33.2-19.7 0-33.2 16.4-33.2 32.6zM448 96c17.5 0 32 14.4 32 32v256c0 17.5-14.4 32-32 32H64c-17.5 0-32-14.4-32-32V128c0-17.5 14.4-32 32-32h384m0-32H64C28.8 64 0 92.8 0 128v256c0 35.2 28.8 64 64 64h384c35.2 0 64-28.8 64-64V128c0-35.2-28.8-64-64-64z"
    ]
};
var $ef0249c5e48bf4e3$export$154857d90d308f7c = {
    prefix: "fab",
    iconName: "twitch",
    icon: [
        512,
        512,
        [],
        "f1e8",
        "M391.17,103.47H352.54v109.7h38.63ZM285,103H246.37V212.75H285ZM120.83,0,24.31,91.42V420.58H140.14V512l96.53-91.42h77.25L487.69,256V0ZM449.07,237.75l-77.22,73.12H294.61l-67.6,64v-64H140.14V36.58H449.07Z"
    ]
};
var $ef0249c5e48bf4e3$export$cab2db22e59af947 = {
    prefix: "fab",
    iconName: "ravelry",
    icon: [
        512,
        512,
        [],
        "f2d9",
        "M498.252,234.223c-1.208-10.34-1.7-20.826-3.746-31a310.306,310.306,0,0,0-9.622-36.6,184.068,184.068,0,0,0-30.874-57.5,251.154,251.154,0,0,0-18.818-21.689,237.362,237.362,0,0,0-47.113-36.116A240.8,240.8,0,0,0,331.356,26.65c-11.018-3.1-22.272-5.431-33.515-7.615-6.78-1.314-13.749-1.667-20.627-2.482-.316-.036-.6-.358-.9-.553q-16.143.009-32.288.006c-2.41.389-4.808.925-7.236,1.15a179.331,179.331,0,0,0-34.256,7.1,221.5,221.5,0,0,0-39.768,16.355,281.385,281.385,0,0,0-38.08,24.158c-6.167,4.61-12.268,9.36-17.974,14.518C96.539,88.494,86.34,97.72,76.785,107.555a243.878,243.878,0,0,0-33.648,43.95,206.488,206.488,0,0,0-20.494,44.6,198.2,198.2,0,0,0-7.691,34.759A201.13,201.13,0,0,0,13.4,266.385a299.716,299.716,0,0,0,4.425,40.24,226.865,226.865,0,0,0,16.73,53.3,210.543,210.543,0,0,0,24,39.528,213.589,213.589,0,0,0,26.358,28.416A251.313,251.313,0,0,0,126.7,458.455a287.831,287.831,0,0,0,55.9,25.277,269.5,269.5,0,0,0,40.641,9.835c6.071,1.01,12.275,1.253,18.412,1.873a4.149,4.149,0,0,1,1.19.56h32.289c2.507-.389,5-.937,7.527-1.143,16.336-1.332,32.107-5.335,47.489-10.717A219.992,219.992,0,0,0,379.1,460.322c9.749-6.447,19.395-13.077,28.737-20.1,5.785-4.348,10.988-9.5,16.3-14.457,3.964-3.7,7.764-7.578,11.51-11.5a232.162,232.162,0,0,0,31.427-41.639c9.542-16.045,17.355-32.905,22.3-50.926,2.859-10.413,4.947-21.045,7.017-31.652,1.032-5.279,1.251-10.723,1.87-16.087.036-.317.358-.6.552-.9V236.005A9.757,9.757,0,0,1,498.252,234.223Zm-161.117-1.15s-16.572-2.98-28.47-2.98c-27.2,0-33.57,14.9-33.57,37.04V360.8H201.582V170.062H275.1v31.931c8.924-26.822,26.771-36.189,62.04-36.189Z"
    ]
};
var $ef0249c5e48bf4e3$export$83d047b1c09d253 = {
    prefix: "fab",
    iconName: "mixer",
    icon: [
        512,
        512,
        [],
        "e056",
        "M114.57,76.07a45.71,45.71,0,0,0-67.51-6.41c-17.58,16.18-19,43.52-4.75,62.77l91.78,123L41.76,379.58c-14.23,19.25-13.11,46.59,4.74,62.77A45.71,45.71,0,0,0,114,435.94L242.89,262.7a12.14,12.14,0,0,0,0-14.23ZM470.24,379.58,377.91,255.45l91.78-123c14.22-19.25,12.83-46.59-4.75-62.77a45.71,45.71,0,0,0-67.51,6.41l-128,172.12a12.14,12.14,0,0,0,0,14.23L398,435.94a45.71,45.71,0,0,0,67.51,6.41C483.35,426.17,484.47,398.83,470.24,379.58Z"
    ]
};
var $ef0249c5e48bf4e3$export$37794c0b0ffc1e44 = {
    prefix: "fab",
    iconName: "square-lastfm",
    icon: [
        448,
        512,
        [
            "lastfm-square"
        ],
        "f203",
        "M400 32H48C21.5 32 0 53.5 0 80v352c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48V80c0-26.5-21.5-48-48-48zm-92.2 312.9c-63.4 0-85.4-28.6-97.1-64.1-16.3-51-21.5-84.3-63-84.3-22.4 0-45.1 16.1-45.1 61.2 0 35.2 18 57.2 43.3 57.2 28.6 0 47.6-21.3 47.6-21.3l11.7 31.9s-19.8 19.4-61.2 19.4c-51.3 0-79.9-30.1-79.9-85.8 0-57.9 28.6-92 82.5-92 73.5 0 80.8 41.4 100.8 101.9 8.8 26.8 24.2 46.2 61.2 46.2 24.9 0 38.1-5.5 38.1-19.1 0-19.9-21.8-22-49.9-28.6-30.4-7.3-42.5-23.1-42.5-48 0-40 32.3-52.4 65.2-52.4 37.4 0 60.1 13.6 63 46.6l-36.7 4.4c-1.5-15.8-11-22.4-28.6-22.4-16.1 0-26 7.3-26 19.8 0 11 4.8 17.6 20.9 21.3 32.7 7.1 71.8 12 71.8 57.5.1 36.7-30.7 50.6-76.1 50.6z"
    ]
};
var $ef0249c5e48bf4e3$export$c2f59587d6a3a574 = $ef0249c5e48bf4e3$export$37794c0b0ffc1e44;
var $ef0249c5e48bf4e3$export$b73c31bd90a3782e = {
    prefix: "fab",
    iconName: "vimeo",
    icon: [
        448,
        512,
        [],
        "f40a",
        "M403.2 32H44.8C20.1 32 0 52.1 0 76.8v358.4C0 459.9 20.1 480 44.8 480h358.4c24.7 0 44.8-20.1 44.8-44.8V76.8c0-24.7-20.1-44.8-44.8-44.8zM377 180.8c-1.4 31.5-23.4 74.7-66 129.4-44 57.2-81.3 85.8-111.7 85.8-18.9 0-34.8-17.4-47.9-52.3-25.5-93.3-36.4-148-57.4-148-2.4 0-10.9 5.1-25.4 15.2l-15.2-19.6c37.3-32.8 72.9-69.2 95.2-71.2 25.2-2.4 40.7 14.8 46.5 51.7 20.7 131.2 29.9 151 67.6 91.6 13.5-21.4 20.8-37.7 21.8-48.9 3.5-33.2-25.9-30.9-45.8-22.4 15.9-52.1 46.3-77.4 91.2-76 33.3.9 49 22.5 47.1 64.7z"
    ]
};
var $ef0249c5e48bf4e3$export$a580d86d20b50be3 = {
    prefix: "fab",
    iconName: "mendeley",
    icon: [
        640,
        512,
        [],
        "f7b3",
        "M624.6 325.2c-12.3-12.4-29.7-19.2-48.4-17.2-43.3-1-49.7-34.9-37.5-98.8 22.8-57.5-14.9-131.5-87.4-130.8-77.4.7-81.7 82-130.9 82-48.1 0-54-81.3-130.9-82-72.9-.8-110.1 73.3-87.4 130.8 12.2 63.9 5.8 97.8-37.5 98.8-21.2-2.3-37 6.5-53 22.5-19.9 19.7-19.3 94.8 42.6 102.6 47.1 5.9 81.6-42.9 61.2-87.8-47.3-103.7 185.9-106.1 146.5-8.2-.1.1-.2.2-.3.4-26.8 42.8 6.8 97.4 58.8 95.2 52.1 2.1 85.4-52.6 58.8-95.2-.1-.2-.2-.3-.3-.4-39.4-97.9 193.8-95.5 146.5 8.2-4.6 10-6.7 21.3-5.7 33 4.9 53.4 68.7 74.1 104.9 35.2 17.8-14.8 23.1-65.6 0-88.3zm-303.9-19.1h-.6c-43.4 0-62.8-37.5-62.8-62.8 0-34.7 28.2-62.8 62.8-62.8h.6c34.7 0 62.8 28.1 62.8 62.8 0 25-19.2 62.8-62.8 62.8z"
    ]
};
var $ef0249c5e48bf4e3$export$6fb93399039178f9 = {
    prefix: "fab",
    iconName: "uniregistry",
    icon: [
        384,
        512,
        [],
        "f404",
        "M192 480c39.5 0 76.2-11.8 106.8-32.2H85.3C115.8 468.2 152.5 480 192 480zm-89.1-193.1v-12.4H0v12.4c0 2.5 0 5 .1 7.4h103.1c-.2-2.4-.3-4.9-.3-7.4zm20.5 57H8.5c2.6 8.5 5.8 16.8 9.6 24.8h138.3c-12.9-5.7-24.1-14.2-33-24.8zm-17.7-34.7H1.3c.9 7.6 2.2 15 3.9 22.3h109.7c-4-6.9-7.2-14.4-9.2-22.3zm-2.8-69.3H0v17.3h102.9zm0-173.2H0v4.9h102.9zm0-34.7H0v2.5h102.9zm0 69.3H0v7.4h102.9zm0 104H0v14.8h102.9zm0-69.3H0v9.9h102.9zm0 34.6H0V183h102.9zm166.2 160.9h109.7c1.8-7.3 3.1-14.7 3.9-22.3H278.3c-2.1 7.9-5.2 15.4-9.2 22.3zm12-185.7H384V136H281.1zm0 37.2H384v-12.4H281.1zm0-74.3H384v-7.4H281.1zm0-76.7v2.5H384V32zm-203 410.9h227.7c11.8-8.7 22.7-18.6 32.2-29.7H44.9c9.6 11 21.4 21 33.2 29.7zm203-371.3H384v-4.9H281.1zm0 148.5H384v-14.8H281.1zM38.8 405.7h305.3c6.7-8.5 12.6-17.6 17.8-27.2H23c5.2 9.6 9.2 18.7 15.8 27.2zm188.8-37.1H367c3.7-8 5.8-16.2 8.5-24.8h-115c-8.8 10.7-20.1 19.2-32.9 24.8zm53.5-81.7c0 2.5-.1 5-.4 7.4h103.1c.1-2.5.2-4.9.2-7.4v-12.4H281.1zm0-29.7H384v-17.3H281.1z"
    ]
};
var $ef0249c5e48bf4e3$export$e71a35e82f13ad7f = {
    prefix: "fab",
    iconName: "figma",
    icon: [
        384,
        512,
        [],
        "f799",
        "M14 95.7924C14 42.8877 56.8878 0 109.793 0H274.161C327.066 0 369.954 42.8877 369.954 95.7924C369.954 129.292 352.758 158.776 326.711 175.897C352.758 193.019 369.954 222.502 369.954 256.002C369.954 308.907 327.066 351.795 274.161 351.795H272.081C247.279 351.795 224.678 342.369 207.666 326.904V415.167C207.666 468.777 163.657 512 110.309 512C57.5361 512 14 469.243 14 416.207C14 382.709 31.1945 353.227 57.2392 336.105C31.1945 318.983 14 289.5 14 256.002C14 222.502 31.196 193.019 57.2425 175.897C31.196 158.776 14 129.292 14 95.7924ZM176.288 191.587H109.793C74.2172 191.587 45.3778 220.427 45.3778 256.002C45.3778 291.44 73.9948 320.194 109.381 320.416C109.518 320.415 109.655 320.415 109.793 320.415H176.288V191.587ZM207.666 256.002C207.666 291.577 236.505 320.417 272.081 320.417H274.161C309.737 320.417 338.576 291.577 338.576 256.002C338.576 220.427 309.737 191.587 274.161 191.587H272.081C236.505 191.587 207.666 220.427 207.666 256.002ZM109.793 351.795C109.655 351.795 109.518 351.794 109.381 351.794C73.9948 352.015 45.3778 380.769 45.3778 416.207C45.3778 451.652 74.6025 480.622 110.309 480.622C146.591 480.622 176.288 451.186 176.288 415.167V351.795H109.793ZM109.793 31.3778C74.2172 31.3778 45.3778 60.2173 45.3778 95.7924C45.3778 131.368 74.2172 160.207 109.793 160.207H176.288V31.3778H109.793ZM207.666 160.207H274.161C309.737 160.207 338.576 131.368 338.576 95.7924C338.576 60.2173 309.737 31.3778 274.161 31.3778H207.666V160.207Z"
    ]
};
var $ef0249c5e48bf4e3$export$c02c848648d47b55 = {
    prefix: "fab",
    iconName: "creative-commons-remix",
    icon: [
        496,
        512,
        [],
        "f4ee",
        "M247.6 8C389.4 8 496 118.1 496 256c0 147.1-118.5 248-248.4 248C113.6 504 0 394.5 0 256 0 123.1 104.7 8 247.6 8zm.8 44.7C130.2 52.7 44.7 150.6 44.7 256c0 109.8 91.2 202.8 203.7 202.8 103.2 0 202.8-81.1 202.8-202.8.1-113.8-90.2-203.3-202.8-203.3zm161.7 207.7l4.9 2.2v70c-7.2 3.6-63.4 27.5-67.3 28.8-6.5-1.8-113.7-46.8-137.3-56.2l-64.2 26.6-63.3-27.5v-63.8l59.3-24.8c-.7-.7-.4 5-.4-70.4l67.3-29.7L361 178.5v61.6l49.1 20.3zm-70.4 81.5v-43.8h-.4v-1.8l-113.8-46.5V295l113.8 46.9v-.4l.4.4zm7.5-57.6l39.9-16.4-36.8-15.5-39 16.4 35.9 15.5zm52.3 38.1v-43L355.2 298v43.4l44.3-19z"
    ]
};
var $ef0249c5e48bf4e3$export$3f0dada7ec074193 = {
    prefix: "fab",
    iconName: "cc-amazon-pay",
    icon: [
        576,
        512,
        [],
        "f42d",
        "M124.7 201.8c.1-11.8 0-23.5 0-35.3v-35.3c0-1.3.4-2 1.4-2.7 11.5-8 24.1-12.1 38.2-11.1 12.5.9 22.7 7 28.1 21.7 3.3 8.9 4.1 18.2 4.1 27.7 0 8.7-.7 17.3-3.4 25.6-5.7 17.8-18.7 24.7-35.7 23.9-11.7-.5-21.9-5-31.4-11.7-.9-.8-1.4-1.6-1.3-2.8zm154.9 14.6c4.6 1.8 9.3 2 14.1 1.5 11.6-1.2 21.9-5.7 31.3-12.5.9-.6 1.3-1.3 1.3-2.5-.1-3.9 0-7.9 0-11.8 0-4-.1-8 0-12 0-1.4-.4-2-1.8-2.2-7-.9-13.9-2.2-20.9-2.9-7-.6-14-.3-20.8 1.9-6.7 2.2-11.7 6.2-13.7 13.1-1.6 5.4-1.6 10.8.1 16.2 1.6 5.5 5.2 9.2 10.4 11.2zM576 80v352c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V80c0-26.5 21.5-48 48-48h480c26.5 0 48 21.5 48 48zm-207.5 23.9c.4 1.7.9 3.4 1.6 5.1 16.5 40.6 32.9 81.3 49.5 121.9 1.4 3.5 1.7 6.4.2 9.9-2.8 6.2-4.9 12.6-7.8 18.7-2.6 5.5-6.7 9.5-12.7 11.2-4.2 1.1-8.5 1.3-12.9.9-2.1-.2-4.2-.7-6.3-.8-2.8-.2-4.2 1.1-4.3 4-.1 2.8-.1 5.6 0 8.3.1 4.6 1.6 6.7 6.2 7.5 4.7.8 9.4 1.6 14.2 1.7 14.3.3 25.7-5.4 33.1-17.9 2.9-4.9 5.6-10.1 7.7-15.4 19.8-50.1 39.5-100.3 59.2-150.5.6-1.5 1.1-3 1.3-4.6.4-2.4-.7-3.6-3.1-3.7-5.6-.1-11.1 0-16.7 0-3.1 0-5.3 1.4-6.4 4.3-.4 1.1-.9 2.3-1.3 3.4l-29.1 83.7c-2.1 6.1-4.2 12.1-6.5 18.6-.4-.9-.6-1.4-.8-1.9-10.8-29.9-21.6-59.9-32.4-89.8-1.7-4.7-3.5-9.5-5.3-14.2-.9-2.5-2.7-4-5.4-4-6.4-.1-12.8-.2-19.2-.1-2.2 0-3.3 1.6-2.8 3.7zM242.4 206c1.7 11.7 7.6 20.8 18 26.6 9.9 5.5 20.7 6.2 31.7 4.6 12.7-1.9 23.9-7.3 33.8-15.5.4-.3.8-.6 1.4-1 .5 3.2.9 6.2 1.5 9.2.5 2.6 2.1 4.3 4.5 4.4 4.6.1 9.1.1 13.7 0 2.3-.1 3.8-1.6 4-3.9.1-.8.1-1.6.1-2.3v-88.8c0-3.6-.2-7.2-.7-10.8-1.6-10.8-6.2-19.7-15.9-25.4-5.6-3.3-11.8-5-18.2-5.9-3-.4-6-.7-9.1-1.1h-10c-.8.1-1.6.3-2.5.3-8.2.4-16.3 1.4-24.2 3.5-5.1 1.3-10 3.2-15 4.9-3 1-4.5 3.2-4.4 6.5.1 2.8-.1 5.6 0 8.3.1 4.1 1.8 5.2 5.7 4.1 6.5-1.7 13.1-3.5 19.7-4.8 10.3-1.9 20.7-2.7 31.1-1.2 5.4.8 10.5 2.4 14.1 7 3.1 4 4.2 8.8 4.4 13.7.3 6.9.2 13.9.3 20.8 0 .4-.1.7-.2 1.2-.4 0-.8 0-1.1-.1-8.8-2.1-17.7-3.6-26.8-4.1-9.5-.5-18.9.1-27.9 3.2-10.8 3.8-19.5 10.3-24.6 20.8-4.1 8.3-4.6 17-3.4 25.8zM98.7 106.9v175.3c0 .8 0 1.7.1 2.5.2 2.5 1.7 4.1 4.1 4.2 5.9.1 11.8.1 17.7 0 2.5 0 4-1.7 4.1-4.1.1-.8.1-1.7.1-2.5v-60.7c.9.7 1.4 1.2 1.9 1.6 15 12.5 32.2 16.6 51.1 12.9 17.1-3.4 28.9-13.9 36.7-29.2 5.8-11.6 8.3-24.1 8.7-37 .5-14.3-1-28.4-6.8-41.7-7.1-16.4-18.9-27.3-36.7-30.9-2.7-.6-5.5-.8-8.2-1.2h-7c-1.2.2-2.4.3-3.6.5-11.7 1.4-22.3 5.8-31.8 12.7-2 1.4-3.9 3-5.9 4.5-.1-.5-.3-.8-.4-1.2-.4-2.3-.7-4.6-1.1-6.9-.6-3.9-2.5-5.5-6.4-5.6h-9.7c-5.9-.1-6.9 1-6.9 6.8zM493.6 339c-2.7-.7-5.1 0-7.6 1-43.9 18.4-89.5 30.2-136.8 35.8-14.5 1.7-29.1 2.8-43.7 3.2-26.6.7-53.2-.8-79.6-4.3-17.8-2.4-35.5-5.7-53-9.9-37-8.9-72.7-21.7-106.7-38.8-8.8-4.4-17.4-9.3-26.1-14-3.8-2.1-6.2-1.5-8.2 2.1v1.7c1.2 1.6 2.2 3.4 3.7 4.8 36 32.2 76.6 56.5 122 72.9 21.9 7.9 44.4 13.7 67.3 17.5 14 2.3 28 3.8 42.2 4.5 3 .1 6 .2 9 .4.7 0 1.4.2 2.1.3h17.7c.7-.1 1.4-.3 2.1-.3 14.9-.4 29.8-1.8 44.6-4 21.4-3.2 42.4-8.1 62.9-14.7 29.6-9.6 57.7-22.4 83.4-40.1 2.8-1.9 5.7-3.8 8-6.2 4.3-4.4 2.3-10.4-3.3-11.9zm50.4-27.7c-.8-4.2-4-5.8-7.6-7-5.7-1.9-11.6-2.8-17.6-3.3-11-.9-22-.4-32.8 1.6-12 2.2-23.4 6.1-33.5 13.1-1.2.8-2.4 1.8-3.1 3-.6.9-.7 2.3-.5 3.4.3 1.3 1.7 1.6 3 1.5.6 0 1.2 0 1.8-.1l19.5-2.1c9.6-.9 19.2-1.5 28.8-.8 4.1.3 8.1 1.2 12 2.2 4.3 1.1 6.2 4.4 6.4 8.7.3 6.7-1.2 13.1-2.9 19.5-3.5 12.9-8.3 25.4-13.3 37.8-.3.8-.7 1.7-.8 2.5-.4 2.5 1 4 3.4 3.5 1.4-.3 3-1.1 4-2.1 3.7-3.6 7.5-7.2 10.6-11.2 10.7-13.8 17-29.6 20.7-46.6.7-3 1.2-6.1 1.7-9.1.2-4.7.2-9.6.2-14.5z"
    ]
};
var $ef0249c5e48bf4e3$export$e4589d83245ae1b2 = {
    prefix: "fab",
    iconName: "dropbox",
    icon: [
        528,
        512,
        [],
        "f16b",
        "M264.4 116.3l-132 84.3 132 84.3-132 84.3L0 284.1l132.3-84.3L0 116.3 132.3 32l132.1 84.3zM131.6 395.7l132-84.3 132 84.3-132 84.3-132-84.3zm132.8-111.6l132-84.3-132-83.6L395.7 32 528 116.3l-132.3 84.3L528 284.8l-132.3 84.3-131.3-85z"
    ]
};
var $ef0249c5e48bf4e3$export$8256451a9905291a = {
    prefix: "fab",
    iconName: "instagram",
    icon: [
        448,
        512,
        [],
        "f16d",
        "M224.1 141c-63.6 0-114.9 51.3-114.9 114.9s51.3 114.9 114.9 114.9S339 319.5 339 255.9 287.7 141 224.1 141zm0 189.6c-41.1 0-74.7-33.5-74.7-74.7s33.5-74.7 74.7-74.7 74.7 33.5 74.7 74.7-33.6 74.7-74.7 74.7zm146.4-194.3c0 14.9-12 26.8-26.8 26.8-14.9 0-26.8-12-26.8-26.8s12-26.8 26.8-26.8 26.8 12 26.8 26.8zm76.1 27.2c-1.7-35.9-9.9-67.7-36.2-93.9-26.2-26.2-58-34.4-93.9-36.2-37-2.1-147.9-2.1-184.9 0-35.8 1.7-67.6 9.9-93.9 36.1s-34.4 58-36.2 93.9c-2.1 37-2.1 147.9 0 184.9 1.7 35.9 9.9 67.7 36.2 93.9s58 34.4 93.9 36.2c37 2.1 147.9 2.1 184.9 0 35.9-1.7 67.7-9.9 93.9-36.2 26.2-26.2 34.4-58 36.2-93.9 2.1-37 2.1-147.8 0-184.8zM398.8 388c-7.8 19.6-22.9 34.7-42.6 42.6-29.5 11.7-99.5 9-132.1 9s-102.7 2.6-132.1-9c-19.6-7.8-34.7-22.9-42.6-42.6-11.7-29.5-9-99.5-9-132.1s-2.6-102.7 9-132.1c7.8-19.6 22.9-34.7 42.6-42.6 29.5-11.7 99.5-9 132.1-9s102.7-2.6 132.1 9c19.6 7.8 34.7 22.9 42.6 42.6 11.7 29.5 9 99.5 9 132.1s2.7 102.7-9 132.1z"
    ]
};
var $ef0249c5e48bf4e3$export$f4e59d0d43aeb784 = {
    prefix: "fab",
    iconName: "cmplid",
    icon: [
        640,
        512,
        [],
        "e360",
        "M226.119,388.165a3.816,3.816,0,0,0-2.294-3.5,3.946,3.946,0,0,0-1.629-.385L72.6,384.3a19.243,19.243,0,0,1-17.924-26.025L81.585,255.692a35.72,35.72,0,0,1,32.373-26H262.525a7.07,7.07,0,0,0,6.392-5.194l10.769-41.131a3.849,3.849,0,0,0-2.237-4.937,3.755,3.755,0,0,0-1.377-.261c-.063,0-.126,0-.189.005H127.38a106.8,106.8,0,0,0-96.99,77.1L3.483,358.824A57.469,57.469,0,0,0,57.314,436q1.43,0,2.86-.072H208.742a7.131,7.131,0,0,0,6.391-5.193L225.839,389.6A3.82,3.82,0,0,0,226.119,388.165ZM306.658,81.2a3.861,3.861,0,0,0,.251-1.367A3.813,3.813,0,0,0,303.079,76c-.064,0-.128,0-.192,0h-41A7.034,7.034,0,0,0,255.5,81.2l-21.347,80.915h51.131ZM180.364,368.249H231.5L263.452,245.69H212.321ZM511.853,79.723a3.809,3.809,0,0,0-3.8-3.661c-.058,0-.137,0-.23.007h-41a7.1,7.1,0,0,0-6.584,5.129L368.91,430.634a3.54,3.54,0,0,0-.262,1.335,3.873,3.873,0,0,0,3.864,3.863c.056,0,.112,0,.169,0h41a7.068,7.068,0,0,0,6.392-5.193L511.533,81.2A3.624,3.624,0,0,0,511.853,79.723ZM324.649,384.47h-41a7.2,7.2,0,0,0-6.392,5.194L266.52,430.8a3.662,3.662,0,0,0-.268,1.374A3.783,3.783,0,0,0,270.023,436c.06,0,.166,0,.3-.012h40.905a7.036,7.036,0,0,0,6.391-5.193l10.769-41.131a3.75,3.75,0,0,0-3.445-5.208c-.108,0-.217,0-.326.014Zm311.324-308.4h-41a7.066,7.066,0,0,0-6.392,5.129l-91.46,349.436a4.073,4.073,0,0,0-.229,1.347,3.872,3.872,0,0,0,3.863,3.851c.056,0,.112,0,.169,0h40.968a7.1,7.1,0,0,0,6.392-5.193L639.68,81.2a3.624,3.624,0,0,0,.32-1.475,3.841,3.841,0,0,0-3.821-3.564c-.068,0-.137,0-.206.006ZM371.562,225.236l10.8-41.1a4.369,4.369,0,0,0,.227-1.388,3.869,3.869,0,0,0-3.861-3.842c-.057,0-.113,0-.169,0h-41.1a7.292,7.292,0,0,0-6.391,5.226l-10.834,41.1a4.417,4.417,0,0,0-.26,1.493c0,.069,0,.138,0,.206a3.776,3.776,0,0,0,3.757,3.507c.076,0,.18,0,.3-.012h41.129A7.034,7.034,0,0,0,371.562,225.236Z"
    ]
};
var $ef0249c5e48bf4e3$export$86108d0b79007794 = {
    prefix: "fab",
    iconName: "facebook",
    icon: [
        512,
        512,
        [
            62000
        ],
        "f09a",
        "M504 256C504 119 393 8 256 8S8 119 8 256c0 123.78 90.69 226.38 209.25 245V327.69h-63V256h63v-54.64c0-62.15 37-96.48 93.67-96.48 27.14 0 55.52 4.84 55.52 4.84v61h-31.28c-30.8 0-40.41 19.12-40.41 38.73V256h68.78l-11 71.69h-57.78V501C413.31 482.38 504 379.78 504 256z"
    ]
};
var $ef0249c5e48bf4e3$export$957b7296da5b4490 = {
    prefix: "fab",
    iconName: "gripfire",
    icon: [
        384,
        512,
        [],
        "f3ac",
        "M112.5 301.4c0-73.8 105.1-122.5 105.1-203 0-47.1-34-88-39.1-90.4.4 3.3.6 6.7.6 10C179.1 110.1 32 171.9 32 286.6c0 49.8 32.2 79.2 66.5 108.3 65.1 46.7 78.1 71.4 78.1 86.6 0 10.1-4.8 17-4.8 22.3 13.1-16.7 17.4-31.9 17.5-46.4 0-29.6-21.7-56.3-44.2-86.5-16-22.3-32.6-42.6-32.6-69.5zm205.3-39c-12.1-66.8-78-124.4-94.7-130.9l4 7.2c2.4 5.1 3.4 10.9 3.4 17.1 0 44.7-54.2 111.2-56.6 116.7-2.2 5.1-3.2 10.5-3.2 15.8 0 20.1 15.2 42.1 17.9 42.1 2.4 0 56.6-55.4 58.1-87.7 6.4 11.7 9.1 22.6 9.1 33.4 0 41.2-41.8 96.9-41.8 96.9 0 11.6 31.9 53.2 35.5 53.2 1 0 2.2-1.4 3.2-2.4 37.9-39.3 67.3-85 67.3-136.8 0-8-.7-16.2-2.2-24.6z"
    ]
};
var $ef0249c5e48bf4e3$export$3a376d0f2ecfb7d0 = {
    prefix: "fab",
    iconName: "jedi-order",
    icon: [
        448,
        512,
        [],
        "f50e",
        "M398.5 373.6c95.9-122.1 17.2-233.1 17.2-233.1 45.4 85.8-41.4 170.5-41.4 170.5 105-171.5-60.5-271.5-60.5-271.5 96.9 72.7-10.1 190.7-10.1 190.7 85.8 158.4-68.6 230.1-68.6 230.1s-.4-16.9-2.2-85.7c4.3 4.5 34.5 36.2 34.5 36.2l-24.2-47.4 62.6-9.1-62.6-9.1 20.2-55.5-31.4 45.9c-2.2-87.7-7.8-305.1-7.9-306.9v-2.4 1-1 2.4c0 1-5.6 219-7.9 306.9l-31.4-45.9 20.2 55.5-62.6 9.1 62.6 9.1-24.2 47.4 34.5-36.2c-1.8 68.8-2.2 85.7-2.2 85.7s-154.4-71.7-68.6-230.1c0 0-107-118.1-10.1-190.7 0 0-165.5 99.9-60.5 271.5 0 0-86.8-84.8-41.4-170.5 0 0-78.7 111 17.2 233.1 0 0-26.2-16.1-49.4-77.7 0 0 16.9 183.3 222 185.7h4.1c205-2.4 222-185.7 222-185.7-23.6 61.5-49.9 77.7-49.9 77.7z"
    ]
};
var $ef0249c5e48bf4e3$export$27afc16078b5f3ac = {
    prefix: "fab",
    iconName: "uikit",
    icon: [
        448,
        512,
        [],
        "f403",
        "M443.9 128v256L218 512 0 384V169.7l87.6 45.1v117l133.5 75.5 135.8-75.5v-151l-101.1-57.6 87.6-53.1L443.9 128zM308.6 49.1L223.8 0l-88.6 54.8 86 47.3 87.4-53z"
    ]
};
var $ef0249c5e48bf4e3$export$a5097e0b1bb080b7 = {
    prefix: "fab",
    iconName: "fort-awesome-alt",
    icon: [
        512,
        512,
        [],
        "f3a3",
        "M208 237.4h-22.2c-2.1 0-3.7 1.6-3.7 3.7v51.7c0 2.1 1.6 3.7 3.7 3.7H208c2.1 0 3.7-1.6 3.7-3.7v-51.7c0-2.1-1.6-3.7-3.7-3.7zm118.2 0H304c-2.1 0-3.7 1.6-3.7 3.7v51.7c0 2.1 1.6 3.7 3.7 3.7h22.2c2.1 0 3.7-1.6 3.7-3.7v-51.7c-.1-2.1-1.7-3.7-3.7-3.7zm132-125.1c-2.3-3.2-4.6-6.4-7.1-9.5-9.8-12.5-20.8-24-32.8-34.4-4.5-3.9-9.1-7.6-13.9-11.2-1.6-1.2-3.2-2.3-4.8-3.5C372 34.1 340.3 20 306 13c-16.2-3.3-32.9-5-50-5s-33.9 1.7-50 5c-34.3 7.1-66 21.2-93.3 40.8-1.6 1.1-3.2 2.3-4.8 3.5-4.8 3.6-9.4 7.3-13.9 11.2-3 2.6-5.9 5.3-8.8 8s-5.7 5.5-8.4 8.4c-5.5 5.7-10.7 11.8-15.6 18-2.4 3.1-4.8 6.3-7.1 9.5C25.2 153 8.3 202.5 8.3 256c0 2 .1 4 .1 6 .1.7.1 1.3.1 2 .1 1.3.1 2.7.2 4 0 .8.1 1.5.1 2.3 0 1.3.1 2.5.2 3.7.1.8.1 1.6.2 2.4.1 1.1.2 2.3.3 3.5 0 .8.1 1.6.2 2.4.1 1.2.3 2.4.4 3.6.1.8.2 1.5.3 2.3.1 1.3.3 2.6.5 3.9.1.6.2 1.3.3 1.9l.9 5.7c.1.6.2 1.1.3 1.7.3 1.3.5 2.7.8 4 .2.8.3 1.6.5 2.4.2 1 .5 2.1.7 3.2.2.9.4 1.7.6 2.6.2 1 .4 2 .7 3 .2.9.5 1.8.7 2.7.3 1 .5 1.9.8 2.9.3.9.5 1.8.8 2.7.2.9.5 1.9.8 2.8s.5 1.8.8 2.7c.3 1 .6 1.9.9 2.8.6 1.6 1.1 3.3 1.7 4.9.4 1 .7 1.9 1 2.8.3 1 .7 2 1.1 3 .3.8.6 1.5.9 2.3l1.2 3c.3.7.6 1.5.9 2.2.4 1 .9 2 1.3 3l.9 2.1c.5 1 .9 2 1.4 3 .3.7.6 1.3.9 2 .5 1 1 2.1 1.5 3.1.2.6.5 1.1.8 1.7.6 1.1 1.1 2.2 1.7 3.3.1.2.2.3.3.5 2.2 4.1 4.4 8.2 6.8 12.2.2.4.5.8.7 1.2.7 1.1 1.3 2.2 2 3.3.3.5.6.9.9 1.4.6 1.1 1.3 2.1 2 3.2.3.5.6.9.9 1.4.7 1.1 1.4 2.1 2.1 3.2.2.4.5.8.8 1.2.7 1.1 1.5 2.2 2.3 3.3.2.2.3.5.5.7 37.5 51.7 94.4 88.5 160 99.4.9.1 1.7.3 2.6.4 1 .2 2.1.4 3.1.5s1.9.3 2.8.4c1 .2 2 .3 3 .4.9.1 1.9.2 2.9.3s1.9.2 2.9.3 2.1.2 3.1.3c.9.1 1.8.1 2.7.2 1.1.1 2.3.1 3.4.2.8 0 1.7.1 2.5.1 1.3 0 2.6.1 3.9.1.7.1 1.4.1 2.1.1 2 .1 4 .1 6 .1s4-.1 6-.1c.7 0 1.4-.1 2.1-.1 1.3 0 2.6 0 3.9-.1.8 0 1.7-.1 2.5-.1 1.1-.1 2.3-.1 3.4-.2.9 0 1.8-.1 2.7-.2 1-.1 2.1-.2 3.1-.3s1.9-.2 2.9-.3c.9-.1 1.9-.2 2.9-.3s2-.3 3-.4 1.9-.3 2.8-.4c1-.2 2.1-.3 3.1-.5.9-.1 1.7-.3 2.6-.4 65.6-11 122.5-47.7 160.1-102.4.2-.2.3-.5.5-.7.8-1.1 1.5-2.2 2.3-3.3.2-.4.5-.8.8-1.2.7-1.1 1.4-2.1 2.1-3.2.3-.5.6-.9.9-1.4.6-1.1 1.3-2.1 2-3.2.3-.5.6-.9.9-1.4.7-1.1 1.3-2.2 2-3.3.2-.4.5-.8.7-1.2 2.4-4 4.6-8.1 6.8-12.2.1-.2.2-.3.3-.5.6-1.1 1.1-2.2 1.7-3.3.2-.6.5-1.1.8-1.7.5-1 1-2.1 1.5-3.1.3-.7.6-1.3.9-2 .5-1 1-2 1.4-3l.9-2.1c.5-1 .9-2 1.3-3 .3-.7.6-1.5.9-2.2l1.2-3c.3-.8.6-1.5.9-2.3.4-1 .7-2 1.1-3s.7-1.9 1-2.8c.6-1.6 1.2-3.3 1.7-4.9.3-1 .6-1.9.9-2.8s.5-1.8.8-2.7c.2-.9.5-1.9.8-2.8s.6-1.8.8-2.7c.3-1 .5-1.9.8-2.9.2-.9.5-1.8.7-2.7.2-1 .5-2 .7-3 .2-.9.4-1.7.6-2.6.2-1 .5-2.1.7-3.2.2-.8.3-1.6.5-2.4.3-1.3.6-2.7.8-4 .1-.6.2-1.1.3-1.7l.9-5.7c.1-.6.2-1.3.3-1.9.1-1.3.3-2.6.5-3.9.1-.8.2-1.5.3-2.3.1-1.2.3-2.4.4-3.6 0-.8.1-1.6.2-2.4.1-1.1.2-2.3.3-3.5.1-.8.1-1.6.2-2.4.1 1.7.1.5.2-.7 0-.8.1-1.5.1-2.3.1-1.3.2-2.7.2-4 .1-.7.1-1.3.1-2 .1-2 .1-4 .1-6 0-53.5-16.9-103-45.8-143.7zM448 371.5c-9.4 15.5-20.6 29.9-33.6 42.9-20.6 20.6-44.5 36.7-71.2 48-13.9 5.8-28.2 10.3-42.9 13.2v-75.8c0-58.6-88.6-58.6-88.6 0v75.8c-14.7-2.9-29-7.3-42.9-13.2-26.7-11.3-50.6-27.4-71.2-48-13-13-24.2-27.4-33.6-42.9v-71.3c0-2.1 1.6-3.7 3.7-3.7h22.1c2.1 0 3.7 1.6 3.7 3.7V326h29.6V182c0-2.1 1.6-3.7 3.7-3.7h22.1c2.1 0 3.7 1.6 3.7 3.7v25.9h29.5V182c0-2.1 1.6-3.7 3.7-3.7H208c2.1 0 3.7 1.6 3.7 3.7v25.9h29.5V182c0-4.8 6.5-3.7 9.5-3.7V88.1c-4.4-2-7.4-6.7-7.4-11.5 0-16.8 25.4-16.8 25.4 0 0 4.8-3 9.4-7.4 11.5V92c6.3-1.4 12.7-2.3 19.2-2.3 9.4 0 18.4 3.5 26.3 3.5 7.2 0 15.2-3.5 19.4-3.5 2.1 0 3.7 1.6 3.7 3.7v48.4c0 5.6-18.7 6.5-22.4 6.5-8.6 0-16.6-3.5-25.4-3.5-7 0-14.1 1.2-20.8 2.8v30.7c3 0 9.5-1.1 9.5 3.7v25.9h29.5V182c0-2.1 1.6-3.7 3.7-3.7h22.2c2.1 0 3.7 1.6 3.7 3.7v25.9h29.5V182c0-2.1 1.6-3.7 3.7-3.7h22.1c2.1 0 3.7 1.6 3.7 3.7v144h29.5v-25.8c0-2.1 1.6-3.7 3.7-3.7h22.2c2.1 0 3.7 1.6 3.7 3.7z"
    ]
};
var $ef0249c5e48bf4e3$export$cc29519275365076 = {
    prefix: "fab",
    iconName: "phabricator",
    icon: [
        496,
        512,
        [],
        "f3db",
        "M323 262.1l-.1-13s21.7-19.8 21.1-21.2l-9.5-20c-.6-1.4-29.5-.5-29.5-.5l-9.4-9.3s.2-28.5-1.2-29.1l-20.1-9.2c-1.4-.6-20.7 21-20.7 21l-13.1-.2s-20.5-21.4-21.9-20.8l-20 8.3c-1.4.5.2 28.9.2 28.9l-9.1 9.1s-29.2-.9-29.7.4l-8.1 19.8c-.6 1.4 21 21 21 21l.1 12.9s-21.7 19.8-21.1 21.2l9.5 20c.6 1.4 29.5.5 29.5.5l9.4 9.3s-.2 31.8 1.2 32.3l20.1 8.3c1.4.6 20.7-23.5 20.7-23.5l13.1.2s20.5 23.8 21.8 23.3l20-7.5c1.4-.6-.2-32.1-.2-32.1l9.1-9.1s29.2.9 29.7-.5l8.1-19.8c.7-1.1-20.9-20.7-20.9-20.7zm-44.9-8.7c.7 17.1-12.8 31.6-30.1 32.4-17.3.8-32.1-12.5-32.8-29.6-.7-17.1 12.8-31.6 30.1-32.3 17.3-.8 32.1 12.5 32.8 29.5zm201.2-37.9l-97-97-.1.1c-75.1-73.3-195.4-72.8-269.8 1.6-50.9 51-27.8 27.9-95.7 95.3-22.3 22.3-22.3 58.7 0 81 69.9 69.4 46.4 46 97.4 97l.1-.1c75.1 73.3 195.4 72.9 269.8-1.6 51-50.9 27.9-27.9 95.3-95.3 22.3-22.3 22.3-58.7 0-81zM140.4 363.8c-59.6-59.5-59.6-156 0-215.5 59.5-59.6 156-59.5 215.6 0 59.5 59.5 59.6 156 0 215.6-59.6 59.5-156 59.4-215.6-.1z"
    ]
};
var $ef0249c5e48bf4e3$export$d0ceedb643a91662 = {
    prefix: "fab",
    iconName: "ussunnah",
    icon: [
        482,
        512,
        [],
        "f407",
        "M481.9 268.1A240.9 240.9 0 1 1 .1 268a240.9 240.9 0 1 1 481.9 0zM24.5 268a216.5 216.5 0 1 0 432.9 0A216.5 216.5 0 1 0 24.5 268zm385.9 63.3c-12.7 0-21.6-1.9-26.7-5.9c-5.5-4.3-8.2-12.3-8.2-23.8V205.1c0-6.5-5.2-20.2-15.7-41.2c7 0 17-9.1 30-27.2V284.5c0 11 2.4 19.4 7 25.3c3.7 4.7 10.1 8.9 19 12.6c1.2 .4 2.6 .9 4.1 1.4c2.9 .9 6.3 2.1 10.3 3.5c-1.8 2.7-8.3 4-19.9 4zm-219 0c-1.3 2.4-3.6 5.5-6.8 9.4l-18.5 22.5c-1-6.1-4-13-9.3-20.6s-9.7-11.4-13.4-11.4h-8.3H53.6c3.3-5.3 4.9-8.8 4.9-10.8c0-2-.8-5.3-2.4-9.7c-1.5-4.4-2.4-8.5-2.4-12.4c0-7.4 2.1-13.9 6.3-19.3L80 253.4l-7.1-17.7L89 215.9l6.7 16.8 8-10.3c-1.8 6.4-2.6 12.3-2.6 17.7c0 4.2 2.8 13.3 8.3 27.3l16.2 40.7H135h8 .3c2.8 .4 7.7 5 14.6 13.9c1.8 2.4 4.3 5.8 7.7 10.2c1.4 1.9 2.9 3.9 4.6 6.1c1.3-2.3 2-4.6 2-7.1c0-2-1.3-6.6-4-13.4L163 304.1c-4-10.6-6.1-17.7-6.1-21.3c0-6.3 1.9-12.3 5.8-17.9c.5-.6 1-1.3 1.5-1.9c4.4-5.6 8.8-11.1 13.3-16.5c-1.1 4.6-1.7 8.7-1.7 12c0 3.7 1.7 9.9 5.1 18.8l7.9 20.4c1.9 4.7 3 8.2 3.7 10.3h17.6 8.3l-.9-2.6c-1.4-3.9-4-7-7.7-9.3l15.6-20.1 12.3 32h13.4L245 292.2c-1.5-3.9-4-7-7.7-9.3L253 262.8 270.3 308h13.4l-11.4-29.4c-1.5-3.9-4-7-7.7-9.3l15.6-20L302.6 308h10.3 8.3 7.6c1.5 0 3-1.1 4.5-3.1s2.2-4.1 2.2-6.3V205.1c0-6.5-4.5-20.3-13.7-41.2c5.4 0 14.1-9.1 26.2-27.2V300.2c0 7.2 .6 12 1.7 14.6c1.6 3.4 5.3 6.2 11.1 8.2c-3.9 5.6-8.7 8.5-14.5 8.5H321.1h-8.3H210.5h-19zM93.4 287.3c-2.7-6.7-4-11.7-4-15c-.6 1.2-2.4 3.7-5.4 7.6c-1.4 1.9-2.2 3.7-2.2 5.3c0 2.6 .8 5.7 2.2 9.3l5.6 13.9h0c5 0 9 0 11.9-.1l-8.2-20.9zm13.5-72.4c-3-5.2-7-9.3-11.9-11.9c-3.5-1.9-5.3-4.3-5.3-7.4c0-2.4 4.6-8.6 14-18.3c.2 3.8 1.9 7.6 4.9 11.2c3.1 3.6 4.6 7 4.6 10.1c0 2.6-2.1 8-6.2 16.3zm-27.6 0c-3-5.2-7-9.3-11.9-11.9c-3.5-1.9-5.3-4.3-5.3-7.4c0-2.4 4.6-8.6 14-18.3c.2 3.8 1.9 7.6 4.9 11.2c3.1 3.6 4.6 7 4.6 10.1c0 2.6-2.1 8-6.2 16.3zm87 27.5c-3-5.2-7-9.3-11.9-11.9c-3.5-1.9-5.3-4.3-5.3-7.4c0-2.4 4.6-8.6 14-18.3c.2 3.8 1.9 7.6 4.9 11.2c3.1 3.6 4.6 7 4.6 10.1c0 2.6-2.1 8-6.2 16.3z"
    ]
};
var $ef0249c5e48bf4e3$export$c30a6352a2a5e8ea = {
    prefix: "fab",
    iconName: "earlybirds",
    icon: [
        480,
        512,
        [],
        "f39a",
        "M313.2 47.5c1.2-13 21.3-14 36.6-8.7.9.3 26.2 9.7 19 15.2-27.9-7.4-56.4 18.2-55.6-6.5zm-201 6.9c30.7-8.1 62 20 61.1-7.1-1.3-14.2-23.4-15.3-40.2-9.6-1 .3-28.7 10.5-20.9 16.7zM319.4 160c-8.8 0-16 7.2-16 16s7.2 16 16 16 16-7.2 16-16-7.2-16-16-16zm-159.7 0c-8.8 0-16 7.2-16 16s7.2 16 16 16 16-7.2 16-16-7.2-16-16-16zm318.5 163.2c-9.9 24-40.7 11-63.9-1.2-13.5 69.1-58.1 111.4-126.3 124.2.3.9-2-.1 24 1 33.6 1.4 63.8-3.1 97.4-8-19.8-13.8-11.4-37.1-9.8-38.1 1.4-.9 14.7 1.7 21.6 11.5 8.6-12.5 28.4-14.8 30.2-13.6 1.6 1.1 6.6 20.9-6.9 34.6 4.7-.9 8.2-1.6 9.8-2.1 2.6-.8 17.7 11.3 3.1 13.3-14.3 2.3-22.6 5.1-47.1 10.8-45.9 10.7-85.9 11.8-117.7 12.8l1 11.6c3.8 18.1-23.4 24.3-27.6 6.2.8 17.9-27.1 21.8-28.4-1l-.5 5.3c-.7 18.4-28.4 17.9-28.3-.6-7.5 13.5-28.1 6.8-26.4-8.5l1.2-12.4c-36.7.9-59.7 3.1-61.8 3.1-20.9 0-20.9-31.6 0-31.6 2.4 0 27.7 1.3 63.2 2.8-61.1-15.5-103.7-55-114.9-118.2-25 12.8-57.5 26.8-68.2.8-10.5-25.4 21.5-42.6 66.8-73.4.7-6.6 1.6-13.3 2.7-19.8-14.4-19.6-11.6-36.3-16.1-60.4-16.8 2.4-23.2-9.1-23.6-23.1.3-7.3 2.1-14.9 2.4-15.4 1.1-1.8 10.1-2 12.7-2.6 6-31.7 50.6-33.2 90.9-34.5 19.7-21.8 45.2-41.5 80.9-48.3C203.3 29 215.2 8.5 216.2 8c1.7-.8 21.2 4.3 26.3 23.2 5.2-8.8 18.3-11.4 19.6-10.7 1.1.6 6.4 15-4.9 25.9 40.3 3.5 72.2 24.7 96 50.7 36.1 1.5 71.8 5.9 77.1 34 2.7.6 11.6.8 12.7 2.6.3.5 2.1 8.1 2.4 15.4-.5 13.9-6.8 25.4-23.6 23.1-3.2 17.3-2.7 32.9-8.7 47.7 2.4 11.7 4 23.8 4.8 36.4 37 25.4 70.3 42.5 60.3 66.9zM207.4 159.9c.9-44-37.9-42.2-78.6-40.3-21.7 1-38.9 1.9-45.5 13.9-11.4 20.9 5.9 92.9 23.2 101.2 9.8 4.7 73.4 7.9 86.3-7.1 8.2-9.4 15-49.4 14.6-67.7zm52 58.3c-4.3-12.4-6-30.1-15.3-32.7-2-.5-9-.5-11 0-10 2.8-10.8 22.1-17 37.2 15.4 0 19.3 9.7 23.7 9.7 4.3 0 6.3-11.3 19.6-14.2zm135.7-84.7c-6.6-12.1-24.8-12.9-46.5-13.9-40.2-1.9-78.2-3.8-77.3 40.3-.5 18.3 5 58.3 13.2 67.8 13 14.9 76.6 11.8 86.3 7.1 15.8-7.6 36.5-78.9 24.3-101.3z"
    ]
};
var $ef0249c5e48bf4e3$export$83b68077d321f3ad = {
    prefix: "fab",
    iconName: "trade-federation",
    icon: [
        496,
        512,
        [],
        "f513",
        "M248 8.8c-137 0-248 111-248 248s111 248 248 248 248-111 248-248-111-248-248-248zm0 482.8c-129.7 0-234.8-105.1-234.8-234.8S118.3 22 248 22s234.8 105.1 234.8 234.8S377.7 491.6 248 491.6zm155.1-328.5v-46.8H209.3V198H54.2l36.7 46h117.7v196.8h48.8V245h83.3v-47h-83.3v-34.8h145.7zm-73.3 45.1v23.9h-82.9v197.4h-26.8V232.1H96.3l-20.1-23.9h143.9v-80.6h171.8V152h-145v56.2zm-161.3-69l-12.4-20.7 2.1 23.8-23.5 5.4 23.3 5.4-2.1 24 12.3-20.5 22.2 9.5-15.7-18.1 15.8-18.1zm-29.6-19.7l9.3-11.5-12.7 5.9-8-12.4 1.7 13.9-14.3 3.8 13.7 2.7-.8 14.7 6.8-12.2 13.8 5.3zm165.4 145.2l-13.1 5.6-7.3-12.2 1.3 14.2-13.9 3.2 13.9 3.2-1.2 14.2 7.3-12.2 13.1 5.5-9.4-10.7zm106.9-77.2l-20.9 9.1-12-19.6 2.2 22.7-22.3 5.4 22.2 4.9-1.8 22.9 11.5-19.6 21.2 8.8-15.1-17zM248 29.9c-125.3 0-226.9 101.6-226.9 226.9S122.7 483.7 248 483.7s226.9-101.6 226.9-226.9S373.3 29.9 248 29.9zM342.6 196v51h-83.3v195.7h-52.7V245.9H89.9l-40-49.9h157.4v-81.6h197.8v50.7H259.4V196zM248 43.2c60.3 0 114.8 25 153.6 65.2H202.5V190H45.1C73.1 104.8 153.4 43.2 248 43.2zm0 427.1c-117.9 0-213.6-95.6-213.6-213.5 0-21.2 3.1-41.8 8.9-61.1L87.1 252h114.7v196.8h64.6V253h83.3v-62.7h-83.2v-19.2h145.6v-50.8c30.8 37 49.3 84.6 49.3 136.5.1 117.9-95.5 213.5-213.4 213.5zM178.8 275l-11-21.4 1.7 24.5-23.7 3.9 23.8 5.9-3.7 23.8 13-20.9 21.5 10.8-15.8-18.8 16.9-17.1z"
    ]
};
var $ef0249c5e48bf4e3$export$2ea4e300aa12cd0a = {
    prefix: "fab",
    iconName: "autoprefixer",
    icon: [
        640,
        512,
        [],
        "f41c",
        "M318.4 16l-161 480h77.5l25.4-81.4h119.5L405 496h77.5L318.4 16zm-40.3 341.9l41.2-130.4h1.5l40.9 130.4h-83.6zM640 405l-10-31.4L462.1 358l19.4 56.5L640 405zm-462.1-47L10 373.7 0 405l158.5 9.4 19.4-56.4z"
    ]
};
var $ef0249c5e48bf4e3$export$45bdf388845cdf99 = {
    prefix: "fab",
    iconName: "whatsapp",
    icon: [
        448,
        512,
        [],
        "f232",
        "M380.9 97.1C339 55.1 283.2 32 223.9 32c-122.4 0-222 99.6-222 222 0 39.1 10.2 77.3 29.6 111L0 480l117.7-30.9c32.4 17.7 68.9 27 106.1 27h.1c122.3 0 224.1-99.6 224.1-222 0-59.3-25.2-115-67.1-157zm-157 341.6c-33.2 0-65.7-8.9-94-25.7l-6.7-4-69.8 18.3L72 359.2l-4.4-7c-18.5-29.4-28.2-63.3-28.2-98.2 0-101.7 82.8-184.5 184.6-184.5 49.3 0 95.6 19.2 130.4 54.1 34.8 34.9 56.2 81.2 56.1 130.5 0 101.8-84.9 184.6-186.6 184.6zm101.2-138.2c-5.5-2.8-32.8-16.2-37.9-18-5.1-1.9-8.8-2.8-12.5 2.8-3.7 5.6-14.3 18-17.6 21.8-3.2 3.7-6.5 4.2-12 1.4-32.6-16.3-54-29.1-75.5-66-5.7-9.8 5.7-9.1 16.3-30.3 1.8-3.7.9-6.9-.5-9.7-1.4-2.8-12.5-30.1-17.1-41.2-4.5-10.8-9.1-9.3-12.5-9.5-3.2-.2-6.9-.2-10.6-.2-3.7 0-9.7 1.4-14.8 6.9-5.1 5.6-19.4 19-19.4 46.3 0 27.3 19.9 53.7 22.6 57.4 2.8 3.7 39.1 59.7 94.8 83.8 35.2 15.2 49 16.5 66.6 13.9 10.7-1.6 32.8-13.4 37.4-26.4 4.6-13 4.6-24.1 3.2-26.4-1.3-2.5-5-3.9-10.5-6.6z"
    ]
};
var $ef0249c5e48bf4e3$export$4dcd48fd9c0bdd2d = {
    prefix: "fab",
    iconName: "slideshare",
    icon: [
        512,
        512,
        [],
        "f1e7",
        "M187.7 153.7c-34 0-61.7 25.7-61.7 57.7 0 31.7 27.7 57.7 61.7 57.7s61.7-26 61.7-57.7c0-32-27.7-57.7-61.7-57.7zm143.4 0c-34 0-61.7 25.7-61.7 57.7 0 31.7 27.7 57.7 61.7 57.7 34.3 0 61.7-26 61.7-57.7.1-32-27.4-57.7-61.7-57.7zm156.6 90l-6 4.3V49.7c0-27.4-20.6-49.7-46-49.7H76.6c-25.4 0-46 22.3-46 49.7V248c-2-1.4-4.3-2.9-6.3-4.3-15.1-10.6-25.1 4-16 17.7 18.3 22.6 53.1 50.3 106.3 72C58.3 525.1 252 555.7 248.9 457.5c0-.7.3-56.6.3-96.6 5.1 1.1 9.4 2.3 13.7 3.1 0 39.7.3 92.8.3 93.5-3.1 98.3 190.6 67.7 134.3-124 53.1-21.7 88-49.4 106.3-72 9.1-13.8-.9-28.3-16.1-17.8zm-30.5 19.2c-68.9 37.4-128.3 31.1-160.6 29.7-23.7-.9-32.6 9.1-33.7 24.9-10.3-7.7-18.6-15.5-20.3-17.1-5.1-5.4-13.7-8-27.1-7.7-31.7 1.1-89.7 7.4-157.4-28V72.3c0-34.9 8.9-45.7 40.6-45.7h317.7c30.3 0 40.9 12.9 40.9 45.7v190.6z"
    ]
};
var $ef0249c5e48bf4e3$export$cfa707f90d6b79ec = {
    prefix: "fab",
    iconName: "google-play",
    icon: [
        512,
        512,
        [],
        "f3ab",
        "M325.3 234.3L104.6 13l280.8 161.2-60.1 60.1zM47 0C34 6.8 25.3 19.2 25.3 35.3v441.3c0 16.1 8.7 28.5 21.7 35.3l256.6-256L47 0zm425.2 225.6l-58.9-34.1-65.7 64.5 65.7 64.5 60.1-34.1c18-14.3 18-46.5-1.2-60.8zM104.6 499l280.8-161.2-60.1-60.1L104.6 499z"
    ]
};
var $ef0249c5e48bf4e3$export$6f9febfcc8ac97d4 = {
    prefix: "fab",
    iconName: "viadeo",
    icon: [
        448,
        512,
        [],
        "f2a9",
        "M276.2 150.5v.7C258.3 98.6 233.6 47.8 205.4 0c43.3 29.2 67 100 70.8 150.5zm32.7 121.7c7.6 18.2 11 37.5 11 57 0 77.7-57.8 141-137.8 139.4l3.8-.3c74.2-46.7 109.3-118.6 109.3-205.1 0-38.1-6.5-75.9-18.9-112 1 11.7 1 23.7 1 35.4 0 91.8-18.1 241.6-116.6 280C95 455.2 49.4 398 49.4 329.2c0-75.6 57.4-142.3 135.4-142.3 16.8 0 33.7 3.1 49.1 9.6 1.7-15.1 6.5-29.9 13.4-43.3-19.9-7.2-41.2-10.7-62.5-10.7-161.5 0-238.7 195.9-129.9 313.7 67.9 74.6 192 73.9 259.8 0 56.6-61.3 60.9-142.4 36.4-201-12.7 8-27.1 13.9-42.2 17zM418.1 11.7c-31 66.5-81.3 47.2-115.8 80.1-12.4 12-20.6 34-20.6 50.5 0 14.1 4.5 27.1 12 38.8 47.4-11 98.3-46 118.2-90.7-.7 5.5-4.8 14.4-7.2 19.2-20.3 35.7-64.6 65.6-99.7 84.9 14.8 14.4 33.7 25.8 55 25.8 79 0 110.1-134.6 58.1-208.6z"
    ]
};
var $ef0249c5e48bf4e3$export$c5b04bbf0f48913a = {
    prefix: "fab",
    iconName: "line",
    icon: [
        512,
        512,
        [],
        "f3c0",
        "M311 196.8v81.3c0 2.1-1.6 3.7-3.7 3.7h-13c-1.3 0-2.4-.7-3-1.5l-37.3-50.3v48.2c0 2.1-1.6 3.7-3.7 3.7h-13c-2.1 0-3.7-1.6-3.7-3.7V196.9c0-2.1 1.6-3.7 3.7-3.7h12.9c1.1 0 2.4 .6 3 1.6l37.3 50.3V196.9c0-2.1 1.6-3.7 3.7-3.7h13c2.1-.1 3.8 1.6 3.8 3.5zm-93.7-3.7h-13c-2.1 0-3.7 1.6-3.7 3.7v81.3c0 2.1 1.6 3.7 3.7 3.7h13c2.1 0 3.7-1.6 3.7-3.7V196.8c0-1.9-1.6-3.7-3.7-3.7zm-31.4 68.1H150.3V196.8c0-2.1-1.6-3.7-3.7-3.7h-13c-2.1 0-3.7 1.6-3.7 3.7v81.3c0 1 .3 1.8 1 2.5c.7 .6 1.5 1 2.5 1h52.2c2.1 0 3.7-1.6 3.7-3.7v-13c0-1.9-1.6-3.7-3.5-3.7zm193.7-68.1H327.3c-1.9 0-3.7 1.6-3.7 3.7v81.3c0 1.9 1.6 3.7 3.7 3.7h52.2c2.1 0 3.7-1.6 3.7-3.7V265c0-2.1-1.6-3.7-3.7-3.7H344V247.7h35.5c2.1 0 3.7-1.6 3.7-3.7V230.9c0-2.1-1.6-3.7-3.7-3.7H344V213.5h35.5c2.1 0 3.7-1.6 3.7-3.7v-13c-.1-1.9-1.7-3.7-3.7-3.7zM512 93.4V419.4c-.1 51.2-42.1 92.7-93.4 92.6H92.6C41.4 511.9-.1 469.8 0 418.6V92.6C.1 41.4 42.2-.1 93.4 0H419.4c51.2 .1 92.7 42.1 92.6 93.4zM441.6 233.5c0-83.4-83.7-151.3-186.4-151.3s-186.4 67.9-186.4 151.3c0 74.7 66.3 137.4 155.9 149.3c21.8 4.7 19.3 12.7 14.4 42.1c-.8 4.7-3.8 18.4 16.1 10.1s107.3-63.2 146.5-108.2c27-29.7 39.9-59.8 39.9-93.1z"
    ]
};
var $ef0249c5e48bf4e3$export$631c05505a17faa8 = {
    prefix: "fab",
    iconName: "google-drive",
    icon: [
        512,
        512,
        [],
        "f3aa",
        "M339 314.9L175.4 32h161.2l163.6 282.9H339zm-137.5 23.6L120.9 480h310.5L512 338.5H201.5zM154.1 67.4L0 338.5 80.6 480 237 208.8 154.1 67.4z"
    ]
};
var $ef0249c5e48bf4e3$export$c2417738aeefe7e6 = {
    prefix: "fab",
    iconName: "servicestack",
    icon: [
        496,
        512,
        [],
        "f3ec",
        "M88 216c81.7 10.2 273.7 102.3 304 232H0c99.5-8.1 184.5-137 88-232zm32-152c32.3 35.6 47.7 83.9 46.4 133.6C249.3 231.3 373.7 321.3 400 448h96C455.3 231.9 222.8 79.5 120 64z"
    ]
};
var $ef0249c5e48bf4e3$export$8b48c2e6e01a12e0 = {
    prefix: "fab",
    iconName: "simplybuilt",
    icon: [
        512,
        512,
        [],
        "f215",
        "M481.2 64h-106c-14.5 0-26.6 11.8-26.6 26.3v39.6H163.3V90.3c0-14.5-12-26.3-26.6-26.3h-106C16.1 64 4.3 75.8 4.3 90.3v331.4c0 14.5 11.8 26.3 26.6 26.3h450.4c14.8 0 26.6-11.8 26.6-26.3V90.3c-.2-14.5-12-26.3-26.7-26.3zM149.8 355.8c-36.6 0-66.4-29.7-66.4-66.4 0-36.9 29.7-66.6 66.4-66.6 36.9 0 66.6 29.7 66.6 66.6 0 36.7-29.7 66.4-66.6 66.4zm212.4 0c-36.9 0-66.6-29.7-66.6-66.6 0-36.6 29.7-66.4 66.6-66.4 36.6 0 66.4 29.7 66.4 66.4 0 36.9-29.8 66.6-66.4 66.6z"
    ]
};
var $ef0249c5e48bf4e3$export$de75f8fcf71dfed9 = {
    prefix: "fab",
    iconName: "bitbucket",
    icon: [
        512,
        512,
        [
            61810
        ],
        "f171",
        "M22.2 32A16 16 0 0 0 6 47.8a26.35 26.35 0 0 0 .2 2.8l67.9 412.1a21.77 21.77 0 0 0 21.3 18.2h325.7a16 16 0 0 0 16-13.4L505 50.7a16 16 0 0 0-13.2-18.3 24.58 24.58 0 0 0-2.8-.2L22.2 32zm285.9 297.8h-104l-28.1-147h157.3l-25.2 147z"
    ]
};
var $ef0249c5e48bf4e3$export$c85bcd118a7a17ff = {
    prefix: "fab",
    iconName: "imdb",
    icon: [
        448,
        512,
        [],
        "f2d8",
        "M89.5 323.6H53.93V186.2H89.5V323.6zM156.1 250.5L165.2 186.2H211.5V323.6H180.5V230.9L167.1 323.6H145.8L132.8 232.9L132.7 323.6H101.5V186.2H147.6C148.1 194.5 150.4 204.3 151.9 215.6L156.1 250.5zM223.7 323.6V186.2H250.3C267.3 186.2 277.3 187.1 283.3 188.6C289.4 190.3 294 192.8 297.2 196.5C300.3 199.8 302.3 203.1 303 208.5C303.9 212.9 304.4 221.6 304.4 234.7V282.9C304.4 295.2 303.7 303.4 302.5 307.6C301.4 311.7 299.4 315 296.5 317.3C293.7 319.7 290.1 321.4 285.8 322.3C281.6 323.1 275.2 323.6 266.7 323.6H223.7zM259.2 209.7V299.1C264.3 299.1 267.5 298.1 268.6 296.8C269.7 294.8 270.4 289.2 270.4 280.1V226.8C270.4 220.6 270.3 216.6 269.7 214.8C269.4 213 268.5 211.8 267.1 210.1C265.7 210.1 263 209.7 259.2 209.7V209.7zM316.5 323.6V186.2H350.6V230.1C353.5 227.7 356.7 225.2 360.1 223.5C363.7 222 368.9 221.1 372.9 221.1C377.7 221.1 381.8 221.9 385.2 223.3C388.6 224.8 391.2 226.8 393.2 229.5C394.9 232.1 395.9 234.8 396.3 237.3C396.7 239.9 396.1 245.3 396.1 253.5V292.1C396.1 300.3 396.3 306.4 395.3 310.5C394.2 314.5 391.5 318.1 387.5 320.1C383.4 324 378.6 325.4 372.9 325.4C368.9 325.4 363.7 324.5 360.2 322.9C356.7 321.1 353.5 318.4 350.6 314.9L348.5 323.6L316.5 323.6zM361.6 302.9C362.3 301.1 362.6 296.9 362.6 290.4V255C362.6 249.4 362.3 245.5 361.5 243.8C360.8 241.9 357.8 241.1 355.7 241.1C353.7 241.1 352.3 241.9 351.6 243.4C351 244.9 350.6 248.8 350.6 255V291.4C350.6 297.5 351 301.4 351.8 303C352.4 304.7 353.9 305.5 355.9 305.5C358.1 305.5 360.1 304.7 361.6 302.9L361.6 302.9zM418.4 32.04C434.1 33.27 447.1 47.28 447.1 63.92V448.1C447.1 464.5 435.2 478.5 418.9 479.1C418.6 479.1 418.4 480 418.1 480H29.88C29.6 480 29.32 479.1 29.04 479.9C13.31 478.5 1.093 466.1 0 449.7L.0186 61.78C1.081 45.88 13.82 33.09 30.26 31.1H417.7C417.9 31.1 418.2 32.01 418.4 32.04L418.4 32.04zM30.27 41.26C19 42.01 10.02 51.01 9.257 62.4V449.7C9.63 455.1 11.91 460.2 15.7 464C19.48 467.9 24.51 470.3 29.89 470.7H418.1C429.6 469.7 438.7 459.1 438.7 448.1V63.91C438.7 58.17 436.6 52.65 432.7 48.45C428.8 44.24 423.4 41.67 417.7 41.26L30.27 41.26z"
    ]
};
var $ef0249c5e48bf4e3$export$17ab471305a2654c = {
    prefix: "fab",
    iconName: "deezer",
    icon: [
        576,
        512,
        [],
        "e077",
        "M451.46,244.71H576V172H451.46Zm0-173.89v72.67H576V70.82Zm0,275.06H576V273.2H451.46ZM0,447.09H124.54V374.42H0Zm150.47,0H275V374.42H150.47Zm150.52,0H425.53V374.42H301Zm150.47,0H576V374.42H451.46ZM301,345.88H425.53V273.2H301Zm-150.52,0H275V273.2H150.47Zm0-101.17H275V172H150.47Z"
    ]
};
var $ef0249c5e48bf4e3$export$910e018904f54b08 = {
    prefix: "fab",
    iconName: "raspberry-pi",
    icon: [
        407,
        512,
        [],
        "f7bb",
        "M372 232.5l-3.7-6.5c.1-46.4-21.4-65.3-46.5-79.7 7.6-2 15.4-3.6 17.6-13.2 13.1-3.3 15.8-9.4 17.1-15.8 3.4-2.3 14.8-8.7 13.6-19.7 6.4-4.4 10-10.1 8.1-18.1 6.9-7.5 8.7-13.7 5.8-19.4 8.3-10.3 4.6-15.6 1.1-20.9 6.2-11.2.7-23.2-16.6-21.2-6.9-10.1-21.9-7.8-24.2-7.8-2.6-3.2-6-6-16.5-4.7-6.8-6.1-14.4-5-22.3-2.1-9.3-7.3-15.5-1.4-22.6.8C271.6.6 269 5.5 263.5 7.6c-12.3-2.6-16.1 3-22 8.9l-6.9-.1c-18.6 10.8-27.8 32.8-31.1 44.1-3.3-11.3-12.5-33.3-31.1-44.1l-6.9.1c-5.9-5.9-9.7-11.5-22-8.9-5.6-2-8.1-7-19.4-3.4-4.6-1.4-8.9-4.4-13.9-4.3-2.6.1-5.5 1-8.7 3.5-7.9-3-15.5-4-22.3 2.1-10.5-1.3-14 1.4-16.5 4.7-2.3 0-17.3-2.3-24.2 7.8C21.2 16 15.8 28 22 39.2c-3.5 5.4-7.2 10.7 1.1 20.9-2.9 5.7-1.1 11.9 5.8 19.4-1.8 8 1.8 13.7 8.1 18.1-1.2 11 10.2 17.4 13.6 19.7 1.3 6.4 4 12.4 17.1 15.8 2.2 9.5 10 11.2 17.6 13.2-25.1 14.4-46.6 33.3-46.5 79.7l-3.7 6.5c-28.8 17.2-54.7 72.7-14.2 117.7 2.6 14.1 7.1 24.2 11 35.4 5.9 45.2 44.5 66.3 54.6 68.8 14.9 11.2 30.8 21.8 52.2 29.2C159 504.2 181 512 203 512h1c22.1 0 44-7.8 64.2-28.4 21.5-7.4 37.3-18 52.2-29.2 10.2-2.5 48.7-23.6 54.6-68.8 3.9-11.2 8.4-21.3 11-35.4 40.6-45.1 14.7-100.5-14-117.7zm-22.2-8c-1.5 18.7-98.9-65.1-82.1-67.9 45.7-7.5 83.6 19.2 82.1 67.9zm-43 93.1c-24.5 15.8-59.8 5.6-78.8-22.8s-14.6-64.2 9.9-80c24.5-15.8 59.8-5.6 78.8 22.8s14.6 64.2-9.9 80zM238.9 29.3c.8 4.2 1.8 6.8 2.9 7.6 5.4-5.8 9.8-11.7 16.8-17.3 0 3.3-1.7 6.8 2.5 9.4 3.7-5 8.8-9.5 15.5-13.3-3.2 5.6-.6 7.3 1.2 9.6 5.1-4.4 10-8.8 19.4-12.3-2.6 3.1-6.2 6.2-2.4 9.8 5.3-3.3 10.6-6.6 23.1-8.9-2.8 3.1-8.7 6.3-5.1 9.4 6.6-2.5 14-4.4 22.1-5.4-3.9 3.2-7.1 6.3-3.9 8.8 7.1-2.2 16.9-5.1 26.4-2.6l-6 6.1c-.7.8 14.1.6 23.9.8-3.6 5-7.2 9.7-9.3 18.2 1 1 5.8.4 10.4 0-4.7 9.9-12.8 12.3-14.7 16.6 2.9 2.2 6.8 1.6 11.2.1-3.4 6.9-10.4 11.7-16 17.3 1.4 1 3.9 1.6 9.7.9-5.2 5.5-11.4 10.5-18.8 15 1.3 1.5 5.8 1.5 10 1.6-6.7 6.5-15.3 9.9-23.4 14.2 4 2.7 6.9 2.1 10 2.1-5.7 4.7-15.4 7.1-24.4 10 1.7 2.7 3.4 3.4 7.1 4.1-9.5 5.3-23.2 2.9-27 5.6.9 2.7 3.6 4.4 6.7 5.8-15.4.9-57.3-.6-65.4-32.3 15.7-17.3 44.4-37.5 93.7-62.6-38.4 12.8-73 30-102 53.5-34.3-15.9-10.8-55.9 5.8-71.8zm-34.4 114.6c24.2-.3 54.1 17.8 54 34.7-.1 15-21 27.1-53.8 26.9-32.1-.4-53.7-15.2-53.6-29.8 0-11.9 26.2-32.5 53.4-31.8zm-123-12.8c3.7-.7 5.4-1.5 7.1-4.1-9-2.8-18.7-5.3-24.4-10 3.1 0 6 .7 10-2.1-8.1-4.3-16.7-7.7-23.4-14.2 4.2-.1 8.7 0 10-1.6-7.4-4.5-13.6-9.5-18.8-15 5.8.7 8.3.1 9.7-.9-5.6-5.6-12.7-10.4-16-17.3 4.3 1.5 8.3 2 11.2-.1-1.9-4.2-10-6.7-14.7-16.6 4.6.4 9.4 1 10.4 0-2.1-8.5-5.8-13.3-9.3-18.2 9.8-.1 24.6 0 23.9-.8l-6-6.1c9.5-2.5 19.3.4 26.4 2.6 3.2-2.5-.1-5.6-3.9-8.8 8.1 1.1 15.4 2.9 22.1 5.4 3.5-3.1-2.3-6.3-5.1-9.4 12.5 2.3 17.8 5.6 23.1 8.9 3.8-3.6.2-6.7-2.4-9.8 9.4 3.4 14.3 7.9 19.4 12.3 1.7-2.3 4.4-4 1.2-9.6 6.7 3.8 11.8 8.3 15.5 13.3 4.1-2.6 2.5-6.2 2.5-9.4 7 5.6 11.4 11.5 16.8 17.3 1.1-.8 2-3.4 2.9-7.6 16.6 15.9 40.1 55.9 6 71.8-29-23.5-63.6-40.7-102-53.5 49.3 25 78 45.3 93.7 62.6-8 31.8-50 33.2-65.4 32.3 3.1-1.4 5.8-3.2 6.7-5.8-4-2.8-17.6-.4-27.2-5.6zm60.1 24.1c16.8 2.8-80.6 86.5-82.1 67.9-1.5-48.7 36.5-75.5 82.1-67.9zM38.2 342c-23.7-18.8-31.3-73.7 12.6-98.3 26.5-7 9 107.8-12.6 98.3zm91 98.2c-13.3 7.9-45.8 4.7-68.8-27.9-15.5-27.4-13.5-55.2-2.6-63.4 16.3-9.8 41.5 3.4 60.9 25.6 16.9 20 24.6 55.3 10.5 65.7zm-26.4-119.7c-24.5-15.8-28.9-51.6-9.9-80s54.3-38.6 78.8-22.8 28.9 51.6 9.9 80c-19.1 28.4-54.4 38.6-78.8 22.8zM205 496c-29.4 1.2-58.2-23.7-57.8-32.3-.4-12.7 35.8-22.6 59.3-22 23.7-1 55.6 7.5 55.7 18.9.5 11-28.8 35.9-57.2 35.4zm58.9-124.9c.2 29.7-26.2 53.8-58.8 54-32.6.2-59.2-23.8-59.4-53.4v-.6c-.2-29.7 26.2-53.8 58.8-54 32.6-.2 59.2 23.8 59.4 53.4v.6zm82.2 42.7c-25.3 34.6-59.6 35.9-72.3 26.3-13.3-12.4-3.2-50.9 15.1-72 20.9-23.3 43.3-38.5 58.9-26.6 10.5 10.3 16.7 49.1-1.7 72.3zm22.9-73.2c-21.5 9.4-39-105.3-12.6-98.3 43.9 24.7 36.3 79.6 12.6 98.3z"
    ]
};
var $ef0249c5e48bf4e3$export$78c2aea9064d90bd = {
    prefix: "fab",
    iconName: "jira",
    icon: [
        496,
        512,
        [],
        "f7b1",
        "M490 241.7C417.1 169 320.6 71.8 248.5 0 83 164.9 6 241.7 6 241.7c-7.9 7.9-7.9 20.7 0 28.7C138.8 402.7 67.8 331.9 248.5 512c379.4-378 15.7-16.7 241.5-241.7 8-7.9 8-20.7 0-28.6zm-241.5 90l-76-75.7 76-75.7 76 75.7-76 75.7z"
    ]
};
var $ef0249c5e48bf4e3$export$b29e4ebead927988 = {
    prefix: "fab",
    iconName: "docker",
    icon: [
        640,
        512,
        [],
        "f395",
        "M349.9 236.3h-66.1v-59.4h66.1v59.4zm0-204.3h-66.1v60.7h66.1V32zm78.2 144.8H362v59.4h66.1v-59.4zm-156.3-72.1h-66.1v60.1h66.1v-60.1zm78.1 0h-66.1v60.1h66.1v-60.1zm276.8 100c-14.4-9.7-47.6-13.2-73.1-8.4-3.3-24-16.7-44.9-41.1-63.7l-14-9.3-9.3 14c-18.4 27.8-23.4 73.6-3.7 103.8-8.7 4.7-25.8 11.1-48.4 10.7H2.4c-8.7 50.8 5.8 116.8 44 162.1 37.1 43.9 92.7 66.2 165.4 66.2 157.4 0 273.9-72.5 328.4-204.2 21.4.4 67.6.1 91.3-45.2 1.5-2.5 6.6-13.2 8.5-17.1l-13.3-8.9zm-511.1-27.9h-66v59.4h66.1v-59.4zm78.1 0h-66.1v59.4h66.1v-59.4zm78.1 0h-66.1v59.4h66.1v-59.4zm-78.1-72.1h-66.1v60.1h66.1v-60.1z"
    ]
};
var $ef0249c5e48bf4e3$export$63c4c3c3c5975c3e = {
    prefix: "fab",
    iconName: "screenpal",
    icon: [
        512,
        512,
        [],
        "e570",
        "M233.5 22.49C233.5 10.07 243.6 0 256 0C268.4 0 278.5 10.07 278.5 22.49C278.5 34.91 268.4 44.98 256 44.98C243.6 44.98 233.5 34.91 233.5 22.49zM313.4 259C313.4 290.7 287.7 316.4 256 316.4C224.3 316.4 198.6 290.7 198.6 259C198.6 227.3 224.3 201.6 256 201.6C287.7 201.6 313.4 227.3 313.4 259zM337.2 350C359.5 330.1 373.7 302.7 377.1 273H496.6C493.1 334.4 466.2 392.2 421.4 434.4C376.7 476.6 317.5 500.2 256 500.2C194.5 500.2 135.3 476.6 90.56 434.4C45.83 392.2 18.94 334.4 15.39 273H135.1C138.5 302.7 152.7 330.1 175 350C197.3 369.9 226.2 380.9 256.1 380.9C285.1 380.9 314.8 369.9 337.2 350zM73.14 140.3C73.54 152.7 63.81 163.1 51.39 163.5C38.97 163.9 28.59 154.2 28.18 141.8C27.78 129.3 37.52 118.9 49.94 118.5C62.35 118.1 72.74 127.9 73.14 140.3zM438.9 141C438.9 128.6 448.9 118.5 461.4 118.5C473.8 118.5 483.8 128.6 483.8 141C483.8 153.5 473.8 163.5 461.4 163.5C448.9 163.5 438.9 153.5 438.9 141zM317.9 95.27C300.6 109.1 278.7 118.1 256 118.1C233.3 118.1 211.4 109.1 194.1 95.27C176.8 80.55 165.3 60.18 161.7 37.78C176.8 31.37 192.5 26.52 208.6 23.31C208.6 35.88 213.6 47.93 222.5 56.82C231.4 65.7 243.4 70.7 256 70.7C268.6 70.7 280.6 65.7 289.5 56.82C298.4 47.93 303.4 35.88 303.4 23.31C319.5 26.52 335.2 31.37 350.3 37.78C346.7 60.18 335.2 80.55 317.9 95.27H317.9zM82.78 231C61.42 238.6 38.06 238.4 16.86 230.4C18.82 214.1 22.46 198.1 27.71 182.5C33.1 185.6 39.05 187.6 45.22 188.5C51.39 189.3 57.67 188.9 63.68 187.3C69.69 185.6 75.33 182.9 80.27 179.1C85.21 175.3 89.36 170.6 92.47 165.2C95.58 159.8 97.61 153.8 98.42 147.7C99.23 141.5 98.83 135.2 97.22 129.2C95.61 123.2 92.83 117.6 89.04 112.6C85.25 107.7 80.53 103.5 75.14 100.4C85.96 88.11 98.01 76.94 111.1 67.07C128.7 81.42 140.6 101.6 144.7 123.9C148.8 146.2 144.8 169.3 133.5 188.9C122.1 208.5 104.1 223.4 82.78 231V231zM429.2 231.1C407.9 223.5 389.9 208.5 378.5 188.9C367.2 169.3 363.3 146.2 367.4 123.9C371.5 101.7 383.4 81.54 400.9 67.19C414 77.04 426.1 88.21 436.9 100.5C426.2 106.9 418.5 117.2 415.4 129.3C412.2 141.3 413.1 154.1 420.2 164.9C426.4 175.7 436.6 183.6 448.6 186.9C460.6 190.2 473.5 188.6 484.3 182.6C489.6 198.1 493.2 214.2 495.2 230.4C473.1 238.5 450.6 238.7 429.2 231.1L429.2 231.1z"
    ]
};
var $ef0249c5e48bf4e3$export$f77d9ddfdff1e2a7 = {
    prefix: "fab",
    iconName: "bluetooth",
    icon: [
        448,
        512,
        [],
        "f293",
        "M292.6 171.1L249.7 214l-.3-86 43.2 43.1m-43.2 219.8l43.1-43.1-42.9-42.9-.2 86zM416 259.4C416 465 344.1 512 230.9 512S32 465 32 259.4 115.4 0 228.6 0 416 53.9 416 259.4zm-158.5 0l79.4-88.6L211.8 36.5v176.9L138 139.6l-27 26.9 92.7 93-92.7 93 26.9 26.9 73.8-73.8 2.3 170 127.4-127.5-83.9-88.7z"
    ]
};
var $ef0249c5e48bf4e3$export$56aff378d7858517 = {
    prefix: "fab",
    iconName: "gitter",
    icon: [
        384,
        512,
        [],
        "f426",
        "M66.4 322.5H16V0h50.4v322.5zM166.9 76.1h-50.4V512h50.4V76.1zm100.6 0h-50.4V512h50.4V76.1zM368 76h-50.4v247H368V76z"
    ]
};
var $ef0249c5e48bf4e3$export$8fb5b89b3d7583de = {
    prefix: "fab",
    iconName: "d-and-d",
    icon: [
        576,
        512,
        [],
        "f38d",
        "M82.5 98.9c-.6-17.2 2-33.8 12.7-48.2.3 7.4 1.2 14.5 4.2 21.6 5.9-27.5 19.7-49.3 42.3-65.5-1.9 5.9-3.5 11.8-3 17.7 8.7-7.4 18.8-17.8 44.4-22.7 14.7-2.8 29.7-2 42.1 1 38.5 9.3 61 34.3 69.7 72.3 5.3 23.1.7 45-8.3 66.4-5.2 12.4-12 24.4-20.7 35.1-2-1.9-3.9-3.8-5.8-5.6-42.8-40.8-26.8-25.2-37.4-37.4-1.1-1.2-1-2.2-.1-3.6 8.3-13.5 11.8-28.2 10-44-1.1-9.8-4.3-18.9-11.3-26.2-14.5-15.3-39.2-15-53.5.6-11.4 12.5-14.1 27.4-10.9 43.6.2 1.3.4 2.7 0 3.9-3.4 13.7-4.6 27.6-2.5 41.6.1.5.1 1.1.1 1.6 0 .3-.1.5-.2 1.1-21.8-11-36-28.3-43.2-52.2-8.3 17.8-11.1 35.5-6.6 54.1-15.6-15.2-21.3-34.3-22-55.2zm469.6 123.2c-11.6-11.6-25-20.4-40.1-26.6-12.8-5.2-26-7.9-39.9-7.1-10 .6-19.6 3.1-29 6.4-2.5.9-5.1 1.6-7.7 2.2-4.9 1.2-7.3-3.1-4.7-6.8 3.2-4.6 3.4-4.2 15-12 .6-.4 1.2-.8 2.2-1.5h-2.5c-.6 0-1.2.2-1.9.3-19.3 3.3-30.7 15.5-48.9 29.6-10.4 8.1-13.8 3.8-12-.5 1.4-3.5 3.3-6.7 5.1-10 1-1.8 2.3-3.4 3.5-5.1-.2-.2-.5-.3-.7-.5-27 18.3-46.7 42.4-57.7 73.3.3.3.7.6 1 .9.3-.6.5-1.2.9-1.7 10.4-12.1 22.8-21.8 36.6-29.8 18.2-10.6 37.5-18.3 58.7-20.2 4.3-.4 8.7-.1 13.1-.1-1.8.7-3.5.9-5.3 1.1-18.5 2.4-35.5 9-51.5 18.5-30.2 17.9-54.5 42.2-75.1 70.4-.3.4-.4.9-.7 1.3 14.5 5.3 24 17.3 36.1 25.6.2-.1.3-.2.4-.4l1.2-2.7c12.2-26.9 27-52.3 46.7-74.5 16.7-18.8 38-25.3 62.5-20 5.9 1.3 11.4 4.4 17.2 6.8 2.3-1.4 5.1-3.2 8-4.7 8.4-4.3 17.4-7 26.7-9 14.7-3.1 29.5-4.9 44.5-1.3v-.5c-.5-.4-1.2-.8-1.7-1.4zM316.7 397.6c-39.4-33-22.8-19.5-42.7-35.6-.8.9 0-.2-1.9 3-11.2 19.1-25.5 35.3-44 47.6-10.3 6.8-21.5 11.8-34.1 11.8-21.6 0-38.2-9.5-49.4-27.8-12-19.5-13.3-40.7-8.2-62.6 7.8-33.8 30.1-55.2 38.6-64.3-18.7-6.2-33 1.7-46.4 13.9.8-13.9 4.3-26.2 11.8-37.3-24.3 10.6-45.9 25-64.8 43.9-.3-5.8 5.4-43.7 5.6-44.7.3-2.7-.6-5.3-3-7.4-24.2 24.7-44.5 51.8-56.1 84.6 7.4-5.9 14.9-11.4 23.6-16.2-8.3 22.3-19.6 52.8-7.8 101.1 4.6 19 11.9 36.8 24.1 52.3 2.9 3.7 6.3 6.9 9.5 10.3.2-.2.4-.3.6-.5-1.4-7-2.2-14.1-1.5-21.9 2.2 3.2 3.9 6 5.9 8.6 12.6 16 28.7 27.4 47.2 35.6 25 11.3 51.1 13.3 77.9 8.6 54.9-9.7 90.7-48.6 116-98.8 1-1.8.6-2.9-.9-4.2zm172-46.4c-9.5-3.1-22.2-4.2-28.7-2.9 9.9 4 14.1 6.6 18.8 12 12.6 14.4 10.4 34.7-5.4 45.6-11.7 8.1-24.9 10.5-38.9 9.1-1.2-.1-2.3-.4-3-.6 2.8-3.7 6-7 8.1-10.8 9.4-16.8 5.4-42.1-8.7-56.1-2.1-2.1-4.6-3.9-7-5.9-.3 1.3-.1 2.1.1 2.8 4.2 16.6-8.1 32.4-24.8 31.8-7.6-.3-13.9-3.8-19.6-8.5-19.5-16.1-39.1-32.1-58.5-48.3-5.9-4.9-12.5-8.1-20.1-8.7-4.6-.4-9.3-.6-13.9-.9-5.9-.4-8.8-2.8-10.4-8.4-.9-3.4-1.5-6.8-2.2-10.2-1.5-8.1-6.2-13-14.3-14.2-4.4-.7-8.9-1-13.3-1.5-13-1.4-19.8-7.4-22.6-20.3-5 11-1.6 22.4 7.3 29.9 4.5 3.8 9.3 7.3 13.8 11.2 4.6 3.8 7.4 8.7 7.9 14.8.4 4.7.8 9.5 1.8 14.1 2.2 10.6 8.9 18.4 17 25.1 16.5 13.7 33 27.3 49.5 41.1 17.9 15 13.9 32.8 13 56-.9 22.9 12.2 42.9 33.5 51.2 1 .4 2 .6 3.6 1.1-15.7-18.2-10.1-44.1.7-52.3.3 2.2.4 4.3.9 6.4 9.4 44.1 45.4 64.2 85 56.9 16-2.9 30.6-8.9 42.9-19.8 2-1.8 3.7-4.1 5.9-6.5-19.3 4.6-35.8.1-50.9-10.6.7-.3 1.3-.3 1.9-.3 21.3 1.8 40.6-3.4 57-17.4 19.5-16.6 26.6-42.9 17.4-66-8.3-20.1-23.6-32.3-43.8-38.9zM99.4 179.3c-5.3-9.2-13.2-15.6-22.1-21.3 13.7-.5 26.6.2 39.6 3.7-7-12.2-8.5-24.7-5-38.7 5.3 11.9 13.7 20.1 23.6 26.8 19.7 13.2 35.7 19.6 46.7 30.2 3.4 3.3 6.3 7.1 9.6 10.9-.8-2.1-1.4-4.1-2.2-6-5-10.6-13-18.6-22.6-25-1.8-1.2-2.8-2.5-3.4-4.5-3.3-12.5-3-25.1-.7-37.6 1-5.5 2.8-10.9 4.5-16.3.8-2.4 2.3-4.6 4-6.6.6 6.9 0 25.5 19.6 46 10.8 11.3 22.4 21.9 33.9 32.7 9 8.5 18.3 16.7 25.5 26.8 1.1 1.6 2.2 3.3 3.8 4.7-5-13-14.2-24.1-24.2-33.8-9.6-9.3-19.4-18.4-29.2-27.4-3.3-3-4.6-6.7-5.1-10.9-1.2-10.4 0-20.6 4.3-30.2.5-1 1.1-2 1.9-3.3.5 4.2.6 7.9 1.4 11.6 4.8 23.1 20.4 36.3 49.3 63.5 10 9.4 19.3 19.2 25.6 31.6 4.8 9.3 7.3 19 5.7 29.6-.1.6.5 1.7 1.1 2 6.2 2.6 10 6.9 9.7 14.3 7.7-2.6 12.5-8 16.4-14.5 4.2 20.2-9.1 50.3-27.2 58.7.4-4.5 5-23.4-16.5-27.7-6.8-1.3-12.8-1.3-22.9-2.1 4.7-9 10.4-20.6.5-22.4-24.9-4.6-52.8 1.9-57.8 4.6 8.2.4 16.3 1 23.5 3.3-2 6.5-4 12.7-5.8 18.9-1.9 6.5 2.1 14.6 9.3 9.6 1.2-.9 2.3-1.9 3.3-2.7-3.1 17.9-2.9 15.9-2.8 18.3.3 10.2 9.5 7.8 15.7 7.3-2.5 11.8-29.5 27.3-45.4 25.8 7-4.7 12.7-10.3 15.9-17.9-6.5.8-12.9 1.6-19.2 2.4l-.3-.9c4.7-3.4 8-7.8 10.2-13.1 8.7-21.1-3.6-38-25-39.9-9.1-.8-17.8.8-25.9 5.5 6.2-15.6 17.2-26.6 32.6-34.5-15.2-4.3-8.9-2.7-24.6-6.3 14.6-9.3 30.2-13.2 46.5-14.6-5.2-3.2-48.1-3.6-70.2 20.9 7.9 1.4 15.5 2.8 23.2 4.2-23.8 7-44 19.7-62.4 35.6 1.1-4.8 2.7-9.5 3.3-14.3.6-4.5.8-9.2.1-13.6-1.5-9.4-8.9-15.1-19.7-16.3-7.9-.9-15.6.1-23.3 1.3-.9.1-1.7.3-2.9 0 15.8-14.8 36-21.7 53.1-33.5 6-4.5 6.8-8.2 3-14.9zm128.4 26.8c3.3 16 12.6 25.5 23.8 24.3-4.6-11.3-12.1-19.5-23.8-24.3z"
    ]
};
var $ef0249c5e48bf4e3$export$d5808a1a9747be4c = {
    prefix: "fab",
    iconName: "microblog",
    icon: [
        448,
        512,
        [],
        "e01a",
        "M399.36,362.23c29.49-34.69,47.1-78.34,47.1-125.79C446.46,123.49,346.86,32,224,32S1.54,123.49,1.54,236.44,101.14,440.87,224,440.87a239.28,239.28,0,0,0,79.44-13.44,7.18,7.18,0,0,1,8.12,2.56c18.58,25.09,47.61,42.74,79.89,49.92a4.42,4.42,0,0,0,5.22-3.43,4.37,4.37,0,0,0-.85-3.62,87,87,0,0,1,3.69-110.69ZM329.52,212.4l-57.3,43.49L293,324.75a6.5,6.5,0,0,1-9.94,7.22L224,290.92,164.94,332a6.51,6.51,0,0,1-9.95-7.22l20.79-68.86-57.3-43.49a6.5,6.5,0,0,1,3.8-11.68l71.88-1.51,23.66-67.92a6.5,6.5,0,0,1,12.28,0l23.66,67.92,71.88,1.51a6.5,6.5,0,0,1,3.88,11.68Z"
    ]
};
var $ef0249c5e48bf4e3$export$e24e559a44f492e1 = {
    prefix: "fab",
    iconName: "cc-diners-club",
    icon: [
        576,
        512,
        [],
        "f24c",
        "M239.7 79.9c-96.9 0-175.8 78.6-175.8 175.8 0 96.9 78.9 175.8 175.8 175.8 97.2 0 175.8-78.9 175.8-175.8 0-97.2-78.6-175.8-175.8-175.8zm-39.9 279.6c-41.7-15.9-71.4-56.4-71.4-103.8s29.7-87.9 71.4-104.1v207.9zm79.8.3V151.6c41.7 16.2 71.4 56.7 71.4 104.1s-29.7 87.9-71.4 104.1zM528 32H48C21.5 32 0 53.5 0 80v352c0 26.5 21.5 48 48 48h480c26.5 0 48-21.5 48-48V80c0-26.5-21.5-48-48-48zM329.7 448h-90.3c-106.2 0-193.8-85.5-193.8-190.2C45.6 143.2 133.2 64 239.4 64h90.3c105 0 200.7 79.2 200.7 193.8 0 104.7-95.7 190.2-200.7 190.2z"
    ]
};
var $ef0249c5e48bf4e3$export$6d2eed3a88c7ed1a = {
    prefix: "fab",
    iconName: "gg-circle",
    icon: [
        512,
        512,
        [],
        "f261",
        "M257 8C120 8 9 119 9 256s111 248 248 248 248-111 248-248S394 8 257 8zm-49.5 374.8L81.8 257.1l125.7-125.7 35.2 35.4-24.2 24.2-11.1-11.1-77.2 77.2 77.2 77.2 26.6-26.6-53.1-52.9 24.4-24.4 77.2 77.2-75 75.2zm99-2.2l-35.2-35.2 24.1-24.4 11.1 11.1 77.2-77.2-77.2-77.2-26.5 26.5 53.1 52.9-24.4 24.4-77.2-77.2 75-75L432.2 255 306.5 380.6z"
    ]
};
var $ef0249c5e48bf4e3$export$238a02799aabf743 = {
    prefix: "fab",
    iconName: "pied-piper-hat",
    icon: [
        640,
        512,
        [],
        "f4e5",
        "M640 24.9c-80.8 53.6-89.4 92.5-96.4 104.4-6.7 12.2-11.7 60.3-23.3 83.6-11.7 23.6-54.2 42.2-66.1 50-11.7 7.8-28.3 38.1-41.9 64.2-108.1-4.4-167.4 38.8-259.2 93.6 29.4-9.7 43.3-16.7 43.3-16.7 94.2-36 139.3-68.3 281.1-49.2 1.1 0 1.9.6 2.8.8 3.9 2.2 5.3 6.9 3.1 10.8l-53.9 95.8c-2.5 4.7-7.8 7.2-13.1 6.1-126.8-23.8-226.9 17.3-318.9 18.6C24.1 488 0 453.4 0 451.8c0-1.1.6-1.7 1.7-1.7 0 0 38.3 0 103.1-15.3C178.4 294.5 244 245.4 315.4 245.4c0 0 71.7 0 90.6 61.9 22.8-39.7 28.3-49.2 28.3-49.2 5.3-9.4 35-77.2 86.4-141.4 51.5-64 90.4-79.9 119.3-91.8z"
    ]
};
var $ef0249c5e48bf4e3$export$36ebae5de28f5e9e = {
    prefix: "fab",
    iconName: "kickstarter-k",
    icon: [
        384,
        512,
        [],
        "f3bc",
        "M147.3 114.4c0-56.2-32.5-82.4-73.4-82.4C26.2 32 0 68.2 0 113.4v283c0 47.3 25.3 83.4 74.9 83.4 39.8 0 72.4-25.6 72.4-83.4v-76.5l112.1 138.3c22.7 27.2 72.1 30.7 103.2 0 27-27.6 27.3-67.4 7.4-92.2l-90.8-114.8 74.9-107.4c17.4-24.7 17.5-63.1-10.4-89.8-30.3-29-82.4-31.6-113.6 12.8L147.3 185v-70.6z"
    ]
};
var $ef0249c5e48bf4e3$export$d51f17330f9046ea = {
    prefix: "fab",
    iconName: "yandex",
    icon: [
        256,
        512,
        [],
        "f413",
        "M153.1 315.8L65.7 512H2l96-209.8c-45.1-22.9-75.2-64.4-75.2-141.1C22.7 53.7 90.8 0 171.7 0H254v512h-55.1V315.8h-45.8zm45.8-269.3h-29.4c-44.4 0-87.4 29.4-87.4 114.6 0 82.3 39.4 108.8 87.4 108.8h29.4V46.5z"
    ]
};
var $ef0249c5e48bf4e3$export$7dcb0372cc290c0e = {
    prefix: "fab",
    iconName: "readme",
    icon: [
        576,
        512,
        [],
        "f4d5",
        "M528.3 46.5H388.5c-48.1 0-89.9 33.3-100.4 80.3-10.6-47-52.3-80.3-100.4-80.3H48c-26.5 0-48 21.5-48 48v245.8c0 26.5 21.5 48 48 48h89.7c102.2 0 132.7 24.4 147.3 75 .7 2.8 5.2 2.8 6 0 14.7-50.6 45.2-75 147.3-75H528c26.5 0 48-21.5 48-48V94.6c0-26.4-21.3-47.9-47.7-48.1zM242 311.9c0 1.9-1.5 3.5-3.5 3.5H78.2c-1.9 0-3.5-1.5-3.5-3.5V289c0-1.9 1.5-3.5 3.5-3.5h160.4c1.9 0 3.5 1.5 3.5 3.5v22.9zm0-60.9c0 1.9-1.5 3.5-3.5 3.5H78.2c-1.9 0-3.5-1.5-3.5-3.5v-22.9c0-1.9 1.5-3.5 3.5-3.5h160.4c1.9 0 3.5 1.5 3.5 3.5V251zm0-60.9c0 1.9-1.5 3.5-3.5 3.5H78.2c-1.9 0-3.5-1.5-3.5-3.5v-22.9c0-1.9 1.5-3.5 3.5-3.5h160.4c1.9 0 3.5 1.5 3.5 3.5v22.9zm259.3 121.7c0 1.9-1.5 3.5-3.5 3.5H337.5c-1.9 0-3.5-1.5-3.5-3.5v-22.9c0-1.9 1.5-3.5 3.5-3.5h160.4c1.9 0 3.5 1.5 3.5 3.5v22.9zm0-60.9c0 1.9-1.5 3.5-3.5 3.5H337.5c-1.9 0-3.5-1.5-3.5-3.5V228c0-1.9 1.5-3.5 3.5-3.5h160.4c1.9 0 3.5 1.5 3.5 3.5v22.9zm0-60.9c0 1.9-1.5 3.5-3.5 3.5H337.5c-1.9 0-3.5-1.5-3.5-3.5v-22.8c0-1.9 1.5-3.5 3.5-3.5h160.4c1.9 0 3.5 1.5 3.5 3.5V190z"
    ]
};
var $ef0249c5e48bf4e3$export$d1a4948b9a07ae7c = {
    prefix: "fab",
    iconName: "html5",
    icon: [
        384,
        512,
        [],
        "f13b",
        "M0 32l34.9 395.8L191.5 480l157.6-52.2L384 32H0zm308.2 127.9H124.4l4.1 49.4h175.6l-13.6 148.4-97.9 27v.3h-1.1l-98.7-27.3-6-75.8h47.7L138 320l53.5 14.5 53.7-14.5 6-62.2H84.3L71.5 112.2h241.1l-4.4 47.7z"
    ]
};
var $ef0249c5e48bf4e3$export$cb60511a0f837c82 = {
    prefix: "fab",
    iconName: "sellsy",
    icon: [
        640,
        512,
        [],
        "f213",
        "M539.71 237.308c3.064-12.257 4.29-24.821 4.29-37.384C544 107.382 468.618 32 376.076 32c-77.22 0-144.634 53.012-163.02 127.781-15.322-13.176-34.934-20.53-55.157-20.53-46.271 0-83.962 37.69-83.962 83.961 0 7.354.92 15.015 3.065 22.369-42.9 20.225-70.785 63.738-70.785 111.234C6.216 424.843 61.68 480 129.401 480h381.198c67.72 0 123.184-55.157 123.184-123.184.001-56.384-38.916-106.025-94.073-119.508zM199.88 401.554c0 8.274-7.048 15.321-15.321 15.321H153.61c-8.274 0-15.321-7.048-15.321-15.321V290.626c0-8.273 7.048-15.321 15.321-15.321h30.949c8.274 0 15.321 7.048 15.321 15.321v110.928zm89.477 0c0 8.274-7.048 15.321-15.322 15.321h-30.949c-8.274 0-15.321-7.048-15.321-15.321V270.096c0-8.274 7.048-15.321 15.321-15.321h30.949c8.274 0 15.322 7.048 15.322 15.321v131.458zm89.477 0c0 8.274-7.047 15.321-15.321 15.321h-30.949c-8.274 0-15.322-7.048-15.322-15.321V238.84c0-8.274 7.048-15.321 15.322-15.321h30.949c8.274 0 15.321 7.048 15.321 15.321v162.714zm87.027 0c0 8.274-7.048 15.321-15.322 15.321h-28.497c-8.274 0-15.321-7.048-15.321-15.321V176.941c0-8.579 7.047-15.628 15.321-15.628h28.497c8.274 0 15.322 7.048 15.322 15.628v224.613z"
    ]
};
var $ef0249c5e48bf4e3$export$5afc94dc87b38719 = {
    prefix: "fab",
    iconName: "sass",
    icon: [
        640,
        512,
        [],
        "f41e",
        "M301.84 378.92c-.3.6-.6 1.08 0 0zm249.13-87a131.16 131.16 0 0 0-58 13.5c-5.9-11.9-12-22.3-13-30.1-1.2-9.1-2.5-14.5-1.1-25.3s7.7-26.1 7.6-27.2-1.4-6.6-14.3-6.7-24 2.5-25.29 5.9a122.83 122.83 0 0 0-5.3 19.1c-2.3 11.7-25.79 53.5-39.09 75.3-4.4-8.5-8.1-16-8.9-22-1.2-9.1-2.5-14.5-1.1-25.3s7.7-26.1 7.6-27.2-1.4-6.6-14.29-6.7-24 2.5-25.3 5.9-2.7 11.4-5.3 19.1-33.89 77.3-42.08 95.4c-4.2 9.2-7.8 16.6-10.4 21.6-.4.8-.7 1.3-.9 1.7.3-.5.5-1 .5-.8-2.2 4.3-3.5 6.7-3.5 6.7v.1c-1.7 3.2-3.6 6.1-4.5 6.1-.6 0-1.9-8.4.3-19.9 4.7-24.2 15.8-61.8 15.7-63.1-.1-.7 2.1-7.2-7.3-10.7-9.1-3.3-12.4 2.2-13.2 2.2s-1.4 2-1.4 2 10.1-42.4-19.39-42.4c-18.4 0-44 20.2-56.58 38.5-7.9 4.3-25 13.6-43 23.5-6.9 3.8-14 7.7-20.7 11.4-.5-.5-.9-1-1.4-1.5-35.79-38.2-101.87-65.2-99.07-116.5 1-18.7 7.5-67.8 127.07-127.4 98-48.8 176.35-35.4 189.84-5.6 19.4 42.5-41.89 121.6-143.66 133-38.79 4.3-59.18-10.7-64.28-16.3-5.3-5.9-6.1-6.2-8.1-5.1-3.3 1.8-1.2 7 0 10.1 3 7.9 15.5 21.9 36.79 28.9 18.7 6.1 64.18 9.5 119.17-11.8 61.78-23.8 109.87-90.1 95.77-145.6C386.52 18.32 293-.18 204.57 31.22c-52.69 18.7-109.67 48.1-150.66 86.4-48.69 45.6-56.48 85.3-53.28 101.9 11.39 58.9 92.57 97.3 125.06 125.7-1.6.9-3.1 1.7-4.5 2.5-16.29 8.1-78.18 40.5-93.67 74.7-17.5 38.8 2.9 66.6 16.29 70.4 41.79 11.6 84.58-9.3 107.57-43.6s20.2-79.1 9.6-99.5c-.1-.3-.3-.5-.4-.8 4.2-2.5 8.5-5 12.8-7.5 8.29-4.9 16.39-9.4 23.49-13.3-4 10.8-6.9 23.8-8.4 42.6-1.8 22 7.3 50.5 19.1 61.7 5.2 4.9 11.49 5 15.39 5 13.8 0 20-11.4 26.89-25 8.5-16.6 16-35.9 16-35.9s-9.4 52.2 16.3 52.2c9.39 0 18.79-12.1 23-18.3v.1s.2-.4.7-1.2c1-1.5 1.5-2.4 1.5-2.4v-.3c3.8-6.5 12.1-21.4 24.59-46 16.2-31.8 31.69-71.5 31.69-71.5a201.24 201.24 0 0 0 6.2 25.8c2.8 9.5 8.7 19.9 13.4 30-3.8 5.2-6.1 8.2-6.1 8.2a.31.31 0 0 0 .1.2c-3 4-6.4 8.3-9.9 12.5-12.79 15.2-28 32.6-30 37.6-2.4 5.9-1.8 10.3 2.8 13.7 3.4 2.6 9.4 3 15.69 2.5 11.5-.8 19.6-3.6 23.5-5.4a82.2 82.2 0 0 0 20.19-10.6c12.5-9.2 20.1-22.4 19.4-39.8-.4-9.6-3.5-19.2-7.3-28.2 1.1-1.6 2.3-3.3 3.4-5C434.8 301.72 450.1 270 450.1 270a201.24 201.24 0 0 0 6.2 25.8c2.4 8.1 7.09 17 11.39 25.7-18.59 15.1-30.09 32.6-34.09 44.1-7.4 21.3-1.6 30.9 9.3 33.1 4.9 1 11.9-1.3 17.1-3.5a79.46 79.46 0 0 0 21.59-11.1c12.5-9.2 24.59-22.1 23.79-39.6-.3-7.9-2.5-15.8-5.4-23.4 15.7-6.6 36.09-10.2 62.09-7.2 55.68 6.5 66.58 41.3 64.48 55.8s-13.8 22.6-17.7 25-5.1 3.3-4.8 5.1c.5 2.6 2.3 2.5 5.6 1.9 4.6-.8 29.19-11.8 30.29-38.7 1.6-34-31.09-71.4-89-71.1zm-429.18 144.7c-18.39 20.1-44.19 27.7-55.28 21.3C54.61 451 59.31 421.42 82 400c13.8-13 31.59-25 43.39-32.4 2.7-1.6 6.6-4 11.4-6.9.8-.5 1.2-.7 1.2-.7.9-.6 1.9-1.1 2.9-1.7 8.29 30.4.3 57.2-19.1 78.3zm134.36-91.4c-6.4 15.7-19.89 55.7-28.09 53.6-7-1.8-11.3-32.3-1.4-62.3 5-15.1 15.6-33.1 21.9-40.1 10.09-11.3 21.19-14.9 23.79-10.4 3.5 5.9-12.2 49.4-16.2 59.2zm111 53c-2.7 1.4-5.2 2.3-6.4 1.6-.9-.5 1.1-2.4 1.1-2.4s13.9-14.9 19.4-21.7c3.2-4 6.9-8.7 10.89-13.9 0 .5.1 1 .1 1.6-.13 17.9-17.32 30-25.12 34.8zm85.58-19.5c-2-1.4-1.7-6.1 5-20.7 2.6-5.7 8.59-15.3 19-24.5a36.18 36.18 0 0 1 1.9 10.8c-.1 22.5-16.2 30.9-25.89 34.4z"
    ]
};
var $ef0249c5e48bf4e3$export$304e26e1efc5b1a4 = {
    prefix: "fab",
    iconName: "wirsindhandwerk",
    icon: [
        512,
        512,
        [
            "wsh"
        ],
        "e2d0",
        "M50.77161,479.81213h83.36071V367.84741l-83.36071,47.009Zm329.04675,0h82.35022V414.85645l-82.35022-47.009Zm.00568-448V251.568L256.1759,179.1861,134.50378,251.568V31.81213H50.77161V392.60565L256.1759,270.31909,462.16858,392.60565V31.81213Z"
    ]
};
var $ef0249c5e48bf4e3$export$c6d19319c89c1ce4 = $ef0249c5e48bf4e3$export$304e26e1efc5b1a4;
var $ef0249c5e48bf4e3$export$25d99c8ee7e610e5 = {
    prefix: "fab",
    iconName: "buromobelexperte",
    icon: [
        448,
        512,
        [],
        "f37f",
        "M0 32v128h128V32H0zm120 120H8V40h112v112zm40-120v128h128V32H160zm120 120H168V40h112v112zm40-120v128h128V32H320zm120 120H328V40h112v112zM0 192v128h128V192H0zm120 120H8V200h112v112zm40-120v128h128V192H160zm120 120H168V200h112v112zm40-120v128h128V192H320zm120 120H328V200h112v112zM0 352v128h128V352H0zm120 120H8V360h112v112zm40-120v128h128V352H160zm120 120H168V360h112v112zm40-120v128h128V352H320z"
    ]
};
var $ef0249c5e48bf4e3$export$fb5e089c1f25c80c = {
    prefix: "fab",
    iconName: "salesforce",
    icon: [
        640,
        512,
        [],
        "f83b",
        "M248.89 245.64h-26.35c.69-5.16 3.32-14.12 13.64-14.12 6.75 0 11.97 3.82 12.71 14.12zm136.66-13.88c-.47 0-14.11-1.77-14.11 20s13.63 20 14.11 20c13 0 14.11-13.54 14.11-20 0-21.76-13.66-20-14.11-20zm-243.22 23.76a8.63 8.63 0 0 0-3.29 7.29c0 4.78 2.08 6.05 3.29 7.05 4.7 3.7 15.07 2.12 20.93.95v-16.94c-5.32-1.07-16.73-1.96-20.93 1.65zM640 232c0 87.58-80 154.39-165.36 136.43-18.37 33-70.73 70.75-132.2 41.63-41.16 96.05-177.89 92.18-213.81-5.17C8.91 428.78-50.19 266.52 53.36 205.61 18.61 126.18 76 32 167.67 32a124.24 124.24 0 0 1 98.56 48.7c20.7-21.4 49.4-34.81 81.15-34.81 42.34 0 79 23.52 98.8 58.57C539 63.78 640 132.69 640 232zm-519.55 31.8c0-11.76-11.69-15.17-17.87-17.17-5.27-2.11-13.41-3.51-13.41-8.94 0-9.46 17-6.66 25.17-2.12 0 0 1.17.71 1.64-.47.24-.7 2.36-6.58 2.59-7.29a1.13 1.13 0 0 0-.7-1.41c-12.33-7.63-40.7-8.51-40.7 12.7 0 12.46 11.49 15.44 17.88 17.17 4.72 1.58 13.17 3 13.17 8.7 0 4-3.53 7.06-9.17 7.06a31.76 31.76 0 0 1-19-6.35c-.47-.23-1.42-.71-1.65.71l-2.4 7.47c-.47.94.23 1.18.23 1.41 1.75 1.4 10.3 6.59 22.82 6.59 13.17 0 21.4-7.06 21.4-18.11zm32-42.58c-10.13 0-18.66 3.17-21.4 5.18a1 1 0 0 0-.24 1.41l2.59 7.06a1 1 0 0 0 1.18.7c.65 0 6.8-4 16.93-4 4 0 7.06.71 9.18 2.36 3.6 2.8 3.06 8.29 3.06 10.58-4.79-.3-19.11-3.44-29.41 3.76a16.92 16.92 0 0 0-7.34 14.54c0 5.9 1.51 10.4 6.59 14.35 12.24 8.16 36.28 2 38.1 1.41 1.58-.32 3.53-.66 3.53-1.88v-33.88c.04-4.61.32-21.64-22.78-21.64zM199 200.24a1.11 1.11 0 0 0-1.18-1.18H188a1.11 1.11 0 0 0-1.17 1.18v79a1.11 1.11 0 0 0 1.17 1.18h9.88a1.11 1.11 0 0 0 1.18-1.18zm55.75 28.93c-2.1-2.31-6.79-7.53-17.65-7.53-3.51 0-14.16.23-20.7 8.94-6.35 7.63-6.58 18.11-6.58 21.41 0 3.12.15 14.26 7.06 21.17 2.64 2.91 9.06 8.23 22.81 8.23 10.82 0 16.47-2.35 18.58-3.76.47-.24.71-.71.24-1.88l-2.35-6.83a1.26 1.26 0 0 0-1.41-.7c-2.59.94-6.35 2.82-15.29 2.82-17.42 0-16.85-14.74-16.94-16.7h37.17a1.23 1.23 0 0 0 1.17-.94c-.29 0 2.07-14.7-6.09-24.23zm36.69 52.69c13.17 0 21.41-7.06 21.41-18.11 0-11.76-11.7-15.17-17.88-17.17-4.14-1.66-13.41-3.38-13.41-8.94 0-3.76 3.29-6.35 8.47-6.35a38.11 38.11 0 0 1 16.7 4.23s1.18.71 1.65-.47c.23-.7 2.35-6.58 2.58-7.29a1.13 1.13 0 0 0-.7-1.41c-7.91-4.9-16.74-4.94-20.23-4.94-12 0-20.46 7.29-20.46 17.64 0 12.46 11.48 15.44 17.87 17.17 6.11 2 13.17 3.26 13.17 8.7 0 4-3.52 7.06-9.17 7.06a31.8 31.8 0 0 1-19-6.35 1 1 0 0 0-1.65.71l-2.35 7.52c-.47.94.23 1.18.23 1.41 1.72 1.4 10.33 6.59 22.79 6.59zM357.09 224c0-.71-.24-1.18-1.18-1.18h-11.76c0-.14.94-8.94 4.47-12.47 4.16-4.15 11.76-1.64 12-1.64 1.17.47 1.41 0 1.64-.47l2.83-7.77c.7-.94 0-1.17-.24-1.41-5.09-2-17.35-2.87-24.46 4.24-5.48 5.48-7 13.92-8 19.52h-8.47a1.28 1.28 0 0 0-1.17 1.18l-1.42 7.76c0 .7.24 1.17 1.18 1.17h8.23c-8.51 47.9-8.75 50.21-10.35 55.52-1.08 3.62-3.29 6.9-5.88 7.76-.09 0-3.88 1.68-9.64-.24 0 0-.94-.47-1.41.71-.24.71-2.59 6.82-2.83 7.53s0 1.41.47 1.41c5.11 2 13 1.77 17.88 0 6.28-2.28 9.72-7.89 11.53-12.94 2.75-7.71 2.81-9.79 11.76-59.74h12.23a1.29 1.29 0 0 0 1.18-1.18zm53.39 16c-.56-1.68-5.1-18.11-25.17-18.11-15.25 0-23 10-25.16 18.11-1 3-3.18 14 0 23.52.09.3 4.41 18.12 25.16 18.12 14.95 0 22.9-9.61 25.17-18.12 3.21-9.61 1.01-20.52 0-23.52zm45.4-16.7c-5-1.65-16.62-1.9-22.11 5.41v-4.47a1.11 1.11 0 0 0-1.18-1.17h-9.4a1.11 1.11 0 0 0-1.18 1.17v55.28a1.12 1.12 0 0 0 1.18 1.18h9.64a1.12 1.12 0 0 0 1.18-1.18v-27.77c0-2.91.05-11.37 4.46-15.05 4.9-4.9 12-3.36 13.41-3.06a1.57 1.57 0 0 0 1.41-.94 74 74 0 0 0 3.06-8 1.16 1.16 0 0 0-.47-1.41zm46.81 54.1l-2.12-7.29c-.47-1.18-1.41-.71-1.41-.71-4.23 1.82-10.15 1.89-11.29 1.89-4.64 0-17.17-1.13-17.17-19.76 0-6.23 1.85-19.76 16.47-19.76a34.85 34.85 0 0 1 11.52 1.65s.94.47 1.18-.71c.94-2.59 1.64-4.47 2.59-7.53.23-.94-.47-1.17-.71-1.17-11.59-3.87-22.34-2.53-27.76 0-1.59.74-16.23 6.49-16.23 27.52 0 2.9-.58 30.11 28.94 30.11a44.45 44.45 0 0 0 15.52-2.83 1.3 1.3 0 0 0 .47-1.42zm53.87-39.52c-.8-3-5.37-16.23-22.35-16.23-16 0-23.52 10.11-25.64 18.59a38.58 38.58 0 0 0-1.65 11.76c0 25.87 18.84 29.4 29.88 29.4 10.82 0 16.46-2.35 18.58-3.76.47-.24.71-.71.24-1.88l-2.36-6.83a1.26 1.26 0 0 0-1.41-.7c-2.59.94-6.35 2.82-15.29 2.82-17.42 0-16.85-14.74-16.93-16.7h37.16a1.25 1.25 0 0 0 1.18-.94c-.24-.01.94-7.07-1.41-15.54zm-23.29-6.35c-10.33 0-13 9-13.64 14.12H546c-.88-11.92-7.62-14.13-12.73-14.13z"
    ]
};
var $ef0249c5e48bf4e3$export$4a726382b32e57cc = {
    prefix: "fab",
    iconName: "octopus-deploy",
    icon: [
        512,
        512,
        [],
        "e082",
        "M455.6,349.2c-45.891-39.09-36.67-77.877-16.095-128.11C475.16,134.04,415.967,34.14,329.93,8.3,237.04-19.6,134.252,24.341,99.677,117.147a180.862,180.862,0,0,0-10.988,73.544c1.733,29.543,14.717,52.97,24.09,80.3,17.2,50.161-28.1,92.743-66.662,117.582-46.806,30.2-36.319,39.857-8.428,41.858,23.378,1.68,44.478-4.548,65.265-15.045,9.2-4.647,40.687-18.931,45.13-28.588C135.9,413.388,111.122,459.5,126.621,488.9c19.1,36.229,67.112-31.77,76.709-45.812,8.591-12.572,42.963-81.279,63.627-46.926,18.865,31.361,8.6,76.391,35.738,104.622,32.854,34.2,51.155-18.312,51.412-44.221.163-16.411-6.1-95.852,29.9-59.944C405.428,418,436.912,467.8,472.568,463.642c38.736-4.516-22.123-67.967-28.262-78.695,5.393,4.279,53.665,34.128,53.818,9.52C498.234,375.678,468.039,359.8,455.6,349.2Z"
    ]
};
var $ef0249c5e48bf4e3$export$86efffc3e85d2a9 = {
    prefix: "fab",
    iconName: "medapps",
    icon: [
        320,
        512,
        [],
        "f3c6",
        "M118.3 238.4c3.5-12.5 6.9-33.6 13.2-33.6 8.3 1.8 9.6 23.4 18.6 36.6 4.6-23.5 5.3-85.1 14.1-86.7 9-.7 19.7 66.5 22 77.5 9.9 4.1 48.9 6.6 48.9 6.6 1.9 7.3-24 7.6-40 7.8-4.6 14.8-5.4 27.7-11.4 28-4.7.2-8.2-28.8-17.5-49.6l-9.4 65.5c-4.4 13-15.5-22.5-21.9-39.3-3.3-.1-62.4-1.6-47.6-7.8l31-5zM228 448c21.2 0 21.2-32 0-32H92c-21.2 0-21.2 32 0 32h136zm-24 64c21.2 0 21.2-32 0-32h-88c-21.2 0-21.2 32 0 32h88zm34.2-141.5c3.2-18.9 5.2-36.4 11.9-48.8 7.9-14.7 16.1-28.1 24-41 24.6-40.4 45.9-75.2 45.9-125.5C320 69.6 248.2 0 160 0S0 69.6 0 155.2c0 50.2 21.3 85.1 45.9 125.5 7.9 12.9 16 26.3 24 41 6.7 12.5 8.7 29.8 11.9 48.9 3.5 21 36.1 15.7 32.6-5.1-3.6-21.7-5.6-40.7-15.3-58.6C66.5 246.5 33 211.3 33 155.2 33 87.3 90 32 160 32s127 55.3 127 123.2c0 56.1-33.5 91.3-66.1 151.6-9.7 18-11.7 37.4-15.3 58.6-3.4 20.6 29 26.4 32.6 5.1z"
    ]
};
var $ef0249c5e48bf4e3$export$ffa3f5d32fe6bc0e = {
    prefix: "fab",
    iconName: "ns8",
    icon: [
        640,
        512,
        [],
        "f3d5",
        "M104.324,269.172h26.067V242.994H104.324Zm52.466-26.178-.055-26.178v-.941a39.325,39.325,0,0,0-78.644.941v.166h26.4v-.166a12.98,12.98,0,0,1,25.956,0v26.178Zm52.356,25.846a91.1,91.1,0,0,1-91.1,91.1h-.609a91.1,91.1,0,0,1-91.1-91.1H0v.166A117.33,117.33,0,0,0,117.44,386.28h.775A117.331,117.331,0,0,0,235.49,268.84V242.828H209.146Zm-157.233,0a65.362,65.362,0,0,0,130.723,0H156.292a39.023,39.023,0,0,1-78.035,0V242.883H51.968v-26.62A65.42,65.42,0,0,1,182.8,217.48v25.293h26.344V217.48a91.761,91.761,0,0,0-183.522,0v25.4H51.913Zm418.4-71.173c13.67,0,24.573,6.642,30.052,18.264l.719,1.549,23.245-11.511-.609-1.439c-8.025-19.26-28.5-31.27-53.407-31.27-23.134,0-43.611,11.4-50.972,28.447-.123,26.876-.158,23.9,0,24.85,4.7,11.013,14.555,19.37,28.668,24.241a102.033,102.033,0,0,0,19.813,3.984c5.479.72,10.626,1.384,15.829,3.1,6.364,2.1,10.46,5.257,12.84,9.851v9.851c-3.708,7.527-13.781,12.342-25.791,12.342-14.334,0-25.956-6.918-31.933-19.039l-.72-1.494L415.026,280.9l.553,1.439c7.915,19.426,29.609,32.044,55.289,32.044,23.632,0,44.608-11.4,52.3-28.447l.166-25.9-.166-.664c-4.87-11.014-15.219-19.647-28.944-24.241-7.693-2.712-14.335-3.6-20.7-4.427a83.777,83.777,0,0,1-14.832-2.878c-6.31-1.937-10.4-5.092-12.619-9.63v-8.412C449.45,202.427,458.969,197.667,470.315,197.667ZM287.568,311.344h26.067v-68.4H287.568Zm352.266-53.3c-2.933-6.254-8.3-12.01-15.441-16.714A37.99,37.99,0,0,0,637.4,226l.166-25.347-.166-.664C630.038,184,610.667,173.26,589.25,173.26S548.461,184,541.1,199.992l-.166,25.347.166.664a39.643,39.643,0,0,0,13.006,15.331c-7.2,4.7-12.508,10.46-15.441,16.714l-.166,28.889.166.72c7.582,15.994,27.893,26.731,50.585,26.731s43.057-10.737,50.584-26.731l.166-28.89Zm-73.22-50.806c3.6-6.31,12.563-10.516,22.58-10.516s19.038,4.206,22.636,10.516v13.725c-3.542,6.2-12.563,10.349-22.636,10.349s-19.094-4.15-22.58-10.349Zm47.319,72.169c-3.764,6.641-13.338,10.9-24.683,10.9-11.125,0-20.976-4.372-24.684-10.9V263.25c3.708-6.309,13.5-10.515,24.684-10.515,11.345,0,20.919,4.15,24.683,10.515ZM376.4,265.962l-59.827-89.713h-29v40.623h26.51v.387l62.539,94.085H402.3V176.249H376.4Z"
    ]
};
var $ef0249c5e48bf4e3$export$e1681fe8211dd475 = {
    prefix: "fab",
    iconName: "pinterest-p",
    icon: [
        384,
        512,
        [],
        "f231",
        "M204 6.5C101.4 6.5 0 74.9 0 185.6 0 256 39.6 296 63.6 296c9.9 0 15.6-27.6 15.6-35.4 0-9.3-23.7-29.1-23.7-67.8 0-80.4 61.2-137.4 140.4-137.4 68.1 0 118.5 38.7 118.5 109.8 0 53.1-21.3 152.7-90.3 152.7-24.9 0-46.2-18-46.2-43.8 0-37.8 26.4-74.4 26.4-113.4 0-66.2-93.9-54.2-93.9 25.8 0 16.8 2.1 35.4 9.6 50.7-13.8 59.4-42 147.9-42 209.1 0 18.9 2.7 37.5 4.5 56.4 3.4 3.8 1.7 3.4 6.9 1.5 50.4-69 48.6-82.5 71.4-172.8 12.3 23.4 44.1 36 69.3 36 106.2 0 153.9-103.5 153.9-196.8C384 71.3 298.2 6.5 204 6.5z"
    ]
};
var $ef0249c5e48bf4e3$export$aa79881dfcf87a16 = {
    prefix: "fab",
    iconName: "apper",
    icon: [
        640,
        512,
        [],
        "f371",
        "M42.1 239.1c22.2 0 29 2.8 33.5 14.6h.8v-22.9c0-11.3-4.8-15.4-17.9-15.4-11.3 0-14.4 2.5-15.1 12.8H4.8c.3-13.9 1.5-19.1 5.8-24.4C17.9 195 29.5 192 56.7 192c33 0 47.1 5 53.9 18.9 2 4.3 4 15.6 4 23.7v76.3H76.3l1.3-19.1h-1c-5.3 15.6-13.6 20.4-35.5 20.4-30.3 0-41.1-10.1-41.1-37.3 0-25.2 12.3-35.8 42.1-35.8zm17.1 48.1c13.1 0 16.9-3 16.9-13.4 0-9.1-4.3-11.6-19.6-11.6-13.1 0-17.9 3-17.9 12.1-.1 10.4 3.7 12.9 20.6 12.9zm77.8-94.9h38.3l-1.5 20.6h.8c9.1-17.1 15.9-20.9 37.5-20.9 14.4 0 24.7 3 31.5 9.1 9.8 8.6 12.8 20.4 12.8 48.1 0 30-3 43.1-12.1 52.9-6.8 7.3-16.4 10.1-33.2 10.1-20.4 0-29.2-5.5-33.8-21.2h-.8v70.3H137v-169zm80.9 60.7c0-27.5-3.3-32.5-20.7-32.5-16.9 0-20.7 5-20.7 28.7 0 28 3.5 33.5 21.2 33.5 16.4 0 20.2-5.6 20.2-29.7zm57.9-60.7h38.3l-1.5 20.6h.8c9.1-17.1 15.9-20.9 37.5-20.9 14.4 0 24.7 3 31.5 9.1 9.8 8.6 12.8 20.4 12.8 48.1 0 30-3 43.1-12.1 52.9-6.8 7.3-16.4 10.1-33.3 10.1-20.4 0-29.2-5.5-33.8-21.2h-.8v70.3h-39.5v-169zm80.9 60.7c0-27.5-3.3-32.5-20.7-32.5-16.9 0-20.7 5-20.7 28.7 0 28 3.5 33.5 21.2 33.5 16.4 0 20.2-5.6 20.2-29.7zm53.8-3.8c0-25.4 3.3-37.8 12.3-45.8 8.8-8.1 22.2-11.3 45.1-11.3 42.8 0 55.7 12.8 55.7 55.7v11.1h-75.3c-.3 2-.3 4-.3 4.8 0 16.9 4.5 21.9 20.1 21.9 13.9 0 17.9-3 17.9-13.9h37.5v2.3c0 9.8-2.5 18.9-6.8 24.7-7.3 9.8-19.6 13.6-44.3 13.6-27.5 0-41.6-3.3-50.6-12.3-8.5-8.5-11.3-21.3-11.3-50.8zm76.4-11.6c-.3-1.8-.3-3.3-.3-3.8 0-12.3-3.3-14.6-19.6-14.6-14.4 0-17.1 3-18.1 15.1l-.3 3.3h38.3zm55.6-45.3h38.3l-1.8 19.9h.7c6.8-14.9 14.4-20.2 29.7-20.2 10.8 0 19.1 3.3 23.4 9.3 5.3 7.3 6.8 14.4 6.8 34 0 1.5 0 5 .2 9.3h-35c.3-1.8.3-3.3.3-4 0-15.4-2-19.4-10.3-19.4-6.3 0-10.8 3.3-13.1 9.3-1 3-1 4.3-1 12.3v68h-38.3V192.3z"
    ]
};
var $ef0249c5e48bf4e3$export$c2ee281dce8eb9d5 = {
    prefix: "fab",
    iconName: "fort-awesome",
    icon: [
        512,
        512,
        [],
        "f286",
        "M489.2 287.9h-27.4c-2.6 0-4.6 2-4.6 4.6v32h-36.6V146.2c0-2.6-2-4.6-4.6-4.6h-27.4c-2.6 0-4.6 2-4.6 4.6v32h-36.6v-32c0-2.6-2-4.6-4.6-4.6h-27.4c-2.6 0-4.6 2-4.6 4.6v32h-36.6v-32c0-6-8-4.6-11.7-4.6v-38c8.3-2 17.1-3.4 25.7-3.4 10.9 0 20.9 4.3 31.4 4.3 4.6 0 27.7-1.1 27.7-8v-60c0-2.6-2-4.6-4.6-4.6-5.1 0-15.1 4.3-24 4.3-9.7 0-20.9-4.3-32.6-4.3-8 0-16 1.1-23.7 2.9v-4.9c5.4-2.6 9.1-8.3 9.1-14.3 0-20.7-31.4-20.8-31.4 0 0 6 3.7 11.7 9.1 14.3v111.7c-3.7 0-11.7-1.4-11.7 4.6v32h-36.6v-32c0-2.6-2-4.6-4.6-4.6h-27.4c-2.6 0-4.6 2-4.6 4.6v32H128v-32c0-2.6-2-4.6-4.6-4.6H96c-2.6 0-4.6 2-4.6 4.6v178.3H54.8v-32c0-2.6-2-4.6-4.6-4.6H22.8c-2.6 0-4.6 2-4.6 4.6V512h182.9v-96c0-72.6 109.7-72.6 109.7 0v96h182.9V292.5c.1-2.6-1.9-4.6-4.5-4.6zm-288.1-4.5c0 2.6-2 4.6-4.6 4.6h-27.4c-2.6 0-4.6-2-4.6-4.6v-64c0-2.6 2-4.6 4.6-4.6h27.4c2.6 0 4.6 2 4.6 4.6v64zm146.4 0c0 2.6-2 4.6-4.6 4.6h-27.4c-2.6 0-4.6-2-4.6-4.6v-64c0-2.6 2-4.6 4.6-4.6h27.4c2.6 0 4.6 2 4.6 4.6v64z"
    ]
};
var $ef0249c5e48bf4e3$export$8d560f87da34bcc1 = {
    prefix: "fab",
    iconName: "waze",
    icon: [
        512,
        512,
        [],
        "f83f",
        "M502.17 201.67C516.69 287.53 471.23 369.59 389 409.8c13 34.1-12.4 70.2-48.32 70.2a51.68 51.68 0 0 1-51.57-49c-6.44.19-64.2 0-76.33-.64A51.69 51.69 0 0 1 159 479.92c-33.86-1.36-57.95-34.84-47-67.92-37.21-13.11-72.54-34.87-99.62-70.8-13-17.28-.48-41.8 20.84-41.8 46.31 0 32.22-54.17 43.15-110.26C94.8 95.2 193.12 32 288.09 32c102.48 0 197.15 70.67 214.08 169.67zM373.51 388.28c42-19.18 81.33-56.71 96.29-102.14 40.48-123.09-64.15-228-181.71-228-83.45 0-170.32 55.42-186.07 136-9.53 48.91 5 131.35-68.75 131.35C58.21 358.6 91.6 378.11 127 389.54c24.66-21.8 63.87-15.47 79.83 14.34 14.22 1 79.19 1.18 87.9.82a51.69 51.69 0 0 1 78.78-16.42zM205.12 187.13c0-34.74 50.84-34.75 50.84 0s-50.84 34.74-50.84 0zm116.57 0c0-34.74 50.86-34.75 50.86 0s-50.86 34.75-50.86 0zm-122.61 70.69c-3.44-16.94 22.18-22.18 25.62-5.21l.06.28c4.14 21.42 29.85 44 64.12 43.07 35.68-.94 59.25-22.21 64.11-42.77 4.46-16.05 28.6-10.36 25.47 6-5.23 22.18-31.21 62-91.46 62.9-42.55 0-80.88-27.84-87.9-64.25z"
    ]
};
var $ef0249c5e48bf4e3$export$4f0eff72b7493340 = {
    prefix: "fab",
    iconName: "cc-jcb",
    icon: [
        576,
        512,
        [],
        "f24b",
        "M431.5 244.3V212c41.2 0 38.5.2 38.5.2 7.3 1.3 13.3 7.3 13.3 16 0 8.8-6 14.5-13.3 15.8-1.2.4-3.3.3-38.5.3zm42.8 20.2c-2.8-.7-3.3-.5-42.8-.5v35c39.6 0 40 .2 42.8-.5 7.5-1.5 13.5-8 13.5-17 0-8.7-6-15.5-13.5-17zM576 80v352c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V80c0-26.5 21.5-48 48-48h480c26.5 0 48 21.5 48 48zM182 192.3h-57c0 67.1 10.7 109.7-35.8 109.7-19.5 0-38.8-5.7-57.2-14.8v28c30 8.3 68 8.3 68 8.3 97.9 0 82-47.7 82-131.2zm178.5 4.5c-63.4-16-165-14.9-165 59.3 0 77.1 108.2 73.6 165 59.2V287C312.9 311.7 253 309 253 256s59.8-55.6 107.5-31.2v-28zM544 286.5c0-18.5-16.5-30.5-38-32v-.8c19.5-2.7 30.3-15.5 30.3-30.2 0-19-15.7-30-37-31 0 0 6.3-.3-120.3-.3v127.5h122.7c24.3.1 42.3-12.9 42.3-33.2z"
    ]
};
var $ef0249c5e48bf4e3$export$3770724b51125ef1 = {
    prefix: "fab",
    iconName: "snapchat",
    icon: [
        512,
        512,
        [
            62124,
            "snapchat-ghost"
        ],
        "f2ab",
        "M496.926,366.6c-3.373-9.176-9.8-14.086-17.112-18.153-1.376-.806-2.641-1.451-3.72-1.947-2.182-1.128-4.414-2.22-6.634-3.373-22.8-12.09-40.609-27.341-52.959-45.42a102.889,102.889,0,0,1-9.089-16.12c-1.054-3.013-1-4.724-.248-6.287a10.221,10.221,0,0,1,2.914-3.038c3.918-2.591,7.96-5.22,10.7-6.993,4.885-3.162,8.754-5.667,11.246-7.44,9.362-6.547,15.909-13.5,20-21.278a42.371,42.371,0,0,0,2.1-35.191c-6.2-16.318-21.613-26.449-40.287-26.449a55.543,55.543,0,0,0-11.718,1.24c-1.029.224-2.059.459-3.063.72.174-11.16-.074-22.94-1.066-34.534-3.522-40.758-17.794-62.123-32.674-79.16A130.167,130.167,0,0,0,332.1,36.443C309.515,23.547,283.91,17,256,17S202.6,23.547,180,36.443a129.735,129.735,0,0,0-33.281,26.783c-14.88,17.038-29.152,38.44-32.673,79.161-.992,11.594-1.24,23.435-1.079,34.533-1-.26-2.021-.5-3.051-.719a55.461,55.461,0,0,0-11.717-1.24c-18.687,0-34.125,10.131-40.3,26.449a42.423,42.423,0,0,0,2.046,35.228c4.105,7.774,10.652,14.731,20.014,21.278,2.48,1.736,6.361,4.24,11.246,7.44,2.641,1.711,6.5,4.216,10.28,6.72a11.054,11.054,0,0,1,3.3,3.311c.794,1.624.818,3.373-.36,6.6a102.02,102.02,0,0,1-8.94,15.785c-12.077,17.669-29.363,32.648-51.434,44.639C32.355,348.608,20.2,352.75,15.069,366.7c-3.868,10.528-1.339,22.506,8.494,32.6a49.137,49.137,0,0,0,12.4,9.387,134.337,134.337,0,0,0,30.342,12.139,20.024,20.024,0,0,1,6.126,2.741c3.583,3.137,3.075,7.861,7.849,14.78a34.468,34.468,0,0,0,8.977,9.127c10.019,6.919,21.278,7.353,33.207,7.811,10.776.41,22.989.881,36.939,5.481,5.778,1.91,11.78,5.605,18.736,9.92C194.842,480.951,217.707,495,255.973,495s61.292-14.123,78.118-24.428c6.907-4.24,12.872-7.9,18.489-9.758,13.949-4.613,26.163-5.072,36.939-5.481,11.928-.459,23.187-.893,33.206-7.812a34.584,34.584,0,0,0,10.218-11.16c3.434-5.84,3.348-9.919,6.572-12.771a18.971,18.971,0,0,1,5.753-2.629A134.893,134.893,0,0,0,476.02,408.71a48.344,48.344,0,0,0,13.019-10.193l.124-.149C498.389,388.5,500.708,376.867,496.926,366.6Zm-34.013,18.277c-20.745,11.458-34.533,10.23-45.259,17.137-9.114,5.865-3.72,18.513-10.342,23.076-8.134,5.617-32.177-.4-63.239,9.858-25.618,8.469-41.961,32.822-88.038,32.822s-62.036-24.3-88.076-32.884c-31-10.255-55.092-4.241-63.239-9.858-6.609-4.563-1.24-17.211-10.341-23.076-10.739-6.907-24.527-5.679-45.26-17.075-13.206-7.291-5.716-11.8-1.314-13.937,75.143-36.381,87.133-92.552,87.666-96.719.645-5.046,1.364-9.014-4.191-14.148-5.369-4.96-29.189-19.7-35.8-24.316-10.937-7.638-15.748-15.264-12.2-24.638,2.48-6.485,8.531-8.928,14.879-8.928a27.643,27.643,0,0,1,5.965.67c12,2.6,23.659,8.617,30.392,10.242a10.749,10.749,0,0,0,2.48.335c3.6,0,4.86-1.811,4.612-5.927-.768-13.132-2.628-38.725-.558-62.644,2.84-32.909,13.442-49.215,26.04-63.636,6.051-6.932,34.484-36.976,88.857-36.976s82.88,29.92,88.931,36.827c12.611,14.421,23.225,30.727,26.04,63.636,2.071,23.919.285,49.525-.558,62.644-.285,4.327,1.017,5.927,4.613,5.927a10.648,10.648,0,0,0,2.48-.335c6.745-1.624,18.4-7.638,30.4-10.242a27.641,27.641,0,0,1,5.964-.67c6.386,0,12.4,2.48,14.88,8.928,3.546,9.374-1.24,17-12.189,24.639-6.609,4.612-30.429,19.343-35.8,24.315-5.568,5.134-4.836,9.1-4.191,14.149.533,4.228,12.511,60.4,87.666,96.718C468.629,373.011,476.119,377.524,462.913,384.877Z"
    ]
};
var $ef0249c5e48bf4e3$export$e6e855f745e10958 = $ef0249c5e48bf4e3$export$3770724b51125ef1;
var $ef0249c5e48bf4e3$export$318074701514e1 = {
    prefix: "fab",
    iconName: "fantasy-flight-games",
    icon: [
        512,
        512,
        [],
        "f6dc",
        "M256 32.86L32.86 256 256 479.14 479.14 256 256 32.86zM88.34 255.83c1.96-2 11.92-12.3 96.49-97.48 41.45-41.75 86.19-43.77 119.77-18.69 24.63 18.4 62.06 58.9 62.15 59 .68.74 1.07 2.86.58 3.38-11.27 11.84-22.68 23.54-33.5 34.69-34.21-32.31-40.52-38.24-48.51-43.95-17.77-12.69-41.4-10.13-56.98 5.1-2.17 2.13-1.79 3.43.12 5.35 2.94 2.95 28.1 28.33 35.09 35.78-11.95 11.6-23.66 22.97-35.69 34.66-12.02-12.54-24.48-25.53-36.54-38.11-21.39 21.09-41.69 41.11-61.85 60.99zm234.82 101.6c-35.49 35.43-78.09 38.14-106.99 20.47-22.08-13.5-39.38-32.08-72.93-66.84 12.05-12.37 23.79-24.42 35.37-36.31 33.02 31.91 37.06 36.01 44.68 42.09 18.48 14.74 42.52 13.67 59.32-1.8 3.68-3.39 3.69-3.64.14-7.24-10.59-10.73-21.19-21.44-31.77-32.18-1.32-1.34-3.03-2.48-.8-4.69 10.79-10.71 21.48-21.52 32.21-32.29.26-.26.65-.38 1.91-1.07 12.37 12.87 24.92 25.92 37.25 38.75 21.01-20.73 41.24-40.68 61.25-60.42 13.68 13.4 27.13 26.58 40.86 40.03-20.17 20.86-81.68 82.71-100.5 101.5zM256 0L0 256l256 256 256-256L256 0zM16 256L256 16l240 240-240 240L16 256z"
    ]
};
var $ef0249c5e48bf4e3$export$8a8ef141dcbeda7b = {
    prefix: "fab",
    iconName: "rust",
    icon: [
        512,
        512,
        [],
        "e07a",
        "M508.52,249.75,486.7,236.24c-.17-2-.34-3.93-.55-5.88l18.72-17.5a7.35,7.35,0,0,0-2.44-12.25l-24-9c-.54-1.88-1.08-3.78-1.67-5.64l15-20.83a7.35,7.35,0,0,0-4.79-11.54l-25.42-4.15c-.9-1.73-1.79-3.45-2.73-5.15l10.68-23.42a7.35,7.35,0,0,0-6.95-10.39l-25.82.91q-1.79-2.22-3.61-4.4L439,81.84A7.36,7.36,0,0,0,430.16,73L405,78.93q-2.17-1.83-4.4-3.61l.91-25.82a7.35,7.35,0,0,0-10.39-7L367.7,53.23c-1.7-.94-3.43-1.84-5.15-2.73L358.4,25.08a7.35,7.35,0,0,0-11.54-4.79L326,35.26c-1.86-.59-3.75-1.13-5.64-1.67l-9-24a7.35,7.35,0,0,0-12.25-2.44l-17.5,18.72c-1.95-.21-3.91-.38-5.88-.55L262.25,3.48a7.35,7.35,0,0,0-12.5,0L236.24,25.3c-2,.17-3.93.34-5.88.55L212.86,7.13a7.35,7.35,0,0,0-12.25,2.44l-9,24c-1.89.55-3.79,1.08-5.66,1.68l-20.82-15a7.35,7.35,0,0,0-11.54,4.79l-4.15,25.41c-1.73.9-3.45,1.79-5.16,2.73L120.88,42.55a7.35,7.35,0,0,0-10.39,7l.92,25.81c-1.49,1.19-3,2.39-4.42,3.61L81.84,73A7.36,7.36,0,0,0,73,81.84L78.93,107c-1.23,1.45-2.43,2.93-3.62,4.41l-25.81-.91a7.42,7.42,0,0,0-6.37,3.26,7.35,7.35,0,0,0-.57,7.13l10.66,23.41c-.94,1.7-1.83,3.43-2.73,5.16L25.08,153.6a7.35,7.35,0,0,0-4.79,11.54l15,20.82c-.59,1.87-1.13,3.77-1.68,5.66l-24,9a7.35,7.35,0,0,0-2.44,12.25l18.72,17.5c-.21,1.95-.38,3.91-.55,5.88L3.48,249.75a7.35,7.35,0,0,0,0,12.5L25.3,275.76c.17,2,.34,3.92.55,5.87L7.13,299.13a7.35,7.35,0,0,0,2.44,12.25l24,9c.55,1.89,1.08,3.78,1.68,5.65l-15,20.83a7.35,7.35,0,0,0,4.79,11.54l25.42,4.15c.9,1.72,1.79,3.45,2.73,5.14L42.56,391.12a7.35,7.35,0,0,0,.57,7.13,7.13,7.13,0,0,0,6.37,3.26l25.83-.91q1.77,2.22,3.6,4.4L73,430.16A7.36,7.36,0,0,0,81.84,439L107,433.07q2.18,1.83,4.41,3.61l-.92,25.82a7.35,7.35,0,0,0,10.39,6.95l23.43-10.68c1.69.94,3.42,1.83,5.14,2.73l4.15,25.42a7.34,7.34,0,0,0,11.54,4.78l20.83-15c1.86.6,3.76,1.13,5.65,1.68l9,24a7.36,7.36,0,0,0,12.25,2.44l17.5-18.72c1.95.21,3.92.38,5.88.55l13.51,21.82a7.35,7.35,0,0,0,12.5,0l13.51-21.82c2-.17,3.93-.34,5.88-.56l17.5,18.73a7.36,7.36,0,0,0,12.25-2.44l9-24c1.89-.55,3.78-1.08,5.65-1.68l20.82,15a7.34,7.34,0,0,0,11.54-4.78l4.15-25.42c1.72-.9,3.45-1.79,5.15-2.73l23.42,10.68a7.35,7.35,0,0,0,10.39-6.95l-.91-25.82q2.22-1.79,4.4-3.61L430.16,439a7.36,7.36,0,0,0,8.84-8.84L433.07,405q1.83-2.17,3.61-4.4l25.82.91a7.23,7.23,0,0,0,6.37-3.26,7.35,7.35,0,0,0,.58-7.13L458.77,367.7c.94-1.7,1.83-3.43,2.73-5.15l25.42-4.15a7.35,7.35,0,0,0,4.79-11.54l-15-20.83c.59-1.87,1.13-3.76,1.67-5.65l24-9a7.35,7.35,0,0,0,2.44-12.25l-18.72-17.5c.21-1.95.38-3.91.55-5.87l21.82-13.51a7.35,7.35,0,0,0,0-12.5Zm-151,129.08A13.91,13.91,0,0,0,341,389.51l-7.64,35.67A187.51,187.51,0,0,1,177,424.44l-7.64-35.66a13.87,13.87,0,0,0-16.46-10.68l-31.51,6.76a187.38,187.38,0,0,1-16.26-19.21H258.3c1.72,0,2.89-.29,2.89-1.91V309.55c0-1.57-1.17-1.91-2.89-1.91H213.47l.05-34.35H262c4.41,0,23.66,1.28,29.79,25.87,1.91,7.55,6.17,32.14,9.06,40,2.89,8.82,14.6,26.46,27.1,26.46H407a187.3,187.3,0,0,1-17.34,20.09Zm25.77,34.49A15.24,15.24,0,1,1,368,398.08h.44A15.23,15.23,0,0,1,383.24,413.32Zm-225.62-.68a15.24,15.24,0,1,1-15.25-15.25h.45A15.25,15.25,0,0,1,157.62,412.64ZM69.57,234.15l32.83-14.6a13.88,13.88,0,0,0,7.06-18.33L102.69,186h26.56V305.73H75.65A187.65,187.65,0,0,1,69.57,234.15ZM58.31,198.09a15.24,15.24,0,0,1,15.23-15.25H74a15.24,15.24,0,1,1-15.67,15.24Zm155.16,24.49.05-35.32h63.26c3.28,0,23.07,3.77,23.07,18.62,0,12.29-15.19,16.7-27.68,16.7ZM399,306.71c-9.8,1.13-20.63-4.12-22-10.09-5.78-32.49-15.39-39.4-30.57-51.4,18.86-11.95,38.46-29.64,38.46-53.26,0-25.52-17.49-41.59-29.4-49.48-16.76-11-35.28-13.23-40.27-13.23H116.32A187.49,187.49,0,0,1,221.21,70.06l23.47,24.6a13.82,13.82,0,0,0,19.6.44l26.26-25a187.51,187.51,0,0,1,128.37,91.43l-18,40.57A14,14,0,0,0,408,220.43l34.59,15.33a187.12,187.12,0,0,1,.4,32.54H423.71c-1.91,0-2.69,1.27-2.69,3.13v8.82C421,301,409.31,305.58,399,306.71ZM240,60.21A15.24,15.24,0,0,1,255.21,45h.45A15.24,15.24,0,1,1,240,60.21ZM436.84,214a15.24,15.24,0,1,1,0-30.48h.44a15.24,15.24,0,0,1-.44,30.48Z"
    ]
};
var $ef0249c5e48bf4e3$export$423f2efa0d73b5f9 = {
    prefix: "fab",
    iconName: "wix",
    icon: [
        640,
        512,
        [],
        "f5cf",
        "M393.38 131.69c0 13.03 2.08 32.69-28.68 43.83-9.52 3.45-15.95 9.66-15.95 9.66 0-31 4.72-42.22 17.4-48.86 9.75-5.11 27.23-4.63 27.23-4.63zm-115.8 35.54l-34.24 132.66-28.48-108.57c-7.69-31.99-20.81-48.53-48.43-48.53-27.37 0-40.66 16.18-48.43 48.53L89.52 299.89 55.28 167.23C49.73 140.51 23.86 128.96 0 131.96l65.57 247.93s21.63 1.56 32.46-3.96c14.22-7.25 20.98-12.84 29.59-46.57 7.67-30.07 29.11-118.41 31.12-124.7 4.76-14.94 11.09-13.81 15.4 0 1.97 6.3 23.45 94.63 31.12 124.7 8.6 33.73 15.37 39.32 29.59 46.57 10.82 5.52 32.46 3.96 32.46 3.96l65.57-247.93c-24.42-3.07-49.82 8.93-55.3 35.27zm115.78 5.21s-4.1 6.34-13.46 11.57c-6.01 3.36-11.78 5.64-17.97 8.61-15.14 7.26-13.18 13.95-13.18 35.2v152.07s16.55 2.09 27.37-3.43c13.93-7.1 17.13-13.95 17.26-44.78V181.41l-.02.01v-8.98zm163.44 84.08L640 132.78s-35.11-5.98-52.5 9.85c-13.3 12.1-24.41 29.55-54.18 72.47-.47.73-6.25 10.54-13.07 0-29.29-42.23-40.8-60.29-54.18-72.47-17.39-15.83-52.5-9.85-52.5-9.85l83.2 123.74-82.97 123.36s36.57 4.62 53.95-11.21c11.49-10.46 17.58-20.37 52.51-70.72 6.81-10.52 12.57-.77 13.07 0 29.4 42.38 39.23 58.06 53.14 70.72 17.39 15.83 53.32 11.21 53.32 11.21L556.8 256.52z"
    ]
};
var $ef0249c5e48bf4e3$export$3a09eb8c07c8379f = {
    prefix: "fab",
    iconName: "square-behance",
    icon: [
        448,
        512,
        [
            "behance-square"
        ],
        "f1b5",
        "M186.5 293c0 19.3-14 25.4-31.2 25.4h-45.1v-52.9h46c18.6.1 30.3 7.8 30.3 27.5zm-7.7-82.3c0-17.7-13.7-21.9-28.9-21.9h-39.6v44.8H153c15.1 0 25.8-6.6 25.8-22.9zm132.3 23.2c-18.3 0-30.5 11.4-31.7 29.7h62.2c-1.7-18.5-11.3-29.7-30.5-29.7zM448 80v352c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V80c0-26.5 21.5-48 48-48h352c26.5 0 48 21.5 48 48zM271.7 185h77.8v-18.9h-77.8V185zm-43 110.3c0-24.1-11.4-44.9-35-51.6 17.2-8.2 26.2-17.7 26.2-37 0-38.2-28.5-47.5-61.4-47.5H68v192h93.1c34.9-.2 67.6-16.9 67.6-55.9zM380 280.5c0-41.1-24.1-75.4-67.6-75.4-42.4 0-71.1 31.8-71.1 73.6 0 43.3 27.3 73 71.1 73 33.2 0 54.7-14.9 65.1-46.8h-33.7c-3.7 11.9-18.6 18.1-30.2 18.1-22.4 0-34.1-13.1-34.1-35.3h100.2c.1-2.3.3-4.8.3-7.2z"
    ]
};
var $ef0249c5e48bf4e3$export$bb4b7fb598656746 = $ef0249c5e48bf4e3$export$3a09eb8c07c8379f;
var $ef0249c5e48bf4e3$export$9be373796460fb80 = {
    prefix: "fab",
    iconName: "supple",
    icon: [
        640,
        512,
        [],
        "f3f9",
        "M640 262.5c0 64.1-109 116.1-243.5 116.1-24.8 0-48.6-1.8-71.1-5 7.7.4 15.5.6 23.4.6 134.5 0 243.5-56.9 243.5-127.1 0-29.4-19.1-56.4-51.2-78 60 21.1 98.9 55.1 98.9 93.4zM47.7 227.9c-.1-70.2 108.8-127.3 243.3-127.6 7.9 0 15.6.2 23.3.5-22.5-3.2-46.3-4.9-71-4.9C108.8 96.3-.1 148.5 0 212.6c.1 38.3 39.1 72.3 99.3 93.3-32.3-21.5-51.5-48.6-51.6-78zm60.2 39.9s10.5 13.2 29.3 13.2c17.9 0 28.4-11.5 28.4-25.1 0-28-40.2-25.1-40.2-39.7 0-5.4 5.3-9.1 12.5-9.1 5.7 0 11.3 2.6 11.3 6.6v3.9h14.2v-7.9c0-12.1-15.4-16.8-25.4-16.8-16.5 0-28.5 10.2-28.5 24.1 0 26.6 40.2 25.4 40.2 39.9 0 6.6-5.8 10.1-12.3 10.1-11.9 0-20.7-10.1-20.7-10.1l-8.8 10.9zm120.8-73.6v54.4c0 11.3-7.1 17.8-17.8 17.8-10.7 0-17.8-6.5-17.8-17.7v-54.5h-15.8v55c0 18.9 13.4 31.9 33.7 31.9 20.1 0 33.4-13 33.4-31.9v-55h-15.7zm34.4 85.4h15.8v-29.5h15.5c16 0 27.2-11.5 27.2-28.1s-11.2-27.8-27.2-27.8h-39.1v13.4h7.8v72zm15.8-43v-29.1h12.9c8.7 0 13.7 5.7 13.7 14.4 0 8.9-5.1 14.7-14 14.7h-12.6zm57 43h15.8v-29.5h15.5c16 0 27.2-11.5 27.2-28.1s-11.2-27.8-27.2-27.8h-39.1v13.4h7.8v72zm15.7-43v-29.1h12.9c8.7 0 13.7 5.7 13.7 14.4 0 8.9-5 14.7-14 14.7h-12.6zm57.1 34.8c0 5.8 2.4 8.2 8.2 8.2h37.6c5.8 0 8.2-2.4 8.2-8.2v-13h-14.3v5.2c0 1.7-1 2.6-2.6 2.6h-18.6c-1.7 0-2.6-1-2.6-2.6v-61.2c0-5.7-2.4-8.2-8.2-8.2H401v13.4h5.2c1.7 0 2.6 1 2.6 2.6v61.2zm63.4 0c0 5.8 2.4 8.2 8.2 8.2H519c5.7 0 8.2-2.4 8.2-8.2v-13h-14.3v5.2c0 1.7-1 2.6-2.6 2.6h-19.7c-1.7 0-2.6-1-2.6-2.6v-20.3h27.7v-13.4H488v-22.4h19.2c1.7 0 2.6 1 2.6 2.6v5.2H524v-13c0-5.7-2.5-8.2-8.2-8.2h-51.6v13.4h7.8v63.9zm58.9-76v5.9h1.6v-5.9h2.7v-1.2h-7v1.2h2.7zm5.7-1.2v7.1h1.5v-5.7l2.3 5.7h1.3l2.3-5.7v5.7h1.5v-7.1h-2.3l-2.1 5.1-2.1-5.1h-2.4z"
    ]
};
var $ef0249c5e48bf4e3$export$50bb8725ea3b3e34 = {
    prefix: "fab",
    iconName: "rebel",
    icon: [
        512,
        512,
        [],
        "f1d0",
        "M256.5 504C117.2 504 9 387.8 13.2 249.9 16 170.7 56.4 97.7 129.7 49.5c.3 0 1.9-.6 1.1.8-5.8 5.5-111.3 129.8-14.1 226.4 49.8 49.5 90 2.5 90 2.5 38.5-50.1-.6-125.9-.6-125.9-10-24.9-45.7-40.1-45.7-40.1l28.8-31.8c24.4 10.5 43.2 38.7 43.2 38.7.8-29.6-21.9-61.4-21.9-61.4L255.1 8l44.3 50.1c-20.5 28.8-21.9 62.6-21.9 62.6 13.8-23 43.5-39.3 43.5-39.3l28.5 31.8c-27.4 8.9-45.4 39.9-45.4 39.9-15.8 28.5-27.1 89.4.6 127.3 32.4 44.6 87.7-2.8 87.7-2.8 102.7-91.9-10.5-225-10.5-225-6.1-5.5.8-2.8.8-2.8 50.1 36.5 114.6 84.4 116.2 204.8C500.9 400.2 399 504 256.5 504z"
    ]
};
var $ef0249c5e48bf4e3$export$f32e22910f9b44 = {
    prefix: "fab",
    iconName: "css3",
    icon: [
        512,
        512,
        [],
        "f13c",
        "M480 32l-64 368-223.3 80L0 400l19.6-94.8h82l-8 40.6L210 390.2l134.1-44.4 18.8-97.1H29.5l16-82h333.7l10.5-52.7H56.3l16.3-82H480z"
    ]
};
var $ef0249c5e48bf4e3$export$ffbc7f79ed77f082 = {
    prefix: "fab",
    iconName: "staylinked",
    icon: [
        440,
        512,
        [],
        "f3f5",
        "M382.7 292.5l2.7 2.7-170-167.3c-3.5-3.5-9.7-3.7-13.8-.5L144.3 171c-4.2 3.2-4.6 8.7-1.1 12.2l68.1 64.3c3.6 3.5 9.9 3.7 14 .5l.1-.1c4.1-3.2 10.4-3 14 .5l84 81.3c3.6 3.5 3.2 9-.9 12.2l-93.2 74c-4.2 3.3-10.5 3.1-14.2-.4L63.2 268c-3.5-3.5-9.7-3.7-13.9-.5L3.5 302.4c-4.2 3.2-4.7 8.7-1.2 12.2L211 510.7s7.4 6.8 17.3-.8l198-163.9c4-3.2 4.4-8.7.7-12.2zm54.5-83.4L226.7 2.5c-1.5-1.2-8-5.5-16.3 1.1L3.6 165.7c-4.2 3.2-4.8 8.7-1.2 12.2l42.3 41.7 171.7 165.1c3.7 3.5 10.1 3.7 14.3.4l50.2-38.8-.3-.3 7.7-6c4.2-3.2 4.6-8.7.9-12.2l-57.1-54.4c-3.6-3.5-10-3.7-14.2-.5l-.1.1c-4.2 3.2-10.5 3.1-14.2-.4L109 180.8c-3.6-3.5-3.1-8.9 1.1-12.2l92.2-71.5c4.1-3.2 10.3-3 13.9.5l160.4 159c3.7 3.5 10 3.7 14.1.5l45.8-35.8c4.1-3.2 4.4-8.7.7-12.2z"
    ]
};
var $ef0249c5e48bf4e3$export$a03842279a704aae = {
    prefix: "fab",
    iconName: "kaggle",
    icon: [
        320,
        512,
        [],
        "f5fa",
        "M304.2 501.5L158.4 320.3 298.2 185c2.6-2.7 1.7-10.5-5.3-10.5h-69.2c-3.5 0-7 1.8-10.5 5.3L80.9 313.5V7.5q0-7.5-7.5-7.5H21.5Q14 0 14 7.5v497q0 7.5 7.5 7.5h51.9q7.5 0 7.5-7.5v-109l30.8-29.3 110.5 140.6c3 3.5 6.5 5.3 10.5 5.3h66.9q5.25 0 6-3z"
    ]
};
var $ef0249c5e48bf4e3$export$1aecd37105f38798 = {
    prefix: "fab",
    iconName: "space-awesome",
    icon: [
        512,
        512,
        [],
        "e5ac",
        "M96 256H128V512H0V352H32V320H64V288H96V256zM512 352V512H384V256H416V288H448V320H480V352H512zM320 64H352V448H320V416H192V448H160V64H192V32H224V0H288V32H320V64zM288 128H224V192H288V128z"
    ]
};
var $ef0249c5e48bf4e3$export$36a61c57a904744e = {
    prefix: "fab",
    iconName: "deviantart",
    icon: [
        320,
        512,
        [],
        "f1bd",
        "M320 93.2l-98.2 179.1 7.4 9.5H320v127.7H159.1l-13.5 9.2-43.7 84c-.3 0-8.6 8.6-9.2 9.2H0v-93.2l93.2-179.4-7.4-9.2H0V102.5h156l13.5-9.2 43.7-84c.3 0 8.6-8.6 9.2-9.2H320v93.1z"
    ]
};
var $ef0249c5e48bf4e3$export$4b1cbad29e4915c6 = {
    prefix: "fab",
    iconName: "cpanel",
    icon: [
        640,
        512,
        [],
        "f388",
        "M210.3 220.2c-5.6-24.8-26.9-41.2-51-41.2h-37c-7.1 0-12.5 4.5-14.3 10.9L73.1 320l24.7-.1c6.8 0 12.3-4.5 14.2-10.7l25.8-95.7h19.8c8.4 0 16.2 5.6 18.3 14.8 2.5 10.9-5.9 22.6-18.3 22.6h-10.3c-7 0-12.5 4.6-14.3 10.8l-6.4 23.8h32c37.2 0 58.3-36.2 51.7-65.3zm-156.5 28h18.6c6.9 0 12.4-4.4 14.3-10.9l6.2-23.6h-40C30 213.7 9 227.8 1.7 254.8-7 288.6 18.5 320 52 320h12.4l7.1-26.1c1.2-4.4-2.2-8.3-6.4-8.3H53.8c-24.7 0-24.9-37.4 0-37.4zm247.5-34.8h-77.9l-3.5 13.4c-2.4 9.6 4.5 18.5 14.2 18.5h57.5c4 0 2.4 4.3 2.1 5.3l-8.6 31.8c-.4 1.4-.9 5.3-5.5 5.3h-34.9c-5.3 0-5.3-7.9 0-7.9h21.6c6.8 0 12.3-4.6 14.2-10.8l3.5-13.2h-48.4c-39.2 0-43.6 63.8-.7 63.8l57.5.2c11.2 0 20.6-7.2 23.4-17.8l14-51.8c4.8-19.2-9.7-36.8-28.5-36.8zM633.1 179h-18.9c-4.9 0-9.2 3.2-10.4 7.9L568.2 320c20.7 0 39.8-13.8 44.9-34.5l26.5-98.2c1.2-4.3-2-8.3-6.5-8.3zm-236.3 34.7v.1h-48.3l-26.2 98c-1.2 4.4 2.2 8.3 6.4 8.3h18.9c4.8 0 9.2-3 10.4-7.8l17.2-64H395c12.5 0 21.4 11.8 18.1 23.4l-10.6 40c-1.2 4.3 1.9 8.3 6.4 8.3H428c4.6 0 9.1-2.9 10.3-7.8l8.8-33.1c9-33.1-15.9-65.4-50.3-65.4zm98.3 74.6c-3.6 0-6-3.4-5.1-6.7l8-30c.9-3.9 3.7-6 7.8-6h32.9c2.6 0 4.6 2.4 3.9 5.1l-.7 2.6c-.6 2-1.9 3-3.9 3h-21.6c-7 0-12.6 4.6-14.2 10.8l-3.5 13h53.4c10.5 0 20.3-6.6 23.2-17.6l3.2-12c4.9-19.1-9.3-36.8-28.3-36.8h-47.3c-17.9 0-33.8 12-38.6 29.6l-10.8 40c-5 17.7 8.3 36.7 28.3 36.7h66.7c6.8 0 12.3-4.5 14.2-10.7l5.7-21z"
    ]
};
var $ef0249c5e48bf4e3$export$659cd0fc2157d001 = {
    prefix: "fab",
    iconName: "goodreads-g",
    icon: [
        384,
        512,
        [],
        "f3a9",
        "M42.6 403.3h2.8c12.7 0 25.5 0 38.2.1 1.6 0 3.1-.4 3.6 2.1 7.1 34.9 30 54.6 62.9 63.9 26.9 7.6 54.1 7.8 81.3 1.8 33.8-7.4 56-28.3 68-60.4 8-21.5 10.7-43.8 11-66.5.1-5.8.3-47-.2-52.8l-.9-.3c-.8 1.5-1.7 2.9-2.5 4.4-22.1 43.1-61.3 67.4-105.4 69.1-103 4-169.4-57-172-176.2-.5-23.7 1.8-46.9 8.3-69.7C58.3 47.7 112.3.6 191.6 0c61.3-.4 101.5 38.7 116.2 70.3.5 1.1 1.3 2.3 2.4 1.9V10.6h44.3c0 280.3.1 332.2.1 332.2-.1 78.5-26.7 143.7-103 162.2-69.5 16.9-159 4.8-196-57.2-8-13.5-11.8-28.3-13-44.5zM188.9 36.5c-52.5-.5-108.5 40.7-115 133.8-4.1 59 14.8 122.2 71.5 148.6 27.6 12.9 74.3 15 108.3-8.7 47.6-33.2 62.7-97 54.8-154-9.7-71.1-47.8-120-119.6-119.7z"
    ]
};
var $ef0249c5e48bf4e3$export$ccce513bbd3bef1d = {
    prefix: "fab",
    iconName: "square-git",
    icon: [
        448,
        512,
        [
            "git-square"
        ],
        "f1d2",
        "M100.59 334.24c48.57 3.31 58.95 2.11 58.95 11.94 0 20-65.55 20.06-65.55 1.52.01-5.09 3.29-9.4 6.6-13.46zm27.95-116.64c-32.29 0-33.75 44.47-.75 44.47 32.51 0 31.71-44.47.75-44.47zM448 80v352a48 48 0 0 1-48 48H48a48 48 0 0 1-48-48V80a48 48 0 0 1 48-48h352a48 48 0 0 1 48 48zm-227 69.31c0 14.49 8.38 22.88 22.86 22.88 14.74 0 23.13-8.39 23.13-22.88S258.62 127 243.88 127c-14.48 0-22.88 7.84-22.88 22.31zM199.18 195h-49.55c-25-6.55-81.56-4.85-81.56 46.75 0 18.8 9.4 32 21.85 38.11C74.23 294.23 66.8 301 66.8 310.6c0 6.87 2.79 13.22 11.18 16.76-8.9 8.4-14 14.48-14 25.92C64 373.35 81.53 385 127.52 385c44.22 0 69.87-16.51 69.87-45.73 0-36.67-28.23-35.32-94.77-39.38l8.38-13.43c17 4.74 74.19 6.23 74.19-42.43 0-11.69-4.83-19.82-9.4-25.67l23.38-1.78zm84.34 109.84l-13-1.78c-3.82-.51-4.07-1-4.07-5.09V192.52h-52.6l-2.79 20.57c15.75 5.55 17 4.86 17 10.17V298c0 5.62-.31 4.58-17 6.87v20.06h72.42zM384 315l-6.87-22.37c-40.93 15.37-37.85-12.41-37.85-16.73v-60.72h37.85v-25.41h-35.82c-2.87 0-2 2.52-2-38.63h-24.18c-2.79 27.7-11.68 38.88-34 41.42v22.62c20.47 0 19.82-.85 19.82 2.54v66.57c0 28.72 11.43 40.91 41.67 40.91 14.45 0 30.45-4.83 41.38-10.2z"
    ]
};
var $ef0249c5e48bf4e3$export$545247d36a0c2435 = $ef0249c5e48bf4e3$export$ccce513bbd3bef1d;
var $ef0249c5e48bf4e3$export$b22e93e631701aa0 = {
    prefix: "fab",
    iconName: "square-tumblr",
    icon: [
        448,
        512,
        [
            "tumblr-square"
        ],
        "f174",
        "M400 32H48C21.5 32 0 53.5 0 80v352c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48V80c0-26.5-21.5-48-48-48zm-82.3 364.2c-8.5 9.1-31.2 19.8-60.9 19.8-75.5 0-91.9-55.5-91.9-87.9v-90h-29.7c-3.4 0-6.2-2.8-6.2-6.2v-42.5c0-4.5 2.8-8.5 7.1-10 38.8-13.7 50.9-47.5 52.7-73.2.5-6.9 4.1-10.2 10-10.2h44.3c3.4 0 6.2 2.8 6.2 6.2v72h51.9c3.4 0 6.2 2.8 6.2 6.2v51.1c0 3.4-2.8 6.2-6.2 6.2h-52.1V321c0 21.4 14.8 33.5 42.5 22.4 3-1.2 5.6-2 8-1.4 2.2.5 3.6 2.1 4.6 4.9l13.8 40.2c1 3.2 2 6.7-.3 9.1z"
    ]
};
var $ef0249c5e48bf4e3$export$b3979340ece626fe = $ef0249c5e48bf4e3$export$b22e93e631701aa0;
var $ef0249c5e48bf4e3$export$33a1efa865dd0849 = {
    prefix: "fab",
    iconName: "trello",
    icon: [
        448,
        512,
        [],
        "f181",
        "M392.3 32H56.1C25.1 32 0 57.1 0 88c-.1 0 0-4 0 336 0 30.9 25.1 56 56 56h336.2c30.8-.2 55.7-25.2 55.7-56V88c.1-30.8-24.8-55.8-55.6-56zM197 371.3c-.2 14.7-12.1 26.6-26.9 26.6H87.4c-14.8.1-26.9-11.8-27-26.6V117.1c0-14.8 12-26.9 26.9-26.9h82.9c14.8 0 26.9 12 26.9 26.9v254.2zm193.1-112c0 14.8-12 26.9-26.9 26.9h-81c-14.8 0-26.9-12-26.9-26.9V117.2c0-14.8 12-26.9 26.8-26.9h81.1c14.8 0 26.9 12 26.9 26.9v142.1z"
    ]
};
var $ef0249c5e48bf4e3$export$e119d42c61b568e2 = {
    prefix: "fab",
    iconName: "creative-commons-nc-jp",
    icon: [
        496,
        512,
        [],
        "f4ea",
        "M247.7 8C103.6 8 0 124.8 0 256c0 136.4 111.8 248 247.7 248C377.9 504 496 403.2 496 256 496 117.2 388.5 8 247.7 8zm.6 450.7c-112 0-203.6-92.5-203.6-202.7 0-21.1 3-41.2 9-60.3l127 56.5h-27.9v38.6h58.1l5.7 11.8v18.7h-63.8V360h63.8v56h61.7v-56h64.2v-35.7l81 36.1c-1.5 2.2-57.1 98.3-175.2 98.3zm87.6-137.3h-57.6v-18.7l2.9-5.6 54.7 24.3zm6.5-51.4v-17.8h-38.6l63-116H301l-43.4 96-23-10.2-39.6-85.7h-65.8l27.3 51-81.9-36.5c27.8-44.1 82.6-98.1 173.7-98.1 112.8 0 203 90 203 203.4 0 21-2.7 40.6-7.9 59l-101-45.1z"
    ]
};
var $ef0249c5e48bf4e3$export$17e9384897437d5a = {
    prefix: "fab",
    iconName: "get-pocket",
    icon: [
        448,
        512,
        [],
        "f265",
        "M407.6 64h-367C18.5 64 0 82.5 0 104.6v135.2C0 364.5 99.7 464 224.2 464c124 0 223.8-99.5 223.8-224.2V104.6c0-22.4-17.7-40.6-40.4-40.6zm-162 268.5c-12.4 11.8-31.4 11.1-42.4 0C89.5 223.6 88.3 227.4 88.3 209.3c0-16.9 13.8-30.7 30.7-30.7 17 0 16.1 3.8 105.2 89.3 90.6-86.9 88.6-89.3 105.5-89.3 16.9 0 30.7 13.8 30.7 30.7 0 17.8-2.9 15.7-114.8 123.2z"
    ]
};
var $ef0249c5e48bf4e3$export$53e7f606db333d60 = {
    prefix: "fab",
    iconName: "perbyte",
    icon: [
        448,
        512,
        [],
        "e083",
        "M305.314,284.578H246.6V383.3h58.711q24.423,0,38.193-13.77t13.77-36.11q0-21.826-14.032-35.335T305.314,284.578ZM149.435,128.7H90.724v98.723h58.711q24.42,0,38.19-13.773t13.77-36.107q0-21.826-14.029-35.338T149.435,128.7ZM366.647,32H81.353A81.445,81.445,0,0,0,0,113.352V398.647A81.445,81.445,0,0,0,81.353,480H366.647A81.445,81.445,0,0,0,448,398.647V113.352A81.445,81.445,0,0,0,366.647,32Zm63.635,366.647a63.706,63.706,0,0,1-63.635,63.635H81.353a63.706,63.706,0,0,1-63.635-63.635V113.352A63.706,63.706,0,0,1,81.353,49.718H366.647a63.706,63.706,0,0,1,63.635,63.634ZM305.314,128.7H246.6v98.723h58.711q24.423,0,38.193-13.773t13.77-36.107q0-21.826-14.032-35.338T305.314,128.7Z"
    ]
};
var $ef0249c5e48bf4e3$export$b84863db58925c09 = {
    prefix: "fab",
    iconName: "grunt",
    icon: [
        384,
        512,
        [],
        "f3ad",
        "M61.3 189.3c-1.1 10 5.2 19.1 5.2 19.1.7-7.5 2.2-12.8 4-16.6.4 10.3 3.2 23.5 12.8 34.1 6.9 7.6 35.6 23.3 54.9 6.1 1 2.4 2.1 5.3 3 8.5 2.9 10.3-2.7 25.3-2.7 25.3s15.1-17.1 13.9-32.5c10.8-.5 21.4-8.4 21.1-19.5 0 0-18.9 10.4-35.5-8.8-9.7-11.2-40.9-42-83.1-31.8 4.3 1 8.9 2.4 13.5 4.1h-.1c-4.2 2-6.5 7.1-7 12zm28.3-1.8c19.5 11 37.4 25.7 44.9 37-5.7 3.3-21.7 10.4-38-1.7-10.3-7.6-9.8-26.2-6.9-35.3zm142.1 45.8c-1.2 15.5 13.9 32.5 13.9 32.5s-5.6-15-2.7-25.3c.9-3.2 2-6 3-8.5 19.3 17.3 48 1.5 54.8-6.1 9.6-10.6 12.3-23.8 12.8-34.1 1.8 3.8 3.4 9.1 4 16.6 0 0 6.4-9.1 5.2-19.1-.6-5-2.9-10-7-11.8h-.1c4.6-1.8 9.2-3.2 13.5-4.1-42.3-10.2-73.4 20.6-83.1 31.8-16.7 19.2-35.5 8.8-35.5 8.8-.2 10.9 10.4 18.9 21.2 19.3zm62.7-45.8c3 9.1 3.4 27.7-7 35.4-16.3 12.1-32.2 5-37.9 1.6 7.5-11.4 25.4-26 44.9-37zM160 418.5h-29.4c-5.5 0-8.2 1.6-9.5 2.9-1.9 2-2.2 4.7-.9 8.1 3.5 9.1 11.4 16.5 13.7 18.6 3.1 2.7 7.5 4.3 11.8 4.3 4.4 0 8.3-1.7 11-4.6 7.5-8.2 11.9-17.1 13-19.8.6-1.5 1.3-4.5-.9-6.8-1.8-1.8-4.7-2.7-8.8-2.7zm189.2-101.2c-2.4 17.9-13 33.8-24.6 43.7-3.1-22.7-3.7-55.5-3.7-62.4 0-14.7 9.5-24.5 12.2-26.1 2.5-1.5 5.4-3 8.3-4.6 18-9.6 40.4-21.6 40.4-43.7 0-16.2-9.3-23.2-15.4-27.8-.8-.6-1.5-1.1-2.2-1.7-2.1-1.7-3.7-3-4.3-4.4-4.4-9.8-3.6-34.2-1.7-37.6.6-.6 16.7-20.9 11.8-39.2-2-7.4-6.9-13.3-14.1-17-5.3-2.7-11.9-4.2-19.5-4.5-.1-2-.5-3.9-.9-5.9-.6-2.6-1.1-5.3-.9-8.1.4-4.7.8-9 2.2-11.3 8.4-13.3 28.8-17.6 29-17.6l12.3-2.4-8.1-9.5c-.1-.2-17.3-17.5-46.3-17.5-7.9 0-16 1.3-24.1 3.9-24.2 7.8-42.9 30.5-49.4 39.3-3.1-1-6.3-1.9-9.6-2.7-4.2-15.8 9-38.5 9-38.5s-13.6-3-33.7 15.2c-2.6-6.5-8.1-20.5-1.8-37.2C184.6 10.1 177.2 26 175 40.4c-7.6-5.4-6.7-23.1-7.2-27.6-7.5.9-29.2 21.9-28.2 48.3-2 .5-3.9 1.1-5.9 1.7-6.5-8.8-25.1-31.5-49.4-39.3-7.9-2.2-16-3.5-23.9-3.5-29 0-46.1 17.3-46.3 17.5L6 46.9l12.3 2.4c.2 0 20.6 4.3 29 17.6 1.4 2.2 1.8 6.6 2.2 11.3.2 2.8-.4 5.5-.9 8.1-.4 1.9-.8 3.9-.9 5.9-7.7.3-14.2 1.8-19.5 4.5-7.2 3.7-12.1 9.6-14.1 17-5 18.2 11.2 38.5 11.8 39.2 1.9 3.4 2.7 27.8-1.7 37.6-.6 1.4-2.2 2.7-4.3 4.4-.7.5-1.4 1.1-2.2 1.7-6.1 4.6-15.4 11.7-15.4 27.8 0 22.1 22.4 34.1 40.4 43.7 3 1.6 5.8 3.1 8.3 4.6 2.7 1.6 12.2 11.4 12.2 26.1 0 6.9-.6 39.7-3.7 62.4-11.6-9.9-22.2-25.9-24.6-43.8 0 0-29.2 22.6-20.6 70.8 5.2 29.5 23.2 46.1 47 54.7 8.8 19.1 29.4 45.7 67.3 49.6C143 504.3 163 512 192.2 512h.2c29.1 0 49.1-7.7 63.6-19.5 37.9-3.9 58.5-30.5 67.3-49.6 23.8-8.7 41.7-25.2 47-54.7 8.2-48.4-21.1-70.9-21.1-70.9zM305.7 37.7c5.6-1.8 11.6-2.7 17.7-2.7 11 0 19.9 3 24.7 5-3.1 1.4-6.4 3.2-9.7 5.3-2.4-.4-5.6-.8-9.2-.8-10.5 0-20.5 3.1-28.7 8.9-12.3 8.7-18 16.9-20.7 22.4-2.2-1.3-4.5-2.5-7.1-3.7-1.6-.8-3.1-1.5-4.7-2.2 6.1-9.1 19.9-26.5 37.7-32.2zm21 18.2c-.8 1-1.6 2.1-2.3 3.2-3.3 5.2-3.9 11.6-4.4 17.8-.5 6.4-1.1 12.5-4.4 17-4.2.8-8.1 1.7-11.5 2.7-2.3-3.1-5.6-7-10.5-11.2 1.4-4.8 5.5-16.1 13.5-22.5 5.6-4.3 12.2-6.7 19.6-7zM45.6 45.3c-3.3-2.2-6.6-4-9.7-5.3 4.8-2 13.7-5 24.7-5 6.1 0 12 .9 17.7 2.7 17.8 5.8 31.6 23.2 37.7 32.1-1.6.7-3.2 1.4-4.8 2.2-2.5 1.2-4.9 2.5-7.1 3.7-2.6-5.4-8.3-13.7-20.7-22.4-8.3-5.8-18.2-8.9-28.8-8.9-3.4.1-6.6.5-9 .9zm44.7 40.1c-4.9 4.2-8.3 8-10.5 11.2-3.4-.9-7.3-1.9-11.5-2.7C65 89.5 64.5 83.4 64 77c-.5-6.2-1.1-12.6-4.4-17.8-.7-1.1-1.5-2.2-2.3-3.2 7.4.3 14 2.6 19.5 7 8 6.3 12.1 17.6 13.5 22.4zM58.1 259.9c-2.7-1.6-5.6-3.1-8.4-4.6-14.9-8-30.2-16.3-30.2-30.5 0-11.1 4.3-14.6 8.9-18.2l.5-.4c.7-.6 1.4-1.2 2.2-1.8-.9 7.2-1.9 13.3-2.7 14.9 0 0 12.1-15 15.7-44.3 1.4-11.5-1.1-34.3-5.1-43 .2 4.9 0 9.8-.3 14.4-.4-.8-.8-1.6-1.3-2.2-3.2-4-11.8-17.5-9.4-26.6.9-3.5 3.1-6 6.7-7.8 3.8-1.9 8.8-2.9 15.1-2.9 12.3 0 25.9 3.7 32.9 6 25.1 8 55.4 30.9 64.1 37.7.2.2.4.3.4.3l5.6 3.9-3.5-5.8c-.2-.3-19.1-31.4-53.2-46.5 2-2.9 7.4-8.1 21.6-15.1 21.4-10.5 46.5-15.8 74.3-15.8 27.9 0 52.9 5.3 74.3 15.8 14.2 6.9 19.6 12.2 21.6 15.1-34 15.1-52.9 46.2-53.1 46.5l-3.5 5.8 5.6-3.9s.2-.1.4-.3c8.7-6.8 39-29.8 64.1-37.7 7-2.2 20.6-6 32.9-6 6.3 0 11.3 1 15.1 2.9 3.5 1.8 5.7 4.4 6.7 7.8 2.5 9.1-6.1 22.6-9.4 26.6-.5.6-.9 1.3-1.3 2.2-.3-4.6-.5-9.5-.3-14.4-4 8.8-6.5 31.5-5.1 43 3.6 29.3 15.7 44.3 15.7 44.3-.8-1.6-1.8-7.7-2.7-14.9.7.6 1.5 1.2 2.2 1.8l.5.4c4.6 3.7 8.9 7.1 8.9 18.2 0 14.2-15.4 22.5-30.2 30.5-2.9 1.5-5.7 3.1-8.4 4.6-8.7 5-18 16.7-19.1 34.2-.9 14.6.9 49.9 3.4 75.9-12.4 4.8-26.7 6.4-39.7 6.8-2-4.1-3.9-8.5-5.5-13.1-.7-2-19.6-51.1-26.4-62.2 5.5 39 17.5 73.7 23.5 89.6-3.5-.5-7.3-.7-11.7-.7h-117c-4.4 0-8.3.3-11.7.7 6-15.9 18.1-50.6 23.5-89.6-6.8 11.2-25.7 60.3-26.4 62.2-1.6 4.6-3.5 9-5.5 13.1-13-.4-27.2-2-39.7-6.8 2.5-26 4.3-61.2 3.4-75.9-.9-17.4-10.3-29.2-19-34.2zM34.8 404.6c-12.1-20-8.7-54.1-3.7-59.1 10.9 34.4 47.2 44.3 74.4 45.4-2.7 4.2-5.2 7.6-7 10l-1.4 1.4c-7.2 7.8-8.6 18.5-4.1 31.8-22.7-.1-46.3-9.8-58.2-29.5zm45.7 43.5c6 1.1 12.2 1.9 18.6 2.4 3.5 8 7.4 15.9 12.3 23.1-14.4-5.9-24.4-16-30.9-25.5zM192 498.2c-60.6-.1-78.3-45.8-84.9-64.7-3.7-10.5-3.4-18.2.9-23.1 2.9-3.3 9.5-7.2 24.6-7.2h118.8c15.1 0 21.8 3.9 24.6 7.2 4.2 4.8 4.5 12.6.9 23.1-6.6 18.8-24.3 64.6-84.9 64.7zm80.6-24.6c4.9-7.2 8.8-15.1 12.3-23.1 6.4-.5 12.6-1.3 18.6-2.4-6.5 9.5-16.5 19.6-30.9 25.5zm76.6-69c-12 19.7-35.6 29.3-58.1 29.7 4.5-13.3 3.1-24.1-4.1-31.8-.4-.5-.9-1-1.4-1.5-1.8-2.4-4.3-5.8-7-10 27.2-1.2 63.5-11 74.4-45.4 5 5 8.4 39.1-3.8 59zM191.9 187.7h.2c12.7-.1 27.2-17.8 27.2-17.8-9.9 6-18.8 8.1-27.3 8.3-8.5-.2-17.4-2.3-27.3-8.3 0 0 14.5 17.6 27.2 17.8zm61.7 230.7h-29.4c-4.2 0-7.2.9-8.9 2.7-2.2 2.3-1.5 5.2-.9 6.7 1 2.6 5.5 11.3 13 19.3 2.7 2.9 6.6 4.5 11 4.5s8.7-1.6 11.8-4.2c2.3-2 10.2-9.2 13.7-18.1 1.3-3.3 1-6-.9-7.9-1.3-1.3-4-2.9-9.4-3z"
    ]
};
var $ef0249c5e48bf4e3$export$33e64266c9adb232 = {
    prefix: "fab",
    iconName: "weebly",
    icon: [
        512,
        512,
        [],
        "f5cc",
        "M425.09 65.83c-39.88 0-73.28 25.73-83.66 64.33-18.16-58.06-65.5-64.33-84.95-64.33-19.78 0-66.8 6.28-85.28 64.33-10.38-38.6-43.45-64.33-83.66-64.33C38.59 65.83 0 99.72 0 143.03c0 28.96 4.18 33.27 77.17 233.48 22.37 60.57 67.77 69.35 92.74 69.35 39.23 0 70.04-19.46 85.93-53.98 15.89 34.83 46.69 54.29 85.93 54.29 24.97 0 70.36-9.1 92.74-69.67 76.55-208.65 77.5-205.58 77.5-227.2.63-48.32-36.01-83.47-86.92-83.47zm26.34 114.81l-65.57 176.44c-7.92 21.49-21.22 37.22-46.24 37.22-23.44 0-37.38-12.41-44.03-33.9l-39.28-117.42h-.95L216.08 360.4c-6.96 21.5-20.9 33.6-44.02 33.6-25.02 0-38.33-15.74-46.24-37.22L60.88 181.55c-5.38-14.83-7.92-23.91-7.92-34.5 0-16.34 15.84-29.36 38.33-29.36 18.69 0 31.99 11.8 36.11 29.05l44.03 139.82h.95l44.66-136.79c6.02-19.67 16.47-32.08 38.96-32.08s32.94 12.11 38.96 32.08l44.66 136.79h.95l44.03-139.82c4.12-17.25 17.42-29.05 36.11-29.05 22.17 0 38.33 13.32 38.33 35.71-.32 7.87-4.12 16.04-7.61 27.24z"
    ]
};
var $ef0249c5e48bf4e3$export$38091cf7f8c68318 = {
    prefix: "fab",
    iconName: "connectdevelop",
    icon: [
        576,
        512,
        [],
        "f20e",
        "M550.5 241l-50.089-86.786c1.071-2.142 1.875-4.553 1.875-7.232 0-8.036-6.696-14.733-14.732-15.001l-55.447-95.893c.536-1.607 1.071-3.214 1.071-4.821 0-8.571-6.964-15.268-15.268-15.268-4.821 0-8.839 2.143-11.786 5.625H299.518C296.839 18.143 292.821 16 288 16s-8.839 2.143-11.518 5.625H170.411C167.464 18.143 163.447 16 158.625 16c-8.303 0-15.268 6.696-15.268 15.268 0 1.607.536 3.482 1.072 4.821l-55.983 97.233c-5.356 2.41-9.107 7.5-9.107 13.661 0 .535.268 1.071.268 1.607l-53.304 92.143c-7.232 1.339-12.59 7.5-12.59 15 0 7.232 5.089 13.393 12.054 15l55.179 95.358c-.536 1.607-.804 2.946-.804 4.821 0 7.232 5.089 13.393 12.054 14.732l51.697 89.732c-.536 1.607-1.071 3.482-1.071 5.357 0 8.571 6.964 15.268 15.268 15.268 4.821 0 8.839-2.143 11.518-5.357h106.875C279.161 493.857 283.447 496 288 496s8.839-2.143 11.518-5.357h107.143c2.678 2.946 6.696 4.821 10.982 4.821 8.571 0 15.268-6.964 15.268-15.268 0-1.607-.267-2.946-.803-4.285l51.697-90.268c6.964-1.339 12.054-7.5 12.054-14.732 0-1.607-.268-3.214-.804-4.821l54.911-95.358c6.964-1.339 12.322-7.5 12.322-15-.002-7.232-5.092-13.393-11.788-14.732zM153.535 450.732l-43.66-75.803h43.66v75.803zm0-83.839h-43.66c-.268-1.071-.804-2.142-1.339-3.214l44.999-47.41v50.624zm0-62.411l-50.357 53.304c-1.339-.536-2.679-1.34-4.018-1.607L43.447 259.75c.535-1.339.535-2.679.535-4.018s0-2.41-.268-3.482l51.965-90c2.679-.268 5.357-1.072 7.768-2.679l50.089 51.965v92.946zm0-102.322l-45.803-47.41c1.339-2.143 2.143-4.821 2.143-7.767 0-.268-.268-.804-.268-1.072l43.928-15.804v72.053zm0-80.625l-43.66 15.804 43.66-75.536v59.732zm326.519 39.108l.804 1.339L445.5 329.125l-63.75-67.232 98.036-101.518.268.268zM291.75 355.107l11.518 11.786H280.5l11.25-11.786zm-.268-11.25l-83.303-85.446 79.553-84.375 83.036 87.589-79.286 82.232zm5.357 5.893l79.286-82.232 67.5 71.25-5.892 28.125H313.714l-16.875-17.143zM410.411 44.393c1.071.536 2.142 1.072 3.482 1.34l57.857 100.714v.536c0 2.946.803 5.624 2.143 7.767L376.393 256l-83.035-87.589L410.411 44.393zm-9.107-2.143L287.732 162.518l-57.054-60.268 166.339-60h4.287zm-123.483 0c2.678 2.678 6.16 4.285 10.179 4.285s7.5-1.607 10.179-4.285h75L224.786 95.821 173.893 42.25h103.928zm-116.249 5.625l1.071-2.142a33.834 33.834 0 0 0 2.679-.804l51.161 53.84-54.911 19.821V47.875zm0 79.286l60.803-21.964 59.732 63.214-79.553 84.107-40.982-42.053v-83.304zm0 92.678L198 257.607l-36.428 38.304v-76.072zm0 87.858l42.053-44.464 82.768 85.982-17.143 17.678H161.572v-59.196zm6.964 162.053c-1.607-1.607-3.482-2.678-5.893-3.482l-1.071-1.607v-89.732h99.91l-91.607 94.821h-1.339zm129.911 0c-2.679-2.41-6.428-4.285-10.447-4.285s-7.767 1.875-10.447 4.285h-96.429l91.607-94.821h38.304l91.607 94.821H298.447zm120-11.786l-4.286 7.5c-1.339.268-2.41.803-3.482 1.339l-89.196-91.875h114.376l-17.412 83.036zm12.856-22.232l12.858-60.803h21.964l-34.822 60.803zm34.822-68.839h-20.357l4.553-21.16 17.143 18.214c-.535.803-1.071 1.874-1.339 2.946zm66.161-107.411l-55.447 96.697c-1.339.535-2.679 1.071-4.018 1.874l-20.625-21.964 34.554-163.928 45.803 79.286c-.267 1.339-.803 2.678-.803 4.285 0 1.339.268 2.411.536 3.75z"
    ]
};
var $ef0249c5e48bf4e3$export$c6c358b395e9032d = {
    prefix: "fab",
    iconName: "leanpub",
    icon: [
        576,
        512,
        [],
        "f212",
        "M386.539 111.485l15.096 248.955-10.979-.275c-36.232-.824-71.64 8.783-102.657 27.997-31.016-19.214-66.424-27.997-102.657-27.997-45.564 0-82.07 10.705-123.516 27.723L93.117 129.6c28.546-11.803 61.484-18.115 92.226-18.115 41.173 0 73.836 13.175 102.657 42.544 27.723-28.271 59.013-41.721 98.539-42.544zM569.07 448c-25.526 0-47.485-5.215-70.542-15.645-34.31-15.645-69.993-24.978-107.871-24.978-38.977 0-74.934 12.901-102.657 40.623-27.723-27.723-63.68-40.623-102.657-40.623-37.878 0-73.561 9.333-107.871 24.978C55.239 442.236 32.731 448 8.303 448H6.93L49.475 98.859C88.726 76.626 136.486 64 181.775 64 218.83 64 256.984 71.685 288 93.095 319.016 71.685 357.17 64 394.225 64c45.289 0 93.049 12.626 132.3 34.859L569.07 448zm-43.368-44.741l-34.036-280.246c-30.742-13.999-67.248-21.41-101.009-21.41-38.428 0-74.385 12.077-102.657 38.702-28.272-26.625-64.228-38.702-102.657-38.702-33.761 0-70.267 7.411-101.009 21.41L50.298 403.259c47.211-19.487 82.894-33.486 135.045-33.486 37.604 0 70.817 9.606 102.657 29.644 31.84-20.038 65.052-29.644 102.657-29.644 52.151 0 87.834 13.999 135.045 33.486z"
    ]
};
var $ef0249c5e48bf4e3$export$161a3454c1d6abdb = {
    prefix: "fab",
    iconName: "black-tie",
    icon: [
        448,
        512,
        [],
        "f27e",
        "M0 32v448h448V32H0zm316.5 325.2L224 445.9l-92.5-88.7 64.5-184-64.5-86.6h184.9L252 173.2l64.5 184z"
    ]
};
var $ef0249c5e48bf4e3$export$ec9cce37001091c7 = {
    prefix: "fab",
    iconName: "themeco",
    icon: [
        448,
        512,
        [],
        "f5c6",
        "M202.9 8.43c9.9-5.73 26-5.82 35.95-.21L430 115.85c10 5.6 18 19.44 18 30.86V364c0 11.44-8.06 25.29-18 31L238.81 503.74c-9.93 5.66-26 5.57-35.85-.21L17.86 395.12C8 389.34 0 375.38 0 364V146.71c0-11.44 8-25.36 17.91-31.08zm-77.4 199.83c-15.94 0-31.89.14-47.83.14v101.45H96.8V280h28.7c49.71 0 49.56-71.74 0-71.74zm140.14 100.29l-30.73-34.64c37-7.51 34.8-65.23-10.87-65.51-16.09 0-32.17-.14-48.26-.14v101.59h19.13v-33.91h18.41l29.56 33.91h22.76zm-41.59-82.32c23.34 0 23.26 32.46 0 32.46h-29.13v-32.46zm-95.56-1.6c21.18 0 21.11 38.85 0 38.85H96.18v-38.84zm192.65-18.25c-68.46 0-71 105.8 0 105.8 69.48-.01 69.41-105.8 0-105.8zm0 17.39c44.12 0 44.8 70.86 0 70.86s-44.43-70.86 0-70.86z"
    ]
};
var $ef0249c5e48bf4e3$export$15d5df18b87754e3 = {
    prefix: "fab",
    iconName: "python",
    icon: [
        448,
        512,
        [],
        "f3e2",
        "M439.8 200.5c-7.7-30.9-22.3-54.2-53.4-54.2h-40.1v47.4c0 36.8-31.2 67.8-66.8 67.8H172.7c-29.2 0-53.4 25-53.4 54.3v101.8c0 29 25.2 46 53.4 54.3 33.8 9.9 66.3 11.7 106.8 0 26.9-7.8 53.4-23.5 53.4-54.3v-40.7H226.2v-13.6h160.2c31.1 0 42.6-21.7 53.4-54.2 11.2-33.5 10.7-65.7 0-108.6zM286.2 404c11.1 0 20.1 9.1 20.1 20.3 0 11.3-9 20.4-20.1 20.4-11 0-20.1-9.2-20.1-20.4.1-11.3 9.1-20.3 20.1-20.3zM167.8 248.1h106.8c29.7 0 53.4-24.5 53.4-54.3V91.9c0-29-24.4-50.7-53.4-55.6-35.8-5.9-74.7-5.6-106.8.1-45.2 8-53.4 24.7-53.4 55.6v40.7h106.9v13.6h-147c-31.1 0-58.3 18.7-66.8 54.2-9.8 40.7-10.2 66.1 0 108.6 7.6 31.6 25.7 54.2 56.8 54.2H101v-48.8c0-35.3 30.5-66.4 66.8-66.4zm-6.7-142.6c-11.1 0-20.1-9.1-20.1-20.3.1-11.3 9-20.4 20.1-20.4 11 0 20.1 9.2 20.1 20.4s-9 20.3-20.1 20.3z"
    ]
};
var $ef0249c5e48bf4e3$export$d3988148e7ca3c41 = {
    prefix: "fab",
    iconName: "android",
    icon: [
        576,
        512,
        [],
        "f17b",
        "M420.55,301.93a24,24,0,1,1,24-24,24,24,0,0,1-24,24m-265.1,0a24,24,0,1,1,24-24,24,24,0,0,1-24,24m273.7-144.48,47.94-83a10,10,0,1,0-17.27-10h0l-48.54,84.07a301.25,301.25,0,0,0-246.56,0L116.18,64.45a10,10,0,1,0-17.27,10h0l47.94,83C64.53,202.22,8.24,285.55,0,384H576c-8.24-98.45-64.54-181.78-146.85-226.55"
    ]
};
var $ef0249c5e48bf4e3$export$d367d9d00bf47408 = {
    prefix: "fab",
    iconName: "bots",
    icon: [
        640,
        512,
        [],
        "e340",
        "M86.344,197.834a51.767,51.767,0,0,0-41.57,20.058V156.018a8.19,8.19,0,0,0-8.19-8.19H8.19A8.19,8.19,0,0,0,0,156.018V333.551a8.189,8.189,0,0,0,8.19,8.189H36.584a8.189,8.189,0,0,0,8.19-8.189v-8.088c11.628,13.373,25.874,19.769,41.573,19.769,34.6,0,61.922-26.164,61.922-73.843C148.266,225.452,121.229,197.834,86.344,197.834ZM71.516,305.691c-9.593,0-21.221-4.942-26.745-12.5V250.164c5.528-7.558,17.152-12.791,26.745-12.791,17.734,0,31.107,13.082,31.107,34.013C102.623,292.609,89.25,305.691,71.516,305.691Zm156.372-59.032a17.4,17.4,0,1,0,17.4,17.4A17.4,17.4,0,0,0,227.888,246.659ZM273.956,156.7V112.039a13.308,13.308,0,1,0-10.237,0V156.7a107.49,107.49,0,1,0,10.237,0Zm85.993,107.367c0,30.531-40.792,55.281-91.112,55.281s-91.111-24.75-91.111-55.281,40.792-55.281,91.111-55.281S359.949,233.532,359.949,264.062Zm-50.163,17.4a17.4,17.4,0,1,0-17.4-17.4h0A17.4,17.4,0,0,0,309.786,281.466ZM580.7,250.455c-14.828-2.617-22.387-3.78-22.387-9.885,0-5.523,7.268-9.884,17.735-9.884a65.56,65.56,0,0,1,34.484,10.1,8.171,8.171,0,0,0,11.288-2.468c.07-.11.138-.221.2-.333l8.611-14.886a8.2,8.2,0,0,0-2.867-11.123,99.863,99.863,0,0,0-52.014-14.138c-38.956,0-60.179,21.514-60.179,46.225,0,36.342,33.725,41.864,57.563,45.642,13.373,2.326,24.13,4.361,24.13,11.048,0,6.4-5.523,10.757-18.9,10.757-13.552,0-30.994-6.222-42.623-13.579a8.206,8.206,0,0,0-11.335,2.491c-.035.054-.069.108-.1.164l-10.2,16.891a8.222,8.222,0,0,0,2.491,11.066c15.224,10.3,37.663,16.692,59.441,16.692,40.409,0,63.957-19.769,63.957-46.515C640,260.63,604.537,254.816,580.7,250.455Zm-95.928,60.787a8.211,8.211,0,0,0-9.521-5.938,23.168,23.168,0,0,1-4.155.387c-7.849,0-12.5-6.106-12.5-14.245V240.28h20.349a8.143,8.143,0,0,0,8.141-8.143V209.466a8.143,8.143,0,0,0-8.141-8.143H458.594V171.091a8.143,8.143,0,0,0-8.143-8.143H422.257a8.143,8.143,0,0,0-8.143,8.143h0v30.232H399a8.143,8.143,0,0,0-8.143,8.143h0v22.671A8.143,8.143,0,0,0,399,240.28h15.115v63.667c0,27.037,15.408,41.282,43.9,41.282,12.183,0,21.383-2.2,27.6-5.446a8.161,8.161,0,0,0,4.145-9.278Z"
    ]
};
var $ef0249c5e48bf4e3$export$8190ad5ab3a607e2 = {
    prefix: "fab",
    iconName: "free-code-camp",
    icon: [
        576,
        512,
        [],
        "f2c5",
        "M97.22,96.21c10.36-10.65,16-17.12,16-21.9,0-2.76-1.92-5.51-3.83-7.42A14.81,14.81,0,0,0,101,64.05c-8.48,0-20.92,8.79-35.84,25.69C23.68,137,2.51,182.81,3.37,250.34s17.47,117,54.06,161.87C76.22,435.86,90.62,448,100.9,448a13.55,13.55,0,0,0,8.37-3.84c1.91-2.76,3.81-5.63,3.81-8.38,0-5.63-3.86-12.2-13.2-20.55-44.45-42.33-67.32-97-67.48-165C32.25,188.8,54,137.83,97.22,96.21ZM239.47,420.07c.58.37.91.55.91.55Zm93.79.55.17-.13C333.24,420.62,333.17,420.67,333.26,420.62Zm3.13-158.18c-16.24-4.15,50.41-82.89-68.05-177.17,0,0,15.54,49.38-62.83,159.57-74.27,104.35,23.46,168.73,34,175.23-6.73-4.35-47.4-35.7,9.55-128.64,11-18.3,25.53-34.87,43.5-72.16,0,0,15.91,22.45,7.6,71.13C287.7,364,354,342.91,355,343.94c22.75,26.78-17.72,73.51-21.58,76.55,5.49-3.65,117.71-78,33-188.1C360.43,238.4,352.62,266.59,336.39,262.44ZM510.88,89.69C496,72.79,483.52,64,475,64a14.81,14.81,0,0,0-8.39,2.84c-1.91,1.91-3.83,4.66-3.83,7.42,0,4.78,5.6,11.26,16,21.9,43.23,41.61,65,92.59,64.82,154.06-.16,68-23,122.63-67.48,165-9.34,8.35-13.18,14.92-13.2,20.55,0,2.75,1.9,5.62,3.81,8.38A13.61,13.61,0,0,0,475.1,448c10.28,0,24.68-12.13,43.47-35.79,36.59-44.85,53.14-94.38,54.06-161.87S552.32,137,510.88,89.69Z"
    ]
};
var $ef0249c5e48bf4e3$export$906602f6a1e50bdd = {
    prefix: "fab",
    iconName: "hornbill",
    icon: [
        512,
        512,
        [],
        "f592",
        "M76.38 370.3a37.8 37.8 0 1 1-32.07-32.42c-78.28-111.35 52-190.53 52-190.53-5.86 43-8.24 91.16-8.24 91.16-67.31 41.49.93 64.06 39.81 72.87a140.38 140.38 0 0 0 131.66 91.94c1.92 0 3.77-.21 5.67-.28l.11 18.86c-99.22 1.39-158.7-29.14-188.94-51.6zm108-327.7A37.57 37.57 0 0 0 181 21.45a37.95 37.95 0 1 0-31.17 54.22c-22.55 29.91-53.83 89.57-52.42 190l21.84-.15c0-.9-.14-1.77-.14-2.68A140.42 140.42 0 0 1 207 132.71c8-37.71 30.7-114.3 73.8-44.29 0 0 48.14 2.38 91.18 8.24 0 0-77.84-128-187.59-54.06zm304.19 134.17a37.94 37.94 0 1 0-53.84-28.7C403 126.13 344.89 99 251.28 100.33l.14 22.5c2.7-.15 5.39-.41 8.14-.41a140.37 140.37 0 0 1 130.49 88.76c39.1 9 105.06 31.58 38.46 72.54 0 0-2.34 48.13-8.21 91.16 0 0 133.45-81.16 49-194.61a37.45 37.45 0 0 0 19.31-3.5zM374.06 436.24c21.43-32.46 46.42-89.69 45.14-179.66l-19.52.14c.08 2.06.3 4.07.3 6.15a140.34 140.34 0 0 1-91.39 131.45c-8.85 38.95-31.44 106.66-72.77 39.49 0 0-48.12-2.34-91.19-8.22 0 0 79.92 131.34 191.9 51a37.5 37.5 0 0 0 3.64 14 37.93 37.93 0 1 0 33.89-54.29z"
    ]
};
var $ef0249c5e48bf4e3$export$530d32089c3347d5 = {
    prefix: "fab",
    iconName: "js",
    icon: [
        448,
        512,
        [],
        "f3b8",
        "M0 32v448h448V32H0zm243.8 349.4c0 43.6-25.6 63.5-62.9 63.5-33.7 0-53.2-17.4-63.2-38.5l34.3-20.7c6.6 11.7 12.6 21.6 27.1 21.6 13.8 0 22.6-5.4 22.6-26.5V237.7h42.1v143.7zm99.6 63.5c-39.1 0-64.4-18.6-76.7-43l34.3-19.8c9 14.7 20.8 25.6 41.5 25.6 17.4 0 28.6-8.7 28.6-20.8 0-14.4-11.4-19.5-30.7-28l-10.5-4.5c-30.4-12.9-50.5-29.2-50.5-63.5 0-31.6 24.1-55.6 61.6-55.6 26.8 0 46 9.3 59.8 33.7L368 290c-7.2-12.9-15-18-27.1-18-12.3 0-20.1 7.8-20.1 18 0 12.6 7.8 17.7 25.9 25.6l10.5 4.5c35.8 15.3 55.9 31 55.9 66.2 0 37.8-29.8 58.6-69.7 58.6z"
    ]
};
var $ef0249c5e48bf4e3$export$4ee0aea9bb537f01 = {
    prefix: "fab",
    iconName: "ideal",
    icon: [
        576,
        512,
        [],
        "e013",
        "M125.61,165.48a49.07,49.07,0,1,0,49.06,49.06A49.08,49.08,0,0,0,125.61,165.48ZM86.15,425.84h78.94V285.32H86.15Zm151.46-211.6c0-20-10-22.53-18.74-22.53H204.82V237.5h14.05C228.62,237.5,237.61,234.69,237.61,214.24Zm201.69,46V168.93h22.75V237.5h33.69C486.5,113.08,388.61,86.19,299.67,86.19H204.84V169h14c25.6,0,41.5,17.35,41.5,45.26,0,28.81-15.52,46-41.5,46h-14V425.88h94.83c144.61,0,194.94-67.16,196.72-165.64Zm-109.75,0H273.3V169h54.43v22.73H296v10.58h30V225H296V237.5h33.51Zm74.66,0-5.16-17.67H369.31l-5.18,17.67H340.47L368,168.92h32.35l27.53,91.34ZM299.65,32H32V480H299.65c161.85,0,251-79.73,251-224.52C550.62,172,518,32,299.65,32Zm0,426.92H53.07V53.07H299.65c142.1,0,229.9,64.61,229.9,202.41C529.55,389.57,448.55,458.92,299.65,458.92Zm83.86-264.85L376,219.88H392.4l-7.52-25.81Z"
    ]
};
var $ef0249c5e48bf4e3$export$61f81190d1a8b4b = {
    prefix: "fab",
    iconName: "git",
    icon: [
        512,
        512,
        [],
        "f1d3",
        "M216.29 158.39H137C97 147.9 6.51 150.63 6.51 233.18c0 30.09 15 51.23 35 61-25.1 23-37 33.85-37 49.21 0 11 4.47 21.14 17.89 26.81C8.13 383.61 0 393.35 0 411.65c0 32.11 28.05 50.82 101.63 50.82 70.75 0 111.79-26.42 111.79-73.18 0-58.66-45.16-56.5-151.63-63l13.43-21.55c27.27 7.58 118.7 10 118.7-67.89 0-18.7-7.73-31.71-15-41.07l37.41-2.84zm-63.42 241.9c0 32.06-104.89 32.1-104.89 2.43 0-8.14 5.27-15 10.57-21.54 77.71 5.3 94.32 3.37 94.32 19.11zm-50.81-134.58c-52.8 0-50.46-71.16 1.2-71.16 49.54 0 50.82 71.16-1.2 71.16zm133.3 100.51v-32.1c26.75-3.66 27.24-2 27.24-11V203.61c0-8.5-2.05-7.38-27.24-16.26l4.47-32.92H324v168.71c0 6.51.4 7.32 6.51 8.14l20.73 2.84v32.1zm52.45-244.31c-23.17 0-36.59-13.43-36.59-36.61s13.42-35.77 36.59-35.77c23.58 0 37 12.62 37 35.77s-13.42 36.61-37 36.61zM512 350.46c-17.49 8.53-43.1 16.26-66.28 16.26-48.38 0-66.67-19.5-66.67-65.46V194.75c0-5.42 1.05-4.06-31.71-4.06V154.5c35.78-4.07 50-22 54.47-66.27h38.63c0 65.83-1.34 61.81 3.26 61.81H501v40.65h-60.56v97.15c0 6.92-4.92 51.41 60.57 26.84z"
    ]
};
var $ef0249c5e48bf4e3$export$dad56877d4f4a953 = {
    prefix: "fab",
    iconName: "dev",
    icon: [
        448,
        512,
        [],
        "f6cc",
        "M120.12 208.29c-3.88-2.9-7.77-4.35-11.65-4.35H91.03v104.47h17.45c3.88 0 7.77-1.45 11.65-4.35 3.88-2.9 5.82-7.25 5.82-13.06v-69.65c-.01-5.8-1.96-10.16-5.83-13.06zM404.1 32H43.9C19.7 32 .06 51.59 0 75.8v360.4C.06 460.41 19.7 480 43.9 480h360.2c24.21 0 43.84-19.59 43.9-43.8V75.8c-.06-24.21-19.7-43.8-43.9-43.8zM154.2 291.19c0 18.81-11.61 47.31-48.36 47.25h-46.4V172.98h47.38c35.44 0 47.36 28.46 47.37 47.28l.01 70.93zm100.68-88.66H201.6v38.42h32.57v29.57H201.6v38.41h53.29v29.57h-62.18c-11.16.29-20.44-8.53-20.72-19.69V193.7c-.27-11.15 8.56-20.41 19.71-20.69h63.19l-.01 29.52zm103.64 115.29c-13.2 30.75-36.85 24.63-47.44 0l-38.53-144.8h32.57l29.71 113.72 29.57-113.72h32.58l-38.46 144.8z"
    ]
};
var $ef0249c5e48bf4e3$export$e999ee7aa7883e37 = {
    prefix: "fab",
    iconName: "sketch",
    icon: [
        512,
        512,
        [],
        "f7c6",
        "M27.5 162.2L9 187.1h90.5l6.9-130.7-78.9 105.8zM396.3 45.7L267.7 32l135.7 147.2-7.1-133.5zM112.2 218.3l-11.2-22H9.9L234.8 458zm2-31.2h284l-81.5-88.5L256.3 33zm297.3 9.1L277.6 458l224.8-261.7h-90.9zM415.4 69L406 56.4l.9 17.3 6.1 113.4h90.3zM113.5 93.5l-4.6 85.6L244.7 32 116.1 45.7zm287.7 102.7h-290l42.4 82.9L256.3 480l144.9-283.8z"
    ]
};
var $ef0249c5e48bf4e3$export$6bf616a61d0b7bf3 = {
    prefix: "fab",
    iconName: "yandex-international",
    icon: [
        320,
        512,
        [],
        "f414",
        "M129.5 512V345.9L18.5 48h55.8l81.8 229.7L250.2 0h51.3L180.8 347.8V512h-51.3z"
    ]
};
var $ef0249c5e48bf4e3$export$2bcb24672b4bf6e6 = {
    prefix: "fab",
    iconName: "cc-amex",
    icon: [
        576,
        512,
        [],
        "f1f3",
        "M48 480C21.49 480 0 458.5 0 432V80C0 53.49 21.49 32 48 32H528C554.5 32 576 53.49 576 80V82.43H500.5L483.5 130L466.6 82.43H369.4V145.6L341.3 82.43H262.7L181 267.1H246.8V430.9H450.5L482.4 395.8L514.3 430.9H576V432C576 458.5 554.5 480 528 480H48zM482.6 364L440.4 410.3H390.5L458 338.6L390.5 266.1H441.9L483.4 312.8L525.4 266.1H576L508 338.2L576 410.3H524.6L482.6 364zM576 296.9V380.2L536.7 338.3L576 296.9zM307.6 377.1H390.6V410.3H268.6V267.1H390.6V300.2H307.6V322.6H388.5V354.9H307.6V377.2V377.1zM537.3 145.7L500.4 246.3H466L429.2 146V246.3H390.5V103H451.7L483.6 192.3L515.8 103H576V246.3H537.3V145.7zM334.5 217.6H268.6L256.7 246.3H213.7L276.1 103H327.3L390.6 246.3H346.5L334.5 217.6zM301.5 138.5L282 185.4H320.9L301.5 138.5z"
    ]
};
var $ef0249c5e48bf4e3$export$2b557426f8d6820b = {
    prefix: "fab",
    iconName: "uber",
    icon: [
        448,
        512,
        [],
        "f402",
        "M414.1 32H33.9C15.2 32 0 47.2 0 65.9V446c0 18.8 15.2 34 33.9 34H414c18.7 0 33.9-15.2 33.9-33.9V65.9C448 47.2 432.8 32 414.1 32zM237.6 391.1C163 398.6 96.4 344.2 88.9 269.6h94.4V290c0 3.7 3 6.8 6.8 6.8H258c3.7 0 6.8-3 6.8-6.8v-67.9c0-3.7-3-6.8-6.8-6.8h-67.9c-3.7 0-6.8 3-6.8 6.8v20.4H88.9c7-69.4 65.4-122.2 135.1-122.2 69.7 0 128.1 52.8 135.1 122.2 7.5 74.5-46.9 141.1-121.5 148.6z"
    ]
};
var $ef0249c5e48bf4e3$export$64e4bc4b496fbbdf = {
    prefix: "fab",
    iconName: "github",
    icon: [
        496,
        512,
        [],
        "f09b",
        "M165.9 397.4c0 2-2.3 3.6-5.2 3.6-3.3.3-5.6-1.3-5.6-3.6 0-2 2.3-3.6 5.2-3.6 3-.3 5.6 1.3 5.6 3.6zm-31.1-4.5c-.7 2 1.3 4.3 4.3 4.9 2.6 1 5.6 0 6.2-2s-1.3-4.3-4.3-5.2c-2.6-.7-5.5.3-6.2 2.3zm44.2-1.7c-2.9.7-4.9 2.6-4.6 4.9.3 2 2.9 3.3 5.9 2.6 2.9-.7 4.9-2.6 4.6-4.6-.3-1.9-3-3.2-5.9-2.9zM244.8 8C106.1 8 0 113.3 0 252c0 110.9 69.8 205.8 169.5 239.2 12.8 2.3 17.3-5.6 17.3-12.1 0-6.2-.3-40.4-.3-61.4 0 0-70 15-84.7-29.8 0 0-11.4-29.1-27.8-36.6 0 0-22.9-15.7 1.6-15.4 0 0 24.9 2 38.6 25.8 21.9 38.6 58.6 27.5 72.9 20.9 2.3-16 8.8-27.1 16-33.7-55.9-6.2-112.3-14.3-112.3-110.5 0-27.5 7.6-41.3 23.6-58.9-2.6-6.5-11.1-33.3 2.6-67.9 20.9-6.5 69 27 69 27 20-5.6 41.5-8.5 62.8-8.5s42.8 2.9 62.8 8.5c0 0 48.1-33.6 69-27 13.7 34.7 5.2 61.4 2.6 67.9 16 17.7 25.8 31.5 25.8 58.9 0 96.5-58.9 104.2-114.8 110.5 9.2 7.9 17 22.9 17 46.4 0 33.7-.3 75.4-.3 83.6 0 6.5 4.6 14.4 17.3 12.1C428.2 457.8 496 362.9 496 252 496 113.3 383.5 8 244.8 8zM97.2 352.9c-1.3 1-1 3.3.7 5.2 1.6 1.6 3.9 2.3 5.2 1 1.3-1 1-3.3-.7-5.2-1.6-1.6-3.9-2.3-5.2-1zm-10.8-8.1c-.7 1.3.3 2.9 2.3 3.9 1.6 1 3.6.7 4.3-.7.7-1.3-.3-2.9-2.3-3.9-2-.6-3.6-.3-4.3.7zm32.4 35.6c-1.6 1.3-1 4.3 1.3 6.2 2.3 2.3 5.2 2.6 6.5 1 1.3-1.3.7-4.3-1.3-6.2-2.2-2.3-5.2-2.6-6.5-1zm-11.4-14.7c-1.6 1-1.6 3.6 0 5.9 1.6 2.3 4.3 3.3 5.6 2.3 1.6-1.3 1.6-3.9 0-6.2-1.4-2.3-4-3.3-5.6-2z"
    ]
};
var $ef0249c5e48bf4e3$export$e1ae2a8de48825fb = {
    prefix: "fab",
    iconName: "php",
    icon: [
        640,
        512,
        [],
        "f457",
        "M320 104.5c171.4 0 303.2 72.2 303.2 151.5S491.3 407.5 320 407.5c-171.4 0-303.2-72.2-303.2-151.5S148.7 104.5 320 104.5m0-16.8C143.3 87.7 0 163 0 256s143.3 168.3 320 168.3S640 349 640 256 496.7 87.7 320 87.7zM218.2 242.5c-7.9 40.5-35.8 36.3-70.1 36.3l13.7-70.6c38 0 63.8-4.1 56.4 34.3zM97.4 350.3h36.7l8.7-44.8c41.1 0 66.6 3 90.2-19.1 26.1-24 32.9-66.7 14.3-88.1-9.7-11.2-25.3-16.7-46.5-16.7h-70.7L97.4 350.3zm185.7-213.6h36.5l-8.7 44.8c31.5 0 60.7-2.3 74.8 10.7 14.8 13.6 7.7 31-8.3 113.1h-37c15.4-79.4 18.3-86 12.7-92-5.4-5.8-17.7-4.6-47.4-4.6l-18.8 96.6h-36.5l32.7-168.6zM505 242.5c-8 41.1-36.7 36.3-70.1 36.3l13.7-70.6c38.2 0 63.8-4.1 56.4 34.3zM384.2 350.3H421l8.7-44.8c43.2 0 67.1 2.5 90.2-19.1 26.1-24 32.9-66.7 14.3-88.1-9.7-11.2-25.3-16.7-46.5-16.7H417l-32.8 168.7z"
    ]
};
var $ef0249c5e48bf4e3$export$994c329bc073af57 = {
    prefix: "fab",
    iconName: "alipay",
    icon: [
        448,
        512,
        [],
        "f642",
        "M377.74 32H70.26C31.41 32 0 63.41 0 102.26v307.48C0 448.59 31.41 480 70.26 480h307.48c38.52 0 69.76-31.08 70.26-69.6-45.96-25.62-110.59-60.34-171.6-88.44-32.07 43.97-84.14 81-148.62 81-70.59 0-93.73-45.3-97.04-76.37-3.97-39.01 14.88-81.5 99.52-81.5 35.38 0 79.35 10.25 127.13 24.96 16.53-30.09 26.45-60.34 26.45-60.34h-178.2v-16.7h92.08v-31.24H88.28v-19.01h109.44V92.34h50.92v50.42h109.44v19.01H248.63v31.24h88.77s-15.21 46.62-38.35 90.92c48.93 16.7 100.01 36.04 148.62 52.74V102.26C447.83 63.57 416.43 32 377.74 32zM47.28 322.95c.99 20.17 10.25 53.73 69.93 53.73 52.07 0 92.58-39.68 117.87-72.9-44.63-18.68-84.48-31.41-109.44-31.41-67.45 0-79.35 33.06-78.36 50.58z"
    ]
};
var $ef0249c5e48bf4e3$export$2373b132177332f8 = {
    prefix: "fab",
    iconName: "youtube",
    icon: [
        576,
        512,
        [
            61802
        ],
        "f167",
        "M549.655 124.083c-6.281-23.65-24.787-42.276-48.284-48.597C458.781 64 288 64 288 64S117.22 64 74.629 75.486c-23.497 6.322-42.003 24.947-48.284 48.597-11.412 42.867-11.412 132.305-11.412 132.305s0 89.438 11.412 132.305c6.281 23.65 24.787 41.5 48.284 47.821C117.22 448 288 448 288 448s170.78 0 213.371-11.486c23.497-6.321 42.003-24.171 48.284-47.821 11.412-42.867 11.412-132.305 11.412-132.305s0-89.438-11.412-132.305zm-317.51 213.508V175.185l142.739 81.205-142.739 81.201z"
    ]
};
var $ef0249c5e48bf4e3$export$b2254aecfa43ac3e = {
    prefix: "fab",
    iconName: "skyatlas",
    icon: [
        640,
        512,
        [],
        "f216",
        "M640 329.3c0 65.9-52.5 114.4-117.5 114.4-165.9 0-196.6-249.7-359.7-249.7-146.9 0-147.1 212.2 5.6 212.2 42.5 0 90.9-17.8 125.3-42.5 5.6-4.1 16.9-16.3 22.8-16.3s10.9 5 10.9 10.9c0 7.8-13.1 19.1-18.7 24.1-40.9 35.6-100.3 61.2-154.7 61.2-83.4.1-154-59-154-144.9s67.5-149.1 152.8-149.1c185.3 0 222.5 245.9 361.9 245.9 99.9 0 94.8-139.7 3.4-139.7-17.5 0-35 11.6-46.9 11.6-8.4 0-15.9-7.2-15.9-15.6 0-11.6 5.3-23.7 5.3-36.3 0-66.6-50.9-114.7-116.9-114.7-53.1 0-80 36.9-88.8 36.9-6.2 0-11.2-5-11.2-11.2 0-5.6 4.1-10.3 7.8-14.4 25.3-28.8 64.7-43.7 102.8-43.7 79.4 0 139.1 58.4 139.1 137.8 0 6.9-.3 13.7-1.2 20.6 11.9-3.1 24.1-4.7 35.9-4.7 60.7 0 111.9 45.3 111.9 107.2z"
    ]
};
var $ef0249c5e48bf4e3$export$db16178b6453c842 = {
    prefix: "fab",
    iconName: "firefox-browser",
    icon: [
        512,
        512,
        [],
        "e007",
        "M130.22 127.548C130.38 127.558 130.3 127.558 130.22 127.548V127.548ZM481.64 172.898C471.03 147.398 449.56 119.898 432.7 111.168C446.42 138.058 454.37 165.048 457.4 185.168C457.405 185.306 457.422 185.443 457.45 185.578C429.87 116.828 383.098 89.1089 344.9 28.7479C329.908 5.05792 333.976 3.51792 331.82 4.08792L331.7 4.15792C284.99 30.1109 256.365 82.5289 249.12 126.898C232.503 127.771 216.219 131.895 201.19 139.035C199.838 139.649 198.736 140.706 198.066 142.031C197.396 143.356 197.199 144.87 197.506 146.323C197.7 147.162 198.068 147.951 198.586 148.639C199.103 149.327 199.76 149.899 200.512 150.318C201.264 150.737 202.096 150.993 202.954 151.071C203.811 151.148 204.676 151.045 205.491 150.768L206.011 150.558C221.511 143.255 238.408 139.393 255.541 139.238C318.369 138.669 352.698 183.262 363.161 201.528C350.161 192.378 326.811 183.338 304.341 187.248C392.081 231.108 368.541 381.784 246.951 376.448C187.487 373.838 149.881 325.467 146.421 285.648C146.421 285.648 157.671 243.698 227.041 243.698C234.541 243.698 255.971 222.778 256.371 216.698C256.281 214.698 213.836 197.822 197.281 181.518C188.434 172.805 184.229 168.611 180.511 165.458C178.499 163.75 176.392 162.158 174.201 160.688C168.638 141.231 168.399 120.638 173.51 101.058C148.45 112.468 128.96 130.508 114.8 146.428H114.68C105.01 134.178 105.68 93.7779 106.25 85.3479C106.13 84.8179 99.022 89.0159 98.1 89.6579C89.5342 95.7103 81.5528 102.55 74.26 110.088C57.969 126.688 30.128 160.242 18.76 211.318C14.224 231.701 12 255.739 12 263.618C12 398.318 121.21 507.508 255.92 507.508C376.56 507.508 478.939 420.281 496.35 304.888C507.922 228.192 481.64 173.82 481.64 172.898Z"
    ]
};
var $ef0249c5e48bf4e3$export$a51c205a2c2f1780 = {
    prefix: "fab",
    iconName: "replyd",
    icon: [
        448,
        512,
        [],
        "f3e6",
        "M320 480H128C57.6 480 0 422.4 0 352V160C0 89.6 57.6 32 128 32h192c70.4 0 128 57.6 128 128v192c0 70.4-57.6 128-128 128zM193.4 273.2c-6.1-2-11.6-3.1-16.4-3.1-7.2 0-13.5 1.9-18.9 5.6-5.4 3.7-9.6 9-12.8 15.8h-1.1l-4.2-18.3h-28v138.9h36.1v-89.7c1.5-5.4 4.4-9.8 8.7-13.2 4.3-3.4 9.8-5.1 16.2-5.1 4.6 0 9.8 1 15.6 3.1l4.8-34zm115.2 103.4c-3.2 2.4-7.7 4.8-13.7 7.1-6 2.3-12.8 3.5-20.4 3.5-12.2 0-21.1-3-26.5-8.9-5.5-5.9-8.5-14.7-9-26.4h83.3c.9-4.8 1.6-9.4 2.1-13.9.5-4.4.7-8.6.7-12.5 0-10.7-1.6-19.7-4.7-26.9-3.2-7.2-7.3-13-12.5-17.2-5.2-4.3-11.1-7.3-17.8-9.2-6.7-1.8-13.5-2.8-20.6-2.8-21.1 0-37.5 6.1-49.2 18.3s-17.5 30.5-17.5 55c0 22.8 5.2 40.7 15.6 53.7 10.4 13.1 26.8 19.6 49.2 19.6 10.7 0 20.9-1.5 30.4-4.6 9.5-3.1 17.1-6.8 22.6-11.2l-12-23.6zm-21.8-70.3c3.8 5.4 5.3 13.1 4.6 23.1h-51.7c.9-9.4 3.7-17 8.2-22.6 4.5-5.6 11.5-8.5 21-8.5 8.2-.1 14.1 2.6 17.9 8zm79.9 2.5c4.1 3.9 9.4 5.8 16.1 5.8 7 0 12.6-1.9 16.7-5.8s6.1-9.1 6.1-15.6-2-11.6-6.1-15.4c-4.1-3.8-9.6-5.7-16.7-5.7-6.7 0-12 1.9-16.1 5.7-4.1 3.8-6.1 8.9-6.1 15.4s2 11.7 6.1 15.6zm0 100.5c4.1 3.9 9.4 5.8 16.1 5.8 7 0 12.6-1.9 16.7-5.8s6.1-9.1 6.1-15.6-2-11.6-6.1-15.4c-4.1-3.8-9.6-5.7-16.7-5.7-6.7 0-12 1.9-16.1 5.7-4.1 3.8-6.1 8.9-6.1 15.4 0 6.6 2 11.7 6.1 15.6z"
    ]
};
var $ef0249c5e48bf4e3$export$fd2c25240484ff41 = {
    prefix: "fab",
    iconName: "suse",
    icon: [
        640,
        512,
        [],
        "f7d6",
        "M471.08 102.66s-.3 18.3-.3 20.3c-9.1-3-74.4-24.1-135.7-26.3-51.9-1.8-122.8-4.3-223 57.3-19.4 12.4-73.9 46.1-99.6 109.7C7 277-.12 307 7 335.06a111 111 0 0 0 16.5 35.7c17.4 25 46.6 41.6 78.1 44.4 44.4 3.9 78.1-16 90-53.3 8.2-25.8 0-63.6-31.5-82.9-25.6-15.7-53.3-12.1-69.2-1.6-13.9 9.2-21.8 23.5-21.6 39.2.3 27.8 24.3 42.6 41.5 42.6a49 49 0 0 0 15.8-2.7c6.5-1.8 13.3-6.5 13.3-14.9 0-12.1-11.6-14.8-16.8-13.9-2.9.5-4.5 2-11.8 2.4-2-.2-12-3.1-12-14V316c.2-12.3 13.2-18 25.5-16.9 32.3 2.8 47.7 40.7 28.5 65.7-18.3 23.7-76.6 23.2-99.7-20.4-26-49.2 12.7-111.2 87-98.4 33.2 5.7 83.6 35.5 102.4 104.3h45.9c-5.7-17.6-8.9-68.3 42.7-68.3 56.7 0 63.9 39.9 79.8 68.3H460c-12.8-18.3-21.7-38.7-18.9-55.8 5.6-33.8 39.7-18.4 82.4-17.4 66.5.4 102.1-27 103.1-28 3.7-3.1 6.5-15.8 7-17.7 1.3-5.1-3.2-2.4-3.2-2.4-8.7 5.2-30.5 15.2-50.9 15.6-25.3.5-76.2-25.4-81.6-28.2-.3-.4.1 1.2-11-25.5 88.4 58.3 118.3 40.5 145.2 21.7.8-.6 4.3-2.9 3.6-5.7-13.8-48.1-22.4-62.7-34.5-69.6-37-21.6-125-34.7-129.2-35.3.1-.1-.9-.3-.9.7zm60.4 72.8a37.54 37.54 0 0 1 38.9-36.3c33.4 1.2 48.8 42.3 24.4 65.2-24.2 22.7-64.4 4.6-63.3-28.9zm38.6-25.3a26.27 26.27 0 1 0 25.4 27.2 26.19 26.19 0 0 0-25.4-27.2zm4.3 28.8c-15.4 0-15.4-15.6 0-15.6s15.4 15.64 0 15.64z"
    ]
};
var $ef0249c5e48bf4e3$export$595f8e07121dc03e = {
    prefix: "fab",
    iconName: "jenkins",
    icon: [
        512,
        512,
        [],
        "f3b6",
        "M487.1 425c-1.4-11.2-19-23.1-28.2-31.9-5.1-5-29-23.1-30.4-29.9-1.4-6.6 9.7-21.5 13.3-28.9 5.1-10.7 8.8-23.7 11.3-32.6 18.8-66.1 20.7-156.9-6.2-211.2-10.2-20.6-38.6-49-56.4-62.5-42-31.7-119.6-35.3-170.1-16.6-14.1 5.2-27.8 9.8-40.1 17.1-33.1 19.4-68.3 32.5-78.1 71.6-24.2 10.8-31.5 41.8-30.3 77.8.2 7 4.1 15.8 2.7 22.4-.7 3.3-5.2 7.6-6.1 9.8-11.6 27.7-2.3 64 11.1 83.7 8.1 11.9 21.5 22.4 39.2 25.2.7 10.6 3.3 19.7 8.2 30.4 3.1 6.8 14.7 19 10.4 27.7-2.2 4.4-21 13.8-27.3 17.6C89 407.2 73.7 415 54.2 429c-12.6 9-32.3 10.2-29.2 31.1 2.1 14.1 10.1 31.6 14.7 45.8.7 2 1.4 4.1 2.1 6h422c4.9-15.3 9.7-30.9 14.6-47.2 3.4-11.4 10.2-27.8 8.7-39.7zM205.9 33.7c1.8-.5 3.4.7 4.9 2.4-.2 5.2-5.4 5.1-8.9 6.8-5.4 6.7-13.4 9.8-20 17.2-6.8 7.5-14.4 27.7-23.4 30-4.5 1.1-9.7-.8-13.6-.5-10.4.7-17.7 6-28.3 7.5 13.6-29.9 56.1-54 89.3-63.4zm-104.8 93.6c13.5-14.9 32.1-24.1 54.8-25.9 11.7 29.7-8.4 65-.9 97.6 2.3 9.9 10.2 25.4-2.4 25.7.3-28.3-34.8-46.3-61.3-29.6-1.8-21.5-4.9-51.7 9.8-67.8zm36.7 200.2c-1-4.1-2.7-12.9-2.3-15.1 1.6-8.7 17.1-12.5 11-24.7-11.3-.1-13.8 10.2-24.1 11.3-26.7 2.6-45.6-35.4-44.4-58.4 1-19.5 17.6-38.2 40.1-35.8 16 1.8 21.4 19.2 24.5 34.7 9.2.5 22.5-.4 26.9-7.6-.6-17.5-8.8-31.6-8.2-47.7 1-30.3 17.5-57.6 4.8-87.4 13.6-30.9 53.5-55.3 83.1-70 36.6-18.3 94.9-3.7 129.3 15.8 19.7 11.1 34.4 32.7 48.3 50.7-19.5-5.8-36.1 4.2-33.1 20.3 16.3-14.9 44.2-.2 52.5 16.4 7.9 15.8 7.8 39.3 9 62.8 2.9 57-10.4 115.9-39.1 157.1-7.7 11-14.1 23-24.9 30.6-26 18.2-65.4 34.7-99.2 23.4-44.7-15-65-44.8-89.5-78.8.7 18.7 13.8 34.1 26.8 48.4 11.3 12.5 25 26.6 39.7 32.4-12.3-2.9-31.1-3.8-36.2 7.2-28.6-1.9-55.1-4.8-68.7-24.2-10.6-15.4-21.4-41.4-26.3-61.4zm222 124.1c4.1-3 11.1-2.9 17.4-3.6-5.4-2.7-13-3.7-19.3-2.2-.1-4.2-2-6.8-3.2-10.2 10.6-3.8 35.5-28.5 49.6-20.3 6.7 3.9 9.5 26.2 10.1 37 .4 9-.8 18-4.5 22.8-18.8-.6-35.8-2.8-50.7-7 .9-6.1-1-12.1.6-16.5zm-17.2-20c-16.8.8-26-1.2-38.3-10.8.2-.8 1.4-.5 1.5-1.4 18 8 40.8-3.3 59-4.9-7.9 5.1-14.6 11.6-22.2 17.1zm-12.1 33.2c-1.6-9.4-3.5-12-2.8-20.2 25-16.6 29.7 28.6 2.8 20.2zM226 438.6c-11.6-.7-48.1-14-38.5-23.7 9.4 6.5 27.5 4.9 41.3 7.3.8 4.4-2.8 10.2-2.8 16.4zM57.7 497.1c-4.3-12.7-9.2-25.1-14.8-36.9 30.8-23.8 65.3-48.9 102.2-63.5 2.8-1.1 23.2 25.4 26.2 27.6 16.5 11.7 37 21 56.2 30.2 1.2 8.8 3.9 20.2 8.7 35.5.7 2.3 1.4 4.7 2.2 7.2H57.7zm240.6 5.7h-.8c.3-.2.5-.4.8-.5v.5zm7.5-5.7c2.1-1.4 4.3-2.8 6.4-4.3 1.1 1.4 2.2 2.8 3.2 4.3h-9.6zm15.1-24.7c-10.8 7.3-20.6 18.3-33.3 25.2-6 3.3-27 11.7-33.4 10.2-3.6-.8-3.9-5.3-5.4-9.5-3.1-9-10.1-23.4-10.8-37-.8-17.2-2.5-46 16-42.4 14.9 2.9 32.3 9.7 43.9 16.1 7.1 3.9 11.1 8.6 21.9 9.5-.1 1.4-.1 2.8-.2 4.3-5.9 3.9-15.3 3.8-21.8 7.1 9.5.4 17 2.7 23.5 5.9-.1 3.4-.3 7-.4 10.6zm53.4 24.7h-14c-.1-3.2-2.8-5.8-6.1-5.8s-5.9 2.6-6.1 5.8h-17.4c-2.8-4.4-5.7-8.6-8.9-12.5 2.1-2.2 4-4.7 6-6.9 9 3.7 14.8-4.9 21.7-4.2 7.9.8 14.2 11.7 25.4 11l-.6 12.6zm8.7 0c.2-4 .4-7.8.6-11.5 15.6-7.3 29 1.3 35.7 11.5H383zm83.4-37c-2.3 11.2-5.8 24-9.9 37.1-.2-.1-.4-.1-.6-.1H428c.6-1.1 1.2-2.2 1.9-3.3-2.6-6.1-9-8.7-10.9-15.5 12.1-22.7 6.5-93.4-24.2-78.5 4.3-6.3 15.6-11.5 20.8-19.3 13 10.4 20.8 20.3 33.2 31.4 6.8 6 20 13.3 21.4 23.1.8 5.5-2.6 18.9-3.8 25.1zM222.2 130.5c5.4-14.9 27.2-34.7 45-32 7.7 1.2 18 8.2 12.2 17.7-30.2-7-45.2 12.6-54.4 33.1-8.1-2-4.9-13.1-2.8-18.8zm184.1 63.1c8.2-3.6 22.4-.7 29.6-5.3-4.2-11.5-10.3-21.4-9.3-37.7.5 0 1 0 1.4.1 6.8 14.2 12.7 29.2 21.4 41.7-5.7 13.5-43.6 25.4-43.1 1.2zm20.4-43zm-117.2 45.7c-6.8-10.9-19-32.5-14.5-45.3 6.5 11.9 8.6 24.4 17.8 33.3 4.1 4 12.2 9 8.2 20.2-.9 2.7-7.8 8.6-11.7 9.7-14.4 4.3-47.9.9-36.6-17.1 11.9.7 27.9 7.8 36.8-.8zm27.3 70c3.8 6.6 1.4 18.7 12.1 20.6 20.2 3.4 43.6-12.3 58.1-17.8 9-15.2-.8-20.7-8.9-30.5-16.6-20-38.8-44.8-38-74.7 6.7-4.9 7.3 7.4 8.2 9.7 8.7 20.3 30.4 46.2 46.3 63.5 3.9 4.3 10.3 8.4 11 11.2 2.1 8.2-5.4 18-4.5 23.5-21.7 13.9-45.8 29.1-81.4 25.6-7.4-6.7-10.3-21.4-2.9-31.1zm-201.3-9.2c-6.8-3.9-8.4-21-16.4-21.4-11.4-.7-9.3 22.2-9.3 35.5-7.8-7.1-9.2-29.1-3.5-40.3-6.6-3.2-9.5 3.6-13.1 5.9 4.7-34.1 49.8-15.8 42.3 20.3zm299.6 28.8c-10.1 19.2-24.4 40.4-54 41-.6-6.2-1.1-15.6 0-19.4 22.7-2.2 36.6-13.7 54-21.6zm-141.9 12.4c18.9 9.9 53.6 11 79.3 10.2 1.4 5.6 1.3 12.6 1.4 19.4-33 1.8-72-6.4-80.7-29.6zm92.2 46.7c-1.7 4.3-5.3 9.3-9.8 11.1-12.1 4.9-45.6 8.7-62.4-.3-10.7-5.7-17.5-18.5-23.4-26-2.8-3.6-16.9-12.9-.2-12.9 13.1 32.7 58 29 95.8 28.1z"
    ]
};
var $ef0249c5e48bf4e3$export$ca61170983a00686 = {
    prefix: "fab",
    iconName: "twitter",
    icon: [
        512,
        512,
        [],
        "f099",
        "M459.37 151.716c.325 4.548.325 9.097.325 13.645 0 138.72-105.583 298.558-298.558 298.558-59.452 0-114.68-17.219-161.137-47.106 8.447.974 16.568 1.299 25.34 1.299 49.055 0 94.213-16.568 130.274-44.832-46.132-.975-84.792-31.188-98.112-72.772 6.498.974 12.995 1.624 19.818 1.624 9.421 0 18.843-1.3 27.614-3.573-48.081-9.747-84.143-51.98-84.143-102.985v-1.299c13.969 7.797 30.214 12.67 47.431 13.319-28.264-18.843-46.781-51.005-46.781-87.391 0-19.492 5.197-37.36 14.294-52.954 51.655 63.675 129.3 105.258 216.365 109.807-1.624-7.797-2.599-15.918-2.599-24.04 0-57.828 46.782-104.934 104.934-104.934 30.213 0 57.502 12.67 76.67 33.137 23.715-4.548 46.456-13.32 66.599-25.34-7.798 24.366-24.366 44.833-46.132 57.827 21.117-2.273 41.584-8.122 60.426-16.243-14.292 20.791-32.161 39.308-52.628 54.253z"
    ]
};
var $ef0249c5e48bf4e3$export$b86b24e51d58f6b5 = {
    prefix: "fab",
    iconName: "rockrms",
    icon: [
        496,
        512,
        [],
        "f3e9",
        "M248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zm157.4 419.5h-90l-112-131.3c-17.9-20.4-3.9-56.1 26.6-56.1h75.3l-84.6-99.3-84.3 98.9h-90L193.5 67.2c14.4-18.4 41.3-17.3 54.5 0l157.7 185.1c19 22.8 2 57.2-27.6 56.1-.6 0-74.2.2-74.2.2l101.5 118.9z"
    ]
};
var $ef0249c5e48bf4e3$export$d42c613d35559431 = {
    prefix: "fab",
    iconName: "pinterest",
    icon: [
        496,
        512,
        [],
        "f0d2",
        "M496 256c0 137-111 248-248 248-25.6 0-50.2-3.9-73.4-11.1 10.1-16.5 25.2-43.5 30.8-65 3-11.6 15.4-59 15.4-59 8.1 15.4 31.7 28.5 56.8 28.5 74.8 0 128.7-68.8 128.7-154.3 0-81.9-66.9-143.2-152.9-143.2-107 0-163.9 71.8-163.9 150.1 0 36.4 19.4 81.7 50.3 96.1 4.7 2.2 7.2 1.2 8.3-3.3.8-3.4 5-20.3 6.9-28.1.6-2.5.3-4.7-1.7-7.1-10.1-12.5-18.3-35.3-18.3-56.6 0-54.7 41.4-107.6 112-107.6 60.9 0 103.6 41.5 103.6 100.9 0 67.1-33.9 113.6-78 113.6-24.3 0-42.6-20.1-36.7-44.8 7-29.5 20.5-61.3 20.5-82.6 0-19-10.2-34.9-31.4-34.9-24.9 0-44.9 25.7-44.9 60.2 0 22 7.4 36.8 7.4 36.8s-24.5 103.8-29 123.2c-5 21.4-3 51.6-.9 71.2C65.4 450.9 0 361.1 0 256 0 119 111 8 248 8s248 111 248 248z"
    ]
};
var $ef0249c5e48bf4e3$export$de04abdf8e0bcc15 = {
    prefix: "fab",
    iconName: "buffer",
    icon: [
        448,
        512,
        [],
        "f837",
        "M427.84 380.67l-196.5 97.82a18.6 18.6 0 0 1-14.67 0L20.16 380.67c-4-2-4-5.28 0-7.29L67.22 350a18.65 18.65 0 0 1 14.69 0l134.76 67a18.51 18.51 0 0 0 14.67 0l134.76-67a18.62 18.62 0 0 1 14.68 0l47.06 23.43c4.05 1.96 4.05 5.24 0 7.24zm0-136.53l-47.06-23.43a18.62 18.62 0 0 0-14.68 0l-134.76 67.08a18.68 18.68 0 0 1-14.67 0L81.91 220.71a18.65 18.65 0 0 0-14.69 0l-47.06 23.43c-4 2-4 5.29 0 7.31l196.51 97.8a18.6 18.6 0 0 0 14.67 0l196.5-97.8c4.05-2.02 4.05-5.3 0-7.31zM20.16 130.42l196.5 90.29a20.08 20.08 0 0 0 14.67 0l196.51-90.29c4-1.86 4-4.89 0-6.74L231.33 33.4a19.88 19.88 0 0 0-14.67 0l-196.5 90.28c-4.05 1.85-4.05 4.88 0 6.74z"
    ]
};
var $ef0249c5e48bf4e3$export$2002216d2d7747f0 = {
    prefix: "fab",
    iconName: "npm",
    icon: [
        576,
        512,
        [],
        "f3d4",
        "M288 288h-32v-64h32v64zm288-128v192H288v32H160v-32H0V160h576zm-416 32H32v128h64v-96h32v96h32V192zm160 0H192v160h64v-32h64V192zm224 0H352v128h64v-96h32v96h32v-96h32v96h32V192z"
    ]
};
var $ef0249c5e48bf4e3$export$a5122f6c6ec2779c = {
    prefix: "fab",
    iconName: "yammer",
    icon: [
        512,
        512,
        [],
        "f840",
        "M500.676,159.486a12.779,12.779,0,0,0-6.4-8.282,13.954,13.954,0,0,0-10.078-1.125L457.8,156.7l-.043-.2-22.3,5.785-1.243.333-.608-2.17A369.037,369.037,0,0,0,347.538,4.289a14.1,14.1,0,0,0-19.784-.463l-102.9,102.747H24.947A24.9,24.9,0,0,0,0,131.417V380.38a24.963,24.963,0,0,0,24.918,24.9H224.986L328.072,508a13.667,13.667,0,0,0,19.327,0c.126-.126.249-.255.37-.385a368.025,368.025,0,0,0,69.577-107.374,403.45,403.45,0,0,0,17.3-50.8v-.028l20.406,5.336.029-.073L483.345,362a20.253,20.253,0,0,0,2.619.5,13.359,13.359,0,0,0,4.139-.072,13.5,13.5,0,0,0,10.515-9.924,415.855,415.855,0,0,0,.058-193.013ZM337.125,24.65l.013.014h-.013Zm-110.2,165.161L174.311,281.1a11.338,11.338,0,0,0-1.489,5.655v46.189a22.04,22.04,0,0,1-22.041,22h-3.4A22.068,22.068,0,0,1,125.3,332.962V287.294a11.532,11.532,0,0,0-1.388-5.51l-51.6-92.2a21.988,21.988,0,0,1,19.264-32.726h3.268a22.059,22.059,0,0,1,19.611,11.916l36.357,70.281,37.515-70.512a22.066,22.066,0,0,1,38.556-.695,21.7,21.7,0,0,1,0,21.967ZM337.145,24.673a348.147,348.147,0,0,1,75.8,141.335l.564,1.952-114.134,29.6V131.417a25.006,25.006,0,0,0-24.947-24.9H255.067Zm60.5,367.305v-.043l-.014.014a347.19,347.19,0,0,1-60.177,95.227l-82.2-81.893h19.177a24.978,24.978,0,0,0,24.947-24.9v-66.2l114.6,29.862A385.191,385.191,0,0,1,397.648,391.978Zm84-52.45.015.014-50.618-13.131L299.379,292.1V219.572l119.746-30.99,4.468-1.157,39.54-10.253,18.511-4.816A393,393,0,0,1,481.644,339.528Z"
    ]
};
var $ef0249c5e48bf4e3$export$fcf54005da871608 = {
    prefix: "fab",
    iconName: "btc",
    icon: [
        384,
        512,
        [],
        "f15a",
        "M310.204 242.638c27.73-14.18 45.377-39.39 41.28-81.3-5.358-57.351-52.458-76.573-114.85-81.929V0h-48.528v77.203c-12.605 0-25.525.315-38.444.63V0h-48.528v79.409c-17.842.539-38.622.276-97.37 0v51.678c38.314-.678 58.417-3.14 63.023 21.427v217.429c-2.925 19.492-18.524 16.685-53.255 16.071L3.765 443.68c88.481 0 97.37.315 97.37.315V512h48.528v-67.06c13.234.315 26.154.315 38.444.315V512h48.528v-68.005c81.299-4.412 135.647-24.894 142.895-101.467 5.671-61.446-23.32-88.862-69.326-99.89zM150.608 134.553c27.415 0 113.126-8.507 113.126 48.528 0 54.515-85.71 48.212-113.126 48.212v-96.74zm0 251.776V279.821c32.772 0 133.127-9.138 133.127 53.255-.001 60.186-100.355 53.253-133.127 53.253z"
    ]
};
var $ef0249c5e48bf4e3$export$657a51e82ea8ac80 = {
    prefix: "fab",
    iconName: "dribbble",
    icon: [
        512,
        512,
        [],
        "f17d",
        "M256 8C119.252 8 8 119.252 8 256s111.252 248 248 248 248-111.252 248-248S392.748 8 256 8zm163.97 114.366c29.503 36.046 47.369 81.957 47.835 131.955-6.984-1.477-77.018-15.682-147.502-6.818-5.752-14.041-11.181-26.393-18.617-41.614 78.321-31.977 113.818-77.482 118.284-83.523zM396.421 97.87c-3.81 5.427-35.697 48.286-111.021 76.519-34.712-63.776-73.185-116.168-79.04-124.008 67.176-16.193 137.966 1.27 190.061 47.489zm-230.48-33.25c5.585 7.659 43.438 60.116 78.537 122.509-99.087 26.313-186.36 25.934-195.834 25.809C62.38 147.205 106.678 92.573 165.941 64.62zM44.17 256.323c0-2.166.043-4.322.108-6.473 9.268.19 111.92 1.513 217.706-30.146 6.064 11.868 11.857 23.915 17.174 35.949-76.599 21.575-146.194 83.527-180.531 142.306C64.794 360.405 44.17 310.73 44.17 256.323zm81.807 167.113c22.127-45.233 82.178-103.622 167.579-132.756 29.74 77.283 42.039 142.053 45.189 160.638-68.112 29.013-150.015 21.053-212.768-27.882zm248.38 8.489c-2.171-12.886-13.446-74.897-41.152-151.033 66.38-10.626 124.7 6.768 131.947 9.055-9.442 58.941-43.273 109.844-90.795 141.978z"
    ]
};
var $ef0249c5e48bf4e3$export$ef143c65b9462290 = {
    prefix: "fab",
    iconName: "stumbleupon-circle",
    icon: [
        496,
        512,
        [],
        "f1a3",
        "M256 8C119 8 8 119 8 256s111 248 248 248 248-111 248-248S393 8 256 8zm0 177.5c-9.8 0-17.8 8-17.8 17.8v106.9c0 40.9-33.9 73.9-74.9 73.9-41.4 0-74.9-33.5-74.9-74.9v-46.5h57.3v45.8c0 10 8 17.8 17.8 17.8s17.8-7.9 17.8-17.8V200.1c0-40 34.2-72.1 74.7-72.1 40.7 0 74.7 32.3 74.7 72.6v23.7l-34.1 10.1-22.9-10.7v-20.6c.1-9.6-7.9-17.6-17.7-17.6zm167.6 123.6c0 41.4-33.5 74.9-74.9 74.9-41.2 0-74.9-33.2-74.9-74.2V263l22.9 10.7 34.1-10.1v47.1c0 9.8 8 17.6 17.8 17.6s17.8-7.9 17.8-17.6v-48h57.3c-.1 45.9-.1 46.4-.1 46.4z"
    ]
};
var $ef0249c5e48bf4e3$export$26bd7ea5833d2643 = {
    prefix: "fab",
    iconName: "internet-explorer",
    icon: [
        512,
        512,
        [],
        "f26b",
        "M483.049 159.706c10.855-24.575 21.424-60.438 21.424-87.871 0-72.722-79.641-98.371-209.673-38.577-107.632-7.181-211.221 73.67-237.098 186.457 30.852-34.862 78.271-82.298 121.977-101.158C125.404 166.85 79.128 228.002 43.992 291.725 23.246 329.651 0 390.94 0 436.747c0 98.575 92.854 86.5 180.251 42.006 31.423 15.43 66.559 15.573 101.695 15.573 97.124 0 184.249-54.294 216.814-146.022H377.927c-52.509 88.593-196.819 52.996-196.819-47.436H509.9c6.407-43.581-1.655-95.715-26.851-141.162zM64.559 346.877c17.711 51.15 53.703 95.871 100.266 123.304-88.741 48.94-173.267 29.096-100.266-123.304zm115.977-108.873c2-55.151 50.276-94.871 103.98-94.871 53.418 0 101.981 39.72 103.981 94.871H180.536zm184.536-187.6c21.425-10.287 48.563-22.003 72.558-22.003 31.422 0 54.274 21.717 54.274 53.722 0 20.003-7.427 49.007-14.569 67.867-26.28-42.292-65.986-81.584-112.263-99.586z"
    ]
};
var $ef0249c5e48bf4e3$export$28d0d3c268c6e8c2 = {
    prefix: "fab",
    iconName: "stubber",
    icon: [
        448,
        512,
        [],
        "e5c7",
        "M136.5 294.2l58.8 22.9c9.1-36.8 25.4-61.1 55-61.1c49.4 0 71.4 63.6 142.4 63.6c15.6 0 35.9-2.8 55.3-13.3V368c0 61.8-50.4 112-112.3 112H0l41.8-56L0 368l41.7-56L0 256.1l41.8-56L0 144.1 41.8 88 0 32H335.7C397.6 32 448 82.3 448 144.1v51.3c-9.2 36.3-25.9 60.6-55 60.6c-49.6 0-71.6-63.5-142.4-63.5c-35.9 0-95.2 14.6-114.1 101.6h0z"
    ]
};
var $ef0249c5e48bf4e3$export$b508fd54409de914 = {
    prefix: "fab",
    iconName: "telegram",
    icon: [
        496,
        512,
        [
            62462,
            "telegram-plane"
        ],
        "f2c6",
        "M248,8C111.033,8,0,119.033,0,256S111.033,504,248,504,496,392.967,496,256,384.967,8,248,8ZM362.952,176.66c-3.732,39.215-19.881,134.378-28.1,178.3-3.476,18.584-10.322,24.816-16.948,25.425-14.4,1.326-25.338-9.517-39.287-18.661-21.827-14.308-34.158-23.215-55.346-37.177-24.485-16.135-8.612-25,5.342-39.5,3.652-3.793,67.107-61.51,68.335-66.746.153-.655.3-3.1-1.154-4.384s-3.59-.849-5.135-.5q-3.283.746-104.608,69.142-14.845,10.194-26.894,9.934c-8.855-.191-25.888-5.006-38.551-9.123-15.531-5.048-27.875-7.717-26.8-16.291q.84-6.7,18.45-13.7,108.446-47.248,144.628-62.3c68.872-28.647,83.183-33.623,92.511-33.789,2.052-.034,6.639.474,9.61,2.885a10.452,10.452,0,0,1,3.53,6.716A43.765,43.765,0,0,1,362.952,176.66Z"
    ]
};
var $ef0249c5e48bf4e3$export$dd32dc1ad06228ec = $ef0249c5e48bf4e3$export$b508fd54409de914;
var $ef0249c5e48bf4e3$export$39ef7a19d18012df = {
    prefix: "fab",
    iconName: "old-republic",
    icon: [
        496,
        512,
        [],
        "f510",
        "M235.76 10.23c7.5-.31 15-.28 22.5-.09 3.61.14 7.2.4 10.79.73 4.92.27 9.79 1.03 14.67 1.62 2.93.43 5.83.98 8.75 1.46 7.9 1.33 15.67 3.28 23.39 5.4 12.24 3.47 24.19 7.92 35.76 13.21 26.56 12.24 50.94 29.21 71.63 49.88 20.03 20.09 36.72 43.55 48.89 69.19 1.13 2.59 2.44 5.1 3.47 7.74 2.81 6.43 5.39 12.97 7.58 19.63 4.14 12.33 7.34 24.99 9.42 37.83.57 3.14 1.04 6.3 1.4 9.47.55 3.83.94 7.69 1.18 11.56.83 8.34.84 16.73.77 25.1-.07 4.97-.26 9.94-.75 14.89-.24 3.38-.51 6.76-.98 10.12-.39 2.72-.63 5.46-1.11 8.17-.9 5.15-1.7 10.31-2.87 15.41-4.1 18.5-10.3 36.55-18.51 53.63-15.77 32.83-38.83 62.17-67.12 85.12a246.503 246.503 0 0 1-56.91 34.86c-6.21 2.68-12.46 5.25-18.87 7.41-3.51 1.16-7.01 2.38-10.57 3.39-6.62 1.88-13.29 3.64-20.04 5-4.66.91-9.34 1.73-14.03 2.48-5.25.66-10.5 1.44-15.79 1.74-6.69.66-13.41.84-20.12.81-6.82.03-13.65-.12-20.45-.79-3.29-.23-6.57-.5-9.83-.95-2.72-.39-5.46-.63-8.17-1.11-4.12-.72-8.25-1.37-12.35-2.22-4.25-.94-8.49-1.89-12.69-3.02-8.63-2.17-17.08-5.01-25.41-8.13-10.49-4.12-20.79-8.75-30.64-14.25-2.14-1.15-4.28-2.29-6.35-3.57-11.22-6.58-21.86-14.1-31.92-22.34-34.68-28.41-61.41-66.43-76.35-108.7-3.09-8.74-5.71-17.65-7.8-26.68-1.48-6.16-2.52-12.42-3.58-18.66-.4-2.35-.61-4.73-.95-7.09-.6-3.96-.75-7.96-1.17-11.94-.8-9.47-.71-18.99-.51-28.49.14-3.51.34-7.01.7-10.51.31-3.17.46-6.37.92-9.52.41-2.81.65-5.65 1.16-8.44.7-3.94 1.3-7.9 2.12-11.82 3.43-16.52 8.47-32.73 15.26-48.18 1.15-2.92 2.59-5.72 3.86-8.59 8.05-16.71 17.9-32.56 29.49-47.06 20-25.38 45.1-46.68 73.27-62.47 7.5-4.15 15.16-8.05 23.07-11.37 15.82-6.88 32.41-11.95 49.31-15.38 3.51-.67 7.04-1.24 10.56-1.85 2.62-.47 5.28-.7 7.91-1.08 3.53-.53 7.1-.68 10.65-1.04 2.46-.24 4.91-.36 7.36-.51m8.64 24.41c-9.23.1-18.43.99-27.57 2.23-7.3 1.08-14.53 2.6-21.71 4.3-13.91 3.5-27.48 8.34-40.46 14.42-10.46 4.99-20.59 10.7-30.18 17.22-4.18 2.92-8.4 5.8-12.34 9.03-5.08 3.97-9.98 8.17-14.68 12.59-2.51 2.24-4.81 4.7-7.22 7.06-28.22 28.79-48.44 65.39-57.5 104.69-2.04 8.44-3.54 17.02-4.44 25.65-1.1 8.89-1.44 17.85-1.41 26.8.11 7.14.38 14.28 1.22 21.37.62 7.12 1.87 14.16 3.2 21.18 1.07 4.65 2.03 9.32 3.33 13.91 6.29 23.38 16.5 45.7 30.07 65.75 8.64 12.98 18.78 24.93 29.98 35.77 16.28 15.82 35.05 29.04 55.34 39.22 7.28 3.52 14.66 6.87 22.27 9.63 5.04 1.76 10.06 3.57 15.22 4.98 11.26 3.23 22.77 5.6 34.39 7.06 2.91.29 5.81.61 8.72.9 13.82 1.08 27.74 1 41.54-.43 4.45-.6 8.92-.99 13.35-1.78 3.63-.67 7.28-1.25 10.87-2.1 4.13-.98 8.28-1.91 12.36-3.07 26.5-7.34 51.58-19.71 73.58-36.2 15.78-11.82 29.96-25.76 42.12-41.28 3.26-4.02 6.17-8.31 9.13-12.55 3.39-5.06 6.58-10.25 9.6-15.54 2.4-4.44 4.74-8.91 6.95-13.45 5.69-12.05 10.28-24.62 13.75-37.49 2.59-10.01 4.75-20.16 5.9-30.45 1.77-13.47 1.94-27.1 1.29-40.65-.29-3.89-.67-7.77-1-11.66-2.23-19.08-6.79-37.91-13.82-55.8-5.95-15.13-13.53-29.63-22.61-43.13-12.69-18.8-28.24-35.68-45.97-49.83-25.05-20-54.47-34.55-85.65-42.08-7.78-1.93-15.69-3.34-23.63-4.45-3.91-.59-7.85-.82-11.77-1.24-7.39-.57-14.81-.72-22.22-.58zM139.26 83.53c13.3-8.89 28.08-15.38 43.3-20.18-3.17 1.77-6.44 3.38-9.53 5.29-11.21 6.68-21.52 14.9-30.38 24.49-6.8 7.43-12.76 15.73-17.01 24.89-3.29 6.86-5.64 14.19-6.86 21.71-.93 4.85-1.3 9.81-1.17 14.75.13 13.66 4.44 27.08 11.29 38.82 5.92 10.22 13.63 19.33 22.36 27.26 4.85 4.36 10.24 8.09 14.95 12.6 2.26 2.19 4.49 4.42 6.43 6.91 2.62 3.31 4.89 6.99 5.99 11.1.9 3.02.66 6.2.69 9.31.02 4.1-.04 8.2.03 12.3.14 3.54-.02 7.09.11 10.63.08 2.38.02 4.76.05 7.14.16 5.77.06 11.53.15 17.3.11 2.91.02 5.82.13 8.74.03 1.63.13 3.28-.03 4.91-.91.12-1.82.18-2.73.16-10.99 0-21.88-2.63-31.95-6.93-6-2.7-11.81-5.89-17.09-9.83-5.75-4.19-11.09-8.96-15.79-14.31-6.53-7.24-11.98-15.39-16.62-23.95-1.07-2.03-2.24-4.02-3.18-6.12-1.16-2.64-2.62-5.14-3.67-7.82-4.05-9.68-6.57-19.94-8.08-30.31-.49-4.44-1.09-8.88-1.2-13.35-.7-15.73.84-31.55 4.67-46.82 2.12-8.15 4.77-16.18 8.31-23.83 6.32-14.2 15.34-27.18 26.3-38.19 6.28-6.2 13.13-11.84 20.53-16.67zm175.37-20.12c2.74.74 5.41 1.74 8.09 2.68 6.36 2.33 12.68 4.84 18.71 7.96 13.11 6.44 25.31 14.81 35.82 24.97 10.2 9.95 18.74 21.6 25.14 34.34 1.28 2.75 2.64 5.46 3.81 8.26 6.31 15.1 10 31.26 11.23 47.57.41 4.54.44 9.09.45 13.64.07 11.64-1.49 23.25-4.3 34.53-1.97 7.27-4.35 14.49-7.86 21.18-3.18 6.64-6.68 13.16-10.84 19.24-6.94 10.47-15.6 19.87-25.82 27.22-10.48 7.64-22.64 13.02-35.4 15.38-3.51.69-7.08 1.08-10.66 1.21-1.85.06-3.72.16-5.56-.1-.28-2.15 0-4.31-.01-6.46-.03-3.73.14-7.45.1-11.17.19-7.02.02-14.05.21-21.07.03-2.38-.03-4.76.03-7.14.17-5.07-.04-10.14.14-15.21.1-2.99-.24-6.04.51-8.96.66-2.5 1.78-4.86 3.09-7.08 4.46-7.31 11.06-12.96 17.68-18.26 5.38-4.18 10.47-8.77 15.02-13.84 7.68-8.37 14.17-17.88 18.78-28.27 2.5-5.93 4.52-12.1 5.55-18.46.86-4.37 1.06-8.83 1.01-13.27-.02-7.85-1.4-15.65-3.64-23.17-1.75-5.73-4.27-11.18-7.09-16.45-3.87-6.93-8.65-13.31-13.96-19.2-9.94-10.85-21.75-19.94-34.6-27.1-1.85-1.02-3.84-1.82-5.63-2.97zm-100.8 58.45c.98-1.18 1.99-2.33 3.12-3.38-.61.93-1.27 1.81-1.95 2.68-3.1 3.88-5.54 8.31-7.03 13.06-.87 3.27-1.68 6.6-1.73 10-.07 2.52-.08 5.07.32 7.57 1.13 7.63 4.33 14.85 8.77 21.12 2 2.7 4.25 5.27 6.92 7.33 1.62 1.27 3.53 2.09 5.34 3.05 3.11 1.68 6.32 3.23 9.07 5.48 2.67 2.09 4.55 5.33 4.4 8.79-.01 73.67 0 147.34-.01 221.02 0 1.35-.08 2.7.04 4.04.13 1.48.82 2.83 1.47 4.15.86 1.66 1.78 3.34 3.18 4.62.85.77 1.97 1.4 3.15 1.24 1.5-.2 2.66-1.35 3.45-2.57.96-1.51 1.68-3.16 2.28-4.85.76-2.13.44-4.42.54-6.63.14-4.03-.02-8.06.14-12.09.03-5.89.03-11.77.06-17.66.14-3.62.03-7.24.11-10.86.15-4.03-.02-8.06.14-12.09.03-5.99.03-11.98.07-17.97.14-3.62.02-7.24.11-10.86.14-3.93-.02-7.86.14-11.78.03-5.99.03-11.98.06-17.97.16-3.94-.01-7.88.19-11.82.29 1.44.13 2.92.22 4.38.19 3.61.42 7.23.76 10.84.32 3.44.44 6.89.86 10.32.37 3.1.51 6.22.95 9.31.57 4.09.87 8.21 1.54 12.29 1.46 9.04 2.83 18.11 5.09 26.99 1.13 4.82 2.4 9.61 4 14.3 2.54 7.9 5.72 15.67 10.31 22.62 1.73 2.64 3.87 4.98 6.1 7.21.27.25.55.51.88.71.6.25 1.31-.07 1.7-.57.71-.88 1.17-1.94 1.7-2.93 4.05-7.8 8.18-15.56 12.34-23.31.7-1.31 1.44-2.62 2.56-3.61 1.75-1.57 3.84-2.69 5.98-3.63 2.88-1.22 5.9-2.19 9.03-2.42 6.58-.62 13.11.75 19.56 1.85 3.69.58 7.4 1.17 11.13 1.41 3.74.1 7.48.05 11.21-.28 8.55-.92 16.99-2.96 24.94-6.25 5.3-2.24 10.46-4.83 15.31-7.93 11.46-7.21 21.46-16.57 30.04-27.01 1.17-1.42 2.25-2.9 3.46-4.28-1.2 3.24-2.67 6.37-4.16 9.48-1.25 2.9-2.84 5.61-4.27 8.42-5.16 9.63-11.02 18.91-17.75 27.52-4.03 5.21-8.53 10.05-13.33 14.57-6.64 6.05-14.07 11.37-22.43 14.76-8.21 3.37-17.31 4.63-26.09 3.29-3.56-.58-7.01-1.69-10.41-2.88-2.79-.97-5.39-2.38-8.03-3.69-3.43-1.71-6.64-3.81-9.71-6.08 2.71 3.06 5.69 5.86 8.7 8.61 4.27 3.76 8.74 7.31 13.63 10.23 3.98 2.45 8.29 4.4 12.84 5.51 1.46.37 2.96.46 4.45.6-1.25 1.1-2.63 2.04-3.99 2.98-9.61 6.54-20.01 11.86-30.69 16.43-20.86 8.7-43.17 13.97-65.74 15.34-4.66.24-9.32.36-13.98.36-4.98-.11-9.97-.13-14.92-.65-11.2-.76-22.29-2.73-33.17-5.43-10.35-2.71-20.55-6.12-30.3-10.55-8.71-3.86-17.12-8.42-24.99-13.79-1.83-1.31-3.74-2.53-5.37-4.08 6.6-1.19 13.03-3.39 18.99-6.48 5.74-2.86 10.99-6.66 15.63-11.07 2.24-2.19 4.29-4.59 6.19-7.09-3.43 2.13-6.93 4.15-10.62 5.78-4.41 2.16-9.07 3.77-13.81 5.02-5.73 1.52-11.74 1.73-17.61 1.14-8.13-.95-15.86-4.27-22.51-8.98-4.32-2.94-8.22-6.43-11.96-10.06-9.93-10.16-18.2-21.81-25.66-33.86-3.94-6.27-7.53-12.75-11.12-19.22-1.05-2.04-2.15-4.05-3.18-6.1 2.85 2.92 5.57 5.97 8.43 8.88 8.99 8.97 18.56 17.44 29.16 24.48 7.55 4.9 15.67 9.23 24.56 11.03 3.11.73 6.32.47 9.47.81 2.77.28 5.56.2 8.34.3 5.05.06 10.11.04 15.16-.16 3.65-.16 7.27-.66 10.89-1.09 2.07-.25 4.11-.71 6.14-1.2 3.88-.95 8.11-.96 11.83.61 4.76 1.85 8.44 5.64 11.38 9.71 2.16 3.02 4.06 6.22 5.66 9.58 1.16 2.43 2.46 4.79 3.55 7.26 1 2.24 2.15 4.42 3.42 6.52.67 1.02 1.4 2.15 2.62 2.55 1.06-.75 1.71-1.91 2.28-3.03 2.1-4.16 3.42-8.65 4.89-13.05 2.02-6.59 3.78-13.27 5.19-20.02 2.21-9.25 3.25-18.72 4.54-28.13.56-3.98.83-7.99 1.31-11.97.87-10.64 1.9-21.27 2.24-31.94.08-1.86.24-3.71.25-5.57.01-4.35.25-8.69.22-13.03-.01-2.38-.01-4.76 0-7.13.05-5.07-.2-10.14-.22-15.21-.2-6.61-.71-13.2-1.29-19.78-.73-5.88-1.55-11.78-3.12-17.51-2.05-7.75-5.59-15.03-9.8-21.82-3.16-5.07-6.79-9.88-11.09-14.03-3.88-3.86-8.58-7.08-13.94-8.45-1.5-.41-3.06-.45-4.59-.64.07-2.99.7-5.93 1.26-8.85 1.59-7.71 3.8-15.3 6.76-22.6 1.52-4.03 3.41-7.9 5.39-11.72 3.45-6.56 7.62-12.79 12.46-18.46zm31.27 1.7c.35-.06.71-.12 1.07-.19.19 1.79.09 3.58.1 5.37v38.13c-.01 1.74.13 3.49-.15 5.22-.36-.03-.71-.05-1.06-.05-.95-3.75-1.72-7.55-2.62-11.31-.38-1.53-.58-3.09-1.07-4.59-1.7-.24-3.43-.17-5.15-.2-5.06-.01-10.13 0-15.19-.01-1.66-.01-3.32.09-4.98-.03-.03-.39-.26-.91.16-1.18 1.28-.65 2.72-.88 4.06-1.35 3.43-1.14 6.88-2.16 10.31-3.31 1.39-.48 2.9-.72 4.16-1.54.04-.56.02-1.13-.05-1.68-1.23-.55-2.53-.87-3.81-1.28-3.13-1.03-6.29-1.96-9.41-3.02-1.79-.62-3.67-1-5.41-1.79-.03-.37-.07-.73-.11-1.09 5.09-.19 10.2.06 15.3-.12 3.36-.13 6.73.08 10.09-.07.12-.39.26-.77.37-1.16 1.08-4.94 2.33-9.83 3.39-14.75zm5.97-.2c.36.05.72.12 1.08.2.98 3.85 1.73 7.76 2.71 11.61.36 1.42.56 2.88 1.03 4.27 2.53.18 5.07-.01 7.61.05 5.16.12 10.33.12 15.49.07.76-.01 1.52.03 2.28.08-.04.36-.07.72-.1 1.08-1.82.83-3.78 1.25-5.67 1.89-3.73 1.23-7.48 2.39-11.22 3.57-.57.17-1.12.42-1.67.64-.15.55-.18 1.12-.12 1.69.87.48 1.82.81 2.77 1.09 4.88 1.52 9.73 3.14 14.63 4.6.38.13.78.27 1.13.49.4.27.23.79.15 1.18-1.66.13-3.31.03-4.97.04-5.17.01-10.33-.01-15.5.01-1.61.03-3.22-.02-4.82.21-.52 1.67-.72 3.42-1.17 5.11-.94 3.57-1.52 7.24-2.54 10.78-.36.01-.71.02-1.06.06-.29-1.73-.15-3.48-.15-5.22v-38.13c.02-1.78-.08-3.58.11-5.37zM65.05 168.33c1.12-2.15 2.08-4.4 3.37-6.46-1.82 7.56-2.91 15.27-3.62 23-.8 7.71-.85 15.49-.54 23.23 1.05 19.94 5.54 39.83 14.23 57.88 2.99 5.99 6.35 11.83 10.5 17.11 6.12 7.47 12.53 14.76 19.84 21.09 4.8 4.1 9.99 7.78 15.54 10.8 3.27 1.65 6.51 3.39 9.94 4.68 5.01 2.03 10.19 3.61 15.42 4.94 3.83.96 7.78 1.41 11.52 2.71 5 1.57 9.47 4.61 13.03 8.43 4.93 5.23 8.09 11.87 10.2 18.67.99 2.9 1.59 5.91 2.17 8.92.15.75.22 1.52.16 2.29-6.5 2.78-13.26 5.06-20.26 6.18-4.11.78-8.29.99-12.46 1.08-10.25.24-20.47-1.76-30.12-5.12-3.74-1.42-7.49-2.85-11.03-4.72-8.06-3.84-15.64-8.7-22.46-14.46-2.92-2.55-5.83-5.13-8.4-8.03-9.16-9.83-16.3-21.41-21.79-33.65-2.39-5.55-4.61-11.18-6.37-16.96-1.17-3.94-2.36-7.89-3.26-11.91-.75-2.94-1.22-5.95-1.87-8.92-.46-2.14-.69-4.32-1.03-6.48-.85-5.43-1.28-10.93-1.33-16.43.11-6.18.25-12.37 1.07-18.5.4-2.86.67-5.74 1.15-8.6.98-5.7 2.14-11.37 3.71-16.93 3.09-11.65 7.48-22.95 12.69-33.84zm363.73-6.44c1.1 1.66 1.91 3.48 2.78 5.26 2.1 4.45 4.24 8.9 6.02 13.49 7.61 18.76 12.3 38.79 13.04 59.05.02 1.76.07 3.52.11 5.29.13 9.57-1.27 19.09-3.18 28.45-.73 3.59-1.54 7.17-2.58 10.69-4.04 14.72-10 29-18.41 41.78-8.21 12.57-19.01 23.55-31.84 31.41-5.73 3.59-11.79 6.64-18.05 9.19-5.78 2.19-11.71 4.03-17.8 5.11-6.4 1.05-12.91 1.52-19.4 1.23-7.92-.48-15.78-2.07-23.21-4.85-1.94-.8-3.94-1.46-5.84-2.33-.21-1.51.25-2.99.53-4.46 1.16-5.74 3.03-11.36 5.7-16.58 2.37-4.51 5.52-8.65 9.46-11.9 2.43-2.05 5.24-3.61 8.16-4.83 3.58-1.5 7.47-1.97 11.24-2.83 7.23-1.71 14.37-3.93 21.15-7 10.35-4.65 19.71-11.38 27.65-19.46 1.59-1.61 3.23-3.18 4.74-4.87 3.37-3.76 6.71-7.57 9.85-11.53 7.48-10.07 12.82-21.59 16.71-33.48 1.58-5.3 3.21-10.6 4.21-16.05.63-2.87 1.04-5.78 1.52-8.68.87-6.09 1.59-12.22 1.68-18.38.12-6.65.14-13.32-.53-19.94-.73-7.99-1.87-15.96-3.71-23.78z"
    ]
};
var $ef0249c5e48bf4e3$export$4001fe5db20c0fd2 = {
    prefix: "fab",
    iconName: "odysee",
    icon: [
        512,
        512,
        [],
        "e5c6",
        "M406.7 463c-42.3 30.8-94.4 49-150.7 49C144.9 512 50.3 441.2 14.9 342.2c2.4 1.7 5.9 3.6 7.9 4.4c16.3 7.4 40.1-5.4 62.9-28.7c6.9-6.9 14.4-12.4 22.8-17.3c18.3-11.9 37.6-20.8 58.4-27.2c0 0 22.3 34.2 43.1 74.8s-22.3 54-27.2 54c-.3 0-.8 0-1.5-.1c-11-.5-70-3-56 51.1c14.9 57.4 97.5 36.6 139.6 8.9s31.7-118.3 31.7-118.3c41.1-6.4 54 37.1 57.9 59.4c.8 4.6 1.1 9.9 1.4 15.5c1.1 21.2 2.3 45.6 35.3 46.4c5.3 0 10.6-.8 15.5-2zm-95.3-23.7c-2-.5-3.5-2.5-3-5c1-2.5 3-3.5 5-3s3.5 3 3 5s-2.5 3.5-5 3zm-207-95.6c1.5-.5 3.5 1 4 3c0 2-1 4-3 4c-1.5 .5-3.5-1-4-3c-.5-1.5 1-3.5 3-4zM451.8 421C489.3 376.4 512 318.8 512 256c0-67.5-26.1-128.9-68.8-174.7c-.1 23.5-6.1 48.2-16.8 69.2c-11.9 20.3-49 58.9-69.8 78.7c-.7 .3-1.1 .9-1.5 1.4c-.2 .2-.3 .4-.5 .6c-5 6.9-4 16.8 3 21.8c21.3 15.8 56.4 45.6 59.4 72.8c3.5 34.9 27.9 75.6 34.2 86.2l0 0c.8 1.3 1.3 2.1 1.4 2.4c0 2.2-.4 4.3-.8 6.5zM390.7 251c-.5 3 1 5.9 4 6.4s5.9-1 6.4-4s-1-5.9-4-6.4c-3-1-5.9 1-6.4 4zm61.4-60.9l-11.4 5.4-3 12.9-5.4-11.4-12.9-3 11.4-5.4 3-12.9 5.4 11.4 12.9 3zM395.5 41.3c-16.2 8.2-22.1 32.8-29 61.4l0 0c-.3 1.4-.7 2.8-1 4.2c-9.5 38.5-30.6 37.6-41.7 37.2c-1.1 0-2-.1-2.9-.1c-5.1 0-6-4-8.9-17.1c-2.6-12.1-6.9-32-17.9-63.6C271.4-2.5 211.4 13.9 165.9 41.1C110.6 74.2 131.5 143 146.1 190.5c.7 2.2 1.4 4.4 2 6.6c-4 4-13.8 7.5-26 11.9c-12.1 4.3-26.6 9.5-40.3 16.9C47.9 243.9 11.5 274.9 2 288.5C.7 277.8 0 267 0 256C0 114.6 114.6 0 256 0c51.4 0 99.4 15.2 139.5 41.3zM58.9 189.6c-1.5-2-4.5-3-6.4-1.5s-3 4.5-1.5 6.4s4.5 3 6.4 1.5c2.5-1.5 3-4.5 1.5-6.4zM327.3 64.9c2-1.5 5-.5 6.4 1.5c1.5 2.5 1 5.4-1.5 6.4c-2 1.5-5 .5-6.4-1.5s-.5-5 1.5-6.4zM95.1 105c-.5 1.5 .5 3 2 3c1.5 .5 3-.5 3-2c.5-1.5-.5-3-2-3s-3 .5-3 2zm84.7-.5c-3.5-43.1 37.1-54 37.1-54c44.1-15.4 56 5.9 66.4 37.6s3 42.6-38.6 58.9s-61.9-4.5-64.9-42.6zm89.6 14.9h1c2.5 0 5-2 5-5c2-6.9 1-14.4-2-20.8c-1.5-2-4-3.5-6.4-2.5c-3 1-4.5 4-3.5 6.9c2 4.5 3 9.9 1.5 14.9c-.5 3 1.5 5.9 4.5 6.4zm-9.9-41.6c-2 0-4-1-5-3s-2-3.5-3-5c-2-2-2-5.4 0-7.4s5.4-2 7.4 0c2 2.5 3.5 5 5 7.4s.5 5.9-2.5 7.4c-.6 0-1 .2-1.3 .3c-.2 .1-.4 .2-.6 .2z"
    ]
};
var $ef0249c5e48bf4e3$export$ee0c07b824da892f = {
    prefix: "fab",
    iconName: "square-whatsapp",
    icon: [
        448,
        512,
        [
            "whatsapp-square"
        ],
        "f40c",
        "M224 122.8c-72.7 0-131.8 59.1-131.9 131.8 0 24.9 7 49.2 20.2 70.1l3.1 5-13.3 48.6 49.9-13.1 4.8 2.9c20.2 12 43.4 18.4 67.1 18.4h.1c72.6 0 133.3-59.1 133.3-131.8 0-35.2-15.2-68.3-40.1-93.2-25-25-58-38.7-93.2-38.7zm77.5 188.4c-3.3 9.3-19.1 17.7-26.7 18.8-12.6 1.9-22.4.9-47.5-9.9-39.7-17.2-65.7-57.2-67.7-59.8-2-2.6-16.2-21.5-16.2-41s10.2-29.1 13.9-33.1c3.6-4 7.9-5 10.6-5 2.6 0 5.3 0 7.6.1 2.4.1 5.7-.9 8.9 6.8 3.3 7.9 11.2 27.4 12.2 29.4s1.7 4.3.3 6.9c-7.6 15.2-15.7 14.6-11.6 21.6 15.3 26.3 30.6 35.4 53.9 47.1 4 2 6.3 1.7 8.6-1 2.3-2.6 9.9-11.6 12.5-15.5 2.6-4 5.3-3.3 8.9-2 3.6 1.3 23.1 10.9 27.1 12.9s6.6 3 7.6 4.6c.9 1.9.9 9.9-2.4 19.1zM400 32H48C21.5 32 0 53.5 0 80v352c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48V80c0-26.5-21.5-48-48-48zM223.9 413.2c-26.6 0-52.7-6.7-75.8-19.3L64 416l22.5-82.2c-13.9-24-21.2-51.3-21.2-79.3C65.4 167.1 136.5 96 223.9 96c42.4 0 82.2 16.5 112.2 46.5 29.9 30 47.9 69.8 47.9 112.2 0 87.4-72.7 158.5-160.1 158.5z"
    ]
};
var $ef0249c5e48bf4e3$export$6fd1d044d66a938d = $ef0249c5e48bf4e3$export$ee0c07b824da892f;
var $ef0249c5e48bf4e3$export$ad65a356f9456393 = {
    prefix: "fab",
    iconName: "node-js",
    icon: [
        448,
        512,
        [],
        "f3d3",
        "M224 508c-6.7 0-13.5-1.8-19.4-5.2l-61.7-36.5c-9.2-5.2-4.7-7-1.7-8 12.3-4.3 14.8-5.2 27.9-12.7 1.4-.8 3.2-.5 4.6.4l47.4 28.1c1.7 1 4.1 1 5.7 0l184.7-106.6c1.7-1 2.8-3 2.8-5V149.3c0-2.1-1.1-4-2.9-5.1L226.8 37.7c-1.7-1-4-1-5.7 0L36.6 144.3c-1.8 1-2.9 3-2.9 5.1v213.1c0 2 1.1 4 2.9 4.9l50.6 29.2c27.5 13.7 44.3-2.4 44.3-18.7V167.5c0-3 2.4-5.3 5.4-5.3h23.4c2.9 0 5.4 2.3 5.4 5.3V378c0 36.6-20 57.6-54.7 57.6-10.7 0-19.1 0-42.5-11.6l-48.4-27.9C8.1 389.2.7 376.3.7 362.4V149.3c0-13.8 7.4-26.8 19.4-33.7L204.6 9c11.7-6.6 27.2-6.6 38.8 0l184.7 106.7c12 6.9 19.4 19.8 19.4 33.7v213.1c0 13.8-7.4 26.7-19.4 33.7L243.4 502.8c-5.9 3.4-12.6 5.2-19.4 5.2zm149.1-210.1c0-39.9-27-50.5-83.7-58-57.4-7.6-63.2-11.5-63.2-24.9 0-11.1 4.9-25.9 47.4-25.9 37.9 0 51.9 8.2 57.7 33.8.5 2.4 2.7 4.2 5.2 4.2h24c1.5 0 2.9-.6 3.9-1.7s1.5-2.6 1.4-4.1c-3.7-44.1-33-64.6-92.2-64.6-52.7 0-84.1 22.2-84.1 59.5 0 40.4 31.3 51.6 81.8 56.6 60.5 5.9 65.2 14.8 65.2 26.7 0 20.6-16.6 29.4-55.5 29.4-48.9 0-59.6-12.3-63.2-36.6-.4-2.6-2.6-4.5-5.3-4.5h-23.9c-3 0-5.3 2.4-5.3 5.3 0 31.1 16.9 68.2 97.8 68.2 58.4-.1 92-23.2 92-63.4z"
    ]
};
var $ef0249c5e48bf4e3$export$68bace18bdcdfc53 = {
    prefix: "fab",
    iconName: "edge-legacy",
    icon: [
        512,
        512,
        [],
        "e078",
        "M25.71,228.16l.35-.48c0,.16,0,.32-.07.48Zm460.58,15.51c0-44-7.76-84.46-28.81-122.4C416.5,47.88,343.91,8,258.89,8,119,7.72,40.62,113.21,26.06,227.68c42.42-61.31,117.07-121.38,220.37-125,0,0,109.67,0,99.42,105H170c6.37-37.39,18.55-59,34.34-78.93-75.05,34.9-121.85,96.1-120.75,188.32.83,71.45,50.13,144.84,120.75,172,83.35,31.84,192.77,7.2,240.13-21.33V363.31C363.6,419.8,173.6,424.23,172.21,295.74H486.29V243.67Z"
    ]
};
var $ef0249c5e48bf4e3$export$c597531345e00f14 = {
    prefix: "fab",
    iconName: "slack",
    icon: [
        448,
        512,
        [
            62447,
            "slack-hash"
        ],
        "f198",
        "M94.12 315.1c0 25.9-21.16 47.06-47.06 47.06S0 341 0 315.1c0-25.9 21.16-47.06 47.06-47.06h47.06v47.06zm23.72 0c0-25.9 21.16-47.06 47.06-47.06s47.06 21.16 47.06 47.06v117.84c0 25.9-21.16 47.06-47.06 47.06s-47.06-21.16-47.06-47.06V315.1zm47.06-188.98c-25.9 0-47.06-21.16-47.06-47.06S139 32 164.9 32s47.06 21.16 47.06 47.06v47.06H164.9zm0 23.72c25.9 0 47.06 21.16 47.06 47.06s-21.16 47.06-47.06 47.06H47.06C21.16 243.96 0 222.8 0 196.9s21.16-47.06 47.06-47.06H164.9zm188.98 47.06c0-25.9 21.16-47.06 47.06-47.06 25.9 0 47.06 21.16 47.06 47.06s-21.16 47.06-47.06 47.06h-47.06V196.9zm-23.72 0c0 25.9-21.16 47.06-47.06 47.06-25.9 0-47.06-21.16-47.06-47.06V79.06c0-25.9 21.16-47.06 47.06-47.06 25.9 0 47.06 21.16 47.06 47.06V196.9zM283.1 385.88c25.9 0 47.06 21.16 47.06 47.06 0 25.9-21.16 47.06-47.06 47.06-25.9 0-47.06-21.16-47.06-47.06v-47.06h47.06zm0-23.72c-25.9 0-47.06-21.16-47.06-47.06 0-25.9 21.16-47.06 47.06-47.06h117.84c25.9 0 47.06 21.16 47.06 47.06 0 25.9-21.16 47.06-47.06 47.06H283.1z"
    ]
};
var $ef0249c5e48bf4e3$export$46ef626e3b64d22 = $ef0249c5e48bf4e3$export$c597531345e00f14;
var $ef0249c5e48bf4e3$export$2d7cd04bce6afc11 = {
    prefix: "fab",
    iconName: "medrt",
    icon: [
        544,
        512,
        [],
        "f3c8",
        "M113.7 256c0 121.8 83.9 222.8 193.5 241.1-18.7 4.5-38.2 6.9-58.2 6.9C111.4 504 0 393 0 256S111.4 8 248.9 8c20.1 0 39.6 2.4 58.2 6.9C197.5 33.2 113.7 134.2 113.7 256m297.4 100.3c-77.7 55.4-179.6 47.5-240.4-14.6 5.5 14.1 12.7 27.7 21.7 40.5 61.6 88.2 182.4 109.3 269.7 47 87.3-62.3 108.1-184.3 46.5-272.6-9-12.9-19.3-24.3-30.5-34.2 37.4 78.8 10.7 178.5-67 233.9m-218.8-244c-1.4 1-2.7 2.1-4 3.1 64.3-17.8 135.9 4 178.9 60.5 35.7 47 42.9 106.6 24.4 158 56.7-56.2 67.6-142.1 22.3-201.8-50-65.5-149.1-74.4-221.6-19.8M296 224c-4.4 0-8-3.6-8-8v-40c0-4.4-3.6-8-8-8h-48c-4.4 0-8 3.6-8 8v40c0 4.4-3.6 8-8 8h-40c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8h40c4.4 0 8 3.6 8 8v40c0 4.4 3.6 8 8 8h48c4.4 0 8-3.6 8-8v-40c0-4.4 3.6-8 8-8h40c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8h-40z"
    ]
};
var $ef0249c5e48bf4e3$export$701b05aa394c8392 = {
    prefix: "fab",
    iconName: "usb",
    icon: [
        640,
        512,
        [],
        "f287",
        "M641.5 256c0 3.1-1.7 6.1-4.5 7.5L547.9 317c-1.4.8-2.8 1.4-4.5 1.4-1.4 0-3.1-.3-4.5-1.1-2.8-1.7-4.5-4.5-4.5-7.8v-35.6H295.7c25.3 39.6 40.5 106.9 69.6 106.9H392V354c0-5 3.9-8.9 8.9-8.9H490c5 0 8.9 3.9 8.9 8.9v89.1c0 5-3.9 8.9-8.9 8.9h-89.1c-5 0-8.9-3.9-8.9-8.9v-26.7h-26.7c-75.4 0-81.1-142.5-124.7-142.5H140.3c-8.1 30.6-35.9 53.5-69 53.5C32 327.3 0 295.3 0 256s32-71.3 71.3-71.3c33.1 0 61 22.8 69 53.5 39.1 0 43.9 9.5 74.6-60.4C255 88.7 273 95.7 323.8 95.7c7.5-20.9 27-35.6 50.4-35.6 29.5 0 53.5 23.9 53.5 53.5s-23.9 53.5-53.5 53.5c-23.4 0-42.9-14.8-50.4-35.6H294c-29.1 0-44.3 67.4-69.6 106.9h310.1v-35.6c0-3.3 1.7-6.1 4.5-7.8 2.8-1.7 6.4-1.4 8.9.3l89.1 53.5c2.8 1.1 4.5 4.1 4.5 7.2z"
    ]
};
var $ef0249c5e48bf4e3$export$ae279e8a7a5b9476 = {
    prefix: "fab",
    iconName: "tumblr",
    icon: [
        320,
        512,
        [],
        "f173",
        "M309.8 480.3c-13.6 14.5-50 31.7-97.4 31.7-120.8 0-147-88.8-147-140.6v-144H17.9c-5.5 0-10-4.5-10-10v-68c0-7.2 4.5-13.6 11.3-16 62-21.8 81.5-76 84.3-117.1.8-11 6.5-16.3 16.1-16.3h70.9c5.5 0 10 4.5 10 10v115.2h83c5.5 0 10 4.4 10 9.9v81.7c0 5.5-4.5 10-10 10h-83.4V360c0 34.2 23.7 53.6 68 35.8 4.8-1.9 9-3.2 12.7-2.2 3.5.9 5.8 3.4 7.4 7.9l22 64.3c1.8 5 3.3 10.6-.4 14.5z"
    ]
};
var $ef0249c5e48bf4e3$export$f796d2c05c7c6dbd = {
    prefix: "fab",
    iconName: "vaadin",
    icon: [
        448,
        512,
        [],
        "f408",
        "M224.5 140.7c1.5-17.6 4.9-52.7 49.8-52.7h98.6c20.7 0 32.1-7.8 32.1-21.6V54.1c0-12.2 9.3-22.1 21.5-22.1S448 41.9 448 54.1v36.5c0 42.9-21.5 62-66.8 62H280.7c-30.1 0-33 14.7-33 27.1 0 1.3-.1 2.5-.2 3.7-.7 12.3-10.9 22.2-23.4 22.2s-22.7-9.8-23.4-22.2c-.1-1.2-.2-2.4-.2-3.7 0-12.3-3-27.1-33-27.1H66.8c-45.3 0-66.8-19.1-66.8-62V54.1C0 41.9 9.4 32 21.6 32s21.5 9.9 21.5 22.1v12.3C43.1 80.2 54.5 88 75.2 88h98.6c44.8 0 48.3 35.1 49.8 52.7h.9zM224 456c11.5 0 21.4-7 25.7-16.3 1.1-1.8 97.1-169.6 98.2-171.4 11.9-19.6-3.2-44.3-27.2-44.3-13.9 0-23.3 6.4-29.8 20.3L224 362l-66.9-117.7c-6.4-13.9-15.9-20.3-29.8-20.3-24 0-39.1 24.6-27.2 44.3 1.1 1.9 97.1 169.6 98.2 171.4 4.3 9.3 14.2 16.3 25.7 16.3z"
    ]
};
var $ef0249c5e48bf4e3$export$e9b10b4b8b90dca5 = {
    prefix: "fab",
    iconName: "quora",
    icon: [
        448,
        512,
        [],
        "f2c4",
        "M440.5 386.7h-29.3c-1.5 13.5-10.5 30.8-33 30.8-20.5 0-35.3-14.2-49.5-35.8 44.2-34.2 74.7-87.5 74.7-153C403.5 111.2 306.8 32 205 32 105.3 32 7.3 111.7 7.3 228.7c0 134.1 131.3 221.6 249 189C276 451.3 302 480 351.5 480c81.8 0 90.8-75.3 89-93.3zM297 329.2C277.5 300 253.3 277 205.5 277c-30.5 0-54.3 10-69 22.8l12.2 24.3c6.2-3 13-4 19.8-4 35.5 0 53.7 30.8 69.2 61.3-10 3-20.7 4.2-32.7 4.2-75 0-107.5-53-107.5-156.7C97.5 124.5 130 71 205 71c76.2 0 108.7 53.5 108.7 157.7.1 41.8-5.4 75.6-16.7 100.5z"
    ]
};
var $ef0249c5e48bf4e3$export$e42e88e46d22eb98 = {
    prefix: "fab",
    iconName: "square-x-twitter",
    icon: [
        448,
        512,
        [],
        "e61a",
        "M64 32C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64zm297.1 84L257.3 234.6 379.4 396H283.8L209 298.1 123.3 396H75.8l111-126.9L69.7 116h98l67.7 89.5L313.6 116h47.5zM323.3 367.6L153.4 142.9H125.1L296.9 367.6h26.3z"
    ]
};
var $ef0249c5e48bf4e3$export$1bc30ca2ce539d7f = {
    prefix: "fab",
    iconName: "reacteurope",
    icon: [
        576,
        512,
        [],
        "f75d",
        "M250.6 211.74l5.8-4.1 5.8 4.1-2.1-6.8 5.7-4.3-7.1-.1-2.3-6.8-2.3 6.8-7.2.1 5.7 4.3zm63.7 0l5.8-4.1 5.8 4.1-2.1-6.8 5.7-4.3-7.2-.1-2.3-6.8-2.3 6.8-7.2.1 5.7 4.3zm-91.3 50.5h-3.4c-4.8 0-3.8 4-3.8 12.1 0 4.7-2.3 6.1-5.8 6.1s-5.8-1.4-5.8-6.1v-36.6c0-4.7 2.3-6.1 5.8-6.1s5.8 1.4 5.8 6.1c0 7.2-.7 10.5 3.8 10.5h3.4c4.7-.1 3.8-3.9 3.8-12.3 0-9.9-6.7-14.1-16.8-14.1h-.2c-10.1 0-16.8 4.2-16.8 14.1V276c0 10.4 6.7 14.1 16.8 14.1h.2c10.1 0 16.8-3.8 16.8-14.1 0-9.86 1.1-13.76-3.8-13.76zm-80.7 17.4h-14.7v-19.3H139c2.5 0 3.8-1.3 3.8-3.8v-2.1c0-2.5-1.3-3.8-3.8-3.8h-11.4v-18.3H142c2.5 0 3.8-1.3 3.8-3.8v-2.1c0-2.5-1.3-3.8-3.8-3.8h-21.7c-2.4-.1-3.7 1.3-3.7 3.8v59.1c0 2.5 1.3 3.8 3.8 3.8h21.9c2.5 0 3.8-1.3 3.8-3.8v-2.1c0-2.5-1.3-3.8-3.8-3.8zm-42-18.5c4.6-2 7.3-6 7.3-12.4v-11.9c0-10.1-6.7-14.1-16.8-14.1H77.4c-2.5 0-3.8 1.3-3.8 3.8v59.1c0 2.5 1.3 3.8 3.8 3.8h3.4c2.5 0 3.8-1.3 3.8-3.8v-22.9h5.6l7.4 23.5a4.1 4.1 0 0 0 4.3 3.2h3.3c2.8 0 4-1.8 3.2-4.4zm-3.8-14c0 4.8-2.5 6.1-6.1 6.1h-5.8v-20.9h5.8c3.6 0 6.1 1.3 6.1 6.1zM176 226a3.82 3.82 0 0 0-4.2-3.4h-6.9a3.68 3.68 0 0 0-4 3.4l-11 59.2c-.5 2.7.9 4.1 3.4 4.1h3a3.74 3.74 0 0 0 4.1-3.5l1.8-11.3h12.2l1.8 11.3a3.74 3.74 0 0 0 4.1 3.5h3.5c2.6 0 3.9-1.4 3.4-4.1zm-12.3 39.3l4.7-29.7 4.7 29.7zm89.3 20.2v-53.2h7.5c2.5 0 3.8-1.3 3.8-3.8v-2.1c0-2.5-1.3-3.8-3.8-3.8h-25.8c-2.5 0-3.8 1.3-3.8 3.8v2.1c0 2.5 1.3 3.8 3.8 3.8h7.3v53.2c0 2.5 1.3 3.8 3.8 3.8h3.4c2.5.04 3.8-1.3 3.8-3.76zm248-.8h-19.4V258h16.1a1.89 1.89 0 0 0 2-2v-.8a1.89 1.89 0 0 0-2-2h-16.1v-25.8h19.1a1.89 1.89 0 0 0 2-2v-.8a1.77 1.77 0 0 0-2-1.9h-22.2a1.62 1.62 0 0 0-2 1.8v63a1.81 1.81 0 0 0 2 1.9H501a1.81 1.81 0 0 0 2-1.9v-.8a1.84 1.84 0 0 0-2-1.96zm-93.1-62.9h-.8c-10.1 0-15.3 4.7-15.3 14.1V276c0 9.3 5.2 14.1 15.3 14.1h.8c10.1 0 15.3-4.8 15.3-14.1v-40.1c0-9.36-5.2-14.06-15.3-14.06zm10.2 52.4c-.1 8-3 11.1-10.5 11.1s-10.5-3.1-10.5-11.1v-36.6c0-7.9 3-11.1 10.5-11.1s10.5 3.2 10.5 11.1zm-46.5-14.5c6.1-1.6 9.2-6.1 9.2-13.3v-9.7c0-9.4-5.2-14.1-15.3-14.1h-13.7a1.81 1.81 0 0 0-2 1.9v63a1.81 1.81 0 0 0 2 1.9h1.2a1.74 1.74 0 0 0 1.9-1.9v-26.9h11.6l10.4 27.2a2.32 2.32 0 0 0 2.3 1.5h1.5c1.4 0 2-1 1.5-2.3zm-6.4-3.9H355v-28.5h10.2c7.5 0 10.5 3.1 10.5 11.1v6.4c0 7.84-3 11.04-10.5 11.04zm85.9-33.1h-13.7a1.62 1.62 0 0 0-2 1.8v63a1.81 1.81 0 0 0 2 1.9h1.2a1.74 1.74 0 0 0 1.9-1.9v-26.1h10.6c10.1 0 15.3-4.8 15.3-14.1v-10.5c0-9.4-5.2-14.1-15.3-14.1zm10.2 22.8c0 7.9-3 11.1-10.5 11.1h-10.2v-29.2h10.2c7.5-.1 10.5 3.1 10.5 11zM259.5 308l-2.3-6.8-2.3 6.8-7.1.1 5.7 4.3-2.1 6.8 5.8-4.1 5.8 4.1-2.1-6.8 5.7-4.3zm227.6-136.1a364.42 364.42 0 0 0-35.6-11.3c19.6-78 11.6-134.7-22.3-153.9C394.7-12.66 343.3 11 291 61.94q5.1 4.95 10.2 10.2c82.5-80 119.6-53.5 120.9-52.8 22.4 12.7 36 55.8 15.5 137.8a587.83 587.83 0 0 0-84.6-13C281.1 43.64 212.4 2 170.8 2 140 2 127 23 123.2 29.74c-18.1 32-13.3 84.2.1 133.8-70.5 20.3-120.7 54.1-120.3 95 .5 59.6 103.2 87.8 122.1 92.8-20.5 81.9-10.1 135.6 22.3 153.9 28 15.8 75.1 6 138.2-55.2q-5.1-4.95-10.2-10.2c-82.5 80-119.7 53.5-120.9 52.8-22.3-12.6-36-55.6-15.5-137.9 12.4 2.9 41.8 9.5 84.6 13 71.9 100.4 140.6 142 182.1 142 30.8 0 43.8-21 47.6-27.7 18-31.9 13.3-84.1-.1-133.8 152.3-43.8 156.2-130.2 33.9-176.3zM135.9 36.84c2.9-5.1 11.9-20.3 34.9-20.3 36.8 0 98.8 39.6 163.3 126.2a714 714 0 0 0-93.9.9 547.76 547.76 0 0 1 42.2-52.4Q277.3 86 272.2 81a598.25 598.25 0 0 0-50.7 64.2 569.69 569.69 0 0 0-84.4 14.6c-.2-1.4-24.3-82.2-1.2-123zm304.8 438.3c-2.9 5.1-11.8 20.3-34.9 20.3-36.7 0-98.7-39.4-163.3-126.2a695.38 695.38 0 0 0 93.9-.9 547.76 547.76 0 0 1-42.2 52.4q5.1 5.25 10.2 10.2a588.47 588.47 0 0 0 50.7-64.2c47.3-4.7 80.3-13.5 84.4-14.6 22.7 84.4 4.5 117 1.2 123zm9.1-138.6c-3.6-11.9-7.7-24.1-12.4-36.4a12.67 12.67 0 0 1-10.7-5.7l-.1.1a19.61 19.61 0 0 1-5.4 3.6c5.7 14.3 10.6 28.4 14.7 42.2a535.3 535.3 0 0 1-72 13c3.5-5.3 17.2-26.2 32.2-54.2a24.6 24.6 0 0 1-6-3.2c-1.1 1.2-3.6 4.2-10.9 4.2-6.2 11.2-17.4 30.9-33.9 55.2a711.91 711.91 0 0 1-112.4 1c-7.9-11.2-21.5-31.1-36.8-57.8a21 21 0 0 1-3-1.5c-1.9 1.6-3.9 3.2-12.6 3.2 6.3 11.2 17.5 30.7 33.8 54.6a548.81 548.81 0 0 1-72.2-11.7q5.85-21 14.1-42.9c-3.2 0-5.4.2-8.4-1a17.58 17.58 0 0 1-6.9 1c-4.9 13.4-9.1 26.5-12.7 39.4C-31.7 297-12.1 216 126.7 175.64c3.6 11.9 7.7 24.1 12.4 36.4 10.4 0 12.9 3.4 14.4 5.3a12 12 0 0 1 2.3-2.2c-5.8-14.7-10.9-29.2-15.2-43.3 7-1.8 32.4-8.4 72-13-15.9 24.3-26.7 43.9-32.8 55.3a14.22 14.22 0 0 1 6.4 8 23.42 23.42 0 0 1 10.2-8.4c6.5-11.7 17.9-31.9 34.8-56.9a711.72 711.72 0 0 1 112.4-1c31.5 44.6 28.9 48.1 42.5 64.5a21.42 21.42 0 0 1 10.4-7.4c-6.4-11.4-17.6-31-34.3-55.5 40.4 4.1 65 10 72.2 11.7-4 14.4-8.9 29.2-14.6 44.2a20.74 20.74 0 0 1 6.8 4.3l.1.1a12.72 12.72 0 0 1 8.9-5.6c4.9-13.4 9.2-26.6 12.8-39.5a359.71 359.71 0 0 1 34.5 11c106.1 39.9 74 87.9 72.6 90.4-19.8 35.1-80.1 55.2-105.7 62.5zm-114.4-114h-1.2a1.74 1.74 0 0 0-1.9 1.9v49.8c0 7.9-2.6 11.1-10.1 11.1s-10.1-3.1-10.1-11.1v-49.8a1.69 1.69 0 0 0-1.9-1.9H309a1.81 1.81 0 0 0-2 1.9v51.5c0 9.6 5 14.1 15.1 14.1h.4c10.1 0 15.1-4.6 15.1-14.1v-51.5a2 2 0 0 0-2.2-1.9zM321.7 308l-2.3-6.8-2.3 6.8-7.1.1 5.7 4.3-2.1 6.8 5.8-4.1 5.8 4.1-2.1-6.8 5.7-4.3zm-31.1 7.4l-2.3-6.8-2.3 6.8-7.1.1 5.7 4.3-2.1 6.8 5.8-4.1 5.8 4.1-2.1-6.8 5.7-4.3zm5.1-30.8h-19.4v-26.7h16.1a1.89 1.89 0 0 0 2-2v-.8a1.89 1.89 0 0 0-2-2h-16.1v-25.8h19.1a1.89 1.89 0 0 0 2-2v-.8a1.77 1.77 0 0 0-2-1.9h-22.2a1.81 1.81 0 0 0-2 1.9v63a1.81 1.81 0 0 0 2 1.9h22.5a1.77 1.77 0 0 0 2-1.9v-.8a1.83 1.83 0 0 0-2-2.06zm-7.4-99.4L286 192l-7.1.1 5.7 4.3-2.1 6.8 5.8-4.1 5.8 4.1-2.1-6.8 5.7-4.3-7.1-.1z"
    ]
};
var $ef0249c5e48bf4e3$export$c1f031b95dadaa21 = {
    prefix: "fab",
    iconName: "medium",
    icon: [
        640,
        512,
        [
            62407,
            "medium-m"
        ],
        "f23a",
        "M180.5,74.262C80.813,74.262,0,155.633,0,256S80.819,437.738,180.5,437.738,361,356.373,361,256,280.191,74.262,180.5,74.262Zm288.25,10.646c-49.845,0-90.245,76.619-90.245,171.095s40.406,171.1,90.251,171.1,90.251-76.619,90.251-171.1H559C559,161.5,518.6,84.908,468.752,84.908Zm139.506,17.821c-17.526,0-31.735,68.628-31.735,153.274s14.2,153.274,31.735,153.274S640,340.631,640,256C640,171.351,625.785,102.729,608.258,102.729Z"
    ]
};
var $ef0249c5e48bf4e3$export$a29b11db7eed2052 = $ef0249c5e48bf4e3$export$c1f031b95dadaa21;
var $ef0249c5e48bf4e3$export$2ffb27c42275836a = {
    prefix: "fab",
    iconName: "amilia",
    icon: [
        448,
        512,
        [],
        "f36d",
        "M240.1 32c-61.9 0-131.5 16.9-184.2 55.4-5.1 3.1-9.1 9.2-7.2 19.4 1.1 5.1 5.1 27.4 10.2 39.6 4.1 10.2 14.2 10.2 20.3 6.1 32.5-22.3 96.5-47.7 152.3-47.7 57.9 0 58.9 28.4 58.9 73.1v38.5C203 227.7 78.2 251 46.7 264.2 11.2 280.5 16.3 357.7 16.3 376s15.2 104 124.9 104c47.8 0 113.7-20.7 153.3-42.1v25.4c0 3 2.1 8.2 6.1 9.1 3.1 1 50.7 2 59.9 2s62.5.3 66.5-.7c4.1-1 5.1-6.1 5.1-9.1V168c-.1-80.3-57.9-136-192-136zm50.2 348c-21.4 13.2-48.7 24.4-79.1 24.4-52.8 0-58.9-33.5-59-44.7 0-12.2-3-42.7 18.3-52.9 24.3-13.2 75.1-29.4 119.8-33.5z"
    ]
};
var $ef0249c5e48bf4e3$export$642f133169ca9ebe = {
    prefix: "fab",
    iconName: "mixcloud",
    icon: [
        640,
        512,
        [],
        "f289",
        "M212.98 346.566H179.789V195.114L185.973 173.47H175.262L137.127 346.566H76.1069L37.7323 173.47H27.276L33.1913 195.114V346.566H0V165H65.6506L102.248 338.096H110.747L147.329 165H212.98L212.98 346.566ZM544.459 283.589L458.434 345.655V307.534L531.329 255.776L458.434 204.017V165.896L544.459 228.231H553.721L640 165.896V204.017L566.866 255.776L640 307.549V345.655L553.721 283.589H544.459ZM430.157 272.311H248.113V239.255H430.157V272.311Z"
    ]
};
var $ef0249c5e48bf4e3$export$5193bd9feb923609 = {
    prefix: "fab",
    iconName: "flipboard",
    icon: [
        448,
        512,
        [],
        "f44d",
        "M0 32v448h448V32H0zm358.4 179.2h-89.6v89.6h-89.6v89.6H89.6V121.6h268.8v89.6z"
    ]
};
var $ef0249c5e48bf4e3$export$e75485903cf50ab7 = {
    prefix: "fab",
    iconName: "viacoin",
    icon: [
        384,
        512,
        [],
        "f237",
        "M384 32h-64l-80.7 192h-94.5L64 32H0l48 112H0v48h68.5l13.8 32H0v48h102.8L192 480l89.2-208H384v-48h-82.3l13.8-32H384v-48h-48l48-112zM192 336l-27-64h54l-27 64z"
    ]
};
var $ef0249c5e48bf4e3$export$19d8e57a729f8d94 = {
    prefix: "fab",
    iconName: "critical-role",
    icon: [
        448,
        512,
        [],
        "f6c9",
        "M225.82 0c.26.15 216.57 124.51 217.12 124.72 3 1.18 3.7 3.46 3.7 6.56q-.11 125.17 0 250.36a5.88 5.88 0 0 1-3.38 5.78c-21.37 12-207.86 118.29-218.93 124.58h-3C142 466.34 3.08 386.56 2.93 386.48a3.29 3.29 0 0 1-1.88-3.24c0-.87 0-225.94-.05-253.1a5 5 0 0 1 2.93-4.93C27.19 112.11 213.2 6 224.07 0zM215.4 20.42l-.22-.16Q118.06 75.55 21 130.87c0 .12.08.23.13.35l30.86 11.64c-7.71 6-8.32 6-10.65 5.13-.1 0-24.17-9.28-26.8-10v230.43c.88-1.41 64.07-110.91 64.13-111 1.62-2.82 3-1.92 9.12-1.52 1.4.09 1.48.22.78 1.42-41.19 71.33-36.4 63-67.48 116.94-.81 1.4-.61 1.13 1.25 1.13h186.5c1.44 0 1.69-.23 1.7-1.64v-8.88c0-1.34 2.36-.81-18.37-1-7.46-.07-14.14-3.22-21.38-12.7-7.38-9.66-14.62-19.43-21.85-29.21-2.28-3.08-3.45-2.38-16.76-2.38-1.75 0-1.78 0-1.76 1.82.29 26.21.15 25.27 1 32.66.52 4.37 2.16 4.2 9.69 4.81 3.14.26 3.88 4.08.52 4.92-1.57.39-31.6.51-33.67-.1a2.42 2.42 0 0 1 .3-4.73c3.29-.76 6.16.81 6.66-4.44 1.3-13.66 1.17-9 1.1-79.42 0-10.82-.35-12.58-5.36-13.55-1.22-.24-3.54-.16-4.69-.55-2.88-1-2-4.84 1.77-4.85 33.67 0 46.08-1.07 56.06 4.86 7.74 4.61 12 11.48 12.51 20.4.88 14.59-6.51 22.35-15 32.59a1.46 1.46 0 0 0 0 2.22c2.6 3.25 5 6.63 7.71 9.83 27.56 33.23 24.11 30.54 41.28 33.06.89.13 1-.42 1-1.15v-11c0-1 .32-1.43 1.41-1.26a72.37 72.37 0 0 0 23.58-.3c1.08-.15 1.5.2 1.48 1.33 0 .11.88 26.69.87 26.8-.05 1.52.67 1.62 1.89 1.62h186.71Q386.51 304.6 346 234.33c2.26-.66-.4 0 6.69-1.39 2-.39 2.05-.41 3.11 1.44 7.31 12.64 77.31 134 77.37 134.06V138c-1.72.5-103.3 38.72-105.76 39.68-1.08.42-1.55.2-1.91-.88-.63-1.9-1.34-3.76-2.09-5.62-.32-.79-.09-1.13.65-1.39.1 0 95.53-35.85 103-38.77-65.42-37.57-130.56-75-196-112.6l86.82 150.39-.28.33c-9.57-.9-10.46-1.6-11.8-3.94-1-1.69-73.5-127.71-82-142.16-9.1 14.67-83.56 146.21-85.37 146.32-2.93.17-5.88.08-9.25.08q43.25-74.74 86.18-149zm51.93 129.92a37.68 37.68 0 0 0 5.54-.85c1.69-.3 2.53.2 2.6 1.92 0 .11.07 19.06-.86 20.45s-1.88 1.22-2.6-.19c-5-9.69 6.22-9.66-39.12-12-.7 0-1 .23-1 .93 0 .13 3.72 122 3.73 122.11 0 .89.52 1.2 1.21 1.51a83.92 83.92 0 0 1 8.7 4.05c7.31 4.33 11.38 10.84 12.41 19.31 1.44 11.8-2.77 35.77-32.21 37.14-2.75.13-28.26 1.08-34.14-23.25-4.66-19.26 8.26-32.7 19.89-36.4a2.45 2.45 0 0 0 2-2.66c.1-5.63 3-107.1 3.71-121.35.05-1.08-.62-1.16-1.35-1.15-32.35.52-36.75-.34-40.22 8.52-2.42 6.18-4.14 1.32-3.95.23q1.59-9 3.31-18c.4-2.11 1.43-2.61 3.43-1.86 5.59 2.11 6.72 1.7 37.25 1.92 1.73 0 1.78-.08 1.82-1.85.68-27.49.58-22.59 1-29.55a2.69 2.69 0 0 0-1.63-2.8c-5.6-2.91-8.75-7.55-8.9-13.87-.35-14.81 17.72-21.67 27.38-11.51 6.84 7.19 5.8 18.91-2.45 24.15a4.35 4.35 0 0 0-2.22 4.34c0 .59-.11-4.31 1 30.05 0 .9.43 1.12 1.24 1.11.1 0 23-.09 34.47-.37zM68.27 141.7c19.84-4.51 32.68-.56 52.49 1.69 2.76.31 3.74 1.22 3.62 4-.21 5-1.16 22.33-1.24 23.15a2.65 2.65 0 0 1-1.63 2.34c-4.06 1.7-3.61-4.45-4-7.29-3.13-22.43-73.87-32.7-74.63 25.4-.31 23.92 17 53.63 54.08 50.88 27.24-2 19-20.19 24.84-20.47a2.72 2.72 0 0 1 3 3.36c-1.83 10.85-3.42 18.95-3.45 19.15-1.54 9.17-86.7 22.09-93.35-42.06-2.71-25.85 10.44-53.37 40.27-60.15zm80 87.67h-19.49a2.57 2.57 0 0 1-2.66-1.79c2.38-3.75 5.89.92 5.86-6.14-.08-25.75.21-38 .23-40.1 0-3.42-.53-4.65-3.32-4.94-7-.72-3.11-3.37-1.11-3.38 11.84-.1 22.62-.18 30.05.72 8.77 1.07 16.71 12.63 7.93 22.62-2 2.25-4 4.42-6.14 6.73.95 1.15 6.9 8.82 17.28 19.68 2.66 2.78 6.15 3.51 9.88 3.13a2.21 2.21 0 0 0 2.23-2.12c.3-3.42.26 4.73.45-40.58 0-5.65-.34-6.58-3.23-6.83-3.95-.35-4-2.26-.69-3.37l19.09-.09c.32 0 4.49.53 1 3.38 0 .05-.16 0-.24 0-3.61.26-3.94 1-4 4.62-.27 43.93.07 40.23.41 42.82.11.84.27 2.23 5.1 2.14 2.49 0 3.86 3.37 0 3.4-10.37.08-20.74 0-31.11.07-10.67 0-13.47-6.2-24.21-20.82-1.6-2.18-8.31-2.36-8.2-.37.88 16.47 0 17.78 4 17.67 4.75-.1 4.73 3.57.83 3.55zm275-10.15c-1.21 7.13.17 10.38-5.3 10.34-61.55-.42-47.82-.22-50.72-.31a18.4 18.4 0 0 1-3.63-.73c-2.53-.6 1.48-1.23-.38-5.6-1.43-3.37-2.78-6.78-4.11-10.19a1.94 1.94 0 0 0-2-1.44 138 138 0 0 0-14.58.07 2.23 2.23 0 0 0-1.62 1.06c-1.58 3.62-3.07 7.29-4.51 11-1.27 3.23 7.86 1.32 12.19 2.16 3 .57 4.53 3.72.66 3.73H322.9c-2.92 0-3.09-3.15-.74-3.21a6.3 6.3 0 0 0 5.92-3.47c1.5-3 2.8-6 4.11-9.09 18.18-42.14 17.06-40.17 18.42-41.61a1.83 1.83 0 0 1 3 0c2.93 3.34 18.4 44.71 23.62 51.92 2 2.7 5.74 2 6.36 2 3.61.13 4-1.11 4.13-4.29.09-1.87.08 1.17.07-41.24 0-4.46-2.36-3.74-5.55-4.27-.26 0-2.56-.63-.08-3.06.21-.2-.89-.24 21.7-.15 2.32 0 5.32 2.75-1.21 3.45a2.56 2.56 0 0 0-2.66 2.83c-.07 1.63-.19 38.89.29 41.21a3.06 3.06 0 0 0 3.23 2.43c13.25.43 14.92.44 16-3.41 1.67-5.78 4.13-2.52 3.73-.19zm-104.72 64.37c-4.24 0-4.42-3.39-.61-3.41 35.91-.16 28.11.38 37.19-.65 1.68-.19 2.38.24 2.25 1.89-.26 3.39-.64 6.78-1 10.16-.25 2.16-3.2 2.61-3.4-.15-.38-5.31-2.15-4.45-15.63-5.08-1.58-.07-1.64 0-1.64 1.52V304c0 1.65 0 1.6 1.62 1.47 3.12-.25 10.31.34 15.69-1.52.47-.16 3.3-1.79 3.07 1.76 0 .21-.76 10.35-1.18 11.39-.53 1.29-1.88 1.51-2.58.32-1.17-2 0-5.08-3.71-5.3-15.42-.9-12.91-2.55-12.91 6 0 12.25-.76 16.11 3.89 16.24 16.64.48 14.4 0 16.43-5.71.84-2.37 3.5-1.77 3.18.58-.44 3.21-.85 6.43-1.23 9.64 0 .36-.16 2.4-4.66 2.39-37.16-.08-34.54-.19-35.21-.31-2.72-.51-2.2-3 .22-3.45 1.1-.19 4 .54 4.16-2.56 2.44-56.22-.07-51.34-3.91-51.33zm-.41-109.52c2.46.61 3.13 1.76 2.95 4.65-.33 5.3-.34 9-.55 9.69-.66 2.23-3.15 2.12-3.34-.27-.38-4.81-3.05-7.82-7.57-9.15-26.28-7.73-32.81 15.46-27.17 30.22 5.88 15.41 22 15.92 28.86 13.78 5.92-1.85 5.88-6.5 6.91-7.58 1.23-1.3 2.25-1.84 3.12 1.1 0 .1.57 11.89-6 12.75-1.6.21-19.38 3.69-32.68-3.39-21-11.19-16.74-35.47-6.88-45.33 14-14.06 39.91-7.06 42.32-6.47zM289.8 280.14c3.28 0 3.66 3 .16 3.43-2.61.32-5-.42-5 5.46 0 2-.19 29.05.4 41.45.11 2.29 1.15 3.52 3.44 3.65 22 1.21 14.95-1.65 18.79-6.34 1.83-2.24 2.76.84 2.76 1.08.35 13.62-4 12.39-5.19 12.4l-38.16-.19c-1.93-.23-2.06-3-.42-3.38 2-.48 4.94.4 5.13-2.8 1-15.87.57-44.65.34-47.81-.27-3.77-2.8-3.27-5.68-3.71-2.47-.38-2-3.22.34-3.22 1.45-.02 17.97-.03 23.09-.02zm-31.63-57.79c.07 4.08 2.86 3.46 6 3.58 2.61.1 2.53 3.41-.07 3.43-6.48 0-13.7 0-21.61-.06-3.84 0-3.38-3.35 0-3.37 4.49 0 3.24 1.61 3.41-45.54 0-5.08-3.27-3.54-4.72-4.23-2.58-1.23-1.36-3.09.41-3.15 1.29 0 20.19-.41 21.17.21s1.87 1.65-.42 2.86c-1 .52-3.86-.28-4.15 2.47 0 .21-.82 1.63-.07 43.8zm-36.91 274.27a2.93 2.93 0 0 0 3.26 0c17-9.79 182-103.57 197.42-112.51-.14-.43 11.26-.18-181.52-.27-1.22 0-1.57.37-1.53 1.56 0 .1 1.25 44.51 1.22 50.38a28.33 28.33 0 0 1-1.36 7.71c-.55 1.83.38-.5-13.5 32.23-.73 1.72-1 2.21-2-.08-4.19-10.34-8.28-20.72-12.57-31a23.6 23.6 0 0 1-2-10.79c.16-2.46.8-16.12 1.51-48 0-1.95 0-2-2-2h-183c2.58 1.63 178.32 102.57 196 112.76zm-90.9-188.75c0 2.4.36 2.79 2.76 3 11.54 1.17 21 3.74 25.64-7.32 6-14.46 2.66-34.41-12.48-38.84-2-.59-16-2.76-15.94 1.51.05 8.04.01 11.61.02 41.65zm105.75-15.05c0 2.13 1.07 38.68 1.09 39.13.34 9.94-25.58 5.77-25.23-2.59.08-2 1.37-37.42 1.1-39.43-14.1 7.44-14.42 40.21 6.44 48.8a17.9 17.9 0 0 0 22.39-7.07c4.91-7.76 6.84-29.47-5.43-39a2.53 2.53 0 0 1-.36.12zm-12.28-198c-9.83 0-9.73 14.75-.07 14.87s10.1-14.88.07-14.91zm-80.15 103.83c0 1.8.41 2.4 2.17 2.58 13.62 1.39 12.51-11 12.16-13.36-1.69-11.22-14.38-10.2-14.35-7.81.05 4.5-.03 13.68.02 18.59zm212.32 6.4l-6.1-15.84c-2.16 5.48-4.16 10.57-6.23 15.84z"
    ]
};
var $ef0249c5e48bf4e3$export$b431c4dc6e2095fc = {
    prefix: "fab",
    iconName: "sitrox",
    icon: [
        448,
        512,
        [],
        "e44a",
        "M212.439 0.00846128V0H448V128H64C64 57.6008 141.755 0.475338 212.439 0.00846128ZM237.256 192V192.007C307.135 192.475 384 249.6 384 320H210.809V319.995C140.915 319.563 64 262.424 64 192H237.256ZM235.565 511.993C306.251 511.521 384 454.399 384 384H0V512H235.565V511.993Z"
    ]
};
var $ef0249c5e48bf4e3$export$5311546a7fb29bad = {
    prefix: "fab",
    iconName: "discourse",
    icon: [
        448,
        512,
        [],
        "f393",
        "M225.9 32C103.3 32 0 130.5 0 252.1 0 256 .1 480 .1 480l225.8-.2c122.7 0 222.1-102.3 222.1-223.9C448 134.3 348.6 32 225.9 32zM224 384c-19.4 0-37.9-4.3-54.4-12.1L88.5 392l22.9-75c-9.8-18.1-15.4-38.9-15.4-61 0-70.7 57.3-128 128-128s128 57.3 128 128-57.3 128-128 128z"
    ]
};
var $ef0249c5e48bf4e3$export$4c7981055454786f = {
    prefix: "fab",
    iconName: "joomla",
    icon: [
        448,
        512,
        [],
        "f1aa",
        "M.6 92.1C.6 58.8 27.4 32 60.4 32c30 0 54.5 21.9 59.2 50.2 32.6-7.6 67.1.6 96.5 30l-44.3 44.3c-20.5-20.5-42.6-16.3-55.4-3.5-14.3 14.3-14.3 37.9 0 52.2l99.5 99.5-44 44.3c-87.7-87.2-49.7-49.7-99.8-99.7-26.8-26.5-35-64.8-24.8-98.9C20.4 144.6.6 120.7.6 92.1zm129.5 116.4l44.3 44.3c10-10 89.7-89.7 99.7-99.8 14.3-14.3 37.6-14.3 51.9 0 12.8 12.8 17 35-3.5 55.4l44 44.3c31.2-31.2 38.5-67.6 28.9-101.2 29.2-4.1 51.9-29.2 51.9-59.5 0-33.2-26.8-60.1-59.8-60.1-30.3 0-55.4 22.5-59.5 51.6-33.8-9.9-71.7-1.5-98.3 25.1-18.3 19.1-71.1 71.5-99.6 99.9zm266.3 152.2c8.2-32.7-.9-68.5-26.3-93.9-11.8-12.2 5 4.7-99.5-99.7l-44.3 44.3 99.7 99.7c14.3 14.3 14.3 37.6 0 51.9-12.8 12.8-35 17-55.4-3.5l-44 44.3c27.6 30.2 68 38.8 102.7 28 5.5 27.4 29.7 48.1 58.9 48.1 33 0 59.8-26.8 59.8-60.1 0-30.2-22.5-55-51.6-59.1zm-84.3-53.1l-44-44.3c-87 86.4-50.4 50.4-99.7 99.8-14.3 14.3-37.6 14.3-51.9 0-13.1-13.4-16.9-35.3 3.2-55.4l-44-44.3c-30.2 30.2-38 65.2-29.5 98.3-26.7 6-46.2 29.9-46.2 58.2C0 453.2 26.8 480 59.8 480c28.6 0 52.5-19.8 58.6-46.7 32.7 8.2 68.5-.6 94.2-26 32.1-32 12.2-12.4 99.5-99.7z"
    ]
};
var $ef0249c5e48bf4e3$export$1dd6c03244d1cf01 = {
    prefix: "fab",
    iconName: "mastodon",
    icon: [
        448,
        512,
        [],
        "f4f6",
        "M433 179.11c0-97.2-63.71-125.7-63.71-125.7-62.52-28.7-228.56-28.4-290.48 0 0 0-63.72 28.5-63.72 125.7 0 115.7-6.6 259.4 105.63 289.1 40.51 10.7 75.32 13 103.33 11.4 50.81-2.8 79.32-18.1 79.32-18.1l-1.7-36.9s-36.31 11.4-77.12 10.1c-40.41-1.4-83-4.4-89.63-54a102.54 102.54 0 0 1-.9-13.9c85.63 20.9 158.65 9.1 178.75 6.7 56.12-6.7 105-41.3 111.23-72.9 9.8-49.8 9-121.5 9-121.5zm-75.12 125.2h-46.63v-114.2c0-49.7-64-51.6-64 6.9v62.5h-46.33V197c0-58.5-64-56.6-64-6.9v114.2H90.19c0-122.1-5.2-147.9 18.41-175 25.9-28.9 79.82-30.8 103.83 6.1l11.6 19.5 11.6-19.5c24.11-37.1 78.12-34.8 103.83-6.1 23.71 27.3 18.4 53 18.4 175z"
    ]
};
var $ef0249c5e48bf4e3$export$a8bcb0976aa786fb = {
    prefix: "fab",
    iconName: "airbnb",
    icon: [
        448,
        512,
        [],
        "f834",
        "M224 373.12c-25.24-31.67-40.08-59.43-45-83.18-22.55-88 112.61-88 90.06 0-5.45 24.25-20.29 52-45 83.18zm138.15 73.23c-42.06 18.31-83.67-10.88-119.3-50.47 103.9-130.07 46.11-200-18.85-200-54.92 0-85.16 46.51-73.28 100.5 6.93 29.19 25.23 62.39 54.43 99.5-32.53 36.05-60.55 52.69-85.15 54.92-50 7.43-89.11-41.06-71.3-91.09 15.1-39.16 111.72-231.18 115.87-241.56 15.75-30.07 25.56-57.4 59.38-57.4 32.34 0 43.4 25.94 60.37 59.87 36 70.62 89.35 177.48 114.84 239.09 13.17 33.07-1.37 71.29-37.01 86.64zm47-136.12C280.27 35.93 273.13 32 224 32c-45.52 0-64.87 31.67-84.66 72.79C33.18 317.1 22.89 347.19 22 349.81-3.22 419.14 48.74 480 111.63 480c21.71 0 60.61-6.06 112.37-62.4 58.68 63.78 101.26 62.4 112.37 62.4 62.89.05 114.85-60.86 89.61-130.19.02-3.89-16.82-38.9-16.82-39.58z"
    ]
};
var $ef0249c5e48bf4e3$export$568095dca08f5ff3 = {
    prefix: "fab",
    iconName: "wolf-pack-battalion",
    icon: [
        512,
        512,
        [],
        "f514",
        "M267.73 471.53l10.56 15.84 5.28-12.32 5.28 7V512c21.06-7.92 21.11-66.86 25.51-97.21 4.62-31.89-.88-92.81 81.37-149.11-8.88-23.61-12-49.43-2.64-80.05C421 189 447 196.21 456.43 239.73l-30.35 8.36c11.15 23 17 46.76 13.2 72.14L412 313.18l-6.16 33.43-18.47-7-8.8 33.39-19.35-7 26.39 21.11 8.8-28.15L419 364.2l7-35.63 26.39 14.52c.25-20 7-58.06-8.8-84.45l26.39 5.28c4-22.07-2.38-39.21-7.92-56.74l22.43 9.68c-.44-25.07-29.94-56.79-61.58-58.5-20.22-1.09-56.74-25.17-54.1-51.9 2-19.87 17.45-42.62 43.11-49.7-44 36.51-9.68 67.3 5.28 73.46 4.4-11.44 17.54-69.08 0-130.2-40.39 22.87-89.65 65.1-93.2 147.79l-58 38.71-3.52 93.25L369.78 220l7 7-17.59 3.52-44 38.71-15.84-5.28-28.1 49.25-3.52 119.64 21.11 15.84-32.55 15.84-32.55-15.84 21.11-15.84-3.52-119.64-28.15-49.26-15.84 5.28-44-38.71-17.58-3.51 7-7 107.33 59.82-3.52-93.25-58.06-38.71C185 65.1 135.77 22.87 95.3 0c-17.54 61.12-4.4 118.76 0 130.2 15-6.16 49.26-36.95 5.28-73.46 25.66 7.08 41.15 29.83 43.11 49.7 2.63 26.74-33.88 50.81-54.1 51.9-31.65 1.72-61.15 33.44-61.59 58.51l22.43-9.68c-5.54 17.53-11.91 34.67-7.92 56.74l26.39-5.28c-15.76 26.39-9.05 64.43-8.8 84.45l26.39-14.52 7 35.63 24.63-5.28 8.8 28.15L153.35 366 134 373l-8.8-33.43-18.47 7-6.16-33.43-27.27 7c-3.82-25.38 2-49.1 13.2-72.14l-30.35-8.36c9.4-43.52 35.47-50.77 63.34-54.1 9.36 30.62 6.24 56.45-2.64 80.05 82.25 56.3 76.75 117.23 81.37 149.11 4.4 30.35 4.45 89.29 25.51 97.21v-29.83l5.28-7 5.28 12.32 10.56-15.84 11.44 21.11 11.43-21.1zm79.17-95L331.06 366c7.47-4.36 13.76-8.42 19.35-12.32-.6 7.22-.27 13.84-3.51 22.84zm28.15-49.26c-.4 10.94-.9 21.66-1.76 31.67-7.85-1.86-15.57-3.8-21.11-7 8.24-7.94 15.55-16.32 22.87-24.68zm24.63 5.28c0-13.43-2.05-24.21-5.28-33.43a235 235 0 0 1-18.47 27.27zm3.52-80.94c19.44 12.81 27.8 33.66 29.91 56.3-12.32-4.53-24.63-9.31-36.95-10.56 5.06-12 6.65-28.14 7-45.74zm-1.76-45.74c.81 14.3 1.84 28.82 1.76 42.23 19.22-8.11 29.78-9.72 44-14.08-10.61-18.96-27.2-25.53-45.76-28.16zM165.68 376.52L181.52 366c-7.47-4.36-13.76-8.42-19.35-12.32.6 7.26.27 13.88 3.51 22.88zm-28.15-49.26c.4 10.94.9 21.66 1.76 31.67 7.85-1.86 15.57-3.8 21.11-7-8.24-7.93-15.55-16.31-22.87-24.67zm-24.64 5.28c0-13.43 2-24.21 5.28-33.43a235 235 0 0 0 18.47 27.27zm-3.52-80.94c-19.44 12.81-27.8 33.66-29.91 56.3 12.32-4.53 24.63-9.31 37-10.56-5-12-6.65-28.14-7-45.74zm1.76-45.74c-.81 14.3-1.84 28.82-1.76 42.23-19.22-8.11-29.78-9.72-44-14.08 10.63-18.95 27.23-25.52 45.76-28.15z"
    ]
};
var $ef0249c5e48bf4e3$export$e08e0c43c651f28e = {
    prefix: "fab",
    iconName: "buy-n-large",
    icon: [
        576,
        512,
        [],
        "f8a6",
        "M288 32C133.27 32 7.79 132.32 7.79 256S133.27 480 288 480s280.21-100.32 280.21-224S442.73 32 288 32zm-85.39 357.19L64.1 390.55l77.25-290.74h133.44c63.15 0 84.93 28.65 78 72.84a60.24 60.24 0 0 1-1.5 6.85 77.39 77.39 0 0 0-17.21-1.93c-42.35 0-76.69 33.88-76.69 75.65 0 37.14 27.14 68 62.93 74.45-18.24 37.16-56.16 60.92-117.71 61.52zM358 207.11h32l-22.16 90.31h-35.41l-11.19-35.63-7.83 35.63h-37.83l26.63-90.31h31.34l15 36.75zm145.86 182.08H306.79L322.63 328a78.8 78.8 0 0 0 11.47.83c42.34 0 76.69-33.87 76.69-75.65 0-32.65-21-60.46-50.38-71.06l21.33-82.35h92.5l-53.05 205.36h103.87zM211.7 269.39H187l-13.8 56.47h24.7c16.14 0 32.11-3.18 37.94-26.65 5.56-22.31-7.99-29.82-24.14-29.82zM233 170h-21.34L200 217.71h21.37c18 0 35.38-14.64 39.21-30.14C265.23 168.71 251.07 170 233 170z"
    ]
};
var $ef0249c5e48bf4e3$export$100b84dda223030b = {
    prefix: "fab",
    iconName: "gulp",
    icon: [
        256,
        512,
        [],
        "f3ae",
        "M209.8 391.1l-14.1 24.6-4.6 80.2c0 8.9-28.3 16.1-63.1 16.1s-63.1-7.2-63.1-16.1l-5.8-79.4-14.9-25.4c41.2 17.3 126 16.7 165.6 0zm-196-253.3l13.6 125.5c5.9-20 20.8-47 40-55.2 6.3-2.7 12.7-2.7 18.7.9 5.2 3 9.6 9.3 10.1 11.8 1.2 6.5-2 9.1-4.5 9.1-3 0-5.3-4.6-6.8-7.3-4.1-7.3-10.3-7.6-16.9-2.8-6.9 5-12.9 13.4-17.1 20.7-5.1 8.8-9.4 18.5-12 28.2-1.5 5.6-2.9 14.6-.6 19.9 1 2.2 2.5 3.6 4.9 3.6 5 0 12.3-6.6 15.8-10.1 4.5-4.5 10.3-11.5 12.5-16l5.2-15.5c2.6-6.8 9.9-5.6 9.9 0 0 10.2-3.7 13.6-10 34.7-5.8 19.5-7.6 25.8-7.6 25.8-.7 2.8-3.4 7.5-6.3 7.5-1.2 0-2.1-.4-2.6-1.2-1-1.4-.9-5.3-.8-6.3.2-3.2 6.3-22.2 7.3-25.2-2 2.2-4.1 4.4-6.4 6.6-5.4 5.1-14.1 11.8-21.5 11.8-3.4 0-5.6-.9-7.7-2.4l7.6 79.6c2 5 39.2 17.1 88.2 17.1 49.1 0 86.3-12.2 88.2-17.1l10.9-94.6c-5.7 5.2-12.3 11.6-19.6 14.8-5.4 2.3-17.4 3.8-17.4-5.7 0-5.2 9.1-14.8 14.4-21.5 1.4-1.7 4.7-5.9 4.7-8.1 0-2.9-6-2.2-11.7 2.5-3.2 2.7-6.2 6.3-8.7 9.7-4.3 6-6.6 11.2-8.5 15.5-6.2 14.2-4.1 8.6-9.1 22-5 13.3-4.2 11.8-5.2 14-.9 1.9-2.2 3.5-4 4.5-1.9 1-4.5.9-6.1-.3-.9-.6-1.3-1.9-1.3-3.7 0-.9.1-1.8.3-2.7 1.5-6.1 7.8-18.1 15-34.3 1.6-3.7 1-2.6.8-2.3-6.2 6-10.9 8.9-14.4 10.5-5.8 2.6-13 2.6-14.5-4.1-.1-.4-.1-.8-.2-1.2-11.8 9.2-24.3 11.7-20-8.1-4.6 8.2-12.6 14.9-22.4 14.9-4.1 0-7.1-1.4-8.6-5.1-2.3-5.5 1.3-14.9 4.6-23.8 1.7-4.5 4-9.9 7.1-16.2 1.6-3.4 4.2-5.4 7.6-4.5.6.2 1.1.4 1.6.7 2.6 1.8 1.6 4.5.3 7.2-3.8 7.5-7.1 13-9.3 20.8-.9 3.3-2 9 1.5 9 2.4 0 4.7-.8 6.9-2.4 4.6-3.4 8.3-8.5 11.1-13.5 2-3.6 4.4-8.3 5.6-12.3.5-1.7 1.1-3.3 1.8-4.8 1.1-2.5 2.6-5.1 5.2-5.1 1.3 0 2.4.5 3.2 1.5 1.7 2.2 1.3 4.5.4 6.9-2 5.6-4.7 10.6-6.9 16.7-1.3 3.5-2.7 8-2.7 11.7 0 3.4 3.7 2.6 6.8 1.2 2.4-1.1 4.8-2.8 6.8-4.5 1.2-4.9.9-3.8 26.4-68.2 1.3-3.3 3.7-4.7 6.1-4.7 1.2 0 2.2.4 3.2 1.1 1.7 1.3 1.7 4.1 1 6.2-.7 1.9-.6 1.3-4.5 10.5-5.2 12.1-8.6 20.8-13.2 31.9-1.9 4.6-7.7 18.9-8.7 22.3-.6 2.2-1.3 5.8 1 5.8 5.4 0 19.3-13.1 23.1-17 .2-.3.5-.4.9-.6.6-1.9 1.2-3.7 1.7-5.5 1.4-3.8 2.7-8.2 5.3-11.3.8-1 1.7-1.6 2.7-1.6 2.8 0 4.2 1.2 4.2 4 0 1.1-.7 5.1-1.1 6.2 1.4-1.5 2.9-3 4.5-4.5 15-13.9 25.7-6.8 25.7.2 0 7.4-8.9 17.7-13.8 23.4-1.6 1.9-4.9 5.4-5 6.4 0 1.3.9 1.8 2.2 1.8 2 0 6.4-3.5 8-4.7 5-3.9 11.8-9.9 16.6-14.1l14.8-136.8c-30.5 17.1-197.6 17.2-228.3.2zm229.7-8.5c0 21-231.2 21-231.2 0 0-8.8 51.8-15.9 115.6-15.9 9 0 17.8.1 26.3.4l12.6-48.7L228.1.6c1.4-1.4 5.8-.2 9.9 3.5s6.6 7.9 5.3 9.3l-.1.1L185.9 74l-10 40.7c39.9 2.6 67.6 8.1 67.6 14.6zm-69.4 4.6c0-.8-.9-1.5-2.5-2.1l-.2.8c0 1.3-5 2.4-11.1 2.4s-11.1-1.1-11.1-2.4c0-.1 0-.2.1-.3l.2-.7c-1.8.6-3 1.4-3 2.3 0 2.1 6.2 3.7 13.7 3.7 7.7.1 13.9-1.6 13.9-3.7z"
    ]
};
var $ef0249c5e48bf4e3$export$f7edf083e5c27672 = {
    prefix: "fab",
    iconName: "creative-commons-sampling-plus",
    icon: [
        496,
        512,
        [],
        "f4f1",
        "M247.6 8C389.4 8 496 118.1 496 256c0 147.1-118.5 248-248.4 248C113.6 504 0 394.5 0 256 0 123.1 104.7 8 247.6 8zm.8 44.7C130.2 52.7 44.7 150.6 44.7 256c0 109.8 91.2 202.8 203.7 202.8 103.2 0 202.8-81.1 202.8-202.8.1-113.8-90.2-203.3-202.8-203.3zm107 205.6c-4.7 0-9 2.8-10.7 7.2l-4 9.5-11-92.8c-1.7-13.9-22-13.4-23.1.4l-4.3 51.4-5.2-68.8c-1.1-14.3-22.1-14.2-23.2 0l-3.5 44.9-5.9-94.3c-.9-14.5-22.3-14.4-23.2 0l-5.1 83.7-4.3-66.3c-.9-14.4-22.2-14.4-23.2 0l-5.3 80.2-4.1-57c-1.1-14.3-22-14.3-23.2-.2l-7.7 89.8-1.8-12.2c-1.7-11.4-17.1-13.6-22-3.3l-13.2 27.7H87.5v23.2h51.3c4.4 0 8.4-2.5 10.4-6.4l10.7 73.1c2 13.5 21.9 13 23.1-.7l3.8-43.6 5.7 78.3c1.1 14.4 22.3 14.2 23.2-.1l4.6-70.4 4.8 73.3c.9 14.4 22.3 14.4 23.2-.1l4.9-80.5 4.5 71.8c.9 14.3 22.1 14.5 23.2.2l4.6-58.6 4.9 64.4c1.1 14.3 22 14.2 23.1.1l6.8-83 2.7 22.3c1.4 11.8 17.7 14.1 22.3 3.1l18-43.4h50.5V258l-58.4.3zm-78 5.2h-21.9v21.9c0 4.1-3.3 7.5-7.5 7.5-4.1 0-7.5-3.3-7.5-7.5v-21.9h-21.9c-4.1 0-7.5-3.3-7.5-7.5 0-4.1 3.4-7.5 7.5-7.5h21.9v-21.9c0-4.1 3.4-7.5 7.5-7.5s7.5 3.3 7.5 7.5v21.9h21.9c4.1 0 7.5 3.3 7.5 7.5 0 4.1-3.4 7.5-7.5 7.5z"
    ]
};
var $ef0249c5e48bf4e3$export$7ea49f2cb08b52c1 = {
    prefix: "fab",
    iconName: "strava",
    icon: [
        384,
        512,
        [],
        "f428",
        "M158.4 0L7 292h89.2l62.2-116.1L220.1 292h88.5zm150.2 292l-43.9 88.2-44.6-88.2h-67.6l112.2 220 111.5-220z"
    ]
};
var $ef0249c5e48bf4e3$export$c09ea58a6f21cb3c = {
    prefix: "fab",
    iconName: "ember",
    icon: [
        640,
        512,
        [],
        "f423",
        "M639.9 254.6c-1.1-10.7-10.7-6.8-10.7-6.8s-15.6 12.1-29.3 10.7c-13.7-1.3-9.4-32-9.4-32s3-28.1-5.1-30.4c-8.1-2.4-18 7.3-18 7.3s-12.4 13.7-18.3 31.2l-1.6.5s1.9-30.6-.3-37.6c-1.6-3.5-16.4-3.2-18.8 3s-14.2 49.2-15 67.2c0 0-23.1 19.6-43.3 22.8s-25-9.4-25-9.4 54.8-15.3 52.9-59.1-44.2-27.6-49-24c-4.6 3.5-29.4 18.4-36.6 59.7-.2 1.4-.7 7.5-.7 7.5s-21.2 14.2-33 18c0 0 33-55.6-7.3-80.9-11.4-6.8-21.3-.5-27.2 5.3 13.6-17.3 46.4-64.2 36.9-105.2-5.8-24.4-18-27.1-29.2-23.1-17 6.7-23.5 16.7-23.5 16.7s-22 32-27.1 79.5-12.6 105.1-12.6 105.1-10.5 10.2-20.2 10.7-5.4-28.7-5.4-28.7 7.5-44.6 7-52.1-1.1-11.6-9.9-14.2c-8.9-2.7-18.5 8.6-18.5 8.6s-25.5 38.7-27.7 44.6l-1.3 2.4-1.3-1.6s18-52.7.8-53.5-28.5 18.8-28.5 18.8-19.6 32.8-20.4 36.5l-1.3-1.6s8.1-38.2 6.4-47.6c-1.6-9.4-10.5-7.5-10.5-7.5s-11.3-1.3-14.2 5.9-13.7 55.3-15 70.7c0 0-28.2 20.2-46.8 20.4-18.5.3-16.7-11.8-16.7-11.8s68-23.3 49.4-69.2c-8.3-11.8-18-15.5-31.7-15.3-13.7.3-30.3 8.6-41.3 33.3-5.3 11.8-6.8 23-7.8 31.5 0 0-12.3 2.4-18.8-2.9s-10 0-10 0-11.2 14-.1 18.3 28.1 6.1 28.1 6.1c1.6 7.5 6.2 19.5 19.6 29.7 20.2 15.3 58.8-1.3 58.8-1.3l15.9-8.8s.5 14.6 12.1 16.7 16.4 1 36.5-47.9c11.8-25 12.6-23.6 12.6-23.6l1.3-.3s-9.1 46.8-5.6 59.7C187.7 319.4 203 318 203 318s8.3 2.4 15-21.2 19.6-49.9 19.6-49.9h1.6s-5.6 48.1 3 63.7 30.9 5.3 30.9 5.3 15.6-7.8 18-10.2c0 0 18.5 15.8 44.6 12.9 58.3-11.5 79.1-25.9 79.1-25.9s10 24.4 41.1 26.7c35.5 2.7 54.8-18.6 54.8-18.6s-.3 13.5 12.1 18.6 20.7-22.8 20.7-22.8l20.7-57.2h1.9s1.1 37.3 21.5 43.2 47-13.7 47-13.7 6.4-3.5 5.3-14.3zm-578 5.3c.8-32 21.8-45.9 29-39 7.3 7 4.6 22-9.1 31.4-13.7 9.5-19.9 7.6-19.9 7.6zm272.8-123.8s19.1-49.7 23.6-25.5-40 96.2-40 96.2c.5-16.2 16.4-70.7 16.4-70.7zm22.8 138.4c-12.6 33-43.3 19.6-43.3 19.6s-3.5-11.8 6.4-44.9 33.3-20.2 33.3-20.2 16.2 12.4 3.6 45.5zm84.6-14.6s-3-10.5 8.1-30.6c11-20.2 19.6-9.1 19.6-9.1s9.4 10.2-1.3 25.5-26.4 14.2-26.4 14.2z"
    ]
};
var $ef0249c5e48bf4e3$export$c9a287a4ab49306f = {
    prefix: "fab",
    iconName: "canadian-maple-leaf",
    icon: [
        512,
        512,
        [],
        "f785",
        "M383.8 351.7c2.5-2.5 105.2-92.4 105.2-92.4l-17.5-7.5c-10-4.9-7.4-11.5-5-17.4 2.4-7.6 20.1-67.3 20.1-67.3s-47.7 10-57.7 12.5c-7.5 2.4-10-2.5-12.5-7.5s-15-32.4-15-32.4-52.6 59.9-55.1 62.3c-10 7.5-20.1 0-17.6-10 0-10 27.6-129.6 27.6-129.6s-30.1 17.4-40.1 22.4c-7.5 5-12.6 5-17.6-5C293.5 72.3 255.9 0 255.9 0s-37.5 72.3-42.5 79.8c-5 10-10 10-17.6 5-10-5-40.1-22.4-40.1-22.4S183.3 182 183.3 192c2.5 10-7.5 17.5-17.6 10-2.5-2.5-55.1-62.3-55.1-62.3S98.1 167 95.6 172s-5 9.9-12.5 7.5C73 177 25.4 167 25.4 167s17.6 59.7 20.1 67.3c2.4 6 5 12.5-5 17.4L23 259.3s102.6 89.9 105.2 92.4c5.1 5 10 7.5 5.1 22.5-5.1 15-10.1 35.1-10.1 35.1s95.2-20.1 105.3-22.6c8.7-.9 18.3 2.5 18.3 12.5S241 512 241 512h30s-5.8-102.7-5.8-112.8 9.5-13.4 18.4-12.5c10 2.5 105.2 22.6 105.2 22.6s-5-20.1-10-35.1 0-17.5 5-22.5z"
    ]
};
var $ef0249c5e48bf4e3$export$619d787387e2c15e = {
    prefix: "fab",
    iconName: "teamspeak",
    icon: [
        576,
        512,
        [],
        "f4f9",
        "M152.8 37.2c-32.2 38.1-56.1 82.6-69.9 130.5c0 .2-.1 .3-.1 .5C43.5 184.4 16 223 16 268c0 59.6 48.4 108 108 108s108-48.4 108-108c0-53.5-38.9-97.9-90-106.5c15.7-41.8 40.4-79.6 72.3-110.7c1.8-1.6 4-2.6 6.3-3.1c37.2-11.5 76.7-13.3 114.8-5.2C454.7 67.6 534 180.7 517.1 301.3c-8.4 62.6-38.6 112.7-87.7 151.4c-50.1 39.7-107.5 54.3-170.2 52.2l-24-1c12.4 2.8 25 4.9 37.6 6.3c40.7 4.2 81.4 2.1 120.1-12.5c94-35.5 149.3-102.3 162.9-202.5c4.8-52.6-5.8-105.4-30.8-152C454.6 11.3 290.8-38.4 159 32c-2.4 1.4-4.5 3.1-6.3 5.2zM309.4 433.9c-2.1 11.5-4.2 21.9-14.6 31.3c53.2-1 123.2-29.2 161.8-97.1c39.7-69.9 37.6-139.9-6.3-207.8C413.8 105 360.5 77.9 293.7 73.7c1.5 2.3 3.2 4.4 5.2 6.3l5.2 6.3c25.1 31.3 37.6 67.9 42.8 107.5c2.1 15.7-1 30.3-13.6 41.8c-4.2 3.1-5.2 6.3-4.2 10.4l7.3 17.7L365.7 318c5.2 11.5 4.2 19.8-6.3 28.2c-3.2 2.5-6.7 4.6-10.4 6.3l-18.8 8.4 3.1 13.6c3.1 6.3 1 12.5-3.1 17.7c-2.5 2.4-3.8 5.9-3.1 9.4c2.1 11.5-2.1 19.8-12.5 25.1c-2.1 1-4.2 5.2-5.2 7.3zm-133.6-3.1c16.7 11.5 34.5 20.9 53.2 26.1c24 5.2 41.8-6.3 44.9-30.3c1-8.4 5.2-14.6 12.5-17.7c7.3-4.2 8.4-7.3 2.1-13.6l-9.4-8.4 13.6-4.2c6.3-2.1 7.3-5.2 5.2-11.5c-1.4-3-2.4-6.2-3.1-9.4c-3.1-14.6-2.1-15.7 11.5-18.8c8.4-3.1 15.7-6.3 21.9-12.5c3.1-2.1 3.1-4.2 1-8.4l-16.7-30.3c-1-1.9-2.1-3.8-3.1-5.7c-6.4-11.7-13-23.6-15.7-37.1c-2.1-9.4-1-17.7 8.4-24c5.2-4.2 8.4-9.4 8.4-16.7c-.4-10.1-1.5-20.3-3.1-30.3c-6.3-37.6-23-68.9-51.2-95c-5.2-4.2-9.4-6.3-16.7-4.2L203.9 91.5c2 1.2 4 2.4 6 3.6l0 0c6.3 3.7 12.2 7.3 17 12.1c30.3 26.1 41.8 61.6 45.9 100.2c1 8.4 0 16.7-7.3 21.9c-8.4 5.2-10.4 12.5-7.3 20.9c4.9 13.2 10.4 26 16.7 38.6L291.6 318c-6.3 8.4-13.6 11.5-21.9 14.6c-12.5 3.1-14.6 7.3-10.4 20.9c.6 1.5 1.4 2.8 2.1 4.2c2.1 5.2 1 8.4-4.2 10.4l-12.5 3.1 5.2 4.2 4.2 4.2c4.2 5.2 4.2 8.4-2.1 10.4c-7.3 4.2-11.5 9.4-11.5 17.7c0 12.5-7.3 19.8-18.8 24c-3.8 1-7.6 1.5-11.5 1l-34.5-2.1z"
    ]
};
var $ef0249c5e48bf4e3$export$72c88c198f2680b = {
    prefix: "fab",
    iconName: "pushed",
    icon: [
        432,
        512,
        [],
        "f3e1",
        "M407 111.9l-98.5-9 14-33.4c10.4-23.5-10.8-40.4-28.7-37L22.5 76.9c-15.1 2.7-26 18.3-21.4 36.6l105.1 348.3c6.5 21.3 36.7 24.2 47.7 7l35.3-80.8 235.2-231.3c16.4-16.8 4.3-42.9-17.4-44.8zM297.6 53.6c5.1-.7 7.5 2.5 5.2 7.4L286 100.9 108.6 84.6l189-31zM22.7 107.9c-3.1-5.1 1-10 6.1-9.1l248.7 22.7-96.9 230.7L22.7 107.9zM136 456.4c-2.6 4-7.9 3.1-9.4-1.2L43.5 179.7l127.7 197.6c-7 15-35.2 79.1-35.2 79.1zm272.8-314.5L210.1 337.3l89.7-213.7 106.4 9.7c4 1.1 5.7 5.3 2.6 8.6z"
    ]
};
var $ef0249c5e48bf4e3$export$1e35be7b9c7acc1f = {
    prefix: "fab",
    iconName: "wordpress-simple",
    icon: [
        512,
        512,
        [],
        "f411",
        "M256 8C119.3 8 8 119.2 8 256c0 136.7 111.3 248 248 248s248-111.3 248-248C504 119.2 392.7 8 256 8zM33 256c0-32.3 6.9-63 19.3-90.7l106.4 291.4C84.3 420.5 33 344.2 33 256zm223 223c-21.9 0-43-3.2-63-9.1l66.9-194.4 68.5 187.8c.5 1.1 1 2.1 1.6 3.1-23.1 8.1-48 12.6-74 12.6zm30.7-327.5c13.4-.7 25.5-2.1 25.5-2.1 12-1.4 10.6-19.1-1.4-18.4 0 0-36.1 2.8-59.4 2.8-21.9 0-58.7-2.8-58.7-2.8-12-.7-13.4 17.7-1.4 18.4 0 0 11.4 1.4 23.4 2.1l34.7 95.2L200.6 393l-81.2-241.5c13.4-.7 25.5-2.1 25.5-2.1 12-1.4 10.6-19.1-1.4-18.4 0 0-36.1 2.8-59.4 2.8-4.2 0-9.1-.1-14.4-.3C109.6 73 178.1 33 256 33c58 0 110.9 22.2 150.6 58.5-1-.1-1.9-.2-2.9-.2-21.9 0-37.4 19.1-37.4 39.6 0 18.4 10.6 33.9 21.9 52.3 8.5 14.8 18.4 33.9 18.4 61.5 0 19.1-7.3 41.2-17 72.1l-22.2 74.3-80.7-239.6zm81.4 297.2l68.1-196.9c12.7-31.8 17-57.2 17-79.9 0-8.2-.5-15.8-1.5-22.9 17.4 31.8 27.3 68.2 27.3 107 0 82.3-44.6 154.1-110.9 192.7z"
    ]
};
var $ef0249c5e48bf4e3$export$cb3944b58accd310 = {
    prefix: "fab",
    iconName: "nutritionix",
    icon: [
        400,
        512,
        [],
        "f3d6",
        "M88 8.1S221.4-.1 209 112.5c0 0 19.1-74.9 103-40.6 0 0-17.7 74-88 56 0 0 14.6-54.6 66.1-56.6 0 0-39.9-10.3-82.1 48.8 0 0-19.8-94.5-93.6-99.7 0 0 75.2 19.4 77.6 107.5 0 .1-106.4 7-104-119.8zm312 315.6c0 48.5-9.7 95.3-32 132.3-42.2 30.9-105 48-168 48-62.9 0-125.8-17.1-168-48C9.7 419 0 372.2 0 323.7 0 275.3 17.7 229 40 192c42.2-30.9 97.1-48.6 160-48.6 63 0 117.8 17.6 160 48.6 22.3 37 40 83.3 40 131.7zM120 428c0-15.5-12.5-28-28-28s-28 12.5-28 28 12.5 28 28 28 28-12.5 28-28zm0-66.2c0-15.5-12.5-28-28-28s-28 12.5-28 28 12.5 28 28 28 28-12.5 28-28zm0-66.2c0-15.5-12.5-28-28-28s-28 12.5-28 28 12.5 28 28 28 28-12.5 28-28zM192 428c0-15.5-12.5-28-28-28s-28 12.5-28 28 12.5 28 28 28 28-12.5 28-28zm0-66.2c0-15.5-12.5-28-28-28s-28 12.5-28 28 12.5 28 28 28 28-12.5 28-28zm0-66.2c0-15.5-12.5-28-28-28s-28 12.5-28 28 12.5 28 28 28 28-12.5 28-28zM264 428c0-15.5-12.5-28-28-28s-28 12.5-28 28 12.5 28 28 28 28-12.5 28-28zm0-66.2c0-15.5-12.5-28-28-28s-28 12.5-28 28 12.5 28 28 28 28-12.5 28-28zm0-66.2c0-15.5-12.5-28-28-28s-28 12.5-28 28 12.5 28 28 28 28-12.5 28-28zM336 428c0-15.5-12.5-28-28-28s-28 12.5-28 28 12.5 28 28 28 28-12.5 28-28zm0-66.2c0-15.5-12.5-28-28-28s-28 12.5-28 28 12.5 28 28 28 28-12.5 28-28zm0-66.2c0-15.5-12.5-28-28-28s-28 12.5-28 28 12.5 28 28 28 28-12.5 28-28zm24-39.6c-4.8-22.3-7.4-36.9-16-56-38.8-19.9-90.5-32-144-32S94.8 180.1 56 200c-8.8 19.5-11.2 33.9-16 56 42.2-7.9 98.7-14.8 160-14.8s117.8 6.9 160 14.8z"
    ]
};
var $ef0249c5e48bf4e3$export$d30ca94800bf542b = {
    prefix: "fab",
    iconName: "wodu",
    icon: [
        640,
        512,
        [],
        "e088",
        "M178.414 339.706H141.1L112.166 223.475h-.478L83.228 339.706H45.2L0 168.946H37.548L64.574 285.177h.478L94.707 168.946h35.157l29.178 117.667h.479L187.5 168.946h36.831zM271.4 212.713c38.984 0 64.1 25.828 64.1 65.291 0 39.222-25.111 65.05-64.1 65.05-38.743 0-63.855-25.828-63.855-65.05C207.547 238.541 232.659 212.713 271.4 212.713zm0 104.753c23.2 0 30.133-19.852 30.133-39.462 0-19.852-6.934-39.7-30.133-39.7-27.7 0-29.894 19.85-29.894 39.7C241.508 297.614 248.443 317.466 271.4 317.466zM435.084 323.922h-.478c-7.893 13.392-21.765 19.132-37.548 19.132-37.31 0-55.485-32.045-55.485-66.246 0-33.243 18.415-64.095 54.767-64.095 14.589 0 28.938 6.218 36.831 18.416h.24V168.946h33.96v170.76H435.084zM405.428 238.3c-22.24 0-29.894 19.134-29.894 39.463 0 19.371 8.848 39.7 29.894 39.7 22.482 0 29.178-19.613 29.178-39.94C434.606 257.436 427.432 238.3 405.428 238.3zM592.96 339.706H560.673V322.487h-.718c-8.609 13.87-23.436 20.567-37.786 20.567-36.113 0-45.2-20.328-45.2-50.941V216.061h33.959V285.9c0 20.329 5.979 30.372 21.765 30.372 18.415 0 26.306-10.283 26.306-35.393V216.061H592.96zM602.453 302.876H640v36.83H602.453z"
    ]
};
var $ef0249c5e48bf4e3$export$6d89c09f17c54b19 = {
    prefix: "fab",
    iconName: "google-pay",
    icon: [
        640,
        512,
        [],
        "e079",
        "M105.72,215v41.25h57.1a49.66,49.66,0,0,1-21.14,32.6c-9.54,6.55-21.72,10.28-36,10.28-27.6,0-50.93-18.91-59.3-44.22a65.61,65.61,0,0,1,0-41l0,0c8.37-25.46,31.7-44.37,59.3-44.37a56.43,56.43,0,0,1,40.51,16.08L176.47,155a101.24,101.24,0,0,0-70.75-27.84,105.55,105.55,0,0,0-94.38,59.11,107.64,107.64,0,0,0,0,96.18v.15a105.41,105.41,0,0,0,94.38,59c28.47,0,52.55-9.53,70-25.91,20-18.61,31.41-46.15,31.41-78.91A133.76,133.76,0,0,0,205.38,215Zm389.41-4c-10.13-9.38-23.93-14.14-41.39-14.14-22.46,0-39.34,8.34-50.5,24.86l20.85,13.26q11.45-17,31.26-17a34.05,34.05,0,0,1,22.75,8.79A28.14,28.14,0,0,1,487.79,248v5.51c-9.1-5.07-20.55-7.75-34.64-7.75-16.44,0-29.65,3.88-39.49,11.77s-14.82,18.31-14.82,31.56a39.74,39.74,0,0,0,13.94,31.27c9.25,8.34,21,12.51,34.79,12.51,16.29,0,29.21-7.3,39-21.89h1v17.72h22.61V250C510.25,233.45,505.26,220.34,495.13,211ZM475.9,300.3a37.32,37.32,0,0,1-26.57,11.16A28.61,28.61,0,0,1,431,305.21a19.41,19.41,0,0,1-7.77-15.63c0-7,3.22-12.81,9.54-17.42s14.53-7,24.07-7C470,265,480.3,268,487.64,273.94,487.64,284.07,483.68,292.85,475.9,300.3Zm-93.65-142A55.71,55.71,0,0,0,341.74,142H279.07V328.74H302.7V253.1h39c16,0,29.5-5.36,40.51-15.93.88-.89,1.76-1.79,2.65-2.68A54.45,54.45,0,0,0,382.25,158.26Zm-16.58,62.23a30.65,30.65,0,0,1-23.34,9.68H302.7V165h39.63a32,32,0,0,1,22.6,9.23A33.18,33.18,0,0,1,365.67,220.49ZM614.31,201,577.77,292.7h-.45L539.9,201H514.21L566,320.55l-29.35,64.32H561L640,201Z"
    ]
};
var $ef0249c5e48bf4e3$export$fd8d76c5b86b3d2b = {
    prefix: "fab",
    iconName: "intercom",
    icon: [
        448,
        512,
        [],
        "f7af",
        "M392 32H56C25.1 32 0 57.1 0 88v336c0 30.9 25.1 56 56 56h336c30.9 0 56-25.1 56-56V88c0-30.9-25.1-56-56-56zm-108.3 82.1c0-19.8 29.9-19.8 29.9 0v199.5c0 19.8-29.9 19.8-29.9 0V114.1zm-74.6-7.5c0-19.8 29.9-19.8 29.9 0v216.5c0 19.8-29.9 19.8-29.9 0V106.6zm-74.7 7.5c0-19.8 29.9-19.8 29.9 0v199.5c0 19.8-29.9 19.8-29.9 0V114.1zM59.7 144c0-19.8 29.9-19.8 29.9 0v134.3c0 19.8-29.9 19.8-29.9 0V144zm323.4 227.8c-72.8 63-241.7 65.4-318.1 0-15-12.8 4.4-35.5 19.4-22.7 65.9 55.3 216.1 53.9 279.3 0 14.9-12.9 34.3 9.8 19.4 22.7zm5.2-93.5c0 19.8-29.9 19.8-29.9 0V144c0-19.8 29.9-19.8 29.9 0v134.3z"
    ]
};
var $ef0249c5e48bf4e3$export$16e69e0d77404518 = {
    prefix: "fab",
    iconName: "zhihu",
    icon: [
        640,
        512,
        [],
        "f63f",
        "M170.54 148.13v217.54l23.43.01 7.71 26.37 42.01-26.37h49.53V148.13H170.54zm97.75 193.93h-27.94l-27.9 17.51-5.08-17.47-11.9-.04V171.75h72.82v170.31zm-118.46-94.39H97.5c1.74-27.1 2.2-51.59 2.2-73.46h51.16s1.97-22.56-8.58-22.31h-88.5c3.49-13.12 7.87-26.66 13.12-40.67 0 0-24.07 0-32.27 21.57-3.39 8.9-13.21 43.14-30.7 78.12 5.89-.64 25.37-1.18 36.84-22.21 2.11-5.89 2.51-6.66 5.14-14.53h28.87c0 10.5-1.2 66.88-1.68 73.44H20.83c-11.74 0-15.56 23.62-15.56 23.62h65.58C66.45 321.1 42.83 363.12 0 396.34c20.49 5.85 40.91-.93 51-9.9 0 0 22.98-20.9 35.59-69.25l53.96 64.94s7.91-26.89-1.24-39.99c-7.58-8.92-28.06-33.06-36.79-41.81L87.9 311.95c4.36-13.98 6.99-27.55 7.87-40.67h61.65s-.09-23.62-7.59-23.62v.01zm412.02-1.6c20.83-25.64 44.98-58.57 44.98-58.57s-18.65-14.8-27.38-4.06c-6 8.15-36.83 48.2-36.83 48.2l19.23 14.43zm-150.09-59.09c-9.01-8.25-25.91 2.13-25.91 2.13s39.52 55.04 41.12 57.45l19.46-13.73s-25.67-37.61-34.66-45.86h-.01zM640 258.35c-19.78 0-130.91.93-131.06.93v-101c4.81 0 12.42-.4 22.85-1.2 40.88-2.41 70.13-4 87.77-4.81 0 0 12.22-27.19-.59-33.44-3.07-1.18-23.17 4.58-23.17 4.58s-165.22 16.49-232.36 18.05c1.6 8.82 7.62 17.08 15.78 19.55 13.31 3.48 22.69 1.7 49.15.89 24.83-1.6 43.68-2.43 56.51-2.43v99.81H351.41s2.82 22.31 25.51 22.85h107.94v70.92c0 13.97-11.19 21.99-24.48 21.12-14.08.11-26.08-1.15-41.69-1.81 1.99 3.97 6.33 14.39 19.31 21.84 9.88 4.81 16.17 6.57 26.02 6.57 29.56 0 45.67-17.28 44.89-45.31v-73.32h122.36c9.68 0 8.7-23.78 8.7-23.78l.03-.01z"
    ]
};
var $ef0249c5e48bf4e3$export$80de216c9d46bac = {
    prefix: "fab",
    iconName: "korvue",
    icon: [
        446,
        512,
        [],
        "f42f",
        "M386.5 34h-327C26.8 34 0 60.8 0 93.5v327.1C0 453.2 26.8 480 59.5 480h327.1c33 0 59.5-26.8 59.5-59.5v-327C446 60.8 419.2 34 386.5 34zM87.1 120.8h96v116l61.8-116h110.9l-81.2 132H87.1v-132zm161.8 272.1l-65.7-113.6v113.6h-96V262.1h191.5l88.6 130.8H248.9z"
    ]
};
var $ef0249c5e48bf4e3$export$4fe14f0ab3be9a3 = {
    prefix: "fab",
    iconName: "pix",
    icon: [
        512,
        512,
        [],
        "e43a",
        "M242.4 292.5C247.8 287.1 257.1 287.1 262.5 292.5L339.5 369.5C353.7 383.7 372.6 391.5 392.6 391.5H407.7L310.6 488.6C280.3 518.1 231.1 518.1 200.8 488.6L103.3 391.2H112.6C132.6 391.2 151.5 383.4 165.7 369.2L242.4 292.5zM262.5 218.9C256.1 224.4 247.9 224.5 242.4 218.9L165.7 142.2C151.5 127.1 132.6 120.2 112.6 120.2H103.3L200.7 22.76C231.1-7.586 280.3-7.586 310.6 22.76L407.8 119.9H392.6C372.6 119.9 353.7 127.7 339.5 141.9L262.5 218.9zM112.6 142.7C126.4 142.7 139.1 148.3 149.7 158.1L226.4 234.8C233.6 241.1 243 245.6 252.5 245.6C261.9 245.6 271.3 241.1 278.5 234.8L355.5 157.8C365.3 148.1 378.8 142.5 392.6 142.5H430.3L488.6 200.8C518.9 231.1 518.9 280.3 488.6 310.6L430.3 368.9H392.6C378.8 368.9 365.3 363.3 355.5 353.5L278.5 276.5C264.6 262.6 240.3 262.6 226.4 276.6L149.7 353.2C139.1 363 126.4 368.6 112.6 368.6H80.78L22.76 310.6C-7.586 280.3-7.586 231.1 22.76 200.8L80.78 142.7H112.6z"
    ]
};
var $ef0249c5e48bf4e3$export$c2ce1e5693cbcd01 = {
    prefix: "fab",
    iconName: "steam-symbol",
    icon: [
        448,
        512,
        [],
        "f3f6",
        "M395.5 177.5c0 33.8-27.5 61-61 61-33.8 0-61-27.3-61-61s27.3-61 61-61c33.5 0 61 27.2 61 61zm52.5.2c0 63-51 113.8-113.7 113.8L225 371.3c-4 43-40.5 76.8-84.5 76.8-40.5 0-74.7-28.8-83-67L0 358V250.7L97.2 290c15.1-9.2 32.2-13.3 52-11.5l71-101.7c.5-62.3 51.5-112.8 114-112.8C397 64 448 115 448 177.7zM203 363c0-34.7-27.8-62.5-62.5-62.5-4.5 0-9 .5-13.5 1.5l26 10.5c25.5 10.2 38 39 27.7 64.5-10.2 25.5-39.2 38-64.7 27.5-10.2-4-20.5-8.3-30.7-12.2 10.5 19.7 31.2 33.2 55.2 33.2 34.7 0 62.5-27.8 62.5-62.5zm207.5-185.3c0-42-34.3-76.2-76.2-76.2-42.3 0-76.5 34.2-76.5 76.2 0 42.2 34.3 76.2 76.5 76.2 41.9.1 76.2-33.9 76.2-76.2z"
    ]
};
var $ef0249c5e48bf4e3$export$3fa11687d7bc6a48 = {
    faMonero: $ef0249c5e48bf4e3$export$155bdf1ceac204e7,
    faHooli: $ef0249c5e48bf4e3$export$3a040ca24382cf1c,
    faYelp: $ef0249c5e48bf4e3$export$2de47f03337052b6,
    faCcVisa: $ef0249c5e48bf4e3$export$acc882c0b0e9e801,
    faLastfm: $ef0249c5e48bf4e3$export$8226e5267dd86de3,
    faShopware: $ef0249c5e48bf4e3$export$c0b2d6cff425a846,
    faCreativeCommonsNc: $ef0249c5e48bf4e3$export$e36098165f3fc869,
    faAws: $ef0249c5e48bf4e3$export$a4ddb2c7f767be70,
    faRedhat: $ef0249c5e48bf4e3$export$d65557a7abc2c5dc,
    faYoast: $ef0249c5e48bf4e3$export$73b6ef60226f6801,
    faCloudflare: $ef0249c5e48bf4e3$export$7a31e37b2189232c,
    faUps: $ef0249c5e48bf4e3$export$c6f6a1beb6102ac,
    faWpexplorer: $ef0249c5e48bf4e3$export$9ab35a48e8f904bf,
    faDyalog: $ef0249c5e48bf4e3$export$1661cbacae81932b,
    faBity: $ef0249c5e48bf4e3$export$76a6a7e968d921fe,
    faStackpath: $ef0249c5e48bf4e3$export$a14b012b76f98910,
    faBuysellads: $ef0249c5e48bf4e3$export$6c0bc096306cebf8,
    faFirstOrder: $ef0249c5e48bf4e3$export$e0a21844bf49ca8e,
    faModx: $ef0249c5e48bf4e3$export$fb06254b4488a5b6,
    faGuilded: $ef0249c5e48bf4e3$export$b6ff6f33a85ee805,
    faVnv: $ef0249c5e48bf4e3$export$13bd8782a2ce17e7,
    faSquareJs: $ef0249c5e48bf4e3$export$c989752ecb8b3fae,
    faJsSquare: $ef0249c5e48bf4e3$export$d9bf3211f885d573,
    faMicrosoft: $ef0249c5e48bf4e3$export$b3b8195c77f1f877,
    faQq: $ef0249c5e48bf4e3$export$39d59e523abf051d,
    faOrcid: $ef0249c5e48bf4e3$export$9bf8457cc97dd02e,
    faJava: $ef0249c5e48bf4e3$export$25a84a6ff654acd1,
    faInvision: $ef0249c5e48bf4e3$export$6e249797a4721568,
    faCreativeCommonsPdAlt: $ef0249c5e48bf4e3$export$d93ab92a56e88ce6,
    faCentercode: $ef0249c5e48bf4e3$export$961762d5b3aedd8d,
    faGlideG: $ef0249c5e48bf4e3$export$91d5526742c32d42,
    faDrupal: $ef0249c5e48bf4e3$export$51e679e8d2e3f8c1,
    faHireAHelper: $ef0249c5e48bf4e3$export$66507f26cc60b31e,
    faCreativeCommonsBy: $ef0249c5e48bf4e3$export$5040b13190e5beb7,
    faUnity: $ef0249c5e48bf4e3$export$72fd5838af249737,
    faWhmcs: $ef0249c5e48bf4e3$export$4d4f65ec2f52482,
    faRocketchat: $ef0249c5e48bf4e3$export$193ac2f517f63e63,
    faVk: $ef0249c5e48bf4e3$export$a6bf4d62e541f988,
    faUntappd: $ef0249c5e48bf4e3$export$f1679625ed434576,
    faMailchimp: $ef0249c5e48bf4e3$export$da9f5a873e107292,
    faCss3Alt: $ef0249c5e48bf4e3$export$928cd5ee6ccd55c0,
    faSquareReddit: $ef0249c5e48bf4e3$export$307bcbd032fbb8d3,
    faRedditSquare: $ef0249c5e48bf4e3$export$f8480c75bb6acc77,
    faVimeoV: $ef0249c5e48bf4e3$export$2ea137a3f22bc61,
    faContao: $ef0249c5e48bf4e3$export$d023cd407bbc3cab,
    faSquareFontAwesome: $ef0249c5e48bf4e3$export$128da80f2cbe244a,
    faDeskpro: $ef0249c5e48bf4e3$export$9005bf63ad3e3083,
    faSistrix: $ef0249c5e48bf4e3$export$36ca6be2e064d2cd,
    faSquareInstagram: $ef0249c5e48bf4e3$export$526087fb4de86dae,
    faInstagramSquare: $ef0249c5e48bf4e3$export$ccb1f25058292a04,
    faBattleNet: $ef0249c5e48bf4e3$export$fb3fd8e112e1fa28,
    faTheRedYeti: $ef0249c5e48bf4e3$export$daa019c708da49e9,
    faSquareHackerNews: $ef0249c5e48bf4e3$export$ca115ee475bced67,
    faHackerNewsSquare: $ef0249c5e48bf4e3$export$310b7424f1f97fc,
    faEdge: $ef0249c5e48bf4e3$export$9c65bd68cbc68ec9,
    faThreads: $ef0249c5e48bf4e3$export$2a1c6a809b4fdc7f,
    faNapster: $ef0249c5e48bf4e3$export$29d678db44edc00,
    faSquareSnapchat: $ef0249c5e48bf4e3$export$8176f1a0ece4380c,
    faSnapchatSquare: $ef0249c5e48bf4e3$export$20f908cf15afb04b,
    faGooglePlusG: $ef0249c5e48bf4e3$export$74ebd8f5ac37d070,
    faArtstation: $ef0249c5e48bf4e3$export$4fb55b03537dc8e3,
    faMarkdown: $ef0249c5e48bf4e3$export$4401a9960e402a1c,
    faSourcetree: $ef0249c5e48bf4e3$export$fd6b8582f52b208a,
    faGooglePlus: $ef0249c5e48bf4e3$export$384e1aaf24320a2d,
    faDiaspora: $ef0249c5e48bf4e3$export$f59fd74fa97e6ae5,
    faFoursquare: $ef0249c5e48bf4e3$export$b14039dbb12386bc,
    faStackOverflow: $ef0249c5e48bf4e3$export$2c0cf6f85294daec,
    faGithubAlt: $ef0249c5e48bf4e3$export$edfa6885dbf62839,
    faPhoenixSquadron: $ef0249c5e48bf4e3$export$699e806dfe31d90b,
    faPagelines: $ef0249c5e48bf4e3$export$e4b095fb96bd3e1,
    faAlgolia: $ef0249c5e48bf4e3$export$8819d592a12ec37e,
    faRedRiver: $ef0249c5e48bf4e3$export$1052bcfc0bf56d5d,
    faCreativeCommonsSa: $ef0249c5e48bf4e3$export$976ebfab93ea9362,
    faSafari: $ef0249c5e48bf4e3$export$3fbc2591308fa490,
    faGoogle: $ef0249c5e48bf4e3$export$4675affbae76524d,
    faSquareFontAwesomeStroke: $ef0249c5e48bf4e3$export$dda4448112663ba,
    faFontAwesomeAlt: $ef0249c5e48bf4e3$export$85f790d14ecf253e,
    faAtlassian: $ef0249c5e48bf4e3$export$f200be919c1eaf0d,
    faLinkedinIn: $ef0249c5e48bf4e3$export$ed0a679f653cc1ec,
    faDigitalOcean: $ef0249c5e48bf4e3$export$c5c4219467aa9953,
    faNimblr: $ef0249c5e48bf4e3$export$3f240983de3f5d10,
    faChromecast: $ef0249c5e48bf4e3$export$8d89e361d79b386e,
    faEvernote: $ef0249c5e48bf4e3$export$acd6dee6975fc503,
    faHackerNews: $ef0249c5e48bf4e3$export$5d439911ece032d6,
    faCreativeCommonsSampling: $ef0249c5e48bf4e3$export$e443cc965f82dd02,
    faAdversal: $ef0249c5e48bf4e3$export$1a30438e2bd95428,
    faCreativeCommons: $ef0249c5e48bf4e3$export$cf9c9b2132d3672c,
    faWatchmanMonitoring: $ef0249c5e48bf4e3$export$17b7e34aba803644,
    faFonticons: $ef0249c5e48bf4e3$export$324e0175b7ef27f7,
    faWeixin: $ef0249c5e48bf4e3$export$5c0c3408fef47d33,
    faShirtsinbulk: $ef0249c5e48bf4e3$export$621d1ced1e254c1c,
    faCodepen: $ef0249c5e48bf4e3$export$f02422936d21d2f4,
    faGitAlt: $ef0249c5e48bf4e3$export$9ce7fda0737f89e7,
    faLyft: $ef0249c5e48bf4e3$export$c2221e2ed2fea622,
    faRev: $ef0249c5e48bf4e3$export$344ccb7aebcc7cfa,
    faWindows: $ef0249c5e48bf4e3$export$b138356c7d4344fd,
    faWizardsOfTheCoast: $ef0249c5e48bf4e3$export$2c1079aeb76cd815,
    faSquareViadeo: $ef0249c5e48bf4e3$export$d20d4c95d5790834,
    faViadeoSquare: $ef0249c5e48bf4e3$export$46c94e3313db0253,
    faMeetup: $ef0249c5e48bf4e3$export$61e6f6fcefd81d6e,
    faCentos: $ef0249c5e48bf4e3$export$47b9420154e916ca,
    faAdn: $ef0249c5e48bf4e3$export$64d8cc39326ee7a8,
    faCloudsmith: $ef0249c5e48bf4e3$export$616a6b084ab35801,
    faPiedPiperAlt: $ef0249c5e48bf4e3$export$ef7de58d3fe843ba,
    faSquareDribbble: $ef0249c5e48bf4e3$export$fc95d67ac3aa8c53,
    faDribbbleSquare: $ef0249c5e48bf4e3$export$ff55221913bb3cd0,
    faCodiepie: $ef0249c5e48bf4e3$export$248fddd2c856e8cc,
    faNode: $ef0249c5e48bf4e3$export$4c16416edc1f091a,
    faMix: $ef0249c5e48bf4e3$export$4176cb98e090fc09,
    faSteam: $ef0249c5e48bf4e3$export$7c80ad2689275b29,
    faCcApplePay: $ef0249c5e48bf4e3$export$37af1170a8e0c21b,
    faScribd: $ef0249c5e48bf4e3$export$d271dfaa2c63aec5,
    faDebian: $ef0249c5e48bf4e3$export$b30079bac9ebcf2a,
    faOpenid: $ef0249c5e48bf4e3$export$b2dcd141e150a391,
    faInstalod: $ef0249c5e48bf4e3$export$792bea9ca32c60da,
    faExpeditedssl: $ef0249c5e48bf4e3$export$fe553f3645c5aefa,
    faSellcast: $ef0249c5e48bf4e3$export$23a4f18e8bd9f913,
    faSquareTwitter: $ef0249c5e48bf4e3$export$58fc652e3c488143,
    faTwitterSquare: $ef0249c5e48bf4e3$export$270370f3feaf6b90,
    faRProject: $ef0249c5e48bf4e3$export$f9a04980ef22b6b0,
    faDelicious: $ef0249c5e48bf4e3$export$fc15ee5b2eab0af4,
    faFreebsd: $ef0249c5e48bf4e3$export$1fa830857b3a4dc7,
    faVuejs: $ef0249c5e48bf4e3$export$3e0cc9b4555f8145,
    faAccusoft: $ef0249c5e48bf4e3$export$233214294e90ff53,
    faIoxhost: $ef0249c5e48bf4e3$export$d11e9e62a1442448,
    faFonticonsFi: $ef0249c5e48bf4e3$export$e6a0ac478bf76bf2,
    faAppStore: $ef0249c5e48bf4e3$export$500760921a1e1f4e,
    faCcMastercard: $ef0249c5e48bf4e3$export$dd0d0d0b3b519db5,
    faItunesNote: $ef0249c5e48bf4e3$export$a0c8448ba3e387bc,
    faGolang: $ef0249c5e48bf4e3$export$36cd41563937ec03,
    faKickstarter: $ef0249c5e48bf4e3$export$f06b8625c0ebb13a,
    faGrav: $ef0249c5e48bf4e3$export$fdcdacf548a335ed,
    faWeibo: $ef0249c5e48bf4e3$export$75bd846ccb390b1e,
    faUncharted: $ef0249c5e48bf4e3$export$e1cced2e7ea20eff,
    faFirstdraft: $ef0249c5e48bf4e3$export$44a54556e145bddf,
    faSquareYoutube: $ef0249c5e48bf4e3$export$1082b39fc1076b43,
    faYoutubeSquare: $ef0249c5e48bf4e3$export$8992da42b645c563,
    faWikipediaW: $ef0249c5e48bf4e3$export$6657c749288c4042,
    faWpressr: $ef0249c5e48bf4e3$export$66f88c21efa6f12d,
    faRendact: $ef0249c5e48bf4e3$export$d06b08e37a8aaaec,
    faAngellist: $ef0249c5e48bf4e3$export$65f66dc47afb97bd,
    faGalacticRepublic: $ef0249c5e48bf4e3$export$ba5a2dfe23db8bb6,
    faNfcDirectional: $ef0249c5e48bf4e3$export$d637dd7b404459cf,
    faSkype: $ef0249c5e48bf4e3$export$78370b1b91348c9e,
    faJoget: $ef0249c5e48bf4e3$export$ae307621d0877ba2,
    faFedora: $ef0249c5e48bf4e3$export$8cf9f3ca16e668b0,
    faStripeS: $ef0249c5e48bf4e3$export$4823078d958b443a,
    faMeta: $ef0249c5e48bf4e3$export$75b94550e27ccec5,
    faLaravel: $ef0249c5e48bf4e3$export$bfe42001388ccf42,
    faHotjar: $ef0249c5e48bf4e3$export$d309e8b75a17a518,
    faBluetoothB: $ef0249c5e48bf4e3$export$ad4174fe3fc4abe2,
    faStickerMule: $ef0249c5e48bf4e3$export$439612f87b462a40,
    faCreativeCommonsZero: $ef0249c5e48bf4e3$export$72df0aea6a5da9de,
    faHips: $ef0249c5e48bf4e3$export$51de6451f4c7b107,
    faBehance: $ef0249c5e48bf4e3$export$907c17a7f1d6a0d3,
    faReddit: $ef0249c5e48bf4e3$export$97dd0b04d798af1a,
    faDiscord: $ef0249c5e48bf4e3$export$c8d4525a5e9ad3ad,
    faChrome: $ef0249c5e48bf4e3$export$430df45ec2fae593,
    faAppStoreIos: $ef0249c5e48bf4e3$export$e36cec8e481a3a4b,
    faCcDiscover: $ef0249c5e48bf4e3$export$4a929e0a1abf7e41,
    faWpbeginner: $ef0249c5e48bf4e3$export$a24323c111493948,
    faConfluence: $ef0249c5e48bf4e3$export$259f76b402dd445f,
    faMdb: $ef0249c5e48bf4e3$export$7add95166ef0248a,
    faDochub: $ef0249c5e48bf4e3$export$81d728fa770edbe1,
    faAccessibleIcon: $ef0249c5e48bf4e3$export$3c152d640f62968e,
    faEbay: $ef0249c5e48bf4e3$export$ddb611ff59fc9802,
    faAmazon: $ef0249c5e48bf4e3$export$ebc1e565fd80a447,
    faUnsplash: $ef0249c5e48bf4e3$export$3997191a5880488f,
    faYarn: $ef0249c5e48bf4e3$export$a67629e1d516967d,
    faSquareSteam: $ef0249c5e48bf4e3$export$c334a5e9c1f73381,
    faSteamSquare: $ef0249c5e48bf4e3$export$b0e9b012d636da0a,
    fa500px: $ef0249c5e48bf4e3$export$4adb509bb23593b0,
    faSquareVimeo: $ef0249c5e48bf4e3$export$8974793285f35ac8,
    faVimeoSquare: $ef0249c5e48bf4e3$export$78628c2da1e685b5,
    faAsymmetrik: $ef0249c5e48bf4e3$export$50ef858a08ddd1e5,
    faFontAwesome: $ef0249c5e48bf4e3$export$aa4baaed1c60f58d,
    faFontAwesomeFlag: $ef0249c5e48bf4e3$export$102c25fde54d4843,
    faFontAwesomeLogoFull: $ef0249c5e48bf4e3$export$6e20d421a2e0f320,
    faGratipay: $ef0249c5e48bf4e3$export$cf1aa567b9609235,
    faApple: $ef0249c5e48bf4e3$export$a649d390c50fd6df,
    faHive: $ef0249c5e48bf4e3$export$f5cdac644000a430,
    faGitkraken: $ef0249c5e48bf4e3$export$cd2223c7b77bd41c,
    faKeybase: $ef0249c5e48bf4e3$export$c80d8749c6106849,
    faApplePay: $ef0249c5e48bf4e3$export$fbfbf4eeb373a6ab,
    faPadlet: $ef0249c5e48bf4e3$export$369427eba18eb826,
    faAmazonPay: $ef0249c5e48bf4e3$export$448eb0f9d8323c85,
    faSquareGithub: $ef0249c5e48bf4e3$export$be5db653ba5b5871,
    faGithubSquare: $ef0249c5e48bf4e3$export$5fe0a956971aa3c2,
    faStumbleupon: $ef0249c5e48bf4e3$export$7872bf6ac6945976,
    faFedex: $ef0249c5e48bf4e3$export$c9127779112e2ff8,
    faPhoenixFramework: $ef0249c5e48bf4e3$export$3d9357caf53f9b59,
    faShopify: $ef0249c5e48bf4e3$export$c18d8940c93637ce,
    faNeos: $ef0249c5e48bf4e3$export$a38c2efcceaf5a01,
    faSquareThreads: $ef0249c5e48bf4e3$export$75f15eb229650b3a,
    faHackerrank: $ef0249c5e48bf4e3$export$5fb7eeed7d5e4dea,
    faResearchgate: $ef0249c5e48bf4e3$export$5c5693a4f82cd9eb,
    faSwift: $ef0249c5e48bf4e3$export$dcdf312747bb3471,
    faAngular: $ef0249c5e48bf4e3$export$9df3e2a7a3f59b3b,
    faSpeakap: $ef0249c5e48bf4e3$export$90ae1a3824ece6f2,
    faAngrycreative: $ef0249c5e48bf4e3$export$a9e7bf021125ee89,
    faYCombinator: $ef0249c5e48bf4e3$export$9ee2f35ed1fe0fd4,
    faEmpire: $ef0249c5e48bf4e3$export$c966a5d80266ef06,
    faEnvira: $ef0249c5e48bf4e3$export$9e2c7c55d2fddd0,
    faSquareGitlab: $ef0249c5e48bf4e3$export$1c14974e1904bc76,
    faGitlabSquare: $ef0249c5e48bf4e3$export$4459a47a802afa29,
    faStudiovinari: $ef0249c5e48bf4e3$export$9d71d8f56add75cb,
    faPiedPiper: $ef0249c5e48bf4e3$export$13581f4cc240d7d9,
    faWordpress: $ef0249c5e48bf4e3$export$8898e76262ada01d,
    faProductHunt: $ef0249c5e48bf4e3$export$91dcff48b72c75ce,
    faFirefox: $ef0249c5e48bf4e3$export$53a067e7149deea9,
    faLinode: $ef0249c5e48bf4e3$export$fcbc58842fe8e217,
    faGoodreads: $ef0249c5e48bf4e3$export$cc058e4fd428aead,
    faSquareOdnoklassniki: $ef0249c5e48bf4e3$export$df58e66e423b11a0,
    faOdnoklassnikiSquare: $ef0249c5e48bf4e3$export$8bab3f1c73ff1d0,
    faJsfiddle: $ef0249c5e48bf4e3$export$49c67105b922997,
    faSith: $ef0249c5e48bf4e3$export$6b9a61f04a3c9eb4,
    faThemeisle: $ef0249c5e48bf4e3$export$9ce81750a9f73ac4,
    faPage4: $ef0249c5e48bf4e3$export$e504e93b36693690,
    faHashnode: $ef0249c5e48bf4e3$export$459e822cce028974,
    faReact: $ef0249c5e48bf4e3$export$e62f4d94322d112c,
    faCcPaypal: $ef0249c5e48bf4e3$export$c4a0e7e817efc4de,
    faSquarespace: $ef0249c5e48bf4e3$export$c1ba640907c93eb6,
    faCcStripe: $ef0249c5e48bf4e3$export$235ca29d6ed8f50f,
    faCreativeCommonsShare: $ef0249c5e48bf4e3$export$82bc9680d7d55560,
    faBitcoin: $ef0249c5e48bf4e3$export$7bb8936d912f16ef,
    faKeycdn: $ef0249c5e48bf4e3$export$644ebffaf375bd06,
    faOpera: $ef0249c5e48bf4e3$export$76e4000ae88923a5,
    faItchIo: $ef0249c5e48bf4e3$export$4ec4278290df08a8,
    faUmbraco: $ef0249c5e48bf4e3$export$b92d594113fd14c4,
    faGalacticSenate: $ef0249c5e48bf4e3$export$85ca259eee71d856,
    faUbuntu: $ef0249c5e48bf4e3$export$188bec0355fe7cb3,
    faDraft2digital: $ef0249c5e48bf4e3$export$89aeef49dacedf59,
    faStripe: $ef0249c5e48bf4e3$export$4124a45a674b7b36,
    faHouzz: $ef0249c5e48bf4e3$export$f5c2efa520323804,
    faGg: $ef0249c5e48bf4e3$export$5b7cd580ca5d0c32,
    faDhl: $ef0249c5e48bf4e3$export$f3f333bdcc61afcd,
    faSquarePinterest: $ef0249c5e48bf4e3$export$bfa4536fab29fa25,
    faPinterestSquare: $ef0249c5e48bf4e3$export$67aa35027cc046c7,
    faXing: $ef0249c5e48bf4e3$export$28ff226a626fb008,
    faBlackberry: $ef0249c5e48bf4e3$export$11c2ed8ca6d46555,
    faCreativeCommonsPd: $ef0249c5e48bf4e3$export$10c9e6deac1c2eeb,
    faPlaystation: $ef0249c5e48bf4e3$export$6fcce83c026197c,
    faQuinscape: $ef0249c5e48bf4e3$export$1079c541f45f51d0,
    faLess: $ef0249c5e48bf4e3$export$df0a28abd4a08bff,
    faBloggerB: $ef0249c5e48bf4e3$export$fb78f7bb43feec45,
    faOpencart: $ef0249c5e48bf4e3$export$b1b65e1549fc9915,
    faVine: $ef0249c5e48bf4e3$export$ff24f295c905f144,
    faPaypal: $ef0249c5e48bf4e3$export$1aaa7b292157aaf7,
    faGitlab: $ef0249c5e48bf4e3$export$bc1566dfb0a3651b,
    faTypo3: $ef0249c5e48bf4e3$export$26fe3ad1dc9d4c5b,
    faRedditAlien: $ef0249c5e48bf4e3$export$9fbf70587b6b0dcc,
    faYahoo: $ef0249c5e48bf4e3$export$d0632e92ebe1197f,
    faDailymotion: $ef0249c5e48bf4e3$export$9743e7788f64058a,
    faAffiliatetheme: $ef0249c5e48bf4e3$export$c40f060084205fb6,
    faPiedPiperPp: $ef0249c5e48bf4e3$export$96d17626187f6e34,
    faBootstrap: $ef0249c5e48bf4e3$export$3de8f256f5aadacf,
    faOdnoklassniki: $ef0249c5e48bf4e3$export$f31d1294fef45f,
    faNfcSymbol: $ef0249c5e48bf4e3$export$a64aa05b0287bdaf,
    faEthereum: $ef0249c5e48bf4e3$export$b5ebb163fdb5edfd,
    faSpeakerDeck: $ef0249c5e48bf4e3$export$7c461c4ee7c07c19,
    faCreativeCommonsNcEu: $ef0249c5e48bf4e3$export$bcf1858bdc40caa3,
    faPatreon: $ef0249c5e48bf4e3$export$a4dfebb823a477ff,
    faAvianex: $ef0249c5e48bf4e3$export$862396e708985a99,
    faEllo: $ef0249c5e48bf4e3$export$e644e4a8cae83fb3,
    faGofore: $ef0249c5e48bf4e3$export$380164e9d6cdbec2,
    faBimobject: $ef0249c5e48bf4e3$export$a219f36955efe01a,
    faFacebookF: $ef0249c5e48bf4e3$export$890714bb00316cc,
    faSquareGooglePlus: $ef0249c5e48bf4e3$export$e94511deb1df63ce,
    faGooglePlusSquare: $ef0249c5e48bf4e3$export$d546947149d9505a,
    faMandalorian: $ef0249c5e48bf4e3$export$2a745e3ef2838c53,
    faFirstOrderAlt: $ef0249c5e48bf4e3$export$ea0bc2cd8d60b806,
    faOsi: $ef0249c5e48bf4e3$export$89cf1df24c6f1e2,
    faGoogleWallet: $ef0249c5e48bf4e3$export$6fd7b581d1a20a14,
    faDAndDBeyond: $ef0249c5e48bf4e3$export$8ffeba28c1feff0d,
    faPeriscope: $ef0249c5e48bf4e3$export$10deb29d7dbf2418,
    faFulcrum: $ef0249c5e48bf4e3$export$beb89eeaf726c65a,
    faCloudscale: $ef0249c5e48bf4e3$export$fdf6053d73314ca6,
    faForumbee: $ef0249c5e48bf4e3$export$e4fb88a0423b6fee,
    faMizuni: $ef0249c5e48bf4e3$export$e6a3c752190fa3cb,
    faSchlix: $ef0249c5e48bf4e3$export$3f1891b85805675f,
    faSquareXing: $ef0249c5e48bf4e3$export$ca49464b0602c8ef,
    faXingSquare: $ef0249c5e48bf4e3$export$3f616d72d818a1a6,
    faBandcamp: $ef0249c5e48bf4e3$export$cf8fa465ef81d073,
    faWpforms: $ef0249c5e48bf4e3$export$f70eba4216b4419a,
    faCloudversify: $ef0249c5e48bf4e3$export$623057fac7dabd52,
    faUsps: $ef0249c5e48bf4e3$export$216644b0c66e66a5,
    faMegaport: $ef0249c5e48bf4e3$export$e7e4dbda4df6110f,
    faMagento: $ef0249c5e48bf4e3$export$9b8374b50472190d,
    faSpotify: $ef0249c5e48bf4e3$export$8218f3fbb2f89724,
    faOptinMonster: $ef0249c5e48bf4e3$export$5247a00f0c0b93a3,
    faFly: $ef0249c5e48bf4e3$export$cfbbba1261e4e2d2,
    faAviato: $ef0249c5e48bf4e3$export$f731696770842fd2,
    faItunes: $ef0249c5e48bf4e3$export$5f69a5b38e12c984,
    faCuttlefish: $ef0249c5e48bf4e3$export$883d4844d275b117,
    faBlogger: $ef0249c5e48bf4e3$export$eba2747efc67a397,
    faFlickr: $ef0249c5e48bf4e3$export$4fc2e88e3ac2b091,
    faViber: $ef0249c5e48bf4e3$export$c16cb0c14aa5beed,
    faSoundcloud: $ef0249c5e48bf4e3$export$5803ef8c86f9786d,
    faDigg: $ef0249c5e48bf4e3$export$1902312a1701467c,
    faTencentWeibo: $ef0249c5e48bf4e3$export$9ea61fa1ff3225c6,
    faSymfony: $ef0249c5e48bf4e3$export$5420457350c35845,
    faMaxcdn: $ef0249c5e48bf4e3$export$a33f03bc723e6603,
    faEtsy: $ef0249c5e48bf4e3$export$c7956780474e39de,
    faFacebookMessenger: $ef0249c5e48bf4e3$export$6c28dada3398f534,
    faAudible: $ef0249c5e48bf4e3$export$83a2d14204e40d9a,
    faThinkPeaks: $ef0249c5e48bf4e3$export$4c12ad86c5e9c2a9,
    faBilibili: $ef0249c5e48bf4e3$export$34797550194301d4,
    faErlang: $ef0249c5e48bf4e3$export$c6087bbc62da6f90,
    faXTwitter: $ef0249c5e48bf4e3$export$fd0513a3aa908a67,
    faCottonBureau: $ef0249c5e48bf4e3$export$8fc0685430a4202e,
    faDashcube: $ef0249c5e48bf4e3$export$fc2c1db4698b6c91,
    fa42Group: $ef0249c5e48bf4e3$export$a02285afcee8b3ba,
    faInnosoft: $ef0249c5e48bf4e3$export$da8db9965333c744,
    faStackExchange: $ef0249c5e48bf4e3$export$d511b4edf7fbac5a,
    faElementor: $ef0249c5e48bf4e3$export$66726053c0c0ec32,
    faSquarePiedPiper: $ef0249c5e48bf4e3$export$9d16a5780aab9cd3,
    faPiedPiperSquare: $ef0249c5e48bf4e3$export$95ddae6b65597c6e,
    faCreativeCommonsNd: $ef0249c5e48bf4e3$export$157e4276d9138bda,
    faPalfed: $ef0249c5e48bf4e3$export$a226dd96512e144,
    faSuperpowers: $ef0249c5e48bf4e3$export$349f4fc9997a1bf0,
    faResolving: $ef0249c5e48bf4e3$export$e73a6c635a57ef10,
    faXbox: $ef0249c5e48bf4e3$export$2c743c09f4269e9c,
    faSearchengin: $ef0249c5e48bf4e3$export$e72de9688042e327,
    faTiktok: $ef0249c5e48bf4e3$export$f310e79ae35a251f,
    faSquareFacebook: $ef0249c5e48bf4e3$export$8545d76ecd01ec19,
    faFacebookSquare: $ef0249c5e48bf4e3$export$cd6ab8ed6a9ec7a4,
    faRenren: $ef0249c5e48bf4e3$export$36a9439e8de2df70,
    faLinux: $ef0249c5e48bf4e3$export$5cb68a24a0b7bdf6,
    faGlide: $ef0249c5e48bf4e3$export$c4c84939b8784e10,
    faLinkedin: $ef0249c5e48bf4e3$export$b38fbe0cd1e4c67d,
    faHubspot: $ef0249c5e48bf4e3$export$418b99079caf9b9b,
    faDeploydog: $ef0249c5e48bf4e3$export$bd9dbf3c3b0bdc5e,
    faTwitch: $ef0249c5e48bf4e3$export$154857d90d308f7c,
    faRavelry: $ef0249c5e48bf4e3$export$cab2db22e59af947,
    faMixer: $ef0249c5e48bf4e3$export$83d047b1c09d253,
    faSquareLastfm: $ef0249c5e48bf4e3$export$37794c0b0ffc1e44,
    faLastfmSquare: $ef0249c5e48bf4e3$export$c2f59587d6a3a574,
    faVimeo: $ef0249c5e48bf4e3$export$b73c31bd90a3782e,
    faMendeley: $ef0249c5e48bf4e3$export$a580d86d20b50be3,
    faUniregistry: $ef0249c5e48bf4e3$export$6fb93399039178f9,
    faFigma: $ef0249c5e48bf4e3$export$e71a35e82f13ad7f,
    faCreativeCommonsRemix: $ef0249c5e48bf4e3$export$c02c848648d47b55,
    faCcAmazonPay: $ef0249c5e48bf4e3$export$3f0dada7ec074193,
    faDropbox: $ef0249c5e48bf4e3$export$e4589d83245ae1b2,
    faInstagram: $ef0249c5e48bf4e3$export$8256451a9905291a,
    faCmplid: $ef0249c5e48bf4e3$export$f4e59d0d43aeb784,
    faFacebook: $ef0249c5e48bf4e3$export$86108d0b79007794,
    faGripfire: $ef0249c5e48bf4e3$export$957b7296da5b4490,
    faJediOrder: $ef0249c5e48bf4e3$export$3a376d0f2ecfb7d0,
    faUikit: $ef0249c5e48bf4e3$export$27afc16078b5f3ac,
    faFortAwesomeAlt: $ef0249c5e48bf4e3$export$a5097e0b1bb080b7,
    faPhabricator: $ef0249c5e48bf4e3$export$cc29519275365076,
    faUssunnah: $ef0249c5e48bf4e3$export$d0ceedb643a91662,
    faEarlybirds: $ef0249c5e48bf4e3$export$c30a6352a2a5e8ea,
    faTradeFederation: $ef0249c5e48bf4e3$export$83b68077d321f3ad,
    faAutoprefixer: $ef0249c5e48bf4e3$export$2ea4e300aa12cd0a,
    faWhatsapp: $ef0249c5e48bf4e3$export$45bdf388845cdf99,
    faSlideshare: $ef0249c5e48bf4e3$export$4dcd48fd9c0bdd2d,
    faGooglePlay: $ef0249c5e48bf4e3$export$cfa707f90d6b79ec,
    faViadeo: $ef0249c5e48bf4e3$export$6f9febfcc8ac97d4,
    faLine: $ef0249c5e48bf4e3$export$c5b04bbf0f48913a,
    faGoogleDrive: $ef0249c5e48bf4e3$export$631c05505a17faa8,
    faServicestack: $ef0249c5e48bf4e3$export$c2417738aeefe7e6,
    faSimplybuilt: $ef0249c5e48bf4e3$export$8b48c2e6e01a12e0,
    faBitbucket: $ef0249c5e48bf4e3$export$de75f8fcf71dfed9,
    faImdb: $ef0249c5e48bf4e3$export$c85bcd118a7a17ff,
    faDeezer: $ef0249c5e48bf4e3$export$17ab471305a2654c,
    faRaspberryPi: $ef0249c5e48bf4e3$export$910e018904f54b08,
    faJira: $ef0249c5e48bf4e3$export$78c2aea9064d90bd,
    faDocker: $ef0249c5e48bf4e3$export$b29e4ebead927988,
    faScreenpal: $ef0249c5e48bf4e3$export$63c4c3c3c5975c3e,
    faBluetooth: $ef0249c5e48bf4e3$export$f77d9ddfdff1e2a7,
    faGitter: $ef0249c5e48bf4e3$export$56aff378d7858517,
    faDAndD: $ef0249c5e48bf4e3$export$8fb5b89b3d7583de,
    faMicroblog: $ef0249c5e48bf4e3$export$d5808a1a9747be4c,
    faCcDinersClub: $ef0249c5e48bf4e3$export$e24e559a44f492e1,
    faGgCircle: $ef0249c5e48bf4e3$export$6d2eed3a88c7ed1a,
    faPiedPiperHat: $ef0249c5e48bf4e3$export$238a02799aabf743,
    faKickstarterK: $ef0249c5e48bf4e3$export$36ebae5de28f5e9e,
    faYandex: $ef0249c5e48bf4e3$export$d51f17330f9046ea,
    faReadme: $ef0249c5e48bf4e3$export$7dcb0372cc290c0e,
    faHtml5: $ef0249c5e48bf4e3$export$d1a4948b9a07ae7c,
    faSellsy: $ef0249c5e48bf4e3$export$cb60511a0f837c82,
    faSass: $ef0249c5e48bf4e3$export$5afc94dc87b38719,
    faWirsindhandwerk: $ef0249c5e48bf4e3$export$304e26e1efc5b1a4,
    faWsh: $ef0249c5e48bf4e3$export$c6d19319c89c1ce4,
    faBuromobelexperte: $ef0249c5e48bf4e3$export$25d99c8ee7e610e5,
    faSalesforce: $ef0249c5e48bf4e3$export$fb5e089c1f25c80c,
    faOctopusDeploy: $ef0249c5e48bf4e3$export$4a726382b32e57cc,
    faMedapps: $ef0249c5e48bf4e3$export$86efffc3e85d2a9,
    faNs8: $ef0249c5e48bf4e3$export$ffa3f5d32fe6bc0e,
    faPinterestP: $ef0249c5e48bf4e3$export$e1681fe8211dd475,
    faApper: $ef0249c5e48bf4e3$export$aa79881dfcf87a16,
    faFortAwesome: $ef0249c5e48bf4e3$export$c2ee281dce8eb9d5,
    faWaze: $ef0249c5e48bf4e3$export$8d560f87da34bcc1,
    faCcJcb: $ef0249c5e48bf4e3$export$4f0eff72b7493340,
    faSnapchat: $ef0249c5e48bf4e3$export$3770724b51125ef1,
    faSnapchatGhost: $ef0249c5e48bf4e3$export$e6e855f745e10958,
    faFantasyFlightGames: $ef0249c5e48bf4e3$export$318074701514e1,
    faRust: $ef0249c5e48bf4e3$export$8a8ef141dcbeda7b,
    faWix: $ef0249c5e48bf4e3$export$423f2efa0d73b5f9,
    faSquareBehance: $ef0249c5e48bf4e3$export$3a09eb8c07c8379f,
    faBehanceSquare: $ef0249c5e48bf4e3$export$bb4b7fb598656746,
    faSupple: $ef0249c5e48bf4e3$export$9be373796460fb80,
    faRebel: $ef0249c5e48bf4e3$export$50bb8725ea3b3e34,
    faCss3: $ef0249c5e48bf4e3$export$f32e22910f9b44,
    faStaylinked: $ef0249c5e48bf4e3$export$ffbc7f79ed77f082,
    faKaggle: $ef0249c5e48bf4e3$export$a03842279a704aae,
    faSpaceAwesome: $ef0249c5e48bf4e3$export$1aecd37105f38798,
    faDeviantart: $ef0249c5e48bf4e3$export$36a61c57a904744e,
    faCpanel: $ef0249c5e48bf4e3$export$4b1cbad29e4915c6,
    faGoodreadsG: $ef0249c5e48bf4e3$export$659cd0fc2157d001,
    faSquareGit: $ef0249c5e48bf4e3$export$ccce513bbd3bef1d,
    faGitSquare: $ef0249c5e48bf4e3$export$545247d36a0c2435,
    faSquareTumblr: $ef0249c5e48bf4e3$export$b22e93e631701aa0,
    faTumblrSquare: $ef0249c5e48bf4e3$export$b3979340ece626fe,
    faTrello: $ef0249c5e48bf4e3$export$33a1efa865dd0849,
    faCreativeCommonsNcJp: $ef0249c5e48bf4e3$export$e119d42c61b568e2,
    faGetPocket: $ef0249c5e48bf4e3$export$17e9384897437d5a,
    faPerbyte: $ef0249c5e48bf4e3$export$53e7f606db333d60,
    faGrunt: $ef0249c5e48bf4e3$export$b84863db58925c09,
    faWeebly: $ef0249c5e48bf4e3$export$33e64266c9adb232,
    faConnectdevelop: $ef0249c5e48bf4e3$export$38091cf7f8c68318,
    faLeanpub: $ef0249c5e48bf4e3$export$c6c358b395e9032d,
    faBlackTie: $ef0249c5e48bf4e3$export$161a3454c1d6abdb,
    faThemeco: $ef0249c5e48bf4e3$export$ec9cce37001091c7,
    faPython: $ef0249c5e48bf4e3$export$15d5df18b87754e3,
    faAndroid: $ef0249c5e48bf4e3$export$d3988148e7ca3c41,
    faBots: $ef0249c5e48bf4e3$export$d367d9d00bf47408,
    faFreeCodeCamp: $ef0249c5e48bf4e3$export$8190ad5ab3a607e2,
    faHornbill: $ef0249c5e48bf4e3$export$906602f6a1e50bdd,
    faJs: $ef0249c5e48bf4e3$export$530d32089c3347d5,
    faIdeal: $ef0249c5e48bf4e3$export$4ee0aea9bb537f01,
    faGit: $ef0249c5e48bf4e3$export$61f81190d1a8b4b,
    faDev: $ef0249c5e48bf4e3$export$dad56877d4f4a953,
    faSketch: $ef0249c5e48bf4e3$export$e999ee7aa7883e37,
    faYandexInternational: $ef0249c5e48bf4e3$export$6bf616a61d0b7bf3,
    faCcAmex: $ef0249c5e48bf4e3$export$2bcb24672b4bf6e6,
    faUber: $ef0249c5e48bf4e3$export$2b557426f8d6820b,
    faGithub: $ef0249c5e48bf4e3$export$64e4bc4b496fbbdf,
    faPhp: $ef0249c5e48bf4e3$export$e1ae2a8de48825fb,
    faAlipay: $ef0249c5e48bf4e3$export$994c329bc073af57,
    faYoutube: $ef0249c5e48bf4e3$export$2373b132177332f8,
    faSkyatlas: $ef0249c5e48bf4e3$export$b2254aecfa43ac3e,
    faFirefoxBrowser: $ef0249c5e48bf4e3$export$db16178b6453c842,
    faReplyd: $ef0249c5e48bf4e3$export$a51c205a2c2f1780,
    faSuse: $ef0249c5e48bf4e3$export$fd2c25240484ff41,
    faJenkins: $ef0249c5e48bf4e3$export$595f8e07121dc03e,
    faTwitter: $ef0249c5e48bf4e3$export$ca61170983a00686,
    faRockrms: $ef0249c5e48bf4e3$export$b86b24e51d58f6b5,
    faPinterest: $ef0249c5e48bf4e3$export$d42c613d35559431,
    faBuffer: $ef0249c5e48bf4e3$export$de04abdf8e0bcc15,
    faNpm: $ef0249c5e48bf4e3$export$2002216d2d7747f0,
    faYammer: $ef0249c5e48bf4e3$export$a5122f6c6ec2779c,
    faBtc: $ef0249c5e48bf4e3$export$fcf54005da871608,
    faDribbble: $ef0249c5e48bf4e3$export$657a51e82ea8ac80,
    faStumbleuponCircle: $ef0249c5e48bf4e3$export$ef143c65b9462290,
    faInternetExplorer: $ef0249c5e48bf4e3$export$26bd7ea5833d2643,
    faStubber: $ef0249c5e48bf4e3$export$28d0d3c268c6e8c2,
    faTelegram: $ef0249c5e48bf4e3$export$b508fd54409de914,
    faTelegramPlane: $ef0249c5e48bf4e3$export$dd32dc1ad06228ec,
    faOldRepublic: $ef0249c5e48bf4e3$export$39ef7a19d18012df,
    faOdysee: $ef0249c5e48bf4e3$export$4001fe5db20c0fd2,
    faSquareWhatsapp: $ef0249c5e48bf4e3$export$ee0c07b824da892f,
    faWhatsappSquare: $ef0249c5e48bf4e3$export$6fd1d044d66a938d,
    faNodeJs: $ef0249c5e48bf4e3$export$ad65a356f9456393,
    faEdgeLegacy: $ef0249c5e48bf4e3$export$68bace18bdcdfc53,
    faSlack: $ef0249c5e48bf4e3$export$c597531345e00f14,
    faSlackHash: $ef0249c5e48bf4e3$export$46ef626e3b64d22,
    faMedrt: $ef0249c5e48bf4e3$export$2d7cd04bce6afc11,
    faUsb: $ef0249c5e48bf4e3$export$701b05aa394c8392,
    faTumblr: $ef0249c5e48bf4e3$export$ae279e8a7a5b9476,
    faVaadin: $ef0249c5e48bf4e3$export$f796d2c05c7c6dbd,
    faQuora: $ef0249c5e48bf4e3$export$e9b10b4b8b90dca5,
    faSquareXTwitter: $ef0249c5e48bf4e3$export$e42e88e46d22eb98,
    faReacteurope: $ef0249c5e48bf4e3$export$1bc30ca2ce539d7f,
    faMedium: $ef0249c5e48bf4e3$export$c1f031b95dadaa21,
    faMediumM: $ef0249c5e48bf4e3$export$a29b11db7eed2052,
    faAmilia: $ef0249c5e48bf4e3$export$2ffb27c42275836a,
    faMixcloud: $ef0249c5e48bf4e3$export$642f133169ca9ebe,
    faFlipboard: $ef0249c5e48bf4e3$export$5193bd9feb923609,
    faViacoin: $ef0249c5e48bf4e3$export$e75485903cf50ab7,
    faCriticalRole: $ef0249c5e48bf4e3$export$19d8e57a729f8d94,
    faSitrox: $ef0249c5e48bf4e3$export$b431c4dc6e2095fc,
    faDiscourse: $ef0249c5e48bf4e3$export$5311546a7fb29bad,
    faJoomla: $ef0249c5e48bf4e3$export$4c7981055454786f,
    faMastodon: $ef0249c5e48bf4e3$export$1dd6c03244d1cf01,
    faAirbnb: $ef0249c5e48bf4e3$export$a8bcb0976aa786fb,
    faWolfPackBattalion: $ef0249c5e48bf4e3$export$568095dca08f5ff3,
    faBuyNLarge: $ef0249c5e48bf4e3$export$e08e0c43c651f28e,
    faGulp: $ef0249c5e48bf4e3$export$100b84dda223030b,
    faCreativeCommonsSamplingPlus: $ef0249c5e48bf4e3$export$f7edf083e5c27672,
    faStrava: $ef0249c5e48bf4e3$export$7ea49f2cb08b52c1,
    faEmber: $ef0249c5e48bf4e3$export$c09ea58a6f21cb3c,
    faCanadianMapleLeaf: $ef0249c5e48bf4e3$export$c9a287a4ab49306f,
    faTeamspeak: $ef0249c5e48bf4e3$export$619d787387e2c15e,
    faPushed: $ef0249c5e48bf4e3$export$72c88c198f2680b,
    faWordpressSimple: $ef0249c5e48bf4e3$export$1e35be7b9c7acc1f,
    faNutritionix: $ef0249c5e48bf4e3$export$cb3944b58accd310,
    faWodu: $ef0249c5e48bf4e3$export$d30ca94800bf542b,
    faGooglePay: $ef0249c5e48bf4e3$export$6d89c09f17c54b19,
    faIntercom: $ef0249c5e48bf4e3$export$fd8d76c5b86b3d2b,
    faZhihu: $ef0249c5e48bf4e3$export$16e69e0d77404518,
    faKorvue: $ef0249c5e48bf4e3$export$80de216c9d46bac,
    faPix: $ef0249c5e48bf4e3$export$4fe14f0ab3be9a3,
    faSteamSymbol: $ef0249c5e48bf4e3$export$c2ce1e5693cbcd01
};


var $d8206b3ab2e65c05$export$82e9f45cca5ba907 = "fas";
var $d8206b3ab2e65c05$export$f22454595d96c106 = {
    prefix: "fas",
    iconName: "0",
    icon: [
        320,
        512,
        [],
        "30",
        "M0 192C0 103.6 71.6 32 160 32s160 71.6 160 160V320c0 88.4-71.6 160-160 160S0 408.4 0 320V192zM160 96c-53 0-96 43-96 96V320c0 53 43 96 96 96s96-43 96-96V192c0-53-43-96-96-96z"
    ]
};
var $d8206b3ab2e65c05$export$8398cb2addc9e182 = {
    prefix: "fas",
    iconName: "1",
    icon: [
        256,
        512,
        [],
        "31",
        "M160 64c0-11.8-6.5-22.6-16.9-28.2s-23-5-32.8 1.6l-96 64C-.5 111.2-4.4 131 5.4 145.8s29.7 18.7 44.4 8.9L96 123.8V416H32c-17.7 0-32 14.3-32 32s14.3 32 32 32h96 96c17.7 0 32-14.3 32-32s-14.3-32-32-32H160V64z"
    ]
};
var $d8206b3ab2e65c05$export$ed1a0ff7bd680a1d = {
    prefix: "fas",
    iconName: "2",
    icon: [
        320,
        512,
        [],
        "32",
        "M142.9 96c-21.5 0-42.2 8.5-57.4 23.8L54.6 150.6c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3L40.2 74.5C67.5 47.3 104.4 32 142.9 32C223 32 288 97 288 177.1c0 38.5-15.3 75.4-42.5 102.6L109.3 416H288c17.7 0 32 14.3 32 32s-14.3 32-32 32H32c-12.9 0-24.6-7.8-29.6-19.8s-2.2-25.7 6.9-34.9L200.2 234.5c15.2-15.2 23.8-35.9 23.8-57.4c0-44.8-36.3-81.1-81.1-81.1z"
    ]
};
var $d8206b3ab2e65c05$export$74b7ff79ce1818d6 = {
    prefix: "fas",
    iconName: "3",
    icon: [
        320,
        512,
        [],
        "33",
        "M0 64C0 46.3 14.3 32 32 32H272c13.2 0 25 8.1 29.8 20.4s1.5 26.3-8.2 35.2L162.3 208H184c75.1 0 136 60.9 136 136s-60.9 136-136 136H105.4C63 480 24.2 456 5.3 418.1l-1.9-3.8c-7.9-15.8-1.5-35 14.3-42.9s35-1.5 42.9 14.3l1.9 3.8c8.1 16.3 24.8 26.5 42.9 26.5H184c39.8 0 72-32.2 72-72s-32.2-72-72-72H80c-13.2 0-25-8.1-29.8-20.4s-1.5-26.3 8.2-35.2L189.7 96H32C14.3 96 0 81.7 0 64z"
    ]
};
var $d8206b3ab2e65c05$export$969b2215780d58fd = {
    prefix: "fas",
    iconName: "4",
    icon: [
        384,
        512,
        [],
        "34",
        "M189 77.6c7.5-16 .7-35.1-15.3-42.6s-35.1-.7-42.6 15.3L3 322.4c-4.7 9.9-3.9 21.5 1.9 30.8S21 368 32 368H256v80c0 17.7 14.3 32 32 32s32-14.3 32-32V368h32c17.7 0 32-14.3 32-32s-14.3-32-32-32H320V160c0-17.7-14.3-32-32-32s-32 14.3-32 32V304H82.4L189 77.6z"
    ]
};
var $d8206b3ab2e65c05$export$3919f68a5b3825a9 = {
    prefix: "fas",
    iconName: "5",
    icon: [
        320,
        512,
        [],
        "35",
        "M32.5 58.3C35.3 43.1 48.5 32 64 32H256c17.7 0 32 14.3 32 32s-14.3 32-32 32H90.7L70.3 208H184c75.1 0 136 60.9 136 136s-60.9 136-136 136H100.5c-39.4 0-75.4-22.3-93-57.5l-4.1-8.2c-7.9-15.8-1.5-35 14.3-42.9s35-1.5 42.9 14.3l4.1 8.2c6.8 13.6 20.6 22.1 35.8 22.1H184c39.8 0 72-32.2 72-72s-32.2-72-72-72H32c-9.5 0-18.5-4.2-24.6-11.5s-8.6-16.9-6.9-26.2l32-176z"
    ]
};
var $d8206b3ab2e65c05$export$580ac17b31ffb5c3 = {
    prefix: "fas",
    iconName: "6",
    icon: [
        320,
        512,
        [],
        "36",
        "M232.4 84.7c11.4-13.5 9.7-33.7-3.8-45.1s-33.7-9.7-45.1 3.8L38.6 214.7C14.7 242.9 1.1 278.4 .1 315.2c0 1.4-.1 2.9-.1 4.3c0 .2 0 .3 0 .5c0 88.4 71.6 160 160 160s160-71.6 160-160c0-85.5-67.1-155.4-151.5-159.8l63.9-75.6zM256 320A96 96 0 1 1 64 320a96 96 0 1 1 192 0z"
    ]
};
var $d8206b3ab2e65c05$export$ee79cab31be16d23 = {
    prefix: "fas",
    iconName: "7",
    icon: [
        320,
        512,
        [],
        "37",
        "M0 64C0 46.3 14.3 32 32 32H288c11.5 0 22 6.1 27.7 16.1s5.7 22.2-.1 32.1l-224 384c-8.9 15.3-28.5 20.4-43.8 11.5s-20.4-28.5-11.5-43.8L232.3 96H32C14.3 96 0 81.7 0 64z"
    ]
};
var $d8206b3ab2e65c05$export$45d84c4b2c560d2f = {
    prefix: "fas",
    iconName: "8",
    icon: [
        320,
        512,
        [],
        "38",
        "M304 160c0-70.7-57.3-128-128-128H144C73.3 32 16 89.3 16 160c0 34.6 13.7 66 36 89C20.5 272.3 0 309.8 0 352c0 70.7 57.3 128 128 128h64c70.7 0 128-57.3 128-128c0-42.2-20.5-79.7-52-103c22.3-23 36-54.4 36-89zM176.1 288H192c35.3 0 64 28.7 64 64s-28.7 64-64 64H128c-35.3 0-64-28.7-64-64s28.7-64 64-64h15.9c0 0 .1 0 .1 0h32c0 0 .1 0 .1 0zm0-64c0 0 0 0 0 0H144c0 0 0 0 0 0c-35.3 0-64-28.7-64-64c0-35.3 28.7-64 64-64h32c35.3 0 64 28.7 64 64c0 35.3-28.6 64-64 64z"
    ]
};
var $d8206b3ab2e65c05$export$a120f1e4223629f2 = {
    prefix: "fas",
    iconName: "9",
    icon: [
        320,
        512,
        [],
        "39",
        "M64 192a96 96 0 1 0 192 0A96 96 0 1 0 64 192zm87.5 159.8C67.1 347.4 0 277.5 0 192C0 103.6 71.6 32 160 32s160 71.6 160 160c0 2.6-.1 5.3-.2 7.9c-1.7 35.7-15.2 70-38.4 97.4l-145 171.4c-11.4 13.5-31.6 15.2-45.1 3.8s-15.2-31.6-3.8-45.1l63.9-75.6z"
    ]
};
var $d8206b3ab2e65c05$export$38320138fc0262d0 = {
    prefix: "fas",
    iconName: "fill-drip",
    icon: [
        576,
        512,
        [],
        "f576",
        "M41.4 9.4C53.9-3.1 74.1-3.1 86.6 9.4L168 90.7l53.1-53.1c28.1-28.1 73.7-28.1 101.8 0L474.3 189.1c28.1 28.1 28.1 73.7 0 101.8L283.9 481.4c-37.5 37.5-98.3 37.5-135.8 0L30.6 363.9c-37.5-37.5-37.5-98.3 0-135.8L122.7 136 41.4 54.6c-12.5-12.5-12.5-32.8 0-45.3zm176 221.3L168 181.3 75.9 273.4c-4.2 4.2-7 9.3-8.4 14.6H386.7l42.3-42.3c3.1-3.1 3.1-8.2 0-11.3L277.7 82.9c-3.1-3.1-8.2-3.1-11.3 0L213.3 136l49.4 49.4c12.5 12.5 12.5 32.8 0 45.3s-32.8 12.5-45.3 0zM512 512c-35.3 0-64-28.7-64-64c0-25.2 32.6-79.6 51.2-108.7c6-9.4 19.5-9.4 25.5 0C543.4 368.4 576 422.8 576 448c0 35.3-28.7 64-64 64z"
    ]
};
var $d8206b3ab2e65c05$export$917a3d30f6cd766 = {
    prefix: "fas",
    iconName: "arrows-to-circle",
    icon: [
        640,
        512,
        [],
        "e4bd",
        "M9.4 9.4C21.9-3.1 42.1-3.1 54.6 9.4L160 114.7V96c0-17.7 14.3-32 32-32s32 14.3 32 32v96c0 4.3-.9 8.5-2.4 12.2c-1.6 3.7-3.8 7.3-6.9 10.3l-.1 .1c-3.1 3-6.6 5.3-10.3 6.9c-3.8 1.6-7.9 2.4-12.2 2.4H96c-17.7 0-32-14.3-32-32s14.3-32 32-32h18.7L9.4 54.6C-3.1 42.1-3.1 21.9 9.4 9.4zM256 256a64 64 0 1 1 128 0 64 64 0 1 1 -128 0zM114.7 352H96c-17.7 0-32-14.3-32-32s14.3-32 32-32h96 0l.1 0c8.8 0 16.7 3.6 22.5 9.3l.1 .1c3 3.1 5.3 6.6 6.9 10.3c1.6 3.8 2.4 7.9 2.4 12.2v96c0 17.7-14.3 32-32 32s-32-14.3-32-32V397.3L54.6 502.6c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3L114.7 352zM416 96c0-17.7 14.3-32 32-32s32 14.3 32 32v18.7L585.4 9.4c12.5-12.5 32.8-12.5 45.3 0s12.5 32.8 0 45.3L525.3 160H544c17.7 0 32 14.3 32 32s-14.3 32-32 32H448c-8.8 0-16.8-3.6-22.6-9.3l-.1-.1c-3-3.1-5.3-6.6-6.9-10.3s-2.4-7.8-2.4-12.2l0-.1v0V96zM525.3 352L630.6 457.4c12.5 12.5 12.5 32.8 0 45.3s-32.8 12.5-45.3 0L480 397.3V416c0 17.7-14.3 32-32 32s-32-14.3-32-32V320v0c0 0 0-.1 0-.1c0-4.3 .9-8.4 2.4-12.2c1.6-3.8 3.9-7.3 6.9-10.4c5.8-5.8 13.7-9.3 22.5-9.4c0 0 .1 0 .1 0h0 96c17.7 0 32 14.3 32 32s-14.3 32-32 32H525.3z"
    ]
};
var $d8206b3ab2e65c05$export$a39bab13d51abfd0 = {
    prefix: "fas",
    iconName: "circle-chevron-right",
    icon: [
        512,
        512,
        [
            "chevron-circle-right"
        ],
        "f138",
        "M0 256a256 256 0 1 0 512 0A256 256 0 1 0 0 256zM241 377c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l87-87-87-87c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0L345 239c9.4 9.4 9.4 24.6 0 33.9L241 377z"
    ]
};
var $d8206b3ab2e65c05$export$2a5db4f6eba6f2b = $d8206b3ab2e65c05$export$a39bab13d51abfd0;
var $d8206b3ab2e65c05$export$c115e8063ee02632 = {
    prefix: "fas",
    iconName: "at",
    icon: [
        512,
        512,
        [
            61946
        ],
        "40",
        "M256 64C150 64 64 150 64 256s86 192 192 192c17.7 0 32 14.3 32 32s-14.3 32-32 32C114.6 512 0 397.4 0 256S114.6 0 256 0S512 114.6 512 256v32c0 53-43 96-96 96c-29.3 0-55.6-13.2-73.2-33.9C320 371.1 289.5 384 256 384c-70.7 0-128-57.3-128-128s57.3-128 128-128c27.9 0 53.7 8.9 74.7 24.1c5.7-5 13.1-8.1 21.3-8.1c17.7 0 32 14.3 32 32v80 32c0 17.7 14.3 32 32 32s32-14.3 32-32V256c0-106-86-192-192-192zm64 192a64 64 0 1 0 -128 0 64 64 0 1 0 128 0z"
    ]
};
var $d8206b3ab2e65c05$export$864bb8d6c21fb792 = {
    prefix: "fas",
    iconName: "trash-can",
    icon: [
        448,
        512,
        [
            61460,
            "trash-alt"
        ],
        "f2ed",
        "M135.2 17.7C140.6 6.8 151.7 0 163.8 0H284.2c12.1 0 23.2 6.8 28.6 17.7L320 32h96c17.7 0 32 14.3 32 32s-14.3 32-32 32H32C14.3 96 0 81.7 0 64S14.3 32 32 32h96l7.2-14.3zM32 128H416V448c0 35.3-28.7 64-64 64H96c-35.3 0-64-28.7-64-64V128zm96 64c-8.8 0-16 7.2-16 16V432c0 8.8 7.2 16 16 16s16-7.2 16-16V208c0-8.8-7.2-16-16-16zm96 0c-8.8 0-16 7.2-16 16V432c0 8.8 7.2 16 16 16s16-7.2 16-16V208c0-8.8-7.2-16-16-16zm96 0c-8.8 0-16 7.2-16 16V432c0 8.8 7.2 16 16 16s16-7.2 16-16V208c0-8.8-7.2-16-16-16z"
    ]
};
var $d8206b3ab2e65c05$export$88df7ff7eb32f9dc = $d8206b3ab2e65c05$export$864bb8d6c21fb792;
var $d8206b3ab2e65c05$export$3313bce3924ea7da = {
    prefix: "fas",
    iconName: "text-height",
    icon: [
        576,
        512,
        [],
        "f034",
        "M64 128V96h64l0 320H96c-17.7 0-32 14.3-32 32s14.3 32 32 32H224c17.7 0 32-14.3 32-32s-14.3-32-32-32H192l0-320h64v32c0 17.7 14.3 32 32 32s32-14.3 32-32V80c0-26.5-21.5-48-48-48H160 48C21.5 32 0 53.5 0 80v48c0 17.7 14.3 32 32 32s32-14.3 32-32zM502.6 41.4c-12.5-12.5-32.8-12.5-45.3 0l-64 64c-9.2 9.2-11.9 22.9-6.9 34.9s16.6 19.8 29.6 19.8h32V352H416c-12.9 0-24.6 7.8-29.6 19.8s-2.2 25.7 6.9 34.9l64 64c12.5 12.5 32.8 12.5 45.3 0l64-64c9.2-9.2 11.9-22.9 6.9-34.9s-16.6-19.8-29.6-19.8H512V160h32c12.9 0 24.6-7.8 29.6-19.8s2.2-25.7-6.9-34.9l-64-64z"
    ]
};
var $d8206b3ab2e65c05$export$e585697127cda27 = {
    prefix: "fas",
    iconName: "user-xmark",
    icon: [
        640,
        512,
        [
            "user-times"
        ],
        "f235",
        "M96 128a128 128 0 1 1 256 0A128 128 0 1 1 96 128zM0 482.3C0 383.8 79.8 304 178.3 304h91.4C368.2 304 448 383.8 448 482.3c0 16.4-13.3 29.7-29.7 29.7H29.7C13.3 512 0 498.7 0 482.3zM471 143c9.4-9.4 24.6-9.4 33.9 0l47 47 47-47c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9l-47 47 47 47c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0l-47-47-47 47c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l47-47-47-47c-9.4-9.4-9.4-24.6 0-33.9z"
    ]
};
var $d8206b3ab2e65c05$export$45b996d071667753 = $d8206b3ab2e65c05$export$e585697127cda27;
var $d8206b3ab2e65c05$export$acb2d72d28cd92d9 = {
    prefix: "fas",
    iconName: "stethoscope",
    icon: [
        576,
        512,
        [
            129658
        ],
        "f0f1",
        "M142.4 21.9c5.6 16.8-3.5 34.9-20.2 40.5L96 71.1V192c0 53 43 96 96 96s96-43 96-96V71.1l-26.1-8.7c-16.8-5.6-25.8-23.7-20.2-40.5s23.7-25.8 40.5-20.2l26.1 8.7C334.4 19.1 352 43.5 352 71.1V192c0 77.2-54.6 141.6-127.3 156.7C231 404.6 278.4 448 336 448c61.9 0 112-50.1 112-112V265.3c-28.3-12.3-48-40.5-48-73.3c0-44.2 35.8-80 80-80s80 35.8 80 80c0 32.8-19.7 61-48 73.3V336c0 97.2-78.8 176-176 176c-92.9 0-168.9-71.9-175.5-163.1C87.2 334.2 32 269.6 32 192V71.1c0-27.5 17.6-52 43.8-60.7l26.1-8.7c16.8-5.6 34.9 3.5 40.5 20.2zM480 224a32 32 0 1 0 0-64 32 32 0 1 0 0 64z"
    ]
};
var $d8206b3ab2e65c05$export$6563a67224e7f879 = {
    prefix: "fas",
    iconName: "message",
    icon: [
        512,
        512,
        [
            "comment-alt"
        ],
        "f27a",
        "M64 0C28.7 0 0 28.7 0 64V352c0 35.3 28.7 64 64 64h96v80c0 6.1 3.4 11.6 8.8 14.3s11.9 2.1 16.8-1.5L309.3 416H448c35.3 0 64-28.7 64-64V64c0-35.3-28.7-64-64-64H64z"
    ]
};
var $d8206b3ab2e65c05$export$6e96904d9af0ec4a = $d8206b3ab2e65c05$export$6563a67224e7f879;
var $d8206b3ab2e65c05$export$d469b770895f47ac = {
    prefix: "fas",
    iconName: "info",
    icon: [
        192,
        512,
        [],
        "f129",
        "M48 80a48 48 0 1 1 96 0A48 48 0 1 1 48 80zM0 224c0-17.7 14.3-32 32-32H96c17.7 0 32 14.3 32 32V448h32c17.7 0 32 14.3 32 32s-14.3 32-32 32H32c-17.7 0-32-14.3-32-32s14.3-32 32-32H64V256H32c-17.7 0-32-14.3-32-32z"
    ]
};
var $d8206b3ab2e65c05$export$d56736f5800b3f0d = {
    prefix: "fas",
    iconName: "down-left-and-up-right-to-center",
    icon: [
        512,
        512,
        [
            "compress-alt"
        ],
        "f422",
        "M439 7c9.4-9.4 24.6-9.4 33.9 0l32 32c9.4 9.4 9.4 24.6 0 33.9l-87 87 39 39c6.9 6.9 8.9 17.2 5.2 26.2s-12.5 14.8-22.2 14.8H296c-13.3 0-24-10.7-24-24V72c0-9.7 5.8-18.5 14.8-22.2s19.3-1.7 26.2 5.2l39 39L439 7zM72 272H216c13.3 0 24 10.7 24 24V440c0 9.7-5.8 18.5-14.8 22.2s-19.3 1.7-26.2-5.2l-39-39L73 505c-9.4 9.4-24.6 9.4-33.9 0L7 473c-9.4-9.4-9.4-24.6 0-33.9l87-87L55 313c-6.9-6.9-8.9-17.2-5.2-26.2s12.5-14.8 22.2-14.8z"
    ]
};
var $d8206b3ab2e65c05$export$a05650ebe54bede = $d8206b3ab2e65c05$export$d56736f5800b3f0d;
var $d8206b3ab2e65c05$export$36b5fbeae4855055 = {
    prefix: "fas",
    iconName: "explosion",
    icon: [
        576,
        512,
        [],
        "e4e9",
        "M499.6 11.3c6.7-10.7 20.5-14.5 31.7-8.5s15.8 19.5 10.6 31L404.8 338.6c2.2 2.3 4.3 4.7 6.3 7.1l97.2-54.7c10.5-5.9 23.6-3.1 30.9 6.4s6.3 23-2.2 31.5l-87 87H378.5c-13.2-37.3-48.7-64-90.5-64s-77.4 26.7-90.5 64H117.8L42.3 363.7c-9.7-6.7-13.1-19.6-7.9-30.3s17.4-15.9 28.7-12.4l97.2 30.4c3-3.9 6.1-7.7 9.4-11.3L107.4 236.3c-6.1-10.1-3.9-23.1 5.1-30.7s22.2-7.5 31.1 .1L246 293.6c1.5-.4 3-.8 4.5-1.1l13.6-142.7c1.2-12.3 11.5-21.7 23.9-21.7s22.7 9.4 23.9 21.7l13.5 141.9L499.6 11.3zM64 448v0H512v0h32c17.7 0 32 14.3 32 32s-14.3 32-32 32H32c-17.7 0-32-14.3-32-32s14.3-32 32-32H64zM288 0c13.3 0 24 10.7 24 24V72c0 13.3-10.7 24-24 24s-24-10.7-24-24V24c0-13.3 10.7-24 24-24z"
    ]
};
var $d8206b3ab2e65c05$export$ef565d07efe2b5e9 = {
    prefix: "fas",
    iconName: "file-lines",
    icon: [
        384,
        512,
        [
            128441,
            128462,
            61686,
            "file-alt",
            "file-text"
        ],
        "f15c",
        "M64 0C28.7 0 0 28.7 0 64V448c0 35.3 28.7 64 64 64H320c35.3 0 64-28.7 64-64V160H256c-17.7 0-32-14.3-32-32V0H64zM256 0V128H384L256 0zM112 256H272c8.8 0 16 7.2 16 16s-7.2 16-16 16H112c-8.8 0-16-7.2-16-16s7.2-16 16-16zm0 64H272c8.8 0 16 7.2 16 16s-7.2 16-16 16H112c-8.8 0-16-7.2-16-16s7.2-16 16-16zm0 64H272c8.8 0 16 7.2 16 16s-7.2 16-16 16H112c-8.8 0-16-7.2-16-16s7.2-16 16-16z"
    ]
};
var $d8206b3ab2e65c05$export$243b47dca32bf0b8 = $d8206b3ab2e65c05$export$ef565d07efe2b5e9;
var $d8206b3ab2e65c05$export$f466100bf9bf37a5 = $d8206b3ab2e65c05$export$ef565d07efe2b5e9;
var $d8206b3ab2e65c05$export$c38cf504b3bc58a2 = {
    prefix: "fas",
    iconName: "wave-square",
    icon: [
        640,
        512,
        [],
        "f83e",
        "M128 64c0-17.7 14.3-32 32-32H320c17.7 0 32 14.3 32 32V416h96V256c0-17.7 14.3-32 32-32H608c17.7 0 32 14.3 32 32s-14.3 32-32 32H512V448c0 17.7-14.3 32-32 32H320c-17.7 0-32-14.3-32-32V96H192V256c0 17.7-14.3 32-32 32H32c-17.7 0-32-14.3-32-32s14.3-32 32-32h96V64z"
    ]
};
var $d8206b3ab2e65c05$export$a95486586631edc7 = {
    prefix: "fas",
    iconName: "ring",
    icon: [
        512,
        512,
        [],
        "f70b",
        "M64 208c0 7.8 4.4 18.7 17.1 30.3C126.5 214.1 188.9 200 256 200s129.5 14.1 174.9 38.3C443.6 226.7 448 215.8 448 208c0-12.3-10.8-32-47.9-50.6C364.9 139.8 314 128 256 128s-108.9 11.8-144.1 29.4C74.8 176 64 195.7 64 208zm192 40c-47 0-89.3 7.6-122.9 19.7C166.3 280.2 208.8 288 256 288s89.7-7.8 122.9-20.3C345.3 255.6 303 248 256 248zM0 208c0-49.6 39.4-85.8 83.3-107.8C129.1 77.3 190.3 64 256 64s126.9 13.3 172.7 36.2c43.9 22 83.3 58.2 83.3 107.8v96c0 49.6-39.4 85.8-83.3 107.8C382.9 434.7 321.7 448 256 448s-126.9-13.3-172.7-36.2C39.4 389.8 0 353.6 0 304V208z"
    ]
};
var $d8206b3ab2e65c05$export$fbbc7601eb465ac7 = {
    prefix: "fas",
    iconName: "building-un",
    icon: [
        384,
        512,
        [],
        "e4d9",
        "M48 0C21.5 0 0 21.5 0 48V464c0 26.5 21.5 48 48 48h96V432c0-26.5 21.5-48 48-48s48 21.5 48 48v80h96c26.5 0 48-21.5 48-48V48c0-26.5-21.5-48-48-48H48zM64 240c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H80c-8.8 0-16-7.2-16-16V240zm112-16h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H176c-8.8 0-16-7.2-16-16V240c0-8.8 7.2-16 16-16zm80 16c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H272c-8.8 0-16-7.2-16-16V240zM237.3 71.1l34.7 52V80c0-8.8 7.2-16 16-16s16 7.2 16 16v96c0 7.1-4.6 13.3-11.4 15.3s-14-.6-17.9-6.4l-34.7-52V176c0 8.8-7.2 16-16 16s-16-7.2-16-16V80c0-7.1 4.6-13.3 11.4-15.3s14 .6 17.9 6.4zM112 80v64c0 8.8 7.2 16 16 16s16-7.2 16-16V80c0-8.8 7.2-16 16-16s16 7.2 16 16v64c0 26.5-21.5 48-48 48s-48-21.5-48-48V80c0-8.8 7.2-16 16-16s16 7.2 16 16z"
    ]
};
var $d8206b3ab2e65c05$export$221059e0d5fd8958 = {
    prefix: "fas",
    iconName: "dice-three",
    icon: [
        448,
        512,
        [
            9858
        ],
        "f527",
        "M64 32C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64zm64 96a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm64 128a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm128 64a32 32 0 1 1 0 64 32 32 0 1 1 0-64z"
    ]
};
var $d8206b3ab2e65c05$export$31c6cf6f5d38dc0 = {
    prefix: "fas",
    iconName: "calendar-days",
    icon: [
        448,
        512,
        [
            "calendar-alt"
        ],
        "f073",
        "M128 0c17.7 0 32 14.3 32 32V64H288V32c0-17.7 14.3-32 32-32s32 14.3 32 32V64h48c26.5 0 48 21.5 48 48v48H0V112C0 85.5 21.5 64 48 64H96V32c0-17.7 14.3-32 32-32zM0 192H448V464c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V192zm64 80v32c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V272c0-8.8-7.2-16-16-16H80c-8.8 0-16 7.2-16 16zm128 0v32c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V272c0-8.8-7.2-16-16-16H208c-8.8 0-16 7.2-16 16zm144-16c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V272c0-8.8-7.2-16-16-16H336zM64 400v32c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V400c0-8.8-7.2-16-16-16H80c-8.8 0-16 7.2-16 16zm144-16c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V400c0-8.8-7.2-16-16-16H208zm112 16v32c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V400c0-8.8-7.2-16-16-16H336c-8.8 0-16 7.2-16 16z"
    ]
};
var $d8206b3ab2e65c05$export$cbc139f33cff356 = $d8206b3ab2e65c05$export$31c6cf6f5d38dc0;
var $d8206b3ab2e65c05$export$8bce49e6ae597af8 = {
    prefix: "fas",
    iconName: "anchor-circle-check",
    icon: [
        640,
        512,
        [],
        "e4aa",
        "M320 96a32 32 0 1 1 -64 0 32 32 0 1 1 64 0zm21.1 80C367 158.8 384 129.4 384 96c0-53-43-96-96-96s-96 43-96 96c0 33.4 17 62.8 42.9 80H224c-17.7 0-32 14.3-32 32s14.3 32 32 32h32V448H208c-53 0-96-43-96-96v-6.1l7 7c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9L97 263c-9.4-9.4-24.6-9.4-33.9 0L7 319c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l7-7V352c0 88.4 71.6 160 160 160h80 80c8.2 0 16.3-.6 24.2-1.8c-22.2-16.2-40.4-37.5-53-62.2H320V368 240h32c17.7 0 32-14.3 32-32s-14.3-32-32-32H341.1zM640 368a144 144 0 1 0 -288 0 144 144 0 1 0 288 0zm-76.7-43.3c6.2 6.2 6.2 16.4 0 22.6l-72 72c-6.2 6.2-16.4 6.2-22.6 0l-40-40c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0L480 385.4l60.7-60.7c6.2-6.2 16.4-6.2 22.6 0z"
    ]
};
var $d8206b3ab2e65c05$export$37584b1a5e175b47 = {
    prefix: "fas",
    iconName: "building-circle-arrow-right",
    icon: [
        640,
        512,
        [],
        "e4d1",
        "M0 48C0 21.5 21.5 0 48 0H336c26.5 0 48 21.5 48 48V232.2c-39.1 32.3-64 81.1-64 135.8c0 49.5 20.4 94.2 53.3 126.2C364.5 505.1 351.1 512 336 512H240V432c0-26.5-21.5-48-48-48s-48 21.5-48 48v80H48c-26.5 0-48-21.5-48-48V48zM80 224c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V240c0-8.8-7.2-16-16-16H80zm80 16v32c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V240c0-8.8-7.2-16-16-16H176c-8.8 0-16 7.2-16 16zm112-16c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V240c0-8.8-7.2-16-16-16H272zM64 112v32c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V112c0-8.8-7.2-16-16-16H80c-8.8 0-16 7.2-16 16zM176 96c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V112c0-8.8-7.2-16-16-16H176zm80 16v32c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V112c0-8.8-7.2-16-16-16H272c-8.8 0-16 7.2-16 16zm96 256a144 144 0 1 1 288 0 144 144 0 1 1 -288 0zm140.7-67.3c-6.2 6.2-6.2 16.4 0 22.6L521.4 352H432c-8.8 0-16 7.2-16 16s7.2 16 16 16h89.4l-28.7 28.7c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0l56-56c6.2-6.2 6.2-16.4 0-22.6l-56-56c-6.2-6.2-16.4-6.2-22.6 0z"
    ]
};
var $d8206b3ab2e65c05$export$cc519c9529a46c5c = {
    prefix: "fas",
    iconName: "volleyball",
    icon: [
        512,
        512,
        [
            127952,
            "volleyball-ball"
        ],
        "f45f",
        "M511.8 267.4c-26.1 8.7-53.4 13.8-81 15.1c9.2-105.3-31.5-204.2-103.2-272.4C434.1 41.1 512 139.5 512 256c0 3.8-.1 7.6-.2 11.4zm-3.9 34.7c-5.8 32-17.6 62-34.2 88.7c-97.5 48.5-217.7 42.6-311.9-24.5c23.7-36.2 55.4-67.7 94.5-91.8c79.9 43.2 170.1 50.8 251.6 27.6zm-236-55.5c-2.5-90.9-41.1-172.7-101.9-231.7C196.8 5.2 225.8 0 256 0c2.7 0 5.3 0 7.9 .1c90.8 60.2 145.7 167.2 134.7 282.3c-43.1-2.4-86.4-14.1-126.8-35.9zM138 28.8c20.6 18.3 38.7 39.4 53.7 62.6C95.9 136.1 30.6 220.8 7.3 316.9C2.5 297.4 0 277 0 256C0 157.2 56 71.5 138 28.8zm69.6 90.5c19.5 38.6 31 81.9 32.3 127.7C162.5 294.6 110.9 368.9 90.2 451C66 430.4 45.6 405.4 30.4 377.2c6.7-108.7 71.9-209.9 177.1-257.9zM256 512c-50.7 0-98-14.7-137.8-40.2c5.6-27 14.8-53.1 27.4-77.7C232.2 454.6 338.1 468.8 433 441c-46 44-108.3 71-177 71z"
    ]
};
var $d8206b3ab2e65c05$export$a15e6fc8e68a76b0 = $d8206b3ab2e65c05$export$cc519c9529a46c5c;
var $d8206b3ab2e65c05$export$159982ce2622211e = {
    prefix: "fas",
    iconName: "arrows-up-to-line",
    icon: [
        576,
        512,
        [],
        "e4c2",
        "M32 96l512 0c17.7 0 32-14.3 32-32s-14.3-32-32-32L32 32C14.3 32 0 46.3 0 64S14.3 96 32 96zM9.4 233.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0L96 237.3 96 448c0 17.7 14.3 32 32 32s32-14.3 32-32l0-210.7 41.4 41.4c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3l-96-96c-12.5-12.5-32.8-12.5-45.3 0l-96 96zm320 45.3c12.5 12.5 32.8 12.5 45.3 0L416 237.3 416 448c0 17.7 14.3 32 32 32s32-14.3 32-32l0-210.7 41.4 41.4c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3l-96-96c-12.5-12.5-32.8-12.5-45.3 0l-96 96c-12.5 12.5-12.5 32.8 0 45.3z"
    ]
};
var $d8206b3ab2e65c05$export$58e2577a373e7d4 = {
    prefix: "fas",
    iconName: "sort-down",
    icon: [
        320,
        512,
        [
            "sort-desc"
        ],
        "f0dd",
        "M182.6 470.6c-12.5 12.5-32.8 12.5-45.3 0l-128-128c-9.2-9.2-11.9-22.9-6.9-34.9s16.6-19.8 29.6-19.8H288c12.9 0 24.6 7.8 29.6 19.8s2.2 25.7-6.9 34.9l-128 128z"
    ]
};
var $d8206b3ab2e65c05$export$e24f016f5f78af6a = $d8206b3ab2e65c05$export$58e2577a373e7d4;
var $d8206b3ab2e65c05$export$d0163707993a8110 = {
    prefix: "fas",
    iconName: "circle-minus",
    icon: [
        512,
        512,
        [
            "minus-circle"
        ],
        "f056",
        "M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM184 232H328c13.3 0 24 10.7 24 24s-10.7 24-24 24H184c-13.3 0-24-10.7-24-24s10.7-24 24-24z"
    ]
};
var $d8206b3ab2e65c05$export$f3979b49bf57313c = $d8206b3ab2e65c05$export$d0163707993a8110;
var $d8206b3ab2e65c05$export$41821b9a6fd703de = {
    prefix: "fas",
    iconName: "door-open",
    icon: [
        576,
        512,
        [],
        "f52b",
        "M320 32c0-9.9-4.5-19.2-12.3-25.2S289.8-1.4 280.2 1l-179.9 45C79 51.3 64 70.5 64 92.5V448H32c-17.7 0-32 14.3-32 32s14.3 32 32 32H96 288h32V480 32zM256 256c0 17.7-10.7 32-24 32s-24-14.3-24-32s10.7-32 24-32s24 14.3 24 32zm96-128h96V480c0 17.7 14.3 32 32 32h64c17.7 0 32-14.3 32-32s-14.3-32-32-32H512V128c0-35.3-28.7-64-64-64H352v64z"
    ]
};
var $d8206b3ab2e65c05$export$122a80ae0f87f726 = {
    prefix: "fas",
    iconName: "right-from-bracket",
    icon: [
        512,
        512,
        [
            "sign-out-alt"
        ],
        "f2f5",
        "M377.9 105.9L500.7 228.7c7.2 7.2 11.3 17.1 11.3 27.3s-4.1 20.1-11.3 27.3L377.9 406.1c-6.4 6.4-15 9.9-24 9.9c-18.7 0-33.9-15.2-33.9-33.9l0-62.1-128 0c-17.7 0-32-14.3-32-32l0-64c0-17.7 14.3-32 32-32l128 0 0-62.1c0-18.7 15.2-33.9 33.9-33.9c9 0 17.6 3.6 24 9.9zM160 96L96 96c-17.7 0-32 14.3-32 32l0 256c0 17.7 14.3 32 32 32l64 0c17.7 0 32 14.3 32 32s-14.3 32-32 32l-64 0c-53 0-96-43-96-96L0 128C0 75 43 32 96 32l64 0c17.7 0 32 14.3 32 32s-14.3 32-32 32z"
    ]
};
var $d8206b3ab2e65c05$export$c844d6923b7096c2 = $d8206b3ab2e65c05$export$122a80ae0f87f726;
var $d8206b3ab2e65c05$export$b5bb295e8ad4ab31 = {
    prefix: "fas",
    iconName: "atom",
    icon: [
        512,
        512,
        [
            9883
        ],
        "f5d2",
        "M256 398.8c-11.8 5.1-23.4 9.7-34.9 13.5c16.7 33.8 31 35.7 34.9 35.7s18.1-1.9 34.9-35.7c-11.4-3.9-23.1-8.4-34.9-13.5zM446 256c33 45.2 44.3 90.9 23.6 128c-20.2 36.3-62.5 49.3-115.2 43.2c-22 52.1-55.6 84.8-98.4 84.8s-76.4-32.7-98.4-84.8c-52.7 6.1-95-6.8-115.2-43.2C21.7 346.9 33 301.2 66 256c-33-45.2-44.3-90.9-23.6-128c20.2-36.3 62.5-49.3 115.2-43.2C179.6 32.7 213.2 0 256 0s76.4 32.7 98.4 84.8c52.7-6.1 95 6.8 115.2 43.2c20.7 37.1 9.4 82.8-23.6 128zm-65.8 67.4c-1.7 14.2-3.9 28-6.7 41.2c31.8 1.4 38.6-8.7 40.2-11.7c2.3-4.2 7-17.9-11.9-48.1c-6.8 6.3-14 12.5-21.6 18.6zm-6.7-175.9c2.8 13.1 5 26.9 6.7 41.2c7.6 6.1 14.8 12.3 21.6 18.6c18.9-30.2 14.2-44 11.9-48.1c-1.6-2.9-8.4-13-40.2-11.7zM290.9 99.7C274.1 65.9 259.9 64 256 64s-18.1 1.9-34.9 35.7c11.4 3.9 23.1 8.4 34.9 13.5c11.8-5.1 23.4-9.7 34.9-13.5zm-159 88.9c1.7-14.3 3.9-28 6.7-41.2c-31.8-1.4-38.6 8.7-40.2 11.7c-2.3 4.2-7 17.9 11.9 48.1c6.8-6.3 14-12.5 21.6-18.6zM110.2 304.8C91.4 335 96 348.7 98.3 352.9c1.6 2.9 8.4 13 40.2 11.7c-2.8-13.1-5-26.9-6.7-41.2c-7.6-6.1-14.8-12.3-21.6-18.6zM336 256a80 80 0 1 0 -160 0 80 80 0 1 0 160 0zm-80-32a32 32 0 1 1 0 64 32 32 0 1 1 0-64z"
    ]
};
var $d8206b3ab2e65c05$export$64f1c53b21f310ac = {
    prefix: "fas",
    iconName: "soap",
    icon: [
        512,
        512,
        [
            129532
        ],
        "e06e",
        "M208 96a48 48 0 1 0 0-96 48 48 0 1 0 0 96zM320 256a64 64 0 1 0 0-128 64 64 0 1 0 0 128zM416 32a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zm0 160c0 27.6-11.7 52.5-30.4 70.1C422.1 275.7 448 310.8 448 352c0 53-43 96-96 96H160c-53 0-96-43-96-96s43-96 96-96h88.4c-15.2-17-24.4-39.4-24.4-64H96c-53 0-96 43-96 96V416c0 53 43 96 96 96H416c53 0 96-43 96-96V288c0-53-43-96-96-96zM160 288c-35.3 0-64 28.7-64 64s28.7 64 64 64H352c35.3 0 64-28.7 64-64s-28.7-64-64-64H320 160z"
    ]
};
var $d8206b3ab2e65c05$export$7fe2894454d8eb8a = {
    prefix: "fas",
    iconName: "icons",
    icon: [
        512,
        512,
        [
            "heart-music-camera-bolt"
        ],
        "f86d",
        "M500.3 7.3C507.7 13.3 512 22.4 512 32V176c0 26.5-28.7 48-64 48s-64-21.5-64-48s28.7-48 64-48V71L352 90.2V208c0 26.5-28.7 48-64 48s-64-21.5-64-48s28.7-48 64-48V64c0-15.3 10.8-28.4 25.7-31.4l160-32c9.4-1.9 19.1 .6 26.6 6.6zM74.7 304l11.8-17.8c5.9-8.9 15.9-14.2 26.6-14.2h61.7c10.7 0 20.7 5.3 26.6 14.2L213.3 304H240c26.5 0 48 21.5 48 48V464c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V352c0-26.5 21.5-48 48-48H74.7zM192 408a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zM478.7 278.3L440.3 368H496c6.7 0 12.6 4.1 15 10.4s.6 13.3-4.4 17.7l-128 112c-5.6 4.9-13.9 5.3-19.9 .9s-8.2-12.4-5.3-19.2L391.7 400H336c-6.7 0-12.6-4.1-15-10.4s-.6-13.3 4.4-17.7l128-112c5.6-4.9 13.9-5.3 19.9-.9s8.2 12.4 5.3 19.2zm-339-59.2c-6.5 6.5-17 6.5-23 0L19.9 119.2c-28-29-26.5-76.9 5-103.9c27-23.5 68.4-19 93.4 6.5l10 10.5 9.5-10.5c25-25.5 65.9-30 93.9-6.5c31 27 32.5 74.9 4.5 103.9l-96.4 99.9z"
    ]
};
var $d8206b3ab2e65c05$export$ec74c13cedb0791d = $d8206b3ab2e65c05$export$7fe2894454d8eb8a;
var $d8206b3ab2e65c05$export$4be1b324ac8a71ba = {
    prefix: "fas",
    iconName: "microphone-lines-slash",
    icon: [
        640,
        512,
        [
            "microphone-alt-slash"
        ],
        "f539",
        "M38.8 5.1C28.4-3.1 13.3-1.2 5.1 9.2S-1.2 34.7 9.2 42.9l592 464c10.4 8.2 25.5 6.3 33.7-4.1s6.3-25.5-4.1-33.7L472.1 344.7c15.2-26 23.9-56.3 23.9-88.7V216c0-13.3-10.7-24-24-24s-24 10.7-24 24v24 16c0 21.2-5.1 41.1-14.2 58.7L416 300.8V256H358.9l-34.5-27c2.9-3.1 7-5 11.6-5h80V192H336c-8.8 0-16-7.2-16-16s7.2-16 16-16h80V128H336c-8.8 0-16-7.2-16-16s7.2-16 16-16h80c0-53-43-96-96-96s-96 43-96 96v54.3L38.8 5.1zm362.5 407l-43.1-33.9C346.1 382 333.3 384 320 384c-70.7 0-128-57.3-128-128v-8.7L144.7 210c-.5 1.9-.7 3.9-.7 6v40c0 89.1 66.2 162.7 152 174.4V464H248c-13.3 0-24 10.7-24 24s10.7 24 24 24h72 72c13.3 0 24-10.7 24-24s-10.7-24-24-24H344V430.4c20.4-2.8 39.7-9.1 57.3-18.2z"
    ]
};
var $d8206b3ab2e65c05$export$d2a53a388f30780 = $d8206b3ab2e65c05$export$4be1b324ac8a71ba;
var $d8206b3ab2e65c05$export$ea908d3d80c57d08 = {
    prefix: "fas",
    iconName: "bridge-circle-check",
    icon: [
        640,
        512,
        [],
        "e4c9",
        "M64 32C46.3 32 32 46.3 32 64s14.3 32 32 32h40v64H32V288c53 0 96 43 96 96v64c0 17.7 14.3 32 32 32h32c17.7 0 32-14.3 32-32V384c0-53 43-96 96-96c6.3 0 12.4 .6 18.3 1.7C367.1 231.8 426.9 192 496 192c42.5 0 81.6 15.1 112 40.2V160H536V96h40c17.7 0 32-14.3 32-32s-14.3-32-32-32H64zM488 96v64H408V96h80zM360 96v64H280V96h80zM232 96v64H152V96h80zM640 368a144 144 0 1 0 -288 0 144 144 0 1 0 288 0zm-76.7-43.3c6.2 6.2 6.2 16.4 0 22.6l-72 72c-6.2 6.2-16.4 6.2-22.6 0l-40-40c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0L480 385.4l60.7-60.7c6.2-6.2 16.4-6.2 22.6 0z"
    ]
};
var $d8206b3ab2e65c05$export$f1b881c73328720c = {
    prefix: "fas",
    iconName: "pump-medical",
    icon: [
        448,
        512,
        [],
        "e06a",
        "M128 32v96H256V96h60.1c4.2 0 8.3 1.7 11.3 4.7l33.9 33.9c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L372.7 55.4c-15-15-35.4-23.4-56.6-23.4H256c0-17.7-14.3-32-32-32H160c-17.7 0-32 14.3-32 32zM117.4 160c-33.3 0-61 25.5-63.8 58.7L35 442.7C31.9 480 61.3 512 98.8 512H285.2c37.4 0 66.9-32 63.8-69.3l-18.7-224c-2.8-33.2-30.5-58.7-63.8-58.7H117.4zM216 280v32h32c13.3 0 24 10.7 24 24s-10.7 24-24 24H216v32c0 13.3-10.7 24-24 24s-24-10.7-24-24V360H136c-13.3 0-24-10.7-24-24s10.7-24 24-24h32V280c0-13.3 10.7-24 24-24s24 10.7 24 24z"
    ]
};
var $d8206b3ab2e65c05$export$614dc068d88655af = {
    prefix: "fas",
    iconName: "fingerprint",
    icon: [
        512,
        512,
        [],
        "f577",
        "M48 256C48 141.1 141.1 48 256 48c63.1 0 119.6 28.1 157.8 72.5c8.6 10.1 23.8 11.2 33.8 2.6s11.2-23.8 2.6-33.8C403.3 34.6 333.7 0 256 0C114.6 0 0 114.6 0 256v40c0 13.3 10.7 24 24 24s24-10.7 24-24V256zm458.5-52.9c-2.7-13-15.5-21.3-28.4-18.5s-21.3 15.5-18.5 28.4c2.9 13.9 4.5 28.3 4.5 43.1v40c0 13.3 10.7 24 24 24s24-10.7 24-24V256c0-18.1-1.9-35.8-5.5-52.9zM256 80c-19 0-37.4 3-54.5 8.6c-15.2 5-18.7 23.7-8.3 35.9c7.1 8.3 18.8 10.8 29.4 7.9c10.6-2.9 21.8-4.4 33.4-4.4c70.7 0 128 57.3 128 128v24.9c0 25.2-1.5 50.3-4.4 75.3c-1.7 14.6 9.4 27.8 24.2 27.8c11.8 0 21.9-8.6 23.3-20.3c3.3-27.4 5-55 5-82.7V256c0-97.2-78.8-176-176-176zM150.7 148.7c-9.1-10.6-25.3-11.4-33.9-.4C93.7 178 80 215.4 80 256v24.9c0 24.2-2.6 48.4-7.8 71.9C68.8 368.4 80.1 384 96.1 384c10.5 0 19.9-7 22.2-17.3c6.4-28.1 9.7-56.8 9.7-85.8V256c0-27.2 8.5-52.4 22.9-73.1c7.2-10.4 8-24.6-.2-34.2zM256 160c-53 0-96 43-96 96v24.9c0 35.9-4.6 71.5-13.8 106.1c-3.8 14.3 6.7 29 21.5 29c9.5 0 17.9-6.2 20.4-15.4c10.5-39 15.9-79.2 15.9-119.7V256c0-28.7 23.3-52 52-52s52 23.3 52 52v24.9c0 36.3-3.5 72.4-10.4 107.9c-2.7 13.9 7.7 27.2 21.8 27.2c10.2 0 19-7 21-17c7.7-38.8 11.6-78.3 11.6-118.1V256c0-53-43-96-96-96zm24 96c0-13.3-10.7-24-24-24s-24 10.7-24 24v24.9c0 59.9-11 119.3-32.5 175.2l-5.9 15.3c-4.8 12.4 1.4 26.3 13.8 31s26.3-1.4 31-13.8l5.9-15.3C267.9 411.9 280 346.7 280 280.9V256z"
    ]
};
var $d8206b3ab2e65c05$export$f7bc8714c970afa4 = {
    prefix: "fas",
    iconName: "hand-point-right",
    icon: [
        512,
        512,
        [],
        "f0a4",
        "M480 96c17.7 0 32 14.3 32 32s-14.3 32-32 32l-208 0 0-64 208 0zM320 288c17.7 0 32 14.3 32 32s-14.3 32-32 32l-64 0c-17.7 0-32-14.3-32-32s14.3-32 32-32l64 0zm64-64c0 17.7-14.3 32-32 32l-48 0c-17.7 0-32-14.3-32-32s14.3-32 32-32l48 0c17.7 0 32 14.3 32 32zM288 384c17.7 0 32 14.3 32 32s-14.3 32-32 32l-64 0c-17.7 0-32-14.3-32-32s14.3-32 32-32l64 0zm-88-96l.6 0c-5.4 9.4-8.6 20.3-8.6 32c0 13.2 4 25.4 10.8 35.6C177.9 364.3 160 388.1 160 416c0 11.7 3.1 22.6 8.6 32l-8.6 0C71.6 448 0 376.4 0 288l0-61.7c0-42.4 16.9-83.1 46.9-113.1l11.6-11.6C82.5 77.5 115.1 64 149 64l27 0c35.3 0 64 28.7 64 64l0 88c0 22.1-17.9 40-40 40s-40-17.9-40-40l0-56c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 56c0 39.8 32.2 72 72 72z"
    ]
};
var $d8206b3ab2e65c05$export$234a18b2b4d530a3 = {
    prefix: "fas",
    iconName: "magnifying-glass-location",
    icon: [
        512,
        512,
        [
            "search-location"
        ],
        "f689",
        "M416 208c0 45.9-14.9 88.3-40 122.7L502.6 457.4c12.5 12.5 12.5 32.8 0 45.3s-32.8 12.5-45.3 0L330.7 376c-34.4 25.2-76.8 40-122.7 40C93.1 416 0 322.9 0 208S93.1 0 208 0S416 93.1 416 208zM288 176c0-44.2-35.8-80-80-80s-80 35.8-80 80c0 48.8 46.5 111.6 68.6 138.6c6 7.3 16.8 7.3 22.7 0c22.1-27 68.6-89.8 68.6-138.6zm-112 0a32 32 0 1 1 64 0 32 32 0 1 1 -64 0z"
    ]
};
var $d8206b3ab2e65c05$export$c33aba6c251a898a = $d8206b3ab2e65c05$export$234a18b2b4d530a3;
var $d8206b3ab2e65c05$export$908d699be6717adc = {
    prefix: "fas",
    iconName: "forward-step",
    icon: [
        320,
        512,
        [
            "step-forward"
        ],
        "f051",
        "M52.5 440.6c-9.5 7.9-22.8 9.7-34.1 4.4S0 428.4 0 416V96C0 83.6 7.2 72.3 18.4 67s24.5-3.6 34.1 4.4l192 160L256 241V96c0-17.7 14.3-32 32-32s32 14.3 32 32V416c0 17.7-14.3 32-32 32s-32-14.3-32-32V271l-11.5 9.6-192 160z"
    ]
};
var $d8206b3ab2e65c05$export$b303329afce5de18 = $d8206b3ab2e65c05$export$908d699be6717adc;
var $d8206b3ab2e65c05$export$e3c56ed54f074063 = {
    prefix: "fas",
    iconName: "face-smile-beam",
    icon: [
        512,
        512,
        [
            128522,
            "smile-beam"
        ],
        "f5b8",
        "M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM164.1 325.5C182 346.2 212.6 368 256 368s74-21.8 91.9-42.5c5.8-6.7 15.9-7.4 22.6-1.6s7.4 15.9 1.6 22.6C349.8 372.1 311.1 400 256 400s-93.8-27.9-116.1-53.5c-5.8-6.7-5.1-16.8 1.6-22.6s16.8-5.1 22.6 1.6zm53.5-96.7l0 0 0 0-.2-.2c-.2-.2-.4-.5-.7-.9c-.6-.8-1.6-2-2.8-3.4c-2.5-2.8-6-6.6-10.2-10.3c-8.8-7.8-18.8-14-27.7-14s-18.9 6.2-27.7 14c-4.2 3.7-7.7 7.5-10.2 10.3c-1.2 1.4-2.2 2.6-2.8 3.4c-.3 .4-.6 .7-.7 .9l-.2 .2 0 0 0 0 0 0c-2.1 2.8-5.7 3.9-8.9 2.8s-5.5-4.1-5.5-7.6c0-17.9 6.7-35.6 16.6-48.8c9.8-13 23.9-23.2 39.4-23.2s29.6 10.2 39.4 23.2c9.9 13.2 16.6 30.9 16.6 48.8c0 3.4-2.2 6.5-5.5 7.6s-6.9 0-8.9-2.8l0 0 0 0zm160 0l0 0-.2-.2c-.2-.2-.4-.5-.7-.9c-.6-.8-1.6-2-2.8-3.4c-2.5-2.8-6-6.6-10.2-10.3c-8.8-7.8-18.8-14-27.7-14s-18.9 6.2-27.7 14c-4.2 3.7-7.7 7.5-10.2 10.3c-1.2 1.4-2.2 2.6-2.8 3.4c-.3 .4-.6 .7-.7 .9l-.2 .2 0 0 0 0 0 0c-2.1 2.8-5.7 3.9-8.9 2.8s-5.5-4.1-5.5-7.6c0-17.9 6.7-35.6 16.6-48.8c9.8-13 23.9-23.2 39.4-23.2s29.6 10.2 39.4 23.2c9.9 13.2 16.6 30.9 16.6 48.8c0 3.4-2.2 6.5-5.5 7.6s-6.9 0-8.9-2.8l0 0 0 0 0 0z"
    ]
};
var $d8206b3ab2e65c05$export$54ada6dc9690e0ca = $d8206b3ab2e65c05$export$e3c56ed54f074063;
var $d8206b3ab2e65c05$export$92fad97e19a9fea = {
    prefix: "fas",
    iconName: "flag-checkered",
    icon: [
        448,
        512,
        [
            127937
        ],
        "f11e",
        "M32 0C49.7 0 64 14.3 64 32V48l69-17.2c38.1-9.5 78.3-5.1 113.5 12.5c46.3 23.2 100.8 23.2 147.1 0l9.6-4.8C423.8 28.1 448 43.1 448 66.1V345.8c0 13.3-8.3 25.3-20.8 30l-34.7 13c-46.2 17.3-97.6 14.6-141.7-7.4c-37.9-19-81.3-23.7-122.5-13.4L64 384v96c0 17.7-14.3 32-32 32s-32-14.3-32-32V400 334 64 32C0 14.3 14.3 0 32 0zM64 187.1l64-13.9v65.5L64 252.6V318l48.8-12.2c5.1-1.3 10.1-2.4 15.2-3.3V238.7l38.9-8.4c8.3-1.8 16.7-2.5 25.1-2.1l0-64c13.6 .4 27.2 2.6 40.4 6.4l23.6 6.9v66.7l-41.7-12.3c-7.3-2.1-14.8-3.4-22.3-3.8v71.4c21.8 1.9 43.3 6.7 64 14.4V244.2l22.7 6.7c13.5 4 27.3 6.4 41.3 7.4V194c-7.8-.8-15.6-2.3-23.2-4.5l-40.8-12v-62c-13-3.8-25.8-8.8-38.2-15c-8.2-4.1-16.9-7-25.8-8.8v72.4c-13-.4-26 .8-38.7 3.6L128 173.2V98L64 114v73.1zM320 335.7c16.8 1.5 33.9-.7 50-6.8l14-5.2V251.9l-7.9 1.8c-18.4 4.3-37.3 5.7-56.1 4.5v77.4zm64-149.4V115.4c-20.9 6.1-42.4 9.1-64 9.1V194c13.9 1.4 28 .5 41.7-2.6l22.3-5.2z"
    ]
};
var $d8206b3ab2e65c05$export$e15f65e77f717c29 = {
    prefix: "fas",
    iconName: "football",
    icon: [
        512,
        512,
        [
            127944,
            "football-ball"
        ],
        "f44e",
        "M247.5 25.4c-13.5 3.3-26.4 7.2-38.6 11.7C142.9 61.6 96.7 103.6 66 153.6c-18.3 29.8-30.9 62.3-39.2 95.4L264.5 486.6c13.5-3.3 26.4-7.2 38.6-11.7c66-24.5 112.2-66.5 142.9-116.5c18.3-29.8 30.9-62.3 39.1-95.3L247.5 25.4zM495.2 205.3c6.1-56.8 1.4-112.2-7.7-156.4c-2.7-12.9-13-22.9-26.1-25.1c-58.2-9.7-109.9-12-155.6-7.9L495.2 205.3zM206.1 496L16.8 306.7c-6.1 56.8-1.4 112.2 7.7 156.4c2.7 12.9 13 22.9 26.1 25.1c58.2 9.7 109.9 12 155.6 7.9zm54.6-331.3c6.2-6.2 16.4-6.2 22.6 0l64 64c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0l-64-64c-6.2-6.2-6.2-16.4 0-22.6zm-48 48c6.2-6.2 16.4-6.2 22.6 0l64 64c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0l-64-64c-6.2-6.2-6.2-16.4 0-22.6zm-48 48c6.2-6.2 16.4-6.2 22.6 0l64 64c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0l-64-64c-6.2-6.2-6.2-16.4 0-22.6z"
    ]
};
var $d8206b3ab2e65c05$export$e8fd664711e31704 = $d8206b3ab2e65c05$export$e15f65e77f717c29;
var $d8206b3ab2e65c05$export$f629fdee00932a01 = {
    prefix: "fas",
    iconName: "school-circle-exclamation",
    icon: [
        640,
        512,
        [],
        "e56c",
        "M337.8 5.4C327-1.8 313-1.8 302.2 5.4L166.3 96H48C21.5 96 0 117.5 0 144V464c0 26.5 21.5 48 48 48H320v0H256V416c0-35.3 28.7-64 64-64l.3 0h.5c3.4-37.7 18.7-72.1 42.2-99.1C350.2 260 335.6 264 320 264c-48.6 0-88-39.4-88-88s39.4-88 88-88s88 39.4 88 88c0 18.3-5.6 35.3-15.1 49.4c29-21 64.6-33.4 103.1-33.4c59.5 0 112.1 29.6 144 74.8V144c0-26.5-21.5-48-48-48H473.7L337.8 5.4zM96 192h32c8.8 0 16 7.2 16 16v64c0 8.8-7.2 16-16 16H96c-8.8 0-16-7.2-16-16V208c0-8.8 7.2-16 16-16zm0 128h32c8.8 0 16 7.2 16 16v64c0 8.8-7.2 16-16 16H96c-8.8 0-16-7.2-16-16V336c0-8.8 7.2-16 16-16zM320 128c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16s-7.2-16-16-16H336V144c0-8.8-7.2-16-16-16zM496 512a144 144 0 1 0 0-288 144 144 0 1 0 0 288zm0-96a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm0-144c8.8 0 16 7.2 16 16v80c0 8.8-7.2 16-16 16s-16-7.2-16-16V288c0-8.8 7.2-16 16-16z"
    ]
};
var $d8206b3ab2e65c05$export$afa58590dfb6fca2 = {
    prefix: "fas",
    iconName: "crop",
    icon: [
        512,
        512,
        [],
        "f125",
        "M448 109.3l54.6-54.6c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L402.7 64 160 64v64l178.7 0L128 338.7V32c0-17.7-14.3-32-32-32S64 14.3 64 32V64H32C14.3 64 0 78.3 0 96s14.3 32 32 32H64V384c0 35.3 28.7 64 64 64H352V384H173.3L384 173.3 384 480c0 17.7 14.3 32 32 32s32-14.3 32-32V448h32c17.7 0 32-14.3 32-32s-14.3-32-32-32H448l0-274.7z"
    ]
};
var $d8206b3ab2e65c05$export$52783a541b1bb03 = {
    prefix: "fas",
    iconName: "angles-down",
    icon: [
        448,
        512,
        [
            "angle-double-down"
        ],
        "f103",
        "M246.6 470.6c-12.5 12.5-32.8 12.5-45.3 0l-160-160c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0L224 402.7 361.4 265.4c12.5-12.5 32.8-12.5 45.3 0s12.5 32.8 0 45.3l-160 160zm160-352l-160 160c-12.5 12.5-32.8 12.5-45.3 0l-160-160c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0L224 210.7 361.4 73.4c12.5-12.5 32.8-12.5 45.3 0s12.5 32.8 0 45.3z"
    ]
};
var $d8206b3ab2e65c05$export$fd504117f273ca92 = $d8206b3ab2e65c05$export$52783a541b1bb03;
var $d8206b3ab2e65c05$export$a28757068b9a3a9a = {
    prefix: "fas",
    iconName: "users-rectangle",
    icon: [
        640,
        512,
        [],
        "e594",
        "M96 0C43 0 0 43 0 96V416c0 53 43 96 96 96H544c53 0 96-43 96-96V96c0-53-43-96-96-96H96zM64 96c0-17.7 14.3-32 32-32H544c17.7 0 32 14.3 32 32V416c0 17.7-14.3 32-32 32H96c-17.7 0-32-14.3-32-32V96zm159.8 80a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zM96 309.3c0 14.7 11.9 26.7 26.7 26.7h56.1c8-34.1 32.8-61.7 65.2-73.6c-7.5-4.1-16.2-6.4-25.3-6.4H149.3C119.9 256 96 279.9 96 309.3zM461.2 336h56.1c14.7 0 26.7-11.9 26.7-26.7c0-29.5-23.9-53.3-53.3-53.3H421.3c-9.2 0-17.8 2.3-25.3 6.4c32.4 11.9 57.2 39.5 65.2 73.6zM372 289c-3.9-.7-7.9-1-12-1H280c-4.1 0-8.1 .3-12 1c-26 4.4-47.3 22.7-55.9 47c-2.7 7.5-4.1 15.6-4.1 24c0 13.3 10.7 24 24 24H408c13.3 0 24-10.7 24-24c0-8.4-1.4-16.5-4.1-24c-8.6-24.3-29.9-42.6-55.9-47zM512 176a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zM320 256a64 64 0 1 0 0-128 64 64 0 1 0 0 128z"
    ]
};
var $d8206b3ab2e65c05$export$b96e695bdcf3f3f5 = {
    prefix: "fas",
    iconName: "people-roof",
    icon: [
        640,
        512,
        [],
        "e537",
        "M335.5 4l288 160c15.4 8.6 21 28.1 12.4 43.5s-28.1 21-43.5 12.4L320 68.6 47.5 220c-15.4 8.6-34.9 3-43.5-12.4s-3-34.9 12.4-43.5L304.5 4c9.7-5.4 21.4-5.4 31.1 0zM320 160a40 40 0 1 1 0 80 40 40 0 1 1 0-80zM144 256a40 40 0 1 1 0 80 40 40 0 1 1 0-80zm312 40a40 40 0 1 1 80 0 40 40 0 1 1 -80 0zM226.9 491.4L200 441.5V480c0 17.7-14.3 32-32 32H120c-17.7 0-32-14.3-32-32V441.5L61.1 491.4c-6.3 11.7-20.8 16-32.5 9.8s-16-20.8-9.8-32.5l37.9-70.3c15.3-28.5 45.1-46.3 77.5-46.3h19.5c16.3 0 31.9 4.5 45.4 12.6l33.6-62.3c15.3-28.5 45.1-46.3 77.5-46.3h19.5c32.4 0 62.1 17.8 77.5 46.3l33.6 62.3c13.5-8.1 29.1-12.6 45.4-12.6h19.5c32.4 0 62.1 17.8 77.5 46.3l37.9 70.3c6.3 11.7 1.9 26.2-9.8 32.5s-26.2 1.9-32.5-9.8L552 441.5V480c0 17.7-14.3 32-32 32H472c-17.7 0-32-14.3-32-32V441.5l-26.9 49.9c-6.3 11.7-20.8 16-32.5 9.8s-16-20.8-9.8-32.5l36.3-67.5c-1.7-1.7-3.2-3.6-4.3-5.8L376 345.5V400c0 17.7-14.3 32-32 32H296c-17.7 0-32-14.3-32-32V345.5l-26.9 49.9c-1.2 2.2-2.6 4.1-4.3 5.8l36.3 67.5c6.3 11.7 1.9 26.2-9.8 32.5s-26.2 1.9-32.5-9.8z"
    ]
};
var $d8206b3ab2e65c05$export$d12c2d6def120efe = {
    prefix: "fas",
    iconName: "people-line",
    icon: [
        640,
        512,
        [],
        "e534",
        "M360 72a40 40 0 1 0 -80 0 40 40 0 1 0 80 0zM144 208a40 40 0 1 0 0-80 40 40 0 1 0 0 80zM32 416c-17.7 0-32 14.3-32 32s14.3 32 32 32H608c17.7 0 32-14.3 32-32s-14.3-32-32-32H32zM496 208a40 40 0 1 0 0-80 40 40 0 1 0 0 80zM200 313.5l26.9 49.9c6.3 11.7 20.8 16 32.5 9.8s16-20.8 9.8-32.5l-36.3-67.5c1.7-1.7 3.2-3.6 4.3-5.8L264 217.5V272c0 17.7 14.3 32 32 32h48c17.7 0 32-14.3 32-32V217.5l26.9 49.9c1.2 2.2 2.6 4.1 4.3 5.8l-36.3 67.5c-6.3 11.7-1.9 26.2 9.8 32.5s26.2 1.9 32.5-9.8L440 313.5V352c0 17.7 14.3 32 32 32h48c17.7 0 32-14.3 32-32V313.5l26.9 49.9c6.3 11.7 20.8 16 32.5 9.8s16-20.8 9.8-32.5l-37.9-70.3c-15.3-28.5-45.1-46.3-77.5-46.3H486.2c-16.3 0-31.9 4.5-45.4 12.6l-33.6-62.3c-15.3-28.5-45.1-46.3-77.5-46.3H310.2c-32.4 0-62.1 17.8-77.5 46.3l-33.6 62.3c-13.5-8.1-29.1-12.6-45.4-12.6H134.2c-32.4 0-62.1 17.8-77.5 46.3L18.9 340.6c-6.3 11.7-1.9 26.2 9.8 32.5s26.2 1.9 32.5-9.8L88 313.5V352c0 17.7 14.3 32 32 32h48c17.7 0 32-14.3 32-32V313.5z"
    ]
};
var $d8206b3ab2e65c05$export$b957c27bc5330472 = {
    prefix: "fas",
    iconName: "beer-mug-empty",
    icon: [
        512,
        512,
        [
            "beer"
        ],
        "f0fc",
        "M32 64c0-17.7 14.3-32 32-32H352c17.7 0 32 14.3 32 32V96h51.2c42.4 0 76.8 34.4 76.8 76.8V274.9c0 30.4-17.9 57.9-45.6 70.2L384 381.7V416c0 35.3-28.7 64-64 64H96c-35.3 0-64-28.7-64-64V64zM384 311.6l56.4-25.1c4.6-2.1 7.6-6.6 7.6-11.7V172.8c0-7.1-5.7-12.8-12.8-12.8H384V311.6zM160 144c0-8.8-7.2-16-16-16s-16 7.2-16 16V368c0 8.8 7.2 16 16 16s16-7.2 16-16V144zm64 0c0-8.8-7.2-16-16-16s-16 7.2-16 16V368c0 8.8 7.2 16 16 16s16-7.2 16-16V144zm64 0c0-8.8-7.2-16-16-16s-16 7.2-16 16V368c0 8.8 7.2 16 16 16s16-7.2 16-16V144z"
    ]
};
var $d8206b3ab2e65c05$export$f74725691538983b = $d8206b3ab2e65c05$export$b957c27bc5330472;
var $d8206b3ab2e65c05$export$1852c99deca7bee8 = {
    prefix: "fas",
    iconName: "diagram-predecessor",
    icon: [
        512,
        512,
        [],
        "e477",
        "M448 416l0-64L64 352l0 64 384 0zm0 64L64 480c-35.3 0-64-28.7-64-64l0-64c0-35.3 28.7-64 64-64l384 0c35.3 0 64 28.7 64 64l0 64c0 35.3-28.7 64-64 64zM288 160c0 35.3-28.7 64-64 64L64 224c-35.3 0-64-28.7-64-64L0 96C0 60.7 28.7 32 64 32l144 0 16 0 144 0c44.2 0 80 35.8 80 80l0 16 38.1 0c21.4 0 32.1 25.9 17 41L433 239c-9.4 9.4-24.6 9.4-33.9 0L329 169c-15.1-15.1-4.4-41 17-41l38.1 0 0-16c0-8.8-7.2-16-16-16l-80 0 0 64z"
    ]
};
var $d8206b3ab2e65c05$export$92c58defe6e4c5a7 = {
    prefix: "fas",
    iconName: "arrow-up-long",
    icon: [
        384,
        512,
        [
            "long-arrow-up"
        ],
        "f176",
        "M214.6 9.4c-12.5-12.5-32.8-12.5-45.3 0l-128 128c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0L160 109.3V480c0 17.7 14.3 32 32 32s32-14.3 32-32V109.3l73.4 73.4c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3l-128-128z"
    ]
};
var $d8206b3ab2e65c05$export$ede1d50ec4b01670 = $d8206b3ab2e65c05$export$92c58defe6e4c5a7;
var $d8206b3ab2e65c05$export$9ebfff5c90672059 = {
    prefix: "fas",
    iconName: "fire-flame-simple",
    icon: [
        384,
        512,
        [
            "burn"
        ],
        "f46a",
        "M372.5 256.5l-.7-1.9C337.8 160.8 282 76.5 209.1 8.5l-3.3-3C202.1 2 197.1 0 192 0s-10.1 2-13.8 5.5l-3.3 3C102 76.5 46.2 160.8 12.2 254.6l-.7 1.9C3.9 277.3 0 299.4 0 321.6C0 426.7 86.8 512 192 512s192-85.3 192-190.4c0-22.2-3.9-44.2-11.5-65.1zm-90.8 49.5c4.1 9.3 6.2 19.4 6.2 29.5c0 53-43 96.5-96 96.5s-96-43.5-96-96.5c0-10.1 2.1-20.3 6.2-29.5l1.9-4.3c15.8-35.4 37.9-67.7 65.3-95.1l8.9-8.9c3.6-3.6 8.5-5.6 13.6-5.6s10 2 13.6 5.6l8.9 8.9c27.4 27.4 49.6 59.7 65.3 95.1l1.9 4.3z"
    ]
};
var $d8206b3ab2e65c05$export$80ed4535efc60402 = $d8206b3ab2e65c05$export$9ebfff5c90672059;
var $d8206b3ab2e65c05$export$e6619e43cb090a16 = {
    prefix: "fas",
    iconName: "person",
    icon: [
        320,
        512,
        [
            129485,
            "male"
        ],
        "f183",
        "M112 48a48 48 0 1 1 96 0 48 48 0 1 1 -96 0zm40 304V480c0 17.7-14.3 32-32 32s-32-14.3-32-32V256.9L59.4 304.5c-9.1 15.1-28.8 20-43.9 10.9s-20-28.8-10.9-43.9l58.3-97c17.4-28.9 48.6-46.6 82.3-46.6h29.7c33.7 0 64.9 17.7 82.3 46.6l58.3 97c9.1 15.1 4.2 34.8-10.9 43.9s-34.8 4.2-43.9-10.9L232 256.9V480c0 17.7-14.3 32-32 32s-32-14.3-32-32V352H152z"
    ]
};
var $d8206b3ab2e65c05$export$2e21f9dba1630651 = $d8206b3ab2e65c05$export$e6619e43cb090a16;
var $d8206b3ab2e65c05$export$c2dee3bd177275a2 = {
    prefix: "fas",
    iconName: "laptop",
    icon: [
        640,
        512,
        [
            128187
        ],
        "f109",
        "M128 32C92.7 32 64 60.7 64 96V352h64V96H512V352h64V96c0-35.3-28.7-64-64-64H128zM19.2 384C8.6 384 0 392.6 0 403.2C0 445.6 34.4 480 76.8 480H563.2c42.4 0 76.8-34.4 76.8-76.8c0-10.6-8.6-19.2-19.2-19.2H19.2z"
    ]
};
var $d8206b3ab2e65c05$export$82cea4f586f6ec9 = {
    prefix: "fas",
    iconName: "file-csv",
    icon: [
        512,
        512,
        [],
        "f6dd",
        "M0 64C0 28.7 28.7 0 64 0H224V128c0 17.7 14.3 32 32 32H384V304H176c-35.3 0-64 28.7-64 64V512H64c-35.3 0-64-28.7-64-64V64zm384 64H256V0L384 128zM200 352h16c22.1 0 40 17.9 40 40v8c0 8.8-7.2 16-16 16s-16-7.2-16-16v-8c0-4.4-3.6-8-8-8H200c-4.4 0-8 3.6-8 8v80c0 4.4 3.6 8 8 8h16c4.4 0 8-3.6 8-8v-8c0-8.8 7.2-16 16-16s16 7.2 16 16v8c0 22.1-17.9 40-40 40H200c-22.1 0-40-17.9-40-40V392c0-22.1 17.9-40 40-40zm133.1 0H368c8.8 0 16 7.2 16 16s-7.2 16-16 16H333.1c-7.2 0-13.1 5.9-13.1 13.1c0 5.2 3 9.9 7.8 12l37.4 16.6c16.3 7.2 26.8 23.4 26.8 41.2c0 24.9-20.2 45.1-45.1 45.1H304c-8.8 0-16-7.2-16-16s7.2-16 16-16h42.9c7.2 0 13.1-5.9 13.1-13.1c0-5.2-3-9.9-7.8-12l-37.4-16.6c-16.3-7.2-26.8-23.4-26.8-41.2c0-24.9 20.2-45.1 45.1-45.1zm98.9 0c8.8 0 16 7.2 16 16v31.6c0 23 5.5 45.6 16 66c10.5-20.3 16-42.9 16-66V368c0-8.8 7.2-16 16-16s16 7.2 16 16v31.6c0 34.7-10.3 68.7-29.6 97.6l-5.1 7.7c-3 4.5-8 7.1-13.3 7.1s-10.3-2.7-13.3-7.1l-5.1-7.7c-19.3-28.9-29.6-62.9-29.6-97.6V368c0-8.8 7.2-16 16-16z"
    ]
};
var $d8206b3ab2e65c05$export$232452c59d77c56e = {
    prefix: "fas",
    iconName: "menorah",
    icon: [
        640,
        512,
        [],
        "f676",
        "M20.8 7.4C22.8 2.9 27.1 0 32 0s9.2 2.9 11.2 7.4L61.3 49.7c1.8 4.1 2.7 8.6 2.7 13.1V64c0 17.7-14.3 32-32 32S0 81.7 0 64V62.8c0-4.5 .9-8.9 2.7-13.1L20.8 7.4zm96 0C118.8 2.9 123.1 0 128 0s9.2 2.9 11.2 7.4l18.2 42.4c1.8 4.1 2.7 8.6 2.7 13.1V64c0 17.7-14.3 32-32 32s-32-14.3-32-32V62.8c0-4.5 .9-8.9 2.7-13.1L116.8 7.4zm77.8 42.4L212.8 7.4C214.8 2.9 219.1 0 224 0s9.2 2.9 11.2 7.4l18.2 42.4c1.8 4.1 2.7 8.6 2.7 13.1V64c0 17.7-14.3 32-32 32s-32-14.3-32-32V62.8c0-4.5 .9-8.9 2.7-13.1zM308.8 7.4C310.8 2.9 315.1 0 320 0s9.2 2.9 11.2 7.4l18.2 42.4c1.8 4.1 2.7 8.6 2.7 13.1V64c0 17.7-14.3 32-32 32s-32-14.3-32-32V62.8c0-4.5 .9-8.9 2.7-13.1L308.8 7.4zm77.8 42.4L404.8 7.4C406.8 2.9 411.1 0 416 0s9.2 2.9 11.2 7.4l18.2 42.4c1.8 4.1 2.7 8.6 2.7 13.1V64c0 17.7-14.3 32-32 32s-32-14.3-32-32V62.8c0-4.5 .9-8.9 2.7-13.1zM500.8 7.4C502.8 2.9 507.1 0 512 0s9.2 2.9 11.2 7.4l18.2 42.4c1.8 4.1 2.7 8.6 2.7 13.1V64c0 17.7-14.3 32-32 32s-32-14.3-32-32V62.8c0-4.5 .9-8.9 2.7-13.1L500.8 7.4zm77.8 42.4L596.8 7.4C598.8 2.9 603.1 0 608 0s9.2 2.9 11.2 7.4l18.2 42.4c1.8 4.1 2.7 8.6 2.7 13.1V64c0 17.7-14.3 32-32 32s-32-14.3-32-32V62.8c0-4.5 .9-8.9 2.7-13.1zM32 128c17.7 0 32 14.3 32 32V288c0 17.7 14.3 32 32 32H288V160c0-17.7 14.3-32 32-32s32 14.3 32 32V320H544c17.7 0 32-14.3 32-32V160c0-17.7 14.3-32 32-32s32 14.3 32 32V288c0 53-43 96-96 96H352v64H480c17.7 0 32 14.3 32 32s-14.3 32-32 32H320 160c-17.7 0-32-14.3-32-32s14.3-32 32-32H288V384H96c-53 0-96-43-96-96V160c0-17.7 14.3-32 32-32zm96 0c17.7 0 32 14.3 32 32v96 32H96V256 160c0-17.7 14.3-32 32-32zm96 0c17.7 0 32 14.3 32 32v96 32H192V256 160c0-17.7 14.3-32 32-32zm192 0c17.7 0 32 14.3 32 32v96 32H384V256 160c0-17.7 14.3-32 32-32zm96 0c17.7 0 32 14.3 32 32v96 32H480V256 160c0-17.7 14.3-32 32-32z"
    ]
};
var $d8206b3ab2e65c05$export$e1d5ceed99060d76 = {
    prefix: "fas",
    iconName: "truck-plane",
    icon: [
        640,
        512,
        [],
        "e58f",
        "M200 0c-30.6 0-56 54.7-56 86.1V192.5L7.8 274.3C2.9 277.2 0 282.4 0 288v64c0 5.1 2.4 9.8 6.4 12.8s9.3 3.9 14.1 2.5l123.4-37v81.2l-50 40c-3.8 3-6 7.6-6 12.5v32c0 5.1 2.5 10 6.6 13s9.5 3.8 14.4 2.2L200 480.9 290.4 511c-1.6-4.7-2.4-9.8-2.4-15V463.4c-18.2-10.5-30.7-29.7-31.9-51.8l-.1-.1V408 325.5 184l0-1.1 0 0V86.1C256 54.7 231.5 0 200 0zm88 176V400c0 20.9 13.4 38.7 32 45.3V488c0 13.3 10.7 24 24 24h16c13.3 0 24-10.7 24-24V448H544v40c0 13.3 10.7 24 24 24h16c13.3 0 24-10.7 24-24V445.3c18.6-6.6 32-24.4 32-45.3V176c0-26.5-21.5-48-48-48H336c-26.5 0-48 21.5-48 48zm79.8 78.7c3.3-8.7 11.2-14.7 20.5-14.7H539.7c9.2 0 17.2 6 20.5 14.7L576 304H352l15.8-49.3zM568 352a24 24 0 1 1 0 48 24 24 0 1 1 0-48zM336 376a24 24 0 1 1 48 0 24 24 0 1 1 -48 0z"
    ]
};
var $d8206b3ab2e65c05$export$fe2d5012d9982673 = {
    prefix: "fas",
    iconName: "record-vinyl",
    icon: [
        512,
        512,
        [],
        "f8d9",
        "M0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm256-96a96 96 0 1 1 0 192 96 96 0 1 1 0-192zm0 224a128 128 0 1 0 0-256 128 128 0 1 0 0 256zm0-96a32 32 0 1 0 0-64 32 32 0 1 0 0 64z"
    ]
};
var $d8206b3ab2e65c05$export$1d1fbac384a76a12 = {
    prefix: "fas",
    iconName: "face-grin-stars",
    icon: [
        512,
        512,
        [
            129321,
            "grin-stars"
        ],
        "f587",
        "M0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm407.4 75.5c5-11.8-7-22.5-19.3-18.7c-39.7 12.2-84.5 19-131.8 19s-92.1-6.8-131.8-19c-12.3-3.8-24.3 6.9-19.3 18.7c25 59.1 83.2 100.5 151.1 100.5s126.2-41.4 151.1-100.5zM160 120c-3.1 0-5.9 1.8-7.2 4.6l-16.6 34.7-38.1 5c-3.1 .4-5.6 2.5-6.6 5.5s-.1 6.2 2.1 8.3l27.9 26.5-7 37.8c-.6 3 .7 6.1 3.2 7.9s5.8 2 8.5 .6L160 232.5l33.8 18.3c2.7 1.5 6 1.3 8.5-.6s3.7-4.9 3.2-7.9l-7-37.8L226.4 178c2.2-2.1 3.1-5.3 2.1-8.3s-3.5-5.1-6.6-5.5l-38.1-5-16.6-34.7c-1.3-2.8-4.1-4.6-7.2-4.6zm192 0c-3.1 0-5.9 1.8-7.2 4.6l-16.6 34.7-38.1 5c-3.1 .4-5.6 2.5-6.6 5.5s-.1 6.2 2.1 8.3l27.9 26.5-7 37.8c-.6 3 .7 6.1 3.2 7.9s5.8 2 8.5 .6L352 232.5l33.8 18.3c2.7 1.5 6 1.3 8.5-.6s3.7-4.9 3.2-7.9l-7-37.8L418.4 178c2.2-2.1 3.1-5.3 2.1-8.3s-3.5-5.1-6.6-5.5l-38.1-5-16.6-34.7c-1.3-2.8-4.1-4.6-7.2-4.6z"
    ]
};
var $d8206b3ab2e65c05$export$64347a5c8c402ef4 = $d8206b3ab2e65c05$export$1d1fbac384a76a12;
var $d8206b3ab2e65c05$export$e74974fac77c468e = {
    prefix: "fas",
    iconName: "bong",
    icon: [
        448,
        512,
        [],
        "f55c",
        "M160 208.5c0 29.1-15.6 53.9-37.2 67.8c-17.2 11.1-31.5 26.1-41.7 43.7H302.9c-10.2-17.6-24.5-32.6-41.7-43.7c-21.6-13.9-37.2-38.7-37.2-67.8V64H160V208.5zM288 64V208.5c0 5.7 3.1 10.9 7.9 14c11.2 7.2 21.5 15.5 30.9 24.8L366.1 208l-7-7c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l24 24 24 24c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0l-7-7-43.3 43.3C374 314.1 384 347.9 384 384c0 39.4-11.9 76.1-32.2 106.5c-9.6 14.4-26.5 21.5-43.8 21.5H76.1c-17.3 0-34.2-7.1-43.8-21.5C11.9 460.1 0 423.4 0 384c0-67.8 35.1-127.3 88.1-161.5c4.8-3.1 7.9-8.3 7.9-14V64C78.3 64 64 49.7 64 32S78.3 0 96 0h16H272h16c17.7 0 32 14.3 32 32s-14.3 32-32 32z"
    ]
};
var $d8206b3ab2e65c05$export$3c8d5c62d76c33b8 = {
    prefix: "fas",
    iconName: "spaghetti-monster-flying",
    icon: [
        640,
        512,
        [
            "pastafarianism"
        ],
        "f67b",
        "M208 64a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zm48 0c0 16.2-6 31.1-16 42.3l15.6 31.2c18.7-6 39.9-9.5 64.4-9.5s45.8 3.5 64.4 9.5L400 106.3C390 95.1 384 80.2 384 64c0-35.3 28.7-64 64-64s64 28.7 64 64s-28.7 64-64 64c-1.7 0-3.4-.1-5.1-.2L427.8 158c21.1 13.6 37.7 30.2 51.4 46.4c7.1 8.3 13.5 16.6 19.3 24l1.4 1.8c6.3 8.1 11.6 14.8 16.7 20.4C527.3 262.3 532.7 264 536 264c2.5 0 4.3-.6 7.1-3.3c3.7-3.5 7.1-8.8 12.5-17.4l.6-.9c4.6-7.4 11-17.6 19.4-25.7c9.7-9.3 22.9-16.7 40.4-16.7c13.3 0 24 10.7 24 24s-10.7 24-24 24c-2.5 0-4.3 .6-7.1 3.3c-3.7 3.5-7.1 8.8-12.5 17.4l-.6 .9c-4.6 7.4-11 17.6-19.4 25.7c-9.7 9.3-22.9 16.7-40.4 16.7c-18.5 0-32.9-8.5-44.3-18.6c-3.1 4-6.6 8.3-10.5 12.7c1.4 4.3 2.8 8.5 4 12.5c.9 3 1.8 5.8 2.6 8.6c3 9.8 5.5 18.2 8.6 25.9c3.9 9.8 7.4 15.4 10.8 18.5c2.6 2.4 5.9 4.3 12.8 4.3c8.7 0 16.9-4.2 33.7-13.2c15-8 35.7-18.8 62.3-18.8c13.3 0 24 10.7 24 24s-10.7 24-24 24c-13.4 0-24.7 5.2-39.7 13.2c-1 .6-2.1 1.1-3.2 1.7C559.9 414 541.4 424 520 424c-18.4 0-33.6-6.1-45.5-17.2c-11.1-10.3-17.9-23.7-22.7-36c-3.6-9-6.7-19.1-9.5-28.5c-16.4 12.3-36.1 23.6-58.9 31.3c3.6 10.8 8.4 23.5 14.4 36.2c7.5 15.9 16.2 30.4 25.8 40.5C433 460.5 441.2 464 448 464c13.3 0 24 10.7 24 24s-10.7 24-24 24c-25.2 0-45-13.5-59.5-28.8c-14.5-15.4-25.7-34.9-34.2-53c-8-17-14.1-33.8-18.3-46.9c-5.2 .4-10.6 .6-16 .6s-10.8-.2-16-.6c-4.2 13-10.3 29.9-18.3 46.9c-8.5 18.1-19.8 37.6-34.2 53C237 498.5 217.2 512 192 512c-13.3 0-24-10.7-24-24s10.7-24 24-24c6.8 0 15-3.5 24.5-13.7c9.5-10.1 18.3-24.6 25.8-40.5c5.9-12.6 10.7-25.4 14.4-36.2c-22.8-7.7-42.5-19-58.9-31.3c-2.9 9.4-6 19.5-9.5 28.5c-4.8 12.2-11.6 25.6-22.7 36C153.6 417.9 138.4 424 120 424c-21.4 0-39.9-10-53.1-17.1l0 0c-1.1-.6-2.2-1.2-3.2-1.7c-15-8-26.3-13.2-39.7-13.2c-13.3 0-24-10.7-24-24s10.7-24 24-24c26.6 0 47.3 10.8 62.3 18.8c16.8 9 25 13.2 33.7 13.2c6.8 0 10.2-1.9 12.8-4.3c3.4-3.2 7-8.8 10.8-18.5c3-7.7 5.6-16.1 8.6-25.9c.8-2.7 1.7-5.6 2.6-8.6c1.2-4 2.6-8.2 4-12.5c-3.9-4.5-7.4-8.8-10.5-12.7C136.9 303.5 122.5 312 104 312c-17.5 0-30.7-7.4-40.4-16.7c-8.4-8.1-14.8-18.3-19.4-25.7l-.6-.9c-5.4-8.6-8.8-13.9-12.5-17.4c-2.8-2.7-4.6-3.3-7.1-3.3c-13.3 0-24-10.7-24-24s10.7-24 24-24c17.5 0 30.7 7.4 40.4 16.7c8.4 8.1 14.8 18.3 19.4 25.7l.6 .9c5.4 8.6 8.8 13.9 12.5 17.4c2.8 2.7 4.6 3.3 7.1 3.3c3.3 0 8.7-1.7 19.4-13.4c5.1-5.6 10.4-12.3 16.7-20.4l1.4-1.8c5.8-7.4 12.2-15.7 19.3-24c13.8-16.2 30.3-32.8 51.4-46.4l-15.1-30.2c-1.7 .1-3.4 .2-5.1 .2c-35.3 0-64-28.7-64-64s28.7-64 64-64s64 28.7 64 64zm208 0a16 16 0 1 0 -32 0 16 16 0 1 0 32 0z"
    ]
};
var $d8206b3ab2e65c05$export$733efdaec97447be = $d8206b3ab2e65c05$export$3c8d5c62d76c33b8;
var $d8206b3ab2e65c05$export$9fe0c42ede2dd003 = {
    prefix: "fas",
    iconName: "arrow-down-up-across-line",
    icon: [
        576,
        512,
        [],
        "e4af",
        "M137.4 502.6c12.5 12.5 32.8 12.5 45.3 0l96-96c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L192 402.7V288H544c17.7 0 32-14.3 32-32s-14.3-32-32-32H448V109.3l41.4 41.4c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3l-96-96c-12.5-12.5-32.8-12.5-45.3 0l-96 96c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0L384 109.3V224H192 128 32c-17.7 0-32 14.3-32 32s14.3 32 32 32h96V402.7L86.6 361.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3l96 96zM128 192h64V64c0-17.7-14.3-32-32-32s-32 14.3-32 32V192zM448 320H384V448c0 17.7 14.3 32 32 32s32-14.3 32-32V320z"
    ]
};
var $d8206b3ab2e65c05$export$faf854a434ce6d0c = {
    prefix: "fas",
    iconName: "spoon",
    icon: [
        512,
        512,
        [
            129348,
            61873,
            "utensil-spoon"
        ],
        "f2e5",
        "M245.8 220.9c-14.5-17.6-21.8-39.2-21.8-60.8C224 80 320 0 416 0c53 0 96 43 96 96c0 96-80 192-160.2 192c-21.6 0-43.2-7.3-60.8-21.8L54.6 502.6c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3L245.8 220.9z"
    ]
};
var $d8206b3ab2e65c05$export$fb7af5d245fb9053 = $d8206b3ab2e65c05$export$faf854a434ce6d0c;
var $d8206b3ab2e65c05$export$8b503c1d76716ddd = {
    prefix: "fas",
    iconName: "jar-wheat",
    icon: [
        320,
        512,
        [],
        "e517",
        "M32 32C32 14.3 46.3 0 64 0H256c17.7 0 32 14.3 32 32s-14.3 32-32 32H64C46.3 64 32 49.7 32 32zM0 160c0-35.3 28.7-64 64-64H256c35.3 0 64 28.7 64 64V448c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V160zm112 0H69.8c-3.2 0-5.8 2.6-5.8 5.8C64 198 90 224 122.2 224H144h32 21.8c32.1 0 58.2-26 58.2-58.2c0-3.2-2.6-5.8-5.8-5.8H208c-19.1 0-36.3 8.4-48 21.7c-11.7-13.3-28.9-21.7-48-21.7zm48 117.7c-11.7-13.3-28.9-21.7-48-21.7H69.8c-3.2 0-5.8 2.6-5.8 5.8C64 294 90 320 122.2 320H144h32 21.8c32.1 0 58.2-26 58.2-58.2c0-3.2-2.6-5.8-5.8-5.8H208c-19.1 0-36.3 8.4-48 21.7zM112 352H69.8c-3.2 0-5.8 2.6-5.8 5.8C64 390 90 416 122.2 416H144v32c0 8.8 7.2 16 16 16s16-7.2 16-16V416h21.8c32.1 0 58.2-26 58.2-58.2c0-3.2-2.6-5.8-5.8-5.8H208c-19.1 0-36.3 8.4-48 21.7c-11.7-13.3-28.9-21.7-48-21.7z"
    ]
};
var $d8206b3ab2e65c05$export$dc2cce064a1e70bb = {
    prefix: "fas",
    iconName: "envelopes-bulk",
    icon: [
        640,
        512,
        [
            "mail-bulk"
        ],
        "f674",
        "M128 0C110.3 0 96 14.3 96 32V224h96V192c0-35.3 28.7-64 64-64H480V32c0-17.7-14.3-32-32-32H128zM256 160c-17.7 0-32 14.3-32 32v32h96c35.3 0 64 28.7 64 64V416H576c17.7 0 32-14.3 32-32V192c0-17.7-14.3-32-32-32H256zm240 64h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H496c-8.8 0-16-7.2-16-16V240c0-8.8 7.2-16 16-16zM64 256c-17.7 0-32 14.3-32 32v13L187.1 415.9c1.4 1 3.1 1.6 4.9 1.6s3.5-.6 4.9-1.6L352 301V288c0-17.7-14.3-32-32-32H64zm288 84.8L216 441.6c-6.9 5.1-15.3 7.9-24 7.9s-17-2.8-24-7.9L32 340.8V480c0 17.7 14.3 32 32 32H320c17.7 0 32-14.3 32-32V340.8z"
    ]
};
var $d8206b3ab2e65c05$export$dd24f40c5337e2e1 = $d8206b3ab2e65c05$export$dc2cce064a1e70bb;
var $d8206b3ab2e65c05$export$61fa9809253098e5 = {
    prefix: "fas",
    iconName: "file-circle-exclamation",
    icon: [
        576,
        512,
        [],
        "e4eb",
        "M0 64C0 28.7 28.7 0 64 0H224V128c0 17.7 14.3 32 32 32H384v38.6C310.1 219.5 256 287.4 256 368c0 59.1 29.1 111.3 73.7 143.3c-3.2 .5-6.4 .7-9.7 .7H64c-35.3 0-64-28.7-64-64V64zm384 64H256V0L384 128zm48 96a144 144 0 1 1 0 288 144 144 0 1 1 0-288zm0 240a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm0-192c-8.8 0-16 7.2-16 16v80c0 8.8 7.2 16 16 16s16-7.2 16-16V288c0-8.8-7.2-16-16-16z"
    ]
};
var $d8206b3ab2e65c05$export$bf5674308c61894f = {
    prefix: "fas",
    iconName: "circle-h",
    icon: [
        512,
        512,
        [
            9405,
            "hospital-symbol"
        ],
        "f47e",
        "M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM368 152V256 360c0 13.3-10.7 24-24 24s-24-10.7-24-24V280H192l0 80c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-208c0-13.3 10.7-24 24-24s24 10.7 24 24v80H320V152c0-13.3 10.7-24 24-24s24 10.7 24 24z"
    ]
};
var $d8206b3ab2e65c05$export$c8a3c78d99c23fed = $d8206b3ab2e65c05$export$bf5674308c61894f;
var $d8206b3ab2e65c05$export$e1611f373a10a98c = {
    prefix: "fas",
    iconName: "pager",
    icon: [
        512,
        512,
        [
            128223
        ],
        "f815",
        "M0 128C0 92.7 28.7 64 64 64H448c35.3 0 64 28.7 64 64V384c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V128zm64 32v64c0 17.7 14.3 32 32 32H416c17.7 0 32-14.3 32-32V160c0-17.7-14.3-32-32-32H96c-17.7 0-32 14.3-32 32zM80 320c-13.3 0-24 10.7-24 24s10.7 24 24 24h56c13.3 0 24-10.7 24-24s-10.7-24-24-24H80zm136 0c-13.3 0-24 10.7-24 24s10.7 24 24 24h48c13.3 0 24-10.7 24-24s-10.7-24-24-24H216z"
    ]
};
var $d8206b3ab2e65c05$export$853fd1561789e3bb = {
    prefix: "fas",
    iconName: "address-book",
    icon: [
        512,
        512,
        [
            62138,
            "contact-book"
        ],
        "f2b9",
        "M96 0C60.7 0 32 28.7 32 64V448c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V64c0-35.3-28.7-64-64-64H96zM208 288h64c44.2 0 80 35.8 80 80c0 8.8-7.2 16-16 16H144c-8.8 0-16-7.2-16-16c0-44.2 35.8-80 80-80zm-32-96a64 64 0 1 1 128 0 64 64 0 1 1 -128 0zM512 80c0-8.8-7.2-16-16-16s-16 7.2-16 16v64c0 8.8 7.2 16 16 16s16-7.2 16-16V80zM496 192c-8.8 0-16 7.2-16 16v64c0 8.8 7.2 16 16 16s16-7.2 16-16V208c0-8.8-7.2-16-16-16zm16 144c0-8.8-7.2-16-16-16s-16 7.2-16 16v64c0 8.8 7.2 16 16 16s16-7.2 16-16V336z"
    ]
};
var $d8206b3ab2e65c05$export$594b5a5d4d2e156b = $d8206b3ab2e65c05$export$853fd1561789e3bb;
var $d8206b3ab2e65c05$export$eff51ea25b4de135 = {
    prefix: "fas",
    iconName: "strikethrough",
    icon: [
        512,
        512,
        [],
        "f0cc",
        "M161.3 144c3.2-17.2 14-30.1 33.7-38.6c21.1-9 51.8-12.3 88.6-6.5c11.9 1.9 48.8 9.1 60.1 12c17.1 4.5 34.6-5.6 39.2-22.7s-5.6-34.6-22.7-39.2c-14.3-3.8-53.6-11.4-66.6-13.4c-44.7-7-88.3-4.2-123.7 10.9c-36.5 15.6-64.4 44.8-71.8 87.3c-.1 .6-.2 1.1-.2 1.7c-2.8 23.9 .5 45.6 10.1 64.6c4.5 9 10.2 16.9 16.7 23.9H32c-17.7 0-32 14.3-32 32s14.3 32 32 32H480c17.7 0 32-14.3 32-32s-14.3-32-32-32H270.1c-.1 0-.3-.1-.4-.1l-1.1-.3c-36-10.8-65.2-19.6-85.2-33.1c-9.3-6.3-15-12.6-18.2-19.1c-3.1-6.1-5.2-14.6-3.8-27.4zM348.9 337.2c2.7 6.5 4.4 15.8 1.9 30.1c-3 17.6-13.8 30.8-33.9 39.4c-21.1 9-51.7 12.3-88.5 6.5c-18-2.9-49.1-13.5-74.4-22.1c-5.6-1.9-11-3.7-15.9-5.4c-16.8-5.6-34.9 3.5-40.5 20.3s3.5 34.9 20.3 40.5c3.6 1.2 7.9 2.7 12.7 4.3l0 0 0 0c24.9 8.5 63.6 21.7 87.6 25.6l0 0 .2 0c44.7 7 88.3 4.2 123.7-10.9c36.5-15.6 64.4-44.8 71.8-87.3c3.6-21 2.7-40.4-3.1-58.1H335.1c7 5.6 11.4 11.2 13.9 17.2z"
    ]
};
var $d8206b3ab2e65c05$export$3f85413cb67e7f67 = {
    prefix: "fas",
    iconName: "k",
    icon: [
        320,
        512,
        [
            107
        ],
        "4b",
        "M311 86.3c12.3-12.7 12-32.9-.7-45.2s-32.9-12-45.2 .7l-155.2 160L64 249V64c0-17.7-14.3-32-32-32S0 46.3 0 64V328 448c0 17.7 14.3 32 32 32s32-14.3 32-32V341l64.7-66.7 133 192c10.1 14.5 30 18.1 44.5 8.1s18.1-30 8.1-44.5L174.1 227.4 311 86.3z"
    ]
};
var $d8206b3ab2e65c05$export$f4d472cf47be4096 = {
    prefix: "fas",
    iconName: "landmark-flag",
    icon: [
        512,
        512,
        [],
        "e51c",
        "M272 0h80c8.8 0 16 7.2 16 16V80c0 8.8-7.2 16-16 16H272v32H464c17.7 0 32 14.3 32 32s-14.3 32-32 32H48c-17.7 0-32-14.3-32-32s14.3-32 32-32H240V16c0-8.8 7.2-16 16-16h16zM64 224h64V416h40V224h64V416h48V224h64V416h40V224h64V420.3c.6 .3 1.2 .7 1.8 1.1l48 32c11.7 7.8 17 22.4 12.9 35.9S494.1 512 480 512H32c-14.1 0-26.5-9.2-30.6-22.7s1.1-28.1 12.9-35.9l48-32c.6-.4 1.2-.7 1.8-1.1V224z"
    ]
};
var $d8206b3ab2e65c05$export$c72de95adaca18b8 = {
    prefix: "fas",
    iconName: "pencil",
    icon: [
        512,
        512,
        [
            9999,
            61504,
            "pencil-alt"
        ],
        "f303",
        "M410.3 231l11.3-11.3-33.9-33.9-62.1-62.1L291.7 89.8l-11.3 11.3-22.6 22.6L58.6 322.9c-10.4 10.4-18 23.3-22.2 37.4L1 480.7c-2.5 8.4-.2 17.5 6.1 23.7s15.3 8.5 23.7 6.1l120.3-35.4c14.1-4.2 27-11.8 37.4-22.2L387.7 253.7 410.3 231zM160 399.4l-9.1 22.7c-4 3.1-8.5 5.4-13.3 6.9L59.4 452l23-78.1c1.4-4.9 3.8-9.4 6.9-13.3l22.7-9.1v32c0 8.8 7.2 16 16 16h32zM362.7 18.7L348.3 33.2 325.7 55.8 314.3 67.1l33.9 33.9 62.1 62.1 33.9 33.9 11.3-11.3 22.6-22.6 14.5-14.5c25-25 25-65.5 0-90.5L453.3 18.7c-25-25-65.5-25-90.5 0zm-47.4 168l-144 144c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6l144-144c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6z"
    ]
};
var $d8206b3ab2e65c05$export$8210adc172262df = $d8206b3ab2e65c05$export$c72de95adaca18b8;
var $d8206b3ab2e65c05$export$ae65f96ea7a4078d = {
    prefix: "fas",
    iconName: "backward",
    icon: [
        512,
        512,
        [
            9194
        ],
        "f04a",
        "M459.5 440.6c9.5 7.9 22.8 9.7 34.1 4.4s18.4-16.6 18.4-29V96c0-12.4-7.2-23.7-18.4-29s-24.5-3.6-34.1 4.4L288 214.3V256v41.7L459.5 440.6zM256 352V256 128 96c0-12.4-7.2-23.7-18.4-29s-24.5-3.6-34.1 4.4l-192 160C4.2 237.5 0 246.5 0 256s4.2 18.5 11.5 24.6l192 160c9.5 7.9 22.8 9.7 34.1 4.4s18.4-16.6 18.4-29V352z"
    ]
};
var $d8206b3ab2e65c05$export$f1011352b01c1c0 = {
    prefix: "fas",
    iconName: "caret-right",
    icon: [
        256,
        512,
        [],
        "f0da",
        "M246.6 278.6c12.5-12.5 12.5-32.8 0-45.3l-128-128c-9.2-9.2-22.9-11.9-34.9-6.9s-19.8 16.6-19.8 29.6l0 256c0 12.9 7.8 24.6 19.8 29.6s25.7 2.2 34.9-6.9l128-128z"
    ]
};
var $d8206b3ab2e65c05$export$932912e74adb8939 = {
    prefix: "fas",
    iconName: "comments",
    icon: [
        640,
        512,
        [
            128490,
            61670
        ],
        "f086",
        "M208 352c114.9 0 208-78.8 208-176S322.9 0 208 0S0 78.8 0 176c0 38.6 14.7 74.3 39.6 103.4c-3.5 9.4-8.7 17.7-14.2 24.7c-4.8 6.2-9.7 11-13.3 14.3c-1.8 1.6-3.3 2.9-4.3 3.7c-.5 .4-.9 .7-1.1 .8l-.2 .2 0 0 0 0C1 327.2-1.4 334.4 .8 340.9S9.1 352 16 352c21.8 0 43.8-5.6 62.1-12.5c9.2-3.5 17.8-7.4 25.3-11.4C134.1 343.3 169.8 352 208 352zM448 176c0 112.3-99.1 196.9-216.5 207C255.8 457.4 336.4 512 432 512c38.2 0 73.9-8.7 104.7-23.9c7.5 4 16 7.9 25.2 11.4c18.3 6.9 40.3 12.5 62.1 12.5c6.9 0 13.1-4.5 15.2-11.1c2.1-6.6-.2-13.8-5.8-17.9l0 0 0 0-.2-.2c-.2-.2-.6-.4-1.1-.8c-1-.8-2.5-2-4.3-3.7c-3.6-3.3-8.5-8.1-13.3-14.3c-5.5-7-10.7-15.4-14.2-24.7c24.9-29 39.6-64.7 39.6-103.4c0-92.8-84.9-168.9-192.6-175.5c.4 5.1 .6 10.3 .6 15.5z"
    ]
};
var $d8206b3ab2e65c05$export$6f95f90dd1f6d86b = {
    prefix: "fas",
    iconName: "paste",
    icon: [
        512,
        512,
        [
            "file-clipboard"
        ],
        "f0ea",
        "M160 0c-23.7 0-44.4 12.9-55.4 32H48C21.5 32 0 53.5 0 80V400c0 26.5 21.5 48 48 48H192V176c0-44.2 35.8-80 80-80h48V80c0-26.5-21.5-48-48-48H215.4C204.4 12.9 183.7 0 160 0zM272 128c-26.5 0-48 21.5-48 48V448v16c0 26.5 21.5 48 48 48H464c26.5 0 48-21.5 48-48V256H416c-17.7 0-32-14.3-32-32V128H320 272zM160 40a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm256 88v96h96l-96-96z"
    ]
};
var $d8206b3ab2e65c05$export$ca3229c47de163fa = $d8206b3ab2e65c05$export$6f95f90dd1f6d86b;
var $d8206b3ab2e65c05$export$37576dfab037d8bf = {
    prefix: "fas",
    iconName: "code-pull-request",
    icon: [
        512,
        512,
        [],
        "e13c",
        "M305.8 2.1C314.4 5.9 320 14.5 320 24V64h16c70.7 0 128 57.3 128 128V358.7c28.3 12.3 48 40.5 48 73.3c0 44.2-35.8 80-80 80s-80-35.8-80-80c0-32.8 19.7-61 48-73.3V192c0-35.3-28.7-64-64-64H320v40c0 9.5-5.6 18.1-14.2 21.9s-18.8 2.3-25.8-4.1l-80-72c-5.1-4.6-7.9-11-7.9-17.8s2.9-13.3 7.9-17.8l80-72c7-6.3 17.2-7.9 25.8-4.1zM104 80A24 24 0 1 0 56 80a24 24 0 1 0 48 0zm8 73.3V358.7c28.3 12.3 48 40.5 48 73.3c0 44.2-35.8 80-80 80s-80-35.8-80-80c0-32.8 19.7-61 48-73.3V153.3C19.7 141 0 112.8 0 80C0 35.8 35.8 0 80 0s80 35.8 80 80c0 32.8-19.7 61-48 73.3zM104 432a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zm328 24a24 24 0 1 0 0-48 24 24 0 1 0 0 48z"
    ]
};
var $d8206b3ab2e65c05$export$2c5a9d8548d8810e = {
    prefix: "fas",
    iconName: "clipboard-list",
    icon: [
        384,
        512,
        [],
        "f46d",
        "M192 0c-41.8 0-77.4 26.7-90.5 64H64C28.7 64 0 92.7 0 128V448c0 35.3 28.7 64 64 64H320c35.3 0 64-28.7 64-64V128c0-35.3-28.7-64-64-64H282.5C269.4 26.7 233.8 0 192 0zm0 64a32 32 0 1 1 0 64 32 32 0 1 1 0-64zM72 272a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zm104-16H304c8.8 0 16 7.2 16 16s-7.2 16-16 16H176c-8.8 0-16-7.2-16-16s7.2-16 16-16zM72 368a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zm88 0c0-8.8 7.2-16 16-16H304c8.8 0 16 7.2 16 16s-7.2 16-16 16H176c-8.8 0-16-7.2-16-16z"
    ]
};
var $d8206b3ab2e65c05$export$37396c36c76937bc = {
    prefix: "fas",
    iconName: "truck-ramp-box",
    icon: [
        640,
        512,
        [
            "truck-loading"
        ],
        "f4de",
        "M640 0V400c0 61.9-50.1 112-112 112c-61 0-110.5-48.7-112-109.3L48.4 502.9c-17.1 4.6-34.6-5.4-39.3-22.5s5.4-34.6 22.5-39.3L352 353.8V64c0-35.3 28.7-64 64-64H640zM576 400a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zM23.1 207.7c-4.6-17.1 5.6-34.6 22.6-39.2l46.4-12.4 20.7 77.3c2.3 8.5 11.1 13.6 19.6 11.3l30.9-8.3c8.5-2.3 13.6-11.1 11.3-19.6l-20.7-77.3 46.4-12.4c17.1-4.6 34.6 5.6 39.2 22.6l41.4 154.5c4.6 17.1-5.6 34.6-22.6 39.2L103.7 384.9c-17.1 4.6-34.6-5.6-39.2-22.6L23.1 207.7z"
    ]
};
var $d8206b3ab2e65c05$export$f00c152db7d44638 = $d8206b3ab2e65c05$export$37396c36c76937bc;
var $d8206b3ab2e65c05$export$76de2a120043c9f8 = {
    prefix: "fas",
    iconName: "user-check",
    icon: [
        640,
        512,
        [],
        "f4fc",
        "M96 128a128 128 0 1 1 256 0A128 128 0 1 1 96 128zM0 482.3C0 383.8 79.8 304 178.3 304h91.4C368.2 304 448 383.8 448 482.3c0 16.4-13.3 29.7-29.7 29.7H29.7C13.3 512 0 498.7 0 482.3zM625 177L497 305c-9.4 9.4-24.6 9.4-33.9 0l-64-64c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l47 47L591 143c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9z"
    ]
};
var $d8206b3ab2e65c05$export$a56b2b0a1073620c = {
    prefix: "fas",
    iconName: "vial-virus",
    icon: [
        512,
        512,
        [],
        "e597",
        "M32 32C14.3 32 0 46.3 0 64S14.3 96 32 96V384c0 53 43 96 96 96c28.6 0 54.2-12.5 71.8-32.3c.1-14.2 5.6-28.3 16.4-39.1c.2-.2 .1-.6-.2-.6c-30.9 0-56-25.1-56-56s25.1-56 56-56c.3 0 .4-.4 .2-.6c-21.9-21.9-21.9-57.3 0-79.2c2.4-2.4 5-4.6 7.8-6.5V96c17.7 0 32-14.3 32-32s-14.3-32-32-32H160 96 32zM96 192V96h64v96H96zM216 376c28.8 0 43.2 34.8 22.9 55.2c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0c20.4-20.4 55.2-5.9 55.2 22.9c0 13.3 10.7 24 24 24s24-10.7 24-24c0-28.8 34.8-43.2 55.2-22.9c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9C444.8 410.8 459.2 376 488 376c13.3 0 24-10.7 24-24s-10.7-24-24-24c-28.8 0-43.2-34.8-22.9-55.2c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0C410.8 259.2 376 244.8 376 216c0-13.3-10.7-24-24-24s-24 10.7-24 24c0 28.8-34.8 43.2-55.2 22.9c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9c20.4 20.4 5.9 55.2-22.9 55.2c-13.3 0-24 10.7-24 24s10.7 24 24 24zm104-88a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm40 96a24 24 0 1 1 48 0 24 24 0 1 1 -48 0z"
    ]
};
var $d8206b3ab2e65c05$export$57f2bcd070bff91a = {
    prefix: "fas",
    iconName: "sheet-plastic",
    icon: [
        384,
        512,
        [],
        "e571",
        "M0 448c0 35.3 28.7 64 64 64H224V384c0-17.7 14.3-32 32-32H384V64c0-35.3-28.7-64-64-64H64C28.7 0 0 28.7 0 64V448zM171.3 75.3l-96 96c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6l96-96c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6zm96 32l-160 160c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6l160-160c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6zM384 384H256V512L384 384z"
    ]
};
var $d8206b3ab2e65c05$export$890d5e011054935a = {
    prefix: "fas",
    iconName: "blog",
    icon: [
        512,
        512,
        [],
        "f781",
        "M192 32c0 17.7 14.3 32 32 32c123.7 0 224 100.3 224 224c0 17.7 14.3 32 32 32s32-14.3 32-32C512 128.9 383.1 0 224 0c-17.7 0-32 14.3-32 32zm0 96c0 17.7 14.3 32 32 32c70.7 0 128 57.3 128 128c0 17.7 14.3 32 32 32s32-14.3 32-32c0-106-86-192-192-192c-17.7 0-32 14.3-32 32zM96 144c0-26.5-21.5-48-48-48S0 117.5 0 144V368c0 79.5 64.5 144 144 144s144-64.5 144-144s-64.5-144-144-144H128v96h16c26.5 0 48 21.5 48 48s-21.5 48-48 48s-48-21.5-48-48V144z"
    ]
};
var $d8206b3ab2e65c05$export$a9174995732e03c5 = {
    prefix: "fas",
    iconName: "user-ninja",
    icon: [
        448,
        512,
        [
            129399
        ],
        "f504",
        "M224 256c-57.2 0-105.6-37.5-122-89.3c-1.1 1.3-2.2 2.6-3.5 3.8c-15.8 15.8-38.8 20.7-53.6 22.1c-8.1 .8-14.6-5.7-13.8-13.8c1.4-14.7 6.3-37.8 22.1-53.6c5.8-5.8 12.6-10.1 19.6-13.4c-7-3.2-13.8-7.6-19.6-13.4C37.4 82.7 32.6 59.7 31.1 44.9c-.8-8.1 5.7-14.6 13.8-13.8c14.7 1.4 37.8 6.3 53.6 22.1c4.8 4.8 8.7 10.4 11.7 16.1C131.4 28.2 174.4 0 224 0c70.7 0 128 57.3 128 128s-57.3 128-128 128zM0 482.3C0 399.5 56.4 330 132.8 309.9c6-1.6 12.2 .9 15.9 5.8l62.5 83.3c6.4 8.5 19.2 8.5 25.6 0l62.5-83.3c3.7-4.9 9.9-7.4 15.9-5.8C391.6 330 448 399.5 448 482.3c0 16.4-13.3 29.7-29.7 29.7H29.7C13.3 512 0 498.7 0 482.3zM160 96c-8.8 0-16 7.2-16 16s7.2 16 16 16H288c8.8 0 16-7.2 16-16s-7.2-16-16-16H160z"
    ]
};
var $d8206b3ab2e65c05$export$5709329dd2b70bdc = {
    prefix: "fas",
    iconName: "person-arrow-up-from-line",
    icon: [
        640,
        512,
        [],
        "e539",
        "M192 96a48 48 0 1 0 0-96 48 48 0 1 0 0 96zm-8 352V352h16v96H184zm-64 0H32c-17.7 0-32 14.3-32 32s14.3 32 32 32H152h80H608c17.7 0 32-14.3 32-32s-14.3-32-32-32H264V256.9l28.6 47.5c9.1 15.1 28.8 20 43.9 10.9s20-28.8 10.9-43.9l-58.3-97c-17.4-28.9-48.6-46.6-82.3-46.6H177.1c-33.7 0-64.9 17.7-82.3 46.6l-58.3 97c-9.1 15.1-4.2 34.8 10.9 43.9s34.8 4.2 43.9-10.9L120 256.9V448zM598.6 121.4l-80-80c-12.5-12.5-32.8-12.5-45.3 0l-80 80c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0L464 141.3 464 384c0 17.7 14.3 32 32 32s32-14.3 32-32V141.3l25.4 25.4c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3z"
    ]
};
var $d8206b3ab2e65c05$export$4e3fe5b42a6cd494 = {
    prefix: "fas",
    iconName: "scroll-torah",
    icon: [
        640,
        512,
        [
            "torah"
        ],
        "f6a0",
        "M96 480V32C96 14.3 74.5 0 48 0S0 14.3 0 32V480c0 17.7 21.5 32 48 32s48-14.3 48-32zM512 32H128V480H512V32zM592 0c-26.5 0-48 14.3-48 32V480c0 17.7 21.5 32 48 32s48-14.3 48-32V32c0-17.7-21.5-32-48-32zM196 313.7c0-3.2 .9-6.4 2.5-9.2L226.7 256l-28.3-48.5c-1.6-2.8-2.5-6-2.5-9.2c0-10.1 8.2-18.3 18.3-18.3H271l31.4-53.9c3.6-6.3 10.3-10.1 17.6-10.1s13.9 3.8 17.6 10.1L369 180h56.7c10.1 0 18.3 8.2 18.3 18.3c0 3.2-.9 6.4-2.5 9.2L413.3 256l28.3 48.5c1.6 2.8 2.5 6 2.5 9.2c0 10.1-8.2 18.3-18.3 18.3H369l-31.4 53.9c-3.6 6.3-10.3 10.1-17.6 10.1s-13.9-3.8-17.6-10.1L271 332H214.3c-10.1 0-18.3-8.2-18.3-18.3zm124 54.7L341.2 332H298.8L320 368.4zM254.5 256l30.3 52h70.4l30.3-52-30.3-52H284.8l-30.3 52zm144.9 23.8L383 308h32.8l-16.4-28.2zM415.8 204H383l16.4 28.2L415.8 204zM320 143.6L298.8 180h42.4L320 143.6zM224.2 204l16.4 28.2L257 204H224.2zM257 308l-16.4-28.2L224.2 308H257z"
    ]
};
var $d8206b3ab2e65c05$export$54d07baabd8c2acb = $d8206b3ab2e65c05$export$4e3fe5b42a6cd494;
var $d8206b3ab2e65c05$export$3e1327487ce53231 = {
    prefix: "fas",
    iconName: "broom-ball",
    icon: [
        576,
        512,
        [
            "quidditch",
            "quidditch-broom-ball"
        ],
        "f458",
        "M566.6 9.4c12.5 12.5 12.5 32.8 0 45.3l-192 192 34.7 34.7c4.2 4.2 6.6 10 6.6 16c0 12.5-10.1 22.6-22.6 22.6H364.3L256 211.7V182.6c0-12.5 10.1-22.6 22.6-22.6c6 0 11.8 2.4 16 6.6l34.7 34.7 192-192c12.5-12.5 32.8-12.5 45.3 0zm-344 225.5L341.1 353.4c3.7 42.7-11.7 85.2-42.3 115.8C271.4 496.6 234.2 512 195.5 512L22.1 512C9.9 512 0 502.1 0 489.9c0-6.3 2.7-12.3 7.3-16.5L133.7 359.7c4.2-3.7-.4-10.4-5.4-7.9L77.2 377.4c-6.1 3-13.2-1.4-13.2-8.2c0-31.5 12.5-61.7 34.8-84l8-8c30.6-30.6 73.1-45.9 115.8-42.3zM464 352a80 80 0 1 1 0 160 80 80 0 1 1 0-160z"
    ]
};
var $d8206b3ab2e65c05$export$c00c446e6db1605f = $d8206b3ab2e65c05$export$3e1327487ce53231;
var $d8206b3ab2e65c05$export$791bfe29b97b4d42 = $d8206b3ab2e65c05$export$3e1327487ce53231;
var $d8206b3ab2e65c05$export$d20aaceb882ca545 = {
    prefix: "fas",
    iconName: "toggle-off",
    icon: [
        576,
        512,
        [],
        "f204",
        "M384 128c70.7 0 128 57.3 128 128s-57.3 128-128 128H192c-70.7 0-128-57.3-128-128s57.3-128 128-128H384zM576 256c0-106-86-192-192-192H192C86 64 0 150 0 256S86 448 192 448H384c106 0 192-86 192-192zM192 352a96 96 0 1 0 0-192 96 96 0 1 0 0 192z"
    ]
};
var $d8206b3ab2e65c05$export$2a0fcb66c3d79d00 = {
    prefix: "fas",
    iconName: "box-archive",
    icon: [
        512,
        512,
        [
            "archive"
        ],
        "f187",
        "M32 32H480c17.7 0 32 14.3 32 32V96c0 17.7-14.3 32-32 32H32C14.3 128 0 113.7 0 96V64C0 46.3 14.3 32 32 32zm0 128H480V416c0 35.3-28.7 64-64 64H96c-35.3 0-64-28.7-64-64V160zm128 80c0 8.8 7.2 16 16 16H336c8.8 0 16-7.2 16-16s-7.2-16-16-16H176c-8.8 0-16 7.2-16 16z"
    ]
};
var $d8206b3ab2e65c05$export$26b3e1c454273f34 = $d8206b3ab2e65c05$export$2a0fcb66c3d79d00;
var $d8206b3ab2e65c05$export$bac321083217fd4 = {
    prefix: "fas",
    iconName: "person-drowning",
    icon: [
        576,
        512,
        [],
        "e545",
        "M192 64c0-17.7-14.3-32-32-32s-32 14.3-32 32V96.2c0 54.1 23.5 104 62.2 138.3l-21 146.7c7.8 2.1 15.5 3.3 22.8 3.3c21.1 0 42-8.5 59.2-20.3c22.1-15.5 51.6-15.5 73.7 0c12.4 8.5 26.1 14.8 39.7 18l17.7-97.6c10.7-1.2 21.3-3.1 31.9-5.5l105-23.9c17.2-3.9 28-21.1 24.1-38.3s-21.1-28-38.3-24.1L400 216.6c-41 9.3-83.7 7.5-123.7-5.2c-50.2-16-84.3-62.6-84.3-115.3V64zM320 192a64 64 0 1 0 0-128 64 64 0 1 0 0 128zM306.5 389.9c-11.1-7.9-25.9-7.9-37 0C247 405.4 219.5 416 192 416c-26.9 0-55.3-10.8-77.4-26.1l0 0c-11.9-8.5-28.1-7.8-39.2 1.7c-14.4 11.9-32.5 21-50.6 25.2c-17.2 4-27.9 21.2-23.9 38.4s21.2 27.9 38.4 23.9c24.5-5.7 44.9-16.5 58.2-25C126.5 469.7 159 480 192 480c31.9 0 60.6-9.9 80.4-18.9c5.8-2.7 11.1-5.3 15.6-7.7c4.5 2.4 9.7 5.1 15.6 7.7c19.8 9 48.5 18.9 80.4 18.9c33 0 65.5-10.3 94.5-25.8c13.4 8.4 33.7 19.3 58.2 25c17.2 4 34.4-6.7 38.4-23.9s-6.7-34.4-23.9-38.4c-18.1-4.2-36.2-13.3-50.6-25.2c-11.1-9.4-27.3-10.1-39.2-1.7l0 0C439.4 405.2 410.9 416 384 416c-27.5 0-55-10.6-77.5-26.1z"
    ]
};
var $d8206b3ab2e65c05$export$6cc91ce23eb3fae1 = {
    prefix: "fas",
    iconName: "arrow-down-9-1",
    icon: [
        576,
        512,
        [
            "sort-numeric-desc",
            "sort-numeric-down-alt"
        ],
        "f886",
        "M160 480c9 0 17.5-3.8 23.6-10.4l88-96c11.9-13 11.1-33.3-2-45.2s-33.3-11.1-45.2 2L192 365.7V64c0-17.7-14.3-32-32-32s-32 14.3-32 32V365.7L95.6 330.4c-11.9-13-32.2-13.9-45.2-2s-13.9 32.2-2 45.2l88 96C142.5 476.2 151 480 160 480zM450.7 294c-8.3-6-19.1-7.7-28.8-4.4l-48 16c-16.8 5.6-25.8 23.7-20.2 40.5s23.7 25.8 40.5 20.2l5.9-2V416H384c-17.7 0-32 14.3-32 32s14.3 32 32 32h48 48c17.7 0 32-14.3 32-32s-14.3-32-32-32H464V320c0-10.3-4.9-19.9-13.3-26zM418.3 91a32 32 0 1 1 27.4 57.9A32 32 0 1 1 418.3 91zM405.1 203.8l-6.8 9.2c-10.5 14.2-7.5 34.2 6.7 44.8s34.2 7.5 44.8-6.7l48.8-65.8c14-18.9 21.5-41.7 21.5-65.2c0-48.6-39.4-88-88-88s-88 39.4-88 88c0 39.2 25.6 72.4 61.1 83.8z"
    ]
};
var $d8206b3ab2e65c05$export$99f058110e2c82a8 = $d8206b3ab2e65c05$export$6cc91ce23eb3fae1;
var $d8206b3ab2e65c05$export$857385fda7a5a98e = $d8206b3ab2e65c05$export$6cc91ce23eb3fae1;
var $d8206b3ab2e65c05$export$8eee2c17ff89e724 = {
    prefix: "fas",
    iconName: "face-grin-tongue-squint",
    icon: [
        512,
        512,
        [
            128541,
            "grin-tongue-squint"
        ],
        "f58a",
        "M0 256C0 368.9 73.1 464.7 174.5 498.8C165.3 484 160 466.6 160 448V400.7c-24-17.5-43.1-41.4-54.8-69.2c-5-11.8 7-22.5 19.3-18.7c39.7 12.2 84.5 19 131.8 19s92.1-6.8 131.8-19c12.3-3.8 24.3 6.9 19.3 18.7c-11.8 28-31.1 52-55.4 69.6V448c0 18.6-5.3 36-14.5 50.8C438.9 464.7 512 368.9 512 256C512 114.6 397.4 0 256 0S0 114.6 0 256zM116 141.1c0-9 9.6-14.7 17.5-10.5l89.9 47.9c10.7 5.7 10.7 21.1 0 26.8l-89.9 47.9c-7.9 4.2-17.5-1.5-17.5-10.5c0-2.8 1-5.5 2.8-7.6l36-43.2-36-43.2c-1.8-2.1-2.8-4.8-2.8-7.6zm262.5-10.5c7.9-4.2 17.5 1.5 17.5 10.5c0 2.8-1 5.5-2.8 7.6l-36 43.2 36 43.2c1.8 2.1 2.8 4.8 2.8 7.6c0 9-9.6 14.7-17.5 10.5l-89.9-47.9c-10.7-5.7-10.7-21.1 0-26.8l89.9-47.9zM320 448V402.6c0-14.7-11.9-26.6-26.6-26.6h-2c-11.3 0-21.1 7.9-23.6 18.9c-2.8 12.6-20.8 12.6-23.6 0c-2.5-11.1-12.3-18.9-23.6-18.9h-2c-14.7 0-26.6 11.9-26.6 26.6V448c0 35.3 28.7 64 64 64s64-28.7 64-64z"
    ]
};
var $d8206b3ab2e65c05$export$4edf34c3def09a31 = $d8206b3ab2e65c05$export$8eee2c17ff89e724;
var $d8206b3ab2e65c05$export$4952c502f544cf85 = {
    prefix: "fas",
    iconName: "spray-can",
    icon: [
        512,
        512,
        [],
        "f5bd",
        "M128 0h64c17.7 0 32 14.3 32 32v96H96V32c0-17.7 14.3-32 32-32zM0 256c0-53 43-96 96-96H224c53 0 96 43 96 96V464c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V256zm240 80A80 80 0 1 0 80 336a80 80 0 1 0 160 0zM256 64a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zM384 32a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm64 32a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm32 64a32 32 0 1 1 0 64 32 32 0 1 1 0-64zM448 256a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zM384 128a32 32 0 1 1 0 64 32 32 0 1 1 0-64z"
    ]
};
var $d8206b3ab2e65c05$export$24b8a0147653649a = {
    prefix: "fas",
    iconName: "truck-monster",
    icon: [
        640,
        512,
        [],
        "f63b",
        "M288 64v64H416L368 64H288zM419.2 25.6L496 128h80c17.7 0 32 14.3 32 32v64c17.7 0 32 14.3 32 32s-14.3 32-32 32c-29.2-38.9-75.7-64-128-64s-98.8 25.1-128 64H288c-29.2-38.9-75.7-64-128-64s-98.8 25.1-128 64c-17.7 0-32-14.3-32-32s14.3-32 32-32V160c0-17.7 14.3-32 32-32H224V48c0-26.5 21.5-48 48-48h96c20.1 0 39.1 9.5 51.2 25.6zM152 256h16c12.1 0 22.1 8.9 23.8 20.6c7.6 2.2 14.9 5.3 21.7 9c9.4-7 22.8-6.3 31.3 2.3l11.3 11.3c8.6 8.6 9.3 21.9 2.3 31.3c3.7 6.8 6.8 14.1 9 21.7c11.6 1.7 20.6 11.7 20.6 23.8v16c0 12.1-8.9 22.1-20.6 23.8c-2.2 7.6-5.3 14.9-9 21.7c7 9.4 6.3 22.8-2.3 31.3l-11.3 11.3c-8.6 8.6-21.9 9.3-31.3 2.2c-6.8 3.7-14.1 6.8-21.7 9C190.1 503.1 180.1 512 168 512H152c-12.1 0-22.1-8.9-23.8-20.6c-7.6-2.2-14.9-5.3-21.7-9c-9.4 7.1-22.8 6.3-31.3-2.2L63.8 468.9c-8.6-8.6-9.3-21.9-2.3-31.3c-3.7-6.9-6.8-14.1-9-21.8C40.9 414.1 32 404.1 32 392V376c0-12.1 8.9-22.1 20.6-23.8c2.2-7.6 5.3-14.9 9-21.8c-7-9.4-6.3-22.8 2.3-31.3l11.3-11.3c8.6-8.6 21.9-9.3 31.3-2.3c6.8-3.7 14.1-6.8 21.7-9c1.7-11.6 11.7-20.6 23.8-20.6zm8 176a48 48 0 1 0 0-96 48 48 0 1 0 0 96zM448.2 276.6c1.7-11.6 11.7-20.6 23.8-20.6h16c12.1 0 22.1 8.9 23.8 20.6c7.6 2.2 14.9 5.3 21.8 9c9.4-7 22.8-6.3 31.3 2.3l11.3 11.3c8.6 8.6 9.3 21.9 2.2 31.3c3.7 6.8 6.8 14.1 9 21.7c11.6 1.7 20.6 11.7 20.6 23.8v16c0 12.1-8.9 22.1-20.6 23.8c-2.2 7.6-5.3 14.9-9 21.7c7 9.4 6.3 22.8-2.2 31.3l-11.3 11.3c-8.6 8.6-21.9 9.3-31.3 2.2c-6.9 3.7-14.1 6.8-21.8 9C510.1 503.1 500.1 512 488 512H472c-12.1 0-22.1-8.9-23.8-20.6c-7.6-2.2-14.9-5.3-21.7-9c-9.4 7.1-22.8 6.3-31.3-2.2l-11.3-11.3c-8.6-8.6-9.3-21.9-2.2-31.3c-3.7-6.9-6.8-14.1-9-21.8C360.9 414.1 352 404.1 352 392V376c0-12.1 8.9-22.1 20.6-23.8c2.2-7.6 5.3-14.9 9-21.8c-7-9.4-6.3-22.8 2.2-31.3l11.3-11.3c8.6-8.6 21.9-9.3 31.3-2.3c6.8-3.7 14.1-6.8 21.7-9zM528 384a48 48 0 1 0 -96 0 48 48 0 1 0 96 0z"
    ]
};
var $d8206b3ab2e65c05$export$c7f24bdea332f90a = {
    prefix: "fas",
    iconName: "w",
    icon: [
        576,
        512,
        [
            119
        ],
        "57",
        "M20.8 34c16.5-6.2 35 2.2 41.2 18.7l110.2 294L257.3 55c4-13.7 16.5-23 30.7-23s26.7 9.4 30.7 23l85.1 291.7L514 52.8c6.2-16.5 24.6-24.9 41.2-18.7s24.9 24.7 18.7 41.2l-144 384c-4.8 12.9-17.4 21.3-31.2 20.7s-25.7-9.8-29.5-23L288 178.3 206.7 457c-3.9 13.2-15.8 22.5-29.5 23s-26.3-7.8-31.2-20.7L2 75.2C-4.2 58.7 4.2 40.2 20.8 34z"
    ]
};
var $d8206b3ab2e65c05$export$11afa141d42099d0 = {
    prefix: "fas",
    iconName: "earth-africa",
    icon: [
        512,
        512,
        [
            127757,
            "globe-africa"
        ],
        "f57c",
        "M177.8 63.2l10 17.4c2.8 4.8 4.2 10.3 4.2 15.9v41.4c0 3.9 1.6 7.7 4.3 10.4c6.2 6.2 16.5 5.7 22-1.2l13.6-17c4.7-5.9 12.9-7.7 19.6-4.3l15.2 7.6c3.4 1.7 7.2 2.6 11 2.6c6.5 0 12.8-2.6 17.4-7.2l3.9-3.9c2.9-2.9 7.3-3.6 11-1.8l29.2 14.6c7.8 3.9 12.6 11.8 12.6 20.5c0 10.5-7.1 19.6-17.3 22.2l-35.4 8.8c-7.4 1.8-15.1 1.5-22.4-.9l-32-10.7c-3.3-1.1-6.7-1.7-10.2-1.7c-7 0-13.8 2.3-19.4 6.5L176 212c-10.1 7.6-16 19.4-16 32v28c0 26.5 21.5 48 48 48h32c8.8 0 16 7.2 16 16v48c0 17.7 14.3 32 32 32c10.1 0 19.6-4.7 25.6-12.8l25.6-34.1c8.3-11.1 12.8-24.6 12.8-38.4V318.6c0-3.9 2.6-7.3 6.4-8.2l5.3-1.3c11.9-3 20.3-13.7 20.3-26c0-7.1-2.8-13.9-7.8-18.9l-33.5-33.5c-3.7-3.7-3.7-9.7 0-13.4c5.7-5.7 14.1-7.7 21.8-5.1l14.1 4.7c12.3 4.1 25.7-1.5 31.5-13c3.5-7 11.2-10.8 18.9-9.2l27.4 5.5C432 112.4 351.5 48 256 48c-27.7 0-54 5.4-78.2 15.2zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256z"
    ]
};
var $d8206b3ab2e65c05$export$64af36f3b403a57c = $d8206b3ab2e65c05$export$11afa141d42099d0;
var $d8206b3ab2e65c05$export$92ab27739d3a91b2 = {
    prefix: "fas",
    iconName: "rainbow",
    icon: [
        640,
        512,
        [
            127752
        ],
        "f75b",
        "M320 96C178.6 96 64 210.6 64 352v96c0 17.7-14.3 32-32 32s-32-14.3-32-32V352C0 175.3 143.3 32 320 32s320 143.3 320 320v96c0 17.7-14.3 32-32 32s-32-14.3-32-32V352C576 210.6 461.4 96 320 96zm0 192c-35.3 0-64 28.7-64 64v96c0 17.7-14.3 32-32 32s-32-14.3-32-32V352c0-70.7 57.3-128 128-128s128 57.3 128 128v96c0 17.7-14.3 32-32 32s-32-14.3-32-32V352c0-35.3-28.7-64-64-64zM160 352v96c0 17.7-14.3 32-32 32s-32-14.3-32-32V352c0-123.7 100.3-224 224-224s224 100.3 224 224v96c0 17.7-14.3 32-32 32s-32-14.3-32-32V352c0-88.4-71.6-160-160-160s-160 71.6-160 160z"
    ]
};
var $d8206b3ab2e65c05$export$9429fd8df55155d = {
    prefix: "fas",
    iconName: "circle-notch",
    icon: [
        512,
        512,
        [],
        "f1ce",
        "M222.7 32.1c5 16.9-4.6 34.8-21.5 39.8C121.8 95.6 64 169.1 64 256c0 106 86 192 192 192s192-86 192-192c0-86.9-57.8-160.4-137.1-184.1c-16.9-5-26.6-22.9-21.5-39.8s22.9-26.6 39.8-21.5C434.9 42.1 512 140 512 256c0 141.4-114.6 256-256 256S0 397.4 0 256C0 140 77.1 42.1 182.9 10.6c16.9-5 34.8 4.6 39.8 21.5z"
    ]
};
var $d8206b3ab2e65c05$export$df1e253fc358ade4 = {
    prefix: "fas",
    iconName: "tablet-screen-button",
    icon: [
        448,
        512,
        [
            "tablet-alt"
        ],
        "f3fa",
        "M0 64C0 28.7 28.7 0 64 0H384c35.3 0 64 28.7 64 64V448c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V64zM256 448a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zM384 64H64V384H384V64z"
    ]
};
var $d8206b3ab2e65c05$export$db0cac088255eacc = $d8206b3ab2e65c05$export$df1e253fc358ade4;
var $d8206b3ab2e65c05$export$7bc6e4d977673e69 = {
    prefix: "fas",
    iconName: "paw",
    icon: [
        512,
        512,
        [],
        "f1b0",
        "M226.5 92.9c14.3 42.9-.3 86.2-32.6 96.8s-70.1-15.6-84.4-58.5s.3-86.2 32.6-96.8s70.1 15.6 84.4 58.5zM100.4 198.6c18.9 32.4 14.3 70.1-10.2 84.1s-59.7-.9-78.5-33.3S-2.7 179.3 21.8 165.3s59.7 .9 78.5 33.3zM69.2 401.2C121.6 259.9 214.7 224 256 224s134.4 35.9 186.8 177.2c3.6 9.7 5.2 20.1 5.2 30.5v1.6c0 25.8-20.9 46.7-46.7 46.7c-11.5 0-22.9-1.4-34-4.2l-88-22c-15.3-3.8-31.3-3.8-46.6 0l-88 22c-11.1 2.8-22.5 4.2-34 4.2C84.9 480 64 459.1 64 433.3v-1.6c0-10.4 1.6-20.8 5.2-30.5zM421.8 282.7c-24.5-14-29.1-51.7-10.2-84.1s54-47.3 78.5-33.3s29.1 51.7 10.2 84.1s-54 47.3-78.5 33.3zM310.1 189.7c-32.3-10.6-46.9-53.9-32.6-96.8s52.1-69.1 84.4-58.5s46.9 53.9 32.6 96.8s-52.1 69.1-84.4 58.5z"
    ]
};
var $d8206b3ab2e65c05$export$8bb3c4d5c2f50243 = {
    prefix: "fas",
    iconName: "cloud",
    icon: [
        640,
        512,
        [
            9729
        ],
        "f0c2",
        "M0 336c0 79.5 64.5 144 144 144H512c70.7 0 128-57.3 128-128c0-61.9-44-113.6-102.4-125.4c4.1-10.7 6.4-22.4 6.4-34.6c0-53-43-96-96-96c-19.7 0-38.1 6-53.3 16.2C367 64.2 315.3 32 256 32C167.6 32 96 103.6 96 192c0 2.7 .1 5.4 .2 8.1C40.2 219.8 0 273.2 0 336z"
    ]
};
var $d8206b3ab2e65c05$export$b6c20c10ddbd9898 = {
    prefix: "fas",
    iconName: "trowel-bricks",
    icon: [
        512,
        512,
        [],
        "e58a",
        "M240.8 4.8C250.3 10.6 256 20.9 256 32v72h89c3.6-13.8 16.1-24 31-24h88c26.5 0 48 21.5 48 48s-21.5 48-48 48H376c-14.9 0-27.4-10.2-31-24H256v72c0 11.1-5.7 21.4-15.2 27.2s-21.2 6.4-31.1 1.4l-192-96C6.8 151.2 0 140.1 0 128s6.8-23.2 17.7-28.6l192-96c9.9-5 21.7-4.4 31.1 1.4zM288 256c0-17.7 14.3-32 32-32H480c17.7 0 32 14.3 32 32v64c0 17.7-14.3 32-32 32H320c-17.7 0-32-14.3-32-32V256zM32 384h96c17.7 0 32 14.3 32 32v64c0 17.7-14.3 32-32 32H32c-17.7 0-32-14.3-32-32V416c0-17.7 14.3-32 32-32zm192 0H480c17.7 0 32 14.3 32 32v64c0 17.7-14.3 32-32 32H224c-17.7 0-32-14.3-32-32V416c0-17.7 14.3-32 32-32z"
    ]
};
var $d8206b3ab2e65c05$export$ba5dc4287853ecbd = {
    prefix: "fas",
    iconName: "face-flushed",
    icon: [
        512,
        512,
        [
            128563,
            "flushed"
        ],
        "f579",
        "M0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zM176 384c0 8.8 7.2 16 16 16H320c8.8 0 16-7.2 16-16s-7.2-16-16-16H192c-8.8 0-16 7.2-16 16zm-16-88a72 72 0 1 0 0-144 72 72 0 1 0 0 144zm264-72a72 72 0 1 0 -144 0 72 72 0 1 0 144 0zm-288 0a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zm192 0a24 24 0 1 1 48 0 24 24 0 1 1 -48 0z"
    ]
};
var $d8206b3ab2e65c05$export$dfd2bd012685aeac = $d8206b3ab2e65c05$export$ba5dc4287853ecbd;
var $d8206b3ab2e65c05$export$684703c93d630cc5 = {
    prefix: "fas",
    iconName: "hospital-user",
    icon: [
        576,
        512,
        [],
        "f80d",
        "M48 0C21.5 0 0 21.5 0 48V256H144c8.8 0 16 7.2 16 16s-7.2 16-16 16H0v64H144c8.8 0 16 7.2 16 16s-7.2 16-16 16H0v80c0 26.5 21.5 48 48 48H265.9c-6.3-10.2-9.9-22.2-9.9-35.1c0-46.9 25.8-87.8 64-109.2V271.8 48c0-26.5-21.5-48-48-48H48zM152 64h16c8.8 0 16 7.2 16 16v24h24c8.8 0 16 7.2 16 16v16c0 8.8-7.2 16-16 16H184v24c0 8.8-7.2 16-16 16H152c-8.8 0-16-7.2-16-16V152H112c-8.8 0-16-7.2-16-16V120c0-8.8 7.2-16 16-16h24V80c0-8.8 7.2-16 16-16zM512 272a80 80 0 1 0 -160 0 80 80 0 1 0 160 0zM288 477.1c0 19.3 15.6 34.9 34.9 34.9H541.1c19.3 0 34.9-15.6 34.9-34.9c0-51.4-41.7-93.1-93.1-93.1H381.1c-51.4 0-93.1 41.7-93.1 93.1z"
    ]
};
var $d8206b3ab2e65c05$export$fa95eb7418c0e2b8 = {
    prefix: "fas",
    iconName: "tent-arrow-left-right",
    icon: [
        576,
        512,
        [],
        "e57f",
        "M488.1 6.2c-9.9-8.9-25-8.1-33.9 1.8s-8.1 25 1.8 33.9L489.5 72 86.5 72l33.5-30.2c9.9-8.9 10.7-24 1.8-33.9S97.8-2.7 87.9 6.2l-80 72C2.9 82.7 0 89.2 0 96s2.9 13.3 7.9 17.8l80 72c9.9 8.9 25 8.1 33.9-1.8s8.1-25-1.8-33.9L86.5 120l402.9 0-33.5 30.2c-9.9 8.9-10.7 24-1.8 33.9s24 10.7 33.9 1.8l80-72c5.1-4.6 7.9-11 7.9-17.8s-2.9-13.3-7.9-17.8l-80-72zM307.4 166.5c-11.5-8.7-27.3-8.7-38.8 0l-168 128c-6.6 5-11 12.5-12.3 20.7l-24 160c-1.4 9.2 1.3 18.6 7.4 25.6S86.7 512 96 512H288V352l96 160h96c9.3 0 18.2-4.1 24.2-11.1s8.8-16.4 7.4-25.6l-24-160c-1.2-8.2-5.6-15.7-12.3-20.7l-168-128z"
    ]
};
var $d8206b3ab2e65c05$export$c36fb40057e2c3aa = {
    prefix: "fas",
    iconName: "gavel",
    icon: [
        512,
        512,
        [
            "legal"
        ],
        "f0e3",
        "M318.6 9.4c-12.5-12.5-32.8-12.5-45.3 0l-120 120c-12.5 12.5-12.5 32.8 0 45.3l16 16c12.5 12.5 32.8 12.5 45.3 0l4-4L325.4 293.4l-4 4c-12.5 12.5-12.5 32.8 0 45.3l16 16c12.5 12.5 32.8 12.5 45.3 0l120-120c12.5-12.5 12.5-32.8 0-45.3l-16-16c-12.5-12.5-32.8-12.5-45.3 0l-4 4L330.6 74.6l4-4c12.5-12.5 12.5-32.8 0-45.3l-16-16zm-152 288c-12.5-12.5-32.8-12.5-45.3 0l-112 112c-12.5 12.5-12.5 32.8 0 45.3l48 48c12.5 12.5 32.8 12.5 45.3 0l112-112c12.5-12.5 12.5-32.8 0-45.3l-1.4-1.4L272 285.3 226.7 240 168 298.7l-1.4-1.4z"
    ]
};
var $d8206b3ab2e65c05$export$59d593c2dacb3781 = $d8206b3ab2e65c05$export$c36fb40057e2c3aa;
var $d8206b3ab2e65c05$export$8a910017964bb8c2 = {
    prefix: "fas",
    iconName: "binoculars",
    icon: [
        512,
        512,
        [],
        "f1e5",
        "M128 32h32c17.7 0 32 14.3 32 32V96H96V64c0-17.7 14.3-32 32-32zm64 96V448c0 17.7-14.3 32-32 32H32c-17.7 0-32-14.3-32-32V388.9c0-34.6 9.4-68.6 27.2-98.3C40.9 267.8 49.7 242.4 53 216L60.5 156c2-16 15.6-28 31.8-28H192zm227.8 0c16.1 0 29.8 12 31.8 28L459 216c3.3 26.4 12.1 51.8 25.8 74.6c17.8 29.7 27.2 63.7 27.2 98.3V448c0 17.7-14.3 32-32 32H352c-17.7 0-32-14.3-32-32V128h99.8zM320 64c0-17.7 14.3-32 32-32h32c17.7 0 32 14.3 32 32V96H320V64zm-32 64V288H224V128h64z"
    ]
};
var $d8206b3ab2e65c05$export$843f63d64e6f7951 = {
    prefix: "fas",
    iconName: "microphone-slash",
    icon: [
        640,
        512,
        [],
        "f131",
        "M38.8 5.1C28.4-3.1 13.3-1.2 5.1 9.2S-1.2 34.7 9.2 42.9l592 464c10.4 8.2 25.5 6.3 33.7-4.1s6.3-25.5-4.1-33.7L472.1 344.7c15.2-26 23.9-56.3 23.9-88.7V216c0-13.3-10.7-24-24-24s-24 10.7-24 24v40c0 21.2-5.1 41.1-14.2 58.7L416 300.8V96c0-53-43-96-96-96s-96 43-96 96v54.3L38.8 5.1zM344 430.4c20.4-2.8 39.7-9.1 57.3-18.2l-43.1-33.9C346.1 382 333.3 384 320 384c-70.7 0-128-57.3-128-128v-8.7L144.7 210c-.5 1.9-.7 3.9-.7 6v40c0 89.1 66.2 162.7 152 174.4V464H248c-13.3 0-24 10.7-24 24s10.7 24 24 24h72 72c13.3 0 24-10.7 24-24s-10.7-24-24-24H344V430.4z"
    ]
};
var $d8206b3ab2e65c05$export$f2adc06617bc0c7 = {
    prefix: "fas",
    iconName: "box-tissue",
    icon: [
        512,
        512,
        [],
        "e05b",
        "M92.5 0H208c40 0 52 24 64 48s24 48 64 48h85.2C436 96 448 108 448 122.8c0 3.4-.7 6.8-1.9 10L409.6 224 384 288H128l-16-64L64.9 35.4c-.6-2.3-.9-4.6-.9-6.9C64 12.8 76.8 0 92.5 0zM79 224l16 64H80c-8.8 0-16 7.2-16 16s7.2 16 16 16h48H384h48c8.8 0 16-7.2 16-16s-7.2-16-16-16H418.5l25.6-64H464c26.5 0 48 21.5 48 48V384H0V272c0-26.5 21.5-48 48-48H79zM0 416H512v48c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V416z"
    ]
};
var $d8206b3ab2e65c05$export$f26017bdca99338d = {
    prefix: "fas",
    iconName: "motorcycle",
    icon: [
        640,
        512,
        [
            127949
        ],
        "f21c",
        "M280 32c-13.3 0-24 10.7-24 24s10.7 24 24 24h57.7l16.4 30.3L256 192l-45.3-45.3c-12-12-28.3-18.7-45.3-18.7H64c-17.7 0-32 14.3-32 32v32h96c88.4 0 160 71.6 160 160c0 11-1.1 21.7-3.2 32h70.4c-2.1-10.3-3.2-21-3.2-32c0-52.2 25-98.6 63.7-127.8l15.4 28.6C402.4 276.3 384 312 384 352c0 70.7 57.3 128 128 128s128-57.3 128-128s-57.3-128-128-128c-13.5 0-26.5 2.1-38.7 6L418.2 128H480c17.7 0 32-14.3 32-32V64c0-17.7-14.3-32-32-32H459.6c-7.5 0-14.7 2.6-20.5 7.4L391.7 78.9l-14-26c-7-12.9-20.5-21-35.2-21H280zM462.7 311.2l28.2 52.2c6.3 11.7 20.9 16 32.5 9.7s16-20.9 9.7-32.5l-28.2-52.2c2.3-.3 4.7-.4 7.1-.4c35.3 0 64 28.7 64 64s-28.7 64-64 64s-64-28.7-64-64c0-15.5 5.5-29.7 14.7-40.8zM187.3 376c-9.5 23.5-32.5 40-59.3 40c-35.3 0-64-28.7-64-64s28.7-64 64-64c26.9 0 49.9 16.5 59.3 40h66.4C242.5 268.8 190.5 224 128 224C57.3 224 0 281.3 0 352s57.3 128 128 128c62.5 0 114.5-44.8 125.8-104H187.3zM128 384a32 32 0 1 0 0-64 32 32 0 1 0 0 64z"
    ]
};
var $d8206b3ab2e65c05$export$e433538b78718fb3 = {
    prefix: "fas",
    iconName: "bell-concierge",
    icon: [
        512,
        512,
        [
            128718,
            "concierge-bell"
        ],
        "f562",
        "M216 64c-13.3 0-24 10.7-24 24s10.7 24 24 24h16v33.3C119.6 157.2 32 252.4 32 368H480c0-115.6-87.6-210.8-200-222.7V112h16c13.3 0 24-10.7 24-24s-10.7-24-24-24H256 216zM24 400c-13.3 0-24 10.7-24 24s10.7 24 24 24H488c13.3 0 24-10.7 24-24s-10.7-24-24-24H24z"
    ]
};
var $d8206b3ab2e65c05$export$ad92ffbbfbc0fcf3 = $d8206b3ab2e65c05$export$e433538b78718fb3;
var $d8206b3ab2e65c05$export$85ba06027671d290 = {
    prefix: "fas",
    iconName: "pen-ruler",
    icon: [
        512,
        512,
        [
            "pencil-ruler"
        ],
        "f5ae",
        "M469.3 19.3l23.4 23.4c25 25 25 65.5 0 90.5l-56.4 56.4L322.3 75.7l56.4-56.4c25-25 65.5-25 90.5 0zM44.9 353.2L299.7 98.3 413.7 212.3 158.8 467.1c-6.7 6.7-15.1 11.6-24.2 14.2l-104 29.7c-8.4 2.4-17.4 .1-23.6-6.1s-8.5-15.2-6.1-23.6l29.7-104c2.6-9.2 7.5-17.5 14.2-24.2zM249.4 103.4L103.4 249.4 16 161.9c-18.7-18.7-18.7-49.1 0-67.9L94.1 16c18.7-18.7 49.1-18.7 67.9 0l19.8 19.8c-.3 .3-.7 .6-1 .9l-64 64c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0l64-64c.3-.3 .6-.7 .9-1l45.1 45.1zM408.6 262.6l45.1 45.1c-.3 .3-.7 .6-1 .9l-64 64c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0l64-64c.3-.3 .6-.7 .9-1L496 350.1c18.7 18.7 18.7 49.1 0 67.9L417.9 496c-18.7 18.7-49.1 18.7-67.9 0l-87.4-87.4L408.6 262.6z"
    ]
};
var $d8206b3ab2e65c05$export$e3a7a1affea005f5 = $d8206b3ab2e65c05$export$85ba06027671d290;
var $d8206b3ab2e65c05$export$804bfc5c390e1a2a = {
    prefix: "fas",
    iconName: "people-arrows",
    icon: [
        640,
        512,
        [
            "people-arrows-left-right"
        ],
        "e068",
        "M64 64a64 64 0 1 1 128 0A64 64 0 1 1 64 64zM25.9 233.4C29.3 191.9 64 160 105.6 160h44.8c27 0 51 13.4 65.5 34.1c-2.7 1.9-5.2 4-7.5 6.3l-64 64c-21.9 21.9-21.9 57.3 0 79.2L192 391.2V464c0 26.5-21.5 48-48 48H112c-26.5 0-48-21.5-48-48V348.3c-26.5-9.5-44.7-35.8-42.2-65.6l4.1-49.3zM448 64a64 64 0 1 1 128 0A64 64 0 1 1 448 64zM431.6 200.4c-2.3-2.3-4.9-4.4-7.5-6.3c14.5-20.7 38.6-34.1 65.5-34.1h44.8c41.6 0 76.3 31.9 79.7 73.4l4.1 49.3c2.5 29.8-15.7 56.1-42.2 65.6V464c0 26.5-21.5 48-48 48H496c-26.5 0-48-21.5-48-48V391.2l47.6-47.6c21.9-21.9 21.9-57.3 0-79.2l-64-64zM272 240v32h96V240c0-9.7 5.8-18.5 14.8-22.2s19.3-1.7 26.2 5.2l64 64c9.4 9.4 9.4 24.6 0 33.9l-64 64c-6.9 6.9-17.2 8.9-26.2 5.2s-14.8-12.5-14.8-22.2V336H272v32c0 9.7-5.8 18.5-14.8 22.2s-19.3 1.7-26.2-5.2l-64-64c-9.4-9.4-9.4-24.6 0-33.9l64-64c6.9-6.9 17.2-8.9 26.2-5.2s14.8 12.5 14.8 22.2z"
    ]
};
var $d8206b3ab2e65c05$export$da01f044c59e3598 = $d8206b3ab2e65c05$export$804bfc5c390e1a2a;
var $d8206b3ab2e65c05$export$1dc6221efb867885 = {
    prefix: "fas",
    iconName: "mars-and-venus-burst",
    icon: [
        640,
        512,
        [],
        "e523",
        "M504 0c-9.7 0-18.5 5.8-22.2 14.8s-1.7 19.3 5.2 26.2l39 39-22.2 22.2C475.9 78.4 439.6 64 400 64c-88.4 0-160 71.6-160 160c0 80.2 59.1 146.7 136.1 158.2c0 .6-.1 1.2-.1 1.8v.4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .3 .4 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3H352c-13.3 0-24 10.7-24 24s10.7 24 24 24h24v.2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0l24 0H376c0 13.3 10.7 24 24 24s24-10.7 24-24H400l24 0v0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0-.1-.1-.1-.1-.1-.1-.1-.1-.1-.1V486 486v-.1-.1-.1-.1-.1-.1-.1-.1-.1-.1-.1-.1-.1V485 485v-.1-.1-.1-.1-.1-.1-.1-.1-.1-.1-.1V484v-.1-.1-.1-.1-.1-.1-.1-.1-.1-.1V483v-.1-.1-.1-.1-.1-.1-.1-.1-.1-.1-.1-.1-.1-.1-.1-.1-.1-.1-.1V481v-.1-.1-.1-.1-.1-.1-.1-.1V480v-.1-.1-.1-.1-.1-.1-.1V479v-.1-.1-.1-.1-.1-.1-.1V478v-.1-.1-.1-.1-.1-.1V477v-.1-.1-.1-.1-.1-.1V476v-.1-.1-.1-.1-.1-.1V475v-.1-.2-.2-.2-.2-.2V474v-.2-.2-.2-.2-.2V473v-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2V470v-.2-.2-.2-.2-.2V469v-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2V467v-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2V463v-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2V459v-.2-.2-.2-.2-.2-.2-.2-.2V457v-.2-.2-.2-.2V456h24c13.3 0 24-10.7 24-24s-10.7-24-24-24H424v-.3-.3-.3-.3-.3-.3-.3-.3-.3-.3-.3-.3-.3-.3V403v-.3-.3V402v-.3-.3V401v-.3-.3V400v-.3-.3-.3-.3-.3-.3-.3-.3-.3-.3-.3-.3-.3-.4-.3-.4-.4-.4-.4V393v-.4-.4-.4-.4-.4-.4-.4-.4-.4-.4-.4-.4-.4V388v-.4-.4-.4-.4-.4-.4-.4-.4-.4-.4V384c0-.6 0-1.2-.1-1.8c77-11.6 136.1-78 136.1-158.2c0-31.4-9-60.7-24.7-85.4L560 113.9l39 39c6.9 6.9 17.2 8.9 26.2 5.2s14.8-12.5 14.8-22.2V24c0-13.3-10.7-24-24-24H504zM400 128a96 96 0 1 1 0 192 96 96 0 1 1 0-192zM190.9 18.1C188.4 12 182.6 8 176 8s-12.4 4-14.9 10.1l-29.4 74L55.6 68.9c-6.3-1.9-13.1 .2-17.2 5.3s-4.6 12.2-1.4 17.9l39.5 69.1L10.9 206.4c-5.4 3.7-8 10.3-6.5 16.7s6.7 11.2 13.1 12.2l78.7 12.2L90.6 327c-.5 6.5 3.1 12.7 9 15.5s12.9 1.8 17.8-2.6L176 286.1l58.6 53.9c4.1 3.8 9.9 5.1 15.2 3.6C223.6 310.8 208 269.2 208 224c0-60.8 28.3-115 72.4-150.2L220.3 92.1l-29.4-74z"
    ]
};
var $d8206b3ab2e65c05$export$5b1d41cdd118ea6d = {
    prefix: "fas",
    iconName: "square-caret-right",
    icon: [
        448,
        512,
        [
            "caret-square-right"
        ],
        "f152",
        "M448 96c0-35.3-28.7-64-64-64L64 32C28.7 32 0 60.7 0 96L0 416c0 35.3 28.7 64 64 64l320 0c35.3 0 64-28.7 64-64l0-320zM320 256c0 6.7-2.8 13-7.7 17.6l-112 104c-7 6.5-17.2 8.2-25.9 4.4s-14.4-12.5-14.4-22l0-208c0-9.5 5.7-18.2 14.4-22s18.9-2.1 25.9 4.4l112 104c4.9 4.5 7.7 10.9 7.7 17.6z"
    ]
};
var $d8206b3ab2e65c05$export$ae86c9de7e0f62fa = $d8206b3ab2e65c05$export$5b1d41cdd118ea6d;
var $d8206b3ab2e65c05$export$b2a906a5928c6404 = {
    prefix: "fas",
    iconName: "scissors",
    icon: [
        512,
        512,
        [
            9984,
            9986,
            9988,
            "cut"
        ],
        "f0c4",
        "M256 192l-39.5-39.5c4.9-12.6 7.5-26.2 7.5-40.5C224 50.1 173.9 0 112 0S0 50.1 0 112s50.1 112 112 112c14.3 0 27.9-2.7 40.5-7.5L192 256l-39.5 39.5c-12.6-4.9-26.2-7.5-40.5-7.5C50.1 288 0 338.1 0 400s50.1 112 112 112s112-50.1 112-112c0-14.3-2.7-27.9-7.5-40.5L499.2 76.8c7.1-7.1 7.1-18.5 0-25.6c-28.3-28.3-74.1-28.3-102.4 0L256 192zm22.6 150.6L396.8 460.8c28.3 28.3 74.1 28.3 102.4 0c7.1-7.1 7.1-18.5 0-25.6L342.6 278.6l-64 64zM64 112a48 48 0 1 1 96 0 48 48 0 1 1 -96 0zm48 240a48 48 0 1 1 0 96 48 48 0 1 1 0-96z"
    ]
};
var $d8206b3ab2e65c05$export$66847f2a71b260e7 = $d8206b3ab2e65c05$export$b2a906a5928c6404;
var $d8206b3ab2e65c05$export$8db7f2f70484e17e = {
    prefix: "fas",
    iconName: "sun-plant-wilt",
    icon: [
        640,
        512,
        [],
        "e57a",
        "M160 0c-6.3 0-12 3.7-14.6 9.5L120.6 64.9 63.9 43.2c-5.9-2.3-12.6-.8-17 3.6s-5.9 11.1-3.6 17l21.7 56.7L9.5 145.4C3.7 148 0 153.7 0 160s3.7 12 9.5 14.6l55.4 24.8L43.2 256.1c-2.3 5.9-.8 12.6 3.6 17s11.1 5.9 17 3.6l56.7-21.7 24.8 55.4c2.6 5.8 8.3 9.5 14.6 9.5s12-3.7 14.6-9.5l24.8-55.4 56.7 21.7c5.9 2.3 12.6 .8 17-3.6s5.9-11.1 3.6-17l-21.7-56.7 55.4-24.8c5.8-2.6 9.5-8.3 9.5-14.6s-3.7-12-9.5-14.6l-55.4-24.8 21.7-56.7c2.3-5.9 .8-12.6-3.6-17s-11.1-5.9-17-3.6L199.4 64.9 174.6 9.5C172 3.7 166.3 0 160 0zm0 96a64 64 0 1 1 0 128 64 64 0 1 1 0-128zm32 64a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zm312 16c0-17.7 14.3-32 32-32s32 14.3 32 32v53.4c-14.8 7.7-24 23.1-24 44.6c0 16.8 16 44 37.4 67.2c5.8 6.2 15.5 6.2 21.2 0C624 318 640 290.7 640 274c0-21.5-9.2-37-24-44.6V176c0-44.2-35.8-80-80-80s-80 35.8-80 80v22.7c-9.8-4.3-20.6-6.7-32-6.7c-44.2 0-80 35.8-80 80v21.4c-14.8 7.7-24 23.1-24 44.6c0 16.8 16 44 37.4 67.2c5.8 6.2 15.5 6.2 21.2 0C400 382 416 354.7 416 338c0-21.5-9.2-37-24-44.6V272c0-17.7 14.3-32 32-32s32 14.3 32 32v8V448H32c-17.7 0-32 14.3-32 32s14.3 32 32 32H608c17.7 0 32-14.3 32-32s-14.3-32-32-32H504V280v-8V176z"
    ]
};
var $d8206b3ab2e65c05$export$c00f55f36d386cb7 = {
    prefix: "fas",
    iconName: "toilets-portable",
    icon: [
        576,
        512,
        [],
        "e584",
        "M32 0H224c17.7 0 32 14.3 32 32V64H0V32C0 14.3 14.3 0 32 0zM0 96H24 232h24v24V488c0 13.3-10.7 24-24 24s-24-10.7-24-24v-8H48v8c0 13.3-10.7 24-24 24s-24-10.7-24-24V120 96zM192 224c-8.8 0-16 7.2-16 16v64c0 8.8 7.2 16 16 16s16-7.2 16-16V240c0-8.8-7.2-16-16-16zM352 0H544c17.7 0 32 14.3 32 32V64H320V32c0-17.7 14.3-32 32-32zM320 96h24H552h24v24V488c0 13.3-10.7 24-24 24s-24-10.7-24-24v-8H368v8c0 13.3-10.7 24-24 24s-24-10.7-24-24V120 96zM512 224c-8.8 0-16 7.2-16 16v64c0 8.8 7.2 16 16 16s16-7.2 16-16V240c0-8.8-7.2-16-16-16z"
    ]
};
var $d8206b3ab2e65c05$export$a274b02dc75663dc = {
    prefix: "fas",
    iconName: "hockey-puck",
    icon: [
        512,
        512,
        [],
        "f453",
        "M256 256C114.6 256 0 213 0 160s114.6-96 256-96s256 43 256 96s-114.6 96-256 96zm192.3 1.8c24.7-9.3 46.9-21 63.7-35.6V352c0 53-114.6 96-256 96S0 405 0 352V222.3c16.8 14.6 39 26.3 63.7 35.6C114.5 276.9 182.5 288 256 288s141.5-11.1 192.3-30.2z"
    ]
};
var $d8206b3ab2e65c05$export$36583f5d3d5a971f = {
    prefix: "fas",
    iconName: "table",
    icon: [
        512,
        512,
        [],
        "f0ce",
        "M64 256V160H224v96H64zm0 64H224v96H64V320zm224 96V320H448v96H288zM448 256H288V160H448v96zM64 32C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H448c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64z"
    ]
};
var $d8206b3ab2e65c05$export$382d3376c7fc7fc5 = {
    prefix: "fas",
    iconName: "magnifying-glass-arrow-right",
    icon: [
        512,
        512,
        [],
        "e521",
        "M416 208c0 45.9-14.9 88.3-40 122.7L502.6 457.4c12.5 12.5 12.5 32.8 0 45.3s-32.8 12.5-45.3 0L330.7 376c-34.4 25.2-76.8 40-122.7 40C93.1 416 0 322.9 0 208S93.1 0 208 0S416 93.1 416 208zM241 119c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9l31 31H120c-13.3 0-24 10.7-24 24s10.7 24 24 24H238.1l-31 31c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l72-72c9.4-9.4 9.4-24.6 0-33.9l-72-72z"
    ]
};
var $d8206b3ab2e65c05$export$73f2bf302381c86a = {
    prefix: "fas",
    iconName: "tachograph-digital",
    icon: [
        640,
        512,
        [
            "digital-tachograph"
        ],
        "f566",
        "M64 64C28.7 64 0 92.7 0 128V384c0 35.3 28.7 64 64 64H576c35.3 0 64-28.7 64-64V128c0-35.3-28.7-64-64-64H64zm32 64H320c17.7 0 32 14.3 32 32v64c0 17.7-14.3 32-32 32H96c-17.7 0-32-14.3-32-32V160c0-17.7 14.3-32 32-32zM64 368c0-8.8 7.2-16 16-16H336c8.8 0 16 7.2 16 16s-7.2 16-16 16H80c-8.8 0-16-7.2-16-16zm320 0c0-8.8 7.2-16 16-16H560c8.8 0 16 7.2 16 16s-7.2 16-16 16H400c-8.8 0-16-7.2-16-16zM80 288a16 16 0 1 1 0 32 16 16 0 1 1 0-32zm48 16a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zm80-16a16 16 0 1 1 0 32 16 16 0 1 1 0-32zm48 16a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zm80-16a16 16 0 1 1 0 32 16 16 0 1 1 0-32z"
    ]
};
var $d8206b3ab2e65c05$export$b3bf1994f0fefe98 = $d8206b3ab2e65c05$export$73f2bf302381c86a;
var $d8206b3ab2e65c05$export$b71a093b86e3da1f = {
    prefix: "fas",
    iconName: "users-slash",
    icon: [
        640,
        512,
        [],
        "e073",
        "M38.8 5.1C28.4-3.1 13.3-1.2 5.1 9.2S-1.2 34.7 9.2 42.9l592 464c10.4 8.2 25.5 6.3 33.7-4.1s6.3-25.5-4.1-33.7L440.6 320H618.7c11.8 0 21.3-9.6 21.3-21.3C640 239.8 592.2 192 533.3 192H490.7c-15.9 0-31 3.5-44.6 9.7c1.3 7.2 1.9 14.7 1.9 22.3c0 30.2-10.5 58-28 79.9l-25.2-19.7C408.1 267.7 416 246.8 416 224c0-53-43-96-96-96c-31.1 0-58.7 14.8-76.3 37.7l-40.6-31.8c13-14.2 20.9-33.1 20.9-53.9c0-44.2-35.8-80-80-80C116.3 0 91.9 14.1 77.5 35.5L38.8 5.1zM106.7 192C47.8 192 0 239.8 0 298.7C0 310.4 9.6 320 21.3 320H234.7c.2 0 .4 0 .7 0c-20.6-18.2-35.2-42.8-40.8-70.8L121.8 192H106.7zM261.3 352C187.7 352 128 411.7 128 485.3c0 14.7 11.9 26.7 26.7 26.7H485.3c10.5 0 19.5-6 23.9-14.8L324.9 352H261.3zM512 160A80 80 0 1 0 512 0a80 80 0 1 0 0 160z"
    ]
};
var $d8206b3ab2e65c05$export$57813571c0e10a0a = {
    prefix: "fas",
    iconName: "clover",
    icon: [
        448,
        512,
        [],
        "e139",
        "M173.3 32C139.4 32 112 59.4 112 93.3v4.9c0 12 3.3 23.7 9.4 34l18.8 31.3c1.1 1.8 1.2 3.1 1 4.2c-.2 1.2-.8 2.5-2 3.6s-2.4 1.8-3.6 2c-1 .2-2.4 .1-4.2-1l-31.3-18.8c-10.3-6.2-22-9.4-34-9.4H61.3C27.4 144 0 171.4 0 205.3c0 16.2 6.5 31.8 17.9 43.3l1.2 1.2c3.4 3.4 3.4 9 0 12.4l-1.2 1.2C6.5 274.9 0 290.5 0 306.7C0 340.6 27.4 368 61.3 368h4.9c12 0 23.7-3.3 34-9.4l31.3-18.8c1.8-1.1 3.1-1.2 4.2-1c1.2 .2 2.5 .8 3.6 2s1.8 2.4 2 3.6c.2 1 .1 2.4-1 4.2l-18.8 31.3c-6.2 10.3-9.4 22-9.4 34v4.9c0 33.8 27.4 61.3 61.3 61.3c16.2 0 31.8-6.5 43.3-17.9l1.2-1.2c3.4-3.4 9-3.4 12.4 0l1.2 1.2c11.5 11.5 27.1 17.9 43.3 17.9c33.8 0 61.3-27.4 61.3-61.3v-4.9c0-12-3.3-23.7-9.4-34l-18.8-31.3c-1.1-1.8-1.2-3.1-1-4.2c.2-1.2 .8-2.5 2-3.6s2.4-1.8 3.6-2c1-.2 2.4-.1 4.2 1l31.3 18.8c10.3 6.2 22 9.4 34 9.4h4.9c33.8 0 61.3-27.4 61.3-61.3c0-16.2-6.5-31.8-17.9-43.3l-1.2-1.2c-3.4-3.4-3.4-9 0-12.4l1.2-1.2c11.5-11.5 17.9-27.1 17.9-43.3c0-33.8-27.4-61.3-61.3-61.3h-4.9c-12 0-23.7 3.3-34 9.4l-31.3 18.8c-1.8 1.1-3.1 1.2-4.2 1c-1.2-.2-2.5-.8-3.6-2s-1.8-2.4-2-3.6c-.2-1-.1-2.4 1-4.2l18.8-31.3c6.2-10.3 9.4-22 9.4-34V93.3C336 59.4 308.6 32 274.7 32c-16.2 0-31.8 6.5-43.3 17.9l-1.2 1.2c-3.4 3.4-9 3.4-12.4 0l-1.2-1.2C205.1 38.5 189.5 32 173.3 32z"
    ]
};
var $d8206b3ab2e65c05$export$bb06d4a7bb6736fe = {
    prefix: "fas",
    iconName: "reply",
    icon: [
        512,
        512,
        [
            61714,
            "mail-reply"
        ],
        "f3e5",
        "M205 34.8c11.5 5.1 19 16.6 19 29.2v64H336c97.2 0 176 78.8 176 176c0 113.3-81.5 163.9-100.2 174.1c-2.5 1.4-5.3 1.9-8.1 1.9c-10.9 0-19.7-8.9-19.7-19.7c0-7.5 4.3-14.4 9.8-19.5c9.4-8.8 22.2-26.4 22.2-56.7c0-53-43-96-96-96H224v64c0 12.6-7.4 24.1-19 29.2s-25 3-34.4-5.4l-160-144C3.9 225.7 0 217.1 0 208s3.9-17.7 10.6-23.8l160-144c9.4-8.5 22.9-10.6 34.4-5.4z"
    ]
};
var $d8206b3ab2e65c05$export$12e45ff70d2646a1 = $d8206b3ab2e65c05$export$bb06d4a7bb6736fe;
var $d8206b3ab2e65c05$export$cafa834c96ebcb1a = {
    prefix: "fas",
    iconName: "star-and-crescent",
    icon: [
        512,
        512,
        [
            9770
        ],
        "f699",
        "M0 256C0 114.6 114.6 0 256 0c33 0 64.6 6.3 93.6 17.7c7.4 2.9 11.5 10.7 9.8 18.4s-8.8 13-16.7 12.4c-4.8-.3-9.7-.5-14.6-.5c-114.9 0-208 93.1-208 208s93.1 208 208 208c4.9 0 9.8-.2 14.6-.5c7.9-.5 15 4.7 16.7 12.4s-2.4 15.5-9.8 18.4C320.6 505.7 289 512 256 512C114.6 512 0 397.4 0 256zM375.4 137.4c3.5-7.1 13.7-7.1 17.2 0l31.5 63.8c1.4 2.8 4.1 4.8 7.2 5.3l70.4 10.2c7.9 1.1 11 10.8 5.3 16.4l-50.9 49.6c-2.3 2.2-3.3 5.4-2.8 8.5l12 70.1c1.3 7.8-6.9 13.8-13.9 10.1l-63-33.1c-2.8-1.5-6.1-1.5-8.9 0l-63 33.1c-7 3.7-15.3-2.3-13.9-10.1l12-70.1c.5-3.1-.5-6.3-2.8-8.5L261 233.1c-5.7-5.6-2.6-15.2 5.3-16.4l70.4-10.2c3.1-.5 5.8-2.4 7.2-5.3l31.5-63.8z"
    ]
};
var $d8206b3ab2e65c05$export$947ee033a6942aa8 = {
    prefix: "fas",
    iconName: "house-fire",
    icon: [
        640,
        512,
        [],
        "e50c",
        "M288 350.1l0 1.9H256c-17.7 0-32 14.3-32 32v64 24c0 22.1-17.9 40-40 40H160 128.1c-1.5 0-3-.1-4.5-.2c-1.2 .1-2.4 .2-3.6 .2H104c-22.1 0-40-17.9-40-40V360c0-.9 0-1.9 .1-2.8V287.6H32c-18 0-32-14-32-32.1c0-9 3-17 10-24L266.4 8c7-7 15-8 22-8s15 2 21 7L447.3 128.1c-12.3-1-25 3-34.8 11.7c-35.4 31.6-65.6 67.7-87.3 102.8C304.3 276.5 288 314.9 288 350.1zM453.5 163.8c19.7 17.8 38.2 37 55.5 57.7c7.9-9.9 16.8-20.7 26.5-29.5c5.6-5.1 14.4-5.1 20 0c24.7 22.7 45.6 52.7 60.4 81.1c14.5 28 24.2 58.8 24.2 79C640 440 568.7 512 480 512c-89.7 0-160-72.1-160-159.8c0-26.4 12.7-60.7 32.4-92.6c20-32.4 48.1-66.1 81.4-95.8c2.8-2.5 6.4-3.8 10-3.7c3.5 0 7 1.3 9.8 3.8zM530 433c30-21 38-63 20-96c-2-4-4-8-7-12l-36 42s-58-74-62-79c-30 37-45 58-45 82c0 49 36 78 81 78c18 0 34-5 49-15z"
    ]
};
var $d8206b3ab2e65c05$export$814c9edba7b84aa4 = {
    prefix: "fas",
    iconName: "square-minus",
    icon: [
        448,
        512,
        [
            61767,
            "minus-square"
        ],
        "f146",
        "M64 32C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64zm88 200H296c13.3 0 24 10.7 24 24s-10.7 24-24 24H152c-13.3 0-24-10.7-24-24s10.7-24 24-24z"
    ]
};
var $d8206b3ab2e65c05$export$ffe9387966b3e681 = $d8206b3ab2e65c05$export$814c9edba7b84aa4;
var $d8206b3ab2e65c05$export$612d3e1afaf45fa5 = {
    prefix: "fas",
    iconName: "helicopter",
    icon: [
        640,
        512,
        [
            128641
        ],
        "f533",
        "M128 32c0-17.7 14.3-32 32-32H544c17.7 0 32 14.3 32 32s-14.3 32-32 32H384v64h32c88.4 0 160 71.6 160 160v64c0 17.7-14.3 32-32 32H384 320c-20.1 0-39.1-9.5-51.2-25.6l-71.4-95.2c-3.5-4.7-8.3-8.3-13.7-10.5L47.2 198.1c-9.5-3.8-16.7-12-19.2-22L5 83.9C2.4 73.8 10.1 64 20.5 64H48c10.1 0 19.6 4.7 25.6 12.8L112 128H320V64H160c-17.7 0-32-14.3-32-32zM384 320H512V288c0-53-43-96-96-96H384V320zM630.6 425.4c12.5 12.5 12.5 32.8 0 45.3l-3.9 3.9c-24 24-56.6 37.5-90.5 37.5H256c-17.7 0-32-14.3-32-32s14.3-32 32-32H536.2c17 0 33.3-6.7 45.3-18.7l3.9-3.9c12.5-12.5 32.8-12.5 45.3 0z"
    ]
};
var $d8206b3ab2e65c05$export$b4d344633433e50e = {
    prefix: "fas",
    iconName: "compass",
    icon: [
        512,
        512,
        [
            129517
        ],
        "f14e",
        "M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zm50.7-186.9L162.4 380.6c-19.4 7.5-38.5-11.6-31-31l55.5-144.3c3.3-8.5 9.9-15.1 18.4-18.4l144.3-55.5c19.4-7.5 38.5 11.6 31 31L325.1 306.7c-3.2 8.5-9.9 15.1-18.4 18.4zM288 256a32 32 0 1 0 -64 0 32 32 0 1 0 64 0z"
    ]
};
var $d8206b3ab2e65c05$export$a1ab39cd66c4e50e = {
    prefix: "fas",
    iconName: "square-caret-down",
    icon: [
        448,
        512,
        [
            "caret-square-down"
        ],
        "f150",
        "M384 480c35.3 0 64-28.7 64-64l0-320c0-35.3-28.7-64-64-64L64 32C28.7 32 0 60.7 0 96L0 416c0 35.3 28.7 64 64 64l320 0zM224 352c-6.7 0-13-2.8-17.6-7.7l-104-112c-6.5-7-8.2-17.2-4.4-25.9s12.5-14.4 22-14.4l208 0c9.5 0 18.2 5.7 22 14.4s2.1 18.9-4.4 25.9l-104 112c-4.5 4.9-10.9 7.7-17.6 7.7z"
    ]
};
var $d8206b3ab2e65c05$export$61aea18df1c84401 = $d8206b3ab2e65c05$export$a1ab39cd66c4e50e;
var $d8206b3ab2e65c05$export$877d3692c1f94bda = {
    prefix: "fas",
    iconName: "file-circle-question",
    icon: [
        576,
        512,
        [],
        "e4ef",
        "M0 64C0 28.7 28.7 0 64 0H224V128c0 17.7 14.3 32 32 32H384v38.6C310.1 219.5 256 287.4 256 368c0 59.1 29.1 111.3 73.7 143.3c-3.2 .5-6.4 .7-9.7 .7H64c-35.3 0-64-28.7-64-64V64zm384 64H256V0L384 128zm48 96a144 144 0 1 1 0 288 144 144 0 1 1 0-288zm0 240a24 24 0 1 0 0-48 24 24 0 1 0 0 48zM368 321.6V328c0 8.8 7.2 16 16 16s16-7.2 16-16v-6.4c0-5.3 4.3-9.6 9.6-9.6h40.5c7.7 0 13.9 6.2 13.9 13.9c0 5.2-2.9 9.9-7.4 12.3l-32 16.8c-5.3 2.8-8.6 8.2-8.6 14.2V384c0 8.8 7.2 16 16 16s16-7.2 16-16v-5.1l23.5-12.3c15.1-7.9 24.5-23.6 24.5-40.6c0-25.4-20.6-45.9-45.9-45.9H409.6c-23 0-41.6 18.6-41.6 41.6z"
    ]
};
var $d8206b3ab2e65c05$export$94100f4c6ee29932 = {
    prefix: "fas",
    iconName: "laptop-code",
    icon: [
        640,
        512,
        [],
        "f5fc",
        "M64 96c0-35.3 28.7-64 64-64H512c35.3 0 64 28.7 64 64V352H512V96H128V352H64V96zM0 403.2C0 392.6 8.6 384 19.2 384H620.8c10.6 0 19.2 8.6 19.2 19.2c0 42.4-34.4 76.8-76.8 76.8H76.8C34.4 480 0 445.6 0 403.2zM281 209l-31 31 31 31c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0l-48-48c-9.4-9.4-9.4-24.6 0-33.9l48-48c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9zM393 175l48 48c9.4 9.4 9.4 24.6 0 33.9l-48 48c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l31-31-31-31c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0z"
    ]
};
var $d8206b3ab2e65c05$export$c74a20c81b957b6a = {
    prefix: "fas",
    iconName: "swatchbook",
    icon: [
        512,
        512,
        [],
        "f5c3",
        "M0 32C0 14.3 14.3 0 32 0H160c17.7 0 32 14.3 32 32V416c0 53-43 96-96 96s-96-43-96-96V32zM223.6 425.9c.3-3.3 .4-6.6 .4-9.9V154l75.4-75.4c12.5-12.5 32.8-12.5 45.3 0l90.5 90.5c12.5 12.5 12.5 32.8 0 45.3L223.6 425.9zM182.8 512l192-192H480c17.7 0 32 14.3 32 32V480c0 17.7-14.3 32-32 32H182.8zM128 64H64v64h64V64zM64 192v64h64V192H64zM96 440a24 24 0 1 0 0-48 24 24 0 1 0 0 48z"
    ]
};
var $d8206b3ab2e65c05$export$214f9ce665590486 = {
    prefix: "fas",
    iconName: "prescription-bottle",
    icon: [
        384,
        512,
        [],
        "f485",
        "M0 32C0 14.3 14.3 0 32 0H352c17.7 0 32 14.3 32 32V64c0 17.7-14.3 32-32 32H32C14.3 96 0 81.7 0 64V32zm32 96H352V448c0 35.3-28.7 64-64 64H96c-35.3 0-64-28.7-64-64V416H144c8.8 0 16-7.2 16-16s-7.2-16-16-16H32V320H144c8.8 0 16-7.2 16-16s-7.2-16-16-16H32V224H144c8.8 0 16-7.2 16-16s-7.2-16-16-16H32V128z"
    ]
};
var $d8206b3ab2e65c05$export$36e9cf7887265da2 = {
    prefix: "fas",
    iconName: "bars",
    icon: [
        448,
        512,
        [
            "navicon"
        ],
        "f0c9",
        "M0 96C0 78.3 14.3 64 32 64H416c17.7 0 32 14.3 32 32s-14.3 32-32 32H32C14.3 128 0 113.7 0 96zM0 256c0-17.7 14.3-32 32-32H416c17.7 0 32 14.3 32 32s-14.3 32-32 32H32c-17.7 0-32-14.3-32-32zM448 416c0 17.7-14.3 32-32 32H32c-17.7 0-32-14.3-32-32s14.3-32 32-32H416c17.7 0 32 14.3 32 32z"
    ]
};
var $d8206b3ab2e65c05$export$409fa7bcaa0e4cd9 = $d8206b3ab2e65c05$export$36e9cf7887265da2;
var $d8206b3ab2e65c05$export$be015e72863c3635 = {
    prefix: "fas",
    iconName: "people-group",
    icon: [
        640,
        512,
        [],
        "e533",
        "M72 88a56 56 0 1 1 112 0A56 56 0 1 1 72 88zM64 245.7C54 256.9 48 271.8 48 288s6 31.1 16 42.3V245.7zm144.4-49.3C178.7 222.7 160 261.2 160 304c0 34.3 12 65.8 32 90.5V416c0 17.7-14.3 32-32 32H96c-17.7 0-32-14.3-32-32V389.2C26.2 371.2 0 332.7 0 288c0-61.9 50.1-112 112-112h32c24 0 46.2 7.5 64.4 20.3zM448 416V394.5c20-24.7 32-56.2 32-90.5c0-42.8-18.7-81.3-48.4-107.7C449.8 183.5 472 176 496 176h32c61.9 0 112 50.1 112 112c0 44.7-26.2 83.2-64 101.2V416c0 17.7-14.3 32-32 32H480c-17.7 0-32-14.3-32-32zm8-328a56 56 0 1 1 112 0A56 56 0 1 1 456 88zM576 245.7v84.7c10-11.3 16-26.1 16-42.3s-6-31.1-16-42.3zM320 32a64 64 0 1 1 0 128 64 64 0 1 1 0-128zM240 304c0 16.2 6 31 16 42.3V261.7c-10 11.3-16 26.1-16 42.3zm144-42.3v84.7c10-11.3 16-26.1 16-42.3s-6-31.1-16-42.3zM448 304c0 44.7-26.2 83.2-64 101.2V448c0 17.7-14.3 32-32 32H288c-17.7 0-32-14.3-32-32V405.2c-37.8-18-64-56.5-64-101.2c0-61.9 50.1-112 112-112h32c61.9 0 112 50.1 112 112z"
    ]
};
var $d8206b3ab2e65c05$export$52757ecc5b1e25b9 = {
    prefix: "fas",
    iconName: "hourglass-end",
    icon: [
        384,
        512,
        [
            8987,
            "hourglass-3"
        ],
        "f253",
        "M32 0C14.3 0 0 14.3 0 32S14.3 64 32 64V75c0 42.4 16.9 83.1 46.9 113.1L146.7 256 78.9 323.9C48.9 353.9 32 394.6 32 437v11c-17.7 0-32 14.3-32 32s14.3 32 32 32H64 320h32c17.7 0 32-14.3 32-32s-14.3-32-32-32V437c0-42.4-16.9-83.1-46.9-113.1L237.3 256l67.9-67.9c30-30 46.9-70.7 46.9-113.1V64c17.7 0 32-14.3 32-32s-14.3-32-32-32H320 64 32zM96 75V64H288V75c0 25.5-10.1 49.9-28.1 67.9L192 210.7l-67.9-67.9C106.1 124.9 96 100.4 96 75z"
    ]
};
var $d8206b3ab2e65c05$export$1ec43c81fef8ffd6 = $d8206b3ab2e65c05$export$52757ecc5b1e25b9;
var $d8206b3ab2e65c05$export$8e521ef33062b00e = {
    prefix: "fas",
    iconName: "heart-crack",
    icon: [
        512,
        512,
        [
            128148,
            "heart-broken"
        ],
        "f7a9",
        "M119.4 44.1c23.3-3.9 46.8-1.9 68.6 5.3l49.8 77.5-75.4 75.4c-1.5 1.5-2.4 3.6-2.3 5.8s1 4.2 2.6 5.7l112 104c2.9 2.7 7.4 2.9 10.5 .3s3.8-7 1.7-10.4l-60.4-98.1 90.7-75.6c2.6-2.1 3.5-5.7 2.4-8.8L296.8 61.8c28.5-16.7 62.4-23.2 95.7-17.6C461.5 55.6 512 115.2 512 185.1v5.8c0 41.5-17.2 81.2-47.6 109.5L283.7 469.1c-7.5 7-17.4 10.9-27.7 10.9s-20.2-3.9-27.7-10.9L47.6 300.4C17.2 272.1 0 232.4 0 190.9v-5.8c0-69.9 50.5-129.5 119.4-141z"
    ]
};
var $d8206b3ab2e65c05$export$4a565395cb65b282 = $d8206b3ab2e65c05$export$8e521ef33062b00e;
var $d8206b3ab2e65c05$export$a47a20ab7bde8c67 = {
    prefix: "fas",
    iconName: "square-up-right",
    icon: [
        448,
        512,
        [
            8599,
            "external-link-square-alt"
        ],
        "f360",
        "M384 32c35.3 0 64 28.7 64 64V416c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96C0 60.7 28.7 32 64 32H384zM320 313.4V176c0-8.8-7.2-16-16-16H166.6c-12.5 0-22.6 10.1-22.6 22.6c0 6 2.4 11.8 6.6 16L184 232l-66.3 66.3C114 302 112 306.9 112 312s2 10 5.7 13.7l36.7 36.7c3.6 3.6 8.5 5.7 13.7 5.7s10-2 13.7-5.7L248 296l33.4 33.4c4.2 4.2 10 6.6 16 6.6c12.5 0 22.6-10.1 22.6-22.6z"
    ]
};
var $d8206b3ab2e65c05$export$e4cdf2977151ee26 = $d8206b3ab2e65c05$export$a47a20ab7bde8c67;
var $d8206b3ab2e65c05$export$eca99665af566fe1 = {
    prefix: "fas",
    iconName: "face-kiss-beam",
    icon: [
        512,
        512,
        [
            128537,
            "kiss-beam"
        ],
        "f597",
        "M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zm48.7-198.3c4.3 5.1 7.3 11.4 7.3 18.3s-3.1 13.2-7.3 18.3c-4.3 5.2-10.1 9.7-16.7 13.4c-2.7 1.5-5.7 3-8.7 4.3c3.1 1.3 6 2.7 8.7 4.3c6.6 3.7 12.5 8.2 16.7 13.4c4.3 5.1 7.3 11.4 7.3 18.3s-3.1 13.2-7.3 18.3c-4.3 5.2-10.1 9.7-16.7 13.4C274.7 443.1 257.4 448 240 448c-3.6 0-6.8-2.5-7.7-6s.6-7.2 3.8-9l0 0 0 0 0 0 0 0 .2-.1c.2-.1 .5-.3 .9-.5c.8-.5 2-1.2 3.4-2.1c2.8-1.9 6.5-4.5 10.2-7.6c3.7-3.1 7.2-6.6 9.6-10.1c2.5-3.5 3.5-6.4 3.5-8.6s-1-5-3.5-8.6c-2.5-3.5-5.9-6.9-9.6-10.1c-3.7-3.1-7.4-5.7-10.2-7.6c-1.4-.9-2.6-1.6-3.4-2.1c-.4-.2-.7-.4-.9-.5l-.2-.1 0 0 0 0 0 0c-2.5-1.4-4.1-4.1-4.1-7s1.6-5.6 4.1-7l0 0 0 0 0 0 0 0 0 0 .2-.1 .3-.2 .6-.4c.8-.5 2-1.2 3.4-2.1c2.8-1.9 6.5-4.5 10.2-7.6c3.7-3.1 7.2-6.6 9.6-10.1c2.5-3.5 3.5-6.4 3.5-8.6s-1-5-3.5-8.6c-2.5-3.5-5.9-6.9-9.6-10.1c-3.7-3.1-7.4-5.7-10.2-7.6c-1.4-.9-2.6-1.6-3.4-2.1l-.4-.3-.5-.3-.2-.1 0 0 0 0 0 0c-3.2-1.8-4.7-5.5-3.8-9s4.1-6 7.7-6c17.4 0 34.7 4.9 47.9 12.3c6.6 3.7 12.5 8.2 16.7 13.4zm-87.1-84.9l0 0 0 0-.2-.2c-.2-.2-.4-.5-.7-.9c-.6-.8-1.6-2-2.8-3.4c-2.5-2.8-6-6.6-10.2-10.3c-8.8-7.8-18.8-14-27.7-14s-18.9 6.2-27.7 14c-4.2 3.7-7.7 7.5-10.2 10.3c-1.2 1.4-2.2 2.6-2.8 3.4c-.3 .4-.6 .7-.7 .9l-.2 .2 0 0 0 0 0 0c-2.1 2.8-5.7 3.9-8.9 2.8s-5.5-4.1-5.5-7.6c0-17.9 6.7-35.6 16.6-48.8c9.8-13 23.9-23.2 39.4-23.2s29.6 10.2 39.4 23.2c9.9 13.2 16.6 30.9 16.6 48.8c0 3.4-2.2 6.5-5.5 7.6s-6.9 0-8.9-2.8l0 0 0 0zm160 0l0 0-.2-.2c-.2-.2-.4-.5-.7-.9c-.6-.8-1.6-2-2.8-3.4c-2.5-2.8-6-6.6-10.2-10.3c-8.8-7.8-18.8-14-27.7-14s-18.9 6.2-27.7 14c-4.2 3.7-7.7 7.5-10.2 10.3c-1.2 1.4-2.2 2.6-2.8 3.4c-.3 .4-.6 .7-.7 .9l-.2 .2 0 0 0 0 0 0c-2.1 2.8-5.7 3.9-8.9 2.8s-5.5-4.1-5.5-7.6c0-17.9 6.7-35.6 16.6-48.8c9.8-13 23.9-23.2 39.4-23.2s29.6 10.2 39.4 23.2c9.9 13.2 16.6 30.9 16.6 48.8c0 3.4-2.2 6.5-5.5 7.6s-6.9 0-8.9-2.8l0 0 0 0 0 0z"
    ]
};
var $d8206b3ab2e65c05$export$d6ff8a73c0812e63 = $d8206b3ab2e65c05$export$eca99665af566fe1;
var $d8206b3ab2e65c05$export$c03de0cc616e77bb = {
    prefix: "fas",
    iconName: "film",
    icon: [
        512,
        512,
        [
            127902
        ],
        "f008",
        "M0 96C0 60.7 28.7 32 64 32H448c35.3 0 64 28.7 64 64V416c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96zM48 368v32c0 8.8 7.2 16 16 16H96c8.8 0 16-7.2 16-16V368c0-8.8-7.2-16-16-16H64c-8.8 0-16 7.2-16 16zm368-16c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V368c0-8.8-7.2-16-16-16H416zM48 240v32c0 8.8 7.2 16 16 16H96c8.8 0 16-7.2 16-16V240c0-8.8-7.2-16-16-16H64c-8.8 0-16 7.2-16 16zm368-16c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V240c0-8.8-7.2-16-16-16H416zM48 112v32c0 8.8 7.2 16 16 16H96c8.8 0 16-7.2 16-16V112c0-8.8-7.2-16-16-16H64c-8.8 0-16 7.2-16 16zM416 96c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V112c0-8.8-7.2-16-16-16H416zM160 128v64c0 17.7 14.3 32 32 32H320c17.7 0 32-14.3 32-32V128c0-17.7-14.3-32-32-32H192c-17.7 0-32 14.3-32 32zm32 160c-17.7 0-32 14.3-32 32v64c0 17.7 14.3 32 32 32H320c17.7 0 32-14.3 32-32V320c0-17.7-14.3-32-32-32H192z"
    ]
};
var $d8206b3ab2e65c05$export$46c6347bff3e04a = {
    prefix: "fas",
    iconName: "ruler-horizontal",
    icon: [
        640,
        512,
        [],
        "f547",
        "M0 336c0 26.5 21.5 48 48 48l544 0c26.5 0 48-21.5 48-48l0-160c0-26.5-21.5-48-48-48l-64 0 0 80c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-80-64 0 0 80c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-80-64 0 0 80c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-80-64 0 0 80c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-80-64 0 0 80c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-80-64 0c-26.5 0-48 21.5-48 48L0 336z"
    ]
};
var $d8206b3ab2e65c05$export$75ce8513e1f1c5c4 = {
    prefix: "fas",
    iconName: "people-robbery",
    icon: [
        576,
        512,
        [],
        "e536",
        "M488.2 59.1C478.1 99.6 441.7 128 400 128s-78.1-28.4-88.2-68.9L303 24.2C298.8 7.1 281.4-3.3 264.2 1S236.7 22.6 241 39.8l8.7 34.9c11 44 40.2 79.6 78.3 99.6V480c0 17.7 14.3 32 32 32s32-14.3 32-32V352h16V480c0 17.7 14.3 32 32 32s32-14.3 32-32V174.3c38.1-20 67.3-55.6 78.3-99.6L559 39.8c4.3-17.1-6.1-34.5-23.3-38.8S501.2 7.1 497 24.2l-8.7 34.9zM400 96a48 48 0 1 0 0-96 48 48 0 1 0 0 96zM80 96A48 48 0 1 0 80 0a48 48 0 1 0 0 96zm-8 32c-35.3 0-64 28.7-64 64v96l0 .6V480c0 17.7 14.3 32 32 32s32-14.3 32-32V352H88V480c0 17.7 14.3 32 32 32s32-14.3 32-32V252.7l13 20.5c5.9 9.2 16.1 14.9 27 14.9h48c17.7 0 32-14.3 32-32s-14.3-32-32-32H209.6l-37.4-58.9C157.6 142 132.1 128 104.7 128H72z"
    ]
};
var $d8206b3ab2e65c05$export$1e80f89fe84a215b = {
    prefix: "fas",
    iconName: "lightbulb",
    icon: [
        384,
        512,
        [
            128161
        ],
        "f0eb",
        "M272 384c9.6-31.9 29.5-59.1 49.2-86.2l0 0c5.2-7.1 10.4-14.2 15.4-21.4c19.8-28.5 31.4-63 31.4-100.3C368 78.8 289.2 0 192 0S16 78.8 16 176c0 37.3 11.6 71.9 31.4 100.3c5 7.2 10.2 14.3 15.4 21.4l0 0c19.8 27.1 39.7 54.4 49.2 86.2H272zM192 512c44.2 0 80-35.8 80-80V416H112v16c0 44.2 35.8 80 80 80zM112 176c0 8.8-7.2 16-16 16s-16-7.2-16-16c0-61.9 50.1-112 112-112c8.8 0 16 7.2 16 16s-7.2 16-16 16c-44.2 0-80 35.8-80 80z"
    ]
};
var $d8206b3ab2e65c05$export$85a918a11b7643c2 = {
    prefix: "fas",
    iconName: "caret-left",
    icon: [
        256,
        512,
        [],
        "f0d9",
        "M9.4 278.6c-12.5-12.5-12.5-32.8 0-45.3l128-128c9.2-9.2 22.9-11.9 34.9-6.9s19.8 16.6 19.8 29.6l0 256c0 12.9-7.8 24.6-19.8 29.6s-25.7 2.2-34.9-6.9l-128-128z"
    ]
};
var $d8206b3ab2e65c05$export$59573943f9eebbd5 = {
    prefix: "fas",
    iconName: "circle-exclamation",
    icon: [
        512,
        512,
        [
            "exclamation-circle"
        ],
        "f06a",
        "M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zm0-384c13.3 0 24 10.7 24 24V264c0 13.3-10.7 24-24 24s-24-10.7-24-24V152c0-13.3 10.7-24 24-24zM224 352a32 32 0 1 1 64 0 32 32 0 1 1 -64 0z"
    ]
};
var $d8206b3ab2e65c05$export$220e07e14c5d7e5d = $d8206b3ab2e65c05$export$59573943f9eebbd5;
var $d8206b3ab2e65c05$export$5e17b20e0f6b132b = {
    prefix: "fas",
    iconName: "school-circle-xmark",
    icon: [
        640,
        512,
        [],
        "e56d",
        "M337.8 5.4C327-1.8 313-1.8 302.2 5.4L166.3 96H48C21.5 96 0 117.5 0 144V464c0 26.5 21.5 48 48 48H320v0H256V416c0-35.3 28.7-64 64-64l.3 0h.5c3.4-37.7 18.7-72.1 42.2-99.1C350.2 260 335.6 264 320 264c-48.6 0-88-39.4-88-88s39.4-88 88-88s88 39.4 88 88c0 18.3-5.6 35.3-15.1 49.4c29-21 64.6-33.4 103.1-33.4c59.5 0 112.1 29.6 144 74.8V144c0-26.5-21.5-48-48-48H473.7L337.8 5.4zM96 192h32c8.8 0 16 7.2 16 16v64c0 8.8-7.2 16-16 16H96c-8.8 0-16-7.2-16-16V208c0-8.8 7.2-16 16-16zm0 128h32c8.8 0 16 7.2 16 16v64c0 8.8-7.2 16-16 16H96c-8.8 0-16-7.2-16-16V336c0-8.8 7.2-16 16-16zM320 128c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16s-7.2-16-16-16H336V144c0-8.8-7.2-16-16-16zM496 512a144 144 0 1 0 0-288 144 144 0 1 0 0 288zm22.6-144l36.7 36.7c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0L496 390.6l-36.7 36.7c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6L473.4 368l-36.7-36.7c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0L496 345.4l36.7-36.7c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6L518.6 368z"
    ]
};
var $d8206b3ab2e65c05$export$ca14f1b4d6afb7aa = {
    prefix: "fas",
    iconName: "arrow-right-from-bracket",
    icon: [
        512,
        512,
        [
            "sign-out"
        ],
        "f08b",
        "M502.6 278.6c12.5-12.5 12.5-32.8 0-45.3l-128-128c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3L402.7 224 192 224c-17.7 0-32 14.3-32 32s14.3 32 32 32l210.7 0-73.4 73.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0l128-128zM160 96c17.7 0 32-14.3 32-32s-14.3-32-32-32L96 32C43 32 0 75 0 128L0 384c0 53 43 96 96 96l64 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l-64 0c-17.7 0-32-14.3-32-32l0-256c0-17.7 14.3-32 32-32l64 0z"
    ]
};
var $d8206b3ab2e65c05$export$33e2b60243ca6d92 = $d8206b3ab2e65c05$export$ca14f1b4d6afb7aa;
var $d8206b3ab2e65c05$export$aca07924996218d8 = {
    prefix: "fas",
    iconName: "circle-chevron-down",
    icon: [
        512,
        512,
        [
            "chevron-circle-down"
        ],
        "f13a",
        "M256 0a256 256 0 1 0 0 512A256 256 0 1 0 256 0zM135 241c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l87 87 87-87c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9L273 345c-9.4 9.4-24.6 9.4-33.9 0L135 241z"
    ]
};
var $d8206b3ab2e65c05$export$9926124d75b2ecab = $d8206b3ab2e65c05$export$aca07924996218d8;
var $d8206b3ab2e65c05$export$c98fdd5082b333ec = {
    prefix: "fas",
    iconName: "unlock-keyhole",
    icon: [
        448,
        512,
        [
            "unlock-alt"
        ],
        "f13e",
        "M224 64c-44.2 0-80 35.8-80 80v48H384c35.3 0 64 28.7 64 64V448c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V256c0-35.3 28.7-64 64-64H80V144C80 64.5 144.5 0 224 0c57.5 0 107 33.7 130.1 82.3c7.6 16 .8 35.1-15.2 42.6s-35.1 .8-42.6-15.2C283.4 82.6 255.9 64 224 64zm32 320c17.7 0 32-14.3 32-32s-14.3-32-32-32H192c-17.7 0-32 14.3-32 32s14.3 32 32 32h64z"
    ]
};
var $d8206b3ab2e65c05$export$b19f508797f3d9c3 = $d8206b3ab2e65c05$export$c98fdd5082b333ec;
var $d8206b3ab2e65c05$export$af51c741ee9cc090 = {
    prefix: "fas",
    iconName: "cloud-showers-heavy",
    icon: [
        512,
        512,
        [],
        "f740",
        "M96 320c-53 0-96-43-96-96c0-42.5 27.6-78.6 65.9-91.2C64.7 126.1 64 119.1 64 112C64 50.1 114.1 0 176 0c43.1 0 80.5 24.3 99.2 60c14.7-17.1 36.5-28 60.8-28c44.2 0 80 35.8 80 80c0 5.5-.6 10.8-1.6 16c.5 0 1.1 0 1.6 0c53 0 96 43 96 96s-43 96-96 96H96zM81.5 353.9c12.2 5.2 17.8 19.3 12.6 31.5l-48 112c-5.2 12.2-19.3 17.8-31.5 12.6S-3.3 490.7 1.9 478.5l48-112c5.2-12.2 19.3-17.8 31.5-12.6zm120 0c12.2 5.2 17.8 19.3 12.6 31.5l-48 112c-5.2 12.2-19.3 17.8-31.5 12.6s-17.8-19.3-12.6-31.5l48-112c5.2-12.2 19.3-17.8 31.5-12.6zm244.6 31.5l-48 112c-5.2 12.2-19.3 17.8-31.5 12.6s-17.8-19.3-12.6-31.5l48-112c5.2-12.2 19.3-17.8 31.5-12.6s17.8 19.3 12.6 31.5zM313.5 353.9c12.2 5.2 17.8 19.3 12.6 31.5l-48 112c-5.2 12.2-19.3 17.8-31.5 12.6s-17.8-19.3-12.6-31.5l48-112c5.2-12.2 19.3-17.8 31.5-12.6z"
    ]
};
var $d8206b3ab2e65c05$export$ca47801915e5a685 = {
    prefix: "fas",
    iconName: "headphones-simple",
    icon: [
        512,
        512,
        [
            "headphones-alt"
        ],
        "f58f",
        "M256 80C141.1 80 48 173.1 48 288V392c0 13.3-10.7 24-24 24s-24-10.7-24-24V288C0 146.6 114.6 32 256 32s256 114.6 256 256V392c0 13.3-10.7 24-24 24s-24-10.7-24-24V288c0-114.9-93.1-208-208-208zM80 352c0-35.3 28.7-64 64-64h16c17.7 0 32 14.3 32 32V448c0 17.7-14.3 32-32 32H144c-35.3 0-64-28.7-64-64V352zm288-64c35.3 0 64 28.7 64 64v64c0 35.3-28.7 64-64 64H352c-17.7 0-32-14.3-32-32V320c0-17.7 14.3-32 32-32h16z"
    ]
};
var $d8206b3ab2e65c05$export$6f0433fa527dd5be = $d8206b3ab2e65c05$export$ca47801915e5a685;
var $d8206b3ab2e65c05$export$b2ce5e79d0eccaf8 = {
    prefix: "fas",
    iconName: "sitemap",
    icon: [
        576,
        512,
        [],
        "f0e8",
        "M208 80c0-26.5 21.5-48 48-48h64c26.5 0 48 21.5 48 48v64c0 26.5-21.5 48-48 48h-8v40H464c30.9 0 56 25.1 56 56v32h8c26.5 0 48 21.5 48 48v64c0 26.5-21.5 48-48 48H464c-26.5 0-48-21.5-48-48V368c0-26.5 21.5-48 48-48h8V288c0-4.4-3.6-8-8-8H312v40h8c26.5 0 48 21.5 48 48v64c0 26.5-21.5 48-48 48H256c-26.5 0-48-21.5-48-48V368c0-26.5 21.5-48 48-48h8V280H112c-4.4 0-8 3.6-8 8v32h8c26.5 0 48 21.5 48 48v64c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V368c0-26.5 21.5-48 48-48h8V288c0-30.9 25.1-56 56-56H264V192h-8c-26.5 0-48-21.5-48-48V80z"
    ]
};
var $d8206b3ab2e65c05$export$5f92ac3e804644e3 = {
    prefix: "fas",
    iconName: "circle-dollar-to-slot",
    icon: [
        512,
        512,
        [
            "donate"
        ],
        "f4b9",
        "M326.7 403.7c-22.1 8-45.9 12.3-70.7 12.3s-48.7-4.4-70.7-12.3c-.3-.1-.5-.2-.8-.3c-30-11-56.8-28.7-78.6-51.4C70 314.6 48 263.9 48 208C48 93.1 141.1 0 256 0S464 93.1 464 208c0 55.9-22 106.6-57.9 144c-1 1-2 2.1-3 3.1c-21.4 21.4-47.4 38.1-76.3 48.6zM256 91.9c-11.1 0-20.1 9-20.1 20.1v6c-5.6 1.2-10.9 2.9-15.9 5.1c-15 6.8-27.9 19.4-31.1 37.7c-1.8 10.2-.8 20 3.4 29c4.2 8.8 10.7 15 17.3 19.5c11.6 7.9 26.9 12.5 38.6 16l2.2 .7c13.9 4.2 23.4 7.4 29.3 11.7c2.5 1.8 3.4 3.2 3.7 4c.3 .8 .9 2.6 .2 6.7c-.6 3.5-2.5 6.4-8 8.8c-6.1 2.6-16 3.9-28.8 1.9c-6-1-16.7-4.6-26.2-7.9l0 0 0 0 0 0c-2.2-.7-4.3-1.5-6.4-2.1c-10.5-3.5-21.8 2.2-25.3 12.7s2.2 21.8 12.7 25.3c1.2 .4 2.7 .9 4.4 1.5c7.9 2.7 20.3 6.9 29.8 9.1V304c0 11.1 9 20.1 20.1 20.1s20.1-9 20.1-20.1v-5.5c5.3-1 10.5-2.5 15.4-4.6c15.7-6.7 28.4-19.7 31.6-38.7c1.8-10.4 1-20.3-3-29.4c-3.9-9-10.2-15.6-16.9-20.5c-12.2-8.8-28.3-13.7-40.4-17.4l-.8-.2c-14.2-4.3-23.8-7.3-29.9-11.4c-2.6-1.8-3.4-3-3.6-3.5c-.2-.3-.7-1.6-.1-5c.3-1.9 1.9-5.2 8.2-8.1c6.4-2.9 16.4-4.5 28.6-2.6c4.3 .7 17.9 3.3 21.7 4.3c10.7 2.8 21.6-3.5 24.5-14.2s-3.5-21.6-14.2-24.5c-4.4-1.2-14.4-3.2-21-4.4V112c0-11.1-9-20.1-20.1-20.1zM48 352H64c19.5 25.9 44 47.7 72.2 64H64v32H256 448V416H375.8c28.2-16.3 52.8-38.1 72.2-64h16c26.5 0 48 21.5 48 48v64c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V400c0-26.5 21.5-48 48-48z"
    ]
};
var $d8206b3ab2e65c05$export$40050ae52860cde7 = $d8206b3ab2e65c05$export$5f92ac3e804644e3;
var $d8206b3ab2e65c05$export$5f9bd9f6df021f93 = {
    prefix: "fas",
    iconName: "memory",
    icon: [
        576,
        512,
        [],
        "f538",
        "M64 64C28.7 64 0 92.7 0 128v7.4c0 6.8 4.4 12.6 10.1 16.3C23.3 160.3 32 175.1 32 192s-8.7 31.7-21.9 40.3C4.4 236 0 241.8 0 248.6V320H576V248.6c0-6.8-4.4-12.6-10.1-16.3C552.7 223.7 544 208.9 544 192s8.7-31.7 21.9-40.3c5.7-3.7 10.1-9.5 10.1-16.3V128c0-35.3-28.7-64-64-64H64zM576 352H0v64c0 17.7 14.3 32 32 32H80V416c0-8.8 7.2-16 16-16s16 7.2 16 16v32h96V416c0-8.8 7.2-16 16-16s16 7.2 16 16v32h96V416c0-8.8 7.2-16 16-16s16 7.2 16 16v32h96V416c0-8.8 7.2-16 16-16s16 7.2 16 16v32h48c17.7 0 32-14.3 32-32V352zM192 160v64c0 17.7-14.3 32-32 32s-32-14.3-32-32V160c0-17.7 14.3-32 32-32s32 14.3 32 32zm128 0v64c0 17.7-14.3 32-32 32s-32-14.3-32-32V160c0-17.7 14.3-32 32-32s32 14.3 32 32zm128 0v64c0 17.7-14.3 32-32 32s-32-14.3-32-32V160c0-17.7 14.3-32 32-32s32 14.3 32 32z"
    ]
};
var $d8206b3ab2e65c05$export$b372a24046126ad8 = {
    prefix: "fas",
    iconName: "road-spikes",
    icon: [
        640,
        512,
        [],
        "e568",
        "M64 116.8c0-15.8 20.5-22 29.3-8.9L192 256V116.8c0-15.8 20.5-22 29.3-8.9L320 256V116.8c0-15.8 20.5-22 29.3-8.9L448 256V116.8c0-15.8 20.5-22 29.3-8.9L606.8 302.2c14.2 21.3-1.1 49.7-26.6 49.7H512 448 384 320 256 192 64V116.8zM32 384H608c17.7 0 32 14.3 32 32s-14.3 32-32 32H32c-17.7 0-32-14.3-32-32s14.3-32 32-32z"
    ]
};
var $d8206b3ab2e65c05$export$e4e44f7b1886fef = {
    prefix: "fas",
    iconName: "fire-burner",
    icon: [
        640,
        512,
        [],
        "e4f1",
        "M293.5 3.8c19.7 17.8 38.2 37 55.5 57.7c7.9-9.9 16.8-20.7 26.5-29.5c5.6-5.1 14.4-5.1 20 0c24.7 22.7 45.6 52.7 60.4 81.1c14.5 28 24.2 58.8 24.2 79C480 280 408.7 352 320 352c-89.7 0-160-72.1-160-159.8c0-26.4 12.7-60.7 32.4-92.6c20-32.4 48.1-66.1 81.4-95.8c2.8-2.5 6.4-3.8 10-3.7c3.5 0 7 1.3 9.8 3.8zM370 273c30-21 38-63 20-96c-2-4-4-8-7-12l-36 42s-58-74-62-79c-30 37-45 58-45 82c0 49 36 78 81 78c18 0 34-5 49-15zM32 288c0-17.7 14.3-32 32-32H96c17.7 0 32 14.3 32 32s-14.3 32-32 32v64H544V320c-17.7 0-32-14.3-32-32s14.3-32 32-32h32c17.7 0 32 14.3 32 32v96c17.7 0 32 14.3 32 32v64c0 17.7-14.3 32-32 32H32c-17.7 0-32-14.3-32-32V416c0-17.7 14.3-32 32-32V288zM320 480a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm160-32a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zM192 480a32 32 0 1 0 0-64 32 32 0 1 0 0 64z"
    ]
};
var $d8206b3ab2e65c05$export$6591b1ea509be9da = {
    prefix: "fas",
    iconName: "flag",
    icon: [
        448,
        512,
        [
            127988,
            61725
        ],
        "f024",
        "M64 32C64 14.3 49.7 0 32 0S0 14.3 0 32V64 368 480c0 17.7 14.3 32 32 32s32-14.3 32-32V352l64.3-16.1c41.1-10.3 84.6-5.5 122.5 13.4c44.2 22.1 95.5 24.8 141.7 7.4l34.7-13c12.5-4.7 20.8-16.6 20.8-30V66.1c0-23-24.2-38-44.8-27.7l-9.6 4.8c-46.3 23.2-100.8 23.2-147.1 0c-35.1-17.6-75.4-22-113.5-12.5L64 48V32z"
    ]
};
var $d8206b3ab2e65c05$export$3dcd4ca3f7108a82 = {
    prefix: "fas",
    iconName: "hanukiah",
    icon: [
        640,
        512,
        [
            128334
        ],
        "f6e6",
        "M314.2 3.3C309.1 12.1 296 36.6 296 56c0 13.3 10.7 24 24 24s24-10.7 24-24c0-19.4-13.1-43.9-18.2-52.7C324.6 1.2 322.4 0 320 0s-4.6 1.2-5.8 3.3zm-288 48C21.1 60.1 8 84.6 8 104c0 13.3 10.7 24 24 24s24-10.7 24-24c0-19.4-13.1-43.9-18.2-52.7C36.6 49.2 34.4 48 32 48s-4.6 1.2-5.8 3.3zM88 104c0 13.3 10.7 24 24 24s24-10.7 24-24c0-19.4-13.1-43.9-18.2-52.7c-1.2-2.1-3.4-3.3-5.8-3.3s-4.6 1.2-5.8 3.3C101.1 60.1 88 84.6 88 104zm82.2-52.7C165.1 60.1 152 84.6 152 104c0 13.3 10.7 24 24 24s24-10.7 24-24c0-19.4-13.1-43.9-18.2-52.7c-1.2-2.1-3.4-3.3-5.8-3.3s-4.6 1.2-5.8 3.3zM216 104c0 13.3 10.7 24 24 24s24-10.7 24-24c0-19.4-13.1-43.9-18.2-52.7c-1.2-2.1-3.4-3.3-5.8-3.3s-4.6 1.2-5.8 3.3C229.1 60.1 216 84.6 216 104zM394.2 51.3C389.1 60.1 376 84.6 376 104c0 13.3 10.7 24 24 24s24-10.7 24-24c0-19.4-13.1-43.9-18.2-52.7c-1.2-2.1-3.4-3.3-5.8-3.3s-4.6 1.2-5.8 3.3zM440 104c0 13.3 10.7 24 24 24s24-10.7 24-24c0-19.4-13.1-43.9-18.2-52.7c-1.2-2.1-3.4-3.3-5.8-3.3s-4.6 1.2-5.8 3.3C453.1 60.1 440 84.6 440 104zm82.2-52.7C517.1 60.1 504 84.6 504 104c0 13.3 10.7 24 24 24s24-10.7 24-24c0-19.4-13.1-43.9-18.2-52.7c-1.2-2.1-3.4-3.3-5.8-3.3s-4.6 1.2-5.8 3.3zM584 104c0 13.3 10.7 24 24 24s24-10.7 24-24c0-19.4-13.1-43.9-18.2-52.7c-1.2-2.1-3.4-3.3-5.8-3.3s-4.6 1.2-5.8 3.3C597.1 60.1 584 84.6 584 104zM112 160c-8.8 0-16 7.2-16 16v96 16h32V272 176c0-8.8-7.2-16-16-16zm64 0c-8.8 0-16 7.2-16 16v96 16h32V272 176c0-8.8-7.2-16-16-16zm64 0c-8.8 0-16 7.2-16 16v96 16h32V272 176c0-8.8-7.2-16-16-16zm160 0c-8.8 0-16 7.2-16 16v96 16h32V272 176c0-8.8-7.2-16-16-16zm64 0c-8.8 0-16 7.2-16 16v96 16h32V272 176c0-8.8-7.2-16-16-16zm64 0c-8.8 0-16 7.2-16 16v96 16h32V272 176c0-8.8-7.2-16-16-16zM352 144c0-17.7-14.3-32-32-32s-32 14.3-32 32V320H96c-17.7 0-32-14.3-32-32V192c0-17.7-14.3-32-32-32s-32 14.3-32 32v96c0 53 43 96 96 96H288v64H160c-17.7 0-32 14.3-32 32s14.3 32 32 32H320 480c17.7 0 32-14.3 32-32s-14.3-32-32-32H352V384H544c53 0 96-43 96-96V192c0-17.7-14.3-32-32-32s-32 14.3-32 32v96c0 17.7-14.3 32-32 32H352V144z"
    ]
};
var $d8206b3ab2e65c05$export$5e19aea195b31816 = {
    prefix: "fas",
    iconName: "feather",
    icon: [
        512,
        512,
        [
            129718
        ],
        "f52d",
        "M278.5 215.6L23 471c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l57-57h68c49.7 0 97.9-14.4 139-41c11.1-7.2 5.5-23-7.8-23c-5.1 0-9.2-4.1-9.2-9.2c0-4.1 2.7-7.6 6.5-8.8l81-24.3c2.5-.8 4.8-2.1 6.7-4l22.4-22.4c10.1-10.1 2.9-27.3-11.3-27.3l-32.2 0c-5.1 0-9.2-4.1-9.2-9.2c0-4.1 2.7-7.6 6.5-8.8l112-33.6c4-1.2 7.4-3.9 9.3-7.7C506.4 207.6 512 184.1 512 160c0-41-16.3-80.3-45.3-109.3l-5.5-5.5C432.3 16.3 393 0 352 0s-80.3 16.3-109.3 45.3L139 149C91 197 64 262.1 64 330v55.3L253.6 195.8c6.2-6.2 16.4-6.2 22.6 0c5.4 5.4 6.1 13.6 2.2 19.8z"
    ]
};
var $d8206b3ab2e65c05$export$2b1464e7557b18eb = {
    prefix: "fas",
    iconName: "volume-low",
    icon: [
        448,
        512,
        [
            128264,
            "volume-down"
        ],
        "f027",
        "M301.1 34.8C312.6 40 320 51.4 320 64V448c0 12.6-7.4 24-18.9 29.2s-25 3.1-34.4-5.3L131.8 352H64c-35.3 0-64-28.7-64-64V224c0-35.3 28.7-64 64-64h67.8L266.7 40.1c9.4-8.4 22.9-10.4 34.4-5.3zM412.6 181.5C434.1 199.1 448 225.9 448 256s-13.9 56.9-35.4 74.5c-10.3 8.4-25.4 6.8-33.8-3.5s-6.8-25.4 3.5-33.8C393.1 284.4 400 271 400 256s-6.9-28.4-17.7-37.3c-10.3-8.4-11.8-23.5-3.5-33.8s23.5-11.8 33.8-3.5z"
    ]
};
var $d8206b3ab2e65c05$export$69fdf57632b6cc29 = $d8206b3ab2e65c05$export$2b1464e7557b18eb;
var $d8206b3ab2e65c05$export$3786a0422a3f33ea = {
    prefix: "fas",
    iconName: "comment-slash",
    icon: [
        640,
        512,
        [],
        "f4b3",
        "M38.8 5.1C28.4-3.1 13.3-1.2 5.1 9.2S-1.2 34.7 9.2 42.9l592 464c10.4 8.2 25.5 6.3 33.7-4.1s6.3-25.5-4.1-33.7L512.9 376.7C552.2 340.2 576 292.3 576 240C576 125.1 461.4 32 320 32c-67.7 0-129.3 21.4-175.1 56.3L38.8 5.1zM64 240c0 45.1 17.7 86.8 47.7 120.9c-1.9 24.5-11.4 46.3-21.4 62.9c-5.5 9.2-11.1 16.6-15.2 21.6c-2.1 2.5-3.7 4.4-4.9 5.7c-.6 .6-1 1.1-1.3 1.4l-.3 .3 0 0 0 0 0 0 0 0c-4.6 4.6-5.9 11.4-3.4 17.4c2.5 6 8.3 9.9 14.8 9.9c28.7 0 57.6-8.9 81.6-19.3c22.9-10 42.4-21.9 54.3-30.6c31.8 11.5 67 17.9 104.1 17.9c37 0 72.3-6.4 104-17.9L82.9 161.3C70.7 185.6 64 212.2 64 240z"
    ]
};
var $d8206b3ab2e65c05$export$dd9dc9b4227dbe94 = {
    prefix: "fas",
    iconName: "cloud-sun-rain",
    icon: [
        640,
        512,
        [
            127782
        ],
        "f743",
        "M294.2 1.2c5.1 2.1 8.7 6.7 9.6 12.1l10.4 62.4c-23.3 10.8-42.9 28.4-56 50.3c-14.6-9-31.8-14.1-50.2-14.1c-53 0-96 43-96 96c0 35.5 19.3 66.6 48 83.2c.8 31.8 13.2 60.7 33.1 82.7l-56 39.2c-4.5 3.1-10.3 3.8-15.4 1.6s-8.7-6.7-9.6-12.1L98.1 317.9 13.4 303.8c-5.4-.9-10-4.5-12.1-9.6s-1.5-10.9 1.6-15.4L52.5 208 2.9 137.2c-3.2-4.5-3.8-10.3-1.6-15.4s6.7-8.7 12.1-9.6L98.1 98.1l14.1-84.7c.9-5.4 4.5-10 9.6-12.1s10.9-1.5 15.4 1.6L208 52.5 278.8 2.9c4.5-3.2 10.3-3.8 15.4-1.6zM208 144c13.8 0 26.7 4.4 37.1 11.9c-1.2 4.1-2.2 8.3-3 12.6c-37.9 14.6-67.2 46.6-77.8 86.4C151.8 243.1 144 226.5 144 208c0-35.3 28.7-64 64-64zm69.4 276c11 7.4 14 22.3 6.7 33.3l-32 48c-7.4 11-22.3 14-33.3 6.7s-14-22.3-6.7-33.3l32-48c7.4-11 22.3-14 33.3-6.7zm96 0c11 7.4 14 22.3 6.7 33.3l-32 48c-7.4 11-22.3 14-33.3 6.7s-14-22.3-6.7-33.3l32-48c7.4-11 22.3-14 33.3-6.7zm96 0c11 7.4 14 22.3 6.7 33.3l-32 48c-7.4 11-22.3 14-33.3 6.7s-14-22.3-6.7-33.3l32-48c7.4-11 22.3-14 33.3-6.7zm96 0c11 7.4 14 22.3 6.7 33.3l-32 48c-7.4 11-22.3 14-33.3 6.7s-14-22.3-6.7-33.3l32-48c7.4-11 22.3-14 33.3-6.7zm74.5-116.1c0 44.2-35.8 80-80 80H288c-53 0-96-43-96-96c0-47.6 34.6-87 80-94.6l0-1.3c0-53 43-96 96-96c34.9 0 65.4 18.6 82.2 46.4c13-9.1 28.8-14.4 45.8-14.4c44.2 0 80 35.8 80 80c0 5.9-.6 11.7-1.9 17.2c37.4 6.7 65.8 39.4 65.8 78.7z"
    ]
};
var $d8206b3ab2e65c05$export$83632d1150d3541f = {
    prefix: "fas",
    iconName: "compress",
    icon: [
        448,
        512,
        [],
        "f066",
        "M160 64c0-17.7-14.3-32-32-32s-32 14.3-32 32v64H32c-17.7 0-32 14.3-32 32s14.3 32 32 32h96c17.7 0 32-14.3 32-32V64zM32 320c-17.7 0-32 14.3-32 32s14.3 32 32 32H96v64c0 17.7 14.3 32 32 32s32-14.3 32-32V352c0-17.7-14.3-32-32-32H32zM352 64c0-17.7-14.3-32-32-32s-32 14.3-32 32v96c0 17.7 14.3 32 32 32h96c17.7 0 32-14.3 32-32s-14.3-32-32-32H352V64zM320 320c-17.7 0-32 14.3-32 32v96c0 17.7 14.3 32 32 32s32-14.3 32-32V384h64c17.7 0 32-14.3 32-32s-14.3-32-32-32H320z"
    ]
};
var $d8206b3ab2e65c05$export$79d4dac715a51fdf = {
    prefix: "fas",
    iconName: "wheat-awn",
    icon: [
        512,
        512,
        [
            "wheat-alt"
        ],
        "e2cd",
        "M505 41c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0L383 95c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l88-88zM305.5 27.3c-6.2-6.2-16.4-6.2-22.6 0L271.5 38.6c-37.5 37.5-37.5 98.3 0 135.8l10.4 10.4-30.5 30.5c-3.4-27.3-15.5-53.8-36.5-74.8l-11.3-11.3c-6.2-6.2-16.4-6.2-22.6 0l-11.3 11.3c-37.5 37.5-37.5 98.3 0 135.8l10.4 10.4-30.5 30.5c-3.4-27.3-15.5-53.8-36.5-74.8L101.8 231c-6.2-6.2-16.4-6.2-22.6 0L67.9 242.3c-37.5 37.5-37.5 98.3 0 135.8l10.4 10.4L9.4 457.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0l68.9-68.9 12.2 12.2c37.5 37.5 98.3 37.5 135.8 0l11.3-11.3c6.2-6.2 6.2-16.4 0-22.6l-11.3-11.3c-21.8-21.8-49.6-34.1-78.1-36.9l31.9-31.9 12.2 12.2c37.5 37.5 98.3 37.5 135.8 0l11.3-11.3c6.2-6.2 6.2-16.4 0-22.6l-11.3-11.3c-21.8-21.8-49.6-34.1-78.1-36.9l31.9-31.9 12.2 12.2c37.5 37.5 98.3 37.5 135.8 0L486.5 231c6.2-6.2 6.2-16.4 0-22.6L475.2 197c-5.2-5.2-10.6-9.8-16.4-13.9L505 137c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-59.4 59.4c-20.6-4.4-42-3.7-62.3 2.1c6.1-21.3 6.6-43.8 1.4-65.3L409 41c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0L329.1 52.9c-3.7-5-7.8-9.8-12.4-14.3L305.5 27.3z"
    ]
};
var $d8206b3ab2e65c05$export$deaf03a29aa05e3a = $d8206b3ab2e65c05$export$79d4dac715a51fdf;
var $d8206b3ab2e65c05$export$8736909014b15ca9 = {
    prefix: "fas",
    iconName: "ankh",
    icon: [
        320,
        512,
        [
            9765
        ],
        "f644",
        "M96 128c0-35.3 28.7-64 64-64s64 28.7 64 64c0 41.6-20.7 76.6-46.6 104.1c-5.9 6.2-11.8 11.8-17.4 16.7c-5.6-4.9-11.5-10.5-17.4-16.7C116.7 204.6 96 169.6 96 128zM160 0C89.3 0 32 57.3 32 128c0 52.4 21.5 95.5 46.8 128H32c-17.7 0-32 14.3-32 32s14.3 32 32 32h96V480c0 17.7 14.3 32 32 32s32-14.3 32-32V320h96c17.7 0 32-14.3 32-32s-14.3-32-32-32H241.2c25.4-32.5 46.8-75.6 46.8-128C288 57.3 230.7 0 160 0z"
    ]
};
var $d8206b3ab2e65c05$export$bfb254bf3c0bc50b = {
    prefix: "fas",
    iconName: "hands-holding-child",
    icon: [
        640,
        512,
        [],
        "e4fa",
        "M320 0a40 40 0 1 1 0 80 40 40 0 1 1 0-80zm44.7 164.3L375.8 253c1.6 13.2-7.7 25.1-20.8 26.8s-25.1-7.7-26.8-20.8l-4.4-35h-7.6l-4.4 35c-1.6 13.2-13.6 22.5-26.8 20.8s-22.5-13.6-20.8-26.8l11.1-88.8L255.5 181c-10.1 8.6-25.3 7.3-33.8-2.8s-7.3-25.3 2.8-33.8l27.9-23.6C271.3 104.8 295.3 96 320 96s48.7 8.8 67.6 24.7l27.9 23.6c10.1 8.6 11.4 23.7 2.8 33.8s-23.7 11.4-33.8 2.8l-19.8-16.7zM40 64c22.1 0 40 17.9 40 40v40 80 40.2c0 17 6.7 33.3 18.7 45.3l51.1 51.1c8.3 8.3 21.3 9.6 31 3.1c12.9-8.6 14.7-26.9 3.7-37.8l-15.2-15.2-32-32c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0l32 32 15.2 15.2 0 0 25.3 25.3c21 21 32.8 49.5 32.8 79.2V464c0 26.5-21.5 48-48 48H173.3c-17 0-33.3-6.7-45.3-18.7L28.1 393.4C10.1 375.4 0 351 0 325.5V224 160 104C0 81.9 17.9 64 40 64zm560 0c22.1 0 40 17.9 40 40v56 64V325.5c0 25.5-10.1 49.9-28.1 67.9L512 493.3c-12 12-28.3 18.7-45.3 18.7H400c-26.5 0-48-21.5-48-48V385.1c0-29.7 11.8-58.2 32.8-79.2l25.3-25.3 0 0 15.2-15.2 32-32c12.5-12.5 32.8-12.5 45.3 0s12.5 32.8 0 45.3l-32 32-15.2 15.2c-11 11-9.2 29.2 3.7 37.8c9.7 6.5 22.7 5.2 31-3.1l51.1-51.1c12-12 18.7-28.3 18.7-45.3V224 144 104c0-22.1 17.9-40 40-40z"
    ]
};
var $d8206b3ab2e65c05$export$19eff32c0fd4f99f = {
    prefix: "fas",
    iconName: "asterisk",
    icon: [
        384,
        512,
        [
            10033,
            61545
        ],
        "2a",
        "M192 32c17.7 0 32 14.3 32 32V199.5l111.5-66.9c15.2-9.1 34.8-4.2 43.9 11s4.2 34.8-11 43.9L254.2 256l114.3 68.6c15.2 9.1 20.1 28.7 11 43.9s-28.7 20.1-43.9 11L224 312.5V448c0 17.7-14.3 32-32 32s-32-14.3-32-32V312.5L48.5 379.4c-15.2 9.1-34.8 4.2-43.9-11s-4.2-34.8 11-43.9L129.8 256 15.5 187.4c-15.2-9.1-20.1-28.7-11-43.9s28.7-20.1 43.9-11L160 199.5V64c0-17.7 14.3-32 32-32z"
    ]
};
var $d8206b3ab2e65c05$export$5bb6a0c94ad2f4bb = {
    prefix: "fas",
    iconName: "square-check",
    icon: [
        448,
        512,
        [
            9745,
            9989,
            61510,
            "check-square"
        ],
        "f14a",
        "M64 32C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64zM337 209L209 337c-9.4 9.4-24.6 9.4-33.9 0l-64-64c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l47 47L303 175c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9z"
    ]
};
var $d8206b3ab2e65c05$export$f0c8040f596df7fe = $d8206b3ab2e65c05$export$5bb6a0c94ad2f4bb;
var $d8206b3ab2e65c05$export$a6f8654bcd49a39f = {
    prefix: "fas",
    iconName: "peseta-sign",
    icon: [
        384,
        512,
        [],
        "e221",
        "M64 32C46.3 32 32 46.3 32 64v96c-17.7 0-32 14.3-32 32s14.3 32 32 32l0 96V448c0 17.7 14.3 32 32 32s32-14.3 32-32V352h96c77.4 0 142-55 156.8-128H352c17.7 0 32-14.3 32-32s-14.3-32-32-32h-3.2C334 87 269.4 32 192 32H64zM282.5 160H96V96h96c41.8 0 77.4 26.7 90.5 64zM96 224H282.5c-13.2 37.3-48.7 64-90.5 64H96V224z"
    ]
};
var $d8206b3ab2e65c05$export$4805b8d175aeb9fb = {
    prefix: "fas",
    iconName: "heading",
    icon: [
        448,
        512,
        [
            "header"
        ],
        "f1dc",
        "M0 64C0 46.3 14.3 32 32 32H80h48c17.7 0 32 14.3 32 32s-14.3 32-32 32H112V208H336V96H320c-17.7 0-32-14.3-32-32s14.3-32 32-32h48 48c17.7 0 32 14.3 32 32s-14.3 32-32 32H400V240 416h16c17.7 0 32 14.3 32 32s-14.3 32-32 32H368 320c-17.7 0-32-14.3-32-32s14.3-32 32-32h16V272H112V416h16c17.7 0 32 14.3 32 32s-14.3 32-32 32H80 32c-17.7 0-32-14.3-32-32s14.3-32 32-32H48V240 96H32C14.3 96 0 81.7 0 64z"
    ]
};
var $d8206b3ab2e65c05$export$579f9604bb10a61a = $d8206b3ab2e65c05$export$4805b8d175aeb9fb;
var $d8206b3ab2e65c05$export$1a989eb1919c64c1 = {
    prefix: "fas",
    iconName: "ghost",
    icon: [
        384,
        512,
        [
            128123
        ],
        "f6e2",
        "M40.1 467.1l-11.2 9c-3.2 2.5-7.1 3.9-11.1 3.9C8 480 0 472 0 462.2V192C0 86 86 0 192 0S384 86 384 192V462.2c0 9.8-8 17.8-17.8 17.8c-4 0-7.9-1.4-11.1-3.9l-11.2-9c-13.4-10.7-32.8-9-44.1 3.9L269.3 506c-3.3 3.8-8.2 6-13.3 6s-9.9-2.2-13.3-6l-26.6-30.5c-12.7-14.6-35.4-14.6-48.2 0L141.3 506c-3.3 3.8-8.2 6-13.3 6s-9.9-2.2-13.3-6L84.2 471c-11.3-12.9-30.7-14.6-44.1-3.9zM160 192a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zm96 32a32 32 0 1 0 0-64 32 32 0 1 0 0 64z"
    ]
};
var $d8206b3ab2e65c05$export$6cfc59842fedbc16 = {
    prefix: "fas",
    iconName: "list",
    icon: [
        512,
        512,
        [
            "list-squares"
        ],
        "f03a",
        "M40 48C26.7 48 16 58.7 16 72v48c0 13.3 10.7 24 24 24H88c13.3 0 24-10.7 24-24V72c0-13.3-10.7-24-24-24H40zM192 64c-17.7 0-32 14.3-32 32s14.3 32 32 32H480c17.7 0 32-14.3 32-32s-14.3-32-32-32H192zm0 160c-17.7 0-32 14.3-32 32s14.3 32 32 32H480c17.7 0 32-14.3 32-32s-14.3-32-32-32H192zm0 160c-17.7 0-32 14.3-32 32s14.3 32 32 32H480c17.7 0 32-14.3 32-32s-14.3-32-32-32H192zM16 232v48c0 13.3 10.7 24 24 24H88c13.3 0 24-10.7 24-24V232c0-13.3-10.7-24-24-24H40c-13.3 0-24 10.7-24 24zM40 368c-13.3 0-24 10.7-24 24v48c0 13.3 10.7 24 24 24H88c13.3 0 24-10.7 24-24V392c0-13.3-10.7-24-24-24H40z"
    ]
};
var $d8206b3ab2e65c05$export$e3f160fc949c2b9d = $d8206b3ab2e65c05$export$6cfc59842fedbc16;
var $d8206b3ab2e65c05$export$b627121801cad756 = {
    prefix: "fas",
    iconName: "square-phone-flip",
    icon: [
        448,
        512,
        [
            "phone-square-alt"
        ],
        "f87b",
        "M384 32c35.3 0 64 28.7 64 64V416c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96C0 60.7 28.7 32 64 32H384zm-90.7 96.7c-9.7-2.6-19.9 2.3-23.7 11.6l-20 48c-3.4 8.2-1 17.6 5.8 23.2L280 231.7c-16.6 35.2-45.1 63.7-80.3 80.3l-20.2-24.7c-5.6-6.8-15-9.2-23.2-5.8l-48 20c-9.3 3.9-14.2 14-11.6 23.7l12 44C111.1 378 119 384 128 384c123.7 0 224-100.3 224-224c0-9-6-16.9-14.7-19.3l-44-12z"
    ]
};
var $d8206b3ab2e65c05$export$a41e77f0de98bba7 = $d8206b3ab2e65c05$export$b627121801cad756;
var $d8206b3ab2e65c05$export$6675e2bf21fdb87e = {
    prefix: "fas",
    iconName: "cart-plus",
    icon: [
        576,
        512,
        [],
        "f217",
        "M0 24C0 10.7 10.7 0 24 0H69.5c22 0 41.5 12.8 50.6 32h411c26.3 0 45.5 25 38.6 50.4l-41 152.3c-8.5 31.4-37 53.3-69.5 53.3H170.7l5.4 28.5c2.2 11.3 12.1 19.5 23.6 19.5H488c13.3 0 24 10.7 24 24s-10.7 24-24 24H199.7c-34.6 0-64.3-24.6-70.7-58.5L77.4 54.5c-.7-3.8-4-6.5-7.9-6.5H24C10.7 48 0 37.3 0 24zM128 464a48 48 0 1 1 96 0 48 48 0 1 1 -96 0zm336-48a48 48 0 1 1 0 96 48 48 0 1 1 0-96zM252 160c0 11 9 20 20 20h44v44c0 11 9 20 20 20s20-9 20-20V180h44c11 0 20-9 20-20s-9-20-20-20H356V96c0-11-9-20-20-20s-20 9-20 20v44H272c-11 0-20 9-20 20z"
    ]
};
var $d8206b3ab2e65c05$export$6a66b1b639455bef = {
    prefix: "fas",
    iconName: "gamepad",
    icon: [
        640,
        512,
        [],
        "f11b",
        "M192 64C86 64 0 150 0 256S86 448 192 448H448c106 0 192-86 192-192s-86-192-192-192H192zM496 168a40 40 0 1 1 0 80 40 40 0 1 1 0-80zM392 304a40 40 0 1 1 80 0 40 40 0 1 1 -80 0zM168 200c0-13.3 10.7-24 24-24s24 10.7 24 24v32h32c13.3 0 24 10.7 24 24s-10.7 24-24 24H216v32c0 13.3-10.7 24-24 24s-24-10.7-24-24V280H136c-13.3 0-24-10.7-24-24s10.7-24 24-24h32V200z"
    ]
};
var $d8206b3ab2e65c05$export$aa13d9234890e8d3 = {
    prefix: "fas",
    iconName: "circle-dot",
    icon: [
        512,
        512,
        [
            128280,
            "dot-circle"
        ],
        "f192",
        "M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zm0-352a96 96 0 1 1 0 192 96 96 0 1 1 0-192z"
    ]
};
var $d8206b3ab2e65c05$export$92bc269cb244d66a = $d8206b3ab2e65c05$export$aa13d9234890e8d3;
var $d8206b3ab2e65c05$export$635e4d8cc8428961 = {
    prefix: "fas",
    iconName: "face-dizzy",
    icon: [
        512,
        512,
        [
            "dizzy"
        ],
        "f567",
        "M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zm0-224a64 64 0 1 1 0 128 64 64 0 1 1 0-128zM100.7 132.7c6.2-6.2 16.4-6.2 22.6 0L160 169.4l36.7-36.7c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6L182.6 192l36.7 36.7c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0L160 214.6l-36.7 36.7c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6L137.4 192l-36.7-36.7c-6.2-6.2-6.2-16.4 0-22.6zm192 0c6.2-6.2 16.4-6.2 22.6 0L352 169.4l36.7-36.7c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6L374.6 192l36.7 36.7c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0L352 214.6l-36.7 36.7c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6L329.4 192l-36.7-36.7c-6.2-6.2-6.2-16.4 0-22.6z"
    ]
};
var $d8206b3ab2e65c05$export$89a2b10dabc487e8 = $d8206b3ab2e65c05$export$635e4d8cc8428961;
var $d8206b3ab2e65c05$export$1199a8ce85311ab5 = {
    prefix: "fas",
    iconName: "egg",
    icon: [
        384,
        512,
        [
            129370
        ],
        "f7fb",
        "M192 496C86 496 0 394 0 288C0 176 64 16 192 16s192 160 192 272c0 106-86 208-192 208zM154.8 134c6.5-6 7-16.1 1-22.6s-16.1-7-22.6-1c-23.9 21.8-41.1 52.7-52.3 84.2C69.7 226.1 64 259.7 64 288c0 8.8 7.2 16 16 16s16-7.2 16-16c0-24.5 5-54.4 15.1-82.8c10.1-28.5 25-54.1 43.7-71.2z"
    ]
};
var $d8206b3ab2e65c05$export$bf221f0e8296233e = {
    prefix: "fas",
    iconName: "house-medical-circle-xmark",
    icon: [
        640,
        512,
        [],
        "e513",
        "M320 368c0 59.5 29.5 112.1 74.8 144H128.1c-35.3 0-64-28.7-64-64V287.6H32c-18 0-32-14-32-32.1c0-9 3-17 10-24L266.4 8c7-7 15-8 22-8s15 2 21 7L522.1 193.9c-8.5-1.3-17.3-1.9-26.1-1.9c-54.7 0-103.5 24.9-135.8 64H320V208c0-8.8-7.2-16-16-16H272c-8.8 0-16 7.2-16 16v48H208c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h48v48c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16zM496 224a144 144 0 1 1 0 288 144 144 0 1 1 0-288zm22.6 144l36.7-36.7c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0L496 345.4l-36.7-36.7c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6L473.4 368l-36.7 36.7c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0L496 390.6l36.7 36.7c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6L518.6 368z"
    ]
};
var $d8206b3ab2e65c05$export$295287303c0e9c7c = {
    prefix: "fas",
    iconName: "campground",
    icon: [
        576,
        512,
        [
            9978
        ],
        "f6bb",
        "M377 52c11-13.8 8.8-33.9-5-45s-33.9-8.8-45 5L288 60.8 249 12c-11-13.8-31.2-16-45-5s-16 31.2-5 45l48 60L12.3 405.4C4.3 415.4 0 427.7 0 440.4V464c0 26.5 21.5 48 48 48H288 528c26.5 0 48-21.5 48-48V440.4c0-12.7-4.3-25.1-12.3-35L329 112l48-60zM288 448H168.5L288 291.7 407.5 448H288z"
    ]
};
var $d8206b3ab2e65c05$export$e18e05ffa2045d3b = {
    prefix: "fas",
    iconName: "folder-plus",
    icon: [
        512,
        512,
        [],
        "f65e",
        "M512 416c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96C0 60.7 28.7 32 64 32H192c20.1 0 39.1 9.5 51.2 25.6l19.2 25.6c6 8.1 15.5 12.8 25.6 12.8H448c35.3 0 64 28.7 64 64V416zM232 376c0 13.3 10.7 24 24 24s24-10.7 24-24V312h64c13.3 0 24-10.7 24-24s-10.7-24-24-24H280V200c0-13.3-10.7-24-24-24s-24 10.7-24 24v64H168c-13.3 0-24 10.7-24 24s10.7 24 24 24h64v64z"
    ]
};
var $d8206b3ab2e65c05$export$65a345b33858a655 = {
    prefix: "fas",
    iconName: "futbol",
    icon: [
        512,
        512,
        [
            9917,
            "futbol-ball",
            "soccer-ball"
        ],
        "f1e3",
        "M417.3 360.1l-71.6-4.8c-5.2-.3-10.3 1.1-14.5 4.2s-7.2 7.4-8.4 12.5l-17.6 69.6C289.5 445.8 273 448 256 448s-33.5-2.2-49.2-6.4L189.2 372c-1.3-5-4.3-9.4-8.4-12.5s-9.3-4.5-14.5-4.2l-71.6 4.8c-17.6-27.2-28.5-59.2-30.4-93.6L125 228.3c4.4-2.8 7.6-7 9.2-11.9s1.4-10.2-.5-15l-26.7-66.6C128 109.2 155.3 89 186.7 76.9l55.2 46c4 3.3 9 5.1 14.1 5.1s10.2-1.8 14.1-5.1l55.2-46c31.3 12.1 58.7 32.3 79.6 57.9l-26.7 66.6c-1.9 4.8-2.1 10.1-.5 15s4.9 9.1 9.2 11.9l60.7 38.2c-1.9 34.4-12.8 66.4-30.4 93.6zM256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zm14.1-325.7c-8.4-6.1-19.8-6.1-28.2 0L194 221c-8.4 6.1-11.9 16.9-8.7 26.8l18.3 56.3c3.2 9.9 12.4 16.6 22.8 16.6h59.2c10.4 0 19.6-6.7 22.8-16.6l18.3-56.3c3.2-9.9-.3-20.7-8.7-26.8l-47.9-34.8z"
    ]
};
var $d8206b3ab2e65c05$export$51a344ca0a215620 = $d8206b3ab2e65c05$export$65a345b33858a655;
var $d8206b3ab2e65c05$export$f4a29712c724ba2d = $d8206b3ab2e65c05$export$65a345b33858a655;
var $d8206b3ab2e65c05$export$7c8b56f3f296a814 = {
    prefix: "fas",
    iconName: "paintbrush",
    icon: [
        576,
        512,
        [
            128396,
            "paint-brush"
        ],
        "f1fc",
        "M339.3 367.1c27.3-3.9 51.9-19.4 67.2-42.9L568.2 74.1c12.6-19.5 9.4-45.3-7.6-61.2S517.7-4.4 499.1 9.6L262.4 187.2c-24 18-38.2 46.1-38.4 76.1L339.3 367.1zm-19.6 25.4l-116-104.4C143.9 290.3 96 339.6 96 400c0 3.9 .2 7.8 .6 11.6C98.4 429.1 86.4 448 68.8 448H64c-17.7 0-32 14.3-32 32s14.3 32 32 32H208c61.9 0 112-50.1 112-112c0-2.5-.1-5-.2-7.5z"
    ]
};
var $d8206b3ab2e65c05$export$594db3339e212bc9 = $d8206b3ab2e65c05$export$7c8b56f3f296a814;
var $d8206b3ab2e65c05$export$7aa08ad5d562578a = {
    prefix: "fas",
    iconName: "lock",
    icon: [
        448,
        512,
        [
            128274
        ],
        "f023",
        "M144 144v48H304V144c0-44.2-35.8-80-80-80s-80 35.8-80 80zM80 192V144C80 64.5 144.5 0 224 0s144 64.5 144 144v48h16c35.3 0 64 28.7 64 64V448c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V256c0-35.3 28.7-64 64-64H80z"
    ]
};
var $d8206b3ab2e65c05$export$84666c793cb2a347 = {
    prefix: "fas",
    iconName: "gas-pump",
    icon: [
        512,
        512,
        [
            9981
        ],
        "f52f",
        "M32 64C32 28.7 60.7 0 96 0H256c35.3 0 64 28.7 64 64V256h8c48.6 0 88 39.4 88 88v32c0 13.3 10.7 24 24 24s24-10.7 24-24V222c-27.6-7.1-48-32.2-48-62V96L384 64c-8.8-8.8-8.8-23.2 0-32s23.2-8.8 32 0l77.3 77.3c12 12 18.7 28.3 18.7 45.3V168v24 32V376c0 39.8-32.2 72-72 72s-72-32.2-72-72V344c0-22.1-17.9-40-40-40h-8V448c17.7 0 32 14.3 32 32s-14.3 32-32 32H32c-17.7 0-32-14.3-32-32s14.3-32 32-32V64zM96 80v96c0 8.8 7.2 16 16 16H240c8.8 0 16-7.2 16-16V80c0-8.8-7.2-16-16-16H112c-8.8 0-16 7.2-16 16z"
    ]
};
var $d8206b3ab2e65c05$export$6e6bd68568c17bbf = {
    prefix: "fas",
    iconName: "hot-tub-person",
    icon: [
        512,
        512,
        [
            "hot-tub"
        ],
        "f593",
        "M272 24c0-13.3-10.7-24-24-24s-24 10.7-24 24v5.2c0 34 14.4 66.4 39.7 89.2l16.4 14.8c15.2 13.7 23.8 33.1 23.8 53.5V200c0 13.3 10.7 24 24 24s24-10.7 24-24V186.8c0-34-14.4-66.4-39.7-89.2L295.8 82.8C280.7 69.1 272 49.7 272 29.2V24zM0 320v16V448c0 35.3 28.7 64 64 64H448c35.3 0 64-28.7 64-64V320c0-35.3-28.7-64-64-64H277.3c-13.8 0-27.3-4.5-38.4-12.8l-85.3-64C137 166.7 116.8 160 96 160c-53 0-96 43-96 96v64zm128 16v96c0 8.8-7.2 16-16 16s-16-7.2-16-16V336c0-8.8 7.2-16 16-16s16 7.2 16 16zm80-16c8.8 0 16 7.2 16 16v96c0 8.8-7.2 16-16 16s-16-7.2-16-16V336c0-8.8 7.2-16 16-16zm112 16v96c0 8.8-7.2 16-16 16s-16-7.2-16-16V336c0-8.8 7.2-16 16-16s16 7.2 16 16zm80-16c8.8 0 16 7.2 16 16v96c0 8.8-7.2 16-16 16s-16-7.2-16-16V336c0-8.8 7.2-16 16-16zM360 0c-13.3 0-24 10.7-24 24v5.2c0 34 14.4 66.4 39.7 89.2l16.4 14.8c15.2 13.7 23.8 33.1 23.8 53.5V200c0 13.3 10.7 24 24 24s24-10.7 24-24V186.8c0-34-14.4-66.4-39.7-89.2L407.8 82.8C392.7 69.1 384 49.7 384 29.2V24c0-13.3-10.7-24-24-24zM64 128A64 64 0 1 0 64 0a64 64 0 1 0 0 128z"
    ]
};
var $d8206b3ab2e65c05$export$4842af92b516c40b = $d8206b3ab2e65c05$export$6e6bd68568c17bbf;
var $d8206b3ab2e65c05$export$9a8788ec0e4a9a0b = {
    prefix: "fas",
    iconName: "map-location",
    icon: [
        576,
        512,
        [
            "map-marked"
        ],
        "f59f",
        "M302.8 312C334.9 271.9 408 174.6 408 120C408 53.7 354.3 0 288 0S168 53.7 168 120c0 54.6 73.1 151.9 105.2 192c7.7 9.6 22 9.6 29.6 0zM416 503l144.9-58c9.1-3.6 15.1-12.5 15.1-22.3V152c0-17-17.1-28.6-32.9-22.3l-116 46.4c-.5 1.2-1 2.5-1.5 3.7c-2.9 6.8-6.1 13.7-9.6 20.6V503zM15.1 187.3C6 191 0 199.8 0 209.6V480.4c0 17 17.1 28.6 32.9 22.3L160 451.8V200.4c-3.5-6.9-6.7-13.8-9.6-20.6c-5.6-13.2-10.4-27.4-12.8-41.5l-122.6 49zM384 255c-20.5 31.3-42.3 59.6-56.2 77c-20.5 25.6-59.1 25.6-79.6 0c-13.9-17.4-35.7-45.7-56.2-77V449.4l192 54.9V255z"
    ]
};
var $d8206b3ab2e65c05$export$df04458e7e32352c = $d8206b3ab2e65c05$export$9a8788ec0e4a9a0b;
var $d8206b3ab2e65c05$export$70fd6006b4e54a5 = {
    prefix: "fas",
    iconName: "house-flood-water",
    icon: [
        576,
        512,
        [],
        "e50e",
        "M306.8 6.1C295.6-2 280.4-2 269.2 6.1l-176 128c-11.2 8.2-15.9 22.6-11.6 35.8S98.1 192 112 192h16v73c1.7 1 3.3 2 4.9 3.1c18 12.4 40.1 20.3 59.2 20.3c21.1 0 42-8.5 59.2-20.3c22.1-15.5 51.6-15.5 73.7 0c18.4 12.7 39.6 20.3 59.2 20.3c19 0 41.2-7.9 59.2-20.3c1.5-1 3-2 4.5-2.9l-.3-73.2H464c13.9 0 26.1-8.9 30.4-22.1s-.4-27.6-11.6-35.8l-176-128zM269.5 309.9C247 325.4 219.5 336 192 336c-26.9 0-55.3-10.8-77.4-26.1l0 0c-11.9-8.5-28.1-7.8-39.2 1.7c-14.4 11.9-32.5 21-50.6 25.2c-17.2 4-27.9 21.2-23.9 38.4s21.2 27.9 38.4 23.9c24.5-5.7 44.9-16.5 58.2-25C126.5 389.7 159 400 192 400c31.9 0 60.6-9.9 80.4-18.9c5.8-2.7 11.1-5.3 15.6-7.7c4.5 2.4 9.7 5.1 15.6 7.7c19.8 9 48.5 18.9 80.4 18.9c33 0 65.5-10.3 94.5-25.8c13.4 8.4 33.7 19.3 58.2 25c17.2 4 34.4-6.7 38.4-23.9s-6.7-34.4-23.9-38.4c-18.1-4.2-36.2-13.3-50.6-25.2c-11.1-9.5-27.3-10.1-39.2-1.7l0 0C439.4 325.2 410.9 336 384 336c-27.5 0-55-10.6-77.5-26.1c-11.1-7.9-25.9-7.9-37 0zM384 448c-27.5 0-55-10.6-77.5-26.1c-11.1-7.9-25.9-7.9-37 0C247 437.4 219.5 448 192 448c-26.9 0-55.3-10.8-77.4-26.1l0 0c-11.9-8.5-28.1-7.8-39.2 1.7c-14.4 11.9-32.5 21-50.6 25.2c-17.2 4-27.9 21.2-23.9 38.4s21.2 27.9 38.4 23.9c24.5-5.7 44.9-16.5 58.2-25C126.5 501.7 159 512 192 512c31.9 0 60.6-9.9 80.4-18.9c5.8-2.7 11.1-5.3 15.6-7.7c4.5 2.4 9.7 5.1 15.6 7.7c19.8 9 48.5 18.9 80.4 18.9c33 0 65.5-10.3 94.5-25.8c13.4 8.4 33.7 19.3 58.2 25c17.2 4 34.4-6.7 38.4-23.9s-6.7-34.4-23.9-38.4c-18.1-4.2-36.2-13.3-50.6-25.2c-11.1-9.4-27.3-10.1-39.2-1.7l0 0C439.4 437.2 410.9 448 384 448z"
    ]
};
var $d8206b3ab2e65c05$export$1744430f718caf6b = {
    prefix: "fas",
    iconName: "tree",
    icon: [
        448,
        512,
        [
            127794
        ],
        "f1bb",
        "M210.6 5.9L62 169.4c-3.9 4.2-6 9.8-6 15.5C56 197.7 66.3 208 79.1 208H104L30.6 281.4c-4.2 4.2-6.6 10-6.6 16C24 309.9 34.1 320 46.6 320H80L5.4 409.5C1.9 413.7 0 419 0 424.5c0 13 10.5 23.5 23.5 23.5H192v32c0 17.7 14.3 32 32 32s32-14.3 32-32V448H424.5c13 0 23.5-10.5 23.5-23.5c0-5.5-1.9-10.8-5.4-15L368 320h33.4c12.5 0 22.6-10.1 22.6-22.6c0-6-2.4-11.8-6.6-16L344 208h24.9c12.7 0 23.1-10.3 23.1-23.1c0-5.7-2.1-11.3-6-15.5L237.4 5.9C234 2.1 229.1 0 224 0s-10 2.1-13.4 5.9z"
    ]
};
var $d8206b3ab2e65c05$export$cffe7d85a82d8116 = {
    prefix: "fas",
    iconName: "bridge-lock",
    icon: [
        640,
        512,
        [],
        "e4cc",
        "M32 64c0-17.7 14.3-32 32-32H576c17.7 0 32 14.3 32 32s-14.3 32-32 32H536v64h-8c-61.9 0-112 50.1-112 112v24.6c-9.9 5.8-18.2 14.1-23.8 24.1c-17.6-20-43.4-32.7-72.2-32.7c-53 0-96 43-96 96v64c0 17.7-14.3 32-32 32H160c-17.7 0-32-14.3-32-32V384c0-53-43-96-96-96V160h72V96H64C46.3 96 32 81.7 32 64zM408 96v64h80V96H408zm-48 64V96H280v64h80zM152 96v64h80V96H152zM528 240c-17.7 0-32 14.3-32 32v48h64V272c0-17.7-14.3-32-32-32zm-80 32c0-44.2 35.8-80 80-80s80 35.8 80 80v48c17.7 0 32 14.3 32 32V480c0 17.7-14.3 32-32 32H448c-17.7 0-32-14.3-32-32V352c0-17.7 14.3-32 32-32V272z"
    ]
};
var $d8206b3ab2e65c05$export$15854c4475080853 = {
    prefix: "fas",
    iconName: "sack-dollar",
    icon: [
        512,
        512,
        [
            128176
        ],
        "f81d",
        "M320 96H192L144.6 24.9C137.5 14.2 145.1 0 157.9 0H354.1c12.8 0 20.4 14.2 13.3 24.9L320 96zM192 128H320c3.8 2.5 8.1 5.3 13 8.4C389.7 172.7 512 250.9 512 416c0 53-43 96-96 96H96c-53 0-96-43-96-96C0 250.9 122.3 172.7 179 136.4l0 0 0 0c4.8-3.1 9.2-5.9 13-8.4zm84 88c0-11-9-20-20-20s-20 9-20 20v14c-7.6 1.7-15.2 4.4-22.2 8.5c-13.9 8.3-25.9 22.8-25.8 43.9c.1 20.3 12 33.1 24.7 40.7c11 6.6 24.7 10.8 35.6 14l1.7 .5c12.6 3.8 21.8 6.8 28 10.7c5.1 3.2 5.8 5.4 5.9 8.2c.1 5-1.8 8-5.9 10.5c-5 3.1-12.9 5-21.4 4.7c-11.1-.4-21.5-3.9-35.1-8.5c-2.3-.8-4.7-1.6-7.2-2.4c-10.5-3.5-21.8 2.2-25.3 12.6s2.2 21.8 12.6 25.3c1.9 .6 4 1.3 6.1 2.1l0 0 0 0c8.3 2.9 17.9 6.2 28.2 8.4V424c0 11 9 20 20 20s20-9 20-20V410.2c8-1.7 16-4.5 23.2-9c14.3-8.9 25.1-24.1 24.8-45c-.3-20.3-11.7-33.4-24.6-41.6c-11.5-7.2-25.9-11.6-37.1-15l0 0-.7-.2c-12.8-3.9-21.9-6.7-28.3-10.5c-5.2-3.1-5.3-4.9-5.3-6.7c0-3.7 1.4-6.5 6.2-9.3c5.4-3.2 13.6-5.1 21.5-5c9.6 .1 20.2 2.2 31.2 5.2c10.7 2.8 21.6-3.5 24.5-14.2s-3.5-21.6-14.2-24.5c-6.5-1.7-13.7-3.4-21.1-4.7V216z"
    ]
};
var $d8206b3ab2e65c05$export$ba236543926e3569 = {
    prefix: "fas",
    iconName: "pen-to-square",
    icon: [
        512,
        512,
        [
            "edit"
        ],
        "f044",
        "M471.6 21.7c-21.9-21.9-57.3-21.9-79.2 0L362.3 51.7l97.9 97.9 30.1-30.1c21.9-21.9 21.9-57.3 0-79.2L471.6 21.7zm-299.2 220c-6.1 6.1-10.8 13.6-13.5 21.9l-29.6 88.8c-2.9 8.6-.6 18.1 5.8 24.6s15.9 8.7 24.6 5.8l88.8-29.6c8.2-2.7 15.7-7.4 21.9-13.5L437.7 172.3 339.7 74.3 172.4 241.7zM96 64C43 64 0 107 0 160V416c0 53 43 96 96 96H352c53 0 96-43 96-96V320c0-17.7-14.3-32-32-32s-32 14.3-32 32v96c0 17.7-14.3 32-32 32H96c-17.7 0-32-14.3-32-32V160c0-17.7 14.3-32 32-32h96c17.7 0 32-14.3 32-32s-14.3-32-32-32H96z"
    ]
};
var $d8206b3ab2e65c05$export$7be713e57d023733 = $d8206b3ab2e65c05$export$ba236543926e3569;
var $d8206b3ab2e65c05$export$6f7218565b1b8d0e = {
    prefix: "fas",
    iconName: "car-side",
    icon: [
        640,
        512,
        [
            128663
        ],
        "f5e4",
        "M171.3 96H224v96H111.3l30.4-75.9C146.5 104 158.2 96 171.3 96zM272 192V96h81.2c9.7 0 18.9 4.4 25 12l67.2 84H272zm256.2 1L428.2 68c-18.2-22.8-45.8-36-75-36H171.3c-39.3 0-74.6 23.9-89.1 60.3L40.6 196.4C16.8 205.8 0 228.9 0 256V368c0 17.7 14.3 32 32 32H65.3c7.6 45.4 47.1 80 94.7 80s87.1-34.6 94.7-80H385.3c7.6 45.4 47.1 80 94.7 80s87.1-34.6 94.7-80H608c17.7 0 32-14.3 32-32V320c0-65.2-48.8-119-111.8-127zM434.7 368a48 48 0 1 1 90.5 32 48 48 0 1 1 -90.5-32zM160 336a48 48 0 1 1 0 96 48 48 0 1 1 0-96z"
    ]
};
var $d8206b3ab2e65c05$export$cdaf45d4e50ac035 = {
    prefix: "fas",
    iconName: "share-nodes",
    icon: [
        448,
        512,
        [
            "share-alt"
        ],
        "f1e0",
        "M352 224c53 0 96-43 96-96s-43-96-96-96s-96 43-96 96c0 4 .2 8 .7 11.9l-94.1 47C145.4 170.2 121.9 160 96 160c-53 0-96 43-96 96s43 96 96 96c25.9 0 49.4-10.2 66.6-26.9l94.1 47c-.5 3.9-.7 7.8-.7 11.9c0 53 43 96 96 96s96-43 96-96s-43-96-96-96c-25.9 0-49.4 10.2-66.6 26.9l-94.1-47c.5-3.9 .7-7.8 .7-11.9s-.2-8-.7-11.9l94.1-47C302.6 213.8 326.1 224 352 224z"
    ]
};
var $d8206b3ab2e65c05$export$f8e8bb0b3aa8c658 = $d8206b3ab2e65c05$export$cdaf45d4e50ac035;
var $d8206b3ab2e65c05$export$24c21c3ca00f3625 = {
    prefix: "fas",
    iconName: "heart-circle-minus",
    icon: [
        576,
        512,
        [],
        "e4ff",
        "M47.6 300.4L228.3 469.1c7.5 7 17.4 10.9 27.7 10.9s20.2-3.9 27.7-10.9l2.6-2.4C267.2 438.6 256 404.6 256 368c0-97.2 78.8-176 176-176c28.3 0 55 6.7 78.7 18.5c.9-6.5 1.3-13 1.3-19.6v-5.8c0-69.9-50.5-129.5-119.4-141C347 36.5 300.6 51.4 268 84L256 96 244 84c-32.6-32.6-79-47.5-124.6-39.9C50.5 55.6 0 115.2 0 185.1v5.8c0 41.5 17.2 81.2 47.6 109.5zM576 368a144 144 0 1 0 -288 0 144 144 0 1 0 288 0zm-64 0c0 8.8-7.2 16-16 16H368c-8.8 0-16-7.2-16-16s7.2-16 16-16H496c8.8 0 16 7.2 16 16z"
    ]
};
var $d8206b3ab2e65c05$export$703272eebf5e3eea = {
    prefix: "fas",
    iconName: "hourglass-half",
    icon: [
        384,
        512,
        [
            "hourglass-2"
        ],
        "f252",
        "M32 0C14.3 0 0 14.3 0 32S14.3 64 32 64V75c0 42.4 16.9 83.1 46.9 113.1L146.7 256 78.9 323.9C48.9 353.9 32 394.6 32 437v11c-17.7 0-32 14.3-32 32s14.3 32 32 32H64 320h32c17.7 0 32-14.3 32-32s-14.3-32-32-32V437c0-42.4-16.9-83.1-46.9-113.1L237.3 256l67.9-67.9c30-30 46.9-70.7 46.9-113.1V64c17.7 0 32-14.3 32-32s-14.3-32-32-32H320 64 32zM96 75V64H288V75c0 19-5.6 37.4-16 53H112c-10.3-15.6-16-34-16-53zm16 309c3.5-5.3 7.6-10.3 12.1-14.9L192 301.3l67.9 67.9c4.6 4.6 8.6 9.6 12.1 14.9H112z"
    ]
};
var $d8206b3ab2e65c05$export$f1052bbf6bf361c0 = $d8206b3ab2e65c05$export$703272eebf5e3eea;
var $d8206b3ab2e65c05$export$6a99139787bf9967 = {
    prefix: "fas",
    iconName: "microscope",
    icon: [
        512,
        512,
        [
            128300
        ],
        "f610",
        "M160 32c0-17.7 14.3-32 32-32h32c17.7 0 32 14.3 32 32c17.7 0 32 14.3 32 32V288c0 17.7-14.3 32-32 32c0 17.7-14.3 32-32 32H192c-17.7 0-32-14.3-32-32c-17.7 0-32-14.3-32-32V64c0-17.7 14.3-32 32-32zM32 448H320c70.7 0 128-57.3 128-128s-57.3-128-128-128V128c106 0 192 86 192 192c0 49.2-18.5 94-48.9 128H480c17.7 0 32 14.3 32 32s-14.3 32-32 32H320 32c-17.7 0-32-14.3-32-32s14.3-32 32-32zm80-64H304c8.8 0 16 7.2 16 16s-7.2 16-16 16H112c-8.8 0-16-7.2-16-16s7.2-16 16-16z"
    ]
};
var $d8206b3ab2e65c05$export$2a9dda2096ce792e = {
    prefix: "fas",
    iconName: "sink",
    icon: [
        512,
        512,
        [],
        "e06d",
        "M288 96c0-17.7 14.3-32 32-32s32 14.3 32 32s14.3 32 32 32s32-14.3 32-32c0-53-43-96-96-96s-96 43-96 96V288H160V264c0-30.9-25.1-56-56-56H56c-13.3 0-24 10.7-24 24s10.7 24 24 24h48c4.4 0 8 3.6 8 8v24H32c-17.7 0-32 14.3-32 32s14.3 32 32 32H256 480c17.7 0 32-14.3 32-32s-14.3-32-32-32H400V264c0-4.4 3.6-8 8-8h56c13.3 0 24-10.7 24-24s-10.7-24-24-24H408c-30.9 0-56 25.1-56 56v24H288V96zM480 416V384H32v32c0 53 43 96 96 96H384c53 0 96-43 96-96z"
    ]
};
var $d8206b3ab2e65c05$export$b0137b4600e9ab12 = {
    prefix: "fas",
    iconName: "bag-shopping",
    icon: [
        448,
        512,
        [
            "shopping-bag"
        ],
        "f290",
        "M160 112c0-35.3 28.7-64 64-64s64 28.7 64 64v48H160V112zm-48 48H48c-26.5 0-48 21.5-48 48V416c0 53 43 96 96 96H352c53 0 96-43 96-96V208c0-26.5-21.5-48-48-48H336V112C336 50.1 285.9 0 224 0S112 50.1 112 112v48zm24 48a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm152 24a24 24 0 1 1 48 0 24 24 0 1 1 -48 0z"
    ]
};
var $d8206b3ab2e65c05$export$5745f8adbc11eb01 = $d8206b3ab2e65c05$export$b0137b4600e9ab12;
var $d8206b3ab2e65c05$export$cf79d63ad07d943a = {
    prefix: "fas",
    iconName: "arrow-down-z-a",
    icon: [
        576,
        512,
        [
            "sort-alpha-desc",
            "sort-alpha-down-alt"
        ],
        "f881",
        "M183.6 469.6C177.5 476.2 169 480 160 480s-17.5-3.8-23.6-10.4l-88-96c-11.9-13-11.1-33.3 2-45.2s33.3-11.1 45.2 2L128 365.7V64c0-17.7 14.3-32 32-32s32 14.3 32 32V365.7l32.4-35.4c11.9-13 32.2-13.9 45.2-2s13.9 32.2 2 45.2l-88 96zM320 64c0-17.7 14.3-32 32-32H480c12.9 0 24.6 7.8 29.6 19.8s2.2 25.7-6.9 34.9L429.3 160H480c17.7 0 32 14.3 32 32s-14.3 32-32 32H352c-12.9 0-24.6-7.8-29.6-19.8s-2.2-25.7 6.9-34.9L402.7 96H352c-17.7 0-32-14.3-32-32zm96 192c12.1 0 23.2 6.8 28.6 17.7l64 128 16 32c7.9 15.8 1.5 35-14.3 42.9s-35 1.5-42.9-14.3L460.2 448H371.8l-7.2 14.3c-7.9 15.8-27.1 22.2-42.9 14.3s-22.2-27.1-14.3-42.9l16-32 64-128c5.4-10.8 16.5-17.7 28.6-17.7zM395.8 400h40.4L416 359.6 395.8 400z"
    ]
};
var $d8206b3ab2e65c05$export$7caf99612a55d427 = $d8206b3ab2e65c05$export$cf79d63ad07d943a;
var $d8206b3ab2e65c05$export$e12d23d82d5c8a89 = $d8206b3ab2e65c05$export$cf79d63ad07d943a;
var $d8206b3ab2e65c05$export$5030322c5fc886d7 = {
    prefix: "fas",
    iconName: "mitten",
    icon: [
        448,
        512,
        [],
        "f7b5",
        "M352 384H64L5.4 178.9C1.8 166.4 0 153.4 0 140.3C0 62.8 62.8 0 140.3 0h3.4c66 0 123.5 44.9 139.5 108.9l31.4 125.8 17.6-20.1C344.8 200.2 362.9 192 382 192h2.8c34.9 0 63.3 28.3 63.3 63.3c0 15.9-6 31.2-16.8 42.9L352 384zM32 448c0-17.7 14.3-32 32-32H352c17.7 0 32 14.3 32 32v32c0 17.7-14.3 32-32 32H64c-17.7 0-32-14.3-32-32V448z"
    ]
};
var $d8206b3ab2e65c05$export$49577f913f0fe4d2 = {
    prefix: "fas",
    iconName: "person-rays",
    icon: [
        512,
        512,
        [],
        "e54d",
        "M208 48a48 48 0 1 1 96 0 48 48 0 1 1 -96 0zm40 304V480c0 17.7-14.3 32-32 32s-32-14.3-32-32V256.9l-28.6 47.5c-9.1 15.1-28.8 20-43.9 10.9s-20-28.8-10.9-43.9l58.3-97c17.4-28.9 48.6-46.6 82.3-46.6h29.7c33.7 0 64.9 17.7 82.3 46.6l58.3 97c9.1 15.1 4.2 34.8-10.9 43.9s-34.8 4.2-43.9-10.9L328 256.9V480c0 17.7-14.3 32-32 32s-32-14.3-32-32V352H248zM7 7C16.4-2.3 31.6-2.3 41 7l80 80c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0L7 41C-2.3 31.6-2.3 16.4 7 7zM471 7c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9l-80 80c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9L471 7zM7 505c-9.4-9.4-9.4-24.6 0-33.9l80-80c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9L41 505c-9.4 9.4-24.6 9.4-33.9 0zm464 0l-80-80c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l80 80c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0z"
    ]
};
var $d8206b3ab2e65c05$export$e5a8f011aef571ac = {
    prefix: "fas",
    iconName: "users",
    icon: [
        640,
        512,
        [],
        "f0c0",
        "M144 0a80 80 0 1 1 0 160A80 80 0 1 1 144 0zM512 0a80 80 0 1 1 0 160A80 80 0 1 1 512 0zM0 298.7C0 239.8 47.8 192 106.7 192h42.7c15.9 0 31 3.5 44.6 9.7c-1.3 7.2-1.9 14.7-1.9 22.3c0 38.2 16.8 72.5 43.3 96c-.2 0-.4 0-.7 0H21.3C9.6 320 0 310.4 0 298.7zM405.3 320c-.2 0-.4 0-.7 0c26.6-23.5 43.3-57.8 43.3-96c0-7.6-.7-15-1.9-22.3c13.6-6.3 28.7-9.7 44.6-9.7h42.7C592.2 192 640 239.8 640 298.7c0 11.8-9.6 21.3-21.3 21.3H405.3zM224 224a96 96 0 1 1 192 0 96 96 0 1 1 -192 0zM128 485.3C128 411.7 187.7 352 261.3 352H378.7C452.3 352 512 411.7 512 485.3c0 14.7-11.9 26.7-26.7 26.7H154.7c-14.7 0-26.7-11.9-26.7-26.7z"
    ]
};
var $d8206b3ab2e65c05$export$ed3f2918429d029a = {
    prefix: "fas",
    iconName: "eye-slash",
    icon: [
        640,
        512,
        [],
        "f070",
        "M38.8 5.1C28.4-3.1 13.3-1.2 5.1 9.2S-1.2 34.7 9.2 42.9l592 464c10.4 8.2 25.5 6.3 33.7-4.1s6.3-25.5-4.1-33.7L525.6 386.7c39.6-40.6 66.4-86.1 79.9-118.4c3.3-7.9 3.3-16.7 0-24.6c-14.9-35.7-46.2-87.7-93-131.1C465.5 68.8 400.8 32 320 32c-68.2 0-125 26.3-169.3 60.8L38.8 5.1zM223.1 149.5C248.6 126.2 282.7 112 320 112c79.5 0 144 64.5 144 144c0 24.9-6.3 48.3-17.4 68.7L408 294.5c8.4-19.3 10.6-41.4 4.8-63.3c-11.1-41.5-47.8-69.4-88.6-71.1c-5.8-.2-9.2 6.1-7.4 11.7c2.1 6.4 3.3 13.2 3.3 20.3c0 10.2-2.4 19.8-6.6 28.3l-90.3-70.8zM373 389.9c-16.4 6.5-34.3 10.1-53 10.1c-79.5 0-144-64.5-144-144c0-6.9 .5-13.6 1.4-20.2L83.1 161.5C60.3 191.2 44 220.8 34.5 243.7c-3.3 7.9-3.3 16.7 0 24.6c14.9 35.7 46.2 87.7 93 131.1C174.5 443.2 239.2 480 320 480c47.8 0 89.9-12.9 126.2-32.5L373 389.9z"
    ]
};
var $d8206b3ab2e65c05$export$a25a266ce0c95019 = {
    prefix: "fas",
    iconName: "flask-vial",
    icon: [
        640,
        512,
        [],
        "e4f3",
        "M175 389.4c-9.8 16-15 34.3-15 53.1c-10 3.5-20.8 5.5-32 5.5c-53 0-96-43-96-96V64C14.3 64 0 49.7 0 32S14.3 0 32 0H96h64 64c17.7 0 32 14.3 32 32s-14.3 32-32 32V309.9l-49 79.6zM96 64v96h64V64H96zM352 0H480h32c17.7 0 32 14.3 32 32s-14.3 32-32 32V214.9L629.7 406.2c6.7 10.9 10.3 23.5 10.3 36.4c0 38.3-31.1 69.4-69.4 69.4H261.4c-38.3 0-69.4-31.1-69.4-69.4c0-12.8 3.6-25.4 10.3-36.4L320 214.9V64c-17.7 0-32-14.3-32-32s14.3-32 32-32h32zm32 64V224c0 5.9-1.6 11.7-4.7 16.8L330.5 320h171l-48.8-79.2c-3.1-5-4.7-10.8-4.7-16.8V64H384z"
    ]
};
var $d8206b3ab2e65c05$export$f69db0b876f7d753 = {
    prefix: "fas",
    iconName: "hand",
    icon: [
        512,
        512,
        [
            129306,
            9995,
            "hand-paper"
        ],
        "f256",
        "M288 32c0-17.7-14.3-32-32-32s-32 14.3-32 32V240c0 8.8-7.2 16-16 16s-16-7.2-16-16V64c0-17.7-14.3-32-32-32s-32 14.3-32 32V336c0 1.5 0 3.1 .1 4.6L67.6 283c-16-15.2-41.3-14.6-56.6 1.4s-14.6 41.3 1.4 56.6L124.8 448c43.1 41.1 100.4 64 160 64H304c97.2 0 176-78.8 176-176V128c0-17.7-14.3-32-32-32s-32 14.3-32 32V240c0 8.8-7.2 16-16 16s-16-7.2-16-16V64c0-17.7-14.3-32-32-32s-32 14.3-32 32V240c0 8.8-7.2 16-16 16s-16-7.2-16-16V32z"
    ]
};
var $d8206b3ab2e65c05$export$6e6216c8b50471bb = $d8206b3ab2e65c05$export$f69db0b876f7d753;
var $d8206b3ab2e65c05$export$8de8eb94230028a5 = {
    prefix: "fas",
    iconName: "om",
    icon: [
        512,
        512,
        [
            128329
        ],
        "f679",
        "M379.3 4.7c-6.2-6.2-16.4-6.2-22.6 0l-16 16c-6.2 6.2-6.2 16.4 0 22.6l16 16c6.2 6.2 16.4 6.2 22.6 0l16-16c6.2-6.2 6.2-16.4 0-22.6l-16-16zM115.2 169.6c8-6 17.9-9.6 28.8-9.6c26.5 0 48 21.5 48 48s-21.5 48-48 48H109.8c-7.6 0-13.8 6.2-13.8 13.8c0 1.5 .2 2.9 .7 4.4l8 24c4.4 13.1 16.6 21.9 30.4 21.9H144h16c35.3 0 64 28.7 64 64s-28.7 64-64 64c-50.8 0-82.7-21.5-102.2-42.8c-9.9-10.8-16.6-21.6-20.9-29.7c-2.1-4-3.6-7.3-4.5-9.6c-.5-1.1-.8-2-1-2.5l-.2-.5 0-.1c-2.6-7.8-10.7-12.3-18.7-10.5C4.4 354.2-.9 361.8 .1 370L16 368C.1 370 .1 370 .1 370l0 0 0 0 0 .1 .1 .4c0 .3 .1 .8 .2 1.3c.2 1.1 .4 2.7 .8 4.6c.8 3.9 2 9.4 3.9 15.9c3.8 13 10.3 30.4 21.3 48C48.7 476.2 89.4 512 160 512c70.7 0 128-57.3 128-128c0-23.3-6.2-45.2-17.1-64h22.6c25.5 0 49.9-10.1 67.9-28.1l26.5-26.5c6-6 14.1-9.4 22.6-9.4H416c17.7 0 32 14.3 32 32v96c0 17.7-14.3 32-32 32c-25.7 0-41.4-12.5-51.2-25.6c-5-6.7-8.4-13.4-10.5-18.6c-1.1-2.5-1.8-4.6-2.2-6c-.2-.7-.4-1.2-.5-1.5l-.1-.3 0 0c0 0 0 0 0 0c-1.9-7.3-8.6-12.4-16.2-12.1c-7.6 .3-13.9 5.9-15.1 13.4L336 368c-15.8-2.6-15.8-2.6-15.8-2.6l0 0 0 0 0 .1-.1 .3c0 .3-.1 .6-.2 1.1c-.1 .9-.3 2.1-.4 3.6c-.3 3-.6 7.3-.6 12.4c0 10.1 1.1 23.9 5.8 38.1c4.8 14.3 13.4 29.3 28.6 40.7C368.7 473.3 389.3 480 416 480c53 0 96-43 96-96V288c0-53-43-96-96-96h-5.5c-25.5 0-49.9 10.1-67.9 28.1l-26.5 26.5c-6 6-14.1 9.4-22.6 9.4H245.2c6.9-14.5 10.8-30.8 10.8-48c0-61.9-50.1-112-112-112c-25.2 0-48.5 8.3-67.2 22.4c-14.1 10.6-17 30.7-6.4 44.8s30.7 17 44.8 6.4zM280.9 66.7c-6-4-14-3.5-19.5 1.3s-7 12.7-3.7 19.2L272 80c-14.3 7.2-14.3 7.2-14.3 7.2l0 0 0 0 0 .1 .1 .2 .4 .7c.3 .6 .8 1.4 1.4 2.4c1.2 2 2.9 4.8 5.1 8.2c4.4 6.7 11.1 15.5 20 24.4C302.4 141.1 330.3 160 368 160c31.2 0 56.6-10.4 73.9-20.2c8.7-5 15.6-9.9 20.4-13.8c2.4-1.9 4.3-3.6 5.7-4.9c.7-.6 1.3-1.2 1.7-1.6l.6-.5 .2-.2 .1-.1 0 0 0 0c0 0 0 0-22.6-22.6l22.6 22.6c12.5-12.5 12.5-32.8 0-45.3c-12.4-12.4-32.6-12.5-45.1-.2c-.1 .1-.2 .2-.5 .4c-.5 .5-1.5 1.3-2.8 2.4c-2.7 2.2-6.8 5.2-12.1 8.2C399.4 90.4 384.8 96 368 96c-20.8 0-42.4-7-59.5-14.6c-8.4-3.7-15.4-7.5-20.3-10.3c-2.4-1.4-4.3-2.5-5.6-3.3c-.6-.4-1.1-.7-1.4-.9l-.3-.2 0 0 0 0 0 0z"
    ]
};
var $d8206b3ab2e65c05$export$2571e33fa6c25993 = {
    prefix: "fas",
    iconName: "worm",
    icon: [
        512,
        512,
        [],
        "e599",
        "M256 96c0-53 43-96 96-96h38.4C439.9 0 480 40.1 480 89.6V176v16V376c0 75.1-60.9 136-136 136s-136-60.9-136-136V296c0-22.1-17.9-40-40-40s-40 17.9-40 40V464c0 26.5-21.5 48-48 48s-48-21.5-48-48V296c0-75.1 60.9-136 136-136s136 60.9 136 136v80c0 22.1 17.9 40 40 40s40-17.9 40-40V192H352c-53 0-96-43-96-96zm144-8a24 24 0 1 0 -48 0 24 24 0 1 0 48 0z"
    ]
};
var $d8206b3ab2e65c05$export$423555e8708eb4c7 = {
    prefix: "fas",
    iconName: "house-circle-xmark",
    icon: [
        640,
        512,
        [],
        "e50b",
        "M320.7 352c8.1-89.7 83.5-160 175.3-160c8.9 0 17.6 .7 26.1 1.9L309.5 7c-6-5-14-7-21-7s-15 1-22 8L10 231.5c-7 7-10 15-10 24c0 18 14 32.1 32 32.1h32v69.7c-.1 .9-.1 1.8-.1 2.8V472c0 22.1 17.9 40 40 40h16c1.2 0 2.4-.1 3.6-.2c1.5 .1 3 .2 4.5 .2H160h24c22.1 0 40-17.9 40-40V448 384c0-17.7 14.3-32 32-32h64l.7 0zM496 512a144 144 0 1 0 0-288 144 144 0 1 0 0 288zm59.3-180.7L518.6 368l36.7 36.7c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0L496 390.6l-36.7 36.7c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6L473.4 368l-36.7-36.7c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0L496 345.4l36.7-36.7c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6z"
    ]
};
var $d8206b3ab2e65c05$export$cae5752c3e3b6545 = {
    prefix: "fas",
    iconName: "plug",
    icon: [
        384,
        512,
        [
            128268
        ],
        "f1e6",
        "M96 0C78.3 0 64 14.3 64 32v96h64V32c0-17.7-14.3-32-32-32zM288 0c-17.7 0-32 14.3-32 32v96h64V32c0-17.7-14.3-32-32-32zM32 160c-17.7 0-32 14.3-32 32s14.3 32 32 32v32c0 77.4 55 142 128 156.8V480c0 17.7 14.3 32 32 32s32-14.3 32-32V412.8C297 398 352 333.4 352 256V224c17.7 0 32-14.3 32-32s-14.3-32-32-32H32z"
    ]
};
var $d8206b3ab2e65c05$export$877e5ae47a854215 = {
    prefix: "fas",
    iconName: "chevron-up",
    icon: [
        512,
        512,
        [],
        "f077",
        "M233.4 105.4c12.5-12.5 32.8-12.5 45.3 0l192 192c12.5 12.5 12.5 32.8 0 45.3s-32.8 12.5-45.3 0L256 173.3 86.6 342.6c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3l192-192z"
    ]
};
var $d8206b3ab2e65c05$export$2262d6b626de1120 = {
    prefix: "fas",
    iconName: "hand-spock",
    icon: [
        576,
        512,
        [
            128406
        ],
        "f259",
        "M246.9 23.7C242.3 6.6 224.8-3.5 207.7 1.1s-27.2 22.1-22.6 39.2L238 237.8c2.5 9.2-4.5 18.2-14 18.2c-6.4 0-12-4.2-13.9-10.3L166.6 102.7c-5.1-16.9-23-26.4-39.9-21.3s-26.4 23-21.3 39.9l62.8 206.4c2.4 7.9-7.2 13.8-13.2 8.1L99.6 283c-16-15.2-41.3-14.6-56.6 1.4s-14.6 41.3 1.4 56.6L156.8 448c43.1 41.1 100.4 64 160 64h10.9 8.2c.1 0 .1-.1 .1-.1v0c0-.1 .1-.1 .1-.1c58.3-3.5 108.6-43.2 125.3-99.7l81.2-275c5-16.9-4.7-34.7-21.6-39.8s-34.7 4.7-39.8 21.6L443.5 247.1c-1.6 5.3-6.4 8.9-12 8.9c-7.9 0-13.8-7.3-12.2-15.1l36-170.3c3.7-17.3-7.4-34.3-24.7-37.9s-34.3 7.4-37.9 24.7L355.1 235.1c-2.6 12.2-13.3 20.9-25.8 20.9c-11.9 0-22.4-8-25.4-19.5l-57-212.8z"
    ]
};
var $d8206b3ab2e65c05$export$b85a7300fc7960b6 = {
    prefix: "fas",
    iconName: "stopwatch",
    icon: [
        448,
        512,
        [
            9201
        ],
        "f2f2",
        "M176 0c-17.7 0-32 14.3-32 32s14.3 32 32 32h16V98.4C92.3 113.8 16 200 16 304c0 114.9 93.1 208 208 208s208-93.1 208-208c0-41.8-12.3-80.7-33.5-113.2l24.1-24.1c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L355.7 143c-28.1-23-62.2-38.8-99.7-44.6V64h16c17.7 0 32-14.3 32-32s-14.3-32-32-32H224 176zm72 192V320c0 13.3-10.7 24-24 24s-24-10.7-24-24V192c0-13.3 10.7-24 24-24s24 10.7 24 24z"
    ]
};
var $d8206b3ab2e65c05$export$5a54c83033a0a56a = {
    prefix: "fas",
    iconName: "face-kiss",
    icon: [
        512,
        512,
        [
            128535,
            "kiss"
        ],
        "f596",
        "M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zm48.7-198.3c4.3 5.1 7.3 11.4 7.3 18.3s-3.1 13.2-7.3 18.3c-4.3 5.2-10.1 9.7-16.7 13.4c-2.7 1.5-5.7 3-8.7 4.3c3.1 1.3 6 2.7 8.7 4.3c6.6 3.7 12.5 8.2 16.7 13.4c4.3 5.1 7.3 11.4 7.3 18.3s-3.1 13.2-7.3 18.3c-4.3 5.2-10.1 9.7-16.7 13.4C274.7 443.1 257.4 448 240 448c-3.6 0-6.8-2.5-7.7-6s.6-7.2 3.8-9l0 0 0 0 0 0 0 0 .2-.1c.2-.1 .5-.3 .9-.5c.8-.5 2-1.2 3.4-2.1c2.8-1.9 6.5-4.5 10.2-7.6c3.7-3.1 7.2-6.6 9.6-10.1c2.5-3.5 3.5-6.4 3.5-8.6s-1-5-3.5-8.6c-2.5-3.5-5.9-6.9-9.6-10.1c-3.7-3.1-7.4-5.7-10.2-7.6c-1.4-.9-2.6-1.6-3.4-2.1c-.4-.2-.7-.4-.9-.5l-.2-.1 0 0 0 0 0 0c-2.5-1.4-4.1-4.1-4.1-7s1.6-5.6 4.1-7l0 0 0 0 0 0 0 0 0 0 .2-.1 .3-.2 .6-.4c.8-.5 2-1.2 3.4-2.1c2.8-1.9 6.5-4.5 10.2-7.6c3.7-3.1 7.2-6.6 9.6-10.1c2.5-3.5 3.5-6.4 3.5-8.6s-1-5-3.5-8.6c-2.5-3.5-5.9-6.9-9.6-10.1c-3.7-3.1-7.4-5.7-10.2-7.6c-1.4-.9-2.6-1.6-3.4-2.1l-.4-.3-.5-.3-.2-.1 0 0 0 0 0 0c-3.2-1.8-4.7-5.5-3.8-9s4.1-6 7.7-6c17.4 0 34.7 4.9 47.9 12.3c6.6 3.7 12.5 8.2 16.7 13.4zM144.4 208a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm192-32a32 32 0 1 1 0 64 32 32 0 1 1 0-64z"
    ]
};
var $d8206b3ab2e65c05$export$c762a77aabf64fd0 = $d8206b3ab2e65c05$export$5a54c83033a0a56a;
var $d8206b3ab2e65c05$export$834071278537f121 = {
    prefix: "fas",
    iconName: "bridge-circle-xmark",
    icon: [
        640,
        512,
        [],
        "e4cb",
        "M64 32C46.3 32 32 46.3 32 64s14.3 32 32 32h40v64H32V288c53 0 96 43 96 96v64c0 17.7 14.3 32 32 32h32c17.7 0 32-14.3 32-32V384c0-53 43-96 96-96c6.3 0 12.4 .6 18.3 1.7C367.1 231.8 426.9 192 496 192c42.5 0 81.6 15.1 112 40.2V160H536V96h40c17.7 0 32-14.3 32-32s-14.3-32-32-32H64zM488 96v64H408V96h80zM360 96v64H280V96h80zM232 96v64H152V96h80zM496 512a144 144 0 1 0 0-288 144 144 0 1 0 0 288zm59.3-180.7L518.6 368l36.7 36.7c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0L496 390.6l-36.7 36.7c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6L473.4 368l-36.7-36.7c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0L496 345.4l36.7-36.7c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6z"
    ]
};
var $d8206b3ab2e65c05$export$95a7394c24f57943 = {
    prefix: "fas",
    iconName: "face-grin-tongue",
    icon: [
        512,
        512,
        [
            128539,
            "grin-tongue"
        ],
        "f589",
        "M0 256C0 368.9 73.1 464.7 174.5 498.8C165.3 484 160 466.6 160 448V400.7c-24-17.5-43.1-41.4-54.8-69.2c-5-11.8 7-22.5 19.3-18.7c39.7 12.2 84.5 19 131.8 19s92.1-6.8 131.8-19c12.3-3.8 24.3 6.9 19.3 18.7c-11.8 28-31.1 52-55.4 69.6V448c0 18.6-5.3 36-14.5 50.8C438.9 464.7 512 368.9 512 256C512 114.6 397.4 0 256 0S0 114.6 0 256zm176.4-80a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm128 32a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zM320 448V402.6c0-14.7-11.9-26.6-26.6-26.6h-2c-11.3 0-21.1 7.9-23.6 18.9c-2.8 12.6-20.8 12.6-23.6 0c-2.5-11.1-12.3-18.9-23.6-18.9h-2c-14.7 0-26.6 11.9-26.6 26.6V448c0 35.3 28.7 64 64 64s64-28.7 64-64z"
    ]
};
var $d8206b3ab2e65c05$export$ef222816a43a4b3a = $d8206b3ab2e65c05$export$95a7394c24f57943;
var $d8206b3ab2e65c05$export$a831eedd2f59c62f = {
    prefix: "fas",
    iconName: "chess-bishop",
    icon: [
        320,
        512,
        [
            9821
        ],
        "f43a",
        "M128 0C110.3 0 96 14.3 96 32c0 16.1 11.9 29.4 27.4 31.7C78.4 106.8 8 190 8 288c0 47.4 30.8 72.3 56 84.7V400H256V372.7c25.2-12.5 56-37.4 56-84.7c0-37.3-10.2-72.4-25.3-104.1l-99.4 99.4c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6L270.8 154.6c-23.2-38.1-51.8-69.5-74.2-90.9C212.1 61.4 224 48.1 224 32c0-17.7-14.3-32-32-32H128zM48 432L6.6 473.4c-4.2 4.2-6.6 10-6.6 16C0 501.9 10.1 512 22.6 512H297.4c12.5 0 22.6-10.1 22.6-22.6c0-6-2.4-11.8-6.6-16L272 432H48z"
    ]
};
var $d8206b3ab2e65c05$export$1dd161850c5bc64e = {
    prefix: "fas",
    iconName: "face-grin-wink",
    icon: [
        512,
        512,
        [
            "grin-wink"
        ],
        "f58c",
        "M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM388.1 312.8c12.3-3.8 24.3 6.9 19.3 18.7C382.4 390.6 324.2 432 256.3 432s-126.2-41.4-151.1-100.5c-5-11.8 7-22.5 19.3-18.7c39.7 12.2 84.5 19 131.8 19s92.1-6.8 131.8-19zm-16.9-79.2c-17.6-23.5-52.8-23.5-70.4 0c-5.3 7.1-15.3 8.5-22.4 3.2s-8.5-15.3-3.2-22.4c30.4-40.5 91.2-40.5 121.6 0c5.3 7.1 3.9 17.1-3.2 22.4s-17.1 3.9-22.4-3.2zM176.4 176a32 32 0 1 1 0 64 32 32 0 1 1 0-64z"
    ]
};
var $d8206b3ab2e65c05$export$2397fcd34eb12177 = $d8206b3ab2e65c05$export$1dd161850c5bc64e;
var $d8206b3ab2e65c05$export$c9c5b76ec992eab4 = {
    prefix: "fas",
    iconName: "ear-deaf",
    icon: [
        512,
        512,
        [
            "deaf",
            "deafness",
            "hard-of-hearing"
        ],
        "f2a4",
        "M502.6 54.6l-40 40c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3l40-40c12.5-12.5 32.8-12.5 45.3 0s12.5 32.8 0 45.3zm-320 320l-128 128c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3l128-128c12.5-12.5 32.8-12.5 45.3 0s12.5 32.8 0 45.3zM240 128c-57.6 0-105.1 43.6-111.3 99.5c-1.9 17.6-17.8 30.2-35.3 28.3s-30.2-17.8-28.3-35.3C74.8 132.5 149.4 64 240 64c97.2 0 176 78.8 176 176c0 46-17.7 87.9-46.6 119.3c-12 13-17.4 24.8-17.4 34.7V400c0 61.9-50.1 112-112 112c-17.7 0-32-14.3-32-32s14.3-32 32-32c26.5 0 48-21.5 48-48v-6.1c0-32.9 17.4-59.6 34.4-78c18.4-20 29.6-46.6 29.6-75.9c0-61.9-50.1-112-112-112zm0 80c-17.7 0-32 14.3-32 32c0 13.3-10.7 24-24 24s-24-10.7-24-24c0-44.2 35.8-80 80-80s80 35.8 80 80c0 13.3-10.7 24-24 24s-24-10.7-24-24c0-17.7-14.3-32-32-32z"
    ]
};
var $d8206b3ab2e65c05$export$4b666adf83f0de01 = $d8206b3ab2e65c05$export$c9c5b76ec992eab4;
var $d8206b3ab2e65c05$export$85c6a9ab2fa2631e = $d8206b3ab2e65c05$export$c9c5b76ec992eab4;
var $d8206b3ab2e65c05$export$ebecf90a5676e17a = $d8206b3ab2e65c05$export$c9c5b76ec992eab4;
var $d8206b3ab2e65c05$export$3f22db9ae9b6be1c = {
    prefix: "fas",
    iconName: "road-circle-check",
    icon: [
        640,
        512,
        [],
        "e564",
        "M213.2 32H288V96c0 17.7 14.3 32 32 32s32-14.3 32-32V32h74.8c27.1 0 51.3 17.1 60.3 42.6l42.7 120.6c-10.9-2.1-22.2-3.2-33.8-3.2c-59.5 0-112.1 29.6-144 74.8V224c0-17.7-14.3-32-32-32s-32 14.3-32 32v64c0 17.7 14.3 32 32 32c2.3 0 4.6-.3 6.8-.7c-4.5 15.5-6.8 31.8-6.8 48.7c0 5.4 .2 10.7 .7 16l-.7 0c-17.7 0-32 14.3-32 32v64H86.6C56.5 480 32 455.5 32 425.4c0-6.2 1.1-12.4 3.1-18.2L152.9 74.6C162 49.1 186.1 32 213.2 32zM352 368a144 144 0 1 1 288 0 144 144 0 1 1 -288 0zm211.3-43.3c-6.2-6.2-16.4-6.2-22.6 0L480 385.4l-28.7-28.7c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6l40 40c6.2 6.2 16.4 6.2 22.6 0l72-72c6.2-6.2 6.2-16.4 0-22.6z"
    ]
};
var $d8206b3ab2e65c05$export$d9769fb795c2db82 = {
    prefix: "fas",
    iconName: "dice-five",
    icon: [
        448,
        512,
        [
            9860
        ],
        "f523",
        "M64 32C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64zm64 96a32 32 0 1 1 0 64 32 32 0 1 1 0-64zM96 352a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zM224 224a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm64-64a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm32 160a32 32 0 1 1 0 64 32 32 0 1 1 0-64z"
    ]
};
var $d8206b3ab2e65c05$export$97d1903b1e012ff7 = {
    prefix: "fas",
    iconName: "square-rss",
    icon: [
        448,
        512,
        [
            "rss-square"
        ],
        "f143",
        "M64 32C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64zM96 136c0-13.3 10.7-24 24-24c137 0 248 111 248 248c0 13.3-10.7 24-24 24s-24-10.7-24-24c0-110.5-89.5-200-200-200c-13.3 0-24-10.7-24-24zm0 96c0-13.3 10.7-24 24-24c83.9 0 152 68.1 152 152c0 13.3-10.7 24-24 24s-24-10.7-24-24c0-57.4-46.6-104-104-104c-13.3 0-24-10.7-24-24zm0 120a32 32 0 1 1 64 0 32 32 0 1 1 -64 0z"
    ]
};
var $d8206b3ab2e65c05$export$89c9b1cca2c11484 = $d8206b3ab2e65c05$export$97d1903b1e012ff7;
var $d8206b3ab2e65c05$export$567a897fc092e403 = {
    prefix: "fas",
    iconName: "land-mine-on",
    icon: [
        640,
        512,
        [],
        "e51b",
        "M344 24V168c0 13.3-10.7 24-24 24s-24-10.7-24-24V24c0-13.3 10.7-24 24-24s24 10.7 24 24zM192 320c0-17.7 14.3-32 32-32H416c17.7 0 32 14.3 32 32v32H192V320zm-77.3 90.5c8.1-16.3 24.8-26.5 42.9-26.5H482.3c18.2 0 34.8 10.3 42.9 26.5l27.6 55.2C563.5 487 548 512 524.2 512H115.8c-23.8 0-39.3-25-28.6-46.3l27.6-55.2zM36.3 138.3c7.5-10.9 22.5-13.6 33.4-6.1l104 72c10.9 7.5 13.6 22.5 6.1 33.4s-22.5 13.6-33.4 6.1l-104-72c-10.9-7.5-13.6-22.5-6.1-33.4zm534.1-6.1c10.9-7.5 25.8-4.8 33.4 6.1s4.8 25.8-6.1 33.4l-104 72c-10.9 7.5-25.8 4.8-33.4-6.1s-4.8-25.8 6.1-33.4l104-72z"
    ]
};
var $d8206b3ab2e65c05$export$7fddf76ec23943d8 = {
    prefix: "fas",
    iconName: "i-cursor",
    icon: [
        256,
        512,
        [],
        "f246",
        "M.1 29.3C-1.4 47 11.7 62.4 29.3 63.9l8 .7C70.5 67.3 96 95 96 128.3V224H64c-17.7 0-32 14.3-32 32s14.3 32 32 32H96v95.7c0 33.3-25.5 61-58.7 63.8l-8 .7C11.7 449.6-1.4 465 .1 482.7s16.9 30.7 34.5 29.2l8-.7c34.1-2.8 64.2-18.9 85.4-42.9c21.2 24 51.2 40.1 85.4 42.9l8 .7c17.6 1.5 33.1-11.6 34.5-29.2s-11.6-33.1-29.2-34.5l-8-.7C185.5 444.7 160 417 160 383.7V288h32c17.7 0 32-14.3 32-32s-14.3-32-32-32H160V128.3c0-33.3 25.5-61 58.7-63.8l8-.7c17.6-1.5 30.7-16.9 29.2-34.5S239-1.4 221.3 .1l-8 .7C179.2 3.6 149.2 19.7 128 43.7c-21.2-24-51.2-40-85.4-42.9l-8-.7C17-1.4 1.6 11.7 .1 29.3z"
    ]
};
var $d8206b3ab2e65c05$export$722e92d2d93ffc68 = {
    prefix: "fas",
    iconName: "stamp",
    icon: [
        512,
        512,
        [],
        "f5bf",
        "M312 201.8c0-17.4 9.2-33.2 19.9-47C344.5 138.5 352 118.1 352 96c0-53-43-96-96-96s-96 43-96 96c0 22.1 7.5 42.5 20.1 58.8c10.7 13.8 19.9 29.6 19.9 47c0 29.9-24.3 54.2-54.2 54.2H112C50.1 256 0 306.1 0 368c0 20.9 13.4 38.7 32 45.3V464c0 26.5 21.5 48 48 48H432c26.5 0 48-21.5 48-48V413.3c18.6-6.6 32-24.4 32-45.3c0-61.9-50.1-112-112-112H366.2c-29.9 0-54.2-24.3-54.2-54.2zM416 416v32H96V416H416z"
    ]
};
var $d8206b3ab2e65c05$export$68b3af7444c89df7 = {
    prefix: "fas",
    iconName: "stairs",
    icon: [
        576,
        512,
        [],
        "e289",
        "M384 64c0-17.7 14.3-32 32-32H544c17.7 0 32 14.3 32 32s-14.3 32-32 32H448v96c0 17.7-14.3 32-32 32H320v96c0 17.7-14.3 32-32 32H192v96c0 17.7-14.3 32-32 32H32c-17.7 0-32-14.3-32-32s14.3-32 32-32h96V320c0-17.7 14.3-32 32-32h96V192c0-17.7 14.3-32 32-32h96V64z"
    ]
};
var $d8206b3ab2e65c05$export$aee03ca0815b7c38 = {
    prefix: "fas",
    iconName: "i",
    icon: [
        320,
        512,
        [
            105
        ],
        "49",
        "M32 32C14.3 32 0 46.3 0 64S14.3 96 32 96h96V416H32c-17.7 0-32 14.3-32 32s14.3 32 32 32H288c17.7 0 32-14.3 32-32s-14.3-32-32-32H192V96h96c17.7 0 32-14.3 32-32s-14.3-32-32-32H160 32z"
    ]
};
var $d8206b3ab2e65c05$export$22a9491150c64fef = {
    prefix: "fas",
    iconName: "hryvnia-sign",
    icon: [
        384,
        512,
        [
            8372,
            "hryvnia"
        ],
        "f6f2",
        "M121.9 116.2C138.3 103.1 158.7 96 179.6 96H223c27.1 0 49 21.9 49 49c0 11.5-4 22.4-11.1 31H32c-17.7 0-32 14.3-32 32s14.3 32 32 32H155.5l-50.6 28.9c-1.7 1-3.4 2-5.1 3.1H32c-17.7 0-32 14.3-32 32s14.3 32 32 32H52.3c-2.8 9.9-4.3 20.4-4.3 31c0 62.4 50.6 113 113 113h43.4c35.5 0 70-12.1 97.7-34.3L308 441c13.8-11 16-31.2 5-45s-31.2-16-45-5l-5.9 4.7c-16.4 13.1-36.7 20.2-57.7 20.2H161c-27.1 0-49-21.9-49-49c0-11.5 4-22.4 11.1-31H352c17.7 0 32-14.3 32-32s-14.3-32-32-32H228.5l50.6-28.9c1.7-1 3.4-2 5.1-3.1H352c17.7 0 32-14.3 32-32s-14.3-32-32-32H331.7c2.8-10 4.3-20.4 4.3-31c0-62.4-50.6-113-113-113H179.6c-35.5 0-70 12.1-97.7 34.3L76 71c-13.8 11-16 31.2-5 45s31.2 16 45 5l5.9-4.7z"
    ]
};
var $d8206b3ab2e65c05$export$33d5f94bd6f75f59 = $d8206b3ab2e65c05$export$22a9491150c64fef;
var $d8206b3ab2e65c05$export$6380e2ed6e69d350 = {
    prefix: "fas",
    iconName: "pills",
    icon: [
        576,
        512,
        [],
        "f484",
        "M112 96c-26.5 0-48 21.5-48 48V256h96V144c0-26.5-21.5-48-48-48zM0 144C0 82.1 50.1 32 112 32s112 50.1 112 112V368c0 61.9-50.1 112-112 112S0 429.9 0 368V144zM554.9 399.4c-7.1 12.3-23.7 13.1-33.8 3.1L333.5 214.9c-10-10-9.3-26.7 3.1-33.8C360 167.7 387.1 160 416 160c88.4 0 160 71.6 160 160c0 28.9-7.7 56-21.1 79.4zm-59.5 59.5C472 472.3 444.9 480 416 480c-88.4 0-160-71.6-160-160c0-28.9 7.7-56 21.1-79.4c7.1-12.3 23.7-13.1 33.8-3.1L498.5 425.1c10 10 9.3 26.7-3.1 33.8z"
    ]
};
var $d8206b3ab2e65c05$export$bdbabf493c478cde = {
    prefix: "fas",
    iconName: "face-grin-wide",
    icon: [
        512,
        512,
        [
            128515,
            "grin-alt"
        ],
        "f581",
        "M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM388.1 312.8c12.3-3.8 24.3 6.9 19.3 18.7C382.4 390.6 324.2 432 256.3 432s-126.2-41.4-151.1-100.5c-5-11.8 7-22.5 19.3-18.7c39.7 12.2 84.5 19 131.8 19s92.1-6.8 131.8-19zM208 192c0 35.3-14.3 64-32 64s-32-28.7-32-64s14.3-64 32-64s32 28.7 32 64zm128 64c-17.7 0-32-28.7-32-64s14.3-64 32-64s32 28.7 32 64s-14.3 64-32 64z"
    ]
};
var $d8206b3ab2e65c05$export$b4abebfe416d36ba = $d8206b3ab2e65c05$export$bdbabf493c478cde;
var $d8206b3ab2e65c05$export$3a1fa2d16f90d635 = {
    prefix: "fas",
    iconName: "tooth",
    icon: [
        448,
        512,
        [
            129463
        ],
        "f5c9",
        "M186.1 52.1C169.3 39.1 148.7 32 127.5 32C74.7 32 32 74.7 32 127.5v6.2c0 15.8 3.7 31.3 10.7 45.5l23.5 47.1c4.5 8.9 7.6 18.4 9.4 28.2l36.7 205.8c2 11.2 11.6 19.4 22.9 19.8s21.4-7.4 24-18.4l28.9-121.3C192.2 323.7 207 312 224 312s31.8 11.7 35.8 28.3l28.9 121.3c2.6 11.1 12.7 18.8 24 18.4s20.9-8.6 22.9-19.8l36.7-205.8c1.8-9.8 4.9-19.3 9.4-28.2l23.5-47.1c7.1-14.1 10.7-29.7 10.7-45.5v-2.1c0-55-44.6-99.6-99.6-99.6c-24.1 0-47.4 8.8-65.6 24.6l-3.2 2.8 19.5 15.2c7 5.4 8.2 15.5 2.8 22.5s-15.5 8.2-22.5 2.8l-24.4-19-37-28.8z"
    ]
};
var $d8206b3ab2e65c05$export$6fb446f784f6b9b3 = {
    prefix: "fas",
    iconName: "v",
    icon: [
        384,
        512,
        [
            118
        ],
        "56",
        "M19.7 34.5c16.3-6.8 35 .9 41.8 17.2L192 364.8 322.5 51.7c6.8-16.3 25.5-24 41.8-17.2s24 25.5 17.2 41.8l-160 384c-5 11.9-16.6 19.7-29.5 19.7s-24.6-7.8-29.5-19.7L2.5 76.3c-6.8-16.3 .9-35 17.2-41.8z"
    ]
};
var $d8206b3ab2e65c05$export$469d376940e10d37 = {
    prefix: "fas",
    iconName: "bangladeshi-taka-sign",
    icon: [
        384,
        512,
        [],
        "e2e6",
        "M36 32.2C18.4 30.1 2.4 42.5 .2 60S10.5 93.6 28 95.8l7.9 1c16 2 28 15.6 28 31.8V160H32c-17.7 0-32 14.3-32 32s14.3 32 32 32H64V384c0 53 43 96 96 96h32c106 0 192-86 192-192V256c0-53-43-96-96-96H272c-17.7 0-32 14.3-32 32s14.3 32 32 32h16c17.7 0 32 14.3 32 32v32c0 70.7-57.3 128-128 128H160c-17.7 0-32-14.3-32-32V224h32c17.7 0 32-14.3 32-32s-14.3-32-32-32H128V128.5c0-48.4-36.1-89.3-84.1-95.3l-7.9-1z"
    ]
};
var $d8206b3ab2e65c05$export$36cb1885ad7a570f = {
    prefix: "fas",
    iconName: "bicycle",
    icon: [
        640,
        512,
        [
            128690
        ],
        "f206",
        "M312 32c-13.3 0-24 10.7-24 24s10.7 24 24 24h25.7l34.6 64H222.9l-27.4-38C191 99.7 183.7 96 176 96H120c-13.3 0-24 10.7-24 24s10.7 24 24 24h43.7l22.1 30.7-26.6 53.1c-10-2.5-20.5-3.8-31.2-3.8C57.3 224 0 281.3 0 352s57.3 128 128 128c65.3 0 119.1-48.9 127-112h49c8.5 0 16.3-4.5 20.7-11.8l84.8-143.5 21.7 40.1C402.4 276.3 384 312 384 352c0 70.7 57.3 128 128 128s128-57.3 128-128s-57.3-128-128-128c-13.5 0-26.5 2.1-38.7 6L375.4 48.8C369.8 38.4 359 32 347.2 32H312zM458.6 303.7l32.3 59.7c6.3 11.7 20.9 16 32.5 9.7s16-20.9 9.7-32.5l-32.3-59.7c3.6-.6 7.4-.9 11.2-.9c39.8 0 72 32.2 72 72s-32.2 72-72 72s-72-32.2-72-72c0-18.6 7-35.5 18.6-48.3zM133.2 368h65c-7.3 32.1-36 56-70.2 56c-39.8 0-72-32.2-72-72s32.2-72 72-72c1.7 0 3.4 .1 5.1 .2l-24.2 48.5c-9 18.1 4.1 39.4 24.3 39.4zm33.7-48l50.7-101.3 72.9 101.2-.1 .1H166.8zm90.6-128H365.9L317 274.8 257.4 192z"
    ]
};
var $d8206b3ab2e65c05$export$76d998742bc186eb = {
    prefix: "fas",
    iconName: "staff-snake",
    icon: [
        384,
        512,
        [
            "rod-asclepius",
            "rod-snake",
            "staff-aesculapius"
        ],
        "e579",
        "M222.6 43.2l-.1 4.8H288c53 0 96 43 96 96s-43 96-96 96H248V160h40c8.8 0 16-7.2 16-16s-7.2-16-16-16H248 220l-4.5 144H256c53 0 96 43 96 96s-43 96-96 96H240V384h16c8.8 0 16-7.2 16-16s-7.2-16-16-16H213l-3.1 99.5L208.5 495l0 1c-.3 8.9-7.6 16-16.5 16s-16.2-7.1-16.5-16l0-1-1-31H136c-22.1 0-40-17.9-40-40s17.9-40 40-40h36l-1-32H152c-53 0-96-43-96-96c0-47.6 34.6-87.1 80-94.7V256c0 8.8 7.2 16 16 16h16.5L164 128H136 122.6c-9 18.9-28.3 32-50.6 32H56c-30.9 0-56-25.1-56-56S25.1 48 56 48h8 8 89.5l-.1-4.8L161 32c0-.7 0-1.3 0-1.9c.5-16.6 14.1-30 31-30s30.5 13.4 31 30c0 .6 0 1.3 0 1.9l-.4 11.2zM64 112a16 16 0 1 0 0-32 16 16 0 1 0 0 32z"
    ]
};
var $d8206b3ab2e65c05$export$f2c3e92ee37a8d89 = $d8206b3ab2e65c05$export$76d998742bc186eb;
var $d8206b3ab2e65c05$export$5d61dcb598296af0 = $d8206b3ab2e65c05$export$76d998742bc186eb;
var $d8206b3ab2e65c05$export$97c8a2cdba3b7700 = $d8206b3ab2e65c05$export$76d998742bc186eb;
var $d8206b3ab2e65c05$export$b293ee8fb8e6b0c4 = {
    prefix: "fas",
    iconName: "head-side-cough-slash",
    icon: [
        640,
        512,
        [],
        "e062",
        "M448 325.8l44 34.5c8.1 1.4 14.8 6.8 18 14.1L552.9 408c10.6 .4 19.5 7.6 22.2 17.4l39.1 30.6c.6 0 1.2-.1 1.8-.1c11.1 0 20.4 7.5 23.2 17.8h-3.9c6.2 8.5 6.4 20.4-.4 29c-8.2 10.4-23.3 12.3-33.7 4.1L9.2 42.9C-1.2 34.7-3.1 19.6 5.1 9.2S28.4-3.1 38.8 5.1L89.6 44.9C127 16.7 173.5 0 224 0h24c95.2 0 181.2 69.3 197.3 160.2c2.3 13 6.8 25.7 15.1 36l42 52.6c6.2 7.8 9.6 17.4 9.6 27.4c0 24.2-19.6 43.8-43.8 43.8H448v0 5.8zM0 224.2c0-38.7 9.8-75.1 27.1-106.9L341.8 365.3l-2.5 .3c-11 1.4-19.2 10.7-19.2 21.8c0 11.6 9 21.2 20.6 21.9l62 3.9 43 33.9C439.3 466.2 421.2 480 400 480H320v8c0 13.3-10.7 24-24 24H256v0H96c-17.7 0-32-14.3-32-32V407.3c0-16.7-6.9-32.5-17.1-45.8C16.6 322.4 0 274.1 0 224.2zM616 360a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm-64-48a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm40-24a24 24 0 1 1 48 0 24 24 0 1 1 -48 0z"
    ]
};
var $d8206b3ab2e65c05$export$fb6bd43f079f72e2 = {
    prefix: "fas",
    iconName: "truck-medical",
    icon: [
        640,
        512,
        [
            128657,
            "ambulance"
        ],
        "f0f9",
        "M0 48C0 21.5 21.5 0 48 0H368c26.5 0 48 21.5 48 48V96h50.7c17 0 33.3 6.7 45.3 18.7L589.3 192c12 12 18.7 28.3 18.7 45.3V256v32 64c17.7 0 32 14.3 32 32s-14.3 32-32 32H576c0 53-43 96-96 96s-96-43-96-96H256c0 53-43 96-96 96s-96-43-96-96H48c-26.5 0-48-21.5-48-48V48zM416 256H544V237.3L466.7 160H416v96zM160 464a48 48 0 1 0 0-96 48 48 0 1 0 0 96zm368-48a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zM176 80v48l-48 0c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h48v48c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V192h48c8.8 0 16-7.2 16-16V144c0-8.8-7.2-16-16-16H240V80c0-8.8-7.2-16-16-16H192c-8.8 0-16 7.2-16 16z"
    ]
};
var $d8206b3ab2e65c05$export$f5c7042778b51765 = $d8206b3ab2e65c05$export$fb6bd43f079f72e2;
var $d8206b3ab2e65c05$export$e23367e54f665590 = {
    prefix: "fas",
    iconName: "wheat-awn-circle-exclamation",
    icon: [
        640,
        512,
        [],
        "e598",
        "M505 41c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0L383 95c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l88-88zM305.5 27.3c-6.2-6.2-16.4-6.2-22.6 0L271.5 38.6c-37.5 37.5-37.5 98.3 0 135.8l10.4 10.4-30.5 30.5c-3.4-27.3-15.5-53.8-36.5-74.8l-11.3-11.3c-6.2-6.2-16.4-6.2-22.6 0l-11.3 11.3c-37.5 37.5-37.5 98.3 0 135.8l10.4 10.4-30.5 30.5c-3.4-27.3-15.5-53.8-36.5-74.8L101.8 231c-6.2-6.2-16.4-6.2-22.6 0L67.9 242.3c-37.5 37.5-37.5 98.3 0 135.8l10.4 10.4L9.4 457.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0l68.9-68.9 12.2 12.2c37.5 37.5 98.3 37.5 135.8 0l11.3-11.3c6.2-6.2 6.2-16.4 0-22.6l-11.3-11.3c-21.8-21.8-49.6-34.1-78.1-36.9l31.9-31.9 12.2 12.2c22.5 22.5 53.3 31.5 82.4 27c0-1 0-2.1 0-3.1c0-33.1 9.1-64.1 25-90.6c-15.5-8.7-32.5-13.8-49.8-15.5l31.9-31.9 12.2 12.2c6 6 12.6 11.1 19.7 15.2c27.5-34 67.3-57.5 112.6-63.8c-4.1-3.8-8.4-7.3-12.9-10.5L505 137c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-59.4 59.4c-20.6-4.4-42-3.7-62.3 2.1c6.1-21.3 6.6-43.8 1.4-65.3L409 41c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0L329.1 52.9c-3.7-5-7.8-9.8-12.4-14.3L305.5 27.3zM496 512a144 144 0 1 0 0-288 144 144 0 1 0 0 288zm0-96a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm0-144c8.8 0 16 7.2 16 16v80c0 8.8-7.2 16-16 16s-16-7.2-16-16V288c0-8.8 7.2-16 16-16z"
    ]
};
var $d8206b3ab2e65c05$export$b23df6bafb174693 = {
    prefix: "fas",
    iconName: "snowman",
    icon: [
        512,
        512,
        [
            9731,
            9924
        ],
        "f7d0",
        "M341.1 140.6c-2 3.9-1.6 8.6 1.2 12c7 8.5 12.9 18.1 17.2 28.4L408 160.2V120c0-13.3 10.7-24 24-24s24 10.7 24 24v19.6l22.5-9.7c12.2-5.2 26.3 .4 31.5 12.6s-.4 26.3-12.6 31.5l-56 24-73.6 31.5c-.5 9.5-2.1 18.6-4.8 27.3c-1.2 3.8-.1 8 2.8 10.8C396.7 296.9 416 338.2 416 384c0 44.7-18.3 85-47.8 114.1c-9.9 9.7-23.7 13.9-37.5 13.9H181.3c-13.9 0-27.7-4.2-37.5-13.9C114.3 469 96 428.7 96 384c0-45.8 19.3-87.1 50.1-116.3c2.9-2.8 4-6.9 2.8-10.8c-2.7-8.7-4.3-17.9-4.8-27.3L70.5 198.1l-56-24C2.4 168.8-3.3 154.7 1.9 142.5s19.3-17.8 31.5-12.6L56 139.6V120c0-13.3 10.7-24 24-24s24 10.7 24 24v40.2L152.6 181c4.3-10.3 10.1-19.9 17.2-28.4c2.8-3.4 3.3-8.1 1.2-12C164 127.2 160 112.1 160 96c0-53 43-96 96-96s96 43 96 96c0 16.1-4 31.2-10.9 44.6zM224 96a16 16 0 1 0 0-32 16 16 0 1 0 0 32zm48 128a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zm-16 80a16 16 0 1 0 0-32 16 16 0 1 0 0 32zm16 48a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zM288 96a16 16 0 1 0 0-32 16 16 0 1 0 0 32zm-48 24v3.2c0 3.2 .8 6.3 2.3 9l9 16.9c.9 1.7 2.7 2.8 4.7 2.8s3.8-1.1 4.7-2.8l9-16.9c1.5-2.8 2.3-5.9 2.3-9V120c0-8.8-7.2-16-16-16s-16 7.2-16 16z"
    ]
};
var $d8206b3ab2e65c05$export$55ceb5d0c144580a = {
    prefix: "fas",
    iconName: "mortar-pestle",
    icon: [
        512,
        512,
        [],
        "f5a7",
        "M504.3 11.1C493.3-1.6 474.5-3.7 461 6.2L252.3 160H397.3L502.6 54.6c11.8-11.8 12.6-30.8 1.6-43.5zM32 192c-17.7 0-32 14.3-32 32s14.3 32 32 32c0 82.5 43.4 147.7 123.9 176.2c-11.1 13.9-19.4 30.3-23.9 48.1C127.6 497.4 142.3 512 160 512H352c17.7 0 32.4-14.6 28.1-31.7c-4.5-17.8-12.8-34.1-23.9-48.1C436.6 403.7 480 338.5 480 256c17.7 0 32-14.3 32-32s-14.3-32-32-32H32z"
    ]
};
var $d8206b3ab2e65c05$export$f3e925217e396f44 = {
    prefix: "fas",
    iconName: "road-barrier",
    icon: [
        640,
        512,
        [],
        "e562",
        "M32 32C14.3 32 0 46.3 0 64V448c0 17.7 14.3 32 32 32s32-14.3 32-32V266.3L149.2 96H64V64c0-17.7-14.3-32-32-32zM405.2 96H330.8l-5.4 10.7L234.8 288h74.3l5.4-10.7L405.2 96zM362.8 288h74.3l5.4-10.7L533.2 96H458.8l-5.4 10.7L362.8 288zM202.8 96l-5.4 10.7L106.8 288h74.3l5.4-10.7L277.2 96H202.8zm288 192H576V448c0 17.7 14.3 32 32 32s32-14.3 32-32V64c0-17.7-14.3-32-32-32s-32 14.3-32 32v53.7L490.8 288z"
    ]
};
var $d8206b3ab2e65c05$export$51e9b8434982947d = {
    prefix: "fas",
    iconName: "school",
    icon: [
        640,
        512,
        [
            127979
        ],
        "f549",
        "M337.8 5.4C327-1.8 313-1.8 302.2 5.4L166.3 96H48C21.5 96 0 117.5 0 144V464c0 26.5 21.5 48 48 48H592c26.5 0 48-21.5 48-48V144c0-26.5-21.5-48-48-48H473.7L337.8 5.4zM256 416c0-35.3 28.7-64 64-64s64 28.7 64 64v96H256V416zM96 192h32c8.8 0 16 7.2 16 16v64c0 8.8-7.2 16-16 16H96c-8.8 0-16-7.2-16-16V208c0-8.8 7.2-16 16-16zm400 16c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v64c0 8.8-7.2 16-16 16H512c-8.8 0-16-7.2-16-16V208zM96 320h32c8.8 0 16 7.2 16 16v64c0 8.8-7.2 16-16 16H96c-8.8 0-16-7.2-16-16V336c0-8.8 7.2-16 16-16zm400 16c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v64c0 8.8-7.2 16-16 16H512c-8.8 0-16-7.2-16-16V336zM232 176a88 88 0 1 1 176 0 88 88 0 1 1 -176 0zm88-48c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16s-7.2-16-16-16H336V144c0-8.8-7.2-16-16-16z"
    ]
};
var $d8206b3ab2e65c05$export$4a284575edd6f1af = {
    prefix: "fas",
    iconName: "igloo",
    icon: [
        576,
        512,
        [],
        "f7ae",
        "M320 33.8V160H48.5C100.2 82.8 188.1 32 288 32c10.8 0 21.5 .6 32 1.8zM352 160V39.1C424.9 55.7 487.2 99.8 527.5 160H352zM29.9 192H96V320H0c0-46 10.8-89.4 29.9-128zM192 320H128V192H448V320H384v32H576v80c0 26.5-21.5 48-48 48H352V352c0-35.3-28.7-64-64-64s-64 28.7-64 64V480H48c-26.5 0-48-21.5-48-48V352H192V320zm288 0V192h66.1c19.2 38.6 29.9 82 29.9 128H480z"
    ]
};
var $d8206b3ab2e65c05$export$e5a289fb22ffb8cb = {
    prefix: "fas",
    iconName: "joint",
    icon: [
        640,
        512,
        [],
        "f595",
        "M448 32c0-17.7-14.3-32-32-32s-32 14.3-32 32V43c0 55.2 21.9 108.1 60.9 147.1l21 21c9 9 14.1 21.2 14.1 33.9v11c0 17.7 14.3 32 32 32s32-14.3 32-32V245c0-29.7-11.8-58.2-32.8-79.2l-21-21C463.2 117.8 448 81.2 448 43V32zM576 256c0 17.7 14.3 32 32 32s32-14.3 32-32V245c0-55.2-21.9-108.1-60.9-147.1l-21-21c-9-9-14.1-21.2-14.1-33.9V32c0-17.7-14.3-32-32-32s-32 14.3-32 32V43c0 29.7 11.8 58.2 32.8 79.2l21 21c27 27 42.2 63.6 42.2 101.8v11zM229.8 360c-4.7-2.3-10-2.7-15.2-2c-37.8 5.6-75.2 14.3-106.9 22.8C81.3 388 58.3 395.1 42 400.4c-8.2 2.7-14.7 4.9-19.2 6.5c-2.3 .8-4 1.4-5.2 1.8l-1.3 .5C6.8 412.5 0 421.4 0 432s6.8 19.5 16.3 22.7l1.3 .5c1.2 .4 3 1.1 5.2 1.8c4.5 1.6 11 3.8 19.2 6.5c16.3 5.4 39.2 12.5 65.7 19.6C160.3 497.3 228.8 512 288 512h67.3c4.1 0 6.3-5.1 3.6-8.3L256.5 380.8c-7.4-8.9-16.5-15.9-26.7-20.8zM445 512h19 51.3c4.1 0 6.3-5.1 3.6-8.3L416.5 380.8C401.3 362.5 378.8 352 355 352H336 288c-1.1 0-2.3 0-3.4 0c-4.1 0-6.2 5.1-3.5 8.3L383.5 483.2C398.7 501.5 421.2 512 445 512zm-3.9-151.7L543.5 483.2c14.6 17.5 35.9 27.9 58.6 28.7c21.1-1.1 37.9-18.6 37.9-39.9V392c0-22.1-17.9-40-40-40H444.7c-4.1 0-6.3 5.1-3.6 8.3z"
    ]
};
var $d8206b3ab2e65c05$export$6bce1afb61f2eb66 = {
    prefix: "fas",
    iconName: "angle-right",
    icon: [
        320,
        512,
        [
            8250
        ],
        "f105",
        "M278.6 233.4c12.5 12.5 12.5 32.8 0 45.3l-160 160c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3L210.7 256 73.4 118.6c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0l160 160z"
    ]
};
var $d8206b3ab2e65c05$export$5b05f097fa38352a = {
    prefix: "fas",
    iconName: "horse",
    icon: [
        576,
        512,
        [
            128014
        ],
        "f6f0",
        "M448 238.1V160h16l9.8 19.6c12.5 25.1 42.2 36.4 68.3 26c20.5-8.2 33.9-28 33.9-50.1V80c0-19.1-8.4-36.3-21.7-48H560c8.8 0 16-7.2 16-16s-7.2-16-16-16H480 448C377.3 0 320 57.3 320 128H224 203.2 148.8c-30.7 0-57.6 16.3-72.5 40.8C33.2 174.5 0 211.4 0 256v56c0 13.3 10.7 24 24 24s24-10.7 24-24V256c0-13.4 6.6-25.2 16.7-32.5c1.6 13 6.3 25.4 13.6 36.4l28.2 42.4c8.3 12.4 6.4 28.7-1.2 41.6c-16.5 28-20.6 62.2-10 93.9l17.5 52.4c4.4 13.1 16.6 21.9 30.4 21.9h33.7c21.8 0 37.3-21.4 30.4-42.1l-20.8-62.5c-2.1-6.4-.5-13.4 4.3-18.2l12.7-12.7c13.2-13.2 20.6-31.1 20.6-49.7c0-2.3-.1-4.6-.3-6.9l84 24c4.1 1.2 8.2 2.1 12.3 2.8V480c0 17.7 14.3 32 32 32h32c17.7 0 32-14.3 32-32V315.7c19.2-19.2 31.5-45.7 32-75.7h0v-1.9zM496 64a16 16 0 1 1 0 32 16 16 0 1 1 0-32z"
    ]
};
var $d8206b3ab2e65c05$export$5a2b164552deda9f = {
    prefix: "fas",
    iconName: "q",
    icon: [
        448,
        512,
        [
            113
        ],
        "51",
        "M64 256c0 88.4 71.6 160 160 160c28.9 0 56-7.7 79.4-21.1l-72-86.4c-11.3-13.6-9.5-33.8 4.1-45.1s33.8-9.5 45.1 4.1l70.9 85.1C371.9 325.8 384 292.3 384 256c0-88.4-71.6-160-160-160S64 167.6 64 256zM344.9 444.6C310 467 268.5 480 224 480C100.3 480 0 379.7 0 256S100.3 32 224 32s224 100.3 224 224c0 56.1-20.6 107.4-54.7 146.7l47.3 56.8c11.3 13.6 9.5 33.8-4.1 45.1s-33.8 9.5-45.1-4.1l-46.6-55.9z"
    ]
};
var $d8206b3ab2e65c05$export$9f5c2b0db8eedeac = {
    prefix: "fas",
    iconName: "g",
    icon: [
        448,
        512,
        [
            103
        ],
        "47",
        "M224 96C135.6 96 64 167.6 64 256s71.6 160 160 160c77.4 0 142-55 156.8-128H256c-17.7 0-32-14.3-32-32s14.3-32 32-32H400c25.8 0 49.6 21.4 47.2 50.6C437.8 389.6 341.4 480 224 480C100.3 480 0 379.7 0 256S100.3 32 224 32c57.4 0 109.7 21.6 149.3 57c13.2 11.8 14.3 32 2.5 45.2s-32 14.3-45.2 2.5C302.3 111.4 265 96 224 96z"
    ]
};
var $d8206b3ab2e65c05$export$b2d79133c81d6697 = {
    prefix: "fas",
    iconName: "notes-medical",
    icon: [
        512,
        512,
        [],
        "f481",
        "M96 352V96c0-35.3 28.7-64 64-64H416c35.3 0 64 28.7 64 64V293.5c0 17-6.7 33.3-18.7 45.3l-58.5 58.5c-12 12-28.3 18.7-45.3 18.7H160c-35.3 0-64-28.7-64-64zM272 128c-8.8 0-16 7.2-16 16v48H208c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h48v48c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V256h48c8.8 0 16-7.2 16-16V208c0-8.8-7.2-16-16-16H320V144c0-8.8-7.2-16-16-16H272zm24 336c13.3 0 24 10.7 24 24s-10.7 24-24 24H136C60.9 512 0 451.1 0 376V152c0-13.3 10.7-24 24-24s24 10.7 24 24l0 224c0 48.6 39.4 88 88 88H296z"
    ]
};
var $d8206b3ab2e65c05$export$a3f1d7f13c202adc = {
    prefix: "fas",
    iconName: "temperature-half",
    icon: [
        320,
        512,
        [
            127777,
            "temperature-2",
            "thermometer-2",
            "thermometer-half"
        ],
        "f2c9",
        "M160 64c-26.5 0-48 21.5-48 48V276.5c0 17.3-7.1 31.9-15.3 42.5C86.2 332.6 80 349.5 80 368c0 44.2 35.8 80 80 80s80-35.8 80-80c0-18.5-6.2-35.4-16.7-48.9c-8.2-10.6-15.3-25.2-15.3-42.5V112c0-26.5-21.5-48-48-48zM48 112C48 50.2 98.1 0 160 0s112 50.1 112 112V276.5c0 .1 .1 .3 .2 .6c.2 .6 .8 1.6 1.7 2.8c18.9 24.4 30.1 55 30.1 88.1c0 79.5-64.5 144-144 144S16 447.5 16 368c0-33.2 11.2-63.8 30.1-88.1c.9-1.2 1.5-2.2 1.7-2.8c.1-.3 .2-.5 .2-.6V112zM208 368c0 26.5-21.5 48-48 48s-48-21.5-48-48c0-20.9 13.4-38.7 32-45.3V208c0-8.8 7.2-16 16-16s16 7.2 16 16V322.7c18.6 6.6 32 24.4 32 45.3z"
    ]
};
var $d8206b3ab2e65c05$export$8176e649df45b32c = $d8206b3ab2e65c05$export$a3f1d7f13c202adc;
var $d8206b3ab2e65c05$export$4dd764ac8d512682 = $d8206b3ab2e65c05$export$a3f1d7f13c202adc;
var $d8206b3ab2e65c05$export$2090f040324b4449 = $d8206b3ab2e65c05$export$a3f1d7f13c202adc;
var $d8206b3ab2e65c05$export$18659308f17918a5 = {
    prefix: "fas",
    iconName: "dong-sign",
    icon: [
        384,
        512,
        [],
        "e169",
        "M288 32c-17.7 0-32 14.3-32 32l-32 0c-17.7 0-32 14.3-32 32s14.3 32 32 32h32v49.1c-18.8-10.9-40.7-17.1-64-17.1c-70.7 0-128 57.3-128 128s57.3 128 128 128c24.5 0 47.4-6.9 66.8-18.8c5 11.1 16.2 18.8 29.2 18.8c17.7 0 32-14.3 32-32V288 128c17.7 0 32-14.3 32-32s-14.3-32-32-32c0-17.7-14.3-32-32-32zM128 288a64 64 0 1 1 128 0 64 64 0 1 1 -128 0zM32 448c-17.7 0-32 14.3-32 32s14.3 32 32 32H352c17.7 0 32-14.3 32-32s-14.3-32-32-32H32z"
    ]
};
var $d8206b3ab2e65c05$export$ba6fd4a436804a48 = {
    prefix: "fas",
    iconName: "capsules",
    icon: [
        576,
        512,
        [],
        "f46b",
        "M64 144c0-26.5 21.5-48 48-48s48 21.5 48 48V256H64V144zM0 144V368c0 61.9 50.1 112 112 112s112-50.1 112-112V189.6c1.8 19.1 8.2 38 19.8 54.8L372.3 431.7c35.5 51.7 105.3 64.3 156 28.1s63-107.5 27.5-159.2L427.3 113.3C391.8 61.5 321.9 49 271.3 85.2c-28 20-44.3 50.8-47.3 83V144c0-61.9-50.1-112-112-112S0 82.1 0 144zm296.6 64.2c-16-23.3-10-55.3 11.9-71c21.2-15.1 50.5-10.3 66 12.2l67 97.6L361.6 303l-65-94.8zM491 407.7c-.8 .6-1.6 1.1-2.4 1.6l4-2.8c-.5 .4-1 .8-1.6 1.2z"
    ]
};
var $d8206b3ab2e65c05$export$48a38da471b097a2 = {
    prefix: "fas",
    iconName: "poo-storm",
    icon: [
        448,
        512,
        [
            "poo-bolt"
        ],
        "f75a",
        "M236.9 .2c-5.5-.7-11 1.4-14.5 5.7s-4.6 10.1-2.8 15.3c2.8 8.2 4.3 16.9 4.3 26.1c0 21.7-8.5 37.2-21.9 47.6c-13.8 10.8-34 17-57.8 17H128c-35.3 0-64 28.7-64 64c0 12.2 3.4 23.5 9.3 33.2C31.7 216.2 0 252.4 0 296c0 41 28 75.4 65.8 85.2c-5.3-18.5 1-38.5 16.2-50.7l160-128c17.6-14.1 42.6-14 60.2 .2s22.8 38.6 12.8 58.8L285.7 320H304c20.4 0 38.5 12.9 45.3 32.1c3.7 10.6 3.5 21.8 0 31.9H360c48.6 0 88-39.4 88-88c0-43.6-31.7-79.8-73.3-86.8c5.9-9.7 9.3-21.1 9.3-33.2c0-35.3-28.7-64-64-64h-1.4c.9-5.4 1.4-10.9 1.4-16.6c0-48.7-36.1-88.9-83.1-95.2zm45.1 227.4c-5.8-4.7-14.2-4.7-20.1-.1l-160 128c-5.3 4.2-7.4 11.4-5.1 17.8s8.3 10.7 15.1 10.7h70.1L129.7 488.8c-3.4 6.7-1.6 14.9 4.3 19.6s14.2 4.7 20.1 .1l160-128c5.3-4.2 7.4-11.4 5.1-17.8s-8.3-10.7-15.1-10.7H233.9l52.4-104.8c3.4-6.7 1.6-14.9-4.3-19.6z"
    ]
};
var $d8206b3ab2e65c05$export$9a24e77f74d9cbd9 = $d8206b3ab2e65c05$export$48a38da471b097a2;
var $d8206b3ab2e65c05$export$c8a28356e07b9ccb = {
    prefix: "fas",
    iconName: "face-frown-open",
    icon: [
        512,
        512,
        [
            128550,
            "frown-open"
        ],
        "f57a",
        "M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM176.4 176a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm128 32a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm-122 174.5c-12.4 5.2-26.5-4.1-21.1-16.4c16-36.6 52.4-62.1 94.8-62.1s78.8 25.6 94.8 62.1c5.4 12.3-8.7 21.6-21.1 16.4c-22.4-9.5-47.4-14.8-73.7-14.8s-51.3 5.3-73.7 14.8z"
    ]
};
var $d8206b3ab2e65c05$export$c4775e66bed5d96 = $d8206b3ab2e65c05$export$c8a28356e07b9ccb;
var $d8206b3ab2e65c05$export$cdc9f5e7e94e76da = {
    prefix: "fas",
    iconName: "hand-point-up",
    icon: [
        384,
        512,
        [
            9757
        ],
        "f0a6",
        "M32 32C32 14.3 46.3 0 64 0S96 14.3 96 32V240H32V32zM224 192c0-17.7 14.3-32 32-32s32 14.3 32 32v64c0 17.7-14.3 32-32 32s-32-14.3-32-32V192zm-64-64c17.7 0 32 14.3 32 32v48c0 17.7-14.3 32-32 32s-32-14.3-32-32V160c0-17.7 14.3-32 32-32zm160 96c0-17.7 14.3-32 32-32s32 14.3 32 32v64c0 17.7-14.3 32-32 32s-32-14.3-32-32V224zm-96 88l0-.6c9.4 5.4 20.3 8.6 32 8.6c13.2 0 25.4-4 35.6-10.8c8.7 24.9 32.5 42.8 60.4 42.8c11.7 0 22.6-3.1 32-8.6V352c0 88.4-71.6 160-160 160H162.3c-42.4 0-83.1-16.9-113.1-46.9L37.5 453.5C13.5 429.5 0 396.9 0 363V336c0-35.3 28.7-64 64-64h88c22.1 0 40 17.9 40 40s-17.9 40-40 40H96c-8.8 0-16 7.2-16 16s7.2 16 16 16h56c39.8 0 72-32.2 72-72z"
    ]
};
var $d8206b3ab2e65c05$export$608138a7337b5d1a = {
    prefix: "fas",
    iconName: "money-bill",
    icon: [
        576,
        512,
        [],
        "f0d6",
        "M64 64C28.7 64 0 92.7 0 128V384c0 35.3 28.7 64 64 64H512c35.3 0 64-28.7 64-64V128c0-35.3-28.7-64-64-64H64zm64 320H64V320c35.3 0 64 28.7 64 64zM64 192V128h64c0 35.3-28.7 64-64 64zM448 384c0-35.3 28.7-64 64-64v64H448zm64-192c-35.3 0-64-28.7-64-64h64v64zM288 160a96 96 0 1 1 0 192 96 96 0 1 1 0-192z"
    ]
};
var $d8206b3ab2e65c05$export$4ed9da5c3cca0ef1 = {
    prefix: "fas",
    iconName: "bookmark",
    icon: [
        384,
        512,
        [
            128278,
            61591
        ],
        "f02e",
        "M0 48V487.7C0 501.1 10.9 512 24.3 512c5 0 9.9-1.5 14-4.4L192 400 345.7 507.6c4.1 2.9 9 4.4 14 4.4c13.4 0 24.3-10.9 24.3-24.3V48c0-26.5-21.5-48-48-48H48C21.5 0 0 21.5 0 48z"
    ]
};
var $d8206b3ab2e65c05$export$97c42b56d462df72 = {
    prefix: "fas",
    iconName: "align-justify",
    icon: [
        448,
        512,
        [],
        "f039",
        "M448 64c0-17.7-14.3-32-32-32H32C14.3 32 0 46.3 0 64S14.3 96 32 96H416c17.7 0 32-14.3 32-32zm0 256c0-17.7-14.3-32-32-32H32c-17.7 0-32 14.3-32 32s14.3 32 32 32H416c17.7 0 32-14.3 32-32zM0 192c0 17.7 14.3 32 32 32H416c17.7 0 32-14.3 32-32s-14.3-32-32-32H32c-17.7 0-32 14.3-32 32zM448 448c0-17.7-14.3-32-32-32H32c-17.7 0-32 14.3-32 32s14.3 32 32 32H416c17.7 0 32-14.3 32-32z"
    ]
};
var $d8206b3ab2e65c05$export$20932e4d438e4e4c = {
    prefix: "fas",
    iconName: "umbrella-beach",
    icon: [
        576,
        512,
        [
            127958
        ],
        "f5ca",
        "M346.3 271.8l-60.1-21.9L214 448H32c-17.7 0-32 14.3-32 32s14.3 32 32 32H544c17.7 0 32-14.3 32-32s-14.3-32-32-32H282.1l64.1-176.2zm121.1-.2l-3.3 9.1 67.7 24.6c18.1 6.6 38-4.2 39.6-23.4c6.5-78.5-23.9-155.5-80.8-208.5c2 8 3.2 16.3 3.4 24.8l.2 6c1.8 57-7.3 113.8-26.8 167.4zM462 99.1c-1.1-34.4-22.5-64.8-54.4-77.4c-.9-.4-1.9-.7-2.8-1.1c-33-11.7-69.8-2.4-93.1 23.8l-4 4.5C272.4 88.3 245 134.2 226.8 184l-3.3 9.1L434 269.7l3.3-9.1c18.1-49.8 26.6-102.5 24.9-155.5l-.2-6zM107.2 112.9c-11.1 15.7-2.8 36.8 15.3 43.4l71 25.8 3.3-9.1c19.5-53.6 49.1-103 87.1-145.5l4-4.5c6.2-6.9 13.1-13 20.5-18.2c-79.6 2.5-154.7 42.2-201.2 108z"
    ]
};
var $d8206b3ab2e65c05$export$5e975cb293c48461 = {
    prefix: "fas",
    iconName: "helmet-un",
    icon: [
        512,
        512,
        [],
        "e503",
        "M479.5 224C471.2 98.9 367.2 0 240 0C107.5 0 0 107.5 0 240v56.3C0 344.8 39.2 384 87.7 384H200h14.9L343.5 505.4c4.5 4.2 10.4 6.6 16.5 6.6h96c13.3 0 24-10.7 24-24s-10.7-24-24-24H369.5l-1.5-1.5V288h80 32c17.7 0 32-14.3 32-32s-14.3-32-32-32h-.5zM320 417.2l-78-73.7L274.4 288H320V417.2zM285.3 103.1l34.7 52V112c0-8.8 7.2-16 16-16s16 7.2 16 16v96c0 7.1-4.6 13.3-11.4 15.3s-14-.6-17.9-6.4l-34.7-52V208c0 8.8-7.2 16-16 16s-16-7.2-16-16V112c0-7.1 4.6-13.3 11.4-15.3s14 .6 17.9 6.4zM160 112v64c0 8.8 7.2 16 16 16s16-7.2 16-16V112c0-8.8 7.2-16 16-16s16 7.2 16 16v64c0 26.5-21.5 48-48 48s-48-21.5-48-48V112c0-8.8 7.2-16 16-16s16 7.2 16 16z"
    ]
};
var $d8206b3ab2e65c05$export$554720e3bf74fe90 = {
    prefix: "fas",
    iconName: "bullseye",
    icon: [
        512,
        512,
        [],
        "f140",
        "M448 256A192 192 0 1 0 64 256a192 192 0 1 0 384 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm256 80a80 80 0 1 0 0-160 80 80 0 1 0 0 160zm0-224a144 144 0 1 1 0 288 144 144 0 1 1 0-288zM224 256a32 32 0 1 1 64 0 32 32 0 1 1 -64 0z"
    ]
};
var $d8206b3ab2e65c05$export$ab07061fe21a3a8e = {
    prefix: "fas",
    iconName: "bacon",
    icon: [
        576,
        512,
        [
            129363
        ],
        "f7e5",
        "M439.2 1.2c11.2-3.2 23.2-.1 31.4 8.1L518 56.7l-26.5 7.9c-58 16.6-98.1 39.6-129.6 67.4c-31.2 27.5-53.2 59.1-75.1 90.9l-2.3 3.3C241.6 288.7 195 356.6 72.8 417.7L37.9 435.2 9.4 406.6c-7.3-7.3-10.6-17.6-9-27.8s8.1-18.9 17.3-23.5C136.1 296.2 180.9 231 223.3 169.3l2.3-3.4c21.8-31.8 44.9-64.9 77.7-93.9c33.4-29.5 75.8-53.6 135.9-70.8zM61.8 459l25.4-12.7c129.5-64.7 179.9-138.1 223.8-202l2.2-3.3c22.1-32.1 42.1-60.5 69.9-85.1c27.5-24.3 63.4-45.2 117.3-60.6l0 0 .2-.1 43.1-12.9 23 23c8 8 11.2 19.7 8.3 30.7s-11.3 19.6-22.2 22.7c-51.9 14.8-85.6 34.7-111.1 57.2c-26.1 23-45.1 49.9-67.3 82.1l-2.2 3.2C327.8 365.9 275.5 442 142.3 508.6c-12.3 6.2-27.2 3.7-36.9-6L61.8 459z"
    ]
};
var $d8206b3ab2e65c05$export$f6dcbf0a940428f4 = {
    prefix: "fas",
    iconName: "hand-point-down",
    icon: [
        384,
        512,
        [],
        "f0a7",
        "M32 480c0 17.7 14.3 32 32 32s32-14.3 32-32V272H32V480zM224 320c0 17.7 14.3 32 32 32s32-14.3 32-32V256c0-17.7-14.3-32-32-32s-32 14.3-32 32v64zm-64 64c17.7 0 32-14.3 32-32V304c0-17.7-14.3-32-32-32s-32 14.3-32 32v48c0 17.7 14.3 32 32 32zm160-96c0 17.7 14.3 32 32 32s32-14.3 32-32V224c0-17.7-14.3-32-32-32s-32 14.3-32 32v64zm-96-88l0 .6c9.4-5.4 20.3-8.6 32-8.6c13.2 0 25.4 4 35.6 10.8c8.7-24.9 32.5-42.8 60.4-42.8c11.7 0 22.6 3.1 32 8.6V160C384 71.6 312.4 0 224 0H162.3C119.8 0 79.1 16.9 49.1 46.9L37.5 58.5C13.5 82.5 0 115.1 0 149v27c0 35.3 28.7 64 64 64h88c22.1 0 40-17.9 40-40s-17.9-40-40-40H96c-8.8 0-16-7.2-16-16s7.2-16 16-16h56c39.8 0 72 32.2 72 72z"
    ]
};
var $d8206b3ab2e65c05$export$c2af1be14cd87640 = {
    prefix: "fas",
    iconName: "arrow-up-from-bracket",
    icon: [
        448,
        512,
        [],
        "e09a",
        "M246.6 9.4c-12.5-12.5-32.8-12.5-45.3 0l-128 128c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0L192 109.3V320c0 17.7 14.3 32 32 32s32-14.3 32-32V109.3l73.4 73.4c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3l-128-128zM64 352c0-17.7-14.3-32-32-32s-32 14.3-32 32v64c0 53 43 96 96 96H352c53 0 96-43 96-96V352c0-17.7-14.3-32-32-32s-32 14.3-32 32v64c0 17.7-14.3 32-32 32H96c-17.7 0-32-14.3-32-32V352z"
    ]
};
var $d8206b3ab2e65c05$export$72b780186370e953 = {
    prefix: "fas",
    iconName: "folder",
    icon: [
        512,
        512,
        [
            128193,
            128447,
            61716,
            "folder-blank"
        ],
        "f07b",
        "M64 480H448c35.3 0 64-28.7 64-64V160c0-35.3-28.7-64-64-64H288c-10.1 0-19.6-4.7-25.6-12.8L243.2 57.6C231.1 41.5 212.1 32 192 32H64C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64z"
    ]
};
var $d8206b3ab2e65c05$export$9ef114244d26da0 = $d8206b3ab2e65c05$export$72b780186370e953;
var $d8206b3ab2e65c05$export$5e0c19cf315ac1bf = {
    prefix: "fas",
    iconName: "file-waveform",
    icon: [
        448,
        512,
        [
            "file-medical-alt"
        ],
        "f478",
        "M96 0C60.7 0 32 28.7 32 64V288H144c6.1 0 11.6 3.4 14.3 8.8L176 332.2l49.7-99.4c2.7-5.4 8.3-8.8 14.3-8.8s11.6 3.4 14.3 8.8L281.9 288H352c8.8 0 16 7.2 16 16s-7.2 16-16 16H272c-6.1 0-11.6-3.4-14.3-8.8L240 275.8l-49.7 99.4c-2.7 5.4-8.3 8.8-14.3 8.8s-11.6-3.4-14.3-8.8L134.1 320H32V448c0 35.3 28.7 64 64 64H352c35.3 0 64-28.7 64-64V160H288c-17.7 0-32-14.3-32-32V0H96zM288 0V128H416L288 0z"
    ]
};
var $d8206b3ab2e65c05$export$ef02a0f5b39aa61f = $d8206b3ab2e65c05$export$5e0c19cf315ac1bf;
var $d8206b3ab2e65c05$export$4c4e509518093d6d = {
    prefix: "fas",
    iconName: "radiation",
    icon: [
        512,
        512,
        [],
        "f7b9",
        "M216 186.7c-23.9 13.8-40 39.7-40 69.3L32 256C14.3 256-.2 241.6 2 224.1C10.7 154 47.8 92.7 101.3 52c14.1-10.7 33.8-5.3 42.7 10l72 124.7zM256 336c14.6 0 28.2-3.9 40-10.7l72 124.8c8.8 15.3 3.7 35.1-12.6 41.9c-30.6 12.9-64.2 20-99.4 20s-68.9-7.1-99.4-20c-16.3-6.9-21.4-26.6-12.6-41.9l72-124.8c11.8 6.8 25.4 10.7 40 10.7zm224-80l-144 0c0-29.6-16.1-55.5-40-69.3L368 62c8.8-15.3 28.6-20.7 42.7-10c53.6 40.7 90.6 102 99.4 172.1c2.2 17.5-12.4 31.9-30 31.9zM256 208a48 48 0 1 1 0 96 48 48 0 1 1 0-96z"
    ]
};
var $d8206b3ab2e65c05$export$8760a1de19ea40b9 = {
    prefix: "fas",
    iconName: "chart-simple",
    icon: [
        448,
        512,
        [],
        "e473",
        "M160 80c0-26.5 21.5-48 48-48h32c26.5 0 48 21.5 48 48V432c0 26.5-21.5 48-48 48H208c-26.5 0-48-21.5-48-48V80zM0 272c0-26.5 21.5-48 48-48H80c26.5 0 48 21.5 48 48V432c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V272zM368 96h32c26.5 0 48 21.5 48 48V432c0 26.5-21.5 48-48 48H368c-26.5 0-48-21.5-48-48V144c0-26.5 21.5-48 48-48z"
    ]
};
var $d8206b3ab2e65c05$export$aa05fce255a5d269 = {
    prefix: "fas",
    iconName: "mars-stroke",
    icon: [
        512,
        512,
        [
            9894
        ],
        "f229",
        "M376 0c-9.7 0-18.5 5.8-22.2 14.8s-1.7 19.3 5.2 26.2l33.4 33.4L370.3 96.4 345 71c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9l25.4 25.4L307.8 159c-28.4-19.5-62.7-31-99.8-31c-97.2 0-176 78.8-176 176s78.8 176 176 176s176-78.8 176-176c0-37-11.4-71.4-31-99.8l28.6-28.6L407 201c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9l-25.4-25.4 22.1-22.1L471 153c6.9 6.9 17.2 8.9 26.2 5.2s14.8-12.5 14.8-22.2V24c0-13.3-10.7-24-24-24H376zm88 48h0v0l0 0zM96 304a112 112 0 1 1 224 0A112 112 0 1 1 96 304z"
    ]
};
var $d8206b3ab2e65c05$export$aa014b06d2d70598 = {
    prefix: "fas",
    iconName: "vial",
    icon: [
        512,
        512,
        [
            129514
        ],
        "f492",
        "M342.6 9.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3l9.4 9.4L28.1 342.6C10.1 360.6 0 385 0 410.5V416c0 53 43 96 96 96h5.5c25.5 0 49.9-10.1 67.9-28.1L448 205.3l9.4 9.4c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3l-32-32-96-96-32-32zM205.3 256L352 109.3 402.7 160l-96 96H205.3z"
    ]
};
var $d8206b3ab2e65c05$export$dbfb0a9f89ad94a4 = {
    prefix: "fas",
    iconName: "gauge",
    icon: [
        512,
        512,
        [
            "dashboard",
            "gauge-med",
            "tachometer-alt-average"
        ],
        "f624",
        "M0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm320 96c0-26.9-16.5-49.9-40-59.3V88c0-13.3-10.7-24-24-24s-24 10.7-24 24V292.7c-23.5 9.5-40 32.5-40 59.3c0 35.3 28.7 64 64 64s64-28.7 64-64zM144 176a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm-16 80a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zm288 32a32 32 0 1 0 0-64 32 32 0 1 0 0 64zM400 144a32 32 0 1 0 -64 0 32 32 0 1 0 64 0z"
    ]
};
var $d8206b3ab2e65c05$export$b7ce24136743d0f1 = $d8206b3ab2e65c05$export$dbfb0a9f89ad94a4;
var $d8206b3ab2e65c05$export$f948a9dd257979f3 = $d8206b3ab2e65c05$export$dbfb0a9f89ad94a4;
var $d8206b3ab2e65c05$export$6f22c345e5a92d1a = $d8206b3ab2e65c05$export$dbfb0a9f89ad94a4;
var $d8206b3ab2e65c05$export$5325fc72e75360b4 = {
    prefix: "fas",
    iconName: "wand-magic-sparkles",
    icon: [
        576,
        512,
        [
            "magic-wand-sparkles"
        ],
        "e2ca",
        "M234.7 42.7L197 56.8c-3 1.1-5 4-5 7.2s2 6.1 5 7.2l37.7 14.1L248.8 123c1.1 3 4 5 7.2 5s6.1-2 7.2-5l14.1-37.7L315 71.2c3-1.1 5-4 5-7.2s-2-6.1-5-7.2L277.3 42.7 263.2 5c-1.1-3-4-5-7.2-5s-6.1 2-7.2 5L234.7 42.7zM46.1 395.4c-18.7 18.7-18.7 49.1 0 67.9l34.6 34.6c18.7 18.7 49.1 18.7 67.9 0L529.9 116.5c18.7-18.7 18.7-49.1 0-67.9L495.3 14.1c-18.7-18.7-49.1-18.7-67.9 0L46.1 395.4zM484.6 82.6l-105 105-23.3-23.3 105-105 23.3 23.3zM7.5 117.2C3 118.9 0 123.2 0 128s3 9.1 7.5 10.8L64 160l21.2 56.5c1.7 4.5 6 7.5 10.8 7.5s9.1-3 10.8-7.5L128 160l56.5-21.2c4.5-1.7 7.5-6 7.5-10.8s-3-9.1-7.5-10.8L128 96 106.8 39.5C105.1 35 100.8 32 96 32s-9.1 3-10.8 7.5L64 96 7.5 117.2zm352 256c-4.5 1.7-7.5 6-7.5 10.8s3 9.1 7.5 10.8L416 416l21.2 56.5c1.7 4.5 6 7.5 10.8 7.5s9.1-3 10.8-7.5L480 416l56.5-21.2c4.5-1.7 7.5-6 7.5-10.8s-3-9.1-7.5-10.8L480 352l-21.2-56.5c-1.7-4.5-6-7.5-10.8-7.5s-9.1 3-10.8 7.5L416 352l-56.5 21.2z"
    ]
};
var $d8206b3ab2e65c05$export$c93286938249f0da = $d8206b3ab2e65c05$export$5325fc72e75360b4;
var $d8206b3ab2e65c05$export$86923e6fe1b42f5e = {
    prefix: "fas",
    iconName: "e",
    icon: [
        320,
        512,
        [
            101
        ],
        "45",
        "M64 32C28.7 32 0 60.7 0 96V256 416c0 35.3 28.7 64 64 64H288c17.7 0 32-14.3 32-32s-14.3-32-32-32H64V288H224c17.7 0 32-14.3 32-32s-14.3-32-32-32H64V96H288c17.7 0 32-14.3 32-32s-14.3-32-32-32H64z"
    ]
};
var $d8206b3ab2e65c05$export$eff4bdcafd3b8d1c = {
    prefix: "fas",
    iconName: "pen-clip",
    icon: [
        512,
        512,
        [
            "pen-alt"
        ],
        "f305",
        "M453.3 19.3l39.4 39.4c25 25 25 65.5 0 90.5l-52.1 52.1 0 0-1-1 0 0-16-16-96-96-17-17 52.1-52.1c25-25 65.5-25 90.5 0zM241 114.9c-9.4-9.4-24.6-9.4-33.9 0L105 217c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9L173.1 81c28.1-28.1 73.7-28.1 101.8 0L288 94.1l17 17 96 96 16 16 1 1-17 17L229.5 412.5c-48 48-109.2 80.8-175.8 94.1l-25 5c-7.9 1.6-16-.9-21.7-6.6s-8.1-13.8-6.6-21.7l5-25c13.3-66.6 46.1-127.8 94.1-175.8L254.1 128 241 114.9z"
    ]
};
var $d8206b3ab2e65c05$export$a3d3e92e430d3beb = $d8206b3ab2e65c05$export$eff4bdcafd3b8d1c;
var $d8206b3ab2e65c05$export$4f25939fdf728c27 = {
    prefix: "fas",
    iconName: "bridge-circle-exclamation",
    icon: [
        640,
        512,
        [],
        "e4ca",
        "M64 32C46.3 32 32 46.3 32 64s14.3 32 32 32h40v64H32V288c53 0 96 43 96 96v64c0 17.7 14.3 32 32 32h32c17.7 0 32-14.3 32-32V384c0-53 43-96 96-96c6.3 0 12.4 .6 18.3 1.7C367.1 231.8 426.9 192 496 192c42.5 0 81.6 15.1 112 40.2V160H536V96h40c17.7 0 32-14.3 32-32s-14.3-32-32-32H64zM488 96v64H408V96h80zM360 96v64H280V96h80zM232 96v64H152V96h80zM496 512a144 144 0 1 0 0-288 144 144 0 1 0 0 288zm0-96a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm0-144c8.8 0 16 7.2 16 16v80c0 8.8-7.2 16-16 16s-16-7.2-16-16V288c0-8.8 7.2-16 16-16z"
    ]
};
var $d8206b3ab2e65c05$export$f5699fa0844e0188 = {
    prefix: "fas",
    iconName: "user",
    icon: [
        448,
        512,
        [
            128100,
            62144
        ],
        "f007",
        "M224 256A128 128 0 1 0 224 0a128 128 0 1 0 0 256zm-45.7 48C79.8 304 0 383.8 0 482.3C0 498.7 13.3 512 29.7 512H418.3c16.4 0 29.7-13.3 29.7-29.7C448 383.8 368.2 304 269.7 304H178.3z"
    ]
};
var $d8206b3ab2e65c05$export$c8c95c2f9937bf6a = {
    prefix: "fas",
    iconName: "school-circle-check",
    icon: [
        640,
        512,
        [],
        "e56b",
        "M337.8 5.4C327-1.8 313-1.8 302.2 5.4L166.3 96H48C21.5 96 0 117.5 0 144V464c0 26.5 21.5 48 48 48H320v0H256V416c0-35.3 28.7-64 64-64l.3 0h.5c3.4-37.7 18.7-72.1 42.2-99.1C350.2 260 335.6 264 320 264c-48.6 0-88-39.4-88-88s39.4-88 88-88s88 39.4 88 88c0 18.3-5.6 35.3-15.1 49.4c29-21 64.6-33.4 103.1-33.4c59.5 0 112.1 29.6 144 74.8V144c0-26.5-21.5-48-48-48H473.7L337.8 5.4zM96 192h32c8.8 0 16 7.2 16 16v64c0 8.8-7.2 16-16 16H96c-8.8 0-16-7.2-16-16V208c0-8.8 7.2-16 16-16zm0 128h32c8.8 0 16 7.2 16 16v64c0 8.8-7.2 16-16 16H96c-8.8 0-16-7.2-16-16V336c0-8.8 7.2-16 16-16zM320 128c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16s-7.2-16-16-16H336V144c0-8.8-7.2-16-16-16zM640 368a144 144 0 1 0 -288 0 144 144 0 1 0 288 0zm-99.3-43.3c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6l-72 72c-6.2 6.2-16.4 6.2-22.6 0l-40-40c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0L480 385.4l60.7-60.7z"
    ]
};
var $d8206b3ab2e65c05$export$3b934e22d1851a3b = {
    prefix: "fas",
    iconName: "dumpster",
    icon: [
        576,
        512,
        [],
        "f793",
        "M49.7 32c-10.5 0-19.8 6.9-22.9 16.9L.9 133c-.6 2-.9 4.1-.9 6.1C0 150.7 9.3 160 20.9 160h94L140.5 32H49.7zM272 160V32H173.1L147.5 160H272zm32 0H428.5L402.9 32H304V160zm157.1 0h94c11.5 0 20.9-9.3 20.9-20.9c0-2.1-.3-4.1-.9-6.1L549.2 48.9C546.1 38.9 536.8 32 526.3 32H435.5l25.6 128zM32 192l4 32H32c-17.7 0-32 14.3-32 32s14.3 32 32 32H44L64 448c0 17.7 14.3 32 32 32s32-14.3 32-32H448c0 17.7 14.3 32 32 32s32-14.3 32-32l20-160h12c17.7 0 32-14.3 32-32s-14.3-32-32-32h-4l4-32H32z"
    ]
};
var $d8206b3ab2e65c05$export$ecbd233b96906ee1 = {
    prefix: "fas",
    iconName: "van-shuttle",
    icon: [
        640,
        512,
        [
            128656,
            "shuttle-van"
        ],
        "f5b6",
        "M64 104v88h96V96H72c-4.4 0-8 3.6-8 8zm482 88L465.1 96H384v96H546zm-226 0V96H224v96h96zM592 384H576c0 53-43 96-96 96s-96-43-96-96H256c0 53-43 96-96 96s-96-43-96-96H48c-26.5 0-48-21.5-48-48V104C0 64.2 32.2 32 72 32H192 352 465.1c18.9 0 36.8 8.3 49 22.8L625 186.5c9.7 11.5 15 26.1 15 41.2V336c0 26.5-21.5 48-48 48zm-64 0a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zM160 432a48 48 0 1 0 0-96 48 48 0 1 0 0 96z"
    ]
};
var $d8206b3ab2e65c05$export$9d63d851db698c09 = $d8206b3ab2e65c05$export$ecbd233b96906ee1;
var $d8206b3ab2e65c05$export$d65aef1ed7db1dae = {
    prefix: "fas",
    iconName: "building-user",
    icon: [
        640,
        512,
        [],
        "e4da",
        "M48 0C21.5 0 0 21.5 0 48V464c0 26.5 21.5 48 48 48h96V432c0-26.5 21.5-48 48-48s48 21.5 48 48v80h89.9c-6.3-10.2-9.9-22.2-9.9-35.1c0-46.9 25.8-87.8 64-109.2V271.8 48c0-26.5-21.5-48-48-48H48zM64 240c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H80c-8.8 0-16-7.2-16-16V240zm112-16h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H176c-8.8 0-16-7.2-16-16V240c0-8.8 7.2-16 16-16zm80 16c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H272c-8.8 0-16-7.2-16-16V240zM80 96h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H80c-8.8 0-16-7.2-16-16V112c0-8.8 7.2-16 16-16zm80 16c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H176c-8.8 0-16-7.2-16-16V112zM272 96h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H272c-8.8 0-16-7.2-16-16V112c0-8.8 7.2-16 16-16zM576 272a80 80 0 1 0 -160 0 80 80 0 1 0 160 0zM352 477.1c0 19.3 15.6 34.9 34.9 34.9H605.1c19.3 0 34.9-15.6 34.9-34.9c0-51.4-41.7-93.1-93.1-93.1H445.1c-51.4 0-93.1 41.7-93.1 93.1z"
    ]
};
var $d8206b3ab2e65c05$export$2c5163541229363 = {
    prefix: "fas",
    iconName: "square-caret-left",
    icon: [
        448,
        512,
        [
            "caret-square-left"
        ],
        "f191",
        "M0 416c0 35.3 28.7 64 64 64l320 0c35.3 0 64-28.7 64-64l0-320c0-35.3-28.7-64-64-64L64 32C28.7 32 0 60.7 0 96L0 416zM128 256c0-6.7 2.8-13 7.7-17.6l112-104c7-6.5 17.2-8.2 25.9-4.4s14.4 12.5 14.4 22l0 208c0 9.5-5.7 18.2-14.4 22s-18.9 2.1-25.9-4.4l-112-104c-4.9-4.5-7.7-10.9-7.7-17.6z"
    ]
};
var $d8206b3ab2e65c05$export$d0c8ba444f1f9581 = $d8206b3ab2e65c05$export$2c5163541229363;
var $d8206b3ab2e65c05$export$73801ed54b42fabe = {
    prefix: "fas",
    iconName: "highlighter",
    icon: [
        576,
        512,
        [],
        "f591",
        "M315 315l158.4-215L444.1 70.6 229 229 315 315zm-187 5l0 0V248.3c0-15.3 7.2-29.6 19.5-38.6L420.6 8.4C428 2.9 437 0 446.2 0c11.4 0 22.4 4.5 30.5 12.6l54.8 54.8c8.1 8.1 12.6 19 12.6 30.5c0 9.2-2.9 18.2-8.4 25.6L334.4 396.5c-9 12.3-23.4 19.5-38.6 19.5H224l-25.4 25.4c-12.5 12.5-32.8 12.5-45.3 0l-50.7-50.7c-12.5-12.5-12.5-32.8 0-45.3L128 320zM7 466.3l63-63 70.6 70.6-31 31c-4.5 4.5-10.6 7-17 7H24c-13.3 0-24-10.7-24-24v-4.7c0-6.4 2.5-12.5 7-17z"
    ]
};
var $d8206b3ab2e65c05$export$fa6ecc35e7315db = {
    prefix: "fas",
    iconName: "key",
    icon: [
        512,
        512,
        [
            128273
        ],
        "f084",
        "M336 352c97.2 0 176-78.8 176-176S433.2 0 336 0S160 78.8 160 176c0 18.7 2.9 36.8 8.3 53.7L7 391c-4.5 4.5-7 10.6-7 17v80c0 13.3 10.7 24 24 24h80c13.3 0 24-10.7 24-24V448h40c13.3 0 24-10.7 24-24V384h40c6.4 0 12.5-2.5 17-7l33.3-33.3c16.9 5.4 35 8.3 53.7 8.3zM376 96a40 40 0 1 1 0 80 40 40 0 1 1 0-80z"
    ]
};
var $d8206b3ab2e65c05$export$dacae2b4ec565333 = {
    prefix: "fas",
    iconName: "bullhorn",
    icon: [
        512,
        512,
        [
            128226,
            128363
        ],
        "f0a1",
        "M480 32c0-12.9-7.8-24.6-19.8-29.6s-25.7-2.2-34.9 6.9L381.7 53c-48 48-113.1 75-181 75H192 160 64c-35.3 0-64 28.7-64 64v96c0 35.3 28.7 64 64 64l0 128c0 17.7 14.3 32 32 32h64c17.7 0 32-14.3 32-32V352l8.7 0c67.9 0 133 27 181 75l43.6 43.6c9.2 9.2 22.9 11.9 34.9 6.9s19.8-16.6 19.8-29.6V300.4c18.6-8.8 32-32.5 32-60.4s-13.4-51.6-32-60.4V32zm-64 76.7V240 371.3C357.2 317.8 280.5 288 200.7 288H192V192h8.7c79.8 0 156.5-29.8 215.3-83.3z"
    ]
};
var $d8206b3ab2e65c05$export$b1b1cdce4a19c682 = {
    prefix: "fas",
    iconName: "globe",
    icon: [
        512,
        512,
        [
            127760
        ],
        "f0ac",
        "M352 256c0 22.2-1.2 43.6-3.3 64H163.3c-2.2-20.4-3.3-41.8-3.3-64s1.2-43.6 3.3-64H348.7c2.2 20.4 3.3 41.8 3.3 64zm28.8-64H503.9c5.3 20.5 8.1 41.9 8.1 64s-2.8 43.5-8.1 64H380.8c2.1-20.6 3.2-42 3.2-64s-1.1-43.4-3.2-64zm112.6-32H376.7c-10-63.9-29.8-117.4-55.3-151.6c78.3 20.7 142 77.5 171.9 151.6zm-149.1 0H167.7c6.1-36.4 15.5-68.6 27-94.7c10.5-23.6 22.2-40.7 33.5-51.5C239.4 3.2 248.7 0 256 0s16.6 3.2 27.8 13.8c11.3 10.8 23 27.9 33.5 51.5c11.6 26 20.9 58.2 27 94.7zm-209 0H18.6C48.6 85.9 112.2 29.1 190.6 8.4C165.1 42.6 145.3 96.1 135.3 160zM8.1 192H131.2c-2.1 20.6-3.2 42-3.2 64s1.1 43.4 3.2 64H8.1C2.8 299.5 0 278.1 0 256s2.8-43.5 8.1-64zM194.7 446.6c-11.6-26-20.9-58.2-27-94.6H344.3c-6.1 36.4-15.5 68.6-27 94.6c-10.5 23.6-22.2 40.7-33.5 51.5C272.6 508.8 263.3 512 256 512s-16.6-3.2-27.8-13.8c-11.3-10.8-23-27.9-33.5-51.5zM135.3 352c10 63.9 29.8 117.4 55.3 151.6C112.2 482.9 48.6 426.1 18.6 352H135.3zm358.1 0c-30 74.1-93.6 130.9-171.9 151.6c25.5-34.2 45.2-87.7 55.3-151.6H493.4z"
    ]
};
var $d8206b3ab2e65c05$export$20d991385719b5b4 = {
    prefix: "fas",
    iconName: "synagogue",
    icon: [
        640,
        512,
        [
            128333
        ],
        "f69b",
        "M309.8 3.7c5.9-4.9 14.6-4.9 20.5 0l121 100.8C469.5 119.7 480 142.2 480 166V280.1 512H464 352V416c0-17.7-14.3-32-32-32s-32 14.3-32 32v96H176 160V280.1 166c0-23.7 10.5-46.3 28.8-61.5L309.8 3.7zM512 512V244.5l28.1-31.2c3-3.4 7.4-5.3 11.9-5.3s8.9 1.9 11.9 5.3l63.8 70.9c7.9 8.8 12.3 20.3 12.3 32.1V448c0 35.3-28.7 64-64 64H512zM128 244.5V512H64c-35.3 0-64-28.7-64-64V316.3c0-11.9 4.4-23.3 12.3-32.1l63.8-70.9c3-3.4 7.4-5.3 11.9-5.3s8.9 1.9 11.9 5.3L128 244.5zM327 124.3c-3.1-5.4-10.9-5.4-13.9 0l-15.9 28.1-32.3-.3c-6.2-.1-10.1 6.7-7 12.1L274.3 192l-16.4 27.8c-3.2 5.4 .7 12.1 7 12.1l32.3-.3L313 259.7c3.1 5.4 10.9 5.4 13.9 0l15.9-28.1 32.3 .3c6.2 .1 10.1-6.7 7-12.1L365.7 192l16.4-27.8c3.2-5.4-.7-12.1-7-12.1l-32.3 .3L327 124.3z"
    ]
};
var $d8206b3ab2e65c05$export$f3d75c19191f1688 = {
    prefix: "fas",
    iconName: "person-half-dress",
    icon: [
        320,
        512,
        [],
        "e548",
        "M160 0a48 48 0 1 1 0 96 48 48 0 1 1 0-96zm8 352V128h6.9c33.7 0 64.9 17.7 82.3 46.6l58.3 97c9.1 15.1 4.2 34.8-10.9 43.9s-34.8 4.2-43.9-10.9L232 256.9V480c0 17.7-14.3 32-32 32s-32-14.3-32-32V352h0zM58.2 182.3c19.9-33.1 55.3-53.5 93.8-54.3V384h0v96c0 17.7-14.3 32-32 32s-32-14.3-32-32V384H70.2c-10.9 0-18.6-10.7-15.2-21.1L93.3 248.1 59.4 304.5c-9.1 15.1-28.8 20-43.9 10.9s-20-28.8-10.9-43.9l53.6-89.2z"
    ]
};
var $d8206b3ab2e65c05$export$4d6835e7175dec24 = {
    prefix: "fas",
    iconName: "road-bridge",
    icon: [
        640,
        512,
        [],
        "e563",
        "M352 0H608c17.7 0 32 14.3 32 32V480c0 17.7-14.3 32-32 32H352c-17.7 0-32-14.3-32-32V32c0-17.7 14.3-32 32-32zM480 200c-13.3 0-24 10.7-24 24v64c0 13.3 10.7 24 24 24s24-10.7 24-24V224c0-13.3-10.7-24-24-24zm24 184c0-13.3-10.7-24-24-24s-24 10.7-24 24v64c0 13.3 10.7 24 24 24s24-10.7 24-24V384zM480 40c-13.3 0-24 10.7-24 24v64c0 13.3 10.7 24 24 24s24-10.7 24-24V64c0-13.3-10.7-24-24-24zM32 96H288v64H248v64h40v96c-53 0-96 43-96 96v64c0 17.7-14.3 32-32 32H128c-17.7 0-32-14.3-32-32V416c0-53-43-96-96-96V224H72V160H32c-17.7 0-32-14.3-32-32s14.3-32 32-32zm168 64H120v64h80V160z"
    ]
};
var $d8206b3ab2e65c05$export$4ac9c4c370f7b157 = {
    prefix: "fas",
    iconName: "location-arrow",
    icon: [
        448,
        512,
        [],
        "f124",
        "M429.6 92.1c4.9-11.9 2.1-25.6-7-34.7s-22.8-11.9-34.7-7l-352 144c-14.2 5.8-22.2 20.8-19.3 35.8s16.1 25.8 31.4 25.8H224V432c0 15.3 10.8 28.4 25.8 31.4s30-5.1 35.8-19.3l144-352z"
    ]
};
var $d8206b3ab2e65c05$export$a2c1c457834fc6d8 = {
    prefix: "fas",
    iconName: "c",
    icon: [
        384,
        512,
        [
            99
        ],
        "43",
        "M329.1 142.9c-62.5-62.5-155.8-62.5-218.3 0s-62.5 163.8 0 226.3s155.8 62.5 218.3 0c12.5-12.5 32.8-12.5 45.3 0s12.5 32.8 0 45.3c-87.5 87.5-221.3 87.5-308.8 0s-87.5-229.3 0-316.8s221.3-87.5 308.8 0c12.5 12.5 12.5 32.8 0 45.3s-32.8 12.5-45.3 0z"
    ]
};
var $d8206b3ab2e65c05$export$2d33c367b2b091ac = {
    prefix: "fas",
    iconName: "tablet-button",
    icon: [
        448,
        512,
        [],
        "f10a",
        "M64 0C28.7 0 0 28.7 0 64V448c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V64c0-35.3-28.7-64-64-64H64zM224 400a32 32 0 1 1 0 64 32 32 0 1 1 0-64z"
    ]
};
var $d8206b3ab2e65c05$export$6f08294ba8a2459c = {
    prefix: "fas",
    iconName: "building-lock",
    icon: [
        576,
        512,
        [],
        "e4d6",
        "M48 0C21.5 0 0 21.5 0 48V464c0 26.5 21.5 48 48 48h96V432c0-26.5 21.5-48 48-48s48 21.5 48 48v80h88.6c-5.4-9.4-8.6-20.3-8.6-32V352c0-23.7 12.9-44.4 32-55.4V272c0-30.5 12.2-58.2 32-78.4V48c0-26.5-21.5-48-48-48H48zM64 240c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H80c-8.8 0-16-7.2-16-16V240zm112-16h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H176c-8.8 0-16-7.2-16-16V240c0-8.8 7.2-16 16-16zm80 16c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H272c-8.8 0-16-7.2-16-16V240zM80 96h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H80c-8.8 0-16-7.2-16-16V112c0-8.8 7.2-16 16-16zm80 16c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H176c-8.8 0-16-7.2-16-16V112zM272 96h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H272c-8.8 0-16-7.2-16-16V112c0-8.8 7.2-16 16-16zM464 240c17.7 0 32 14.3 32 32v48H432V272c0-17.7 14.3-32 32-32zm-80 32v48c-17.7 0-32 14.3-32 32V480c0 17.7 14.3 32 32 32H544c17.7 0 32-14.3 32-32V352c0-17.7-14.3-32-32-32V272c0-44.2-35.8-80-80-80s-80 35.8-80 80z"
    ]
};
var $d8206b3ab2e65c05$export$c9f93c4667edc585 = {
    prefix: "fas",
    iconName: "pizza-slice",
    icon: [
        512,
        512,
        [],
        "f818",
        "M169.7 .9c-22.8-1.6-41.9 14-47.5 34.7L110.4 80c.5 0 1.1 0 1.6 0c176.7 0 320 143.3 320 320c0 .5 0 1.1 0 1.6l44.4-11.8c20.8-5.5 36.3-24.7 34.7-47.5C498.5 159.5 352.5 13.5 169.7 .9zM399.8 410.2c.1-3.4 .2-6.8 .2-10.2c0-159.1-128.9-288-288-288c-3.4 0-6.8 .1-10.2 .2L.5 491.9c-1.5 5.5 .1 11.4 4.1 15.4s9.9 5.6 15.4 4.1L399.8 410.2zM176 208a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm64 128a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zM96 384a32 32 0 1 1 64 0 32 32 0 1 1 -64 0z"
    ]
};
var $d8206b3ab2e65c05$export$53e23123cc9a6796 = {
    prefix: "fas",
    iconName: "money-bill-wave",
    icon: [
        576,
        512,
        [],
        "f53a",
        "M0 112.5V422.3c0 18 10.1 35 27 41.3c87 32.5 174 10.3 261-11.9c79.8-20.3 159.6-40.7 239.3-18.9c23 6.3 48.7-9.5 48.7-33.4V89.7c0-18-10.1-35-27-41.3C462 15.9 375 38.1 288 60.3C208.2 80.6 128.4 100.9 48.7 79.1C25.6 72.8 0 88.6 0 112.5zM288 352c-44.2 0-80-43-80-96s35.8-96 80-96s80 43 80 96s-35.8 96-80 96zM64 352c35.3 0 64 28.7 64 64H64V352zm64-208c0 35.3-28.7 64-64 64V144h64zM512 304v64H448c0-35.3 28.7-64 64-64zM448 96h64v64c-35.3 0-64-28.7-64-64z"
    ]
};
var $d8206b3ab2e65c05$export$2acab8312b7a999b = {
    prefix: "fas",
    iconName: "chart-area",
    icon: [
        512,
        512,
        [
            "area-chart"
        ],
        "f1fe",
        "M64 64c0-17.7-14.3-32-32-32S0 46.3 0 64V400c0 44.2 35.8 80 80 80H480c17.7 0 32-14.3 32-32s-14.3-32-32-32H80c-8.8 0-16-7.2-16-16V64zm96 288H448c17.7 0 32-14.3 32-32V251.8c0-7.6-2.7-15-7.7-20.8l-65.8-76.8c-12.1-14.2-33.7-15-46.9-1.8l-21 21c-10 10-26.4 9.2-35.4-1.6l-39.2-47c-12.6-15.1-35.7-15.4-48.7-.6L135.9 215c-5.1 5.8-7.9 13.3-7.9 21.1v84c0 17.7 14.3 32 32 32z"
    ]
};
var $d8206b3ab2e65c05$export$fc2e595f0e0612cb = $d8206b3ab2e65c05$export$2acab8312b7a999b;
var $d8206b3ab2e65c05$export$9a3d31c75a465b9a = {
    prefix: "fas",
    iconName: "house-flag",
    icon: [
        640,
        512,
        [],
        "e50d",
        "M480 0c-17.7 0-32 14.3-32 32V192 512h64V192H624c8.8 0 16-7.2 16-16V48c0-8.8-7.2-16-16-16H512c0-17.7-14.3-32-32-32zM416 159L276.8 39.7c-12-10.3-29.7-10.3-41.7 0l-224 192C1 240.4-2.7 254.5 2 267.1S18.6 288 32 288H64V480c0 17.7 14.3 32 32 32h64c17.7 0 32-14.3 32-32V384c0-17.7 14.3-32 32-32h64c17.7 0 32 14.3 32 32v96c0 17.7 14.3 32 32 32h64.7l.2 0h-1V159z"
    ]
};
var $d8206b3ab2e65c05$export$d7ccc6651f90f7cc = {
    prefix: "fas",
    iconName: "person-circle-minus",
    icon: [
        576,
        512,
        [],
        "e540",
        "M112 48a48 48 0 1 1 96 0 48 48 0 1 1 -96 0zm40 304V480c0 17.7-14.3 32-32 32s-32-14.3-32-32V256.9L59.4 304.5c-9.1 15.1-28.8 20-43.9 10.9s-20-28.8-10.9-43.9l58.3-97c17.4-28.9 48.6-46.6 82.3-46.6h29.7c33.7 0 64.9 17.7 82.3 46.6l44.9 74.7c-16.1 17.6-28.6 38.5-36.6 61.5c-1.9-1.8-3.5-3.9-4.9-6.3L232 256.9V480c0 17.7-14.3 32-32 32s-32-14.3-32-32V352H152zm136 16a144 144 0 1 1 288 0 144 144 0 1 1 -288 0zm224 0c0-8.8-7.2-16-16-16H368c-8.8 0-16 7.2-16 16s7.2 16 16 16H496c8.8 0 16-7.2 16-16z"
    ]
};
var $d8206b3ab2e65c05$export$76f704d256def3c7 = {
    prefix: "fas",
    iconName: "ban",
    icon: [
        512,
        512,
        [
            128683,
            "cancel"
        ],
        "f05e",
        "M367.2 412.5L99.5 144.8C77.1 176.1 64 214.5 64 256c0 106 86 192 192 192c41.5 0 79.9-13.1 111.2-35.5zm45.3-45.3C434.9 335.9 448 297.5 448 256c0-106-86-192-192-192c-41.5 0-79.9 13.1-111.2 35.5L412.5 367.2zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256z"
    ]
};
var $d8206b3ab2e65c05$export$6d25ef56192f6d69 = $d8206b3ab2e65c05$export$76f704d256def3c7;
var $d8206b3ab2e65c05$export$e0ce7d1aba7105e7 = {
    prefix: "fas",
    iconName: "camera-rotate",
    icon: [
        640,
        512,
        [],
        "e0d8",
        "M213.1 64.8L202.7 96H128c-35.3 0-64 28.7-64 64V416c0 35.3 28.7 64 64 64H512c35.3 0 64-28.7 64-64V160c0-35.3-28.7-64-64-64H437.3L426.9 64.8C420.4 45.2 402.1 32 381.4 32H258.6c-20.7 0-39 13.2-45.5 32.8zM448 256c0 8.8-7.2 16-16 16H355.3c-6.2 0-11.3-5.1-11.3-11.3c0-3 1.2-5.9 3.3-8L371 229c-13.6-13.4-31.9-21-51-21c-19.2 0-37.7 7.6-51.3 21.3L249 249c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l19.7-19.7C257.4 172.7 288 160 320 160c31.8 0 62.4 12.6 85 35l23.7-23.7c2.1-2.1 5-3.3 8-3.3c6.2 0 11.3 5.1 11.3 11.3V256zM192 320c0-8.8 7.2-16 16-16h76.7c6.2 0 11.3 5.1 11.3 11.3c0 3-1.2 5.9-3.3 8L269 347c13.6 13.4 31.9 21 51 21c19.2 0 37.7-7.6 51.3-21.3L391 327c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9l-19.7 19.7C382.6 403.3 352 416 320 416c-31.8 0-62.4-12.6-85-35l-23.7 23.7c-2.1 2.1-5 3.3-8 3.3c-6.2 0-11.3-5.1-11.3-11.3V320z"
    ]
};
var $d8206b3ab2e65c05$export$43832c90c10a7a31 = {
    prefix: "fas",
    iconName: "spray-can-sparkles",
    icon: [
        512,
        512,
        [
            "air-freshener"
        ],
        "f5d0",
        "M96 32v96H224V32c0-17.7-14.3-32-32-32H128C110.3 0 96 14.3 96 32zm0 128c-53 0-96 43-96 96V464c0 26.5 21.5 48 48 48H272c26.5 0 48-21.5 48-48V256c0-53-43-96-96-96H96zm64 96a80 80 0 1 1 0 160 80 80 0 1 1 0-160zM384 48c0-1.4-1-3-2.2-3.6L352 32 339.6 2.2C339 1 337.4 0 336 0s-3 1-3.6 2.2L320 32 290.2 44.4C289 45 288 46.6 288 48c0 1.4 1 3 2.2 3.6L320 64l12.4 29.8C333 95 334.6 96 336 96s3-1 3.6-2.2L352 64l29.8-12.4C383 51 384 49.4 384 48zm76.4 45.8C461 95 462.6 96 464 96s3-1 3.6-2.2L480 64l29.8-12.4C511 51 512 49.4 512 48c0-1.4-1-3-2.2-3.6L480 32 467.6 2.2C467 1 465.4 0 464 0s-3 1-3.6 2.2L448 32 418.2 44.4C417 45 416 46.6 416 48c0 1.4 1 3 2.2 3.6L448 64l12.4 29.8zm7.2 100.4c-.6-1.2-2.2-2.2-3.6-2.2s-3 1-3.6 2.2L448 224l-29.8 12.4c-1.2 .6-2.2 2.2-2.2 3.6c0 1.4 1 3 2.2 3.6L448 256l12.4 29.8c.6 1.2 2.2 2.2 3.6 2.2s3-1 3.6-2.2L480 256l29.8-12.4c1.2-.6 2.2-2.2 2.2-3.6c0-1.4-1-3-2.2-3.6L480 224l-12.4-29.8zM448 144c0-1.4-1-3-2.2-3.6L416 128 403.6 98.2C403 97 401.4 96 400 96s-3 1-3.6 2.2L384 128l-29.8 12.4c-1.2 .6-2.2 2.2-2.2 3.6c0 1.4 1 3 2.2 3.6L384 160l12.4 29.8c.6 1.2 2.2 2.2 3.6 2.2s3-1 3.6-2.2L416 160l29.8-12.4c1.2-.6 2.2-2.2 2.2-3.6z"
    ]
};
var $d8206b3ab2e65c05$export$a5e63e89b5ccee83 = $d8206b3ab2e65c05$export$43832c90c10a7a31;
var $d8206b3ab2e65c05$export$a3b0eb2cd7942125 = {
    prefix: "fas",
    iconName: "star",
    icon: [
        576,
        512,
        [
            11088,
            61446
        ],
        "f005",
        "M316.9 18C311.6 7 300.4 0 288.1 0s-23.4 7-28.8 18L195 150.3 51.4 171.5c-12 1.8-22 10.2-25.7 21.7s-.7 24.2 7.9 32.7L137.8 329 113.2 474.7c-2 12 3 24.2 12.9 31.3s23 8 33.8 2.3l128.3-68.5 128.3 68.5c10.8 5.7 23.9 4.9 33.8-2.3s14.9-19.3 12.9-31.3L438.5 329 542.7 225.9c8.6-8.5 11.7-21.2 7.9-32.7s-13.7-19.9-25.7-21.7L381.2 150.3 316.9 18z"
    ]
};
var $d8206b3ab2e65c05$export$cb8434288c91ae83 = {
    prefix: "fas",
    iconName: "repeat",
    icon: [
        512,
        512,
        [
            128257
        ],
        "f363",
        "M0 224c0 17.7 14.3 32 32 32s32-14.3 32-32c0-53 43-96 96-96H320v32c0 12.9 7.8 24.6 19.8 29.6s25.7 2.2 34.9-6.9l64-64c12.5-12.5 12.5-32.8 0-45.3l-64-64c-9.2-9.2-22.9-11.9-34.9-6.9S320 19.1 320 32V64H160C71.6 64 0 135.6 0 224zm512 64c0-17.7-14.3-32-32-32s-32 14.3-32 32c0 53-43 96-96 96H192V352c0-12.9-7.8-24.6-19.8-29.6s-25.7-2.2-34.9 6.9l-64 64c-12.5 12.5-12.5 32.8 0 45.3l64 64c9.2 9.2 22.9 11.9 34.9 6.9s19.8-16.6 19.8-29.6V448H352c88.4 0 160-71.6 160-160z"
    ]
};
var $d8206b3ab2e65c05$export$9d0a89fcd084abb = {
    prefix: "fas",
    iconName: "cross",
    icon: [
        384,
        512,
        [
            128327,
            10013
        ],
        "f654",
        "M176 0c-26.5 0-48 21.5-48 48v80H48c-26.5 0-48 21.5-48 48v32c0 26.5 21.5 48 48 48h80V464c0 26.5 21.5 48 48 48h32c26.5 0 48-21.5 48-48V256h80c26.5 0 48-21.5 48-48V176c0-26.5-21.5-48-48-48H256V48c0-26.5-21.5-48-48-48H176z"
    ]
};
var $d8206b3ab2e65c05$export$6e7cf270cda52323 = {
    prefix: "fas",
    iconName: "box",
    icon: [
        448,
        512,
        [
            128230
        ],
        "f466",
        "M50.7 58.5L0 160H208V32H93.7C75.5 32 58.9 42.3 50.7 58.5zM240 160H448L397.3 58.5C389.1 42.3 372.5 32 354.3 32H240V160zm208 32H0V416c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V192z"
    ]
};
var $d8206b3ab2e65c05$export$63f2d9e5f4689aa8 = {
    prefix: "fas",
    iconName: "venus-mars",
    icon: [
        640,
        512,
        [
            9892
        ],
        "f228",
        "M176 288a112 112 0 1 0 0-224 112 112 0 1 0 0 224zM352 176c0 86.3-62.1 158.1-144 173.1V384h32c17.7 0 32 14.3 32 32s-14.3 32-32 32H208v32c0 17.7-14.3 32-32 32s-32-14.3-32-32V448H112c-17.7 0-32-14.3-32-32s14.3-32 32-32h32V349.1C62.1 334.1 0 262.3 0 176C0 78.8 78.8 0 176 0s176 78.8 176 176zM271.9 360.6c19.3-10.1 36.9-23.1 52.1-38.4c20 18.5 46.7 29.8 76.1 29.8c61.9 0 112-50.1 112-112s-50.1-112-112-112c-7.2 0-14.3 .7-21.1 2c-4.9-21.5-13-41.7-24-60.2C369.3 66 384.4 64 400 64c37 0 71.4 11.4 99.8 31l20.6-20.6L487 41c-6.9-6.9-8.9-17.2-5.2-26.2S494.3 0 504 0H616c13.3 0 24 10.7 24 24V136c0 9.7-5.8 18.5-14.8 22.2s-19.3 1.7-26.2-5.2l-33.4-33.4L545 140.2c19.5 28.4 31 62.7 31 99.8c0 97.2-78.8 176-176 176c-50.5 0-96-21.3-128.1-55.4z"
    ]
};
var $d8206b3ab2e65c05$export$e4f903bc63db445 = {
    prefix: "fas",
    iconName: "arrow-pointer",
    icon: [
        320,
        512,
        [
            "mouse-pointer"
        ],
        "f245",
        "M0 55.2V426c0 12.2 9.9 22 22 22c6.3 0 12.4-2.7 16.6-7.5L121.2 346l58.1 116.3c7.9 15.8 27.1 22.2 42.9 14.3s22.2-27.1 14.3-42.9L179.8 320H297.9c12.2 0 22.1-9.9 22.1-22.1c0-6.3-2.7-12.3-7.4-16.5L38.6 37.9C34.3 34.1 28.9 32 23.2 32C10.4 32 0 42.4 0 55.2z"
    ]
};
var $d8206b3ab2e65c05$export$2e19a69cc26b147 = $d8206b3ab2e65c05$export$e4f903bc63db445;
var $d8206b3ab2e65c05$export$8d2b1b230601e804 = {
    prefix: "fas",
    iconName: "maximize",
    icon: [
        512,
        512,
        [
            "expand-arrows-alt"
        ],
        "f31e",
        "M200 32H56C42.7 32 32 42.7 32 56V200c0 9.7 5.8 18.5 14.8 22.2s19.3 1.7 26.2-5.2l40-40 79 79-79 79L73 295c-6.9-6.9-17.2-8.9-26.2-5.2S32 302.3 32 312V456c0 13.3 10.7 24 24 24H200c9.7 0 18.5-5.8 22.2-14.8s1.7-19.3-5.2-26.2l-40-40 79-79 79 79-40 40c-6.9 6.9-8.9 17.2-5.2 26.2s12.5 14.8 22.2 14.8H456c13.3 0 24-10.7 24-24V312c0-9.7-5.8-18.5-14.8-22.2s-19.3-1.7-26.2 5.2l-40 40-79-79 79-79 40 40c6.9 6.9 17.2 8.9 26.2 5.2s14.8-12.5 14.8-22.2V56c0-13.3-10.7-24-24-24H312c-9.7 0-18.5 5.8-22.2 14.8s-1.7 19.3 5.2 26.2l40 40-79 79-79-79 40-40c6.9-6.9 8.9-17.2 5.2-26.2S209.7 32 200 32z"
    ]
};
var $d8206b3ab2e65c05$export$6219dcd88b5fa6c2 = $d8206b3ab2e65c05$export$8d2b1b230601e804;
var $d8206b3ab2e65c05$export$bab2cd86f8c65657 = {
    prefix: "fas",
    iconName: "charging-station",
    icon: [
        576,
        512,
        [],
        "f5e7",
        "M96 0C60.7 0 32 28.7 32 64V448c-17.7 0-32 14.3-32 32s14.3 32 32 32H320c17.7 0 32-14.3 32-32s-14.3-32-32-32V304h16c22.1 0 40 17.9 40 40v32c0 39.8 32.2 72 72 72s72-32.2 72-72V252.3c32.5-10.2 56-40.5 56-76.3V144c0-8.8-7.2-16-16-16H544V80c0-8.8-7.2-16-16-16s-16 7.2-16 16v48H480V80c0-8.8-7.2-16-16-16s-16 7.2-16 16v48H432c-8.8 0-16 7.2-16 16v32c0 35.8 23.5 66.1 56 76.3V376c0 13.3-10.7 24-24 24s-24-10.7-24-24V344c0-48.6-39.4-88-88-88H320V64c0-35.3-28.7-64-64-64H96zM216.9 82.7c6 4 8.5 11.5 6.3 18.3l-25 74.9H256c6.7 0 12.7 4.2 15 10.4s.5 13.3-4.6 17.7l-112 96c-5.5 4.7-13.4 5.1-19.3 1.1s-8.5-11.5-6.3-18.3l25-74.9H96c-6.7 0-12.7-4.2-15-10.4s-.5-13.3 4.6-17.7l112-96c5.5-4.7 13.4-5.1 19.3-1.1z"
    ]
};
var $d8206b3ab2e65c05$export$b17d50542d1fc340 = {
    prefix: "fas",
    iconName: "shapes",
    icon: [
        512,
        512,
        [
            "triangle-circle-square"
        ],
        "f61f",
        "M315.4 15.5C309.7 5.9 299.2 0 288 0s-21.7 5.9-27.4 15.5l-96 160c-5.9 9.9-6.1 22.2-.4 32.2s16.3 16.2 27.8 16.2H384c11.5 0 22.2-6.2 27.8-16.2s5.5-22.3-.4-32.2l-96-160zM288 312V456c0 22.1 17.9 40 40 40H472c22.1 0 40-17.9 40-40V312c0-22.1-17.9-40-40-40H328c-22.1 0-40 17.9-40 40zM128 512a128 128 0 1 0 0-256 128 128 0 1 0 0 256z"
    ]
};
var $d8206b3ab2e65c05$export$34261e5aea24fc1d = $d8206b3ab2e65c05$export$b17d50542d1fc340;
var $d8206b3ab2e65c05$export$ee94b652453ad208 = {
    prefix: "fas",
    iconName: "shuffle",
    icon: [
        512,
        512,
        [
            128256,
            "random"
        ],
        "f074",
        "M403.8 34.4c12-5 25.7-2.2 34.9 6.9l64 64c6 6 9.4 14.1 9.4 22.6s-3.4 16.6-9.4 22.6l-64 64c-9.2 9.2-22.9 11.9-34.9 6.9s-19.8-16.6-19.8-29.6V160H352c-10.1 0-19.6 4.7-25.6 12.8L284 229.3 244 176l31.2-41.6C293.3 110.2 321.8 96 352 96h32V64c0-12.9 7.8-24.6 19.8-29.6zM164 282.7L204 336l-31.2 41.6C154.7 401.8 126.2 416 96 416H32c-17.7 0-32-14.3-32-32s14.3-32 32-32H96c10.1 0 19.6-4.7 25.6-12.8L164 282.7zm274.6 188c-9.2 9.2-22.9 11.9-34.9 6.9s-19.8-16.6-19.8-29.6V416H352c-30.2 0-58.7-14.2-76.8-38.4L121.6 172.8c-6-8.1-15.5-12.8-25.6-12.8H32c-17.7 0-32-14.3-32-32s14.3-32 32-32H96c30.2 0 58.7 14.2 76.8 38.4L326.4 339.2c6 8.1 15.5 12.8 25.6 12.8h32V320c0-12.9 7.8-24.6 19.8-29.6s25.7-2.2 34.9 6.9l64 64c6 6 9.4 14.1 9.4 22.6s-3.4 16.6-9.4 22.6l-64 64z"
    ]
};
var $d8206b3ab2e65c05$export$8357bf8cc666d5f0 = $d8206b3ab2e65c05$export$ee94b652453ad208;
var $d8206b3ab2e65c05$export$f48814ae62850c74 = {
    prefix: "fas",
    iconName: "person-running",
    icon: [
        448,
        512,
        [
            127939,
            "running"
        ],
        "f70c",
        "M320 48a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zM125.7 175.5c9.9-9.9 23.4-15.5 37.5-15.5c1.9 0 3.8 .1 5.6 .3L137.6 254c-9.3 28 1.7 58.8 26.8 74.5l86.2 53.9-25.4 88.8c-4.9 17 5 34.7 22 39.6s34.7-5 39.6-22l28.7-100.4c5.9-20.6-2.6-42.6-20.7-53.9L238 299l30.9-82.4 5.1 12.3C289 264.7 323.9 288 362.7 288H384c17.7 0 32-14.3 32-32s-14.3-32-32-32H362.7c-12.9 0-24.6-7.8-29.5-19.7l-6.3-15c-14.6-35.1-44.1-61.9-80.5-73.1l-48.7-15c-11.1-3.4-22.7-5.2-34.4-5.2c-31 0-60.8 12.3-82.7 34.3L57.4 153.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0l23.1-23.1zM91.2 352H32c-17.7 0-32 14.3-32 32s14.3 32 32 32h69.6c19 0 36.2-11.2 43.9-28.5L157 361.6l-9.5-6c-17.5-10.9-30.5-26.8-37.9-44.9L91.2 352z"
    ]
};
var $d8206b3ab2e65c05$export$5dfd1cb43dc9eadb = $d8206b3ab2e65c05$export$f48814ae62850c74;
var $d8206b3ab2e65c05$export$7955f08360418647 = {
    prefix: "fas",
    iconName: "mobile-retro",
    icon: [
        320,
        512,
        [],
        "e527",
        "M0 64C0 28.7 28.7 0 64 0H256c35.3 0 64 28.7 64 64V448c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V64zm64 96v64c0 17.7 14.3 32 32 32H224c17.7 0 32-14.3 32-32V160c0-17.7-14.3-32-32-32H96c-17.7 0-32 14.3-32 32zM80 352a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm24 56a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zm56-56a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm24 56a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zm56-56a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm24 56a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zM128 48c-8.8 0-16 7.2-16 16s7.2 16 16 16h64c8.8 0 16-7.2 16-16s-7.2-16-16-16H128z"
    ]
};
var $d8206b3ab2e65c05$export$523960de087f5198 = {
    prefix: "fas",
    iconName: "grip-lines-vertical",
    icon: [
        192,
        512,
        [],
        "f7a5",
        "M64 64c0-17.7-14.3-32-32-32S0 46.3 0 64V448c0 17.7 14.3 32 32 32s32-14.3 32-32V64zm128 0c0-17.7-14.3-32-32-32s-32 14.3-32 32V448c0 17.7 14.3 32 32 32s32-14.3 32-32V64z"
    ]
};
var $d8206b3ab2e65c05$export$6daa96b1986e2ef0 = {
    prefix: "fas",
    iconName: "spider",
    icon: [
        512,
        512,
        [
            128375
        ],
        "f717",
        "M158.4 32.6c4.8-12.4-1.4-26.3-13.8-31s-26.3 1.4-31 13.8L81.1 100c-7.9 20.7-3 44.1 12.7 59.7l57.4 57.4L70.8 190.3c-2.4-.8-4.3-2.7-5.1-5.1L46.8 128.4C42.6 115.8 29 109 16.4 113.2S-3 131 1.2 143.6l18.9 56.8c5.6 16.7 18.7 29.8 35.4 35.4L116.1 256 55.6 276.2c-16.7 5.6-29.8 18.7-35.4 35.4L1.2 368.4C-3 381 3.8 394.6 16.4 398.8s26.2-2.6 30.4-15.2l18.9-56.8c.8-2.4 2.7-4.3 5.1-5.1l80.4-26.8L93.7 352.3C78.1 368 73.1 391.4 81.1 412l32.5 84.6c4.8 12.4 18.6 18.5 31 13.8s18.5-18.6 13.8-31l-32.5-84.6c-1.1-3-.4-6.3 1.8-8.5L160 353.9c1 52.1 43.6 94.1 96 94.1s95-41.9 96-94.1l32.3 32.3c2.2 2.2 2.9 5.6 1.8 8.5l-32.5 84.6c-4.8 12.4 1.4 26.3 13.8 31s26.3-1.4 31-13.8L430.9 412c7.9-20.7 3-44.1-12.7-59.7l-57.4-57.4 80.4 26.8c2.4 .8 4.3 2.7 5.1 5.1l18.9 56.8c4.2 12.6 17.8 19.4 30.4 15.2s19.4-17.8 15.2-30.4l-18.9-56.8c-5.6-16.7-18.7-29.8-35.4-35.4L395.9 256l60.5-20.2c16.7-5.6 29.8-18.7 35.4-35.4l18.9-56.8c4.2-12.6-2.6-26.2-15.2-30.4s-26.2 2.6-30.4 15.2l-18.9 56.8c-.8 2.4-2.7 4.3-5.1 5.1l-80.4 26.8 57.4-57.4c15.6-15.6 20.6-39 12.7-59.7L398.4 15.4C393.6 3 379.8-3.2 367.4 1.6s-18.5 18.6-13.8 31l32.5 84.6c1.1 3 .4 6.3-1.8 8.5L336 174.1V160c0-31.8-18.6-59.3-45.5-72.2c-9.1-4.4-18.5 3.3-18.5 13.4V112c0 8.8-7.2 16-16 16s-16-7.2-16-16V101.2c0-10.1-9.4-17.7-18.5-13.4C194.6 100.7 176 128.2 176 160v14.1l-48.3-48.3c-2.2-2.2-2.9-5.6-1.8-8.5l32.5-84.6z"
    ]
};
var $d8206b3ab2e65c05$export$740142a89118fbc0 = {
    prefix: "fas",
    iconName: "hands-bound",
    icon: [
        640,
        512,
        [],
        "e4f9",
        "M96 32C96 14.3 81.7 0 64 0S32 14.3 32 32V96v59.1 .7V192v21.9c0 14.2 5.1 27.9 14.3 38.7L131.6 352H128c-13.3 0-24 10.7-24 24s10.7 24 24 24h32H288h64H480h32c13.3 0 24-10.7 24-24s-10.7-24-24-24h-3.6l85.3-99.5c9.2-10.8 14.3-24.5 14.3-38.7V192 155.8v-.7V96 32c0-17.7-14.3-32-32-32s-32 14.3-32 32V96v48.8l-69.3 92.4c-5.7 7.6-16.1 9.6-24.2 4.8c-9.7-5.7-12.1-18.7-5.1-27.5L473 180c10.8-13.5 8.9-33.3-4.4-44.5s-33-9.8-44.5 3.2l-46.7 52.5C361 209.7 352 233.4 352 258.1V320v32H288V320 258.1c0-24.6-9-48.4-25.4-66.8l-46.7-52.5c-11.5-13-31.3-14.4-44.5-3.2s-15.2 30.9-4.4 44.5l27.6 34.5c7 8.8 4.7 21.8-5.1 27.5c-8.1 4.8-18.6 2.7-24.2-4.8L96 144.8V96 32zm64 448v32H288V480h64v32H480V480h32c13.3 0 24-10.7 24-24s-10.7-24-24-24H480 352 288 160 128c-13.3 0-24 10.7-24 24s10.7 24 24 24h32z"
    ]
};
var $d8206b3ab2e65c05$export$a3dced32d48cb1ea = {
    prefix: "fas",
    iconName: "file-invoice-dollar",
    icon: [
        384,
        512,
        [],
        "f571",
        "M64 0C28.7 0 0 28.7 0 64V448c0 35.3 28.7 64 64 64H320c35.3 0 64-28.7 64-64V160H256c-17.7 0-32-14.3-32-32V0H64zM256 0V128H384L256 0zM64 80c0-8.8 7.2-16 16-16h64c8.8 0 16 7.2 16 16s-7.2 16-16 16H80c-8.8 0-16-7.2-16-16zm0 64c0-8.8 7.2-16 16-16h64c8.8 0 16 7.2 16 16s-7.2 16-16 16H80c-8.8 0-16-7.2-16-16zm128 72c8.8 0 16 7.2 16 16v17.3c8.5 1.2 16.7 3.1 24.1 5.1c8.5 2.3 13.6 11 11.3 19.6s-11 13.6-19.6 11.3c-11.1-3-22-5.2-32.1-5.3c-8.4-.1-17.4 1.8-23.6 5.5c-5.7 3.4-8.1 7.3-8.1 12.8c0 3.7 1.3 6.5 7.3 10.1c6.9 4.1 16.6 7.1 29.2 10.9l.5 .1 0 0 0 0c11.3 3.4 25.3 7.6 36.3 14.6c12.1 7.6 22.4 19.7 22.7 38.2c.3 19.3-9.6 33.3-22.9 41.6c-7.7 4.8-16.4 7.6-25.1 9.1V440c0 8.8-7.2 16-16 16s-16-7.2-16-16V422.2c-11.2-2.1-21.7-5.7-30.9-8.9l0 0c-2.1-.7-4.2-1.4-6.2-2.1c-8.4-2.8-12.9-11.9-10.1-20.2s11.9-12.9 20.2-10.1c2.5 .8 4.8 1.6 7.1 2.4l0 0 0 0 0 0c13.6 4.6 24.6 8.4 36.3 8.7c9.1 .3 17.9-1.7 23.7-5.3c5.1-3.2 7.9-7.3 7.8-14c-.1-4.6-1.8-7.8-7.7-11.6c-6.8-4.3-16.5-7.4-29-11.2l-1.6-.5 0 0c-11-3.3-24.3-7.3-34.8-13.7c-12-7.2-22.6-18.9-22.7-37.3c-.1-19.4 10.8-32.8 23.8-40.5c7.5-4.4 15.8-7.2 24.1-8.7V232c0-8.8 7.2-16 16-16z"
    ]
};
var $d8206b3ab2e65c05$export$f201ba865ea1b8dc = {
    prefix: "fas",
    iconName: "plane-circle-exclamation",
    icon: [
        640,
        512,
        [],
        "e556",
        "M256 0c-35 0-64 59.5-64 93.7v84.6L8.1 283.4c-5 2.8-8.1 8.2-8.1 13.9v65.5c0 10.6 10.2 18.3 20.4 15.4l171.6-49 0 70.9-57.6 43.2c-4 3-6.4 7.8-6.4 12.8v42c0 7.8 6.3 14 14 14c1.3 0 2.6-.2 3.9-.5L256 480l110.1 31.5c1.3 .4 2.6 .5 3.9 .5c6 0 11.1-3.7 13.1-9C344.5 470.7 320 422.2 320 368c0-60.6 30.6-114 77.1-145.6L320 178.3V93.7C320 59.5 292 0 256 0zM496 512a144 144 0 1 0 0-288 144 144 0 1 0 0 288zm0-96a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm0-144c8.8 0 16 7.2 16 16v80c0 8.8-7.2 16-16 16s-16-7.2-16-16V288c0-8.8 7.2-16 16-16z"
    ]
};
var $d8206b3ab2e65c05$export$8cf137aceaaf4de0 = {
    prefix: "fas",
    iconName: "x-ray",
    icon: [
        512,
        512,
        [],
        "f497",
        "M0 64C0 46.3 14.3 32 32 32H480c17.7 0 32 14.3 32 32s-14.3 32-32 32V416c17.7 0 32 14.3 32 32s-14.3 32-32 32H32c-17.7 0-32-14.3-32-32s14.3-32 32-32V96C14.3 96 0 81.7 0 64zM256 96c-8.8 0-16 7.2-16 16v32H160c-8.8 0-16 7.2-16 16s7.2 16 16 16h80v48H128c-8.8 0-16 7.2-16 16s7.2 16 16 16H240v70.6L189.1 307c-5.2-2-10.6-3-16.2-3h-2.1c-23.6 0-42.8 19.2-42.8 42.8c0 9.6 3.2 18.9 9.1 26.4l18.2 23.2c9.7 12.4 24.6 19.6 40.3 19.6H316.4c15.7 0 30.6-7.2 40.3-19.6l18.2-23.2c5.9-7.5 9.1-16.8 9.1-26.4c0-23.6-19.2-42.8-42.8-42.8H339c-5.5 0-11 1-16.2 3L272 326.6V256H384c8.8 0 16-7.2 16-16s-7.2-16-16-16H272V176h80c8.8 0 16-7.2 16-16s-7.2-16-16-16H272V112c0-8.8-7.2-16-16-16zM208 352a16 16 0 1 1 0 32 16 16 0 1 1 0-32zm80 16a16 16 0 1 1 32 0 16 16 0 1 1 -32 0z"
    ]
};
var $d8206b3ab2e65c05$export$761e747b06ed2e1f = {
    prefix: "fas",
    iconName: "spell-check",
    icon: [
        576,
        512,
        [],
        "f891",
        "M112 0C99.1 0 87.4 7.8 82.5 19.7l-66.7 160-13.3 32c-6.8 16.3 .9 35 17.2 41.8s35-.9 41.8-17.2L66.7 224h90.7l5.1 12.3c6.8 16.3 25.5 24 41.8 17.2s24-25.5 17.2-41.8l-13.3-32-66.7-160C136.6 7.8 124.9 0 112 0zm18.7 160H93.3L112 115.2 130.7 160zM256 32v96 96c0 17.7 14.3 32 32 32h80c44.2 0 80-35.8 80-80c0-23.1-9.8-43.8-25.4-58.4c6-11.2 9.4-24 9.4-37.6c0-44.2-35.8-80-80-80H288c-17.7 0-32 14.3-32 32zm96 64H320V64h32c8.8 0 16 7.2 16 16s-7.2 16-16 16zm-32 64h32 16c8.8 0 16 7.2 16 16s-7.2 16-16 16H320V160zM566.6 310.6c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L352 434.7l-73.4-73.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3l96 96c12.5 12.5 32.8 12.5 45.3 0l192-192z"
    ]
};
var $d8206b3ab2e65c05$export$f54d004dd5f1cb5e = {
    prefix: "fas",
    iconName: "slash",
    icon: [
        640,
        512,
        [],
        "f715",
        "M5.1 9.2C13.3-1.2 28.4-3.1 38.8 5.1l592 464c10.4 8.2 12.3 23.3 4.1 33.7s-23.3 12.3-33.7 4.1L9.2 42.9C-1.2 34.7-3.1 19.6 5.1 9.2z"
    ]
};
var $d8206b3ab2e65c05$export$72cf138e5ddda6eb = {
    prefix: "fas",
    iconName: "computer-mouse",
    icon: [
        384,
        512,
        [
            128433,
            "mouse"
        ],
        "f8cc",
        "M0 192H176V0H160C71.6 0 0 71.6 0 160v32zm0 32V352c0 88.4 71.6 160 160 160h64c88.4 0 160-71.6 160-160V224H192 0zm384-32V160C384 71.6 312.4 0 224 0H208V192H384z"
    ]
};
var $d8206b3ab2e65c05$export$198b96b894c66074 = $d8206b3ab2e65c05$export$72cf138e5ddda6eb;
var $d8206b3ab2e65c05$export$a02c5909359525be = {
    prefix: "fas",
    iconName: "arrow-right-to-bracket",
    icon: [
        512,
        512,
        [
            "sign-in"
        ],
        "f090",
        "M352 96l64 0c17.7 0 32 14.3 32 32l0 256c0 17.7-14.3 32-32 32l-64 0c-17.7 0-32 14.3-32 32s14.3 32 32 32l64 0c53 0 96-43 96-96l0-256c0-53-43-96-96-96l-64 0c-17.7 0-32 14.3-32 32s14.3 32 32 32zm-9.4 182.6c12.5-12.5 12.5-32.8 0-45.3l-128-128c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3L242.7 224 32 224c-17.7 0-32 14.3-32 32s14.3 32 32 32l210.7 0-73.4 73.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0l128-128z"
    ]
};
var $d8206b3ab2e65c05$export$a55eff0ca4f9c3df = $d8206b3ab2e65c05$export$a02c5909359525be;
var $d8206b3ab2e65c05$export$b3d636689da4a3e5 = {
    prefix: "fas",
    iconName: "shop-slash",
    icon: [
        640,
        512,
        [
            "store-alt-slash"
        ],
        "e070",
        "M38.8 5.1C28.4-3.1 13.3-1.2 5.1 9.2S-1.2 34.7 9.2 42.9l592 464c10.4 8.2 25.5 6.3 33.7-4.1s6.3-25.5-4.1-33.7l-54.8-43V224H512V376L384 275.7V224H320v1.5L277.2 192H603.2c20.3 0 36.8-16.5 36.8-36.8c0-7.3-2.2-14.4-6.2-20.4L558.2 21.4C549.3 8 534.4 0 518.3 0H121.7c-16 0-31 8-39.9 21.4L74.1 32.8 38.8 5.1zM36.8 192h85L21 112.5 6.2 134.7c-4 6.1-6.2 13.2-6.2 20.4C0 175.5 16.5 192 36.8 192zM320 384H128V224H64V384v80c0 26.5 21.5 48 48 48H336c26.5 0 48-21.5 48-48V398.5l-64-50.4V384z"
    ]
};
var $d8206b3ab2e65c05$export$b932a586f6ff48b4 = $d8206b3ab2e65c05$export$b3d636689da4a3e5;
var $d8206b3ab2e65c05$export$1bf820d499b6202e = {
    prefix: "fas",
    iconName: "server",
    icon: [
        512,
        512,
        [],
        "f233",
        "M64 32C28.7 32 0 60.7 0 96v64c0 35.3 28.7 64 64 64H448c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64zm280 72a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm48 24a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zM64 288c-35.3 0-64 28.7-64 64v64c0 35.3 28.7 64 64 64H448c35.3 0 64-28.7 64-64V352c0-35.3-28.7-64-64-64H64zm280 72a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm56 24a24 24 0 1 1 48 0 24 24 0 1 1 -48 0z"
    ]
};
var $d8206b3ab2e65c05$export$61c2a6b698f55df6 = {
    prefix: "fas",
    iconName: "virus-covid-slash",
    icon: [
        640,
        512,
        [],
        "e4a9",
        "M38.8 5.1C28.4-3.1 13.3-1.2 5.1 9.2S-1.2 34.7 9.2 42.9l592 464c10.4 8.2 25.5 6.3 33.7-4.1s6.3-25.5-4.1-33.7L472.1 344.7c11.4-19.5 19.1-41.4 22.3-64.7H528v16c0 13.3 10.7 24 24 24s24-10.7 24-24V216c0-13.3-10.7-24-24-24s-24 10.7-24 24v16H494.4c-4.2-30.7-16.3-58.8-34.1-82.3L484 125.9l11.3 11.3c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9L472.7 46.7c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9L450.1 92l-23.8 23.8C402.8 97.9 374.7 85.8 344 81.6V48h16c13.3 0 24-10.7 24-24s-10.7-24-24-24H280c-13.3 0-24 10.7-24 24s10.7 24 24 24h16V81.6c-30.7 4.2-58.8 16.3-82.3 34.1L189.9 92l11.3-11.3c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0L134.1 79.8 38.8 5.1zM149.2 213.5c-1.5 6-2.7 12.2-3.5 18.5H112V216c0-13.3-10.7-24-24-24s-24 10.7-24 24v80c0 13.3 10.7 24 24 24s24-10.7 24-24V280h33.6c4.2 30.7 16.3 58.8 34.1 82.3L156 386.1l-11.3-11.3c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9l56.6 56.6c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9L189.9 420l23.8-23.8c23.5 17.9 51.7 29.9 82.3 34.1V464H280c-13.3 0-24 10.7-24 24s10.7 24 24 24h80c13.3 0 24-10.7 24-24s-10.7-24-24-24H344V430.4c20.4-2.8 39.7-9.1 57.3-18.2L149.2 213.5z"
    ]
};
var $d8206b3ab2e65c05$export$452410c103c2403b = {
    prefix: "fas",
    iconName: "shop-lock",
    icon: [
        640,
        512,
        [],
        "e4a5",
        "M36.8 192H449.6c20.2-19.8 47.9-32 78.4-32c30.5 0 58.1 12.2 78.3 31.9c18.9-1.6 33.7-17.4 33.7-36.7c0-7.3-2.2-14.4-6.2-20.4L558.2 21.4C549.3 8 534.4 0 518.3 0H121.7c-16 0-31 8-39.9 21.4L6.2 134.7c-4 6.1-6.2 13.2-6.2 20.4C0 175.5 16.5 192 36.8 192zM384 224H320V384H128V224H64V384v80c0 26.5 21.5 48 48 48H336c26.5 0 48-21.5 48-48V384 352 224zm144 16c17.7 0 32 14.3 32 32v48H496V272c0-17.7 14.3-32 32-32zm-80 32v48c-17.7 0-32 14.3-32 32V480c0 17.7 14.3 32 32 32H608c17.7 0 32-14.3 32-32V352c0-17.7-14.3-32-32-32V272c0-44.2-35.8-80-80-80s-80 35.8-80 80z"
    ]
};
var $d8206b3ab2e65c05$export$f0c28584caa8f4b = {
    prefix: "fas",
    iconName: "hourglass-start",
    icon: [
        384,
        512,
        [
            "hourglass-1"
        ],
        "f251",
        "M32 0C14.3 0 0 14.3 0 32S14.3 64 32 64V75c0 42.4 16.9 83.1 46.9 113.1L146.7 256 78.9 323.9C48.9 353.9 32 394.6 32 437v11c-17.7 0-32 14.3-32 32s14.3 32 32 32H64 320h32c17.7 0 32-14.3 32-32s-14.3-32-32-32V437c0-42.4-16.9-83.1-46.9-113.1L237.3 256l67.9-67.9c30-30 46.9-70.7 46.9-113.1V64c17.7 0 32-14.3 32-32s-14.3-32-32-32H320 64 32zM288 437v11H96V437c0-25.5 10.1-49.9 28.1-67.9L192 301.3l67.9 67.9c18 18 28.1 42.4 28.1 67.9z"
    ]
};
var $d8206b3ab2e65c05$export$87929336ab5c59cd = $d8206b3ab2e65c05$export$f0c28584caa8f4b;
var $d8206b3ab2e65c05$export$f35a116a762ef8fc = {
    prefix: "fas",
    iconName: "blender-phone",
    icon: [
        576,
        512,
        [],
        "f6b6",
        "M224 352L196.8 52.3C194.2 24.2 216.3 0 244.6 0H534.1c21.1 0 36.4 20.1 30.9 40.4L558.5 64H400c-8.8 0-16 7.2-16 16s7.2 16 16 16H549.8l-17.5 64H400c-8.8 0-16 7.2-16 16s7.2 16 16 16H523.6l-17.5 64H400c-8.8 0-16 7.2-16 16s7.2 16 16 16h97.5L480 352H224zm-16 32H496c26.5 0 48 21.5 48 48v32c0 26.5-21.5 48-48 48H208c-26.5 0-48-21.5-48-48V432c0-26.5 21.5-48 48-48zm144 96a32 32 0 1 0 0-64 32 32 0 1 0 0 64zM147.5 30.7c10.8 6.7 15.3 21 10.6 33.4l-22 57.8c-4.2 10.9-14.5 17.6-25.3 16.4l-33.3-3.6c-13.6 42.2-13.6 88.4 0 130.7l33.3-3.6c10.9-1.2 21.2 5.5 25.3 16.4l22 57.8c4.7 12.4 .2 26.7-10.6 33.4l-44 27.2c-9.7 6-21.9 4.2-29.8-4.3C-24.6 286-24.6 114 73.7 7.8C81.6-.7 93.8-2.5 103.5 3.5l44 27.2z"
    ]
};
var $d8206b3ab2e65c05$export$6c0cfe6d58faf860 = {
    prefix: "fas",
    iconName: "building-wheat",
    icon: [
        640,
        512,
        [],
        "e4db",
        "M0 48C0 21.5 21.5 0 48 0H336c26.5 0 48 21.5 48 48V464c0 26.5-21.5 48-48 48H240V432c0-26.5-21.5-48-48-48s-48 21.5-48 48v80H48c-26.5 0-48-21.5-48-48V48zM80 224c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V240c0-8.8-7.2-16-16-16H80zm80 16v32c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V240c0-8.8-7.2-16-16-16H176c-8.8 0-16 7.2-16 16zm112-16c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V240c0-8.8-7.2-16-16-16H272zM64 112v32c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V112c0-8.8-7.2-16-16-16H80c-8.8 0-16 7.2-16 16zM176 96c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V112c0-8.8-7.2-16-16-16H176zm80 16v32c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V112c0-8.8-7.2-16-16-16H272c-8.8 0-16 7.2-16 16zm384 80v16c0 44.2-35.8 80-80 80H544V272c0-44.2 35.8-80 80-80h16zm0 128c0 44.2-35.8 80-80 80H544V384c0-44.2 35.8-80 80-80h16v16zm0 112c0 44.2-35.8 80-80 80H544V496c0-44.2 35.8-80 80-80h16v16zM512 496v16H496c-44.2 0-80-35.8-80-80V416h16c44.2 0 80 35.8 80 80zm0-96H496c-44.2 0-80-35.8-80-80V304h16c44.2 0 80 35.8 80 80v16zm0-128v16H496c-44.2 0-80-35.8-80-80V192h16c44.2 0 80 35.8 80 80zM528 32c13.3 0 24 10.7 24 24V160c0 13.3-10.7 24-24 24s-24-10.7-24-24V56c0-13.3 10.7-24 24-24zm96 64v32c0 13.3-10.7 24-24 24s-24-10.7-24-24V96c0-13.3 10.7-24 24-24s24 10.7 24 24zM456 72c13.3 0 24 10.7 24 24v32c0 13.3-10.7 24-24 24s-24-10.7-24-24V96c0-13.3 10.7-24 24-24z"
    ]
};
var $d8206b3ab2e65c05$export$9b94ed8d16d281f9 = {
    prefix: "fas",
    iconName: "person-breastfeeding",
    icon: [
        448,
        512,
        [],
        "e53a",
        "M224 0a80 80 0 1 1 0 160A80 80 0 1 1 224 0zM436.8 382.8L373.5 462c-16.6 20.7-46.8 24.1-67.5 7.5c-17.6-14.1-22.7-38.1-13.5-57.7l-.8-.1c-38.9-5.6-74.3-25.1-99.7-54.8V320c0-17.7-14.3-32-32-32s-32 14.3-32 32v48c0 .8 0 1.6 .1 2.4l101.4 50.7c23.7 11.9 33.3 40.7 21.5 64.4s-40.7 33.3-64.4 21.5L27.2 427.3c-1.1-.5-2.2-1.1-3.3-1.7c-4.9-2.8-9.2-6.4-12.6-10.6c-4.6-5.4-7.8-11.7-9.6-18.4c-3.3-12-1.9-25.2 4.8-36.6c.6-1.1 1.3-2.2 2-3.2L75.6 256.1c26.7-40.1 71.7-64.1 119.8-64.1h75.2c46.5 0 90.1 22.5 117.2 60.3l50.7 70.9c2.2 3 4 6.1 5.5 9.4c2.9 6.7 4.3 13.8 4 20.8c-.3 10.6-4.2 21-11.2 29.4zM320 332a44 44 0 1 0 -88 0 44 44 0 1 0 88 0z"
    ]
};
var $d8206b3ab2e65c05$export$a5fd2acfcb5247c6 = {
    prefix: "fas",
    iconName: "right-to-bracket",
    icon: [
        512,
        512,
        [
            "sign-in-alt"
        ],
        "f2f6",
        "M217.9 105.9L340.7 228.7c7.2 7.2 11.3 17.1 11.3 27.3s-4.1 20.1-11.3 27.3L217.9 406.1c-6.4 6.4-15 9.9-24 9.9c-18.7 0-33.9-15.2-33.9-33.9l0-62.1L32 320c-17.7 0-32-14.3-32-32l0-64c0-17.7 14.3-32 32-32l128 0 0-62.1c0-18.7 15.2-33.9 33.9-33.9c9 0 17.6 3.6 24 9.9zM352 416l64 0c17.7 0 32-14.3 32-32l0-256c0-17.7-14.3-32-32-32l-64 0c-17.7 0-32-14.3-32-32s14.3-32 32-32l64 0c53 0 96 43 96 96l0 256c0 53-43 96-96 96l-64 0c-17.7 0-32-14.3-32-32s14.3-32 32-32z"
    ]
};
var $d8206b3ab2e65c05$export$e6709746115bd2ea = $d8206b3ab2e65c05$export$a5fd2acfcb5247c6;
var $d8206b3ab2e65c05$export$f89d028573ffc0a6 = {
    prefix: "fas",
    iconName: "venus",
    icon: [
        384,
        512,
        [
            9792
        ],
        "f221",
        "M80 176a112 112 0 1 1 224 0A112 112 0 1 1 80 176zM224 349.1c81.9-15 144-86.8 144-173.1C368 78.8 289.2 0 192 0S16 78.8 16 176c0 86.3 62.1 158.1 144 173.1V384H128c-17.7 0-32 14.3-32 32s14.3 32 32 32h32v32c0 17.7 14.3 32 32 32s32-14.3 32-32V448h32c17.7 0 32-14.3 32-32s-14.3-32-32-32H224V349.1z"
    ]
};
var $d8206b3ab2e65c05$export$2c31ca0d9bee400f = {
    prefix: "fas",
    iconName: "passport",
    icon: [
        448,
        512,
        [],
        "f5ab",
        "M0 64C0 28.7 28.7 0 64 0H384c35.3 0 64 28.7 64 64V448c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V64zM183 278.8c-27.9-13.2-48.4-39.4-53.7-70.8h39.1c1.6 30.4 7.7 53.8 14.6 70.8zm41.3 9.2l-.3 0-.3 0c-2.4-3.5-5.7-8.9-9.1-16.5c-6-13.6-12.4-34.3-14.2-63.5h47.1c-1.8 29.2-8.1 49.9-14.2 63.5c-3.4 7.6-6.7 13-9.1 16.5zm40.7-9.2c6.8-17.1 12.9-40.4 14.6-70.8h39.1c-5.3 31.4-25.8 57.6-53.7 70.8zM279.6 176c-1.6-30.4-7.7-53.8-14.6-70.8c27.9 13.2 48.4 39.4 53.7 70.8H279.6zM223.7 96l.3 0 .3 0c2.4 3.5 5.7 8.9 9.1 16.5c6 13.6 12.4 34.3 14.2 63.5H200.5c1.8-29.2 8.1-49.9 14.2-63.5c3.4-7.6 6.7-13 9.1-16.5zM183 105.2c-6.8 17.1-12.9 40.4-14.6 70.8H129.3c5.3-31.4 25.8-57.6 53.7-70.8zM352 192A128 128 0 1 0 96 192a128 128 0 1 0 256 0zM112 384c-8.8 0-16 7.2-16 16s7.2 16 16 16H336c8.8 0 16-7.2 16-16s-7.2-16-16-16H112z"
    ]
};
var $d8206b3ab2e65c05$export$a6d8e50dcd4b4294 = {
    prefix: "fas",
    iconName: "heart-pulse",
    icon: [
        512,
        512,
        [
            "heartbeat"
        ],
        "f21e",
        "M228.3 469.1L47.6 300.4c-4.2-3.9-8.2-8.1-11.9-12.4h87c22.6 0 43-13.6 51.7-34.5l10.5-25.2 49.3 109.5c3.8 8.5 12.1 14 21.4 14.1s17.8-5 22-13.3L320 253.7l1.7 3.4c9.5 19 28.9 31 50.1 31H476.3c-3.7 4.3-7.7 8.5-11.9 12.4L283.7 469.1c-7.5 7-17.4 10.9-27.7 10.9s-20.2-3.9-27.7-10.9zM503.7 240h-132c-3 0-5.8-1.7-7.2-4.4l-23.2-46.3c-4.1-8.1-12.4-13.3-21.5-13.3s-17.4 5.1-21.5 13.3l-41.4 82.8L205.9 158.2c-3.9-8.7-12.7-14.3-22.2-14.1s-18.1 5.9-21.8 14.8l-31.8 76.3c-1.2 3-4.2 4.9-7.4 4.9H16c-2.6 0-5 .4-7.3 1.1C3 225.2 0 208.2 0 190.9v-5.8c0-69.9 50.5-129.5 119.4-141C165 36.5 211.4 51.4 244 84l12 12 12-12c32.6-32.6 79-47.5 124.6-39.9C461.5 55.6 512 115.2 512 185.1v5.8c0 16.9-2.8 33.5-8.3 49.1z"
    ]
};
var $d8206b3ab2e65c05$export$ca880e19206e80aa = $d8206b3ab2e65c05$export$a6d8e50dcd4b4294;
var $d8206b3ab2e65c05$export$7754cc6d5559ff38 = {
    prefix: "fas",
    iconName: "people-carry-box",
    icon: [
        640,
        512,
        [
            "people-carry"
        ],
        "f4ce",
        "M80 48a48 48 0 1 1 96 0A48 48 0 1 1 80 48zm64 193.7v65.1l51 51c7.1 7.1 11.8 16.2 13.4 26.1l15.2 90.9c2.9 17.4-8.9 33.9-26.3 36.8s-33.9-8.9-36.8-26.3l-14.3-85.9L66.8 320C54.8 308 48 291.7 48 274.7V186.6c0-32.4 26.2-58.6 58.6-58.6c24.1 0 46.5 12 59.9 32l47.4 71.1 10.1 5V160c0-17.7 14.3-32 32-32H384c17.7 0 32 14.3 32 32v76.2l10.1-5L473.5 160c13.3-20 35.8-32 59.9-32c32.4 0 58.6 26.2 58.6 58.6v88.1c0 17-6.7 33.3-18.7 45.3l-79.4 79.4-14.3 85.9c-2.9 17.4-19.4 29.2-36.8 26.3s-29.2-19.4-26.3-36.8l15.2-90.9c1.6-9.9 6.3-19 13.4-26.1l51-51V241.7l-19 28.5c-4.6 7-11 12.6-18.5 16.3l-59.6 29.8c-2.4 1.3-4.9 2.2-7.6 2.8c-2.6 .6-5.3 .9-7.9 .8H256.7c-2.5 .1-5-.2-7.5-.7c-2.9-.6-5.6-1.6-8.1-3l-59.5-29.8c-7.5-3.7-13.8-9.4-18.5-16.3l-19-28.5zM2.3 468.1L50.1 348.6l49.2 49.2-37.6 94c-6.6 16.4-25.2 24.4-41.6 17.8S-4.3 484.5 2.3 468.1zM512 0a48 48 0 1 1 0 96 48 48 0 1 1 0-96zm77.9 348.6l47.8 119.5c6.6 16.4-1.4 35-17.8 41.6s-35-1.4-41.6-17.8l-37.6-94 49.2-49.2z"
    ]
};
var $d8206b3ab2e65c05$export$35fbd4ff1265acd5 = $d8206b3ab2e65c05$export$7754cc6d5559ff38;
var $d8206b3ab2e65c05$export$15d012277c3ecf9a = {
    prefix: "fas",
    iconName: "temperature-high",
    icon: [
        512,
        512,
        [],
        "f769",
        "M416 64a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm0 128A96 96 0 1 0 416 0a96 96 0 1 0 0 192zM96 112c0-26.5 21.5-48 48-48s48 21.5 48 48V276.5c0 17.3 7.1 31.9 15.3 42.5C217.8 332.6 224 349.5 224 368c0 44.2-35.8 80-80 80s-80-35.8-80-80c0-18.5 6.2-35.4 16.7-48.9C88.9 308.4 96 293.8 96 276.5V112zM144 0C82.1 0 32 50.2 32 112V276.5c0 .1-.1 .3-.2 .6c-.2 .6-.8 1.6-1.7 2.8C11.2 304.2 0 334.8 0 368c0 79.5 64.5 144 144 144s144-64.5 144-144c0-33.2-11.2-63.8-30.1-88.1c-.9-1.2-1.5-2.2-1.7-2.8c-.1-.3-.2-.5-.2-.6V112C256 50.2 205.9 0 144 0zm0 416c26.5 0 48-21.5 48-48c0-20.9-13.4-38.7-32-45.3V112c0-8.8-7.2-16-16-16s-16 7.2-16 16V322.7c-18.6 6.6-32 24.4-32 45.3c0 26.5 21.5 48 48 48z"
    ]
};
var $d8206b3ab2e65c05$export$4a7bb4be15f35178 = {
    prefix: "fas",
    iconName: "microchip",
    icon: [
        512,
        512,
        [],
        "f2db",
        "M176 24c0-13.3-10.7-24-24-24s-24 10.7-24 24V64c-35.3 0-64 28.7-64 64H24c-13.3 0-24 10.7-24 24s10.7 24 24 24H64v56H24c-13.3 0-24 10.7-24 24s10.7 24 24 24H64v56H24c-13.3 0-24 10.7-24 24s10.7 24 24 24H64c0 35.3 28.7 64 64 64v40c0 13.3 10.7 24 24 24s24-10.7 24-24V448h56v40c0 13.3 10.7 24 24 24s24-10.7 24-24V448h56v40c0 13.3 10.7 24 24 24s24-10.7 24-24V448c35.3 0 64-28.7 64-64h40c13.3 0 24-10.7 24-24s-10.7-24-24-24H448V280h40c13.3 0 24-10.7 24-24s-10.7-24-24-24H448V176h40c13.3 0 24-10.7 24-24s-10.7-24-24-24H448c0-35.3-28.7-64-64-64V24c0-13.3-10.7-24-24-24s-24 10.7-24 24V64H280V24c0-13.3-10.7-24-24-24s-24 10.7-24 24V64H176V24zM160 128H352c17.7 0 32 14.3 32 32V352c0 17.7-14.3 32-32 32H160c-17.7 0-32-14.3-32-32V160c0-17.7 14.3-32 32-32zm192 32H160V352H352V160z"
    ]
};
var $d8206b3ab2e65c05$export$dc1083dcd1d7b9d6 = {
    prefix: "fas",
    iconName: "crown",
    icon: [
        576,
        512,
        [
            128081
        ],
        "f521",
        "M309 106c11.4-7 19-19.7 19-34c0-22.1-17.9-40-40-40s-40 17.9-40 40c0 14.4 7.6 27 19 34L209.7 220.6c-9.1 18.2-32.7 23.4-48.6 10.7L72 160c5-6.7 8-15 8-24c0-22.1-17.9-40-40-40S0 113.9 0 136s17.9 40 40 40c.2 0 .5 0 .7 0L86.4 427.4c5.5 30.4 32 52.6 63 52.6H426.6c30.9 0 57.4-22.1 63-52.6L535.3 176c.2 0 .5 0 .7 0c22.1 0 40-17.9 40-40s-17.9-40-40-40s-40 17.9-40 40c0 9 3 17.3 8 24l-89.1 71.3c-15.9 12.7-39.5 7.5-48.6-10.7L309 106z"
    ]
};
var $d8206b3ab2e65c05$export$43d1fa6671908715 = {
    prefix: "fas",
    iconName: "weight-hanging",
    icon: [
        512,
        512,
        [],
        "f5cd",
        "M224 96a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm122.5 32c3.5-10 5.5-20.8 5.5-32c0-53-43-96-96-96s-96 43-96 96c0 11.2 1.9 22 5.5 32H120c-22 0-41.2 15-46.6 36.4l-72 288c-3.6 14.3-.4 29.5 8.7 41.2S33.2 512 48 512H464c14.8 0 28.7-6.8 37.8-18.5s12.3-26.8 8.7-41.2l-72-288C433.2 143 414 128 392 128H346.5z"
    ]
};
var $d8206b3ab2e65c05$export$f4595f012786d346 = {
    prefix: "fas",
    iconName: "xmarks-lines",
    icon: [
        640,
        512,
        [],
        "e59a",
        "M32 32C14.3 32 0 46.3 0 64S14.3 96 32 96H608c17.7 0 32-14.3 32-32s-14.3-32-32-32H32zm0 384c-17.7 0-32 14.3-32 32s14.3 32 32 32H608c17.7 0 32-14.3 32-32s-14.3-32-32-32H32zM7 167c-9.4 9.4-9.4 24.6 0 33.9l55 55L7 311c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l55-55 55 55c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9l-55-55 55-55c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-55 55L41 167c-9.4-9.4-24.6-9.4-33.9 0zM265 167c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9l55 55-55 55c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l55-55 55 55c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9l-55-55 55-55c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-55 55-55-55zM455 167c-9.4 9.4-9.4 24.6 0 33.9l55 55-55 55c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l55-55 55 55c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9l-55-55 55-55c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-55 55-55-55c-9.4-9.4-24.6-9.4-33.9 0z"
    ]
};
var $d8206b3ab2e65c05$export$a20cb90865b6beb8 = {
    prefix: "fas",
    iconName: "file-prescription",
    icon: [
        384,
        512,
        [],
        "f572",
        "M64 0C28.7 0 0 28.7 0 64V448c0 35.3 28.7 64 64 64H320c35.3 0 64-28.7 64-64V160H256c-17.7 0-32-14.3-32-32V0H64zM256 0V128H384L256 0zM104 196h72c33.1 0 60 26.9 60 60c0 25.5-15.9 47.2-38.3 55.9l43 40.3 33.8-31c8.1-7.5 20.8-6.9 28.3 1.2s6.9 20.8-1.2 28.3L270 379.7l31.7 29.7c8.1 7.6 8.5 20.2 .9 28.3s-20.2 8.5-28.3 .9l-33.9-31.8-34.9 32c-8.1 7.5-20.8 6.9-28.3-1.2s-6.9-20.8 1.2-28.3l32.6-29.9-64.8-60.8c-.9-.8-1.6-1.7-2.3-2.6H124v44c0 11-9 20-20 20s-20-9-20-20V296 216c0-11 9-20 20-20zm72 80c11 0 20-9 20-20s-9-20-20-20H124v40h52z"
    ]
};
var $d8206b3ab2e65c05$export$e521c542d18b85c3 = {
    prefix: "fas",
    iconName: "weight-scale",
    icon: [
        512,
        512,
        [
            "weight"
        ],
        "f496",
        "M128 176a128 128 0 1 1 256 0 128 128 0 1 1 -256 0zM391.8 64C359.5 24.9 310.7 0 256 0S152.5 24.9 120.2 64H64C28.7 64 0 92.7 0 128V448c0 35.3 28.7 64 64 64H448c35.3 0 64-28.7 64-64V128c0-35.3-28.7-64-64-64H391.8zM296 224c0-10.6-4.1-20.2-10.9-27.4l33.6-78.3c3.5-8.1-.3-17.5-8.4-21s-17.5 .3-21 8.4L255.7 184c-22 .1-39.7 18-39.7 40c0 22.1 17.9 40 40 40s40-17.9 40-40z"
    ]
};
var $d8206b3ab2e65c05$export$cf3bafa68a60bae4 = $d8206b3ab2e65c05$export$e521c542d18b85c3;
var $d8206b3ab2e65c05$export$3d626cfc365a7e36 = {
    prefix: "fas",
    iconName: "user-group",
    icon: [
        640,
        512,
        [
            128101,
            "user-friends"
        ],
        "f500",
        "M96 128a128 128 0 1 1 256 0A128 128 0 1 1 96 128zM0 482.3C0 383.8 79.8 304 178.3 304h91.4C368.2 304 448 383.8 448 482.3c0 16.4-13.3 29.7-29.7 29.7H29.7C13.3 512 0 498.7 0 482.3zM609.3 512H471.4c5.4-9.4 8.6-20.3 8.6-32v-8c0-60.7-27.1-115.2-69.8-151.8c2.4-.1 4.7-.2 7.1-.2h61.4C567.8 320 640 392.2 640 481.3c0 17-13.8 30.7-30.7 30.7zM432 256c-31 0-59-12.6-79.3-32.9C372.4 196.5 384 163.6 384 128c0-26.8-6.6-52.1-18.3-74.3C384.3 40.1 407.2 32 432 32c61.9 0 112 50.1 112 112s-50.1 112-112 112z"
    ]
};
var $d8206b3ab2e65c05$export$46073bec205635d9 = $d8206b3ab2e65c05$export$3d626cfc365a7e36;
var $d8206b3ab2e65c05$export$fb00fdd8857804c7 = {
    prefix: "fas",
    iconName: "arrow-up-a-z",
    icon: [
        576,
        512,
        [
            "sort-alpha-up"
        ],
        "f15e",
        "M183.6 42.4C177.5 35.8 169 32 160 32s-17.5 3.8-23.6 10.4l-88 96c-11.9 13-11.1 33.3 2 45.2s33.3 11.1 45.2-2L128 146.3V448c0 17.7 14.3 32 32 32s32-14.3 32-32V146.3l32.4 35.4c11.9 13 32.2 13.9 45.2 2s13.9-32.2 2-45.2l-88-96zM320 320c0 17.7 14.3 32 32 32h50.7l-73.4 73.4c-9.2 9.2-11.9 22.9-6.9 34.9s16.6 19.8 29.6 19.8H480c17.7 0 32-14.3 32-32s-14.3-32-32-32H429.3l73.4-73.4c9.2-9.2 11.9-22.9 6.9-34.9s-16.6-19.8-29.6-19.8H352c-17.7 0-32 14.3-32 32zM416 32c-12.1 0-23.2 6.8-28.6 17.7l-64 128-16 32c-7.9 15.8-1.5 35 14.3 42.9s35 1.5 42.9-14.3l7.2-14.3h88.4l7.2 14.3c7.9 15.8 27.1 22.2 42.9 14.3s22.2-27.1 14.3-42.9l-16-32-64-128C439.2 38.8 428.1 32 416 32zM395.8 176L416 135.6 436.2 176H395.8z"
    ]
};
var $d8206b3ab2e65c05$export$3c4115b156be730d = $d8206b3ab2e65c05$export$fb00fdd8857804c7;
var $d8206b3ab2e65c05$export$861b1f13085cf122 = {
    prefix: "fas",
    iconName: "chess-knight",
    icon: [
        448,
        512,
        [
            9822
        ],
        "f441",
        "M96 48L82.7 61.3C70.7 73.3 64 89.5 64 106.5V238.9c0 10.7 5.3 20.7 14.2 26.6l10.6 7c14.3 9.6 32.7 10.7 48.1 3l3.2-1.6c2.6-1.3 5-2.8 7.3-4.5l49.4-37c6.6-5 15.7-5 22.3 0c10.2 7.7 9.9 23.1-.7 30.3L90.4 350C73.9 361.3 64 380 64 400H384l28.9-159c2.1-11.3 3.1-22.8 3.1-34.3V192C416 86 330 0 224 0H83.8C72.9 0 64 8.9 64 19.8c0 7.5 4.2 14.3 10.9 17.7L96 48zm24 68a20 20 0 1 1 40 0 20 20 0 1 1 -40 0zM22.6 473.4c-4.2 4.2-6.6 10-6.6 16C16 501.9 26.1 512 38.6 512H409.4c12.5 0 22.6-10.1 22.6-22.6c0-6-2.4-11.8-6.6-16L384 432H64L22.6 473.4z"
    ]
};
var $d8206b3ab2e65c05$export$67ca89c1ca38d559 = {
    prefix: "fas",
    iconName: "face-laugh-squint",
    icon: [
        512,
        512,
        [
            "laugh-squint"
        ],
        "f59b",
        "M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM96.8 314.1c-3.8-13.7 7.4-26.1 21.6-26.1H393.6c14.2 0 25.5 12.4 21.6 26.1C396.2 382 332.1 432 256 432s-140.2-50-159.2-117.9zm36.7-199.4l89.9 47.9c10.7 5.7 10.7 21.1 0 26.8l-89.9 47.9c-7.9 4.2-17.5-1.5-17.5-10.5c0-2.8 1-5.5 2.8-7.6l36-43.2-36-43.2c-1.8-2.1-2.8-4.8-2.8-7.6c0-9 9.6-14.7 17.5-10.5zM396 125.1c0 2.8-1 5.5-2.8 7.6l-36 43.2 36 43.2c1.8 2.1 2.8 4.8 2.8 7.6c0 9-9.6 14.7-17.5 10.5l-89.9-47.9c-10.7-5.7-10.7-21.1 0-26.8l89.9-47.9c7.9-4.2 17.5 1.5 17.5 10.5z"
    ]
};
var $d8206b3ab2e65c05$export$b206e700cf7084e1 = $d8206b3ab2e65c05$export$67ca89c1ca38d559;
var $d8206b3ab2e65c05$export$76a9413fbe130a53 = {
    prefix: "fas",
    iconName: "wheelchair",
    icon: [
        512,
        512,
        [],
        "f193",
        "M192 96a48 48 0 1 0 0-96 48 48 0 1 0 0 96zM120.5 247.2c12.4-4.7 18.7-18.5 14-30.9s-18.5-18.7-30.9-14C43.1 225.1 0 283.5 0 352c0 88.4 71.6 160 160 160c61.2 0 114.3-34.3 141.2-84.7c6.2-11.7 1.8-26.2-9.9-32.5s-26.2-1.8-32.5 9.9C240 440 202.8 464 160 464C98.1 464 48 413.9 48 352c0-47.9 30.1-88.8 72.5-104.8zM259.8 176l-1.9-9.7c-4.5-22.3-24-38.3-46.8-38.3c-30.1 0-52.7 27.5-46.8 57l23.1 115.5c6 29.9 32.2 51.4 62.8 51.4h5.1c.4 0 .8 0 1.3 0h94.1c6.7 0 12.6 4.1 15 10.4L402 459.2c6 16.1 23.8 24.6 40.1 19.1l48-16c16.8-5.6 25.8-23.7 20.2-40.5s-23.7-25.8-40.5-20.2l-18.7 6.2-25.5-68c-11.7-31.2-41.6-51.9-74.9-51.9H282.2l-9.6-48H336c17.7 0 32-14.3 32-32s-14.3-32-32-32H259.8z"
    ]
};
var $d8206b3ab2e65c05$export$a29c8ea43e92771d = {
    prefix: "fas",
    iconName: "circle-arrow-up",
    icon: [
        512,
        512,
        [
            "arrow-circle-up"
        ],
        "f0aa",
        "M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM385 231c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0l-71-71V376c0 13.3-10.7 24-24 24s-24-10.7-24-24V193.9l-71 71c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9L239 119c9.4-9.4 24.6-9.4 33.9 0L385 231z"
    ]
};
var $d8206b3ab2e65c05$export$a2f6f3baa50af0b1 = $d8206b3ab2e65c05$export$a29c8ea43e92771d;
var $d8206b3ab2e65c05$export$5cffc34afa81e517 = {
    prefix: "fas",
    iconName: "toggle-on",
    icon: [
        576,
        512,
        [],
        "f205",
        "M192 64C86 64 0 150 0 256S86 448 192 448H384c106 0 192-86 192-192s-86-192-192-192H192zm192 96a96 96 0 1 1 0 192 96 96 0 1 1 0-192z"
    ]
};
var $d8206b3ab2e65c05$export$6af1cc5998ca52bc = {
    prefix: "fas",
    iconName: "person-walking",
    icon: [
        320,
        512,
        [
            128694,
            "walking"
        ],
        "f554",
        "M160 48a48 48 0 1 1 96 0 48 48 0 1 1 -96 0zM126.5 199.3c-1 .4-1.9 .8-2.9 1.2l-8 3.5c-16.4 7.3-29 21.2-34.7 38.2l-2.6 7.8c-5.6 16.8-23.7 25.8-40.5 20.2s-25.8-23.7-20.2-40.5l2.6-7.8c11.4-34.1 36.6-61.9 69.4-76.5l8-3.5c20.8-9.2 43.3-14 66.1-14c44.6 0 84.8 26.8 101.9 67.9L281 232.7l21.4 10.7c15.8 7.9 22.2 27.1 14.3 42.9s-27.1 22.2-42.9 14.3L247 287.3c-10.3-5.2-18.4-13.8-22.8-24.5l-9.6-23-19.3 65.5 49.5 54c5.4 5.9 9.2 13 11.2 20.8l23 92.1c4.3 17.1-6.1 34.5-23.3 38.8s-34.5-6.1-38.8-23.3l-22-88.1-70.7-77.1c-14.8-16.1-20.3-38.6-14.7-59.7l16.9-63.5zM68.7 398l25-62.4c2.1 3 4.5 5.8 7 8.6l40.7 44.4-14.5 36.2c-2.4 6-6 11.5-10.6 16.1L54.6 502.6c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3L68.7 398z"
    ]
};
var $d8206b3ab2e65c05$export$4886811b7174ec35 = $d8206b3ab2e65c05$export$6af1cc5998ca52bc;
var $d8206b3ab2e65c05$export$be32b10ce70a09df = {
    prefix: "fas",
    iconName: "l",
    icon: [
        320,
        512,
        [
            108
        ],
        "4c",
        "M64 32c17.7 0 32 14.3 32 32V416H288c17.7 0 32 14.3 32 32s-14.3 32-32 32H64c-17.7 0-32-14.3-32-32V64c0-17.7 14.3-32 32-32z"
    ]
};
var $d8206b3ab2e65c05$export$7b24b34ef6cc130c = {
    prefix: "fas",
    iconName: "fire",
    icon: [
        448,
        512,
        [
            128293
        ],
        "f06d",
        "M159.3 5.4c7.8-7.3 19.9-7.2 27.7 .1c27.6 25.9 53.5 53.8 77.7 84c11-14.4 23.5-30.1 37-42.9c7.9-7.4 20.1-7.4 28 .1c34.6 33 63.9 76.6 84.5 118c20.3 40.8 33.8 82.5 33.8 111.9C448 404.2 348.2 512 224 512C98.4 512 0 404.1 0 276.5c0-38.4 17.8-85.3 45.4-131.7C73.3 97.7 112.7 48.6 159.3 5.4zM225.7 416c25.3 0 47.7-7 68.8-21c42.1-29.4 53.4-88.2 28.1-134.4c-4.5-9-16-9.6-22.5-2l-25.2 29.3c-6.6 7.6-18.5 7.4-24.7-.5c-16.5-21-46-58.5-62.8-79.8c-6.3-8-18.3-8.1-24.7-.1c-33.8 42.5-50.8 69.3-50.8 99.4C112 375.4 162.6 416 225.7 416z"
    ]
};
var $d8206b3ab2e65c05$export$580ae0d0bbd809fb = {
    prefix: "fas",
    iconName: "bed-pulse",
    icon: [
        640,
        512,
        [
            "procedures"
        ],
        "f487",
        "M483.2 9.6L524 64h92c13.3 0 24 10.7 24 24s-10.7 24-24 24H512c-7.6 0-14.7-3.6-19.2-9.6L468.7 70.3l-47 99.9c-3.7 7.8-11.3 13.1-19.9 13.7s-16.9-3.4-21.7-10.6L339.2 112H216c-13.3 0-24-10.7-24-24s10.7-24 24-24H352c8 0 15.5 4 20 10.7l24.4 36.6 45.9-97.5C445.9 6.2 453.2 1 461.6 .1s16.6 2.7 21.6 9.5zM320 160h12.7l20.7 31.1c11.2 16.8 30.6 26.3 50.7 24.8s37.9-13.7 46.5-32L461.9 160H544c53 0 96 43 96 96V480c0 17.7-14.3 32-32 32s-32-14.3-32-32V448H352 320 64v32c0 17.7-14.3 32-32 32s-32-14.3-32-32V96C0 78.3 14.3 64 32 64s32 14.3 32 32V352H288V192c0-17.7 14.3-32 32-32zm-144 0a80 80 0 1 1 0 160 80 80 0 1 1 0-160z"
    ]
};
var $d8206b3ab2e65c05$export$5f9e1870e1866dde = $d8206b3ab2e65c05$export$580ae0d0bbd809fb;
var $d8206b3ab2e65c05$export$76d92e7f30d064c5 = {
    prefix: "fas",
    iconName: "shuttle-space",
    icon: [
        640,
        512,
        [
            "space-shuttle"
        ],
        "f197",
        "M130 480c40.6 0 80.4-11 115.2-31.9L352 384l-224 0 0 96h2zM352 128L245.2 63.9C210.4 43 170.6 32 130 32h-2v96l224 0zM96 128l0-96H80C53.5 32 32 53.5 32 80v48h8c-22.1 0-40 17.9-40 40v16V328v16c0 22.1 17.9 40 40 40H32v48c0 26.5 21.5 48 48 48H96l0-96h8c26.2 0 49.4-12.6 64-32H456c69.3 0 135-22.7 179.2-81.6c6.4-8.5 6.4-20.3 0-28.8C591 182.7 525.3 160 456 160H168c-14.6-19.4-37.8-32-64-32l-8 0zM512 243.6v24.9c0 19.6-15.9 35.6-35.6 35.6c-2.5 0-4.4-2-4.4-4.4V212.4c0-2.5 2-4.4 4.4-4.4c19.6 0 35.6 15.9 35.6 35.6z"
    ]
};
var $d8206b3ab2e65c05$export$4d1c12ba2b4ca565 = $d8206b3ab2e65c05$export$76d92e7f30d064c5;
var $d8206b3ab2e65c05$export$2f203616c892d415 = {
    prefix: "fas",
    iconName: "face-laugh",
    icon: [
        512,
        512,
        [
            "laugh"
        ],
        "f599",
        "M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM96.8 314.1c-3.8-13.7 7.4-26.1 21.6-26.1H393.6c14.2 0 25.5 12.4 21.6 26.1C396.2 382 332.1 432 256 432s-140.2-50-159.2-117.9zM144.4 192a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm192-32a32 32 0 1 1 0 64 32 32 0 1 1 0-64z"
    ]
};
var $d8206b3ab2e65c05$export$6c74e314e801a4fe = $d8206b3ab2e65c05$export$2f203616c892d415;
var $d8206b3ab2e65c05$export$ff7e93418af88b78 = {
    prefix: "fas",
    iconName: "folder-open",
    icon: [
        576,
        512,
        [
            128194,
            128449,
            61717
        ],
        "f07c",
        "M88.7 223.8L0 375.8V96C0 60.7 28.7 32 64 32H181.5c17 0 33.3 6.7 45.3 18.7l26.5 26.5c12 12 28.3 18.7 45.3 18.7H416c35.3 0 64 28.7 64 64v32H144c-22.8 0-43.8 12.1-55.3 31.8zm27.6 16.1C122.1 230 132.6 224 144 224H544c11.5 0 22 6.1 27.7 16.1s5.7 22.2-.1 32.1l-112 192C453.9 474 443.4 480 432 480H32c-11.5 0-22-6.1-27.7-16.1s-5.7-22.2 .1-32.1l112-192z"
    ]
};
var $d8206b3ab2e65c05$export$2a155a6e20f64134 = {
    prefix: "fas",
    iconName: "heart-circle-plus",
    icon: [
        576,
        512,
        [],
        "e500",
        "M47.6 300.4L228.3 469.1c7.5 7 17.4 10.9 27.7 10.9s20.2-3.9 27.7-10.9l2.6-2.4C267.2 438.6 256 404.6 256 368c0-97.2 78.8-176 176-176c28.3 0 55 6.7 78.7 18.5c.9-6.5 1.3-13 1.3-19.6v-5.8c0-69.9-50.5-129.5-119.4-141C347 36.5 300.6 51.4 268 84L256 96 244 84c-32.6-32.6-79-47.5-124.6-39.9C50.5 55.6 0 115.2 0 185.1v5.8c0 41.5 17.2 81.2 47.6 109.5zM432 512a144 144 0 1 0 0-288 144 144 0 1 0 0 288zm16-208v48h48c8.8 0 16 7.2 16 16s-7.2 16-16 16H448v48c0 8.8-7.2 16-16 16s-16-7.2-16-16V384H368c-8.8 0-16-7.2-16-16s7.2-16 16-16h48V304c0-8.8 7.2-16 16-16s16 7.2 16 16z"
    ]
};
var $d8206b3ab2e65c05$export$f54081bdbf6d4eb5 = {
    prefix: "fas",
    iconName: "code-fork",
    icon: [
        448,
        512,
        [],
        "e13b",
        "M80 104a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm80-24c0 32.8-19.7 61-48 73.3V192c0 17.7 14.3 32 32 32H304c17.7 0 32-14.3 32-32V153.3C307.7 141 288 112.8 288 80c0-44.2 35.8-80 80-80s80 35.8 80 80c0 32.8-19.7 61-48 73.3V192c0 53-43 96-96 96H256v70.7c28.3 12.3 48 40.5 48 73.3c0 44.2-35.8 80-80 80s-80-35.8-80-80c0-32.8 19.7-61 48-73.3V288H144c-53 0-96-43-96-96V153.3C19.7 141 0 112.8 0 80C0 35.8 35.8 0 80 0s80 35.8 80 80zm208 24a24 24 0 1 0 0-48 24 24 0 1 0 0 48zM248 432a24 24 0 1 0 -48 0 24 24 0 1 0 48 0z"
    ]
};
var $d8206b3ab2e65c05$export$a9947c2888b3c8fd = {
    prefix: "fas",
    iconName: "city",
    icon: [
        640,
        512,
        [
            127961
        ],
        "f64f",
        "M480 48c0-26.5-21.5-48-48-48H336c-26.5 0-48 21.5-48 48V96H224V24c0-13.3-10.7-24-24-24s-24 10.7-24 24V96H112V24c0-13.3-10.7-24-24-24S64 10.7 64 24V96H48C21.5 96 0 117.5 0 144v96V464c0 26.5 21.5 48 48 48H304h32 96H592c26.5 0 48-21.5 48-48V240c0-26.5-21.5-48-48-48H480V48zm96 320v32c0 8.8-7.2 16-16 16H528c-8.8 0-16-7.2-16-16V368c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16zM240 416H208c-8.8 0-16-7.2-16-16V368c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16zM128 400c0 8.8-7.2 16-16 16H80c-8.8 0-16-7.2-16-16V368c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v32zM560 256c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H528c-8.8 0-16-7.2-16-16V272c0-8.8 7.2-16 16-16h32zM256 176v32c0 8.8-7.2 16-16 16H208c-8.8 0-16-7.2-16-16V176c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16zM112 160c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H80c-8.8 0-16-7.2-16-16V176c0-8.8 7.2-16 16-16h32zM256 304c0 8.8-7.2 16-16 16H208c-8.8 0-16-7.2-16-16V272c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v32zM112 320H80c-8.8 0-16-7.2-16-16V272c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16zm304-48v32c0 8.8-7.2 16-16 16H368c-8.8 0-16-7.2-16-16V272c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16zM400 64c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H368c-8.8 0-16-7.2-16-16V80c0-8.8 7.2-16 16-16h32zm16 112v32c0 8.8-7.2 16-16 16H368c-8.8 0-16-7.2-16-16V176c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16z"
    ]
};
var $d8206b3ab2e65c05$export$417391ae30b5922e = {
    prefix: "fas",
    iconName: "microphone-lines",
    icon: [
        384,
        512,
        [
            127897,
            "microphone-alt"
        ],
        "f3c9",
        "M96 96V256c0 53 43 96 96 96s96-43 96-96H208c-8.8 0-16-7.2-16-16s7.2-16 16-16h80V192H208c-8.8 0-16-7.2-16-16s7.2-16 16-16h80V128H208c-8.8 0-16-7.2-16-16s7.2-16 16-16h80c0-53-43-96-96-96S96 43 96 96zM320 240v16c0 70.7-57.3 128-128 128s-128-57.3-128-128V216c0-13.3-10.7-24-24-24s-24 10.7-24 24v40c0 89.1 66.2 162.7 152 174.4V464H120c-13.3 0-24 10.7-24 24s10.7 24 24 24h72 72c13.3 0 24-10.7 24-24s-10.7-24-24-24H216V430.4c85.8-11.7 152-85.3 152-174.4V216c0-13.3-10.7-24-24-24s-24 10.7-24 24v24z"
    ]
};
var $d8206b3ab2e65c05$export$f08ef94fea14f5ac = $d8206b3ab2e65c05$export$417391ae30b5922e;
var $d8206b3ab2e65c05$export$4894bf28f771e1f3 = {
    prefix: "fas",
    iconName: "pepper-hot",
    icon: [
        512,
        512,
        [
            127798
        ],
        "f816",
        "M428.3 3c11.6-6.4 26.2-2.3 32.6 9.3l4.8 8.7c19.3 34.7 19.8 75.7 3.4 110C495.8 159.6 512 197.9 512 240c0 18.5-3.1 36.3-8.9 52.8c-6.1 17.3-28.5 16.3-36.8-.1l-11.7-23.4c-4.1-8.1-12.4-13.3-21.5-13.3H360c-13.3 0-24-10.7-24-24V152c0-13.3-10.7-24-24-24l-17.1 0c-21.3 0-30-23.9-10.8-32.9C304.7 85.4 327.7 80 352 80c28.3 0 54.8 7.3 77.8 20.2c5.5-18.2 3.7-38.4-6-55.8L419 35.7c-6.4-11.6-2.3-26.2 9.3-32.6zM171.2 345.5L264 160l40 0v80c0 26.5 21.5 48 48 48h76.2l23.9 47.8C372.3 443.9 244.3 512 103.2 512H44.4C19.9 512 0 492.1 0 467.6c0-20.8 14.5-38.8 34.8-43.3l49.8-11.1c37.6-8.4 69.5-33.2 86.7-67.7z"
    ]
};
var $d8206b3ab2e65c05$export$db1382cd406cc506 = {
    prefix: "fas",
    iconName: "unlock",
    icon: [
        448,
        512,
        [
            128275
        ],
        "f09c",
        "M144 144c0-44.2 35.8-80 80-80c31.9 0 59.4 18.6 72.3 45.7c7.6 16 26.7 22.8 42.6 15.2s22.8-26.7 15.2-42.6C331 33.7 281.5 0 224 0C144.5 0 80 64.5 80 144v48H64c-35.3 0-64 28.7-64 64V448c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V256c0-35.3-28.7-64-64-64H144V144z"
    ]
};
var $d8206b3ab2e65c05$export$dec10d4c2c113312 = {
    prefix: "fas",
    iconName: "colon-sign",
    icon: [
        384,
        512,
        [],
        "e140",
        "M255 39.8c4.3-17.1-6.1-34.5-23.3-38.8S197.2 7.1 193 24.2L181.9 68.6C96.1 87.8 32 164.4 32 256c0 58.1 25.8 110.2 66.7 145.4L81 472.2c-4.3 17.1 6.1 34.5 23.3 38.8s34.5-6.1 38.8-23.3l13-52.1c9 3.4 18.4 6.2 28 8.2L177 472.2c-4.3 17.1 6.1 34.5 23.3 38.8s34.5-6.1 38.8-23.3l10.4-41.4c33.4-4.4 64.1-17.4 89.8-36.7c14.1-10.6 17-30.7 6.4-44.8s-30.7-17-44.8-6.4c-10.2 7.7-21.7 13.9-34 18.3L321 160c9.4-.3 18.5-4.7 24.6-12.8c10.6-14.1 7.8-34.2-6.4-44.8c-1.1-.8-2.2-1.6-3.3-2.4L351 39.8c4.3-17.1-6.1-34.5-23.3-38.8S293.2 7.1 289 24.2L277.2 71.5c-9.3-2.7-18.8-4.6-28.6-5.9L255 39.8zM163.2 143.3L117.3 326.8C103.9 306.5 96 282.2 96 256c0-48.7 27.2-91 67.2-112.7zm8.6 229.5l61.1-244.6c9.9 .7 19.5 2.5 28.7 5.3l-62 248.1c-9.7-1.9-19-4.8-27.8-8.8z"
    ]
};
var $d8206b3ab2e65c05$export$23b086400a31acfe = {
    prefix: "fas",
    iconName: "headset",
    icon: [
        512,
        512,
        [],
        "f590",
        "M256 48C141.1 48 48 141.1 48 256v40c0 13.3-10.7 24-24 24s-24-10.7-24-24V256C0 114.6 114.6 0 256 0S512 114.6 512 256V400.1c0 48.6-39.4 88-88.1 88L313.6 488c-8.3 14.3-23.8 24-41.6 24H240c-26.5 0-48-21.5-48-48s21.5-48 48-48h32c17.8 0 33.3 9.7 41.6 24l110.4 .1c22.1 0 40-17.9 40-40V256c0-114.9-93.1-208-208-208zM144 208h16c17.7 0 32 14.3 32 32V352c0 17.7-14.3 32-32 32H144c-35.3 0-64-28.7-64-64V272c0-35.3 28.7-64 64-64zm224 0c35.3 0 64 28.7 64 64v48c0 35.3-28.7 64-64 64H352c-17.7 0-32-14.3-32-32V240c0-17.7 14.3-32 32-32h16z"
    ]
};
var $d8206b3ab2e65c05$export$4ab2f33219630bad = {
    prefix: "fas",
    iconName: "store-slash",
    icon: [
        640,
        512,
        [],
        "e071",
        "M38.8 5.1C28.4-3.1 13.3-1.2 5.1 9.2S-1.2 34.7 9.2 42.9l592 464c10.4 8.2 25.5 6.3 33.7-4.1s6.3-25.5-4.1-33.7l-86.8-68V384 252.6c-4 1-8 1.8-12.3 2.3l-.1 0c-5.3 .7-10.7 1.1-16.2 1.1c-12.4 0-24.3-1.9-35.4-5.3V350.9L301.2 210.7c7-4.4 13.3-9.7 18.8-15.7c15.9 17.6 39.1 29 65.2 29c26.2 0 49.3-11.4 65.2-29c16 17.6 39.1 29 65.2 29c4.1 0 8.1-.3 12.1-.8c55.5-7.4 81.8-72.5 52.1-119.4L522.3 13.1C517.2 5 508.1 0 498.4 0H141.6c-9.7 0-18.8 5-23.9 13.1l-22.7 36L38.8 5.1zm73.4 218.1c4 .5 8.1 .8 12.1 .8c11 0 21.4-2 31-5.6L48.9 134.5c-6.1 40.6 19.5 82.8 63.3 88.7zM160 384V250.6c-11.2 3.5-23.2 5.4-35.6 5.4c-5.5 0-11-.4-16.3-1.1l-.1 0c-4.1-.6-8.1-1.3-12-2.3V384v64c0 35.3 28.7 64 64 64H480c12.9 0 24.8-3.8 34.9-10.3L365.5 384H160z"
    ]
};
var $d8206b3ab2e65c05$export$2ffc88a4d31e8ffc = {
    prefix: "fas",
    iconName: "road-circle-xmark",
    icon: [
        640,
        512,
        [],
        "e566",
        "M213.2 32H288V96c0 17.7 14.3 32 32 32s32-14.3 32-32V32h74.8c27.1 0 51.3 17.1 60.3 42.6l42.7 120.6c-10.9-2.1-22.2-3.2-33.8-3.2c-59.5 0-112.1 29.6-144 74.8V224c0-17.7-14.3-32-32-32s-32 14.3-32 32v64c0 17.7 14.3 32 32 32c2.3 0 4.6-.3 6.8-.7c-4.5 15.5-6.8 31.8-6.8 48.7c0 5.4 .2 10.7 .7 16l-.7 0c-17.7 0-32 14.3-32 32v64H86.6C56.5 480 32 455.5 32 425.4c0-6.2 1.1-12.4 3.1-18.2L152.9 74.6C162 49.1 186.1 32 213.2 32zM496 224a144 144 0 1 1 0 288 144 144 0 1 1 0-288zm22.6 144l36.7-36.7c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0L496 345.4l-36.7-36.7c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6L473.4 368l-36.7 36.7c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0L496 390.6l36.7 36.7c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6L518.6 368z"
    ]
};
var $d8206b3ab2e65c05$export$d6e17c0df8ed1bf7 = {
    prefix: "fas",
    iconName: "user-minus",
    icon: [
        640,
        512,
        [],
        "f503",
        "M96 128a128 128 0 1 1 256 0A128 128 0 1 1 96 128zM0 482.3C0 383.8 79.8 304 178.3 304h91.4C368.2 304 448 383.8 448 482.3c0 16.4-13.3 29.7-29.7 29.7H29.7C13.3 512 0 498.7 0 482.3zM472 200H616c13.3 0 24 10.7 24 24s-10.7 24-24 24H472c-13.3 0-24-10.7-24-24s10.7-24 24-24z"
    ]
};
var $d8206b3ab2e65c05$export$efc6d53e0dedceee = {
    prefix: "fas",
    iconName: "mars-stroke-up",
    icon: [
        320,
        512,
        [
            9896,
            "mars-stroke-v"
        ],
        "f22a",
        "M148.7 4.7c6.2-6.2 16.4-6.2 22.6 0l64 64c4.6 4.6 5.9 11.5 3.5 17.4s-8.3 9.9-14.8 9.9H184v24h32c13.3 0 24 10.7 24 24s-10.7 24-24 24H184v24c0 .6 0 1.2-.1 1.8c77 11.6 136.1 78 136.1 158.2c0 88.4-71.6 160-160 160S0 440.4 0 352c0-80.2 59.1-146.7 136.1-158.2c0-.6-.1-1.2-.1-1.8V168H104c-13.3 0-24-10.7-24-24s10.7-24 24-24h32V96H96c-6.5 0-12.3-3.9-14.8-9.9s-1.1-12.9 3.5-17.4l64-64zM256 352A96 96 0 1 0 64 352a96 96 0 1 0 192 0z"
    ]
};
var $d8206b3ab2e65c05$export$ed7aa1c25104f333 = $d8206b3ab2e65c05$export$efc6d53e0dedceee;
var $d8206b3ab2e65c05$export$7df1926e9eef8cc3 = {
    prefix: "fas",
    iconName: "champagne-glasses",
    icon: [
        640,
        512,
        [
            129346,
            "glass-cheers"
        ],
        "f79f",
        "M155.6 17.3C163 3 179.9-3.6 195 1.9L320 47.5l125-45.6c15.1-5.5 32 1.1 39.4 15.4l78.8 152.9c28.8 55.8 10.3 122.3-38.5 156.6L556.1 413l41-15c16.6-6 35 2.5 41 19.1s-2.5 35-19.1 41l-71.1 25.9L476.8 510c-16.6 6.1-35-2.5-41-19.1s2.5-35 19.1-41l41-15-31.3-86.2c-59.4 5.2-116.2-34-130-95.2L320 188.8l-14.6 64.7c-13.8 61.3-70.6 100.4-130 95.2l-31.3 86.2 41 15c16.6 6 25.2 24.4 19.1 41s-24.4 25.2-41 19.1L92.2 484.1 21.1 458.2c-16.6-6.1-25.2-24.4-19.1-41s24.4-25.2 41-19.1l41 15 31.3-86.2C66.5 292.5 48.1 226 76.9 170.2L155.6 17.3zm44 54.4l-27.2 52.8L261.6 157l13.1-57.9L199.6 71.7zm240.9 0L365.4 99.1 378.5 157l89.2-32.5L440.5 71.7z"
    ]
};
var $d8206b3ab2e65c05$export$20007d7d74cb98fe = $d8206b3ab2e65c05$export$7df1926e9eef8cc3;
var $d8206b3ab2e65c05$export$97d84347d71ba297 = {
    prefix: "fas",
    iconName: "clipboard",
    icon: [
        384,
        512,
        [
            128203
        ],
        "f328",
        "M192 0c-41.8 0-77.4 26.7-90.5 64H64C28.7 64 0 92.7 0 128V448c0 35.3 28.7 64 64 64H320c35.3 0 64-28.7 64-64V128c0-35.3-28.7-64-64-64H282.5C269.4 26.7 233.8 0 192 0zm0 64a32 32 0 1 1 0 64 32 32 0 1 1 0-64zM112 192H272c8.8 0 16 7.2 16 16s-7.2 16-16 16H112c-8.8 0-16-7.2-16-16s7.2-16 16-16z"
    ]
};
var $d8206b3ab2e65c05$export$8403e4b31e8aa805 = {
    prefix: "fas",
    iconName: "house-circle-exclamation",
    icon: [
        640,
        512,
        [],
        "e50a",
        "M320.7 352c8.1-89.7 83.5-160 175.3-160c8.9 0 17.6 .7 26.1 1.9L309.5 7c-6-5-14-7-21-7s-15 1-22 8L10 231.5c-7 7-10 15-10 24c0 18 14 32.1 32 32.1h32v69.7c-.1 .9-.1 1.8-.1 2.8V472c0 22.1 17.9 40 40 40h16c1.2 0 2.4-.1 3.6-.2c1.5 .1 3 .2 4.5 .2H160h24c22.1 0 40-17.9 40-40V448 384c0-17.7 14.3-32 32-32h64l.7 0zM496 512a144 144 0 1 0 0-288 144 144 0 1 0 0 288zm0-96a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm0-144c8.8 0 16 7.2 16 16v80c0 8.8-7.2 16-16 16s-16-7.2-16-16V288c0-8.8 7.2-16 16-16z"
    ]
};
var $d8206b3ab2e65c05$export$929df388c07f293d = {
    prefix: "fas",
    iconName: "file-arrow-up",
    icon: [
        384,
        512,
        [
            "file-upload"
        ],
        "f574",
        "M64 0C28.7 0 0 28.7 0 64V448c0 35.3 28.7 64 64 64H320c35.3 0 64-28.7 64-64V160H256c-17.7 0-32-14.3-32-32V0H64zM256 0V128H384L256 0zM216 408c0 13.3-10.7 24-24 24s-24-10.7-24-24V305.9l-31 31c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l72-72c9.4-9.4 24.6-9.4 33.9 0l72 72c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0l-31-31V408z"
    ]
};
var $d8206b3ab2e65c05$export$dd55ded1264643d2 = $d8206b3ab2e65c05$export$929df388c07f293d;
var $d8206b3ab2e65c05$export$1642419fe3db2857 = {
    prefix: "fas",
    iconName: "wifi",
    icon: [
        640,
        512,
        [
            "wifi-3",
            "wifi-strong"
        ],
        "f1eb",
        "M54.2 202.9C123.2 136.7 216.8 96 320 96s196.8 40.7 265.8 106.9c12.8 12.2 33 11.8 45.2-.9s11.8-33-.9-45.2C549.7 79.5 440.4 32 320 32S90.3 79.5 9.8 156.7C-2.9 169-3.3 189.2 8.9 202s32.5 13.2 45.2 .9zM320 256c56.8 0 108.6 21.1 148.2 56c13.3 11.7 33.5 10.4 45.2-2.8s10.4-33.5-2.8-45.2C459.8 219.2 393 192 320 192s-139.8 27.2-190.5 72c-13.3 11.7-14.5 31.9-2.8 45.2s31.9 14.5 45.2 2.8c39.5-34.9 91.3-56 148.2-56zm64 160a64 64 0 1 0 -128 0 64 64 0 1 0 128 0z"
    ]
};
var $d8206b3ab2e65c05$export$2349bb04a04f4b2d = $d8206b3ab2e65c05$export$1642419fe3db2857;
var $d8206b3ab2e65c05$export$4b3167c852f4c4aa = $d8206b3ab2e65c05$export$1642419fe3db2857;
var $d8206b3ab2e65c05$export$1ea66a88b8f620c9 = {
    prefix: "fas",
    iconName: "bath",
    icon: [
        512,
        512,
        [
            128705,
            "bathtub"
        ],
        "f2cd",
        "M96 77.3c0-7.3 5.9-13.3 13.3-13.3c3.5 0 6.9 1.4 9.4 3.9l14.9 14.9C130 91.8 128 101.7 128 112c0 19.9 7.2 38 19.2 52c-5.3 9.2-4 21.1 3.8 29c9.4 9.4 24.6 9.4 33.9 0L289 89c9.4-9.4 9.4-24.6 0-33.9c-7.9-7.9-19.8-9.1-29-3.8C246 39.2 227.9 32 208 32c-10.3 0-20.2 2-29.2 5.5L163.9 22.6C149.4 8.1 129.7 0 109.3 0C66.6 0 32 34.6 32 77.3V256c-17.7 0-32 14.3-32 32s14.3 32 32 32H480c17.7 0 32-14.3 32-32s-14.3-32-32-32H96V77.3zM32 352v16c0 28.4 12.4 54 32 71.6V480c0 17.7 14.3 32 32 32s32-14.3 32-32V464H384v16c0 17.7 14.3 32 32 32s32-14.3 32-32V439.6c19.6-17.6 32-43.1 32-71.6V352H32z"
    ]
};
var $d8206b3ab2e65c05$export$40ae013b5e6269d8 = $d8206b3ab2e65c05$export$1ea66a88b8f620c9;
var $d8206b3ab2e65c05$export$22346afd6a3cddf8 = {
    prefix: "fas",
    iconName: "underline",
    icon: [
        448,
        512,
        [],
        "f0cd",
        "M16 64c0-17.7 14.3-32 32-32h96c17.7 0 32 14.3 32 32s-14.3 32-32 32H128V224c0 53 43 96 96 96s96-43 96-96V96H304c-17.7 0-32-14.3-32-32s14.3-32 32-32h96c17.7 0 32 14.3 32 32s-14.3 32-32 32H384V224c0 88.4-71.6 160-160 160s-160-71.6-160-160V96H48C30.3 96 16 81.7 16 64zM0 448c0-17.7 14.3-32 32-32H416c17.7 0 32 14.3 32 32s-14.3 32-32 32H32c-17.7 0-32-14.3-32-32z"
    ]
};
var $d8206b3ab2e65c05$export$3842882ea09b25af = {
    prefix: "fas",
    iconName: "user-pen",
    icon: [
        640,
        512,
        [
            "user-edit"
        ],
        "f4ff",
        "M224 256A128 128 0 1 0 224 0a128 128 0 1 0 0 256zm-45.7 48C79.8 304 0 383.8 0 482.3C0 498.7 13.3 512 29.7 512H322.8c-3.1-8.8-3.7-18.4-1.4-27.8l15-60.1c2.8-11.3 8.6-21.5 16.8-29.7l40.3-40.3c-32.1-31-75.7-50.1-123.9-50.1H178.3zm435.5-68.3c-15.6-15.6-40.9-15.6-56.6 0l-29.4 29.4 71 71 29.4-29.4c15.6-15.6 15.6-40.9 0-56.6l-14.4-14.4zM375.9 417c-4.1 4.1-7 9.2-8.4 14.9l-15 60.1c-1.4 5.5 .2 11.2 4.2 15.2s9.7 5.6 15.2 4.2l60.1-15c5.6-1.4 10.8-4.3 14.9-8.4L576.1 358.7l-71-71L375.9 417z"
    ]
};
var $d8206b3ab2e65c05$export$a68a6960fc8eef82 = $d8206b3ab2e65c05$export$3842882ea09b25af;
var $d8206b3ab2e65c05$export$afa7b53ac8ebcb5d = {
    prefix: "fas",
    iconName: "signature",
    icon: [
        640,
        512,
        [],
        "f5b7",
        "M192 128c0-17.7 14.3-32 32-32s32 14.3 32 32v7.8c0 27.7-2.4 55.3-7.1 82.5l-84.4 25.3c-40.6 12.2-68.4 49.6-68.4 92v71.9c0 40 32.5 72.5 72.5 72.5c26 0 50-13.9 62.9-36.5l13.9-24.3c26.8-47 46.5-97.7 58.4-150.5l94.4-28.3-12.5 37.5c-3.3 9.8-1.6 20.5 4.4 28.8s15.7 13.3 26 13.3H544c17.7 0 32-14.3 32-32s-14.3-32-32-32H460.4l18-53.9c3.8-11.3 .9-23.8-7.4-32.4s-20.7-11.8-32.2-8.4L316.4 198.1c2.4-20.7 3.6-41.4 3.6-62.3V128c0-53-43-96-96-96s-96 43-96 96v32c0 17.7 14.3 32 32 32s32-14.3 32-32V128zm-9.2 177l49-14.7c-10.4 33.8-24.5 66.4-42.1 97.2l-13.9 24.3c-1.5 2.6-4.3 4.3-7.4 4.3c-4.7 0-8.5-3.8-8.5-8.5V335.6c0-14.1 9.3-26.6 22.8-30.7zM24 368c-13.3 0-24 10.7-24 24s10.7 24 24 24H64.3c-.2-2.8-.3-5.6-.3-8.5V368H24zm592 48c13.3 0 24-10.7 24-24s-10.7-24-24-24H305.9c-6.7 16.3-14.2 32.3-22.3 48H616z"
    ]
};
var $d8206b3ab2e65c05$export$195780ddabd8e0c6 = {
    prefix: "fas",
    iconName: "stroopwafel",
    icon: [
        512,
        512,
        [],
        "f551",
        "M0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zM312.6 63.7c-6.2-6.2-16.4-6.2-22.6 0L256 97.6 222.1 63.7c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6l33.9 33.9-45.3 45.3-56.6-56.6c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6l56.6 56.6-45.3 45.3L86.3 199.4c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6L97.6 256 63.7 289.9c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0l33.9-33.9 45.3 45.3-56.6 56.6c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0l56.6-56.6 45.3 45.3-33.9 33.9c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0L256 414.4l33.9 33.9c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6l-33.9-33.9 45.3-45.3 56.6 56.6c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6l-56.6-56.6 45.3-45.3 33.9 33.9c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6L414.4 256l33.9-33.9c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0l-33.9 33.9-45.3-45.3 56.6-56.6c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0l-56.6 56.6-45.3-45.3 33.9-33.9c6.2-6.2 6.2-16.4 0-22.6zM142.9 256l45.3-45.3L233.4 256l-45.3 45.3L142.9 256zm67.9 67.9L256 278.6l45.3 45.3L256 369.1l-45.3-45.3zM278.6 256l45.3-45.3L369.1 256l-45.3 45.3L278.6 256zm22.6-67.9L256 233.4l-45.3-45.3L256 142.9l45.3 45.3z"
    ]
};
var $d8206b3ab2e65c05$export$7e0c7fd2a2e88823 = {
    prefix: "fas",
    iconName: "bold",
    icon: [
        384,
        512,
        [],
        "f032",
        "M0 64C0 46.3 14.3 32 32 32H80 96 224c70.7 0 128 57.3 128 128c0 31.3-11.3 60.1-30 82.3c37.1 22.4 62 63.1 62 109.7c0 70.7-57.3 128-128 128H96 80 32c-17.7 0-32-14.3-32-32s14.3-32 32-32H48V256 96H32C14.3 96 0 81.7 0 64zM224 224c35.3 0 64-28.7 64-64s-28.7-64-64-64H112V224H224zM112 288V416H256c35.3 0 64-28.7 64-64s-28.7-64-64-64H224 112z"
    ]
};
var $d8206b3ab2e65c05$export$217195c80db39097 = {
    prefix: "fas",
    iconName: "anchor-lock",
    icon: [
        640,
        512,
        [],
        "e4ad",
        "M320 96a32 32 0 1 1 -64 0 32 32 0 1 1 64 0zm21.1 80C367 158.8 384 129.4 384 96c0-53-43-96-96-96s-96 43-96 96c0 33.4 17 62.8 42.9 80H224c-17.7 0-32 14.3-32 32s14.3 32 32 32h32V448H208c-53 0-96-43-96-96v-6.1l7 7c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9L97 263c-9.4-9.4-24.6-9.4-33.9 0L7 319c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l7-7V352c0 88.4 71.6 160 160 160h80 80c8 0 15.9-.6 23.6-1.7c-4.8-9-7.6-19.3-7.6-30.3V446.7c-5.2 .9-10.5 1.3-16 1.3H320V240h32c17.7 0 32-14.3 32-32s-14.3-32-32-32H341.1zM528 240c17.7 0 32 14.3 32 32v48H496V272c0-17.7 14.3-32 32-32zm-80 32v48c-17.7 0-32 14.3-32 32V480c0 17.7 14.3 32 32 32H608c17.7 0 32-14.3 32-32V352c0-17.7-14.3-32-32-32V272c0-44.2-35.8-80-80-80s-80 35.8-80 80z"
    ]
};
var $d8206b3ab2e65c05$export$374e1dce366a2175 = {
    prefix: "fas",
    iconName: "building-ngo",
    icon: [
        384,
        512,
        [],
        "e4d7",
        "M48 0C21.5 0 0 21.5 0 48V464c0 26.5 21.5 48 48 48h96V432c0-26.5 21.5-48 48-48s48 21.5 48 48v80h96c26.5 0 48-21.5 48-48V48c0-26.5-21.5-48-48-48H48zM64 240c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H80c-8.8 0-16-7.2-16-16V240zm112-16h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H176c-8.8 0-16-7.2-16-16V240c0-8.8 7.2-16 16-16zm80 16c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H272c-8.8 0-16-7.2-16-16V240zM168 64h48c8.8 0 16 7.2 16 16s-7.2 16-16 16H184v64h16V144c0-8.8 7.2-16 16-16s16 7.2 16 16v24c0 13.3-10.7 24-24 24H176c-13.3 0-24-10.7-24-24V80c0-8.8 7.2-16 16-16zM304 96c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16s16-7.2 16-16V112c0-8.8-7.2-16-16-16zm-48 16c0-26.5 21.5-48 48-48s48 21.5 48 48v32c0 26.5-21.5 48-48 48s-48-21.5-48-48V112zM61.3 71.1l34.7 52V80c0-8.8 7.2-16 16-16s16 7.2 16 16v96c0 7.1-4.6 13.3-11.4 15.3s-14-.6-17.9-6.4L64 132.8V176c0 8.8-7.2 16-16 16s-16-7.2-16-16V80c0-7.1 4.6-13.3 11.4-15.3s14 .6 17.9 6.4z"
    ]
};
var $d8206b3ab2e65c05$export$1ff755b523ab2851 = {
    prefix: "fas",
    iconName: "manat-sign",
    icon: [
        384,
        512,
        [],
        "e1d5",
        "M192 32c-17.7 0-32 14.3-32 32V98.7C69.2 113.9 0 192.9 0 288V448c0 17.7 14.3 32 32 32s32-14.3 32-32V288c0-59.6 40.8-109.8 96-124V448c0 17.7 14.3 32 32 32s32-14.3 32-32V164c55.2 14.2 96 64.3 96 124V448c0 17.7 14.3 32 32 32s32-14.3 32-32V288c0-95.1-69.2-174.1-160-189.3V64c0-17.7-14.3-32-32-32z"
    ]
};
var $d8206b3ab2e65c05$export$6a15ccae09bbaf93 = {
    prefix: "fas",
    iconName: "not-equal",
    icon: [
        448,
        512,
        [],
        "f53e",
        "M369.8 37.4c14.7 9.8 18.7 29.7 8.9 44.4L337.1 144H400c17.7 0 32 14.3 32 32s-14.3 32-32 32H294.5l-64 96H400c17.7 0 32 14.3 32 32s-14.3 32-32 32H187.8l-65.2 97.7c-9.8 14.7-29.7 18.7-44.4 8.9s-18.7-29.7-8.9-44.4L110.9 368H48c-17.7 0-32-14.3-32-32s14.3-32 32-32H153.5l64-96H48c-17.7 0-32-14.3-32-32s14.3-32 32-32H260.2l65.2-97.7c9.8-14.7 29.7-18.7 44.4-8.9z"
    ]
};
var $d8206b3ab2e65c05$export$cf897c3e0abd59e4 = {
    prefix: "fas",
    iconName: "border-top-left",
    icon: [
        448,
        512,
        [
            "border-style"
        ],
        "f853",
        "M0 448c0 17.7 14.3 32 32 32s32-14.3 32-32l0-336c0-8.8 7.2-16 16-16l336 0c17.7 0 32-14.3 32-32s-14.3-32-32-32L80 32C35.8 32 0 67.8 0 112L0 448zm160 0a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zm192 0a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zm-96 0a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zm192 0a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zM416 288a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm0 32a32 32 0 1 0 0 64 32 32 0 1 0 0-64zm0-128a32 32 0 1 0 0-64 32 32 0 1 0 0 64z"
    ]
};
var $d8206b3ab2e65c05$export$c2867ca78120d644 = $d8206b3ab2e65c05$export$cf897c3e0abd59e4;
var $d8206b3ab2e65c05$export$757f50b8af780c19 = {
    prefix: "fas",
    iconName: "map-location-dot",
    icon: [
        576,
        512,
        [
            "map-marked-alt"
        ],
        "f5a0",
        "M408 120c0 54.6-73.1 151.9-105.2 192c-7.7 9.6-22 9.6-29.6 0C241.1 271.9 168 174.6 168 120C168 53.7 221.7 0 288 0s120 53.7 120 120zm8 80.4c3.5-6.9 6.7-13.8 9.6-20.6c.5-1.2 1-2.5 1.5-3.7l116-46.4C558.9 123.4 576 135 576 152V422.8c0 9.8-6 18.6-15.1 22.3L416 503V200.4zM137.6 138.3c2.4 14.1 7.2 28.3 12.8 41.5c2.9 6.8 6.1 13.7 9.6 20.6V451.8L32.9 502.7C17.1 509 0 497.4 0 480.4V209.6c0-9.8 6-18.6 15.1-22.3l122.6-49zM327.8 332c13.9-17.4 35.7-45.7 56.2-77V504.3L192 449.4V255c20.5 31.3 42.3 59.6 56.2 77c20.5 25.6 59.1 25.6 79.6 0zM288 152a40 40 0 1 0 0-80 40 40 0 1 0 0 80z"
    ]
};
var $d8206b3ab2e65c05$export$a977d47c74d8e86c = $d8206b3ab2e65c05$export$757f50b8af780c19;
var $d8206b3ab2e65c05$export$859f204e59641ca4 = {
    prefix: "fas",
    iconName: "jedi",
    icon: [
        576,
        512,
        [],
        "f669",
        "M246 315.7l-21.2-31.9c-2.1-3.2-1.7-7.4 1-10.1s6.9-3.1 10.1-1l29.5 19.7c2.1 1.4 4.9 0 5-2.6L279.7 8c.1-4.5 3.8-8 8.3-8s8.1 3.5 8.3 8l9.4 281.9c.1 2.5 2.9 3.9 5 2.6l29.5-19.7c3.2-2.1 7.4-1.7 10.1 1s3.1 6.9 1 10.1L330 315.7c-1.3 1.9-.2 4.5 2 4.9l37.6 7.5c3.7 .7 6.4 4 6.4 7.8s-2.7 7.1-6.4 7.8L332 351.4c-2.2 .4-3.3 3-2 4.9l21.2 31.9c2.1 3.2 1.7 7.4-1 10.1s-6.9 3.1-10.1 1l-26.3-17.6c-2.2-1.4-5.1 .2-5 2.8l2.1 61.5C370.6 435.2 416 382.9 416 320c0-37-15.7-70.4-40.8-93.7c-7-6.5-6.5-18.6 1-24.4C410.1 175.5 432 134.3 432 88c0-16.8-2.9-33-8.2-48c-4.6-13 10.2-30 21.4-22c53.5 38 92.7 94.8 107.8 160.7c.5 2.1-.2 4.3-1.7 5.9l-28.4 28.4c-4 4-1.2 10.9 4.5 10.9h26c3.4 0 6.2 2.6 6.3 6c.1 3.3 .2 6.6 .2 10c0 17.5-1.7 34.7-4.8 51.3c-.2 1.2-.9 2.4-1.7 3.3l-46.5 46.5c-4 4-1.2 10.9 4.5 10.9H526c4.6 0 7.7 4.8 5.7 9C487.2 450.5 394.8 512 288 512S88.8 450.5 44.3 361c-2.1-4.2 1-9 5.7-9H64.5c5.7 0 8.6-6.9 4.5-10.9L22.6 294.6c-.9-.9-1.5-2-1.7-3.3C17.7 274.7 16 257.5 16 240c0-3.3 .1-6.7 .2-10c.1-3.4 2.9-6 6.3-6h26c5.7 0 8.6-6.9 4.5-10.9L24.6 184.6c-1.5-1.5-2.2-3.8-1.7-5.9C38.1 112.8 77.3 56 130.8 18c11.3-8 26 8.9 21.4 22c-5.3 15-8.2 31.2-8.2 48c0 46.3 21.9 87.5 55.8 113.9c7.5 5.8 8 17.9 1 24.4C175.7 249.6 160 283 160 320c0 62.9 45.4 115.2 105.1 126l2.1-61.5c.1-2.6-2.8-4.2-5-2.8l-26.3 17.6c-3.2 2.1-7.4 1.7-10.1-1s-3.1-6.9-1-10.1L246 356.3c1.3-1.9 .2-4.5-2-4.9l-37.6-7.5c-3.7-.7-6.4-4-6.4-7.8s2.7-7.1 6.4-7.8l37.6-7.5c2.2-.4 3.3-3 2-4.9z"
    ]
};
var $d8206b3ab2e65c05$export$91d747e5aabe6fe8 = {
    prefix: "fas",
    iconName: "square-poll-vertical",
    icon: [
        448,
        512,
        [
            "poll"
        ],
        "f681",
        "M64 32C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64zm64 192c17.7 0 32 14.3 32 32v96c0 17.7-14.3 32-32 32s-32-14.3-32-32V256c0-17.7 14.3-32 32-32zm64-64c0-17.7 14.3-32 32-32s32 14.3 32 32V352c0 17.7-14.3 32-32 32s-32-14.3-32-32V160zM320 288c17.7 0 32 14.3 32 32v32c0 17.7-14.3 32-32 32s-32-14.3-32-32V320c0-17.7 14.3-32 32-32z"
    ]
};
var $d8206b3ab2e65c05$export$bc8ca14ab51f93db = $d8206b3ab2e65c05$export$91d747e5aabe6fe8;
var $d8206b3ab2e65c05$export$47a822c30184e8af = {
    prefix: "fas",
    iconName: "mug-hot",
    icon: [
        512,
        512,
        [
            9749
        ],
        "f7b6",
        "M88 0C74.7 0 64 10.7 64 24c0 38.9 23.4 59.4 39.1 73.1l1.1 1C120.5 112.3 128 119.9 128 136c0 13.3 10.7 24 24 24s24-10.7 24-24c0-38.9-23.4-59.4-39.1-73.1l-1.1-1C119.5 47.7 112 40.1 112 24c0-13.3-10.7-24-24-24zM32 192c-17.7 0-32 14.3-32 32V416c0 53 43 96 96 96H288c53 0 96-43 96-96h16c61.9 0 112-50.1 112-112s-50.1-112-112-112H352 32zm352 64h16c26.5 0 48 21.5 48 48s-21.5 48-48 48H384V256zM224 24c0-13.3-10.7-24-24-24s-24 10.7-24 24c0 38.9 23.4 59.4 39.1 73.1l1.1 1C232.5 112.3 240 119.9 240 136c0 13.3 10.7 24 24 24s24-10.7 24-24c0-38.9-23.4-59.4-39.1-73.1l-1.1-1C231.5 47.7 224 40.1 224 24z"
    ]
};
var $d8206b3ab2e65c05$export$a44d0c11093d9c1e = {
    prefix: "fas",
    iconName: "car-battery",
    icon: [
        512,
        512,
        [
            "battery-car"
        ],
        "f5df",
        "M80 96c0-17.7 14.3-32 32-32h64c17.7 0 32 14.3 32 32l96 0c0-17.7 14.3-32 32-32h64c17.7 0 32 14.3 32 32h16c35.3 0 64 28.7 64 64V384c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V160c0-35.3 28.7-64 64-64l16 0zm304 96c0-8.8-7.2-16-16-16s-16 7.2-16 16v32H320c-8.8 0-16 7.2-16 16s7.2 16 16 16h32v32c0 8.8 7.2 16 16 16s16-7.2 16-16V256h32c8.8 0 16-7.2 16-16s-7.2-16-16-16H384V192zM80 240c0 8.8 7.2 16 16 16h96c8.8 0 16-7.2 16-16s-7.2-16-16-16H96c-8.8 0-16 7.2-16 16z"
    ]
};
var $d8206b3ab2e65c05$export$9133165ca669dd4b = $d8206b3ab2e65c05$export$a44d0c11093d9c1e;
var $d8206b3ab2e65c05$export$b2727de8ccdbb5ec = {
    prefix: "fas",
    iconName: "gift",
    icon: [
        512,
        512,
        [
            127873
        ],
        "f06b",
        "M190.5 68.8L225.3 128H224 152c-22.1 0-40-17.9-40-40s17.9-40 40-40h2.2c14.9 0 28.8 7.9 36.3 20.8zM64 88c0 14.4 3.5 28 9.6 40H32c-17.7 0-32 14.3-32 32v64c0 17.7 14.3 32 32 32H480c17.7 0 32-14.3 32-32V160c0-17.7-14.3-32-32-32H438.4c6.1-12 9.6-25.6 9.6-40c0-48.6-39.4-88-88-88h-2.2c-31.9 0-61.5 16.9-77.7 44.4L256 85.5l-24.1-41C215.7 16.9 186.1 0 154.2 0H152C103.4 0 64 39.4 64 88zm336 0c0 22.1-17.9 40-40 40H288h-1.3l34.8-59.2C329.1 55.9 342.9 48 357.8 48H360c22.1 0 40 17.9 40 40zM32 288V464c0 26.5 21.5 48 48 48H224V288H32zM288 512H432c26.5 0 48-21.5 48-48V288H288V512z"
    ]
};
var $d8206b3ab2e65c05$export$4d85df590065572f = {
    prefix: "fas",
    iconName: "dice-two",
    icon: [
        448,
        512,
        [
            9857
        ],
        "f528",
        "M0 96C0 60.7 28.7 32 64 32H384c35.3 0 64 28.7 64 64V416c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96zM352 352a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zM128 192a32 32 0 1 0 0-64 32 32 0 1 0 0 64z"
    ]
};
var $d8206b3ab2e65c05$export$7b8ce73615739d30 = {
    prefix: "fas",
    iconName: "chess-queen",
    icon: [
        512,
        512,
        [
            9819
        ],
        "f445",
        "M256 0a56 56 0 1 1 0 112A56 56 0 1 1 256 0zM134.1 143.8c3.3-13 15-23.8 30.2-23.8c12.3 0 22.6 7.2 27.7 17c12 23.2 36.2 39 64 39s52-15.8 64-39c5.1-9.8 15.4-17 27.7-17c15.3 0 27 10.8 30.2 23.8c7 27.8 32.2 48.3 62.1 48.3c10.8 0 21-2.7 29.8-7.4c8.4-4.4 18.9-4.5 27.6 .9c13 8 17.1 25 9.2 38L399.7 400H384 343.6 168.4 128 112.3L5.4 223.6c-7.9-13-3.8-30 9.2-38c8.7-5.3 19.2-5.3 27.6-.9c8.9 4.7 19 7.4 29.8 7.4c29.9 0 55.1-20.5 62.1-48.3zM256 224l0 0 0 0h0zM112 432H400l41.4 41.4c4.2 4.2 6.6 10 6.6 16c0 12.5-10.1 22.6-22.6 22.6H86.6C74.1 512 64 501.9 64 489.4c0-6 2.4-11.8 6.6-16L112 432z"
    ]
};
var $d8206b3ab2e65c05$export$58d7d709c0a8ca5f = {
    prefix: "fas",
    iconName: "glasses",
    icon: [
        576,
        512,
        [],
        "f530",
        "M118.6 80c-11.5 0-21.4 7.9-24 19.1L57 260.3c20.5-6.2 48.3-12.3 78.7-12.3c32.3 0 61.8 6.9 82.8 13.5c10.6 3.3 19.3 6.7 25.4 9.2c3.1 1.3 5.5 2.4 7.3 3.2c.9 .4 1.6 .7 2.1 1l.6 .3 .2 .1 .1 0 0 0 0 0s0 0-6.3 12.7h0l6.3-12.7c5.8 2.9 10.4 7.3 13.5 12.7h40.6c3.1-5.3 7.7-9.8 13.5-12.7l6.3 12.7h0c-6.3-12.7-6.3-12.7-6.3-12.7l0 0 0 0 .1 0 .2-.1 .6-.3c.5-.2 1.2-.6 2.1-1c1.8-.8 4.2-1.9 7.3-3.2c6.1-2.6 14.8-5.9 25.4-9.2c21-6.6 50.4-13.5 82.8-13.5c30.4 0 58.2 6.1 78.7 12.3L481.4 99.1c-2.6-11.2-12.6-19.1-24-19.1c-3.1 0-6.2 .6-9.2 1.8L416.9 94.3c-12.3 4.9-26.3-1.1-31.2-13.4s1.1-26.3 13.4-31.2l31.3-12.5c8.6-3.4 17.7-5.2 27-5.2c33.8 0 63.1 23.3 70.8 56.2l43.9 188c1.7 7.3 2.9 14.7 3.5 22.1c.3 1.9 .5 3.8 .5 5.7v6.7V352v16c0 61.9-50.1 112-112 112H419.7c-59.4 0-108.5-46.4-111.8-105.8L306.6 352H269.4l-1.2 22.2C264.9 433.6 215.8 480 156.3 480H112C50.1 480 0 429.9 0 368V352 310.7 304c0-1.9 .2-3.8 .5-5.7c.6-7.4 1.8-14.8 3.5-22.1l43.9-188C55.5 55.3 84.8 32 118.6 32c9.2 0 18.4 1.8 27 5.2l31.3 12.5c12.3 4.9 18.3 18.9 13.4 31.2s-18.9 18.3-31.2 13.4L127.8 81.8c-2.9-1.2-6-1.8-9.2-1.8zM64 325.4V368c0 26.5 21.5 48 48 48h44.3c25.5 0 46.5-19.9 47.9-45.3l2.5-45.6c-2.3-.8-4.9-1.7-7.5-2.5c-17.2-5.4-39.9-10.5-63.6-10.5c-23.7 0-46.2 5.1-63.2 10.5c-3.1 1-5.9 1.9-8.5 2.9zM512 368V325.4c-2.6-.9-5.5-1.9-8.5-2.9c-17-5.4-39.5-10.5-63.2-10.5c-23.7 0-46.4 5.1-63.6 10.5c-2.7 .8-5.2 1.7-7.5 2.5l2.5 45.6c1.4 25.4 22.5 45.3 47.9 45.3H464c26.5 0 48-21.5 48-48z"
    ]
};
var $d8206b3ab2e65c05$export$bd301515df6246af = {
    prefix: "fas",
    iconName: "chess-board",
    icon: [
        448,
        512,
        [],
        "f43c",
        "M64 32C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64zm64 64v64h64V96h64v64h64V96h64v64H320v64h64v64H320v64h64v64H320V352H256v64H192V352H128v64H64V352h64V288H64V224h64V160H64V96h64zm64 128h64V160H192v64zm0 64V224H128v64h64zm64 0H192v64h64V288zm0 0h64V224H256v64z"
    ]
};
var $d8206b3ab2e65c05$export$5559de5f969b9590 = {
    prefix: "fas",
    iconName: "building-circle-check",
    icon: [
        640,
        512,
        [],
        "e4d2",
        "M48 0C21.5 0 0 21.5 0 48V464c0 26.5 21.5 48 48 48h96V432c0-26.5 21.5-48 48-48s48 21.5 48 48v80h96c15.1 0 28.5-6.9 37.3-17.8C340.4 462.2 320 417.5 320 368c0-54.7 24.9-103.5 64-135.8V48c0-26.5-21.5-48-48-48H48zM64 240c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H80c-8.8 0-16-7.2-16-16V240zm112-16h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H176c-8.8 0-16-7.2-16-16V240c0-8.8 7.2-16 16-16zm80 16c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H272c-8.8 0-16-7.2-16-16V240zM80 96h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H80c-8.8 0-16-7.2-16-16V112c0-8.8 7.2-16 16-16zm80 16c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H176c-8.8 0-16-7.2-16-16V112zM272 96h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H272c-8.8 0-16-7.2-16-16V112c0-8.8 7.2-16 16-16zM640 368a144 144 0 1 0 -288 0 144 144 0 1 0 288 0zm-76.7-43.3c6.2 6.2 6.2 16.4 0 22.6l-72 72c-6.2 6.2-16.4 6.2-22.6 0l-40-40c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0L480 385.4l60.7-60.7c6.2-6.2 16.4-6.2 22.6 0z"
    ]
};
var $d8206b3ab2e65c05$export$c9dc1583b207b7ff = {
    prefix: "fas",
    iconName: "person-chalkboard",
    icon: [
        640,
        512,
        [],
        "e53d",
        "M192 96a48 48 0 1 0 0-96 48 48 0 1 0 0 96zm-8 384V352h16V480c0 17.7 14.3 32 32 32s32-14.3 32-32V192h56 64 16c17.7 0 32-14.3 32-32s-14.3-32-32-32H384V64H576V256H384V224H320v48c0 26.5 21.5 48 48 48H592c26.5 0 48-21.5 48-48V48c0-26.5-21.5-48-48-48H368c-26.5 0-48 21.5-48 48v80H243.1 177.1c-33.7 0-64.9 17.7-82.3 46.6l-58.3 97c-9.1 15.1-4.2 34.8 10.9 43.9s34.8 4.2 43.9-10.9L120 256.9V480c0 17.7 14.3 32 32 32s32-14.3 32-32z"
    ]
};
var $d8206b3ab2e65c05$export$321e84e6a900c2d6 = {
    prefix: "fas",
    iconName: "mars-stroke-right",
    icon: [
        640,
        512,
        [
            9897,
            "mars-stroke-h"
        ],
        "f22b",
        "M208 368a112 112 0 1 0 0-224 112 112 0 1 0 0 224zm174.4-88C370.7 365.8 297.1 432 208 432c-97.2 0-176-78.8-176-176s78.8-176 176-176c89.1 0 162.7 66.2 174.4 152H416V176c0-13.3 10.7-24 24-24s24 10.7 24 24v56h32V176c0-9.7 5.8-18.5 14.8-22.2s19.3-1.7 26.2 5.2l80 80c9.4 9.4 9.4 24.6 0 33.9l-80 80c-6.9 6.9-17.2 8.9-26.2 5.2s-14.8-12.5-14.8-22.2V280H464v56c0 13.3-10.7 24-24 24s-24-10.7-24-24V280H382.4z"
    ]
};
var $d8206b3ab2e65c05$export$5cb0daeafbcdabe3 = $d8206b3ab2e65c05$export$321e84e6a900c2d6;
var $d8206b3ab2e65c05$export$be38a892fe9b4098 = {
    prefix: "fas",
    iconName: "hand-back-fist",
    icon: [
        448,
        512,
        [
            "hand-rock"
        ],
        "f255",
        "M144 0C117.5 0 96 21.5 96 48V96v28.5V176c0 8.8-7.2 16-16 16s-16-7.2-16-16V149.3l-9 7.5C40.4 169 32 187 32 206V244c0 38 16.9 74 46.1 98.3L128 384v96c0 17.7 14.3 32 32 32H320c17.7 0 32-14.3 32-32V374.7c46.9-19 80-65 80-118.7V176 160 144c0-26.5-21.5-48-48-48c-12.4 0-23.6 4.7-32.1 12.3C350 83.5 329.3 64 304 64c-12.4 0-23.6 4.7-32.1 12.3C270 51.5 249.3 32 224 32c-12.4 0-23.6 4.7-32.1 12.3C190 19.5 169.3 0 144 0z"
    ]
};
var $d8206b3ab2e65c05$export$97a81eba394c8c44 = $d8206b3ab2e65c05$export$be38a892fe9b4098;
var $d8206b3ab2e65c05$export$66068918abb14406 = {
    prefix: "fas",
    iconName: "square-caret-up",
    icon: [
        448,
        512,
        [
            "caret-square-up"
        ],
        "f151",
        "M64 32C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64zM224 160c6.7 0 13 2.8 17.6 7.7l104 112c6.5 7 8.2 17.2 4.4 25.9s-12.5 14.4-22 14.4H120c-9.5 0-18.2-5.7-22-14.4s-2.1-18.9 4.4-25.9l104-112c4.5-4.9 10.9-7.7 17.6-7.7z"
    ]
};
var $d8206b3ab2e65c05$export$307ae80b26533ce5 = $d8206b3ab2e65c05$export$66068918abb14406;
var $d8206b3ab2e65c05$export$b416056e795d2eac = {
    prefix: "fas",
    iconName: "cloud-showers-water",
    icon: [
        576,
        512,
        [],
        "e4e4",
        "M224 0c38.6 0 71.9 22.8 87.2 55.7C325.7 41.1 345.8 32 368 32c38.7 0 71 27.5 78.4 64H448c35.3 0 64 28.7 64 64s-28.7 64-64 64H128c-35.3 0-64-28.7-64-64s28.7-64 64-64c0-53 43-96 96-96zM140.6 292.3l-48 80c-6.8 11.4-21.6 15-32.9 8.2s-15.1-21.6-8.2-32.9l48-80c6.8-11.4 21.6-15.1 32.9-8.2s15.1 21.6 8.2 32.9zm327.8-32.9c11.4 6.8 15 21.6 8.2 32.9l-48 80c-6.8 11.4-21.6 15-32.9 8.2s-15-21.6-8.2-32.9l48-80c6.8-11.4 21.6-15.1 32.9-8.2zM252.6 292.3l-48 80c-6.8 11.4-21.6 15-32.9 8.2s-15.1-21.6-8.2-32.9l48-80c6.8-11.4 21.6-15.1 32.9-8.2s15.1 21.6 8.2 32.9zm103.8-32.9c11.4 6.8 15 21.6 8.2 32.9l-48 80c-6.8 11.4-21.6 15-32.9 8.2s-15.1-21.6-8.2-32.9l48-80c6.8-11.4 21.6-15.1 32.9-8.2zM306.5 421.9C329 437.4 356.5 448 384 448c26.9 0 55.4-10.8 77.4-26.1l0 0c11.9-8.5 28.1-7.8 39.2 1.7c14.4 11.9 32.5 21 50.6 25.2c17.2 4 27.9 21.2 23.9 38.4s-21.2 27.9-38.4 23.9c-24.5-5.7-44.9-16.5-58.2-25C449.5 501.7 417 512 384 512c-31.9 0-60.6-9.9-80.4-18.9c-5.8-2.7-11.1-5.3-15.6-7.7c-4.5 2.4-9.7 5.1-15.6 7.7c-19.8 9-48.5 18.9-80.4 18.9c-33 0-65.5-10.3-94.5-25.8c-13.4 8.4-33.7 19.3-58.2 25c-17.2 4-34.4-6.7-38.4-23.9s6.7-34.4 23.9-38.4c18.1-4.2 36.2-13.3 50.6-25.2c11.1-9.4 27.3-10.1 39.2-1.7l0 0C136.7 437.2 165.1 448 192 448c27.5 0 55-10.6 77.5-26.1c11.1-7.9 25.9-7.9 37 0z"
    ]
};
var $d8206b3ab2e65c05$export$b532f5d25de97633 = {
    prefix: "fas",
    iconName: "chart-bar",
    icon: [
        512,
        512,
        [
            "bar-chart"
        ],
        "f080",
        "M32 32c17.7 0 32 14.3 32 32V400c0 8.8 7.2 16 16 16H480c17.7 0 32 14.3 32 32s-14.3 32-32 32H80c-44.2 0-80-35.8-80-80V64C0 46.3 14.3 32 32 32zm96 96c0-17.7 14.3-32 32-32l192 0c17.7 0 32 14.3 32 32s-14.3 32-32 32l-192 0c-17.7 0-32-14.3-32-32zm32 64H288c17.7 0 32 14.3 32 32s-14.3 32-32 32H160c-17.7 0-32-14.3-32-32s14.3-32 32-32zm0 96H416c17.7 0 32 14.3 32 32s-14.3 32-32 32H160c-17.7 0-32-14.3-32-32s14.3-32 32-32z"
    ]
};
var $d8206b3ab2e65c05$export$2d5f754a5e5738b = $d8206b3ab2e65c05$export$b532f5d25de97633;
var $d8206b3ab2e65c05$export$2f78563e14e49916 = {
    prefix: "fas",
    iconName: "hands-bubbles",
    icon: [
        576,
        512,
        [
            "hands-wash"
        ],
        "e05e",
        "M416 64a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm96 128a32 32 0 1 0 0-64 32 32 0 1 0 0 64zM160 464a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zM32 160l.1 72.6c.1 52.2 24 101 64 133.1c-.1-1.9-.1-3.8-.1-5.7v-8c0-71.8 37-138.6 97.9-176.7l60.2-37.6c8.6-5.4 17.9-8.4 27.3-9.4l45.9-79.5c6.6-11.5 2.7-26.2-8.8-32.8s-26.2-2.7-32.8 8.8l-78 135.1c-3.3 5.7-10.7 7.7-16.4 4.4s-7.7-10.7-4.4-16.4l62-107.4c6.6-11.5 2.7-26.2-8.8-32.8S214 5 207.4 16.5l-68 117.8 0 0 0 0-43.3 75L96 160c0-17.7-14.4-32-32-32s-32 14.4-32 32zM332.1 88.5L307.5 131c13.9 4.5 26.4 13.7 34.7 27c.9 1.5 1.7 2.9 2.5 4.4l28.9-50c6.6-11.5 2.7-26.2-8.8-32.8s-26.2-2.7-32.8 8.8zm46.4 63.7l-26.8 46.4c-.6 6-2.1 11.8-4.3 17.4H352h13.3l0 0H397l23-39.8c6.6-11.5 2.7-26.2-8.8-32.8s-26.2-2.7-32.8 8.8zM315.1 175c-9.4-15-29.1-19.5-44.1-10.2l-60.2 37.6C159.3 234.7 128 291.2 128 352v8c0 8.9 .8 17.6 2.2 26.1c35.4 8.2 61.8 40 61.8 77.9c0 6.3-.7 12.5-2.1 18.4C215.1 501 246.3 512 280 512H456c13.3 0 24-10.7 24-24s-10.7-24-24-24H364c-6.6 0-12-5.4-12-12s5.4-12 12-12H488c13.3 0 24-10.7 24-24s-10.7-24-24-24H364c-6.6 0-12-5.4-12-12s5.4-12 12-12H520c13.3 0 24-10.7 24-24s-10.7-24-24-24H364c-6.6 0-12-5.4-12-12s5.4-12 12-12H488c13.3 0 24-10.7 24-24s-10.7-24-24-24H352l0 0 0 0H258.8L305 219.1c15-9.4 19.5-29.1 10.2-44.1z"
    ]
};
var $d8206b3ab2e65c05$export$996b5dea53b124e3 = $d8206b3ab2e65c05$export$2f78563e14e49916;
var $d8206b3ab2e65c05$export$b2c723344cff0d8 = {
    prefix: "fas",
    iconName: "less-than-equal",
    icon: [
        448,
        512,
        [],
        "f537",
        "M395.9 93.7c16.4-6.6 24.4-25.2 17.8-41.6s-25.2-24.4-41.6-17.8l-320 128C40 167.1 32 178.9 32 192s8 24.9 20.1 29.7l320 128c16.4 6.6 35-1.4 41.6-17.8s-1.4-35-17.8-41.6L150.2 192 395.9 93.7zM32 416c-17.7 0-32 14.3-32 32s14.3 32 32 32H416c17.7 0 32-14.3 32-32s-14.3-32-32-32H32z"
    ]
};
var $d8206b3ab2e65c05$export$17cde74bf6f1ee89 = {
    prefix: "fas",
    iconName: "train",
    icon: [
        448,
        512,
        [
            128646
        ],
        "f238",
        "M96 0C43 0 0 43 0 96V352c0 48 35.2 87.7 81.1 94.9l-46 46C28.1 499.9 33.1 512 43 512H82.7c8.5 0 16.6-3.4 22.6-9.4L160 448H288l54.6 54.6c6 6 14.1 9.4 22.6 9.4H405c10 0 15-12.1 7.9-19.1l-46-46c46-7.1 81.1-46.9 81.1-94.9V96c0-53-43-96-96-96H96zM64 96c0-17.7 14.3-32 32-32H352c17.7 0 32 14.3 32 32v96c0 17.7-14.3 32-32 32H96c-17.7 0-32-14.3-32-32V96zM224 288a48 48 0 1 1 0 96 48 48 0 1 1 0-96z"
    ]
};
var $d8206b3ab2e65c05$export$23a892b1a4b994bd = {
    prefix: "fas",
    iconName: "eye-low-vision",
    icon: [
        640,
        512,
        [
            "low-vision"
        ],
        "f2a8",
        "M38.8 5.1C28.4-3.1 13.3-1.2 5.1 9.2S-1.2 34.7 9.2 42.9l592 464c10.4 8.2 25.5 6.3 33.7-4.1s6.3-25.5-4.1-33.7L525.6 386.7c39.6-40.6 66.4-86.1 79.9-118.4c3.3-7.9 3.3-16.7 0-24.6c-14.9-35.7-46.2-87.7-93-131.1C465.5 68.8 400.8 32 320 32c-68.2 0-125 26.3-169.3 60.8L38.8 5.1zM223 149.5c48.6-44.3 123-50.8 179.3-11.7c60.8 42.4 78.9 123.2 44.2 186.9L408 294.5c8.4-19.3 10.6-41.4 4.8-63.3c-11.1-41.5-47.8-69.4-88.6-71.1c-5.8-.2-9.2 6.1-7.4 11.7c2.1 6.4 3.3 13.2 3.3 20.3c0 10.2-2.4 19.8-6.6 28.3L223 149.5zm223.1 298L83.1 161.5c-11 14.4-20.5 28.7-28.4 42.2l339 265.7c18.7-5.5 36.2-13 52.6-21.8zM34.5 268.3c14.9 35.7 46.2 87.7 93 131.1C174.5 443.2 239.2 480 320 480c3.1 0 6.1-.1 9.2-.2L33.1 247.8c-1.8 6.8-1.3 14 1.4 20.5z"
    ]
};
var $d8206b3ab2e65c05$export$7a65d2aa54cb4e93 = $d8206b3ab2e65c05$export$23a892b1a4b994bd;
var $d8206b3ab2e65c05$export$bfa312207b788ed9 = {
    prefix: "fas",
    iconName: "crow",
    icon: [
        640,
        512,
        [],
        "f520",
        "M456 0c-48.6 0-88 39.4-88 88v29.2L12.5 390.6c-14 10.8-16.6 30.9-5.9 44.9s30.9 16.6 44.9 5.9L126.1 384H259.2l46.6 113.1c5 12.3 19.1 18.1 31.3 13.1s18.1-19.1 13.1-31.3L311.1 384H352c1.1 0 2.1 0 3.2 0l46.6 113.2c5 12.3 19.1 18.1 31.3 13.1s18.1-19.1 13.1-31.3l-42-102C484.9 354.1 544 280 544 192V128v-8l80.5-20.1c8.6-2.1 13.8-10.8 11.6-19.4C629 52 603.4 32 574 32H523.9C507.7 12.5 483.3 0 456 0zm0 64a24 24 0 1 1 0 48 24 24 0 1 1 0-48z"
    ]
};
var $d8206b3ab2e65c05$export$e363e74e36cce80c = {
    prefix: "fas",
    iconName: "sailboat",
    icon: [
        576,
        512,
        [],
        "e445",
        "M256 16c0-7 4.5-13.2 11.2-15.3s13.9 .4 17.9 6.1l224 320c3.4 4.9 3.8 11.3 1.1 16.6s-8.2 8.6-14.2 8.6H272c-8.8 0-16-7.2-16-16V16zM212.1 96.5c7 1.9 11.9 8.2 11.9 15.5V336c0 8.8-7.2 16-16 16H80c-5.7 0-11-3-13.8-8s-2.9-11-.1-16l128-224c3.6-6.3 11-9.4 18-7.5zM5.7 404.3C2.8 394.1 10.5 384 21.1 384H554.9c10.6 0 18.3 10.1 15.4 20.3l-4 14.3C550.7 473.9 500.4 512 443 512H133C75.6 512 25.3 473.9 9.7 418.7l-4-14.3z"
    ]
};
var $d8206b3ab2e65c05$export$eccfff9bfd585652 = {
    prefix: "fas",
    iconName: "window-restore",
    icon: [
        512,
        512,
        [],
        "f2d2",
        "M432 64H208c-8.8 0-16 7.2-16 16V96H128V80c0-44.2 35.8-80 80-80H432c44.2 0 80 35.8 80 80V304c0 44.2-35.8 80-80 80H416V320h16c8.8 0 16-7.2 16-16V80c0-8.8-7.2-16-16-16zM0 192c0-35.3 28.7-64 64-64H320c35.3 0 64 28.7 64 64V448c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V192zm64 32c0 17.7 14.3 32 32 32H288c17.7 0 32-14.3 32-32s-14.3-32-32-32H96c-17.7 0-32 14.3-32 32z"
    ]
};
var $d8206b3ab2e65c05$export$eaf727acca5a35e4 = {
    prefix: "fas",
    iconName: "square-plus",
    icon: [
        448,
        512,
        [
            61846,
            "plus-square"
        ],
        "f0fe",
        "M64 32C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64zM200 344V280H136c-13.3 0-24-10.7-24-24s10.7-24 24-24h64V168c0-13.3 10.7-24 24-24s24 10.7 24 24v64h64c13.3 0 24 10.7 24 24s-10.7 24-24 24H248v64c0 13.3-10.7 24-24 24s-24-10.7-24-24z"
    ]
};
var $d8206b3ab2e65c05$export$b6359eebfe900c35 = $d8206b3ab2e65c05$export$eaf727acca5a35e4;
var $d8206b3ab2e65c05$export$75825a4c2b3375e = {
    prefix: "fas",
    iconName: "torii-gate",
    icon: [
        512,
        512,
        [
            9961
        ],
        "f6a1",
        "M0 80c0 26.5 21.5 48 48 48H64v64h64V128h96v64h64V128h96v64h64V128h16c26.5 0 48-21.5 48-48V13.4C512 6 506 0 498.6 0c-1.7 0-3.4 .3-5 1l-49 19.6C425.7 28.1 405.5 32 385.2 32H126.8c-20.4 0-40.5-3.9-59.4-11.4L18.4 1c-1.6-.6-3.3-1-5-1C6 0 0 6 0 13.4V80zM64 288V480c0 17.7 14.3 32 32 32s32-14.3 32-32V288H384V480c0 17.7 14.3 32 32 32s32-14.3 32-32V288h32c17.7 0 32-14.3 32-32s-14.3-32-32-32H32c-17.7 0-32 14.3-32 32s14.3 32 32 32H64z"
    ]
};
var $d8206b3ab2e65c05$export$fe2358263efac504 = {
    prefix: "fas",
    iconName: "frog",
    icon: [
        576,
        512,
        [],
        "f52e",
        "M368 32c41.7 0 75.9 31.8 79.7 72.5l85.6 26.3c25.4 7.8 42.8 31.3 42.8 57.9c0 21.8-11.7 41.9-30.7 52.7L400.8 323.5 493.3 416H544c17.7 0 32 14.3 32 32s-14.3 32-32 32H480c-8.5 0-16.6-3.4-22.6-9.4L346.9 360.2c11.7-36 3.2-77.1-25.4-105.7c-40.6-40.6-106.3-40.6-146.9-.1L101 324.4c-6.4 6.1-6.7 16.2-.6 22.6s16.2 6.6 22.6 .6l73.8-70.2 .1-.1 .1-.1c3.5-3.5 7.3-6.6 11.3-9.2c27.9-18.5 65.9-15.4 90.5 9.2c24.7 24.7 27.7 62.9 9 90.9c-2.6 3.8-5.6 7.5-9 10.9L261.8 416H352c17.7 0 32 14.3 32 32s-14.3 32-32 32H64c-35.3 0-64-28.7-64-64C0 249.6 127 112.9 289.3 97.5C296.2 60.2 328.8 32 368 32zm0 104a24 24 0 1 0 0-48 24 24 0 1 0 0 48z"
    ]
};
var $d8206b3ab2e65c05$export$2124c7628e573b84 = {
    prefix: "fas",
    iconName: "bucket",
    icon: [
        448,
        512,
        [],
        "e4cf",
        "M96 152v8H48v-8C48 68.1 116.1 0 200 0h48c83.9 0 152 68.1 152 152v8H352v-8c0-57.4-46.6-104-104-104H200C142.6 48 96 94.6 96 152zM0 224c0-17.7 14.3-32 32-32H416c17.7 0 32 14.3 32 32s-14.3 32-32 32h-5.1L388.5 469c-2.6 24.4-23.2 43-47.7 43H107.2c-24.6 0-45.2-18.5-47.7-43L37.1 256H32c-17.7 0-32-14.3-32-32z"
    ]
};
var $d8206b3ab2e65c05$export$7e9f0928967e03b = {
    prefix: "fas",
    iconName: "image",
    icon: [
        512,
        512,
        [],
        "f03e",
        "M0 96C0 60.7 28.7 32 64 32H448c35.3 0 64 28.7 64 64V416c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96zM323.8 202.5c-4.5-6.6-11.9-10.5-19.8-10.5s-15.4 3.9-19.8 10.5l-87 127.6L170.7 297c-4.6-5.7-11.5-9-18.7-9s-14.2 3.3-18.7 9l-64 80c-5.8 7.2-6.9 17.1-2.9 25.4s12.4 13.6 21.6 13.6h96 32H424c8.9 0 17.1-4.9 21.2-12.8s3.6-17.4-1.4-24.7l-120-176zM112 192a48 48 0 1 0 0-96 48 48 0 1 0 0 96z"
    ]
};
var $d8206b3ab2e65c05$export$eed3c491effe6d12 = {
    prefix: "fas",
    iconName: "microphone",
    icon: [
        384,
        512,
        [],
        "f130",
        "M192 0C139 0 96 43 96 96V256c0 53 43 96 96 96s96-43 96-96V96c0-53-43-96-96-96zM64 216c0-13.3-10.7-24-24-24s-24 10.7-24 24v40c0 89.1 66.2 162.7 152 174.4V464H120c-13.3 0-24 10.7-24 24s10.7 24 24 24h72 72c13.3 0 24-10.7 24-24s-10.7-24-24-24H216V430.4c85.8-11.7 152-85.3 152-174.4V216c0-13.3-10.7-24-24-24s-24 10.7-24 24v40c0 70.7-57.3 128-128 128s-128-57.3-128-128V216z"
    ]
};
var $d8206b3ab2e65c05$export$1da3b2e53dcafa2d = {
    prefix: "fas",
    iconName: "cow",
    icon: [
        640,
        512,
        [
            128004
        ],
        "f6c8",
        "M96 224v32V416c0 17.7 14.3 32 32 32h32c17.7 0 32-14.3 32-32V327.8c9.9 6.6 20.6 12 32 16.1V368c0 8.8 7.2 16 16 16s16-7.2 16-16V351.1c5.3 .6 10.6 .9 16 .9s10.7-.3 16-.9V368c0 8.8 7.2 16 16 16s16-7.2 16-16V343.8c11.4-4 22.1-9.4 32-16.1V416c0 17.7 14.3 32 32 32h32c17.7 0 32-14.3 32-32V256l32 32v49.5c0 9.5 2.8 18.7 8.1 26.6L530 427c8.8 13.1 23.5 21 39.3 21c22.5 0 41.9-15.9 46.3-38l20.3-101.6c2.6-13-.3-26.5-8-37.3l-3.9-5.5V184c0-13.3-10.7-24-24-24s-24 10.7-24 24v14.4l-52.9-74.1C496 86.5 452.4 64 405.9 64H272 256 192 144C77.7 64 24 117.7 24 184v54C9.4 249.8 0 267.8 0 288v17.6c0 8 6.4 14.4 14.4 14.4C46.2 320 72 294.2 72 262.4V256 224 184c0-24.3 12.1-45.8 30.5-58.9C98.3 135.9 96 147.7 96 160v64zM560 336a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zM166.6 166.6c-4.2-4.2-6.6-10-6.6-16c0-12.5 10.1-22.6 22.6-22.6H361.4c12.5 0 22.6 10.1 22.6 22.6c0 6-2.4 11.8-6.6 16l-23.4 23.4C332.2 211.8 302.7 224 272 224s-60.2-12.2-81.9-33.9l-23.4-23.4z"
    ]
};
var $d8206b3ab2e65c05$export$7de776bdab4e536d = {
    prefix: "fas",
    iconName: "caret-up",
    icon: [
        320,
        512,
        [],
        "f0d8",
        "M182.6 137.4c-12.5-12.5-32.8-12.5-45.3 0l-128 128c-9.2 9.2-11.9 22.9-6.9 34.9s16.6 19.8 29.6 19.8H288c12.9 0 24.6-7.8 29.6-19.8s2.2-25.7-6.9-34.9l-128-128z"
    ]
};
var $d8206b3ab2e65c05$export$7484ff654cd6474f = {
    prefix: "fas",
    iconName: "screwdriver",
    icon: [
        512,
        512,
        [
            129691
        ],
        "f54a",
        "M465 7c-8.5-8.5-22-9.4-31.6-2.1l-104 80c-5.9 4.5-9.4 11.6-9.4 19v54.1l-85.6 85.6c6.7 4.2 13 9.3 18.8 15.1s10.9 12.2 15.1 18.8L353.9 192H408c7.5 0 14.5-3.5 19-9.4l80-104c7.4-9.6 6.5-23.1-2.1-31.6L465 7zM121.4 281.4l-112 112c-12.5 12.5-12.5 32.8 0 45.3l64 64c12.5 12.5 32.8 12.5 45.3 0l112-112c30.2-30.2 30.2-79.1 0-109.3s-79.1-30.2-109.3 0z"
    ]
};
var $d8206b3ab2e65c05$export$5e30548b7f8eeb95 = {
    prefix: "fas",
    iconName: "folder-closed",
    icon: [
        512,
        512,
        [],
        "e185",
        "M448 480H64c-35.3 0-64-28.7-64-64V192H512V416c0 35.3-28.7 64-64 64zm64-320H0V96C0 60.7 28.7 32 64 32H192c20.1 0 39.1 9.5 51.2 25.6l19.2 25.6c6 8.1 15.5 12.8 25.6 12.8H448c35.3 0 64 28.7 64 64z"
    ]
};
var $d8206b3ab2e65c05$export$197b9567e88a0b1d = {
    prefix: "fas",
    iconName: "house-tsunami",
    icon: [
        576,
        512,
        [],
        "e515",
        "M80.8 136.5C104.9 93.8 152.6 64 209 64c16.9 0 33.1 2.7 48.2 7.7c16.8 5.5 34.9-3.6 40.4-20.4s-3.6-34.9-20.4-40.4C255.8 3.8 232.8 0 209 0C95.2 0 0 88 0 200c0 91.6 53.5 172.1 142.2 194.1c13.4 3.8 27.5 5.9 42.2 5.9c.7 0 1.4 0 2.1-.1c1.8 0 3.7 .1 5.5 .1l0 0c31.9 0 60.6-9.9 80.4-18.9c5.8-2.7 11.1-5.3 15.6-7.7c4.5 2.4 9.7 5.1 15.6 7.7c19.8 9 48.5 18.9 80.4 18.9c33 0 65.5-10.3 94.5-25.8c13.4 8.4 33.7 19.3 58.2 25c17.2 4 34.4-6.7 38.4-23.9s-6.7-34.4-23.9-38.4c-18.1-4.2-36.2-13.3-50.6-25.2c-11.1-9.5-27.3-10.1-39.2-1.7l0 0C439.4 325.2 410.9 336 384 336c-27.5 0-55-10.6-77.5-26.1c-11.1-7.9-25.9-7.9-37 0c-22.4 15.5-49.9 26.1-77.4 26.1c0 0-.1 0-.1 0c-12.4 0-24-1.5-34.9-4.3C121.6 320.2 96 287 96 248c0-48.5 39.5-88 88.4-88c13.5 0 26.1 3 37.5 8.3c16 7.5 35.1 .6 42.5-15.5s.6-35.1-15.5-42.5C229.3 101.1 207.4 96 184.4 96c-40 0-76.4 15.4-103.6 40.5zm252-18.1c-8.1 6-12.8 15.5-12.8 25.6V265c1.6 1 3.3 2 4.8 3.1c18.4 12.7 39.6 20.3 59.2 20.3c19 0 41.2-7.9 59.2-20.3c23.8-16.7 55.8-15.3 78.1 3.4c10.6 8.8 24.2 15.6 37.3 18.6c5.8 1.4 11.2 3.4 16.2 6.2c.7-2.7 1.1-5.5 1.1-8.4l-.4-144c0-10-4.7-19.4-12.7-25.5l-95.5-72c-11.4-8.6-27.1-8.6-38.5 0l-96 72zM384 448c-27.5 0-55-10.6-77.5-26.1c-11.1-7.9-25.9-7.9-37 0C247 437.4 219.5 448 192 448c-26.9 0-55.3-10.8-77.4-26.1l0 0c-11.9-8.5-28.1-7.8-39.2 1.7c-14.4 11.9-32.5 21-50.6 25.2c-17.2 4-27.9 21.2-23.9 38.4s21.2 27.9 38.4 23.9c24.5-5.7 44.9-16.5 58.2-25C126.5 501.7 159 512 192 512c31.9 0 60.6-9.9 80.4-18.9c5.8-2.7 11.1-5.3 15.6-7.7c4.5 2.4 9.7 5.1 15.6 7.7c19.8 9 48.5 18.9 80.4 18.9c33 0 65.5-10.3 94.5-25.8c13.4 8.4 33.7 19.3 58.2 25c17.2 4 34.4-6.7 38.4-23.9s-6.7-34.4-23.9-38.4c-18.1-4.2-36.2-13.3-50.6-25.2c-11.1-9.4-27.3-10.1-39.2-1.7l0 0C439.4 437.2 410.9 448 384 448z"
    ]
};
var $d8206b3ab2e65c05$export$5498258519fc5b72 = {
    prefix: "fas",
    iconName: "square-nfi",
    icon: [
        448,
        512,
        [],
        "e576",
        "M0 96C0 60.7 28.7 32 64 32H384c35.3 0 64 28.7 64 64V416c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96zm75.7 64.6C68.8 162.5 64 168.8 64 176V336c0 8.8 7.2 16 16 16s16-7.2 16-16V233.8l66.3 110.5c3.7 6.2 11.1 9.1 18 7.2s11.7-8.2 11.7-15.4V176c0-8.8-7.2-16-16-16s-16 7.2-16 16V278.2L93.7 167.8c-3.7-6.2-11.1-9.1-18-7.2zM224 176v64 96c0 8.8 7.2 16 16 16s16-7.2 16-16V256h48c8.8 0 16-7.2 16-16s-7.2-16-16-16H256V192h48c8.8 0 16-7.2 16-16s-7.2-16-16-16H240c-8.8 0-16 7.2-16 16zm160 0c0-8.8-7.2-16-16-16s-16 7.2-16 16V336c0 8.8 7.2 16 16 16s16-7.2 16-16V176z"
    ]
};
var $d8206b3ab2e65c05$export$cbe485a104805f4f = {
    prefix: "fas",
    iconName: "arrow-up-from-ground-water",
    icon: [
        576,
        512,
        [],
        "e4b5",
        "M288 352c17.7 0 32-14.3 32-32V109.3l25.4 25.4c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3l-80-80c-12.5-12.5-32.8-12.5-45.3 0l-80 80c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0L256 109.3V320c0 17.7 14.3 32 32 32zm-18.5 69.9C247 437.4 219.5 448 192 448c-26.9 0-55.3-10.8-77.4-26.1l0 0c-11.9-8.5-28.1-7.8-39.2 1.7c-14.4 11.9-32.5 21-50.6 25.2c-17.2 4-27.9 21.2-23.9 38.4s21.2 27.9 38.4 23.9c24.5-5.7 44.9-16.5 58.2-25C126.5 501.7 159 512 192 512c31.9 0 60.6-9.9 80.4-18.9c5.8-2.7 11.1-5.3 15.6-7.7c4.5 2.4 9.7 5.1 15.6 7.7c19.8 9 48.5 18.9 80.4 18.9c33 0 65.5-10.3 94.5-25.8c13.4 8.4 33.7 19.3 58.2 25c17.2 4 34.4-6.7 38.4-23.9s-6.7-34.4-23.9-38.4c-18.1-4.2-36.2-13.3-50.6-25.2c-11.1-9.4-27.3-10.1-39.2-1.7l0 0C439.4 437.2 410.9 448 384 448c-27.5 0-55-10.6-77.5-26.1c-11.1-7.9-25.9-7.9-37 0zM192 192H48c-26.5 0-48 21.5-48 48V425c5.3-3.1 11.2-5.4 17.5-6.9c13.1-3.1 26.7-9.8 37.3-18.6c22.2-18.7 54.3-20.1 78.1-3.4c18 12.4 40.1 20.3 59.1 20.3V192zm384 48c0-26.5-21.5-48-48-48H384V416.5h0c19 0 41.2-7.9 59.2-20.3c23.8-16.7 55.8-15.3 78.1 3.4c10.6 8.8 24.2 15.6 37.3 18.6c6.3 1.5 12.1 3.8 17.5 6.9V240z"
    ]
};
var $d8206b3ab2e65c05$export$98401bb29cff68e0 = {
    prefix: "fas",
    iconName: "martini-glass",
    icon: [
        512,
        512,
        [
            127864,
            "glass-martini-alt"
        ],
        "f57b",
        "M32 0C19.1 0 7.4 7.8 2.4 19.8s-2.2 25.7 6.9 34.9L224 269.3V448H160c-17.7 0-32 14.3-32 32s14.3 32 32 32h96 96c17.7 0 32-14.3 32-32s-14.3-32-32-32H288V269.3L502.6 54.6c9.2-9.2 11.9-22.9 6.9-34.9S492.9 0 480 0H32zM173.3 128l-64-64H402.7l-64 64H173.3z"
    ]
};
var $d8206b3ab2e65c05$export$2258439b8f4e7acb = $d8206b3ab2e65c05$export$98401bb29cff68e0;
var $d8206b3ab2e65c05$export$7adaa412bd8eb08f = {
    prefix: "fas",
    iconName: "rotate-left",
    icon: [
        512,
        512,
        [
            "rotate-back",
            "rotate-backward",
            "undo-alt"
        ],
        "f2ea",
        "M48.5 224H40c-13.3 0-24-10.7-24-24V72c0-9.7 5.8-18.5 14.8-22.2s19.3-1.7 26.2 5.2L98.6 96.6c87.6-86.5 228.7-86.2 315.8 1c87.5 87.5 87.5 229.3 0 316.8s-229.3 87.5-316.8 0c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0c62.5 62.5 163.8 62.5 226.3 0s62.5-163.8 0-226.3c-62.2-62.2-162.7-62.5-225.3-1L185 183c6.9 6.9 8.9 17.2 5.2 26.2s-12.5 14.8-22.2 14.8H48.5z"
    ]
};
var $d8206b3ab2e65c05$export$9706706f1bc7b12 = $d8206b3ab2e65c05$export$7adaa412bd8eb08f;
var $d8206b3ab2e65c05$export$4ceb0b05fed961a9 = $d8206b3ab2e65c05$export$7adaa412bd8eb08f;
var $d8206b3ab2e65c05$export$c8197b992c46c4a6 = $d8206b3ab2e65c05$export$7adaa412bd8eb08f;
var $d8206b3ab2e65c05$export$ccaa019a3fd4563f = {
    prefix: "fas",
    iconName: "table-columns",
    icon: [
        512,
        512,
        [
            "columns"
        ],
        "f0db",
        "M0 96C0 60.7 28.7 32 64 32H448c35.3 0 64 28.7 64 64V416c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96zm64 64V416H224V160H64zm384 0H288V416H448V160z"
    ]
};
var $d8206b3ab2e65c05$export$bb861166644ac28a = $d8206b3ab2e65c05$export$ccaa019a3fd4563f;
var $d8206b3ab2e65c05$export$4fbda8f64648f3b5 = {
    prefix: "fas",
    iconName: "lemon",
    icon: [
        448,
        512,
        [
            127819
        ],
        "f094",
        "M448 96c0-35.3-28.7-64-64-64c-6.6 0-13 1-19 2.9c-22.5 7-48.1 14.9-71 9c-75.2-19.1-156.4 11-213.7 68.3S-7.2 250.8 11.9 326c5.8 22.9-2 48.4-9 71C1 403 0 409.4 0 416c0 35.3 28.7 64 64 64c6.6 0 13-1 19.1-2.9c22.5-7 48.1-14.9 71-9c75.2 19.1 156.4-11 213.7-68.3s87.5-138.5 68.3-213.7c-5.8-22.9 2-48.4 9-71c1.9-6 2.9-12.4 2.9-19.1zM212.5 127.4c-54.6 16-101.1 62.5-117.1 117.1C92.9 253 84 257.8 75.5 255.4S62.2 244 64.6 235.5c19.1-65.1 73.7-119.8 138.9-138.9c8.5-2.5 17.4 2.4 19.9 10.9s-2.4 17.4-10.9 19.9z"
    ]
};
var $d8206b3ab2e65c05$export$280300af4baa1a3e = {
    prefix: "fas",
    iconName: "head-side-mask",
    icon: [
        576,
        512,
        [],
        "e063",
        "M32 224.2c0-22.2 3.2-43.6 9.2-63.9L262.2 321c-4 9.5-6.2 20-6.2 31V512H128c-17.7 0-32-14.3-32-32V407.3c0-16.7-6.9-32.5-17.1-45.8C48.6 322.4 32 274.1 32 224.2zm248.3 70.4L53 129.3C88.7 53 166.2 0 256 0h24c95.2 0 181.2 69.3 197.3 160.2c2.3 13 6.8 25.7 15.1 36l42 52.6c5.4 6.7 8.6 14.8 9.4 23.2H336c-21.7 0-41.3 8.6-55.7 22.6zM336 304H534l0 0h10l-19.7 64H368c-8.8 0-16 7.2-16 16s7.2 16 16 16H514.5l-9.8 32H368c-8.8 0-16 7.2-16 16s7.2 16 16 16H494.8l-.9 2.8c-8.3 26.9-33.1 45.2-61.2 45.2H288V352c0-14 6-26.7 15.6-35.4c0 0 0 0 0 0c8.5-7.8 19.9-12.6 32.4-12.6zm48-80a32 32 0 1 0 0-64 32 32 0 1 0 0 64z"
    ]
};
var $d8206b3ab2e65c05$export$b4c63e9bfc7906f1 = {
    prefix: "fas",
    iconName: "handshake",
    icon: [
        640,
        512,
        [],
        "f2b5",
        "M323.4 85.2l-96.8 78.4c-16.1 13-19.2 36.4-7 53.1c12.9 17.8 38 21.3 55.3 7.8l99.3-77.2c7-5.4 17-4.2 22.5 2.8s4.2 17-2.8 22.5l-20.9 16.2L512 316.8V128h-.7l-3.9-2.5L434.8 79c-15.3-9.8-33.2-15-51.4-15c-21.8 0-43 7.5-60 21.2zm22.8 124.4l-51.7 40.2C263 274.4 217.3 268 193.7 235.6c-22.2-30.5-16.6-73.1 12.7-96.8l83.2-67.3c-11.6-4.9-24.1-7.4-36.8-7.4C234 64 215.7 69.6 200 80l-72 48V352h28.2l91.4 83.4c19.6 17.9 49.9 16.5 67.8-3.1c5.5-6.1 9.2-13.2 11.1-20.6l17 15.6c19.5 17.9 49.9 16.6 67.8-2.9c4.5-4.9 7.8-10.6 9.9-16.5c19.4 13 45.8 10.3 62.1-7.5c17.9-19.5 16.6-49.9-2.9-67.8l-134.2-123zM16 128c-8.8 0-16 7.2-16 16V352c0 17.7 14.3 32 32 32H64c17.7 0 32-14.3 32-32V128H16zM48 320a16 16 0 1 1 0 32 16 16 0 1 1 0-32zM544 128V352c0 17.7 14.3 32 32 32h32c17.7 0 32-14.3 32-32V144c0-8.8-7.2-16-16-16H544zm32 208a16 16 0 1 1 32 0 16 16 0 1 1 -32 0z"
    ]
};
var $d8206b3ab2e65c05$export$31ee86ac717db552 = {
    prefix: "fas",
    iconName: "gem",
    icon: [
        512,
        512,
        [
            128142
        ],
        "f3a5",
        "M116.7 33.8c4.5-6.1 11.7-9.8 19.3-9.8H376c7.6 0 14.8 3.6 19.3 9.8l112 152c6.8 9.2 6.1 21.9-1.5 30.4l-232 256c-4.5 5-11 7.9-17.8 7.9s-13.2-2.9-17.8-7.9l-232-256c-7.7-8.5-8.3-21.2-1.5-30.4l112-152zm38.5 39.8c-3.3 2.5-4.2 7-2.1 10.5l57.4 95.6L63.3 192c-4.1 .3-7.3 3.8-7.3 8s3.2 7.6 7.3 8l192 16c.4 0 .9 0 1.3 0l192-16c4.1-.3 7.3-3.8 7.3-8s-3.2-7.6-7.3-8L301.5 179.8l57.4-95.6c2.1-3.5 1.2-8.1-2.1-10.5s-7.9-2-10.7 1L256 172.2 165.9 74.6c-2.8-3-7.4-3.4-10.7-1z"
    ]
};
var $d8206b3ab2e65c05$export$5879d0bca1aa497b = {
    prefix: "fas",
    iconName: "dolly",
    icon: [
        576,
        512,
        [
            "dolly-box"
        ],
        "f472",
        "M0 32C0 14.3 14.3 0 32 0h72.9c27.5 0 52 17.6 60.7 43.8L257.7 320c30.1 .5 56.8 14.9 74 37l202.1-67.4c16.8-5.6 34.9 3.5 40.5 20.2s-3.5 34.9-20.2 40.5L352 417.7c-.9 52.2-43.5 94.3-96 94.3c-53 0-96-43-96-96c0-30.8 14.5-58.2 37-75.8L104.9 64H32C14.3 64 0 49.7 0 32zM244.8 134.5c-5.5-16.8 3.7-34.9 20.5-40.3L311 79.4l19.8 60.9 60.9-19.8L371.8 59.6l45.7-14.8c16.8-5.5 34.9 3.7 40.3 20.5l49.4 152.2c5.5 16.8-3.7 34.9-20.5 40.3L334.5 307.2c-16.8 5.5-34.9-3.7-40.3-20.5L244.8 134.5z"
    ]
};
var $d8206b3ab2e65c05$export$461bbb9e92cc531b = $d8206b3ab2e65c05$export$5879d0bca1aa497b;
var $d8206b3ab2e65c05$export$c4ab83701fc591a5 = {
    prefix: "fas",
    iconName: "smoking",
    icon: [
        640,
        512,
        [
            128684
        ],
        "f48d",
        "M448 32V43c0 38.2 15.2 74.8 42.2 101.8l21 21c21 21 32.8 49.5 32.8 79.2v11c0 17.7-14.3 32-32 32s-32-14.3-32-32V245c0-12.7-5.1-24.9-14.1-33.9l-21-21C405.9 151.1 384 98.1 384 43V32c0-17.7 14.3-32 32-32s32 14.3 32 32zM576 256V245c0-38.2-15.2-74.8-42.2-101.8l-21-21c-21-21-32.8-49.5-32.8-79.2V32c0-17.7 14.3-32 32-32s32 14.3 32 32V43c0 12.7 5.1 24.9 14.1 33.9l21 21c39 39 60.9 91.9 60.9 147.1v11c0 17.7-14.3 32-32 32s-32-14.3-32-32zM0 416c0-35.3 28.7-64 64-64H416c17.7 0 32 14.3 32 32v96c0 17.7-14.3 32-32 32H64c-35.3 0-64-28.7-64-64V416zm224 0v32H384V416H224zm288-64c17.7 0 32 14.3 32 32v96c0 17.7-14.3 32-32 32s-32-14.3-32-32V384c0-17.7 14.3-32 32-32zm96 0c17.7 0 32 14.3 32 32v96c0 17.7-14.3 32-32 32s-32-14.3-32-32V384c0-17.7 14.3-32 32-32z"
    ]
};
var $d8206b3ab2e65c05$export$e0601b1f239fec74 = {
    prefix: "fas",
    iconName: "minimize",
    icon: [
        512,
        512,
        [
            "compress-arrows-alt"
        ],
        "f78c",
        "M456 224H312c-13.3 0-24-10.7-24-24V56c0-9.7 5.8-18.5 14.8-22.2s19.3-1.7 26.2 5.2l40 40L442.3 5.7C446 2 450.9 0 456 0s10 2 13.7 5.7l36.7 36.7C510 46 512 50.9 512 56s-2 10-5.7 13.7L433 143l40 40c6.9 6.9 8.9 17.2 5.2 26.2s-12.5 14.8-22.2 14.8zm0 64c9.7 0 18.5 5.8 22.2 14.8s1.7 19.3-5.2 26.2l-40 40 73.4 73.4c3.6 3.6 5.7 8.5 5.7 13.7s-2 10-5.7 13.7l-36.7 36.7C466 510 461.1 512 456 512s-10-2-13.7-5.7L369 433l-40 40c-6.9 6.9-17.2 8.9-26.2 5.2s-14.8-12.5-14.8-22.2V312c0-13.3 10.7-24 24-24H456zm-256 0c13.3 0 24 10.7 24 24V456c0 9.7-5.8 18.5-14.8 22.2s-19.3 1.7-26.2-5.2l-40-40L69.7 506.3C66 510 61.1 512 56 512s-10-2-13.7-5.7L5.7 469.7C2 466 0 461.1 0 456s2-10 5.7-13.7L79 369 39 329c-6.9-6.9-8.9-17.2-5.2-26.2s12.5-14.8 22.2-14.8H200zM56 224c-9.7 0-18.5-5.8-22.2-14.8s-1.7-19.3 5.2-26.2l40-40L5.7 69.7C2 66 0 61.1 0 56s2-10 5.7-13.7L42.3 5.7C46 2 50.9 0 56 0s10 2 13.7 5.7L143 79l40-40c6.9-6.9 17.2-8.9 26.2-5.2s14.8 12.5 14.8 22.2V200c0 13.3-10.7 24-24 24H56z"
    ]
};
var $d8206b3ab2e65c05$export$39205db0ea980efd = $d8206b3ab2e65c05$export$e0601b1f239fec74;
var $d8206b3ab2e65c05$export$6f9b0bfc012deb25 = {
    prefix: "fas",
    iconName: "monument",
    icon: [
        384,
        512,
        [],
        "f5a6",
        "M180.7 4.7c6.2-6.2 16.4-6.2 22.6 0l80 80c2.5 2.5 4.1 5.8 4.6 9.3l40.2 322H55.9L96.1 94c.4-3.5 2-6.8 4.6-9.3l80-80zM152 272c-13.3 0-24 10.7-24 24s10.7 24 24 24h80c13.3 0 24-10.7 24-24s-10.7-24-24-24H152zM32 448H352c17.7 0 32 14.3 32 32s-14.3 32-32 32H32c-17.7 0-32-14.3-32-32s14.3-32 32-32z"
    ]
};
var $d8206b3ab2e65c05$export$695fae58f55c3a87 = {
    prefix: "fas",
    iconName: "snowplow",
    icon: [
        640,
        512,
        [],
        "f7d2",
        "M298.9 64l68.6 160H256l-64-64V64H298.9zM445.1 242.7l-87.4-204C347.6 15.3 324.5 0 298.9 0H176c-26.5 0-48 21.5-48 48V160H96c-17.7 0-32 14.3-32 32V298.8C26.2 316.8 0 355.3 0 400c0 61.9 50.1 112 112 112H368c61.9 0 112-50.1 112-112c0-17.2-3.9-33.5-10.8-48H512v50.7c0 17 6.7 33.3 18.7 45.3l54.6 54.6c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L576 402.7V320 235.2L633 164c11-13.8 8.8-33.9-5-45s-33.9-8.8-45 5l-57 71.2c-9.1 11.3-14 25.4-14 40V288H448V256.7c.1-2.4-.2-4.8-.6-7.1s-1.2-4.7-2.2-6.8zM368 352c26.5 0 48 21.5 48 48s-21.5 48-48 48H112c-26.5 0-48-21.5-48-48s21.5-48 48-48H368zM144 400a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zm216 24a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm-56-24a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zM200 424a24 24 0 1 0 0-48 24 24 0 1 0 0 48z"
    ]
};
var $d8206b3ab2e65c05$export$48b60f1720e09944 = {
    prefix: "fas",
    iconName: "angles-right",
    icon: [
        512,
        512,
        [
            187,
            "angle-double-right"
        ],
        "f101",
        "M470.6 278.6c12.5-12.5 12.5-32.8 0-45.3l-160-160c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3L402.7 256 265.4 393.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0l160-160zm-352 160l160-160c12.5-12.5 12.5-32.8 0-45.3l-160-160c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3L210.7 256 73.4 393.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0z"
    ]
};
var $d8206b3ab2e65c05$export$792931403404faf0 = $d8206b3ab2e65c05$export$48b60f1720e09944;
var $d8206b3ab2e65c05$export$8ec2f752344b69bd = {
    prefix: "fas",
    iconName: "cannabis",
    icon: [
        512,
        512,
        [],
        "f55f",
        "M256 0c5.3 0 10.3 2.7 13.3 7.1c15.8 23.5 36.7 63.7 49.2 109c7.2 26.4 11.8 55.2 10.4 84c11.5-8.8 23.7-16.7 35.8-23.6c41-23.3 84.4-36.9 112.2-42.5c5.2-1 10.7 .6 14.4 4.4s5.4 9.2 4.4 14.5c-5.6 27.7-19.3 70.9-42.7 111.7c-9.1 15.9-19.9 31.7-32.4 46.3c27.8 6.6 52.4 17.3 67.2 25.5c5.1 2.8 8.2 8.2 8.2 14s-3.2 11.2-8.2 14c-15.2 8.4-40.9 19.5-69.8 26.1c-20.2 4.6-42.9 7.2-65.2 4.6l8.3 33.1c1.5 6.1-.6 12.4-5.5 16.4s-11.6 4.6-17.2 1.9L280 417.2V488c0 13.3-10.7 24-24 24s-24-10.7-24-24V417.2l-58.5 29.1c-5.6 2.8-12.3 2.1-17.2-1.9s-7-10.3-5.5-16.4l8.3-33.1c-22.2 2.6-45 0-65.2-4.6c-28.9-6.6-54.6-17.6-69.8-26.1c-5.1-2.8-8.2-8.2-8.2-14s3.2-11.2 8.2-14c14.8-8.2 39.4-18.8 67.2-25.5C78.9 296.3 68.1 280.5 59 264.6c-23.4-40.8-37.1-84-42.7-111.7c-1.1-5.2 .6-10.7 4.4-14.5s9.2-5.4 14.4-4.4c27.9 5.5 71.2 19.2 112.2 42.5c12.1 6.9 24.3 14.7 35.8 23.6c-1.4-28.7 3.1-57.6 10.4-84c12.5-45.3 33.4-85.5 49.2-109c3-4.4 8-7.1 13.3-7.1z"
    ]
};
var $d8206b3ab2e65c05$export$86c4e45dc3302d15 = {
    prefix: "fas",
    iconName: "circle-play",
    icon: [
        512,
        512,
        [
            61469,
            "play-circle"
        ],
        "f144",
        "M0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zM188.3 147.1c-7.6 4.2-12.3 12.3-12.3 20.9V344c0 8.7 4.7 16.7 12.3 20.9s16.8 4.1 24.3-.5l144-88c7.1-4.4 11.5-12.1 11.5-20.5s-4.4-16.1-11.5-20.5l-144-88c-7.4-4.5-16.7-4.7-24.3-.5z"
    ]
};
var $d8206b3ab2e65c05$export$cf04333781061c5e = $d8206b3ab2e65c05$export$86c4e45dc3302d15;
var $d8206b3ab2e65c05$export$bed2b0ed4ae45e0d = {
    prefix: "fas",
    iconName: "tablets",
    icon: [
        640,
        512,
        [],
        "f490",
        "M614.3 247c16.3-25 25.7-54.9 25.7-87C640 71.6 568.4 0 480 0c-32.1 0-61.9 9.4-87 25.7c-7.9 5.2-8.5 16.2-1.8 22.9L591.4 248.8c6.7 6.7 17.8 6.2 22.9-1.8zM567 294.3c7.9-5.2 8.5-16.2 1.8-22.9L368.6 71.2c-6.7-6.7-17.8-6.2-22.9 1.8c-16.3 25-25.7 54.9-25.7 87c0 88.4 71.6 160 160 160c32.1 0 61.9-9.4 87-25.7zM301.5 368H18.5c-9.5 0-16.9 8.2-15 17.5C18.9 457.8 83.1 512 160 512s141.1-54.2 156.5-126.5c2-9.3-5.5-17.5-15-17.5zm0-32c9.5 0 16.9-8.2 15-17.5C301.1 246.2 236.9 192 160 192S18.9 246.2 3.5 318.5c-2 9.3 5.5 17.5 15 17.5H301.5z"
    ]
};
var $d8206b3ab2e65c05$export$6bad2c9f317b52e5 = {
    prefix: "fas",
    iconName: "ethernet",
    icon: [
        512,
        512,
        [],
        "f796",
        "M0 224V416c0 17.7 14.3 32 32 32H96V336c0-8.8 7.2-16 16-16s16 7.2 16 16V448h64V336c0-8.8 7.2-16 16-16s16 7.2 16 16V448h64V336c0-8.8 7.2-16 16-16s16 7.2 16 16V448h64V336c0-8.8 7.2-16 16-16s16 7.2 16 16V448h64c17.7 0 32-14.3 32-32V224c0-17.7-14.3-32-32-32H448V160c0-17.7-14.3-32-32-32H384V96c0-17.7-14.3-32-32-32H160c-17.7 0-32 14.3-32 32v32H96c-17.7 0-32 14.3-32 32v32H32c-17.7 0-32 14.3-32 32z"
    ]
};
var $d8206b3ab2e65c05$export$902a3969bb113dff = {
    prefix: "fas",
    iconName: "euro-sign",
    icon: [
        320,
        512,
        [
            8364,
            "eur",
            "euro"
        ],
        "f153",
        "M48.1 240c-.1 2.7-.1 5.3-.1 8v16c0 2.7 0 5.3 .1 8H32c-17.7 0-32 14.3-32 32s14.3 32 32 32H60.3C89.9 419.9 170 480 264 480h24c17.7 0 32-14.3 32-32s-14.3-32-32-32H264c-57.9 0-108.2-32.4-133.9-80H256c17.7 0 32-14.3 32-32s-14.3-32-32-32H112.2c-.1-2.6-.2-5.3-.2-8V248c0-2.7 .1-5.4 .2-8H256c17.7 0 32-14.3 32-32s-14.3-32-32-32H130.1c25.7-47.6 76-80 133.9-80h24c17.7 0 32-14.3 32-32s-14.3-32-32-32H264C170 32 89.9 92.1 60.3 176H32c-17.7 0-32 14.3-32 32s14.3 32 32 32H48.1z"
    ]
};
var $d8206b3ab2e65c05$export$4b859160cfeb12ff = $d8206b3ab2e65c05$export$902a3969bb113dff;
var $d8206b3ab2e65c05$export$bdabbefede2d3a2 = $d8206b3ab2e65c05$export$902a3969bb113dff;
var $d8206b3ab2e65c05$export$a339864ee3df7e9a = {
    prefix: "fas",
    iconName: "chair",
    icon: [
        448,
        512,
        [
            129681
        ],
        "f6c0",
        "M248 48V256h48V58.7c23.9 13.8 40 39.7 40 69.3V256h48V128C384 57.3 326.7 0 256 0H192C121.3 0 64 57.3 64 128V256h48V128c0-29.6 16.1-55.5 40-69.3V256h48V48h48zM48 288c-12.1 0-23.2 6.8-28.6 17.7l-16 32c-5 9.9-4.4 21.7 1.4 31.1S20.9 384 32 384l0 96c0 17.7 14.3 32 32 32s32-14.3 32-32V384H352v96c0 17.7 14.3 32 32 32s32-14.3 32-32V384c11.1 0 21.4-5.7 27.2-15.2s6.4-21.2 1.4-31.1l-16-32C423.2 294.8 412.1 288 400 288H48z"
    ]
};
var $d8206b3ab2e65c05$export$c2e9877668862374 = {
    prefix: "fas",
    iconName: "circle-check",
    icon: [
        512,
        512,
        [
            61533,
            "check-circle"
        ],
        "f058",
        "M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM369 209L241 337c-9.4 9.4-24.6 9.4-33.9 0l-64-64c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l47 47L335 175c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9z"
    ]
};
var $d8206b3ab2e65c05$export$be9e388158c74f29 = $d8206b3ab2e65c05$export$c2e9877668862374;
var $d8206b3ab2e65c05$export$229de76dfef2687f = {
    prefix: "fas",
    iconName: "circle-stop",
    icon: [
        512,
        512,
        [
            62094,
            "stop-circle"
        ],
        "f28d",
        "M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM192 160H320c17.7 0 32 14.3 32 32V320c0 17.7-14.3 32-32 32H192c-17.7 0-32-14.3-32-32V192c0-17.7 14.3-32 32-32z"
    ]
};
var $d8206b3ab2e65c05$export$47af2aad60ab3e7c = $d8206b3ab2e65c05$export$229de76dfef2687f;
var $d8206b3ab2e65c05$export$aaaddd2cf7e20f64 = {
    prefix: "fas",
    iconName: "compass-drafting",
    icon: [
        512,
        512,
        [
            "drafting-compass"
        ],
        "f568",
        "M352 96c0 14.3-3.1 27.9-8.8 40.2L396 227.4c-23.7 25.3-54.2 44.1-88.5 53.6L256 192h0 0l-68 117.5c21.5 6.8 44.3 10.5 68.1 10.5c70.7 0 133.8-32.7 174.9-84c11.1-13.8 31.2-16 45-5s16 31.2 5 45C428.1 341.8 347 384 256 384c-35.4 0-69.4-6.4-100.7-18.1L98.7 463.7C94 471.8 87 478.4 78.6 482.6L23.2 510.3c-5 2.5-10.9 2.2-15.6-.7S0 501.5 0 496V440.6c0-8.4 2.2-16.7 6.5-24.1l60-103.7C53.7 301.6 41.8 289.3 31.2 276c-11.1-13.8-8.8-33.9 5-45s33.9-8.8 45 5c5.7 7.1 11.8 13.8 18.2 20.1l69.4-119.9c-5.6-12.2-8.8-25.8-8.8-40.2c0-53 43-96 96-96s96 43 96 96zm21 297.9c32.6-12.8 62.5-30.8 88.9-52.9l43.7 75.5c4.2 7.3 6.5 15.6 6.5 24.1V496c0 5.5-2.9 10.7-7.6 13.6s-10.6 3.2-15.6 .7l-55.4-27.7c-8.4-4.2-15.4-10.8-20.1-18.9L373 393.9zM256 128a32 32 0 1 0 0-64 32 32 0 1 0 0 64z"
    ]
};
var $d8206b3ab2e65c05$export$c8c2b127d13b9d79 = $d8206b3ab2e65c05$export$aaaddd2cf7e20f64;
var $d8206b3ab2e65c05$export$2eff9f6cbe00a643 = {
    prefix: "fas",
    iconName: "plate-wheat",
    icon: [
        512,
        512,
        [],
        "e55a",
        "M176 32c44.2 0 80 35.8 80 80v16c0 8.8-7.2 16-16 16c-44.2 0-80-35.8-80-80V48c0-8.8 7.2-16 16-16zM56 64h48c13.3 0 24 10.7 24 24s-10.7 24-24 24H56c-13.3 0-24-10.7-24-24s10.7-24 24-24zM24 136H136c13.3 0 24 10.7 24 24s-10.7 24-24 24H24c-13.3 0-24-10.7-24-24s10.7-24 24-24zm8 96c0-13.3 10.7-24 24-24h48c13.3 0 24 10.7 24 24s-10.7 24-24 24H56c-13.3 0-24-10.7-24-24zM272 48c0-8.8 7.2-16 16-16c44.2 0 80 35.8 80 80v16c0 8.8-7.2 16-16 16c-44.2 0-80-35.8-80-80V48zM400 32c44.2 0 80 35.8 80 80v16c0 8.8-7.2 16-16 16c-44.2 0-80-35.8-80-80V48c0-8.8 7.2-16 16-16zm80 160v16c0 44.2-35.8 80-80 80c-8.8 0-16-7.2-16-16V256c0-44.2 35.8-80 80-80c8.8 0 16 7.2 16 16zM352 176c8.8 0 16 7.2 16 16v16c0 44.2-35.8 80-80 80c-8.8 0-16-7.2-16-16V256c0-44.2 35.8-80 80-80zm-96 16v16c0 44.2-35.8 80-80 80c-8.8 0-16-7.2-16-16V256c0-44.2 35.8-80 80-80c8.8 0 16 7.2 16 16zM3.5 347.6C1.6 332.9 13 320 27.8 320H484.2c14.8 0 26.2 12.9 24.4 27.6C502.3 397.8 464.2 437 416 446v2c0 17.7-14.3 32-32 32H128c-17.7 0-32-14.3-32-32v-2c-48.2-9-86.3-48.2-92.5-98.4z"
    ]
};
var $d8206b3ab2e65c05$export$78792ed87d92a3ad = {
    prefix: "fas",
    iconName: "icicles",
    icon: [
        512,
        512,
        [],
        "f7ad",
        "M75.8 304.8L1 35.7c-.7-2.5-1-5-1-7.5C0 12.6 12.6 0 28.2 0H482.4C498.8 0 512 13.2 512 29.6c0 1.6-.1 3.3-.4 4.9L434.6 496.1c-1.5 9.2-9.5 15.9-18.8 15.9c-9.2 0-17.1-6.6-18.7-15.6L336 160 307.2 303.9c-1.9 9.3-10.1 16.1-19.6 16.1c-9.2 0-17.2-6.2-19.4-15.1L240 192 210.6 368.2c-1.5 9.1-9.4 15.8-18.6 15.8s-17.1-6.7-18.6-15.8L144 192 115.9 304.3c-2.3 9.2-10.6 15.7-20.1 15.7c-9.3 0-17.5-6.2-20-15.2z"
    ]
};
var $d8206b3ab2e65c05$export$d359c2cc7640953c = {
    prefix: "fas",
    iconName: "person-shelter",
    icon: [
        512,
        512,
        [],
        "e54f",
        "M271.9 4.2c-9.8-5.6-21.9-5.6-31.8 0l-224 128C6.2 137.9 0 148.5 0 160V480c0 17.7 14.3 32 32 32s32-14.3 32-32V178.6L256 68.9 448 178.6V480c0 17.7 14.3 32 32 32s32-14.3 32-32V160c0-11.5-6.2-22.1-16.1-27.8l-224-128zM256 208a40 40 0 1 0 0-80 40 40 0 1 0 0 80zm-8 280V400h16v88c0 13.3 10.7 24 24 24s24-10.7 24-24V313.5l26.9 49.9c6.3 11.7 20.8 16 32.5 9.8s16-20.8 9.8-32.5l-37.9-70.3c-15.3-28.5-45.1-46.3-77.5-46.3H246.2c-32.4 0-62.1 17.8-77.5 46.3l-37.9 70.3c-6.3 11.7-1.9 26.2 9.8 32.5s26.2 1.9 32.5-9.8L200 313.5V488c0 13.3 10.7 24 24 24s24-10.7 24-24z"
    ]
};
var $d8206b3ab2e65c05$export$771cf879fba0cf93 = {
    prefix: "fas",
    iconName: "neuter",
    icon: [
        384,
        512,
        [
            9906
        ],
        "f22c",
        "M80 176a112 112 0 1 1 224 0A112 112 0 1 1 80 176zM224 349.1c81.9-15 144-86.8 144-173.1C368 78.8 289.2 0 192 0S16 78.8 16 176c0 86.3 62.1 158.1 144 173.1V480c0 17.7 14.3 32 32 32s32-14.3 32-32V349.1z"
    ]
};
var $d8206b3ab2e65c05$export$a75288855ea05282 = {
    prefix: "fas",
    iconName: "id-badge",
    icon: [
        384,
        512,
        [],
        "f2c1",
        "M64 0C28.7 0 0 28.7 0 64V448c0 35.3 28.7 64 64 64H320c35.3 0 64-28.7 64-64V64c0-35.3-28.7-64-64-64H64zm96 320h64c44.2 0 80 35.8 80 80c0 8.8-7.2 16-16 16H96c-8.8 0-16-7.2-16-16c0-44.2 35.8-80 80-80zm-32-96a64 64 0 1 1 128 0 64 64 0 1 1 -128 0zM144 64h96c8.8 0 16 7.2 16 16s-7.2 16-16 16H144c-8.8 0-16-7.2-16-16s7.2-16 16-16z"
    ]
};
var $d8206b3ab2e65c05$export$e6789173649caa25 = {
    prefix: "fas",
    iconName: "marker",
    icon: [
        512,
        512,
        [],
        "f5a1",
        "M481 31C445.1-4.8 386.9-4.8 351 31l-15 15L322.9 33C294.8 4.9 249.2 4.9 221.1 33L135 119c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0L255 66.9c9.4-9.4 24.6-9.4 33.9 0L302.1 80 186.3 195.7 316.3 325.7 481 161c35.9-35.9 35.9-94.1 0-129.9zM293.7 348.3L163.7 218.3 99.5 282.5c-48 48-80.8 109.2-94.1 175.8l-5 25c-1.6 7.9 .9 16 6.6 21.7s13.8 8.1 21.7 6.6l25-5c66.6-13.3 127.8-46.1 175.8-94.1l64.2-64.2z"
    ]
};
var $d8206b3ab2e65c05$export$3f2d51c0547bf984 = {
    prefix: "fas",
    iconName: "face-laugh-beam",
    icon: [
        512,
        512,
        [
            128513,
            "laugh-beam"
        ],
        "f59a",
        "M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM96.8 314.1c-3.8-13.7 7.4-26.1 21.6-26.1H393.6c14.2 0 25.5 12.4 21.6 26.1C396.2 382 332.1 432 256 432s-140.2-50-159.2-117.9zM217.6 212.8l0 0 0 0-.2-.2c-.2-.2-.4-.5-.7-.9c-.6-.8-1.6-2-2.8-3.4c-2.5-2.8-6-6.6-10.2-10.3c-8.8-7.8-18.8-14-27.7-14s-18.9 6.2-27.7 14c-4.2 3.7-7.7 7.5-10.2 10.3c-1.2 1.4-2.2 2.6-2.8 3.4c-.3 .4-.6 .7-.7 .9l-.2 .2 0 0 0 0 0 0c-2.1 2.8-5.7 3.9-8.9 2.8s-5.5-4.1-5.5-7.6c0-17.9 6.7-35.6 16.6-48.8c9.8-13 23.9-23.2 39.4-23.2s29.6 10.2 39.4 23.2c9.9 13.2 16.6 30.9 16.6 48.8c0 3.4-2.2 6.5-5.5 7.6s-6.9 0-8.9-2.8l0 0 0 0zm160 0l0 0-.2-.2c-.2-.2-.4-.5-.7-.9c-.6-.8-1.6-2-2.8-3.4c-2.5-2.8-6-6.6-10.2-10.3c-8.8-7.8-18.8-14-27.7-14s-18.9 6.2-27.7 14c-4.2 3.7-7.7 7.5-10.2 10.3c-1.2 1.4-2.2 2.6-2.8 3.4c-.3 .4-.6 .7-.7 .9l-.2 .2 0 0 0 0 0 0c-2.1 2.8-5.7 3.9-8.9 2.8s-5.5-4.1-5.5-7.6c0-17.9 6.7-35.6 16.6-48.8c9.8-13 23.9-23.2 39.4-23.2s29.6 10.2 39.4 23.2c9.9 13.2 16.6 30.9 16.6 48.8c0 3.4-2.2 6.5-5.5 7.6s-6.9 0-8.9-2.8l0 0 0 0 0 0z"
    ]
};
var $d8206b3ab2e65c05$export$a88d1f4073ea9369 = $d8206b3ab2e65c05$export$3f2d51c0547bf984;
var $d8206b3ab2e65c05$export$2a66e6044c1f7036 = {
    prefix: "fas",
    iconName: "helicopter-symbol",
    icon: [
        512,
        512,
        [],
        "e502",
        "M445.3 224H510C495.6 108.2 403.8 16.4 288 2V66.7C368.4 80.1 431.9 143.6 445.3 224zM510 288H445.3C431.9 368.4 368.4 431.9 288 445.4V510c115.8-14.4 207.6-106.2 222-222zM2 288C16.4 403.8 108.2 495.6 224 510V445.4C143.6 431.9 80.1 368.4 66.7 288H2zm0-64H66.7C80.1 143.6 143.6 80.1 224 66.7V2C108.2 16.4 16.4 108.2 2 224zm206-64c0-17.7-14.3-32-32-32s-32 14.3-32 32V352c0 17.7 14.3 32 32 32s32-14.3 32-32V288h96v64c0 17.7 14.3 32 32 32s32-14.3 32-32V160c0-17.7-14.3-32-32-32s-32 14.3-32 32v64H208V160z"
    ]
};
var $d8206b3ab2e65c05$export$e119aada7f690d05 = {
    prefix: "fas",
    iconName: "universal-access",
    icon: [
        512,
        512,
        [],
        "f29a",
        "M0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm161.5-86.1c-12.2-5.2-26.3 .4-31.5 12.6s.4 26.3 12.6 31.5l11.9 5.1c17.3 7.4 35.2 12.9 53.6 16.3v50.1c0 4.3-.7 8.6-2.1 12.6l-28.7 86.1c-4.2 12.6 2.6 26.2 15.2 30.4s26.2-2.6 30.4-15.2l24.4-73.2c1.3-3.8 4.8-6.4 8.8-6.4s7.6 2.6 8.8 6.4l24.4 73.2c4.2 12.6 17.8 19.4 30.4 15.2s19.4-17.8 15.2-30.4l-28.7-86.1c-1.4-4.1-2.1-8.3-2.1-12.6V235.5c18.4-3.5 36.3-8.9 53.6-16.3l11.9-5.1c12.2-5.2 17.8-19.3 12.6-31.5s-19.3-17.8-31.5-12.6L338.7 175c-26.1 11.2-54.2 17-82.7 17s-56.5-5.8-82.7-17l-11.9-5.1zM256 160a40 40 0 1 0 0-80 40 40 0 1 0 0 80z"
    ]
};
var $d8206b3ab2e65c05$export$7b69b3617b84259b = {
    prefix: "fas",
    iconName: "circle-chevron-up",
    icon: [
        512,
        512,
        [
            "chevron-circle-up"
        ],
        "f139",
        "M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM377 271c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0l-87-87-87 87c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9L239 167c9.4-9.4 24.6-9.4 33.9 0L377 271z"
    ]
};
var $d8206b3ab2e65c05$export$b786cf5db03f2c36 = $d8206b3ab2e65c05$export$7b69b3617b84259b;
var $d8206b3ab2e65c05$export$d317bc452442782d = {
    prefix: "fas",
    iconName: "lari-sign",
    icon: [
        384,
        512,
        [],
        "e1c8",
        "M144 32c17.7 0 32 14.3 32 32V96.7c5.3-.4 10.6-.7 16-.7s10.7 .2 16 .7V64c0-17.7 14.3-32 32-32s32 14.3 32 32v49.4c54.9 25.2 95.8 75.5 108.2 136.2c3.5 17.3-7.7 34.2-25 37.7s-34.2-7.7-37.7-25c-6.1-29.9-22.5-55.9-45.4-74.3V256c0 17.7-14.3 32-32 32s-32-14.3-32-32V161c-5.2-.7-10.6-1-16-1s-10.8 .3-16 1v95c0 17.7-14.3 32-32 32s-32-14.3-32-32V188.1C82.7 211.5 64 247.6 64 288c0 70.7 57.3 128 128 128H352c17.7 0 32 14.3 32 32s-14.3 32-32 32H192 32c-17.7 0-32-14.3-32-32s14.3-32 32-32H48.9C18.5 382 0 337.2 0 288c0-77.5 45.9-144.3 112-174.6V64c0-17.7 14.3-32 32-32z"
    ]
};
var $d8206b3ab2e65c05$export$bae30a76735500e1 = {
    prefix: "fas",
    iconName: "volcano",
    icon: [
        512,
        512,
        [
            127755
        ],
        "f770",
        "M160 144c-35.3 0-64-28.7-64-64s28.7-64 64-64c15.7 0 30 5.6 41.2 15C212.4 12.4 232.7 0 256 0s43.6 12.4 54.8 31C322 21.6 336.3 16 352 16c35.3 0 64 28.7 64 64s-28.7 64-64 64c-14.7 0-28.3-5-39.1-13.3l-32 48C275.3 187 266 192 256 192s-19.3-5-24.9-13.3l-32-48C188.3 139 174.7 144 160 144zM144 352l48.4-24.2c10.2-5.1 21.6-7.8 33-7.8c19.6 0 38.4 7.8 52.2 21.6l32.5 32.5c6.3 6.3 14.9 9.9 23.8 9.9c11.3 0 21.8-5.6 28-15l9.7-14.6-58.9-66.3c-9.1-10.2-22.2-16.1-35.9-16.1H235.1c-13.7 0-26.8 5.9-35.9 16.1l-59.9 67.4L144 352zm19.4-95.8c18.2-20.5 44.3-32.2 71.8-32.2h41.8c27.4 0 53.5 11.7 71.8 32.2l150.2 169c8.5 9.5 13.2 21.9 13.2 34.7c0 28.8-23.4 52.2-52.2 52.2H52.2C23.4 512 0 488.6 0 459.8c0-12.8 4.7-25.1 13.2-34.7l150.2-169z"
    ]
};
var $d8206b3ab2e65c05$export$a1d09c95bee8043b = {
    prefix: "fas",
    iconName: "person-walking-dashed-line-arrow-right",
    icon: [
        640,
        512,
        [],
        "e553",
        "M208 96a48 48 0 1 0 0-96 48 48 0 1 0 0 96zM123.7 200.5c1-.4 1.9-.8 2.9-1.2l-16.9 63.5c-5.6 21.1-.1 43.6 14.7 59.7l70.7 77.1 22 88.1c4.3 17.1 21.7 27.6 38.8 23.3s27.6-21.7 23.3-38.8l-23-92.1c-1.9-7.8-5.8-14.9-11.2-20.8l-49.5-54 19.3-65.5 9.6 23c4.4 10.6 12.5 19.3 22.8 24.5l26.7 13.3c15.8 7.9 35 1.5 42.9-14.3s1.5-35-14.3-42.9L281 232.7l-15.3-36.8C248.5 154.8 208.3 128 163.7 128c-22.8 0-45.3 4.8-66.1 14l-8 3.5c-32.9 14.6-58.1 42.4-69.4 76.5l-2.6 7.8c-5.6 16.8 3.5 34.9 20.2 40.5s34.9-3.5 40.5-20.2l2.6-7.8c5.7-17.1 18.3-30.9 34.7-38.2l8-3.5zm-30 135.1L68.7 398 9.4 457.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0L116.3 441c4.6-4.6 8.2-10.1 10.6-16.1l14.5-36.2-40.7-44.4c-2.5-2.7-4.8-5.6-7-8.6zM550.6 153.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3L530.7 224H384c-17.7 0-32 14.3-32 32s14.3 32 32 32H530.7l-25.4 25.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0l80-80c12.5-12.5 12.5-32.8 0-45.3l-80-80zM392 0c-13.3 0-24 10.7-24 24V72c0 13.3 10.7 24 24 24s24-10.7 24-24V24c0-13.3-10.7-24-24-24zm24 152c0-13.3-10.7-24-24-24s-24 10.7-24 24v16c0 13.3 10.7 24 24 24s24-10.7 24-24V152zM392 320c-13.3 0-24 10.7-24 24v16c0 13.3 10.7 24 24 24s24-10.7 24-24V344c0-13.3-10.7-24-24-24zm24 120c0-13.3-10.7-24-24-24s-24 10.7-24 24v48c0 13.3 10.7 24 24 24s24-10.7 24-24V440z"
    ]
};
var $d8206b3ab2e65c05$export$170c56774c8e7961 = {
    prefix: "fas",
    iconName: "sterling-sign",
    icon: [
        320,
        512,
        [
            163,
            "gbp",
            "pound-sign"
        ],
        "f154",
        "M112 160.4c0-35.5 28.8-64.4 64.4-64.4c6.9 0 13.8 1.1 20.4 3.3l81.2 27.1c16.8 5.6 34.9-3.5 40.5-20.2s-3.5-34.9-20.2-40.5L217 38.6c-13.1-4.4-26.8-6.6-40.6-6.6C105.5 32 48 89.5 48 160.4V224H32c-17.7 0-32 14.3-32 32s14.3 32 32 32H48v44.5c0 17.4-4.7 34.5-13.7 49.4L4.6 431.5c-5.9 9.9-6.1 22.2-.4 32.2S20.5 480 32 480H288c17.7 0 32-14.3 32-32s-14.3-32-32-32H88.5l.7-1.1C104.1 390 112 361.5 112 332.5V288H224c17.7 0 32-14.3 32-32s-14.3-32-32-32H112V160.4z"
    ]
};
var $d8206b3ab2e65c05$export$3d9479ec1d1ae83e = $d8206b3ab2e65c05$export$170c56774c8e7961;
var $d8206b3ab2e65c05$export$9ce041dfec8319b = $d8206b3ab2e65c05$export$170c56774c8e7961;
var $d8206b3ab2e65c05$export$ee194b18f5c6f6b6 = {
    prefix: "fas",
    iconName: "viruses",
    icon: [
        640,
        512,
        [],
        "e076",
        "M192 0c13.3 0 24 10.7 24 24V37.5c0 35.6 43.1 53.5 68.3 28.3l9.5-9.5c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9l-9.5 9.5C293 124.9 310.9 168 346.5 168H360c13.3 0 24 10.7 24 24s-10.7 24-24 24H346.5c-35.6 0-53.5 43.1-28.3 68.3l9.5 9.5c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0l-9.5-9.5C259.1 293 216 310.9 216 346.5V360c0 13.3-10.7 24-24 24s-24-10.7-24-24V346.5c0-35.6-43.1-53.5-68.3-28.3l-9.5 9.5c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l9.5-9.5C91 259.1 73.1 216 37.5 216H24c-13.3 0-24-10.7-24-24s10.7-24 24-24H37.5c35.6 0 53.5-43.1 28.3-68.3l-9.5-9.5c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l9.5 9.5C124.9 91 168 73.1 168 37.5V24c0-13.3 10.7-24 24-24zm48 224a16 16 0 1 0 0-32 16 16 0 1 0 0 32zm-48-64a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zm320 80c0 33 39.9 49.5 63.2 26.2c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6C574.5 312.1 591 352 624 352c8.8 0 16 7.2 16 16s-7.2 16-16 16c-33 0-49.5 39.9-26.2 63.2c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0C551.9 446.5 512 463 512 496c0 8.8-7.2 16-16 16s-16-7.2-16-16c0-33-39.9-49.5-63.2-26.2c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6C417.5 423.9 401 384 368 384c-8.8 0-16-7.2-16-16s7.2-16 16-16c33 0 49.5-39.9 26.2-63.2c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0C440.1 289.5 480 273 480 240c0-8.8 7.2-16 16-16s16 7.2 16 16zm0 112a32 32 0 1 0 -64 0 32 32 0 1 0 64 0z"
    ]
};
var $d8206b3ab2e65c05$export$8aaca358568da0e0 = {
    prefix: "fas",
    iconName: "square-person-confined",
    icon: [
        448,
        512,
        [],
        "e577",
        "M64 32C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64zm96 112a48 48 0 1 1 96 0 48 48 0 1 1 -96 0zm80 104c0-30.9 25.1-56 56-56s56 25.1 56 56V350.1c0 36.4-29.5 65.9-65.9 65.9c-17.5 0-34.3-6.9-46.6-19.3L184.8 342l-28.1 56.3c-7.9 15.8-27.1 22.2-42.9 14.3s-22.2-27.1-14.3-42.9l48-96c4.6-9.2 13.3-15.6 23.5-17.3s20.5 1.7 27.8 9L240 306.7V248z"
    ]
};
var $d8206b3ab2e65c05$export$48c51dda34e9f04c = {
    prefix: "fas",
    iconName: "user-tie",
    icon: [
        448,
        512,
        [],
        "f508",
        "M224 256A128 128 0 1 1 224 0a128 128 0 1 1 0 256zM209.1 359.2l-18.6-31c-6.4-10.7 1.3-24.2 13.7-24.2H224h19.7c12.4 0 20.1 13.6 13.7 24.2l-18.6 31 33.4 123.9 36-146.9c2-8.1 9.8-13.4 17.9-11.3c70.1 17.6 121.9 81 121.9 156.4c0 17-13.8 30.7-30.7 30.7H285.5c-2.1 0-4-.4-5.8-1.1l.3 1.1H168l.3-1.1c-1.8 .7-3.8 1.1-5.8 1.1H30.7C13.8 512 0 498.2 0 481.3c0-75.5 51.9-138.9 121.9-156.4c8.1-2 15.9 3.3 17.9 11.3l36 146.9 33.4-123.9z"
    ]
};
var $d8206b3ab2e65c05$export$5977e8de7e65b20 = {
    prefix: "fas",
    iconName: "arrow-down-long",
    icon: [
        384,
        512,
        [
            "long-arrow-down"
        ],
        "f175",
        "M169.4 502.6c12.5 12.5 32.8 12.5 45.3 0l128-128c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L224 402.7 224 32c0-17.7-14.3-32-32-32s-32 14.3-32 32l0 370.7L86.6 329.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3l128 128z"
    ]
};
var $d8206b3ab2e65c05$export$52ecf90b62f3f030 = $d8206b3ab2e65c05$export$5977e8de7e65b20;
var $d8206b3ab2e65c05$export$8a4f323f00a91606 = {
    prefix: "fas",
    iconName: "tent-arrow-down-to-line",
    icon: [
        640,
        512,
        [],
        "e57e",
        "M241.8 111.9c8.9 9.9 8.1 25-1.8 33.9l-80 72c-9.1 8.2-23 8.2-32.1 0l-80-72c-9.9-8.9-10.7-24-1.8-33.9s24-10.7 33.9-1.8l39.9 36L120 24c0-13.3 10.7-24 24-24s24 10.7 24 24l0 122.1 39.9-36c9.9-8.9 25-8.1 33.9 1.8zm122.8 22.6c11.5-8.7 27.3-8.7 38.8 0l168 128c6.6 5 11 12.5 12.3 20.7l24 160 .7 4.7c17.5 .2 31.6 14.4 31.6 32c0 17.7-14.3 32-32 32H32c-17.7 0-32-14.3-32-32s14.3-32 32-32H159.6l.7-4.7 24-160c1.2-8.2 5.6-15.7 12.3-20.7l168-128zM384 448h76.8L384 320V448z"
    ]
};
var $d8206b3ab2e65c05$export$a881f37164b11fbf = {
    prefix: "fas",
    iconName: "certificate",
    icon: [
        512,
        512,
        [],
        "f0a3",
        "M211 7.3C205 1 196-1.4 187.6 .8s-14.9 8.9-17.1 17.3L154.7 80.6l-62-17.5c-8.4-2.4-17.4 0-23.5 6.1s-8.5 15.1-6.1 23.5l17.5 62L18.1 170.6c-8.4 2.1-15 8.7-17.3 17.1S1 205 7.3 211l46.2 45L7.3 301C1 307-1.4 316 .8 324.4s8.9 14.9 17.3 17.1l62.5 15.8-17.5 62c-2.4 8.4 0 17.4 6.1 23.5s15.1 8.5 23.5 6.1l62-17.5 15.8 62.5c2.1 8.4 8.7 15 17.1 17.3s17.3-.2 23.4-6.4l45-46.2 45 46.2c6.1 6.2 15 8.7 23.4 6.4s14.9-8.9 17.1-17.3l15.8-62.5 62 17.5c8.4 2.4 17.4 0 23.5-6.1s8.5-15.1 6.1-23.5l-17.5-62 62.5-15.8c8.4-2.1 15-8.7 17.3-17.1s-.2-17.3-6.4-23.4l-46.2-45 46.2-45c6.2-6.1 8.7-15 6.4-23.4s-8.9-14.9-17.3-17.1l-62.5-15.8 17.5-62c2.4-8.4 0-17.4-6.1-23.5s-15.1-8.5-23.5-6.1l-62 17.5L341.4 18.1c-2.1-8.4-8.7-15-17.1-17.3S307 1 301 7.3L256 53.5 211 7.3z"
    ]
};
var $d8206b3ab2e65c05$export$ca6fd367f31ecbc5 = {
    prefix: "fas",
    iconName: "reply-all",
    icon: [
        576,
        512,
        [
            "mail-reply-all"
        ],
        "f122",
        "M209.4 39.5c-9.1-9.6-24.3-10-33.9-.9L33.8 173.2c-19.9 18.9-19.9 50.7 0 69.6L175.5 377.4c9.6 9.1 24.8 8.7 33.9-.9s8.7-24.8-.9-33.9L66.8 208 208.5 73.4c9.6-9.1 10-24.3 .9-33.9zM352 64c0-12.6-7.4-24.1-19-29.2s-25-3-34.4 5.4l-160 144c-6.7 6.1-10.6 14.7-10.6 23.8s3.9 17.7 10.6 23.8l160 144c9.4 8.5 22.9 10.6 34.4 5.4s19-16.6 19-29.2V288h32c53 0 96 43 96 96c0 30.4-12.8 47.9-22.2 56.7c-5.5 5.1-9.8 12-9.8 19.5c0 10.9 8.8 19.7 19.7 19.7c2.8 0 5.6-.6 8.1-1.9C494.5 467.9 576 417.3 576 304c0-97.2-78.8-176-176-176H352V64z"
    ]
};
var $d8206b3ab2e65c05$export$8274334f3a2c1841 = $d8206b3ab2e65c05$export$ca6fd367f31ecbc5;
var $d8206b3ab2e65c05$export$60710f3921019268 = {
    prefix: "fas",
    iconName: "suitcase",
    icon: [
        512,
        512,
        [
            129523
        ],
        "f0f2",
        "M176 56V96H336V56c0-4.4-3.6-8-8-8H184c-4.4 0-8 3.6-8 8zM128 96V56c0-30.9 25.1-56 56-56H328c30.9 0 56 25.1 56 56V96v32V480H128V128 96zM64 96H96V480H64c-35.3 0-64-28.7-64-64V160c0-35.3 28.7-64 64-64zM448 480H416V96h32c35.3 0 64 28.7 64 64V416c0 35.3-28.7 64-64 64z"
    ]
};
var $d8206b3ab2e65c05$export$f3854553fe688388 = {
    prefix: "fas",
    iconName: "person-skating",
    icon: [
        448,
        512,
        [
            "skating"
        ],
        "f7c5",
        "M352 48a48 48 0 1 1 96 0 48 48 0 1 1 -96 0zM128 128c0-17.7 14.3-32 32-32H319.4c43.6 0 64.6 53.4 32.8 83.1l-74.4 69.4 60.2 60.2c9 9 14.1 21.2 14.1 33.9V416c0 17.7-14.3 32-32 32s-32-14.3-32-32V349.3l-77.9-77.8c-26.6-26.6-24.6-70.3 4.3-94.4l20.4-17H160c-17.7 0-32-14.3-32-32zM81.4 353.4l86.9-86.9c4.6 10 11 19.3 19.3 27.5l21.8 21.8-82.7 82.7c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3zm322.5 95.1c8.6 2.1 13.8 10.8 11.6 19.4l-.4 1.7c-6.2 24.9-28.6 42.4-54.3 42.4H272c-8.8 0-16-7.2-16-16s7.2-16 16-16h88.8c11 0 20.6-7.5 23.3-18.2l.4-1.7c2.1-8.6 10.8-13.8 19.4-11.6zM135.2 478.3l-6.2 3.1c-21.6 10.8-47.6 6.6-64.6-10.5L4.7 411.3c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0l59.6 59.6c7.3 7.3 18.5 9.1 27.7 4.5l6.2-3.1c7.9-4 17.5-.7 21.5 7.2s.7 17.5-7.2 21.5z"
    ]
};
var $d8206b3ab2e65c05$export$21bd1d54bd4f2c5a = $d8206b3ab2e65c05$export$f3854553fe688388;
var $d8206b3ab2e65c05$export$3300e4b4d1d1936f = {
    prefix: "fas",
    iconName: "filter-circle-dollar",
    icon: [
        576,
        512,
        [
            "funnel-dollar"
        ],
        "f662",
        "M3.9 22.9C10.5 8.9 24.5 0 40 0H472c15.5 0 29.5 8.9 36.1 22.9s4.6 30.5-5.2 42.5L396.4 195.6C316.2 212.1 256 283 256 368c0 27.4 6.3 53.4 17.5 76.5c-1.6-.8-3.2-1.8-4.7-2.9l-64-48c-8.1-6-12.8-15.5-12.8-25.6V288.9L9 65.3C-.7 53.4-2.8 36.8 3.9 22.9zM288 368a144 144 0 1 1 288 0 144 144 0 1 1 -288 0zm120.8-32.6c.6-.9 1.8-2.1 4.2-3.4c5.1-2.7 12.5-4.1 18.7-4c8.2 .1 17.1 1.8 26.4 4.1c8.6 2.1 17.3-3.1 19.4-11.7s-3.1-17.3-11.7-19.4c-5.6-1.4-11.6-2.7-17.9-3.7V288c0-8.8-7.2-16-16-16s-16 7.2-16 16v9.5c-6.1 1.2-12.3 3.2-18 6.3c-11.8 6.3-23 18.4-21.8 37.2c1 16 11.7 25.3 21.6 30.7c8.8 4.7 19.7 7.8 28.6 10.3l1.8 .5c10.3 2.9 17.9 5.2 23.2 8.3c4.5 2.7 4.7 4.2 4.7 5.6c.1 2.4-.5 3.7-1 4.5c-.6 1-1.8 2.2-4 3.3c-4.7 2.5-11.8 3.8-18.5 3.6c-9.5-.3-18.5-3.1-29.9-6.8c-1.9-.6-3.8-1.2-5.8-1.8c-8.4-2.6-17.4 2.1-20 10.5s2.1 17.4 10.5 20c1.6 .5 3.3 1 5 1.6l0 0 0 0c7 2.3 15.1 4.8 23.7 6.6v11.4c0 8.8 7.2 16 16 16s16-7.2 16-16V438.7c6.2-1.1 12.5-3.1 18.3-6.2c12.1-6.5 22.3-18.7 21.7-36.9c-.5-16.2-10.3-26.3-20.5-32.3c-9.4-5.6-21.2-8.9-30.5-11.5l-.2 0c-10.4-2.9-18.3-5.2-23.9-8.2c-4.8-2.6-4.8-4-4.8-4.5l0-.1c-.1-1.9 .3-2.9 .8-3.6z"
    ]
};
var $d8206b3ab2e65c05$export$cebe38ad8f0a143d = $d8206b3ab2e65c05$export$3300e4b4d1d1936f;
var $d8206b3ab2e65c05$export$41dbdadc07a89b05 = {
    prefix: "fas",
    iconName: "camera-retro",
    icon: [
        512,
        512,
        [
            128247
        ],
        "f083",
        "M220.6 121.2L271.1 96 448 96v96H333.2c-21.9-15.1-48.5-24-77.2-24s-55.2 8.9-77.2 24H64V128H192c9.9 0 19.7-2.3 28.6-6.8zM0 128V416c0 35.3 28.7 64 64 64H448c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H271.1c-9.9 0-19.7 2.3-28.6 6.8L192 64H160V48c0-8.8-7.2-16-16-16H80c-8.8 0-16 7.2-16 16l0 16C28.7 64 0 92.7 0 128zM168 304a88 88 0 1 1 176 0 88 88 0 1 1 -176 0z"
    ]
};
var $d8206b3ab2e65c05$export$a30c52cde32bec7e = {
    prefix: "fas",
    iconName: "circle-arrow-down",
    icon: [
        512,
        512,
        [
            "arrow-circle-down"
        ],
        "f0ab",
        "M256 0a256 256 0 1 0 0 512A256 256 0 1 0 256 0zM127 281c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l71 71L232 136c0-13.3 10.7-24 24-24s24 10.7 24 24l0 182.1 71-71c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9L273 393c-9.4 9.4-24.6 9.4-33.9 0L127 281z"
    ]
};
var $d8206b3ab2e65c05$export$6cfa36bbb3a057 = $d8206b3ab2e65c05$export$a30c52cde32bec7e;
var $d8206b3ab2e65c05$export$d796c05153b1255c = {
    prefix: "fas",
    iconName: "file-import",
    icon: [
        512,
        512,
        [
            "arrow-right-to-file"
        ],
        "f56f",
        "M128 64c0-35.3 28.7-64 64-64H352V128c0 17.7 14.3 32 32 32H512V448c0 35.3-28.7 64-64 64H192c-35.3 0-64-28.7-64-64V336H302.1l-39 39c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l80-80c9.4-9.4 9.4-24.6 0-33.9l-80-80c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9l39 39H128V64zm0 224v48H24c-13.3 0-24-10.7-24-24s10.7-24 24-24H128zM512 128H384V0L512 128z"
    ]
};
var $d8206b3ab2e65c05$export$32f14beaf6294476 = $d8206b3ab2e65c05$export$d796c05153b1255c;
var $d8206b3ab2e65c05$export$38150b61dfd06fff = {
    prefix: "fas",
    iconName: "square-arrow-up-right",
    icon: [
        448,
        512,
        [
            "external-link-square"
        ],
        "f14c",
        "M384 32c35.3 0 64 28.7 64 64V416c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96C0 60.7 28.7 32 64 32H384zM160 144c-13.3 0-24 10.7-24 24s10.7 24 24 24h94.1L119 327c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l135-135V328c0 13.3 10.7 24 24 24s24-10.7 24-24V168c0-13.3-10.7-24-24-24H160z"
    ]
};
var $d8206b3ab2e65c05$export$e04d83fed5ebcebf = $d8206b3ab2e65c05$export$38150b61dfd06fff;
var $d8206b3ab2e65c05$export$9010ed816a8b9c97 = {
    prefix: "fas",
    iconName: "box-open",
    icon: [
        640,
        512,
        [],
        "f49e",
        "M58.9 42.1c3-6.1 9.6-9.6 16.3-8.7L320 64 564.8 33.4c6.7-.8 13.3 2.7 16.3 8.7l41.7 83.4c9 17.9-.6 39.6-19.8 45.1L439.6 217.3c-13.9 4-28.8-1.9-36.2-14.3L320 64 236.6 203c-7.4 12.4-22.3 18.3-36.2 14.3L37.1 170.6c-19.3-5.5-28.8-27.2-19.8-45.1L58.9 42.1zM321.1 128l54.9 91.4c14.9 24.8 44.6 36.6 72.5 28.6L576 211.6v167c0 22-15 41.2-36.4 46.6l-204.1 51c-10.2 2.6-20.9 2.6-31 0l-204.1-51C79 419.7 64 400.5 64 378.5v-167L191.6 248c27.8 8 57.6-3.8 72.5-28.6L318.9 128h2.2z"
    ]
};
var $d8206b3ab2e65c05$export$7c265716d4399676 = {
    prefix: "fas",
    iconName: "scroll",
    icon: [
        576,
        512,
        [
            128220
        ],
        "f70e",
        "M0 80v48c0 17.7 14.3 32 32 32H48 96V80c0-26.5-21.5-48-48-48S0 53.5 0 80zM112 32c10 13.4 16 30 16 48V384c0 35.3 28.7 64 64 64s64-28.7 64-64v-5.3c0-32.4 26.3-58.7 58.7-58.7H480V128c0-53-43-96-96-96H112zM464 480c61.9 0 112-50.1 112-112c0-8.8-7.2-16-16-16H314.7c-14.7 0-26.7 11.9-26.7 26.7V384c0 53-43 96-96 96H368h96z"
    ]
};
var $d8206b3ab2e65c05$export$f9a38ef7b046ab51 = {
    prefix: "fas",
    iconName: "spa",
    icon: [
        576,
        512,
        [],
        "f5bb",
        "M183.1 235.3c33.7 20.7 62.9 48.1 85.8 80.5c7 9.9 13.4 20.3 19.1 31c5.7-10.8 12.1-21.1 19.1-31c22.9-32.4 52.1-59.8 85.8-80.5C437.6 207.8 490.1 192 546 192h9.9c11.1 0 20.1 9 20.1 20.1C576 360.1 456.1 480 308.1 480H288 267.9C119.9 480 0 360.1 0 212.1C0 201 9 192 20.1 192H30c55.9 0 108.4 15.8 153.1 43.3zM301.5 37.6c15.7 16.9 61.1 71.8 84.4 164.6c-38 21.6-71.4 50.8-97.9 85.6c-26.5-34.8-59.9-63.9-97.9-85.6c23.2-92.8 68.6-147.7 84.4-164.6C278 33.9 282.9 32 288 32s10 1.9 13.5 5.6z"
    ]
};
var $d8206b3ab2e65c05$export$db853fbb474326cc = {
    prefix: "fas",
    iconName: "location-pin-lock",
    icon: [
        512,
        512,
        [],
        "e51f",
        "M215.7 499.2c11-13.8 25.1-31.7 40.3-52.3V352c0-23.7 12.9-44.4 32-55.4V272c0-55.6 40.5-101.7 93.6-110.5C367 70 287.7 0 192 0C86 0 0 86 0 192c0 87.4 117 243 168.3 307.2c12.3 15.3 35.1 15.3 47.4 0zM192 128a64 64 0 1 1 0 128 64 64 0 1 1 0-128zM400 240c17.7 0 32 14.3 32 32v48H368V272c0-17.7 14.3-32 32-32zm-80 32v48c-17.7 0-32 14.3-32 32V480c0 17.7 14.3 32 32 32H480c17.7 0 32-14.3 32-32V352c0-17.7-14.3-32-32-32V272c0-44.2-35.8-80-80-80s-80 35.8-80 80z"
    ]
};
var $d8206b3ab2e65c05$export$da79f048408b1722 = {
    prefix: "fas",
    iconName: "pause",
    icon: [
        320,
        512,
        [
            9208
        ],
        "f04c",
        "M48 64C21.5 64 0 85.5 0 112V400c0 26.5 21.5 48 48 48H80c26.5 0 48-21.5 48-48V112c0-26.5-21.5-48-48-48H48zm192 0c-26.5 0-48 21.5-48 48V400c0 26.5 21.5 48 48 48h32c26.5 0 48-21.5 48-48V112c0-26.5-21.5-48-48-48H240z"
    ]
};
var $d8206b3ab2e65c05$export$50d11c98c99e3b2d = {
    prefix: "fas",
    iconName: "hill-avalanche",
    icon: [
        576,
        512,
        [],
        "e507",
        "M439.7 401.9c34.2 23.1 81.1 19.5 111.4-10.8c34.4-34.4 34.4-90.1 0-124.4c-27.8-27.8-69.5-33.1-102.6-16c-11.8 6.1-16.4 20.6-10.3 32.3s20.6 16.4 32.3 10.3c15.1-7.8 34-5.3 46.6 7.3c15.6 15.6 15.6 40.9 0 56.6s-40.9 15.6-56.6 0l-81.7-81.7C401.2 261.3 416 236.4 416 208c0-33.9-21.1-62.9-50.9-74.5c1.9-6.8 2.9-14 2.9-21.5c0-44.2-35.8-80-80-80c-27.3 0-51.5 13.7-65.9 34.6C216.3 46.6 197.9 32 176 32c-26.5 0-48 21.5-48 48c0 4 .5 7.9 1.4 11.6L439.7 401.9zM480 64a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zm0 128a32 32 0 1 0 0-64 32 32 0 1 0 0 64zM68.3 87C43.1 61.8 0 79.7 0 115.3V432c0 44.2 35.8 80 80 80H396.7c35.6 0 53.5-43.1 28.3-68.3L68.3 87z"
    ]
};
var $d8206b3ab2e65c05$export$ac389bf5cc37feb5 = {
    prefix: "fas",
    iconName: "temperature-empty",
    icon: [
        320,
        512,
        [
            "temperature-0",
            "thermometer-0",
            "thermometer-empty"
        ],
        "f2cb",
        "M112 112c0-26.5 21.5-48 48-48s48 21.5 48 48V276.5c0 17.3 7.1 31.9 15.3 42.5C233.8 332.6 240 349.5 240 368c0 44.2-35.8 80-80 80s-80-35.8-80-80c0-18.5 6.2-35.4 16.7-48.9c8.2-10.6 15.3-25.2 15.3-42.5V112zM160 0C98.1 0 48 50.2 48 112V276.5c0 .1-.1 .3-.2 .6c-.2 .6-.8 1.6-1.7 2.8C27.2 304.2 16 334.8 16 368c0 79.5 64.5 144 144 144s144-64.5 144-144c0-33.2-11.2-63.8-30.1-88.1c-.9-1.2-1.5-2.2-1.7-2.8c-.1-.3-.2-.5-.2-.6V112C272 50.2 221.9 0 160 0zm0 416a48 48 0 1 0 0-96 48 48 0 1 0 0 96z"
    ]
};
var $d8206b3ab2e65c05$export$e99b7d2ccc282383 = $d8206b3ab2e65c05$export$ac389bf5cc37feb5;
var $d8206b3ab2e65c05$export$4c13a186ecce3b80 = $d8206b3ab2e65c05$export$ac389bf5cc37feb5;
var $d8206b3ab2e65c05$export$81a2f8298cf523f9 = $d8206b3ab2e65c05$export$ac389bf5cc37feb5;
var $d8206b3ab2e65c05$export$d59078f6e80b4a67 = {
    prefix: "fas",
    iconName: "bomb",
    icon: [
        512,
        512,
        [
            128163
        ],
        "f1e2",
        "M459.1 52.4L442.6 6.5C440.7 2.6 436.5 0 432.1 0s-8.5 2.6-10.4 6.5L405.2 52.4l-46 16.8c-4.3 1.6-7.3 5.9-7.2 10.4c0 4.5 3 8.7 7.2 10.2l45.7 16.8 16.8 45.8c1.5 4.4 5.8 7.5 10.4 7.5s8.9-3.1 10.4-7.5l16.5-45.8 45.7-16.8c4.2-1.5 7.2-5.7 7.2-10.2c0-4.6-3-8.9-7.2-10.4L459.1 52.4zm-132.4 53c-12.5-12.5-32.8-12.5-45.3 0l-2.9 2.9C256.5 100.3 232.7 96 208 96C93.1 96 0 189.1 0 304S93.1 512 208 512s208-93.1 208-208c0-24.7-4.3-48.5-12.2-70.5l2.9-2.9c12.5-12.5 12.5-32.8 0-45.3l-80-80zM200 192c-57.4 0-104 46.6-104 104v8c0 8.8-7.2 16-16 16s-16-7.2-16-16v-8c0-75.1 60.9-136 136-136h8c8.8 0 16 7.2 16 16s-7.2 16-16 16h-8z"
    ]
};
var $d8206b3ab2e65c05$export$5f519e9ac15ab8c3 = {
    prefix: "fas",
    iconName: "registered",
    icon: [
        512,
        512,
        [
            174
        ],
        "f25d",
        "M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM160 152c0-13.3 10.7-24 24-24h88c44.2 0 80 35.8 80 80c0 28-14.4 52.7-36.3 67l34.1 75.1c5.5 12.1 .1 26.3-11.9 31.8s-26.3 .1-31.8-11.9L268.9 288H208v72c0 13.3-10.7 24-24 24s-24-10.7-24-24V264 152zm48 88h64c17.7 0 32-14.3 32-32s-14.3-32-32-32H208v64z"
    ]
};
var $d8206b3ab2e65c05$export$6ea408c7266ed557 = {
    prefix: "fas",
    iconName: "address-card",
    icon: [
        576,
        512,
        [
            62140,
            "contact-card",
            "vcard"
        ],
        "f2bb",
        "M64 32C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H512c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64zm80 256h64c44.2 0 80 35.8 80 80c0 8.8-7.2 16-16 16H80c-8.8 0-16-7.2-16-16c0-44.2 35.8-80 80-80zm-32-96a64 64 0 1 1 128 0 64 64 0 1 1 -128 0zm256-32H496c8.8 0 16 7.2 16 16s-7.2 16-16 16H368c-8.8 0-16-7.2-16-16s7.2-16 16-16zm0 64H496c8.8 0 16 7.2 16 16s-7.2 16-16 16H368c-8.8 0-16-7.2-16-16s7.2-16 16-16zm0 64H496c8.8 0 16 7.2 16 16s-7.2 16-16 16H368c-8.8 0-16-7.2-16-16s7.2-16 16-16z"
    ]
};
var $d8206b3ab2e65c05$export$4ac51eb0b298b190 = $d8206b3ab2e65c05$export$6ea408c7266ed557;
var $d8206b3ab2e65c05$export$91228257deb1bf18 = $d8206b3ab2e65c05$export$6ea408c7266ed557;
var $d8206b3ab2e65c05$export$f4d7840209109993 = {
    prefix: "fas",
    iconName: "scale-unbalanced-flip",
    icon: [
        640,
        512,
        [
            "balance-scale-right"
        ],
        "f516",
        "M117.9 62.4c-16.8-5.6-25.8-23.7-20.2-40.5s23.7-25.8 40.5-20.2l113 37.7C265 15.8 290.7 0 320 0c44.2 0 80 35.8 80 80c0 3-.2 5.9-.5 8.8l122.6 40.9c16.8 5.6 25.8 23.7 20.2 40.5s-23.7 25.8-40.5 20.2L366.4 145.2c-4.5 3.2-9.3 5.9-14.4 8.2V480c0 17.7-14.3 32-32 32H128c-17.7 0-32-14.3-32-32s14.3-32 32-32H288V153.3c-21-9.2-37.2-27-44.2-49l-125.9-42zM200.4 288L128 163.8 55.6 288H200.4zM128 384C65.1 384 12.8 350 2 305.1c-2.6-11 1-22.3 6.7-32.1l95.2-163.2c5-8.6 14.2-13.8 24.1-13.8s19.1 5.3 24.1 13.8l95.2 163.2c5.7 9.8 9.3 21.1 6.7 32.1C243.2 350 190.9 384 128 384zm382.8-92.2L438.4 416H583.3L510.8 291.8zm126 141.3C626 478 573.7 512 510.8 512s-115.2-34-126-78.9c-2.6-11 1-22.3 6.7-32.1l95.2-163.2c5-8.6 14.2-13.8 24.1-13.8s19.1 5.3 24.1 13.8l95.2 163.2c5.7 9.8 9.3 21.1 6.7 32.1z"
    ]
};
var $d8206b3ab2e65c05$export$2238e05f8920005a = $d8206b3ab2e65c05$export$f4d7840209109993;
var $d8206b3ab2e65c05$export$34c1e678c32ed646 = {
    prefix: "fas",
    iconName: "subscript",
    icon: [
        512,
        512,
        [],
        "f12c",
        "M32 64C14.3 64 0 78.3 0 96s14.3 32 32 32H47.3l89.6 128L47.3 384H32c-17.7 0-32 14.3-32 32s14.3 32 32 32H64c10.4 0 20.2-5.1 26.2-13.6L176 311.8l85.8 122.6c6 8.6 15.8 13.6 26.2 13.6h32c17.7 0 32-14.3 32-32s-14.3-32-32-32H304.7L215.1 256l89.6-128H320c17.7 0 32-14.3 32-32s-14.3-32-32-32H288c-10.4 0-20.2 5.1-26.2 13.6L176 200.2 90.2 77.6C84.2 69.1 74.4 64 64 64H32zM480 320c0-11.1-5.7-21.4-15.2-27.2s-21.2-6.4-31.1-1.4l-32 16c-15.8 7.9-22.2 27.1-14.3 42.9C393 361.5 404.3 368 416 368v80c-17.7 0-32 14.3-32 32s14.3 32 32 32h32 32c17.7 0 32-14.3 32-32s-14.3-32-32-32V320z"
    ]
};
var $d8206b3ab2e65c05$export$99749ac517cbef07 = {
    prefix: "fas",
    iconName: "diamond-turn-right",
    icon: [
        512,
        512,
        [
            "directions"
        ],
        "f5eb",
        "M227.7 11.7c15.6-15.6 40.9-15.6 56.6 0l216 216c15.6 15.6 15.6 40.9 0 56.6l-216 216c-15.6 15.6-40.9 15.6-56.6 0l-216-216c-15.6-15.6-15.6-40.9 0-56.6l216-216zm87.6 137c-4.6-4.6-11.5-5.9-17.4-3.5s-9.9 8.3-9.9 14.8v56H224c-35.3 0-64 28.7-64 64v48c0 13.3 10.7 24 24 24s24-10.7 24-24V280c0-8.8 7.2-16 16-16h64v56c0 6.5 3.9 12.3 9.9 14.8s12.9 1.1 17.4-3.5l80-80c6.2-6.2 6.2-16.4 0-22.6l-80-80z"
    ]
};
var $d8206b3ab2e65c05$export$6a6973de44442fe5 = $d8206b3ab2e65c05$export$99749ac517cbef07;
var $d8206b3ab2e65c05$export$ea2986b45ba5d2cf = {
    prefix: "fas",
    iconName: "burst",
    icon: [
        512,
        512,
        [],
        "e4dc",
        "M37.6 4.2C28-2.3 15.2-1.1 7 7s-9.4 21-2.8 30.5l112 163.3L16.6 233.2C6.7 236.4 0 245.6 0 256s6.7 19.6 16.6 22.8l103.1 33.4L66.8 412.8c-4.9 9.3-3.2 20.7 4.3 28.1s18.8 9.2 28.1 4.3l100.6-52.9 33.4 103.1c3.2 9.9 12.4 16.6 22.8 16.6s19.6-6.7 22.8-16.6l33.4-103.1 100.6 52.9c9.3 4.9 20.7 3.2 28.1-4.3s9.2-18.8 4.3-28.1L392.3 312.2l103.1-33.4c9.9-3.2 16.6-12.4 16.6-22.8s-6.7-19.6-16.6-22.8L388.9 198.7l25.7-70.4c3.2-8.8 1-18.6-5.6-25.2s-16.4-8.8-25.2-5.6l-70.4 25.7L278.8 16.6C275.6 6.7 266.4 0 256 0s-19.6 6.7-22.8 16.6l-32.3 99.6L37.6 4.2z"
    ]
};
var $d8206b3ab2e65c05$export$6486d62e77b910 = {
    prefix: "fas",
    iconName: "house-laptop",
    icon: [
        640,
        512,
        [
            "laptop-house"
        ],
        "e066",
        "M218.3 8.5c12.3-11.3 31.2-11.3 43.4 0l208 192c6.7 6.2 10.3 14.8 10.3 23.5H336c-19.1 0-36.3 8.4-48 21.7V208c0-8.8-7.2-16-16-16H208c-8.8 0-16 7.2-16 16v64c0 8.8 7.2 16 16 16h64V416H112c-26.5 0-48-21.5-48-48V256H32c-13.2 0-25-8.1-29.8-20.3s-1.6-26.2 8.1-35.2l208-192zM352 304V448H544V304H352zm-48-16c0-17.7 14.3-32 32-32H560c17.7 0 32 14.3 32 32V448h32c8.8 0 16 7.2 16 16c0 26.5-21.5 48-48 48H544 352 304c-26.5 0-48-21.5-48-48c0-8.8 7.2-16 16-16h32V288z"
    ]
};
var $d8206b3ab2e65c05$export$efd983de5e4d6ad3 = $d8206b3ab2e65c05$export$6486d62e77b910;
var $d8206b3ab2e65c05$export$5352cbdc070ce8d = {
    prefix: "fas",
    iconName: "face-tired",
    icon: [
        512,
        512,
        [
            128555,
            "tired"
        ],
        "f5c8",
        "M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM164.7 328.7c22-22 53.9-40.7 91.3-40.7s69.3 18.7 91.3 40.7c11.1 11.1 20.1 23.4 26.4 35.4c6.2 11.7 10.3 24.4 10.3 35.9c0 5.2-2.6 10.2-6.9 13.2s-9.8 3.7-14.7 1.8l-20.5-7.7c-26.9-10.1-55.5-15.3-84.3-15.3h-3.2c-28.8 0-57.3 5.2-84.3 15.3L149.6 415c-4.9 1.8-10.4 1.2-14.7-1.8s-6.9-7.9-6.9-13.2c0-11.6 4.2-24.2 10.3-35.9c6.3-12 15.3-24.3 26.4-35.4zm-31.2-182l89.9 47.9c10.7 5.7 10.7 21.1 0 26.8l-89.9 47.9c-7.9 4.2-17.5-1.5-17.5-10.5c0-2.8 1-5.5 2.8-7.6l36-43.2-36-43.2c-1.8-2.1-2.8-4.8-2.8-7.6c0-9 9.6-14.7 17.5-10.5zM396 157.1c0 2.8-1 5.5-2.8 7.6l-36 43.2 36 43.2c1.8 2.1 2.8 4.8 2.8 7.6c0 9-9.6 14.7-17.5 10.5l-89.9-47.9c-10.7-5.7-10.7-21.1 0-26.8l89.9-47.9c7.9-4.2 17.5 1.5 17.5 10.5z"
    ]
};
var $d8206b3ab2e65c05$export$3d016d62cda18371 = $d8206b3ab2e65c05$export$5352cbdc070ce8d;
var $d8206b3ab2e65c05$export$a822dad6e586ee9e = {
    prefix: "fas",
    iconName: "money-bills",
    icon: [
        640,
        512,
        [],
        "e1f3",
        "M96 96V320c0 35.3 28.7 64 64 64H576c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H160c-35.3 0-64 28.7-64 64zm64 160c35.3 0 64 28.7 64 64H160V256zM224 96c0 35.3-28.7 64-64 64V96h64zM576 256v64H512c0-35.3 28.7-64 64-64zM512 96h64v64c-35.3 0-64-28.7-64-64zM288 208a80 80 0 1 1 160 0 80 80 0 1 1 -160 0zM48 120c0-13.3-10.7-24-24-24S0 106.7 0 120V360c0 66.3 53.7 120 120 120H520c13.3 0 24-10.7 24-24s-10.7-24-24-24H120c-39.8 0-72-32.2-72-72V120z"
    ]
};
var $d8206b3ab2e65c05$export$aa11b8edb09fed14 = {
    prefix: "fas",
    iconName: "smog",
    icon: [
        640,
        512,
        [],
        "f75f",
        "M32 144c0 79.5 64.5 144 144 144H299.3c22.6 19.9 52.2 32 84.7 32s62.1-12.1 84.7-32H496c61.9 0 112-50.1 112-112s-50.1-112-112-112c-10.7 0-21 1.5-30.8 4.3C443.8 27.7 401.1 0 352 0c-32.6 0-62.4 12.2-85.1 32.3C242.1 12.1 210.5 0 176 0C96.5 0 32 64.5 32 144zM616 368H280c-13.3 0-24 10.7-24 24s10.7 24 24 24H616c13.3 0 24-10.7 24-24s-10.7-24-24-24zm-64 96H440c-13.3 0-24 10.7-24 24s10.7 24 24 24H552c13.3 0 24-10.7 24-24s-10.7-24-24-24zm-192 0H24c-13.3 0-24 10.7-24 24s10.7 24 24 24H360c13.3 0 24-10.7 24-24s-10.7-24-24-24zM224 392c0-13.3-10.7-24-24-24H96c-13.3 0-24 10.7-24 24s10.7 24 24 24H200c13.3 0 24-10.7 24-24z"
    ]
};
var $d8206b3ab2e65c05$export$e94134641c0e2 = {
    prefix: "fas",
    iconName: "crutch",
    icon: [
        512,
        512,
        [],
        "f7f7",
        "M297.4 9.4c-12.5 12.5-12.5 32.8 0 45.3l160 160c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3l-160-160c-12.5-12.5-32.8-12.5-45.3 0zm-96 144l-34.8 34.8c-12.9 12.9-21.9 29.2-25.8 47.1L116.8 342.9c-1.3 5.9-4.3 11.4-8.6 15.7L9.4 457.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0l98.8-98.8c4.3-4.3 9.7-7.3 15.7-8.6l107.6-23.9c17.8-4 34.1-12.9 47.1-25.8l34.7-34.7c0 0 .1-.1 .1-.1s.1-.1 .1-.1l74.6-74.6-45.3-45.3L336 242.7 269.3 176l52.1-52.1L276.1 78.6l-74.7 74.7zM224 221.3L290.7 288l-12.2 12.2c-4.3 4.3-9.7 7.3-15.7 8.6l-76.7 17 17-76.7c1.3-5.9 4.3-11.4 8.6-15.7L224 221.3z"
    ]
};
var $d8206b3ab2e65c05$export$aa4baaed1c60f58d = {
    prefix: "fas",
    iconName: "font-awesome",
    icon: [
        448,
        512,
        [
            62501,
            62694,
            "font-awesome-flag",
            "font-awesome-logo-full"
        ],
        "f2b4",
        "M448 48V384c-63.1 22.5-82.3 32-119.5 32c-62.8 0-86.6-32-149.3-32c-20.6 0-36.6 3.6-51.2 8.2v-64c14.6-4.6 30.6-8.2 51.2-8.2c62.7 0 86.5 32 149.3 32c20.4 0 35.6-3 55.5-9.3v-208c-19.9 6.3-35.1 9.3-55.5 9.3c-62.8 0-86.6-32-149.3-32c-50.8 0-74.9 20.6-115.2 28.7V448c0 17.7-14.3 32-32 32s-32-14.3-32-32V64C0 46.3 14.3 32 32 32s32 14.3 32 32V76.7c40.3-8 64.4-28.7 115.2-28.7c62.7 0 86.5 32 149.3 32c37.1 0 56.4-9.5 119.5-32z"
    ]
};
var $d8206b3ab2e65c05$export$102c25fde54d4843 = $d8206b3ab2e65c05$export$aa4baaed1c60f58d;
var $d8206b3ab2e65c05$export$6e20d421a2e0f320 = $d8206b3ab2e65c05$export$aa4baaed1c60f58d;
var $d8206b3ab2e65c05$export$3507214fff1cc655 = {
    prefix: "fas",
    iconName: "cloud-arrow-up",
    icon: [
        640,
        512,
        [
            62338,
            "cloud-upload",
            "cloud-upload-alt"
        ],
        "f0ee",
        "M144 480C64.5 480 0 415.5 0 336c0-62.8 40.2-116.2 96.2-135.9c-.1-2.7-.2-5.4-.2-8.1c0-88.4 71.6-160 160-160c59.3 0 111 32.2 138.7 80.2C409.9 102 428.3 96 448 96c53 0 96 43 96 96c0 12.2-2.3 23.8-6.4 34.6C596 238.4 640 290.1 640 352c0 70.7-57.3 128-128 128H144zm79-217c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l39-39V392c0 13.3 10.7 24 24 24s24-10.7 24-24V257.9l39 39c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9l-80-80c-9.4-9.4-24.6-9.4-33.9 0l-80 80z"
    ]
};
var $d8206b3ab2e65c05$export$a48720e6366f5d9a = $d8206b3ab2e65c05$export$3507214fff1cc655;
var $d8206b3ab2e65c05$export$e73b3e819b9d14a5 = $d8206b3ab2e65c05$export$3507214fff1cc655;
var $d8206b3ab2e65c05$export$5c390baea5db4f77 = {
    prefix: "fas",
    iconName: "palette",
    icon: [
        512,
        512,
        [
            127912
        ],
        "f53f",
        "M512 256c0 .9 0 1.8 0 2.7c-.4 36.5-33.6 61.3-70.1 61.3H344c-26.5 0-48 21.5-48 48c0 3.4 .4 6.7 1 9.9c2.1 10.2 6.5 20 10.8 29.9c6.1 13.8 12.1 27.5 12.1 42c0 31.8-21.6 60.7-53.4 62c-3.5 .1-7 .2-10.6 .2C114.6 512 0 397.4 0 256S114.6 0 256 0S512 114.6 512 256zM128 288a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zm0-96a32 32 0 1 0 0-64 32 32 0 1 0 0 64zM288 96a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zm96 96a32 32 0 1 0 0-64 32 32 0 1 0 0 64z"
    ]
};
var $d8206b3ab2e65c05$export$db9f783f15682c4a = {
    prefix: "fas",
    iconName: "arrows-turn-right",
    icon: [
        448,
        512,
        [],
        "e4c0",
        "M297.4 9.4c12.5-12.5 32.8-12.5 45.3 0l96 96c12.5 12.5 12.5 32.8 0 45.3l-96 96c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3L338.7 160H128c-35.3 0-64 28.7-64 64v32c0 17.7-14.3 32-32 32s-32-14.3-32-32V224C0 153.3 57.3 96 128 96H338.7L297.4 54.6c-12.5-12.5-12.5-32.8 0-45.3zm-96 256c12.5-12.5 32.8-12.5 45.3 0l96 96c12.5 12.5 12.5 32.8 0 45.3l-96 96c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3L242.7 416H96c-17.7 0-32 14.3-32 32v32c0 17.7-14.3 32-32 32s-32-14.3-32-32V448c0-53 43-96 96-96H242.7l-41.4-41.4c-12.5-12.5-12.5-32.8 0-45.3z"
    ]
};
var $d8206b3ab2e65c05$export$c8370e53051a657 = {
    prefix: "fas",
    iconName: "vest",
    icon: [
        448,
        512,
        [],
        "e085",
        "M207.1 237.4L151.2 69.7C168.6 79.7 192.6 88 224 88s55.4-8.3 72.8-18.3L226.5 280.6c-1.6 4.9-2.5 10-2.5 15.2V464c0 26.5 21.5 48 48 48H400c26.5 0 48-21.5 48-48V270.5c0-9.5-2.8-18.7-8.1-26.6l-47.9-71.8c-5.3-7.9-8.1-17.1-8.1-26.6V128 54.3 48c0-26.5-21.5-48-48-48h-4.5c-.2 0-.4 0-.6 0c-.4 0-.8 0-1.2 0C311 0 295.7 9.7 285.7 18.8C276.4 27.2 257.2 40 224 40s-52.4-12.8-61.7-21.2C152.3 9.7 137 0 118.3 0c-.4 0-.8 0-1.2 0c-.2 0-.4 0-.6 0H112C85.5 0 64 21.5 64 48v6.3V128v17.5c0 9.5-2.8 18.7-8.1 26.6L8.1 243.9C2.8 251.8 0 261.1 0 270.5V464c0 26.5 21.5 48 48 48H176c9.9 0 19-3 26.7-8.1C195.9 492.2 192 478.5 192 464V295.8c0-8.6 1.4-17.1 4.1-25.3l11-33.1zM347.3 356.7l48 48c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0l-48-48c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0zm-294.6 48l48-48c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6l-48 48c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6z"
    ]
};
var $d8206b3ab2e65c05$export$fd312949b97346ae = {
    prefix: "fas",
    iconName: "ferry",
    icon: [
        576,
        512,
        [],
        "e4ea",
        "M224 0H352c17.7 0 32 14.3 32 32h75.1c20.6 0 31.6 24.3 18.1 39.8L456 96H120L98.8 71.8C85.3 56.3 96.3 32 116.9 32H192c0-17.7 14.3-32 32-32zM96 128H480c17.7 0 32 14.3 32 32V283.5c0 13.3-4.2 26.3-11.9 37.2l-51.4 71.9c-1.9 1.1-3.7 2.2-5.5 3.5c-15.5 10.7-34 18-51 19.9H375.6c-17.1-1.8-35-9-50.8-19.9c-22.1-15.5-51.6-15.5-73.7 0c-14.8 10.2-32.5 18-50.6 19.9H183.9c-17-1.8-35.6-9.2-51-19.9c-1.8-1.3-3.7-2.4-5.6-3.5L75.9 320.7C68.2 309.8 64 296.8 64 283.5V160c0-17.7 14.3-32 32-32zm32 64v96H448V192H128zM306.5 421.9C329 437.4 356.5 448 384 448c26.9 0 55.3-10.8 77.4-26.1l0 0c11.9-8.5 28.1-7.8 39.2 1.7c14.4 11.9 32.5 21 50.6 25.2c17.2 4 27.9 21.2 23.9 38.4s-21.2 27.9-38.4 23.9c-24.5-5.7-44.9-16.5-58.2-25C449.5 501.7 417 512 384 512c-31.9 0-60.6-9.9-80.4-18.9c-5.8-2.7-11.1-5.3-15.6-7.7c-4.5 2.4-9.7 5.1-15.6 7.7c-19.8 9-48.5 18.9-80.4 18.9c-33 0-65.5-10.3-94.5-25.8c-13.4 8.4-33.7 19.3-58.2 25c-17.2 4-34.4-6.7-38.4-23.9s6.7-34.4 23.9-38.4c18.1-4.2 36.2-13.3 50.6-25.2c11.1-9.4 27.3-10.1 39.2-1.7l0 0C136.7 437.2 165.1 448 192 448c27.5 0 55-10.6 77.5-26.1c11.1-7.9 25.9-7.9 37 0z"
    ]
};
var $d8206b3ab2e65c05$export$cfb044c7d35060bb = {
    prefix: "fas",
    iconName: "arrows-down-to-people",
    icon: [
        640,
        512,
        [],
        "e4b9",
        "M144 0c-13.3 0-24 10.7-24 24V142.1L97 119c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9l64 64c9.4 9.4 24.6 9.4 33.9 0l64-64c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-23 23V24c0-13.3-10.7-24-24-24zM360 200a40 40 0 1 0 -80 0 40 40 0 1 0 80 0zM184 296a40 40 0 1 0 -80 0 40 40 0 1 0 80 0zm312 40a40 40 0 1 0 0-80 40 40 0 1 0 0 80zM200 441.5l26.9 49.9c6.3 11.7 20.8 16 32.5 9.8s16-20.8 9.8-32.5l-36.3-67.5c1.7-1.7 3.2-3.6 4.3-5.8L264 345.5V400c0 17.7 14.3 32 32 32h48c17.7 0 32-14.3 32-32V345.5l26.9 49.9c1.2 2.2 2.6 4.1 4.3 5.8l-36.3 67.5c-6.3 11.7-1.9 26.2 9.8 32.5s26.2 1.9 32.5-9.8L440 441.5V480c0 17.7 14.3 32 32 32h48c17.7 0 32-14.3 32-32V441.5l26.9 49.9c6.3 11.7 20.8 16 32.5 9.8s16-20.8 9.8-32.5l-37.9-70.3c-15.3-28.5-45.1-46.3-77.5-46.3H486.2c-16.3 0-31.9 4.5-45.4 12.6l-33.6-62.3c-15.3-28.5-45.1-46.3-77.5-46.3H310.2c-32.4 0-62.1 17.8-77.5 46.3l-33.6 62.3c-13.5-8.1-29.1-12.6-45.4-12.6H134.2c-32.4 0-62.1 17.8-77.5 46.3L18.9 468.6c-6.3 11.7-1.9 26.2 9.8 32.5s26.2 1.9 32.5-9.8L88 441.5V480c0 17.7 14.3 32 32 32h48c17.7 0 32-14.3 32-32V441.5zM415 153l64 64c9.4 9.4 24.6 9.4 33.9 0l64-64c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-23 23V24c0-13.3-10.7-24-24-24s-24 10.7-24 24V142.1l-23-23c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9z"
    ]
};
var $d8206b3ab2e65c05$export$d7b60b8dbd03cfe4 = {
    prefix: "fas",
    iconName: "seedling",
    icon: [
        512,
        512,
        [
            127793,
            "sprout"
        ],
        "f4d8",
        "M512 32c0 113.6-84.6 207.5-194.2 222c-7.1-53.4-30.6-101.6-65.3-139.3C290.8 46.3 364 0 448 0h32c17.7 0 32 14.3 32 32zM0 96C0 78.3 14.3 64 32 64H64c123.7 0 224 100.3 224 224v32V480c0 17.7-14.3 32-32 32s-32-14.3-32-32V320C100.3 320 0 219.7 0 96z"
    ]
};
var $d8206b3ab2e65c05$export$9f3035e3a8c62323 = $d8206b3ab2e65c05$export$d7b60b8dbd03cfe4;
var $d8206b3ab2e65c05$export$47d93e9001818ee7 = {
    prefix: "fas",
    iconName: "left-right",
    icon: [
        512,
        512,
        [
            8596,
            "arrows-alt-h"
        ],
        "f337",
        "M504.3 273.6c4.9-4.5 7.7-10.9 7.7-17.6s-2.8-13-7.7-17.6l-112-104c-7-6.5-17.2-8.2-25.9-4.4s-14.4 12.5-14.4 22l0 56-192 0 0-56c0-9.5-5.7-18.2-14.4-22s-18.9-2.1-25.9 4.4l-112 104C2.8 243 0 249.3 0 256s2.8 13 7.7 17.6l112 104c7 6.5 17.2 8.2 25.9 4.4s14.4-12.5 14.4-22l0-56 192 0 0 56c0 9.5 5.7 18.2 14.4 22s18.9 2.1 25.9-4.4l112-104z"
    ]
};
var $d8206b3ab2e65c05$export$7937ea574fb1389 = $d8206b3ab2e65c05$export$47d93e9001818ee7;
var $d8206b3ab2e65c05$export$e81e7f3390fe84fe = {
    prefix: "fas",
    iconName: "boxes-packing",
    icon: [
        640,
        512,
        [],
        "e4c7",
        "M256 48c0-26.5 21.5-48 48-48H592c26.5 0 48 21.5 48 48V464c0 26.5-21.5 48-48 48H381.3c1.8-5 2.7-10.4 2.7-16V253.3c18.6-6.6 32-24.4 32-45.3V176c0-26.5-21.5-48-48-48H256V48zM571.3 347.3c6.2-6.2 6.2-16.4 0-22.6l-64-64c-6.2-6.2-16.4-6.2-22.6 0l-64 64c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0L480 310.6V432c0 8.8 7.2 16 16 16s16-7.2 16-16V310.6l36.7 36.7c6.2 6.2 16.4 6.2 22.6 0zM0 176c0-8.8 7.2-16 16-16H368c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H16c-8.8 0-16-7.2-16-16V176zm352 80V480c0 17.7-14.3 32-32 32H64c-17.7 0-32-14.3-32-32V256H352zM144 320c-8.8 0-16 7.2-16 16s7.2 16 16 16h96c8.8 0 16-7.2 16-16s-7.2-16-16-16H144z"
    ]
};
var $d8206b3ab2e65c05$export$827fbb87bdbe1028 = {
    prefix: "fas",
    iconName: "circle-arrow-left",
    icon: [
        512,
        512,
        [
            "arrow-circle-left"
        ],
        "f0a8",
        "M512 256A256 256 0 1 0 0 256a256 256 0 1 0 512 0zM231 127c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9l-71 71L376 232c13.3 0 24 10.7 24 24s-10.7 24-24 24l-182.1 0 71 71c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0L119 273c-9.4-9.4-9.4-24.6 0-33.9L231 127z"
    ]
};
var $d8206b3ab2e65c05$export$728262abb9f58d0a = $d8206b3ab2e65c05$export$827fbb87bdbe1028;
var $d8206b3ab2e65c05$export$88a8383ecdd39a54 = {
    prefix: "fas",
    iconName: "group-arrows-rotate",
    icon: [
        512,
        512,
        [],
        "e4f6",
        "M201.1 71.9c16.9-5 26.6-22.9 21.5-39.8s-22.9-26.6-39.8-21.5c-21.5 6.4-41.8 15.5-60.6 27C114.3 34 105.4 32 96 32C60.7 32 32 60.7 32 96c0 9.4 2 18.3 5.6 26.3c-11.5 18.7-20.6 39-27 60.6c-5 16.9 4.6 34.8 21.5 39.8s34.8-4.6 39.8-21.5c4.3-14.6 10.4-28.5 17.9-41.4c2 .2 4.1 .3 6.1 .3c35.3 0 64-28.7 64-64c0-2.1-.1-4.1-.3-6.1c12.9-7.5 26.8-13.6 41.4-17.9zm128-61.3c-16.9-5-34.8 4.6-39.8 21.5s4.6 34.8 21.5 39.8c14.6 4.3 28.5 10.4 41.4 17.9c-.2 2-.3 4.1-.3 6.1c0 35.3 28.7 64 64 64c2.1 0 4.1-.1 6.2-.3c7.5 12.9 13.6 26.8 17.9 41.4c5 16.9 22.9 26.6 39.8 21.5s26.6-22.9 21.5-39.8c-6.4-21.5-15.5-41.8-27-60.6c3.6-8 5.6-16.9 5.6-26.3c0-35.3-28.7-64-64-64c-9.4 0-18.3 2-26.3 5.6c-18.7-11.5-39-20.6-60.6-27zM71.9 310.9c-5-16.9-22.9-26.6-39.8-21.5s-26.6 22.9-21.5 39.8c6.4 21.5 15.5 41.8 27 60.6C34 397.7 32 406.6 32 416c0 35.3 28.7 64 64 64c9.4 0 18.3-2 26.3-5.6c18.7 11.5 39 20.6 60.6 27c16.9 5 34.8-4.6 39.8-21.5s-4.6-34.8-21.5-39.8c-14.6-4.3-28.5-10.4-41.4-17.9c.2-2 .3-4.1 .3-6.2c0-35.3-28.7-64-64-64c-2.1 0-4.1 .1-6.2 .3c-7.5-12.9-13.6-26.8-17.9-41.4zm429.4 18.3c5-16.9-4.6-34.8-21.5-39.8s-34.8 4.6-39.8 21.5c-4.3 14.6-10.4 28.5-17.9 41.4c-2-.2-4.1-.3-6.2-.3c-35.3 0-64 28.7-64 64c0 2.1 .1 4.1 .3 6.2c-12.9 7.5-26.8 13.6-41.4 17.9c-16.9 5-26.6 22.9-21.5 39.8s22.9 26.6 39.8 21.5c21.5-6.4 41.8-15.5 60.6-27c8 3.6 16.9 5.6 26.3 5.6c35.3 0 64-28.7 64-64c0-9.4-2-18.3-5.6-26.3c11.5-18.7 20.6-39 27-60.6zM192.8 256.8c0-15.6 5.6-29.9 14.9-41.1L223 231c6.6 6.6 17.8 1.9 17.8-7.4V163.2c0-5.7-4.7-10.4-10.4-10.4H169.9c-9.3 0-13.9 11.2-7.4 17.8l11.2 11.2c-17.9 19.8-28.9 46.2-28.9 75.1c0 43.6 24.9 81.3 61.1 99.8c11.8 6 26.3 1.4 32.3-10.4s1.4-26.3-10.4-32.3c-20.8-10.6-34.9-32.2-34.9-57zm93.1-58.6c20.8 10.6 34.9 32.2 34.9 57c0 15.6-5.6 29.9-14.9 41.1L290.6 281c-6.6-6.6-17.8-1.9-17.8 7.4v60.5c0 5.7 4.7 10.4 10.4 10.4h60.5c9.3 0 13.9-11.2 7.4-17.8l-11.2-11.2c17.9-19.8 28.9-46.2 28.9-75.1c0-43.6-24.9-81.3-61.1-99.8c-11.8-6-26.3-1.4-32.3 10.4s-1.4 26.3 10.4 32.3z"
    ]
};
var $d8206b3ab2e65c05$export$8b89ca3201039376 = {
    prefix: "fas",
    iconName: "bowl-food",
    icon: [
        512,
        512,
        [],
        "e4c6",
        "M0 192c0-35.3 28.7-64 64-64c.5 0 1.1 0 1.6 0C73 91.5 105.3 64 144 64c15 0 29 4.1 40.9 11.2C198.2 49.6 225.1 32 256 32s57.8 17.6 71.1 43.2C339 68.1 353 64 368 64c38.7 0 71 27.5 78.4 64c.5 0 1.1 0 1.6 0c35.3 0 64 28.7 64 64c0 11.7-3.1 22.6-8.6 32H8.6C3.1 214.6 0 203.7 0 192zm0 91.4C0 268.3 12.3 256 27.4 256H484.6c15.1 0 27.4 12.3 27.4 27.4c0 70.5-44.4 130.7-106.7 154.1L403.5 452c-2 16-15.6 28-31.8 28H140.2c-16.1 0-29.8-12-31.8-28l-1.8-14.4C44.4 414.1 0 353.9 0 283.4z"
    ]
};
var $d8206b3ab2e65c05$export$14d66ba7571ae0b9 = {
    prefix: "fas",
    iconName: "candy-cane",
    icon: [
        512,
        512,
        [],
        "f786",
        "M348.8 131.5c3.7-2.3 7.9-3.5 12.2-3.5c12.7 0 23 10.3 23 23v5.6c0 9.9-5.1 19.1-13.5 24.3L30.1 393.7C.1 412.5-9 451.9 9.7 481.9s58.2 39.1 88.2 20.4L438.4 289.5c45.8-28.6 73.6-78.8 73.6-132.8V151C512 67.6 444.4 0 361 0c-28.3 0-56 8-80.1 23L254.1 39.7c-30 18.7-39.1 58.2-20.4 88.2s58.2 39.1 88.2 20.4l26.8-16.8zM298.4 49.8c9.2-5.7 19.1-10.1 29.4-13.1L348 97.5c-5.7 1.4-11.2 3.7-16.3 6.8l-12.6 7.9L298.4 49.8zm88.5 52.7l46.2-46.2c8.5 6.5 16.1 14.1 22.6 22.6l-46.2 46.2c-5.1-9.6-13-17.5-22.6-22.6zm28.9 59.3l61.6 20.5c-2.2 10.5-5.8 20.7-10.5 30.2l-62-20.7c6.2-8.8 10.1-19.1 11-30.1zm-86.1 82.5l60.4 37.7-30.2 18.9-60.4-37.7 30.2-18.9zm-107.2 67l60.4 37.7-30.2 18.9-60.4-37.7 30.2-18.9zM119.3 375.7l60.4 37.7-30.2 18.9L89.1 394.6l30.2-18.9z"
    ]
};
var $d8206b3ab2e65c05$export$4229d00802c33062 = {
    prefix: "fas",
    iconName: "arrow-down-wide-short",
    icon: [
        576,
        512,
        [
            "sort-amount-asc",
            "sort-amount-down"
        ],
        "f160",
        "M151.6 469.6C145.5 476.2 137 480 128 480s-17.5-3.8-23.6-10.4l-88-96c-11.9-13-11.1-33.3 2-45.2s33.3-11.1 45.2 2L96 365.7V64c0-17.7 14.3-32 32-32s32 14.3 32 32V365.7l32.4-35.4c11.9-13 32.2-13.9 45.2-2s13.9 32.2 2 45.2l-88 96zM320 480c-17.7 0-32-14.3-32-32s14.3-32 32-32h32c17.7 0 32 14.3 32 32s-14.3 32-32 32H320zm0-128c-17.7 0-32-14.3-32-32s14.3-32 32-32h96c17.7 0 32 14.3 32 32s-14.3 32-32 32H320zm0-128c-17.7 0-32-14.3-32-32s14.3-32 32-32H480c17.7 0 32 14.3 32 32s-14.3 32-32 32H320zm0-128c-17.7 0-32-14.3-32-32s14.3-32 32-32H544c17.7 0 32 14.3 32 32s-14.3 32-32 32H320z"
    ]
};
var $d8206b3ab2e65c05$export$ddf8b8dd5983367d = $d8206b3ab2e65c05$export$4229d00802c33062;
var $d8206b3ab2e65c05$export$4b2a02d50e417b5f = $d8206b3ab2e65c05$export$4229d00802c33062;
var $d8206b3ab2e65c05$export$cdd116afa0309c17 = {
    prefix: "fas",
    iconName: "cloud-bolt",
    icon: [
        512,
        512,
        [
            127785,
            "thunderstorm"
        ],
        "f76c",
        "M0 224c0 53 43 96 96 96h47.2L290 202.5c17.6-14.1 42.6-14 60.2 .2s22.8 38.6 12.8 58.8L333.7 320H352h64c53 0 96-43 96-96s-43-96-96-96c-.5 0-1.1 0-1.6 0c1.1-5.2 1.6-10.5 1.6-16c0-44.2-35.8-80-80-80c-24.3 0-46.1 10.9-60.8 28C256.5 24.3 219.1 0 176 0C114.1 0 64 50.1 64 112c0 7.1 .7 14.1 1.9 20.8C27.6 145.4 0 181.5 0 224zm330.1 3.6c-5.8-4.7-14.2-4.7-20.1-.1l-160 128c-5.3 4.2-7.4 11.4-5.1 17.8s8.3 10.7 15.1 10.7h70.1L177.7 488.8c-3.4 6.7-1.6 14.9 4.3 19.6s14.2 4.7 20.1 .1l160-128c5.3-4.2 7.4-11.4 5.1-17.8s-8.3-10.7-15.1-10.7H281.9l52.4-104.8c3.4-6.7 1.6-14.9-4.2-19.6z"
    ]
};
var $d8206b3ab2e65c05$export$bbf9e3d433f8f6de = $d8206b3ab2e65c05$export$cdd116afa0309c17;
var $d8206b3ab2e65c05$export$ec658c0f040c3e1a = {
    prefix: "fas",
    iconName: "text-slash",
    icon: [
        640,
        512,
        [
            "remove-format"
        ],
        "f87d",
        "M38.8 5.1C28.4-3.1 13.3-1.2 5.1 9.2S-1.2 34.7 9.2 42.9l592 464c10.4 8.2 25.5 6.3 33.7-4.1s6.3-25.5-4.1-33.7L355.7 253.5 400.2 96H503L497 120.2c-4.3 17.1 6.1 34.5 23.3 38.8s34.5-6.1 38.8-23.3l11-44.1C577.6 61.3 554.7 32 523.5 32H376.1h-.3H204.5c-22 0-41.2 15-46.6 36.4l-6.3 25.2L38.8 5.1zm168 131.7c.1-.3 .2-.7 .3-1L217 96H333.7L301.3 210.8l-94.5-74.1zM243.3 416H192c-17.7 0-32 14.3-32 32s14.3 32 32 32H352c17.7 0 32-14.3 32-32s-14.3-32-32-32H309.8l17.6-62.1L272.9 311 243.3 416z"
    ]
};
var $d8206b3ab2e65c05$export$d91179f327329532 = $d8206b3ab2e65c05$export$ec658c0f040c3e1a;
var $d8206b3ab2e65c05$export$6143da800b0e6626 = {
    prefix: "fas",
    iconName: "face-smile-wink",
    icon: [
        512,
        512,
        [
            128521,
            "smile-wink"
        ],
        "f4da",
        "M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM164.1 325.5C182 346.2 212.6 368 256 368s74-21.8 91.9-42.5c5.8-6.7 15.9-7.4 22.6-1.6s7.4 15.9 1.6 22.6C349.8 372.1 311.1 400 256 400s-93.8-27.9-116.1-53.5c-5.8-6.7-5.1-16.8 1.6-22.6s16.8-5.1 22.6 1.6zM144.4 208a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm156.4 25.6c-5.3 7.1-15.3 8.5-22.4 3.2s-8.5-15.3-3.2-22.4c30.4-40.5 91.2-40.5 121.6 0c5.3 7.1 3.9 17.1-3.2 22.4s-17.1 3.9-22.4-3.2c-17.6-23.5-52.8-23.5-70.4 0z"
    ]
};
var $d8206b3ab2e65c05$export$f5dbb37f6801ee3f = $d8206b3ab2e65c05$export$6143da800b0e6626;
var $d8206b3ab2e65c05$export$f0858dff6e769cf6 = {
    prefix: "fas",
    iconName: "file-word",
    icon: [
        384,
        512,
        [],
        "f1c2",
        "M64 0C28.7 0 0 28.7 0 64V448c0 35.3 28.7 64 64 64H320c35.3 0 64-28.7 64-64V160H256c-17.7 0-32-14.3-32-32V0H64zM256 0V128H384L256 0zM111 257.1l26.8 89.2 31.6-90.3c3.4-9.6 12.5-16.1 22.7-16.1s19.3 6.4 22.7 16.1l31.6 90.3L273 257.1c3.8-12.7 17.2-19.9 29.9-16.1s19.9 17.2 16.1 29.9l-48 160c-3 10-12 16.9-22.4 17.1s-19.8-6.2-23.2-16.1L192 336.6l-33.3 95.3c-3.4 9.8-12.8 16.3-23.2 16.1s-19.5-7.1-22.4-17.1l-48-160c-3.8-12.7 3.4-26.1 16.1-29.9s26.1 3.4 29.9 16.1z"
    ]
};
var $d8206b3ab2e65c05$export$c341daeecdea449a = {
    prefix: "fas",
    iconName: "file-powerpoint",
    icon: [
        384,
        512,
        [],
        "f1c4",
        "M64 0C28.7 0 0 28.7 0 64V448c0 35.3 28.7 64 64 64H320c35.3 0 64-28.7 64-64V160H256c-17.7 0-32-14.3-32-32V0H64zM256 0V128H384L256 0zM136 240h68c42 0 76 34 76 76s-34 76-76 76H160v32c0 13.3-10.7 24-24 24s-24-10.7-24-24V368 264c0-13.3 10.7-24 24-24zm68 104c15.5 0 28-12.5 28-28s-12.5-28-28-28H160v56h44z"
    ]
};
var $d8206b3ab2e65c05$export$672e2f590b189583 = {
    prefix: "fas",
    iconName: "arrows-left-right",
    icon: [
        512,
        512,
        [
            "arrows-h"
        ],
        "f07e",
        "M406.6 374.6l96-96c12.5-12.5 12.5-32.8 0-45.3l-96-96c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3L402.7 224l-293.5 0 41.4-41.4c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0l-96 96c-12.5 12.5-12.5 32.8 0 45.3l96 96c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L109.3 288l293.5 0-41.4 41.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0z"
    ]
};
var $d8206b3ab2e65c05$export$de517642cdb40354 = $d8206b3ab2e65c05$export$672e2f590b189583;
var $d8206b3ab2e65c05$export$aa54b16c409e882f = {
    prefix: "fas",
    iconName: "house-lock",
    icon: [
        640,
        512,
        [],
        "e510",
        "M384 480c0 11.7 3.1 22.6 8.6 32H392c-22.1 0-40-17.9-40-40V448 384c0-17.7-14.3-32-32-32H256c-17.7 0-32 14.3-32 32v64 24c0 22.1-17.9 40-40 40H160 128.1c-1.5 0-3-.1-4.5-.2c-1.2 .1-2.4 .2-3.6 .2H104c-22.1 0-40-17.9-40-40V360c0-.9 0-1.9 .1-2.8V287.6H32c-18 0-32-14-32-32.1c0-9 3-17 10-24L266.4 8c7-7 15-8 22-8s15 2 21 7L490.7 166.3C447.2 181.7 416 223.2 416 272v24.6c-19.1 11.1-32 31.7-32 55.4V480zM528 240c-17.7 0-32 14.3-32 32v48h64V272c0-17.7-14.3-32-32-32zm-80 32c0-44.2 35.8-80 80-80s80 35.8 80 80v48c17.7 0 32 14.3 32 32V480c0 17.7-14.3 32-32 32H448c-17.7 0-32-14.3-32-32V352c0-17.7 14.3-32 32-32V272z"
    ]
};
var $d8206b3ab2e65c05$export$542a9676c5286e01 = {
    prefix: "fas",
    iconName: "cloud-arrow-down",
    icon: [
        640,
        512,
        [
            62337,
            "cloud-download",
            "cloud-download-alt"
        ],
        "f0ed",
        "M144 480C64.5 480 0 415.5 0 336c0-62.8 40.2-116.2 96.2-135.9c-.1-2.7-.2-5.4-.2-8.1c0-88.4 71.6-160 160-160c59.3 0 111 32.2 138.7 80.2C409.9 102 428.3 96 448 96c53 0 96 43 96 96c0 12.2-2.3 23.8-6.4 34.6C596 238.4 640 290.1 640 352c0 70.7-57.3 128-128 128H144zm79-167l80 80c9.4 9.4 24.6 9.4 33.9 0l80-80c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-39 39V184c0-13.3-10.7-24-24-24s-24 10.7-24 24V318.1l-39-39c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9z"
    ]
};
var $d8206b3ab2e65c05$export$b318977f29260464 = $d8206b3ab2e65c05$export$542a9676c5286e01;
var $d8206b3ab2e65c05$export$351357a14c41f824 = $d8206b3ab2e65c05$export$542a9676c5286e01;
var $d8206b3ab2e65c05$export$f2819bf60df55912 = {
    prefix: "fas",
    iconName: "children",
    icon: [
        640,
        512,
        [],
        "e4e1",
        "M160 0a64 64 0 1 1 0 128A64 64 0 1 1 160 0zM88 480V400H70.2c-10.9 0-18.6-10.7-15.2-21.1l31.1-93.4L57.5 323.3c-10.7 14.1-30.8 16.8-44.8 6.2s-16.8-30.7-6.2-44.8L65.4 207c22.4-29.6 57.5-47 94.6-47s72.2 17.4 94.6 47l58.9 77.7c10.7 14.1 7.9 34.2-6.2 44.8s-34.2 7.9-44.8-6.2l-28.6-37.8L265 378.9c3.5 10.4-4.3 21.1-15.2 21.1H232v80c0 17.7-14.3 32-32 32s-32-14.3-32-32V400H152v80c0 17.7-14.3 32-32 32s-32-14.3-32-32zM480 0a64 64 0 1 1 0 128A64 64 0 1 1 480 0zm-8 384v96c0 17.7-14.3 32-32 32s-32-14.3-32-32V300.5L395.1 321c-9.4 15-29.2 19.4-44.1 10s-19.4-29.2-10-44.1l51.7-82.1c17.6-27.9 48.3-44.9 81.2-44.9h12.3c33 0 63.7 16.9 81.2 44.9L619.1 287c9.4 15 4.9 34.7-10 44.1s-34.7 4.9-44.1-10L552 300.5V480c0 17.7-14.3 32-32 32s-32-14.3-32-32V384H472z"
    ]
};
var $d8206b3ab2e65c05$export$49a36efd66df775 = {
    prefix: "fas",
    iconName: "chalkboard",
    icon: [
        576,
        512,
        [
            "blackboard"
        ],
        "f51b",
        "M96 32C60.7 32 32 60.7 32 96V384H96V96l384 0V384h64V96c0-35.3-28.7-64-64-64H96zM224 384v32H32c-17.7 0-32 14.3-32 32s14.3 32 32 32H544c17.7 0 32-14.3 32-32s-14.3-32-32-32H416V384c0-17.7-14.3-32-32-32H256c-17.7 0-32 14.3-32 32z"
    ]
};
var $d8206b3ab2e65c05$export$f497e01bf522fd9c = $d8206b3ab2e65c05$export$49a36efd66df775;
var $d8206b3ab2e65c05$export$ae7fc6b7f0534be9 = {
    prefix: "fas",
    iconName: "user-large-slash",
    icon: [
        640,
        512,
        [
            "user-alt-slash"
        ],
        "f4fa",
        "M38.8 5.1C28.4-3.1 13.3-1.2 5.1 9.2S-1.2 34.7 9.2 42.9l592 464c10.4 8.2 25.5 6.3 33.7-4.1s6.3-25.5-4.1-33.7L381.9 274c48.5-23.2 82.1-72.7 82.1-130C464 64.5 399.5 0 320 0C250.4 0 192.4 49.3 178.9 114.9L38.8 5.1zM545.5 512H528L284.3 320h-59C136.2 320 64 392.2 64 481.3c0 17 13.8 30.7 30.7 30.7H545.3l.3 0z"
    ]
};
var $d8206b3ab2e65c05$export$46185fab4772ada6 = $d8206b3ab2e65c05$export$ae7fc6b7f0534be9;
var $d8206b3ab2e65c05$export$c6c3bd5f7d9b8bf2 = {
    prefix: "fas",
    iconName: "envelope-open",
    icon: [
        512,
        512,
        [
            62135
        ],
        "f2b6",
        "M64 208.1L256 65.9 448 208.1v47.4L289.5 373c-9.7 7.2-21.4 11-33.5 11s-23.8-3.9-33.5-11L64 255.5V208.1zM256 0c-12.1 0-23.8 3.9-33.5 11L25.9 156.7C9.6 168.8 0 187.8 0 208.1V448c0 35.3 28.7 64 64 64H448c35.3 0 64-28.7 64-64V208.1c0-20.3-9.6-39.4-25.9-51.4L289.5 11C279.8 3.9 268.1 0 256 0z"
    ]
};
var $d8206b3ab2e65c05$export$e99ae494101c5e91 = {
    prefix: "fas",
    iconName: "handshake-simple-slash",
    icon: [
        640,
        512,
        [
            "handshake-alt-slash"
        ],
        "e05f",
        "M38.8 5.1C28.4-3.1 13.3-1.2 5.1 9.2S-1.2 34.7 9.2 42.9l592 464c10.4 8.2 25.5 6.3 33.7-4.1s6.3-25.5-4.1-33.7l-135-105.8c-1.1-11.3-6.3-22.3-15.3-30.7l-134.2-123-23.4 18.2-26-20.3 77.2-60.1c7-5.4 17-4.2 22.5 2.8s4.2 17-2.8 22.5l-20.9 16.2L550.2 352H592c26.5 0 48-21.5 48-48V176c0-26.5-21.5-48-48-48H516h-4-.7l-3.9-2.5L434.8 79c-15.3-9.8-33.2-15-51.4-15c-21.8 0-43 7.5-60 21.2l-89.7 72.6-25.8-20.3 81.8-66.2c-11.6-4.9-24.1-7.4-36.8-7.4C234 64 215.7 69.6 200 80l-35.5 23.7L38.8 5.1zM413.6 421.9L41.2 128.5C17.9 131.8 0 151.8 0 176V304c0 26.5 21.5 48 48 48H156.2l91.4 83.4c19.6 17.9 49.9 16.5 67.8-3.1c5.5-6.1 9.2-13.2 11.1-20.6l17 15.6c19.5 17.9 49.9 16.6 67.8-2.9c.8-.8 1.5-1.7 2.2-2.6z"
    ]
};
var $d8206b3ab2e65c05$export$ca302f956ae9f1bf = $d8206b3ab2e65c05$export$e99ae494101c5e91;
var $d8206b3ab2e65c05$export$f042d3e458efa721 = {
    prefix: "fas",
    iconName: "mattress-pillow",
    icon: [
        640,
        512,
        [],
        "e525",
        "M256 64H64C28.7 64 0 92.7 0 128V384c0 35.3 28.7 64 64 64H256V64zm32 384H576c35.3 0 64-28.7 64-64V128c0-35.3-28.7-64-64-64H288V448zM64 160c0-17.7 14.3-32 32-32h64c17.7 0 32 14.3 32 32V352c0 17.7-14.3 32-32 32H96c-17.7 0-32-14.3-32-32V160z"
    ]
};
var $d8206b3ab2e65c05$export$b731a51acb74b00c = {
    prefix: "fas",
    iconName: "guarani-sign",
    icon: [
        384,
        512,
        [],
        "e19a",
        "M192 0c-17.7 0-32 14.3-32 32V66.7C69.2 81.9 0 160.9 0 256s69.2 174.1 160 189.3V480c0 17.7 14.3 32 32 32s32-14.3 32-32V445.3c90.8-15.2 160-94.2 160-189.3c0-17.7-14.3-32-32-32H224V132c22.1 5.7 41.8 17.1 57.6 32.6c12.6 12.4 32.9 12.2 45.3-.4s12.2-32.9-.5-45.3C299 92 263.5 73.3 224 66.7V32c0-17.7-14.3-32-32-32zM160 132V380c-55.2-14.2-96-64.3-96-124s40.8-109.8 96-124zM224 380V288h92c-11.6 45-47 80.4-92 92z"
    ]
};
var $d8206b3ab2e65c05$export$2fd091cb98dc8ab8 = {
    prefix: "fas",
    iconName: "arrows-rotate",
    icon: [
        512,
        512,
        [
            128472,
            "refresh",
            "sync"
        ],
        "f021",
        "M105.1 202.6c7.7-21.8 20.2-42.3 37.8-59.8c62.5-62.5 163.8-62.5 226.3 0L386.3 160H336c-17.7 0-32 14.3-32 32s14.3 32 32 32H463.5c0 0 0 0 0 0h.4c17.7 0 32-14.3 32-32V64c0-17.7-14.3-32-32-32s-32 14.3-32 32v51.2L414.4 97.6c-87.5-87.5-229.3-87.5-316.8 0C73.2 122 55.6 150.7 44.8 181.4c-5.9 16.7 2.9 34.9 19.5 40.8s34.9-2.9 40.8-19.5zM39 289.3c-5 1.5-9.8 4.2-13.7 8.2c-4 4-6.7 8.8-8.1 14c-.3 1.2-.6 2.5-.8 3.8c-.3 1.7-.4 3.4-.4 5.1V448c0 17.7 14.3 32 32 32s32-14.3 32-32V396.9l17.6 17.5 0 0c87.5 87.4 229.3 87.4 316.7 0c24.4-24.4 42.1-53.1 52.9-83.7c5.9-16.7-2.9-34.9-19.5-40.8s-34.9 2.9-40.8 19.5c-7.7 21.8-20.2 42.3-37.8 59.8c-62.5 62.5-163.8 62.5-226.3 0l-.1-.1L125.6 352H176c17.7 0 32-14.3 32-32s-14.3-32-32-32H48.4c-1.6 0-3.2 .1-4.8 .3s-3.1 .5-4.6 1z"
    ]
};
var $d8206b3ab2e65c05$export$fd4359e93d7b3d14 = $d8206b3ab2e65c05$export$2fd091cb98dc8ab8;
var $d8206b3ab2e65c05$export$ff87319002e3dae9 = $d8206b3ab2e65c05$export$2fd091cb98dc8ab8;
var $d8206b3ab2e65c05$export$d75fb6743634a0a = {
    prefix: "fas",
    iconName: "fire-extinguisher",
    icon: [
        512,
        512,
        [
            129519
        ],
        "f134",
        "M500.3 7.3C507.7 13.3 512 22.4 512 32v96c0 9.6-4.3 18.7-11.7 24.7s-17.2 8.5-26.6 6.6l-160-32C301.5 124.9 292 115.7 289 104H224v34.8c37.8 18 64 56.5 64 101.2V384H64V240c0-44.7 26.2-83.2 64-101.2V110c-36.2 11.1-66 36.9-82.3 70.5c-5.8 11.9-20.2 16.9-32.1 11.1S-3.3 171.4 2.5 159.5C26.7 109.8 72.7 72.6 128 60.4V32c0-17.7 14.3-32 32-32h32c17.7 0 32 14.3 32 32V56h65c3-11.7 12.5-20.9 24.7-23.4l160-32c9.4-1.9 19.1 .6 26.6 6.6zM288 416v32c0 35.3-28.7 64-64 64H128c-35.3 0-64-28.7-64-64V416H288zM176 96a16 16 0 1 0 0-32 16 16 0 1 0 0 32z"
    ]
};
var $d8206b3ab2e65c05$export$64dd1b27affb6572 = {
    prefix: "fas",
    iconName: "cruzeiro-sign",
    icon: [
        448,
        512,
        [],
        "e152",
        "M96 256c0-88.4 71.6-160 160-160c41 0 78.3 15.4 106.7 40.7c13.2 11.8 33.4 10.7 45.2-2.5s10.7-33.4-2.5-45.2c-39.6-35.5-92-57-149.3-57C132.3 32 32 132.3 32 256s100.3 224 224 224c57.4 0 109.7-21.6 149.3-57c13.2-11.8 14.3-32 2.5-45.2s-32-14.3-45.2-2.5C334.3 400.6 297 416 256 416V320v-8.7c0-12.8 10.4-23.3 23.3-23.3c4.6 0 9.1 1.4 12.9 3.9l10.1 6.7c14.7 9.8 34.6 5.8 44.4-8.9s5.8-34.6-8.9-44.4l-10.1-6.7c-14.3-9.6-31.2-14.7-48.4-14.7c-12.4 0-24.2 2.6-34.9 7.3c-5.5-4.5-12.6-7.3-20.3-7.3c-17.7 0-32 14.3-32 32v55.3V320v82.7C135.5 378 96 321.6 96 256z"
    ]
};
var $d8206b3ab2e65c05$export$7bf8dfe2e6661a54 = {
    prefix: "fas",
    iconName: "greater-than-equal",
    icon: [
        448,
        512,
        [],
        "f532",
        "M52.1 93.7C35.7 87.1 27.7 68.5 34.3 52.1s25.2-24.4 41.6-17.8l320 128C408 167.1 416 178.9 416 192s-8 24.9-20.1 29.7l-320 128c-16.4 6.6-35-1.4-41.6-17.8s1.4-35 17.8-41.6L297.8 192 52.1 93.7zM416 416c17.7 0 32 14.3 32 32s-14.3 32-32 32H32c-17.7 0-32-14.3-32-32s14.3-32 32-32H416z"
    ]
};
var $d8206b3ab2e65c05$export$36e034ccc72554a9 = {
    prefix: "fas",
    iconName: "shield-halved",
    icon: [
        512,
        512,
        [
            "shield-alt"
        ],
        "f3ed",
        "M256 0c4.6 0 9.2 1 13.4 2.9L457.7 82.8c22 9.3 38.4 31 38.3 57.2c-.5 99.2-41.3 280.7-213.6 363.2c-16.7 8-36.1 8-52.8 0C57.3 420.7 16.5 239.2 16 140c-.1-26.2 16.3-47.9 38.3-57.2L242.7 2.9C246.8 1 251.4 0 256 0zm0 66.8V444.8C394 378 431.1 230.1 432 141.4L256 66.8l0 0z"
    ]
};
var $d8206b3ab2e65c05$export$d6508d18a824f291 = $d8206b3ab2e65c05$export$36e034ccc72554a9;
var $d8206b3ab2e65c05$export$7fb8daedae341012 = {
    prefix: "fas",
    iconName: "book-atlas",
    icon: [
        448,
        512,
        [
            "atlas"
        ],
        "f558",
        "M0 96C0 43 43 0 96 0H384h32c17.7 0 32 14.3 32 32V352c0 17.7-14.3 32-32 32v64c17.7 0 32 14.3 32 32s-14.3 32-32 32H384 96c-53 0-96-43-96-96V96zM64 416c0 17.7 14.3 32 32 32H352V384H96c-17.7 0-32 14.3-32 32zM247.4 283.8c-3.7 3.7-6.2 4.2-7.4 4.2s-3.7-.5-7.4-4.2c-3.8-3.7-8-10-11.8-18.9c-6.2-14.5-10.8-34.3-12.2-56.9h63c-1.5 22.6-6 42.4-12.2 56.9c-3.8 8.9-8 15.2-11.8 18.9zm42.7-9.9c7.3-18.3 12-41.1 13.4-65.9h31.1c-4.7 27.9-21.4 51.7-44.5 65.9zm0-163.8c23.2 14.2 39.9 38 44.5 65.9H303.5c-1.4-24.7-6.1-47.5-13.4-65.9zM368 192a128 128 0 1 0 -256 0 128 128 0 1 0 256 0zM145.3 208h31.1c1.4 24.7 6.1 47.5 13.4 65.9c-23.2-14.2-39.9-38-44.5-65.9zm31.1-32H145.3c4.7-27.9 21.4-51.7 44.5-65.9c-7.3 18.3-12 41.1-13.4 65.9zm56.1-75.8c3.7-3.7 6.2-4.2 7.4-4.2s3.7 .5 7.4 4.2c3.8 3.7 8 10 11.8 18.9c6.2 14.5 10.8 34.3 12.2 56.9h-63c1.5-22.6 6-42.4 12.2-56.9c3.8-8.9 8-15.2 11.8-18.9z"
    ]
};
var $d8206b3ab2e65c05$export$380a9050e42fe5d7 = $d8206b3ab2e65c05$export$7fb8daedae341012;
var $d8206b3ab2e65c05$export$37c67e0b3dc6bd1b = {
    prefix: "fas",
    iconName: "virus",
    icon: [
        512,
        512,
        [],
        "e074",
        "M288 32c0-17.7-14.3-32-32-32s-32 14.3-32 32V43.5c0 49.9-60.3 74.9-95.6 39.6L120.2 75C107.7 62.5 87.5 62.5 75 75s-12.5 32.8 0 45.3l8.2 8.2C118.4 163.7 93.4 224 43.5 224H32c-17.7 0-32 14.3-32 32s14.3 32 32 32H43.5c49.9 0 74.9 60.3 39.6 95.6L75 391.8c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0l8.2-8.2c35.3-35.3 95.6-10.3 95.6 39.6V480c0 17.7 14.3 32 32 32s32-14.3 32-32V468.5c0-49.9 60.3-74.9 95.6-39.6l8.2 8.2c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3l-8.2-8.2c-35.3-35.3-10.3-95.6 39.6-95.6H480c17.7 0 32-14.3 32-32s-14.3-32-32-32H468.5c-49.9 0-74.9-60.3-39.6-95.6l8.2-8.2c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0l-8.2 8.2C348.3 118.4 288 93.4 288 43.5V32zM176 224a48 48 0 1 1 96 0 48 48 0 1 1 -96 0zm128 56a24 24 0 1 1 0 48 24 24 0 1 1 0-48z"
    ]
};
var $d8206b3ab2e65c05$export$74d890536dbd21b7 = {
    prefix: "fas",
    iconName: "envelope-circle-check",
    icon: [
        640,
        512,
        [],
        "e4e8",
        "M48 64C21.5 64 0 85.5 0 112c0 15.1 7.1 29.3 19.2 38.4L236.8 313.6c11.4 8.5 27 8.5 38.4 0l57.4-43c23.9-59.8 79.7-103.3 146.3-109.8l13.9-10.4c12.1-9.1 19.2-23.3 19.2-38.4c0-26.5-21.5-48-48-48H48zM294.4 339.2c-22.8 17.1-54 17.1-76.8 0L0 176V384c0 35.3 28.7 64 64 64H360.2C335.1 417.6 320 378.5 320 336c0-5.6 .3-11.1 .8-16.6l-26.4 19.8zM640 336a144 144 0 1 0 -288 0 144 144 0 1 0 288 0zm-76.7-43.3c6.2 6.2 6.2 16.4 0 22.6l-72 72c-6.2 6.2-16.4 6.2-22.6 0l-40-40c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0L480 353.4l60.7-60.7c6.2-6.2 16.4-6.2 22.6 0z"
    ]
};
var $d8206b3ab2e65c05$export$a137712e11e257dd = {
    prefix: "fas",
    iconName: "layer-group",
    icon: [
        576,
        512,
        [],
        "f5fd",
        "M264.5 5.2c14.9-6.9 32.1-6.9 47 0l218.6 101c8.5 3.9 13.9 12.4 13.9 21.8s-5.4 17.9-13.9 21.8l-218.6 101c-14.9 6.9-32.1 6.9-47 0L45.9 149.8C37.4 145.8 32 137.3 32 128s5.4-17.9 13.9-21.8L264.5 5.2zM476.9 209.6l53.2 24.6c8.5 3.9 13.9 12.4 13.9 21.8s-5.4 17.9-13.9 21.8l-218.6 101c-14.9 6.9-32.1 6.9-47 0L45.9 277.8C37.4 273.8 32 265.3 32 256s5.4-17.9 13.9-21.8l53.2-24.6 152 70.2c23.4 10.8 50.4 10.8 73.8 0l152-70.2zm-152 198.2l152-70.2 53.2 24.6c8.5 3.9 13.9 12.4 13.9 21.8s-5.4 17.9-13.9 21.8l-218.6 101c-14.9 6.9-32.1 6.9-47 0L45.9 405.8C37.4 401.8 32 393.3 32 384s5.4-17.9 13.9-21.8l53.2-24.6 152 70.2c23.4 10.8 50.4 10.8 73.8 0z"
    ]
};
var $d8206b3ab2e65c05$export$ab3a06d4b53c0fc0 = {
    prefix: "fas",
    iconName: "arrows-to-dot",
    icon: [
        512,
        512,
        [],
        "e4be",
        "M256 0c17.7 0 32 14.3 32 32V64h32c12.9 0 24.6 7.8 29.6 19.8s2.2 25.7-6.9 34.9l-64 64c-12.5 12.5-32.8 12.5-45.3 0l-64-64c-9.2-9.2-11.9-22.9-6.9-34.9s16.6-19.8 29.6-19.8h32V32c0-17.7 14.3-32 32-32zM169.4 393.4l64-64c12.5-12.5 32.8-12.5 45.3 0l64 64c9.2 9.2 11.9 22.9 6.9 34.9s-16.6 19.8-29.6 19.8H288v32c0 17.7-14.3 32-32 32s-32-14.3-32-32V448H192c-12.9 0-24.6-7.8-29.6-19.8s-2.2-25.7 6.9-34.9zM32 224H64V192c0-12.9 7.8-24.6 19.8-29.6s25.7-2.2 34.9 6.9l64 64c12.5 12.5 12.5 32.8 0 45.3l-64 64c-9.2 9.2-22.9 11.9-34.9 6.9s-19.8-16.6-19.8-29.6V288H32c-17.7 0-32-14.3-32-32s14.3-32 32-32zm297.4 54.6c-12.5-12.5-12.5-32.8 0-45.3l64-64c9.2-9.2 22.9-11.9 34.9-6.9s19.8 16.6 19.8 29.6v32h32c17.7 0 32 14.3 32 32s-14.3 32-32 32H448v32c0 12.9-7.8 24.6-19.8 29.6s-25.7 2.2-34.9-6.9l-64-64zM256 224a32 32 0 1 1 0 64 32 32 0 1 1 0-64z"
    ]
};
var $d8206b3ab2e65c05$export$d56753dd2eb5c323 = {
    prefix: "fas",
    iconName: "archway",
    icon: [
        512,
        512,
        [],
        "f557",
        "M32 32C14.3 32 0 46.3 0 64S14.3 96 32 96H480c17.7 0 32-14.3 32-32s-14.3-32-32-32H32zm0 384c-17.7 0-32 14.3-32 32s14.3 32 32 32H96h64V352c0-53 43-96 96-96s96 43 96 96V480h64 64c17.7 0 32-14.3 32-32s-14.3-32-32-32V128H32V416z"
    ]
};
var $d8206b3ab2e65c05$export$5e4b6785eedecc1a = {
    prefix: "fas",
    iconName: "heart-circle-check",
    icon: [
        576,
        512,
        [],
        "e4fd",
        "M47.6 300.4L228.3 469.1c7.5 7 17.4 10.9 27.7 10.9s20.2-3.9 27.7-10.9l2.6-2.4C267.2 438.6 256 404.6 256 368c0-97.2 78.8-176 176-176c28.3 0 55 6.7 78.7 18.5c.9-6.5 1.3-13 1.3-19.6v-5.8c0-69.9-50.5-129.5-119.4-141C347 36.5 300.6 51.4 268 84L256 96 244 84c-32.6-32.6-79-47.5-124.6-39.9C50.5 55.6 0 115.2 0 185.1v5.8c0 41.5 17.2 81.2 47.6 109.5zM576 368a144 144 0 1 0 -288 0 144 144 0 1 0 288 0zm-76.7-43.3c6.2 6.2 6.2 16.4 0 22.6l-72 72c-6.2 6.2-16.4 6.2-22.6 0l-40-40c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0L416 385.4l60.7-60.7c6.2-6.2 16.4-6.2 22.6 0z"
    ]
};
var $d8206b3ab2e65c05$export$e824540f5a6a8a57 = {
    prefix: "fas",
    iconName: "house-chimney-crack",
    icon: [
        576,
        512,
        [
            "house-damage"
        ],
        "f6f1",
        "M575.8 255.5c0 18-15 32.1-32 32.1h-32l.7 160.2c.2 35.5-28.5 64.3-64 64.3H326.4L288 448l80.8-67.3c7.8-6.5 7.6-18.6-.4-24.9L250.6 263.2c-14.6-11.5-33.8 7-22.8 22L288 368l-85.5 71.2c-6.1 5-7.5 13.8-3.5 20.5L230.4 512H128.1c-35.3 0-64-28.7-64-64V287.6H32c-18 0-32-14-32-32.1c0-9 3-17 10-24L266.4 8c7-7 15-8 22-8s15 2 21 7L416 100.7V64c0-17.7 14.3-32 32-32h32c17.7 0 32 14.3 32 32V185l52.8 46.4c8 7 12 15 11 24z"
    ]
};
var $d8206b3ab2e65c05$export$8d7e943005ce0b49 = $d8206b3ab2e65c05$export$e824540f5a6a8a57;
var $d8206b3ab2e65c05$export$7a4a0e4caa1e4e6f = {
    prefix: "fas",
    iconName: "file-zipper",
    icon: [
        384,
        512,
        [
            "file-archive"
        ],
        "f1c6",
        "M64 0C28.7 0 0 28.7 0 64V448c0 35.3 28.7 64 64 64H320c35.3 0 64-28.7 64-64V160H256c-17.7 0-32-14.3-32-32V0H64zM256 0V128H384L256 0zM96 48c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16s-7.2 16-16 16H112c-8.8 0-16-7.2-16-16zm0 64c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16s-7.2 16-16 16H112c-8.8 0-16-7.2-16-16zm0 64c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16s-7.2 16-16 16H112c-8.8 0-16-7.2-16-16zm-6.3 71.8c3.7-14 16.4-23.8 30.9-23.8h14.8c14.5 0 27.2 9.7 30.9 23.8l23.5 88.2c1.4 5.4 2.1 10.9 2.1 16.4c0 35.2-28.8 63.7-64 63.7s-64-28.5-64-63.7c0-5.5 .7-11.1 2.1-16.4l23.5-88.2zM112 336c-8.8 0-16 7.2-16 16s7.2 16 16 16h32c8.8 0 16-7.2 16-16s-7.2-16-16-16H112z"
    ]
};
var $d8206b3ab2e65c05$export$bf2047a9946b5c3f = $d8206b3ab2e65c05$export$7a4a0e4caa1e4e6f;
var $d8206b3ab2e65c05$export$90b4406457aae8cc = {
    prefix: "fas",
    iconName: "square",
    icon: [
        448,
        512,
        [
            9632,
            9723,
            9724,
            61590
        ],
        "f0c8",
        "M0 96C0 60.7 28.7 32 64 32H384c35.3 0 64 28.7 64 64V416c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96z"
    ]
};
var $d8206b3ab2e65c05$export$a8a0de30198815a3 = {
    prefix: "fas",
    iconName: "martini-glass-empty",
    icon: [
        512,
        512,
        [
            "glass-martini"
        ],
        "f000",
        "M32 0C19.1 0 7.4 7.8 2.4 19.8s-2.2 25.7 6.9 34.9L224 269.3V448H160c-17.7 0-32 14.3-32 32s14.3 32 32 32h96 96c17.7 0 32-14.3 32-32s-14.3-32-32-32H288V269.3L502.6 54.6c9.2-9.2 11.9-22.9 6.9-34.9S492.9 0 480 0H32zM256 210.7L109.3 64H402.7L256 210.7z"
    ]
};
var $d8206b3ab2e65c05$export$e96f280e39af4a91 = $d8206b3ab2e65c05$export$a8a0de30198815a3;
var $d8206b3ab2e65c05$export$ce96e32767a7dd51 = {
    prefix: "fas",
    iconName: "couch",
    icon: [
        640,
        512,
        [],
        "f4b8",
        "M64 160C64 89.3 121.3 32 192 32H448c70.7 0 128 57.3 128 128v33.6c-36.5 7.4-64 39.7-64 78.4v48H128V272c0-38.7-27.5-71-64-78.4V160zM544 272c0-20.9 13.4-38.7 32-45.3c5-1.8 10.4-2.7 16-2.7c26.5 0 48 21.5 48 48V448c0 17.7-14.3 32-32 32H576c-17.7 0-32-14.3-32-32H96c0 17.7-14.3 32-32 32H32c-17.7 0-32-14.3-32-32V272c0-26.5 21.5-48 48-48c5.6 0 11 1 16 2.7c18.6 6.6 32 24.4 32 45.3v48 32h32H512h32V320 272z"
    ]
};
var $d8206b3ab2e65c05$export$66c557f70914132c = {
    prefix: "fas",
    iconName: "cedi-sign",
    icon: [
        384,
        512,
        [],
        "e0df",
        "M256 32c0-17.7-14.3-32-32-32s-32 14.3-32 32V66.7C101.2 81.9 32 160.9 32 256s69.2 174.1 160 189.3V480c0 17.7 14.3 32 32 32s32-14.3 32-32V445.3c30.9-5.2 59.2-17.7 83.2-35.8c14.1-10.6 17-30.7 6.4-44.8s-30.7-17-44.8-6.4c-13.2 9.9-28.3 17.3-44.8 21.6V132c16.4 4.2 31.6 11.6 44.8 21.6c14.1 10.6 34.2 7.8 44.8-6.4s7.8-34.2-6.4-44.8c-24-18-52.4-30.6-83.2-35.8V32zM192 132V380c-55.2-14.2-96-64.3-96-124s40.8-109.8 96-124z"
    ]
};
var $d8206b3ab2e65c05$export$16e344bae4d495ed = {
    prefix: "fas",
    iconName: "italic",
    icon: [
        384,
        512,
        [],
        "f033",
        "M128 64c0-17.7 14.3-32 32-32H352c17.7 0 32 14.3 32 32s-14.3 32-32 32H293.3L160 416h64c17.7 0 32 14.3 32 32s-14.3 32-32 32H32c-17.7 0-32-14.3-32-32s14.3-32 32-32H90.7L224 96H160c-17.7 0-32-14.3-32-32z"
    ]
};
var $d8206b3ab2e65c05$export$16a3f12c6ae9650 = {
    prefix: "fas",
    iconName: "church",
    icon: [
        640,
        512,
        [
            9962
        ],
        "f51d",
        "M344 24c0-13.3-10.7-24-24-24s-24 10.7-24 24V48H264c-13.3 0-24 10.7-24 24s10.7 24 24 24h32v46.4L183.3 210c-14.5 8.7-23.3 24.3-23.3 41.2V512h96V416c0-35.3 28.7-64 64-64s64 28.7 64 64v96h96V251.2c0-16.9-8.8-32.5-23.3-41.2L344 142.4V96h32c13.3 0 24-10.7 24-24s-10.7-24-24-24H344V24zM24.9 330.3C9.5 338.8 0 354.9 0 372.4V464c0 26.5 21.5 48 48 48h80V273.6L24.9 330.3zM592 512c26.5 0 48-21.5 48-48V372.4c0-17.5-9.5-33.6-24.9-42.1L512 273.6V512h80z"
    ]
};
var $d8206b3ab2e65c05$export$d477129b070e5ac4 = {
    prefix: "fas",
    iconName: "comments-dollar",
    icon: [
        640,
        512,
        [],
        "f653",
        "M416 176c0 97.2-93.1 176-208 176c-38.2 0-73.9-8.7-104.7-23.9c-7.5 4-16 7.9-25.2 11.4C59.8 346.4 37.8 352 16 352c-6.9 0-13.1-4.5-15.2-11.1s.2-13.8 5.8-17.9l0 0 0 0 .2-.2c.2-.2 .6-.4 1.1-.8c1-.8 2.5-2 4.3-3.7c3.6-3.3 8.5-8.1 13.3-14.3c5.5-7 10.7-15.4 14.2-24.7C14.7 250.3 0 214.6 0 176C0 78.8 93.1 0 208 0S416 78.8 416 176zM231.5 383C348.9 372.9 448 288.3 448 176c0-5.2-.2-10.4-.6-15.5C555.1 167.1 640 243.2 640 336c0 38.6-14.7 74.3-39.6 103.4c3.5 9.4 8.7 17.7 14.2 24.7c4.8 6.2 9.7 11 13.3 14.3c1.8 1.6 3.3 2.9 4.3 3.7c.5 .4 .9 .7 1.1 .8l.2 .2 0 0 0 0c5.6 4.1 7.9 11.3 5.8 17.9c-2.1 6.6-8.3 11.1-15.2 11.1c-21.8 0-43.8-5.6-62.1-12.5c-9.2-3.5-17.8-7.4-25.2-11.4C505.9 503.3 470.2 512 432 512c-95.6 0-176.2-54.6-200.5-129zM228 72c0-11-9-20-20-20s-20 9-20 20V86c-7.6 1.7-15.2 4.4-22.2 8.5c-13.9 8.3-25.9 22.8-25.8 43.9c.1 20.3 12 33.1 24.7 40.7c11 6.6 24.7 10.8 35.6 14l1.7 .5c12.6 3.8 21.8 6.8 28 10.7c5.1 3.2 5.8 5.4 5.9 8.2c.1 5-1.8 8-5.9 10.5c-5 3.1-12.9 5-21.4 4.7c-11.1-.4-21.5-3.9-35.1-8.5c-2.3-.8-4.7-1.6-7.2-2.4c-10.5-3.5-21.8 2.2-25.3 12.6s2.2 21.8 12.6 25.3c1.9 .6 4 1.3 6.1 2.1l0 0 0 0c8.3 2.9 17.9 6.2 28.2 8.4V280c0 11 9 20 20 20s20-9 20-20V266.2c8-1.7 16-4.5 23.2-9c14.3-8.9 25.1-24.1 24.8-45c-.3-20.3-11.7-33.4-24.6-41.6c-11.5-7.2-25.9-11.6-37.1-15l-.7-.2c-12.8-3.9-21.9-6.7-28.3-10.5c-5.2-3.1-5.3-4.9-5.3-6.7c0-3.7 1.4-6.5 6.2-9.3c5.4-3.2 13.6-5.1 21.5-5c9.6 .1 20.2 2.2 31.2 5.2c10.7 2.8 21.6-3.5 24.5-14.2s-3.5-21.6-14.2-24.5c-6.5-1.7-13.7-3.4-21.1-4.7V72z"
    ]
};
var $d8206b3ab2e65c05$export$a1672d808fbed0bd = {
    prefix: "fas",
    iconName: "democrat",
    icon: [
        640,
        512,
        [],
        "f747",
        "M64 32c0-8.9 3.8-20.9 6.2-27.3C71.2 1.8 74 0 77 0c1.9 0 3.8 .7 5.2 2.1L128 45.7 173.8 2.1C175.2 .7 177.1 0 179 0c3 0 5.8 1.8 6.8 4.7c2.4 6.5 6.2 18.4 6.2 27.3c0 26.5-21.9 42-29.5 46.6l76.2 72.6c6 5.7 13.9 8.8 22.1 8.8H480l32 0c40.3 0 78.2 19 102.4 51.2l19.2 25.6c10.6 14.1 7.7 34.2-6.4 44.8s-34.2 7.7-44.8-6.4l-19.2-25.6c-5.3-7-11.8-12.8-19.2-17V320H192l-40.4-94.3c-3.9-9.2-15.3-12.6-23.6-7l-42.1 28c-9.1 6.1-19.7 9.3-30.7 9.3h-2C23.9 256 0 232.1 0 202.7c0-12.1 4.1-23.8 11.7-33.3L87.6 74.6C78.1 67.4 64 53.2 64 32zM448 352h96v64 64c0 17.7-14.3 32-32 32H480c-17.7 0-32-14.3-32-32V416H288v64c0 17.7-14.3 32-32 32H224c-17.7 0-32-14.3-32-32V416 352h96H448zM260.9 210.9c-.9-1.8-2.8-2.9-4.8-2.9s-3.9 1.1-4.8 2.9l-10.5 20.5-23.5 3.3c-2 .3-3.7 1.6-4.3 3.5s-.1 3.9 1.3 5.3l17 16-4 22.6c-.3 1.9 .5 3.9 2.1 5s3.8 1.3 5.6 .4l21-10.7 21 10.7c1.8 .9 4 .8 5.6-.4s2.5-3.1 2.1-5l-4-22.6 17-16c1.5-1.4 2-3.4 1.3-5.3s-2.3-3.2-4.3-3.5l-23.5-3.3-10.5-20.5zM368.1 208c-2 0-3.9 1.1-4.8 2.9l-10.5 20.5-23.5 3.3c-2 .3-3.7 1.6-4.3 3.5s-.1 3.9 1.3 5.3l17 16-4 22.6c-.3 1.9 .5 3.9 2.1 5s3.8 1.3 5.6 .4l21-10.7 21 10.7c1.8 .9 4 .8 5.6-.4s2.5-3.1 2.1-5l-4-22.6 17-16c1.5-1.4 2-3.4 1.4-5.3s-2.3-3.2-4.3-3.5l-23.5-3.3-10.5-20.5c-.9-1.8-2.8-2.9-4.8-2.9zm116.8 2.9c-.9-1.8-2.8-2.9-4.8-2.9s-3.9 1.1-4.8 2.9l-10.5 20.5-23.5 3.3c-2 .3-3.7 1.6-4.3 3.5s-.1 3.9 1.3 5.3l17 16-4 22.6c-.3 1.9 .5 3.9 2.1 5s3.8 1.3 5.6 .4l21-10.7 21 10.7c1.8 .9 4 .8 5.6-.4s2.5-3.1 2.1-5l-4-22.6 17-16c1.5-1.4 2-3.4 1.4-5.3s-2.3-3.2-4.3-3.5l-23.5-3.3-10.5-20.5z"
    ]
};
var $d8206b3ab2e65c05$export$3481c1aa28972f9b = {
    prefix: "fas",
    iconName: "z",
    icon: [
        384,
        512,
        [
            122
        ],
        "5a",
        "M0 64C0 46.3 14.3 32 32 32H352c12.4 0 23.7 7.2 29 18.4s3.6 24.5-4.4 34.1L100.3 416H352c17.7 0 32 14.3 32 32s-14.3 32-32 32H32c-12.4 0-23.7-7.2-29-18.4s-3.6-24.5 4.4-34.1L283.7 96H32C14.3 96 0 81.7 0 64z"
    ]
};
var $d8206b3ab2e65c05$export$5ebd3cd0630e3ae7 = {
    prefix: "fas",
    iconName: "person-skiing",
    icon: [
        512,
        512,
        [
            9975,
            "skiing"
        ],
        "f7c9",
        "M380.7 48a48 48 0 1 1 96 0 48 48 0 1 1 -96 0zM2.7 268.9c6.1-11.8 20.6-16.3 32.4-10.2L232.7 361.3l46.2-69.2-75.1-75.1c-14.6-14.6-20.4-33.9-18.4-52.1l108.8 52 39.3 39.3c16.2 16.2 18.7 41.5 6 60.6L289.8 391l128.7 66.8c13.6 7.1 29.8 7.2 43.6 .3l15.2-7.6c11.9-5.9 26.3-1.1 32.2 10.7s1.1 26.3-10.7 32.2l-15.2 7.6c-27.5 13.7-59.9 13.5-87.2-.7L12.9 301.3C1.2 295.2-3.4 280.7 2.7 268.9zM118.9 65.6L137 74.2l8.7-17.4c4-7.9 13.6-11.1 21.5-7.2s11.1 13.6 7.2 21.5l-8.5 16.9 54.7 26.2c1.5-.7 3.1-1.4 4.7-2.1l83.4-33.4c34.2-13.7 72.8 4.2 84.5 39.2l17.1 51.2 52.1 26.1c15.8 7.9 22.2 27.1 14.3 42.9s-27.1 22.2-42.9 14.3l-58.1-29c-11.4-5.7-20-15.7-24.1-27.8l-5.8-17.3-27.3 12.1-6.8 3-6.7-3.2L151.5 116.7l-9.2 18.4c-4 7.9-13.6 11.1-21.5 7.2s-11.1-13.6-7.2-21.5l9-18-17.6-8.4c-8-3.8-11.3-13.4-7.5-21.3s13.4-11.3 21.3-7.5z"
    ]
};
var $d8206b3ab2e65c05$export$eae1acab6fb96708 = $d8206b3ab2e65c05$export$5ebd3cd0630e3ae7;
var $d8206b3ab2e65c05$export$b81a894d5bc3eb17 = {
    prefix: "fas",
    iconName: "road-lock",
    icon: [
        640,
        512,
        [],
        "e567",
        "M288 32H213.2c-27.1 0-51.3 17.1-60.3 42.6L35.1 407.2c-2.1 5.9-3.1 12-3.1 18.2C32 455.5 56.5 480 86.6 480H288V416c0-17.7 14.3-32 32-32s32 14.3 32 32v64h32V352c0-23.7 12.9-44.4 32-55.4V272c0-58.3 44.6-106.2 101.5-111.5L487.1 74.6C478 49.1 453.9 32 426.8 32H352V96c0 17.7-14.3 32-32 32s-32-14.3-32-32V32zm64 192v64c0 17.7-14.3 32-32 32s-32-14.3-32-32V224c0-17.7 14.3-32 32-32s32 14.3 32 32zm176 16c17.7 0 32 14.3 32 32v48H496V272c0-17.7 14.3-32 32-32zm-80 32v48c-17.7 0-32 14.3-32 32V480c0 17.7 14.3 32 32 32H608c17.7 0 32-14.3 32-32V352c0-17.7-14.3-32-32-32V272c0-44.2-35.8-80-80-80s-80 35.8-80 80z"
    ]
};
var $d8206b3ab2e65c05$export$406fe05808a3753e = {
    prefix: "fas",
    iconName: "a",
    icon: [
        384,
        512,
        [
            97
        ],
        "41",
        "M221.5 51.7C216.6 39.8 204.9 32 192 32s-24.6 7.8-29.5 19.7l-120 288-40 96c-6.8 16.3 .9 35 17.2 41.8s35-.9 41.8-17.2L93.3 384H290.7l31.8 76.3c6.8 16.3 25.5 24 41.8 17.2s24-25.5 17.2-41.8l-40-96-120-288zM264 320H120l72-172.8L264 320z"
    ]
};
var $d8206b3ab2e65c05$export$4520eb1840c4e110 = {
    prefix: "fas",
    iconName: "temperature-arrow-down",
    icon: [
        576,
        512,
        [
            "temperature-down"
        ],
        "e03f",
        "M128 112c0-26.5 21.5-48 48-48s48 21.5 48 48V276.5c0 17.3 7.1 31.9 15.3 42.5C249.8 332.6 256 349.5 256 368c0 44.2-35.8 80-80 80s-80-35.8-80-80c0-18.5 6.2-35.4 16.7-48.9c8.2-10.6 15.3-25.2 15.3-42.5V112zM176 0C114.1 0 64 50.1 64 112V276.4c0 .1-.1 .3-.2 .6c-.2 .6-.8 1.6-1.7 2.8C43.2 304.2 32 334.8 32 368c0 79.5 64.5 144 144 144s144-64.5 144-144c0-33.2-11.2-63.8-30.1-88.1c-.9-1.2-1.5-2.2-1.7-2.8c-.1-.3-.2-.5-.2-.6V112C288 50.1 237.9 0 176 0zm0 416c26.5 0 48-21.5 48-48c0-20.9-13.4-38.7-32-45.3V272c0-8.8-7.2-16-16-16s-16 7.2-16 16v50.7c-18.6 6.6-32 24.4-32 45.3c0 26.5 21.5 48 48 48zm336-64H480V64c0-17.7-14.3-32-32-32s-32 14.3-32 32V352H384c-12.9 0-24.6 7.8-29.6 19.8s-2.2 25.7 6.9 34.9l64 64c6 6 14.1 9.4 22.6 9.4s16.6-3.4 22.6-9.4l64-64c9.2-9.2 11.9-22.9 6.9-34.9s-16.6-19.8-29.6-19.8z"
    ]
};
var $d8206b3ab2e65c05$export$f0b2aca3866f00f6 = $d8206b3ab2e65c05$export$4520eb1840c4e110;
var $d8206b3ab2e65c05$export$2a9d3e120019c92d = {
    prefix: "fas",
    iconName: "feather-pointed",
    icon: [
        512,
        512,
        [
            "feather-alt"
        ],
        "f56b",
        "M278.5 215.6L23 471c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l74.8-74.8c7.4 4.6 15.3 8.2 23.8 10.5C200.3 452.8 270 454.5 338 409.4c12.2-8.1 5.8-25.4-8.8-25.4l-16.1 0c-5.1 0-9.2-4.1-9.2-9.2c0-4.1 2.7-7.6 6.5-8.8l97.7-29.3c3.4-1 6.4-3.1 8.4-6.1c4.4-6.4 8.6-12.9 12.6-19.6c6.2-10.3-1.5-23-13.5-23l-38.6 0c-5.1 0-9.2-4.1-9.2-9.2c0-4.1 2.7-7.6 6.5-8.8l80.9-24.3c4.6-1.4 8.4-4.8 10.2-9.3C494.5 163 507.8 86.1 511.9 36.8c.8-9.9-3-19.6-10-26.6s-16.7-10.8-26.6-10C391.5 7 228.5 40.5 137.4 131.6C57.3 211.7 56.7 302.3 71.3 356.4c2.1 7.9 12 9.6 17.8 3.8L253.6 195.8c6.2-6.2 16.4-6.2 22.6 0c5.4 5.4 6.1 13.6 2.2 19.8z"
    ]
};
var $d8206b3ab2e65c05$export$68cf766c786bcd78 = $d8206b3ab2e65c05$export$2a9d3e120019c92d;
var $d8206b3ab2e65c05$export$bcb419f1cd5beac3 = {
    prefix: "fas",
    iconName: "p",
    icon: [
        320,
        512,
        [
            112
        ],
        "50",
        "M0 96C0 60.7 28.7 32 64 32h96c88.4 0 160 71.6 160 160s-71.6 160-160 160H64v96c0 17.7-14.3 32-32 32s-32-14.3-32-32V320 96zM64 288h96c53 0 96-43 96-96s-43-96-96-96H64V288z"
    ]
};
var $d8206b3ab2e65c05$export$bab8f3647c394f48 = {
    prefix: "fas",
    iconName: "snowflake",
    icon: [
        448,
        512,
        [
            10052,
            10054
        ],
        "f2dc",
        "M224 0c17.7 0 32 14.3 32 32V62.1l15-15c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9l-49 49v70.3l61.4-35.8 17.7-66.1c3.4-12.8 16.6-20.4 29.4-17s20.4 16.6 17 29.4l-5.2 19.3 23.6-13.8c15.3-8.9 34.9-3.7 43.8 11.5s3.8 34.9-11.5 43.8l-25.3 14.8 21.7 5.8c12.8 3.4 20.4 16.6 17 29.4s-16.6 20.4-29.4 17l-67.7-18.1L287.5 256l60.9 35.5 67.7-18.1c12.8-3.4 26 4.2 29.4 17s-4.2 26-17 29.4l-21.7 5.8 25.3 14.8c15.3 8.9 20.4 28.5 11.5 43.8s-28.5 20.4-43.8 11.5l-23.6-13.8 5.2 19.3c3.4 12.8-4.2 26-17 29.4s-26-4.2-29.4-17l-17.7-66.1L256 311.7v70.3l49 49c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0l-15-15V480c0 17.7-14.3 32-32 32s-32-14.3-32-32V449.9l-15 15c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l49-49V311.7l-61.4 35.8-17.7 66.1c-3.4 12.8-16.6 20.4-29.4 17s-20.4-16.6-17-29.4l5.2-19.3L48.1 395.6c-15.3 8.9-34.9 3.7-43.8-11.5s-3.7-34.9 11.5-43.8l25.3-14.8-21.7-5.8c-12.8-3.4-20.4-16.6-17-29.4s16.6-20.4 29.4-17l67.7 18.1L160.5 256 99.6 220.5 31.9 238.6c-12.8 3.4-26-4.2-29.4-17s4.2-26 17-29.4l21.7-5.8L15.9 171.6C.6 162.7-4.5 143.1 4.4 127.9s28.5-20.4 43.8-11.5l23.6 13.8-5.2-19.3c-3.4-12.8 4.2-26 17-29.4s26 4.2 29.4 17l17.7 66.1L192 200.3V129.9L143 81c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l15 15V32c0-17.7 14.3-32 32-32z"
    ]
};
var $d8206b3ab2e65c05$export$d91b374112d4f8c1 = {
    prefix: "fas",
    iconName: "newspaper",
    icon: [
        512,
        512,
        [
            128240
        ],
        "f1ea",
        "M96 96c0-35.3 28.7-64 64-64H448c35.3 0 64 28.7 64 64V416c0 35.3-28.7 64-64 64H80c-44.2 0-80-35.8-80-80V128c0-17.7 14.3-32 32-32s32 14.3 32 32V400c0 8.8 7.2 16 16 16s16-7.2 16-16V96zm64 24v80c0 13.3 10.7 24 24 24H296c13.3 0 24-10.7 24-24V120c0-13.3-10.7-24-24-24H184c-13.3 0-24 10.7-24 24zm208-8c0 8.8 7.2 16 16 16h48c8.8 0 16-7.2 16-16s-7.2-16-16-16H384c-8.8 0-16 7.2-16 16zm0 96c0 8.8 7.2 16 16 16h48c8.8 0 16-7.2 16-16s-7.2-16-16-16H384c-8.8 0-16 7.2-16 16zM160 304c0 8.8 7.2 16 16 16H432c8.8 0 16-7.2 16-16s-7.2-16-16-16H176c-8.8 0-16 7.2-16 16zm0 96c0 8.8 7.2 16 16 16H432c8.8 0 16-7.2 16-16s-7.2-16-16-16H176c-8.8 0-16 7.2-16 16z"
    ]
};
var $d8206b3ab2e65c05$export$d0ccaddca9e06d1e = {
    prefix: "fas",
    iconName: "rectangle-ad",
    icon: [
        576,
        512,
        [
            "ad"
        ],
        "f641",
        "M64 32C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H512c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64zM229.5 173.3l72 144c5.9 11.9 1.1 26.3-10.7 32.2s-26.3 1.1-32.2-10.7L253.2 328H162.8l-5.4 10.7c-5.9 11.9-20.3 16.7-32.2 10.7s-16.7-20.3-10.7-32.2l72-144c4.1-8.1 12.4-13.3 21.5-13.3s17.4 5.1 21.5 13.3zM208 237.7L186.8 280h42.3L208 237.7zM392 256a24 24 0 1 0 0 48 24 24 0 1 0 0-48zm24-43.9V184c0-13.3 10.7-24 24-24s24 10.7 24 24v96 48c0 13.3-10.7 24-24 24c-6.6 0-12.6-2.7-17-7c-9.4 4.5-19.9 7-31 7c-39.8 0-72-32.2-72-72s32.2-72 72-72c8.4 0 16.5 1.4 24 4.1z"
    ]
};
var $d8206b3ab2e65c05$export$7af266c3465b1ff2 = $d8206b3ab2e65c05$export$d0ccaddca9e06d1e;
var $d8206b3ab2e65c05$export$2f1e22e081a1ad05 = {
    prefix: "fas",
    iconName: "circle-arrow-right",
    icon: [
        512,
        512,
        [
            "arrow-circle-right"
        ],
        "f0a9",
        "M0 256a256 256 0 1 0 512 0A256 256 0 1 0 0 256zM281 385c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l71-71L136 280c-13.3 0-24-10.7-24-24s10.7-24 24-24l182.1 0-71-71c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0L393 239c9.4 9.4 9.4 24.6 0 33.9L281 385z"
    ]
};
var $d8206b3ab2e65c05$export$7d3d828103aa3be7 = $d8206b3ab2e65c05$export$2f1e22e081a1ad05;
var $d8206b3ab2e65c05$export$fb5ab619c34ea613 = {
    prefix: "fas",
    iconName: "filter-circle-xmark",
    icon: [
        576,
        512,
        [],
        "e17b",
        "M3.9 22.9C10.5 8.9 24.5 0 40 0H472c15.5 0 29.5 8.9 36.1 22.9s4.6 30.5-5.2 42.5L396.4 195.6C316.2 212.1 256 283 256 368c0 27.4 6.3 53.4 17.5 76.5c-1.6-.8-3.2-1.8-4.7-2.9l-64-48c-8.1-6-12.8-15.5-12.8-25.6V288.9L9 65.3C-.7 53.4-2.8 36.8 3.9 22.9zM432 224a144 144 0 1 1 0 288 144 144 0 1 1 0-288zm59.3 107.3c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0L432 345.4l-36.7-36.7c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6L409.4 368l-36.7 36.7c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0L432 390.6l36.7 36.7c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6L454.6 368l36.7-36.7z"
    ]
};
var $d8206b3ab2e65c05$export$4982360d3b844c19 = {
    prefix: "fas",
    iconName: "locust",
    icon: [
        576,
        512,
        [],
        "e520",
        "M312 32c-13.3 0-24 10.7-24 24s10.7 24 24 24h16c98.7 0 180.6 71.4 197 165.4c-9-3.5-18.8-5.4-29-5.4H431.8l-41.8-97.5c-3.4-7.9-10.8-13.4-19.3-14.4s-17 2.7-22.1 9.6l-40.9 55.5-21.7-50.7c-3.3-7.8-10.5-13.2-18.9-14.3s-16.7 2.3-22 8.9l-240 304c-8.2 10.4-6.4 25.5 4 33.7s25.5 6.4 33.7-4l79.4-100.5 43 16.4-40.5 55c-7.9 10.7-5.6 25.7 5.1 33.6s25.7 5.6 33.6-5.1L215.1 400h74.5l-29.3 42.3c-7.5 10.9-4.8 25.8 6.1 33.4s25.8 4.8 33.4-6.1L348 400h80.4l38.8 67.9c6.6 11.5 21.2 15.5 32.7 8.9s15.5-21.2 8.9-32.7L483.6 400H496c44.1 0 79.8-35.7 80-79.7c0-.1 0-.2 0-.3V280C576 143 465 32 328 32H312zm50.5 168l17.1 40H333l29.5-40zm-87.7 38.1l-1.4 1.9H225.1l32.7-41.5 16.9 39.5zM88.8 240C57.4 240 32 265.4 32 296.8c0 15.5 6.3 30 16.9 40.4L126.7 240H88.8zM496 288a16 16 0 1 1 0 32 16 16 0 1 1 0-32z"
    ]
};
var $d8206b3ab2e65c05$export$4941c5969d5399b = {
    prefix: "fas",
    iconName: "sort",
    icon: [
        320,
        512,
        [
            "unsorted"
        ],
        "f0dc",
        "M137.4 41.4c12.5-12.5 32.8-12.5 45.3 0l128 128c9.2 9.2 11.9 22.9 6.9 34.9s-16.6 19.8-29.6 19.8H32c-12.9 0-24.6-7.8-29.6-19.8s-2.2-25.7 6.9-34.9l128-128zm0 429.3l-128-128c-9.2-9.2-11.9-22.9-6.9-34.9s16.6-19.8 29.6-19.8H288c12.9 0 24.6 7.8 29.6 19.8s2.2 25.7-6.9 34.9l-128 128c-12.5 12.5-32.8 12.5-45.3 0z"
    ]
};
var $d8206b3ab2e65c05$export$418597748f0fe52d = $d8206b3ab2e65c05$export$4941c5969d5399b;
var $d8206b3ab2e65c05$export$3db8f67cd0fc963b = {
    prefix: "fas",
    iconName: "list-ol",
    icon: [
        512,
        512,
        [
            "list-1-2",
            "list-numeric"
        ],
        "f0cb",
        "M24 56c0-13.3 10.7-24 24-24H80c13.3 0 24 10.7 24 24V176h16c13.3 0 24 10.7 24 24s-10.7 24-24 24H40c-13.3 0-24-10.7-24-24s10.7-24 24-24H56V80H48C34.7 80 24 69.3 24 56zM86.7 341.2c-6.5-7.4-18.3-6.9-24 1.2L51.5 357.9c-7.7 10.8-22.7 13.3-33.5 5.6s-13.3-22.7-5.6-33.5l11.1-15.6c23.7-33.2 72.3-35.6 99.2-4.9c21.3 24.4 20.8 60.9-1.1 84.7L86.8 432H120c13.3 0 24 10.7 24 24s-10.7 24-24 24H32c-9.5 0-18.2-5.6-22-14.4s-2.1-18.9 4.3-25.9l72-78c5.3-5.8 5.4-14.6 .3-20.5zM224 64H480c17.7 0 32 14.3 32 32s-14.3 32-32 32H224c-17.7 0-32-14.3-32-32s14.3-32 32-32zm0 160H480c17.7 0 32 14.3 32 32s-14.3 32-32 32H224c-17.7 0-32-14.3-32-32s14.3-32 32-32zm0 160H480c17.7 0 32 14.3 32 32s-14.3 32-32 32H224c-17.7 0-32-14.3-32-32s14.3-32 32-32z"
    ]
};
var $d8206b3ab2e65c05$export$7e3d894cd55296b = $d8206b3ab2e65c05$export$3db8f67cd0fc963b;
var $d8206b3ab2e65c05$export$cf51408faadac277 = $d8206b3ab2e65c05$export$3db8f67cd0fc963b;
var $d8206b3ab2e65c05$export$523180e731928397 = {
    prefix: "fas",
    iconName: "person-dress-burst",
    icon: [
        640,
        512,
        [],
        "e544",
        "M528 48a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zM390.2 384H408v96c0 17.7 14.3 32 32 32s32-14.3 32-32V384h16v96c0 17.7 14.3 32 32 32s32-14.3 32-32V384h17.8c10.9 0 18.6-10.7 15.2-21.1L546.7 248.1l33.9 56.3c9.1 15.1 28.8 20 43.9 10.9s20-28.8 10.9-43.9l-53.6-89.2c-20.2-33.7-56.7-54.3-96-54.3H474.2c-39.3 0-75.7 20.6-96 54.3l-53.6 89.2c-9.1 15.1-4.2 34.8 10.9 43.9s34.8 4.2 43.9-10.9l33.9-56.3L375 362.9c-3.5 10.4 4.3 21.1 15.2 21.1zM190.9 18.1C188.4 12 182.6 8 176 8s-12.4 4-14.9 10.1l-29.4 74L55.6 68.9c-6.3-1.9-13.1 .2-17.2 5.3s-4.6 12.2-1.4 17.9l39.5 69.1L10.9 206.4c-5.4 3.7-8 10.3-6.5 16.7s6.7 11.2 13.1 12.2l78.7 12.2L90.6 327c-.5 6.5 3.1 12.7 9 15.5s12.9 1.8 17.8-2.6L176 286.1l58.6 53.9c4.8 4.4 11.9 5.5 17.8 2.6s9.5-9 9-15.5l-5.6-79.4 50.5-7.8 24.4-40.5-55.2-38L315 92.2c3.3-5.7 2.7-12.8-1.4-17.9s-10.9-7.2-17.2-5.3L220.3 92.1l-29.4-74z"
    ]
};
var $d8206b3ab2e65c05$export$eeb59dd1825c6a65 = {
    prefix: "fas",
    iconName: "money-check-dollar",
    icon: [
        576,
        512,
        [
            "money-check-alt"
        ],
        "f53d",
        "M64 64C28.7 64 0 92.7 0 128V384c0 35.3 28.7 64 64 64H512c35.3 0 64-28.7 64-64V128c0-35.3-28.7-64-64-64H64zM272 192H496c8.8 0 16 7.2 16 16s-7.2 16-16 16H272c-8.8 0-16-7.2-16-16s7.2-16 16-16zM256 304c0-8.8 7.2-16 16-16H496c8.8 0 16 7.2 16 16s-7.2 16-16 16H272c-8.8 0-16-7.2-16-16zM164 152v13.9c7.5 1.2 14.6 2.9 21.1 4.7c10.7 2.8 17 13.8 14.2 24.5s-13.8 17-24.5 14.2c-11-2.9-21.6-5-31.2-5.2c-7.9-.1-16 1.8-21.5 5c-4.8 2.8-6.2 5.6-6.2 9.3c0 1.8 .1 3.5 5.3 6.7c6.3 3.8 15.5 6.7 28.3 10.5l.7 .2c11.2 3.4 25.6 7.7 37.1 15c12.9 8.1 24.3 21.3 24.6 41.6c.3 20.9-10.5 36.1-24.8 45c-7.2 4.5-15.2 7.3-23.2 9V360c0 11-9 20-20 20s-20-9-20-20V345.4c-10.3-2.2-20-5.5-28.2-8.4l0 0 0 0c-2.1-.7-4.1-1.4-6.1-2.1c-10.5-3.5-16.1-14.8-12.6-25.3s14.8-16.1 25.3-12.6c2.5 .8 4.9 1.7 7.2 2.4c13.6 4.6 24 8.1 35.1 8.5c8.6 .3 16.5-1.6 21.4-4.7c4.1-2.5 6-5.5 5.9-10.5c0-2.9-.8-5-5.9-8.2c-6.3-4-15.4-6.9-28-10.7l-1.7-.5c-10.9-3.3-24.6-7.4-35.6-14c-12.7-7.7-24.6-20.5-24.7-40.7c-.1-21.1 11.8-35.7 25.8-43.9c6.9-4.1 14.5-6.8 22.2-8.5V152c0-11 9-20 20-20s20 9 20 20z"
    ]
};
var $d8206b3ab2e65c05$export$8c6ccc9745897cb2 = $d8206b3ab2e65c05$export$eeb59dd1825c6a65;
var $d8206b3ab2e65c05$export$567d5631a7b0599f = {
    prefix: "fas",
    iconName: "vector-square",
    icon: [
        448,
        512,
        [],
        "f5cb",
        "M368 80h32v32H368V80zM352 32c-17.7 0-32 14.3-32 32H128c0-17.7-14.3-32-32-32H32C14.3 32 0 46.3 0 64v64c0 17.7 14.3 32 32 32V352c-17.7 0-32 14.3-32 32v64c0 17.7 14.3 32 32 32H96c17.7 0 32-14.3 32-32H320c0 17.7 14.3 32 32 32h64c17.7 0 32-14.3 32-32V384c0-17.7-14.3-32-32-32V160c17.7 0 32-14.3 32-32V64c0-17.7-14.3-32-32-32H352zM96 160c17.7 0 32-14.3 32-32H320c0 17.7 14.3 32 32 32V352c-17.7 0-32 14.3-32 32H128c0-17.7-14.3-32-32-32V160zM48 400H80v32H48V400zm320 32V400h32v32H368zM48 112V80H80v32H48z"
    ]
};
var $d8206b3ab2e65c05$export$d78e8b0681279167 = {
    prefix: "fas",
    iconName: "bread-slice",
    icon: [
        512,
        512,
        [],
        "f7ec",
        "M256 32C192 32 0 64 0 192c0 35.3 28.7 64 64 64V432c0 26.5 21.5 48 48 48H400c26.5 0 48-21.5 48-48V256c35.3 0 64-28.7 64-64C512 64 320 32 256 32z"
    ]
};
var $d8206b3ab2e65c05$export$8a7bee49fdf8c954 = {
    prefix: "fas",
    iconName: "language",
    icon: [
        640,
        512,
        [],
        "f1ab",
        "M0 128C0 92.7 28.7 64 64 64H256h48 16H576c35.3 0 64 28.7 64 64V384c0 35.3-28.7 64-64 64H320 304 256 64c-35.3 0-64-28.7-64-64V128zm320 0V384H576V128H320zM178.3 175.9c-3.2-7.2-10.4-11.9-18.3-11.9s-15.1 4.7-18.3 11.9l-64 144c-4.5 10.1 .1 21.9 10.2 26.4s21.9-.1 26.4-10.2l8.9-20.1h73.6l8.9 20.1c4.5 10.1 16.3 14.6 26.4 10.2s14.6-16.3 10.2-26.4l-64-144zM160 233.2L179 276H141l19-42.8zM448 164c11 0 20 9 20 20v4h44 16c11 0 20 9 20 20s-9 20-20 20h-2l-1.6 4.5c-8.9 24.4-22.4 46.6-39.6 65.4c.9 .6 1.8 1.1 2.7 1.6l18.9 11.3c9.5 5.7 12.5 18 6.9 27.4s-18 12.5-27.4 6.9l-18.9-11.3c-4.5-2.7-8.8-5.5-13.1-8.5c-10.6 7.5-21.9 14-34 19.4l-3.6 1.6c-10.1 4.5-21.9-.1-26.4-10.2s.1-21.9 10.2-26.4l3.6-1.6c6.4-2.9 12.6-6.1 18.5-9.8l-12.2-12.2c-7.8-7.8-7.8-20.5 0-28.3s20.5-7.8 28.3 0l14.6 14.6 .5 .5c12.4-13.1 22.5-28.3 29.8-45H448 376c-11 0-20-9-20-20s9-20 20-20h52v-4c0-11 9-20 20-20z"
    ]
};
var $d8206b3ab2e65c05$export$611ae61f02de0aa = {
    prefix: "fas",
    iconName: "face-kiss-wink-heart",
    icon: [
        512,
        512,
        [
            128536,
            "kiss-wink-heart"
        ],
        "f598",
        "M498 339.7c9.1-26.2 14-54.4 14-83.7C512 114.6 397.4 0 256 0S0 114.6 0 256S114.6 512 256 512c35.4 0 69.1-7.2 99.7-20.2c-4.8-5.5-8.5-12.2-10.4-19.7l-22.9-89.3c-10-39 11.8-80.9 51.8-92.1c37.2-10.4 73.8 10.1 87.5 44c12.7-1.6 25.1 .4 36.2 5zM296 332c0 6.9-3.1 13.2-7.3 18.3c-4.3 5.2-10.1 9.7-16.7 13.4c-2.7 1.5-5.7 3-8.7 4.3c3.1 1.3 6 2.7 8.7 4.3c6.6 3.7 12.5 8.2 16.7 13.4c4.3 5.1 7.3 11.4 7.3 18.3s-3.1 13.2-7.3 18.3c-4.3 5.2-10.1 9.7-16.7 13.4C258.7 443.1 241.4 448 224 448c-3.6 0-6.8-2.5-7.7-6s.6-7.2 3.8-9l0 0 0 0 0 0 0 0 .2-.1c.2-.1 .5-.3 .9-.5c.8-.5 2-1.2 3.4-2.1c2.8-1.9 6.5-4.5 10.2-7.6c3.7-3.1 7.2-6.6 9.6-10.1c2.5-3.5 3.5-6.4 3.5-8.6s-1-5-3.5-8.6c-2.5-3.5-5.9-6.9-9.6-10.1c-3.7-3.1-7.4-5.7-10.2-7.6c-1.4-.9-2.6-1.6-3.4-2.1l-.6-.4-.3-.2-.2-.1 0 0 0 0 0 0c-2.5-1.4-4.1-4.1-4.1-7s1.6-5.6 4.1-7l0 0 0 0 0 0 0 0 0 0 .2-.1c.2-.1 .5-.3 .9-.5c.8-.5 2-1.2 3.4-2.1c2.8-1.9 6.5-4.5 10.2-7.6c3.7-3.1 7.2-6.6 9.6-10.1c2.5-3.5 3.5-6.4 3.5-8.6s-1-5-3.5-8.6c-2.5-3.5-5.9-6.9-9.6-10.1c-3.7-3.1-7.4-5.7-10.2-7.6c-1.4-.9-2.6-1.6-3.4-2.1c-.4-.2-.7-.4-.9-.5l-.2-.1 0 0 0 0 0 0c-3.2-1.8-4.7-5.5-3.8-9s4.1-6 7.7-6c17.4 0 34.7 4.9 47.9 12.3c6.6 3.7 12.5 8.2 16.7 13.4c4.3 5.1 7.3 11.4 7.3 18.3zM176.4 176a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm194.8 57.6c-17.6-23.5-52.8-23.5-70.4 0c-5.3 7.1-15.3 8.5-22.4 3.2s-8.5-15.3-3.2-22.4c30.4-40.5 91.2-40.5 121.6 0c5.3 7.1 3.9 17.1-3.2 22.4s-17.1 3.9-22.4-3.2zM434 352.3c-6-23.2-28.8-37-51.1-30.8s-35.4 30.1-29.5 53.4l22.9 89.3c2.2 8.7 11.2 13.9 19.8 11.4l84.9-23.8c22.2-6.2 35.4-30.1 29.5-53.4s-28.8-37-51.1-30.8l-20.2 5.6-5.4-21z"
    ]
};
var $d8206b3ab2e65c05$export$ebba617701dfb917 = $d8206b3ab2e65c05$export$611ae61f02de0aa;
var $d8206b3ab2e65c05$export$f253a38d7142e29f = {
    prefix: "fas",
    iconName: "filter",
    icon: [
        512,
        512,
        [],
        "f0b0",
        "M3.9 54.9C10.5 40.9 24.5 32 40 32H472c15.5 0 29.5 8.9 36.1 22.9s4.6 30.5-5.2 42.5L320 320.9V448c0 12.1-6.8 23.2-17.7 28.6s-23.8 4.3-33.5-3l-64-48c-8.1-6-12.8-15.5-12.8-25.6V320.9L9 97.3C-.7 85.4-2.8 68.8 3.9 54.9z"
    ]
};
var $d8206b3ab2e65c05$export$d96973f90e8f6e47 = {
    prefix: "fas",
    iconName: "question",
    icon: [
        320,
        512,
        [
            10067,
            10068,
            61736
        ],
        "3f",
        "M80 160c0-35.3 28.7-64 64-64h32c35.3 0 64 28.7 64 64v3.6c0 21.8-11.1 42.1-29.4 53.8l-42.2 27.1c-25.2 16.2-40.4 44.1-40.4 74V320c0 17.7 14.3 32 32 32s32-14.3 32-32v-1.4c0-8.2 4.2-15.8 11-20.2l42.2-27.1c36.6-23.6 58.8-64.1 58.8-107.7V160c0-70.7-57.3-128-128-128H144C73.3 32 16 89.3 16 160c0 17.7 14.3 32 32 32s32-14.3 32-32zm80 320a40 40 0 1 0 0-80 40 40 0 1 0 0 80z"
    ]
};
var $d8206b3ab2e65c05$export$d0de575ac166712b = {
    prefix: "fas",
    iconName: "file-signature",
    icon: [
        576,
        512,
        [],
        "f573",
        "M64 0C28.7 0 0 28.7 0 64V448c0 35.3 28.7 64 64 64H320c35.3 0 64-28.7 64-64V428.7c-2.7 1.1-5.4 2-8.2 2.7l-60.1 15c-3 .7-6 1.2-9 1.4c-.9 .1-1.8 .2-2.7 .2H240c-6.1 0-11.6-3.4-14.3-8.8l-8.8-17.7c-1.7-3.4-5.1-5.5-8.8-5.5s-7.2 2.1-8.8 5.5l-8.8 17.7c-2.9 5.9-9.2 9.4-15.7 8.8s-12.1-5.1-13.9-11.3L144 381l-9.8 32.8c-6.1 20.3-24.8 34.2-46 34.2H80c-8.8 0-16-7.2-16-16s7.2-16 16-16h8.2c7.1 0 13.3-4.6 15.3-11.4l14.9-49.5c3.4-11.3 13.8-19.1 25.6-19.1s22.2 7.8 25.6 19.1l11.6 38.6c7.4-6.2 16.8-9.7 26.8-9.7c15.9 0 30.4 9 37.5 23.2l4.4 8.8h8.9c-3.1-8.8-3.7-18.4-1.4-27.8l15-60.1c2.8-11.3 8.6-21.5 16.8-29.7L384 203.6V160H256c-17.7 0-32-14.3-32-32V0H64zM256 0V128H384L256 0zM549.8 139.7c-15.6-15.6-40.9-15.6-56.6 0l-29.4 29.4 71 71 29.4-29.4c15.6-15.6 15.6-40.9 0-56.6l-14.4-14.4zM311.9 321c-4.1 4.1-7 9.2-8.4 14.9l-15 60.1c-1.4 5.5 .2 11.2 4.2 15.2s9.7 5.6 15.2 4.2l60.1-15c5.6-1.4 10.8-4.3 14.9-8.4L512.1 262.7l-71-71L311.9 321z"
    ]
};
var $d8206b3ab2e65c05$export$cd7b22f4e6e3834b = {
    prefix: "fas",
    iconName: "up-down-left-right",
    icon: [
        512,
        512,
        [
            "arrows-alt"
        ],
        "f0b2",
        "M278.6 9.4c-12.5-12.5-32.8-12.5-45.3 0l-64 64c-9.2 9.2-11.9 22.9-6.9 34.9s16.6 19.8 29.6 19.8h32v96H128V192c0-12.9-7.8-24.6-19.8-29.6s-25.7-2.2-34.9 6.9l-64 64c-12.5 12.5-12.5 32.8 0 45.3l64 64c9.2 9.2 22.9 11.9 34.9 6.9s19.8-16.6 19.8-29.6V288h96v96H192c-12.9 0-24.6 7.8-29.6 19.8s-2.2 25.7 6.9 34.9l64 64c12.5 12.5 32.8 12.5 45.3 0l64-64c9.2-9.2 11.9-22.9 6.9-34.9s-16.6-19.8-29.6-19.8H288V288h96v32c0 12.9 7.8 24.6 19.8 29.6s25.7 2.2 34.9-6.9l64-64c12.5-12.5 12.5-32.8 0-45.3l-64-64c-9.2-9.2-22.9-11.9-34.9-6.9s-19.8 16.6-19.8 29.6v32H288V128h32c12.9 0 24.6-7.8 29.6-19.8s2.2-25.7-6.9-34.9l-64-64z"
    ]
};
var $d8206b3ab2e65c05$export$3cdabfff52cfc73a = $d8206b3ab2e65c05$export$cd7b22f4e6e3834b;
var $d8206b3ab2e65c05$export$1ddbaebce033a0d = {
    prefix: "fas",
    iconName: "house-chimney-user",
    icon: [
        576,
        512,
        [],
        "e065",
        "M543.8 287.6c17 0 32-14 32-32.1c1-9-3-17-11-24L512 185V64c0-17.7-14.3-32-32-32H448c-17.7 0-32 14.3-32 32v36.7L309.5 7c-6-5-14-7-21-7s-15 1-22 8L10 231.5c-7 7-10 15-10 24c0 18 14 32.1 32 32.1h32V448c0 35.3 28.7 64 64 64H448.5c35.5 0 64.2-28.8 64-64.3l-.7-160.2h32zM288 160a64 64 0 1 1 0 128 64 64 0 1 1 0-128zM176 400c0-44.2 35.8-80 80-80h64c44.2 0 80 35.8 80 80c0 8.8-7.2 16-16 16H192c-8.8 0-16-7.2-16-16z"
    ]
};
var $d8206b3ab2e65c05$export$97e5ef3e80a0fbef = {
    prefix: "fas",
    iconName: "hand-holding-heart",
    icon: [
        576,
        512,
        [],
        "f4be",
        "M163.9 136.9c-29.4-29.8-29.4-78.2 0-108s77-29.8 106.4 0l17.7 18 17.7-18c29.4-29.8 77-29.8 106.4 0s29.4 78.2 0 108L310.5 240.1c-6.2 6.3-14.3 9.4-22.5 9.4s-16.3-3.1-22.5-9.4L163.9 136.9zM568.2 336.3c13.1 17.8 9.3 42.8-8.5 55.9L433.1 485.5c-23.4 17.2-51.6 26.5-80.7 26.5H192 32c-17.7 0-32-14.3-32-32V416c0-17.7 14.3-32 32-32H68.8l44.9-36c22.7-18.2 50.9-28 80-28H272h16 64c17.7 0 32 14.3 32 32s-14.3 32-32 32H288 272c-8.8 0-16 7.2-16 16s7.2 16 16 16H392.6l119.7-88.2c17.8-13.1 42.8-9.3 55.9 8.5zM193.6 384l0 0-.9 0c.3 0 .6 0 .9 0z"
    ]
};
var $d8206b3ab2e65c05$export$7ee0dbd1e92e2859 = {
    prefix: "fas",
    iconName: "puzzle-piece",
    icon: [
        512,
        512,
        [
            129513
        ],
        "f12e",
        "M192 104.8c0-9.2-5.8-17.3-13.2-22.8C167.2 73.3 160 61.3 160 48c0-26.5 28.7-48 64-48s64 21.5 64 48c0 13.3-7.2 25.3-18.8 34c-7.4 5.5-13.2 13.6-13.2 22.8v0c0 12.8 10.4 23.2 23.2 23.2H336c26.5 0 48 21.5 48 48v56.8c0 12.8 10.4 23.2 23.2 23.2v0c9.2 0 17.3-5.8 22.8-13.2c8.7-11.6 20.7-18.8 34-18.8c26.5 0 48 28.7 48 64s-21.5 64-48 64c-13.3 0-25.3-7.2-34-18.8c-5.5-7.4-13.6-13.2-22.8-13.2v0c-12.8 0-23.2 10.4-23.2 23.2V464c0 26.5-21.5 48-48 48H279.2c-12.8 0-23.2-10.4-23.2-23.2v0c0-9.2 5.8-17.3 13.2-22.8c11.6-8.7 18.8-20.7 18.8-34c0-26.5-28.7-48-64-48s-64 21.5-64 48c0 13.3 7.2 25.3 18.8 34c7.4 5.5 13.2 13.6 13.2 22.8v0c0 12.8-10.4 23.2-23.2 23.2H48c-26.5 0-48-21.5-48-48V343.2C0 330.4 10.4 320 23.2 320v0c9.2 0 17.3 5.8 22.8 13.2C54.7 344.8 66.7 352 80 352c26.5 0 48-28.7 48-64s-21.5-64-48-64c-13.3 0-25.3 7.2-34 18.8C40.5 250.2 32.4 256 23.2 256v0C10.4 256 0 245.6 0 232.8V176c0-26.5 21.5-48 48-48H168.8c12.8 0 23.2-10.4 23.2-23.2v0z"
    ]
};
var $d8206b3ab2e65c05$export$be069f641c85d0b3 = {
    prefix: "fas",
    iconName: "money-check",
    icon: [
        576,
        512,
        [],
        "f53c",
        "M64 64C28.7 64 0 92.7 0 128V384c0 35.3 28.7 64 64 64H512c35.3 0 64-28.7 64-64V128c0-35.3-28.7-64-64-64H64zm48 160H272c8.8 0 16 7.2 16 16s-7.2 16-16 16H112c-8.8 0-16-7.2-16-16s7.2-16 16-16zM96 336c0-8.8 7.2-16 16-16H464c8.8 0 16 7.2 16 16s-7.2 16-16 16H112c-8.8 0-16-7.2-16-16zM376 160h80c13.3 0 24 10.7 24 24v48c0 13.3-10.7 24-24 24H376c-13.3 0-24-10.7-24-24V184c0-13.3 10.7-24 24-24z"
    ]
};
var $d8206b3ab2e65c05$export$3e4892d8bf919edd = {
    prefix: "fas",
    iconName: "star-half-stroke",
    icon: [
        640,
        512,
        [
            "star-half-alt"
        ],
        "f5c0",
        "M320 376.4l.1-.1 26.4 14.1 85.2 45.5-16.5-97.6-4.8-28.7 20.7-20.5 70.1-69.3-96.1-14.2-29.3-4.3-12.9-26.6L320.1 86.9l-.1 .3V376.4zm175.1 98.3c2 12-3 24.2-12.9 31.3s-23 8-33.8 2.3L320.1 439.8 191.8 508.3C181 514 167.9 513.1 158 506s-14.9-19.3-12.9-31.3L169.8 329 65.6 225.9c-8.6-8.5-11.7-21.2-7.9-32.7s13.7-19.9 25.7-21.7L227 150.3 291.4 18c5.4-11 16.5-18 28.8-18s23.4 7 28.8 18l64.3 132.3 143.6 21.2c12 1.8 22 10.2 25.7 21.7s.7 24.2-7.9 32.7L470.5 329l24.6 145.7z"
    ]
};
var $d8206b3ab2e65c05$export$c13575f42532efb3 = $d8206b3ab2e65c05$export$3e4892d8bf919edd;
var $d8206b3ab2e65c05$export$eba095993e51cc97 = {
    prefix: "fas",
    iconName: "code",
    icon: [
        640,
        512,
        [],
        "f121",
        "M392.8 1.2c-17-4.9-34.7 5-39.6 22l-128 448c-4.9 17 5 34.7 22 39.6s34.7-5 39.6-22l128-448c4.9-17-5-34.7-22-39.6zm80.6 120.1c-12.5 12.5-12.5 32.8 0 45.3L562.7 256l-89.4 89.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0l112-112c12.5-12.5 12.5-32.8 0-45.3l-112-112c-12.5-12.5-32.8-12.5-45.3 0zm-306.7 0c-12.5-12.5-32.8-12.5-45.3 0l-112 112c-12.5 12.5-12.5 32.8 0 45.3l112 112c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L77.3 256l89.4-89.4c12.5-12.5 12.5-32.8 0-45.3z"
    ]
};
var $d8206b3ab2e65c05$export$f1304dd34ea2afbd = {
    prefix: "fas",
    iconName: "whiskey-glass",
    icon: [
        512,
        512,
        [
            129347,
            "glass-whiskey"
        ],
        "f7a0",
        "M32 32c-9.3 0-18.1 4-24.2 11.1S-1 59.4 .3 68.6l50 342.9c5.7 39.3 39.4 68.5 79.2 68.5h253c39.7 0 73.4-29.1 79.2-68.5l50-342.9c1.3-9.2-1.4-18.5-7.5-25.5S489.3 32 480 32H32zM87.7 224L69 96H443L424.3 224H87.7z"
    ]
};
var $d8206b3ab2e65c05$export$fdec0f5f1a169419 = $d8206b3ab2e65c05$export$f1304dd34ea2afbd;
var $d8206b3ab2e65c05$export$c49f030b19083ebe = {
    prefix: "fas",
    iconName: "building-circle-exclamation",
    icon: [
        640,
        512,
        [],
        "e4d3",
        "M48 0C21.5 0 0 21.5 0 48V464c0 26.5 21.5 48 48 48h96V432c0-26.5 21.5-48 48-48s48 21.5 48 48v80h96c15.1 0 28.5-6.9 37.3-17.8C340.4 462.2 320 417.5 320 368c0-54.7 24.9-103.5 64-135.8V48c0-26.5-21.5-48-48-48H48zM64 240c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H80c-8.8 0-16-7.2-16-16V240zm112-16h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H176c-8.8 0-16-7.2-16-16V240c0-8.8 7.2-16 16-16zm80 16c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H272c-8.8 0-16-7.2-16-16V240zM80 96h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H80c-8.8 0-16-7.2-16-16V112c0-8.8 7.2-16 16-16zm80 16c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H176c-8.8 0-16-7.2-16-16V112zM272 96h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H272c-8.8 0-16-7.2-16-16V112c0-8.8 7.2-16 16-16zM496 512a144 144 0 1 0 0-288 144 144 0 1 0 0 288zm0-96a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm0-144c8.8 0 16 7.2 16 16v80c0 8.8-7.2 16-16 16s-16-7.2-16-16V288c0-8.8 7.2-16 16-16z"
    ]
};
var $d8206b3ab2e65c05$export$6a1e4cdbb8ca10c5 = {
    prefix: "fas",
    iconName: "magnifying-glass-chart",
    icon: [
        512,
        512,
        [],
        "e522",
        "M416 208c0 45.9-14.9 88.3-40 122.7L502.6 457.4c12.5 12.5 12.5 32.8 0 45.3s-32.8 12.5-45.3 0L330.7 376c-34.4 25.2-76.8 40-122.7 40C93.1 416 0 322.9 0 208S93.1 0 208 0S416 93.1 416 208zm-312 8v64c0 13.3 10.7 24 24 24s24-10.7 24-24l0-64c0-13.3-10.7-24-24-24s-24 10.7-24 24zm80-96V280c0 13.3 10.7 24 24 24s24-10.7 24-24V120c0-13.3-10.7-24-24-24s-24 10.7-24 24zm80 64v96c0 13.3 10.7 24 24 24s24-10.7 24-24V184c0-13.3-10.7-24-24-24s-24 10.7-24 24z"
    ]
};
var $d8206b3ab2e65c05$export$5ad84e891223f2c3 = {
    prefix: "fas",
    iconName: "arrow-up-right-from-square",
    icon: [
        512,
        512,
        [
            "external-link"
        ],
        "f08e",
        "M320 0c-17.7 0-32 14.3-32 32s14.3 32 32 32h82.7L201.4 265.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0L448 109.3V192c0 17.7 14.3 32 32 32s32-14.3 32-32V32c0-17.7-14.3-32-32-32H320zM80 32C35.8 32 0 67.8 0 112V432c0 44.2 35.8 80 80 80H400c44.2 0 80-35.8 80-80V320c0-17.7-14.3-32-32-32s-32 14.3-32 32V432c0 8.8-7.2 16-16 16H80c-8.8 0-16-7.2-16-16V112c0-8.8 7.2-16 16-16H192c17.7 0 32-14.3 32-32s-14.3-32-32-32H80z"
    ]
};
var $d8206b3ab2e65c05$export$f4c613289034e5ef = $d8206b3ab2e65c05$export$5ad84e891223f2c3;
var $d8206b3ab2e65c05$export$b1f00c433aabac05 = {
    prefix: "fas",
    iconName: "cubes-stacked",
    icon: [
        448,
        512,
        [],
        "e4e6",
        "M192 64v64c0 17.7 14.3 32 32 32h64c17.7 0 32-14.3 32-32V64c0-17.7-14.3-32-32-32H224c-17.7 0-32 14.3-32 32zM82.7 207c-15.3 8.8-20.5 28.4-11.7 43.7l32 55.4c8.8 15.3 28.4 20.5 43.7 11.7l55.4-32c15.3-8.8 20.5-28.4 11.7-43.7l-32-55.4c-8.8-15.3-28.4-20.5-43.7-11.7L82.7 207zM288 192c-17.7 0-32 14.3-32 32v64c0 17.7 14.3 32 32 32h64c17.7 0 32-14.3 32-32V224c0-17.7-14.3-32-32-32H288zm64 160c-17.7 0-32 14.3-32 32v64c0 17.7 14.3 32 32 32h64c17.7 0 32-14.3 32-32V384c0-17.7-14.3-32-32-32H352zM160 384v64c0 17.7 14.3 32 32 32h64c17.7 0 32-14.3 32-32V384c0-17.7-14.3-32-32-32H192c-17.7 0-32 14.3-32 32zM32 352c-17.7 0-32 14.3-32 32v64c0 17.7 14.3 32 32 32H96c17.7 0 32-14.3 32-32V384c0-17.7-14.3-32-32-32H32z"
    ]
};
var $d8206b3ab2e65c05$export$51790ddd26e431bc = {
    prefix: "fas",
    iconName: "won-sign",
    icon: [
        512,
        512,
        [
            8361,
            "krw",
            "won"
        ],
        "f159",
        "M62.4 53.9C56.8 37.1 38.6 28.1 21.9 33.6S-3.9 57.4 1.6 74.1L51.6 224H32c-17.7 0-32 14.3-32 32s14.3 32 32 32H72.9l56.7 170.1c4.5 13.5 17.4 22.4 31.6 21.9s26.4-10.4 29.8-24.2L233 288h46L321 455.8c3.4 13.8 15.6 23.7 29.8 24.2s27.1-8.4 31.6-21.9L439.1 288H480c17.7 0 32-14.3 32-32s-14.3-32-32-32H460.4l50-149.9c5.6-16.8-3.5-34.9-20.2-40.5s-34.9 3.5-40.5 20.2L392.9 224H329L287 56.2C283.5 42 270.7 32 256 32s-27.5 10-31 24.2L183 224h-64L62.4 53.9zm78 234.1H167l-11.4 45.6L140.4 288zM249 224l7-28.1 7 28.1H249zm96 64h26.6l-15.2 45.6L345 288z"
    ]
};
var $d8206b3ab2e65c05$export$2f65e07a45b95b50 = $d8206b3ab2e65c05$export$51790ddd26e431bc;
var $d8206b3ab2e65c05$export$5a1fd3ed9564d7fa = $d8206b3ab2e65c05$export$51790ddd26e431bc;
var $d8206b3ab2e65c05$export$1df4e031b8ee4f84 = {
    prefix: "fas",
    iconName: "virus-covid",
    icon: [
        512,
        512,
        [],
        "e4a8",
        "M192 24c0-13.3 10.7-24 24-24h80c13.3 0 24 10.7 24 24s-10.7 24-24 24H280V81.6c30.7 4.2 58.8 16.3 82.3 34.1L386.1 92 374.8 80.6c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l56.6 56.6c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0L420 125.9l-23.8 23.8c17.9 23.5 29.9 51.7 34.1 82.3H464V216c0-13.3 10.7-24 24-24s24 10.7 24 24v80c0 13.3-10.7 24-24 24s-24-10.7-24-24V280H430.4c-4.2 30.7-16.3 58.8-34.1 82.3L420 386.1l11.3-11.3c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9l-56.6 56.6c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9L386.1 420l-23.8-23.8c-23.5 17.9-51.7 29.9-82.3 34.1V464h16c13.3 0 24 10.7 24 24s-10.7 24-24 24H216c-13.3 0-24-10.7-24-24s10.7-24 24-24h16V430.4c-30.7-4.2-58.8-16.3-82.3-34.1L125.9 420l11.3 11.3c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0L46.7 408.7c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0L92 386.1l23.8-23.8C97.9 338.8 85.8 310.7 81.6 280H48v16c0 13.3-10.7 24-24 24s-24-10.7-24-24V216c0-13.3 10.7-24 24-24s24 10.7 24 24v16H81.6c4.2-30.7 16.3-58.8 34.1-82.3L92 125.9 80.6 137.2c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l56.6-56.6c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9L125.9 92l23.8 23.8c23.5-17.9 51.7-29.9 82.3-34.1V48H216c-13.3 0-24-10.7-24-24zm48 200a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zm64 104a24 24 0 1 0 0-48 24 24 0 1 0 0 48z"
    ]
};
var $d8206b3ab2e65c05$export$299c200ad3db97b4 = {
    prefix: "fas",
    iconName: "austral-sign",
    icon: [
        448,
        512,
        [],
        "e0a9",
        "M253.5 51.7C248.6 39.8 236.9 32 224 32s-24.6 7.8-29.5 19.7L122.7 224H32c-17.7 0-32 14.3-32 32s14.3 32 32 32H96L82.7 320H32c-17.7 0-32 14.3-32 32s14.3 32 32 32H56L34.5 435.7c-6.8 16.3 .9 35 17.2 41.8s35-.9 41.8-17.2L125.3 384H322.7l31.8 76.3c6.8 16.3 25.5 24 41.8 17.2s24-25.5 17.2-41.8L392 384h24c17.7 0 32-14.3 32-32s-14.3-32-32-32H365.3L352 288h64c17.7 0 32-14.3 32-32s-14.3-32-32-32H325.3L253.5 51.7zM256 224H192l32-76.8L256 224zm-90.7 64H282.7L296 320H152l13.3-32z"
    ]
};
var $d8206b3ab2e65c05$export$a2f384a559654618 = {
    prefix: "fas",
    iconName: "f",
    icon: [
        320,
        512,
        [
            102
        ],
        "46",
        "M64 32C28.7 32 0 60.7 0 96V256 448c0 17.7 14.3 32 32 32s32-14.3 32-32V288H224c17.7 0 32-14.3 32-32s-14.3-32-32-32H64V96H288c17.7 0 32-14.3 32-32s-14.3-32-32-32H64z"
    ]
};
var $d8206b3ab2e65c05$export$7c497bae2754a087 = {
    prefix: "fas",
    iconName: "leaf",
    icon: [
        512,
        512,
        [],
        "f06c",
        "M272 96c-78.6 0-145.1 51.5-167.7 122.5c33.6-17 71.5-26.5 111.7-26.5h88c8.8 0 16 7.2 16 16s-7.2 16-16 16H288 216s0 0 0 0c-16.6 0-32.7 1.9-48.2 5.4c-25.9 5.9-50 16.4-71.4 30.7c0 0 0 0 0 0C38.3 298.8 0 364.9 0 440v16c0 13.3 10.7 24 24 24s24-10.7 24-24V440c0-48.7 20.7-92.5 53.8-123.2C121.6 392.3 190.3 448 272 448l1 0c132.1-.7 239-130.9 239-291.4c0-42.6-7.5-83.1-21.1-119.6c-2.6-6.9-12.7-6.6-16.2-.1C455.9 72.1 418.7 96 376 96L272 96z"
    ]
};
var $d8206b3ab2e65c05$export$f224567a4851a5e9 = {
    prefix: "fas",
    iconName: "road",
    icon: [
        576,
        512,
        [
            128739
        ],
        "f018",
        "M256 32H181.2c-27.1 0-51.3 17.1-60.3 42.6L3.1 407.2C1.1 413 0 419.2 0 425.4C0 455.5 24.5 480 54.6 480H256V416c0-17.7 14.3-32 32-32s32 14.3 32 32v64H521.4c30.2 0 54.6-24.5 54.6-54.6c0-6.2-1.1-12.4-3.1-18.2L455.1 74.6C446 49.1 421.9 32 394.8 32H320V96c0 17.7-14.3 32-32 32s-32-14.3-32-32V32zm64 192v64c0 17.7-14.3 32-32 32s-32-14.3-32-32V224c0-17.7 14.3-32 32-32s32 14.3 32 32z"
    ]
};
var $d8206b3ab2e65c05$export$9958afcdfece1b58 = {
    prefix: "fas",
    iconName: "taxi",
    icon: [
        512,
        512,
        [
            128662,
            "cab"
        ],
        "f1ba",
        "M192 0c-17.7 0-32 14.3-32 32V64c0 .1 0 .1 0 .2c-38.6 2.2-72.3 27.3-85.2 64.1L39.6 228.8C16.4 238.4 0 261.3 0 288V432v48c0 17.7 14.3 32 32 32H64c17.7 0 32-14.3 32-32V432H416v48c0 17.7 14.3 32 32 32h32c17.7 0 32-14.3 32-32V432 288c0-26.7-16.4-49.6-39.6-59.2L437.2 128.3c-12.9-36.8-46.6-62-85.2-64.1c0-.1 0-.1 0-.2V32c0-17.7-14.3-32-32-32H192zM165.4 128H346.6c13.6 0 25.7 8.6 30.2 21.4L402.9 224H109.1l26.1-74.6c4.5-12.8 16.6-21.4 30.2-21.4zM96 288a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm288 32a32 32 0 1 1 64 0 32 32 0 1 1 -64 0z"
    ]
};
var $d8206b3ab2e65c05$export$7bf12d9380f0971b = $d8206b3ab2e65c05$export$9958afcdfece1b58;
var $d8206b3ab2e65c05$export$55686b1eb7d00307 = {
    prefix: "fas",
    iconName: "person-circle-plus",
    icon: [
        576,
        512,
        [],
        "e541",
        "M112 48a48 48 0 1 1 96 0 48 48 0 1 1 -96 0zm40 304V480c0 17.7-14.3 32-32 32s-32-14.3-32-32V256.9L59.4 304.5c-9.1 15.1-28.8 20-43.9 10.9s-20-28.8-10.9-43.9l58.3-97c17.4-28.9 48.6-46.6 82.3-46.6h29.7c33.7 0 64.9 17.7 82.3 46.6l44.9 74.7c-16.1 17.6-28.6 38.5-36.6 61.5c-1.9-1.8-3.5-3.9-4.9-6.3L232 256.9V480c0 17.7-14.3 32-32 32s-32-14.3-32-32V352H152zM432 224a144 144 0 1 1 0 288 144 144 0 1 1 0-288zm16 80c0-8.8-7.2-16-16-16s-16 7.2-16 16v48H368c-8.8 0-16 7.2-16 16s7.2 16 16 16h48v48c0 8.8 7.2 16 16 16s16-7.2 16-16V384h48c8.8 0 16-7.2 16-16s-7.2-16-16-16H448V304z"
    ]
};
var $d8206b3ab2e65c05$export$1de7b9cf7d1b153b = {
    prefix: "fas",
    iconName: "chart-pie",
    icon: [
        576,
        512,
        [
            "pie-chart"
        ],
        "f200",
        "M304 240V16.6c0-9 7-16.6 16-16.6C443.7 0 544 100.3 544 224c0 9-7.6 16-16.6 16H304zM32 272C32 150.7 122.1 50.3 239 34.3c9.2-1.3 17 6.1 17 15.4V288L412.5 444.5c6.7 6.7 6.2 17.7-1.5 23.1C371.8 495.6 323.8 512 272 512C139.5 512 32 404.6 32 272zm526.4 16c9.3 0 16.6 7.8 15.4 17c-7.7 55.9-34.6 105.6-73.9 142.3c-6 5.6-15.4 5.2-21.2-.7L320 288H558.4z"
    ]
};
var $d8206b3ab2e65c05$export$7877286cd337de81 = $d8206b3ab2e65c05$export$1de7b9cf7d1b153b;
var $d8206b3ab2e65c05$export$b16dcd08f3da1ba2 = {
    prefix: "fas",
    iconName: "bolt-lightning",
    icon: [
        384,
        512,
        [],
        "e0b7",
        "M0 256L28.5 28c2-16 15.6-28 31.8-28H228.9c15 0 27.1 12.1 27.1 27.1c0 3.2-.6 6.5-1.7 9.5L208 160H347.3c20.2 0 36.7 16.4 36.7 36.7c0 7.4-2.2 14.6-6.4 20.7l-192.2 281c-5.9 8.6-15.6 13.7-25.9 13.7h-2.9c-15.7 0-28.5-12.8-28.5-28.5c0-2.3 .3-4.6 .9-6.9L176 288H32c-17.7 0-32-14.3-32-32z"
    ]
};
var $d8206b3ab2e65c05$export$2bad98c38bea5994 = {
    prefix: "fas",
    iconName: "sack-xmark",
    icon: [
        512,
        512,
        [],
        "e56a",
        "M192 96H320l47.4-71.1C374.5 14.2 366.9 0 354.1 0H157.9c-12.8 0-20.4 14.2-13.3 24.9L192 96zm128 32H192c-3.8 2.5-8.1 5.3-13 8.4l0 0 0 0C122.3 172.7 0 250.9 0 416c0 53 43 96 96 96H416c53 0 96-43 96-96c0-165.1-122.3-243.3-179-279.6c-4.8-3.1-9.2-5.9-13-8.4zM289.9 336l47 47c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0l-47-47-47 47c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l47-47-47-47c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l47 47 47-47c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9l-47 47z"
    ]
};
var $d8206b3ab2e65c05$export$77cb1a465c4fe84 = {
    prefix: "fas",
    iconName: "file-excel",
    icon: [
        384,
        512,
        [],
        "f1c3",
        "M64 0C28.7 0 0 28.7 0 64V448c0 35.3 28.7 64 64 64H320c35.3 0 64-28.7 64-64V160H256c-17.7 0-32-14.3-32-32V0H64zM256 0V128H384L256 0zM155.7 250.2L192 302.1l36.3-51.9c7.6-10.9 22.6-13.5 33.4-5.9s13.5 22.6 5.9 33.4L221.3 344l46.4 66.2c7.6 10.9 5 25.8-5.9 33.4s-25.8 5-33.4-5.9L192 385.8l-36.3 51.9c-7.6 10.9-22.6 13.5-33.4 5.9s-13.5-22.6-5.9-33.4L162.7 344l-46.4-66.2c-7.6-10.9-5-25.8 5.9-33.4s25.8-5 33.4 5.9z"
    ]
};
var $d8206b3ab2e65c05$export$70fde3f3fdaa6a6a = {
    prefix: "fas",
    iconName: "file-contract",
    icon: [
        384,
        512,
        [],
        "f56c",
        "M64 0C28.7 0 0 28.7 0 64V448c0 35.3 28.7 64 64 64H320c35.3 0 64-28.7 64-64V160H256c-17.7 0-32-14.3-32-32V0H64zM256 0V128H384L256 0zM80 64h64c8.8 0 16 7.2 16 16s-7.2 16-16 16H80c-8.8 0-16-7.2-16-16s7.2-16 16-16zm0 64h64c8.8 0 16 7.2 16 16s-7.2 16-16 16H80c-8.8 0-16-7.2-16-16s7.2-16 16-16zm54.2 253.8c-6.1 20.3-24.8 34.2-46 34.2H80c-8.8 0-16-7.2-16-16s7.2-16 16-16h8.2c7.1 0 13.3-4.6 15.3-11.4l14.9-49.5c3.4-11.3 13.8-19.1 25.6-19.1s22.2 7.7 25.6 19.1l11.6 38.6c7.4-6.2 16.8-9.7 26.8-9.7c15.9 0 30.4 9 37.5 23.2l4.4 8.8H304c8.8 0 16 7.2 16 16s-7.2 16-16 16H240c-6.1 0-11.6-3.4-14.3-8.8l-8.8-17.7c-1.7-3.4-5.1-5.5-8.8-5.5s-7.2 2.1-8.8 5.5l-8.8 17.7c-2.9 5.9-9.2 9.4-15.7 8.8s-12.1-5.1-13.9-11.3L144 349l-9.8 32.8z"
    ]
};
var $d8206b3ab2e65c05$export$e7af4f0123222b6f = {
    prefix: "fas",
    iconName: "fish-fins",
    icon: [
        576,
        512,
        [],
        "e4f2",
        "M275.2 38.4c-10.6-8-25-8.5-36.3-1.5S222 57.3 224.6 70.3l9.7 48.6c-19.4 9-36.9 19.9-52.4 31.5c-15.3 11.5-29 23.9-40.7 36.3L48.1 132.4c-12.5-7.3-28.4-5.3-38.7 4.9S-3 163.3 4.2 175.9L50 256 4.2 336.1c-7.2 12.6-5 28.4 5.3 38.6s26.1 12.2 38.7 4.9l93.1-54.3c11.8 12.3 25.4 24.8 40.7 36.3c15.5 11.6 33 22.5 52.4 31.5l-9.7 48.6c-2.6 13 3.1 26.3 14.3 33.3s25.6 6.5 36.3-1.5l77.6-58.2c54.9-4 101.5-27 137.2-53.8c39.2-29.4 67.2-64.7 81.6-89.5c5.8-9.9 5.8-22.2 0-32.1c-14.4-24.8-42.5-60.1-81.6-89.5c-35.8-26.8-82.3-49.8-137.2-53.8L275.2 38.4zM384 256a32 32 0 1 1 64 0 32 32 0 1 1 -64 0z"
    ]
};
var $d8206b3ab2e65c05$export$592422b29ab0a914 = {
    prefix: "fas",
    iconName: "building-flag",
    icon: [
        640,
        512,
        [],
        "e4d5",
        "M48 0C21.5 0 0 21.5 0 48V464c0 26.5 21.5 48 48 48h96V432c0-26.5 21.5-48 48-48s48 21.5 48 48v80h96c26.5 0 48-21.5 48-48V48c0-26.5-21.5-48-48-48H48zM64 240c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H80c-8.8 0-16-7.2-16-16V240zm112-16h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H176c-8.8 0-16-7.2-16-16V240c0-8.8 7.2-16 16-16zm80 16c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H272c-8.8 0-16-7.2-16-16V240zM80 96h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H80c-8.8 0-16-7.2-16-16V112c0-8.8 7.2-16 16-16zm80 16c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H176c-8.8 0-16-7.2-16-16V112zM272 96h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H272c-8.8 0-16-7.2-16-16V112c0-8.8 7.2-16 16-16zM448 0c-17.7 0-32 14.3-32 32V512h64V192H624c8.8 0 16-7.2 16-16V48c0-8.8-7.2-16-16-16H480c0-17.7-14.3-32-32-32z"
    ]
};
var $d8206b3ab2e65c05$export$3de52eeb00462407 = {
    prefix: "fas",
    iconName: "face-grin-beam",
    icon: [
        512,
        512,
        [
            128516,
            "grin-beam"
        ],
        "f582",
        "M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM388.1 312.8c12.3-3.8 24.3 6.9 19.3 18.7C382.4 390.6 324.2 432 256.3 432s-126.2-41.4-151.1-100.5c-5-11.8 7-22.5 19.3-18.7c39.7 12.2 84.5 19 131.8 19s92.1-6.8 131.8-19zm-170.5-84l0 0 0 0-.2-.2c-.2-.2-.4-.5-.7-.9c-.6-.8-1.6-2-2.8-3.4c-2.5-2.8-6-6.6-10.2-10.3c-8.8-7.8-18.8-14-27.7-14s-18.9 6.2-27.7 14c-4.2 3.7-7.7 7.5-10.2 10.3c-1.2 1.4-2.2 2.6-2.8 3.4c-.3 .4-.6 .7-.7 .9l-.2 .2 0 0 0 0 0 0c-2.1 2.8-5.7 3.9-8.9 2.8s-5.5-4.1-5.5-7.6c0-17.9 6.7-35.6 16.6-48.8c9.8-13 23.9-23.2 39.4-23.2s29.6 10.2 39.4 23.2c9.9 13.2 16.6 30.9 16.6 48.8c0 3.4-2.2 6.5-5.5 7.6s-6.9 0-8.9-2.8l0 0 0 0zm160 0l0 0-.2-.2c-.2-.2-.4-.5-.7-.9c-.6-.8-1.6-2-2.8-3.4c-2.5-2.8-6-6.6-10.2-10.3c-8.8-7.8-18.8-14-27.7-14s-18.9 6.2-27.7 14c-4.2 3.7-7.7 7.5-10.2 10.3c-1.2 1.4-2.2 2.6-2.8 3.4c-.3 .4-.6 .7-.7 .9l-.2 .2 0 0 0 0 0 0c-2.1 2.8-5.7 3.9-8.9 2.8s-5.5-4.1-5.5-7.6c0-17.9 6.7-35.6 16.6-48.8c9.8-13 23.9-23.2 39.4-23.2s29.6 10.2 39.4 23.2c9.9 13.2 16.6 30.9 16.6 48.8c0 3.4-2.2 6.5-5.5 7.6s-6.9 0-8.9-2.8l0 0 0 0 0 0z"
    ]
};
var $d8206b3ab2e65c05$export$734da5249381ec7e = $d8206b3ab2e65c05$export$3de52eeb00462407;
var $d8206b3ab2e65c05$export$887f6345573abcac = {
    prefix: "fas",
    iconName: "object-ungroup",
    icon: [
        640,
        512,
        [],
        "f248",
        "M32 119.4C12.9 108.4 0 87.7 0 64C0 28.7 28.7 0 64 0c23.7 0 44.4 12.9 55.4 32H328.6C339.6 12.9 360.3 0 384 0c35.3 0 64 28.7 64 64c0 23.7-12.9 44.4-32 55.4V232.6c19.1 11.1 32 31.7 32 55.4c0 35.3-28.7 64-64 64c-23.7 0-44.4-12.9-55.4-32H119.4c-11.1 19.1-31.7 32-55.4 32c-35.3 0-64-28.7-64-64c0-23.7 12.9-44.4 32-55.4V119.4zM119.4 96c-5.6 9.7-13.7 17.8-23.4 23.4V232.6c9.7 5.6 17.8 13.7 23.4 23.4H328.6c5.6-9.7 13.7-17.8 23.4-23.4V119.4c-9.7-5.6-17.8-13.7-23.4-23.4H119.4zm192 384c-11.1 19.1-31.7 32-55.4 32c-35.3 0-64-28.7-64-64c0-23.7 12.9-44.4 32-55.4V352h64v40.6c9.7 5.6 17.8 13.7 23.4 23.4H520.6c5.6-9.7 13.7-17.8 23.4-23.4V279.4c-9.7-5.6-17.8-13.7-23.4-23.4h-46c-5.4-15.4-14.6-28.9-26.5-39.6V192h72.6c11.1-19.1 31.7-32 55.4-32c35.3 0 64 28.7 64 64c0 23.7-12.9 44.4-32 55.4V392.6c19.1 11.1 32 31.7 32 55.4c0 35.3-28.7 64-64 64c-23.7 0-44.4-12.9-55.4-32H311.4z"
    ]
};
var $d8206b3ab2e65c05$export$bb45b6b87d1adf27 = {
    prefix: "fas",
    iconName: "poop",
    icon: [
        512,
        512,
        [],
        "f619",
        "M254.4 6.6c3.5-4.3 9-6.5 14.5-5.7C315.8 7.2 352 47.4 352 96c0 11.2-1.9 22-5.5 32H352c35.3 0 64 28.7 64 64c0 19.1-8.4 36.3-21.7 48H408c39.8 0 72 32.2 72 72c0 23.2-11 43.8-28 57c34.1 5.7 60 35.3 60 71c0 39.8-32.2 72-72 72H72c-39.8 0-72-32.2-72-72c0-35.7 25.9-65.3 60-71c-17-13.2-28-33.8-28-57c0-39.8 32.2-72 72-72h13.7C104.4 228.3 96 211.1 96 192c0-35.3 28.7-64 64-64h16.2c44.1-.1 79.8-35.9 79.8-80c0-9.2-1.5-17.9-4.3-26.1c-1.8-5.2-.8-11.1 2.8-15.4z"
    ]
};
var $d8206b3ab2e65c05$export$c0b7617de95c0c05 = {
    prefix: "fas",
    iconName: "location-pin",
    icon: [
        384,
        512,
        [
            "map-marker"
        ],
        "f041",
        "M384 192c0 87.4-117 243-168.3 307.2c-12.3 15.3-35.1 15.3-47.4 0C117 435 0 279.4 0 192C0 86 86 0 192 0S384 86 384 192z"
    ]
};
var $d8206b3ab2e65c05$export$10d360e4f1a554dd = $d8206b3ab2e65c05$export$c0b7617de95c0c05;
var $d8206b3ab2e65c05$export$ab1408bfbe914cc9 = {
    prefix: "fas",
    iconName: "kaaba",
    icon: [
        576,
        512,
        [
            128331
        ],
        "f66b",
        "M60 120l228 71.2L516 120 288 48.8 60 120zM278.5 1.5c6.2-1.9 12.9-1.9 19.1 0l256 80C566.9 85.6 576 98 576 112v16 0 21.2L292.8 237.7c-3.1 1-6.4 1-9.5 0L0 149.2V128 112C0 98 9.1 85.6 22.5 81.5l256-80zm23.9 266.8L576 182.8v46.5l-52.8 16.5c-8.4 2.6-13.1 11.6-10.5 20s11.6 13.1 20 10.5L576 262.8V400c0 14-9.1 26.4-22.5 30.5l-256 80c-6.2 1.9-12.9 1.9-19.1 0l-256-80C9.1 426.4 0 414 0 400V262.8l43.2 13.5c8.4 2.6 17.4-2.1 20-10.5s-2.1-17.4-10.5-20L0 229.2V182.8l273.7 85.5c9.3 2.9 19.3 2.9 28.6 0zm-185.5-2.6c-8.4-2.6-17.4 2.1-20 10.5s2.1 17.4 10.5 20l64 20c8.4 2.6 17.4-2.1 20-10.5s-2.1-17.4-10.5-20l-64-20zm352 30.5c8.4-2.6 13.1-11.6 10.5-20s-11.6-13.1-20-10.5l-64 20c-8.4 2.6-13.1 11.6-10.5 20s11.6 13.1 20 10.5l64-20zm-224 9.5c-8.4-2.6-17.4 2.1-20 10.5s2.1 17.4 10.5 20l38.5 12c9.3 2.9 19.3 2.9 28.6 0l38.5-12c8.4-2.6 13.1-11.6 10.5-20s-11.6-13.1-20-10.5l-38.5 12c-3.1 1-6.4 1-9.5 0l-38.5-12z"
    ]
};
var $d8206b3ab2e65c05$export$c8cc083ccc72b17 = {
    prefix: "fas",
    iconName: "toilet-paper",
    icon: [
        640,
        512,
        [
            129531
        ],
        "f71e",
        "M444.2 0C397.2 49.6 384 126.5 384 192c0 158.8-27.3 247-42.7 283.9c-10 24-33.2 36.1-55.4 36.1H48c-11.5 0-22.2-6.2-27.8-16.2s-5.6-22.3 .4-32.2c9.8-17.7 15.4-38.2 20.5-57.7C52.3 362.8 64 293.5 64 192C64 86 107 0 160 0H444.2zM512 384c-53 0-96-86-96-192S459 0 512 0s96 86 96 192s-43 192-96 192zm0-128c17.7 0 32-28.7 32-64s-14.3-64-32-64s-32 28.7-32 64s14.3 64 32 64zM144 208a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zm64 0a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zm48 16a16 16 0 1 0 0-32 16 16 0 1 0 0 32zm80-16a16 16 0 1 0 -32 0 16 16 0 1 0 32 0z"
    ]
};
var $d8206b3ab2e65c05$export$aacaf42fba617981 = {
    prefix: "fas",
    iconName: "helmet-safety",
    icon: [
        576,
        512,
        [
            "hard-hat",
            "hat-hard"
        ],
        "f807",
        "M256 32c-17.7 0-32 14.3-32 32v2.3 99.6c0 5.6-4.5 10.1-10.1 10.1c-3.6 0-7-1.9-8.8-5.1L157.1 87C83 123.5 32 199.8 32 288v64H544l0-66.4c-.9-87.2-51.7-162.4-125.1-198.6l-48 83.9c-1.8 3.2-5.2 5.1-8.8 5.1c-5.6 0-10.1-4.5-10.1-10.1V66.3 64c0-17.7-14.3-32-32-32H256zM16.6 384C7.4 384 0 391.4 0 400.6c0 4.7 2 9.2 5.8 11.9C27.5 428.4 111.8 480 288 480s260.5-51.6 282.2-67.5c3.8-2.8 5.8-7.2 5.8-11.9c0-9.2-7.4-16.6-16.6-16.6H16.6z"
    ]
};
var $d8206b3ab2e65c05$export$7b72177558a98b6f = $d8206b3ab2e65c05$export$aacaf42fba617981;
var $d8206b3ab2e65c05$export$c0e235dbf1644a2f = $d8206b3ab2e65c05$export$aacaf42fba617981;
var $d8206b3ab2e65c05$export$8484041d5b209494 = {
    prefix: "fas",
    iconName: "eject",
    icon: [
        448,
        512,
        [
            9167
        ],
        "f052",
        "M224 32c13.5 0 26.3 5.6 35.4 15.6l176 192c12.9 14 16.2 34.3 8.6 51.8S419 320 400 320H48c-19 0-36.3-11.2-43.9-28.7s-4.3-37.7 8.6-51.8l176-192C197.7 37.6 210.5 32 224 32zM0 432c0-26.5 21.5-48 48-48H400c26.5 0 48 21.5 48 48s-21.5 48-48 48H48c-26.5 0-48-21.5-48-48z"
    ]
};
var $d8206b3ab2e65c05$export$1fec48c8bdd69c1d = {
    prefix: "fas",
    iconName: "circle-right",
    icon: [
        512,
        512,
        [
            61838,
            "arrow-alt-circle-right"
        ],
        "f35a",
        "M0 256a256 256 0 1 0 512 0A256 256 0 1 0 0 256zM294.6 135.1l99.9 107.1c3.5 3.8 5.5 8.7 5.5 13.8s-2 10.1-5.5 13.8L294.6 376.9c-4.2 4.5-10.1 7.1-16.3 7.1C266 384 256 374 256 361.7l0-57.7-96 0c-17.7 0-32-14.3-32-32l0-32c0-17.7 14.3-32 32-32l96 0 0-57.7c0-12.3 10-22.3 22.3-22.3c6.2 0 12.1 2.6 16.3 7.1z"
    ]
};
var $d8206b3ab2e65c05$export$88962ffdad8b856d = $d8206b3ab2e65c05$export$1fec48c8bdd69c1d;
var $d8206b3ab2e65c05$export$9cbf8612c6cadc74 = {
    prefix: "fas",
    iconName: "plane-circle-check",
    icon: [
        640,
        512,
        [],
        "e555",
        "M256 0c-35 0-64 59.5-64 93.7v84.6L8.1 283.4c-5 2.8-8.1 8.2-8.1 13.9v65.5c0 10.6 10.2 18.3 20.4 15.4l171.6-49 0 70.9-57.6 43.2c-4 3-6.4 7.8-6.4 12.8v42c0 7.8 6.3 14 14 14c1.3 0 2.6-.2 3.9-.5L256 480l110.1 31.5c1.3 .4 2.6 .5 3.9 .5c6 0 11.1-3.7 13.1-9C344.5 470.7 320 422.2 320 368c0-60.6 30.6-114 77.1-145.6L320 178.3V93.7C320 59.5 292 0 256 0zM640 368a144 144 0 1 0 -288 0 144 144 0 1 0 288 0zm-76.7-43.3c6.2 6.2 6.2 16.4 0 22.6l-72 72c-6.2 6.2-16.4 6.2-22.6 0l-40-40c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0L480 385.4l60.7-60.7c6.2-6.2 16.4-6.2 22.6 0z"
    ]
};
var $d8206b3ab2e65c05$export$a6d72a9a068392b5 = {
    prefix: "fas",
    iconName: "face-rolling-eyes",
    icon: [
        512,
        512,
        [
            128580,
            "meh-rolling-eyes"
        ],
        "f5a5",
        "M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM192 368H320c8.8 0 16 7.2 16 16s-7.2 16-16 16H192c-8.8 0-16-7.2-16-16s7.2-16 16-16zm32-144c0 35.3-28.7 64-64 64s-64-28.7-64-64c0-26 15.5-48.4 37.8-58.4c-3.7 5.2-5.8 11.6-5.8 18.4c0 17.7 14.3 32 32 32s32-14.3 32-32c0-6.9-2.2-13.2-5.8-18.4C208.5 175.6 224 198 224 224zm128 64c-35.3 0-64-28.7-64-64c0-26 15.5-48.4 37.8-58.4c-3.7 5.2-5.8 11.6-5.8 18.4c0 17.7 14.3 32 32 32s32-14.3 32-32c0-6.9-2.2-13.2-5.8-18.4C400.5 175.6 416 198 416 224c0 35.3-28.7 64-64 64z"
    ]
};
var $d8206b3ab2e65c05$export$fdc62a1bea767cc2 = $d8206b3ab2e65c05$export$a6d72a9a068392b5;
var $d8206b3ab2e65c05$export$40cdac24aa94a57a = {
    prefix: "fas",
    iconName: "object-group",
    icon: [
        576,
        512,
        [],
        "f247",
        "M32 119.4C12.9 108.4 0 87.7 0 64C0 28.7 28.7 0 64 0c23.7 0 44.4 12.9 55.4 32H456.6C467.6 12.9 488.3 0 512 0c35.3 0 64 28.7 64 64c0 23.7-12.9 44.4-32 55.4V392.6c19.1 11.1 32 31.7 32 55.4c0 35.3-28.7 64-64 64c-23.7 0-44.4-12.9-55.4-32H119.4c-11.1 19.1-31.7 32-55.4 32c-35.3 0-64-28.7-64-64c0-23.7 12.9-44.4 32-55.4V119.4zM456.6 96H119.4c-5.6 9.7-13.7 17.8-23.4 23.4V392.6c9.7 5.6 17.8 13.7 23.4 23.4H456.6c5.6-9.7 13.7-17.8 23.4-23.4V119.4c-9.7-5.6-17.8-13.7-23.4-23.4zM128 160c0-17.7 14.3-32 32-32H288c17.7 0 32 14.3 32 32v96c0 17.7-14.3 32-32 32H160c-17.7 0-32-14.3-32-32V160zM256 320h32c35.3 0 64-28.7 64-64V224h64c17.7 0 32 14.3 32 32v96c0 17.7-14.3 32-32 32H288c-17.7 0-32-14.3-32-32V320z"
    ]
};
var $d8206b3ab2e65c05$export$e022f62a119e1d93 = {
    prefix: "fas",
    iconName: "chart-line",
    icon: [
        512,
        512,
        [
            "line-chart"
        ],
        "f201",
        "M64 64c0-17.7-14.3-32-32-32S0 46.3 0 64V400c0 44.2 35.8 80 80 80H480c17.7 0 32-14.3 32-32s-14.3-32-32-32H80c-8.8 0-16-7.2-16-16V64zm406.6 86.6c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L320 210.7l-57.4-57.4c-12.5-12.5-32.8-12.5-45.3 0l-112 112c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0L240 221.3l57.4 57.4c12.5 12.5 32.8 12.5 45.3 0l128-128z"
    ]
};
var $d8206b3ab2e65c05$export$f729617a20de475b = $d8206b3ab2e65c05$export$e022f62a119e1d93;
var $d8206b3ab2e65c05$export$122c8413a0dc5ff6 = {
    prefix: "fas",
    iconName: "mask-ventilator",
    icon: [
        640,
        512,
        [],
        "e524",
        "M159.1 176C139.4 219.2 128 264.7 128 300.8c0 15.9 2.2 31.4 6.3 46l-31.8-7.9C70.5 330.9 48 302.1 48 269V184c0-4.4 3.6-8 8-8H159.1zm26-48H56c-30.9 0-56 25.1-56 56v85c0 55.1 37.5 103.1 90.9 116.4l71.3 17.8c22.7 30.5 55.4 54.1 93.8 66.6V393.3c-19.7-16.4-32-40.3-32-66.9c0-49.5 43-134.4 96-134.4c52.5 0 96 84.9 96 134.4c0 26.7-12.4 50.4-32 66.8v76.6c38-12.6 70.6-36 93.5-66.4l71.6-17.9C602.5 372.1 640 324.1 640 269V184c0-30.9-25.1-56-56-56H454.5C419.7 73.8 372.1 32 320 32c-52.6 0-100.2 41.8-134.9 96zm295.6 48H584c4.4 0 8 3.6 8 8v85c0 33-22.5 61.8-54.5 69.9l-31.8 8c4.2-14.7 6.4-30.1 6.4-46.1c0-36.1-11.6-81.6-31.3-124.8zM288 320V512h64V320c0-17.7-14.3-32-32-32s-32 14.3-32 32z"
    ]
};
var $d8206b3ab2e65c05$export$b4da69a0247f3620 = {
    prefix: "fas",
    iconName: "arrow-right",
    icon: [
        448,
        512,
        [
            8594
        ],
        "f061",
        "M438.6 278.6c12.5-12.5 12.5-32.8 0-45.3l-160-160c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3L338.8 224 32 224c-17.7 0-32 14.3-32 32s14.3 32 32 32l306.7 0L233.4 393.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0l160-160z"
    ]
};
var $d8206b3ab2e65c05$export$905f45f8ffd6b8e5 = {
    prefix: "fas",
    iconName: "signs-post",
    icon: [
        512,
        512,
        [
            "map-signs"
        ],
        "f277",
        "M224 32H64C46.3 32 32 46.3 32 64v64c0 17.7 14.3 32 32 32H441.4c4.2 0 8.3-1.7 11.3-4.7l48-48c6.2-6.2 6.2-16.4 0-22.6l-48-48c-3-3-7.1-4.7-11.3-4.7H288c0-17.7-14.3-32-32-32s-32 14.3-32 32zM480 256c0-17.7-14.3-32-32-32H288V192H224v32H70.6c-4.2 0-8.3 1.7-11.3 4.7l-48 48c-6.2 6.2-6.2 16.4 0 22.6l48 48c3 3 7.1 4.7 11.3 4.7H448c17.7 0 32-14.3 32-32V256zM288 480V384H224v96c0 17.7 14.3 32 32 32s32-14.3 32-32z"
    ]
};
var $d8206b3ab2e65c05$export$743f4b1071b3333a = $d8206b3ab2e65c05$export$905f45f8ffd6b8e5;
var $d8206b3ab2e65c05$export$6357093f67788b33 = {
    prefix: "fas",
    iconName: "cash-register",
    icon: [
        512,
        512,
        [],
        "f788",
        "M64 0C46.3 0 32 14.3 32 32V96c0 17.7 14.3 32 32 32h80v32H87c-31.6 0-58.5 23.1-63.3 54.4L1.1 364.1C.4 368.8 0 373.6 0 378.4V448c0 35.3 28.7 64 64 64H448c35.3 0 64-28.7 64-64V378.4c0-4.8-.4-9.6-1.1-14.4L488.2 214.4C483.5 183.1 456.6 160 425 160H208V128h80c17.7 0 32-14.3 32-32V32c0-17.7-14.3-32-32-32H64zM96 48H256c8.8 0 16 7.2 16 16s-7.2 16-16 16H96c-8.8 0-16-7.2-16-16s7.2-16 16-16zM64 432c0-8.8 7.2-16 16-16H432c8.8 0 16 7.2 16 16s-7.2 16-16 16H80c-8.8 0-16-7.2-16-16zm48-168a24 24 0 1 1 0-48 24 24 0 1 1 0 48zm120-24a24 24 0 1 1 -48 0 24 24 0 1 1 48 0zM160 344a24 24 0 1 1 0-48 24 24 0 1 1 0 48zM328 240a24 24 0 1 1 -48 0 24 24 0 1 1 48 0zM256 344a24 24 0 1 1 0-48 24 24 0 1 1 0 48zM424 240a24 24 0 1 1 -48 0 24 24 0 1 1 48 0zM352 344a24 24 0 1 1 0-48 24 24 0 1 1 0 48z"
    ]
};
var $d8206b3ab2e65c05$export$c8f8a597ffd676c0 = {
    prefix: "fas",
    iconName: "person-circle-question",
    icon: [
        576,
        512,
        [],
        "e542",
        "M112 48a48 48 0 1 1 96 0 48 48 0 1 1 -96 0zm40 304V480c0 17.7-14.3 32-32 32s-32-14.3-32-32V256.9L59.4 304.5c-9.1 15.1-28.8 20-43.9 10.9s-20-28.8-10.9-43.9l58.3-97c17.4-28.9 48.6-46.6 82.3-46.6h29.7c33.7 0 64.9 17.7 82.3 46.6l44.9 74.7c-16.1 17.6-28.6 38.5-36.6 61.5c-1.9-1.8-3.5-3.9-4.9-6.3L232 256.9V480c0 17.7-14.3 32-32 32s-32-14.3-32-32V352H152zM432 224a144 144 0 1 1 0 288 144 144 0 1 1 0-288zm0 240a24 24 0 1 0 0-48 24 24 0 1 0 0 48zM368 321.6V328c0 8.8 7.2 16 16 16s16-7.2 16-16v-6.4c0-5.3 4.3-9.6 9.6-9.6h40.5c7.7 0 13.9 6.2 13.9 13.9c0 5.2-2.9 9.9-7.4 12.3l-32 16.8c-5.3 2.8-8.6 8.2-8.6 14.2V384c0 8.8 7.2 16 16 16s16-7.2 16-16v-5.1l23.5-12.3c15.1-7.9 24.5-23.6 24.5-40.6c0-25.4-20.6-45.9-45.9-45.9H409.6c-23 0-41.6 18.6-41.6 41.6z"
    ]
};
var $d8206b3ab2e65c05$export$d762b7b66d5875e1 = {
    prefix: "fas",
    iconName: "h",
    icon: [
        384,
        512,
        [
            104
        ],
        "48",
        "M320 256l0 192c0 17.7 14.3 32 32 32s32-14.3 32-32l0-224V64c0-17.7-14.3-32-32-32s-32 14.3-32 32V192L64 192 64 64c0-17.7-14.3-32-32-32S0 46.3 0 64V448c0 17.7 14.3 32 32 32s32-14.3 32-32l0-192 256 0z"
    ]
};
var $d8206b3ab2e65c05$export$2305b1a41b3f914 = {
    prefix: "fas",
    iconName: "tarp",
    icon: [
        576,
        512,
        [],
        "e57b",
        "M576 128c0-35.3-28.7-64-64-64H64C28.7 64 0 92.7 0 128V384c0 35.3 28.7 64 64 64l352 0 0-128c0-17.7 14.3-32 32-32H576V128zM448 448L576 320H448l0 128zM96 128a32 32 0 1 1 0 64 32 32 0 1 1 0-64z"
    ]
};
var $d8206b3ab2e65c05$export$158a12f36bbecf9 = {
    prefix: "fas",
    iconName: "screwdriver-wrench",
    icon: [
        512,
        512,
        [
            "tools"
        ],
        "f7d9",
        "M78.6 5C69.1-2.4 55.6-1.5 47 7L7 47c-8.5 8.5-9.4 22-2.1 31.6l80 104c4.5 5.9 11.6 9.4 19 9.4h54.1l109 109c-14.7 29-10 65.4 14.3 89.6l112 112c12.5 12.5 32.8 12.5 45.3 0l64-64c12.5-12.5 12.5-32.8 0-45.3l-112-112c-24.2-24.2-60.6-29-89.6-14.3l-109-109V104c0-7.5-3.5-14.5-9.4-19L78.6 5zM19.9 396.1C7.2 408.8 0 426.1 0 444.1C0 481.6 30.4 512 67.9 512c18 0 35.3-7.2 48-19.9L233.7 374.3c-7.8-20.9-9-43.6-3.6-65.1l-61.7-61.7L19.9 396.1zM512 144c0-10.5-1.1-20.7-3.2-30.5c-2.4-11.2-16.1-14.1-24.2-6l-63.9 63.9c-3 3-7.1 4.7-11.3 4.7H352c-8.8 0-16-7.2-16-16V102.6c0-4.2 1.7-8.3 4.7-11.3l63.9-63.9c8.1-8.1 5.2-21.8-6-24.2C388.7 1.1 378.5 0 368 0C288.5 0 224 64.5 224 144l0 .8 85.3 85.3c36-9.1 75.8 .5 104 28.7L429 274.5c49-23 83-72.8 83-130.5zM56 432a24 24 0 1 1 48 0 24 24 0 1 1 -48 0z"
    ]
};
var $d8206b3ab2e65c05$export$646e4e7a8c6172aa = $d8206b3ab2e65c05$export$158a12f36bbecf9;
var $d8206b3ab2e65c05$export$9adae865350879af = {
    prefix: "fas",
    iconName: "arrows-to-eye",
    icon: [
        640,
        512,
        [],
        "e4bf",
        "M15 15C24.4 5.7 39.6 5.7 49 15l63 63V40c0-13.3 10.7-24 24-24s24 10.7 24 24v96c0 13.3-10.7 24-24 24H40c-13.3 0-24-10.7-24-24s10.7-24 24-24H78.1L15 49C5.7 39.6 5.7 24.4 15 15zM133.5 243.9C158.6 193.6 222.7 112 320 112s161.4 81.6 186.5 131.9c3.8 7.6 3.8 16.5 0 24.2C481.4 318.4 417.3 400 320 400s-161.4-81.6-186.5-131.9c-3.8-7.6-3.8-16.5 0-24.2zM320 320a64 64 0 1 0 0-128 64 64 0 1 0 0 128zM591 15c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9l-63 63H600c13.3 0 24 10.7 24 24s-10.7 24-24 24H504c-13.3 0-24-10.7-24-24V40c0-13.3 10.7-24 24-24s24 10.7 24 24V78.1l63-63zM15 497c-9.4-9.4-9.4-24.6 0-33.9l63-63H40c-13.3 0-24-10.7-24-24s10.7-24 24-24h96c13.3 0 24 10.7 24 24v96c0 13.3-10.7 24-24 24s-24-10.7-24-24V433.9L49 497c-9.4 9.4-24.6 9.4-33.9 0zm576 0l-63-63V472c0 13.3-10.7 24-24 24s-24-10.7-24-24V376c0-13.3 10.7-24 24-24h96c13.3 0 24 10.7 24 24s-10.7 24-24 24H561.9l63 63c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0z"
    ]
};
var $d8206b3ab2e65c05$export$4f3b3144ce966486 = {
    prefix: "fas",
    iconName: "plug-circle-bolt",
    icon: [
        576,
        512,
        [],
        "e55b",
        "M96 0C78.3 0 64 14.3 64 32v96h64V32c0-17.7-14.3-32-32-32zM288 0c-17.7 0-32 14.3-32 32v96h64V32c0-17.7-14.3-32-32-32zM32 160c-17.7 0-32 14.3-32 32s14.3 32 32 32v32c0 77.4 55 142 128 156.8V480c0 17.7 14.3 32 32 32s32-14.3 32-32V412.8c12.3-2.5 24.1-6.4 35.1-11.5c-2.1-10.8-3.1-21.9-3.1-33.3c0-80.3 53.8-148 127.3-169.2c.5-2.2 .7-4.5 .7-6.8c0-17.7-14.3-32-32-32H32zM432 512a144 144 0 1 0 0-288 144 144 0 1 0 0 288zm47.9-225c4.3 3.7 5.4 9.9 2.6 14.9L452.4 356H488c5.2 0 9.8 3.3 11.4 8.2s-.1 10.3-4.2 13.4l-96 72c-4.5 3.4-10.8 3.2-15.1-.6s-5.4-9.9-2.6-14.9L411.6 380H376c-5.2 0-9.8-3.3-11.4-8.2s.1-10.3 4.2-13.4l96-72c4.5-3.4 10.8-3.2 15.1 .6z"
    ]
};
var $d8206b3ab2e65c05$export$e4b51a47a2f8b9db = {
    prefix: "fas",
    iconName: "heart",
    icon: [
        512,
        512,
        [
            128153,
            128154,
            128155,
            128156,
            128420,
            129293,
            129294,
            129505,
            9829,
            10084,
            61578
        ],
        "f004",
        "M47.6 300.4L228.3 469.1c7.5 7 17.4 10.9 27.7 10.9s20.2-3.9 27.7-10.9L464.4 300.4c30.4-28.3 47.6-68 47.6-109.5v-5.8c0-69.9-50.5-129.5-119.4-141C347 36.5 300.6 51.4 268 84L256 96 244 84c-32.6-32.6-79-47.5-124.6-39.9C50.5 55.6 0 115.2 0 185.1v5.8c0 41.5 17.2 81.2 47.6 109.5z"
    ]
};
var $d8206b3ab2e65c05$export$808b88e8735e31e8 = {
    prefix: "fas",
    iconName: "mars-and-venus",
    icon: [
        512,
        512,
        [
            9893
        ],
        "f224",
        "M337.8 14.8C341.5 5.8 350.3 0 360 0H472c13.3 0 24 10.7 24 24V136c0 9.7-5.8 18.5-14.8 22.2s-19.3 1.7-26.2-5.2l-39-39-24.7 24.7C407 163.3 416 192.6 416 224c0 80.2-59.1 146.7-136.1 158.2c0 .6 .1 1.2 .1 1.8v.4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .3 .4 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3h24c13.3 0 24 10.7 24 24s-10.7 24-24 24H280v.2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0l-24 0-24 0v0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0-.1-.1-.1-.1-.1-.1-.1-.1-.1-.1V486 486v-.1-.1-.1-.1-.1-.1-.1-.1-.1-.1-.1-.1-.1V485 485v-.1-.1-.1-.1-.1-.1-.1-.1-.1-.1-.1V484v-.1-.1-.1-.1-.1-.1-.1-.1-.1-.1V483v-.1-.1-.1-.1-.1-.1-.1-.1-.1-.1-.1-.1-.1-.1-.1-.1-.1-.1-.1V481v-.1-.1-.1-.1-.1-.1-.1-.1V480v-.1-.1-.1-.1-.1-.1-.1V479v-.1-.1-.1-.1-.1-.1-.1V478v-.1-.1-.1-.1-.1-.1V477v-.1-.1-.1-.1-.1-.1V476v-.1-.1-.1-.1-.1-.1V475v-.1-.2-.2-.2-.2-.2V474v-.2-.2-.2-.2-.2V473v-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2V470v-.2-.2-.2-.2-.2V469v-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2V467v-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2V463v-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2V459v-.2-.2-.2-.2-.2-.2-.2-.2V457v-.2-.2-.2-.2V456H208c-13.3 0-24-10.7-24-24s10.7-24 24-24h24v-.3-.3-.3-.3-.3-.3-.3-.3-.3-.3-.3-.3-.3-.3V403v-.3-.3V402v-.3-.3V401v-.3-.3V400v-.3-.3-.3-.3-.3-.3-.3-.3-.3-.3-.3-.3-.3-.4-.3-.4-.4-.4-.4V393v-.4-.4-.4-.4-.4-.4-.4-.4-.4-.4-.4-.4-.4V388v-.4-.4-.4-.4-.4-.4-.4-.4-.4-.4V384c0-.6 0-1.2 .1-1.8C155.1 370.7 96 304.2 96 224c0-88.4 71.6-160 160-160c39.6 0 75.9 14.4 103.8 38.2L382.1 80 343 41c-6.9-6.9-8.9-17.2-5.2-26.2zM448 48l0 0h0v0zM256 488h24c0 13.3-10.7 24-24 24s-24-10.7-24-24h24zm96-264a96 96 0 1 0 -192 0 96 96 0 1 0 192 0z"
    ]
};
var $d8206b3ab2e65c05$export$9a513ee921e8e885 = {
    prefix: "fas",
    iconName: "house-user",
    icon: [
        576,
        512,
        [
            "home-user"
        ],
        "e1b0",
        "M575.8 255.5c0 18-15 32.1-32 32.1h-32l.7 160.2c.2 35.5-28.5 64.3-64 64.3H128.1c-35.3 0-64-28.7-64-64V287.6H32c-18 0-32-14-32-32.1c0-9 3-17 10-24L266.4 8c7-7 15-8 22-8s15 2 21 7L564.8 231.5c8 7 12 15 11 24zM352 224a64 64 0 1 0 -128 0 64 64 0 1 0 128 0zm-96 96c-44.2 0-80 35.8-80 80c0 8.8 7.2 16 16 16H384c8.8 0 16-7.2 16-16c0-44.2-35.8-80-80-80H256z"
    ]
};
var $d8206b3ab2e65c05$export$e732fa55ae5bbdf0 = $d8206b3ab2e65c05$export$9a513ee921e8e885;
var $d8206b3ab2e65c05$export$25e9b29b3f2230b5 = {
    prefix: "fas",
    iconName: "dumpster-fire",
    icon: [
        640,
        512,
        [],
        "f794",
        "M49.7 32c-10.5 0-19.8 6.9-22.9 16.9L.9 133c-.6 2-.9 4.1-.9 6.1C0 150.7 9.3 160 20.9 160h94L140.5 32H49.7zM272 160V32H173.1L147.5 160H272zm32 0h58c15.1-18.1 32.1-35.7 50.5-52.1c1.5-1.4 3.2-2.6 4.8-3.8L402.9 32H304V160zm209.9-23.7c17.4-15.8 43.9-16.2 61.7-1.2c-.1-.7-.3-1.4-.5-2.1L549.2 48.9C546.1 38.9 536.8 32 526.3 32H435.5l12.8 64.2c9.6 1 19 4.9 26.6 11.8c11.7 10.6 23 21.6 33.9 33.1c1.6-1.6 3.3-3.2 5-4.8zM325.2 210.7c3.8-6.2 7.9-12.5 12.3-18.7H32l4 32H32c-17.7 0-32 14.3-32 32s14.3 32 32 32H44L64 448c0 17.7 14.3 32 32 32s32-14.3 32-32H337.6c-31-34.7-49.6-80.6-49.6-129.9c0-35.2 16.3-73.6 37.2-107.4zm128.4-78.9c-2.8-2.5-6.3-3.7-9.8-3.8c-3.6 0-7.2 1.2-10 3.7c-33.2 29.7-61.4 63.4-81.4 95.8c-19.7 31.9-32.4 66.2-32.4 92.6C320 407.9 390.3 480 480 480c88.7 0 160-72 160-159.8c0-20.2-9.6-50.9-24.2-79c-14.8-28.5-35.7-58.5-60.4-81.1c-5.6-5.1-14.4-5.2-20 0c-9.6 8.8-18.6 19.6-26.5 29.5c-17.3-20.7-35.8-39.9-55.5-57.7zM530 401c-15 10-31 15-49 15c-45 0-81-29-81-78c0-24 15-45 45-82c4 5 62 79 62 79l36-42c3 4 5 8 7 12c18 33 10 75-20 96z"
    ]
};
var $d8206b3ab2e65c05$export$baa3c215534dbf2a = {
    prefix: "fas",
    iconName: "house-crack",
    icon: [
        576,
        512,
        [],
        "e3b1",
        "M543.8 287.6c17 0 32-14 32-32.1c1-9-3-17-11-24L309.5 7c-6-5-14-7-21-7s-15 1-22 8L10 231.5c-7 7-10 15-10 24c0 18 14 32.1 32 32.1h32V448c0 35.3 28.7 64 64 64H230.4l-31.3-52.2c-4.1-6.8-2.6-15.5 3.5-20.5L288 368l-60.2-82.8c-10.9-15 8.2-33.5 22.8-22l117.9 92.6c8 6.3 8.2 18.4 .4 24.9L288 448l38.4 64H448.5c35.5 0 64.2-28.8 64-64.3l-.7-160.2h32z"
    ]
};
var $d8206b3ab2e65c05$export$c6e76550bdc0255d = {
    prefix: "fas",
    iconName: "martini-glass-citrus",
    icon: [
        576,
        512,
        [
            "cocktail"
        ],
        "f561",
        "M432 240c53 0 96-43 96-96s-43-96-96-96c-35.5 0-66.6 19.3-83.2 48H296.2C316 40.1 369.3 0 432 0c79.5 0 144 64.5 144 144s-64.5 144-144 144c-27.7 0-53.5-7.8-75.5-21.3l35.4-35.4c12.2 5.6 25.8 8.7 40.1 8.7zM1.8 142.8C5.5 133.8 14.3 128 24 128H392c9.7 0 18.5 5.8 22.2 14.8s1.7 19.3-5.2 26.2l-177 177V464h64c13.3 0 24 10.7 24 24s-10.7 24-24 24H208 120c-13.3 0-24-10.7-24-24s10.7-24 24-24h64V345.9L7 169c-6.9-6.9-8.9-17.2-5.2-26.2z"
    ]
};
var $d8206b3ab2e65c05$export$4be708f1e41d387b = $d8206b3ab2e65c05$export$c6e76550bdc0255d;
var $d8206b3ab2e65c05$export$c938968e28178994 = {
    prefix: "fas",
    iconName: "face-surprise",
    icon: [
        512,
        512,
        [
            128558,
            "surprise"
        ],
        "f5c2",
        "M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM176.4 176a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm128 32a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zM256 288a64 64 0 1 1 0 128 64 64 0 1 1 0-128z"
    ]
};
var $d8206b3ab2e65c05$export$46647c72213f53ba = $d8206b3ab2e65c05$export$c938968e28178994;
var $d8206b3ab2e65c05$export$3ee278c67519eeeb = {
    prefix: "fas",
    iconName: "bottle-water",
    icon: [
        320,
        512,
        [],
        "e4c5",
        "M120 0h80c13.3 0 24 10.7 24 24V64H96V24c0-13.3 10.7-24 24-24zM32 151.7c0-15.6 9-29.8 23.2-36.5l24.4-11.4c11-5.1 23-7.8 35.1-7.8h90.6c12.1 0 24.1 2.7 35.1 7.8l24.4 11.4c14.1 6.6 23.2 20.8 23.2 36.5c0 14.4-7.5 27-18.9 34.1c11.5 8.8 18.9 22.6 18.9 38.2c0 16.7-8.5 31.4-21.5 40c12.9 8.6 21.5 23.3 21.5 40s-8.5 31.4-21.5 40c12.9 8.6 21.5 23.3 21.5 40s-8.5 31.4-21.5 40c12.9 8.6 21.5 23.3 21.5 40c0 26.5-21.5 48-48 48H80c-26.5 0-48-21.5-48-48c0-16.7 8.5-31.4 21.5-40C40.5 415.4 32 400.7 32 384s8.5-31.4 21.5-40C40.5 335.4 32 320.7 32 304s8.5-31.4 21.5-40C40.5 255.4 32 240.7 32 224c0-15.6 7.4-29.4 18.9-38.2C39.5 178.7 32 166.1 32 151.7zM96 240c0 8.8 7.2 16 16 16h96c8.8 0 16-7.2 16-16s-7.2-16-16-16H112c-8.8 0-16 7.2-16 16zm16 112c-8.8 0-16 7.2-16 16s7.2 16 16 16h96c8.8 0 16-7.2 16-16s-7.2-16-16-16H112z"
    ]
};
var $d8206b3ab2e65c05$export$fbeef2513e05ad08 = {
    prefix: "fas",
    iconName: "circle-pause",
    icon: [
        512,
        512,
        [
            62092,
            "pause-circle"
        ],
        "f28b",
        "M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM224 192V320c0 17.7-14.3 32-32 32s-32-14.3-32-32V192c0-17.7 14.3-32 32-32s32 14.3 32 32zm128 0V320c0 17.7-14.3 32-32 32s-32-14.3-32-32V192c0-17.7 14.3-32 32-32s32 14.3 32 32z"
    ]
};
var $d8206b3ab2e65c05$export$d8cf08a0362da8db = $d8206b3ab2e65c05$export$fbeef2513e05ad08;
var $d8206b3ab2e65c05$export$7a494edbf9b65575 = {
    prefix: "fas",
    iconName: "toilet-paper-slash",
    icon: [
        640,
        512,
        [],
        "e072",
        "M38.8 5.1C28.4-3.1 13.3-1.2 5.1 9.2S-1.2 34.7 9.2 42.9l592 464c10.4 8.2 25.5 6.3 33.7-4.1s6.3-25.5-4.1-33.7l-109.7-86C569.9 374 608 291.9 608 192C608 86 565 0 512 0s-96 86-96 192c0 49.1 9.2 93.9 24.4 127.9l-59-46.2c1.6-24.8 2.6-52 2.6-81.6c0-65.5 13.2-142.4 60.2-192H160c-24.8 0-47.4 18.8-64.4 49.6L38.8 5.1zM367.3 385.4L66.5 148.4C64.9 162.4 64 177 64 192c0 101.5-11.7 170.8-23 213.9c-5.1 19.4-10.7 39.9-20.5 57.7c-5.9 9.9-6.1 22.1-.4 32.2S36.5 512 48 512H285.9c22.3 0 45.4-12.1 55.4-36.1c7.4-17.7 17.5-47.2 26-90.6zM544 192c0 35.3-14.3 64-32 64s-32-28.7-32-64s14.3-64 32-64s32 28.7 32 64z"
    ]
};
var $d8206b3ab2e65c05$export$12de8220d30453a3 = {
    prefix: "fas",
    iconName: "apple-whole",
    icon: [
        448,
        512,
        [
            127822,
            127823,
            "apple-alt"
        ],
        "f5d1",
        "M224 112c-8.8 0-16-7.2-16-16V80c0-44.2 35.8-80 80-80h16c8.8 0 16 7.2 16 16V32c0 44.2-35.8 80-80 80H224zM0 288c0-76.3 35.7-160 112-160c27.3 0 59.7 10.3 82.7 19.3c18.8 7.3 39.9 7.3 58.7 0c22.9-8.9 55.4-19.3 82.7-19.3c76.3 0 112 83.7 112 160c0 128-80 224-160 224c-16.5 0-38.1-6.6-51.5-11.3c-8.1-2.8-16.9-2.8-25 0c-13.4 4.7-35 11.3-51.5 11.3C80 512 0 416 0 288z"
    ]
};
var $d8206b3ab2e65c05$export$bcdd94f3977a0884 = $d8206b3ab2e65c05$export$12de8220d30453a3;
var $d8206b3ab2e65c05$export$64c1570509eaf40d = {
    prefix: "fas",
    iconName: "kitchen-set",
    icon: [
        576,
        512,
        [],
        "e51a",
        "M240 144A96 96 0 1 0 48 144a96 96 0 1 0 192 0zm44.4 32C269.9 240.1 212.5 288 144 288C64.5 288 0 223.5 0 144S64.5 0 144 0c68.5 0 125.9 47.9 140.4 112h71.8c8.8-9.8 21.6-16 35.8-16H496c26.5 0 48 21.5 48 48s-21.5 48-48 48H392c-14.2 0-27-6.2-35.8-16H284.4zM144 80a64 64 0 1 1 0 128 64 64 0 1 1 0-128zM400 240c13.3 0 24 10.7 24 24v8h96c13.3 0 24 10.7 24 24s-10.7 24-24 24H280c-13.3 0-24-10.7-24-24s10.7-24 24-24h96v-8c0-13.3 10.7-24 24-24zM288 464V352H512V464c0 26.5-21.5 48-48 48H336c-26.5 0-48-21.5-48-48zM48 320h80 16 32c26.5 0 48 21.5 48 48s-21.5 48-48 48H160c0 17.7-14.3 32-32 32H64c-17.7 0-32-14.3-32-32V336c0-8.8 7.2-16 16-16zm128 64c8.8 0 16-7.2 16-16s-7.2-16-16-16H160v32h16zM24 464H200c13.3 0 24 10.7 24 24s-10.7 24-24 24H24c-13.3 0-24-10.7-24-24s10.7-24 24-24z"
    ]
};
var $d8206b3ab2e65c05$export$eb4c616de6eef46f = {
    prefix: "fas",
    iconName: "r",
    icon: [
        320,
        512,
        [
            114
        ],
        "52",
        "M64 32C28.7 32 0 60.7 0 96V288 448c0 17.7 14.3 32 32 32s32-14.3 32-32V320h95.3L261.8 466.4c10.1 14.5 30.1 18 44.6 7.9s18-30.1 7.9-44.6L230.1 309.5C282.8 288.1 320 236.4 320 176c0-79.5-64.5-144-144-144H64zM176 256H64V96H176c44.2 0 80 35.8 80 80s-35.8 80-80 80z"
    ]
};
var $d8206b3ab2e65c05$export$f9d1c19925fd7fa8 = {
    prefix: "fas",
    iconName: "temperature-quarter",
    icon: [
        320,
        512,
        [
            "temperature-1",
            "thermometer-1",
            "thermometer-quarter"
        ],
        "f2ca",
        "M160 64c-26.5 0-48 21.5-48 48V276.5c0 17.3-7.1 31.9-15.3 42.5C86.2 332.6 80 349.5 80 368c0 44.2 35.8 80 80 80s80-35.8 80-80c0-18.5-6.2-35.4-16.7-48.9c-8.2-10.6-15.3-25.2-15.3-42.5V112c0-26.5-21.5-48-48-48zM48 112C48 50.2 98.1 0 160 0s112 50.1 112 112V276.5c0 .1 .1 .3 .2 .6c.2 .6 .8 1.6 1.7 2.8c18.9 24.4 30.1 55 30.1 88.1c0 79.5-64.5 144-144 144S16 447.5 16 368c0-33.2 11.2-63.8 30.1-88.1c.9-1.2 1.5-2.2 1.7-2.8c.1-.3 .2-.5 .2-.6V112zM208 368c0 26.5-21.5 48-48 48s-48-21.5-48-48c0-20.9 13.4-38.7 32-45.3V272c0-8.8 7.2-16 16-16s16 7.2 16 16v50.7c18.6 6.6 32 24.4 32 45.3z"
    ]
};
var $d8206b3ab2e65c05$export$d4f1cd380bde2129 = $d8206b3ab2e65c05$export$f9d1c19925fd7fa8;
var $d8206b3ab2e65c05$export$3f77fbe2dabe285b = $d8206b3ab2e65c05$export$f9d1c19925fd7fa8;
var $d8206b3ab2e65c05$export$ed05754fcbec6e46 = $d8206b3ab2e65c05$export$f9d1c19925fd7fa8;
var $d8206b3ab2e65c05$export$973ae4f1e4d2ce78 = {
    prefix: "fas",
    iconName: "cube",
    icon: [
        512,
        512,
        [],
        "f1b2",
        "M234.5 5.7c13.9-5 29.1-5 43.1 0l192 68.6C495 83.4 512 107.5 512 134.6V377.4c0 27-17 51.2-42.5 60.3l-192 68.6c-13.9 5-29.1 5-43.1 0l-192-68.6C17 428.6 0 404.5 0 377.4V134.6c0-27 17-51.2 42.5-60.3l192-68.6zM256 66L82.3 128 256 190l173.7-62L256 66zm32 368.6l160-57.1v-188L288 246.6v188z"
    ]
};
var $d8206b3ab2e65c05$export$441bfc8058328ce8 = {
    prefix: "fas",
    iconName: "bitcoin-sign",
    icon: [
        320,
        512,
        [],
        "e0b4",
        "M48 32C48 14.3 62.3 0 80 0s32 14.3 32 32V64h32V32c0-17.7 14.3-32 32-32s32 14.3 32 32V64c0 1.5-.1 3.1-.3 4.5C254.1 82.2 288 125.1 288 176c0 24.2-7.7 46.6-20.7 64.9c31.7 19.8 52.7 55 52.7 95.1c0 61.9-50.1 112-112 112v32c0 17.7-14.3 32-32 32s-32-14.3-32-32V448H112v32c0 17.7-14.3 32-32 32s-32-14.3-32-32V448H41.7C18.7 448 0 429.3 0 406.3V288 265.7 224 101.6C0 80.8 16.8 64 37.6 64H48V32zM64 224H176c26.5 0 48-21.5 48-48s-21.5-48-48-48H64v96zm112 64H64v96H208c26.5 0 48-21.5 48-48s-21.5-48-48-48H176z"
    ]
};
var $d8206b3ab2e65c05$export$2a5c6f182c0cbcb = {
    prefix: "fas",
    iconName: "shield-dog",
    icon: [
        512,
        512,
        [],
        "e573",
        "M269.4 2.9C265.2 1 260.7 0 256 0s-9.2 1-13.4 2.9L54.3 82.8c-22 9.3-38.4 31-38.3 57.2c.5 99.2 41.3 280.7 213.6 363.2c16.7 8 36.1 8 52.8 0C454.7 420.7 495.5 239.2 496 140c.1-26.2-16.3-47.9-38.3-57.2L269.4 2.9zM160.9 286.2c4.8 1.2 9.9 1.8 15.1 1.8c35.3 0 64-28.7 64-64V160h44.2c12.1 0 23.2 6.8 28.6 17.7L320 192h64c8.8 0 16 7.2 16 16v32c0 44.2-35.8 80-80 80H272v50.7c0 7.3-5.9 13.3-13.3 13.3c-1.8 0-3.6-.4-5.2-1.1l-98.7-42.3c-6.6-2.8-10.8-9.3-10.8-16.4c0-2.8 .6-5.5 1.9-8l15-30zM160 160h40 8v32 32c0 17.7-14.3 32-32 32s-32-14.3-32-32V176c0-8.8 7.2-16 16-16zm128 48a16 16 0 1 0 -32 0 16 16 0 1 0 32 0z"
    ]
};
var $d8206b3ab2e65c05$export$b9c649c5e37017f3 = {
    prefix: "fas",
    iconName: "solar-panel",
    icon: [
        640,
        512,
        [],
        "f5ba",
        "M122.2 0C91.7 0 65.5 21.5 59.5 51.4L8.3 307.4C.4 347 30.6 384 71 384H288v64H224c-17.7 0-32 14.3-32 32s14.3 32 32 32H416c17.7 0 32-14.3 32-32s-14.3-32-32-32H352V384H569c40.4 0 70.7-36.9 62.8-76.6l-51.2-256C574.5 21.5 548.3 0 517.8 0H122.2zM260.9 64H379.1l10.4 104h-139L260.9 64zM202.3 168H101.4L122.2 64h90.4L202.3 168zM91.8 216H197.5L187.1 320H71L91.8 216zm153.9 0H394.3l10.4 104-169.4 0 10.4-104zm196.8 0H548.2L569 320h-116L442.5 216zm96-48H437.7L427.3 64h90.4l31.4-6.3L517.8 64l20.8 104z"
    ]
};
var $d8206b3ab2e65c05$export$84b5acad4436d02a = {
    prefix: "fas",
    iconName: "lock-open",
    icon: [
        576,
        512,
        [],
        "f3c1",
        "M352 144c0-44.2 35.8-80 80-80s80 35.8 80 80v48c0 17.7 14.3 32 32 32s32-14.3 32-32V144C576 64.5 511.5 0 432 0S288 64.5 288 144v48H64c-35.3 0-64 28.7-64 64V448c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V256c0-35.3-28.7-64-64-64H352V144z"
    ]
};
var $d8206b3ab2e65c05$export$c7a833ce065e0ea4 = {
    prefix: "fas",
    iconName: "elevator",
    icon: [
        512,
        512,
        [],
        "e16d",
        "M132.7 4.7l-64 64c-4.6 4.6-5.9 11.5-3.5 17.4s8.3 9.9 14.8 9.9H208c6.5 0 12.3-3.9 14.8-9.9s1.1-12.9-3.5-17.4l-64-64c-6.2-6.2-16.4-6.2-22.6 0zM64 128c-35.3 0-64 28.7-64 64V448c0 35.3 28.7 64 64 64H448c35.3 0 64-28.7 64-64V192c0-35.3-28.7-64-64-64H64zm96 96a48 48 0 1 1 0 96 48 48 0 1 1 0-96zM80 400c0-26.5 21.5-48 48-48h64c26.5 0 48 21.5 48 48v16c0 17.7-14.3 32-32 32H112c-17.7 0-32-14.3-32-32V400zm192 0c0-26.5 21.5-48 48-48h64c26.5 0 48 21.5 48 48v16c0 17.7-14.3 32-32 32H304c-17.7 0-32-14.3-32-32V400zm32-128a48 48 0 1 1 96 0 48 48 0 1 1 -96 0zM356.7 91.3c6.2 6.2 16.4 6.2 22.6 0l64-64c4.6-4.6 5.9-11.5 3.5-17.4S438.5 0 432 0H304c-6.5 0-12.3 3.9-14.8 9.9s-1.1 12.9 3.5 17.4l64 64z"
    ]
};
var $d8206b3ab2e65c05$export$1b71392d9effbe = {
    prefix: "fas",
    iconName: "money-bill-transfer",
    icon: [
        640,
        512,
        [],
        "e528",
        "M535 41c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l64 64c4.5 4.5 7 10.6 7 17s-2.5 12.5-7 17l-64 64c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l23-23L384 112c-13.3 0-24-10.7-24-24s10.7-24 24-24l174.1 0L535 41zM105 377l-23 23L256 400c13.3 0 24 10.7 24 24s-10.7 24-24 24L81.9 448l23 23c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0L7 441c-4.5-4.5-7-10.6-7-17s2.5-12.5 7-17l64-64c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9zM96 64H337.9c-3.7 7.2-5.9 15.3-5.9 24c0 28.7 23.3 52 52 52l117.4 0c-4 17 .6 35.5 13.8 48.8c20.3 20.3 53.2 20.3 73.5 0L608 169.5V384c0 35.3-28.7 64-64 64H302.1c3.7-7.2 5.9-15.3 5.9-24c0-28.7-23.3-52-52-52l-117.4 0c4-17-.6-35.5-13.8-48.8c-20.3-20.3-53.2-20.3-73.5 0L32 342.5V128c0-35.3 28.7-64 64-64zm64 64H96v64c35.3 0 64-28.7 64-64zM544 320c-35.3 0-64 28.7-64 64h64V320zM320 352a96 96 0 1 0 0-192 96 96 0 1 0 0 192z"
    ]
};
var $d8206b3ab2e65c05$export$18ab80cba7d5044f = {
    prefix: "fas",
    iconName: "money-bill-trend-up",
    icon: [
        512,
        512,
        [],
        "e529",
        "M470.7 9.4c3 3.1 5.3 6.6 6.9 10.3s2.4 7.8 2.4 12.2l0 .1v0 96c0 17.7-14.3 32-32 32s-32-14.3-32-32V109.3L310.6 214.6c-11.8 11.8-30.8 12.6-43.5 1.7L176 138.1 84.8 216.3c-13.4 11.5-33.6 9.9-45.1-3.5s-9.9-33.6 3.5-45.1l112-96c12-10.3 29.7-10.3 41.7 0l89.5 76.7L370.7 64H352c-17.7 0-32-14.3-32-32s14.3-32 32-32h96 0c8.8 0 16.8 3.6 22.6 9.3l.1 .1zM0 304c0-26.5 21.5-48 48-48H464c26.5 0 48 21.5 48 48V464c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V304zM48 416v48H96c0-26.5-21.5-48-48-48zM96 304H48v48c26.5 0 48-21.5 48-48zM464 416c-26.5 0-48 21.5-48 48h48V416zM416 304c0 26.5 21.5 48 48 48V304H416zm-96 80a64 64 0 1 0 -128 0 64 64 0 1 0 128 0z"
    ]
};
var $d8206b3ab2e65c05$export$30d3e64480aa266b = {
    prefix: "fas",
    iconName: "house-flood-water-circle-arrow-right",
    icon: [
        640,
        512,
        [],
        "e50f",
        "M288 144A144 144 0 1 0 0 144a144 144 0 1 0 288 0zM140.7 76.7c6.2-6.2 16.4-6.2 22.6 0l56 56c6.2 6.2 6.2 16.4 0 22.6l-56 56c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6L169.4 160H80c-8.8 0-16-7.2-16-16s7.2-16 16-16h89.4L140.7 99.3c-6.2-6.2-6.2-16.4 0-22.6zM320 144c0 57.3-27.4 108.2-69.8 140.3c11.8-3.6 23-9.4 33-16.2c22.1-15.5 51.6-15.5 73.7 0c18.4 12.7 39.6 20.3 59.2 20.3c19 0 41.2-7.9 59.2-20.3c23.8-16.7 55.8-15.4 78.1 3.4c2.1 1.7 4.2 3.3 6.5 4.9l-.3-84.4H576c13.9 0 26.1-8.9 30.4-22.1s-.4-27.6-11.6-35.8l-176-128C407.6-2 392.4-2 381.2 6.1L301 64.4c12.1 23.9 19 50.9 19 79.6zm18.5 165.9c-11.1-7.9-25.9-7.9-37 0C279 325.4 251.5 336 224 336c-26.9 0-55.3-10.8-77.4-26.1l0 0c-11.9-8.5-28.1-7.8-39.2 1.7c-14.4 11.9-32.5 21-50.6 25.2c-17.2 4-27.9 21.2-23.9 38.4s21.2 27.9 38.4 23.9c24.5-5.7 44.9-16.5 58.2-25C158.5 389.7 191 400 224 400c31.9 0 60.6-9.9 80.4-18.9c5.8-2.7 11.1-5.3 15.6-7.7c4.5 2.4 9.7 5.1 15.6 7.7c19.8 9 48.6 18.9 80.4 18.9c33 0 65.5-10.3 94.5-25.8c13.4 8.4 33.7 19.3 58.2 25c17.2 4 34.4-6.7 38.4-23.9s-6.7-34.4-23.9-38.4c-18.1-4.2-36.2-13.3-50.6-25.2c-11.1-9.5-27.3-10.1-39.2-1.7l0 0C471.4 325.2 442.9 336 416 336c-27.5 0-55-10.6-77.5-26.1zm0 112c-11.1-7.9-25.9-7.9-37 0C279 437.4 251.5 448 224 448c-26.9 0-55.3-10.8-77.4-26.1l0 0c-11.9-8.5-28.1-7.8-39.2 1.7c-14.4 11.9-32.5 21-50.6 25.2c-17.2 4-27.9 21.2-23.9 38.4s21.2 27.9 38.4 23.9c24.5-5.7 44.9-16.5 58.2-25C158.5 501.7 191 512 224 512c31.9 0 60.6-9.9 80.4-18.9c5.8-2.7 11.1-5.3 15.6-7.7c4.5 2.4 9.7 5.1 15.6 7.7c19.8 9 48.6 18.9 80.4 18.9c33 0 65.5-10.3 94.5-25.8c13.4 8.4 33.7 19.3 58.2 25c17.2 4 34.4-6.7 38.4-23.9s-6.7-34.4-23.9-38.4c-18.1-4.2-36.2-13.3-50.6-25.2c-11.1-9.4-27.3-10.1-39.2-1.7l0 0C471.4 437.2 442.9 448 416 448c-27.5 0-55-10.6-77.5-26.1z"
    ]
};
var $d8206b3ab2e65c05$export$287bdd70ab874659 = {
    prefix: "fas",
    iconName: "square-poll-horizontal",
    icon: [
        448,
        512,
        [
            "poll-h"
        ],
        "f682",
        "M448 96c0-35.3-28.7-64-64-64L64 32C28.7 32 0 60.7 0 96L0 416c0 35.3 28.7 64 64 64l320 0c35.3 0 64-28.7 64-64l0-320zM256 160c0 17.7-14.3 32-32 32l-96 0c-17.7 0-32-14.3-32-32s14.3-32 32-32l96 0c17.7 0 32 14.3 32 32zm64 64c17.7 0 32 14.3 32 32s-14.3 32-32 32l-192 0c-17.7 0-32-14.3-32-32s14.3-32 32-32l192 0zM192 352c0 17.7-14.3 32-32 32l-32 0c-17.7 0-32-14.3-32-32s14.3-32 32-32l32 0c17.7 0 32 14.3 32 32z"
    ]
};
var $d8206b3ab2e65c05$export$456a238f0144d430 = $d8206b3ab2e65c05$export$287bdd70ab874659;
var $d8206b3ab2e65c05$export$4280b2387fbdad12 = {
    prefix: "fas",
    iconName: "circle",
    icon: [
        512,
        512,
        [
            128308,
            128309,
            128992,
            128993,
            128994,
            128995,
            128996,
            9679,
            9898,
            9899,
            11044,
            61708,
            61915
        ],
        "f111",
        "M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512z"
    ]
};
var $d8206b3ab2e65c05$export$662cbc6ed5a3c5e8 = {
    prefix: "fas",
    iconName: "backward-fast",
    icon: [
        512,
        512,
        [
            9198,
            "fast-backward"
        ],
        "f049",
        "M493.6 445c-11.2 5.3-24.5 3.6-34.1-4.4L288 297.7V416c0 12.4-7.2 23.7-18.4 29s-24.5 3.6-34.1-4.4L64 297.7V416c0 17.7-14.3 32-32 32s-32-14.3-32-32V96C0 78.3 14.3 64 32 64s32 14.3 32 32V214.3L235.5 71.4c9.5-7.9 22.8-9.7 34.1-4.4S288 83.6 288 96V214.3L459.5 71.4c9.5-7.9 22.8-9.7 34.1-4.4S512 83.6 512 96V416c0 12.4-7.2 23.7-18.4 29z"
    ]
};
var $d8206b3ab2e65c05$export$e6246a3279a379b8 = $d8206b3ab2e65c05$export$662cbc6ed5a3c5e8;
var $d8206b3ab2e65c05$export$a65c441f12cb6bd = {
    prefix: "fas",
    iconName: "recycle",
    icon: [
        512,
        512,
        [
            9842,
            9850,
            9851
        ],
        "f1b8",
        "M174.7 45.1C192.2 17 223 0 256 0s63.8 17 81.3 45.1l38.6 61.7 27-15.6c8.4-4.9 18.9-4.2 26.6 1.7s11.1 15.9 8.6 25.3l-23.4 87.4c-3.4 12.8-16.6 20.4-29.4 17l-87.4-23.4c-9.4-2.5-16.3-10.4-17.6-20s3.4-19.1 11.8-23.9l28.4-16.4L283 79c-5.8-9.3-16-15-27-15s-21.2 5.7-27 15l-17.5 28c-9.2 14.8-28.6 19.5-43.6 10.5c-15.3-9.2-20.2-29.2-10.7-44.4l17.5-28zM429.5 251.9c15-9 34.4-4.3 43.6 10.5l24.4 39.1c9.4 15.1 14.4 32.4 14.6 50.2c.3 53.1-42.7 96.4-95.8 96.4L320 448v32c0 9.7-5.8 18.5-14.8 22.2s-19.3 1.7-26.2-5.2l-64-64c-9.4-9.4-9.4-24.6 0-33.9l64-64c6.9-6.9 17.2-8.9 26.2-5.2s14.8 12.5 14.8 22.2v32l96.2 0c17.6 0 31.9-14.4 31.8-32c0-5.9-1.7-11.7-4.8-16.7l-24.4-39.1c-9.5-15.2-4.7-35.2 10.7-44.4zm-364.6-31L36 204.2c-8.4-4.9-13.1-14.3-11.8-23.9s8.2-17.5 17.6-20l87.4-23.4c12.8-3.4 26 4.2 29.4 17L182 241.2c2.5 9.4-.9 19.3-8.6 25.3s-18.2 6.6-26.6 1.7l-26.5-15.3L68.8 335.3c-3.1 5-4.8 10.8-4.8 16.7c-.1 17.6 14.2 32 31.8 32l32.2 0c17.7 0 32 14.3 32 32s-14.3 32-32 32l-32.2 0C42.7 448-.3 404.8 0 351.6c.1-17.8 5.1-35.1 14.6-50.2l50.3-80.5z"
    ]
};
var $d8206b3ab2e65c05$export$94363e983c225a04 = {
    prefix: "fas",
    iconName: "user-astronaut",
    icon: [
        448,
        512,
        [],
        "f4fb",
        "M370.7 96.1C346.1 39.5 289.7 0 224 0S101.9 39.5 77.3 96.1C60.9 97.5 48 111.2 48 128v64c0 16.8 12.9 30.5 29.3 31.9C101.9 280.5 158.3 320 224 320s122.1-39.5 146.7-96.1c16.4-1.4 29.3-15.1 29.3-31.9V128c0-16.8-12.9-30.5-29.3-31.9zM336 144v16c0 53-43 96-96 96H208c-53 0-96-43-96-96V144c0-26.5 21.5-48 48-48H288c26.5 0 48 21.5 48 48zM189.3 162.7l-6-21.2c-.9-3.3-3.9-5.5-7.3-5.5s-6.4 2.2-7.3 5.5l-6 21.2-21.2 6c-3.3 .9-5.5 3.9-5.5 7.3s2.2 6.4 5.5 7.3l21.2 6 6 21.2c.9 3.3 3.9 5.5 7.3 5.5s6.4-2.2 7.3-5.5l6-21.2 21.2-6c3.3-.9 5.5-3.9 5.5-7.3s-2.2-6.4-5.5-7.3l-21.2-6zM112.7 316.5C46.7 342.6 0 407 0 482.3C0 498.7 13.3 512 29.7 512H128V448c0-17.7 14.3-32 32-32H288c17.7 0 32 14.3 32 32v64l98.3 0c16.4 0 29.7-13.3 29.7-29.7c0-75.3-46.7-139.7-112.7-165.8C303.9 338.8 265.5 352 224 352s-79.9-13.2-111.3-35.5zM176 448c-8.8 0-16 7.2-16 16v48h32V464c0-8.8-7.2-16-16-16zm96 32a16 16 0 1 0 0-32 16 16 0 1 0 0 32z"
    ]
};
var $d8206b3ab2e65c05$export$cfee4df0d5df6d21 = {
    prefix: "fas",
    iconName: "plane-slash",
    icon: [
        640,
        512,
        [],
        "e069",
        "M514.3 192c34.2 0 93.7 29 93.7 64c0 36-59.5 64-93.7 64H440.6L630.8 469.1c10.4 8.2 12.3 23.3 4.1 33.7s-23.3 12.3-33.7 4.1L9.2 42.9C-1.2 34.7-3.1 19.6 5.1 9.2S28.4-3.1 38.8 5.1L238.1 161.3 197.8 20.4C194.9 10.2 202.6 0 213.2 0h56.2c11.5 0 22.1 6.2 27.8 16.1L397.7 192l116.6 0zM41.5 128.7l321 252.9L297.2 495.9c-5.7 10-16.3 16.1-27.8 16.1l-56.2 0c-10.6 0-18.3-10.2-15.4-20.4l49-171.6H144l-43.2 57.6c-3 4-7.8 6.4-12.8 6.4H46c-7.8 0-14-6.3-14-14c0-1.3 .2-2.6 .5-3.9L64 256 32.5 145.9c-.4-1.3-.5-2.6-.5-3.9c0-6.2 4-11.4 9.5-13.3z"
    ]
};
var $d8206b3ab2e65c05$export$9c9b2fbddd59047d = {
    prefix: "fas",
    iconName: "trademark",
    icon: [
        640,
        512,
        [
            8482
        ],
        "f25c",
        "M345.6 108.8c-8.3-11-22.7-15.5-35.7-11.2S288 114.2 288 128V384c0 17.7 14.3 32 32 32s32-14.3 32-32V224l86.4 115.2c6 8.1 15.5 12.8 25.6 12.8s19.6-4.7 25.6-12.8L576 224V384c0 17.7 14.3 32 32 32s32-14.3 32-32V128c0-13.8-8.8-26-21.9-30.4s-27.5 .1-35.7 11.2L464 266.7 345.6 108.8zM0 128c0 17.7 14.3 32 32 32H96V384c0 17.7 14.3 32 32 32s32-14.3 32-32V160h64c17.7 0 32-14.3 32-32s-14.3-32-32-32H32C14.3 96 0 110.3 0 128z"
    ]
};
var $d8206b3ab2e65c05$export$44dee69e3a29b0e = {
    prefix: "fas",
    iconName: "basketball",
    icon: [
        512,
        512,
        [
            127936,
            "basketball-ball"
        ],
        "f434",
        "M86.6 64l85.2 85.2C194.5 121.7 208 86.4 208 48c0-14.7-2-28.9-5.7-42.4C158.6 15 119 35.5 86.6 64zM64 86.6C35.5 119 15 158.6 5.6 202.3C19.1 206 33.3 208 48 208c38.4 0 73.7-13.5 101.3-36.1L64 86.6zM256 0c-7.3 0-14.6 .3-21.8 .9C238 16 240 31.8 240 48c0 47.3-17.1 90.5-45.4 124L256 233.4 425.4 64C380.2 24.2 320.9 0 256 0zM48 240c-16.2 0-32-2-47.1-5.8C.3 241.4 0 248.7 0 256c0 64.9 24.2 124.2 64 169.4L233.4 256 172 194.6C138.5 222.9 95.3 240 48 240zm463.1 37.8c.6-7.2 .9-14.5 .9-21.8c0-64.9-24.2-124.2-64-169.4L278.6 256 340 317.4c33.4-28.3 76.7-45.4 124-45.4c16.2 0 32 2 47.1 5.8zm-4.7 31.9C492.9 306 478.7 304 464 304c-38.4 0-73.7 13.5-101.3 36.1L448 425.4c28.5-32.3 49.1-71.9 58.4-115.7zM340.1 362.7C317.5 390.3 304 425.6 304 464c0 14.7 2 28.9 5.7 42.4C353.4 497 393 476.5 425.4 448l-85.2-85.2zM317.4 340L256 278.6 86.6 448c45.1 39.8 104.4 64 169.4 64c7.3 0 14.6-.3 21.8-.9C274 496 272 480.2 272 464c0-47.3 17.1-90.5 45.4-124z"
    ]
};
var $d8206b3ab2e65c05$export$36550ab8ffcc5b28 = $d8206b3ab2e65c05$export$44dee69e3a29b0e;
var $d8206b3ab2e65c05$export$219ccae0e4da3c92 = {
    prefix: "fas",
    iconName: "satellite-dish",
    icon: [
        512,
        512,
        [
            128225
        ],
        "f7c0",
        "M192 32c0-17.7 14.3-32 32-32C383.1 0 512 128.9 512 288c0 17.7-14.3 32-32 32s-32-14.3-32-32C448 164.3 347.7 64 224 64c-17.7 0-32-14.3-32-32zM60.6 220.6L164.7 324.7l28.4-28.4c-.7-2.6-1.1-5.4-1.1-8.3c0-17.7 14.3-32 32-32s32 14.3 32 32s-14.3 32-32 32c-2.9 0-5.6-.4-8.3-1.1l-28.4 28.4L291.4 451.4c14.5 14.5 11.8 38.8-7.3 46.3C260.5 506.9 234.9 512 208 512C93.1 512 0 418.9 0 304c0-26.9 5.1-52.5 14.4-76.1c7.5-19 31.8-21.8 46.3-7.3zM224 96c106 0 192 86 192 192c0 17.7-14.3 32-32 32s-32-14.3-32-32c0-70.7-57.3-128-128-128c-17.7 0-32-14.3-32-32s14.3-32 32-32z"
    ]
};
var $d8206b3ab2e65c05$export$72ea8a5e4e86cd69 = {
    prefix: "fas",
    iconName: "circle-up",
    icon: [
        512,
        512,
        [
            61467,
            "arrow-alt-circle-up"
        ],
        "f35b",
        "M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM135.1 217.4l107.1-99.9c3.8-3.5 8.7-5.5 13.8-5.5s10.1 2 13.8 5.5l107.1 99.9c4.5 4.2 7.1 10.1 7.1 16.3c0 12.3-10 22.3-22.3 22.3H304v96c0 17.7-14.3 32-32 32H240c-17.7 0-32-14.3-32-32V256H150.3C138 256 128 246 128 233.7c0-6.2 2.6-12.1 7.1-16.3z"
    ]
};
var $d8206b3ab2e65c05$export$3747a8ef0995eadf = $d8206b3ab2e65c05$export$72ea8a5e4e86cd69;
var $d8206b3ab2e65c05$export$da39ed20699ee2d7 = {
    prefix: "fas",
    iconName: "mobile-screen-button",
    icon: [
        384,
        512,
        [
            "mobile-alt"
        ],
        "f3cd",
        "M16 64C16 28.7 44.7 0 80 0H304c35.3 0 64 28.7 64 64V448c0 35.3-28.7 64-64 64H80c-35.3 0-64-28.7-64-64V64zM224 448a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zM304 64H80V384H304V64z"
    ]
};
var $d8206b3ab2e65c05$export$e9599bc6cd92234d = $d8206b3ab2e65c05$export$da39ed20699ee2d7;
var $d8206b3ab2e65c05$export$39461921e738be65 = {
    prefix: "fas",
    iconName: "volume-high",
    icon: [
        640,
        512,
        [
            128266,
            "volume-up"
        ],
        "f028",
        "M533.6 32.5C598.5 85.3 640 165.8 640 256s-41.5 170.8-106.4 223.5c-10.3 8.4-25.4 6.8-33.8-3.5s-6.8-25.4 3.5-33.8C557.5 398.2 592 331.2 592 256s-34.5-142.2-88.7-186.3c-10.3-8.4-11.8-23.5-3.5-33.8s23.5-11.8 33.8-3.5zM473.1 107c43.2 35.2 70.9 88.9 70.9 149s-27.7 113.8-70.9 149c-10.3 8.4-25.4 6.8-33.8-3.5s-6.8-25.4 3.5-33.8C475.3 341.3 496 301.1 496 256s-20.7-85.3-53.2-111.8c-10.3-8.4-11.8-23.5-3.5-33.8s23.5-11.8 33.8-3.5zm-60.5 74.5C434.1 199.1 448 225.9 448 256s-13.9 56.9-35.4 74.5c-10.3 8.4-25.4 6.8-33.8-3.5s-6.8-25.4 3.5-33.8C393.1 284.4 400 271 400 256s-6.9-28.4-17.7-37.3c-10.3-8.4-11.8-23.5-3.5-33.8s23.5-11.8 33.8-3.5zM301.1 34.8C312.6 40 320 51.4 320 64V448c0 12.6-7.4 24-18.9 29.2s-25 3.1-34.4-5.3L131.8 352H64c-35.3 0-64-28.7-64-64V224c0-35.3 28.7-64 64-64h67.8L266.7 40.1c9.4-8.4 22.9-10.4 34.4-5.3z"
    ]
};
var $d8206b3ab2e65c05$export$5940d3e475d90cc4 = $d8206b3ab2e65c05$export$39461921e738be65;
var $d8206b3ab2e65c05$export$9c0b63b698611d06 = {
    prefix: "fas",
    iconName: "users-rays",
    icon: [
        640,
        512,
        [],
        "e593",
        "M41 7C31.6-2.3 16.4-2.3 7 7S-2.3 31.6 7 41l72 72c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9L41 7zM599 7L527 79c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l72-72c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0zM7 505c9.4 9.4 24.6 9.4 33.9 0l72-72c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0L7 471c-9.4 9.4-9.4 24.6 0 33.9zm592 0c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9l-72-72c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9l72 72zM320 256a64 64 0 1 0 0-128 64 64 0 1 0 0 128zM212.1 336c-2.7 7.5-4.1 15.6-4.1 24c0 13.3 10.7 24 24 24H408c13.3 0 24-10.7 24-24c0-8.4-1.4-16.5-4.1-24c-.5-1.4-1-2.7-1.6-4c-9.4-22.3-29.8-38.9-54.3-43c-3.9-.7-7.9-1-12-1H280c-4.1 0-8.1 .3-12 1c-.8 .1-1.7 .3-2.5 .5c-24.9 5.1-45.1 23-53.4 46.5zM175.8 224a48 48 0 1 0 0-96 48 48 0 1 0 0 96zm-26.5 32C119.9 256 96 279.9 96 309.3c0 14.7 11.9 26.7 26.7 26.7h56.1c8-34.1 32.8-61.7 65.2-73.6c-7.5-4.1-16.2-6.4-25.3-6.4H149.3zm368 80c14.7 0 26.7-11.9 26.7-26.7c0-29.5-23.9-53.3-53.3-53.3H421.3c-9.2 0-17.8 2.3-25.3 6.4c32.4 11.9 57.2 39.5 65.2 73.6h56.1zM464 224a48 48 0 1 0 0-96 48 48 0 1 0 0 96z"
    ]
};
var $d8206b3ab2e65c05$export$79204db8777905c8 = {
    prefix: "fas",
    iconName: "wallet",
    icon: [
        512,
        512,
        [],
        "f555",
        "M64 32C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H448c35.3 0 64-28.7 64-64V192c0-35.3-28.7-64-64-64H80c-8.8 0-16-7.2-16-16s7.2-16 16-16H448c17.7 0 32-14.3 32-32s-14.3-32-32-32H64zM416 272a32 32 0 1 1 0 64 32 32 0 1 1 0-64z"
    ]
};
var $d8206b3ab2e65c05$export$7babcb2c90eb609a = {
    prefix: "fas",
    iconName: "clipboard-check",
    icon: [
        384,
        512,
        [],
        "f46c",
        "M192 0c-41.8 0-77.4 26.7-90.5 64H64C28.7 64 0 92.7 0 128V448c0 35.3 28.7 64 64 64H320c35.3 0 64-28.7 64-64V128c0-35.3-28.7-64-64-64H282.5C269.4 26.7 233.8 0 192 0zm0 64a32 32 0 1 1 0 64 32 32 0 1 1 0-64zM305 273L177 401c-9.4 9.4-24.6 9.4-33.9 0L79 337c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l47 47L271 239c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9z"
    ]
};
var $d8206b3ab2e65c05$export$b8d24c57c9e64933 = {
    prefix: "fas",
    iconName: "file-audio",
    icon: [
        384,
        512,
        [],
        "f1c7",
        "M64 0C28.7 0 0 28.7 0 64V448c0 35.3 28.7 64 64 64H320c35.3 0 64-28.7 64-64V160H256c-17.7 0-32-14.3-32-32V0H64zM256 0V128H384L256 0zm2 226.3c37.1 22.4 62 63.1 62 109.7s-24.9 87.3-62 109.7c-7.6 4.6-17.4 2.1-22-5.4s-2.1-17.4 5.4-22C269.4 401.5 288 370.9 288 336s-18.6-65.5-46.5-82.3c-7.6-4.6-10-14.4-5.4-22s14.4-10 22-5.4zm-91.9 30.9c6 2.5 9.9 8.3 9.9 14.8V400c0 6.5-3.9 12.3-9.9 14.8s-12.9 1.1-17.4-3.5L113.4 376H80c-8.8 0-16-7.2-16-16V312c0-8.8 7.2-16 16-16h33.4l35.3-35.3c4.6-4.6 11.5-5.9 17.4-3.5zm51 34.9c6.6-5.9 16.7-5.3 22.6 1.3C249.8 304.6 256 319.6 256 336s-6.2 31.4-16.3 42.7c-5.9 6.6-16 7.1-22.6 1.3s-7.1-16-1.3-22.6c5.1-5.7 8.1-13.1 8.1-21.3s-3.1-15.7-8.1-21.3c-5.9-6.6-5.3-16.7 1.3-22.6z"
    ]
};
var $d8206b3ab2e65c05$export$128a6cab12423493 = {
    prefix: "fas",
    iconName: "burger",
    icon: [
        512,
        512,
        [
            "hamburger"
        ],
        "f805",
        "M61.1 224C45 224 32 211 32 194.9c0-1.9 .2-3.7 .6-5.6C37.9 168.3 78.8 32 256 32s218.1 136.3 223.4 157.3c.5 1.9 .6 3.7 .6 5.6c0 16.1-13 29.1-29.1 29.1H61.1zM144 128a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zm240 16a16 16 0 1 0 0-32 16 16 0 1 0 0 32zM272 96a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zM16 304c0-26.5 21.5-48 48-48H448c26.5 0 48 21.5 48 48s-21.5 48-48 48H64c-26.5 0-48-21.5-48-48zm16 96c0-8.8 7.2-16 16-16H464c8.8 0 16 7.2 16 16v16c0 35.3-28.7 64-64 64H96c-35.3 0-64-28.7-64-64V400z"
    ]
};
var $d8206b3ab2e65c05$export$bab3bb9f4f59363 = $d8206b3ab2e65c05$export$128a6cab12423493;
var $d8206b3ab2e65c05$export$3c6c0c8185296ac5 = {
    prefix: "fas",
    iconName: "wrench",
    icon: [
        512,
        512,
        [
            128295
        ],
        "f0ad",
        "M352 320c88.4 0 160-71.6 160-160c0-15.3-2.2-30.1-6.2-44.2c-3.1-10.8-16.4-13.2-24.3-5.3l-76.8 76.8c-3 3-7.1 4.7-11.3 4.7H336c-8.8 0-16-7.2-16-16V118.6c0-4.2 1.7-8.3 4.7-11.3l76.8-76.8c7.9-7.9 5.4-21.2-5.3-24.3C382.1 2.2 367.3 0 352 0C263.6 0 192 71.6 192 160c0 19.1 3.4 37.5 9.5 54.5L19.9 396.1C7.2 408.8 0 426.1 0 444.1C0 481.6 30.4 512 67.9 512c18 0 35.3-7.2 48-19.9L297.5 310.5c17 6.2 35.4 9.5 54.5 9.5zM80 408a24 24 0 1 1 0 48 24 24 0 1 1 0-48z"
    ]
};
var $d8206b3ab2e65c05$export$f5bfd1271b8b71d1 = {
    prefix: "fas",
    iconName: "bugs",
    icon: [
        576,
        512,
        [],
        "e4d0",
        "M164.5 107.4l33.4-73.5c5.5-12.1 .1-26.3-11.9-31.8s-26.3-.1-31.8 11.9L128 71.7 101.9 14.1C96.4 2 82.1-3.3 70.1 2.1S52.7 21.9 58.1 33.9l33.4 73.5c-10.2 7.1-18.2 17-22.9 28.6h-17l-4.1-20.7c-2.6-13-15.2-21.4-28.2-18.8S-2.1 111.7 .5 124.7l8 40C10.7 175.9 20.6 184 32 184H64v23.3l-37.8 9.5c-9.5 2.4-16.6 10.2-17.9 19.9l-8 56c-1.9 13.1 7.2 25.3 20.4 27.2s25.3-7.2 27.2-20.4l5.7-40 18.4-4.6C82.7 274.6 103.8 288 128 288s45.3-13.4 56.1-33.2l18.4 4.6 5.7 40c1.9 13.1 14 22.2 27.2 20.4s22.2-14 20.4-27.2l-8-56c-1.4-9.7-8.5-17.5-17.9-19.9L192 207.3V184h32c11.4 0 21.3-8.1 23.5-19.3l8-40c2.6-13-5.8-25.6-18.8-28.2s-25.6 5.8-28.2 18.8L204.3 136h-17c-4.7-11.6-12.7-21.5-22.9-28.6zM496 286.5l65.6-47c10.8-7.7 13.3-22.7 5.6-33.5s-22.7-13.3-33.5-5.6l-51.4 36.8 6.1-62.9c1.3-13.2-8.4-24.9-21.6-26.2s-24.9 8.4-26.2 21.6L432.8 250c-12.3 1-24.2 5.6-34.1 13.3L384 254.8l6.8-20c4.2-12.6-2.5-26.2-15-30.4s-26.2 2.5-30.4 15l-13.1 38.6c-3.7 10.8 .8 22.8 10.7 28.5l27.7 16L359 322.7 321.5 312c-9.4-2.7-19.5 .6-25.5 8.3l-34.9 44.5c-8.2 10.4-6.4 25.5 4.1 33.7s25.5 6.4 33.7-4.1l25-31.8 18.2 5.2c-.5 22.6 11 44.7 32 56.8s45.9 11 65.2-.7l13.6 13.2-15.1 37.5c-4.9 12.3 1 26.3 13.3 31.2s26.3-1 31.2-13.3L503.5 440c3.6-9.1 1.4-19.4-5.6-26.2l-28-27.1 11.6-20.1 27.7 16c9.9 5.7 22.5 3.7 30-4.9L566.2 347c8.7-10 7.8-25.1-2.2-33.9s-25.1-7.8-33.9 2.2l-13.9 15.9-14.7-8.5c1.7-12.4-.2-25-5.5-36.2z"
    ]
};
var $d8206b3ab2e65c05$export$8bf9e3f7f57d486a = {
    prefix: "fas",
    iconName: "rupee-sign",
    icon: [
        448,
        512,
        [
            8360,
            "rupee"
        ],
        "f156",
        "M0 64C0 46.3 14.3 32 32 32h80c79.5 0 144 64.5 144 144c0 58.8-35.2 109.3-85.7 131.7l51.4 128.4c6.6 16.4-1.4 35-17.8 41.6s-35-1.4-41.6-17.8L106.3 320H64V448c0 17.7-14.3 32-32 32s-32-14.3-32-32V288 64zM64 256h48c44.2 0 80-35.8 80-80s-35.8-80-80-80H64V256zm256.5 16.4c-.9 6 0 8.7 .4 9.8c.4 1.1 1.4 2.6 4.2 4.9c7.2 5.7 18.7 10 37.9 16.8l1.3 .5c16 5.6 38.7 13.6 55.7 28.1c9.5 8.1 17.9 18.6 23.1 32.3c5.1 13.7 6.1 28.5 3.8 44c-4.2 28.1-20.5 49.3-43.8 60.9c-22.1 11-48.1 12.5-73.2 8l-.2 0 0 0c-9.3-1.8-20.5-5.7-29.3-9c-6-2.3-12.6-4.9-17.7-6.9l0 0c-2.5-1-4.6-1.8-6.3-2.5c-16.5-6.4-24.6-25-18.2-41.4s24.9-24.6 41.4-18.2c2.6 1 5.2 2 7.9 3.1l0 0c4.8 1.9 9.8 3.9 15.4 6c8.8 3.3 15.3 5.4 18.7 6c15.7 2.8 26.7 .8 32.9-2.3c5-2.5 8-6 9.1-13c1-6.9 .2-10.5-.5-12.3c-.6-1.7-1.8-3.6-4.5-5.9c-6.9-5.8-18.2-10.4-36.9-17l-3-1.1c-15.5-5.4-37-13-53.3-25.9c-9.5-7.5-18.3-17.6-23.7-31c-5.5-13.4-6.6-28-4.4-43.2c8.4-57.1 67-78 116.9-68.9c6.9 1.3 27.3 5.8 35.4 8.4c16.9 5.2 26.3 23.2 21.1 40.1s-23.2 26.3-40.1 21.1c-4.7-1.4-22.3-5.5-27.9-6.5c-14.6-2.7-25.8-.4-32.6 3.2c-6.3 3.3-8.9 7.6-9.5 12z"
    ]
};
var $d8206b3ab2e65c05$export$9da25a46cfcb6fa4 = $d8206b3ab2e65c05$export$8bf9e3f7f57d486a;
var $d8206b3ab2e65c05$export$6440b286d3cbac9b = {
    prefix: "fas",
    iconName: "file-image",
    icon: [
        384,
        512,
        [
            128443
        ],
        "f1c5",
        "M64 0C28.7 0 0 28.7 0 64V448c0 35.3 28.7 64 64 64H320c35.3 0 64-28.7 64-64V160H256c-17.7 0-32-14.3-32-32V0H64zM256 0V128H384L256 0zM64 256a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm152 32c5.3 0 10.2 2.6 13.2 6.9l88 128c3.4 4.9 3.7 11.3 1 16.5s-8.2 8.6-14.2 8.6H216 176 128 80c-5.8 0-11.1-3.1-13.9-8.1s-2.8-11.2 .2-16.1l48-80c2.9-4.8 8.1-7.8 13.7-7.8s10.8 2.9 13.7 7.8l12.8 21.4 48.3-70.2c3-4.3 7.9-6.9 13.2-6.9z"
    ]
};
var $d8206b3ab2e65c05$export$d7cf0978afd90002 = {
    prefix: "fas",
    iconName: "circle-question",
    icon: [
        512,
        512,
        [
            62108,
            "question-circle"
        ],
        "f059",
        "M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM169.8 165.3c7.9-22.3 29.1-37.3 52.8-37.3h58.3c34.9 0 63.1 28.3 63.1 63.1c0 22.6-12.1 43.5-31.7 54.8L280 264.4c-.2 13-10.9 23.6-24 23.6c-13.3 0-24-10.7-24-24V250.5c0-8.6 4.6-16.5 12.1-20.8l44.3-25.4c4.7-2.7 7.6-7.7 7.6-13.1c0-8.4-6.8-15.1-15.1-15.1H222.6c-3.4 0-6.4 2.1-7.5 5.3l-.4 1.2c-4.4 12.5-18.2 19-30.6 14.6s-19-18.2-14.6-30.6l.4-1.2zM224 352a32 32 0 1 1 64 0 32 32 0 1 1 -64 0z"
    ]
};
var $d8206b3ab2e65c05$export$5ba67d7f2265c1a5 = $d8206b3ab2e65c05$export$d7cf0978afd90002;
var $d8206b3ab2e65c05$export$6ccbeeccfea6dc8a = {
    prefix: "fas",
    iconName: "plane-departure",
    icon: [
        640,
        512,
        [
            128747
        ],
        "f5b0",
        "M381 114.9L186.1 41.8c-16.7-6.2-35.2-5.3-51.1 2.7L89.1 67.4C78 73 77.2 88.5 87.6 95.2l146.9 94.5L136 240 77.8 214.1c-8.7-3.9-18.8-3.7-27.3 .6L18.3 230.8c-9.3 4.7-11.8 16.8-5 24.7l73.1 85.3c6.1 7.1 15 11.2 24.3 11.2H248.4c5 0 9.9-1.2 14.3-3.4L535.6 212.2c46.5-23.3 82.5-63.3 100.8-112C645.9 75 627.2 48 600.2 48H542.8c-20.2 0-40.2 4.8-58.2 14L381 114.9zM0 480c0 17.7 14.3 32 32 32H608c17.7 0 32-14.3 32-32s-14.3-32-32-32H32c-17.7 0-32 14.3-32 32z"
    ]
};
var $d8206b3ab2e65c05$export$2cef3f81ad90fb76 = {
    prefix: "fas",
    iconName: "handshake-slash",
    icon: [
        640,
        512,
        [],
        "e060",
        "M38.8 5.1C28.4-3.1 13.3-1.2 5.1 9.2S-1.2 34.7 9.2 42.9l592 464c10.4 8.2 25.5 6.3 33.7-4.1s6.3-25.5-4.1-33.7l-135-105.8c-1.1-11.3-6.3-22.3-15.3-30.7l-134.2-123-23.4 18.2-26-20.3 77.2-60.1c7-5.4 17-4.2 22.5 2.8s4.2 17-2.8 22.5l-20.9 16.2L512 316.8V128h-.7l-3.9-2.5L434.8 79c-15.3-9.8-33.2-15-51.4-15c-21.8 0-43 7.5-60 21.2l-89.7 72.6-25.8-20.3 81.8-66.2c-11.6-4.9-24.1-7.4-36.8-7.4C234 64 215.7 69.6 200 80l-35.5 23.7L38.8 5.1zM413.6 421.9L128 196.8V352h28.2l91.4 83.4c19.6 17.9 49.9 16.5 67.8-3.1c5.5-6.1 9.2-13.2 11.1-20.6l17 15.6c19.5 17.9 49.9 16.6 67.8-2.9c.8-.8 1.5-1.7 2.2-2.6zM96 171.6L40.6 128H16c-8.8 0-16 7.2-16 16V352c0 17.7 14.3 32 32 32H64c17.7 0 32-14.3 32-32V171.6zM48 320a16 16 0 1 1 0 32 16 16 0 1 1 0-32zM544 128V352c0 17.7 14.3 32 32 32h32c17.7 0 32-14.3 32-32V144c0-8.8-7.2-16-16-16H544zm32 208a16 16 0 1 1 32 0 16 16 0 1 1 -32 0z"
    ]
};
var $d8206b3ab2e65c05$export$3d177ecdf7fc50ec = {
    prefix: "fas",
    iconName: "book-bookmark",
    icon: [
        448,
        512,
        [],
        "e0bb",
        "M0 96C0 43 43 0 96 0h96V190.7c0 13.4 15.5 20.9 26 12.5L272 160l54 43.2c10.5 8.4 26 .9 26-12.5V0h32 32c17.7 0 32 14.3 32 32V352c0 17.7-14.3 32-32 32v64c17.7 0 32 14.3 32 32s-14.3 32-32 32H384 96c-53 0-96-43-96-96V96zM64 416c0 17.7 14.3 32 32 32H352V384H96c-17.7 0-32 14.3-32 32z"
    ]
};
var $d8206b3ab2e65c05$export$aa054a78ab078db3 = {
    prefix: "fas",
    iconName: "code-branch",
    icon: [
        448,
        512,
        [],
        "f126",
        "M80 104a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm80-24c0 32.8-19.7 61-48 73.3v87.8c18.8-10.9 40.7-17.1 64-17.1h96c35.3 0 64-28.7 64-64v-6.7C307.7 141 288 112.8 288 80c0-44.2 35.8-80 80-80s80 35.8 80 80c0 32.8-19.7 61-48 73.3V160c0 70.7-57.3 128-128 128H176c-35.3 0-64 28.7-64 64v6.7c28.3 12.3 48 40.5 48 73.3c0 44.2-35.8 80-80 80s-80-35.8-80-80c0-32.8 19.7-61 48-73.3V352 153.3C19.7 141 0 112.8 0 80C0 35.8 35.8 0 80 0s80 35.8 80 80zm232 0a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zM80 456a24 24 0 1 0 0-48 24 24 0 1 0 0 48z"
    ]
};
var $d8206b3ab2e65c05$export$37672611144b857b = {
    prefix: "fas",
    iconName: "hat-cowboy",
    icon: [
        640,
        512,
        [],
        "f8c0",
        "M320 64c14.4 0 22.3-7 30.8-14.4C360.4 41.1 370.7 32 392 32c49.3 0 84.4 152.2 97.9 221.9C447.8 272.1 390.9 288 320 288s-127.8-15.9-169.9-34.1C163.6 184.2 198.7 32 248 32c21.3 0 31.6 9.1 41.2 17.6C297.7 57 305.6 64 320 64zM111.1 270.7c47.2 24.5 117.5 49.3 209 49.3s161.8-24.8 208.9-49.3c24.8-12.9 49.8-28.3 70.1-47.7c7.9-7.9 20.2-9.2 29.6-3.3c9.5 5.9 13.5 17.9 9.9 28.5c-13.5 37.7-38.4 72.3-66.1 100.6C523.7 398.9 443.6 448 320 448s-203.6-49.1-252.5-99.2C39.8 320.4 14.9 285.8 1.4 248.1c-3.6-10.6 .4-22.6 9.9-28.5c9.5-5.9 21.7-4.5 29.6 3.3c20.4 19.4 45.3 34.8 70.1 47.7z"
    ]
};
var $d8206b3ab2e65c05$export$f402c7c97f3383f0 = {
    prefix: "fas",
    iconName: "bridge",
    icon: [
        576,
        512,
        [],
        "e4c8",
        "M32 32C14.3 32 0 46.3 0 64S14.3 96 32 96H72v64H0V288c53 0 96 43 96 96v64c0 17.7 14.3 32 32 32h32c17.7 0 32-14.3 32-32V384c0-53 43-96 96-96s96 43 96 96v64c0 17.7 14.3 32 32 32h32c17.7 0 32-14.3 32-32V384c0-53 43-96 96-96V160H504V96h40c17.7 0 32-14.3 32-32s-14.3-32-32-32H32zM456 96v64H376V96h80zM328 96v64H248V96h80zM200 96v64H120V96h80z"
    ]
};
var $d8206b3ab2e65c05$export$d86c56ab43eb0deb = {
    prefix: "fas",
    iconName: "phone-flip",
    icon: [
        512,
        512,
        [
            128381,
            "phone-alt"
        ],
        "f879",
        "M347.1 24.6c7.7-18.6 28-28.5 47.4-23.2l88 24C499.9 30.2 512 46 512 64c0 247.4-200.6 448-448 448c-18 0-33.8-12.1-38.6-29.5l-24-88c-5.3-19.4 4.6-39.7 23.2-47.4l96-40c16.3-6.8 35.2-2.1 46.3 11.6L207.3 368c70.4-33.3 127.4-90.3 160.7-160.7L318.7 167c-13.7-11.2-18.4-30-11.6-46.3l40-96z"
    ]
};
var $d8206b3ab2e65c05$export$a07a9b305deebf32 = $d8206b3ab2e65c05$export$d86c56ab43eb0deb;
var $d8206b3ab2e65c05$export$4a5a13c01d46357c = {
    prefix: "fas",
    iconName: "truck-front",
    icon: [
        512,
        512,
        [],
        "e2b7",
        "M0 80C0 35.8 35.8 0 80 0H432c44.2 0 80 35.8 80 80V368c0 26.2-12.6 49.4-32 64v48c0 17.7-14.3 32-32 32H416c-17.7 0-32-14.3-32-32V448H128v32c0 17.7-14.3 32-32 32H64c-17.7 0-32-14.3-32-32V432C12.6 417.4 0 394.2 0 368V80zm129.9 72.2L112 224H400l-17.9-71.8C378.5 138 365.7 128 351 128H161c-14.7 0-27.5 10-31 24.2zM128 320a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zm288 32a32 32 0 1 0 0-64 32 32 0 1 0 0 64z"
    ]
};
var $d8206b3ab2e65c05$export$ab927dada03be4b3 = {
    prefix: "fas",
    iconName: "cat",
    icon: [
        576,
        512,
        [
            128008
        ],
        "f6be",
        "M320 192h17.1c22.1 38.3 63.5 64 110.9 64c11 0 21.8-1.4 32-4v4 32V480c0 17.7-14.3 32-32 32s-32-14.3-32-32V339.2L280 448h56c17.7 0 32 14.3 32 32s-14.3 32-32 32H192c-53 0-96-43-96-96V192.5c0-16.1-12-29.8-28-31.8l-7.9-1c-17.5-2.2-30-18.2-27.8-35.7s18.2-30 35.7-27.8l7.9 1c48 6 84.1 46.8 84.1 95.3v85.3c34.4-51.7 93.2-85.8 160-85.8zm160 26.5v0c-10 3.5-20.8 5.5-32 5.5c-28.4 0-54-12.4-71.6-32h0c-3.7-4.1-7-8.5-9.9-13.2C357.3 164 352 146.6 352 128v0V32 12 10.7C352 4.8 356.7 .1 362.6 0h.2c3.3 0 6.4 1.6 8.4 4.2l0 .1L384 21.3l27.2 36.3L416 64h64l4.8-6.4L512 21.3 524.8 4.3l0-.1c2-2.6 5.1-4.2 8.4-4.2h.2C539.3 .1 544 4.8 544 10.7V12 32v96c0 17.3-4.6 33.6-12.6 47.6c-11.3 19.8-29.6 35.2-51.4 42.9zM432 128a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zm48 16a16 16 0 1 0 0-32 16 16 0 1 0 0 32z"
    ]
};
var $d8206b3ab2e65c05$export$61add9eca991b5ec = {
    prefix: "fas",
    iconName: "anchor-circle-exclamation",
    icon: [
        640,
        512,
        [],
        "e4ab",
        "M320 96a32 32 0 1 1 -64 0 32 32 0 1 1 64 0zm21.1 80C367 158.8 384 129.4 384 96c0-53-43-96-96-96s-96 43-96 96c0 33.4 17 62.8 42.9 80H224c-17.7 0-32 14.3-32 32s14.3 32 32 32h32V448H208c-53 0-96-43-96-96v-6.1l7 7c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9L97 263c-9.4-9.4-24.6-9.4-33.9 0L7 319c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l7-7V352c0 88.4 71.6 160 160 160h80 80c8.2 0 16.3-.6 24.2-1.8c-22.2-16.2-40.4-37.5-53-62.2H320V368 240h32c17.7 0 32-14.3 32-32s-14.3-32-32-32H341.1zM496 512a144 144 0 1 0 0-288 144 144 0 1 0 0 288zm0-96a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm0-144c8.8 0 16 7.2 16 16v80c0 8.8-7.2 16-16 16s-16-7.2-16-16V288c0-8.8 7.2-16 16-16z"
    ]
};
var $d8206b3ab2e65c05$export$f4419f7b2e53b340 = {
    prefix: "fas",
    iconName: "truck-field",
    icon: [
        640,
        512,
        [],
        "e58d",
        "M32 96c0-35.3 28.7-64 64-64H320c23.7 0 44.4 12.9 55.4 32h51.8c25.3 0 48.2 14.9 58.5 38l52.8 118.8c.5 1.1 .9 2.1 1.3 3.2H544c35.3 0 64 28.7 64 64v32c17.7 0 32 14.3 32 32s-14.3 32-32 32H576c0 53-43 96-96 96s-96-43-96-96H256c0 53-43 96-96 96s-96-43-96-96H32c-17.7 0-32-14.3-32-32s14.3-32 32-32V288c-17.7 0-32-14.3-32-32V160c0-17.7 14.3-32 32-32V96zM384 224h85.9l-42.7-96H384v96zM160 432a48 48 0 1 0 0-96 48 48 0 1 0 0 96zm368-48a48 48 0 1 0 -96 0 48 48 0 1 0 96 0z"
    ]
};
var $d8206b3ab2e65c05$export$806c0a45a7ecd6e8 = {
    prefix: "fas",
    iconName: "route",
    icon: [
        512,
        512,
        [],
        "f4d7",
        "M512 96c0 50.2-59.1 125.1-84.6 155c-3.8 4.4-9.4 6.1-14.5 5H320c-17.7 0-32 14.3-32 32s14.3 32 32 32h96c53 0 96 43 96 96s-43 96-96 96H139.6c8.7-9.9 19.3-22.6 30-36.8c6.3-8.4 12.8-17.6 19-27.2H416c17.7 0 32-14.3 32-32s-14.3-32-32-32H320c-53 0-96-43-96-96s43-96 96-96h39.8c-21-31.5-39.8-67.7-39.8-96c0-53 43-96 96-96s96 43 96 96zM117.1 489.1c-3.8 4.3-7.2 8.1-10.1 11.3l-1.8 2-.2-.2c-6 4.6-14.6 4-20-1.8C59.8 473 0 402.5 0 352c0-53 43-96 96-96s96 43 96 96c0 30-21.1 67-43.5 97.9c-10.7 14.7-21.7 28-30.8 38.5l-.6 .7zM128 352a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zM416 128a32 32 0 1 0 0-64 32 32 0 1 0 0 64z"
    ]
};
var $d8206b3ab2e65c05$export$d4aa151a4554b74e = {
    prefix: "fas",
    iconName: "clipboard-question",
    icon: [
        384,
        512,
        [],
        "e4e3",
        "M192 0c-41.8 0-77.4 26.7-90.5 64H64C28.7 64 0 92.7 0 128V448c0 35.3 28.7 64 64 64H320c35.3 0 64-28.7 64-64V128c0-35.3-28.7-64-64-64H282.5C269.4 26.7 233.8 0 192 0zm0 64a32 32 0 1 1 0 64 32 32 0 1 1 0-64zM105.8 229.3c7.9-22.3 29.1-37.3 52.8-37.3h58.3c34.9 0 63.1 28.3 63.1 63.1c0 22.6-12.1 43.5-31.7 54.8L216 328.4c-.2 13-10.9 23.6-24 23.6c-13.3 0-24-10.7-24-24V314.5c0-8.6 4.6-16.5 12.1-20.8l44.3-25.4c4.7-2.7 7.6-7.7 7.6-13.1c0-8.4-6.8-15.1-15.1-15.1H158.6c-3.4 0-6.4 2.1-7.5 5.3l-.4 1.2c-4.4 12.5-18.2 19-30.6 14.6s-19-18.2-14.6-30.6l.4-1.2zM160 416a32 32 0 1 1 64 0 32 32 0 1 1 -64 0z"
    ]
};
var $d8206b3ab2e65c05$export$5dd22dcb6e3ed369 = {
    prefix: "fas",
    iconName: "panorama",
    icon: [
        640,
        512,
        [],
        "e209",
        "M45.6 32C20.4 32 0 52.4 0 77.6V434.4C0 459.6 20.4 480 45.6 480c5.1 0 10-.8 14.7-2.4C74.6 472.8 177.6 440 320 440s245.4 32.8 259.6 37.6c4.7 1.6 9.7 2.4 14.7 2.4c25.2 0 45.6-20.4 45.6-45.6V77.6C640 52.4 619.6 32 594.4 32c-5 0-10 .8-14.7 2.4C565.4 39.2 462.4 72 320 72S74.6 39.2 60.4 34.4C55.6 32.8 50.7 32 45.6 32zM96 160a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm272 0c7.9 0 15.4 3.9 19.8 10.5L512.3 353c5.4 8 5.6 18.4 .4 26.5s-14.7 12.3-24.2 10.7C442.7 382.4 385.2 376 320 376c-65.6 0-123.4 6.5-169.3 14.4c-9.8 1.7-19.7-2.9-24.7-11.5s-4.3-19.4 1.9-27.2L197.3 265c4.6-5.7 11.4-9 18.7-9s14.2 3.3 18.7 9l26.4 33.1 87-127.6c4.5-6.6 11.9-10.5 19.8-10.5z"
    ]
};
var $d8206b3ab2e65c05$export$101422b773924276 = {
    prefix: "fas",
    iconName: "comment-medical",
    icon: [
        512,
        512,
        [],
        "f7f5",
        "M256 448c141.4 0 256-93.1 256-208S397.4 32 256 32S0 125.1 0 240c0 45.1 17.7 86.8 47.7 120.9c-1.9 24.5-11.4 46.3-21.4 62.9c-5.5 9.2-11.1 16.6-15.2 21.6c-2.1 2.5-3.7 4.4-4.9 5.7c-.6 .6-1 1.1-1.3 1.4l-.3 .3 0 0 0 0 0 0 0 0c-4.6 4.6-5.9 11.4-3.4 17.4c2.5 6 8.3 9.9 14.8 9.9c28.7 0 57.6-8.9 81.6-19.3c22.9-10 42.4-21.9 54.3-30.6c31.8 11.5 67 17.9 104.1 17.9zM224 160c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v48h48c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H288v48c0 8.8-7.2 16-16 16H240c-8.8 0-16-7.2-16-16V272H176c-8.8 0-16-7.2-16-16V224c0-8.8 7.2-16 16-16h48V160z"
    ]
};
var $d8206b3ab2e65c05$export$c88ac21fe7c88ae6 = {
    prefix: "fas",
    iconName: "teeth-open",
    icon: [
        576,
        512,
        [],
        "f62f",
        "M96 32C43 32 0 75 0 128v64c0 35.3 28.7 64 64 64H512c35.3 0 64-28.7 64-64V128c0-53-43-96-96-96H96zM224 96c26.5 0 48 21.5 48 48v56c0 13.3-10.7 24-24 24H200c-13.3 0-24-10.7-24-24V144c0-26.5 21.5-48 48-48zm80 48c0-26.5 21.5-48 48-48s48 21.5 48 48v56c0 13.3-10.7 24-24 24H328c-13.3 0-24-10.7-24-24V144zM96 128c26.5 0 48 21.5 48 48v24c0 13.3-10.7 24-24 24H72c-13.3 0-24-10.7-24-24V176c0-26.5 21.5-48 48-48zm336 48c0-26.5 21.5-48 48-48s48 21.5 48 48v24c0 13.3-10.7 24-24 24H456c-13.3 0-24-10.7-24-24V176zM96 480H480c53 0 96-43 96-96V352c0-35.3-28.7-64-64-64H64c-35.3 0-64 28.7-64 64v32c0 53 43 96 96 96zm0-64c-26.5 0-48-21.5-48-48V344c0-13.3 10.7-24 24-24h48c13.3 0 24 10.7 24 24v24c0 26.5-21.5 48-48 48zm80-48V344c0-13.3 10.7-24 24-24h48c13.3 0 24 10.7 24 24v24c0 26.5-21.5 48-48 48s-48-21.5-48-48zm176 48c-26.5 0-48-21.5-48-48V344c0-13.3 10.7-24 24-24h48c13.3 0 24 10.7 24 24v24c0 26.5-21.5 48-48 48zm80-48V344c0-13.3 10.7-24 24-24h48c13.3 0 24 10.7 24 24v24c0 26.5-21.5 48-48 48s-48-21.5-48-48z"
    ]
};
var $d8206b3ab2e65c05$export$4b89fabf50a10951 = {
    prefix: "fas",
    iconName: "file-circle-minus",
    icon: [
        576,
        512,
        [],
        "e4ed",
        "M0 64C0 28.7 28.7 0 64 0H224V128c0 17.7 14.3 32 32 32H384v38.6C310.1 219.5 256 287.4 256 368c0 59.1 29.1 111.3 73.7 143.3c-3.2 .5-6.4 .7-9.7 .7H64c-35.3 0-64-28.7-64-64V64zm384 64H256V0L384 128zM288 368a144 144 0 1 1 288 0 144 144 0 1 1 -288 0zm224 0c0-8.8-7.2-16-16-16H368c-8.8 0-16 7.2-16 16s7.2 16 16 16H496c8.8 0 16-7.2 16-16z"
    ]
};
var $d8206b3ab2e65c05$export$d55778e3ab6c933f = {
    prefix: "fas",
    iconName: "tags",
    icon: [
        512,
        512,
        [],
        "f02c",
        "M345 39.1L472.8 168.4c52.4 53 52.4 138.2 0 191.2L360.8 472.9c-9.3 9.4-24.5 9.5-33.9 .2s-9.5-24.5-.2-33.9L438.6 325.9c33.9-34.3 33.9-89.4 0-123.7L310.9 72.9c-9.3-9.4-9.2-24.6 .2-33.9s24.6-9.2 33.9 .2zM0 229.5V80C0 53.5 21.5 32 48 32H197.5c17 0 33.3 6.7 45.3 18.7l168 168c25 25 25 65.5 0 90.5L277.3 442.7c-25 25-65.5 25-90.5 0l-168-168C6.7 262.7 0 246.5 0 229.5zM144 144a32 32 0 1 0 -64 0 32 32 0 1 0 64 0z"
    ]
};
var $d8206b3ab2e65c05$export$e06d6607d3577d6e = {
    prefix: "fas",
    iconName: "wine-glass",
    icon: [
        320,
        512,
        [
            127863
        ],
        "f4e3",
        "M32.1 29.3C33.5 12.8 47.4 0 64 0H256c16.6 0 30.5 12.8 31.9 29.3l14 168.4c6 72-42.5 135.2-109.9 150.6V448h48c17.7 0 32 14.3 32 32s-14.3 32-32 32H160 80c-17.7 0-32-14.3-32-32s14.3-32 32-32h48V348.4C60.6 333 12.1 269.8 18.1 197.8l14-168.4zm56 98.7H231.9l-5.3-64H93.4l-5.3 64z"
    ]
};
var $d8206b3ab2e65c05$export$dc9cc4280bee320d = {
    prefix: "fas",
    iconName: "forward-fast",
    icon: [
        512,
        512,
        [
            9197,
            "fast-forward"
        ],
        "f050",
        "M18.4 445c11.2 5.3 24.5 3.6 34.1-4.4L224 297.7V416c0 12.4 7.2 23.7 18.4 29s24.5 3.6 34.1-4.4L448 297.7V416c0 17.7 14.3 32 32 32s32-14.3 32-32V96c0-17.7-14.3-32-32-32s-32 14.3-32 32V214.3L276.5 71.4c-9.5-7.9-22.8-9.7-34.1-4.4S224 83.6 224 96V214.3L52.5 71.4c-9.5-7.9-22.8-9.7-34.1-4.4S0 83.6 0 96V416c0 12.4 7.2 23.7 18.4 29z"
    ]
};
var $d8206b3ab2e65c05$export$61a8cdc53c2e078d = $d8206b3ab2e65c05$export$dc9cc4280bee320d;
var $d8206b3ab2e65c05$export$38c072b870a9e4ab = {
    prefix: "fas",
    iconName: "face-meh-blank",
    icon: [
        512,
        512,
        [
            128566,
            "meh-blank"
        ],
        "f5a4",
        "M0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm208.4-48a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zm128 32a32 32 0 1 0 0-64 32 32 0 1 0 0 64z"
    ]
};
var $d8206b3ab2e65c05$export$e945435725f71e88 = $d8206b3ab2e65c05$export$38c072b870a9e4ab;
var $d8206b3ab2e65c05$export$f2cfa036d76f69ab = {
    prefix: "fas",
    iconName: "square-parking",
    icon: [
        448,
        512,
        [
            127359,
            "parking"
        ],
        "f540",
        "M64 32C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64zM192 256h48c17.7 0 32-14.3 32-32s-14.3-32-32-32H192v64zm48 64H192v32c0 17.7-14.3 32-32 32s-32-14.3-32-32V288 168c0-22.1 17.9-40 40-40h72c53 0 96 43 96 96s-43 96-96 96z"
    ]
};
var $d8206b3ab2e65c05$export$fda29c8f99573a4e = $d8206b3ab2e65c05$export$f2cfa036d76f69ab;
var $d8206b3ab2e65c05$export$58845db8e7e9a199 = {
    prefix: "fas",
    iconName: "house-signal",
    icon: [
        576,
        512,
        [],
        "e012",
        "M357.7 8.5c-12.3-11.3-31.2-11.3-43.4 0l-208 192c-9.4 8.6-12.7 22-8.5 34c87.1 25.3 155.6 94.2 180.3 181.6H464c26.5 0 48-21.5 48-48V256h32c13.2 0 25-8.1 29.8-20.3s1.6-26.2-8.1-35.2l-208-192zM288 208c0-8.8 7.2-16 16-16h64c8.8 0 16 7.2 16 16v64c0 8.8-7.2 16-16 16H304c-8.8 0-16-7.2-16-16V208zM24 256c-13.3 0-24 10.7-24 24s10.7 24 24 24c101.6 0 184 82.4 184 184c0 13.3 10.7 24 24 24s24-10.7 24-24c0-128.1-103.9-232-232-232zm8 256a32 32 0 1 0 0-64 32 32 0 1 0 0 64zM0 376c0 13.3 10.7 24 24 24c48.6 0 88 39.4 88 88c0 13.3 10.7 24 24 24s24-10.7 24-24c0-75.1-60.9-136-136-136c-13.3 0-24 10.7-24 24z"
    ]
};
var $d8206b3ab2e65c05$export$ee3a02da18715b2 = {
    prefix: "fas",
    iconName: "bars-progress",
    icon: [
        512,
        512,
        [
            "tasks-alt"
        ],
        "f828",
        "M448 160H320V128H448v32zM48 64C21.5 64 0 85.5 0 112v64c0 26.5 21.5 48 48 48H464c26.5 0 48-21.5 48-48V112c0-26.5-21.5-48-48-48H48zM448 352v32H192V352H448zM48 288c-26.5 0-48 21.5-48 48v64c0 26.5 21.5 48 48 48H464c26.5 0 48-21.5 48-48V336c0-26.5-21.5-48-48-48H48z"
    ]
};
var $d8206b3ab2e65c05$export$bbc0784fc1578f7f = $d8206b3ab2e65c05$export$ee3a02da18715b2;
var $d8206b3ab2e65c05$export$7a255960242435f6 = {
    prefix: "fas",
    iconName: "faucet-drip",
    icon: [
        512,
        512,
        [
            128688
        ],
        "e006",
        "M224 0c17.7 0 32 14.3 32 32V44l96-12c17.7 0 32 14.3 32 32s-14.3 32-32 32L256 84l-31-3.9-1-.1-1 .1L192 84 96 96C78.3 96 64 81.7 64 64s14.3-32 32-32l96 12V32c0-17.7 14.3-32 32-32zM0 224c0-17.7 14.3-32 32-32h96l22.6-22.6c6-6 14.1-9.4 22.6-9.4H192V116.2l32-4 32 4V160h18.7c8.5 0 16.6 3.4 22.6 9.4L320 192h32c88.4 0 160 71.6 160 160c0 17.7-14.3 32-32 32H416c-17.7 0-32-14.3-32-32s-14.3-32-32-32H315.9c-20.2 29-53.9 48-91.9 48s-71.7-19-91.9-48H32c-17.7 0-32-14.3-32-32V224zM436.8 423.4c1.9-4.5 6.3-7.4 11.2-7.4s9.2 2.9 11.2 7.4l18.2 42.4c1.8 4.1 2.7 8.6 2.7 13.1V480c0 17.7-14.3 32-32 32s-32-14.3-32-32v-1.2c0-4.5 .9-8.9 2.7-13.1l18.2-42.4z"
    ]
};
var $d8206b3ab2e65c05$export$df587aaf7765e1ce = {
    prefix: "fas",
    iconName: "cart-flatbed",
    icon: [
        640,
        512,
        [
            "dolly-flatbed"
        ],
        "f474",
        "M32 0C14.3 0 0 14.3 0 32S14.3 64 32 64H48c8.8 0 16 7.2 16 16V368c0 44.2 35.8 80 80 80h18.7c-1.8 5-2.7 10.4-2.7 16c0 26.5 21.5 48 48 48s48-21.5 48-48c0-5.6-1-11-2.7-16H450.7c-1.8 5-2.7 10.4-2.7 16c0 26.5 21.5 48 48 48s48-21.5 48-48c0-5.6-1-11-2.7-16H608c17.7 0 32-14.3 32-32s-14.3-32-32-32H144c-8.8 0-16-7.2-16-16V80C128 35.8 92.2 0 48 0H32zM192 80V272c0 26.5 21.5 48 48 48H560c26.5 0 48-21.5 48-48V80c0-26.5-21.5-48-48-48H464V176c0 5.9-3.2 11.3-8.5 14.1s-11.5 2.5-16.4-.8L400 163.2l-39.1 26.1c-4.9 3.3-11.2 3.6-16.4 .8s-8.5-8.2-8.5-14.1V32H240c-26.5 0-48 21.5-48 48z"
    ]
};
var $d8206b3ab2e65c05$export$f7c6efb60c53b285 = $d8206b3ab2e65c05$export$df587aaf7765e1ce;
var $d8206b3ab2e65c05$export$130df7ed74437774 = {
    prefix: "fas",
    iconName: "ban-smoking",
    icon: [
        512,
        512,
        [
            128685,
            "smoking-ban"
        ],
        "f54d",
        "M99.5 144.8L178.7 224l96 96 92.5 92.5C335.9 434.9 297.5 448 256 448C150 448 64 362 64 256c0-41.5 13.1-79.9 35.5-111.2zM333.3 288l-32-32H384v32H333.3zm32 32H400c8.8 0 16-7.2 16-16V240c0-8.8-7.2-16-16-16H269.3L144.8 99.5C176.1 77.1 214.5 64 256 64c106 0 192 86 192 192c0 41.5-13.1 79.9-35.5 111.2L365.3 320zM256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM272 96c-8.8 0-16 7.2-16 16c0 26.5 21.5 48 48 48h32c8.8 0 16 7.2 16 16s7.2 16 16 16s16-7.2 16-16c0-26.5-21.5-48-48-48H304c-8.8 0-16-7.2-16-16s-7.2-16-16-16zM229.5 320l-96-96H112c-8.8 0-16 7.2-16 16v64c0 8.8 7.2 16 16 16H229.5z"
    ]
};
var $d8206b3ab2e65c05$export$e50452a49dec29f = $d8206b3ab2e65c05$export$130df7ed74437774;
var $d8206b3ab2e65c05$export$5e63e8b85b5f119c = {
    prefix: "fas",
    iconName: "terminal",
    icon: [
        576,
        512,
        [],
        "f120",
        "M9.4 86.6C-3.1 74.1-3.1 53.9 9.4 41.4s32.8-12.5 45.3 0l192 192c12.5 12.5 12.5 32.8 0 45.3l-192 192c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3L178.7 256 9.4 86.6zM256 416H544c17.7 0 32 14.3 32 32s-14.3 32-32 32H256c-17.7 0-32-14.3-32-32s14.3-32 32-32z"
    ]
};
var $d8206b3ab2e65c05$export$c93d62849efbdd11 = {
    prefix: "fas",
    iconName: "mobile-button",
    icon: [
        384,
        512,
        [],
        "f10b",
        "M80 0C44.7 0 16 28.7 16 64V448c0 35.3 28.7 64 64 64H304c35.3 0 64-28.7 64-64V64c0-35.3-28.7-64-64-64H80zM192 400a32 32 0 1 1 0 64 32 32 0 1 1 0-64z"
    ]
};
var $d8206b3ab2e65c05$export$86c50f517be57a40 = {
    prefix: "fas",
    iconName: "house-medical-flag",
    icon: [
        640,
        512,
        [],
        "e514",
        "M480 0c17.7 0 32 14.3 32 32H624c8.8 0 16 7.2 16 16V176c0 8.8-7.2 16-16 16H512V512H448V192 32c0-17.7 14.3-32 32-32zM276.8 39.7L416 159V512h1l-.2 0H96c-17.7 0-32-14.3-32-32V288H32c-13.4 0-25.4-8.3-30-20.9s-1-26.7 9.2-35.4l224-192c12-10.3 29.7-10.3 41.7 0zM224 208v48H176c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h48v48c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V320h48c8.8 0 16-7.2 16-16V272c0-8.8-7.2-16-16-16H288V208c0-8.8-7.2-16-16-16H240c-8.8 0-16 7.2-16 16z"
    ]
};
var $d8206b3ab2e65c05$export$1d307c13b511e8e1 = {
    prefix: "fas",
    iconName: "basket-shopping",
    icon: [
        576,
        512,
        [
            "shopping-basket"
        ],
        "f291",
        "M253.3 35.1c6.1-11.8 1.5-26.3-10.2-32.4s-26.3-1.5-32.4 10.2L117.6 192H32c-17.7 0-32 14.3-32 32s14.3 32 32 32L83.9 463.5C91 492 116.6 512 146 512H430c29.4 0 55-20 62.1-48.5L544 256c17.7 0 32-14.3 32-32s-14.3-32-32-32H458.4L365.3 12.9C359.2 1.2 344.7-3.4 332.9 2.7s-16.3 20.6-10.2 32.4L404.3 192H171.7L253.3 35.1zM192 304v96c0 8.8-7.2 16-16 16s-16-7.2-16-16V304c0-8.8 7.2-16 16-16s16 7.2 16 16zm96-16c8.8 0 16 7.2 16 16v96c0 8.8-7.2 16-16 16s-16-7.2-16-16V304c0-8.8 7.2-16 16-16zm128 16v96c0 8.8-7.2 16-16 16s-16-7.2-16-16V304c0-8.8 7.2-16 16-16s16 7.2 16 16z"
    ]
};
var $d8206b3ab2e65c05$export$ca6d443595a6578f = $d8206b3ab2e65c05$export$1d307c13b511e8e1;
var $d8206b3ab2e65c05$export$b88ed5e1e0eac4c6 = {
    prefix: "fas",
    iconName: "tape",
    icon: [
        576,
        512,
        [],
        "f4db",
        "M380.8 416c41.5-40.7 67.2-97.3 67.2-160C448 132.3 347.7 32 224 32S0 132.3 0 256S100.3 480 224 480H544c17.7 0 32-14.3 32-32s-14.3-32-32-32H380.8zM224 160a96 96 0 1 1 0 192 96 96 0 1 1 0-192zm64 96a64 64 0 1 0 -128 0 64 64 0 1 0 128 0z"
    ]
};
var $d8206b3ab2e65c05$export$d3724faf0c559353 = {
    prefix: "fas",
    iconName: "bus-simple",
    icon: [
        448,
        512,
        [
            "bus-alt"
        ],
        "f55e",
        "M224 0C348.8 0 448 35.2 448 80V96 416c0 17.7-14.3 32-32 32v32c0 17.7-14.3 32-32 32H352c-17.7 0-32-14.3-32-32V448H128v32c0 17.7-14.3 32-32 32H64c-17.7 0-32-14.3-32-32l0-32c-17.7 0-32-14.3-32-32V96 80C0 35.2 99.2 0 224 0zM64 128V256c0 17.7 14.3 32 32 32H352c17.7 0 32-14.3 32-32V128c0-17.7-14.3-32-32-32H96c-17.7 0-32 14.3-32 32zM80 400a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm288 0a32 32 0 1 0 0-64 32 32 0 1 0 0 64z"
    ]
};
var $d8206b3ab2e65c05$export$40616edfab6d332a = $d8206b3ab2e65c05$export$d3724faf0c559353;
var $d8206b3ab2e65c05$export$b8c3e79e8c99c95b = {
    prefix: "fas",
    iconName: "eye",
    icon: [
        576,
        512,
        [
            128065
        ],
        "f06e",
        "M288 32c-80.8 0-145.5 36.8-192.6 80.6C48.6 156 17.3 208 2.5 243.7c-3.3 7.9-3.3 16.7 0 24.6C17.3 304 48.6 356 95.4 399.4C142.5 443.2 207.2 480 288 480s145.5-36.8 192.6-80.6c46.8-43.5 78.1-95.4 93-131.1c3.3-7.9 3.3-16.7 0-24.6c-14.9-35.7-46.2-87.7-93-131.1C433.5 68.8 368.8 32 288 32zM144 256a144 144 0 1 1 288 0 144 144 0 1 1 -288 0zm144-64c0 35.3-28.7 64-64 64c-7.1 0-13.9-1.2-20.3-3.3c-5.5-1.8-11.9 1.6-11.7 7.4c.3 6.9 1.3 13.8 3.2 20.7c13.7 51.2 66.4 81.6 117.6 67.9s81.6-66.4 67.9-117.6c-11.1-41.5-47.8-69.4-88.6-71.1c-5.8-.2-9.2 6.1-7.4 11.7c2.1 6.4 3.3 13.2 3.3 20.3z"
    ]
};
var $d8206b3ab2e65c05$export$e8ea88c55e55be7c = {
    prefix: "fas",
    iconName: "face-sad-cry",
    icon: [
        512,
        512,
        [
            128557,
            "sad-cry"
        ],
        "f5b3",
        "M352 493.4c-29.6 12-62.1 18.6-96 18.6s-66.4-6.6-96-18.6V288c0-8.8-7.2-16-16-16s-16 7.2-16 16V477.8C51.5 433.5 0 350.8 0 256C0 114.6 114.6 0 256 0S512 114.6 512 256c0 94.8-51.5 177.5-128 221.8V288c0-8.8-7.2-16-16-16s-16 7.2-16 16V493.4zM195.2 233.6c5.3 7.1 15.3 8.5 22.4 3.2s8.5-15.3 3.2-22.4c-30.4-40.5-91.2-40.5-121.6 0c-5.3 7.1-3.9 17.1 3.2 22.4s17.1 3.9 22.4-3.2c17.6-23.5 52.8-23.5 70.4 0zm121.6 0c17.6-23.5 52.8-23.5 70.4 0c5.3 7.1 15.3 8.5 22.4 3.2s8.5-15.3 3.2-22.4c-30.4-40.5-91.2-40.5-121.6 0c-5.3 7.1-3.9 17.1 3.2 22.4s17.1 3.9 22.4-3.2zM208 336v32c0 26.5 21.5 48 48 48s48-21.5 48-48V336c0-26.5-21.5-48-48-48s-48 21.5-48 48z"
    ]
};
var $d8206b3ab2e65c05$export$8e924e6bd422cef9 = $d8206b3ab2e65c05$export$e8ea88c55e55be7c;
var $d8206b3ab2e65c05$export$b6b464c98c009494 = {
    prefix: "fas",
    iconName: "audio-description",
    icon: [
        576,
        512,
        [],
        "f29e",
        "M64 32C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H512c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64zM213.5 173.3l72 144c5.9 11.9 1.1 26.3-10.7 32.2s-26.3 1.1-32.2-10.7l-9.4-18.9H150.9l-9.4 18.9c-5.9 11.9-20.3 16.7-32.2 10.7s-16.7-20.3-10.7-32.2l72-144c4.1-8.1 12.4-13.3 21.5-13.3s17.4 5.1 21.5 13.3zm-.4 106.6L192 237.7l-21.1 42.2h42.2zM304 184c0-13.3 10.7-24 24-24h56c53 0 96 43 96 96s-43 96-96 96H328c-13.3 0-24-10.7-24-24V184zm48 24v96h32c26.5 0 48-21.5 48-48s-21.5-48-48-48H352z"
    ]
};
var $d8206b3ab2e65c05$export$41b1e14a6b0fe11b = {
    prefix: "fas",
    iconName: "person-military-to-person",
    icon: [
        512,
        512,
        [],
        "e54c",
        "M71 12.5c-8.6 1-15 8.2-15 16.8c0 9.3 7.5 16.8 16.7 16.9H184.1c8.8-.1 15.9-7.2 15.9-16V16c0-9.5-8.3-17-17.8-15.9L71 12.5zM189.5 78.1H66.5C64.9 83.8 64 89.8 64 96c0 35.3 28.7 64 64 64s64-28.7 64-64c0-6.2-.9-12.2-2.5-17.9zM32 256v32c0 17.7 14.3 32 32 32H192c1.8 0 3.5-.1 5.2-.4L53 208.6C40.1 220.3 32 237.2 32 256zm190.2 42.5c1.1-3.3 1.8-6.8 1.8-10.5V256c0-35.3-28.7-64-64-64H96c-3.7 0-7.4 .3-10.9 .9L222.2 298.5zM384 160a64 64 0 1 0 0-128 64 64 0 1 0 0 128zm-32 32c-35.3 0-64 28.7-64 64v32c0 17.7 14.3 32 32 32H448c17.7 0 32-14.3 32-32V256c0-35.3-28.7-64-64-64H352zM215.8 450.1c5.2-4.6 8.2-11.1 8.2-18.1s-3-13.5-8.2-18.1l-64-56c-7.1-6.2-17.1-7.7-25.7-3.8S112 366.6 112 376v32l-88 0c-13.3 0-24 10.7-24 24s10.7 24 24 24l88 0v32c0 9.4 5.5 18 14.1 21.9s18.6 2.4 25.7-3.8l64-56zM288 431.9c0 6.9 2.9 13.5 8.1 18.1l64 56.4c7.1 6.2 17.1 7.8 25.7 3.9s14.1-12.4 14.1-21.9l0-32.4 88 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-88 0 0-32c0-9.4-5.5-18-14.1-21.9s-18.6-2.4-25.7 3.8l-64 56c-5.2 4.5-8.2 11.1-8.2 18z"
    ]
};
var $d8206b3ab2e65c05$export$348a01df65a66c99 = {
    prefix: "fas",
    iconName: "file-shield",
    icon: [
        576,
        512,
        [],
        "e4f0",
        "M0 64C0 28.7 28.7 0 64 0H224V128c0 17.7 14.3 32 32 32H384v47l-92.8 37.1c-21.3 8.5-35.2 29.1-35.2 52c0 56.6 18.9 148 94.2 208.3c-9 4.8-19.3 7.6-30.2 7.6H64c-35.3 0-64-28.7-64-64V64zm384 64H256V0L384 128zm39.1 97.7c5.7-2.3 12.1-2.3 17.8 0l120 48C570 277.4 576 286.2 576 296c0 63.3-25.9 168.8-134.8 214.2c-5.9 2.5-12.6 2.5-18.5 0C313.9 464.8 288 359.3 288 296c0-9.8 6-18.6 15.1-22.3l120-48zM527.4 312L432 273.8V461.7c68.2-33 91.5-99 95.4-149.7z"
    ]
};
var $d8206b3ab2e65c05$export$3924ab4d3ef9b5ef = {
    prefix: "fas",
    iconName: "user-slash",
    icon: [
        640,
        512,
        [],
        "f506",
        "M38.8 5.1C28.4-3.1 13.3-1.2 5.1 9.2S-1.2 34.7 9.2 42.9l592 464c10.4 8.2 25.5 6.3 33.7-4.1s6.3-25.5-4.1-33.7L353.3 251.6C407.9 237 448 187.2 448 128C448 57.3 390.7 0 320 0C250.2 0 193.5 55.8 192 125.2L38.8 5.1zM264.3 304.3C170.5 309.4 96 387.2 96 482.3c0 16.4 13.3 29.7 29.7 29.7H514.3c3.9 0 7.6-.7 11-2.1l-261-205.6z"
    ]
};
var $d8206b3ab2e65c05$export$8f4567331fb0d3bc = {
    prefix: "fas",
    iconName: "pen",
    icon: [
        512,
        512,
        [
            128394
        ],
        "f304",
        "M362.7 19.3L314.3 67.7 444.3 197.7l48.4-48.4c25-25 25-65.5 0-90.5L453.3 19.3c-25-25-65.5-25-90.5 0zm-71 71L58.6 323.5c-10.4 10.4-18 23.3-22.2 37.4L1 481.2C-1.5 489.7 .8 498.8 7 505s15.3 8.5 23.7 6.1l120.3-35.4c14.1-4.2 27-11.8 37.4-22.2L421.7 220.3 291.7 90.3z"
    ]
};
var $d8206b3ab2e65c05$export$5b2f0f631f559d51 = {
    prefix: "fas",
    iconName: "tower-observation",
    icon: [
        512,
        512,
        [],
        "e586",
        "M241.7 3.4c9-4.5 19.6-4.5 28.6 0l160 80c15.8 7.9 22.2 27.1 14.3 42.9C439 137.5 427.7 144 416 144v80c0 17.7-14.3 32-32 32h-4.9l32 192H480c17.7 0 32 14.3 32 32s-14.3 32-32 32H384.5c-.4 0-.8 0-1.1 0H128.6c-.4 0-.8 0-1.1 0H32c-17.7 0-32-14.3-32-32s14.3-32 32-32h68.9l32-192H128c-17.7 0-32-14.3-32-32V144c-11.7 0-23-6.5-28.6-17.7c-7.9-15.8-1.5-35 14.3-42.9l160-80zM314.5 448L256 399.2 197.5 448h117zM197.8 256l-4.7 28.3L256 336.8l62.9-52.5L314.2 256H197.8zm-13.9 83.2l-11.2 67L218.5 368l-34.6-28.8zM293.5 368l45.8 38.1-11.2-67L293.5 368zM176 128c-8.8 0-16 7.2-16 16s7.2 16 16 16H336c8.8 0 16-7.2 16-16s-7.2-16-16-16H176z"
    ]
};
var $d8206b3ab2e65c05$export$143d0ca7d2200f20 = {
    prefix: "fas",
    iconName: "file-code",
    icon: [
        384,
        512,
        [],
        "f1c9",
        "M64 0C28.7 0 0 28.7 0 64V448c0 35.3 28.7 64 64 64H320c35.3 0 64-28.7 64-64V160H256c-17.7 0-32-14.3-32-32V0H64zM256 0V128H384L256 0zM153 289l-31 31 31 31c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0L71 337c-9.4-9.4-9.4-24.6 0-33.9l48-48c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9zM265 255l48 48c9.4 9.4 9.4 24.6 0 33.9l-48 48c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l31-31-31-31c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0z"
    ]
};
var $d8206b3ab2e65c05$export$79046b073b6c584d = {
    prefix: "fas",
    iconName: "signal",
    icon: [
        640,
        512,
        [
            128246,
            "signal-5",
            "signal-perfect"
        ],
        "f012",
        "M576 0c17.7 0 32 14.3 32 32V480c0 17.7-14.3 32-32 32s-32-14.3-32-32V32c0-17.7 14.3-32 32-32zM448 96c17.7 0 32 14.3 32 32V480c0 17.7-14.3 32-32 32s-32-14.3-32-32V128c0-17.7 14.3-32 32-32zM352 224V480c0 17.7-14.3 32-32 32s-32-14.3-32-32V224c0-17.7 14.3-32 32-32s32 14.3 32 32zM192 288c17.7 0 32 14.3 32 32V480c0 17.7-14.3 32-32 32s-32-14.3-32-32V320c0-17.7 14.3-32 32-32zM96 416v64c0 17.7-14.3 32-32 32s-32-14.3-32-32V416c0-17.7 14.3-32 32-32s32 14.3 32 32z"
    ]
};
var $d8206b3ab2e65c05$export$3417071118065933 = $d8206b3ab2e65c05$export$79046b073b6c584d;
var $d8206b3ab2e65c05$export$1aea50ab3e99cc95 = $d8206b3ab2e65c05$export$79046b073b6c584d;
var $d8206b3ab2e65c05$export$ce69441578ff2fdb = {
    prefix: "fas",
    iconName: "bus",
    icon: [
        576,
        512,
        [
            128653
        ],
        "f207",
        "M288 0C422.4 0 512 35.2 512 80V96l0 32c17.7 0 32 14.3 32 32v64c0 17.7-14.3 32-32 32l0 160c0 17.7-14.3 32-32 32v32c0 17.7-14.3 32-32 32H416c-17.7 0-32-14.3-32-32V448H192v32c0 17.7-14.3 32-32 32H128c-17.7 0-32-14.3-32-32l0-32c-17.7 0-32-14.3-32-32l0-160c-17.7 0-32-14.3-32-32V160c0-17.7 14.3-32 32-32h0V96h0V80C64 35.2 153.6 0 288 0zM128 160v96c0 17.7 14.3 32 32 32H272V128H160c-17.7 0-32 14.3-32 32zM304 288H416c17.7 0 32-14.3 32-32V160c0-17.7-14.3-32-32-32H304V288zM144 400a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm288 0a32 32 0 1 0 0-64 32 32 0 1 0 0 64zM384 80c0-8.8-7.2-16-16-16H208c-8.8 0-16 7.2-16 16s7.2 16 16 16H368c8.8 0 16-7.2 16-16z"
    ]
};
var $d8206b3ab2e65c05$export$742f89ae2f8d6b20 = {
    prefix: "fas",
    iconName: "heart-circle-xmark",
    icon: [
        576,
        512,
        [],
        "e501",
        "M47.6 300.4L228.3 469.1c7.5 7 17.4 10.9 27.7 10.9s20.2-3.9 27.7-10.9l2.6-2.4C267.2 438.6 256 404.6 256 368c0-97.2 78.8-176 176-176c28.3 0 55 6.7 78.7 18.5c.9-6.5 1.3-13 1.3-19.6v-5.8c0-69.9-50.5-129.5-119.4-141C347 36.5 300.6 51.4 268 84L256 96 244 84c-32.6-32.6-79-47.5-124.6-39.9C50.5 55.6 0 115.2 0 185.1v5.8c0 41.5 17.2 81.2 47.6 109.5zM432 512a144 144 0 1 0 0-288 144 144 0 1 0 0 288zm59.3-180.7L454.6 368l36.7 36.7c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0L432 390.6l-36.7 36.7c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6L409.4 368l-36.7-36.7c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0L432 345.4l36.7-36.7c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6z"
    ]
};
var $d8206b3ab2e65c05$export$af554427144a7e5c = {
    prefix: "fas",
    iconName: "house-chimney",
    icon: [
        576,
        512,
        [
            63499,
            "home-lg"
        ],
        "e3af",
        "M543.8 287.6c17 0 32-14 32-32.1c1-9-3-17-11-24L512 185V64c0-17.7-14.3-32-32-32H448c-17.7 0-32 14.3-32 32v36.7L309.5 7c-6-5-14-7-21-7s-15 1-22 8L10 231.5c-7 7-10 15-10 24c0 18 14 32.1 32 32.1h32v69.7c-.1 .9-.1 1.8-.1 2.8V472c0 22.1 17.9 40 40 40h16c1.2 0 2.4-.1 3.6-.2c1.5 .1 3 .2 4.5 .2H160h24c22.1 0 40-17.9 40-40V448 384c0-17.7 14.3-32 32-32h64c17.7 0 32 14.3 32 32v64 24c0 22.1 17.9 40 40 40h24 32.5c1.4 0 2.8 0 4.2-.1c1.1 .1 2.2 .1 3.3 .1h16c22.1 0 40-17.9 40-40V455.8c.3-2.6 .5-5.3 .5-8.1l-.7-160.2h32z"
    ]
};
var $d8206b3ab2e65c05$export$dbab81727ec94698 = $d8206b3ab2e65c05$export$af554427144a7e5c;
var $d8206b3ab2e65c05$export$703cd98be31ec905 = {
    prefix: "fas",
    iconName: "window-maximize",
    icon: [
        512,
        512,
        [
            128470
        ],
        "f2d0",
        "M64 32C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H448c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64zM96 96H416c17.7 0 32 14.3 32 32s-14.3 32-32 32H96c-17.7 0-32-14.3-32-32s14.3-32 32-32z"
    ]
};
var $d8206b3ab2e65c05$export$e5f78e87efbb0248 = {
    prefix: "fas",
    iconName: "face-frown",
    icon: [
        512,
        512,
        [
            9785,
            "frown"
        ],
        "f119",
        "M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM159.3 388.7c-2.6 8.4-11.6 13.2-20 10.5s-13.2-11.6-10.5-20C145.2 326.1 196.3 288 256 288s110.8 38.1 127.3 91.3c2.6 8.4-2.1 17.4-10.5 20s-17.4-2.1-20-10.5C340.5 349.4 302.1 320 256 320s-84.5 29.4-96.7 68.7zM144.4 208a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm192-32a32 32 0 1 1 0 64 32 32 0 1 1 0-64z"
    ]
};
var $d8206b3ab2e65c05$export$43b7108508aecc5f = $d8206b3ab2e65c05$export$e5f78e87efbb0248;
var $d8206b3ab2e65c05$export$8767bafb19515ee4 = {
    prefix: "fas",
    iconName: "prescription",
    icon: [
        448,
        512,
        [],
        "f5b1",
        "M32 0C14.3 0 0 14.3 0 32V192v96c0 17.7 14.3 32 32 32s32-14.3 32-32V224h50.7l128 128L137.4 457.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0L288 397.3 393.4 502.6c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L333.3 352 438.6 246.6c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L288 306.7l-85.8-85.8C251.4 209.1 288 164.8 288 112C288 50.1 237.9 0 176 0H32zM176 160H64V64H176c26.5 0 48 21.5 48 48s-21.5 48-48 48z"
    ]
};
var $d8206b3ab2e65c05$export$78edc9b98453b6f7 = {
    prefix: "fas",
    iconName: "shop",
    icon: [
        640,
        512,
        [
            "store-alt"
        ],
        "f54f",
        "M36.8 192H603.2c20.3 0 36.8-16.5 36.8-36.8c0-7.3-2.2-14.4-6.2-20.4L558.2 21.4C549.3 8 534.4 0 518.3 0H121.7c-16 0-31 8-39.9 21.4L6.2 134.7c-4 6.1-6.2 13.2-6.2 20.4C0 175.5 16.5 192 36.8 192zM64 224V384v80c0 26.5 21.5 48 48 48H336c26.5 0 48-21.5 48-48V384 224H320V384H128V224H64zm448 0V480c0 17.7 14.3 32 32 32s32-14.3 32-32V224H512z"
    ]
};
var $d8206b3ab2e65c05$export$1f1871dab9cec9d8 = $d8206b3ab2e65c05$export$78edc9b98453b6f7;
var $d8206b3ab2e65c05$export$f62f2879ccaea13f = {
    prefix: "fas",
    iconName: "floppy-disk",
    icon: [
        448,
        512,
        [
            128190,
            128426,
            "save"
        ],
        "f0c7",
        "M64 32C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V173.3c0-17-6.7-33.3-18.7-45.3L352 50.7C340 38.7 323.7 32 306.7 32H64zm0 96c0-17.7 14.3-32 32-32H288c17.7 0 32 14.3 32 32v64c0 17.7-14.3 32-32 32H96c-17.7 0-32-14.3-32-32V128zM224 288a64 64 0 1 1 0 128 64 64 0 1 1 0-128z"
    ]
};
var $d8206b3ab2e65c05$export$1aaa83ff70706e1e = $d8206b3ab2e65c05$export$f62f2879ccaea13f;
var $d8206b3ab2e65c05$export$ee4b92e89fe0dfaf = {
    prefix: "fas",
    iconName: "vihara",
    icon: [
        640,
        512,
        [],
        "f6a7",
        "M281 22L305.8 4.7c1.3-.9 2.7-1.8 4.1-2.4C313.1 .7 316.6 0 320 0s6.9 .7 10.1 2.2c1.4 .7 2.8 1.5 4.1 2.4L359 22C393 45.8 430.8 63.5 470.8 74.4l23 6.3c1.8 .5 3.6 1.1 5.2 2c3.2 1.7 5.9 4 8.1 6.8c3.8 4.9 5.6 11.3 4.7 17.8c-.4 2.8-1.2 5.4-2.5 7.8c-1.7 3.2-4 5.9-6.8 8.1c-4.3 3.2-9.6 5.1-15.1 4.9H480v56.1l6.4 5.1 5.2 4.1c21.1 16.7 45 29.6 70.5 38.1l28.9 9.6c1.6 .5 3.2 1.2 4.6 2c3.1 1.7 5.8 4.1 7.8 6.9s3.5 6.1 4.1 9.6c.5 2.7 .6 5.5 .1 8.3s-1.4 5.4-2.7 7.8c-1.7 3.1-4.1 5.8-6.9 7.8s-6.1 3.5-9.6 4.1c-1.6 .3-3.3 .4-5 .4H544v65.9c20.5 22.8 47.4 39.2 77.4 46.7C632 403 640 412.6 640 424c0 13.3-10.7 24-24 24H576v32c0 17.7-14.3 32-32 32s-32-14.3-32-32V448H352v32c0 17.7-14.3 32-32 32s-32-14.3-32-32V448H128v32c0 17.7-14.3 32-32 32s-32-14.3-32-32V448H24c-13.3 0-24-10.7-24-24c0-11.4 8-21 18.6-23.4c30-7.6 56.9-23.9 77.4-46.7V288H56.6c-1.7 0-3.4-.1-5-.4c-3.5-.7-6.8-2.1-9.6-4.1s-5.2-4.7-7-7.8c-1.3-2.4-2.3-5-2.7-7.8s-.4-5.6 .1-8.3c.7-3.5 2.1-6.8 4.1-9.6s4.7-5.2 7.8-6.9c1.4-.8 3-1.5 4.6-2l28.9-9.6c25.5-8.5 49.4-21.4 70.5-38.1l5.2-4.1 6.4-5.1V176 128h-7.5c-5.5 .1-10.8-1.7-15.1-4.9c-2.8-2.1-5.1-4.8-6.8-8.1c-1.2-2.4-2.1-5-2.5-7.8c-.9-6.5 .9-12.8 4.7-17.8c2.1-2.8 4.8-5.1 8.1-6.8c1.6-.8 3.4-1.5 5.2-2l23-6.3C209.2 63.5 247 45.8 281 22zM416 128H320 224v64h72 48 72V128zM160 288v64H296h24 24H480V288H344 320h0H296 160z"
    ]
};
var $d8206b3ab2e65c05$export$4d10bcc8d068f454 = {
    prefix: "fas",
    iconName: "scale-unbalanced",
    icon: [
        640,
        512,
        [
            "balance-scale-left"
        ],
        "f515",
        "M522.1 62.4c16.8-5.6 25.8-23.7 20.2-40.5S518.6-3.9 501.9 1.6l-113 37.7C375 15.8 349.3 0 320 0c-44.2 0-80 35.8-80 80c0 3 .2 5.9 .5 8.8L117.9 129.6c-16.8 5.6-25.8 23.7-20.2 40.5s23.7 25.8 40.5 20.2l135.5-45.2c4.5 3.2 9.3 5.9 14.4 8.2V480c0 17.7 14.3 32 32 32H512c17.7 0 32-14.3 32-32s-14.3-32-32-32H352V153.3c21-9.2 37.2-27 44.2-49l125.9-42zM439.6 288L512 163.8 584.4 288H439.6zM512 384c62.9 0 115.2-34 126-78.9c2.6-11-1-22.3-6.7-32.1L536.1 109.8c-5-8.6-14.2-13.8-24.1-13.8s-19.1 5.3-24.1 13.8L392.7 273.1c-5.7 9.8-9.3 21.1-6.7 32.1C396.8 350 449.1 384 512 384zM129.2 291.8L201.6 416H56.7l72.4-124.2zM3.2 433.1C14 478 66.3 512 129.2 512s115.2-34 126-78.9c2.6-11-1-22.3-6.7-32.1L153.2 237.8c-5-8.6-14.2-13.8-24.1-13.8s-19.1 5.3-24.1 13.8L9.9 401.1c-5.7 9.8-9.3 21.1-6.7 32.1z"
    ]
};
var $d8206b3ab2e65c05$export$786cb0c775487f19 = $d8206b3ab2e65c05$export$4d10bcc8d068f454;
var $d8206b3ab2e65c05$export$f9dd5b1410e95035 = {
    prefix: "fas",
    iconName: "sort-up",
    icon: [
        320,
        512,
        [
            "sort-asc"
        ],
        "f0de",
        "M182.6 41.4c-12.5-12.5-32.8-12.5-45.3 0l-128 128c-9.2 9.2-11.9 22.9-6.9 34.9s16.6 19.8 29.6 19.8H288c12.9 0 24.6-7.8 29.6-19.8s2.2-25.7-6.9-34.9l-128-128z"
    ]
};
var $d8206b3ab2e65c05$export$e4c8c924b1cc43a7 = $d8206b3ab2e65c05$export$f9dd5b1410e95035;
var $d8206b3ab2e65c05$export$63ffcb3d4e94cb92 = {
    prefix: "fas",
    iconName: "comment-dots",
    icon: [
        512,
        512,
        [
            128172,
            62075,
            "commenting"
        ],
        "f4ad",
        "M256 448c141.4 0 256-93.1 256-208S397.4 32 256 32S0 125.1 0 240c0 45.1 17.7 86.8 47.7 120.9c-1.9 24.5-11.4 46.3-21.4 62.9c-5.5 9.2-11.1 16.6-15.2 21.6c-2.1 2.5-3.7 4.4-4.9 5.7c-.6 .6-1 1.1-1.3 1.4l-.3 .3 0 0 0 0 0 0 0 0c-4.6 4.6-5.9 11.4-3.4 17.4c2.5 6 8.3 9.9 14.8 9.9c28.7 0 57.6-8.9 81.6-19.3c22.9-10 42.4-21.9 54.3-30.6c31.8 11.5 67 17.9 104.1 17.9zM128 208a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm128 0a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm96 32a32 32 0 1 1 64 0 32 32 0 1 1 -64 0z"
    ]
};
var $d8206b3ab2e65c05$export$49ee382a2425e89c = $d8206b3ab2e65c05$export$63ffcb3d4e94cb92;
var $d8206b3ab2e65c05$export$77a38850ff8b0407 = {
    prefix: "fas",
    iconName: "plant-wilt",
    icon: [
        512,
        512,
        [],
        "e5aa",
        "M288 120c0-30.9 25.1-56 56-56s56 25.1 56 56v13c-29.3 10-48 34.5-48 70.1c0 27.9 25.3 74.8 66 111.6c3.8 3.5 8.9 5.3 14 5.3s10.2-1.8 14-5.3c40.7-36.8 66-83.7 66-111.6c0-35.6-18.7-60.2-48-70.1V120C464 53.7 410.3 0 344 0S224 53.7 224 120v21.8C207.3 133 188.2 128 168 128c-66.3 0-120 53.7-120 120v13c-29.3 10-48 34.5-48 70.1C0 359 25.3 405.9 66 442.7c3.8 3.5 8.9 5.3 14 5.3s10.2-1.8 14-5.3c40.7-36.8 66-83.7 66-111.6c0-35.6-18.7-60.2-48-70.1V248c0-30.9 25.1-56 56-56s56 25.1 56 56v32V480c0 17.7 14.3 32 32 32s32-14.3 32-32V280 248 120z"
    ]
};
var $d8206b3ab2e65c05$export$f214f827e0023247 = {
    prefix: "fas",
    iconName: "diamond",
    icon: [
        512,
        512,
        [
            9830
        ],
        "f219",
        "M284.3 11.7c-15.6-15.6-40.9-15.6-56.6 0l-216 216c-15.6 15.6-15.6 40.9 0 56.6l216 216c15.6 15.6 40.9 15.6 56.6 0l216-216c15.6-15.6 15.6-40.9 0-56.6l-216-216z"
    ]
};
var $d8206b3ab2e65c05$export$5d53da7627754bc6 = {
    prefix: "fas",
    iconName: "face-grin-squint",
    icon: [
        512,
        512,
        [
            128518,
            "grin-squint"
        ],
        "f585",
        "M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM388.1 312.8c12.3-3.8 24.3 6.9 19.3 18.7C382.4 390.6 324.2 432 256.3 432s-126.2-41.4-151.1-100.5c-5-11.8 7-22.5 19.3-18.7c39.7 12.2 84.5 19 131.8 19s92.1-6.8 131.8-19zM133.5 146.7l89.9 47.9c10.7 5.7 10.7 21.1 0 26.8l-89.9 47.9c-7.9 4.2-17.5-1.5-17.5-10.5c0-2.8 1-5.5 2.8-7.6l36-43.2-36-43.2c-1.8-2.1-2.8-4.8-2.8-7.6c0-9 9.6-14.7 17.5-10.5zM396 157.1c0 2.8-1 5.5-2.8 7.6l-36 43.2 36 43.2c1.8 2.1 2.8 4.8 2.8 7.6c0 9-9.6 14.7-17.5 10.5l-89.9-47.9c-10.7-5.7-10.7-21.1 0-26.8l89.9-47.9c7.9-4.2 17.5 1.5 17.5 10.5z"
    ]
};
var $d8206b3ab2e65c05$export$243ae757907b1580 = $d8206b3ab2e65c05$export$5d53da7627754bc6;
var $d8206b3ab2e65c05$export$61a67f5f8ab39be = {
    prefix: "fas",
    iconName: "hand-holding-dollar",
    icon: [
        576,
        512,
        [
            "hand-holding-usd"
        ],
        "f4c0",
        "M312 24V34.5c6.4 1.2 12.6 2.7 18.2 4.2c12.8 3.4 20.4 16.6 17 29.4s-16.6 20.4-29.4 17c-10.9-2.9-21.1-4.9-30.2-5c-7.3-.1-14.7 1.7-19.4 4.4c-2.1 1.3-3.1 2.4-3.5 3c-.3 .5-.7 1.2-.7 2.8c0 .3 0 .5 0 .6c.2 .2 .9 1.2 3.3 2.6c5.8 3.5 14.4 6.2 27.4 10.1l.9 .3c11.1 3.3 25.9 7.8 37.9 15.3c13.7 8.6 26.1 22.9 26.4 44.9c.3 22.5-11.4 38.9-26.7 48.5c-6.7 4.1-13.9 7-21.3 8.8V232c0 13.3-10.7 24-24 24s-24-10.7-24-24V220.6c-9.5-2.3-18.2-5.3-25.6-7.8c-2.1-.7-4.1-1.4-6-2c-12.6-4.2-19.4-17.8-15.2-30.4s17.8-19.4 30.4-15.2c2.6 .9 5 1.7 7.3 2.5c13.6 4.6 23.4 7.9 33.9 8.3c8 .3 15.1-1.6 19.2-4.1c1.9-1.2 2.8-2.2 3.2-2.9c.4-.6 .9-1.8 .8-4.1l0-.2c0-1 0-2.1-4-4.6c-5.7-3.6-14.3-6.4-27.1-10.3l-1.9-.6c-10.8-3.2-25-7.5-36.4-14.4c-13.5-8.1-26.5-22-26.6-44.1c-.1-22.9 12.9-38.6 27.7-47.4c6.4-3.8 13.3-6.4 20.2-8.2V24c0-13.3 10.7-24 24-24s24 10.7 24 24zM568.2 336.3c13.1 17.8 9.3 42.8-8.5 55.9L433.1 485.5c-23.4 17.2-51.6 26.5-80.7 26.5H192 32c-17.7 0-32-14.3-32-32V416c0-17.7 14.3-32 32-32H68.8l44.9-36c22.7-18.2 50.9-28 80-28H272h16 64c17.7 0 32 14.3 32 32s-14.3 32-32 32H288 272c-8.8 0-16 7.2-16 16s7.2 16 16 16H392.6l119.7-88.2c17.8-13.1 42.8-9.3 55.9 8.5zM193.6 384l0 0-.9 0c.3 0 .6 0 .9 0z"
    ]
};
var $d8206b3ab2e65c05$export$47d27bc305b59690 = $d8206b3ab2e65c05$export$61a67f5f8ab39be;
var $d8206b3ab2e65c05$export$b0babe4230e35ebe = {
    prefix: "fas",
    iconName: "bacterium",
    icon: [
        512,
        512,
        [],
        "e05a",
        "M423.1 30.6c3.6-12.7-3.7-26-16.5-29.7s-26 3.7-29.7 16.5l-4.2 14.7c-9.8-.4-19.9 .5-29.9 2.8c-12.1 2.8-23.7 5.9-34.9 9.4l-5.9-13.7c-5.2-12.2-19.3-17.8-31.5-12.6s-17.8 19.3-12.6 31.5l4.9 11.3c-22 9.4-42 20.1-60.2 31.8L196 82.7c-7.4-11-22.3-14-33.3-6.7s-14 22.3-6.7 33.3l7.8 11.6c-18 15-33.7 30.8-47.3 47.1L103 157.3c-10.4-8.3-25.5-6.6-33.7 3.7s-6.6 25.5 3.7 33.7l15 12c-2.1 3.2-4.1 6.5-6 9.7c-9.4 15.7-17 31-23.2 45.3l-9.9-3.9c-12.3-4.9-26.3 1.1-31.2 13.4s1.1 26.3 13.4 31.2l11.6 4.6c-.3 1.1-.6 2.1-.9 3.1c-3.5 12.5-5.7 23.2-7.1 31.3c-.7 4.1-1.2 7.5-1.6 10.3c-.2 1.4-.3 2.6-.4 3.6l-.1 1.4-.1 .6 0 .3 0 .1c0 0 0 .1 39.2 3.7l0 0-39.2-3.6c-.5 5-.6 10-.4 14.9l-14.7 4.2C4.7 380.6-2.7 393.8 .9 406.6s16.9 20.1 29.7 16.5l13.8-3.9c10.6 20.7 27.6 37.8 48.5 48.5l-3.9 13.7c-3.6 12.7 3.7 26 16.5 29.7s26-3.7 29.7-16.5l4.2-14.7c23.8 1 46.3-5.5 65.1-17.6L215 473c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9l-10.6-10.6c9.1-14.1 15.1-30.5 17-48.3l.1-.8c.3-1.7 1-5.1 2.3-9.8l.2-.8 12.6 5.4c12.2 5.2 26.3-.4 31.5-12.6s-.4-26.3-12.6-31.5l-11.3-4.8c9.9-14.9 24.9-31.6 48.6-46l2.1 7.5c3.6 12.7 16.9 20.1 29.7 16.5s20.1-16.9 16.5-29.7L371 259.2c6.9-2.2 14.3-4.3 22.2-6.1c12.9-3 24.7-8 35.2-14.8L439 249c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9l-10.6-10.6c12.2-19 18.6-41.6 17.6-65.1l14.7-4.2c12.7-3.6 20.1-16.9 16.5-29.7s-16.9-20.1-29.7-16.5l-13.7 3.9c-10.8-21.2-28-38-48.5-48.5l3.9-13.8zM92.1 363.3l0 0L144 368l-51.9-4.7zM112 320a48 48 0 1 1 96 0 48 48 0 1 1 -96 0zM240 184a24 24 0 1 1 0 48 24 24 0 1 1 0-48z"
    ]
};
var $d8206b3ab2e65c05$export$d97ff927c450c87f = {
    prefix: "fas",
    iconName: "hand-pointer",
    icon: [
        448,
        512,
        [],
        "f25a",
        "M128 40c0-22.1 17.9-40 40-40s40 17.9 40 40V188.2c8.5-7.6 19.7-12.2 32-12.2c20.6 0 38.2 13 45 31.2c8.8-9.3 21.2-15.2 35-15.2c25.3 0 46 19.5 47.9 44.3c8.5-7.7 19.8-12.3 32.1-12.3c26.5 0 48 21.5 48 48v48 16 48c0 70.7-57.3 128-128 128l-16 0H240l-.1 0h-5.2c-5 0-9.9-.3-14.7-1c-55.3-5.6-106.2-34-140-79L8 336c-13.3-17.7-9.7-42.7 8-56s42.7-9.7 56 8l56 74.7V40zM240 304c0-8.8-7.2-16-16-16s-16 7.2-16 16v96c0 8.8 7.2 16 16 16s16-7.2 16-16V304zm48-16c-8.8 0-16 7.2-16 16v96c0 8.8 7.2 16 16 16s16-7.2 16-16V304c0-8.8-7.2-16-16-16zm80 16c0-8.8-7.2-16-16-16s-16 7.2-16 16v96c0 8.8 7.2 16 16 16s16-7.2 16-16V304z"
    ]
};
var $d8206b3ab2e65c05$export$48d1206500db2e9d = {
    prefix: "fas",
    iconName: "drum-steelpan",
    icon: [
        576,
        512,
        [],
        "f56a",
        "M288 32c159.1 0 288 48 288 128V352c0 80-128.9 128-288 128S0 432 0 352V160C0 80 128.9 32 288 32zM528 160c0-9.9-8-29.9-55-49.8c-18.6-7.9-40.9-14.4-66-19.4l-27.8 43.6c-7.3 11.5-11.2 24.8-11.2 38.4c0 17.5 6.4 34.4 18.1 47.5l9.8 11c29.8-5.2 55.9-12.5 77.2-21.5c47.1-19.9 55-39.9 55-49.8zM349.2 237.3c-8-26.2-32.4-45.3-61.2-45.3s-53.3 19.1-61.2 45.3c19.4 1.7 39.9 2.7 61.2 2.7s41.8-.9 61.2-2.7zM169 90.8c-25.2 5-47.4 11.6-66 19.4C56 130.1 48 150.1 48 160s8 29.9 55 49.8c21.3 9 47.4 16.3 77.2 21.5l9.8-11c11.6-13.1 18.1-30 18.1-47.5c0-13.6-3.9-26.9-11.2-38.4L169 90.8zm56.3-8C224.5 87 224 91.5 224 96c0 35.3 28.7 64 64 64s64-28.7 64-64c0-4.5-.5-9-1.4-13.2C330.8 81 309.8 80 288 80s-42.8 1-62.6 2.8z"
    ]
};
var $d8206b3ab2e65c05$export$c578e919f2c5c135 = {
    prefix: "fas",
    iconName: "hand-scissors",
    icon: [
        512,
        512,
        [],
        "f257",
        "M40 208c-22.1 0-40 17.9-40 40s17.9 40 40 40l180.2 0c-7.6 8.5-12.2 19.7-12.2 32c0 25.3 19.5 46 44.3 47.9c-7.7 8.5-12.3 19.8-12.3 32.1c0 26.5 21.5 48 48 48l32 0 64 0c70.7 0 128-57.3 128-128l0-113.1c0-40.2-16-78.8-44.4-107.3C444.8 76.8 413.9 64 381.7 64L336 64c-21.3 0-39.3 13.9-45.6 33.1l74.5 23.7c8.4 2.7 13.1 11.7 10.4 20.1s-11.7 13.1-20.1 10.4L288 129.9l0 .1L84 65.8C62.9 59.2 40.5 70.9 33.8 92s5.1 43.5 26.2 50.2L269.5 208 40 208z"
    ]
};
var $d8206b3ab2e65c05$export$a96374faedb12593 = {
    prefix: "fas",
    iconName: "hands-praying",
    icon: [
        640,
        512,
        [
            "praying-hands"
        ],
        "f684",
        "M351.2 4.8c3.2-2 6.6-3.3 10-4.1c4.7-1 9.6-.9 14.1 .1c7.7 1.8 14.8 6.5 19.4 13.6L514.6 194.2c8.8 13.1 13.4 28.6 13.4 44.4v73.5c0 6.9 4.4 13 10.9 15.2l79.2 26.4C631.2 358 640 370.2 640 384v96c0 9.9-4.6 19.3-12.5 25.4s-18.1 8.1-27.7 5.5L431 465.9c-56-14.9-95-65.7-95-123.7V224c0-17.7 14.3-32 32-32s32 14.3 32 32v80c0 8.8 7.2 16 16 16s16-7.2 16-16V219.1c0-7-1.8-13.8-5.3-19.8L340.3 48.1c-1.7-3-2.9-6.1-3.6-9.3c-1-4.7-1-9.6 .1-14.1c1.9-8 6.8-15.2 14.3-19.9zm-62.4 0c7.5 4.6 12.4 11.9 14.3 19.9c1.1 4.6 1.2 9.4 .1 14.1c-.7 3.2-1.9 6.3-3.6 9.3L213.3 199.3c-3.5 6-5.3 12.9-5.3 19.8V304c0 8.8 7.2 16 16 16s16-7.2 16-16V224c0-17.7 14.3-32 32-32s32 14.3 32 32V342.3c0 58-39 108.7-95 123.7l-168.7 45c-9.6 2.6-19.9 .5-27.7-5.5S0 490 0 480V384c0-13.8 8.8-26 21.9-30.4l79.2-26.4c6.5-2.2 10.9-8.3 10.9-15.2V238.5c0-15.8 4.7-31.2 13.4-44.4L245.2 14.5c4.6-7.1 11.7-11.8 19.4-13.6c4.6-1.1 9.4-1.2 14.1-.1c3.5 .8 6.9 2.1 10 4.1z"
    ]
};
var $d8206b3ab2e65c05$export$95e08e91b0929943 = $d8206b3ab2e65c05$export$a96374faedb12593;
var $d8206b3ab2e65c05$export$9c58ddc4b3356f98 = {
    prefix: "fas",
    iconName: "arrow-rotate-right",
    icon: [
        512,
        512,
        [
            8635,
            "arrow-right-rotate",
            "arrow-rotate-forward",
            "redo"
        ],
        "f01e",
        "M386.3 160H336c-17.7 0-32 14.3-32 32s14.3 32 32 32H464c17.7 0 32-14.3 32-32V64c0-17.7-14.3-32-32-32s-32 14.3-32 32v51.2L414.4 97.6c-87.5-87.5-229.3-87.5-316.8 0s-87.5 229.3 0 316.8s229.3 87.5 316.8 0c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0c-62.5 62.5-163.8 62.5-226.3 0s-62.5-163.8 0-226.3s163.8-62.5 226.3 0L386.3 160z"
    ]
};
var $d8206b3ab2e65c05$export$ffa1245982c1b28b = $d8206b3ab2e65c05$export$9c58ddc4b3356f98;
var $d8206b3ab2e65c05$export$89c59b5f47067f4c = $d8206b3ab2e65c05$export$9c58ddc4b3356f98;
var $d8206b3ab2e65c05$export$3d9f98aa1c24c776 = $d8206b3ab2e65c05$export$9c58ddc4b3356f98;
var $d8206b3ab2e65c05$export$ae3a453550dec95 = {
    prefix: "fas",
    iconName: "biohazard",
    icon: [
        576,
        512,
        [
            9763
        ],
        "f780",
        "M173.2 0c-1.8 0-3.5 .7-4.8 2C138.5 32.3 120 74 120 120c0 26.2 6 50.9 16.6 73c-22 2.4-43.8 9.1-64.2 20.5C37.9 232.8 13.3 262.4 .4 296c-.7 1.7-.5 3.7 .5 5.2c2.2 3.7 7.4 4.3 10.6 1.3C64.2 254.3 158 245.1 205 324s-8.1 153.1-77.6 173.2c-4.2 1.2-6.3 5.9-4.1 9.6c1 1.6 2.6 2.7 4.5 3c36.5 5.9 75.2 .1 109.7-19.2c20.4-11.4 37.4-26.5 50.5-43.8c13.1 17.3 30.1 32.4 50.5 43.8c34.5 19.3 73.3 25.2 109.7 19.2c1.9-.3 3.5-1.4 4.5-3c2.2-3.7 .1-8.4-4.1-9.6C379.1 477.1 324 403 371 324s140.7-69.8 193.5-21.4c3.2 2.9 8.4 2.3 10.6-1.3c1-1.6 1.1-3.5 .5-5.2c-12.9-33.6-37.5-63.2-72.1-82.5c-20.4-11.4-42.2-18.1-64.2-20.5C450 170.9 456 146.2 456 120c0-46-18.5-87.7-48.4-118c-1.3-1.3-3-2-4.8-2c-5 0-8.4 5.2-6.7 9.9C421.7 80.5 385.6 176 288 176S154.3 80.5 179.9 9.9c1.7-4.7-1.6-9.9-6.7-9.9zM240 272a48 48 0 1 1 96 0 48 48 0 1 1 -96 0zM181.7 417.6c6.3-11.8 9.8-25.1 8.6-39.8c-19.5-18-34-41.4-41.2-67.8c-12.5-8.1-26.2-11.8-40-12.4c-9-.4-18.1 .6-27.1 2.7c7.8 57.1 38.7 106.8 82.9 139.4c6.8-6.7 12.6-14.1 16.8-22.1zM288 64c-28.8 0-56.3 5.9-81.2 16.5c2 8.3 5 16.2 9 23.5c6.8 12.4 16.7 23.1 30.1 30.3c13.3-4.1 27.5-6.3 42.2-6.3s28.8 2.2 42.2 6.3c13.4-7.2 23.3-17.9 30.1-30.3c4-7.3 7-15.2 9-23.5C344.3 69.9 316.8 64 288 64zM426.9 310c-7.2 26.4-21.7 49.7-41.2 67.8c-1.2 14.7 2.2 28.1 8.6 39.8c4.3 8 10 15.4 16.8 22.1c44.3-32.6 75.2-82.3 82.9-139.4c-9-2.2-18.1-3.1-27.1-2.7c-13.8 .6-27.5 4.4-40 12.4z"
    ]
};
var $d8206b3ab2e65c05$export$14e1096ad1719098 = {
    prefix: "fas",
    iconName: "location-crosshairs",
    icon: [
        512,
        512,
        [
            "location"
        ],
        "f601",
        "M256 0c17.7 0 32 14.3 32 32V66.7C368.4 80.1 431.9 143.6 445.3 224H480c17.7 0 32 14.3 32 32s-14.3 32-32 32H445.3C431.9 368.4 368.4 431.9 288 445.3V480c0 17.7-14.3 32-32 32s-32-14.3-32-32V445.3C143.6 431.9 80.1 368.4 66.7 288H32c-17.7 0-32-14.3-32-32s14.3-32 32-32H66.7C80.1 143.6 143.6 80.1 224 66.7V32c0-17.7 14.3-32 32-32zM128 256a128 128 0 1 0 256 0 128 128 0 1 0 -256 0zm128-80a80 80 0 1 1 0 160 80 80 0 1 1 0-160z"
    ]
};
var $d8206b3ab2e65c05$export$45e012c32174eb5d = $d8206b3ab2e65c05$export$14e1096ad1719098;
var $d8206b3ab2e65c05$export$2f8a28204bb4b86f = {
    prefix: "fas",
    iconName: "mars-double",
    icon: [
        640,
        512,
        [
            9891
        ],
        "f227",
        "M312 32c-9.7 0-18.5 5.8-22.2 14.8s-1.7 19.3 5.2 26.2l33.4 33.4L275.8 159c-28.4-19.5-62.7-31-99.8-31C78.8 128 0 206.8 0 304s78.8 176 176 176s176-78.8 176-176c0-37-11.4-71.4-31-99.8l52.6-52.6L407 185c6.9 6.9 17.2 8.9 26.2 5.2s14.8-12.5 14.8-22.2V56c0-13.3-10.7-24-24-24H312zm88 48h0v0l0 0zM64 304a112 112 0 1 1 224 0A112 112 0 1 1 64 304zM368 480c97.2 0 176-78.8 176-176c0-37-11.4-71.4-31-99.8l52.6-52.6L599 185c6.9 6.9 17.2 8.9 26.2 5.2s14.8-12.5 14.8-22.2V56c0-13.3-10.7-24-24-24H504c-9.7 0-18.5 5.8-22.2 14.8c-1.2 2.9-1.8 6-1.8 9l0 .2v.2c0 6.2 2.5 12.2 7 16.8l33.4 33.4L480 146.7V168c0 22.6-13.6 43.1-34.6 51.7c-.8 .3-1.7 .7-2.5 1C465.7 241.2 480 270.9 480 304c0 61.9-50.1 112-112 112c-5.4 0-10.8-.4-16-1.1c-12.9 20.4-29.1 38.3-48.1 53.1c19.8 7.8 41.4 12 64 12z"
    ]
};
var $d8206b3ab2e65c05$export$f31a37ecbfd4e707 = {
    prefix: "fas",
    iconName: "child-dress",
    icon: [
        320,
        512,
        [],
        "e59c",
        "M224 64A64 64 0 1 0 96 64a64 64 0 1 0 128 0zM88 400v80c0 17.7 14.3 32 32 32s32-14.3 32-32V400h16v80c0 17.7 14.3 32 32 32s32-14.3 32-32V400h17.8c10.9 0 18.6-10.7 15.2-21.1l-31.1-93.4 28.6 37.8c10.7 14.1 30.8 16.8 44.8 6.2s16.8-30.7 6.2-44.8L254.6 207c-22.4-29.6-57.5-47-94.6-47s-72.2 17.4-94.6 47L6.5 284.7c-10.7 14.1-7.9 34.2 6.2 44.8s34.2 7.9 44.8-6.2l28.7-37.8L55 378.9C51.6 389.3 59.3 400 70.2 400H88z"
    ]
};
var $d8206b3ab2e65c05$export$6ea1decf8bb3513d = {
    prefix: "fas",
    iconName: "users-between-lines",
    icon: [
        640,
        512,
        [],
        "e591",
        "M0 24C0 10.7 10.7 0 24 0H616c13.3 0 24 10.7 24 24s-10.7 24-24 24H24C10.7 48 0 37.3 0 24zM0 488c0-13.3 10.7-24 24-24H616c13.3 0 24 10.7 24 24s-10.7 24-24 24H24c-13.3 0-24-10.7-24-24zM83.2 160a64 64 0 1 1 128 0 64 64 0 1 1 -128 0zM32 320c0-35.3 28.7-64 64-64h96c12.2 0 23.7 3.4 33.4 9.4c-37.2 15.1-65.6 47.2-75.8 86.6H64c-17.7 0-32-14.3-32-32zm461.6 32c-10.3-40.1-39.6-72.6-77.7-87.4c9.4-5.5 20.4-8.6 32.1-8.6h96c35.3 0 64 28.7 64 64c0 17.7-14.3 32-32 32H493.6zM391.2 290.4c32.1 7.4 58.1 30.9 68.9 61.6c3.5 10 5.5 20.8 5.5 32c0 17.7-14.3 32-32 32h-224c-17.7 0-32-14.3-32-32c0-11.2 1.9-22 5.5-32c10.5-29.7 35.3-52.8 66.1-60.9c7.8-2.1 16-3.1 24.5-3.1h96c7.4 0 14.7 .8 21.6 2.4zm44-130.4a64 64 0 1 1 128 0 64 64 0 1 1 -128 0zM321.6 96a80 80 0 1 1 0 160 80 80 0 1 1 0-160z"
    ]
};
var $d8206b3ab2e65c05$export$895159d10626af74 = {
    prefix: "fas",
    iconName: "lungs-virus",
    icon: [
        640,
        512,
        [],
        "e067",
        "M320 0c17.7 0 32 14.3 32 32V156.2c-8.5-7.6-19.7-12.2-32-12.2s-23.5 4.6-32 12.2V32c0-17.7 14.3-32 32-32zM444.5 195.5c-16.4-16.4-41.8-18.5-60.5-6.1V165.3C384 127 415 96 453.3 96c21.7 0 42.8 10.2 55.8 28.8c15.4 22.1 44.3 65.4 71 116.9c26.5 50.9 52.4 112.5 59.6 170.3c.2 1.3 .2 2.6 .2 4v7c0 49.1-39.8 89-89 89c-7.3 0-14.5-.9-21.6-2.7l-72.7-18.2c-20.9-5.2-38.7-17.1-51.5-32.9c14 1.5 28.5-3 39.2-13.8l-22.6-22.6 22.6 22.6c18.7-18.7 18.7-49.1 0-67.9c-1.1-1.1-1.4-2-1.5-2.5c-.1-.8-.1-1.8 .4-2.9s1.2-1.9 1.8-2.3c.5-.3 1.3-.8 2.9-.8c26.5 0 48-21.5 48-48s-21.5-48-48-48c-1.6 0-2.4-.4-2.9-.8c-.6-.4-1.3-1.2-1.8-2.3s-.5-2.2-.4-2.9c.1-.6 .4-1.4 1.5-2.5c18.7-18.7 18.7-49.1 0-67.9zM421.8 421.8c-6.2 6.2-16.4 6.2-22.6 0C375.9 398.5 336 415 336 448c0 8.8-7.2 16-16 16s-16-7.2-16-16c0-33-39.9-49.5-63.2-26.2c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6C241.5 375.9 225 336 192 336c-8.8 0-16-7.2-16-16s7.2-16 16-16c33 0 49.5-39.9 26.2-63.2c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0C264.1 241.5 304 225 304 192c0-8.8 7.2-16 16-16s16 7.2 16 16c0 33 39.9 49.5 63.2 26.2c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6C398.5 264.1 415 304 448 304c8.8 0 16 7.2 16 16s-7.2 16-16 16c-33 0-49.5 39.9-26.2 63.2c6.2 6.2 6.2 16.4 0 22.6zM183.3 491.2l-72.7 18.2c-7.1 1.8-14.3 2.7-21.6 2.7c-49.1 0-89-39.8-89-89v-7c0-1.3 .1-2.7 .2-4c7.2-57.9 33.1-119.4 59.6-170.3c26.8-51.5 55.6-94.8 71-116.9c13-18.6 34-28.8 55.8-28.8C225 96 256 127 256 165.3v24.1c-18.6-12.4-44-10.3-60.5 6.1c-18.7 18.7-18.7 49.1 0 67.9c1.1 1.1 1.4 2 1.5 2.5c.1 .8 .1 1.8-.4 2.9s-1.2 1.9-1.8 2.3c-.5 .3-1.3 .8-2.9 .8c-26.5 0-48 21.5-48 48s21.5 48 48 48c1.6 0 2.4 .4 2.9 .8c.6 .4 1.3 1.2 1.8 2.3s.5 2.2 .4 2.9c-.1 .6-.4 1.4-1.5 2.5c-18.7 18.7-18.7 49.1 0 67.9c10.7 10.7 25.3 15.3 39.2 13.8c-12.8 15.9-30.6 27.7-51.5 32.9zM296 320a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm72 32a16 16 0 1 0 -32 0 16 16 0 1 0 32 0z"
    ]
};
var $d8206b3ab2e65c05$export$8ac6d81a3d5b40a1 = {
    prefix: "fas",
    iconName: "face-grin-tears",
    icon: [
        640,
        512,
        [
            128514,
            "grin-tears"
        ],
        "f588",
        "M548.6 371.4C506.4 454.8 419.9 512 320 512s-186.4-57.2-228.6-140.6c4.5-2.9 8.7-6.3 12.7-10.3c8.1-8.1 13.2-18.6 16.5-26.6c3.6-8.8 6.5-18.4 8.8-27.5c4.6-18.2 7.7-37 9.3-48.2c3.9-26.5-18.8-49.2-45.2-45.4c-6.8 .9-16.2 2.4-26.6 4.4C85.3 94.5 191.6 0 320 0S554.7 94.5 573.2 217.7c-10.3-2-19.8-3.5-26.6-4.4c-26.5-3.9-49.2 18.8-45.2 45.4c1.6 11.3 4.6 30 9.3 48.2c2.3 9.1 5.2 18.8 8.8 27.5c3.3 8.1 8.4 18.5 16.5 26.6c3.9 3.9 8.2 7.4 12.7 10.3zM107 254.1c-3.1 21.5-11.4 70.2-25.5 84.4c-.9 1-1.9 1.8-2.9 2.7C60 356.7 32 355.5 14.3 337.7c-18.7-18.7-19.1-48.8-.7-67.2c8.6-8.6 30.1-15.1 50.5-19.6c13-2.8 25.5-4.8 33.9-6c5.4-.8 9.9 3.7 9 9zm454.5 87.1c-.8-.6-1.5-1.3-2.3-2c-.2-.2-.5-.4-.7-.7c-14.1-14.1-22.5-62.9-25.5-84.4c-.8-5.4 3.7-9.9 9-9c1 .1 2.2 .3 3.3 .5c8.2 1.2 19.2 3 30.6 5.5c20.4 4.4 41.9 10.9 50.5 19.6c18.4 18.4 18 48.5-.7 67.2c-17.7 17.7-45.7 19-64.2 3.4zm-90.1-9.7c5-11.8-7-22.5-19.3-18.7c-39.7 12.2-84.4 19-131.8 19s-92.1-6.8-131.8-19c-12.3-3.8-24.3 6.9-19.3 18.7c25 59.1 83.2 100.5 151.1 100.5s126.2-41.4 151.1-100.5zM281.6 228.8l0 0 0 0 0 0c2.1 2.8 5.7 3.9 8.9 2.8s5.5-4.1 5.5-7.6c0-17.9-6.7-35.6-16.6-48.8c-9.8-13-23.9-23.2-39.4-23.2s-29.6 10.2-39.4 23.2C190.7 188.4 184 206.1 184 224c0 3.4 2.2 6.5 5.5 7.6s6.9 0 8.9-2.8l0 0 0 0 0 0 .2-.2c.2-.2 .4-.5 .7-.9c.6-.8 1.6-2 2.8-3.4c2.5-2.8 6-6.6 10.2-10.3c8.8-7.8 18.8-14 27.7-14s18.9 6.2 27.7 14c4.2 3.7 7.7 7.5 10.2 10.3c1.2 1.4 2.2 2.6 2.8 3.4c.3 .4 .6 .7 .7 .9l.2 .2 0 0zm160 0l0 0 0 0c2.1 2.8 5.7 3.9 8.9 2.8s5.5-4.1 5.5-7.6c0-17.9-6.7-35.6-16.6-48.8c-9.8-13-23.9-23.2-39.4-23.2s-29.6 10.2-39.4 23.2C350.7 188.4 344 206.1 344 224c0 3.4 2.2 6.5 5.5 7.6s6.9 0 8.9-2.8l0 0 0 0 0 0 .2-.2c.2-.2 .4-.5 .7-.9c.6-.8 1.6-2 2.8-3.4c2.5-2.8 6-6.6 10.2-10.3c8.8-7.8 18.8-14 27.7-14s18.9 6.2 27.7 14c4.2 3.7 7.7 7.5 10.2 10.3c1.2 1.4 2.2 2.6 2.8 3.4c.3 .4 .6 .7 .7 .9l.2 .2 0 0 0 0z"
    ]
};
var $d8206b3ab2e65c05$export$b2f7512221512b5b = $d8206b3ab2e65c05$export$8ac6d81a3d5b40a1;
var $d8206b3ab2e65c05$export$ddab067855cf34cb = {
    prefix: "fas",
    iconName: "phone",
    icon: [
        512,
        512,
        [
            128222,
            128379
        ],
        "f095",
        "M164.9 24.6c-7.7-18.6-28-28.5-47.4-23.2l-88 24C12.1 30.2 0 46 0 64C0 311.4 200.6 512 448 512c18 0 33.8-12.1 38.6-29.5l24-88c5.3-19.4-4.6-39.7-23.2-47.4l-96-40c-16.3-6.8-35.2-2.1-46.3 11.6L304.7 368C234.3 334.7 177.3 277.7 144 207.3L193.3 167c13.7-11.2 18.4-30 11.6-46.3l-40-96z"
    ]
};
var $d8206b3ab2e65c05$export$3c70ffe5660af060 = {
    prefix: "fas",
    iconName: "calendar-xmark",
    icon: [
        512,
        512,
        [
            "calendar-times"
        ],
        "f273",
        "M160 0c17.7 0 32 14.3 32 32V64H320V32c0-17.7 14.3-32 32-32s32 14.3 32 32V64h48c26.5 0 48 21.5 48 48v48H32V112c0-26.5 21.5-48 48-48h48V32c0-17.7 14.3-32 32-32zM32 192H480V464c0 26.5-21.5 48-48 48H80c-26.5 0-48-21.5-48-48V192zM337 305c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-47 47-47-47c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9l47 47-47 47c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l47-47 47 47c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9l-47-47 47-47z"
    ]
};
var $d8206b3ab2e65c05$export$99b20d7352fbcf08 = $d8206b3ab2e65c05$export$3c70ffe5660af060;
var $d8206b3ab2e65c05$export$84a2f9476730c40e = {
    prefix: "fas",
    iconName: "child-reaching",
    icon: [
        384,
        512,
        [],
        "e59d",
        "M256 64A64 64 0 1 0 128 64a64 64 0 1 0 128 0zM152.9 169.3c-23.7-8.4-44.5-24.3-58.8-45.8L74.6 94.2C64.8 79.5 45 75.6 30.2 85.4s-18.7 29.7-8.9 44.4L40.9 159c18.1 27.1 42.8 48.4 71.1 62.4V480c0 17.7 14.3 32 32 32s32-14.3 32-32V384h32v96c0 17.7 14.3 32 32 32s32-14.3 32-32V221.6c29.1-14.2 54.4-36.2 72.7-64.2l18.2-27.9c9.6-14.8 5.4-34.6-9.4-44.3s-34.6-5.5-44.3 9.4L291 122.4c-21.8 33.4-58.9 53.6-98.8 53.6c-12.6 0-24.9-2-36.6-5.8c-.9-.3-1.8-.7-2.7-.9z"
    ]
};
var $d8206b3ab2e65c05$export$5b64b916710da7c7 = {
    prefix: "fas",
    iconName: "head-side-virus",
    icon: [
        512,
        512,
        [],
        "e064",
        "M0 224.2C0 100.6 100.2 0 224 0h24c95.2 0 181.2 69.3 197.3 160.2c2.3 13 6.8 25.7 15.1 36l42 52.6c6.2 7.8 9.6 17.4 9.6 27.4c0 24.2-19.6 43.8-43.8 43.8H448v64c0 35.3-28.7 64-64 64H320v32c0 17.7-14.3 32-32 32H96c-17.7 0-32-14.3-32-32V407.3c0-16.7-6.9-32.5-17.1-45.8C16.6 322.4 0 274.1 0 224.2zM224 64c-8.8 0-16 7.2-16 16c0 33-39.9 49.5-63.2 26.2c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6C145.5 152.1 129 192 96 192c-8.8 0-16 7.2-16 16s7.2 16 16 16c33 0 49.5 39.9 26.2 63.2c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0C168.1 286.5 208 303 208 336c0 8.8 7.2 16 16 16s16-7.2 16-16c0-33 39.9-49.5 63.2-26.2c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6C302.5 263.9 319 224 352 224c8.8 0 16-7.2 16-16s-7.2-16-16-16c-33 0-49.5-39.9-26.2-63.2c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0C279.9 129.5 240 113 240 80c0-8.8-7.2-16-16-16zm-24 96a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm40 80a16 16 0 1 1 32 0 16 16 0 1 1 -32 0z"
    ]
};
var $d8206b3ab2e65c05$export$f504a6909b677146 = {
    prefix: "fas",
    iconName: "user-gear",
    icon: [
        640,
        512,
        [
            "user-cog"
        ],
        "f4fe",
        "M224 0a128 128 0 1 1 0 256A128 128 0 1 1 224 0zM178.3 304h91.4c11.8 0 23.4 1.2 34.5 3.3c-2.1 18.5 7.4 35.6 21.8 44.8c-16.6 10.6-26.7 31.6-20 53.3c4 12.9 9.4 25.5 16.4 37.6s15.2 23.1 24.4 33c15.7 16.9 39.6 18.4 57.2 8.7v.9c0 9.2 2.7 18.5 7.9 26.3H29.7C13.3 512 0 498.7 0 482.3C0 383.8 79.8 304 178.3 304zM436 218.2c0-7 4.5-13.3 11.3-14.8c10.5-2.4 21.5-3.7 32.7-3.7s22.2 1.3 32.7 3.7c6.8 1.5 11.3 7.8 11.3 14.8v30.6c7.9 3.4 15.4 7.7 22.3 12.8l24.9-14.3c6.1-3.5 13.7-2.7 18.5 2.4c7.6 8.1 14.3 17.2 20.1 27.2s10.3 20.4 13.5 31c2.1 6.7-1.1 13.7-7.2 17.2l-25 14.4c.4 4 .7 8.1 .7 12.3s-.2 8.2-.7 12.3l25 14.4c6.1 3.5 9.2 10.5 7.2 17.2c-3.3 10.6-7.8 21-13.5 31s-12.5 19.1-20.1 27.2c-4.8 5.1-12.5 5.9-18.5 2.4l-24.9-14.3c-6.9 5.1-14.3 9.4-22.3 12.8l0 30.6c0 7-4.5 13.3-11.3 14.8c-10.5 2.4-21.5 3.7-32.7 3.7s-22.2-1.3-32.7-3.7c-6.8-1.5-11.3-7.8-11.3-14.8V454.8c-8-3.4-15.6-7.7-22.5-12.9l-24.7 14.3c-6.1 3.5-13.7 2.7-18.5-2.4c-7.6-8.1-14.3-17.2-20.1-27.2s-10.3-20.4-13.5-31c-2.1-6.7 1.1-13.7 7.2-17.2l24.8-14.3c-.4-4.1-.7-8.2-.7-12.4s.2-8.3 .7-12.4L343.8 325c-6.1-3.5-9.2-10.5-7.2-17.2c3.3-10.6 7.7-21 13.5-31s12.5-19.1 20.1-27.2c4.8-5.1 12.4-5.9 18.5-2.4l24.8 14.3c6.9-5.1 14.5-9.4 22.5-12.9V218.2zm92.1 133.5a48.1 48.1 0 1 0 -96.1 0 48.1 48.1 0 1 0 96.1 0z"
    ]
};
var $d8206b3ab2e65c05$export$474108c2b86e730e = $d8206b3ab2e65c05$export$f504a6909b677146;
var $d8206b3ab2e65c05$export$bbbff45e04f4abab = {
    prefix: "fas",
    iconName: "arrow-up-1-9",
    icon: [
        576,
        512,
        [
            "sort-numeric-up"
        ],
        "f163",
        "M450.7 38c8.3 6 13.3 15.7 13.3 26v96h16c17.7 0 32 14.3 32 32s-14.3 32-32 32H432 384c-17.7 0-32-14.3-32-32s14.3-32 32-32h16V108.4l-5.9 2c-16.8 5.6-34.9-3.5-40.5-20.2s3.5-34.9 20.2-40.5l48-16c9.8-3.3 20.5-1.6 28.8 4.4zM160 32c9 0 17.5 3.8 23.6 10.4l88 96c11.9 13 11.1 33.3-2 45.2s-33.3 11.1-45.2-2L192 146.3V448c0 17.7-14.3 32-32 32s-32-14.3-32-32V146.3L95.6 181.6c-11.9 13-32.2 13.9-45.2 2s-13.9-32.2-2-45.2l88-96C142.5 35.8 151 32 160 32zM445.7 364.9A32 32 0 1 0 418.3 307a32 32 0 1 0 27.4 57.9zm-40.7 54.9C369.6 408.4 344 375.2 344 336c0-48.6 39.4-88 88-88s88 39.4 88 88c0 23.5-7.5 46.3-21.5 65.2L449.7 467c-10.5 14.2-30.6 17.2-44.8 6.7s-17.2-30.6-6.7-44.8l6.8-9.2z"
    ]
};
var $d8206b3ab2e65c05$export$d213a3ba3cabed48 = $d8206b3ab2e65c05$export$bbbff45e04f4abab;
var $d8206b3ab2e65c05$export$2c79e1a422528bba = {
    prefix: "fas",
    iconName: "door-closed",
    icon: [
        576,
        512,
        [
            128682
        ],
        "f52a",
        "M96 64c0-35.3 28.7-64 64-64H416c35.3 0 64 28.7 64 64V448h64c17.7 0 32 14.3 32 32s-14.3 32-32 32H432 144 32c-17.7 0-32-14.3-32-32s14.3-32 32-32H96V64zM384 288a32 32 0 1 0 0-64 32 32 0 1 0 0 64z"
    ]
};
var $d8206b3ab2e65c05$export$bea811bbf570f05a = {
    prefix: "fas",
    iconName: "shield-virus",
    icon: [
        512,
        512,
        [],
        "e06c",
        "M269.4 2.9C265.2 1 260.7 0 256 0s-9.2 1-13.4 2.9L54.3 82.8c-22 9.3-38.4 31-38.3 57.2c.5 99.2 41.3 280.7 213.6 363.2c16.7 8 36.1 8 52.8 0C454.7 420.7 495.5 239.2 496 140c.1-26.2-16.3-47.9-38.3-57.2L269.4 2.9zM256 112c8.8 0 16 7.2 16 16c0 33 39.9 49.5 63.2 26.2c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6C334.5 200.1 351 240 384 240c8.8 0 16 7.2 16 16s-7.2 16-16 16c-33 0-49.5 39.9-26.2 63.2c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0C311.9 334.5 272 351 272 384c0 8.8-7.2 16-16 16s-16-7.2-16-16c0-33-39.9-49.5-63.2-26.2c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6C177.5 311.9 161 272 128 272c-8.8 0-16-7.2-16-16s7.2-16 16-16c33 0 49.5-39.9 26.2-63.2c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0C200.1 177.5 240 161 240 128c0-8.8 7.2-16 16-16zM232 256a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm72 32a16 16 0 1 0 -32 0 16 16 0 1 0 32 0z"
    ]
};
var $d8206b3ab2e65c05$export$3397c7b4679acccc = {
    prefix: "fas",
    iconName: "dice-six",
    icon: [
        448,
        512,
        [
            9861
        ],
        "f526",
        "M0 96C0 60.7 28.7 32 64 32H384c35.3 0 64 28.7 64 64V416c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96zm160 64a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zM128 288a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm32 64a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zM320 192a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm32 64a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zM320 384a32 32 0 1 0 0-64 32 32 0 1 0 0 64z"
    ]
};
var $d8206b3ab2e65c05$export$f3858ce1b3218e2 = {
    prefix: "fas",
    iconName: "mosquito-net",
    icon: [
        640,
        512,
        [],
        "e52c",
        "M168.8 462.3c-7.9-4-11.1-13.6-7.2-21.5L192 380.2l0-44.2c0-4.2 1.7-8.3 4.7-11.3L256 265.4V242.2L139.2 344C87.8 395.3 0 358.9 0 286.3c0-41.1 30.6-75.8 71.4-80.9l159.9-23.9-49.6-41.3c-5.1-4.2-7-11.1-4.9-17.4l13.9-41.7-29-58.1c-4-7.9-.7-17.5 7.2-21.5s17.5-.7 21.5 7.2l32 64c1.9 3.8 2.2 8.2 .9 12.2l-12.5 37.6L256 160.5V137.9c0-14.9 10.1-27.3 23.8-31V63.7c0-4.5 3.7-8.2 8.2-8.2s8.2 3.7 8.2 8.2V107c13.7 3.6 23.8 16.1 23.8 31v22.6l45.4-37.8L352.8 85.1c-1.3-4-1-8.4 .9-12.2l32-64c4-7.9 13.6-11.1 21.5-7.2s11.1 13.6 7.2 21.5l-29 58.1 13.9 41.7c2.1 6.2 .1 13.1-4.9 17.4l-49.6 41.3 159.9 23.9c22.5 2.8 41.8 14.6 54.7 31.4c-2.7 2.6-5.2 5.4-7.3 8.6c-8.6-12.9-23.3-21.5-40-21.5s-31.4 8.5-40 21.5c-8.6-12.9-23.3-21.5-40-21.5c-21.7 0-40 14.3-45.9 34.1c-10.7 3.2-19.8 10.1-25.9 19.2l-40.2-35v23.1l32.4 32.4c-.3 2-.4 4.1-.4 6.2c0 16.7 8.5 31.4 21.5 40c-4 2.6-7.5 5.9-10.6 9.5L320 310.6v50c0 17.7-14.3 32-32 32s-32-14.3-32-32v-50l-32 32 0 41.4c0 2.5-.6 4.9-1.7 7.2l-32 64c-4 7.9-13.6 11.1-21.5 7.2zM512 256c8.8 0 16 7.2 16 16v16h48V272c0-8.8 7.2-16 16-16s16 7.2 16 16v16h16c8.8 0 16 7.2 16 16s-7.2 16-16 16H608v48h16c8.8 0 16 7.2 16 16s-7.2 16-16 16H608v48h16c8.8 0 16 7.2 16 16s-7.2 16-16 16H608v16c0 8.8-7.2 16-16 16s-16-7.2-16-16V480H528v16c0 8.8-7.2 16-16 16s-16-7.2-16-16V480H448v16c0 8.8-7.2 16-16 16s-16-7.2-16-16V480H400c-8.8 0-16-7.2-16-16s7.2-16 16-16h16V400H400c-8.8 0-16-7.2-16-16s7.2-16 16-16h16V320H400c-8.8 0-16-7.2-16-16s7.2-16 16-16h16V272c0-8.8 7.2-16 16-16s16 7.2 16 16v16h48V272c0-8.8 7.2-16 16-16zm16 112h48V320H528v48zm0 80h48V400H528v48zM448 320v48h48V320H448zm0 80v48h48V400H448z"
    ]
};
var $d8206b3ab2e65c05$export$154e99cb34841765 = {
    prefix: "fas",
    iconName: "bridge-water",
    icon: [
        576,
        512,
        [],
        "e4ce",
        "M0 96C0 78.3 14.3 64 32 64H544c17.7 0 32 14.3 32 32v35.6c0 15.7-12.7 28.4-28.4 28.4c-37.3 0-67.6 30.2-67.6 67.6V352.5c-12.9 0-25.8 3.9-36.8 11.7c-18 12.4-40.1 20.3-59.2 20.3h0l0-.5V256c0-53-43-96-96-96s-96 43-96 96V384l0 .5c-19 0-41.2-7.9-59.1-20.3c-11.1-7.8-24-11.7-36.9-11.7V227.6C96 190.2 65.8 160 28.4 160C12.7 160 0 147.3 0 131.6V96zM306.5 389.9C329 405.4 356.5 416 384 416c26.9 0 55.4-10.8 77.4-26.1l0 0c11.9-8.5 28.1-7.8 39.2 1.7c14.4 11.9 32.5 21 50.6 25.2c17.2 4 27.9 21.2 23.9 38.4s-21.2 27.9-38.4 23.9c-24.5-5.7-44.9-16.5-58.2-25C449.5 469.7 417 480 384 480c-31.9 0-60.6-9.9-80.4-18.9c-5.8-2.7-11.1-5.3-15.6-7.7c-4.5 2.4-9.7 5.1-15.6 7.7c-19.8 9-48.5 18.9-80.4 18.9c-33 0-65.5-10.3-94.5-25.8c-13.4 8.4-33.7 19.3-58.2 25c-17.2 4-34.4-6.7-38.4-23.9s6.7-34.4 23.9-38.4c18.1-4.2 36.2-13.3 50.6-25.2c11.1-9.4 27.3-10.1 39.2-1.7l0 0C136.7 405.2 165.1 416 192 416c27.5 0 55-10.6 77.5-26.1c11.1-7.9 25.9-7.9 37 0z"
    ]
};
var $d8206b3ab2e65c05$export$2337c975289bdd84 = {
    prefix: "fas",
    iconName: "person-booth",
    icon: [
        576,
        512,
        [],
        "f756",
        "M256 32c0-17.7-14.3-32-32-32s-32 14.3-32 32V192h64V32zm320 0c0-17.7-14.3-32-32-32s-32 14.3-32 32V480c0 17.7 14.3 32 32 32s32-14.3 32-32V32zM224 512c17.7 0 32-14.3 32-32V320H192V480c0 17.7 14.3 32 32 32zM320 0c-9.3 0-18.1 4-24.2 11s-8.8 16.3-7.5 25.5l31.2 218.6L288.6 409.7c-3.5 17.3 7.8 34.2 25.1 37.7s34.2-7.8 37.7-25.1l.7-3.6c1.3 16.4 15.1 29.4 31.9 29.4c17.7 0 32-14.3 32-32c0 17.7 14.3 32 32 32s32-14.3 32-32V32c0-17.7-14.3-32-32-32H320zM112 80A48 48 0 1 0 16 80a48 48 0 1 0 96 0zm0 261.3V269.3l4.7 4.7c9 9 21.2 14.1 33.9 14.1H224c17.7 0 32-14.3 32-32s-14.3-32-32-32H157.3l-41.6-41.6c-14.3-14.3-33.8-22.4-54-22.4C27.6 160 0 187.6 0 221.6v55.7l0 .9V480c0 17.7 14.3 32 32 32s32-14.3 32-32V384l32 42.7V480c0 17.7 14.3 32 32 32s32-14.3 32-32V421.3c0-10.4-3.4-20.5-9.6-28.8L112 341.3z"
    ]
};
var $d8206b3ab2e65c05$export$d8724cf433389700 = {
    prefix: "fas",
    iconName: "text-width",
    icon: [
        448,
        512,
        [],
        "f035",
        "M64 128V96H192l0 128H176c-17.7 0-32 14.3-32 32s14.3 32 32 32h96c17.7 0 32-14.3 32-32s-14.3-32-32-32H256l0-128H384v32c0 17.7 14.3 32 32 32s32-14.3 32-32V80c0-26.5-21.5-48-48-48H224 48C21.5 32 0 53.5 0 80v48c0 17.7 14.3 32 32 32s32-14.3 32-32zM9.4 361.4c-12.5 12.5-12.5 32.8 0 45.3l64 64c9.2 9.2 22.9 11.9 34.9 6.9s19.8-16.6 19.8-29.6V416H320v32c0 12.9 7.8 24.6 19.8 29.6s25.7 2.2 34.9-6.9l64-64c12.5-12.5 12.5-32.8 0-45.3l-64-64c-9.2-9.2-22.9-11.9-34.9-6.9s-19.8 16.6-19.8 29.6v32H128V320c0-12.9-7.8-24.6-19.8-29.6s-25.7-2.2-34.9 6.9l-64 64z"
    ]
};
var $d8206b3ab2e65c05$export$7daa48199dcb2ad1 = {
    prefix: "fas",
    iconName: "hat-wizard",
    icon: [
        512,
        512,
        [],
        "f6e8",
        "M64 416L168.6 180.7c15.3-34.4 40.3-63.5 72-83.7l146.9-94c3-1.9 6.5-2.9 10-2.9C407.7 0 416 8.3 416 18.6v1.6c0 2.6-.5 5.1-1.4 7.5L354.8 176.9c-1.9 4.7-2.8 9.7-2.8 14.7c0 5.5 1.2 11 3.4 16.1L448 416H240.9l11.8-35.4 40.4-13.5c6.5-2.2 10.9-8.3 10.9-15.2s-4.4-13-10.9-15.2l-40.4-13.5-13.5-40.4C237 276.4 230.9 272 224 272s-13 4.4-15.2 10.9l-13.5 40.4-40.4 13.5C148.4 339 144 345.1 144 352s4.4 13 10.9 15.2l40.4 13.5L207.1 416H64zM279.6 141.5c-1.1-3.3-4.1-5.5-7.6-5.5s-6.5 2.2-7.6 5.5l-6.7 20.2-20.2 6.7c-3.3 1.1-5.5 4.1-5.5 7.6s2.2 6.5 5.5 7.6l20.2 6.7 6.7 20.2c1.1 3.3 4.1 5.5 7.6 5.5s6.5-2.2 7.6-5.5l6.7-20.2 20.2-6.7c3.3-1.1 5.5-4.1 5.5-7.6s-2.2-6.5-5.5-7.6l-20.2-6.7-6.7-20.2zM32 448H480c17.7 0 32 14.3 32 32s-14.3 32-32 32H32c-17.7 0-32-14.3-32-32s14.3-32 32-32z"
    ]
};
var $d8206b3ab2e65c05$export$8bdfe14ac72a8b17 = {
    prefix: "fas",
    iconName: "pen-fancy",
    icon: [
        512,
        512,
        [
            128395,
            10002
        ],
        "f5ac",
        "M373.5 27.1C388.5 9.9 410.2 0 433 0c43.6 0 79 35.4 79 79c0 22.8-9.9 44.6-27.1 59.6L277.7 319l-10.3-10.3-64-64L193 234.3 373.5 27.1zM170.3 256.9l10.4 10.4 64 64 10.4 10.4-19.2 83.4c-3.9 17.1-16.9 30.7-33.8 35.4L24.4 510.3l95.4-95.4c2.6 .7 5.4 1.1 8.3 1.1c17.7 0 32-14.3 32-32s-14.3-32-32-32s-32 14.3-32 32c0 2.9 .4 5.6 1.1 8.3L1.7 487.6 51.5 310c4.7-16.9 18.3-29.9 35.4-33.8l83.4-19.2z"
    ]
};
var $d8206b3ab2e65c05$export$f4d483fca19a4604 = {
    prefix: "fas",
    iconName: "person-digging",
    icon: [
        576,
        512,
        [
            "digging"
        ],
        "f85e",
        "M208 64a48 48 0 1 1 96 0 48 48 0 1 1 -96 0zM9.8 214.8c5.1-12.2 19.1-18 31.4-12.9L60.7 210l22.9-38.1C99.9 144.6 129.3 128 161 128c51.4 0 97 32.9 113.3 81.7l34.6 103.7 79.3 33.1 34.2-45.6c6.4-8.5 16.6-13.3 27.2-12.8s20.3 6.4 25.8 15.5l96 160c5.9 9.9 6.1 22.2 .4 32.2s-16.3 16.2-27.8 16.2H288c-11.1 0-21.4-5.7-27.2-15.2s-6.4-21.2-1.4-31.1l16-32c5.4-10.8 16.5-17.7 28.6-17.7h32l22.5-30L22.8 246.2c-12.2-5.1-18-19.1-12.9-31.4zm82.8 91.8l112 48c11.8 5 19.4 16.6 19.4 29.4v96c0 17.7-14.3 32-32 32s-32-14.3-32-32V405.1l-60.6-26-37 111c-5.6 16.8-23.7 25.8-40.5 20.2S-3.9 486.6 1.6 469.9l48-144 11-33 32 13.7z"
    ]
};
var $d8206b3ab2e65c05$export$7bd93e3343bd5671 = $d8206b3ab2e65c05$export$f4d483fca19a4604;
var $d8206b3ab2e65c05$export$ed8c149a0ea54bb4 = {
    prefix: "fas",
    iconName: "trash",
    icon: [
        448,
        512,
        [],
        "f1f8",
        "M135.2 17.7L128 32H32C14.3 32 0 46.3 0 64S14.3 96 32 96H416c17.7 0 32-14.3 32-32s-14.3-32-32-32H320l-7.2-14.3C307.4 6.8 296.3 0 284.2 0H163.8c-12.1 0-23.2 6.8-28.6 17.7zM416 128H32L53.2 467c1.6 25.3 22.6 45 47.9 45H346.9c25.3 0 46.3-19.7 47.9-45L416 128z"
    ]
};
var $d8206b3ab2e65c05$export$f3a0a4e6723a86d4 = {
    prefix: "fas",
    iconName: "gauge-simple",
    icon: [
        512,
        512,
        [
            "gauge-simple-med",
            "tachometer-average"
        ],
        "f629",
        "M0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm320 96c0-26.9-16.5-49.9-40-59.3V88c0-13.3-10.7-24-24-24s-24 10.7-24 24V292.7c-23.5 9.5-40 32.5-40 59.3c0 35.3 28.7 64 64 64s64-28.7 64-64z"
    ]
};
var $d8206b3ab2e65c05$export$ba8c12ff7cfa2521 = $d8206b3ab2e65c05$export$f3a0a4e6723a86d4;
var $d8206b3ab2e65c05$export$94fcfd6f6335431b = $d8206b3ab2e65c05$export$f3a0a4e6723a86d4;
var $d8206b3ab2e65c05$export$6feb44fec53ba30d = {
    prefix: "fas",
    iconName: "book-medical",
    icon: [
        448,
        512,
        [],
        "f7e6",
        "M0 96C0 43 43 0 96 0H384h32c17.7 0 32 14.3 32 32V352c0 17.7-14.3 32-32 32v64c17.7 0 32 14.3 32 32s-14.3 32-32 32H384 96c-53 0-96-43-96-96V96zM64 416c0 17.7 14.3 32 32 32H352V384H96c-17.7 0-32 14.3-32 32zM208 112v48H160c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h48v48c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V224h48c8.8 0 16-7.2 16-16V176c0-8.8-7.2-16-16-16H272V112c0-8.8-7.2-16-16-16H224c-8.8 0-16 7.2-16 16z"
    ]
};
var $d8206b3ab2e65c05$export$dd0ede1713d2d2f9 = {
    prefix: "fas",
    iconName: "poo",
    icon: [
        512,
        512,
        [
            128169
        ],
        "f2fe",
        "M268.9 .9c-5.5-.7-11 1.4-14.5 5.7s-4.6 10.1-2.8 15.4c2.8 8.2 4.3 16.9 4.3 26.1c0 44.1-35.7 79.9-79.8 80H160c-35.3 0-64 28.7-64 64c0 19.1 8.4 36.3 21.7 48H104c-39.8 0-72 32.2-72 72c0 23.2 11 43.8 28 57c-34.1 5.7-60 35.3-60 71c0 39.8 32.2 72 72 72H440c39.8 0 72-32.2 72-72c0-35.7-25.9-65.3-60-71c17-13.2 28-33.8 28-57c0-39.8-32.2-72-72-72H394.3c13.3-11.7 21.7-28.9 21.7-48c0-35.3-28.7-64-64-64h-5.5c3.5-10 5.5-20.8 5.5-32c0-48.6-36.2-88.8-83.1-95.1zM192 256a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm96 32a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm64 108.3c0 2.4-.7 4.8-2.2 6.7c-8.2 10.5-39.5 45-93.8 45s-85.6-34.6-93.8-45c-1.5-1.9-2.2-4.3-2.2-6.7c0-6.8 5.5-12.3 12.3-12.3H339.7c6.8 0 12.3 5.5 12.3 12.3z"
    ]
};
var $d8206b3ab2e65c05$export$54e3a80c9875b74c = {
    prefix: "fas",
    iconName: "quote-right",
    icon: [
        448,
        512,
        [
            8221,
            "quote-right-alt"
        ],
        "f10e",
        "M448 296c0 66.3-53.7 120-120 120h-8c-17.7 0-32-14.3-32-32s14.3-32 32-32h8c30.9 0 56-25.1 56-56v-8H320c-35.3 0-64-28.7-64-64V160c0-35.3 28.7-64 64-64h64c35.3 0 64 28.7 64 64v32 32 72zm-256 0c0 66.3-53.7 120-120 120H64c-17.7 0-32-14.3-32-32s14.3-32 32-32h8c30.9 0 56-25.1 56-56v-8H64c-35.3 0-64-28.7-64-64V160c0-35.3 28.7-64 64-64h64c35.3 0 64 28.7 64 64v32 32 72z"
    ]
};
var $d8206b3ab2e65c05$export$dd692f2e88bd4b1a = $d8206b3ab2e65c05$export$54e3a80c9875b74c;
var $d8206b3ab2e65c05$export$312f2c01c6fedca8 = {
    prefix: "fas",
    iconName: "shirt",
    icon: [
        640,
        512,
        [
            128085,
            "t-shirt",
            "tshirt"
        ],
        "f553",
        "M211.8 0c7.8 0 14.3 5.7 16.7 13.2C240.8 51.9 277.1 80 320 80s79.2-28.1 91.5-66.8C413.9 5.7 420.4 0 428.2 0h12.6c22.5 0 44.2 7.9 61.5 22.3L628.5 127.4c6.6 5.5 10.7 13.5 11.4 22.1s-2.1 17.1-7.8 23.6l-56 64c-11.4 13.1-31.2 14.6-44.6 3.5L480 197.7V448c0 35.3-28.7 64-64 64H224c-35.3 0-64-28.7-64-64V197.7l-51.5 42.9c-13.3 11.1-33.1 9.6-44.6-3.5l-56-64c-5.7-6.5-8.5-15-7.8-23.6s4.8-16.6 11.4-22.1L137.7 22.3C155 7.9 176.7 0 199.2 0h12.6z"
    ]
};
var $d8206b3ab2e65c05$export$144e5f8bc4d705a6 = $d8206b3ab2e65c05$export$312f2c01c6fedca8;
var $d8206b3ab2e65c05$export$36edce3ba87c2b17 = $d8206b3ab2e65c05$export$312f2c01c6fedca8;
var $d8206b3ab2e65c05$export$30523a9441a31e97 = {
    prefix: "fas",
    iconName: "cubes",
    icon: [
        576,
        512,
        [],
        "f1b3",
        "M290.8 48.6l78.4 29.7L288 109.5 206.8 78.3l78.4-29.7c1.8-.7 3.8-.7 5.7 0zM136 92.5V204.7c-1.3 .4-2.6 .8-3.9 1.3l-96 36.4C14.4 250.6 0 271.5 0 294.7V413.9c0 22.2 13.1 42.3 33.5 51.3l96 42.2c14.4 6.3 30.7 6.3 45.1 0L288 457.5l113.5 49.9c14.4 6.3 30.7 6.3 45.1 0l96-42.2c20.3-8.9 33.5-29.1 33.5-51.3V294.7c0-23.3-14.4-44.1-36.1-52.4l-96-36.4c-1.3-.5-2.6-.9-3.9-1.3V92.5c0-23.3-14.4-44.1-36.1-52.4l-96-36.4c-12.8-4.8-26.9-4.8-39.7 0l-96 36.4C150.4 48.4 136 69.3 136 92.5zM392 210.6l-82.4 31.2V152.6L392 121v89.6zM154.8 250.9l78.4 29.7L152 311.7 70.8 280.6l78.4-29.7c1.8-.7 3.8-.7 5.7 0zm18.8 204.4V354.8L256 323.2v95.9l-82.4 36.2zM421.2 250.9c1.8-.7 3.8-.7 5.7 0l78.4 29.7L424 311.7l-81.2-31.1 78.4-29.7zM523.2 421.2l-77.6 34.1V354.8L528 323.2v90.7c0 3.2-1.9 6-4.8 7.3z"
    ]
};
var $d8206b3ab2e65c05$export$89fa217ec5503ac9 = {
    prefix: "fas",
    iconName: "divide",
    icon: [
        448,
        512,
        [
            10135,
            247
        ],
        "f529",
        "M272 96a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zm0 320a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zM400 288c17.7 0 32-14.3 32-32s-14.3-32-32-32H48c-17.7 0-32 14.3-32 32s14.3 32 32 32H400z"
    ]
};
var $d8206b3ab2e65c05$export$c04e864469c1d117 = {
    prefix: "fas",
    iconName: "tenge-sign",
    icon: [
        384,
        512,
        [
            8376,
            "tenge"
        ],
        "f7d7",
        "M0 64C0 46.3 14.3 32 32 32H352c17.7 0 32 14.3 32 32s-14.3 32-32 32H32C14.3 96 0 81.7 0 64zM0 192c0-17.7 14.3-32 32-32H192 352c17.7 0 32 14.3 32 32s-14.3 32-32 32H224V448c0 17.7-14.3 32-32 32s-32-14.3-32-32V224H32c-17.7 0-32-14.3-32-32z"
    ]
};
var $d8206b3ab2e65c05$export$af6ebee83047b793 = $d8206b3ab2e65c05$export$c04e864469c1d117;
var $d8206b3ab2e65c05$export$ad02dd8ca5816958 = {
    prefix: "fas",
    iconName: "headphones",
    icon: [
        512,
        512,
        [
            127911
        ],
        "f025",
        "M256 80C149.9 80 62.4 159.4 49.6 262c9.4-3.8 19.6-6 30.4-6c26.5 0 48 21.5 48 48V432c0 26.5-21.5 48-48 48c-44.2 0-80-35.8-80-80V384 336 288C0 146.6 114.6 32 256 32s256 114.6 256 256v48 48 16c0 44.2-35.8 80-80 80c-26.5 0-48-21.5-48-48V304c0-26.5 21.5-48 48-48c10.8 0 21 2.1 30.4 6C449.6 159.4 362.1 80 256 80z"
    ]
};
var $d8206b3ab2e65c05$export$96891bbcda1dbb7b = {
    prefix: "fas",
    iconName: "hands-holding",
    icon: [
        640,
        512,
        [],
        "f4c2",
        "M80 104c0-22.1-17.9-40-40-40S0 81.9 0 104v56 64V325.5c0 25.5 10.1 49.9 28.1 67.9L128 493.3c12 12 28.3 18.7 45.3 18.7H240c26.5 0 48-21.5 48-48V385.1c0-29.7-11.8-58.2-32.8-79.2l-25.3-25.3 0 0-15.2-15.2-32-32c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3l32 32 15.2 15.2c11 11 9.2 29.2-3.7 37.8c-9.7 6.5-22.7 5.2-31-3.1L98.7 309.5c-12-12-18.7-28.3-18.7-45.3V224 144 104zm480 0v40 80 40.2c0 17-6.7 33.3-18.7 45.3l-51.1 51.1c-8.3 8.3-21.3 9.6-31 3.1c-12.9-8.6-14.7-26.9-3.7-37.8l15.2-15.2 32-32c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0l-32 32-15.2 15.2 0 0-25.3 25.3c-21 21-32.8 49.5-32.8 79.2V464c0 26.5 21.5 48 48 48h66.7c17 0 33.3-6.7 45.3-18.7l99.9-99.9c18-18 28.1-42.4 28.1-67.9V224 160 104c0-22.1-17.9-40-40-40s-40 17.9-40 40z"
    ]
};
var $d8206b3ab2e65c05$export$765c446e974b5e59 = {
    prefix: "fas",
    iconName: "hands-clapping",
    icon: [
        512,
        512,
        [],
        "e1a8",
        "M336 16V80c0 8.8-7.2 16-16 16s-16-7.2-16-16V16c0-8.8 7.2-16 16-16s16 7.2 16 16zm-98.7 7.1l32 48c4.9 7.4 2.9 17.3-4.4 22.2s-17.3 2.9-22.2-4.4l-32-48c-4.9-7.4-2.9-17.3 4.4-22.2s17.3-2.9 22.2 4.4zM135 119c9.4-9.4 24.6-9.4 33.9 0L292.7 242.7c10.1 10.1 27.3 2.9 27.3-11.3V192c0-17.7 14.3-32 32-32s32 14.3 32 32V345.6c0 57.1-30 110-78.9 139.4c-64 38.4-145.8 28.3-198.5-24.4L7 361c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l53 53c6.1 6.1 16 6.1 22.1 0s6.1-16 0-22.1L23 265c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l93 93c6.1 6.1 16 6.1 22.1 0s6.1-16 0-22.1L55 185c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l117 117c6.1 6.1 16 6.1 22.1 0s6.1-16 0-22.1l-93-93c-9.4-9.4-9.4-24.6 0-33.9zM433.1 484.9c-24.2 14.5-50.9 22.1-77.7 23.1c48.1-39.6 76.6-99 76.6-162.4l0-98.1c8.2-.1 16-6.4 16-16V192c0-17.7 14.3-32 32-32s32 14.3 32 32V345.6c0 57.1-30 110-78.9 139.4zM424.9 18.7c7.4 4.9 9.3 14.8 4.4 22.2l-32 48c-4.9 7.4-14.8 9.3-22.2 4.4s-9.3-14.8-4.4-22.2l32-48c4.9-7.4 14.8-9.3 22.2-4.4z"
    ]
};
var $d8206b3ab2e65c05$export$929518bb4b66a588 = {
    prefix: "fas",
    iconName: "republican",
    icon: [
        640,
        512,
        [],
        "f75e",
        "M0 192C0 103.6 71.6 32 160 32H384c88.4 0 160 71.6 160 160v64H0V192zm415.9-64c-2.4 0-4.7 1.3-5.7 3.4l-12.6 24.6-28.2 4c-2.4 .3-4.4 2-5.2 4.2s-.1 4.7 1.6 6.3l20.4 19.2-4.8 27.1c-.4 2.3 .6 4.7 2.5 6s4.6 1.6 6.7 .5l25.2-12.8 25.2 12.8c2.2 1.1 4.8 .9 6.7-.5s3-3.7 2.5-6l-4.8-27.1L466 170.5c1.7-1.6 2.4-4.1 1.6-6.3s-2.8-3.9-5.2-4.2l-28.2-4-12.6-24.6c-1.1-2.1-3.3-3.4-5.7-3.4zm-138.3 3.4c-1.1-2.1-3.3-3.4-5.7-3.4s-4.7 1.3-5.7 3.4l-12.6 24.6-28.2 4c-2.4 .3-4.4 2-5.2 4.2s-.1 4.7 1.6 6.3l20.4 19.2-4.8 27.1c-.4 2.3 .6 4.7 2.5 6s4.6 1.6 6.7 .5l25.2-12.8 25.2 12.8c2.2 1.1 4.8 .9 6.7-.5s3-3.7 2.5-6l-4.8-27.1L322 170.5c1.7-1.6 2.4-4.1 1.6-6.3s-2.8-3.9-5.2-4.2l-28.2-4-12.6-24.6zM127.9 128c-2.4 0-4.7 1.3-5.7 3.4l-12.6 24.6-28.2 4c-2.4 .3-4.4 2-5.2 4.2s-.1 4.7 1.6 6.3l20.4 19.2-4.8 27.1c-.4 2.3 .6 4.7 2.5 6s4.6 1.6 6.7 .5l25.2-12.8 25.2 12.8c2.2 1.1 4.8 .9 6.7-.5s3-3.7 2.5-6l-4.8-27.1L178 170.5c1.7-1.6 2.4-4.1 1.6-6.3s-2.8-3.9-5.2-4.2l-28.2-4-12.6-24.6c-1.1-2.1-3.3-3.4-5.7-3.4zm.1 160H320h96 32 64 32v32 80c0 8.8 7.2 16 16 16s16-7.2 16-16V352c0-17.7 14.3-32 32-32s32 14.3 32 32v48c0 44.2-35.8 80-80 80s-80-35.8-80-80V352H448v32 64c0 17.7-14.3 32-32 32H352c-17.7 0-32-14.3-32-32V384H128v64c0 17.7-14.3 32-32 32H32c-17.7 0-32-14.3-32-32V384 288H128z"
    ]
};
var $d8206b3ab2e65c05$export$b7fac681e7d09400 = {
    prefix: "fas",
    iconName: "arrow-left",
    icon: [
        448,
        512,
        [
            8592
        ],
        "f060",
        "M9.4 233.4c-12.5 12.5-12.5 32.8 0 45.3l160 160c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L109.2 288 416 288c17.7 0 32-14.3 32-32s-14.3-32-32-32l-306.7 0L214.6 118.6c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0l-160 160z"
    ]
};
var $d8206b3ab2e65c05$export$16c9e0374c346c6e = {
    prefix: "fas",
    iconName: "person-circle-xmark",
    icon: [
        576,
        512,
        [],
        "e543",
        "M112 48a48 48 0 1 1 96 0 48 48 0 1 1 -96 0zm40 304V480c0 17.7-14.3 32-32 32s-32-14.3-32-32V256.9L59.4 304.5c-9.1 15.1-28.8 20-43.9 10.9s-20-28.8-10.9-43.9l58.3-97c17.4-28.9 48.6-46.6 82.3-46.6h29.7c33.7 0 64.9 17.7 82.3 46.6l44.9 74.7c-16.1 17.6-28.6 38.5-36.6 61.5c-1.9-1.8-3.5-3.9-4.9-6.3L232 256.9V480c0 17.7-14.3 32-32 32s-32-14.3-32-32V352H152zM432 224a144 144 0 1 1 0 288 144 144 0 1 1 0-288zm59.3 107.3c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0L432 345.4l-36.7-36.7c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6L409.4 368l-36.7 36.7c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0L432 390.6l36.7 36.7c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6L454.6 368l36.7-36.7z"
    ]
};
var $d8206b3ab2e65c05$export$8e90575265a56cfc = {
    prefix: "fas",
    iconName: "ruler",
    icon: [
        512,
        512,
        [
            128207
        ],
        "f545",
        "M177.9 494.1c-18.7 18.7-49.1 18.7-67.9 0L17.9 401.9c-18.7-18.7-18.7-49.1 0-67.9l50.7-50.7 48 48c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6l-48-48 41.4-41.4 48 48c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6l-48-48 41.4-41.4 48 48c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6l-48-48 41.4-41.4 48 48c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6l-48-48 50.7-50.7c18.7-18.7 49.1-18.7 67.9 0l92.1 92.1c18.7 18.7 18.7 49.1 0 67.9L177.9 494.1z"
    ]
};
var $d8206b3ab2e65c05$export$e490f662af4d1c78 = {
    prefix: "fas",
    iconName: "align-left",
    icon: [
        448,
        512,
        [],
        "f036",
        "M288 64c0 17.7-14.3 32-32 32H32C14.3 96 0 81.7 0 64S14.3 32 32 32H256c17.7 0 32 14.3 32 32zm0 256c0 17.7-14.3 32-32 32H32c-17.7 0-32-14.3-32-32s14.3-32 32-32H256c17.7 0 32 14.3 32 32zM0 192c0-17.7 14.3-32 32-32H416c17.7 0 32 14.3 32 32s-14.3 32-32 32H32c-17.7 0-32-14.3-32-32zM448 448c0 17.7-14.3 32-32 32H32c-17.7 0-32-14.3-32-32s14.3-32 32-32H416c17.7 0 32 14.3 32 32z"
    ]
};
var $d8206b3ab2e65c05$export$64bfd48ed353c031 = {
    prefix: "fas",
    iconName: "dice-d6",
    icon: [
        448,
        512,
        [],
        "f6d1",
        "M201 10.3c14.3-7.8 31.6-7.8 46 0L422.3 106c5.1 2.8 8.3 8.2 8.3 14s-3.2 11.2-8.3 14L231.7 238c-4.8 2.6-10.5 2.6-15.3 0L25.7 134c-5.1-2.8-8.3-8.2-8.3-14s3.2-11.2 8.3-14L201 10.3zM23.7 170l176 96c5.1 2.8 8.3 8.2 8.3 14V496c0 5.6-3 10.9-7.8 13.8s-10.9 3-15.8 .3L25 423.1C9.6 414.7 0 398.6 0 381V184c0-5.6 3-10.9 7.8-13.8s10.9-3 15.8-.3zm400.7 0c5-2.7 11-2.6 15.8 .3s7.8 8.1 7.8 13.8V381c0 17.6-9.6 33.7-25 42.1L263.7 510c-5 2.7-11 2.6-15.8-.3s-7.8-8.1-7.8-13.8V280c0-5.9 3.2-11.2 8.3-14l176-96z"
    ]
};
var $d8206b3ab2e65c05$export$5fbcef35138741a5 = {
    prefix: "fas",
    iconName: "restroom",
    icon: [
        640,
        512,
        [],
        "f7bd",
        "M80 48a48 48 0 1 1 96 0A48 48 0 1 1 80 48zm40 304V480c0 17.7-14.3 32-32 32s-32-14.3-32-32V325.2c-8.1 9.2-21.1 13.2-33.5 9.4c-16.9-5.3-26.3-23.2-21-40.1l30.9-99.1C44.9 155.3 82 128 124 128h8c42 0 79.1 27.3 91.6 67.4l30.9 99.1c5.3 16.9-4.1 34.8-21 40.1c-12.4 3.9-25.4-.2-33.5-9.4V480c0 17.7-14.3 32-32 32s-32-14.3-32-32V352H120zM320 0c13.3 0 24 10.7 24 24V488c0 13.3-10.7 24-24 24s-24-10.7-24-24V24c0-13.3 10.7-24 24-24zM464 48a48 48 0 1 1 96 0 48 48 0 1 1 -96 0zM440 480V384H422.2c-10.9 0-18.6-10.7-15.2-21.1l9-26.9c-3.2 0-6.4-.5-9.5-1.5c-16.9-5.3-26.3-23.2-21-40.1l29.7-95.2C428.4 156.9 467.6 128 512 128s83.6 28.9 96.8 71.2l29.7 95.2c5.3 16.9-4.1 34.8-21 40.1c-3.2 1-6.4 1.5-9.5 1.5l9 26.9c3.5 10.4-4.3 21.1-15.2 21.1H584v96c0 17.7-14.3 32-32 32s-32-14.3-32-32V384H504v96c0 17.7-14.3 32-32 32s-32-14.3-32-32z"
    ]
};
var $d8206b3ab2e65c05$export$bbf24078bd1f73e6 = {
    prefix: "fas",
    iconName: "j",
    icon: [
        320,
        512,
        [
            106
        ],
        "4a",
        "M288 32c17.7 0 32 14.3 32 32V320c0 88.4-71.6 160-160 160S0 408.4 0 320V288c0-17.7 14.3-32 32-32s32 14.3 32 32v32c0 53 43 96 96 96s96-43 96-96V64c0-17.7 14.3-32 32-32z"
    ]
};
var $d8206b3ab2e65c05$export$72b785dcfe44c69b = {
    prefix: "fas",
    iconName: "users-viewfinder",
    icon: [
        640,
        512,
        [],
        "e595",
        "M48 48h88c13.3 0 24-10.7 24-24s-10.7-24-24-24H32C14.3 0 0 14.3 0 32V136c0 13.3 10.7 24 24 24s24-10.7 24-24V48zM175.8 224a48 48 0 1 0 0-96 48 48 0 1 0 0 96zm-26.5 32C119.9 256 96 279.9 96 309.3c0 14.7 11.9 26.7 26.7 26.7h56.1c8-34.1 32.8-61.7 65.2-73.6c-7.5-4.1-16.2-6.4-25.3-6.4H149.3zm368 80c14.7 0 26.7-11.9 26.7-26.7c0-29.5-23.9-53.3-53.3-53.3H421.3c-9.2 0-17.8 2.3-25.3 6.4c32.4 11.9 57.2 39.5 65.2 73.6h56.1zm-89.4 0c-8.6-24.3-29.9-42.6-55.9-47c-3.9-.7-7.9-1-12-1H280c-4.1 0-8.1 .3-12 1c-26 4.4-47.3 22.7-55.9 47c-2.7 7.5-4.1 15.6-4.1 24c0 13.3 10.7 24 24 24H408c13.3 0 24-10.7 24-24c0-8.4-1.4-16.5-4.1-24zM464 224a48 48 0 1 0 0-96 48 48 0 1 0 0 96zm-80-32a64 64 0 1 0 -128 0 64 64 0 1 0 128 0zM504 48h88v88c0 13.3 10.7 24 24 24s24-10.7 24-24V32c0-17.7-14.3-32-32-32H504c-13.3 0-24 10.7-24 24s10.7 24 24 24zM48 464V376c0-13.3-10.7-24-24-24s-24 10.7-24 24V480c0 17.7 14.3 32 32 32H136c13.3 0 24-10.7 24-24s-10.7-24-24-24H48zm456 0c-13.3 0-24 10.7-24 24s10.7 24 24 24H608c17.7 0 32-14.3 32-32V376c0-13.3-10.7-24-24-24s-24 10.7-24 24v88H504z"
    ]
};
var $d8206b3ab2e65c05$export$b44eb38345c6a964 = {
    prefix: "fas",
    iconName: "file-video",
    icon: [
        384,
        512,
        [],
        "f1c8",
        "M64 0C28.7 0 0 28.7 0 64V448c0 35.3 28.7 64 64 64H320c35.3 0 64-28.7 64-64V160H256c-17.7 0-32-14.3-32-32V0H64zM256 0V128H384L256 0zM64 288c0-17.7 14.3-32 32-32h96c17.7 0 32 14.3 32 32v96c0 17.7-14.3 32-32 32H96c-17.7 0-32-14.3-32-32V288zM300.9 397.9L256 368V304l44.9-29.9c2-1.3 4.4-2.1 6.8-2.1c6.8 0 12.3 5.5 12.3 12.3V387.7c0 6.8-5.5 12.3-12.3 12.3c-2.4 0-4.8-.7-6.8-2.1z"
    ]
};
var $d8206b3ab2e65c05$export$c1a3ba061b4f60c4 = {
    prefix: "fas",
    iconName: "up-right-from-square",
    icon: [
        512,
        512,
        [
            "external-link-alt"
        ],
        "f35d",
        "M352 0c-12.9 0-24.6 7.8-29.6 19.8s-2.2 25.7 6.9 34.9L370.7 96 201.4 265.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0L416 141.3l41.4 41.4c9.2 9.2 22.9 11.9 34.9 6.9s19.8-16.6 19.8-29.6V32c0-17.7-14.3-32-32-32H352zM80 32C35.8 32 0 67.8 0 112V432c0 44.2 35.8 80 80 80H400c44.2 0 80-35.8 80-80V320c0-17.7-14.3-32-32-32s-32 14.3-32 32V432c0 8.8-7.2 16-16 16H80c-8.8 0-16-7.2-16-16V112c0-8.8 7.2-16 16-16H192c17.7 0 32-14.3 32-32s-14.3-32-32-32H80z"
    ]
};
var $d8206b3ab2e65c05$export$d7f107e456ab0306 = $d8206b3ab2e65c05$export$c1a3ba061b4f60c4;
var $d8206b3ab2e65c05$export$c517dffc18db483f = {
    prefix: "fas",
    iconName: "table-cells",
    icon: [
        512,
        512,
        [
            "th"
        ],
        "f00a",
        "M64 32C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H448c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64zm88 64v64H64V96h88zm56 0h88v64H208V96zm240 0v64H360V96h88zM64 224h88v64H64V224zm232 0v64H208V224h88zm64 0h88v64H360V224zM152 352v64H64V352h88zm56 0h88v64H208V352zm240 0v64H360V352h88z"
    ]
};
var $d8206b3ab2e65c05$export$4d383c83efc0c819 = $d8206b3ab2e65c05$export$c517dffc18db483f;
var $d8206b3ab2e65c05$export$38611f1c776aba73 = {
    prefix: "fas",
    iconName: "file-pdf",
    icon: [
        512,
        512,
        [],
        "f1c1",
        "M0 64C0 28.7 28.7 0 64 0H224V128c0 17.7 14.3 32 32 32H384V304H176c-35.3 0-64 28.7-64 64V512H64c-35.3 0-64-28.7-64-64V64zm384 64H256V0L384 128zM176 352h32c30.9 0 56 25.1 56 56s-25.1 56-56 56H192v32c0 8.8-7.2 16-16 16s-16-7.2-16-16V448 368c0-8.8 7.2-16 16-16zm32 80c13.3 0 24-10.7 24-24s-10.7-24-24-24H192v48h16zm96-80h32c26.5 0 48 21.5 48 48v64c0 26.5-21.5 48-48 48H304c-8.8 0-16-7.2-16-16V368c0-8.8 7.2-16 16-16zm32 128c8.8 0 16-7.2 16-16V400c0-8.8-7.2-16-16-16H320v96h16zm80-112c0-8.8 7.2-16 16-16h48c8.8 0 16 7.2 16 16s-7.2 16-16 16H448v32h32c8.8 0 16 7.2 16 16s-7.2 16-16 16H448v48c0 8.8-7.2 16-16 16s-16-7.2-16-16V432 368z"
    ]
};
var $d8206b3ab2e65c05$export$df8194b081d34b27 = {
    prefix: "fas",
    iconName: "book-bible",
    icon: [
        448,
        512,
        [
            "bible"
        ],
        "f647",
        "M96 0C43 0 0 43 0 96V416c0 53 43 96 96 96H384h32c17.7 0 32-14.3 32-32s-14.3-32-32-32V384c17.7 0 32-14.3 32-32V32c0-17.7-14.3-32-32-32H384 96zm0 384H352v64H96c-17.7 0-32-14.3-32-32s14.3-32 32-32zM208 80c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v48h48c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H272V304c0 8.8-7.2 16-16 16H224c-8.8 0-16-7.2-16-16V192H160c-8.8 0-16-7.2-16-16V144c0-8.8 7.2-16 16-16h48V80z"
    ]
};
var $d8206b3ab2e65c05$export$2eac809b0670d139 = $d8206b3ab2e65c05$export$df8194b081d34b27;
var $d8206b3ab2e65c05$export$9db87eabf605857e = {
    prefix: "fas",
    iconName: "o",
    icon: [
        448,
        512,
        [
            111
        ],
        "4f",
        "M224 96a160 160 0 1 0 0 320 160 160 0 1 0 0-320zM448 256A224 224 0 1 1 0 256a224 224 0 1 1 448 0z"
    ]
};
var $d8206b3ab2e65c05$export$25ea11267429d202 = {
    prefix: "fas",
    iconName: "suitcase-medical",
    icon: [
        512,
        512,
        [
            "medkit"
        ],
        "f0fa",
        "M184 48H328c4.4 0 8 3.6 8 8V96H176V56c0-4.4 3.6-8 8-8zm-56 8V96v32V480H384V128 96 56c0-30.9-25.1-56-56-56H184c-30.9 0-56 25.1-56 56zM96 96H64C28.7 96 0 124.7 0 160V416c0 35.3 28.7 64 64 64H96V96zM416 480h32c35.3 0 64-28.7 64-64V160c0-35.3-28.7-64-64-64H416V480zM224 208c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v48h48c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H288v48c0 8.8-7.2 16-16 16H240c-8.8 0-16-7.2-16-16V320H176c-8.8 0-16-7.2-16-16V272c0-8.8 7.2-16 16-16h48V208z"
    ]
};
var $d8206b3ab2e65c05$export$e75f02bae5b7d34b = $d8206b3ab2e65c05$export$25ea11267429d202;
var $d8206b3ab2e65c05$export$597826232327559b = {
    prefix: "fas",
    iconName: "user-secret",
    icon: [
        448,
        512,
        [
            128373
        ],
        "f21b",
        "M224 16c-6.7 0-10.8-2.8-15.5-6.1C201.9 5.4 194 0 176 0c-30.5 0-52 43.7-66 89.4C62.7 98.1 32 112.2 32 128c0 14.3 25 27.1 64.6 35.9c-.4 4-.6 8-.6 12.1c0 17 3.3 33.2 9.3 48H45.4C38 224 32 230 32 237.4c0 1.7 .3 3.4 1 5l38.8 96.9C28.2 371.8 0 423.8 0 482.3C0 498.7 13.3 512 29.7 512H418.3c16.4 0 29.7-13.3 29.7-29.7c0-58.5-28.2-110.4-71.7-143L415 242.4c.6-1.6 1-3.3 1-5c0-7.4-6-13.4-13.4-13.4H342.7c6-14.8 9.3-31 9.3-48c0-4.1-.2-8.1-.6-12.1C391 155.1 416 142.3 416 128c0-15.8-30.7-29.9-78-38.6C324 43.7 302.5 0 272 0c-18 0-25.9 5.4-32.5 9.9c-4.8 3.3-8.8 6.1-15.5 6.1zm56 208H267.6c-16.5 0-31.1-10.6-36.3-26.2c-2.3-7-12.2-7-14.5 0c-5.2 15.6-19.9 26.2-36.3 26.2H168c-22.1 0-40-17.9-40-40V169.6c28.2 4.1 61 6.4 96 6.4s67.8-2.3 96-6.4V184c0 22.1-17.9 40-40 40zm-88 96l16 32L176 480 128 288l64 32zm128-32L272 480 240 352l16-32 64-32z"
    ]
};
var $d8206b3ab2e65c05$export$743cce3ca4eb1d7d = {
    prefix: "fas",
    iconName: "otter",
    icon: [
        640,
        512,
        [
            129446
        ],
        "f700",
        "M181.5 197.1l12.9 6.4c5.9 3 12.4 4.5 19.1 4.5c23.5 0 42.6-19.1 42.6-42.6V144c0-35.3-28.7-64-64-64H128c-35.3 0-64 28.7-64 64v21.4c0 23.5 19.1 42.6 42.6 42.6c6.6 0 13.1-1.5 19.1-4.5l12.9-6.4 8.4-4.2L135.1 185c-4.5-3-7.1-8-7.1-13.3V168c0-13.3 10.7-24 24-24h16c13.3 0 24 10.7 24 24v3.7c0 5.3-2.7 10.3-7.1 13.3l-11.8 7.9 8.4 4.2zm-8.6 49.4L160 240l-12.9 6.4c-12.6 6.3-26.5 9.6-40.5 9.6c-3.6 0-7.1-.2-10.6-.6v.6c0 35.3 28.7 64 64 64h64c17.7 0 32 14.3 32 32s-14.3 32-32 32H384V336 320c0-23.7 12.9-44.4 32-55.4c9.4-5.4 20.3-8.6 32-8.6V240c0-26.5 21.5-48 48-48c8.8 0 16 7.2 16 16v32 16 48c0 8.8 7.2 16 16 16s16-7.2 16-16V204.3c0-48.2-30.8-91-76.6-106.3l-8.5-2.8c-8-2.7-12.6-11.1-10.4-19.3s10.3-13.2 18.6-11.6l19.9 4C576 86.1 640 164.2 640 254.9l0 1.1h0c0 123.7-100.3 224-224 224h-1.1H256h-.6C132 480 32 380 32 256.6V256 216.8c-10.1-14.6-16-32.3-16-51.4V144l0-1.4C6.7 139.3 0 130.5 0 120c0-13.3 10.7-24 24-24h2.8C44.8 58.2 83.3 32 128 32h64c44.7 0 83.2 26.2 101.2 64H296c13.3 0 24 10.7 24 24c0 10.5-6.7 19.3-16 22.6l0 1.4v21.4c0 1.4 0 2.8-.1 4.3c12-6.2 25.7-9.6 40.1-9.6h8c17.7 0 32 14.3 32 32s-14.3 32-32 32h-8c-13.3 0-24 10.7-24 24v8h56.4c-15.2 17-24.4 39.4-24.4 64H320c-42.3 0-78.2-27.4-91-65.3c-5.1 .9-10.3 1.3-15.6 1.3c-14.1 0-27.9-3.3-40.5-9.6zM96 128a16 16 0 1 1 0 32 16 16 0 1 1 0-32zm112 16a16 16 0 1 1 32 0 16 16 0 1 1 -32 0z"
    ]
};
var $d8206b3ab2e65c05$export$27f7383b96c3f4b4 = {
    prefix: "fas",
    iconName: "person-dress",
    icon: [
        320,
        512,
        [
            "female"
        ],
        "f182",
        "M160 0a48 48 0 1 1 0 96 48 48 0 1 1 0-96zM88 384H70.2c-10.9 0-18.6-10.7-15.2-21.1L93.3 248.1 59.4 304.5c-9.1 15.1-28.8 20-43.9 10.9s-20-28.8-10.9-43.9l53.6-89.2c20.3-33.7 56.7-54.3 96-54.3h11.6c39.3 0 75.7 20.6 96 54.3l53.6 89.2c9.1 15.1 4.2 34.8-10.9 43.9s-34.8 4.2-43.9-10.9l-33.9-56.3L265 362.9c3.5 10.4-4.3 21.1-15.2 21.1H232v96c0 17.7-14.3 32-32 32s-32-14.3-32-32V384H152v96c0 17.7-14.3 32-32 32s-32-14.3-32-32V384z"
    ]
};
var $d8206b3ab2e65c05$export$70e8e75e61dd7169 = $d8206b3ab2e65c05$export$27f7383b96c3f4b4;
var $d8206b3ab2e65c05$export$7a088030853df12c = {
    prefix: "fas",
    iconName: "comment-dollar",
    icon: [
        512,
        512,
        [],
        "f651",
        "M256 448c141.4 0 256-93.1 256-208S397.4 32 256 32S0 125.1 0 240c0 45.1 17.7 86.8 47.7 120.9c-1.9 24.5-11.4 46.3-21.4 62.9c-5.5 9.2-11.1 16.6-15.2 21.6c-2.1 2.5-3.7 4.4-4.9 5.7c-.6 .6-1 1.1-1.3 1.4l-.3 .3 0 0 0 0 0 0 0 0c-4.6 4.6-5.9 11.4-3.4 17.4c2.5 6 8.3 9.9 14.8 9.9c28.7 0 57.6-8.9 81.6-19.3c22.9-10 42.4-21.9 54.3-30.6c31.8 11.5 67 17.9 104.1 17.9zm20-312v13.9c7.5 1.2 14.6 2.9 21.1 4.7c10.7 2.8 17 13.8 14.2 24.5s-13.8 17-24.5 14.2c-11-2.9-21.6-5-31.2-5.2c-7.9-.1-16 1.8-21.5 5c-4.8 2.8-6.2 5.6-6.2 9.3c0 1.8 .1 3.5 5.3 6.7c6.3 3.8 15.5 6.7 28.3 10.5l.7 .2c11.2 3.4 25.6 7.7 37.1 15c12.9 8.1 24.3 21.3 24.6 41.6c.3 20.9-10.5 36.1-24.8 45c-7.2 4.5-15.2 7.3-23.2 9V344c0 11-9 20-20 20s-20-9-20-20V329.4c-10.3-2.2-20-5.5-28.2-8.4l0 0 0 0c-2.1-.7-4.1-1.4-6.1-2.1c-10.5-3.5-16.1-14.8-12.6-25.3s14.8-16.1 25.3-12.6c2.5 .8 4.9 1.7 7.2 2.4c13.6 4.6 24 8.1 35.1 8.5c8.6 .3 16.5-1.6 21.4-4.7c4.1-2.5 6-5.5 5.9-10.5c0-2.9-.8-5-5.9-8.2c-6.3-4-15.4-6.9-28-10.7l-1.7-.5c-10.9-3.3-24.6-7.4-35.6-14c-12.7-7.7-24.6-20.5-24.7-40.7c-.1-21.1 11.8-35.7 25.8-43.9c6.9-4.1 14.5-6.8 22.2-8.5V136c0-11 9-20 20-20s20 9 20 20z"
    ]
};
var $d8206b3ab2e65c05$export$694b7e88782dec12 = {
    prefix: "fas",
    iconName: "business-time",
    icon: [
        640,
        512,
        [
            "briefcase-clock"
        ],
        "f64a",
        "M184 48H328c4.4 0 8 3.6 8 8V96H176V56c0-4.4 3.6-8 8-8zm-56 8V96H64C28.7 96 0 124.7 0 160v96H192 352h8.2c32.3-39.1 81.1-64 135.8-64c5.4 0 10.7 .2 16 .7V160c0-35.3-28.7-64-64-64H384V56c0-30.9-25.1-56-56-56H184c-30.9 0-56 25.1-56 56zM320 352H224c-17.7 0-32-14.3-32-32V288H0V416c0 35.3 28.7 64 64 64H360.2C335.1 449.6 320 410.5 320 368c0-5.4 .2-10.7 .7-16l-.7 0zm320 16a144 144 0 1 0 -288 0 144 144 0 1 0 288 0zM496 288c8.8 0 16 7.2 16 16v48h32c8.8 0 16 7.2 16 16s-7.2 16-16 16H496c-8.8 0-16-7.2-16-16V304c0-8.8 7.2-16 16-16z"
    ]
};
var $d8206b3ab2e65c05$export$8b00ae94743552ce = $d8206b3ab2e65c05$export$694b7e88782dec12;
var $d8206b3ab2e65c05$export$d2bcaf492dfb3817 = {
    prefix: "fas",
    iconName: "table-cells-large",
    icon: [
        512,
        512,
        [
            "th-large"
        ],
        "f009",
        "M448 96V224H288V96H448zm0 192V416H288V288H448zM224 224H64V96H224V224zM64 288H224V416H64V288zM64 32C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H448c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64z"
    ]
};
var $d8206b3ab2e65c05$export$69782f333e90cdc6 = $d8206b3ab2e65c05$export$d2bcaf492dfb3817;
var $d8206b3ab2e65c05$export$24c764717169f536 = {
    prefix: "fas",
    iconName: "book-tanakh",
    icon: [
        448,
        512,
        [
            "tanakh"
        ],
        "f827",
        "M352 0c53 0 96 43 96 96V416c0 53-43 96-96 96H64 32c-17.7 0-32-14.3-32-32s14.3-32 32-32V384c-17.7 0-32-14.3-32-32V32C0 14.3 14.3 0 32 0H64 352zm0 384H96v64H352c17.7 0 32-14.3 32-32s-14.3-32-32-32zM138.7 208l13.9 24H124.9l13.9-24zm-13.9-24L97.1 232c-6.2 10.7 1.5 24 13.9 24h55.4l27.7 48c6.2 10.7 21.6 10.7 27.7 0l27.7-48H305c12.3 0 20-13.3 13.9-24l-27.7-48 27.7-48c6.2-10.7-1.5-24-13.9-24H249.6L221.9 64c-6.2-10.7-21.6-10.7-27.7 0l-27.7 48H111c-12.3 0-20 13.3-13.9 24l27.7 48zm27.7 0l27.7-48h55.4l27.7 48-27.7 48H180.3l-27.7-48zm0-48l-13.9 24-13.9-24h27.7zm41.6-24L208 88l13.9 24H194.1zm69.3 24h27.7l-13.9 24-13.9-24zm13.9 72l13.9 24H263.4l13.9-24zm-55.4 48L208 280l-13.9-24h27.7z"
    ]
};
var $d8206b3ab2e65c05$export$7fd4a58929315448 = $d8206b3ab2e65c05$export$24c764717169f536;
var $d8206b3ab2e65c05$export$c377f240bb8b5d74 = {
    prefix: "fas",
    iconName: "phone-volume",
    icon: [
        512,
        512,
        [
            "volume-control-phone"
        ],
        "f2a0",
        "M280 0C408.1 0 512 103.9 512 232c0 13.3-10.7 24-24 24s-24-10.7-24-24c0-101.6-82.4-184-184-184c-13.3 0-24-10.7-24-24s10.7-24 24-24zm8 192a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm-32-72c0-13.3 10.7-24 24-24c75.1 0 136 60.9 136 136c0 13.3-10.7 24-24 24s-24-10.7-24-24c0-48.6-39.4-88-88-88c-13.3 0-24-10.7-24-24zM117.5 1.4c19.4-5.3 39.7 4.6 47.4 23.2l40 96c6.8 16.3 2.1 35.2-11.6 46.3L144 207.3c33.3 70.4 90.3 127.4 160.7 160.7L345 318.7c11.2-13.7 30-18.4 46.3-11.6l96 40c18.6 7.7 28.5 28 23.2 47.4l-24 88C481.8 499.9 466 512 448 512C200.6 512 0 311.4 0 64C0 46 12.1 30.2 29.5 25.4l88-24z"
    ]
};
var $d8206b3ab2e65c05$export$5358d004fa3d3be2 = $d8206b3ab2e65c05$export$c377f240bb8b5d74;
var $d8206b3ab2e65c05$export$ab6f71fd6878da90 = {
    prefix: "fas",
    iconName: "hat-cowboy-side",
    icon: [
        640,
        512,
        [],
        "f8c1",
        "M152.7 135.9l-10.4 57.2c6.8-.7 13.6-1.1 20.5-1.1h10.7c39.4 0 77.8 12.1 110.1 34.7L562.4 421.8l35.1 24.6c24.4-6 42.5-28.1 42.5-54.4c0-75.8-94.7-126.6-134.6-144.7L474 83.9C468.2 53.8 441.8 32 411.1 32h-2.7c-5.6 0-11.1 .7-16.5 2.2L199.2 85.5c-23.9 6.4-42 26-46.5 50.4zM0 384c0 35.3 28.7 64 64 64H544L265.3 252.9c-26.9-18.8-58.9-28.9-91.8-28.9H162.9c-60.6 0-116 34.2-143.1 88.4L13.5 325C4.6 342.7 0 362.3 0 382.2V384z"
    ]
};
var $d8206b3ab2e65c05$export$1204f2d171424659 = {
    prefix: "fas",
    iconName: "clipboard-user",
    icon: [
        384,
        512,
        [],
        "f7f3",
        "M192 0c-41.8 0-77.4 26.7-90.5 64H64C28.7 64 0 92.7 0 128V448c0 35.3 28.7 64 64 64H320c35.3 0 64-28.7 64-64V128c0-35.3-28.7-64-64-64H282.5C269.4 26.7 233.8 0 192 0zm0 64a32 32 0 1 1 0 64 32 32 0 1 1 0-64zM128 256a64 64 0 1 1 128 0 64 64 0 1 1 -128 0zM80 432c0-44.2 35.8-80 80-80h64c44.2 0 80 35.8 80 80c0 8.8-7.2 16-16 16H96c-8.8 0-16-7.2-16-16z"
    ]
};
var $d8206b3ab2e65c05$export$60b41e3581d1739a = {
    prefix: "fas",
    iconName: "child",
    icon: [
        320,
        512,
        [],
        "f1ae",
        "M96 64a64 64 0 1 1 128 0A64 64 0 1 1 96 64zm48 320v96c0 17.7-14.3 32-32 32s-32-14.3-32-32V287.8L59.1 321c-9.4 15-29.2 19.4-44.1 10S-4.5 301.9 4.9 287l39.9-63.3C69.7 184 113.2 160 160 160s90.3 24 115.2 63.6L315.1 287c9.4 15 4.9 34.7-10 44.1s-34.7 4.9-44.1-10L240 287.8V480c0 17.7-14.3 32-32 32s-32-14.3-32-32V384H144z"
    ]
};
var $d8206b3ab2e65c05$export$f0f37dbc60110b10 = {
    prefix: "fas",
    iconName: "lira-sign",
    icon: [
        320,
        512,
        [
            8356
        ],
        "f195",
        "M112 160.4c0-35.5 28.8-64.4 64.4-64.4c6.9 0 13.8 1.1 20.4 3.3l81.2 27.1c16.8 5.6 34.9-3.5 40.5-20.2s-3.5-34.9-20.2-40.5L217 38.6c-13.1-4.4-26.8-6.6-40.6-6.6C105.5 32 48 89.5 48 160.4V192H32c-17.7 0-32 14.3-32 32s14.3 32 32 32H48v32H32c-17.7 0-32 14.3-32 32s14.3 32 32 32H46c-2.2 10.5-6.1 20.6-11.7 29.9L4.6 431.5c-5.9 9.9-6.1 22.2-.4 32.2S20.5 480 32 480H288c17.7 0 32-14.3 32-32s-14.3-32-32-32H88.5l.7-1.1c11.6-19.3 18.9-40.7 21.6-62.9H224c17.7 0 32-14.3 32-32s-14.3-32-32-32H112V256H224c17.7 0 32-14.3 32-32s-14.3-32-32-32H112V160.4z"
    ]
};
var $d8206b3ab2e65c05$export$da3f1730d013e224 = {
    prefix: "fas",
    iconName: "satellite",
    icon: [
        512,
        512,
        [
            128752
        ],
        "f7bf",
        "M233 7c-9.4-9.4-24.6-9.4-33.9 0l-96 96c-9.4 9.4-9.4 24.6 0 33.9l89.4 89.4-15.5 15.5C152.3 230.4 124.9 224 96 224c-31.7 0-61.5 7.7-87.8 21.2c-9 4.7-10.3 16.7-3.1 23.8L112.7 376.7 96.3 393.1c-2.6-.7-5.4-1.1-8.3-1.1c-17.7 0-32 14.3-32 32s14.3 32 32 32s32-14.3 32-32c0-2.9-.4-5.6-1.1-8.3l16.4-16.4L242.9 506.9c7.2 7.2 19.2 5.9 23.8-3.1C280.3 477.5 288 447.7 288 416c0-28.9-6.4-56.3-17.8-80.9l15.5-15.5L375 409c9.4 9.4 24.6 9.4 33.9 0l96-96c9.4-9.4 9.4-24.6 0-33.9l-89.4-89.4 55-55c12.5-12.5 12.5-32.8 0-45.3l-48-48c-12.5-12.5-32.8-12.5-45.3 0l-55 55L233 7zm159 351l-72.4-72.4 62.1-62.1L454.1 296 392 358.1zM226.3 192.4L153.9 120 216 57.9l72.4 72.4-62.1 62.1z"
    ]
};
var $d8206b3ab2e65c05$export$1125ac57be52258c = {
    prefix: "fas",
    iconName: "plane-lock",
    icon: [
        640,
        512,
        [],
        "e558",
        "M192 93.7C192 59.5 221 0 256 0c36 0 64 59.5 64 93.7v84.6l101.8 58.2C418 247.6 416 259.6 416 272v24.6c-17.9 10.4-30.3 29.1-31.8 50.9L320 329.1V400l57.6 43.2c4 3 6.4 7.8 6.4 12.8v24 18c0 7.8-6.3 14-14 14c-1.3 0-2.6-.2-3.9-.5L256 480 145.9 511.5c-1.3 .4-2.6 .5-3.9 .5c-7.8 0-14-6.3-14-14V456c0-5 2.4-9.8 6.4-12.8L192 400l0-70.9-171.6 49C10.2 381.1 0 373.4 0 362.8V297.3c0-5.7 3.1-11 8.1-13.9L192 178.3V93.7zM528 240c-17.7 0-32 14.3-32 32v48h64V272c0-17.7-14.3-32-32-32zm-80 32c0-44.2 35.8-80 80-80s80 35.8 80 80v48c17.7 0 32 14.3 32 32V480c0 17.7-14.3 32-32 32H448c-17.7 0-32-14.3-32-32V352c0-17.7 14.3-32 32-32V272z"
    ]
};
var $d8206b3ab2e65c05$export$cb61f447f29887e = {
    prefix: "fas",
    iconName: "tag",
    icon: [
        448,
        512,
        [
            127991
        ],
        "f02b",
        "M0 80V229.5c0 17 6.7 33.3 18.7 45.3l176 176c25 25 65.5 25 90.5 0L418.7 317.3c25-25 25-65.5 0-90.5l-176-176c-12-12-28.3-18.7-45.3-18.7H48C21.5 32 0 53.5 0 80zm112 32a32 32 0 1 1 0 64 32 32 0 1 1 0-64z"
    ]
};
var $d8206b3ab2e65c05$export$805cd88398a70581 = {
    prefix: "fas",
    iconName: "comment",
    icon: [
        512,
        512,
        [
            128489,
            61669
        ],
        "f075",
        "M512 240c0 114.9-114.6 208-256 208c-37.1 0-72.3-6.4-104.1-17.9c-11.9 8.7-31.3 20.6-54.3 30.6C73.6 471.1 44.7 480 16 480c-6.5 0-12.3-3.9-14.8-9.9c-2.5-6-1.1-12.8 3.4-17.4l0 0 0 0 0 0 0 0 .3-.3c.3-.3 .7-.7 1.3-1.4c1.1-1.2 2.8-3.1 4.9-5.7c4.1-5 9.6-12.4 15.2-21.6c10-16.6 19.5-38.4 21.4-62.9C17.7 326.8 0 285.1 0 240C0 125.1 114.6 32 256 32s256 93.1 256 208z"
    ]
};
var $d8206b3ab2e65c05$export$e4019fe302a972e1 = {
    prefix: "fas",
    iconName: "cake-candles",
    icon: [
        448,
        512,
        [
            127874,
            "birthday-cake",
            "cake"
        ],
        "f1fd",
        "M86.4 5.5L61.8 47.6C58 54.1 56 61.6 56 69.2V72c0 22.1 17.9 40 40 40s40-17.9 40-40V69.2c0-7.6-2-15-5.8-21.6L105.6 5.5C103.6 2.1 100 0 96 0s-7.6 2.1-9.6 5.5zm128 0L189.8 47.6c-3.8 6.5-5.8 14-5.8 21.6V72c0 22.1 17.9 40 40 40s40-17.9 40-40V69.2c0-7.6-2-15-5.8-21.6L233.6 5.5C231.6 2.1 228 0 224 0s-7.6 2.1-9.6 5.5zM317.8 47.6c-3.8 6.5-5.8 14-5.8 21.6V72c0 22.1 17.9 40 40 40s40-17.9 40-40V69.2c0-7.6-2-15-5.8-21.6L361.6 5.5C359.6 2.1 356 0 352 0s-7.6 2.1-9.6 5.5L317.8 47.6zM128 176c0-17.7-14.3-32-32-32s-32 14.3-32 32v48c-35.3 0-64 28.7-64 64v71c8.3 5.2 18.1 9 28.8 9c13.5 0 27.2-6.1 38.4-13.4c5.4-3.5 9.9-7.1 13-9.7c1.5-1.3 2.7-2.4 3.5-3.1c.4-.4 .7-.6 .8-.8l.1-.1 0 0 0 0s0 0 0 0s0 0 0 0c3.1-3.2 7.4-4.9 11.9-4.8s8.6 2.1 11.6 5.4l0 0 0 0 .1 .1c.1 .1 .4 .4 .7 .7c.7 .7 1.7 1.7 3.1 3c2.8 2.6 6.8 6.1 11.8 9.5c10.2 7.1 23 13.1 36.3 13.1s26.1-6 36.3-13.1c5-3.5 9-6.9 11.8-9.5c1.4-1.3 2.4-2.3 3.1-3c.3-.3 .6-.6 .7-.7l.1-.1c3-3.5 7.4-5.4 12-5.4s9 2 12 5.4l.1 .1c.1 .1 .4 .4 .7 .7c.7 .7 1.7 1.7 3.1 3c2.8 2.6 6.8 6.1 11.8 9.5c10.2 7.1 23 13.1 36.3 13.1s26.1-6 36.3-13.1c5-3.5 9-6.9 11.8-9.5c1.4-1.3 2.4-2.3 3.1-3c.3-.3 .6-.6 .7-.7l.1-.1c2.9-3.4 7.1-5.3 11.6-5.4s8.7 1.6 11.9 4.8l0 0 0 0 0 0 .1 .1c.2 .2 .4 .4 .8 .8c.8 .7 1.9 1.8 3.5 3.1c3.1 2.6 7.5 6.2 13 9.7c11.2 7.3 24.9 13.4 38.4 13.4c10.7 0 20.5-3.9 28.8-9V288c0-35.3-28.7-64-64-64V176c0-17.7-14.3-32-32-32s-32 14.3-32 32v48H256V176c0-17.7-14.3-32-32-32s-32 14.3-32 32v48H128V176zM448 394.6c-8.5 3.3-18.2 5.4-28.8 5.4c-22.5 0-42.4-9.9-55.8-18.6c-4.1-2.7-7.8-5.4-10.9-7.8c-2.8 2.4-6.1 5-9.8 7.5C329.8 390 310.6 400 288 400s-41.8-10-54.6-18.9c-3.5-2.4-6.7-4.9-9.4-7.2c-2.7 2.3-5.9 4.7-9.4 7.2C201.8 390 182.6 400 160 400s-41.8-10-54.6-18.9c-3.7-2.6-7-5.2-9.8-7.5c-3.1 2.4-6.8 5.1-10.9 7.8C71.2 390.1 51.3 400 28.8 400c-10.6 0-20.3-2.2-28.8-5.4V480c0 17.7 14.3 32 32 32H416c17.7 0 32-14.3 32-32V394.6z"
    ]
};
var $d8206b3ab2e65c05$export$bdcf98f725a7241a = $d8206b3ab2e65c05$export$e4019fe302a972e1;
var $d8206b3ab2e65c05$export$707bc1c80c0177c1 = $d8206b3ab2e65c05$export$e4019fe302a972e1;
var $d8206b3ab2e65c05$export$6f095630677adc = {
    prefix: "fas",
    iconName: "envelope",
    icon: [
        512,
        512,
        [
            128386,
            9993,
            61443
        ],
        "f0e0",
        "M48 64C21.5 64 0 85.5 0 112c0 15.1 7.1 29.3 19.2 38.4L236.8 313.6c11.4 8.5 27 8.5 38.4 0L492.8 150.4c12.1-9.1 19.2-23.3 19.2-38.4c0-26.5-21.5-48-48-48H48zM0 176V384c0 35.3 28.7 64 64 64H448c35.3 0 64-28.7 64-64V176L294.4 339.2c-22.8 17.1-54 17.1-76.8 0L0 176z"
    ]
};
var $d8206b3ab2e65c05$export$152ef92a4f9d80a7 = {
    prefix: "fas",
    iconName: "angles-up",
    icon: [
        448,
        512,
        [
            "angle-double-up"
        ],
        "f102",
        "M246.6 41.4c-12.5-12.5-32.8-12.5-45.3 0l-160 160c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0L224 109.3 361.4 246.6c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3l-160-160zm160 352l-160-160c-12.5-12.5-32.8-12.5-45.3 0l-160 160c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0L224 301.3 361.4 438.6c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3z"
    ]
};
var $d8206b3ab2e65c05$export$9bb51e1a2c07db7c = $d8206b3ab2e65c05$export$152ef92a4f9d80a7;
var $d8206b3ab2e65c05$export$4b24ca1552f410af = {
    prefix: "fas",
    iconName: "paperclip",
    icon: [
        448,
        512,
        [
            128206
        ],
        "f0c6",
        "M364.2 83.8c-24.4-24.4-64-24.4-88.4 0l-184 184c-42.1 42.1-42.1 110.3 0 152.4s110.3 42.1 152.4 0l152-152c10.9-10.9 28.7-10.9 39.6 0s10.9 28.7 0 39.6l-152 152c-64 64-167.6 64-231.6 0s-64-167.6 0-231.6l184-184c46.3-46.3 121.3-46.3 167.6 0s46.3 121.3 0 167.6l-176 176c-28.6 28.6-75 28.6-103.6 0s-28.6-75 0-103.6l144-144c10.9-10.9 28.7-10.9 39.6 0s10.9 28.7 0 39.6l-144 144c-6.7 6.7-6.7 17.7 0 24.4s17.7 6.7 24.4 0l176-176c24.4-24.4 24.4-64 0-88.4z"
    ]
};
var $d8206b3ab2e65c05$export$e201217e5046cd15 = {
    prefix: "fas",
    iconName: "arrow-right-to-city",
    icon: [
        640,
        512,
        [],
        "e4b3",
        "M288 48c0-26.5 21.5-48 48-48h96c26.5 0 48 21.5 48 48V192h40V120c0-13.3 10.7-24 24-24s24 10.7 24 24v72h24c26.5 0 48 21.5 48 48V464c0 26.5-21.5 48-48 48H432 336c-26.5 0-48-21.5-48-48V48zm64 32v32c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V80c0-8.8-7.2-16-16-16H368c-8.8 0-16 7.2-16 16zm16 80c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V176c0-8.8-7.2-16-16-16H368zM352 272v32c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V272c0-8.8-7.2-16-16-16H368c-8.8 0-16 7.2-16 16zm176-16c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V272c0-8.8-7.2-16-16-16H528zM512 368v32c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V368c0-8.8-7.2-16-16-16H528c-8.8 0-16 7.2-16 16zM166.6 153.4l80 80c12.5 12.5 12.5 32.8 0 45.3l-80 80c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3L146.7 288H32c-17.7 0-32-14.3-32-32s14.3-32 32-32H146.7l-25.4-25.4c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0z"
    ]
};
var $d8206b3ab2e65c05$export$838459d11f3971df = {
    prefix: "fas",
    iconName: "ribbon",
    icon: [
        448,
        512,
        [
            127895
        ],
        "f4d6",
        "M333.2 322.8l0 0-133.9-146 0 0L146 118.6c7.8-5.1 37-22.6 78-22.6s70.2 17.4 78 22.6L245.7 180l85.6 93.4 27.4-29.8c16.3-17.7 25.3-40.9 25.3-65V149.1c0-19-5.6-37.5-16.1-53.3L327.8 35.6C312.9 13.4 287.9 0 261.2 0h-76c-25.8 0-50.1 12.5-65.1 33.5L81.9 87C70.3 103.2 64 122.8 64 142.8V164c0 23.2 8.4 45.6 23.6 63.1l56 64.2 0 0 83.3 95.6 0 0 91.8 105.3c10 11.5 26.8 14.3 40 6.8l54.5-31.1c17.8-10.2 21.6-34.3 7.7-49.4l-87.7-95.7zM205.2 410.6l-83.3-95.6L27.1 418.5c-13.9 15.1-10.1 39.2 7.7 49.4l55.1 31.5c13 7.4 29.3 4.9 39.4-6.1l75.9-82.6z"
    ]
};
var $d8206b3ab2e65c05$export$ba9b387e84727819 = {
    prefix: "fas",
    iconName: "lungs",
    icon: [
        640,
        512,
        [
            129729
        ],
        "f604",
        "M320 0c17.7 0 32 14.3 32 32V164.1c0 16.4 8.4 31.7 22.2 40.5l9.8 6.2V165.3C384 127 415 96 453.3 96c21.7 0 42.8 10.2 55.8 28.8c15.4 22.1 44.3 65.4 71 116.9c26.5 50.9 52.4 112.5 59.6 170.3c.2 1.3 .2 2.6 .2 4v7c0 49.1-39.8 89-89 89c-7.3 0-14.5-.9-21.6-2.7l-72.7-18.2C414 480.5 384 442.1 384 398V325l90.5 57.6c7.5 4.7 17.3 2.5 22.1-4.9s2.5-17.3-4.9-22.1L384 287.1v-.4l-44.1-28.1c-7.3-4.6-13.9-10.1-19.9-16.1c-5.9 6-12.6 11.5-19.9 16.1L256 286.7 161.2 347l-13.5 8.6c0 0 0 0-.1 0c-7.4 4.8-9.6 14.6-4.8 22.1c4.7 7.5 14.6 9.7 22.1 4.9l91.1-58V398c0 44.1-30 82.5-72.7 93.1l-72.7 18.2c-7.1 1.8-14.3 2.7-21.6 2.7c-49.1 0-89-39.8-89-89v-7c0-1.3 .1-2.7 .2-4c7.2-57.9 33.1-119.4 59.6-170.3c26.8-51.5 55.6-94.8 71-116.9c13-18.6 34-28.8 55.8-28.8C225 96 256 127 256 165.3v45.5l9.8-6.2c13.8-8.8 22.2-24.1 22.2-40.5V32c0-17.7 14.3-32 32-32z"
    ]
};
var $d8206b3ab2e65c05$export$25218e5886296cb9 = {
    prefix: "fas",
    iconName: "arrow-up-9-1",
    icon: [
        576,
        512,
        [
            "sort-numeric-up-alt"
        ],
        "f887",
        "M160 32c9 0 17.5 3.8 23.6 10.4l88 96c11.9 13 11.1 33.3-2 45.2s-33.3 11.1-45.2-2L192 146.3V448c0 17.7-14.3 32-32 32s-32-14.3-32-32V146.3L95.6 181.6c-11.9 13-32.2 13.9-45.2 2s-13.9-32.2-2-45.2l88-96C142.5 35.8 151 32 160 32zM450.7 294c8.3 6 13.3 15.7 13.3 26v96h16c17.7 0 32 14.3 32 32s-14.3 32-32 32H432 384c-17.7 0-32-14.3-32-32s14.3-32 32-32h16V364.4l-5.9 2c-16.8 5.6-34.9-3.5-40.5-20.2s3.5-34.9 20.2-40.5l48-16c9.8-3.3 20.5-1.6 28.8 4.4zm-5-145.1A32 32 0 1 0 418.3 91a32 32 0 1 0 27.4 57.9zm-40.7 54.9C369.6 192.4 344 159.2 344 120c0-48.6 39.4-88 88-88s88 39.4 88 88c0 23.5-7.5 46.3-21.5 65.2L449.7 251c-10.5 14.2-30.6 17.2-44.8 6.7s-17.2-30.6-6.7-44.8l6.8-9.2z"
    ]
};
var $d8206b3ab2e65c05$export$d41859f1bbb9e086 = $d8206b3ab2e65c05$export$25218e5886296cb9;
var $d8206b3ab2e65c05$export$4a157bd81dcd8d80 = {
    prefix: "fas",
    iconName: "litecoin-sign",
    icon: [
        384,
        512,
        [],
        "e1d3",
        "M128 64c0-17.7-14.3-32-32-32S64 46.3 64 64V213.6L23.2 225.2c-17 4.9-26.8 22.6-22 39.6s22.6 26.8 39.6 22L64 280.1V448c0 17.7 14.3 32 32 32H352c17.7 0 32-14.3 32-32s-14.3-32-32-32H128V261.9l136.8-39.1c17-4.9 26.8-22.6 22-39.6s-22.6-26.8-39.6-22L128 195.3V64z"
    ]
};
var $d8206b3ab2e65c05$export$2b488402ec335d97 = {
    prefix: "fas",
    iconName: "border-none",
    icon: [
        448,
        512,
        [],
        "f850",
        "M32 480a32 32 0 1 1 0-64 32 32 0 1 1 0 64zm96-64a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm0-384a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm0 256a32 32 0 1 1 0-64 32 32 0 1 1 0 64zM320 416a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm0-320a32 32 0 1 1 0-64 32 32 0 1 1 0 64zm0 128a32 32 0 1 1 0 64 32 32 0 1 1 0-64zM224 480a32 32 0 1 1 0-64 32 32 0 1 1 0 64zm0-448a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm0 256a32 32 0 1 1 0-64 32 32 0 1 1 0 64zM416 416a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm0-384a32 32 0 1 1 0 64 32 32 0 1 1 0-64zM32 96a32 32 0 1 1 0-64 32 32 0 1 1 0 64zM416 224a32 32 0 1 1 0 64 32 32 0 1 1 0-64zM32 288a32 32 0 1 1 0-64 32 32 0 1 1 0 64zm192 32a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm192 64a32 32 0 1 1 0-64 32 32 0 1 1 0 64zM32 320a32 32 0 1 1 0 64 32 32 0 1 1 0-64zM416 192a32 32 0 1 1 0-64 32 32 0 1 1 0 64zM32 128a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm192 64a32 32 0 1 1 0-64 32 32 0 1 1 0 64z"
    ]
};
var $d8206b3ab2e65c05$export$de462dd5a18e80d4 = {
    prefix: "fas",
    iconName: "circle-nodes",
    icon: [
        512,
        512,
        [],
        "e4e2",
        "M418.4 157.9c35.3-8.3 61.6-40 61.6-77.9c0-44.2-35.8-80-80-80c-43.4 0-78.7 34.5-80 77.5L136.2 151.1C121.7 136.8 101.9 128 80 128c-44.2 0-80 35.8-80 80s35.8 80 80 80c12.2 0 23.8-2.7 34.1-7.6L259.7 407.8c-2.4 7.6-3.7 15.8-3.7 24.2c0 44.2 35.8 80 80 80s80-35.8 80-80c0-27.7-14-52.1-35.4-66.4l37.8-207.7zM156.3 232.2c2.2-6.9 3.5-14.2 3.7-21.7l183.8-73.5c3.6 3.5 7.4 6.7 11.6 9.5L317.6 354.1c-5.5 1.3-10.8 3.1-15.8 5.5L156.3 232.2z"
    ]
};
var $d8206b3ab2e65c05$export$ca9e3368f1d9500a = {
    prefix: "fas",
    iconName: "parachute-box",
    icon: [
        512,
        512,
        [],
        "f4cd",
        "M383.5 192c.3-5.3 .5-10.6 .5-16c0-51-15.9-96-40.2-127.6C319.5 16.9 288.2 0 256 0s-63.5 16.9-87.8 48.4C143.9 80 128 125 128 176c0 5.4 .2 10.7 .5 16H240V320H208c-7 0-13.7 1.5-19.7 4.2L68.2 192H96.5c-.3-5.3-.5-10.6-.5-16c0-64 22.2-121.2 57.1-159.3C62 49.3 18.6 122.6 4.2 173.6C1.5 183.1 9 192 18.9 192h6L165.2 346.3c-3.3 6.5-5.2 13.9-5.2 21.7v96c0 26.5 21.5 48 48 48h96c26.5 0 48-21.5 48-48V368c0-7.8-1.9-15.2-5.2-21.7L487.1 192h6c9.9 0 17.4-8.9 14.7-18.4C493.4 122.6 450 49.3 358.9 16.7C393.8 54.8 416 112.1 416 176c0 5.4-.2 10.7-.5 16h28.3L323.7 324.2c-6-2.7-12.7-4.2-19.7-4.2H272V192H383.5z"
    ]
};
var $d8206b3ab2e65c05$export$318208bc30aeebcc = {
    prefix: "fas",
    iconName: "indent",
    icon: [
        448,
        512,
        [],
        "f03c",
        "M0 64C0 46.3 14.3 32 32 32H416c17.7 0 32 14.3 32 32s-14.3 32-32 32H32C14.3 96 0 81.7 0 64zM192 192c0-17.7 14.3-32 32-32H416c17.7 0 32 14.3 32 32s-14.3 32-32 32H224c-17.7 0-32-14.3-32-32zm32 96H416c17.7 0 32 14.3 32 32s-14.3 32-32 32H224c-17.7 0-32-14.3-32-32s14.3-32 32-32zM0 448c0-17.7 14.3-32 32-32H416c17.7 0 32 14.3 32 32s-14.3 32-32 32H32c-17.7 0-32-14.3-32-32zM127.8 268.6L25.8 347.9C15.3 356.1 0 348.6 0 335.3V176.7c0-13.3 15.3-20.8 25.8-12.6l101.9 79.3c8.2 6.4 8.2 18.9 0 25.3z"
    ]
};
var $d8206b3ab2e65c05$export$40cb0a4a3a74dc03 = {
    prefix: "fas",
    iconName: "truck-field-un",
    icon: [
        640,
        512,
        [],
        "e58e",
        "M96 32C60.7 32 32 60.7 32 96v32c-17.7 0-32 14.3-32 32v96c0 17.7 14.3 32 32 32v32c-17.7 0-32 14.3-32 32s14.3 32 32 32H64c0 53 43 96 96 96s96-43 96-96H384c0 53 43 96 96 96s96-43 96-96h32c17.7 0 32-14.3 32-32s-14.3-32-32-32V288c0-35.3-28.7-64-64-64h-4.2c-.4-1.1-.9-2.1-1.3-3.2L485.7 102c-10.3-23.1-33.2-38-58.5-38H375.4C364.4 44.9 343.7 32 320 32H96zm288 96h43.2l42.7 96H384V128zM112 384a48 48 0 1 1 96 0 48 48 0 1 1 -96 0zm368-48a48 48 0 1 1 0 96 48 48 0 1 1 0-96zM253.3 135.1l34.7 52V144c0-8.8 7.2-16 16-16s16 7.2 16 16v96c0 7.1-4.6 13.3-11.4 15.3s-14-.6-17.9-6.4l-34.7-52V240c0 8.8-7.2 16-16 16s-16-7.2-16-16V144c0-7.1 4.6-13.3 11.4-15.3s14 .6 17.9 6.4zM128 144v64c0 8.8 7.2 16 16 16s16-7.2 16-16V144c0-8.8 7.2-16 16-16s16 7.2 16 16v64c0 26.5-21.5 48-48 48s-48-21.5-48-48V144c0-8.8 7.2-16 16-16s16 7.2 16 16z"
    ]
};
var $d8206b3ab2e65c05$export$b9098a890f61e022 = {
    prefix: "fas",
    iconName: "hourglass",
    icon: [
        384,
        512,
        [
            9203,
            62032,
            "hourglass-empty"
        ],
        "f254",
        "M0 32C0 14.3 14.3 0 32 0H64 320h32c17.7 0 32 14.3 32 32s-14.3 32-32 32V75c0 42.4-16.9 83.1-46.9 113.1L237.3 256l67.9 67.9c30 30 46.9 70.7 46.9 113.1v11c17.7 0 32 14.3 32 32s-14.3 32-32 32H320 64 32c-17.7 0-32-14.3-32-32s14.3-32 32-32V437c0-42.4 16.9-83.1 46.9-113.1L146.7 256 78.9 188.1C48.9 158.1 32 117.4 32 75V64C14.3 64 0 49.7 0 32zM96 64V75c0 25.5 10.1 49.9 28.1 67.9L192 210.7l67.9-67.9c18-18 28.1-42.4 28.1-67.9V64H96zm0 384H288V437c0-25.5-10.1-49.9-28.1-67.9L192 301.3l-67.9 67.9c-18 18-28.1 42.4-28.1 67.9v11z"
    ]
};
var $d8206b3ab2e65c05$export$a2f8176a0161e891 = $d8206b3ab2e65c05$export$b9098a890f61e022;
var $d8206b3ab2e65c05$export$64f9eb99c9749cce = {
    prefix: "fas",
    iconName: "mountain",
    icon: [
        512,
        512,
        [
            127956
        ],
        "f6fc",
        "M256 32c12.5 0 24.1 6.4 30.8 17L503.4 394.4c5.6 8.9 8.6 19.2 8.6 29.7c0 30.9-25 55.9-55.9 55.9H55.9C25 480 0 455 0 424.1c0-10.5 3-20.8 8.6-29.7L225.2 49c6.6-10.6 18.3-17 30.8-17zm65 192L256 120.4 176.9 246.5l18.3 24.4c6.4 8.5 19.2 8.5 25.6 0l25.6-34.1c6-8.1 15.5-12.8 25.6-12.8h49z"
    ]
};
var $d8206b3ab2e65c05$export$9884bf227eeb829 = {
    prefix: "fas",
    iconName: "user-doctor",
    icon: [
        448,
        512,
        [
            "user-md"
        ],
        "f0f0",
        "M224 256A128 128 0 1 0 224 0a128 128 0 1 0 0 256zm-96 55.2C54 332.9 0 401.3 0 482.3C0 498.7 13.3 512 29.7 512H418.3c16.4 0 29.7-13.3 29.7-29.7c0-81-54-149.4-128-171.1V362c27.6 7.1 48 32.2 48 62v40c0 8.8-7.2 16-16 16H336c-8.8 0-16-7.2-16-16s7.2-16 16-16V424c0-17.7-14.3-32-32-32s-32 14.3-32 32v24c8.8 0 16 7.2 16 16s-7.2 16-16 16H256c-8.8 0-16-7.2-16-16V424c0-29.8 20.4-54.9 48-62V304.9c-6-.6-12.1-.9-18.3-.9H178.3c-6.2 0-12.3 .3-18.3 .9v65.4c23.1 6.9 40 28.3 40 53.7c0 30.9-25.1 56-56 56s-56-25.1-56-56c0-25.4 16.9-46.8 40-53.7V311.2zM144 448a24 24 0 1 0 0-48 24 24 0 1 0 0 48z"
    ]
};
var $d8206b3ab2e65c05$export$ab0d33a2c03f1794 = $d8206b3ab2e65c05$export$9884bf227eeb829;
var $d8206b3ab2e65c05$export$317f99f46b39906e = {
    prefix: "fas",
    iconName: "circle-info",
    icon: [
        512,
        512,
        [
            "info-circle"
        ],
        "f05a",
        "M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM216 336h24V272H216c-13.3 0-24-10.7-24-24s10.7-24 24-24h48c13.3 0 24 10.7 24 24v88h8c13.3 0 24 10.7 24 24s-10.7 24-24 24H216c-13.3 0-24-10.7-24-24s10.7-24 24-24zm40-208a32 32 0 1 1 0 64 32 32 0 1 1 0-64z"
    ]
};
var $d8206b3ab2e65c05$export$aa9288aeadf882fa = $d8206b3ab2e65c05$export$317f99f46b39906e;
var $d8206b3ab2e65c05$export$5d120e8b87ad33f4 = {
    prefix: "fas",
    iconName: "cloud-meatball",
    icon: [
        512,
        512,
        [],
        "f73b",
        "M0 224c0 53 43 96 96 96h44.7c9.5-23.5 32.5-40 59.3-40c2 0 3.9 .1 5.8 .3C217.6 265.5 235.7 256 256 256s38.4 9.5 50.2 24.3c1.9-.2 3.9-.3 5.8-.3c26.9 0 49.9 16.5 59.3 40H416c53 0 96-43 96-96s-43-96-96-96c-.5 0-1.1 0-1.6 0c1.1-5.2 1.6-10.5 1.6-16c0-44.2-35.8-80-80-80c-24.3 0-46.1 10.9-60.8 28C256.5 24.3 219.1 0 176 0C114.1 0 64 50.1 64 112c0 7.1 .7 14.1 1.9 20.8C27.6 145.4 0 181.5 0 224zm288 96c0-17.7-14.3-32-32-32s-32 14.3-32 32c0 1 .1 2.1 .1 3.1c-.7-.8-1.4-1.6-2.1-2.3c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3c.7 .7 1.5 1.4 2.3 2.1c-1-.1-2.1-.1-3.1-.1c-17.7 0-32 14.3-32 32s14.3 32 32 32c1 0 2.1-.1 3.1-.1c-.8 .7-1.6 1.3-2.3 2.1c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0c.7-.7 1.4-1.5 2.1-2.3c-.1 1-.1 2.1-.1 3.1c0 17.7 14.3 32 32 32s32-14.3 32-32c0-1-.1-2.1-.1-3.1c.7 .8 1.3 1.6 2.1 2.3c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3c-.7-.7-1.5-1.4-2.3-2.1c1 .1 2.1 .1 3.1 .1c17.7 0 32-14.3 32-32s-14.3-32-32-32c-1 0-2.1 .1-3.1 .1c.8-.7 1.6-1.3 2.3-2.1c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0c-.7 .7-1.4 1.5-2.1 2.3c.1-1 .1-2.1 .1-3.1zM48 448a48 48 0 1 0 0-96 48 48 0 1 0 0 96zm416 0a48 48 0 1 0 0-96 48 48 0 1 0 0 96z"
    ]
};
var $d8206b3ab2e65c05$export$84ffbd7161ca2008 = {
    prefix: "fas",
    iconName: "camera",
    icon: [
        512,
        512,
        [
            62258,
            "camera-alt"
        ],
        "f030",
        "M149.1 64.8L138.7 96H64C28.7 96 0 124.7 0 160V416c0 35.3 28.7 64 64 64H448c35.3 0 64-28.7 64-64V160c0-35.3-28.7-64-64-64H373.3L362.9 64.8C356.4 45.2 338.1 32 317.4 32H194.6c-20.7 0-39 13.2-45.5 32.8zM256 192a96 96 0 1 1 0 192 96 96 0 1 1 0-192z"
    ]
};
var $d8206b3ab2e65c05$export$8872b5664e88e793 = $d8206b3ab2e65c05$export$84ffbd7161ca2008;
var $d8206b3ab2e65c05$export$f9409a7b020dbec4 = {
    prefix: "fas",
    iconName: "square-virus",
    icon: [
        448,
        512,
        [],
        "e578",
        "M64 32C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64zM223.8 93.7c13.3 0 24 10.7 24 24c0 29.3 35.4 43.9 56.1 23.2c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9c-20.7 20.7-6 56.1 23.2 56.1c13.3 0 24 10.7 24 24s-10.7 24-24 24c-29.3 0-43.9 35.4-23.2 56.1c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0c-20.7-20.7-56.1-6-56.1 23.2c0 13.3-10.7 24-24 24s-24-10.7-24-24c0-29.3-35.4-43.9-56.1-23.2c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9c20.7-20.7 6-56.1-23.2-56.1c-13.3 0-24-10.7-24-24s10.7-24 24-24c29.3 0 43.9-35.4 23.2-56.1c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0c20.7 20.7 56.1 6 56.1-23.2c0-13.3 10.7-24 24-24zM192 256a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm88 32a24 24 0 1 0 -48 0 24 24 0 1 0 48 0z"
    ]
};
var $d8206b3ab2e65c05$export$1439f0d6365138da = {
    prefix: "fas",
    iconName: "meteor",
    icon: [
        512,
        512,
        [
            9732
        ],
        "f753",
        "M493.7 .9L299.4 75.6l2.3-29.3c1-12.8-12.8-21.5-24-15.1L101.3 133.4C38.6 169.7 0 236.6 0 309C0 421.1 90.9 512 203 512c72.4 0 139.4-38.6 175.7-101.3L480.8 234.3c6.5-11.1-2.2-25-15.1-24l-29.3 2.3L511.1 18.3c.6-1.5 .9-3.2 .9-4.8C512 6 506 0 498.5 0c-1.7 0-3.3 .3-4.8 .9zM192 192a128 128 0 1 1 0 256 128 128 0 1 1 0-256zm0 96a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zm16 96a16 16 0 1 0 0-32 16 16 0 1 0 0 32z"
    ]
};
var $d8206b3ab2e65c05$export$d901d50df5cf8d91 = {
    prefix: "fas",
    iconName: "car-on",
    icon: [
        512,
        512,
        [],
        "e4dd",
        "M280 24c0-13.3-10.7-24-24-24s-24 10.7-24 24v80c0 13.3 10.7 24 24 24s24-10.7 24-24V24zM185.8 224H326.2c6.8 0 12.8 4.3 15.1 10.6L360.3 288H151.7l19.1-53.4c2.3-6.4 8.3-10.6 15.1-10.6zm-75.3-10.9L82.2 292.4C62.1 300.9 48 320.8 48 344v40 64 32c0 17.7 14.3 32 32 32H96c17.7 0 32-14.3 32-32V448H384v32c0 17.7 14.3 32 32 32h16c17.7 0 32-14.3 32-32V448 384 344c0-23.2-14.1-43.1-34.2-51.6l-28.3-79.3C390.1 181.3 360 160 326.2 160H185.8c-33.8 0-64 21.3-75.3 53.1zM128 344a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm232 24a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zM39 39c-9.4 9.4-9.4 24.6 0 33.9l48 48c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9L73 39c-9.4-9.4-24.6-9.4-33.9 0zm400 0L391 87c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l48-48c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0z"
    ]
};
var $d8206b3ab2e65c05$export$26a8fd1143d2d6c0 = {
    prefix: "fas",
    iconName: "sleigh",
    icon: [
        640,
        512,
        [],
        "f7cc",
        "M32 32C14.3 32 0 46.3 0 64S14.3 96 32 96V256c0 53 43 96 96 96v32h64V352H384v32h64V352c53 0 96-43 96-96V160c17.7 0 32-14.3 32-32s-14.3-32-32-32H512 480c-17.7 0-32 14.3-32 32v41.3c0 30.2-24.5 54.7-54.7 54.7c-75.5 0-145.6-38.9-185.6-102.9l-4.3-6.9C174.2 67.6 125 37.6 70.7 32.7c-2.2-.5-4.4-.7-6.7-.7H55 32zM640 384c0-17.7-14.3-32-32-32s-32 14.3-32 32v8c0 13.3-10.7 24-24 24H64c-17.7 0-32 14.3-32 32s14.3 32 32 32H552c48.6 0 88-39.4 88-88v-8z"
    ]
};
var $d8206b3ab2e65c05$export$9a40d582bd4628fb = {
    prefix: "fas",
    iconName: "arrow-down-1-9",
    icon: [
        576,
        512,
        [
            "sort-numeric-asc",
            "sort-numeric-down"
        ],
        "f162",
        "M450.7 38c-8.3-6-19.1-7.7-28.8-4.4l-48 16c-16.8 5.6-25.8 23.7-20.2 40.5s23.7 25.8 40.5 20.2l5.9-2V160H384c-17.7 0-32 14.3-32 32s14.3 32 32 32h48 48c17.7 0 32-14.3 32-32s-14.3-32-32-32H464V64c0-10.3-4.9-19.9-13.3-26zM160 480c9 0 17.5-3.8 23.6-10.4l88-96c11.9-13 11.1-33.3-2-45.2s-33.3-11.1-45.2 2L192 365.7V64c0-17.7-14.3-32-32-32s-32 14.3-32 32V365.7L95.6 330.4c-11.9-13-32.2-13.9-45.2-2s-13.9 32.2-2 45.2l88 96C142.5 476.2 151 480 160 480zM418.3 307a32 32 0 1 1 27.4 57.9A32 32 0 1 1 418.3 307zM405.1 419.8l-6.8 9.2c-10.5 14.2-7.5 34.2 6.7 44.8s34.2 7.5 44.8-6.7l48.8-65.8c14-18.9 21.5-41.7 21.5-65.2c0-48.6-39.4-88-88-88s-88 39.4-88 88c0 39.2 25.6 72.4 61.1 83.8z"
    ]
};
var $d8206b3ab2e65c05$export$a4fb1aa2cdfb18d7 = $d8206b3ab2e65c05$export$9a40d582bd4628fb;
var $d8206b3ab2e65c05$export$835db7eb35b3c29b = $d8206b3ab2e65c05$export$9a40d582bd4628fb;
var $d8206b3ab2e65c05$export$b9c3f9a906f96b82 = {
    prefix: "fas",
    iconName: "hand-holding-droplet",
    icon: [
        576,
        512,
        [
            "hand-holding-water"
        ],
        "f4c1",
        "M275.5 6.6C278.3 2.5 283 0 288 0s9.7 2.5 12.5 6.6L366.8 103C378 119.3 384 138.6 384 158.3V160c0 53-43 96-96 96s-96-43-96-96v-1.7c0-19.8 6-39 17.2-55.3L275.5 6.6zM568.2 336.3c13.1 17.8 9.3 42.8-8.5 55.9L433.1 485.5c-23.4 17.2-51.6 26.5-80.7 26.5H192 32c-17.7 0-32-14.3-32-32V416c0-17.7 14.3-32 32-32H68.8l44.9-36c22.7-18.2 50.9-28 80-28H272h16 64c17.7 0 32 14.3 32 32s-14.3 32-32 32H288 272c-8.8 0-16 7.2-16 16s7.2 16 16 16H392.6l119.7-88.2c17.8-13.1 42.8-9.3 55.9 8.5zM193.6 384l0 0-.9 0c.3 0 .6 0 .9 0z"
    ]
};
var $d8206b3ab2e65c05$export$4265371b99d38b95 = $d8206b3ab2e65c05$export$b9c3f9a906f96b82;
var $d8206b3ab2e65c05$export$efaeddad0a6e901b = {
    prefix: "fas",
    iconName: "water",
    icon: [
        576,
        512,
        [],
        "f773",
        "M269.5 69.9c11.1-7.9 25.9-7.9 37 0C329 85.4 356.5 96 384 96c26.9 0 55.4-10.8 77.4-26.1l0 0c11.9-8.5 28.1-7.8 39.2 1.7c14.4 11.9 32.5 21 50.6 25.2c17.2 4 27.9 21.2 23.9 38.4s-21.2 27.9-38.4 23.9c-24.5-5.7-44.9-16.5-58.2-25C449.5 149.7 417 160 384 160c-31.9 0-60.6-9.9-80.4-18.9c-5.8-2.7-11.1-5.3-15.6-7.7c-4.5 2.4-9.7 5.1-15.6 7.7c-19.8 9-48.5 18.9-80.4 18.9c-33 0-65.5-10.3-94.5-25.8c-13.4 8.4-33.7 19.3-58.2 25c-17.2 4-34.4-6.7-38.4-23.9s6.7-34.4 23.9-38.4C42.8 92.6 61 83.5 75.3 71.6c11.1-9.5 27.3-10.1 39.2-1.7l0 0C136.7 85.2 165.1 96 192 96c27.5 0 55-10.6 77.5-26.1zm37 288C329 373.4 356.5 384 384 384c26.9 0 55.4-10.8 77.4-26.1l0 0c11.9-8.5 28.1-7.8 39.2 1.7c14.4 11.9 32.5 21 50.6 25.2c17.2 4 27.9 21.2 23.9 38.4s-21.2 27.9-38.4 23.9c-24.5-5.7-44.9-16.5-58.2-25C449.5 437.7 417 448 384 448c-31.9 0-60.6-9.9-80.4-18.9c-5.8-2.7-11.1-5.3-15.6-7.7c-4.5 2.4-9.7 5.1-15.6 7.7c-19.8 9-48.5 18.9-80.4 18.9c-33 0-65.5-10.3-94.5-25.8c-13.4 8.4-33.7 19.3-58.2 25c-17.2 4-34.4-6.7-38.4-23.9s6.7-34.4 23.9-38.4c18.1-4.2 36.2-13.3 50.6-25.2c11.1-9.4 27.3-10.1 39.2-1.7l0 0C136.7 373.2 165.1 384 192 384c27.5 0 55-10.6 77.5-26.1c11.1-7.9 25.9-7.9 37 0zm0-144C329 229.4 356.5 240 384 240c26.9 0 55.4-10.8 77.4-26.1l0 0c11.9-8.5 28.1-7.8 39.2 1.7c14.4 11.9 32.5 21 50.6 25.2c17.2 4 27.9 21.2 23.9 38.4s-21.2 27.9-38.4 23.9c-24.5-5.7-44.9-16.5-58.2-25C449.5 293.7 417 304 384 304c-31.9 0-60.6-9.9-80.4-18.9c-5.8-2.7-11.1-5.3-15.6-7.7c-4.5 2.4-9.7 5.1-15.6 7.7c-19.8 9-48.5 18.9-80.4 18.9c-33 0-65.5-10.3-94.5-25.8c-13.4 8.4-33.7 19.3-58.2 25c-17.2 4-34.4-6.7-38.4-23.9s6.7-34.4 23.9-38.4c18.1-4.2 36.2-13.3 50.6-25.2c11.1-9.5 27.3-10.1 39.2-1.7l0 0C136.7 229.2 165.1 240 192 240c27.5 0 55-10.6 77.5-26.1c11.1-7.9 25.9-7.9 37 0z"
    ]
};
var $d8206b3ab2e65c05$export$5655108e1162ba45 = {
    prefix: "fas",
    iconName: "calendar-check",
    icon: [
        448,
        512,
        [],
        "f274",
        "M128 0c17.7 0 32 14.3 32 32V64H288V32c0-17.7 14.3-32 32-32s32 14.3 32 32V64h48c26.5 0 48 21.5 48 48v48H0V112C0 85.5 21.5 64 48 64H96V32c0-17.7 14.3-32 32-32zM0 192H448V464c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V192zM329 305c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-95 95-47-47c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9l64 64c9.4 9.4 24.6 9.4 33.9 0L329 305z"
    ]
};
var $d8206b3ab2e65c05$export$983e9c27cac7ed1c = {
    prefix: "fas",
    iconName: "braille",
    icon: [
        640,
        512,
        [],
        "f2a1",
        "M0 96a64 64 0 1 1 128 0A64 64 0 1 1 0 96zM224 272a16 16 0 1 0 0-32 16 16 0 1 0 0 32zm0-80a64 64 0 1 1 0 128 64 64 0 1 1 0-128zM80 416a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zM0 416a64 64 0 1 1 128 0A64 64 0 1 1 0 416zm240 0a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zm-80 0a64 64 0 1 1 128 0 64 64 0 1 1 -128 0zM64 192a64 64 0 1 1 0 128 64 64 0 1 1 0-128zM224 32a64 64 0 1 1 0 128 64 64 0 1 1 0-128zM352 96a64 64 0 1 1 128 0A64 64 0 1 1 352 96zm240 0a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zm-80 0a64 64 0 1 1 128 0A64 64 0 1 1 512 96zm64 176a16 16 0 1 0 0-32 16 16 0 1 0 0 32zm0-80a64 64 0 1 1 0 128 64 64 0 1 1 0-128zm16 224a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zm-80 0a64 64 0 1 1 128 0 64 64 0 1 1 -128 0zM416 272a16 16 0 1 0 0-32 16 16 0 1 0 0 32zm0-80a64 64 0 1 1 0 128 64 64 0 1 1 0-128zm16 224a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zm-80 0a64 64 0 1 1 128 0 64 64 0 1 1 -128 0z"
    ]
};
var $d8206b3ab2e65c05$export$99cfe064ff0b71c9 = {
    prefix: "fas",
    iconName: "prescription-bottle-medical",
    icon: [
        384,
        512,
        [
            "prescription-bottle-alt"
        ],
        "f486",
        "M0 32C0 14.3 14.3 0 32 0H352c17.7 0 32 14.3 32 32V64c0 17.7-14.3 32-32 32H32C14.3 96 0 81.7 0 64V32zm32 96H352V448c0 35.3-28.7 64-64 64H96c-35.3 0-64-28.7-64-64V128zM160 240v48H112c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h48v48c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V352h48c8.8 0 16-7.2 16-16V304c0-8.8-7.2-16-16-16H224V240c0-8.8-7.2-16-16-16H176c-8.8 0-16 7.2-16 16z"
    ]
};
var $d8206b3ab2e65c05$export$65d1c884b8581d1a = $d8206b3ab2e65c05$export$99cfe064ff0b71c9;
var $d8206b3ab2e65c05$export$2bebc54c51db6505 = {
    prefix: "fas",
    iconName: "landmark",
    icon: [
        512,
        512,
        [
            127963
        ],
        "f66f",
        "M240.1 4.2c9.8-5.6 21.9-5.6 31.8 0l171.8 98.1L448 104l0 .9 47.9 27.4c12.6 7.2 18.8 22 15.1 36s-16.4 23.8-30.9 23.8H32c-14.5 0-27.2-9.8-30.9-23.8s2.5-28.8 15.1-36L64 104.9V104l4.4-1.6L240.1 4.2zM64 224h64V416h40V224h64V416h48V224h64V416h40V224h64V420.3c.6 .3 1.2 .7 1.8 1.1l48 32c11.7 7.8 17 22.4 12.9 35.9S494.1 512 480 512H32c-14.1 0-26.5-9.2-30.6-22.7s1.1-28.1 12.9-35.9l48-32c.6-.4 1.2-.7 1.8-1.1V224z"
    ]
};
var $d8206b3ab2e65c05$export$d7895f386f8bd8b8 = {
    prefix: "fas",
    iconName: "truck",
    icon: [
        640,
        512,
        [
            128666,
            9951
        ],
        "f0d1",
        "M48 0C21.5 0 0 21.5 0 48V368c0 26.5 21.5 48 48 48H64c0 53 43 96 96 96s96-43 96-96H384c0 53 43 96 96 96s96-43 96-96h32c17.7 0 32-14.3 32-32s-14.3-32-32-32V288 256 237.3c0-17-6.7-33.3-18.7-45.3L512 114.7c-12-12-28.3-18.7-45.3-18.7H416V48c0-26.5-21.5-48-48-48H48zM416 160h50.7L544 237.3V256H416V160zM112 416a48 48 0 1 1 96 0 48 48 0 1 1 -96 0zm368-48a48 48 0 1 1 0 96 48 48 0 1 1 0-96z"
    ]
};
var $d8206b3ab2e65c05$export$721c101130c40043 = {
    prefix: "fas",
    iconName: "crosshairs",
    icon: [
        512,
        512,
        [],
        "f05b",
        "M256 0c17.7 0 32 14.3 32 32V42.4c93.7 13.9 167.7 88 181.6 181.6H480c17.7 0 32 14.3 32 32s-14.3 32-32 32H469.6c-13.9 93.7-88 167.7-181.6 181.6V480c0 17.7-14.3 32-32 32s-32-14.3-32-32V469.6C130.3 455.7 56.3 381.7 42.4 288H32c-17.7 0-32-14.3-32-32s14.3-32 32-32H42.4C56.3 130.3 130.3 56.3 224 42.4V32c0-17.7 14.3-32 32-32zM107.4 288c12.5 58.3 58.4 104.1 116.6 116.6V384c0-17.7 14.3-32 32-32s32 14.3 32 32v20.6c58.3-12.5 104.1-58.4 116.6-116.6H384c-17.7 0-32-14.3-32-32s14.3-32 32-32h20.6C392.1 165.7 346.3 119.9 288 107.4V128c0 17.7-14.3 32-32 32s-32-14.3-32-32V107.4C165.7 119.9 119.9 165.7 107.4 224H128c17.7 0 32 14.3 32 32s-14.3 32-32 32H107.4zM256 224a32 32 0 1 1 0 64 32 32 0 1 1 0-64z"
    ]
};
var $d8206b3ab2e65c05$export$c48422e9da776c1b = {
    prefix: "fas",
    iconName: "person-cane",
    icon: [
        448,
        512,
        [],
        "e53c",
        "M272 48a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zm-8 187.3l47.4 57.1c11.3 13.6 31.5 15.5 45.1 4.2s15.5-31.5 4.2-45.1l-73.7-88.9c-18.2-22-45.3-34.7-73.9-34.7H177.1c-33.7 0-64.9 17.7-82.3 46.6l-58.3 97c-9.1 15.1-4.2 34.8 10.9 43.9s34.8 4.2 43.9-10.9L120 256.9V480c0 17.7 14.3 32 32 32s32-14.3 32-32V352h16V480c0 17.7 14.3 32 32 32s32-14.3 32-32V235.3zM352 376c0-4.4 3.6-8 8-8s8 3.6 8 8V488c0 13.3 10.7 24 24 24s24-10.7 24-24V376c0-30.9-25.1-56-56-56s-56 25.1-56 56v8c0 13.3 10.7 24 24 24s24-10.7 24-24v-8z"
    ]
};
var $d8206b3ab2e65c05$export$e5075400db564e24 = {
    prefix: "fas",
    iconName: "tent",
    icon: [
        576,
        512,
        [],
        "e57d",
        "M269.4 6C280.5-2 295.5-2 306.6 6l224 160c7.4 5.3 12.2 13.5 13.2 22.5l32 288c1 9-1.9 18.1-8 24.9s-14.7 10.7-23.8 10.7H416L288 288V512H32c-9.1 0-17.8-3.9-23.8-10.7s-9-15.8-8-24.9l32-288c1-9 5.8-17.2 13.2-22.5L269.4 6z"
    ]
};
var $d8206b3ab2e65c05$export$750a64470c2e0f3f = {
    prefix: "fas",
    iconName: "vest-patches",
    icon: [
        448,
        512,
        [],
        "e086",
        "M151.2 69.7l55.9 167.7-11 33.1c-2.7 8.2-4.1 16.7-4.1 25.3V464c0 14.5 3.9 28.2 10.7 39.9C195 509 185.9 512 176 512H48c-26.5 0-48-21.5-48-48V270.5c0-9.5 2.8-18.7 8.1-26.6l47.9-71.8c5.3-7.9 8.1-17.1 8.1-26.6V128 54.3 48C64 21.5 85.5 0 112 0h4.5c.2 0 .4 0 .6 0c.4 0 .8 0 1.2 0c18.8 0 34.1 9.7 44.1 18.8C171.6 27.2 190.8 40 224 40s52.4-12.8 61.7-21.2C295.7 9.7 311 0 329.7 0c.4 0 .8 0 1.2 0c.2 0 .4 0 .6 0H336c26.5 0 48 21.5 48 48v6.3V128v17.5c0 9.5 2.8 18.7 8.1 26.6l47.9 71.8c5.3 7.9 8.1 17.1 8.1 26.6V464c0 26.5-21.5 48-48 48H272c-26.5 0-48-21.5-48-48V295.8c0-5.2 .8-10.3 2.5-15.2L296.8 69.7C279.4 79.7 255.4 88 224 88s-55.4-8.3-72.8-18.3zM96 456a40 40 0 1 0 0-80 40 40 0 1 0 0 80zM63.5 255.5c-4.7 4.7-4.7 12.3 0 17L79 288 63.5 303.5c-4.7 4.7-4.7 12.3 0 17s12.3 4.7 17 0L96 305l15.5 15.5c4.7 4.7 12.3 4.7 17 0s4.7-12.3 0-17L113 288l15.5-15.5c4.7-4.7 4.7-12.3 0-17s-12.3-4.7-17 0L96 271 80.5 255.5c-4.7-4.7-12.3-4.7-17 0zM304 280v8 32c0 8.8 7.2 16 16 16h32 8c13.3 0 24-10.7 24-24s-10.7-24-24-24h-8v-8c0-13.3-10.7-24-24-24s-24 10.7-24 24z"
    ]
};
var $d8206b3ab2e65c05$export$f178c8c2ad3cc861 = {
    prefix: "fas",
    iconName: "check-double",
    icon: [
        448,
        512,
        [],
        "f560",
        "M342.6 86.6c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L160 178.7l-57.4-57.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3l80 80c12.5 12.5 32.8 12.5 45.3 0l160-160zm96 128c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L160 402.7 54.6 297.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3l128 128c12.5 12.5 32.8 12.5 45.3 0l256-256z"
    ]
};
var $d8206b3ab2e65c05$export$43b642fac7053978 = {
    prefix: "fas",
    iconName: "arrow-down-a-z",
    icon: [
        576,
        512,
        [
            "sort-alpha-asc",
            "sort-alpha-down"
        ],
        "f15d",
        "M183.6 469.6C177.5 476.2 169 480 160 480s-17.5-3.8-23.6-10.4l-88-96c-11.9-13-11.1-33.3 2-45.2s33.3-11.1 45.2 2L128 365.7V64c0-17.7 14.3-32 32-32s32 14.3 32 32V365.7l32.4-35.4c11.9-13 32.2-13.9 45.2-2s13.9 32.2 2 45.2l-88 96zM320 320c0-17.7 14.3-32 32-32H480c12.9 0 24.6 7.8 29.6 19.8s2.2 25.7-6.9 34.9L429.3 416H480c17.7 0 32 14.3 32 32s-14.3 32-32 32H352c-12.9 0-24.6-7.8-29.6-19.8s-2.2-25.7 6.9-34.9L402.7 352H352c-17.7 0-32-14.3-32-32zM416 32c12.1 0 23.2 6.8 28.6 17.7l64 128 16 32c7.9 15.8 1.5 35-14.3 42.9s-35 1.5-42.9-14.3L460.2 224H371.8l-7.2 14.3c-7.9 15.8-27.1 22.2-42.9 14.3s-22.2-27.1-14.3-42.9l16-32 64-128C392.8 38.8 403.9 32 416 32zM395.8 176h40.4L416 135.6 395.8 176z"
    ]
};
var $d8206b3ab2e65c05$export$cb87697f2fa77cfc = $d8206b3ab2e65c05$export$43b642fac7053978;
var $d8206b3ab2e65c05$export$7658045270aafde3 = $d8206b3ab2e65c05$export$43b642fac7053978;
var $d8206b3ab2e65c05$export$6a4ef2ef77625063 = {
    prefix: "fas",
    iconName: "money-bill-wheat",
    icon: [
        512,
        512,
        [],
        "e52a",
        "M176 0c44.2 0 80 35.8 80 80c0 8.8-7.2 16-16 16c-44.2 0-80-35.8-80-80c0-8.8 7.2-16 16-16zM56 16h48c13.3 0 24 10.7 24 24s-10.7 24-24 24H56C42.7 64 32 53.3 32 40s10.7-24 24-24zM24 88H136c13.3 0 24 10.7 24 24s-10.7 24-24 24H24c-13.3 0-24-10.7-24-24S10.7 88 24 88zm8 96c0-13.3 10.7-24 24-24h48c13.3 0 24 10.7 24 24s-10.7 24-24 24H56c-13.3 0-24-10.7-24-24zM272 16c0-8.8 7.2-16 16-16c44.2 0 80 35.8 80 80c0 8.8-7.2 16-16 16c-44.2 0-80-35.8-80-80zM400 0c44.2 0 80 35.8 80 80c0 8.8-7.2 16-16 16c-44.2 0-80-35.8-80-80c0-8.8 7.2-16 16-16zm80 144c0 44.2-35.8 80-80 80c-8.8 0-16-7.2-16-16c0-44.2 35.8-80 80-80c8.8 0 16 7.2 16 16zM352 128c8.8 0 16 7.2 16 16c0 44.2-35.8 80-80 80c-8.8 0-16-7.2-16-16c0-44.2 35.8-80 80-80zm-96 16c0 44.2-35.8 80-80 80c-8.8 0-16-7.2-16-16c0-44.2 35.8-80 80-80c8.8 0 16 7.2 16 16zM0 304c0-26.5 21.5-48 48-48H464c26.5 0 48 21.5 48 48V464c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V304zM48 416v48H96c0-26.5-21.5-48-48-48zM96 304H48v48c26.5 0 48-21.5 48-48zM464 416c-26.5 0-48 21.5-48 48h48V416zM416 304c0 26.5 21.5 48 48 48V304H416zm-96 80a64 64 0 1 0 -128 0 64 64 0 1 0 128 0z"
    ]
};
var $d8206b3ab2e65c05$export$b3e64f5f68c6623f = {
    prefix: "fas",
    iconName: "cookie",
    icon: [
        512,
        512,
        [
            127850
        ],
        "f563",
        "M247.2 17c-22.1-3.1-44.6 .9-64.4 11.4l-74 39.5C89.1 78.4 73.2 94.9 63.4 115L26.7 190.6c-9.8 20.1-13 42.9-9.1 64.9l14.5 82.8c3.9 22.1 14.6 42.3 30.7 57.9l60.3 58.4c16.1 15.6 36.6 25.6 58.7 28.7l83 11.7c22.1 3.1 44.6-.9 64.4-11.4l74-39.5c19.7-10.5 35.6-27 45.4-47.2l36.7-75.5c9.8-20.1 13-42.9 9.1-64.9l-14.6-82.8c-3.9-22.1-14.6-42.3-30.7-57.9L388.9 57.5c-16.1-15.6-36.6-25.6-58.7-28.7L247.2 17zM208 144a32 32 0 1 1 0 64 32 32 0 1 1 0-64zM144 336a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm224-64a32 32 0 1 1 0 64 32 32 0 1 1 0-64z"
    ]
};
var $d8206b3ab2e65c05$export$89b706873769c180 = {
    prefix: "fas",
    iconName: "arrow-rotate-left",
    icon: [
        512,
        512,
        [
            8634,
            "arrow-left-rotate",
            "arrow-rotate-back",
            "arrow-rotate-backward",
            "undo"
        ],
        "f0e2",
        "M125.7 160H176c17.7 0 32 14.3 32 32s-14.3 32-32 32H48c-17.7 0-32-14.3-32-32V64c0-17.7 14.3-32 32-32s32 14.3 32 32v51.2L97.6 97.6c87.5-87.5 229.3-87.5 316.8 0s87.5 229.3 0 316.8s-229.3 87.5-316.8 0c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0c62.5 62.5 163.8 62.5 226.3 0s62.5-163.8 0-226.3s-163.8-62.5-226.3 0L125.7 160z"
    ]
};
var $d8206b3ab2e65c05$export$1aea864c3e1d79b = $d8206b3ab2e65c05$export$89b706873769c180;
var $d8206b3ab2e65c05$export$a34701878babe5fc = $d8206b3ab2e65c05$export$89b706873769c180;
var $d8206b3ab2e65c05$export$fce381d12e4535cd = $d8206b3ab2e65c05$export$89b706873769c180;
var $d8206b3ab2e65c05$export$a5e5ba60b1dfe2b2 = $d8206b3ab2e65c05$export$89b706873769c180;
var $d8206b3ab2e65c05$export$4cb736b866cbb7ec = {
    prefix: "fas",
    iconName: "hard-drive",
    icon: [
        512,
        512,
        [
            128436,
            "hdd"
        ],
        "f0a0",
        "M0 96C0 60.7 28.7 32 64 32H448c35.3 0 64 28.7 64 64V280.4c-17-15.2-39.4-24.4-64-24.4H64c-24.6 0-47 9.2-64 24.4V96zM64 288H448c35.3 0 64 28.7 64 64v64c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V352c0-35.3 28.7-64 64-64zM320 416a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm128-32a32 32 0 1 0 -64 0 32 32 0 1 0 64 0z"
    ]
};
var $d8206b3ab2e65c05$export$62551e9c5ba7093f = $d8206b3ab2e65c05$export$4cb736b866cbb7ec;
var $d8206b3ab2e65c05$export$8ff56f5ebb8416a0 = {
    prefix: "fas",
    iconName: "face-grin-squint-tears",
    icon: [
        512,
        512,
        [
            129315,
            "grin-squint-tears"
        ],
        "f586",
        "M426.8 14.2C446-5 477.5-4.6 497.1 14.9s20 51 .7 70.3c-6.8 6.8-21.4 12.4-37.4 16.7c-16.3 4.4-34.1 7.5-46.3 9.3c-1.6 .2-3.1 .5-4.6 .6c-4.9 .8-9.1-2.8-9.5-7.4c-.1-.7 0-1.4 .1-2.1c1.6-11.2 4.6-29.6 9-47c.3-1.3 .7-2.6 1-3.9c4.3-15.9 9.8-30.5 16.7-37.4zm-44.7 19c-1.5 4.8-2.9 9.6-4.1 14.3c-4.8 18.9-8 38.5-9.7 50.3c-4 26.8 18.9 49.7 45.7 45.8c11.9-1.6 31.5-4.8 50.4-9.7c4.7-1.2 9.5-2.5 14.3-4.1C534.2 227.5 520.2 353.8 437 437c-83.2 83.2-209.5 97.2-307.2 41.8c1.5-4.8 2.8-9.6 4-14.3c4.8-18.9 8-38.5 9.7-50.3c4-26.8-18.9-49.7-45.7-45.8c-11.9 1.6-31.5 4.8-50.4 9.7c-4.7 1.2-9.5 2.5-14.3 4.1C-22.2 284.5-8.2 158.2 75 75C158.2-8.3 284.5-22.2 382.2 33.2zM51.5 410.1c18.5-5 38.8-8.3 50.9-10c.4-.1 .7-.1 1-.1c5.1-.2 9.2 4.3 8.4 9.6c-1.7 12.1-5 32.4-10 50.9C97.6 476.4 92 491 85.2 497.8C66 517 34.5 516.6 14.9 497.1s-20-51-.7-70.3c6.8-6.8 21.4-12.4 37.4-16.7zM416.9 209c-4.7-11.9-20.8-11-26.8 .3c-19 35.5-45 70.8-77.5 103.3S244.8 371.1 209.3 390c-11.3 6-12.2 22.1-.3 26.8c57.6 22.9 125.8 11 172.3-35.5s58.4-114.8 35.5-172.3zM87.1 285.1c2 2 4.6 3.2 7.3 3.4l56.1 5.1 5.1 56.1c.3 2.8 1.5 5.4 3.4 7.3c6.3 6.3 17.2 3.6 19.8-4.9l29.7-97.4c3.5-11.6-7.3-22.5-19-19L92 265.3c-8.6 2.6-11.3 13.4-4.9 19.8zM265.3 92l-29.7 97.4c-3.5 11.6 7.3 22.5 19 19l97.4-29.7c8.6-2.6 11.3-13.4 4.9-19.8c-2-2-4.6-3.2-7.3-3.4l-56.1-5.1-5.1-56.1c-.3-2.8-1.5-5.4-3.4-7.3c-6.3-6.3-17.2-3.6-19.8 4.9z"
    ]
};
var $d8206b3ab2e65c05$export$542206d6a85f3b42 = $d8206b3ab2e65c05$export$8ff56f5ebb8416a0;
var $d8206b3ab2e65c05$export$56700074cf37be5c = {
    prefix: "fas",
    iconName: "dumbbell",
    icon: [
        640,
        512,
        [],
        "f44b",
        "M96 64c0-17.7 14.3-32 32-32h32c17.7 0 32 14.3 32 32V224v64V448c0 17.7-14.3 32-32 32H128c-17.7 0-32-14.3-32-32V384H64c-17.7 0-32-14.3-32-32V288c-17.7 0-32-14.3-32-32s14.3-32 32-32V160c0-17.7 14.3-32 32-32H96V64zm448 0v64h32c17.7 0 32 14.3 32 32v64c17.7 0 32 14.3 32 32s-14.3 32-32 32v64c0 17.7-14.3 32-32 32H544v64c0 17.7-14.3 32-32 32H480c-17.7 0-32-14.3-32-32V288 224 64c0-17.7 14.3-32 32-32h32c17.7 0 32 14.3 32 32zM416 224v64H224V224H416z"
    ]
};
var $d8206b3ab2e65c05$export$1f7600fa9fdb3978 = {
    prefix: "fas",
    iconName: "rectangle-list",
    icon: [
        576,
        512,
        [
            "list-alt"
        ],
        "f022",
        "M0 96C0 60.7 28.7 32 64 32H512c35.3 0 64 28.7 64 64V416c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96zM128 288a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm32-128a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zM128 384a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm96-248c-13.3 0-24 10.7-24 24s10.7 24 24 24H448c13.3 0 24-10.7 24-24s-10.7-24-24-24H224zm0 96c-13.3 0-24 10.7-24 24s10.7 24 24 24H448c13.3 0 24-10.7 24-24s-10.7-24-24-24H224zm0 96c-13.3 0-24 10.7-24 24s10.7 24 24 24H448c13.3 0 24-10.7 24-24s-10.7-24-24-24H224z"
    ]
};
var $d8206b3ab2e65c05$export$c6327a203ffc65a3 = $d8206b3ab2e65c05$export$1f7600fa9fdb3978;
var $d8206b3ab2e65c05$export$1585b7c3c7109751 = {
    prefix: "fas",
    iconName: "tarp-droplet",
    icon: [
        576,
        512,
        [],
        "e57c",
        "M288 160c-35.3 0-64-26.9-64-60c0-24 33.7-70.1 52.2-93.5c6.1-7.7 17.5-7.7 23.6 0C318.3 29.9 352 76 352 100c0 33.1-28.7 60-64 60zM64 128H197.5c13.2 37.3 48.7 64 90.5 64s77.4-26.7 90.5-64H512c35.3 0 64 28.7 64 64V352H448c-17.7 0-32 14.3-32 32l0 128L64 512c-35.3 0-64-28.7-64-64V192c0-35.3 28.7-64 64-64zM448 512l0-128H576L448 512zM96 256a32 32 0 1 0 0-64 32 32 0 1 0 0 64z"
    ]
};
var $d8206b3ab2e65c05$export$5d08d08f88a96aac = {
    prefix: "fas",
    iconName: "house-medical-circle-check",
    icon: [
        640,
        512,
        [],
        "e511",
        "M320 368c0 59.5 29.5 112.1 74.8 144H128.1c-35.3 0-64-28.7-64-64V287.6H32c-18 0-32-14-32-32.1c0-9 3-17 10-24L266.4 8c7-7 15-8 22-8s15 2 21 7L522.1 193.9c-8.5-1.3-17.3-1.9-26.1-1.9c-54.7 0-103.5 24.9-135.8 64H320V208c0-8.8-7.2-16-16-16H272c-8.8 0-16 7.2-16 16v48H208c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h48v48c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16zm32 0a144 144 0 1 1 288 0 144 144 0 1 1 -288 0zm211.3-43.3c-6.2-6.2-16.4-6.2-22.6 0L480 385.4l-28.7-28.7c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6l40 40c6.2 6.2 16.4 6.2 22.6 0l72-72c6.2-6.2 6.2-16.4 0-22.6z"
    ]
};
var $d8206b3ab2e65c05$export$c8cd1786449517d3 = {
    prefix: "fas",
    iconName: "person-skiing-nordic",
    icon: [
        576,
        512,
        [
            "skiing-nordic"
        ],
        "f7ca",
        "M336 96a48 48 0 1 0 0-96 48 48 0 1 0 0 96zM227.2 160c1.9 0 3.8 .1 5.6 .3L201.6 254c-9.3 28 1.7 58.8 26.8 74.5l86.2 53.9L291.3 464H202.8l41.1-88.1-32.4-20.3c-7.8-4.9-14.7-10.7-20.6-17.3L132.2 464H99.7l54.2-257.6c4.6-1.5 9-4.1 12.7-7.8l23.1-23.1c9.9-9.9 23.4-15.5 37.5-15.5zM121.4 198.6c.4 .4 .8 .8 1.3 1.2L67 464H24c-13.3 0-24 10.7-24 24s10.7 24 24 24H159.3c.4 0 .9 0 1.3 0H319.3c.5 0 1 0 1.4 0H504c39.8 0 72-32.2 72-72v-8c0-13.3-10.7-24-24-24s-24 10.7-24 24v8c0 13.3-10.7 24-24 24H434.6l27.6-179.3c10.5-5.2 17.8-16.1 17.8-28.7c0-17.7-14.3-32-32-32H426.7c-12.9 0-24.6-7.8-29.5-19.7l-6.3-15c-14.6-35.1-44.1-61.9-80.5-73.1l-48.7-15c-11.1-3.4-22.7-5.2-34.4-5.2c-31 0-60.8 12.3-82.7 34.3l-23.1 23.1c-12.5 12.5-12.5 32.8 0 45.3zm308 89.4L402.3 464H357.8l21.6-75.6c5.9-20.6-2.6-42.6-20.7-53.9L302 299l30.9-82.4 5.1 12.3C353 264.7 387.9 288 426.7 288h2.7z"
    ]
};
var $d8206b3ab2e65c05$export$6ea48260d7d09b1b = $d8206b3ab2e65c05$export$c8cd1786449517d3;
var $d8206b3ab2e65c05$export$16768a660ae3ca9d = {
    prefix: "fas",
    iconName: "calendar-plus",
    icon: [
        512,
        512,
        [],
        "f271",
        "M128 32V64H80c-26.5 0-48 21.5-48 48v48H480V112c0-26.5-21.5-48-48-48H384V32c0-17.7-14.3-32-32-32s-32 14.3-32 32V64H192V32c0-17.7-14.3-32-32-32s-32 14.3-32 32zM480 192H32V464c0 26.5 21.5 48 48 48H432c26.5 0 48-21.5 48-48V192zM256 248c13.3 0 24 10.7 24 24v56h56c13.3 0 24 10.7 24 24s-10.7 24-24 24H280v56c0 13.3-10.7 24-24 24s-24-10.7-24-24V376H176c-13.3 0-24-10.7-24-24s10.7-24 24-24h56V272c0-13.3 10.7-24 24-24z"
    ]
};
var $d8206b3ab2e65c05$export$9b2dbe133273f284 = {
    prefix: "fas",
    iconName: "plane-arrival",
    icon: [
        640,
        512,
        [
            128748
        ],
        "f5af",
        "M.3 166.9L0 68C0 57.7 9.5 50.1 19.5 52.3l35.6 7.9c10.6 2.3 19.2 9.9 23 20L96 128l127.3 37.6L181.8 20.4C178.9 10.2 186.6 0 197.2 0h40.1c11.6 0 22.2 6.2 27.9 16.3l109 193.8 107.2 31.7c15.9 4.7 30.8 12.5 43.7 22.8l34.4 27.6c24 19.2 18.1 57.3-10.7 68.2c-41.2 15.6-86.2 18.1-128.8 7L121.7 289.8c-11.1-2.9-21.2-8.7-29.3-16.9L9.5 189.4c-5.9-6-9.3-14-9.3-22.5zM32 448H608c17.7 0 32 14.3 32 32s-14.3 32-32 32H32c-17.7 0-32-14.3-32-32s14.3-32 32-32zm96-80a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm128-16a32 32 0 1 1 0 64 32 32 0 1 1 0-64z"
    ]
};
var $d8206b3ab2e65c05$export$5ae86b9da9cca3bd = {
    prefix: "fas",
    iconName: "circle-left",
    icon: [
        512,
        512,
        [
            61840,
            "arrow-alt-circle-left"
        ],
        "f359",
        "M512 256A256 256 0 1 0 0 256a256 256 0 1 0 512 0zM217.4 376.9L117.5 269.8c-3.5-3.8-5.5-8.7-5.5-13.8s2-10.1 5.5-13.8l99.9-107.1c4.2-4.5 10.1-7.1 16.3-7.1c12.3 0 22.3 10 22.3 22.3l0 57.7 96 0c17.7 0 32 14.3 32 32l0 32c0 17.7-14.3 32-32 32l-96 0 0 57.7c0 12.3-10 22.3-22.3 22.3c-6.2 0-12.1-2.6-16.3-7.1z"
    ]
};
var $d8206b3ab2e65c05$export$5460a5b11a24996f = $d8206b3ab2e65c05$export$5ae86b9da9cca3bd;
var $d8206b3ab2e65c05$export$cda326cc3bce41c = {
    prefix: "fas",
    iconName: "train-subway",
    icon: [
        448,
        512,
        [
            "subway"
        ],
        "f239",
        "M96 0C43 0 0 43 0 96V352c0 48 35.2 87.7 81.1 94.9l-46 46C28.1 499.9 33.1 512 43 512H82.7c8.5 0 16.6-3.4 22.6-9.4L160 448H288l54.6 54.6c6 6 14.1 9.4 22.6 9.4H405c10 0 15-12.1 7.9-19.1l-46-46c46-7.1 81.1-46.9 81.1-94.9V96c0-53-43-96-96-96H96zM64 128c0-17.7 14.3-32 32-32h80c17.7 0 32 14.3 32 32v96c0 17.7-14.3 32-32 32H96c-17.7 0-32-14.3-32-32V128zM272 96h80c17.7 0 32 14.3 32 32v96c0 17.7-14.3 32-32 32H272c-17.7 0-32-14.3-32-32V128c0-17.7 14.3-32 32-32zM64 352a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm288-32a32 32 0 1 1 0 64 32 32 0 1 1 0-64z"
    ]
};
var $d8206b3ab2e65c05$export$4cabc8a12d4e2f9 = $d8206b3ab2e65c05$export$cda326cc3bce41c;
var $d8206b3ab2e65c05$export$dce43b02b3fe0c18 = {
    prefix: "fas",
    iconName: "chart-gantt",
    icon: [
        512,
        512,
        [],
        "e0e4",
        "M32 32c17.7 0 32 14.3 32 32V400c0 8.8 7.2 16 16 16H480c17.7 0 32 14.3 32 32s-14.3 32-32 32H80c-44.2 0-80-35.8-80-80V64C0 46.3 14.3 32 32 32zm96 96c0-17.7 14.3-32 32-32l96 0c17.7 0 32 14.3 32 32s-14.3 32-32 32H160c-17.7 0-32-14.3-32-32zm96 64H352c17.7 0 32 14.3 32 32s-14.3 32-32 32H224c-17.7 0-32-14.3-32-32s14.3-32 32-32zm160 96h64c17.7 0 32 14.3 32 32s-14.3 32-32 32H384c-17.7 0-32-14.3-32-32s14.3-32 32-32z"
    ]
};
var $d8206b3ab2e65c05$export$1d2b135cc5a2c852 = {
    prefix: "fas",
    iconName: "indian-rupee-sign",
    icon: [
        320,
        512,
        [
            "indian-rupee",
            "inr"
        ],
        "e1bc",
        "M0 64C0 46.3 14.3 32 32 32H96h16H288c17.7 0 32 14.3 32 32s-14.3 32-32 32H231.8c9.6 14.4 16.7 30.6 20.7 48H288c17.7 0 32 14.3 32 32s-14.3 32-32 32H252.4c-13.2 58.3-61.9 103.2-122.2 110.9L274.6 422c14.4 10.3 17.7 30.3 7.4 44.6s-30.3 17.7-44.6 7.4L13.4 314C2.1 306-2.7 291.5 1.5 278.2S18.1 256 32 256h80c32.8 0 61-19.7 73.3-48H32c-17.7 0-32-14.3-32-32s14.3-32 32-32H185.3C173 115.7 144.8 96 112 96H96 32C14.3 96 0 81.7 0 64z"
    ]
};
var $d8206b3ab2e65c05$export$be886a4def17c565 = $d8206b3ab2e65c05$export$1d2b135cc5a2c852;
var $d8206b3ab2e65c05$export$12c6d8b3e052490b = $d8206b3ab2e65c05$export$1d2b135cc5a2c852;
var $d8206b3ab2e65c05$export$c3605731beb92daf = {
    prefix: "fas",
    iconName: "crop-simple",
    icon: [
        512,
        512,
        [
            "crop-alt"
        ],
        "f565",
        "M128 32c0-17.7-14.3-32-32-32S64 14.3 64 32V64H32C14.3 64 0 78.3 0 96s14.3 32 32 32H64V384c0 35.3 28.7 64 64 64H352V384H128V32zM384 480c0 17.7 14.3 32 32 32s32-14.3 32-32V448h32c17.7 0 32-14.3 32-32s-14.3-32-32-32H448l0-256c0-35.3-28.7-64-64-64L160 64v64l224 0 0 352z"
    ]
};
var $d8206b3ab2e65c05$export$d932915fde4f1010 = $d8206b3ab2e65c05$export$c3605731beb92daf;
var $d8206b3ab2e65c05$export$a312c7d58dd44a75 = {
    prefix: "fas",
    iconName: "money-bill-1",
    icon: [
        576,
        512,
        [
            "money-bill-alt"
        ],
        "f3d1",
        "M64 64C28.7 64 0 92.7 0 128V384c0 35.3 28.7 64 64 64H512c35.3 0 64-28.7 64-64V128c0-35.3-28.7-64-64-64H64zm64 320H64V320c35.3 0 64 28.7 64 64zM64 192V128h64c0 35.3-28.7 64-64 64zM448 384c0-35.3 28.7-64 64-64v64H448zm64-192c-35.3 0-64-28.7-64-64h64v64zM176 256a112 112 0 1 1 224 0 112 112 0 1 1 -224 0zm76-48c0 9.7 6.9 17.7 16 19.6V276h-4c-11 0-20 9-20 20s9 20 20 20h24 24c11 0 20-9 20-20s-9-20-20-20h-4V208c0-11-9-20-20-20H272c-11 0-20 9-20 20z"
    ]
};
var $d8206b3ab2e65c05$export$a35d573395884c3d = $d8206b3ab2e65c05$export$a312c7d58dd44a75;
var $d8206b3ab2e65c05$export$1db7e2ee10d36035 = {
    prefix: "fas",
    iconName: "left-long",
    icon: [
        512,
        512,
        [
            "long-arrow-alt-left"
        ],
        "f30a",
        "M177.5 414c-8.8 3.8-19 2-26-4.6l-144-136C2.7 268.9 0 262.6 0 256s2.7-12.9 7.5-17.4l144-136c7-6.6 17.2-8.4 26-4.6s14.5 12.5 14.5 22l0 72 288 0c17.7 0 32 14.3 32 32l0 64c0 17.7-14.3 32-32 32l-288 0 0 72c0 9.6-5.7 18.2-14.5 22z"
    ]
};
var $d8206b3ab2e65c05$export$a8b3226b2bf323d = $d8206b3ab2e65c05$export$1db7e2ee10d36035;
var $d8206b3ab2e65c05$export$c062100d54a2da00 = {
    prefix: "fas",
    iconName: "dna",
    icon: [
        448,
        512,
        [
            129516
        ],
        "f471",
        "M416 0c17.7 0 32 14.3 32 32c0 59.8-30.3 107.5-69.4 146.6c-28 28-62.5 53.5-97.3 77.4l-2.5 1.7c-11.9 8.1-23.8 16.1-35.5 23.9l0 0 0 0 0 0-1.6 1c-6 4-11.9 7.9-17.8 11.9c-20.9 14-40.8 27.7-59.3 41.5H283.3c-9.8-7.4-20.1-14.7-30.7-22.1l7-4.7 3-2c15.1-10.1 30.9-20.6 46.7-31.6c25 18.1 48.9 37.3 69.4 57.7C417.7 372.5 448 420.2 448 480c0 17.7-14.3 32-32 32s-32-14.3-32-32H64c0 17.7-14.3 32-32 32s-32-14.3-32-32c0-59.8 30.3-107.5 69.4-146.6c28-28 62.5-53.5 97.3-77.4c-34.8-23.9-69.3-49.3-97.3-77.4C30.3 139.5 0 91.8 0 32C0 14.3 14.3 0 32 0S64 14.3 64 32H384c0-17.7 14.3-32 32-32zM338.6 384H109.4c-10.1 10.6-18.6 21.3-25.5 32H364.1c-6.8-10.7-15.3-21.4-25.5-32zM109.4 128H338.6c10.1-10.7 18.6-21.3 25.5-32H83.9c6.8 10.7 15.3 21.3 25.5 32zm55.4 48c18.4 13.8 38.4 27.5 59.3 41.5c20.9-14 40.8-27.7 59.3-41.5H164.7z"
    ]
};
var $d8206b3ab2e65c05$export$c4ff5306c5470939 = {
    prefix: "fas",
    iconName: "virus-slash",
    icon: [
        640,
        512,
        [],
        "e075",
        "M38.8 5.1C28.4-3.1 13.3-1.2 5.1 9.2S-1.2 34.7 9.2 42.9l592 464c10.4 8.2 25.5 6.3 33.7-4.1s6.3-25.5-4.1-33.7l-154.3-121c-2-30.1 20.8-60.1 56-60.1H544c17.7 0 32-14.3 32-32s-14.3-32-32-32H532.5c-49.9 0-74.9-60.3-39.6-95.6l8.2-8.2c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0l-8.2 8.2C412.3 118.4 352 93.4 352 43.5V32c0-17.7-14.3-32-32-32s-32 14.3-32 32V43.5c0 49.9-60.3 74.9-95.6 39.6L184.2 75c-12.5-12.5-32.8-12.5-45.3 0c-1.6 1.6-3.1 3.4-4.3 5.3L38.8 5.1zm225.8 177c6.9-3.9 14.9-6.1 23.4-6.1c26.5 0 48 21.5 48 48c0 4.4-.6 8.7-1.7 12.7l-69.7-54.6zM402 412.7L144.7 210c-9.5 8.5-22.2 14-37.2 14H96c-17.7 0-32 14.3-32 32s14.3 32 32 32h11.5c49.9 0 74.9 60.3 39.6 95.6l-8.2 8.2c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0l8.2-8.2c35.3-35.3 95.6-10.3 95.6 39.6V480c0 17.7 14.3 32 32 32s32-14.3 32-32V468.5c0-31.2 23.6-52.7 50-55.7z"
    ]
};
var $d8206b3ab2e65c05$export$fee0376c250cdef = {
    prefix: "fas",
    iconName: "minus",
    icon: [
        448,
        512,
        [
            8211,
            8722,
            10134,
            "subtract"
        ],
        "f068",
        "M432 256c0 17.7-14.3 32-32 32L48 288c-17.7 0-32-14.3-32-32s14.3-32 32-32l352 0c17.7 0 32 14.3 32 32z"
    ]
};
var $d8206b3ab2e65c05$export$f8cb2531ef1fc4a2 = $d8206b3ab2e65c05$export$fee0376c250cdef;
var $d8206b3ab2e65c05$export$442fddbbd741c590 = {
    prefix: "fas",
    iconName: "chess",
    icon: [
        512,
        512,
        [],
        "f439",
        "M144 16c0-8.8-7.2-16-16-16s-16 7.2-16 16V32H96c-8.8 0-16 7.2-16 16s7.2 16 16 16h16V96H60.2C49.1 96 40 105.1 40 116.2c0 2.5 .5 4.9 1.3 7.3L73.8 208H72c-13.3 0-24 10.7-24 24s10.7 24 24 24h4L60 384H196L180 256h4c13.3 0 24-10.7 24-24s-10.7-24-24-24h-1.8l32.5-84.5c.9-2.3 1.3-4.8 1.3-7.3c0-11.2-9.1-20.2-20.2-20.2H144V64h16c8.8 0 16-7.2 16-16s-7.2-16-16-16H144V16zM48 416L4.8 473.6C1.7 477.8 0 482.8 0 488c0 13.3 10.7 24 24 24H232c13.3 0 24-10.7 24-24c0-5.2-1.7-10.2-4.8-14.4L208 416H48zm288 0l-43.2 57.6c-3.1 4.2-4.8 9.2-4.8 14.4c0 13.3 10.7 24 24 24H488c13.3 0 24-10.7 24-24c0-5.2-1.7-10.2-4.8-14.4L464 416H336zM304 208v51.9c0 7.8 2.8 15.3 8 21.1L339.2 312 337 384H462.5l-3.3-72 28.3-30.8c5.4-5.9 8.5-13.6 8.5-21.7V208c0-8.8-7.2-16-16-16H464c-8.8 0-16 7.2-16 16v16H424V208c0-8.8-7.2-16-16-16H392c-8.8 0-16 7.2-16 16v16H352V208c0-8.8-7.2-16-16-16H320c-8.8 0-16 7.2-16 16zm80 96c0-8.8 7.2-16 16-16s16 7.2 16 16v32H384V304z"
    ]
};
var $d8206b3ab2e65c05$export$6e5225f0e6c0bacd = {
    prefix: "fas",
    iconName: "arrow-left-long",
    icon: [
        512,
        512,
        [
            "long-arrow-left"
        ],
        "f177",
        "M9.4 233.4c-12.5 12.5-12.5 32.8 0 45.3l128 128c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L109.3 288 480 288c17.7 0 32-14.3 32-32s-14.3-32-32-32l-370.7 0 73.4-73.4c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0l-128 128z"
    ]
};
var $d8206b3ab2e65c05$export$80896efc906118b4 = $d8206b3ab2e65c05$export$6e5225f0e6c0bacd;
var $d8206b3ab2e65c05$export$2bd45e99b9afa947 = {
    prefix: "fas",
    iconName: "plug-circle-check",
    icon: [
        576,
        512,
        [],
        "e55c",
        "M96 0C78.3 0 64 14.3 64 32v96h64V32c0-17.7-14.3-32-32-32zM288 0c-17.7 0-32 14.3-32 32v96h64V32c0-17.7-14.3-32-32-32zM32 160c-17.7 0-32 14.3-32 32s14.3 32 32 32v32c0 77.4 55 142 128 156.8V480c0 17.7 14.3 32 32 32s32-14.3 32-32V412.8c12.3-2.5 24.1-6.4 35.1-11.5c-2.1-10.8-3.1-21.9-3.1-33.3c0-80.3 53.8-148 127.3-169.2c.5-2.2 .7-4.5 .7-6.8c0-17.7-14.3-32-32-32H32zM576 368a144 144 0 1 0 -288 0 144 144 0 1 0 288 0zm-76.7-43.3c6.2 6.2 6.2 16.4 0 22.6l-72 72c-6.2 6.2-16.4 6.2-22.6 0l-40-40c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0L416 385.4l60.7-60.7c6.2-6.2 16.4-6.2 22.6 0z"
    ]
};
var $d8206b3ab2e65c05$export$6aab6c3359c2554c = {
    prefix: "fas",
    iconName: "street-view",
    icon: [
        512,
        512,
        [],
        "f21d",
        "M320 64A64 64 0 1 0 192 64a64 64 0 1 0 128 0zm-96 96c-35.3 0-64 28.7-64 64v48c0 17.7 14.3 32 32 32h1.8l11.1 99.5c1.8 16.2 15.5 28.5 31.8 28.5h38.7c16.3 0 30-12.3 31.8-28.5L318.2 304H320c17.7 0 32-14.3 32-32V224c0-35.3-28.7-64-64-64H224zM132.3 394.2c13-2.4 21.7-14.9 19.3-27.9s-14.9-21.7-27.9-19.3c-32.4 5.9-60.9 14.2-82 24.8c-10.5 5.3-20.3 11.7-27.8 19.6C6.4 399.5 0 410.5 0 424c0 21.4 15.5 36.1 29.1 45c14.7 9.6 34.3 17.3 56.4 23.4C130.2 504.7 190.4 512 256 512s125.8-7.3 170.4-19.6c22.1-6.1 41.8-13.8 56.4-23.4c13.7-8.9 29.1-23.6 29.1-45c0-13.5-6.4-24.5-14-32.6c-7.5-7.9-17.3-14.3-27.8-19.6c-21-10.6-49.5-18.9-82-24.8c-13-2.4-25.5 6.3-27.9 19.3s6.3 25.5 19.3 27.9c30.2 5.5 53.7 12.8 69 20.5c3.2 1.6 5.8 3.1 7.9 4.5c3.6 2.4 3.6 7.2 0 9.6c-8.8 5.7-23.1 11.8-43 17.3C374.3 457 318.5 464 256 464s-118.3-7-157.7-17.9c-19.9-5.5-34.2-11.6-43-17.3c-3.6-2.4-3.6-7.2 0-9.6c2.1-1.4 4.8-2.9 7.9-4.5c15.3-7.7 38.8-14.9 69-20.5z"
    ]
};
var $d8206b3ab2e65c05$export$acef3e5c2029d285 = {
    prefix: "fas",
    iconName: "franc-sign",
    icon: [
        320,
        512,
        [],
        "e18f",
        "M80 32C62.3 32 48 46.3 48 64V224v96H32c-17.7 0-32 14.3-32 32s14.3 32 32 32H48v64c0 17.7 14.3 32 32 32s32-14.3 32-32V384h80c17.7 0 32-14.3 32-32s-14.3-32-32-32H112V256H256c17.7 0 32-14.3 32-32s-14.3-32-32-32H112V96H288c17.7 0 32-14.3 32-32s-14.3-32-32-32H80z"
    ]
};
var $d8206b3ab2e65c05$export$d94ba52e980ea0f1 = {
    prefix: "fas",
    iconName: "volume-off",
    icon: [
        320,
        512,
        [],
        "f026",
        "M320 64c0-12.6-7.4-24-18.9-29.2s-25-3.1-34.4 5.3L131.8 160H64c-35.3 0-64 28.7-64 64v64c0 35.3 28.7 64 64 64h67.8L266.7 471.9c9.4 8.4 22.9 10.4 34.4 5.3S320 460.6 320 448V64z"
    ]
};
var $d8206b3ab2e65c05$export$bc43eb4655c78f49 = {
    prefix: "fas",
    iconName: "hands-asl-interpreting",
    icon: [
        640,
        512,
        [
            "american-sign-language-interpreting",
            "asl-interpreting",
            "hands-american-sign-language-interpreting"
        ],
        "f2a3",
        "M156.6 46.3c7.9-15.8 1.5-35-14.3-42.9s-35-1.5-42.9 14.3L13.5 189.4C4.6 207.2 0 226.8 0 246.7V256c0 70.7 57.3 128 128 128h72 8v-.3c35.2-2.7 65.4-22.8 82.1-51.7c8.8-15.3 3.6-34.9-11.7-43.7s-34.9-3.6-43.7 11.7c-7 12-19.9 20-34.7 20c-22.1 0-40-17.9-40-40s17.9-40 40-40c14.8 0 27.7 8 34.7 20c8.8 15.3 28.4 20.5 43.7 11.7s20.5-28.4 11.7-43.7c-12.8-22.1-33.6-39.1-58.4-47.1l80.8-22c17-4.6 27.1-22.2 22.5-39.3s-22.2-27.1-39.3-22.5L194.9 124.6l81.6-68c13.6-11.3 15.4-31.5 4.1-45.1S249.1-3.9 235.5 7.4L133.6 92.3l23-46zM483.4 465.7c-7.9 15.8-1.5 35 14.3 42.9s35 1.5 42.9-14.3l85.9-171.7c8.9-17.8 13.5-37.4 13.5-57.2V256c0-70.7-57.3-128-128-128H440h-8v.3c-35.2 2.7-65.4 22.8-82.1 51.7c-8.9 15.3-3.6 34.9 11.7 43.7s34.9 3.6 43.7-11.7c7-12 19.9-20 34.7-20c22.1 0 40 17.9 40 40s-17.9 40-40 40c-14.8 0-27.7-8-34.7-20c-8.9-15.3-28.4-20.5-43.7-11.7s-20.5 28.4-11.7 43.7c12.8 22.1 33.6 39.1 58.4 47.1l-80.8 22c-17.1 4.7-27.1 22.2-22.5 39.3s22.2 27.1 39.3 22.5l100.7-27.5-81.6 68c-13.6 11.3-15.4 31.5-4.1 45.1s31.5 15.4 45.1 4.1l101.9-84.9-23 46z"
    ]
};
var $d8206b3ab2e65c05$export$23a7517099ab1b86 = $d8206b3ab2e65c05$export$bc43eb4655c78f49;
var $d8206b3ab2e65c05$export$beb51abfb05a4eca = $d8206b3ab2e65c05$export$bc43eb4655c78f49;
var $d8206b3ab2e65c05$export$82846008645b0301 = $d8206b3ab2e65c05$export$bc43eb4655c78f49;
var $d8206b3ab2e65c05$export$ec05accb7226d001 = {
    prefix: "fas",
    iconName: "gear",
    icon: [
        512,
        512,
        [
            9881,
            "cog"
        ],
        "f013",
        "M495.9 166.6c3.2 8.7 .5 18.4-6.4 24.6l-43.3 39.4c1.1 8.3 1.7 16.8 1.7 25.4s-.6 17.1-1.7 25.4l43.3 39.4c6.9 6.2 9.6 15.9 6.4 24.6c-4.4 11.9-9.7 23.3-15.8 34.3l-4.7 8.1c-6.6 11-14 21.4-22.1 31.2c-5.9 7.2-15.7 9.6-24.5 6.8l-55.7-17.7c-13.4 10.3-28.2 18.9-44 25.4l-12.5 57.1c-2 9.1-9 16.3-18.2 17.8c-13.8 2.3-28 3.5-42.5 3.5s-28.7-1.2-42.5-3.5c-9.2-1.5-16.2-8.7-18.2-17.8l-12.5-57.1c-15.8-6.5-30.6-15.1-44-25.4L83.1 425.9c-8.8 2.8-18.6 .3-24.5-6.8c-8.1-9.8-15.5-20.2-22.1-31.2l-4.7-8.1c-6.1-11-11.4-22.4-15.8-34.3c-3.2-8.7-.5-18.4 6.4-24.6l43.3-39.4C64.6 273.1 64 264.6 64 256s.6-17.1 1.7-25.4L22.4 191.2c-6.9-6.2-9.6-15.9-6.4-24.6c4.4-11.9 9.7-23.3 15.8-34.3l4.7-8.1c6.6-11 14-21.4 22.1-31.2c5.9-7.2 15.7-9.6 24.5-6.8l55.7 17.7c13.4-10.3 28.2-18.9 44-25.4l12.5-57.1c2-9.1 9-16.3 18.2-17.8C227.3 1.2 241.5 0 256 0s28.7 1.2 42.5 3.5c9.2 1.5 16.2 8.7 18.2 17.8l12.5 57.1c15.8 6.5 30.6 15.1 44 25.4l55.7-17.7c8.8-2.8 18.6-.3 24.5 6.8c8.1 9.8 15.5 20.2 22.1 31.2l4.7 8.1c6.1 11 11.4 22.4 15.8 34.3zM256 336a80 80 0 1 0 0-160 80 80 0 1 0 0 160z"
    ]
};
var $d8206b3ab2e65c05$export$d6298bbfd1912a78 = $d8206b3ab2e65c05$export$ec05accb7226d001;
var $d8206b3ab2e65c05$export$1d6c5a49025d720b = {
    prefix: "fas",
    iconName: "droplet-slash",
    icon: [
        640,
        512,
        [
            "tint-slash"
        ],
        "f5c7",
        "M320 512c53.2 0 101.4-21.6 136.1-56.6l-298.3-235C140 257.1 128 292.3 128 320c0 106 86 192 192 192zM505.2 370.7c4.4-16.1 6.8-33.1 6.8-50.7c0-91.2-130.2-262.3-166.6-308.3C339.4 4.2 330.5 0 320.9 0h-1.8c-9.6 0-18.5 4.2-24.5 11.7C277.8 33 240.7 81.3 205.8 136L38.8 5.1C28.4-3.1 13.3-1.2 5.1 9.2S-1.2 34.7 9.2 42.9l592 464c10.4 8.2 25.5 6.3 33.7-4.1s6.3-25.5-4.1-33.7L505.2 370.7zM224 336c0 44.2 35.8 80 80 80c8.8 0 16 7.2 16 16s-7.2 16-16 16c-61.9 0-112-50.1-112-112c0-8.8 7.2-16 16-16s16 7.2 16 16z"
    ]
};
var $d8206b3ab2e65c05$export$5d6f0943039b898f = $d8206b3ab2e65c05$export$1d6c5a49025d720b;
var $d8206b3ab2e65c05$export$4999586d7e1087fb = {
    prefix: "fas",
    iconName: "mosque",
    icon: [
        640,
        512,
        [
            128332
        ],
        "f678",
        "M400 0c5 0 9.8 2.4 12.8 6.4c34.7 46.3 78.1 74.9 133.5 111.5l0 0 0 0c5.2 3.4 10.5 7 16 10.6c28.9 19.2 45.7 51.7 45.7 86.1c0 28.6-11.3 54.5-29.8 73.4H221.8c-18.4-19-29.8-44.9-29.8-73.4c0-34.4 16.7-66.9 45.7-86.1c5.4-3.6 10.8-7.1 16-10.6l0 0 0 0C309.1 81.3 352.5 52.7 387.2 6.4c3-4 7.8-6.4 12.8-6.4zM288 512V440c0-13.3-10.7-24-24-24s-24 10.7-24 24v72H192c-17.7 0-32-14.3-32-32V352c0-17.7 14.3-32 32-32H608c17.7 0 32 14.3 32 32V480c0 17.7-14.3 32-32 32H560V440c0-13.3-10.7-24-24-24s-24 10.7-24 24v72H448V454c0-19-8.4-37-23-49.2L400 384l-25 20.8C360.4 417 352 435 352 454v58H288zM70.4 5.2c5.7-4.3 13.5-4.3 19.2 0l16 12C139.8 42.9 160 83.2 160 126v2H0v-2C0 83.2 20.2 42.9 54.4 17.2l16-12zM0 160H160V296.6c-19.1 11.1-32 31.7-32 55.4V480c0 9.6 2.1 18.6 5.8 26.8c-6.6 3.4-14 5.2-21.8 5.2H48c-26.5 0-48-21.5-48-48V176 160z"
    ]
};
var $d8206b3ab2e65c05$export$67c7a1518d0715ff = {
    prefix: "fas",
    iconName: "mosquito",
    icon: [
        640,
        512,
        [],
        "e52b",
        "M463.7 505.9c9.8-8.9 10.7-24.3 2.1-34.3l-42.1-49 0-54.7c0-5.5-1.8-10.8-5.1-15.1L352 266.3l0-.3L485.4 387.8C542.4 447.6 640 405.2 640 320.6c0-47.9-34-88.3-79.4-94.2l-153-23.9 40.8-40.9c7.8-7.8 9.4-20.1 3.9-29.8L428.5 90.1l38.2-50.9c8-10.6 6.1-25.9-4.3-34.1s-25.2-6.3-33.2 4.4l-48 63.9c-5.9 7.9-6.6 18.6-1.7 27.2L402.2 140 352 190.3l0-38.2c0-14.9-10.2-27.4-24-31l0-57.2c0-4.4-3.6-8-8-8s-8 3.6-8 8l0 57.2c-13.8 3.6-24 16.1-24 31l0 38.1L237.8 140l22.6-39.5c4.9-8.6 4.2-19.3-1.7-27.2l-48-63.9c-8-10.6-22.8-12.6-33.2-4.4s-12.2 23.5-4.3 34.1l38.2 50.9-23.9 41.7c-5.5 9.7-3.9 22 3.9 29.8l40.8 40.9-153 23.9C34 232.3 0 272.7 0 320.6c0 84.6 97.6 127 154.6 67.1L288 266l0 .3-66.5 86.4c-3.3 4.3-5.1 9.6-5.1 15.1l0 54.7-42.1 49c-8.6 10.1-7.7 25.5 2.1 34.3s24.7 7.9 33.4-2.1l48-55.9c3.8-4.4 5.9-10.2 5.9-16.1l0-55.4L288 344.7l0 63.1c0 17.7 14.3 32 32 32s32-14.3 32-32l0-63.1 24.3 31.6 0 55.4c0 5.9 2.1 11.7 5.9 16.1l48 55.9c8.6 10.1 23.6 11 33.4 2.1z"
    ]
};
var $d8206b3ab2e65c05$export$f823fee3712b2601 = {
    prefix: "fas",
    iconName: "star-of-david",
    icon: [
        512,
        512,
        [
            10017
        ],
        "f69a",
        "M404.2 309.5L383.1 344h42.3l-21.1-34.5zM371.4 256l-54-88H194.6l-54 88 54 88H317.4l54-88zm65.7 0l53.4 87c3.6 5.9 5.5 12.7 5.5 19.6c0 20.7-16.8 37.4-37.4 37.4H348.7l-56.2 91.5C284.8 504.3 270.9 512 256 512s-28.8-7.7-36.6-20.5L163.3 400H53.4C32.8 400 16 383.2 16 362.6c0-6.9 1.9-13.7 5.5-19.6l53.4-87L21.5 169c-3.6-5.9-5.5-12.7-5.5-19.6C16 128.8 32.8 112 53.4 112H163.3l56.2-91.5C227.2 7.7 241.1 0 256 0s28.8 7.7 36.6 20.5L348.7 112H458.6c20.7 0 37.4 16.8 37.4 37.4c0 6.9-1.9 13.7-5.5 19.6l-53.4 87zm-54-88l21.1 34.5L425.4 168H383.1zM283 112L256 68l-27 44h54zM128.9 168H86.6l21.1 34.5L128.9 168zM107.8 309.5L86.6 344h42.3l-21.1-34.5zM229 400l27 44 27-44H229z"
    ]
};
var $d8206b3ab2e65c05$export$842b988dae95ccb8 = {
    prefix: "fas",
    iconName: "person-military-rifle",
    icon: [
        512,
        512,
        [],
        "e54b",
        "M160 39c0-13 10-23.8 22.9-24.9L334.7 1.4C344 .7 352 8 352 17.4V48c0 8.8-7.2 16-16 16H185c-13.8 0-25-11.2-25-25zm17.6 57H334.4c1 5.2 1.6 10.5 1.6 16c0 44.2-35.8 80-80 80s-80-35.8-80-80c0-5.5 .6-10.8 1.6-16zm228 364.3L352 369.7V480c0 1.3-.1 2.5-.2 3.8L177.5 234.9c16.6-7.1 34.6-10.9 53.3-10.9h50.4c15.9 0 31.3 2.8 45.8 7.9L421.9 67.7c-7.7-4.4-10.3-14.2-5.9-21.9s14.2-10.3 21.9-5.9l13.9 8 13.9 8c7.7 4.4 10.3 14.2 5.9 21.9L416 173.9l1.6 .9c15.3 8.8 20.6 28.4 11.7 43.7L392.6 282c2 2.8 3.9 5.8 5.7 8.8l76.1 128.8c11.2 19 4.9 43.5-14.1 54.8s-43.5 4.9-54.8-14.1zM320 512H192c-17.7 0-32-14.3-32-32V369.7l-53.6 90.6c-11.2 19-35.8 25.3-54.8 14.1s-25.3-35.8-14.1-54.8l76.1-128.8c9.4-15.8 21.7-29.3 36-40L331.1 510c-3.5 1.3-7.2 2-11.1 2zM296 320a24 24 0 1 0 0-48 24 24 0 1 0 0 48z"
    ]
};
var $d8206b3ab2e65c05$export$c790b41dc166ae13 = {
    prefix: "fas",
    iconName: "cart-shopping",
    icon: [
        576,
        512,
        [
            128722,
            "shopping-cart"
        ],
        "f07a",
        "M0 24C0 10.7 10.7 0 24 0H69.5c22 0 41.5 12.8 50.6 32h411c26.3 0 45.5 25 38.6 50.4l-41 152.3c-8.5 31.4-37 53.3-69.5 53.3H170.7l5.4 28.5c2.2 11.3 12.1 19.5 23.6 19.5H488c13.3 0 24 10.7 24 24s-10.7 24-24 24H199.7c-34.6 0-64.3-24.6-70.7-58.5L77.4 54.5c-.7-3.8-4-6.5-7.9-6.5H24C10.7 48 0 37.3 0 24zM128 464a48 48 0 1 1 96 0 48 48 0 1 1 -96 0zm336-48a48 48 0 1 1 0 96 48 48 0 1 1 0-96z"
    ]
};
var $d8206b3ab2e65c05$export$51da406e5aa1388c = $d8206b3ab2e65c05$export$c790b41dc166ae13;
var $d8206b3ab2e65c05$export$507e8edd7676b2e9 = {
    prefix: "fas",
    iconName: "vials",
    icon: [
        512,
        512,
        [],
        "f493",
        "M0 64C0 46.3 14.3 32 32 32H88h48 56c17.7 0 32 14.3 32 32s-14.3 32-32 32V400c0 44.2-35.8 80-80 80s-80-35.8-80-80V96C14.3 96 0 81.7 0 64zM136 96H88V256h48V96zM288 64c0-17.7 14.3-32 32-32h56 48 56c17.7 0 32 14.3 32 32s-14.3 32-32 32V400c0 44.2-35.8 80-80 80s-80-35.8-80-80V96c-17.7 0-32-14.3-32-32zM424 96H376V256h48V96z"
    ]
};
var $d8206b3ab2e65c05$export$f193138a7d21971c = {
    prefix: "fas",
    iconName: "plug-circle-plus",
    icon: [
        576,
        512,
        [],
        "e55f",
        "M96 0C78.3 0 64 14.3 64 32v96h64V32c0-17.7-14.3-32-32-32zM288 0c-17.7 0-32 14.3-32 32v96h64V32c0-17.7-14.3-32-32-32zM32 160c-17.7 0-32 14.3-32 32s14.3 32 32 32v32c0 77.4 55 142 128 156.8V480c0 17.7 14.3 32 32 32s32-14.3 32-32V412.8c12.3-2.5 24.1-6.4 35.1-11.5c-2.1-10.8-3.1-21.9-3.1-33.3c0-80.3 53.8-148 127.3-169.2c.5-2.2 .7-4.5 .7-6.8c0-17.7-14.3-32-32-32H32zM432 512a144 144 0 1 0 0-288 144 144 0 1 0 0 288zm16-208v48h48c8.8 0 16 7.2 16 16s-7.2 16-16 16H448v48c0 8.8-7.2 16-16 16s-16-7.2-16-16V384H368c-8.8 0-16-7.2-16-16s7.2-16 16-16h48V304c0-8.8 7.2-16 16-16s16 7.2 16 16z"
    ]
};
var $d8206b3ab2e65c05$export$c5a9302c8c13c79a = {
    prefix: "fas",
    iconName: "place-of-worship",
    icon: [
        640,
        512,
        [],
        "f67f",
        "M224 109.3V217.6L183.3 242c-14.5 8.7-23.3 24.3-23.3 41.2V512h96V416c0-35.3 28.7-64 64-64s64 28.7 64 64v96h96V283.2c0-16.9-8.8-32.5-23.3-41.2L416 217.6V109.3c0-8.5-3.4-16.6-9.4-22.6L331.3 11.3c-6.2-6.2-16.4-6.2-22.6 0L233.4 86.6c-6 6-9.4 14.1-9.4 22.6zM24.9 330.3C9.5 338.8 0 354.9 0 372.4V464c0 26.5 21.5 48 48 48h80V273.6L24.9 330.3zM592 512c26.5 0 48-21.5 48-48V372.4c0-17.5-9.5-33.6-24.9-42.1L512 273.6V512h80z"
    ]
};
var $d8206b3ab2e65c05$export$cacbd95c283996ec = {
    prefix: "fas",
    iconName: "grip-vertical",
    icon: [
        320,
        512,
        [],
        "f58e",
        "M40 352l48 0c22.1 0 40 17.9 40 40l0 48c0 22.1-17.9 40-40 40l-48 0c-22.1 0-40-17.9-40-40l0-48c0-22.1 17.9-40 40-40zm192 0l48 0c22.1 0 40 17.9 40 40l0 48c0 22.1-17.9 40-40 40l-48 0c-22.1 0-40-17.9-40-40l0-48c0-22.1 17.9-40 40-40zM40 320c-22.1 0-40-17.9-40-40l0-48c0-22.1 17.9-40 40-40l48 0c22.1 0 40 17.9 40 40l0 48c0 22.1-17.9 40-40 40l-48 0zM232 192l48 0c22.1 0 40 17.9 40 40l0 48c0 22.1-17.9 40-40 40l-48 0c-22.1 0-40-17.9-40-40l0-48c0-22.1 17.9-40 40-40zM40 160c-22.1 0-40-17.9-40-40L0 72C0 49.9 17.9 32 40 32l48 0c22.1 0 40 17.9 40 40l0 48c0 22.1-17.9 40-40 40l-48 0zM232 32l48 0c22.1 0 40 17.9 40 40l0 48c0 22.1-17.9 40-40 40l-48 0c-22.1 0-40-17.9-40-40l0-48c0-22.1 17.9-40 40-40z"
    ]
};
var $d8206b3ab2e65c05$export$2d3ccb9b2099f3fe = {
    prefix: "fas",
    iconName: "arrow-turn-up",
    icon: [
        384,
        512,
        [
            "level-up"
        ],
        "f148",
        "M32 448c-17.7 0-32 14.3-32 32s14.3 32 32 32l96 0c53 0 96-43 96-96l0-306.7 73.4 73.4c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3l-128-128c-12.5-12.5-32.8-12.5-45.3 0l-128 128c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0L160 109.3 160 416c0 17.7-14.3 32-32 32l-96 0z"
    ]
};
var $d8206b3ab2e65c05$export$c227d3ba1de97ceb = $d8206b3ab2e65c05$export$2d3ccb9b2099f3fe;
var $d8206b3ab2e65c05$export$4f39e8dbaf09ea8b = {
    prefix: "fas",
    iconName: "u",
    icon: [
        384,
        512,
        [
            117
        ],
        "55",
        "M32 32c17.7 0 32 14.3 32 32V288c0 70.7 57.3 128 128 128s128-57.3 128-128V64c0-17.7 14.3-32 32-32s32 14.3 32 32V288c0 106-86 192-192 192S0 394 0 288V64C0 46.3 14.3 32 32 32z"
    ]
};
var $d8206b3ab2e65c05$export$60b44cfa7af18422 = {
    prefix: "fas",
    iconName: "square-root-variable",
    icon: [
        576,
        512,
        [
            "square-root-alt"
        ],
        "f698",
        "M282.6 78.1c8-27.3 33-46.1 61.4-46.1H544c17.7 0 32 14.3 32 32s-14.3 32-32 32H344L238.7 457c-3.6 12.3-14.1 21.2-26.8 22.8s-25.1-4.6-31.5-15.6L77.6 288H32c-17.7 0-32-14.3-32-32s14.3-32 32-32H77.6c22.8 0 43.8 12.1 55.3 31.8l65.2 111.8L282.6 78.1zM393.4 233.4c12.5-12.5 32.8-12.5 45.3 0L480 274.7l41.4-41.4c12.5-12.5 32.8-12.5 45.3 0s12.5 32.8 0 45.3L525.3 320l41.4 41.4c12.5 12.5 12.5 32.8 0 45.3s-32.8 12.5-45.3 0L480 365.3l-41.4 41.4c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3L434.7 320l-41.4-41.4c-12.5-12.5-12.5-32.8 0-45.3z"
    ]
};
var $d8206b3ab2e65c05$export$28e4b96627e00057 = $d8206b3ab2e65c05$export$60b44cfa7af18422;
var $d8206b3ab2e65c05$export$95b9968e7fceb821 = {
    prefix: "fas",
    iconName: "clock",
    icon: [
        512,
        512,
        [
            128339,
            "clock-four"
        ],
        "f017",
        "M256 0a256 256 0 1 1 0 512A256 256 0 1 1 256 0zM232 120V256c0 8 4 15.5 10.7 20l96 64c11 7.4 25.9 4.4 33.3-6.7s4.4-25.9-6.7-33.3L280 243.2V120c0-13.3-10.7-24-24-24s-24 10.7-24 24z"
    ]
};
var $d8206b3ab2e65c05$export$9a575facf1cab48f = $d8206b3ab2e65c05$export$95b9968e7fceb821;
var $d8206b3ab2e65c05$export$5d2b6a700940df16 = {
    prefix: "fas",
    iconName: "backward-step",
    icon: [
        320,
        512,
        [
            "step-backward"
        ],
        "f048",
        "M267.5 440.6c9.5 7.9 22.8 9.7 34.1 4.4s18.4-16.6 18.4-29V96c0-12.4-7.2-23.7-18.4-29s-24.5-3.6-34.1 4.4l-192 160L64 241V96c0-17.7-14.3-32-32-32S0 78.3 0 96V416c0 17.7 14.3 32 32 32s32-14.3 32-32V271l11.5 9.6 192 160z"
    ]
};
var $d8206b3ab2e65c05$export$2884e379aed297d4 = $d8206b3ab2e65c05$export$5d2b6a700940df16;
var $d8206b3ab2e65c05$export$d7ff2047dbc34562 = {
    prefix: "fas",
    iconName: "pallet",
    icon: [
        640,
        512,
        [],
        "f482",
        "M32 320c-17.7 0-32 14.3-32 32s14.3 32 32 32H64v64H32c-17.7 0-32 14.3-32 32s14.3 32 32 32H96 320 544h64c17.7 0 32-14.3 32-32s-14.3-32-32-32H576V384h32c17.7 0 32-14.3 32-32s-14.3-32-32-32H544 320 96 32zm96 64H288v64H128V384zm224 0H512v64H352V384z"
    ]
};
var $d8206b3ab2e65c05$export$a0856b225f3b0614 = {
    prefix: "fas",
    iconName: "faucet",
    icon: [
        512,
        512,
        [],
        "e005",
        "M192 96v12L96 96c-17.7 0-32 14.3-32 32s14.3 32 32 32l96-12 31-3.9 1-.1 1 .1 31 3.9 96 12c17.7 0 32-14.3 32-32s-14.3-32-32-32l-96 12V96c0-17.7-14.3-32-32-32s-32 14.3-32 32zM32 256c-17.7 0-32 14.3-32 32v64c0 17.7 14.3 32 32 32H132.1c20.2 29 53.9 48 91.9 48s71.7-19 91.9-48H352c17.7 0 32 14.3 32 32s14.3 32 32 32h64c17.7 0 32-14.3 32-32c0-88.4-71.6-160-160-160H320l-22.6-22.6c-6-6-14.1-9.4-22.6-9.4H256V180.2l-32-4-32 4V224H173.3c-8.5 0-16.6 3.4-22.6 9.4L128 256H32z"
    ]
};
var $d8206b3ab2e65c05$export$59669f486ab41d86 = {
    prefix: "fas",
    iconName: "baseball-bat-ball",
    icon: [
        512,
        512,
        [],
        "f432",
        "M424 0c-12.4 0-24.2 4.9-33 13.7L233.5 171.2c-10.5 10.5-19.8 22.1-27.7 34.6L132.7 321.6c-7.3 11.5-15.8 22.2-25.5 31.9L69.9 390.7l51.3 51.3 37.3-37.3c9.6-9.6 20.3-18.2 31.9-25.5l115.8-73.1c12.5-7.9 24.1-17.2 34.6-27.7L498.3 121c8.7-8.7 13.7-20.6 13.7-33s-4.9-24.2-13.7-33L457 13.7C448.2 4.9 436.4 0 424 0zm88 432a80 80 0 1 0 -160 0 80 80 0 1 0 160 0zM15 399c-9.4 9.4-9.4 24.6 0 33.9l64 64c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9L49 399c-9.4-9.4-24.6-9.4-33.9 0z"
    ]
};
var $d8206b3ab2e65c05$export$cb39585371b75720 = {
    prefix: "fas",
    iconName: "s",
    icon: [
        320,
        512,
        [
            115
        ],
        "53",
        "M99.1 105.4C79 114 68.2 127.2 65.2 144.8c-2.4 14.1-.7 23.2 2 29.4c2.8 6.3 7.9 12.4 16.7 18.6c19.2 13.4 48.3 22.1 84.9 32.5c1 .3 1.9 .6 2.9 .8c32.7 9.3 72 20.6 100.9 40.7c15.7 10.9 29.9 25.5 38.6 45.1c8.8 19.8 10.8 42 6.6 66.3c-7.3 42.5-35.3 71.7-71.8 87.3c-35.4 15.2-79.1 17.9-123.7 10.9l-.2 0 0 0c-24-3.9-62.7-17.1-87.6-25.6c-4.8-1.7-9.2-3.1-12.8-4.3C5.1 440.8-3.9 422.7 1.6 405.9s23.7-25.8 40.5-20.3c4.9 1.6 10.2 3.4 15.9 5.4c25.4 8.6 56.4 19.2 74.4 22.1c36.8 5.7 67.5 2.5 88.5-6.5c20.1-8.6 30.8-21.8 33.9-39.4c2.4-14.1 .7-23.2-2-29.4c-2.8-6.3-7.9-12.4-16.7-18.6c-19.2-13.4-48.3-22.1-84.9-32.5c-1-.3-1.9-.6-2.9-.8c-32.7-9.3-72-20.6-100.9-40.7c-15.7-10.9-29.9-25.5-38.6-45.1c-8.8-19.8-10.8-42-6.6-66.3l31.5 5.5L2.1 133.9C9.4 91.4 37.4 62.2 73.9 46.6c35.4-15.2 79.1-17.9 123.7-10.9c13 2 52.4 9.6 66.6 13.4c17.1 4.5 27.2 22.1 22.7 39.2s-22.1 27.2-39.2 22.7c-11.2-3-48.1-10.2-60.1-12l4.9-31.5-4.9 31.5c-36.9-5.8-67.5-2.5-88.6 6.5z"
    ]
};
var $d8206b3ab2e65c05$export$5e239d90ef904a84 = {
    prefix: "fas",
    iconName: "timeline",
    icon: [
        640,
        512,
        [],
        "e29c",
        "M128 72a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm32 97.3c28.3-12.3 48-40.5 48-73.3c0-44.2-35.8-80-80-80S48 51.8 48 96c0 32.8 19.7 61 48 73.3V224H32c-17.7 0-32 14.3-32 32s14.3 32 32 32H288v54.7c-28.3 12.3-48 40.5-48 73.3c0 44.2 35.8 80 80 80s80-35.8 80-80c0-32.8-19.7-61-48-73.3V288H608c17.7 0 32-14.3 32-32s-14.3-32-32-32H544V169.3c28.3-12.3 48-40.5 48-73.3c0-44.2-35.8-80-80-80s-80 35.8-80 80c0 32.8 19.7 61 48 73.3V224H160V169.3zM488 96a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zM320 392a24 24 0 1 1 0 48 24 24 0 1 1 0-48z"
    ]
};
var $d8206b3ab2e65c05$export$fb61df5d98785fa8 = {
    prefix: "fas",
    iconName: "keyboard",
    icon: [
        576,
        512,
        [
            9000
        ],
        "f11c",
        "M64 64C28.7 64 0 92.7 0 128V384c0 35.3 28.7 64 64 64H512c35.3 0 64-28.7 64-64V128c0-35.3-28.7-64-64-64H64zm16 64h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H80c-8.8 0-16-7.2-16-16V144c0-8.8 7.2-16 16-16zM64 240c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H80c-8.8 0-16-7.2-16-16V240zm16 80h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H80c-8.8 0-16-7.2-16-16V336c0-8.8 7.2-16 16-16zm80-176c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H176c-8.8 0-16-7.2-16-16V144zm16 80h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H176c-8.8 0-16-7.2-16-16V240c0-8.8 7.2-16 16-16zM160 336c0-8.8 7.2-16 16-16H400c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H176c-8.8 0-16-7.2-16-16V336zM272 128h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H272c-8.8 0-16-7.2-16-16V144c0-8.8 7.2-16 16-16zM256 240c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H272c-8.8 0-16-7.2-16-16V240zM368 128h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H368c-8.8 0-16-7.2-16-16V144c0-8.8 7.2-16 16-16zM352 240c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H368c-8.8 0-16-7.2-16-16V240zM464 128h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H464c-8.8 0-16-7.2-16-16V144c0-8.8 7.2-16 16-16zM448 240c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H464c-8.8 0-16-7.2-16-16V240zm16 80h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H464c-8.8 0-16-7.2-16-16V336c0-8.8 7.2-16 16-16z"
    ]
};
var $d8206b3ab2e65c05$export$f9395ef707603e40 = {
    prefix: "fas",
    iconName: "caret-down",
    icon: [
        320,
        512,
        [],
        "f0d7",
        "M137.4 374.6c12.5 12.5 32.8 12.5 45.3 0l128-128c9.2-9.2 11.9-22.9 6.9-34.9s-16.6-19.8-29.6-19.8L32 192c-12.9 0-24.6 7.8-29.6 19.8s-2.2 25.7 6.9 34.9l128 128z"
    ]
};
var $d8206b3ab2e65c05$export$9c73560282dceccd = {
    prefix: "fas",
    iconName: "house-chimney-medical",
    icon: [
        576,
        512,
        [
            "clinic-medical"
        ],
        "f7f2",
        "M575.8 255.5c0 18-15 32.1-32 32.1h-32l.7 160.2c.2 35.5-28.5 64.3-64 64.3H128.1c-35.3 0-64-28.7-64-64V287.6H32c-18 0-32-14-32-32.1c0-9 3-17 10-24L266.4 8c7-7 15-8 22-8s15 2 21 7L416 100.7V64c0-17.7 14.3-32 32-32h32c17.7 0 32 14.3 32 32V185l52.8 46.4c8 7 12 15 11 24zM272 192c-8.8 0-16 7.2-16 16v48H208c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h48v48c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V320h48c8.8 0 16-7.2 16-16V272c0-8.8-7.2-16-16-16H320V208c0-8.8-7.2-16-16-16H272z"
    ]
};
var $d8206b3ab2e65c05$export$20d8a680febc7434 = $d8206b3ab2e65c05$export$9c73560282dceccd;
var $d8206b3ab2e65c05$export$7ed2bad15ae6237f = {
    prefix: "fas",
    iconName: "temperature-three-quarters",
    icon: [
        320,
        512,
        [
            "temperature-3",
            "thermometer-3",
            "thermometer-three-quarters"
        ],
        "f2c8",
        "M160 64c-26.5 0-48 21.5-48 48V276.5c0 17.3-7.1 31.9-15.3 42.5C86.2 332.6 80 349.5 80 368c0 44.2 35.8 80 80 80s80-35.8 80-80c0-18.5-6.2-35.4-16.7-48.9c-8.2-10.6-15.3-25.2-15.3-42.5V112c0-26.5-21.5-48-48-48zM48 112C48 50.2 98.1 0 160 0s112 50.1 112 112V276.5c0 .1 .1 .3 .2 .6c.2 .6 .8 1.6 1.7 2.8c18.9 24.4 30.1 55 30.1 88.1c0 79.5-64.5 144-144 144S16 447.5 16 368c0-33.2 11.2-63.8 30.1-88.1c.9-1.2 1.5-2.2 1.7-2.8c.1-.3 .2-.5 .2-.6V112zM208 368c0 26.5-21.5 48-48 48s-48-21.5-48-48c0-20.9 13.4-38.7 32-45.3V144c0-8.8 7.2-16 16-16s16 7.2 16 16V322.7c18.6 6.6 32 24.4 32 45.3z"
    ]
};
var $d8206b3ab2e65c05$export$89def3268ed9b4bc = $d8206b3ab2e65c05$export$7ed2bad15ae6237f;
var $d8206b3ab2e65c05$export$2f653125f4e6463 = $d8206b3ab2e65c05$export$7ed2bad15ae6237f;
var $d8206b3ab2e65c05$export$6c632d1dc30d4a77 = $d8206b3ab2e65c05$export$7ed2bad15ae6237f;
var $d8206b3ab2e65c05$export$8867e7da34bb8bf4 = {
    prefix: "fas",
    iconName: "mobile-screen",
    icon: [
        384,
        512,
        [
            "mobile-android-alt"
        ],
        "f3cf",
        "M16 64C16 28.7 44.7 0 80 0H304c35.3 0 64 28.7 64 64V448c0 35.3-28.7 64-64 64H80c-35.3 0-64-28.7-64-64V64zM144 448c0 8.8 7.2 16 16 16h64c8.8 0 16-7.2 16-16s-7.2-16-16-16H160c-8.8 0-16 7.2-16 16zM304 64H80V384H304V64z"
    ]
};
var $d8206b3ab2e65c05$export$cb39d7b468ba5838 = $d8206b3ab2e65c05$export$8867e7da34bb8bf4;
var $d8206b3ab2e65c05$export$a5f2976a01fdc970 = {
    prefix: "fas",
    iconName: "plane-up",
    icon: [
        512,
        512,
        [],
        "e22d",
        "M192 93.7C192 59.5 221 0 256 0c36 0 64 59.5 64 93.7l0 66.3L497.8 278.5c8.9 5.9 14.2 15.9 14.2 26.6v56.7c0 10.9-10.7 18.6-21.1 15.2L320 320v80l57.6 43.2c4 3 6.4 7.8 6.4 12.8v42c0 7.8-6.3 14-14 14c-1.3 0-2.6-.2-3.9-.5L256 480 145.9 511.5c-1.3 .4-2.6 .5-3.9 .5c-7.8 0-14-6.3-14-14V456c0-5 2.4-9.8 6.4-12.8L192 400V320L21.1 377C10.7 380.4 0 372.7 0 361.8V305.1c0-10.7 5.3-20.7 14.2-26.6L192 160V93.7z"
    ]
};
var $d8206b3ab2e65c05$export$46d49a6734c4872a = {
    prefix: "fas",
    iconName: "piggy-bank",
    icon: [
        576,
        512,
        [],
        "f4d3",
        "M400 96l0 .7c-5.3-.4-10.6-.7-16-.7H256c-16.5 0-32.5 2.1-47.8 6c-.1-2-.2-4-.2-6c0-53 43-96 96-96s96 43 96 96zm-16 32c3.5 0 7 .1 10.4 .3c4.2 .3 8.4 .7 12.6 1.3C424.6 109.1 450.8 96 480 96h11.5c10.4 0 18 9.8 15.5 19.9l-13.8 55.2c15.8 14.8 28.7 32.8 37.5 52.9H544c17.7 0 32 14.3 32 32v96c0 17.7-14.3 32-32 32H512c-9.1 12.1-19.9 22.9-32 32v64c0 17.7-14.3 32-32 32H416c-17.7 0-32-14.3-32-32V448H256v32c0 17.7-14.3 32-32 32H192c-17.7 0-32-14.3-32-32V416c-34.9-26.2-58.7-66.3-63.2-112H68c-37.6 0-68-30.4-68-68s30.4-68 68-68h4c13.3 0 24 10.7 24 24s-10.7 24-24 24H68c-11 0-20 9-20 20s9 20 20 20H99.2c12.1-59.8 57.7-107.5 116.3-122.8c12.9-3.4 26.5-5.2 40.5-5.2H384zm64 136a24 24 0 1 0 -48 0 24 24 0 1 0 48 0z"
    ]
};
var $d8206b3ab2e65c05$export$e6dadc1155c4ee48 = {
    prefix: "fas",
    iconName: "battery-half",
    icon: [
        576,
        512,
        [
            "battery-3"
        ],
        "f242",
        "M464 160c8.8 0 16 7.2 16 16V336c0 8.8-7.2 16-16 16H80c-8.8 0-16-7.2-16-16V176c0-8.8 7.2-16 16-16H464zM80 96C35.8 96 0 131.8 0 176V336c0 44.2 35.8 80 80 80H464c44.2 0 80-35.8 80-80V320c17.7 0 32-14.3 32-32V224c0-17.7-14.3-32-32-32V176c0-44.2-35.8-80-80-80H80zm208 96H96V320H288V192z"
    ]
};
var $d8206b3ab2e65c05$export$f9138caac2aedaed = $d8206b3ab2e65c05$export$e6dadc1155c4ee48;
var $d8206b3ab2e65c05$export$28f06bbf9c17c3af = {
    prefix: "fas",
    iconName: "mountain-city",
    icon: [
        640,
        512,
        [],
        "e52e",
        "M336 0c-26.5 0-48 21.5-48 48v92.1l71.4 118.4c2.5-1.6 5.4-2.5 8.6-2.5h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16h-3.5l73.8 122.4c12.4 20.6 12.9 46.3 1.2 67.3c-.4 .8-.9 1.6-1.4 2.3H592c26.5 0 48-21.5 48-48V240c0-26.5-21.5-48-48-48H568V120c0-13.3-10.7-24-24-24s-24 10.7-24 24v72H480V48c0-26.5-21.5-48-48-48H336zm32 64h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H368c-8.8 0-16-7.2-16-16V80c0-8.8 7.2-16 16-16zM352 176c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H368c-8.8 0-16-7.2-16-16V176zm160 96c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H528c-8.8 0-16-7.2-16-16V272zm16 80h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H528c-8.8 0-16-7.2-16-16V368c0-8.8 7.2-16 16-16zM224 188.9L283.8 288H223l-48 64-24.6-41.2L224 188.9zm29.4-44.2C247.1 134.3 236 128 224 128s-23.1 6.3-29.4 16.7L5.1 458.9c-6.5 10.8-6.7 24.3-.7 35.3S22 512 34.5 512H413.5c12.5 0 24-6.8 30.1-17.8s5.8-24.5-.7-35.3L253.4 144.7z"
    ]
};
var $d8206b3ab2e65c05$export$bc5da164799a0e = {
    prefix: "fas",
    iconName: "coins",
    icon: [
        512,
        512,
        [],
        "f51e",
        "M512 80c0 18-14.3 34.6-38.4 48c-29.1 16.1-72.5 27.5-122.3 30.9c-3.7-1.8-7.4-3.5-11.3-5C300.6 137.4 248.2 128 192 128c-8.3 0-16.4 .2-24.5 .6l-1.1-.6C142.3 114.6 128 98 128 80c0-44.2 86-80 192-80S512 35.8 512 80zM160.7 161.1c10.2-.7 20.7-1.1 31.3-1.1c62.2 0 117.4 12.3 152.5 31.4C369.3 204.9 384 221.7 384 240c0 4-.7 7.9-2.1 11.7c-4.6 13.2-17 25.3-35 35.5c0 0 0 0 0 0c-.1 .1-.3 .1-.4 .2l0 0 0 0c-.3 .2-.6 .3-.9 .5c-35 19.4-90.8 32-153.6 32c-59.6 0-112.9-11.3-148.2-29.1c-1.9-.9-3.7-1.9-5.5-2.9C14.3 274.6 0 258 0 240c0-34.8 53.4-64.5 128-75.4c10.5-1.5 21.4-2.7 32.7-3.5zM416 240c0-21.9-10.6-39.9-24.1-53.4c28.3-4.4 54.2-11.4 76.2-20.5c16.3-6.8 31.5-15.2 43.9-25.5V176c0 19.3-16.5 37.1-43.8 50.9c-14.6 7.4-32.4 13.7-52.4 18.5c.1-1.8 .2-3.5 .2-5.3zm-32 96c0 18-14.3 34.6-38.4 48c-1.8 1-3.6 1.9-5.5 2.9C304.9 404.7 251.6 416 192 416c-62.8 0-118.6-12.6-153.6-32C14.3 370.6 0 354 0 336V300.6c12.5 10.3 27.6 18.7 43.9 25.5C83.4 342.6 135.8 352 192 352s108.6-9.4 148.1-25.9c7.8-3.2 15.3-6.9 22.4-10.9c6.1-3.4 11.8-7.2 17.2-11.2c1.5-1.1 2.9-2.3 4.3-3.4V304v5.7V336zm32 0V304 278.1c19-4.2 36.5-9.5 52.1-16c16.3-6.8 31.5-15.2 43.9-25.5V272c0 10.5-5 21-14.9 30.9c-16.3 16.3-45 29.7-81.3 38.4c.1-1.7 .2-3.5 .2-5.3zM192 448c56.2 0 108.6-9.4 148.1-25.9c16.3-6.8 31.5-15.2 43.9-25.5V432c0 44.2-86 80-192 80S0 476.2 0 432V396.6c12.5 10.3 27.6 18.7 43.9 25.5C83.4 438.6 135.8 448 192 448z"
    ]
};
var $d8206b3ab2e65c05$export$8d41d1f1ba3f9217 = {
    prefix: "fas",
    iconName: "khanda",
    icon: [
        512,
        512,
        [
            9772
        ],
        "f66d",
        "M245.8 3.7c5.9-4.9 14.6-4.9 20.5 0l48 40c5.9 4.9 7.5 13.2 3.8 19.9l0 0 0 0 0 0 0 0-.1 .1-.3 .6c-.3 .5-.7 1.3-1.2 2.3c-1 2-2.6 5-4.4 8.6c-.5 .9-.9 1.9-1.4 2.9C344.9 97.4 368 134 368 176s-23.1 78.6-57.3 97.8c.5 1 1 2 1.4 2.9c1.8 3.7 3.3 6.6 4.4 8.6c.5 1 .9 1.8 1.2 2.3l.3 .6 .1 .1 0 0 0 0c3.6 6.7 2 15-3.8 19.9L272 343.5v19.8l35.6-24.5 41.1-28.2c42.8-29.4 68.4-78 68.4-130c0-31.1-9.2-61.6-26.5-87.5l-2.8-4.2c-4-6-3.5-14 1.3-19.5s12.7-7 19.2-3.7L401.1 80c7.2-14.3 7.2-14.3 7.2-14.3l0 0 0 0 .1 0 .3 .2 1 .5c.8 .4 2 1.1 3.5 1.9c2.9 1.7 7 4.1 11.8 7.3c9.6 6.4 22.5 16.1 35.4 29c25.7 25.7 52.7 65.6 52.7 119.3c0 53.1-26.4 100.5-51.2 133.6c-12.6 16.7-25.1 30.3-34.5 39.7c-4.7 4.7-8.7 8.4-11.5 10.9c-1.4 1.3-2.5 2.2-3.3 2.9l-.9 .8-.3 .2-.1 .1 0 0 0 0s0 0-10.2-12.3l10.2 12.3c-5.1 4.3-12.4 4.9-18.2 1.6l-75.6-43-32.7 22.5 45.5 31.3c1.8-.4 3.7-.7 5.7-.7c13.3 0 24 10.7 24 24s-10.7 24-24 24c-12.2 0-22.3-9.1-23.8-21L272 423.4v28.9c9.6 5.5 16 15.9 16 27.7c0 17.7-14.3 32-32 32s-32-14.3-32-32c0-11.8 6.4-22.2 16-27.7V424.1l-40.3 27.7C197.8 463.3 187.9 472 176 472c-13.3 0-24-10.7-24-24s10.7-24 24-24c2.2 0 4.4 .3 6.5 .9l45.8-31.5-32.7-22.5-75.6 43c-5.8 3.3-13 2.7-18.2-1.6L112 400c-10.2 12.3-10.2 12.3-10.3 12.3l0 0 0 0-.1-.1-.3-.2-.9-.8c-.8-.7-1.9-1.7-3.3-2.9c-2.8-2.5-6.7-6.2-11.5-10.9c-9.4-9.4-21.9-23-34.5-39.7C26.4 324.5 0 277.1 0 224c0-53.7 26.9-93.6 52.7-119.3c12.9-12.9 25.8-22.6 35.4-29C93 72.5 97 70 99.9 68.4c1.5-.8 2.6-1.5 3.5-1.9l1-.5 .3-.2 .1 0 0 0 0 0s0 0 7.2 14.3l-7.2-14.3c6.5-3.2 14.3-1.7 19.2 3.7s5.3 13.4 1.3 19.5l-2.8 4.2C105.2 119 96 149.5 96 180.6c0 51.9 25.6 100.6 68.4 130l41.1 28.2L240 362.6V343.5l-42.2-35.2c-5.9-4.9-7.5-13.2-3.8-19.9l0 0 0 0 0 0 .1-.1 .3-.6c.3-.5 .7-1.3 1.2-2.3c1-2 2.6-5 4.4-8.6c.5-.9 .9-1.9 1.4-2.9C167.1 254.6 144 218 144 176s23.1-78.6 57.3-97.8c-.5-1-1-2-1.4-2.9c-1.8-3.7-3.3-6.6-4.4-8.6c-.5-1-.9-1.8-1.2-2.3l-.3-.6-.1-.1 0 0 0 0 0 0c-3.6-6.7-2-15 3.8-19.9l48-40zM220.2 122.9c-17 11.5-28.2 31-28.2 53.1s11.2 41.6 28.2 53.1C227 210.2 232 190.9 232 176s-5-34.2-11.8-53.1zm71.5 106.2c17-11.5 28.2-31 28.2-53.1s-11.2-41.6-28.2-53.1C285 141.8 280 161.1 280 176s5 34.2 11.8 53.1z"
    ]
};
var $d8206b3ab2e65c05$export$ea6970ed5a15feb6 = {
    prefix: "fas",
    iconName: "sliders",
    icon: [
        512,
        512,
        [
            "sliders-h"
        ],
        "f1de",
        "M0 416c0 17.7 14.3 32 32 32l54.7 0c12.3 28.3 40.5 48 73.3 48s61-19.7 73.3-48L480 448c17.7 0 32-14.3 32-32s-14.3-32-32-32l-246.7 0c-12.3-28.3-40.5-48-73.3-48s-61 19.7-73.3 48L32 384c-17.7 0-32 14.3-32 32zm128 0a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zM320 256a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm32-80c-32.8 0-61 19.7-73.3 48L32 224c-17.7 0-32 14.3-32 32s14.3 32 32 32l246.7 0c12.3 28.3 40.5 48 73.3 48s61-19.7 73.3-48l54.7 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l-54.7 0c-12.3-28.3-40.5-48-73.3-48zM192 128a32 32 0 1 1 0-64 32 32 0 1 1 0 64zm73.3-64C253 35.7 224.8 16 192 16s-61 19.7-73.3 48L32 64C14.3 64 0 78.3 0 96s14.3 32 32 32l86.7 0c12.3 28.3 40.5 48 73.3 48s61-19.7 73.3-48L480 128c17.7 0 32-14.3 32-32s-14.3-32-32-32L265.3 64z"
    ]
};
var $d8206b3ab2e65c05$export$94d4dcb523f95563 = $d8206b3ab2e65c05$export$ea6970ed5a15feb6;
var $d8206b3ab2e65c05$export$54d16fa2e445d3fe = {
    prefix: "fas",
    iconName: "folder-tree",
    icon: [
        576,
        512,
        [],
        "f802",
        "M64 32C64 14.3 49.7 0 32 0S0 14.3 0 32v96V384c0 35.3 28.7 64 64 64H256V384H64V160H256V96H64V32zM288 192c0 17.7 14.3 32 32 32H544c17.7 0 32-14.3 32-32V64c0-17.7-14.3-32-32-32H445.3c-8.5 0-16.6-3.4-22.6-9.4L409.4 9.4c-6-6-14.1-9.4-22.6-9.4H320c-17.7 0-32 14.3-32 32V192zm0 288c0 17.7 14.3 32 32 32H544c17.7 0 32-14.3 32-32V352c0-17.7-14.3-32-32-32H445.3c-8.5 0-16.6-3.4-22.6-9.4l-13.3-13.3c-6-6-14.1-9.4-22.6-9.4H320c-17.7 0-32 14.3-32 32V480z"
    ]
};
var $d8206b3ab2e65c05$export$882cabd11f4943b8 = {
    prefix: "fas",
    iconName: "network-wired",
    icon: [
        640,
        512,
        [],
        "f6ff",
        "M256 64H384v64H256V64zM240 0c-26.5 0-48 21.5-48 48v96c0 26.5 21.5 48 48 48h48v32H32c-17.7 0-32 14.3-32 32s14.3 32 32 32h96v32H80c-26.5 0-48 21.5-48 48v96c0 26.5 21.5 48 48 48H240c26.5 0 48-21.5 48-48V368c0-26.5-21.5-48-48-48H192V288H448v32H400c-26.5 0-48 21.5-48 48v96c0 26.5 21.5 48 48 48H560c26.5 0 48-21.5 48-48V368c0-26.5-21.5-48-48-48H512V288h96c17.7 0 32-14.3 32-32s-14.3-32-32-32H352V192h48c26.5 0 48-21.5 48-48V48c0-26.5-21.5-48-48-48H240zM96 448V384H224v64H96zm320-64H544v64H416V384z"
    ]
};
var $d8206b3ab2e65c05$export$184725965b3402dc = {
    prefix: "fas",
    iconName: "map-pin",
    icon: [
        320,
        512,
        [
            128205
        ],
        "f276",
        "M16 144a144 144 0 1 1 288 0A144 144 0 1 1 16 144zM160 80c8.8 0 16-7.2 16-16s-7.2-16-16-16c-53 0-96 43-96 96c0 8.8 7.2 16 16 16s16-7.2 16-16c0-35.3 28.7-64 64-64zM128 480V317.1c10.4 1.9 21.1 2.9 32 2.9s21.6-1 32-2.9V480c0 17.7-14.3 32-32 32s-32-14.3-32-32z"
    ]
};
var $d8206b3ab2e65c05$export$38d20d399463edf9 = {
    prefix: "fas",
    iconName: "hamsa",
    icon: [
        512,
        512,
        [],
        "f665",
        "M34.6 288H80c8.8 0 16-7.2 16-16V72c0-22.1 17.9-40 40-40s40 17.9 40 40V204c0 11 9 20 20 20s20-9 20-20V40c0-22.1 17.9-40 40-40s40 17.9 40 40V204c0 11 9 20 20 20s20-9 20-20V72c0-22.1 17.9-40 40-40s40 17.9 40 40V272c0 8.8 7.2 16 16 16h45.4c19.1 0 34.6 15.5 34.6 34.6c0 8.6-3.2 16.9-9 23.3L416.6 441c-41.1 45.2-99.4 71-160.6 71s-119.4-25.8-160.6-71L9 345.9c-5.8-6.4-9-14.7-9-23.3C0 303.5 15.5 288 34.6 288zM256 288c-38.4 0-76.8 35.8-90.6 50.2c-3.6 3.7-5.4 8.7-5.4 13.8s1.8 10.1 5.4 13.8C179.2 380.2 217.6 416 256 416s76.8-35.8 90.6-50.2c3.6-3.7 5.4-8.7 5.4-13.8s-1.8-10.1-5.4-13.8C332.8 323.8 294.4 288 256 288zm0 32a32 32 0 1 1 0 64 32 32 0 1 1 0-64z"
    ]
};
var $d8206b3ab2e65c05$export$875b6c94a4b00ea8 = {
    prefix: "fas",
    iconName: "cent-sign",
    icon: [
        384,
        512,
        [],
        "e3f5",
        "M224 0c17.7 0 32 14.3 32 32V66.7c30.9 5.2 59.2 17.7 83.2 35.8c14.1 10.6 17 30.7 6.4 44.8s-30.7 17-44.8 6.4C279.4 137.5 252.9 128 224 128c-70.7 0-128 57.3-128 128s57.3 128 128 128c28.9 0 55.4-9.5 76.8-25.6c14.1-10.6 34.2-7.8 44.8 6.4s7.8 34.2-6.4 44.8c-24 18-52.4 30.6-83.2 35.8V480c0 17.7-14.3 32-32 32s-32-14.3-32-32V445.3C101.2 430.1 32 351.1 32 256s69.2-174.1 160-189.3V32c0-17.7 14.3-32 32-32z"
    ]
};
var $d8206b3ab2e65c05$export$f9b579ba06048af = {
    prefix: "fas",
    iconName: "flask",
    icon: [
        448,
        512,
        [],
        "f0c3",
        "M288 0H160 128C110.3 0 96 14.3 96 32s14.3 32 32 32V196.8c0 11.8-3.3 23.5-9.5 33.5L10.3 406.2C3.6 417.2 0 429.7 0 442.6C0 480.9 31.1 512 69.4 512H378.6c38.3 0 69.4-31.1 69.4-69.4c0-12.8-3.6-25.4-10.3-36.4L329.5 230.4c-6.2-10.1-9.5-21.7-9.5-33.5V64c17.7 0 32-14.3 32-32s-14.3-32-32-32H288zM192 196.8V64h64V196.8c0 23.7 6.6 46.9 19 67.1L309.5 320h-171L173 263.9c12.4-20.2 19-43.4 19-67.1z"
    ]
};
var $d8206b3ab2e65c05$export$e7b4c26b5857fe9c = {
    prefix: "fas",
    iconName: "person-pregnant",
    icon: [
        384,
        512,
        [],
        "e31e",
        "M192 0a48 48 0 1 1 0 96 48 48 0 1 1 0-96zM120 383c-13.8-3.6-24-16.1-24-31V296.9l-4.6 7.6c-9.1 15.1-28.8 20-43.9 10.9s-20-28.8-10.9-43.9l58.3-97c15-24.9 40.3-41.5 68.7-45.6c4.1-.6 8.2-1 12.5-1h1.1 12.5H192c1.4 0 2.8 .1 4.1 .3c35.7 2.9 65.4 29.3 72.1 65l6.1 32.5c44.3 8.6 77.7 47.5 77.7 94.3v32c0 17.7-14.3 32-32 32H304 264v96c0 17.7-14.3 32-32 32s-32-14.3-32-32V384h-8-8v96c0 17.7-14.3 32-32 32s-32-14.3-32-32V383z"
    ]
};
var $d8206b3ab2e65c05$export$76cc39f249b6864e = {
    prefix: "fas",
    iconName: "wand-sparkles",
    icon: [
        512,
        512,
        [],
        "f72b",
        "M464 6.1c9.5-8.5 24-8.1 33 .9l8 8c9 9 9.4 23.5 .9 33l-85.8 95.9c-2.6 2.9-4.1 6.7-4.1 10.7V176c0 8.8-7.2 16-16 16H384.2c-4.6 0-8.9 1.9-11.9 5.3L100.7 500.9C94.3 508 85.3 512 75.8 512c-8.8 0-17.3-3.5-23.5-9.8L9.7 459.7C3.5 453.4 0 445 0 436.2c0-9.5 4-18.5 11.1-24.8l111.6-99.8c3.4-3 5.3-7.4 5.3-11.9V272c0-8.8 7.2-16 16-16h34.6c3.9 0 7.7-1.5 10.7-4.1L464 6.1zM432 288c3.6 0 6.7 2.4 7.7 5.8l14.8 51.7 51.7 14.8c3.4 1 5.8 4.1 5.8 7.7s-2.4 6.7-5.8 7.7l-51.7 14.8-14.8 51.7c-1 3.4-4.1 5.8-7.7 5.8s-6.7-2.4-7.7-5.8l-14.8-51.7-51.7-14.8c-3.4-1-5.8-4.1-5.8-7.7s2.4-6.7 5.8-7.7l51.7-14.8 14.8-51.7c1-3.4 4.1-5.8 7.7-5.8zM87.7 69.8l14.8 51.7 51.7 14.8c3.4 1 5.8 4.1 5.8 7.7s-2.4 6.7-5.8 7.7l-51.7 14.8L87.7 218.2c-1 3.4-4.1 5.8-7.7 5.8s-6.7-2.4-7.7-5.8L57.5 166.5 5.8 151.7c-3.4-1-5.8-4.1-5.8-7.7s2.4-6.7 5.8-7.7l51.7-14.8L72.3 69.8c1-3.4 4.1-5.8 7.7-5.8s6.7 2.4 7.7 5.8zM208 0c3.7 0 6.9 2.5 7.8 6.1l6.8 27.3 27.3 6.8c3.6 .9 6.1 4.1 6.1 7.8s-2.5 6.9-6.1 7.8l-27.3 6.8-6.8 27.3c-.9 3.6-4.1 6.1-7.8 6.1s-6.9-2.5-7.8-6.1l-6.8-27.3-27.3-6.8c-3.6-.9-6.1-4.1-6.1-7.8s2.5-6.9 6.1-7.8l27.3-6.8 6.8-27.3c.9-3.6 4.1-6.1 7.8-6.1z"
    ]
};
var $d8206b3ab2e65c05$export$7480721bf113be3e = {
    prefix: "fas",
    iconName: "ellipsis-vertical",
    icon: [
        128,
        512,
        [
            "ellipsis-v"
        ],
        "f142",
        "M64 360a56 56 0 1 0 0 112 56 56 0 1 0 0-112zm0-160a56 56 0 1 0 0 112 56 56 0 1 0 0-112zM120 96A56 56 0 1 0 8 96a56 56 0 1 0 112 0z"
    ]
};
var $d8206b3ab2e65c05$export$e58494c7fcb5380 = $d8206b3ab2e65c05$export$7480721bf113be3e;
var $d8206b3ab2e65c05$export$3604f15924cf0b98 = {
    prefix: "fas",
    iconName: "ticket",
    icon: [
        576,
        512,
        [
            127903
        ],
        "f145",
        "M64 64C28.7 64 0 92.7 0 128v64c0 8.8 7.4 15.7 15.7 18.6C34.5 217.1 48 235 48 256s-13.5 38.9-32.3 45.4C7.4 304.3 0 311.2 0 320v64c0 35.3 28.7 64 64 64H512c35.3 0 64-28.7 64-64V320c0-8.8-7.4-15.7-15.7-18.6C541.5 294.9 528 277 528 256s13.5-38.9 32.3-45.4c8.3-2.9 15.7-9.8 15.7-18.6V128c0-35.3-28.7-64-64-64H64zm64 112l0 160c0 8.8 7.2 16 16 16H432c8.8 0 16-7.2 16-16V176c0-8.8-7.2-16-16-16H144c-8.8 0-16 7.2-16 16zM96 160c0-17.7 14.3-32 32-32H448c17.7 0 32 14.3 32 32V352c0 17.7-14.3 32-32 32H128c-17.7 0-32-14.3-32-32V160z"
    ]
};
var $d8206b3ab2e65c05$export$a1cca9928dcf9798 = {
    prefix: "fas",
    iconName: "power-off",
    icon: [
        512,
        512,
        [
            9211
        ],
        "f011",
        "M288 32c0-17.7-14.3-32-32-32s-32 14.3-32 32V256c0 17.7 14.3 32 32 32s32-14.3 32-32V32zM143.5 120.6c13.6-11.3 15.4-31.5 4.1-45.1s-31.5-15.4-45.1-4.1C49.7 115.4 16 181.8 16 256c0 132.5 107.5 240 240 240s240-107.5 240-240c0-74.2-33.8-140.6-86.6-184.6c-13.6-11.3-33.8-9.4-45.1 4.1s-9.4 33.8 4.1 45.1c38.9 32.3 63.5 81 63.5 135.4c0 97.2-78.8 176-176 176s-176-78.8-176-176c0-54.4 24.7-103.1 63.5-135.4z"
    ]
};
var $d8206b3ab2e65c05$export$b356b1dbe7d7f736 = {
    prefix: "fas",
    iconName: "right-long",
    icon: [
        512,
        512,
        [
            "long-arrow-alt-right"
        ],
        "f30b",
        "M334.5 414c8.8 3.8 19 2 26-4.6l144-136c4.8-4.5 7.5-10.8 7.5-17.4s-2.7-12.9-7.5-17.4l-144-136c-7-6.6-17.2-8.4-26-4.6s-14.5 12.5-14.5 22l0 72L32 192c-17.7 0-32 14.3-32 32l0 64c0 17.7 14.3 32 32 32l288 0 0 72c0 9.6 5.7 18.2 14.5 22z"
    ]
};
var $d8206b3ab2e65c05$export$533e1f578f74c066 = $d8206b3ab2e65c05$export$b356b1dbe7d7f736;
var $d8206b3ab2e65c05$export$19357abad396e723 = {
    prefix: "fas",
    iconName: "flag-usa",
    icon: [
        448,
        512,
        [],
        "f74d",
        "M32 0C49.7 0 64 14.3 64 32V48l69-17.2c38.1-9.5 78.3-5.1 113.5 12.5c46.3 23.2 100.8 23.2 147.1 0l9.6-4.8C423.8 28.1 448 43.1 448 66.1v36.1l-44.7 16.2c-42.8 15.6-90 13.9-131.6-4.6l-16.1-7.2c-20.3-9-41.8-14.7-63.6-16.9v32.2c17.4 2.1 34.4 6.7 50.6 13.9l16.1 7.2c49.2 21.9 105 23.8 155.6 5.4L448 136.3v62l-44.7 16.2c-42.8 15.6-90 13.9-131.6-4.6l-16.1-7.2c-40.2-17.9-85-22.5-128.1-13.3L64 203.1v32.7l70.2-15.1c36.4-7.8 74.3-3.9 108.4 11.3l16.1 7.2c49.2 21.9 105 23.8 155.6 5.4L448 232.3v62l-44.7 16.2c-42.8 15.6-90 13.9-131.6-4.6l-16.1-7.2c-40.2-17.9-85-22.5-128.1-13.3L64 299.1v32.7l70.2-15.1c36.4-7.8 74.3-3.9 108.4 11.3l16.1 7.2c49.2 21.9 105 23.8 155.6 5.4L448 328.3v33.5c0 13.3-8.3 25.3-20.8 30l-34.7 13c-46.2 17.3-97.6 14.6-141.7-7.4c-37.9-19-81.3-23.7-122.5-13.4L64 400v80c0 17.7-14.3 32-32 32s-32-14.3-32-32V416 345.5 312.8 249.5 216.8 153.5 120.8 64 32C0 14.3 14.3 0 32 0zm80 96A16 16 0 1 0 80 96a16 16 0 1 0 32 0zm32 0a16 16 0 1 0 0-32 16 16 0 1 0 0 32zm-32 48a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zm32 0a16 16 0 1 0 0-32 16 16 0 1 0 0 32z"
    ]
};
var $d8206b3ab2e65c05$export$e1046cf83da9b7ef = {
    prefix: "fas",
    iconName: "laptop-file",
    icon: [
        640,
        512,
        [],
        "e51d",
        "M128 0C92.7 0 64 28.7 64 64V288H19.2C8.6 288 0 296.6 0 307.2C0 349.6 34.4 384 76.8 384H320V288H128V64H448V96h64V64c0-35.3-28.7-64-64-64H128zM512 128H400c-26.5 0-48 21.5-48 48V464c0 26.5 21.5 48 48 48H592c26.5 0 48-21.5 48-48V256H544c-17.7 0-32-14.3-32-32V128zm32 0v96h96l-96-96z"
    ]
};
var $d8206b3ab2e65c05$export$7c85aba0f9624b29 = {
    prefix: "fas",
    iconName: "tty",
    icon: [
        512,
        512,
        [
            "teletype"
        ],
        "f1e4",
        "M38.3 241.3L15.1 200.6c-9.2-16.2-8.4-36.5 4.5-50C61.4 106.8 144.7 48 256 48s194.6 58.8 236.4 102.6c12.9 13.5 13.7 33.8 4.5 50l-23.1 40.7c-7.5 13.2-23.3 19.3-37.8 14.6l-81.1-26.6c-13.1-4.3-22-16.6-22-30.4V144c-49.6-18.1-104-18.1-153.6 0v54.8c0 13.8-8.9 26.1-22 30.4L76.1 255.8c-14.5 4.7-30.3-1.4-37.8-14.6zM32 336c0-8.8 7.2-16 16-16H80c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H48c-8.8 0-16-7.2-16-16V336zm0 96c0-8.8 7.2-16 16-16H80c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H48c-8.8 0-16-7.2-16-16V432zM144 320h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H144c-8.8 0-16-7.2-16-16V336c0-8.8 7.2-16 16-16zm80 16c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H240c-8.8 0-16-7.2-16-16V336zm112-16h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H336c-8.8 0-16-7.2-16-16V336c0-8.8 7.2-16 16-16zm80 16c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H432c-8.8 0-16-7.2-16-16V336zm16 80h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H432c-8.8 0-16-7.2-16-16V432c0-8.8 7.2-16 16-16zM128 432c0-8.8 7.2-16 16-16H368c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H144c-8.8 0-16-7.2-16-16V432z"
    ]
};
var $d8206b3ab2e65c05$export$14bcd5c43dc736f9 = $d8206b3ab2e65c05$export$7c85aba0f9624b29;
var $d8206b3ab2e65c05$export$2faddf1690e14e11 = {
    prefix: "fas",
    iconName: "diagram-next",
    icon: [
        512,
        512,
        [],
        "e476",
        "M512 160c0 35.3-28.7 64-64 64H280v64h46.1c21.4 0 32.1 25.9 17 41L273 399c-9.4 9.4-24.6 9.4-33.9 0L169 329c-15.1-15.1-4.4-41 17-41H232V224H64c-35.3 0-64-28.7-64-64V96C0 60.7 28.7 32 64 32H448c35.3 0 64 28.7 64 64v64zM448 416V352H365.3l.4-.4c18.4-18.4 20.4-43.7 11-63.6l71.3 0c35.3 0 64 28.7 64 64v64c0 35.3-28.7 64-64 64L64 480c-35.3 0-64-28.7-64-64V352c0-35.3 28.7-64 64-64l71.3 0c-9.4 19.9-7.4 45.2 11 63.6l.4 .4H64v64H210.7l5.7 5.7c21.9 21.9 57.3 21.9 79.2 0l5.7-5.7H448z"
    ]
};
var $d8206b3ab2e65c05$export$b16df914812cedbe = {
    prefix: "fas",
    iconName: "person-rifle",
    icon: [
        576,
        512,
        [],
        "e54e",
        "M265.2 192c25.4 0 49.8 7.1 70.8 19.9V512H144V337.7L90.4 428.3c-11.2 19-35.8 25.3-54.8 14.1s-25.3-35.8-14.1-54.8L97.7 258.8c24.5-41.4 69-66.8 117.1-66.8h50.4zM160 80a80 80 0 1 1 160 0A80 80 0 1 1 160 80zM448 0c8.8 0 16 7.2 16 16V132.3c9.6 5.5 16 15.9 16 27.7V269.3l16-5.3V208c0-8.8 7.2-16 16-16h16c8.8 0 16 7.2 16 16v84.5c0 6.9-4.4 13-10.9 15.2L480 325.3V352h48c8.8 0 16 7.2 16 16v16c0 8.8-7.2 16-16 16H484l23 92.1c2.5 10.1-5.1 19.9-15.5 19.9H432c-8.8 0-16-7.2-16-16V400H400c-17.7 0-32-14.3-32-32V224c0-17.7 14.3-32 32-32V160c0-11.8 6.4-22.2 16-27.7V32c-8.8 0-16-7.2-16-16s7.2-16 16-16h16 16z"
    ]
};
var $d8206b3ab2e65c05$export$bc50edea6e121df5 = {
    prefix: "fas",
    iconName: "house-medical-circle-exclamation",
    icon: [
        640,
        512,
        [],
        "e512",
        "M320 368c0 59.5 29.5 112.1 74.8 144H128.1c-35.3 0-64-28.7-64-64V287.6H32c-18 0-32-14-32-32.1c0-9 3-17 10-24L266.4 8c7-7 15-8 22-8s15 2 21 7L522.1 193.9c-8.5-1.3-17.3-1.9-26.1-1.9c-54.7 0-103.5 24.9-135.8 64H320V208c0-8.8-7.2-16-16-16H272c-8.8 0-16 7.2-16 16v48H208c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h48v48c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16zM496 224a144 144 0 1 1 0 288 144 144 0 1 1 0-288zm0 240a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm0-192c-8.8 0-16 7.2-16 16v80c0 8.8 7.2 16 16 16s16-7.2 16-16V288c0-8.8-7.2-16-16-16z"
    ]
};
var $d8206b3ab2e65c05$export$8e047801a8603af7 = {
    prefix: "fas",
    iconName: "closed-captioning",
    icon: [
        576,
        512,
        [],
        "f20a",
        "M0 96C0 60.7 28.7 32 64 32H512c35.3 0 64 28.7 64 64V416c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96zM200 208c14.2 0 27 6.1 35.8 16c8.8 9.9 24 10.7 33.9 1.9s10.7-24 1.9-33.9c-17.5-19.6-43.1-32-71.5-32c-53 0-96 43-96 96s43 96 96 96c28.4 0 54-12.4 71.5-32c8.8-9.9 8-25-1.9-33.9s-25-8-33.9 1.9c-8.8 9.9-21.6 16-35.8 16c-26.5 0-48-21.5-48-48s21.5-48 48-48zm144 48c0-26.5 21.5-48 48-48c14.2 0 27 6.1 35.8 16c8.8 9.9 24 10.7 33.9 1.9s10.7-24 1.9-33.9c-17.5-19.6-43.1-32-71.5-32c-53 0-96 43-96 96s43 96 96 96c28.4 0 54-12.4 71.5-32c8.8-9.9 8-25-1.9-33.9s-25-8-33.9 1.9c-8.8 9.9-21.6 16-35.8 16c-26.5 0-48-21.5-48-48z"
    ]
};
var $d8206b3ab2e65c05$export$baf9f153991b2ea = {
    prefix: "fas",
    iconName: "person-hiking",
    icon: [
        384,
        512,
        [
            "hiking"
        ],
        "f6ec",
        "M192 48a48 48 0 1 1 96 0 48 48 0 1 1 -96 0zm51.3 182.7L224.2 307l49.7 49.7c9 9 14.1 21.2 14.1 33.9V480c0 17.7-14.3 32-32 32s-32-14.3-32-32V397.3l-73.9-73.9c-15.8-15.8-22.2-38.6-16.9-60.3l20.4-84c8.3-34.1 42.7-54.9 76.7-46.4c19 4.8 35.6 16.4 46.4 32.7L305.1 208H336V184c0-13.3 10.7-24 24-24s24 10.7 24 24v55.8c0 .1 0 .2 0 .2s0 .2 0 .2V488c0 13.3-10.7 24-24 24s-24-10.7-24-24V272H296.6c-16 0-31-8-39.9-21.4l-13.3-20zM81.1 471.9L117.3 334c3 4.2 6.4 8.2 10.1 11.9l41.9 41.9L142.9 488.1c-4.5 17.1-22 27.3-39.1 22.8s-27.3-22-22.8-39.1zm55.5-346L101.4 266.5c-3 12.1-14.9 19.9-27.2 17.9l-47.9-8c-14-2.3-22.9-16.3-19.2-30L31.9 155c9.5-34.8 41.1-59 77.2-59h4.2c15.6 0 27.1 14.7 23.3 29.8z"
    ]
};
var $d8206b3ab2e65c05$export$b2ab0105a901499e = $d8206b3ab2e65c05$export$baf9f153991b2ea;
var $d8206b3ab2e65c05$export$6a6f9cba7a1e5fe4 = {
    prefix: "fas",
    iconName: "venus-double",
    icon: [
        640,
        512,
        [
            9890
        ],
        "f226",
        "M192 288a112 112 0 1 0 0-224 112 112 0 1 0 0 224zM368 176c0 86.3-62.1 158.1-144 173.1V384h32c17.7 0 32 14.3 32 32s-14.3 32-32 32H224v32c0 17.7-14.3 32-32 32s-32-14.3-32-32V448H128c-17.7 0-32-14.3-32-32s14.3-32 32-32h32V349.1C78.1 334.1 16 262.3 16 176C16 78.8 94.8 0 192 0s176 78.8 176 176zM344 318c14.6-15.6 26.8-33.4 36-53c18.8 14.4 42.4 23 68 23c61.9 0 112-50.1 112-112s-50.1-112-112-112c-25.6 0-49.1 8.6-68 23c-9.3-19.5-21.5-37.4-36-53C373.1 12.6 409.1 0 448 0c97.2 0 176 78.8 176 176c0 86.3-62.1 158.1-144 173.1V384h32c17.7 0 32 14.3 32 32s-14.3 32-32 32H480v32c0 17.7-14.3 32-32 32s-32-14.3-32-32V448H384c-17.7 0-32-14.3-32-32s14.3-32 32-32h32V349.1c-26.6-4.9-51.1-15.7-72-31.1z"
    ]
};
var $d8206b3ab2e65c05$export$74f06b41ed2ca28a = {
    prefix: "fas",
    iconName: "images",
    icon: [
        576,
        512,
        [],
        "f302",
        "M160 32c-35.3 0-64 28.7-64 64V320c0 35.3 28.7 64 64 64H512c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H160zM396 138.7l96 144c4.9 7.4 5.4 16.8 1.2 24.6S480.9 320 472 320H328 280 200c-9.2 0-17.6-5.3-21.6-13.6s-2.9-18.2 2.9-25.4l64-80c4.6-5.7 11.4-9 18.7-9s14.2 3.3 18.7 9l17.3 21.6 56-84C360.5 132 368 128 376 128s15.5 4 20 10.7zM192 128a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zM48 120c0-13.3-10.7-24-24-24S0 106.7 0 120V344c0 75.1 60.9 136 136 136H456c13.3 0 24-10.7 24-24s-10.7-24-24-24H136c-48.6 0-88-39.4-88-88V120z"
    ]
};
var $d8206b3ab2e65c05$export$693bd40950ed2c3a = {
    prefix: "fas",
    iconName: "calculator",
    icon: [
        384,
        512,
        [
            128425
        ],
        "f1ec",
        "M64 0C28.7 0 0 28.7 0 64V448c0 35.3 28.7 64 64 64H320c35.3 0 64-28.7 64-64V64c0-35.3-28.7-64-64-64H64zM96 64H288c17.7 0 32 14.3 32 32v32c0 17.7-14.3 32-32 32H96c-17.7 0-32-14.3-32-32V96c0-17.7 14.3-32 32-32zm32 160a32 32 0 1 1 -64 0 32 32 0 1 1 64 0zM96 352a32 32 0 1 1 0-64 32 32 0 1 1 0 64zM64 416c0-17.7 14.3-32 32-32h96c17.7 0 32 14.3 32 32s-14.3 32-32 32H96c-17.7 0-32-14.3-32-32zM192 256a32 32 0 1 1 0-64 32 32 0 1 1 0 64zm32 64a32 32 0 1 1 -64 0 32 32 0 1 1 64 0zm64-64a32 32 0 1 1 0-64 32 32 0 1 1 0 64zm32 64a32 32 0 1 1 -64 0 32 32 0 1 1 64 0zM288 448a32 32 0 1 1 0-64 32 32 0 1 1 0 64z"
    ]
};
var $d8206b3ab2e65c05$export$dace56f632fecf6f = {
    prefix: "fas",
    iconName: "people-pulling",
    icon: [
        576,
        512,
        [],
        "e535",
        "M80 96A48 48 0 1 0 80 0a48 48 0 1 0 0 96zM64 128c-35.3 0-64 28.7-64 64V320c0 17.7 14.3 32 32 32c9.8 0 18.5-4.4 24.4-11.2L80.4 485.3c2.9 17.4 19.4 29.2 36.8 26.3s29.2-19.4 26.3-36.8L123.1 352h15.7l30 134.9c3.8 17.3 20.9 28.1 38.2 24.3s28.1-20.9 24.3-38.2l-57.3-258 116.3 53.8c.5 .3 1.1 .5 1.6 .7c8.6 3.6 18 3.1 25.9-.7c3.4-1.6 6.6-3.9 9.3-6.7c3.1-3.2 5.5-7 7.1-11.4c.1-.3 .2-.7 .3-1l2.5-7.5c5.7-17.1 18.3-30.9 34.7-38.2l8-3.5c1-.4 1.9-.8 2.9-1.2l-16.9 63.5c-5.6 21.1-.1 43.6 14.7 59.7l70.7 77.1 22 88.1c4.3 17.1 21.7 27.6 38.8 23.3s27.6-21.7 23.3-38.8l-23-92.1c-1.9-7.8-5.8-14.9-11.2-20.8l-49.5-54 19.3-65.5 9.6 23c4.4 10.6 12.5 19.3 22.8 24.5l26.7 13.3c15.8 7.9 35 1.5 42.9-14.3s1.5-35-14.3-42.9L537 232.7l-15.3-36.8C504.5 154.8 464.3 128 419.7 128c-22.8 0-45.3 4.8-66.1 14l-8 3.5c-24.4 10.9-44.6 29-58.1 51.6L157.3 136.9C144.7 131 130.9 128 117 128H64zM464 96a48 48 0 1 0 0-96 48 48 0 1 0 0 96zM349.7 335.6l-25 62.4-59.4 59.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0L372.3 441c4.6-4.6 8.2-10.1 10.6-16.1l14.5-36.2-40.7-44.4c-2.5-2.7-4.8-5.6-7-8.6z"
    ]
};
var $d8206b3ab2e65c05$export$328a9baf0f9e3405 = {
    prefix: "fas",
    iconName: "n",
    icon: [
        384,
        512,
        [
            110
        ],
        "4e",
        "M21.1 33.9c12.7-4.6 26.9-.7 35.5 9.6L320 359.6V64c0-17.7 14.3-32 32-32s32 14.3 32 32V448c0 13.5-8.4 25.5-21.1 30.1s-26.9 .7-35.5-9.6L64 152.4V448c0 17.7-14.3 32-32 32s-32-14.3-32-32V64C0 50.5 8.4 38.5 21.1 33.9z"
    ]
};
var $d8206b3ab2e65c05$export$85cb04eaefaf2d8b = {
    prefix: "fas",
    iconName: "cable-car",
    icon: [
        512,
        512,
        [
            128673,
            57551,
            "tram"
        ],
        "f7da",
        "M288 0a32 32 0 1 1 0 64 32 32 0 1 1 0-64zM160 56a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zM32 288c0-35.3 28.7-64 64-64H232V157.5l-203.1 42c-13 2.7-25.7-5.7-28.4-18.6s5.7-25.7 18.6-28.4l232-48 232-48c13-2.7 25.7 5.7 28.4 18.6s-5.7 25.7-18.6 28.4L280 147.5V224H416c35.3 0 64 28.7 64 64V448c0 35.3-28.7 64-64 64H96c-35.3 0-64-28.7-64-64V288zm64 0c-8.8 0-16 7.2-16 16v64c0 8.8 7.2 16 16 16h64c8.8 0 16-7.2 16-16V304c0-8.8-7.2-16-16-16H96zm112 16v64c0 8.8 7.2 16 16 16h64c8.8 0 16-7.2 16-16V304c0-8.8-7.2-16-16-16H224c-8.8 0-16 7.2-16 16zm144-16c-8.8 0-16 7.2-16 16v64c0 8.8 7.2 16 16 16h64c8.8 0 16-7.2 16-16V304c0-8.8-7.2-16-16-16H352z"
    ]
};
var $d8206b3ab2e65c05$export$a7a36674c079f293 = $d8206b3ab2e65c05$export$85cb04eaefaf2d8b;
var $d8206b3ab2e65c05$export$a6c308ee087b4ded = {
    prefix: "fas",
    iconName: "cloud-rain",
    icon: [
        512,
        512,
        [
            127783,
            9926
        ],
        "f73d",
        "M96 320c-53 0-96-43-96-96c0-42.5 27.6-78.6 65.9-91.2C64.7 126.1 64 119.1 64 112C64 50.1 114.1 0 176 0c43.1 0 80.5 24.3 99.2 60c14.7-17.1 36.5-28 60.8-28c44.2 0 80 35.8 80 80c0 5.5-.6 10.8-1.6 16c.5 0 1.1 0 1.6 0c53 0 96 43 96 96s-43 96-96 96H96zm-6.8 52c1.3-2.5 3.9-4 6.8-4s5.4 1.5 6.8 4l35.1 64.6c4.1 7.5 6.2 15.8 6.2 24.3v3c0 26.5-21.5 48-48 48s-48-21.5-48-48v-3c0-8.5 2.1-16.9 6.2-24.3L89.2 372zm160 0c1.3-2.5 3.9-4 6.8-4s5.4 1.5 6.8 4l35.1 64.6c4.1 7.5 6.2 15.8 6.2 24.3v3c0 26.5-21.5 48-48 48s-48-21.5-48-48v-3c0-8.5 2.1-16.9 6.2-24.3L249.2 372zm124.9 64.6L409.2 372c1.3-2.5 3.9-4 6.8-4s5.4 1.5 6.8 4l35.1 64.6c4.1 7.5 6.2 15.8 6.2 24.3v3c0 26.5-21.5 48-48 48s-48-21.5-48-48v-3c0-8.5 2.1-16.9 6.2-24.3z"
    ]
};
var $d8206b3ab2e65c05$export$c4c015418a1f24df = {
    prefix: "fas",
    iconName: "building-circle-xmark",
    icon: [
        640,
        512,
        [],
        "e4d4",
        "M48 0C21.5 0 0 21.5 0 48V464c0 26.5 21.5 48 48 48h96V432c0-26.5 21.5-48 48-48s48 21.5 48 48v80h96c15.1 0 28.5-6.9 37.3-17.8C340.4 462.2 320 417.5 320 368c0-54.7 24.9-103.5 64-135.8V48c0-26.5-21.5-48-48-48H48zM64 240c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H80c-8.8 0-16-7.2-16-16V240zm112-16h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H176c-8.8 0-16-7.2-16-16V240c0-8.8 7.2-16 16-16zm80 16c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H272c-8.8 0-16-7.2-16-16V240zM80 96h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H80c-8.8 0-16-7.2-16-16V112c0-8.8 7.2-16 16-16zm80 16c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H176c-8.8 0-16-7.2-16-16V112zM272 96h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H272c-8.8 0-16-7.2-16-16V112c0-8.8 7.2-16 16-16zM496 512a144 144 0 1 0 0-288 144 144 0 1 0 0 288zm59.3-180.7L518.6 368l36.7 36.7c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0L496 390.6l-36.7 36.7c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6L473.4 368l-36.7-36.7c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0L496 345.4l36.7-36.7c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6z"
    ]
};
var $d8206b3ab2e65c05$export$6c645741140616af = {
    prefix: "fas",
    iconName: "ship",
    icon: [
        576,
        512,
        [
            128674
        ],
        "f21a",
        "M192 32c0-17.7 14.3-32 32-32H352c17.7 0 32 14.3 32 32V64h48c26.5 0 48 21.5 48 48V240l44.4 14.8c23.1 7.7 29.5 37.5 11.5 53.9l-101 92.6c-16.2 9.4-34.7 15.1-50.9 15.1c-19.6 0-40.8-7.7-59.2-20.3c-22.1-15.5-51.6-15.5-73.7 0c-17.1 11.8-38 20.3-59.2 20.3c-16.2 0-34.7-5.7-50.9-15.1l-101-92.6c-18-16.5-11.6-46.2 11.5-53.9L96 240V112c0-26.5 21.5-48 48-48h48V32zM160 218.7l107.8-35.9c13.1-4.4 27.3-4.4 40.5 0L416 218.7V128H160v90.7zM306.5 421.9C329 437.4 356.5 448 384 448c26.9 0 55.4-10.8 77.4-26.1l0 0c11.9-8.5 28.1-7.8 39.2 1.7c14.4 11.9 32.5 21 50.6 25.2c17.2 4 27.9 21.2 23.9 38.4s-21.2 27.9-38.4 23.9c-24.5-5.7-44.9-16.5-58.2-25C449.5 501.7 417 512 384 512c-31.9 0-60.6-9.9-80.4-18.9c-5.8-2.7-11.1-5.3-15.6-7.7c-4.5 2.4-9.7 5.1-15.6 7.7c-19.8 9-48.5 18.9-80.4 18.9c-33 0-65.5-10.3-94.5-25.8c-13.4 8.4-33.7 19.3-58.2 25c-17.2 4-34.4-6.7-38.4-23.9s6.7-34.4 23.9-38.4c18.1-4.2 36.2-13.3 50.6-25.2c11.1-9.4 27.3-10.1 39.2-1.7l0 0C136.7 437.2 165.1 448 192 448c27.5 0 55-10.6 77.5-26.1c11.1-7.9 25.9-7.9 37 0z"
    ]
};
var $d8206b3ab2e65c05$export$8f2463c7b2fc6ae4 = {
    prefix: "fas",
    iconName: "arrows-down-to-line",
    icon: [
        576,
        512,
        [],
        "e4b8",
        "M544 416L32 416c-17.7 0-32 14.3-32 32s14.3 32 32 32l512 0c17.7 0 32-14.3 32-32s-14.3-32-32-32zm22.6-137.4c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L480 274.7 480 64c0-17.7-14.3-32-32-32s-32 14.3-32 32l0 210.7-41.4-41.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3l96 96c12.5 12.5 32.8 12.5 45.3 0l96-96zm-320-45.3c-12.5-12.5-32.8-12.5-45.3 0L160 274.7 160 64c0-17.7-14.3-32-32-32s-32 14.3-32 32l0 210.7L54.6 233.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3l96 96c12.5 12.5 32.8 12.5 45.3 0l96-96c12.5-12.5 12.5-32.8 0-45.3z"
    ]
};
var $d8206b3ab2e65c05$export$8f734e51d72ca13a = {
    prefix: "fas",
    iconName: "download",
    icon: [
        512,
        512,
        [],
        "f019",
        "M288 32c0-17.7-14.3-32-32-32s-32 14.3-32 32V274.7l-73.4-73.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3l128 128c12.5 12.5 32.8 12.5 45.3 0l128-128c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L288 274.7V32zM64 352c-35.3 0-64 28.7-64 64v32c0 35.3 28.7 64 64 64H448c35.3 0 64-28.7 64-64V416c0-35.3-28.7-64-64-64H346.5l-45.3 45.3c-25 25-65.5 25-90.5 0L165.5 352H64zm368 56a24 24 0 1 1 0 48 24 24 0 1 1 0-48z"
    ]
};
var $d8206b3ab2e65c05$export$92292137ef3cf4c8 = {
    prefix: "fas",
    iconName: "face-grin",
    icon: [
        512,
        512,
        [
            128512,
            "grin"
        ],
        "f580",
        "M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM388.1 312.8c12.3-3.8 24.3 6.9 19.3 18.7C382.4 390.6 324.2 432 256.3 432s-126.2-41.4-151.1-100.5c-5-11.8 7-22.5 19.3-18.7c39.7 12.2 84.5 19 131.8 19s92.1-6.8 131.8-19zM144.4 208a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm192-32a32 32 0 1 1 0 64 32 32 0 1 1 0-64z"
    ]
};
var $d8206b3ab2e65c05$export$37e1f10b6de76621 = $d8206b3ab2e65c05$export$92292137ef3cf4c8;
var $d8206b3ab2e65c05$export$bbcc9e0b6022772b = {
    prefix: "fas",
    iconName: "delete-left",
    icon: [
        576,
        512,
        [
            9003,
            "backspace"
        ],
        "f55a",
        "M576 128c0-35.3-28.7-64-64-64H205.3c-17 0-33.3 6.7-45.3 18.7L9.4 233.4c-6 6-9.4 14.1-9.4 22.6s3.4 16.6 9.4 22.6L160 429.3c12 12 28.3 18.7 45.3 18.7H512c35.3 0 64-28.7 64-64V128zM271 175c9.4-9.4 24.6-9.4 33.9 0l47 47 47-47c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9l-47 47 47 47c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0l-47-47-47 47c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l47-47-47-47c-9.4-9.4-9.4-24.6 0-33.9z"
    ]
};
var $d8206b3ab2e65c05$export$e43e3f67102fc526 = $d8206b3ab2e65c05$export$bbcc9e0b6022772b;
var $d8206b3ab2e65c05$export$1bc3e0ad56dc9eb0 = {
    prefix: "fas",
    iconName: "eye-dropper",
    icon: [
        512,
        512,
        [
            "eye-dropper-empty",
            "eyedropper"
        ],
        "f1fb",
        "M341.6 29.2L240.1 130.8l-9.4-9.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3l160 160c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3l-9.4-9.4L482.8 170.4c39-39 39-102.2 0-141.1s-102.2-39-141.1 0zM55.4 323.3c-15 15-23.4 35.4-23.4 56.6v42.4L5.4 462.2c-8.5 12.7-6.8 29.6 4 40.4s27.7 12.5 40.4 4L89.7 480h42.4c21.2 0 41.6-8.4 56.6-23.4L309.4 335.9l-45.3-45.3L143.4 411.3c-3 3-7.1 4.7-11.3 4.7H96V379.9c0-4.2 1.7-8.3 4.7-11.3L221.4 247.9l-45.3-45.3L55.4 323.3z"
    ]
};
var $d8206b3ab2e65c05$export$ef304e9b7524c1f9 = $d8206b3ab2e65c05$export$1bc3e0ad56dc9eb0;
var $d8206b3ab2e65c05$export$91549a375c0b6d25 = $d8206b3ab2e65c05$export$1bc3e0ad56dc9eb0;
var $d8206b3ab2e65c05$export$8547e9f3a2ddab5b = {
    prefix: "fas",
    iconName: "file-circle-check",
    icon: [
        576,
        512,
        [],
        "e5a0",
        "M0 64C0 28.7 28.7 0 64 0H224V128c0 17.7 14.3 32 32 32H384v38.6C310.1 219.5 256 287.4 256 368c0 59.1 29.1 111.3 73.7 143.3c-3.2 .5-6.4 .7-9.7 .7H64c-35.3 0-64-28.7-64-64V64zm384 64H256V0L384 128zM288 368a144 144 0 1 1 288 0 144 144 0 1 1 -288 0zm211.3-43.3c-6.2-6.2-16.4-6.2-22.6 0L416 385.4l-28.7-28.7c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6l40 40c6.2 6.2 16.4 6.2 22.6 0l72-72c6.2-6.2 6.2-16.4 0-22.6z"
    ]
};
var $d8206b3ab2e65c05$export$a8710cdb23198d53 = {
    prefix: "fas",
    iconName: "forward",
    icon: [
        512,
        512,
        [
            9193
        ],
        "f04e",
        "M52.5 440.6c-9.5 7.9-22.8 9.7-34.1 4.4S0 428.4 0 416V96C0 83.6 7.2 72.3 18.4 67s24.5-3.6 34.1 4.4L224 214.3V256v41.7L52.5 440.6zM256 352V256 128 96c0-12.4 7.2-23.7 18.4-29s24.5-3.6 34.1 4.4l192 160c7.3 6.1 11.5 15.1 11.5 24.6s-4.2 18.5-11.5 24.6l-192 160c-9.5 7.9-22.8 9.7-34.1 4.4s-18.4-16.6-18.4-29V352z"
    ]
};
var $d8206b3ab2e65c05$export$59edacfad04cd121 = {
    prefix: "fas",
    iconName: "mobile",
    icon: [
        384,
        512,
        [
            128241,
            "mobile-android",
            "mobile-phone"
        ],
        "f3ce",
        "M80 0C44.7 0 16 28.7 16 64V448c0 35.3 28.7 64 64 64H304c35.3 0 64-28.7 64-64V64c0-35.3-28.7-64-64-64H80zm80 432h64c8.8 0 16 7.2 16 16s-7.2 16-16 16H160c-8.8 0-16-7.2-16-16s7.2-16 16-16z"
    ]
};
var $d8206b3ab2e65c05$export$82f602311a698c32 = $d8206b3ab2e65c05$export$59edacfad04cd121;
var $d8206b3ab2e65c05$export$475a9be8da747e57 = $d8206b3ab2e65c05$export$59edacfad04cd121;
var $d8206b3ab2e65c05$export$dc130582748497c6 = {
    prefix: "fas",
    iconName: "face-meh",
    icon: [
        512,
        512,
        [
            128528,
            "meh"
        ],
        "f11a",
        "M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM176.4 176a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm128 32a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zM160 336H352c8.8 0 16 7.2 16 16s-7.2 16-16 16H160c-8.8 0-16-7.2-16-16s7.2-16 16-16z"
    ]
};
var $d8206b3ab2e65c05$export$6d2db489aaeeecd2 = $d8206b3ab2e65c05$export$dc130582748497c6;
var $d8206b3ab2e65c05$export$70e29dd05344623e = {
    prefix: "fas",
    iconName: "align-center",
    icon: [
        448,
        512,
        [],
        "f037",
        "M352 64c0-17.7-14.3-32-32-32H128c-17.7 0-32 14.3-32 32s14.3 32 32 32H320c17.7 0 32-14.3 32-32zm96 128c0-17.7-14.3-32-32-32H32c-17.7 0-32 14.3-32 32s14.3 32 32 32H416c17.7 0 32-14.3 32-32zM0 448c0 17.7 14.3 32 32 32H416c17.7 0 32-14.3 32-32s-14.3-32-32-32H32c-17.7 0-32 14.3-32 32zM352 320c0-17.7-14.3-32-32-32H128c-17.7 0-32 14.3-32 32s14.3 32 32 32H320c17.7 0 32-14.3 32-32z"
    ]
};
var $d8206b3ab2e65c05$export$a57d448e8969ce8a = {
    prefix: "fas",
    iconName: "book-skull",
    icon: [
        448,
        512,
        [
            "book-dead"
        ],
        "f6b7",
        "M0 96C0 43 43 0 96 0H384h32c17.7 0 32 14.3 32 32V352c0 17.7-14.3 32-32 32v64c17.7 0 32 14.3 32 32s-14.3 32-32 32H384 96c-53 0-96-43-96-96V96zM64 416c0 17.7 14.3 32 32 32H352V384H96c-17.7 0-32 14.3-32 32zM320 112c0-35.3-35.8-64-80-64s-80 28.7-80 64c0 20.9 12.6 39.5 32 51.2V176c0 8.8 7.2 16 16 16h64c8.8 0 16-7.2 16-16V163.2c19.4-11.7 32-30.3 32-51.2zM208 96a16 16 0 1 1 0 32 16 16 0 1 1 0-32zm48 16a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zM134.3 209.3c-8.1-3.5-17.5 .3-21 8.4s.3 17.5 8.4 21L199.4 272l-77.7 33.3c-8.1 3.5-11.9 12.9-8.4 21s12.9 11.9 21 8.4L240 289.4l105.7 45.3c8.1 3.5 17.5-.3 21-8.4s-.3-17.5-8.4-21L280.6 272l77.7-33.3c8.1-3.5 11.9-12.9 8.4-21s-12.9-11.9-21-8.4L240 254.6 134.3 209.3z"
    ]
};
var $d8206b3ab2e65c05$export$b98a3f8c3941a74a = $d8206b3ab2e65c05$export$a57d448e8969ce8a;
var $d8206b3ab2e65c05$export$782ac893fc22249b = {
    prefix: "fas",
    iconName: "id-card",
    icon: [
        576,
        512,
        [
            62147,
            "drivers-license"
        ],
        "f2c2",
        "M0 96l576 0c0-35.3-28.7-64-64-64H64C28.7 32 0 60.7 0 96zm0 32V416c0 35.3 28.7 64 64 64H512c35.3 0 64-28.7 64-64V128H0zM64 405.3c0-29.5 23.9-53.3 53.3-53.3H234.7c29.5 0 53.3 23.9 53.3 53.3c0 5.9-4.8 10.7-10.7 10.7H74.7c-5.9 0-10.7-4.8-10.7-10.7zM176 192a64 64 0 1 1 0 128 64 64 0 1 1 0-128zm176 16c0-8.8 7.2-16 16-16H496c8.8 0 16 7.2 16 16s-7.2 16-16 16H368c-8.8 0-16-7.2-16-16zm0 64c0-8.8 7.2-16 16-16H496c8.8 0 16 7.2 16 16s-7.2 16-16 16H368c-8.8 0-16-7.2-16-16zm0 64c0-8.8 7.2-16 16-16H496c8.8 0 16 7.2 16 16s-7.2 16-16 16H368c-8.8 0-16-7.2-16-16z"
    ]
};
var $d8206b3ab2e65c05$export$8359c70e609eff64 = $d8206b3ab2e65c05$export$782ac893fc22249b;
var $d8206b3ab2e65c05$export$e21cfc4f23776bff = {
    prefix: "fas",
    iconName: "outdent",
    icon: [
        448,
        512,
        [
            "dedent"
        ],
        "f03b",
        "M0 64C0 46.3 14.3 32 32 32H416c17.7 0 32 14.3 32 32s-14.3 32-32 32H32C14.3 96 0 81.7 0 64zM192 192c0-17.7 14.3-32 32-32H416c17.7 0 32 14.3 32 32s-14.3 32-32 32H224c-17.7 0-32-14.3-32-32zm32 96H416c17.7 0 32 14.3 32 32s-14.3 32-32 32H224c-17.7 0-32-14.3-32-32s14.3-32 32-32zM0 448c0-17.7 14.3-32 32-32H416c17.7 0 32 14.3 32 32s-14.3 32-32 32H32c-17.7 0-32-14.3-32-32zM.2 268.6c-8.2-6.4-8.2-18.9 0-25.3l101.9-79.3c10.5-8.2 25.8-.7 25.8 12.6V335.3c0 13.3-15.3 20.8-25.8 12.6L.2 268.6z"
    ]
};
var $d8206b3ab2e65c05$export$cbffb369d9299db7 = $d8206b3ab2e65c05$export$e21cfc4f23776bff;
var $d8206b3ab2e65c05$export$3772719b170306e2 = {
    prefix: "fas",
    iconName: "heart-circle-exclamation",
    icon: [
        576,
        512,
        [],
        "e4fe",
        "M47.6 300.4L228.3 469.1c7.5 7 17.4 10.9 27.7 10.9s20.2-3.9 27.7-10.9l2.6-2.4C267.2 438.6 256 404.6 256 368c0-97.2 78.8-176 176-176c28.3 0 55 6.7 78.7 18.5c.9-6.5 1.3-13 1.3-19.6v-5.8c0-69.9-50.5-129.5-119.4-141C347 36.5 300.6 51.4 268 84L256 96 244 84c-32.6-32.6-79-47.5-124.6-39.9C50.5 55.6 0 115.2 0 185.1v5.8c0 41.5 17.2 81.2 47.6 109.5zM432 512a144 144 0 1 0 0-288 144 144 0 1 0 0 288zm0-96a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm0-144c8.8 0 16 7.2 16 16v80c0 8.8-7.2 16-16 16s-16-7.2-16-16V288c0-8.8 7.2-16 16-16z"
    ]
};
var $d8206b3ab2e65c05$export$dcadc0d67468dfa8 = {
    prefix: "fas",
    iconName: "house",
    icon: [
        576,
        512,
        [
            127968,
            63498,
            63500,
            "home",
            "home-alt",
            "home-lg-alt"
        ],
        "f015",
        "M575.8 255.5c0 18-15 32.1-32 32.1h-32l.7 160.2c0 2.7-.2 5.4-.5 8.1V472c0 22.1-17.9 40-40 40H456c-1.1 0-2.2 0-3.3-.1c-1.4 .1-2.8 .1-4.2 .1H416 392c-22.1 0-40-17.9-40-40V448 384c0-17.7-14.3-32-32-32H256c-17.7 0-32 14.3-32 32v64 24c0 22.1-17.9 40-40 40H160 128.1c-1.5 0-3-.1-4.5-.2c-1.2 .1-2.4 .2-3.6 .2H104c-22.1 0-40-17.9-40-40V360c0-.9 0-1.9 .1-2.8V287.6H32c-18 0-32-14-32-32.1c0-9 3-17 10-24L266.4 8c7-7 15-8 22-8s15 2 21 7L564.8 231.5c8 7 12 15 11 24z"
    ]
};
var $d8206b3ab2e65c05$export$48f10d71ec526479 = $d8206b3ab2e65c05$export$dcadc0d67468dfa8;
var $d8206b3ab2e65c05$export$279659c4b23dbedb = $d8206b3ab2e65c05$export$dcadc0d67468dfa8;
var $d8206b3ab2e65c05$export$20d6d52d45f53262 = $d8206b3ab2e65c05$export$dcadc0d67468dfa8;
var $d8206b3ab2e65c05$export$39be5cb4aed5a521 = {
    prefix: "fas",
    iconName: "calendar-week",
    icon: [
        448,
        512,
        [],
        "f784",
        "M128 0c17.7 0 32 14.3 32 32V64H288V32c0-17.7 14.3-32 32-32s32 14.3 32 32V64h48c26.5 0 48 21.5 48 48v48H0V112C0 85.5 21.5 64 48 64H96V32c0-17.7 14.3-32 32-32zM0 192H448V464c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V192zm80 64c-8.8 0-16 7.2-16 16v64c0 8.8 7.2 16 16 16H368c8.8 0 16-7.2 16-16V272c0-8.8-7.2-16-16-16H80z"
    ]
};
var $d8206b3ab2e65c05$export$ba2fa38f7bcc6930 = {
    prefix: "fas",
    iconName: "laptop-medical",
    icon: [
        640,
        512,
        [],
        "f812",
        "M64 96c0-35.3 28.7-64 64-64H512c35.3 0 64 28.7 64 64V352H512V96H128V352H64V96zM0 403.2C0 392.6 8.6 384 19.2 384H620.8c10.6 0 19.2 8.6 19.2 19.2c0 42.4-34.4 76.8-76.8 76.8H76.8C34.4 480 0 445.6 0 403.2zM288 160c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v48h48c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H352v48c0 8.8-7.2 16-16 16H304c-8.8 0-16-7.2-16-16V272H240c-8.8 0-16-7.2-16-16V224c0-8.8 7.2-16 16-16h48V160z"
    ]
};
var $d8206b3ab2e65c05$export$fa30fcd1e0d0d8 = {
    prefix: "fas",
    iconName: "b",
    icon: [
        320,
        512,
        [
            98
        ],
        "42",
        "M64 32C28.7 32 0 60.7 0 96V256 416c0 35.3 28.7 64 64 64H192c70.7 0 128-57.3 128-128c0-46.5-24.8-87.3-62-109.7c18.7-22.3 30-51 30-82.3c0-70.7-57.3-128-128-128H64zm96 192H64V96h96c35.3 0 64 28.7 64 64s-28.7 64-64 64zM64 288h96 32c35.3 0 64 28.7 64 64s-28.7 64-64 64H64V288z"
    ]
};
var $d8206b3ab2e65c05$export$56cbcd962389b090 = {
    prefix: "fas",
    iconName: "file-medical",
    icon: [
        384,
        512,
        [],
        "f477",
        "M64 0C28.7 0 0 28.7 0 64V448c0 35.3 28.7 64 64 64H320c35.3 0 64-28.7 64-64V160H256c-17.7 0-32-14.3-32-32V0H64zM256 0V128H384L256 0zM160 240c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v48h48c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H224v48c0 8.8-7.2 16-16 16H176c-8.8 0-16-7.2-16-16V352H112c-8.8 0-16-7.2-16-16V304c0-8.8 7.2-16 16-16h48V240z"
    ]
};
var $d8206b3ab2e65c05$export$d91800b7be5303b0 = {
    prefix: "fas",
    iconName: "dice-one",
    icon: [
        448,
        512,
        [
            9856
        ],
        "f525",
        "M64 32C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64zM224 224a32 32 0 1 1 0 64 32 32 0 1 1 0-64z"
    ]
};
var $d8206b3ab2e65c05$export$d9933d91e1314d02 = {
    prefix: "fas",
    iconName: "kiwi-bird",
    icon: [
        576,
        512,
        [],
        "f535",
        "M291.2 388.4c31.2-18.8 64.7-36.4 101.1-36.4H448c4.6 0 9.1-.2 13.6-.7l85.3 121.9c4 5.7 11.3 8.2 17.9 6.1s11.2-8.3 11.2-15.3V224c0-70.7-57.3-128-128-128H392.3c-36.4 0-69.9-17.6-101.1-36.4C262.3 42.1 228.3 32 192 32C86 32 0 118 0 224c0 71.1 38.6 133.1 96 166.3V456c0 13.3 10.7 24 24 24s24-10.7 24-24V410c15.3 3.9 31.4 6 48 6c5.4 0 10.7-.2 16-.7V456c0 13.3 10.7 24 24 24s24-10.7 24-24V405.1c12.4-4.4 24.2-10 35.2-16.7zM448 200a24 24 0 1 1 0 48 24 24 0 1 1 0-48z"
    ]
};
var $d8206b3ab2e65c05$export$56b6d3d7d0e67a1c = {
    prefix: "fas",
    iconName: "arrow-right-arrow-left",
    icon: [
        448,
        512,
        [
            8644,
            "exchange"
        ],
        "f0ec",
        "M438.6 150.6c12.5-12.5 12.5-32.8 0-45.3l-96-96c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3L338.7 96 32 96C14.3 96 0 110.3 0 128s14.3 32 32 32l306.7 0-41.4 41.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0l96-96zm-333.3 352c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L109.3 416 416 416c17.7 0 32-14.3 32-32s-14.3-32-32-32l-306.7 0 41.4-41.4c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0l-96 96c-12.5 12.5-12.5 32.8 0 45.3l96 96z"
    ]
};
var $d8206b3ab2e65c05$export$1aab915ca61b734a = $d8206b3ab2e65c05$export$56b6d3d7d0e67a1c;
var $d8206b3ab2e65c05$export$7f465bf410c6eff7 = {
    prefix: "fas",
    iconName: "rotate-right",
    icon: [
        512,
        512,
        [
            "redo-alt",
            "rotate-forward"
        ],
        "f2f9",
        "M463.5 224H472c13.3 0 24-10.7 24-24V72c0-9.7-5.8-18.5-14.8-22.2s-19.3-1.7-26.2 5.2L413.4 96.6c-87.6-86.5-228.7-86.2-315.8 1c-87.5 87.5-87.5 229.3 0 316.8s229.3 87.5 316.8 0c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0c-62.5 62.5-163.8 62.5-226.3 0s-62.5-163.8 0-226.3c62.2-62.2 162.7-62.5 225.3-1L327 183c-6.9 6.9-8.9 17.2-5.2 26.2s12.5 14.8 22.2 14.8H463.5z"
    ]
};
var $d8206b3ab2e65c05$export$50c037520c6cfdc1 = $d8206b3ab2e65c05$export$7f465bf410c6eff7;
var $d8206b3ab2e65c05$export$2507849a0fdd7f64 = $d8206b3ab2e65c05$export$7f465bf410c6eff7;
var $d8206b3ab2e65c05$export$750d52edc1dafc7 = {
    prefix: "fas",
    iconName: "utensils",
    icon: [
        448,
        512,
        [
            127860,
            61685,
            "cutlery"
        ],
        "f2e7",
        "M416 0C400 0 288 32 288 176V288c0 35.3 28.7 64 64 64h32V480c0 17.7 14.3 32 32 32s32-14.3 32-32V352 240 32c0-17.7-14.3-32-32-32zM64 16C64 7.8 57.9 1 49.7 .1S34.2 4.6 32.4 12.5L2.1 148.8C.7 155.1 0 161.5 0 167.9c0 45.9 35.1 83.6 80 87.7V480c0 17.7 14.3 32 32 32s32-14.3 32-32V255.6c44.9-4.1 80-41.8 80-87.7c0-6.4-.7-12.8-2.1-19.1L191.6 12.5c-1.8-8-9.3-13.3-17.4-12.4S160 7.8 160 16V150.2c0 5.4-4.4 9.8-9.8 9.8c-5.1 0-9.3-3.9-9.8-9L127.9 14.6C127.2 6.3 120.3 0 112 0s-15.2 6.3-15.9 14.6L83.7 151c-.5 5.1-4.7 9-9.8 9c-5.4 0-9.8-4.4-9.8-9.8V16zm48.3 152l-.3 0-.3 0 .3-.7 .3 .7z"
    ]
};
var $d8206b3ab2e65c05$export$7034e54a8036c5c8 = $d8206b3ab2e65c05$export$750d52edc1dafc7;
var $d8206b3ab2e65c05$export$63f4908401ded049 = {
    prefix: "fas",
    iconName: "arrow-up-wide-short",
    icon: [
        576,
        512,
        [
            "sort-amount-up"
        ],
        "f161",
        "M151.6 42.4C145.5 35.8 137 32 128 32s-17.5 3.8-23.6 10.4l-88 96c-11.9 13-11.1 33.3 2 45.2s33.3 11.1 45.2-2L96 146.3V448c0 17.7 14.3 32 32 32s32-14.3 32-32V146.3l32.4 35.4c11.9 13 32.2 13.9 45.2 2s13.9-32.2 2-45.2l-88-96zM320 480h32c17.7 0 32-14.3 32-32s-14.3-32-32-32H320c-17.7 0-32 14.3-32 32s14.3 32 32 32zm0-128h96c17.7 0 32-14.3 32-32s-14.3-32-32-32H320c-17.7 0-32 14.3-32 32s14.3 32 32 32zm0-128H480c17.7 0 32-14.3 32-32s-14.3-32-32-32H320c-17.7 0-32 14.3-32 32s14.3 32 32 32zm0-128H544c17.7 0 32-14.3 32-32s-14.3-32-32-32H320c-17.7 0-32 14.3-32 32s14.3 32 32 32z"
    ]
};
var $d8206b3ab2e65c05$export$28ef3e933e4b5364 = $d8206b3ab2e65c05$export$63f4908401ded049;
var $d8206b3ab2e65c05$export$9b53510cf4010e4d = {
    prefix: "fas",
    iconName: "mill-sign",
    icon: [
        384,
        512,
        [],
        "e1ed",
        "M302.1 42.8c5.9-16.6-2.7-35-19.4-40.9s-35 2.7-40.9 19.4L208 116.1c-5.7 4-11.1 8.5-16 13.5C171.7 108.9 143.3 96 112 96c-19.5 0-37.8 5-53.7 13.7C52.5 101.4 42.9 96 32 96C14.3 96 0 110.3 0 128v80V416c0 17.7 14.3 32 32 32s32-14.3 32-32V208c0-26.5 21.5-48 48-48s48 21.5 48 48v42.5L81.9 469.2c-5.9 16.6 2.7 35 19.4 40.9s35-2.7 40.9-19.4l21.4-60C168.9 441 179.6 448 192 448c17.7 0 32-14.3 32-32V261.5l35.7-100c3.9-1 8.1-1.6 12.3-1.6c26.5 0 48 21.5 48 48V416c0 17.7 14.3 32 32 32s32-14.3 32-32V208c0-58.2-44.3-106-101.1-111.5l19.2-53.8z"
    ]
};
var $d8206b3ab2e65c05$export$86079bc65a716451 = {
    prefix: "fas",
    iconName: "bowl-rice",
    icon: [
        512,
        512,
        [],
        "e2eb",
        "M176 56c0-13.3 10.7-24 24-24h16c13.3 0 24 10.7 24 24s-10.7 24-24 24H200c-13.3 0-24-10.7-24-24zm24 48h16c13.3 0 24 10.7 24 24s-10.7 24-24 24H200c-13.3 0-24-10.7-24-24s10.7-24 24-24zM56 176H72c13.3 0 24 10.7 24 24s-10.7 24-24 24H56c-13.3 0-24-10.7-24-24s10.7-24 24-24zM0 283.4C0 268.3 12.3 256 27.4 256H484.6c15.1 0 27.4 12.3 27.4 27.4c0 70.5-44.4 130.7-106.7 154.1L403.5 452c-2 16-15.6 28-31.8 28H140.2c-16.1 0-29.8-12-31.8-28l-1.8-14.4C44.4 414.1 0 353.9 0 283.4zM224 200c0-13.3 10.7-24 24-24h16c13.3 0 24 10.7 24 24s-10.7 24-24 24H248c-13.3 0-24-10.7-24-24zm-96 0c0-13.3 10.7-24 24-24h16c13.3 0 24 10.7 24 24s-10.7 24-24 24H152c-13.3 0-24-10.7-24-24zm-24-96h16c13.3 0 24 10.7 24 24s-10.7 24-24 24H104c-13.3 0-24-10.7-24-24s10.7-24 24-24zm216 96c0-13.3 10.7-24 24-24h16c13.3 0 24 10.7 24 24s-10.7 24-24 24H344c-13.3 0-24-10.7-24-24zm-24-96h16c13.3 0 24 10.7 24 24s-10.7 24-24 24H296c-13.3 0-24-10.7-24-24s10.7-24 24-24zm120 96c0-13.3 10.7-24 24-24h16c13.3 0 24 10.7 24 24s-10.7 24-24 24H440c-13.3 0-24-10.7-24-24zm-24-96h16c13.3 0 24 10.7 24 24s-10.7 24-24 24H392c-13.3 0-24-10.7-24-24s10.7-24 24-24zM296 32h16c13.3 0 24 10.7 24 24s-10.7 24-24 24H296c-13.3 0-24-10.7-24-24s10.7-24 24-24z"
    ]
};
var $d8206b3ab2e65c05$export$138b45e2afb1dfa4 = {
    prefix: "fas",
    iconName: "skull",
    icon: [
        512,
        512,
        [
            128128
        ],
        "f54c",
        "M416 398.9c58.5-41.1 96-104.1 96-174.9C512 100.3 397.4 0 256 0S0 100.3 0 224c0 70.7 37.5 133.8 96 174.9c0 .4 0 .7 0 1.1v64c0 26.5 21.5 48 48 48h48V464c0-8.8 7.2-16 16-16s16 7.2 16 16v48h64V464c0-8.8 7.2-16 16-16s16 7.2 16 16v48h48c26.5 0 48-21.5 48-48V400c0-.4 0-.7 0-1.1zM96 256a64 64 0 1 1 128 0A64 64 0 1 1 96 256zm256-64a64 64 0 1 1 0 128 64 64 0 1 1 0-128z"
    ]
};
var $d8206b3ab2e65c05$export$fd06ff4ce9799eb0 = {
    prefix: "fas",
    iconName: "tower-broadcast",
    icon: [
        576,
        512,
        [
            "broadcast-tower"
        ],
        "f519",
        "M80.3 44C69.8 69.9 64 98.2 64 128s5.8 58.1 16.3 84c6.6 16.4-1.3 35-17.7 41.7s-35-1.3-41.7-17.7C7.4 202.6 0 166.1 0 128S7.4 53.4 20.9 20C27.6 3.6 46.2-4.3 62.6 2.3S86.9 27.6 80.3 44zM555.1 20C568.6 53.4 576 89.9 576 128s-7.4 74.6-20.9 108c-6.6 16.4-25.3 24.3-41.7 17.7S489.1 228.4 495.7 212c10.5-25.9 16.3-54.2 16.3-84s-5.8-58.1-16.3-84C489.1 27.6 497 9 513.4 2.3s35 1.3 41.7 17.7zM352 128c0 23.7-12.9 44.4-32 55.4V480c0 17.7-14.3 32-32 32s-32-14.3-32-32V183.4c-19.1-11.1-32-31.7-32-55.4c0-35.3 28.7-64 64-64s64 28.7 64 64zM170.6 76.8C163.8 92.4 160 109.7 160 128s3.8 35.6 10.6 51.2c7.1 16.2-.3 35.1-16.5 42.1s-35.1-.3-42.1-16.5c-10.3-23.6-16-49.6-16-76.8s5.7-53.2 16-76.8c7.1-16.2 25.9-23.6 42.1-16.5s23.6 25.9 16.5 42.1zM464 51.2c10.3 23.6 16 49.6 16 76.8s-5.7 53.2-16 76.8c-7.1 16.2-25.9 23.6-42.1 16.5s-23.6-25.9-16.5-42.1c6.8-15.6 10.6-32.9 10.6-51.2s-3.8-35.6-10.6-51.2c-7.1-16.2 .3-35.1 16.5-42.1s35.1 .3 42.1 16.5z"
    ]
};
var $d8206b3ab2e65c05$export$f68b38d51f5c0ed = $d8206b3ab2e65c05$export$fd06ff4ce9799eb0;
var $d8206b3ab2e65c05$export$f846b848b3ba3064 = {
    prefix: "fas",
    iconName: "truck-pickup",
    icon: [
        640,
        512,
        [
            128763
        ],
        "f63c",
        "M368.6 96l76.8 96H288V96h80.6zM224 80V192H64c-17.7 0-32 14.3-32 32v64c-17.7 0-32 14.3-32 32s14.3 32 32 32H65.1c-.7 5.2-1.1 10.6-1.1 16c0 61.9 50.1 112 112 112s112-50.1 112-112c0-5.4-.4-10.8-1.1-16h66.3c-.7 5.2-1.1 10.6-1.1 16c0 61.9 50.1 112 112 112s112-50.1 112-112c0-5.4-.4-10.8-1.1-16H608c17.7 0 32-14.3 32-32s-14.3-32-32-32V224c0-17.7-14.3-32-32-32H527.4L418.6 56c-12.1-15.2-30.5-24-50-24H272c-26.5 0-48 21.5-48 48zm0 288a48 48 0 1 1 -96 0 48 48 0 1 1 96 0zm288 0a48 48 0 1 1 -96 0 48 48 0 1 1 96 0z"
    ]
};
var $d8206b3ab2e65c05$export$5608156cc81126e7 = {
    prefix: "fas",
    iconName: "up-long",
    icon: [
        320,
        512,
        [
            "long-arrow-alt-up"
        ],
        "f30c",
        "M318 177.5c3.8-8.8 2-19-4.6-26l-136-144C172.9 2.7 166.6 0 160 0s-12.9 2.7-17.4 7.5l-136 144c-6.6 7-8.4 17.2-4.6 26S14.4 192 24 192H96l0 288c0 17.7 14.3 32 32 32h64c17.7 0 32-14.3 32-32l0-288h72c9.6 0 18.2-5.7 22-14.5z"
    ]
};
var $d8206b3ab2e65c05$export$43c8f2a46326c55f = $d8206b3ab2e65c05$export$5608156cc81126e7;
var $d8206b3ab2e65c05$export$51577929c676143b = {
    prefix: "fas",
    iconName: "stop",
    icon: [
        384,
        512,
        [
            9209
        ],
        "f04d",
        "M0 128C0 92.7 28.7 64 64 64H320c35.3 0 64 28.7 64 64V384c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V128z"
    ]
};
var $d8206b3ab2e65c05$export$e151fe5abf6db993 = {
    prefix: "fas",
    iconName: "code-merge",
    icon: [
        448,
        512,
        [],
        "f387",
        "M80 56a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm32.4 97.2c28-12.4 47.6-40.5 47.6-73.2c0-44.2-35.8-80-80-80S0 35.8 0 80c0 32.8 19.7 61 48 73.3V358.7C19.7 371 0 399.2 0 432c0 44.2 35.8 80 80 80s80-35.8 80-80c0-32.8-19.7-61-48-73.3V272c26.7 20.1 60 32 96 32h86.7c12.3 28.3 40.5 48 73.3 48c44.2 0 80-35.8 80-80s-35.8-80-80-80c-32.8 0-61 19.7-73.3 48H208c-49.9 0-91-38.1-95.6-86.8zM80 408a24 24 0 1 1 0 48 24 24 0 1 1 0-48zM344 272a24 24 0 1 1 48 0 24 24 0 1 1 -48 0z"
    ]
};
var $d8206b3ab2e65c05$export$a9578350255b2b79 = {
    prefix: "fas",
    iconName: "upload",
    icon: [
        512,
        512,
        [],
        "f093",
        "M288 109.3V352c0 17.7-14.3 32-32 32s-32-14.3-32-32V109.3l-73.4 73.4c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3l128-128c12.5-12.5 32.8-12.5 45.3 0l128 128c12.5 12.5 12.5 32.8 0 45.3s-32.8 12.5-45.3 0L288 109.3zM64 352H192c0 35.3 28.7 64 64 64s64-28.7 64-64H448c35.3 0 64 28.7 64 64v32c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V416c0-35.3 28.7-64 64-64zM432 456a24 24 0 1 0 0-48 24 24 0 1 0 0 48z"
    ]
};
var $d8206b3ab2e65c05$export$4cf54a379be7e59a = {
    prefix: "fas",
    iconName: "hurricane",
    icon: [
        384,
        512,
        [],
        "f751",
        "M0 208C0 104.4 75.7 18.5 174.9 2.6C184 1.2 192 8.6 192 17.9V81.2c0 8.4 6.5 15.3 14.7 16.5C307 112.5 384 199 384 303.4c0 103.6-75.7 189.5-174.9 205.4c-9.2 1.5-17.1-5.9-17.1-15.2V430.2c0-8.4-6.5-15.3-14.7-16.5C77 398.9 0 312.4 0 208zm288 48A96 96 0 1 0 96 256a96 96 0 1 0 192 0zm-96-32a32 32 0 1 1 0 64 32 32 0 1 1 0-64z"
    ]
};
var $d8206b3ab2e65c05$export$ac54ffffdb218383 = {
    prefix: "fas",
    iconName: "mound",
    icon: [
        576,
        512,
        [],
        "e52d",
        "M144.1 179.2C173.8 127.7 228.6 96 288 96s114.2 31.7 143.9 83.2L540.4 368c12.3 21.3-3.1 48-27.7 48H63.3c-24.6 0-40-26.6-27.7-48L144.1 179.2z"
    ]
};
var $d8206b3ab2e65c05$export$a3a5de5f6e2513ba = {
    prefix: "fas",
    iconName: "toilet-portable",
    icon: [
        320,
        512,
        [],
        "e583",
        "M0 32V64H320V32c0-17.7-14.3-32-32-32H32C14.3 0 0 14.3 0 32zM24 96H0v24V488c0 13.3 10.7 24 24 24s24-10.7 24-24v-8H272v8c0 13.3 10.7 24 24 24s24-10.7 24-24V120 96H296 24zM256 240v64c0 8.8-7.2 16-16 16s-16-7.2-16-16V240c0-8.8 7.2-16 16-16s16 7.2 16 16z"
    ]
};
var $d8206b3ab2e65c05$export$84021631df0f831b = {
    prefix: "fas",
    iconName: "compact-disc",
    icon: [
        512,
        512,
        [
            128191,
            128192,
            128440
        ],
        "f51f",
        "M0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm256 32a32 32 0 1 1 0-64 32 32 0 1 1 0 64zm-96-32a96 96 0 1 0 192 0 96 96 0 1 0 -192 0zM96 240c0-35 17.5-71.1 45.2-98.8S205 96 240 96c8.8 0 16-7.2 16-16s-7.2-16-16-16c-45.4 0-89.2 22.3-121.5 54.5S64 194.6 64 240c0 8.8 7.2 16 16 16s16-7.2 16-16z"
    ]
};
var $d8206b3ab2e65c05$export$148bcede94488555 = {
    prefix: "fas",
    iconName: "file-arrow-down",
    icon: [
        384,
        512,
        [
            "file-download"
        ],
        "f56d",
        "M64 0C28.7 0 0 28.7 0 64V448c0 35.3 28.7 64 64 64H320c35.3 0 64-28.7 64-64V160H256c-17.7 0-32-14.3-32-32V0H64zM256 0V128H384L256 0zM216 232V334.1l31-31c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9l-72 72c-9.4 9.4-24.6 9.4-33.9 0l-72-72c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l31 31V232c0-13.3 10.7-24 24-24s24 10.7 24 24z"
    ]
};
var $d8206b3ab2e65c05$export$1013b9966d758343 = $d8206b3ab2e65c05$export$148bcede94488555;
var $d8206b3ab2e65c05$export$afb5d0eee7c1bdb = {
    prefix: "fas",
    iconName: "caravan",
    icon: [
        640,
        512,
        [],
        "f8ff",
        "M0 112C0 67.8 35.8 32 80 32H416c88.4 0 160 71.6 160 160V352h32c17.7 0 32 14.3 32 32s-14.3 32-32 32l-32 0H288c0 53-43 96-96 96s-96-43-96-96H80c-44.2 0-80-35.8-80-80V112zM320 352H448V256H416c-8.8 0-16-7.2-16-16s7.2-16 16-16h32V160c0-17.7-14.3-32-32-32H352c-17.7 0-32 14.3-32 32V352zM96 128c-17.7 0-32 14.3-32 32v64c0 17.7 14.3 32 32 32H224c17.7 0 32-14.3 32-32V160c0-17.7-14.3-32-32-32H96zm96 336a48 48 0 1 0 0-96 48 48 0 1 0 0 96z"
    ]
};
var $d8206b3ab2e65c05$export$1639f087457d4f58 = {
    prefix: "fas",
    iconName: "shield-cat",
    icon: [
        512,
        512,
        [],
        "e572",
        "M269.4 2.9C265.2 1 260.7 0 256 0s-9.2 1-13.4 2.9L54.3 82.8c-22 9.3-38.4 31-38.3 57.2c.5 99.2 41.3 280.7 213.6 363.2c16.7 8 36.1 8 52.8 0C454.7 420.7 495.5 239.2 496 140c.1-26.2-16.3-47.9-38.3-57.2L269.4 2.9zM160 154.4c0-5.8 4.7-10.4 10.4-10.4h.2c3.4 0 6.5 1.6 8.5 4.3l40 53.3c3 4 7.8 6.4 12.8 6.4h48c5 0 9.8-2.4 12.8-6.4l40-53.3c2-2.7 5.2-4.3 8.5-4.3h.2c5.8 0 10.4 4.7 10.4 10.4V272c0 53-43 96-96 96s-96-43-96-96V154.4zM216 288a16 16 0 1 0 0-32 16 16 0 1 0 0 32zm96-16a16 16 0 1 0 -32 0 16 16 0 1 0 32 0z"
    ]
};
var $d8206b3ab2e65c05$export$6869964aa308dd31 = {
    prefix: "fas",
    iconName: "bolt",
    icon: [
        448,
        512,
        [
            9889,
            "zap"
        ],
        "f0e7",
        "M349.4 44.6c5.9-13.7 1.5-29.7-10.6-38.5s-28.6-8-39.9 1.8l-256 224c-10 8.8-13.6 22.9-8.9 35.3S50.7 288 64 288H175.5L98.6 467.4c-5.9 13.7-1.5 29.7 10.6 38.5s28.6 8 39.9-1.8l256-224c10-8.8 13.6-22.9 8.9-35.3s-16.6-20.7-30-20.7H272.5L349.4 44.6z"
    ]
};
var $d8206b3ab2e65c05$export$d62abb82664f55ca = $d8206b3ab2e65c05$export$6869964aa308dd31;
var $d8206b3ab2e65c05$export$b80f542550a05ea7 = {
    prefix: "fas",
    iconName: "glass-water",
    icon: [
        384,
        512,
        [],
        "e4f4",
        "M32 0C23.1 0 14.6 3.7 8.6 10.2S-.6 25.4 .1 34.3L28.9 437.7c3 41.9 37.8 74.3 79.8 74.3H275.3c42 0 76.8-32.4 79.8-74.3L383.9 34.3c.6-8.9-2.4-17.6-8.5-24.1S360.9 0 352 0H32zM73 156.5L66.4 64H317.6L311 156.5l-24.2 12.1c-19.4 9.7-42.2 9.7-61.6 0c-20.9-10.4-45.5-10.4-66.4 0c-19.4 9.7-42.2 9.7-61.6 0L73 156.5z"
    ]
};
var $d8206b3ab2e65c05$export$b69c6757012a2267 = {
    prefix: "fas",
    iconName: "oil-well",
    icon: [
        576,
        512,
        [],
        "e532",
        "M528.3 61.3c-11.4-42.7-55.3-68-98-56.6L414.9 8.8C397.8 13.4 387.7 31 392.3 48l24.5 91.4L308.5 167.5l-6.3-18.1C297.7 136.6 285.6 128 272 128s-25.7 8.6-30.2 21.4l-13.6 39L96 222.6V184c0-13.3-10.7-24-24-24s-24 10.7-24 24V448H32c-17.7 0-32 14.3-32 32s14.3 32 32 32H544c17.7 0 32-14.3 32-32s-14.3-32-32-32H406.7L340 257.5l-62.2 16.1L305.3 352H238.7L265 277l-74.6 19.3L137.3 448H96V288.8l337.4-87.5 25.2 94c4.6 17.1 22.1 27.2 39.2 22.6l15.5-4.1c42.7-11.4 68-55.3 56.6-98L528.3 61.3zM205.1 448l11.2-32H327.7l11.2 32H205.1z"
    ]
};
var $d8206b3ab2e65c05$export$4689a147513594a7 = {
    prefix: "fas",
    iconName: "vault",
    icon: [
        576,
        512,
        [],
        "e2c5",
        "M64 0C28.7 0 0 28.7 0 64V416c0 35.3 28.7 64 64 64H80l16 32h64l16-32H400l16 32h64l16-32h16c35.3 0 64-28.7 64-64V64c0-35.3-28.7-64-64-64H64zM224 320a80 80 0 1 0 0-160 80 80 0 1 0 0 160zm0-240a160 160 0 1 1 0 320 160 160 0 1 1 0-320zM480 221.3V336c0 8.8-7.2 16-16 16s-16-7.2-16-16V221.3c-18.6-6.6-32-24.4-32-45.3c0-26.5 21.5-48 48-48s48 21.5 48 48c0 20.9-13.4 38.7-32 45.3z"
    ]
};
var $d8206b3ab2e65c05$export$a9f5c0b9c1e77a6f = {
    prefix: "fas",
    iconName: "mars",
    icon: [
        448,
        512,
        [
            9794
        ],
        "f222",
        "M289.8 46.8c3.7-9 12.5-14.8 22.2-14.8H424c13.3 0 24 10.7 24 24V168c0 9.7-5.8 18.5-14.8 22.2s-19.3 1.7-26.2-5.2l-33.4-33.4L321 204.2c19.5 28.4 31 62.7 31 99.8c0 97.2-78.8 176-176 176S0 401.2 0 304s78.8-176 176-176c37 0 71.4 11.4 99.8 31l52.6-52.6L295 73c-6.9-6.9-8.9-17.2-5.2-26.2zM400 80l0 0h0v0zM176 416a112 112 0 1 0 0-224 112 112 0 1 0 0 224z"
    ]
};
var $d8206b3ab2e65c05$export$505476859b9691c0 = {
    prefix: "fas",
    iconName: "toilet",
    icon: [
        448,
        512,
        [
            128701
        ],
        "f7d8",
        "M24 0C10.7 0 0 10.7 0 24S10.7 48 24 48h8V196.9c-1.9 1.4-3.8 2.9-5.6 4.4C10.9 214.5 0 232.9 0 256c0 46.9 14.3 84.1 37 112.5c14.2 17.7 31.1 31.3 48.5 41.8L65.6 469.9c-3.3 9.8-1.6 20.5 4.4 28.8s15.7 13.3 26 13.3H352c10.3 0 19.9-4.9 26-13.3s7.7-19.1 4.4-28.8l-19.8-59.5c17.4-10.5 34.3-24.1 48.5-41.8c22.7-28.4 37-65.5 37-112.5c0-23.1-10.9-41.5-26.4-54.6c-1.8-1.5-3.7-3-5.6-4.4V48h8c13.3 0 24-10.7 24-24s-10.7-24-24-24H24zM384 256.3c0 1-.3 2.6-3.8 5.6c-4.8 4.1-14 9-29.3 13.4C320.5 284 276.1 288 224 288s-96.5-4-126.9-12.8c-15.3-4.4-24.5-9.3-29.3-13.4c-3.5-3-3.8-4.6-3.8-5.6l0-.3 0-.1c0-1 0-2.5 3.8-5.8c4.8-4.1 14-9 29.3-13.4C127.5 228 171.9 224 224 224s96.5 4 126.9 12.8c15.3 4.4 24.5 9.3 29.3 13.4c3.8 3.2 3.8 4.8 3.8 5.8l0 .1 0 .3zM328.2 384l-.2 .5 0-.5h.2zM112 64h32c8.8 0 16 7.2 16 16s-7.2 16-16 16H112c-8.8 0-16-7.2-16-16s7.2-16 16-16z"
    ]
};
var $d8206b3ab2e65c05$export$94ef668f5108e431 = {
    prefix: "fas",
    iconName: "plane-circle-xmark",
    icon: [
        640,
        512,
        [],
        "e557",
        "M256 0c-35 0-64 59.5-64 93.7v84.6L8.1 283.4c-5 2.8-8.1 8.2-8.1 13.9v65.5c0 10.6 10.2 18.3 20.4 15.4l171.6-49 0 70.9-57.6 43.2c-4 3-6.4 7.8-6.4 12.8v42c0 7.8 6.3 14 14 14c1.3 0 2.6-.2 3.9-.5L256 480l110.1 31.5c1.3 .4 2.6 .5 3.9 .5c6 0 11.1-3.7 13.1-9C344.5 470.7 320 422.2 320 368c0-60.6 30.6-114 77.1-145.6L320 178.3V93.7C320 59.5 292 0 256 0zM496 512a144 144 0 1 0 0-288 144 144 0 1 0 0 288zm59.3-180.7L518.6 368l36.7 36.7c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0L496 390.6l-36.7 36.7c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6L473.4 368l-36.7-36.7c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0L496 345.4l36.7-36.7c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6z"
    ]
};
var $d8206b3ab2e65c05$export$30f1437f5a4e991d = {
    prefix: "fas",
    iconName: "yen-sign",
    icon: [
        320,
        512,
        [
            165,
            "cny",
            "jpy",
            "rmb",
            "yen"
        ],
        "f157",
        "M58.6 46.2C48.8 31.5 29 27.6 14.3 37.4S-4.4 67 5.4 81.7L100.2 224H48c-17.7 0-32 14.3-32 32s14.3 32 32 32h80v32H48c-17.7 0-32 14.3-32 32s14.3 32 32 32h80v64c0 17.7 14.3 32 32 32s32-14.3 32-32V384h80c17.7 0 32-14.3 32-32s-14.3-32-32-32H192V288h80c17.7 0 32-14.3 32-32s-14.3-32-32-32H219.8L314.6 81.7c9.8-14.7 5.8-34.6-8.9-44.4s-34.6-5.8-44.4 8.9L160 198.3 58.6 46.2z"
    ]
};
var $d8206b3ab2e65c05$export$268a23eee8f089a2 = $d8206b3ab2e65c05$export$30f1437f5a4e991d;
var $d8206b3ab2e65c05$export$5460a9192eb79bf5 = $d8206b3ab2e65c05$export$30f1437f5a4e991d;
var $d8206b3ab2e65c05$export$e2a8016afc962883 = $d8206b3ab2e65c05$export$30f1437f5a4e991d;
var $d8206b3ab2e65c05$export$cf914b1afb9455a2 = $d8206b3ab2e65c05$export$30f1437f5a4e991d;
var $d8206b3ab2e65c05$export$1ae0a94c8ba4131a = {
    prefix: "fas",
    iconName: "ruble-sign",
    icon: [
        384,
        512,
        [
            8381,
            "rouble",
            "rub",
            "ruble"
        ],
        "f158",
        "M96 32C78.3 32 64 46.3 64 64V256H32c-17.7 0-32 14.3-32 32s14.3 32 32 32H64v32H32c-17.7 0-32 14.3-32 32s14.3 32 32 32H64v32c0 17.7 14.3 32 32 32s32-14.3 32-32V416H288c17.7 0 32-14.3 32-32s-14.3-32-32-32H128V320H240c79.5 0 144-64.5 144-144s-64.5-144-144-144H96zM240 256H128V96H240c44.2 0 80 35.8 80 80s-35.8 80-80 80z"
    ]
};
var $d8206b3ab2e65c05$export$c5dc3d98c4d8f2a5 = $d8206b3ab2e65c05$export$1ae0a94c8ba4131a;
var $d8206b3ab2e65c05$export$9c4d936240e1f0b1 = $d8206b3ab2e65c05$export$1ae0a94c8ba4131a;
var $d8206b3ab2e65c05$export$6c0cf65134387046 = $d8206b3ab2e65c05$export$1ae0a94c8ba4131a;
var $d8206b3ab2e65c05$export$2fa35dcbc038dbe9 = {
    prefix: "fas",
    iconName: "sun",
    icon: [
        512,
        512,
        [
            9728
        ],
        "f185",
        "M361.5 1.2c5 2.1 8.6 6.6 9.6 11.9L391 121l107.9 19.8c5.3 1 9.8 4.6 11.9 9.6s1.5 10.7-1.6 15.2L446.9 256l62.3 90.3c3.1 4.5 3.7 10.2 1.6 15.2s-6.6 8.6-11.9 9.6L391 391 371.1 498.9c-1 5.3-4.6 9.8-9.6 11.9s-10.7 1.5-15.2-1.6L256 446.9l-90.3 62.3c-4.5 3.1-10.2 3.7-15.2 1.6s-8.6-6.6-9.6-11.9L121 391 13.1 371.1c-5.3-1-9.8-4.6-11.9-9.6s-1.5-10.7 1.6-15.2L65.1 256 2.8 165.7c-3.1-4.5-3.7-10.2-1.6-15.2s6.6-8.6 11.9-9.6L121 121 140.9 13.1c1-5.3 4.6-9.8 9.6-11.9s10.7-1.5 15.2 1.6L256 65.1 346.3 2.8c4.5-3.1 10.2-3.7 15.2-1.6zM160 256a96 96 0 1 1 192 0 96 96 0 1 1 -192 0zm224 0a128 128 0 1 0 -256 0 128 128 0 1 0 256 0z"
    ]
};
var $d8206b3ab2e65c05$export$790dd5b32282b6fb = {
    prefix: "fas",
    iconName: "guitar",
    icon: [
        512,
        512,
        [],
        "f7a6",
        "M465 7c-9.4-9.4-24.6-9.4-33.9 0L383 55c-2.4 2.4-4.3 5.3-5.5 8.5l-15.4 41-77.5 77.6c-45.1-29.4-99.3-30.2-131 1.6c-11 11-18 24.6-21.4 39.6c-3.7 16.6-19.1 30.7-36.1 31.6c-25.6 1.3-49.3 10.7-67.3 28.6C-16 328.4-7.6 409.4 47.5 464.5s136.1 63.5 180.9 18.7c17.9-17.9 27.4-41.7 28.6-67.3c.9-17 15-32.3 31.6-36.1c15-3.4 28.6-10.5 39.6-21.4c31.8-31.8 31-85.9 1.6-131l77.6-77.6 41-15.4c3.2-1.2 6.1-3.1 8.5-5.5l48-48c9.4-9.4 9.4-24.6 0-33.9L465 7zM208 256a48 48 0 1 1 0 96 48 48 0 1 1 0-96z"
    ]
};
var $d8206b3ab2e65c05$export$600a1b26b33c3d47 = {
    prefix: "fas",
    iconName: "face-laugh-wink",
    icon: [
        512,
        512,
        [
            "laugh-wink"
        ],
        "f59c",
        "M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM96.8 314.1c-3.8-13.7 7.4-26.1 21.6-26.1H393.6c14.2 0 25.5 12.4 21.6 26.1C396.2 382 332.1 432 256 432s-140.2-50-159.2-117.9zM144.4 192a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm156.4 25.6c-5.3 7.1-15.3 8.5-22.4 3.2s-8.5-15.3-3.2-22.4c30.4-40.5 91.2-40.5 121.6 0c5.3 7.1 3.9 17.1-3.2 22.4s-17.1 3.9-22.4-3.2c-17.6-23.5-52.8-23.5-70.4 0z"
    ]
};
var $d8206b3ab2e65c05$export$77ac40095f39933e = $d8206b3ab2e65c05$export$600a1b26b33c3d47;
var $d8206b3ab2e65c05$export$5bcca85203ebd1e8 = {
    prefix: "fas",
    iconName: "horse-head",
    icon: [
        640,
        512,
        [],
        "f7ab",
        "M64 464V316.9c0-108.4 68.3-205.1 170.5-241.3L404.2 15.5C425.6 7.9 448 23.8 448 46.4c0 11-5.5 21.2-14.6 27.3L400 96c48.1 0 91.2 29.8 108.1 74.9l48.6 129.5c11.8 31.4 4.1 66.8-19.6 90.5c-16 16-37.8 25.1-60.5 25.1h-3.4c-26.1 0-50.9-11.6-67.6-31.7l-32.3-38.7c-11.7 4.1-24.2 6.4-37.3 6.4l-.1 0 0 0c-6.3 0-12.5-.5-18.6-1.5c-3.6-.6-7.2-1.4-10.7-2.3l0 0c-28.9-7.8-53.1-26.8-67.8-52.2c-4.4-7.6-14.2-10.3-21.9-5.8s-10.3 14.2-5.8 21.9c24 41.5 68.3 70 119.3 71.9l47.2 70.8c4 6.1 6.2 13.2 6.2 20.4c0 20.3-16.5 36.8-36.8 36.8H112c-26.5 0-48-21.5-48-48zM392 224a24 24 0 1 0 0-48 24 24 0 1 0 0 48z"
    ]
};
var $d8206b3ab2e65c05$export$cd79eeea6201e9d4 = {
    prefix: "fas",
    iconName: "bore-hole",
    icon: [
        512,
        512,
        [],
        "e4c3",
        "M256 0c-17.7 0-32 14.3-32 32V296.6c-19.1 11.1-32 31.7-32 55.4c0 35.3 28.7 64 64 64s64-28.7 64-64c0-23.7-12.9-44.4-32-55.4V32c0-17.7-14.3-32-32-32zM48 128c-26.5 0-48 21.5-48 48V464c0 26.5 21.5 48 48 48H464c26.5 0 48-21.5 48-48V176c0-26.5-21.5-48-48-48H384c-17.7 0-32 14.3-32 32V352c0 53-43 96-96 96s-96-43-96-96V160c0-17.7-14.3-32-32-32H48z"
    ]
};
var $d8206b3ab2e65c05$export$5548c3eb51060fa8 = {
    prefix: "fas",
    iconName: "industry",
    icon: [
        576,
        512,
        [],
        "f275",
        "M64 32C46.3 32 32 46.3 32 64V304v48 80c0 26.5 21.5 48 48 48H496c26.5 0 48-21.5 48-48V304 152.2c0-18.2-19.4-29.7-35.4-21.1L352 215.4V152.2c0-18.2-19.4-29.7-35.4-21.1L160 215.4V64c0-17.7-14.3-32-32-32H64z"
    ]
};
var $d8206b3ab2e65c05$export$531badb89cf01312 = {
    prefix: "fas",
    iconName: "circle-down",
    icon: [
        512,
        512,
        [
            61466,
            "arrow-alt-circle-down"
        ],
        "f358",
        "M256 0a256 256 0 1 0 0 512A256 256 0 1 0 256 0zM376.9 294.6L269.8 394.5c-3.8 3.5-8.7 5.5-13.8 5.5s-10.1-2-13.8-5.5L135.1 294.6c-4.5-4.2-7.1-10.1-7.1-16.3c0-12.3 10-22.3 22.3-22.3l57.7 0 0-96c0-17.7 14.3-32 32-32l32 0c17.7 0 32 14.3 32 32l0 96 57.7 0c12.3 0 22.3 10 22.3 22.3c0 6.2-2.6 12.1-7.1 16.3z"
    ]
};
var $d8206b3ab2e65c05$export$ff3afbc8c0bc5d59 = $d8206b3ab2e65c05$export$531badb89cf01312;
var $d8206b3ab2e65c05$export$b9d8fdf63999a76d = {
    prefix: "fas",
    iconName: "arrows-turn-to-dots",
    icon: [
        512,
        512,
        [],
        "e4c1",
        "M249.4 25.4c12.5-12.5 32.8-12.5 45.3 0s12.5 32.8 0 45.3L269.3 96 416 96c53 0 96 43 96 96v32c0 17.7-14.3 32-32 32s-32-14.3-32-32V192c0-17.7-14.3-32-32-32l-146.7 0 25.4 25.4c12.5 12.5 12.5 32.8 0 45.3s-32.8 12.5-45.3 0l-80-80c-12.5-12.5-12.5-32.8 0-45.3l80-80zm13.3 256l80 80c12.5 12.5 12.5 32.8 0 45.3l-80 80c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3L242.7 416 96 416c-17.7 0-32 14.3-32 32v32c0 17.7-14.3 32-32 32s-32-14.3-32-32V448c0-53 43-96 96-96l146.7 0-25.4-25.4c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0zM384 384a64 64 0 1 1 128 0 64 64 0 1 1 -128 0zM64 192A64 64 0 1 1 64 64a64 64 0 1 1 0 128z"
    ]
};
var $d8206b3ab2e65c05$export$6248ec7440b2ffcb = {
    prefix: "fas",
    iconName: "florin-sign",
    icon: [
        384,
        512,
        [],
        "e184",
        "M314.7 32c-38.8 0-73.7 23.3-88.6 59.1L170.7 224H64c-17.7 0-32 14.3-32 32s14.3 32 32 32h80L98.9 396.3c-5 11.9-16.6 19.7-29.5 19.7H32c-17.7 0-32 14.3-32 32s14.3 32 32 32H69.3c38.8 0 73.7-23.3 88.6-59.1L213.3 288H320c17.7 0 32-14.3 32-32s-14.3-32-32-32H240l45.1-108.3c5-11.9 16.6-19.7 29.5-19.7H352c17.7 0 32-14.3 32-32s-14.3-32-32-32H314.7z"
    ]
};
var $d8206b3ab2e65c05$export$a51c464b699200ae = {
    prefix: "fas",
    iconName: "arrow-down-short-wide",
    icon: [
        576,
        512,
        [
            "sort-amount-desc",
            "sort-amount-down-alt"
        ],
        "f884",
        "M151.6 469.6C145.5 476.2 137 480 128 480s-17.5-3.8-23.6-10.4l-88-96c-11.9-13-11.1-33.3 2-45.2s33.3-11.1 45.2 2L96 365.7V64c0-17.7 14.3-32 32-32s32 14.3 32 32V365.7l32.4-35.4c11.9-13 32.2-13.9 45.2-2s13.9 32.2 2 45.2l-88 96zM320 32h32c17.7 0 32 14.3 32 32s-14.3 32-32 32H320c-17.7 0-32-14.3-32-32s14.3-32 32-32zm0 128h96c17.7 0 32 14.3 32 32s-14.3 32-32 32H320c-17.7 0-32-14.3-32-32s14.3-32 32-32zm0 128H480c17.7 0 32 14.3 32 32s-14.3 32-32 32H320c-17.7 0-32-14.3-32-32s14.3-32 32-32zm0 128H544c17.7 0 32 14.3 32 32s-14.3 32-32 32H320c-17.7 0-32-14.3-32-32s14.3-32 32-32z"
    ]
};
var $d8206b3ab2e65c05$export$93835bc31892b5c3 = $d8206b3ab2e65c05$export$a51c464b699200ae;
var $d8206b3ab2e65c05$export$e7d80d8c226cb77 = $d8206b3ab2e65c05$export$a51c464b699200ae;
var $d8206b3ab2e65c05$export$7f24f1bf98af5411 = {
    prefix: "fas",
    iconName: "less-than",
    icon: [
        384,
        512,
        [
            62774
        ],
        "3c",
        "M380.6 81.7c7.9 15.8 1.5 35-14.3 42.9L103.6 256 366.3 387.4c15.8 7.9 22.2 27.1 14.3 42.9s-27.1 22.2-42.9 14.3l-320-160C6.8 279.2 0 268.1 0 256s6.8-23.2 17.7-28.6l320-160c15.8-7.9 35-1.5 42.9 14.3z"
    ]
};
var $d8206b3ab2e65c05$export$4b5be0142d10f342 = {
    prefix: "fas",
    iconName: "angle-down",
    icon: [
        448,
        512,
        [
            8964
        ],
        "f107",
        "M201.4 342.6c12.5 12.5 32.8 12.5 45.3 0l160-160c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L224 274.7 86.6 137.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3l160 160z"
    ]
};
var $d8206b3ab2e65c05$export$ec5cfe409de2ed37 = {
    prefix: "fas",
    iconName: "car-tunnel",
    icon: [
        512,
        512,
        [],
        "e4de",
        "M256 0C114.6 0 0 114.6 0 256V448c0 35.3 28.7 64 64 64h42.8c-6.6-5.9-10.8-14.4-10.8-24V376c0-20.8 11.3-38.9 28.1-48.6l21-64.7c7.5-23.1 29-38.7 53.3-38.7H313.6c24.3 0 45.8 15.6 53.3 38.7l21 64.7c16.8 9.7 28.2 27.8 28.2 48.6V488c0 9.6-4.2 18.1-10.8 24H448c35.3 0 64-28.7 64-64V256C512 114.6 397.4 0 256 0zM362.8 512c-6.6-5.9-10.8-14.4-10.8-24V448H160v40c0 9.6-4.2 18.1-10.8 24H362.8zM190.8 277.5L177 320H335l-13.8-42.5c-1.1-3.3-4.1-5.5-7.6-5.5H198.4c-3.5 0-6.5 2.2-7.6 5.5zM168 408a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm200-24a24 24 0 1 0 -48 0 24 24 0 1 0 48 0z"
    ]
};
var $d8206b3ab2e65c05$export$3cd04b7c1624f598 = {
    prefix: "fas",
    iconName: "head-side-cough",
    icon: [
        640,
        512,
        [],
        "e061",
        "M0 224.2C0 100.6 100.2 0 224 0h24c95.2 0 181.2 69.3 197.3 160.2c2.3 13 6.8 25.7 15.1 36l42 52.6c6.2 7.8 9.6 17.4 9.6 27.4c0 24.2-19.6 43.8-43.8 43.8H448v0 32L339.2 365.6c-11 1.4-19.2 10.7-19.2 21.8c0 11.6 9 21.2 20.6 21.9L448 416v16c0 26.5-21.5 48-48 48H320v8c0 13.3-10.7 24-24 24H256v0H96c-17.7 0-32-14.3-32-32V407.3c0-16.7-6.9-32.5-17.1-45.8C16.6 322.4 0 274.1 0 224.2zm352-.2a32 32 0 1 0 0-64 32 32 0 1 0 0 64zM464 384a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zm152-24a24 24 0 1 1 0 48 24 24 0 1 1 0-48zM592 480a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zM552 312a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm40-24a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zM552 408a24 24 0 1 1 0 48 24 24 0 1 1 0-48z"
    ]
};
var $d8206b3ab2e65c05$export$1412f35381064d7d = {
    prefix: "fas",
    iconName: "grip-lines",
    icon: [
        448,
        512,
        [],
        "f7a4",
        "M32 288c-17.7 0-32 14.3-32 32s14.3 32 32 32l384 0c17.7 0 32-14.3 32-32s-14.3-32-32-32L32 288zm0-128c-17.7 0-32 14.3-32 32s14.3 32 32 32l384 0c17.7 0 32-14.3 32-32s-14.3-32-32-32L32 160z"
    ]
};
var $d8206b3ab2e65c05$export$aba24ca305bbe8c1 = {
    prefix: "fas",
    iconName: "thumbs-down",
    icon: [
        512,
        512,
        [
            128078,
            61576
        ],
        "f165",
        "M313.4 479.1c26-5.2 42.9-30.5 37.7-56.5l-2.3-11.4c-5.3-26.7-15.1-52.1-28.8-75.2H464c26.5 0 48-21.5 48-48c0-18.5-10.5-34.6-25.9-42.6C497 236.6 504 223.1 504 208c0-23.4-16.8-42.9-38.9-47.1c4.4-7.3 6.9-15.8 6.9-24.9c0-21.3-13.9-39.4-33.1-45.6c.7-3.3 1.1-6.8 1.1-10.4c0-26.5-21.5-48-48-48H294.5c-19 0-37.5 5.6-53.3 16.1L202.7 73.8C176 91.6 160 121.6 160 153.7V192v48 24.9c0 29.2 13.3 56.7 36 75l7.4 5.9c26.5 21.2 44.6 51 51.2 84.2l2.3 11.4c5.2 26 30.5 42.9 56.5 37.7zM32 384H96c17.7 0 32-14.3 32-32V128c0-17.7-14.3-32-32-32H32C14.3 96 0 110.3 0 128V352c0 17.7 14.3 32 32 32z"
    ]
};
var $d8206b3ab2e65c05$export$d9b89b5872b67a4f = {
    prefix: "fas",
    iconName: "user-lock",
    icon: [
        640,
        512,
        [],
        "f502",
        "M224 256A128 128 0 1 0 224 0a128 128 0 1 0 0 256zm-45.7 48C79.8 304 0 383.8 0 482.3C0 498.7 13.3 512 29.7 512H392.6c-5.4-9.4-8.6-20.3-8.6-32V352c0-2.1 .1-4.2 .3-6.3c-31-26-71-41.7-114.6-41.7H178.3zM528 240c17.7 0 32 14.3 32 32v48H496V272c0-17.7 14.3-32 32-32zm-80 32v48c-17.7 0-32 14.3-32 32V480c0 17.7 14.3 32 32 32H608c17.7 0 32-14.3 32-32V352c0-17.7-14.3-32-32-32V272c0-44.2-35.8-80-80-80s-80 35.8-80 80z"
    ]
};
var $d8206b3ab2e65c05$export$becbc35d3541bcc = {
    prefix: "fas",
    iconName: "arrow-right-long",
    icon: [
        512,
        512,
        [
            "long-arrow-right"
        ],
        "f178",
        "M502.6 278.6c12.5-12.5 12.5-32.8 0-45.3l-128-128c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3L402.7 224 32 224c-17.7 0-32 14.3-32 32s14.3 32 32 32l370.7 0-73.4 73.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0l128-128z"
    ]
};
var $d8206b3ab2e65c05$export$7ec6527cf8651899 = $d8206b3ab2e65c05$export$becbc35d3541bcc;
var $d8206b3ab2e65c05$export$f6773af4219eebd = {
    prefix: "fas",
    iconName: "anchor-circle-xmark",
    icon: [
        640,
        512,
        [],
        "e4ac",
        "M320 96a32 32 0 1 1 -64 0 32 32 0 1 1 64 0zm21.1 80C367 158.8 384 129.4 384 96c0-53-43-96-96-96s-96 43-96 96c0 33.4 17 62.8 42.9 80H224c-17.7 0-32 14.3-32 32s14.3 32 32 32h32V448H208c-53 0-96-43-96-96v-6.1l7 7c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9L97 263c-9.4-9.4-24.6-9.4-33.9 0L7 319c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l7-7V352c0 88.4 71.6 160 160 160h80 80c8.2 0 16.3-.6 24.2-1.8c-22.2-16.2-40.4-37.5-53-62.2H320V368 240h32c17.7 0 32-14.3 32-32s-14.3-32-32-32H341.1zM496 512a144 144 0 1 0 0-288 144 144 0 1 0 0 288zm59.3-180.7L518.6 368l36.7 36.7c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0L496 390.6l-36.7 36.7c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6L473.4 368l-36.7-36.7c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0L496 345.4l36.7-36.7c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6z"
    ]
};
var $d8206b3ab2e65c05$export$37fe3659ba7b6b54 = {
    prefix: "fas",
    iconName: "ellipsis",
    icon: [
        448,
        512,
        [
            "ellipsis-h"
        ],
        "f141",
        "M8 256a56 56 0 1 1 112 0A56 56 0 1 1 8 256zm160 0a56 56 0 1 1 112 0 56 56 0 1 1 -112 0zm216-56a56 56 0 1 1 0 112 56 56 0 1 1 0-112z"
    ]
};
var $d8206b3ab2e65c05$export$c9f2fedd4489a2ee = $d8206b3ab2e65c05$export$37fe3659ba7b6b54;
var $d8206b3ab2e65c05$export$3db75d5ac9e98468 = {
    prefix: "fas",
    iconName: "chess-pawn",
    icon: [
        320,
        512,
        [
            9823
        ],
        "f443",
        "M215.5 224c29.2-18.4 48.5-50.9 48.5-88c0-57.4-46.6-104-104-104S56 78.6 56 136c0 37.1 19.4 69.6 48.5 88H96c-17.7 0-32 14.3-32 32c0 16.5 12.5 30 28.5 31.8L80 400H240L227.5 287.8c16-1.8 28.5-15.3 28.5-31.8c0-17.7-14.3-32-32-32h-8.5zM22.6 473.4c-4.2 4.2-6.6 10-6.6 16C16 501.9 26.1 512 38.6 512H281.4c12.5 0 22.6-10.1 22.6-22.6c0-6-2.4-11.8-6.6-16L256 432H64L22.6 473.4z"
    ]
};
var $d8206b3ab2e65c05$export$f04e7a0f1033a0cd = {
    prefix: "fas",
    iconName: "kit-medical",
    icon: [
        576,
        512,
        [
            "first-aid"
        ],
        "f479",
        "M64 32C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H96V32H64zm64 0V480H448V32H128zM512 480c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H480V480h32zM256 176c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v48h48c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H320v48c0 8.8-7.2 16-16 16H272c-8.8 0-16-7.2-16-16V288H208c-8.8 0-16-7.2-16-16V240c0-8.8 7.2-16 16-16h48V176z"
    ]
};
var $d8206b3ab2e65c05$export$5b01ccb2da4c4387 = $d8206b3ab2e65c05$export$f04e7a0f1033a0cd;
var $d8206b3ab2e65c05$export$a77a2f6da72f89e3 = {
    prefix: "fas",
    iconName: "person-through-window",
    icon: [
        640,
        512,
        [],
        "e5a9",
        "M64 64l224 0 0 9.8c0 39-23.7 74-59.9 88.4C167.6 186.5 128 245 128 310.2l0 73.8s0 0 0 0H64V64zm288 0l224 0V384H508.3l-3.7-4.5-75.2-90.2c-9.1-10.9-22.6-17.3-36.9-17.3l-71.1 0-41-63.1c-.3-.5-.6-1-1-1.4c44.7-29 72.5-79 72.5-133.6l0-9.8zm73 320H379.2l42.7 64H592c26.5 0 48-21.5 48-48V48c0-26.5-21.5-48-48-48H48C21.5 0 0 21.5 0 48V400c0 26.5 21.5 48 48 48H308.2l33.2 49.8c9.8 14.7 29.7 18.7 44.4 8.9s18.7-29.7 8.9-44.4L310.5 336l74.6 0 40 48zm-159.5 0H192s0 0 0 0l0-73.8c0-10.2 1.6-20.1 4.7-29.5L265.5 384zM192 128a48 48 0 1 0 -96 0 48 48 0 1 0 96 0z"
    ]
};
var $d8206b3ab2e65c05$export$b34d64c205c732a9 = {
    prefix: "fas",
    iconName: "toolbox",
    icon: [
        512,
        512,
        [
            129520
        ],
        "f552",
        "M176 88v40H336V88c0-4.4-3.6-8-8-8H184c-4.4 0-8 3.6-8 8zm-48 40V88c0-30.9 25.1-56 56-56H328c30.9 0 56 25.1 56 56v40h28.1c12.7 0 24.9 5.1 33.9 14.1l51.9 51.9c9 9 14.1 21.2 14.1 33.9V304H384V288c0-17.7-14.3-32-32-32s-32 14.3-32 32v16H192V288c0-17.7-14.3-32-32-32s-32 14.3-32 32v16H0V227.9c0-12.7 5.1-24.9 14.1-33.9l51.9-51.9c9-9 21.2-14.1 33.9-14.1H128zM0 416V336H128v16c0 17.7 14.3 32 32 32s32-14.3 32-32V336H320v16c0 17.7 14.3 32 32 32s32-14.3 32-32V336H512v80c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64z"
    ]
};
var $d8206b3ab2e65c05$export$3aa81d0e606b08b6 = {
    prefix: "fas",
    iconName: "hands-holding-circle",
    icon: [
        640,
        512,
        [],
        "e4fb",
        "M320 0a128 128 0 1 1 0 256A128 128 0 1 1 320 0zM40 64c22.1 0 40 17.9 40 40v40 80 40.2c0 17 6.7 33.3 18.7 45.3l51.1 51.1c8.3 8.3 21.3 9.6 31 3.1c12.9-8.6 14.7-26.9 3.7-37.8l-15.2-15.2-32-32c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0l32 32 15.2 15.2 0 0 25.3 25.3c21 21 32.8 49.5 32.8 79.2V464c0 26.5-21.5 48-48 48H173.3c-17 0-33.3-6.7-45.3-18.7L28.1 393.4C10.1 375.4 0 351 0 325.5V224 160 104C0 81.9 17.9 64 40 64zm560 0c22.1 0 40 17.9 40 40v56 64V325.5c0 25.5-10.1 49.9-28.1 67.9L512 493.3c-12 12-28.3 18.7-45.3 18.7H400c-26.5 0-48-21.5-48-48V385.1c0-29.7 11.8-58.2 32.8-79.2l25.3-25.3 0 0 15.2-15.2 32-32c12.5-12.5 32.8-12.5 45.3 0s12.5 32.8 0 45.3l-32 32-15.2 15.2c-11 11-9.2 29.2 3.7 37.8c9.7 6.5 22.7 5.2 31-3.1l51.1-51.1c12-12 18.7-28.3 18.7-45.3V224 144 104c0-22.1 17.9-40 40-40z"
    ]
};
var $d8206b3ab2e65c05$export$a18cfac400116d9f = {
    prefix: "fas",
    iconName: "bug",
    icon: [
        512,
        512,
        [],
        "f188",
        "M256 0c53 0 96 43 96 96v3.6c0 15.7-12.7 28.4-28.4 28.4H188.4c-15.7 0-28.4-12.7-28.4-28.4V96c0-53 43-96 96-96zM41.4 105.4c12.5-12.5 32.8-12.5 45.3 0l64 64c.7 .7 1.3 1.4 1.9 2.1c14.2-7.3 30.4-11.4 47.5-11.4H312c17.1 0 33.2 4.1 47.5 11.4c.6-.7 1.2-1.4 1.9-2.1l64-64c12.5-12.5 32.8-12.5 45.3 0s12.5 32.8 0 45.3l-64 64c-.7 .7-1.4 1.3-2.1 1.9c6.2 12 10.1 25.3 11.1 39.5H480c17.7 0 32 14.3 32 32s-14.3 32-32 32H416c0 24.6-5.5 47.8-15.4 68.6c2.2 1.3 4.2 2.9 6 4.8l64 64c12.5 12.5 12.5 32.8 0 45.3s-32.8 12.5-45.3 0l-63.1-63.1c-24.5 21.8-55.8 36.2-90.3 39.6V240c0-8.8-7.2-16-16-16s-16 7.2-16 16V479.2c-34.5-3.4-65.8-17.8-90.3-39.6L86.6 502.6c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3l64-64c1.9-1.9 3.9-3.4 6-4.8C101.5 367.8 96 344.6 96 320H32c-17.7 0-32-14.3-32-32s14.3-32 32-32H96.3c1.1-14.1 5-27.5 11.1-39.5c-.7-.6-1.4-1.2-2.1-1.9l-64-64c-12.5-12.5-12.5-32.8 0-45.3z"
    ]
};
var $d8206b3ab2e65c05$export$3e7437bf6535bef0 = {
    prefix: "fas",
    iconName: "credit-card",
    icon: [
        576,
        512,
        [
            128179,
            62083,
            "credit-card-alt"
        ],
        "f09d",
        "M64 32C28.7 32 0 60.7 0 96v32H576V96c0-35.3-28.7-64-64-64H64zM576 224H0V416c0 35.3 28.7 64 64 64H512c35.3 0 64-28.7 64-64V224zM112 352h64c8.8 0 16 7.2 16 16s-7.2 16-16 16H112c-8.8 0-16-7.2-16-16s7.2-16 16-16zm112 16c0-8.8 7.2-16 16-16H368c8.8 0 16 7.2 16 16s-7.2 16-16 16H240c-8.8 0-16-7.2-16-16z"
    ]
};
var $d8206b3ab2e65c05$export$5fffe8e3c36964a2 = $d8206b3ab2e65c05$export$3e7437bf6535bef0;
var $d8206b3ab2e65c05$export$9eefe7fcdf123b76 = {
    prefix: "fas",
    iconName: "car",
    icon: [
        512,
        512,
        [
            128664,
            "automobile"
        ],
        "f1b9",
        "M135.2 117.4L109.1 192H402.9l-26.1-74.6C372.3 104.6 360.2 96 346.6 96H165.4c-13.6 0-25.7 8.6-30.2 21.4zM39.6 196.8L74.8 96.3C88.3 57.8 124.6 32 165.4 32H346.6c40.8 0 77.1 25.8 90.6 64.3l35.2 100.5c23.2 9.6 39.6 32.5 39.6 59.2V400v48c0 17.7-14.3 32-32 32H448c-17.7 0-32-14.3-32-32V400H96v48c0 17.7-14.3 32-32 32H32c-17.7 0-32-14.3-32-32V400 256c0-26.7 16.4-49.6 39.6-59.2zM128 288a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zm288 32a32 32 0 1 0 0-64 32 32 0 1 0 0 64z"
    ]
};
var $d8206b3ab2e65c05$export$240a6c53cf7ac525 = $d8206b3ab2e65c05$export$9eefe7fcdf123b76;
var $d8206b3ab2e65c05$export$6638511b28df3be5 = {
    prefix: "fas",
    iconName: "hand-holding-hand",
    icon: [
        576,
        512,
        [],
        "e4f7",
        "M7.8 207.7c-13.1-17.8-9.3-42.8 8.5-55.9L142.9 58.5C166.2 41.3 194.5 32 223.5 32H384 544c17.7 0 32 14.3 32 32v64c0 17.7-14.3 32-32 32H507.2l-44.9 36c-22.7 18.2-50.9 28-80 28H304 288 224c-17.7 0-32-14.3-32-32s14.3-32 32-32h64 16c8.8 0 16-7.2 16-16s-7.2-16-16-16H183.4L63.7 216.2c-17.8 13.1-42.8 9.3-55.9-8.5zM382.4 160l0 0 .9 0c-.3 0-.6 0-.9 0zM568.2 304.3c13.1 17.8 9.3 42.8-8.5 55.9L433.1 453.5c-23.4 17.2-51.6 26.5-80.7 26.5H192 32c-17.7 0-32-14.3-32-32V384c0-17.7 14.3-32 32-32H68.8l44.9-36c22.7-18.2 50.9-28 80-28H272h16 64c17.7 0 32 14.3 32 32s-14.3 32-32 32H288 272c-8.8 0-16 7.2-16 16s7.2 16 16 16H392.6l119.7-88.2c17.8-13.1 42.8-9.3 55.9 8.5zM193.6 352l0 0-.9 0c.3 0 .6 0 .9 0z"
    ]
};
var $d8206b3ab2e65c05$export$cb6e40528b98a5b = {
    prefix: "fas",
    iconName: "book-open-reader",
    icon: [
        512,
        512,
        [
            "book-reader"
        ],
        "f5da",
        "M160 96a96 96 0 1 1 192 0A96 96 0 1 1 160 96zm80 152V512l-48.4-24.2c-20.9-10.4-43.5-17-66.8-19.3l-96-9.6C12.5 457.2 0 443.5 0 427V224c0-17.7 14.3-32 32-32H62.3c63.6 0 125.6 19.6 177.7 56zm32 264V248c52.1-36.4 114.1-56 177.7-56H480c17.7 0 32 14.3 32 32V427c0 16.4-12.5 30.2-28.8 31.8l-96 9.6c-23.2 2.3-45.9 8.9-66.8 19.3L272 512z"
    ]
};
var $d8206b3ab2e65c05$export$cee14fe33262fa7d = $d8206b3ab2e65c05$export$cb6e40528b98a5b;
var $d8206b3ab2e65c05$export$af9eaee7db3ba7a9 = {
    prefix: "fas",
    iconName: "mountain-sun",
    icon: [
        640,
        512,
        [],
        "e52f",
        "M560 160A80 80 0 1 0 560 0a80 80 0 1 0 0 160zM55.9 512H381.1h75H578.9c33.8 0 61.1-27.4 61.1-61.1c0-11.2-3.1-22.2-8.9-31.8l-132-216.3C495 196.1 487.8 192 480 192s-15 4.1-19.1 10.7l-48.2 79L286.8 81c-6.6-10.6-18.3-17-30.8-17s-24.1 6.4-30.8 17L8.6 426.4C3 435.3 0 445.6 0 456.1C0 487 25 512 55.9 512z"
    ]
};
var $d8206b3ab2e65c05$export$a63cecc8a4166c49 = {
    prefix: "fas",
    iconName: "arrows-left-right-to-line",
    icon: [
        640,
        512,
        [],
        "e4ba",
        "M32 64c17.7 0 32 14.3 32 32l0 320c0 17.7-14.3 32-32 32s-32-14.3-32-32V96C0 78.3 14.3 64 32 64zm214.6 73.4c12.5 12.5 12.5 32.8 0 45.3L205.3 224l229.5 0-41.4-41.4c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0l96 96c12.5 12.5 12.5 32.8 0 45.3l-96 96c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3L434.7 288l-229.5 0 41.4 41.4c12.5 12.5 12.5 32.8 0 45.3s-32.8 12.5-45.3 0l-96-96c-12.5-12.5-12.5-32.8 0-45.3l96-96c12.5-12.5 32.8-12.5 45.3 0zM640 96V416c0 17.7-14.3 32-32 32s-32-14.3-32-32V96c0-17.7 14.3-32 32-32s32 14.3 32 32z"
    ]
};
var $d8206b3ab2e65c05$export$b06003a02c9055bd = {
    prefix: "fas",
    iconName: "dice-d20",
    icon: [
        512,
        512,
        [],
        "f6cf",
        "M48.7 125.8l53.2 31.9c7.8 4.7 17.8 2 22.2-5.9L201.6 12.1c3-5.4-.9-12.1-7.1-12.1c-1.6 0-3.2 .5-4.6 1.4L47.9 98.8c-9.6 6.6-9.2 20.9 .8 26.9zM16 171.7V295.3c0 8 10.4 11 14.7 4.4l60-92c5-7.6 2.6-17.8-5.2-22.5L40.2 158C29.6 151.6 16 159.3 16 171.7zM310.4 12.1l77.6 139.6c4.4 7.9 14.5 10.6 22.2 5.9l53.2-31.9c10-6 10.4-20.3 .8-26.9L322.1 1.4c-1.4-.9-3-1.4-4.6-1.4c-6.2 0-10.1 6.7-7.1 12.1zM496 171.7c0-12.4-13.6-20.1-24.2-13.7l-45.3 27.2c-7.8 4.7-10.1 14.9-5.2 22.5l60 92c4.3 6.7 14.7 3.6 14.7-4.4V171.7zm-49.3 246L286.1 436.6c-8.1 .9-14.1 7.8-14.1 15.9v52.8c0 3.7 3 6.8 6.8 6.8c.8 0 1.6-.1 2.4-.4l172.7-64c6.1-2.2 10.1-8 10.1-14.5c0-9.3-8.1-16.5-17.3-15.4zM233.2 512c3.7 0 6.8-3 6.8-6.8V452.6c0-8.1-6.1-14.9-14.1-15.9l-160.6-19c-9.2-1.1-17.3 6.1-17.3 15.4c0 6.5 4 12.3 10.1 14.5l172.7 64c.8 .3 1.6 .4 2.4 .4zM41.7 382.9l170.9 20.2c7.8 .9 13.4-7.5 9.5-14.3l-85.7-150c-5.9-10.4-20.7-10.8-27.3-.8L30.2 358.2c-6.5 9.9-.3 23.3 11.5 24.7zm439.6-24.8L402.9 238.1c-6.5-10-21.4-9.6-27.3 .8L290.2 388.5c-3.9 6.8 1.6 15.2 9.5 14.3l170.1-20c11.8-1.4 18-14.7 11.5-24.6zm-216.9 11l78.4-137.2c6.1-10.7-1.6-23.9-13.9-23.9H183.1c-12.3 0-20 13.3-13.9 23.9l78.4 137.2c3.7 6.4 13 6.4 16.7 0zM174.4 176H337.6c12.2 0 19.9-13.1 14-23.8l-80-144c-2.8-5.1-8.2-8.2-14-8.2h-3.2c-5.8 0-11.2 3.2-14 8.2l-80 144c-5.9 10.7 1.8 23.8 14 23.8z"
    ]
};
var $d8206b3ab2e65c05$export$41ce20639e8fef2b = {
    prefix: "fas",
    iconName: "truck-droplet",
    icon: [
        640,
        512,
        [],
        "e58c",
        "M0 48C0 21.5 21.5 0 48 0H368c26.5 0 48 21.5 48 48V96h50.7c17 0 33.3 6.7 45.3 18.7L589.3 192c12 12 18.7 28.3 18.7 45.3V256v32 64c17.7 0 32 14.3 32 32s-14.3 32-32 32H576c0 53-43 96-96 96s-96-43-96-96H256c0 53-43 96-96 96s-96-43-96-96H48c-26.5 0-48-21.5-48-48V48zM416 256H544V237.3L466.7 160H416v96zM160 464a48 48 0 1 0 0-96 48 48 0 1 0 0 96zm368-48a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zM208 272c39.8 0 72-29.6 72-66c0-27-39.4-82.9-59.9-110.3c-6.1-8.2-18.1-8.2-24.2 0C175.4 123 136 179 136 206c0 36.5 32.2 66 72 66z"
    ]
};
var $d8206b3ab2e65c05$export$e4686afbe882e24a = {
    prefix: "fas",
    iconName: "file-circle-xmark",
    icon: [
        576,
        512,
        [],
        "e5a1",
        "M0 64C0 28.7 28.7 0 64 0H224V128c0 17.7 14.3 32 32 32H384v38.6C310.1 219.5 256 287.4 256 368c0 59.1 29.1 111.3 73.7 143.3c-3.2 .5-6.4 .7-9.7 .7H64c-35.3 0-64-28.7-64-64V64zm384 64H256V0L384 128zm48 96a144 144 0 1 1 0 288 144 144 0 1 1 0-288zm59.3 107.3c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0L432 345.4l-36.7-36.7c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6L409.4 368l-36.7 36.7c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0L432 390.6l36.7 36.7c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6L454.6 368l36.7-36.7z"
    ]
};
var $d8206b3ab2e65c05$export$d7a5da41ce01461d = {
    prefix: "fas",
    iconName: "temperature-arrow-up",
    icon: [
        576,
        512,
        [
            "temperature-up"
        ],
        "e040",
        "M128 112c0-26.5 21.5-48 48-48s48 21.5 48 48V276.5c0 17.3 7.1 31.9 15.3 42.5C249.8 332.6 256 349.5 256 368c0 44.2-35.8 80-80 80s-80-35.8-80-80c0-18.5 6.2-35.4 16.7-48.9c8.2-10.6 15.3-25.2 15.3-42.5V112zM176 0C114.1 0 64 50.1 64 112V276.4c0 .1-.1 .3-.2 .6c-.2 .6-.8 1.6-1.7 2.8C43.2 304.2 32 334.8 32 368c0 79.5 64.5 144 144 144s144-64.5 144-144c0-33.2-11.2-63.8-30.1-88.1c-.9-1.2-1.5-2.2-1.7-2.8c-.1-.3-.2-.5-.2-.6V112C288 50.1 237.9 0 176 0zm0 416c26.5 0 48-21.5 48-48c0-20.9-13.4-38.7-32-45.3V112c0-8.8-7.2-16-16-16s-16 7.2-16 16V322.7c-18.6 6.6-32 24.4-32 45.3c0 26.5 21.5 48 48 48zM480 160h32c12.9 0 24.6-7.8 29.6-19.8s2.2-25.7-6.9-34.9l-64-64c-12.5-12.5-32.8-12.5-45.3 0l-64 64c-9.2 9.2-11.9 22.9-6.9 34.9s16.6 19.8 29.6 19.8h32V448c0 17.7 14.3 32 32 32s32-14.3 32-32V160z"
    ]
};
var $d8206b3ab2e65c05$export$872345a0157330a3 = $d8206b3ab2e65c05$export$d7a5da41ce01461d;
var $d8206b3ab2e65c05$export$b48a5be96314835a = {
    prefix: "fas",
    iconName: "medal",
    icon: [
        512,
        512,
        [
            127941
        ],
        "f5a2",
        "M4.1 38.2C1.4 34.2 0 29.4 0 24.6C0 11 11 0 24.6 0H133.9c11.2 0 21.7 5.9 27.4 15.5l68.5 114.1c-48.2 6.1-91.3 28.6-123.4 61.9L4.1 38.2zm503.7 0L405.6 191.5c-32.1-33.3-75.2-55.8-123.4-61.9L350.7 15.5C356.5 5.9 366.9 0 378.1 0H487.4C501 0 512 11 512 24.6c0 4.8-1.4 9.6-4.1 13.6zM80 336a176 176 0 1 1 352 0A176 176 0 1 1 80 336zm184.4-94.9c-3.4-7-13.3-7-16.8 0l-22.4 45.4c-1.4 2.8-4 4.7-7 5.1L168 298.9c-7.7 1.1-10.7 10.5-5.2 16l36.3 35.4c2.2 2.2 3.2 5.2 2.7 8.3l-8.6 49.9c-1.3 7.6 6.7 13.5 13.6 9.9l44.8-23.6c2.7-1.4 6-1.4 8.7 0l44.8 23.6c6.9 3.6 14.9-2.2 13.6-9.9l-8.6-49.9c-.5-3 .5-6.1 2.7-8.3l36.3-35.4c5.6-5.4 2.5-14.8-5.2-16l-50.1-7.3c-3-.4-5.7-2.4-7-5.1l-22.4-45.4z"
    ]
};
var $d8206b3ab2e65c05$export$f24e0fce77994d4d = {
    prefix: "fas",
    iconName: "bed",
    icon: [
        640,
        512,
        [
            128716
        ],
        "f236",
        "M32 32c17.7 0 32 14.3 32 32V320H288V160c0-17.7 14.3-32 32-32H544c53 0 96 43 96 96V448c0 17.7-14.3 32-32 32s-32-14.3-32-32V416H352 320 64v32c0 17.7-14.3 32-32 32s-32-14.3-32-32V64C0 46.3 14.3 32 32 32zm144 96a80 80 0 1 1 0 160 80 80 0 1 1 0-160z"
    ]
};
var $d8206b3ab2e65c05$export$51e3c5be06a49e32 = {
    prefix: "fas",
    iconName: "square-h",
    icon: [
        448,
        512,
        [
            "h-square"
        ],
        "f0fd",
        "M64 32C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64zM336 152V256 360c0 13.3-10.7 24-24 24s-24-10.7-24-24V280H160l0 80c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-208c0-13.3 10.7-24 24-24s24 10.7 24 24v80H288V152c0-13.3 10.7-24 24-24s24 10.7 24 24z"
    ]
};
var $d8206b3ab2e65c05$export$f08bbcf8f59eafc2 = $d8206b3ab2e65c05$export$51e3c5be06a49e32;
var $d8206b3ab2e65c05$export$5c0b4709125e92f8 = {
    prefix: "fas",
    iconName: "podcast",
    icon: [
        448,
        512,
        [],
        "f2ce",
        "M319.4 372c48.5-31.3 80.6-85.9 80.6-148c0-97.2-78.8-176-176-176S48 126.8 48 224c0 62.1 32.1 116.6 80.6 148c1.2 17.3 4 38 7.2 57.1l.2 1C56 395.8 0 316.5 0 224C0 100.3 100.3 0 224 0S448 100.3 448 224c0 92.5-56 171.9-136 206.1l.2-1.1c3.1-19.2 6-39.8 7.2-57zm-2.3-38.1c-1.6-5.7-3.9-11.1-7-16.2c-5.8-9.7-13.5-17-21.9-22.4c19.5-17.6 31.8-43 31.8-71.3c0-53-43-96-96-96s-96 43-96 96c0 28.3 12.3 53.8 31.8 71.3c-8.4 5.4-16.1 12.7-21.9 22.4c-3.1 5.1-5.4 10.5-7 16.2C99.8 307.5 80 268 80 224c0-79.5 64.5-144 144-144s144 64.5 144 144c0 44-19.8 83.5-50.9 109.9zM224 312c32.9 0 64 8.6 64 43.8c0 33-12.9 104.1-20.6 132.9c-5.1 19-24.5 23.4-43.4 23.4s-38.2-4.4-43.4-23.4c-7.8-28.5-20.6-99.7-20.6-132.8c0-35.1 31.1-43.8 64-43.8zm0-144a56 56 0 1 1 0 112 56 56 0 1 1 0-112z"
    ]
};
var $d8206b3ab2e65c05$export$bf4d97a79734997f = {
    prefix: "fas",
    iconName: "temperature-full",
    icon: [
        320,
        512,
        [
            "temperature-4",
            "thermometer-4",
            "thermometer-full"
        ],
        "f2c7",
        "M160 64c-26.5 0-48 21.5-48 48V276.5c0 17.3-7.1 31.9-15.3 42.5C86.2 332.6 80 349.5 80 368c0 44.2 35.8 80 80 80s80-35.8 80-80c0-18.5-6.2-35.4-16.7-48.9c-8.2-10.6-15.3-25.2-15.3-42.5V112c0-26.5-21.5-48-48-48zM48 112C48 50.2 98.1 0 160 0s112 50.1 112 112V276.5c0 .1 .1 .3 .2 .6c.2 .6 .8 1.6 1.7 2.8c18.9 24.4 30.1 55 30.1 88.1c0 79.5-64.5 144-144 144S16 447.5 16 368c0-33.2 11.2-63.8 30.1-88.1c.9-1.2 1.5-2.2 1.7-2.8c.1-.3 .2-.5 .2-.6V112zM208 368c0 26.5-21.5 48-48 48s-48-21.5-48-48c0-20.9 13.4-38.7 32-45.3V112c0-8.8 7.2-16 16-16s16 7.2 16 16V322.7c18.6 6.6 32 24.4 32 45.3z"
    ]
};
var $d8206b3ab2e65c05$export$db946f8dc50a57ca = $d8206b3ab2e65c05$export$bf4d97a79734997f;
var $d8206b3ab2e65c05$export$92b2e2293472dd50 = $d8206b3ab2e65c05$export$bf4d97a79734997f;
var $d8206b3ab2e65c05$export$74e07083cef79a6f = $d8206b3ab2e65c05$export$bf4d97a79734997f;
var $d8206b3ab2e65c05$export$9b6162797ab1b255 = {
    prefix: "fas",
    iconName: "bell",
    icon: [
        448,
        512,
        [
            128276,
            61602
        ],
        "f0f3",
        "M224 0c-17.7 0-32 14.3-32 32V51.2C119 66 64 130.6 64 208v18.8c0 47-17.3 92.4-48.5 127.6l-7.4 8.3c-8.4 9.4-10.4 22.9-5.3 34.4S19.4 416 32 416H416c12.6 0 24-7.4 29.2-18.9s3.1-25-5.3-34.4l-7.4-8.3C401.3 319.2 384 273.9 384 226.8V208c0-77.4-55-142-128-156.8V32c0-17.7-14.3-32-32-32zm45.3 493.3c12-12 18.7-28.3 18.7-45.3H224 160c0 17 6.7 33.3 18.7 45.3s28.3 18.7 45.3 18.7s33.3-6.7 45.3-18.7z"
    ]
};
var $d8206b3ab2e65c05$export$4fa56a54e822dd25 = {
    prefix: "fas",
    iconName: "superscript",
    icon: [
        512,
        512,
        [],
        "f12b",
        "M480 32c0-11.1-5.7-21.4-15.2-27.2s-21.2-6.4-31.1-1.4l-32 16c-15.8 7.9-22.2 27.1-14.3 42.9C393 73.5 404.3 80 416 80v80c-17.7 0-32 14.3-32 32s14.3 32 32 32h32 32c17.7 0 32-14.3 32-32s-14.3-32-32-32V32zM32 64C14.3 64 0 78.3 0 96s14.3 32 32 32H47.3l89.6 128L47.3 384H32c-17.7 0-32 14.3-32 32s14.3 32 32 32H64c10.4 0 20.2-5.1 26.2-13.6L176 311.8l85.8 122.6c6 8.6 15.8 13.6 26.2 13.6h32c17.7 0 32-14.3 32-32s-14.3-32-32-32H304.7L215.1 256l89.6-128H320c17.7 0 32-14.3 32-32s-14.3-32-32-32H288c-10.4 0-20.2 5.1-26.2 13.6L176 200.2 90.2 77.6C84.2 69.1 74.4 64 64 64H32z"
    ]
};
var $d8206b3ab2e65c05$export$12ef959394d63192 = {
    prefix: "fas",
    iconName: "plug-circle-xmark",
    icon: [
        576,
        512,
        [],
        "e560",
        "M96 0C78.3 0 64 14.3 64 32v96h64V32c0-17.7-14.3-32-32-32zM288 0c-17.7 0-32 14.3-32 32v96h64V32c0-17.7-14.3-32-32-32zM32 160c-17.7 0-32 14.3-32 32s14.3 32 32 32v32c0 77.4 55 142 128 156.8V480c0 17.7 14.3 32 32 32s32-14.3 32-32V412.8c12.3-2.5 24.1-6.4 35.1-11.5c-2.1-10.8-3.1-21.9-3.1-33.3c0-80.3 53.8-148 127.3-169.2c.5-2.2 .7-4.5 .7-6.8c0-17.7-14.3-32-32-32H32zM432 512a144 144 0 1 0 0-288 144 144 0 1 0 0 288zm59.3-180.7L454.6 368l36.7 36.7c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0L432 390.6l-36.7 36.7c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6L409.4 368l-36.7-36.7c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0L432 345.4l36.7-36.7c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6z"
    ]
};
var $d8206b3ab2e65c05$export$aa3c4c1c5a47bf98 = {
    prefix: "fas",
    iconName: "star-of-life",
    icon: [
        512,
        512,
        [],
        "f621",
        "M208 32c0-17.7 14.3-32 32-32h32c17.7 0 32 14.3 32 32V172.9l122-70.4c15.3-8.8 34.9-3.6 43.7 11.7l16 27.7c8.8 15.3 3.6 34.9-11.7 43.7L352 256l122 70.4c15.3 8.8 20.5 28.4 11.7 43.7l-16 27.7c-8.8 15.3-28.4 20.6-43.7 11.7L304 339.1V480c0 17.7-14.3 32-32 32H240c-17.7 0-32-14.3-32-32V339.1L86 409.6c-15.3 8.8-34.9 3.6-43.7-11.7l-16-27.7c-8.8-15.3-3.6-34.9 11.7-43.7L160 256 38 185.6c-15.3-8.8-20.5-28.4-11.7-43.7l16-27.7C51.1 98.8 70.7 93.6 86 102.4l122 70.4V32z"
    ]
};
var $d8206b3ab2e65c05$export$4c60a3aade08b6c2 = {
    prefix: "fas",
    iconName: "phone-slash",
    icon: [
        640,
        512,
        [],
        "f3dd",
        "M228.9 24.6c-7.7-18.6-28-28.5-47.4-23.2l-88 24C76.1 30.2 64 46 64 64c0 107.4 37.8 206 100.8 283.1L9.2 469.1c-10.4 8.2-12.3 23.3-4.1 33.7s23.3 12.3 33.7 4.1l592-464c10.4-8.2 12.3-23.3 4.1-33.7s-23.3-12.3-33.7-4.1L253 278c-17.8-21.5-32.9-45.2-45-70.7L257.3 167c13.7-11.2 18.4-30 11.6-46.3l-40-96zm96.8 319l-91.3 72C310.7 476 407.1 512 512 512c18 0 33.8-12.1 38.6-29.5l24-88c5.3-19.4-4.6-39.7-23.2-47.4l-96-40c-16.3-6.8-35.2-2.1-46.3 11.6L368.7 368c-15-7.1-29.3-15.2-43-24.3z"
    ]
};
var $d8206b3ab2e65c05$export$d1de8d1b815d6a5 = {
    prefix: "fas",
    iconName: "paint-roller",
    icon: [
        512,
        512,
        [],
        "f5aa",
        "M0 64C0 28.7 28.7 0 64 0H352c35.3 0 64 28.7 64 64v64c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V64zM160 352c0-17.7 14.3-32 32-32V304c0-44.2 35.8-80 80-80H416c17.7 0 32-14.3 32-32V160 69.5c37.3 13.2 64 48.7 64 90.5v32c0 53-43 96-96 96H272c-8.8 0-16 7.2-16 16v16c17.7 0 32 14.3 32 32V480c0 17.7-14.3 32-32 32H192c-17.7 0-32-14.3-32-32V352z"
    ]
};
var $d8206b3ab2e65c05$export$503f458ca5cf64c2 = {
    prefix: "fas",
    iconName: "handshake-angle",
    icon: [
        640,
        512,
        [
            "hands-helping"
        ],
        "f4c4",
        "M544 248v3.3l69.7-69.7c21.9-21.9 21.9-57.3 0-79.2L535.6 24.4c-21.9-21.9-57.3-21.9-79.2 0L416.3 64.5c-2.7-.3-5.5-.5-8.3-.5H296c-37.1 0-67.6 28-71.6 64H224V248c0 22.1 17.9 40 40 40s40-17.9 40-40V176c0 0 0-.1 0-.1V160l16 0 136 0c0 0 0 0 .1 0H464c44.2 0 80 35.8 80 80v8zM336 192v56c0 39.8-32.2 72-72 72s-72-32.2-72-72V129.4c-35.9 6.2-65.8 32.3-76 68.2L99.5 255.2 26.3 328.4c-21.9 21.9-21.9 57.3 0 79.2l78.1 78.1c21.9 21.9 57.3 21.9 79.2 0l37.7-37.7c.9 0 1.8 .1 2.7 .1H384c26.5 0 48-21.5 48-48c0-5.6-1-11-2.7-16H432c26.5 0 48-21.5 48-48c0-12.8-5-24.4-13.2-33c25.7-5 45.1-27.6 45.2-54.8v-.4c-.1-30.8-25.1-55.8-56-55.8c0 0 0 0 0 0l-120 0z"
    ]
};
var $d8206b3ab2e65c05$export$287dbb1632da0d44 = $d8206b3ab2e65c05$export$503f458ca5cf64c2;
var $d8206b3ab2e65c05$export$90a475e93ff4bb8a = {
    prefix: "fas",
    iconName: "location-dot",
    icon: [
        384,
        512,
        [
            "map-marker-alt"
        ],
        "f3c5",
        "M215.7 499.2C267 435 384 279.4 384 192C384 86 298 0 192 0S0 86 0 192c0 87.4 117 243 168.3 307.2c12.3 15.3 35.1 15.3 47.4 0zM192 128a64 64 0 1 1 0 128 64 64 0 1 1 0-128z"
    ]
};
var $d8206b3ab2e65c05$export$4be92fa780613f93 = $d8206b3ab2e65c05$export$90a475e93ff4bb8a;
var $d8206b3ab2e65c05$export$cad54bead856a678 = {
    prefix: "fas",
    iconName: "file",
    icon: [
        384,
        512,
        [
            128196,
            128459,
            61462
        ],
        "f15b",
        "M0 64C0 28.7 28.7 0 64 0H224V128c0 17.7 14.3 32 32 32H384V448c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V64zm384 64H256V0L384 128z"
    ]
};
var $d8206b3ab2e65c05$export$da07b6bc24a496ca = {
    prefix: "fas",
    iconName: "greater-than",
    icon: [
        384,
        512,
        [
            62769
        ],
        "3e",
        "M3.4 81.7c-7.9 15.8-1.5 35 14.3 42.9L280.5 256 17.7 387.4C1.9 395.3-4.5 414.5 3.4 430.3s27.1 22.2 42.9 14.3l320-160c10.8-5.4 17.7-16.5 17.7-28.6s-6.8-23.2-17.7-28.6l-320-160c-15.8-7.9-35-1.5-42.9 14.3z"
    ]
};
var $d8206b3ab2e65c05$export$3fb4da6af843d39f = {
    prefix: "fas",
    iconName: "person-swimming",
    icon: [
        576,
        512,
        [
            127946,
            "swimmer"
        ],
        "f5c4",
        "M309.5 178.4L447.9 297.1c-1.6 .9-3.2 2-4.8 3c-18 12.4-40.1 20.3-59.2 20.3c-19.6 0-40.8-7.7-59.2-20.3c-22.1-15.5-51.6-15.5-73.7 0c-17.1 11.8-38 20.3-59.2 20.3c-10.1 0-21.1-2.2-31.9-6.2C163.1 193.2 262.2 96 384 96h64c17.7 0 32 14.3 32 32s-14.3 32-32 32H384c-26.9 0-52.3 6.6-74.5 18.4zM160 160A64 64 0 1 1 32 160a64 64 0 1 1 128 0zM306.5 325.9C329 341.4 356.5 352 384 352c26.9 0 55.4-10.8 77.4-26.1l0 0c11.9-8.5 28.1-7.8 39.2 1.7c14.4 11.9 32.5 21 50.6 25.2c17.2 4 27.9 21.2 23.9 38.4s-21.2 27.9-38.4 23.9c-24.5-5.7-44.9-16.5-58.2-25C449.5 405.7 417 416 384 416c-31.9 0-60.6-9.9-80.4-18.9c-5.8-2.7-11.1-5.3-15.6-7.7c-4.5 2.4-9.7 5.1-15.6 7.7c-19.8 9-48.5 18.9-80.4 18.9c-33 0-65.5-10.3-94.5-25.8c-13.4 8.4-33.7 19.3-58.2 25c-17.2 4-34.4-6.7-38.4-23.9s6.7-34.4 23.9-38.4c18.1-4.2 36.2-13.3 50.6-25.2c11.1-9.4 27.3-10.1 39.2-1.7l0 0C136.7 341.2 165.1 352 192 352c27.5 0 55-10.6 77.5-26.1c11.1-7.9 25.9-7.9 37 0z"
    ]
};
var $d8206b3ab2e65c05$export$67daf2e2f88c1365 = $d8206b3ab2e65c05$export$3fb4da6af843d39f;
var $d8206b3ab2e65c05$export$9686eff8d817f770 = {
    prefix: "fas",
    iconName: "arrow-down",
    icon: [
        384,
        512,
        [
            8595
        ],
        "f063",
        "M169.4 470.6c12.5 12.5 32.8 12.5 45.3 0l160-160c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L224 370.8 224 64c0-17.7-14.3-32-32-32s-32 14.3-32 32l0 306.7L54.6 265.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3l160 160z"
    ]
};
var $d8206b3ab2e65c05$export$cc1b6e60cb98fb90 = {
    prefix: "fas",
    iconName: "droplet",
    icon: [
        384,
        512,
        [
            128167,
            "tint"
        ],
        "f043",
        "M192 512C86 512 0 426 0 320C0 228.8 130.2 57.7 166.6 11.7C172.6 4.2 181.5 0 191.1 0h1.8c9.6 0 18.5 4.2 24.5 11.7C253.8 57.7 384 228.8 384 320c0 106-86 192-192 192zM96 336c0-8.8-7.2-16-16-16s-16 7.2-16 16c0 61.9 50.1 112 112 112c8.8 0 16-7.2 16-16s-7.2-16-16-16c-44.2 0-80-35.8-80-80z"
    ]
};
var $d8206b3ab2e65c05$export$60dd975bd5938c15 = $d8206b3ab2e65c05$export$cc1b6e60cb98fb90;
var $d8206b3ab2e65c05$export$e7fc4fe34e767f28 = {
    prefix: "fas",
    iconName: "eraser",
    icon: [
        576,
        512,
        [],
        "f12d",
        "M290.7 57.4L57.4 290.7c-25 25-25 65.5 0 90.5l80 80c12 12 28.3 18.7 45.3 18.7H288h9.4H512c17.7 0 32-14.3 32-32s-14.3-32-32-32H387.9L518.6 285.3c25-25 25-65.5 0-90.5L381.3 57.4c-25-25-65.5-25-90.5 0zM297.4 416H288l-105.4 0-80-80L227.3 211.3 364.7 348.7 297.4 416z"
    ]
};
var $d8206b3ab2e65c05$export$9c4218a898614082 = {
    prefix: "fas",
    iconName: "earth-americas",
    icon: [
        512,
        512,
        [
            127758,
            "earth",
            "earth-america",
            "globe-americas"
        ],
        "f57d",
        "M57.7 193l9.4 16.4c8.3 14.5 21.9 25.2 38 29.8L163 255.7c17.2 4.9 29 20.6 29 38.5v39.9c0 11 6.2 21 16 25.9s16 14.9 16 25.9v39c0 15.6 14.9 26.9 29.9 22.6c16.1-4.6 28.6-17.5 32.7-33.8l2.8-11.2c4.2-16.9 15.2-31.4 30.3-40l8.1-4.6c15-8.5 24.2-24.5 24.2-41.7v-8.3c0-12.7-5.1-24.9-14.1-33.9l-3.9-3.9c-9-9-21.2-14.1-33.9-14.1H257c-11.1 0-22.1-2.9-31.8-8.4l-34.5-19.7c-4.3-2.5-7.6-6.5-9.2-11.2c-3.2-9.6 1.1-20 10.2-24.5l5.9-3c6.6-3.3 14.3-3.9 21.3-1.5l23.2 7.7c8.2 2.7 17.2-.4 21.9-7.5c4.7-7 4.2-16.3-1.2-22.8l-13.6-16.3c-10-12-9.9-29.5 .3-41.3l15.7-18.3c8.8-10.3 10.2-25 3.5-36.7l-2.4-4.2c-3.5-.2-6.9-.3-10.4-.3C163.1 48 84.4 108.9 57.7 193zM464 256c0-36.8-9.6-71.4-26.4-101.5L412 164.8c-15.7 6.3-23.8 23.8-18.5 39.8l16.9 50.7c3.5 10.4 12 18.3 22.6 20.9l29.1 7.3c1.2-9 1.8-18.2 1.8-27.5zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256z"
    ]
};
var $d8206b3ab2e65c05$export$c2118d3775773870 = $d8206b3ab2e65c05$export$9c4218a898614082;
var $d8206b3ab2e65c05$export$8b0f3a26397cf632 = $d8206b3ab2e65c05$export$9c4218a898614082;
var $d8206b3ab2e65c05$export$e96bcc7bde9498db = $d8206b3ab2e65c05$export$9c4218a898614082;
var $d8206b3ab2e65c05$export$ae02241644924482 = {
    prefix: "fas",
    iconName: "person-burst",
    icon: [
        640,
        512,
        [],
        "e53b",
        "M480 96a48 48 0 1 0 0-96 48 48 0 1 0 0 96zm-8 384V352h16V480c0 17.7 14.3 32 32 32s32-14.3 32-32V256.9l28.6 47.5c9.1 15.1 28.8 20 43.9 10.9s20-28.8 10.9-43.9l-58.3-97c-17.4-28.9-48.6-46.6-82.3-46.6H465.1c-33.7 0-64.9 17.7-82.3 46.6l-58.3 97c-9.1 15.1-4.2 34.8 10.9 43.9s34.8 4.2 43.9-10.9L408 256.9V480c0 17.7 14.3 32 32 32s32-14.3 32-32zM190.9 18.1C188.4 12 182.6 8 176 8s-12.4 4-14.9 10.1l-29.4 74L55.6 68.9c-6.3-1.9-13.1 .2-17.2 5.3s-4.6 12.2-1.4 17.9l39.5 69.1L10.9 206.4c-5.4 3.7-8 10.3-6.5 16.7s6.7 11.2 13.1 12.2l78.7 12.2L90.6 327c-.5 6.5 3.1 12.7 9 15.5s12.9 1.8 17.8-2.6L176 286.1l58.6 53.9c4.8 4.4 11.9 5.5 17.8 2.6s9.5-9 9-15.5l-5.6-79.4 50.5-7.8 24.4-40.5-55.2-38L315 92.2c3.3-5.7 2.7-12.8-1.4-17.9s-10.9-7.2-17.2-5.3L220.3 92.1l-29.4-74z"
    ]
};
var $d8206b3ab2e65c05$export$a1ab1e69a300089f = {
    prefix: "fas",
    iconName: "dove",
    icon: [
        512,
        512,
        [
            128330
        ],
        "f4ba",
        "M160.8 96.5c14 17 31 30.9 49.5 42.2c25.9 15.8 53.7 25.9 77.7 31.6V138.8C265.8 108.5 250 71.5 248.6 28c-.4-11.3-7.5-21.5-18.4-24.4c-7.6-2-15.8-.2-21 5.8c-13.3 15.4-32.7 44.6-48.4 87.2zM320 144v30.6l0 0v1.3l0 0 0 32.1c-60.8-5.1-185-43.8-219.3-157.2C97.4 40 87.9 32 76.6 32c-7.9 0-15.3 3.9-18.8 11C46.8 65.9 32 112.1 32 176c0 116.9 80.1 180.5 118.4 202.8L11.8 416.6C6.7 418 2.6 421.8 .9 426.8s-.8 10.6 2.3 14.8C21.7 466.2 77.3 512 160 512c3.6 0 7.2-1.2 10-3.5L245.6 448H320c88.4 0 160-71.6 160-160V128l29.9-44.9c1.3-2 2.1-4.4 2.1-6.8c0-6.8-5.5-12.3-12.3-12.3H400c-44.2 0-80 35.8-80 80zm80-16a16 16 0 1 1 0 32 16 16 0 1 1 0-32z"
    ]
};
var $d8206b3ab2e65c05$export$1344b64f6e922e12 = {
    prefix: "fas",
    iconName: "battery-empty",
    icon: [
        576,
        512,
        [
            "battery-0"
        ],
        "f244",
        "M80 160c-8.8 0-16 7.2-16 16V336c0 8.8 7.2 16 16 16H464c8.8 0 16-7.2 16-16V176c0-8.8-7.2-16-16-16H80zM0 176c0-44.2 35.8-80 80-80H464c44.2 0 80 35.8 80 80v16c17.7 0 32 14.3 32 32v64c0 17.7-14.3 32-32 32v16c0 44.2-35.8 80-80 80H80c-44.2 0-80-35.8-80-80V176z"
    ]
};
var $d8206b3ab2e65c05$export$de8d0338927394c1 = $d8206b3ab2e65c05$export$1344b64f6e922e12;
var $d8206b3ab2e65c05$export$8d36a54dbf1e6bce = {
    prefix: "fas",
    iconName: "socks",
    icon: [
        512,
        512,
        [
            129510
        ],
        "f696",
        "M175.2 476.6c-9.7-18-15.2-38.7-15.2-60.6c0-40.3 19-78.2 51.2-102.4l64-48c8.1-6 12.8-15.5 12.8-25.6V96H128V240c0 20.1-9.5 39.1-25.6 51.2l-64 48C14.2 357.3 0 385.8 0 416c0 53 43 96 96 96c20.8 0 41-6.7 57.6-19.2l21.6-16.2zM128 64H288V48c0-14.5 3.9-28.2 10.7-39.9C291 3 281.9 0 272 0H176c-26.5 0-48 21.5-48 48V64zM320 96V240c0 20.1-9.5 39.1-25.6 51.2l-64 48C206.2 357.3 192 385.8 192 416c0 53 43 96 96 96c20.8 0 41-6.7 57.6-19.2l115.2-86.4C493 382.2 512 344.3 512 304V96H320zM512 64V48c0-26.5-21.5-48-48-48H368c-26.5 0-48 21.5-48 48V64H512z"
    ]
};
var $d8206b3ab2e65c05$export$366b69cbdce46334 = {
    prefix: "fas",
    iconName: "inbox",
    icon: [
        512,
        512,
        [],
        "f01c",
        "M121 32C91.6 32 66 52 58.9 80.5L1.9 308.4C.6 313.5 0 318.7 0 323.9V416c0 35.3 28.7 64 64 64H448c35.3 0 64-28.7 64-64V323.9c0-5.2-.6-10.4-1.9-15.5l-57-227.9C446 52 420.4 32 391 32H121zm0 64H391l48 192H387.8c-12.1 0-23.2 6.8-28.6 17.7l-14.3 28.6c-5.4 10.8-16.5 17.7-28.6 17.7H195.8c-12.1 0-23.2-6.8-28.6-17.7l-14.3-28.6c-5.4-10.8-16.5-17.7-28.6-17.7H73L121 96z"
    ]
};
var $d8206b3ab2e65c05$export$a6f4f4a005d91fbd = {
    prefix: "fas",
    iconName: "section",
    icon: [
        256,
        512,
        [],
        "e447",
        "M64.9 96C67.1 84.4 73.7 76.2 86 70.6c13.8-6.2 34.8-8.9 61.2-4.5c8.8 1.4 36.1 7.1 44.1 9.3c17 4.8 34.7-5.1 39.5-22.2s-5.1-34.7-22.2-39.5c-11.1-3.1-41-9.2-50.9-10.8C123-2.7 88.3-.6 59.7 12.3C29.9 25.8 7.5 50.9 1.6 86.5c-.1 .5-.2 1.1-.2 1.6c-2.2 19.7 .3 37.9 8.1 54.1c7.7 16.1 19.4 28 32 36.9c.6 .5 1.3 .9 2 1.4C22.3 194.2 6.5 215.1 1.7 243c-.1 .6-.2 1.1-.2 1.7c-2.3 19.3 .4 37.1 8.4 53c7.9 15.6 19.8 27 32.3 35.5c22.4 15.2 51.9 24 75.4 31l0 0 3.7 1.1c27.2 8.2 46.9 14.6 59.4 23.8c5.5 4 8.2 7.6 9.5 10.9c1.3 3.2 2.6 8.6 .9 18.1c-1.7 10.1-7.7 18-20.7 23.5c-14 6-35.4 8.5-62 4.4c-12.8-2.1-35.1-9.7-54.1-16.2l0 0c-4.3-1.5-8.5-2.9-12.3-4.2C25.3 420 7.2 429.1 1.6 445.8s3.5 34.9 20.3 40.5c2.6 .8 5.7 1.9 9.2 3.1c18.6 6.3 48.5 16.6 67.3 19.6l0 0 .2 0c34.5 5.4 68.8 3.4 97.2-8.7c29.4-12.6 52.5-36.5 58.5-71.5c3.3-19.3 1.9-37.4-5-53.9c-6.3-15-16.4-26.4-27.6-35.2c16.5-13.9 28.5-33.2 32.6-58.2c3.2-19.8 1.9-38.3-4.8-55.1c-6.7-16.8-17.8-29.4-30.2-39c-22.8-17.6-53.6-27.4-77.7-35l-1.4-.5c-27.4-8.7-47.8-15.3-61.5-25c-6.1-4.4-9.5-8.5-11.4-12.4c-1.8-3.7-3.2-9.3-2.3-18.5zm76.7 208.5c-.2-.1-.4-.1-.6-.2l-1.4-.4c-27.4-8.2-47.9-14.5-61.7-23.8c-6.2-4.2-9.3-7.9-11-11.3c-1.5-3-2.9-7.7-2.1-15.7c1.9-9.7 7.9-17.3 20.5-22.7c14-6 35.4-8.5 62.1-4.3l16.4 2.6c6.3 2.9 11.7 6 16.2 9.5c5.5 4.2 8.4 8.2 10 12.2c1.6 4 2.8 10.4 1.1 20.9c-2.4 14.7-12.8 26.4-37.1 31l-12.4 2.3z"
    ]
};
var $d8206b3ab2e65c05$export$d262c1f5912046e6 = {
    prefix: "fas",
    iconName: "gauge-high",
    icon: [
        512,
        512,
        [
            62461,
            "tachometer-alt",
            "tachometer-alt-fast"
        ],
        "f625",
        "M0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zM288 96a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zM256 416c35.3 0 64-28.7 64-64c0-17.4-6.9-33.1-18.1-44.6L366 161.7c5.3-12.1-.2-26.3-12.3-31.6s-26.3 .2-31.6 12.3L257.9 288c-.6 0-1.3 0-1.9 0c-35.3 0-64 28.7-64 64s28.7 64 64 64zM176 144a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zM96 288a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm352-32a32 32 0 1 0 -64 0 32 32 0 1 0 64 0z"
    ]
};
var $d8206b3ab2e65c05$export$38dd17b9f064c10f = $d8206b3ab2e65c05$export$d262c1f5912046e6;
var $d8206b3ab2e65c05$export$e99d8b85f35b8ca5 = $d8206b3ab2e65c05$export$d262c1f5912046e6;
var $d8206b3ab2e65c05$export$f5c53ce8ec380d11 = {
    prefix: "fas",
    iconName: "envelope-open-text",
    icon: [
        512,
        512,
        [],
        "f658",
        "M215.4 96H144 107.8 96v8.8V144v40.4 89L.2 202.5c1.6-18.1 10.9-34.9 25.7-45.8L48 140.3V96c0-26.5 21.5-48 48-48h76.6l49.9-36.9C232.2 3.9 243.9 0 256 0s23.8 3.9 33.5 11L339.4 48H416c26.5 0 48 21.5 48 48v44.3l22.1 16.4c14.8 10.9 24.1 27.7 25.7 45.8L416 273.4v-89V144 104.8 96H404.2 368 296.6 215.4zM0 448V242.1L217.6 403.3c11.1 8.2 24.6 12.7 38.4 12.7s27.3-4.4 38.4-12.7L512 242.1V448v0c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64v0zM176 160H336c8.8 0 16 7.2 16 16s-7.2 16-16 16H176c-8.8 0-16-7.2-16-16s7.2-16 16-16zm0 64H336c8.8 0 16 7.2 16 16s-7.2 16-16 16H176c-8.8 0-16-7.2-16-16s7.2-16 16-16z"
    ]
};
var $d8206b3ab2e65c05$export$7a76c9d35b42d691 = {
    prefix: "fas",
    iconName: "hospital",
    icon: [
        640,
        512,
        [
            127973,
            62589,
            "hospital-alt",
            "hospital-wide"
        ],
        "f0f8",
        "M192 48c0-26.5 21.5-48 48-48H400c26.5 0 48 21.5 48 48V512H368V432c0-26.5-21.5-48-48-48s-48 21.5-48 48v80H192V48zM48 96H160V512H48c-26.5 0-48-21.5-48-48V320H80c8.8 0 16-7.2 16-16s-7.2-16-16-16H0V224H80c8.8 0 16-7.2 16-16s-7.2-16-16-16H0V144c0-26.5 21.5-48 48-48zm544 0c26.5 0 48 21.5 48 48v48H560c-8.8 0-16 7.2-16 16s7.2 16 16 16h80v64H560c-8.8 0-16 7.2-16 16s7.2 16 16 16h80V464c0 26.5-21.5 48-48 48H480V96H592zM312 64c-8.8 0-16 7.2-16 16v24H272c-8.8 0-16 7.2-16 16v16c0 8.8 7.2 16 16 16h24v24c0 8.8 7.2 16 16 16h16c8.8 0 16-7.2 16-16V152h24c8.8 0 16-7.2 16-16V120c0-8.8-7.2-16-16-16H344V80c0-8.8-7.2-16-16-16H312z"
    ]
};
var $d8206b3ab2e65c05$export$cea7736417b94a3b = $d8206b3ab2e65c05$export$7a76c9d35b42d691;
var $d8206b3ab2e65c05$export$69c8cc0360f017e8 = $d8206b3ab2e65c05$export$7a76c9d35b42d691;
var $d8206b3ab2e65c05$export$770be8b3d5776043 = {
    prefix: "fas",
    iconName: "wine-bottle",
    icon: [
        512,
        512,
        [],
        "f72f",
        "M393.4 9.4c12.5-12.5 32.8-12.5 45.3 0l64 64c12.5 12.5 12.5 32.8 0 45.3c-11.8 11.8-30.7 12.5-43.2 1.9l-9.5 9.5-48.8 48.8c-9.2 9.2-11.5 22.9-8.6 35.6c9.4 40.9-1.9 85.6-33.8 117.5L197.3 493.3c-25 25-65.5 25-90.5 0l-88-88c-25-25-25-65.5 0-90.5L180.2 153.3c31.9-31.9 76.6-43.1 117.5-33.8c12.6 2.9 26.4 .5 35.5-8.6l48.8-48.8 9.5-9.5c-10.6-12.6-10-31.4 1.9-43.2zM99.3 347.3l65.4 65.4c6.2 6.2 16.4 6.2 22.6 0l97.4-97.4c6.2-6.2 6.2-16.4 0-22.6l-65.4-65.4c-6.2-6.2-16.4-6.2-22.6 0L99.3 324.7c-6.2 6.2-6.2 16.4 0 22.6z"
    ]
};
var $d8206b3ab2e65c05$export$5d65c40a109eb09c = {
    prefix: "fas",
    iconName: "chess-rook",
    icon: [
        448,
        512,
        [
            9820
        ],
        "f447",
        "M32 192V48c0-8.8 7.2-16 16-16h64c8.8 0 16 7.2 16 16V88c0 4.4 3.6 8 8 8h32c4.4 0 8-3.6 8-8V48c0-8.8 7.2-16 16-16h64c8.8 0 16 7.2 16 16V88c0 4.4 3.6 8 8 8h32c4.4 0 8-3.6 8-8V48c0-8.8 7.2-16 16-16h64c8.8 0 16 7.2 16 16V192c0 10.1-4.7 19.6-12.8 25.6L352 256l16 144H80L96 256 44.8 217.6C36.7 211.6 32 202.1 32 192zm176 96h32c8.8 0 16-7.2 16-16V224c0-17.7-14.3-32-32-32s-32 14.3-32 32v48c0 8.8 7.2 16 16 16zM22.6 473.4L64 432H384l41.4 41.4c4.2 4.2 6.6 10 6.6 16c0 12.5-10.1 22.6-22.6 22.6H38.6C26.1 512 16 501.9 16 489.4c0-6 2.4-11.8 6.6-16z"
    ]
};
var $d8206b3ab2e65c05$export$2f8a7938c06a2142 = {
    prefix: "fas",
    iconName: "bars-staggered",
    icon: [
        512,
        512,
        [
            "reorder",
            "stream"
        ],
        "f550",
        "M0 96C0 78.3 14.3 64 32 64H416c17.7 0 32 14.3 32 32s-14.3 32-32 32H32C14.3 128 0 113.7 0 96zM64 256c0-17.7 14.3-32 32-32H480c17.7 0 32 14.3 32 32s-14.3 32-32 32H96c-17.7 0-32-14.3-32-32zM448 416c0 17.7-14.3 32-32 32H32c-17.7 0-32-14.3-32-32s14.3-32 32-32H416c17.7 0 32 14.3 32 32z"
    ]
};
var $d8206b3ab2e65c05$export$75d2bb378a2fc102 = $d8206b3ab2e65c05$export$2f8a7938c06a2142;
var $d8206b3ab2e65c05$export$ed81ab40fc4e904 = $d8206b3ab2e65c05$export$2f8a7938c06a2142;
var $d8206b3ab2e65c05$export$45cbd92c28deb2c7 = {
    prefix: "fas",
    iconName: "dharmachakra",
    icon: [
        512,
        512,
        [
            9784
        ],
        "f655",
        "M337.8 205.7l48.6-42.5c13.8 19.3 23.4 41.9 27.4 66.2l-64.4 4.3c-2.4-10.1-6.4-19.5-11.6-28zm140.1 19.5c-5.3-38.8-20.6-74.5-43.2-104.3l.8-.7C449 108.4 449.7 87.6 437 75s-33.4-12-45.2 1.5l-.7 .8c-29.8-22.6-65.5-37.9-104.3-43.2l.1-1.1c1.2-17.9-13-33-30.9-33s-32.1 15.2-30.9 33l.1 1.1c-38.8 5.3-74.5 20.6-104.3 43.2l-.7-.8C108.4 63 87.6 62.3 75 75s-12 33.4 1.5 45.2l.8 .7c-22.6 29.8-37.9 65.5-43.2 104.3l-1.1-.1c-17.9-1.2-33 13-33 30.9s15.2 32.1 33 30.9l1.1-.1c5.3 38.8 20.6 74.5 43.2 104.3l-.8 .7C63 403.6 62.3 424.4 75 437s33.4 12 45.2-1.5l.7-.8c29.8 22.6 65.5 37.9 104.3 43.2l-.1 1.1c-1.2 17.9 13 33 30.9 33s32.1-15.2 30.9-33l-.1-1.1c38.8-5.3 74.5-20.6 104.3-43.2l.7 .8c11.8 13.5 32.5 14.2 45.2 1.5s12-33.4-1.5-45.2l-.8-.7c22.6-29.8 37.9-65.5 43.2-104.3l1.1 .1c17.9 1.2 33-13 33-30.9s-15.2-32.1-33-30.9l-1.1 .1zM163.2 125.6c19.3-13.8 41.9-23.4 66.2-27.5l4.3 64.4c-10 2.4-19.5 6.4-28 11.6l-42.5-48.6zm-65 103.8c4.1-24.4 13.7-46.9 27.5-66.2l48.6 42.5c-5.3 8.5-9.2 18-11.6 28l-64.4-4.3zm27.5 119.4c-13.8-19.3-23.4-41.9-27.5-66.2l64.4-4.3c2.4 10 6.4 19.5 11.6 28l-48.6 42.5zm103.8 65c-24.4-4.1-46.9-13.7-66.2-27.4l42.5-48.6c8.5 5.3 18 9.2 28 11.6l-4.3 64.4zm119.4-27.4c-19.3 13.8-41.9 23.4-66.2 27.4l-4.3-64.4c10-2.4 19.5-6.4 28-11.6l42.5 48.6zm65-103.8c-4.1 24.4-13.7 46.9-27.4 66.2l-48.6-42.5c5.3-8.5 9.2-18 11.6-28l64.4 4.3zm-65-156.9l-42.5 48.6c-8.5-5.3-18-9.2-28-11.6l4.3-64.4c24.4 4.1 46.9 13.7 66.2 27.5zM256 224a32 32 0 1 1 0 64 32 32 0 1 1 0-64z"
    ]
};
var $d8206b3ab2e65c05$export$9fae219b4d3ce0be = {
    prefix: "fas",
    iconName: "hotdog",
    icon: [
        512,
        512,
        [
            127789
        ],
        "f80f",
        "M488.6 23.4c31.2 31.2 31.2 81.9 0 113.1l-352 352c-31.2 31.2-81.9 31.2-113.1 0s-31.2-81.9 0-113.1l352-352c31.2-31.2 81.9-31.2 113.1 0zM443.3 92.7c-6.2-6.2-16.4-6.2-22.6 0c-12.5 12.5-23.8 15.1-37.5 17.6l-2.5 .4c-13.8 2.5-31.6 5.6-48 22c-16.7 16.7-20.9 36-24.1 50.9l0 0v0l-.2 1c-3.4 15.6-6 26.4-15.7 36.1s-20.5 12.3-36.1 15.7l-1 .2c-14.9 3.2-34.2 7.4-50.9 24.1s-20.9 36-24.1 50.9l-.2 1c-3.4 15.6-6 26.4-15.7 36.1c-9.2 9.2-18 10.8-32.7 13.4l0 0-.9 .2c-15.6 2.8-34.9 6.9-54.4 26.4c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0c12.5-12.5 23.8-15.1 37.5-17.6l2.5-.4c13.8-2.5 31.6-5.6 48-22c16.7-16.7 20.9-36 24.1-50.9l.2-1c3.4-15.6 6-26.4 15.7-36.1s20.5-12.3 36.1-15.7l1-.2c14.9-3.2 34.2-7.4 50.9-24.1s20.9-36 24.1-50.9l.2-1c3.4-15.6 6-26.4 15.7-36.1c9.2-9.2 18-10.8 32.7-13.4l.9-.2c15.6-2.8 34.9-6.9 54.4-26.4c6.2-6.2 6.2-16.4 0-22.6zM191.2 479.2l288-288L495 207c10.9 10.9 17 25.6 17 41s-6.1 30.1-17 41L289 495c-10.9 10.9-25.6 17-41 17s-30.1-6.1-41-17l-15.8-15.8zM17 305C6.1 294.1 0 279.4 0 264s6.1-30.1 17-41L223 17C233.9 6.1 248.6 0 264 0s30.1 6.1 41 17l15.8 15.8-288 288L17 305z"
    ]
};
var $d8206b3ab2e65c05$export$2ffee5b2bc935c1f = {
    prefix: "fas",
    iconName: "person-walking-with-cane",
    icon: [
        512,
        512,
        [
            "blind"
        ],
        "f29d",
        "M176 96a48 48 0 1 0 0-96 48 48 0 1 0 0 96zm-8.4 32c-36.4 0-69.6 20.5-85.9 53.1L35.4 273.7c-7.9 15.8-1.5 35 14.3 42.9s35 1.5 42.9-14.3L128 231.6v43.2c0 17 6.7 33.3 18.7 45.3L224 397.3V480c0 17.7 14.3 32 32 32s32-14.3 32-32V390.6c0-12.7-5.1-24.9-14.1-33.9L224 306.7V213.3l70.4 93.9c10.6 14.1 30.7 17 44.8 6.4s17-30.7 6.4-44.8L268.8 166.4C250.7 142.2 222.2 128 192 128H167.6zM128.3 346.8L97 472.2c-4.3 17.1 6.1 34.5 23.3 38.8s34.5-6.1 38.8-23.3l22-88.2-52.8-52.8zM450.8 505.1c5 7.3 15 9.1 22.3 4s9.1-15 4-22.3L358.9 316.1c-2.8 3.8-6.1 7.3-10.1 10.3c-5 3.8-10.5 6.4-16.2 7.9L450.8 505.1z"
    ]
};
var $d8206b3ab2e65c05$export$923de21def6ea9b6 = $d8206b3ab2e65c05$export$2ffee5b2bc935c1f;
var $d8206b3ab2e65c05$export$5b9205e1042594b7 = {
    prefix: "fas",
    iconName: "drum",
    icon: [
        512,
        512,
        [
            129345
        ],
        "f569",
        "M501.2 76.1c11.1-7.3 14.2-22.1 6.9-33.2s-22.1-14.2-33.2-6.9L370.2 104.5C335.8 98.7 297 96 256 96C114.6 96 0 128 0 208V368c0 31.3 27.4 58.8 72 78.7V344c0-13.3 10.7-24 24-24s24 10.7 24 24V463.4c33 8.9 71.1 14.5 112 16.1V376c0-13.3 10.7-24 24-24s24 10.7 24 24V479.5c40.9-1.6 79-7.2 112-16.1V344c0-13.3 10.7-24 24-24s24 10.7 24 24V446.7c44.6-19.9 72-47.4 72-78.7V208c0-41.1-30.2-69.5-78.8-87.4l67.9-44.5zM307.4 145.6l-64.6 42.3c-11.1 7.3-14.2 22.1-6.9 33.2s22.1 14.2 33.2 6.9l111.1-72.8c14.7 3.2 27.9 7 39.4 11.5C458.4 181.8 464 197.4 464 208c0 .8-2.7 17.2-46 35.9C379.1 260.7 322 272 256 272s-123.1-11.3-162-28.1C50.7 225.2 48 208.8 48 208c0-10.6 5.6-26.2 44.4-41.3C130.6 151.9 187.8 144 256 144c18 0 35.1 .5 51.4 1.6z"
    ]
};
var $d8206b3ab2e65c05$export$dd52741c60cc638f = {
    prefix: "fas",
    iconName: "ice-cream",
    icon: [
        448,
        512,
        [
            127848
        ],
        "f810",
        "M367.1 160c.6-5.3 .9-10.6 .9-16C368 64.5 303.5 0 224 0S80 64.5 80 144c0 5.4 .3 10.7 .9 16H80c-26.5 0-48 21.5-48 48s21.5 48 48 48h53.5 181H368c26.5 0 48-21.5 48-48s-21.5-48-48-48h-.9zM96 288L200.8 497.7c4.4 8.8 13.3 14.3 23.2 14.3s18.8-5.5 23.2-14.3L352 288H96z"
    ]
};
var $d8206b3ab2e65c05$export$2a376a9d0d8fee96 = {
    prefix: "fas",
    iconName: "heart-circle-bolt",
    icon: [
        576,
        512,
        [],
        "e4fc",
        "M47.6 300.4L228.3 469.1c7.5 7 17.4 10.9 27.7 10.9s20.2-3.9 27.7-10.9l2.6-2.4C267.2 438.6 256 404.6 256 368c0-97.2 78.8-176 176-176c28.3 0 55 6.7 78.7 18.5c.9-6.5 1.3-13 1.3-19.6v-5.8c0-69.9-50.5-129.5-119.4-141C347 36.5 300.6 51.4 268 84L256 96 244 84c-32.6-32.6-79-47.5-124.6-39.9C50.5 55.6 0 115.2 0 185.1v5.8c0 41.5 17.2 81.2 47.6 109.5zM432 512a144 144 0 1 0 0-288 144 144 0 1 0 0 288zm47.9-225c4.3 3.7 5.4 9.9 2.6 14.9L452.4 356H488c5.2 0 9.8 3.3 11.4 8.2s-.1 10.3-4.2 13.4l-96 72c-4.5 3.4-10.8 3.2-15.1-.6s-5.4-9.9-2.6-14.9L411.6 380H376c-5.2 0-9.8-3.3-11.4-8.2s.1-10.3 4.2-13.4l96-72c4.5-3.4 10.8-3.2 15.1 .6z"
    ]
};
var $d8206b3ab2e65c05$export$b5698497901d7197 = {
    prefix: "fas",
    iconName: "fax",
    icon: [
        512,
        512,
        [
            128224,
            128439
        ],
        "f1ac",
        "M128 64v96h64V64H386.7L416 93.3V160h64V93.3c0-17-6.7-33.3-18.7-45.3L432 18.7C420 6.7 403.7 0 386.7 0H192c-35.3 0-64 28.7-64 64zM0 160V480c0 17.7 14.3 32 32 32H64c17.7 0 32-14.3 32-32V160c0-17.7-14.3-32-32-32H32c-17.7 0-32 14.3-32 32zm480 32H128V480c0 17.7 14.3 32 32 32H480c17.7 0 32-14.3 32-32V224c0-17.7-14.3-32-32-32zM256 256a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm96 32a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm32 96a32 32 0 1 1 0 64 32 32 0 1 1 0-64zM224 416a32 32 0 1 1 64 0 32 32 0 1 1 -64 0z"
    ]
};
var $d8206b3ab2e65c05$export$dec46f8df1860e0 = {
    prefix: "fas",
    iconName: "paragraph",
    icon: [
        448,
        512,
        [
            182
        ],
        "f1dd",
        "M192 32h64H416c17.7 0 32 14.3 32 32s-14.3 32-32 32H384l0 352c0 17.7-14.3 32-32 32s-32-14.3-32-32l0-352H288V448c0 17.7-14.3 32-32 32s-32-14.3-32-32V352H192c-88.4 0-160-71.6-160-160s71.6-160 160-160z"
    ]
};
var $d8206b3ab2e65c05$export$6999832247e52c2b = {
    prefix: "fas",
    iconName: "check-to-slot",
    icon: [
        576,
        512,
        [
            "vote-yea"
        ],
        "f772",
        "M96 80c0-26.5 21.5-48 48-48H432c26.5 0 48 21.5 48 48V384H96V80zm313 47c-9.4-9.4-24.6-9.4-33.9 0l-111 111-47-47c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9l64 64c9.4 9.4 24.6 9.4 33.9 0L409 161c9.4-9.4 9.4-24.6 0-33.9zM0 336c0-26.5 21.5-48 48-48H64V416H512V288h16c26.5 0 48 21.5 48 48v96c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V336z"
    ]
};
var $d8206b3ab2e65c05$export$e87bb3db1608b850 = $d8206b3ab2e65c05$export$6999832247e52c2b;
var $d8206b3ab2e65c05$export$228008b5e11032fa = {
    prefix: "fas",
    iconName: "star-half",
    icon: [
        576,
        512,
        [
            61731
        ],
        "f089",
        "M288 0c-12.2 .1-23.3 7-28.6 18L195 150.3 51.4 171.5c-12 1.8-22 10.2-25.7 21.7s-.7 24.2 7.9 32.7L137.8 329 113.2 474.7c-2 12 3 24.2 12.9 31.3s23 8 33.8 2.3L288 439.8V0zM429.9 512c1.1 .1 2.1 .1 3.2 0h-3.2z"
    ]
};
var $d8206b3ab2e65c05$export$2088efcf62cf3b1 = {
    prefix: "fas",
    iconName: "boxes-stacked",
    icon: [
        576,
        512,
        [
            62625,
            "boxes",
            "boxes-alt"
        ],
        "f468",
        "M248 0H208c-26.5 0-48 21.5-48 48V160c0 35.3 28.7 64 64 64H352c35.3 0 64-28.7 64-64V48c0-26.5-21.5-48-48-48H328V80c0 8.8-7.2 16-16 16H264c-8.8 0-16-7.2-16-16V0zM64 256c-35.3 0-64 28.7-64 64V448c0 35.3 28.7 64 64 64H224c35.3 0 64-28.7 64-64V320c0-35.3-28.7-64-64-64H184v80c0 8.8-7.2 16-16 16H120c-8.8 0-16-7.2-16-16V256H64zM352 512H512c35.3 0 64-28.7 64-64V320c0-35.3-28.7-64-64-64H472v80c0 8.8-7.2 16-16 16H408c-8.8 0-16-7.2-16-16V256H352c-15 0-28.8 5.1-39.7 13.8c4.9 10.4 7.7 22 7.7 34.2V464c0 12.2-2.8 23.8-7.7 34.2C323.2 506.9 337 512 352 512z"
    ]
};
var $d8206b3ab2e65c05$export$2007320dd6cde6db = $d8206b3ab2e65c05$export$2088efcf62cf3b1;
var $d8206b3ab2e65c05$export$e6ef1d896ed63b3e = $d8206b3ab2e65c05$export$2088efcf62cf3b1;
var $d8206b3ab2e65c05$export$88bc01ff8dbecc55 = {
    prefix: "fas",
    iconName: "link",
    icon: [
        640,
        512,
        [
            128279,
            "chain"
        ],
        "f0c1",
        "M579.8 267.7c56.5-56.5 56.5-148 0-204.5c-50-50-128.8-56.5-186.3-15.4l-1.6 1.1c-14.4 10.3-17.7 30.3-7.4 44.6s30.3 17.7 44.6 7.4l1.6-1.1c32.1-22.9 76-19.3 103.8 8.6c31.5 31.5 31.5 82.5 0 114L422.3 334.8c-31.5 31.5-82.5 31.5-114 0c-27.9-27.9-31.5-71.8-8.6-103.8l1.1-1.6c10.3-14.4 6.9-34.4-7.4-44.6s-34.4-6.9-44.6 7.4l-1.1 1.6C206.5 251.2 213 330 263 380c56.5 56.5 148 56.5 204.5 0L579.8 267.7zM60.2 244.3c-56.5 56.5-56.5 148 0 204.5c50 50 128.8 56.5 186.3 15.4l1.6-1.1c14.4-10.3 17.7-30.3 7.4-44.6s-30.3-17.7-44.6-7.4l-1.6 1.1c-32.1 22.9-76 19.3-103.8-8.6C74 372 74 321 105.5 289.5L217.7 177.2c31.5-31.5 82.5-31.5 114 0c27.9 27.9 31.5 71.8 8.6 103.9l-1.1 1.6c-10.3 14.4-6.9 34.4 7.4 44.6s34.4 6.9 44.6-7.4l1.1-1.6C433.5 260.8 427 182 377 132c-56.5-56.5-148-56.5-204.5 0L60.2 244.3z"
    ]
};
var $d8206b3ab2e65c05$export$b5d071e02a25554f = $d8206b3ab2e65c05$export$88bc01ff8dbecc55;
var $d8206b3ab2e65c05$export$837bc776b490934d = {
    prefix: "fas",
    iconName: "ear-listen",
    icon: [
        512,
        512,
        [
            "assistive-listening-systems"
        ],
        "f2a2",
        "M398.3 3.4c-15.8-7.9-35-1.5-42.9 14.3c-7.9 15.8-1.5 34.9 14.2 42.9l.4 .2c.4 .2 1.1 .6 2.1 1.2c2 1.2 5 3 8.7 5.6c7.5 5.2 17.6 13.2 27.7 24.2C428.5 113.4 448 146 448 192c0 17.7 14.3 32 32 32s32-14.3 32-32c0-66-28.5-113.4-56.5-143.7C441.6 33.2 427.7 22.2 417.3 15c-5.3-3.7-9.7-6.4-13-8.3c-1.6-1-3-1.7-4-2.2c-.5-.3-.9-.5-1.2-.7l-.4-.2-.2-.1-.1 0 0 0c0 0 0 0-14.3 28.6L398.3 3.4zM128.7 227.5c6.2-56 53.7-99.5 111.3-99.5c61.9 0 112 50.1 112 112c0 29.3-11.2 55.9-29.6 75.9c-17 18.4-34.4 45.1-34.4 78V400c0 26.5-21.5 48-48 48c-17.7 0-32 14.3-32 32s14.3 32 32 32c61.9 0 112-50.1 112-112v-6.1c0-9.8 5.4-21.7 17.4-34.7C398.3 327.9 416 286 416 240c0-97.2-78.8-176-176-176C149.4 64 74.8 132.5 65.1 220.5c-1.9 17.6 10.7 33.4 28.3 35.3s33.4-10.7 35.3-28.3zM32 512a32 32 0 1 0 0-64 32 32 0 1 0 0 64zM192 352a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zM41.4 361.4c-12.5 12.5-12.5 32.8 0 45.3l64 64c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3l-64-64c-12.5-12.5-32.8-12.5-45.3 0zM208 240c0-17.7 14.3-32 32-32s32 14.3 32 32c0 13.3 10.7 24 24 24s24-10.7 24-24c0-44.2-35.8-80-80-80s-80 35.8-80 80c0 13.3 10.7 24 24 24s24-10.7 24-24z"
    ]
};
var $d8206b3ab2e65c05$export$8eeef3dc0035b165 = $d8206b3ab2e65c05$export$837bc776b490934d;
var $d8206b3ab2e65c05$export$ad95e4f80f98ebe0 = {
    prefix: "fas",
    iconName: "tree-city",
    icon: [
        640,
        512,
        [],
        "e587",
        "M288 48c0-26.5 21.5-48 48-48h96c26.5 0 48 21.5 48 48V192h40V120c0-13.3 10.7-24 24-24s24 10.7 24 24v72h24c26.5 0 48 21.5 48 48V464c0 26.5-21.5 48-48 48H432 336c-26.5 0-48-21.5-48-48V48zm64 32v32c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V80c0-8.8-7.2-16-16-16H368c-8.8 0-16 7.2-16 16zm16 80c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V176c0-8.8-7.2-16-16-16H368zM352 272v32c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V272c0-8.8-7.2-16-16-16H368c-8.8 0-16 7.2-16 16zm176-16c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V272c0-8.8-7.2-16-16-16H528zM512 368v32c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V368c0-8.8-7.2-16-16-16H528c-8.8 0-16 7.2-16 16zM224 160c0 6-1 11-2 16c20 14 34 38 34 64c0 45-36 80-80 80H160V480c0 18-15 32-32 32c-18 0-32-14-32-32V320H80c-45 0-80-35-80-80c0-26 13-50 33-64c-1-5-1-10-1-16c0-53 42-96 96-96c53 0 96 43 96 96z"
    ]
};
var $d8206b3ab2e65c05$export$436587205947bca5 = {
    prefix: "fas",
    iconName: "play",
    icon: [
        384,
        512,
        [
            9654
        ],
        "f04b",
        "M73 39c-14.8-9.1-33.4-9.4-48.5-.9S0 62.6 0 80V432c0 17.4 9.4 33.4 24.5 41.9s33.7 8.1 48.5-.9L361 297c14.3-8.7 23-24.2 23-41s-8.7-32.2-23-41L73 39z"
    ]
};
var $d8206b3ab2e65c05$export$a5dc297d3f60936 = {
    prefix: "fas",
    iconName: "font",
    icon: [
        448,
        512,
        [],
        "f031",
        "M254 52.8C249.3 40.3 237.3 32 224 32s-25.3 8.3-30 20.8L57.8 416H32c-17.7 0-32 14.3-32 32s14.3 32 32 32h96c17.7 0 32-14.3 32-32s-14.3-32-32-32h-1.8l18-48H303.8l18 48H320c-17.7 0-32 14.3-32 32s14.3 32 32 32h96c17.7 0 32-14.3 32-32s-14.3-32-32-32H390.2L254 52.8zM279.8 304H168.2L224 155.1 279.8 304z"
    ]
};
var $d8206b3ab2e65c05$export$fe44d4c71644ea0 = {
    prefix: "fas",
    iconName: "rupiah-sign",
    icon: [
        512,
        512,
        [],
        "e23d",
        "M0 64C0 46.3 14.3 32 32 32h80c79.5 0 144 64.5 144 144c0 58.8-35.2 109.3-85.7 131.7l51.4 128.4c6.6 16.4-1.4 35-17.8 41.6s-35-1.4-41.6-17.8L106.3 320H64V448c0 17.7-14.3 32-32 32s-32-14.3-32-32V288 64zM64 256h48c44.2 0 80-35.8 80-80s-35.8-80-80-80H64V256zm256-96h80c61.9 0 112 50.1 112 112s-50.1 112-112 112H352v96c0 17.7-14.3 32-32 32s-32-14.3-32-32V352 192c0-17.7 14.3-32 32-32zm80 160c26.5 0 48-21.5 48-48s-21.5-48-48-48H352v96h48z"
    ]
};
var $d8206b3ab2e65c05$export$34c8b97060c09ff = {
    prefix: "fas",
    iconName: "magnifying-glass",
    icon: [
        512,
        512,
        [
            128269,
            "search"
        ],
        "f002",
        "M416 208c0 45.9-14.9 88.3-40 122.7L502.6 457.4c12.5 12.5 12.5 32.8 0 45.3s-32.8 12.5-45.3 0L330.7 376c-34.4 25.2-76.8 40-122.7 40C93.1 416 0 322.9 0 208S93.1 0 208 0S416 93.1 416 208zM208 352a144 144 0 1 0 0-288 144 144 0 1 0 0 288z"
    ]
};
var $d8206b3ab2e65c05$export$871a78837687ffe8 = $d8206b3ab2e65c05$export$34c8b97060c09ff;
var $d8206b3ab2e65c05$export$eabe53838d45ac6a = {
    prefix: "fas",
    iconName: "table-tennis-paddle-ball",
    icon: [
        640,
        512,
        [
            127955,
            "ping-pong-paddle-ball",
            "table-tennis"
        ],
        "f45d",
        "M480 288c-50.1 0-93.6 28.8-114.6 70.8L132.9 126.3l.6-.6 60.1-60.1c87.5-87.5 229.3-87.5 316.8 0c67.1 67.1 82.7 166.3 46.8 248.3C535.8 297.6 509 288 480 288zM113.3 151.9L354.1 392.7c-1.4 7.5-2.1 15.3-2.1 23.3c0 23.2 6.2 44.9 16.9 63.7c-3 .2-6.1 .3-9.2 .3H357c-33.9 0-66.5-13.5-90.5-37.5l-9.8-9.8c-13.1-13.1-34.6-12.4-46.8 1.7L152.2 501c-5.8 6.7-14.2 10.7-23 11s-17.5-3.1-23.8-9.4l-32-32c-6.3-6.3-9.7-14.9-9.4-23.8s4.3-17.2 11-23l66.6-57.7c14-12.2 14.8-33.7 1.7-46.8l-9.8-9.8c-24-24-37.5-56.6-37.5-90.5v-2.7c0-22.8 6.1-44.9 17.3-64.3zM480 320a96 96 0 1 1 0 192 96 96 0 1 1 0-192z"
    ]
};
var $d8206b3ab2e65c05$export$ebb246c621751737 = $d8206b3ab2e65c05$export$eabe53838d45ac6a;
var $d8206b3ab2e65c05$export$f378fbb4e0ef7edf = $d8206b3ab2e65c05$export$eabe53838d45ac6a;
var $d8206b3ab2e65c05$export$cdcec8ca7ec0d381 = {
    prefix: "fas",
    iconName: "person-dots-from-line",
    icon: [
        576,
        512,
        [
            "diagnoses"
        ],
        "f470",
        "M288 176A88 88 0 1 0 288 0a88 88 0 1 0 0 176zM78.7 372.9c15-12.5 50-34.4 97.3-50.1V432H400V322.7c47.3 15.8 82.3 37.7 97.3 50.1c20.4 17 50.6 14.2 67.6-6.1s14.2-50.6-6.1-67.6c-12-10-30.1-22.5-53.2-35C497.2 278.4 481.7 288 464 288c-26.5 0-48-21.5-48-48c0-4.3 .6-8.4 1.6-12.4C379.1 215.9 335.3 208 288 208c-60.2 0-114.9 12.9-160 29.9c0 .7 0 1.4 0 2.1c0 26.5-21.5 48-48 48c-11.8 0-22.7-4.3-31-11.4c-13.1 8.1-23.7 15.9-31.7 22.5c-20.4 17-23.1 47.2-6.1 67.6s47.2 23.1 67.6 6.1zM24 464c-13.3 0-24 10.7-24 24s10.7 24 24 24H552c13.3 0 24-10.7 24-24s-10.7-24-24-24H24zM224 280a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zm104 56a24 24 0 1 1 0 48 24 24 0 1 1 0-48zM96 240a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zm368 16a16 16 0 1 0 0-32 16 16 0 1 0 0 32z"
    ]
};
var $d8206b3ab2e65c05$export$68bad2b52a90d1fa = $d8206b3ab2e65c05$export$cdcec8ca7ec0d381;
var $d8206b3ab2e65c05$export$60430351cdb4ba89 = {
    prefix: "fas",
    iconName: "trash-can-arrow-up",
    icon: [
        448,
        512,
        [
            "trash-restore-alt"
        ],
        "f82a",
        "M163.8 0H284.2c12.1 0 23.2 6.8 28.6 17.7L320 32h96c17.7 0 32 14.3 32 32s-14.3 32-32 32H32C14.3 96 0 81.7 0 64S14.3 32 32 32h96l7.2-14.3C140.6 6.8 151.7 0 163.8 0zM32 128H416V448c0 35.3-28.7 64-64 64H96c-35.3 0-64-28.7-64-64V128zm192 64c-6.4 0-12.5 2.5-17 7l-80 80c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l39-39V408c0 13.3 10.7 24 24 24s24-10.7 24-24V273.9l39 39c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9l-80-80c-4.5-4.5-10.6-7-17-7z"
    ]
};
var $d8206b3ab2e65c05$export$d075b19b21cb9856 = $d8206b3ab2e65c05$export$60430351cdb4ba89;
var $d8206b3ab2e65c05$export$58b7558ca9822358 = {
    prefix: "fas",
    iconName: "naira-sign",
    icon: [
        448,
        512,
        [],
        "e1f6",
        "M122.6 46.3c-7.8-11.7-22.4-17-35.9-12.9S64 49.9 64 64V256H32c-17.7 0-32 14.3-32 32s14.3 32 32 32H64V448c0 17.7 14.3 32 32 32s32-14.3 32-32V320H228.2l97.2 145.8c7.8 11.7 22.4 17 35.9 12.9s22.7-16.5 22.7-30.6V320h32c17.7 0 32-14.3 32-32s-14.3-32-32-32H384V64c0-17.7-14.3-32-32-32s-32 14.3-32 32V256H262.5L122.6 46.3zM305.1 320H320v22.3L305.1 320zM185.5 256H128V169.7L185.5 256z"
    ]
};
var $d8206b3ab2e65c05$export$9206260ff0c0c616 = {
    prefix: "fas",
    iconName: "cart-arrow-down",
    icon: [
        576,
        512,
        [],
        "f218",
        "M24 0C10.7 0 0 10.7 0 24S10.7 48 24 48H69.5c3.8 0 7.1 2.7 7.9 6.5l51.6 271c6.5 34 36.2 58.5 70.7 58.5H488c13.3 0 24-10.7 24-24s-10.7-24-24-24H199.7c-11.5 0-21.4-8.2-23.6-19.5L170.7 288H459.2c32.6 0 61.1-21.8 69.5-53.3l41-152.3C576.6 57 557.4 32 531.1 32H360V134.1l23-23c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9l-64 64c-9.4 9.4-24.6 9.4-33.9 0l-64-64c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l23 23V32H120.1C111 12.8 91.6 0 69.5 0H24zM176 512a48 48 0 1 0 0-96 48 48 0 1 0 0 96zm336-48a48 48 0 1 0 -96 0 48 48 0 1 0 96 0z"
    ]
};
var $d8206b3ab2e65c05$export$8a322f740d64e9fc = {
    prefix: "fas",
    iconName: "walkie-talkie",
    icon: [
        384,
        512,
        [],
        "f8ef",
        "M112 24c0-13.3-10.7-24-24-24S64 10.7 64 24V96H48C21.5 96 0 117.5 0 144V300.1c0 12.7 5.1 24.9 14.1 33.9l3.9 3.9c9 9 14.1 21.2 14.1 33.9V464c0 26.5 21.5 48 48 48H304c26.5 0 48-21.5 48-48V371.9c0-12.7 5.1-24.9 14.1-33.9l3.9-3.9c9-9 14.1-21.2 14.1-33.9V144c0-26.5-21.5-48-48-48H320c0-17.7-14.3-32-32-32s-32 14.3-32 32H224c0-17.7-14.3-32-32-32s-32 14.3-32 32H112V24zm0 136H272c8.8 0 16 7.2 16 16s-7.2 16-16 16H112c-8.8 0-16-7.2-16-16s7.2-16 16-16zm0 64H272c8.8 0 16 7.2 16 16s-7.2 16-16 16H112c-8.8 0-16-7.2-16-16s7.2-16 16-16zm0 64H272c8.8 0 16 7.2 16 16s-7.2 16-16 16H112c-8.8 0-16-7.2-16-16s7.2-16 16-16z"
    ]
};
var $d8206b3ab2e65c05$export$27f34878d8ed7a76 = {
    prefix: "fas",
    iconName: "file-pen",
    icon: [
        576,
        512,
        [
            128221,
            "file-edit"
        ],
        "f31c",
        "M0 64C0 28.7 28.7 0 64 0H224V128c0 17.7 14.3 32 32 32H384V285.7l-86.8 86.8c-10.3 10.3-17.5 23.1-21 37.2l-18.7 74.9c-2.3 9.2-1.8 18.8 1.3 27.5H64c-35.3 0-64-28.7-64-64V64zm384 64H256V0L384 128zM549.8 235.7l14.4 14.4c15.6 15.6 15.6 40.9 0 56.6l-29.4 29.4-71-71 29.4-29.4c15.6-15.6 40.9-15.6 56.6 0zM311.9 417L441.1 287.8l71 71L382.9 487.9c-4.1 4.1-9.2 7-14.9 8.4l-60.1 15c-5.5 1.4-11.2-.2-15.2-4.2s-5.6-9.7-4.2-15.2l15-60.1c1.4-5.6 4.3-10.8 8.4-14.9z"
    ]
};
var $d8206b3ab2e65c05$export$e343e19f1757c5ae = $d8206b3ab2e65c05$export$27f34878d8ed7a76;
var $d8206b3ab2e65c05$export$32b0cd6133c2742 = {
    prefix: "fas",
    iconName: "receipt",
    icon: [
        384,
        512,
        [
            129534
        ],
        "f543",
        "M14 2.2C22.5-1.7 32.5-.3 39.6 5.8L80 40.4 120.4 5.8c9-7.7 22.3-7.7 31.2 0L192 40.4 232.4 5.8c9-7.7 22.3-7.7 31.2 0L304 40.4 344.4 5.8c7.1-6.1 17.1-7.5 25.6-3.6s14 12.4 14 21.8V488c0 9.4-5.5 17.9-14 21.8s-18.5 2.5-25.6-3.6L304 471.6l-40.4 34.6c-9 7.7-22.3 7.7-31.2 0L192 471.6l-40.4 34.6c-9 7.7-22.3 7.7-31.2 0L80 471.6 39.6 506.2c-7.1 6.1-17.1 7.5-25.6 3.6S0 497.4 0 488V24C0 14.6 5.5 6.1 14 2.2zM96 144c-8.8 0-16 7.2-16 16s7.2 16 16 16H288c8.8 0 16-7.2 16-16s-7.2-16-16-16H96zM80 352c0 8.8 7.2 16 16 16H288c8.8 0 16-7.2 16-16s-7.2-16-16-16H96c-8.8 0-16 7.2-16 16zM96 240c-8.8 0-16 7.2-16 16s7.2 16 16 16H288c8.8 0 16-7.2 16-16s-7.2-16-16-16H96z"
    ]
};
var $d8206b3ab2e65c05$export$3643b719db23d46e = {
    prefix: "fas",
    iconName: "square-pen",
    icon: [
        448,
        512,
        [
            "pen-square",
            "pencil-square"
        ],
        "f14b",
        "M64 32C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64zM325.8 139.7l14.4 14.4c15.6 15.6 15.6 40.9 0 56.6l-21.4 21.4-71-71 21.4-21.4c15.6-15.6 40.9-15.6 56.6 0zM119.9 289L225.1 183.8l71 71L190.9 359.9c-4.1 4.1-9.2 7-14.9 8.4l-60.1 15c-5.5 1.4-11.2-.2-15.2-4.2s-5.6-9.7-4.2-15.2l15-60.1c1.4-5.6 4.3-10.8 8.4-14.9z"
    ]
};
var $d8206b3ab2e65c05$export$fbb231ccb3d960bc = $d8206b3ab2e65c05$export$3643b719db23d46e;
var $d8206b3ab2e65c05$export$35d253ecd249e771 = $d8206b3ab2e65c05$export$3643b719db23d46e;
var $d8206b3ab2e65c05$export$957e62a9b80ff4e3 = {
    prefix: "fas",
    iconName: "suitcase-rolling",
    icon: [
        384,
        512,
        [],
        "f5c1",
        "M144 56c0-4.4 3.6-8 8-8h80c4.4 0 8 3.6 8 8v72H144V56zm176 72H288V56c0-30.9-25.1-56-56-56H152C121.1 0 96 25.1 96 56v72H64c-35.3 0-64 28.7-64 64V416c0 35.3 28.7 64 64 64c0 17.7 14.3 32 32 32s32-14.3 32-32H256c0 17.7 14.3 32 32 32s32-14.3 32-32c35.3 0 64-28.7 64-64V192c0-35.3-28.7-64-64-64zM112 224H272c8.8 0 16 7.2 16 16s-7.2 16-16 16H112c-8.8 0-16-7.2-16-16s7.2-16 16-16zm0 128H272c8.8 0 16 7.2 16 16s-7.2 16-16 16H112c-8.8 0-16-7.2-16-16s7.2-16 16-16z"
    ]
};
var $d8206b3ab2e65c05$export$38c8c32017dd9cc = {
    prefix: "fas",
    iconName: "person-circle-exclamation",
    icon: [
        576,
        512,
        [],
        "e53f",
        "M112 48a48 48 0 1 1 96 0 48 48 0 1 1 -96 0zm40 304V480c0 17.7-14.3 32-32 32s-32-14.3-32-32V256.9L59.4 304.5c-9.1 15.1-28.8 20-43.9 10.9s-20-28.8-10.9-43.9l58.3-97c17.4-28.9 48.6-46.6 82.3-46.6h29.7c33.7 0 64.9 17.7 82.3 46.6l44.9 74.7c-16.1 17.6-28.6 38.5-36.6 61.5c-1.9-1.8-3.5-3.9-4.9-6.3L232 256.9V480c0 17.7-14.3 32-32 32s-32-14.3-32-32V352H152zM432 224a144 144 0 1 1 0 288 144 144 0 1 1 0-288zm0 240a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm0-192c-8.8 0-16 7.2-16 16v80c0 8.8 7.2 16 16 16s16-7.2 16-16V288c0-8.8-7.2-16-16-16z"
    ]
};
var $d8206b3ab2e65c05$export$8db9bc521720fccd = {
    prefix: "fas",
    iconName: "chevron-down",
    icon: [
        512,
        512,
        [],
        "f078",
        "M233.4 406.6c12.5 12.5 32.8 12.5 45.3 0l192-192c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L256 338.7 86.6 169.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3l192 192z"
    ]
};
var $d8206b3ab2e65c05$export$9338fc4614cfc0cf = {
    prefix: "fas",
    iconName: "battery-full",
    icon: [
        576,
        512,
        [
            128267,
            "battery",
            "battery-5"
        ],
        "f240",
        "M464 160c8.8 0 16 7.2 16 16V336c0 8.8-7.2 16-16 16H80c-8.8 0-16-7.2-16-16V176c0-8.8 7.2-16 16-16H464zM80 96C35.8 96 0 131.8 0 176V336c0 44.2 35.8 80 80 80H464c44.2 0 80-35.8 80-80V320c17.7 0 32-14.3 32-32V224c0-17.7-14.3-32-32-32V176c0-44.2-35.8-80-80-80H80zm368 96H96V320H448V192z"
    ]
};
var $d8206b3ab2e65c05$export$214720d39635cea8 = $d8206b3ab2e65c05$export$9338fc4614cfc0cf;
var $d8206b3ab2e65c05$export$e426617482c711a7 = $d8206b3ab2e65c05$export$9338fc4614cfc0cf;
var $d8206b3ab2e65c05$export$8717352b90217272 = {
    prefix: "fas",
    iconName: "skull-crossbones",
    icon: [
        448,
        512,
        [
            128369,
            9760
        ],
        "f714",
        "M368 128c0 44.4-25.4 83.5-64 106.4V256c0 17.7-14.3 32-32 32H176c-17.7 0-32-14.3-32-32V234.4c-38.6-23-64-62.1-64-106.4C80 57.3 144.5 0 224 0s144 57.3 144 128zM168 176a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm144-32a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zM3.4 273.7c7.9-15.8 27.1-22.2 42.9-14.3L224 348.2l177.7-88.8c15.8-7.9 35-1.5 42.9 14.3s1.5 35-14.3 42.9L295.6 384l134.8 67.4c15.8 7.9 22.2 27.1 14.3 42.9s-27.1 22.2-42.9 14.3L224 419.8 46.3 508.6c-15.8 7.9-35 1.5-42.9-14.3s-1.5-35 14.3-42.9L152.4 384 17.7 316.6C1.9 308.7-4.5 289.5 3.4 273.7z"
    ]
};
var $d8206b3ab2e65c05$export$ca4c5b4dcff58860 = {
    prefix: "fas",
    iconName: "code-compare",
    icon: [
        512,
        512,
        [],
        "e13a",
        "M320 488c0 9.5-5.6 18.1-14.2 21.9s-18.8 2.3-25.8-4.1l-80-72c-5.1-4.6-7.9-11-7.9-17.8s2.9-13.3 7.9-17.8l80-72c7-6.3 17.2-7.9 25.8-4.1s14.2 12.4 14.2 21.9v40h16c35.3 0 64-28.7 64-64V153.3C371.7 141 352 112.8 352 80c0-44.2 35.8-80 80-80s80 35.8 80 80c0 32.8-19.7 61-48 73.3V320c0 70.7-57.3 128-128 128H320v40zM456 80a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zM192 24c0-9.5 5.6-18.1 14.2-21.9s18.8-2.3 25.8 4.1l80 72c5.1 4.6 7.9 11 7.9 17.8s-2.9 13.3-7.9 17.8l-80 72c-7 6.3-17.2 7.9-25.8 4.1s-14.2-12.4-14.2-21.9V128H176c-35.3 0-64 28.7-64 64V358.7c28.3 12.3 48 40.5 48 73.3c0 44.2-35.8 80-80 80s-80-35.8-80-80c0-32.8 19.7-61 48-73.3V192c0-70.7 57.3-128 128-128h16V24zM56 432a24 24 0 1 0 48 0 24 24 0 1 0 -48 0z"
    ]
};
var $d8206b3ab2e65c05$export$f8a219cf4f516384 = {
    prefix: "fas",
    iconName: "list-ul",
    icon: [
        512,
        512,
        [
            "list-dots"
        ],
        "f0ca",
        "M64 144a48 48 0 1 0 0-96 48 48 0 1 0 0 96zM192 64c-17.7 0-32 14.3-32 32s14.3 32 32 32H480c17.7 0 32-14.3 32-32s-14.3-32-32-32H192zm0 160c-17.7 0-32 14.3-32 32s14.3 32 32 32H480c17.7 0 32-14.3 32-32s-14.3-32-32-32H192zm0 160c-17.7 0-32 14.3-32 32s14.3 32 32 32H480c17.7 0 32-14.3 32-32s-14.3-32-32-32H192zM64 464a48 48 0 1 0 0-96 48 48 0 1 0 0 96zm48-208a48 48 0 1 0 -96 0 48 48 0 1 0 96 0z"
    ]
};
var $d8206b3ab2e65c05$export$e6f4ba30d84fa6ea = $d8206b3ab2e65c05$export$f8a219cf4f516384;
var $d8206b3ab2e65c05$export$8845cce2a763ee07 = {
    prefix: "fas",
    iconName: "school-lock",
    icon: [
        640,
        512,
        [],
        "e56f",
        "M302.2 5.4c10.7-7.2 24.8-7.2 35.5 0L473.7 96H592c26.5 0 48 21.5 48 48V272c0-61.9-50.1-112-112-112s-112 50.1-112 112v24.6c-19.1 11.1-32 31.7-32 55.4H320.3l-.3 0c-35.3 0-64 28.7-64 64v96h64v0H48c-26.5 0-48-21.5-48-48V144c0-26.5 21.5-48 48-48H166.3L302.2 5.4zM80 208v64c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V208c0-8.8-7.2-16-16-16H96c-8.8 0-16 7.2-16 16zm0 128v64c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V336c0-8.8-7.2-16-16-16H96c-8.8 0-16 7.2-16 16zm240-72a88 88 0 1 0 0-176 88 88 0 1 0 0 176zm16-120v16h16c8.8 0 16 7.2 16 16s-7.2 16-16 16H320c-8.8 0-16-7.2-16-16V144c0-8.8 7.2-16 16-16s16 7.2 16 16zm192 96c-17.7 0-32 14.3-32 32v48h64V272c0-17.7-14.3-32-32-32zm-80 32c0-44.2 35.8-80 80-80s80 35.8 80 80v48c17.7 0 32 14.3 32 32V480c0 17.7-14.3 32-32 32H448c-17.7 0-32-14.3-32-32V352c0-17.7 14.3-32 32-32V272z"
    ]
};
var $d8206b3ab2e65c05$export$f4b64c3a138c1b59 = {
    prefix: "fas",
    iconName: "tower-cell",
    icon: [
        576,
        512,
        [],
        "e585",
        "M62.6 2.3C46.2-4.3 27.6 3.6 20.9 20C7.4 53.4 0 89.9 0 128s7.4 74.6 20.9 108c6.6 16.4 25.3 24.3 41.7 17.7S86.9 228.4 80.3 212C69.8 186.1 64 157.8 64 128s5.8-58.1 16.3-84C86.9 27.6 79 9 62.6 2.3zm450.8 0C497 9 489.1 27.6 495.7 44C506.2 69.9 512 98.2 512 128s-5.8 58.1-16.3 84c-6.6 16.4 1.3 35 17.7 41.7s35-1.3 41.7-17.7c13.5-33.4 20.9-69.9 20.9-108s-7.4-74.6-20.9-108C548.4 3.6 529.8-4.3 513.4 2.3zM340.1 165.2c7.5-10.5 11.9-23.3 11.9-37.2c0-35.3-28.7-64-64-64s-64 28.7-64 64c0 13.9 4.4 26.7 11.9 37.2L98.9 466.8c-7.3 16.1-.2 35.1 15.9 42.4s35.1 .2 42.4-15.9L177.7 448H398.3l20.6 45.2c7.3 16.1 26.3 23.2 42.4 15.9s23.2-26.3 15.9-42.4L340.1 165.2zM369.2 384H206.8l14.5-32H354.7l14.5 32zM288 205.3L325.6 288H250.4L288 205.3zM163.3 73.6c5.3-12.1-.2-26.3-12.4-31.6s-26.3 .2-31.6 12.4C109.5 77 104 101.9 104 128s5.5 51 15.3 73.6c5.3 12.1 19.5 17.7 31.6 12.4s17.7-19.5 12.4-31.6C156 165.8 152 147.4 152 128s4-37.8 11.3-54.4zM456.7 54.4c-5.3-12.1-19.5-17.7-31.6-12.4s-17.7 19.5-12.4 31.6C420 90.2 424 108.6 424 128s-4 37.8-11.3 54.4c-5.3 12.1 .2 26.3 12.4 31.6s26.3-.2 31.6-12.4C466.5 179 472 154.1 472 128s-5.5-51-15.3-73.6z"
    ]
};
var $d8206b3ab2e65c05$export$e88ba08d4f4d65b6 = {
    prefix: "fas",
    iconName: "down-long",
    icon: [
        320,
        512,
        [
            "long-arrow-alt-down"
        ],
        "f309",
        "M2 334.5c-3.8 8.8-2 19 4.6 26l136 144c4.5 4.8 10.8 7.5 17.4 7.5s12.9-2.7 17.4-7.5l136-144c6.6-7 8.4-17.2 4.6-26s-12.5-14.5-22-14.5l-72 0 0-288c0-17.7-14.3-32-32-32L128 0C110.3 0 96 14.3 96 32l0 288-72 0c-9.6 0-18.2 5.7-22 14.5z"
    ]
};
var $d8206b3ab2e65c05$export$8b92530ca6418c2f = $d8206b3ab2e65c05$export$e88ba08d4f4d65b6;
var $d8206b3ab2e65c05$export$e6fd420a918b43b5 = {
    prefix: "fas",
    iconName: "ranking-star",
    icon: [
        640,
        512,
        [],
        "e561",
        "M353.8 54.1L330.2 6.3c-3.9-8.3-16.1-8.6-20.4 0L286.2 54.1l-52.3 7.5c-9.3 1.4-13.3 12.9-6.4 19.8l38 37-9 52.1c-1.4 9.3 8.2 16.5 16.8 12.2l46.9-24.8 46.6 24.4c8.6 4.3 18.3-2.9 16.8-12.2l-9-52.1 38-36.6c6.8-6.8 2.9-18.3-6.4-19.8l-52.3-7.5zM256 256c-17.7 0-32 14.3-32 32V480c0 17.7 14.3 32 32 32H384c17.7 0 32-14.3 32-32V288c0-17.7-14.3-32-32-32H256zM32 320c-17.7 0-32 14.3-32 32V480c0 17.7 14.3 32 32 32H160c17.7 0 32-14.3 32-32V352c0-17.7-14.3-32-32-32H32zm416 96v64c0 17.7 14.3 32 32 32H608c17.7 0 32-14.3 32-32V416c0-17.7-14.3-32-32-32H480c-17.7 0-32 14.3-32 32z"
    ]
};
var $d8206b3ab2e65c05$export$d5713874f8fefe1b = {
    prefix: "fas",
    iconName: "chess-king",
    icon: [
        448,
        512,
        [
            9818
        ],
        "f43f",
        "M224 0c17.7 0 32 14.3 32 32V48h16c17.7 0 32 14.3 32 32s-14.3 32-32 32H256v48H408c22.1 0 40 17.9 40 40c0 5.3-1 10.5-3.1 15.4L368 400H80L3.1 215.4C1 210.5 0 205.3 0 200c0-22.1 17.9-40 40-40H192V112H176c-17.7 0-32-14.3-32-32s14.3-32 32-32h16V32c0-17.7 14.3-32 32-32zM38.6 473.4L80 432H368l41.4 41.4c4.2 4.2 6.6 10 6.6 16c0 12.5-10.1 22.6-22.6 22.6H54.6C42.1 512 32 501.9 32 489.4c0-6 2.4-11.8 6.6-16z"
    ]
};
var $d8206b3ab2e65c05$export$dcd74f2821882a49 = {
    prefix: "fas",
    iconName: "person-harassing",
    icon: [
        576,
        512,
        [],
        "e549",
        "M192 96a48 48 0 1 0 0-96 48 48 0 1 0 0 96zM59.4 304.5L88 256.9V480c0 17.7 14.3 32 32 32s32-14.3 32-32V352h16V480c0 17.7 14.3 32 32 32s32-14.3 32-32V235.3l47.4 57.1c11.3 13.6 31.5 15.5 45.1 4.2s15.5-31.5 4.2-45.1l-73.7-88.9c-18.2-22-45.3-34.7-73.9-34.7H145.1c-33.7 0-64.9 17.7-82.3 46.6l-58.3 97c-9.1 15.1-4.2 34.8 10.9 43.9s34.8 4.2 43.9-10.9zM480 240a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zM464 344v58.7l-41.4-41.4c-7.3-7.3-17.6-10.6-27.8-9s-18.9 8.1-23.5 17.3l-48 96c-7.9 15.8-1.5 35 14.3 42.9s35 1.5 42.9-14.3L408.8 438l54.7 54.7c12.4 12.4 29.1 19.3 46.6 19.3c36.4 0 65.9-29.5 65.9-65.9V344c0-30.9-25.1-56-56-56s-56 25.1-56 56zM288 48c0 8.8 7.2 16 16 16h56c8.8 0 16-7.2 16-16s-7.2-16-16-16H304c-8.8 0-16 7.2-16 16zm-.8 49.7c-7.9-4-17.5-.7-21.5 7.2s-.7 17.5 7.2 21.5l48 24c7.9 4 17.5 .7 21.5-7.2s.7-17.5-7.2-21.5l-48-24z"
    ]
};
var $d8206b3ab2e65c05$export$9d355b4e79216962 = {
    prefix: "fas",
    iconName: "brazilian-real-sign",
    icon: [
        512,
        512,
        [],
        "e46c",
        "M400 0c17.7 0 32 14.3 32 32V50.2c12.5 2.3 24.7 6.4 36.2 12.1l10.1 5.1c15.8 7.9 22.2 27.1 14.3 42.9s-27.1 22.2-42.9 14.3l-10.2-5.1c-9.9-5-20.9-7.5-32-7.5h-1.7c-29.8 0-53.9 24.1-53.9 53.9c0 22 13.4 41.8 33.9 50l52 20.8c44.7 17.9 74.1 61.2 74.1 109.4v3.4c0 51.2-33.6 94.6-80 109.2V480c0 17.7-14.3 32-32 32s-32-14.3-32-32V460.6c-15-3.5-29.4-9.7-42.3-18.3l-23.4-15.6c-14.7-9.8-18.7-29.7-8.9-44.4s29.7-18.7 44.4-8.9L361.2 389c10.8 7.2 23.4 11 36.3 11c27.9 0 50.5-22.6 50.5-50.5v-3.4c0-22-13.4-41.8-33.9-50l-52-20.8C317.3 257.4 288 214.1 288 165.9C288 114 321.5 70 368 54.2V32c0-17.7 14.3-32 32-32zM0 64C0 46.3 14.3 32 32 32h80c79.5 0 144 64.5 144 144c0 58.8-35.2 109.3-85.7 131.7l51.4 128.4c6.6 16.4-1.4 35-17.8 41.6s-35-1.4-41.6-17.8L106.3 320H64V448c0 17.7-14.3 32-32 32s-32-14.3-32-32V288 64zM64 256h48c44.2 0 80-35.8 80-80s-35.8-80-80-80H64V256z"
    ]
};
var $d8206b3ab2e65c05$export$8a56136f40511e5d = {
    prefix: "fas",
    iconName: "landmark-dome",
    icon: [
        512,
        512,
        [
            "landmark-alt"
        ],
        "f752",
        "M248 0h16c13.3 0 24 10.7 24 24V34.7C368.4 48.1 431.9 111.6 445.3 192H448c17.7 0 32 14.3 32 32s-14.3 32-32 32H64c-17.7 0-32-14.3-32-32s14.3-32 32-32h2.7C80.1 111.6 143.6 48.1 224 34.7V24c0-13.3 10.7-24 24-24zM64 288h64V416h40V288h64V416h48V288h64V416h40V288h64V420.3c.6 .3 1.2 .7 1.7 1.1l48 32c11.7 7.8 17 22.4 12.9 35.9S494.1 512 480 512H32c-14.1 0-26.5-9.2-30.6-22.7s1.1-28.1 12.9-35.9l48-32c.6-.4 1.2-.7 1.8-1.1V288z"
    ]
};
var $d8206b3ab2e65c05$export$8b9c180efffc50ab = $d8206b3ab2e65c05$export$8a56136f40511e5d;
var $d8206b3ab2e65c05$export$8e144ed4d52eef49 = {
    prefix: "fas",
    iconName: "arrow-up",
    icon: [
        384,
        512,
        [
            8593
        ],
        "f062",
        "M214.6 41.4c-12.5-12.5-32.8-12.5-45.3 0l-160 160c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0L160 141.2V448c0 17.7 14.3 32 32 32s32-14.3 32-32V141.2L329.4 246.6c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3l-160-160z"
    ]
};
var $d8206b3ab2e65c05$export$e0cfed4ba2fe562c = {
    prefix: "fas",
    iconName: "tv",
    icon: [
        640,
        512,
        [
            63717,
            "television",
            "tv-alt"
        ],
        "f26c",
        "M64 64V352H576V64H64zM0 64C0 28.7 28.7 0 64 0H576c35.3 0 64 28.7 64 64V352c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V64zM128 448H512c17.7 0 32 14.3 32 32s-14.3 32-32 32H128c-17.7 0-32-14.3-32-32s14.3-32 32-32z"
    ]
};
var $d8206b3ab2e65c05$export$9803b0176917be28 = $d8206b3ab2e65c05$export$e0cfed4ba2fe562c;
var $d8206b3ab2e65c05$export$6aa64ad5a1974ad7 = $d8206b3ab2e65c05$export$e0cfed4ba2fe562c;
var $d8206b3ab2e65c05$export$ac094c06f566cca3 = {
    prefix: "fas",
    iconName: "shrimp",
    icon: [
        512,
        512,
        [
            129424
        ],
        "e448",
        "M64 32C28.7 32 0 60.7 0 96s28.7 64 64 64h1c3.7 88.9 77 160 167 160h56V128H264 88.8 64c-17.7 0-32-14.3-32-32s14.3-32 32-32H464c8.8 0 16-7.2 16-16s-7.2-16-16-16H64zM224 456c0 13.3 10.7 24 24 24h72V407.8l-64.1-22.4c-12.5-4.4-26.2 2.2-30.6 14.7s2.2 26.2 14.7 30.6l4.5 1.6C233 433.9 224 443.9 224 456zm128 23.3c36.4-3.3 69.5-17.6 96.1-39.6l-86.5-34.6c-3 1.8-6.2 3.2-9.6 4.3v69.9zM472.6 415c24.6-30.3 39.4-68.9 39.4-111c0-12.3-1.3-24.3-3.7-35.9L382.8 355.1c.8 3.4 1.2 7 1.2 10.6c0 4.6-.7 9-1.9 13.1L472.6 415zM336 128H320V320h18.3c9.9 0 19.1 3.2 26.6 8.5l133.5-92.4C471.8 172.6 409.1 128 336 128zM168 192a24 24 0 1 1 48 0 24 24 0 1 1 -48 0z"
    ]
};
var $d8206b3ab2e65c05$export$350a84fd0f833f4d = {
    prefix: "fas",
    iconName: "list-check",
    icon: [
        512,
        512,
        [
            "tasks"
        ],
        "f0ae",
        "M152.1 38.2c9.9 8.9 10.7 24 1.8 33.9l-72 80c-4.4 4.9-10.6 7.8-17.2 7.9s-12.9-2.4-17.6-7L7 113C-2.3 103.6-2.3 88.4 7 79s24.6-9.4 33.9 0l22.1 22.1 55.1-61.2c8.9-9.9 24-10.7 33.9-1.8zm0 160c9.9 8.9 10.7 24 1.8 33.9l-72 80c-4.4 4.9-10.6 7.8-17.2 7.9s-12.9-2.4-17.6-7L7 273c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l22.1 22.1 55.1-61.2c8.9-9.9 24-10.7 33.9-1.8zM224 96c0-17.7 14.3-32 32-32H480c17.7 0 32 14.3 32 32s-14.3 32-32 32H256c-17.7 0-32-14.3-32-32zm0 160c0-17.7 14.3-32 32-32H480c17.7 0 32 14.3 32 32s-14.3 32-32 32H256c-17.7 0-32-14.3-32-32zM160 416c0-17.7 14.3-32 32-32H480c17.7 0 32 14.3 32 32s-14.3 32-32 32H192c-17.7 0-32-14.3-32-32zM48 368a48 48 0 1 1 0 96 48 48 0 1 1 0-96z"
    ]
};
var $d8206b3ab2e65c05$export$2f6d5b2fec286d63 = $d8206b3ab2e65c05$export$350a84fd0f833f4d;
var $d8206b3ab2e65c05$export$3fe50bd8062cd141 = {
    prefix: "fas",
    iconName: "jug-detergent",
    icon: [
        384,
        512,
        [],
        "e519",
        "M96 24c0-13.3 10.7-24 24-24h80c13.3 0 24 10.7 24 24V48h8c13.3 0 24 10.7 24 24s-10.7 24-24 24H88C74.7 96 64 85.3 64 72s10.7-24 24-24h8V24zM0 256c0-70.7 57.3-128 128-128H256c70.7 0 128 57.3 128 128V448c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V256zm256 0v96c0 17.7 14.3 32 32 32s32-14.3 32-32V256c0-17.7-14.3-32-32-32s-32 14.3-32 32z"
    ]
};
var $d8206b3ab2e65c05$export$9a5c11a5e3d7f1e7 = {
    prefix: "fas",
    iconName: "circle-user",
    icon: [
        512,
        512,
        [
            62142,
            "user-circle"
        ],
        "f2bd",
        "M399 384.2C376.9 345.8 335.4 320 288 320H224c-47.4 0-88.9 25.8-111 64.2c35.2 39.2 86.2 63.8 143 63.8s107.8-24.7 143-63.8zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm256 16a72 72 0 1 0 0-144 72 72 0 1 0 0 144z"
    ]
};
var $d8206b3ab2e65c05$export$be7d974e9e0dba1a = $d8206b3ab2e65c05$export$9a5c11a5e3d7f1e7;
var $d8206b3ab2e65c05$export$d1886bc596424e6c = {
    prefix: "fas",
    iconName: "user-shield",
    icon: [
        640,
        512,
        [],
        "f505",
        "M224 256A128 128 0 1 0 224 0a128 128 0 1 0 0 256zm-45.7 48C79.8 304 0 383.8 0 482.3C0 498.7 13.3 512 29.7 512H418.3c1.8 0 3.5-.2 5.3-.5c-76.3-55.1-99.8-141-103.1-200.2c-16.1-4.8-33.1-7.3-50.7-7.3H178.3zm308.8-78.3l-120 48C358 277.4 352 286.2 352 296c0 63.3 25.9 168.8 134.8 214.2c5.9 2.5 12.6 2.5 18.5 0C614.1 464.8 640 359.3 640 296c0-9.8-6-18.6-15.1-22.3l-120-48c-5.7-2.3-12.1-2.3-17.8 0zM591.4 312c-3.9 50.7-27.2 116.7-95.4 149.7V273.8L591.4 312z"
    ]
};
var $d8206b3ab2e65c05$export$cc58cb0f2257a6a9 = {
    prefix: "fas",
    iconName: "wind",
    icon: [
        512,
        512,
        [],
        "f72e",
        "M288 32c0 17.7 14.3 32 32 32h32c17.7 0 32 14.3 32 32s-14.3 32-32 32H32c-17.7 0-32 14.3-32 32s14.3 32 32 32H352c53 0 96-43 96-96s-43-96-96-96H320c-17.7 0-32 14.3-32 32zm64 352c0 17.7 14.3 32 32 32h32c53 0 96-43 96-96s-43-96-96-96H32c-17.7 0-32 14.3-32 32s14.3 32 32 32H416c17.7 0 32 14.3 32 32s-14.3 32-32 32H384c-17.7 0-32 14.3-32 32zM128 512h32c53 0 96-43 96-96s-43-96-96-96H32c-17.7 0-32 14.3-32 32s14.3 32 32 32H160c17.7 0 32 14.3 32 32s-14.3 32-32 32H128c-17.7 0-32 14.3-32 32s14.3 32 32 32z"
    ]
};
var $d8206b3ab2e65c05$export$6d2be7c5d395dd16 = {
    prefix: "fas",
    iconName: "car-burst",
    icon: [
        640,
        512,
        [
            "car-crash"
        ],
        "f5e1",
        "M176 8c-6.6 0-12.4 4-14.9 10.1l-29.4 74L55.6 68.9c-6.3-1.9-13.1 .2-17.2 5.3s-4.6 12.2-1.4 17.9l39.5 69.1L10.9 206.4c-5.4 3.7-8 10.3-6.5 16.7s6.7 11.2 13.1 12.2l78.7 12.2L90.6 327c-.5 6.5 3.1 12.7 9 15.5s12.9 1.8 17.8-2.6l35.3-32.5 9.5-35.4 10.4-38.6c8-29.9 30.5-52.1 57.9-60.9l41-59.2c11.3-16.3 26.4-28.9 43.5-37.2c-.4-.6-.8-1.2-1.3-1.8c-4.1-5.1-10.9-7.2-17.2-5.3L220.3 92.1l-29.4-74C188.4 12 182.6 8 176 8zM367.7 161.5l135.6 36.3c6.5 1.8 11.3 7.4 11.8 14.2l4.6 56.5-201.5-54 32.2-46.6c3.8-5.6 10.8-8.1 17.3-6.4zm-69.9-30l-47.9 69.3c-21.6 3-40.3 18.6-46.3 41l-10.4 38.6-16.6 61.8-8.3 30.9c-4.6 17.1 5.6 34.6 22.6 39.2l15.5 4.1c17.1 4.6 34.6-5.6 39.2-22.6l8.3-30.9 247.3 66.3-8.3 30.9c-4.6 17.1 5.6 34.6 22.6 39.2l15.5 4.1c17.1 4.6 34.6-5.6 39.2-22.6l8.3-30.9L595 388l10.4-38.6c6-22.4-2.5-45.2-19.6-58.7l-6.8-84c-2.7-33.7-26.4-62-59-70.8L384.2 99.7c-32.7-8.8-67.3 4-86.5 31.8zm-17 131a24 24 0 1 1 -12.4 46.4 24 24 0 1 1 12.4-46.4zm217.9 83.2A24 24 0 1 1 545 358.1a24 24 0 1 1 -46.4-12.4z"
    ]
};
var $d8206b3ab2e65c05$export$8ff55566398404cd = $d8206b3ab2e65c05$export$6d2be7c5d395dd16;
var $d8206b3ab2e65c05$export$b8c4c058fe7d193c = {
    prefix: "fas",
    iconName: "y",
    icon: [
        384,
        512,
        [
            121
        ],
        "59",
        "M58 45.4C47.8 31 27.8 27.7 13.4 38S-4.3 68.2 6 82.6L160 298.3V448c0 17.7 14.3 32 32 32s32-14.3 32-32V298.3L378 82.6c10.3-14.4 6.9-34.4-7.4-44.6S336.2 31 326 45.4L192 232.9 58 45.4z"
    ]
};
var $d8206b3ab2e65c05$export$22c642403aeeaeaf = {
    prefix: "fas",
    iconName: "person-snowboarding",
    icon: [
        512,
        512,
        [
            127938,
            "snowboarding"
        ],
        "f7ce",
        "M209.7 3.4c15.8-7.9 35-1.5 42.9 14.3l25 50 42.4 8.5c19.5 3.9 37.8 12.3 53.5 24.5l126.1 98.1c14 10.9 16.5 31 5.6 44.9s-31 16.5-44.9 5.6l-72.1-56.1-71.5 31.8 33.1 27.6c23.2 19.3 33.5 50 26.7 79.4l-17.4 75.2c-2.2 9.4-8.2 16.8-16.1 21l86.5 33.1c4.6 1.8 9.4 2.6 14.3 2.6H472c13.3 0 24 10.7 24 24s-10.7 24-24 24H443.8c-10.8 0-21.4-2-31.5-5.8L60.1 371.3c-11.5-4.4-22-11.2-30.8-20L7 329c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l22.4 22.4c4 4 8.7 7.1 14 9.1l22.4 8.6c-.8-1.6-1.5-3.2-2.1-4.9c-5.6-16.8 3.5-34.9 20.2-40.5L192 264.9l0-53.2c0-24.2 13.7-46.4 35.4-57.2l45.2-22.6-7.5-1.5c-19.4-3.9-35.9-16.5-44.7-34.1l-25-50c-7.9-15.8-1.5-35 14.3-42.9zM139 350.1l159 60.9c-2.1-5.6-2.6-11.9-1.1-18.2l17.4-75.2c1.4-5.9-.7-12-5.3-15.9l-52.8-44 0 18.8c0 20.7-13.2 39-32.8 45.5L139 350.1zM432 0a48 48 0 1 1 0 96 48 48 0 1 1 0-96z"
    ]
};
var $d8206b3ab2e65c05$export$72683772d587302a = $d8206b3ab2e65c05$export$22c642403aeeaeaf;
var $d8206b3ab2e65c05$export$27de16299ddd171 = {
    prefix: "fas",
    iconName: "truck-fast",
    icon: [
        640,
        512,
        [
            "shipping-fast"
        ],
        "f48b",
        "M112 0C85.5 0 64 21.5 64 48V96H16c-8.8 0-16 7.2-16 16s7.2 16 16 16H64 272c8.8 0 16 7.2 16 16s-7.2 16-16 16H64 48c-8.8 0-16 7.2-16 16s7.2 16 16 16H64 240c8.8 0 16 7.2 16 16s-7.2 16-16 16H64 16c-8.8 0-16 7.2-16 16s7.2 16 16 16H64 208c8.8 0 16 7.2 16 16s-7.2 16-16 16H64V416c0 53 43 96 96 96s96-43 96-96H384c0 53 43 96 96 96s96-43 96-96h32c17.7 0 32-14.3 32-32s-14.3-32-32-32V288 256 237.3c0-17-6.7-33.3-18.7-45.3L512 114.7c-12-12-28.3-18.7-45.3-18.7H416V48c0-26.5-21.5-48-48-48H112zM544 237.3V256H416V160h50.7L544 237.3zM160 368a48 48 0 1 1 0 96 48 48 0 1 1 0-96zm272 48a48 48 0 1 1 96 0 48 48 0 1 1 -96 0z"
    ]
};
var $d8206b3ab2e65c05$export$5e419f47aaeb3c05 = $d8206b3ab2e65c05$export$27de16299ddd171;
var $d8206b3ab2e65c05$export$24228a855c5f6812 = {
    prefix: "fas",
    iconName: "fish",
    icon: [
        576,
        512,
        [
            128031
        ],
        "f578",
        "M180.5 141.5C219.7 108.5 272.6 80 336 80s116.3 28.5 155.5 61.5c39.1 33 66.9 72.4 81 99.8c4.7 9.2 4.7 20.1 0 29.3c-14.1 27.4-41.9 66.8-81 99.8C452.3 403.5 399.4 432 336 432s-116.3-28.5-155.5-61.5c-16.2-13.7-30.5-28.5-42.7-43.1L48.1 379.6c-12.5 7.3-28.4 5.3-38.7-4.9S-3 348.7 4.2 336.1L50 256 4.2 175.9c-7.2-12.6-5-28.4 5.3-38.6s26.1-12.2 38.7-4.9l89.7 52.3c12.2-14.6 26.5-29.4 42.7-43.1zM448 256a32 32 0 1 0 -64 0 32 32 0 1 0 64 0z"
    ]
};
var $d8206b3ab2e65c05$export$10f5839059d22f7e = {
    prefix: "fas",
    iconName: "user-graduate",
    icon: [
        448,
        512,
        [],
        "f501",
        "M219.3 .5c3.1-.6 6.3-.6 9.4 0l200 40C439.9 42.7 448 52.6 448 64s-8.1 21.3-19.3 23.5L352 102.9V160c0 70.7-57.3 128-128 128s-128-57.3-128-128V102.9L48 93.3v65.1l15.7 78.4c.9 4.7-.3 9.6-3.3 13.3s-7.6 5.9-12.4 5.9H16c-4.8 0-9.3-2.1-12.4-5.9s-4.3-8.6-3.3-13.3L16 158.4V86.6C6.5 83.3 0 74.3 0 64C0 52.6 8.1 42.7 19.3 40.5l200-40zM111.9 327.7c10.5-3.4 21.8 .4 29.4 8.5l71 75.5c6.3 6.7 17 6.7 23.3 0l71-75.5c7.6-8.1 18.9-11.9 29.4-8.5C401 348.6 448 409.4 448 481.3c0 17-13.8 30.7-30.7 30.7H30.7C13.8 512 0 498.2 0 481.3c0-71.9 47-132.7 111.9-153.6z"
    ]
};
var $d8206b3ab2e65c05$export$625fb3848216f28c = {
    prefix: "fas",
    iconName: "circle-half-stroke",
    icon: [
        512,
        512,
        [
            9680,
            "adjust"
        ],
        "f042",
        "M448 256c0-106-86-192-192-192V448c106 0 192-86 192-192zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256z"
    ]
};
var $d8206b3ab2e65c05$export$cfa06e4b68edca2d = $d8206b3ab2e65c05$export$625fb3848216f28c;
var $d8206b3ab2e65c05$export$add3b381ced12554 = {
    prefix: "fas",
    iconName: "clapperboard",
    icon: [
        512,
        512,
        [],
        "e131",
        "M448 32H361.9l-1 1-127 127h92.1l1-1L453.8 32.3c-1.9-.2-3.8-.3-5.8-.3zm64 128V96c0-15.1-5.3-29.1-14-40l-104 104H512zM294.1 32H201.9l-1 1L73.9 160h92.1l1-1 127-127zM64 32C28.7 32 0 60.7 0 96v64H6.1l1-1 127-127H64zM512 192H0V416c0 35.3 28.7 64 64 64H448c35.3 0 64-28.7 64-64V192z"
    ]
};
var $d8206b3ab2e65c05$export$55c8e3afd9f6c0b4 = {
    prefix: "fas",
    iconName: "circle-radiation",
    icon: [
        512,
        512,
        [
            9762,
            "radiation-alt"
        ],
        "f7ba",
        "M256 64a192 192 0 1 1 0 384 192 192 0 1 1 0-384zm0 448A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM200 256c0-20.7 11.3-38.8 28-48.5l-36-62.3c-8.8-15.3-28.7-20.8-42-9c-25.6 22.6-43.9 53.3-50.9 88.1C95.7 241.5 110.3 256 128 256l72 0zm28 48.5l-36 62.4c-8.8 15.3-3.6 35.2 13.1 40.8c16 5.4 33.1 8.3 50.9 8.3s34.9-2.9 50.9-8.3c16.7-5.6 21.9-25.5 13.1-40.8l-36-62.4c-8.2 4.8-17.8 7.5-28 7.5s-19.8-2.7-28-7.5zM312 256l72 0c17.7 0 32.3-14.5 28.8-31.8c-7-34.8-25.3-65.5-50.9-88.1c-13.2-11.7-33.1-6.3-42 9l-36 62.3c16.7 9.7 28 27.8 28 48.5zm-56 32a32 32 0 1 0 0-64 32 32 0 1 0 0 64z"
    ]
};
var $d8206b3ab2e65c05$export$2f048fa82bbddf6f = $d8206b3ab2e65c05$export$55c8e3afd9f6c0b4;
var $d8206b3ab2e65c05$export$dc3654cf8a596fbf = {
    prefix: "fas",
    iconName: "baseball",
    icon: [
        512,
        512,
        [
            129358,
            9918,
            "baseball-ball"
        ],
        "f433",
        "M62.7 223.4c-4.8 .4-9.7 .6-14.7 .6c-15.6 0-30.8-2-45.2-5.9C19.2 107.1 107.1 19.2 218.1 2.8C222 17.2 224 32.4 224 48c0 4.9-.2 9.8-.6 14.7c-.7 8.8 5.8 16.5 14.6 17.3s16.5-5.8 17.3-14.6c.5-5.7 .7-11.5 .7-17.3c0-16.5-1.9-32.6-5.6-47.9c1.8 0 3.7-.1 5.6-.1C397.4 0 512 114.6 512 256c0 1.9 0 3.7-.1 5.6c-15.4-3.6-31.4-5.6-47.9-5.6c-5.8 0-11.6 .2-17.3 .7c-8.8 .7-15.4 8.5-14.6 17.3s8.5 15.4 17.3 14.6c4.8-.4 9.7-.6 14.7-.6c15.6 0 30.8 2 45.2 5.9C492.8 404.9 404.9 492.8 293.9 509.2C290 494.8 288 479.6 288 464c0-4.9 .2-9.8 .6-14.7c.7-8.8-5.8-16.5-14.6-17.3s-16.5 5.8-17.3 14.6c-.5 5.7-.7 11.5-.7 17.3c0 16.5 1.9 32.6 5.6 47.9c-1.8 0-3.7 .1-5.6 .1C114.6 512 0 397.4 0 256c0-1.9 0-3.7 .1-5.6C15.4 254.1 31.5 256 48 256c5.8 0 11.6-.2 17.3-.7c8.8-.7 15.4-8.5 14.6-17.3s-8.5-15.4-17.3-14.6zM121.3 208c-8 3.7-11.6 13.2-7.9 21.2s13.2 11.6 21.2 7.9c45.2-20.8 81.7-57.2 102.5-102.5c3.7-8 .2-17.5-7.9-21.2s-17.5-.2-21.2 7.9c-17.6 38.3-48.5 69.2-86.7 86.7zm277.2 74.7c-3.7-8-13.2-11.6-21.2-7.9c-45.2 20.8-81.7 57.2-102.5 102.5c-3.7 8-.2 17.5 7.9 21.2s17.5 .2 21.2-7.9c17.6-38.3 48.5-69.2 86.7-86.7c8-3.7 11.6-13.2 7.9-21.2z"
    ]
};
var $d8206b3ab2e65c05$export$63a3f8ceae07c7f3 = $d8206b3ab2e65c05$export$dc3654cf8a596fbf;
var $d8206b3ab2e65c05$export$b024a52a4ccf5e69 = {
    prefix: "fas",
    iconName: "jet-fighter-up",
    icon: [
        512,
        512,
        [],
        "e518",
        "M270.7 9.7C268.2 3.8 262.4 0 256 0s-12.2 3.8-14.7 9.7L197.2 112.6c-3.4 8-5.2 16.5-5.2 25.2v77l-144 84V280c0-13.3-10.7-24-24-24s-24 10.7-24 24v56 32 24c0 13.3 10.7 24 24 24s24-10.7 24-24v-8H192v32.7L133.5 468c-3.5 3-5.5 7.4-5.5 12v16c0 8.8 7.2 16 16 16h96V448c0-8.8 7.2-16 16-16s16 7.2 16 16v64h96c8.8 0 16-7.2 16-16V480c0-4.6-2-9-5.5-12L320 416.7V384H464v8c0 13.3 10.7 24 24 24s24-10.7 24-24V368 336 280c0-13.3-10.7-24-24-24s-24 10.7-24 24v18.8l-144-84v-77c0-8.7-1.8-17.2-5.2-25.2L270.7 9.7z"
    ]
};
var $d8206b3ab2e65c05$export$59c351869dc27435 = {
    prefix: "fas",
    iconName: "diagram-project",
    icon: [
        576,
        512,
        [
            "project-diagram"
        ],
        "f542",
        "M0 80C0 53.5 21.5 32 48 32h96c26.5 0 48 21.5 48 48V96H384V80c0-26.5 21.5-48 48-48h96c26.5 0 48 21.5 48 48v96c0 26.5-21.5 48-48 48H432c-26.5 0-48-21.5-48-48V160H192v16c0 1.7-.1 3.4-.3 5L272 288h96c26.5 0 48 21.5 48 48v96c0 26.5-21.5 48-48 48H272c-26.5 0-48-21.5-48-48V336c0-1.7 .1-3.4 .3-5L144 224H48c-26.5 0-48-21.5-48-48V80z"
    ]
};
var $d8206b3ab2e65c05$export$30bf9f5b96509df1 = $d8206b3ab2e65c05$export$59c351869dc27435;
var $d8206b3ab2e65c05$export$e9bd786d30cb716c = {
    prefix: "fas",
    iconName: "copy",
    icon: [
        448,
        512,
        [],
        "f0c5",
        "M208 0H332.1c12.7 0 24.9 5.1 33.9 14.1l67.9 67.9c9 9 14.1 21.2 14.1 33.9V336c0 26.5-21.5 48-48 48H208c-26.5 0-48-21.5-48-48V48c0-26.5 21.5-48 48-48zM48 128h80v64H64V448H256V416h64v48c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V176c0-26.5 21.5-48 48-48z"
    ]
};
var $d8206b3ab2e65c05$export$28cc565c11db6f2e = {
    prefix: "fas",
    iconName: "volume-xmark",
    icon: [
        576,
        512,
        [
            "volume-mute",
            "volume-times"
        ],
        "f6a9",
        "M301.1 34.8C312.6 40 320 51.4 320 64V448c0 12.6-7.4 24-18.9 29.2s-25 3.1-34.4-5.3L131.8 352H64c-35.3 0-64-28.7-64-64V224c0-35.3 28.7-64 64-64h67.8L266.7 40.1c9.4-8.4 22.9-10.4 34.4-5.3zM425 167l55 55 55-55c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9l-55 55 55 55c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0l-55-55-55 55c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l55-55-55-55c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0z"
    ]
};
var $d8206b3ab2e65c05$export$aa8decd057dfd29b = $d8206b3ab2e65c05$export$28cc565c11db6f2e;
var $d8206b3ab2e65c05$export$a1c7b36ba71dbeca = $d8206b3ab2e65c05$export$28cc565c11db6f2e;
var $d8206b3ab2e65c05$export$72e2d874a963de0c = {
    prefix: "fas",
    iconName: "hand-sparkles",
    icon: [
        640,
        512,
        [],
        "e05d",
        "M320 0c17.7 0 32 14.3 32 32V240c0 8.8 7.2 16 16 16s16-7.2 16-16V64c0-17.7 14.3-32 32-32s32 14.3 32 32V240c0 8.8 7.2 16 16 16s16-7.2 16-16V128c0-17.7 14.3-32 32-32s32 14.3 32 32V323.1c-11.9 4.8-21.3 14.9-25 27.8l-8.9 31.2L478.9 391C460.6 396.3 448 413 448 432c0 18.9 12.5 35.6 30.6 40.9C448.4 497.4 409.9 512 368 512H348.8c-59.6 0-116.9-22.9-160-64L76.4 341c-16-15.2-16.6-40.6-1.4-56.6s40.6-16.6 56.6-1.4l60.5 57.6c0-1.5-.1-3.1-.1-4.6V64c0-17.7 14.3-32 32-32s32 14.3 32 32V240c0 8.8 7.2 16 16 16s16-7.2 16-16V32c0-17.7 14.3-32 32-32zm-7.3 326.6c-1.1-3.9-4.7-6.6-8.7-6.6s-7.6 2.7-8.7 6.6L288 352l-25.4 7.3c-3.9 1.1-6.6 4.7-6.6 8.7s2.7 7.6 6.6 8.7L288 384l7.3 25.4c1.1 3.9 4.7 6.6 8.7 6.6s7.6-2.7 8.7-6.6L320 384l25.4-7.3c3.9-1.1 6.6-4.7 6.6-8.7s-2.7-7.6-6.6-8.7L320 352l-7.3-25.4zM104 120l48.3 13.8c4.6 1.3 7.7 5.5 7.7 10.2s-3.1 8.9-7.7 10.2L104 168 90.2 216.3c-1.3 4.6-5.5 7.7-10.2 7.7s-8.9-3.1-10.2-7.7L56 168 7.7 154.2C3.1 152.9 0 148.7 0 144s3.1-8.9 7.7-10.2L56 120 69.8 71.7C71.1 67.1 75.3 64 80 64s8.9 3.1 10.2 7.7L104 120zM584 408l48.3 13.8c4.6 1.3 7.7 5.5 7.7 10.2s-3.1 8.9-7.7 10.2L584 456l-13.8 48.3c-1.3 4.6-5.5 7.7-10.2 7.7s-8.9-3.1-10.2-7.7L536 456l-48.3-13.8c-4.6-1.3-7.7-5.5-7.7-10.2s3.1-8.9 7.7-10.2L536 408l13.8-48.3c1.3-4.6 5.5-7.7 10.2-7.7s8.9 3.1 10.2 7.7L584 408z"
    ]
};
var $d8206b3ab2e65c05$export$eb83fb404127db75 = {
    prefix: "fas",
    iconName: "grip",
    icon: [
        448,
        512,
        [
            "grip-horizontal"
        ],
        "f58d",
        "M128 136c0-22.1-17.9-40-40-40L40 96C17.9 96 0 113.9 0 136l0 48c0 22.1 17.9 40 40 40H88c22.1 0 40-17.9 40-40l0-48zm0 192c0-22.1-17.9-40-40-40H40c-22.1 0-40 17.9-40 40l0 48c0 22.1 17.9 40 40 40H88c22.1 0 40-17.9 40-40V328zm32-192v48c0 22.1 17.9 40 40 40h48c22.1 0 40-17.9 40-40V136c0-22.1-17.9-40-40-40l-48 0c-22.1 0-40 17.9-40 40zM288 328c0-22.1-17.9-40-40-40H200c-22.1 0-40 17.9-40 40l0 48c0 22.1 17.9 40 40 40h48c22.1 0 40-17.9 40-40V328zm32-192v48c0 22.1 17.9 40 40 40h48c22.1 0 40-17.9 40-40V136c0-22.1-17.9-40-40-40l-48 0c-22.1 0-40 17.9-40 40zM448 328c0-22.1-17.9-40-40-40H360c-22.1 0-40 17.9-40 40v48c0 22.1 17.9 40 40 40h48c22.1 0 40-17.9 40-40V328z"
    ]
};
var $d8206b3ab2e65c05$export$4a45308d6c8decc1 = $d8206b3ab2e65c05$export$eb83fb404127db75;
var $d8206b3ab2e65c05$export$928280bdd54fa173 = {
    prefix: "fas",
    iconName: "share-from-square",
    icon: [
        576,
        512,
        [
            61509,
            "share-square"
        ],
        "f14d",
        "M352 224H305.5c-45 0-81.5 36.5-81.5 81.5c0 22.3 10.3 34.3 19.2 40.5c6.8 4.7 12.8 12 12.8 20.3c0 9.8-8 17.8-17.8 17.8h-2.5c-2.4 0-4.8-.4-7.1-1.4C210.8 374.8 128 333.4 128 240c0-79.5 64.5-144 144-144h80V34.7C352 15.5 367.5 0 386.7 0c8.6 0 16.8 3.2 23.2 8.9L548.1 133.3c7.6 6.8 11.9 16.5 11.9 26.7s-4.3 19.9-11.9 26.7l-139 125.1c-5.9 5.3-13.5 8.2-21.4 8.2H384c-17.7 0-32-14.3-32-32V224zM80 96c-8.8 0-16 7.2-16 16V432c0 8.8 7.2 16 16 16H400c8.8 0 16-7.2 16-16V384c0-17.7 14.3-32 32-32s32 14.3 32 32v48c0 44.2-35.8 80-80 80H80c-44.2 0-80-35.8-80-80V112C0 67.8 35.8 32 80 32h48c17.7 0 32 14.3 32 32s-14.3 32-32 32H80z"
    ]
};
var $d8206b3ab2e65c05$export$ae9e1434571f373c = $d8206b3ab2e65c05$export$928280bdd54fa173;
var $d8206b3ab2e65c05$export$f7367a7301f2dc0f = {
    prefix: "fas",
    iconName: "child-combatant",
    icon: [
        576,
        512,
        [
            "child-rifle"
        ],
        "e4e0",
        "M176 128A64 64 0 1 0 176 0a64 64 0 1 0 0 128zm-8 352V352h16V480c0 17.7 14.3 32 32 32s32-14.3 32-32V300.5L260.9 321c9.4 15 29.2 19.4 44.1 10s19.4-29.2 10-44.1l-51.7-82.1c-17.6-27.9-48.3-44.9-81.2-44.9H169.8c-33 0-63.7 16.9-81.2 44.9L36.9 287c-9.4 15-4.9 34.7 10 44.1s34.7 4.9 44.1-10L104 300.5V480c0 17.7 14.3 32 32 32s32-14.3 32-32zM448 0H432 416c-8.8 0-16 7.2-16 16s7.2 16 16 16V132.3c-9.6 5.5-16 15.9-16 27.7v32c-17.7 0-32 14.3-32 32V368c0 17.7 14.3 32 32 32h16v96c0 8.8 7.2 16 16 16h59.5c10.4 0 18-9.8 15.5-19.9L484 400h44c8.8 0 16-7.2 16-16V368c0-8.8-7.2-16-16-16H480V325.3l53.1-17.7c6.5-2.2 10.9-8.3 10.9-15.2V208c0-8.8-7.2-16-16-16H512c-8.8 0-16 7.2-16 16v56l-16 5.3V160c0-11.8-6.4-22.2-16-27.7V16c0-8.8-7.2-16-16-16z"
    ]
};
var $d8206b3ab2e65c05$export$9b027cdb5db3ae5c = $d8206b3ab2e65c05$export$f7367a7301f2dc0f;
var $d8206b3ab2e65c05$export$e18f576a7b31ba46 = {
    prefix: "fas",
    iconName: "gun",
    icon: [
        576,
        512,
        [],
        "e19b",
        "M528 56c0-13.3-10.7-24-24-24s-24 10.7-24 24v8H32C14.3 64 0 78.3 0 96V208c0 17.7 14.3 32 32 32H42c20.8 0 36.1 19.6 31 39.8L33 440.2c-2.4 9.6-.2 19.7 5.8 27.5S54.1 480 64 480h96c14.7 0 27.5-10 31-24.2L217 352H321.4c23.7 0 44.8-14.9 52.7-37.2L400.9 240H432c8.5 0 16.6-3.4 22.6-9.4L477.3 208H544c17.7 0 32-14.3 32-32V96c0-17.7-14.3-32-32-32H528V56zM321.4 304H229l16-64h105l-21 58.7c-1.1 3.2-4.2 5.3-7.5 5.3zM80 128H464c8.8 0 16 7.2 16 16s-7.2 16-16 16H80c-8.8 0-16-7.2-16-16s7.2-16 16-16z"
    ]
};
var $d8206b3ab2e65c05$export$318ed022991eef56 = {
    prefix: "fas",
    iconName: "square-phone",
    icon: [
        448,
        512,
        [
            "phone-square"
        ],
        "f098",
        "M64 32C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64zm90.7 96.7c9.7-2.6 19.9 2.3 23.7 11.6l20 48c3.4 8.2 1 17.6-5.8 23.2L168 231.7c16.6 35.2 45.1 63.7 80.3 80.3l20.2-24.7c5.6-6.8 15-9.2 23.2-5.8l48 20c9.3 3.9 14.2 14 11.6 23.7l-12 44C336.9 378 329 384 320 384C196.3 384 96 283.7 96 160c0-9 6-16.9 14.7-19.3l44-12z"
    ]
};
var $d8206b3ab2e65c05$export$8ba22605a641ebdf = $d8206b3ab2e65c05$export$318ed022991eef56;
var $d8206b3ab2e65c05$export$a105e7b44ca0eb9e = {
    prefix: "fas",
    iconName: "plus",
    icon: [
        448,
        512,
        [
            10133,
            61543,
            "add"
        ],
        "2b",
        "M256 80c0-17.7-14.3-32-32-32s-32 14.3-32 32V224H48c-17.7 0-32 14.3-32 32s14.3 32 32 32H192V432c0 17.7 14.3 32 32 32s32-14.3 32-32V288H400c17.7 0 32-14.3 32-32s-14.3-32-32-32H256V80z"
    ]
};
var $d8206b3ab2e65c05$export$9e8f9a9d4ad32c0f = $d8206b3ab2e65c05$export$a105e7b44ca0eb9e;
var $d8206b3ab2e65c05$export$1fe4a9976a241685 = {
    prefix: "fas",
    iconName: "expand",
    icon: [
        448,
        512,
        [],
        "f065",
        "M32 32C14.3 32 0 46.3 0 64v96c0 17.7 14.3 32 32 32s32-14.3 32-32V96h64c17.7 0 32-14.3 32-32s-14.3-32-32-32H32zM64 352c0-17.7-14.3-32-32-32s-32 14.3-32 32v96c0 17.7 14.3 32 32 32h96c17.7 0 32-14.3 32-32s-14.3-32-32-32H64V352zM320 32c-17.7 0-32 14.3-32 32s14.3 32 32 32h64v64c0 17.7 14.3 32 32 32s32-14.3 32-32V64c0-17.7-14.3-32-32-32H320zM448 352c0-17.7-14.3-32-32-32s-32 14.3-32 32v64H320c-17.7 0-32 14.3-32 32s14.3 32 32 32h96c17.7 0 32-14.3 32-32V352z"
    ]
};
var $d8206b3ab2e65c05$export$9835883ce9d0fe78 = {
    prefix: "fas",
    iconName: "computer",
    icon: [
        640,
        512,
        [],
        "e4e5",
        "M384 96V320H64L64 96H384zM64 32C28.7 32 0 60.7 0 96V320c0 35.3 28.7 64 64 64H181.3l-10.7 32H96c-17.7 0-32 14.3-32 32s14.3 32 32 32H352c17.7 0 32-14.3 32-32s-14.3-32-32-32H277.3l-10.7-32H384c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64zm464 0c-26.5 0-48 21.5-48 48V432c0 26.5 21.5 48 48 48h64c26.5 0 48-21.5 48-48V80c0-26.5-21.5-48-48-48H528zm16 64h32c8.8 0 16 7.2 16 16s-7.2 16-16 16H544c-8.8 0-16-7.2-16-16s7.2-16 16-16zm-16 80c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16s-7.2 16-16 16H544c-8.8 0-16-7.2-16-16zm32 160a32 32 0 1 1 0 64 32 32 0 1 1 0-64z"
    ]
};
var $d8206b3ab2e65c05$export$e6e44779b2fa1a5c = {
    prefix: "fas",
    iconName: "xmark",
    icon: [
        384,
        512,
        [
            128473,
            10005,
            10006,
            10060,
            215,
            "close",
            "multiply",
            "remove",
            "times"
        ],
        "f00d",
        "M342.6 150.6c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L192 210.7 86.6 105.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3L146.7 256 41.4 361.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0L192 301.3 297.4 406.6c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L237.3 256 342.6 150.6z"
    ]
};
var $d8206b3ab2e65c05$export$23c717133fd81476 = $d8206b3ab2e65c05$export$e6e44779b2fa1a5c;
var $d8206b3ab2e65c05$export$4ed4ff13d4dbc862 = $d8206b3ab2e65c05$export$e6e44779b2fa1a5c;
var $d8206b3ab2e65c05$export$34810740c1bd6c54 = $d8206b3ab2e65c05$export$e6e44779b2fa1a5c;
var $d8206b3ab2e65c05$export$174bd7f477b115b4 = $d8206b3ab2e65c05$export$e6e44779b2fa1a5c;
var $d8206b3ab2e65c05$export$ff9a43e3a9cb653c = {
    prefix: "fas",
    iconName: "arrows-up-down-left-right",
    icon: [
        512,
        512,
        [
            "arrows"
        ],
        "f047",
        "M278.6 9.4c-12.5-12.5-32.8-12.5-45.3 0l-64 64c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0l9.4-9.4V224H109.3l9.4-9.4c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0l-64 64c-12.5 12.5-12.5 32.8 0 45.3l64 64c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3l-9.4-9.4H224V402.7l-9.4-9.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3l64 64c12.5 12.5 32.8 12.5 45.3 0l64-64c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0l-9.4 9.4V288H402.7l-9.4 9.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0l64-64c12.5-12.5 12.5-32.8 0-45.3l-64-64c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3l9.4 9.4H288V109.3l9.4 9.4c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3l-64-64z"
    ]
};
var $d8206b3ab2e65c05$export$d5ae09a305d70340 = $d8206b3ab2e65c05$export$ff9a43e3a9cb653c;
var $d8206b3ab2e65c05$export$fd7622d4b8d3674b = {
    prefix: "fas",
    iconName: "chalkboard-user",
    icon: [
        640,
        512,
        [
            "chalkboard-teacher"
        ],
        "f51c",
        "M160 64c0-35.3 28.7-64 64-64H576c35.3 0 64 28.7 64 64V352c0 35.3-28.7 64-64 64H336.8c-11.8-25.5-29.9-47.5-52.4-64H384V320c0-17.7 14.3-32 32-32h64c17.7 0 32 14.3 32 32v32h64V64L224 64v49.1C205.2 102.2 183.3 96 160 96V64zm0 64a96 96 0 1 1 0 192 96 96 0 1 1 0-192zM133.3 352h53.3C260.3 352 320 411.7 320 485.3c0 14.7-11.9 26.7-26.7 26.7H26.7C11.9 512 0 500.1 0 485.3C0 411.7 59.7 352 133.3 352z"
    ]
};
var $d8206b3ab2e65c05$export$443fcf69b0155291 = $d8206b3ab2e65c05$export$fd7622d4b8d3674b;
var $d8206b3ab2e65c05$export$c8f99b9b5ea83555 = {
    prefix: "fas",
    iconName: "peso-sign",
    icon: [
        384,
        512,
        [],
        "e222",
        "M64 32C46.3 32 32 46.3 32 64v64c-17.7 0-32 14.3-32 32s14.3 32 32 32l0 32c-17.7 0-32 14.3-32 32s14.3 32 32 32l0 64v96c0 17.7 14.3 32 32 32s32-14.3 32-32V384h80c68.4 0 127.7-39 156.8-96H352c17.7 0 32-14.3 32-32s-14.3-32-32-32h-.7c.5-5.3 .7-10.6 .7-16s-.2-10.7-.7-16h.7c17.7 0 32-14.3 32-32s-14.3-32-32-32H332.8C303.7 71 244.4 32 176 32H64zm190.4 96H96V96h80c30.5 0 58.2 12.2 78.4 32zM96 192H286.9c.7 5.2 1.1 10.6 1.1 16s-.4 10.8-1.1 16H96V192zm158.4 96c-20.2 19.8-47.9 32-78.4 32H96V288H254.4z"
    ]
};
var $d8206b3ab2e65c05$export$18ba6a500873dba9 = {
    prefix: "fas",
    iconName: "building-shield",
    icon: [
        576,
        512,
        [],
        "e4d8",
        "M0 48C0 21.5 21.5 0 48 0H336c26.5 0 48 21.5 48 48V207l-42.4 17H304 272c-8.8 0-16 7.2-16 16v32 24.2V304c0 .9 .1 1.7 .2 2.6c2.3 58.1 24.1 144.8 98.7 201.5c-5.8 2.5-12.2 3.9-18.9 3.9H240V432c0-26.5-21.5-48-48-48s-48 21.5-48 48v80H48c-26.5 0-48-21.5-48-48V48zM80 224c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V240c0-8.8-7.2-16-16-16H80zm80 16v32c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V240c0-8.8-7.2-16-16-16H176c-8.8 0-16 7.2-16 16zM64 112v32c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V112c0-8.8-7.2-16-16-16H80c-8.8 0-16 7.2-16 16zM176 96c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V112c0-8.8-7.2-16-16-16H176zm80 16v32c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V112c0-8.8-7.2-16-16-16H272c-8.8 0-16 7.2-16 16zM423.1 225.7c5.7-2.3 12.1-2.3 17.8 0l120 48C570 277.4 576 286.2 576 296c0 63.3-25.9 168.8-134.8 214.2c-5.9 2.5-12.6 2.5-18.5 0C313.9 464.8 288 359.3 288 296c0-9.8 6-18.6 15.1-22.3l120-48zM527.4 312L432 273.8V461.7c68.2-33 91.5-99 95.4-149.7z"
    ]
};
var $d8206b3ab2e65c05$export$8afab767536f59ad = {
    prefix: "fas",
    iconName: "baby",
    icon: [
        448,
        512,
        [],
        "f77c",
        "M152 88a72 72 0 1 1 144 0A72 72 0 1 1 152 88zM39.7 144.5c13-17.9 38-21.8 55.9-8.8L131.8 162c26.8 19.5 59.1 30 92.2 30s65.4-10.5 92.2-30l36.2-26.4c17.9-13 42.9-9 55.9 8.8s9 42.9-8.8 55.9l-36.2 26.4c-13.6 9.9-28.1 18.2-43.3 25V288H128V251.7c-15.2-6.7-29.7-15.1-43.3-25L48.5 200.3c-17.9-13-21.8-38-8.8-55.9zm89.8 184.8l60.6 53-26 37.2 24.3 24.3c15.6 15.6 15.6 40.9 0 56.6s-40.9 15.6-56.6 0l-48-48C70 438.6 68.1 417 79.2 401.1l50.2-71.8zm128.5 53l60.6-53 50.2 71.8c11.1 15.9 9.2 37.5-4.5 51.2l-48 48c-15.6 15.6-40.9 15.6-56.6 0s-15.6-40.9 0-56.6L284 419.4l-26-37.2z"
    ]
};
var $d8206b3ab2e65c05$export$d7e538fddb81da68 = {
    prefix: "fas",
    iconName: "users-line",
    icon: [
        640,
        512,
        [],
        "e592",
        "M211.2 96a64 64 0 1 0 -128 0 64 64 0 1 0 128 0zM32 256c0 17.7 14.3 32 32 32h85.6c10.1-39.4 38.6-71.5 75.8-86.6c-9.7-6-21.2-9.4-33.4-9.4H96c-35.3 0-64 28.7-64 64zm461.6 32H576c17.7 0 32-14.3 32-32c0-35.3-28.7-64-64-64H448c-11.7 0-22.7 3.1-32.1 8.6c38.1 14.8 67.4 47.3 77.7 87.4zM391.2 226.4c-6.9-1.6-14.2-2.4-21.6-2.4h-96c-8.5 0-16.7 1.1-24.5 3.1c-30.8 8.1-55.6 31.1-66.1 60.9c-3.5 10-5.5 20.8-5.5 32c0 17.7 14.3 32 32 32h224c17.7 0 32-14.3 32-32c0-11.2-1.9-22-5.5-32c-10.8-30.7-36.8-54.2-68.9-61.6zM563.2 96a64 64 0 1 0 -128 0 64 64 0 1 0 128 0zM321.6 192a80 80 0 1 0 0-160 80 80 0 1 0 0 160zM32 416c-17.7 0-32 14.3-32 32s14.3 32 32 32H608c17.7 0 32-14.3 32-32s-14.3-32-32-32H32z"
    ]
};
var $d8206b3ab2e65c05$export$932a67a1b1a7a724 = {
    prefix: "fas",
    iconName: "quote-left",
    icon: [
        448,
        512,
        [
            8220,
            "quote-left-alt"
        ],
        "f10d",
        "M0 216C0 149.7 53.7 96 120 96h8c17.7 0 32 14.3 32 32s-14.3 32-32 32h-8c-30.9 0-56 25.1-56 56v8h64c35.3 0 64 28.7 64 64v64c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V320 288 216zm256 0c0-66.3 53.7-120 120-120h8c17.7 0 32 14.3 32 32s-14.3 32-32 32h-8c-30.9 0-56 25.1-56 56v8h64c35.3 0 64 28.7 64 64v64c0 35.3-28.7 64-64 64H320c-35.3 0-64-28.7-64-64V320 288 216z"
    ]
};
var $d8206b3ab2e65c05$export$95bb9ad3aa35c741 = $d8206b3ab2e65c05$export$932a67a1b1a7a724;
var $d8206b3ab2e65c05$export$e87e41787bbedc98 = {
    prefix: "fas",
    iconName: "tractor",
    icon: [
        640,
        512,
        [
            128668
        ],
        "f722",
        "M96 64c0-35.3 28.7-64 64-64H266.3c26.2 0 49.7 15.9 59.4 40.2L373.7 160H480V126.2c0-24.8 5.8-49.3 16.9-71.6l2.5-5c7.9-15.8 27.1-22.2 42.9-14.3s22.2 27.1 14.3 42.9l-2.5 5c-6.7 13.3-10.1 28-10.1 42.9V160h56c22.1 0 40 17.9 40 40v45.4c0 16.5-8.5 31.9-22.6 40.7l-43.3 27.1c-14.2-5.9-29.8-9.2-46.1-9.2c-39.3 0-74.1 18.9-96 48H352c0 17.7-14.3 32-32 32h-8.2c-1.7 4.8-3.7 9.5-5.8 14.1l5.8 5.8c12.5 12.5 12.5 32.8 0 45.3l-22.6 22.6c-12.5 12.5-32.8 12.5-45.3 0l-5.8-5.8c-4.6 2.2-9.3 4.1-14.1 5.8V480c0 17.7-14.3 32-32 32H160c-17.7 0-32-14.3-32-32v-8.2c-4.8-1.7-9.5-3.7-14.1-5.8l-5.8 5.8c-12.5 12.5-32.8 12.5-45.3 0L40.2 449.1c-12.5-12.5-12.5-32.8 0-45.3l5.8-5.8c-2.2-4.6-4.1-9.3-5.8-14.1H32c-17.7 0-32-14.3-32-32V320c0-17.7 14.3-32 32-32h8.2c1.7-4.8 3.7-9.5 5.8-14.1l-5.8-5.8c-12.5-12.5-12.5-32.8 0-45.3l22.6-22.6c9-9 21.9-11.5 33.1-7.6V192 160 64zm170.3 0H160v96h32H304.7L266.3 64zM176 256a80 80 0 1 0 0 160 80 80 0 1 0 0-160zM528 448a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm0 64c-48.6 0-88-39.4-88-88c0-29.8 14.8-56.1 37.4-72c14.3-10.1 31.8-16 50.6-16c2.7 0 5.3 .1 7.9 .3c44.9 4 80.1 41.7 80.1 87.7c0 48.6-39.4 88-88 88z"
    ]
};
var $d8206b3ab2e65c05$export$940cea0f5451895c = {
    prefix: "fas",
    iconName: "trash-arrow-up",
    icon: [
        448,
        512,
        [
            "trash-restore"
        ],
        "f829",
        "M163.8 0H284.2c12.1 0 23.2 6.8 28.6 17.7L320 32h96c17.7 0 32 14.3 32 32s-14.3 32-32 32H32C14.3 96 0 81.7 0 64S14.3 32 32 32h96l7.2-14.3C140.6 6.8 151.7 0 163.8 0zM32 128H416L394.8 467c-1.6 25.3-22.6 45-47.9 45H101.1c-25.3 0-46.3-19.7-47.9-45L32 128zm192 64c-6.4 0-12.5 2.5-17 7l-80 80c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l39-39V408c0 13.3 10.7 24 24 24s24-10.7 24-24V273.9l39 39c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9l-80-80c-4.5-4.5-10.6-7-17-7z"
    ]
};
var $d8206b3ab2e65c05$export$d32f45a64ed40e8d = $d8206b3ab2e65c05$export$940cea0f5451895c;
var $d8206b3ab2e65c05$export$fc9f7bd981c34c45 = {
    prefix: "fas",
    iconName: "arrow-down-up-lock",
    icon: [
        640,
        512,
        [],
        "e4b0",
        "M150.6 502.6l96-96c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L160 402.7V288H416V272c0-17.2 3.9-33.5 10.8-48H352V109.3l41.4 41.4c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3l-96-96c-6-6-14.1-9.4-22.6-9.4s-16.6 3.4-22.6 9.4l-96 96c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0L288 109.3V224l-128 0H96l-64 0c-17.7 0-32 14.3-32 32s14.3 32 32 32H96V402.7L54.6 361.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3l96 96c12.5 12.5 32.8 12.5 45.3 0zM160 192V64c0-17.7-14.3-32-32-32s-32 14.3-32 32V192h64zM288 320V448c0 17.7 14.3 32 32 32s32-14.3 32-32V320H288zm240-80c17.7 0 32 14.3 32 32v48H496V272c0-17.7 14.3-32 32-32zm-80 32v48c-17.7 0-32 14.3-32 32V480c0 17.7 14.3 32 32 32H608c17.7 0 32-14.3 32-32V352c0-17.7-14.3-32-32-32V272c0-44.2-35.8-80-80-80s-80 35.8-80 80z"
    ]
};
var $d8206b3ab2e65c05$export$4d384ffc907ddaff = {
    prefix: "fas",
    iconName: "lines-leaning",
    icon: [
        384,
        512,
        [],
        "e51e",
        "M190.4 74.1c5.6-16.8-3.5-34.9-20.2-40.5s-34.9 3.5-40.5 20.2l-128 384c-5.6 16.8 3.5 34.9 20.2 40.5s34.9-3.5 40.5-20.2l128-384zm70.9-41.7c-17.4-2.9-33.9 8.9-36.8 26.3l-64 384c-2.9 17.4 8.9 33.9 26.3 36.8s33.9-8.9 36.8-26.3l64-384c2.9-17.4-8.9-33.9-26.3-36.8zM352 32c-17.7 0-32 14.3-32 32V448c0 17.7 14.3 32 32 32s32-14.3 32-32V64c0-17.7-14.3-32-32-32z"
    ]
};
var $d8206b3ab2e65c05$export$613f406c1b5802a8 = {
    prefix: "fas",
    iconName: "ruler-combined",
    icon: [
        512,
        512,
        [],
        "f546",
        "M.2 468.9C2.7 493.1 23.1 512 48 512l96 0 320 0c26.5 0 48-21.5 48-48l0-96c0-26.5-21.5-48-48-48l-48 0 0 80c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-80-64 0 0 80c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-80-64 0 0 80c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-80-80 0c-8.8 0-16-7.2-16-16s7.2-16 16-16l80 0 0-64-80 0c-8.8 0-16-7.2-16-16s7.2-16 16-16l80 0 0-64-80 0c-8.8 0-16-7.2-16-16s7.2-16 16-16l80 0 0-48c0-26.5-21.5-48-48-48L48 0C21.5 0 0 21.5 0 48L0 368l0 96c0 1.7 .1 3.3 .2 4.9z"
    ]
};
var $d8206b3ab2e65c05$export$da61665fff8aebfe = {
    prefix: "fas",
    iconName: "copyright",
    icon: [
        512,
        512,
        [
            169
        ],
        "f1f9",
        "M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM199.4 312.6c31.2 31.2 81.9 31.2 113.1 0c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9c-50 50-131 50-181 0s-50-131 0-181s131-50 181 0c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0c-31.2-31.2-81.9-31.2-113.1 0s-31.2 81.9 0 113.1z"
    ]
};
var $d8206b3ab2e65c05$export$a7c5f5e4805fdab = {
    prefix: "fas",
    iconName: "equals",
    icon: [
        448,
        512,
        [
            62764
        ],
        "3d",
        "M48 128c-17.7 0-32 14.3-32 32s14.3 32 32 32H400c17.7 0 32-14.3 32-32s-14.3-32-32-32H48zm0 192c-17.7 0-32 14.3-32 32s14.3 32 32 32H400c17.7 0 32-14.3 32-32s-14.3-32-32-32H48z"
    ]
};
var $d8206b3ab2e65c05$export$db34f7a6de38784f = {
    prefix: "fas",
    iconName: "blender",
    icon: [
        512,
        512,
        [],
        "f517",
        "M0 64C0 28.7 28.7 0 64 0h64 32H470.1c21.1 0 36.4 20.1 30.9 40.4L494.5 64H336c-8.8 0-16 7.2-16 16s7.2 16 16 16H485.8l-17.5 64H336c-8.8 0-16 7.2-16 16s7.2 16 16 16H459.6l-17.5 64H336c-8.8 0-16 7.2-16 16s7.2 16 16 16h97.5L416 352H160l-8.7-96H64c-35.3 0-64-28.7-64-64V64zM145.5 192L133.8 64H64V192h81.5zM144 384H432c26.5 0 48 21.5 48 48v32c0 26.5-21.5 48-48 48H144c-26.5 0-48-21.5-48-48V432c0-26.5 21.5-48 48-48zm144 96a32 32 0 1 0 0-64 32 32 0 1 0 0 64z"
    ]
};
var $d8206b3ab2e65c05$export$b4619aeaf0b9d18e = {
    prefix: "fas",
    iconName: "teeth",
    icon: [
        576,
        512,
        [],
        "f62e",
        "M0 128C0 75 43 32 96 32H480c53 0 96 43 96 96V384c0 53-43 96-96 96H96c-53 0-96-43-96-96V128zm176 48v56c0 13.3 10.7 24 24 24h48c13.3 0 24-10.7 24-24V176c0-26.5-21.5-48-48-48s-48 21.5-48 48zm176-48c-26.5 0-48 21.5-48 48v56c0 13.3 10.7 24 24 24h48c13.3 0 24-10.7 24-24V176c0-26.5-21.5-48-48-48zM48 208v24c0 13.3 10.7 24 24 24h48c13.3 0 24-10.7 24-24V208c0-26.5-21.5-48-48-48s-48 21.5-48 48zM96 384c26.5 0 48-21.5 48-48V312c0-13.3-10.7-24-24-24H72c-13.3 0-24 10.7-24 24v24c0 26.5 21.5 48 48 48zm80-48c0 26.5 21.5 48 48 48s48-21.5 48-48V312c0-13.3-10.7-24-24-24H200c-13.3 0-24 10.7-24 24v24zm176 48c26.5 0 48-21.5 48-48V312c0-13.3-10.7-24-24-24H328c-13.3 0-24 10.7-24 24v24c0 26.5 21.5 48 48 48zm80-176v24c0 13.3 10.7 24 24 24h48c13.3 0 24-10.7 24-24V208c0-26.5-21.5-48-48-48s-48 21.5-48 48zm48 176c26.5 0 48-21.5 48-48V312c0-13.3-10.7-24-24-24H456c-13.3 0-24 10.7-24 24v24c0 26.5 21.5 48 48 48z"
    ]
};
var $d8206b3ab2e65c05$export$3570be7b68efb8db = {
    prefix: "fas",
    iconName: "shekel-sign",
    icon: [
        448,
        512,
        [
            8362,
            "ils",
            "shekel",
            "sheqel",
            "sheqel-sign"
        ],
        "f20b",
        "M32 32C14.3 32 0 46.3 0 64V448c0 17.7 14.3 32 32 32s32-14.3 32-32V96H192c35.3 0 64 28.7 64 64V320c0 17.7 14.3 32 32 32s32-14.3 32-32V160c0-70.7-57.3-128-128-128H32zM320 480c70.7 0 128-57.3 128-128V64c0-17.7-14.3-32-32-32s-32 14.3-32 32V352c0 35.3-28.7 64-64 64H192V192c0-17.7-14.3-32-32-32s-32 14.3-32 32V448c0 17.7 14.3 32 32 32H320z"
    ]
};
var $d8206b3ab2e65c05$export$ecadeff45b05a451 = $d8206b3ab2e65c05$export$3570be7b68efb8db;
var $d8206b3ab2e65c05$export$27e0e10e74d98736 = $d8206b3ab2e65c05$export$3570be7b68efb8db;
var $d8206b3ab2e65c05$export$28b3b26a80030d4e = $d8206b3ab2e65c05$export$3570be7b68efb8db;
var $d8206b3ab2e65c05$export$d84993fb5e8c6edd = $d8206b3ab2e65c05$export$3570be7b68efb8db;
var $d8206b3ab2e65c05$export$fc82fb79180cd17c = {
    prefix: "fas",
    iconName: "map",
    icon: [
        576,
        512,
        [
            128506,
            62072
        ],
        "f279",
        "M384 476.1L192 421.2V35.9L384 90.8V476.1zm32-1.2V88.4L543.1 37.5c15.8-6.3 32.9 5.3 32.9 22.3V394.6c0 9.8-6 18.6-15.1 22.3L416 474.8zM15.1 95.1L160 37.2V423.6L32.9 474.5C17.1 480.8 0 469.2 0 452.2V117.4c0-9.8 6-18.6 15.1-22.3z"
    ]
};
var $d8206b3ab2e65c05$export$b24d84ed5657d89a = {
    prefix: "fas",
    iconName: "rocket",
    icon: [
        512,
        512,
        [],
        "f135",
        "M156.6 384.9L125.7 354c-8.5-8.5-11.5-20.8-7.7-32.2c3-8.9 7-20.5 11.8-33.8L24 288c-8.6 0-16.6-4.6-20.9-12.1s-4.2-16.7 .2-24.1l52.5-88.5c13-21.9 36.5-35.3 61.9-35.3l82.3 0c2.4-4 4.8-7.7 7.2-11.3C289.1-4.1 411.1-8.1 483.9 5.3c11.6 2.1 20.6 11.2 22.8 22.8c13.4 72.9 9.3 194.8-111.4 276.7c-3.5 2.4-7.3 4.8-11.3 7.2v82.3c0 25.4-13.4 49-35.3 61.9l-88.5 52.5c-7.4 4.4-16.6 4.5-24.1 .2s-12.1-12.2-12.1-20.9V380.8c-14.1 4.9-26.4 8.9-35.7 11.9c-11.2 3.6-23.4 .5-31.8-7.8zM384 168a40 40 0 1 0 0-80 40 40 0 1 0 0 80z"
    ]
};
var $d8206b3ab2e65c05$export$ed36ad335b36be22 = {
    prefix: "fas",
    iconName: "photo-film",
    icon: [
        640,
        512,
        [
            "photo-video"
        ],
        "f87c",
        "M256 0H576c35.3 0 64 28.7 64 64V288c0 35.3-28.7 64-64 64H256c-35.3 0-64-28.7-64-64V64c0-35.3 28.7-64 64-64zM476 106.7C471.5 100 464 96 456 96s-15.5 4-20 10.7l-56 84L362.7 169c-4.6-5.7-11.5-9-18.7-9s-14.2 3.3-18.7 9l-64 80c-5.8 7.2-6.9 17.1-2.9 25.4s12.4 13.6 21.6 13.6h80 48H552c8.9 0 17-4.9 21.2-12.7s3.7-17.3-1.2-24.6l-96-144zM336 96a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zM64 128h96V384v32c0 17.7 14.3 32 32 32H320c17.7 0 32-14.3 32-32V384H512v64c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V192c0-35.3 28.7-64 64-64zm8 64c-8.8 0-16 7.2-16 16v16c0 8.8 7.2 16 16 16H88c8.8 0 16-7.2 16-16V208c0-8.8-7.2-16-16-16H72zm0 104c-8.8 0-16 7.2-16 16v16c0 8.8 7.2 16 16 16H88c8.8 0 16-7.2 16-16V312c0-8.8-7.2-16-16-16H72zm0 104c-8.8 0-16 7.2-16 16v16c0 8.8 7.2 16 16 16H88c8.8 0 16-7.2 16-16V416c0-8.8-7.2-16-16-16H72zm336 16v16c0 8.8 7.2 16 16 16h16c8.8 0 16-7.2 16-16V416c0-8.8-7.2-16-16-16H424c-8.8 0-16 7.2-16 16z"
    ]
};
var $d8206b3ab2e65c05$export$739f6a6a12dfb6ed = $d8206b3ab2e65c05$export$ed36ad335b36be22;
var $d8206b3ab2e65c05$export$758f1fb3784e4080 = {
    prefix: "fas",
    iconName: "folder-minus",
    icon: [
        512,
        512,
        [],
        "f65d",
        "M448 480H64c-35.3 0-64-28.7-64-64V96C0 60.7 28.7 32 64 32H192c20.1 0 39.1 9.5 51.2 25.6l19.2 25.6c6 8.1 15.5 12.8 25.6 12.8H448c35.3 0 64 28.7 64 64V416c0 35.3-28.7 64-64 64zM184 272c-13.3 0-24 10.7-24 24s10.7 24 24 24H328c13.3 0 24-10.7 24-24s-10.7-24-24-24H184z"
    ]
};
var $d8206b3ab2e65c05$export$de59c2657a8ace67 = {
    prefix: "fas",
    iconName: "store",
    icon: [
        576,
        512,
        [],
        "f54e",
        "M547.6 103.8L490.3 13.1C485.2 5 476.1 0 466.4 0H109.6C99.9 0 90.8 5 85.7 13.1L28.3 103.8c-29.6 46.8-3.4 111.9 51.9 119.4c4 .5 8.1 .8 12.1 .8c26.1 0 49.3-11.4 65.2-29c15.9 17.6 39.1 29 65.2 29c26.1 0 49.3-11.4 65.2-29c15.9 17.6 39.1 29 65.2 29c26.2 0 49.3-11.4 65.2-29c16 17.6 39.1 29 65.2 29c4.1 0 8.1-.3 12.1-.8c55.5-7.4 81.8-72.5 52.1-119.4zM499.7 254.9l-.1 0c-5.3 .7-10.7 1.1-16.2 1.1c-12.4 0-24.3-1.9-35.4-5.3V384H128V250.6c-11.2 3.5-23.2 5.4-35.6 5.4c-5.5 0-11-.4-16.3-1.1l-.1 0c-4.1-.6-8.1-1.3-12-2.3V384v64c0 35.3 28.7 64 64 64H448c35.3 0 64-28.7 64-64V384 252.6c-4 1-8 1.8-12.3 2.3z"
    ]
};
var $d8206b3ab2e65c05$export$cf36928a9c52e98a = {
    prefix: "fas",
    iconName: "arrow-trend-up",
    icon: [
        576,
        512,
        [],
        "e098",
        "M384 160c-17.7 0-32-14.3-32-32s14.3-32 32-32H544c17.7 0 32 14.3 32 32V288c0 17.7-14.3 32-32 32s-32-14.3-32-32V205.3L342.6 374.6c-12.5 12.5-32.8 12.5-45.3 0L192 269.3 54.6 406.6c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3l160-160c12.5-12.5 32.8-12.5 45.3 0L320 306.7 466.7 160H384z"
    ]
};
var $d8206b3ab2e65c05$export$2a44d62160972254 = {
    prefix: "fas",
    iconName: "plug-circle-minus",
    icon: [
        576,
        512,
        [],
        "e55e",
        "M96 0C78.3 0 64 14.3 64 32v96h64V32c0-17.7-14.3-32-32-32zM288 0c-17.7 0-32 14.3-32 32v96h64V32c0-17.7-14.3-32-32-32zM32 160c-17.7 0-32 14.3-32 32s14.3 32 32 32v32c0 77.4 55 142 128 156.8V480c0 17.7 14.3 32 32 32s32-14.3 32-32V412.8c12.3-2.5 24.1-6.4 35.1-11.5c-2.1-10.8-3.1-21.9-3.1-33.3c0-80.3 53.8-148 127.3-169.2c.5-2.2 .7-4.5 .7-6.8c0-17.7-14.3-32-32-32H32zM576 368a144 144 0 1 0 -288 0 144 144 0 1 0 288 0zm-64 0c0 8.8-7.2 16-16 16H368c-8.8 0-16-7.2-16-16s7.2-16 16-16H496c8.8 0 16 7.2 16 16z"
    ]
};
var $d8206b3ab2e65c05$export$5c1f29f4c7cad367 = {
    prefix: "fas",
    iconName: "sign-hanging",
    icon: [
        512,
        512,
        [
            "sign"
        ],
        "f4d9",
        "M96 0c17.7 0 32 14.3 32 32V64l352 0c17.7 0 32 14.3 32 32s-14.3 32-32 32l-352 0V480c0 17.7-14.3 32-32 32s-32-14.3-32-32V128H32C14.3 128 0 113.7 0 96S14.3 64 32 64H64V32C64 14.3 78.3 0 96 0zm96 160H448c17.7 0 32 14.3 32 32V352c0 17.7-14.3 32-32 32H192c-17.7 0-32-14.3-32-32V192c0-17.7 14.3-32 32-32z"
    ]
};
var $d8206b3ab2e65c05$export$d21d0d6c8e9e8bf9 = $d8206b3ab2e65c05$export$5c1f29f4c7cad367;
var $d8206b3ab2e65c05$export$a527a6267c55a54c = {
    prefix: "fas",
    iconName: "bezier-curve",
    icon: [
        640,
        512,
        [],
        "f55b",
        "M296 136V88h48v48H296zM288 32c-26.5 0-48 21.5-48 48v4H121.6C111.2 62.7 89.3 48 64 48C28.7 48 0 76.7 0 112s28.7 64 64 64c25.3 0 47.2-14.7 57.6-36h66.9c-58.9 39.6-98.9 105-104 180H80c-26.5 0-48 21.5-48 48v64c0 26.5 21.5 48 48 48h64c26.5 0 48-21.5 48-48V368c0-26.5-21.5-48-48-48h-3.3c5.9-67 48.5-123.4 107.5-149.1c8.6 12.7 23.2 21.1 39.8 21.1h64c16.6 0 31.1-8.4 39.8-21.1c59 25.7 101.6 82.1 107.5 149.1H496c-26.5 0-48 21.5-48 48v64c0 26.5 21.5 48 48 48h64c26.5 0 48-21.5 48-48V368c0-26.5-21.5-48-48-48h-4.5c-5-75-45.1-140.4-104-180h66.9c10.4 21.3 32.3 36 57.6 36c35.3 0 64-28.7 64-64s-28.7-64-64-64c-25.3 0-47.2 14.7-57.6 36H400V80c0-26.5-21.5-48-48-48H288zM88 376h48v48H88V376zm416 48V376h48v48H504z"
    ]
};
var $d8206b3ab2e65c05$export$6b31a1e5968b2378 = {
    prefix: "fas",
    iconName: "bell-slash",
    icon: [
        640,
        512,
        [
            128277,
            61943
        ],
        "f1f6",
        "M38.8 5.1C28.4-3.1 13.3-1.2 5.1 9.2S-1.2 34.7 9.2 42.9l592 464c10.4 8.2 25.5 6.3 33.7-4.1s6.3-25.5-4.1-33.7l-87.5-68.6c.5-1.7 .7-3.5 .7-5.4c0-27.6-11-54.1-30.5-73.7L512 320c-20.5-20.5-32-48.3-32-77.3V208c0-77.4-55-142-128-156.8V32c0-17.7-14.3-32-32-32s-32 14.3-32 32V51.2c-42.6 8.6-79 34.2-102 69.3L38.8 5.1zM160 242.7c0 29-11.5 56.8-32 77.3l-1.5 1.5C107 341 96 367.5 96 395.2c0 11.5 9.3 20.8 20.8 20.8H406.2L160 222.1v20.7zM384 448H320 256c0 17 6.7 33.3 18.7 45.3s28.3 18.7 45.3 18.7s33.3-6.7 45.3-18.7s18.7-28.3 18.7-45.3z"
    ]
};
var $d8206b3ab2e65c05$export$1c92b67c45a4b4fc = {
    prefix: "fas",
    iconName: "tablet",
    icon: [
        448,
        512,
        [
            "tablet-android"
        ],
        "f3fb",
        "M64 0C28.7 0 0 28.7 0 64V448c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V64c0-35.3-28.7-64-64-64H64zM176 432h96c8.8 0 16 7.2 16 16s-7.2 16-16 16H176c-8.8 0-16-7.2-16-16s7.2-16 16-16z"
    ]
};
var $d8206b3ab2e65c05$export$5eddbb7c71278268 = $d8206b3ab2e65c05$export$1c92b67c45a4b4fc;
var $d8206b3ab2e65c05$export$9b263780a7312c8c = {
    prefix: "fas",
    iconName: "school-flag",
    icon: [
        576,
        512,
        [],
        "e56e",
        "M288 0H400c8.8 0 16 7.2 16 16V80c0 8.8-7.2 16-16 16H320.7l89.6 64H512c35.3 0 64 28.7 64 64V448c0 35.3-28.7 64-64 64H336V400c0-26.5-21.5-48-48-48s-48 21.5-48 48V512H64c-35.3 0-64-28.7-64-64V224c0-35.3 28.7-64 64-64H165.7L256 95.5V32c0-17.7 14.3-32 32-32zm48 240a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zM80 224c-8.8 0-16 7.2-16 16v64c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V240c0-8.8-7.2-16-16-16H80zm368 16v64c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V240c0-8.8-7.2-16-16-16H464c-8.8 0-16 7.2-16 16zM80 352c-8.8 0-16 7.2-16 16v64c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V368c0-8.8-7.2-16-16-16H80zm384 0c-8.8 0-16 7.2-16 16v64c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V368c0-8.8-7.2-16-16-16H464z"
    ]
};
var $d8206b3ab2e65c05$export$d3c2bcfd3b861e4a = {
    prefix: "fas",
    iconName: "fill",
    icon: [
        512,
        512,
        [],
        "f575",
        "M86.6 9.4C74.1-3.1 53.9-3.1 41.4 9.4s-12.5 32.8 0 45.3L122.7 136 30.6 228.1c-37.5 37.5-37.5 98.3 0 135.8L148.1 481.4c37.5 37.5 98.3 37.5 135.8 0L474.3 290.9c28.1-28.1 28.1-73.7 0-101.8L322.9 37.7c-28.1-28.1-73.7-28.1-101.8 0L168 90.7 86.6 9.4zM168 181.3l49.4 49.4c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L213.3 136l53.1-53.1c3.1-3.1 8.2-3.1 11.3 0L429.1 234.3c3.1 3.1 3.1 8.2 0 11.3L386.7 288H67.5c1.4-5.4 4.2-10.4 8.4-14.6L168 181.3z"
    ]
};
var $d8206b3ab2e65c05$export$887340269e6d6cac = {
    prefix: "fas",
    iconName: "angle-up",
    icon: [
        448,
        512,
        [
            8963
        ],
        "f106",
        "M201.4 137.4c12.5-12.5 32.8-12.5 45.3 0l160 160c12.5 12.5 12.5 32.8 0 45.3s-32.8 12.5-45.3 0L224 205.3 86.6 342.6c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3l160-160z"
    ]
};
var $d8206b3ab2e65c05$export$482976e9a4ab10f3 = {
    prefix: "fas",
    iconName: "drumstick-bite",
    icon: [
        512,
        512,
        [],
        "f6d7",
        "M160 265.2c0 8.5-3.4 16.6-9.4 22.6l-26.8 26.8c-12.3 12.3-32.5 11.4-49.4 7.2C69.8 320.6 65 320 60 320c-33.1 0-60 26.9-60 60s26.9 60 60 60c6.3 0 12 5.7 12 12c0 33.1 26.9 60 60 60s60-26.9 60-60c0-5-.6-9.8-1.8-14.5c-4.2-16.9-5.2-37.1 7.2-49.4l26.8-26.8c6-6 14.1-9.4 22.6-9.4H336c6.3 0 12.4-.3 18.5-1c11.9-1.2 16.4-15.5 10.8-26c-8.5-15.8-13.3-33.8-13.3-53c0-61.9 50.1-112 112-112c8 0 15.7 .8 23.2 2.4c11.7 2.5 24.1-5.9 22-17.6C494.5 62.5 422.5 0 336 0C238.8 0 160 78.8 160 176v89.2z"
    ]
};
var $d8206b3ab2e65c05$export$273296afacf93991 = {
    prefix: "fas",
    iconName: "holly-berry",
    icon: [
        512,
        512,
        [],
        "f7aa",
        "M256 96a48 48 0 1 0 0-96 48 48 0 1 0 0 96zm-80 96a48 48 0 1 0 0-96 48 48 0 1 0 0 96zM276.8 383.8c1 .1 2.1 .2 3.2 .2c39.8 0 72 32.2 72 72v22.7c0 16.4 16 27.9 31.6 22.8l12.8-4.3c18-6 37.3-6.5 55.6-1.5l19.4 5.3c17.9 4.9 34.4-11.6 29.5-29.5L495.6 452c-5-18.3-4.4-37.6 1.5-55.6l4.3-12.8c5.2-15.5-6.4-31.6-22.8-31.6c-34.6 0-62.7-28.1-62.7-62.7v-32c0-16.4-16-27.9-31.6-22.8l-12.8 4.3c-18 6-37.3 6.5-55.6 1.5l-29.6-8.1c-2.9-.8-5.9-1-8.7-.7c4.2 9.7 5.8 20.8 3.7 32.3L275 298.7c-1.5 8.4-1.4 17 .5 25.3l5.3 23.9c2.8 12.7 1.1 25.2-4 35.9zM127.6 234.5c-15.5-5.2-31.6 6.4-31.6 22.8v32C96 323.9 67.9 352 33.3 352c-16.4 0-27.9 16-22.8 31.6l4.3 12.8c6 18 6.5 37.3 1.5 55.6l-5.3 19.4C6.2 489.4 22.6 505.8 40.5 501L60 495.6c18.3-5 37.6-4.5 55.6 1.5l12.8 4.3c15.5 5.2 31.6-6.4 31.6-22.8v-32c0-34.6 28.1-62.7 62.7-62.7c16.4 0 27.9-16 22.8-31.6l-4.3-12.8c-6-18-6.5-37.3-1.5-55.6l5.3-19.4c4.9-17.9-11.6-34.4-29.5-29.5L196 240.4c-18.3 5-37.6 4.4-55.6-1.5l-12.8-4.3zM384 144a48 48 0 1 0 -96 0 48 48 0 1 0 96 0z"
    ]
};
var $d8206b3ab2e65c05$export$75702e3e3dd44a44 = {
    prefix: "fas",
    iconName: "chevron-left",
    icon: [
        320,
        512,
        [
            9001
        ],
        "f053",
        "M9.4 233.4c-12.5 12.5-12.5 32.8 0 45.3l192 192c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L77.3 256 246.6 86.6c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0l-192 192z"
    ]
};
var $d8206b3ab2e65c05$export$7fc18cf2d526c341 = {
    prefix: "fas",
    iconName: "bacteria",
    icon: [
        640,
        512,
        [],
        "e059",
        "M304.9 .7c-9.6-2.7-19.5 2.8-22.3 12.4l-4.3 15.2c-8.3-.6-16.8 0-25.2 1.9c-7.3 1.7-14.3 3.5-21.1 5.5l-5.5-12.7c-3.9-9.1-14.5-13.4-23.6-9.5s-13.4 14.5-9.5 23.6l4.4 10.4c-16.6 6.7-31.7 14.4-45.4 22.8L147 62c-5.5-8.3-16.7-10.5-25-5s-10.5 16.7-5 25l6 9c-13.7 11-25.5 22.8-35.8 34.9l-10-8c-7.8-6.2-19.1-5-25.3 2.8s-5 19.1 2.8 25.3L65.9 155c-1.8 2.8-3.5 5.7-5.1 8.5c-6.6 11.4-11.8 22.6-16 33l-8-3.2c-9.2-3.7-19.7 .8-23.4 10s.8 19.7 10 23.4l10.4 4.2c-.2 .8-.4 1.5-.5 2.3c-2.2 9.3-3.4 17.3-4.1 23.4c-.4 3.1-.6 5.7-.8 7.8c-.1 1.1-.1 2-.2 2.8l-.1 1.1 0 .5 0 .2 0 .1c0 0 0 .1 29.1 1l-.1 0L28 269.3c-.1 3.1 0 6.1 .2 9.1l-15.2 4.3C3.5 285.4-2 295.4 .7 304.9s12.7 15.1 22.3 12.4l15.6-4.5c7.6 13.6 18.9 25 32.6 32.6L66.7 361c-2.7 9.6 2.8 19.5 12.4 22.3s19.5-2.8 22.3-12.4l4.3-15.2c1.2 .1 2.4 .2 3.6 .2c15.6 .5 30.3-3.3 43-10.2l9 9c7 7 18.4 7 25.5 0s7-18.4 0-25.5l-7.2-7.2c9.3-12.6 15.2-27.8 16.3-44.5l7.1 3c9.1 3.9 19.7-.3 23.6-9.5s-.3-19.7-9.5-23.6l-8.6-3.7c6.4-9.9 17.3-22.4 36.9-33.3l1.3 4.4c2.7 9.6 12.7 15.1 22.3 12.4s15.1-12.7 12.4-22.3l-2.3-8.1c3.8-1.1 7.7-2.1 11.9-3.1c11.6-2.7 22.1-7.7 31.1-14.4l7.2 7.2c7 7 18.4 7 25.5 0s7-18.4 0-25.5l-9-9c7.6-13.9 11.3-30.1 10.1-46.6l15.2-4.3c9.6-2.7 15.1-12.7 12.4-22.3S370.6 64 361 66.7l-15.6 4.5c-7.7-13.9-19.1-25.1-32.6-32.6l4.5-15.6c2.7-9.6-2.8-19.5-12.4-22.3zM112 272l-48-1.5 0 0c11.7 .4 27.3 .9 48 1.6zm16-80a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm64-48a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zM322.7 489c-2.7 9.6 2.8 19.5 12.4 22.3s19.5-2.8 22.2-12.4l4.3-15.2c8.3 .6 16.8 0 25.2-1.9c7.3-1.7 14.3-3.5 21.1-5.5l5.5 12.7c3.9 9.1 14.5 13.4 23.6 9.5s13.4-14.5 9.5-23.6l-4.4-10.4c16.6-6.7 31.7-14.4 45.4-22.8L493 450c5.5 8.3 16.7 10.5 25 5s10.5-16.7 5-25l-6-9c13.7-11 25.5-22.8 35.8-34.9l10 8c7.8 6.2 19.1 5 25.3-2.8s5-19.1-2.8-25.3L574.1 357c1.8-2.8 3.5-5.7 5.1-8.5c6.6-11.4 11.8-22.6 16-33l8 3.2c9.2 3.7 19.7-.8 23.4-10s-.8-19.7-10-23.4l-10.4-4.2c.2-.8 .4-1.5 .5-2.3c2.2-9.3 3.4-17.3 4.1-23.4c.4-3.1 .6-5.7 .8-7.8c.1-1.1 .1-2 .2-2.8l.1-1.1 0-.5 0-.2 0-.1c0 0 0-.1-29.1-1l.1 0 29.1 .9c.1-3.1 0-6.1-.2-9.1l15.2-4.3c9.6-2.7 15.1-12.7 12.4-22.3s-12.7-15.1-22.3-12.4l-15.6 4.5c-7.6-13.6-18.9-25-32.6-32.6l4.5-15.6c2.7-9.6-2.8-19.5-12.4-22.3s-19.5 2.8-22.3 12.4l-4.3 15.2c-1.2-.1-2.4-.2-3.6-.2c-15.6-.5-30.3 3.3-43 10.2l-9-9c-7-7-18.4-7-25.5 0s-7 18.4 0 25.5l7.2 7.2c-9.3 12.6-15.2 27.8-16.3 44.5l-7.1-3c-9.1-3.9-19.7 .3-23.6 9.5s.3 19.7 9.5 23.6l8.6 3.7c-6.4 9.9-17.3 22.4-36.9 33.3l-1.3-4.4c-2.7-9.6-12.7-15.1-22.3-12.4s-15.1 12.7-12.4 22.3l2.3 8.1c-3.8 1.1-7.7 2.1-11.9 3.1c-11.6 2.7-22.1 7.7-31.1 14.4l-7.2-7.2c-7-7-18.4-7-25.5 0s-7 18.4 0 25.5l9 9c-7.6 13.9-11.3 30.1-10.1 46.6l-15.2 4.3c-9.6 2.7-15.1 12.7-12.4 22.2s12.7 15.1 22.3 12.4l15.6-4.5c7.7 13.9 19.1 25.1 32.6 32.6L322.7 489zM576 241.5l0 0c-11.7-.4-27.3-.9-48-1.6l48 1.5zM448 384a32 32 0 1 1 -64 0 32 32 0 1 1 64 0z"
    ]
};
var $d8206b3ab2e65c05$export$54608d0a883fea4d = {
    prefix: "fas",
    iconName: "hand-lizard",
    icon: [
        512,
        512,
        [],
        "f258",
        "M0 112C0 85.5 21.5 64 48 64H160h80 46.5c36.8 0 71.2 18 92.1 48.2l113.5 164c13 18.7 19.9 41 19.9 63.8v12 16 48c0 17.7-14.3 32-32 32H384c-17.7 0-32-14.3-32-32V402.2L273.9 352H240 160 112c-26.5 0-48-21.5-48-48s21.5-48 48-48h48 80c26.5 0 48-21.5 48-48s-21.5-48-48-48H160 48c-26.5 0-48-21.5-48-48z"
    ]
};
var $d8206b3ab2e65c05$export$3db5bca65a1be8dc = {
    prefix: "fas",
    iconName: "notdef",
    icon: [
        384,
        512,
        [],
        "e1fe",
        "M64 390.3L153.5 256 64 121.7V390.3zM102.5 448H281.5L192 313.7 102.5 448zm128-192L320 390.3V121.7L230.5 256zM281.5 64H102.5L192 198.3 281.5 64zM0 48C0 21.5 21.5 0 48 0H336c26.5 0 48 21.5 48 48V464c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V48z"
    ]
};
var $d8206b3ab2e65c05$export$c7675a37487adc45 = {
    prefix: "fas",
    iconName: "disease",
    icon: [
        512,
        512,
        [],
        "f7fa",
        "M236.4 61.4L227 75.5c-21.3 32-59.4 48.5-97.3 42.1l-59.6-9.9C33.4 101.6 0 129.9 .1 167.1c0 15.9 6.4 31.2 17.6 42.5l29.2 29.2c11 11 17.2 25.9 17.2 41.5c0 15.8-6.4 30.9-17.7 42L33.3 335.1C22.2 345.9 16 360.7 16 376.2c0 36.8 34.1 64.2 70.1 56.2l62.3-13.8c7.7-1.7 15.7-2.6 23.6-2.6h10c27.2 0 53.7 9.3 75 26.3L287.8 467c10.5 8.4 23.6 13 37 13c32.7 0 59.3-26.5 59.3-59.3l0-25.2c0-34.9 21.4-66.2 53.9-78.8l36.9-14.3c22.4-8.7 37.2-30.3 37.2-54.3c0-28.1-20.1-52.3-47.8-57.3l-28-5.1c-36.5-6.7-65.4-34.5-73.6-70.7l-7.1-31.5C348.9 53.4 322.1 32 291.3 32c-22 0-42.6 11-54.9 29.4zM160 192a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm128 16a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zm0 80a32 32 0 1 1 0 64 32 32 0 1 1 0-64z"
    ]
};
var $d8206b3ab2e65c05$export$5000f52ca9819bf5 = {
    prefix: "fas",
    iconName: "briefcase-medical",
    icon: [
        512,
        512,
        [],
        "f469",
        "M184 48H328c4.4 0 8 3.6 8 8V96H176V56c0-4.4 3.6-8 8-8zm-56 8V96H64C28.7 96 0 124.7 0 160V416c0 35.3 28.7 64 64 64H448c35.3 0 64-28.7 64-64V160c0-35.3-28.7-64-64-64H384V56c0-30.9-25.1-56-56-56H184c-30.9 0-56 25.1-56 56zm96 152c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v48h48c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H288v48c0 8.8-7.2 16-16 16H240c-8.8 0-16-7.2-16-16V320H176c-8.8 0-16-7.2-16-16V272c0-8.8 7.2-16 16-16h48V208z"
    ]
};
var $d8206b3ab2e65c05$export$c093cc22e88981c2 = {
    prefix: "fas",
    iconName: "genderless",
    icon: [
        384,
        512,
        [],
        "f22d",
        "M192 144a112 112 0 1 1 0 224 112 112 0 1 1 0-224zm0 288a176 176 0 1 0 0-352 176 176 0 1 0 0 352z"
    ]
};
var $d8206b3ab2e65c05$export$930de8c26eb20490 = {
    prefix: "fas",
    iconName: "chevron-right",
    icon: [
        320,
        512,
        [
            9002
        ],
        "f054",
        "M310.6 233.4c12.5 12.5 12.5 32.8 0 45.3l-192 192c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3L242.7 256 73.4 86.6c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0l192 192z"
    ]
};
var $d8206b3ab2e65c05$export$cebc76f79478e40e = {
    prefix: "fas",
    iconName: "retweet",
    icon: [
        576,
        512,
        [],
        "f079",
        "M272 416c17.7 0 32-14.3 32-32s-14.3-32-32-32H160c-17.7 0-32-14.3-32-32V192h32c12.9 0 24.6-7.8 29.6-19.8s2.2-25.7-6.9-34.9l-64-64c-12.5-12.5-32.8-12.5-45.3 0l-64 64c-9.2 9.2-11.9 22.9-6.9 34.9s16.6 19.8 29.6 19.8l32 0 0 128c0 53 43 96 96 96H272zM304 96c-17.7 0-32 14.3-32 32s14.3 32 32 32l112 0c17.7 0 32 14.3 32 32l0 128H416c-12.9 0-24.6 7.8-29.6 19.8s-2.2 25.7 6.9 34.9l64 64c12.5 12.5 32.8 12.5 45.3 0l64-64c9.2-9.2 11.9-22.9 6.9-34.9s-16.6-19.8-29.6-19.8l-32 0V192c0-53-43-96-96-96L304 96z"
    ]
};
var $d8206b3ab2e65c05$export$ff2b8d5628da5f14 = {
    prefix: "fas",
    iconName: "car-rear",
    icon: [
        512,
        512,
        [
            "car-alt"
        ],
        "f5de",
        "M165.4 96H346.6c13.6 0 25.7 8.6 30.2 21.4L402.9 192H109.1l26.1-74.6c4.5-12.8 16.6-21.4 30.2-21.4zm-90.6 .3L39.6 196.8C16.4 206.4 0 229.3 0 256v80c0 23.7 12.9 44.4 32 55.4V448c0 17.7 14.3 32 32 32H96c17.7 0 32-14.3 32-32V400H384v48c0 17.7 14.3 32 32 32h32c17.7 0 32-14.3 32-32V391.4c19.1-11.1 32-31.7 32-55.4V256c0-26.7-16.4-49.6-39.6-59.2L437.2 96.3C423.7 57.8 387.4 32 346.6 32H165.4c-40.8 0-77.1 25.8-90.6 64.3zM208 272h96c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H208c-8.8 0-16-7.2-16-16V288c0-8.8 7.2-16 16-16zM48 280c0-13.3 10.7-24 24-24h32c13.3 0 24 10.7 24 24s-10.7 24-24 24H72c-13.3 0-24-10.7-24-24zm360-24h32c13.3 0 24 10.7 24 24s-10.7 24-24 24H408c-13.3 0-24-10.7-24-24s10.7-24 24-24z"
    ]
};
var $d8206b3ab2e65c05$export$7937ed2462a665c0 = $d8206b3ab2e65c05$export$ff2b8d5628da5f14;
var $d8206b3ab2e65c05$export$821aeede187f23c9 = {
    prefix: "fas",
    iconName: "pump-soap",
    icon: [
        448,
        512,
        [],
        "e06b",
        "M128 32v96H256V96h60.1c4.2 0 8.3 1.7 11.3 4.7l33.9 33.9c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L372.7 55.4c-15-15-35.4-23.4-56.6-23.4H256c0-17.7-14.3-32-32-32H160c-17.7 0-32 14.3-32 32zM117.4 160c-33.3 0-61 25.5-63.8 58.7L35 442.7C31.9 480 61.3 512 98.8 512H285.2c37.4 0 66.9-32 63.8-69.3l-18.7-224c-2.8-33.2-30.5-58.7-63.8-58.7H117.4zM256 360c0 35.3-28.7 56-64 56s-64-20.7-64-56c0-32.5 37-80.9 50.9-97.9c3.2-3.9 8.1-6.1 13.1-6.1s9.9 2.2 13.1 6.1C219 279.1 256 327.5 256 360z"
    ]
};
var $d8206b3ab2e65c05$export$a714fc79f58cc9ef = {
    prefix: "fas",
    iconName: "video-slash",
    icon: [
        640,
        512,
        [],
        "f4e2",
        "M38.8 5.1C28.4-3.1 13.3-1.2 5.1 9.2S-1.2 34.7 9.2 42.9l592 464c10.4 8.2 25.5 6.3 33.7-4.1s6.3-25.5-4.1-33.7l-86.4-67.7 13.8 9.2c9.8 6.5 22.4 7.2 32.9 1.6s16.9-16.4 16.9-28.2V128c0-11.8-6.5-22.6-16.9-28.2s-23-5-32.9 1.6l-96 64L448 174.9V192 320v5.8l-32-25.1V128c0-35.3-28.7-64-64-64H113.9L38.8 5.1zM407 416.7L32.3 121.5c-.2 2.1-.3 4.3-.3 6.5V384c0 35.3 28.7 64 64 64H352c23.4 0 43.9-12.6 55-31.3z"
    ]
};
var $d8206b3ab2e65c05$export$acec92052ac2183 = {
    prefix: "fas",
    iconName: "battery-quarter",
    icon: [
        576,
        512,
        [
            "battery-2"
        ],
        "f243",
        "M464 160c8.8 0 16 7.2 16 16V336c0 8.8-7.2 16-16 16H80c-8.8 0-16-7.2-16-16V176c0-8.8 7.2-16 16-16H464zM80 96C35.8 96 0 131.8 0 176V336c0 44.2 35.8 80 80 80H464c44.2 0 80-35.8 80-80V320c17.7 0 32-14.3 32-32V224c0-17.7-14.3-32-32-32V176c0-44.2-35.8-80-80-80H80zm112 96H96V320h96V192z"
    ]
};
var $d8206b3ab2e65c05$export$23ca8a94c555576 = $d8206b3ab2e65c05$export$acec92052ac2183;
var $d8206b3ab2e65c05$export$11b26516cae2104f = {
    prefix: "fas",
    iconName: "radio",
    icon: [
        512,
        512,
        [
            128251
        ],
        "f8d7",
        "M494.8 47c12.7-3.7 20-17.1 16.3-29.8S494-2.8 481.2 1L51.7 126.9c-9.4 2.7-17.9 7.3-25.1 13.2C10.5 151.7 0 170.6 0 192v4V304 448c0 35.3 28.7 64 64 64H448c35.3 0 64-28.7 64-64V192c0-35.3-28.7-64-64-64H218.5L494.8 47zM368 240a80 80 0 1 1 0 160 80 80 0 1 1 0-160zM80 256c0-8.8 7.2-16 16-16h96c8.8 0 16 7.2 16 16s-7.2 16-16 16H96c-8.8 0-16-7.2-16-16zM64 320c0-8.8 7.2-16 16-16H208c8.8 0 16 7.2 16 16s-7.2 16-16 16H80c-8.8 0-16-7.2-16-16zm16 64c0-8.8 7.2-16 16-16h96c8.8 0 16 7.2 16 16s-7.2 16-16 16H96c-8.8 0-16-7.2-16-16z"
    ]
};
var $d8206b3ab2e65c05$export$3b3ab4d86bad7d26 = {
    prefix: "fas",
    iconName: "baby-carriage",
    icon: [
        512,
        512,
        [
            "carriage-baby"
        ],
        "f77d",
        "M256 192H.1C2.7 117.9 41.3 52.9 99 14.1c13.3-8.9 30.8-4.3 39.9 8.8L256 192zm128-32c0-35.3 28.7-64 64-64h32c17.7 0 32 14.3 32 32s-14.3 32-32 32l-32 0v64c0 25.2-5.8 50.2-17 73.5s-27.8 44.5-48.6 62.3s-45.5 32-72.7 41.6S253.4 416 224 416s-58.5-5-85.7-14.6s-51.9-23.8-72.7-41.6s-37.3-39-48.6-62.3S0 249.2 0 224l224 0 160 0V160zM80 416a48 48 0 1 1 0 96 48 48 0 1 1 0-96zm240 48a48 48 0 1 1 96 0 48 48 0 1 1 -96 0z"
    ]
};
var $d8206b3ab2e65c05$export$9f117d92ccd36cf1 = $d8206b3ab2e65c05$export$3b3ab4d86bad7d26;
var $d8206b3ab2e65c05$export$bf0b19daceaec9c2 = {
    prefix: "fas",
    iconName: "traffic-light",
    icon: [
        320,
        512,
        [
            128678
        ],
        "f637",
        "M64 0C28.7 0 0 28.7 0 64V352c0 88.4 71.6 160 160 160s160-71.6 160-160V64c0-35.3-28.7-64-64-64H64zm96 416a48 48 0 1 1 0-96 48 48 0 1 1 0 96zm48-176a48 48 0 1 1 -96 0 48 48 0 1 1 96 0zm-48-80a48 48 0 1 1 0-96 48 48 0 1 1 0 96z"
    ]
};
var $d8206b3ab2e65c05$export$f576739e9b18ea4f = {
    prefix: "fas",
    iconName: "thermometer",
    icon: [
        512,
        512,
        [],
        "f491",
        "M96 382.1V293.3c0-14.9 5.9-29.1 16.4-39.6l27.3-27.3 57 57c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6l-57-57 41.4-41.4 57 57c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6l-57-57 41.4-41.4 57 57c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6l-57-57 45.5-45.5C355.2 10.9 381.4 0 408.8 0C465.8 0 512 46.2 512 103.2c0 27.4-10.9 53.6-30.2 73L258.3 399.6c-10.5 10.5-24.7 16.4-39.6 16.4H129.9L41 505c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l89-89z"
    ]
};
var $d8206b3ab2e65c05$export$248171cb6dad4307 = {
    prefix: "fas",
    iconName: "vr-cardboard",
    icon: [
        640,
        512,
        [],
        "f729",
        "M576 64H64C28.7 64 0 92.7 0 128V384c0 35.3 28.7 64 64 64H184.4c24.2 0 46.4-13.7 57.2-35.4l32-64c8.8-17.5 26.7-28.6 46.3-28.6s37.5 11.1 46.3 28.6l32 64c10.8 21.7 33 35.4 57.2 35.4H576c35.3 0 64-28.7 64-64V128c0-35.3-28.7-64-64-64zM96 240a64 64 0 1 1 128 0A64 64 0 1 1 96 240zm384-64a64 64 0 1 1 0 128 64 64 0 1 1 0-128z"
    ]
};
var $d8206b3ab2e65c05$export$bd40d3a3a16fb147 = {
    prefix: "fas",
    iconName: "hand-middle-finger",
    icon: [
        448,
        512,
        [
            128405
        ],
        "f806",
        "M232 0c-22.1 0-40 17.9-40 40V204.2c-8.5-7.6-19.7-12.2-32-12.2c-26.5 0-48 21.5-48 48v7 73c0 8.8-7.2 16-16 16s-16-7.2-16-16V264.3c-2 1.4-3.9 3-5.8 4.5L55 284.8C40.4 297 32 315 32 334V372c0 38 16.9 74 46.1 98.3l5.4 4.5c28.8 24 65 37.1 102.4 37.1H304c70.7 0 128-57.3 128-128V320 288c0-26.5-21.5-48-48-48c-12.4 0-23.6 4.7-32.1 12.3C350 227.5 329.3 208 304 208c-12.3 0-23.5 4.6-32 12.2V40c0-22.1-17.9-40-40-40z"
    ]
};
var $d8206b3ab2e65c05$export$89a1764fbb7ad2cb = {
    prefix: "fas",
    iconName: "percent",
    icon: [
        384,
        512,
        [
            62101,
            62785,
            "percentage"
        ],
        "25",
        "M374.6 118.6c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0l-320 320c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0l320-320zM128 128A64 64 0 1 0 0 128a64 64 0 1 0 128 0zM384 384a64 64 0 1 0 -128 0 64 64 0 1 0 128 0z"
    ]
};
var $d8206b3ab2e65c05$export$89333857fc063a2e = $d8206b3ab2e65c05$export$89a1764fbb7ad2cb;
var $d8206b3ab2e65c05$export$a06617a1a4ccea67 = {
    prefix: "fas",
    iconName: "truck-moving",
    icon: [
        640,
        512,
        [],
        "f4df",
        "M64 32C28.7 32 0 60.7 0 96V304v80 16c0 44.2 35.8 80 80 80c26.2 0 49.4-12.6 64-32c14.6 19.4 37.8 32 64 32c44.2 0 80-35.8 80-80c0-5.5-.6-10.8-1.6-16H416h33.6c-1 5.2-1.6 10.5-1.6 16c0 44.2 35.8 80 80 80s80-35.8 80-80c0-5.5-.6-10.8-1.6-16H608c17.7 0 32-14.3 32-32V288 272 261.7c0-9.2-3.2-18.2-9-25.3l-58.8-71.8c-10.6-13-26.5-20.5-43.3-20.5H480V96c0-35.3-28.7-64-64-64H64zM585 256H480V192h48.8c2.4 0 4.7 1.1 6.2 2.9L585 256zM528 368a32 32 0 1 1 0 64 32 32 0 1 1 0-64zM176 400a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zM80 368a32 32 0 1 1 0 64 32 32 0 1 1 0-64z"
    ]
};
var $d8206b3ab2e65c05$export$b7ae54b4078b2060 = {
    prefix: "fas",
    iconName: "glass-water-droplet",
    icon: [
        384,
        512,
        [],
        "e4f5",
        "M32 0C23.1 0 14.6 3.7 8.6 10.2S-.6 25.4 .1 34.3L28.9 437.7c3 41.9 37.8 74.3 79.8 74.3H275.3c42 0 76.8-32.4 79.8-74.3L383.9 34.3c.6-8.9-2.4-17.6-8.5-24.1S360.9 0 352 0H32zM83 297.5L66.4 64H317.6L301 297.5 288 304c-20.1 10.1-43.9 10.1-64 0s-43.9-10.1-64 0s-43.9 10.1-64 0l-13-6.5zM256 196c0-24-33.7-70.1-52.2-93.5c-6.1-7.7-17.5-7.7-23.6 0C161.7 125.9 128 172 128 196c0 33.1 28.7 60 64 60s64-26.9 64-60z"
    ]
};
var $d8206b3ab2e65c05$export$e9d85839f7751f01 = {
    prefix: "fas",
    iconName: "display",
    icon: [
        576,
        512,
        [],
        "e163",
        "M64 0C28.7 0 0 28.7 0 64V352c0 35.3 28.7 64 64 64H240l-10.7 32H160c-17.7 0-32 14.3-32 32s14.3 32 32 32H416c17.7 0 32-14.3 32-32s-14.3-32-32-32H346.7L336 416H512c35.3 0 64-28.7 64-64V64c0-35.3-28.7-64-64-64H64zM512 64V352H64V64H512z"
    ]
};
var $d8206b3ab2e65c05$export$b5023c446f10324 = {
    prefix: "fas",
    iconName: "face-smile",
    icon: [
        512,
        512,
        [
            128578,
            "smile"
        ],
        "f118",
        "M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM164.1 325.5C182 346.2 212.6 368 256 368s74-21.8 91.9-42.5c5.8-6.7 15.9-7.4 22.6-1.6s7.4 15.9 1.6 22.6C349.8 372.1 311.1 400 256 400s-93.8-27.9-116.1-53.5c-5.8-6.7-5.1-16.8 1.6-22.6s16.8-5.1 22.6 1.6zM144.4 208a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm192-32a32 32 0 1 1 0 64 32 32 0 1 1 0-64z"
    ]
};
var $d8206b3ab2e65c05$export$c632b2334f0913bc = $d8206b3ab2e65c05$export$b5023c446f10324;
var $d8206b3ab2e65c05$export$b6314cdc01bb5c43 = {
    prefix: "fas",
    iconName: "thumbtack",
    icon: [
        384,
        512,
        [
            128204,
            128392,
            "thumb-tack"
        ],
        "f08d",
        "M32 32C32 14.3 46.3 0 64 0H320c17.7 0 32 14.3 32 32s-14.3 32-32 32H290.5l11.4 148.2c36.7 19.9 65.7 53.2 79.5 94.7l1 3c3.3 9.8 1.6 20.5-4.4 28.8s-15.7 13.3-26 13.3H32c-10.3 0-19.9-4.9-26-13.3s-7.7-19.1-4.4-28.8l1-3c13.8-41.5 42.8-74.8 79.5-94.7L93.5 64H64C46.3 64 32 49.7 32 32zM160 384h64v96c0 17.7-14.3 32-32 32s-32-14.3-32-32V384z"
    ]
};
var $d8206b3ab2e65c05$export$b63d0c7b519a9aae = $d8206b3ab2e65c05$export$b6314cdc01bb5c43;
var $d8206b3ab2e65c05$export$29c432d69ccf85a5 = {
    prefix: "fas",
    iconName: "trophy",
    icon: [
        576,
        512,
        [
            127942
        ],
        "f091",
        "M400 0H176c-26.5 0-48.1 21.8-47.1 48.2c.2 5.3 .4 10.6 .7 15.8H24C10.7 64 0 74.7 0 88c0 92.6 33.5 157 78.5 200.7c44.3 43.1 98.3 64.8 138.1 75.8c23.4 6.5 39.4 26 39.4 45.6c0 20.9-17 37.9-37.9 37.9H192c-17.7 0-32 14.3-32 32s14.3 32 32 32H384c17.7 0 32-14.3 32-32s-14.3-32-32-32H357.9C337 448 320 431 320 410.1c0-19.6 15.9-39.2 39.4-45.6c39.9-11 93.9-32.7 138.2-75.8C542.5 245 576 180.6 576 88c0-13.3-10.7-24-24-24H446.4c.3-5.2 .5-10.4 .7-15.8C448.1 21.8 426.5 0 400 0zM48.9 112h84.4c9.1 90.1 29.2 150.3 51.9 190.6c-24.9-11-50.8-26.5-73.2-48.3c-32-31.1-58-76-63-142.3zM464.1 254.3c-22.4 21.8-48.3 37.3-73.2 48.3c22.7-40.3 42.8-100.5 51.9-190.6h84.4c-5.1 66.3-31.1 111.2-63 142.3z"
    ]
};
var $d8206b3ab2e65c05$export$8ecd436ef91fc02e = {
    prefix: "fas",
    iconName: "person-praying",
    icon: [
        448,
        512,
        [
            128720,
            "pray"
        ],
        "f683",
        "M352 64A64 64 0 1 0 224 64a64 64 0 1 0 128 0zM232.7 264l22.9 31.5c6.5 8.9 16.3 14.7 27.2 16.1s21.9-1.7 30.4-8.7l88-72c17.1-14 19.6-39.2 5.6-56.3s-39.2-19.6-56.3-5.6l-55.2 45.2-26.2-36C253.6 156.7 228.6 144 202 144c-30.9 0-59.2 17.1-73.6 44.4L79.8 280.9c-20.2 38.5-9.4 85.9 25.6 111.8L158.6 432H72c-22.1 0-40 17.9-40 40s17.9 40 40 40H280c17.3 0 32.6-11.1 38-27.5s-.3-34.4-14.2-44.7L187.7 354l45-90z"
    ]
};
var $d8206b3ab2e65c05$export$3b32c982141cad51 = $d8206b3ab2e65c05$export$8ecd436ef91fc02e;
var $d8206b3ab2e65c05$export$6310f315e1ebbca5 = {
    prefix: "fas",
    iconName: "hammer",
    icon: [
        576,
        512,
        [
            128296
        ],
        "f6e3",
        "M413.5 237.5c-28.2 4.8-58.2-3.6-80-25.4l-38.1-38.1C280.4 159 272 138.8 272 117.6V105.5L192.3 62c-5.3-2.9-8.6-8.6-8.3-14.7s3.9-11.5 9.5-14l47.2-21C259.1 4.2 279 0 299.2 0h18.1c36.7 0 72 14 98.7 39.1l44.6 42c24.2 22.8 33.2 55.7 26.6 86L503 183l8-8c9.4-9.4 24.6-9.4 33.9 0l24 24c9.4 9.4 9.4 24.6 0 33.9l-88 88c-9.4 9.4-24.6 9.4-33.9 0l-24-24c-9.4-9.4-9.4-24.6 0-33.9l8-8-17.5-17.5zM27.4 377.1L260.9 182.6c3.5 4.9 7.5 9.6 11.8 14l38.1 38.1c6 6 12.4 11.2 19.2 15.7L134.9 484.6c-14.5 17.4-36 27.4-58.6 27.4C34.1 512 0 477.8 0 435.7c0-22.6 10.1-44.1 27.4-58.6z"
    ]
};
var $d8206b3ab2e65c05$export$e49e3cfceea441cc = {
    prefix: "fas",
    iconName: "hand-peace",
    icon: [
        512,
        512,
        [
            9996
        ],
        "f25b",
        "M224 0c17.7 0 32 14.3 32 32V240H192V32c0-17.7 14.3-32 32-32zm96 160c17.7 0 32 14.3 32 32v64c0 17.7-14.3 32-32 32s-32-14.3-32-32V192c0-17.7 14.3-32 32-32zm64 64c0-17.7 14.3-32 32-32s32 14.3 32 32v64c0 17.7-14.3 32-32 32s-32-14.3-32-32V224zM93.3 51.2L175.9 240H106.1L34.7 76.8C27.6 60.6 35 41.8 51.2 34.7s35.1 .3 42.1 16.5zm27 221.3l-.2-.5h69.9H216c22.1 0 40 17.9 40 40s-17.9 40-40 40H160c-8.8 0-16 7.2-16 16s7.2 16 16 16h56c39.8 0 72-32.2 72-72l0-.6c9.4 5.4 20.3 8.6 32 8.6c13.2 0 25.4-4 35.6-10.8c8.7 24.9 32.5 42.8 60.4 42.8c11.7 0 22.6-3.1 32-8.6V352c0 88.4-71.6 160-160 160H226.3c-42.4 0-83.1-16.9-113.1-46.9l-11.6-11.6C77.5 429.5 64 396.9 64 363V336c0-32.7 24.6-59.7 56.3-63.5z"
    ]
};
var $d8206b3ab2e65c05$export$decde496a29c5b23 = {
    prefix: "fas",
    iconName: "rotate",
    icon: [
        512,
        512,
        [
            128260,
            "sync-alt"
        ],
        "f2f1",
        "M142.9 142.9c62.2-62.2 162.7-62.5 225.3-1L327 183c-6.9 6.9-8.9 17.2-5.2 26.2s12.5 14.8 22.2 14.8H463.5c0 0 0 0 0 0H472c13.3 0 24-10.7 24-24V72c0-9.7-5.8-18.5-14.8-22.2s-19.3-1.7-26.2 5.2L413.4 96.6c-87.6-86.5-228.7-86.2-315.8 1C73.2 122 55.6 150.7 44.8 181.4c-5.9 16.7 2.9 34.9 19.5 40.8s34.9-2.9 40.8-19.5c7.7-21.8 20.2-42.3 37.8-59.8zM16 312v7.6 .7V440c0 9.7 5.8 18.5 14.8 22.2s19.3 1.7 26.2-5.2l41.6-41.6c87.6 86.5 228.7 86.2 315.8-1c24.4-24.4 42.1-53.1 52.9-83.7c5.9-16.7-2.9-34.9-19.5-40.8s-34.9 2.9-40.8 19.5c-7.7 21.8-20.2 42.3-37.8 59.8c-62.2 62.2-162.7 62.5-225.3 1L185 329c6.9-6.9 8.9-17.2 5.2-26.2s-12.5-14.8-22.2-14.8H48.4h-.7H40c-13.3 0-24 10.7-24 24z"
    ]
};
var $d8206b3ab2e65c05$export$2ff2056be8c281e4 = $d8206b3ab2e65c05$export$decde496a29c5b23;
var $d8206b3ab2e65c05$export$1025ad641edb49c2 = {
    prefix: "fas",
    iconName: "spinner",
    icon: [
        512,
        512,
        [],
        "f110",
        "M304 48a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zm0 416a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zM48 304a48 48 0 1 0 0-96 48 48 0 1 0 0 96zm464-48a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zM142.9 437A48 48 0 1 0 75 369.1 48 48 0 1 0 142.9 437zm0-294.2A48 48 0 1 0 75 75a48 48 0 1 0 67.9 67.9zM369.1 437A48 48 0 1 0 437 369.1 48 48 0 1 0 369.1 437z"
    ]
};
var $d8206b3ab2e65c05$export$30a5bb4ad3fa716c = {
    prefix: "fas",
    iconName: "robot",
    icon: [
        640,
        512,
        [
            129302
        ],
        "f544",
        "M320 0c17.7 0 32 14.3 32 32V96H472c39.8 0 72 32.2 72 72V440c0 39.8-32.2 72-72 72H168c-39.8 0-72-32.2-72-72V168c0-39.8 32.2-72 72-72H288V32c0-17.7 14.3-32 32-32zM208 384c-8.8 0-16 7.2-16 16s7.2 16 16 16h32c8.8 0 16-7.2 16-16s-7.2-16-16-16H208zm96 0c-8.8 0-16 7.2-16 16s7.2 16 16 16h32c8.8 0 16-7.2 16-16s-7.2-16-16-16H304zm96 0c-8.8 0-16 7.2-16 16s7.2 16 16 16h32c8.8 0 16-7.2 16-16s-7.2-16-16-16H400zM264 256a40 40 0 1 0 -80 0 40 40 0 1 0 80 0zm152 40a40 40 0 1 0 0-80 40 40 0 1 0 0 80zM48 224H64V416H48c-26.5 0-48-21.5-48-48V272c0-26.5 21.5-48 48-48zm544 0c26.5 0 48 21.5 48 48v96c0 26.5-21.5 48-48 48H576V224h16z"
    ]
};
var $d8206b3ab2e65c05$export$8614cb1326eacd7a = {
    prefix: "fas",
    iconName: "peace",
    icon: [
        512,
        512,
        [
            9774
        ],
        "f67c",
        "M224 445.3V323.5l-94.3 77.1c26.1 22.8 58.5 38.7 94.3 44.7zM89.2 351.1L224 240.8V66.7C133.2 81.9 64 160.9 64 256c0 34.6 9.2 67.1 25.2 95.1zm293.1 49.5L288 323.5V445.3c35.7-6 68.1-21.9 94.3-44.7zm40.6-49.5c16-28 25.2-60.5 25.2-95.1c0-95.1-69.2-174.1-160-189.3V240.8L422.8 351.1zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256z"
    ]
};
var $d8206b3ab2e65c05$export$4aac79b9ae3cfdb8 = {
    prefix: "fas",
    iconName: "gears",
    icon: [
        640,
        512,
        [
            "cogs"
        ],
        "f085",
        "M308.5 135.3c7.1-6.3 9.9-16.2 6.2-25c-2.3-5.3-4.8-10.5-7.6-15.5L304 89.4c-3-5-6.3-9.9-9.8-14.6c-5.7-7.6-15.7-10.1-24.7-7.1l-28.2 9.3c-10.7-8.8-23-16-36.2-20.9L199 27.1c-1.9-9.3-9.1-16.7-18.5-17.8C173.9 8.4 167.2 8 160.4 8h-.7c-6.8 0-13.5 .4-20.1 1.2c-9.4 1.1-16.6 8.6-18.5 17.8L115 56.1c-13.3 5-25.5 12.1-36.2 20.9L50.5 67.8c-9-3-19-.5-24.7 7.1c-3.5 4.7-6.8 9.6-9.9 14.6l-3 5.3c-2.8 5-5.3 10.2-7.6 15.6c-3.7 8.7-.9 18.6 6.2 25l22.2 19.8C32.6 161.9 32 168.9 32 176s.6 14.1 1.7 20.9L11.5 216.7c-7.1 6.3-9.9 16.2-6.2 25c2.3 5.3 4.8 10.5 7.6 15.6l3 5.2c3 5.1 6.3 9.9 9.9 14.6c5.7 7.6 15.7 10.1 24.7 7.1l28.2-9.3c10.7 8.8 23 16 36.2 20.9l6.1 29.1c1.9 9.3 9.1 16.7 18.5 17.8c6.7 .8 13.5 1.2 20.4 1.2s13.7-.4 20.4-1.2c9.4-1.1 16.6-8.6 18.5-17.8l6.1-29.1c13.3-5 25.5-12.1 36.2-20.9l28.2 9.3c9 3 19 .5 24.7-7.1c3.5-4.7 6.8-9.5 9.8-14.6l3.1-5.4c2.8-5 5.3-10.2 7.6-15.5c3.7-8.7 .9-18.6-6.2-25l-22.2-19.8c1.1-6.8 1.7-13.8 1.7-20.9s-.6-14.1-1.7-20.9l22.2-19.8zM112 176a48 48 0 1 1 96 0 48 48 0 1 1 -96 0zM504.7 500.5c6.3 7.1 16.2 9.9 25 6.2c5.3-2.3 10.5-4.8 15.5-7.6l5.4-3.1c5-3 9.9-6.3 14.6-9.8c7.6-5.7 10.1-15.7 7.1-24.7l-9.3-28.2c8.8-10.7 16-23 20.9-36.2l29.1-6.1c9.3-1.9 16.7-9.1 17.8-18.5c.8-6.7 1.2-13.5 1.2-20.4s-.4-13.7-1.2-20.4c-1.1-9.4-8.6-16.6-17.8-18.5L583.9 307c-5-13.3-12.1-25.5-20.9-36.2l9.3-28.2c3-9 .5-19-7.1-24.7c-4.7-3.5-9.6-6.8-14.6-9.9l-5.3-3c-5-2.8-10.2-5.3-15.6-7.6c-8.7-3.7-18.6-.9-25 6.2l-19.8 22.2c-6.8-1.1-13.8-1.7-20.9-1.7s-14.1 .6-20.9 1.7l-19.8-22.2c-6.3-7.1-16.2-9.9-25-6.2c-5.3 2.3-10.5 4.8-15.6 7.6l-5.2 3c-5.1 3-9.9 6.3-14.6 9.9c-7.6 5.7-10.1 15.7-7.1 24.7l9.3 28.2c-8.8 10.7-16 23-20.9 36.2L315.1 313c-9.3 1.9-16.7 9.1-17.8 18.5c-.8 6.7-1.2 13.5-1.2 20.4s.4 13.7 1.2 20.4c1.1 9.4 8.6 16.6 17.8 18.5l29.1 6.1c5 13.3 12.1 25.5 20.9 36.2l-9.3 28.2c-3 9-.5 19 7.1 24.7c4.7 3.5 9.5 6.8 14.6 9.8l5.4 3.1c5 2.8 10.2 5.3 15.5 7.6c8.7 3.7 18.6 .9 25-6.2l19.8-22.2c6.8 1.1 13.8 1.7 20.9 1.7s14.1-.6 20.9-1.7l19.8 22.2zM464 304a48 48 0 1 1 0 96 48 48 0 1 1 0-96z"
    ]
};
var $d8206b3ab2e65c05$export$af1575770afc9559 = $d8206b3ab2e65c05$export$4aac79b9ae3cfdb8;
var $d8206b3ab2e65c05$export$e3a174a50618c208 = {
    prefix: "fas",
    iconName: "warehouse",
    icon: [
        640,
        512,
        [],
        "f494",
        "M0 488V171.3c0-26.2 15.9-49.7 40.2-59.4L308.1 4.8c7.6-3.1 16.1-3.1 23.8 0L599.8 111.9c24.3 9.7 40.2 33.3 40.2 59.4V488c0 13.3-10.7 24-24 24H568c-13.3 0-24-10.7-24-24V224c0-17.7-14.3-32-32-32H128c-17.7 0-32 14.3-32 32V488c0 13.3-10.7 24-24 24H24c-13.3 0-24-10.7-24-24zm488 24l-336 0c-13.3 0-24-10.7-24-24V432H512l0 56c0 13.3-10.7 24-24 24zM128 400V336H512v64H128zm0-96V224H512l0 80H128z"
    ]
};
var $d8206b3ab2e65c05$export$bc804c6ab898f610 = {
    prefix: "fas",
    iconName: "arrow-up-right-dots",
    icon: [
        576,
        512,
        [],
        "e4b7",
        "M160 0c-17.7 0-32 14.3-32 32s14.3 32 32 32h50.7L9.4 265.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0L256 109.3V160c0 17.7 14.3 32 32 32s32-14.3 32-32V32c0-17.7-14.3-32-32-32H160zM576 80a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zM448 208a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zM400 384a48 48 0 1 0 0-96 48 48 0 1 0 0 96zm48 80a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zm128 0a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zM272 384a48 48 0 1 0 0-96 48 48 0 1 0 0 96zm48 80a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zM144 512a48 48 0 1 0 0-96 48 48 0 1 0 0 96zM576 336a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zm-48-80a48 48 0 1 0 0-96 48 48 0 1 0 0 96z"
    ]
};
var $d8206b3ab2e65c05$export$d6f21e17ea797702 = {
    prefix: "fas",
    iconName: "splotch",
    icon: [
        512,
        512,
        [],
        "f5bc",
        "M208.5 62.3l28.1-36.9C248.8 9.4 267.8 0 288 0c28.5 0 53.6 18.7 61.8 46l17.8 59.4c10.3 34.4 36.1 62 69.8 74.6l39.8 14.9c20.9 7.9 34.8 27.9 34.8 50.2c0 16.9-7.9 32.8-21.5 42.9l-67.3 50.5c-24.3 18.2-37.2 47.9-33.8 78.1l2.5 22.7c4.3 38.7-26 72.6-65 72.6c-14.8 0-29.3-5.1-40.8-14.3l-55.4-44.3c-4.5-3.6-9.3-6.7-14.5-9.2c-15.8-7.9-33.7-10.4-51-7.3L82.4 451.9C47.8 458.2 16 431.6 16 396.5c0-13.2 4.7-26 13.1-36.2l11.2-13.4c14.6-17.4 22.6-39.4 22.6-62.1c0-18.8-5.5-37.2-15.8-53L8.8 173.5C3.1 164.7 0 154.4 0 143.9c0-33.4 30.1-58.8 63-53.2l51.3 8.7c35.9 6.1 72.2-8.2 94.2-37.1z"
    ]
};
var $d8206b3ab2e65c05$export$fbb22081b65e4f33 = {
    prefix: "fas",
    iconName: "face-grin-hearts",
    icon: [
        512,
        512,
        [
            128525,
            "grin-hearts"
        ],
        "f584",
        "M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM388.1 312.8c12.3-3.8 24.3 6.9 19.3 18.7C382.4 390.6 324.2 432 256.3 432s-126.2-41.4-151.1-100.5c-5-11.8 7-22.5 19.3-18.7c39.7 12.2 84.5 19 131.8 19s92.1-6.8 131.8-19zM199.3 129.1c17.8 4.8 28.4 23.1 23.6 40.8l-17.4 65c-2.3 8.5-11.1 13.6-19.6 11.3l-65.1-17.4c-17.8-4.8-28.4-23.1-23.6-40.8s23.1-28.4 40.8-23.6l16.1 4.3 4.3-16.1c4.8-17.8 23.1-28.4 40.8-23.6zm154.3 23.6l4.3 16.1 16.1-4.3c17.8-4.8 36.1 5.8 40.8 23.6s-5.8 36.1-23.6 40.8l-65.1 17.4c-8.5 2.3-17.3-2.8-19.6-11.3l-17.4-65c-4.8-17.8 5.8-36.1 23.6-40.8s36.1 5.8 40.9 23.6z"
    ]
};
var $d8206b3ab2e65c05$export$c56cf0e0c3bc5ed2 = $d8206b3ab2e65c05$export$fbb22081b65e4f33;
var $d8206b3ab2e65c05$export$2df6451abf70a6ff = {
    prefix: "fas",
    iconName: "dice-four",
    icon: [
        448,
        512,
        [
            9859
        ],
        "f524",
        "M0 96C0 60.7 28.7 32 64 32H384c35.3 0 64 28.7 64 64V416c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96zm160 64a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zM128 384a32 32 0 1 0 0-64 32 32 0 1 0 0 64zM352 160a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zM320 384a32 32 0 1 0 0-64 32 32 0 1 0 0 64z"
    ]
};
var $d8206b3ab2e65c05$export$3bee83bf278fddbe = {
    prefix: "fas",
    iconName: "sim-card",
    icon: [
        384,
        512,
        [],
        "f7c4",
        "M64 0H242.7c17 0 33.3 6.7 45.3 18.7L365.3 96c12 12 18.7 28.3 18.7 45.3V448c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V64C0 28.7 28.7 0 64 0zM96 192c-17.7 0-32 14.3-32 32v32h64V192H96zM64 352h80 96 80V288H240 144 64v64zM320 224c0-17.7-14.3-32-32-32H256v64h64V224zM160 192v64h64V192H160zM288 448c17.7 0 32-14.3 32-32V384H256v64h32zM160 384v64h64V384H160zM64 416c0 17.7 14.3 32 32 32h32V384H64v32z"
    ]
};
var $d8206b3ab2e65c05$export$7e3f1701aa95ef01 = {
    prefix: "fas",
    iconName: "transgender",
    icon: [
        512,
        512,
        [
            9895,
            "transgender-alt"
        ],
        "f225",
        "M112 0c6.5 0 12.3 3.9 14.8 9.9s1.1 12.9-3.5 17.4l-31 31L112 78.1l7-7c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9l-7 7 15.2 15.2C187.7 107.6 220.5 96 256 96s68.3 11.6 94.9 31.2l68.8-68.8-31-31c-4.6-4.6-5.9-11.5-3.5-17.4s8.3-9.9 14.8-9.9h96c8.8 0 16 7.2 16 16v96c0 6.5-3.9 12.3-9.9 14.8s-12.9 1.1-17.4-3.5l-31-31-68.8 68.8C404.4 187.7 416 220.5 416 256c0 80.2-59 146.6-136 158.2V432h16c13.3 0 24 10.7 24 24s-10.7 24-24 24H280v8c0 13.3-10.7 24-24 24s-24-10.7-24-24v-8H216c-13.3 0-24-10.7-24-24s10.7-24 24-24h16V414.2C155 402.6 96 336.2 96 256c0-35.5 11.6-68.3 31.2-94.9L112 145.9l-7 7c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l7-7L58.3 92.3l-31 31c-4.6 4.6-11.5 5.9-17.4 3.5S0 118.5 0 112V16C0 7.2 7.2 0 16 0h96zM352 256a96 96 0 1 0 -192 0 96 96 0 1 0 192 0z"
    ]
};
var $d8206b3ab2e65c05$export$9c36cf9334c052f = $d8206b3ab2e65c05$export$7e3f1701aa95ef01;
var $d8206b3ab2e65c05$export$e134ecd00b622a47 = {
    prefix: "fas",
    iconName: "mercury",
    icon: [
        384,
        512,
        [
            9791
        ],
        "f223",
        "M72.1 7C85.8-4 106-1.8 117 12c17.6 22 44.7 36 75 36s57.3-14 75-36c11.1-13.8 31.2-16 45-5s16 31.2 5 45c-7.8 9.7-16.6 18.4-26.4 26.1C337.3 109.7 368 163.3 368 224c0 89.1-66.2 162.7-152 174.4V424h32c13.3 0 24 10.7 24 24s-10.7 24-24 24H216v16c0 13.3-10.7 24-24 24s-24-10.7-24-24V472H136c-13.3 0-24-10.7-24-24s10.7-24 24-24h32V398.4C82.2 386.7 16 313.1 16 224c0-60.7 30.7-114.3 77.5-145.9C83.7 70.5 74.9 61.7 67.1 52c-11.1-13.8-8.8-33.9 5-45zM80 224a112 112 0 1 0 224 0A112 112 0 1 0 80 224z"
    ]
};
var $d8206b3ab2e65c05$export$fd4d6cfd52703f50 = {
    prefix: "fas",
    iconName: "arrow-turn-down",
    icon: [
        384,
        512,
        [
            "level-down"
        ],
        "f149",
        "M32 64C14.3 64 0 49.7 0 32S14.3 0 32 0l96 0c53 0 96 43 96 96l0 306.7 73.4-73.4c12.5-12.5 32.8-12.5 45.3 0s12.5 32.8 0 45.3l-128 128c-12.5 12.5-32.8 12.5-45.3 0l-128-128c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0L160 402.7 160 96c0-17.7-14.3-32-32-32L32 64z"
    ]
};
var $d8206b3ab2e65c05$export$3794c07e7a666c94 = $d8206b3ab2e65c05$export$fd4d6cfd52703f50;
var $d8206b3ab2e65c05$export$a75569baaf4a6c3a = {
    prefix: "fas",
    iconName: "person-falling-burst",
    icon: [
        640,
        512,
        [],
        "e547",
        "M256 32c0-17.7-14.3-32-32-32s-32 14.3-32 32l0 9.8c0 39-23.7 74-59.9 88.4C71.6 154.5 32 213 32 278.2V352c0 17.7 14.3 32 32 32s32-14.3 32-32l0-73.8c0-10 1.6-19.8 4.5-29L261.1 497.4c9.6 14.8 29.4 19.1 44.3 9.5s19.1-29.4 9.5-44.3L222.6 320H224l80 0 38.4 51.2c10.6 14.1 30.7 17 44.8 6.4s17-30.7 6.4-44.8l-43.2-57.6C341.3 263.1 327.1 256 312 256l-71.5 0-56.8-80.2-.2-.3c44.7-29 72.5-79 72.5-133.6l0-9.8zM96 80A48 48 0 1 0 0 80a48 48 0 1 0 96 0zM464 286.1l58.6 53.9c4.8 4.4 11.9 5.5 17.8 2.6s9.5-9 9-15.5l-5.6-79.4 78.7-12.2c6.5-1 11.7-5.9 13.1-12.2s-1.1-13-6.5-16.7l-65.6-45.1L603 92.2c3.3-5.7 2.7-12.8-1.4-17.9s-10.9-7.2-17.2-5.3L508.3 92.1l-29.4-74C476.4 12 470.6 8 464 8s-12.4 4-14.9 10.1l-29.4 74L343.6 68.9c-6.3-1.9-13.1 .2-17.2 5.3s-4.6 12.2-1.4 17.9l39.5 69.1-65.6 45.1c-5.4 3.7-8 10.3-6.5 16.7c.1 .3 .1 .6 .2 .8l19.4 0c20.1 0 39.2 7.5 53.8 20.8l18.4 2.9L383 265.3l36.2 48.3c2.1 2.8 3.9 5.7 5.5 8.6L464 286.1z"
    ]
};
var $d8206b3ab2e65c05$export$f8db2747dadd48f7 = {
    prefix: "fas",
    iconName: "award",
    icon: [
        384,
        512,
        [],
        "f559",
        "M173.8 5.5c11-7.3 25.4-7.3 36.4 0L228 17.2c6 3.9 13 5.8 20.1 5.4l21.3-1.3c13.2-.8 25.6 6.4 31.5 18.2l9.6 19.1c3.2 6.4 8.4 11.5 14.7 14.7L344.5 83c11.8 5.9 19 18.3 18.2 31.5l-1.3 21.3c-.4 7.1 1.5 14.2 5.4 20.1l11.8 17.8c7.3 11 7.3 25.4 0 36.4L366.8 228c-3.9 6-5.8 13-5.4 20.1l1.3 21.3c.8 13.2-6.4 25.6-18.2 31.5l-19.1 9.6c-6.4 3.2-11.5 8.4-14.7 14.7L301 344.5c-5.9 11.8-18.3 19-31.5 18.2l-21.3-1.3c-7.1-.4-14.2 1.5-20.1 5.4l-17.8 11.8c-11 7.3-25.4 7.3-36.4 0L156 366.8c-6-3.9-13-5.8-20.1-5.4l-21.3 1.3c-13.2 .8-25.6-6.4-31.5-18.2l-9.6-19.1c-3.2-6.4-8.4-11.5-14.7-14.7L39.5 301c-11.8-5.9-19-18.3-18.2-31.5l1.3-21.3c.4-7.1-1.5-14.2-5.4-20.1L5.5 210.2c-7.3-11-7.3-25.4 0-36.4L17.2 156c3.9-6 5.8-13 5.4-20.1l-1.3-21.3c-.8-13.2 6.4-25.6 18.2-31.5l19.1-9.6C65 70.2 70.2 65 73.4 58.6L83 39.5c5.9-11.8 18.3-19 31.5-18.2l21.3 1.3c7.1 .4 14.2-1.5 20.1-5.4L173.8 5.5zM272 192a80 80 0 1 0 -160 0 80 80 0 1 0 160 0zM1.3 441.8L44.4 339.3c.2 .1 .3 .2 .4 .4l9.6 19.1c11.7 23.2 36 37.3 62 35.8l21.3-1.3c.2 0 .5 0 .7 .2l17.8 11.8c5.1 3.3 10.5 5.9 16.1 7.7l-37.6 89.3c-2.3 5.5-7.4 9.2-13.3 9.7s-11.6-2.2-14.8-7.2L74.4 455.5l-56.1 8.3c-5.7 .8-11.4-1.5-15-6s-4.3-10.7-2.1-16zm248 60.4L211.7 413c5.6-1.8 11-4.3 16.1-7.7l17.8-11.8c.2-.1 .4-.2 .7-.2l21.3 1.3c26 1.5 50.3-12.6 62-35.8l9.6-19.1c.1-.2 .2-.3 .4-.4l43.2 102.5c2.2 5.3 1.4 11.4-2.1 16s-9.3 6.9-15 6l-56.1-8.3-32.2 49.2c-3.2 5-8.9 7.7-14.8 7.2s-11-4.3-13.3-9.7z"
    ]
};
var $d8206b3ab2e65c05$export$68ddda3b30ba09f0 = {
    prefix: "fas",
    iconName: "ticket-simple",
    icon: [
        576,
        512,
        [
            "ticket-alt"
        ],
        "f3ff",
        "M0 128C0 92.7 28.7 64 64 64H512c35.3 0 64 28.7 64 64v64c0 8.8-7.4 15.7-15.7 18.6C541.5 217.1 528 235 528 256s13.5 38.9 32.3 45.4c8.3 2.9 15.7 9.8 15.7 18.6v64c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V320c0-8.8 7.4-15.7 15.7-18.6C34.5 294.9 48 277 48 256s-13.5-38.9-32.3-45.4C7.4 207.7 0 200.8 0 192V128z"
    ]
};
var $d8206b3ab2e65c05$export$75e38ba471fd89c4 = $d8206b3ab2e65c05$export$68ddda3b30ba09f0;
var $d8206b3ab2e65c05$export$f26673f8b10c3d46 = {
    prefix: "fas",
    iconName: "building",
    icon: [
        384,
        512,
        [
            127970,
            61687
        ],
        "f1ad",
        "M48 0C21.5 0 0 21.5 0 48V464c0 26.5 21.5 48 48 48h96V432c0-26.5 21.5-48 48-48s48 21.5 48 48v80h96c26.5 0 48-21.5 48-48V48c0-26.5-21.5-48-48-48H48zM64 240c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H80c-8.8 0-16-7.2-16-16V240zm112-16h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H176c-8.8 0-16-7.2-16-16V240c0-8.8 7.2-16 16-16zm80 16c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H272c-8.8 0-16-7.2-16-16V240zM80 96h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H80c-8.8 0-16-7.2-16-16V112c0-8.8 7.2-16 16-16zm80 16c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H176c-8.8 0-16-7.2-16-16V112zM272 96h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H272c-8.8 0-16-7.2-16-16V112c0-8.8 7.2-16 16-16z"
    ]
};
var $d8206b3ab2e65c05$export$2ebd565813951f81 = {
    prefix: "fas",
    iconName: "angles-left",
    icon: [
        512,
        512,
        [
            171,
            "angle-double-left"
        ],
        "f100",
        "M41.4 233.4c-12.5 12.5-12.5 32.8 0 45.3l160 160c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L109.3 256 246.6 118.6c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0l-160 160zm352-160l-160 160c-12.5 12.5-12.5 32.8 0 45.3l160 160c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L301.3 256 438.6 118.6c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0z"
    ]
};
var $d8206b3ab2e65c05$export$21b0833b3cf929a7 = $d8206b3ab2e65c05$export$2ebd565813951f81;
var $d8206b3ab2e65c05$export$fc19ca0fe15e73bc = {
    prefix: "fas",
    iconName: "qrcode",
    icon: [
        448,
        512,
        [],
        "f029",
        "M0 80C0 53.5 21.5 32 48 32h96c26.5 0 48 21.5 48 48v96c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V80zM64 96v64h64V96H64zM0 336c0-26.5 21.5-48 48-48h96c26.5 0 48 21.5 48 48v96c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V336zm64 16v64h64V352H64zM304 32h96c26.5 0 48 21.5 48 48v96c0 26.5-21.5 48-48 48H304c-26.5 0-48-21.5-48-48V80c0-26.5 21.5-48 48-48zm80 64H320v64h64V96zM256 304c0-8.8 7.2-16 16-16h64c8.8 0 16 7.2 16 16s7.2 16 16 16h32c8.8 0 16-7.2 16-16s7.2-16 16-16s16 7.2 16 16v96c0 8.8-7.2 16-16 16H368c-8.8 0-16-7.2-16-16s-7.2-16-16-16s-16 7.2-16 16v64c0 8.8-7.2 16-16 16H272c-8.8 0-16-7.2-16-16V304zM368 480a16 16 0 1 1 0-32 16 16 0 1 1 0 32zm64 0a16 16 0 1 1 0-32 16 16 0 1 1 0 32z"
    ]
};
var $d8206b3ab2e65c05$export$29be1665d1b36a3b = {
    prefix: "fas",
    iconName: "clock-rotate-left",
    icon: [
        512,
        512,
        [
            "history"
        ],
        "f1da",
        "M75 75L41 41C25.9 25.9 0 36.6 0 57.9V168c0 13.3 10.7 24 24 24H134.1c21.4 0 32.1-25.9 17-41l-30.8-30.8C155 85.5 203 64 256 64c106 0 192 86 192 192s-86 192-192 192c-40.8 0-78.6-12.7-109.7-34.4c-14.5-10.1-34.4-6.6-44.6 7.9s-6.6 34.4 7.9 44.6C151.2 495 201.7 512 256 512c141.4 0 256-114.6 256-256S397.4 0 256 0C185.3 0 121.3 28.7 75 75zm181 53c-13.3 0-24 10.7-24 24V256c0 6.4 2.5 12.5 7 17l72 72c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9l-65-65V152c0-13.3-10.7-24-24-24z"
    ]
};
var $d8206b3ab2e65c05$export$76d1986559ca7b7a = $d8206b3ab2e65c05$export$29be1665d1b36a3b;
var $d8206b3ab2e65c05$export$2ff38f330c834084 = {
    prefix: "fas",
    iconName: "face-grin-beam-sweat",
    icon: [
        512,
        512,
        [
            128517,
            "grin-beam-sweat"
        ],
        "f583",
        "M476.8 126.3c-4.1 1.1-8.4 1.7-12.8 1.7c-26.5 0-48-21-48-47c0-5 1.8-11.3 4.6-18.1c.3-.7 .6-1.4 .9-2.1c9-20.2 26.5-44.9 36-57.5c3.2-4.4 9.6-4.4 12.8 0C483.4 20.6 512 61 512 81c0 21.7-14.9 39.8-35.2 45.3zM256 0c51.4 0 99.3 15.2 139.4 41.2c-1.5 3.1-3 6.2-4.3 9.3c-3.4 8-7.1 19-7.1 30.5c0 44.3 36.6 79 80 79c9.6 0 18.8-1.7 27.4-4.8c13.3 30.9 20.6 65 20.6 100.8c0 141.4-114.6 256-256 256S0 397.4 0 256S114.6 0 256 0zM383.8 317.8C345.3 329.4 301.9 336 256 336s-89.3-6.6-127.8-18.2c-12.3-3.7-24.3 7-19.2 18.7c24.5 56.9 81.1 96.7 147 96.7s122.5-39.8 147-96.7c5.1-11.8-6.9-22.4-19.2-18.7zm-166.2-89l0 0 0 0c2.1 2.8 5.7 3.9 8.9 2.8s5.5-4.1 5.5-7.6c0-17.9-6.7-35.6-16.6-48.8c-9.8-13-23.9-23.2-39.4-23.2s-29.6 10.2-39.4 23.2C126.7 188.4 120 206.1 120 224c0 3.4 2.2 6.5 5.5 7.6s6.9 0 8.9-2.8l0 0 0 0 0 0 .2-.2c.2-.2 .4-.5 .7-.9c.6-.8 1.6-2 2.8-3.4c2.5-2.8 6-6.6 10.2-10.3c8.8-7.8 18.8-14 27.7-14s18.9 6.2 27.7 14c4.2 3.7 7.7 7.5 10.2 10.3c1.2 1.4 2.2 2.6 2.8 3.4c.3 .4 .6 .7 .7 .9l.2 .2 0 0 0 0zm160 0l0 0 0 0 0 0c2.1 2.8 5.7 3.9 8.9 2.8s5.5-4.1 5.5-7.6c0-17.9-6.7-35.6-16.6-48.8c-9.8-13-23.9-23.2-39.4-23.2s-29.6 10.2-39.4 23.2C286.7 188.4 280 206.1 280 224c0 3.4 2.2 6.5 5.5 7.6s6.9 0 8.9-2.8l0 0 0 0 0 0 .2-.2c.2-.2 .4-.5 .7-.9c.6-.8 1.6-2 2.8-3.4c2.5-2.8 6-6.6 10.2-10.3c8.8-7.8 18.8-14 27.7-14s18.9 6.2 27.7 14c4.2 3.7 7.7 7.5 10.2 10.3c1.2 1.4 2.2 2.6 2.8 3.4c.3 .4 .6 .7 .7 .9l.2 .2 0 0z"
    ]
};
var $d8206b3ab2e65c05$export$14d0ccc54c5b6826 = $d8206b3ab2e65c05$export$2ff38f330c834084;
var $d8206b3ab2e65c05$export$364f19abcfac1b0a = {
    prefix: "fas",
    iconName: "file-export",
    icon: [
        576,
        512,
        [
            "arrow-right-from-file"
        ],
        "f56e",
        "M0 64C0 28.7 28.7 0 64 0H224V128c0 17.7 14.3 32 32 32H384V288H216c-13.3 0-24 10.7-24 24s10.7 24 24 24H384V448c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V64zM384 336V288H494.1l-39-39c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l80 80c9.4 9.4 9.4 24.6 0 33.9l-80 80c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l39-39H384zm0-208H256V0L384 128z"
    ]
};
var $d8206b3ab2e65c05$export$b9c76255b38e1df1 = $d8206b3ab2e65c05$export$364f19abcfac1b0a;
var $d8206b3ab2e65c05$export$8241bd5b9163ca12 = {
    prefix: "fas",
    iconName: "shield",
    icon: [
        512,
        512,
        [
            128737,
            "shield-blank"
        ],
        "f132",
        "M256 0c4.6 0 9.2 1 13.4 2.9L457.7 82.8c22 9.3 38.4 31 38.3 57.2c-.5 99.2-41.3 280.7-213.6 363.2c-16.7 8-36.1 8-52.8 0C57.3 420.7 16.5 239.2 16 140c-.1-26.2 16.3-47.9 38.3-57.2L242.7 2.9C246.8 1 251.4 0 256 0z"
    ]
};
var $d8206b3ab2e65c05$export$64f54da8fbaba8ee = $d8206b3ab2e65c05$export$8241bd5b9163ca12;
var $d8206b3ab2e65c05$export$be9d5060a4bc3b4b = {
    prefix: "fas",
    iconName: "arrow-up-short-wide",
    icon: [
        576,
        512,
        [
            "sort-amount-up-alt"
        ],
        "f885",
        "M151.6 42.4C145.5 35.8 137 32 128 32s-17.5 3.8-23.6 10.4l-88 96c-11.9 13-11.1 33.3 2 45.2s33.3 11.1 45.2-2L96 146.3V448c0 17.7 14.3 32 32 32s32-14.3 32-32V146.3l32.4 35.4c11.9 13 32.2 13.9 45.2 2s13.9-32.2 2-45.2l-88-96zM320 32c-17.7 0-32 14.3-32 32s14.3 32 32 32h32c17.7 0 32-14.3 32-32s-14.3-32-32-32H320zm0 128c-17.7 0-32 14.3-32 32s14.3 32 32 32h96c17.7 0 32-14.3 32-32s-14.3-32-32-32H320zm0 128c-17.7 0-32 14.3-32 32s14.3 32 32 32H480c17.7 0 32-14.3 32-32s-14.3-32-32-32H320zm0 128c-17.7 0-32 14.3-32 32s14.3 32 32 32H544c17.7 0 32-14.3 32-32s-14.3-32-32-32H320z"
    ]
};
var $d8206b3ab2e65c05$export$6e87844b0f151b6a = $d8206b3ab2e65c05$export$be9d5060a4bc3b4b;
var $d8206b3ab2e65c05$export$2d077da983246a68 = {
    prefix: "fas",
    iconName: "house-medical",
    icon: [
        576,
        512,
        [],
        "e3b2",
        "M543.8 287.6c17 0 32-14 32-32.1c1-9-3-17-11-24L309.5 7c-6-5-14-7-21-7s-15 1-22 8L10 231.5c-7 7-10 15-10 24c0 18 14 32.1 32 32.1h32V448c0 35.3 28.7 64 64 64H448.5c35.5 0 64.2-28.8 64-64.3l-.7-160.2h32zM256 208c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v48h48c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H320v48c0 8.8-7.2 16-16 16H272c-8.8 0-16-7.2-16-16V320H208c-8.8 0-16-7.2-16-16V272c0-8.8 7.2-16 16-16h48V208z"
    ]
};
var $d8206b3ab2e65c05$export$14c9f1d85e53ae99 = {
    prefix: "fas",
    iconName: "golf-ball-tee",
    icon: [
        384,
        512,
        [
            "golf-ball"
        ],
        "f450",
        "M384 192c0 66.8-34.1 125.6-85.8 160H85.8C34.1 317.6 0 258.8 0 192C0 86 86 0 192 0S384 86 384 192zM242.1 256.6c0 18.5-15 33.5-33.5 33.5c-4.9 0-9.1 5.1-5.4 8.4c5.9 5.2 13.7 8.4 22.1 8.4c18.5 0 33.5-15 33.5-33.5c0-8.5-3.2-16.2-8.4-22.1c-3.3-3.7-8.4 .5-8.4 5.4zm-52.3-49.3c-4.9 0-9.1 5.1-5.4 8.4c5.9 5.2 13.7 8.4 22.1 8.4c18.5 0 33.5-15 33.5-33.5c0-8.5-3.2-16.2-8.4-22.1c-3.3-3.7-8.4 .5-8.4 5.4c0 18.5-15 33.5-33.5 33.5zm113.5-17.5c0 18.5-15 33.5-33.5 33.5c-4.9 0-9.1 5.1-5.4 8.4c5.9 5.2 13.7 8.4 22.1 8.4c18.5 0 33.5-15 33.5-33.5c0-8.5-3.2-16.2-8.4-22.1c-3.3-3.7-8.4 .5-8.4 5.4zM96 416c0-17.7 14.3-32 32-32h64 64c17.7 0 32 14.3 32 32s-14.3 32-32 32H240c-8.8 0-16 7.2-16 16v16c0 17.7-14.3 32-32 32s-32-14.3-32-32V464c0-8.8-7.2-16-16-16H128c-17.7 0-32-14.3-32-32z"
    ]
};
var $d8206b3ab2e65c05$export$2251487a9a33c682 = $d8206b3ab2e65c05$export$14c9f1d85e53ae99;
var $d8206b3ab2e65c05$export$f2b13ad44c03c40f = {
    prefix: "fas",
    iconName: "circle-chevron-left",
    icon: [
        512,
        512,
        [
            "chevron-circle-left"
        ],
        "f137",
        "M512 256A256 256 0 1 0 0 256a256 256 0 1 0 512 0zM271 135c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9l-87 87 87 87c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0L167 273c-9.4-9.4-9.4-24.6 0-33.9L271 135z"
    ]
};
var $d8206b3ab2e65c05$export$4a42c8c2451a33fd = $d8206b3ab2e65c05$export$f2b13ad44c03c40f;
var $d8206b3ab2e65c05$export$792391babe46862d = {
    prefix: "fas",
    iconName: "house-chimney-window",
    icon: [
        576,
        512,
        [],
        "e00d",
        "M575.8 255.5c0 18-15 32.1-32 32.1h-32l.7 160.2c.2 35.5-28.5 64.3-64 64.3H128.1c-35.3 0-64-28.7-64-64V287.6H32c-18 0-32-14-32-32.1c0-9 3-17 10-24L266.4 8c7-7 15-8 22-8s15 2 21 7L416 100.7V64c0-17.7 14.3-32 32-32h32c17.7 0 32 14.3 32 32V185l52.8 46.4c8 7 12 15 11 24zM248 192c-13.3 0-24 10.7-24 24v80c0 13.3 10.7 24 24 24h80c13.3 0 24-10.7 24-24V216c0-13.3-10.7-24-24-24H248z"
    ]
};
var $d8206b3ab2e65c05$export$a82594dcc75a49f5 = {
    prefix: "fas",
    iconName: "pen-nib",
    icon: [
        512,
        512,
        [
            10001
        ],
        "f5ad",
        "M368.4 18.3L312.7 74.1 437.9 199.3l55.7-55.7c21.9-21.9 21.9-57.3 0-79.2L447.6 18.3c-21.9-21.9-57.3-21.9-79.2 0zM288 94.6l-9.2 2.8L134.7 140.6c-19.9 6-35.7 21.2-42.3 41L3.8 445.8c-3.8 11.3-1 23.9 7.3 32.4L164.7 324.7c-3-6.3-4.7-13.3-4.7-20.7c0-26.5 21.5-48 48-48s48 21.5 48 48s-21.5 48-48 48c-7.4 0-14.4-1.7-20.7-4.7L33.7 500.9c8.6 8.3 21.1 11.2 32.4 7.3l264.3-88.6c19.7-6.6 35-22.4 41-42.3l43.2-144.1 2.8-9.2L288 94.6z"
    ]
};
var $d8206b3ab2e65c05$export$89af87b7d6c15adf = {
    prefix: "fas",
    iconName: "tent-arrow-turn-left",
    icon: [
        576,
        512,
        [],
        "e580",
        "M120.1 41.8c9.9-8.9 10.7-24 1.8-33.9S97.8-2.7 87.9 6.2l-80 72C2.9 82.7 0 89.2 0 96s2.9 13.3 7.9 17.8l80 72c9.9 8.9 25 8.1 33.9-1.8s8.1-25-1.8-33.9L86.5 120 456 120c39.8 0 72 32.2 72 72v40c0 13.3 10.7 24 24 24s24-10.7 24-24V192c0-66.3-53.7-120-120-120L86.5 72l33.5-30.2zM307.4 166.5c-11.5-8.7-27.3-8.7-38.8 0l-168 128c-6.6 5-11 12.5-12.3 20.7l-24 160c-1.4 9.2 1.3 18.6 7.4 25.6S86.7 512 96 512H288V352l96 160h96c9.3 0 18.2-4.1 24.2-11.1s8.8-16.4 7.4-25.6l-24-160c-1.2-8.2-5.6-15.7-12.3-20.7l-168-128z"
    ]
};
var $d8206b3ab2e65c05$export$c93b950e845a4ee7 = {
    prefix: "fas",
    iconName: "tents",
    icon: [
        640,
        512,
        [],
        "e582",
        "M396.6 6.5L235.8 129.1c9.6 1.8 18.9 5.8 27 12l168 128c13.2 10.1 22 24.9 24.5 41.4l6.2 41.5H608c9.3 0 18.2-4.1 24.2-11.1s8.8-16.4 7.4-25.6l-24-160c-1.2-8.2-5.6-15.7-12.3-20.7l-168-128c-11.5-8.7-27.3-8.7-38.8 0zm-153.2 160c-11.5-8.7-27.3-8.7-38.8 0l-168 128c-6.6 5-11 12.5-12.3 20.7l-24 160c-1.4 9.2 1.3 18.6 7.4 25.6S22.7 512 32 512H224V352l96 160h96c9.3 0 18.2-4.1 24.2-11.1s8.8-16.4 7.4-25.6l-24-160c-1.2-8.2-5.6-15.7-12.3-20.7l-168-128z"
    ]
};
var $d8206b3ab2e65c05$export$8282f5f5dcf6b009 = {
    prefix: "fas",
    iconName: "wand-magic",
    icon: [
        512,
        512,
        [
            "magic"
        ],
        "f0d0",
        "M14.1 463.3c-18.7-18.7-18.7-49.1 0-67.9L395.4 14.1c18.7-18.7 49.1-18.7 67.9 0l34.6 34.6c18.7 18.7 18.7 49.1 0 67.9L116.5 497.9c-18.7 18.7-49.1 18.7-67.9 0L14.1 463.3zM347.6 187.6l105-105L429.4 59.3l-105 105 23.3 23.3z"
    ]
};
var $d8206b3ab2e65c05$export$e58f9b502d4dd52d = $d8206b3ab2e65c05$export$8282f5f5dcf6b009;
var $d8206b3ab2e65c05$export$c6406747800cf702 = {
    prefix: "fas",
    iconName: "dog",
    icon: [
        576,
        512,
        [
            128021
        ],
        "f6d3",
        "M309.6 158.5L332.7 19.8C334.6 8.4 344.5 0 356.1 0c7.5 0 14.5 3.5 19 9.5L392 32h52.1c12.7 0 24.9 5.1 33.9 14.1L496 64h56c13.3 0 24 10.7 24 24v24c0 44.2-35.8 80-80 80H464 448 426.7l-5.1 30.5-112-64zM416 256.1L416 480c0 17.7-14.3 32-32 32H352c-17.7 0-32-14.3-32-32V364.8c-24 12.3-51.2 19.2-80 19.2s-56-6.9-80-19.2V480c0 17.7-14.3 32-32 32H96c-17.7 0-32-14.3-32-32V249.8c-28.8-10.9-51.4-35.3-59.2-66.5L1 167.8c-4.3-17.1 6.1-34.5 23.3-38.8s34.5 6.1 38.8 23.3l3.9 15.5C70.5 182 83.3 192 98 192h30 16H303.8L416 256.1zM464 80a16 16 0 1 0 -32 0 16 16 0 1 0 32 0z"
    ]
};
var $d8206b3ab2e65c05$export$28e93ec9f5e2ddf3 = {
    prefix: "fas",
    iconName: "carrot",
    icon: [
        512,
        512,
        [
            129365
        ],
        "f787",
        "M346.7 6C337.6 17 320 42.3 320 72c0 40 15.3 55.3 40 80s40 40 80 40c29.7 0 55-17.6 66-26.7c4-3.3 6-8.2 6-13.3s-2-10-6-13.2c-11.4-9.1-38.3-26.8-74-26.8c-32 0-40 8-40 8s8-8 8-40c0-35.7-17.7-62.6-26.8-74C370 2 365.1 0 360 0s-10 2-13.3 6zM244.6 136c-40 0-77.1 18.1-101.7 48.2l60.5 60.5c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0l-55.3-55.3 0 .1L2.2 477.9C-2 487-.1 497.8 7 505s17.9 9 27.1 4.8l134.7-62.4-52.1-52.1c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0L199.7 433l100.2-46.4c46.4-21.5 76.2-68 76.2-119.2C376 194.8 317.2 136 244.6 136z"
    ]
};
var $d8206b3ab2e65c05$export$c4c2f69a53bab720 = {
    prefix: "fas",
    iconName: "moon",
    icon: [
        384,
        512,
        [
            127769,
            9214
        ],
        "f186",
        "M223.5 32C100 32 0 132.3 0 256S100 480 223.5 480c60.6 0 115.5-24.2 155.8-63.4c5-4.9 6.3-12.5 3.1-18.7s-10.1-9.7-17-8.5c-9.8 1.7-19.8 2.6-30.1 2.6c-96.9 0-175.5-78.8-175.5-176c0-65.8 36-123.1 89.3-153.3c6.1-3.5 9.2-10.5 7.7-17.3s-7.3-11.9-14.3-12.5c-6.3-.5-12.6-.8-19-.8z"
    ]
};
var $d8206b3ab2e65c05$export$b86d7336e68a3f57 = {
    prefix: "fas",
    iconName: "wine-glass-empty",
    icon: [
        320,
        512,
        [
            "wine-glass-alt"
        ],
        "f5ce",
        "M64 0C47.4 0 33.5 12.8 32.1 29.3l-14 168.4c-6 72 42.5 135.2 109.9 150.6V448H80c-17.7 0-32 14.3-32 32s14.3 32 32 32h80 80c17.7 0 32-14.3 32-32s-14.3-32-32-32H192V348.4c67.4-15.4 115.9-78.6 109.9-150.6l-14-168.4C286.5 12.8 272.6 0 256 0H64zM81.9 203.1L93.4 64H226.6l11.6 139.1C242 248.8 205.9 288 160 288s-82-39.2-78.1-84.9z"
    ]
};
var $d8206b3ab2e65c05$export$b8ff3fe2b78aef2f = $d8206b3ab2e65c05$export$b86d7336e68a3f57;
var $d8206b3ab2e65c05$export$549b99473b7201e6 = {
    prefix: "fas",
    iconName: "cheese",
    icon: [
        512,
        512,
        [],
        "f7ef",
        "M512 240.2V256H0c0-20 10-38.7 26.6-49.8L274.9 40.7c8.6-5.7 18.6-8.7 28.9-8.7C418.8 32 512 125.2 512 240.2zm0 47.8V416c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V288H512z"
    ]
};
var $d8206b3ab2e65c05$export$6ec1acbf3f610b8f = {
    prefix: "fas",
    iconName: "yin-yang",
    icon: [
        512,
        512,
        [
            9775
        ],
        "f6ad",
        "M256 64c53 0 96 43 96 96s-43 96-96 96s-96 43-96 96s43 96 96 96C150 448 64 362 64 256S150 64 256 64zm0 448A256 256 0 1 0 256 0a256 256 0 1 0 0 512zm32-352a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zM224 352a32 32 0 1 1 64 0 32 32 0 1 1 -64 0z"
    ]
};
var $d8206b3ab2e65c05$export$fcb0647a5340b5b8 = {
    prefix: "fas",
    iconName: "music",
    icon: [
        512,
        512,
        [
            127925
        ],
        "f001",
        "M499.1 6.3c8.1 6 12.9 15.6 12.9 25.7v72V368c0 44.2-43 80-96 80s-96-35.8-96-80s43-80 96-80c11.2 0 22 1.6 32 4.6V147L192 223.8V432c0 44.2-43 80-96 80s-96-35.8-96-80s43-80 96-80c11.2 0 22 1.6 32 4.6V200 128c0-14.1 9.3-26.6 22.8-30.7l320-96c9.7-2.9 20.2-1.1 28.3 5z"
    ]
};
var $d8206b3ab2e65c05$export$d5d870c10bc9f1ce = {
    prefix: "fas",
    iconName: "code-commit",
    icon: [
        640,
        512,
        [],
        "f386",
        "M320 336a80 80 0 1 0 0-160 80 80 0 1 0 0 160zm156.8-48C462 361 397.4 416 320 416s-142-55-156.8-128H32c-17.7 0-32-14.3-32-32s14.3-32 32-32H163.2C178 151 242.6 96 320 96s142 55 156.8 128H608c17.7 0 32 14.3 32 32s-14.3 32-32 32H476.8z"
    ]
};
var $d8206b3ab2e65c05$export$9e9af12b90a1abd2 = {
    prefix: "fas",
    iconName: "temperature-low",
    icon: [
        512,
        512,
        [],
        "f76b",
        "M448 96a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zM320 96a96 96 0 1 1 192 0A96 96 0 1 1 320 96zM144 64c-26.5 0-48 21.5-48 48V276.5c0 17.3-7.1 31.9-15.3 42.5C70.2 332.6 64 349.5 64 368c0 44.2 35.8 80 80 80s80-35.8 80-80c0-18.5-6.2-35.4-16.7-48.9c-8.2-10.6-15.3-25.2-15.3-42.5V112c0-26.5-21.5-48-48-48zM32 112C32 50.2 82.1 0 144 0s112 50.1 112 112V276.5c0 .1 .1 .3 .2 .6c.2 .6 .8 1.6 1.7 2.8c18.9 24.4 30.1 55 30.1 88.1c0 79.5-64.5 144-144 144S0 447.5 0 368c0-33.2 11.2-63.8 30.1-88.1c.9-1.2 1.5-2.2 1.7-2.8c.1-.3 .2-.5 .2-.6V112zM192 368c0 26.5-21.5 48-48 48s-48-21.5-48-48c0-20.9 13.4-38.7 32-45.3V272c0-8.8 7.2-16 16-16s16 7.2 16 16v50.7c18.6 6.6 32 24.4 32 45.3z"
    ]
};
var $d8206b3ab2e65c05$export$cf152282d5de300d = {
    prefix: "fas",
    iconName: "person-biking",
    icon: [
        640,
        512,
        [
            128692,
            "biking"
        ],
        "f84a",
        "M400 96a48 48 0 1 0 0-96 48 48 0 1 0 0 96zm27.2 64l-61.8-48.8c-17.3-13.6-41.7-13.8-59.1-.3l-83.1 64.2c-30.7 23.8-28.5 70.8 4.3 91.6L288 305.1V416c0 17.7 14.3 32 32 32s32-14.3 32-32V288c0-10.7-5.3-20.7-14.2-26.6L295 232.9l60.3-48.5L396 217c5.7 4.5 12.7 7 20 7h64c17.7 0 32-14.3 32-32s-14.3-32-32-32H427.2zM56 384a72 72 0 1 1 144 0A72 72 0 1 1 56 384zm200 0A128 128 0 1 0 0 384a128 128 0 1 0 256 0zm184 0a72 72 0 1 1 144 0 72 72 0 1 1 -144 0zm200 0a128 128 0 1 0 -256 0 128 128 0 1 0 256 0z"
    ]
};
var $d8206b3ab2e65c05$export$a5bcf835dbf9c0b = $d8206b3ab2e65c05$export$cf152282d5de300d;
var $d8206b3ab2e65c05$export$2a533051418ff4ca = {
    prefix: "fas",
    iconName: "broom",
    icon: [
        576,
        512,
        [
            129529
        ],
        "f51a",
        "M566.6 54.6c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0l-192 192-34.7-34.7c-4.2-4.2-10-6.6-16-6.6c-12.5 0-22.6 10.1-22.6 22.6v29.1L364.3 320h29.1c12.5 0 22.6-10.1 22.6-22.6c0-6-2.4-11.8-6.6-16l-34.7-34.7 192-192zM341.1 353.4L222.6 234.9c-42.7-3.7-85.2 11.7-115.8 42.3l-8 8C76.5 307.5 64 337.7 64 369.2c0 6.8 7.1 11.2 13.2 8.2l51.1-25.5c5-2.5 9.5 4.1 5.4 7.9L7.3 473.4C2.7 477.6 0 483.6 0 489.9C0 502.1 9.9 512 22.1 512l173.3 0c38.8 0 75.9-15.4 103.4-42.8c30.6-30.6 45.9-73.1 42.3-115.8z"
    ]
};
var $d8206b3ab2e65c05$export$7b96388ca2be471b = {
    prefix: "fas",
    iconName: "shield-heart",
    icon: [
        512,
        512,
        [],
        "e574",
        "M269.4 2.9C265.2 1 260.7 0 256 0s-9.2 1-13.4 2.9L54.3 82.8c-22 9.3-38.4 31-38.3 57.2c.5 99.2 41.3 280.7 213.6 363.2c16.7 8 36.1 8 52.8 0C454.7 420.7 495.5 239.2 496 140c.1-26.2-16.3-47.9-38.3-57.2L269.4 2.9zM144 221.3c0-33.8 27.4-61.3 61.3-61.3c16.2 0 31.8 6.5 43.3 17.9l7.4 7.4 7.4-7.4c11.5-11.5 27.1-17.9 43.3-17.9c33.8 0 61.3 27.4 61.3 61.3c0 16.2-6.5 31.8-17.9 43.3l-82.7 82.7c-6.2 6.2-16.4 6.2-22.6 0l-82.7-82.7c-11.5-11.5-17.9-27.1-17.9-43.3z"
    ]
};
var $d8206b3ab2e65c05$export$31f89d8ac1d14ed6 = {
    prefix: "fas",
    iconName: "gopuram",
    icon: [
        512,
        512,
        [],
        "f664",
        "M120 0c13.3 0 24 10.7 24 24v8h40V24c0-13.3 10.7-24 24-24s24 10.7 24 24v8h48V24c0-13.3 10.7-24 24-24s24 10.7 24 24v8h40V24c0-13.3 10.7-24 24-24s24 10.7 24 24v8V64v64c17.7 0 32 14.3 32 32v64c17.7 0 32 14.3 32 32v96c17.7 0 32 14.3 32 32v96c0 17.7-14.3 32-32 32H416V352H384V224H352V128H320v96h32V352h32V512H304V464c0-26.5-21.5-48-48-48s-48 21.5-48 48v48H128V352h32V224h32V128H160v96H128V352H96V512H32c-17.7 0-32-14.3-32-32V384c0-17.7 14.3-32 32-32V256c0-17.7 14.3-32 32-32V160c0-17.7 14.3-32 32-32V64 32 24c0-13.3 10.7-24 24-24zM256 272c-17.7 0-32 14.3-32 32v48h64V304c0-17.7-14.3-32-32-32zm-32-80v32h64V192c0-17.7-14.3-32-32-32s-32 14.3-32 32z"
    ]
};
var $d8206b3ab2e65c05$export$bd931e906edf2f47 = {
    prefix: "fas",
    iconName: "earth-oceania",
    icon: [
        512,
        512,
        [
            "globe-oceania"
        ],
        "e47b",
        "M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM208.6 357.3l-39-13.5c-6.5-2.2-13.6-2.3-20.1-.3l-15.3 4.9c-18.5 5.9-38.5-2.4-47.5-19.5l-3.3-6.2c-10.6-20.1-2.3-45 18.2-54.7l35.3-16.8c2.3-1.1 4.4-2.8 5.9-4.8l5.3-7c7.2-9.6 18.6-15.3 30.6-15.3s23.4 5.7 30.6 15.3l4.6 6.1c2 2.6 4.9 4.5 8.1 5.1c7.8 1.6 15.7-1.5 20.4-7.9l10.4-14.2c2-2.8 5.3-4.4 8.7-4.4c4.4 0 8.4 2.7 10 6.8l10.1 25.9c2.8 7.2 6.7 14 11.5 20.2L311 299.8c5.8 7.4 9 16.6 9 26s-3.2 18.6-9 26L299 367.2c-8.3 10.6-21 16.8-34.4 16.8c-8.4 0-16.6-2.4-23.7-7l-25.4-16.4c-2.2-1.4-4.5-2.5-6.9-3.4zm65.2-214.8L296 164.7c10.1 10.1 2.9 27.3-11.3 27.3H254.8c-5.6 0-11.1-1.2-16.2-3.4l-42.8-19c-14.3-6.3-11.9-27.3 3.4-30.3l38.5-7.7c13.1-2.6 26.7 1.5 36.1 10.9zM248 432c0-8.8 7.2-16 16-16h16c8.8 0 16 7.2 16 16s-7.2 16-16 16H264c-8.8 0-16-7.2-16-16zM431.2 298.9l8 24c2.8 8.4-1.7 17.4-10.1 20.2s-17.4-1.7-20.2-10.1l-8-24c-2.8-8.4 1.7-17.4 10.1-20.2s17.4 1.7 20.2 10.1zm-19.9 80.4l-32 32c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6l32-32c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6z"
    ]
};
var $d8206b3ab2e65c05$export$8ac3f5271448657d = $d8206b3ab2e65c05$export$bd931e906edf2f47;
var $d8206b3ab2e65c05$export$5a17e58bb7afb1d7 = {
    prefix: "fas",
    iconName: "square-xmark",
    icon: [
        448,
        512,
        [
            10062,
            "times-square",
            "xmark-square"
        ],
        "f2d3",
        "M64 32C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64zm79 143c9.4-9.4 24.6-9.4 33.9 0l47 47 47-47c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9l-47 47 47 47c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0l-47-47-47 47c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l47-47-47-47c-9.4-9.4-9.4-24.6 0-33.9z"
    ]
};
var $d8206b3ab2e65c05$export$c0248ac97142ea2a = $d8206b3ab2e65c05$export$5a17e58bb7afb1d7;
var $d8206b3ab2e65c05$export$9a364781d6b7602b = $d8206b3ab2e65c05$export$5a17e58bb7afb1d7;
var $d8206b3ab2e65c05$export$c92c903bade56844 = {
    prefix: "fas",
    iconName: "hashtag",
    icon: [
        448,
        512,
        [
            62098
        ],
        "23",
        "M181.3 32.4c17.4 2.9 29.2 19.4 26.3 36.8L197.8 128h95.1l11.5-69.3c2.9-17.4 19.4-29.2 36.8-26.3s29.2 19.4 26.3 36.8L357.8 128H416c17.7 0 32 14.3 32 32s-14.3 32-32 32H347.1L325.8 320H384c17.7 0 32 14.3 32 32s-14.3 32-32 32H315.1l-11.5 69.3c-2.9 17.4-19.4 29.2-36.8 26.3s-29.2-19.4-26.3-36.8l9.8-58.7H155.1l-11.5 69.3c-2.9 17.4-19.4 29.2-36.8 26.3s-29.2-19.4-26.3-36.8L90.2 384H32c-17.7 0-32-14.3-32-32s14.3-32 32-32h68.9l21.3-128H64c-17.7 0-32-14.3-32-32s14.3-32 32-32h68.9l11.5-69.3c2.9-17.4 19.4-29.2 36.8-26.3zM187.1 192L165.8 320h95.1l21.3-128H187.1z"
    ]
};
var $d8206b3ab2e65c05$export$95457ede07b81517 = {
    prefix: "fas",
    iconName: "up-right-and-down-left-from-center",
    icon: [
        512,
        512,
        [
            "expand-alt"
        ],
        "f424",
        "M344 0H488c13.3 0 24 10.7 24 24V168c0 9.7-5.8 18.5-14.8 22.2s-19.3 1.7-26.2-5.2l-39-39-87 87c-9.4 9.4-24.6 9.4-33.9 0l-32-32c-9.4-9.4-9.4-24.6 0-33.9l87-87L327 41c-6.9-6.9-8.9-17.2-5.2-26.2S334.3 0 344 0zM168 512H24c-13.3 0-24-10.7-24-24V344c0-9.7 5.8-18.5 14.8-22.2s19.3-1.7 26.2 5.2l39 39 87-87c9.4-9.4 24.6-9.4 33.9 0l32 32c9.4 9.4 9.4 24.6 0 33.9l-87 87 39 39c6.9 6.9 8.9 17.2 5.2 26.2s-12.5 14.8-22.2 14.8z"
    ]
};
var $d8206b3ab2e65c05$export$bcb8d86a3a1d6eb6 = $d8206b3ab2e65c05$export$95457ede07b81517;
var $d8206b3ab2e65c05$export$2599126c3a57f727 = {
    prefix: "fas",
    iconName: "oil-can",
    icon: [
        640,
        512,
        [],
        "f613",
        "M320 128c17.7 0 32-14.3 32-32s-14.3-32-32-32H192c-17.7 0-32 14.3-32 32s14.3 32 32 32h32v32H144 96 48c-26.5 0-48 21.5-48 48v64.8c0 19 11.2 36.2 28.5 43.9l67.5 30V368c0 26.5 21.5 48 48 48H403.1c18.4 0 35.8-7.9 48-21.7L633.5 187.7c12.3-13.9-.3-35.4-18.4-31.5L448 192l-50.5-25.2c-8.9-4.4-18.7-6.8-28.6-6.8H288V128h32zM96 208v86.1L48 272.8V208H96z"
    ]
};
var $d8206b3ab2e65c05$export$6e625d2e7790c860 = {
    prefix: "fas",
    iconName: "t",
    icon: [
        384,
        512,
        [
            116
        ],
        "54",
        "M32 32C14.3 32 0 46.3 0 64S14.3 96 32 96H160V448c0 17.7 14.3 32 32 32s32-14.3 32-32V96H352c17.7 0 32-14.3 32-32s-14.3-32-32-32H192 32z"
    ]
};
var $d8206b3ab2e65c05$export$d4c909619093de2d = {
    prefix: "fas",
    iconName: "hippo",
    icon: [
        640,
        512,
        [
            129435
        ],
        "f6ed",
        "M407 47c9.4-9.4 24.6-9.4 33.9 0l17.2 17.2c1.9-.1 3.9-.2 5.8-.2h32c11.2 0 21.9 2.3 31.6 6.5L543 55c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9L564 101.9c7.6 12.2 12 26.7 12 42.1c0 10.2 7.4 18.8 16.7 23c27.9 12.5 47.3 40.5 47.3 73c0 26.2-12.6 49.4-32 64v32c0 8.8-7.2 16-16 16H560c-8.8 0-16-7.2-16-16V320H480v16c0 8.8-7.2 16-16 16H432c-8.8 0-16-7.2-16-16V318.4c-11.8-2.4-22.7-7.4-32-14.4c-1.5-1.1-2.9-2.3-4.3-3.5c-17-14.7-27.7-36.4-27.7-60.5c0-8.8-7.2-16-16-16s-16 7.2-16 16c0 44.7 26.2 83.2 64 101.2V352c0 17.7 14.3 32 32 32h32v64c0 17.7-14.3 32-32 32H352c-17.7 0-32-14.3-32-32V372c-19.8 7.7-41.4 12-64 12s-44.2-4.3-64-12v76c0 17.7-14.3 32-32 32H96c-17.7 0-32-14.3-32-32V329.1L45.9 369.7c-5.4 12.1-19.6 17.6-31.7 12.2S-3.3 362.4 2.1 350.3L24 300.9c5.3-11.9 8-24.7 8-37.7C32 155.7 117.2 68 223.8 64.1l.2-.1h7.2H256h32c41.7 0 83.4 12.1 117.2 25.7c1.7-1.8 3.5-3.6 5.3-5.2L407 81c-9.4-9.4-9.4-24.6 0-33.9zm73 185a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zm88 24a24 24 0 1 0 0-48 24 24 0 1 0 0 48zM480 144a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zm48 16a16 16 0 1 0 0-32 16 16 0 1 0 0 32z"
    ]
};
var $d8206b3ab2e65c05$export$d01ddcc9efe7b149 = {
    prefix: "fas",
    iconName: "chart-column",
    icon: [
        512,
        512,
        [],
        "e0e3",
        "M32 32c17.7 0 32 14.3 32 32V400c0 8.8 7.2 16 16 16H480c17.7 0 32 14.3 32 32s-14.3 32-32 32H80c-44.2 0-80-35.8-80-80V64C0 46.3 14.3 32 32 32zM160 224c17.7 0 32 14.3 32 32v64c0 17.7-14.3 32-32 32s-32-14.3-32-32V256c0-17.7 14.3-32 32-32zm128-64V320c0 17.7-14.3 32-32 32s-32-14.3-32-32V160c0-17.7 14.3-32 32-32s32 14.3 32 32zm64 32c17.7 0 32 14.3 32 32v96c0 17.7-14.3 32-32 32s-32-14.3-32-32V224c0-17.7 14.3-32 32-32zM480 96V320c0 17.7-14.3 32-32 32s-32-14.3-32-32V96c0-17.7 14.3-32 32-32s32 14.3 32 32z"
    ]
};
var $d8206b3ab2e65c05$export$a590003279d671b8 = {
    prefix: "fas",
    iconName: "infinity",
    icon: [
        640,
        512,
        [
            8734,
            9854
        ],
        "f534",
        "M0 241.1C0 161 65 96 145.1 96c38.5 0 75.4 15.3 102.6 42.5L320 210.7l72.2-72.2C419.5 111.3 456.4 96 494.9 96C575 96 640 161 640 241.1v29.7C640 351 575 416 494.9 416c-38.5 0-75.4-15.3-102.6-42.5L320 301.3l-72.2 72.2C220.5 400.7 183.6 416 145.1 416C65 416 0 351 0 270.9V241.1zM274.7 256l-72.2-72.2c-15.2-15.2-35.9-23.8-57.4-23.8C100.3 160 64 196.3 64 241.1v29.7c0 44.8 36.3 81.1 81.1 81.1c21.5 0 42.2-8.5 57.4-23.8L274.7 256zm90.5 0l72.2 72.2c15.2 15.2 35.9 23.8 57.4 23.8c44.8 0 81.1-36.3 81.1-81.1V241.1c0-44.8-36.3-81.1-81.1-81.1c-21.5 0-42.2 8.5-57.4 23.8L365.3 256z"
    ]
};
var $d8206b3ab2e65c05$export$2db4f9712313eafa = {
    prefix: "fas",
    iconName: "vial-circle-check",
    icon: [
        512,
        512,
        [],
        "e596",
        "M0 64C0 46.3 14.3 32 32 32H96h64 64c17.7 0 32 14.3 32 32s-14.3 32-32 32V266.8c-20.2 28.6-32 63.5-32 101.2c0 25.2 5.3 49.1 14.8 70.8C189.5 463.7 160.6 480 128 480c-53 0-96-43-96-96V96C14.3 96 0 81.7 0 64zM96 96v96h64V96H96zM224 368a144 144 0 1 1 288 0 144 144 0 1 1 -288 0zm211.3-43.3c-6.2-6.2-16.4-6.2-22.6 0L352 385.4l-28.7-28.7c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6l40 40c6.2 6.2 16.4 6.2 22.6 0l72-72c6.2-6.2 6.2-16.4 0-22.6z"
    ]
};
var $d8206b3ab2e65c05$export$f9a5161975928326 = {
    prefix: "fas",
    iconName: "person-arrow-down-to-line",
    icon: [
        640,
        512,
        [],
        "e538",
        "M192 96a48 48 0 1 0 0-96 48 48 0 1 0 0 96zm-8 352V352h16v96H184zm-64 0H32c-17.7 0-32 14.3-32 32s14.3 32 32 32H152h80H608c17.7 0 32-14.3 32-32s-14.3-32-32-32H264V256.9l28.6 47.5c9.1 15.1 28.8 20 43.9 10.9s20-28.8 10.9-43.9l-58.3-97c-17.4-28.9-48.6-46.6-82.3-46.6H177.1c-33.7 0-64.9 17.7-82.3 46.6l-58.3 97c-9.1 15.1-4.2 34.8 10.9 43.9s34.8 4.2 43.9-10.9L120 256.9V448zM464 64V306.7l-25.4-25.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3l80 80c12.5 12.5 32.8 12.5 45.3 0l80-80c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L528 306.7V64c0-17.7-14.3-32-32-32s-32 14.3-32 32z"
    ]
};
var $d8206b3ab2e65c05$export$4f1ce88b2b4cd5cd = {
    prefix: "fas",
    iconName: "voicemail",
    icon: [
        640,
        512,
        [],
        "f897",
        "M144 320a80 80 0 1 1 0-160 80 80 0 1 1 0 160zm119.8 0c15.3-22.9 24.2-50.4 24.2-80c0-79.5-64.5-144-144-144S0 160.5 0 240s64.5 144 144 144H496c79.5 0 144-64.5 144-144s-64.5-144-144-144s-144 64.5-144 144c0 29.6 8.9 57.1 24.2 80H263.8zM496 160a80 80 0 1 1 0 160 80 80 0 1 1 0-160z"
    ]
};
var $d8206b3ab2e65c05$export$55145a3dae4f984a = {
    prefix: "fas",
    iconName: "fan",
    icon: [
        512,
        512,
        [],
        "f863",
        "M258.6 0c-1.7 0-3.4 .1-5.1 .5C168 17 115.6 102.3 130.5 189.3c2.9 17 8.4 32.9 15.9 47.4L32 224H29.4C13.2 224 0 237.2 0 253.4c0 1.7 .1 3.4 .5 5.1C17 344 102.3 396.4 189.3 381.5c17-2.9 32.9-8.4 47.4-15.9L224 480v2.6c0 16.2 13.2 29.4 29.4 29.4c1.7 0 3.4-.1 5.1-.5C344 495 396.4 409.7 381.5 322.7c-2.9-17-8.4-32.9-15.9-47.4L480 288h2.6c16.2 0 29.4-13.2 29.4-29.4c0-1.7-.1-3.4-.5-5.1C495 168 409.7 115.6 322.7 130.5c-17 2.9-32.9 8.4-47.4 15.9L288 32V29.4C288 13.2 274.8 0 258.6 0zM256 224a32 32 0 1 1 0 64 32 32 0 1 1 0-64z"
    ]
};
var $d8206b3ab2e65c05$export$1ae0a37b36ace746 = {
    prefix: "fas",
    iconName: "person-walking-luggage",
    icon: [
        576,
        512,
        [],
        "e554",
        "M432 96a48 48 0 1 0 0-96 48 48 0 1 0 0 96zM347.7 200.5c1-.4 1.9-.8 2.9-1.2l-16.9 63.5c-5.6 21.1-.1 43.6 14.7 59.7l70.7 77.1 22 88.1c4.3 17.1 21.7 27.6 38.8 23.3s27.6-21.7 23.3-38.8l-23-92.1c-1.9-7.8-5.8-14.9-11.2-20.8l-49.5-54 19.3-65.5 9.6 23c4.4 10.6 12.5 19.3 22.8 24.5l26.7 13.3c15.8 7.9 35 1.5 42.9-14.3s1.5-35-14.3-42.9L505 232.7l-15.3-36.8C472.5 154.8 432.3 128 387.7 128c-22.8 0-45.3 4.8-66.1 14l-8 3.5c-32.9 14.6-58.1 42.4-69.4 76.5l-2.6 7.8c-5.6 16.8 3.5 34.9 20.2 40.5s34.9-3.5 40.5-20.2l2.6-7.8c5.7-17.1 18.3-30.9 34.7-38.2l8-3.5zm-30 135.1l-25 62.4-59.4 59.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0L340.3 441c4.6-4.6 8.2-10.1 10.6-16.1l14.5-36.2-40.7-44.4c-2.5-2.7-4.8-5.6-7-8.6zM256 274.1c-7.7-4.4-17.4-1.8-21.9 5.9l-32 55.4L147.7 304c-15.3-8.8-34.9-3.6-43.7 11.7L40 426.6c-8.8 15.3-3.6 34.9 11.7 43.7l55.4 32c15.3 8.8 34.9 3.6 43.7-11.7l64-110.9c1.5-2.6 2.6-5.2 3.3-8L261.9 296c4.4-7.7 1.8-17.4-5.9-21.9z"
    ]
};
var $d8206b3ab2e65c05$export$e36c32dd5cba9b90 = {
    prefix: "fas",
    iconName: "up-down",
    icon: [
        256,
        512,
        [
            8597,
            11021,
            "arrows-alt-v"
        ],
        "f338",
        "M145.6 7.7C141 2.8 134.7 0 128 0s-13 2.8-17.6 7.7l-104 112c-6.5 7-8.2 17.2-4.4 25.9S14.5 160 24 160H80V352H24c-9.5 0-18.2 5.7-22 14.4s-2.1 18.9 4.4 25.9l104 112c4.5 4.9 10.9 7.7 17.6 7.7s13-2.8 17.6-7.7l104-112c6.5-7 8.2-17.2 4.4-25.9s-12.5-14.4-22-14.4H176V160h56c9.5 0 18.2-5.7 22-14.4s2.1-18.9-4.4-25.9l-104-112z"
    ]
};
var $d8206b3ab2e65c05$export$138cb56a3f8f7040 = $d8206b3ab2e65c05$export$e36c32dd5cba9b90;
var $d8206b3ab2e65c05$export$301c3fab0c4545bd = {
    prefix: "fas",
    iconName: "cloud-moon-rain",
    icon: [
        576,
        512,
        [],
        "f73c",
        "M481.2 0C417 0 363.5 46.5 353.7 107.6c35.4 17.6 60.2 53.3 62.1 95.1c23.2 11 42 29.7 53.1 52.7c4 .4 8.1 .6 12.3 .6c34.9 0 66.7-13.8 89.9-36.1c5.1-4.9 6.4-12.5 3.2-18.7s-10.1-9.7-17-8.6c-4.9 .8-10 1.3-15.2 1.3c-49 0-88.4-39.3-88.4-87.4c0-32.6 18-61.1 44.9-76.1c6.1-3.4 9.3-10.5 7.8-17.4s-7.3-12-14.3-12.6c-3.6-.3-7.3-.5-10.9-.5zM367.9 383.9c44.2 0 80-35.8 80-80c0-39.3-28.4-72.1-65.8-78.7c1.2-5.6 1.9-11.3 1.9-17.2c0-44.2-35.8-80-80-80c-17 0-32.8 5.3-45.8 14.4C241.3 114.6 210.8 96 176 96c-53 0-96 43-96 96l0 1.3c-45.4 7.6-80 47.1-80 94.6c0 53 43 96 96 96H367.9zM85.4 420.1c-11-7.4-25.9-4.4-33.3 6.7l-32 48c-7.4 11-4.4 25.9 6.7 33.3s25.9 4.4 33.3-6.7l32-48c7.4-11 4.4-25.9-6.7-33.3zm96 0c-11-7.4-25.9-4.4-33.3 6.7l-32 48c-7.4 11-4.4 25.9 6.7 33.3s25.9 4.4 33.3-6.7l32-48c7.4-11 4.4-25.9-6.7-33.3zm96 0c-11-7.4-25.9-4.4-33.3 6.7l-32 48c-7.4 11-4.4 25.9 6.7 33.3s25.9 4.4 33.3-6.7l32-48c7.4-11 4.4-25.9-6.7-33.3zm96 0c-11-7.4-25.9-4.4-33.3 6.7l-32 48c-7.4 11-4.4 25.9 6.7 33.3s25.9 4.4 33.3-6.7l32-48c7.4-11 4.4-25.9-6.7-33.3z"
    ]
};
var $d8206b3ab2e65c05$export$34f5c36a3e80efa2 = {
    prefix: "fas",
    iconName: "calendar",
    icon: [
        448,
        512,
        [
            128197,
            128198
        ],
        "f133",
        "M96 32V64H48C21.5 64 0 85.5 0 112v48H448V112c0-26.5-21.5-48-48-48H352V32c0-17.7-14.3-32-32-32s-32 14.3-32 32V64H160V32c0-17.7-14.3-32-32-32S96 14.3 96 32zM448 192H0V464c0 26.5 21.5 48 48 48H400c26.5 0 48-21.5 48-48V192z"
    ]
};
var $d8206b3ab2e65c05$export$3a48b9820e92f5ab = {
    prefix: "fas",
    iconName: "trailer",
    icon: [
        640,
        512,
        [],
        "e041",
        "M48 32C21.5 32 0 53.5 0 80V336c0 26.5 21.5 48 48 48H65.1c7.8-54.3 54.4-96 110.9-96s103.1 41.7 110.9 96H488h8H608c17.7 0 32-14.3 32-32s-14.3-32-32-32H544V80c0-26.5-21.5-48-48-48H48zM80 96c8.8 0 16 7.2 16 16l0 131.2c-11.4 5.9-22.2 12.9-32 21V112c0-8.8 7.2-16 16-16zm96 128c-5.4 0-10.7 .2-16 .7L160 112c0-8.8 7.2-16 16-16s16 7.2 16 16l0 112.7c-5.3-.5-10.6-.7-16-.7zm80 19.2L256 112c0-8.8 7.2-16 16-16s16 7.2 16 16l0 152.2c-9.8-8.1-20.6-15.2-32-21zM368 96c8.8 0 16 7.2 16 16l0 192c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-192c0-8.8 7.2-16 16-16zm112 16l0 192c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-192c0-8.8 7.2-16 16-16s16 7.2 16 16zM176 480a80 80 0 1 0 0-160 80 80 0 1 0 0 160zm0-112a32 32 0 1 1 0 64 32 32 0 1 1 0-64z"
    ]
};
var $d8206b3ab2e65c05$export$6d636565b3ec36b4 = {
    prefix: "fas",
    iconName: "bahai",
    icon: [
        576,
        512,
        [
            "haykal"
        ],
        "f666",
        "M288 0c14.5 0 27.2 9.7 30.9 23.8l23.9 89.6 75.9-53.3c11.9-8.3 27.8-7.6 39 1.7s14.6 24.9 8.4 38.1l-39.3 84 92.4 8c14.4 1.2 26.2 12 28.8 26.3s-4.9 28.5-18 34.6l-84.1 39.1 65.7 65.5c10.3 10.2 12.4 26.1 5.1 38.7s-22 18.7-36 14.9L391 386.8l8.2 92.4c1.3 14.4-7.3 27.9-20.9 32.9s-28.9 .1-37.2-11.7l-53.1-76-53.1 76c-8.3 11.9-23.6 16.7-37.2 11.7s-22.2-18.5-20.9-32.9l8.2-92.4L95.4 410.9c-14 3.8-28.8-2.3-36-14.9s-5.2-28.4 5.1-38.7l65.7-65.5L46 252.7c-13.1-6.1-20.5-20.3-18-34.6s14.3-25.1 28.8-26.3l92.4-8-39.3-84c-6.1-13.1-2.7-28.8 8.4-38.1s27.1-10 39-1.7l75.9 53.3 23.9-89.6C260.8 9.7 273.5 0 288 0zm0 156.2l-4.8 18c-2.7 10.1-10.2 18.2-20 21.8s-20.8 2.1-29.3-3.9l-15.2-10.7 7.9 16.8c4.4 9.5 4 20.5-1.3 29.6s-14.5 15-25 15.9l-18.5 1.6 16.8 7.8c9.5 4.4 16.2 13.2 18 23.5s-1.5 20.8-8.9 28.2l-13.2 13.1 17.9-4.8c10.1-2.7 20.9-.3 28.9 6.4s12.2 16.9 11.3 27.3l-1.6 18.5 10.6-15.2c6-8.6 15.8-13.7 26.2-13.7s20.2 5.1 26.2 13.7l10.6 15.2-1.6-18.5c-.9-10.4 3.3-20.6 11.3-27.3s18.8-9.1 28.9-6.4l17.9 4.8-13.2-13.1c-7.4-7.4-10.7-17.9-8.9-28.2s8.5-19.1 18-23.5l16.8-7.8-18.5-1.6c-10.4-.9-19.7-6.8-25-15.9s-5.7-20.1-1.3-29.6l7.9-16.8-15.2 10.7c-8.6 6-19.5 7.5-29.3 3.9s-17.3-11.7-20-21.8l-4.8-18z"
    ]
};
var $d8206b3ab2e65c05$export$5c15e34e0e43f15c = $d8206b3ab2e65c05$export$6d636565b3ec36b4;
var $d8206b3ab2e65c05$export$303efb6031da122 = {
    prefix: "fas",
    iconName: "sd-card",
    icon: [
        384,
        512,
        [],
        "f7c2",
        "M320 0H141.3C124.3 0 108 6.7 96 18.7L18.7 96C6.7 108 0 124.3 0 141.3V448c0 35.3 28.7 64 64 64H320c35.3 0 64-28.7 64-64V64c0-35.3-28.7-64-64-64zM160 88v48c0 13.3-10.7 24-24 24s-24-10.7-24-24V88c0-13.3 10.7-24 24-24s24 10.7 24 24zm80 0v48c0 13.3-10.7 24-24 24s-24-10.7-24-24V88c0-13.3 10.7-24 24-24s24 10.7 24 24zm80 0v48c0 13.3-10.7 24-24 24s-24-10.7-24-24V88c0-13.3 10.7-24 24-24s24 10.7 24 24z"
    ]
};
var $d8206b3ab2e65c05$export$ae1875ba975aa0e9 = {
    prefix: "fas",
    iconName: "dragon",
    icon: [
        640,
        512,
        [
            128009
        ],
        "f6d5",
        "M352 124.5l-51.9-13c-6.5-1.6-11.3-7.1-12-13.8s2.8-13.1 8.7-16.1l40.8-20.4L294.4 28.8c-5.5-4.1-7.8-11.3-5.6-17.9S297.1 0 304 0H416h32 16c30.2 0 58.7 14.2 76.8 38.4l57.6 76.8c6.2 8.3 9.6 18.4 9.6 28.8c0 26.5-21.5 48-48 48H538.5c-17 0-33.3-6.7-45.3-18.7L480 160H448v21.5c0 24.8 12.8 47.9 33.8 61.1l106.6 66.6c32.1 20.1 51.6 55.2 51.6 93.1C640 462.9 590.9 512 530.2 512H496 432 32.3c-3.3 0-6.6-.4-9.6-1.4C13.5 507.8 6 501 2.4 492.1C1 488.7 .2 485.2 0 481.4c-.2-3.7 .3-7.3 1.3-10.7c2.8-9.2 9.6-16.7 18.6-20.4c3-1.2 6.2-2 9.5-2.2L433.3 412c8.3-.7 14.7-7.7 14.7-16.1c0-4.3-1.7-8.4-4.7-11.4l-44.4-44.4c-30-30-46.9-70.7-46.9-113.1V181.5v-57zM512 72.3c0-.1 0-.2 0-.3s0-.2 0-.3v.6zm-1.3 7.4L464.3 68.1c-.2 1.3-.3 2.6-.3 3.9c0 13.3 10.7 24 24 24c10.6 0 19.5-6.8 22.7-16.3zM130.9 116.5c16.3-14.5 40.4-16.2 58.5-4.1l130.6 87V227c0 32.8 8.4 64.8 24 93H112c-6.7 0-12.7-4.2-15-10.4s-.5-13.3 4.6-17.7L171 232.3 18.4 255.8c-7 1.1-13.9-2.6-16.9-9s-1.5-14.1 3.8-18.8L130.9 116.5z"
    ]
};
var $d8206b3ab2e65c05$export$cdbdd2118099ae07 = {
    prefix: "fas",
    iconName: "shoe-prints",
    icon: [
        640,
        512,
        [],
        "f54b",
        "M416 0C352.3 0 256 32 256 32V160c48 0 76 16 104 32s56 32 104 32c56.4 0 176-16 176-96S512 0 416 0zM128 96c0 35.3 28.7 64 64 64h32V32H192c-35.3 0-64 28.7-64 64zM288 512c96 0 224-48 224-128s-119.6-96-176-96c-48 0-76 16-104 32s-56 32-104 32V480s96.3 32 160 32zM0 416c0 35.3 28.7 64 64 64H96V352H64c-35.3 0-64 28.7-64 64z"
    ]
};
var $d8206b3ab2e65c05$export$eeda28b8ca4cb18e = {
    prefix: "fas",
    iconName: "circle-plus",
    icon: [
        512,
        512,
        [
            "plus-circle"
        ],
        "f055",
        "M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM232 344V280H168c-13.3 0-24-10.7-24-24s10.7-24 24-24h64V168c0-13.3 10.7-24 24-24s24 10.7 24 24v64h64c13.3 0 24 10.7 24 24s-10.7 24-24 24H280v64c0 13.3-10.7 24-24 24s-24-10.7-24-24z"
    ]
};
var $d8206b3ab2e65c05$export$d9cc3a81499af48c = $d8206b3ab2e65c05$export$eeda28b8ca4cb18e;
var $d8206b3ab2e65c05$export$4272e56f2429da88 = {
    prefix: "fas",
    iconName: "face-grin-tongue-wink",
    icon: [
        512,
        512,
        [
            128540,
            "grin-tongue-wink"
        ],
        "f58b",
        "M174.5 498.8C73.1 464.7 0 368.9 0 256C0 114.6 114.6 0 256 0S512 114.6 512 256c0 112.9-73.1 208.7-174.5 242.8C346.7 484 352 466.6 352 448V401.1c24.3-17.5 43.6-41.6 55.4-69.6c5-11.8-7-22.5-19.3-18.7c-39.7 12.2-84.5 19-131.8 19s-92.1-6.8-131.8-19c-12.3-3.8-24.3 6.9-19.3 18.7c11.7 27.8 30.8 51.7 54.8 69.2V448c0 18.6 5.3 36 14.5 50.8zm20.7-265.2c5.3 7.1 15.3 8.5 22.4 3.2s8.5-15.3 3.2-22.4c-30.4-40.5-91.2-40.5-121.6 0c-5.3 7.1-3.9 17.1 3.2 22.4s17.1 3.9 22.4-3.2c17.6-23.5 52.8-23.5 70.4 0zM336 272a64 64 0 1 0 0-128 64 64 0 1 0 0 128zM320 402.6V448c0 35.3-28.7 64-64 64s-64-28.7-64-64V402.6c0-14.7 11.9-26.6 26.6-26.6h2c11.3 0 21.1 7.9 23.6 18.9c2.8 12.6 20.8 12.6 23.6 0c2.5-11.1 12.3-18.9 23.6-18.9h2c14.7 0 26.6 11.9 26.6 26.6zM336 184a24 24 0 1 1 0 48 24 24 0 1 1 0-48z"
    ]
};
var $d8206b3ab2e65c05$export$58099903d50aefb3 = $d8206b3ab2e65c05$export$4272e56f2429da88;
var $d8206b3ab2e65c05$export$e6094d25274088ab = {
    prefix: "fas",
    iconName: "hand-holding",
    icon: [
        576,
        512,
        [],
        "f4bd",
        "M559.7 392.2c17.8-13.1 21.6-38.1 8.5-55.9s-38.1-21.6-55.9-8.5L392.6 416H272c-8.8 0-16-7.2-16-16s7.2-16 16-16h16 64c17.7 0 32-14.3 32-32s-14.3-32-32-32H288 272 193.7c-29.1 0-57.3 9.9-80 28L68.8 384H32c-17.7 0-32 14.3-32 32v64c0 17.7 14.3 32 32 32H192 352.5c29 0 57.3-9.3 80.7-26.5l126.6-93.3zm-366.1-8.3a.5 .5 0 1 1 -.9 .1 .5 .5 0 1 1 .9-.1z"
    ]
};
var $d8206b3ab2e65c05$export$d893dd9509763a17 = {
    prefix: "fas",
    iconName: "plug-circle-exclamation",
    icon: [
        576,
        512,
        [],
        "e55d",
        "M96 0C78.3 0 64 14.3 64 32v96h64V32c0-17.7-14.3-32-32-32zM288 0c-17.7 0-32 14.3-32 32v96h64V32c0-17.7-14.3-32-32-32zM32 160c-17.7 0-32 14.3-32 32s14.3 32 32 32v32c0 77.4 55 142 128 156.8V480c0 17.7 14.3 32 32 32s32-14.3 32-32V412.8c12.3-2.5 24.1-6.4 35.1-11.5c-2.1-10.8-3.1-21.9-3.1-33.3c0-80.3 53.8-148 127.3-169.2c.5-2.2 .7-4.5 .7-6.8c0-17.7-14.3-32-32-32H32zM432 512a144 144 0 1 0 0-288 144 144 0 1 0 0 288zm0-96a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm0-144c8.8 0 16 7.2 16 16v80c0 8.8-7.2 16-16 16s-16-7.2-16-16V288c0-8.8 7.2-16 16-16z"
    ]
};
var $d8206b3ab2e65c05$export$22965c7f4d903953 = {
    prefix: "fas",
    iconName: "link-slash",
    icon: [
        640,
        512,
        [
            "chain-broken",
            "chain-slash",
            "unlink"
        ],
        "f127",
        "M38.8 5.1C28.4-3.1 13.3-1.2 5.1 9.2S-1.2 34.7 9.2 42.9l592 464c10.4 8.2 25.5 6.3 33.7-4.1s6.3-25.5-4.1-33.7L489.3 358.2l90.5-90.5c56.5-56.5 56.5-148 0-204.5c-50-50-128.8-56.5-186.3-15.4l-1.6 1.1c-14.4 10.3-17.7 30.3-7.4 44.6s30.3 17.7 44.6 7.4l1.6-1.1c32.1-22.9 76-19.3 103.8 8.6c31.5 31.5 31.5 82.5 0 114l-96 96-31.9-25C430.9 239.6 420.1 175.1 377 132c-52.2-52.3-134.5-56.2-191.3-11.7L38.8 5.1zM239 162c30.1-14.9 67.7-9.9 92.8 15.3c20 20 27.5 48.3 21.7 74.5L239 162zM406.6 416.4L220.9 270c-2.1 39.8 12.2 80.1 42.2 110c38.9 38.9 94.4 51 143.6 36.3zm-290-228.5L60.2 244.3c-56.5 56.5-56.5 148 0 204.5c50 50 128.8 56.5 186.3 15.4l1.6-1.1c14.4-10.3 17.7-30.3 7.4-44.6s-30.3-17.7-44.6-7.4l-1.6 1.1c-32.1 22.9-76 19.3-103.8-8.6C74 372 74 321 105.5 289.5l61.8-61.8-50.6-39.9z"
    ]
};
var $d8206b3ab2e65c05$export$382551e04f32620a = $d8206b3ab2e65c05$export$22965c7f4d903953;
var $d8206b3ab2e65c05$export$12f09d657be59586 = $d8206b3ab2e65c05$export$22965c7f4d903953;
var $d8206b3ab2e65c05$export$2f546f7d8ba01e18 = $d8206b3ab2e65c05$export$22965c7f4d903953;
var $d8206b3ab2e65c05$export$76c1aa4bf9a39458 = {
    prefix: "fas",
    iconName: "clone",
    icon: [
        512,
        512,
        [],
        "f24d",
        "M288 448H64V224h64V160H64c-35.3 0-64 28.7-64 64V448c0 35.3 28.7 64 64 64H288c35.3 0 64-28.7 64-64V384H288v64zm-64-96H448c35.3 0 64-28.7 64-64V64c0-35.3-28.7-64-64-64H224c-35.3 0-64 28.7-64 64V288c0 35.3 28.7 64 64 64z"
    ]
};
var $d8206b3ab2e65c05$export$5a200e8504b7367a = {
    prefix: "fas",
    iconName: "person-walking-arrow-loop-left",
    icon: [
        640,
        512,
        [],
        "e551",
        "M208 96a48 48 0 1 0 0-96 48 48 0 1 0 0 96zM123.7 200.5c1-.4 1.9-.8 2.9-1.2l-16.9 63.5c-5.6 21.1-.1 43.6 14.7 59.7l70.7 77.1 22 88.1c4.3 17.1 21.7 27.6 38.8 23.3s27.6-21.7 23.3-38.8l-23-92.1c-1.9-7.8-5.8-14.9-11.2-20.8l-49.5-54 19.3-65.5 9.6 23c4.4 10.6 12.5 19.3 22.8 24.5l26.7 13.3c15.8 7.9 35 1.5 42.9-14.3s1.5-35-14.3-42.9L281 232.7l-15.3-36.8C248.5 154.8 208.3 128 163.7 128c-22.8 0-45.3 4.8-66.1 14l-8 3.5c-32.9 14.6-58.1 42.4-69.4 76.5l-2.6 7.8c-5.6 16.8 3.5 34.9 20.2 40.5s34.9-3.5 40.5-20.2l2.6-7.8c5.7-17.1 18.3-30.9 34.7-38.2l8-3.5zm-30 135.1L68.7 398 9.4 457.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0L116.3 441c4.6-4.6 8.2-10.1 10.6-16.1l14.5-36.2-40.7-44.4c-2.5-2.7-4.8-5.6-7-8.6zm347.7 119c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L461.3 384H480c88.4 0 160-71.6 160-160s-71.6-160-160-160L352 64c-17.7 0-32 14.3-32 32s14.3 32 32 32l128 0c53 0 96 43 96 96s-43 96-96 96H461.3l25.4-25.4c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0l-80 80c-12.5 12.5-12.5 32.8 0 45.3l80 80z"
    ]
};
var $d8206b3ab2e65c05$export$a0a53d8e3c68e9f1 = {
    prefix: "fas",
    iconName: "arrow-up-z-a",
    icon: [
        576,
        512,
        [
            "sort-alpha-up-alt"
        ],
        "f882",
        "M183.6 42.4C177.5 35.8 169 32 160 32s-17.5 3.8-23.6 10.4l-88 96c-11.9 13-11.1 33.3 2 45.2s33.3 11.1 45.2-2L128 146.3V448c0 17.7 14.3 32 32 32s32-14.3 32-32V146.3l32.4 35.4c11.9 13 32.2 13.9 45.2 2s13.9-32.2 2-45.2l-88-96zM320 64c0 17.7 14.3 32 32 32h50.7l-73.4 73.4c-9.2 9.2-11.9 22.9-6.9 34.9s16.6 19.8 29.6 19.8H480c17.7 0 32-14.3 32-32s-14.3-32-32-32H429.3l73.4-73.4c9.2-9.2 11.9-22.9 6.9-34.9s-16.6-19.8-29.6-19.8H352c-17.7 0-32 14.3-32 32zm96 192c-12.1 0-23.2 6.8-28.6 17.7l-64 128-16 32c-7.9 15.8-1.5 35 14.3 42.9s35 1.5 42.9-14.3l7.2-14.3h88.4l7.2 14.3c7.9 15.8 27.1 22.2 42.9 14.3s22.2-27.1 14.3-42.9l-16-32-64-128C439.2 262.8 428.1 256 416 256zM395.8 400L416 359.6 436.2 400H395.8z"
    ]
};
var $d8206b3ab2e65c05$export$95ef20828693fb0f = $d8206b3ab2e65c05$export$a0a53d8e3c68e9f1;
var $d8206b3ab2e65c05$export$769724fc1434d618 = {
    prefix: "fas",
    iconName: "fire-flame-curved",
    icon: [
        384,
        512,
        [
            "fire-alt"
        ],
        "f7e4",
        "M153.6 29.9l16-21.3C173.6 3.2 180 0 186.7 0C198.4 0 208 9.6 208 21.3V43.5c0 13.1 5.4 25.7 14.9 34.7L307.6 159C356.4 205.6 384 270.2 384 337.7C384 434 306 512 209.7 512H192C86 512 0 426 0 320v-3.8c0-48.8 19.4-95.6 53.9-130.1l3.5-3.5c4.2-4.2 10-6.6 16-6.6C85.9 176 96 186.1 96 198.6V288c0 35.3 28.7 64 64 64s64-28.7 64-64v-3.9c0-18-7.2-35.3-19.9-48l-38.6-38.6c-24-24-37.5-56.7-37.5-90.7c0-27.7 9-54.8 25.6-76.9z"
    ]
};
var $d8206b3ab2e65c05$export$70dc26b4926d0b1b = $d8206b3ab2e65c05$export$769724fc1434d618;
var $d8206b3ab2e65c05$export$6d274258ba4b0089 = {
    prefix: "fas",
    iconName: "tornado",
    icon: [
        448,
        512,
        [
            127786
        ],
        "f76f",
        "M0 32V45.6C0 62.7 1.7 79.6 5 96H357.8c3.2-6.9 7.5-13.3 13-18.8l38.6-38.6c4.2-4.2 6.6-10 6.6-16C416 10.1 405.9 0 393.4 0H32C14.3 0 0 14.3 0 32zm352.2 96H13.6c12.2 35.9 32.3 68.7 58.8 96H412l-47.2-62.9c-7.3-9.7-11.6-21.2-12.6-33.1zm-226 138.2l116.4 68.5c8.2 4.8 15.8 10.7 22.5 17.3H445c2-9.8 3-19.9 3-30.1c0-23-5.3-45.5-15.3-65.9H110.2c5.2 3.6 10.5 7 16 10.2zM288 384c10.3 21.4 13.8 45.5 9.9 69l-5.9 35.7c-2 12.2 7.4 23.4 19.8 23.4c5.3 0 10.4-2.1 14.2-5.9l78.2-78.2c12.8-12.8 23.1-27.7 30.4-43.9H288z"
    ]
};
var $d8206b3ab2e65c05$export$430d63b54b1d4009 = {
    prefix: "fas",
    iconName: "file-circle-plus",
    icon: [
        576,
        512,
        [
            58606
        ],
        "e494",
        "M0 64C0 28.7 28.7 0 64 0H224V128c0 17.7 14.3 32 32 32H384v38.6C310.1 219.5 256 287.4 256 368c0 59.1 29.1 111.3 73.7 143.3c-3.2 .5-6.4 .7-9.7 .7H64c-35.3 0-64-28.7-64-64V64zm384 64H256V0L384 128zm48 96a144 144 0 1 1 0 288 144 144 0 1 1 0-288zm16 80c0-8.8-7.2-16-16-16s-16 7.2-16 16v48H368c-8.8 0-16 7.2-16 16s7.2 16 16 16h48v48c0 8.8 7.2 16 16 16s16-7.2 16-16V384h48c8.8 0 16-7.2 16-16s-7.2-16-16-16H448V304z"
    ]
};
var $d8206b3ab2e65c05$export$ad3212bc3fa1595b = {
    prefix: "fas",
    iconName: "book-quran",
    icon: [
        448,
        512,
        [
            "quran"
        ],
        "f687",
        "M352 0c53 0 96 43 96 96V416c0 53-43 96-96 96H64 32c-17.7 0-32-14.3-32-32s14.3-32 32-32V384c-17.7 0-32-14.3-32-32V32C0 14.3 14.3 0 32 0H64 352zm0 384H96v64H352c17.7 0 32-14.3 32-32s-14.3-32-32-32zM274.1 150.2l-8.9 21.4-23.1 1.9c-5.7 .5-8 7.5-3.7 11.2L256 199.8l-5.4 22.6c-1.3 5.5 4.7 9.9 9.6 6.9L280 217.2l19.8 12.1c4.9 3 10.9-1.4 9.6-6.9L304 199.8l17.6-15.1c4.3-3.7 2-10.8-3.7-11.2l-23.1-1.9-8.9-21.4c-2.2-5.3-9.6-5.3-11.8 0zM96 192c0 70.7 57.3 128 128 128c25.6 0 49.5-7.5 69.5-20.5c3.2-2.1 4.5-6.2 3.1-9.7s-5.2-5.6-9-4.8c-6.1 1.2-12.5 1.9-19 1.9c-52.4 0-94.9-42.5-94.9-94.9s42.5-94.9 94.9-94.9c6.5 0 12.8 .7 19 1.9c3.8 .8 7.5-1.3 9-4.8s.2-7.6-3.1-9.7C273.5 71.5 249.6 64 224 64C153.3 64 96 121.3 96 192z"
    ]
};
var $d8206b3ab2e65c05$export$46f29ea84ed4c5f1 = $d8206b3ab2e65c05$export$ad3212bc3fa1595b;
var $d8206b3ab2e65c05$export$12a35719f889cd1 = {
    prefix: "fas",
    iconName: "anchor",
    icon: [
        576,
        512,
        [
            9875
        ],
        "f13d",
        "M320 96a32 32 0 1 1 -64 0 32 32 0 1 1 64 0zm21.1 80C367 158.8 384 129.4 384 96c0-53-43-96-96-96s-96 43-96 96c0 33.4 17 62.8 42.9 80H224c-17.7 0-32 14.3-32 32s14.3 32 32 32h32V448H208c-53 0-96-43-96-96v-6.1l7 7c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9L97 263c-9.4-9.4-24.6-9.4-33.9 0L7 319c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l7-7V352c0 88.4 71.6 160 160 160h80 80c88.4 0 160-71.6 160-160v-6.1l7 7c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9l-56-56c-9.4-9.4-24.6-9.4-33.9 0l-56 56c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l7-7V352c0 53-43 96-96 96H320V240h32c17.7 0 32-14.3 32-32s-14.3-32-32-32H341.1z"
    ]
};
var $d8206b3ab2e65c05$export$93a5eb721c9c0d25 = {
    prefix: "fas",
    iconName: "border-all",
    icon: [
        448,
        512,
        [],
        "f84c",
        "M384 96V224H256V96H384zm0 192V416H256V288H384zM192 224H64V96H192V224zM64 288H192V416H64V288zM64 32C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64z"
    ]
};
var $d8206b3ab2e65c05$export$67a047c738fb34da = {
    prefix: "fas",
    iconName: "face-angry",
    icon: [
        512,
        512,
        [
            128544,
            "angry"
        ],
        "f556",
        "M0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zM338.7 395.9c6.6-5.9 7.1-16 1.2-22.6C323.8 355.4 295.7 336 256 336s-67.8 19.4-83.9 37.3c-5.9 6.6-5.4 16.7 1.2 22.6s16.7 5.4 22.6-1.2c11.7-13 31.6-26.7 60.1-26.7s48.4 13.7 60.1 26.7c5.9 6.6 16 7.1 22.6 1.2zM176.4 272c17.7 0 32-14.3 32-32c0-1.5-.1-3-.3-4.4l10.9 3.6c8.4 2.8 17.4-1.7 20.2-10.1s-1.7-17.4-10.1-20.2l-96-32c-8.4-2.8-17.4 1.7-20.2 10.1s1.7 17.4 10.1 20.2l30.7 10.2c-5.8 5.8-9.3 13.8-9.3 22.6c0 17.7 14.3 32 32 32zm192-32c0-8.9-3.6-17-9.5-22.8l30.2-10.1c8.4-2.8 12.9-11.9 10.1-20.2s-11.9-12.9-20.2-10.1l-96 32c-8.4 2.8-12.9 11.9-10.1 20.2s11.9 12.9 20.2 10.1l11.7-3.9c-.2 1.5-.3 3.1-.3 4.7c0 17.7 14.3 32 32 32s32-14.3 32-32z"
    ]
};
var $d8206b3ab2e65c05$export$3c96c08e234498c5 = $d8206b3ab2e65c05$export$67a047c738fb34da;
var $d8206b3ab2e65c05$export$317dde8664f7de71 = {
    prefix: "fas",
    iconName: "cookie-bite",
    icon: [
        512,
        512,
        [],
        "f564",
        "M257.5 27.6c-.8-5.4-4.9-9.8-10.3-10.6c-22.1-3.1-44.6 .9-64.4 11.4l-74 39.5C89.1 78.4 73.2 94.9 63.4 115L26.7 190.6c-9.8 20.1-13 42.9-9.1 64.9l14.5 82.8c3.9 22.1 14.6 42.3 30.7 57.9l60.3 58.4c16.1 15.6 36.6 25.6 58.7 28.7l83 11.7c22.1 3.1 44.6-.9 64.4-11.4l74-39.5c19.7-10.5 35.6-27 45.4-47.2l36.7-75.5c9.8-20.1 13-42.9 9.1-64.9c-.9-5.3-5.3-9.3-10.6-10.1c-51.5-8.2-92.8-47.1-104.5-97.4c-1.8-7.6-8-13.4-15.7-14.6c-54.6-8.7-97.7-52-106.2-106.8zM208 144a32 32 0 1 1 0 64 32 32 0 1 1 0-64zM144 336a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm224-64a32 32 0 1 1 0 64 32 32 0 1 1 0-64z"
    ]
};
var $d8206b3ab2e65c05$export$d2caed5e37174c23 = {
    prefix: "fas",
    iconName: "arrow-trend-down",
    icon: [
        576,
        512,
        [],
        "e097",
        "M384 352c-17.7 0-32 14.3-32 32s14.3 32 32 32H544c17.7 0 32-14.3 32-32V224c0-17.7-14.3-32-32-32s-32 14.3-32 32v82.7L342.6 137.4c-12.5-12.5-32.8-12.5-45.3 0L192 242.7 54.6 105.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3l160 160c12.5 12.5 32.8 12.5 45.3 0L320 205.3 466.7 352H384z"
    ]
};
var $d8206b3ab2e65c05$export$7329a1ca27b90c5b = {
    prefix: "fas",
    iconName: "rss",
    icon: [
        448,
        512,
        [
            "feed"
        ],
        "f09e",
        "M0 64C0 46.3 14.3 32 32 32c229.8 0 416 186.2 416 416c0 17.7-14.3 32-32 32s-32-14.3-32-32C384 253.6 226.4 96 32 96C14.3 96 0 81.7 0 64zM0 416a64 64 0 1 1 128 0A64 64 0 1 1 0 416zM32 160c159.1 0 288 128.9 288 288c0 17.7-14.3 32-32 32s-32-14.3-32-32c0-123.7-100.3-224-224-224c-17.7 0-32-14.3-32-32s14.3-32 32-32z"
    ]
};
var $d8206b3ab2e65c05$export$67ad3d0233cd7b33 = $d8206b3ab2e65c05$export$7329a1ca27b90c5b;
var $d8206b3ab2e65c05$export$df9bd3777d1154d2 = {
    prefix: "fas",
    iconName: "draw-polygon",
    icon: [
        448,
        512,
        [],
        "f5ee",
        "M96 151.4V360.6c9.7 5.6 17.8 13.7 23.4 23.4H328.6c0-.1 .1-.2 .1-.3l-4.5-7.9-32-56 0 0c-1.4 .1-2.8 .1-4.2 .1c-35.3 0-64-28.7-64-64s28.7-64 64-64c1.4 0 2.8 0 4.2 .1l0 0 32-56 4.5-7.9-.1-.3H119.4c-5.6 9.7-13.7 17.8-23.4 23.4zM384.3 352c35.2 .2 63.7 28.7 63.7 64c0 35.3-28.7 64-64 64c-23.7 0-44.4-12.9-55.4-32H119.4c-11.1 19.1-31.7 32-55.4 32c-35.3 0-64-28.7-64-64c0-23.7 12.9-44.4 32-55.4V151.4C12.9 140.4 0 119.7 0 96C0 60.7 28.7 32 64 32c23.7 0 44.4 12.9 55.4 32H328.6c11.1-19.1 31.7-32 55.4-32c35.3 0 64 28.7 64 64c0 35.3-28.5 63.8-63.7 64l-4.5 7.9-32 56-2.3 4c4.2 8.5 6.5 18 6.5 28.1s-2.3 19.6-6.5 28.1l2.3 4 32 56 4.5 7.9z"
    ]
};
var $d8206b3ab2e65c05$export$33fb4280dc20f0dd = {
    prefix: "fas",
    iconName: "scale-balanced",
    icon: [
        640,
        512,
        [
            9878,
            "balance-scale"
        ],
        "f24e",
        "M384 32H512c17.7 0 32 14.3 32 32s-14.3 32-32 32H398.4c-5.2 25.8-22.9 47.1-46.4 57.3V448H512c17.7 0 32 14.3 32 32s-14.3 32-32 32H320 128c-17.7 0-32-14.3-32-32s14.3-32 32-32H288V153.3c-23.5-10.3-41.2-31.6-46.4-57.3H128c-17.7 0-32-14.3-32-32s14.3-32 32-32H256c14.6-19.4 37.8-32 64-32s49.4 12.6 64 32zm55.6 288H584.4L512 195.8 439.6 320zM512 416c-62.9 0-115.2-34-126-78.9c-2.6-11 1-22.3 6.7-32.1l95.2-163.2c5-8.6 14.2-13.8 24.1-13.8s19.1 5.3 24.1 13.8l95.2 163.2c5.7 9.8 9.3 21.1 6.7 32.1C627.2 382 574.9 416 512 416zM126.8 195.8L54.4 320H199.3L126.8 195.8zM.9 337.1c-2.6-11 1-22.3 6.7-32.1l95.2-163.2c5-8.6 14.2-13.8 24.1-13.8s19.1 5.3 24.1 13.8l95.2 163.2c5.7 9.8 9.3 21.1 6.7 32.1C242 382 189.7 416 126.8 416S11.7 382 .9 337.1z"
    ]
};
var $d8206b3ab2e65c05$export$fec323dcfd81d750 = $d8206b3ab2e65c05$export$33fb4280dc20f0dd;
var $d8206b3ab2e65c05$export$cc4351eb13da27d8 = {
    prefix: "fas",
    iconName: "gauge-simple-high",
    icon: [
        512,
        512,
        [
            61668,
            "tachometer",
            "tachometer-fast"
        ],
        "f62a",
        "M0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm320 96c0-15.9-5.8-30.4-15.3-41.6l76.6-147.4c6.1-11.8 1.5-26.3-10.2-32.4s-26.2-1.5-32.4 10.2L262.1 288.3c-2-.2-4-.3-6.1-.3c-35.3 0-64 28.7-64 64s28.7 64 64 64s64-28.7 64-64z"
    ]
};
var $d8206b3ab2e65c05$export$362d0f652c3fbca2 = $d8206b3ab2e65c05$export$cc4351eb13da27d8;
var $d8206b3ab2e65c05$export$375b6a8680f980ed = $d8206b3ab2e65c05$export$cc4351eb13da27d8;
var $d8206b3ab2e65c05$export$f7f7c15f18cc19a1 = {
    prefix: "fas",
    iconName: "shower",
    icon: [
        512,
        512,
        [
            128703
        ],
        "f2cc",
        "M64 131.9C64 112.1 80.1 96 99.9 96c9.5 0 18.6 3.8 25.4 10.5l16.2 16.2c-21 38.9-17.4 87.5 10.9 123L151 247c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0L345 121c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-1.3 1.3c-35.5-28.3-84.2-31.9-123-10.9L170.5 61.3C151.8 42.5 126.4 32 99.9 32C44.7 32 0 76.7 0 131.9V448c0 17.7 14.3 32 32 32s32-14.3 32-32V131.9zM256 352a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm64 64a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zm0-128a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm64 64a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zm0-128a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm64 64a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zm32-32a32 32 0 1 0 0-64 32 32 0 1 0 0 64z"
    ]
};
var $d8206b3ab2e65c05$export$6e6ddc253102e596 = {
    prefix: "fas",
    iconName: "desktop",
    icon: [
        576,
        512,
        [
            128421,
            61704,
            "desktop-alt"
        ],
        "f390",
        "M64 0C28.7 0 0 28.7 0 64V352c0 35.3 28.7 64 64 64H240l-10.7 32H160c-17.7 0-32 14.3-32 32s14.3 32 32 32H416c17.7 0 32-14.3 32-32s-14.3-32-32-32H346.7L336 416H512c35.3 0 64-28.7 64-64V64c0-35.3-28.7-64-64-64H64zM512 64V288H64V64H512z"
    ]
};
var $d8206b3ab2e65c05$export$ff09a62b9e0fa899 = $d8206b3ab2e65c05$export$6e6ddc253102e596;
var $d8206b3ab2e65c05$export$bd6a7788954842b5 = {
    prefix: "fas",
    iconName: "m",
    icon: [
        448,
        512,
        [
            109
        ],
        "4d",
        "M22.7 33.4c13.5-4.1 28.1 1.1 35.9 12.9L224 294.3 389.4 46.2c7.8-11.7 22.4-17 35.9-12.9S448 49.9 448 64V448c0 17.7-14.3 32-32 32s-32-14.3-32-32V169.7L250.6 369.8c-5.9 8.9-15.9 14.2-26.6 14.2s-20.7-5.3-26.6-14.2L64 169.7V448c0 17.7-14.3 32-32 32s-32-14.3-32-32V64C0 49.9 9.2 37.5 22.7 33.4z"
    ]
};
var $d8206b3ab2e65c05$export$6e989c3c7050dbb = {
    prefix: "fas",
    iconName: "table-list",
    icon: [
        512,
        512,
        [
            "th-list"
        ],
        "f00b",
        "M0 96C0 60.7 28.7 32 64 32H448c35.3 0 64 28.7 64 64V416c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96zm64 0v64h64V96H64zm384 0H192v64H448V96zM64 224v64h64V224H64zm384 0H192v64H448V224zM64 352v64h64V352H64zm384 0H192v64H448V352z"
    ]
};
var $d8206b3ab2e65c05$export$daf2614a457122c0 = $d8206b3ab2e65c05$export$6e989c3c7050dbb;
var $d8206b3ab2e65c05$export$435fe17e9d6170d6 = {
    prefix: "fas",
    iconName: "comment-sms",
    icon: [
        512,
        512,
        [
            "sms"
        ],
        "f7cd",
        "M256 448c141.4 0 256-93.1 256-208S397.4 32 256 32S0 125.1 0 240c0 45.1 17.7 86.8 47.7 120.9c-1.9 24.5-11.4 46.3-21.4 62.9c-5.5 9.2-11.1 16.6-15.2 21.6c-2.1 2.5-3.7 4.4-4.9 5.7c-.6 .6-1 1.1-1.3 1.4l-.3 .3 0 0 0 0 0 0 0 0c-4.6 4.6-5.9 11.4-3.4 17.4c2.5 6 8.3 9.9 14.8 9.9c28.7 0 57.6-8.9 81.6-19.3c22.9-10 42.4-21.9 54.3-30.6c31.8 11.5 67 17.9 104.1 17.9zM202.9 176.8c6.5-2.2 13.7 .1 17.9 5.6L256 229.3l35.2-46.9c4.1-5.5 11.3-7.8 17.9-5.6s10.9 8.3 10.9 15.2v96c0 8.8-7.2 16-16 16s-16-7.2-16-16V240l-19.2 25.6c-3 4-7.8 6.4-12.8 6.4s-9.8-2.4-12.8-6.4L224 240v48c0 8.8-7.2 16-16 16s-16-7.2-16-16V192c0-6.9 4.4-13 10.9-15.2zm173.1 38c0 .2 0 .4 0 .4c.1 .1 .6 .8 2.2 1.7c3.9 2.3 9.6 4.1 18.3 6.8l.6 .2c7.4 2.2 17.3 5.2 25.2 10.2c9.1 5.7 17.4 15.2 17.6 29.9c.2 15-7.6 26-17.8 32.3c-9.5 5.9-20.9 7.9-30.7 7.6c-12.2-.4-23.7-4.4-32.6-7.4l0 0 0 0c-1.4-.5-2.7-.9-4-1.4c-8.4-2.8-12.9-11.9-10.1-20.2s11.9-12.9 20.2-10.1c1.7 .6 3.3 1.1 4.9 1.6l0 0 0 0c9.1 3.1 15.6 5.3 22.6 5.5c5.3 .2 10-1 12.8-2.8c1.2-.8 1.8-1.5 2.1-2c.2-.4 .6-1.2 .6-2.7l0-.2c0-.7 0-1.4-2.7-3.1c-3.8-2.4-9.6-4.3-18-6.9l-1.2-.4c-7.2-2.2-16.7-5-24.3-9.6c-9-5.4-17.7-14.7-17.7-29.4c-.1-15.2 8.6-25.7 18.5-31.6c9.4-5.5 20.5-7.5 29.7-7.4c10 .2 19.7 2.3 27.9 4.4c8.5 2.3 13.6 11 11.3 19.6s-11 13.6-19.6 11.3c-7.3-1.9-14.1-3.3-20.1-3.4c-4.9-.1-9.8 1.1-12.9 2.9c-1.4 .8-2.1 1.6-2.4 2c-.2 .3-.4 .8-.4 1.9zm-272 0c0 .2 0 .4 0 .4c.1 .1 .6 .8 2.2 1.7c3.9 2.3 9.6 4.1 18.3 6.8l.6 .2c7.4 2.2 17.3 5.2 25.2 10.2c9.1 5.7 17.4 15.2 17.6 29.9c.2 15-7.6 26-17.8 32.3c-9.5 5.9-20.9 7.9-30.7 7.6c-12.3-.4-24.2-4.5-33.2-7.6l0 0 0 0c-1.3-.4-2.5-.8-3.6-1.2c-8.4-2.8-12.9-11.9-10.1-20.2s11.9-12.9 20.2-10.1c1.4 .5 2.8 .9 4.1 1.4l0 0 0 0c9.5 3.2 16.5 5.6 23.7 5.8c5.3 .2 10-1 12.8-2.8c1.2-.8 1.8-1.5 2.1-2c.2-.4 .6-1.2 .6-2.7l0-.2c0-.7 0-1.4-2.7-3.1c-3.8-2.4-9.6-4.3-18-6.9l-1.2-.4 0 0c-7.2-2.2-16.7-5-24.3-9.6C80.8 239 72.1 229.7 72 215c-.1-15.2 8.6-25.7 18.5-31.6c9.4-5.5 20.5-7.5 29.7-7.4c9.5 .1 22.2 2.1 31.1 4.4c8.5 2.3 13.6 11 11.3 19.6s-11 13.6-19.6 11.3c-6.6-1.8-16.8-3.3-23.3-3.4c-4.9-.1-9.8 1.1-12.9 2.9c-1.4 .8-2.1 1.6-2.4 2c-.2 .3-.4 .8-.4 1.9z"
    ]
};
var $d8206b3ab2e65c05$export$9dbcc3443daa7323 = $d8206b3ab2e65c05$export$435fe17e9d6170d6;
var $d8206b3ab2e65c05$export$c9d7ef726d1a8742 = {
    prefix: "fas",
    iconName: "book",
    icon: [
        448,
        512,
        [
            128212
        ],
        "f02d",
        "M96 0C43 0 0 43 0 96V416c0 53 43 96 96 96H384h32c17.7 0 32-14.3 32-32s-14.3-32-32-32V384c17.7 0 32-14.3 32-32V32c0-17.7-14.3-32-32-32H384 96zm0 384H352v64H96c-17.7 0-32-14.3-32-32s14.3-32 32-32zm32-240c0-8.8 7.2-16 16-16H336c8.8 0 16 7.2 16 16s-7.2 16-16 16H144c-8.8 0-16-7.2-16-16zm16 48H336c8.8 0 16 7.2 16 16s-7.2 16-16 16H144c-8.8 0-16-7.2-16-16s7.2-16 16-16z"
    ]
};
var $d8206b3ab2e65c05$export$4c17261776a709f2 = {
    prefix: "fas",
    iconName: "user-plus",
    icon: [
        640,
        512,
        [],
        "f234",
        "M96 128a128 128 0 1 1 256 0A128 128 0 1 1 96 128zM0 482.3C0 383.8 79.8 304 178.3 304h91.4C368.2 304 448 383.8 448 482.3c0 16.4-13.3 29.7-29.7 29.7H29.7C13.3 512 0 498.7 0 482.3zM504 312V248H440c-13.3 0-24-10.7-24-24s10.7-24 24-24h64V136c0-13.3 10.7-24 24-24s24 10.7 24 24v64h64c13.3 0 24 10.7 24 24s-10.7 24-24 24H552v64c0 13.3-10.7 24-24 24s-24-10.7-24-24z"
    ]
};
var $d8206b3ab2e65c05$export$62b2c752fccc6a9c = {
    prefix: "fas",
    iconName: "check",
    icon: [
        448,
        512,
        [
            10003,
            10004
        ],
        "f00c",
        "M438.6 105.4c12.5 12.5 12.5 32.8 0 45.3l-256 256c-12.5 12.5-32.8 12.5-45.3 0l-128-128c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0L160 338.7 393.4 105.4c12.5-12.5 32.8-12.5 45.3 0z"
    ]
};
var $d8206b3ab2e65c05$export$cfb37069d38f379e = {
    prefix: "fas",
    iconName: "battery-three-quarters",
    icon: [
        576,
        512,
        [
            "battery-4"
        ],
        "f241",
        "M464 160c8.8 0 16 7.2 16 16V336c0 8.8-7.2 16-16 16H80c-8.8 0-16-7.2-16-16V176c0-8.8 7.2-16 16-16H464zM80 96C35.8 96 0 131.8 0 176V336c0 44.2 35.8 80 80 80H464c44.2 0 80-35.8 80-80V320c17.7 0 32-14.3 32-32V224c0-17.7-14.3-32-32-32V176c0-44.2-35.8-80-80-80H80zm272 96H96V320H352V192z"
    ]
};
var $d8206b3ab2e65c05$export$35ffefed200d123c = $d8206b3ab2e65c05$export$cfb37069d38f379e;
var $d8206b3ab2e65c05$export$c9382fa3394ef53a = {
    prefix: "fas",
    iconName: "house-circle-check",
    icon: [
        640,
        512,
        [],
        "e509",
        "M320.7 352c8.1-89.7 83.5-160 175.3-160c8.9 0 17.6 .7 26.1 1.9L309.5 7c-6-5-14-7-21-7s-15 1-22 8L10 231.5c-7 7-10 15-10 24c0 18 14 32.1 32 32.1h32v69.7c-.1 .9-.1 1.8-.1 2.8V472c0 22.1 17.9 40 40 40h16c1.2 0 2.4-.1 3.6-.2c1.5 .1 3 .2 4.5 .2H160h24c22.1 0 40-17.9 40-40V448 384c0-17.7 14.3-32 32-32h64l.7 0zM640 368a144 144 0 1 0 -288 0 144 144 0 1 0 288 0zm-76.7-43.3c6.2 6.2 6.2 16.4 0 22.6l-72 72c-6.2 6.2-16.4 6.2-22.6 0l-40-40c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0L480 385.4l60.7-60.7c6.2-6.2 16.4-6.2 22.6 0z"
    ]
};
var $d8206b3ab2e65c05$export$3cbcd1b7e35945d2 = {
    prefix: "fas",
    iconName: "angle-left",
    icon: [
        320,
        512,
        [
            8249
        ],
        "f104",
        "M41.4 233.4c-12.5 12.5-12.5 32.8 0 45.3l160 160c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L109.3 256 246.6 118.6c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0l-160 160z"
    ]
};
var $d8206b3ab2e65c05$export$ff7f40159cadb0ac = {
    prefix: "fas",
    iconName: "diagram-successor",
    icon: [
        512,
        512,
        [],
        "e47a",
        "M512 416l0-64c0-35.3-28.7-64-64-64L64 288c-35.3 0-64 28.7-64 64l0 64c0 35.3 28.7 64 64 64l384 0c35.3 0 64-28.7 64-64zM64 160l0-64 144 0 16 0 0 64L64 160zm224 0l0-64 80 0c8.8 0 16 7.2 16 16l0 16-38.1 0c-21.4 0-32.1 25.9-17 41L399 239c9.4 9.4 24.6 9.4 33.9 0L503 169c15.1-15.1 4.4-41-17-41L448 128l0-16c0-44.2-35.8-80-80-80L224 32l-16 0L64 32C28.7 32 0 60.7 0 96l0 64c0 35.3 28.7 64 64 64l160 0c35.3 0 64-28.7 64-64z"
    ]
};
var $d8206b3ab2e65c05$export$d69fa2b7839ce76 = {
    prefix: "fas",
    iconName: "truck-arrow-right",
    icon: [
        640,
        512,
        [],
        "e58b",
        "M0 48C0 21.5 21.5 0 48 0H368c26.5 0 48 21.5 48 48V96h50.7c17 0 33.3 6.7 45.3 18.7L589.3 192c12 12 18.7 28.3 18.7 45.3V256v32 64c17.7 0 32 14.3 32 32s-14.3 32-32 32H576c0 53-43 96-96 96s-96-43-96-96H256c0 53-43 96-96 96s-96-43-96-96H48c-26.5 0-48-21.5-48-48V48zM416 256H544V237.3L466.7 160H416v96zM160 464a48 48 0 1 0 0-96 48 48 0 1 0 0 96zm368-48a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zM257 95c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9l39 39H96c-13.3 0-24 10.7-24 24s10.7 24 24 24H262.1l-39 39c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l80-80c9.4-9.4 9.4-24.6 0-33.9L257 95z"
    ]
};
var $d8206b3ab2e65c05$export$7df274119d2469d1 = {
    prefix: "fas",
    iconName: "arrows-split-up-and-left",
    icon: [
        512,
        512,
        [],
        "e4bc",
        "M246.6 150.6c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3l96-96c12.5-12.5 32.8-12.5 45.3 0l96 96c12.5 12.5 12.5 32.8 0 45.3s-32.8 12.5-45.3 0L352 109.3V384c0 35.3 28.7 64 64 64h64c17.7 0 32 14.3 32 32s-14.3 32-32 32H416c-70.7 0-128-57.3-128-128c0-35.3-28.7-64-64-64H109.3l41.4 41.4c12.5 12.5 12.5 32.8 0 45.3s-32.8 12.5-45.3 0l-96-96c-12.5-12.5-12.5-32.8 0-45.3l96-96c12.5-12.5 32.8-12.5 45.3 0s12.5 32.8 0 45.3L109.3 256H224c23.3 0 45.2 6.2 64 17.1V109.3l-41.4 41.4z"
    ]
};
var $d8206b3ab2e65c05$export$ca492f58fe30a42f = {
    prefix: "fas",
    iconName: "hand-fist",
    icon: [
        448,
        512,
        [
            9994,
            "fist-raised"
        ],
        "f6de",
        "M192 0c17.7 0 32 14.3 32 32V144H160V32c0-17.7 14.3-32 32-32zM64 64c0-17.7 14.3-32 32-32s32 14.3 32 32v80H64V64zm192 0c0-17.7 14.3-32 32-32s32 14.3 32 32v96c0 17.7-14.3 32-32 32s-32-14.3-32-32V64zm96 64c0-17.7 14.3-32 32-32s32 14.3 32 32v64c0 17.7-14.3 32-32 32s-32-14.3-32-32V128zm-96 88l0-.6c9.4 5.4 20.3 8.6 32 8.6c13.2 0 25.4-4 35.6-10.8c8.7 24.9 32.5 42.8 60.4 42.8c11.7 0 22.6-3.1 32-8.6V256c0 52.3-25.1 98.8-64 128v96c0 17.7-14.3 32-32 32H160c-17.7 0-32-14.3-32-32V401.6c-17.3-7.9-33.2-18.8-46.9-32.5L69.5 357.5C45.5 333.5 32 300.9 32 267V240c0-35.3 28.7-64 64-64h88c22.1 0 40 17.9 40 40s-17.9 40-40 40H128c-8.8 0-16 7.2-16 16s7.2 16 16 16h56c39.8 0 72-32.2 72-72z"
    ]
};
var $d8206b3ab2e65c05$export$fa0323a4d7489a8d = $d8206b3ab2e65c05$export$ca492f58fe30a42f;
var $d8206b3ab2e65c05$export$482eb125aaf0fbc2 = {
    prefix: "fas",
    iconName: "cloud-moon",
    icon: [
        640,
        512,
        [],
        "f6c3",
        "M495.8 0c5.5 0 10.9 .2 16.3 .7c7 .6 12.8 5.7 14.3 12.5s-1.6 13.9-7.7 17.3c-44.4 25.2-74.4 73-74.4 127.8c0 81 65.5 146.6 146.2 146.6c8.6 0 17-.7 25.1-2.1c6.9-1.2 13.8 2.2 17 8.5s1.9 13.8-3.1 18.7c-34.5 33.6-81.7 54.4-133.6 54.4c-9.3 0-18.4-.7-27.4-1.9c-11.2-22.6-29.8-40.9-52.6-51.7c-2.7-58.5-50.3-105.3-109.2-106.7c-1.7-10.4-2.6-21-2.6-31.8C304 86.1 389.8 0 495.8 0zM447.9 431.9c0 44.2-35.8 80-80 80H96c-53 0-96-43-96-96c0-47.6 34.6-87 80-94.6l0-1.3c0-53 43-96 96-96c34.9 0 65.4 18.6 82.2 46.4c13-9.1 28.8-14.4 45.8-14.4c44.2 0 80 35.8 80 80c0 5.9-.6 11.7-1.9 17.2c37.4 6.7 65.8 39.4 65.8 78.7z"
    ]
};
var $d8206b3ab2e65c05$export$8da450d063b0eb37 = {
    prefix: "fas",
    iconName: "briefcase",
    icon: [
        512,
        512,
        [
            128188
        ],
        "f0b1",
        "M184 48H328c4.4 0 8 3.6 8 8V96H176V56c0-4.4 3.6-8 8-8zm-56 8V96H64C28.7 96 0 124.7 0 160v96H192 320 512V160c0-35.3-28.7-64-64-64H384V56c0-30.9-25.1-56-56-56H184c-30.9 0-56 25.1-56 56zM512 288H320v32c0 17.7-14.3 32-32 32H224c-17.7 0-32-14.3-32-32V288H0V416c0 35.3 28.7 64 64 64H448c35.3 0 64-28.7 64-64V288z"
    ]
};
var $d8206b3ab2e65c05$export$e94ab3a30cf4aca5 = {
    prefix: "fas",
    iconName: "person-falling",
    icon: [
        512,
        512,
        [],
        "e546",
        "M288 0c17.7 0 32 14.3 32 32l0 9.8c0 54.6-27.9 104.6-72.5 133.6l.2 .3L304.5 256l87.5 0c15.1 0 29.3 7.1 38.4 19.2l43.2 57.6c10.6 14.1 7.7 34.2-6.4 44.8s-34.2 7.7-44.8-6.4L384 320l-96 0h-1.4l92.3 142.6c9.6 14.8 5.4 34.6-9.5 44.3s-34.6 5.4-44.3-9.5L164.5 249.2c-2.9 9.2-4.5 19-4.5 29l0 73.8c0 17.7-14.3 32-32 32s-32-14.3-32-32V278.2c0-65.1 39.6-123.7 100.1-147.9C232.3 115.8 256 80.8 256 41.8l0-9.8c0-17.7 14.3-32 32-32zM112 32a48 48 0 1 1 0 96 48 48 0 1 1 0-96z"
    ]
};
var $d8206b3ab2e65c05$export$c23fd8b91a7ed48 = {
    prefix: "fas",
    iconName: "image-portrait",
    icon: [
        384,
        512,
        [
            "portrait"
        ],
        "f3e0",
        "M384 64c0-35.3-28.7-64-64-64H64C28.7 0 0 28.7 0 64V448c0 35.3 28.7 64 64 64H320c35.3 0 64-28.7 64-64l0-384zM128 192a64 64 0 1 1 128 0 64 64 0 1 1 -128 0zM80 356.6c0-37.9 30.7-68.6 68.6-68.6h86.9c37.9 0 68.6 30.7 68.6 68.6c0 15.1-12.3 27.4-27.4 27.4H107.4C92.3 384 80 371.7 80 356.6z"
    ]
};
var $d8206b3ab2e65c05$export$e3d25f819c7ee7d7 = $d8206b3ab2e65c05$export$c23fd8b91a7ed48;
var $d8206b3ab2e65c05$export$9eec597148166b36 = {
    prefix: "fas",
    iconName: "user-tag",
    icon: [
        640,
        512,
        [],
        "f507",
        "M224 256A128 128 0 1 0 224 0a128 128 0 1 0 0 256zm-45.7 48C79.8 304 0 383.8 0 482.3C0 498.7 13.3 512 29.7 512H418.3c10 0 18.8-4.9 24.2-12.5l-99.2-99.2c-14.9-14.9-23.3-35.1-23.3-56.1v-33c-15.9-4.7-32.8-7.2-50.3-7.2H178.3zM384 224c-17.7 0-32 14.3-32 32v82.7c0 17 6.7 33.3 18.7 45.3L478.1 491.3c18.7 18.7 49.1 18.7 67.9 0l73.4-73.4c18.7-18.7 18.7-49.1 0-67.9L512 242.7c-12-12-28.3-18.7-45.3-18.7H384zm24 80a24 24 0 1 1 48 0 24 24 0 1 1 -48 0z"
    ]
};
var $d8206b3ab2e65c05$export$7cee7480f25f5289 = {
    prefix: "fas",
    iconName: "rug",
    icon: [
        640,
        512,
        [],
        "e569",
        "M24 64H56 80V88v88 80 80 88 24H56 24c-13.3 0-24-10.7-24-24s10.7-24 24-24h8V360H24c-13.3 0-24-10.7-24-24s10.7-24 24-24h8V280H24c-13.3 0-24-10.7-24-24s10.7-24 24-24h8V200H24c-13.3 0-24-10.7-24-24s10.7-24 24-24h8V112H24C10.7 112 0 101.3 0 88S10.7 64 24 64zm88 0H528V448H112V64zM640 88c0 13.3-10.7 24-24 24h-8v40h8c13.3 0 24 10.7 24 24s-10.7 24-24 24h-8v32h8c13.3 0 24 10.7 24 24s-10.7 24-24 24h-8v32h8c13.3 0 24 10.7 24 24s-10.7 24-24 24h-8v40h8c13.3 0 24 10.7 24 24s-10.7 24-24 24H584 560V424 336 256 176 88 64h24 32c13.3 0 24 10.7 24 24z"
    ]
};
var $d8206b3ab2e65c05$export$7adefae4a1be1d97 = {
    prefix: "fas",
    iconName: "earth-europe",
    icon: [
        512,
        512,
        [
            "globe-europe"
        ],
        "f7a2",
        "M266.3 48.3L232.5 73.6c-5.4 4-8.5 10.4-8.5 17.1v9.1c0 6.8 5.5 12.3 12.3 12.3c2.4 0 4.8-.7 6.8-2.1l41.8-27.9c2-1.3 4.4-2.1 6.8-2.1h1c6.2 0 11.3 5.1 11.3 11.3c0 3-1.2 5.9-3.3 8l-19.9 19.9c-5.8 5.8-12.9 10.2-20.7 12.8l-26.5 8.8c-5.8 1.9-9.6 7.3-9.6 13.4c0 3.7-1.5 7.3-4.1 10l-17.9 17.9c-6.4 6.4-9.9 15-9.9 24v4.3c0 16.4 13.6 29.7 29.9 29.7c11 0 21.2-6.2 26.1-16l4-8.1c2.4-4.8 7.4-7.9 12.8-7.9c4.5 0 8.7 2.1 11.4 5.7l16.3 21.7c2.1 2.9 5.5 4.5 9.1 4.5c8.4 0 13.9-8.9 10.1-16.4l-1.1-2.3c-3.5-7 0-15.5 7.5-18l21.2-7.1c7.6-2.5 12.7-9.6 12.7-17.6c0-10.3 8.3-18.6 18.6-18.6H400c8.8 0 16 7.2 16 16s-7.2 16-16 16H379.3c-7.2 0-14.2 2.9-19.3 8l-4.7 4.7c-2.1 2.1-3.3 5-3.3 8c0 6.2 5.1 11.3 11.3 11.3h11.3c6 0 11.8 2.4 16 6.6l6.5 6.5c1.8 1.8 2.8 4.3 2.8 6.8s-1 5-2.8 6.8l-7.5 7.5C386 262 384 266.9 384 272s2 10 5.7 13.7L408 304c10.2 10.2 24.1 16 38.6 16H454c6.5-20.2 10-41.7 10-64c0-111.4-87.6-202.4-197.7-207.7zm172 307.9c-3.7-2.6-8.2-4.1-13-4.1c-6 0-11.8-2.4-16-6.6L396 332c-7.7-7.7-18-12-28.9-12c-9.7 0-19.2-3.5-26.6-9.8L314 287.4c-11.6-9.9-26.4-15.4-41.7-15.4H251.4c-12.6 0-25 3.7-35.5 10.7L188.5 301c-17.8 11.9-28.5 31.9-28.5 53.3v3.2c0 17 6.7 33.3 18.7 45.3l16 16c8.5 8.5 20 13.3 32 13.3H248c13.3 0 24 10.7 24 24c0 2.5 .4 5 1.1 7.3c71.3-5.8 132.5-47.6 165.2-107.2zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zM187.3 100.7c-6.2-6.2-16.4-6.2-22.6 0l-32 32c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0l32-32c6.2-6.2 6.2-16.4 0-22.6z"
    ]
};
var $d8206b3ab2e65c05$export$5318b8ede86cc96b = $d8206b3ab2e65c05$export$7adefae4a1be1d97;
var $d8206b3ab2e65c05$export$ab81ff863770d996 = {
    prefix: "fas",
    iconName: "cart-flatbed-suitcase",
    icon: [
        640,
        512,
        [
            "luggage-cart"
        ],
        "f59d",
        "M0 32C0 14.3 14.3 0 32 0H48c44.2 0 80 35.8 80 80V368c0 8.8 7.2 16 16 16H608c17.7 0 32 14.3 32 32s-14.3 32-32 32H541.3c1.8 5 2.7 10.4 2.7 16c0 26.5-21.5 48-48 48s-48-21.5-48-48c0-5.6 1-11 2.7-16H253.3c1.8 5 2.7 10.4 2.7 16c0 26.5-21.5 48-48 48s-48-21.5-48-48c0-5.6 1-11 2.7-16H144c-44.2 0-80-35.8-80-80V80c0-8.8-7.2-16-16-16H32C14.3 64 0 49.7 0 32zM432 96V56c0-4.4-3.6-8-8-8H344c-4.4 0-8 3.6-8 8V96h96zM288 96V56c0-30.9 25.1-56 56-56h80c30.9 0 56 25.1 56 56V96 320H288V96zM512 320V96h16c26.5 0 48 21.5 48 48V272c0 26.5-21.5 48-48 48H512zM240 96h16V320H240c-26.5 0-48-21.5-48-48V144c0-26.5 21.5-48 48-48z"
    ]
};
var $d8206b3ab2e65c05$export$bd1e24dd3cde8514 = $d8206b3ab2e65c05$export$ab81ff863770d996;
var $d8206b3ab2e65c05$export$3896694b3e81fba7 = {
    prefix: "fas",
    iconName: "rectangle-xmark",
    icon: [
        512,
        512,
        [
            62164,
            "rectangle-times",
            "times-rectangle",
            "window-close"
        ],
        "f410",
        "M64 32C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H448c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64zM175 175c9.4-9.4 24.6-9.4 33.9 0l47 47 47-47c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9l-47 47 47 47c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0l-47-47-47 47c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l47-47-47-47c-9.4-9.4-9.4-24.6 0-33.9z"
    ]
};
var $d8206b3ab2e65c05$export$eaaf26416a51dc1 = $d8206b3ab2e65c05$export$3896694b3e81fba7;
var $d8206b3ab2e65c05$export$10147c0014152a3f = $d8206b3ab2e65c05$export$3896694b3e81fba7;
var $d8206b3ab2e65c05$export$18b7775f78a3e16 = $d8206b3ab2e65c05$export$3896694b3e81fba7;
var $d8206b3ab2e65c05$export$ffc7123046a28ee = {
    prefix: "fas",
    iconName: "baht-sign",
    icon: [
        320,
        512,
        [],
        "e0ac",
        "M144 0c-17.7 0-32 14.3-32 32V64H37.6C16.8 64 0 80.8 0 101.6V224v41.7V288 406.3c0 23 18.7 41.7 41.7 41.7H112v32c0 17.7 14.3 32 32 32s32-14.3 32-32V448h32c61.9 0 112-50.1 112-112c0-40.1-21.1-75.3-52.7-95.1C280.3 222.6 288 200.2 288 176c0-61.9-50.1-112-112-112V32c0-17.7-14.3-32-32-32zM112 128v96H64V128h48zm64 96V128c26.5 0 48 21.5 48 48s-21.5 48-48 48zm-64 64v96H64V288h48zm64 96V288h32c26.5 0 48 21.5 48 48s-21.5 48-48 48H176z"
    ]
};
var $d8206b3ab2e65c05$export$8a3071811b2b7979 = {
    prefix: "fas",
    iconName: "book-open",
    icon: [
        576,
        512,
        [
            128214,
            128366
        ],
        "f518",
        "M249.6 471.5c10.8 3.8 22.4-4.1 22.4-15.5V78.6c0-4.2-1.6-8.4-5-11C247.4 52 202.4 32 144 32C93.5 32 46.3 45.3 18.1 56.1C6.8 60.5 0 71.7 0 83.8V454.1c0 11.9 12.8 20.2 24.1 16.5C55.6 460.1 105.5 448 144 448c33.9 0 79 14 105.6 23.5zm76.8 0C353 462 398.1 448 432 448c38.5 0 88.4 12.1 119.9 22.6c11.3 3.8 24.1-4.6 24.1-16.5V83.8c0-12.1-6.8-23.3-18.1-27.6C529.7 45.3 482.5 32 432 32c-58.4 0-103.4 20-123 35.6c-3.3 2.6-5 6.8-5 11V456c0 11.4 11.7 19.3 22.4 15.5z"
    ]
};
var $d8206b3ab2e65c05$export$d3d49030d557a09b = {
    prefix: "fas",
    iconName: "book-journal-whills",
    icon: [
        448,
        512,
        [
            "journal-whills"
        ],
        "f66a",
        "M0 96C0 43 43 0 96 0H384h32c17.7 0 32 14.3 32 32V352c0 17.7-14.3 32-32 32v64c17.7 0 32 14.3 32 32s-14.3 32-32 32H384 96c-53 0-96-43-96-96V96zM64 416c0 17.7 14.3 32 32 32H352V384H96c-17.7 0-32 14.3-32 32zm90.4-234.4l-21.2-21.2c-3 10.1-5.1 20.6-5.1 31.6c0 .2 0 .5 .1 .8s.1 .5 .1 .8L165.2 226c2.5 2.1 3.4 5.8 2.3 8.9c-1.3 3-4.1 5.1-7.5 5.1c-1.9-.1-3.8-.8-5.2-2l-23.6-20.6C142.8 267 186.9 304 240 304s97.3-37 108.9-86.6L325.3 238c-1.4 1.2-3.3 2-5.3 2c-2.2-.1-4.4-1.1-6-2.8c-1.2-1.5-1.9-3.4-2-5.2c.1-2.2 1.1-4.4 2.8-6l37.1-32.5c0-.3 0-.5 .1-.8s.1-.5 .1-.8c0-11-2.1-21.5-5.1-31.6l-21.2 21.2c-3.1 3.1-8.1 3.1-11.3 0s-3.1-8.1 0-11.2l26.4-26.5c-8.2-17-20.5-31.7-35.9-42.6c-2.7-1.9-6.2 1.4-5 4.5c8.5 22.4 3.6 48-13 65.6c-3.2 3.4-3.6 8.9-.9 12.7c9.8 14 12.7 31.9 7.5 48.5c-5.9 19.4-22 34.1-41.9 38.3l-1.4-34.3 12.6 8.6c.6 .4 1.5 .6 2.3 .6c1.5 0 2.7-.8 3.5-2s.6-2.8-.1-4L260 225.4l18-3.6c1.8-.4 3.1-2.1 3.1-4s-1.4-3.5-3.1-3.9l-18-3.7 8.5-14.3c.8-1.2 .9-2.9 .1-4.1s-2-2-3.5-2l-.1 0c-.7 .1-1.5 .3-2.1 .7l-14.1 9.6L244 87.9c-.1-2.2-1.9-3.9-4-3.9s-3.9 1.6-4 3.9l-4.6 110.8-12-8.1c-1.5-1.1-3.6-.9-5 .4s-1.6 3.4-.8 5l8.6 14.3-18 3.7c-1.8 .4-3.1 2-3.1 3.9s1.4 3.6 3.1 4l18 3.8-8.6 14.2c-.2 .6-.5 1.4-.5 2c0 1.1 .5 2.1 1.2 3c.8 .6 1.8 1 2.8 1c.7 0 1.6-.2 2.2-.6l10.4-7.1-1.4 32.8c-19.9-4.1-36-18.9-41.9-38.3c-5.1-16.6-2.2-34.4 7.6-48.5c2.7-3.9 2.3-9.3-.9-12.7c-16.6-17.5-21.6-43.1-13.1-65.5c1.2-3.1-2.3-6.4-5-4.5c-15.3 10.9-27.6 25.6-35.8 42.6l26.4 26.5c3.1 3.1 3.1 8.1 0 11.2s-8.1 3.1-11.2 0z"
    ]
};
var $d8206b3ab2e65c05$export$66a0d8d45aab6631 = $d8206b3ab2e65c05$export$d3d49030d557a09b;
var $d8206b3ab2e65c05$export$74d1f89b5feb9d42 = {
    prefix: "fas",
    iconName: "handcuffs",
    icon: [
        640,
        512,
        [],
        "e4f8",
        "M240 32a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zM192 48a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm-32 80c17.7 0 32 14.3 32 32h8c13.3 0 24 10.7 24 24v16c0 1.7-.2 3.4-.5 5.1C280.3 229.6 320 286.2 320 352c0 88.4-71.6 160-160 160S0 440.4 0 352c0-65.8 39.7-122.4 96.5-146.9c-.4-1.6-.5-3.3-.5-5.1V184c0-13.3 10.7-24 24-24h8c0-17.7 14.3-32 32-32zm0 320a96 96 0 1 0 0-192 96 96 0 1 0 0 192zm192-96c0-25.9-5.1-50.5-14.4-73.1c16.9-32.9 44.8-59.1 78.9-73.9c-.4-1.6-.5-3.3-.5-5.1V184c0-13.3 10.7-24 24-24h8c0-17.7 14.3-32 32-32s32 14.3 32 32h8c13.3 0 24 10.7 24 24v16c0 1.7-.2 3.4-.5 5.1C600.3 229.6 640 286.2 640 352c0 88.4-71.6 160-160 160c-62 0-115.8-35.3-142.4-86.9c9.3-22.5 14.4-47.2 14.4-73.1zm224 0a96 96 0 1 0 -192 0 96 96 0 1 0 192 0zM368 0a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm80 48a32 32 0 1 1 0 64 32 32 0 1 1 0-64z"
    ]
};
var $d8206b3ab2e65c05$export$1cbf6e649ce86166 = {
    prefix: "fas",
    iconName: "triangle-exclamation",
    icon: [
        512,
        512,
        [
            9888,
            "exclamation-triangle",
            "warning"
        ],
        "f071",
        "M256 32c14.2 0 27.3 7.5 34.5 19.8l216 368c7.3 12.4 7.3 27.7 .2 40.1S486.3 480 472 480H40c-14.3 0-27.6-7.7-34.7-20.1s-7-27.8 .2-40.1l216-368C228.7 39.5 241.8 32 256 32zm0 128c-13.3 0-24 10.7-24 24V296c0 13.3 10.7 24 24 24s24-10.7 24-24V184c0-13.3-10.7-24-24-24zm32 224a32 32 0 1 0 -64 0 32 32 0 1 0 64 0z"
    ]
};
var $d8206b3ab2e65c05$export$3d249b63b52cce7c = $d8206b3ab2e65c05$export$1cbf6e649ce86166;
var $d8206b3ab2e65c05$export$2e470a35c38b096a = $d8206b3ab2e65c05$export$1cbf6e649ce86166;
var $d8206b3ab2e65c05$export$24680dede86b1883 = {
    prefix: "fas",
    iconName: "database",
    icon: [
        448,
        512,
        [],
        "f1c0",
        "M448 80v48c0 44.2-100.3 80-224 80S0 172.2 0 128V80C0 35.8 100.3 0 224 0S448 35.8 448 80zM393.2 214.7c20.8-7.4 39.9-16.9 54.8-28.6V288c0 44.2-100.3 80-224 80S0 332.2 0 288V186.1c14.9 11.8 34 21.2 54.8 28.6C99.7 230.7 159.5 240 224 240s124.3-9.3 169.2-25.3zM0 346.1c14.9 11.8 34 21.2 54.8 28.6C99.7 390.7 159.5 400 224 400s124.3-9.3 169.2-25.3c20.8-7.4 39.9-16.9 54.8-28.6V432c0 44.2-100.3 80-224 80S0 476.2 0 432V346.1z"
    ]
};
var $d8206b3ab2e65c05$export$c08b4b0e2b0dc027 = {
    prefix: "fas",
    iconName: "share",
    icon: [
        512,
        512,
        [
            "arrow-turn-right",
            "mail-forward"
        ],
        "f064",
        "M307 34.8c-11.5 5.1-19 16.6-19 29.2v64H176C78.8 128 0 206.8 0 304C0 417.3 81.5 467.9 100.2 478.1c2.5 1.4 5.3 1.9 8.1 1.9c10.9 0 19.7-8.9 19.7-19.7c0-7.5-4.3-14.4-9.8-19.5C108.8 431.9 96 414.4 96 384c0-53 43-96 96-96h96v64c0 12.6 7.4 24.1 19 29.2s25 3 34.4-5.4l160-144c6.7-6.1 10.6-14.7 10.6-23.8s-3.8-17.7-10.6-23.8l-160-144c-9.4-8.5-22.9-10.6-34.4-5.4z"
    ]
};
var $d8206b3ab2e65c05$export$f20385ecfa20c36e = $d8206b3ab2e65c05$export$c08b4b0e2b0dc027;
var $d8206b3ab2e65c05$export$81df7693d3f2f8da = $d8206b3ab2e65c05$export$c08b4b0e2b0dc027;
var $d8206b3ab2e65c05$export$8f534e1e0ab75bfe = {
    prefix: "fas",
    iconName: "bottle-droplet",
    icon: [
        320,
        512,
        [],
        "e4c4",
        "M96 0C82.7 0 72 10.7 72 24s10.7 24 24 24c4.4 0 8 3.6 8 8v64.9c0 12.2-7.2 23.1-17.2 30.1C53.7 174.1 32 212.5 32 256V448c0 35.3 28.7 64 64 64H224c35.3 0 64-28.7 64-64V256c0-43.5-21.7-81.9-54.8-105c-10-7-17.2-17.9-17.2-30.1V56c0-4.4 3.6-8 8-8c13.3 0 24-10.7 24-24s-10.7-24-24-24l-8 0 0 0 0 0H104l0 0 0 0L96 0zm64 382c-26.5 0-48-20.1-48-45c0-16.8 22.1-48.1 36.3-66.4c6-7.8 17.5-7.8 23.5 0C185.9 288.9 208 320.2 208 337c0 24.9-21.5 45-48 45z"
    ]
};
var $d8206b3ab2e65c05$export$140d4da0adbaf435 = {
    prefix: "fas",
    iconName: "mask-face",
    icon: [
        640,
        512,
        [],
        "e1d7",
        "M320 64c-27.2 0-53.8 8-76.4 23.1l-37.1 24.8c-15.8 10.5-34.3 16.1-53.3 16.1H144 128 56c-30.9 0-56 25.1-56 56v85c0 55.1 37.5 103.1 90.9 116.4l108 27C233.8 435 275.4 448 320 448s86.2-13 121.1-35.5l108-27C602.5 372.1 640 324.1 640 269V184c0-30.9-25.1-56-56-56H512 496h-9.2c-19 0-37.5-5.6-53.3-16.1L396.4 87.1C373.8 72 347.2 64 320 64zM132.3 346.3l-29.8-7.4C70.5 330.9 48 302.1 48 269V184c0-4.4 3.6-8 8-8H96v48c0 45.1 13.4 87.2 36.3 122.3zm405.1-7.4l-29.8 7.4c23-35.2 36.3-77.2 36.3-122.3V176h40c4.4 0 8 3.6 8 8v85c0 33-22.5 61.8-54.5 69.9zM192 208c0-8.8 7.2-16 16-16H432c8.8 0 16 7.2 16 16s-7.2 16-16 16H208c-8.8 0-16-7.2-16-16zm16 48H432c8.8 0 16 7.2 16 16s-7.2 16-16 16H208c-8.8 0-16-7.2-16-16s7.2-16 16-16zm16 80c0-8.8 7.2-16 16-16H400c8.8 0 16 7.2 16 16s-7.2 16-16 16H240c-8.8 0-16-7.2-16-16z"
    ]
};
var $d8206b3ab2e65c05$export$7ec15a32285f6c22 = {
    prefix: "fas",
    iconName: "hill-rockslide",
    icon: [
        576,
        512,
        [],
        "e508",
        "M252.4 103.8l27 48c2.8 5 8.2 8.2 13.9 8.2l53.3 0c5.8 0 11.1-3.1 13.9-8.2l27-48c2.7-4.9 2.7-10.8 0-15.7l-27-48c-2.8-5-8.2-8.2-13.9-8.2H293.4c-5.8 0-11.1 3.1-13.9 8.2l-27 48c-2.7 4.9-2.7 10.8 0 15.7zM68.3 87C43.1 61.8 0 79.7 0 115.3V432c0 44.2 35.8 80 80 80H396.7c35.6 0 53.5-43.1 28.3-68.3L68.3 87zM504.2 403.6c4.9 2.7 10.8 2.7 15.7 0l48-27c5-2.8 8.2-8.2 8.2-13.9V309.4c0-5.8-3.1-11.1-8.2-13.9l-48-27c-4.9-2.7-10.8-2.7-15.7 0l-48 27c-5 2.8-8.2 8.2-8.2 13.9v53.3c0 5.8 3.1 11.1 8.2 13.9l48 27zM192 64a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zM384 288a32 32 0 1 0 0-64 32 32 0 1 0 0 64z"
    ]
};
var $d8206b3ab2e65c05$export$a082af56be9786ae = {
    prefix: "fas",
    iconName: "right-left",
    icon: [
        512,
        512,
        [
            "exchange-alt"
        ],
        "f362",
        "M32 96l320 0V32c0-12.9 7.8-24.6 19.8-29.6s25.7-2.2 34.9 6.9l96 96c6 6 9.4 14.1 9.4 22.6s-3.4 16.6-9.4 22.6l-96 96c-9.2 9.2-22.9 11.9-34.9 6.9s-19.8-16.6-19.8-29.6V160L32 160c-17.7 0-32-14.3-32-32s14.3-32 32-32zM480 352c17.7 0 32 14.3 32 32s-14.3 32-32 32H160v64c0 12.9-7.8 24.6-19.8 29.6s-25.7 2.2-34.9-6.9l-96-96c-6-6-9.4-14.1-9.4-22.6s3.4-16.6 9.4-22.6l96-96c9.2-9.2 22.9-11.9 34.9-6.9s19.8 16.6 19.8 29.6l0 64H480z"
    ]
};
var $d8206b3ab2e65c05$export$f6c6fb20d374b128 = $d8206b3ab2e65c05$export$a082af56be9786ae;
var $d8206b3ab2e65c05$export$b5378818301da1be = {
    prefix: "fas",
    iconName: "paper-plane",
    icon: [
        512,
        512,
        [
            61913
        ],
        "f1d8",
        "M498.1 5.6c10.1 7 15.4 19.1 13.5 31.2l-64 416c-1.5 9.7-7.4 18.2-16 23s-18.9 5.4-28 1.6L284 427.7l-68.5 74.1c-8.9 9.7-22.9 12.9-35.2 8.1S160 493.2 160 480V396.4c0-4 1.5-7.8 4.2-10.7L331.8 202.8c5.8-6.3 5.6-16-.4-22s-15.7-6.4-22-.7L106 360.8 17.7 316.6C7.1 311.3 .3 300.7 0 288.9s5.9-22.8 16.1-28.7l448-256c10.7-6.1 23.9-5.5 34 1.4z"
    ]
};
var $d8206b3ab2e65c05$export$79753c2153535b01 = {
    prefix: "fas",
    iconName: "road-circle-exclamation",
    icon: [
        640,
        512,
        [],
        "e565",
        "M213.2 32H288V96c0 17.7 14.3 32 32 32s32-14.3 32-32V32h74.8c27.1 0 51.3 17.1 60.3 42.6l42.7 120.6c-10.9-2.1-22.2-3.2-33.8-3.2c-59.5 0-112.1 29.6-144 74.8V224c0-17.7-14.3-32-32-32s-32 14.3-32 32v64c0 17.7 14.3 32 32 32c2.3 0 4.6-.3 6.8-.7c-4.5 15.5-6.8 31.8-6.8 48.7c0 5.4 .2 10.7 .7 16l-.7 0c-17.7 0-32 14.3-32 32v64H86.6C56.5 480 32 455.5 32 425.4c0-6.2 1.1-12.4 3.1-18.2L152.9 74.6C162 49.1 186.1 32 213.2 32zM496 224a144 144 0 1 1 0 288 144 144 0 1 1 0-288zm0 240a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm0-192c-8.8 0-16 7.2-16 16v80c0 8.8 7.2 16 16 16s16-7.2 16-16V288c0-8.8-7.2-16-16-16z"
    ]
};
var $d8206b3ab2e65c05$export$1156dc6acb0058bd = {
    prefix: "fas",
    iconName: "dungeon",
    icon: [
        512,
        512,
        [],
        "f6d9",
        "M336.6 156.5c1.3 1.1 2.7 2.2 3.9 3.3c9.3 8.2 23 10.5 33.4 3.6l67.6-45.1c11.4-7.6 14.2-23.2 5.1-33.4C430 66.6 410.9 50.6 389.7 37.6c-11.9-7.3-26.9-1.4-32.1 11.6l-30.5 76.2c-4.5 11.1 .2 23.6 9.5 31.2zM328 36.8c5.1-12.8-1.6-27.4-15-30.5C294.7 2.2 275.6 0 256 0s-38.7 2.2-57 6.4C185.5 9.4 178.8 24 184 36.8l30.3 75.8c4.5 11.3 16.8 17.2 29 16c4.2-.4 8.4-.6 12.7-.6s8.6 .2 12.7 .6c12.1 1.2 24.4-4.7 29-16L328 36.8zM65.5 85c-9.1 10.2-6.3 25.8 5.1 33.4l67.6 45.1c10.3 6.9 24.1 4.6 33.4-3.6c1.3-1.1 2.6-2.3 4-3.3c9.3-7.5 13.9-20.1 9.5-31.2L154.4 49.2c-5.2-12.9-20.3-18.8-32.1-11.6C101.1 50.6 82 66.6 65.5 85zm314 137.1c.9 3.3 1.7 6.6 2.3 10c2.5 13 13 23.9 26.2 23.9h80c13.3 0 24.1-10.8 22.9-24c-2.5-27.2-9.3-53.2-19.7-77.3c-5.5-12.9-21.4-16.6-33.1-8.9l-68.6 45.7c-9.8 6.5-13.2 19.2-10 30.5zM53.9 145.8c-11.6-7.8-27.6-4-33.1 8.9C10.4 178.8 3.6 204.8 1.1 232c-1.2 13.2 9.6 24 22.9 24h80c13.3 0 23.8-10.8 26.2-23.9c.6-3.4 1.4-6.7 2.3-10c3.1-11.4-.2-24-10-30.5L53.9 145.8zM104 288H24c-13.3 0-24 10.7-24 24v48c0 13.3 10.7 24 24 24h80c13.3 0 24-10.7 24-24V312c0-13.3-10.7-24-24-24zm304 0c-13.3 0-24 10.7-24 24v48c0 13.3 10.7 24 24 24h80c13.3 0 24-10.7 24-24V312c0-13.3-10.7-24-24-24H408zM24 416c-13.3 0-24 10.7-24 24v48c0 13.3 10.7 24 24 24h80c13.3 0 24-10.7 24-24V440c0-13.3-10.7-24-24-24H24zm384 0c-13.3 0-24 10.7-24 24v48c0 13.3 10.7 24 24 24h80c13.3 0 24-10.7 24-24V440c0-13.3-10.7-24-24-24H408zM272 192c0-8.8-7.2-16-16-16s-16 7.2-16 16V464c0 8.8 7.2 16 16 16s16-7.2 16-16V192zm-64 32c0-8.8-7.2-16-16-16s-16 7.2-16 16V464c0 8.8 7.2 16 16 16s16-7.2 16-16V224zm128 0c0-8.8-7.2-16-16-16s-16 7.2-16 16V464c0 8.8 7.2 16 16 16s16-7.2 16-16V224z"
    ]
};
var $d8206b3ab2e65c05$export$7370f36a39a38737 = {
    prefix: "fas",
    iconName: "align-right",
    icon: [
        448,
        512,
        [],
        "f038",
        "M448 64c0 17.7-14.3 32-32 32H192c-17.7 0-32-14.3-32-32s14.3-32 32-32H416c17.7 0 32 14.3 32 32zm0 256c0 17.7-14.3 32-32 32H192c-17.7 0-32-14.3-32-32s14.3-32 32-32H416c17.7 0 32 14.3 32 32zM0 192c0-17.7 14.3-32 32-32H416c17.7 0 32 14.3 32 32s-14.3 32-32 32H32c-17.7 0-32-14.3-32-32zM448 448c0 17.7-14.3 32-32 32H32c-17.7 0-32-14.3-32-32s14.3-32 32-32H416c17.7 0 32 14.3 32 32z"
    ]
};
var $d8206b3ab2e65c05$export$52e3e96cd1564779 = {
    prefix: "fas",
    iconName: "money-bill-1-wave",
    icon: [
        576,
        512,
        [
            "money-bill-wave-alt"
        ],
        "f53b",
        "M0 112.5V422.3c0 18 10.1 35 27 41.3c87 32.5 174 10.3 261-11.9c79.8-20.3 159.6-40.7 239.3-18.9c23 6.3 48.7-9.5 48.7-33.4V89.7c0-18-10.1-35-27-41.3C462 15.9 375 38.1 288 60.3C208.2 80.6 128.4 100.9 48.7 79.1C25.6 72.8 0 88.6 0 112.5zM128 416H64V352c35.3 0 64 28.7 64 64zM64 224V160h64c0 35.3-28.7 64-64 64zM448 352c0-35.3 28.7-64 64-64v64H448zm64-192c-35.3 0-64-28.7-64-64h64v64zM384 256c0 61.9-43 112-96 112s-96-50.1-96-112s43-112 96-112s96 50.1 96 112zM252 208c0 9.7 6.9 17.7 16 19.6V276h-4c-11 0-20 9-20 20s9 20 20 20h24 24c11 0 20-9 20-20s-9-20-20-20h-4V208c0-11-9-20-20-20H272c-11 0-20 9-20 20z"
    ]
};
var $d8206b3ab2e65c05$export$1613858e873cbb3e = $d8206b3ab2e65c05$export$52e3e96cd1564779;
var $d8206b3ab2e65c05$export$53dd2cacf674142a = {
    prefix: "fas",
    iconName: "life-ring",
    icon: [
        512,
        512,
        [],
        "f1cd",
        "M367.2 412.5C335.9 434.9 297.5 448 256 448s-79.9-13.1-111.2-35.5l58-58c15.8 8.6 34 13.5 53.3 13.5s37.4-4.9 53.3-13.5l58 58zm90.7 .8c33.8-43.4 54-98 54-157.3s-20.2-113.9-54-157.3c9-12.5 7.9-30.1-3.4-41.3S425.8 45 413.3 54C369.9 20.2 315.3 0 256 0S142.1 20.2 98.7 54c-12.5-9-30.1-7.9-41.3 3.4S45 86.2 54 98.7C20.2 142.1 0 196.7 0 256s20.2 113.9 54 157.3c-9 12.5-7.9 30.1 3.4 41.3S86.2 467 98.7 458c43.4 33.8 98 54 157.3 54s113.9-20.2 157.3-54c12.5 9 30.1 7.9 41.3-3.4s12.4-28.8 3.4-41.3zm-45.5-46.1l-58-58c8.6-15.8 13.5-34 13.5-53.3s-4.9-37.4-13.5-53.3l58-58C434.9 176.1 448 214.5 448 256s-13.1 79.9-35.5 111.2zM367.2 99.5l-58 58c-15.8-8.6-34-13.5-53.3-13.5s-37.4 4.9-53.3 13.5l-58-58C176.1 77.1 214.5 64 256 64s79.9 13.1 111.2 35.5zM157.5 309.3l-58 58C77.1 335.9 64 297.5 64 256s13.1-79.9 35.5-111.2l58 58c-8.6 15.8-13.5 34-13.5 53.3s4.9 37.4 13.5 53.3zM208 256a48 48 0 1 1 96 0 48 48 0 1 1 -96 0z"
    ]
};
var $d8206b3ab2e65c05$export$f9712d0cf5150f0c = {
    prefix: "fas",
    iconName: "hands",
    icon: [
        576,
        512,
        [
            "sign-language",
            "signing"
        ],
        "f2a7",
        "M544 160l-.1 72.6c-.1 52.2-24 101-64 133.1c.1-1.9 .1-3.8 .1-5.7v-8c0-71.8-37-138.6-97.9-176.7l-60.2-37.6c-8.6-5.4-17.9-8.4-27.3-9.4L248.7 48.8c-6.6-11.5-2.7-26.2 8.8-32.8s26.2-2.7 32.8 8.8l78 135.1c3.3 5.7 10.7 7.7 16.4 4.4s7.7-10.7 4.4-16.4l-62-107.4c-6.6-11.5-2.7-26.2 8.8-32.8S362 5 368.6 16.5l68 117.8 0 0 0 0 43.3 75L480 160c0-17.7 14.4-32 32-32s32 14.4 32 32zM243.9 88.5L268.5 131c-13.9 4.5-26.4 13.7-34.7 27c-.9 1.4-1.7 2.9-2.5 4.4l-28.9-50c-6.6-11.5-2.7-26.2 8.8-32.8s26.2-2.7 32.8 8.8zm-46.4 63.7l26.8 46.4c.6 6 2.1 11.8 4.3 17.4H224 210.7l0 0H179l-23-39.8c-6.6-11.5-2.7-26.2 8.8-32.8s26.2-2.7 32.8 8.8zM260.9 175c9.4-15 29.1-19.5 44.1-10.2l60.2 37.6C416.7 234.7 448 291.2 448 352v8c0 83.9-68.1 152-152 152H120c-13.3 0-24-10.7-24-24s10.7-24 24-24h92c6.6 0 12-5.4 12-12s-5.4-12-12-12H88c-13.3 0-24-10.7-24-24s10.7-24 24-24H212c6.6 0 12-5.4 12-12s-5.4-12-12-12H56c-13.3 0-24-10.7-24-24s10.7-24 24-24H212c6.6 0 12-5.4 12-12s-5.4-12-12-12H88c-13.3 0-24-10.7-24-24s10.7-24 24-24H224l0 0 0 0h93.2L271 219.1c-15-9.4-19.5-29.1-10.2-44.1z"
    ]
};
var $d8206b3ab2e65c05$export$20993813350f9671 = $d8206b3ab2e65c05$export$f9712d0cf5150f0c;
var $d8206b3ab2e65c05$export$5cc0e6f5191f4f02 = $d8206b3ab2e65c05$export$f9712d0cf5150f0c;
var $d8206b3ab2e65c05$export$80968bcfef6481ca = {
    prefix: "fas",
    iconName: "calendar-day",
    icon: [
        448,
        512,
        [],
        "f783",
        "M128 0c17.7 0 32 14.3 32 32V64H288V32c0-17.7 14.3-32 32-32s32 14.3 32 32V64h48c26.5 0 48 21.5 48 48v48H0V112C0 85.5 21.5 64 48 64H96V32c0-17.7 14.3-32 32-32zM0 192H448V464c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V192zm80 64c-8.8 0-16 7.2-16 16v96c0 8.8 7.2 16 16 16h96c8.8 0 16-7.2 16-16V272c0-8.8-7.2-16-16-16H80z"
    ]
};
var $d8206b3ab2e65c05$export$5930e9bdfd790d77 = {
    prefix: "fas",
    iconName: "water-ladder",
    icon: [
        576,
        512,
        [
            "ladder-water",
            "swimming-pool"
        ],
        "f5c5",
        "M128 127.7C128 74.9 170.9 32 223.7 32c48.3 0 89 36 95 83.9l1 8.2c2.2 17.5-10.2 33.5-27.8 35.7s-33.5-10.2-35.7-27.8l-1-8.2c-2-15.9-15.5-27.8-31.5-27.8c-17.5 0-31.7 14.2-31.7 31.7V224H384V127.7C384 74.9 426.9 32 479.7 32c48.3 0 89 36 95 83.9l1 8.2c2.2 17.5-10.2 33.5-27.8 35.7s-33.5-10.2-35.7-27.8l-1-8.2c-2-15.9-15.5-27.8-31.5-27.8c-17.5 0-31.7 14.2-31.7 31.7V361c-1.6 1-3.3 2-4.8 3.1c-18 12.4-40.1 20.3-59.2 20.3h0V288H192v96.5c-19 0-41.2-7.9-59.1-20.3c-1.6-1.1-3.2-2.2-4.9-3.1V127.7zM306.5 389.9C329 405.4 356.5 416 384 416c26.9 0 55.4-10.8 77.4-26.1l0 0c11.9-8.5 28.1-7.8 39.2 1.7c14.4 11.9 32.5 21 50.6 25.2c17.2 4 27.9 21.2 23.9 38.4s-21.2 27.9-38.4 23.9c-24.5-5.7-44.9-16.5-58.2-25C449.5 469.7 417 480 384 480c-31.9 0-60.6-9.9-80.4-18.9c-5.8-2.7-11.1-5.3-15.6-7.7c-4.5 2.4-9.7 5.1-15.6 7.7c-19.8 9-48.5 18.9-80.4 18.9c-33 0-65.5-10.3-94.5-25.8c-13.4 8.4-33.7 19.3-58.2 25c-17.2 4-34.4-6.7-38.4-23.9s6.7-34.4 23.9-38.4c18.1-4.2 36.2-13.3 50.6-25.2c11.1-9.4 27.3-10.1 39.2-1.7l0 0C136.7 405.2 165.1 416 192 416c27.5 0 55-10.6 77.5-26.1c11.1-7.9 25.9-7.9 37 0z"
    ]
};
var $d8206b3ab2e65c05$export$c5ea6eeef2db2b3b = $d8206b3ab2e65c05$export$5930e9bdfd790d77;
var $d8206b3ab2e65c05$export$4dee691631c67d5c = $d8206b3ab2e65c05$export$5930e9bdfd790d77;
var $d8206b3ab2e65c05$export$64185f27d82c259f = {
    prefix: "fas",
    iconName: "arrows-up-down",
    icon: [
        320,
        512,
        [
            "arrows-v"
        ],
        "f07d",
        "M182.6 9.4c-12.5-12.5-32.8-12.5-45.3 0l-96 96c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0L128 109.3V402.7L86.6 361.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3l96 96c12.5 12.5 32.8 12.5 45.3 0l96-96c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L192 402.7V109.3l41.4 41.4c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3l-96-96z"
    ]
};
var $d8206b3ab2e65c05$export$cec5f1bc9e068e48 = $d8206b3ab2e65c05$export$64185f27d82c259f;
var $d8206b3ab2e65c05$export$bd5bd2ef56b793b1 = {
    prefix: "fas",
    iconName: "face-grimace",
    icon: [
        512,
        512,
        [
            128556,
            "grimace"
        ],
        "f57f",
        "M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zm96-112h-8V360l55.3 0c-3.8 22.7-23.6 40-47.3 40zm47.3-56L344 344V304h8c23.8 0 43.5 17.3 47.3 40zM328 344H264V304h64v40zm0 56H264V360h64v40zm-80-96v40l-64 0V304h64zm0 56v40H184V360l64 0zm-80-16H112.7c3.8-22.7 23.6-40 47.3-40h8v40zm0 56h-8c-23.8 0-43.5-17.3-47.3-40H168v40zM144.4 208a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm192-32a32 32 0 1 1 0 64 32 32 0 1 1 0-64z"
    ]
};
var $d8206b3ab2e65c05$export$3d08cd36ac1ef231 = $d8206b3ab2e65c05$export$bd5bd2ef56b793b1;
var $d8206b3ab2e65c05$export$1482162f7fe04ac = {
    prefix: "fas",
    iconName: "wheelchair-move",
    icon: [
        448,
        512,
        [
            "wheelchair-alt"
        ],
        "e2ce",
        "M320 48a48 48 0 1 1 96 0 48 48 0 1 1 -96 0zM204.5 121.3c-5.4-2.5-11.7-1.9-16.4 1.7l-40.9 30.7c-14.1 10.6-34.2 7.7-44.8-6.4s-7.7-34.2 6.4-44.8l40.9-30.7c23.7-17.8 55.3-21 82.1-8.4l90.4 42.5c29.1 13.7 36.8 51.6 15.2 75.5L299.1 224h97.4c30.3 0 53 27.7 47.1 57.4L415.4 422.3c-3.5 17.3-20.3 28.6-37.7 25.1s-28.6-20.3-25.1-37.7L377 288H306.7c8.6 19.6 13.3 41.2 13.3 64c0 88.4-71.6 160-160 160S0 440.4 0 352s71.6-160 160-160c11.1 0 22 1.1 32.4 3.3l54.2-54.2-42.1-19.8zM160 448a96 96 0 1 0 0-192 96 96 0 1 0 0 192z"
    ]
};
var $d8206b3ab2e65c05$export$7db9460785019040 = $d8206b3ab2e65c05$export$1482162f7fe04ac;
var $d8206b3ab2e65c05$export$b5dc9dd0347bbb6 = {
    prefix: "fas",
    iconName: "turn-down",
    icon: [
        384,
        512,
        [
            10549,
            "level-down-alt"
        ],
        "f3be",
        "M350 334.5c3.8 8.8 2 19-4.6 26l-136 144c-4.5 4.8-10.8 7.5-17.4 7.5s-12.9-2.7-17.4-7.5l-136-144c-6.6-7-8.4-17.2-4.6-26s12.5-14.5 22-14.5h88l0-192c0-17.7-14.3-32-32-32H32C14.3 96 0 81.7 0 64V32C0 14.3 14.3 0 32 0l80 0c70.7 0 128 57.3 128 128l0 192h88c9.6 0 18.2 5.7 22 14.5z"
    ]
};
var $d8206b3ab2e65c05$export$c07eb6ff5a382cbd = $d8206b3ab2e65c05$export$b5dc9dd0347bbb6;
var $d8206b3ab2e65c05$export$3e15790fe68c095b = {
    prefix: "fas",
    iconName: "person-walking-arrow-right",
    icon: [
        640,
        512,
        [],
        "e552",
        "M208 96a48 48 0 1 0 0-96 48 48 0 1 0 0 96zM123.7 200.5c1-.4 1.9-.8 2.9-1.2l-16.9 63.5c-5.6 21.1-.1 43.6 14.7 59.7l70.7 77.1 22 88.1c4.3 17.1 21.7 27.6 38.8 23.3s27.6-21.7 23.3-38.8l-23-92.1c-1.9-7.8-5.8-14.9-11.2-20.8l-49.5-54 19.3-65.5 9.6 23c4.4 10.6 12.5 19.3 22.8 24.5l26.7 13.3c15.8 7.9 35 1.5 42.9-14.3s1.5-35-14.3-42.9L281 232.7l-15.3-36.8C248.5 154.8 208.3 128 163.7 128c-22.8 0-45.3 4.8-66.1 14l-8 3.5c-32.9 14.6-58.1 42.4-69.4 76.5l-2.6 7.8c-5.6 16.8 3.5 34.9 20.2 40.5s34.9-3.5 40.5-20.2l2.6-7.8c5.7-17.1 18.3-30.9 34.7-38.2l8-3.5zm-30 135.1L68.7 398 9.4 457.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0L116.3 441c4.6-4.6 8.2-10.1 10.6-16.1l14.5-36.2-40.7-44.4c-2.5-2.7-4.8-5.6-7-8.6zM550.6 153.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3L530.7 224H384c-17.7 0-32 14.3-32 32s14.3 32 32 32H530.7l-25.4 25.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0l80-80c12.5-12.5 12.5-32.8 0-45.3l-80-80z"
    ]
};
var $d8206b3ab2e65c05$export$15da4ef8c0fb20d6 = {
    prefix: "fas",
    iconName: "square-envelope",
    icon: [
        448,
        512,
        [
            "envelope-square"
        ],
        "f199",
        "M64 32C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64zM218 271.7L64.2 172.4C66 156.4 79.5 144 96 144H352c16.5 0 30 12.4 31.8 28.4L230 271.7c-1.8 1.2-3.9 1.8-6 1.8s-4.2-.6-6-1.8zm29.4 26.9L384 210.4V336c0 17.7-14.3 32-32 32H96c-17.7 0-32-14.3-32-32V210.4l136.6 88.2c7 4.5 15.1 6.9 23.4 6.9s16.4-2.4 23.4-6.9z"
    ]
};
var $d8206b3ab2e65c05$export$354e159473e73552 = $d8206b3ab2e65c05$export$15da4ef8c0fb20d6;
var $d8206b3ab2e65c05$export$4ed8206e6619cc8f = {
    prefix: "fas",
    iconName: "dice",
    icon: [
        640,
        512,
        [
            127922
        ],
        "f522",
        "M274.9 34.3c-28.1-28.1-73.7-28.1-101.8 0L34.3 173.1c-28.1 28.1-28.1 73.7 0 101.8L173.1 413.7c28.1 28.1 73.7 28.1 101.8 0L413.7 274.9c28.1-28.1 28.1-73.7 0-101.8L274.9 34.3zM200 224a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zM96 200a24 24 0 1 1 0 48 24 24 0 1 1 0-48zM224 376a24 24 0 1 1 0-48 24 24 0 1 1 0 48zM352 200a24 24 0 1 1 0 48 24 24 0 1 1 0-48zM224 120a24 24 0 1 1 0-48 24 24 0 1 1 0 48zm96 328c0 35.3 28.7 64 64 64H576c35.3 0 64-28.7 64-64V256c0-35.3-28.7-64-64-64H461.7c11.6 36 3.1 77-25.4 105.5L320 413.8V448zM480 328a24 24 0 1 1 0 48 24 24 0 1 1 0-48z"
    ]
};
var $d8206b3ab2e65c05$export$5ee2640fe105312d = {
    prefix: "fas",
    iconName: "bowling-ball",
    icon: [
        512,
        512,
        [],
        "f436",
        "M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM240 80a32 32 0 1 1 0 64 32 32 0 1 1 0-64zM208 208a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm-64-64a32 32 0 1 1 0 64 32 32 0 1 1 0-64z"
    ]
};
var $d8206b3ab2e65c05$export$97fa4f4c1006ab1 = {
    prefix: "fas",
    iconName: "brain",
    icon: [
        512,
        512,
        [
            129504
        ],
        "f5dc",
        "M184 0c30.9 0 56 25.1 56 56V456c0 30.9-25.1 56-56 56c-28.9 0-52.7-21.9-55.7-50.1c-5.2 1.4-10.7 2.1-16.3 2.1c-35.3 0-64-28.7-64-64c0-7.4 1.3-14.6 3.6-21.2C21.4 367.4 0 338.2 0 304c0-31.9 18.7-59.5 45.8-72.3C37.1 220.8 32 207 32 192c0-30.7 21.6-56.3 50.4-62.6C80.8 123.9 80 118 80 112c0-29.9 20.6-55.1 48.3-62.1C131.3 21.9 155.1 0 184 0zM328 0c28.9 0 52.6 21.9 55.7 49.9c27.8 7 48.3 32.1 48.3 62.1c0 6-.8 11.9-2.4 17.4c28.8 6.2 50.4 31.9 50.4 62.6c0 15-5.1 28.8-13.8 39.7C493.3 244.5 512 272.1 512 304c0 34.2-21.4 63.4-51.6 74.8c2.3 6.6 3.6 13.8 3.6 21.2c0 35.3-28.7 64-64 64c-5.6 0-11.1-.7-16.3-2.1c-3 28.2-26.8 50.1-55.7 50.1c-30.9 0-56-25.1-56-56V56c0-30.9 25.1-56 56-56z"
    ]
};
var $d8206b3ab2e65c05$export$658a137d3845bca7 = {
    prefix: "fas",
    iconName: "bandage",
    icon: [
        640,
        512,
        [
            129657,
            "band-aid"
        ],
        "f462",
        "M480 416h96c35.3 0 64-28.7 64-64V160c0-35.3-28.7-64-64-64H480V416zM448 96H192V416H448V96zM64 96C28.7 96 0 124.7 0 160V352c0 35.3 28.7 64 64 64h96V96H64zM248 208a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zm120-24a24 24 0 1 1 0 48 24 24 0 1 1 0-48zM248 304a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zm120-24a24 24 0 1 1 0 48 24 24 0 1 1 0-48z"
    ]
};
var $d8206b3ab2e65c05$export$b14a1014df2fdf46 = $d8206b3ab2e65c05$export$658a137d3845bca7;
var $d8206b3ab2e65c05$export$23e8b4955c2d951b = {
    prefix: "fas",
    iconName: "calendar-minus",
    icon: [
        512,
        512,
        [],
        "f272",
        "M160 0c17.7 0 32 14.3 32 32V64H320V32c0-17.7 14.3-32 32-32s32 14.3 32 32V64h48c26.5 0 48 21.5 48 48v48H32V112c0-26.5 21.5-48 48-48h48V32c0-17.7 14.3-32 32-32zM32 192H480V464c0 26.5-21.5 48-48 48H80c-26.5 0-48-21.5-48-48V192zM344 376c13.3 0 24-10.7 24-24s-10.7-24-24-24H168c-13.3 0-24 10.7-24 24s10.7 24 24 24H344z"
    ]
};
var $d8206b3ab2e65c05$export$30262489773a79a3 = {
    prefix: "fas",
    iconName: "circle-xmark",
    icon: [
        512,
        512,
        [
            61532,
            "times-circle",
            "xmark-circle"
        ],
        "f057",
        "M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM175 175c9.4-9.4 24.6-9.4 33.9 0l47 47 47-47c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9l-47 47 47 47c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0l-47-47-47 47c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l47-47-47-47c-9.4-9.4-9.4-24.6 0-33.9z"
    ]
};
var $d8206b3ab2e65c05$export$ab0ec50720a747eb = $d8206b3ab2e65c05$export$30262489773a79a3;
var $d8206b3ab2e65c05$export$90ac4096df8efdee = $d8206b3ab2e65c05$export$30262489773a79a3;
var $d8206b3ab2e65c05$export$de9a67b55dbe819a = {
    prefix: "fas",
    iconName: "gifts",
    icon: [
        640,
        512,
        [],
        "f79c",
        "M200.6 32C205 19.5 198.5 5.8 186 1.4S159.8 3.5 155.4 16L144.7 46.2l-9.9-29.8C130.6 3.8 117-3 104.4 1.2S85 19 89.2 31.6l8.3 25-27.4-20c-10.7-7.8-25.7-5.4-33.5 5.3s-5.4 25.7 5.3 33.5L70.2 96H48C21.5 96 0 117.5 0 144V464c0 26.5 21.5 48 48 48H200.6c-5.4-9.4-8.6-20.3-8.6-32V256c0-29.9 20.5-55 48.2-62c1.8-31 17.1-58.2 40.1-76.1C271.7 104.7 256.9 96 240 96H217.8l28.3-20.6c10.7-7.8 13.1-22.8 5.3-33.5s-22.8-13.1-33.5-5.3L192.5 55.1 200.6 32zM363.5 185.5L393.1 224H344c-13.3 0-24-10.7-24-24c0-13.1 10.8-24 24.2-24c7.6 0 14.7 3.5 19.3 9.5zM272 200c0 8.4 1.4 16.5 4.1 24H272c-26.5 0-48 21.5-48 48v80H416V256h32v96H640V272c0-26.5-21.5-48-48-48h-4.1c2.7-7.5 4.1-15.6 4.1-24c0-39.9-32.5-72-72.2-72c-22.4 0-43.6 10.4-57.3 28.2L432 195.8l-30.5-39.6c-13.7-17.8-35-28.2-57.3-28.2c-39.7 0-72.2 32.1-72.2 72zM224 464c0 26.5 21.5 48 48 48H416V384H224v80zm224 48H592c26.5 0 48-21.5 48-48V384H448V512zm96-312c0 13.3-10.7 24-24 24H470.9l29.6-38.5c4.6-5.9 11.7-9.5 19.3-9.5c13.4 0 24.2 10.9 24.2 24z"
    ]
};
var $d8206b3ab2e65c05$export$c402efcf01d5ca07 = {
    prefix: "fas",
    iconName: "hotel",
    icon: [
        512,
        512,
        [
            127976
        ],
        "f594",
        "M0 32C0 14.3 14.3 0 32 0H480c17.7 0 32 14.3 32 32s-14.3 32-32 32V448c17.7 0 32 14.3 32 32s-14.3 32-32 32H304V464c0-26.5-21.5-48-48-48s-48 21.5-48 48v48H32c-17.7 0-32-14.3-32-32s14.3-32 32-32V64C14.3 64 0 49.7 0 32zm96 80v32c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V112c0-8.8-7.2-16-16-16H112c-8.8 0-16 7.2-16 16zM240 96c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V112c0-8.8-7.2-16-16-16H240zm112 16v32c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V112c0-8.8-7.2-16-16-16H368c-8.8 0-16 7.2-16 16zM112 192c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V208c0-8.8-7.2-16-16-16H112zm112 16v32c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V208c0-8.8-7.2-16-16-16H240c-8.8 0-16 7.2-16 16zm144-16c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V208c0-8.8-7.2-16-16-16H368zM328 384c13.3 0 24.3-10.9 21-23.8c-10.6-41.5-48.2-72.2-93-72.2s-82.5 30.7-93 72.2c-3.3 12.8 7.8 23.8 21 23.8H328z"
    ]
};
var $d8206b3ab2e65c05$export$807cdd395fe012cb = {
    prefix: "fas",
    iconName: "earth-asia",
    icon: [
        512,
        512,
        [
            127759,
            "globe-asia"
        ],
        "f57e",
        "M51.7 295.1l31.7 6.3c7.9 1.6 16-.9 21.7-6.6l15.4-15.4c11.6-11.6 31.1-8.4 38.4 6.2l9.3 18.5c4.8 9.6 14.6 15.7 25.4 15.7c15.2 0 26.1-14.6 21.7-29.2l-6-19.9c-4.6-15.4 6.9-30.9 23-30.9h2.3c13.4 0 25.9-6.7 33.3-17.8l10.7-16.1c5.6-8.5 5.3-19.6-.8-27.7l-16.1-21.5c-10.3-13.7-3.3-33.5 13.4-37.7l17-4.3c7.5-1.9 13.6-7.2 16.5-14.4l16.4-40.9C303.4 52.1 280.2 48 256 48C141.1 48 48 141.1 48 256c0 13.4 1.3 26.5 3.7 39.1zm407.7 4.6c-3-.3-6-.1-9 .8l-15.8 4.4c-6.7 1.9-13.8-.9-17.5-6.7l-2-3.1c-6-9.4-16.4-15.1-27.6-15.1s-21.6 5.7-27.6 15.1l-6.1 9.5c-1.4 2.2-3.4 4.1-5.7 5.3L312 330.1c-18.1 10.1-25.5 32.4-17 51.3l5.5 12.4c8.6 19.2 30.7 28.5 50.5 21.1l2.6-1c10-3.7 21.3-2.2 29.9 4.1l1.5 1.1c37.2-29.5 64.1-71.4 74.4-119.5zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm144.5 92.1c-2.1 8.6 3.1 17.3 11.6 19.4l32 8c8.6 2.1 17.3-3.1 19.4-11.6s-3.1-17.3-11.6-19.4l-32-8c-8.6-2.1-17.3 3.1-19.4 11.6zm92-20c-2.1 8.6 3.1 17.3 11.6 19.4s17.3-3.1 19.4-11.6l8-32c2.1-8.6-3.1-17.3-11.6-19.4s-17.3 3.1-19.4 11.6l-8 32zM343.2 113.7c-7.9-4-17.5-.7-21.5 7.2l-16 32c-4 7.9-.7 17.5 7.2 21.5s17.5 .7 21.5-7.2l16-32c4-7.9 .7-17.5-7.2-21.5z"
    ]
};
var $d8206b3ab2e65c05$export$796fdfc909e603f4 = $d8206b3ab2e65c05$export$807cdd395fe012cb;
var $d8206b3ab2e65c05$export$31e6961064ddac7b = {
    prefix: "fas",
    iconName: "id-card-clip",
    icon: [
        576,
        512,
        [
            "id-card-alt"
        ],
        "f47f",
        "M256 0h64c17.7 0 32 14.3 32 32V96c0 17.7-14.3 32-32 32H256c-17.7 0-32-14.3-32-32V32c0-17.7 14.3-32 32-32zM64 64H192v48c0 26.5 21.5 48 48 48h96c26.5 0 48-21.5 48-48V64H512c35.3 0 64 28.7 64 64V448c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V128C0 92.7 28.7 64 64 64zM176 437.3c0 5.9 4.8 10.7 10.7 10.7H389.3c5.9 0 10.7-4.8 10.7-10.7c0-29.5-23.9-53.3-53.3-53.3H229.3c-29.5 0-53.3 23.9-53.3 53.3zM288 352a64 64 0 1 0 0-128 64 64 0 1 0 0 128z"
    ]
};
var $d8206b3ab2e65c05$export$dc37ebbac31f6c6c = $d8206b3ab2e65c05$export$31e6961064ddac7b;
var $d8206b3ab2e65c05$export$f48a3ba52a0a9e56 = {
    prefix: "fas",
    iconName: "magnifying-glass-plus",
    icon: [
        512,
        512,
        [
            "search-plus"
        ],
        "f00e",
        "M416 208c0 45.9-14.9 88.3-40 122.7L502.6 457.4c12.5 12.5 12.5 32.8 0 45.3s-32.8 12.5-45.3 0L330.7 376c-34.4 25.2-76.8 40-122.7 40C93.1 416 0 322.9 0 208S93.1 0 208 0S416 93.1 416 208zM184 296c0 13.3 10.7 24 24 24s24-10.7 24-24V232h64c13.3 0 24-10.7 24-24s-10.7-24-24-24H232V120c0-13.3-10.7-24-24-24s-24 10.7-24 24v64H120c-13.3 0-24 10.7-24 24s10.7 24 24 24h64v64z"
    ]
};
var $d8206b3ab2e65c05$export$378f00e6b1a8185 = $d8206b3ab2e65c05$export$f48a3ba52a0a9e56;
var $d8206b3ab2e65c05$export$47e4e0d519d33497 = {
    prefix: "fas",
    iconName: "thumbs-up",
    icon: [
        512,
        512,
        [
            128077,
            61575
        ],
        "f164",
        "M313.4 32.9c26 5.2 42.9 30.5 37.7 56.5l-2.3 11.4c-5.3 26.7-15.1 52.1-28.8 75.2H464c26.5 0 48 21.5 48 48c0 18.5-10.5 34.6-25.9 42.6C497 275.4 504 288.9 504 304c0 23.4-16.8 42.9-38.9 47.1c4.4 7.3 6.9 15.8 6.9 24.9c0 21.3-13.9 39.4-33.1 45.6c.7 3.3 1.1 6.8 1.1 10.4c0 26.5-21.5 48-48 48H294.5c-19 0-37.5-5.6-53.3-16.1l-38.5-25.7C176 420.4 160 390.4 160 358.3V320 272 247.1c0-29.2 13.3-56.7 36-75l7.4-5.9c26.5-21.2 44.6-51 51.2-84.2l2.3-11.4c5.2-26 30.5-42.9 56.5-37.7zM32 192H96c17.7 0 32 14.3 32 32V448c0 17.7-14.3 32-32 32H32c-17.7 0-32-14.3-32-32V224c0-17.7 14.3-32 32-32z"
    ]
};
var $d8206b3ab2e65c05$export$b00596a09aa07311 = {
    prefix: "fas",
    iconName: "user-clock",
    icon: [
        640,
        512,
        [],
        "f4fd",
        "M224 0a128 128 0 1 1 0 256A128 128 0 1 1 224 0zM178.3 304h91.4c20.6 0 40.4 3.5 58.8 9.9C323 331 320 349.1 320 368c0 59.5 29.5 112.1 74.8 144H29.7C13.3 512 0 498.7 0 482.3C0 383.8 79.8 304 178.3 304zM352 368a144 144 0 1 1 288 0 144 144 0 1 1 -288 0zm144-80c-8.8 0-16 7.2-16 16v64c0 8.8 7.2 16 16 16h48c8.8 0 16-7.2 16-16s-7.2-16-16-16H512V304c0-8.8-7.2-16-16-16z"
    ]
};
var $d8206b3ab2e65c05$export$8846d49caaed1c0a = {
    prefix: "fas",
    iconName: "hand-dots",
    icon: [
        512,
        512,
        [
            "allergies"
        ],
        "f461",
        "M288 32c0-17.7-14.3-32-32-32s-32 14.3-32 32V240c0 8.8-7.2 16-16 16s-16-7.2-16-16V64c0-17.7-14.3-32-32-32s-32 14.3-32 32V336c0 1.5 0 3.1 .1 4.6L67.6 283c-16-15.2-41.3-14.6-56.6 1.4s-14.6 41.3 1.4 56.6L124.8 448c43.1 41.1 100.4 64 160 64H304c97.2 0 176-78.8 176-176V128c0-17.7-14.3-32-32-32s-32 14.3-32 32V240c0 8.8-7.2 16-16 16s-16-7.2-16-16V64c0-17.7-14.3-32-32-32s-32 14.3-32 32V240c0 8.8-7.2 16-16 16s-16-7.2-16-16V32zM240 336a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zm80 16a16 16 0 1 1 0 32 16 16 0 1 1 0-32zm48-16a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zm-16 80a16 16 0 1 1 0 32 16 16 0 1 1 0-32zM240 432a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zm-48-48a16 16 0 1 1 0 32 16 16 0 1 1 0-32z"
    ]
};
var $d8206b3ab2e65c05$export$dcae2101babbffff = $d8206b3ab2e65c05$export$8846d49caaed1c0a;
var $d8206b3ab2e65c05$export$bef39294aed2281a = {
    prefix: "fas",
    iconName: "file-invoice",
    icon: [
        384,
        512,
        [],
        "f570",
        "M64 0C28.7 0 0 28.7 0 64V448c0 35.3 28.7 64 64 64H320c35.3 0 64-28.7 64-64V160H256c-17.7 0-32-14.3-32-32V0H64zM256 0V128H384L256 0zM80 64h64c8.8 0 16 7.2 16 16s-7.2 16-16 16H80c-8.8 0-16-7.2-16-16s7.2-16 16-16zm0 64h64c8.8 0 16 7.2 16 16s-7.2 16-16 16H80c-8.8 0-16-7.2-16-16s7.2-16 16-16zm16 96H288c17.7 0 32 14.3 32 32v64c0 17.7-14.3 32-32 32H96c-17.7 0-32-14.3-32-32V256c0-17.7 14.3-32 32-32zm0 32v64H288V256H96zM240 416h64c8.8 0 16 7.2 16 16s-7.2 16-16 16H240c-8.8 0-16-7.2-16-16s7.2-16 16-16z"
    ]
};
var $d8206b3ab2e65c05$export$26a3f9d2784b90d8 = {
    prefix: "fas",
    iconName: "window-minimize",
    icon: [
        512,
        512,
        [
            128469
        ],
        "f2d1",
        "M32 416c-17.7 0-32 14.3-32 32s14.3 32 32 32H480c17.7 0 32-14.3 32-32s-14.3-32-32-32H32z"
    ]
};
var $d8206b3ab2e65c05$export$60048819854688c5 = {
    prefix: "fas",
    iconName: "mug-saucer",
    icon: [
        640,
        512,
        [
            "coffee"
        ],
        "f0f4",
        "M96 64c0-17.7 14.3-32 32-32H448h64c70.7 0 128 57.3 128 128s-57.3 128-128 128H480c0 53-43 96-96 96H192c-53 0-96-43-96-96V64zM480 224h32c35.3 0 64-28.7 64-64s-28.7-64-64-64H480V224zM32 416H544c17.7 0 32 14.3 32 32s-14.3 32-32 32H32c-17.7 0-32-14.3-32-32s14.3-32 32-32z"
    ]
};
var $d8206b3ab2e65c05$export$1d24a9e457278011 = $d8206b3ab2e65c05$export$60048819854688c5;
var $d8206b3ab2e65c05$export$5824ffe6f8983c83 = {
    prefix: "fas",
    iconName: "brush",
    icon: [
        384,
        512,
        [],
        "f55d",
        "M162.4 6c-1.5-3.6-5-6-8.9-6h-19c-3.9 0-7.5 2.4-8.9 6L104.9 57.7c-3.2 8-14.6 8-17.8 0L66.4 6c-1.5-3.6-5-6-8.9-6H48C21.5 0 0 21.5 0 48V224v22.4V256H9.6 374.4 384v-9.6V224 48c0-26.5-21.5-48-48-48H230.5c-3.9 0-7.5 2.4-8.9 6L200.9 57.7c-3.2 8-14.6 8-17.8 0L162.4 6zM0 288v32c0 35.3 28.7 64 64 64h64v64c0 35.3 28.7 64 64 64s64-28.7 64-64V384h64c35.3 0 64-28.7 64-64V288H0zM192 432a16 16 0 1 1 0 32 16 16 0 1 1 0-32z"
    ]
};
var $d8206b3ab2e65c05$export$7b028758c03b9655 = {
    prefix: "fas",
    iconName: "mask",
    icon: [
        576,
        512,
        [],
        "f6fa",
        "M288 64C64 64 0 160 0 272S80 448 176 448h8.4c24.2 0 46.4-13.7 57.2-35.4l23.2-46.3c4.4-8.8 13.3-14.3 23.2-14.3s18.8 5.5 23.2 14.3l23.2 46.3c10.8 21.7 33 35.4 57.2 35.4H400c96 0 176-64 176-176s-64-208-288-208zM96 256a64 64 0 1 1 128 0A64 64 0 1 1 96 256zm320-64a64 64 0 1 1 0 128 64 64 0 1 1 0-128z"
    ]
};
var $d8206b3ab2e65c05$export$56d810b9ab2e30bc = {
    prefix: "fas",
    iconName: "magnifying-glass-minus",
    icon: [
        512,
        512,
        [
            "search-minus"
        ],
        "f010",
        "M416 208c0 45.9-14.9 88.3-40 122.7L502.6 457.4c12.5 12.5 12.5 32.8 0 45.3s-32.8 12.5-45.3 0L330.7 376c-34.4 25.2-76.8 40-122.7 40C93.1 416 0 322.9 0 208S93.1 0 208 0S416 93.1 416 208zM136 184c-13.3 0-24 10.7-24 24s10.7 24 24 24H280c13.3 0 24-10.7 24-24s-10.7-24-24-24H136z"
    ]
};
var $d8206b3ab2e65c05$export$efca97eef6a7a17d = $d8206b3ab2e65c05$export$56d810b9ab2e30bc;
var $d8206b3ab2e65c05$export$a6ad5df9d9f29553 = {
    prefix: "fas",
    iconName: "ruler-vertical",
    icon: [
        256,
        512,
        [],
        "f548",
        "M0 48C0 21.5 21.5 0 48 0H208c26.5 0 48 21.5 48 48V96H176c-8.8 0-16 7.2-16 16s7.2 16 16 16h80v64H176c-8.8 0-16 7.2-16 16s7.2 16 16 16h80v64H176c-8.8 0-16 7.2-16 16s7.2 16 16 16h80v64H176c-8.8 0-16 7.2-16 16s7.2 16 16 16h80v48c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V48z"
    ]
};
var $d8206b3ab2e65c05$export$50a28538498238f = {
    prefix: "fas",
    iconName: "user-large",
    icon: [
        512,
        512,
        [
            "user-alt"
        ],
        "f406",
        "M256 288A144 144 0 1 0 256 0a144 144 0 1 0 0 288zm-94.7 32C72.2 320 0 392.2 0 481.3c0 17 13.8 30.7 30.7 30.7H481.3c17 0 30.7-13.8 30.7-30.7C512 392.2 439.8 320 350.7 320H161.3z"
    ]
};
var $d8206b3ab2e65c05$export$ae9b19c2ac726cfc = $d8206b3ab2e65c05$export$50a28538498238f;
var $d8206b3ab2e65c05$export$d401d4aeba21cdf3 = {
    prefix: "fas",
    iconName: "train-tram",
    icon: [
        448,
        512,
        [
            128650
        ],
        "e5b4",
        "M86.8 48c-12.2 0-23.6 5.5-31.2 15L42.7 79C34.5 89.3 19.4 91 9 82.7S-3 59.4 5.3 49L18 33C34.7 12.2 60 0 86.8 0H361.2c26.7 0 52 12.2 68.7 33l12.8 16c8.3 10.4 6.6 25.5-3.8 33.7s-25.5 6.6-33.7-3.7L392.5 63c-7.6-9.5-19.1-15-31.2-15H248V96h40c53 0 96 43 96 96V352c0 30.6-14.3 57.8-36.6 75.4l65.5 65.5c7.1 7.1 2.1 19.1-7.9 19.1H365.3c-8.5 0-16.6-3.4-22.6-9.4L288 448H160l-54.6 54.6c-6 6-14.1 9.4-22.6 9.4H43c-10 0-15-12.1-7.9-19.1l65.5-65.5C78.3 409.8 64 382.6 64 352V192c0-53 43-96 96-96h40V48H86.8zM160 160c-17.7 0-32 14.3-32 32v32c0 17.7 14.3 32 32 32H288c17.7 0 32-14.3 32-32V192c0-17.7-14.3-32-32-32H160zm32 192a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zm96 32a32 32 0 1 0 0-64 32 32 0 1 0 0 64z"
    ]
};
var $d8206b3ab2e65c05$export$ab9af5aa013d2162 = {
    prefix: "fas",
    iconName: "user-nurse",
    icon: [
        448,
        512,
        [],
        "f82f",
        "M96 128V70.2c0-13.3 8.3-25.3 20.8-30l96-36c7.2-2.7 15.2-2.7 22.5 0l96 36c12.5 4.7 20.8 16.6 20.8 30V128h-.3c.2 2.6 .3 5.3 .3 8v40c0 70.7-57.3 128-128 128s-128-57.3-128-128V136c0-2.7 .1-5.4 .3-8H96zm48 48c0 44.2 35.8 80 80 80s80-35.8 80-80V160H144v16zM111.9 327.7c10.5-3.4 21.8 .4 29.4 8.5l71 75.5c6.3 6.7 17 6.7 23.3 0l71-75.5c7.6-8.1 18.9-11.9 29.4-8.5C401 348.6 448 409.4 448 481.3c0 17-13.8 30.7-30.7 30.7H30.7C13.8 512 0 498.2 0 481.3c0-71.9 47-132.7 111.9-153.6zM208 48V64H192c-4.4 0-8 3.6-8 8V88c0 4.4 3.6 8 8 8h16v16c0 4.4 3.6 8 8 8h16c4.4 0 8-3.6 8-8V96h16c4.4 0 8-3.6 8-8V72c0-4.4-3.6-8-8-8H240V48c0-4.4-3.6-8-8-8H216c-4.4 0-8 3.6-8 8z"
    ]
};
var $d8206b3ab2e65c05$export$1aa9423ec6b1d609 = {
    prefix: "fas",
    iconName: "syringe",
    icon: [
        512,
        512,
        [
            128137
        ],
        "f48e",
        "M441 7l32 32 32 32c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0l-15-15L417.9 128l55 55c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0l-72-72L295 73c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l55 55L422.1 56 407 41c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0zM210.3 155.7l61.1-61.1c.3 .3 .6 .7 1 1l16 16 56 56 56 56 16 16c.3 .3 .6 .6 1 1l-191 191c-10.5 10.5-24.7 16.4-39.6 16.4H97.9L41 505c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l57-57V325.3c0-14.9 5.9-29.1 16.4-39.6l43.3-43.3 57 57c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6l-57-57 41.4-41.4 57 57c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6l-57-57z"
    ]
};
var $d8206b3ab2e65c05$export$dcaadfd9c98e42a1 = {
    prefix: "fas",
    iconName: "cloud-sun",
    icon: [
        640,
        512,
        [
            9925
        ],
        "f6c4",
        "M294.2 1.2c5.1 2.1 8.7 6.7 9.6 12.1l14.1 84.7 84.7 14.1c5.4 .9 10 4.5 12.1 9.6s1.5 10.9-1.6 15.4l-38.5 55c-2.2-.1-4.4-.2-6.7-.2c-23.3 0-45.1 6.2-64 17.1l0-1.1c0-53-43-96-96-96s-96 43-96 96s43 96 96 96c8.1 0 15.9-1 23.4-2.9c-36.6 18.1-63.3 53.1-69.8 94.9l-24.4 17c-4.5 3.2-10.3 3.8-15.4 1.6s-8.7-6.7-9.6-12.1L98.1 317.9 13.4 303.8c-5.4-.9-10-4.5-12.1-9.6s-1.5-10.9 1.6-15.4L52.5 208 2.9 137.2c-3.2-4.5-3.8-10.3-1.6-15.4s6.7-8.7 12.1-9.6L98.1 98.1l14.1-84.7c.9-5.4 4.5-10 9.6-12.1s10.9-1.5 15.4 1.6L208 52.5 278.8 2.9c4.5-3.2 10.3-3.8 15.4-1.6zM144 208a64 64 0 1 1 128 0 64 64 0 1 1 -128 0zM639.9 431.9c0 44.2-35.8 80-80 80H288c-53 0-96-43-96-96c0-47.6 34.6-87 80-94.6l0-1.3c0-53 43-96 96-96c34.9 0 65.4 18.6 82.2 46.4c13-9.1 28.8-14.4 45.8-14.4c44.2 0 80 35.8 80 80c0 5.9-.6 11.7-1.9 17.2c37.4 6.7 65.8 39.4 65.8 78.7z"
    ]
};
var $d8206b3ab2e65c05$export$df6244b0501f2112 = {
    prefix: "fas",
    iconName: "stopwatch-20",
    icon: [
        448,
        512,
        [],
        "e06f",
        "M176 0c-17.7 0-32 14.3-32 32s14.3 32 32 32h16V98.4C92.3 113.8 16 200 16 304c0 114.9 93.1 208 208 208s208-93.1 208-208c0-41.8-12.3-80.7-33.5-113.2l24.1-24.1c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L355.7 143c-28.1-23-62.2-38.8-99.7-44.6V64h16c17.7 0 32-14.3 32-32s-14.3-32-32-32H176zM288 204c28.7 0 52 23.3 52 52v96c0 28.7-23.3 52-52 52s-52-23.3-52-52V256c0-28.7 23.3-52 52-52zm-12 52v96c0 6.6 5.4 12 12 12s12-5.4 12-12V256c0-6.6-5.4-12-12-12s-12 5.4-12 12zM159.5 244c-5.4 0-10.2 3.5-11.9 8.6l-.6 1.7c-3.5 10.5-14.8 16.1-25.3 12.6s-16.1-14.8-12.6-25.3l.6-1.7c7.2-21.5 27.2-35.9 49.8-35.9c29 0 52.5 23.5 52.5 52.5v2.2c0 13.4-4.9 26.4-13.8 36.4l-39 43.9c-6.2 7-10 15.7-10.9 24.9H192c11 0 20 9 20 20s-9 20-20 20H128c-11 0-20-9-20-20V368.3c0-20.6 7.5-40.4 21.2-55.8l39-43.9c2.4-2.7 3.7-6.2 3.7-9.8v-2.2c0-6.9-5.6-12.5-12.5-12.5z"
    ]
};
var $d8206b3ab2e65c05$export$7ec6541fee081990 = {
    prefix: "fas",
    iconName: "square-full",
    icon: [
        512,
        512,
        [
            128997,
            128998,
            128999,
            129000,
            129001,
            129002,
            129003,
            11035,
            11036
        ],
        "f45c",
        "M0 0H512V512H0V0z"
    ]
};
var $d8206b3ab2e65c05$export$78932e9c9abea6b7 = {
    prefix: "fas",
    iconName: "magnet",
    icon: [
        448,
        512,
        [
            129522
        ],
        "f076",
        "M0 160v96C0 379.7 100.3 480 224 480s224-100.3 224-224V160H320v96c0 53-43 96-96 96s-96-43-96-96V160H0zm0-32H128V64c0-17.7-14.3-32-32-32H32C14.3 32 0 46.3 0 64v64zm320 0H448V64c0-17.7-14.3-32-32-32H352c-17.7 0-32 14.3-32 32v64z"
    ]
};
var $d8206b3ab2e65c05$export$53583b459a87a01 = {
    prefix: "fas",
    iconName: "jar",
    icon: [
        320,
        512,
        [],
        "e516",
        "M32 32C32 14.3 46.3 0 64 0H256c17.7 0 32 14.3 32 32s-14.3 32-32 32H64C46.3 64 32 49.7 32 32zM0 160c0-35.3 28.7-64 64-64H256c35.3 0 64 28.7 64 64V448c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V160zm96 64c-17.7 0-32 14.3-32 32v96c0 17.7 14.3 32 32 32H224c17.7 0 32-14.3 32-32V256c0-17.7-14.3-32-32-32H96z"
    ]
};
var $d8206b3ab2e65c05$export$4a4e034527c933f5 = {
    prefix: "fas",
    iconName: "note-sticky",
    icon: [
        448,
        512,
        [
            62026,
            "sticky-note"
        ],
        "f249",
        "M64 32C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H288V368c0-26.5 21.5-48 48-48H448V96c0-35.3-28.7-64-64-64H64zM448 352H402.7 336c-8.8 0-16 7.2-16 16v66.7V480l32-32 64-64 32-32z"
    ]
};
var $d8206b3ab2e65c05$export$80889adc5d98bf4a = $d8206b3ab2e65c05$export$4a4e034527c933f5;
var $d8206b3ab2e65c05$export$fc4dd5feed8df23 = {
    prefix: "fas",
    iconName: "bug-slash",
    icon: [
        640,
        512,
        [],
        "e490",
        "M38.8 5.1C28.4-3.1 13.3-1.2 5.1 9.2S-1.2 34.7 9.2 42.9l592 464c10.4 8.2 25.5 6.3 33.7-4.1s6.3-25.5-4.1-33.7L477.4 348.9c1.7-9.4 2.6-19 2.6-28.9h64c17.7 0 32-14.3 32-32s-14.3-32-32-32H479.7c-1.1-14.1-5-27.5-11.1-39.5c.7-.6 1.4-1.2 2.1-1.9l64-64c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0l-64 64c-.7 .7-1.3 1.4-1.9 2.1C409.2 164.1 393.1 160 376 160H264c-8.3 0-16.3 1-24 2.8L38.8 5.1zM320 0c-53 0-96 43-96 96v3.6c0 15.7 12.7 28.4 28.4 28.4H387.6c15.7 0 28.4-12.7 28.4-28.4V96c0-53-43-96-96-96zM160.3 256H96c-17.7 0-32 14.3-32 32s14.3 32 32 32h64c0 24.6 5.5 47.8 15.4 68.6c-2.2 1.3-4.2 2.9-6 4.8l-64 64c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0l63.1-63.1c24.5 21.8 55.8 36.2 90.3 39.6V335.5L166.7 227.3c-3.4 9-5.6 18.7-6.4 28.7zM336 479.2c36.6-3.6 69.7-19.6 94.8-43.8L336 360.7V479.2z"
    ]
};
var $d8206b3ab2e65c05$export$1a093e7861c5e48f = {
    prefix: "fas",
    iconName: "arrow-up-from-water-pump",
    icon: [
        576,
        512,
        [],
        "e4b6",
        "M112 0C85.5 0 64 21.5 64 48V256H48c-26.5 0-48 21.5-48 48v96c0 8 2 15.6 5.4 22.2c3.8-1.7 7.8-3.1 12-4.1c13.1-3.1 26.7-9.8 37.3-18.6c22.2-18.7 54.3-20.1 78.1-3.4c18 12.4 40.1 20.3 59.2 20.3c21.1 0 42-8.5 59.2-20.3c22.1-15.5 51.6-15.5 73.7 0c18.4 12.7 39.6 20.3 59.2 20.3c19 0 41.2-7.9 59.2-20.3c23.8-16.7 55.8-15.3 78.1 3.4c10.6 8.8 24.2 15.6 37.3 18.6c4.2 1 8.2 2.4 12 4.1C574 415.6 576 408 576 400V304c0-26.5-21.5-48-48-48H480l0-146.7 25.4 25.4c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3l-80-80c-12.5-12.5-32.8-12.5-45.3 0l-80 80c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0L416 109.3 416 256H288V48c0-26.5-21.5-48-48-48H112zM306.5 421.9c-11.1-7.9-25.9-7.9-37 0C247 437.4 219.5 448 192 448c-26.9 0-55.3-10.8-77.4-26.1l0 0c-11.9-8.5-28.1-7.8-39.2 1.7c-14.4 11.9-32.5 21-50.6 25.2c-17.2 4-27.9 21.2-23.9 38.4s21.2 27.9 38.4 23.9c24.5-5.7 44.9-16.5 58.2-25C126.5 501.7 159 512 192 512c31.9 0 60.6-9.9 80.4-18.9c5.8-2.7 11.1-5.3 15.6-7.7c4.5 2.4 9.7 5.1 15.6 7.7c19.8 9 48.5 18.9 80.4 18.9c33 0 65.5-10.3 94.5-25.8c13.4 8.4 33.7 19.3 58.2 25c17.2 4 34.4-6.7 38.4-23.9s-6.7-34.4-23.9-38.4c-18.1-4.2-36.2-13.3-50.6-25.2c-11.1-9.4-27.3-10.1-39.2-1.7l0 0C439.4 437.2 410.9 448 384 448c-27.5 0-55-10.6-77.5-26.1z"
    ]
};
var $d8206b3ab2e65c05$export$5902c007d5703f2d = {
    prefix: "fas",
    iconName: "bone",
    icon: [
        576,
        512,
        [
            129460
        ],
        "f5d7",
        "M153.7 144.8c6.9 16.3 20.6 31.2 38.3 31.2H384c17.7 0 31.4-14.9 38.3-31.2C434.4 116.1 462.9 96 496 96c44.2 0 80 35.8 80 80c0 30.4-17 56.9-42 70.4c-3.6 1.9-6 5.5-6 9.6s2.4 7.7 6 9.6c25 13.5 42 40 42 70.4c0 44.2-35.8 80-80 80c-33.1 0-61.6-20.1-73.7-48.8C415.4 350.9 401.7 336 384 336H192c-17.7 0-31.4 14.9-38.3 31.2C141.6 395.9 113.1 416 80 416c-44.2 0-80-35.8-80-80c0-30.4 17-56.9 42-70.4c3.6-1.9 6-5.5 6-9.6s-2.4-7.7-6-9.6C17 232.9 0 206.4 0 176c0-44.2 35.8-80 80-80c33.1 0 61.6 20.1 73.7 48.8z"
    ]
};
var $d8206b3ab2e65c05$export$c950c1ba7f227d5b = {
    prefix: "fas",
    iconName: "user-injured",
    icon: [
        448,
        512,
        [],
        "f728",
        "M240 80H342.7c-7.9-19.5-20.4-36.5-36.2-49.9L240 80zm37.7-68.2C261.3 4.2 243.2 0 224 0c-53.7 0-99.7 33.1-118.7 80h81.4l91-68.2zM224 256c70.7 0 128-57.3 128-128c0-5.4-.3-10.8-1-16H97c-.7 5.2-1 10.6-1 16c0 70.7 57.3 128 128 128zM124 312.4c-9.7 3.1-19.1 7-28 11.7V512H243.7L181.5 408.2 124 312.4zm33-7.2L204.3 384H272c44.2 0 80 35.8 80 80c0 18-6 34.6-16 48h82.3c16.4 0 29.7-13.3 29.7-29.7C448 383.8 368.2 304 269.7 304H178.3c-7.2 0-14.3 .4-21.3 1.3zM0 482.3C0 498.7 13.3 512 29.7 512H64V345.4C24.9 378.1 0 427.3 0 482.3zM320 464c0-26.5-21.5-48-48-48H223.5l57.1 95.2C303 507.2 320 487.6 320 464z"
    ]
};
var $d8206b3ab2e65c05$export$8a5a0dbb2a17e253 = {
    prefix: "fas",
    iconName: "face-sad-tear",
    icon: [
        512,
        512,
        [
            128546,
            "sad-tear"
        ],
        "f5b4",
        "M0 256a256 256 0 1 0 512 0A256 256 0 1 0 0 256zm240 80c0-8.8 7.2-16 16-16c45 0 85.6 20.5 115.7 53.1c6 6.5 5.6 16.6-.9 22.6s-16.6 5.6-22.6-.9c-25-27.1-57.4-42.9-92.3-42.9c-8.8 0-16-7.2-16-16zm-80 80c-26.5 0-48-21-48-47c0-20 28.6-60.4 41.6-77.7c3.2-4.4 9.6-4.4 12.8 0C179.6 308.6 208 349 208 369c0 26-21.5 47-48 47zM367.6 208a32 32 0 1 1 -64 0 32 32 0 1 1 64 0zm-192-32a32 32 0 1 1 0 64 32 32 0 1 1 0-64z"
    ]
};
var $d8206b3ab2e65c05$export$4b5241926f692f91 = $d8206b3ab2e65c05$export$8a5a0dbb2a17e253;
var $d8206b3ab2e65c05$export$f654c69e66b466c0 = {
    prefix: "fas",
    iconName: "plane",
    icon: [
        576,
        512,
        [],
        "f072",
        "M482.3 192c34.2 0 93.7 29 93.7 64c0 36-59.5 64-93.7 64l-116.6 0L265.2 495.9c-5.7 10-16.3 16.1-27.8 16.1l-56.2 0c-10.6 0-18.3-10.2-15.4-20.4l49-171.6L112 320 68.8 377.6c-3 4-7.8 6.4-12.8 6.4l-42 0c-7.8 0-14-6.3-14-14c0-1.3 .2-2.6 .5-3.9L32 256 .5 145.9c-.4-1.3-.5-2.6-.5-3.9c0-7.8 6.3-14 14-14l42 0c5 0 9.8 2.4 12.8 6.4L112 192l102.9 0-49-171.6C162.9 10.2 170.6 0 181.2 0l56.2 0c11.5 0 22.1 6.2 27.8 16.1L365.7 192l116.6 0z"
    ]
};
var $d8206b3ab2e65c05$export$51adfe7c9ee4f428 = {
    prefix: "fas",
    iconName: "tent-arrows-down",
    icon: [
        576,
        512,
        [],
        "e581",
        "M209.8 111.9c-8.9-9.9-24-10.7-33.9-1.8l-39.9 36L136 24c0-13.3-10.7-24-24-24S88 10.7 88 24l0 122.1-39.9-36c-9.9-8.9-25-8.1-33.9 1.8s-8.1 25 1.8 33.9l80 72c9.1 8.2 23 8.2 32.1 0l80-72c9.9-8.9 10.7-24 1.8-33.9zm352 0c-8.9-9.9-24-10.7-33.9-1.8l-39.9 36V24c0-13.3-10.7-24-24-24s-24 10.7-24 24V146.1l-39.9-36c-9.9-8.9-25-8.1-33.9 1.8s-8.1 25 1.8 33.9l80 72c9.1 8.2 23 8.2 32.1 0l80-72c9.9-8.9 10.7-24 1.8-33.9zM307.4 166.5c-11.5-8.7-27.3-8.7-38.8 0l-168 128c-6.6 5-11 12.5-12.3 20.7l-24 160c-1.4 9.2 1.3 18.6 7.4 25.6S86.7 512 96 512H288V352l96 160h96c9.3 0 18.2-4.1 24.2-11.1s8.8-16.4 7.4-25.6l-24-160c-1.2-8.2-5.6-15.7-12.3-20.7l-168-128z"
    ]
};
var $d8206b3ab2e65c05$export$de6218b649cbb6a9 = {
    prefix: "fas",
    iconName: "exclamation",
    icon: [
        64,
        512,
        [
            10069,
            10071,
            61738
        ],
        "21",
        "M64 64c0-17.7-14.3-32-32-32S0 46.3 0 64V320c0 17.7 14.3 32 32 32s32-14.3 32-32V64zM32 480a40 40 0 1 0 0-80 40 40 0 1 0 0 80z"
    ]
};
var $d8206b3ab2e65c05$export$7e05388be208e313 = {
    prefix: "fas",
    iconName: "arrows-spin",
    icon: [
        512,
        512,
        [],
        "e4bb",
        "M256 96c38.4 0 73.7 13.5 101.3 36.1l-32.6 32.6c-4.6 4.6-5.9 11.5-3.5 17.4s8.3 9.9 14.8 9.9H448c8.8 0 16-7.2 16-16V64c0-6.5-3.9-12.3-9.9-14.8s-12.9-1.1-17.4 3.5l-34 34C363.4 52.6 312.1 32 256 32c-10.9 0-21.5 .8-32 2.3V99.2c10.3-2.1 21-3.2 32-3.2zM132.1 154.7l32.6 32.6c4.6 4.6 11.5 5.9 17.4 3.5s9.9-8.3 9.9-14.8V64c0-8.8-7.2-16-16-16H64c-6.5 0-12.3 3.9-14.8 9.9s-1.1 12.9 3.5 17.4l34 34C52.6 148.6 32 199.9 32 256c0 10.9 .8 21.5 2.3 32H99.2c-2.1-10.3-3.2-21-3.2-32c0-38.4 13.5-73.7 36.1-101.3zM477.7 224H412.8c2.1 10.3 3.2 21 3.2 32c0 38.4-13.5 73.7-36.1 101.3l-32.6-32.6c-4.6-4.6-11.5-5.9-17.4-3.5s-9.9 8.3-9.9 14.8V448c0 8.8 7.2 16 16 16H448c6.5 0 12.3-3.9 14.8-9.9s1.1-12.9-3.5-17.4l-34-34C459.4 363.4 480 312.1 480 256c0-10.9-.8-21.5-2.3-32zM256 416c-38.4 0-73.7-13.5-101.3-36.1l32.6-32.6c4.6-4.6 5.9-11.5 3.5-17.4s-8.3-9.9-14.8-9.9H64c-8.8 0-16 7.2-16 16l0 112c0 6.5 3.9 12.3 9.9 14.8s12.9 1.1 17.4-3.5l34-34C148.6 459.4 199.9 480 256 480c10.9 0 21.5-.8 32-2.3V412.8c-10.3 2.1-21 3.2-32 3.2z"
    ]
};
var $d8206b3ab2e65c05$export$ae64371e02ee8e56 = {
    prefix: "fas",
    iconName: "print",
    icon: [
        512,
        512,
        [
            128424,
            128438,
            9113
        ],
        "f02f",
        "M128 0C92.7 0 64 28.7 64 64v96h64V64H354.7L384 93.3V160h64V93.3c0-17-6.7-33.3-18.7-45.3L400 18.7C388 6.7 371.7 0 354.7 0H128zM384 352v32 64H128V384 368 352H384zm64 32h32c17.7 0 32-14.3 32-32V256c0-35.3-28.7-64-64-64H64c-35.3 0-64 28.7-64 64v96c0 17.7 14.3 32 32 32H64v64c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V384zM432 248a24 24 0 1 1 0 48 24 24 0 1 1 0-48z"
    ]
};
var $d8206b3ab2e65c05$export$b458d393151b6960 = {
    prefix: "fas",
    iconName: "turkish-lira-sign",
    icon: [
        384,
        512,
        [
            "try",
            "turkish-lira"
        ],
        "e2bb",
        "M96 32c17.7 0 32 14.3 32 32V99.3L247.2 65.2c17-4.9 34.7 5 39.6 22s-5 34.7-22 39.6L128 165.9v29.4l119.2-34.1c17-4.9 34.7 5 39.6 22s-5 34.7-22 39.6L128 261.9V416h63.8c68.2 0 124.4-53.5 127.8-121.6l.4-8c.9-17.7 15.9-31.2 33.6-30.4s31.2 15.9 30.4 33.6l-.4 8C378.5 399.8 294.1 480 191.8 480H96c-17.7 0-32-14.3-32-32V280.1l-23.2 6.6c-17 4.9-34.7-5-39.6-22s5-34.7 22-39.6L64 213.6V184.1l-23.2 6.6c-17 4.9-34.7-5-39.6-22s5-34.7 22-39.6L64 117.6V64c0-17.7 14.3-32 32-32z"
    ]
};
var $d8206b3ab2e65c05$export$970dda513e46c41f = $d8206b3ab2e65c05$export$b458d393151b6960;
var $d8206b3ab2e65c05$export$40e66e5966827199 = $d8206b3ab2e65c05$export$b458d393151b6960;
var $d8206b3ab2e65c05$export$fb420d3e4d8c6a18 = {
    prefix: "fas",
    iconName: "dollar-sign",
    icon: [
        320,
        512,
        [
            128178,
            61781,
            "dollar",
            "usd"
        ],
        "24",
        "M160 0c17.7 0 32 14.3 32 32V67.7c1.6 .2 3.1 .4 4.7 .7c.4 .1 .7 .1 1.1 .2l48 8.8c17.4 3.2 28.9 19.9 25.7 37.2s-19.9 28.9-37.2 25.7l-47.5-8.7c-31.3-4.6-58.9-1.5-78.3 6.2s-27.2 18.3-29 28.1c-2 10.7-.5 16.7 1.2 20.4c1.8 3.9 5.5 8.3 12.8 13.2c16.3 10.7 41.3 17.7 73.7 26.3l2.9 .8c28.6 7.6 63.6 16.8 89.6 33.8c14.2 9.3 27.6 21.9 35.9 39.5c8.5 17.9 10.3 37.9 6.4 59.2c-6.9 38-33.1 63.4-65.6 76.7c-13.7 5.6-28.6 9.2-44.4 11V480c0 17.7-14.3 32-32 32s-32-14.3-32-32V445.1c-.4-.1-.9-.1-1.3-.2l-.2 0 0 0c-24.4-3.8-64.5-14.3-91.5-26.3c-16.1-7.2-23.4-26.1-16.2-42.2s26.1-23.4 42.2-16.2c20.9 9.3 55.3 18.5 75.2 21.6c31.9 4.7 58.2 2 76-5.3c16.9-6.9 24.6-16.9 26.8-28.9c1.9-10.6 .4-16.7-1.3-20.4c-1.9-4-5.6-8.4-13-13.3c-16.4-10.7-41.5-17.7-74-26.3l-2.8-.7 0 0C119.4 279.3 84.4 270 58.4 253c-14.2-9.3-27.5-22-35.8-39.6c-8.4-17.9-10.1-37.9-6.1-59.2C23.7 116 52.3 91.2 84.8 78.3c13.3-5.3 27.9-8.9 43.2-11V32c0-17.7 14.3-32 32-32z"
    ]
};
var $d8206b3ab2e65c05$export$a4ffb0775547fcdf = $d8206b3ab2e65c05$export$fb420d3e4d8c6a18;
var $d8206b3ab2e65c05$export$72cca07d38a28589 = $d8206b3ab2e65c05$export$fb420d3e4d8c6a18;
var $d8206b3ab2e65c05$export$476af662c0c32cbc = {
    prefix: "fas",
    iconName: "x",
    icon: [
        384,
        512,
        [
            120
        ],
        "58",
        "M376.6 84.5c11.3-13.6 9.5-33.8-4.1-45.1s-33.8-9.5-45.1 4.1L192 206 56.6 43.5C45.3 29.9 25.1 28.1 11.5 39.4S-3.9 70.9 7.4 84.5L150.3 256 7.4 427.5c-11.3 13.6-9.5 33.8 4.1 45.1s33.8 9.5 45.1-4.1L192 306 327.4 468.5c11.3 13.6 31.5 15.4 45.1 4.1s15.4-31.5 4.1-45.1L233.7 256 376.6 84.5z"
    ]
};
var $d8206b3ab2e65c05$export$fa4f1ead37dc1dce = {
    prefix: "fas",
    iconName: "magnifying-glass-dollar",
    icon: [
        512,
        512,
        [
            "search-dollar"
        ],
        "f688",
        "M416 208c0 45.9-14.9 88.3-40 122.7L502.6 457.4c12.5 12.5 12.5 32.8 0 45.3s-32.8 12.5-45.3 0L330.7 376c-34.4 25.2-76.8 40-122.7 40C93.1 416 0 322.9 0 208S93.1 0 208 0S416 93.1 416 208zM228 104c0-11-9-20-20-20s-20 9-20 20v14c-7.6 1.7-15.2 4.4-22.2 8.5c-13.9 8.3-25.9 22.8-25.8 43.9c.1 20.3 12 33.1 24.7 40.7c11 6.6 24.7 10.8 35.6 14l1.7 .5c12.6 3.8 21.8 6.8 28 10.7c5.1 3.2 5.8 5.4 5.9 8.2c.1 5-1.8 8-5.9 10.5c-5 3.1-12.9 5-21.4 4.7c-11.1-.4-21.5-3.9-35.1-8.5c-2.3-.8-4.7-1.6-7.2-2.4c-10.5-3.5-21.8 2.2-25.3 12.6s2.2 21.8 12.6 25.3c1.9 .6 4 1.3 6.1 2.1l0 0 0 0c8.3 2.9 17.9 6.2 28.2 8.4V312c0 11 9 20 20 20s20-9 20-20V298.2c8-1.7 16-4.5 23.2-9c14.3-8.9 25.1-24.1 24.8-45c-.3-20.3-11.7-33.4-24.6-41.6c-11.5-7.2-25.9-11.6-37.1-15l-.7-.2c-12.8-3.9-21.9-6.7-28.3-10.5c-5.2-3.1-5.3-4.9-5.3-6.7c0-3.7 1.4-6.5 6.2-9.3c5.4-3.2 13.6-5.1 21.5-5c9.6 .1 20.2 2.2 31.2 5.2c10.7 2.8 21.6-3.5 24.5-14.2s-3.5-21.6-14.2-24.5c-6.5-1.7-13.7-3.4-21.1-4.7V104z"
    ]
};
var $d8206b3ab2e65c05$export$65b49a6767630708 = $d8206b3ab2e65c05$export$fa4f1ead37dc1dce;
var $d8206b3ab2e65c05$export$3a18218720110fc0 = {
    prefix: "fas",
    iconName: "users-gear",
    icon: [
        640,
        512,
        [
            "users-cog"
        ],
        "f509",
        "M144 160A80 80 0 1 0 144 0a80 80 0 1 0 0 160zm368 0A80 80 0 1 0 512 0a80 80 0 1 0 0 160zM0 298.7C0 310.4 9.6 320 21.3 320H234.7c.2 0 .4 0 .7 0c-26.6-23.5-43.3-57.8-43.3-96c0-7.6 .7-15 1.9-22.3c-13.6-6.3-28.7-9.7-44.6-9.7H106.7C47.8 192 0 239.8 0 298.7zM320 320c24 0 45.9-8.8 62.7-23.3c2.5-3.7 5.2-7.3 8-10.7c2.7-3.3 5.7-6.1 9-8.3C410 262.3 416 243.9 416 224c0-53-43-96-96-96s-96 43-96 96s43 96 96 96zm65.4 60.2c-10.3-5.9-18.1-16.2-20.8-28.2H261.3C187.7 352 128 411.7 128 485.3c0 14.7 11.9 26.7 26.7 26.7H455.2c-2.1-5.2-3.2-10.9-3.2-16.4v-3c-1.3-.7-2.7-1.5-4-2.3l-2.6 1.5c-16.8 9.7-40.5 8-54.7-9.7c-4.5-5.6-8.6-11.5-12.4-17.6l-.1-.2-.1-.2-2.4-4.1-.1-.2-.1-.2c-3.4-6.2-6.4-12.6-9-19.3c-8.2-21.2 2.2-42.6 19-52.3l2.7-1.5c0-.8 0-1.5 0-2.3s0-1.5 0-2.3l-2.7-1.5zM533.3 192H490.7c-15.9 0-31 3.5-44.6 9.7c1.3 7.2 1.9 14.7 1.9 22.3c0 17.4-3.5 33.9-9.7 49c2.5 .9 4.9 2 7.1 3.3l2.6 1.5c1.3-.8 2.6-1.6 4-2.3v-3c0-19.4 13.3-39.1 35.8-42.6c7.9-1.2 16-1.9 24.2-1.9s16.3 .6 24.2 1.9c22.5 3.5 35.8 23.2 35.8 42.6v3c1.3 .7 2.7 1.5 4 2.3l2.6-1.5c16.8-9.7 40.5-8 54.7 9.7c2.3 2.8 4.5 5.8 6.6 8.7c-2.1-57.1-49-102.7-106.6-102.7zm91.3 163.9c6.3-3.6 9.5-11.1 6.8-18c-2.1-5.5-4.6-10.8-7.4-15.9l-2.3-4c-3.1-5.1-6.5-9.9-10.2-14.5c-4.6-5.7-12.7-6.7-19-3L574.4 311c-8.9-7.6-19.1-13.6-30.4-17.6v-21c0-7.3-4.9-13.8-12.1-14.9c-6.5-1-13.1-1.5-19.9-1.5s-13.4 .5-19.9 1.5c-7.2 1.1-12.1 7.6-12.1 14.9v21c-11.2 4-21.5 10-30.4 17.6l-18.2-10.5c-6.3-3.6-14.4-2.6-19 3c-3.7 4.6-7.1 9.5-10.2 14.6l-2.3 3.9c-2.8 5.1-5.3 10.4-7.4 15.9c-2.6 6.8 .5 14.3 6.8 17.9l18.2 10.5c-1 5.7-1.6 11.6-1.6 17.6s.6 11.9 1.6 17.5l-18.2 10.5c-6.3 3.6-9.5 11.1-6.8 17.9c2.1 5.5 4.6 10.7 7.4 15.8l2.4 4.1c3 5.1 6.4 9.9 10.1 14.5c4.6 5.7 12.7 6.7 19 3L449.6 457c8.9 7.6 19.2 13.6 30.4 17.6v21c0 7.3 4.9 13.8 12.1 14.9c6.5 1 13.1 1.5 19.9 1.5s13.4-.5 19.9-1.5c7.2-1.1 12.1-7.6 12.1-14.9v-21c11.2-4 21.5-10 30.4-17.6l18.2 10.5c6.3 3.6 14.4 2.6 19-3c3.7-4.6 7.1-9.4 10.1-14.5l2.4-4.2c2.8-5.1 5.3-10.3 7.4-15.8c2.6-6.8-.5-14.3-6.8-17.9l-18.2-10.5c1-5.7 1.6-11.6 1.6-17.5s-.6-11.9-1.6-17.6l18.2-10.5zM472 384a40 40 0 1 1 80 0 40 40 0 1 1 -80 0z"
    ]
};
var $d8206b3ab2e65c05$export$5e0b06753fc69b81 = $d8206b3ab2e65c05$export$3a18218720110fc0;
var $d8206b3ab2e65c05$export$50b6dcaa9ec03439 = {
    prefix: "fas",
    iconName: "person-military-pointing",
    icon: [
        576,
        512,
        [],
        "e54a",
        "M246.9 14.1C234 15.2 224 26 224 39c0 13.8 11.2 25 25 25H400c8.8 0 16-7.2 16-16V17.4C416 8 408 .7 398.7 1.4L246.9 14.1zM240 112c0 44.2 35.8 80 80 80s80-35.8 80-80c0-5.5-.6-10.8-1.6-16H241.6c-1 5.2-1.6 10.5-1.6 16zM72 224c-22.1 0-40 17.9-40 40s17.9 40 40 40H224v89.4L386.8 230.5c-13.3-4.3-27.3-6.5-41.6-6.5H240 72zm345.7 20.9L246.6 416H416V369.7l53.6 90.6c11.2 19 35.8 25.3 54.8 14.1s25.3-35.8 14.1-54.8L462.3 290.8c-11.2-18.9-26.6-34.5-44.6-45.9zM224 448v32c0 17.7 14.3 32 32 32H384c17.7 0 32-14.3 32-32V448H224z"
    ]
};
var $d8206b3ab2e65c05$export$a411e7e26cb63d5e = {
    prefix: "fas",
    iconName: "building-columns",
    icon: [
        512,
        512,
        [
            "bank",
            "institution",
            "museum",
            "university"
        ],
        "f19c",
        "M243.4 2.6l-224 96c-14 6-21.8 21-18.7 35.8S16.8 160 32 160v8c0 13.3 10.7 24 24 24H456c13.3 0 24-10.7 24-24v-8c15.2 0 28.3-10.7 31.3-25.6s-4.8-29.9-18.7-35.8l-224-96c-8-3.4-17.2-3.4-25.2 0zM128 224H64V420.3c-.6 .3-1.2 .7-1.8 1.1l-48 32c-11.7 7.8-17 22.4-12.9 35.9S17.9 512 32 512H480c14.1 0 26.5-9.2 30.6-22.7s-1.1-28.1-12.9-35.9l-48-32c-.6-.4-1.2-.7-1.8-1.1V224H384V416H344V224H280V416H232V224H168V416H128V224zM256 64a32 32 0 1 1 0 64 32 32 0 1 1 0-64z"
    ]
};
var $d8206b3ab2e65c05$export$6e379b829ea8b99 = $d8206b3ab2e65c05$export$a411e7e26cb63d5e;
var $d8206b3ab2e65c05$export$1dba320226a34c1f = $d8206b3ab2e65c05$export$a411e7e26cb63d5e;
var $d8206b3ab2e65c05$export$9b3953adff472ad2 = $d8206b3ab2e65c05$export$a411e7e26cb63d5e;
var $d8206b3ab2e65c05$export$f2e1460ebe1a8cb0 = $d8206b3ab2e65c05$export$a411e7e26cb63d5e;
var $d8206b3ab2e65c05$export$9ff64ffae70e08c0 = {
    prefix: "fas",
    iconName: "umbrella",
    icon: [
        576,
        512,
        [],
        "f0e9",
        "M288 0c17.7 0 32 14.3 32 32V49.7C451.8 63.4 557.7 161 573.9 285.9c2 15.6-17.3 24.4-27.8 12.7C532.1 283 504.8 272 480 272c-38.7 0-71 27.5-78.4 64.1c-1.7 8.7-8.7 15.9-17.6 15.9s-15.8-7.2-17.6-15.9C359 299.5 326.7 272 288 272s-71 27.5-78.4 64.1c-1.7 8.7-8.7 15.9-17.6 15.9s-15.8-7.2-17.6-15.9C167 299.5 134.7 272 96 272c-24.8 0-52.1 11-66.1 26.7C19.4 310.4 .1 301.5 2.1 285.9C18.3 161 124.2 63.4 256 49.7V32c0-17.7 14.3-32 32-32zm0 304c12.3 0 23.5 4.6 32 12.2V430.6c0 45-36.5 81.4-81.4 81.4c-30.8 0-59-17.4-72.8-45l-2.3-4.7c-7.9-15.8-1.5-35 14.3-42.9s35-1.5 42.9 14.3l2.3 4.7c3 5.9 9 9.6 15.6 9.6c9.6 0 17.4-7.8 17.4-17.4V316.2c8.5-7.6 19.7-12.2 32-12.2z"
    ]
};
var $d8206b3ab2e65c05$export$12ca996a6f686fe1 = {
    prefix: "fas",
    iconName: "trowel",
    icon: [
        512,
        512,
        [],
        "e589",
        "M343.9 213.4L245.3 312l65.4 65.4c7.9 7.9 11.1 19.4 8.4 30.3s-10.8 19.6-21.5 22.9l-256 80c-11.4 3.5-23.8 .5-32.2-7.9S-2.1 481.8 1.5 470.5l80-256c3.3-10.7 12-18.9 22.9-21.5s22.4 .5 30.3 8.4L200 266.7l98.6-98.6c-14.3-14.6-14.2-38 .3-52.5l95.4-95.4c26.9-26.9 70.5-26.9 97.5 0s26.9 70.5 0 97.5l-95.4 95.4c-14.5 14.5-37.9 14.6-52.5 .3z"
    ]
};
var $d8206b3ab2e65c05$export$56c73b799aac2555 = {
    prefix: "fas",
    iconName: "d",
    icon: [
        384,
        512,
        [
            100
        ],
        "44",
        "M0 96C0 60.7 28.7 32 64 32h96c123.7 0 224 100.3 224 224s-100.3 224-224 224H64c-35.3 0-64-28.7-64-64V96zm160 0H64V416h96c88.4 0 160-71.6 160-160s-71.6-160-160-160z"
    ]
};
var $d8206b3ab2e65c05$export$c7e014b7e3ac3d83 = {
    prefix: "fas",
    iconName: "stapler",
    icon: [
        640,
        512,
        [],
        "e5af",
        "M640 299.3V304 432c0 26.5-21.5 48-48 48H512 448 64c-17.7 0-32-14.3-32-32s14.3-32 32-32H448V368H96c-17.7 0-32-14.3-32-32V219.4L33.8 214C14.2 210.5 0 193.5 0 173.7c0-8.9 2.9-17.5 8.2-24.6l35.6-47.5C76.7 57.8 128.2 32 182.9 32c27 0 53.6 6.3 77.8 18.4L586.9 213.5C619.5 229.7 640 263 640 299.3zM448 304V288L128 230.9V304H448z"
    ]
};
var $d8206b3ab2e65c05$export$bf5896cc1ce4d55 = {
    prefix: "fas",
    iconName: "masks-theater",
    icon: [
        640,
        512,
        [
            127917,
            "theater-masks"
        ],
        "f630",
        "M74.6 373.2c41.7 36.1 108 82.5 166.1 73.7c6.1-.9 12.1-2.5 18-4.5c-9.2-12.3-17.3-24.4-24.2-35.4c-21.9-35-28.8-75.2-25.9-113.6c-20.6 4.1-39.2 13-54.7 25.4c-6.5 5.2-16.3 1.3-14.8-7c6.4-33.5 33-60.9 68.2-66.3c2.6-.4 5.3-.7 7.9-.8l19.4-131.3c2-13.8 8-32.7 25-45.9C278.2 53.2 310.5 37 363.2 32.2c-.8-.7-1.6-1.4-2.4-2.1C340.6 14.5 288.4-11.5 175.7 5.6S20.5 63 5.7 83.9C0 91.9-.8 102 .6 111.8L24.8 276.1c5.5 37.3 21.5 72.6 49.8 97.2zm87.7-219.6c4.4-3.1 10.8-2 11.8 3.3c.1 .5 .2 1.1 .3 1.6c3.2 21.8-11.6 42-33.1 45.3s-41.5-11.8-44.7-33.5c-.1-.5-.1-1.1-.2-1.6c-.6-5.4 5.2-8.4 10.3-6.7c9 3 18.8 3.9 28.7 2.4s19.1-5.3 26.8-10.8zM261.6 390c29.4 46.9 79.5 110.9 137.6 119.7s124.5-37.5 166.1-73.7c28.3-24.5 44.3-59.8 49.8-97.2l24.2-164.3c1.4-9.8 .6-19.9-5.1-27.9c-14.8-20.9-57.3-61.2-170-78.3S299.4 77.2 279.2 92.8c-7.8 6-11.5 15.4-12.9 25.2L242.1 282.3c-5.5 37.3-.4 75.8 19.6 107.7zM404.5 235.3c-7.7-5.5-16.8-9.3-26.8-10.8s-19.8-.6-28.7 2.4c-5.1 1.7-10.9-1.3-10.3-6.7c.1-.5 .1-1.1 .2-1.6c3.2-21.8 23.2-36.8 44.7-33.5s36.3 23.5 33.1 45.3c-.1 .5-.2 1.1-.3 1.6c-1 5.3-7.4 6.4-11.8 3.3zm136.2 15.5c-1 5.3-7.4 6.4-11.8 3.3c-7.7-5.5-16.8-9.3-26.8-10.8s-19.8-.6-28.7 2.4c-5.1 1.7-10.9-1.3-10.3-6.7c.1-.5 .1-1.1 .2-1.6c3.2-21.8 23.2-36.8 44.7-33.5s36.3 23.5 33.1 45.3c-.1 .5-.2 1.1-.3 1.6zM530 350.2c-19.6 44.7-66.8 72.5-116.8 64.9s-87.1-48.2-93-96.7c-1-8.3 8.9-12.1 15.2-6.7c23.9 20.8 53.6 35.3 87 40.3s66.1 .1 94.9-12.8c7.6-3.4 16 3.2 12.6 10.9z"
    ]
};
var $d8206b3ab2e65c05$export$3dbedc487b0159ac = $d8206b3ab2e65c05$export$bf5896cc1ce4d55;
var $d8206b3ab2e65c05$export$a6df39524c41472c = {
    prefix: "fas",
    iconName: "kip-sign",
    icon: [
        384,
        512,
        [],
        "e1c4",
        "M340.8 88.3c13.4-11.5 15-31.7 3.5-45.1s-31.7-15-45.1-3.5L128 186.4V64c0-17.7-14.3-32-32-32S64 46.3 64 64V224H32c-17.7 0-32 14.3-32 32s14.3 32 32 32H64V448c0 17.7 14.3 32 32 32s32-14.3 32-32V325.6L299.2 472.3c13.4 11.5 33.6 9.9 45.1-3.5s9.9-33.6-3.5-45.1L182.5 288H352c17.7 0 32-14.3 32-32s-14.3-32-32-32H182.5L340.8 88.3z"
    ]
};
var $d8206b3ab2e65c05$export$b276ec3dc9760d39 = {
    prefix: "fas",
    iconName: "hand-point-left",
    icon: [
        512,
        512,
        [],
        "f0a5",
        "M32 96C14.3 96 0 110.3 0 128s14.3 32 32 32l208 0 0-64L32 96zM192 288c-17.7 0-32 14.3-32 32s14.3 32 32 32l64 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l-64 0zm-64-64c0 17.7 14.3 32 32 32l48 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l-48 0c-17.7 0-32 14.3-32 32zm96 160c-17.7 0-32 14.3-32 32s14.3 32 32 32l64 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l-64 0zm88-96l-.6 0c5.4 9.4 8.6 20.3 8.6 32c0 13.2-4 25.4-10.8 35.6c24.9 8.7 42.8 32.5 42.8 60.4c0 11.7-3.1 22.6-8.6 32l8.6 0c88.4 0 160-71.6 160-160l0-61.7c0-42.4-16.9-83.1-46.9-113.1l-11.6-11.6C429.5 77.5 396.9 64 363 64l-27 0c-35.3 0-64 28.7-64 64l0 88c0 22.1 17.9 40 40 40s40-17.9 40-40l0-56c0-8.8 7.2-16 16-16s16 7.2 16 16l0 56c0 39.8-32.2 72-72 72z"
    ]
};
var $d8206b3ab2e65c05$export$e8485db4dab0ab30 = {
    prefix: "fas",
    iconName: "handshake-simple",
    icon: [
        640,
        512,
        [
            129309,
            "handshake-alt"
        ],
        "f4c6",
        "M323.4 85.2l-96.8 78.4c-16.1 13-19.2 36.4-7 53.1c12.9 17.8 38 21.3 55.3 7.8l99.3-77.2c7-5.4 17-4.2 22.5 2.8s4.2 17-2.8 22.5l-20.9 16.2L550.2 352H592c26.5 0 48-21.5 48-48V176c0-26.5-21.5-48-48-48H516h-4-.7l-3.9-2.5L434.8 79c-15.3-9.8-33.2-15-51.4-15c-21.8 0-43 7.5-60 21.2zm22.8 124.4l-51.7 40.2C263 274.4 217.3 268 193.7 235.6c-22.2-30.5-16.6-73.1 12.7-96.8l83.2-67.3c-11.6-4.9-24.1-7.4-36.8-7.4C234 64 215.7 69.6 200 80l-72 48H48c-26.5 0-48 21.5-48 48V304c0 26.5 21.5 48 48 48H156.2l91.4 83.4c19.6 17.9 49.9 16.5 67.8-3.1c5.5-6.1 9.2-13.2 11.1-20.6l17 15.6c19.5 17.9 49.9 16.6 67.8-2.9c4.5-4.9 7.8-10.6 9.9-16.5c19.4 13 45.8 10.3 62.1-7.5c17.9-19.5 16.6-49.9-2.9-67.8l-134.2-123z"
    ]
};
var $d8206b3ab2e65c05$export$e9aa3c6f9f47aa1a = $d8206b3ab2e65c05$export$e8485db4dab0ab30;
var $d8206b3ab2e65c05$export$2130e629ab767ab3 = {
    prefix: "fas",
    iconName: "jet-fighter",
    icon: [
        640,
        512,
        [
            "fighter-jet"
        ],
        "f0fb",
        "M160 24c0-13.3 10.7-24 24-24H296c13.3 0 24 10.7 24 24s-10.7 24-24 24H280L384 192H500.4c7.7 0 15.3 1.4 22.5 4.1L625 234.4c9 3.4 15 12 15 21.6s-6 18.2-15 21.6L522.9 315.9c-7.2 2.7-14.8 4.1-22.5 4.1H384L280 464h16c13.3 0 24 10.7 24 24s-10.7 24-24 24H184c-13.3 0-24-10.7-24-24s10.7-24 24-24h8V320H160l-54.6 54.6c-6 6-14.1 9.4-22.6 9.4H64c-17.7 0-32-14.3-32-32V288c-17.7 0-32-14.3-32-32s14.3-32 32-32V160c0-17.7 14.3-32 32-32H82.7c8.5 0 16.6 3.4 22.6 9.4L160 192h32V48h-8c-13.3 0-24-10.7-24-24zM80 240c-8.8 0-16 7.2-16 16s7.2 16 16 16h64c8.8 0 16-7.2 16-16s-7.2-16-16-16H80z"
    ]
};
var $d8206b3ab2e65c05$export$102b809faf56e033 = $d8206b3ab2e65c05$export$2130e629ab767ab3;
var $d8206b3ab2e65c05$export$1bdb0ec5af3fea99 = {
    prefix: "fas",
    iconName: "square-share-nodes",
    icon: [
        448,
        512,
        [
            "share-alt-square"
        ],
        "f1e1",
        "M64 32C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64zM384 160c0 35.3-28.7 64-64 64c-15.4 0-29.5-5.4-40.6-14.5L194.1 256l85.3 46.5c11-9.1 25.2-14.5 40.6-14.5c35.3 0 64 28.7 64 64s-28.7 64-64 64s-64-28.7-64-64c0-2.5 .1-4.9 .4-7.3L174.5 300c-11.7 12.3-28.2 20-46.5 20c-35.3 0-64-28.7-64-64s28.7-64 64-64c18.3 0 34.8 7.7 46.5 20l81.9-44.7c-.3-2.4-.4-4.9-.4-7.3c0-35.3 28.7-64 64-64s64 28.7 64 64z"
    ]
};
var $d8206b3ab2e65c05$export$3799c2d8fd7e493b = $d8206b3ab2e65c05$export$1bdb0ec5af3fea99;
var $d8206b3ab2e65c05$export$3825a842b5afc5aa = {
    prefix: "fas",
    iconName: "barcode",
    icon: [
        512,
        512,
        [],
        "f02a",
        "M24 32C10.7 32 0 42.7 0 56V456c0 13.3 10.7 24 24 24H40c13.3 0 24-10.7 24-24V56c0-13.3-10.7-24-24-24H24zm88 0c-8.8 0-16 7.2-16 16V464c0 8.8 7.2 16 16 16s16-7.2 16-16V48c0-8.8-7.2-16-16-16zm72 0c-13.3 0-24 10.7-24 24V456c0 13.3 10.7 24 24 24h16c13.3 0 24-10.7 24-24V56c0-13.3-10.7-24-24-24H184zm96 0c-13.3 0-24 10.7-24 24V456c0 13.3 10.7 24 24 24h16c13.3 0 24-10.7 24-24V56c0-13.3-10.7-24-24-24H280zM448 56V456c0 13.3 10.7 24 24 24h16c13.3 0 24-10.7 24-24V56c0-13.3-10.7-24-24-24H472c-13.3 0-24 10.7-24 24zm-64-8V464c0 8.8 7.2 16 16 16s16-7.2 16-16V48c0-8.8-7.2-16-16-16s-16 7.2-16 16z"
    ]
};
var $d8206b3ab2e65c05$export$37bd38cf96417095 = {
    prefix: "fas",
    iconName: "plus-minus",
    icon: [
        384,
        512,
        [],
        "e43c",
        "M224 32c0-17.7-14.3-32-32-32s-32 14.3-32 32V144H48c-17.7 0-32 14.3-32 32s14.3 32 32 32H160V320c0 17.7 14.3 32 32 32s32-14.3 32-32V208H336c17.7 0 32-14.3 32-32s-14.3-32-32-32H224V32zM0 480c0 17.7 14.3 32 32 32H352c17.7 0 32-14.3 32-32s-14.3-32-32-32H32c-17.7 0-32 14.3-32 32z"
    ]
};
var $d8206b3ab2e65c05$export$5c6bd8729527871b = {
    prefix: "fas",
    iconName: "video",
    icon: [
        576,
        512,
        [
            "video-camera"
        ],
        "f03d",
        "M0 128C0 92.7 28.7 64 64 64H320c35.3 0 64 28.7 64 64V384c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V128zM559.1 99.8c10.4 5.6 16.9 16.4 16.9 28.2V384c0 11.8-6.5 22.6-16.9 28.2s-23 5-32.9-1.6l-96-64L416 337.1V320 192 174.9l14.2-9.5 96-64c9.8-6.5 22.4-7.2 32.9-1.6z"
    ]
};
var $d8206b3ab2e65c05$export$3a530df752193ccf = $d8206b3ab2e65c05$export$5c6bd8729527871b;
var $d8206b3ab2e65c05$export$874e305fd7920cce = {
    prefix: "fas",
    iconName: "graduation-cap",
    icon: [
        640,
        512,
        [
            127891,
            "mortar-board"
        ],
        "f19d",
        "M320 32c-8.1 0-16.1 1.4-23.7 4.1L15.8 137.4C6.3 140.9 0 149.9 0 160s6.3 19.1 15.8 22.6l57.9 20.9C57.3 229.3 48 259.8 48 291.9v28.1c0 28.4-10.8 57.7-22.3 80.8c-6.5 13-13.9 25.8-22.5 37.6C0 442.7-.9 448.3 .9 453.4s6 8.9 11.2 10.2l64 16c4.2 1.1 8.7 .3 12.4-2s6.3-6.1 7.1-10.4c8.6-42.8 4.3-81.2-2.1-108.7C90.3 344.3 86 329.8 80 316.5V291.9c0-30.2 10.2-58.7 27.9-81.5c12.9-15.5 29.6-28 49.2-35.7l157-61.7c8.2-3.2 17.5 .8 20.7 9s-.8 17.5-9 20.7l-157 61.7c-12.4 4.9-23.3 12.4-32.2 21.6l159.6 57.6c7.6 2.7 15.6 4.1 23.7 4.1s16.1-1.4 23.7-4.1L624.2 182.6c9.5-3.4 15.8-12.5 15.8-22.6s-6.3-19.1-15.8-22.6L343.7 36.1C336.1 33.4 328.1 32 320 32zM128 408c0 35.3 86 72 192 72s192-36.7 192-72L496.7 262.6 354.5 314c-11.1 4-22.8 6-34.5 6s-23.5-2-34.5-6L143.3 262.6 128 408z"
    ]
};
var $d8206b3ab2e65c05$export$dd0a013bf23a9d86 = $d8206b3ab2e65c05$export$874e305fd7920cce;
var $d8206b3ab2e65c05$export$bb2a6b1b5e852300 = {
    prefix: "fas",
    iconName: "hand-holding-medical",
    icon: [
        576,
        512,
        [],
        "e05c",
        "M224 24V80H168c-13.3 0-24 10.7-24 24v48c0 13.3 10.7 24 24 24h56v56c0 13.3 10.7 24 24 24h48c13.3 0 24-10.7 24-24V176h56c13.3 0 24-10.7 24-24V104c0-13.3-10.7-24-24-24H320V24c0-13.3-10.7-24-24-24H248c-13.3 0-24 10.7-24 24zM559.7 392.2c17.8-13.1 21.6-38.1 8.5-55.9s-38.1-21.6-55.9-8.5L392.6 416H272c-8.8 0-16-7.2-16-16s7.2-16 16-16h16 64c17.7 0 32-14.3 32-32s-14.3-32-32-32H288 272 193.7c-29.1 0-57.3 9.9-80 28L68.8 384H32c-17.7 0-32 14.3-32 32v64c0 17.7 14.3 32 32 32H192 352.5c29 0 57.3-9.3 80.7-26.5l126.6-93.3zm-367-8.2l.9 0 0 0c-.3 0-.6 0-.9 0z"
    ]
};
var $d8206b3ab2e65c05$export$30294c81ac4031ca = {
    prefix: "fas",
    iconName: "person-circle-check",
    icon: [
        576,
        512,
        [],
        "e53e",
        "M112 48a48 48 0 1 1 96 0 48 48 0 1 1 -96 0zm40 304V480c0 17.7-14.3 32-32 32s-32-14.3-32-32V256.9L59.4 304.5c-9.1 15.1-28.8 20-43.9 10.9s-20-28.8-10.9-43.9l58.3-97c17.4-28.9 48.6-46.6 82.3-46.6h29.7c33.7 0 64.9 17.7 82.3 46.6l44.9 74.7c-16.1 17.6-28.6 38.5-36.6 61.5c-1.9-1.8-3.5-3.9-4.9-6.3L232 256.9V480c0 17.7-14.3 32-32 32s-32-14.3-32-32V352H152zm136 16a144 144 0 1 1 288 0 144 144 0 1 1 -288 0zm211.3-43.3c-6.2-6.2-16.4-6.2-22.6 0L416 385.4l-28.7-28.7c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6l40 40c6.2 6.2 16.4 6.2 22.6 0l72-72c6.2-6.2 6.2-16.4 0-22.6z"
    ]
};
var $d8206b3ab2e65c05$export$314f5cab62fc6968 = {
    prefix: "fas",
    iconName: "turn-up",
    icon: [
        384,
        512,
        [
            10548,
            "level-up-alt"
        ],
        "f3bf",
        "M350 177.5c3.8-8.8 2-19-4.6-26l-136-144C204.9 2.7 198.6 0 192 0s-12.9 2.7-17.4 7.5l-136 144c-6.6 7-8.4 17.2-4.6 26s12.5 14.5 22 14.5h88l0 192c0 17.7-14.3 32-32 32H32c-17.7 0-32 14.3-32 32v32c0 17.7 14.3 32 32 32l80 0c70.7 0 128-57.3 128-128l0-192h88c9.6 0 18.2-5.7 22-14.5z"
    ]
};
var $d8206b3ab2e65c05$export$d6f21a309b179c3d = $d8206b3ab2e65c05$export$314f5cab62fc6968;
var $d8206b3ab2e65c05$export$da048c47c8dcd50a = {
    fa0: $d8206b3ab2e65c05$export$f22454595d96c106,
    fa1: $d8206b3ab2e65c05$export$8398cb2addc9e182,
    fa2: $d8206b3ab2e65c05$export$ed1a0ff7bd680a1d,
    fa3: $d8206b3ab2e65c05$export$74b7ff79ce1818d6,
    fa4: $d8206b3ab2e65c05$export$969b2215780d58fd,
    fa5: $d8206b3ab2e65c05$export$3919f68a5b3825a9,
    fa6: $d8206b3ab2e65c05$export$580ac17b31ffb5c3,
    fa7: $d8206b3ab2e65c05$export$ee79cab31be16d23,
    fa8: $d8206b3ab2e65c05$export$45d84c4b2c560d2f,
    fa9: $d8206b3ab2e65c05$export$a120f1e4223629f2,
    faFillDrip: $d8206b3ab2e65c05$export$38320138fc0262d0,
    faArrowsToCircle: $d8206b3ab2e65c05$export$917a3d30f6cd766,
    faCircleChevronRight: $d8206b3ab2e65c05$export$a39bab13d51abfd0,
    faChevronCircleRight: $d8206b3ab2e65c05$export$2a5db4f6eba6f2b,
    faAt: $d8206b3ab2e65c05$export$c115e8063ee02632,
    faTrashCan: $d8206b3ab2e65c05$export$864bb8d6c21fb792,
    faTrashAlt: $d8206b3ab2e65c05$export$88df7ff7eb32f9dc,
    faTextHeight: $d8206b3ab2e65c05$export$3313bce3924ea7da,
    faUserXmark: $d8206b3ab2e65c05$export$e585697127cda27,
    faUserTimes: $d8206b3ab2e65c05$export$45b996d071667753,
    faStethoscope: $d8206b3ab2e65c05$export$acb2d72d28cd92d9,
    faMessage: $d8206b3ab2e65c05$export$6563a67224e7f879,
    faCommentAlt: $d8206b3ab2e65c05$export$6e96904d9af0ec4a,
    faInfo: $d8206b3ab2e65c05$export$d469b770895f47ac,
    faDownLeftAndUpRightToCenter: $d8206b3ab2e65c05$export$d56736f5800b3f0d,
    faCompressAlt: $d8206b3ab2e65c05$export$a05650ebe54bede,
    faExplosion: $d8206b3ab2e65c05$export$36b5fbeae4855055,
    faFileLines: $d8206b3ab2e65c05$export$ef565d07efe2b5e9,
    faFileAlt: $d8206b3ab2e65c05$export$243b47dca32bf0b8,
    faFileText: $d8206b3ab2e65c05$export$f466100bf9bf37a5,
    faWaveSquare: $d8206b3ab2e65c05$export$c38cf504b3bc58a2,
    faRing: $d8206b3ab2e65c05$export$a95486586631edc7,
    faBuildingUn: $d8206b3ab2e65c05$export$fbbc7601eb465ac7,
    faDiceThree: $d8206b3ab2e65c05$export$221059e0d5fd8958,
    faCalendarDays: $d8206b3ab2e65c05$export$31c6cf6f5d38dc0,
    faCalendarAlt: $d8206b3ab2e65c05$export$cbc139f33cff356,
    faAnchorCircleCheck: $d8206b3ab2e65c05$export$8bce49e6ae597af8,
    faBuildingCircleArrowRight: $d8206b3ab2e65c05$export$37584b1a5e175b47,
    faVolleyball: $d8206b3ab2e65c05$export$cc519c9529a46c5c,
    faVolleyballBall: $d8206b3ab2e65c05$export$a15e6fc8e68a76b0,
    faArrowsUpToLine: $d8206b3ab2e65c05$export$159982ce2622211e,
    faSortDown: $d8206b3ab2e65c05$export$58e2577a373e7d4,
    faSortDesc: $d8206b3ab2e65c05$export$e24f016f5f78af6a,
    faCircleMinus: $d8206b3ab2e65c05$export$d0163707993a8110,
    faMinusCircle: $d8206b3ab2e65c05$export$f3979b49bf57313c,
    faDoorOpen: $d8206b3ab2e65c05$export$41821b9a6fd703de,
    faRightFromBracket: $d8206b3ab2e65c05$export$122a80ae0f87f726,
    faSignOutAlt: $d8206b3ab2e65c05$export$c844d6923b7096c2,
    faAtom: $d8206b3ab2e65c05$export$b5bb295e8ad4ab31,
    faSoap: $d8206b3ab2e65c05$export$64f1c53b21f310ac,
    faIcons: $d8206b3ab2e65c05$export$7fe2894454d8eb8a,
    faHeartMusicCameraBolt: $d8206b3ab2e65c05$export$ec74c13cedb0791d,
    faMicrophoneLinesSlash: $d8206b3ab2e65c05$export$4be1b324ac8a71ba,
    faMicrophoneAltSlash: $d8206b3ab2e65c05$export$d2a53a388f30780,
    faBridgeCircleCheck: $d8206b3ab2e65c05$export$ea908d3d80c57d08,
    faPumpMedical: $d8206b3ab2e65c05$export$f1b881c73328720c,
    faFingerprint: $d8206b3ab2e65c05$export$614dc068d88655af,
    faHandPointRight: $d8206b3ab2e65c05$export$f7bc8714c970afa4,
    faMagnifyingGlassLocation: $d8206b3ab2e65c05$export$234a18b2b4d530a3,
    faSearchLocation: $d8206b3ab2e65c05$export$c33aba6c251a898a,
    faForwardStep: $d8206b3ab2e65c05$export$908d699be6717adc,
    faStepForward: $d8206b3ab2e65c05$export$b303329afce5de18,
    faFaceSmileBeam: $d8206b3ab2e65c05$export$e3c56ed54f074063,
    faSmileBeam: $d8206b3ab2e65c05$export$54ada6dc9690e0ca,
    faFlagCheckered: $d8206b3ab2e65c05$export$92fad97e19a9fea,
    faFootball: $d8206b3ab2e65c05$export$e15f65e77f717c29,
    faFootballBall: $d8206b3ab2e65c05$export$e8fd664711e31704,
    faSchoolCircleExclamation: $d8206b3ab2e65c05$export$f629fdee00932a01,
    faCrop: $d8206b3ab2e65c05$export$afa58590dfb6fca2,
    faAnglesDown: $d8206b3ab2e65c05$export$52783a541b1bb03,
    faAngleDoubleDown: $d8206b3ab2e65c05$export$fd504117f273ca92,
    faUsersRectangle: $d8206b3ab2e65c05$export$a28757068b9a3a9a,
    faPeopleRoof: $d8206b3ab2e65c05$export$b96e695bdcf3f3f5,
    faPeopleLine: $d8206b3ab2e65c05$export$d12c2d6def120efe,
    faBeerMugEmpty: $d8206b3ab2e65c05$export$b957c27bc5330472,
    faBeer: $d8206b3ab2e65c05$export$f74725691538983b,
    faDiagramPredecessor: $d8206b3ab2e65c05$export$1852c99deca7bee8,
    faArrowUpLong: $d8206b3ab2e65c05$export$92c58defe6e4c5a7,
    faLongArrowUp: $d8206b3ab2e65c05$export$ede1d50ec4b01670,
    faFireFlameSimple: $d8206b3ab2e65c05$export$9ebfff5c90672059,
    faBurn: $d8206b3ab2e65c05$export$80ed4535efc60402,
    faPerson: $d8206b3ab2e65c05$export$e6619e43cb090a16,
    faMale: $d8206b3ab2e65c05$export$2e21f9dba1630651,
    faLaptop: $d8206b3ab2e65c05$export$c2dee3bd177275a2,
    faFileCsv: $d8206b3ab2e65c05$export$82cea4f586f6ec9,
    faMenorah: $d8206b3ab2e65c05$export$232452c59d77c56e,
    faTruckPlane: $d8206b3ab2e65c05$export$e1d5ceed99060d76,
    faRecordVinyl: $d8206b3ab2e65c05$export$fe2d5012d9982673,
    faFaceGrinStars: $d8206b3ab2e65c05$export$1d1fbac384a76a12,
    faGrinStars: $d8206b3ab2e65c05$export$64347a5c8c402ef4,
    faBong: $d8206b3ab2e65c05$export$e74974fac77c468e,
    faSpaghettiMonsterFlying: $d8206b3ab2e65c05$export$3c8d5c62d76c33b8,
    faPastafarianism: $d8206b3ab2e65c05$export$733efdaec97447be,
    faArrowDownUpAcrossLine: $d8206b3ab2e65c05$export$9fe0c42ede2dd003,
    faSpoon: $d8206b3ab2e65c05$export$faf854a434ce6d0c,
    faUtensilSpoon: $d8206b3ab2e65c05$export$fb7af5d245fb9053,
    faJarWheat: $d8206b3ab2e65c05$export$8b503c1d76716ddd,
    faEnvelopesBulk: $d8206b3ab2e65c05$export$dc2cce064a1e70bb,
    faMailBulk: $d8206b3ab2e65c05$export$dd24f40c5337e2e1,
    faFileCircleExclamation: $d8206b3ab2e65c05$export$61fa9809253098e5,
    faCircleH: $d8206b3ab2e65c05$export$bf5674308c61894f,
    faHospitalSymbol: $d8206b3ab2e65c05$export$c8a3c78d99c23fed,
    faPager: $d8206b3ab2e65c05$export$e1611f373a10a98c,
    faAddressBook: $d8206b3ab2e65c05$export$853fd1561789e3bb,
    faContactBook: $d8206b3ab2e65c05$export$594b5a5d4d2e156b,
    faStrikethrough: $d8206b3ab2e65c05$export$eff51ea25b4de135,
    faK: $d8206b3ab2e65c05$export$3f85413cb67e7f67,
    faLandmarkFlag: $d8206b3ab2e65c05$export$f4d472cf47be4096,
    faPencil: $d8206b3ab2e65c05$export$c72de95adaca18b8,
    faPencilAlt: $d8206b3ab2e65c05$export$8210adc172262df,
    faBackward: $d8206b3ab2e65c05$export$ae65f96ea7a4078d,
    faCaretRight: $d8206b3ab2e65c05$export$f1011352b01c1c0,
    faComments: $d8206b3ab2e65c05$export$932912e74adb8939,
    faPaste: $d8206b3ab2e65c05$export$6f95f90dd1f6d86b,
    faFileClipboard: $d8206b3ab2e65c05$export$ca3229c47de163fa,
    faCodePullRequest: $d8206b3ab2e65c05$export$37576dfab037d8bf,
    faClipboardList: $d8206b3ab2e65c05$export$2c5a9d8548d8810e,
    faTruckRampBox: $d8206b3ab2e65c05$export$37396c36c76937bc,
    faTruckLoading: $d8206b3ab2e65c05$export$f00c152db7d44638,
    faUserCheck: $d8206b3ab2e65c05$export$76de2a120043c9f8,
    faVialVirus: $d8206b3ab2e65c05$export$a56b2b0a1073620c,
    faSheetPlastic: $d8206b3ab2e65c05$export$57f2bcd070bff91a,
    faBlog: $d8206b3ab2e65c05$export$890d5e011054935a,
    faUserNinja: $d8206b3ab2e65c05$export$a9174995732e03c5,
    faPersonArrowUpFromLine: $d8206b3ab2e65c05$export$5709329dd2b70bdc,
    faScrollTorah: $d8206b3ab2e65c05$export$4e3fe5b42a6cd494,
    faTorah: $d8206b3ab2e65c05$export$54d07baabd8c2acb,
    faBroomBall: $d8206b3ab2e65c05$export$3e1327487ce53231,
    faQuidditch: $d8206b3ab2e65c05$export$c00c446e6db1605f,
    faQuidditchBroomBall: $d8206b3ab2e65c05$export$791bfe29b97b4d42,
    faToggleOff: $d8206b3ab2e65c05$export$d20aaceb882ca545,
    faBoxArchive: $d8206b3ab2e65c05$export$2a0fcb66c3d79d00,
    faArchive: $d8206b3ab2e65c05$export$26b3e1c454273f34,
    faPersonDrowning: $d8206b3ab2e65c05$export$bac321083217fd4,
    faArrowDown91: $d8206b3ab2e65c05$export$6cc91ce23eb3fae1,
    faSortNumericDesc: $d8206b3ab2e65c05$export$99f058110e2c82a8,
    faSortNumericDownAlt: $d8206b3ab2e65c05$export$857385fda7a5a98e,
    faFaceGrinTongueSquint: $d8206b3ab2e65c05$export$8eee2c17ff89e724,
    faGrinTongueSquint: $d8206b3ab2e65c05$export$4edf34c3def09a31,
    faSprayCan: $d8206b3ab2e65c05$export$4952c502f544cf85,
    faTruckMonster: $d8206b3ab2e65c05$export$24b8a0147653649a,
    faW: $d8206b3ab2e65c05$export$c7f24bdea332f90a,
    faEarthAfrica: $d8206b3ab2e65c05$export$11afa141d42099d0,
    faGlobeAfrica: $d8206b3ab2e65c05$export$64af36f3b403a57c,
    faRainbow: $d8206b3ab2e65c05$export$92ab27739d3a91b2,
    faCircleNotch: $d8206b3ab2e65c05$export$9429fd8df55155d,
    faTabletScreenButton: $d8206b3ab2e65c05$export$df1e253fc358ade4,
    faTabletAlt: $d8206b3ab2e65c05$export$db0cac088255eacc,
    faPaw: $d8206b3ab2e65c05$export$7bc6e4d977673e69,
    faCloud: $d8206b3ab2e65c05$export$8bb3c4d5c2f50243,
    faTrowelBricks: $d8206b3ab2e65c05$export$b6c20c10ddbd9898,
    faFaceFlushed: $d8206b3ab2e65c05$export$ba5dc4287853ecbd,
    faFlushed: $d8206b3ab2e65c05$export$dfd2bd012685aeac,
    faHospitalUser: $d8206b3ab2e65c05$export$684703c93d630cc5,
    faTentArrowLeftRight: $d8206b3ab2e65c05$export$fa95eb7418c0e2b8,
    faGavel: $d8206b3ab2e65c05$export$c36fb40057e2c3aa,
    faLegal: $d8206b3ab2e65c05$export$59d593c2dacb3781,
    faBinoculars: $d8206b3ab2e65c05$export$8a910017964bb8c2,
    faMicrophoneSlash: $d8206b3ab2e65c05$export$843f63d64e6f7951,
    faBoxTissue: $d8206b3ab2e65c05$export$f2adc06617bc0c7,
    faMotorcycle: $d8206b3ab2e65c05$export$f26017bdca99338d,
    faBellConcierge: $d8206b3ab2e65c05$export$e433538b78718fb3,
    faConciergeBell: $d8206b3ab2e65c05$export$ad92ffbbfbc0fcf3,
    faPenRuler: $d8206b3ab2e65c05$export$85ba06027671d290,
    faPencilRuler: $d8206b3ab2e65c05$export$e3a7a1affea005f5,
    faPeopleArrows: $d8206b3ab2e65c05$export$804bfc5c390e1a2a,
    faPeopleArrowsLeftRight: $d8206b3ab2e65c05$export$da01f044c59e3598,
    faMarsAndVenusBurst: $d8206b3ab2e65c05$export$1dc6221efb867885,
    faSquareCaretRight: $d8206b3ab2e65c05$export$5b1d41cdd118ea6d,
    faCaretSquareRight: $d8206b3ab2e65c05$export$ae86c9de7e0f62fa,
    faScissors: $d8206b3ab2e65c05$export$b2a906a5928c6404,
    faCut: $d8206b3ab2e65c05$export$66847f2a71b260e7,
    faSunPlantWilt: $d8206b3ab2e65c05$export$8db7f2f70484e17e,
    faToiletsPortable: $d8206b3ab2e65c05$export$c00f55f36d386cb7,
    faHockeyPuck: $d8206b3ab2e65c05$export$a274b02dc75663dc,
    faTable: $d8206b3ab2e65c05$export$36583f5d3d5a971f,
    faMagnifyingGlassArrowRight: $d8206b3ab2e65c05$export$382d3376c7fc7fc5,
    faTachographDigital: $d8206b3ab2e65c05$export$73f2bf302381c86a,
    faDigitalTachograph: $d8206b3ab2e65c05$export$b3bf1994f0fefe98,
    faUsersSlash: $d8206b3ab2e65c05$export$b71a093b86e3da1f,
    faClover: $d8206b3ab2e65c05$export$57813571c0e10a0a,
    faReply: $d8206b3ab2e65c05$export$bb06d4a7bb6736fe,
    faMailReply: $d8206b3ab2e65c05$export$12e45ff70d2646a1,
    faStarAndCrescent: $d8206b3ab2e65c05$export$cafa834c96ebcb1a,
    faHouseFire: $d8206b3ab2e65c05$export$947ee033a6942aa8,
    faSquareMinus: $d8206b3ab2e65c05$export$814c9edba7b84aa4,
    faMinusSquare: $d8206b3ab2e65c05$export$ffe9387966b3e681,
    faHelicopter: $d8206b3ab2e65c05$export$612d3e1afaf45fa5,
    faCompass: $d8206b3ab2e65c05$export$b4d344633433e50e,
    faSquareCaretDown: $d8206b3ab2e65c05$export$a1ab39cd66c4e50e,
    faCaretSquareDown: $d8206b3ab2e65c05$export$61aea18df1c84401,
    faFileCircleQuestion: $d8206b3ab2e65c05$export$877d3692c1f94bda,
    faLaptopCode: $d8206b3ab2e65c05$export$94100f4c6ee29932,
    faSwatchbook: $d8206b3ab2e65c05$export$c74a20c81b957b6a,
    faPrescriptionBottle: $d8206b3ab2e65c05$export$214f9ce665590486,
    faBars: $d8206b3ab2e65c05$export$36e9cf7887265da2,
    faNavicon: $d8206b3ab2e65c05$export$409fa7bcaa0e4cd9,
    faPeopleGroup: $d8206b3ab2e65c05$export$be015e72863c3635,
    faHourglassEnd: $d8206b3ab2e65c05$export$52757ecc5b1e25b9,
    faHourglass3: $d8206b3ab2e65c05$export$1ec43c81fef8ffd6,
    faHeartCrack: $d8206b3ab2e65c05$export$8e521ef33062b00e,
    faHeartBroken: $d8206b3ab2e65c05$export$4a565395cb65b282,
    faSquareUpRight: $d8206b3ab2e65c05$export$a47a20ab7bde8c67,
    faExternalLinkSquareAlt: $d8206b3ab2e65c05$export$e4cdf2977151ee26,
    faFaceKissBeam: $d8206b3ab2e65c05$export$eca99665af566fe1,
    faKissBeam: $d8206b3ab2e65c05$export$d6ff8a73c0812e63,
    faFilm: $d8206b3ab2e65c05$export$c03de0cc616e77bb,
    faRulerHorizontal: $d8206b3ab2e65c05$export$46c6347bff3e04a,
    faPeopleRobbery: $d8206b3ab2e65c05$export$75ce8513e1f1c5c4,
    faLightbulb: $d8206b3ab2e65c05$export$1e80f89fe84a215b,
    faCaretLeft: $d8206b3ab2e65c05$export$85a918a11b7643c2,
    faCircleExclamation: $d8206b3ab2e65c05$export$59573943f9eebbd5,
    faExclamationCircle: $d8206b3ab2e65c05$export$220e07e14c5d7e5d,
    faSchoolCircleXmark: $d8206b3ab2e65c05$export$5e17b20e0f6b132b,
    faArrowRightFromBracket: $d8206b3ab2e65c05$export$ca14f1b4d6afb7aa,
    faSignOut: $d8206b3ab2e65c05$export$33e2b60243ca6d92,
    faCircleChevronDown: $d8206b3ab2e65c05$export$aca07924996218d8,
    faChevronCircleDown: $d8206b3ab2e65c05$export$9926124d75b2ecab,
    faUnlockKeyhole: $d8206b3ab2e65c05$export$c98fdd5082b333ec,
    faUnlockAlt: $d8206b3ab2e65c05$export$b19f508797f3d9c3,
    faCloudShowersHeavy: $d8206b3ab2e65c05$export$af51c741ee9cc090,
    faHeadphonesSimple: $d8206b3ab2e65c05$export$ca47801915e5a685,
    faHeadphonesAlt: $d8206b3ab2e65c05$export$6f0433fa527dd5be,
    faSitemap: $d8206b3ab2e65c05$export$b2ce5e79d0eccaf8,
    faCircleDollarToSlot: $d8206b3ab2e65c05$export$5f92ac3e804644e3,
    faDonate: $d8206b3ab2e65c05$export$40050ae52860cde7,
    faMemory: $d8206b3ab2e65c05$export$5f9bd9f6df021f93,
    faRoadSpikes: $d8206b3ab2e65c05$export$b372a24046126ad8,
    faFireBurner: $d8206b3ab2e65c05$export$e4e44f7b1886fef,
    faFlag: $d8206b3ab2e65c05$export$6591b1ea509be9da,
    faHanukiah: $d8206b3ab2e65c05$export$3dcd4ca3f7108a82,
    faFeather: $d8206b3ab2e65c05$export$5e19aea195b31816,
    faVolumeLow: $d8206b3ab2e65c05$export$2b1464e7557b18eb,
    faVolumeDown: $d8206b3ab2e65c05$export$69fdf57632b6cc29,
    faCommentSlash: $d8206b3ab2e65c05$export$3786a0422a3f33ea,
    faCloudSunRain: $d8206b3ab2e65c05$export$dd9dc9b4227dbe94,
    faCompress: $d8206b3ab2e65c05$export$83632d1150d3541f,
    faWheatAwn: $d8206b3ab2e65c05$export$79d4dac715a51fdf,
    faWheatAlt: $d8206b3ab2e65c05$export$deaf03a29aa05e3a,
    faAnkh: $d8206b3ab2e65c05$export$8736909014b15ca9,
    faHandsHoldingChild: $d8206b3ab2e65c05$export$bfb254bf3c0bc50b,
    faAsterisk: $d8206b3ab2e65c05$export$19eff32c0fd4f99f,
    faSquareCheck: $d8206b3ab2e65c05$export$5bb6a0c94ad2f4bb,
    faCheckSquare: $d8206b3ab2e65c05$export$f0c8040f596df7fe,
    faPesetaSign: $d8206b3ab2e65c05$export$a6f8654bcd49a39f,
    faHeading: $d8206b3ab2e65c05$export$4805b8d175aeb9fb,
    faHeader: $d8206b3ab2e65c05$export$579f9604bb10a61a,
    faGhost: $d8206b3ab2e65c05$export$1a989eb1919c64c1,
    faList: $d8206b3ab2e65c05$export$6cfc59842fedbc16,
    faListSquares: $d8206b3ab2e65c05$export$e3f160fc949c2b9d,
    faSquarePhoneFlip: $d8206b3ab2e65c05$export$b627121801cad756,
    faPhoneSquareAlt: $d8206b3ab2e65c05$export$a41e77f0de98bba7,
    faCartPlus: $d8206b3ab2e65c05$export$6675e2bf21fdb87e,
    faGamepad: $d8206b3ab2e65c05$export$6a66b1b639455bef,
    faCircleDot: $d8206b3ab2e65c05$export$aa13d9234890e8d3,
    faDotCircle: $d8206b3ab2e65c05$export$92bc269cb244d66a,
    faFaceDizzy: $d8206b3ab2e65c05$export$635e4d8cc8428961,
    faDizzy: $d8206b3ab2e65c05$export$89a2b10dabc487e8,
    faEgg: $d8206b3ab2e65c05$export$1199a8ce85311ab5,
    faHouseMedicalCircleXmark: $d8206b3ab2e65c05$export$bf221f0e8296233e,
    faCampground: $d8206b3ab2e65c05$export$295287303c0e9c7c,
    faFolderPlus: $d8206b3ab2e65c05$export$e18e05ffa2045d3b,
    faFutbol: $d8206b3ab2e65c05$export$65a345b33858a655,
    faFutbolBall: $d8206b3ab2e65c05$export$51a344ca0a215620,
    faSoccerBall: $d8206b3ab2e65c05$export$f4a29712c724ba2d,
    faPaintbrush: $d8206b3ab2e65c05$export$7c8b56f3f296a814,
    faPaintBrush: $d8206b3ab2e65c05$export$594db3339e212bc9,
    faLock: $d8206b3ab2e65c05$export$7aa08ad5d562578a,
    faGasPump: $d8206b3ab2e65c05$export$84666c793cb2a347,
    faHotTubPerson: $d8206b3ab2e65c05$export$6e6bd68568c17bbf,
    faHotTub: $d8206b3ab2e65c05$export$4842af92b516c40b,
    faMapLocation: $d8206b3ab2e65c05$export$9a8788ec0e4a9a0b,
    faMapMarked: $d8206b3ab2e65c05$export$df04458e7e32352c,
    faHouseFloodWater: $d8206b3ab2e65c05$export$70fd6006b4e54a5,
    faTree: $d8206b3ab2e65c05$export$1744430f718caf6b,
    faBridgeLock: $d8206b3ab2e65c05$export$cffe7d85a82d8116,
    faSackDollar: $d8206b3ab2e65c05$export$15854c4475080853,
    faPenToSquare: $d8206b3ab2e65c05$export$ba236543926e3569,
    faEdit: $d8206b3ab2e65c05$export$7be713e57d023733,
    faCarSide: $d8206b3ab2e65c05$export$6f7218565b1b8d0e,
    faShareNodes: $d8206b3ab2e65c05$export$cdaf45d4e50ac035,
    faShareAlt: $d8206b3ab2e65c05$export$f8e8bb0b3aa8c658,
    faHeartCircleMinus: $d8206b3ab2e65c05$export$24c21c3ca00f3625,
    faHourglassHalf: $d8206b3ab2e65c05$export$703272eebf5e3eea,
    faHourglass2: $d8206b3ab2e65c05$export$f1052bbf6bf361c0,
    faMicroscope: $d8206b3ab2e65c05$export$6a99139787bf9967,
    faSink: $d8206b3ab2e65c05$export$2a9dda2096ce792e,
    faBagShopping: $d8206b3ab2e65c05$export$b0137b4600e9ab12,
    faShoppingBag: $d8206b3ab2e65c05$export$5745f8adbc11eb01,
    faArrowDownZA: $d8206b3ab2e65c05$export$cf79d63ad07d943a,
    faSortAlphaDesc: $d8206b3ab2e65c05$export$7caf99612a55d427,
    faSortAlphaDownAlt: $d8206b3ab2e65c05$export$e12d23d82d5c8a89,
    faMitten: $d8206b3ab2e65c05$export$5030322c5fc886d7,
    faPersonRays: $d8206b3ab2e65c05$export$49577f913f0fe4d2,
    faUsers: $d8206b3ab2e65c05$export$e5a8f011aef571ac,
    faEyeSlash: $d8206b3ab2e65c05$export$ed3f2918429d029a,
    faFlaskVial: $d8206b3ab2e65c05$export$a25a266ce0c95019,
    faHand: $d8206b3ab2e65c05$export$f69db0b876f7d753,
    faHandPaper: $d8206b3ab2e65c05$export$6e6216c8b50471bb,
    faOm: $d8206b3ab2e65c05$export$8de8eb94230028a5,
    faWorm: $d8206b3ab2e65c05$export$2571e33fa6c25993,
    faHouseCircleXmark: $d8206b3ab2e65c05$export$423555e8708eb4c7,
    faPlug: $d8206b3ab2e65c05$export$cae5752c3e3b6545,
    faChevronUp: $d8206b3ab2e65c05$export$877e5ae47a854215,
    faHandSpock: $d8206b3ab2e65c05$export$2262d6b626de1120,
    faStopwatch: $d8206b3ab2e65c05$export$b85a7300fc7960b6,
    faFaceKiss: $d8206b3ab2e65c05$export$5a54c83033a0a56a,
    faKiss: $d8206b3ab2e65c05$export$c762a77aabf64fd0,
    faBridgeCircleXmark: $d8206b3ab2e65c05$export$834071278537f121,
    faFaceGrinTongue: $d8206b3ab2e65c05$export$95a7394c24f57943,
    faGrinTongue: $d8206b3ab2e65c05$export$ef222816a43a4b3a,
    faChessBishop: $d8206b3ab2e65c05$export$a831eedd2f59c62f,
    faFaceGrinWink: $d8206b3ab2e65c05$export$1dd161850c5bc64e,
    faGrinWink: $d8206b3ab2e65c05$export$2397fcd34eb12177,
    faEarDeaf: $d8206b3ab2e65c05$export$c9c5b76ec992eab4,
    faDeaf: $d8206b3ab2e65c05$export$4b666adf83f0de01,
    faDeafness: $d8206b3ab2e65c05$export$85c6a9ab2fa2631e,
    faHardOfHearing: $d8206b3ab2e65c05$export$ebecf90a5676e17a,
    faRoadCircleCheck: $d8206b3ab2e65c05$export$3f22db9ae9b6be1c,
    faDiceFive: $d8206b3ab2e65c05$export$d9769fb795c2db82,
    faSquareRss: $d8206b3ab2e65c05$export$97d1903b1e012ff7,
    faRssSquare: $d8206b3ab2e65c05$export$89c9b1cca2c11484,
    faLandMineOn: $d8206b3ab2e65c05$export$567a897fc092e403,
    faICursor: $d8206b3ab2e65c05$export$7fddf76ec23943d8,
    faStamp: $d8206b3ab2e65c05$export$722e92d2d93ffc68,
    faStairs: $d8206b3ab2e65c05$export$68b3af7444c89df7,
    faI: $d8206b3ab2e65c05$export$aee03ca0815b7c38,
    faHryvniaSign: $d8206b3ab2e65c05$export$22a9491150c64fef,
    faHryvnia: $d8206b3ab2e65c05$export$33d5f94bd6f75f59,
    faPills: $d8206b3ab2e65c05$export$6380e2ed6e69d350,
    faFaceGrinWide: $d8206b3ab2e65c05$export$bdbabf493c478cde,
    faGrinAlt: $d8206b3ab2e65c05$export$b4abebfe416d36ba,
    faTooth: $d8206b3ab2e65c05$export$3a1fa2d16f90d635,
    faV: $d8206b3ab2e65c05$export$6fb446f784f6b9b3,
    faBangladeshiTakaSign: $d8206b3ab2e65c05$export$469d376940e10d37,
    faBicycle: $d8206b3ab2e65c05$export$36cb1885ad7a570f,
    faStaffSnake: $d8206b3ab2e65c05$export$76d998742bc186eb,
    faRodAsclepius: $d8206b3ab2e65c05$export$f2c3e92ee37a8d89,
    faRodSnake: $d8206b3ab2e65c05$export$5d61dcb598296af0,
    faStaffAesculapius: $d8206b3ab2e65c05$export$97c8a2cdba3b7700,
    faHeadSideCoughSlash: $d8206b3ab2e65c05$export$b293ee8fb8e6b0c4,
    faTruckMedical: $d8206b3ab2e65c05$export$fb6bd43f079f72e2,
    faAmbulance: $d8206b3ab2e65c05$export$f5c7042778b51765,
    faWheatAwnCircleExclamation: $d8206b3ab2e65c05$export$e23367e54f665590,
    faSnowman: $d8206b3ab2e65c05$export$b23df6bafb174693,
    faMortarPestle: $d8206b3ab2e65c05$export$55ceb5d0c144580a,
    faRoadBarrier: $d8206b3ab2e65c05$export$f3e925217e396f44,
    faSchool: $d8206b3ab2e65c05$export$51e9b8434982947d,
    faIgloo: $d8206b3ab2e65c05$export$4a284575edd6f1af,
    faJoint: $d8206b3ab2e65c05$export$e5a289fb22ffb8cb,
    faAngleRight: $d8206b3ab2e65c05$export$6bce1afb61f2eb66,
    faHorse: $d8206b3ab2e65c05$export$5b05f097fa38352a,
    faQ: $d8206b3ab2e65c05$export$5a2b164552deda9f,
    faG: $d8206b3ab2e65c05$export$9f5c2b0db8eedeac,
    faNotesMedical: $d8206b3ab2e65c05$export$b2d79133c81d6697,
    faTemperatureHalf: $d8206b3ab2e65c05$export$a3f1d7f13c202adc,
    faTemperature2: $d8206b3ab2e65c05$export$8176e649df45b32c,
    faThermometer2: $d8206b3ab2e65c05$export$4dd764ac8d512682,
    faThermometerHalf: $d8206b3ab2e65c05$export$2090f040324b4449,
    faDongSign: $d8206b3ab2e65c05$export$18659308f17918a5,
    faCapsules: $d8206b3ab2e65c05$export$ba6fd4a436804a48,
    faPooStorm: $d8206b3ab2e65c05$export$48a38da471b097a2,
    faPooBolt: $d8206b3ab2e65c05$export$9a24e77f74d9cbd9,
    faFaceFrownOpen: $d8206b3ab2e65c05$export$c8a28356e07b9ccb,
    faFrownOpen: $d8206b3ab2e65c05$export$c4775e66bed5d96,
    faHandPointUp: $d8206b3ab2e65c05$export$cdc9f5e7e94e76da,
    faMoneyBill: $d8206b3ab2e65c05$export$608138a7337b5d1a,
    faBookmark: $d8206b3ab2e65c05$export$4ed9da5c3cca0ef1,
    faAlignJustify: $d8206b3ab2e65c05$export$97c42b56d462df72,
    faUmbrellaBeach: $d8206b3ab2e65c05$export$20932e4d438e4e4c,
    faHelmetUn: $d8206b3ab2e65c05$export$5e975cb293c48461,
    faBullseye: $d8206b3ab2e65c05$export$554720e3bf74fe90,
    faBacon: $d8206b3ab2e65c05$export$ab07061fe21a3a8e,
    faHandPointDown: $d8206b3ab2e65c05$export$f6dcbf0a940428f4,
    faArrowUpFromBracket: $d8206b3ab2e65c05$export$c2af1be14cd87640,
    faFolder: $d8206b3ab2e65c05$export$72b780186370e953,
    faFolderBlank: $d8206b3ab2e65c05$export$9ef114244d26da0,
    faFileWaveform: $d8206b3ab2e65c05$export$5e0c19cf315ac1bf,
    faFileMedicalAlt: $d8206b3ab2e65c05$export$ef02a0f5b39aa61f,
    faRadiation: $d8206b3ab2e65c05$export$4c4e509518093d6d,
    faChartSimple: $d8206b3ab2e65c05$export$8760a1de19ea40b9,
    faMarsStroke: $d8206b3ab2e65c05$export$aa05fce255a5d269,
    faVial: $d8206b3ab2e65c05$export$aa014b06d2d70598,
    faGauge: $d8206b3ab2e65c05$export$dbfb0a9f89ad94a4,
    faDashboard: $d8206b3ab2e65c05$export$b7ce24136743d0f1,
    faGaugeMed: $d8206b3ab2e65c05$export$f948a9dd257979f3,
    faTachometerAltAverage: $d8206b3ab2e65c05$export$6f22c345e5a92d1a,
    faWandMagicSparkles: $d8206b3ab2e65c05$export$5325fc72e75360b4,
    faMagicWandSparkles: $d8206b3ab2e65c05$export$c93286938249f0da,
    faE: $d8206b3ab2e65c05$export$86923e6fe1b42f5e,
    faPenClip: $d8206b3ab2e65c05$export$eff4bdcafd3b8d1c,
    faPenAlt: $d8206b3ab2e65c05$export$a3d3e92e430d3beb,
    faBridgeCircleExclamation: $d8206b3ab2e65c05$export$4f25939fdf728c27,
    faUser: $d8206b3ab2e65c05$export$f5699fa0844e0188,
    faSchoolCircleCheck: $d8206b3ab2e65c05$export$c8c95c2f9937bf6a,
    faDumpster: $d8206b3ab2e65c05$export$3b934e22d1851a3b,
    faVanShuttle: $d8206b3ab2e65c05$export$ecbd233b96906ee1,
    faShuttleVan: $d8206b3ab2e65c05$export$9d63d851db698c09,
    faBuildingUser: $d8206b3ab2e65c05$export$d65aef1ed7db1dae,
    faSquareCaretLeft: $d8206b3ab2e65c05$export$2c5163541229363,
    faCaretSquareLeft: $d8206b3ab2e65c05$export$d0c8ba444f1f9581,
    faHighlighter: $d8206b3ab2e65c05$export$73801ed54b42fabe,
    faKey: $d8206b3ab2e65c05$export$fa6ecc35e7315db,
    faBullhorn: $d8206b3ab2e65c05$export$dacae2b4ec565333,
    faGlobe: $d8206b3ab2e65c05$export$b1b1cdce4a19c682,
    faSynagogue: $d8206b3ab2e65c05$export$20d991385719b5b4,
    faPersonHalfDress: $d8206b3ab2e65c05$export$f3d75c19191f1688,
    faRoadBridge: $d8206b3ab2e65c05$export$4d6835e7175dec24,
    faLocationArrow: $d8206b3ab2e65c05$export$4ac9c4c370f7b157,
    faC: $d8206b3ab2e65c05$export$a2c1c457834fc6d8,
    faTabletButton: $d8206b3ab2e65c05$export$2d33c367b2b091ac,
    faBuildingLock: $d8206b3ab2e65c05$export$6f08294ba8a2459c,
    faPizzaSlice: $d8206b3ab2e65c05$export$c9f93c4667edc585,
    faMoneyBillWave: $d8206b3ab2e65c05$export$53e23123cc9a6796,
    faChartArea: $d8206b3ab2e65c05$export$2acab8312b7a999b,
    faAreaChart: $d8206b3ab2e65c05$export$fc2e595f0e0612cb,
    faHouseFlag: $d8206b3ab2e65c05$export$9a3d31c75a465b9a,
    faPersonCircleMinus: $d8206b3ab2e65c05$export$d7ccc6651f90f7cc,
    faBan: $d8206b3ab2e65c05$export$76f704d256def3c7,
    faCancel: $d8206b3ab2e65c05$export$6d25ef56192f6d69,
    faCameraRotate: $d8206b3ab2e65c05$export$e0ce7d1aba7105e7,
    faSprayCanSparkles: $d8206b3ab2e65c05$export$43832c90c10a7a31,
    faAirFreshener: $d8206b3ab2e65c05$export$a5e63e89b5ccee83,
    faStar: $d8206b3ab2e65c05$export$a3b0eb2cd7942125,
    faRepeat: $d8206b3ab2e65c05$export$cb8434288c91ae83,
    faCross: $d8206b3ab2e65c05$export$9d0a89fcd084abb,
    faBox: $d8206b3ab2e65c05$export$6e7cf270cda52323,
    faVenusMars: $d8206b3ab2e65c05$export$63f2d9e5f4689aa8,
    faArrowPointer: $d8206b3ab2e65c05$export$e4f903bc63db445,
    faMousePointer: $d8206b3ab2e65c05$export$2e19a69cc26b147,
    faMaximize: $d8206b3ab2e65c05$export$8d2b1b230601e804,
    faExpandArrowsAlt: $d8206b3ab2e65c05$export$6219dcd88b5fa6c2,
    faChargingStation: $d8206b3ab2e65c05$export$bab2cd86f8c65657,
    faShapes: $d8206b3ab2e65c05$export$b17d50542d1fc340,
    faTriangleCircleSquare: $d8206b3ab2e65c05$export$34261e5aea24fc1d,
    faShuffle: $d8206b3ab2e65c05$export$ee94b652453ad208,
    faRandom: $d8206b3ab2e65c05$export$8357bf8cc666d5f0,
    faPersonRunning: $d8206b3ab2e65c05$export$f48814ae62850c74,
    faRunning: $d8206b3ab2e65c05$export$5dfd1cb43dc9eadb,
    faMobileRetro: $d8206b3ab2e65c05$export$7955f08360418647,
    faGripLinesVertical: $d8206b3ab2e65c05$export$523960de087f5198,
    faSpider: $d8206b3ab2e65c05$export$6daa96b1986e2ef0,
    faHandsBound: $d8206b3ab2e65c05$export$740142a89118fbc0,
    faFileInvoiceDollar: $d8206b3ab2e65c05$export$a3dced32d48cb1ea,
    faPlaneCircleExclamation: $d8206b3ab2e65c05$export$f201ba865ea1b8dc,
    faXRay: $d8206b3ab2e65c05$export$8cf137aceaaf4de0,
    faSpellCheck: $d8206b3ab2e65c05$export$761e747b06ed2e1f,
    faSlash: $d8206b3ab2e65c05$export$f54d004dd5f1cb5e,
    faComputerMouse: $d8206b3ab2e65c05$export$72cf138e5ddda6eb,
    faMouse: $d8206b3ab2e65c05$export$198b96b894c66074,
    faArrowRightToBracket: $d8206b3ab2e65c05$export$a02c5909359525be,
    faSignIn: $d8206b3ab2e65c05$export$a55eff0ca4f9c3df,
    faShopSlash: $d8206b3ab2e65c05$export$b3d636689da4a3e5,
    faStoreAltSlash: $d8206b3ab2e65c05$export$b932a586f6ff48b4,
    faServer: $d8206b3ab2e65c05$export$1bf820d499b6202e,
    faVirusCovidSlash: $d8206b3ab2e65c05$export$61c2a6b698f55df6,
    faShopLock: $d8206b3ab2e65c05$export$452410c103c2403b,
    faHourglassStart: $d8206b3ab2e65c05$export$f0c28584caa8f4b,
    faHourglass1: $d8206b3ab2e65c05$export$87929336ab5c59cd,
    faBlenderPhone: $d8206b3ab2e65c05$export$f35a116a762ef8fc,
    faBuildingWheat: $d8206b3ab2e65c05$export$6c0cfe6d58faf860,
    faPersonBreastfeeding: $d8206b3ab2e65c05$export$9b94ed8d16d281f9,
    faRightToBracket: $d8206b3ab2e65c05$export$a5fd2acfcb5247c6,
    faSignInAlt: $d8206b3ab2e65c05$export$e6709746115bd2ea,
    faVenus: $d8206b3ab2e65c05$export$f89d028573ffc0a6,
    faPassport: $d8206b3ab2e65c05$export$2c31ca0d9bee400f,
    faHeartPulse: $d8206b3ab2e65c05$export$a6d8e50dcd4b4294,
    faHeartbeat: $d8206b3ab2e65c05$export$ca880e19206e80aa,
    faPeopleCarryBox: $d8206b3ab2e65c05$export$7754cc6d5559ff38,
    faPeopleCarry: $d8206b3ab2e65c05$export$35fbd4ff1265acd5,
    faTemperatureHigh: $d8206b3ab2e65c05$export$15d012277c3ecf9a,
    faMicrochip: $d8206b3ab2e65c05$export$4a7bb4be15f35178,
    faCrown: $d8206b3ab2e65c05$export$dc1083dcd1d7b9d6,
    faWeightHanging: $d8206b3ab2e65c05$export$43d1fa6671908715,
    faXmarksLines: $d8206b3ab2e65c05$export$f4595f012786d346,
    faFilePrescription: $d8206b3ab2e65c05$export$a20cb90865b6beb8,
    faWeightScale: $d8206b3ab2e65c05$export$e521c542d18b85c3,
    faWeight: $d8206b3ab2e65c05$export$cf3bafa68a60bae4,
    faUserGroup: $d8206b3ab2e65c05$export$3d626cfc365a7e36,
    faUserFriends: $d8206b3ab2e65c05$export$46073bec205635d9,
    faArrowUpAZ: $d8206b3ab2e65c05$export$fb00fdd8857804c7,
    faSortAlphaUp: $d8206b3ab2e65c05$export$3c4115b156be730d,
    faChessKnight: $d8206b3ab2e65c05$export$861b1f13085cf122,
    faFaceLaughSquint: $d8206b3ab2e65c05$export$67ca89c1ca38d559,
    faLaughSquint: $d8206b3ab2e65c05$export$b206e700cf7084e1,
    faWheelchair: $d8206b3ab2e65c05$export$76a9413fbe130a53,
    faCircleArrowUp: $d8206b3ab2e65c05$export$a29c8ea43e92771d,
    faArrowCircleUp: $d8206b3ab2e65c05$export$a2f6f3baa50af0b1,
    faToggleOn: $d8206b3ab2e65c05$export$5cffc34afa81e517,
    faPersonWalking: $d8206b3ab2e65c05$export$6af1cc5998ca52bc,
    faWalking: $d8206b3ab2e65c05$export$4886811b7174ec35,
    faL: $d8206b3ab2e65c05$export$be32b10ce70a09df,
    faFire: $d8206b3ab2e65c05$export$7b24b34ef6cc130c,
    faBedPulse: $d8206b3ab2e65c05$export$580ae0d0bbd809fb,
    faProcedures: $d8206b3ab2e65c05$export$5f9e1870e1866dde,
    faShuttleSpace: $d8206b3ab2e65c05$export$76d92e7f30d064c5,
    faSpaceShuttle: $d8206b3ab2e65c05$export$4d1c12ba2b4ca565,
    faFaceLaugh: $d8206b3ab2e65c05$export$2f203616c892d415,
    faLaugh: $d8206b3ab2e65c05$export$6c74e314e801a4fe,
    faFolderOpen: $d8206b3ab2e65c05$export$ff7e93418af88b78,
    faHeartCirclePlus: $d8206b3ab2e65c05$export$2a155a6e20f64134,
    faCodeFork: $d8206b3ab2e65c05$export$f54081bdbf6d4eb5,
    faCity: $d8206b3ab2e65c05$export$a9947c2888b3c8fd,
    faMicrophoneLines: $d8206b3ab2e65c05$export$417391ae30b5922e,
    faMicrophoneAlt: $d8206b3ab2e65c05$export$f08ef94fea14f5ac,
    faPepperHot: $d8206b3ab2e65c05$export$4894bf28f771e1f3,
    faUnlock: $d8206b3ab2e65c05$export$db1382cd406cc506,
    faColonSign: $d8206b3ab2e65c05$export$dec10d4c2c113312,
    faHeadset: $d8206b3ab2e65c05$export$23b086400a31acfe,
    faStoreSlash: $d8206b3ab2e65c05$export$4ab2f33219630bad,
    faRoadCircleXmark: $d8206b3ab2e65c05$export$2ffc88a4d31e8ffc,
    faUserMinus: $d8206b3ab2e65c05$export$d6e17c0df8ed1bf7,
    faMarsStrokeUp: $d8206b3ab2e65c05$export$efc6d53e0dedceee,
    faMarsStrokeV: $d8206b3ab2e65c05$export$ed7aa1c25104f333,
    faChampagneGlasses: $d8206b3ab2e65c05$export$7df1926e9eef8cc3,
    faGlassCheers: $d8206b3ab2e65c05$export$20007d7d74cb98fe,
    faClipboard: $d8206b3ab2e65c05$export$97d84347d71ba297,
    faHouseCircleExclamation: $d8206b3ab2e65c05$export$8403e4b31e8aa805,
    faFileArrowUp: $d8206b3ab2e65c05$export$929df388c07f293d,
    faFileUpload: $d8206b3ab2e65c05$export$dd55ded1264643d2,
    faWifi: $d8206b3ab2e65c05$export$1642419fe3db2857,
    faWifi3: $d8206b3ab2e65c05$export$2349bb04a04f4b2d,
    faWifiStrong: $d8206b3ab2e65c05$export$4b3167c852f4c4aa,
    faBath: $d8206b3ab2e65c05$export$1ea66a88b8f620c9,
    faBathtub: $d8206b3ab2e65c05$export$40ae013b5e6269d8,
    faUnderline: $d8206b3ab2e65c05$export$22346afd6a3cddf8,
    faUserPen: $d8206b3ab2e65c05$export$3842882ea09b25af,
    faUserEdit: $d8206b3ab2e65c05$export$a68a6960fc8eef82,
    faSignature: $d8206b3ab2e65c05$export$afa7b53ac8ebcb5d,
    faStroopwafel: $d8206b3ab2e65c05$export$195780ddabd8e0c6,
    faBold: $d8206b3ab2e65c05$export$7e0c7fd2a2e88823,
    faAnchorLock: $d8206b3ab2e65c05$export$217195c80db39097,
    faBuildingNgo: $d8206b3ab2e65c05$export$374e1dce366a2175,
    faManatSign: $d8206b3ab2e65c05$export$1ff755b523ab2851,
    faNotEqual: $d8206b3ab2e65c05$export$6a15ccae09bbaf93,
    faBorderTopLeft: $d8206b3ab2e65c05$export$cf897c3e0abd59e4,
    faBorderStyle: $d8206b3ab2e65c05$export$c2867ca78120d644,
    faMapLocationDot: $d8206b3ab2e65c05$export$757f50b8af780c19,
    faMapMarkedAlt: $d8206b3ab2e65c05$export$a977d47c74d8e86c,
    faJedi: $d8206b3ab2e65c05$export$859f204e59641ca4,
    faSquarePollVertical: $d8206b3ab2e65c05$export$91d747e5aabe6fe8,
    faPoll: $d8206b3ab2e65c05$export$bc8ca14ab51f93db,
    faMugHot: $d8206b3ab2e65c05$export$47a822c30184e8af,
    faCarBattery: $d8206b3ab2e65c05$export$a44d0c11093d9c1e,
    faBatteryCar: $d8206b3ab2e65c05$export$9133165ca669dd4b,
    faGift: $d8206b3ab2e65c05$export$b2727de8ccdbb5ec,
    faDiceTwo: $d8206b3ab2e65c05$export$4d85df590065572f,
    faChessQueen: $d8206b3ab2e65c05$export$7b8ce73615739d30,
    faGlasses: $d8206b3ab2e65c05$export$58d7d709c0a8ca5f,
    faChessBoard: $d8206b3ab2e65c05$export$bd301515df6246af,
    faBuildingCircleCheck: $d8206b3ab2e65c05$export$5559de5f969b9590,
    faPersonChalkboard: $d8206b3ab2e65c05$export$c9dc1583b207b7ff,
    faMarsStrokeRight: $d8206b3ab2e65c05$export$321e84e6a900c2d6,
    faMarsStrokeH: $d8206b3ab2e65c05$export$5cb0daeafbcdabe3,
    faHandBackFist: $d8206b3ab2e65c05$export$be38a892fe9b4098,
    faHandRock: $d8206b3ab2e65c05$export$97a81eba394c8c44,
    faSquareCaretUp: $d8206b3ab2e65c05$export$66068918abb14406,
    faCaretSquareUp: $d8206b3ab2e65c05$export$307ae80b26533ce5,
    faCloudShowersWater: $d8206b3ab2e65c05$export$b416056e795d2eac,
    faChartBar: $d8206b3ab2e65c05$export$b532f5d25de97633,
    faBarChart: $d8206b3ab2e65c05$export$2d5f754a5e5738b,
    faHandsBubbles: $d8206b3ab2e65c05$export$2f78563e14e49916,
    faHandsWash: $d8206b3ab2e65c05$export$996b5dea53b124e3,
    faLessThanEqual: $d8206b3ab2e65c05$export$b2c723344cff0d8,
    faTrain: $d8206b3ab2e65c05$export$17cde74bf6f1ee89,
    faEyeLowVision: $d8206b3ab2e65c05$export$23a892b1a4b994bd,
    faLowVision: $d8206b3ab2e65c05$export$7a65d2aa54cb4e93,
    faCrow: $d8206b3ab2e65c05$export$bfa312207b788ed9,
    faSailboat: $d8206b3ab2e65c05$export$e363e74e36cce80c,
    faWindowRestore: $d8206b3ab2e65c05$export$eccfff9bfd585652,
    faSquarePlus: $d8206b3ab2e65c05$export$eaf727acca5a35e4,
    faPlusSquare: $d8206b3ab2e65c05$export$b6359eebfe900c35,
    faToriiGate: $d8206b3ab2e65c05$export$75825a4c2b3375e,
    faFrog: $d8206b3ab2e65c05$export$fe2358263efac504,
    faBucket: $d8206b3ab2e65c05$export$2124c7628e573b84,
    faImage: $d8206b3ab2e65c05$export$7e9f0928967e03b,
    faMicrophone: $d8206b3ab2e65c05$export$eed3c491effe6d12,
    faCow: $d8206b3ab2e65c05$export$1da3b2e53dcafa2d,
    faCaretUp: $d8206b3ab2e65c05$export$7de776bdab4e536d,
    faScrewdriver: $d8206b3ab2e65c05$export$7484ff654cd6474f,
    faFolderClosed: $d8206b3ab2e65c05$export$5e30548b7f8eeb95,
    faHouseTsunami: $d8206b3ab2e65c05$export$197b9567e88a0b1d,
    faSquareNfi: $d8206b3ab2e65c05$export$5498258519fc5b72,
    faArrowUpFromGroundWater: $d8206b3ab2e65c05$export$cbe485a104805f4f,
    faMartiniGlass: $d8206b3ab2e65c05$export$98401bb29cff68e0,
    faGlassMartiniAlt: $d8206b3ab2e65c05$export$2258439b8f4e7acb,
    faRotateLeft: $d8206b3ab2e65c05$export$7adaa412bd8eb08f,
    faRotateBack: $d8206b3ab2e65c05$export$9706706f1bc7b12,
    faRotateBackward: $d8206b3ab2e65c05$export$4ceb0b05fed961a9,
    faUndoAlt: $d8206b3ab2e65c05$export$c8197b992c46c4a6,
    faTableColumns: $d8206b3ab2e65c05$export$ccaa019a3fd4563f,
    faColumns: $d8206b3ab2e65c05$export$bb861166644ac28a,
    faLemon: $d8206b3ab2e65c05$export$4fbda8f64648f3b5,
    faHeadSideMask: $d8206b3ab2e65c05$export$280300af4baa1a3e,
    faHandshake: $d8206b3ab2e65c05$export$b4c63e9bfc7906f1,
    faGem: $d8206b3ab2e65c05$export$31ee86ac717db552,
    faDolly: $d8206b3ab2e65c05$export$5879d0bca1aa497b,
    faDollyBox: $d8206b3ab2e65c05$export$461bbb9e92cc531b,
    faSmoking: $d8206b3ab2e65c05$export$c4ab83701fc591a5,
    faMinimize: $d8206b3ab2e65c05$export$e0601b1f239fec74,
    faCompressArrowsAlt: $d8206b3ab2e65c05$export$39205db0ea980efd,
    faMonument: $d8206b3ab2e65c05$export$6f9b0bfc012deb25,
    faSnowplow: $d8206b3ab2e65c05$export$695fae58f55c3a87,
    faAnglesRight: $d8206b3ab2e65c05$export$48b60f1720e09944,
    faAngleDoubleRight: $d8206b3ab2e65c05$export$792931403404faf0,
    faCannabis: $d8206b3ab2e65c05$export$8ec2f752344b69bd,
    faCirclePlay: $d8206b3ab2e65c05$export$86c4e45dc3302d15,
    faPlayCircle: $d8206b3ab2e65c05$export$cf04333781061c5e,
    faTablets: $d8206b3ab2e65c05$export$bed2b0ed4ae45e0d,
    faEthernet: $d8206b3ab2e65c05$export$6bad2c9f317b52e5,
    faEuroSign: $d8206b3ab2e65c05$export$902a3969bb113dff,
    faEur: $d8206b3ab2e65c05$export$4b859160cfeb12ff,
    faEuro: $d8206b3ab2e65c05$export$bdabbefede2d3a2,
    faChair: $d8206b3ab2e65c05$export$a339864ee3df7e9a,
    faCircleCheck: $d8206b3ab2e65c05$export$c2e9877668862374,
    faCheckCircle: $d8206b3ab2e65c05$export$be9e388158c74f29,
    faCircleStop: $d8206b3ab2e65c05$export$229de76dfef2687f,
    faStopCircle: $d8206b3ab2e65c05$export$47af2aad60ab3e7c,
    faCompassDrafting: $d8206b3ab2e65c05$export$aaaddd2cf7e20f64,
    faDraftingCompass: $d8206b3ab2e65c05$export$c8c2b127d13b9d79,
    faPlateWheat: $d8206b3ab2e65c05$export$2eff9f6cbe00a643,
    faIcicles: $d8206b3ab2e65c05$export$78792ed87d92a3ad,
    faPersonShelter: $d8206b3ab2e65c05$export$d359c2cc7640953c,
    faNeuter: $d8206b3ab2e65c05$export$771cf879fba0cf93,
    faIdBadge: $d8206b3ab2e65c05$export$a75288855ea05282,
    faMarker: $d8206b3ab2e65c05$export$e6789173649caa25,
    faFaceLaughBeam: $d8206b3ab2e65c05$export$3f2d51c0547bf984,
    faLaughBeam: $d8206b3ab2e65c05$export$a88d1f4073ea9369,
    faHelicopterSymbol: $d8206b3ab2e65c05$export$2a66e6044c1f7036,
    faUniversalAccess: $d8206b3ab2e65c05$export$e119aada7f690d05,
    faCircleChevronUp: $d8206b3ab2e65c05$export$7b69b3617b84259b,
    faChevronCircleUp: $d8206b3ab2e65c05$export$b786cf5db03f2c36,
    faLariSign: $d8206b3ab2e65c05$export$d317bc452442782d,
    faVolcano: $d8206b3ab2e65c05$export$bae30a76735500e1,
    faPersonWalkingDashedLineArrowRight: $d8206b3ab2e65c05$export$a1d09c95bee8043b,
    faSterlingSign: $d8206b3ab2e65c05$export$170c56774c8e7961,
    faGbp: $d8206b3ab2e65c05$export$3d9479ec1d1ae83e,
    faPoundSign: $d8206b3ab2e65c05$export$9ce041dfec8319b,
    faViruses: $d8206b3ab2e65c05$export$ee194b18f5c6f6b6,
    faSquarePersonConfined: $d8206b3ab2e65c05$export$8aaca358568da0e0,
    faUserTie: $d8206b3ab2e65c05$export$48c51dda34e9f04c,
    faArrowDownLong: $d8206b3ab2e65c05$export$5977e8de7e65b20,
    faLongArrowDown: $d8206b3ab2e65c05$export$52ecf90b62f3f030,
    faTentArrowDownToLine: $d8206b3ab2e65c05$export$8a4f323f00a91606,
    faCertificate: $d8206b3ab2e65c05$export$a881f37164b11fbf,
    faReplyAll: $d8206b3ab2e65c05$export$ca6fd367f31ecbc5,
    faMailReplyAll: $d8206b3ab2e65c05$export$8274334f3a2c1841,
    faSuitcase: $d8206b3ab2e65c05$export$60710f3921019268,
    faPersonSkating: $d8206b3ab2e65c05$export$f3854553fe688388,
    faSkating: $d8206b3ab2e65c05$export$21bd1d54bd4f2c5a,
    faFilterCircleDollar: $d8206b3ab2e65c05$export$3300e4b4d1d1936f,
    faFunnelDollar: $d8206b3ab2e65c05$export$cebe38ad8f0a143d,
    faCameraRetro: $d8206b3ab2e65c05$export$41dbdadc07a89b05,
    faCircleArrowDown: $d8206b3ab2e65c05$export$a30c52cde32bec7e,
    faArrowCircleDown: $d8206b3ab2e65c05$export$6cfa36bbb3a057,
    faFileImport: $d8206b3ab2e65c05$export$d796c05153b1255c,
    faArrowRightToFile: $d8206b3ab2e65c05$export$32f14beaf6294476,
    faSquareArrowUpRight: $d8206b3ab2e65c05$export$38150b61dfd06fff,
    faExternalLinkSquare: $d8206b3ab2e65c05$export$e04d83fed5ebcebf,
    faBoxOpen: $d8206b3ab2e65c05$export$9010ed816a8b9c97,
    faScroll: $d8206b3ab2e65c05$export$7c265716d4399676,
    faSpa: $d8206b3ab2e65c05$export$f9a38ef7b046ab51,
    faLocationPinLock: $d8206b3ab2e65c05$export$db853fbb474326cc,
    faPause: $d8206b3ab2e65c05$export$da79f048408b1722,
    faHillAvalanche: $d8206b3ab2e65c05$export$50d11c98c99e3b2d,
    faTemperatureEmpty: $d8206b3ab2e65c05$export$ac389bf5cc37feb5,
    faTemperature0: $d8206b3ab2e65c05$export$e99b7d2ccc282383,
    faThermometer0: $d8206b3ab2e65c05$export$4c13a186ecce3b80,
    faThermometerEmpty: $d8206b3ab2e65c05$export$81a2f8298cf523f9,
    faBomb: $d8206b3ab2e65c05$export$d59078f6e80b4a67,
    faRegistered: $d8206b3ab2e65c05$export$5f519e9ac15ab8c3,
    faAddressCard: $d8206b3ab2e65c05$export$6ea408c7266ed557,
    faContactCard: $d8206b3ab2e65c05$export$4ac51eb0b298b190,
    faVcard: $d8206b3ab2e65c05$export$91228257deb1bf18,
    faScaleUnbalancedFlip: $d8206b3ab2e65c05$export$f4d7840209109993,
    faBalanceScaleRight: $d8206b3ab2e65c05$export$2238e05f8920005a,
    faSubscript: $d8206b3ab2e65c05$export$34c1e678c32ed646,
    faDiamondTurnRight: $d8206b3ab2e65c05$export$99749ac517cbef07,
    faDirections: $d8206b3ab2e65c05$export$6a6973de44442fe5,
    faBurst: $d8206b3ab2e65c05$export$ea2986b45ba5d2cf,
    faHouseLaptop: $d8206b3ab2e65c05$export$6486d62e77b910,
    faLaptopHouse: $d8206b3ab2e65c05$export$efd983de5e4d6ad3,
    faFaceTired: $d8206b3ab2e65c05$export$5352cbdc070ce8d,
    faTired: $d8206b3ab2e65c05$export$3d016d62cda18371,
    faMoneyBills: $d8206b3ab2e65c05$export$a822dad6e586ee9e,
    faSmog: $d8206b3ab2e65c05$export$aa11b8edb09fed14,
    faCrutch: $d8206b3ab2e65c05$export$e94134641c0e2,
    faFontAwesome: $d8206b3ab2e65c05$export$aa4baaed1c60f58d,
    faFontAwesomeFlag: $d8206b3ab2e65c05$export$102c25fde54d4843,
    faFontAwesomeLogoFull: $d8206b3ab2e65c05$export$6e20d421a2e0f320,
    faCloudArrowUp: $d8206b3ab2e65c05$export$3507214fff1cc655,
    faCloudUpload: $d8206b3ab2e65c05$export$a48720e6366f5d9a,
    faCloudUploadAlt: $d8206b3ab2e65c05$export$e73b3e819b9d14a5,
    faPalette: $d8206b3ab2e65c05$export$5c390baea5db4f77,
    faArrowsTurnRight: $d8206b3ab2e65c05$export$db9f783f15682c4a,
    faVest: $d8206b3ab2e65c05$export$c8370e53051a657,
    faFerry: $d8206b3ab2e65c05$export$fd312949b97346ae,
    faArrowsDownToPeople: $d8206b3ab2e65c05$export$cfb044c7d35060bb,
    faSeedling: $d8206b3ab2e65c05$export$d7b60b8dbd03cfe4,
    faSprout: $d8206b3ab2e65c05$export$9f3035e3a8c62323,
    faLeftRight: $d8206b3ab2e65c05$export$47d93e9001818ee7,
    faArrowsAltH: $d8206b3ab2e65c05$export$7937ea574fb1389,
    faBoxesPacking: $d8206b3ab2e65c05$export$e81e7f3390fe84fe,
    faCircleArrowLeft: $d8206b3ab2e65c05$export$827fbb87bdbe1028,
    faArrowCircleLeft: $d8206b3ab2e65c05$export$728262abb9f58d0a,
    faGroupArrowsRotate: $d8206b3ab2e65c05$export$88a8383ecdd39a54,
    faBowlFood: $d8206b3ab2e65c05$export$8b89ca3201039376,
    faCandyCane: $d8206b3ab2e65c05$export$14d66ba7571ae0b9,
    faArrowDownWideShort: $d8206b3ab2e65c05$export$4229d00802c33062,
    faSortAmountAsc: $d8206b3ab2e65c05$export$ddf8b8dd5983367d,
    faSortAmountDown: $d8206b3ab2e65c05$export$4b2a02d50e417b5f,
    faCloudBolt: $d8206b3ab2e65c05$export$cdd116afa0309c17,
    faThunderstorm: $d8206b3ab2e65c05$export$bbf9e3d433f8f6de,
    faTextSlash: $d8206b3ab2e65c05$export$ec658c0f040c3e1a,
    faRemoveFormat: $d8206b3ab2e65c05$export$d91179f327329532,
    faFaceSmileWink: $d8206b3ab2e65c05$export$6143da800b0e6626,
    faSmileWink: $d8206b3ab2e65c05$export$f5dbb37f6801ee3f,
    faFileWord: $d8206b3ab2e65c05$export$f0858dff6e769cf6,
    faFilePowerpoint: $d8206b3ab2e65c05$export$c341daeecdea449a,
    faArrowsLeftRight: $d8206b3ab2e65c05$export$672e2f590b189583,
    faArrowsH: $d8206b3ab2e65c05$export$de517642cdb40354,
    faHouseLock: $d8206b3ab2e65c05$export$aa54b16c409e882f,
    faCloudArrowDown: $d8206b3ab2e65c05$export$542a9676c5286e01,
    faCloudDownload: $d8206b3ab2e65c05$export$b318977f29260464,
    faCloudDownloadAlt: $d8206b3ab2e65c05$export$351357a14c41f824,
    faChildren: $d8206b3ab2e65c05$export$f2819bf60df55912,
    faChalkboard: $d8206b3ab2e65c05$export$49a36efd66df775,
    faBlackboard: $d8206b3ab2e65c05$export$f497e01bf522fd9c,
    faUserLargeSlash: $d8206b3ab2e65c05$export$ae7fc6b7f0534be9,
    faUserAltSlash: $d8206b3ab2e65c05$export$46185fab4772ada6,
    faEnvelopeOpen: $d8206b3ab2e65c05$export$c6c3bd5f7d9b8bf2,
    faHandshakeSimpleSlash: $d8206b3ab2e65c05$export$e99ae494101c5e91,
    faHandshakeAltSlash: $d8206b3ab2e65c05$export$ca302f956ae9f1bf,
    faMattressPillow: $d8206b3ab2e65c05$export$f042d3e458efa721,
    faGuaraniSign: $d8206b3ab2e65c05$export$b731a51acb74b00c,
    faArrowsRotate: $d8206b3ab2e65c05$export$2fd091cb98dc8ab8,
    faRefresh: $d8206b3ab2e65c05$export$fd4359e93d7b3d14,
    faSync: $d8206b3ab2e65c05$export$ff87319002e3dae9,
    faFireExtinguisher: $d8206b3ab2e65c05$export$d75fb6743634a0a,
    faCruzeiroSign: $d8206b3ab2e65c05$export$64dd1b27affb6572,
    faGreaterThanEqual: $d8206b3ab2e65c05$export$7bf8dfe2e6661a54,
    faShieldHalved: $d8206b3ab2e65c05$export$36e034ccc72554a9,
    faShieldAlt: $d8206b3ab2e65c05$export$d6508d18a824f291,
    faBookAtlas: $d8206b3ab2e65c05$export$7fb8daedae341012,
    faAtlas: $d8206b3ab2e65c05$export$380a9050e42fe5d7,
    faVirus: $d8206b3ab2e65c05$export$37c67e0b3dc6bd1b,
    faEnvelopeCircleCheck: $d8206b3ab2e65c05$export$74d890536dbd21b7,
    faLayerGroup: $d8206b3ab2e65c05$export$a137712e11e257dd,
    faArrowsToDot: $d8206b3ab2e65c05$export$ab3a06d4b53c0fc0,
    faArchway: $d8206b3ab2e65c05$export$d56753dd2eb5c323,
    faHeartCircleCheck: $d8206b3ab2e65c05$export$5e4b6785eedecc1a,
    faHouseChimneyCrack: $d8206b3ab2e65c05$export$e824540f5a6a8a57,
    faHouseDamage: $d8206b3ab2e65c05$export$8d7e943005ce0b49,
    faFileZipper: $d8206b3ab2e65c05$export$7a4a0e4caa1e4e6f,
    faFileArchive: $d8206b3ab2e65c05$export$bf2047a9946b5c3f,
    faSquare: $d8206b3ab2e65c05$export$90b4406457aae8cc,
    faMartiniGlassEmpty: $d8206b3ab2e65c05$export$a8a0de30198815a3,
    faGlassMartini: $d8206b3ab2e65c05$export$e96f280e39af4a91,
    faCouch: $d8206b3ab2e65c05$export$ce96e32767a7dd51,
    faCediSign: $d8206b3ab2e65c05$export$66c557f70914132c,
    faItalic: $d8206b3ab2e65c05$export$16e344bae4d495ed,
    faChurch: $d8206b3ab2e65c05$export$16a3f12c6ae9650,
    faCommentsDollar: $d8206b3ab2e65c05$export$d477129b070e5ac4,
    faDemocrat: $d8206b3ab2e65c05$export$a1672d808fbed0bd,
    faZ: $d8206b3ab2e65c05$export$3481c1aa28972f9b,
    faPersonSkiing: $d8206b3ab2e65c05$export$5ebd3cd0630e3ae7,
    faSkiing: $d8206b3ab2e65c05$export$eae1acab6fb96708,
    faRoadLock: $d8206b3ab2e65c05$export$b81a894d5bc3eb17,
    faA: $d8206b3ab2e65c05$export$406fe05808a3753e,
    faTemperatureArrowDown: $d8206b3ab2e65c05$export$4520eb1840c4e110,
    faTemperatureDown: $d8206b3ab2e65c05$export$f0b2aca3866f00f6,
    faFeatherPointed: $d8206b3ab2e65c05$export$2a9d3e120019c92d,
    faFeatherAlt: $d8206b3ab2e65c05$export$68cf766c786bcd78,
    faP: $d8206b3ab2e65c05$export$bcb419f1cd5beac3,
    faSnowflake: $d8206b3ab2e65c05$export$bab8f3647c394f48,
    faNewspaper: $d8206b3ab2e65c05$export$d91b374112d4f8c1,
    faRectangleAd: $d8206b3ab2e65c05$export$d0ccaddca9e06d1e,
    faAd: $d8206b3ab2e65c05$export$7af266c3465b1ff2,
    faCircleArrowRight: $d8206b3ab2e65c05$export$2f1e22e081a1ad05,
    faArrowCircleRight: $d8206b3ab2e65c05$export$7d3d828103aa3be7,
    faFilterCircleXmark: $d8206b3ab2e65c05$export$fb5ab619c34ea613,
    faLocust: $d8206b3ab2e65c05$export$4982360d3b844c19,
    faSort: $d8206b3ab2e65c05$export$4941c5969d5399b,
    faUnsorted: $d8206b3ab2e65c05$export$418597748f0fe52d,
    faListOl: $d8206b3ab2e65c05$export$3db8f67cd0fc963b,
    faList12: $d8206b3ab2e65c05$export$7e3d894cd55296b,
    faListNumeric: $d8206b3ab2e65c05$export$cf51408faadac277,
    faPersonDressBurst: $d8206b3ab2e65c05$export$523180e731928397,
    faMoneyCheckDollar: $d8206b3ab2e65c05$export$eeb59dd1825c6a65,
    faMoneyCheckAlt: $d8206b3ab2e65c05$export$8c6ccc9745897cb2,
    faVectorSquare: $d8206b3ab2e65c05$export$567d5631a7b0599f,
    faBreadSlice: $d8206b3ab2e65c05$export$d78e8b0681279167,
    faLanguage: $d8206b3ab2e65c05$export$8a7bee49fdf8c954,
    faFaceKissWinkHeart: $d8206b3ab2e65c05$export$611ae61f02de0aa,
    faKissWinkHeart: $d8206b3ab2e65c05$export$ebba617701dfb917,
    faFilter: $d8206b3ab2e65c05$export$f253a38d7142e29f,
    faQuestion: $d8206b3ab2e65c05$export$d96973f90e8f6e47,
    faFileSignature: $d8206b3ab2e65c05$export$d0de575ac166712b,
    faUpDownLeftRight: $d8206b3ab2e65c05$export$cd7b22f4e6e3834b,
    faArrowsAlt: $d8206b3ab2e65c05$export$3cdabfff52cfc73a,
    faHouseChimneyUser: $d8206b3ab2e65c05$export$1ddbaebce033a0d,
    faHandHoldingHeart: $d8206b3ab2e65c05$export$97e5ef3e80a0fbef,
    faPuzzlePiece: $d8206b3ab2e65c05$export$7ee0dbd1e92e2859,
    faMoneyCheck: $d8206b3ab2e65c05$export$be069f641c85d0b3,
    faStarHalfStroke: $d8206b3ab2e65c05$export$3e4892d8bf919edd,
    faStarHalfAlt: $d8206b3ab2e65c05$export$c13575f42532efb3,
    faCode: $d8206b3ab2e65c05$export$eba095993e51cc97,
    faWhiskeyGlass: $d8206b3ab2e65c05$export$f1304dd34ea2afbd,
    faGlassWhiskey: $d8206b3ab2e65c05$export$fdec0f5f1a169419,
    faBuildingCircleExclamation: $d8206b3ab2e65c05$export$c49f030b19083ebe,
    faMagnifyingGlassChart: $d8206b3ab2e65c05$export$6a1e4cdbb8ca10c5,
    faArrowUpRightFromSquare: $d8206b3ab2e65c05$export$5ad84e891223f2c3,
    faExternalLink: $d8206b3ab2e65c05$export$f4c613289034e5ef,
    faCubesStacked: $d8206b3ab2e65c05$export$b1f00c433aabac05,
    faWonSign: $d8206b3ab2e65c05$export$51790ddd26e431bc,
    faKrw: $d8206b3ab2e65c05$export$2f65e07a45b95b50,
    faWon: $d8206b3ab2e65c05$export$5a1fd3ed9564d7fa,
    faVirusCovid: $d8206b3ab2e65c05$export$1df4e031b8ee4f84,
    faAustralSign: $d8206b3ab2e65c05$export$299c200ad3db97b4,
    faF: $d8206b3ab2e65c05$export$a2f384a559654618,
    faLeaf: $d8206b3ab2e65c05$export$7c497bae2754a087,
    faRoad: $d8206b3ab2e65c05$export$f224567a4851a5e9,
    faTaxi: $d8206b3ab2e65c05$export$9958afcdfece1b58,
    faCab: $d8206b3ab2e65c05$export$7bf12d9380f0971b,
    faPersonCirclePlus: $d8206b3ab2e65c05$export$55686b1eb7d00307,
    faChartPie: $d8206b3ab2e65c05$export$1de7b9cf7d1b153b,
    faPieChart: $d8206b3ab2e65c05$export$7877286cd337de81,
    faBoltLightning: $d8206b3ab2e65c05$export$b16dcd08f3da1ba2,
    faSackXmark: $d8206b3ab2e65c05$export$2bad98c38bea5994,
    faFileExcel: $d8206b3ab2e65c05$export$77cb1a465c4fe84,
    faFileContract: $d8206b3ab2e65c05$export$70fde3f3fdaa6a6a,
    faFishFins: $d8206b3ab2e65c05$export$e7af4f0123222b6f,
    faBuildingFlag: $d8206b3ab2e65c05$export$592422b29ab0a914,
    faFaceGrinBeam: $d8206b3ab2e65c05$export$3de52eeb00462407,
    faGrinBeam: $d8206b3ab2e65c05$export$734da5249381ec7e,
    faObjectUngroup: $d8206b3ab2e65c05$export$887f6345573abcac,
    faPoop: $d8206b3ab2e65c05$export$bb45b6b87d1adf27,
    faLocationPin: $d8206b3ab2e65c05$export$c0b7617de95c0c05,
    faMapMarker: $d8206b3ab2e65c05$export$10d360e4f1a554dd,
    faKaaba: $d8206b3ab2e65c05$export$ab1408bfbe914cc9,
    faToiletPaper: $d8206b3ab2e65c05$export$c8cc083ccc72b17,
    faHelmetSafety: $d8206b3ab2e65c05$export$aacaf42fba617981,
    faHardHat: $d8206b3ab2e65c05$export$7b72177558a98b6f,
    faHatHard: $d8206b3ab2e65c05$export$c0e235dbf1644a2f,
    faEject: $d8206b3ab2e65c05$export$8484041d5b209494,
    faCircleRight: $d8206b3ab2e65c05$export$1fec48c8bdd69c1d,
    faArrowAltCircleRight: $d8206b3ab2e65c05$export$88962ffdad8b856d,
    faPlaneCircleCheck: $d8206b3ab2e65c05$export$9cbf8612c6cadc74,
    faFaceRollingEyes: $d8206b3ab2e65c05$export$a6d72a9a068392b5,
    faMehRollingEyes: $d8206b3ab2e65c05$export$fdc62a1bea767cc2,
    faObjectGroup: $d8206b3ab2e65c05$export$40cdac24aa94a57a,
    faChartLine: $d8206b3ab2e65c05$export$e022f62a119e1d93,
    faLineChart: $d8206b3ab2e65c05$export$f729617a20de475b,
    faMaskVentilator: $d8206b3ab2e65c05$export$122c8413a0dc5ff6,
    faArrowRight: $d8206b3ab2e65c05$export$b4da69a0247f3620,
    faSignsPost: $d8206b3ab2e65c05$export$905f45f8ffd6b8e5,
    faMapSigns: $d8206b3ab2e65c05$export$743f4b1071b3333a,
    faCashRegister: $d8206b3ab2e65c05$export$6357093f67788b33,
    faPersonCircleQuestion: $d8206b3ab2e65c05$export$c8f8a597ffd676c0,
    faH: $d8206b3ab2e65c05$export$d762b7b66d5875e1,
    faTarp: $d8206b3ab2e65c05$export$2305b1a41b3f914,
    faScrewdriverWrench: $d8206b3ab2e65c05$export$158a12f36bbecf9,
    faTools: $d8206b3ab2e65c05$export$646e4e7a8c6172aa,
    faArrowsToEye: $d8206b3ab2e65c05$export$9adae865350879af,
    faPlugCircleBolt: $d8206b3ab2e65c05$export$4f3b3144ce966486,
    faHeart: $d8206b3ab2e65c05$export$e4b51a47a2f8b9db,
    faMarsAndVenus: $d8206b3ab2e65c05$export$808b88e8735e31e8,
    faHouseUser: $d8206b3ab2e65c05$export$9a513ee921e8e885,
    faHomeUser: $d8206b3ab2e65c05$export$e732fa55ae5bbdf0,
    faDumpsterFire: $d8206b3ab2e65c05$export$25e9b29b3f2230b5,
    faHouseCrack: $d8206b3ab2e65c05$export$baa3c215534dbf2a,
    faMartiniGlassCitrus: $d8206b3ab2e65c05$export$c6e76550bdc0255d,
    faCocktail: $d8206b3ab2e65c05$export$4be708f1e41d387b,
    faFaceSurprise: $d8206b3ab2e65c05$export$c938968e28178994,
    faSurprise: $d8206b3ab2e65c05$export$46647c72213f53ba,
    faBottleWater: $d8206b3ab2e65c05$export$3ee278c67519eeeb,
    faCirclePause: $d8206b3ab2e65c05$export$fbeef2513e05ad08,
    faPauseCircle: $d8206b3ab2e65c05$export$d8cf08a0362da8db,
    faToiletPaperSlash: $d8206b3ab2e65c05$export$7a494edbf9b65575,
    faAppleWhole: $d8206b3ab2e65c05$export$12de8220d30453a3,
    faAppleAlt: $d8206b3ab2e65c05$export$bcdd94f3977a0884,
    faKitchenSet: $d8206b3ab2e65c05$export$64c1570509eaf40d,
    faR: $d8206b3ab2e65c05$export$eb4c616de6eef46f,
    faTemperatureQuarter: $d8206b3ab2e65c05$export$f9d1c19925fd7fa8,
    faTemperature1: $d8206b3ab2e65c05$export$d4f1cd380bde2129,
    faThermometer1: $d8206b3ab2e65c05$export$3f77fbe2dabe285b,
    faThermometerQuarter: $d8206b3ab2e65c05$export$ed05754fcbec6e46,
    faCube: $d8206b3ab2e65c05$export$973ae4f1e4d2ce78,
    faBitcoinSign: $d8206b3ab2e65c05$export$441bfc8058328ce8,
    faShieldDog: $d8206b3ab2e65c05$export$2a5c6f182c0cbcb,
    faSolarPanel: $d8206b3ab2e65c05$export$b9c649c5e37017f3,
    faLockOpen: $d8206b3ab2e65c05$export$84b5acad4436d02a,
    faElevator: $d8206b3ab2e65c05$export$c7a833ce065e0ea4,
    faMoneyBillTransfer: $d8206b3ab2e65c05$export$1b71392d9effbe,
    faMoneyBillTrendUp: $d8206b3ab2e65c05$export$18ab80cba7d5044f,
    faHouseFloodWaterCircleArrowRight: $d8206b3ab2e65c05$export$30d3e64480aa266b,
    faSquarePollHorizontal: $d8206b3ab2e65c05$export$287bdd70ab874659,
    faPollH: $d8206b3ab2e65c05$export$456a238f0144d430,
    faCircle: $d8206b3ab2e65c05$export$4280b2387fbdad12,
    faBackwardFast: $d8206b3ab2e65c05$export$662cbc6ed5a3c5e8,
    faFastBackward: $d8206b3ab2e65c05$export$e6246a3279a379b8,
    faRecycle: $d8206b3ab2e65c05$export$a65c441f12cb6bd,
    faUserAstronaut: $d8206b3ab2e65c05$export$94363e983c225a04,
    faPlaneSlash: $d8206b3ab2e65c05$export$cfee4df0d5df6d21,
    faTrademark: $d8206b3ab2e65c05$export$9c9b2fbddd59047d,
    faBasketball: $d8206b3ab2e65c05$export$44dee69e3a29b0e,
    faBasketballBall: $d8206b3ab2e65c05$export$36550ab8ffcc5b28,
    faSatelliteDish: $d8206b3ab2e65c05$export$219ccae0e4da3c92,
    faCircleUp: $d8206b3ab2e65c05$export$72ea8a5e4e86cd69,
    faArrowAltCircleUp: $d8206b3ab2e65c05$export$3747a8ef0995eadf,
    faMobileScreenButton: $d8206b3ab2e65c05$export$da39ed20699ee2d7,
    faMobileAlt: $d8206b3ab2e65c05$export$e9599bc6cd92234d,
    faVolumeHigh: $d8206b3ab2e65c05$export$39461921e738be65,
    faVolumeUp: $d8206b3ab2e65c05$export$5940d3e475d90cc4,
    faUsersRays: $d8206b3ab2e65c05$export$9c0b63b698611d06,
    faWallet: $d8206b3ab2e65c05$export$79204db8777905c8,
    faClipboardCheck: $d8206b3ab2e65c05$export$7babcb2c90eb609a,
    faFileAudio: $d8206b3ab2e65c05$export$b8d24c57c9e64933,
    faBurger: $d8206b3ab2e65c05$export$128a6cab12423493,
    faHamburger: $d8206b3ab2e65c05$export$bab3bb9f4f59363,
    faWrench: $d8206b3ab2e65c05$export$3c6c0c8185296ac5,
    faBugs: $d8206b3ab2e65c05$export$f5bfd1271b8b71d1,
    faRupeeSign: $d8206b3ab2e65c05$export$8bf9e3f7f57d486a,
    faRupee: $d8206b3ab2e65c05$export$9da25a46cfcb6fa4,
    faFileImage: $d8206b3ab2e65c05$export$6440b286d3cbac9b,
    faCircleQuestion: $d8206b3ab2e65c05$export$d7cf0978afd90002,
    faQuestionCircle: $d8206b3ab2e65c05$export$5ba67d7f2265c1a5,
    faPlaneDeparture: $d8206b3ab2e65c05$export$6ccbeeccfea6dc8a,
    faHandshakeSlash: $d8206b3ab2e65c05$export$2cef3f81ad90fb76,
    faBookBookmark: $d8206b3ab2e65c05$export$3d177ecdf7fc50ec,
    faCodeBranch: $d8206b3ab2e65c05$export$aa054a78ab078db3,
    faHatCowboy: $d8206b3ab2e65c05$export$37672611144b857b,
    faBridge: $d8206b3ab2e65c05$export$f402c7c97f3383f0,
    faPhoneFlip: $d8206b3ab2e65c05$export$d86c56ab43eb0deb,
    faPhoneAlt: $d8206b3ab2e65c05$export$a07a9b305deebf32,
    faTruckFront: $d8206b3ab2e65c05$export$4a5a13c01d46357c,
    faCat: $d8206b3ab2e65c05$export$ab927dada03be4b3,
    faAnchorCircleExclamation: $d8206b3ab2e65c05$export$61add9eca991b5ec,
    faTruckField: $d8206b3ab2e65c05$export$f4419f7b2e53b340,
    faRoute: $d8206b3ab2e65c05$export$806c0a45a7ecd6e8,
    faClipboardQuestion: $d8206b3ab2e65c05$export$d4aa151a4554b74e,
    faPanorama: $d8206b3ab2e65c05$export$5dd22dcb6e3ed369,
    faCommentMedical: $d8206b3ab2e65c05$export$101422b773924276,
    faTeethOpen: $d8206b3ab2e65c05$export$c88ac21fe7c88ae6,
    faFileCircleMinus: $d8206b3ab2e65c05$export$4b89fabf50a10951,
    faTags: $d8206b3ab2e65c05$export$d55778e3ab6c933f,
    faWineGlass: $d8206b3ab2e65c05$export$e06d6607d3577d6e,
    faForwardFast: $d8206b3ab2e65c05$export$dc9cc4280bee320d,
    faFastForward: $d8206b3ab2e65c05$export$61a8cdc53c2e078d,
    faFaceMehBlank: $d8206b3ab2e65c05$export$38c072b870a9e4ab,
    faMehBlank: $d8206b3ab2e65c05$export$e945435725f71e88,
    faSquareParking: $d8206b3ab2e65c05$export$f2cfa036d76f69ab,
    faParking: $d8206b3ab2e65c05$export$fda29c8f99573a4e,
    faHouseSignal: $d8206b3ab2e65c05$export$58845db8e7e9a199,
    faBarsProgress: $d8206b3ab2e65c05$export$ee3a02da18715b2,
    faTasksAlt: $d8206b3ab2e65c05$export$bbc0784fc1578f7f,
    faFaucetDrip: $d8206b3ab2e65c05$export$7a255960242435f6,
    faCartFlatbed: $d8206b3ab2e65c05$export$df587aaf7765e1ce,
    faDollyFlatbed: $d8206b3ab2e65c05$export$f7c6efb60c53b285,
    faBanSmoking: $d8206b3ab2e65c05$export$130df7ed74437774,
    faSmokingBan: $d8206b3ab2e65c05$export$e50452a49dec29f,
    faTerminal: $d8206b3ab2e65c05$export$5e63e8b85b5f119c,
    faMobileButton: $d8206b3ab2e65c05$export$c93d62849efbdd11,
    faHouseMedicalFlag: $d8206b3ab2e65c05$export$86c50f517be57a40,
    faBasketShopping: $d8206b3ab2e65c05$export$1d307c13b511e8e1,
    faShoppingBasket: $d8206b3ab2e65c05$export$ca6d443595a6578f,
    faTape: $d8206b3ab2e65c05$export$b88ed5e1e0eac4c6,
    faBusSimple: $d8206b3ab2e65c05$export$d3724faf0c559353,
    faBusAlt: $d8206b3ab2e65c05$export$40616edfab6d332a,
    faEye: $d8206b3ab2e65c05$export$b8c3e79e8c99c95b,
    faFaceSadCry: $d8206b3ab2e65c05$export$e8ea88c55e55be7c,
    faSadCry: $d8206b3ab2e65c05$export$8e924e6bd422cef9,
    faAudioDescription: $d8206b3ab2e65c05$export$b6b464c98c009494,
    faPersonMilitaryToPerson: $d8206b3ab2e65c05$export$41b1e14a6b0fe11b,
    faFileShield: $d8206b3ab2e65c05$export$348a01df65a66c99,
    faUserSlash: $d8206b3ab2e65c05$export$3924ab4d3ef9b5ef,
    faPen: $d8206b3ab2e65c05$export$8f4567331fb0d3bc,
    faTowerObservation: $d8206b3ab2e65c05$export$5b2f0f631f559d51,
    faFileCode: $d8206b3ab2e65c05$export$143d0ca7d2200f20,
    faSignal: $d8206b3ab2e65c05$export$79046b073b6c584d,
    faSignal5: $d8206b3ab2e65c05$export$3417071118065933,
    faSignalPerfect: $d8206b3ab2e65c05$export$1aea50ab3e99cc95,
    faBus: $d8206b3ab2e65c05$export$ce69441578ff2fdb,
    faHeartCircleXmark: $d8206b3ab2e65c05$export$742f89ae2f8d6b20,
    faHouseChimney: $d8206b3ab2e65c05$export$af554427144a7e5c,
    faHomeLg: $d8206b3ab2e65c05$export$dbab81727ec94698,
    faWindowMaximize: $d8206b3ab2e65c05$export$703cd98be31ec905,
    faFaceFrown: $d8206b3ab2e65c05$export$e5f78e87efbb0248,
    faFrown: $d8206b3ab2e65c05$export$43b7108508aecc5f,
    faPrescription: $d8206b3ab2e65c05$export$8767bafb19515ee4,
    faShop: $d8206b3ab2e65c05$export$78edc9b98453b6f7,
    faStoreAlt: $d8206b3ab2e65c05$export$1f1871dab9cec9d8,
    faFloppyDisk: $d8206b3ab2e65c05$export$f62f2879ccaea13f,
    faSave: $d8206b3ab2e65c05$export$1aaa83ff70706e1e,
    faVihara: $d8206b3ab2e65c05$export$ee4b92e89fe0dfaf,
    faScaleUnbalanced: $d8206b3ab2e65c05$export$4d10bcc8d068f454,
    faBalanceScaleLeft: $d8206b3ab2e65c05$export$786cb0c775487f19,
    faSortUp: $d8206b3ab2e65c05$export$f9dd5b1410e95035,
    faSortAsc: $d8206b3ab2e65c05$export$e4c8c924b1cc43a7,
    faCommentDots: $d8206b3ab2e65c05$export$63ffcb3d4e94cb92,
    faCommenting: $d8206b3ab2e65c05$export$49ee382a2425e89c,
    faPlantWilt: $d8206b3ab2e65c05$export$77a38850ff8b0407,
    faDiamond: $d8206b3ab2e65c05$export$f214f827e0023247,
    faFaceGrinSquint: $d8206b3ab2e65c05$export$5d53da7627754bc6,
    faGrinSquint: $d8206b3ab2e65c05$export$243ae757907b1580,
    faHandHoldingDollar: $d8206b3ab2e65c05$export$61a67f5f8ab39be,
    faHandHoldingUsd: $d8206b3ab2e65c05$export$47d27bc305b59690,
    faBacterium: $d8206b3ab2e65c05$export$b0babe4230e35ebe,
    faHandPointer: $d8206b3ab2e65c05$export$d97ff927c450c87f,
    faDrumSteelpan: $d8206b3ab2e65c05$export$48d1206500db2e9d,
    faHandScissors: $d8206b3ab2e65c05$export$c578e919f2c5c135,
    faHandsPraying: $d8206b3ab2e65c05$export$a96374faedb12593,
    faPrayingHands: $d8206b3ab2e65c05$export$95e08e91b0929943,
    faArrowRotateRight: $d8206b3ab2e65c05$export$9c58ddc4b3356f98,
    faArrowRightRotate: $d8206b3ab2e65c05$export$ffa1245982c1b28b,
    faArrowRotateForward: $d8206b3ab2e65c05$export$89c59b5f47067f4c,
    faRedo: $d8206b3ab2e65c05$export$3d9f98aa1c24c776,
    faBiohazard: $d8206b3ab2e65c05$export$ae3a453550dec95,
    faLocationCrosshairs: $d8206b3ab2e65c05$export$14e1096ad1719098,
    faLocation: $d8206b3ab2e65c05$export$45e012c32174eb5d,
    faMarsDouble: $d8206b3ab2e65c05$export$2f8a28204bb4b86f,
    faChildDress: $d8206b3ab2e65c05$export$f31a37ecbfd4e707,
    faUsersBetweenLines: $d8206b3ab2e65c05$export$6ea1decf8bb3513d,
    faLungsVirus: $d8206b3ab2e65c05$export$895159d10626af74,
    faFaceGrinTears: $d8206b3ab2e65c05$export$8ac6d81a3d5b40a1,
    faGrinTears: $d8206b3ab2e65c05$export$b2f7512221512b5b,
    faPhone: $d8206b3ab2e65c05$export$ddab067855cf34cb,
    faCalendarXmark: $d8206b3ab2e65c05$export$3c70ffe5660af060,
    faCalendarTimes: $d8206b3ab2e65c05$export$99b20d7352fbcf08,
    faChildReaching: $d8206b3ab2e65c05$export$84a2f9476730c40e,
    faHeadSideVirus: $d8206b3ab2e65c05$export$5b64b916710da7c7,
    faUserGear: $d8206b3ab2e65c05$export$f504a6909b677146,
    faUserCog: $d8206b3ab2e65c05$export$474108c2b86e730e,
    faArrowUp19: $d8206b3ab2e65c05$export$bbbff45e04f4abab,
    faSortNumericUp: $d8206b3ab2e65c05$export$d213a3ba3cabed48,
    faDoorClosed: $d8206b3ab2e65c05$export$2c79e1a422528bba,
    faShieldVirus: $d8206b3ab2e65c05$export$bea811bbf570f05a,
    faDiceSix: $d8206b3ab2e65c05$export$3397c7b4679acccc,
    faMosquitoNet: $d8206b3ab2e65c05$export$f3858ce1b3218e2,
    faBridgeWater: $d8206b3ab2e65c05$export$154e99cb34841765,
    faPersonBooth: $d8206b3ab2e65c05$export$2337c975289bdd84,
    faTextWidth: $d8206b3ab2e65c05$export$d8724cf433389700,
    faHatWizard: $d8206b3ab2e65c05$export$7daa48199dcb2ad1,
    faPenFancy: $d8206b3ab2e65c05$export$8bdfe14ac72a8b17,
    faPersonDigging: $d8206b3ab2e65c05$export$f4d483fca19a4604,
    faDigging: $d8206b3ab2e65c05$export$7bd93e3343bd5671,
    faTrash: $d8206b3ab2e65c05$export$ed8c149a0ea54bb4,
    faGaugeSimple: $d8206b3ab2e65c05$export$f3a0a4e6723a86d4,
    faGaugeSimpleMed: $d8206b3ab2e65c05$export$ba8c12ff7cfa2521,
    faTachometerAverage: $d8206b3ab2e65c05$export$94fcfd6f6335431b,
    faBookMedical: $d8206b3ab2e65c05$export$6feb44fec53ba30d,
    faPoo: $d8206b3ab2e65c05$export$dd0ede1713d2d2f9,
    faQuoteRight: $d8206b3ab2e65c05$export$54e3a80c9875b74c,
    faQuoteRightAlt: $d8206b3ab2e65c05$export$dd692f2e88bd4b1a,
    faShirt: $d8206b3ab2e65c05$export$312f2c01c6fedca8,
    faTShirt: $d8206b3ab2e65c05$export$144e5f8bc4d705a6,
    faTshirt: $d8206b3ab2e65c05$export$36edce3ba87c2b17,
    faCubes: $d8206b3ab2e65c05$export$30523a9441a31e97,
    faDivide: $d8206b3ab2e65c05$export$89fa217ec5503ac9,
    faTengeSign: $d8206b3ab2e65c05$export$c04e864469c1d117,
    faTenge: $d8206b3ab2e65c05$export$af6ebee83047b793,
    faHeadphones: $d8206b3ab2e65c05$export$ad02dd8ca5816958,
    faHandsHolding: $d8206b3ab2e65c05$export$96891bbcda1dbb7b,
    faHandsClapping: $d8206b3ab2e65c05$export$765c446e974b5e59,
    faRepublican: $d8206b3ab2e65c05$export$929518bb4b66a588,
    faArrowLeft: $d8206b3ab2e65c05$export$b7fac681e7d09400,
    faPersonCircleXmark: $d8206b3ab2e65c05$export$16c9e0374c346c6e,
    faRuler: $d8206b3ab2e65c05$export$8e90575265a56cfc,
    faAlignLeft: $d8206b3ab2e65c05$export$e490f662af4d1c78,
    faDiceD6: $d8206b3ab2e65c05$export$64bfd48ed353c031,
    faRestroom: $d8206b3ab2e65c05$export$5fbcef35138741a5,
    faJ: $d8206b3ab2e65c05$export$bbf24078bd1f73e6,
    faUsersViewfinder: $d8206b3ab2e65c05$export$72b785dcfe44c69b,
    faFileVideo: $d8206b3ab2e65c05$export$b44eb38345c6a964,
    faUpRightFromSquare: $d8206b3ab2e65c05$export$c1a3ba061b4f60c4,
    faExternalLinkAlt: $d8206b3ab2e65c05$export$d7f107e456ab0306,
    faTableCells: $d8206b3ab2e65c05$export$c517dffc18db483f,
    faTh: $d8206b3ab2e65c05$export$4d383c83efc0c819,
    faFilePdf: $d8206b3ab2e65c05$export$38611f1c776aba73,
    faBookBible: $d8206b3ab2e65c05$export$df8194b081d34b27,
    faBible: $d8206b3ab2e65c05$export$2eac809b0670d139,
    faO: $d8206b3ab2e65c05$export$9db87eabf605857e,
    faSuitcaseMedical: $d8206b3ab2e65c05$export$25ea11267429d202,
    faMedkit: $d8206b3ab2e65c05$export$e75f02bae5b7d34b,
    faUserSecret: $d8206b3ab2e65c05$export$597826232327559b,
    faOtter: $d8206b3ab2e65c05$export$743cce3ca4eb1d7d,
    faPersonDress: $d8206b3ab2e65c05$export$27f7383b96c3f4b4,
    faFemale: $d8206b3ab2e65c05$export$70e8e75e61dd7169,
    faCommentDollar: $d8206b3ab2e65c05$export$7a088030853df12c,
    faBusinessTime: $d8206b3ab2e65c05$export$694b7e88782dec12,
    faBriefcaseClock: $d8206b3ab2e65c05$export$8b00ae94743552ce,
    faTableCellsLarge: $d8206b3ab2e65c05$export$d2bcaf492dfb3817,
    faThLarge: $d8206b3ab2e65c05$export$69782f333e90cdc6,
    faBookTanakh: $d8206b3ab2e65c05$export$24c764717169f536,
    faTanakh: $d8206b3ab2e65c05$export$7fd4a58929315448,
    faPhoneVolume: $d8206b3ab2e65c05$export$c377f240bb8b5d74,
    faVolumeControlPhone: $d8206b3ab2e65c05$export$5358d004fa3d3be2,
    faHatCowboySide: $d8206b3ab2e65c05$export$ab6f71fd6878da90,
    faClipboardUser: $d8206b3ab2e65c05$export$1204f2d171424659,
    faChild: $d8206b3ab2e65c05$export$60b41e3581d1739a,
    faLiraSign: $d8206b3ab2e65c05$export$f0f37dbc60110b10,
    faSatellite: $d8206b3ab2e65c05$export$da3f1730d013e224,
    faPlaneLock: $d8206b3ab2e65c05$export$1125ac57be52258c,
    faTag: $d8206b3ab2e65c05$export$cb61f447f29887e,
    faComment: $d8206b3ab2e65c05$export$805cd88398a70581,
    faCakeCandles: $d8206b3ab2e65c05$export$e4019fe302a972e1,
    faBirthdayCake: $d8206b3ab2e65c05$export$bdcf98f725a7241a,
    faCake: $d8206b3ab2e65c05$export$707bc1c80c0177c1,
    faEnvelope: $d8206b3ab2e65c05$export$6f095630677adc,
    faAnglesUp: $d8206b3ab2e65c05$export$152ef92a4f9d80a7,
    faAngleDoubleUp: $d8206b3ab2e65c05$export$9bb51e1a2c07db7c,
    faPaperclip: $d8206b3ab2e65c05$export$4b24ca1552f410af,
    faArrowRightToCity: $d8206b3ab2e65c05$export$e201217e5046cd15,
    faRibbon: $d8206b3ab2e65c05$export$838459d11f3971df,
    faLungs: $d8206b3ab2e65c05$export$ba9b387e84727819,
    faArrowUp91: $d8206b3ab2e65c05$export$25218e5886296cb9,
    faSortNumericUpAlt: $d8206b3ab2e65c05$export$d41859f1bbb9e086,
    faLitecoinSign: $d8206b3ab2e65c05$export$4a157bd81dcd8d80,
    faBorderNone: $d8206b3ab2e65c05$export$2b488402ec335d97,
    faCircleNodes: $d8206b3ab2e65c05$export$de462dd5a18e80d4,
    faParachuteBox: $d8206b3ab2e65c05$export$ca9e3368f1d9500a,
    faIndent: $d8206b3ab2e65c05$export$318208bc30aeebcc,
    faTruckFieldUn: $d8206b3ab2e65c05$export$40cb0a4a3a74dc03,
    faHourglass: $d8206b3ab2e65c05$export$b9098a890f61e022,
    faHourglassEmpty: $d8206b3ab2e65c05$export$a2f8176a0161e891,
    faMountain: $d8206b3ab2e65c05$export$64f9eb99c9749cce,
    faUserDoctor: $d8206b3ab2e65c05$export$9884bf227eeb829,
    faUserMd: $d8206b3ab2e65c05$export$ab0d33a2c03f1794,
    faCircleInfo: $d8206b3ab2e65c05$export$317f99f46b39906e,
    faInfoCircle: $d8206b3ab2e65c05$export$aa9288aeadf882fa,
    faCloudMeatball: $d8206b3ab2e65c05$export$5d120e8b87ad33f4,
    faCamera: $d8206b3ab2e65c05$export$84ffbd7161ca2008,
    faCameraAlt: $d8206b3ab2e65c05$export$8872b5664e88e793,
    faSquareVirus: $d8206b3ab2e65c05$export$f9409a7b020dbec4,
    faMeteor: $d8206b3ab2e65c05$export$1439f0d6365138da,
    faCarOn: $d8206b3ab2e65c05$export$d901d50df5cf8d91,
    faSleigh: $d8206b3ab2e65c05$export$26a8fd1143d2d6c0,
    faArrowDown19: $d8206b3ab2e65c05$export$9a40d582bd4628fb,
    faSortNumericAsc: $d8206b3ab2e65c05$export$a4fb1aa2cdfb18d7,
    faSortNumericDown: $d8206b3ab2e65c05$export$835db7eb35b3c29b,
    faHandHoldingDroplet: $d8206b3ab2e65c05$export$b9c3f9a906f96b82,
    faHandHoldingWater: $d8206b3ab2e65c05$export$4265371b99d38b95,
    faWater: $d8206b3ab2e65c05$export$efaeddad0a6e901b,
    faCalendarCheck: $d8206b3ab2e65c05$export$5655108e1162ba45,
    faBraille: $d8206b3ab2e65c05$export$983e9c27cac7ed1c,
    faPrescriptionBottleMedical: $d8206b3ab2e65c05$export$99cfe064ff0b71c9,
    faPrescriptionBottleAlt: $d8206b3ab2e65c05$export$65d1c884b8581d1a,
    faLandmark: $d8206b3ab2e65c05$export$2bebc54c51db6505,
    faTruck: $d8206b3ab2e65c05$export$d7895f386f8bd8b8,
    faCrosshairs: $d8206b3ab2e65c05$export$721c101130c40043,
    faPersonCane: $d8206b3ab2e65c05$export$c48422e9da776c1b,
    faTent: $d8206b3ab2e65c05$export$e5075400db564e24,
    faVestPatches: $d8206b3ab2e65c05$export$750a64470c2e0f3f,
    faCheckDouble: $d8206b3ab2e65c05$export$f178c8c2ad3cc861,
    faArrowDownAZ: $d8206b3ab2e65c05$export$43b642fac7053978,
    faSortAlphaAsc: $d8206b3ab2e65c05$export$cb87697f2fa77cfc,
    faSortAlphaDown: $d8206b3ab2e65c05$export$7658045270aafde3,
    faMoneyBillWheat: $d8206b3ab2e65c05$export$6a4ef2ef77625063,
    faCookie: $d8206b3ab2e65c05$export$b3e64f5f68c6623f,
    faArrowRotateLeft: $d8206b3ab2e65c05$export$89b706873769c180,
    faArrowLeftRotate: $d8206b3ab2e65c05$export$1aea864c3e1d79b,
    faArrowRotateBack: $d8206b3ab2e65c05$export$a34701878babe5fc,
    faArrowRotateBackward: $d8206b3ab2e65c05$export$fce381d12e4535cd,
    faUndo: $d8206b3ab2e65c05$export$a5e5ba60b1dfe2b2,
    faHardDrive: $d8206b3ab2e65c05$export$4cb736b866cbb7ec,
    faHdd: $d8206b3ab2e65c05$export$62551e9c5ba7093f,
    faFaceGrinSquintTears: $d8206b3ab2e65c05$export$8ff56f5ebb8416a0,
    faGrinSquintTears: $d8206b3ab2e65c05$export$542206d6a85f3b42,
    faDumbbell: $d8206b3ab2e65c05$export$56700074cf37be5c,
    faRectangleList: $d8206b3ab2e65c05$export$1f7600fa9fdb3978,
    faListAlt: $d8206b3ab2e65c05$export$c6327a203ffc65a3,
    faTarpDroplet: $d8206b3ab2e65c05$export$1585b7c3c7109751,
    faHouseMedicalCircleCheck: $d8206b3ab2e65c05$export$5d08d08f88a96aac,
    faPersonSkiingNordic: $d8206b3ab2e65c05$export$c8cd1786449517d3,
    faSkiingNordic: $d8206b3ab2e65c05$export$6ea48260d7d09b1b,
    faCalendarPlus: $d8206b3ab2e65c05$export$16768a660ae3ca9d,
    faPlaneArrival: $d8206b3ab2e65c05$export$9b2dbe133273f284,
    faCircleLeft: $d8206b3ab2e65c05$export$5ae86b9da9cca3bd,
    faArrowAltCircleLeft: $d8206b3ab2e65c05$export$5460a5b11a24996f,
    faTrainSubway: $d8206b3ab2e65c05$export$cda326cc3bce41c,
    faSubway: $d8206b3ab2e65c05$export$4cabc8a12d4e2f9,
    faChartGantt: $d8206b3ab2e65c05$export$dce43b02b3fe0c18,
    faIndianRupeeSign: $d8206b3ab2e65c05$export$1d2b135cc5a2c852,
    faIndianRupee: $d8206b3ab2e65c05$export$be886a4def17c565,
    faInr: $d8206b3ab2e65c05$export$12c6d8b3e052490b,
    faCropSimple: $d8206b3ab2e65c05$export$c3605731beb92daf,
    faCropAlt: $d8206b3ab2e65c05$export$d932915fde4f1010,
    faMoneyBill1: $d8206b3ab2e65c05$export$a312c7d58dd44a75,
    faMoneyBillAlt: $d8206b3ab2e65c05$export$a35d573395884c3d,
    faLeftLong: $d8206b3ab2e65c05$export$1db7e2ee10d36035,
    faLongArrowAltLeft: $d8206b3ab2e65c05$export$a8b3226b2bf323d,
    faDna: $d8206b3ab2e65c05$export$c062100d54a2da00,
    faVirusSlash: $d8206b3ab2e65c05$export$c4ff5306c5470939,
    faMinus: $d8206b3ab2e65c05$export$fee0376c250cdef,
    faSubtract: $d8206b3ab2e65c05$export$f8cb2531ef1fc4a2,
    faChess: $d8206b3ab2e65c05$export$442fddbbd741c590,
    faArrowLeftLong: $d8206b3ab2e65c05$export$6e5225f0e6c0bacd,
    faLongArrowLeft: $d8206b3ab2e65c05$export$80896efc906118b4,
    faPlugCircleCheck: $d8206b3ab2e65c05$export$2bd45e99b9afa947,
    faStreetView: $d8206b3ab2e65c05$export$6aab6c3359c2554c,
    faFrancSign: $d8206b3ab2e65c05$export$acef3e5c2029d285,
    faVolumeOff: $d8206b3ab2e65c05$export$d94ba52e980ea0f1,
    faHandsAslInterpreting: $d8206b3ab2e65c05$export$bc43eb4655c78f49,
    faAmericanSignLanguageInterpreting: $d8206b3ab2e65c05$export$23a7517099ab1b86,
    faAslInterpreting: $d8206b3ab2e65c05$export$beb51abfb05a4eca,
    faHandsAmericanSignLanguageInterpreting: $d8206b3ab2e65c05$export$82846008645b0301,
    faGear: $d8206b3ab2e65c05$export$ec05accb7226d001,
    faCog: $d8206b3ab2e65c05$export$d6298bbfd1912a78,
    faDropletSlash: $d8206b3ab2e65c05$export$1d6c5a49025d720b,
    faTintSlash: $d8206b3ab2e65c05$export$5d6f0943039b898f,
    faMosque: $d8206b3ab2e65c05$export$4999586d7e1087fb,
    faMosquito: $d8206b3ab2e65c05$export$67c7a1518d0715ff,
    faStarOfDavid: $d8206b3ab2e65c05$export$f823fee3712b2601,
    faPersonMilitaryRifle: $d8206b3ab2e65c05$export$842b988dae95ccb8,
    faCartShopping: $d8206b3ab2e65c05$export$c790b41dc166ae13,
    faShoppingCart: $d8206b3ab2e65c05$export$51da406e5aa1388c,
    faVials: $d8206b3ab2e65c05$export$507e8edd7676b2e9,
    faPlugCirclePlus: $d8206b3ab2e65c05$export$f193138a7d21971c,
    faPlaceOfWorship: $d8206b3ab2e65c05$export$c5a9302c8c13c79a,
    faGripVertical: $d8206b3ab2e65c05$export$cacbd95c283996ec,
    faArrowTurnUp: $d8206b3ab2e65c05$export$2d3ccb9b2099f3fe,
    faLevelUp: $d8206b3ab2e65c05$export$c227d3ba1de97ceb,
    faU: $d8206b3ab2e65c05$export$4f39e8dbaf09ea8b,
    faSquareRootVariable: $d8206b3ab2e65c05$export$60b44cfa7af18422,
    faSquareRootAlt: $d8206b3ab2e65c05$export$28e4b96627e00057,
    faClock: $d8206b3ab2e65c05$export$95b9968e7fceb821,
    faClockFour: $d8206b3ab2e65c05$export$9a575facf1cab48f,
    faBackwardStep: $d8206b3ab2e65c05$export$5d2b6a700940df16,
    faStepBackward: $d8206b3ab2e65c05$export$2884e379aed297d4,
    faPallet: $d8206b3ab2e65c05$export$d7ff2047dbc34562,
    faFaucet: $d8206b3ab2e65c05$export$a0856b225f3b0614,
    faBaseballBatBall: $d8206b3ab2e65c05$export$59669f486ab41d86,
    faS: $d8206b3ab2e65c05$export$cb39585371b75720,
    faTimeline: $d8206b3ab2e65c05$export$5e239d90ef904a84,
    faKeyboard: $d8206b3ab2e65c05$export$fb61df5d98785fa8,
    faCaretDown: $d8206b3ab2e65c05$export$f9395ef707603e40,
    faHouseChimneyMedical: $d8206b3ab2e65c05$export$9c73560282dceccd,
    faClinicMedical: $d8206b3ab2e65c05$export$20d8a680febc7434,
    faTemperatureThreeQuarters: $d8206b3ab2e65c05$export$7ed2bad15ae6237f,
    faTemperature3: $d8206b3ab2e65c05$export$89def3268ed9b4bc,
    faThermometer3: $d8206b3ab2e65c05$export$2f653125f4e6463,
    faThermometerThreeQuarters: $d8206b3ab2e65c05$export$6c632d1dc30d4a77,
    faMobileScreen: $d8206b3ab2e65c05$export$8867e7da34bb8bf4,
    faMobileAndroidAlt: $d8206b3ab2e65c05$export$cb39d7b468ba5838,
    faPlaneUp: $d8206b3ab2e65c05$export$a5f2976a01fdc970,
    faPiggyBank: $d8206b3ab2e65c05$export$46d49a6734c4872a,
    faBatteryHalf: $d8206b3ab2e65c05$export$e6dadc1155c4ee48,
    faBattery3: $d8206b3ab2e65c05$export$f9138caac2aedaed,
    faMountainCity: $d8206b3ab2e65c05$export$28f06bbf9c17c3af,
    faCoins: $d8206b3ab2e65c05$export$bc5da164799a0e,
    faKhanda: $d8206b3ab2e65c05$export$8d41d1f1ba3f9217,
    faSliders: $d8206b3ab2e65c05$export$ea6970ed5a15feb6,
    faSlidersH: $d8206b3ab2e65c05$export$94d4dcb523f95563,
    faFolderTree: $d8206b3ab2e65c05$export$54d16fa2e445d3fe,
    faNetworkWired: $d8206b3ab2e65c05$export$882cabd11f4943b8,
    faMapPin: $d8206b3ab2e65c05$export$184725965b3402dc,
    faHamsa: $d8206b3ab2e65c05$export$38d20d399463edf9,
    faCentSign: $d8206b3ab2e65c05$export$875b6c94a4b00ea8,
    faFlask: $d8206b3ab2e65c05$export$f9b579ba06048af,
    faPersonPregnant: $d8206b3ab2e65c05$export$e7b4c26b5857fe9c,
    faWandSparkles: $d8206b3ab2e65c05$export$76cc39f249b6864e,
    faEllipsisVertical: $d8206b3ab2e65c05$export$7480721bf113be3e,
    faEllipsisV: $d8206b3ab2e65c05$export$e58494c7fcb5380,
    faTicket: $d8206b3ab2e65c05$export$3604f15924cf0b98,
    faPowerOff: $d8206b3ab2e65c05$export$a1cca9928dcf9798,
    faRightLong: $d8206b3ab2e65c05$export$b356b1dbe7d7f736,
    faLongArrowAltRight: $d8206b3ab2e65c05$export$533e1f578f74c066,
    faFlagUsa: $d8206b3ab2e65c05$export$19357abad396e723,
    faLaptopFile: $d8206b3ab2e65c05$export$e1046cf83da9b7ef,
    faTty: $d8206b3ab2e65c05$export$7c85aba0f9624b29,
    faTeletype: $d8206b3ab2e65c05$export$14bcd5c43dc736f9,
    faDiagramNext: $d8206b3ab2e65c05$export$2faddf1690e14e11,
    faPersonRifle: $d8206b3ab2e65c05$export$b16df914812cedbe,
    faHouseMedicalCircleExclamation: $d8206b3ab2e65c05$export$bc50edea6e121df5,
    faClosedCaptioning: $d8206b3ab2e65c05$export$8e047801a8603af7,
    faPersonHiking: $d8206b3ab2e65c05$export$baf9f153991b2ea,
    faHiking: $d8206b3ab2e65c05$export$b2ab0105a901499e,
    faVenusDouble: $d8206b3ab2e65c05$export$6a6f9cba7a1e5fe4,
    faImages: $d8206b3ab2e65c05$export$74f06b41ed2ca28a,
    faCalculator: $d8206b3ab2e65c05$export$693bd40950ed2c3a,
    faPeoplePulling: $d8206b3ab2e65c05$export$dace56f632fecf6f,
    faN: $d8206b3ab2e65c05$export$328a9baf0f9e3405,
    faCableCar: $d8206b3ab2e65c05$export$85cb04eaefaf2d8b,
    faTram: $d8206b3ab2e65c05$export$a7a36674c079f293,
    faCloudRain: $d8206b3ab2e65c05$export$a6c308ee087b4ded,
    faBuildingCircleXmark: $d8206b3ab2e65c05$export$c4c015418a1f24df,
    faShip: $d8206b3ab2e65c05$export$6c645741140616af,
    faArrowsDownToLine: $d8206b3ab2e65c05$export$8f2463c7b2fc6ae4,
    faDownload: $d8206b3ab2e65c05$export$8f734e51d72ca13a,
    faFaceGrin: $d8206b3ab2e65c05$export$92292137ef3cf4c8,
    faGrin: $d8206b3ab2e65c05$export$37e1f10b6de76621,
    faDeleteLeft: $d8206b3ab2e65c05$export$bbcc9e0b6022772b,
    faBackspace: $d8206b3ab2e65c05$export$e43e3f67102fc526,
    faEyeDropper: $d8206b3ab2e65c05$export$1bc3e0ad56dc9eb0,
    faEyeDropperEmpty: $d8206b3ab2e65c05$export$ef304e9b7524c1f9,
    faEyedropper: $d8206b3ab2e65c05$export$91549a375c0b6d25,
    faFileCircleCheck: $d8206b3ab2e65c05$export$8547e9f3a2ddab5b,
    faForward: $d8206b3ab2e65c05$export$a8710cdb23198d53,
    faMobile: $d8206b3ab2e65c05$export$59edacfad04cd121,
    faMobileAndroid: $d8206b3ab2e65c05$export$82f602311a698c32,
    faMobilePhone: $d8206b3ab2e65c05$export$475a9be8da747e57,
    faFaceMeh: $d8206b3ab2e65c05$export$dc130582748497c6,
    faMeh: $d8206b3ab2e65c05$export$6d2db489aaeeecd2,
    faAlignCenter: $d8206b3ab2e65c05$export$70e29dd05344623e,
    faBookSkull: $d8206b3ab2e65c05$export$a57d448e8969ce8a,
    faBookDead: $d8206b3ab2e65c05$export$b98a3f8c3941a74a,
    faIdCard: $d8206b3ab2e65c05$export$782ac893fc22249b,
    faDriversLicense: $d8206b3ab2e65c05$export$8359c70e609eff64,
    faOutdent: $d8206b3ab2e65c05$export$e21cfc4f23776bff,
    faDedent: $d8206b3ab2e65c05$export$cbffb369d9299db7,
    faHeartCircleExclamation: $d8206b3ab2e65c05$export$3772719b170306e2,
    faHouse: $d8206b3ab2e65c05$export$dcadc0d67468dfa8,
    faHome: $d8206b3ab2e65c05$export$48f10d71ec526479,
    faHomeAlt: $d8206b3ab2e65c05$export$279659c4b23dbedb,
    faHomeLgAlt: $d8206b3ab2e65c05$export$20d6d52d45f53262,
    faCalendarWeek: $d8206b3ab2e65c05$export$39be5cb4aed5a521,
    faLaptopMedical: $d8206b3ab2e65c05$export$ba2fa38f7bcc6930,
    faB: $d8206b3ab2e65c05$export$fa30fcd1e0d0d8,
    faFileMedical: $d8206b3ab2e65c05$export$56cbcd962389b090,
    faDiceOne: $d8206b3ab2e65c05$export$d91800b7be5303b0,
    faKiwiBird: $d8206b3ab2e65c05$export$d9933d91e1314d02,
    faArrowRightArrowLeft: $d8206b3ab2e65c05$export$56b6d3d7d0e67a1c,
    faExchange: $d8206b3ab2e65c05$export$1aab915ca61b734a,
    faRotateRight: $d8206b3ab2e65c05$export$7f465bf410c6eff7,
    faRedoAlt: $d8206b3ab2e65c05$export$50c037520c6cfdc1,
    faRotateForward: $d8206b3ab2e65c05$export$2507849a0fdd7f64,
    faUtensils: $d8206b3ab2e65c05$export$750d52edc1dafc7,
    faCutlery: $d8206b3ab2e65c05$export$7034e54a8036c5c8,
    faArrowUpWideShort: $d8206b3ab2e65c05$export$63f4908401ded049,
    faSortAmountUp: $d8206b3ab2e65c05$export$28ef3e933e4b5364,
    faMillSign: $d8206b3ab2e65c05$export$9b53510cf4010e4d,
    faBowlRice: $d8206b3ab2e65c05$export$86079bc65a716451,
    faSkull: $d8206b3ab2e65c05$export$138b45e2afb1dfa4,
    faTowerBroadcast: $d8206b3ab2e65c05$export$fd06ff4ce9799eb0,
    faBroadcastTower: $d8206b3ab2e65c05$export$f68b38d51f5c0ed,
    faTruckPickup: $d8206b3ab2e65c05$export$f846b848b3ba3064,
    faUpLong: $d8206b3ab2e65c05$export$5608156cc81126e7,
    faLongArrowAltUp: $d8206b3ab2e65c05$export$43c8f2a46326c55f,
    faStop: $d8206b3ab2e65c05$export$51577929c676143b,
    faCodeMerge: $d8206b3ab2e65c05$export$e151fe5abf6db993,
    faUpload: $d8206b3ab2e65c05$export$a9578350255b2b79,
    faHurricane: $d8206b3ab2e65c05$export$4cf54a379be7e59a,
    faMound: $d8206b3ab2e65c05$export$ac54ffffdb218383,
    faToiletPortable: $d8206b3ab2e65c05$export$a3a5de5f6e2513ba,
    faCompactDisc: $d8206b3ab2e65c05$export$84021631df0f831b,
    faFileArrowDown: $d8206b3ab2e65c05$export$148bcede94488555,
    faFileDownload: $d8206b3ab2e65c05$export$1013b9966d758343,
    faCaravan: $d8206b3ab2e65c05$export$afb5d0eee7c1bdb,
    faShieldCat: $d8206b3ab2e65c05$export$1639f087457d4f58,
    faBolt: $d8206b3ab2e65c05$export$6869964aa308dd31,
    faZap: $d8206b3ab2e65c05$export$d62abb82664f55ca,
    faGlassWater: $d8206b3ab2e65c05$export$b80f542550a05ea7,
    faOilWell: $d8206b3ab2e65c05$export$b69c6757012a2267,
    faVault: $d8206b3ab2e65c05$export$4689a147513594a7,
    faMars: $d8206b3ab2e65c05$export$a9f5c0b9c1e77a6f,
    faToilet: $d8206b3ab2e65c05$export$505476859b9691c0,
    faPlaneCircleXmark: $d8206b3ab2e65c05$export$94ef668f5108e431,
    faYenSign: $d8206b3ab2e65c05$export$30f1437f5a4e991d,
    faCny: $d8206b3ab2e65c05$export$268a23eee8f089a2,
    faJpy: $d8206b3ab2e65c05$export$5460a9192eb79bf5,
    faRmb: $d8206b3ab2e65c05$export$e2a8016afc962883,
    faYen: $d8206b3ab2e65c05$export$cf914b1afb9455a2,
    faRubleSign: $d8206b3ab2e65c05$export$1ae0a94c8ba4131a,
    faRouble: $d8206b3ab2e65c05$export$c5dc3d98c4d8f2a5,
    faRub: $d8206b3ab2e65c05$export$9c4d936240e1f0b1,
    faRuble: $d8206b3ab2e65c05$export$6c0cf65134387046,
    faSun: $d8206b3ab2e65c05$export$2fa35dcbc038dbe9,
    faGuitar: $d8206b3ab2e65c05$export$790dd5b32282b6fb,
    faFaceLaughWink: $d8206b3ab2e65c05$export$600a1b26b33c3d47,
    faLaughWink: $d8206b3ab2e65c05$export$77ac40095f39933e,
    faHorseHead: $d8206b3ab2e65c05$export$5bcca85203ebd1e8,
    faBoreHole: $d8206b3ab2e65c05$export$cd79eeea6201e9d4,
    faIndustry: $d8206b3ab2e65c05$export$5548c3eb51060fa8,
    faCircleDown: $d8206b3ab2e65c05$export$531badb89cf01312,
    faArrowAltCircleDown: $d8206b3ab2e65c05$export$ff3afbc8c0bc5d59,
    faArrowsTurnToDots: $d8206b3ab2e65c05$export$b9d8fdf63999a76d,
    faFlorinSign: $d8206b3ab2e65c05$export$6248ec7440b2ffcb,
    faArrowDownShortWide: $d8206b3ab2e65c05$export$a51c464b699200ae,
    faSortAmountDesc: $d8206b3ab2e65c05$export$93835bc31892b5c3,
    faSortAmountDownAlt: $d8206b3ab2e65c05$export$e7d80d8c226cb77,
    faLessThan: $d8206b3ab2e65c05$export$7f24f1bf98af5411,
    faAngleDown: $d8206b3ab2e65c05$export$4b5be0142d10f342,
    faCarTunnel: $d8206b3ab2e65c05$export$ec5cfe409de2ed37,
    faHeadSideCough: $d8206b3ab2e65c05$export$3cd04b7c1624f598,
    faGripLines: $d8206b3ab2e65c05$export$1412f35381064d7d,
    faThumbsDown: $d8206b3ab2e65c05$export$aba24ca305bbe8c1,
    faUserLock: $d8206b3ab2e65c05$export$d9b89b5872b67a4f,
    faArrowRightLong: $d8206b3ab2e65c05$export$becbc35d3541bcc,
    faLongArrowRight: $d8206b3ab2e65c05$export$7ec6527cf8651899,
    faAnchorCircleXmark: $d8206b3ab2e65c05$export$f6773af4219eebd,
    faEllipsis: $d8206b3ab2e65c05$export$37fe3659ba7b6b54,
    faEllipsisH: $d8206b3ab2e65c05$export$c9f2fedd4489a2ee,
    faChessPawn: $d8206b3ab2e65c05$export$3db75d5ac9e98468,
    faKitMedical: $d8206b3ab2e65c05$export$f04e7a0f1033a0cd,
    faFirstAid: $d8206b3ab2e65c05$export$5b01ccb2da4c4387,
    faPersonThroughWindow: $d8206b3ab2e65c05$export$a77a2f6da72f89e3,
    faToolbox: $d8206b3ab2e65c05$export$b34d64c205c732a9,
    faHandsHoldingCircle: $d8206b3ab2e65c05$export$3aa81d0e606b08b6,
    faBug: $d8206b3ab2e65c05$export$a18cfac400116d9f,
    faCreditCard: $d8206b3ab2e65c05$export$3e7437bf6535bef0,
    faCreditCardAlt: $d8206b3ab2e65c05$export$5fffe8e3c36964a2,
    faCar: $d8206b3ab2e65c05$export$9eefe7fcdf123b76,
    faAutomobile: $d8206b3ab2e65c05$export$240a6c53cf7ac525,
    faHandHoldingHand: $d8206b3ab2e65c05$export$6638511b28df3be5,
    faBookOpenReader: $d8206b3ab2e65c05$export$cb6e40528b98a5b,
    faBookReader: $d8206b3ab2e65c05$export$cee14fe33262fa7d,
    faMountainSun: $d8206b3ab2e65c05$export$af9eaee7db3ba7a9,
    faArrowsLeftRightToLine: $d8206b3ab2e65c05$export$a63cecc8a4166c49,
    faDiceD20: $d8206b3ab2e65c05$export$b06003a02c9055bd,
    faTruckDroplet: $d8206b3ab2e65c05$export$41ce20639e8fef2b,
    faFileCircleXmark: $d8206b3ab2e65c05$export$e4686afbe882e24a,
    faTemperatureArrowUp: $d8206b3ab2e65c05$export$d7a5da41ce01461d,
    faTemperatureUp: $d8206b3ab2e65c05$export$872345a0157330a3,
    faMedal: $d8206b3ab2e65c05$export$b48a5be96314835a,
    faBed: $d8206b3ab2e65c05$export$f24e0fce77994d4d,
    faSquareH: $d8206b3ab2e65c05$export$51e3c5be06a49e32,
    faHSquare: $d8206b3ab2e65c05$export$f08bbcf8f59eafc2,
    faPodcast: $d8206b3ab2e65c05$export$5c0b4709125e92f8,
    faTemperatureFull: $d8206b3ab2e65c05$export$bf4d97a79734997f,
    faTemperature4: $d8206b3ab2e65c05$export$db946f8dc50a57ca,
    faThermometer4: $d8206b3ab2e65c05$export$92b2e2293472dd50,
    faThermometerFull: $d8206b3ab2e65c05$export$74e07083cef79a6f,
    faBell: $d8206b3ab2e65c05$export$9b6162797ab1b255,
    faSuperscript: $d8206b3ab2e65c05$export$4fa56a54e822dd25,
    faPlugCircleXmark: $d8206b3ab2e65c05$export$12ef959394d63192,
    faStarOfLife: $d8206b3ab2e65c05$export$aa3c4c1c5a47bf98,
    faPhoneSlash: $d8206b3ab2e65c05$export$4c60a3aade08b6c2,
    faPaintRoller: $d8206b3ab2e65c05$export$d1de8d1b815d6a5,
    faHandshakeAngle: $d8206b3ab2e65c05$export$503f458ca5cf64c2,
    faHandsHelping: $d8206b3ab2e65c05$export$287dbb1632da0d44,
    faLocationDot: $d8206b3ab2e65c05$export$90a475e93ff4bb8a,
    faMapMarkerAlt: $d8206b3ab2e65c05$export$4be92fa780613f93,
    faFile: $d8206b3ab2e65c05$export$cad54bead856a678,
    faGreaterThan: $d8206b3ab2e65c05$export$da07b6bc24a496ca,
    faPersonSwimming: $d8206b3ab2e65c05$export$3fb4da6af843d39f,
    faSwimmer: $d8206b3ab2e65c05$export$67daf2e2f88c1365,
    faArrowDown: $d8206b3ab2e65c05$export$9686eff8d817f770,
    faDroplet: $d8206b3ab2e65c05$export$cc1b6e60cb98fb90,
    faTint: $d8206b3ab2e65c05$export$60dd975bd5938c15,
    faEraser: $d8206b3ab2e65c05$export$e7fc4fe34e767f28,
    faEarthAmericas: $d8206b3ab2e65c05$export$9c4218a898614082,
    faEarth: $d8206b3ab2e65c05$export$c2118d3775773870,
    faEarthAmerica: $d8206b3ab2e65c05$export$8b0f3a26397cf632,
    faGlobeAmericas: $d8206b3ab2e65c05$export$e96bcc7bde9498db,
    faPersonBurst: $d8206b3ab2e65c05$export$ae02241644924482,
    faDove: $d8206b3ab2e65c05$export$a1ab1e69a300089f,
    faBatteryEmpty: $d8206b3ab2e65c05$export$1344b64f6e922e12,
    faBattery0: $d8206b3ab2e65c05$export$de8d0338927394c1,
    faSocks: $d8206b3ab2e65c05$export$8d36a54dbf1e6bce,
    faInbox: $d8206b3ab2e65c05$export$366b69cbdce46334,
    faSection: $d8206b3ab2e65c05$export$a6f4f4a005d91fbd,
    faGaugeHigh: $d8206b3ab2e65c05$export$d262c1f5912046e6,
    faTachometerAlt: $d8206b3ab2e65c05$export$38dd17b9f064c10f,
    faTachometerAltFast: $d8206b3ab2e65c05$export$e99d8b85f35b8ca5,
    faEnvelopeOpenText: $d8206b3ab2e65c05$export$f5c53ce8ec380d11,
    faHospital: $d8206b3ab2e65c05$export$7a76c9d35b42d691,
    faHospitalAlt: $d8206b3ab2e65c05$export$cea7736417b94a3b,
    faHospitalWide: $d8206b3ab2e65c05$export$69c8cc0360f017e8,
    faWineBottle: $d8206b3ab2e65c05$export$770be8b3d5776043,
    faChessRook: $d8206b3ab2e65c05$export$5d65c40a109eb09c,
    faBarsStaggered: $d8206b3ab2e65c05$export$2f8a7938c06a2142,
    faReorder: $d8206b3ab2e65c05$export$75d2bb378a2fc102,
    faStream: $d8206b3ab2e65c05$export$ed81ab40fc4e904,
    faDharmachakra: $d8206b3ab2e65c05$export$45cbd92c28deb2c7,
    faHotdog: $d8206b3ab2e65c05$export$9fae219b4d3ce0be,
    faPersonWalkingWithCane: $d8206b3ab2e65c05$export$2ffee5b2bc935c1f,
    faBlind: $d8206b3ab2e65c05$export$923de21def6ea9b6,
    faDrum: $d8206b3ab2e65c05$export$5b9205e1042594b7,
    faIceCream: $d8206b3ab2e65c05$export$dd52741c60cc638f,
    faHeartCircleBolt: $d8206b3ab2e65c05$export$2a376a9d0d8fee96,
    faFax: $d8206b3ab2e65c05$export$b5698497901d7197,
    faParagraph: $d8206b3ab2e65c05$export$dec46f8df1860e0,
    faCheckToSlot: $d8206b3ab2e65c05$export$6999832247e52c2b,
    faVoteYea: $d8206b3ab2e65c05$export$e87bb3db1608b850,
    faStarHalf: $d8206b3ab2e65c05$export$228008b5e11032fa,
    faBoxesStacked: $d8206b3ab2e65c05$export$2088efcf62cf3b1,
    faBoxes: $d8206b3ab2e65c05$export$2007320dd6cde6db,
    faBoxesAlt: $d8206b3ab2e65c05$export$e6ef1d896ed63b3e,
    faLink: $d8206b3ab2e65c05$export$88bc01ff8dbecc55,
    faChain: $d8206b3ab2e65c05$export$b5d071e02a25554f,
    faEarListen: $d8206b3ab2e65c05$export$837bc776b490934d,
    faAssistiveListeningSystems: $d8206b3ab2e65c05$export$8eeef3dc0035b165,
    faTreeCity: $d8206b3ab2e65c05$export$ad95e4f80f98ebe0,
    faPlay: $d8206b3ab2e65c05$export$436587205947bca5,
    faFont: $d8206b3ab2e65c05$export$a5dc297d3f60936,
    faRupiahSign: $d8206b3ab2e65c05$export$fe44d4c71644ea0,
    faMagnifyingGlass: $d8206b3ab2e65c05$export$34c8b97060c09ff,
    faSearch: $d8206b3ab2e65c05$export$871a78837687ffe8,
    faTableTennisPaddleBall: $d8206b3ab2e65c05$export$eabe53838d45ac6a,
    faPingPongPaddleBall: $d8206b3ab2e65c05$export$ebb246c621751737,
    faTableTennis: $d8206b3ab2e65c05$export$f378fbb4e0ef7edf,
    faPersonDotsFromLine: $d8206b3ab2e65c05$export$cdcec8ca7ec0d381,
    faDiagnoses: $d8206b3ab2e65c05$export$68bad2b52a90d1fa,
    faTrashCanArrowUp: $d8206b3ab2e65c05$export$60430351cdb4ba89,
    faTrashRestoreAlt: $d8206b3ab2e65c05$export$d075b19b21cb9856,
    faNairaSign: $d8206b3ab2e65c05$export$58b7558ca9822358,
    faCartArrowDown: $d8206b3ab2e65c05$export$9206260ff0c0c616,
    faWalkieTalkie: $d8206b3ab2e65c05$export$8a322f740d64e9fc,
    faFilePen: $d8206b3ab2e65c05$export$27f34878d8ed7a76,
    faFileEdit: $d8206b3ab2e65c05$export$e343e19f1757c5ae,
    faReceipt: $d8206b3ab2e65c05$export$32b0cd6133c2742,
    faSquarePen: $d8206b3ab2e65c05$export$3643b719db23d46e,
    faPenSquare: $d8206b3ab2e65c05$export$fbb231ccb3d960bc,
    faPencilSquare: $d8206b3ab2e65c05$export$35d253ecd249e771,
    faSuitcaseRolling: $d8206b3ab2e65c05$export$957e62a9b80ff4e3,
    faPersonCircleExclamation: $d8206b3ab2e65c05$export$38c8c32017dd9cc,
    faChevronDown: $d8206b3ab2e65c05$export$8db9bc521720fccd,
    faBatteryFull: $d8206b3ab2e65c05$export$9338fc4614cfc0cf,
    faBattery: $d8206b3ab2e65c05$export$214720d39635cea8,
    faBattery5: $d8206b3ab2e65c05$export$e426617482c711a7,
    faSkullCrossbones: $d8206b3ab2e65c05$export$8717352b90217272,
    faCodeCompare: $d8206b3ab2e65c05$export$ca4c5b4dcff58860,
    faListUl: $d8206b3ab2e65c05$export$f8a219cf4f516384,
    faListDots: $d8206b3ab2e65c05$export$e6f4ba30d84fa6ea,
    faSchoolLock: $d8206b3ab2e65c05$export$8845cce2a763ee07,
    faTowerCell: $d8206b3ab2e65c05$export$f4b64c3a138c1b59,
    faDownLong: $d8206b3ab2e65c05$export$e88ba08d4f4d65b6,
    faLongArrowAltDown: $d8206b3ab2e65c05$export$8b92530ca6418c2f,
    faRankingStar: $d8206b3ab2e65c05$export$e6fd420a918b43b5,
    faChessKing: $d8206b3ab2e65c05$export$d5713874f8fefe1b,
    faPersonHarassing: $d8206b3ab2e65c05$export$dcd74f2821882a49,
    faBrazilianRealSign: $d8206b3ab2e65c05$export$9d355b4e79216962,
    faLandmarkDome: $d8206b3ab2e65c05$export$8a56136f40511e5d,
    faLandmarkAlt: $d8206b3ab2e65c05$export$8b9c180efffc50ab,
    faArrowUp: $d8206b3ab2e65c05$export$8e144ed4d52eef49,
    faTv: $d8206b3ab2e65c05$export$e0cfed4ba2fe562c,
    faTelevision: $d8206b3ab2e65c05$export$9803b0176917be28,
    faTvAlt: $d8206b3ab2e65c05$export$6aa64ad5a1974ad7,
    faShrimp: $d8206b3ab2e65c05$export$ac094c06f566cca3,
    faListCheck: $d8206b3ab2e65c05$export$350a84fd0f833f4d,
    faTasks: $d8206b3ab2e65c05$export$2f6d5b2fec286d63,
    faJugDetergent: $d8206b3ab2e65c05$export$3fe50bd8062cd141,
    faCircleUser: $d8206b3ab2e65c05$export$9a5c11a5e3d7f1e7,
    faUserCircle: $d8206b3ab2e65c05$export$be7d974e9e0dba1a,
    faUserShield: $d8206b3ab2e65c05$export$d1886bc596424e6c,
    faWind: $d8206b3ab2e65c05$export$cc58cb0f2257a6a9,
    faCarBurst: $d8206b3ab2e65c05$export$6d2be7c5d395dd16,
    faCarCrash: $d8206b3ab2e65c05$export$8ff55566398404cd,
    faY: $d8206b3ab2e65c05$export$b8c4c058fe7d193c,
    faPersonSnowboarding: $d8206b3ab2e65c05$export$22c642403aeeaeaf,
    faSnowboarding: $d8206b3ab2e65c05$export$72683772d587302a,
    faTruckFast: $d8206b3ab2e65c05$export$27de16299ddd171,
    faShippingFast: $d8206b3ab2e65c05$export$5e419f47aaeb3c05,
    faFish: $d8206b3ab2e65c05$export$24228a855c5f6812,
    faUserGraduate: $d8206b3ab2e65c05$export$10f5839059d22f7e,
    faCircleHalfStroke: $d8206b3ab2e65c05$export$625fb3848216f28c,
    faAdjust: $d8206b3ab2e65c05$export$cfa06e4b68edca2d,
    faClapperboard: $d8206b3ab2e65c05$export$add3b381ced12554,
    faCircleRadiation: $d8206b3ab2e65c05$export$55c8e3afd9f6c0b4,
    faRadiationAlt: $d8206b3ab2e65c05$export$2f048fa82bbddf6f,
    faBaseball: $d8206b3ab2e65c05$export$dc3654cf8a596fbf,
    faBaseballBall: $d8206b3ab2e65c05$export$63a3f8ceae07c7f3,
    faJetFighterUp: $d8206b3ab2e65c05$export$b024a52a4ccf5e69,
    faDiagramProject: $d8206b3ab2e65c05$export$59c351869dc27435,
    faProjectDiagram: $d8206b3ab2e65c05$export$30bf9f5b96509df1,
    faCopy: $d8206b3ab2e65c05$export$e9bd786d30cb716c,
    faVolumeXmark: $d8206b3ab2e65c05$export$28cc565c11db6f2e,
    faVolumeMute: $d8206b3ab2e65c05$export$aa8decd057dfd29b,
    faVolumeTimes: $d8206b3ab2e65c05$export$a1c7b36ba71dbeca,
    faHandSparkles: $d8206b3ab2e65c05$export$72e2d874a963de0c,
    faGrip: $d8206b3ab2e65c05$export$eb83fb404127db75,
    faGripHorizontal: $d8206b3ab2e65c05$export$4a45308d6c8decc1,
    faShareFromSquare: $d8206b3ab2e65c05$export$928280bdd54fa173,
    faShareSquare: $d8206b3ab2e65c05$export$ae9e1434571f373c,
    faChildCombatant: $d8206b3ab2e65c05$export$f7367a7301f2dc0f,
    faChildRifle: $d8206b3ab2e65c05$export$9b027cdb5db3ae5c,
    faGun: $d8206b3ab2e65c05$export$e18f576a7b31ba46,
    faSquarePhone: $d8206b3ab2e65c05$export$318ed022991eef56,
    faPhoneSquare: $d8206b3ab2e65c05$export$8ba22605a641ebdf,
    faPlus: $d8206b3ab2e65c05$export$a105e7b44ca0eb9e,
    faAdd: $d8206b3ab2e65c05$export$9e8f9a9d4ad32c0f,
    faExpand: $d8206b3ab2e65c05$export$1fe4a9976a241685,
    faComputer: $d8206b3ab2e65c05$export$9835883ce9d0fe78,
    faXmark: $d8206b3ab2e65c05$export$e6e44779b2fa1a5c,
    faClose: $d8206b3ab2e65c05$export$23c717133fd81476,
    faMultiply: $d8206b3ab2e65c05$export$4ed4ff13d4dbc862,
    faRemove: $d8206b3ab2e65c05$export$34810740c1bd6c54,
    faTimes: $d8206b3ab2e65c05$export$174bd7f477b115b4,
    faArrowsUpDownLeftRight: $d8206b3ab2e65c05$export$ff9a43e3a9cb653c,
    faArrows: $d8206b3ab2e65c05$export$d5ae09a305d70340,
    faChalkboardUser: $d8206b3ab2e65c05$export$fd7622d4b8d3674b,
    faChalkboardTeacher: $d8206b3ab2e65c05$export$443fcf69b0155291,
    faPesoSign: $d8206b3ab2e65c05$export$c8f99b9b5ea83555,
    faBuildingShield: $d8206b3ab2e65c05$export$18ba6a500873dba9,
    faBaby: $d8206b3ab2e65c05$export$8afab767536f59ad,
    faUsersLine: $d8206b3ab2e65c05$export$d7e538fddb81da68,
    faQuoteLeft: $d8206b3ab2e65c05$export$932a67a1b1a7a724,
    faQuoteLeftAlt: $d8206b3ab2e65c05$export$95bb9ad3aa35c741,
    faTractor: $d8206b3ab2e65c05$export$e87e41787bbedc98,
    faTrashArrowUp: $d8206b3ab2e65c05$export$940cea0f5451895c,
    faTrashRestore: $d8206b3ab2e65c05$export$d32f45a64ed40e8d,
    faArrowDownUpLock: $d8206b3ab2e65c05$export$fc9f7bd981c34c45,
    faLinesLeaning: $d8206b3ab2e65c05$export$4d384ffc907ddaff,
    faRulerCombined: $d8206b3ab2e65c05$export$613f406c1b5802a8,
    faCopyright: $d8206b3ab2e65c05$export$da61665fff8aebfe,
    faEquals: $d8206b3ab2e65c05$export$a7c5f5e4805fdab,
    faBlender: $d8206b3ab2e65c05$export$db34f7a6de38784f,
    faTeeth: $d8206b3ab2e65c05$export$b4619aeaf0b9d18e,
    faShekelSign: $d8206b3ab2e65c05$export$3570be7b68efb8db,
    faIls: $d8206b3ab2e65c05$export$ecadeff45b05a451,
    faShekel: $d8206b3ab2e65c05$export$27e0e10e74d98736,
    faSheqel: $d8206b3ab2e65c05$export$28b3b26a80030d4e,
    faSheqelSign: $d8206b3ab2e65c05$export$d84993fb5e8c6edd,
    faMap: $d8206b3ab2e65c05$export$fc82fb79180cd17c,
    faRocket: $d8206b3ab2e65c05$export$b24d84ed5657d89a,
    faPhotoFilm: $d8206b3ab2e65c05$export$ed36ad335b36be22,
    faPhotoVideo: $d8206b3ab2e65c05$export$739f6a6a12dfb6ed,
    faFolderMinus: $d8206b3ab2e65c05$export$758f1fb3784e4080,
    faStore: $d8206b3ab2e65c05$export$de59c2657a8ace67,
    faArrowTrendUp: $d8206b3ab2e65c05$export$cf36928a9c52e98a,
    faPlugCircleMinus: $d8206b3ab2e65c05$export$2a44d62160972254,
    faSignHanging: $d8206b3ab2e65c05$export$5c1f29f4c7cad367,
    faSign: $d8206b3ab2e65c05$export$d21d0d6c8e9e8bf9,
    faBezierCurve: $d8206b3ab2e65c05$export$a527a6267c55a54c,
    faBellSlash: $d8206b3ab2e65c05$export$6b31a1e5968b2378,
    faTablet: $d8206b3ab2e65c05$export$1c92b67c45a4b4fc,
    faTabletAndroid: $d8206b3ab2e65c05$export$5eddbb7c71278268,
    faSchoolFlag: $d8206b3ab2e65c05$export$9b263780a7312c8c,
    faFill: $d8206b3ab2e65c05$export$d3c2bcfd3b861e4a,
    faAngleUp: $d8206b3ab2e65c05$export$887340269e6d6cac,
    faDrumstickBite: $d8206b3ab2e65c05$export$482976e9a4ab10f3,
    faHollyBerry: $d8206b3ab2e65c05$export$273296afacf93991,
    faChevronLeft: $d8206b3ab2e65c05$export$75702e3e3dd44a44,
    faBacteria: $d8206b3ab2e65c05$export$7fc18cf2d526c341,
    faHandLizard: $d8206b3ab2e65c05$export$54608d0a883fea4d,
    faNotdef: $d8206b3ab2e65c05$export$3db5bca65a1be8dc,
    faDisease: $d8206b3ab2e65c05$export$c7675a37487adc45,
    faBriefcaseMedical: $d8206b3ab2e65c05$export$5000f52ca9819bf5,
    faGenderless: $d8206b3ab2e65c05$export$c093cc22e88981c2,
    faChevronRight: $d8206b3ab2e65c05$export$930de8c26eb20490,
    faRetweet: $d8206b3ab2e65c05$export$cebc76f79478e40e,
    faCarRear: $d8206b3ab2e65c05$export$ff2b8d5628da5f14,
    faCarAlt: $d8206b3ab2e65c05$export$7937ed2462a665c0,
    faPumpSoap: $d8206b3ab2e65c05$export$821aeede187f23c9,
    faVideoSlash: $d8206b3ab2e65c05$export$a714fc79f58cc9ef,
    faBatteryQuarter: $d8206b3ab2e65c05$export$acec92052ac2183,
    faBattery2: $d8206b3ab2e65c05$export$23ca8a94c555576,
    faRadio: $d8206b3ab2e65c05$export$11b26516cae2104f,
    faBabyCarriage: $d8206b3ab2e65c05$export$3b3ab4d86bad7d26,
    faCarriageBaby: $d8206b3ab2e65c05$export$9f117d92ccd36cf1,
    faTrafficLight: $d8206b3ab2e65c05$export$bf0b19daceaec9c2,
    faThermometer: $d8206b3ab2e65c05$export$f576739e9b18ea4f,
    faVrCardboard: $d8206b3ab2e65c05$export$248171cb6dad4307,
    faHandMiddleFinger: $d8206b3ab2e65c05$export$bd40d3a3a16fb147,
    faPercent: $d8206b3ab2e65c05$export$89a1764fbb7ad2cb,
    faPercentage: $d8206b3ab2e65c05$export$89333857fc063a2e,
    faTruckMoving: $d8206b3ab2e65c05$export$a06617a1a4ccea67,
    faGlassWaterDroplet: $d8206b3ab2e65c05$export$b7ae54b4078b2060,
    faDisplay: $d8206b3ab2e65c05$export$e9d85839f7751f01,
    faFaceSmile: $d8206b3ab2e65c05$export$b5023c446f10324,
    faSmile: $d8206b3ab2e65c05$export$c632b2334f0913bc,
    faThumbtack: $d8206b3ab2e65c05$export$b6314cdc01bb5c43,
    faThumbTack: $d8206b3ab2e65c05$export$b63d0c7b519a9aae,
    faTrophy: $d8206b3ab2e65c05$export$29c432d69ccf85a5,
    faPersonPraying: $d8206b3ab2e65c05$export$8ecd436ef91fc02e,
    faPray: $d8206b3ab2e65c05$export$3b32c982141cad51,
    faHammer: $d8206b3ab2e65c05$export$6310f315e1ebbca5,
    faHandPeace: $d8206b3ab2e65c05$export$e49e3cfceea441cc,
    faRotate: $d8206b3ab2e65c05$export$decde496a29c5b23,
    faSyncAlt: $d8206b3ab2e65c05$export$2ff2056be8c281e4,
    faSpinner: $d8206b3ab2e65c05$export$1025ad641edb49c2,
    faRobot: $d8206b3ab2e65c05$export$30a5bb4ad3fa716c,
    faPeace: $d8206b3ab2e65c05$export$8614cb1326eacd7a,
    faGears: $d8206b3ab2e65c05$export$4aac79b9ae3cfdb8,
    faCogs: $d8206b3ab2e65c05$export$af1575770afc9559,
    faWarehouse: $d8206b3ab2e65c05$export$e3a174a50618c208,
    faArrowUpRightDots: $d8206b3ab2e65c05$export$bc804c6ab898f610,
    faSplotch: $d8206b3ab2e65c05$export$d6f21e17ea797702,
    faFaceGrinHearts: $d8206b3ab2e65c05$export$fbb22081b65e4f33,
    faGrinHearts: $d8206b3ab2e65c05$export$c56cf0e0c3bc5ed2,
    faDiceFour: $d8206b3ab2e65c05$export$2df6451abf70a6ff,
    faSimCard: $d8206b3ab2e65c05$export$3bee83bf278fddbe,
    faTransgender: $d8206b3ab2e65c05$export$7e3f1701aa95ef01,
    faTransgenderAlt: $d8206b3ab2e65c05$export$9c36cf9334c052f,
    faMercury: $d8206b3ab2e65c05$export$e134ecd00b622a47,
    faArrowTurnDown: $d8206b3ab2e65c05$export$fd4d6cfd52703f50,
    faLevelDown: $d8206b3ab2e65c05$export$3794c07e7a666c94,
    faPersonFallingBurst: $d8206b3ab2e65c05$export$a75569baaf4a6c3a,
    faAward: $d8206b3ab2e65c05$export$f8db2747dadd48f7,
    faTicketSimple: $d8206b3ab2e65c05$export$68ddda3b30ba09f0,
    faTicketAlt: $d8206b3ab2e65c05$export$75e38ba471fd89c4,
    faBuilding: $d8206b3ab2e65c05$export$f26673f8b10c3d46,
    faAnglesLeft: $d8206b3ab2e65c05$export$2ebd565813951f81,
    faAngleDoubleLeft: $d8206b3ab2e65c05$export$21b0833b3cf929a7,
    faQrcode: $d8206b3ab2e65c05$export$fc19ca0fe15e73bc,
    faClockRotateLeft: $d8206b3ab2e65c05$export$29be1665d1b36a3b,
    faHistory: $d8206b3ab2e65c05$export$76d1986559ca7b7a,
    faFaceGrinBeamSweat: $d8206b3ab2e65c05$export$2ff38f330c834084,
    faGrinBeamSweat: $d8206b3ab2e65c05$export$14d0ccc54c5b6826,
    faFileExport: $d8206b3ab2e65c05$export$364f19abcfac1b0a,
    faArrowRightFromFile: $d8206b3ab2e65c05$export$b9c76255b38e1df1,
    faShield: $d8206b3ab2e65c05$export$8241bd5b9163ca12,
    faShieldBlank: $d8206b3ab2e65c05$export$64f54da8fbaba8ee,
    faArrowUpShortWide: $d8206b3ab2e65c05$export$be9d5060a4bc3b4b,
    faSortAmountUpAlt: $d8206b3ab2e65c05$export$6e87844b0f151b6a,
    faHouseMedical: $d8206b3ab2e65c05$export$2d077da983246a68,
    faGolfBallTee: $d8206b3ab2e65c05$export$14c9f1d85e53ae99,
    faGolfBall: $d8206b3ab2e65c05$export$2251487a9a33c682,
    faCircleChevronLeft: $d8206b3ab2e65c05$export$f2b13ad44c03c40f,
    faChevronCircleLeft: $d8206b3ab2e65c05$export$4a42c8c2451a33fd,
    faHouseChimneyWindow: $d8206b3ab2e65c05$export$792391babe46862d,
    faPenNib: $d8206b3ab2e65c05$export$a82594dcc75a49f5,
    faTentArrowTurnLeft: $d8206b3ab2e65c05$export$89af87b7d6c15adf,
    faTents: $d8206b3ab2e65c05$export$c93b950e845a4ee7,
    faWandMagic: $d8206b3ab2e65c05$export$8282f5f5dcf6b009,
    faMagic: $d8206b3ab2e65c05$export$e58f9b502d4dd52d,
    faDog: $d8206b3ab2e65c05$export$c6406747800cf702,
    faCarrot: $d8206b3ab2e65c05$export$28e93ec9f5e2ddf3,
    faMoon: $d8206b3ab2e65c05$export$c4c2f69a53bab720,
    faWineGlassEmpty: $d8206b3ab2e65c05$export$b86d7336e68a3f57,
    faWineGlassAlt: $d8206b3ab2e65c05$export$b8ff3fe2b78aef2f,
    faCheese: $d8206b3ab2e65c05$export$549b99473b7201e6,
    faYinYang: $d8206b3ab2e65c05$export$6ec1acbf3f610b8f,
    faMusic: $d8206b3ab2e65c05$export$fcb0647a5340b5b8,
    faCodeCommit: $d8206b3ab2e65c05$export$d5d870c10bc9f1ce,
    faTemperatureLow: $d8206b3ab2e65c05$export$9e9af12b90a1abd2,
    faPersonBiking: $d8206b3ab2e65c05$export$cf152282d5de300d,
    faBiking: $d8206b3ab2e65c05$export$a5bcf835dbf9c0b,
    faBroom: $d8206b3ab2e65c05$export$2a533051418ff4ca,
    faShieldHeart: $d8206b3ab2e65c05$export$7b96388ca2be471b,
    faGopuram: $d8206b3ab2e65c05$export$31f89d8ac1d14ed6,
    faEarthOceania: $d8206b3ab2e65c05$export$bd931e906edf2f47,
    faGlobeOceania: $d8206b3ab2e65c05$export$8ac3f5271448657d,
    faSquareXmark: $d8206b3ab2e65c05$export$5a17e58bb7afb1d7,
    faTimesSquare: $d8206b3ab2e65c05$export$c0248ac97142ea2a,
    faXmarkSquare: $d8206b3ab2e65c05$export$9a364781d6b7602b,
    faHashtag: $d8206b3ab2e65c05$export$c92c903bade56844,
    faUpRightAndDownLeftFromCenter: $d8206b3ab2e65c05$export$95457ede07b81517,
    faExpandAlt: $d8206b3ab2e65c05$export$bcb8d86a3a1d6eb6,
    faOilCan: $d8206b3ab2e65c05$export$2599126c3a57f727,
    faT: $d8206b3ab2e65c05$export$6e625d2e7790c860,
    faHippo: $d8206b3ab2e65c05$export$d4c909619093de2d,
    faChartColumn: $d8206b3ab2e65c05$export$d01ddcc9efe7b149,
    faInfinity: $d8206b3ab2e65c05$export$a590003279d671b8,
    faVialCircleCheck: $d8206b3ab2e65c05$export$2db4f9712313eafa,
    faPersonArrowDownToLine: $d8206b3ab2e65c05$export$f9a5161975928326,
    faVoicemail: $d8206b3ab2e65c05$export$4f1ce88b2b4cd5cd,
    faFan: $d8206b3ab2e65c05$export$55145a3dae4f984a,
    faPersonWalkingLuggage: $d8206b3ab2e65c05$export$1ae0a37b36ace746,
    faUpDown: $d8206b3ab2e65c05$export$e36c32dd5cba9b90,
    faArrowsAltV: $d8206b3ab2e65c05$export$138cb56a3f8f7040,
    faCloudMoonRain: $d8206b3ab2e65c05$export$301c3fab0c4545bd,
    faCalendar: $d8206b3ab2e65c05$export$34f5c36a3e80efa2,
    faTrailer: $d8206b3ab2e65c05$export$3a48b9820e92f5ab,
    faBahai: $d8206b3ab2e65c05$export$6d636565b3ec36b4,
    faHaykal: $d8206b3ab2e65c05$export$5c15e34e0e43f15c,
    faSdCard: $d8206b3ab2e65c05$export$303efb6031da122,
    faDragon: $d8206b3ab2e65c05$export$ae1875ba975aa0e9,
    faShoePrints: $d8206b3ab2e65c05$export$cdbdd2118099ae07,
    faCirclePlus: $d8206b3ab2e65c05$export$eeda28b8ca4cb18e,
    faPlusCircle: $d8206b3ab2e65c05$export$d9cc3a81499af48c,
    faFaceGrinTongueWink: $d8206b3ab2e65c05$export$4272e56f2429da88,
    faGrinTongueWink: $d8206b3ab2e65c05$export$58099903d50aefb3,
    faHandHolding: $d8206b3ab2e65c05$export$e6094d25274088ab,
    faPlugCircleExclamation: $d8206b3ab2e65c05$export$d893dd9509763a17,
    faLinkSlash: $d8206b3ab2e65c05$export$22965c7f4d903953,
    faChainBroken: $d8206b3ab2e65c05$export$382551e04f32620a,
    faChainSlash: $d8206b3ab2e65c05$export$12f09d657be59586,
    faUnlink: $d8206b3ab2e65c05$export$2f546f7d8ba01e18,
    faClone: $d8206b3ab2e65c05$export$76c1aa4bf9a39458,
    faPersonWalkingArrowLoopLeft: $d8206b3ab2e65c05$export$5a200e8504b7367a,
    faArrowUpZA: $d8206b3ab2e65c05$export$a0a53d8e3c68e9f1,
    faSortAlphaUpAlt: $d8206b3ab2e65c05$export$95ef20828693fb0f,
    faFireFlameCurved: $d8206b3ab2e65c05$export$769724fc1434d618,
    faFireAlt: $d8206b3ab2e65c05$export$70dc26b4926d0b1b,
    faTornado: $d8206b3ab2e65c05$export$6d274258ba4b0089,
    faFileCirclePlus: $d8206b3ab2e65c05$export$430d63b54b1d4009,
    faBookQuran: $d8206b3ab2e65c05$export$ad3212bc3fa1595b,
    faQuran: $d8206b3ab2e65c05$export$46f29ea84ed4c5f1,
    faAnchor: $d8206b3ab2e65c05$export$12a35719f889cd1,
    faBorderAll: $d8206b3ab2e65c05$export$93a5eb721c9c0d25,
    faFaceAngry: $d8206b3ab2e65c05$export$67a047c738fb34da,
    faAngry: $d8206b3ab2e65c05$export$3c96c08e234498c5,
    faCookieBite: $d8206b3ab2e65c05$export$317dde8664f7de71,
    faArrowTrendDown: $d8206b3ab2e65c05$export$d2caed5e37174c23,
    faRss: $d8206b3ab2e65c05$export$7329a1ca27b90c5b,
    faFeed: $d8206b3ab2e65c05$export$67ad3d0233cd7b33,
    faDrawPolygon: $d8206b3ab2e65c05$export$df9bd3777d1154d2,
    faScaleBalanced: $d8206b3ab2e65c05$export$33fb4280dc20f0dd,
    faBalanceScale: $d8206b3ab2e65c05$export$fec323dcfd81d750,
    faGaugeSimpleHigh: $d8206b3ab2e65c05$export$cc4351eb13da27d8,
    faTachometer: $d8206b3ab2e65c05$export$362d0f652c3fbca2,
    faTachometerFast: $d8206b3ab2e65c05$export$375b6a8680f980ed,
    faShower: $d8206b3ab2e65c05$export$f7f7c15f18cc19a1,
    faDesktop: $d8206b3ab2e65c05$export$6e6ddc253102e596,
    faDesktopAlt: $d8206b3ab2e65c05$export$ff09a62b9e0fa899,
    faM: $d8206b3ab2e65c05$export$bd6a7788954842b5,
    faTableList: $d8206b3ab2e65c05$export$6e989c3c7050dbb,
    faThList: $d8206b3ab2e65c05$export$daf2614a457122c0,
    faCommentSms: $d8206b3ab2e65c05$export$435fe17e9d6170d6,
    faSms: $d8206b3ab2e65c05$export$9dbcc3443daa7323,
    faBook: $d8206b3ab2e65c05$export$c9d7ef726d1a8742,
    faUserPlus: $d8206b3ab2e65c05$export$4c17261776a709f2,
    faCheck: $d8206b3ab2e65c05$export$62b2c752fccc6a9c,
    faBatteryThreeQuarters: $d8206b3ab2e65c05$export$cfb37069d38f379e,
    faBattery4: $d8206b3ab2e65c05$export$35ffefed200d123c,
    faHouseCircleCheck: $d8206b3ab2e65c05$export$c9382fa3394ef53a,
    faAngleLeft: $d8206b3ab2e65c05$export$3cbcd1b7e35945d2,
    faDiagramSuccessor: $d8206b3ab2e65c05$export$ff7f40159cadb0ac,
    faTruckArrowRight: $d8206b3ab2e65c05$export$d69fa2b7839ce76,
    faArrowsSplitUpAndLeft: $d8206b3ab2e65c05$export$7df274119d2469d1,
    faHandFist: $d8206b3ab2e65c05$export$ca492f58fe30a42f,
    faFistRaised: $d8206b3ab2e65c05$export$fa0323a4d7489a8d,
    faCloudMoon: $d8206b3ab2e65c05$export$482eb125aaf0fbc2,
    faBriefcase: $d8206b3ab2e65c05$export$8da450d063b0eb37,
    faPersonFalling: $d8206b3ab2e65c05$export$e94ab3a30cf4aca5,
    faImagePortrait: $d8206b3ab2e65c05$export$c23fd8b91a7ed48,
    faPortrait: $d8206b3ab2e65c05$export$e3d25f819c7ee7d7,
    faUserTag: $d8206b3ab2e65c05$export$9eec597148166b36,
    faRug: $d8206b3ab2e65c05$export$7cee7480f25f5289,
    faEarthEurope: $d8206b3ab2e65c05$export$7adefae4a1be1d97,
    faGlobeEurope: $d8206b3ab2e65c05$export$5318b8ede86cc96b,
    faCartFlatbedSuitcase: $d8206b3ab2e65c05$export$ab81ff863770d996,
    faLuggageCart: $d8206b3ab2e65c05$export$bd1e24dd3cde8514,
    faRectangleXmark: $d8206b3ab2e65c05$export$3896694b3e81fba7,
    faRectangleTimes: $d8206b3ab2e65c05$export$eaaf26416a51dc1,
    faTimesRectangle: $d8206b3ab2e65c05$export$10147c0014152a3f,
    faWindowClose: $d8206b3ab2e65c05$export$18b7775f78a3e16,
    faBahtSign: $d8206b3ab2e65c05$export$ffc7123046a28ee,
    faBookOpen: $d8206b3ab2e65c05$export$8a3071811b2b7979,
    faBookJournalWhills: $d8206b3ab2e65c05$export$d3d49030d557a09b,
    faJournalWhills: $d8206b3ab2e65c05$export$66a0d8d45aab6631,
    faHandcuffs: $d8206b3ab2e65c05$export$74d1f89b5feb9d42,
    faTriangleExclamation: $d8206b3ab2e65c05$export$1cbf6e649ce86166,
    faExclamationTriangle: $d8206b3ab2e65c05$export$3d249b63b52cce7c,
    faWarning: $d8206b3ab2e65c05$export$2e470a35c38b096a,
    faDatabase: $d8206b3ab2e65c05$export$24680dede86b1883,
    faShare: $d8206b3ab2e65c05$export$c08b4b0e2b0dc027,
    faArrowTurnRight: $d8206b3ab2e65c05$export$f20385ecfa20c36e,
    faMailForward: $d8206b3ab2e65c05$export$81df7693d3f2f8da,
    faBottleDroplet: $d8206b3ab2e65c05$export$8f534e1e0ab75bfe,
    faMaskFace: $d8206b3ab2e65c05$export$140d4da0adbaf435,
    faHillRockslide: $d8206b3ab2e65c05$export$7ec15a32285f6c22,
    faRightLeft: $d8206b3ab2e65c05$export$a082af56be9786ae,
    faExchangeAlt: $d8206b3ab2e65c05$export$f6c6fb20d374b128,
    faPaperPlane: $d8206b3ab2e65c05$export$b5378818301da1be,
    faRoadCircleExclamation: $d8206b3ab2e65c05$export$79753c2153535b01,
    faDungeon: $d8206b3ab2e65c05$export$1156dc6acb0058bd,
    faAlignRight: $d8206b3ab2e65c05$export$7370f36a39a38737,
    faMoneyBill1Wave: $d8206b3ab2e65c05$export$52e3e96cd1564779,
    faMoneyBillWaveAlt: $d8206b3ab2e65c05$export$1613858e873cbb3e,
    faLifeRing: $d8206b3ab2e65c05$export$53dd2cacf674142a,
    faHands: $d8206b3ab2e65c05$export$f9712d0cf5150f0c,
    faSignLanguage: $d8206b3ab2e65c05$export$20993813350f9671,
    faSigning: $d8206b3ab2e65c05$export$5cc0e6f5191f4f02,
    faCalendarDay: $d8206b3ab2e65c05$export$80968bcfef6481ca,
    faWaterLadder: $d8206b3ab2e65c05$export$5930e9bdfd790d77,
    faLadderWater: $d8206b3ab2e65c05$export$c5ea6eeef2db2b3b,
    faSwimmingPool: $d8206b3ab2e65c05$export$4dee691631c67d5c,
    faArrowsUpDown: $d8206b3ab2e65c05$export$64185f27d82c259f,
    faArrowsV: $d8206b3ab2e65c05$export$cec5f1bc9e068e48,
    faFaceGrimace: $d8206b3ab2e65c05$export$bd5bd2ef56b793b1,
    faGrimace: $d8206b3ab2e65c05$export$3d08cd36ac1ef231,
    faWheelchairMove: $d8206b3ab2e65c05$export$1482162f7fe04ac,
    faWheelchairAlt: $d8206b3ab2e65c05$export$7db9460785019040,
    faTurnDown: $d8206b3ab2e65c05$export$b5dc9dd0347bbb6,
    faLevelDownAlt: $d8206b3ab2e65c05$export$c07eb6ff5a382cbd,
    faPersonWalkingArrowRight: $d8206b3ab2e65c05$export$3e15790fe68c095b,
    faSquareEnvelope: $d8206b3ab2e65c05$export$15da4ef8c0fb20d6,
    faEnvelopeSquare: $d8206b3ab2e65c05$export$354e159473e73552,
    faDice: $d8206b3ab2e65c05$export$4ed8206e6619cc8f,
    faBowlingBall: $d8206b3ab2e65c05$export$5ee2640fe105312d,
    faBrain: $d8206b3ab2e65c05$export$97fa4f4c1006ab1,
    faBandage: $d8206b3ab2e65c05$export$658a137d3845bca7,
    faBandAid: $d8206b3ab2e65c05$export$b14a1014df2fdf46,
    faCalendarMinus: $d8206b3ab2e65c05$export$23e8b4955c2d951b,
    faCircleXmark: $d8206b3ab2e65c05$export$30262489773a79a3,
    faTimesCircle: $d8206b3ab2e65c05$export$ab0ec50720a747eb,
    faXmarkCircle: $d8206b3ab2e65c05$export$90ac4096df8efdee,
    faGifts: $d8206b3ab2e65c05$export$de9a67b55dbe819a,
    faHotel: $d8206b3ab2e65c05$export$c402efcf01d5ca07,
    faEarthAsia: $d8206b3ab2e65c05$export$807cdd395fe012cb,
    faGlobeAsia: $d8206b3ab2e65c05$export$796fdfc909e603f4,
    faIdCardClip: $d8206b3ab2e65c05$export$31e6961064ddac7b,
    faIdCardAlt: $d8206b3ab2e65c05$export$dc37ebbac31f6c6c,
    faMagnifyingGlassPlus: $d8206b3ab2e65c05$export$f48a3ba52a0a9e56,
    faSearchPlus: $d8206b3ab2e65c05$export$378f00e6b1a8185,
    faThumbsUp: $d8206b3ab2e65c05$export$47e4e0d519d33497,
    faUserClock: $d8206b3ab2e65c05$export$b00596a09aa07311,
    faHandDots: $d8206b3ab2e65c05$export$8846d49caaed1c0a,
    faAllergies: $d8206b3ab2e65c05$export$dcae2101babbffff,
    faFileInvoice: $d8206b3ab2e65c05$export$bef39294aed2281a,
    faWindowMinimize: $d8206b3ab2e65c05$export$26a3f9d2784b90d8,
    faMugSaucer: $d8206b3ab2e65c05$export$60048819854688c5,
    faCoffee: $d8206b3ab2e65c05$export$1d24a9e457278011,
    faBrush: $d8206b3ab2e65c05$export$5824ffe6f8983c83,
    faMask: $d8206b3ab2e65c05$export$7b028758c03b9655,
    faMagnifyingGlassMinus: $d8206b3ab2e65c05$export$56d810b9ab2e30bc,
    faSearchMinus: $d8206b3ab2e65c05$export$efca97eef6a7a17d,
    faRulerVertical: $d8206b3ab2e65c05$export$a6ad5df9d9f29553,
    faUserLarge: $d8206b3ab2e65c05$export$50a28538498238f,
    faUserAlt: $d8206b3ab2e65c05$export$ae9b19c2ac726cfc,
    faTrainTram: $d8206b3ab2e65c05$export$d401d4aeba21cdf3,
    faUserNurse: $d8206b3ab2e65c05$export$ab9af5aa013d2162,
    faSyringe: $d8206b3ab2e65c05$export$1aa9423ec6b1d609,
    faCloudSun: $d8206b3ab2e65c05$export$dcaadfd9c98e42a1,
    faStopwatch20: $d8206b3ab2e65c05$export$df6244b0501f2112,
    faSquareFull: $d8206b3ab2e65c05$export$7ec6541fee081990,
    faMagnet: $d8206b3ab2e65c05$export$78932e9c9abea6b7,
    faJar: $d8206b3ab2e65c05$export$53583b459a87a01,
    faNoteSticky: $d8206b3ab2e65c05$export$4a4e034527c933f5,
    faStickyNote: $d8206b3ab2e65c05$export$80889adc5d98bf4a,
    faBugSlash: $d8206b3ab2e65c05$export$fc4dd5feed8df23,
    faArrowUpFromWaterPump: $d8206b3ab2e65c05$export$1a093e7861c5e48f,
    faBone: $d8206b3ab2e65c05$export$5902c007d5703f2d,
    faUserInjured: $d8206b3ab2e65c05$export$c950c1ba7f227d5b,
    faFaceSadTear: $d8206b3ab2e65c05$export$8a5a0dbb2a17e253,
    faSadTear: $d8206b3ab2e65c05$export$4b5241926f692f91,
    faPlane: $d8206b3ab2e65c05$export$f654c69e66b466c0,
    faTentArrowsDown: $d8206b3ab2e65c05$export$51adfe7c9ee4f428,
    faExclamation: $d8206b3ab2e65c05$export$de6218b649cbb6a9,
    faArrowsSpin: $d8206b3ab2e65c05$export$7e05388be208e313,
    faPrint: $d8206b3ab2e65c05$export$ae64371e02ee8e56,
    faTurkishLiraSign: $d8206b3ab2e65c05$export$b458d393151b6960,
    faTry: $d8206b3ab2e65c05$export$970dda513e46c41f,
    faTurkishLira: $d8206b3ab2e65c05$export$40e66e5966827199,
    faDollarSign: $d8206b3ab2e65c05$export$fb420d3e4d8c6a18,
    faDollar: $d8206b3ab2e65c05$export$a4ffb0775547fcdf,
    faUsd: $d8206b3ab2e65c05$export$72cca07d38a28589,
    faX: $d8206b3ab2e65c05$export$476af662c0c32cbc,
    faMagnifyingGlassDollar: $d8206b3ab2e65c05$export$fa4f1ead37dc1dce,
    faSearchDollar: $d8206b3ab2e65c05$export$65b49a6767630708,
    faUsersGear: $d8206b3ab2e65c05$export$3a18218720110fc0,
    faUsersCog: $d8206b3ab2e65c05$export$5e0b06753fc69b81,
    faPersonMilitaryPointing: $d8206b3ab2e65c05$export$50b6dcaa9ec03439,
    faBuildingColumns: $d8206b3ab2e65c05$export$a411e7e26cb63d5e,
    faBank: $d8206b3ab2e65c05$export$6e379b829ea8b99,
    faInstitution: $d8206b3ab2e65c05$export$1dba320226a34c1f,
    faMuseum: $d8206b3ab2e65c05$export$9b3953adff472ad2,
    faUniversity: $d8206b3ab2e65c05$export$f2e1460ebe1a8cb0,
    faUmbrella: $d8206b3ab2e65c05$export$9ff64ffae70e08c0,
    faTrowel: $d8206b3ab2e65c05$export$12ca996a6f686fe1,
    faD: $d8206b3ab2e65c05$export$56c73b799aac2555,
    faStapler: $d8206b3ab2e65c05$export$c7e014b7e3ac3d83,
    faMasksTheater: $d8206b3ab2e65c05$export$bf5896cc1ce4d55,
    faTheaterMasks: $d8206b3ab2e65c05$export$3dbedc487b0159ac,
    faKipSign: $d8206b3ab2e65c05$export$a6df39524c41472c,
    faHandPointLeft: $d8206b3ab2e65c05$export$b276ec3dc9760d39,
    faHandshakeSimple: $d8206b3ab2e65c05$export$e8485db4dab0ab30,
    faHandshakeAlt: $d8206b3ab2e65c05$export$e9aa3c6f9f47aa1a,
    faJetFighter: $d8206b3ab2e65c05$export$2130e629ab767ab3,
    faFighterJet: $d8206b3ab2e65c05$export$102b809faf56e033,
    faSquareShareNodes: $d8206b3ab2e65c05$export$1bdb0ec5af3fea99,
    faShareAltSquare: $d8206b3ab2e65c05$export$3799c2d8fd7e493b,
    faBarcode: $d8206b3ab2e65c05$export$3825a842b5afc5aa,
    faPlusMinus: $d8206b3ab2e65c05$export$37bd38cf96417095,
    faVideo: $d8206b3ab2e65c05$export$5c6bd8729527871b,
    faVideoCamera: $d8206b3ab2e65c05$export$3a530df752193ccf,
    faGraduationCap: $d8206b3ab2e65c05$export$874e305fd7920cce,
    faMortarBoard: $d8206b3ab2e65c05$export$dd0a013bf23a9d86,
    faHandHoldingMedical: $d8206b3ab2e65c05$export$bb2a6b1b5e852300,
    faPersonCircleCheck: $d8206b3ab2e65c05$export$30294c81ac4031ca,
    faTurnUp: $d8206b3ab2e65c05$export$314f5cab62fc6968,
    faLevelUpAlt: $d8206b3ab2e65c05$export$d6f21a309b179c3d
};


(0, $a43d996a7aa8a839$export$b839f963c7dc0e34).add((0, $ef0249c5e48bf4e3$export$ca61170983a00686), (0, $d8206b3ab2e65c05$export$28cc565c11db6f2e), (0, $d8206b3ab2e65c05$export$2b1464e7557b18eb), (0, $ef0249c5e48bf4e3$export$c8d4525a5e9ad3ad), (0, $d8206b3ab2e65c05$export$eeda28b8ca4cb18e), (0, $d8206b3ab2e65c05$export$9429fd8df55155d), (0, $ef0249c5e48bf4e3$export$fd0513a3aa908a67), (0, $d8206b3ab2e65c05$export$d7cf0978afd90002));
const $70fc9a727fa662ae$var$app = document.getElementById("react");
if ($70fc9a727fa662ae$var$app) {
    const root = $7e96a608cb33bf79$export$882461b6382ed46c($70fc9a727fa662ae$var$app);
    root.render(/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $6a807f7e8fbb49cb$export$8c41bb232f1008b1), {}));
}


//# sourceMappingURL=index.c4ccc323.js.map
